export const diagnosticosSNOMED = [
  {
    "codigo":395051008,
    "descripcion":"CONTROL RESPIRATORIO NO REQUERIDO"
  },
  {
    "codigo":131072002,
    "descripcion":"NIVEL DE PREGNANEDIOL POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":294912008,
    "descripcion":"ALERGIA A L-CARNITINA"
  },
  {
    "codigo":17111000119107,
    "descripcion":"ÚLCERA ISQUÉMICA DE PIEL"
  },
  {
    "codigo":63701002,
    "descripcion":"TRASTORNO DE PÁNICO CON AGORAFOBIA, EVITACIÓN AGORAFÓBICA LEVE Y ATAQUES DE PÁNICO LEVES"
  },
  {
    "codigo":10666711000119108,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN DE PIERNA DERECHA ESTADIO IV"
  },
  {
    "codigo":11787121000119102,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE DEDO MEÑIQUE IZQUIERDO"
  },
  {
    "codigo":1208746001,
    "descripcion":"SÍNDROME DE DISCAPACIDAD INTELECTUAL, DEBILIDAD MUSCULAR, BAJA TALLA Y DISMORFISMO FACIAL"
  },
  {
    "codigo":94634005,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA GLÁNDULA TIROIDES"
  },
  {
    "codigo":61866006,
    "descripcion":"INFECCIÓN CAUSADA POR POROCEPHALUS CROTALI"
  },
  {
    "codigo":127402007,
    "descripcion":"HALLAZGO EN LA DURACIÓN DE VIDA ERITROCÍTICA"
  },
  {
    "codigo":225706007,
    "descripcion":"HALLAZGO EN LAS RELACIONES INTERPERSONALES"
  },
  {
    "codigo":60031001,
    "descripcion":"PLEURESÍA SEROFIBRINOSA"
  },
  {
    "codigo":289407003,
    "descripcion":"SUTURA SAGITAL EN DIÁMETRO OBLICUO"
  },
  {
    "codigo":715391004,
    "descripcion":"SÍNDROME DE BLEFAROFIMOSIS-EPICANTO INVERSO-PTOSIS"
  },
  {
    "codigo":92799007,
    "descripcion":"CARCINOMA IN SITU DEL VESTÍBULO DE LA NARIZ"
  },
  {
    "codigo":1303380004,
    "descripcion":"FRACTURA DE CLAVÍCULA IZQUIERDA"
  },
  {
    "codigo":254804007,
    "descripcion":"NEVO EN COCARDA"
  },
  {
    "codigo":58196009,
    "descripcion":"ABSCESO DE TOBILLO"
  },
  {
    "codigo":11842571000119101,
    "descripcion":"RUPTURA TRAUMÁTICA DE TENDÓN DE PIE IZQUIERDO"
  },
  {
    "codigo":416809004,
    "descripcion":"ELASTICIDAD DE PARTES BLANDAS"
  },
  {
    "codigo":1268777006,
    "descripcion":"CAPAZ DE PAGAR CALEFACCIÓN EN VIVIENDA"
  },
  {
    "codigo":87294007,
    "descripcion":"VÉRTEBRA SUPERNUMERARIA"
  },
  {
    "codigo":118227000,
    "descripcion":"HALLAZGO EN LOS SIGNOS VITALES"
  },
  {
    "codigo":283902008,
    "descripcion":"TIENE MEMORIA RETARDADA"
  },
  {
    "codigo":216531002,
    "descripcion":"INTOXICACIÓN ACCIDENTAL CAUSADA POR CLORDIAZEPÓXIDO"
  },
  {
    "codigo":773587008,
    "descripcion":"SÍNDROME DE INSUFICIENCIA CARDÍACA CONGESTIVA, CARDIOMEGALIA Y DISCAPACIDAD INTELECTUAL LIGADA AL CROMOSOMA X"
  },
  {
    "codigo":52691008,
    "descripcion":"SIN CONFIRMACIÓN MICROSCÓPICA: DETERMINACIÓN CLÍNICA DE TUMOR METASTÁSICO (CÁNCER)"
  },
  {
    "codigo":183763009,
    "descripcion":"CONSULTA DOMICILIARIA DE CIRUGÍA MAXILOFACIAL, REALIZADA"
  },
  {
    "codigo":1197736003,
    "descripcion":"INSUFICIENCIA HEPÁTICA CRÓNICA DEBIDA A SHUNT PORTOSISTÉMICO"
  },
  {
    "codigo":313000007,
    "descripcion":"VASCULOPATÍA CORIORRETINIANA"
  },
  {
    "codigo":16253001,
    "descripcion":"MIOCARDIOPATÍA DILATADA PERIPARTO"
  },
  {
    "codigo":1359741006,
    "descripcion":"TRASTORNO DE OBESIDAD DE CAUSA GENÉTICA"
  },
  {
    "codigo":704381006,
    "descripcion":"CONOCIMIENTO DEFICIENTE SOBRE HIGIENE BUCAL"
  },
  {
    "codigo":868221006,
    "descripcion":"OCLUSIÓN DE RAMA MARGINAL DE ARTERIA CORONARIA DERECHA"
  },
  {
    "codigo":276562001,
    "descripcion":"HIPOGLUCEMIA NEONATAL IATROGÉNICA"
  },
  {
    "codigo":407634002,
    "descripcion":"ESCALA DE DETERIORO GENERAL NIVEL 6 - DETERIORO COGNITIVO SEVERO"
  },
  {
    "codigo":440402001,
    "descripcion":"PACIENTE PSIQUIÁTRICO EN INTERNACIÓN BREVE"
  },
  {
    "codigo":1259602004,
    "descripcion":"CARCINOMA PRIMARIO DE HÍGADO Y\/O VÍA BILIAR"
  },
  {
    "codigo":347301000119103,
    "descripcion":"IRITIS AGUDA DE AMBOS OJOS"
  },
  {
    "codigo":47186006,
    "descripcion":"CAPTACIÓN IRREGULAR POR UN TEJIDO U ÓRGANO"
  },
  {
    "codigo":14418008,
    "descripcion":"EMBARAZO PRECOZ"
  },
  {
    "codigo":702546009,
    "descripcion":"REQUIERE OXIGENOTERAPIA DURANTE EL EJERCICIO"
  },
  {
    "codigo":78119002,
    "descripcion":"PARESIA BILATERAL COMPLETA"
  },
  {
    "codigo":241959003,
    "descripcion":"URTICARIA ANGIOEDEMATOSA PRODUCIDA POR ANTIINFLAMATORIO NO ESTEROIDE"
  },
  {
    "codigo":373031003,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM GASTRI"
  },
  {
    "codigo":307495005,
    "descripcion":"COANAS NO PERMEABLES"
  },
  {
    "codigo":274727006,
    "descripcion":"ROCE PRECORDIAL"
  },
  {
    "codigo":766247009,
    "descripcion":"TUMOR NEUROECTODÉRMICO PRIMITIVO DEL CUERPO UTERINO"
  },
  {
    "codigo":305660003,
    "descripcion":"ATENDIDO POR UN MÉDICO"
  },
  {
    "codigo":240124007,
    "descripcion":"HEMATOMA INTERMUSCULAR"
  },
  {
    "codigo":403964007,
    "descripcion":"HEMANGIOMA MICROVENULAR"
  },
  {
    "codigo":43516009,
    "descripcion":"ESPUTO FÉTIDO"
  },
  {
    "codigo":895484009,
    "descripcion":"SE MOVILIZA CON DISPOSITIVO ORTÉSICO"
  },
  {
    "codigo":860881004,
    "descripcion":"DIPLEJÍA FLÁCCIDA DE EXTREMIDADES INFERIORES"
  },
  {
    "codigo":8913004,
    "descripcion":"AMENORREA FISIOLÓGICA PRIMARIA"
  },
  {
    "codigo":402129006,
    "descripcion":"ACTINOMICETOMA CAUSADO POR NOCARDIA"
  },
  {
    "codigo":1186726000,
    "descripcion":"HIPERPLASIA PRIMARIA DE CÓNDILO MANDIBULAR"
  },
  {
    "codigo":1286865009,
    "descripcion":"FRACTURA DE HUESO DE CINTURA ESCAPULAR"
  },
  {
    "codigo":301990003,
    "descripcion":"VESICULITIS ESPERMÁTICA GONOCÓCICA"
  },
  {
    "codigo":236454004,
    "descripcion":"NEFROPATÍA CRÓNICA POR PLOMO"
  },
  {
    "codigo":39846008,
    "descripcion":"PRESIÓN INTRAORAL REDUCIDA"
  },
  {
    "codigo":234619000,
    "descripcion":"DEFICIENCIA HEREDITARIA DEL INHIBIDOR ESTERASA C1"
  },
  {
    "codigo":169083003,
    "descripcion":"ESTUDIO DE RESONANCIA MAGNÉTICA NUCLEAR ANORMAL"
  },
  {
    "codigo":365691004,
    "descripcion":"HALLAZGO RELACIONADO CON LA PRESENCIA DE BACTERIAS"
  },
  {
    "codigo":300155003,
    "descripcion":"SIN REFLEJO LUMINOSO EN LA MEMBRANA TIMPÁNICA"
  },
  {
    "codigo":462160000,
    "descripcion":"RETENCIÓN FETAL DE LÍQUIDO LIMITADA A UN COMPARTIMIENTO FETAL"
  },
  {
    "codigo":167248002,
    "descripcion":"OLOR DE LA ORINA: AMONIACAL"
  },
  {
    "codigo":296485005,
    "descripcion":"SOBREDOSIS DE COLCHICINA"
  },
  {
    "codigo":165413005,
    "descripcion":"HEMATÓCRITO POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":294650000,
    "descripcion":"ALERGIA A COMPONENTE DE VACUNA QUE CONTIENE ANTÍGENO CONTRA ORTORUBULAVIRUS DE LAS PAPERAS"
  },
  {
    "codigo":720634003,
    "descripcion":"SÍNDROME DE ATAXIA CEREBELOSA, ARREFLEXIA, PIE CAVO, ATROFIA ÓPTICA, HIPOACUSIA NEUROSENSORIAL"
  },
  {
    "codigo":1179386005,
    "descripcion":"INFECCIÓN VIRAL DE NERVIO PERIFÉRICO"
  },
  {
    "codigo":32506008,
    "descripcion":"ROTACIÓN FETAL INTERNA"
  },
  {
    "codigo":65274008,
    "descripcion":"ANOMALÍA CONGÉNITA DE LAS GLÁNDULAS PARATIROIDES"
  },
  {
    "codigo":391119003,
    "descripcion":"PRUEBA DE REVERSIBILIDAD AL IPRATROPIO : POSITIVA"
  },
  {
    "codigo":128975004,
    "descripcion":"ESTADO DE REPOSO"
  },
  {
    "codigo":292815005,
    "descripcion":"REACCIÓN ADVERSA AL CLOTRIMAZOL"
  },
  {
    "codigo":127140000,
    "descripcion":"LINFADENOPATÍA AÓRTICA"
  },
  {
    "codigo":1306788001,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE CUARTO ANTERIOR"
  },
  {
    "codigo":225444004,
    "descripcion":"CON MAYOR RIESGO DE SUICIDIO"
  },
  {
    "codigo":290980004,
    "descripcion":"INTOXICACIÓN POR CLONAZEPAM"
  },
  {
    "codigo":94372008,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA PARED LATERAL DE LA NASOFARINGE"
  },
  {
    "codigo":715129000,
    "descripcion":"INCAPAZ DE PASAR DE LA CAMA A UNA SILLA DE RUEDAS"
  },
  {
    "codigo":11818611000119101,
    "descripcion":"ESGUINCE DE LIGAMENTO DE ARTICULACIÓN INTERFALÁNGICA DE DEDO ANULAR IZQUIERDO"
  },
  {
    "codigo":92537005,
    "descripcion":"CARCINOMA IN SITU DEL ANO"
  },
  {
    "codigo":289145007,
    "descripcion":"HALLAZGO RELACIONADO CON EL PATRÓN DE ALIMENTACIÓN DEL LACTANTE"
  },
  {
    "codigo":420217008,
    "descripcion":"HALLAZGO RELACIONADO CON LA AGUDEZA VISUAL DEL OJO IZQUIERDO"
  },
  {
    "codigo":90702000,
    "descripcion":"REACCIÓN AUTOINMUNITARIA MEDIADA POR INMUNOCOMPLEJOS"
  },
  {
    "codigo":27001009,
    "descripcion":"VESICULITIS ESPERMÁTICA"
  },
  {
    "codigo":1335886001,
    "descripcion":"SINOSTOSIS RADIOCUBITAL DE AMBOS ANTEBRAZOS"
  },
  {
    "codigo":189006001,
    "descripcion":"LIPOMA DE PIE"
  },
  {
    "codigo":25166002,
    "descripcion":"INTOXICACIÓN POR HERBICIDA DE HORMONAS VEGETALES"
  },
  {
    "codigo":449315003,
    "descripcion":"ANOMALÍA CONGÉNITA DE CUERDAS TENDINOSAS DE VÁLVULA AURICULOVENTRICULAR DERECHA EN VENTRÍCULO CON DOBLE TRACTO DE ENTRADA"
  },
  {
    "codigo":159911000146108,
    "descripcion":"A VECES SE SIENTE INSEGURO ACERCA DE CUIDAR A UN NIÑO"
  },
  {
    "codigo":285475004,
    "descripcion":"INCAPAZ DE MOVER LOS LABIOS"
  },
  {
    "codigo":1137443007,
    "descripcion":"CALCIFICACIÓN PUNTEADA DE ESQUELETO CARTILAGINOSO EN LA LACTANCIA"
  },
  {
    "codigo":19661000,
    "descripcion":"ELEFANTIASIS POR BRUGIA MALAYI"
  },
  {
    "codigo":185336008,
    "descripcion":"INCUMPLIDOR CON LAS CITACIONES"
  },
  {
    "codigo":283640008,
    "descripcion":"HERIDA POR PINCHAZO DE AGUJA EN DEDO DEL PIE"
  },
  {
    "codigo":249037004,
    "descripcion":"MEMBRANA AMNIÓTICA SOBRE LA CABEZA DEL BEBÉ EN EL MOMENTO DEL PARTO"
  },
  {
    "codigo":773325004,
    "descripcion":"SÍNDROME DE MICRODUPLICACIÓN 7Q11.23 DISTAL"
  },
  {
    "codigo":1363149006,
    "descripcion":"ASTILLA EN MANO CON INFECCIÓN"
  },
  {
    "codigo":871629009,
    "descripcion":"REACCIÓN ADVERSA A ÁCIDO CLODRÓNICO"
  },
  {
    "codigo":247202002,
    "descripcion":"CÚPULA ÓPTICA OCUPADA"
  },
  {
    "codigo":771490005,
    "descripcion":"FRACTURAS QUE COMPROMETEN REGIONES MÚLTIPLES DE LA EXTREMIDAD INFERIOR DERECHA"
  },
  {
    "codigo":48759000,
    "descripcion":"FORÚNCULO DE TOBILLO"
  },
  {
    "codigo":212599001,
    "descripcion":"INTOXICACIÓN POR DERIVADO DE PIRAZOL"
  },
  {
    "codigo":15991002,
    "descripcion":"DEFICIENCIA GRAVE DE ESTEROIDE 21 - HIDROXILASA"
  },
  {
    "codigo":441975003,
    "descripcion":"MASA DE LENGUA"
  },
  {
    "codigo":79692001,
    "descripcion":"CORTOCIRCUITO DE DERECHA A IZQUIERDA"
  },
  {
    "codigo":866124002,
    "descripcion":"MIELITIS CAUSADA POR POLIOVIRUS HUMANO"
  },
  {
    "codigo":1193804003,
    "descripcion":"ENTERITIS POR GIARDIA LAMBLIA"
  },
  {
    "codigo":276300008,
    "descripcion":"ESTUPOR DISOCIATIVO"
  },
  {
    "codigo":77857001,
    "descripcion":"INTOXICACIÓN POR PROGUANIL"
  },
  {
    "codigo":405537002,
    "descripcion":"REPOSICIÓN PREOPERATORIA DE LÍQUIDOS INADECUADA"
  },
  {
    "codigo":45089002,
    "descripcion":"VISIÓN NORMAL"
  },
  {
    "codigo":1259340008,
    "descripcion":"CARCINOMA PRIMARIO DE ÁREA RETROMOLAR"
  },
  {
    "codigo":307233002,
    "descripcion":"EROSIÓN DE ESTÓMAGO CON HEMORRAGIA"
  },
  {
    "codigo":733217006,
    "descripcion":"LESIÓN TRAUMÁTICA DE ÓRGANO INTRATORÁCICO"
  },
  {
    "codigo":208929003,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE LA ARTICULACIÓN FEMORORROTULIANA"
  },
  {
    "codigo":1255670000,
    "descripcion":"HALLAZGO DE NIVEL DE RIESGO AUMENTADO"
  },
  {
    "codigo":239862000,
    "descripcion":"ARTROSIS IDIOPÁTICA"
  },
  {
    "codigo":1222902000,
    "descripcion":"NO PATEA CON PIERNA"
  },
  {
    "codigo":403702001,
    "descripcion":"PIODERMIA GANGRENOSA PARAESTOMAL"
  },
  {
    "codigo":700449008,
    "descripcion":"HIPERGLUCEMIA NO RELACIONADA CON DIABETES"
  },
  {
    "codigo":698614006,
    "descripcion":"SORDOMUTISMO ADQUIRIDO"
  },
  {
    "codigo":10486009,
    "descripcion":"INTOXICACIÓN POR MEDAZEPAM"
  },
  {
    "codigo":238027003,
    "descripcion":"GANGLIOSISDOSIS GM1 DEL ADULTO"
  },
  {
    "codigo":762315004,
    "descripcion":"LEUCEMIA MIELOIDE AGUDA RELACIONADA CON TRATAMIENTO DEBIDA A LA ADMINISTRACIÓN DE AGENTE ANTINEOPLÁSICO Y POSTERIOR A ELLA"
  },
  {
    "codigo":301728005,
    "descripcion":"NO REALIZA ACTIVIDADES LABORALES"
  },
  {
    "codigo":133031000119106,
    "descripcion":"TROMBOSIS DE INJERTO ARTERIOVENOSO CAUSADA POR DISPOSITIVO DE ACCESO ARTERIOVENOSO PARA HEMODIÁLISIS"
  },
  {
    "codigo":365429000,
    "descripcion":"FERTILIDAD DEL SEMEN - HALLAZGO"
  },
  {
    "codigo":37749001,
    "descripcion":"SIGNO DE DAWBARN"
  },
  {
    "codigo":4981000,
    "descripcion":"ENFISEMA PANACINAR"
  },
  {
    "codigo":72352009,
    "descripcion":"VÁLVULA AÓRTICA BICÚSPIDE"
  },
  {
    "codigo":170656008,
    "descripcion":"EJERCICIO RESTRINGIDO POR EL ASMA OCASIONALMENTE"
  },
  {
    "codigo":398197009,
    "descripcion":"QUISTE COLEDOCIANO CONGÉNITO"
  },
  {
    "codigo":199754002,
    "descripcion":"TRABAJO DE PARTO OBSTRUIDO POR PRESENTACIÓN DE HOMBROS"
  },
  {
    "codigo":429130005,
    "descripcion":"HALLADO DE PIE"
  },
  {
    "codigo":722207000,
    "descripcion":"SÍNDROME DE INSUFICIENCIA PANCREÁTICA, ANEMIA DISERITROPOYÉTICA, HIPEROSTOSIS DE CALOTA CRANEAL"
  },
  {
    "codigo":230687001,
    "descripcion":"MIOPATÍA EN LA MIASTENIA GRAVE"
  },
  {
    "codigo":15671361000119104,
    "descripcion":"BRAQUIDACTILIA DE DEDOS DE PIE DERECHO"
  },
  {
    "codigo":427295004,
    "descripcion":"ASMA PERSISTENTE MODERADA"
  },
  {
    "codigo":296223003,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE TIETILPERAZINA"
  },
  {
    "codigo":197919005,
    "descripcion":"ESTENOSIS DEL MEATO URINARIO"
  },
  {
    "codigo":294388006,
    "descripcion":"ALERGIA A PIRIMETAMINA"
  },
  {
    "codigo":718537002,
    "descripcion":"ALERGIA A ROSUVASTATINA"
  },
  {
    "codigo":292553006,
    "descripcion":"REACCIÓN ADVERSA A LA CARBOCISTEÍNA"
  },
  {
    "codigo":94110001,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL NERVIO TROCLEAR"
  },
  {
    "codigo":1306526002,
    "descripcion":"CARCINOMA IN SITU DE CUADRANTE SUPERIOR INTERNO DE MAMA"
  },
  {
    "codigo":28574005,
    "descripcion":"ANOMALÍA CONGÉNITA DE LA ARTERIA CORONARIA"
  },
  {
    "codigo":92275006,
    "descripcion":"NEOPLASIA BENIGNA DE HUESO PARIETAL"
  },
  {
    "codigo":713032002,
    "descripcion":"DISECCIÓN DE ARTERIA DE MIEMBRO INFERIOR"
  },
  {
    "codigo":287048003,
    "descripcion":"DOLOR EN MIEMBRO INFERIOR DERECHO"
  },
  {
    "codigo":188744006,
    "descripcion":"LEUCEMIA MONOCÍTICA"
  },
  {
    "codigo":254280007,
    "descripcion":"FENOTIPO DE TURNER, CARIOTIPO DE DELECIÓN PARCIAL DEL CROMOSOMA X"
  },
  {
    "codigo":285213001,
    "descripcion":"UTILIZACIÓN DE LISTAS COMO AYUDA MEMORIA"
  },
  {
    "codigo":449053004,
    "descripcion":"LINFOMA DE ESÓFAGO INFERIOR"
  },
  {
    "codigo":78259006,
    "descripcion":"INFECCIÓN CAUSADA POR CHABERTIA"
  },
  {
    "codigo":840434004,
    "descripcion":"DISECCIÓN DE ARTERIA CEREBRAL POSTERIOR"
  },
  {
    "codigo":283378004,
    "descripcion":"LACERACIÓN DEL ABDOMEN"
  },
  {
    "codigo":248775000,
    "descripcion":"ERECCIÓN EXCESIVA"
  },
  {
    "codigo":21234008,
    "descripcion":"ESTENOSIS CONGÉNITA DE AORTA"
  },
  {
    "codigo":347079002,
    "descripcion":"TRASTORNO DE LA CUERDA TIMPÁNICA"
  },
  {
    "codigo":19399000,
    "descripcion":"OTITIS MEDIA AGUDA EXUDATIVA"
  },
  {
    "codigo":1197212001,
    "descripcion":"MENINGOCELE POSTERIOR"
  },
  {
    "codigo":281543009,
    "descripcion":"DISTENSIÓN DE TENDÓN DE CARA INTERNA DE MUSLO"
  },
  {
    "codigo":1295516002,
    "descripcion":"HIPERTENSIÓN OCULAR BILATERAL DEBIDA A SÍNDROME SISTÉMICO"
  },
  {
    "codigo":212337002,
    "descripcion":"LESIÓN NERVIOSA MÚLTIPLE A NIVEL DE TOBILLO Y PIE"
  },
  {
    "codigo":276038000,
    "descripcion":"SIN AYUDA DISPONIBLE"
  },
  {
    "codigo":1259078003,
    "descripcion":"TRASTORNO AUTONÓMICO DEBIDO A TÉTANOS"
  },
  {
    "codigo":308806009,
    "descripcion":"SITUACIÓN DEL INFORME FORENSE"
  },
  {
    "codigo":405275001,
    "descripcion":"RUPTURA DE LIGAMENTO LATERAL CUBITAL DE PULGAR"
  },
  {
    "codigo":732955001,
    "descripcion":"SÍNDROME DE SINFALANGISMO CON MÚLTIPLES ANOMALÍAS DE MANOS Y PIES"
  },
  {
    "codigo":77595004,
    "descripcion":"DEFORMIDAD DE REDUCCIÓN DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":274203005,
    "descripcion":"HEMATOMA SUBUNGUEAL DEL PIE"
  },
  {
    "codigo":208667002,
    "descripcion":"FRACTURA NO EXPUESTA DE TOBILLO, TRIMALEOLAR, FRACTURA PERONEA SUPERIOR"
  },
  {
    "codigo":306971007,
    "descripcion":"INCAPAZ DE ESCUCHAR LA VOZ EN UNA CONVERSACIÓN"
  },
  {
    "codigo":698352000,
    "descripcion":"INFLAMACIÓN CRÓNICA DEL ANTRO GÁSTRICO CON HEMORRAGIA"
  },
  {
    "codigo":700187009,
    "descripcion":"ATENDIDO EN CONSULTORIO ESPECIALIZADO EN USO INAPROPIADO DE DROGAS"
  },
  {
    "codigo":403440002,
    "descripcion":"FISURA MEDIANA DE LABIO"
  },
  {
    "codigo":1255408003,
    "descripcion":"REACCIÓN ADVERSA A ETANOL"
  },
  {
    "codigo":75760003,
    "descripcion":"AMPOLLA DE ANTEBRAZO, SIN INFECCIÓN"
  },
  {
    "codigo":763888005,
    "descripcion":"NEUMONÍA NECROSANTE CAUSADA POR STAPHYLOCOCCUS AUREUS PRODUCTOR DE LEUCOCIDINA DE PANTON-VALENTINE"
  },
  {
    "codigo":681000119101,
    "descripcion":"PROBLEMA DE RELACIÓN CON HERMANOS"
  },
  {
    "codigo":237765003,
    "descripcion":"HIPOALDOSTERONISMO HIPERRENINÉMICO"
  },
  {
    "codigo":235930006,
    "descripcion":"ULCERACIÓN DE LA VÍA BILIAR"
  },
  {
    "codigo":203162009,
    "descripcion":"OSTEOMIELITIS AGUDA DE CLAVÍCULA"
  },
  {
    "codigo":299631003,
    "descripcion":"ARTICULACIÓN DEL DEDO DEL PIE ESTABLE"
  },
  {
    "codigo":15729321000119104,
    "descripcion":"LUXACIÓN DE HOMBRO IZQUIERDO DEBIDA A DISPLASIA CONGÉNITA"
  },
  {
    "codigo":234095009,
    "descripcion":"MALFORMACIÓN DE VASOS LINFÁTICOS"
  },
  {
    "codigo":365167009,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA ABRIR Y CERRAR RECIPIENTES"
  },
  {
    "codigo":428868003,
    "descripcion":"RINITIS GUSTATIVA"
  },
  {
    "codigo":232260004,
    "descripcion":"COLESTEATOMA MASTOIDEO"
  },
  {
    "codigo":2884008,
    "descripcion":"SÍNDROME DE WEILL - MARCHESANI"
  },
  {
    "codigo":263193000,
    "descripcion":"FRACTURA SUPRACONDÍLEA DE HÚMERO"
  },
  {
    "codigo":164889003,
    "descripcion":"FIBRILACIÓN AURICULAR EN EL ELECTROCARDIOGRAMA"
  },
  {
    "codigo":295961004,
    "descripcion":"SOBREDOSIS DE BECLAMIDA"
  },
  {
    "codigo":230425004,
    "descripcion":"ENFERMEDAD DE LAFORA"
  },
  {
    "codigo":64750001,
    "descripcion":"SUBLIMACIÓN - MECANISMO DE DEFENSA PSICOLÓGICO"
  },
  {
    "codigo":294126003,
    "descripcion":"ALERGIA A PROMETAZINA"
  },
  {
    "codigo":95683004,
    "descripcion":"COROIDITIS GRANULOMATOSA"
  },
  {
    "codigo":292291007,
    "descripcion":"REACCIÓN ADVERSA A LA IMIPRAMINA"
  },
  {
    "codigo":126616000,
    "descripcion":"NEOPLASIA DE MÚSCULO"
  },
  {
    "codigo":93848003,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA ZONA DE UNIÓN DE LA LENGUA"
  },
  {
    "codigo":1339032004,
    "descripcion":"TRASTORNO DE ARTERIA CAUSADO POR RADIACIÓN IONIZANTE"
  },
  {
    "codigo":716440005,
    "descripcion":"CAPAZ DE RECONOCER DOLOR EN PARTE DEL CUERPO"
  },
  {
    "codigo":92013001,
    "descripcion":"NEOPLASIA BENIGNA DE VASO SANGUÍNEO DEL TÓRAX"
  },
  {
    "codigo":16905181000119102,
    "descripcion":"MELANOMA MALIGNO DE PIEL DE PÁRPADO INFERIOR DERECHO"
  },
  {
    "codigo":254018004,
    "descripcion":"FISURA FACIAL INFRAORBITARIA- FISURA DE TESSIER TIPO 6"
  },
  {
    "codigo":685021000119103,
    "descripcion":"HEMANGIOMA DE HUESO"
  },
  {
    "codigo":286786007,
    "descripcion":"RASGO DE LA PERSONALIDAD: CONTROL DE LA IRA - HALLAZGO"
  },
  {
    "codigo":284951000,
    "descripcion":"INCAPAZ DE LAVARSE LUEGO DE IR AL BAÑO"
  },
  {
    "codigo":403018000,
    "descripcion":"TIÑA DE CUERO CABELLUDO CAUSADA POR TRICHOPHYTON VIOLACEUM"
  },
  {
    "codigo":1004012004,
    "descripcion":"TRASTORNO FETAL DEBIDO A PROCEDIMIENTO QUIRÚRGICO SOBRE EL FETO Y POSTERIOR A ÉL"
  },
  {
    "codigo":283116004,
    "descripcion":"AMPOLLA TRAUMÁTICA DE LA FRENTE"
  },
  {
    "codigo":445121000,
    "descripcion":"UTILIZA ANOTADOR ELECTRÓNICO"
  },
  {
    "codigo":53740009,
    "descripcion":"PÓLIPO DEL LIGAMENTO ANCHO"
  },
  {
    "codigo":281281000,
    "descripcion":"ESPÉCIMEN SIN LIPEMIA VISIBLE"
  },
  {
    "codigo":248513002,
    "descripcion":"NÓDULOS DE LISCH DE IRIS"
  },
  {
    "codigo":314049009,
    "descripcion":"ENDOMETRIOSIS DEL LIGAMENTO UTEROSACRO"
  },
  {
    "codigo":246678002,
    "descripcion":"EQUIMOSIS SUBCONJUNTIVAL"
  },
  {
    "codigo":1295254003,
    "descripcion":"SCHWANNOMA MICROQUÍSTICO \/ RETICULAR"
  },
  {
    "codigo":443286004,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN"
  },
  {
    "codigo":312214005,
    "descripcion":"SÍNDROME DE FLOATING HARBOR"
  },
  {
    "codigo":1196950005,
    "descripcion":"DEFECTO DE GEN DE SUBUNIDAD ESTRUCTURAL DE COMPLEJO IV DE CADENA RESPIRATORIA MITOCONDRIAL"
  },
  {
    "codigo":82838007,
    "descripcion":"TAQUICARDIA IRREGULAR"
  },
  {
    "codigo":408683000,
    "descripcion":"ASPERGILOSIS PULMONAR ASOCIADA CON LA ATENCIÓN MÉDICA"
  },
  {
    "codigo":330871000119104,
    "descripcion":"XERODERMIA DE PÁRPADO IZQUIERDO"
  },
  {
    "codigo":15467003,
    "descripcion":"NACIMIENTO DE TÉRMINO DE GEMELOS MONOCIGÓTICOS, AMBOS VIVOS"
  },
  {
    "codigo":212075005,
    "descripcion":"CORROSIÓN QUE COMPROMETE EL 40 AL 49 PORCIENTO DE SUPERFICIE CORPORAL"
  },
  {
    "codigo":277611003,
    "descripcion":"ENFERMEDAD DE HODGKIN DE CELULARIDAD MIXTA CON ESCLEROSIS NODULAR"
  },
  {
    "codigo":15977591000119105,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE OJO DERECHO"
  },
  {
    "codigo":111936002,
    "descripcion":"SARCOIDOSIS CEREBRAL"
  },
  {
    "codigo":275776005,
    "descripcion":"PORFIRINAS EN ORINA - HALLAZGO"
  },
  {
    "codigo":10652791000119106,
    "descripcion":"ÚLCERA POR ESTASIS VENOSA DE PIERNA DERECHA CONCOMITANTE CON EDEMA DE PIERNA DERECHA"
  },
  {
    "codigo":13632006,
    "descripcion":"INTOXICACIÓN POR METARAMINOL"
  },
  {
    "codigo":79168008,
    "descripcion":"GENU VARO CONGÉNITO"
  },
  {
    "codigo":243008009,
    "descripcion":"LESIÓN POR MUNICIÓN"
  },
  {
    "codigo":208405003,
    "descripcion":"FRACTURA NO EXPUESTA DE LA DIÁFISIS DEL PRIMER METACARPIANO"
  },
  {
    "codigo":110101006,
    "descripcion":"LACERACIÓN COMPLEJA DE MUCOSA YUGAL"
  },
  {
    "codigo":206570000,
    "descripcion":"REACCIÓN MEDICAMENTOSA E INTOXICACIÓN NEONATAL"
  },
  {
    "codigo":77333008,
    "descripcion":"PERIFOLICULITIS DEL CUERO CABELLUDO ABSCEDADA Y DISECANTE"
  },
  {
    "codigo":75498004,
    "descripcion":"SINUSITIS BACTERIANA AGUDA"
  },
  {
    "codigo":1156842005,
    "descripcion":"PARAPLEJÍA ESPÁSTICA HEREDITARIA PURA LIGADA AL CROMOSOMA X"
  },
  {
    "codigo":763626009,
    "descripcion":"DISCAPACIDAD INTELECTUAL DEBIDA A DEFICIENCIA NUTRICIONAL"
  },
  {
    "codigo":403178009,
    "descripcion":"ECCEMA CRAQUELÉ POR EDEMA AGUDO"
  },
  {
    "codigo":237503005,
    "descripcion":"TIROXICOSIS LIMÍTROFE"
  },
  {
    "codigo":73663008,
    "descripcion":"TRASTORNO DE SISTEMA NERVIOSO CENTRAL DEBIDO A XERODERMIA PIGMENTOSA"
  },
  {
    "codigo":16907691000119100,
    "descripcion":"NEVO DISPLÁSICO DE PIEL DE PÁRPADO INFERIOR DERECHO"
  },
  {
    "codigo":301204007,
    "descripcion":"ADENOIDES PRESENTES"
  },
  {
    "codigo":6292008,
    "descripcion":"SIGNO DEL OBTURADOR"
  },
  {
    "codigo":202900007,
    "descripcion":"SINOVITIS Y TENOSINOVITIS"
  },
  {
    "codigo":299369002,
    "descripcion":"INESTABILIDAD ANTEROPOSTERIOR DE ARTICULACIÓN DE RODILLA"
  },
  {
    "codigo":266601003,
    "descripcion":"MENSTRUACIÓN EXCESIVA Y FRECUENTE"
  },
  {
    "codigo":233833005,
    "descripcion":"INFARTO AGUDO DE ONDA Q - LATERAL"
  },
  {
    "codigo":364905006,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA ADOPTAR UNA POSTURA"
  },
  {
    "codigo":10954001000119108,
    "descripcion":"HERIDA ABIERTA DE MUÑECA IZQUIERDA DEBIDA A MORDEDURA DE GATO"
  },
  {
    "codigo":168297009,
    "descripcion":"ORGANISMO NO AISLADO EN CULTIVO DE HISOPADO NASAL"
  },
  {
    "codigo":789054002,
    "descripcion":"RUPTURA TRAUMÁTICA DE LIGAMENTO ESCAFOSEMILUNAR"
  },
  {
    "codigo":166462003,
    "descripcion":"ÍNDICE ANDROGÉNICO LIBRE FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":35390002,
    "descripcion":"RECHAZO CRÓNICO INACTIVO DE INJERTO"
  },
  {
    "codigo":231998005,
    "descripcion":"PLIEGUE COROIDEO"
  },
  {
    "codigo":68158006,
    "descripcion":"CICLOPLEJÍA"
  },
  {
    "codigo":2622007,
    "descripcion":"ÚLCERA CUTÁNEA INFECTADA"
  },
  {
    "codigo":363070008,
    "descripcion":"TRASTORNO HEREDITARIO CONGÉNITO"
  },
  {
    "codigo":787001,
    "descripcion":"ESTENOSIS MITRAL REUMÁTICA CON INSUFICIENCIA"
  },
  {
    "codigo":199230006,
    "descripcion":"DIABETES MELLITUS TIPO 2 PREEXISTENTE"
  },
  {
    "codigo":46091000087101,
    "descripcion":"ESGUINCE DE LIGAMENTO SACROILÍACO IZQUIERDO"
  },
  {
    "codigo":262931005,
    "descripcion":"SECCIÓN DE TROMPA DE FALOPIO"
  },
  {
    "codigo":40971000087101,
    "descripcion":"QUEMADURA DE EXTREMIDAD SUPERIOR IZQUIERDA"
  },
  {
    "codigo":721683008,
    "descripcion":"INFECCIÓN QUE CAUSA ABSCESO DE COLON"
  },
  {
    "codigo":43531000087102,
    "descripcion":"DESGARRO DE MENISCO INTERNO DE ARTICULACIÓN DE RODILLA DERECHA"
  },
  {
    "codigo":295699008,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE ÓXIDO MERCÚRICO"
  },
  {
    "codigo":719848005,
    "descripcion":"TRASTORNO CAUSADO POR ALCOHOL"
  },
  {
    "codigo":293864009,
    "descripcion":"ALERGIA A METILFENOBARBITAL"
  },
  {
    "codigo":95421005,
    "descripcion":"MIALGIA INTERCOSTAL"
  },
  {
    "codigo":783549006,
    "descripcion":"OBESIDAD DEBIDA A DEFICIENCIA DE CEP19"
  },
  {
    "codigo":29885006,
    "descripcion":"INESTABILIDAD DE ARTICULACIÓN SACROILÍACA"
  },
  {
    "codigo":128189008,
    "descripcion":"MONONEUROPATÍA"
  },
  {
    "codigo":292029007,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR UROQUINASA"
  },
  {
    "codigo":60818005,
    "descripcion":"AFAGIA"
  },
  {
    "codigo":288359002,
    "descripcion":"NO LANZA OBJETOS"
  },
  {
    "codigo":124519003,
    "descripcion":"DEFICIENCIA DE ALANTOICASA"
  },
  {
    "codigo":333381000119104,
    "descripcion":"ESCOTOMA PARACECAL DERECHO"
  },
  {
    "codigo":253756002,
    "descripcion":"DESPLAZAMIENTO DE CONDUCTO DE WHARTON"
  },
  {
    "codigo":778044004,
    "descripcion":"PAQUIDERMIA PLEGADA DE CUERO CABELLUDO PRIMARIA NO ESENCIAL"
  },
  {
    "codigo":712508005,
    "descripcion":"DESPRENDIMIENTO DE RETINA REGMATÓGENO DEBIDO A DIÁLISIS RETINIANA"
  },
  {
    "codigo":57148006,
    "descripcion":"ANOMALÍA CONGÉNITA DEL CEREBRO"
  },
  {
    "codigo":286524005,
    "descripcion":"DIFICULTAD PARA LLEVAR ALIMENTOS PREPARADOS"
  },
  {
    "codigo":188220005,
    "descripcion":"NEOPLASIA MALIGNA DE TESTÍCULO ECTÓPICO"
  },
  {
    "codigo":415761002,
    "descripcion":"NO ES POSIBLE EVALUAR LA LOCALIZACIÓN DEL NÓDULO TUMORAL"
  },
  {
    "codigo":1234961002,
    "descripcion":"TRASTORNO NEONATAL DEBIDO A ENREDO DE CORDÓN"
  },
  {
    "codigo":250086000,
    "descripcion":"DESVIACIÓN DE ARTICULACIÓN"
  },
  {
    "codigo":20710005,
    "descripcion":"FORMACIÓN DE LÍQUIDO CEFALORRAQUÍDEO DISMINUIDA"
  },
  {
    "codigo":282854008,
    "descripcion":"INCAPAZ DE MANTENERSE EN BIPEDESTACIÓN"
  },
  {
    "codigo":444859001,
    "descripcion":"PULMONES EN DISPOSICIÓN NORMAL"
  },
  {
    "codigo":1003750009,
    "descripcion":"CONTRACTURA EN FLEXIÓN DE ARTICULACIÓN METACARPOFALÁNGICA DE DEDO PULGAR"
  },
  {
    "codigo":248251001,
    "descripcion":"SANGRA FÁCILMENTE"
  },
  {
    "codigo":770704000,
    "descripcion":"REACCIÓN ADVERSA AL FACTOR IX"
  },
  {
    "codigo":17040003,
    "descripcion":"INTOXICACIÓN POR LOBELIA CARDINALIS"
  },
  {
    "codigo":49808004,
    "descripcion":"EDAD AVANZADA"
  },
  {
    "codigo":82576008,
    "descripcion":"CUERPO EXTRAÑO RETENIDO EN OJO"
  },
  {
    "codigo":47973001,
    "descripcion":"ARTIFICIO"
  },
  {
    "codigo":1260389007,
    "descripcion":"HEMICOREA DEBIDA A ABSCESO CEREBRAL"
  },
  {
    "codigo":277349008,
    "descripcion":"QUEMADURA POR PLACA DE DIATERMIA"
  },
  {
    "codigo":275514001,
    "descripcion":"FUNCIÓN VENTRICULAR IZQUIERDA DETERIORADA"
  },
  {
    "codigo":13370002,
    "descripcion":"FIBROMATOSIS DE FASCIA PLANTAR"
  },
  {
    "codigo":441189007,
    "descripcion":"DEFICIENCIA HOMOCIGOTA DE PROTEÍNA S"
  },
  {
    "codigo":406586005,
    "descripcion":"INFECCIÓN DEL SISTEMA NERVIOSO CENTRAL POR VIRUS DEL HERPES"
  },
  {
    "codigo":46138007,
    "descripcion":"NEUROPATÍA DEGENERATIVA NEUROGÉNICA NIGERIANA"
  },
  {
    "codigo":373818007,
    "descripcion":"SIN TRATAMIENTO ONCOLÓGICO - CONDUCTA EXPECTANTE"
  },
  {
    "codigo":371983001,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE GLÁNDULA ENDOCRINA"
  },
  {
    "codigo":109839004,
    "descripcion":"NEOPLASIA MALIGNA SUPERPUESTA DEL RECTO, ANO Y CONDUCTO ANAL"
  },
  {
    "codigo":240911006,
    "descripcion":"QUISTE POR LINGUATULINA"
  },
  {
    "codigo":239076000,
    "descripcion":"SÍNDROME DE HIPERQUERATOSIS PALMOPLANTAR Y ESCLERODACTILIA"
  },
  {
    "codigo":75236001,
    "descripcion":"ABSCESO ANORRECTAL"
  },
  {
    "codigo":1254884001,
    "descripcion":"DERMATOSIS AMPOLLAR AUTOINMUNE POR FÁRMACO"
  },
  {
    "codigo":11535009,
    "descripcion":"FACIES LEONINA"
  },
  {
    "codigo":237241002,
    "descripcion":"EMBARAZO VIABLE"
  },
  {
    "codigo":11804691000119101,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA DISTAL DE DEDO ANULAR DERECHO"
  },
  {
    "codigo":827065006,
    "descripcion":"TONO DE MÚSCULO ESQUELÉTICO NORMAL"
  },
  {
    "codigo":106169008,
    "descripcion":"AFASIA, AGNOSIA, DISLEXIA Y\/O APRAXIA"
  },
  {
    "codigo":300942003,
    "descripcion":"DOLOR A LA PALPACIÓN EN GANGLIO LINFÁTICO"
  },
  {
    "codigo":268174004,
    "descripcion":"BULBUS CORDIS Y ANOMALÍAS DE CIERRE DE TABIQUES CARDÍACOS"
  },
  {
    "codigo":366478004,
    "descripcion":"HALLAZGO RELACIONADO CON LA AMPLITUD DE LA ABDUCCIÓN DE HOMBRO"
  },
  {
    "codigo":78728005,
    "descripcion":"GASTROTORACÓPAGO"
  },
  {
    "codigo":4195003,
    "descripcion":"DUPLICACIÓN CONGÉNITA DEL ANO"
  },
  {
    "codigo":16637971000119104,
    "descripcion":"TRASTORNO DE AMBOS NERVIOS PLANTARES LATERALES"
  },
  {
    "codigo":36963005,
    "descripcion":"OSTEÍTIS PEDIA"
  },
  {
    "codigo":102499006,
    "descripcion":"EN FORMA Y BIEN"
  },
  {
    "codigo":1149240000,
    "descripcion":"SOBREDOSIS ACCIDENTAL POR DIETILAMIDA DE ÁCIDO LISÉRGICO"
  },
  {
    "codigo":461112001,
    "descripcion":"TRAYECTO ANÓMALO DE ARTERIA CORONARIA POR DELANTE DEL TRONCO PULMONAR"
  },
  {
    "codigo":67896006,
    "descripcion":"LEISHMANIASIS DÉRMICA POST - KALA AZAR"
  },
  {
    "codigo":35128007,
    "descripcion":"INFESTACIÓN CAUSADA POR DERMANYSSUS"
  },
  {
    "codigo":1891000124102,
    "descripcion":"TRANSICIÓN DE LA ATENCIÓN AGUDA A ATENCIÓN EN CUIDADOS PALIATIVOS"
  },
  {
    "codigo":611171000124102,
    "descripcion":"VIVIENDA QUE SATISFACE NECESIDADES FUNCIONALES"
  },
  {
    "codigo":262669002,
    "descripcion":"LESIÓN PENETRANTE DE OROFARINGE"
  },
  {
    "codigo":721421002,
    "descripcion":"FRACTURA DE SÉPTIMA VÉRTEBRA DORSAL"
  },
  {
    "codigo":295437002,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE DANTRÓN"
  },
  {
    "codigo":129762002,
    "descripcion":"CALCIFICACIÓN RADIOGRÁFICA FINA, LINEAL, RAMIFICADA"
  },
  {
    "codigo":64226004,
    "descripcion":"COLITIS"
  },
  {
    "codigo":293602008,
    "descripcion":"ALERGIA A ALCALOIDE DEL OPIO"
  },
  {
    "codigo":226231002,
    "descripcion":"DIETA CHINA"
  },
  {
    "codigo":62391003,
    "descripcion":"ESTERILIDAD POSOPERATORIA"
  },
  {
    "codigo":193463006,
    "descripcion":"ATROFIA COROIDEA SECUNDARIA DIFUSA"
  },
  {
    "codigo":95159006,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL TERCIO SUPERIOR DEL ESÓFAGO"
  },
  {
    "codigo":816055008,
    "descripcion":"TUMORACIÓN DE CUADRANTE SUPERIOR EXTERNO DE MAMA"
  },
  {
    "codigo":160695008,
    "descripcion":"TRANSPORTE DEMASIADO COSTOSO"
  },
  {
    "codigo":93324004,
    "descripcion":"POSICIÓN ANÓMALA CONGÉNITA DE LA VESÍCULA BILIAR"
  },
  {
    "codigo":16011591000119100,
    "descripcion":"SÍNDROME COMPARTIMENTAL TIBIAL ANTERIOR DE AMBAS PIERNAS DEBIDO A LESIÓN TRAUMÁTICA"
  },
  {
    "codigo":91489000,
    "descripcion":"INSUFICIENCIA VASCULAR AGUDA DEL INTESTINO"
  },
  {
    "codigo":224396009,
    "descripcion":"ESCASA ACEPTACIÓN DE LA SUPERVISIÓN EN EL TRABAJO"
  },
  {
    "codigo":124257002,
    "descripcion":"DEFICIENCIA DE CARNITINA ACETILTRANSFERASA"
  },
  {
    "codigo":419169003,
    "descripcion":"HALO LÍMBICO DE VOGT, TIPO I"
  },
  {
    "codigo":253494003,
    "descripcion":"AUSENCIA DE VALVAS DE VÁLVULA AURICULOVENTRICULAR IZQUIERDA"
  },
  {
    "codigo":11860141000119109,
    "descripcion":"ESGUINCE DE LIGAMENTO CRUZADO DE RODILLA IZQUIERDA"
  },
  {
    "codigo":1264179007,
    "descripcion":"PIERCING EN TERCIO MEDIO DE LABIO SUPERIOR"
  },
  {
    "codigo":89654006,
    "descripcion":"TRASTORNO DEL QUIASMA ÓPTICO ASOCIADO CON TRASTORNO VASCULAR"
  },
  {
    "codigo":1269302007,
    "descripcion":"VÁRICE DE VENA DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":286262009,
    "descripcion":"INCAPAZ DE ACOMODAR LOS ÓRGANOS DE LA FONACIÓN EN EL MOMENTO DE ARTICULAR PALABRAS"
  },
  {
    "codigo":55051001,
    "descripcion":"MIASTENIA GRAVIS, FORMA JUVENIL"
  },
  {
    "codigo":448267005,
    "descripcion":"FIBROMA DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":87819007,
    "descripcion":"ESTAFILOMA POSTERIOR"
  },
  {
    "codigo":251659008,
    "descripcion":"ESPERMATOZOIDES EN MOCO CERVICAL POSCOITAL, MOTILIDAD DE PROGRESIÓN LENTA"
  },
  {
    "codigo":249824001,
    "descripcion":"DEDO GORDO DEL PIE FLÁCCIDO"
  },
  {
    "codigo":446432002,
    "descripcion":"HIPOPLASIA VENOSA PULMONAR"
  },
  {
    "codigo":282592001,
    "descripcion":"DIFICULTAD PARA BRINCAR EN UN SOLO PIE"
  },
  {
    "codigo":315360004,
    "descripcion":"PAÍS DE NACIMIENTO - ATLÁNTICO"
  },
  {
    "codigo":1003488007,
    "descripcion":"SOSPECHA DE GLAUCOMA DE ÁNGULO CERRADO"
  },
  {
    "codigo":247989001,
    "descripcion":"APARECE DESNUDO EN PÚBLICO"
  },
  {
    "codigo":18613002,
    "descripcion":"ABORTO ESPONTÁNEO CON CHOQUE SÉPTICO"
  },
  {
    "codigo":444597005,
    "descripcion":"LINFOMA DE LA ZONA MARGINAL EXTRAGANGLIONAR DE TEJIDO LINFOIDE ASOCIADO A MUCOSA DE ESTÓMAGO"
  },
  {
    "codigo":51381009,
    "descripcion":"DIÁMETRO AUMENTADO"
  },
  {
    "codigo":213386007,
    "descripcion":"LESIONES DE LOS MÚSCULOS Y TENDONES QUE COMPROMETEN MÚLTIPLES REGIONES DEL CUERPO"
  },
  {
    "codigo":442762009,
    "descripcion":"DISFUNCIÓN DEL EJE HIPOTALÁMICO-HIPOFISARIO-SUPRARRENAL"
  },
  {
    "codigo":440927002,
    "descripcion":"VIRUS DE INFLUENZA A SUBTIPO H2 PRESENTE"
  },
  {
    "codigo":1260127003,
    "descripcion":"VASCULITIS GRANULOMATOSA"
  },
  {
    "codigo":211551004,
    "descripcion":"LESIÓN TRAUMÁTICA CERRADA POR APLASTAMIENTO, REGIÓN DE HOMBRO"
  },
  {
    "codigo":735839004,
    "descripcion":"DISTENSIÓN DE MÚSCULO CUÁDRICEPS"
  },
  {
    "codigo":209716000,
    "descripcion":"SECCIÓN EXPUESTA DE SÍNFISIS PÚBICA"
  },
  {
    "codigo":80479009,
    "descripcion":"INSUFICIENCIA VENTRICULAR DERECHA, CONGESTIVA AGUDA"
  },
  {
    "codigo":111412007,
    "descripcion":"GRANULOMA URETRAL"
  },
  {
    "codigo":207881000,
    "descripcion":"FRACTURAS MÚLTIPLES QUE COMPROMETEN EL CRÁNEO Y LOS HUESOS FACIALES"
  },
  {
    "codigo":109577004,
    "descripcion":"CARIES DENTAL PRIMARIA, ORIGEN MULTISUPERFICIAL"
  },
  {
    "codigo":240649007,
    "descripcion":"LEISHMANIASIS PANAMEÑA"
  },
  {
    "codigo":238814003,
    "descripcion":"ERUPCIÓN MACULOPAPULAR POR FÁRMACOS"
  },
  {
    "codigo":402654005,
    "descripcion":"PÚRPURA TROMBOCITOPÉNICA POR CONSUMO DE PLAQUETAS"
  },
  {
    "codigo":304350007,
    "descripcion":"AMPLITUD DE MOVIMIENTO DE LA COLUMNA LUMBAR"
  },
  {
    "codigo":1287390007,
    "descripcion":"HERIDA DE GLÚTEO POR ARMA DE FUEGO"
  },
  {
    "codigo":292872000,
    "descripcion":"REACCIÓN ADVERSA A AGENTES FENÓLICOS"
  },
  {
    "codigo":87461000119100,
    "descripcion":"ÚLCERA DE ANTEPIÉ DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":1285555004,
    "descripcion":"CORIORRETINOPATÍA HEMORRÁGICA EXUDATIVA PERIFÉRICA"
  },
  {
    "codigo":15931301000119102,
    "descripcion":"QUISTE EMBRIONARIO DE OVARIO IZQUIERDO"
  },
  {
    "codigo":340901000119103,
    "descripcion":"ENTROPIÓN DE PÁRPADO IZQUIERDO"
  },
  {
    "codigo":369061000119104,
    "descripcion":"HEMORRAGIA DE LA VÍA URINARIA POSTERIOR A PROCEDIMIENTO TRANSURETRAL"
  },
  {
    "codigo":1187251009,
    "descripcion":"SÍNDROME DE CONTRACTURAS PROGRESIVAS, DEBILIDAD DE CINTURA DE EXTREMIDAD Y DISTROFIA MUSCULAR DE INICIO EN LA INFANCIA"
  },
  {
    "codigo":1080741000119106,
    "descripcion":"LIPOSARCOMA PRIMARIO DE PARTES BLANDAS DE EXTREMIDAD INFERIOR DERECHA"
  },
  {
    "codigo":16896421000119107,
    "descripcion":"PREDIABETES GESTACIONAL"
  },
  {
    "codigo":26021000119107,
    "descripcion":"VÉRTIGO COMO SECUELA DE ENFERMEDAD CEREBROVASCULAR"
  },
  {
    "codigo":1085861000119107,
    "descripcion":"COMPLICACIÓN DEBIDA A ENFERMEDAD DE CROHN DE INTESTINO DELGADO"
  },
  {
    "codigo":366216006,
    "descripcion":"HALLAZGO RELACIONADO CON LA PERFUSIÓN ARTERIAL DE LA MANO"
  },
  {
    "codigo":16709541000119108,
    "descripcion":"FRACTURA NO EXPUESTA DE PORCIÓN BASILAR DERECHA DE HUESO OCCIPITAL"
  },
  {
    "codigo":1075621000119109,
    "descripcion":"DERRAME DE BOLSA SEROSA DE OLÉCRANON DE CODO IZQUIERDO"
  },
  {
    "codigo":322981000119108,
    "descripcion":"DEDO ANULAR DERECHO EN GATILLO ADQUIRIDO"
  },
  {
    "codigo":298845001,
    "descripcion":"AMPLITUD DE CIRCUNDUCCIÓN ACTIVA DE HOMBRO AUMENTADA"
  },
  {
    "codigo":167773003,
    "descripcion":"VOLUMEN DE SEMEN BAJO: 0,5 - 1 ML"
  },
  {
    "codigo":1088421000119107,
    "descripcion":"PERICONDRITIS CRÓNICA DE OÍDO EXTERNO IZQUIERDO"
  },
  {
    "codigo":330661000119109,
    "descripcion":"COMPRESIÓN DE NERVIO PERONEO PROFUNDO DERECHO"
  },
  {
    "codigo":202376007,
    "descripcion":"DERRAME DE ARTICULACIÓN METACARPOFALÁNGICA"
  },
  {
    "codigo":724829007,
    "descripcion":"DERMATITIS POR CONTACTO OCUPACIONAL"
  },
  {
    "codigo":266077001,
    "descripcion":"INFECCIÓN ESTAFILOCÓCICA DEL TRACTO GASTROINTESTINAL"
  },
  {
    "codigo":15932181000119102,
    "descripcion":"CINTILLA OVÁRICA IZQUIERDA"
  },
  {
    "codigo":231474005,
    "descripcion":"DEPENDENCIA DE DIAZEPAM"
  },
  {
    "codigo":165938006,
    "descripcion":"INMUNOGLOBULINAS DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":297010006,
    "descripcion":"SOBREDOSIS INTENCIONAL DE BENDROFLUAZIDA"
  },
  {
    "codigo":721159001,
    "descripcion":"CARIES DENTAL DEBIDA A DEFICIENCIA DE FLÚOR"
  },
  {
    "codigo":426247003,
    "descripcion":"INFECCIÓN GENITOURINARIA AGUDA POR CHLAMYDIA TRACHOMATIS"
  },
  {
    "codigo":295175007,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE HEROÍNA"
  },
  {
    "codigo":229639009,
    "descripcion":"AFONÍA HIPOFUNCIONAL"
  },
  {
    "codigo":63964003,
    "descripcion":"INTOXICACIÓN POR RODODENDRO INDICUM"
  },
  {
    "codigo":340911000119100,
    "descripcion":"ENOFTALMOS DE OJO IZQUIERDO DEBIDO A ATROFIA DE TEJIDO ORBITARIO"
  },
  {
    "codigo":1145308008,
    "descripcion":"POSICIÓN DE CEJA ANORMAL"
  },
  {
    "codigo":62129004,
    "descripcion":"ESPASMO DEL ANILLO DE BANDL"
  },
  {
    "codigo":94897004,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA COMISURA DE LA LARINGE"
  },
  {
    "codigo":224134001,
    "descripcion":"VIVE CON NIÑOS"
  },
  {
    "codigo":289670006,
    "descripcion":"DOLOR AL MOVIMIENTO DEL ÚTERO"
  },
  {
    "codigo":93062009,
    "descripcion":"DILATACIÓN CONGÉNITA DE LA VENA CAVA SUPERIOR"
  },
  {
    "codigo":386139002,
    "descripcion":"ARTERIA CORONARIA ESTENÓTICA"
  },
  {
    "codigo":255067005,
    "descripcion":"SARCOMA DE HUESO Y TEJIDO CONECTIVO"
  },
  {
    "codigo":123995008,
    "descripcion":"CARBOHIDRATO POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":449840001,
    "descripcion":"PRÓTESIS COCLEAR IN SITU"
  },
  {
    "codigo":89392001,
    "descripcion":"SÍNDROME DE PRADER-WILLI"
  },
  {
    "codigo":58459009,
    "descripcion":"LIPIDOSIS POR ALMACENAMIENTO DE ESFINGOMIELINA\/COLESTEROL"
  },
  {
    "codigo":253232000,
    "descripcion":"ANIRIDIA TIPO 2"
  },
  {
    "codigo":286000005,
    "descripcion":"NO ABRE LA TUBERÍA DE GAS MAESTRA"
  },
  {
    "codigo":56624009,
    "descripcion":"BORRAMIENTO CERVICAL, 20%"
  },
  {
    "codigo":251397002,
    "descripcion":"TOLERANCIA A LA SACAROSA"
  },
  {
    "codigo":284165002,
    "descripcion":"NO MUEVE LA CABEZA"
  },
  {
    "codigo":87557004,
    "descripcion":"INCONTINENCIA URINARIA DE URGENCIA"
  },
  {
    "codigo":448005008,
    "descripcion":"ATRESIA DE VENA SISTÉMICA"
  },
  {
    "codigo":52954000,
    "descripcion":"TRASTORNO ESQUIZOIDE DE LA PERSONALIDAD"
  },
  {
    "codigo":85722001,
    "descripcion":"CONTRACCIÓN PIELOURETERAL"
  },
  {
    "codigo":54789009,
    "descripcion":"INTOXICACIÓN POR BRACHIARIA"
  },
  {
    "codigo":249562008,
    "descripcion":"HALLAZGO INTESTINAL"
  },
  {
    "codigo":870319003,
    "descripcion":"ATROFIA ÓPTICA DEBIDA A SÍFILIS TARDÍA"
  },
  {
    "codigo":1263535005,
    "descripcion":"ENFERMEDAD DE NEURONA MOTORA DEBIDA A INFECCIÓN POR VIRUS DE INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":409732000,
    "descripcion":"CLASIFICACIÓN INTERNACIONAL DE NEUROBLASTOMA: GRUPO CON HISTOLOGÍA FAVORABLE, PACIENTE DE CUALQUIER EDAD, CON GANGLIONEUROMA, MIXTO"
  },
  {
    "codigo":442500001,
    "descripcion":"MEMBRANA TIMPÁNICA COMPLETAMENTE VISIBLE"
  },
  {
    "codigo":213124002,
    "descripcion":"INFECCIÓN DE HUESO ASOCIADA CON DISPOSITIVO DE FIJACIÓN ESPINAL"
  },
  {
    "codigo":11783241000119105,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA ANTERIOR DE CADERA DERECHA"
  },
  {
    "codigo":247727008,
    "descripcion":"EL PROPIO REFLEJO EN EL ESPEJO PARECE IRREAL"
  },
  {
    "codigo":49284006,
    "descripcion":"ANEMIA MEGALOBLÁSTICA TIPO JUVENIL"
  },
  {
    "codigo":278660006,
    "descripcion":"DIENTE PARCIALMENTE ERUPCIONADO"
  },
  {
    "codigo":16516008,
    "descripcion":"ÚLCERA DUODENAL FAMILIAR ASOCIADA CON VACIAMIENTO GÁSTRICO TEMPRANO"
  },
  {
    "codigo":702809001,
    "descripcion":"REACCIÓN MEDICAMENTOSA CON EOSINOFILIA Y SÍNTOMAS SISTÉMICOS"
  },
  {
    "codigo":735577004,
    "descripcion":"PERFORACIÓN DE AORTA TORACOABDOMINAL CONCOMITANTE CON ANEURISMA DE AORTA TORACOABDOMINAL Y DEBIDA A ÉL"
  },
  {
    "codigo":209454001,
    "descripcion":"ESGUINCE DE LIGAMENTO INTRÍNSECO CORTO NO ESPECÍFICO"
  },
  {
    "codigo":1290798002,
    "descripcion":"CONTUSIÓN PROFUNDA DE MÚSCULO"
  },
  {
    "codigo":733742003,
    "descripcion":"MEJORÍA EN EL EQUILIBRIO"
  },
  {
    "codigo":370141003,
    "descripcion":"OBSTRUCCIÓN REUMÁTICA DE VÁLVULAS MITRAL Y AÓRTICA"
  },
  {
    "codigo":76547000,
    "descripcion":"INTOXICACIÓN POR FENTIÓN"
  },
  {
    "codigo":43779005,
    "descripcion":"DISFONÍA VENTRICULAR"
  },
  {
    "codigo":240387006,
    "descripcion":"MUERMO PULMONAR"
  },
  {
    "codigo":11011007,
    "descripcion":"ECCEMA INFANTIL AGUDO"
  },
  {
    "codigo":402392000,
    "descripcion":"URTICARIA Y\/O ANGIOEDEMA ALÉRGICOS"
  },
  {
    "codigo":41944006,
    "descripcion":"AMPUTADO"
  },
  {
    "codigo":238552006,
    "descripcion":"ECCEMA DISCOIDE DE MANOS Y PIES"
  },
  {
    "codigo":269485000,
    "descripcion":"NEOPLASIA BENIGNA DE MAMA"
  },
  {
    "codigo":369624008,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA DE VENA RENAL, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":1156056008,
    "descripcion":"FENOBARBITAL SÉRICO POR ENCIMA DEL RANGO TERAPÉUTICO"
  },
  {
    "codigo":105645003,
    "descripcion":"ENFERMEDAD CAUSADA POR ACANTHAMOEBIDAE"
  },
  {
    "codigo":302253005,
    "descripcion":"NACIDO POR CESÁREA - EMBARAZO A TÉRMINO"
  },
  {
    "codigo":7341005,
    "descripcion":"FRACTURAS MÚLTIPLES NO EXPUESTAS DE EXTREMO PROXIMAL DE CÚBITO"
  },
  {
    "codigo":236717007,
    "descripcion":"HEMATURIA DEL TRACTO URINARIO SUPERIOR"
  },
  {
    "codigo":38274001,
    "descripcion":"COMPLEJOS VENTRICULARES PREMATUROS INTERPOLADOS"
  },
  {
    "codigo":203949009,
    "descripcion":"ESPINA BÍFIDA DORSAL CON HIDROCEFALIA - CERRADA"
  },
  {
    "codigo":300418006,
    "descripcion":"DEFENSA ABDOMINAL EN LA FOSA ILÍACA IZQUIERDA"
  },
  {
    "codigo":202114006,
    "descripcion":"DESLIZAMIENTO FEMORORROTULIANO"
  },
  {
    "codigo":726402006,
    "descripcion":"DISOMÍA UNIPARENTAL DE ORIGEN PATERNO"
  },
  {
    "codigo":429655000,
    "descripcion":"FRACTURA NO EXPUESTA DE RADIO CON EXPANSIÓN LOCALIZADA DE LA CORTEZA"
  },
  {
    "codigo":724567003,
    "descripcion":"TRASTORNO NEUROLÓGICO CAUSADO POR INGESTIÓN EXCESIVA DE MACRONUTRIENTES"
  },
  {
    "codigo":298583007,
    "descripcion":"TEMPERATURA DE LA COLUMNA VERTEBRAL TORÁCICA - HALLAZGO"
  },
  {
    "codigo":396887007,
    "descripcion":"TUMOR QUE INVADE MÁS ALLÁ DE LA CÁPSULA PANCREÁTICA HACIA EL BAZO (PÁNCREAS ENDOCRINO)"
  },
  {
    "codigo":296748001,
    "descripcion":"SOBREDOSIS DE CEFPIROMA"
  },
  {
    "codigo":460588005,
    "descripcion":"ORIGEN ANÓMALO DE ARTERIA CORONARIA CIRCUNFLEJA IZQUIERDA EN SENO AÓRTICO DE ARTERIA CORONARIA DERECHA"
  },
  {
    "codigo":427820006,
    "descripcion":"HALLAZGO RELACIONADO CON LA SUCCIÓN"
  },
  {
    "codigo":67372006,
    "descripcion":"CONJUNTIVITIS DEBIDA A TOXOPLASMOSIS DISEMINADA ADQUIRIDA"
  },
  {
    "codigo":1343489000,
    "descripcion":"FRACTURA DE HUESO DE TÓRAX"
  },
  {
    "codigo":343421000119107,
    "descripcion":"RETINOPATÍA SOLAR BILATERAL"
  },
  {
    "codigo":294913003,
    "descripcion":"ALERGIA A COMPUESTO DE YODO"
  },
  {
    "codigo":196609006,
    "descripcion":"ÚLCERA ESOFÁGICA DE BARRET"
  },
  {
    "codigo":131073007,
    "descripcion":"NIVEL DE PREGNANEDIOL POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1145046005,
    "descripcion":"SOBREDOSIS INTENCIONAL DE TIOPENTAL"
  },
  {
    "codigo":63702009,
    "descripcion":"SÍNDROME DE ALSTROM"
  },
  {
    "codigo":127403002,
    "descripcion":"HALLAZGO EN EL PROCESO DE DESTRUCCIÓN ERITROCÍTICA"
  },
  {
    "codigo":225707003,
    "descripcion":"EDEMA SACRO"
  },
  {
    "codigo":293078009,
    "descripcion":"REACCIÓN ADVERSA A LA ISONIAZIDA"
  },
  {
    "codigo":1208747005,
    "descripcion":"TRASTORNO NEUROLÓGICO CON CATARATAS Y COMPROMISO CARDÍACO LETAL INFANTIL ASOCIADO A GEN DE INOSINA TRIFOSFATO PIROFOSFOHIDROLASA"
  },
  {
    "codigo":94635006,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE TIBIA"
  },
  {
    "codigo":92800006,
    "descripcion":"CARCINOMA IN SITU DE LA PLEURA VISCERAL"
  },
  {
    "codigo":290481000119100,
    "descripcion":"HEMIPLEJÍA ESPÁSTICA DE LADO DERECHO DOMINANTE"
  },
  {
    "codigo":387712008,
    "descripcion":"ICTERICIA NEONATAL"
  },
  {
    "codigo":60032008,
    "descripcion":"INCAPAZ DE CONCENTRARSE"
  },
  {
    "codigo":289408008,
    "descripcion":"SUTURA SAGITAL EN DIÁMETRO OBLICUO DERECHO"
  },
  {
    "codigo":1303381000,
    "descripcion":"FRACTURA DE CLAVÍCULA DERECHA"
  },
  {
    "codigo":728667671000119108,
    "descripcion":"DISTROFIA DE SUPERFICIE ANTERIOR DE CÓRNEA DE AMBOS OJOS"
  },
  {
    "codigo":254805008,
    "descripcion":"NEVO CUTÁNEO COMPUESTO"
  },
  {
    "codigo":1268778001,
    "descripcion":"CAPAZ DE PAGAR SERVICIO DE TELEFONÍA"
  },
  {
    "codigo":89130002,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE LA QUINTA VÉRTEBRA CERVICAL"
  },
  {
    "codigo":285738005,
    "descripcion":"LESIÓN DE ARTERIA PEDIA"
  },
  {
    "codigo":449578008,
    "descripcion":"NEOPLASIA MALIGNA DE ALVÉOLO DE MAXILAR INFERIOR"
  },
  {
    "codigo":251135002,
    "descripcion":"ECG EN EL LÍMITE DE LA NORMALIDAD"
  },
  {
    "codigo":21759003,
    "descripcion":"ÚLCERA GASTROYEYUNAL CON PERFORACIÓN Y CON OBSTRUCCIÓN"
  },
  {
    "codigo":249300001,
    "descripcion":"HALLAZGO URETRAL"
  },
  {
    "codigo":282068002,
    "descripcion":"PERFORACIÓN DE ÍLEON"
  },
  {
    "codigo":773588003,
    "descripcion":"OSIFICACIÓN INCOMPLETA DE VÉRTEBRA"
  },
  {
    "codigo":183764003,
    "descripcion":"CONSULTA DOMICILIARIA UROLÓGICA, REALIZADA"
  },
  {
    "codigo":118228005,
    "descripcion":"HALLAZGO FUNCIONAL"
  },
  {
    "codigo":247465000,
    "descripcion":"AMPOLLAS SUBCUTÁNEAS"
  },
  {
    "codigo":216532009,
    "descripcion":"INTOXICACIÓN ACCIDENTAL CAUSADA POR DIAZEPAM"
  },
  {
    "codigo":18089006,
    "descripcion":"ABSCESO RETROCECAL"
  },
  {
    "codigo":313001006,
    "descripcion":"VASCULOPATÍA COROIDEA POLIPOIDE IDIOPÁTICA"
  },
  {
    "codigo":444073006,
    "descripcion":"DIABETES MELLITUS TIPO 1 NO CONTROLADA"
  },
  {
    "codigo":1163134001,
    "descripcion":"PARACOCCIDIOIDOMICOSIS JUVENIL AGUDA"
  },
  {
    "codigo":868222004,
    "descripcion":"OCLUSIÓN DE RAMA DESCENDENTE POSTERIOR DE ARTERIA CORONARIA DERECHA"
  },
  {
    "codigo":407635001,
    "descripcion":"ESCALA DE DETERIORO GENERAL NIVEL 7 - DETERIORO COGNITIVO MUY SEVERO"
  },
  {
    "codigo":768083003,
    "descripcion":"GANGRENA CONCOMITANTE CON HERNIA CRURAL IZQUIERDA Y DEBIDA A ELLA"
  },
  {
    "codigo":79955004,
    "descripcion":"COR PULMONALE CRÓNICO"
  },
  {
    "codigo":276563006,
    "descripcion":"HIPERINSULINEMIA NEONATAL IDIOPÁTICA TRANSITORIA"
  },
  {
    "codigo":440403006,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA LEER LOS LABIOS"
  },
  {
    "codigo":1259603009,
    "descripcion":"EXTRAVASACIÓN DE LÍQUIDO CEFALORRAQUÍDEO CRANEAL DEBIDA A OSTEOMIELITIS"
  },
  {
    "codigo":12584003,
    "descripcion":"DOLOR ÓSEO"
  },
  {
    "codigo":733480003,
    "descripcion":"ESPÉCIMEN DESCOMPUESTO"
  },
  {
    "codigo":373032005,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM GILVUM"
  },
  {
    "codigo":45352006,
    "descripcion":"ESPASMO"
  },
  {
    "codigo":307496006,
    "descripcion":"DIVERTICULITIS"
  },
  {
    "codigo":43517000,
    "descripcion":"ESQUIADOR ACUÁTICO EN ACCIDENTE DE EMBARCACIÓN"
  },
  {
    "codigo":241960008,
    "descripcion":"URTICARIA ANGIOEDEMATOSA PRODUCIDA POR ASPIRINA"
  },
  {
    "codigo":766248004,
    "descripcion":"TUMOR NEUROECTODÉRMICO PRIMITIVO DE CUELLO UTERINO"
  },
  {
    "codigo":305661004,
    "descripcion":"ATENDIDO POR UN ALERGISTA CLÍNICO"
  },
  {
    "codigo":371197005,
    "descripcion":"AUSENCIA CONGÉNITA DE PIE"
  },
  {
    "codigo":240125008,
    "descripcion":"SÍNDROME DE APLASTAMIENTO MUSCULAR"
  },
  {
    "codigo":403965008,
    "descripcion":"HEMANGIOMA SINUSOIDAL"
  },
  {
    "codigo":74450001,
    "descripcion":"HIPERCLOREMIA"
  },
  {
    "codigo":860882006,
    "descripcion":"HERIDA ABIERTA DE ESPESOR COMPLETO DE PÁRPADO"
  },
  {
    "codigo":367527001,
    "descripcion":"FRACTURA EXPUESTA DEL PIE"
  },
  {
    "codigo":236455003,
    "descripcion":"NEFROPATÍA POR PLOMO"
  },
  {
    "codigo":301991004,
    "descripcion":"CIERRE OCULAR - HALLAZGO"
  },
  {
    "codigo":1217660000,
    "descripcion":"DEFICIENCIA DIRECCIONAL DE MOVIMIENTOS DE PERSECUCIÓN SUAVE"
  },
  {
    "codigo":1119356001,
    "descripcion":"ATAXIA PROGRESIVA DE TRONCO"
  },
  {
    "codigo":7079009,
    "descripcion":"ABSCESO DE MAMA NO PUERPERAL"
  },
  {
    "codigo":234620006,
    "descripcion":"DEFICIENCIA HEREDITARIA DEL INHIBIDOR ESTERASA C1 - FACTOR DISFUNCIONANTE"
  },
  {
    "codigo":365692006,
    "descripcion":"HALLAZGO RELACIONADO CON LA PRESENCIA DE ELEMENTOS MICÓTICOS"
  },
  {
    "codigo":201852006,
    "descripcion":"ARTROSIS SECUNDARIA LOCALIZADA, DE LA MANO"
  },
  {
    "codigo":267388009,
    "descripcion":"HIPOPITUITARISMO IDIOPÁTICO"
  },
  {
    "codigo":462161001,
    "descripcion":"RETENCIÓN FETAL DE LÍQUIDO LIMITADA A DOS COMPARTIMIENTOS FETALES"
  },
  {
    "codigo":167249005,
    "descripcion":"ORINA CON OLOR A PESCADO"
  },
  {
    "codigo":165414004,
    "descripcion":"HEMATÓCRITO POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":296486006,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE COLCHICINA"
  },
  {
    "codigo":198182008,
    "descripcion":"ENDOMETRITIS SUBAGUDA"
  },
  {
    "codigo":1179387001,
    "descripcion":"INFECCIÓN VIRAL DE NERVIO CRANEAL"
  },
  {
    "codigo":720635002,
    "descripcion":"DISPLASIA CEREBRO-FACIO-TORÁCICA"
  },
  {
    "codigo":294651001,
    "descripcion":"ALERGIA A COMPONENTE DE VACUNA QUE CONTIENE ANTÍGENO DE BORDETELLA PERTUSSIS"
  },
  {
    "codigo":65275009,
    "descripcion":"COLECISTITIS AGUDA"
  },
  {
    "codigo":128976003,
    "descripcion":"ESTADO DEL PACIENTE DURANTE EL EJERCICIO"
  },
  {
    "codigo":11843711000119106,
    "descripcion":"ABRASIÓN DE PIEL DE PABELLÓN AURICULAR DERECHO"
  },
  {
    "codigo":292816006,
    "descripcion":"REACCIÓN ADVERSA AL FENTICONAZOL"
  },
  {
    "codigo":63440008,
    "descripcion":"VERRUGA PLANTAR"
  },
  {
    "codigo":391120009,
    "descripcion":"GRADO 1 DE LA ESCALA DE DISNEA DEL MEDICAL RESEARCH COUNCIL"
  },
  {
    "codigo":290981000,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR CLONAZEPAM"
  },
  {
    "codigo":94373003,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA PARED LATERAL DE LA OROFARINGE"
  },
  {
    "codigo":225445003,
    "descripcion":"PENSAMIENTOS INTRUSIVOS"
  },
  {
    "codigo":782501005,
    "descripcion":"TRASTORNO DE AJUSTE CON ESTADO DE ÁNIMO MIXTO CON ANSIEDAD Y DEPRESIÓN"
  },
  {
    "codigo":61605005,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA ARTERIA MAMARIA INTERNA"
  },
  {
    "codigo":127141001,
    "descripcion":"LINFADENOPATÍA HILIAR RENAL"
  },
  {
    "codigo":190842000,
    "descripcion":"TOFO GOTOSO DE MANO"
  },
  {
    "codigo":92538000,
    "descripcion":"CARCINOMA IN SITU DE VÉRTICE VESICAL"
  },
  {
    "codigo":1208485009,
    "descripcion":"SÍNDROME DE DISFUNCIÓN MITOCONDRIAL MÚLTIPLE TIPO 1"
  },
  {
    "codigo":27002002,
    "descripcion":"MORDIDA EN CRUZ ANTERIOR"
  },
  {
    "codigo":1306789009,
    "descripcion":"GLAUCOMA BILATERAL DEBIDO A MALFORMACIÓN CONGÉNITA DE ÁNGULO DE CÁMARA ANTERIOR"
  },
  {
    "codigo":715130005,
    "descripcion":"INCAPAZ DE PASAR DE UN AUTOMÓVIL A UNA SILLA DE RUEDAS"
  },
  {
    "codigo":59770006,
    "descripcion":"DISLEXIA"
  },
  {
    "codigo":289146008,
    "descripcion":"FRECUENCIA DE ALIMENTACIÓN DEL LACTANTE - HALLAZGO"
  },
  {
    "codigo":254543002,
    "descripcion":"CARCINOMA DE LA PORCIÓN ABDOMINAL DEL ESÓFAGO"
  },
  {
    "codigo":1335887005,
    "descripcion":"SINOSTOSIS RADIOCUBITAL DE ANTEBRAZO IZQUIERDO"
  },
  {
    "codigo":25167006,
    "descripcion":"PERIESPLENITIS"
  },
  {
    "codigo":1137444001,
    "descripcion":"CALCIFICACIÓN PUNTEADA DE EPÍFISIS DE CALCÁNEO"
  },
  {
    "codigo":23332002,
    "descripcion":"PRUEBA DE PARTO FALLIDA"
  },
  {
    "codigo":285476003,
    "descripcion":"MUEVE LOS LABIOS"
  },
  {
    "codigo":711460001,
    "descripcion":"ALTURA FACIAL INFERIOR AUMENTADA"
  },
  {
    "codigo":449316002,
    "descripcion":"ANOMALÍA CONGÉNITA DE VÁLVULA AURICULOVENTRICULAR DERECHA EN VENTRÍCULO CON DOBLE TRACTO DE ENTRADA"
  },
  {
    "codigo":54265003,
    "descripcion":"ANOMALÍA CONGÉNITA DE LA ARTERIA CEREBRAL"
  },
  {
    "codigo":185337004,
    "descripcion":"ENCUENTRO FALLIDO - SIN RESPUESTA AL LLAMADO"
  },
  {
    "codigo":283641007,
    "descripcion":"HERIDA POR PINCHAZO DE AGUJA EN EL DEDO GORDO"
  },
  {
    "codigo":445646001,
    "descripcion":"AZOEMIA PRERRENAL"
  },
  {
    "codigo":609486003,
    "descripcion":"INTERRUPCIÓN INDUCIDA DEL EMBARAZO COMPLICADA POR EMBOLIA SÉPTICA"
  },
  {
    "codigo":773326003,
    "descripcion":"SÍNDROME DE MICRODELECIÓN 7Q31"
  },
  {
    "codigo":871630004,
    "descripcion":"DEFECTO DE TABIQUE AURICULOVENTRICULAR CON DESEQUILIBRIO VENTRICULAR"
  },
  {
    "codigo":1363150006,
    "descripcion":"ASTILLA EN AXILA"
  },
  {
    "codigo":249038009,
    "descripcion":"NO SE PALPAN LOS MOVIMIENTOS FETALES"
  },
  {
    "codigo":321971000119104,
    "descripcion":"OSTEOMIELITIS SUBAGUDA DE HUESO FEMORAL IZQUIERDO"
  },
  {
    "codigo":17827007,
    "descripcion":"SÍNDROME DE CROSS"
  },
  {
    "codigo":771491009,
    "descripcion":"FRACTURAS NO EXPUESTAS QUE COMPROMETEN MÚLTIPLES REGIONES DE LA EXTREMIDAD SUPERIOR IZQUIERDA"
  },
  {
    "codigo":441976002,
    "descripcion":"PARASOMNIA ORGÁNICA"
  },
  {
    "codigo":212600003,
    "descripcion":"INTOXICACIÓN AMINOFENAZONA"
  },
  {
    "codigo":48760005,
    "descripcion":"SÍNDROME DE TRISOMÍA PARCIAL 10P"
  },
  {
    "codigo":866125001,
    "descripcion":"MIELITIS CAUSADA POR RETROVIRIDAE"
  },
  {
    "codigo":1193805002,
    "descripcion":"INFLAMACIÓN INTESTINAL POR GIARDIA LAMBLIA"
  },
  {
    "codigo":79693006,
    "descripcion":"ALTERACIÓN EN LA DIGESTIÓN INTESTINAL DE CÉLULAS EPITELIALES"
  },
  {
    "codigo":276301007,
    "descripcion":"ENERGÍA AUMENTADA"
  },
  {
    "codigo":1259341007,
    "descripcion":"CARCINOMA PRIMARIO DE GLÁNDULA PARÓTIDA"
  },
  {
    "codigo":733218001,
    "descripcion":"CONTUSIÓN DE TRÁQUEA TORÁCICA"
  },
  {
    "codigo":12322003,
    "descripcion":"EVENTRACIÓN CONGÉNITA DEL ORIFICIO DIAFRAGMÁTICO IZQUIERDO"
  },
  {
    "codigo":405538007,
    "descripcion":"HEMORRAGIA ESPONTÁNEA"
  },
  {
    "codigo":307234008,
    "descripcion":"NECROSIS DE UNA ILEOSTOMÍA"
  },
  {
    "codigo":700450008,
    "descripcion":"COLPOSCOPIA ANORMAL"
  },
  {
    "codigo":1290274008,
    "descripcion":"TUMOR NEUROENDOCRINO BIEN DIFERENCIADO DE COLON"
  },
  {
    "codigo":76023003,
    "descripcion":"HIPOSTENURIA"
  },
  {
    "codigo":208930008,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE LA ARTICULACIÓN FEMORORROTULIANA, EXTERNA"
  },
  {
    "codigo":1222903005,
    "descripcion":"PATEA CON PIERNA"
  },
  {
    "codigo":239863005,
    "descripcion":"OSTEOARTRITIS DE ARTICULACIÓN CIGOAPOFISARIA VERTEBRAL"
  },
  {
    "codigo":698615007,
    "descripcion":"SORDOMUTISMO CONGÉNITO"
  },
  {
    "codigo":370935006,
    "descripcion":"DIÁLISIS ZONULAR"
  },
  {
    "codigo":762316003,
    "descripcion":"TRASTORNO LINFOPROLIFERATIVO POLIMÓRFICO POSTERIOR A TRASPLANTE"
  },
  {
    "codigo":205260006,
    "descripcion":"ACROCEFALOPOLISINDACTILIA"
  },
  {
    "codigo":238028008,
    "descripcion":"ESFINGOLIPOIDOSIS"
  },
  {
    "codigo":8652009,
    "descripcion":"OPISTÓTONOS"
  },
  {
    "codigo":301729002,
    "descripcion":"DIFICULTAD PARA REALIZAR ACTIVIDADES LABORALES"
  },
  {
    "codigo":350951000119101,
    "descripcion":"LINFOMA DE LINFOCITOS B DE GANGLIOS LINFÁTICOS INTRAABDOMINALES"
  },
  {
    "codigo":170657004,
    "descripcion":"EJERCICIO RESTRINGIDO POR EL ASMA EN FORMA SEVERA"
  },
  {
    "codigo":103286000,
    "descripcion":"VÉRTIGO HORIZONTAL"
  },
  {
    "codigo":234358000,
    "descripcion":"ANEMIA MEGALOBLÁSTICA DE CAUSA DIETARIA"
  },
  {
    "codigo":267126001,
    "descripcion":"NIVEL 4 DE ACTIVIDAD SEGÚN EL PRINCIPIO FITT"
  },
  {
    "codigo":365430005,
    "descripcion":"HALLAZGO RELACIONADO CON ASPECTO DE LA ORINA"
  },
  {
    "codigo":299894007,
    "descripcion":"RESPUESTA PLANTAR IZQUIERDA DE RESULTADO DUDOSO"
  },
  {
    "codigo":199755001,
    "descripcion":"TRABAJO DE PARTO OBSTRUIDO POR PRESENTACIÓN COMPUESTA"
  },
  {
    "codigo":66848000,
    "descripcion":"HÁLITO URÉMICO"
  },
  {
    "codigo":134219008,
    "descripcion":"HUESO TRIANGULAR DEL TARSO"
  },
  {
    "codigo":427296003,
    "descripcion":"INFARTO TALÁMICO"
  },
  {
    "codigo":292554000,
    "descripcion":"REACCIÓN ADVERSA A LA METILCISTEÍNA"
  },
  {
    "codigo":30410001,
    "descripcion":"PTOSIS PARALÍTICA"
  },
  {
    "codigo":1144522003,
    "descripcion":"TOLERA LA DIETA"
  },
  {
    "codigo":290719001,
    "descripcion":"INTOXICACIÓN POR HIDROXIUREA"
  },
  {
    "codigo":94111002,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL TRONCO"
  },
  {
    "codigo":126879004,
    "descripcion":"NEOPLASIA DEL APARATO URINARIO"
  },
  {
    "codigo":1306527006,
    "descripcion":"CARCINOMA IN SITU DE CUADRANTE INFERIOR EXTERNO DE MAMA"
  },
  {
    "codigo":28575006,
    "descripcion":"HIPERFENILALANINEMIA TRANSITORIA"
  },
  {
    "codigo":714868001,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA MANTENER LA POSICIÓN DE RODILLAS"
  },
  {
    "codigo":92276007,
    "descripcion":"NEOPLASIA BENIGNA DEL LÓBULO PARIETAL"
  },
  {
    "codigo":288884008,
    "descripcion":"CAPAZ DE COMER"
  },
  {
    "codigo":90441002,
    "descripcion":"TIROIDITIS CRÓNICA NO SUPURATIVA"
  },
  {
    "codigo":324481000119107,
    "descripcion":"ARTRITIS INFECCIOSA DE CADERA"
  },
  {
    "codigo":385353004,
    "descripcion":"ESTADIO DE INFECCIÓN POR VIH DEL CDC - HALLAZGO"
  },
  {
    "codigo":254281006,
    "descripcion":"FENOTIPO DE TURNER, CARIOTIPO DE CROMOSOMA EN ANILLO"
  },
  {
    "codigo":713033007,
    "descripcion":"DISECCIÓN DE ARTERIA DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":55838005,
    "descripcion":"SECUENCIA DE HIPOTIROIDISMO"
  },
  {
    "codigo":449054005,
    "descripcion":"NEOPLASIA EPITELIAL MALIGNA DE FONDO DE ÚTERO"
  },
  {
    "codigo":285214007,
    "descripcion":"UTILIZACIÓN DE ETIQUETAS COMO AYUDA MEMORIA"
  },
  {
    "codigo":840435003,
    "descripcion":"DERMATOFITOSIS DISEMINADA DEBIDA A INMUNODEFICIENCIA"
  },
  {
    "codigo":283379007,
    "descripcion":"LACERACIÓN DE LA REGIÓN PÉLVICA"
  },
  {
    "codigo":281544003,
    "descripcion":"DISTENSIÓN DE TENDÓN DE PIE Y TOBILLO"
  },
  {
    "codigo":248776004,
    "descripcion":"SIEMPRE TIENE UNA ERECCIÓN"
  },
  {
    "codigo":707528007,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS PRIMARIO DE NASOFARINGE"
  },
  {
    "codigo":246941002,
    "descripcion":"MARGEN CORNEAL - HALLAZGO"
  },
  {
    "codigo":1295517006,
    "descripcion":"COLESTASIS INTRAHEPÁTICA FAMILIAR PROGRESIVA TIPO 4"
  },
  {
    "codigo":17565009,
    "descripcion":"HIPOESTESIA DE LA LENGUA"
  },
  {
    "codigo":1259079006,
    "descripcion":"TRASTORNO AUTONÓMICO DEBIDO A INTOXICACIÓN POR ESTIMULANTE"
  },
  {
    "codigo":306972000,
    "descripcion":"INCAPAZ DE ESCUCHAR LA VOZ FUERTE"
  },
  {
    "codigo":732956000,
    "descripcion":"SÍNDROME DE BRAQUIDACTILIA Y SINFALANGISMO DISTAL"
  },
  {
    "codigo":405276000,
    "descripcion":"EDEMA PULMONAR POR PRESIÓN NEGATIVA"
  },
  {
    "codigo":15918261000119105,
    "descripcion":"FRACTURA NO EXPUESTA DE CRESTA ALVEOLAR DE LADO DERECHO DE MAXILAR SUPERIOR"
  },
  {
    "codigo":274204004,
    "descripcion":"QUEMADURA DE CÓRNEA"
  },
  {
    "codigo":681141000119105,
    "descripcion":"PAPILOMA DE CONJUNTIVA DE OJO DERECHO"
  },
  {
    "codigo":208668007,
    "descripcion":"FRACTURA EXPUESTA DE TOBILLO, TRIMALEOLAR, FRACTURA PERONEA INFERIOR"
  },
  {
    "codigo":110364008,
    "descripcion":"DOLOR POSTPROCEDIMIENTO"
  },
  {
    "codigo":763889002,
    "descripcion":"SÍNDROME DE ESPINA BÍFIDA E HIPOSPADIAS"
  },
  {
    "codigo":403441003,
    "descripcion":"ULCERACIÓN LABIAL POR ERITEMA MULTIFORME"
  },
  {
    "codigo":698353005,
    "descripcion":"REQUIERE VACUNACIÓN CONTRA VIRUS INFLUENZA"
  },
  {
    "codigo":1255409006,
    "descripcion":"REACCIÓN ADVERSA A BEBIDA ALCOHÓLICA"
  },
  {
    "codigo":237766002,
    "descripcion":"HEMORRAGIA CORTICOSUPRARRENAL"
  },
  {
    "codigo":204998005,
    "descripcion":"ATRESIA Y ESTENOSIS DE LA URETRA Y DEL CUELLO VESICAL"
  },
  {
    "codigo":301467000,
    "descripcion":"HIPEREXTENSIÓN DE LA COLUMNA LUMBAR"
  },
  {
    "codigo":39323002,
    "descripcion":"HIPERPLASIA DE ADENOIDES"
  },
  {
    "codigo":203163004,
    "descripcion":"OSTEOMIELITIS AGUDA DE OMÓPLATO"
  },
  {
    "codigo":235931005,
    "descripcion":"PÉRDIDA DE BILIS"
  },
  {
    "codigo":397936000,
    "descripcion":"MORBILIDAD ANESTÉSICA"
  },
  {
    "codigo":70256003,
    "descripcion":"HALLAZGO RELACIONADO CON ACTO SEXUAL"
  },
  {
    "codigo":1217136003,
    "descripcion":"CRISIS EPILÉPTICA TÓNICO-CLÓNICA"
  },
  {
    "codigo":299632005,
    "descripcion":"ARTICULACIÓN DE DEDO DEL PIE DOLOROSA A LA PALPACIÓN"
  },
  {
    "codigo":135792006,
    "descripcion":"SANGRE EN LA ROPA INTERIOR"
  },
  {
    "codigo":234096005,
    "descripcion":"LINFANGITIS ASCENDENTE"
  },
  {
    "codigo":201328008,
    "descripcion":"PIEL PERIANAL MACERADA"
  },
  {
    "codigo":37488003,
    "descripcion":"DOLOR VULVOVAGINAL"
  },
  {
    "codigo":365168004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA TAPAR RECIPIENTES"
  },
  {
    "codigo":15701481000119100,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE TENDÓN DE AMBOS BRAZOS"
  },
  {
    "codigo":68421004,
    "descripcion":"DETENCIÓN EPIFISARIA"
  },
  {
    "codigo":428869006,
    "descripcion":"RINITIS MIXTA"
  },
  {
    "codigo":230426003,
    "descripcion":"EPILEPSIA MIOCLÓNICA CON FIBRAS ROJAS RASGADAS"
  },
  {
    "codigo":295962006,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE BECLAMIDA"
  },
  {
    "codigo":164890007,
    "descripcion":"ALETEO AURICULAR EN EL ELECTROCARDIOGRAMA"
  },
  {
    "codigo":294127007,
    "descripcion":"ALERGIA A AZATADINA"
  },
  {
    "codigo":292292000,
    "descripcion":"REACCIÓN ADVERSA A LA PROTRIPTILINA"
  },
  {
    "codigo":30148002,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE INGLE SIN INFECCIÓN"
  },
  {
    "codigo":95684005,
    "descripcion":"TUBÉRCULOS COROIDEOS"
  },
  {
    "codigo":1177028005,
    "descripcion":"PANUVEÍTIS BACTERIANA"
  },
  {
    "codigo":423364005,
    "descripcion":"VISIÓN A DISTANCIA 20\/25"
  },
  {
    "codigo":290457000,
    "descripcion":"INTOXICACIÓN POR SEN"
  },
  {
    "codigo":421529006,
    "descripcion":"DEMENCIA CON SÍNDROME DE INMUNODEFICIENCIA ADQUIRIDA"
  },
  {
    "codigo":93849006,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE RIÑÓN"
  },
  {
    "codigo":1339033009,
    "descripcion":"TRASTORNO DE NERVIO ÓPTICO CAUSADO POR RADIACIÓN"
  },
  {
    "codigo":716441009,
    "descripcion":"CAPAZ DE REFLEXIONAR SOBRE EL PROPIO COMPORTAMIENTO"
  },
  {
    "codigo":126617009,
    "descripcion":"NEOPLASIA DE MÚSCULO DE LA CABEZA"
  },
  {
    "codigo":288622007,
    "descripcion":"CAPAZ DE EMPLEAR LENGUAJE AUTOMÁTICO"
  },
  {
    "codigo":92014007,
    "descripcion":"NEOPLASIA BENIGNA DE VASO SANGUÍNEO DE DEDO DE PIE"
  },
  {
    "codigo":286787003,
    "descripcion":"CARÁCTER EXCESIVAMENTE CONFIADO"
  },
  {
    "codigo":254019007,
    "descripcion":"FISURA FACIAL INFRAORBITARIA- FISURA DE TESSIER TIPO 7"
  },
  {
    "codigo":219416007,
    "descripcion":"HERIDA DE GUERRA POR BAYONETA"
  },
  {
    "codigo":446957000,
    "descripcion":"POLIOMIELITIS BULBAR AGUDA CAUSADA POR POLIOVIRUS HUMANO 1"
  },
  {
    "codigo":284952007,
    "descripcion":"SE LIMPIA SOLO LUEGO DE IR AL BAÑO"
  },
  {
    "codigo":53741008,
    "descripcion":"ARTERIOSCLEROSIS CORONARIA"
  },
  {
    "codigo":19138001,
    "descripcion":"EPIDERMODISPLASIA VERRUCIFORME"
  },
  {
    "codigo":1004013009,
    "descripcion":"TRASTORNO NEONATAL DEBIDO A PROCEDIMIENTO QUIRÚRGICO SOBRE EL FETO Y POSTERIOR A ÉL"
  },
  {
    "codigo":838338001,
    "descripcion":"INFECCIÓN BACTERIANA DEBIDA A INFECCIÓN POR VIRUS DE INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":283117008,
    "descripcion":"AMPOLLA TRAUMÁTICA DE LA REGIÓN OCULAR"
  },
  {
    "codigo":1149448005,
    "descripcion":"PERIODONTITIS GENERALIZADA ESTADIO 4 GRADO C SEGÚN LA CLASIFICACIÓN DE LAS ENFERMEDADES Y ALTERACIONES PERIODONTALES Y PERIIMPLANTARIAS DE 2017 DE LA ACADEMIA ESTADOUNIDENSE DE PERIODONTOLOGÍA Y LA FEDERACIÓN EUROPEA DE PERIODONTOLOGÍA"
  },
  {
    "codigo":281282007,
    "descripcion":"ESPÉCIMEN SIN ICTERICIA VISIBLE"
  },
  {
    "codigo":248514008,
    "descripcion":"TUMORACIÓN EN PÁRPADO"
  },
  {
    "codigo":445122007,
    "descripcion":"PLACENTA DE INSERCIÓN BAJA"
  },
  {
    "codigo":1295255002,
    "descripcion":"SCHWANNOMA EPITELIOIDE"
  },
  {
    "codigo":246679005,
    "descripcion":"SECRECIÓN OCULAR"
  },
  {
    "codigo":312215006,
    "descripcion":"ENCEFALITIS INFECCIOSA"
  },
  {
    "codigo":310380001,
    "descripcion":"CITA SOLICITADA POR UN FAMILIAR"
  },
  {
    "codigo":81004002,
    "descripcion":"LEPRA"
  },
  {
    "codigo":1162348003,
    "descripcion":"OSTEOSARCOMA DE HUESO VERTEBRAL"
  },
  {
    "codigo":277612005,
    "descripcion":"ENFERMEDAD DE HODGKIN, ESCLEROSIS NODULAR - DEPLECIÓN LINFOCÍTICA"
  },
  {
    "codigo":408684006,
    "descripcion":"ENFERMEDAD POR VIRUS SINCITIAL RESPIRATORIO ASOCIADA CON LA ATENCIÓN MÉDICA"
  },
  {
    "codigo":48236007,
    "descripcion":"SÍNDROME DE ASHERMAN"
  },
  {
    "codigo":79169000,
    "descripcion":"ALCALEMIA"
  },
  {
    "codigo":243009001,
    "descripcion":"LESIÓN POR PERDIGÓN DE PISTOLA DE AIRE COMPRIMIDO"
  },
  {
    "codigo":275777001,
    "descripcion":"PORFOBILINÓGENO EN ORINA - HALLAZGO"
  },
  {
    "codigo":111937006,
    "descripcion":"SARCOIDOSIS, TIPO NODULAR"
  },
  {
    "codigo":210241007,
    "descripcion":"LESIÓN TRAUMÁTICA DE TROMPA DE FALOPIO CON HERIDA ABIERTA HACIA CAVIDAD"
  },
  {
    "codigo":77334002,
    "descripcion":"INTOXICACIÓN POR CLORURO DE SODIO"
  },
  {
    "codigo":208406002,
    "descripcion":"FRACTURA NO EXPUESTA DEL CUELLO DEL PRIMER METACARPIANO"
  },
  {
    "codigo":110102004,
    "descripcion":"LACERACIÓN COMPLEJA CONTAMINADA DE MUCOSA YUGAL"
  },
  {
    "codigo":1156843000,
    "descripcion":"UVEÍTIS DEBIDA A OLIGOARTRITIS IDIOPÁTICA JUVENIL NEGATIVA PARA ANTICUERPOS ANTINUCLEARES DE INICIO PERSISTENTE"
  },
  {
    "codigo":204736001,
    "descripcion":"INTESTINO GRUESO IMPERFORADO"
  },
  {
    "codigo":237504004,
    "descripcion":"FUNCIÓN TIROIDEA AUTÓNOMA"
  },
  {
    "codigo":30121000175109,
    "descripcion":"ÚLCERA POR PRESIÓN EN TOBILLO DERECHO, ESTADIO IV"
  },
  {
    "codigo":695751021000132104,
    "descripcion":"LIPOMA DE ESTÓMAGO"
  },
  {
    "codigo":235669002,
    "descripcion":"SÍNDROME DEL ASA EFERENTE"
  },
  {
    "codigo":399509004,
    "descripcion":"CONFIGURACIÓN MIXTA DE TUMOR ENDOFÍTICO Y EXOFÍTICO"
  },
  {
    "codigo":301205008,
    "descripcion":"SIN VISUALIZACIÓN DE LA RINOFARINGE"
  },
  {
    "codigo":299370001,
    "descripcion":"MENISCO INESTABLE"
  },
  {
    "codigo":201066002,
    "descripcion":"ESTRÍAS ATRÓFICAS DE PIEL"
  },
  {
    "codigo":233834004,
    "descripcion":"INFARTO AGUDO NO Q - LATERAL"
  },
  {
    "codigo":364906007,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA MOVERSE DE UNA POSICIÓN A OTRA"
  },
  {
    "codigo":789055001,
    "descripcion":"APNEA DEL SUEÑO CENTRAL EMERGENTE DE TRATAMIENTO"
  },
  {
    "codigo":231999002,
    "descripcion":"RUPTURA CORIORRETINIANA"
  },
  {
    "codigo":199231005,
    "descripcion":"DIABETES MELLITUS PREEXISTENTE RELACIONADA CON DESNUTRICIÓN"
  },
  {
    "codigo":721684002,
    "descripcion":"COLITIS CAUSADA POR PROTOZOARIO"
  },
  {
    "codigo":262932003,
    "descripcion":"APLASTAMIENTO DE TROMPA DE FALOPIO"
  },
  {
    "codigo":788006,
    "descripcion":"DIETA RELACIONADA CON LA ENFERMEDAD"
  },
  {
    "codigo":16906321000119107,
    "descripcion":"QUISTE DERMOIDE DE PÁRPADO INFERIOR IZQUIERDO"
  },
  {
    "codigo":293865005,
    "descripcion":"ALERGIA A FENOBARBITAL"
  },
  {
    "codigo":62654000,
    "descripcion":"FALLA DE ROTACIÓN DEL CIEGO"
  },
  {
    "codigo":292030002,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR UROCINASA"
  },
  {
    "codigo":95422003,
    "descripcion":"HEMORRAGIA DE MÚSCULO"
  },
  {
    "codigo":128190004,
    "descripcion":"METABOLOPATÍA HEREDITARIA DEL SISTEMA NERVIOSO"
  },
  {
    "codigo":783550006,
    "descripcion":"NEUROPATÍA SENSITIVA HEREDITARIA Y AUTONÓMICA TIPO 7"
  },
  {
    "codigo":29886007,
    "descripcion":"ADHERENCIA DEL INTESTINO"
  },
  {
    "codigo":28051002,
    "descripcion":"REPETICIÓN DE PALABRAS"
  },
  {
    "codigo":191891003,
    "descripcion":"PATRÓN DE USO NOCIVO DE CANNABIS SIN DEPENDENCIA"
  },
  {
    "codigo":39141000087101,
    "descripcion":"DOLOR MUSCULOESQUELÉTICO CRÓNICO DEBIDO A TRASTORNO"
  },
  {
    "codigo":41701000087101,
    "descripcion":"QUEMADURA DE SEGUNDO DEDO DE PIE IZQUIERDO"
  },
  {
    "codigo":93587007,
    "descripcion":"OSIFICACIÓN INCOMPLETA DE HUESO INTERPARIETAL"
  },
  {
    "codigo":421267008,
    "descripcion":"MARGEN PROXIMAL QUIRÚRGICO NO COMPROMETIDO POR ADENOMA"
  },
  {
    "codigo":46821000087105,
    "descripcion":"CICATRIZ DE INTESTINO GRUESO POSTERIOR A POLIPECTOMÍA"
  },
  {
    "codigo":44261000087109,
    "descripcion":"CONTUSIÓN DE CÓNDILO INTERNO DE FÉMUR DERECHO"
  },
  {
    "codigo":288360007,
    "descripcion":"DIFICULTAD PARA LANZAR OBJETOS"
  },
  {
    "codigo":124520009,
    "descripcion":"DEFICIENCIA DE ARGININA DEIMINASA"
  },
  {
    "codigo":712509002,
    "descripcion":"HEMORRAGIA DE YEYUNO"
  },
  {
    "codigo":778045003,
    "descripcion":"SUSCEPTIBILIDAD A INFECCIONES VIRALES Y MICOBACTERIANAS."
  },
  {
    "codigo":417597005,
    "descripcion":"HALLAZGO RELACIONADO CON PRUEBA EN ORINA CON TIRA REACTIVA"
  },
  {
    "codigo":253757006,
    "descripcion":"CONDUCTO SALIVAL ACCESORIO"
  },
  {
    "codigo":448530003,
    "descripcion":"OBSTRUCCIÓN PARCIAL DE CONDUCTO CARDÍACO"
  },
  {
    "codigo":284690004,
    "descripcion":"AUTOMUTILACIÓN DE LOS GENITALES"
  },
  {
    "codigo":1234962009,
    "descripcion":"TRASTORNO FETAL DEBIDO A TRAUMATISMO DE CORDÓN UMBILICAL"
  },
  {
    "codigo":250087009,
    "descripcion":"DEFORMIDAD ARTICULAR"
  },
  {
    "codigo":86247009,
    "descripcion":"DILATACIÓN DEL INTESTINO"
  },
  {
    "codigo":282855009,
    "descripcion":"MANTIENE LA POSICIÓN EN BIPEDESTACIÓN"
  },
  {
    "codigo":18876004,
    "descripcion":"DOLOR EN DEDO DE MANO"
  },
  {
    "codigo":1071431000000102,
    "descripcion":"NO EVALÚA RIESGOS"
  },
  {
    "codigo":444860006,
    "descripcion":"MIELOMENINGOCELE DE COLUMNA VERTEBRAL LUMBOSACRA"
  },
  {
    "codigo":248252008,
    "descripcion":"SANGRA PROFUSAMENTE"
  },
  {
    "codigo":770705004,
    "descripcion":"REACCIÓN ADVERSA AL FACTOR V"
  },
  {
    "codigo":703334000,
    "descripcion":"MALFORMACIÓN ARTERIOVENOSA DE MANDÍBULA"
  },
  {
    "codigo":1260390003,
    "descripcion":"DISTONÍA DEBIDA A SÍNDROME DE LESCH NYHAN"
  },
  {
    "codigo":441190003,
    "descripcion":"ENFERMEDAD GRAVE POR DEFICIENCIA HEREDITARIA DE FACTOR IX SIN INHIBIDORES"
  },
  {
    "codigo":688671000119103,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE CARA ANTERIOR DEL PISO DE LA BOCA"
  },
  {
    "codigo":15206007,
    "descripcion":"NEUMOTÓRAX ABIERTO"
  },
  {
    "codigo":406587001,
    "descripcion":"INFECCIÓN DEL SISTEMA NERVIOSO CENTRAL POR HISTOPLASMA"
  },
  {
    "codigo":109840002,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA ZONA CLOACÓGENA"
  },
  {
    "codigo":240912004,
    "descripcion":"GRANULOMA POR LINGUATULINA"
  },
  {
    "codigo":11536005,
    "descripcion":"RINOLALIA ANTERIOR CERRADA"
  },
  {
    "codigo":371984007,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL ESÓFAGO"
  },
  {
    "codigo":1254885000,
    "descripcion":"PITIRIASIS RUBRA PILARIS DE ADULTO"
  },
  {
    "codigo":402917003,
    "descripcion":"FIEBRE DEL VALLE DEL RIFT"
  },
  {
    "codigo":40634001,
    "descripcion":"HIPEREMOTIVIDAD"
  },
  {
    "codigo":1187514002,
    "descripcion":"FORMA MIOPÁTICA DE DEFICIENCIA DE CARNITINA PALMITOILTRANSFERASA II"
  },
  {
    "codigo":401082004,
    "descripcion":"ATAQUE HIPOGLUCÉMICO QUE REQUIRIÓ LA ASISTENCIA DE UN TERCERO"
  },
  {
    "codigo":1351354004,
    "descripcion":"DEFICIENCIA DE CLASE I DEL COMPLEJO MAYOR DE HISTOCOMPATIBILIDAD DEBIDA A MUTACIÓN DE TAP1"
  },
  {
    "codigo":827066007,
    "descripcion":"VISIÓN DE COLORES NORMAL"
  },
  {
    "codigo":106170009,
    "descripcion":"DISLEXIA Y\/O DISFUNCIÓN DEL HABLA"
  },
  {
    "codigo":237242009,
    "descripcion":"EMBARAZO NO VIABLE"
  },
  {
    "codigo":38799004,
    "descripcion":"SENSIBILIDAD AUTOLEUCOCITARIA"
  },
  {
    "codigo":366479007,
    "descripcion":"HALLAZGO RELACIONADO CON LA AMPLITUD DE ABDUCCIÓN ACTIVA DE HOMBRO"
  },
  {
    "codigo":300943008,
    "descripcion":"NERVIOSISMO PREVIO A EVALUACIÓN"
  },
  {
    "codigo":11311801000119105,
    "descripcion":"FRACTURA POR OSTEOPOROSIS SECUNDARIA DE VÉRTEBRA"
  },
  {
    "codigo":102500002,
    "descripcion":"RECIÉN NACIDO SANO"
  },
  {
    "codigo":36964004,
    "descripcion":"CESE DEL DESARROLLO Y\/O CRECIMIENTO ÓSEO"
  },
  {
    "codigo":299108004,
    "descripcion":"ARTICULACIÓN DE DEDO DE LA MANO INESTABLE"
  },
  {
    "codigo":200804009,
    "descripcion":"DERMATITIS POR CONTACTO CAUSADA POR ÁLCALIS"
  },
  {
    "codigo":1149241001,
    "descripcion":"SOBREDOSIS INTENCIONAL DE DIETILAMIDA DE ÁCIDO LISÉRGICO"
  },
  {
    "codigo":15735481000119108,
    "descripcion":"EPITELIOPATÍA CORNEAL DE OJO IZQUIEDA CAUSADA POR VIRUS HERPES SIMPLEX"
  },
  {
    "codigo":262670001,
    "descripcion":"LESIÓN DE CAVIDAD NASAL Y SENOS PARANASALES"
  },
  {
    "codigo":426510004,
    "descripcion":"SCHWANNOMA DE LA MÉDULA ESPINAL"
  },
  {
    "codigo":295438007,
    "descripcion":"SOBREDOSIS INTENCIONAL DE DANTRÓN"
  },
  {
    "codigo":195299000,
    "descripcion":"GANGRENA PRESENIL"
  },
  {
    "codigo":719587001,
    "descripcion":"HALLAZGO RELACIONADO CON LOS GRADOS DE HOUSE-BRACKMANN PARA EL NERVIO FACIAL"
  },
  {
    "codigo":721422009,
    "descripcion":"FRACTURA DE OCTAVA VÉRTEBRA DORSAL"
  },
  {
    "codigo":293603003,
    "descripcion":"ALERGIA A ANÁLOGO DE LA PETIDINA"
  },
  {
    "codigo":129763007,
    "descripcion":"CALCIFICACIÓN RADIOGRÁFICA HETEROGÉNEA"
  },
  {
    "codigo":95160001,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL URACO"
  },
  {
    "codigo":717752005,
    "descripcion":"OBSTRUCCIÓN DE VÍA URINARIA INFERIOR FETAL"
  },
  {
    "codigo":422840005,
    "descripcion":"LESIÓN TUMORAL CEREBRAL"
  },
  {
    "codigo":440381000124102,
    "descripcion":"INFUSIÓN PARA NUTRICIÓN ENTERAL EXCESIVA"
  },
  {
    "codigo":224397000,
    "descripcion":"HALLAZGO RELACIONADO CON EL DESEMPEÑO LABORAL"
  },
  {
    "codigo":226232009,
    "descripcion":"DIETA CON COMBINACIÓN DE ALIMENTOS"
  },
  {
    "codigo":816056009,
    "descripcion":"MASA DE PEZÓN MAMARIO"
  },
  {
    "codigo":11776851000119107,
    "descripcion":"LACERACIÓN DE TENDÓN DE PORCIÓN LARGA DE BÍCEPS BRAQUIAL DERECHO"
  },
  {
    "codigo":2621000124108,
    "descripcion":"SEGUNDO MOLAR SUPERIOR IZQUIERDO PERMANENTE SUPERNUMERARIO"
  },
  {
    "codigo":160696009,
    "descripcion":"DISTANCIA DE TRANSPORTE EXCESIVAMENTE GRANDE"
  },
  {
    "codigo":191629006,
    "descripcion":"TRASTORNO AFECTIVO BIPOLAR, EPISODIO ACTUAL DEPRESIVO, LEVE"
  },
  {
    "codigo":124258007,
    "descripcion":"DEFICIENCIA DE ACETIL - COA ACETILTRANSFERASA"
  },
  {
    "codigo":58722007,
    "descripcion":"FRACTURA DE MOORE"
  },
  {
    "codigo":253495002,
    "descripcion":"DOBLE ORIFICIO DE VÁLVULA AURICULOVENTRICULAR IZQUIERDA"
  },
  {
    "codigo":286263004,
    "descripcion":"DIFICULTAD PARA ACOMODAR LOS ÓRGANOS DE LA FONACIÓN AL MOMENTO DE ARTICULAR PALABRAS"
  },
  {
    "codigo":89655007,
    "descripcion":"NEUTROPENIA CONGÉNITA"
  },
  {
    "codigo":276616001,
    "descripcion":"GESTACIÓN FETAL PROLONGADA"
  },
  {
    "codigo":24119009,
    "descripcion":"INTOXICACIÓN POR FENANTRENO"
  },
  {
    "codigo":251660003,
    "descripcion":"MOCO CERVICAL POSCOITAL, ESPERMATOZOIDES MÓVILES E INMÓVILES NO PROGRESIVOS"
  },
  {
    "codigo":315361000,
    "descripcion":"PAÍS DE NACIMIENTO - PACÍFICO"
  },
  {
    "codigo":91271000119101,
    "descripcion":"CARCINOMA ESCAMOCELULAR METASTÁSICO DE HUESO"
  },
  {
    "codigo":413665004,
    "descripcion":"ENDOFTALMITIS RELACIONADA CON AMPOLLA DE FILTRACIÓN"
  },
  {
    "codigo":1003489004,
    "descripcion":"SOSPECHA DE GLAUCOMA DE ÁNGULO CERRADO DE OJO DERECHO"
  },
  {
    "codigo":85985006,
    "descripcion":"TORSIÓN CRÓNICA DE ESTÓMAGO"
  },
  {
    "codigo":84150000,
    "descripcion":"MALFORMACIÓN ARTERIOVENOSA DEL HÍGADO"
  },
  {
    "codigo":1362102004,
    "descripcion":"PARTO EXTRAHOSPITALARIO"
  },
  {
    "codigo":247990005,
    "descripcion":"MÚSICA A ALTO VOLUMEN - CONDUCTA ANTISOCIAL"
  },
  {
    "codigo":16475271000119104,
    "descripcion":"MEIBOMIANITIS DE AMBOS PÁRPADOS INFERIORES"
  },
  {
    "codigo":49547008,
    "descripcion":"ALCALOSIS COMPENSADA"
  },
  {
    "codigo":735840002,
    "descripcion":"LACERACIÓN DE PIERNA SIN CUERPO EXTRAÑO"
  },
  {
    "codigo":211552006,
    "descripcion":"LESIÓN TRAUMÁTICA CERRADA POR APLASTAMIENTO, REGIÓN ESCAPULAR"
  },
  {
    "codigo":310561000119100,
    "descripcion":"INFECCIÓN PIÓGENA DE DISCO INTERVERTEBRAL TORÁCICO"
  },
  {
    "codigo":1260128008,
    "descripcion":"DEFICIENCIA COMBINADA DE LA FOSFORILACIÓN OXIDATIVA ASOCIADA AL GEN WARS2"
  },
  {
    "codigo":308021002,
    "descripcion":"ATENDIDO EN CONSULTORIO ESPECIALIZADO"
  },
  {
    "codigo":1074311000119107,
    "descripcion":"ARTRITIS DE PIE IZQUIERDO DEBIDA A TRAUMATISMO"
  },
  {
    "codigo":13109008,
    "descripcion":"RAQUITISMO ENANO"
  },
  {
    "codigo":209717009,
    "descripcion":"SECCIÓN EXPUESTA DE LIGAMENTO SACROTUBEROSO"
  },
  {
    "codigo":240650007,
    "descripcion":"LEISHMANIASIS LUPOIDE"
  },
  {
    "codigo":764938007,
    "descripcion":"CARCINOMA LINFOEPITELIAL"
  },
  {
    "codigo":109578009,
    "descripcion":"CARIES DE LA INFANCIA"
  },
  {
    "codigo":238815002,
    "descripcion":"REACCIÓN POR AMPICILINA EN MONONUCLEOSIS INFECCIOSA"
  },
  {
    "codigo":304351006,
    "descripcion":"AMPLITUD DE MOVIMIENTO DE COLUMNA LUMBAR AUMENTADA"
  },
  {
    "codigo":1287391006,
    "descripcion":"HERIDA POR ARMA DE FUEGO DE PIE"
  },
  {
    "codigo":402655006,
    "descripcion":"VASCULITIS CUTÁNEA NECROSANTE"
  },
  {
    "codigo":1187252002,
    "descripcion":"TROMBOCITOPENIA AUTOSÓMICA DOMINANTE CON DEFECTO EN SECRECIÓN PLAQUETARIA"
  },
  {
    "codigo":11779361000119106,
    "descripcion":"AMPOLLA INFECTADA DE ANTEBRAZO IZQUIERDO"
  },
  {
    "codigo":71305001,
    "descripcion":"VÉRTIGO PAROXÍSTICO BENIGNO DE LA NIÑEZ"
  },
  {
    "codigo":366217002,
    "descripcion":"HALLAZGO RELACIONADO CON LA PERFUSIÓN CUBITAL DE LA MANO"
  },
  {
    "codigo":202377003,
    "descripcion":"DERRAME DE ARTICULACIÓN INTERFALÁNGICA PROXIMAL DE DEDO DE LA MANO"
  },
  {
    "codigo":398985007,
    "descripcion":"CONTROL DE DIABETES - ESTADO DE LOS SITIOS DE INYECCIÓN, NORMAL"
  },
  {
    "codigo":298846000,
    "descripcion":"AMPLITUD DE CIRCUNDUCCIÓN ACTIVA DE HOMBRO DISMINUIDA"
  },
  {
    "codigo":724830002,
    "descripcion":"DERMATITIS DE REGIÓN ANOGENITAL"
  },
  {
    "codigo":266078006,
    "descripcion":"INFECCIÓN DEL TRACTO GASTROINTESTINAL POR PSEUDOMONAS"
  },
  {
    "codigo":167774009,
    "descripcion":"VOLUMEN DE SEMEN MUY BAJO: MENOR A 0,5 ML"
  },
  {
    "codigo":165939003,
    "descripcion":"INMUNOGLOBULINAS FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":295551000119100,
    "descripcion":"CALCIFICACIÓN Y OSIFICACIÓN DE MÚSCULO DE PIERNA DEBIDA A QUEMADURA"
  },
  {
    "codigo":290431000119101,
    "descripcion":"CEFALEA INTRATABLE POSTERIOR A TRAUMATISMO"
  },
  {
    "codigo":129151000119102,
    "descripcion":"ENFERMEDAD RENAL CRÓNICA DEBIDA A HIPERTENSIÓN, ESTADIO 4"
  },
  {
    "codigo":10942591000119103,
    "descripcion":"LESIÓN TRAUMÁTICA DE CONDUCTO DE GLÁNDULA LAGRIMAL DERECHA"
  },
  {
    "codigo":313471000119104,
    "descripcion":"LORDOSIS LUMBAR"
  },
  {
    "codigo":10676351000119103,
    "descripcion":"ASMA PERSISTENTE MODERADA CONTROLADA"
  },
  {
    "codigo":292991000119106,
    "descripcion":"SÍNDROME DE EATON LAMBERT SIN NEOPLASIA MALIGNA SUBYACENTE"
  },
  {
    "codigo":321151000119106,
    "descripcion":"ESPONDILOLISTESIS ADQUIRIDA DE VÉRTEBRAS CERVICALES"
  },
  {
    "codigo":323711000119108,
    "descripcion":"TUMOR TENOSINOVIAL DIFUSO DE CÉLULAS GIGANTES DE MUÑECA DERECHA"
  },
  {
    "codigo":111231000119109,
    "descripcion":"DISLIPIDEMIA CON LIPOPROTEÍNAS DE ALTA DENSIDAD POR DEBAJO DEL RANGO DE REFERENCIA Y TRIGLICÉRIDOS POR ENCIMA DEL RANGO DE REFERENCIA DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":721160006,
    "descripcion":"VÁRICES DE TERCIO SUPERIOR DEL ESÓFAGO"
  },
  {
    "codigo":229640006,
    "descripcion":"AFONÍA HIPERFUNCIONAL"
  },
  {
    "codigo":264008,
    "descripcion":"OJO CIEGO HIPERTENSIVO"
  },
  {
    "codigo":426248008,
    "descripcion":"LEUCEMIA LINFOIDE ALEUCÉMICA, EN REMISIÓN"
  },
  {
    "codigo":293341000,
    "descripcion":"REACCIÓN ADVERSA AL ANTICOAGULANTE DE ACCIÓN INDIRECTA"
  },
  {
    "codigo":16008831000119109,
    "descripcion":"DISPLASIA CONGÉNITA DE EXTREMIDAD SUPERIOR IZQUIERDA"
  },
  {
    "codigo":424413001,
    "descripcion":"SARCOMA"
  },
  {
    "codigo":336511000119108,
    "descripcion":"EPITELIOPATÍA PIGMENTARIA PLACOIDE MULTIFOCAL AGUDA DE OJO DERECHO"
  },
  {
    "codigo":341631000119109,
    "descripcion":"CONJUNTIVITIS CRÓNICA DE OJO IZQUIERDO"
  },
  {
    "codigo":291506005,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ESPIRAMICINA"
  },
  {
    "codigo":715655000,
    "descripcion":"MIOCARDIOPATÍA AMILOIDE FAMILIAR RELACIONADA CON TRANSTIRETINA"
  },
  {
    "codigo":94898009,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA CARA LARÍNGEA DE LA EPIGLOTIS"
  },
  {
    "codigo":224135000,
    "descripcion":"VIVE CON UNA HIJA"
  },
  {
    "codigo":93063004,
    "descripcion":"DIVERTÍCULO CONGÉNITO DEL TRACTO INTESTINAL"
  },
  {
    "codigo":781191008,
    "descripcion":"CELULITIS DE HERIDA POSOPERATORIA EXTENSA"
  },
  {
    "codigo":386140000,
    "descripcion":"ARTERIA CORONARIA ECTÁSICA"
  },
  {
    "codigo":255068000,
    "descripcion":"CARCINOMA DE HUESO, TEJIDO, PIEL Y MAMA"
  },
  {
    "codigo":713820002,
    "descripcion":"VÍCTIMA DE AGRESIÓN SEXUAL POR PAREJA ÍNTIMA"
  },
  {
    "codigo":58460004,
    "descripcion":"ANTÍGENO DE GRUPO SANGUÍNEO O"
  },
  {
    "codigo":123996009,
    "descripcion":"CARBOHIDRATO POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":449841002,
    "descripcion":"SONDA NASOGÁSTRICA PERMEABLE"
  },
  {
    "codigo":253233005,
    "descripcion":"SEUDOPOLICORIA"
  },
  {
    "codigo":56625005,
    "descripcion":"FIEBRE DEL AGUA NEGRA"
  },
  {
    "codigo":187697007,
    "descripcion":"NEOPLASIA MALIGNA DE RECESO FARÍNGEO"
  },
  {
    "codigo":286001009,
    "descripcion":"DIFICULTAD PARA ABRIR LA TUBERÍA DE GAS MAESTRA"
  },
  {
    "codigo":284166001,
    "descripcion":"DIFICULTAD PARA MOVER LA CABEZA"
  },
  {
    "codigo":415238003,
    "descripcion":"TRASTORNO DEL SUEÑO CON MOVIMIENTOS OCULARES RÁPIDOS"
  },
  {
    "codigo":218630003,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR ÁCIDO MEFENÁMICO"
  },
  {
    "codigo":448006009,
    "descripcion":"TABIQUE INTERAURICULAR INTACTO"
  },
  {
    "codigo":249563003,
    "descripcion":"INTESTINO PALPABLE A TRAVÉS DEL ABDOMEN"
  },
  {
    "codigo":20187005,
    "descripcion":"GRANULOMA DE MÚSCULO POR CUERPO EXTRAÑO"
  },
  {
    "codigo":216795007,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR HUMOS DE ARSÉNICO"
  },
  {
    "codigo":18352002,
    "descripcion":"PRESIÓN ARTERIAL SISTÓLICA ANORMAL"
  },
  {
    "codigo":247728003,
    "descripcion":"LOS OBJETOS PARECEN IRREALES"
  },
  {
    "codigo":1263536006,
    "descripcion":"ENFERMEDAD DE NEURONA MOTORA DEBIDA A PARAPLEJÍA ESPÁSTICA HEREDITARIA"
  },
  {
    "codigo":82053000,
    "descripcion":"ABSCESO ESPLÉNICO"
  },
  {
    "codigo":870320009,
    "descripcion":"OSTEÍTIS CONDENSANTE DE PARTE INTERNA DE CLAVÍCULA"
  },
  {
    "codigo":213125001,
    "descripcion":"INFECCIÓN DE HUESO ASOCIADA CON PERNO DE FIJACIÓN EXTERNA"
  },
  {
    "codigo":16517004,
    "descripcion":"LIPIDOSIS CEREBRAL"
  },
  {
    "codigo":1360005005,
    "descripcion":"NEOPLASIA MALIGNA DE TRACTO GASTROINTESTINAL INFERIOR"
  },
  {
    "codigo":409733005,
    "descripcion":"CLASIFICACIÓN INTERNACIONAL DE NEUROBLASTOMA: GRUPO CON HISTOLOGÍA FAVORABLE, PAC. <1,5 AÑOS, CON NEUROBLASTOMA MAL DIFERENCIADO (S\/ PREDOMINIO DE CÉL. DE SCHWANN EN EL ESTROMA) E ÍNDICE BAJO O INTERMEDIO DE MITOSIS-CARIORREXIS"
  },
  {
    "codigo":278661005,
    "descripcion":"DIENTE PRESENTE"
  },
  {
    "codigo":309594000,
    "descripcion":"RETINOPATÍA AVANZADA"
  },
  {
    "codigo":1259866001,
    "descripcion":"FÍSTULA POSOPERATORIA DE VEJIGA"
  },
  {
    "codigo":473434003,
    "descripcion":"DOLOR EN EL MENTÓN"
  },
  {
    "codigo":211290004,
    "descripcion":"LESIONES SUPERFICIALES MÚLTIPLES EN EL ANTEBRAZO"
  },
  {
    "codigo":276826005,
    "descripcion":"GLIOMA MALIGNO DE CEREBRO"
  },
  {
    "codigo":702810006,
    "descripcion":"SÍNDROME DE HIPERSENSIBILIDAD A ALOPURINOL"
  },
  {
    "codigo":209455000,
    "descripcion":"ESGUINCE DE LIGAMENTO ESCAFOTRAPEZOIDE"
  },
  {
    "codigo":735578009,
    "descripcion":"ANOMALÍA ADQUIRIDA DE SENO CORONARIO"
  },
  {
    "codigo":307759003,
    "descripcion":"INFECCIÓN DEL TRACTO GASTROINTESTINAL POR HELICOBACTER PYLORI"
  },
  {
    "codigo":45615004,
    "descripcion":"MANO CAVA"
  },
  {
    "codigo":1290799005,
    "descripcion":"CONTUSIÓN PROFUNDA DE HUESO"
  },
  {
    "codigo":12847006,
    "descripcion":"ÚLCERA DUODENAL AGUDA CON HEMORRAGIA"
  },
  {
    "codigo":240388001,
    "descripcion":"MUERMO SUPURATIVO CRÓNICO"
  },
  {
    "codigo":830212002,
    "descripcion":"ALERGIA A BÁLSAMO DE PERÚ"
  },
  {
    "codigo":109316003,
    "descripcion":"OSTEOMIELITIS CRÓNICA DE HUESO FRONTAL"
  },
  {
    "codigo":238553001,
    "descripcion":"ECCEMA CONSTITUCIONAL DE MANO"
  },
  {
    "codigo":10936201000119107,
    "descripcion":"FRACTURA NO EXPUESTA DE HUESO TRAPEZOIDE DE MUÑECA DERECHA"
  },
  {
    "codigo":9177003,
    "descripcion":"VASCULITIS HISTIOCÍTICA DE LA PIEL"
  },
  {
    "codigo":1156057004,
    "descripcion":"FENOBARBITAL SÉRICO POR DEBAJO DEL RANGO TERAPÉUTICO"
  },
  {
    "codigo":402393005,
    "descripcion":"URTICARIA CAUSADA POR ADITIVO ALIMENTARIO"
  },
  {
    "codigo":369625009,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA DE LA FASCIA DE GEROTA, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":236718002,
    "descripcion":"HEMATURIA QUÍMICA"
  },
  {
    "codigo":105646002,
    "descripcion":"ENFERMEDAD CAUSADA POR HARTMANNELLIDAE"
  },
  {
    "codigo":203950009,
    "descripcion":"ESPINA BÍFIDA LUMBAR CON HIDROCEFALIA - CERRADA"
  },
  {
    "codigo":5507002,
    "descripcion":"TRASTORNO DE HÁBITOS ESTEREOTIPADOS"
  },
  {
    "codigo":300419003,
    "descripcion":"DEFENSA ABDOMINAL EN EL HIPOGASTRIO"
  },
  {
    "codigo":726403001,
    "descripcion":"TEMOR A ENFERMEDAD OCULAR"
  },
  {
    "codigo":398723007,
    "descripcion":"NEVO VERRUGOSO EPIDERMOIDE"
  },
  {
    "codigo":202115007,
    "descripcion":"DESGARRO PARCIAL ANTIGUO DE LIGAMENTO LATERAL EXTERNO DE RODILLA"
  },
  {
    "codigo":298584001,
    "descripcion":"COLUMNA VERTEBRAL DORSAL MUY CALIENTE"
  },
  {
    "codigo":396888002,
    "descripcion":"TUMOR QUE INVADE MÁS ALLÁ DE LA CÁPSULA PANCREÁTICA HACIA EL COLON (PÁNCREAS ENDOCRINO)"
  },
  {
    "codigo":365955008,
    "descripcion":"HALLAZGO RELACIONADO CON LA CONDUCTA QUE ACOMPAÑA AL SEXO"
  },
  {
    "codigo":429656004,
    "descripcion":"EFECTO TARDÍO DE LESIÓN TRAUMÁTICA DE CEREBRO"
  },
  {
    "codigo":36440009,
    "descripcion":"IMPOSIBILIDAD DE AUMENTAR DE PESO"
  },
  {
    "codigo":460589002,
    "descripcion":"ANILLO VASCULAR CON CAYADO AÓRTICO DERECHO Y LIGAMENTO ARTERIOSO IZQUIERDO ENTRE ARTERIA SUBCLAVIA IZQUIERDA Y ARTERIA CARÓTIDA PRIMITIVA IZQUIERDA"
  },
  {
    "codigo":1837006,
    "descripcion":"INTOXICACIÓN POR ORCIPRENALINA"
  },
  {
    "codigo":198445009,
    "descripcion":"INFERTILIDAD ANOVULATORIA PRIMARIA"
  },
  {
    "codigo":296749009,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE CEFPIROMA"
  },
  {
    "codigo":131074001,
    "descripcion":"NIVEL DE ANDRÓGENO POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":360450007,
    "descripcion":"DISTENSIÓN DE MÚSCULO DEL CUELLO"
  },
  {
    "codigo":30935000,
    "descripcion":"TRASTORNO BIPOLAR I MANÍACO EN REMISIÓN TOTAL"
  },
  {
    "codigo":1145047001,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE TIOPENTAL"
  },
  {
    "codigo":293079001,
    "descripcion":"REACCIÓN ADVERSA A ETAMBUTOL"
  },
  {
    "codigo":162007004,
    "descripcion":"TUMEFACCIÓN DENTAL"
  },
  {
    "codigo":424151006,
    "descripcion":"GLIOMA CEREBRAL ANAPLÁSICO"
  },
  {
    "codigo":717228004,
    "descripcion":"QUERATODERMIA PALMOPLANTAR HEREDITARIA, TIPO GAMBORG NIELSEN"
  },
  {
    "codigo":94636007,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LOS GANGLIOS LINFÁTICOS TIBIALES"
  },
  {
    "codigo":127404008,
    "descripcion":"HALLAZGO EN LA PRODUCCIÓN DE GRANULOCITOS"
  },
  {
    "codigo":289409000,
    "descripcion":"SUTURA SAGITAL EN DIÁMETRO OBLICUO IZQUIERDO"
  },
  {
    "codigo":60033003,
    "descripcion":"PANICULITIS QUE AFECTA LA REGIÓN DEL DORSO"
  },
  {
    "codigo":92801005,
    "descripcion":"CARCINOMA IN SITU DE LAS CUERDAS VOCALES"
  },
  {
    "codigo":1303382007,
    "descripcion":"FRACTURA DE OLÉCRANON IZQUIERDO"
  },
  {
    "codigo":418646009,
    "descripcion":"MUERTE - ESPERADA"
  },
  {
    "codigo":285739002,
    "descripcion":"LESIÓN DE ARTERIA PLANTAR PROFUNDA"
  },
  {
    "codigo":254806009,
    "descripcion":"NEVO AZUL CUTÁNEO"
  },
  {
    "codigo":1268779009,
    "descripcion":"CAPAZ DE PAGAR MEDICACIÓN"
  },
  {
    "codigo":251136001,
    "descripcion":"ECG EN EL LÍMITE DE LA ANORMALIDAD"
  },
  {
    "codigo":414976005,
    "descripcion":"ORGANISMO NO IDENTIFICADO, DERIVADO AL CDC"
  },
  {
    "codigo":1363413000,
    "descripcion":"SINUSITIS MAXILAR DEBIDA A ENFERMEDAD PERIODONTAL"
  },
  {
    "codigo":249301002,
    "descripcion":"SANGRADO POR URETRA"
  },
  {
    "codigo":445909003,
    "descripcion":"QUISTE EPIDERMOIDE DE PIEL DE ESCROTO"
  },
  {
    "codigo":15663601000119101,
    "descripcion":"CONJUNTIVITIS HEMORRÁGICA AGUDA DE AMBOS OJOS"
  },
  {
    "codigo":216533004,
    "descripcion":"INTOXICACIÓN ACCIDENTAL CAUSADA POR FLURAZEPAM"
  },
  {
    "codigo":282069005,
    "descripcion":"RUPTURA DE ÍLEON"
  },
  {
    "codigo":444074000,
    "descripcion":"DIABETES MELLITUS TIPO 1 BIEN CONTROLADA"
  },
  {
    "codigo":85461008,
    "descripcion":"CAPILARITIS"
  },
  {
    "codigo":1197738002,
    "descripcion":"PSEUDOBSTRUCCIÓN INTESTINAL CRÓNICA IDIOPÁTICA"
  },
  {
    "codigo":313002004,
    "descripcion":"NEURORRETINITIS MACULAR AGUDA"
  },
  {
    "codigo":247466004,
    "descripcion":"ERUPCIÓN HERPETIFORME"
  },
  {
    "codigo":344561000119104,
    "descripcion":"RETINITIS PERIFÉRICA FOCAL DE AMBOS OJOS"
  },
  {
    "codigo":276564000,
    "descripcion":"TRASTORNO PERINATAL DE GLÁNDULA TIROIDES DE FETO Y\/O RECIÉN NACIDO"
  },
  {
    "codigo":704383009,
    "descripcion":"CONOCIMIENTO DEFICIENTE SOBRE DESARROLLO INFANTIL"
  },
  {
    "codigo":473172002,
    "descripcion":"HEMATOMA EN LOCALIZACIÓN DE GENERADOR DE PULSOS DE MARCAPASOS"
  },
  {
    "codigo":868223009,
    "descripcion":"OCLUSIÓN DE RAMA LATERAL POSTERIOR DE ARTERIA CORONARIA DERECHA"
  },
  {
    "codigo":702548005,
    "descripcion":"FRACTURA DE TORNILLO DE IMPLANTE DENTAL"
  },
  {
    "codigo":1081841000119106,
    "descripcion":"CARCINOMA MICROCÍTICO PRIMARIO DE LÓBULO INFERIOR DE PULMÓN IZQUIERDO"
  },
  {
    "codigo":373033000,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM GOODII"
  },
  {
    "codigo":768084009,
    "descripcion":"HERNIA FEMORAL DERECHA CON GANGRENA"
  },
  {
    "codigo":307497002,
    "descripcion":"PERFORACIÓN TRAUMÁTICA DE LA MEMBRANA TIMPÁNICA"
  },
  {
    "codigo":209193003,
    "descripcion":"SUBLUXACIÓN VERTEBRAL EXPUESTA CON LESIÓN MEDULAR COMPLETA A NIVEL LUMBAR"
  },
  {
    "codigo":15745521000119107,
    "descripcion":"OMÓPLATOS ALADOS BILATERALES"
  },
  {
    "codigo":766249007,
    "descripcion":"SÍNDROME DE SORDERA, NEFRITIS Y MALFORMACIÓN ANORRECTAL"
  },
  {
    "codigo":895486006,
    "descripcion":"SE MOVILIZA CON MULETA"
  },
  {
    "codigo":305662006,
    "descripcion":"ATENDIDO POR UN CARDIÓLOGO"
  },
  {
    "codigo":240126009,
    "descripcion":"INFARTO MUSCULAR ISQUÉMICO"
  },
  {
    "codigo":402131002,
    "descripcion":"CANDIDIASIS CUTÁNEA DISEMINADA"
  },
  {
    "codigo":403966009,
    "descripcion":"HEMANGIOMA ARTERIOVENOSO"
  },
  {
    "codigo":74451002,
    "descripcion":"HIPERTENSIÓN ARTERIAL DIASTÓLICA SECUNDARIA"
  },
  {
    "codigo":860883001,
    "descripcion":"NEUROPATÍA AUTONÓMICA GENERALIZADA DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":41683006,
    "descripcion":"SIGNO DE DEMIANOFF"
  },
  {
    "codigo":8915006,
    "descripcion":"HIPOPLASIA CONGÉNITA DE GLÁNDULA MAMARIA"
  },
  {
    "codigo":269224001,
    "descripcion":"LESIÓN POR APLASTAMIENTO DE ROSTRO, CUERO CABELLUDO Y CUELLO"
  },
  {
    "codigo":236456002,
    "descripcion":"NEFROPATÍA CRÓNICA POR CADMIO"
  },
  {
    "codigo":1186728004,
    "descripcion":"ESCLEROSIS MÚLTIPLE PEDIÁTRICA"
  },
  {
    "codigo":367528006,
    "descripcion":"AMILOIDOSIS DE LA FIEBRE MEDITERRÁNEA FAMILIAR"
  },
  {
    "codigo":365693001,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA USAR RAZONAMIENTO ARITMÉTICO"
  },
  {
    "codigo":267389001,
    "descripcion":"HIPOPITUITARISMO POR LESIÓN LUEGO DEL PARTO"
  },
  {
    "codigo":39848009,
    "descripcion":"LESIÓN TRAUMÁTICA DEL CUELLO POR HIPERFLEXIÓN - HIPEREXTENSIÓN"
  },
  {
    "codigo":1217661001,
    "descripcion":"CATARATA POR TRASTORNO OCULAR DEGENERATIVO"
  },
  {
    "codigo":1119357005,
    "descripcion":"ATAXIA ESPÁSTICA"
  },
  {
    "codigo":38013005,
    "descripcion":"INMUNOSUPRESIÓN"
  },
  {
    "codigo":234621005,
    "descripcion":"DEFICIENCIA DEL FACTOR I"
  },
  {
    "codigo":300157006,
    "descripcion":"REFLEJO LUMINOSO DE LA MEMBRANA TIMPÁNICA ANORMAL"
  },
  {
    "codigo":68946007,
    "descripcion":"INFECCIÓN CAUSADA POR ONCHOCERCA GIBSONI"
  },
  {
    "codigo":462162008,
    "descripcion":"EDEMA DIFUSO DE PIEL FETAL"
  },
  {
    "codigo":296487002,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE COLCHICINA"
  },
  {
    "codigo":198183003,
    "descripcion":"ENDOMIOMETRITIS SUBAGUDA"
  },
  {
    "codigo":720636001,
    "descripcion":"SÍNDROME DE COLESTASIS CON RETINOPATÍA PIGMENTARIA Y FISURA DE PALADAR"
  },
  {
    "codigo":1179388006,
    "descripcion":"ENCEFALITIS POR VIRUS USUTU"
  },
  {
    "codigo":294652008,
    "descripcion":"ALERGIA A COMPONENTE DE VACUNA QUE CONTIENE ANTÍGENO DE STREPTOCOCCUS PNEUMONIAE"
  },
  {
    "codigo":292817002,
    "descripcion":"REACCIÓN ADVERSA AL TIOCONAZOL"
  },
  {
    "codigo":423889005,
    "descripcion":"ASMA ALÉRGICA NO MEDIADA POR IGE"
  },
  {
    "codigo":128977007,
    "descripcion":"ESTADO DEL PACIENTE PREVIO AL EJERCICIO"
  },
  {
    "codigo":391121008,
    "descripcion":"PRUEBA DE REVERSIBILIDAD A COMBINACIÓN DE SALBUTAMOL E IPRATROPIO: POSITIVA"
  },
  {
    "codigo":1084351000119102,
    "descripcion":"TROMPAS DE EUSTAQUIO BILATERALES PERMEABLES"
  },
  {
    "codigo":225446002,
    "descripcion":"PENSAMIENTOS POSITIVOS SOBRE UNO MISMO"
  },
  {
    "codigo":782502003,
    "descripcion":"GANGRENA DEBIDA A HERNIA UMBILICAL RECIDIVANTE"
  },
  {
    "codigo":1208486005,
    "descripcion":"SÍNDROME DE DISFUNCIÓN MITOCONDRIAL MÚLTIPLE TIPO 2"
  },
  {
    "codigo":290982007,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR CLONAZEPAM"
  },
  {
    "codigo":127142008,
    "descripcion":"LINFADENOPATÍA LUMBAR"
  },
  {
    "codigo":94374009,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA PARED LATERAL DE LA VEJIGA"
  },
  {
    "codigo":59771005,
    "descripcion":"LITIASIS VESICULAR CON COLECISTITIS AGUDA"
  },
  {
    "codigo":1335888000,
    "descripcion":"SINOSTOSIS RADIOCUBITAL DE ANTEBRAZO DERECHO"
  },
  {
    "codigo":92539008,
    "descripcion":"CARCINOMA IN SITU DE APÉNDICE ILEOCECAL"
  },
  {
    "codigo":715131009,
    "descripcion":"INCAPAZ DE PASAR DE UNA SILLA A LA CAMA"
  },
  {
    "codigo":347071000119105,
    "descripcion":"CATARATA NEGRA DE AMBOS OJOS"
  },
  {
    "codigo":713296005,
    "descripcion":"ALERGIA A INHIBIDOR DE PROTEASA RETROVIRAL"
  },
  {
    "codigo":1137445000,
    "descripcion":"CALCIFICACIÓN PUNTEADA DE HUESO DE TARSO"
  },
  {
    "codigo":254544008,
    "descripcion":"CARCINOMA IN SITU DE LA PORCIÓN ABDOMINAL DEL ESÓFAGO"
  },
  {
    "codigo":711461002,
    "descripcion":"ALTURA FACIAL INFERIOR DISMINUIDA"
  },
  {
    "codigo":285477007,
    "descripcion":"DIFICULTAD PARA MOVER LOS LABIOS"
  },
  {
    "codigo":283642000,
    "descripcion":"HERIDA POR PINCHAZO DE AGUJA EN EL DORSO DEL PIE"
  },
  {
    "codigo":54266002,
    "descripcion":"INFECCIÓN CAUSADA POR FASCIOLOPSIS BUSKI"
  },
  {
    "codigo":871631000,
    "descripcion":"ÚLCERA DE INTESTINO DEBIDA A VASCULITIS POR INMUNOGLOBULINA A"
  },
  {
    "codigo":185338009,
    "descripcion":"ENCUENTRO FALLIDO - SE DEJÓ MENSAJE EN EL LUGAR DE TRABAJO"
  },
  {
    "codigo":19663002,
    "descripcion":"INFECCIÓN POR HERPESVIRUS T"
  },
  {
    "codigo":1363151005,
    "descripcion":"ASTILLA EN AXILA CON INFECCIÓN"
  },
  {
    "codigo":609487007,
    "descripcion":"INTERRUPCIÓN INDUCIDA DEL EMBARAZO COMPLICADA POR CHOQUE SÉPTICO"
  },
  {
    "codigo":773327007,
    "descripcion":"RECTOCELE FEMENINO CONCOMITANTE CON ENTEROCELE"
  },
  {
    "codigo":247204001,
    "descripcion":"PAPILA ÓPTICA CON FORMA DE CAMPANILLA"
  },
  {
    "codigo":771492002,
    "descripcion":"FRACTURAS NO EXPUESTAS QUE COMPROMETEN MÚLTIPLES REGIONES DE LA EXTREMIDAD SUPERIOR DERECHA"
  },
  {
    "codigo":1197476009,
    "descripcion":"PROTEINOSIS ALVEOLAR PULMONAR E HIPOGAMMAGLOBULINEMIA DE INICIO EN LACTANTE"
  },
  {
    "codigo":12199001000119107,
    "descripcion":"SUBLUXACIÓN DE PRÓTESIS DE ARTICULACIÓN DE RODILLA IZQUIERDA"
  },
  {
    "codigo":15993004,
    "descripcion":"HIPOVENTILACIÓN ALVEOLAR"
  },
  {
    "codigo":866126000,
    "descripcion":"MIELITIS CAUSADA POR VIRUS INFLUENZA A"
  },
  {
    "codigo":276302000,
    "descripcion":"SENSACIÓN DE PÉRDIDA DE LOS SENTIMIENTOS"
  },
  {
    "codigo":1193806001,
    "descripcion":"ENTERITIS EOSINOFÍLICA CAUSADA POR ANCYLOSTOMA CANINUM"
  },
  {
    "codigo":407374003,
    "descripcion":"TRANSEXUAL"
  },
  {
    "codigo":14158003,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE DEDO DEL PIE, CON INFECCIÓN"
  },
  {
    "codigo":15639641000119109,
    "descripcion":"DEBILIDAD DE MANO IZQUIERDA"
  },
  {
    "codigo":79694000,
    "descripcion":"HEMIANOPSIA CRUZADA"
  },
  {
    "codigo":1259342000,
    "descripcion":"CARCINOMA PRIMARIO DE GLÁNDULA SUBMANDIBULAR"
  },
  {
    "codigo":405539004,
    "descripcion":"HEMORRAGIA DE VASO SANGUÍNEO"
  },
  {
    "codigo":700451007,
    "descripcion":"ÍLEON TERMINAL VISUALIZADO"
  },
  {
    "codigo":208931007,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE LA ARTICULACIÓN FEMORORROTULIANA, INTERNA"
  },
  {
    "codigo":307235009,
    "descripcion":"NECROSIS DE UNA COLOSTOMÍA"
  },
  {
    "codigo":733219009,
    "descripcion":"LACERACIÓN DE PLEURA"
  },
  {
    "codigo":1222904004,
    "descripcion":"DIFICULTAD PARA PATEAR CON PIERNA"
  },
  {
    "codigo":370936007,
    "descripcion":"RUPTURA ZONULAR"
  },
  {
    "codigo":698616008,
    "descripcion":"FRACTURA NO EXPUESTA DE CALOTA CRANEAL CON PÉRDIDA DE CONSCIENCIA"
  },
  {
    "codigo":895224009,
    "descripcion":"LESIÓN SUPERFICIAL DE PIEL DEL PÁRPADO"
  },
  {
    "codigo":205261005,
    "descripcion":"MACRODACTILIA DE DEDOS DE LA MANO - SIMPLE"
  },
  {
    "codigo":762317007,
    "descripcion":"TRASTORNO DEL DESARROLLO DEL LENGUAJE CONCOMITANTE CON ALTERACIÓN DEL LENGUAJE RECEPTIVO Y EXPRESIVO"
  },
  {
    "codigo":400034001,
    "descripcion":"FLEBECTASIA DE YUGULAR INTERNA"
  },
  {
    "codigo":72354005,
    "descripcion":"INTOLERANCIA A ANTICONCEPTIVO ORAL"
  },
  {
    "codigo":170658009,
    "descripcion":"EJERCICIO NUNCA RESTRINGIDO POR EL ASMA"
  },
  {
    "codigo":39586009,
    "descripcion":"TALASEMIA POR PERSISTENCIA HEREDITARIA DE HEMOGLOBINA FETAL A GAMMA BETA^+^"
  },
  {
    "codigo":267127005,
    "descripcion":"NIVEL 5 DE ACTIVIDAD SEGÚN EL PRINCIPIO FITT"
  },
  {
    "codigo":168823005,
    "descripcion":"TRAGO DE BARIO NORMAL"
  },
  {
    "codigo":299895008,
    "descripcion":"RESPUESTA PLANTAR DERECHA DUDOSA"
  },
  {
    "codigo":103287009,
    "descripcion":"VÉRTIGO AL DESPERTAR"
  },
  {
    "codigo":365431009,
    "descripcion":"HALLAZGO RELACIONADO CON EL NIVEL DE PSICOSIS"
  },
  {
    "codigo":396364005,
    "descripcion":"TAMAÑO DE LESIÓN, NO SE PUEDE DETERMINAR"
  },
  {
    "codigo":722209002,
    "descripcion":"SÍNDROME DE PARAPLEJÍA ESPÁSTICA, DISCAPACIDAD INTELECTUAL E HIPERQUERATOSIS PALMOPLANTAR"
  },
  {
    "codigo":230689003,
    "descripcion":"TRASTORNOS CEREBROVASCULARES Y VERTEBROVASCULARES"
  },
  {
    "codigo":296225005,
    "descripcion":"SOBREDOSIS DE CLORPROMAZINA"
  },
  {
    "codigo":65014005,
    "descripcion":"INFECCIÓN CAUSADA POR BUNOSTOMUM TRIGONOCEPHALUM"
  },
  {
    "codigo":294390007,
    "descripcion":"ALERGIA A AMODIAQUINA"
  },
  {
    "codigo":718539004,
    "descripcion":"LESIÓN TRAUMÁTICA DE MANGUITO ROTADOR"
  },
  {
    "codigo":292555004,
    "descripcion":"REACCIÓN ADVERSA A LA ACETILCISTEÍNA"
  },
  {
    "codigo":423627007,
    "descripcion":"SARCOMA DE OVARIO"
  },
  {
    "codigo":1144523008,
    "descripcion":"TOLERANCIA A LA ACTIVIDAD NORMAL"
  },
  {
    "codigo":126880001,
    "descripcion":"NEOPLASIA DE RIÑÓN"
  },
  {
    "codigo":390859008,
    "descripcion":"VELOCIDAD DE FLUJO ESPIRATORIO PICO: TÉCNICA DEFICIENTE"
  },
  {
    "codigo":290720007,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR HIDROXICARBAMIDA"
  },
  {
    "codigo":716704007,
    "descripcion":"AMILOIDOSIS NODULAR CUTÁNEA LOCALIZADA PRIMARIA"
  },
  {
    "codigo":28576007,
    "descripcion":"FRACTURA EXPUESTA DE FÉMUR"
  },
  {
    "codigo":11873831000119107,
    "descripcion":"DERMATITIS POR CONTACTO DE AMBOS PÁRPADOS INFERIORES"
  },
  {
    "codigo":92277003,
    "descripcion":"NEOPLASIA BENIGNA DEL PERITONEO PARIETAL"
  },
  {
    "codigo":94112009,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL CÚBITO"
  },
  {
    "codigo":419957005,
    "descripcion":"DERMATITIS ALÉRGICA POR CONTACTO DE CONDUCTO AUDITIVO EXTERNO"
  },
  {
    "codigo":713034001,
    "descripcion":"DISECCIÓN DE ARTERIA MESENTÉRICA"
  },
  {
    "codigo":288885009,
    "descripcion":"INCAPAZ DE COMER"
  },
  {
    "codigo":418122003,
    "descripcion":"BRONCOMONILIASIS"
  },
  {
    "codigo":714869009,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA MANTENER LA POSICIÓN EN CUCLILLAS"
  },
  {
    "codigo":254282004,
    "descripcion":"MUJER CON MÁS DE TRES CROMOSOMAS X"
  },
  {
    "codigo":287050006,
    "descripcion":"OSTEOMIELITIS AGUDA DE CODO"
  },
  {
    "codigo":449055006,
    "descripcion":"LEIOMIOSARCOMA DE UNIÓN CARDIOESOFÁGICA"
  },
  {
    "codigo":285215008,
    "descripcion":"MEMORIA ASISTIDA CON UTILIZACIÓN DE DIARIO"
  },
  {
    "codigo":840436002,
    "descripcion":"DISECCIÓN DE ARTERIA CEREBRAL MEDIA"
  },
  {
    "codigo":86772005,
    "descripcion":"EFECTO TÓXICO DE PRODUCTO DERIVADO DEL PETRÓLEO"
  },
  {
    "codigo":283380005,
    "descripcion":"LACERACIÓN DE PERINEO"
  },
  {
    "codigo":447220009,
    "descripcion":"HEMATOMA DE CUELLO"
  },
  {
    "codigo":281545002,
    "descripcion":"RUPTURA DE TENDÓN DE LA CABEZA Y DEL CUELLO"
  },
  {
    "codigo":84937002,
    "descripcion":"HIPONATREMIA CEREBRAL"
  },
  {
    "codigo":445385004,
    "descripcion":"TUMEFACCIÓN DE CABEZA"
  },
  {
    "codigo":609225004,
    "descripcion":"REGRESIÓN DEL DESARROLLO"
  },
  {
    "codigo":11820891000119101,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA INFERIOR DE ARTICULACIÓN ESCAPULOHUMERAL IZQUIERDA"
  },
  {
    "codigo":707529004,
    "descripcion":"CARCINOMA SUPERPUESTO DE CÉLULAS ESCAMOSAS DE OROFARINGE"
  },
  {
    "codigo":248777008,
    "descripcion":"ERECCIÓN MUY INTENSA"
  },
  {
    "codigo":50334000,
    "descripcion":"POLIMORFISMO GENÉTICO"
  },
  {
    "codigo":1297353008,
    "descripcion":"DISPLASIA CONGÉNITA DE ARTICULACIÓN DE RODILLA"
  },
  {
    "codigo":48499001,
    "descripcion":"ÍNDICE DE MASA CORPORAL AUMENTADO"
  },
  {
    "codigo":310643001,
    "descripcion":"INFECCIÓN DE CATÉTER INTRAVENOSO"
  },
  {
    "codigo":246942009,
    "descripcion":"ANILLO DEL LIMBO CORNEAL"
  },
  {
    "codigo":736627004,
    "descripcion":"SIN RUIDOS EPIGÁSTRICOS"
  },
  {
    "codigo":308808005,
    "descripcion":"SITUACIÓN DEL INFORME POSTMORTEM"
  },
  {
    "codigo":276040005,
    "descripcion":"CUIDA A ALGUIEN"
  },
  {
    "codigo":352091000119106,
    "descripcion":"CARCINOMA DE CÉLULAS DE MERKEL PRIMARIO DE PIEL DE NARIZ"
  },
  {
    "codigo":1259080009,
    "descripcion":"TRASTORNO AUTONÓMICO DEBIDO A ENFERMEDAD DE PARKINSON"
  },
  {
    "codigo":274205003,
    "descripcion":"QUEMADURA DE REGIÓN OCULAR"
  },
  {
    "codigo":1290013004,
    "descripcion":"TUMOR NEUROENDOCRINO BIEN DIFERENCIADO PRIMARIO DE ANO"
  },
  {
    "codigo":208669004,
    "descripcion":"FRACTURA EXPUESTA DE TOBILLO, TRIMALEOLAR, FRACTURA PERONEA SUPERIOR"
  },
  {
    "codigo":700189007,
    "descripcion":"ANOMALÍA DE UÑA DE DEDO DE PIE"
  },
  {
    "codigo":110365009,
    "descripcion":"REGUSTO"
  },
  {
    "codigo":1255410001,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR SUSTANCIA CON ESTRUCTURA ALCOHÓLICA"
  },
  {
    "codigo":732957009,
    "descripcion":"SÍNDROME DE BRAQUIDACTILIA Y DEDO GORDO VARO PREAXIAL"
  },
  {
    "codigo":403442005,
    "descripcion":"DISPLASIA MUCOEPITELIAL HEREDITARIA"
  },
  {
    "codigo":763890006,
    "descripcion":"BAJA ESTATURA CON RETRASO DE LA EDAD ÓSEA DEBIDO A DEFICIENCIA DEL METABOLISMO DE LA HORMONA TIROIDEA"
  },
  {
    "codigo":1157106007,
    "descripcion":"REACCIÓN ADVERSA A VACUNA VECTOR VIRAL NO REPLICANTE CONTRA COVID-19"
  },
  {
    "codigo":204999002,
    "descripcion":"ATRESIA DE CUELLO VESICAL"
  },
  {
    "codigo":237767006,
    "descripcion":"ELEVACIÓN DE LA GLOBULINA FIJADORA DE CORTISOL"
  },
  {
    "codigo":72092001,
    "descripcion":"VASCULOPATÍA ARTERIOSCLERÓTICA"
  },
  {
    "codigo":235932003,
    "descripcion":"FILTRACIÓN DE CONDUCTO BILIAR"
  },
  {
    "codigo":203164005,
    "descripcion":"OSTEOMIELITIS AGUDA DE HÚMERO"
  },
  {
    "codigo":299633000,
    "descripcion":"ARTICULACIÓN DEL DEDO DEL PIE DOLOROSA DURANTE EL MOVIMIENTO"
  },
  {
    "codigo":234097001,
    "descripcion":"LINFEDEMA"
  },
  {
    "codigo":135793001,
    "descripcion":"MUDANZA"
  },
  {
    "codigo":4721006,
    "descripcion":"PROBLEMA BÁSICO PARA EL APRENDIZAJE MOTOR"
  },
  {
    "codigo":70257007,
    "descripcion":"CALASIA DEL ESFÍNTER ESOFÁGICO INFERIOR"
  },
  {
    "codigo":365169007,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA ENROSCAR UNA TAPA"
  },
  {
    "codigo":397937009,
    "descripcion":"VAPORIZADOR DE ANESTESIA VACÍO"
  },
  {
    "codigo":777474191000119103,
    "descripcion":"RETINOPATÍA NO PROLIFERATIVA DE AMBOS OJOS DEBIDA A ANEMIA DREPANOCÍTICA"
  },
  {
    "codigo":428870007,
    "descripcion":"ENFERMEDAD QUÍSTICA DE LA CAPA ADVENTICIA DE ARTERIA POPLÍTEA"
  },
  {
    "codigo":232262007,
    "descripcion":"COLESTEATOMA CONGÉNITO"
  },
  {
    "codigo":295963001,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE BECLAMIDA"
  },
  {
    "codigo":197659005,
    "descripcion":"ATROFIA DE RIÑÓN"
  },
  {
    "codigo":164891006,
    "descripcion":"ELECTROCARDIOGRAMA: TAQUICARDIA PAROXÍSTICA AURICULAR"
  },
  {
    "codigo":1051005,
    "descripcion":"HIPERPLASIA DE LAS CÉLULAS ALFA DE LOS ISLOTES PANCREÁTICOS CON EXCESO DE GASTRINA"
  },
  {
    "codigo":263195007,
    "descripcion":"FRACTURA PROXIMAL DEL RADIO"
  },
  {
    "codigo":294128002,
    "descripcion":"ALERGIA A BROMFENIRAMINA"
  },
  {
    "codigo":31984004,
    "descripcion":"FRACTURA NO EXPUESTA DE HUESOS DEL TRONCO"
  },
  {
    "codigo":1177029002,
    "descripcion":"UVEÍTIS INTERMEDIA SIFILÍTICA"
  },
  {
    "codigo":292293005,
    "descripcion":"REACCIÓN ADVERSA A INHIBIDOR DE MONOAMINOOXIDASA"
  },
  {
    "codigo":95685006,
    "descripcion":"RETINITIS GRANULOMATOSA"
  },
  {
    "codigo":62917007,
    "descripcion":"OLOR VAGINAL ANORMAL"
  },
  {
    "codigo":11823401000119102,
    "descripcion":"AMPOLLA TRAUMÁTICA DE BRAZO DERECHO"
  },
  {
    "codigo":421530001,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR EPINEFRINA"
  },
  {
    "codigo":716442002,
    "descripcion":"CAPAZ DE RECORDAR PERSONAS"
  },
  {
    "codigo":28314004,
    "descripcion":"ASFIXIA EN LACTANTE NACIDO VIVO"
  },
  {
    "codigo":126618004,
    "descripcion":"NEOPLASIA DE MÚSCULO DE LA CARA"
  },
  {
    "codigo":290458005,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR SEN"
  },
  {
    "codigo":93850006,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LABIOS MAYORES DE LA VULVA"
  },
  {
    "codigo":288623002,
    "descripcion":"INCAPAZ DE EMPLEAR LENGUAJE AUTOMÁTICO"
  },
  {
    "codigo":92015008,
    "descripcion":"NEOPLASIA BENIGNA DE VASO SANGUÍNEO DEL TRONCO"
  },
  {
    "codigo":254020001,
    "descripcion":"CRANEOSINOSTOSIS UNICORONAL"
  },
  {
    "codigo":26479009,
    "descripcion":"CANALICULITIS LAGRIMAL CRÓNICA"
  },
  {
    "codigo":57412004,
    "descripcion":"HEPATITIS VIRAL AGUDA"
  },
  {
    "codigo":286788008,
    "descripcion":"NIVEL NORMAL DE AGRESIVIDAD - RASGO DEL CARÁCTER"
  },
  {
    "codigo":284953002,
    "descripcion":"NO SE LAVA LUEGO DE IR AL BAÑO"
  },
  {
    "codigo":448793002,
    "descripcion":"VÁLVULA TRONCAL BICÚSPIDE"
  },
  {
    "codigo":1004014003,
    "descripcion":"TRASTORNO FETAL DEBIDO A TOMA DE MUESTRAS DE VELLOSIDADES CORIÓNICAS Y POSTERIOR A ELLA"
  },
  {
    "codigo":283118003,
    "descripcion":"AMPOLLA TRAUMÁTICA EN LA REGIÓN AURICULAR"
  },
  {
    "codigo":446958005,
    "descripcion":"POLIOMIELITIS PARALÍTICA AGUDA CAUSADA POR POLIOVIRUS HUMANO 1"
  },
  {
    "codigo":445123002,
    "descripcion":"UTILIZA CONVERSOR DE HABLA EN TEXTO"
  },
  {
    "codigo":281283002,
    "descripcion":"ESPÉCIMEN SIN HEMÓLISIS VISIBLE"
  },
  {
    "codigo":1295256001,
    "descripcion":"ICTERICIA NEONATAL DEBIDA A OBSTRUCCIÓN CONGÉNITA DE VÍA BILIAR"
  },
  {
    "codigo":248515009,
    "descripcion":"TUMORACIÓN EN BORDE PALPEBRAL"
  },
  {
    "codigo":838339009,
    "descripcion":"ENCEFALOCELE BASAL"
  },
  {
    "codigo":312216007,
    "descripcion":"MENINGITIS INFECCIOSA"
  },
  {
    "codigo":277613000,
    "descripcion":"LINFOMA T CUTÁNEO PERIFÉRICO"
  },
  {
    "codigo":1162349006,
    "descripcion":"OSTEOSARCOMA DE HUESO DE CLAVÍCULA"
  },
  {
    "codigo":408685007,
    "descripcion":"ENFERMEDAD POR VIRUS DE LA PARAINFLUENZA ASOCIADA CON LA ATENCIÓN MÉDICA"
  },
  {
    "codigo":210242000,
    "descripcion":"LESIÓN TRAUMÁTICA DE OVARIO CON HERIDA ABIERTA HACIA CAVIDAD ABDOMINAL"
  },
  {
    "codigo":308546005,
    "descripcion":"DISECCIÓN DE AORTA"
  },
  {
    "codigo":275778006,
    "descripcion":"BILIRRUBINA EN ORINA - HALLAZGO"
  },
  {
    "codigo":243010006,
    "descripcion":"LESIÓN POR BALA DE GOMA"
  },
  {
    "codigo":372247004,
    "descripcion":"ARTRITIS MICÓTICA"
  },
  {
    "codigo":304876001,
    "descripcion":"APEGO DEPENDIENTE"
  },
  {
    "codigo":110103009,
    "descripcion":"AVULSIÓN DE MUCOSA YUGAL"
  },
  {
    "codigo":403180003,
    "descripcion":"TATUAJE DECORATIVO DE LA PIEL"
  },
  {
    "codigo":1156844006,
    "descripcion":"UVEÍTIS DEBIDA A OLIGOARTRITIS IDIOPÁTICA JUVENIL POSITIVA PARA ANTICUERPOS ANTINUCLEARES DE INICIO PERSISTENTE"
  },
  {
    "codigo":73665001,
    "descripcion":"ENTERITIS ISQUÉMICA"
  },
  {
    "codigo":237505003,
    "descripcion":"HIPERTIROIDISMO APÁTICO"
  },
  {
    "codigo":40897007,
    "descripcion":"SORDERA OCUPACIONAL"
  },
  {
    "codigo":235670001,
    "descripcion":"OBSTRUCCIÓN DE ESTOMA GÁSTRICO"
  },
  {
    "codigo":71830006,
    "descripcion":"LESIÓN TRAUMÁTICA DE TOBILLO EN SUPINACIÓN-ADUCCIÓN, GRADO 2"
  },
  {
    "codigo":266603000,
    "descripcion":"SANGRADO RELACIONADO CON LA OVULACIÓN"
  },
  {
    "codigo":399510009,
    "descripcion":"HALLAZGO HISTOLÓGICO ACCIDENTAL DE TUMOR DE PRÓSTATA EN 5% O MENOS DEL TEJIDO RESECADO"
  },
  {
    "codigo":299371002,
    "descripcion":"MENISCO ESTABLE"
  },
  {
    "codigo":301206009,
    "descripcion":"RINOFARINGE NORMAL"
  },
  {
    "codigo":364907003,
    "descripcion":"CARACTERÍSTICAS DE LA UNIDAD MOTORA-HALLAZGO"
  },
  {
    "codigo":233835003,
    "descripcion":"INFARTO AGUDO DE MIOCARDIO DISEMINADO"
  },
  {
    "codigo":397675006,
    "descripcion":"DEMUESTRA CONOCIMIENTO DEL PROCESO DE CICATRIZACIÓN DE HERIDA"
  },
  {
    "codigo":201067006,
    "descripcion":"ESTRÍAS FISIOLÓGICAS"
  },
  {
    "codigo":789056000,
    "descripcion":"TUBERCULOSIS DE OÍDO INTERNO"
  },
  {
    "codigo":166464002,
    "descripcion":"ANDROSTENEDIONA SÉRICA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":461376004,
    "descripcion":"HIPOPLASIA CONGÉNITA DE AORTA TORACOABDOMINAL"
  },
  {
    "codigo":11825911000119106,
    "descripcion":"LACERACIÓN DE TENDÓN DE LA MUÑECA DERECHA"
  },
  {
    "codigo":10311000132100,
    "descripcion":"TODA LA MUCOSA DEL SEGMENTO COLÓNICO SE VISUALIZA SATISFACTORIAMENTE, SIN TINCIÓN RESIDUAL, PEQUEÑOS FRAGMENTOS DE HECES O LÍQUIDO OPACO"
  },
  {
    "codigo":232000008,
    "descripcion":"DERRAME COROIDEO"
  },
  {
    "codigo":721685001,
    "descripcion":"INFECCIÓN PARASITARIA QUE CAUSA COLITIS"
  },
  {
    "codigo":262933008,
    "descripcion":"LESIÓN TRAUMÁTICA DE CUELLO UTERINO"
  },
  {
    "codigo":295701008,
    "descripcion":"SOBREDOSIS DE METOTREXATO"
  },
  {
    "codigo":424938000,
    "descripcion":"CARCINOMA PULMONAR MACROCÍTICO, TNM ESTADIO 1"
  },
  {
    "codigo":64490002,
    "descripcion":"ANACATADÍDIMO"
  },
  {
    "codigo":293866006,
    "descripcion":"ALERGIA A PRIMIDONA"
  },
  {
    "codigo":128191000,
    "descripcion":"ENCEFALOMIELITIS DEBIDA A RUBÉOLA"
  },
  {
    "codigo":31722008,
    "descripcion":"TAQUICARDIA VENTRICULAR EN ENTORCHADO"
  },
  {
    "codigo":783551005,
    "descripcion":"SÍNDROME DE ICTIOSIS, BAJA ESTATURA, BRAQUIDACTILIA, MICROESFEROFAQUIA"
  },
  {
    "codigo":95423008,
    "descripcion":"OSTEOMIELITIS DEL CRÁNEO"
  },
  {
    "codigo":290196002,
    "descripcion":"INTOXICACIÓN POR ANÁLOGO DE MEPERIDINA"
  },
  {
    "codigo":93588002,
    "descripcion":"OSIFICACIÓN INCOMPLETA DE ISQUIÓN"
  },
  {
    "codigo":60820008,
    "descripcion":"INFECCIÓN CAUSADA POR FONSECAEA PEDROSOI"
  },
  {
    "codigo":716180009,
    "descripcion":"SÍNDROME DE ODONTOMA-DISFAGIA"
  },
  {
    "codigo":386665002,
    "descripcion":"REACCIÓN PUPILAR NORMAL"
  },
  {
    "codigo":124521008,
    "descripcion":"DEFICIENCIA DE ADENINA DESAMINASA"
  },
  {
    "codigo":253758001,
    "descripcion":"INCOMPETENCIA PALATOESOFÁGICA CONGÉNITA"
  },
  {
    "codigo":778046002,
    "descripcion":"SOMATOMAMOTROPINOMA"
  },
  {
    "codigo":712510007,
    "descripcion":"HEMORRAGIA INTESTINAL"
  },
  {
    "codigo":286526007,
    "descripcion":"CAPAZ DE MANTENER LA TEMPERATURA CORRECTA DE LOS ALIMENTOS"
  },
  {
    "codigo":284691000,
    "descripcion":"AUTOENUCLEACIÓN DE LOS OJOS"
  },
  {
    "codigo":1234963004,
    "descripcion":"TRASTORNO NEONATAL DEBIDO A LESIÓN TRAUMÁTICA DE CORDÓN UMBILICAL"
  },
  {
    "codigo":39871000087101,
    "descripcion":"HERIDA DE REGIÓN DE OJO IZQUIERDO POR MORDEDURA"
  },
  {
    "codigo":448531004,
    "descripcion":"GASES EN SANGRE ARTERIAL FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":34751000087103,
    "descripcion":"LACTIPLANTIBACILLUS PARAPLANTARUM O LACTIPLANTIBACILLUS PENTOSUS O LACTIPLANTIBACILLUS PLANTARUM"
  },
  {
    "codigo":47551000087104,
    "descripcion":"FRACTURA BIMALEOLAR DE TOBILLO DERECHO"
  },
  {
    "codigo":42431000087105,
    "descripcion":"LESIÓN TRAUMÁTICA DE LIGAMENTO LATERAL INTERNO DE RODILLA IZQUIERDA"
  },
  {
    "codigo":282856005,
    "descripcion":"NO SE MANTIENE EN BIPEDESTACIÓN"
  },
  {
    "codigo":248253003,
    "descripcion":"LA SANGRE NO COAGULA ADECUADAMENTE"
  },
  {
    "codigo":11828421000119102,
    "descripcion":"LACERACIÓN DE MÚSCULO CUÁDRICEPS FEMORAL DERECHO"
  },
  {
    "codigo":49810002,
    "descripcion":"CELULITIS DE HOMBRO"
  },
  {
    "codigo":15207003,
    "descripcion":"LEISHMANIASIS CUTÁNEA ZOONÓTICA"
  },
  {
    "codigo":1260391004,
    "descripcion":"DISTONÍA DEBIDA A LEUCODISTROFIA METACROMÁTICA"
  },
  {
    "codigo":703335004,
    "descripcion":"MALFORMACIÓN ARTERIOVENOSA DE MAXILAR SUPERIOR"
  },
  {
    "codigo":441191004,
    "descripcion":"ENFERMEDAD POR DEFICIENCIA HEREDITARIA MODERADA DE FACTOR IX SIN INHIBIDORES"
  },
  {
    "codigo":78908001,
    "descripcion":"ANEMIA HEMOLÍTICA NO ESFEROCÍTICA HEREDITARIA POR DISMINUCIÓN DE LA ACTIVIDAD DE ADENOSINA DESAMINASA"
  },
  {
    "codigo":275516004,
    "descripcion":"CARDIOMEGALIA DEBIDO A HIPERTENSIÓN"
  },
  {
    "codigo":1074721000000105,
    "descripcion":"INCAPAZ DE ASISTIR CON LA PREPARACIÓN DE COMIDAS"
  },
  {
    "codigo":208145002,
    "descripcion":"FRACTURA O RUPTURA DE LA PELVIS"
  },
  {
    "codigo":109841003,
    "descripcion":"CARCINOMA DE CÉLULAS HEPÁTICAS"
  },
  {
    "codigo":763366000,
    "descripcion":"SÍNDROME DE LEUCOENCEFALOPATÍA, ANOMALÍAS TALÁMICAS Y DEL TRONCO ENCEFÁLICO, CON NIVELES ELEVADOS DE LACTATO"
  },
  {
    "codigo":271846001,
    "descripcion":"SECRECIÓN DEFICIENTE DE ORINA"
  },
  {
    "codigo":75238000,
    "descripcion":"MUCOPOLISACARIDOSIS, MPS - III - C"
  },
  {
    "codigo":1254886004,
    "descripcion":"DERMATOSIS NEUTROFÍLICA FEBRIL AGUDA DE MANO"
  },
  {
    "codigo":239078004,
    "descripcion":"QUERATODERMIA PALMOPLANTAR PAPULOVERRUGOSA DE JAKAC-WOLF"
  },
  {
    "codigo":10655071000119103,
    "descripcion":"ÚLCERA ISQUÉMICA ATEROSCLERÓTICA DE TALÓN IZQUIERDO"
  },
  {
    "codigo":40635000,
    "descripcion":"CISTITIS CAUSADA POR PSEUDOMONAS"
  },
  {
    "codigo":1187515001,
    "descripcion":"DEFICIENCIA DE TRANSPORTADOR MITOCONDRIAL DE FOSFATO"
  },
  {
    "codigo":827067003,
    "descripcion":"RETRACCIÓN DE COÁGULO DE SANGRE"
  },
  {
    "codigo":237243004,
    "descripcion":"EMBARAZO BIOQUÍMICO"
  },
  {
    "codigo":1351355003,
    "descripcion":"DEFICIENCIA DE COMPLEJO MAYOR DE HISTOCOMPATIBILIDAD DEBIDA A MUTACIÓN DE TAP2"
  },
  {
    "codigo":38800000,
    "descripcion":"SINOVITIS SEROSA AGUDA"
  },
  {
    "codigo":300944002,
    "descripcion":"PERSONALIDAD VULNERABLE"
  },
  {
    "codigo":366480005,
    "descripcion":"REFLEJO ABDOMINAL - HALLAZGO"
  },
  {
    "codigo":102501003,
    "descripcion":"RECIÉN NACIDO DE SEXO MASCULINO SANO"
  },
  {
    "codigo":4197006,
    "descripcion":"EVALUACIÓN DE DISCAPACIDAD: ALTERACIÓN CLASE 5"
  },
  {
    "codigo":299109007,
    "descripcion":"ARTICULACIÓN DE DEDO DE LA MANO ESTABLE"
  },
  {
    "codigo":15707641000119102,
    "descripcion":"DEGENERACIÓN CALCÁREA DE CÓRNEA DE AMBOS OJOS"
  },
  {
    "codigo":428346000,
    "descripcion":"ALIVIO DE DOLOR MEDIANTE MEDICACIÓN"
  },
  {
    "codigo":264506002,
    "descripcion":"AVULSIÓN DE FIJACIÓN TIBIAL"
  },
  {
    "codigo":333151000119108,
    "descripcion":"GLAUCOMA FACOLÍTICO DE OJO DERECHO"
  },
  {
    "codigo":1149242008,
    "descripcion":"SOBREDOSIS DE NITRATO VASODILATADOR"
  },
  {
    "codigo":527001,
    "descripcion":"PROGRESIÓN FETAL ESPONTÁNEA, MÉTODO DE ROEDERER"
  },
  {
    "codigo":66063001,
    "descripcion":"ODONTODISPLASIA REGIONAL"
  },
  {
    "codigo":721423004,
    "descripcion":"FRACTURA DE NOVENA VÉRTEBRA DORSAL"
  },
  {
    "codigo":129764001,
    "descripcion":"CALCIFICACIÓN RADIOGRÁFICA DISTRIBUIDA EN FORMA DIFUSA"
  },
  {
    "codigo":64228003,
    "descripcion":"PARÁLISIS DEL DIAFRAGMA"
  },
  {
    "codigo":1418361000168101,
    "descripcion":"CARCINOMA EPIDERMOIDE QUERATINOCÍTICO DE PIEL"
  },
  {
    "codigo":717753000,
    "descripcion":"OBSTRUCCIÓN DE VÍA URINARIA INFERIOR FETAL DEBIDA A ATRESIA DE URETRA"
  },
  {
    "codigo":424676008,
    "descripcion":"TONO MUSCULAR AUMENTADO - LADO DERECHO MÁS ACENTUADO QUE EL IZQUIERDO"
  },
  {
    "codigo":816057000,
    "descripcion":"TUMORACIÓN DE MAMA CON RETRACCIÓN DE LA PIEL"
  },
  {
    "codigo":160697000,
    "descripcion":"MOVILIDAD, ADECUADA"
  },
  {
    "codigo":226233004,
    "descripcion":"DIETA CON CARNE HALAL"
  },
  {
    "codigo":293604009,
    "descripcion":"ALERGIA A ALFENTANILO"
  },
  {
    "codigo":95161002,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE URÉTER"
  },
  {
    "codigo":191630001,
    "descripcion":"TRASTORNO AFECTIVO BIPOLAR, EPISODIO ACTUAL DEPRESIVO, MODERADO"
  },
  {
    "codigo":93326002,
    "descripcion":"POSICIÓN ANÓMALA CONGÉNITA DE HÚMERO"
  },
  {
    "codigo":224398005,
    "descripcion":"DESEMPEÑO LABORAL LIMITADO"
  },
  {
    "codigo":124259004,
    "descripcion":"DEFICIENCIA DE SULFURO DE HIDRÓGENO ACETILTRANSFERASA"
  },
  {
    "codigo":714083007,
    "descripcion":"SEPSIS RECURRENTE POR SALMONELLA CONCOMITANTE CON INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":16746131000119105,
    "descripcion":"RETINOPATÍA NO PROLIFERATIVA MODERADA DE OJO IZQUIERDO DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":253496001,
    "descripcion":"ANOMALÍA DE EBSTEIN DE VÁLVULA AURICULOVENTRICULAR IZQUIERDA"
  },
  {
    "codigo":335661000119100,
    "descripcion":"ECTASIA DE CÓRNEA DERECHA"
  },
  {
    "codigo":56888007,
    "descripcion":"FRAGILIDAD CAPILAR AUMENTADA"
  },
  {
    "codigo":89656008,
    "descripcion":"MEATITIS URETRAL"
  },
  {
    "codigo":415501002,
    "descripcion":"SÍNDROME DE SCHWARTZ-MATSUO"
  },
  {
    "codigo":791000124107,
    "descripcion":"ACIDURIA 2-METIL-3-HIDROXIBUTÍRICA"
  },
  {
    "codigo":282594000,
    "descripcion":"CAPAZ DE BRINCAR CON LOS PIES EN FORMA ALTERNADA"
  },
  {
    "codigo":446434001,
    "descripcion":"QUISTE EPIDERMOIDE DE PIEL DE OREJA"
  },
  {
    "codigo":448269008,
    "descripcion":"LINFOMA DE CURVATURA MENOR DEL ESTÓMAGO"
  },
  {
    "codigo":53218004,
    "descripcion":"SENSACIÓN DE CHASQUIDO EN LA LARINGE"
  },
  {
    "codigo":249826004,
    "descripcion":"DEFORMIDAD EN VALGO DE SEGUNDO A QUINTO DEDOS DEL PIE"
  },
  {
    "codigo":1003490008,
    "descripcion":"SOSPECHA DE GLAUCOMA DE ÁNGULO CERRADO DE OJO IZQUIERDO"
  },
  {
    "codigo":444599008,
    "descripcion":"RELAJACIÓN DE PISO PÉLVICO"
  },
  {
    "codigo":18615009,
    "descripcion":"INSOLACIÓN"
  },
  {
    "codigo":247991009,
    "descripcion":"GENEROSIDAD EXCESIVA"
  },
  {
    "codigo":442764005,
    "descripcion":"INTOXICACIÓN CAUSADA POR BENCENO"
  },
  {
    "codigo":1260129000,
    "descripcion":"SÍNDROME NEURODEGENERATIVO DE NEUROPATÍA AXONAL SENSITIVO Y MOTORA Y DE ATROFIA ÓPTICA DE INICIO EN LA INFANCIA"
  },
  {
    "codigo":211553001,
    "descripcion":"LESIÓN TRAUMÁTICA CERRADA POR APLASTAMIENTO, AXILA"
  },
  {
    "codigo":47713000,
    "descripcion":"AUSENCIA CONGÉNITA DE HÚMERO"
  },
  {
    "codigo":440929004,
    "descripcion":"VIRUS SINCITIAL RESPIRATORIO DE TIPO A PRESENTE"
  },
  {
    "codigo":209718004,
    "descripcion":"SECCIÓN EXPUESTA DE LIGAMENTO SACROESPINOSO"
  },
  {
    "codigo":111414008,
    "descripcion":"CELULITIS DE LA VESÍCULA SEMINAL"
  },
  {
    "codigo":764939004,
    "descripcion":"FONDO ALBIPUNCTATUS"
  },
  {
    "codigo":76811005,
    "descripcion":"PROBLEMA CON FAMILIARES POLÍTICOS ANCIANOS"
  },
  {
    "codigo":238816001,
    "descripcion":"ERITEMA URTICANTE TÓXICO"
  },
  {
    "codigo":271584002,
    "descripcion":"MANOS FRÍAS"
  },
  {
    "codigo":304352004,
    "descripcion":"AMPLITUD DEL MOVIMIENTO DE LA COLUMNA VERTEBRAL LUMBAR, DISMINUIDA"
  },
  {
    "codigo":1287392004,
    "descripcion":"HERIDA POR ARMA DE FUEGO DE ANTEBRAZO"
  },
  {
    "codigo":402656007,
    "descripcion":"VASCULITIS URTICARIA"
  },
  {
    "codigo":366218007,
    "descripcion":"HALLAZGO RELACIONADO CON PERFUSIÓN ARTERIAL DE PIERNA"
  },
  {
    "codigo":300682007,
    "descripcion":"CAPAZ DE MANEJAR ACTIVIDADES FINANCIERAS PERSONALES"
  },
  {
    "codigo":202378008,
    "descripcion":"DERRAME DE ARTICULACIÓN INTERFALÁNGICA DISTAL DE DEDO DE LA MANO"
  },
  {
    "codigo":724831003,
    "descripcion":"ANGIOEDEMA FÍSICO"
  },
  {
    "codigo":167775005,
    "descripcion":"VOLUMEN DE SEMEN: SIN ESPÉCIMEN"
  },
  {
    "codigo":298847009,
    "descripcion":"SIN AMPLITUD ACTIVA DE CIRCUNDUCCIÓN DE HOMBRO"
  },
  {
    "codigo":297012003,
    "descripcion":"SOBREDOSIS DE CLOROTIAZIDA"
  },
  {
    "codigo":722996009,
    "descripcion":"MALFORMACIÓN CONGÉNITA DE SISTEMA NERVIOSO AUTÓNOMO"
  },
  {
    "codigo":295177004,
    "descripcion":"SOBREDOSIS DE DIHIDROCODEÍNA"
  },
  {
    "codigo":721161005,
    "descripcion":"QUISTE DE DUPLICACIÓN ESOFÁGICA"
  },
  {
    "codigo":33033006,
    "descripcion":"MIOGLOBINURIA DEL EJERCICIO"
  },
  {
    "codigo":229641005,
    "descripcion":"VOZ TRANSEXUAL"
  },
  {
    "codigo":1145310005,
    "descripcion":"CARA ANGOSTA"
  },
  {
    "codigo":94899001,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA LARINGE"
  },
  {
    "codigo":291507001,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR ESPIRAMICINA"
  },
  {
    "codigo":1089881000119100,
    "descripcion":"MUCOSA DE CRESTA ALVEOLAR RESIDUAL QUERATINIZADA MÍNIMA"
  },
  {
    "codigo":152921000119101,
    "descripcion":"DEPENDENCIA DE DISPOSITIVO RESPIRATORIO"
  },
  {
    "codigo":293721000119101,
    "descripcion":"INMUNIDAD CONTRA SARAMPIÓN, PAPERAS Y RUBÉOLA DETERMINADA POR SEROLOGÍA"
  },
  {
    "codigo":15720281000119101,
    "descripcion":"TRASTORNO DE CARTÍLAGO ARTICULAR DE MUÑECA DERECHA"
  },
  {
    "codigo":193203006,
    "descripcion":"NEUROPATÍA SÉRICA"
  },
  {
    "codigo":781192001,
    "descripcion":"CELULITIS DE HERIDA POSQUIRÚRGICA"
  },
  {
    "codigo":314201000119105,
    "descripcion":"MIOSITIS OSIFICANTE TRAUMÁTICA DE MANO IZQUIERDA"
  },
  {
    "codigo":971918681000119107,
    "descripcion":"INSUFICIENCIA RESPIRATORIA CRÓNICA POR APNEA OBSTRUCTIVA DEL SUEÑO"
  },
  {
    "codigo":11995481000119108,
    "descripcion":"DEHISCENCIA DE HERIDA DE MUÑÓN DE AMPUTACIÓN DE EXTREMIDAD SUPERIOR IZQUIERDA"
  },
  {
    "codigo":715656004,
    "descripcion":"APLASIA CONGÉNITA DE GLÁNDULA LAGRIMAL CONCOMITANTE CON APLASIA CONGÉNITA DE GLÁNDULA SALIVAL"
  },
  {
    "codigo":337241000119108,
    "descripcion":"ENTROPIÓN DE PÁRPADO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":93064005,
    "descripcion":"DUPLICACIÓN CONGÉNITA DE LA AORTA"
  },
  {
    "codigo":16731481000119108,
    "descripcion":"INFECCIÓN DE SONDA DE NEFROSTOMÍA"
  },
  {
    "codigo":355208009,
    "descripcion":"OSTEOCONDROSIS JUVENIL DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":334681000119108,
    "descripcion":"IRIDOSQUISIS DERECHA"
  },
  {
    "codigo":15676761000119109,
    "descripcion":"MIOSITIS DE ANTEBRAZO DERECHO"
  },
  {
    "codigo":316761000119109,
    "descripcion":"DOLOR EN ANTEBRAZO IZQUIERDO"
  },
  {
    "codigo":1077081000119108,
    "descripcion":"QUISTE ÓSEO DE FÉMUR DERECHO"
  },
  {
    "codigo":15707481000119109,
    "descripcion":"MIOSITIS OSIFICANTE TRAUMÁTICA DE HOMBROS BILATERALES"
  },
  {
    "codigo":123997000,
    "descripcion":"FRUCTOSA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":417074000,
    "descripcion":"DISFUNCIÓN SOMÁTICA DE CRÁNEO"
  },
  {
    "codigo":255069008,
    "descripcion":"CARCINOMA DE LABIO, CAVIDAD ORAL Y FARINGE"
  },
  {
    "codigo":10823931000119108,
    "descripcion":"FRACTURA EXPUESTA DE FALANGE DE DEDO MEÑIQUE IZQUIERDO"
  },
  {
    "codigo":713821003,
    "descripcion":"VÍCTIMA DE AGRESIÓN SEXUAL POR PERSONA CONVIVIENTE"
  },
  {
    "codigo":253234004,
    "descripcion":"HETEROCROMÍA CONGÉNITA DEL IRIS"
  },
  {
    "codigo":1269042005,
    "descripcion":"ASTROCITOMA PROTOPLÁSMICO PRIMARIO DE CEREBRO"
  },
  {
    "codigo":187698002,
    "descripcion":"NEOPLASIA MALIGNA DE ORIFICIO DE TROMPA DE EUSTAQUIO"
  },
  {
    "codigo":448007000,
    "descripcion":"DEFECTO DEL TABIQUE AURICULOVENTRICULAR ASOCIADO CON TETRALOGÍA DE FALLOT"
  },
  {
    "codigo":449842009,
    "descripcion":"SONDA NASOGÁSTRICA IN SITU"
  },
  {
    "codigo":87559001,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO DE CODO"
  },
  {
    "codigo":251399004,
    "descripcion":"TOLERANCIA A LA LACTOSA"
  },
  {
    "codigo":446172000,
    "descripcion":"INTENTO FALLIDO PARA DEJAR DE FUMAR"
  },
  {
    "codigo":282332003,
    "descripcion":"NO SE DETECTAN ANOMALÍAS - RESULTADO DEL EXAMEN"
  },
  {
    "codigo":249564009,
    "descripcion":"MATERIA FECAL PALPABLE EN INTESTINO"
  },
  {
    "codigo":247729006,
    "descripcion":"LAS PERSONAS PARECEN SER ACTORES DE UNA PELÍCULA"
  },
  {
    "codigo":213126000,
    "descripcion":"INFECCIÓN DE INJERTO DE HUESO"
  },
  {
    "codigo":870321008,
    "descripcion":"PARÁLISIS DE NERVIO OCULAR CAUSADA POR HERPES ZÓSTER"
  },
  {
    "codigo":409734004,
    "descripcion":"CLASIFICACIÓN INTERNACIONAL DE NEUROBLASTOMA: GRUPO CON HISTOLOGÍA FAVORABLE, PAC. >1,5 AÑOS Y < 5 AÑOS, CON NEUROBLASTOMA DIFERENCIADO (S\/ PREDOMINIO DE CÉL. DE SCHWANN EN EL ESTROMA), E ÍNDICE BAJO DE MITOSIS-CARIORREXIS"
  },
  {
    "codigo":82054006,
    "descripcion":"HIPEROSTOSIS INTERNA FRONTAL"
  },
  {
    "codigo":211291000,
    "descripcion":"LESIONES SUPERFICIALES MÚLTIPLES EN LA MUÑECA Y LA MANO"
  },
  {
    "codigo":735579001,
    "descripcion":"COMUNICACIÓN INTERAURICULAR RESIDUAL POSTERIOR A PROCEDIMIENTO"
  },
  {
    "codigo":49286008,
    "descripcion":"ESTRANGULACIÓN DE INTESTINO"
  },
  {
    "codigo":276827001,
    "descripcion":"GLIOMA MALIGNO DE MÉDULA ESPINAL"
  },
  {
    "codigo":14683004,
    "descripcion":"FIEBRE RECURRENTE TRANSMITIDA POR PIOJOS"
  },
  {
    "codigo":1259867005,
    "descripcion":"CEFALEA TARDÍA CAUSADA POR ALCOHOL"
  },
  {
    "codigo":702811005,
    "descripcion":"REACCIÓN MEDICAMENTOSA CON EOSINOFILIA Y SÍNTOMAS SISTÉMICOS CAUSADA POR RANELATO DE ESTRONCIO"
  },
  {
    "codigo":473435002,
    "descripcion":"FRACTURA VERTEBRAL SEGÚN EL SISTEMA DE CLASIFICACIÓN DE DOS COLUMNAS PARA FRACTURAS VERTEBRALES POR ESTALLIDO"
  },
  {
    "codigo":11835951000119105,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN METATARSOFALÁNGICA DE SEGUNDO A QUINTO DEDOS DE PIE DERECHO"
  },
  {
    "codigo":733744002,
    "descripcion":"MEJORÍA EN LA CAPACIDAD PARA UTILIZAR EL BAÑO DE MANERA INDEPENDIENTE"
  },
  {
    "codigo":45616003,
    "descripcion":"COLAPSO TRAQUEAL ADQUIRIDO"
  },
  {
    "codigo":209456004,
    "descripcion":"ESGUINCE DEL LIGAMENTO SEMILUNAR-PIRAMIDAL"
  },
  {
    "codigo":1290800009,
    "descripcion":"QUISTE SINOVIAL DE PIE"
  },
  {
    "codigo":76549002,
    "descripcion":"LINFANGITIS AGUDA DE LA REGIÓN TEMPORAL"
  },
  {
    "codigo":11013005,
    "descripcion":"GLOMERULONEFRITIS ASOCIADA A LUPUS ERITEMATOSO SISTÉMICO, CLASE VI DE LA OMS"
  },
  {
    "codigo":109317007,
    "descripcion":"OSTEOMIELITIS CRÓNICA DE HUESO CIGOMÁTICO"
  },
  {
    "codigo":240389009,
    "descripcion":"MELIOIDOSIS SEPTICÉMICA"
  },
  {
    "codigo":402394004,
    "descripcion":"URTICARIA CAUSADA POR SALICILATO"
  },
  {
    "codigo":304090004,
    "descripcion":"ÉMBOLO DE INJERTO VASCULAR"
  },
  {
    "codigo":369626005,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA DE URÉTER Y RIÑÓN, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":238554007,
    "descripcion":"PATRÓN EN DELANTAL DE ECCEMA VESICULAR DE LA MANO"
  },
  {
    "codigo":367151000119109,
    "descripcion":"ESTENOSIS DE URÉTER CONCOMITANTE CON VASO QUE CRUZA Y DEBIDA A ÉL"
  },
  {
    "codigo":1156058009,
    "descripcion":"FENOBARBITAL SÉRICO DENTRO DEL RANGO TERAPÉUTICO"
  },
  {
    "codigo":105647006,
    "descripcion":"ENFERMEDAD CAUSADA POR VAHLKAMPFIIDAE"
  },
  {
    "codigo":203951008,
    "descripcion":"ESPINA BÍFIDA SACRA CON HIDROCEFALIA - CERRADA"
  },
  {
    "codigo":7343008,
    "descripcion":"LIPARITOSIS"
  },
  {
    "codigo":38276004,
    "descripcion":"MOTIVOS DE CONSULTA MÚLTIPLES"
  },
  {
    "codigo":71044004,
    "descripcion":"CATARATA ASOCIADA CON RADIACIÓN"
  },
  {
    "codigo":726404007,
    "descripcion":"CATARATA CORONARIA RELACIONADA CON LA EDAD"
  },
  {
    "codigo":298585000,
    "descripcion":"COLUMNA VERTEBRAL DORSAL TIBIA"
  },
  {
    "codigo":365956009,
    "descripcion":"HALLAZGO RELACIONADO CON LA ORIENTACIÓN SEXUAL"
  },
  {
    "codigo":202116008,
    "descripcion":"DESGARRO COMPLETO ANTIGUO DE LIGAMENTO LATERAL EXTERNO DE RODILLA"
  },
  {
    "codigo":396889005,
    "descripcion":"TUMOR QUE INVADE MÁS ALLÁ DE LA CÁPSULA PANCREÁTICA HACIA GRANDES VASOS ADYACENTES (PÁNCREAS ENDOCRINO)"
  },
  {
    "codigo":429657008,
    "descripcion":"CONTRACTURA DE LA MUÑECA EN PRONACIÓN"
  },
  {
    "codigo":198446005,
    "descripcion":"INFERTILIDAD ANOVULATORIA SECUNDARIA"
  },
  {
    "codigo":460590006,
    "descripcion":"ANILLO VASCULAR CON CAYADO AÓRTICO DERECHO Y LIGAMENTO ARTERIOSO IZQUIERDO CON ARTERIA SUBCLAVIA IZQUIERDA RETROESOFÁGICA ANÓMALA"
  },
  {
    "codigo":67374007,
    "descripcion":"ARTICULACIÓN INESTABLE"
  },
  {
    "codigo":131075000,
    "descripcion":"NIVEL DE ANDRÓGENO POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":296750009,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE CEFPIROMA"
  },
  {
    "codigo":294915005,
    "descripcion":"ALERGIA A YODÓFORO"
  },
  {
    "codigo":293080003,
    "descripcion":"REACCIÓN ADVERSA A FÁRMACO ANTILEPROSO"
  },
  {
    "codigo":30936004,
    "descripcion":"ENTESOPATÍA DE LA REGIÓN DE LA CADERA"
  },
  {
    "codigo":94637003,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA PUNTA Y EL BORDE LATERAL DE LA LENGUA"
  },
  {
    "codigo":127405009,
    "descripcion":"HALLAZGO EN LA PRODUCCIÓN DE NEUTRÓFILOS"
  },
  {
    "codigo":92802003,
    "descripcion":"CARCINOMA IN SITU DE LA VULVA"
  },
  {
    "codigo":289410005,
    "descripcion":"FONTANELA PALPABLE A TRAVÉS DE LA VAGINA"
  },
  {
    "codigo":254807000,
    "descripcion":"NEVO AZUL CUTÁNEO COMÚN"
  },
  {
    "codigo":1303383002,
    "descripcion":"FRACTURA DE OLÉCRANON DERECHO"
  },
  {
    "codigo":189271002,
    "descripcion":"CARCINOMA IN SITU DE LA CAVIDAD TIMPÁNICA"
  },
  {
    "codigo":285740000,
    "descripcion":"LESIÓN DE ARTERIA DE LOS DEDOS DE LA MANO"
  },
  {
    "codigo":56364004,
    "descripcion":"HAMARTOMA FIBROSO DE LA INFANCIA"
  },
  {
    "codigo":414977001,
    "descripcion":"ORGANISMO NO IDENTIFICADO, ENVIADO A LABORATORIO DE REFERENCIA PARA SU IDENTIFICACIÓN"
  },
  {
    "codigo":218369003,
    "descripcion":"REACCIÓN ADVERSA A QUINIOFÓN"
  },
  {
    "codigo":251137005,
    "descripcion":"TRAZADO DIGITÁLICO DEL ELECTROCARDIOGRAMA"
  },
  {
    "codigo":283905005,
    "descripcion":"AVULSIÓN DE RIÑÓN"
  },
  {
    "codigo":447745006,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN EN RODILLA"
  },
  {
    "codigo":343191000119102,
    "descripcion":"CATARATAS DE AMBOS OJOS DEBIDAS A TRAUMATISMO Y POSTERIORES A ÉL"
  },
  {
    "codigo":52694000,
    "descripcion":"FRACTURA CERRADA DE SITIOS MÚLTIPLES DE METACARPO"
  },
  {
    "codigo":15934461000119109,
    "descripcion":"COXA VALGA CONGÉNITA DE AMBAS CADERAS"
  },
  {
    "codigo":216534005,
    "descripcion":"INTOXICACIÓN ACCIDENTAL CAUSADA POR LORAZEPAM"
  },
  {
    "codigo":282070006,
    "descripcion":"SECCIÓN DE ÍLEON"
  },
  {
    "codigo":118230007,
    "descripcion":"HALLAZGO RELACIONADO CON LA AUDICIÓN"
  },
  {
    "codigo":83627000,
    "descripcion":"DERMATITIS FOTOTÓXICA MEDICAMENTOSA"
  },
  {
    "codigo":708054009,
    "descripcion":"NEOPLASIA MALIGNA DESPUÉS DE TRATAMIENTO INMUNOSUPRESOR"
  },
  {
    "codigo":249302009,
    "descripcion":"MEATO URETRAL - HALLAZGO"
  },
  {
    "codigo":1197739005,
    "descripcion":"FIBROSIS DE HÍGADO DEBIDA E ESTEATOSIS DE HÍGADO ASOCIADA A FUNCIÓN METABÓLICA"
  },
  {
    "codigo":247467008,
    "descripcion":"COMEDÓN"
  },
  {
    "codigo":313003009,
    "descripcion":"DISTROFIA DE BASTONES"
  },
  {
    "codigo":1080471000119105,
    "descripcion":"CARCINOMA DE CÉLULAS GRANDES PRIMARIO DE LÓBULO SUPERIOR DE PULMÓN IZQUIERDO"
  },
  {
    "codigo":868224003,
    "descripcion":"INFARTO AGUDO DE MIOCARDIO CON ELEVACIÓN DEL SEGMENTO ST DEBIDO A OCLUSIÓN DE RAMA MARGINAL DE ARTERIA CORONARIA DERECHA"
  },
  {
    "codigo":1163136004,
    "descripcion":"INFECCIÓN BACTERIANA DE NERVIO PERIFÉRICO"
  },
  {
    "codigo":15989911000119106,
    "descripcion":"ESTRÍAS ANGIOIDES DE COROIDES DE OJO DERECHO"
  },
  {
    "codigo":49024004,
    "descripcion":"SÍNDROME DE TRISOMÍA PARCIAL 4P"
  },
  {
    "codigo":442240008,
    "descripcion":"ARTERIOSCLEROSIS EN INJERTO-PUENTE NO AUTÓLOGO EN ARTERIA CORONARIA"
  },
  {
    "codigo":702549002,
    "descripcion":"MIALGIA MEDIADA CENTRALMENTE"
  },
  {
    "codigo":1259605002,
    "descripcion":"COREA DEBIDA A NEUROFERRITINOPATÍA"
  },
  {
    "codigo":276565004,
    "descripcion":"BOCIO NEONATAL"
  },
  {
    "codigo":768085005,
    "descripcion":"HERNIA FEMORAL IZQUIERDA RECURRENTE CON GANGRENA"
  },
  {
    "codigo":1193736004,
    "descripcion":"INFLAMACIÓN INTESTINAL POR STAPHYLOCOCCUS AUREUS METICILINORRESISTENTE"
  },
  {
    "codigo":241962000,
    "descripcion":"URTICARIA ANGIOEDEMATOSA AGRAVADA POR QUÍMICOS"
  },
  {
    "codigo":11785521000119102,
    "descripcion":"ABRASIÓN DE PIEL DE DEDO ANULAR DERECHO"
  },
  {
    "codigo":274730004,
    "descripcion":"DEFECTO DE LLENADO VESICAL"
  },
  {
    "codigo":373034006,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM HASSIACUM"
  },
  {
    "codigo":307498007,
    "descripcion":"POSOPERATORIO DE DEPRESIÓN DE LA PUNTA DE LA NARIZ"
  },
  {
    "codigo":403967000,
    "descripcion":"HEMANGIOMA FUSOCELULAR"
  },
  {
    "codigo":209194009,
    "descripcion":"SUBLUXACIÓN VERTEBRAL EXPUESTA CON LESIÓN MEDULAR ANTERIOR A NIVEL LUMBAR"
  },
  {
    "codigo":305663001,
    "descripcion":"ATENDIDO POR MÉDICO ESPECIALISTA EN TÓRAX"
  },
  {
    "codigo":371199008,
    "descripcion":"AUSENCIA CONGÉNITA DE MANO"
  },
  {
    "codigo":698879009,
    "descripcion":"INGESTIÓN DE ALIMENTO NO SEGURO"
  },
  {
    "codigo":762580003,
    "descripcion":"URANOSQUISIS CON LABIO LEPORINO BILATERAL Y FISURA ALVEOLAR BILATERAL"
  },
  {
    "codigo":29491004,
    "descripcion":"HIPOTROPÍA"
  },
  {
    "codigo":860884007,
    "descripcion":"NEUROPATÍA ÓPTICA ISQUÉMICA NO ARTERÍTICA IDIOPÁTICA POSTERIOR"
  },
  {
    "codigo":8916007,
    "descripcion":"MIOCARDITIS POR PROTOZOARIOS"
  },
  {
    "codigo":402132009,
    "descripcion":"CANDIDIOSIS SISTÉMICA CON COMPROMISO CUTÁNEO"
  },
  {
    "codigo":301993001,
    "descripcion":"CAPAZ DE ACEPTAR BASE DE APOYO"
  },
  {
    "codigo":269225000,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DE ESCROTO Y TESTÍCULO"
  },
  {
    "codigo":7081006,
    "descripcion":"REACCIÓN A TRANSFUSIÓN CAUSADA POR CONTAMINANTE EN SANGRE"
  },
  {
    "codigo":1186729007,
    "descripcion":"SÍNDROME DE DISCAPACIDAD INTELECTUAL, ANOMALÍAS CARDÍACAS, TALLA BAJA Y LAXITUD ARTICULAR"
  },
  {
    "codigo":236457006,
    "descripcion":"NEFROPATÍA CRÓNICA POR MERCURIO"
  },
  {
    "codigo":300158001,
    "descripcion":"REFLEJO LUMINOSO DE LA MEMBRANA TIMPÁNICA NORMAL"
  },
  {
    "codigo":234622003,
    "descripcion":"DEFICIENCIA DEL FACTOR H"
  },
  {
    "codigo":267390005,
    "descripcion":"HIPOPITUITARISMO POSTINFARTO"
  },
  {
    "codigo":365694007,
    "descripcion":"PRESENCIA DE HUEVOS, QUISTES Y PARÁSITOS - HALLAZGO"
  },
  {
    "codigo":1217662008,
    "descripcion":"NISTAGMO DISYUNTIVO PENDULAR"
  },
  {
    "codigo":462163003,
    "descripcion":"DERRAME PLEURAL FETAL"
  },
  {
    "codigo":36179005,
    "descripcion":"SÍNDROME DE DÉFICIT NEUROLÓGICO ISQUÉMICO REVERSIBLE"
  },
  {
    "codigo":298323006,
    "descripcion":"PRUEBA DEDO-DEDO, NORMAL"
  },
  {
    "codigo":396627007,
    "descripcion":"MARGEN QUIRÚRGICO NO COMPROMETIDO POR CARCINOMA IN SITU"
  },
  {
    "codigo":165416002,
    "descripcion":"HEMATÓCRITO FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":65277001,
    "descripcion":"AMINOACIDURIA POR IMIDAZOL"
  },
  {
    "codigo":198184009,
    "descripcion":"MIOMETRITIS SUBAGUDA"
  },
  {
    "codigo":1179389003,
    "descripcion":"ADENOCARCINOMA PARAGANGLIONAR"
  },
  {
    "codigo":16238181000119101,
    "descripcion":"TRASTORNO DEPRESIVO CAUSADO POR ANFETAMINA"
  },
  {
    "codigo":720637005,
    "descripcion":"ENFERMEDAD DE CHARCOT-MARIE-TOOTH TIPO 2H"
  },
  {
    "codigo":391122001,
    "descripcion":"PRUEBA DE REVERSIBILIDAD A CORTICOSTEROIDES: POSITIVA"
  },
  {
    "codigo":128978002,
    "descripcion":"ESTADO DEL PACIENTE LUEGO DEL EJERCICIO"
  },
  {
    "codigo":784338005,
    "descripcion":"TRASTORNO DEBIDO A LESIÓN DE NERVIO DE MIEMBRO INFERIOR Y POSTERIOR A ELLA"
  },
  {
    "codigo":292818007,
    "descripcion":"REACCIÓN ADVERSA AL ECONAZOL"
  },
  {
    "codigo":127143003,
    "descripcion":"LINFADENOPATÍA INTESTINAL"
  },
  {
    "codigo":94375005,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL LÓBULO INFERIOR IZQUIERDO DEL PULMÓN"
  },
  {
    "codigo":225447006,
    "descripcion":"REAPARICIÓN DE PENSAMIENTOS ANTIGUOS"
  },
  {
    "codigo":192679007,
    "descripcion":"MENINGITIS NO PIÓGENA"
  },
  {
    "codigo":782503008,
    "descripcion":"HERNIA FEMORAL RECIDIVANTE CON GANGRENA"
  },
  {
    "codigo":715132002,
    "descripcion":"INCAPAZ DE PASAR DE LA SILLA AL INODORO"
  },
  {
    "codigo":345701000119106,
    "descripcion":"GLAUCOMA DE ÁNGULO CERRADO INTERMITENTE BILATERAL"
  },
  {
    "codigo":289148009,
    "descripcion":"ALIMENTACIÓN DEL LACTANTE, NORMAL"
  },
  {
    "codigo":713297001,
    "descripcion":"CANDIDIASIS DE ESÓFAGO CONCOMITANTE CON INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":16047871000119101,
    "descripcion":"ARTRITIS INFECCIOSA DE ARTICULACIÓN DE TOBILLO DERECHO CAUSADA POR VIRUS"
  },
  {
    "codigo":11814501000119108,
    "descripcion":"RUPTURA TRAUMÁTICA DE LIGAMENTO COLATERAL DE ARTICULACIÓN DE DEDO MEDIO DE MANO IZQUIERDA"
  },
  {
    "codigo":1335889008,
    "descripcion":"HEMORRAGIA DE PARTES BLANDAS"
  },
  {
    "codigo":449318001,
    "descripcion":"LINFOMA NO HODGKIN DE PRÓSTATA"
  },
  {
    "codigo":187174008,
    "descripcion":"ESTRONGILOIDIASIS INTESTINAL"
  },
  {
    "codigo":185339001,
    "descripcion":"ENCUENTRO FALLIDO - SE DEJÓ MENSAJE A CONVIVIENTE"
  },
  {
    "codigo":1268518009,
    "descripcion":"CARCINOMA NEUROENDOCRINO MICROCÍTICO PRIMARIO DE VEJIGA"
  },
  {
    "codigo":283643005,
    "descripcion":"HERIDA POR PINCHAZO DE AGUJA EN LA PLANTA DEL PIE"
  },
  {
    "codigo":707792000,
    "descripcion":"GINGIVITIS ULCEROSA NECROSANTE"
  },
  {
    "codigo":773328002,
    "descripcion":"PANICULITIS INFANTIL CON UVEÍTIS Y GRANULOMATOSIS SISTÉMICA"
  },
  {
    "codigo":1363152003,
    "descripcion":"ASTILLA EN HOMBRO"
  },
  {
    "codigo":10641151000119106,
    "descripcion":"ÚLCERA CRÓNICA DE PIERNA IZQUIERDA"
  },
  {
    "codigo":1197477000,
    "descripcion":"INMUNODEFICIENCIA COMBINADA POR DEFICIENCIA DE LRBA"
  },
  {
    "codigo":15693721000119101,
    "descripcion":"QUERATITIS DE OJO DERECHO CAUSADA POR HONGO"
  },
  {
    "codigo":17829005,
    "descripcion":"ENDOMETRIOSIS DEL OMBLIGO"
  },
  {
    "codigo":116133005,
    "descripcion":"AGAMMAGLOBULINEMIA CONGÉNITA"
  },
  {
    "codigo":771493007,
    "descripcion":"FRACTURAS QUE COMPROMETEN REGIONES MÚLTIPLES DE LA EXTREMIDAD SUPERIOR IZQUIERDA"
  },
  {
    "codigo":292761000119102,
    "descripcion":"PARÁLISIS TARDÍA DEL NERVIO CUBITAL IZQUIERDO"
  },
  {
    "codigo":441978001,
    "descripcion":"RINITIS ALÉRGICA DEBIDA A ALIMENTOS"
  },
  {
    "codigo":212602006,
    "descripcion":"INTOXICACIÓN POR IBUPROFENO"
  },
  {
    "codigo":407375002,
    "descripcion":"TRANSEXUAL EN QUIEN SE REALIZÓ EL CAMBIO DE SEXO QUIRÚRGICAMENTE"
  },
  {
    "codigo":767823004,
    "descripcion":"HERNIA INGUINAL IZQUIERDA OBSTRUIDA CON GANGRENA"
  },
  {
    "codigo":1193807005,
    "descripcion":"INFLAMACIÓN EOSINOFÍLICA INTESTINAL CAUSADA POR ANCYLOSTOMA CANINUM"
  },
  {
    "codigo":1259343005,
    "descripcion":"CARCINOMA PRIMARIO DE GLÁNDULA SUBLINGUAL"
  },
  {
    "codigo":276303005,
    "descripcion":"PREOCUPACIÓN POR LA MUERTE"
  },
  {
    "codigo":700452000,
    "descripcion":"CAPAZ DE PARTICIPAR EN UNA CONSULTA DE TELEMEDICINA"
  },
  {
    "codigo":866127009,
    "descripcion":"MIELITIS CAUSADA POR PLASMODIUM"
  },
  {
    "codigo":241700002,
    "descripcion":"RESPIRACIÓN ESPONTÁNEA"
  },
  {
    "codigo":733220003,
    "descripcion":"CONTUSIÓN DE REGIÓN SUPERFICIAL DE PELVIS"
  },
  {
    "codigo":208932000,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE LA ARTICULACIÓN FEMORORROTULIANA"
  },
  {
    "codigo":307236005,
    "descripcion":"ILEOSTOMÍA CON ALTO DÉBITO"
  },
  {
    "codigo":16594841000119106,
    "descripcion":"NEUROMA ACÚSTICO DE NERVIO VESTIBULAR DERECHO"
  },
  {
    "codigo":77860008,
    "descripcion":"ALTERACIÓN DE CUERNO POSTERIOR DE MENISCO EXTERNO"
  },
  {
    "codigo":239865003,
    "descripcion":"ARTROSIS DE LA ARTICULACIÓN ACROMIOCLAVICULAR"
  },
  {
    "codigo":698617004,
    "descripcion":"FRACTURA NO EXPUESTA DE CALOTA CRANEAL CON CONMOCIÓN"
  },
  {
    "codigo":403705004,
    "descripcion":"DERMATOSIS POR URETEROSTOMÍA"
  },
  {
    "codigo":762318002,
    "descripcion":"TRASTORNO DEL DESARROLLO DEL LENGUAJE CONCOMITANTE CON ALTERACIÓN DEL LENGUAJE EXPRESIVO"
  },
  {
    "codigo":205262003,
    "descripcion":"MACRODACTILIA DE DEDOS DE LA MANO - TUMOR GRASO EN NERVIO"
  },
  {
    "codigo":8654005,
    "descripcion":"DISPLASIA ECTODÉRMICA"
  },
  {
    "codigo":238030005,
    "descripcion":"LEUCODISTROFIA DE CÉLULAS GLOBOIDES, DE COMIENZO TEMPRANO"
  },
  {
    "codigo":39221000146103,
    "descripcion":"TRASTORNO DEL SUEÑO DEBIDO A DEPENDENCIA DE ESTIMULANTE"
  },
  {
    "codigo":400035000,
    "descripcion":"HAMARTOMA DE APARATO SUDORÍPARO APOCRINO"
  },
  {
    "codigo":39587000,
    "descripcion":"POSICIÓN MENTOILÍACA IZQUIERDA TRANSVERSA"
  },
  {
    "codigo":170659001,
    "descripcion":"USO DE ESTEROIDES INHALATORIOS"
  },
  {
    "codigo":301731006,
    "descripcion":"CAPAZ DE REALIZAR ACTIVIDADES DE TALLER"
  },
  {
    "codigo":365432002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CONSISTENCIA DE LA ORINA"
  },
  {
    "codigo":234360003,
    "descripcion":"ANEMIA DEL VEGANO"
  },
  {
    "codigo":103288004,
    "descripcion":"VÉRTIGO VERTICAL"
  },
  {
    "codigo":168824004,
    "descripcion":"TRAGO DE BARIO ANORMAL"
  },
  {
    "codigo":430968008,
    "descripcion":"DOLOR EN PERINEO MASCULINO"
  },
  {
    "codigo":4984008,
    "descripcion":"ANEMIA MICROCÍTICA NORMOCRÓMICA"
  },
  {
    "codigo":299896009,
    "descripcion":"RESPUESTA PLANTAR IZQUIERDA AUSENTE"
  },
  {
    "codigo":298061003,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE CABEZA Y CUELLO"
  },
  {
    "codigo":102451000119107,
    "descripcion":"BLOQUEO AURICULOVENTRICULAR COMPLETO COMO COMPLICACIÓN DE ABLACIÓN DE NÓDULO AURICULOVENTRICULAR"
  },
  {
    "codigo":199757009,
    "descripcion":"TRABAJO DE PARTO OBSTRUIDO POR PELVIS ÓSEA"
  },
  {
    "codigo":296226006,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE CLORPROMAZINA"
  },
  {
    "codigo":230690007,
    "descripcion":"ACCIDENTE CEREBROVASCULAR"
  },
  {
    "codigo":1344802008,
    "descripcion":"OSTEOCONDROPATÍA DE RADIO"
  },
  {
    "codigo":722210007,
    "descripcion":"ENANISMO PARASTREMÁTICO"
  },
  {
    "codigo":294391006,
    "descripcion":"ALERGIA A PRIMAQUINA"
  },
  {
    "codigo":423628002,
    "descripcion":"NEUROPATÍA AGUDA POR HERPES ZÓSTER"
  },
  {
    "codigo":292556003,
    "descripcion":"REACCIÓN ADVERSA A FÁRMACO ESTIMULANTE RESPIRATORIO"
  },
  {
    "codigo":390860003,
    "descripcion":"VELOCIDAD DE FLUJO ESPIRATORIO PICO: TÉCNICA ACEPTABLE"
  },
  {
    "codigo":126881002,
    "descripcion":"NEOPLASIA DE LA PELVIS RENAL"
  },
  {
    "codigo":94113004,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE TESTÍCULO NO DESCENDIDO"
  },
  {
    "codigo":290721006,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR HIDROXIUREA"
  },
  {
    "codigo":321741000119108,
    "descripcion":"ARTRITIS ESTAFILOCÓCICA DE MANO DERECHA"
  },
  {
    "codigo":419958000,
    "descripcion":"NEOPLASIA BENIGNA DE LA REGIÓN BUCAL"
  },
  {
    "codigo":1306529009,
    "descripcion":"CARCINOMA IN SITU DE CUADRANTE INFERIOR INTERNO DE MAMA"
  },
  {
    "codigo":288886005,
    "descripcion":"COME"
  },
  {
    "codigo":714870005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA MANTENER LA POSICIÓN RECLINADA"
  },
  {
    "codigo":713035000,
    "descripcion":"DISECCIÓN DE ARTERIA PRECEREBRAL"
  },
  {
    "codigo":24907000,
    "descripcion":"ENFERMEDAD CAUSADA POR LENTIVIRUS"
  },
  {
    "codigo":92278008,
    "descripcion":"NEOPLASIA BENIGNA DE LA PLEURA PARIETAL"
  },
  {
    "codigo":254283009,
    "descripcion":"MOSAICISMO - LÍNEAS CON DIVERSOS NÚMEROS DE CROMOSOMAS X"
  },
  {
    "codigo":23072002,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE MUÑECA SIN INFECCIÓN"
  },
  {
    "codigo":86773000,
    "descripcion":"LARINGITIS EDEMATOSA"
  },
  {
    "codigo":21237001,
    "descripcion":"ATROFIA URETRAL POSTMENOPÁUSICA"
  },
  {
    "codigo":285216009,
    "descripcion":"LIBERACIÓN DE RECUERDOS TRAUMÁTICOS"
  },
  {
    "codigo":840437006,
    "descripcion":"DISECCIÓN DE MÚLTIPLES ARTERIAS CEREBRALES"
  },
  {
    "codigo":281546001,
    "descripcion":"RUPTURA DE TENDÓN DE TRONCO"
  },
  {
    "codigo":1297354002,
    "descripcion":"DISPLASIA CONGÉNITA DE ARTICULACIÓN DE RODILLA DERECHA"
  },
  {
    "codigo":248778003,
    "descripcion":"ERECCIÓN MUY GRANDE"
  },
  {
    "codigo":445386003,
    "descripcion":"DOLOR A LA PALPACIÓN DE LA REGIÓN PERIUMBILICAL"
  },
  {
    "codigo":283381009,
    "descripcion":"LACERACIÓN DE LOS GENITALES"
  },
  {
    "codigo":707530009,
    "descripcion":"HAMARTOMA QUÍSTICO DE PULMÓN Y RIÑÓN"
  },
  {
    "codigo":17567001,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA ARTERIA HEPÁTICA"
  },
  {
    "codigo":1197215004,
    "descripcion":"HOLOPROSENCEFALIA MICROFORMA"
  },
  {
    "codigo":246943004,
    "descripcion":"ANILLO CORNEAL INMUNOLÓGICO"
  },
  {
    "codigo":15732002,
    "descripcion":"TRASTORNO SECUNDARIO DEL SENTIDO DEL GUSTO"
  },
  {
    "codigo":441716003,
    "descripcion":"PSICOSIS INFANTIL RESIDUAL"
  },
  {
    "codigo":48500005,
    "descripcion":"TRASTORNO DELIRANTE"
  },
  {
    "codigo":703860006,
    "descripcion":"PICHIA KUDRIAVZEVII O CANDIDA INCONSPICUA O CANDIDA LAMBICA"
  },
  {
    "codigo":13897001,
    "descripcion":"BLOQUEO RETICULOENDOTELIAL"
  },
  {
    "codigo":308809002,
    "descripcion":"SITUACIÓN DEL INFORME POSTMORTEM DEL FORENSE"
  },
  {
    "codigo":104961000119108,
    "descripcion":"ISQUEMIA DE RETINA DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":1259081008,
    "descripcion":"TRASTORNO AUTONÓMICO DEBIDO A ENFERMEDAD PRIÓNICA"
  },
  {
    "codigo":77598002,
    "descripcion":"FRACTURA EXPUESTA DEL ACETÁBULO"
  },
  {
    "codigo":732958004,
    "descripcion":"SÍNDROME DE PARAPLEJÍA ESPÁSTICA CON PUBERTAD PRECOZ"
  },
  {
    "codigo":110366005,
    "descripcion":"NIVEL ESTROGÉNICO NORMAL"
  },
  {
    "codigo":1088001000119109,
    "descripcion":"OTITIS EXTERNA AGUDA DE CONTACTO DE CONDUCTO AUDITIVO EXTERNO IZQUIERDO"
  },
  {
    "codigo":12062007,
    "descripcion":"CELULITIS PÉLVICA PUERPERAL"
  },
  {
    "codigo":403443000,
    "descripcion":"ENFERMEDAD DE BEHÇET CON COMPROMISO DE LA MUCOSA BUCAL"
  },
  {
    "codigo":10227000,
    "descripcion":"INFECCIÓN HERPÉTICA DE PENE"
  },
  {
    "codigo":1290014005,
    "descripcion":"TUMOR NEUROENDOCRINO BIEN DIFERENCIADO PRIMARIO DE VÍA BILIAR"
  },
  {
    "codigo":763891005,
    "descripcion":"DISPLASIA HEPÁTICA, PANCREÁTICA Y RENAL"
  },
  {
    "codigo":8392000,
    "descripcion":"NO FUMADOR"
  },
  {
    "codigo":237768001,
    "descripcion":"DISMINUCIÓN DE LA GLOBULINA FIJADORA DE CORTISOL"
  },
  {
    "codigo":205000002,
    "descripcion":"ESTENOSIS DE CUELLO DE VEJIGA URINARIA"
  },
  {
    "codigo":301469002,
    "descripcion":"DIARREA ASOCIADA CON ANTIBIÓTICOS"
  },
  {
    "codigo":203165006,
    "descripcion":"OSTEOMIELITIS AGUDA DE RADIO"
  },
  {
    "codigo":235933008,
    "descripcion":"TRASTORNO RELACIONADO CON STENT EN CONDUCTO BILIAR"
  },
  {
    "codigo":37490002,
    "descripcion":"FRACTURAS MÚLTIPLES EXPUESTAS DE AMBAS EXTREMIDADES INFERIORES"
  },
  {
    "codigo":397938004,
    "descripcion":"NIVEL PLASMÁTICO DE CREATINCINASA - HALLAZGO"
  },
  {
    "codigo":201330005,
    "descripcion":"TRASTORNOS DE ELIMINACIÓN TRANSEPIDÉRMICA"
  },
  {
    "codigo":168562006,
    "descripcion":"RADIOGRAFÍA SIMPLE DE NARIZ NORMAL"
  },
  {
    "codigo":299634006,
    "descripcion":"CREPITACIÓN DE ARTICULACIÓN DE DEDO DE PIE"
  },
  {
    "codigo":1348210008,
    "descripcion":"PATRÓN DE USO PERJUDICIAL DE SUSTANCIA EN REMISIÓN"
  },
  {
    "codigo":68423001,
    "descripcion":"ESPUTO ESPUMOSO"
  },
  {
    "codigo":232263002,
    "descripcion":"ANOMALÍA ADQUIRIDA DE LOS HUESECILLOS DEL OÍDO"
  },
  {
    "codigo":365170008,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA DESENROSCAR UNA TAPA"
  },
  {
    "codigo":35655004,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE PARED ABDOMINAL SIN INFECCIÓN"
  },
  {
    "codigo":197660000,
    "descripcion":"FIBROSIS RENAL"
  },
  {
    "codigo":33820001,
    "descripcion":"DEFICIENCIA ADQUIRIDA DE FACTOR X"
  },
  {
    "codigo":787484007,
    "descripcion":"NECROSIS AVASCULAR PROGRESIVA DE HUESO SEMILUNAR"
  },
  {
    "codigo":263196008,
    "descripcion":"FRACTURA DE CABEZA DE RADIO"
  },
  {
    "codigo":294129005,
    "descripcion":"ALERGIA A CLORFENAMINA"
  },
  {
    "codigo":297781000119108,
    "descripcion":"DERRAME INTERMITENTE DE ARTICULACIÓN DE CODO"
  },
  {
    "codigo":195825009,
    "descripcion":"MUCOCELE DE SENO NASAL"
  },
  {
    "codigo":62918002,
    "descripcion":"ARTROPATÍA EN EL SÍNDROME DE BEHCET"
  },
  {
    "codigo":292294004,
    "descripcion":"REACCIÓN ADVERSA A LA FENELZINA"
  },
  {
    "codigo":11848501000119109,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE PÁRPADO DERECHO"
  },
  {
    "codigo":95686007,
    "descripcion":"ATROFIA CORIORRETINIANA"
  },
  {
    "codigo":1177030007,
    "descripcion":"INFECCIÓN POR OPISTHORCHIS FELINEUS"
  },
  {
    "codigo":290459002,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR SEN"
  },
  {
    "codigo":93851005,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LABIOS MENORES DE LA VULVA"
  },
  {
    "codigo":126619007,
    "descripcion":"NEOPLASIA DE MÚSCULO DEL CUELLO"
  },
  {
    "codigo":716443007,
    "descripcion":"CAPAZ DE DESVIAR LA ATENCIÓN"
  },
  {
    "codigo":419696001,
    "descripcion":"REFLEJO SUPRARROTULIANO ANORMAL"
  },
  {
    "codigo":26480007,
    "descripcion":"SÍNDROME DE TRISOMÍA PARCIAL 11P"
  },
  {
    "codigo":288624008,
    "descripcion":"UTILIZA LENGUAJE AUTOMÁTICO"
  },
  {
    "codigo":92016009,
    "descripcion":"NEOPLASIA BENIGNA DE VASO SANGUÍNEO DEL MIEMBRO SUPERIOR"
  },
  {
    "codigo":254021002,
    "descripcion":"CRANEOSINOSTOSIS BICORONAL"
  },
  {
    "codigo":286789000,
    "descripcion":"EXPRESIÓN ADECUADA COMPATIBLE CON ENOJO"
  },
  {
    "codigo":385093006,
    "descripcion":"NEUMONÍA EXTRAHOSPITALARIA"
  },
  {
    "codigo":22810007,
    "descripcion":"PROGNATISMO MANDIBULAR"
  },
  {
    "codigo":219418008,
    "descripcion":"HERIDA DE GUERRA, AHOGADO EN OPERACIONES BÉLICAS"
  },
  {
    "codigo":284954008,
    "descripcion":"DIFICULTAD PARA LAVARSE LUEGO DE IR AL BAÑO"
  },
  {
    "codigo":1004015002,
    "descripcion":"TRASTORNO NEONATAL DEBIDO A TOMA DE MUESTRAS DE VELLOSIDADES CORIÓNICAS Y POSTERIOR A ELLA"
  },
  {
    "codigo":448794008,
    "descripcion":"DOBLE TRACTO DE SALIDA DE VENTRÍCULO DERECHO CON DEFECTO SUBPULMONAR DE TABIQUE INTERVENTRICULAR"
  },
  {
    "codigo":53743006,
    "descripcion":"ANEMIA POSTERIOR A PÉRDIDA DE SANGRE FETAL"
  },
  {
    "codigo":283119006,
    "descripcion":"AMPOLLA TRAUMÁTICA DE LA NARIZ"
  },
  {
    "codigo":248516005,
    "descripcion":"QUISTE DE BORDE PALPEBRAL"
  },
  {
    "codigo":15727721000119106,
    "descripcion":"ADHERENCIA DE ARTICULACIÓN TEMPOROMANDIBULAR DERECHA"
  },
  {
    "codigo":707268007,
    "descripcion":"ESTOMATITIS ULCEROSA CRÓNICA"
  },
  {
    "codigo":281284008,
    "descripcion":"ESPÉCIMEN POSIBLEMENTE OBTENIDO DE BRAZO DE GOTEO INTRAVENOSO"
  },
  {
    "codigo":445124008,
    "descripcion":"EDEMA DE DORSO DE PIE"
  },
  {
    "codigo":838340006,
    "descripcion":"LEUCEMIA-LINFOMA LINFOBLÁSTICO DE CÉLULAS B CON T(5;14)(Q31;Q32); IL3-IGH"
  },
  {
    "codigo":312217003,
    "descripcion":"VENTRICULITIS INFECCIOSA"
  },
  {
    "codigo":1295257005,
    "descripcion":"ICTERICIA NEONATAL DEBIDA A INGESTIÓN DE SANGRE MATERNA"
  },
  {
    "codigo":17305005,
    "descripcion":"GONORREA AGUDA DEL APARATO GENITOURINARIO"
  },
  {
    "codigo":246681007,
    "descripcion":"SANGRE EN EL OJO"
  },
  {
    "codigo":15470004,
    "descripcion":"ENFERMEDAD DE GRAVES CON ACROPAQUIA"
  },
  {
    "codigo":277614006,
    "descripcion":"LEUCEMIA\/LINFOMA DE LINFOCITOS T PRETÍMICOS Y TÍMICOS"
  },
  {
    "codigo":212078007,
    "descripcion":"QUEMADURA QUE COMPROMETE 50-59 PORCIENTO DE LA SUPERFICIE DEL CUERPO, CON QUEMADURA DE ESPESOR COMPLETO QUE AFECTA 10-19 PORCIENTO DE LA SUPERFICIE CORPORAL"
  },
  {
    "codigo":408686008,
    "descripcion":"ENFERMEDAD ADENOVIRAL ASOCIADA CON LA ATENCIÓN MÉDICA"
  },
  {
    "codigo":767299002,
    "descripcion":"EFECTO TÓXICO DE MERCURIO Y\/O COMPUESTOS DE MERCURIO"
  },
  {
    "codigo":275779003,
    "descripcion":"UROBILINA EN ORINA - HALLAZGO"
  },
  {
    "codigo":46403004,
    "descripcion":"RELACIÓN VENTILACIÓN - PERFUSIÓN AUMENTADA"
  },
  {
    "codigo":243011005,
    "descripcion":"LESIÓN POR DESCARGA DE PISTOLA DE BENGALA"
  },
  {
    "codigo":210243005,
    "descripcion":"LESIÓN TRAUMÁTICA DE PRÓSTATA CON HERIDA ABIERTA HACIA CAVIDAD ABDOMINAL"
  },
  {
    "codigo":11800000,
    "descripcion":"ALEXIA SUBCORTICAL"
  },
  {
    "codigo":208408001,
    "descripcion":"FRACTURA NO EXPUESTA DE LA CABEZA DEL PRIMER METACARPIANO"
  },
  {
    "codigo":110104003,
    "descripcion":"LACERACIÓN SIMPLE DEL VESTÍBULO MANDIBULAR"
  },
  {
    "codigo":44568006,
    "descripcion":"QUERATITIS INTERSTICIAL SIFILÍTICA"
  },
  {
    "codigo":372248009,
    "descripcion":"ARTRITIS SUPURATIVA MICÓTICA"
  },
  {
    "codigo":206573003,
    "descripcion":"SÍNTOMAS DE ABSTINENCIA NEONATAL POR FARMACOTERAPIA"
  },
  {
    "codigo":403181004,
    "descripcion":"TATUAJE DECORATIVO DE LA PIEL REALIZADO POR PROFESIONAL"
  },
  {
    "codigo":42733007,
    "descripcion":"DERMATITIS DE CONTACTO CAUSADA POR DICROMATO"
  },
  {
    "codigo":1156845007,
    "descripcion":"UVEÍTIS DEBIDA A OLIGOARTRITIS IDIOPÁTICA JUVENIL NEGATIVA PARA ANTICUERPOS ANTINUCLEARES DE INICIO EXTENDIDO"
  },
  {
    "codigo":8130001,
    "descripcion":"BOCA DE PESCADO"
  },
  {
    "codigo":237506002,
    "descripcion":"TIROTOXICOSIS EN EL EMBARAZO"
  },
  {
    "codigo":73666000,
    "descripcion":"ESTIMULACIÓN OROGENITAL"
  },
  {
    "codigo":11769091000119109,
    "descripcion":"RUPTURA TRAUMÁTICA DE TENDÓN DE HOMBRO DERECHO"
  },
  {
    "codigo":301207000,
    "descripcion":"LARINGE PRESENTE"
  },
  {
    "codigo":235671002,
    "descripcion":"FÍSTULA GÁSTRICA"
  },
  {
    "codigo":69996000,
    "descripcion":"BLASTOMICOSIS"
  },
  {
    "codigo":233836002,
    "descripcion":"INFARTO AGUDO DE ONDA Q - MASIVO"
  },
  {
    "codigo":37228003,
    "descripcion":"INFECCIÓN CAUSADA POR HAEMONCHUS CONTORTUS"
  },
  {
    "codigo":168300004,
    "descripcion":"ORGANISMO AISLADO EN CULTIVO DE HISOPADO DE FAUCES"
  },
  {
    "codigo":683421000119106,
    "descripcion":"DERMATOFIBROMA DE PIEL DE LABIO"
  },
  {
    "codigo":16057911000119100,
    "descripcion":"PARÁLISIS FACIAL DERECHA GRADO I DE HOUSE-BRACKMANN"
  },
  {
    "codigo":397676007,
    "descripcion":"DERIVACIÓN RETRASADA - CONSULTORIO ESPECIALIZADO COMPLETO"
  },
  {
    "codigo":364908008,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA MOVERSE EN UNA MISMA POSICIÓN"
  },
  {
    "codigo":299372009,
    "descripcion":"ARTICULACIÓN DE LA RODILLA DOLOROSA A LA PALPACIÓN"
  },
  {
    "codigo":166465001,
    "descripcion":"ANDROSTENEDIONA SÉRICA FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":428609006,
    "descripcion":"LESIÓN TRAUMÁTICA NEUROVASCULAR"
  },
  {
    "codigo":232001007,
    "descripcion":"DEGENERACIÓN RETINIANA PROGRESIVA LENTA"
  },
  {
    "codigo":721686000,
    "descripcion":"PÓLIPOS INFLAMATORIOS CONCOMITANTES CON ENFERMEDAD INFLAMATORIA DEL INTESTINO Y DEBIDOS A ELLA"
  },
  {
    "codigo":2625009,
    "descripcion":"SÍNDROME DE SENTER"
  },
  {
    "codigo":789057009,
    "descripcion":"TUBERCULOSIS DE OÍDO MEDIO"
  },
  {
    "codigo":426774001,
    "descripcion":"DOLOR CARACTERIZADO POR UN FACTOR DESENCADENANTE"
  },
  {
    "codigo":262934002,
    "descripcion":"PERFORACIÓN DE CUELLO UTERINO"
  },
  {
    "codigo":295702001,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE METOTREXATO"
  },
  {
    "codigo":230166005,
    "descripcion":"ENCEFALITIS POR VIRUS ROCÍO"
  },
  {
    "codigo":457707000,
    "descripcion":"TROMBOSIS DE VÁLVULA TRONCAL"
  },
  {
    "codigo":33558009,
    "descripcion":"PERICARDITIS POSTRADIACIÓN"
  },
  {
    "codigo":293867002,
    "descripcion":"ALERGIA A CARBAMAZEPINA"
  },
  {
    "codigo":64491003,
    "descripcion":"FORMA MIXEDEMATOSA DE CRETINISMO"
  },
  {
    "codigo":31723003,
    "descripcion":"VÍCTIMA DE ACCIÓN MILITAR"
  },
  {
    "codigo":95424002,
    "descripcion":"OSTEOMIELITIS AGUDA DEL CRÁNEO"
  },
  {
    "codigo":292032005,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR PENICILINASA"
  },
  {
    "codigo":128192007,
    "descripcion":"NEURITIS PERIFÉRICA"
  },
  {
    "codigo":191893000,
    "descripcion":"PATRÓN DE USO NOCIVO CONTINUO DE CANNABIS SIN DEPENDENCIA"
  },
  {
    "codigo":93589005,
    "descripcion":"OSIFICACIÓN INCOMPLETA DE HUESO LAGRIMAL"
  },
  {
    "codigo":290197006,
    "descripcion":"INTOXICACIÓN POR ALFENTANILO"
  },
  {
    "codigo":124522001,
    "descripcion":"DEFICIENCIA DE GUANINA DESAMINASA"
  },
  {
    "codigo":1173098001,
    "descripcion":"PLACENTA PREVIA LATERAL"
  },
  {
    "codigo":386666001,
    "descripcion":"PUPILAS SIMÉTRICAS Y REACTIVAS A LA LUZ"
  },
  {
    "codigo":286527003,
    "descripcion":"INCAPAZ DE MANTENER LA TEMPERATURA CORRECTA DE LOS ALIMENTOS"
  },
  {
    "codigo":24383005,
    "descripcion":"PERITONITIS ESCLEROSANTE"
  },
  {
    "codigo":712511006,
    "descripcion":"ABSCESO DE COLON SIGMOIDE"
  },
  {
    "codigo":778047006,
    "descripcion":"EPILEPSIA MIOCLÓNICA EN LA ENCEFALOPATÍA NO PROGRESIVA"
  },
  {
    "codigo":1234964005,
    "descripcion":"TRASTORNO FETAL DEBIDO A NUDO VERDADERO DE CORDÓN UMBILICAL"
  },
  {
    "codigo":448532006,
    "descripcion":"OLIGOASTENOZOOSPERMIA"
  },
  {
    "codigo":415764005,
    "descripcion":"TIROSINEMIA TIPO III"
  },
  {
    "codigo":282857001,
    "descripcion":"DIFICULTAD PARA MANTENERSE EN BIPEDESTACIÓN"
  },
  {
    "codigo":250089007,
    "descripcion":"PROTRUSIÓN ANTERIOR DE CABEZA DE HÚMERO"
  },
  {
    "codigo":84414000,
    "descripcion":"LINFANGITIS INFECCIOSA DE LOS GANGLIOS LINFÁTICOS SUPERFICIALES"
  },
  {
    "codigo":86249007,
    "descripcion":"NEFROPATÍA OBSTRUCTIVA"
  },
  {
    "codigo":51646002,
    "descripcion":"ARTRITIS ESTREPTOCÓCICA"
  },
  {
    "codigo":444862003,
    "descripcion":"OBESIDAD DE LA INFANCIA"
  },
  {
    "codigo":1264062004,
    "descripcion":"DOLOR TORÁCICO URENTE"
  },
  {
    "codigo":40601000087100,
    "descripcion":"ABRASIÓN DE PIEL DE QUINTO DEDO DE PIE IZQUIERDO"
  },
  {
    "codigo":43161000087102,
    "descripcion":"HERIDA PUNZANTE DE MANO IZQUIERDA CON CUERPO EXTRAÑO"
  },
  {
    "codigo":770707007,
    "descripcion":"REACCIÓN ADVERSA AL FACTOR VII"
  },
  {
    "codigo":35481000087104,
    "descripcion":"ISQUEMIA DE MIOCARDIO DE TABIQUE INTERVENTRICULAR"
  },
  {
    "codigo":277352000,
    "descripcion":"DOLOR POR SUXAMETONIO"
  },
  {
    "codigo":48281000087106,
    "descripcion":"FRACTURA DE SECCIÓN CERVICAL MEDIA DE CUELLO DE FÉMUR IZQUIERDO"
  },
  {
    "codigo":703336003,
    "descripcion":"MALFORMACIÓN ARTERIOVENOSA DEL PROCESO FRONTONASAL"
  },
  {
    "codigo":38041000087108,
    "descripcion":"ACINESIA DE SEGMENTO BASAL INFERIOR DE VENTRÍCULO CARDÍACO IZQUIERDO"
  },
  {
    "codigo":441192006,
    "descripcion":"ENFERMEDAD POR DEFICIENCIA HEREDITARIA LEVE DE FACTOR IX SIN INHIBIDORES"
  },
  {
    "codigo":80744008,
    "descripcion":"CONMOCIÓN RETINIANA"
  },
  {
    "codigo":406589003,
    "descripcion":"INFECCIÓN DEL SISTEMA NERVIOSO CENTRAL POR LEPTOSPIRA"
  },
  {
    "codigo":331781000119101,
    "descripcion":"CATARATA DE OJO DERECHO DEBIDA A TRAUMATISMO Y POSTERIOR A ÉL"
  },
  {
    "codigo":275517008,
    "descripcion":"TROMBOSIS VENOSA SUPERFICIAL"
  },
  {
    "codigo":765202001,
    "descripcion":"MENINGIOMA BENIGNO MÚLTIPLE FAMILIAR"
  },
  {
    "codigo":78909009,
    "descripcion":"EVALUACIÓN DE DISCAPACIDAD: ALTERACIÓN CLASE 8"
  },
  {
    "codigo":240914003,
    "descripcion":"INFECCIÓN CAUSADA POR ALGAS"
  },
  {
    "codigo":208146001,
    "descripcion":"FRACTURA NO EXPUESTA DE ACETÁBULO, SOLO LABIO ANTERIOR"
  },
  {
    "codigo":109842005,
    "descripcion":"CARCINOMA DE LAS VÍAS BILIARES INTRAHEPÁTICAS"
  },
  {
    "codigo":11538006,
    "descripcion":"CUADRIPLEJÍA"
  },
  {
    "codigo":44306006,
    "descripcion":"TRASTORNO DE LOS LINFOCITOS T"
  },
  {
    "codigo":371986009,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL OJO"
  },
  {
    "codigo":271847005,
    "descripcion":"HIPERTIROSINEMIA HEREDITARIA"
  },
  {
    "codigo":239079007,
    "descripcion":"HIPERPIGMENTACIÓN CUTÁNEA HEREDADA"
  },
  {
    "codigo":1254887008,
    "descripcion":"PIEL EXCEDENTE LOCALIZADA"
  },
  {
    "codigo":763367009,
    "descripcion":"PARAPLEJÍA ESPÁSTICA AUTOSÓMICA RECESIVA TIPO 48"
  },
  {
    "codigo":1351356002,
    "descripcion":"DEFICIENCIA DE CLASE I DEL COMPLEJO MAYOR DE HISTOCOMPATIBILIDAD DEBIDA A MUTACIÓN DE TAPBP"
  },
  {
    "codigo":10817541000119106,
    "descripcion":"FRACTURA EXPUESTA DE PORCIÓN PROXIMAL DE PERONÉ DERECHO"
  },
  {
    "codigo":827068008,
    "descripcion":"HIPERTENSIÓN EN ESTADIO 2"
  },
  {
    "codigo":300945001,
    "descripcion":"TALÓN INFECTADO"
  },
  {
    "codigo":1075451000000107,
    "descripcion":"INCAPAZ DE DESPLAZAR OBJETOS POR EL HOGAR"
  },
  {
    "codigo":6033008,
    "descripcion":"ABSCESO DE FONDO DE SACO DE DOUGLAS"
  },
  {
    "codigo":366481009,
    "descripcion":"HALLAZGO RELACIONADO CON LA AMPLITUD DE MOVIMIENTO PASIVO DE ABDUCCIÓN DE HOMBRO"
  },
  {
    "codigo":299110002,
    "descripcion":"BLOQUEO DE ARTICULACIÓN DE DEDO DE MANO"
  },
  {
    "codigo":399249008,
    "descripcion":"FUCOSIDOSIS DEL ADULTO"
  },
  {
    "codigo":102502005,
    "descripcion":"RECIÉN NACIDO DE SEXO FEMENINO SANO"
  },
  {
    "codigo":266342009,
    "descripcion":"RINITIS CATARRAL CRÓNICA"
  },
  {
    "codigo":1149243003,
    "descripcion":"LOGRA CONTROLAR SÍNTOMAS"
  },
  {
    "codigo":264507006,
    "descripcion":"AVULSIÓN DE FIJACIÓN FEMORAL"
  },
  {
    "codigo":295440002,
    "descripcion":"SOBREDOSIS DE PICOSULFATO SÓDICO"
  },
  {
    "codigo":721424005,
    "descripcion":"FRACTURA DE DÉCIMA VÉRTEBRA DORSAL"
  },
  {
    "codigo":129765000,
    "descripcion":"CALCIFICACIÓN DISTRIBUIDA EN FORMA LINEAL"
  },
  {
    "codigo":293605005,
    "descripcion":"ALERGIA A FENTANILO"
  },
  {
    "codigo":64229006,
    "descripcion":"LESIÓN TRAUMÁTICA DURANTE EL PARTO"
  },
  {
    "codigo":195301007,
    "descripcion":"GANGRENA PERIFÉRICA"
  },
  {
    "codigo":193466003,
    "descripcion":"DISTROFIA PERIPAPILAR PARCIAL DE COROIDES"
  },
  {
    "codigo":226234005,
    "descripcion":"DIETA SALUDABLE"
  },
  {
    "codigo":717754006,
    "descripcion":"OBSTRUCCIÓN DE VÍA URINARIA INFERIOR FETAL DEBIDA A VÁLVULA URETRAL POSTERIOR"
  },
  {
    "codigo":816058005,
    "descripcion":"TUMORACIÓN DE MAMA FIJA A LA PIEL"
  },
  {
    "codigo":62394006,
    "descripcion":"ADHERENCIAS PERITONEALES DE LA PELVIS FEMENINA"
  },
  {
    "codigo":95162009,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL ORIFICIO URETERAL DE LA VEJIGA"
  },
  {
    "codigo":93327006,
    "descripcion":"POSICIÓN ANÓMALA CONGÉNITA DEL ILION"
  },
  {
    "codigo":714084001,
    "descripcion":"INFECCIÓN DEL TRACTO RESPIRATORIO CAUSADA POR PARÁSITO"
  },
  {
    "codigo":781455009,
    "descripcion":"DISTENSIÓN DE TENDÓN EXTENSOR DE REGIÓN DE MUÑECA"
  },
  {
    "codigo":25956006,
    "descripcion":"TIÑA PEDIA CAUSADA POR TRICHOPHYTON"
  },
  {
    "codigo":58724008,
    "descripcion":"SÍNDROME COSTAL"
  },
  {
    "codigo":124260009,
    "descripcion":"DEFICIENCIA DE TIOETANOLAMINA ACETILTRANSFERASA"
  },
  {
    "codigo":24121004,
    "descripcion":"INSOMNIO NO RELACIONADO CON OTRO TRASTORNO MENTAL"
  },
  {
    "codigo":253497005,
    "descripcion":"PROLAPSO DE VÁLVULA AURICULOVENTRICULAR IZQUIERDA"
  },
  {
    "codigo":286265006,
    "descripcion":"CAPAZ DE ARTICULAR CORRECTAMENTE PARA HABLAR"
  },
  {
    "codigo":448270009,
    "descripcion":"LIPOMA DE PARED TORÁCICA"
  },
  {
    "codigo":282595004,
    "descripcion":"INCAPAZ DE BRINCAR CON LOS PIES EN FORMA ALTERNADA"
  },
  {
    "codigo":1003491007,
    "descripcion":"SOSPECHA DE GLAUCOMA DE ÁNGULO CERRADO BILATERAL"
  },
  {
    "codigo":247992002,
    "descripcion":"REGALA DINERO"
  },
  {
    "codigo":213389000,
    "descripcion":"LESIONES TRAUMÁTICAS MÚLTIPLES GRAVES"
  },
  {
    "codigo":442765006,
    "descripcion":"BACILLUS ANTHRACIS AISLADO EN CULTIVO"
  },
  {
    "codigo":82317007,
    "descripcion":"ENFERMEDAD GRANULOMATOSA CRÓNICA, TIPO III"
  },
  {
    "codigo":1260130005,
    "descripcion":"SÍNDROME PROGRESIVO DE TEMBLOR ESENCIAL, TRASTORNO DEL HABLA, DISMORFIA FACIAL, DISCAPACIDAD INTELECTUAL Y CONDUCTA ANÓMALA"
  },
  {
    "codigo":735842005,
    "descripcion":"FRACTURA DE MALÉOLO EXTERNO POR DEBAJO DE LA SINDESMOSIS"
  },
  {
    "codigo":211554007,
    "descripcion":"LESIÓN TRAUMÁTICA CERRADA POR APLASTAMIENTO, BRAZO"
  },
  {
    "codigo":471863000,
    "descripcion":"TRASTORNO DEL MIOCARDIO DEBIDO A HEMOGLOBINOPATÍA DREPANOCÍTICA"
  },
  {
    "codigo":440930009,
    "descripcion":"ADENOVIRUS HUMANO PRESENTE"
  },
  {
    "codigo":209719007,
    "descripcion":"SECCIÓN EXPUESTA DE LIGAMENTO SACROILÍACO"
  },
  {
    "codigo":766775007,
    "descripcion":"FRACTURA NO EXPUESTA DE CÓCCIX"
  },
  {
    "codigo":15954541000119105,
    "descripcion":"CAMBIOS EN LA PIEL DE AMBAS MAMAS"
  },
  {
    "codigo":764940002,
    "descripcion":"LEUCEMIA MIELOIDE AGUDA HEREDITARIA"
  },
  {
    "codigo":76812003,
    "descripcion":"TRASTORNO DE PÁNICO CON AGORAFOBIA, EVITACIÓN AGORAFÓBICA MODERADA Y ATAQUES DE PÁNICO EN REMISIÓN PARCIAL"
  },
  {
    "codigo":109580003,
    "descripcion":"CARIES DE LA LACTANCIA ASOCIADA CON AMAMANTAMIENTO"
  },
  {
    "codigo":207884008,
    "descripcion":"FRACTURA DE CUELLO Y TRONCO"
  },
  {
    "codigo":271585001,
    "descripcion":"PIES FRÍOS"
  },
  {
    "codigo":9441002,
    "descripcion":"LESIÓN TRAUMÁTICA DEL NERVIO ACÚSTICO"
  },
  {
    "codigo":402657003,
    "descripcion":"VASCULITIS NECROSANTE SECUNDARIA A ENFERMEDAD DEL TEJIDO CONJUNTIVO"
  },
  {
    "codigo":304353009,
    "descripcion":"AUSENCIA DE MOVIMIENTO DE LA COLUMNA LUMBAR"
  },
  {
    "codigo":1287393009,
    "descripcion":"HERIDA POR ARMA DE FUEGO DE MANO"
  },
  {
    "codigo":13221000122100,
    "descripcion":"ALERGIA A ATORVASTATINA"
  },
  {
    "codigo":890507000,
    "descripcion":"DERMATITIS POR EXPOSICIÓN A LUZ ULTRAVIOLETA ARTIFICIAL"
  },
  {
    "codigo":202379000,
    "descripcion":"DERRAME DE LA ARTICULACIÓN DE LA CADERA"
  },
  {
    "codigo":300683002,
    "descripcion":"INCAPAZ DE MANEJAR ACTIVIDADES FINANCIERAS PERSONALES"
  },
  {
    "codigo":12241671000119104,
    "descripcion":"ARTROSIS DE ARTICULACIÓN DE DEDO DE LA MANO DERECHA"
  },
  {
    "codigo":398987004,
    "descripcion":"CEFALEA LUEGO DE PUNCIÓN LUMBAR"
  },
  {
    "codigo":366219004,
    "descripcion":"TENDENCIA A SANGRAR - HALLAZGO"
  },
  {
    "codigo":38539003,
    "descripcion":"INFECCIÓN CAUSADA POR ONCHOCERCA VOLVULUS"
  },
  {
    "codigo":11832071000119105,
    "descripcion":"LACERACIÓN DE VASO SANGUÍNEO DE MEÑIQUE DERECHO"
  },
  {
    "codigo":722997000,
    "descripcion":"TRASTORNO HEREDITARIO DEL SISTEMA NERVIOSO AUTÓNOMO"
  },
  {
    "codigo":16665351000119107,
    "descripcion":"FRACTURA EXPUESTA DE LADO DERECHO DE MAXILAR SUPERIOR"
  },
  {
    "codigo":231477003,
    "descripcion":"ADICCIÓN A HEROÍNA"
  },
  {
    "codigo":788533006,
    "descripcion":"ANOMALÍA CONGÉNITA DE AURÍCULA"
  },
  {
    "codigo":297013008,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE CLOROTIAZIDA"
  },
  {
    "codigo":229642003,
    "descripcion":"FONACIÓN DE BANDA VENTRICULAR"
  },
  {
    "codigo":721162003,
    "descripcion":"FALLA DE LA LACTANCIA CON DIFICULTAD EN EL APEGO"
  },
  {
    "codigo":295178009,
    "descripcion":"SOBREDOSIS ACCIDENTAL POR DIHIDROCODEÍNA"
  },
  {
    "codigo":293343002,
    "descripcion":"REACCIÓN ADVERSA A LA NICUMALONA"
  },
  {
    "codigo":91041000119104,
    "descripcion":"SARCOMA DE EWING DE ESTRUCTURA ÓSEA DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":31199003,
    "descripcion":"INTOXICACIÓN POR CRYPTOSTEGIA GRANDIFLORA"
  },
  {
    "codigo":195039008,
    "descripcion":"BLOQUEO AURICULOVENTRICULAR PARCIAL"
  },
  {
    "codigo":424415008,
    "descripcion":"CONDICIONES DE VIDA ANTIHIGIÉNICAS"
  },
  {
    "codigo":94900006,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA PORCIÓN LATERAL DEL PISO DE LA BOCA"
  },
  {
    "codigo":27529000,
    "descripcion":"ATROFIA ADQUIRIDA DE OVARIO"
  },
  {
    "codigo":1010569005,
    "descripcion":"TESTÍCULO DERECHO NO DESCENDIDO"
  },
  {
    "codigo":781193006,
    "descripcion":"NECROSIS DE HERIDA QUIRÚRGICA"
  },
  {
    "codigo":715657008,
    "descripcion":"NECROSIS AVASCULAR DE CABEZA DE FÉMUR FAMILIAR"
  },
  {
    "codigo":289673008,
    "descripcion":"HALLAZGO RELACIONADO CON MEDICIONES DEL ÚTERO"
  },
  {
    "codigo":224137008,
    "descripcion":"VIVE CON LOS PADRES"
  },
  {
    "codigo":713822005,
    "descripcion":"SE DESPIERTA POR LA NOCHE"
  },
  {
    "codigo":123998005,
    "descripcion":"FRUCTOSA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1269043000,
    "descripcion":"TUMOR RHABDOIDE PRIMARIO MALIGNO"
  },
  {
    "codigo":255070009,
    "descripcion":"NEOPLASIA MALIGNA SUPERPUESTA DE CAVIDAD BUCAL Y LABIO Y GLÁNDULAS SALIVALES"
  },
  {
    "codigo":56627002,
    "descripcion":"TRASTORNO PSICOSEXUAL"
  },
  {
    "codigo":253235003,
    "descripcion":"QUISTE CONGÉNITO DE IRIS"
  },
  {
    "codigo":11776051000119100,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE ANTEBRAZO DERECHO"
  },
  {
    "codigo":307251000119101,
    "descripcion":"ARTRITIS ENTEROPÁTICA DE ARTICULACIÓN GLENOHUMERAL"
  },
  {
    "codigo":66611000119101,
    "descripcion":"PORTADOR DE TRASTORNO CROMOSÓMICO"
  },
  {
    "codigo":1085491000119102,
    "descripcion":"EDENTULISMO COMPLETO DE CLASE I DEBIDO A CARIES"
  },
  {
    "codigo":125491000119103,
    "descripcion":"SÍNDROME DE TURNER FETAL"
  },
  {
    "codigo":38451000119105,
    "descripcion":"INTENTO FALLIDO DE PARTO VAGINAL DESPUÉS DE OPERACIÓN CESÁREA PREVIA"
  },
  {
    "codigo":33331000119103,
    "descripcion":"SECUELA DE ACCIDENTE CEREBROVASCULAR LACUNAR"
  },
  {
    "codigo":317491000119107,
    "descripcion":"DETENCIÓN PARCIAL DEL CRECIMIENTO EPIFISARIO DE HÚMERO PROXIMAL DERECHO"
  },
  {
    "codigo":350771000119108,
    "descripcion":"NEOPLASIA LIPOMATOSA BENIGNA DE PIEL Y\/O DE TEJIDO CELULAR SUBCUTÁNEO DE EXTREMIDAD INFERIOR IZQUIERDA"
  },
  {
    "codigo":10949171000119104,
    "descripcion":"HERIDA ABIERTA DE MUÑECA DERECHA DEBIDA A MORDEDURA DE PERRO"
  },
  {
    "codigo":322611000119107,
    "descripcion":"SINOVITIS TRANSITORIA DE MANO DERECHA"
  },
  {
    "codigo":2611000119103,
    "descripcion":"TRASTORNO SENSITIVO DE LOS SENTIDOS DEL OLFATO Y\/O DEL GUSTO"
  },
  {
    "codigo":54792008,
    "descripcion":"DERMATOSIS ERITEMATOESCAMOSA"
  },
  {
    "codigo":330291000119104,
    "descripcion":"COMPRESIÓN DE NERVIO RADIAL DERECHO"
  },
  {
    "codigo":15636531000119108,
    "descripcion":"DISFUNCIÓN SOMÁTICA DE ARTICULACIÓN SACROILÍACA IZQUIERDA"
  },
  {
    "codigo":1077811000119107,
    "descripcion":"OSTEOMIELITIS DE PIE IZQUIERDO"
  },
  {
    "codigo":332851000119107,
    "descripcion":"PSEUDOEDEMA DE PAPILA DE OJO DERECHO"
  },
  {
    "codigo":249565005,
    "descripcion":"HALLAZGO RELACIONADO CON EL HÍGADO"
  },
  {
    "codigo":10862131000119109,
    "descripcion":"HERIDA POR DISPARO DE ARMA DE FUEGO DE REGIÓN DE RODILLA IZQUIERDA"
  },
  {
    "codigo":16749781000119101,
    "descripcion":"RETINOPATÍA PROLIFERATIVA BILATERAL POR DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":18354001,
    "descripcion":"INDURACIÓN CRÓNICA DE PULMÓN"
  },
  {
    "codigo":870322001,
    "descripcion":"HERIDA ABIERTA DE PIEL DE PÁRPADO"
  },
  {
    "codigo":247730001,
    "descripcion":"ALUCINACIONES VERBALES"
  },
  {
    "codigo":83890006,
    "descripcion":"TRASTORNO DE LA PERSONALIDAD DEL GRUPO C"
  },
  {
    "codigo":1263538007,
    "descripcion":"ENFERMEDAD DE NEURONA MOTORA DEBIDA A GAMMAPATÍA"
  },
  {
    "codigo":409735003,
    "descripcion":"CLASIFICACIÓN INTERNACIONAL DE NEUROBLASTOMA: GRUPO CON HISTOLOGÍA DESFAVORABLE, PACIENTE DE CUALQUIER EDAD, CON GANGLIONEUROBLASTOMA, NODULAR"
  },
  {
    "codigo":213127009,
    "descripcion":"INFECCIÓN EL ALOINJERTO ÓSEO"
  },
  {
    "codigo":473436001,
    "descripcion":"FRACTURA VERTEBRAL SEGÚN EL SISTEMA DE CLASIFICACIÓN DE TRES COLUMNAS PARA FRACTURAS VERTEBRALES POR ESTALLIDO"
  },
  {
    "codigo":735580003,
    "descripcion":"COMUNICACIÓN INTERAURICULAR RECURRENTE DESPUÉS DE PROCEDIMIENTO"
  },
  {
    "codigo":309596003,
    "descripcion":"ANOMALÍA RETINIANA NO RELACIONADA CON DIABETES"
  },
  {
    "codigo":276828006,
    "descripcion":"GLIOBLASTOMA MULTIFORME DE CEREBRO"
  },
  {
    "codigo":47452006,
    "descripcion":"VIRUELA CLÁSICA"
  },
  {
    "codigo":240390000,
    "descripcion":"MELIOIDOSIS SUPURATIVA LOCALIZADA AGUDA"
  },
  {
    "codigo":897585008,
    "descripcion":"GLAUCOMA PRIMARIO CONGÉNITO BILATERAL"
  },
  {
    "codigo":109318002,
    "descripcion":"OSTEOMIELITIS CRÓNICA DE HUESO ESFENOIDES"
  },
  {
    "codigo":209457008,
    "descripcion":"ESGUINCE DE LIGAMENTO ESCAFOSEMILUNAR"
  },
  {
    "codigo":369627001,
    "descripcion":"MARGEN RENAL PROXIMAL, SÓLO NEFRECTOMÍA PARCIAL, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":402395003,
    "descripcion":"ANAFILAXIS NO ALÉRGICA IATROGÉNICA"
  },
  {
    "codigo":74715005,
    "descripcion":"SÍNDROME DE LA MUJER GOLPEADA"
  },
  {
    "codigo":271323007,
    "descripcion":"NEOPLASIA MALIGNA DE LABIO, CAVIDAD BUCAL Y FARINGE"
  },
  {
    "codigo":238555008,
    "descripcion":"ECCEMA HIPERQUERATÓSICO FISURADO DE PALMAS"
  },
  {
    "codigo":105648001,
    "descripcion":"ENFERMEDAD CAUSADA POR TRICHOMONADIDAE"
  },
  {
    "codigo":72880002,
    "descripcion":"ENFERMEDAD POR EL VIRUS OROPOUCHE"
  },
  {
    "codigo":236720004,
    "descripcion":"PROTEINURIA ASINTOMÁTICA"
  },
  {
    "codigo":365957000,
    "descripcion":"HALLAZGO RELACIONADO CON LA RELACIÓN SEXUAL"
  },
  {
    "codigo":202117004,
    "descripcion":"DESGARRO ANTIGUO DEL COMPLEJO CAPSULAR POSTEROLATERAL"
  },
  {
    "codigo":5509004,
    "descripcion":"TRASTORNO DE PÁNICO CON AGORAFOBIA Y ATAQUES DE PÁNICO GRAVES"
  },
  {
    "codigo":726405008,
    "descripcion":"CATARATA PUNTEADA RELACIONADA CON LA EDAD"
  },
  {
    "codigo":396890001,
    "descripcion":"MARGEN QUIRÚRGICO DE CONDUCTO NO COMPROMETIDO POR CARCINOMA IN SITU"
  },
  {
    "codigo":298586004,
    "descripcion":"COLUMNA VERTEBRAL DORSAL FRÍA"
  },
  {
    "codigo":165679005,
    "descripcion":"HEMOGLOBINA A1C MENOR DE 7%, INDICATIVA DE BUEN CONTROL DE LA DIABETES"
  },
  {
    "codigo":460591005,
    "descripcion":"ANILLO VASCULAR CON CAYADO AÓRTICO DERECHO Y CONDUCTO ARTERIOSO IZQUIERDO DESDE ARTERIA SUBCLAVIA IZQUIERDA RETROESOFÁGICA ANÓMALA"
  },
  {
    "codigo":67375008,
    "descripcion":"GASTROENTERITIS EOSINOFÍLICA CON AFECTACIÓN PREDOMINANTE DE LA CAPA MUSCULAR"
  },
  {
    "codigo":131076004,
    "descripcion":"TESTOSTERONA ANORMAL"
  },
  {
    "codigo":425988004,
    "descripcion":"TRASTORNO DE INTEGRACIÓN SENSORIAL"
  },
  {
    "codigo":294916006,
    "descripcion":"ALERGIA A YODOPOVIDONA"
  },
  {
    "codigo":11863561000119106,
    "descripcion":"CONTUSIÓN DE SEGUNDO A QUINTO DEDO DEL PIE IZQUIERDO"
  },
  {
    "codigo":162009001,
    "descripcion":"SÍNTOMAS DE LA BOCA"
  },
  {
    "codigo":11781641000119107,
    "descripcion":"LACERACIÓN DE VENA FEMORAL DERECHA"
  },
  {
    "codigo":293081004,
    "descripcion":"REACCIÓN ADVERSA A LA DAPSONA"
  },
  {
    "codigo":291246000,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR MARIHUANA"
  },
  {
    "codigo":61870003,
    "descripcion":"QUIMERA HOMÓLOGA"
  },
  {
    "codigo":94638008,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA LENGUA"
  },
  {
    "codigo":715395008,
    "descripcion":"FIBRILACIÓN AURICULAR FAMILIAR"
  },
  {
    "codigo":289411009,
    "descripcion":"FONTANELA ANTERIOR PALPABLE"
  },
  {
    "codigo":92803008,
    "descripcion":"CARCINOMA IN SITU DEL ANILLO DE WALDEYER"
  },
  {
    "codigo":58200004,
    "descripcion":"PSEUDOPTOSIS"
  },
  {
    "codigo":254808005,
    "descripcion":"NEVO AZUL CELULAR DE LA PIEL"
  },
  {
    "codigo":90968009,
    "descripcion":"EMBARAZO PROLONGADO"
  },
  {
    "codigo":189272009,
    "descripcion":"CARCINOMA IN SITU DE ANTRO TIMPÁNICO"
  },
  {
    "codigo":286371000119107,
    "descripcion":"ENFERMEDAD RENAL CRÓNICA TERMINAL POR HIPERTENSIÓN MALIGNA EN DIÁLISIS"
  },
  {
    "codigo":285741001,
    "descripcion":"EPISODIO VAGO"
  },
  {
    "codigo":416813006,
    "descripcion":"NEUROPATÍA ÓPTICA COMPRESIVA POR ENFERMEDAD OCULAR TIROIDEA"
  },
  {
    "codigo":21762000,
    "descripcion":"FLUJO VASCULAR DISMINUIDO"
  },
  {
    "codigo":251138000,
    "descripcion":"TRAZADO ELECTROCARDIOGRÁFICO INADECUADO"
  },
  {
    "codigo":218370002,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR DIYODOHIDROXIQUINA"
  },
  {
    "codigo":54530004,
    "descripcion":"FRACTURA EXPUESTA DEL MALÉOLO MEDIAL"
  },
  {
    "codigo":283906006,
    "descripcion":"CONTUSIÓN DE URÉTER"
  },
  {
    "codigo":249303004,
    "descripcion":"CONSTRICCIÓN DEL MEATO URETRAL"
  },
  {
    "codigo":183767005,
    "descripcion":"EN LISTA PARA ADMISIÓN HOSPITALARIA"
  },
  {
    "codigo":118231006,
    "descripcion":"HALLAZGO DE LA COMUNICACIÓN"
  },
  {
    "codigo":708055005,
    "descripcion":"ENFERMEDAD GINGIVAL CAUSADA POR BACTERIAS"
  },
  {
    "codigo":11810621000119105,
    "descripcion":"RUPTURA TRAUMÁTICA DE TENDÓN DE REGIÓN DE CADERA DERECHA"
  },
  {
    "codigo":1079101000119105,
    "descripcion":"CARCINOMA BASOCELULAR PRIMARIO DE PABELLÓN AURICULAR IZQUIERDO"
  },
  {
    "codigo":216535006,
    "descripcion":"INTOXICACIÓN ACCIDENTAL CAUSADA POR MEDAZEPAM"
  },
  {
    "codigo":247468003,
    "descripcion":"COMEDÓN CERRADO"
  },
  {
    "codigo":1363415007,
    "descripcion":"SINEQUIAS ANTERIORES PERIFÉRICAS EN CUADRANTE NASAL DE ÁNGULO IRIDOCORNEAL"
  },
  {
    "codigo":83628005,
    "descripcion":"HEMORRAGIA GASTROINTESTINAL CRÓNICA"
  },
  {
    "codigo":1197740007,
    "descripcion":"PANCREATITIS AUTOINMUNITARIA TIPO 2"
  },
  {
    "codigo":41000112104,
    "descripcion":"INMUNOGLOBULINA DE CADENA LIVIANA LIBRE POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":868225002,
    "descripcion":"INFARTO AGUDO DE MIOCARDIO CON ELEVACIÓN DEL SEGMENTO ST DEBIDO A OCLUSIÓN DE RAMA DESCENDENTE POSTERIOR DE ARTERIA CORONARIA DERECHA"
  },
  {
    "codigo":49025003,
    "descripcion":"INFECCIÓN CAUSADA POR PARASCARIS EQUORUM"
  },
  {
    "codigo":81793007,
    "descripcion":"POLIDACTILIA DE DEDOS DE LA MANO"
  },
  {
    "codigo":1163137008,
    "descripcion":"INFECCIÓN BACTERIANA DE NERVIO CRANEAL"
  },
  {
    "codigo":473174001,
    "descripcion":"DESPLAZAMIENTO DE IMPLANTE MUSCULOESQUELÉTICO"
  },
  {
    "codigo":79958002,
    "descripcion":"FIEBRE POR GRANOS"
  },
  {
    "codigo":276566003,
    "descripcion":"HIPOTIROIDISMO NEONATAL TRANSITORIO"
  },
  {
    "codigo":768086006,
    "descripcion":"HERNIA FEMORAL DERECHA RECURRENTE CON GANGRENA"
  },
  {
    "codigo":733483001,
    "descripcion":"VIRUS HEMAGLUTINANTE PRESENTE"
  },
  {
    "codigo":307499004,
    "descripcion":"FIJACIÓN DE LA ARTICULACIÓN CRICOARITENOIDE"
  },
  {
    "codigo":241963005,
    "descripcion":"ANGIOEDEMA-URTICARIA PRODUCIDO POR COLORANTE AZOICO"
  },
  {
    "codigo":766251006,
    "descripcion":"MIOPATÍA MITOCONDRIAL INFANTIL LETAL"
  },
  {
    "codigo":373035007,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM HIBERNIAE"
  },
  {
    "codigo":240128005,
    "descripcion":"CAQUEXIA MUSCULAR"
  },
  {
    "codigo":403968005,
    "descripcion":"HEMANGIOMA VENOSO"
  },
  {
    "codigo":895488007,
    "descripcion":"SE MOVILIZA CON ANDADOR"
  },
  {
    "codigo":305664007,
    "descripcion":"ATENDIDO POR UN MÉDICO DE TÓRAX"
  },
  {
    "codigo":402133004,
    "descripcion":"INFECCIÓN CUTÁNEA POR MALASSEZIA"
  },
  {
    "codigo":762581004,
    "descripcion":"URANOSQUISIS CON LABIO LEPORINO IZQUIERDO Y FISURA ALVEOLAR IZQUIERDA"
  },
  {
    "codigo":236458001,
    "descripcion":"NEFRITIS TUBULOINTERSTICIAL GRANULOMATOSA"
  },
  {
    "codigo":1186730002,
    "descripcion":"SÍNDROME DE GABRIELE DE-VRIES"
  },
  {
    "codigo":301994007,
    "descripcion":"INCAPAZ DE ACEPTAR BASE DE APOYO"
  },
  {
    "codigo":70783003,
    "descripcion":"HIPERTROFIA DE LA TÚNICA VAGINAL"
  },
  {
    "codigo":1217663003,
    "descripcion":"PARÁLISIS CRÓNICA DE CUARTO NERVIO CRANEAL CON EXTENSIÓN DE COMITANCIA"
  },
  {
    "codigo":298324000,
    "descripcion":"PRUEBA DEDO-NARIZ, NORMAL"
  },
  {
    "codigo":365695008,
    "descripcion":"LÍQUIDO CEFALORRAQUÍDEO: MICROORGANISMOS - HALLAZGO"
  },
  {
    "codigo":431231008,
    "descripcion":"RINOSINUSITIS AGUDA"
  },
  {
    "codigo":201855008,
    "descripcion":"ARTROSIS SECUNDARIA LOCALIZADA, DE TOBILLO Y\/O PIE"
  },
  {
    "codigo":234623008,
    "descripcion":"DEFICIENCIA DE LA PROTEÍNA FIJADORA DEL COMPLEMENTO 4"
  },
  {
    "codigo":300159009,
    "descripcion":"MEMBRANA TIMPÁNICA NORMAL"
  },
  {
    "codigo":68948008,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE COSTILLA"
  },
  {
    "codigo":462164009,
    "descripcion":"DERRAME PERICÁRDICO FETAL"
  },
  {
    "codigo":1279529002,
    "descripcion":"DEBILIDAD DE MÚSCULO FACIAL DEBIDA A HEMORRAGIA SUBARACNOIDEA INTRACRANEAL NO TRAUMÁTICA Y POSTERIOR A ELLA"
  },
  {
    "codigo":460329003,
    "descripcion":"MIOCARDITIS CAUSADA POR CANDIDA"
  },
  {
    "codigo":296489004,
    "descripcion":"SOBREDOSIS DE MIORRELAJANTE"
  },
  {
    "codigo":198185005,
    "descripcion":"PERIMETRITIS SUBAGUDA"
  },
  {
    "codigo":720638000,
    "descripcion":"ENFERMEDAD DE CHARCOT-MARIE-TOOTH TIPO 4J"
  },
  {
    "codigo":344331000119102,
    "descripcion":"CICATRIZ CORIORRETINIANA BILATERAL POSQUIRÚRGICA"
  },
  {
    "codigo":1179390007,
    "descripcion":"ADENOCARCINOMA DE CUERPO CAROTÍDEO"
  },
  {
    "codigo":425726009,
    "descripcion":"DISPOSICIÓN PARA MEJORAR LA CAPACIDAD INDIVIDUAL PARA AFRONTAR UNA SITUACIÓN"
  },
  {
    "codigo":784339002,
    "descripcion":"DEFICIENCIA DE ANTAGONISTA DE RECEPTOR DE INTERLEUCINA 36"
  },
  {
    "codigo":294654009,
    "descripcion":"ALERGIA A COMPONENTE DE VACUNA QUE CONTIENE ANTÍGENO DE POLIOVIRUS HUMANO"
  },
  {
    "codigo":292819004,
    "descripcion":"REACCIÓN ADVERSA AL ISOCONAZOL"
  },
  {
    "codigo":391123006,
    "descripcion":"GRADO 2 DE LA ESCALA DE DISNEA DEL MEDICAL RESEARCH COUNCIL"
  },
  {
    "codigo":28840001,
    "descripcion":"PSORIASIS PUSTULOSA GENERALIZADA, TIPO EXANTEMATOSA"
  },
  {
    "codigo":225448001,
    "descripcion":"TIENE UN AMIGO IMAGINARIO"
  },
  {
    "codigo":782504002,
    "descripcion":"OBSTRUCCIÓN INTESTINAL POR HERNIA UMBILICAL RECIDIVANTE"
  },
  {
    "codigo":1081611000119106,
    "descripcion":"RABDOMIOSARCOMA PRIMARIO DE EXTREMIDAD SUPERIOR IZQUIERDA"
  },
  {
    "codigo":1208488006,
    "descripcion":"SÍNDROME ASOCIADO A GEN SATB2"
  },
  {
    "codigo":94376006,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL LÓBULO SUPERIOR IZQUIERDO DEL PULMÓN"
  },
  {
    "codigo":1306792008,
    "descripcion":"INHIBIDOR DE FACTOR DE COAGULACIÓN DETECTADO EN SANGRE DESPUÉS DE TRANSFUSIÓN DE FACTORES DE COAGULACIÓN"
  },
  {
    "codigo":289149001,
    "descripcion":"ALIMENTACIÓN, NORMAL"
  },
  {
    "codigo":127144009,
    "descripcion":"LINFADENOPATÍA MESENTÉRICA"
  },
  {
    "codigo":715133007,
    "descripcion":"INCAPAZ DE PASAR DE UNA SILLA A UNA SILLA DE RUEDAS"
  },
  {
    "codigo":59773008,
    "descripcion":"ALVEOLITIS PULMONAR SIMPLE"
  },
  {
    "codigo":1335890004,
    "descripcion":"RECUPERADO DE EVENTO ADVERSO CON SECUELAS"
  },
  {
    "codigo":57938005,
    "descripcion":"MIOTONÍA CONGÉNITA, FORMA AUTOSÓMICA DOMINANTE"
  },
  {
    "codigo":713298006,
    "descripcion":"ENFERMEDAD CARDÍACA CONCOMITANTE CON INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":1268519001,
    "descripcion":"NEUROBLASTOMA PRIMARIO"
  },
  {
    "codigo":711463004,
    "descripcion":"ALTURA FACIAL POSTERIOR DISMINUIDA"
  },
  {
    "codigo":285479005,
    "descripcion":"CAPAZ DE REDONDEAR LOS LABIOS"
  },
  {
    "codigo":1137447008,
    "descripcion":"ERITEMA DE PIEL DE PÁRPADO"
  },
  {
    "codigo":449319009,
    "descripcion":"NEVO MELANOCÍTICO DE PIEL DEL TÓRAX"
  },
  {
    "codigo":185340004,
    "descripcion":"ENCUENTRO FALLIDO - SE DEJÓ MENSAJE EN CONTESTADOR AUTOMÁTICO"
  },
  {
    "codigo":283644004,
    "descripcion":"HERIDA POR PINCHAZO DE AGUJA EN EL TALÓN"
  },
  {
    "codigo":871633002,
    "descripcion":"ÚLCERA DE INTESTINO DEBIDA A ENFERMEDAD DE INJERTO VERSUS HUÉSPED"
  },
  {
    "codigo":609489005,
    "descripcion":"INTERRUPCIÓN INDUCIDA DEL EMBARAZO COMPLICADA POR EMBOLIA DE JABÓN"
  },
  {
    "codigo":773329005,
    "descripcion":"SÍNDROME CK"
  },
  {
    "codigo":707793005,
    "descripcion":"PIEL CALIENTE"
  },
  {
    "codigo":1363153008,
    "descripcion":"ASTILLA EN HOMBRO CON INFECCIÓN"
  },
  {
    "codigo":50598000,
    "descripcion":"RUPTURA GÁSTRICA"
  },
  {
    "codigo":83366000,
    "descripcion":"QUEMADURAS DE ESPESOR COMPLETO DE MÚLTIPLES SITIOS"
  },
  {
    "codigo":771494001,
    "descripcion":"FRACTURAS QUE COMPROMETEN REGIONES MÚLTIPLES DE LA EXTREMIDAD SUPERIOR DERECHA"
  },
  {
    "codigo":247206004,
    "descripcion":"REMANENTES DE TEJIDO DE LA PAPILA ÓPTICA"
  },
  {
    "codigo":1197478005,
    "descripcion":"INMUNODEFICIENCIA PRIMARIA CON INMUNIDAD LINFOCITARIA ABERRANTE MULTIFACÉTICA"
  },
  {
    "codigo":116134004,
    "descripcion":"NIVEL DE GAMMAGLOBULINAS FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":212603001,
    "descripcion":"INTOXICACIÓN POR NAPROXENO"
  },
  {
    "codigo":81531005,
    "descripcion":"DIABETES MELLITUS TIPO 2 EN PERSONA OBESA"
  },
  {
    "codigo":48763007,
    "descripcion":"HERNIA CONGÉNITA DEL AGUJERO DE MORGAGNI"
  },
  {
    "codigo":1193808000,
    "descripcion":"ENTERITIS EOSINOFÍLICA"
  },
  {
    "codigo":407376001,
    "descripcion":"TRANSEXUAL, HOMBRE A MUJER"
  },
  {
    "codigo":440144004,
    "descripcion":"LESIÓN TRAUMÁTICA POR INTENTO DE SUICIDIO"
  },
  {
    "codigo":16037751000119101,
    "descripcion":"OSTEOCONDROPATÍA CUBITAL BILATERAL"
  },
  {
    "codigo":276304004,
    "descripcion":"PREOCUPACIÓN POR UN DESASTRE"
  },
  {
    "codigo":767824005,
    "descripcion":"HERNIA INGUINAL DERECHA OBSTRUIDA CON GANGRENA"
  },
  {
    "codigo":866128004,
    "descripcion":"MIELITIS CAUSADA POR ROSEOLOVIRUS"
  },
  {
    "codigo":1259344004,
    "descripcion":"CARCINOMA PRIMARIO DE ESÓFAGO CERVICAL"
  },
  {
    "codigo":16675391000119106,
    "descripcion":"ECOGRAFÍA DE RIÑÓN IZQUIERDO ANORMAL"
  },
  {
    "codigo":405541003,
    "descripcion":"HEMORRAGIA BRONQUIAL"
  },
  {
    "codigo":700453005,
    "descripcion":"PÉRDIDA DE LA AUDICIÓN NEUROSENSORIAL CONGÉNITA"
  },
  {
    "codigo":208933005,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE LA ARTICULACIÓN FEMORORROTULIANA, EXTERNA"
  },
  {
    "codigo":45093008,
    "descripcion":"MIOCARDITIS INTERSTICIAL CRÓNICA"
  },
  {
    "codigo":239866002,
    "descripcion":"ARTROSIS DE CODO"
  },
  {
    "codigo":403706003,
    "descripcion":"QUEMADURA CON ELECTROCAUTERIO"
  },
  {
    "codigo":43258006,
    "descripcion":"SÍNDROME LACTOALCALINO"
  },
  {
    "codigo":698618009,
    "descripcion":"PÉRDIDA DE CONSCIENCIA CONCOMITANTE CON FRACTURA EXPUESTA DE CALOTA CRANEAL Y DEBIDA A ELLA"
  },
  {
    "codigo":762319005,
    "descripcion":"TRASTORNO DEL DESARROLLO DEL LENGUAJE CONCOMITANTE CON ALTERACIÓN PREDOMINANTE DEL LENGUAJE PRAGMÁTICO"
  },
  {
    "codigo":238031009,
    "descripcion":"DEFICIENCIA DE ARILSULFATASA S"
  },
  {
    "codigo":301732004,
    "descripcion":"INCAPAZ DE REALIZAR ACTIVIDADES DE TALLER"
  },
  {
    "codigo":400036004,
    "descripcion":"SÍNDROME HIPOPLÁSICO ESMALTE-ONICÓLISIS-HIPOHIDROSIS"
  },
  {
    "codigo":170660006,
    "descripcion":"SIN USO DE ESTEROIDES INHALATORIOS"
  },
  {
    "codigo":430969000,
    "descripcion":"NEUMONÍA ASPIRATIVA RECURRENTE"
  },
  {
    "codigo":299897000,
    "descripcion":"RESPUESTA PLANTAR DERECHA AUSENTE"
  },
  {
    "codigo":15665881000119107,
    "descripcion":"CATARATA CAPSULAR CONGÉNITA DE OJO IZQUIERDO"
  },
  {
    "codigo":234361004,
    "descripcion":"DEFICIENCIA CONGÉNITA DE FACTOR INTRÍNSECO"
  },
  {
    "codigo":103289007,
    "descripcion":"VÉRTIGO PRODUCIDO POR LA HIPEREXTENSIÓN DEL CUELLO"
  },
  {
    "codigo":346841000119108,
    "descripcion":"DACRIOADENITIS CRÓNICA DE AMBOS OJOS"
  },
  {
    "codigo":1084121000119108,
    "descripcion":"OTITIS EXTERNA DE AMBOS CONDUCTOS AUDITIVOS EXTERNOS CAUSADA POR HONGO"
  },
  {
    "codigo":4985009,
    "descripcion":"TRASTORNO DE LA URETRA"
  },
  {
    "codigo":298062005,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE LA CABEZA"
  },
  {
    "codigo":296227002,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE CLORPROMAZINA"
  },
  {
    "codigo":722211006,
    "descripcion":"SÍNDROME DE CONDUCTO ARTERIOSO PERMEABLE, VÁLVULA AÓRTICA BICÚSPIDE Y ANOMALÍAS DE MANO"
  },
  {
    "codigo":230691006,
    "descripcion":"ACCIDENTE CEREBROVASCULAR POR OCLUSIÓN DE ARTERIA CEREBRAL"
  },
  {
    "codigo":720376002,
    "descripcion":"REGISTRADO PARA ACCESO A EDUCACIÓN PARA PACIENTES EN LÍNEA"
  },
  {
    "codigo":294392004,
    "descripcion":"ALERGIA A MEFLOQUINA"
  },
  {
    "codigo":425464007,
    "descripcion":"NEUMONÍA HOSPITALARIA"
  },
  {
    "codigo":390861004,
    "descripcion":"VELOCIDAD DE FLUJO ESPIRATORIO PICO: TÉCNICA CORRECTA"
  },
  {
    "codigo":63181006,
    "descripcion":"ESQUIZOFRENIA PARANOIDE EN REMISIÓN"
  },
  {
    "codigo":292557007,
    "descripcion":"REACCIÓN ADVERSA A LA NIQUETAMIDA"
  },
  {
    "codigo":389026000,
    "descripcion":"ASCITIS"
  },
  {
    "codigo":1306530004,
    "descripcion":"CARCINOMA IN SITU DE PORCIÓN CENTRAL DE MAMA"
  },
  {
    "codigo":28578008,
    "descripcion":"OCLUSIÓN INCIPIENTE DE LA VENA RETINIANA"
  },
  {
    "codigo":716706009,
    "descripcion":"SÍNDROME DE EPILEPSIA CON DISCAPACIDAD INTELECTUAL LIMITADO A LAS MUJERES"
  },
  {
    "codigo":126882009,
    "descripcion":"NEOPLASIA DE URÉTER"
  },
  {
    "codigo":288887001,
    "descripcion":"NO COME"
  },
  {
    "codigo":92279000,
    "descripcion":"NEOPLASIA BENIGNA DE LA GLÁNDULA PARÓTIDA"
  },
  {
    "codigo":714871009,
    "descripcion":"CAPAZ DE MANTENER LA POSICIÓN RECOSTADA"
  },
  {
    "codigo":57676002,
    "descripcion":"DOLOR DE ARTICULACIÓN"
  },
  {
    "codigo":287052003,
    "descripcion":"OSTEOMIELITIS AGUDA DE CADERA"
  },
  {
    "codigo":713036004,
    "descripcion":"DISECCIÓN DE ARTERIA RENAL"
  },
  {
    "codigo":254284003,
    "descripcion":"ANORMALIDAD DE CROMOSOMA SEXUAL - FENOTIPO MASCULINO"
  },
  {
    "codigo":385356007,
    "descripcion":"ESTADIO TUMORAL - HALLAZGO"
  },
  {
    "codigo":23073007,
    "descripcion":"POSTURA DE DESCEREBRACIÓN"
  },
  {
    "codigo":840438001,
    "descripcion":"DISECCIÓN DE ARTERIA VERTEBRAL INTRACRANEAL"
  },
  {
    "codigo":283382002,
    "descripcion":"LACERACIÓN DE LA INGLE"
  },
  {
    "codigo":447222001,
    "descripcion":"GRANULOMA GRAVÍDICO"
  },
  {
    "codigo":54006005,
    "descripcion":"TALASEMIA POR PERSISTENCIA HEREDITARIA DE HEMOGLOBINA FETAL DELTA BETA MÁS"
  },
  {
    "codigo":1297355001,
    "descripcion":"DISPLASIA CONGÉNITA DE ARTICULACIÓN DE RODILLA IZQUIERDA"
  },
  {
    "codigo":84939004,
    "descripcion":"RUBÉOLA EN LA MADRE, QUE COMPLICA EL EMBARAZO, EL PARTO Y\/O EL PUERPERIO"
  },
  {
    "codigo":281547005,
    "descripcion":"RUPTURA DE TENDÓN DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":248779006,
    "descripcion":"NO PUEDE MANTENER UNA ERECCIÓN"
  },
  {
    "codigo":445387007,
    "descripcion":"VEJIGA NEUROGÉNICA CONGÉNITA"
  },
  {
    "codigo":707531008,
    "descripcion":"CARCINOMA PRIMARIO DE CÉLULAS ESCAMOSAS DE HENDIDURA BRANQUIAL"
  },
  {
    "codigo":771232003,
    "descripcion":"QUERATITIS EPITELIAL CAUSADA POR INFECCIÓN"
  },
  {
    "codigo":246944005,
    "descripcion":"SEUDOGERONTOXON"
  },
  {
    "codigo":17568006,
    "descripcion":"ESCLEROSTOSIS"
  },
  {
    "codigo":736629001,
    "descripcion":"NO ES POSIBLE MANTENER LA VÍA AÉREA DEL PACIENTE"
  },
  {
    "codigo":81269001,
    "descripcion":"INFECCIÓN CAUSADA POR GONGYLONEMA INGLUVICOLA"
  },
  {
    "codigo":703861005,
    "descripcion":"HEMATOMA EPIDURAL ESPINAL"
  },
  {
    "codigo":408949005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CONDUCTA PARA CONTROLAR EL DOLOR"
  },
  {
    "codigo":15733007,
    "descripcion":"CARIES INCIPIENTE DEL ESMALTE"
  },
  {
    "codigo":441717007,
    "descripcion":"HEMIPLEJÍA DEL LADO NO DOMINANTE"
  },
  {
    "codigo":310645008,
    "descripcion":"PESTAÑA ADHERIDA AL ORIFICIO DE LA GLÁNDULA DE MEIBOMIO"
  },
  {
    "codigo":276042002,
    "descripcion":"CUIDA A SU PADRE CRÓNICAMENTE ENFERMO"
  },
  {
    "codigo":308810007,
    "descripcion":"SITUACIÓN DEL INFORME POSTMORTEM DEL CIRUJANO POLICIAL"
  },
  {
    "codigo":110367001,
    "descripcion":"NIVEL DE ESTRÓGENOS AUMENTADO"
  },
  {
    "codigo":12063002,
    "descripcion":"PROCTORRAGIA"
  },
  {
    "codigo":77599005,
    "descripcion":"METATARSO VARO"
  },
  {
    "codigo":274207006,
    "descripcion":"SOLVENTES - EFECTOS TÓXICOS"
  },
  {
    "codigo":732959007,
    "descripcion":"NEURODEGENERACIÓN ASOCIADA CON PROTEÍNA CON ESTRUCTURA DE PROPULSOR BETA"
  },
  {
    "codigo":1290015006,
    "descripcion":"TUMOR NEUROENDOCRINO BIEN DIFERENCIADO PRIMARIO DE CUERPO DE ESTÓMAGO"
  },
  {
    "codigo":403444006,
    "descripcion":"ULCERACIÓN TRAUMÁTICA ORAL"
  },
  {
    "codigo":42996007,
    "descripcion":"ILUSIÓN DE INTERMETAMORFOSIS"
  },
  {
    "codigo":1222644009,
    "descripcion":"MIOPATÍA MITOCONDRIAL AUTOSÓMICA DOMINANTE CON INTOLERANCIA A EJERCICIO"
  },
  {
    "codigo":1255412009,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ALCOHOL"
  },
  {
    "codigo":8393005,
    "descripcion":"CONTRACCIONES TETÁNICAS DEL ÚTERO"
  },
  {
    "codigo":237769009,
    "descripcion":"TRASTORNO DEL TRASLADO CORTISOL-CORTISONA"
  },
  {
    "codigo":235934002,
    "descripcion":"DESPLAZAMIENTO DE STENT BILIAR"
  },
  {
    "codigo":301470001,
    "descripcion":"TÍMPANO INFLAMADO"
  },
  {
    "codigo":39326005,
    "descripcion":"MALACOPLASIA DEL ÍLEON"
  },
  {
    "codigo":203166007,
    "descripcion":"OSTEOMIELITIS AGUDA DE CÚBITO"
  },
  {
    "codigo":168563001,
    "descripcion":"RADIOGRAFÍA SIMPLE DE NARIZ ANORMAL"
  },
  {
    "codigo":234099003,
    "descripcion":"LINFEDEMA POR LINFOGRANULOMA VENÉREO"
  },
  {
    "codigo":365171007,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA ENHEBRAR UNA AGUJA"
  },
  {
    "codigo":1348211007,
    "descripcion":"PATRÓN DE USO NOCIVO DE SUSTANCIA SIN DEPENDENCIA"
  },
  {
    "codigo":299635007,
    "descripcion":"CREPITACIÓN PALPABLE DE ARTICULACIÓN DE DEDO DE PIE"
  },
  {
    "codigo":35656003,
    "descripcion":"EMBARAZO INTRALIGAMENTARIO"
  },
  {
    "codigo":232264008,
    "descripcion":"ANQUILOSIS OSICULAR"
  },
  {
    "codigo":197661001,
    "descripcion":"GLOMERULOESCLEROSIS"
  },
  {
    "codigo":263197004,
    "descripcion":"FRACTURA DE CUELLO DE RADIO"
  },
  {
    "codigo":230429005,
    "descripcion":"ENCEFALOPATÍA EPILÉPTICA DE LA PRIMERA INFANCIA CON SUPRESIÓN Y SALVA"
  },
  {
    "codigo":294130000,
    "descripcion":"ALERGIA A CINARIZINA"
  },
  {
    "codigo":164893009,
    "descripcion":"ARRITMIA VENTRICULAR EN EL ELECTROCARDIOGRAMA"
  },
  {
    "codigo":16899701000119102,
    "descripcion":"DOLOR DE ARTICULACIONES DE AMBAS MANOS"
  },
  {
    "codigo":295965008,
    "descripcion":"SOBREDOSIS DE LAMOTRIGINA"
  },
  {
    "codigo":425202006,
    "descripcion":"REPOSO\/SUEÑO INSUFICIENTE PARA LA EDAD"
  },
  {
    "codigo":95687003,
    "descripcion":"HIPOPIGMENTACIÓN ADQUIRIDA DE LA COROIDES"
  },
  {
    "codigo":292295003,
    "descripcion":"REACCIÓN ADVERSA A IPRONIAZIDA"
  },
  {
    "codigo":1177031006,
    "descripcion":"UVEÍTIS INTERMEDIA TUBERCULOSA"
  },
  {
    "codigo":1339036001,
    "descripcion":"EVENTO ADVERSO PERSISTENTE SIN RECUPERACIÓN"
  },
  {
    "codigo":126620001,
    "descripcion":"NEOPLASIA DE MÚSCULO DE HOMBRO"
  },
  {
    "codigo":716444001,
    "descripcion":"CAPAZ DE COMPRAR EN NEGOCIO CERCANO"
  },
  {
    "codigo":92017000,
    "descripcion":"NEOPLASIA BENIGNA DE VASO SANGUÍNEO"
  },
  {
    "codigo":679541000119107,
    "descripcion":"LESIÓN VASCULAR DE PÁRPADO SUPERIOR DERECHO"
  },
  {
    "codigo":419697005,
    "descripcion":"MUERTE - INESPERADA"
  },
  {
    "codigo":12203791000119102,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DE REGIÓN DORSAL DE MANO DERECHA"
  },
  {
    "codigo":288625009,
    "descripcion":"NO EMPLEA LENGUAJE AUTOMÁTICO"
  },
  {
    "codigo":57414003,
    "descripcion":"TIROSINOSIS"
  },
  {
    "codigo":90182005,
    "descripcion":"INSUFICIENCIA HIPOFISARIA INDUCIDA POR HIPOFISECTOMÍA"
  },
  {
    "codigo":254022009,
    "descripcion":"SÍNDROME DE CRÁNEO EN FORMA DE TRÉBOL"
  },
  {
    "codigo":16054031000119104,
    "descripcion":"DISPLASIA GLENOIDEA CONGÉNITA BILATERAL DE ESCÁPULAS"
  },
  {
    "codigo":88347003,
    "descripcion":"INFECCIÓN CAUSADA POR STEPHANURUS DENTATUS"
  },
  {
    "codigo":22811006,
    "descripcion":"LEUCOENCEFALOPATÍA"
  },
  {
    "codigo":283120000,
    "descripcion":"AMPOLLA TRAUMÁTICA DE LA MEJILLA"
  },
  {
    "codigo":1004016001,
    "descripcion":"TRASTORNO FETAL DEBIDO A AMNIOCENTESIS Y POSTERIOR A ELLA"
  },
  {
    "codigo":248517001,
    "descripcion":"TUMORACIÓN EN EL LIMBO CORNEAL"
  },
  {
    "codigo":707269004,
    "descripcion":"CAPAZ DE MANEJAR EL CUIDADO DE LOS PIES"
  },
  {
    "codigo":838341005,
    "descripcion":"LEUCEMIA-LINFOMA LINFOBLÁSTICO DE CÉLULAS B CON REORDENAMIENTO T(V;11Q23); MLL"
  },
  {
    "codigo":1295258000,
    "descripcion":"DOLOR DE RESERVORIO DE BOMBA DE INFUSIÓN INTRATECAL POSTERIOR A IMPLANTE DE BOMBA DE INFUSIÓN INTRATECAL"
  },
  {
    "codigo":445125009,
    "descripcion":"NECROSIS DE TEJIDO CELULAR SUBCUTÁNEO"
  },
  {
    "codigo":84677008,
    "descripcion":"QUEMADURA DE LA EXTREMIDAD INFERIOR"
  },
  {
    "codigo":281285009,
    "descripcion":"ESPÉCIMEN SEPARADO"
  },
  {
    "codigo":246682000,
    "descripcion":"COÁGULO SANGUÍNEO EN OJO"
  },
  {
    "codigo":312218008,
    "descripcion":"OTITIS MEDIA INFECCIOSA"
  },
  {
    "codigo":408687004,
    "descripcion":"GRIPE ASOCIADA CON LA ATENCIÓN MÉDICA"
  },
  {
    "codigo":1162351005,
    "descripcion":"OSTEOSARCOMA DE HUESO DE COSTILLA"
  },
  {
    "codigo":212079004,
    "descripcion":"QUEMADURA QUE COMPROMETE 50-59 PORCIENTO DE LA SUPERFICIE DEL CUERPO, CON QUEMADURA DE ESPESOR COMPLETO QUE AFECTA 20-29 PORCIENTO DE LA SUPERFICIE CORPORAL"
  },
  {
    "codigo":277615007,
    "descripcion":"LINFOMA B DE BAJO GRADO"
  },
  {
    "codigo":243012003,
    "descripcion":"LESIÓN POR CERROJO DE BALLESTA"
  },
  {
    "codigo":210244004,
    "descripcion":"LESIÓN TRAUMÁTICA DE VESÍCULA SEMINAL CON HERIDA ABIERTA HACIA CAVIDAD ABDOMINAL"
  },
  {
    "codigo":110105002,
    "descripcion":"LACERACIÓN SIMPLE CONTAMINADA DEL VESTÍBULO MANDIBULAR"
  },
  {
    "codigo":765465004,
    "descripcion":"TROMBOSIS ASOCIADA CON DISPOSITIVO DE ASISTENCIA VENTRICULAR IZQUIERDA"
  },
  {
    "codigo":350181000221109,
    "descripcion":"LEISHMANIASIS VISCERAL CANINA"
  },
  {
    "codigo":403182006,
    "descripcion":"TATUAJE CUTÁNEO DECORATIVO REALIZADO POR AFICIONADO"
  },
  {
    "codigo":763630007,
    "descripcion":"SÍNDROME DE SATOYOSHI"
  },
  {
    "codigo":9966008,
    "descripcion":"FRACTURA DE ARCO NEURAL"
  },
  {
    "codigo":1156846008,
    "descripcion":"UVEÍTIS DEBIDA A OLIGOARTRITIS IDIOPÁTICA JUVENIL POSITIVA PARA ANTICUERPOS ANTINUCLEARES DE INICIO EXTENDIDO"
  },
  {
    "codigo":237507006,
    "descripcion":"TIROTOXICOSIS INDUCIDA POR GCH"
  },
  {
    "codigo":204739008,
    "descripcion":"MEGACOLON AGANGLIONAR CONGÉNITO"
  },
  {
    "codigo":71832003,
    "descripcion":"ANEMIA HEMOLÍTICA AUTOINMUNITARIA CAUSADA POR INMUNOGLOBULINA M"
  },
  {
    "codigo":301208005,
    "descripcion":"HALLAZGO RELACIONADO CON LA APARIENCIA DE LA LARINGE"
  },
  {
    "codigo":6296006,
    "descripcion":"DILATACIÓN CONGÉNITA DE LA TRÁQUEA"
  },
  {
    "codigo":168301000,
    "descripcion":"ORGANISMO NO AISLADO EN CULTIVO DE HISOPADO DE FAUCES"
  },
  {
    "codigo":170136008,
    "descripcion":"EXAMEN DEL NIÑO A LOS 18 MESES: NORMAL"
  },
  {
    "codigo":364909000,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA MANTENER UNA POSICIÓN"
  },
  {
    "codigo":235672009,
    "descripcion":"FÍSTULA GÁSTRICA INTERNA"
  },
  {
    "codigo":299373004,
    "descripcion":"DOLOR A LA PALPACIÓN EN LA LÍNEA ARTICULAR INTERNA DE LA RODILLA"
  },
  {
    "codigo":4461006,
    "descripcion":"COMPLICACIÓN DE PROCEDIMIENTO ADMINISTRATIVO"
  },
  {
    "codigo":233837006,
    "descripcion":"INFARTO AGUDO NO Q - MASIVO"
  },
  {
    "codigo":68162000,
    "descripcion":"HEMORRAGIA DIGESTIVA BAJA CRÓNICA"
  },
  {
    "codigo":201069009,
    "descripcion":"ATROFIA SENIL DEGENERATIVA DE LA PIEL"
  },
  {
    "codigo":232002000,
    "descripcion":"DEGENERACIÓN RETINIANA EN COPOS"
  },
  {
    "codigo":789058004,
    "descripcion":"FRACTURA EN CUÑA DE EXTREMO INFERIOR DE FÉMUR QUE NO SE EXTIENDE HACIA LA ARTICULACIÓN"
  },
  {
    "codigo":35394006,
    "descripcion":"REACCIÓN AUTOINMUNITARIA POSTVACUNACIÓN"
  },
  {
    "codigo":33559001,
    "descripcion":"SÍNDROME DE HIPERPLASIA DE GLÁNDULA PINEAL Y DIABETES MELLITUS"
  },
  {
    "codigo":262935001,
    "descripcion":"DESGARRO DE LA PARED VAGINAL"
  },
  {
    "codigo":295703006,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE METOTREXATO"
  },
  {
    "codigo":66327008,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE LA MANO"
  },
  {
    "codigo":228332002,
    "descripcion":"CARACTERÍSTICA DE LAS ACTIVIDADES RELACIONADAS CON LA BEBIDA"
  },
  {
    "codigo":293868007,
    "descripcion":"ALERGIA A VIGABATRINA"
  },
  {
    "codigo":29889000,
    "descripcion":"RUPTURA DEL CORAZÓN"
  },
  {
    "codigo":95425001,
    "descripcion":"OSTEOMIELITIS CRÓNICA DEL CRÁNEO"
  },
  {
    "codigo":128193002,
    "descripcion":"TRASTORNO DEL NERVIO FRÉNICO"
  },
  {
    "codigo":292033000,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR PENICILINASA"
  },
  {
    "codigo":16357751000119101,
    "descripcion":"ADENOMA DE GLÁNDULA SUPRARRENAL DERECHA"
  },
  {
    "codigo":62657007,
    "descripcion":"INSUFICIENCIA CARDÍACA Y\/O PARO CARDÍACO POSTERIOR A LA ANESTESIA Y\/O SEDACIÓN EN EL TRABAJO DE PARTO Y\/O PARTO"
  },
  {
    "codigo":783553008,
    "descripcion":"SÍNDROME DE SINDACTILIA, CAMPTODACTILIA Y CLINODACTILIA DE QUINTOS DEDOS DE LAS MANOS Y DEDOS DE LOS PIES BÍFIDOS"
  },
  {
    "codigo":93590001,
    "descripcion":"OSIFICACIÓN INCOMPLETA DE LA MANDÍBULA"
  },
  {
    "codigo":290198001,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ALFENTANILO"
  },
  {
    "codigo":191894006,
    "descripcion":"PATRÓN DE USO EPISÓDICO NOCIVO SIN DEPENDENCIA DE CANNABIS"
  },
  {
    "codigo":301431000119104,
    "descripcion":"ABSCESO DE BOLSA SEROSA DE CADERA IZQUIERDA"
  },
  {
    "codigo":386667005,
    "descripcion":"PUPILAS SIMÉTRICAS, REACTIVAS A LA LUZ Y A LA ACOMODACIÓN"
  },
  {
    "codigo":22071000175105,
    "descripcion":"COMPORTAMIENTO QUE SUPONE RIESGO PARA LA SEGURIDAD DEL PERSONAL"
  },
  {
    "codigo":1173099009,
    "descripcion":"HEMORRAGIA COLÓNICA POR ANGIODISPLASIA"
  },
  {
    "codigo":778048001,
    "descripcion":"PARAPLEJÍA ESPÁSTICA MITOCONDRIAL RELACIONADA CON MT-ATP6"
  },
  {
    "codigo":29751000175105,
    "descripcion":"ÚLCERA POR PRESIÓN EN CADERA DERECHA, ESTADIO III"
  },
  {
    "codigo":253760004,
    "descripcion":"ANILLO ESOFÁGICO CONGÉNITO"
  },
  {
    "codigo":712512004,
    "descripcion":"PERFORACIÓN DE COLON SIGMOIDE"
  },
  {
    "codigo":288363009,
    "descripcion":"CAPAZ DE LEVANTAR OBJETOS"
  },
  {
    "codigo":286528008,
    "descripcion":"MANTIENE LA TEMPERATURA CORRECTA DE LOS ALIMENTOS"
  },
  {
    "codigo":19511000175105,
    "descripcion":"FALTA DE APOYO PARA DEJAR DE FUMAR"
  },
  {
    "codigo":284693002,
    "descripcion":"AUTOINDUCCIÓN DE UN PROLAPSO"
  },
  {
    "codigo":16030071000119107,
    "descripcion":"OSTEOMIELITIS SUBAGUDA DE AMBOS HUESOS FEMORALES"
  },
  {
    "codigo":1234965006,
    "descripcion":"TRASTORNO NEONATAL DEBIDO A NUDO VERDADERO DE CORDÓN UMBILICAL"
  },
  {
    "codigo":251925007,
    "descripcion":"RUPTURA DE VEJIGA URINARIA"
  },
  {
    "codigo":250090003,
    "descripcion":"PROYECCIÓN ANGULAR DEL ACROMION"
  },
  {
    "codigo":446698005,
    "descripcion":"REACTIVACIÓN DE HEPATITIS VIRAL TIPO B"
  },
  {
    "codigo":53482009,
    "descripcion":"CONVULSIÓN PARCIAL SÚBITA"
  },
  {
    "codigo":248255005,
    "descripcion":"NO PUEDE DORMIR EN ABSOLUTO"
  },
  {
    "codigo":444863008,
    "descripcion":"GLAUCOMA DE ÁNGULO ESTRECHO ANATÓMICO CON PRESIÓN INTRAOCULAR LIMÍTROFE"
  },
  {
    "codigo":770708002,
    "descripcion":"REACCIÓN ADVERSA AL FACTOR XI"
  },
  {
    "codigo":17044007,
    "descripcion":"VÍCTIMA DE VIOLACIÓN DE MENORES"
  },
  {
    "codigo":47977000,
    "descripcion":"HEMATOMA MESENTÉRICO"
  },
  {
    "codigo":15675921000119107,
    "descripcion":"TENDINITIS CALCIFICANTE DE AMBOS BRAZOS"
  },
  {
    "codigo":703337007,
    "descripcion":"REQUIERE VACUNACIÓN ANTIDIFTÉRICA, ANTITETÁNICA Y CONTRA LA TOS FERINA"
  },
  {
    "codigo":275518003,
    "descripcion":"VENAS VARICOSAS DE PERINEO"
  },
  {
    "codigo":406590007,
    "descripcion":"INFECCIÓN DEL SISTEMA NERVIOSO CENTRAL POR LISTERIA"
  },
  {
    "codigo":371987000,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE TROMPA DE FALOPIO"
  },
  {
    "codigo":77075001,
    "descripcion":"GLAUCOMA PRIMARIO DE ÁNGULO ABIERTO"
  },
  {
    "codigo":240915002,
    "descripcion":"PROTOTECOSIS"
  },
  {
    "codigo":109843000,
    "descripcion":"HEPATOBLASTOMA (CLÍNICO)"
  },
  {
    "codigo":46451000087100,
    "descripcion":"FRACTURA DE OMÓPLATO IZQUIERDO"
  },
  {
    "codigo":208147005,
    "descripcion":"FRACTURA NO EXPUESTA DE ACETÁBULO, SÓLO LABIO POSTERIOR"
  },
  {
    "codigo":38771000087102,
    "descripcion":"DOLOR MUSCULOESQUELÉTICO CRÓNICO PRIMARIO DE EXTREMIDAD"
  },
  {
    "codigo":271848000,
    "descripcion":"SUPRESIÓN DE LA SECRECIÓN DE ORINA"
  },
  {
    "codigo":173544001,
    "descripcion":"HURGARSE LOS OJOS"
  },
  {
    "codigo":43891000087104,
    "descripcion":"CORTE EN PIEL DE DEDO MEDIO DE MANO DERECHA"
  },
  {
    "codigo":1254888003,
    "descripcion":"HIPERHIDROSIS LOCALIZADA DEBIDA A TRASTORNO NEUROLÓGICO FOCAL"
  },
  {
    "codigo":763368004,
    "descripcion":"HIPERPIGMENTACIÓN E HIPOPIGMENTACIÓN CUTÁNEA PROGRESIVA FAMILIAR"
  },
  {
    "codigo":239080005,
    "descripcion":"VARIACIÓN NORMAL EN LA PIGMENTACIÓN CUTÁNEA"
  },
  {
    "codigo":402920006,
    "descripcion":"SÍNDROME PÁPULO-PURPÚRICO EN GUANTES Y MEDIAS"
  },
  {
    "codigo":1156584007,
    "descripcion":"SÍNDROME DE DISCAPACIDAD INTELECTUAL LIGADA AL CROMOSOMA X-ROSTRO HIPOTÓNICO"
  },
  {
    "codigo":827069000,
    "descripcion":"HIPERTENSIÓN EN ESTADIO 1"
  },
  {
    "codigo":56691000087109,
    "descripcion":"COMENTARIOS DE CARÁCTER SEXUAL INADECUADOS"
  },
  {
    "codigo":41331000087108,
    "descripcion":"HEMATOMA DE TERCER DEDO DE PIE IZQUIERDO"
  },
  {
    "codigo":237245006,
    "descripcion":"SÍNDROME DEL GEMELO EVANESCENTE"
  },
  {
    "codigo":300946000,
    "descripcion":"PULGAR INFECTADO"
  },
  {
    "codigo":1187517009,
    "descripcion":"MIOPATÍA MITOCONDRIAL DE HERENCIA MATERNA"
  },
  {
    "codigo":366482002,
    "descripcion":"HALLAZGO RELACIONADO CON LA AMPLITUD DE LA ADUCCIÓN DE HOMBRO"
  },
  {
    "codigo":73405008,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN LA REGIÓN DEL TRONCO, SIN INFECCIÓN"
  },
  {
    "codigo":38802008,
    "descripcion":"ESTADO POSTPARTO, 5 SEMANAS"
  },
  {
    "codigo":102503000,
    "descripcion":"RECIÉN NACIDO PREMATURO SANO"
  },
  {
    "codigo":299111003,
    "descripcion":"ARTICULACIÓN DE DEDO DE LA MANO DOLOROSA A LA PALPACIÓN"
  },
  {
    "codigo":266343004,
    "descripcion":"HIPERTROFIA DE AMÍGDALA Y\/O ADENOIDES"
  },
  {
    "codigo":264508001,
    "descripcion":"ADENOPATÍA HILIAR BILATERAL"
  },
  {
    "codigo":4199009,
    "descripcion":"SÍNDROME DE TRISOMÍA PARCIAL 18P"
  },
  {
    "codigo":33297000,
    "descripcion":"DEFICIENCIA HEREDITARIA DE FACTOR II"
  },
  {
    "codigo":786961001,
    "descripcion":"DISTENSIÓN DE TENDÓN DE MANO"
  },
  {
    "codigo":295441003,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE PICOSULFATO SÓDICO"
  },
  {
    "codigo":262673004,
    "descripcion":"HERIDA PENETRANTE DE LARINGE"
  },
  {
    "codigo":721425006,
    "descripcion":"FRACTURA DE DECIMOPRIMERA VÉRTEBRA DORSAL"
  },
  {
    "codigo":195302000,
    "descripcion":"GANGRENA DE DEDO DEL PIE"
  },
  {
    "codigo":10681311000119102,
    "descripcion":"NÓDULO DE PIEL DE CABEZA"
  },
  {
    "codigo":12237791000119102,
    "descripcion":"TROMBOSIS AGUDA DE VENA SUPERFICIAL DE AMBOS MIEMBROS SUPERIORES"
  },
  {
    "codigo":129766004,
    "descripcion":"CALCIFICACIÓN DISTRIBUIDA EN GRUPOS"
  },
  {
    "codigo":293606006,
    "descripcion":"ALERGIA A MEPERIDINA"
  },
  {
    "codigo":719590007,
    "descripcion":"GRIPE CAUSADA POR VIRUS INFLUENZA ESTACIONAL"
  },
  {
    "codigo":816059002,
    "descripcion":"TUMORACIÓN PROFUNDA FIJA DE MAMA"
  },
  {
    "codigo":95163004,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA URETRA"
  },
  {
    "codigo":226235006,
    "descripcion":"DIETA DEL CINTURÓN DE MUESLI"
  },
  {
    "codigo":717755007,
    "descripcion":"OBSTRUCCIÓN DE VÍA URINARIA INFERIOR FETAL DEBIDA A VÁLVULA URETRAL ANTERIOR"
  },
  {
    "codigo":93328001,
    "descripcion":"POSICIÓN ANÓMALA CONGÉNITA DE LA VENA CAVA INFERIOR"
  },
  {
    "codigo":781456005,
    "descripcion":"DISTENSIÓN DE TENDÓN FLEXOR DE LA MUÑECA"
  },
  {
    "codigo":714085000,
    "descripcion":"SIN ESCALERAS EN LA RESIDENCIA"
  },
  {
    "codigo":16006111000119107,
    "descripcion":"TROMBOFLEBITIS DE VENA SUPERFICIAL DE AMBOS MIEMBROS SUPERIORES"
  },
  {
    "codigo":1303909005,
    "descripcion":"SENO DÉRMICO ESPINAL CONGÉNITO"
  },
  {
    "codigo":124261008,
    "descripcion":"DEFICIENCIA DE DIHIDROLIPOAMIDA ACETILTRANSFERASA"
  },
  {
    "codigo":253498000,
    "descripcion":"HENDIDURA VERDADERA DE VALVA DE VÁLVULA AURICULOVENTRICULAR IZQUIERDA"
  },
  {
    "codigo":24122006,
    "descripcion":"DESIGUALDAD EN LA CIRCUNFERENCIA"
  },
  {
    "codigo":286266007,
    "descripcion":"INCAPAZ DE USAR DE MANERA CORRECTA LA ARTICULACIÓN DEL HABLA"
  },
  {
    "codigo":56890008,
    "descripcion":"VÍCTIMA DE AGRESIÓN SEXUAL"
  },
  {
    "codigo":251663001,
    "descripcion":"ANOVULATORIO"
  },
  {
    "codigo":87823004,
    "descripcion":"ANQUILOSIS DE LA ARTICULACIÓN LUMBOSACRA"
  },
  {
    "codigo":249828003,
    "descripcion":"PIERNAS EN BOTELLA DE CHAMPÁN INVERTIDA"
  },
  {
    "codigo":446436004,
    "descripcion":"QUISTE EPIDERMOIDE DE PIEL DE CUERO CABELLUDO"
  },
  {
    "codigo":282596003,
    "descripcion":"SALTA ALTERNANDO LOS PIES"
  },
  {
    "codigo":332921000119107,
    "descripcion":"IRIDOCICLITIS PRIMARIA DE OJO DERECHO"
  },
  {
    "codigo":84153003,
    "descripcion":"COJERA POR PIERNA CORTA"
  },
  {
    "codigo":247993007,
    "descripcion":"REGALA PROPIEDADES"
  },
  {
    "codigo":442766007,
    "descripcion":"ALCOHOL EN ESPÉCIMEN DE SANGRE POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":735843000,
    "descripcion":"RUPTURA DE LIGAMENTO CALCANEOPERONEO"
  },
  {
    "codigo":211555008,
    "descripcion":"LESIÓN TRAUMÁTICA CERRADA POR APLASTAMIENTO, REGIÓN CLAVICULAR"
  },
  {
    "codigo":80483009,
    "descripcion":"ABSCESO DE GLÁNDULA SALIVAL"
  },
  {
    "codigo":209720001,
    "descripcion":"SECCIÓN EXPUESTA DE LIGAMENTO SACROILÍACO ANTERIOR"
  },
  {
    "codigo":111416005,
    "descripcion":"CELULITIS DEL CUERPO CAVERNOSO"
  },
  {
    "codigo":450251000124102,
    "descripcion":"TRASTORNO DE ARTERIA DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":78648007,
    "descripcion":"CON MAYOR RIESGO DE INFECCIÓN"
  },
  {
    "codigo":2251000124102,
    "descripcion":"SEGUNDO MOLAR INFERIOR DERECHO DECIDUO SUPERNUMERARIO"
  },
  {
    "codigo":109581004,
    "descripcion":"CARIES DE LA INFANCIA ASOCIADAS CON LA ALIMENTACIÓN CON MAMADERA"
  },
  {
    "codigo":611531000124109,
    "descripcion":"INSEGURIDAD HABITACIONAL"
  },
  {
    "codigo":238818000,
    "descripcion":"ERITEMA NO BULLOSO MULTIFORME"
  },
  {
    "codigo":240653009,
    "descripcion":"ENFERMEDAD DE CHAGAS AGUDA"
  },
  {
    "codigo":76813008,
    "descripcion":"GRANULOMA PIOGÉNICO DE LA MUCOSA ORAL"
  },
  {
    "codigo":1287394003,
    "descripcion":"HERIDA POR ARMA DE FUEGO DE REGIÓN DE CADERA"
  },
  {
    "codigo":402658008,
    "descripcion":"VASCULITIS TIPO ENFERMEDAD DEL SUERO"
  },
  {
    "codigo":9442009,
    "descripcion":"HEMORRAGIA ASOCIADA CON AFIBRINOGENEMIA DE LAS PARTURIENTAS"
  },
  {
    "codigo":1187255000,
    "descripcion":"PARESTESIA EN SILLA DE MONTAR"
  },
  {
    "codigo":7607008,
    "descripcion":"PERICARDITIS REUMATOIDE"
  },
  {
    "codigo":38540001,
    "descripcion":"ESGUINCE DE ARTICULACIÓN INTERFALÁNGICA DE DEDO DE LA MANO"
  },
  {
    "codigo":202380002,
    "descripcion":"DERRAME DE ARTICULACIÓN SACROILÍACA"
  },
  {
    "codigo":366220005,
    "descripcion":"PRESENCIA DENTAL - HALLAZGO"
  },
  {
    "codigo":724833000,
    "descripcion":"SUPERPOSICIÓN DE SÍNDROME DE STEVENS-JOHNSON Y NECRÓLISIS EPIDÉRMICA TÓXICA CAUSADA POR FÁRMACO"
  },
  {
    "codigo":266081001,
    "descripcion":"COLITIS, ENTERITIS Y GASTROENTERITIS PRESUNTAMENTE INFECCIOSAS"
  },
  {
    "codigo":300684008,
    "descripcion":"ADMINISTRA LAS ACTIVIDADES FINANCIERAS PERSONALES"
  },
  {
    "codigo":167777002,
    "descripcion":"CANTIDAD SUFICIENTE DE ESPERMATOZOIDES\/CC: SUPERIOR A 60 MILLONES"
  },
  {
    "codigo":298849007,
    "descripcion":"AMPLITUD DE CIRCUNDUCCIÓN PASIVA DE HOMBRO NORMAL"
  },
  {
    "codigo":297014002,
    "descripcion":"SOBREDOSIS INTENCIONAL DE CLOROTIAZIDA"
  },
  {
    "codigo":722998005,
    "descripcion":"HIPERACTIVIDAD DEL SISTEMA NERVIOSO AUTÓNOMO"
  },
  {
    "codigo":67638006,
    "descripcion":"PSEUDOQUISTE DE LA RETINA"
  },
  {
    "codigo":2102007,
    "descripcion":"VASCULARIZACIÓN PROFUNDA DE LA CÓRNEA"
  },
  {
    "codigo":231478008,
    "descripcion":"DEPENDENCIA DE METADONA"
  },
  {
    "codigo":426251001,
    "descripcion":"DISPOSICIÓN PARA MEJORAR LA FUNCIÓN PARENTAL"
  },
  {
    "codigo":721163008,
    "descripcion":"SOBRECARGA DE LÍQUIDO SIN EDEMA"
  },
  {
    "codigo":229643008,
    "descripcion":"VOZ ASOCIADA CON SORDERA"
  },
  {
    "codigo":1145312002,
    "descripcion":"HIPOPLASIA CONGÉNITA DE TERCIO MEDIO FACIAL"
  },
  {
    "codigo":335431000119105,
    "descripcion":"PLIEGUE DE MEMBRANA DE DESCEMET DE OJO DERECHO"
  },
  {
    "codigo":293344008,
    "descripcion":"REACCIÓN ADVERSA A LA WARFARINA"
  },
  {
    "codigo":424416009,
    "descripcion":"LUXACIÓN COMPLETA DE CRISTALINO"
  },
  {
    "codigo":94901005,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA PARED LATERAL DE LA NASOFARINGE"
  },
  {
    "codigo":225973006,
    "descripcion":"CAPAZ DE MANTENER LA AUTOESTIMA"
  },
  {
    "codigo":422581008,
    "descripcion":"CARCINOMA DE COLON, ESTADIO II"
  },
  {
    "codigo":289674002,
    "descripcion":"CUERPO DEL ÚTERO NORMAL"
  },
  {
    "codigo":60298004,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN LA REGIÓN DEL ANTEBRAZO, CON INFECCIÓN"
  },
  {
    "codigo":11777761000119103,
    "descripcion":"RUPTURA TRAUMÁTICA DE TENDÓN DE MÚSCULO SUPRAESPINOSO DERECHO"
  },
  {
    "codigo":93066007,
    "descripcion":"GASTROPTOSIS CONGÉNITA"
  },
  {
    "codigo":58463002,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE LA CADERA, SIN INFECCIÓN"
  },
  {
    "codigo":10958561000119105,
    "descripcion":"HERIDA ABIERTA DE PIE DERECHO"
  },
  {
    "codigo":255071008,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS DE LABIO"
  },
  {
    "codigo":253236002,
    "descripcion":"MALFORMACIÓN CONGÉNITA DEL HUMOR VÍTREO"
  },
  {
    "codigo":417076003,
    "descripcion":"LUXACIÓN DE ARTICULACIÓN DE HOMBRO"
  },
  {
    "codigo":286004001,
    "descripcion":"INCAPAZ DE CERRAR LA TUBERÍA DE GAS MAESTRA"
  },
  {
    "codigo":449844005,
    "descripcion":"PRÓTESIS MAMARIA IN SITU"
  },
  {
    "codigo":187700006,
    "descripcion":"NEOPLASIA MALIGNA DE PARED ANTERIOR DE NASOFARINGE"
  },
  {
    "codigo":23860007,
    "descripcion":"XILOSURIA"
  },
  {
    "codigo":1269044006,
    "descripcion":"TUMOR DESMOPLÁSICO DE CÉLULAS PEQUEÑAS Y REDONDAS PRIMARIO"
  },
  {
    "codigo":145121000119106,
    "descripcion":"PATRÓN DE USO NOCIVO DE OPIOIDE ENDOVENOSO SIN DEPENDENCIA"
  },
  {
    "codigo":251401005,
    "descripcion":"INTOLERANCIA A LA D-XILOSA"
  },
  {
    "codigo":22025006,
    "descripcion":"CONTRACTURA ISQUÉMICA DE VOLKMANN POSTERIOR A LESIÓN TRAUMÁTICA"
  },
  {
    "codigo":415241007,
    "descripcion":"HALLAZGO RELACIONADO CON LA DISPOSICIÓN PARA MEJORAR"
  },
  {
    "codigo":216798009,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR BERILIO Y\/O COMPUESTO DE BERILIO"
  },
  {
    "codigo":247731002,
    "descripcion":"ALUCINACIONES AUDITIVAS NO VERBALES"
  },
  {
    "codigo":16415501000119100,
    "descripcion":"ISQUEMIA VISCERAL AGUDA"
  },
  {
    "codigo":166582541000119101,
    "descripcion":"PROLAPSO DE YEYUNOSTOMÍA"
  },
  {
    "codigo":11858701000119101,
    "descripcion":"LESIÓN TRAUMÁTICA DE VENA POPLÍTEA DERECHA"
  },
  {
    "codigo":10972941000119103,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO DIGITAL DE DEDO MEDIO DERECHO"
  },
  {
    "codigo":305421000119104,
    "descripcion":"CONTRACTURA DE MÚSCULO DE BRAZO DERECHO"
  },
  {
    "codigo":3341000119104,
    "descripcion":"EQUIMOSIS DEBIDA A TRAUMATISMO"
  },
  {
    "codigo":323341000119106,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE MUSLO"
  },
  {
    "codigo":704648003,
    "descripcion":"EDEMA EXUDATIVO"
  },
  {
    "codigo":10760461000119107,
    "descripcion":"TRASTORNO PSICÓTICO MATERNO QUE COMPLICA EL EMBARAZO"
  },
  {
    "codigo":10809101000119109,
    "descripcion":"HIPOTIROIDISMO EN EL MOMENTO DEL NACIMIENTO"
  },
  {
    "codigo":15952141000119106,
    "descripcion":"TUMEFACCIÓN EN LA GLÁNDULA PARÓTIDA IZQUIERDA"
  },
  {
    "codigo":1360008007,
    "descripcion":"CON MAYOR RIESGO DE ALTERACIÓN DE FUNCIÓN MUSCULOESQUELÉTICA"
  },
  {
    "codigo":15934221000119103,
    "descripcion":"DEDO EN MARTILLO ADQUIRIDO DE SEGUNDO A QUINTO DEDOS DE PIE IZQUIERDO"
  },
  {
    "codigo":781000119106,
    "descripcion":"ARTROPATÍA NEUROPÁTICA DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":333581000119106,
    "descripcion":"OFTALMÍA NODOSA DERECHA"
  },
  {
    "codigo":409736002,
    "descripcion":"CLASIFICACIÓN INTERNACIONAL DE NEUROBLASTOMA: GRUPO CON HISTOLOGÍA DESFAVORABLE, PACIENTE DE CUALQUIER EDAD, CON NEUROBLASTOMA INDIFERENCIADO"
  },
  {
    "codigo":735581004,
    "descripcion":"DEFECTO DEL TABIQUE INTERVENTRICULAR POSTERIOR A PROCEDIMIENTO"
  },
  {
    "codigo":113421000119109,
    "descripcion":"INFESTACIÓN CUTÁNEA"
  },
  {
    "codigo":11848461000119109,
    "descripcion":"ABRASIÓN DE PIEL DE PÁRPADO DERECHO"
  },
  {
    "codigo":473437005,
    "descripcion":"LIPOMA PAROSTAL"
  },
  {
    "codigo":1259869008,
    "descripcion":"HEMATOMA DE CAPA DARTOS DE ESCROTO"
  },
  {
    "codigo":1290802001,
    "descripcion":"QUISTE SINOVIAL DE TOBILLO"
  },
  {
    "codigo":307762000,
    "descripcion":"DEPRESIÓN DE MÉDULA ÓSEA"
  },
  {
    "codigo":209458003,
    "descripcion":"ESGUINCE DEL LIGAMENTO INTERCARPIANO PALMAR O V LIGAMENTO"
  },
  {
    "codigo":276829003,
    "descripcion":"GLIOBLASTOMA MULTIFORME DE MÉDULA ESPINAL"
  },
  {
    "codigo":240391001,
    "descripcion":"MELIOIDOSIS PULMONAR"
  },
  {
    "codigo":897586009,
    "descripcion":"DESVIACIÓN RADIAL CONGÉNITA DE DEDOS DE AMBAS MANOS"
  },
  {
    "codigo":109319005,
    "descripcion":"OSTEOMIELITIS CRÓNICA DE HUESO TEMPORAL"
  },
  {
    "codigo":43783005,
    "descripcion":"BEBEDOR MODERADO"
  },
  {
    "codigo":271324001,
    "descripcion":"NEOPLASIA BENIGNA DE LABIO, CAVIDAD BUCAL Y\/O FARINGE"
  },
  {
    "codigo":402396002,
    "descripcion":"REACCIÓN DE HIPERSENSIBILIDAD NO ALÉRGICA CAUSADA POR MEDIO DE RADIOCONTRASTE"
  },
  {
    "codigo":205788004,
    "descripcion":"SÍNDROME DE ALCOHOLISMO FETAL"
  },
  {
    "codigo":369628006,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA DE VEJIGA, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":236721000,
    "descripcion":"CANDIDURIA"
  },
  {
    "codigo":238556009,
    "descripcion":"ECCEMA HIPERQUERATÓSICO DE PALMAS"
  },
  {
    "codigo":1075221000119107,
    "descripcion":"PIE CAVO ADQUIRIDO IZQUIERDO"
  },
  {
    "codigo":72881003,
    "descripcion":"MEGALOAPÉNDICE"
  },
  {
    "codigo":269489006,
    "descripcion":"NEOPLASIA BENIGNA DE PARÉNQUIMA RENAL"
  },
  {
    "codigo":300422001,
    "descripcion":"HALLAZGO RELACIONADO CON UNA PULSACIÓN EN EL ABDOMEN"
  },
  {
    "codigo":105649009,
    "descripcion":"ENFERMEDAD CAUSADA POR PLASMODIIDAE"
  },
  {
    "codigo":398726004,
    "descripcion":"ENFERMEDAD PULMONAR REUMATOIDEA"
  },
  {
    "codigo":13331000202101,
    "descripcion":"DIFICULTAD PARA EQUILIBRAR ACTIVIDAD Y DESCANSO"
  },
  {
    "codigo":267654007,
    "descripcion":"MIOSITIS ORBITARIA CRÓNICA"
  },
  {
    "codigo":5510009,
    "descripcion":"TRASTORNO DELIRANTE ORGÁNICO"
  },
  {
    "codigo":726406009,
    "descripcion":"POSICIÓN ANÓMALA CONGÉNITA DE PÁRPADO"
  },
  {
    "codigo":202118009,
    "descripcion":"DESGARRO PARCIAL ANTIGUO DE LIGAMENTO LATERAL INTERNO DE RODILLA"
  },
  {
    "codigo":429659006,
    "descripcion":"INFECCIÓN POR VIRUS LINFOTRÓPICO DE CÉLULAS T HUMANO TIPO 1"
  },
  {
    "codigo":298587008,
    "descripcion":"COLUMNA VERTEBRAL DORSAL HELADA"
  },
  {
    "codigo":427824002,
    "descripcion":"BACILOS PEQUEÑOS GRAMNEGATIVOS"
  },
  {
    "codigo":460592003,
    "descripcion":"ANILLO VASCULAR CON CAYADO AÓRTICO DERECHO Y CONDUCTO ARTERIOSO IZQUIERDO DESDE DIVERTÍCULO RETROESOFÁGICO DE AORTA Y ARTERIA SUBCLAVIA IZQUIERDA ANÓMALA"
  },
  {
    "codigo":198448006,
    "descripcion":"INFERTILIDAD FEMENINA DE ORIGEN HIPOFISARIO-HIPOTALÁMICO"
  },
  {
    "codigo":249523004,
    "descripcion":"DESCONOCE SI EXPULSA FLATOS"
  },
  {
    "codigo":165680008,
    "descripcion":"HEMOGLOBINA A1C ENTRE 7% Y 10%, INDICATIVA DE CONTROL DE LA DIABETES EN EL LÍMITE"
  },
  {
    "codigo":131077008,
    "descripcion":"NIVEL DE TESTOSTERONA POR ENCIMA DE RANGO DE REFERENCIA"
  },
  {
    "codigo":1145050003,
    "descripcion":"SOBREDOSIS DE TIOPENTAL"
  },
  {
    "codigo":293082006,
    "descripcion":"REACCIÓN ADVERSA A LA CLOFAZIMINA"
  },
  {
    "codigo":94639000,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA FOSA AMIGDALINA"
  },
  {
    "codigo":717231003,
    "descripcion":"SÍNDROME DE FIEBRE PERIÓDICA Y ESTOMATITIS AFTOSA CON FARINGITIS Y LINFADENITIS CERVICAL"
  },
  {
    "codigo":285001000119105,
    "descripcion":"ENFERMEDAD RENAL CRÓNICA DEBIDA A HIPERTENSIÓN BENIGNA, ESTADIO 4"
  },
  {
    "codigo":291247009,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR MARIHUANA"
  },
  {
    "codigo":92804002,
    "descripcion":"GINGIVITIS CATARRAL"
  },
  {
    "codigo":289412002,
    "descripcion":"FONTANELA ANTERIOR PALPABLE EN EL CUADRANTE ANTERIOR"
  },
  {
    "codigo":254809002,
    "descripcion":"NEVO AZUL CELULAR DE CUERO CABELLUDO"
  },
  {
    "codigo":1303385009,
    "descripcion":"FRACTURA ÓSEA DE TOBILLO DERECHO"
  },
  {
    "codigo":252974005,
    "descripcion":"PRUEBA DE OCLUSIÓN - VISIÓN CERCANA"
  },
  {
    "codigo":54531000,
    "descripcion":"INTOXICACIÓN POR PENICILINA G"
  },
  {
    "codigo":285742008,
    "descripcion":"OYE VOCES RIÉNDOSE DE ÉL\/ELLA"
  },
  {
    "codigo":283907002,
    "descripcion":"HEMATOMA DE URÉTER"
  },
  {
    "codigo":21763005,
    "descripcion":"LESIÓN DENTAL"
  },
  {
    "codigo":183768000,
    "descripcion":"INSCRIPTO EN LISTA DE ADMISIÓN DE MEDICINA GENERAL"
  },
  {
    "codigo":251139008,
    "descripcion":"SOSPECHA DE INVERSIÓN DE DERIVACIONES ECG EN EL BRAZO"
  },
  {
    "codigo":1332483008,
    "descripcion":"MELANOMA MALIGNO DE CÉLULAS BALONIZADAS METASTÁSICO"
  },
  {
    "codigo":282072003,
    "descripcion":"PERFORACIÓN TARDÍA DEL ÍLEON"
  },
  {
    "codigo":118232004,
    "descripcion":"HALLAZGO EN EL APARATO REPRODUCTOR"
  },
  {
    "codigo":249304005,
    "descripcion":"UNA MOLESTIA EN EL MEATO URETRAL"
  },
  {
    "codigo":216536007,
    "descripcion":"INTOXICACIÓN ACCIDENTAL CAUSADA POR NITRAZEPAM"
  },
  {
    "codigo":1363416008,
    "descripcion":"SINEQUIAS ANTERIORES PERIFÉRICAS EN CUADRANTE TEMPORAL DE ÁNGULO IRIDOCORNEAL"
  },
  {
    "codigo":314840009,
    "descripcion":"ATAXIA PROGRESIVA"
  },
  {
    "codigo":1197741006,
    "descripcion":"HEMORRAGIA DE INTESTINO GRUESO POR DIVERTICULITIS"
  },
  {
    "codigo":868226001,
    "descripcion":"INFARTO AGUDO DE MIOCARDIO CON ELEVACIÓN DEL SEGMENTO ST DEBIDO A OCLUSIÓN DE RAMA LATERAL POSTERIOR DE ARTERIA CORONARIA DERECHA"
  },
  {
    "codigo":49026002,
    "descripcion":"DESTRUCCIÓN DE LINFOCITOS AUMENTADA"
  },
  {
    "codigo":1163138003,
    "descripcion":"COCCIDIOIDOMICOSIS ARTICULAR"
  },
  {
    "codigo":473175000,
    "descripcion":"DESPLAZAMIENTO DE DISPOSITIVO DE FIJACIÓN INTERNA"
  },
  {
    "codigo":702551003,
    "descripcion":"INCAPAZ DE TRAGAR UN COMPRIMIDO"
  },
  {
    "codigo":276567007,
    "descripcion":"ACIDOSIS FETAL PREPARTO"
  },
  {
    "codigo":12588000,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE EXTREMO DISTAL DE CÚBITO"
  },
  {
    "codigo":47191007,
    "descripcion":"INTOXICACIÓN CAUSADA POR BLEOMICINA"
  },
  {
    "codigo":16288381000119105,
    "descripcion":"DISECCIÓN DE AMBAS ARTERIAS FEMORALES"
  },
  {
    "codigo":241964004,
    "descripcion":"ANGIOEDEMA-URTICARIA PRODUCIDO POR BENZOATO DE SODIO"
  },
  {
    "codigo":766252004,
    "descripcion":"MIOSITIS JUVENIL CON SUPERPOSICIÓN"
  },
  {
    "codigo":209196006,
    "descripcion":"SÍNDROME MEDULAR POSTERIOR DE MÉDULA LUMBAR DEBIDO A SUBLUXACIÓN VERTEBRAL EXPUESTA DE COLUMNA LUMBAR"
  },
  {
    "codigo":274732007,
    "descripcion":"EXTRAVASACIÓN DE ORINA"
  },
  {
    "codigo":307500008,
    "descripcion":"ARTRITIS DE LA ARTICULACIÓN CRICOARITENOIDE"
  },
  {
    "codigo":373036008,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM HODLERI"
  },
  {
    "codigo":240129002,
    "descripcion":"ATROFIA MUSCULAR POR DESUSO"
  },
  {
    "codigo":16206461000119106,
    "descripcion":"SÍNDROME DE NERVIO INTERÓSEO POSTERIOR BILATERAL"
  },
  {
    "codigo":45356009,
    "descripcion":"FRACTURA NO EXPUESTA DE UNA COSTILLA"
  },
  {
    "codigo":698881006,
    "descripcion":"COROIDITIS DISEMINADA GENERALIZADA"
  },
  {
    "codigo":43521007,
    "descripcion":"DEPÓSITO CORNEAL ASOCIADO CON TRASTORNO METABÓLICO"
  },
  {
    "codigo":305665008,
    "descripcion":"ATENDIDO POR NEUMONÓLOGO"
  },
  {
    "codigo":402134005,
    "descripcion":"ONICOMICOSIS CAUSADA POR DERMATOFITO"
  },
  {
    "codigo":762582006,
    "descripcion":"URANOSQUISIS CON LABIO LEPORINO DERECHO Y FISURA ALVEOLAR DERECHA"
  },
  {
    "codigo":860886009,
    "descripcion":"GRANULOMA DE ENCÉFALO CAUSADO POR SCHISTOSOMA MANSONI"
  },
  {
    "codigo":433067002,
    "descripcion":"ADAMANTINOMA DE FÉMUR"
  },
  {
    "codigo":5248000,
    "descripcion":"EDEMA SUPRAGLÓTICO"
  },
  {
    "codigo":301995008,
    "descripcion":"ACEPTA BASE DE APOYO"
  },
  {
    "codigo":236459009,
    "descripcion":"MALACOPLAQUIA RENAL"
  },
  {
    "codigo":234624002,
    "descripcion":"DEFICIENCIA DEL ACELERADOR DE LA DEGRADACIÓN DE LA CONVERTASA DEL COMPLEMENTO C3"
  },
  {
    "codigo":300160004,
    "descripcion":"HALLAZGO RELACIONADO CON TUBO DE VENTILACIÓN TIMPÁNICA"
  },
  {
    "codigo":16016151000119105,
    "descripcion":"CONDROCALCINOSIS DE AMBOS PIES"
  },
  {
    "codigo":429397000,
    "descripcion":"FORMACIÓN DE ERITROCITOS EN PILAS DE MONEDAS EN ARTERIA DE LA RETINA"
  },
  {
    "codigo":365696009,
    "descripcion":"MICROSCOPIA URINARIA: MICROORGANISMOS\/CUERPOS EXTRAÑOS - HALLAZGO"
  },
  {
    "codigo":70784009,
    "descripcion":"IRRITACIÓN MENÍNGEA"
  },
  {
    "codigo":1217664009,
    "descripcion":"QUISTE COLOBOMATOSO CONGÉNITO DE ÓRBITA"
  },
  {
    "codigo":298325004,
    "descripcion":"HALLAZGO RELACIONADO CON EL MOVIMIENTO"
  },
  {
    "codigo":462165005,
    "descripcion":"QUISTE DE PLEXO COROIDEO FETAL"
  },
  {
    "codigo":396629005,
    "descripcion":"MARGEN QUIRÚRGICO COMPROMETIDO POR CARCINOMA IN SITU"
  },
  {
    "codigo":68949000,
    "descripcion":"INFECCIÓN CAUSADA POR VIRUS PARAINFLUENZA 4 HUMANO"
  },
  {
    "codigo":788010000,
    "descripcion":"PERITONITIS PÉLVICA"
  },
  {
    "codigo":34346002,
    "descripcion":"COLECISTITIS ALITIÁSICA AGUDA"
  },
  {
    "codigo":198186006,
    "descripcion":"PIOMETRITIS SUBAGUDA"
  },
  {
    "codigo":1279530007,
    "descripcion":"SANGRADO DEBIDO A TRATAMIENTO CON ASPIRINA"
  },
  {
    "codigo":427562009,
    "descripcion":"SANGRE EN VÍA AÉREA SUPERIOR"
  },
  {
    "codigo":32511005,
    "descripcion":"EVALUACIÓN DE DISCAPACIDAD: ALTERACIÓN CLASE 1"
  },
  {
    "codigo":294655005,
    "descripcion":"ALERGIA A COMPONENTE DE VACUNA QUE CONTIENE ANTÍGENO DE LYSSAVIRUS DE LA RABIA"
  },
  {
    "codigo":720639008,
    "descripcion":"SÍNDROME DE COLOBOMA, CARDIOPATÍA CONGÉNITA, DERMATOSIS ICTIOSIFORME, DISCAPACIDAD INTELECTUAL Y ANOMALÍAS AUDITIVAS"
  },
  {
    "codigo":391124000,
    "descripcion":"GRADO 3 DE LA ESCALA DE DISNEA DEL MEDICAL RESEARCH COUNCIL"
  },
  {
    "codigo":784340000,
    "descripcion":"INMUNODEFICIENCIA COMBINADA DEBIDA A DEFICIENCIA DE RECEPTOR DE INTERLEUCINA 21"
  },
  {
    "codigo":63444004,
    "descripcion":"TROMBOCITOPENIA POR HIPERESPLENISMO"
  },
  {
    "codigo":292820005,
    "descripcion":"REACCIÓN ADVERSA AL SULCONAZOL"
  },
  {
    "codigo":782505001,
    "descripcion":"HERNIA FEMORAL RECURRENTE OBSTRUIDA"
  },
  {
    "codigo":423892009,
    "descripcion":"INFECCIÓN DE LA MANO POR MICOBACTERIAS ATÍPICAS"
  },
  {
    "codigo":61609004,
    "descripcion":"COCOS GRAMPOSITIVOS EN CADENAS"
  },
  {
    "codigo":127145005,
    "descripcion":"LINFADENOPATÍA MESENTÉRICA INFERIOR"
  },
  {
    "codigo":289150001,
    "descripcion":"HALLAZGO RELACIONADO CON LA VELOCIDAD PARA BEBER"
  },
  {
    "codigo":225449009,
    "descripcion":"PENSAMIENTOS RAROS"
  },
  {
    "codigo":290985009,
    "descripcion":"INTOXICACIÓN POR ZOPICLONA"
  },
  {
    "codigo":190846002,
    "descripcion":"HEMOSIDEROSIS, PRIMARIA"
  },
  {
    "codigo":92542002,
    "descripcion":"CARCINOMA IN SITU DE COLON ASCENDENTE"
  },
  {
    "codigo":715134001,
    "descripcion":"INCAPAZ DE PASAR DEL INODORO A UNA SILLA"
  },
  {
    "codigo":1335891000,
    "descripcion":"LESIÓN TRAUMÁTICA DE ENCÉFALO POR EXPLOSIÓN"
  },
  {
    "codigo":254547001,
    "descripcion":"CARCINOMA DE TERCIO SUPERIOR DE ESÓFAGO"
  },
  {
    "codigo":713299003,
    "descripcion":"TRASTORNO DEL GLOBO OCULAR PROPIAMENTE DICHO CONCOMITANTE CON INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":187176005,
    "descripcion":"ESTRONGILOIDIASIS DISEMINADA"
  },
  {
    "codigo":185341000,
    "descripcion":"ENCUENTRO FALLIDO - IMPOSIBLE OBTENER EL NÚMERO DE TELÉFONO"
  },
  {
    "codigo":285480008,
    "descripcion":"INCAPAZ DE REDONDEAR LOS LABIOS"
  },
  {
    "codigo":283645003,
    "descripcion":"SÍNDROME DE LEV"
  },
  {
    "codigo":773330000,
    "descripcion":"ENFERMEDAD DE CHARCOT-MARIE-TOOTH INTERMEDIA AUTOSÓMICA RECESIVA TIPO B"
  },
  {
    "codigo":609490001,
    "descripcion":"INTERRUPCIÓN INDUCIDA DEL EMBARAZO COMPLICADA POR UREMIA"
  },
  {
    "codigo":1363154002,
    "descripcion":"ASTILLA EN BRAZO"
  },
  {
    "codigo":52434006,
    "descripcion":"DISTENSIBILIDAD PULMONAR DISMINUIDA"
  },
  {
    "codigo":249042007,
    "descripcion":"HALLAZGO RELACIONADO CON EL CORAZÓN DEL FETO"
  },
  {
    "codigo":871634008,
    "descripcion":"VERRUGAS DE REGIÓN PERIANAL EN LA LACTANCIA CAUSADAS POR PAPILOMAVIRUS HUMANO"
  },
  {
    "codigo":771495000,
    "descripcion":"FRACTURAS EXPUESTAS QUE COMPROMETEN MÚLTIPLES ÁREAS DE LA EXTREMIDAD SUPERIOR IZQUIERDA"
  },
  {
    "codigo":1197479002,
    "descripcion":"DEFICIENCIA DE DOCK 2"
  },
  {
    "codigo":445650008,
    "descripcion":"ORIFICIO AÓRTICO ANTERIOR IZQUIERDO CON RESPECTO A ORIFICIO PULMONAR"
  },
  {
    "codigo":247207008,
    "descripcion":"RESTOS VASCULARES HIALOIDES DE LA PAPILA ÓPTICA"
  },
  {
    "codigo":83367009,
    "descripcion":"TRASTORNO MENTAL ORGÁNICO INDUCIDO POR ANFETAMINA"
  },
  {
    "codigo":441980007,
    "descripcion":"CUADRIPLEJÍA COMPLETA DEBIDA A LESIÓN DE MÉDULA ESPINAL ENTRE QUINTA Y SÉPTIMA VÉRTEBRAS CERVICALES"
  },
  {
    "codigo":15936741000119107,
    "descripcion":"ERISIPELA DE EXTREMIDAD INFERIOR IZQUIERDA"
  },
  {
    "codigo":10939621000119107,
    "descripcion":"LACERACIÓN DE HOMBRO DERECHO"
  },
  {
    "codigo":1259345003,
    "descripcion":"CARCINOMA PRIMARIO DE PORCIÓN TORÁCICA DE ESÓFAGO"
  },
  {
    "codigo":407377005,
    "descripcion":"TRANSEXUAL, MUJER A HOMBRE"
  },
  {
    "codigo":276305003,
    "descripcion":"PREOCUPACIÓN POR LA RUINA"
  },
  {
    "codigo":866129007,
    "descripcion":"MIELITIS CAUSADA POR VIRUS LINFOTRÓPICO T TIPO 1"
  },
  {
    "codigo":12326000,
    "descripcion":"ACIDOSIS RESPIRATORIA"
  },
  {
    "codigo":1193809008,
    "descripcion":"INFLAMACIÓN EOSINOFÍLICA INTESTINAL"
  },
  {
    "codigo":700454004,
    "descripcion":"HIPOACUSIA NEUROSENSORIAL PROFUNDA"
  },
  {
    "codigo":405542005,
    "descripcion":"NECROSIS HEPÁTICA MEDICAMENTOSA"
  },
  {
    "codigo":733222006,
    "descripcion":"MÚLTIPLES LESIONES TRAUMÁTICAS SUPERFICIALES DE PARED ABDOMINAL"
  },
  {
    "codigo":208934004,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE LA ARTICULACIÓN FEMORORROTULIANA, INTERNA"
  },
  {
    "codigo":698619001,
    "descripcion":"CONMOCIÓN CONCOMITANTE CON FRACTURA EXPUESTA DE CALOTA CRANEAL DEBIDA A ELLA"
  },
  {
    "codigo":895227002,
    "descripcion":"HIPERCAPNIA FETAL"
  },
  {
    "codigo":10491005,
    "descripcion":"MENINGITIS CAUSA POR ALFA HERPESVIRUS HUMANO 3"
  },
  {
    "codigo":239867006,
    "descripcion":"ARTROSIS DE MUÑECA"
  },
  {
    "codigo":403707007,
    "descripcion":"REACCIÓN CUTÁNEA POR INYECCIÓN DE MATERIAL EXTRAÑO"
  },
  {
    "codigo":238032002,
    "descripcion":"TRASTORNO DEL CATABOLISMO DEL COLESTEROL"
  },
  {
    "codigo":205264002,
    "descripcion":"MANO HENDIDA - PRIMERA FISURA"
  },
  {
    "codigo":762320004,
    "descripcion":"TRASTORNO DEL ESTADO DE ÁNIMO CON SÍNTOMAS MANÍACOS CAUSADO POR OPIOIDE"
  },
  {
    "codigo":8656007,
    "descripcion":"CATARATA TRAUMÁTICA TOTAL"
  },
  {
    "codigo":39589002,
    "descripcion":"HIPOPLASIA DE CORAZÓN DERECHO"
  },
  {
    "codigo":6821004,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DEL CUELLO"
  },
  {
    "codigo":170661005,
    "descripcion":"USO DE ESTEROIDES INHALATORIOS - DOSIS NORMAL"
  },
  {
    "codigo":203429007,
    "descripcion":"OSTEOPOROSIS IDIOPÁTICA GENERALIZADA"
  },
  {
    "codigo":400037008,
    "descripcion":"TRASTORNO DE PIEL PERIANAL"
  },
  {
    "codigo":365434001,
    "descripcion":"PRUEBA DE ORINA EN DOS VASOS: ASPECTO DEL PRIMER VASO - HALLAZGO"
  },
  {
    "codigo":398202002,
    "descripcion":"ESTADO DEL PACIENTE APROPIADO PARA RECIBIR ANESTESIA"
  },
  {
    "codigo":301733009,
    "descripcion":"REALIZA ACTIVIDADES DE TALLER"
  },
  {
    "codigo":103290003,
    "descripcion":"VÉRTIGO PAROXÍSTICO"
  },
  {
    "codigo":37754005,
    "descripcion":"NEUROSÍFILIS ASINTOMÁTICA"
  },
  {
    "codigo":234362006,
    "descripcion":"ANEMIA PERNICIOSA CONGÉNITA DE BIERMER"
  },
  {
    "codigo":11787801000119103,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE DEDO ANULAR DERECHO CON INFECCIÓN"
  },
  {
    "codigo":298063000,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE LA MEJILLA"
  },
  {
    "codigo":35919005,
    "descripcion":"TRASTORNO DEL ESPECTRO AUTISTA"
  },
  {
    "codigo":427300002,
    "descripcion":"PÉRDIDA DE VÍTREO"
  },
  {
    "codigo":722212004,
    "descripcion":"ENCEFALOMIOPATÍA MITOCONDRIAL SEVERA LIGADA AL CROMOSOMA X"
  },
  {
    "codigo":230692004,
    "descripcion":"INFARTO - PRECEREBRAL"
  },
  {
    "codigo":12115481000119107,
    "descripcion":"QUEMADURA QUÍMICA DE ANTEBRAZO DERECHO"
  },
  {
    "codigo":65017003,
    "descripcion":"NEUROPATÍA PERIFÉRICA HEREDITARIA"
  },
  {
    "codigo":294393009,
    "descripcion":"ALERGIA A HIDROXICLOROQUINA"
  },
  {
    "codigo":292558002,
    "descripcion":"REACCIÓN ADVERSA AL ETAMIVANO"
  },
  {
    "codigo":390862006,
    "descripcion":"BUENA EXPANSIÓN TORÁCICA CON EL INHALADOR"
  },
  {
    "codigo":61347001,
    "descripcion":"ÚLCERA DUODENAL AGUDA CON PERFORACIÓN"
  },
  {
    "codigo":126883004,
    "descripcion":"NEOPLASIA DE LA URETRA"
  },
  {
    "codigo":290723009,
    "descripcion":"INTOXICACIÓN POR PROCARBAZINA"
  },
  {
    "codigo":92280002,
    "descripcion":"NEOPLASIA BENIGNA DE LOS GANGLIOS LINFÁTICOS PAROTÍDEOS"
  },
  {
    "codigo":419960003,
    "descripcion":"PUBERAL"
  },
  {
    "codigo":714872002,
    "descripcion":"INCAPACIDAD PARA MANTENER UNA POSICIÓN RECOSTADA"
  },
  {
    "codigo":254285002,
    "descripcion":"VARÓN CON CROMOSOMA SEXUAL ESTRUCTURALMENTE ANORMAL"
  },
  {
    "codigo":287053008,
    "descripcion":"OSTEOMIELITIS CRÓNICA DE CODO"
  },
  {
    "codigo":416290001,
    "descripcion":"ENFERMEDAD DREPANOCÍTICA POR HEMOGLOBINA S SIN CRISIS HEMOLÍTICA"
  },
  {
    "codigo":285218005,
    "descripcion":"CAPAZ DE RECORDAR HABILIDADES MOTRICES"
  },
  {
    "codigo":88610006,
    "descripcion":"SOPLO CARDÍACO"
  },
  {
    "codigo":449058008,
    "descripcion":"LINFOMA NO HODGKIN FOLICULAR DE AMÍGDALA PALATINA"
  },
  {
    "codigo":283383007,
    "descripcion":"LACERACIÓN DEL GLÚTEO"
  },
  {
    "codigo":840439009,
    "descripcion":"DISECCIÓN DE ARTERIA CARÓTIDA INTRACRANEAL"
  },
  {
    "codigo":445388002,
    "descripcion":"GLOMERULOESCLEROSIS FOCAL Y SEGMENTARIA AUTOSÓMICA RECESIVA"
  },
  {
    "codigo":707532001,
    "descripcion":"CARCINOMA PRIMARIO DE CÉLULAS ESCAMOSAS DE PARED POSTERIOR DE OROFARINGE"
  },
  {
    "codigo":248780009,
    "descripcion":"MIEDO A LA EYACULACIÓN"
  },
  {
    "codigo":246945006,
    "descripcion":"HALO LÍMBICO DE VOGT"
  },
  {
    "codigo":1197217007,
    "descripcion":"PARAGANGLIOMAS MÚLTIPLES ASOCIADOS CON POLICITEMIA"
  },
  {
    "codigo":81270000,
    "descripcion":"INTOXICACIÓN POR PSILOCIBINA"
  },
  {
    "codigo":83105008,
    "descripcion":"CARDIOPATÍA HIPERTENSIVA MALIGNA CON INSUFICIENCIA CARDÍACA CONGESTIVA"
  },
  {
    "codigo":771233008,
    "descripcion":"TUMOR MIOFIBROBLÁSTICO INFLAMATORIO"
  },
  {
    "codigo":703862003,
    "descripcion":"HEMATOMA SUBDURAL ESPINAL"
  },
  {
    "codigo":321511000119103,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE TENDÓN FLEXOR DE ANTEBRAZO IZQUIERDO"
  },
  {
    "codigo":1259083006,
    "descripcion":"TRASTORNO DE SISTEMA NERVIOSO AUTÓNOMO DEBIDO A ESCLEROSIS MÚLTIPLE"
  },
  {
    "codigo":276043007,
    "descripcion":"CUIDA A SU ESPOSO CRÓNICAMENTE ENFERMO"
  },
  {
    "codigo":732960002,
    "descripcion":"ANEMIA HEMOLÍTICA AUTOINMUNITARIA SECUNDARIA CONCOMITANTE CON LUPUS ERITEMATOSO SISTÉMICO Y DEBIDA A ÉL"
  },
  {
    "codigo":110368006,
    "descripcion":"NIVEL DE ESTRÓGENOS DISMINUIDO"
  },
  {
    "codigo":1290016007,
    "descripcion":"TUMOR NEUROENDOCRINO BIEN DIFERENCIADO PRIMARIO DE BRONQUIO"
  },
  {
    "codigo":77600008,
    "descripcion":"SÍNDROME DE BING - NEEL"
  },
  {
    "codigo":44832008,
    "descripcion":"AUMENTO EN LA CIRCUNFERENCIA"
  },
  {
    "codigo":12064008,
    "descripcion":"HIPOPLASIA DEL ENDOMETRIO"
  },
  {
    "codigo":1255413004,
    "descripcion":"EFECTO TÓXICO DE SUSTANCIA CON ESTRUCTURA DE ALCOHOL"
  },
  {
    "codigo":1222645005,
    "descripcion":"QUERATODERMIA DIFUSA NO EPIDERMOLÍTICA ASOCIADA AL GEN KRT1"
  },
  {
    "codigo":403445007,
    "descripcion":"ULCERACIÓN BUCAL POR QUEMADURA TÉRMICA"
  },
  {
    "codigo":763893008,
    "descripcion":"DISPLASIA EPIFISARIA MÚLTIPLE CON DISPLASIA FEMORAL PROXIMAL SEVERA"
  },
  {
    "codigo":10643431000119108,
    "descripcion":"ÚLCERA VARICOSA DE PANTORRILLA IZQUIERDA"
  },
  {
    "codigo":237770005,
    "descripcion":"SÍNDROME DE APARENTE EXCESO DE MINERALOCORTICOIDES"
  },
  {
    "codigo":235935001,
    "descripcion":"OBSTRUCCIÓN DE STENT BILIAR"
  },
  {
    "codigo":301471002,
    "descripcion":"AMÍGDALA AGRANDADA"
  },
  {
    "codigo":203167003,
    "descripcion":"OSTEOMIELITIS AGUDA DE HUESO DEL CARPO"
  },
  {
    "codigo":365172000,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA CORTAR CON TIJERA"
  },
  {
    "codigo":1348212000,
    "descripcion":"PATRÓN PERJUDICIAL DE USO DE SUSTANCIAS MIXTAS SIN DEPENDENCIA"
  },
  {
    "codigo":4724003,
    "descripcion":"PARÁLISIS AGUDA DEL NERVIO RADIAL"
  },
  {
    "codigo":37492005,
    "descripcion":"TROMBOCITOPENIA LIGADA AL SEXO"
  },
  {
    "codigo":234100006,
    "descripcion":"ELEFANTIASIS POR BRUGIA TIMORI"
  },
  {
    "codigo":299636008,
    "descripcion":"CREPITACIÓN DE ARTICULACIÓN DE DEDO DE PIE AUDIBLE"
  },
  {
    "codigo":397940009,
    "descripcion":"VÍCTIMA DE MALTRATO INFANTIL"
  },
  {
    "codigo":11819291000119101,
    "descripcion":"ESGUINCE DE LIGAMENTO CORACOCLAVICULAR IZQUIERDO"
  },
  {
    "codigo":363337006,
    "descripcion":"SECUELAS URINARIAS DE TRASTORNOS"
  },
  {
    "codigo":131201000119108,
    "descripcion":"EXCAVACIÓN FISIOLÓGICA ACENTUADA DE PAPILA ÓPTICA"
  },
  {
    "codigo":232265009,
    "descripcion":"LUXACIÓN OSICULAR TRAUMÁTICA"
  },
  {
    "codigo":66590003,
    "descripcion":"DEPENDENCIA DE ALCOHOL"
  },
  {
    "codigo":164894003,
    "descripcion":"ELECTROCARDIOGRAMA: SIN ARRITMIA VENTRICULAR"
  },
  {
    "codigo":427038005,
    "descripcion":"CÁNCER PULMONAR NO MICROCÍTICO, NEGATIVO PARA EXPRESIÓN DEL RECEPTOR DE FACTOR DE CRECIMIENTO EPIDÉRMICO"
  },
  {
    "codigo":425203001,
    "descripcion":"PRESENCIA DE PINTURA CON BASE DE PLOMO"
  },
  {
    "codigo":294131001,
    "descripcion":"ALERGIA A CIPROHEPTADINA"
  },
  {
    "codigo":263198009,
    "descripcion":"FRACTURA DE DIÁFISIS DE RADIO"
  },
  {
    "codigo":295966009,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE LAMOTRIGINA"
  },
  {
    "codigo":292296002,
    "descripcion":"REACCIÓN ADVERSA A LA ISOCARBOXAZIDA"
  },
  {
    "codigo":1177032004,
    "descripcion":"INFECCIÓN DE PIEL CAUSADA POR NEOSCYTALIDIUM"
  },
  {
    "codigo":62920004,
    "descripcion":"DIAFISITIS"
  },
  {
    "codigo":423368008,
    "descripcion":"OBLICUIDAD PÉLVICA CONGÉNITA"
  },
  {
    "codigo":95688008,
    "descripcion":"MANCHAS DE ROTH"
  },
  {
    "codigo":126621002,
    "descripcion":"NEOPLASIA DE MÚSCULO DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":716445000,
    "descripcion":"CAPAZ DE COMPRAR EN CENTRO COMERCIAL"
  },
  {
    "codigo":290461006,
    "descripcion":"INTOXICACIÓN POR DOCUSATO"
  },
  {
    "codigo":288626005,
    "descripcion":"DIFICULTAD PARA EMPLEAR LENGUAJE AUTOMÁTICO"
  },
  {
    "codigo":92018005,
    "descripcion":"NEOPLASIA BENIGNA DEL CUERPO DEL PÁNCREAS"
  },
  {
    "codigo":254023004,
    "descripcion":"ANORMALIDAD CONGÉNITA DE LA FORMA DEL CRÁNEO"
  },
  {
    "codigo":188487008,
    "descripcion":"LINFOSARCOMA Y RETICULOSARCOMA"
  },
  {
    "codigo":286791008,
    "descripcion":"TIENDE A PERMITIR QUE LA IRA AUMENTE"
  },
  {
    "codigo":284956005,
    "descripcion":"CAPAZ DE MANEJAR LA HIGIENE MENSTRUAL"
  },
  {
    "codigo":219420006,
    "descripcion":"HERIDA DE GUERRA POR ARMAS NUCLEARES"
  },
  {
    "codigo":88348008,
    "descripcion":"SINUSITIS MAXILAR"
  },
  {
    "codigo":283121001,
    "descripcion":"AMPOLLA TRAUMÁTICA DE LA BOCA"
  },
  {
    "codigo":1004017005,
    "descripcion":"TRASTORNO NEONATAL DEBIDO A AMNIOCENTESIS Y POSTERIOR A ELLA"
  },
  {
    "codigo":709105005,
    "descripcion":"SÍNDROME DE JACKSON-WEISS"
  },
  {
    "codigo":707270003,
    "descripcion":"CAPAZ DE LEVANTARSE DEL PISO"
  },
  {
    "codigo":838342003,
    "descripcion":"LEUCEMIA-LINFOMA LINFOBLÁSTICO DE CÉLULAS B CON T(12;21) (P13;Q22); TEL\/AML1 (ETV6-RUNX1)"
  },
  {
    "codigo":445126005,
    "descripcion":"EDEMA DE MIEMBRO COMPLETO"
  },
  {
    "codigo":248518006,
    "descripcion":"TUMORACIÓN DE CARÚNCULA OCULAR"
  },
  {
    "codigo":281286005,
    "descripcion":"ESPÉCIMEN NO SEPARADO"
  },
  {
    "codigo":312219000,
    "descripcion":"BLEFARITIS INFECCIOSA"
  },
  {
    "codigo":212080001,
    "descripcion":"QUEMADURA QUE COMPROMETE 50-59 PORCIENTO DE LA SUPERFICIE DEL CUERPO, CON QUEMADURA DE ESPESOR COMPLETO QUE AFECTA 30-39 PORCIENTO DE LA SUPERFICIE CORPORAL"
  },
  {
    "codigo":441456002,
    "descripcion":"PÓLIPO"
  },
  {
    "codigo":1162352003,
    "descripcion":"OSTEOSARCOMA DE CARTÍLAGO ARTICULAR DE ESTERNÓN"
  },
  {
    "codigo":95923004,
    "descripcion":"VÍCTIMA DE TRAUMA PSICOLÓGICO"
  },
  {
    "codigo":11821801000119100,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN ESTERNOCLAVICULAR DERECHA"
  },
  {
    "codigo":277616008,
    "descripcion":"LINFOMA B DE BAJO GRADO DIFUSO"
  },
  {
    "codigo":408688009,
    "descripcion":"SÍNDROME RESPIRATORIO AGUDO GRAVE ASOCIADO CON LA ATENCIÓN MÉDICA"
  },
  {
    "codigo":210245003,
    "descripcion":"LESIÓN TRAUMÁTICA DE CONDUCTO DEFERENTE CON HERIDA ABIERTA HACIA CAVIDAD ABDOMINAL"
  },
  {
    "codigo":111941005,
    "descripcion":"ENFERMEDAD FAMILIAR"
  },
  {
    "codigo":243013008,
    "descripcion":"LESIÓN POR FLECHA"
  },
  {
    "codigo":110106001,
    "descripcion":"LACERACIÓN COMPLEJA DEL VESTÍBULO MANDIBULAR"
  },
  {
    "codigo":16026191000119109,
    "descripcion":"MALFORMACIÓN ARTERIOVENOSA CONGÉNITA DE AMBOS MIEMBROS SUPERIORES"
  },
  {
    "codigo":1156847004,
    "descripcion":"TEMBLOR DEBIDO A FEOCROMOCITOMA"
  },
  {
    "codigo":763631006,
    "descripcion":"SÍNDROME DE BAJA ESTATURA, HUESOS WORMIANOS Y DEXTROCARDIA"
  },
  {
    "codigo":237508001,
    "descripcion":"HIPERTIROIDISMO IATROGÉNICO"
  },
  {
    "codigo":204740005,
    "descripcion":"ENFERMEDAD DE HIRSCHSPRUNG DE SEGMENTO LARGO"
  },
  {
    "codigo":353001000119106,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE HUESO DE PIE DERECHO"
  },
  {
    "codigo":39065001,
    "descripcion":"QUEMADURA DEL OÍDO"
  },
  {
    "codigo":301209002,
    "descripcion":"CREPITACIÓN LARÍNGEA AUSENTE"
  },
  {
    "codigo":170137004,
    "descripcion":"EXAMEN DEL NIÑO A LOS 18 MESES: PARA OBSERVACIÓN"
  },
  {
    "codigo":235673004,
    "descripcion":"FÍSTULA GASTROYEYUNAL"
  },
  {
    "codigo":71833008,
    "descripcion":"ENFERMEDAD DE CROHN DE INTESTINO DELGADO Y GRUESO"
  },
  {
    "codigo":233838001,
    "descripcion":"INFARTO AGUDO DE MIOCARDIO POSTERIOR"
  },
  {
    "codigo":299374005,
    "descripcion":"DOLOR A LA PALPACIÓN EN LA LÍNEA ARTICULAR EXTERNA DE LA RODILLA"
  },
  {
    "codigo":201070005,
    "descripcion":"MANCHAS ATRÓFICAS CUTÁNEAS"
  },
  {
    "codigo":364910005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA MANTENERSE EN BIPEDESTACIÓN"
  },
  {
    "codigo":199235001,
    "descripcion":"DISFUNCIÓN TIROIDEA DURANTE EL EMBARAZO, EL PARTO Y EL PUERPERIO"
  },
  {
    "codigo":232003005,
    "descripcion":"DIÁLISIS RETINIANA"
  },
  {
    "codigo":262936000,
    "descripcion":"DESGARRO DE LA CÚPULA VAGINAL"
  },
  {
    "codigo":264771009,
    "descripcion":"FENOTIPO ACROMEGALOIDE"
  },
  {
    "codigo":166467009,
    "descripcion":"HORMONAS SEXUALES MASCULINAS POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":66328003,
    "descripcion":"INFECCIÓN CAUSADA POR COTYLOPHORON"
  },
  {
    "codigo":721688004,
    "descripcion":"MALFORMACIÓN ARTERIOVENOSA DE INTESTINO GRUESO"
  },
  {
    "codigo":792004,
    "descripcion":"ENFERMEDAD DE JAKOB - CREUTZFELDT"
  },
  {
    "codigo":230168006,
    "descripcion":"ENCEFALITIS POR VIRUS TENSAW"
  },
  {
    "codigo":293869004,
    "descripcion":"ALERGIA A FENITOÍNA"
  },
  {
    "codigo":95426000,
    "descripcion":"ESCLEROSIS APOFISARIA"
  },
  {
    "codigo":424941009,
    "descripcion":"RADICULITIS POR HERPES ZÓSTER"
  },
  {
    "codigo":10946411000119105,
    "descripcion":"LESIÓN POR DESOLLAMIENTO DE MANO IZQUIERDA"
  },
  {
    "codigo":423106003,
    "descripcion":"ADENOCARCINOMA DE NASOFARINGE"
  },
  {
    "codigo":783554002,
    "descripcion":"DISTROFIA MUSCULAR DE LAS CINTURAS DE LOS MIEMBROS AUTOSÓMICA RECESIVA TIPO 2U"
  },
  {
    "codigo":128194008,
    "descripcion":"TRASTORNO DEL NERVIO PERONEO SUPERFICIAL"
  },
  {
    "codigo":93591002,
    "descripcion":"OSIFICACIÓN INCOMPLETA DEL MAXILAR"
  },
  {
    "codigo":716183006,
    "descripcion":"PERIODONTITIS DEBIDA A RESTAURACIÓN DENTAL DEFECTUOSA"
  },
  {
    "codigo":28055006,
    "descripcion":"SÍNDROME DE WEST"
  },
  {
    "codigo":124524000,
    "descripcion":"DEFICIENCIA DE CITIDINA DESAMINASA"
  },
  {
    "codigo":191895007,
    "descripcion":"PATRÓN DE USO NOCIVO DE CANNABIS SIN DEPENDENCIA, EN REMISIÓN"
  },
  {
    "codigo":290199009,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR ALFENTANILO"
  },
  {
    "codigo":288364003,
    "descripcion":"INCAPAZ DE RECOGER OBJETOS"
  },
  {
    "codigo":286529000,
    "descripcion":"NO MANTIENE LA TEMPERATURA CORRECTA DE LOS ALIMENTOS"
  },
  {
    "codigo":24385003,
    "descripcion":"CUERPO EXTRAÑO EN EL PULMÓN"
  },
  {
    "codigo":319297003,
    "descripcion":"ESTOMATITIS AFTOSA HERPETIFORME"
  },
  {
    "codigo":89921006,
    "descripcion":"INFERTILIDAD SECUNDARIA A BLOQUEO COMPLETO DE LA ESPERMATOGENIA"
  },
  {
    "codigo":778049009,
    "descripcion":"SÍNDROME DE DERRAME UVEAL IDIOPÁTICO"
  },
  {
    "codigo":712513009,
    "descripcion":"ADENOMA DE COLON DESCENDENTE"
  },
  {
    "codigo":1234966007,
    "descripcion":"TRASTORNO FETAL DEBIDO A CORDÓN UMBILICAL LARGO"
  },
  {
    "codigo":284694008,
    "descripcion":"ROMPERSE LOS HUESOS"
  },
  {
    "codigo":446699002,
    "descripcion":"DEFICIENCIA DE VALVA DE VÁLVULA TRICÚSPIDE"
  },
  {
    "codigo":282859003,
    "descripcion":"CAPAZ DE MANTENERSE SENTADO"
  },
  {
    "codigo":1003755004,
    "descripcion":"ALERGIA A LÁTEX"
  },
  {
    "codigo":84416003,
    "descripcion":"CONTUSIÓN DE MUSLO"
  },
  {
    "codigo":1264064003,
    "descripcion":"PERFORACIÓN ADQUIRIDA DE TABIQUE NASAL"
  },
  {
    "codigo":248256006,
    "descripcion":"NO DUERME LO SUFICIENTE"
  },
  {
    "codigo":49813000,
    "descripcion":"MACROSTOMÍA CONGÉNITA BILATERAL"
  },
  {
    "codigo":82581004,
    "descripcion":"EX BEBEDOR DE ALCOHOL"
  },
  {
    "codigo":770709005,
    "descripcion":"REACCIÓN ADVERSA AL FACTOR XIII"
  },
  {
    "codigo":277354004,
    "descripcion":"ESPASMO DEL MÚSCULO MASETERO"
  },
  {
    "codigo":78911000,
    "descripcion":"FARINGITIS CAUSADA POR EL VIRUS PARAINFLUENZA"
  },
  {
    "codigo":275519006,
    "descripcion":"MALFORMACIÓN ARTERIOVENOSA PERIFÉRICA"
  },
  {
    "codigo":765204000,
    "descripcion":"DISPLASIA DISEGMENTARIA TIPO SILVERMAN HANMAKER"
  },
  {
    "codigo":240916001,
    "descripcion":"PROTOTECOSIS DISEMINADA"
  },
  {
    "codigo":208148000,
    "descripcion":"FRACTURA NO EXPUESTA DE ACETÁBULO, COLUMNA ANTERIOR"
  },
  {
    "codigo":371988005,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE CUERDA VOCAL FALSA"
  },
  {
    "codigo":109844006,
    "descripcion":"ANGIOSARCOMA DE HÍGADO"
  },
  {
    "codigo":699668009,
    "descripcion":"MIOCARDIOPATÍA CONGESTIVA NO ISQUÉMICA SECUNDARIA"
  },
  {
    "codigo":1287657002,
    "descripcion":"TUMOR NEUROENDOCRINO BIEN DIFERENCIADO PRIMARIO DE AMPOLLA DE VATER"
  },
  {
    "codigo":402921005,
    "descripcion":"FOLICULITIS POR PSEUDOMONAS AERUGINOSA"
  },
  {
    "codigo":1254889006,
    "descripcion":"DEFORMIDAD UNGUEAL ADQUIRIDA POR TIC HABITUAL"
  },
  {
    "codigo":763369007,
    "descripcion":"PARAPLEJÍA ESPÁSTICA AUTOSÓMICA DOMINANTE TIPO 37"
  },
  {
    "codigo":239081009,
    "descripcion":"PIGMENTACIÓN RACIAL"
  },
  {
    "codigo":75241009,
    "descripcion":"COROIDEREMIA"
  },
  {
    "codigo":7870007,
    "descripcion":"LESIÓN VASCULAR DE CORDÓN"
  },
  {
    "codigo":11771371000119104,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE CODO DERECHO"
  },
  {
    "codigo":44621000087101,
    "descripcion":"KLEBSIELLA OXYTOCA O ESPECIE RAOULTELLA"
  },
  {
    "codigo":47181000087102,
    "descripcion":"DISTENSIÓN DE TENDÓN DE CABEZA LARGA DE BÍCEPS BRAQUIAL DERECHO"
  },
  {
    "codigo":366483007,
    "descripcion":"HALLAZGO RELACIONADO CON LA AMPLITUD DE ADUCCIÓN ACTIVA DE HOMBRO"
  },
  {
    "codigo":71571008,
    "descripcion":"INFESTACIÓN CAUSADA POR INSECTOS"
  },
  {
    "codigo":300947009,
    "descripcion":"TENDINITIS DEL MÚSCULO DELTOIDES"
  },
  {
    "codigo":725096002,
    "descripcion":"SÍNDROME DE CRIPTOMICROTIA Y BRAQUIDACTILIA"
  },
  {
    "codigo":302571000119105,
    "descripcion":"ANQUILOSIS DE ARTICULACIÓN DE CODO DERECHO"
  },
  {
    "codigo":39501000087108,
    "descripcion":"DISTENSIÓN DE TENDÓN EXTENSOR DE REGIÓN DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":299112005,
    "descripcion":"ARTICULACIÓN DE DEDO DE LA MANO DOLOROSA AL MOVIMIENTO"
  },
  {
    "codigo":102504006,
    "descripcion":"RECIÉN NACIDO PREMATURO DE SEXO MASCULINO SANO"
  },
  {
    "codigo":2365002,
    "descripcion":"FARINGITIS GRANULOMATOSA CRÓNICA"
  },
  {
    "codigo":428349007,
    "descripcion":"DISCAPACIDAD DEL BRAZO"
  },
  {
    "codigo":295442005,
    "descripcion":"SOBREDOSIS INTENCIONAL DE PICOSULFATO SÓDICO"
  },
  {
    "codigo":721426007,
    "descripcion":"FRACTURA DE DECIMOSEGUNDA VÉRTEBRA DORSAL"
  },
  {
    "codigo":293607002,
    "descripcion":"ALERGIA A FENOPERIDINA"
  },
  {
    "codigo":195303005,
    "descripcion":"GANGRENA DEL PIE"
  },
  {
    "codigo":685701000119105,
    "descripcion":"LEIOMIOSARCOMA PRIMARIO DE PERINEO"
  },
  {
    "codigo":129767008,
    "descripcion":"CALCIFICACIÓN DISTRIBUIDA POR REGIONES"
  },
  {
    "codigo":193468002,
    "descripcion":"DISTROFIA COROIDEA CENTRAL PARCIAL"
  },
  {
    "codigo":160700001,
    "descripcion":"PERSONA SOLTERA SIN HOGAR"
  },
  {
    "codigo":95164005,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL CUELLO DE LA VEJIGA"
  },
  {
    "codigo":331551000119100,
    "descripcion":"LAGOFTALMOS MECÁNICO DE PÁRPADO SUPERIOR DERECHO"
  },
  {
    "codigo":226236007,
    "descripcion":"DIETA SIN CARNE ROJA"
  },
  {
    "codigo":816060007,
    "descripcion":"TUMORACIÓN DE MAMA MÓVIL"
  },
  {
    "codigo":1128111000000103,
    "descripcion":"SOSPECHA DE ÁNGULO CERRADO PRIMARIO"
  },
  {
    "codigo":1071791000000106,
    "descripcion":"NO SE METE EN LA CAMA SIN ASISTENCIA"
  },
  {
    "codigo":717756008,
    "descripcion":"DUPLICACIÓN COMPLETA DE URETRA"
  },
  {
    "codigo":1303910000,
    "descripcion":"HEMOCROMATOSIS RELACIONADA CON SLC40A1"
  },
  {
    "codigo":93329009,
    "descripcion":"POSICIÓN ANÓMALA CONGÉNITA DE TRONCO BRAQUIOCEFÁLICO"
  },
  {
    "codigo":224401008,
    "descripcion":"PATRÓN DE AUSENTISMO DEL TRABAJO ANTERIOR"
  },
  {
    "codigo":124262001,
    "descripcion":"DEFICIENCIA DE GLICINA ACILTRANSFERASA"
  },
  {
    "codigo":1172838005,
    "descripcion":"NEUROPATÍA SENSITIVA AUTONÓMICA HEREDITARIA TIPO 8"
  },
  {
    "codigo":286267003,
    "descripcion":"DIFICULTAD PARA USAR DE MANERA CORRECTA LA ARTICULACIÓN DEL HABLA"
  },
  {
    "codigo":22288000,
    "descripcion":"NEOPLASIA DE CUELLO UTERINO QUE AFECTA EL EMBARAZO"
  },
  {
    "codigo":253499008,
    "descripcion":"TEJIDO ACCESORIO SOBRE VALVA DE VÁLVULA AURICULOVENTRICULAR IZQUIERDA"
  },
  {
    "codigo":55056006,
    "descripcion":"PORFIRIA HEPÁTICA"
  },
  {
    "codigo":251664007,
    "descripcion":"OVULATORIO"
  },
  {
    "codigo":249829006,
    "descripcion":"HIPERTROFIA DE MÚSCULO ESQUELÉTICO"
  },
  {
    "codigo":282597007,
    "descripcion":"NO BRINCA CON LOS PIES EN FORMA ALTERNADA"
  },
  {
    "codigo":247994001,
    "descripcion":"INTOLERANCIA AL RUIDO"
  },
  {
    "codigo":315365009,
    "descripcion":"NACIDO EN AFGANISTÁN"
  },
  {
    "codigo":18618006,
    "descripcion":"AURA"
  },
  {
    "codigo":442767003,
    "descripcion":"FONOCARDIOGRAMA ANORMAL"
  },
  {
    "codigo":82319005,
    "descripcion":"DEFICIENCIA DE ACIL-COENZIMA A DESHIDROGENASA"
  },
  {
    "codigo":737679006,
    "descripcion":"CAPAZ DE ACCEDER AL PROGRAMA ESCOLAR"
  },
  {
    "codigo":14948001,
    "descripcion":"OTITIS MEDIA AGUDA SUPURATIVA SIN RUPTURA ESPONTÁNEA DEL TÍMPANO"
  },
  {
    "codigo":703076003,
    "descripcion":"HIPERSENSIBILIDAD NO ALÉRGICA A ÁCIDO BENZOICO"
  },
  {
    "codigo":735844006,
    "descripcion":"AVULSIÓN DE LIGAMENTO CON FRAGMENTO ÓSEO DE MALÉOLO EXTERNO"
  },
  {
    "codigo":271667004,
    "descripcion":"MANCHAS DE KOPLIK"
  },
  {
    "codigo":734009000,
    "descripcion":"DIASTEMA"
  },
  {
    "codigo":211556009,
    "descripcion":"LESIÓN TRAUMÁTICA ABIERTA POR APLASTAMIENTO, REGIÓN DE HOMBRO"
  },
  {
    "codigo":209721002,
    "descripcion":"SECCIÓN EXPUESTA DE LIGAMENTO SACROILÍACO POSTERIOR"
  },
  {
    "codigo":240654003,
    "descripcion":"CHAGOMA"
  },
  {
    "codigo":764942005,
    "descripcion":"SÍNDROME DE MICROFTALMÍA COLOBOMATOSA Y DISPLASIA RIZOMÉLICA"
  },
  {
    "codigo":109582006,
    "descripcion":"DESGASTE DE CORONA DENTAL ASOCIADA CON EL ENVEJECIMIENTO"
  },
  {
    "codigo":402659000,
    "descripcion":"VASCULITIS NECROSANTE INDUCIDA POR FÁRMACOS"
  },
  {
    "codigo":1287395002,
    "descripcion":"HERIDA POR ARMA DE FUEGO DE REGIÓN DE RODILLA"
  },
  {
    "codigo":271587009,
    "descripcion":"RIGIDEZ"
  },
  {
    "codigo":204216001,
    "descripcion":"MÚLTIPLES MÚSCULOS OCULARES SUPERNUMERARIOS"
  },
  {
    "codigo":1187256004,
    "descripcion":"NEUMONÍA VIRAL DEBIDA A MONONUCLEOSIS INFECCIOSA CAUSADA POR VIRUS DE EPSTEIN-BARR"
  },
  {
    "codigo":433592008,
    "descripcion":"REEMPLAZO AGUDO DE TRASPLANTE PANCREÁTICO"
  },
  {
    "codigo":267917000,
    "descripcion":"ARTROFITO ARTICULAR DE TOBILLO Y PIE"
  },
  {
    "codigo":73144008,
    "descripcion":"ENFERMEDAD PULMONAR CAUSADA POR TALCO"
  },
  {
    "codigo":202381003,
    "descripcion":"DERRAME DE LA ARTICULACIÓN DE LA RODILLA"
  },
  {
    "codigo":16662611000119107,
    "descripcion":"DISECCIÓN DE ARTERIA POPLÍTEA DERECHA"
  },
  {
    "codigo":16881901000119101,
    "descripcion":"LESIÓN ESCLEROSANTE COMPLEJA DE MAMA IZQUIERDA"
  },
  {
    "codigo":726669007,
    "descripcion":"SÍNDROME DE CALCIFICACIÓN DEL SISTEMA NERVIOSO CENTRAL, SORDERA, ACIDOSIS TUBULAR Y ANEMIA"
  },
  {
    "codigo":169613008,
    "descripcion":"PROVEEDOR DE ATENCIÓN PRENATAL"
  },
  {
    "codigo":366221009,
    "descripcion":"REFLEJO DE PRENSIÓN PLANTAR - HALLAZGO"
  },
  {
    "codigo":300685009,
    "descripcion":"NO MANEJA ACTIVIDADES FINANCIERAS PERSONALES"
  },
  {
    "codigo":724834006,
    "descripcion":"DERMATOSIS NEUTROFÍLICA"
  },
  {
    "codigo":298850007,
    "descripcion":"AMPLITUD DE CIRCUNDUCCIÓN PASIVA DE HOMBRO AUMENTADA"
  },
  {
    "codigo":231479000,
    "descripcion":"DEPENDENCIA DE MORFINA"
  },
  {
    "codigo":167778007,
    "descripcion":"CANTIDAD MODERADA DE ESPERMATOZOIDES\/CC: 30-60 MILLONES"
  },
  {
    "codigo":722999002,
    "descripcion":"ANISOCORIA EPISÓDICA"
  },
  {
    "codigo":428087005,
    "descripcion":"EXCAVACIÓN FISIOLÓGICA DE LA PAPILA ÓPTICA"
  },
  {
    "codigo":229644002,
    "descripcion":"VOZ HIPONASAL"
  },
  {
    "codigo":295180003,
    "descripcion":"SOBREDOSIS DE NALBUFINA"
  },
  {
    "codigo":721164002,
    "descripcion":"DEFICIENCIA DE FLÚOR"
  },
  {
    "codigo":31201001,
    "descripcion":"INFECCIÓN PERIANAL CONSECUTIVA A ABRASIÓN CUTÁNEA"
  },
  {
    "codigo":1145313007,
    "descripcion":"FILTRO ESTRECHO"
  },
  {
    "codigo":225974000,
    "descripcion":"INCAPAZ DE MANTENER LA AUTOESTIMA"
  },
  {
    "codigo":422582001,
    "descripcion":"PELÍCULA LAGRIMAL IRREGULAR"
  },
  {
    "codigo":94902003,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA PARED LATERAL DE LA OROFARINGE"
  },
  {
    "codigo":193206003,
    "descripcion":"MIASTENIA GRAVE NEONATAL PERSISTENTE"
  },
  {
    "codigo":289675001,
    "descripcion":"HALLAZGO RELACIONADO CON EL ÚTERO GRÁVIDO"
  },
  {
    "codigo":93067003,
    "descripcion":"ELONGACIÓN CONGÉNITA DE TRONCO BRAQUIOCEFÁLICO"
  },
  {
    "codigo":781195004,
    "descripcion":"LÍNEA DE SUTURA INFLAMADA"
  },
  {
    "codigo":715659006,
    "descripcion":"DIFTERIA DEL SISTEMA RESPIRATORIO"
  },
  {
    "codigo":224139006,
    "descripcion":"VIVE CON LA MADRE"
  },
  {
    "codigo":124000000,
    "descripcion":"LACTOSA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":255072001,
    "descripcion":"NEOPLASIA MALIGNA DE GLÁNDULA SALIVAL"
  },
  {
    "codigo":286005000,
    "descripcion":"CIERRA LA LLAVE PRINCIPAL DE GAS"
  },
  {
    "codigo":11831841000119101,
    "descripcion":"LESIÓN TRAUMÁTICA DE VASO SANGUÍNEO DE DEDO MEDIO DE MANO DERECHA"
  },
  {
    "codigo":187701005,
    "descripcion":"NEOPLASIA MALIGNA DEL PISO DE LA NASOFARINGE"
  },
  {
    "codigo":449845006,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR MIRTAZAPINA"
  },
  {
    "codigo":89397007,
    "descripcion":"LITIASIS PULMONAR"
  },
  {
    "codigo":1269045007,
    "descripcion":"TUMOR PRIMARIO MIXTO DE CÉLULAS GERMINALES"
  },
  {
    "codigo":218634007,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR DERIVADO DE OXAZOLIDINA"
  },
  {
    "codigo":54794009,
    "descripcion":"SUSTANCIA GRIS ECTÓPICA EN EL CENTRO OVAL"
  },
  {
    "codigo":249567002,
    "descripcion":"BORDE HEPÁTICO"
  },
  {
    "codigo":446175003,
    "descripcion":"TRASTORNO DE ESTRÉS POSTRAUMÁTICO AGUDO LUEGO DE COMBATE MILITAR"
  },
  {
    "codigo":216799001,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR HUMOS DE LATÓN"
  },
  {
    "codigo":870324000,
    "descripcion":"HIPERTENSIÓN OCULAR DEBIDA A TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":10930721000119105,
    "descripcion":"FRACTURA NO EXPUESTA DE METÁFISIS DE HUESO METATARSIANO DE PIE IZQUIERDO"
  },
  {
    "codigo":1263540002,
    "descripcion":"AMIOTROFIA MONOMÉLICA BENIGNA DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":90811000119100,
    "descripcion":"GLIOMA CEREBRAL MALIGNO DE BAJO GRADO"
  },
  {
    "codigo":772020009,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR NEBIVOLOL"
  },
  {
    "codigo":247732009,
    "descripcion":"ALUCINACIONES DE MÚSICA"
  },
  {
    "codigo":1281843005,
    "descripcion":"SÍNDROME DE ATRESIA DE COANAS, ATELIA, HIPOTIROIDISMO, RETRASO PUBERAL Y BAJA ESTATURA"
  },
  {
    "codigo":1360009004,
    "descripcion":"FUNCIÓN DE SISTEMA MUSCULOESQUELÉTICO ALTERADA"
  },
  {
    "codigo":409737006,
    "descripcion":"CLASIFICACIÓN INTERNACIONAL DE NEUROBLASTOMA: GRUPO CON HISTOLOGÍA DESFAVORABLE, PAC. <1,5 AÑOS, CON NEUROBLASTOMA MAL DIFERENCIADO O DIFERENCIADO (S\/ PREDOMINIO DE CÉL. DE SCHWANN EN EL ESTROMA) E ÍNDICE ELEVADO DE MITOSIS-CARIORREXIS"
  },
  {
    "codigo":473438000,
    "descripcion":"FRACTURA POR FLEXIÓN-DISTRACCIÓN DE VÉRTEBRA DE CHANCE"
  },
  {
    "codigo":309598002,
    "descripcion":"ANORMALIDAD DEL PIE NO RELACIONADA CON DIABETES"
  },
  {
    "codigo":16583201000119109,
    "descripcion":"ARTROSIS SECUNDARIA DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":735582006,
    "descripcion":"TRASTORNO DE VENTRÍCULO CARDÍACO POSTERIOR A PROCEDIMIENTO"
  },
  {
    "codigo":14686007,
    "descripcion":"HEMIANESTESIA"
  },
  {
    "codigo":897587000,
    "descripcion":"AFAQUIA PRIMARIA BILATERAL"
  },
  {
    "codigo":1259870009,
    "descripcion":"DOLOR DEBIDO A RETRACCIÓN DE TESTÍCULO"
  },
  {
    "codigo":16050151000119100,
    "descripcion":"TRASTORNO DE ARTICULACIÓN GLENOHUMERAL DERECHA POSTERIOR A ADMINISTRACIÓN DE VACUNA"
  },
  {
    "codigo":16469991000119101,
    "descripcion":"FATIGA DEBIDA A ACCIDENTE CEREBROVASCULAR Y POSTERIOR A ÉL"
  },
  {
    "codigo":12243431000119101,
    "descripcion":"ABSCESO POSTERIOR A PROCEDIMIENTO"
  },
  {
    "codigo":34791000119103,
    "descripcion":"DOLOR TORÁCICO DEBIDO A PERICARDITIS"
  },
  {
    "codigo":10676711000119103,
    "descripcion":"ASMA PERSISTENTE MODERADA NO CONTROLADA"
  },
  {
    "codigo":16027111000119103,
    "descripcion":"MIOQUIMIA DE MÚSCULO FACIAL IZQUIERDO"
  },
  {
    "codigo":10750951000119106,
    "descripcion":"EPILEPSIA EN LA MADRE QUE COMPLICA EL NACIMIENTO"
  },
  {
    "codigo":367591000119105,
    "descripcion":"NEFROPATÍA HEREDITARIA"
  },
  {
    "codigo":16009191000119108,
    "descripcion":"DEFORMIDAD CONGÉNITA DE AMBAS EXTREMIDADES SUPERIORES"
  },
  {
    "codigo":109320004,
    "descripcion":"OSTEOMIELITIS CRÓNICA DEL COMPLEJO ÓRBITO - NASAL"
  },
  {
    "codigo":334311000119108,
    "descripcion":"BAJA VISIÓN EN OJO IZQUIERDO, VISIÓN NORMAL EN OJO DERECHO"
  },
  {
    "codigo":308711000119105,
    "descripcion":"GANGLIÓN DE CADERA DERECHA"
  },
  {
    "codigo":240392008,
    "descripcion":"MELIOIDOSIS SUPURATIVA CRÓNICA"
  },
  {
    "codigo":290791000119105,
    "descripcion":"TRASTORNO DE LA FLUIDEZ DEL LENGUAJE COMO SECUELA DE ACCIDENTE CEREBROVASCULAR"
  },
  {
    "codigo":1074151000119105,
    "descripcion":"CONDROCALCINOSIS DE CADERA IZQUIERDA"
  },
  {
    "codigo":1079271000119106,
    "descripcion":"NEOPLASIA BENIGNA DE HUESO DE MIEMBRO SUPERIOR DERECHO"
  },
  {
    "codigo":221899751000119107,
    "descripcion":"ÚLCERA PILÓRICA CRÓNICA CAUSADA POR HELICOBACTER PYLORI"
  },
  {
    "codigo":10679271000119108,
    "descripcion":"TUMEFACCIÓN LOCALIZADA DE ANTEBRAZO IZQUIERDO"
  },
  {
    "codigo":402397006,
    "descripcion":"URTICARIA AUTOINMUNITARIA"
  },
  {
    "codigo":238557000,
    "descripcion":"ECCEMA DISCOIDE INESPECÍFICO DE LA MANO"
  },
  {
    "codigo":7346000,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA VENA MESENTÉRICA INFERIOR"
  },
  {
    "codigo":302258001,
    "descripcion":"PROBLEMA EN LA ESPALDA"
  },
  {
    "codigo":764680009,
    "descripcion":"INFECCIÓN DE LÍNEA DE TRANSMISIÓN DE DISPOSITIVO DE ASISTENCIA VENTRICULAR IZQUIERDA"
  },
  {
    "codigo":203954000,
    "descripcion":"ESPINA BÍFIDA CON HIDROCEFALIA DE INICIO TARDÍO"
  },
  {
    "codigo":369629003,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA DE URÉTER Y VEJIGA, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":72882005,
    "descripcion":"QUEMADURA EPIDÉRMICA DE HOMBRO"
  },
  {
    "codigo":1156061005,
    "descripcion":"CARBAMAZEPINA SÉRICA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":171186007,
    "descripcion":"PRUEBA DE GUTHRIE DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":726407000,
    "descripcion":"DISTOPIA DE CANTO PALPEBRAL"
  },
  {
    "codigo":202119001,
    "descripcion":"DESGARRO COMPLETO ANTIGUO DE LIGAMENTO LATERAL INTERNO DE RODILLA"
  },
  {
    "codigo":236722007,
    "descripcion":"PERFORACIÓN DEL ÚTERO POR SONDA UTERINA"
  },
  {
    "codigo":365959002,
    "descripcion":"COMPROMISO CON LA RELACIÓN SEXUAL - HALLAZGO"
  },
  {
    "codigo":105650009,
    "descripcion":"ENFERMEDAD CAUSADA POR ADELEIDAE"
  },
  {
    "codigo":38279006,
    "descripcion":"TUBERCULOSIS DE HUESO"
  },
  {
    "codigo":200284000,
    "descripcion":"EMBOLIA PULMONAR OBSTÉTRICA"
  },
  {
    "codigo":36444000,
    "descripcion":"TRASTORNO DEL METABOLISMO DEL CICLO DE LA UREA"
  },
  {
    "codigo":724572007,
    "descripcion":"TRASTORNO DE UNIÓN NEUROMUSCULAR DEBIDO A INGESTIÓN DE COMPUESTO CON FÓSFORO ORGÁNICO"
  },
  {
    "codigo":198449003,
    "descripcion":"INFERTILIDAD PRIMARIA DE ORIGEN HIPOFISARIO-HIPOTALÁMICO"
  },
  {
    "codigo":165681007,
    "descripcion":"HEMOGLOBINA A1C MAYOR DE 10%, INDICATIVA DE MAL CONTROL DE LA DIABETES"
  },
  {
    "codigo":460593008,
    "descripcion":"ANILLO VASCULAR CON CAYADO AÓRTICO DERECHO Y CONDUCTO ARTERIOSO IZQUIERDO DESDE ARTERIA BRAQUIOCEFÁLICA RETROESOFÁGICA ANÓMALA"
  },
  {
    "codigo":131078003,
    "descripcion":"NIVEL DE TESTOSTERONA POR DEBAJO DE RANGO DE REFERENCIA"
  },
  {
    "codigo":293083001,
    "descripcion":"REACCIÓN ADVERSA A PLAGUICIDA"
  },
  {
    "codigo":194779001,
    "descripcion":"CARDIOPATÍA Y NEFROPATÍA HIPERTENSIVAS CON INSUFICIENCIA CARDÍACA (CONGESTIVA)"
  },
  {
    "codigo":94640003,
    "descripcion":"NEOPLASIA MALIGNA SECUNDARIA DEL PILAR AMIGDALINO"
  },
  {
    "codigo":16012271000119106,
    "descripcion":"TROMBOFLEBITIS DE VENA TIBIAL IZQUIERDA"
  },
  {
    "codigo":717232005,
    "descripcion":"ENFERMEDAD DE CAROLI"
  },
  {
    "codigo":715397000,
    "descripcion":"HAMARTOMA MESENQUIMATOSO DE HÍGADO"
  },
  {
    "codigo":60037002,
    "descripcion":"HEPATITIS VIRAL CRÓNICA PERSISTENTE"
  },
  {
    "codigo":420485005,
    "descripcion":"IRIDOCICLITIS HERPÉTICA"
  },
  {
    "codigo":289413007,
    "descripcion":"FONTANELA ANTERIOR PALPABLE EN LA REGIÓN POSTERIOR"
  },
  {
    "codigo":1010309009,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE EXTREMIDAD INFERIOR IZQUIERDA ENTRE LA RODILLA Y EL TOBILLO"
  },
  {
    "codigo":1303386005,
    "descripcion":"FRACTURA ÓSEA DE ARTICULACIÓN DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":254810007,
    "descripcion":"NEVO CELULAR CUTÁNEO EN BALÓN"
  },
  {
    "codigo":1076361000119104,
    "descripcion":"INFECCIÓN DE BOLSA SEROSA DE OLÉCRANON DE CODO IZQUIERDO"
  },
  {
    "codigo":285743003,
    "descripcion":"ALUCINACIONES DE SONIDOS SIMPLES"
  },
  {
    "codigo":252975006,
    "descripcion":"PRUEBA DE OCLUSIÓN - VISIÓN LEJANA"
  },
  {
    "codigo":89135007,
    "descripcion":"TROMBOARTERITIS"
  },
  {
    "codigo":56367006,
    "descripcion":"INTOXICACIÓN POR MACROZAMIA"
  },
  {
    "codigo":1332484002,
    "descripcion":"CARCINOMA ANAPLÁSICO DE TIROIDES METASTÁSICO"
  },
  {
    "codigo":21764004,
    "descripcion":"DEFECTO DEL TRANSPORTE RENAL DE CARNITINA"
  },
  {
    "codigo":251140005,
    "descripcion":"ELECTROCARDIOGRAMA DE MALA CALIDAD"
  },
  {
    "codigo":54532007,
    "descripcion":"TRASTORNO DEL CICLO DE SUEÑO - VIGILIA, TIPO CAMBIANTE"
  },
  {
    "codigo":283908007,
    "descripcion":"LACERACIÓN DE URÉTER"
  },
  {
    "codigo":708057002,
    "descripcion":"OSTEOMIELITIS ESCLEROSANTE"
  },
  {
    "codigo":1363417004,
    "descripcion":"SINEQUIAS ANTERIORES PERIFÉRICAS EN CUADRANTE INFERIOR DE ÁNGULO IRIDOCORNEAL"
  },
  {
    "codigo":183769008,
    "descripcion":"INSCRIPTO EN LISTA DE ADMISIÓN PEDIÁTRICA"
  },
  {
    "codigo":118233009,
    "descripcion":"HALLAZGO RELACIONADO CON LA ACTIVIDAD COTIDIANA"
  },
  {
    "codigo":282073008,
    "descripcion":"QUEMADURA DE APÉNDICE ILEOCECAL"
  },
  {
    "codigo":1197742004,
    "descripcion":"ENFERMEDAD DE BEHÇET DE INTESTINO DELGADO"
  },
  {
    "codigo":247470007,
    "descripcion":"ERUPCIÓN MORBILIFORME"
  },
  {
    "codigo":16259002,
    "descripcion":"INTOXICACIÓN POR CEPA DE ALLIUM"
  },
  {
    "codigo":442243005,
    "descripcion":"DISFUNCIÓN PSICOSEXUAL ASOCIADA CON INHIBICIÓN DE LA LIBIDO"
  },
  {
    "codigo":737155005,
    "descripcion":"ANOMALÍA CONGÉNITA DE VÁLVULA AURICULOVENTRICULAR"
  },
  {
    "codigo":1163139006,
    "descripcion":"COCCIDIOIDOMICOSIS ÓSEA"
  },
  {
    "codigo":276568002,
    "descripcion":"ACIDOSIS FETAL INTRAPARTO"
  },
  {
    "codigo":473176004,
    "descripcion":"DESPLAZAMIENTO DE DISPOSITIVO ORTOPÉDICO"
  },
  {
    "codigo":702552005,
    "descripcion":"PÉRDIDA DE EMPASTE EN ORIFICIO DE ACCESO A IMPLANTE DENTAL"
  },
  {
    "codigo":209197002,
    "descripcion":"SUBLUXACIÓN VERTEBRAL EXPUESTA CON LESIÓN DE LA COLA DE CABALLO"
  },
  {
    "codigo":274733002,
    "descripcion":"DEFECTO DE RELLENO RENAL"
  },
  {
    "codigo":373037004,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM INTERJECTUM"
  },
  {
    "codigo":15932861000119101,
    "descripcion":"OBSTRUCCIÓN PROXIMAL DE TROMPA DE FALOPIO IZQUIERDA"
  },
  {
    "codigo":1290541007,
    "descripcion":"MAL USO INTENCIONAL DE MEDICACIÓN"
  },
  {
    "codigo":43522000,
    "descripcion":"ABSCESO DE LA PELVIS FEMENINA"
  },
  {
    "codigo":403970001,
    "descripcion":"GLOMANGIOMA DE PIEL"
  },
  {
    "codigo":12589008,
    "descripcion":"LACERACIÓN DEL TRONCO ENCEFÁLICO CON HERIDA INTRACRANEAL ABIERTA"
  },
  {
    "codigo":307501007,
    "descripcion":"TUMOR TRANSGLÓTICO"
  },
  {
    "codigo":698882004,
    "descripcion":"COROIDITIS PERIFÉRICA DISEMINADA"
  },
  {
    "codigo":240130007,
    "descripcion":"FATIGA MUSCULAR RESPIRATORIA SISTÉMICA GRAVE"
  },
  {
    "codigo":860887000,
    "descripcion":"GASTRITIS CAUSADA POR STRONGYLOIDES STERCOLARIS"
  },
  {
    "codigo":762583001,
    "descripcion":"ESTAFILOSQUISIS CON LABIO LEPORINO BILATERAL Y FISURA ALVEOLAR BILATERAL"
  },
  {
    "codigo":305666009,
    "descripcion":"ATENDIDO POR UN INMUNÓLOGO CLÍNICO"
  },
  {
    "codigo":72620002,
    "descripcion":"DEGENERACIÓN NODULAR DE LA CÓRNEA"
  },
  {
    "codigo":236460004,
    "descripcion":"ACIDOSIS TUBULAR RENAL PROXIMAL FAMILIAR"
  },
  {
    "codigo":433068007,
    "descripcion":"ANEURISMA DE AORTA TORÁCICA"
  },
  {
    "codigo":365697000,
    "descripcion":"UROCULTIVO: ORGANISMOS - HALLAZGO"
  },
  {
    "codigo":301996009,
    "descripcion":"NO ACEPTA BASE DE APOYO"
  },
  {
    "codigo":234625001,
    "descripcion":"DEFICIENCIA DEL FACTOR HOMÓLOGO DE RESTRICCIÓN"
  },
  {
    "codigo":300161000,
    "descripcion":"TUBO DE VENTILACIÓN TIMPÁNICA, AUSENTE"
  },
  {
    "codigo":201857000,
    "descripcion":"ARTROSIS DE AMBAS ARTICULACIONES DE CADERA DEBIDA A TRAUMATISMO Y POSTERIOR A ÉL"
  },
  {
    "codigo":1217665005,
    "descripcion":"PARÁLISIS CRÓNICA DE NERVIO TROCLEAR"
  },
  {
    "codigo":396630000,
    "descripcion":"COMPROMISO DEL MARGEN QUIRÚRGICO POR CARCINOMA IN SITU NO APLICABLE"
  },
  {
    "codigo":167254001,
    "descripcion":"PRUEBA DE EMBARAZO EN ORINA: NEGATIVA"
  },
  {
    "codigo":15988311000119102,
    "descripcion":"ANOMALÍA CONGÉNITA BILATERAL DE VÍAS LAGRIMALES"
  },
  {
    "codigo":298326003,
    "descripcion":"HALLAZGO RELACIONADO CON EL PATRÓN DE MOTRICIDAD GRUESA"
  },
  {
    "codigo":462166006,
    "descripcion":"ANEMIA FETAL"
  },
  {
    "codigo":788011001,
    "descripcion":"PERITONITIS PÉLVICA AGUDA"
  },
  {
    "codigo":722475006,
    "descripcion":"ANEMIA DISERITROPOYÉTICA CONGÉNITA LIGADA AL CROMOSOMA X CON TROMBOCITOPENIA"
  },
  {
    "codigo":296491007,
    "descripcion":"SOBREDOSIS DE BACLOFENO"
  },
  {
    "codigo":1179392004,
    "descripcion":"HIPOTIROIDISMO CENTRAL ADQUIRIDO TRAUMÁTICO"
  },
  {
    "codigo":720640005,
    "descripcion":"SÍNDROME DE ATRESIA DE COANAS, PÉRDIDA DE LA AUDICIÓN, DEFECTO CARDÍACO Y DISMORFISMO CRANEOFACIAL"
  },
  {
    "codigo":294656006,
    "descripcion":"ALERGIA A COMPONENTE DE VACUNA QUE CONTIENE ANTÍGENO DE VIRUS DE LA RUBÉOLA"
  },
  {
    "codigo":784341001,
    "descripcion":"ESCLEROSIS LATERAL AMIOTRÓFICA TIPO 4"
  },
  {
    "codigo":30677002,
    "descripcion":"PÓLIPO COANAL"
  },
  {
    "codigo":423893004,
    "descripcion":"DOLOR CONSECUTIVO A LA RELACIÓN SEXUAL"
  },
  {
    "codigo":391125004,
    "descripcion":"GRADO 4 DE LA ESCALA DE DISNEA DEL MEDICAL RESEARCH COUNCIL"
  },
  {
    "codigo":1144789007,
    "descripcion":"HALLAZGO DE GASES EN SANGRE"
  },
  {
    "codigo":292821009,
    "descripcion":"REACCIÓN ADVERSA AL KETOCONAZOL"
  },
  {
    "codigo":290986005,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ZOPICLONA"
  },
  {
    "codigo":127146006,
    "descripcion":"LINFADENOPATÍA SIGMOIDEA"
  },
  {
    "codigo":94378007,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA CURVATURA MENOR DEL ESTÓMAGO"
  },
  {
    "codigo":715135000,
    "descripcion":"INCAPAZ DE PASAR DEL INODORO A UNA SILLA DE RUEDAS"
  },
  {
    "codigo":225450009,
    "descripcion":"PENSAMIENTOS DE HOMICIDIO"
  },
  {
    "codigo":289151002,
    "descripcion":"PATRÓN DE BEBIDA - HALLAZGO"
  },
  {
    "codigo":15716081000119104,
    "descripcion":"ENOSTOSIS DE RADIO DERECHO"
  },
  {
    "codigo":190847006,
    "descripcion":"HEMOSIDEROSIS, ADQUIRIDA"
  },
  {
    "codigo":27007008,
    "descripcion":"CICATRIZACIÓN DEL MÚSCULO PAPILAR"
  },
  {
    "codigo":90708001,
    "descripcion":"NEFROPATÍA"
  },
  {
    "codigo":57940000,
    "descripcion":"ÚLCERA DUODENAL CRÓNICA SIN HEMORRAGIA, SIN PERFORACIÓN Y SIN OBSTRUCCIÓN"
  },
  {
    "codigo":713300006,
    "descripcion":"TRASTORNO DEL TRACTO GASTROINTESTINAL CONCOMITANTE CON INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":1268521006,
    "descripcion":"LESIÓN DE ARTERIA CÓLICA IZQUIERDA"
  },
  {
    "codigo":285481007,
    "descripcion":"REDONDEA LOS LABIOS"
  },
  {
    "codigo":711465006,
    "descripcion":"ALTURA FACIAL INFERIOR ANTERIOR AUMENTADA"
  },
  {
    "codigo":87038002,
    "descripcion":"ALOPECIA POSPARTO"
  },
  {
    "codigo":283646002,
    "descripcion":"HERIDA PUNZANTE CAUSADA POR AGUJA DE COSER"
  },
  {
    "codigo":315121000119109,
    "descripcion":"OSTEOCONDRITIS DISECANTE DE HUESO DE MANO DERECHA"
  },
  {
    "codigo":1363155001,
    "descripcion":"ASTILLA EN BRAZO CON INFECCIÓN"
  },
  {
    "codigo":609491002,
    "descripcion":"INTERRUPCIÓN INDUCIDA DEL EMBARAZO COMPLICADA POR INFECCIÓN DE LA VÍA URINARIA"
  },
  {
    "codigo":707795003,
    "descripcion":"SALIVA EN LA VÍA AÉREA SUPERIOR"
  },
  {
    "codigo":773331001,
    "descripcion":"SÍNDROME DE PROGERIA DE NÉSTOR - GUILLERMO"
  },
  {
    "codigo":871635009,
    "descripcion":"CARCINOMA ESCAMOCELULAR IN SITU DE ESÓFAGO"
  },
  {
    "codigo":247208003,
    "descripcion":"RESTOS DE TEJIDO GLIAL EN LA PAPILA ÓPTICA"
  },
  {
    "codigo":771496004,
    "descripcion":"FRACTURAS EXPUESTAS QUE COMPROMETEN MÚLTIPLES REGIONES DE LA EXTREMIDAD SUPERIOR DERECHA"
  },
  {
    "codigo":17832008,
    "descripcion":"DISMINUCIÓN HORMONAL"
  },
  {
    "codigo":15997003,
    "descripcion":"ABSCESO POSOPERATORIO DE HERIDA"
  },
  {
    "codigo":441981006,
    "descripcion":"HIPERTROFIA DE OVARIO"
  },
  {
    "codigo":407378000,
    "descripcion":"TRANSEXUAL EN QUIEN SE REALIZÓ EL CAMBIO DE SEXO QUIRÚRGICAMENTE, DE HOMBRE A MUJER"
  },
  {
    "codigo":276306002,
    "descripcion":"PÉRDIDA DE INICIATIVA"
  },
  {
    "codigo":866130002,
    "descripcion":"MIELITIS CAUSADA POR HERPES SIMPLE TIPO 2"
  },
  {
    "codigo":1259346002,
    "descripcion":"CARCINOMA PRIMARIO DE ESÓFAGO ABDOMINAL"
  },
  {
    "codigo":767826007,
    "descripcion":"GANGRENA CONCOMITANTE CON HERNIA INGUINAL IZQUIERDA Y DEBIDA A ELLA"
  },
  {
    "codigo":405543000,
    "descripcion":"HIPERPIREXIA MEDICAMENTOSA"
  },
  {
    "codigo":733223001,
    "descripcion":"LACERACIÓN DE ARTERIA AXILAR"
  },
  {
    "codigo":307239003,
    "descripcion":"FUNCIONAMIENTO DEFECTUOSO DE ESTOMA"
  },
  {
    "codigo":700455003,
    "descripcion":"GINGIVITIS CAUSADA POR CANDIDA"
  },
  {
    "codigo":77863005,
    "descripcion":"CARDITIS DE LYME"
  },
  {
    "codigo":239868001,
    "descripcion":"ARTROSIS DE ARTICULACIÓN DE DEDO DE LA MANO"
  },
  {
    "codigo":403708002,
    "descripcion":"TELANGIECTASIA POSQUIRÚRGICA"
  },
  {
    "codigo":370940003,
    "descripcion":"FUGA DE HUMOR ACUOSO DETECTADA POR PRUEBA DE SEIDEL"
  },
  {
    "codigo":344101000119106,
    "descripcion":"IRITIS RECURRENTE DE AMBOS OJOS"
  },
  {
    "codigo":698620007,
    "descripcion":"FRACTURA NO EXPUESTA DE BASE DE CRÁNEO CON PÉRDIDA DE CONSCIENCIA"
  },
  {
    "codigo":762321000,
    "descripcion":"TRASTORNO DEL ESTADO DE ÁNIMO CON SÍNTOMAS DEPRESIVOS CAUSADO POR OPIOIDE"
  },
  {
    "codigo":205265001,
    "descripcion":"MANO HENDIDA - CENTRAL"
  },
  {
    "codigo":238033007,
    "descripcion":"DEFICIENCIA DE 3-BETA-HIDROXI-DELTA-5-C27-ESTEROIDE DESHIDROGENASA"
  },
  {
    "codigo":301734003,
    "descripcion":"NO REALIZA ACTIVIDADES DE TALLER"
  },
  {
    "codigo":400038003,
    "descripcion":"SÍNDROME DE MALFORMACIÓN CONGÉNITA"
  },
  {
    "codigo":432806004,
    "descripcion":"ATENDIDO EN CONSULTORIO ESPECIALIZADO EN TRASTORNOS DE LA MEMORIA"
  },
  {
    "codigo":170662003,
    "descripcion":"USO DE ESTEROIDES INHALATORIOS - DOSIS ALTA"
  },
  {
    "codigo":365435000,
    "descripcion":"PRUEBA DE ORINA EN DOS VASOS, ASPECTO DEL SEGUNDO VASO - HALLAZGO"
  },
  {
    "codigo":234363001,
    "descripcion":"MALABSORCIÓN SELECTIVA DE CIANOCOBALAMINA"
  },
  {
    "codigo":299899002,
    "descripcion":"PROBLEMA DEL SENTIDO DEL OLFATO"
  },
  {
    "codigo":16046271000119104,
    "descripcion":"ENFERMEDAD POR DEPÓSITO DE HIDROXIAPATITA DE AMBOS HOMBROS"
  },
  {
    "codigo":103291004,
    "descripcion":"VÉRTIGO INTERMITENTE"
  },
  {
    "codigo":298064006,
    "descripcion":"CUERPO EXTRAÑO EN LA PIEL DE LA FRENTE"
  },
  {
    "codigo":34085004,
    "descripcion":"INTOXICACIÓN POR GLUCAGÓN"
  },
  {
    "codigo":296229004,
    "descripcion":"SOBREDOSIS DE PIPOTIAZINA"
  },
  {
    "codigo":722213009,
    "descripcion":"DISCAPACIDAD INTELECTUAL SEVERA LIGADA AL CROMOSOMA X, TIPO GUSTAVSON"
  },
  {
    "codigo":230693009,
    "descripcion":"INFARTO DE LA CIRCULACIÓN CEREBRAL ANTERIOR"
  },
  {
    "codigo":294394003,
    "descripcion":"ALERGIA A CLOROQUINA"
  },
  {
    "codigo":65018008,
    "descripcion":"ÚLCERA DE CONDUCTO CÍSTICO"
  },
  {
    "codigo":390863001,
    "descripcion":"MALA EXPANSIÓN TORÁCICA CON EL INHALADOR"
  },
  {
    "codigo":292559005,
    "descripcion":"REACCIÓN ADVERSA AL DOXAPRAM"
  },
  {
    "codigo":30415006,
    "descripcion":"ENFERMEDAD CAUSADA POR VIRUS PAPILOMA"
  },
  {
    "codigo":63183009,
    "descripcion":"MIOCARDIOPATÍA HIPERTRÓFICA IDIOPÁTICA PRIMARIA"
  },
  {
    "codigo":1144527009,
    "descripcion":"INTERACTÚA CON OTROS NORMALMENTE"
  },
  {
    "codigo":290724003,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR PROCARBAZINA"
  },
  {
    "codigo":716708005,
    "descripcion":"SÍNDROME FRAXF"
  },
  {
    "codigo":126884005,
    "descripcion":"NEOPLASIA DE LAS GLÁNDULAS PARAURETRALES"
  },
  {
    "codigo":94116007,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL MIEMBRO SUPERIOR"
  },
  {
    "codigo":1306532007,
    "descripcion":"CARCINOMA IN SITU DE PROLONGACIÓN AXILAR DE MAMA"
  },
  {
    "codigo":92281003,
    "descripcion":"NEOPLASIA BENIGNA DE LA RÓTULA"
  },
  {
    "codigo":288889003,
    "descripcion":"CAPAZ DE COMER CIERTOS ALIMENTOS"
  },
  {
    "codigo":714873007,
    "descripcion":"MANTIENE UNA POSICIÓN RECOSTADA"
  },
  {
    "codigo":26745009,
    "descripcion":"MUCOPOLISACARIDOSIS, MPS - I - H\/S"
  },
  {
    "codigo":254286001,
    "descripcion":"VARÓN CON MOSAICISMO DE LOS CROMOSOMAS SEXUALES"
  },
  {
    "codigo":713038003,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA SUPERPUESTA DE HUESO Y CARTÍLAGO ARTICULAR DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":18931000119103,
    "descripcion":"TOXOPLASMOSIS DISEMINADA ADQUIRIDA"
  },
  {
    "codigo":90446007,
    "descripcion":"PRURITO ANAL"
  },
  {
    "codigo":385358008,
    "descripcion":"HALLAZGO RELACIONADO CON EL ESTADIO DE DUKES"
  },
  {
    "codigo":449059000,
    "descripcion":"LINFOMA NO HODGKIN FOLICULAR DE CUELLO UTERINO"
  },
  {
    "codigo":285219002,
    "descripcion":"INCAPAZ DE RECORDAR HABILIDADES MOTRICES"
  },
  {
    "codigo":186915005,
    "descripcion":"GONORREA CRÓNICA DE LA VÍA GENITOURINARIA INFERIOR"
  },
  {
    "codigo":283384001,
    "descripcion":"LACERACIÓN DE LA CADERA"
  },
  {
    "codigo":54008006,
    "descripcion":"ESTERNÓN BÍFIDO"
  },
  {
    "codigo":840440006,
    "descripcion":"ENCEFALITIS CAUSADA POR LEPTOSPIRA"
  },
  {
    "codigo":248781008,
    "descripcion":"POLUCIONES NOCTURNAS"
  },
  {
    "codigo":281549008,
    "descripcion":"RUPTURA DE TENDÓN DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":771234002,
    "descripcion":"HIPOPLASIA AISLADA BILATERAL DE LOS HEMISFERIOS CEREBELOSOS"
  },
  {
    "codigo":17570002,
    "descripcion":"INTOXICACIÓN POR EMETINA"
  },
  {
    "codigo":443554005,
    "descripcion":"HALLAZGO RELACIONADO CON LA ZONA COLOREADA CORRESPONDIENTE A LA ESTIMACIÓN DE PESO PEDIÁTRICO DE BROSELOW LUTEN"
  },
  {
    "codigo":1295522006,
    "descripcion":"SÍNDROME MEDULAR ANTERIOR DEBIDO A ISQUEMIA"
  },
  {
    "codigo":246946007,
    "descripcion":"ULCERACIÓN CORNEAL MARGINAL"
  },
  {
    "codigo":212343000,
    "descripcion":"LESIÓN NO EXPUESTA DEL NERVIO OBTURADOR"
  },
  {
    "codigo":310647000,
    "descripcion":"ANEMIA SECUNDARIA A INSUFICIENCIA RENAL"
  },
  {
    "codigo":81271001,
    "descripcion":"PSORIASIS PUSTULOSA LOCALIZADA"
  },
  {
    "codigo":441719005,
    "descripcion":"RETRASO DEL DESARROLLO DEL HABLA Y DEL LENGUAJE DEBIDO A PÉRDIDA DE LA AUDICIÓN"
  },
  {
    "codigo":48503007,
    "descripcion":"LINFANGITIS AGUDA DE MANO"
  },
  {
    "codigo":1259084000,
    "descripcion":"ENFERMEDAD AUTOINMUNITARIA DE MOVIMIENTO"
  },
  {
    "codigo":277879009,
    "descripcion":"NEUROPATÍA AUTÓNOMA"
  },
  {
    "codigo":703863008,
    "descripcion":"TRASTORNO DE LA PIEL DEL PENE"
  },
  {
    "codigo":439884003,
    "descripcion":"FÍSTULA ARTERIOVENOSA DE VENA POPLÍTEA A SAFENA INTERNA TRANSPUESTA"
  },
  {
    "codigo":276044001,
    "descripcion":"CUIDA A SU MADRE CRÓNICAMENTE ENFERMA"
  },
  {
    "codigo":15966861000119106,
    "descripcion":"SÍNDROME DE ABERTURA DE SALIDA TORÁCICA VENOSO DERECHO"
  },
  {
    "codigo":79436008,
    "descripcion":"INTOXICACIÓN POR ESPECIE DE NIDORELLA"
  },
  {
    "codigo":44833003,
    "descripcion":"PSEUDOLINFOMA DE PULMÓN EN LA ENFERMEDAD DE SJÖGREN"
  },
  {
    "codigo":732961003,
    "descripcion":"SÍNDROME DE DISPLASIA BRANQUIAL, DISCAPACIDAD INTELECTUAL Y HERNIA INGUINAL"
  },
  {
    "codigo":1290017003,
    "descripcion":"TUMOR NEUROENDOCRINO BIEN DIFERENCIADO PRIMARIO DE CARDIAS GÁSTRICO"
  },
  {
    "codigo":1255414005,
    "descripcion":"FRACTURA DE MÚLTIPLES FALANGES DE DEDO DE MANO"
  },
  {
    "codigo":1222646006,
    "descripcion":"SÍNDROME DE QUERATODERMIA PALMOPLANTAR, NEUROPATÍA SENSITIVA Y MOTORA HEREDITARIA"
  },
  {
    "codigo":16022311000119103,
    "descripcion":"TRASTORNO DE LIGAMENTOS DE ARTICULACIONES DE AMBAS CADERAS"
  },
  {
    "codigo":42998008,
    "descripcion":"PARÁLISIS LARÍNGEA DEL NERVIO VAGO"
  },
  {
    "codigo":403446008,
    "descripcion":"ULCERACIÓN BUCAL CAUSADA POR LESIÓN POR FRÍO"
  },
  {
    "codigo":205003000,
    "descripcion":"ATRESIA DE URETRA ANTERIOR"
  },
  {
    "codigo":11844391000119104,
    "descripcion":"AMPOLLA DE OREJA IZQUIERDA CON INFECCIÓN"
  },
  {
    "codigo":235936000,
    "descripcion":"INFECCIÓN DE STENT BILIAR"
  },
  {
    "codigo":237771009,
    "descripcion":"DEFICIENCIA DE CORTICOSTEROIDE 11-REDUCTASA"
  },
  {
    "codigo":72096003,
    "descripcion":"INTOXICACIÓN POR NITRATO"
  },
  {
    "codigo":203168008,
    "descripcion":"OSTEOMIELITIS AGUDA DE METACARPIANO"
  },
  {
    "codigo":234101005,
    "descripcion":"ELEFANTIASIS POR ONCHOCERCA"
  },
  {
    "codigo":365173005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA UTILIZAR PINZAS"
  },
  {
    "codigo":397941008,
    "descripcion":"NIÑO SOSTENIDO EN EL REGAZO DE ASISTENTE"
  },
  {
    "codigo":363338001,
    "descripcion":"TRASTORNO HEREDITARIO DE VÍAS URINARIAS"
  },
  {
    "codigo":428874003,
    "descripcion":"INFECCIÓN INTESTINAL CAUSADA POR ESCHERICHIA COLI DEL SEROTIPO O158"
  },
  {
    "codigo":232266005,
    "descripcion":"PÉRDIDA TOTAL DE HUECESILLO DEL OÍDO"
  },
  {
    "codigo":295967000,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE LAMOTRIGINA"
  },
  {
    "codigo":1055001,
    "descripcion":"ESTENOSIS DE LA ARTERIA CEREBRAL ANTERIOR"
  },
  {
    "codigo":164895002,
    "descripcion":"TAQUICARDIA VENTRICULAR EN EL ELECTROCARDIOGRAMA"
  },
  {
    "codigo":230431001,
    "descripcion":"CONVULSIONES RELACIONADAS CON LA SITUACIÓN"
  },
  {
    "codigo":263199001,
    "descripcion":"FRACTURA DE RADIO DISTAL"
  },
  {
    "codigo":359668007,
    "descripcion":"RETINITIS FOCAL"
  },
  {
    "codigo":423369000,
    "descripcion":"INHIBICIÓN FARMACOLÓGICA DE ENZIMA CYP2C19 DEL CITOCROMO P450"
  },
  {
    "codigo":294132008,
    "descripcion":"ALERGIA A DIMETINDENO"
  },
  {
    "codigo":95689000,
    "descripcion":"SEDIMENTOS RETINIANA"
  },
  {
    "codigo":62921000,
    "descripcion":"INFECCIÓN CAUSADA POR TYPHLOCOELUM"
  },
  {
    "codigo":292297006,
    "descripcion":"REACCIÓN ADVERSA A LA TRANILCIPROMINA"
  },
  {
    "codigo":30153007,
    "descripcion":"INTOXICACIÓN POR HELENIUM HOOPESII"
  },
  {
    "codigo":1177033009,
    "descripcion":"INFECCIÓN DE LA PIEL POR STAPHYLOCOCCUS AUREUS PRODUCTOR DE LEUCOCIDINA DE PANTON-VALENTINE"
  },
  {
    "codigo":93854002,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL INTESTINO GRUESO"
  },
  {
    "codigo":28318001,
    "descripcion":"HEMORRAGIA BASILAR"
  },
  {
    "codigo":290462004,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR DOCUSATO"
  },
  {
    "codigo":716446004,
    "descripcion":"CAPAZ DE COMPRAR EN SUPERMERCADO"
  },
  {
    "codigo":61086009,
    "descripcion":"PULSO IRREGULAR"
  },
  {
    "codigo":126622009,
    "descripcion":"NEOPLASIA DE MÚSCULO DE LA CADERA"
  },
  {
    "codigo":92019002,
    "descripcion":"NEOPLASIA BENIGNA DEL CUERPO DEL PENE"
  },
  {
    "codigo":254024005,
    "descripcion":"PLAGIOCEFALIA POSTURAL"
  },
  {
    "codigo":284957001,
    "descripcion":"INCAPAZ DE MANEJAR LA HIGIENE MENSTRUAL"
  },
  {
    "codigo":55581002,
    "descripcion":"MECONIO EN LÍQUIDO AMNIÓTICO DETECTADO POR PRIMERA VEZ DURANTE EL TRABAJO DE PARTO Y\/O PARTO EN INFANTE NACIDO VIVO"
  },
  {
    "codigo":219421005,
    "descripcion":"HERIDA DE GUERRA POR EFECTOS EXPLOSIVOS DE ARMA NUCLEAR"
  },
  {
    "codigo":1004018000,
    "descripcion":"TRASTORNO NEONATAL DEBIDO A PROCEDIMIENTO QUIRÚRGICO SOBRE LA MADRE Y POSTERIOR A ÉL"
  },
  {
    "codigo":86514004,
    "descripcion":"HEPATITIS GRANULOMATOSA"
  },
  {
    "codigo":283122008,
    "descripcion":"AMPOLLA TRAUMÁTICA DE LA GARGANTA"
  },
  {
    "codigo":248519003,
    "descripcion":"TUMORACIÓN EN EXTREMIDADES"
  },
  {
    "codigo":707271004,
    "descripcion":"SEPSIS DEBIDA A INFECCIÓN DE LA CAVIDAD BUCAL"
  },
  {
    "codigo":84679006,
    "descripcion":"CANDIDIASIS GASTROINTESTINAL"
  },
  {
    "codigo":838343008,
    "descripcion":"LEUCEMIA-LINFOMA LINFOBLÁSTICO DE CÉLULAS B CON T(1;19)(Q23;P13.3); E2A-PBX1 (TCF3\/PBX1)"
  },
  {
    "codigo":50076003,
    "descripcion":"BARITOSIS"
  },
  {
    "codigo":246684004,
    "descripcion":"POSTURA OCULOCEFÁLICA NORMAL"
  },
  {
    "codigo":312220006,
    "descripcion":"EPIDIDIMO-ORQUITIS INFECCIOSA"
  },
  {
    "codigo":408689001,
    "descripcion":"COMER EN EXCESO DE MANERA OCASIONAL"
  },
  {
    "codigo":212081002,
    "descripcion":"QUEMADURA QUE COMPROMETE 50-59 PORCIENTO DE LA SUPERFICIE DEL CUERPO, CON QUEMADURA DE ESPESOR COMPLETO QUE AFECTA 40-49 PORCIENTO DE LA SUPERFICIE CORPORAL"
  },
  {
    "codigo":48241004,
    "descripcion":"DIVERTICULITIS DE MECKEL"
  },
  {
    "codigo":277617004,
    "descripcion":"LINFOMA B DE ALTO GRADO"
  },
  {
    "codigo":441457006,
    "descripcion":"QUISTE"
  },
  {
    "codigo":310385006,
    "descripcion":"SITUACIÓN DE INFORMACIÓN"
  },
  {
    "codigo":1162353008,
    "descripcion":"OSTEOSARCOMA DE CARTÍLAGO ARTICULAR DE VÉRTEBRA"
  },
  {
    "codigo":15998351000119102,
    "descripcion":"TRASTORNO DE LA MÁCULA DE AMBOS OJOS"
  },
  {
    "codigo":243014002,
    "descripcion":"LESIÓN POR HONDA"
  },
  {
    "codigo":308550003,
    "descripcion":"PÉRDIDA DE SANGRE MENSTRUAL NORMAL"
  },
  {
    "codigo":296181000119109,
    "descripcion":"ALTERACIÓN DE CUERNO ANTERIOR DE MENISCO INTERNO DEBIDA A LESIÓN TRAUMÁTICA DE RODILLA"
  },
  {
    "codigo":156936000,
    "descripcion":"AGENESIA DE PULMÓN"
  },
  {
    "codigo":110107005,
    "descripcion":"LACERACIÓN COMPLEJA CONTAMINADA DEL VESTÍBULO MANDIBULAR"
  },
  {
    "codigo":763632004,
    "descripcion":"EPILEPSIA POR SOBRESALTO"
  },
  {
    "codigo":351631000119106,
    "descripcion":"NEOPLASIA TESTICULAR DERECHA DE COMPORTAMIENTO INCIERTO"
  },
  {
    "codigo":206576006,
    "descripcion":"ISQUEMIA CEREBRAL NEONATAL"
  },
  {
    "codigo":75504007,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE DEDO DE LA MANO, SIN INFECCIÓN"
  },
  {
    "codigo":1156848009,
    "descripcion":"DISTROFIA MUSCULAR AUTOSÓMICA RECESIVA DE EMERY-DREIFUSS"
  },
  {
    "codigo":237509009,
    "descripcion":"TIROTOXICOSIS EN TRATAMIENTO CON TIROXINA"
  },
  {
    "codigo":204741009,
    "descripcion":"ENFERMEDAD DE HIRSCHSPRUNG DE SEGMENTO CORTO"
  },
  {
    "codigo":235674005,
    "descripcion":"PERFORACIÓN DE ESTÓMAGO"
  },
  {
    "codigo":301210007,
    "descripcion":"LESIÓN DE LARINGE"
  },
  {
    "codigo":6298007,
    "descripcion":"INFECCIÓN CAUSADA POR ABSIDIA"
  },
  {
    "codigo":170138009,
    "descripcion":"EXAMEN DEL NIÑO A LOS 18 MESES: ANORMAL - DERIVADO"
  },
  {
    "codigo":37231002,
    "descripcion":"EDEMA DE LA MÁCULA DE LA RETINA"
  },
  {
    "codigo":1251482009,
    "descripcion":"METÁSTASIS DE ADENOCARCINOMA EN CONDUCTO PANCREÁTICO"
  },
  {
    "codigo":266607004,
    "descripcion":"TRASTORNO DE LA PERIMENOPAUSIA"
  },
  {
    "codigo":299375006,
    "descripcion":"DOLOR INFRARROTULIANO A LA PALPACIÓN"
  },
  {
    "codigo":4463009,
    "descripcion":"POLINEUROPATÍA AMILOIDE FAMILIAR, TIPO II"
  },
  {
    "codigo":364911009,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA MANTENERSE SENTADO"
  },
  {
    "codigo":233839009,
    "descripcion":"INFARTO ANTIGUA DE MIOCARDIO ANTERIOR"
  },
  {
    "codigo":232004004,
    "descripcion":"DESGARRO DE RETINA GIGANTE"
  },
  {
    "codigo":68164004,
    "descripcion":"HIPERPLASIA ERITROIDE DE LA MÉDULA ÓSEA"
  },
  {
    "codigo":295705004,
    "descripcion":"SOBREDOSIS DE MERCAPTOPURINA"
  },
  {
    "codigo":66329006,
    "descripcion":"GASTRITIS EOSINOFÍLICA"
  },
  {
    "codigo":721689007,
    "descripcion":"VÁRICES DE INTESTINO GRUESO"
  },
  {
    "codigo":426777008,
    "descripcion":"FRACTURA PATOLÓGICA DE RÓTULA"
  },
  {
    "codigo":228334001,
    "descripcion":"PRIORIDAD OTORGADA A LAS ACTIVIDADES RELACIONADAS CON LA BEBIDA"
  },
  {
    "codigo":262937009,
    "descripcion":"LESIÓN DE VASO SANGUÍNEO DEL CUELLO"
  },
  {
    "codigo":293870003,
    "descripcion":"ALERGIA A ETOSUXIMIDA"
  },
  {
    "codigo":783555001,
    "descripcion":"SÍNDROME DE HIPOTRICOSIS Y SORDERA"
  },
  {
    "codigo":423107007,
    "descripcion":"PELIGRO DE MATERIAL RADIOLÓGICO EN EL AMBIENTE"
  },
  {
    "codigo":292035007,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ESPERMICIDA"
  },
  {
    "codigo":95427009,
    "descripcion":"CUELLO CORTO"
  },
  {
    "codigo":128195009,
    "descripcion":"NEUROPATÍA DEL NERVIO PERONEO PROFUNDO"
  },
  {
    "codigo":288776000,
    "descripcion":"CAPAZ DE COMUNICAR INTENCIONES"
  },
  {
    "codigo":60824004,
    "descripcion":"HERNIA SINOVIAL"
  },
  {
    "codigo":421272004,
    "descripcion":"MIOCARDITIS SUBAGUDA ASOCIADA CON SIDA"
  },
  {
    "codigo":355736000,
    "descripcion":"ENTEROCELE VAGINAL ADQUIRIDO"
  },
  {
    "codigo":93592009,
    "descripcion":"OSIFICACIÓN INCOMPLETA DEL METACARPO"
  },
  {
    "codigo":288365002,
    "descripcion":"RECOGE OBJETOS"
  },
  {
    "codigo":124525004,
    "descripcion":"DEFICIENCIA DE AMP DESAMINASA"
  },
  {
    "codigo":26221006,
    "descripcion":"ÚLCERA PÉPTICA CON HEMORRAGIA, PERFORACIÓN Y OBSTRUCCIÓN"
  },
  {
    "codigo":24386002,
    "descripcion":"SOBRECRECIMIENTO DE LOS HUESOS NASALES"
  },
  {
    "codigo":712514003,
    "descripcion":"ADENOMA DE COLON TRANSVERSO"
  },
  {
    "codigo":286530005,
    "descripcion":"DIFICULTAD PARA MANTENER LA TEMPERATURA CORRECTA DE LOS ALIMENTOS"
  },
  {
    "codigo":778050009,
    "descripcion":"MIOSITIS EOSINOFÍLICA IDIOPÁTICA"
  },
  {
    "codigo":1234967003,
    "descripcion":"TRASTORNO NEONATAL DEBIDO A CORDÓN UMBILICAL LARGO"
  },
  {
    "codigo":415767003,
    "descripcion":"MUCOSA COLÓNICA ULCERADA"
  },
  {
    "codigo":354141000119105,
    "descripcion":"NEOPLASIA BENIGNA DE EPIDÍDIMO IZQUIERDO"
  },
  {
    "codigo":284695009,
    "descripcion":"ARRANCARSE LOS DIENTES"
  },
  {
    "codigo":1003756003,
    "descripcion":"ANGIOEDEMA-URTICARIA INDUCIDO POR PROTEÍNA DEL LÁTEX DE HEVEA BRASILIENSIS"
  },
  {
    "codigo":20716004,
    "descripcion":"FRECUENCIA RESPIRATORIA NORMAL"
  },
  {
    "codigo":86252004,
    "descripcion":"AGENESIA DE ARTERIA PULMONAR"
  },
  {
    "codigo":282860008,
    "descripcion":"INCAPAZ DE MANTENERSE SENTADO"
  },
  {
    "codigo":84417007,
    "descripcion":"AMPOLLA DEL ANTEBRAZO, CON INFECCIÓN"
  },
  {
    "codigo":1296833008,
    "descripcion":"DESPLAZAMIENTO DE HUESO"
  },
  {
    "codigo":770710000,
    "descripcion":"REACCIÓN ADVERSA A FACTOR VON WILLEBRAND"
  },
  {
    "codigo":681821000119109,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE CUELLO"
  },
  {
    "codigo":82582006,
    "descripcion":"ESTRECHEZ VENOSA"
  },
  {
    "codigo":703339005,
    "descripcion":"LESIÓN MODERADAMENTE CAVITADA LIMITADA A LA MITAD EXTERNA DE LA DENTINA"
  },
  {
    "codigo":5611000175106,
    "descripcion":"RUTINA INEFICAZ DE ADMINISTRACIÓN DE MEDICACIÓN EN EL DOMICILIO"
  },
  {
    "codigo":439360004,
    "descripcion":"CATÉTER DE DIÁLISIS PERITONEAL SALIDO"
  },
  {
    "codigo":406592004,
    "descripcion":"COMPROMISO SARAMPIONOSO DEL SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":699669001,
    "descripcion":"SÍNDROME DE RENPENNING"
  },
  {
    "codigo":472128009,
    "descripcion":"TORTUOSIDAD DE RAMA DEL CAYADO AÓRTICO"
  },
  {
    "codigo":371989002,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL GLANDE DEL PENE"
  },
  {
    "codigo":765205004,
    "descripcion":"TRASTORNO EN REMISIÓN"
  },
  {
    "codigo":208149008,
    "descripcion":"FRACTURA NO EXPUESTA DE ACETÁBULO, COLUMNA POSTERIOR"
  },
  {
    "codigo":239082002,
    "descripcion":"DISCROMATOSIS UNIVERSAL"
  },
  {
    "codigo":402922003,
    "descripcion":"FOLICULITIS POR PROPIONIBACTERIUM ACNES"
  },
  {
    "codigo":1254890002,
    "descripcion":"EPIDERMÓLISIS BULLOSA DE LA ZONA DE UNIÓN NO DE TIPO HERLITZ LOCALIZADA"
  },
  {
    "codigo":827071000,
    "descripcion":"RIGIDEZ POSMORTEM"
  },
  {
    "codigo":763370008,
    "descripcion":"PARAPLEJÍA ESPÁSTICA LIGADA AL CROMOSOMA X TIPO 34"
  },
  {
    "codigo":302783002,
    "descripcion":"AGLUTINACIÓN ERITROCÍTICA"
  },
  {
    "codigo":237247003,
    "descripcion":"CONTINUIDAD DE EMBARAZO POSTERIOR A ABORTO DE FETO GEMELAR"
  },
  {
    "codigo":1187519007,
    "descripcion":"GASTRINOMA MALIGNO DE PÁNCREAS"
  },
  {
    "codigo":399252000,
    "descripcion":"ESTRABISMO DIVERGENTE CONCOMITANTE"
  },
  {
    "codigo":366484001,
    "descripcion":"HALLAZGO RELACIONADO CON LA AMPLITUD DE MOVIMIENTO PASIVO DE ADUCCIÓN DE HOMBRO"
  },
  {
    "codigo":71572001,
    "descripcion":"INFECCIÓN CAUSADA POR ENTEROMONAS"
  },
  {
    "codigo":300948004,
    "descripcion":"DEBILIDAD DEL CUÁDRICEPS"
  },
  {
    "codigo":268180007,
    "descripcion":"SÍNDROME DEL CORAZÓN DERECHO HIPOPLÁSICO"
  },
  {
    "codigo":299113000,
    "descripcion":"CREPITACIÓN DE ARTICULACIÓN DE DEDO DE MANO"
  },
  {
    "codigo":38804009,
    "descripcion":"SÍNDROME DE TURNER"
  },
  {
    "codigo":725097006,
    "descripcion":"SÍNDROME DE CRISPONI"
  },
  {
    "codigo":102505007,
    "descripcion":"RECIÉN NACIDO PREMATURO DE SEXO FEMENINO SANO"
  },
  {
    "codigo":2366001,
    "descripcion":"EFECTO TARDÍO DE LUXACIÓN"
  },
  {
    "codigo":297278001,
    "descripcion":"LEUCODISTROFIA METACROMÁTICA POR DEFICIENCIA DEL ACTIVADOR DE CEREBRÓSIDO SULFATASA"
  },
  {
    "codigo":15702161000119109,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE TENDÓN DE RÓTULA DERECHA"
  },
  {
    "codigo":428350007,
    "descripcion":"DISCAPACIDAD DEL PIE"
  },
  {
    "codigo":197139005,
    "descripcion":"MEGACOLON IDIOPÁTICO"
  },
  {
    "codigo":262675006,
    "descripcion":"FRACTURA DE HUESO HIOIDES"
  },
  {
    "codigo":42791000087104,
    "descripcion":"PROLAPSO DE DISCO INTERVERTEBRAL T8-T9"
  },
  {
    "codigo":40231000087105,
    "descripcion":"HERIDA PUNZANTE DE MUSLO IZQUIERDO CON CUERPO EXTRAÑO"
  },
  {
    "codigo":53031000087107,
    "descripcion":"AUMENTO DE NIVEL DE DESORIENTACIÓN EN RELACIÓN A LA HORA"
  },
  {
    "codigo":195304004,
    "descripcion":"GANGRENA DE DEDO DE LA MANO"
  },
  {
    "codigo":719592004,
    "descripcion":"DEPRESIÓN MAYOR MODERADAMENTE SEVERA"
  },
  {
    "codigo":129768003,
    "descripcion":"CALCIFICACIÓN DISTRIBUIDA EN FORMA SEGMENTARIA"
  },
  {
    "codigo":293608007,
    "descripcion":"ALERGIA A MEPTAZINOL"
  },
  {
    "codigo":162536008,
    "descripcion":"PATRÓN DIETARIO RESTRINGIDO"
  },
  {
    "codigo":31464009,
    "descripcion":"MARCHA CALCÁNEA"
  },
  {
    "codigo":160701002,
    "descripcion":"MIGRANTE SOCIAL"
  },
  {
    "codigo":226237003,
    "descripcion":"DIETA SIN CARNE DE CERDO"
  },
  {
    "codigo":12208581000119101,
    "descripcion":"DEPÓSITO EN LENTE INTRAOCULAR DE OJO DERECHO"
  },
  {
    "codigo":47911000087109,
    "descripcion":"FRACTURA DE UNDÉCIMA COSTILLA IZQUIERDA"
  },
  {
    "codigo":95165006,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL APARATO URINARIO"
  },
  {
    "codigo":717757004,
    "descripcion":"DUPLICACIÓN PARCIAL DE URETRA"
  },
  {
    "codigo":27794000,
    "descripcion":"INFECCIÓN CAUSADA POR PLATYNOSOMUM"
  },
  {
    "codigo":224402001,
    "descripcion":"PATRÓN DE AUSENTISMO DEL TRABAJO ACTUAL"
  },
  {
    "codigo":93330004,
    "descripcion":"POSICIÓN ANÓMALA CONGÉNITA DEL TRACTO INTESTINAL"
  },
  {
    "codigo":58727001,
    "descripcion":"DEPENDENCIA DE PCP"
  },
  {
    "codigo":1172839002,
    "descripcion":"SÍNDROME LETAL DE NO COMPACTACIÓN DEL VENTRÍCULO IZQUIERDO, CRISIS CONVULSIVAS, HIPOTONÍA, CATARATAS, RETRASO DEL DESARROLLO"
  },
  {
    "codigo":1303911001,
    "descripcion":"ENFERMEDAD DE LA FERROPORTINA"
  },
  {
    "codigo":124263006,
    "descripcion":"DEFICIENCIA DE GLUTAMINA FENILACETILTRANSFERASA"
  },
  {
    "codigo":56892000,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN LA REGIÓN DE LA PARED TORÁCICA, CON INFECCIÓN"
  },
  {
    "codigo":15976901000119105,
    "descripcion":"NEOPLASIA BENIGNA DE AMBOS OMÓPLATOS"
  },
  {
    "codigo":253500004,
    "descripcion":"DISPLASIA DE VALVA DE VÁLVULA AURICULOVENTRICULAR IZQUIERDA"
  },
  {
    "codigo":448273006,
    "descripcion":"MELANOMA MALIGNO DE PIEL DE ESCROTO"
  },
  {
    "codigo":251665008,
    "descripcion":"INVESTIGACIÓN OBSTÉTRICA - HALLAZGO"
  },
  {
    "codigo":249830001,
    "descripcion":"PSEUDOHIPERTROFIA DE MÚSCULO"
  },
  {
    "codigo":282598002,
    "descripcion":"DIFICULTAD PARA BRINCAR CON LOS PIES EN FORMA ALTERNADA"
  },
  {
    "codigo":446438003,
    "descripcion":"INTOXICACIÓN POR INGESTA DE PESCADO CONTAMINADO CON BACTERIA"
  },
  {
    "codigo":315366005,
    "descripcion":"NACIDO EN ALBANIA"
  },
  {
    "codigo":247995000,
    "descripcion":"EXUBERANCIA"
  },
  {
    "codigo":51387008,
    "descripcion":"ACIDOSIS"
  },
  {
    "codigo":278928000,
    "descripcion":"INSUFICIENCIA MITRAL TRANSITORIA DEL RECIÉN NACIDO"
  },
  {
    "codigo":16784003,
    "descripcion":"TRASTORNO DEL TRANSPORTE DE LOS AMINOÁCIDOS"
  },
  {
    "codigo":442768008,
    "descripcion":"LÍQUIDO PERITONEAL ANORMAL"
  },
  {
    "codigo":211557000,
    "descripcion":"LESIÓN TRAUMÁTICA ABIERTA POR APLASTAMIENTO, REGIÓN ESCAPULAR"
  },
  {
    "codigo":47717004,
    "descripcion":"DEGLUCIÓN ANORMAL"
  },
  {
    "codigo":703077007,
    "descripcion":"QUISTE PARAOVÁRICO"
  },
  {
    "codigo":1260133007,
    "descripcion":"SORDERA NEUROSENSORIAL SINDRÓMICA POR UNA DEFICIENCIA COMBINADA DE LA FOSFORILACIÓN OXIDATIVA"
  },
  {
    "codigo":14949009,
    "descripcion":"RUPTURA ANTIGUA DEL LIGAMENTO DE LA RODILLA"
  },
  {
    "codigo":275258002,
    "descripcion":"CAMBIOS MAMARIOS"
  },
  {
    "codigo":735845007,
    "descripcion":"FRACTURA DE MALÉOLO EXTERNO A LA ALTURA DE LA SINDESMOSIS"
  },
  {
    "codigo":10625631000119108,
    "descripcion":"BRONCONEUMONÍA CAUSADA POR STAPHYLOCOCCUS AUREUS"
  },
  {
    "codigo":734010005,
    "descripcion":"SEPARACIÓN DE DIENTES POSTERIORES"
  },
  {
    "codigo":111418006,
    "descripcion":"ENDOCERVICITIS CRÓNICA CON EROSIÓN"
  },
  {
    "codigo":13114007,
    "descripcion":"AMPOLLA DE LABIO, CON INFECCIÓN"
  },
  {
    "codigo":44047000,
    "descripcion":"SÍNDROME DE ZIEVE"
  },
  {
    "codigo":764943000,
    "descripcion":"DEFECTO COMBINADO DE LA FOSFORILACIÓN OXIDATIVA TIPO 2"
  },
  {
    "codigo":76815001,
    "descripcion":"EFECTO TÓXICO DE LA ACETONA"
  },
  {
    "codigo":109583001,
    "descripcion":"DESGASTE DE CORONA DENTAL DEBIDO A FUERZAS MASTICATORIAS"
  },
  {
    "codigo":1287396001,
    "descripcion":"HERIDA POR ARMA DE FUEGO DE PIERNA"
  },
  {
    "codigo":238820002,
    "descripcion":"ERITEMA MULTIFORME DEL EMBARAZO"
  },
  {
    "codigo":763108005,
    "descripcion":"FISURA SUBMUCOSA DE PALADAR"
  },
  {
    "codigo":402660005,
    "descripcion":"VASCULITIS NECROSANTE SECUNDARIA A INFECCIÓN"
  },
  {
    "codigo":9444005,
    "descripcion":"INFECCIÓN CAUSADA POR DIPYLIDIUM CANINUM"
  },
  {
    "codigo":204217005,
    "descripcion":"HIPOPLASIA DE MÚSCULO OCULAR"
  },
  {
    "codigo":73145009,
    "descripcion":"ACCIÓN DE CONDUCIR UN VEHÍCULO CON IMPRUDENCIA"
  },
  {
    "codigo":366222002,
    "descripcion":"HALLAZGO RELACIONADO CON LA ERUPCIÓN DENTAL"
  },
  {
    "codigo":169614002,
    "descripcion":"ATENCIÓN PRENATAL POR MÉDICO GENERAL"
  },
  {
    "codigo":202382005,
    "descripcion":"DERRAME DE ARTICULACIÓN TIBIOPERONEA"
  },
  {
    "codigo":300686005,
    "descripcion":"DIFICULTAD PARA MANEJAR ACTIVIDADES FINANCIERAS PERSONALES"
  },
  {
    "codigo":726670008,
    "descripcion":"SÍNDROME DE WEAVER WILLIAMS"
  },
  {
    "codigo":167779004,
    "descripcion":"NÚMERO DE ESPERMATOZOIDES\/CC BAJO: 10 - 30 MILLONES"
  },
  {
    "codigo":3939004,
    "descripcion":"DENSIDAD DE UNA COLONIA BACTERIANA, TRANSPARENTE"
  },
  {
    "codigo":298851006,
    "descripcion":"AMPLITUD DE CIRCUNDUCCIÓN PASIVA DE HOMBRO DISMINUIDA"
  },
  {
    "codigo":724835007,
    "descripcion":"CALCIFICACIÓN DISTRÓFICA DE PIEL DEBIDA A ENFERMEDAD INFLAMATORIA"
  },
  {
    "codigo":428088000,
    "descripcion":"LACERACIÓN DE LA CABEZA"
  },
  {
    "codigo":723000001,
    "descripcion":"HIPERHIDROSIS GENERALIZADA DEBIDA A TRASTORNO NEUROLÓGICO"
  },
  {
    "codigo":231480002,
    "descripcion":"DEPENDENCIA DE OPIO"
  },
  {
    "codigo":297016000,
    "descripcion":"SOBREDOSIS DE DIURÉTICO DE ASA"
  },
  {
    "codigo":721165001,
    "descripcion":"PRIONOPATÍA VARIABLE SENSIBLE A PROTEASA"
  },
  {
    "codigo":229645001,
    "descripcion":"VOZ HIPERNASAL"
  },
  {
    "codigo":295181004,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE NALBUFINA"
  },
  {
    "codigo":661631000124109,
    "descripcion":"INFLAMACIÓN DE ARTICULACIÓN DE REGIÓN DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":1145314001,
    "descripcion":"FILTRO CORTO"
  },
  {
    "codigo":195042002,
    "descripcion":"BLOQUEO AURICULOVENTRICULAR DE SEGUNDO GRADO"
  },
  {
    "codigo":162274004,
    "descripcion":"SÍNTOMAS VISUALES"
  },
  {
    "codigo":293346005,
    "descripcion":"REACCIÓN ADVERSA A LA FENINDIONA"
  },
  {
    "codigo":193207007,
    "descripcion":"MIASTENIA GRAVE JUVENIL O DEL ADULTO"
  },
  {
    "codigo":289676000,
    "descripcion":"ÚTERO GRÁVIDO PRESENTE"
  },
  {
    "codigo":94903008,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA PARED LATERAL DE LA VEJIGA"
  },
  {
    "codigo":93068008,
    "descripcion":"HIPERTROFIA CONGÉNITA DE GLÁNDULA SUPRARRENAL"
  },
  {
    "codigo":124001001,
    "descripcion":"LACTOSA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":191372008,
    "descripcion":"POLICITEMIA POR CARDIOPATÍA CIANÓTICA"
  },
  {
    "codigo":224140008,
    "descripcion":"VIVE CON EL PADRE"
  },
  {
    "codigo":255073006,
    "descripcion":"NEOPLASIA MALIGNA DE OÍDO, NARIZ Y\/O GARGANTA"
  },
  {
    "codigo":713825007,
    "descripcion":"ESTENOSIS DE ARTERIA RENAL DE RIÑÓN TRASPLANTADO"
  },
  {
    "codigo":253238001,
    "descripcion":"HIPOPLASIA PARCIAL DE LA PAPILA ÓPTICA"
  },
  {
    "codigo":417078002,
    "descripcion":"CONJUNTIVITIS ASOCIADA CON EPIDERMÓLISIS BULLOSA"
  },
  {
    "codigo":286006004,
    "descripcion":"NO CIERRA LA TUBERÍA DE GAS MAESTRA"
  },
  {
    "codigo":449846007,
    "descripcion":"PRÓTESIS METÁLICA DE VÁLVULA MITRAL IN SITU"
  },
  {
    "codigo":1269046008,
    "descripcion":"CORDOMA PRIMARIO"
  },
  {
    "codigo":251403008,
    "descripcion":"INTOLERANCIA DEL INTESTINO DELGADO A LA GLUCOSA"
  },
  {
    "codigo":218635008,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR PARAMETADIONA"
  },
  {
    "codigo":85728002,
    "descripcion":"DESCRIPCIÓN EXCLUSIVAMENTE DEL ASPECTO MORFOLÓGICO"
  },
  {
    "codigo":216800002,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR CADMIO Y\/O COMPUESTO DE CADMIO"
  },
  {
    "codigo":249568007,
    "descripcion":"BORDE HEPÁTICO PALPABLE EN LA INSPIRACIÓN"
  },
  {
    "codigo":1263541003,
    "descripcion":"HIPOTENSIÓN INTRACRANEAL DEBIDA A RINORREA DE LÍQUIDO CEFALORRAQUÍDEO"
  },
  {
    "codigo":247733004,
    "descripcion":"ALUCINACIONES VISUALES SIN FORMA"
  },
  {
    "codigo":870325004,
    "descripcion":"INFECCIÓN PARASITARIA DE COLON CAUSADA POR ASCARIS LUMBRICOIDES"
  },
  {
    "codigo":772021008,
    "descripcion":"ALERGIA AL NEBIVOLOL"
  },
  {
    "codigo":409738001,
    "descripcion":"CLASIFICACIÓN INTERNACIONAL DE NEUROBLASTOMA: GRUPO CON HISTOLOGÍA DESFAVORABLE, PAC. DE 5 AÑOS O +, CON CUALQUIER SUBTIPO DE NEUROBLASTOMA (S\/ PREDOMINIO DE CÉL. DE SCHWANN EN EL ESTROMA) Y CUALQUIER ÍNDICE DE MITOSIS-CARIORREXIS"
  },
  {
    "codigo":442506007,
    "descripcion":"ENFERMEDAD INFLAMATORIA DE ESTRUCTURA GENITAL FEMENINA"
  },
  {
    "codigo":11777211000119105,
    "descripcion":"LACERACIÓN DE MÚSCULO TRÍCEPS BRAQUIAL IZQUIERDO"
  },
  {
    "codigo":735583001,
    "descripcion":"OBSTRUCCIÓN DE VENA CAVA INFERIOR CONCOMITANTE CON CUERPO EXTRAÑO Y DEBIDA A ÉL"
  },
  {
    "codigo":702815001,
    "descripcion":"TRASTORNO DE HIPERACTIVIDAD CON DÉFICIT DE ATENCIÓN, PRESENTACIÓN CON DESATENCIÓN (RESTRICTIVA)"
  },
  {
    "codigo":82058009,
    "descripcion":"MIELOCELE"
  },
  {
    "codigo":335201000119104,
    "descripcion":"HEMORRAGIA EXPULSIVA DE COROIDES DE OJO DERECHO"
  },
  {
    "codigo":473439008,
    "descripcion":"CONDRORRADIONECROSIS DE LARINGE"
  },
  {
    "codigo":897588005,
    "descripcion":"HIPERTROFIA CONGÉNITA BILATERAL DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":109321000,
    "descripcion":"OSTEOMIELITIS ESCLEROSANTE CRÓNICA NO SUPURATIVA DE HUESO DE LA CARA"
  },
  {
    "codigo":240393003,
    "descripcion":"CEREBRITIS POR LISTERIA"
  },
  {
    "codigo":404233006,
    "descripcion":"MENINGITIS CAUSADA POR VIRUS DE NILO OCCIDENTAL"
  },
  {
    "codigo":830217008,
    "descripcion":"CON MAYOR RIESGO DE PREOCUPACIÓN POR LA ALFABETIZACIÓN"
  },
  {
    "codigo":402398001,
    "descripcion":"URTICARIA AUTOINMUNITARIA AGUDA"
  },
  {
    "codigo":1156062003,
    "descripcion":"CARBAMAZEPINA SÉRICA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":271326004,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LABIO, CAVIDAD BUCAL Y FARINGE"
  },
  {
    "codigo":9182005,
    "descripcion":"CONDUCTA PELEADORA"
  },
  {
    "codigo":238558005,
    "descripcion":"ECCEMA INESPECÍFICO DE LA PUNTA DE LOS DEDOS DE LA MANO"
  },
  {
    "codigo":369630008,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA DE URETRA Y VEJIGA, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":236723002,
    "descripcion":"TRASTORNO DE IMPLANTE DE ESFÍNTER URINARIO"
  },
  {
    "codigo":171187003,
    "descripcion":"PRUEBA DE GUTHRIE ANORMAL"
  },
  {
    "codigo":11995841000119100,
    "descripcion":"HEMATOMA DE MUÑÓN DE AMPUTACIÓN DE EXTREMIDAD SUPERIOR IZQUIERDA"
  },
  {
    "codigo":15684801000119100,
    "descripcion":"PERIOSTITIS DE ANTEBRAZO DERECHO"
  },
  {
    "codigo":15741121000119102,
    "descripcion":"GANGLIÓN DE CARA PALMAR DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":1090241000119103,
    "descripcion":"ESTENOSIS ADQUIRIDA DE CONDUCTO AUDITIVO EXTERNO SECUNDARIA A INFECCIÓN"
  },
  {
    "codigo":10692801000119104,
    "descripcion":"EXCESO DE PIEL DE BRAZO"
  },
  {
    "codigo":296641000119105,
    "descripcion":"HIPERLAXITUD ARTICULAR DE CODO"
  },
  {
    "codigo":1074881000119106,
    "descripcion":"ARTRITIS DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":251770561000119107,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DEBIDO A EMBOLIA DE ARTERIA CEREBRAL ANTERIOR IZQUIERDA"
  },
  {
    "codigo":120001000119107,
    "descripcion":"PORTACIÓN DE ESTREPTOCOCO DEL GRUPO B QUE COMPLICA EL EMBARAZO"
  },
  {
    "codigo":337601000119109,
    "descripcion":"CATARATA DE OJO IZQUIERDO CAUSADA POR CORTICOSTEROIDE"
  },
  {
    "codigo":726408005,
    "descripcion":"MIOQUIMIA PALPEBRAL"
  },
  {
    "codigo":1085121000119107,
    "descripcion":"HEMORRAGIA GÁSTRICA DEBIDA A GASTRITIS SUPERFICIAL CRÓNICA"
  },
  {
    "codigo":680641000119108,
    "descripcion":"MEIBOMIANITIS DE PÁRPADO DERECHO"
  },
  {
    "codigo":15725761000119107,
    "descripcion":"SÍNDROME DE IMPACTO CUBITAL DE MUÑECA DERECHA"
  },
  {
    "codigo":7361000119105,
    "descripcion":"PERFORACIÓN DE MEMBRANA TIMPÁNICA DEBIDA A OTITIS MEDIA"
  },
  {
    "codigo":202120007,
    "descripcion":"DESGARRO ANTIGUO DEL COMPLEJO CAPSULAR INTERNO"
  },
  {
    "codigo":11304641000119107,
    "descripcion":"FRACTURA EXPUESTA DE CUELLO DE ÓRBITA"
  },
  {
    "codigo":342721000119109,
    "descripcion":"QUISTE DE PÁRPADO INFERIOR IZQUIERDO"
  },
  {
    "codigo":298589006,
    "descripcion":"DEFORMIDAD DE LA COLUMNA LUMBAR"
  },
  {
    "codigo":38280009,
    "descripcion":"HEMATOMETRA"
  },
  {
    "codigo":3677008,
    "descripcion":"PROBLEMA ACADÉMICO"
  },
  {
    "codigo":429661002,
    "descripcion":"NEUROMA DEL PIE"
  },
  {
    "codigo":296754000,
    "descripcion":"SOBREDOSIS DE DOXICICLINA"
  },
  {
    "codigo":198450003,
    "descripcion":"INFERTILIDAD SECUNDARIA DE ORIGEN HIPOFISARIO-HIPOTALÁMICO"
  },
  {
    "codigo":427826000,
    "descripcion":"FRACTURA DISTAL DE FÉMUR TIPO IV DE SALTER-HARRIS NO EXPUESTA"
  },
  {
    "codigo":460594002,
    "descripcion":"ANILLO VASCULAR CON CAYADO AÓRTICO DERECHO Y CONDUCTO ARTERIOSO IZQUIERDO DESDE DIVERTÍCULO DE AORTA RETROESOFÁGICO"
  },
  {
    "codigo":360455002,
    "descripcion":"ENFERMEDAD DE COATS"
  },
  {
    "codigo":425991004,
    "descripcion":"DISFUNCIÓN CERVICODORSAL SEGMENTARIA"
  },
  {
    "codigo":32775005,
    "descripcion":"EJE INDETERMINADO POR ELECTROCARDIOGRAMA"
  },
  {
    "codigo":194780003,
    "descripcion":"CARDIOPATÍA Y NEFROPATÍA HIPERTENSIVAS CON INSUFICIENCIA RENAL"
  },
  {
    "codigo":293084007,
    "descripcion":"REACCIÓN ADVERSA AL BENZOATO DE BENCILO"
  },
  {
    "codigo":94641004,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA TRÁQUEA"
  },
  {
    "codigo":291249007,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ÁCIDO LISÉRGICO"
  },
  {
    "codigo":92806000,
    "descripcion":"HEMIVÉRTEBRA CERVICAL"
  },
  {
    "codigo":289414001,
    "descripcion":"FONTANELA ANTERIOR PALPABLE EN LA REGIÓN LATERAL DERECHA"
  },
  {
    "codigo":27270004,
    "descripcion":"ENANISMO HIPOFISARIO CON SILLA TURCA GRANDE"
  },
  {
    "codigo":125574005,
    "descripcion":"HIPERPLASIA ANGIOLINFOIDEA CON EOSINOFILIA"
  },
  {
    "codigo":420486006,
    "descripcion":"MACULOPATÍA EXUDATIVA DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":1303387001,
    "descripcion":"FRACTURA DE HUESO DE MANDÍBULA"
  },
  {
    "codigo":254811006,
    "descripcion":"NEVO EPITELIOIDE Y FUSOCELULAR"
  },
  {
    "codigo":416816003,
    "descripcion":"DISTENSIÓN LIGAMENTOSA"
  },
  {
    "codigo":11861961000119100,
    "descripcion":"RUPTURA TRAUMÁTICA DE LIGAMENTO LATERAL INTERNO DE RODILLA IZQUIERDA"
  },
  {
    "codigo":285744009,
    "descripcion":"ALUCINACIONES FORMADAS: PERSONAS"
  },
  {
    "codigo":1332485001,
    "descripcion":"SARCOMA DE ESTROMA ENDOMETRIAL METASTÁSICO"
  },
  {
    "codigo":283909004,
    "descripcion":"CORTE DE URÉTER"
  },
  {
    "codigo":314842001,
    "descripcion":"REGISTRO DE RESIDENTE TEMPORARIO: VENCIDO"
  },
  {
    "codigo":282074002,
    "descripcion":"HEMATOMA ANAL"
  },
  {
    "codigo":52698002,
    "descripcion":"HIPERTENSIÓN ARTERIAL TRANSITORIA"
  },
  {
    "codigo":251141009,
    "descripcion":"ERROR ELECTROCARDIOGRÁFICO ATRIBUIBLE A LA CAPTACIÓN\/EQUIPO"
  },
  {
    "codigo":15984431000119109,
    "descripcion":"MALFORMACIÓN CONGÉNITA DEL OÍDO DERECHO CON ALTERACIÓN AUDITIVA"
  },
  {
    "codigo":183770009,
    "descripcion":"INSCRIPTO EN LISTA DE ADMISIÓN DERMATOLÓGICA"
  },
  {
    "codigo":1363418009,
    "descripcion":"SINEQUIAS ANTERIORES PERIFÉRICAS EN CUADRANTE SUPERIOR DE ÁNGULO IRIDOCORNEAL"
  },
  {
    "codigo":247471006,
    "descripcion":"ERUPCIÓN MACULOPAPULAR"
  },
  {
    "codigo":83631006,
    "descripcion":"TRASTORNO DE PÁNICO CON AGORAFOBIA, EVITACIÓN AGORAFÓBICA MODERADA Y ATAQUES DE PÁNICO GRAVES"
  },
  {
    "codigo":11780041000119105,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE ANTEBRAZO IZQUIERDO"
  },
  {
    "codigo":1197743009,
    "descripcion":"HEMORRAGIA DE SEGMENTO ESOFÁGICO INFERIOR DEBIDA A ENFERMEDAD POR REFLUJO GASTROESOFÁGICO EROSIVA"
  },
  {
    "codigo":81796004,
    "descripcion":"QUISTE IDIOPÁTICO EN EL IRIS"
  },
  {
    "codigo":737156006,
    "descripcion":"ANOMALÍA CONGÉNITA DE TABIQUE AURICULOVENTRICULAR"
  },
  {
    "codigo":16260007,
    "descripcion":"INTOXICACIÓN CAUSADA POR AZATIOPRINA"
  },
  {
    "codigo":702553000,
    "descripcion":"ESPINA NASAL ANTERIOR PROMINENTE"
  },
  {
    "codigo":14425001,
    "descripcion":"GANGLIO DE LA FRAMBESIA"
  },
  {
    "codigo":1163140008,
    "descripcion":"INFECCIÓN COLÓNICA POR HAEMOPHILUS DUCREYI"
  },
  {
    "codigo":276569005,
    "descripcion":"TRASTORNO DE LOS ELECTRÓLITOS DURANTE EL PERÍODO PERINATAL"
  },
  {
    "codigo":473177008,
    "descripcion":"OBSTRUCCIÓN DE SONDA NASOGÁSTRICA"
  },
  {
    "codigo":1259609008,
    "descripcion":"COREA DEBIDA A CITOPATÍA MITOCONDRIAL"
  },
  {
    "codigo":241966002,
    "descripcion":"ESCARCHADO"
  },
  {
    "codigo":307502000,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS DE LA BOCA"
  },
  {
    "codigo":1290542000,
    "descripcion":"USO INADECUADO NO INTENCIONAL DE MEDICACIÓN"
  },
  {
    "codigo":405806007,
    "descripcion":"TAQUICARDIA VENTRICULAR SIN PULSO"
  },
  {
    "codigo":274734008,
    "descripcion":"FRECUENCIA MICCIONAL Y POLIURIA"
  },
  {
    "codigo":373038009,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM INTERMEDIUM"
  },
  {
    "codigo":403971002,
    "descripcion":"GLOMANGIOMIOMA CUTÁNEO"
  },
  {
    "codigo":305667000,
    "descripcion":"ATENDIDO POR UN NEUROFISIÓLOGO CLÍNICO"
  },
  {
    "codigo":76291004,
    "descripcion":"CONSISTENCIA GRANULOSA FINA"
  },
  {
    "codigo":240131006,
    "descripcion":"RABDOMIÓLISIS"
  },
  {
    "codigo":895491007,
    "descripcion":"LIQUEN ESCLEROSO DE VULVA"
  },
  {
    "codigo":698883009,
    "descripcion":"COROIDITIS DISEMINADA DE POLO POSTERIOR"
  },
  {
    "codigo":860888005,
    "descripcion":"INFECCIÓN FÚNGICA DE ESTÓMAGO CAUSADA POR CANDIDA"
  },
  {
    "codigo":402136007,
    "descripcion":"MICOSIS SUPERFICIAL DEBIDA A MOHO SAPRÓFITO"
  },
  {
    "codigo":301997000,
    "descripcion":"DIFICULTAD PARA ACEPTAR BASE DE APOYO"
  },
  {
    "codigo":236461000,
    "descripcion":"ACIDOSIS TUBULAR RENAL DISTAL"
  },
  {
    "codigo":170925002,
    "descripcion":"NUEVA PRESCRIPCIÓN POR CAMBIO DE SÍNTOMAS"
  },
  {
    "codigo":72621003,
    "descripcion":"GINGIVITIS CRÓNICA"
  },
  {
    "codigo":762584007,
    "descripcion":"ESTAFILOSQUISIS CON LABIO LEPORINO IZQUIERDO Y FISURA ALVEOLAR IZQUIERDA"
  },
  {
    "codigo":7085002,
    "descripcion":"HIPERCALCEMIA SECUNDARIA A SARCOIDOSIS"
  },
  {
    "codigo":269229006,
    "descripcion":"CUERPO EXTRAÑO EN INTESTINO Y COLON"
  },
  {
    "codigo":234626000,
    "descripcion":"DEFICIENCIA DEL INHIBIDOR DEL COMPLEMENTO 5A"
  },
  {
    "codigo":418705661000119102,
    "descripcion":"FIBROMATOSIS AGRESIVA DE CABEZA Y CUELLO"
  },
  {
    "codigo":12081251000119109,
    "descripcion":"QUEMADURA QUÍMICA DE SACO CONJUNTIVAL IZQUIERDO"
  },
  {
    "codigo":365698005,
    "descripcion":"CRECIMIENTO DEL ORGANISMO - HALLAZGO"
  },
  {
    "codigo":1217666006,
    "descripcion":"CONJUNTIVITIS SECUNDARIA"
  },
  {
    "codigo":300162007,
    "descripcion":"OÍDO MEDIO-HALLAZGO"
  },
  {
    "codigo":167255000,
    "descripcion":"PRUEBA DE EMBARAZO EN ORINA, DUDOSA"
  },
  {
    "codigo":201858005,
    "descripcion":"GONARTROSIS POSTRAUMÁTICA, BILATERAL"
  },
  {
    "codigo":462167002,
    "descripcion":"MEDIASTINO FETAL DESPLAZADO HACIA LA DERECHA"
  },
  {
    "codigo":3415004,
    "descripcion":"CIANOSIS"
  },
  {
    "codigo":296492000,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE BACLOFENO"
  },
  {
    "codigo":198188007,
    "descripcion":"ENFERMEDAD INFLAMATORIA UTERINA CRÓNICA"
  },
  {
    "codigo":722476007,
    "descripcion":"SÍNDROME DE ENGROSAMIENTO DE LÓBULO AURICULAR CON SORDERA DE CONDUCCIÓN"
  },
  {
    "codigo":788012008,
    "descripcion":"INFLAMACIÓN DE PELVIS CAUSADA POR CHLAMYDIA TRACHOMATIS"
  },
  {
    "codigo":294657002,
    "descripcion":"ALERGIA A COMPONENTE DE VACUNA QUE CONTIENE ANTÍGENO DE VIRUS VACCINIA"
  },
  {
    "codigo":1179393009,
    "descripcion":"DUODENITIS VIRAL"
  },
  {
    "codigo":292822002,
    "descripcion":"REACCIÓN ADVERSA AL MICONAZOL"
  },
  {
    "codigo":391126003,
    "descripcion":"GRADO 5 DE LA ESCALA DE DISNEA DEL MEDICAL RESEARCH COUNCIL"
  },
  {
    "codigo":11809021000119109,
    "descripcion":"HERIDA DE REGIÓN DE CADERA IZQUIERDA DEBIDA A PICADURA DE INSECTO NO VENENOSO"
  },
  {
    "codigo":423894005,
    "descripcion":"MIGRAÑA REFRACTARIA"
  },
  {
    "codigo":784342008,
    "descripcion":"EPILEPSIA MIOCLÓNICA INFANTIL FAMILIAR"
  },
  {
    "codigo":290987001,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR ZOPICLONA"
  },
  {
    "codigo":127147002,
    "descripcion":"LINFADENOPATÍA RECTAL SUPERIOR"
  },
  {
    "codigo":67991000119104,
    "descripcion":"COLESTEROL EN SUERO FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":94379004,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE AMÍGDALA LINGUAL"
  },
  {
    "codigo":225451008,
    "descripcion":"CREE QUE LO ESPÍAN POR EL TELEVISOR"
  },
  {
    "codigo":92544001,
    "descripcion":"CARCINOMA IN SITU DE LA BASE DE LA LENGUA"
  },
  {
    "codigo":715136004,
    "descripcion":"INCAPAZ DE PASAR DE UNA SILLA DE RUEDAS A LA CAMA"
  },
  {
    "codigo":289152009,
    "descripcion":"HALLAZGO RELACIONADO CON LA FRECUENCIA DE LA INGESTIÓN DE ALCOHOL"
  },
  {
    "codigo":1335893002,
    "descripcion":"ANTICUERPO CONTRA DEPENDOPARVOVIRUS DETECTADO"
  },
  {
    "codigo":254549003,
    "descripcion":"CARCINOMA DE TERCIO MEDIO DE ESÓFAGO"
  },
  {
    "codigo":25173007,
    "descripcion":"NEOPLASIA RECIDIVANTE"
  },
  {
    "codigo":285482000,
    "descripcion":"NO REDONDEA LOS LABIOS"
  },
  {
    "codigo":1268522004,
    "descripcion":"LESIÓN DE ARTERIA CÓLICA"
  },
  {
    "codigo":711466007,
    "descripcion":"ALTURA FACIAL ANTERIOR INFERIOR DISMINUIDA"
  },
  {
    "codigo":416554009,
    "descripcion":"ATENDIDO EN CONSULTORIO EXTRAHOSPITALARIO ESPECIALIZADO EN DIABETES"
  },
  {
    "codigo":283647006,
    "descripcion":"HERIDA PUNZANTE DE MANO CAUSADA POR AGUJA DE COSER"
  },
  {
    "codigo":1363156000,
    "descripcion":"ASTILLA EN PARED TORÁCICA"
  },
  {
    "codigo":707796002,
    "descripcion":"FUSIÓN DE INCISIVOS MANDIBULARES"
  },
  {
    "codigo":871636005,
    "descripcion":"DEFECTO DE TABIQUE VENTRICULAR CON COMPROMISO DOBLE DE SALIDA YUXTAARTERIAL CON TABIQUE DE SALIDA FIBROSO MAL ALINEADO EN LA PARTE ANTERIOR Y BORDE POSTEROINFERIOR MUSCULAR"
  },
  {
    "codigo":773332008,
    "descripcion":"SÍNDROME DE CRANEOSINOSTOSIS Y ANOMALÍAS DENTALES"
  },
  {
    "codigo":50601005,
    "descripcion":"INTOXICACIÓN POR ANTAGONISTA DE METALES PESADOS"
  },
  {
    "codigo":210771000,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE EXTREMIDAD"
  },
  {
    "codigo":46931002,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE SEGUNDA VÉRTEBRA CERVICAL"
  },
  {
    "codigo":866131003,
    "descripcion":"MIELITIS CAUSADA POR VIRUS HERPES HUMANO"
  },
  {
    "codigo":14163004,
    "descripcion":"FORMACIÓN ÓSEA ENDÓSTICA NORMAL"
  },
  {
    "codigo":79699005,
    "descripcion":"OMÓPLATO EN RESORTE"
  },
  {
    "codigo":767827003,
    "descripcion":"HERNIA INGUINAL DERECHA CON GANGRENA"
  },
  {
    "codigo":1259347006,
    "descripcion":"CARCINOMA PRIMARIO DE TERCIO SUPERIOR DE ESÓFAGO"
  },
  {
    "codigo":407379008,
    "descripcion":"TRANSEXUAL EN QUIEN SE REALIZÓ EL CAMBIO DE SEXO QUIRÚRGICAMENTE, DE MUJER A HOMBRE"
  },
  {
    "codigo":45096000,
    "descripcion":"INTOXICACIÓN POR PANICUM"
  },
  {
    "codigo":405544006,
    "descripcion":"HIPOPLASIA DE MÉDULA ÓSEA MEDICAMENTOSA"
  },
  {
    "codigo":733224007,
    "descripcion":"LACERACIÓN DE ARTERIA BRAQUIAL"
  },
  {
    "codigo":403709005,
    "descripcion":"COMPLICACIÓN DE CIRUGÍA CUTÁNEA"
  },
  {
    "codigo":698621006,
    "descripcion":"FRACTURA NO EXPUESTA DE BASE DE CRÁNEO CON CONMOCIÓN"
  },
  {
    "codigo":205266000,
    "descripcion":"MANO HENDIDA CON SINDACTILIA"
  },
  {
    "codigo":239869009,
    "descripcion":"ARTROSIS DE ARTICULACIÓN INTERFALÁNGICA DISTAL"
  },
  {
    "codigo":1080011000119109,
    "descripcion":"SARCOMA DE EWING PRIMARIO DE HUESO DE MANO IZQUIERDA"
  },
  {
    "codigo":762322007,
    "descripcion":"TRASTORNO DEL ESTADO DE O ÁNIMO CON SÍNTOMAS DEPRESIVOS Y MANÍACOS MIXTOS CAUSADO POR OPIOIDE"
  },
  {
    "codigo":301735002,
    "descripcion":"DIFICULTAD PARA REALIZAR ACTIVIDADES DE TALLER"
  },
  {
    "codigo":432807008,
    "descripcion":"SÍNDROME DE ALERGIA ORAL"
  },
  {
    "codigo":168828001,
    "descripcion":"COMIDA DE BARIO NORMAL"
  },
  {
    "codigo":170663008,
    "descripcion":"AUMENTO APROPIADO DE ESTEROIDES INHALATORIOS"
  },
  {
    "codigo":365436004,
    "descripcion":"HALLAZGO RELACIONADO CON TAMAÑO DE MATERIA FECAL"
  },
  {
    "codigo":103292006,
    "descripcion":"VÉRTIGO CONSTANTE"
  },
  {
    "codigo":299900007,
    "descripcion":"SENTIDO DEL OLFATO NORMAL"
  },
  {
    "codigo":234364007,
    "descripcion":"ANEMIA POR DEFICIENCIA COMBINADA"
  },
  {
    "codigo":789585000,
    "descripcion":"POLINEUROPATÍA SENSITIVA DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":207871000119100,
    "descripcion":"VÍCTIMA ADULTA DE MALTRATO EMOCIONAL"
  },
  {
    "codigo":199761003,
    "descripcion":"TRABAJO DE PARTO OBSTRUIDO POR PELVIS DEFORMADA"
  },
  {
    "codigo":298065007,
    "descripcion":"CUERPO EXTRAÑO EN LA PIEL DE LABIO"
  },
  {
    "codigo":230694003,
    "descripcion":"INFARTO POR ACCIDENTE CEREBROVASCULAR DE LA CIRCULACIÓN CEREBRAL ANTERIOR"
  },
  {
    "codigo":197926005,
    "descripcion":"INFECCIÓN POSQUIRÚRGICA DE LAS VÍAS URINARIAS"
  },
  {
    "codigo":1318006,
    "descripcion":"PROCESAMIENTO GENÉTICO DE PROTEÍNAS LUEGO DEL PROCESO DE TRADUCCIÓN"
  },
  {
    "codigo":296230009,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE PIPOTIAZINA"
  },
  {
    "codigo":292560000,
    "descripcion":"REACCIÓN ADVERSA A SURFACTANTE RESPIRATORIO"
  },
  {
    "codigo":1144528004,
    "descripcion":"SENTIDO DE POSICIÓN Y MOVIMIENTO NORMAL"
  },
  {
    "codigo":716709002,
    "descripcion":"SÍNDROME DE DISCAPACIDAD INTELECTUAL FRAXE"
  },
  {
    "codigo":28581003,
    "descripcion":"DISMETRÍA POR REBOTE"
  },
  {
    "codigo":290725002,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR PROCARBAZINA"
  },
  {
    "codigo":345241000119101,
    "descripcion":"COROIDITIS MACULAR FOCAL DE AMBOS OJOS"
  },
  {
    "codigo":126885006,
    "descripcion":"NEOPLASIA DE VEJIGA URINARIA"
  },
  {
    "codigo":714874001,
    "descripcion":"NO MANTIENE UNA POSICIÓN RECOSTADA"
  },
  {
    "codigo":26746005,
    "descripcion":"SÍNDROME DE LESIÓN POR FRÍO EN EL RECIÉN NACIDO"
  },
  {
    "codigo":92282005,
    "descripcion":"NEOPLASIA BENIGNA DE LOS GANGLIOS LINFÁTICOS AXILARES PECTORALES"
  },
  {
    "codigo":288890007,
    "descripcion":"INCAPAZ DE COMER CIERTOS ALIMENTOS"
  },
  {
    "codigo":287055001,
    "descripcion":"OSTEOMIELITIS CRÓNICA DE CADERA"
  },
  {
    "codigo":59514009,
    "descripcion":"AUSENCIA CONGÉNITA DE INTESTINO GRUESO"
  },
  {
    "codigo":876879006,
    "descripcion":"FALLECIDO EN DOMICILIO"
  },
  {
    "codigo":15664281000119105,
    "descripcion":"NEOPLASIA BENIGNA DE AMBAS RETINAS"
  },
  {
    "codigo":283385000,
    "descripcion":"LACERACIÓN DE MUSLO"
  },
  {
    "codigo":285220008,
    "descripcion":"CAPAZ DE RECORDAR NUEVAS HABILIDADES MOTRICES"
  },
  {
    "codigo":54009003,
    "descripcion":"RITMO CIRCADIANO NORMAL"
  },
  {
    "codigo":840441005,
    "descripcion":"DISECCIÓN DE ARTERIA INTRACRANEAL"
  },
  {
    "codigo":707534000,
    "descripcion":"ENFERMEDAD PULMONAR CRÓNICA DEBIDA A TRASTORNO DEL SURFACTANTE"
  },
  {
    "codigo":445390001,
    "descripcion":"DISPLASIA DE TESTÍCULO"
  },
  {
    "codigo":248782001,
    "descripcion":"ANEYACULACIÓN"
  },
  {
    "codigo":1297358004,
    "descripcion":"LUXACIÓN DE RODILLA DEBIDA A DISPLASIA CONGÉNITA"
  },
  {
    "codigo":84942005,
    "descripcion":"PARAGRAFÍA"
  },
  {
    "codigo":281550008,
    "descripcion":"RUPTURA DE TENDÓN DE PIE Y TOBILLO"
  },
  {
    "codigo":771235001,
    "descripcion":"TUMOR VASOPROLIFERATIVO DE RETINA"
  },
  {
    "codigo":159901000146106,
    "descripcion":"USUALMENTE INSEGURO ACERCA DE CUIDAR A UN NIÑO"
  },
  {
    "codigo":1295523001,
    "descripcion":"SÍNDROME MEDULAR ANTERIOR DEBIDO A NEOPLASIA"
  },
  {
    "codigo":246947003,
    "descripcion":"ULCERACIÓN CORNEAL MARGINAL - SIMPLE"
  },
  {
    "codigo":8861000146107,
    "descripcion":"VIVE CON HIJOS ADULTOS"
  },
  {
    "codigo":703864002,
    "descripcion":"TRASTORNO DE LA PIEL DEL ESCROTO"
  },
  {
    "codigo":212344006,
    "descripcion":"LESIÓN EXPUESTA DEL NERVIO OBTURADOR"
  },
  {
    "codigo":276045000,
    "descripcion":"CUIDA A SU CÓNYUGE CRÓNICAMENTE ENFERMO"
  },
  {
    "codigo":1259085004,
    "descripcion":"ENFERMEDAD AUTOINMUNITARIA DE MÉDULA ESPINAL"
  },
  {
    "codigo":46669005,
    "descripcion":"DEXTROLATERALIDAD"
  },
  {
    "codigo":308813009,
    "descripcion":"SITUACIÓN DE NOTIFICACIÓN"
  },
  {
    "codigo":110370002,
    "descripcion":"HIERRO DE LA MÉDULA ÓSEA: NORMAL"
  },
  {
    "codigo":732962005,
    "descripcion":"ANEMIA HEMOLÍTICA AUTOINMUNITARIA SECUNDARIA CONCOMITANTE CON ENFERMEDAD INFLAMATORIA CRÓNICA Y DEBIDA A ELLA"
  },
  {
    "codigo":42999000,
    "descripcion":"PERICARDITIS ADHESIVA CRÓNICA"
  },
  {
    "codigo":763895001,
    "descripcion":"MIOESCLEROSIS"
  },
  {
    "codigo":75767000,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE MEJILLA SIN INFECCIÓN"
  },
  {
    "codigo":292301000119104,
    "descripcion":"NEURALGIA DE NERVIO ILIOHIPOGÁSTRICO DERECHO"
  },
  {
    "codigo":403447004,
    "descripcion":"ULCERACIÓN BUCAL POR QUEMADURA POR AGENTES QUÍMICOS"
  },
  {
    "codigo":1290018008,
    "descripcion":"TUMOR NEUROENDOCRINO BIEN DIFERENCIADO PRIMARIO DE CONDUCTO CÍSTICO"
  },
  {
    "codigo":1255415006,
    "descripcion":"FRACTURA CONMINUTA DE FALANGE DE DEDO DE MANO"
  },
  {
    "codigo":237772002,
    "descripcion":"ATROFIA SUPRARRENAL"
  },
  {
    "codigo":675431000119100,
    "descripcion":"BLEFARITIS DE PÁRPADO IZQUIERDO CAUSADA POR ESTAFILOCOCO"
  },
  {
    "codigo":205004006,
    "descripcion":"ESTENOSIS DE URETRA ANTERIOR"
  },
  {
    "codigo":203169000,
    "descripcion":"OSTEOMIELITIS AGUDA DE FALANGE DE DEDO DE LA MANO"
  },
  {
    "codigo":39329003,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DEL FLANCO, CON INFECCIÓN"
  },
  {
    "codigo":10669671000119101,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN DE REGIÓN COCCÍGEA DE ESPALDA ESTADIO II"
  },
  {
    "codigo":301473004,
    "descripcion":"CAPAZ DE SUPERAR OBSTÁCULOS"
  },
  {
    "codigo":6561007,
    "descripcion":"DOLOR EN LA URETRA"
  },
  {
    "codigo":201334001,
    "descripcion":"PROBLEMA DE ELIMINACIÓN TRANSEPIDÉRMICA, INESPECÍFICO"
  },
  {
    "codigo":234102003,
    "descripcion":"LIPEDEMA"
  },
  {
    "codigo":365174004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA REALIZAR ACTIVIDADES DE DIBUJO"
  },
  {
    "codigo":37494006,
    "descripcion":"VELOCIDAD DE FLUJO ESPIRATORIO PICO, AUMENTADA"
  },
  {
    "codigo":299638009,
    "descripcion":"ARTICULACIÓN DEL DEDO DEL PIE ROJA"
  },
  {
    "codigo":428875002,
    "descripcion":"INFECCIÓN BACTERIANA RECURRENTE"
  },
  {
    "codigo":232267001,
    "descripcion":"NEUROPATÍA FACIAL INFLAMATORIA"
  },
  {
    "codigo":363339009,
    "descripcion":"COMPLICACIÓN UROLÓGICA DERIVADA DE PROCEDIMIENTO"
  },
  {
    "codigo":164896001,
    "descripcion":"FIBRILACIÓN VENTRICULAR EN EL ELECTROCARDIOGRAMA"
  },
  {
    "codigo":263200003,
    "descripcion":"FRACTURA DE BARTON DE LA PALMA DE LA MANO"
  },
  {
    "codigo":230432008,
    "descripcion":"CONVULSIONES FEBRILES FAMILIARES"
  },
  {
    "codigo":197664009,
    "descripcion":"TRASTORNOS TUBULARES CON PÉRDIDA DE FOSFATO"
  },
  {
    "codigo":64757003,
    "descripcion":"SARCOIDOSIS DE LOS GANGLIOS LINFÁTICOS"
  },
  {
    "codigo":294133003,
    "descripcion":"ALERGIA A DIFENHIDRAMINA"
  },
  {
    "codigo":392437005,
    "descripcion":"EMBRIOTOXON POSTERIOR"
  },
  {
    "codigo":425205008,
    "descripcion":"ESCALERAS NO SEGURAS EN EL HOGAR"
  },
  {
    "codigo":292298001,
    "descripcion":"REACCIÓN ADVERSA A LA MOCLOBEMIDA"
  },
  {
    "codigo":128458002,
    "descripcion":"MORFEA EN PLACAS"
  },
  {
    "codigo":1177034003,
    "descripcion":"INFECCIÓN PARASITARIA DE NERVIO PERIFÉRICO"
  },
  {
    "codigo":193994000,
    "descripcion":"OBSTRUCCIÓN CONGÉNITA DE CONDUCTO NASOLAGRIMAL"
  },
  {
    "codigo":95690009,
    "descripcion":"DESGARRO DE RETINA"
  },
  {
    "codigo":16705281000119104,
    "descripcion":"NEUROMA BILATERAL DE EXTREMIDADES SUPERIORES POSTERIOR A CIRUGÍA"
  },
  {
    "codigo":126623004,
    "descripcion":"NEOPLASIA DE MÚSCULO DE LOS MIEMBROS INFERIORES"
  },
  {
    "codigo":11790081000119104,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE DEDO MEDIO DE MANO DERECHA"
  },
  {
    "codigo":716447008,
    "descripcion":"CAPAZ DE COMPRAR EN LÍNEA"
  },
  {
    "codigo":290463009,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR DOCUSATO"
  },
  {
    "codigo":28319009,
    "descripcion":"ERITROCITOSIS POR CARDIOPATÍA"
  },
  {
    "codigo":288628006,
    "descripcion":"CAPAZ DE JUGAR CON LAS PALABRAS Y LOS SIGNIFICADOS"
  },
  {
    "codigo":92020008,
    "descripcion":"NEOPLASIA BENIGNA DEL CUERPO DEL ESTÓMAGO"
  },
  {
    "codigo":59252009,
    "descripcion":"SÍNDROME DE DE BARSEY"
  },
  {
    "codigo":254025006,
    "descripcion":"MICROSOMÍA FACIAL"
  },
  {
    "codigo":188489006,
    "descripcion":"RETICULOSARCOMA DE GANGLIOS LINFÁTICOS DE CABEZA, CARA Y CUELLO"
  },
  {
    "codigo":219422003,
    "descripcion":"HERIDA DE GUERRA POR EXPOSICIÓN A RADIACIÓN IONIZANTE DE ARMA NUCLEAR"
  },
  {
    "codigo":284958006,
    "descripcion":"MANEJA LA HIGIENE MENSTRUAL"
  },
  {
    "codigo":416030007,
    "descripcion":"CITOLOGÍA CERVICOVAGINAL: LESIÓN INTRAEPITELIAL ESCAMOSA DE BAJO GRADO"
  },
  {
    "codigo":874782009,
    "descripcion":"ANOMALÍA ADQUIRIDA DE VÁLVULA AURICULOVENTRICULAR (SIN MORFOLOGÍA MITRAL O TRICUSPÍDEA) DESPUÉS DE REPARACIÓN DE DEFECTO DEL TABIQUE AURICULOVENTRICULAR"
  },
  {
    "codigo":283123003,
    "descripcion":"AMPOLLA SUPERFICIAL TRAUMÁTICA DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":1004019008,
    "descripcion":"TRASTORNO FETAL DEBIDO A PROCEDIMIENTO QUIRÚRGICO SOBRE LA MADRE Y POSTERIOR A ÉL"
  },
  {
    "codigo":772808000,
    "descripcion":"INTOXICACIÓN CAUSADA POR USO INAPROPIADO DE DROGAS CON FINES RECREATIVOS"
  },
  {
    "codigo":19144002,
    "descripcion":"GLAUCOMA ABSOLUTO"
  },
  {
    "codigo":838344002,
    "descripcion":"LEUCEMIA-LINFOMA LINFOBLÁSTICO DE CÉLULAS B CON HIPODIPLOIDIA"
  },
  {
    "codigo":281288006,
    "descripcion":"ESPÉCIMEN CON HEMÓLISIS MACROSCÓPICA"
  },
  {
    "codigo":707272006,
    "descripcion":"DISQUERATOSIS CONGÉNITA AUTOSÓMICA RECESIVA"
  },
  {
    "codigo":248520009,
    "descripcion":"NÓDULO DE OSLER DE LA MANO"
  },
  {
    "codigo":246685003,
    "descripcion":"POSTURA OCULOCEFÁLICA ANORMAL"
  },
  {
    "codigo":312221005,
    "descripcion":"URETERITIS INFECCIOSA"
  },
  {
    "codigo":50077007,
    "descripcion":"ONICOPATÍA AZOÉMICA"
  },
  {
    "codigo":441458001,
    "descripcion":"RECUENTO DE PLAQUETAS POR DEBAJO DEL RANGO DE REFERENCIA AL NACER"
  },
  {
    "codigo":1162354002,
    "descripcion":"OSTEOSARCOMA DE CARTÍLAGO ARTICULAR DE COSTILLA"
  },
  {
    "codigo":81010002,
    "descripcion":"PRESIÓN ARTERIAL SISTÓLICA DISMINUIDA"
  },
  {
    "codigo":408690005,
    "descripcion":"RESPIRACIÓN CONTENIDA"
  },
  {
    "codigo":310386007,
    "descripcion":"SITUACIÓN DE INFORMACIÓN DEL PACIENTE"
  },
  {
    "codigo":15474008,
    "descripcion":"FRACTURA EXPUESTA DE PELVIS"
  },
  {
    "codigo":212082009,
    "descripcion":"QUEMADURA QUE COMPROMETE 50-59 PORCIENTO DE LA SUPERFICIE DEL CUERPO, CON QUEMADURA DE ESPESOR COMPLETO QUE AFECTA 50-59 PORCIENTO DE LA SUPERFICIE CORPORAL"
  },
  {
    "codigo":243015001,
    "descripcion":"LESIÓN POR ARMA EXPLOSIVA"
  },
  {
    "codigo":277618009,
    "descripcion":"LINFOMA FOLICULAR DE CÉLULAS B DE BAJO GRADO"
  },
  {
    "codigo":767303007,
    "descripcion":"EFECTO TÓXICO DE MANGANESO Y\/O COMPUESTOS DE MANGANESO"
  },
  {
    "codigo":110108000,
    "descripcion":"AVULSIÓN DEL VESTÍBULO MANDIBULAR"
  },
  {
    "codigo":44572005,
    "descripcion":"PERITONITIS TUBERCULOSA"
  },
  {
    "codigo":1156849001,
    "descripcion":"EPIDERMÓLISIS BULLOSA SIMPLE AUTOSÓMICA RECESIVA"
  },
  {
    "codigo":677941000119107,
    "descripcion":"QUISTE MACULAR DE OJO DERECHO"
  },
  {
    "codigo":16052431000119101,
    "descripcion":"TENDINOSIS DE BÍCEPS BRAQUIAL DERECHO"
  },
  {
    "codigo":42737008,
    "descripcion":"MASCULINIDAD"
  },
  {
    "codigo":237510004,
    "descripcion":"HIPERTIROIDISMO INDUCIDO POR YODO"
  },
  {
    "codigo":8134005,
    "descripcion":"NISTAGMO PERIÓDICO ALTERNANTE"
  },
  {
    "codigo":170139001,
    "descripcion":"EXAMEN DEL NIÑO A LOS 18 MESES: ANORMAL - EN TRATAMIENTO"
  },
  {
    "codigo":1251483004,
    "descripcion":"METÁSTASIS DE ADENOCARCINOMA EN PARAGANGLIOS"
  },
  {
    "codigo":202907005,
    "descripcion":"TENOSINOVITIS DE TOBILLO"
  },
  {
    "codigo":235675006,
    "descripcion":"GASTROPARESIA"
  },
  {
    "codigo":399515004,
    "descripcion":"TROMPA DE FALOPIO DERECHA FUSIONADA CON OVARIO DERECHO"
  },
  {
    "codigo":364912002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA ADAPTARSE A UNA POSICIÓN"
  },
  {
    "codigo":4464003,
    "descripcion":"ENFERMEDAD POR VIRUS ROCÍO"
  },
  {
    "codigo":233840006,
    "descripcion":"INFARTO ANTIGUO DE MIOCARDIO INFERIOR"
  },
  {
    "codigo":299376007,
    "descripcion":"DOLOR A LA PALPACIÓN EN EL HUECO POPLÍTEO"
  },
  {
    "codigo":70000009,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DE SITIOS MÚLTIPLES DE LA EXTREMIDAD INFERIOR"
  },
  {
    "codigo":11792591000119107,
    "descripcion":"LUXACIÓN TRAUMÁTICA ABIERTA DE ARTICULACIÓN DE DEDO MEDIO DE MANO DERECHA"
  },
  {
    "codigo":232005003,
    "descripcion":"DESGARRO IATROGÉNICO DE LA RETINA"
  },
  {
    "codigo":789061003,
    "descripcion":"TRASTORNO BIPOLAR DE CICLOS RÁPIDOS TIPO II"
  },
  {
    "codigo":197402000,
    "descripcion":"CÁLCULO DE VÍA BILIAR CON COLANGITIS"
  },
  {
    "codigo":66330001,
    "descripcion":"INFESTACIÓN CAUSADA POR PSORERGATES"
  },
  {
    "codigo":461381008,
    "descripcion":"TRAYECTO INTRAMURAL ANÓMALO DE PORCIÓN PROXIMAL DE ARTERIA CORONARIA DENTRO DE SENO AÓRTICO"
  },
  {
    "codigo":721690003,
    "descripcion":"ÚLCERA HEMORRÁGICA AGUDA DE RECTO"
  },
  {
    "codigo":262938004,
    "descripcion":"HEMORRAGIA SECUNDARIA"
  },
  {
    "codigo":295706003,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE MERCAPTOPURINA"
  },
  {
    "codigo":230170002,
    "descripcion":"ENCEFALITIS POR VIRUS KUMLINGE"
  },
  {
    "codigo":228335000,
    "descripcion":"LA BEBIDA TIENE PRIORIDAD SOBRE LAS OBLIGACIONES SOCIALES"
  },
  {
    "codigo":293871004,
    "descripcion":"ALERGIA A CLONAZEPAM"
  },
  {
    "codigo":64495007,
    "descripcion":"BRAZO INESTABLE"
  },
  {
    "codigo":62660000,
    "descripcion":"SEDIMENTO CONJUNTIVAL"
  },
  {
    "codigo":783556000,
    "descripcion":"SÍNDROME DE RESISTENCIA SEVERA A LA INSULINA Y OBESIDAD DE COMIENZO TEMPRANO DEBIDO A DEFICIENCIA DE PROTEÍNA 1 ADAPTADORA SH2B"
  },
  {
    "codigo":95428004,
    "descripcion":"DEFORMIDAD ADQUIRIDA DEL TRONCO"
  },
  {
    "codigo":128196005,
    "descripcion":"RADICULOPATÍA LUMBAR"
  },
  {
    "codigo":292036008,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR ESPERMICIDA"
  },
  {
    "codigo":60825003,
    "descripcion":"QUEMADURA PROFUNDA DE TERCER GRADO DE LA REGIÓN ESCAPULAR"
  },
  {
    "codigo":93593004,
    "descripcion":"OSIFICACIÓN INCOMPLETA DEL METATARSO"
  },
  {
    "codigo":290201006,
    "descripcion":"INTOXICACIÓN POR FENTANILO"
  },
  {
    "codigo":536691000221104,
    "descripcion":"TESTIGO DE EPISODIOS DE VIOLENCIA"
  },
  {
    "codigo":288366001,
    "descripcion":"NO LEVANTA OBJETOS"
  },
  {
    "codigo":124526003,
    "descripcion":"DEFICIENCIA DE ADP DESAMINASA"
  },
  {
    "codigo":58990004,
    "descripcion":"ABORTO ESPONTÁNEO COMPLICADO POR LESIÓN DE ÓRGANOS Y\/O TEJIDOS PÉLVICOS"
  },
  {
    "codigo":253763002,
    "descripcion":"DISMOTILIDAD ESTOMACAL"
  },
  {
    "codigo":712515002,
    "descripcion":"ADENOMA DE COLON ASCENDENTE"
  },
  {
    "codigo":24387006,
    "descripcion":"INFECCIÓN CAUSADA POR DAVAINEA"
  },
  {
    "codigo":778051008,
    "descripcion":"QUERATODERMIA PALMOPLANTAR FOCAL CON QUERATOSIS EN LAS ARTICULACIONES"
  },
  {
    "codigo":284696005,
    "descripcion":"AUTORREMOCIÓN DE LAS UÑAS"
  },
  {
    "codigo":1234968008,
    "descripcion":"TRASTORNO NEONATAL DEBIDO A CORDÓN UMBILICAL CORTO"
  },
  {
    "codigo":11821571000119107,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA ANTERIOR DE ARTICULACIÓN ESTERNOCLAVICULAR DERECHA"
  },
  {
    "codigo":413933004,
    "descripcion":"MIOCARDITIS POR COXSACKIE DEL RECIÉN NACIDO"
  },
  {
    "codigo":53485006,
    "descripcion":"SÍNDROME DE BEHCET, INCOMPLETO"
  },
  {
    "codigo":1003757007,
    "descripcion":"REACCIÓN ALÉRGICA CAUSADA POR PROTEÍNA DEL LÁTEX DE HEVEA BRASILIENSIS"
  },
  {
    "codigo":282861007,
    "descripcion":"SE MANTIENE SENTADO"
  },
  {
    "codigo":1264066001,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS QUERATINIZANTE DE NASOFARINGE METASTÁSICO"
  },
  {
    "codigo":1296834002,
    "descripcion":"DESPLAZAMIENTO TRAUMÁTICO DE HUESO"
  },
  {
    "codigo":248258007,
    "descripcion":"CIRCUNSTANCIAS QUE INTERFIEREN CON EL SUEÑO"
  },
  {
    "codigo":770711001,
    "descripcion":"REACCIÓN ADVERSA AL FACTOR VIII"
  },
  {
    "codigo":49815007,
    "descripcion":"DAÑO DEL CÓCCIX DURANTE EL PARTO"
  },
  {
    "codigo":277356002,
    "descripcion":"APNEA POR MIVACURIO"
  },
  {
    "codigo":15212002,
    "descripcion":"UNIÓN MACROMOLECULAR ANORMAL"
  },
  {
    "codigo":1293164004,
    "descripcion":"HIPERTROFIA DE MÚSCULO CRICOFARÍNGEO"
  },
  {
    "codigo":47980004,
    "descripcion":"INTOXICACIÓN POR MERCURIO INORGÁNICO"
  },
  {
    "codigo":439361000,
    "descripcion":"NEOPLASIA DE TRACTO AERODIGESTIVO SUPERIOR"
  },
  {
    "codigo":275521001,
    "descripcion":"BEBÉ AZUL"
  },
  {
    "codigo":78913002,
    "descripcion":"EDEMA DEL RECIÉN NACIDO"
  },
  {
    "codigo":1260396009,
    "descripcion":"DISTONÍA DEBIDA A TRASTORNO HEREDITARIO"
  },
  {
    "codigo":111681000,
    "descripcion":"HEMORRAGIA EXTRADURAL POSTRAUMÁTICA CON HERIDA INTRACRANEAL ABIERTA Y PÉRDIDA DE LA CONSCIENCIA"
  },
  {
    "codigo":699670000,
    "descripcion":"SÍNDROME DE MEMBRANA AXILAR"
  },
  {
    "codigo":406593009,
    "descripcion":"METAHEMOGLOBINEMIA DEBIDA A INTOXICACIÓN CON NITRATO"
  },
  {
    "codigo":765206003,
    "descripcion":"SÍNDROME DE ANILLOS DE CONSTRICCIÓN"
  },
  {
    "codigo":371990006,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA ENCÍA"
  },
  {
    "codigo":208150008,
    "descripcion":"FRACTURA NO EXPUESTA DE ACETÁBULO, PISO"
  },
  {
    "codigo":11542009,
    "descripcion":"PÉRDIDA DEL AFECTO"
  },
  {
    "codigo":1254891003,
    "descripcion":"REACCIÓN CUTÁNEA POR MORDEDURA DE PULPO"
  },
  {
    "codigo":9707006,
    "descripcion":"VÓLVULO INTESTINAL"
  },
  {
    "codigo":239083007,
    "descripcion":"LEUCOPATÍA PROGRESIVA SIMÉTRICA"
  },
  {
    "codigo":402923008,
    "descripcion":"ACNÉ NECRÓTICA VARIOLIFORME DE MARGEN DE IMPLANTACIÓN PILOSA"
  },
  {
    "codigo":1187520001,
    "descripcion":"SÍNDROME DE LEIGH DEBIDO A DEFICIENCIA DE CITOCROMO C OXIDASA"
  },
  {
    "codigo":106176003,
    "descripcion":"HALLAZGO RELACIONADO CON EL SISTEMA ENDOCRINO"
  },
  {
    "codigo":10949431000119106,
    "descripcion":"HERIDA PUNZANTE DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":827072007,
    "descripcion":"MESOMORFO"
  },
  {
    "codigo":366485000,
    "descripcion":"AMPLITUD DE LA ROTACIÓN INTERNA DE HOMBRO - HALLAZGO"
  },
  {
    "codigo":40640008,
    "descripcion":"FIBROSIS PULMONAR MASIVA CONCOMITANTE CON SILICOSIS Y DEBIDA A ELLA"
  },
  {
    "codigo":169877002,
    "descripcion":"PERÍMETRO CEFÁLICO AL NACER: < PERCENTILO 3"
  },
  {
    "codigo":11768631000119107,
    "descripcion":"HEMATOMA SUBUNGUEAL DE DEDO MEDIO DE MANO DERECHA"
  },
  {
    "codigo":399253005,
    "descripcion":"QUISTE SIMPLE DE MAMA"
  },
  {
    "codigo":71573006,
    "descripcion":"PENSAMIENTO CONCRETO"
  },
  {
    "codigo":300949007,
    "descripcion":"DEDO DE LA MANO INFECTADO"
  },
  {
    "codigo":725098001,
    "descripcion":"SÍNDROME CRANEOMICROMÉLICO"
  },
  {
    "codigo":299114006,
    "descripcion":"CREPITACIÓN PALPABLE DE ARTICULACIÓN DE DEDO DE MANO"
  },
  {
    "codigo":102506008,
    "descripcion":"NIÑO SANO"
  },
  {
    "codigo":2367005,
    "descripcion":"GASTRITIS HEMORRÁGICA AGUDA"
  },
  {
    "codigo":33300005,
    "descripcion":"SENSACIÓN DE IMPOTENCIA"
  },
  {
    "codigo":295444006,
    "descripcion":"SOBREDOSIS DE LACTULOSA"
  },
  {
    "codigo":262676007,
    "descripcion":"CONTUSIÓN DE LA LARINGE"
  },
  {
    "codigo":721428008,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÉDULA ESPINAL DORSAL"
  },
  {
    "codigo":197140007,
    "descripcion":"MEGACOLON SECUNDARIO - CONGÉNITO"
  },
  {
    "codigo":15674321000119107,
    "descripcion":"MIOSITIS INTERSTICIAL DE AMBOS HOMBROS"
  },
  {
    "codigo":195305003,
    "descripcion":"GANGRENA DEL PULGAR"
  },
  {
    "codigo":424681004,
    "descripcion":"ANIMAL INFECTADO EN EL AMBIENTE"
  },
  {
    "codigo":31465005,
    "descripcion":"BORRAMIENTO CERVICAL, 80%"
  },
  {
    "codigo":64233004,
    "descripcion":"QUISTE FIMBRIAL EMBRIONARIO"
  },
  {
    "codigo":293609004,
    "descripcion":"ALERGIA A LEVORFANOL"
  },
  {
    "codigo":129769006,
    "descripcion":"CALCIFICACIÓN EN ACÚMULOS"
  },
  {
    "codigo":719593009,
    "descripcion":"DEPRESIÓN MODERADAMENTE SEVERA"
  },
  {
    "codigo":95166007,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LOS ANEXOS UTERINOS"
  },
  {
    "codigo":93331000,
    "descripcion":"POSICIÓN ANÓMALA CONGÉNITA DEL ISQUION"
  },
  {
    "codigo":160702009,
    "descripcion":"EMIGRANTE ILEGAL"
  },
  {
    "codigo":226238008,
    "descripcion":"DIETA SIN CARNE DE VACA"
  },
  {
    "codigo":715923003,
    "descripcion":"SÍNDROME DE DEFICIENCIA DE LIPASA ÁCIDA LISOSÓMICA"
  },
  {
    "codigo":717758009,
    "descripcion":"ATRESIA Y ESTENOSIS CONGÉNITAS DE URÉTER"
  },
  {
    "codigo":38401000087101,
    "descripcion":"HIPOCINESIA DE REGIÓN DE MIOCARDIO DE VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":224403006,
    "descripcion":"PRODUCTIVIDAD EN EL TRABAJO"
  },
  {
    "codigo":46081000087103,
    "descripcion":"ESGUINCE DE LIGAMENTO ISQUIOFEMORAL DERECHO"
  },
  {
    "codigo":1172840000,
    "descripcion":"SCHWANNOMA BENIGNO DE NERVIO DE MUCOSA GINGIVAL"
  },
  {
    "codigo":43521000087104,
    "descripcion":"DESGARRO DE MENISCO INTERNO DE ARTICULACIÓN DE RODILLA IZQUIERDA"
  },
  {
    "codigo":124264000,
    "descripcion":"DEFICIENCIA DE GLICEROL - 3 - FOSFATO ACILTRANSFERASA"
  },
  {
    "codigo":40961000087105,
    "descripcion":"QUEMADURA DE PÁRPADO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":1303912008,
    "descripcion":"CORDÓN MEDULAR RETENIDO CONGÉNITO"
  },
  {
    "codigo":286269000,
    "descripcion":"CAPAZ DE USAR ARTICULACIÓN SECUNDARIA"
  },
  {
    "codigo":253501000,
    "descripcion":"ANOMALÍA DE CUERDAS TENDINOSAS DE VÁLVULA AURICULOVENTRICULAR IZQUIERDA"
  },
  {
    "codigo":89661005,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO DE PALMA DE LA MANO"
  },
  {
    "codigo":56893005,
    "descripcion":"HIPOSECRECIÓN DE LA GLÁNDULA SALIVAL"
  },
  {
    "codigo":448274000,
    "descripcion":"NEOPLASIA MALIGNA DE TEJIDO CONJUNTIVO"
  },
  {
    "codigo":24125008,
    "descripcion":"TRASTORNOS MENTALES EN LA INFANCIA"
  },
  {
    "codigo":251666009,
    "descripcion":"CARDIOTOCOGRAFÍA - HALLAZGO"
  },
  {
    "codigo":249831002,
    "descripcion":"HEMIHIPERTROFIA DE MÚSCULO ESQUELÉTICO"
  },
  {
    "codigo":774119001,
    "descripcion":"OBSTRUCCIÓN DE TROMPA DE EUSTAQUIO IZQUIERDA"
  },
  {
    "codigo":315367001,
    "descripcion":"NACIDO EN ALGERIA"
  },
  {
    "codigo":217063006,
    "descripcion":"TRATAMIENTO DE CHOQUE COMO CAUSA DE REACCIÓN ANORMAL DEL PACIENTE, O DE COMPLICACIÓN POSTERIOR, SIN MENCIÓN DE IMPREVISTOS DURANTE EL PROCEDIMIENTO"
  },
  {
    "codigo":446439006,
    "descripcion":"INTOXICACIÓN POR INGESTIÓN DE PESCADO CONTAMINADO CON TOXINA AMBIENTAL"
  },
  {
    "codigo":1362108000,
    "descripcion":"DISCAPACIDAD INTELECTUAL DE CAUSA GENÉTICA"
  },
  {
    "codigo":85991008,
    "descripcion":"ABORTO ESPONTÁNEO CON PERITONITIS PÉLVICA"
  },
  {
    "codigo":444604002,
    "descripcion":"CARCINOMA DE MAMA CON CARACTERÍSTICAS DUCTALES Y LOBULILLARES"
  },
  {
    "codigo":870588003,
    "descripcion":"SEPSIS DEBIDA A COVID-19"
  },
  {
    "codigo":247996004,
    "descripcion":"EXCITACIÓN INCONTROLABLE"
  },
  {
    "codigo":442769000,
    "descripcion":"EVALUACIÓN DE SISTEMA OCULOMOTOR, ANORMAL"
  },
  {
    "codigo":18620009,
    "descripcion":"SECUESTRO CONGÉNITO DEL PULMÓN"
  },
  {
    "codigo":1075811000000105,
    "descripcion":"INCAPAZ DE COMPRAR EN LÍNEA"
  },
  {
    "codigo":278929008,
    "descripcion":"INFECCIÓN POR HEPATITIS C CONGÉNITA"
  },
  {
    "codigo":1260134001,
    "descripcion":"SÍNDROME DE PARAPARESIA ESPÁSTICA, DISCAPACIDAD INTELECTUAL, NISTAGMO Y OBESIDAD"
  },
  {
    "codigo":211558005,
    "descripcion":"LESIÓN TRAUMÁTICA ABIERTA POR APLASTAMIENTO, AXILA"
  },
  {
    "codigo":735846008,
    "descripcion":"AVULSIÓN DE LIGAMENTO CON FRAGMENTO ÓSEO DE MALÉOLO INTERNO"
  },
  {
    "codigo":14950009,
    "descripcion":"FRACTURA DE SEIS COSTILLAS"
  },
  {
    "codigo":200755008,
    "descripcion":"ABSCESO DE EXTREMIDAD"
  },
  {
    "codigo":209723004,
    "descripcion":"SECCIÓN EXPUESTA DE LIGAMENTO ILIOLUMBAR"
  },
  {
    "codigo":275259005,
    "descripcion":"MALFORMACIÓN CONGÉNITA DE OÍDO"
  },
  {
    "codigo":76816000,
    "descripcion":"COLITIS JABONOSA"
  },
  {
    "codigo":240656001,
    "descripcion":"EXANTEMA DE CHAGAS"
  },
  {
    "codigo":734011009,
    "descripcion":"SEPARACIÓN GENERALIZADA DE DIENTES INFERIORES"
  },
  {
    "codigo":764944006,
    "descripcion":"DISTROFIA MUSCULAR CONGÉNITA TIPO 1B"
  },
  {
    "codigo":109584007,
    "descripcion":"PÉRDIDA DE LOS DIENTES POR DESGASTE"
  },
  {
    "codigo":763109002,
    "descripcion":"FISURA CENTRAL DE PALADAR BLANDO"
  },
  {
    "codigo":238821003,
    "descripcion":"ELASTÓLISIS DÉRMICA IDIOPÁTICA"
  },
  {
    "codigo":1287397005,
    "descripcion":"HERIDA POR ARMA DE FUEGO DE REGIÓN DE HOMBRO"
  },
  {
    "codigo":402661009,
    "descripcion":"VASCULITIS PARANEOPLÁSICA"
  },
  {
    "codigo":1187258003,
    "descripcion":"CALCIO EN SUERO POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":73146005,
    "descripcion":"SÍNDROME DE HUNTER, FORMA SEVERA"
  },
  {
    "codigo":202383000,
    "descripcion":"DERRAME ARTICULAR DE TOBILLO"
  },
  {
    "codigo":169615001,
    "descripcion":"ATENCIÓN PRENATAL BRINDADA POR CONSULTOR"
  },
  {
    "codigo":71311003,
    "descripcion":"CIFOSIS CONGÉNITA"
  },
  {
    "codigo":366223007,
    "descripcion":"ANGULACIÓN DENTARIA - HALLAZGO"
  },
  {
    "codigo":398991009,
    "descripcion":"RETRASO MOTOR"
  },
  {
    "codigo":167780001,
    "descripcion":"NÚMERO DE ESPERMATOZOIDES\/CC MUY BAJO: 0 - 10 MILLONES"
  },
  {
    "codigo":298852004,
    "descripcion":"SIN AMPLITUD PASIVA DE CIRCUNDUCCIÓN DE HOMBRO"
  },
  {
    "codigo":724836008,
    "descripcion":"PANICULITIS CALCIFICANTE"
  },
  {
    "codigo":723001002,
    "descripcion":"HIPOHIDROSIS DEBIDA A ANOMALÍA GENÉTICA DE LA ESTRUCTURA Y FUNCIÓN DE LAS GLÁNDULAS ECRINAS"
  },
  {
    "codigo":67641002,
    "descripcion":"PRUEBA DE CUBRIR Y DESCUBRIR"
  },
  {
    "codigo":34873006,
    "descripcion":"LUXACIÓN EXPUESTA DE LA MUÑECA"
  },
  {
    "codigo":165945006,
    "descripcion":"ANTICUERPOS MONOCLONALES DETECTADOS"
  },
  {
    "codigo":428089008,
    "descripcion":"HEMANGIOMA VENOSO DEL CEREBRO"
  },
  {
    "codigo":721166000,
    "descripcion":"VIRUS DE LA INMUNODEFICIENCIA HUMANA QUE COMPLICA EL EMBARAZO, PARTO Y PUERPERIO"
  },
  {
    "codigo":33038002,
    "descripcion":"HEMATOPOYESIS NORMAL"
  },
  {
    "codigo":297017009,
    "descripcion":"SOBREDOSIS DE FUROSEMIDA"
  },
  {
    "codigo":295182006,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE NALBUFINA"
  },
  {
    "codigo":1145315000,
    "descripcion":"FILTRO ANCHO"
  },
  {
    "codigo":293347001,
    "descripcion":"EFECTO ADVERSO HEMOSTÁTICO"
  },
  {
    "codigo":11773651000119104,
    "descripcion":"HERIDA INFECTADA DE CODO IZQUIERDO DEBIDA A PICADURA DE INSECTO NO VENENOSO"
  },
  {
    "codigo":94904002,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL LÓBULO INFERIOR IZQUIERDO DEL PULMÓN"
  },
  {
    "codigo":1881000124100,
    "descripcion":"TRANSICIÓN DE LA ATENCIÓN AGUDA A ATENCIÓN PROLONGADA"
  },
  {
    "codigo":93069000,
    "descripcion":"HIPERTROFIA CONGÉNITA DE VÁLVULA AÓRTICA"
  },
  {
    "codigo":1141645001,
    "descripcion":"ENDOCARDITIS VEGETATIVA INFECCIOSA"
  },
  {
    "codigo":191373003,
    "descripcion":"POLICITEMIA POR ENFERMEDAD RESPIRATORIA CIANÓTICA"
  },
  {
    "codigo":224141007,
    "descripcion":"VIVE CON LOS ABUELOS"
  },
  {
    "codigo":255074000,
    "descripcion":"NEOPLASIA MALIGNA DE CAVIDAD NASAL Y NASOFARINGE"
  },
  {
    "codigo":91234001,
    "descripcion":"ESCALA DEL COMA DE GLASGOW, 12"
  },
  {
    "codigo":289677009,
    "descripcion":"ÚTERO GRÁVIDO AUSENTE"
  },
  {
    "codigo":713826008,
    "descripcion":"OSTEOARTROSIS DE ARTICULACIÓN CIGOAPOFISARIA DE COLUMNA VERTEBRAL LUMBAR"
  },
  {
    "codigo":449847003,
    "descripcion":"DIENTE INFERIOR PERMANENTE SUPERNUMERARIO"
  },
  {
    "codigo":1269047004,
    "descripcion":"TUMOR PAPILAR DE REGIÓN PINEAL PRIMARIO"
  },
  {
    "codigo":417079005,
    "descripcion":"SÍNDROME TÓXICO DEL SEGMENTO ANTERIOR"
  },
  {
    "codigo":286007008,
    "descripcion":"DIFICULTAD PARA CERRAR LA TUBERÍA DE GAS MAESTRA"
  },
  {
    "codigo":253239009,
    "descripcion":"HIPOPLASIA SECTORIAL DE LA PAPILA ÓPTICA"
  },
  {
    "codigo":218636009,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR TRIMETADIONA"
  },
  {
    "codigo":216801003,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR SAL DE COBRE"
  },
  {
    "codigo":249569004,
    "descripcion":"HALLAZGO RELACIONADO CON LA VESÍCULA BILIAR"
  },
  {
    "codigo":18358003,
    "descripcion":"PROSOPAGNOSIA"
  },
  {
    "codigo":870326003,
    "descripcion":"INFECCIÓN PARASITARIA DE COLON CAUSADA POR STRONGYLOIDES"
  },
  {
    "codigo":1263542005,
    "descripcion":"SÍNDROME DEL MUÑÓN SALTARÍN"
  },
  {
    "codigo":247734005,
    "descripcion":"ALUCINACIONES VISUALES CON FORMA"
  },
  {
    "codigo":11829101000119109,
    "descripcion":"AMPOLLA TRAUMÁTICA DE RODILLA DERECHA"
  },
  {
    "codigo":213131003,
    "descripcion":"DISPOSITIVO PROTÉSICO INTERNO QUE PRODUCE EMBOLIA"
  },
  {
    "codigo":702816000,
    "descripcion":"SÍNDROME DE DUPLICACIÓN XQ28 PROXIMAL"
  },
  {
    "codigo":409739009,
    "descripcion":"CLASIF. INTERNAC. DE NEUROBLASTOMA: HISTOL. DESFAVOR., PAC. >1,5 AÑOS Y <5 AÑOS, CON NEUROBLASTOMA MAL DIFERENCIADO Y CUALQUIER ÍNDICE DE MITOSIS-CARIORREXIS O NEUROBLASTOMA DIFERENCIADO E ÍNDICE INTERMEDIO\/ELEVADO DE MITOSIS-CARIORREXIS"
  },
  {
    "codigo":80224003,
    "descripcion":"GESTACIÓN MÚLTIPLE CON UNA PRESENTACIÓN FETAL ANÓMALA O MÁS"
  },
  {
    "codigo":16527521000119100,
    "descripcion":"CARCINOMA NO MICROCÍTICO PRIMARIO DE LÓBULO SUPERIOR DE PULMÓN IZQUIERDO"
  },
  {
    "codigo":735584007,
    "descripcion":"TRASTORNO DE AURÍCULA POSTERIOR A PROCEDIMIENTO"
  },
  {
    "codigo":897589002,
    "descripcion":"AUSENCIA PARCIAL CONGÉNITA DE MÚSCULO GÁSTRICO"
  },
  {
    "codigo":10956961000119101,
    "descripcion":"HERIDA ABIERTA DE DEDO ÍNDICE IZQUIERDO DEBIDA A MORDEDURA HUMANA"
  },
  {
    "codigo":1290805004,
    "descripcion":"LUXACIÓN DE ARTICULACIÓN DE HUESO SEMILUNAR"
  },
  {
    "codigo":12853006,
    "descripcion":"EMBOLIA DE LA PRENSA DE HERÓFILO"
  },
  {
    "codigo":404234000,
    "descripcion":"MENINGITIS CAUSADA POR VIRUS DE ENCEFALITIS DE SAINT LOUIS"
  },
  {
    "codigo":109322007,
    "descripcion":"OSTEOMIELITIS ESCLEROSANTE CRÓNICA NO SUPURATIVA DE HUESO FRONTAL"
  },
  {
    "codigo":240394009,
    "descripcion":"ERISIPELOIDE CUTÁNEO"
  },
  {
    "codigo":238559002,
    "descripcion":"ECCEMA CONSTITUCIONAL DE PIE"
  },
  {
    "codigo":369631007,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA DE URACO Y VEJIGA, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":271327008,
    "descripcion":"SÍNDROME HIPOGLUCÉMICO"
  },
  {
    "codigo":402399009,
    "descripcion":"URTICARIA AUTOINMUNITARIA CRÓNICA"
  },
  {
    "codigo":105652001,
    "descripcion":"ENFERMEDAD CAUSADA POR BABESIIDAE"
  },
  {
    "codigo":1156063008,
    "descripcion":"CARBAMAZEPINA SÉRICA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":72884006,
    "descripcion":"CORTOCIRCUITO VASCULAR"
  },
  {
    "codigo":726409002,
    "descripcion":"HEMATOMA DE PÁRPADO"
  },
  {
    "codigo":365961006,
    "descripcion":"PAREJAS SEXUALES - HALLAZGO"
  },
  {
    "codigo":202121006,
    "descripcion":"DESGARRO PARCIAL ANTIGUO DEL LIGAMENTO CRUZADO ANTERIOR"
  },
  {
    "codigo":38281008,
    "descripcion":"EPILEPSIA NEONATAL AUTOLIMITADA"
  },
  {
    "codigo":298590002,
    "descripcion":"PÉRDIDA DE LA LORDOSIS DE LA COLUMNA LUMBAR"
  },
  {
    "codigo":200286003,
    "descripcion":"EMBOLIA PULMONAR GASEOSA DE ORIGEN OBSTÉTRICO"
  },
  {
    "codigo":396894005,
    "descripcion":"ESTADO FUNCIONAL DE TUMOR ENDOCRINO PANCREÁTICO, NO PUEDE SER EVALUADO"
  },
  {
    "codigo":460595001,
    "descripcion":"ARTERIA COLATERAL QUE DERIVA EL FLUJO SISTÉMICO HACIA LA CIRCULACIÓN PULMONAR QUE CONECTA CON ARTERIAS PULMONARES CENTRALES"
  },
  {
    "codigo":41371000119100,
    "descripcion":"COMPLEJO DE SHONE"
  },
  {
    "codigo":369051000119101,
    "descripcion":"DISFUNCIÓN ERÉCTIL CONSECUTIVA A BRAQUITERAPIA DE PRÓSTATA"
  },
  {
    "codigo":335771000119102,
    "descripcion":"HIPEREMIA CONJUNTIVAL DE OJO DERECHO"
  },
  {
    "codigo":1075611000119102,
    "descripcion":"DERRAME DE BOLSA SEROSA DE OLÉCRANON DE CODO DERECHO"
  },
  {
    "codigo":120731000119103,
    "descripcion":"HIPOGLUCEMIA DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":427827009,
    "descripcion":"ASPIRACIÓN A BRONQUIO FUENTE"
  },
  {
    "codigo":90011000119105,
    "descripcion":"TRASTORNO DEL MOVIMIENTO RELACIONADO CON EL SUEÑO DE CAUSA ORGÁNICA"
  },
  {
    "codigo":322971000119105,
    "descripcion":"DEDO MAYOR DERECHO EN GATILLO ADQUIRIDO"
  },
  {
    "codigo":1085851000119105,
    "descripcion":"ABSCESO DE INTESTINO CONCOMITANTE CON ENFERMEDAD DE CROHN DE INTESTINO DELGADO Y DEBIDO A ELLA"
  },
  {
    "codigo":15771000119109,
    "descripcion":"HIPERALFALIPOPROTEINEMIA FAMILIAR"
  },
  {
    "codigo":12267931000119106,
    "descripcion":"TROMBOSIS ASOCIADA CON CATÉTER VASCULAR"
  },
  {
    "codigo":13211000119109,
    "descripcion":"LESIÓN DE VÉRTEBRA"
  },
  {
    "codigo":16438171000119103,
    "descripcion":"SÍNDROME DE DOLOR LOCALIZADO EN TROCÁNTER MAYOR DERECHO"
  },
  {
    "codigo":292251000119105,
    "descripcion":"NEUROMA DE MORTON EN PIE IZQUIERDO"
  },
  {
    "codigo":338331000119107,
    "descripcion":"IRITIS RECURRENTE DE OJO IZQUIERDO"
  },
  {
    "codigo":330651000119107,
    "descripcion":"COMPRESIÓN DE NERVIO PERONEO PROFUNDO IZQUIERDO"
  },
  {
    "codigo":194781004,
    "descripcion":"CARDIOPATÍA Y NEFROPATÍA HIPERTENSIVAS CON INSUFICIENCIA CARDÍACA (CONGESTIVA) E INSUFICIENCIA RENAL"
  },
  {
    "codigo":65544004,
    "descripcion":"QUEMADURA DEL ESTÓMAGO"
  },
  {
    "codigo":131080009,
    "descripcion":"NIVEL DE HIDROCORTISONA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":719069008,
    "descripcion":"SÍNDROME DE CRANEOSINOSTOSIS DE SHPRINTZEN GOLDBERG"
  },
  {
    "codigo":293085008,
    "descripcion":"REACCIÓN ADVERSA AL MONOSULFIRAM"
  },
  {
    "codigo":717234006,
    "descripcion":"ALERGIA A PROTEÍNA ANIMAL"
  },
  {
    "codigo":94642006,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LOS GANGLIOS LINFÁTICOS TRAQUEOBRONQUIALES"
  },
  {
    "codigo":289415000,
    "descripcion":"FONTANELA ANTERIOR PALPABLE EN LA REGIÓN LATERAL IZQUIERDA"
  },
  {
    "codigo":291250007,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR ÁCIDO LISÉRGICO"
  },
  {
    "codigo":336341000119104,
    "descripcion":"ASTIGMATISMO DE OJO DERECHO"
  },
  {
    "codigo":92807009,
    "descripcion":"ASMA INDUCIDA POR AGENTES QUÍMICOS"
  },
  {
    "codigo":254812004,
    "descripcion":"NEVO DE CÉLULAS FUSIFORMES DE REED"
  },
  {
    "codigo":1303388006,
    "descripcion":"FRACTURA ÓSEA DE HOMBRO DERECHO"
  },
  {
    "codigo":90972008,
    "descripcion":"INHIBICIÓN DE LA MOTILIDAD GÁSTRICA"
  },
  {
    "codigo":285745005,
    "descripcion":"ALUCINACIONES FORMADAS: ANIMALES"
  },
  {
    "codigo":1332486000,
    "descripcion":"MELANOMA MALIGNO AMELANÓTICO METASTÁSICO EN PIEL"
  },
  {
    "codigo":251142002,
    "descripcion":"REGISTRO ELECTROCARDIOGRÁFICO RUIDOSO"
  },
  {
    "codigo":21766002,
    "descripcion":"INFESTACIÓN CAUSADA POR PHORMIA"
  },
  {
    "codigo":185606006,
    "descripcion":"EXTENDIDO CERVICAL - RECONVOCATORIA ANULADA"
  },
  {
    "codigo":216539000,
    "descripcion":"INTOXICACIÓN ACCIDENTAL CAUSADA POR HIDROXIZINA"
  },
  {
    "codigo":282075001,
    "descripcion":"QUEMADURA DE ANO"
  },
  {
    "codigo":118235002,
    "descripcion":"HALLAZGO OCULAR \/ VISUAL"
  },
  {
    "codigo":249307003,
    "descripcion":"SÍNTOMA NASAL"
  },
  {
    "codigo":445915003,
    "descripcion":"PULSO TIBIAL POSTERIOR TRIFÁSICO"
  },
  {
    "codigo":10877551000119104,
    "descripcion":"HERIDA ABIERTA DE PIERNA IZQUIERDA DEBIDA A MORDEDURA"
  },
  {
    "codigo":314843006,
    "descripcion":"REGISTRO DE TRATAMIENTO INMEDIATAMENTE NECESARIO: VENCIDO"
  },
  {
    "codigo":85467007,
    "descripcion":"ABORTO ESPONTÁNEO CON PERFORACIÓN DE VEJIGA URINARIA"
  },
  {
    "codigo":183771008,
    "descripcion":"INSCRIPTO EN LISTA DE ADMISIÓN CARDIOLÓGICA"
  },
  {
    "codigo":708059004,
    "descripcion":"ATRESIA DE URETRA PENIANA"
  },
  {
    "codigo":247472004,
    "descripcion":"RONCHA"
  },
  {
    "codigo":737157002,
    "descripcion":"FALSO ANEURISMA DE AORTA DEBIDO A PROCEDIMIENTO Y POSTERIOR A ÉL"
  },
  {
    "codigo":311173003,
    "descripcion":"TRASTORNO RELACIONADO CON FENCICLIDINA"
  },
  {
    "codigo":442245003,
    "descripcion":"TRASTORNO CRÓNICO DE LA PERSONALIDAD HIPOMANÍACA"
  },
  {
    "codigo":11997961000119101,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DE MUÑECA DERECHA"
  },
  {
    "codigo":16261006,
    "descripcion":"COLAPSO DE CONDUCTO AUDITIVO EXTERNO"
  },
  {
    "codigo":1163141007,
    "descripcion":"GRANULOMA CEREBELOSO"
  },
  {
    "codigo":407642001,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: ITALIANO"
  },
  {
    "codigo":473178003,
    "descripcion":"RUPTURA DE DISPOSITIVO DE FIJACIÓN INTERNA"
  },
  {
    "codigo":1259610003,
    "descripcion":"CARCINOMA PRIMARIO DE GLÁNDULA DE BARTOLINO"
  },
  {
    "codigo":79962008,
    "descripcion":"ESPASMO DIFUSO DEL ESÓFAGO"
  },
  {
    "codigo":373039001,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM KOMOSSENCE"
  },
  {
    "codigo":241967006,
    "descripcion":"EFECTOS GENERALES DE LAS BAJAS TEMPERATURAS"
  },
  {
    "codigo":274735009,
    "descripcion":"ESPERMATOZOIDES ANORMALES"
  },
  {
    "codigo":240132004,
    "descripcion":"RABDOMIÓLISIS NO TRAUMÁTICA"
  },
  {
    "codigo":305668005,
    "descripcion":"ATENDIDO POR UN FARMACÓLOGO CLÍNICO"
  },
  {
    "codigo":860889002,
    "descripcion":"GASTRITIS CAUSADA POR CRYPTOSPORIDIUM"
  },
  {
    "codigo":402137003,
    "descripcion":"ONICOMICOSIS POR INFECCIÓN OPORTUNISTA"
  },
  {
    "codigo":762585008,
    "descripcion":"ESTAFILOSQUISIS CON LABIO LEPORINO DERECHO Y FISURA ALVEOLAR DERECHA"
  },
  {
    "codigo":170926001,
    "descripcion":"EFECTO COLATERAL MEDICAMENTOSO ASOCIADO CON PRESCRIPCIÓN REPETIDA"
  },
  {
    "codigo":367534004,
    "descripcion":"DIENTE SUPERNUMERARIO"
  },
  {
    "codigo":1186734006,
    "descripcion":"PARAPLEJÍA ESPÁSTICA COMPLEJA AUTOSÓMICA RECESIVA DEBIDA A DISFUNCIÓN DE LA VÍA DE KENNEDY"
  },
  {
    "codigo":267395000,
    "descripcion":"TRASTORNO ADRENOGENITAL"
  },
  {
    "codigo":1217667002,
    "descripcion":"HEMORRAGIA VÍTREA DEBIDA A OCLUSIÓN DE VENA CENTRAL DE RETINA"
  },
  {
    "codigo":300163002,
    "descripcion":"OÍDO MEDIO NO OBSERVADO"
  },
  {
    "codigo":201859002,
    "descripcion":"ARTROSIS POSTRAUMÁTICA DE LA PRIMERA ARTICULACIÓN CARPOMETACARPIANA, BILATERAL"
  },
  {
    "codigo":11807651000119104,
    "descripcion":"RUPTURA TRAUMÁTICA DE LIGAMENTO ESCAFOSEMILUNAR DE MUÑECA DERECHA"
  },
  {
    "codigo":5251007,
    "descripcion":"HEMORRAGIA SUBARACNOIDEA TRAUMÁTICA CON HERIDA INTRACRANEAL ABIERTA"
  },
  {
    "codigo":338851000119105,
    "descripcion":"DEGENERACIÓN DE CÓRNEA PERIFÉRICA DE OJO IZQUIERDO"
  },
  {
    "codigo":234627009,
    "descripcion":"DEFICIENCIA DE INACTIVADOR DE ANAFILOTOXINA"
  },
  {
    "codigo":1076131000119105,
    "descripcion":"DISFUNCIÓN DE TENDÓN TIBIAL POSTERIOR DE PIE DERECHO"
  },
  {
    "codigo":36184004,
    "descripcion":"ANEURISMA DE ARTERIA RENAL"
  },
  {
    "codigo":167256004,
    "descripcion":"PRUEBA DE EMBARAZO EN ORINA, POSITIVA"
  },
  {
    "codigo":462168007,
    "descripcion":"MEDIASTINO FETAL DESPLAZADO HACIA LA IZQUIERDA"
  },
  {
    "codigo":722477003,
    "descripcion":"SÍNDROME DE TORIELLO-CAREY"
  },
  {
    "codigo":198189004,
    "descripcion":"PIOMETRITIS CRÓNICA"
  },
  {
    "codigo":788013003,
    "descripcion":"INFLAMACIÓN CRÓNICA DE PERITONEO PÉLVICO"
  },
  {
    "codigo":427565006,
    "descripcion":"VARIABILIDAD DE FRECUENCIA CARDÍACA FETAL AUSENTE"
  },
  {
    "codigo":1345069005,
    "descripcion":"DEPÓSITO FIBRINOIDE PERIVELLOSO MASIVO"
  },
  {
    "codigo":165421004,
    "descripcion":"RECUENTO DE GLÓBULOS ROJOS DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":296493005,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE BACLOFENO"
  },
  {
    "codigo":34349009,
    "descripcion":"HIPERLIPOPROTEINEMIA FAMILIAR TIPO 5"
  },
  {
    "codigo":1179394003,
    "descripcion":"HIPOTIROIDISMO CONGÉNITO DEBIDO A MUTACIÓN DE PEROXIDASA TIROIDEA"
  },
  {
    "codigo":1279533009,
    "descripcion":"TROMBOEMBOLISMO DE VENA DEBIDO A INMOVILIZACIÓN PROLONGADA"
  },
  {
    "codigo":15959101000119103,
    "descripcion":"CARCINOMA DE CÉLULAS DE TRANSICIÓN DE RIÑÓN DERECHO"
  },
  {
    "codigo":163586006,
    "descripcion":"EXAMEN EN EL SISTEMA NERVIOSO - NO SE DETECTARON ANOMALÍAS"
  },
  {
    "codigo":294658007,
    "descripcion":"ALERGIA A COMPONENTE DE VACUNA QUE CONTIENE ANTÍGENO DE CLOSTRIDIUM TETANI"
  },
  {
    "codigo":784343003,
    "descripcion":"ATAXIA ESPÁSTICA AUTOSÓMICA RECESIVA CON LEUCOENCEFALOPATÍA"
  },
  {
    "codigo":292823007,
    "descripcion":"REACCIÓN ADVERSA A ANTIFÚNGICOS TRIAZÓLICOS"
  },
  {
    "codigo":61612001,
    "descripcion":"INCOMPETENCIA AÓRTICA SIFILÍTICA"
  },
  {
    "codigo":94380001,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LABIO"
  },
  {
    "codigo":225452001,
    "descripcion":"DELIRIO PARANOIDE"
  },
  {
    "codigo":11836631000119100,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN TARSOMETATARSIANA DE PIE IZQUIERDO"
  },
  {
    "codigo":127148007,
    "descripcion":"LINFADENOPATÍA ILEOCÓLICA"
  },
  {
    "codigo":92545000,
    "descripcion":"CARCINOMA IN SITU DE LAS VÍAS BILIARES"
  },
  {
    "codigo":289153004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CANTIDAD DE BEBIDA"
  },
  {
    "codigo":715137008,
    "descripcion":"INCAPAZ DE PASAR DE UNA SILLA DE RUEDAS A UN AUTOMÓVIL"
  },
  {
    "codigo":59777009,
    "descripcion":"TORACÓPAGO"
  },
  {
    "codigo":711467003,
    "descripcion":"RELACIÓN ENTRE CORONA Y RAÍZ DENTAL COMPROMETIDA"
  },
  {
    "codigo":285483005,
    "descripcion":"DIFICULTAD PARA REDONDEAR LOS LABIOS"
  },
  {
    "codigo":283648001,
    "descripcion":"AGUJA DE COSER EN DEDO DE LA MANO"
  },
  {
    "codigo":54272002,
    "descripcion":"OTITIS EXTERNA AGUDA ECCEMATOIDE"
  },
  {
    "codigo":1268523009,
    "descripcion":"DILATACIÓN ADQUIRIDA DE VENTRÍCULO CARDÍACO DERECHO"
  },
  {
    "codigo":87040007,
    "descripcion":"LUXACIÓN DE LOS HUESECILLOS DEL OÍDO"
  },
  {
    "codigo":871637001,
    "descripcion":"TROMBOSIS DE MÚLTIPLES VENAS CEREBRALES"
  },
  {
    "codigo":773333003,
    "descripcion":"LUPUS ERITEMATOSO SISTÉMICO AUTOSÓMICO"
  },
  {
    "codigo":609493004,
    "descripcion":"INTERRUPCIÓN INDUCIDA DEL EMBARAZO COMPLICADA POR TÉTANOS"
  },
  {
    "codigo":707797006,
    "descripcion":"TODOS LOS PULSOS PRESENTES POR DEBAJO DE LA RODILLA EN AMBOS MIEMBROS"
  },
  {
    "codigo":16014551000119108,
    "descripcion":"TROMBOFLEBITIS DE VENA SUPERFICIAL DE MIEMBRO INFERIOR IZQUIERDO"
  },
  {
    "codigo":16669911000119108,
    "descripcion":"FRACTURA NO EXPUESTA SUBCONDÍLEA DE LADO IZQUIERDO DE LA MANDÍBULA"
  },
  {
    "codigo":249045009,
    "descripcion":"RUIDOS CARDÍACOS FETALES PRESENTES"
  },
  {
    "codigo":1363157009,
    "descripcion":"ASTILLA EN PARED TORÁCICA CON INFECCIÓN"
  },
  {
    "codigo":247210001,
    "descripcion":"VASOS CILIORRETINIANOS"
  },
  {
    "codigo":16561521000119103,
    "descripcion":"FRACTURA NO EXPUESTA DE HUESO CIGOMÁTICO IZQUIERDO"
  },
  {
    "codigo":1197482007,
    "descripcion":"SUSCEPTIBILIDAD A PERIODONTITIS JUVENIL LOCALIZADA"
  },
  {
    "codigo":83370008,
    "descripcion":"SIGNOS ELECTROCARDIOGRÁFICOS DE HIPERTROFIA VENTRICULAR"
  },
  {
    "codigo":81535001,
    "descripcion":"SENSIBILIDAD AUTOPLAQUETARIA"
  },
  {
    "codigo":212607000,
    "descripcion":"INTOXICACIÓN POR PIRABITAL"
  },
  {
    "codigo":15999000,
    "descripcion":"CIRROSIS MIXTA MICRO Y MACRONODULAR"
  },
  {
    "codigo":1162879007,
    "descripcion":"ARTRITIS TUBERCULOSA DE REGIÓN DE HOMBRO CAUSADA POR MYCOBACTERIUM TUBERCULOSIS"
  },
  {
    "codigo":472916000,
    "descripcion":"ENCEFALOPATÍA METABÓLICA TÓXICA"
  },
  {
    "codigo":1259348001,
    "descripcion":"CARCINOMA PRIMARIO DE TERCIO MEDIO DE ESÓFAGO"
  },
  {
    "codigo":866132005,
    "descripcion":"MIELITIS CAUSADA POR HERPES SIMPLE TIPO 1"
  },
  {
    "codigo":210772007,
    "descripcion":"HERIDAS ABIERTAS MÚLTIPLES DE CADERA Y MUSLO"
  },
  {
    "codigo":208937006,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE LA ARTICULACIÓN DE LA RODILLA, ANTERIOR"
  },
  {
    "codigo":405545007,
    "descripcion":"ESTENOSIS DE ARTERIA MESENTÉRICA"
  },
  {
    "codigo":403710000,
    "descripcion":"EFECTO ADVERSO POR FOTOQUIMIOTERAPIA CON PUVA"
  },
  {
    "codigo":43262000,
    "descripcion":"HEMORRAGIA SUBDURAL TRAUMÁTICA CON HERIDA INTRACRANEAL ABIERTA Y CONCUSIÓN"
  },
  {
    "codigo":733225008,
    "descripcion":"LACERACIÓN DE VENA AXILAR"
  },
  {
    "codigo":341361000119108,
    "descripcion":"ANOMALÍA VASCULAR DE CONJUNTIVA IZQUIERDA"
  },
  {
    "codigo":698622004,
    "descripcion":"ALTERACIÓN VISUAL RELACIONADA CON FÁRMACO"
  },
  {
    "codigo":239870005,
    "descripcion":"ARTROSIS DE ARTICULACIÓN INTERFALÁNGICA PROXIMAL"
  },
  {
    "codigo":12329007,
    "descripcion":"INFECCIÓN CAUSADA POR BILHARZIELLA"
  },
  {
    "codigo":8659000,
    "descripcion":"PRODUCCIÓN ECTÓPICA DE SUSTANCIA ENDOCRINA"
  },
  {
    "codigo":76030009,
    "descripcion":"ORGASMO PREPUBERAL"
  },
  {
    "codigo":762323002,
    "descripcion":"INTOXICACIÓN POR ESTIMULANTE"
  },
  {
    "codigo":41427001,
    "descripcion":"TRASTORNO DE LOS BRONQUIOS"
  },
  {
    "codigo":238035000,
    "descripcion":"DEFICIENCIA DE DELTA-4-3-OXOESTEROIDE-5-BETA-REDUCTASA"
  },
  {
    "codigo":205267009,
    "descripcion":"MANO HENDIDA CON POLIDACTILIA"
  },
  {
    "codigo":400040008,
    "descripcion":"LINFEDEMA HEREDITARIO TIPO II"
  },
  {
    "codigo":103293001,
    "descripcion":"VÉRTIGO INDUCIDO VISUALMENTE"
  },
  {
    "codigo":4989003,
    "descripcion":"QUEMADURA ELÉCTRICA DE LA PIEL"
  },
  {
    "codigo":299901006,
    "descripcion":"SENTIDO DEL GUSTO NORMAL"
  },
  {
    "codigo":1184637006,
    "descripcion":"VELOCIDAD DE FLUJO RESPIRATORIO POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":365437008,
    "descripcion":"HALLAZGO RELACIONADO CON LA CONSISTENCIA DE LA MATERIA FECAL"
  },
  {
    "codigo":68690000,
    "descripcion":"INFECCIÓN CAUSADA POR OOMYCETES"
  },
  {
    "codigo":234365008,
    "descripcion":"MACROCITOSIS QUE RESPONDE A LA TIAMINA"
  },
  {
    "codigo":168829009,
    "descripcion":"COMIDA DE BARIO ANORMAL"
  },
  {
    "codigo":199762005,
    "descripcion":"TRABAJO DE PARTO OBSTRUIDO POR PELVIS CONTRAÍDA"
  },
  {
    "codigo":298066008,
    "descripcion":"CUERPO EXTRAÑO EN LA PIEL DE LA BOCA"
  },
  {
    "codigo":197927001,
    "descripcion":"INFECCIÓN RECURRENTE DE LA VÍA URINARIA"
  },
  {
    "codigo":230695002,
    "descripcion":"INFARTO PARCIAL DE LA CEREBRAL ANTERIOR"
  },
  {
    "codigo":296231008,
    "descripcion":"SOBREDOSIS INTENCIONAL DE PIPOTIAZINA"
  },
  {
    "codigo":294396001,
    "descripcion":"ALERGIA A PROGUANIL"
  },
  {
    "codigo":292561001,
    "descripcion":"REACCIÓN ADVERSA A BERACTANTE"
  },
  {
    "codigo":423633003,
    "descripcion":"CISTOCELE DE LA LÍNEA MEDIA"
  },
  {
    "codigo":1081151000119102,
    "descripcion":"NEOPLASIA GERMINAL NO SEMINOMATOSA PRIMARIA DE TESTÍCULO IZQUIERDO DESCENDIDO"
  },
  {
    "codigo":716710007,
    "descripcion":"DISCAPACIDAD DEL DESARROLLO DE LA PRIMERA INFANCIA"
  },
  {
    "codigo":92283000,
    "descripcion":"NEOPLASIA BENIGNA DE HUESO ILÍACO"
  },
  {
    "codigo":126886007,
    "descripcion":"NEOPLASIA DEL TRÍGONO VESICAL"
  },
  {
    "codigo":94118008,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LAS VÍAS RESPIRATORIAS SUPERIORES"
  },
  {
    "codigo":714875000,
    "descripcion":"DIFICULTAD PARA MANTENER LA POSICIÓN RECOSTADA"
  },
  {
    "codigo":59515005,
    "descripcion":"ÚLCERA GASTROYEYUNAL AGUDA CON HEMORRAGIA PERO SIN OBSTRUCCIÓN"
  },
  {
    "codigo":288891006,
    "descripcion":"COME CIERTOS ALIMENTOS"
  },
  {
    "codigo":287056000,
    "descripcion":"OSTEOMIELITIS CRÓNICA DE RODILLA"
  },
  {
    "codigo":343871000119105,
    "descripcion":"HEMORRAGIA DE AMBAS RETINAS"
  },
  {
    "codigo":385360005,
    "descripcion":"SISTEMA DE ESTADIFICACIÓN DE DUKES MODIFICADO - HALLAZGO"
  },
  {
    "codigo":11786201000119100,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE MANO IZQUIERDA CON INFECCIÓN"
  },
  {
    "codigo":90448008,
    "descripcion":"OSIFICACIÓN DEL LIGAMENTO LONGITUDINAL POSTERIOR"
  },
  {
    "codigo":876880009,
    "descripcion":"FALLECIDO EN RESIDENCIA GERIÁTRICA"
  },
  {
    "codigo":285221007,
    "descripcion":"INCAPAZ DE RECORDAR NUEVAS HABILIDADES MOTRICES"
  },
  {
    "codigo":447226003,
    "descripcion":"QUISTE EPIDERMOIDE DE PIEL DE TÓRAX"
  },
  {
    "codigo":840442003,
    "descripcion":"ENCEFALITIS CAUSADA POR VIRUS DE LA INMUNODEFICIENCIA HUMANA TIPO 2"
  },
  {
    "codigo":283386004,
    "descripcion":"LACERACIÓN DE LA RODILLA"
  },
  {
    "codigo":707535004,
    "descripcion":"CARCINOMA PRIMARIO DE CÉLULAS ESCAMOSAS DE PARED LATERAL DE OROFARINGE"
  },
  {
    "codigo":248783006,
    "descripcion":"PENETRACIÓN SIN EYACULACIÓN"
  },
  {
    "codigo":281551007,
    "descripcion":"SECCIÓN TRAUMÁTICA DE TENDÓN DE CABEZA Y CUELLO"
  },
  {
    "codigo":771236000,
    "descripcion":"CALCIFILAXIA VISCERAL"
  },
  {
    "codigo":10967001000119105,
    "descripcion":"HERIDA PUNZANTE DE RODILLA DERECHA"
  },
  {
    "codigo":12113881000119105,
    "descripcion":"QUEMADURA QUÍMICA DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":1229988003,
    "descripcion":"NEOPLASIA MIELOIDE Y\/O LINFOIDE CON MATERIAL PERICENTRIOLAR 1-QUINASA DE JANUS 2"
  },
  {
    "codigo":1295524007,
    "descripcion":"SÍNDROME MEDULAR ANTERIOR DEBIDO A PROLAPSO DE DISCO INTERVERTEBRAL"
  },
  {
    "codigo":246948008,
    "descripcion":"ULCERACIÓN CORNEAL PERIFÉRICA"
  },
  {
    "codigo":703865001,
    "descripcion":"TRASTORNO DE LA PIEL DE GENITALES MASCULINOS"
  },
  {
    "codigo":48505000,
    "descripcion":"XANTOPSIA"
  },
  {
    "codigo":212345007,
    "descripcion":"LESIÓN NO EXPUESTA DEL NERVIO PUDENDO"
  },
  {
    "codigo":1259086003,
    "descripcion":"INFLAMACIÓN AUTOINMUNITARIA DE CEREBELO"
  },
  {
    "codigo":276046004,
    "descripcion":"CUIDA A SU ESPOSA CRÓNICAMENTE ENFERMA"
  },
  {
    "codigo":46670006,
    "descripcion":"REFLEJO ANORMAL"
  },
  {
    "codigo":732963000,
    "descripcion":"ANEMIA HEMOLÍTICA AUTOINMUNITARIA SECUNDARIA CONCOMITANTE CON TRASTORNO LINFOPROLIFERATIVO Y DEBIDA A ÉL"
  },
  {
    "codigo":12067001,
    "descripcion":"CUELLO FEMORAL VARO ADQUIRIDO"
  },
  {
    "codigo":1290019000,
    "descripcion":"TUMOR NEUROENDOCRINO BIEN DIFERENCIADO PRIMARIO DE PORCIÓN DISTAL DE COLÉDOCO"
  },
  {
    "codigo":110371003,
    "descripcion":"HIERRO DE LA MÉDULA ÓSEA: ANORMAL"
  },
  {
    "codigo":19831000146107,
    "descripcion":"CAPAZ DE LAVARSE DE FORMA INDEPENDIENTE"
  },
  {
    "codigo":700195008,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE SEGUNDO A QUINTO DEDOS DEL PIE"
  },
  {
    "codigo":1255416007,
    "descripcion":"FRACTURA FALÁNGICA DE MÚLTIPLES DEDOS DE MANO"
  },
  {
    "codigo":203170004,
    "descripcion":"OSTEOMIELITIS AGUDA DE FÉMUR"
  },
  {
    "codigo":235938004,
    "descripcion":"ESTENOSIS ANASTOMÓTICA BILIAR"
  },
  {
    "codigo":301474005,
    "descripcion":"INCAPAZ DE SUPERAR OBSTÁCULOS"
  },
  {
    "codigo":299639001,
    "descripcion":"HALLAZGO RELACIONADO CON TEMPERATURA DE ARTICULACIÓN DE DEDO DE PIE"
  },
  {
    "codigo":365175003,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA DISFRUTAR LA VIDA"
  },
  {
    "codigo":37495007,
    "descripcion":"HIPOPLASIA ADRENOCORTICAL FAMILIAR"
  },
  {
    "codigo":428876001,
    "descripcion":"MELANOSIS VULVAR"
  },
  {
    "codigo":166732005,
    "descripcion":"URATO EN SANGRE DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":363340006,
    "descripcion":"VASCULOPATÍA DE EXTREMIDAD"
  },
  {
    "codigo":232268006,
    "descripcion":"MASTOIDITIS AGUDA CON ABSCESO DE CUELLO"
  },
  {
    "codigo":295969002,
    "descripcion":"SOBREDOSIS DE PIRACETAM"
  },
  {
    "codigo":263201004,
    "descripcion":"FRACTURA DE BARTON DEL DORSO DE LA MANO"
  },
  {
    "codigo":30155000,
    "descripcion":"RIGIDEZ DE DESCEREBRACIÓN"
  },
  {
    "codigo":294134009,
    "descripcion":"ALERGIA A DIFENILPIRALINA"
  },
  {
    "codigo":1177035002,
    "descripcion":"ASPERGILOSIS PLEURAL"
  },
  {
    "codigo":193995004,
    "descripcion":"ESTENOSIS ADQUIRIDA DE CONDUCTO NASOLAGRIMAL"
  },
  {
    "codigo":95691008,
    "descripcion":"RETINOPATÍA ARTERIOSCLERÓTICA"
  },
  {
    "codigo":93856000,
    "descripcion":"NEOPLASIA MALIGNA DE CARA LARÍNGEA DE PLIEGUE INTERARITENOIDEO"
  },
  {
    "codigo":716448003,
    "descripcion":"CAPAZ DE SENTARSE EN LA CAMA"
  },
  {
    "codigo":126624005,
    "descripcion":"NEOPLASIA DE MÚSCULO DEL TRONCO"
  },
  {
    "codigo":26485002,
    "descripcion":"HÍGADO DE ASERRÍN"
  },
  {
    "codigo":288629003,
    "descripcion":"INCAPAZ DE JUGAR CON LAS PALABRAS Y LOS SIGNIFICADOS"
  },
  {
    "codigo":59253004,
    "descripcion":"DISENTERÍA CATARRAL"
  },
  {
    "codigo":92021007,
    "descripcion":"NEOPLASIA BENIGNA DEL CUERPO DEL ÚTERO"
  },
  {
    "codigo":254026007,
    "descripcion":"MICROSOMÍA CRANEOFACIAL"
  },
  {
    "codigo":90186008,
    "descripcion":"INTOXICACIÓN POR PANICUM EFFUSUM"
  },
  {
    "codigo":88351001,
    "descripcion":"HIPERCALCEMIA ASOCIADA CON DIÁLISIS CRÓNICA"
  },
  {
    "codigo":284959003,
    "descripcion":"NO MANEJA LA HIGIENE MENSTRUAL"
  },
  {
    "codigo":416031006,
    "descripcion":"ESPÉCIMEN PARA CITOLOGÍA CERVICOVAGINAL NO SATISFACTORIO"
  },
  {
    "codigo":250356000,
    "descripcion":"OBSERVACIONES DE LA TENDENCIA TROMBÓTICA"
  },
  {
    "codigo":219423008,
    "descripcion":"HERIDA DE GUERRA POR EFECTOS DE BOLA DE ARMA NUCLEAR"
  },
  {
    "codigo":1004020002,
    "descripcion":"TRASTORNO FETAL DEBIDO A ENFERMEDAD RESPIRATORIA MATERNA"
  },
  {
    "codigo":53748002,
    "descripcion":"SÍNDROME DE EPIDERMÓLISIS BULLOSA CONGÉNITA DE LA ZONA DE UNIÓN - ATRESIA PILÓRICA"
  },
  {
    "codigo":20980008,
    "descripcion":"ESCOLIOSIS IDIOPÁTICA INFANTIL PROGRESIVA"
  },
  {
    "codigo":707273001,
    "descripcion":"DISQUERATOSIS CONGÉNITA AUTOSÓMICA DOMINANTE"
  },
  {
    "codigo":283124009,
    "descripcion":"AMPOLLA TRAUMÁTICA DE LA MANO"
  },
  {
    "codigo":445129003,
    "descripcion":"UTILIZA TRANSLITERADOR PARA LENGUAJE EN CLAVE"
  },
  {
    "codigo":281289003,
    "descripcion":"ESPÉCIMEN LEVEMENTE HEMOLIZADO"
  },
  {
    "codigo":838345001,
    "descripcion":"ATROFIA ÓPTICA AUTOSÓMICA RECESIVA TIPO 6"
  },
  {
    "codigo":248521008,
    "descripcion":"TUMORACIÓN EN DEDO DE LA MANO"
  },
  {
    "codigo":84681008,
    "descripcion":"CELULITIS RECTAL"
  },
  {
    "codigo":246686002,
    "descripcion":"POSICIÓN OCULAR CON CABEZA INCLINADA"
  },
  {
    "codigo":312222003,
    "descripcion":"INFECCIÓN DE TESTÍCULO Y EPIDÍDIMO"
  },
  {
    "codigo":1162355001,
    "descripcion":"DISCITIS VIRAL"
  },
  {
    "codigo":277619001,
    "descripcion":"LEUCEMIA PROLINFOCÍTICA DE CÉLULAS B"
  },
  {
    "codigo":310387003,
    "descripcion":"GLOMERULOESCLEROSIS INTRACAPILAR DE RIÑÓN DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":212083004,
    "descripcion":"CORROSIÓN QUE COMPROMETE EL 50 - 59 PORCIENTO DE LA SUPERFICIE CORPORAL"
  },
  {
    "codigo":243016000,
    "descripcion":"LESIÓN POR FRAGMENTO DE ARMA EXPLOSIVA"
  },
  {
    "codigo":408691009,
    "descripcion":"RESPIRACIÓN PLEURÍTICA"
  },
  {
    "codigo":111944002,
    "descripcion":"VÍCTIMA DE EMBOSCADA"
  },
  {
    "codigo":13640000,
    "descripcion":"LATIDOS DE FUSIÓN"
  },
  {
    "codigo":11817691000119106,
    "descripcion":"ESGUINCE DE LIGAMENTO DE DEDO ÍNDICE DERECHO"
  },
  {
    "codigo":308552006,
    "descripcion":"SITUACIÓN DEL INFORME"
  },
  {
    "codigo":11805005,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA INGLE"
  },
  {
    "codigo":110109008,
    "descripcion":"LACERACIÓN SIMPLE DEL VESTÍBULO MAXILAR"
  },
  {
    "codigo":1156850001,
    "descripcion":"NEUROPATÍA MOTORA DISTAL HEREDITARIA AUTOSÓMICA RECESIVA"
  },
  {
    "codigo":206578007,
    "descripcion":"LEUCOMALACIA CEREBRAL NEONATAL"
  },
  {
    "codigo":403186009,
    "descripcion":"REACCIÓN A ESPINA EN LA PIEL"
  },
  {
    "codigo":40903003,
    "descripcion":"QUEMADURA DE LA PALMA DE LA MANO"
  },
  {
    "codigo":8135006,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN TEMPOROMANDIBULAR"
  },
  {
    "codigo":73671007,
    "descripcion":"ESPALDA ANGOSTA"
  },
  {
    "codigo":202908000,
    "descripcion":"TENOSINOVITIS DEL PIE"
  },
  {
    "codigo":1251484005,
    "descripcion":"METÁSTASIS DE ADENOCARCINOMA EN GLÁNDULA HIPÓFISIS"
  },
  {
    "codigo":235676007,
    "descripcion":"VACIADO GÁSTRICO RETARDADO LUEGO DE PROCEDIMIENTO"
  },
  {
    "codigo":266609001,
    "descripcion":"INFERTILIDAD FEMENINA DE ORIGEN ANOVULATORIO"
  },
  {
    "codigo":4465002,
    "descripcion":"ESFEROFAQUIA"
  },
  {
    "codigo":397681003,
    "descripcion":"NORMOTERMIA EN EL PERÍODO POSOPERATORIO INMEDIATO"
  },
  {
    "codigo":299377003,
    "descripcion":"ARTICULACIÓN DE LA RODILLA DOLOROSA AL MOVIMIENTO"
  },
  {
    "codigo":233841005,
    "descripcion":"INFARTO ANTIGUO DE MIOCARDIO LATERAL"
  },
  {
    "codigo":364913007,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD DE CAMBIAR DE POSICIÓN"
  },
  {
    "codigo":461382001,
    "descripcion":"TRAYECTO INTRAMURAL ANÓMALO DE PORCIÓN PROXIMAL DE ARTERIA CORONARIA A TRAVÉS DE LA COMISURA DE LA VÁLVULA AÓRTICA"
  },
  {
    "codigo":68166002,
    "descripcion":"QUERATITIS EN EL EXANTEMA"
  },
  {
    "codigo":232006002,
    "descripcion":"AGUJERO MACULAR"
  },
  {
    "codigo":789062005,
    "descripcion":"VAGABUNDEO DEBIDO A DEMENCIA"
  },
  {
    "codigo":721691004,
    "descripcion":"PÓLIPO HIPERPLÁSICO DE INTESTINO GRUESO"
  },
  {
    "codigo":262939007,
    "descripcion":"SECCIÓN DE ARTERIA"
  },
  {
    "codigo":33563008,
    "descripcion":"VULVODINIA ESENCIAL"
  },
  {
    "codigo":424944001,
    "descripcion":"CÉLULAS DE ADENOCARCINOMA MUCINOSO PRESENTES; REPRESENTAN MENOS DE 50% DE LAS CÉLULAS MALIGNAS"
  },
  {
    "codigo":295707007,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE MERCAPTOPURINA"
  },
  {
    "codigo":457712004,
    "descripcion":"CALCIFICACIÓN DE VÁLVULA TRONCAL"
  },
  {
    "codigo":228336004,
    "descripcion":"LA BEBIDA TIENE PRIORIDAD SOBRE LAS OBLIGACIONES FAMILIARES"
  },
  {
    "codigo":719856008,
    "descripcion":"ADECUADO PARA CONTROL DE SALUD A DISTANCIA"
  },
  {
    "codigo":128197001,
    "descripcion":"RADICULOPATÍA SACRA"
  },
  {
    "codigo":351401000119101,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE GLÁNDULA SUPRARRENAL IZQUIERDA"
  },
  {
    "codigo":60826002,
    "descripcion":"COCCIDIOIDOMICOSIS"
  },
  {
    "codigo":290202004,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR FENTANILO"
  },
  {
    "codigo":93594005,
    "descripcion":"OSIFICACIÓN INCOMPLETA DE HUESO NASAL"
  },
  {
    "codigo":288367005,
    "descripcion":"DIFICULTAD PARA LEVANTAR OBJETOS"
  },
  {
    "codigo":124527007,
    "descripcion":"DEFICIENCIA DE METENILOTETRAHIDROFOLATO CICLOHIDROLASA"
  },
  {
    "codigo":24388001,
    "descripcion":"PUNTAJE DE APGAR 5"
  },
  {
    "codigo":1204036002,
    "descripcion":"TRASTORNO POSTERIOR A INTERRUPCIÓN INDUCIDA DE EMBARAZO"
  },
  {
    "codigo":286532002,
    "descripcion":"CAPAZ DE PREPARAR LOS ALIMENTOS HIGIÉNICAMENTE"
  },
  {
    "codigo":417604002,
    "descripcion":"SÍNDROME DE AXENFELD-RIEGER"
  },
  {
    "codigo":679081000119106,
    "descripcion":"XEROSIS DE AMBAS CÓRNEAS"
  },
  {
    "codigo":1234969000,
    "descripcion":"TRASTORNO FETAL DEBIDO A CORDÓN UMBILICAL CORTO"
  },
  {
    "codigo":1236804009,
    "descripcion":"SÍNDROME DE ATAXIA CEREBELOSA CON NEUROPATÍA Y ARREFLEXIA VESTIBULAR BILATERAL"
  },
  {
    "codigo":448537000,
    "descripcion":"DERIVADA A OBSTÉTRICA"
  },
  {
    "codigo":284697001,
    "descripcion":"AUTOCANIBALISMO"
  },
  {
    "codigo":253764008,
    "descripcion":"AUSENCIA CONGÉNITA, ATRESIA Y ESTENOSIS DE INTESTINO DELGADO"
  },
  {
    "codigo":282862000,
    "descripcion":"NO SE MANTIENE SENTADO"
  },
  {
    "codigo":1003758002,
    "descripcion":"ANAFILAXIS CAUSADA POR PROTEÍNA DEL LÁTEX DE HEVEA BRASILIENSIS"
  },
  {
    "codigo":1296835001,
    "descripcion":"HIPERTENSIÓN OCULAR POR CÉLULAS FANTASMAS DE AMBOS OJOS"
  },
  {
    "codigo":446702009,
    "descripcion":"PARTÍCULAS PEQUEÑAS DE CÁLCULO EN VEJIGA URINARIA"
  },
  {
    "codigo":248259004,
    "descripcion":"SÍNTOMAS QUE INTERFIEREN CON EL SUEÑO"
  },
  {
    "codigo":84419005,
    "descripcion":"EFECTO TÓXICO DE GAS LACRIMÓGENO"
  },
  {
    "codigo":1264067005,
    "descripcion":"CARCINOMA DE CÉLULAS ACINARES DE PÁNCREAS METASTÁSICO"
  },
  {
    "codigo":444867009,
    "descripcion":"FRACTURA EXPUESTA DE CALOTA CRANEANA"
  },
  {
    "codigo":17048005,
    "descripcion":"CONTUSIÓN DE UÑA DE DEDO DEL PIE"
  },
  {
    "codigo":1260397000,
    "descripcion":"DISTONÍA DEBIDA A PARAPLEJÍA ESPÁSTICA HEREDITARIA"
  },
  {
    "codigo":770712008,
    "descripcion":"ALERGIA A FACTOR DE COAGULACIÓN VIIA"
  },
  {
    "codigo":1293165003,
    "descripcion":"DOLOR NO AGRAVADO POR DEAMBULACIÓN"
  },
  {
    "codigo":277357006,
    "descripcion":"RETENCIÓN DE ESPUTO"
  },
  {
    "codigo":406594003,
    "descripcion":"INFECCIÓN DEL SISTEMA NERVIOSO CENTRAL POR MICOBACTERIAS"
  },
  {
    "codigo":16846301000119103,
    "descripcion":"CARCINOMA DE CÉLULAS DE MERKEL PRIMARIO DE PIEL DE CEJA"
  },
  {
    "codigo":439362007,
    "descripcion":"ATENDIDO EN CONSULTORIO ESPECIALIZADO PEDIÁTRICO COMUNITARIO"
  },
  {
    "codigo":78914008,
    "descripcion":"LACERACIÓN ENCEFÁLICA"
  },
  {
    "codigo":11543004,
    "descripcion":"OTOESCLEROSIS"
  },
  {
    "codigo":371991005,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL PALADAR DURO"
  },
  {
    "codigo":109847004,
    "descripcion":"NEOPLASIA MALIGNA SUPERPUESTA DE LAS VÍAS BILIARES"
  },
  {
    "codigo":765207007,
    "descripcion":"TRASTORNO EN REMISIÓN PARCIAL"
  },
  {
    "codigo":208151007,
    "descripcion":"FRACTURA NO EXPUESTA DE ACETÁBULO, TRANSVERSAL DE AMBAS COLUMNAS"
  },
  {
    "codigo":239084001,
    "descripcion":"SÍNDROME DE NAEGELI-FRANCESCHETTI-JADASSOHN"
  },
  {
    "codigo":402924002,
    "descripcion":"ERISIPELA RECURRENTE"
  },
  {
    "codigo":75244001,
    "descripcion":"INTOXICACIÓN POR DICHAPETALUM"
  },
  {
    "codigo":1254892005,
    "descripcion":"LIPEDEMA DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":237249000,
    "descripcion":"MOLA HIDATÍDICA COMPLETA"
  },
  {
    "codigo":1287660009,
    "descripcion":"TUMOR NEUROENDOCRINO BIEN DIFERENCIADO PRIMARIO DE CONDUCTO ANAL"
  },
  {
    "codigo":1187521002,
    "descripcion":"GLUCAGONOMA PANCREÁTICO MALIGNO"
  },
  {
    "codigo":302785009,
    "descripcion":"ANTICUERPO HETERÓFILO DETECTADO POR PRUEBA DE MONOSPOT"
  },
  {
    "codigo":366486004,
    "descripcion":"HALLAZGO RELACIONADO CON LA AMPLITUD DEL MOVIMIENTO ACTIVO DE ROTACIÓN INTERNA DE HOMBRO"
  },
  {
    "codigo":169878007,
    "descripcion":"PERÍMETRO CEFÁLICO AL NACER: ENTRE PERCENTILOS 3 Y 9"
  },
  {
    "codigo":300950007,
    "descripcion":"MANO INFECTADA"
  },
  {
    "codigo":300168006,
    "descripcion":"MARTILLO: PRESENTE"
  },
  {
    "codigo":320906871000119104,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR CANNABINOIDE SINTÉTICO"
  },
  {
    "codigo":30111000175100,
    "descripcion":"ÚLCERA POR PRESIÓN EN TOBILLO DERECHO, ESTADIO III"
  },
  {
    "codigo":102507004,
    "descripcion":"VARÓN SANO"
  },
  {
    "codigo":299115007,
    "descripcion":"CREPITACIÓN AUDIBLE DE ARTICULACIÓN DE DEDO DE MANO"
  },
  {
    "codigo":67904000,
    "descripcion":"PELVIS ENANA"
  },
  {
    "codigo":36971009,
    "descripcion":"SINUSITIS"
  },
  {
    "codigo":725099009,
    "descripcion":"DISPLASIA CRANEOMETADIAFISARIA TIPO HUESO WORMIANO"
  },
  {
    "codigo":35136003,
    "descripcion":"RETROPULSIÓN"
  },
  {
    "codigo":353911000119105,
    "descripcion":"NEOPLASIA BENIGNA DE PELVIS RENAL DERECHA"
  },
  {
    "codigo":1091191000119106,
    "descripcion":"OTITIS MEDIA CRÓNICA TUBOTIMPÁNICA SUPURATIVA DE OÍDO MEDIO DERECHO"
  },
  {
    "codigo":11986551000119105,
    "descripcion":"QUEMADURA EPIDÉRMICA DE RODILLA IZQUIERDA"
  },
  {
    "codigo":1149248007,
    "descripcion":"MUCOSA ORAL INTACTA"
  },
  {
    "codigo":721429000,
    "descripcion":"LESIÓN COMPLETA DE MÉDULA ESPINAL DORSAL"
  },
  {
    "codigo":262677003,
    "descripcion":"LARINGITIS HEMORRÁGICA TRAUMÁTICA"
  },
  {
    "codigo":197141006,
    "descripcion":"MEGACOLON SECUNDARIO ADQUIRIDO"
  },
  {
    "codigo":295445007,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE LACTULOSA"
  },
  {
    "codigo":681591000119108,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE PARED ANTERIOR DE VEJIGA URINARIA"
  },
  {
    "codigo":195306002,
    "descripcion":"GANGRENA DE LA MANO"
  },
  {
    "codigo":129770007,
    "descripcion":"CALCIFICACIÓN INDIVIDUAL"
  },
  {
    "codigo":226239000,
    "descripcion":"DIETA RASTAFARI"
  },
  {
    "codigo":293610009,
    "descripcion":"ALERGIA A FÁRMACO ANTIINFLAMATORIO NO ESTEROIDE"
  },
  {
    "codigo":162538009,
    "descripcion":"VEGETARIANO OVOLÁCTEO"
  },
  {
    "codigo":95167003,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL ÚTERO"
  },
  {
    "codigo":160703004,
    "descripcion":"VAGABUNDO"
  },
  {
    "codigo":717759001,
    "descripcion":"AUSENCIA CONGÉNITA DE VEJIGA URINARIA Y URETRA"
  },
  {
    "codigo":816063009,
    "descripcion":"PULSO EN ARTERIA PEDIA IZQUIERDA NORMAL"
  },
  {
    "codigo":27796003,
    "descripcion":"HIPOVITAMINOSIS A CON XEROSIS CONJUNTIVAL"
  },
  {
    "codigo":93332007,
    "descripcion":"POSICIÓN ANÓMALA CONGÉNITA DEL HÍGADO"
  },
  {
    "codigo":60564007,
    "descripcion":"SURCO DE HARRISON"
  },
  {
    "codigo":1172841001,
    "descripcion":"DEFICIENCIA COMBINADA DE LA FOSFORILACIÓN OXIDATIVA TIPO 30"
  },
  {
    "codigo":715924009,
    "descripcion":"TRASTORNO DE DESREGULACIÓN DISRUPTIVA DEL ESTADO DE ÁNIMO"
  },
  {
    "codigo":58729003,
    "descripcion":"TRASTORNO DE LOS VASOS CAPILARES"
  },
  {
    "codigo":1303913003,
    "descripcion":"MIELOCISTOCELE TERMINAL"
  },
  {
    "codigo":124265004,
    "descripcion":"DEFICIENCIA DE ACETIL-COA ACILTRANSFERASA"
  },
  {
    "codigo":191636007,
    "descripcion":"TRASTORNO AFECTIVO BIPOLAR MIXTO"
  },
  {
    "codigo":89662003,
    "descripcion":"ÚLCERA PILÓRICA ASOCIADA CON HELICOBACTER"
  },
  {
    "codigo":56894004,
    "descripcion":"DETENCIÓN DE LA MADURACIÓN ERITROCÍTICA"
  },
  {
    "codigo":286270004,
    "descripcion":"INCAPAZ DE USAR LA ARTICULACIÓN SECUNDARIA"
  },
  {
    "codigo":253502007,
    "descripcion":"CUERDAS TENDINOSAS DE VÁLVULA AURICULOVENTRICULAR IZQUIERDA EXCESIVAMENTE CORTAS"
  },
  {
    "codigo":87827003,
    "descripcion":"DEFICIENCIA DE ISOVALERIL-COA DESHIDROGENASA"
  },
  {
    "codigo":41691000087101,
    "descripcion":"QUEMADURA DE PÁRPADO SUPERIOR DERECHO"
  },
  {
    "codigo":46811000087102,
    "descripcion":"NEOPLASIA MALIGNA DE INTESTINO GRUESO CON HEMORRAGIA"
  },
  {
    "codigo":217064000,
    "descripcion":"TRATAMIENTO DE ELECTROCHOQUE COMO CAUSA DE REACCIÓN ANORMAL DEL PACIENTE, O DE COMPLICACIÓN POSTERIOR, SIN MENCIÓN DE IMPREVISTOS DURANTE EL PROCEDIMIENTO"
  },
  {
    "codigo":34011000087104,
    "descripcion":"LESIONES TRAUMÁTICAS MÚLTIPLES DE REGIÓN DE COLUMNA VERTEBRAL"
  },
  {
    "codigo":44251000087106,
    "descripcion":"CONTUSIÓN DE CÓNDILO EXTERNO DE FÉMUR DERECHO"
  },
  {
    "codigo":10971000087107,
    "descripcion":"ISQUEMIA DE MIOCARDIO DURANTE LA CIRUGÍA"
  },
  {
    "codigo":39131000087107,
    "descripcion":"CEFALEA CRÓNICA DEBIDA A TRASTORNO"
  },
  {
    "codigo":9224001,
    "descripcion":"LATIDO PRECORDIAL ANORMAL"
  },
  {
    "codigo":315368006,
    "descripcion":"NACIDO EN ANDORRA"
  },
  {
    "codigo":774120007,
    "descripcion":"OBSTRUCCIÓN DE TROMPA DE EUSTAQUIO DERECHA"
  },
  {
    "codigo":282600008,
    "descripcion":"CAPAZ DE SALTAR"
  },
  {
    "codigo":444605001,
    "descripcion":"BRADICARDIA SINUSAL SINTOMÁTICA"
  },
  {
    "codigo":870589006,
    "descripcion":"LESIÓN RENAL AGUDA DEBIDA A COVID-19"
  },
  {
    "codigo":18621008,
    "descripcion":"PRODUCCIÓN DISMINUIDA TRANSITORIA DE T>4<"
  },
  {
    "codigo":247997008,
    "descripcion":"AMEDRENTAR"
  },
  {
    "codigo":278930003,
    "descripcion":"OFTALMÍA POR PSEUDOMONAS NEONATAL"
  },
  {
    "codigo":442770004,
    "descripcion":"ELECTROOCULOGRAMA ANORMAL"
  },
  {
    "codigo":47719001,
    "descripcion":"HIPERVALINEMIA"
  },
  {
    "codigo":211559002,
    "descripcion":"LESIÓN TRAUMÁTICA ABIERTA POR APLASTAMIENTO, BRAZO"
  },
  {
    "codigo":735847004,
    "descripcion":"FRACTURA DE PERONÉ DISTAL POR ENCIMA DE LA SINDESMOSIS"
  },
  {
    "codigo":80487005,
    "descripcion":"EDAD GESTACIONAL, 39 SEMANAS"
  },
  {
    "codigo":275260000,
    "descripcion":"MALFORMACIÓN CONGÉNITA DEL APARATO RESPIRATORIO"
  },
  {
    "codigo":734012002,
    "descripcion":"SEPARACIÓN GENERALIZADA DE DIENTES SUPERIORES"
  },
  {
    "codigo":111420009,
    "descripcion":"LEUCOPLAQUIA DE LA VAGINA"
  },
  {
    "codigo":240657005,
    "descripcion":"LIPOCHAGOMA SUBCUTÁNEO"
  },
  {
    "codigo":404497006,
    "descripcion":"MORAXELLA CATHARRALIS BETALACTAMASA NEGATIVA-HALLAZGO"
  },
  {
    "codigo":764945007,
    "descripcion":"MIOPATÍA CONGÉNITA CON NÚCLEOS INTERNOS Y CENTROS ATÍPICOS"
  },
  {
    "codigo":1287398000,
    "descripcion":"HERIDA POR ARMA DE FUEGO DE REGIÓN AXILAR"
  },
  {
    "codigo":109585008,
    "descripcion":"ABRASIÓN DE CUELLO DENTAL"
  },
  {
    "codigo":402662002,
    "descripcion":"VASCULITIS NECROSANTE POR CRIOGLOBULINEMIA MIXTA"
  },
  {
    "codigo":271590003,
    "descripcion":"CONSTITUCIÓN OBESA"
  },
  {
    "codigo":238822005,
    "descripcion":"ELASTOLISIS DÉRMICA NO INFLAMATORIA"
  },
  {
    "codigo":763110007,
    "descripcion":"DEFECTO COMBINADO DE LA FOSFORILACIÓN OXIDATIVA TIPO 13"
  },
  {
    "codigo":73147001,
    "descripcion":"HERNIA INGUINAL DIRECTA"
  },
  {
    "codigo":7611002,
    "descripcion":"SECUENCIA DE DISPLASIA SEPTOÓPTICA"
  },
  {
    "codigo":40379007,
    "descripcion":"DEPRESIÓN MAYOR RECURRENTE LEVE"
  },
  {
    "codigo":726672000,
    "descripcion":"SÍNDROME DE BAJA ESTATURA, FACIES CARACTERÍSTICA, HIPOPLASIA DEL ESMALTE DENTAL, RIGIDIEZ ARTICULAR PROGRESIVA Y VOZ AGUDA"
  },
  {
    "codigo":169616000,
    "descripcion":"ATENCIÓN PRENATAL COMPARTIDA"
  },
  {
    "codigo":366224001,
    "descripcion":"INCLINACIÓN DE DIENTE INCISIVO - HALLAZGO"
  },
  {
    "codigo":202384006,
    "descripcion":"DERRAME DE ARTICULACIÓN SUBASTRAGALINA"
  },
  {
    "codigo":300688006,
    "descripcion":"CAPAZ DE MANEJAR DINERO"
  },
  {
    "codigo":724837004,
    "descripcion":"ICTIOSIS QUERATINOPÁTICA"
  },
  {
    "codigo":428090004,
    "descripcion":"TUMORACIÓN EN VEJIGA URINARIA"
  },
  {
    "codigo":297018004,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE FUROSEMIDA"
  },
  {
    "codigo":723002009,
    "descripcion":"ASOMATOGNOSIA"
  },
  {
    "codigo":426255005,
    "descripcion":"DISGLUCEMIA"
  },
  {
    "codigo":229647009,
    "descripcion":"VOZ ESOFÁGICA"
  },
  {
    "codigo":1145316004,
    "descripcion":"FILTRO PROFUNDO"
  },
  {
    "codigo":293348006,
    "descripcion":"REACCIÓN ADVERSA AL ETAMSILATO"
  },
  {
    "codigo":31204009,
    "descripcion":"CALCIFICACIÓN DE VEJIGA URINARIA"
  },
  {
    "codigo":94905001,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL LÓBULO SUPERIOR IZQUIERDO DEL PULMÓN"
  },
  {
    "codigo":280797561000119107,
    "descripcion":"FIBRILACIÓN AURICULAR PERMANENTE DEBIDA A TRASTORNO DE VÁLVULA CARDÍACA"
  },
  {
    "codigo":422585004,
    "descripcion":"MARGEN QUIRÚRGICO PROXIMAL AFECTADO POR ADENOMA CON DISPLASIA DE ALTO GRADO DE MALIGNIDAD"
  },
  {
    "codigo":29369005,
    "descripcion":"GLAUCOMA POR HIPERSECRECIÓN"
  },
  {
    "codigo":193209005,
    "descripcion":"SÍNDROME MIASTÉNICO POR OTRO TRASTORNO"
  },
  {
    "codigo":15704441000119108,
    "descripcion":"ATROFIA DE MÚSCULO DE AMBOS HOMBROS"
  },
  {
    "codigo":1141646000,
    "descripcion":"ENDOCARDITIS VEGETATIVA NO INFECCIOSA"
  },
  {
    "codigo":224142000,
    "descripcion":"VIVE CON EL ABUELO"
  },
  {
    "codigo":93070004,
    "descripcion":"AGRANDAMIENTO CONGÉNITO DE FONTANELA"
  },
  {
    "codigo":289678004,
    "descripcion":"ÚTERO GRÁVIDO NO OBSERVADO"
  },
  {
    "codigo":715662009,
    "descripcion":"ENFERMEDAD DE CREUTZFELDT-JAKOB IATROGÉNICA"
  },
  {
    "codigo":124003003,
    "descripcion":"GALACTOSA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":713827004,
    "descripcion":"BAJO ATENCIÓN DE SERVICIO"
  },
  {
    "codigo":255075004,
    "descripcion":"NEOPLASIA MALIGNA DE PARED NASAL LATERAL"
  },
  {
    "codigo":418915007,
    "descripcion":"INFILTRADO CORNEAL MARGINAL ASOCIADO CON BLEFAROCONJUNTIVITIS"
  },
  {
    "codigo":89400003,
    "descripcion":"SÍNDROME DEL TRONCO BRAQUIOCEFÁLICO CURVADO"
  },
  {
    "codigo":440371000124100,
    "descripcion":"INFUSIÓN PARA NUTRICIÓN PARENTERAL INADECUADA"
  },
  {
    "codigo":2611000124100,
    "descripcion":"CANINO SUPERIOR IZQUIERDO PERMANENTE SUPERNUMERARIO"
  },
  {
    "codigo":253240006,
    "descripcion":"DISGENESIA TRABECULAR"
  },
  {
    "codigo":449848008,
    "descripcion":"DIENTE SUPERIOR PERMANENTE SUPERNUMERARIO"
  },
  {
    "codigo":251405001,
    "descripcion":"RELACIÓN MANITOL\/CELOBIOSA"
  },
  {
    "codigo":1269048009,
    "descripcion":"GLIOMA PONTINO INTRÍNSECO DIFUSO PRIMARIO"
  },
  {
    "codigo":249570003,
    "descripcion":"VESÍCULA BILIAR PALPABLE EN LA INSPIRACIÓN"
  },
  {
    "codigo":216802005,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR COMPUESTOS DE HIERRO"
  },
  {
    "codigo":10818221000119104,
    "descripcion":"FRACTURA EXPUESTA DE FALANGE DISTAL DE DEDO MEÑIQUE IZQUIERDO"
  },
  {
    "codigo":772023006,
    "descripcion":"NUEVO CRECIMIENTO DE UÑA DEBIDO A DESTRUCCIÓN QUÍMICA DEL LECHO UNGUEAL Y POSTERIOR A ELLA"
  },
  {
    "codigo":247735006,
    "descripcion":"ALUCINACIONES VISUALES ESCÉNICAS"
  },
  {
    "codigo":870327007,
    "descripcion":"CARCINOMA ESCAMOCELULAR PAPILAR DE NASOFARINGE"
  },
  {
    "codigo":49292002,
    "descripcion":"LIPODISTROFIA FAMILIAR PARCIAL"
  },
  {
    "codigo":278668004,
    "descripcion":"DIENTE INCISIVO PROTRUYENTE"
  },
  {
    "codigo":213132005,
    "descripcion":"DISPOSITIVO PROTÉSICO INTERNO QUE PROVOCA FIBROSIS"
  },
  {
    "codigo":14689000,
    "descripcion":"ÚTERO CORDIFORME"
  },
  {
    "codigo":735585008,
    "descripcion":"PERFORACIÓN DE AURÍCULA POSTERIOR A PROCEDIMIENTO"
  },
  {
    "codigo":702817009,
    "descripcion":"PREHIPERTENSIÓN"
  },
  {
    "codigo":307766002,
    "descripcion":"INFARTO DEL HEMISFERIO CEREBRAL IZQUIERDO"
  },
  {
    "codigo":10627911000119102,
    "descripcion":"CARBUNCO DE DEDO DE PIE IZQUIERDO"
  },
  {
    "codigo":897590006,
    "descripcion":"DISPLASIA ÓSEA CONGÉNITA DE ORIGEN MEDICAMENTOSO"
  },
  {
    "codigo":109323002,
    "descripcion":"OSTEOMIELITIS ESCLEROSANTE CRÓNICA NO SUPURATIVA DE HUESO CIGOMÁTICO"
  },
  {
    "codigo":404235004,
    "descripcion":"ENCEFALITIS POR VIRUS JAMESTON CANYON"
  },
  {
    "codigo":240395005,
    "descripcion":"ERISIPELOIDE CUTÁNEO LOCALIZADO"
  },
  {
    "codigo":369632000,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA DE ÚTERO Y VEJIGA, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":402400002,
    "descripcion":"URTICARIA AUTOINMUNITARIA EPISÓDICA"
  },
  {
    "codigo":302261000,
    "descripcion":"SISTEMA NERVIOSO NORMAL"
  },
  {
    "codigo":305991000119107,
    "descripcion":"TRASTORNO DE LIGAMENTO DE ARTICULACIÓN DE CODO IZQUIERDO"
  },
  {
    "codigo":105653006,
    "descripcion":"ENFERMEDAD CAUSADA POR THEILERIIDAE"
  },
  {
    "codigo":203957007,
    "descripcion":"SÍNDROME DE DANDY-WALKER CON ESPINA BÍFIDA"
  },
  {
    "codigo":431498001,
    "descripcion":"GINECOMASTIA IDIOPÁTICA"
  },
  {
    "codigo":236725009,
    "descripcion":"OBSTRUCCIÓN DE STENT URINARIO"
  },
  {
    "codigo":1186997009,
    "descripcion":"MONONUCLEOSIS INFECCIOSA CAUSADA POR VIRUS DE EPSTEIN-BARR"
  },
  {
    "codigo":365962004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA EL GOCE SEXUAL"
  },
  {
    "codigo":202122004,
    "descripcion":"DESGARRO COMPLETO ANTIGUO DE LIGAMENTO CRUZADO ANTERIOR"
  },
  {
    "codigo":1052255000,
    "descripcion":"CRIPTORQUIDIA ADQUIRIDA"
  },
  {
    "codigo":298591003,
    "descripcion":"ESCOLIOSIS LUMBAR"
  },
  {
    "codigo":15680481000119104,
    "descripcion":"CONJUNTIVITIS VIRAL DE AMBOS OJOS"
  },
  {
    "codigo":396895006,
    "descripcion":"HALLAZGO RELACIONADO CON TUMOR ENDOCRINO DEL PÁNCREAS"
  },
  {
    "codigo":69215007,
    "descripcion":"INTOLERANCIA AL CALOR"
  },
  {
    "codigo":460596000,
    "descripcion":"ARTERIA COLATERAL QUE DERIVA EL FLUJO SISTÉMICO HACIA LA CIRCULACIÓN PULMONAR QUE CONECTA CON ARTERIAS PULMONARES INTRAPARENQUIMATOSAS AISLADAS"
  },
  {
    "codigo":724575009,
    "descripcion":"DEFICIENCIA DE COENZIMA Q10"
  },
  {
    "codigo":296756003,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE DOXICICLINA"
  },
  {
    "codigo":427828004,
    "descripcion":"QUEMADURA DE TABIQUE NASAL"
  },
  {
    "codigo":34612006,
    "descripcion":"PELVIS GIGANTE"
  },
  {
    "codigo":198452006,
    "descripcion":"INFERTILIDAD TUBARIA PRIMARIA"
  },
  {
    "codigo":1148724006,
    "descripcion":"SOBREDOSIS DE GLUCÓSIDO DIGITÁLICO"
  },
  {
    "codigo":196617003,
    "descripcion":"DIVERTÍCULO ESOFÁGICO POR TRACCIÓN"
  },
  {
    "codigo":65545003,
    "descripcion":"RETINOSQUISIS BULLOSA - QUISTES RETINIANOS"
  },
  {
    "codigo":131081008,
    "descripcion":"NIVEL DE CORTISOL POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":293086009,
    "descripcion":"REACCIÓN ADVERSA A PLAGUICIDA A BASE DE CARBAMATO"
  },
  {
    "codigo":94643001,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE COLON TRANSVERSO"
  },
  {
    "codigo":12202101000119100,
    "descripcion":"HEMORRAGIA DE SISTEMA RESPIRATORIO POSTERIOR A PROCEDIMIENTO SOBRE SISTEMA RESPIRATORIO"
  },
  {
    "codigo":1091701000119101,
    "descripcion":"ENFERMEDAD DE MÉNIÈRE DE OÍDO INTERNO DERECHO EN REMISIÓN"
  },
  {
    "codigo":16236661000119100,
    "descripcion":"DELIRIO DEBIDO A INTOXICACIÓN CON METANFETAMINA"
  },
  {
    "codigo":15949941000119101,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE PIEL DE MAMA IZQUIERDA"
  },
  {
    "codigo":15629941000119104,
    "descripcion":"DOLOR EN LA REGIÓN INGUINAL IZQUIERDA"
  },
  {
    "codigo":195772021000119105,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DEBIDO A TROMBOSIS DE ARTERIA CEREBRAL ANTERIOR IZQUIERDA"
  },
  {
    "codigo":129141000119104,
    "descripcion":"ÚLCERA GÁSTRICA CAUSADA POR FÁRMACO ANTIINFLAMATORIO NO ESTEROIDE UTILIZADO CON FINES TERAPÉUTICOS"
  },
  {
    "codigo":697788021000119105,
    "descripcion":"PORTADOR DE ENFERMEDAD DE GAUCHER"
  },
  {
    "codigo":16264821000119108,
    "descripcion":"TRASTORNO DEPRESIVO MAYOR SEVERO RECURRENTE CONCOMITANTE CON ANSIEDAD"
  },
  {
    "codigo":92808004,
    "descripcion":"ENFERMEDAD DEGENERATIVA CRÓNICA DE VÁLVULA AÓRTICA"
  },
  {
    "codigo":318581000119107,
    "descripcion":"HIPERLORDOSIS POSTURAL ADQUIRIDA DE COLUMNA VERTEBRAL LUMBAR Y SACRA"
  },
  {
    "codigo":27272007,
    "descripcion":"PALADAR OJIVAL"
  },
  {
    "codigo":420488007,
    "descripcion":"OBSTRUCCIÓN DE CATÉTER URINARIO URETRAL"
  },
  {
    "codigo":98421000119108,
    "descripcion":"PORTADOR DE DISAUTONOMÍA FAMILIAR"
  },
  {
    "codigo":339061000119108,
    "descripcion":"EXOSTOSIS DE ÓRBITA IZQUIERDA"
  },
  {
    "codigo":21621000119107,
    "descripcion":"DOLOR PERINEAL FEMENINO"
  },
  {
    "codigo":354421000119107,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE EXTREMIDAD INFERIOR DERECHA"
  },
  {
    "codigo":25437005,
    "descripcion":"DISCINESIA CARDÍACA"
  },
  {
    "codigo":1010312007,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE EXTREMIDAD INFERIOR DERECHA ENTRE LA RODILLA Y EL TOBILLO"
  },
  {
    "codigo":1303389003,
    "descripcion":"FRACTURA ÓSEA DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":189277003,
    "descripcion":"CARCINOMA IN SITU DE LA PIEL DEL PÁRPADO, INCLUIDO EL CANTO PALPEBRAL"
  },
  {
    "codigo":418653000,
    "descripcion":"COLOBOMA SECUNDARIO DEL CRISTALINO"
  },
  {
    "codigo":11803771000119109,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA PROXIMAL DE DEDO ÍNDICE DERECHO"
  },
  {
    "codigo":56370005,
    "descripcion":"CICATRIZ RETINIANA POSTINFLAMATORIA"
  },
  {
    "codigo":285746006,
    "descripcion":"ALUCINACIONES FORMADAS: INSECTOS"
  },
  {
    "codigo":89138009,
    "descripcion":"CHOQUE CARDIÓGENO"
  },
  {
    "codigo":251143007,
    "descripcion":"ARTIFICIO ELECTROCARDIOGRÁFICO"
  },
  {
    "codigo":283911008,
    "descripcion":"CORTE DE CONDUCTO URINARIO"
  },
  {
    "codigo":118236001,
    "descripcion":"HALLAZGO EN EL OÍDO"
  },
  {
    "codigo":445916002,
    "descripcion":"OLOR DE HERIDA"
  },
  {
    "codigo":183772001,
    "descripcion":"INSCRIPTO EN LISTA DE ADMISIÓN INMUNOLÓGICA"
  },
  {
    "codigo":282076000,
    "descripcion":"CONTUSIÓN DE ANO"
  },
  {
    "codigo":413148009,
    "descripcion":"ESTADO DE CONSENTIMIENTO PARA LA PARTICIPACIÓN EN AUDITORÍA"
  },
  {
    "codigo":1197745002,
    "descripcion":"LIPODISTROFIA PARCIAL FAMILIAR ASOCIADA A RECEPTOR GAMMA ACTIVADO POR PROLIFERADOR DE PEROXISOMA"
  },
  {
    "codigo":1163142000,
    "descripcion":"COLITIS CAUSADA POR BRACHYSPIRA PILOSICOLI"
  },
  {
    "codigo":442246002,
    "descripcion":"TRASTORNO DE ARTICULACIÓN DE TOBILLO Y\/O PIE"
  },
  {
    "codigo":49030004,
    "descripcion":"RUPTURA DE HEBRAS"
  },
  {
    "codigo":737158007,
    "descripcion":"ANEURISMA DE AORTA DEBIDO A PROCEDIMIENTO Y POSTERIOR A ÉL"
  },
  {
    "codigo":1259611004,
    "descripcion":"COREA DEBIDA A FORMA CLÁSICA DE NEURODEGENERACIÓN ASOCIADA A PANTOTENATO CINASA"
  },
  {
    "codigo":276571005,
    "descripcion":"FALTA DE ACCIONAMIENTO RESPIRATORIO"
  },
  {
    "codigo":407643006,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: ALEMÁN"
  },
  {
    "codigo":702555007,
    "descripcion":"ALTA PROVOCACIÓN BACTERIANA"
  },
  {
    "codigo":241968001,
    "descripcion":"HIPOTERMIA POR INMERSIÓN"
  },
  {
    "codigo":78128001,
    "descripcion":"COLITIS ASOCIADA CON HELICOBACTER"
  },
  {
    "codigo":14427009,
    "descripcion":"IRITIS SUBAGUDA"
  },
  {
    "codigo":373040004,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM LENTIFLAVUM"
  },
  {
    "codigo":274736005,
    "descripcion":"DEFECTO DE LLENADO URETERAL"
  },
  {
    "codigo":698885002,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: ARMENIO"
  },
  {
    "codigo":305669002,
    "descripcion":"ATENDIDO POR UN FISIÓLOGO CLÍNICO"
  },
  {
    "codigo":240133009,
    "descripcion":"RABDOMIÓLISIS PAROXÍSTICA FAMILIAR"
  },
  {
    "codigo":205530002,
    "descripcion":"HIPOPLASIA MUSCULAR"
  },
  {
    "codigo":41690001,
    "descripcion":"TRASTORNO POR INHIBIDOR DEL FACTOR V"
  },
  {
    "codigo":860890006,
    "descripcion":"NEOPLASIA INTERSTICIAL DE PULMÓN FETAL"
  },
  {
    "codigo":402138008,
    "descripcion":"MICOSIS CUTÁNEA DISEMINADA"
  },
  {
    "codigo":762586009,
    "descripcion":"URANOESTAFILOSQUISIS CON LABIO LEPORINO BILATERAL Y FISURA ALVEOLAR BILATERAL"
  },
  {
    "codigo":301999002,
    "descripcion":"CAPAZ DE MOVERSE"
  },
  {
    "codigo":236463002,
    "descripcion":"ACIDOSIS TUBULORRENAL HIPERCALIÉMICA"
  },
  {
    "codigo":337481000119104,
    "descripcion":"PARÁLISIS DE NERVIO OCULOMOTOR IZQUIERDO"
  },
  {
    "codigo":1186735007,
    "descripcion":"NEOPLASIA MIXTA NEUROENDOCRINA Y NO NEUROENDOCRINA DE PÁNCREAS"
  },
  {
    "codigo":365700001,
    "descripcion":"HALLAZGO RELACIONADO CON EL CRECIMIENTO DE HONGOS"
  },
  {
    "codigo":431236003,
    "descripcion":"ARTRITIS BACTERIANA DE ARTICULACIÓN SACROILÍACA"
  },
  {
    "codigo":234628004,
    "descripcion":"DEFICIENCIA DEL RECEPTOR DEL COMPLEMENTO"
  },
  {
    "codigo":1217668007,
    "descripcion":"QUISTE ODONTÓGENO DE ÓRBITA"
  },
  {
    "codigo":300164008,
    "descripcion":"HUESECILLOS DEL OÍDO, PRESENTES"
  },
  {
    "codigo":462169004,
    "descripcion":"TAQUICARDIA SUPRAVENTRICULAR FETAL CON INTERVALO VENTRICULOAURICULAR CORTO"
  },
  {
    "codigo":298329005,
    "descripcion":"MOVIMIENTO VIOLENTO DE TIPO BALISMO"
  },
  {
    "codigo":722478008,
    "descripcion":"SÍNDROME DE DISPLASIA ESQUELÉTICA CON DISCAPACIDAD INTELECTUAL"
  },
  {
    "codigo":32515001,
    "descripcion":"ATROFIA SENIL DEL CUELLO UTERINO"
  },
  {
    "codigo":1179395002,
    "descripcion":"HIPOTIROIDISMO CONSUNTIVO CAUSADO POR YODOTIRONINA DESYODASA TIPO 3"
  },
  {
    "codigo":311011000119104,
    "descripcion":"HIDRARTROSIS INTERMITENTE DE RODILLA DERECHA"
  },
  {
    "codigo":294659004,
    "descripcion":"ALERGIA A COMPONENTE DE VACUNA QUE CONTIENE ANTÍGENO DE SALMONELLA ENTERICA SUBESPECIE ENTERICA SEROVARIEDAD TYPHI"
  },
  {
    "codigo":292824001,
    "descripcion":"REACCIÓN ADVERSA AL FLUCONAZOL"
  },
  {
    "codigo":391128002,
    "descripcion":"PROGRAMA DE REHABILITACIÓN PULMONAR: INICIADO"
  },
  {
    "codigo":128984004,
    "descripcion":"INFECCIÓN OCULAR DE ORIGEN BACTERIANO"
  },
  {
    "codigo":423896007,
    "descripcion":"CARCINOMA ESCAMOCELULAR DE LA PUNTA DE LA NARIZ"
  },
  {
    "codigo":192685000,
    "descripcion":"PANENCEFALITIS ESCLEROSANTE SUBAGUDA"
  },
  {
    "codigo":784344009,
    "descripcion":"DISGENESIA CORTICAL CON HIPOPLASIA PONTOCEREBELOSA DEBIDA A MUTACIÓN DE CLASE III DE TUBULINA BETA"
  },
  {
    "codigo":422061002,
    "descripcion":"OPACIDADES VÍTREAS"
  },
  {
    "codigo":94381002,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE HÍGADO"
  },
  {
    "codigo":290989003,
    "descripcion":"INTOXICACIÓN POR ZOLPIDEM"
  },
  {
    "codigo":127149004,
    "descripcion":"LINFADENOPATÍA CÓLICA DERECHA"
  },
  {
    "codigo":28845006,
    "descripcion":"APENDICITIS AGUDA CON PERITONITIS GENERALIZADA"
  },
  {
    "codigo":225453006,
    "descripcion":"PERCEPCIÓN FALSA"
  },
  {
    "codigo":715138003,
    "descripcion":"INCAPAZ DE PASAR DE UNA SILLA DE RUEDAS A UNA SILLA"
  },
  {
    "codigo":92546004,
    "descripcion":"CARCINOMA IN SITU DE VEJIGA URINARIA"
  },
  {
    "codigo":289154005,
    "descripcion":"BEBE LÍQUIDOS NORMALMENTE"
  },
  {
    "codigo":57943003,
    "descripcion":"VEJEZ EXTREMA (MÁS DE 100 AÑOS)"
  },
  {
    "codigo":254551004,
    "descripcion":"CARCINOMA DE TERCIO INFERIOR DE ESÓFAGO"
  },
  {
    "codigo":189015008,
    "descripcion":"LIPOMA DE CONDUCTO VERTEBRAL - EXTRADURAL"
  },
  {
    "codigo":449324007,
    "descripcion":"ALERGIA A DOXACURIO"
  },
  {
    "codigo":56108007,
    "descripcion":"RIÑÓN PÉLVICO"
  },
  {
    "codigo":339991000119102,
    "descripcion":"SUBLUXACIÓN DEL CRISTALINO DEL OJO IZQUIERDO"
  },
  {
    "codigo":707798001,
    "descripcion":"ALTA DE ATENCIÓN MÉDICA EN AMBULANCIA"
  },
  {
    "codigo":19670002,
    "descripcion":"ABSCESO DEL PERIOSTIO SIN OSTEOMIELITIS"
  },
  {
    "codigo":283649009,
    "descripcion":"AGUJA DE COSER ATRAVESADA EN LA UÑA"
  },
  {
    "codigo":1363158004,
    "descripcion":"ASTILLA EN MAMA"
  },
  {
    "codigo":609494005,
    "descripcion":"INTERRUPCIÓN INDUCIDA DEL EMBARAZO COMPLICADA POR TRASTORNO DE LA PELVIS"
  },
  {
    "codigo":871638006,
    "descripcion":"MIOCARDIOPATÍA HIPERTRÓFICA DEBIDA A ENFERMEDAD DE ALMACENAMIENTO DE GLUCÓGENO"
  },
  {
    "codigo":247211002,
    "descripcion":"ARTERIA CILIORRETINIANA"
  },
  {
    "codigo":1197483002,
    "descripcion":"TRASTORNO FUNCIONAL DE NEUTRÓFILO POLIMORFONUCLEAR"
  },
  {
    "codigo":443819006,
    "descripcion":"MIOPATÍA EN DOLENCIA CRÍTICA"
  },
  {
    "codigo":50603008,
    "descripcion":"ANQUILOSIS DE LA ARTICULACIÓN TEMPOROMANDIBULAR"
  },
  {
    "codigo":16000003,
    "descripcion":"ERUPCIÓN PREMATURA DE DIENTE"
  },
  {
    "codigo":866133000,
    "descripcion":"NEURORRETINITIS INFECCIOSA"
  },
  {
    "codigo":210773002,
    "descripcion":"HERIDAS ABIERTAS QUE COMPROMETEN MÚLTIPLES REGIONES DE LA PORCIÓN DISTAL DEL (DE LOS) MIEMBRO(S)"
  },
  {
    "codigo":11782321000119102,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXTERNA NO EXPUESTA DE ARTICULACIÓN FEMORORROTULIANA IZQUIERDA"
  },
  {
    "codigo":700458001,
    "descripcion":"EDEMA PULMONAR DEBIDO A HIPOPROTEINEMIA"
  },
  {
    "codigo":276309009,
    "descripcion":"PATRÓN ELECTROCARDIOGRÁFICO JUVENIL"
  },
  {
    "codigo":208938001,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE LA ARTICULACIÓN DE LA RODILLA, POSTERIOR"
  },
  {
    "codigo":45098004,
    "descripcion":"ANEMIA CAUSADA POR MECANISMOS MÚLTIPLES"
  },
  {
    "codigo":1259349009,
    "descripcion":"CARCINOMA PRIMARIO DE TERCIO INFERIOR DE ESÓFAGO"
  },
  {
    "codigo":405546008,
    "descripcion":"DERRAME PERICÁRDICO CONCOMITANTE CON NEOPLASIA MALIGNA DE PERICARDIO Y DEBIDO A ELLA"
  },
  {
    "codigo":403711001,
    "descripcion":"NEOPLASIA MALIGNA DE PIEL ASOCIADA A TERAPIA CON PUVA"
  },
  {
    "codigo":733226009,
    "descripcion":"LACERACIÓN DE VENA BRAQUIAL"
  },
  {
    "codigo":16697521000119104,
    "descripcion":"RETINOPATÍA NO PROLIFERATIVA MODERADA BILATERAL DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":239871009,
    "descripcion":"ARTROSIS DE ARTICULACIÓN METACARPOFALÁNGICA DE DEDO"
  },
  {
    "codigo":698623009,
    "descripcion":"ARTROPATÍA ASOCIADA CON SIRINGOMIELIA"
  },
  {
    "codigo":238036004,
    "descripcion":"TRASTORNO DE LA SÍNTESIS DE COLESTEROL"
  },
  {
    "codigo":762324008,
    "descripcion":"DELIRIO CAUSADO POR ESTIMULANTE"
  },
  {
    "codigo":203433000,
    "descripcion":"OSTEOPOROSIS POSOOFORECTOMÍA"
  },
  {
    "codigo":301737005,
    "descripcion":"CAPAZ DE REALIZAR ACTIVIDADES DE OFICINA"
  },
  {
    "codigo":67761000119108,
    "descripcion":"BOCIO DE FUNCIONAMIENTO AUTÓNOMO"
  },
  {
    "codigo":6825008,
    "descripcion":"LACERACIÓN PERINEAL QUE COMPROMETE EL TABIQUE RECTOVAGINAL"
  },
  {
    "codigo":1184638001,
    "descripcion":"VELOCIDAD DE FLUJO RESPIRATORIO POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":365438003,
    "descripcion":"HALLAZGO RELACIONADO CON EL CONTENIDO DE LA MATERIA FECAL"
  },
  {
    "codigo":299902004,
    "descripcion":"HALLAZGO RELACIONADO CON EL SENTIDO DE LA TEMPERATURA"
  },
  {
    "codigo":398206004,
    "descripcion":"DEFORMIDAD CONGÉNITA DE LA CARA"
  },
  {
    "codigo":103294007,
    "descripcion":"VÉRTIGO PRODUCIDO POR PRESIÓN EN EL CUELLO"
  },
  {
    "codigo":430974008,
    "descripcion":"SÍNDROME COMPARTIMENTAL DE ABDOMEN DEBIDO A LESIÓN TRAUMÁTICA"
  },
  {
    "codigo":234366009,
    "descripcion":"ANEMIA SIDEROBLÁSTICA RELACIONADA CON EL ALCOHOL"
  },
  {
    "codigo":199763000,
    "descripcion":"TRABAJO DE PARTO OBSTRUIDO POR CONTRACCIÓN DEL ESTRECHO SUPERIOR DE LA PELVIS"
  },
  {
    "codigo":35923002,
    "descripcion":"SINUSITIS MAXILAR CRÓNICA"
  },
  {
    "codigo":298067004,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE LA NARIZ"
  },
  {
    "codigo":230696001,
    "descripcion":"INFARTO DE LA CIRCULACIÓN CEREBRAL POSTERIOR"
  },
  {
    "codigo":197928006,
    "descripcion":"INFECCIÓN CRÓNICA DE LAS VÍAS URINARIAS"
  },
  {
    "codigo":427304006,
    "descripcion":"HALLAZGO RELACIONADO CON LA RESPUESTA AL DOLOR"
  },
  {
    "codigo":1079781000119101,
    "descripcion":"DERMATOFIBROMA DE PIEL DE OREJA DERECHA"
  },
  {
    "codigo":1144530002,
    "descripcion":"CAPAZ DE CRIAR EFICAZMENTE"
  },
  {
    "codigo":30418008,
    "descripcion":"ANEMIA POR DISFUNCIÓN ADRENAL"
  },
  {
    "codigo":421799001,
    "descripcion":"PÉRDIDA CUTÁNEA DE ESPESOR COMPLETO Y DE TEJIDO SUBCUTÁNEO"
  },
  {
    "codigo":718546008,
    "descripcion":"CISTOSCOPIA NORMAL"
  },
  {
    "codigo":126887003,
    "descripcion":"NEOPLASIA DEL VÉRTICE VESICAL"
  },
  {
    "codigo":290727005,
    "descripcion":"INTOXICACIÓN POR RAZOXANO"
  },
  {
    "codigo":288892004,
    "descripcion":"NO COME CIERTOS ALIMENTOS"
  },
  {
    "codigo":714876004,
    "descripcion":"DIFICULTAD PARA MANTENERSE EN CUCLILLAS"
  },
  {
    "codigo":92284006,
    "descripcion":"NEOPLASIA BENIGNA DEL PERITONEO PÉLVICO"
  },
  {
    "codigo":26748006,
    "descripcion":"HIPOCALCIFICACIÓN DE DIENTES"
  },
  {
    "codigo":254289008,
    "descripcion":"NEOPLASIA POSTRASPLANTE"
  },
  {
    "codigo":876881008,
    "descripcion":"FALLECIDO EN INSTALACIONES DE ATENCIÓN MÉDICA GENERAL"
  },
  {
    "codigo":287057009,
    "descripcion":"COMPLEJO AURICULAR PREMATURO"
  },
  {
    "codigo":23078003,
    "descripcion":"PRODUCCIÓN DE GRANULOCITOS AUMENTADA"
  },
  {
    "codigo":96741000119109,
    "descripcion":"CARDIOPATÍA Y ENFERMEDAD RENAL CRÓNICA POR HIPERTENSIÓN, ESTADIO 2"
  },
  {
    "codigo":285222000,
    "descripcion":"CAPAZ DE RECORDAR HABILIDADES MOTRICES PREVIAS"
  },
  {
    "codigo":55846006,
    "descripcion":"XERODERMA PALPEBRAL"
  },
  {
    "codigo":21243004,
    "descripcion":"NACIMIENTO DE TÉRMINO"
  },
  {
    "codigo":840443008,
    "descripcion":"DACRIOADENITIS DEBIDA A MONONUCLEOSIS INFECCIOSA"
  },
  {
    "codigo":281552000,
    "descripcion":"SECCIÓN TRAUMÁTICA DE TENDÓN DEL TRONCO"
  },
  {
    "codigo":283387008,
    "descripcion":"LACERACIÓN DE PIERNA"
  },
  {
    "codigo":707536003,
    "descripcion":"MANIFESTACIÓN DEL APARATO DIGESTIVO CONCOMITANTE CON FIBROSIS QUÍSTICA Y DEBIDA A ELLA"
  },
  {
    "codigo":16044671000119106,
    "descripcion":"ARTRITIS IDIOPÁTICA JUVENIL DE AMBOS CODOS"
  },
  {
    "codigo":15690521000119100,
    "descripcion":"ARTRITIS INFECCIOSA DE AMBAS RODILLAS"
  },
  {
    "codigo":246949000,
    "descripcion":"PANNUS CORNEAL MARGINAL"
  },
  {
    "codigo":1231824009,
    "descripcion":"ESTEATOSIS HEPÁTICA ASOCIADA A DISFUNCIÓN METABÓLICA"
  },
  {
    "codigo":703866000,
    "descripcion":"HEPATITIS C CRÓNICA CON FIBROSIS EN ESTADIO 2"
  },
  {
    "codigo":771237009,
    "descripcion":"SÍNDROME DE NIEVE VISUAL"
  },
  {
    "codigo":441722007,
    "descripcion":"HEMIPLEJÍA ESPÁSTICA DE LADO NO DOMINANTE"
  },
  {
    "codigo":212346008,
    "descripcion":"LESIÓN EXPUESTA DEL NERVIO PUDENDO"
  },
  {
    "codigo":79439001,
    "descripcion":"ANOMALÍA CONGÉNITA DEL CAYADO AÓRTICO"
  },
  {
    "codigo":1259087007,
    "descripcion":"ENCEFALITIS AUTOINMUNITARIA CAUSADA POR ANTICUERPO CONTRA RECEPTOR DE N-METIL-D-ASPARTATO"
  },
  {
    "codigo":276047008,
    "descripcion":"CUIDA A UN ANCIANO DEPENDIENTE"
  },
  {
    "codigo":16837401000119105,
    "descripcion":"NEOVASCULARIZACIÓN DE COROIDES DE AMBOS OJOS DEBIDA A MIOPÍA DEGENERATIVA"
  },
  {
    "codigo":110372005,
    "descripcion":"HIERRO DE LA MÉDULA ÓSEA AUMENTADO"
  },
  {
    "codigo":1290020006,
    "descripcion":"TUMOR NEUROENDOCRINO BIEN DIFERENCIADO PRIMARIO DE ESÓFAGO"
  },
  {
    "codigo":12068006,
    "descripcion":"PROLAPSO DE LA URETRA"
  },
  {
    "codigo":403449001,
    "descripcion":"MÁCULA MELANÓTICA DE LA MUCOSA ORAL (TIPO REACTIVO)"
  },
  {
    "codigo":1255417003,
    "descripcion":"FRACTURA EXPUESTA CONMINUTA DE FALANGE DE DEDO DE PIE"
  },
  {
    "codigo":1222649004,
    "descripcion":"SÍNDROME DE NEUROPATÍA AUDITIVA Y ATROFIA ÓPTICA"
  },
  {
    "codigo":237774001,
    "descripcion":"GLÁNDULA SUPRARRENAL PEQUEÑA"
  },
  {
    "codigo":203171000,
    "descripcion":"OSTEOMIELITIS AGUDA DE RÓTULA"
  },
  {
    "codigo":301475006,
    "descripcion":"SORTEA OBSTÁCULOS"
  },
  {
    "codigo":235939007,
    "descripcion":"RUPTURA DE ANASTOMOSIS BILIAR"
  },
  {
    "codigo":234104002,
    "descripcion":"FILTRACIÓN DE LINFA"
  },
  {
    "codigo":365176002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA REALIZAR ACTIVIDADES DE ESCRITURA"
  },
  {
    "codigo":299640004,
    "descripcion":"ARTICULACIÓN DEL DEDO DEL PIE - CALIENTE"
  },
  {
    "codigo":1348216002,
    "descripcion":"PATRÓN DE USO EPISÓDICO NOCIVO SIN DEPENDENCIA DE SUSTANCIAS MIXTAS"
  },
  {
    "codigo":232269003,
    "descripcion":"MASTOIDITIS AGUDA CON PARÁLISIS FACIAL"
  },
  {
    "codigo":428877005,
    "descripcion":"INFECCIÓN CUTÁNEA DE DEDO DE LA MANO"
  },
  {
    "codigo":1082291000119108,
    "descripcion":"CARCINOMA DE CÉLULAS DE TRANSICIÓN DE URÉTER IZQUIERDO"
  },
  {
    "codigo":164898000,
    "descripcion":"ECG: BLOQUEO CARDÍACO"
  },
  {
    "codigo":2893009,
    "descripcion":"ANOMALÍA DEL PAR DE CROMOSOMAS 10"
  },
  {
    "codigo":295970001,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE PIRACETAM"
  },
  {
    "codigo":16538701000119103,
    "descripcion":"SENSACIÓN DE BLOQUEO DEL OÍDO IZQUIERDO"
  },
  {
    "codigo":33826007,
    "descripcion":"QUEMADURA EPIDÉRMICA DE CODO"
  },
  {
    "codigo":31991001,
    "descripcion":"FAGOCITOSIS LEUCOCÍTICA"
  },
  {
    "codigo":294135005,
    "descripcion":"ALERGIA A HIDROXIZINA"
  },
  {
    "codigo":128460000,
    "descripcion":"ESCLEROSIS SISTÉMICA, DIFUSA"
  },
  {
    "codigo":292300001,
    "descripcion":"REACCIÓN ADVERSA AL TRIPTÓFANO"
  },
  {
    "codigo":95692001,
    "descripcion":"LIPIDEMIA RETINIANA"
  },
  {
    "codigo":290465002,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ACEITE DE RICINO"
  },
  {
    "codigo":28321004,
    "descripcion":"FÍSTULA VESICOCUTÁNEA"
  },
  {
    "codigo":126625006,
    "descripcion":"NEOPLASIA DE MÚSCULO DEL TÓRAX"
  },
  {
    "codigo":716449006,
    "descripcion":"CAPAZ DE ORDENAR ELEMENTOS PARA RECICLAR"
  },
  {
    "codigo":93857009,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA COMISURA DE LA LARINGE"
  },
  {
    "codigo":288630008,
    "descripcion":"JUEGA CON LAS PALABRAS Y LOS SIGNIFICADOS"
  },
  {
    "codigo":254027003,
    "descripcion":"MICROSOMÍA CRANEOFACIAL BILATERAL"
  },
  {
    "codigo":286795004,
    "descripcion":"TIENDE A DIRIGIR LA IRA CONTRA SÍ MISMO"
  },
  {
    "codigo":710944000,
    "descripcion":"INFLAMACIÓN DE ARTERIA UMBILICAL FETAL"
  },
  {
    "codigo":22816001,
    "descripcion":"SUPERFECUNDACIÓN"
  },
  {
    "codigo":57419008,
    "descripcion":"GASTROENTERITIS DE ORIGEN PRESUNTAMENTE INFECCIOSO"
  },
  {
    "codigo":219424002,
    "descripcion":"HERIDA DE GUERRA POR CALOR DESPEDIDO POR ARMAS NUCLEARES"
  },
  {
    "codigo":416032004,
    "descripcion":"RESULTADO DE CITOLOGÍA CERVICOVAGINAL NORMAL O BENIGNO"
  },
  {
    "codigo":292071000119106,
    "descripcion":"TRASTORNO DE NERVIO CIÁTICO POPLÍTEO EXTERNO IZQUIERDO"
  },
  {
    "codigo":284960008,
    "descripcion":"DIFICULTAD PARA MANEJAR LA HIGIENE MENSTRUAL"
  },
  {
    "codigo":1004021003,
    "descripcion":"TRASTORNO NEONATAL DEBIDO A ENFERMEDAD RESPIRATORIA MATERNA"
  },
  {
    "codigo":709109004,
    "descripcion":"INSUFICIENCIA RESPIRATORIA HIPERCÁPNICA"
  },
  {
    "codigo":283125005,
    "descripcion":"AMPOLLA TRAUMÁTICA DEL DORSO DE LA MANO"
  },
  {
    "codigo":20981007,
    "descripcion":"ANEURISMA DE ARTERIA DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":838346000,
    "descripcion":"LEUCEMIA-LINFOMA LINFOBLÁSTICO DE CÉLULAS B CON HIPERDIPLOIDIA"
  },
  {
    "codigo":84682001,
    "descripcion":"VÍCTIMA DE ACCIDENTE AÉREO"
  },
  {
    "codigo":248522001,
    "descripcion":"TUMORACIÓN QUE DESCIENDE POR VAGINA"
  },
  {
    "codigo":772810003,
    "descripcion":"GRIPE CAUSADA POR VIRUS INFLUENZA A SUBTIPO H3N2"
  },
  {
    "codigo":347521000119103,
    "descripcion":"CATARATA SENIL HIPERMADURA DE OJO IZQUIERDO"
  },
  {
    "codigo":281290007,
    "descripcion":"ESPÉCIMEN LEVEMENTE ICTÉRICO"
  },
  {
    "codigo":445130008,
    "descripcion":"ADENOIDITIS INFECCIOSA AGUDA"
  },
  {
    "codigo":707274007,
    "descripcion":"INFECCIÓN CAUSADA POR BACTERIAS RESISTENTES A CARBAPENEM"
  },
  {
    "codigo":246687006,
    "descripcion":"POSICIÓN OCULAR CON CABEZA FLEXIONADA"
  },
  {
    "codigo":1162356000,
    "descripcion":"ARTRITIS TUBERCULOSA DE MANO CAUSADA POR MYCOBACTERIUM TUBERCULOSIS"
  },
  {
    "codigo":312223008,
    "descripcion":"ORQUITIS INFECCIOSA"
  },
  {
    "codigo":15666561000119105,
    "descripcion":"ESCAFOIDES TARSIANO ACCESORIO BILATERAL"
  },
  {
    "codigo":441460004,
    "descripcion":"CISTICERCOSIS DE CEREBRO"
  },
  {
    "codigo":310388008,
    "descripcion":"SITUACIÓN DE INFORMACIÓN DEL FAMILIAR"
  },
  {
    "codigo":111945001,
    "descripcion":"IDENTIFICACIÓN DE UN CUERPO"
  },
  {
    "codigo":79177001,
    "descripcion":"AUSENCIA CONGÉNITA DE TIBIA"
  },
  {
    "codigo":1084801000119107,
    "descripcion":"MENINGITIS CAUSADA POR SPOROTHRIX SCHENKII"
  },
  {
    "codigo":243017009,
    "descripcion":"LESIÓN POR FRAGMENTO DE PROYECTIL DE ARTILLERÍA"
  },
  {
    "codigo":110110003,
    "descripcion":"LACERACIÓN SIMPLE CONTAMINADA DEL VESTÍBULO MAXILAR"
  },
  {
    "codigo":11806006,
    "descripcion":"TRASTORNO DE ANSIEDAD POR SEPARACIÓN EN LA NIÑEZ"
  },
  {
    "codigo":44574006,
    "descripcion":"PORFIRIURIA"
  },
  {
    "codigo":403187000,
    "descripcion":"REACCIÓN A ANILLO METÁLICO, CLAVOS O HEBILLAS EN CONTACTO CON LA PIEL"
  },
  {
    "codigo":208414008,
    "descripcion":"FRACTURA EXPUESTA DE LA BASE DE HUESO METACARPIANO"
  },
  {
    "codigo":75507000,
    "descripcion":"HEMORRAGIA SUBARACNOIDEA POSTRAUMÁTICA CON HERIDA INTRACRANEAL ABIERTA Y PÉRDIDA DE LA CONSCIENCIA"
  },
  {
    "codigo":237512007,
    "descripcion":"TIROTOXICOSIS DEBIDA A ADENOMA HIPOFISARIO SECRETOR DE TSH"
  },
  {
    "codigo":40904009,
    "descripcion":"QUEMADURA DE CUALQUIER GRADO QUE COMPROMETE 30-39 PORCIENTO DE LA SUPERFICIE DEL CUERPO"
  },
  {
    "codigo":235677003,
    "descripcion":"BEZOAR"
  },
  {
    "codigo":1251485006,
    "descripcion":"METÁSTASIS DE ADENOCARCINOMA EN PRÓSTATA"
  },
  {
    "codigo":399517007,
    "descripcion":"NO SE PUEDE DETERMINAR ESTADIO TUMORAL"
  },
  {
    "codigo":202909008,
    "descripcion":"TUMOR TENOSINOVIAL DE CÉLULAS GIGANTES DIFUSO DE VAINA TENDINOSA"
  },
  {
    "codigo":301213009,
    "descripcion":"HALLAZGO RELACIONADO CON LA SENSIBILIDAD DE LA LARINGE"
  },
  {
    "codigo":364914001,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA PARARSE"
  },
  {
    "codigo":233842003,
    "descripcion":"INFARTO ANTIGUO DE MIOCARDIO POSTERIOR"
  },
  {
    "codigo":299378008,
    "descripcion":"CREPITACIÓN DE ARTICULACIÓN DE RODILLA"
  },
  {
    "codigo":789063000,
    "descripcion":"SÍNDROME DE HIPERALDOSTERONISMO PRIMARIO, CONVULSIONES Y ANOMALÍAS NEUROLÓGICAS"
  },
  {
    "codigo":461383006,
    "descripcion":"TRAYECTO INTRAMURAL ANÓMALO DE PORCIÓN PROXIMAL DE ARTERIA CORONARIA POR ENCIMA DE SENO AÓRTICO"
  },
  {
    "codigo":721692006,
    "descripcion":"PÓLIPO LINFOIDE BENIGNO DE INTESTINO GRUESO"
  },
  {
    "codigo":426780009,
    "descripcion":"AMENORREA HIPERGONADOTRÓFICA"
  },
  {
    "codigo":262940009,
    "descripcion":"SECCIÓN DE ARTERIA VERTEBRAL"
  },
  {
    "codigo":228337008,
    "descripcion":"LA BEBIDA TIENE PRIORIDAD SOBRE LAS OBLIGACIONES FINANCIERAS"
  },
  {
    "codigo":29894000,
    "descripcion":"BRADICARDIA AUTONÓMICA VAGAL"
  },
  {
    "codigo":95430002,
    "descripcion":"PARÁLISIS DE VÍAS RESPIRATORIAS"
  },
  {
    "codigo":783558004,
    "descripcion":"DEFECTO COMBINADO DE LA FOSFORILACIÓN OXIDATIVA TIPO 11"
  },
  {
    "codigo":191899001,
    "descripcion":"PATRÓN DE USO NOCIVO CONTINUO DE ALUCINÓGENO SIN DEPENDENCIA"
  },
  {
    "codigo":93595006,
    "descripcion":"OSIFICACIÓN INCOMPLETA DE HUESO PALATINO"
  },
  {
    "codigo":716187007,
    "descripcion":"ALERGIA A PROTEÍNA DE INSECTO"
  },
  {
    "codigo":677711000119105,
    "descripcion":"PERIVASCULITIS RETINIANA BILATERAL"
  },
  {
    "codigo":290203009,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR FENTANILO"
  },
  {
    "codigo":124528002,
    "descripcion":"DEFICIENCIA DE IMP CICLOHIDROLASA"
  },
  {
    "codigo":26224003,
    "descripcion":"INTENTO FALLIDO DE ABORTO COMPLICADO POR INFECCIÓN GENITOPÉLVICA"
  },
  {
    "codigo":1236805005,
    "descripcion":"SÍNDROME NEURODEGENERATIVO ASOCIADO A LA PROTEÍNA MITOCONDRIAL ENOIL COENZIMA A REDUCTASA"
  },
  {
    "codigo":1204037006,
    "descripcion":"SEPSIS POSTERIOR A INTERRUPCIÓN INDUCIDA DE EMBARAZO"
  },
  {
    "codigo":286533007,
    "descripcion":"INCAPAZ DE PREPARAR LOS ALIMENTOS HIGIÉNICAMENTE"
  },
  {
    "codigo":186394003,
    "descripcion":"ACTINOMICOSIS DEL CIEGO"
  },
  {
    "codigo":1234970004,
    "descripcion":"TRASTORNO FETAL DEBIDO A TROMBOSIS DE CORDÓN UMBILICAL"
  },
  {
    "codigo":282863005,
    "descripcion":"DIFICULTAD PARA MANTENERSE SENTADO"
  },
  {
    "codigo":20719006,
    "descripcion":"COLESTASIS EXTRAHEPÁTICA"
  },
  {
    "codigo":250095008,
    "descripcion":"RODILLA EN VALGO ASIMÉTRICA"
  },
  {
    "codigo":1296836000,
    "descripcion":"HIPERTENSIÓN OCULAR DE OJO IZQUIERDO DEBIDA A HEMÓLISIS POSTERIOR A HEMORRAGIA INTRAOCULAR"
  },
  {
    "codigo":1264068000,
    "descripcion":"CARCINOMA LINFOEPITELIAL METASTÁSICO"
  },
  {
    "codigo":444868004,
    "descripcion":"SUDORACIÓN ASIMÉTRICA"
  },
  {
    "codigo":248260009,
    "descripcion":"NO SE RECUPERA CON EL SUEÑO"
  },
  {
    "codigo":770713003,
    "descripcion":"ALERGIA A FACTOR DE COAGULACIÓN V"
  },
  {
    "codigo":49817004,
    "descripcion":"DIABETES MELLITUS NEONATAL"
  },
  {
    "codigo":15214001,
    "descripcion":"ROSARIO COSTAL"
  },
  {
    "codigo":277358001,
    "descripcion":"TEMBLORES POR HALOTANO"
  },
  {
    "codigo":1293166002,
    "descripcion":"NEOPLASIA MALIGNA DE ESTRUCTURA DE NERVIO AUDITIVO"
  },
  {
    "codigo":1260398005,
    "descripcion":"DISTONÍA DEBIDA A HOMOCISTINURIA"
  },
  {
    "codigo":13379001,
    "descripcion":"INTOXICACIÓN POR EUPHORBIA MAURITANICA"
  },
  {
    "codigo":406595002,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOPLASMA PNEUMONIAE"
  },
  {
    "codigo":111683002,
    "descripcion":"LESIÓN TRAUMÁTICA DE DUODENO SIN HERIDA ABIERTA HACIA CAVIDAD ABDOMINAL"
  },
  {
    "codigo":209987007,
    "descripcion":"HEMORRAGIA SUBDURAL TRAUMÁTICA INTRACRANEAL"
  },
  {
    "codigo":765208002,
    "descripcion":"TRASTORNO EN REMISIÓN COMPLETA"
  },
  {
    "codigo":371992003,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL TRACTO INTESTINAL"
  },
  {
    "codigo":77080005,
    "descripcion":"QUERATOCONJUNTIVITIS NEUROTRÓFICA"
  },
  {
    "codigo":239085000,
    "descripcion":"DISCROMATOSIS SIMÉTRICA DE LAS EXTREMIDADES"
  },
  {
    "codigo":1254893000,
    "descripcion":"ONICODISPLASIA CONGÉNITA AISLADA"
  },
  {
    "codigo":1156589002,
    "descripcion":"LESIÓN DE DORSO DE TRONCO"
  },
  {
    "codigo":370157003,
    "descripcion":"IDIOMA PRINCIPAL HABLADO"
  },
  {
    "codigo":402925001,
    "descripcion":"ERISIPELA DE MIEMBRO INFERIOR"
  },
  {
    "codigo":271853005,
    "descripcion":"DOLOR HIPOCONDRIAL"
  },
  {
    "codigo":109848009,
    "descripcion":"NEOPLASIA SUPERPUESTA MALIGNA DEL PÁNCREAS"
  },
  {
    "codigo":763373005,
    "descripcion":"PARAPLEJÍA ESPÁSTICA AUTOSÓMICA RECESIVA TIPO 5A"
  },
  {
    "codigo":237250000,
    "descripcion":"MOLA HIDATIFORME PARCIAL"
  },
  {
    "codigo":1287661008,
    "descripcion":"TUMOR NEUROENDOCRINO BIEN DIFERENCIADO PRIMARIO MALIGNO DE APÉNDICE"
  },
  {
    "codigo":302786005,
    "descripcion":"ANTICUERPO HETERÓFILO NO DETECTADO POR PRUEBA DE MONOSPOT"
  },
  {
    "codigo":204482005,
    "descripcion":"VÁRICE CONGÉNITA"
  },
  {
    "codigo":73410007,
    "descripcion":"HIPERTENSIÓN ARTERIAL VASCULORRENAL SECUNDARIA BENIGNA"
  },
  {
    "codigo":827074008,
    "descripcion":"CONJUNTIVITIS CAUSADA POR FÁRMACO"
  },
  {
    "codigo":1187522009,
    "descripcion":"DEFICIENCIA DE PEX26"
  },
  {
    "codigo":169879004,
    "descripcion":"PERÍMETRO CEFÁLICO AL NACER: ENTRE PERCENTILOS 10 Y 24"
  },
  {
    "codigo":366487008,
    "descripcion":"HALLAZGO RELACIONADO CON LA AMPLITUD DE MOVIMIENTO PASIVO DE ROTACIÓN INTERNA DE HOMBRO"
  },
  {
    "codigo":725100001,
    "descripcion":"DISPLASIA CRANEOLENTICULOSUTURAL"
  },
  {
    "codigo":397420007,
    "descripcion":"FIEBRE DEL NILO OCCIDENTAL SIN ENCEFALITIS"
  },
  {
    "codigo":723265000,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE ANO"
  },
  {
    "codigo":102508009,
    "descripcion":"NIÑA SANA"
  },
  {
    "codigo":67905004,
    "descripcion":"INSUFICIENCIA RESPIRATORIA CRÓNICA REAGUDIZADA"
  },
  {
    "codigo":788801007,
    "descripcion":"ALERGIA A CARNE BOVINA DEBIDA A SÍNDROME DE ALFA-GALACTOSIDASA"
  },
  {
    "codigo":721430005,
    "descripcion":"LESIÓN COMPLETA DE MÉDULA ESPINAL AL NIVEL DEL PRIMER SEGMENTO DORSAL"
  },
  {
    "codigo":262678008,
    "descripcion":"LARINGITIS POSTERIOR A RADIOTERAPIA"
  },
  {
    "codigo":295446008,
    "descripcion":"SOBREDOSIS INTENCIONAL DE LACTULOSA"
  },
  {
    "codigo":719595002,
    "descripcion":"SÍNDROME DE AUSENCIA DE HUELLAS DIGITALES CON MILIO CONGÉNITO"
  },
  {
    "codigo":64235006,
    "descripcion":"ETANOLAMINOSIS"
  },
  {
    "codigo":129771006,
    "descripcion":"PUNTOS DE REFERENCIA EN LA MAMOGRAFÍA"
  },
  {
    "codigo":293611008,
    "descripcion":"ALERGIA A ACEMETACINA"
  },
  {
    "codigo":29632002,
    "descripcion":"ATRESIA DE LA FARINGE"
  },
  {
    "codigo":816064003,
    "descripcion":"PULSO EN ARTERIA PEDIA DERECHA NORMAL"
  },
  {
    "codigo":226240003,
    "descripcion":"DIETA DE LOS ADVENTISTAS DEL SÉPTIMO DÍA"
  },
  {
    "codigo":10301000132102,
    "descripcion":"CANTIDAD MENOR DE TINCIÓN RESIDUAL, PEQUEÑOS FRAGMENTOS DE HECES Y\/O LÍQUIDO OPACO, PERO LA MUCOSA DEL SEGMENTO COLÓNICO SE VISUALIZA SATISFATORIAMENTE"
  },
  {
    "codigo":717760006,
    "descripcion":"SÍNDROME NEFRÓTICO RESISTENTE A MÚLTIPLES FÁRMACOS"
  },
  {
    "codigo":95168008,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL TRACTO UVEAL"
  },
  {
    "codigo":93333002,
    "descripcion":"POSICIÓN ANÓMALA CONGÉNITA DE VÉRTEBRA LUMBAR"
  },
  {
    "codigo":16054711000119107,
    "descripcion":"ESOTROPÍA INFANTIL DE OJO DERECHO"
  },
  {
    "codigo":224405004,
    "descripcion":"NO VISUALIZACIÓN DE LA VESÍCULA"
  },
  {
    "codigo":715925005,
    "descripcion":"CAPAZ DE COMPRENDER EL TIEMPO"
  },
  {
    "codigo":381521000119102,
    "descripcion":"HEMORRAGIA DEBIDA A CISTOSTOMÍA Y POSTERIOR A ELLA"
  },
  {
    "codigo":124266003,
    "descripcion":"DEFICIENCIA DE MALTOSA FOSFORILASA"
  },
  {
    "codigo":286271000,
    "descripcion":"UTILIZA ARTICULACIÓN SECUNDARIA"
  },
  {
    "codigo":1303914009,
    "descripcion":"MIELOSQUISIS DORSAL LIMITADA NO SACULAR"
  },
  {
    "codigo":187967002,
    "descripcion":"NEOPLASIA MALIGNA DEL CALCÁNEO"
  },
  {
    "codigo":253503002,
    "descripcion":"CUERDAS TENDINOSAS DE VÁLVULA AURICULOVENTRICULAR IZQUIERDA EXCESIVAMENTE LARGAS"
  },
  {
    "codigo":417343009,
    "descripcion":"SHOCK VASOGÉNICO"
  },
  {
    "codigo":251668005,
    "descripcion":"TRAZADO CARDIOTOCOGRÁFICO REACTIVO"
  },
  {
    "codigo":87828008,
    "descripcion":"INSUFICIENCIA"
  },
  {
    "codigo":415508008,
    "descripcion":"ASTIGMATISMO SECUNDARIO"
  },
  {
    "codigo":315369003,
    "descripcion":"NACIDO EN ANGOLA"
  },
  {
    "codigo":249833004,
    "descripcion":"HALLAZGO RELACIONADO CON MEDICIONES MUSCULOESQUELÉTICAS"
  },
  {
    "codigo":85993006,
    "descripcion":"CONTRACCIÓN CALICIAL RENAL"
  },
  {
    "codigo":774121006,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE MANO DERECHA"
  },
  {
    "codigo":446441007,
    "descripcion":"QUISTE EPIDERMOIDE DE PIEL DE MEJILLA"
  },
  {
    "codigo":444606000,
    "descripcion":"ATROFIA DE MÚSCULO ESQUELÉTICO DE LA PELVIS"
  },
  {
    "codigo":870590002,
    "descripcion":"INSUFICIENCIA RESPIRATORIA HIPOXÉMICA AGUDA DEBIDA A COVID-19"
  },
  {
    "codigo":282601007,
    "descripcion":"INCAPAZ DE SALTAR"
  },
  {
    "codigo":247998003,
    "descripcion":"INTIMIDACIÓN EMOCIONAL"
  },
  {
    "codigo":442771000,
    "descripcion":"ESTUDIO DE FUNCIÓN RETINIANA, ANORMAL"
  },
  {
    "codigo":49555001,
    "descripcion":"INMUNODEFICIENCIA COMBINADA SEVERA POR AUSENCIA DEL RECEPTOR DE CÉLULAS T"
  },
  {
    "codigo":82323002,
    "descripcion":"SÍFILIS CONGÉNITA TARDÍA (2 AÑOS O MÁS)"
  },
  {
    "codigo":34741000087101,
    "descripcion":"LACTICASEIBACILLUS CASEI O LACTICASEIBACILLUS PARACASEI O LACTICASEIBACILLUS RHAMNOSUS"
  },
  {
    "codigo":55221000087102,
    "descripcion":"PÉRDIDA DE AUTONOMÍA FUNCIONAL EN ACTIVIDADES DE LA VIDA DIARIA"
  },
  {
    "codigo":47541000087102,
    "descripcion":"FRACTURA BIMALEOLAR DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":39861000087105,
    "descripcion":"HEMATOMA DE TALÓN DERECHO"
  },
  {
    "codigo":440936003,
    "descripcion":"VIRUS RESISTENTE A AMANTADINA PRESENTE"
  },
  {
    "codigo":42421000087108,
    "descripcion":"LESIÓN TRAUMÁTICA DE TENDÓN DE AQUILES DERECHO"
  },
  {
    "codigo":211560007,
    "descripcion":"LESIÓN TRAUMÁTICA ABIERTA POR APLASTAMIENTO, REGIÓN CLAVICULAR"
  },
  {
    "codigo":735848009,
    "descripcion":"LUXACIÓN TRAUMÁTICA POSTERIOR DE ARTICULACIÓN TIBIOFEMORAL"
  },
  {
    "codigo":766781004,
    "descripcion":"VENTILACIÓN DE LA VÍA AÉREA SUPRAGLÓTICA DIFÍCIL"
  },
  {
    "codigo":209725006,
    "descripcion":"SECCIÓN EXPUESTA DE LIGAMENTO LUMBOSACRO"
  },
  {
    "codigo":734013007,
    "descripcion":"SEPARACIÓN DE DIENTES ANTERIORES"
  },
  {
    "codigo":240658000,
    "descripcion":"ENFERMEDAD DE CHAGAS CRÓNICA"
  },
  {
    "codigo":11282001,
    "descripcion":"HOMOCISTINURIA"
  },
  {
    "codigo":764946008,
    "descripcion":"SÍNDROME CONSTITUCIONAL DE DESAJUSTE DE LA REPARACIÓN CON DEFICIENCIA"
  },
  {
    "codigo":238823000,
    "descripcion":"ESTRÍAS PATOLÓGICAS"
  },
  {
    "codigo":109586009,
    "descripcion":"EROSIÓN DENTAL POR PRÁCTICAS ORALES DELETÉREAS"
  },
  {
    "codigo":9447003,
    "descripcion":"MARCHA ESPÁSTICA"
  },
  {
    "codigo":271591004,
    "descripcion":"COMPLETAMENTE CONSCIENTE"
  },
  {
    "codigo":402663007,
    "descripcion":"VASCULITIS PUSTULAR"
  },
  {
    "codigo":1287399008,
    "descripcion":"HERIDA POR ARMA DE FUEGO DE MUSLO"
  },
  {
    "codigo":366225000,
    "descripcion":"ANGULACIÓN DE DIENTE INCISIVO - HALLAZGO"
  },
  {
    "codigo":7612009,
    "descripcion":"PRESENCIA DE TRASTORNO FUNCIONAL, INVESTIGACIÓN NEGATIVA"
  },
  {
    "codigo":300689003,
    "descripcion":"INCAPAZ DE MANEJAR DINERO"
  },
  {
    "codigo":398993007,
    "descripcion":"ALTERACIÓN DE ARTICULACIÓN"
  },
  {
    "codigo":202385007,
    "descripcion":"DERRAME DE ARTICULACIÓN ASTRAGALONAVICULAR"
  },
  {
    "codigo":69478001,
    "descripcion":"DEFICIENCIA DE COLIPASA PANCREÁTICA"
  },
  {
    "codigo":298854003,
    "descripcion":"ARTICULACIÓN DE HOMBRO INESTABLE"
  },
  {
    "codigo":428091000,
    "descripcion":"INFECCIÓN CRÓNICA DE LA VÍA URINARIA INFERIOR"
  },
  {
    "codigo":2107001,
    "descripcion":"ANISOMELIA"
  },
  {
    "codigo":724838009,
    "descripcion":"SÍNDROME DE DESCAMACIÓN CUTÁNEA HEREDITARIA"
  },
  {
    "codigo":723003004,
    "descripcion":"LIQUEN PLANO ERUPTIVO AGUDO"
  },
  {
    "codigo":34875004,
    "descripcion":"ELEVACIÓN DE UNA COLONIA BACTERIANA, SOBREELEVADA"
  },
  {
    "codigo":297019007,
    "descripcion":"SOBREDOSIS INTENCIONAL DE FUROSEMIDA"
  },
  {
    "codigo":229648004,
    "descripcion":"VOZ TRAQUEOESOFÁGICA"
  },
  {
    "codigo":721168004,
    "descripcion":"HIDRONEFROSIS CONGÉNITA DEBIDA A OBSTRUCCIÓN DE UNIÓN URETEROPÉLVICA"
  },
  {
    "codigo":196880006,
    "descripcion":"HERNIA EPIGÁSTRICA CON GANGRENA"
  },
  {
    "codigo":295184007,
    "descripcion":"SOBREDOSIS DE MORFINA"
  },
  {
    "codigo":293349003,
    "descripcion":"REACCIÓN ADVERSA A LA TROMBOPLASTINA"
  },
  {
    "codigo":162277006,
    "descripcion":"VE RESPLANDORES"
  },
  {
    "codigo":63973006,
    "descripcion":"SEDUCCIÓN FEMENINA"
  },
  {
    "codigo":1145317008,
    "descripcion":"FILTRO LARGO"
  },
  {
    "codigo":15676601000119102,
    "descripcion":"TENDINITIS DE TENDÓN EXTENSOR DE MANO IZQUIERDA"
  },
  {
    "codigo":291514004,
    "descripcion":"INTOXICACIÓN POR ESPECTINOMICINA"
  },
  {
    "codigo":93071000,
    "descripcion":"HIPERTROFIA CONGÉNITA DEL PULMÓN"
  },
  {
    "codigo":224143005,
    "descripcion":"VIVE CON LA ABUELA"
  },
  {
    "codigo":289679007,
    "descripcion":"HALLAZGO RELACIONADO CON EL TAMAÑO DEL ÚTERO GRÁVIDO"
  },
  {
    "codigo":1141647009,
    "descripcion":"ENDOCARDITIS INFECCIOSA DE VÁLVULA CARDÍACA CON VEGETACIONES"
  },
  {
    "codigo":58468006,
    "descripcion":"FACTOR DE COLICINA"
  },
  {
    "codigo":418916008,
    "descripcion":"QUERATITIS INTRAUTERINA"
  },
  {
    "codigo":713828009,
    "descripcion":"AL CUIDADO DE SERVICIO DE ATENCIÓN DE ADULTOS"
  },
  {
    "codigo":124004009,
    "descripcion":"GALACTOSA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1269049001,
    "descripcion":"GLIOBLASTOMA GIGANTOCELULAR DE SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":253241005,
    "descripcion":"DISTOPIA DE ÓRBITA"
  },
  {
    "codigo":286009006,
    "descripcion":"CAPAZ DE ENCENDER UN ARTEFACTO ELECTRODOMÉSTICO"
  },
  {
    "codigo":417081007,
    "descripcion":"MOVIMIENTO ANTERIOR SISTÓLICO DE VÁLVULA MITRAL"
  },
  {
    "codigo":251406000,
    "descripcion":"PRUEBAS DEL ALIENTO - HALLAZGO"
  },
  {
    "codigo":710158004,
    "descripcion":"ALERGIA A RAÍZ DE LIRIO"
  },
  {
    "codigo":54798007,
    "descripcion":"ÚLCERA GASTROYEYUNAL CON HEMORRAGIA, PERFORACIÓN Y OBSTRUCCIÓN"
  },
  {
    "codigo":216803000,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR MANGANESO Y\/O COMPUESTO DE MANGANESO"
  },
  {
    "codigo":249571004,
    "descripcion":"BAZO - HALLAZGO"
  },
  {
    "codigo":280504001,
    "descripcion":"ESTENOSIS DE TROMPA DE FALOPIO"
  },
  {
    "codigo":870328002,
    "descripcion":"ERUPCIÓN PAPULAR PRURIGINOSA DE PIEL DEBIDA A INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":540941000124101,
    "descripcion":"MASA DE COLUMNA VERTEBRAL CERVICAL"
  },
  {
    "codigo":1263544006,
    "descripcion":"HIPOTENSIÓN INTRACRANEAL DEBIDA A OTORREA DE LÍQUIDO CEFALORRAQUÍDEO"
  },
  {
    "codigo":247736007,
    "descripcion":"ALUCINACIÓN DE EMITIR OLOR"
  },
  {
    "codigo":213133000,
    "descripcion":"DISPOSITIVO PROTÉSICO INTERNO QUE PROVOCA HEMORRAGIA"
  },
  {
    "codigo":651021000124108,
    "descripcion":"INODORO FUNCIONANTE EN DOMICILIO"
  },
  {
    "codigo":278669007,
    "descripcion":"DIENTE INCISIVO QUE PROTRUYE HACIA ATRÁS"
  },
  {
    "codigo":735586009,
    "descripcion":"EROSIÓN AURICULAR CAUSADA POR DISPOSITIVO IMPLANTADO DESPUÉS DE OPERACIÓN EN AURÍCULA"
  },
  {
    "codigo":45623002,
    "descripcion":"GLAUCOMA DEBIDO A ANOMALÍA DE SEGMENTO ANTERIOR"
  },
  {
    "codigo":15951341000119104,
    "descripcion":"MELANOMA IN SITU DE PIEL DE MAMA IZQUIERDA"
  },
  {
    "codigo":209463004,
    "descripcion":"ESGUINCE CARPOMETACARPIANO"
  },
  {
    "codigo":897591005,
    "descripcion":"DISPLASIA CONGÉNITA DE VESTÍBULO DE LA OREJA"
  },
  {
    "codigo":307767006,
    "descripcion":"INFARTO DEL HEMISFERIO CEREBRAL DERECHO"
  },
  {
    "codigo":1290807007,
    "descripcion":"SARCOMA DE CÉLULAS FUSIFORMES INDIFERENCIADO"
  },
  {
    "codigo":406071008,
    "descripcion":"TUMOR QUE COMPROMETE EN FORMA DIFUSA A AMBOS OVARIOS, NO PUEDE DETERMINARSE LA LOCALIZACIÓN DE TUMOR PRIMARIO"
  },
  {
    "codigo":404236003,
    "descripcion":"ENCEFALITIS POR VIRUS SNOWSHOE HARE"
  },
  {
    "codigo":240396006,
    "descripcion":"ERISIPELOIDE CUTÁNEO DISEMINADO"
  },
  {
    "codigo":109324008,
    "descripcion":"OSTEOMIELITIS ESCLEROSANTE CRÓNICA NO SUPURATIVA DE ESFENOIDES"
  },
  {
    "codigo":76556008,
    "descripcion":"SÍNDROME DE HIPERFOSFATASA - OSTEOECTASIA"
  },
  {
    "codigo":402401003,
    "descripcion":"ANGIOEDEMA AUTOINMUNITARIO"
  },
  {
    "codigo":369633005,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA DE VAGINA Y VEJIGA, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":238561006,
    "descripcion":"PODOPÓNFOLIX CRÓNICO"
  },
  {
    "codigo":16006791000119102,
    "descripcion":"ARTRITIS REACTIVA DE ARTICULACIÓN DE AMBAS MANOS"
  },
  {
    "codigo":105654000,
    "descripcion":"ENFERMEDAD CAUSADA POR CRYPTOSPORIDIIDAE"
  },
  {
    "codigo":1186998004,
    "descripcion":"MONONUCLEOSIS INFECCIOSA POR VIRUS DEL HERPES HUMANO 6"
  },
  {
    "codigo":236726005,
    "descripcion":"MIGRACIÓN DE STENT URINARIO"
  },
  {
    "codigo":7350007,
    "descripcion":"FÍSTULA VESICOURETRAL"
  },
  {
    "codigo":267659002,
    "descripcion":"ESCLERITIS Y EPIESCLERITIS"
  },
  {
    "codigo":300427007,
    "descripcion":"RESONANCIA ABDOMINAL NORMAL"
  },
  {
    "codigo":365963009,
    "descripcion":"EROTISMO - HALLAZGO"
  },
  {
    "codigo":167520001,
    "descripcion":"SUSTANCIAS REDUCTORAS NO DETECTADAS EN ORINA"
  },
  {
    "codigo":202123009,
    "descripcion":"DESGARRO PARCIAL ANTIGUO DEL LIGAMENTO CRUZADO POSTERIOR"
  },
  {
    "codigo":36448002,
    "descripcion":"ENFERMEDAD POR EL VIRUS GUAROA"
  },
  {
    "codigo":724576005,
    "descripcion":"EPILEPSIA DEPENDIENTE DE FOSFATO DE 5-PIRIDOXAL"
  },
  {
    "codigo":429664005,
    "descripcion":"FRACTURA DE APÓFISIS POSTERIOR DEL ASTRÁGALO"
  },
  {
    "codigo":1052256004,
    "descripcion":"CRIPTORQUIDIA ADQUIRIDA DE TESTÍCULO IZQUIERDO"
  },
  {
    "codigo":69216008,
    "descripcion":"TALASEMIA HB LEPORE"
  },
  {
    "codigo":1845001,
    "descripcion":"PARAPARESIA"
  },
  {
    "codigo":198453001,
    "descripcion":"INFERTILIDAD TUBARIA SECUNDARIA"
  },
  {
    "codigo":165685003,
    "descripcion":"RECUENTO DE RETICULOCITOS FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":3680009,
    "descripcion":"MONOCÉFALO TRIPUS DIBRAQUIO"
  },
  {
    "codigo":1148725007,
    "descripcion":"SOBREDOSIS DE CORTICOSTEROIDE Y\/O DERIVADO DE CORTICOSTEROIDE"
  },
  {
    "codigo":131082001,
    "descripcion":"CORTISONA ANORMAL"
  },
  {
    "codigo":460597009,
    "descripcion":"ARTERIA COLATERAL QUE DERIVA EL FLUJO SISTÉMICO HACIA LA CIRCULACIÓN PULMONAR QUE CONECTA CON ARTERIAS TRAQUEOBRONQUIALES"
  },
  {
    "codigo":293087000,
    "descripcion":"REACCIÓN ADVERSA AL CARBARILO"
  },
  {
    "codigo":194783001,
    "descripcion":"HIPERTENSIÓN ARTERIAL RENOVASCULAR MALIGNA SECUNDARIA"
  },
  {
    "codigo":782772000,
    "descripcion":"DISTROFIA MUSCULAR CONGÉNITA CON DISCAPACIDAD INTELECTUAL Y EPILEPSIA SEVERA"
  },
  {
    "codigo":63711009,
    "descripcion":"SÍNDROME DE BRAQUIDACTILIA TIPO E"
  },
  {
    "codigo":11310881000119106,
    "descripcion":"FRACTURA NO EXPUESTA DE SEGUNDA VÉRTEBRA LUMBAR"
  },
  {
    "codigo":94644007,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL TRAPECIO"
  },
  {
    "codigo":289417008,
    "descripcion":"FONTANELA POSTERIOR PALPABLE POR VÍA VAGINAL"
  },
  {
    "codigo":715401008,
    "descripcion":"CIRROSIS BILIAR PRIMARIA CONCOMITANTE CON ESCLERODERMIA SISTÉMICA"
  },
  {
    "codigo":713566001,
    "descripcion":"FALTA DE INTERÉS"
  },
  {
    "codigo":307131000119102,
    "descripcion":"ARTRITIS ENTEROPÁTICA DE ARTICULACIÓN DE RODILLA IZQUIERDA"
  },
  {
    "codigo":1303390007,
    "descripcion":"FRACTURA DE HUESO DE ANTEBRAZO IZQUIERDO"
  },
  {
    "codigo":90974009,
    "descripcion":"SALMONELOSIS (EXCEPTO FIEBRE TIFOIDEA HUMANA Y LA PARATIFOIDEA)"
  },
  {
    "codigo":285747002,
    "descripcion":"ALUCINACIONES FORMADAS: OBJETOS"
  },
  {
    "codigo":16014671000119100,
    "descripcion":"OCLUSIÓN DE ARTERIA FEMORAL IZQUIERDA"
  },
  {
    "codigo":1084751000119101,
    "descripcion":"DISFUNCIÓN VELOFARÍNGEA ADQUIRIDA LIMÍTROFE"
  },
  {
    "codigo":296271000119100,
    "descripcion":"TRASTORNO DE LIGAMENTO DE PIE"
  },
  {
    "codigo":91471000119102,
    "descripcion":"HIPERSOMNIA MEDICAMENTOSA"
  },
  {
    "codigo":16260431000119104,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE PARTES BLANDAS DE HOMBRO DERECHO"
  },
  {
    "codigo":21768001,
    "descripcion":"RESPUESTA TERAPÉUTICA, REGULAR"
  },
  {
    "codigo":16055631000119106,
    "descripcion":"TRASTORNO DE SISTEMA CARDIOVASCULAR CONCOMITANTE CON SÍNDROME DE MARFAN Y DEBIDO A ÉL"
  },
  {
    "codigo":367951000119106,
    "descripcion":"ESTRECHEZ URETRAL ANTERIOR DE ORIGEN TRAUMÁTICO"
  },
  {
    "codigo":10630991000119108,
    "descripcion":"LINFANGITIS AGUDA DE RODILLA DERECHA"
  },
  {
    "codigo":10943311000119108,
    "descripcion":"CONTUSIÓN DE CEREBRO DERECHO"
  },
  {
    "codigo":809087311000119106,
    "descripcion":"PORTADOR DE MIOPATÍA NEMALÍNICA RELACIONADA A NEBULINA"
  },
  {
    "codigo":10756431000119109,
    "descripcion":"ANSIEDAD POSPARTO"
  },
  {
    "codigo":127311000119106,
    "descripcion":"SEPSIS CAUSADA POR MENINGOCOCO"
  },
  {
    "codigo":413149001,
    "descripcion":"CONSENTIMIENTO INFORMADO PARA AUDITORÍA NACIONAL"
  },
  {
    "codigo":15978831000119108,
    "descripcion":"TRASTORNO DE RAÍZ DE NERVIO CERVICAL DERECHO"
  },
  {
    "codigo":15999311000119108,
    "descripcion":"CICATRICES EN AMBAS CÓRNEAS"
  },
  {
    "codigo":314845004,
    "descripcion":"ESTADO DE PARTICIPACIÓN DEL PACIENTE"
  },
  {
    "codigo":118237005,
    "descripcion":"HALLAZGO NASAL"
  },
  {
    "codigo":183773006,
    "descripcion":"INSCRIPTO EN LISTA DE ADMISIÓN NEUROLÓGICA"
  },
  {
    "codigo":85469005,
    "descripcion":"NEUMONÍA HIPOSTÁSICA"
  },
  {
    "codigo":871901008,
    "descripcion":"TELANGIECTASIA ADQUIRIDA DE INTESTINOS DELGADO Y GRUESO"
  },
  {
    "codigo":1197746001,
    "descripcion":"LIPODISTROFIA PARCIAL FAMILIAR ASOCIADA A GEN AKT SERINA\/TREONINA QUINASA 2"
  },
  {
    "codigo":216541004,
    "descripcion":"INTOXICACIÓN ACCIDENTAL CAUSADA POR MEPROBAMATO"
  },
  {
    "codigo":305587005,
    "descripcion":"BAJO ATENCIÓN DE OBSTÉTRICA EXTRAHOSPITALARIA"
  },
  {
    "codigo":282077009,
    "descripcion":"LACERACIÓN ANAL"
  },
  {
    "codigo":50866000,
    "descripcion":"EPILEPSIA DE AUSENCIA EN LA NIÑEZ"
  },
  {
    "codigo":737159004,
    "descripcion":"ANEURISMA DE ARTERIA BASILAR"
  },
  {
    "codigo":1163143005,
    "descripcion":"COLITIS CAUSADA POR CAMPYLOBACTER"
  },
  {
    "codigo":276572003,
    "descripcion":"IMPULSO RESPIRATORIO INSUFICIENTE"
  },
  {
    "codigo":211036004,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DEL TRONCO"
  },
  {
    "codigo":1259612006,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE GLÁNDULA DE MOLL"
  },
  {
    "codigo":405809000,
    "descripcion":"APRAXIA OCULAR MOTORA TIPO COGAN"
  },
  {
    "codigo":373041000,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM MADAGASCARIENSE"
  },
  {
    "codigo":733489002,
    "descripcion":"MIOPATÍA DISTAL CON COMPROMISO DE CARA POSTERIOR DE PIERNA Y CARA ANTERIOR DE MANO"
  },
  {
    "codigo":209201002,
    "descripcion":"SUBLUXACIÓN NO EXPUESTA DEL CÓCCIX"
  },
  {
    "codigo":45361006,
    "descripcion":"ENCARCELACIÓN"
  },
  {
    "codigo":698886001,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: ASAMÉS"
  },
  {
    "codigo":78129009,
    "descripcion":"PÚRPURA TROMBOCITOPÉNICA TROMBÓTICA"
  },
  {
    "codigo":240134003,
    "descripcion":"TRASTORNO DE HUESO Y CARTÍLAGO ARTICULAR"
  },
  {
    "codigo":241969009,
    "descripcion":"HIPOTERMIA ACCIDENTAL EN PERSONA ANCIANA"
  },
  {
    "codigo":403974005,
    "descripcion":"MIOPERICITOMA DE PIEL"
  },
  {
    "codigo":305670001,
    "descripcion":"ATENDIDO POR UN DERMATÓLOGO"
  },
  {
    "codigo":402139000,
    "descripcion":"DERMATOSIS CAUSADA POR PARÁSITO"
  },
  {
    "codigo":762587000,
    "descripcion":"URANOESTAFILOSQUISIS CON LABIO LEPORINO IZQUIERDO Y FISURA ALVEOLAR IZQUIERDA"
  },
  {
    "codigo":860891005,
    "descripcion":"PÓLIPO HIPERPLÁSICO DE ESÓFAGO"
  },
  {
    "codigo":1286875007,
    "descripcion":"CON MAYOR RIESGO DE EMBARAZO NO PLANEADO"
  },
  {
    "codigo":10959241000119100,
    "descripcion":"HERIDA ABIERTA DE MUÑECA DERECHA"
  },
  {
    "codigo":302000008,
    "descripcion":"SE MUEVE"
  },
  {
    "codigo":269232009,
    "descripcion":"QUEMADURA CIRCUNSCRIPTA A OJO Y ANEXOS OCULARES"
  },
  {
    "codigo":365701002,
    "descripcion":"HALLAZGO RELACIONADO CON EL CRECIMIENTO DE VIRUS"
  },
  {
    "codigo":236464008,
    "descripcion":"HIPOALDOSTERONISMO HIPORRENINÉMICO"
  },
  {
    "codigo":1217669004,
    "descripcion":"CONJUNTIVITIS PAPILAR VERNAL CRÓNICA"
  },
  {
    "codigo":38021004,
    "descripcion":"INTOXICACIÓN POR HEXACLOROFENO"
  },
  {
    "codigo":431237007,
    "descripcion":"TRASTORNO DE CEFALEA CRÓNICA"
  },
  {
    "codigo":298330000,
    "descripcion":"HALLAZGO RELACIONADO CON LA RESPUESTA MOTRIZ"
  },
  {
    "codigo":234629007,
    "descripcion":"DEFICIENCIA DEL RECEPTOR 1 DEL COMPLEMENTO"
  },
  {
    "codigo":36186002,
    "descripcion":"POLIARTROPATÍA"
  },
  {
    "codigo":462170003,
    "descripcion":"TAQUICARDIA SUPRAVENTRICULAR FETAL CON INTERVALO VENTRICULOAURICULAR PROLONGADO"
  },
  {
    "codigo":300165009,
    "descripcion":"HUESECILLOS DEL OÍDO, AUSENTES"
  },
  {
    "codigo":722479000,
    "descripcion":"POSICIÓN CERVICAL NEUTRA"
  },
  {
    "codigo":165423001,
    "descripcion":"RECUENTO DE GLÓBULOS ROJOS POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":427567003,
    "descripcion":"ÉMBOLO ATEROMATOSO DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":296495003,
    "descripcion":"SOBREDOSIS DE METOCARBAMOL"
  },
  {
    "codigo":196356001,
    "descripcion":"GINGIVITIS CRÓNICA MARGINAL"
  },
  {
    "codigo":1179396001,
    "descripcion":"HIPOTIROIDISMO CONGÉNITO DEBIDO A MUTACIÓN DE DEIODINASA TIROIDEA"
  },
  {
    "codigo":12106121000119106,
    "descripcion":"QUEMADURA DE MUÑECA DERECHA"
  },
  {
    "codigo":292825000,
    "descripcion":"REACCIÓN ADVERSA AL ITRACONAZOL"
  },
  {
    "codigo":128985003,
    "descripcion":"ANOMALÍA CONGÉNITA DEL IRIS"
  },
  {
    "codigo":784345005,
    "descripcion":"CONVULSIONES PARCIALES MIGRATORIAS MALIGNAS DE LA LACTANCIA"
  },
  {
    "codigo":225454000,
    "descripcion":"DISTORSIÓN SENSITIVA"
  },
  {
    "codigo":192686004,
    "descripcion":"POLIOENCEFALITIS"
  },
  {
    "codigo":127150004,
    "descripcion":"LINFADENOPATÍA MEDIOCÓLICA"
  },
  {
    "codigo":1306798007,
    "descripcion":"ARTERITIS DE CÉLULAS GIGANTES CRANEAL"
  },
  {
    "codigo":290990007,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ZOLPIDEM"
  },
  {
    "codigo":94382009,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE HUESO LARGO DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":289155006,
    "descripcion":"PROBLEMA CON LA INGESTA HÍDRICA"
  },
  {
    "codigo":715139006,
    "descripcion":"INCAPAZ DE PASAR DE UNA SILLA DE RUEDAS A UN INODORO"
  },
  {
    "codigo":92547008,
    "descripcion":"CARCINOMA IN SITU DEL CUERPO DEL PÁNCREAS"
  },
  {
    "codigo":711469000,
    "descripcion":"RESTAURACIÓN DENTAL BIOLÓGICAMENTE INACEPTABLE"
  },
  {
    "codigo":189016009,
    "descripcion":"LIPOMA DE CONDUCTO VERTEBRAL - INTRADURAL"
  },
  {
    "codigo":88877002,
    "descripcion":"XERODERMA PIGMENTOSO, FORMA VARIANTE"
  },
  {
    "codigo":285485003,
    "descripcion":"CAPAZ DE ESTIRAR LOS LABIOS"
  },
  {
    "codigo":338621000119101,
    "descripcion":"CORIORRETINITIS FOCAL DE POLO POSTERIOR DE OJO IZQUIERDO"
  },
  {
    "codigo":54274001,
    "descripcion":"SÍFILIS PRIMARIA DE LOS DEDOS DE LA MANO"
  },
  {
    "codigo":283650009,
    "descripcion":"HERIDA PUNZANTE POR CLAVO METÁLICO EN PIEL"
  },
  {
    "codigo":871639003,
    "descripcion":"MIOCARDIOPATÍA DILATADA DEBIDA A ENFERMEDAD MITOCONDRIAL"
  },
  {
    "codigo":609495006,
    "descripcion":"ESGUINCE DE TOBILLO DE TERCER GRADO"
  },
  {
    "codigo":1363159007,
    "descripcion":"ASTILLA EN MAMA CON INFECCIÓN"
  },
  {
    "codigo":443820000,
    "descripcion":"TRASTORNO DE RIÑÓN Y\/O URÉTER"
  },
  {
    "codigo":707799009,
    "descripcion":"RITMO CARDÍACO NO SUSCEPTIBLE A CHOQUE DETECTADO MEDIANTE DESFIBRILADOR EXTERNO AUTOMÁTICO"
  },
  {
    "codigo":279980002,
    "descripcion":"DOLOR NEURÓGENO PERIFÉRICO"
  },
  {
    "codigo":704129001,
    "descripcion":"CAPAZ DE MANEJAR ESTOMA DE UROSTOMÍA"
  },
  {
    "codigo":247212009,
    "descripcion":"VENA RETINOCILIAR"
  },
  {
    "codigo":79702003,
    "descripcion":"MONOCÉFALO TETRÁPODO DIBRAQUIO"
  },
  {
    "codigo":866134006,
    "descripcion":"INFESTACIÓN DE PÁRPADO CAUSADA POR LOA LOA"
  },
  {
    "codigo":733227000,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO DEL MANGUITO ROTADOR"
  },
  {
    "codigo":1259350009,
    "descripcion":"CARCINOMA PRIMARIO DE CARDIAS GÁSTRICO"
  },
  {
    "codigo":12331003,
    "descripcion":"GIGANTISMO POR DÉFICIT DE SOMATOSTATINA"
  },
  {
    "codigo":405547004,
    "descripcion":"ABSCESO DE MIOCARDIO"
  },
  {
    "codigo":77867006,
    "descripcion":"INTERVALO QT ACORTADO"
  },
  {
    "codigo":208939009,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE LA ARTICULACIÓN DE LA RODILLA, INTERNA"
  },
  {
    "codigo":239872002,
    "descripcion":"ARTROSIS DE CADERA"
  },
  {
    "codigo":698624003,
    "descripcion":"DEMENCIA ASOCIADA CON LIPIDOSIS CEREBRAL"
  },
  {
    "codigo":403712008,
    "descripcion":"CARCINOMA BASOCELULAR ASOCIADO CON FOTOQUIMIOTERAPIA CON PSORALENO Y RADIACIÓN ULTRAVIOLETA DE ONDA LARGA"
  },
  {
    "codigo":205269007,
    "descripcion":"MANO EN RÁFAGA"
  },
  {
    "codigo":301738000,
    "descripcion":"INCAPAZ DE REALIZAR ACTIVIDADES DE OFICINA"
  },
  {
    "codigo":762325009,
    "descripcion":"TRASTORNO PSICÓTICO CAUSADO POR ESTIMULANTE"
  },
  {
    "codigo":238037008,
    "descripcion":"TRASTORNO DEL DEPÓSITO Y METABOLISMO DE LIPOPROTEÍNAS"
  },
  {
    "codigo":400042000,
    "descripcion":"MALFORMACIÓN VASCULAR CUTÁNEA"
  },
  {
    "codigo":367601000119103,
    "descripcion":"AMILOIDOSIS HEREDITARIA"
  },
  {
    "codigo":203434006,
    "descripcion":"OSTEOPOROSIS POSQUIRÚRGICA POR MALABSORCIÓN"
  },
  {
    "codigo":234367000,
    "descripcion":"PANCITOPENIA CON PANCREATITIS"
  },
  {
    "codigo":365439006,
    "descripcion":"PH DE LA MATERIA FECAL - HALLAZGO"
  },
  {
    "codigo":103295008,
    "descripcion":"VÉRTIGO PRECEDIDO POR TRABAJO DENTAL PROLONGADO O CIRUGÍA BUCAL"
  },
  {
    "codigo":299903009,
    "descripcion":"DISCRIMINACIÓN FRÍO-CALOR REDUCIDA"
  },
  {
    "codigo":789588003,
    "descripcion":"NEUROPATÍA SENSITIVA PERIFÉRICA"
  },
  {
    "codigo":199764006,
    "descripcion":"TRABAJO DE PARTO OBSTRUIDO POR CONTRACCIÓN DE LA SALIDA PÉLVICA Y LA CAVIDAD MEDIA"
  },
  {
    "codigo":34089005,
    "descripcion":"CUATRILLIZOS RECIÉN NACIDOS PREMATUROS"
  },
  {
    "codigo":66857006,
    "descripcion":"HEMOPTISIS"
  },
  {
    "codigo":427305007,
    "descripcion":"DISPOSICIÓN PARA FORTALECER LA CAPACIDAD PARA ADOPTAR DECISIONES"
  },
  {
    "codigo":294398000,
    "descripcion":"ALERGIA A QUININA"
  },
  {
    "codigo":296233006,
    "descripcion":"SOBREDOSIS DE PROMAZINA"
  },
  {
    "codigo":292563003,
    "descripcion":"REACCIÓN ADVERSA A PUMACTANT"
  },
  {
    "codigo":718547004,
    "descripcion":"CISTOSCOPIA ANORMAL"
  },
  {
    "codigo":423635005,
    "descripcion":"VISIÓN A DISTANCIA 20\/80"
  },
  {
    "codigo":290728000,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR RAZOXANO"
  },
  {
    "codigo":716712004,
    "descripcion":"HEMOSIDEROSIS PULMONAR SECUNDARIA"
  },
  {
    "codigo":94120006,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL URACO"
  },
  {
    "codigo":126888008,
    "descripcion":"NEOPLASIA DE LA PARED LATERAL DE LA VEJIGA"
  },
  {
    "codigo":92285007,
    "descripcion":"NEOPLASIA BENIGNA DE LA PELVIS"
  },
  {
    "codigo":714877008,
    "descripcion":"MANTIENE LA POSICIÓN EN CUCLILLAS"
  },
  {
    "codigo":876882001,
    "descripcion":"FALLECIDO EN CENTRO DE CUIDADOS PALIATIVOS"
  },
  {
    "codigo":385362002,
    "descripcion":"ESTADIO DE LA FEDERACIÓN INTERNACIONAL DE GINECOLOGÍA Y OBSTETRICIA (FIGO) PARA NEOPLASIAS MALIGNAS GINECOLÓGICAS - HALLAZGO"
  },
  {
    "codigo":288893009,
    "descripcion":"DIFICULTAD PARA COMER CIERTOS ALIMENTOS"
  },
  {
    "codigo":254290004,
    "descripcion":"TRASTORNO LINFOPROLIFERATIVO POSTERIOR A TRASPLANTE"
  },
  {
    "codigo":188754005,
    "descripcion":"LEUCEMIA MEGACARIOCÍTICA"
  },
  {
    "codigo":418130002,
    "descripcion":"PROCTOCOLITIS"
  },
  {
    "codigo":55847002,
    "descripcion":"INTOXICACIÓN POR RODENTICIDA"
  },
  {
    "codigo":285223005,
    "descripcion":"INCAPAZ DE RECORDAR HABILIDADES MOTRICES PREVIAS"
  },
  {
    "codigo":416295006,
    "descripcion":"HIPERPLASIA EPITELIAL FOCAL DE PIEL"
  },
  {
    "codigo":449063007,
    "descripcion":"LINFOMA NO HODGKIN FOLICULAR DE CAVIDAD BUCAL"
  },
  {
    "codigo":54012000,
    "descripcion":"CEFALEA POSTRAUMÁTICA"
  },
  {
    "codigo":840444002,
    "descripcion":"DACRIOADENITIS DEBIDA A QUERATITIS POR ACANTHAMOEBA"
  },
  {
    "codigo":283388003,
    "descripcion":"LACERACIÓN DE ESPINILLA"
  },
  {
    "codigo":21244005,
    "descripcion":"SÍNDROME DE BORRIES"
  },
  {
    "codigo":445393004,
    "descripcion":"BLOQUEO DE RAMA DERECHA Y DE FASCÍCULO IZQUIERDO POSTERIOR EN ELECTROCARDIOGRAMA"
  },
  {
    "codigo":281553005,
    "descripcion":"SECCIÓN TRAUMÁTICA DE TENDÓN DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":248785004,
    "descripcion":"ORGASMO SIN EYACULACIÓN"
  },
  {
    "codigo":707537007,
    "descripcion":"CARCINOMA PRIMARIO DE CÉLULAS ESCAMOSAS DE SUPERFICIE ANTERIOR DE EPIGLOTIS"
  },
  {
    "codigo":246950000,
    "descripcion":"ÚLCERA MARGINAL FOCAL DE LA CÓRNEA"
  },
  {
    "codigo":771238004,
    "descripcion":"SÍNDROME PIRAMIDAL Y DE ATROFIA ESPINAL Y OFTALMOPLEJÍA"
  },
  {
    "codigo":83110007,
    "descripcion":"DESCEMETOCELE"
  },
  {
    "codigo":736635001,
    "descripcion":"PÓLIPO DE FOSA NASAL IZQUIERDA"
  },
  {
    "codigo":212347004,
    "descripcion":"LESIONES NERVIOSAS MÚLTIPLES DE LA CINTURA PÉLVICA Y MIEMBROS INFERIORES"
  },
  {
    "codigo":439888000,
    "descripcion":"EXTENDIDO CERVICAL DE PAPANICOLAOU ANORMAL"
  },
  {
    "codigo":16016831000119105,
    "descripcion":"ARTRITIS INFECCIOSA DE ARTICULACIÓN DE RODILLA IZQUIERDA CAUSADA POR VIRUS"
  },
  {
    "codigo":1259088002,
    "descripcion":"DEGENERACIÓN AUTOINMUNITARIA DE CEREBELO"
  },
  {
    "codigo":276048003,
    "descripcion":"CUIDA A DISCAPACITADOS FÍSICOS"
  },
  {
    "codigo":46672003,
    "descripcion":"PROCTITIS ASOCIADA CON HELICOBACTER"
  },
  {
    "codigo":110373000,
    "descripcion":"HIERRO DE MÉDULA ÓSEA DISMINUIDO"
  },
  {
    "codigo":208677000,
    "descripcion":"FRACTURA NO EXPUESTA DEL CALCÁNEO, EXTRARTICULAR"
  },
  {
    "codigo":274213002,
    "descripcion":"FÍSTULA POSQUIRÚRGICA"
  },
  {
    "codigo":1290021005,
    "descripcion":"TUMOR NEUROENDOCRINO BIEN DIFERENCIADO PRIMARIO DE PULMÓN"
  },
  {
    "codigo":732965007,
    "descripcion":"ANEMIA HEMOLÍTICA AUTOINMUNITARIA SECUNDARIA CONCOMITANTE CON TRASTORNO REUMÁTICO Y DEBIDA A ÉL"
  },
  {
    "codigo":403450001,
    "descripcion":"PELO BUCAL"
  },
  {
    "codigo":343641000119104,
    "descripcion":"ESCLERITIS DE AMBOS OJOS"
  },
  {
    "codigo":73935008,
    "descripcion":"ENCEFALITIS TÓXICA CAUSADA POR HIDROXIQUINOLINA"
  },
  {
    "codigo":8399009,
    "descripcion":"CONVERSIÓN DE LA REACCIÓN DE LA PRUEBA CUTÁNEA"
  },
  {
    "codigo":72100002,
    "descripcion":"LÉNTIGO SOLAR"
  },
  {
    "codigo":301476007,
    "descripcion":"NO SUPERA OBSTÁCULOS"
  },
  {
    "codigo":299641000,
    "descripcion":"ARTICULACIÓN DEL DEDO DEL PIE - TIBIA"
  },
  {
    "codigo":234105001,
    "descripcion":"FÍSTULA LINFÁTICA"
  },
  {
    "codigo":235940009,
    "descripcion":"FILTRACIÓN POR ANASTOMOSIS BILIAR"
  },
  {
    "codigo":317171000119101,
    "descripcion":"PANICULITIS LUMBAR Y SACRA"
  },
  {
    "codigo":37497004,
    "descripcion":"HIPEROXALURIA ENTÉRICA"
  },
  {
    "codigo":203172007,
    "descripcion":"OSTEOMIELITIS AGUDA DE TIBIA"
  },
  {
    "codigo":365177006,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA REALIZAR ACTIVIDADES DE COPIADO"
  },
  {
    "codigo":1348217006,
    "descripcion":"PATRÓN DE USO NOCIVO CONTINUO DE SUSTANCIAS MIXTAS SIN DEPENDENCIA"
  },
  {
    "codigo":201337008,
    "descripcion":"AMILOIDOSIS DE PIEL"
  },
  {
    "codigo":232270002,
    "descripcion":"MASTOIDITIS AGUDA CON LABERINTITIS"
  },
  {
    "codigo":363342003,
    "descripcion":"COMPLICACIÓN DEL SISTEMA VISUAL DERIVADA DE PROCEDIMIENTO"
  },
  {
    "codigo":789326003,
    "descripcion":"MOVIMIENTO DE PARED ABDOMINAL NORMAL"
  },
  {
    "codigo":263203001,
    "descripcion":"FRACTURA DE EXTREMO PROXIMAL DE CÚBITO"
  },
  {
    "codigo":295971002,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE PIRACETAM"
  },
  {
    "codigo":1059007,
    "descripcion":"INFECCIÓN POR OPISTHORCHIS"
  },
  {
    "codigo":66595008,
    "descripcion":"SÍNDROME DE NECROSIS MIOCÁRDICA MEDICAMENTOSA"
  },
  {
    "codigo":164899008,
    "descripcion":"ELECTROCARDIOGRAMA: SIN BLOQUEO CARDÍACO"
  },
  {
    "codigo":294136006,
    "descripcion":"ALERGIA A MEPIRAMINA"
  },
  {
    "codigo":31992008,
    "descripcion":"HIPERTENSIÓN ARTERIAL SECUNDARIA"
  },
  {
    "codigo":128461001,
    "descripcion":"ESCLEROSIS SISTÉMICA SIN ESCLERODERMIA"
  },
  {
    "codigo":292301002,
    "descripcion":"REACCIÓN ADVERSA A LA VENLAFAXINA"
  },
  {
    "codigo":1177037005,
    "descripcion":"ESOFAGITIS POR MICOBACTERIAS NO TUBERCULOSAS"
  },
  {
    "codigo":95693006,
    "descripcion":"RETINOPATÍA POR HIPERVISCOSIDAD"
  },
  {
    "codigo":290466001,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR ACEITE DE RICINO"
  },
  {
    "codigo":93858004,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA CARA LARÍNGEA DE LA EPIGLOTIS"
  },
  {
    "codigo":716450006,
    "descripcion":"CAPAZ DE PONERSE DE PIE DESDE LA POSICIÓN SEDENTE EN EL BORDE DE LA CAMA"
  },
  {
    "codigo":126626007,
    "descripcion":"NEOPLASIA DE MÚSCULO DEL ABDOMEN"
  },
  {
    "codigo":419703006,
    "descripcion":"ENFERMEDAD NO NEUROINVASIVA POR VIRUS DEL VALLE DE CACHE"
  },
  {
    "codigo":288631007,
    "descripcion":"NO JUEGA CON LAS PALABRAS Y LOS SIGNIFICADOS"
  },
  {
    "codigo":57420002,
    "descripcion":"ABORTO POR LISTERIA"
  },
  {
    "codigo":286796003,
    "descripcion":"CARÁCTER NO AGRESIVO"
  },
  {
    "codigo":24652004,
    "descripcion":"MARCACIONES DISMINUIDAS"
  },
  {
    "codigo":188492005,
    "descripcion":"RETICULOSARCOMA DE GANGLIOS LINFÁTICOS DE AXILA Y EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":1083431000119100,
    "descripcion":"OTITIS MEDIA SUPURATIVA CRÓNICA DE AMBOS OÍDOS MEDIOS"
  },
  {
    "codigo":90188009,
    "descripcion":"FRACASO EN LA INDUCCIÓN MECÁNICA"
  },
  {
    "codigo":22817005,
    "descripcion":"DISTENSIÓN DEL TENDÓN DE AQUILES"
  },
  {
    "codigo":416033009,
    "descripcion":"CITOLOGÍA CERVICOVAGINAL: LESIÓN INTRAEPITELIAL ESCAMOSA DE ALTO GRADO O CARCINOMA"
  },
  {
    "codigo":1004022005,
    "descripcion":"TRASTORNO FETAL DEBIDO A ENFERMEDAD RESPIRATORIA CRÓNICA MATERNA"
  },
  {
    "codigo":283126006,
    "descripcion":"AMPOLLA TRAUMÁTICA DE DEDO DE LA MANO"
  },
  {
    "codigo":709110009,
    "descripcion":"INSUFICIENCIA RESPIRATORIA AGUDA HIPERCÁPNICA"
  },
  {
    "codigo":248523006,
    "descripcion":"MASA RECTAL"
  },
  {
    "codigo":281291006,
    "descripcion":"ESPÉCIMEN MACROSCÓPICAMENTE ICTÉRICO"
  },
  {
    "codigo":445131007,
    "descripcion":"OBSTRUCCIÓN DEL TRACTO DE SALIDA DEL VENTRÍCULO IZQUIERDO POR TÚNEL FIBROMUSCULAR"
  },
  {
    "codigo":246688001,
    "descripcion":"POSICIÓN OCULAR CON CABEZA HIPEREXTENDIDA"
  },
  {
    "codigo":312224002,
    "descripcion":"EPIDIDIMITIS INFECCIOSA"
  },
  {
    "codigo":838347009,
    "descripcion":"NEUROPATÍA AUTONÓMICA DEBIDA A ENFERMEDAD DE REFSUM"
  },
  {
    "codigo":426467521000119100,
    "descripcion":"ATRAPAMIENTO DE MÚSCULO RECTO INTERNO DE OJO IZQUIERDO"
  },
  {
    "codigo":1295264007,
    "descripcion":"TUMOR DE CÉLULAS GIGANTES DE PARTES BLANDAS"
  },
  {
    "codigo":441461000,
    "descripcion":"SIGNO DE DESTOT"
  },
  {
    "codigo":310389000,
    "descripcion":"SITUACIÓN DE INFORMACIÓN DEL PARIENTE MÁS CERCANO"
  },
  {
    "codigo":111946000,
    "descripcion":"ENTIERRO EN VIDA"
  },
  {
    "codigo":1162357009,
    "descripcion":"BURSITIS VIRAL"
  },
  {
    "codigo":48245008,
    "descripcion":"ARTRITIS BACTERIANA"
  },
  {
    "codigo":243018004,
    "descripcion":"LESIÓN POR FRAGMENTO DE BOMBA AÉREA"
  },
  {
    "codigo":11807002,
    "descripcion":"LESIÓN TRAUMÁTICA A NIVEL DE C5 - C7 CON LESIÓN DE LA MÉDULA ESPINAL Y SIN LESIÓN ÓSEA"
  },
  {
    "codigo":110111004,
    "descripcion":"LACERACIÓN COMPLEJA DEL VESTÍBULO MAXILAR"
  },
  {
    "codigo":765471005,
    "descripcion":"SÍNDROME DE DISCAPACIDAD INTELECTUAL, HIPOGONADISMO, ICTIOSIS, OBESIDAD Y BAJA ESTATURA LIGADO AL CROMOSOMA X"
  },
  {
    "codigo":12198081000119105,
    "descripcion":"DEPÓSITO EN LENTE INTRAOCULAR DE OJO IZQUIERDO"
  },
  {
    "codigo":403188005,
    "descripcion":"QUEMADURA FRÍA"
  },
  {
    "codigo":42740008,
    "descripcion":"GASTRITIS ATRÓFICA DE GLÁNDULAS FÚNDICAS"
  },
  {
    "codigo":1156852009,
    "descripcion":"ENFERMEDAD DE CHARCOT-MARIE-TOOTH AUTOSÓMICA RECESIVA TIPO 2"
  },
  {
    "codigo":204745000,
    "descripcion":"AGANGLIONOSIS INTESTINAL COMPLETA"
  },
  {
    "codigo":237513002,
    "descripcion":"ANOMALÍA CONGÉNITA DE HUESO Y ARTICULACIÓN"
  },
  {
    "codigo":9972008,
    "descripcion":"DOLOR IRRADIADO"
  },
  {
    "codigo":202910003,
    "descripcion":"SINOVITIS POR ESPINA VEGETAL"
  },
  {
    "codigo":1251486007,
    "descripcion":"METÁSTASIS DE CARCINOMA DE HÍGADO"
  },
  {
    "codigo":364915000,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA PONERSE DE PIE SOLO"
  },
  {
    "codigo":235678008,
    "descripcion":"TRICOFITOBEZOAR"
  },
  {
    "codigo":37235006,
    "descripcion":"POSICIÓN OCCIPITOILÍACA POSTERIOR"
  },
  {
    "codigo":70003006,
    "descripcion":"COCOS GRAMPOSITIVOS EN GRUPOS"
  },
  {
    "codigo":233843008,
    "descripcion":"INFARTO MIOCÁRDICO SILENTE"
  },
  {
    "codigo":461384000,
    "descripcion":"TRAYECTO ANÓMALO DE ARTERIA CORONARIA A TRAVÉS DEL TRACTO DE SALIDA DEL VENTRÍCULO DERECHO"
  },
  {
    "codigo":232008001,
    "descripcion":"DESPRENDIMIENTO REGMATÓGENO DE RETINA - EN LA MÁCULA"
  },
  {
    "codigo":264776004,
    "descripcion":"ALTERACIÓN DEL VOLUMEN CIRCULATORIO"
  },
  {
    "codigo":428616007,
    "descripcion":"DISCAPACIDAD DE MIEMBRO INFERIOR"
  },
  {
    "codigo":363080007,
    "descripcion":"TRASTORNO HEREDITARIO DEL TUBO DIGESTIVO"
  },
  {
    "codigo":35400008,
    "descripcion":"HEMOCROMATOSIS HEREDITARIA"
  },
  {
    "codigo":721693001,
    "descripcion":"PÓLIPO HAMARTOMATOSO DE INTESTINO GRUESO"
  },
  {
    "codigo":295709005,
    "descripcion":"SOBREDOSIS DE TIOGUANINA"
  },
  {
    "codigo":262941008,
    "descripcion":"SECCIÓN DE ARTERIA CORONARIA"
  },
  {
    "codigo":10834421000119103,
    "descripcion":"FRACTURA EXPUESTA DE SEGUNDA FALANGE DE DEDO ÍNDICE DE MANO DERECHA"
  },
  {
    "codigo":293874007,
    "descripcion":"ALERGIA A ZOPICLONA"
  },
  {
    "codigo":95431003,
    "descripcion":"HEMORRAGIA DE VÍAS RESPIRATORIAS"
  },
  {
    "codigo":191900006,
    "descripcion":"PATRÓN DE USO EPISÓDICO NOCIVO SIN DEPENDENCIA DE ALUCINÓGENO"
  },
  {
    "codigo":93596007,
    "descripcion":"OSIFICACIÓN INCOMPLETA DE HUESO PARIETAL"
  },
  {
    "codigo":124529005,
    "descripcion":"DEFICIENCIA DE PIROFOSFATASA INORGÁNICA"
  },
  {
    "codigo":386673006,
    "descripcion":"CUMPLE CON EL TRATAMIENTO"
  },
  {
    "codigo":24390000,
    "descripcion":"NIVEL DE UROBILINÓGENO POR ENCIMA DE RANGO DE REFERENCIA"
  },
  {
    "codigo":286534001,
    "descripcion":"PREPARA LOS ALIMENTOS HIGIÉNICAMENTE"
  },
  {
    "codigo":188230001,
    "descripcion":"NEOPLASIA MALIGNA DE CUERPO DE PENE"
  },
  {
    "codigo":288369008,
    "descripcion":"CAPAZ DE PASAR OBJETOS DE UNA MANO A OTRA"
  },
  {
    "codigo":57158005,
    "descripcion":"PÓLIPO DE LA VULVA"
  },
  {
    "codigo":1236806006,
    "descripcion":"ANTEVERSIÓN CONGÉNITA DE FÉMUR PERSISTENTE"
  },
  {
    "codigo":1234971000,
    "descripcion":"TRASTORNO NEONATAL DEBIDO A TROMBOSIS DE CORDÓN UMBILICAL"
  },
  {
    "codigo":186395002,
    "descripcion":"ACTINOMICOSIS HEPÁTICA"
  },
  {
    "codigo":284699003,
    "descripcion":"DESPELLEJARSE LA PIEL"
  },
  {
    "codigo":86256001,
    "descripcion":"HEMATOMA DE CORDÓN"
  },
  {
    "codigo":282864004,
    "descripcion":"CAPAZ DE ADAPTARSE A UNA POSICIÓN"
  },
  {
    "codigo":413936007,
    "descripcion":"TRÍADA DE CURRARINO"
  },
  {
    "codigo":444869007,
    "descripcion":"HEMANGIOMA CAVERNOSO DE CEREBRO"
  },
  {
    "codigo":1264069008,
    "descripcion":"TRASTORNO FETAL CAUSADO POR TRANSFERENCIA PLACENTARIA DE DIETILESTILBESTROL"
  },
  {
    "codigo":1296837009,
    "descripcion":"HIPERTENSIÓN OCULAR HEMOLÍTICA BILATERAL"
  },
  {
    "codigo":248261008,
    "descripcion":"SE QUEDA DORMIDO"
  },
  {
    "codigo":770714009,
    "descripcion":"ALERGIA A FACTOR DE COAGULACIÓN VII"
  },
  {
    "codigo":1260399002,
    "descripcion":"DISTONÍA DEBIDA A DEFECTO EN TRANSPORTE DE AMINOÁCIDOS NEUTROS 1"
  },
  {
    "codigo":406596001,
    "descripcion":"INFECCIÓN DEL SISTEMA NERVIOSO CENTRAL POR NAEGLERIA"
  },
  {
    "codigo":111684008,
    "descripcion":"DESGARRO CAPSULAR SIN RUPTURA MAYOR DE PARÉNQUIMA ESPLÉNICO Y CON HERIDA ABIERTA EN CAVIDAD ABDOMINAL"
  },
  {
    "codigo":275524009,
    "descripcion":"NEOPLASIA INMUNOPROLIFERATIVA"
  },
  {
    "codigo":765209005,
    "descripcion":"TRASTORNO EN REMISIÓN ESPONTÁNEA"
  },
  {
    "codigo":44313006,
    "descripcion":"INSUFICIENCIA VENTRICULAR DERECHA, SECUNDARIA A INSUFICIENCIA VENTRICULAR IZQUIERDA"
  },
  {
    "codigo":402926000,
    "descripcion":"FASCITIS NECROSANTE NEONATAL"
  },
  {
    "codigo":371993008,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA GLÁNDULA LAGRIMAL"
  },
  {
    "codigo":1287662001,
    "descripcion":"TUMOR NEUROENDOCRINO BIEN DIFERENCIADO PRIMARIO DE COLON"
  },
  {
    "codigo":75246004,
    "descripcion":"PLÉTORA"
  },
  {
    "codigo":239086004,
    "descripcion":"HIPERPIGMENTACIÓN RETICULAR ZOSTERIFORME"
  },
  {
    "codigo":1254894006,
    "descripcion":"LIPIDEMA DE CUERO CABELLUDO"
  },
  {
    "codigo":763374004,
    "descripcion":"PARAPLEJÍA ESPÁSTICA AUTOSÓMICA DOMINANTE TIPO 12"
  },
  {
    "codigo":11000771000119104,
    "descripcion":"DEPENDENCIA DE DIÁLISIS PERITONEAL CÍCLICA"
  },
  {
    "codigo":1187523004,
    "descripcion":"DEFICIENCIA DE PEX3"
  },
  {
    "codigo":40643005,
    "descripcion":"FRACTURA DE CUERPO DE OMÓPLATO"
  },
  {
    "codigo":169880001,
    "descripcion":"PERÍMETRO CEFÁLICO AL NACER: ENTRE PERCENTILOS 25 Y 49"
  },
  {
    "codigo":366488003,
    "descripcion":"AMPLITUD DE LA ROTACIÓN EXTERNA DE HOMBRO - HALLAZGO"
  },
  {
    "codigo":300952004,
    "descripcion":"ÚLCERA DE PALADAR"
  },
  {
    "codigo":268184003,
    "descripcion":"HIPOPLASIA DE AORTA"
  },
  {
    "codigo":11819971000119106,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN RADIOCUBITAL INFERIOR DERECHA"
  },
  {
    "codigo":69741000,
    "descripcion":"HIDROSADENITIS"
  },
  {
    "codigo":102509001,
    "descripcion":"ADOLESCENTE SANO"
  },
  {
    "codigo":725101002,
    "descripcion":"LIGAMENTO COSTOCORACOIDE CORTO CONGÉNITO"
  },
  {
    "codigo":6040009,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM FORTUITUM"
  },
  {
    "codigo":299117004,
    "descripcion":"ARTICULACIÓN DE DEDO DE LA MANO ERITEMATOSA"
  },
  {
    "codigo":66071002,
    "descripcion":"HEPATITIS VIRAL TIPO B"
  },
  {
    "codigo":197143009,
    "descripcion":"MEGACOLON EN LA ENFERMEDAD DE CHAGAS"
  },
  {
    "codigo":721431009,
    "descripcion":"LESIÓN COMPLETA DE MÉDULA ESPINAL AL NIVEL DEL SEGUNDO SEGMENTO DORSAL"
  },
  {
    "codigo":293612001,
    "descripcion":"ALERGIA A AZAPROPAZONA"
  },
  {
    "codigo":129772004,
    "descripcion":"UBICACIÓN MAMOGRÁFICA EN HORA 1"
  },
  {
    "codigo":424684007,
    "descripcion":"NO BUSCA ATENCIÓN POR SÍNTOMAS QUE REQUIEREN TRATAMIENTO"
  },
  {
    "codigo":95169000,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA ÚVULA"
  },
  {
    "codigo":816065002,
    "descripcion":"SENSACIÓN DE DOLOR NORMAL"
  },
  {
    "codigo":226241004,
    "descripcion":"DIETA DE LA EDAD DE PIEDRA"
  },
  {
    "codigo":717761005,
    "descripcion":"SÍNDROME DE COROIDEREMIA CON SORDERA Y OBESIDAD"
  },
  {
    "codigo":29633007,
    "descripcion":"GLUCOGENOSIS"
  },
  {
    "codigo":421014001,
    "descripcion":"VOLUMEN DEL PULSO - COMPLETO"
  },
  {
    "codigo":27798002,
    "descripcion":"ANEMIA MEGALOBLÁSTICA POR ALTERACIÓN DE LA ABSORCIÓN DE FOLATO"
  },
  {
    "codigo":11793501000119109,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE PIE IZQUIERDO"
  },
  {
    "codigo":93334008,
    "descripcion":"POSICIÓN ANÓMALA CONGÉNITA DEL PULMÓN"
  },
  {
    "codigo":191638008,
    "descripcion":"TRASTORNO AFECTIVO BIPOLAR MIXTO, LEVE"
  },
  {
    "codigo":1172843003,
    "descripcion":"DEFICIENCIA COMBINADA DE LA FOSFORILACIÓN OXIDATIVA TIPO 29"
  },
  {
    "codigo":1303915005,
    "descripcion":"MIELOSQUISIS DORSAL LIMITADA"
  },
  {
    "codigo":124267007,
    "descripcion":"DEFICIENCIA DE ENZIMA RAMIFICADORA 1, 4 - ALFA - GLUCANO"
  },
  {
    "codigo":58731007,
    "descripcion":"FRACTURAS MÚLTIPLES EXPUESTAS DE MIEMBRO SUPERIOR Y COSTILLAS"
  },
  {
    "codigo":417344003,
    "descripcion":"COROIDITIS POR CRIPTOCOCOS"
  },
  {
    "codigo":286272007,
    "descripcion":"NO USA ARTICULACIÓN SECUNDARIA"
  },
  {
    "codigo":187968007,
    "descripcion":"NEOPLASIA MALIGNA DEL CUNEIFORME INTERNO"
  },
  {
    "codigo":415509000,
    "descripcion":"MIOCARDIOPATÍA RESTRICTIVA SECUNDARIA"
  },
  {
    "codigo":251669002,
    "descripcion":"TRAZADO CARDIOTOCOGRÁFICO NO REACTIVO"
  },
  {
    "codigo":253504008,
    "descripcion":"CUERDAS TENDINOSAS DE VÁLVULA AURICULOVENTRICULAR IZQUIERDA EN EL TABIQUE DE SALIDA"
  },
  {
    "codigo":448277007,
    "descripcion":"VÉRTICE DEL CORAZÓN EN LA LÍNEA MEDIA POSTERIOR"
  },
  {
    "codigo":282602000,
    "descripcion":"BRINCA"
  },
  {
    "codigo":315370002,
    "descripcion":"NACIDO EN ANTIGUA Y BARBUDA"
  },
  {
    "codigo":774122004,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE MANO IZQUIERDA"
  },
  {
    "codigo":53226007,
    "descripcion":"PIE PLANO"
  },
  {
    "codigo":870591003,
    "descripcion":"RABDOMIÓLISIS DEBIDA A COVID-19"
  },
  {
    "codigo":247999006,
    "descripcion":"BURLA"
  },
  {
    "codigo":278932006,
    "descripcion":"RAQUITISMO BIOQUÍMICO"
  },
  {
    "codigo":442772007,
    "descripcion":"ÁCIDO INDOLACÉTICO EN ESPÉCIMEN DE ORINA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":735849001,
    "descripcion":"LUXACIÓN TRAUMÁTICA INTERNA DE ARTICULACIÓN TIBIOFEMORAL"
  },
  {
    "codigo":211561006,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO, BRAZO, SITIOS MÚLTIPLES"
  },
  {
    "codigo":471870000,
    "descripcion":"MIOCARDIOPATÍA INDUCIDA POR MARCAPASOS"
  },
  {
    "codigo":111422001,
    "descripcion":"ABSCESO CRÓNICO DE LA MAMA"
  },
  {
    "codigo":275262008,
    "descripcion":"MALFORMACIÓN CONGÉNITA DE LAS VÍAS DIGESTIVAS SUPERIORES"
  },
  {
    "codigo":44051003,
    "descripcion":"ENDOCARDITIS MALIGNA"
  },
  {
    "codigo":43151000087100,
    "descripcion":"HEMATOMA DE REGIÓN DE MUÑECA DERECHA"
  },
  {
    "codigo":35471000087101,
    "descripcion":"ISQUEMIA DE SEGMENTO APICAL ANTERIOR DE VENTRÍCULO IZQUIERDO DE CORAZÓN"
  },
  {
    "codigo":38031000087102,
    "descripcion":"ACINESIA DE SEGMENTO ANTEROSEPTAL BASAL DE VENTRÍCULO CARDÍACO IZQUIERDO"
  },
  {
    "codigo":240659008,
    "descripcion":"MEGAVÍSCERAS EN ENFERMEDAD DE CHAGAS"
  },
  {
    "codigo":1287400001,
    "descripcion":"HERIDA POR ARMA DE FUEGO DE BRAZO"
  },
  {
    "codigo":404499009,
    "descripcion":"PROVIDENCIA STUARTII UREASA POSITIVA-HALLAZGO"
  },
  {
    "codigo":402664001,
    "descripcion":"VASCULITIS CUTÁNEA LOCALIZADA"
  },
  {
    "codigo":40591000087108,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE SEGUNDO DEDO DE PIE DERECHO"
  },
  {
    "codigo":48271000087109,
    "descripcion":"FRACTURA DE HUESO TEMPORAL IZQUIERDO"
  },
  {
    "codigo":238824006,
    "descripcion":"HEMATOMA PAROXÍSTICO DEL DEDO"
  },
  {
    "codigo":74984006,
    "descripcion":"INTOXICACIÓN POR FENSUXIMIDA"
  },
  {
    "codigo":73149003,
    "descripcion":"ENCOPRESIS CON ESTREÑIMIENTO E INCONTINENCIA POR REBOSAMIENTO"
  },
  {
    "codigo":267922000,
    "descripcion":"LUXACIÓN PATOLÓGICA DE TOBILLO Y\/O PIE"
  },
  {
    "codigo":40381009,
    "descripcion":"PARÁLISIS PERIÓDICA NORMOCALIÉMICA FAMILIAR"
  },
  {
    "codigo":726674004,
    "descripcion":"HERNIA DE MÚSCULO A TRAVÉS DE FASCIA DE PIERNA"
  },
  {
    "codigo":366226004,
    "descripcion":"ANGULACIÓN DE DIENTE CANINO - HALLAZGO"
  },
  {
    "codigo":300690007,
    "descripcion":"ADMINISTRA DINERO"
  },
  {
    "codigo":724839001,
    "descripcion":"TRASTORNO GENÉTICO DE LA PIGMENTACIÓN CUTÁNEA"
  },
  {
    "codigo":298855002,
    "descripcion":"ARTICULACIÓN DE HOMBRO ESTABLE"
  },
  {
    "codigo":69479009,
    "descripcion":"HIPERVENTILACIÓN POR ANSIEDAD"
  },
  {
    "codigo":1148988003,
    "descripcion":"INGESTA INADECUADA DE SAL DE SULFATO"
  },
  {
    "codigo":723004005,
    "descripcion":"DERMATOSIS AMPOLLAR AUTOINMUNITARIA"
  },
  {
    "codigo":428092007,
    "descripcion":"TORSIÓN EXTRAVAGINAL DEL CORDÓN ESPERMÁTICO"
  },
  {
    "codigo":360721004,
    "descripcion":"DEFICIENCIA DE ACILASA DE ACETIL COA"
  },
  {
    "codigo":65809005,
    "descripcion":"BORRAMIENTO CERVICAL, 40%"
  },
  {
    "codigo":33041006,
    "descripcion":"FRACTURA NO EXPUESTA DE EXTREMO PROXIMAL DE CÚBITO"
  },
  {
    "codigo":229649007,
    "descripcion":"VOZ FISTULOSA"
  },
  {
    "codigo":719334000,
    "descripcion":"NO APTO PARA VOLAR"
  },
  {
    "codigo":162278001,
    "descripcion":"MOSCAS VOLANTES EN EL CAMPO VISUAL"
  },
  {
    "codigo":424422000,
    "descripcion":"OSTEOMA DE ÓRBITA"
  },
  {
    "codigo":293350003,
    "descripcion":"REACCIÓN ADVERSA AL ÁCIDO TRANEXÁMICO"
  },
  {
    "codigo":295185008,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE MORFINA"
  },
  {
    "codigo":195046004,
    "descripcion":"BLOQUEO DE LA RAMA IZQUIERDA PRINCIPAL DEL HAZ DE HIS"
  },
  {
    "codigo":31206006,
    "descripcion":"ANEMIA MEGALOBLÁSTICA REFRACTARIA"
  },
  {
    "codigo":291515003,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ESPECTINOMICINA"
  },
  {
    "codigo":422587007,
    "descripcion":"NÁUSEAS"
  },
  {
    "codigo":94907009,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA CURVATURA MENOR DEL ESTÓMAGO"
  },
  {
    "codigo":420752001,
    "descripcion":"LESIONES EN FORMA DE HUELLA DACTILAR EN EL EPITELIO DE LA CÓRNEA"
  },
  {
    "codigo":27536004,
    "descripcion":"EDEMA CORNEAL SECUNDARIO"
  },
  {
    "codigo":715664005,
    "descripcion":"SARCOMA DE CÉLULAS DENDRÍTICAS INTERDIGITANTES"
  },
  {
    "codigo":289680005,
    "descripcion":"ÚTERO GRÁVIDO GRANDE PARA LA EDAD GESTACIONAL"
  },
  {
    "codigo":93072007,
    "descripcion":"HIPERTROFIA CONGÉNITA DE LA CAVIDAD NASAL"
  },
  {
    "codigo":224144004,
    "descripcion":"VIVE CON UN INQUILINO"
  },
  {
    "codigo":713829001,
    "descripcion":"NEURALGIA INTERCOSTAL POSINFECCIOSA"
  },
  {
    "codigo":255077007,
    "descripcion":"NEOPLASIA MALIGNA DE ÓRGANO DIGESTIVO"
  },
  {
    "codigo":449850000,
    "descripcion":"INFECCIÓN CAUSADA POR THEILERIA EQUI"
  },
  {
    "codigo":286010001,
    "descripcion":"INCAPAZ DE ENCENDER UN ARTEFACTO ELECTRODOMÉSTICO"
  },
  {
    "codigo":1269050001,
    "descripcion":"ASTROCITOMA GEMISTOCÍTICO PRIMARIO DE SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":253242003,
    "descripcion":"DISTOPÍA HORIZONTAL DE ÓRBITA"
  },
  {
    "codigo":448015002,
    "descripcion":"FIBROMA PLEOMÓRFICO"
  },
  {
    "codigo":20196005,
    "descripcion":"PANICULITIS LOBULILLAR"
  },
  {
    "codigo":249572006,
    "descripcion":"BAZO PALPABLE"
  },
  {
    "codigo":446180007,
    "descripcion":"TRASTORNO DE ESTRÉS POSTRAUMÁTICO DE INICIO TARDÍO CONSECUTIVO A COMBATE MILITAR"
  },
  {
    "codigo":247737003,
    "descripcion":"ALUCINACIÓN OLFATIVA: OLOR EMANADO DE LAS PERSONAS"
  },
  {
    "codigo":870329005,
    "descripcion":"PANUVEÍTIS CAUSADA POR VIRUS"
  },
  {
    "codigo":1263545007,
    "descripcion":"HIPERTENSIÓN INTRACRANEAL BENIGNA DEBIDA A ENFERMEDAD METABÓLICA"
  },
  {
    "codigo":1163406003,
    "descripcion":"SÍNDROME DEL ACENTO EXTRANJERO"
  },
  {
    "codigo":82062003,
    "descripcion":"HIDROCELE CONGÉNITO"
  },
  {
    "codigo":213134006,
    "descripcion":"DOLOR ASOCIADO CON DISPOSITIVO PROTÉSICO INTERNO"
  },
  {
    "codigo":278670008,
    "descripcion":"ANGULACIÓN DE DIENTE INCISIVO - MESIAL"
  },
  {
    "codigo":47459002,
    "descripcion":"AUSENCIA DE ACTIVIDAD DE LA GLÁNDULA SEBÁCEA"
  },
  {
    "codigo":473443007,
    "descripcion":"ORIGEN ANÓMALO DE ARTERIA CORONARIA DERECHA"
  },
  {
    "codigo":307768001,
    "descripcion":"PÓLIPO DE LA LENGUA"
  },
  {
    "codigo":897592003,
    "descripcion":"TRASTORNO CONGÉNITO DE LA GLICOSILACIÓN TIPO 1I"
  },
  {
    "codigo":431591000124102,
    "descripcion":"OSTEONECROSIS DISBÁRICA"
  },
  {
    "codigo":454631000124104,
    "descripcion":"SE NIEGA A SUSPENDER MEDICACIÓN"
  },
  {
    "codigo":240397002,
    "descripcion":"PASTEURELOSIS CUTÁNEA"
  },
  {
    "codigo":404237007,
    "descripcion":"ENCEFALITIS POR VIRUS KEYSTONE"
  },
  {
    "codigo":1156066000,
    "descripcion":"VISIÓN ANORMAL DEBIDA A HEMANGIOMA INFANTIL SUPERFICIAL DE REGIÓN PERIORBITARIA"
  },
  {
    "codigo":109325009,
    "descripcion":"OSTEOMIELITIS ESCLEROSANTE CRÓNICA NO SUPURATIVA DE HUESO TEMPORAL"
  },
  {
    "codigo":238562004,
    "descripcion":"ECCEMA HIPERQUERATÓSICO PLANTAR"
  },
  {
    "codigo":402402005,
    "descripcion":"URTICARIA Y\/O ANGIOEDEMA AUTOINMUNITARIO"
  },
  {
    "codigo":41954005,
    "descripcion":"OTITIS MEDIA SUPURATIVA CRÓNICA ATICOANTRAL"
  },
  {
    "codigo":369634004,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA RADIAL PROFUNDA DE VEJIGA URINARIA, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":236727001,
    "descripcion":"TRASTORNO POR PRÓTESIS TESTICULAR"
  },
  {
    "codigo":105655004,
    "descripcion":"ENFERMEDAD CAUSADA POR TRYPANOSOMATIDAE"
  },
  {
    "codigo":40119006,
    "descripcion":"ENVENENAMIENTO DEBIDO A PICADURA DE ARAÑA RECLUSA PARDA"
  },
  {
    "codigo":1186999007,
    "descripcion":"MONONUCLEOSIS INFECCIOSA POR TOXOPLASMA"
  },
  {
    "codigo":431500000,
    "descripcion":"RUPTURA DE LIGAMENTO CUBITOPIRAMIDAL DE MUÑECA"
  },
  {
    "codigo":300428002,
    "descripcion":"HALLAZGO RELACIONADO CON AUSCULTACIÓN DE ABDOMEN"
  },
  {
    "codigo":890252003,
    "descripcion":"DERMATITIS IRRITATIVA POR CONTACTO DE MANO POR CEMENTO"
  },
  {
    "codigo":365964003,
    "descripcion":"HALLAZGO EN EL INTERÉS ERÓTICO"
  },
  {
    "codigo":202124003,
    "descripcion":"DESGARRO COMPLETO ANTIGUO DE LIGAMENTO CRUZADO POSTERIOR"
  },
  {
    "codigo":267660007,
    "descripcion":"ESCLERITIS POSTERIOR"
  },
  {
    "codigo":298593000,
    "descripcion":"LESIÓN DE COLUMNA LUMBAR"
  },
  {
    "codigo":724577001,
    "descripcion":"NEOPLASIA OSTEÓGENA BENIGNA DE HUESO DE EXTREMIDAD"
  },
  {
    "codigo":69217004,
    "descripcion":"ESTRECHEZ DE LA SALIDA DE LA PELVIS"
  },
  {
    "codigo":429665006,
    "descripcion":"CONTUSIÓN DE COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":3681008,
    "descripcion":"TROMBOFLEBITIS DE LA PRENSA DE HERÓFILO"
  },
  {
    "codigo":332231000119102,
    "descripcion":"ESCLEROMALACIA PERFORANTE DE OJO DERECHO"
  },
  {
    "codigo":722742002,
    "descripcion":"RESPIRA AIRE AMBIENTE"
  },
  {
    "codigo":427830002,
    "descripcion":"ÚLCERA FAGEDÉNICA TROPICAL DE LA PIERNA"
  },
  {
    "codigo":460598004,
    "descripcion":"ESTENOSIS ADQUIRIDA DE VENA CAVA SUPERIOR"
  },
  {
    "codigo":165686002,
    "descripcion":"RECUENTO DE RETICULOCITOS NORMAL"
  },
  {
    "codigo":296758002,
    "descripcion":"SOBREDOSIS DE MINOCICLINA"
  },
  {
    "codigo":1052257008,
    "descripcion":"CRIPTORQUIDIA ADQUIRIDA DE TESTÍCULO DERECHO"
  },
  {
    "codigo":65547006,
    "descripcion":"INFARTO AGUDO DE MIOCARDIO DE PARED INFEROLATERAL"
  },
  {
    "codigo":294923007,
    "descripcion":"ALERGIA A VITAMINA A"
  },
  {
    "codigo":15978951000119105,
    "descripcion":"TIMPANOESCLEROSIS DEL OÍDO MEDIO IZQUIERDO"
  },
  {
    "codigo":10654151000119105,
    "descripcion":"ÚLCERA ISQUÉMICA DE DEDO DE PIE DERECHO DEBIDA A ENFERMEDAD ATEROSCLERÓTICA"
  },
  {
    "codigo":131083006,
    "descripcion":"NIVEL DE CORTISONA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":424160003,
    "descripcion":"ALMACENAMIENTO DE SUSTANCIAS PELIGROSAS EN CONDICIONES NO SEGURAS"
  },
  {
    "codigo":293088005,
    "descripcion":"REACCIÓN ADVERSA A PLAGUICIDA CLORADO"
  },
  {
    "codigo":1145056009,
    "descripcion":"SOBREDOSIS INTENCIONAL DE CLORAZEPATO"
  },
  {
    "codigo":192949002,
    "descripcion":"PARAPLEJÍA CONGÉNITA"
  },
  {
    "codigo":422325003,
    "descripcion":"SOPLO HOLODIASTÓLICO"
  },
  {
    "codigo":782773005,
    "descripcion":"SÍNDROME DE ARTERIOPATÍA LETAL DEBIDO A DEFICIENCIA DE FIBULINA-4"
  },
  {
    "codigo":94645008,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE HUESO TRAPEZOIDE"
  },
  {
    "codigo":715402001,
    "descripcion":"RESISTENCIA HEREDITARIA A GLUCOCORTICOIDES"
  },
  {
    "codigo":291253009,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR PSILOCIBINA"
  },
  {
    "codigo":289418003,
    "descripcion":"FONTANELA POSTERIOR PALPABLE EN LA REGIÓN ANTERIOR"
  },
  {
    "codigo":60042005,
    "descripcion":"INTOXICACIÓN POR GOSIPOL"
  },
  {
    "codigo":1010314008,
    "descripcion":"TRASTORNO FETAL DEBIDO A OBESIDAD MATERNA CON UN ÍNDICE DE MASA CORPORAL PARA ADULTO DE 40 O SUPERIOR"
  },
  {
    "codigo":189279000,
    "descripcion":"CARCINOMA IN SITU DE LA PIEL DEL PABELLÓN AURICULAR"
  },
  {
    "codigo":713567005,
    "descripcion":"DUERME DURANTE EL DÍA"
  },
  {
    "codigo":1303391006,
    "descripcion":"FRACTURA DE HUESO DE ANTEBRAZO DERECHO"
  },
  {
    "codigo":16745211000119100,
    "descripcion":"RETINOPATÍA DIABÉTICA NO PROLIFERATIVA DE OJO IZQUIERDO DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":87305000,
    "descripcion":"REPRESIÓN - MECANISMO DE DEFENSA PSICOLÓGICA"
  },
  {
    "codigo":283913006,
    "descripcion":"SECCIÓN DE CONDUCTO URINARIO"
  },
  {
    "codigo":118238000,
    "descripcion":"HALLAZGO DEL APARATO GENITOURINARIO"
  },
  {
    "codigo":871902001,
    "descripcion":"BIOPSIA DE SITIO PREVIO DE BIOPSIA QUE REVELA CAMBIO HISTOLÓGICO"
  },
  {
    "codigo":183774000,
    "descripcion":"INSCRIPTO EN LISTA DE ADMISIÓN GERIÁTRICA"
  },
  {
    "codigo":314846003,
    "descripcion":"SE LE DA AL PACIENTE OPCIÓN DE TRATAMIENTO"
  },
  {
    "codigo":52702003,
    "descripcion":"SÍNDROME DE FATIGA CRÓNICA"
  },
  {
    "codigo":249310005,
    "descripcion":"NARIZ PEQUEÑA"
  },
  {
    "codigo":11830011000119103,
    "descripcion":"HEMATOMA DE REGIÓN DE CADERA IZQUIERDA"
  },
  {
    "codigo":688891000119103,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE MEMBRANA MUCOSA DE LABIO"
  },
  {
    "codigo":445918001,
    "descripcion":"CISTITIS EOSINOFÍLICA"
  },
  {
    "codigo":18099001,
    "descripcion":"ABSCESO RETROFARÍNGEO"
  },
  {
    "codigo":247475002,
    "descripcion":"VASOS SANGUÍNEOS DILATADOS EN LA PIEL"
  },
  {
    "codigo":83635002,
    "descripcion":"FRACTURA DE LA APÓFISIS TRANSVERSA DE LA VÉRTEBRA"
  },
  {
    "codigo":1085481000119100,
    "descripcion":"EDENTULISMO COMPLETO DEBIDO A CARIES"
  },
  {
    "codigo":15708201000119101,
    "descripcion":"TROMBOSIS AGUDA DE VENA PROFUNDA DE MIEMBRO SUPERIOR DERECHO POSTERIOR A PROCEDIMIENTO"
  },
  {
    "codigo":340521000119102,
    "descripcion":"HEMORRAGIA EN VAINA DE NERVIO ÓPTICO IZQUIERDO"
  },
  {
    "codigo":350761000119102,
    "descripcion":"NEOPLASIA LIPOMATOSA BENIGNA DE PIEL Y\/O DEL TEJIDO CELULAR SUBCUTÁNEO DE EXTREMIDAD SUPERIOR DERECHA"
  },
  {
    "codigo":66601000119104,
    "descripcion":"PORTADOR DE TRASTORNO POR HEMOGLOBINOPATÍA C"
  },
  {
    "codigo":11996201000119105,
    "descripcion":"NECROSIS DE MUÑÓN DE AMPUTACIÓN DE EXTREMIDAD SUPERIOR IZQUIERDA"
  },
  {
    "codigo":1090601000119102,
    "descripcion":"OTITIS MEDIA ALÉRGICA AGUDA DEL OÍDO DERECHO"
  },
  {
    "codigo":11822121000119107,
    "descripcion":"SUBLUXACIÓN DE ARTICULACIÓN ACROMIOCLAVICULAR DERECHA"
  },
  {
    "codigo":314921000119108,
    "descripcion":"OSTEÍTIS DEFORMANTE DE TIBIA Y PERONÉ DERECHOS"
  },
  {
    "codigo":41000119109,
    "descripcion":"DISTENSIÓN DE PIE"
  },
  {
    "codigo":15677481000119109,
    "descripcion":"MIOSITIS DE ANTEBRAZO IZQUIERDO"
  },
  {
    "codigo":1077801000119109,
    "descripcion":"OSTEOMIELITIS DE TOBILLO DERECHO"
  },
  {
    "codigo":11850281000119104,
    "descripcion":"CUERPO EXTRAÑO SUPERFICIAL DE MAMA IZQUIERDA CON INFECCIÓN"
  },
  {
    "codigo":737160009,
    "descripcion":"DISECCIÓN DE ARTERIA BASILAR"
  },
  {
    "codigo":11778601000119106,
    "descripcion":"DISTENSIÓN DE MÚSCULO INFRAESPINOSO DERECHO"
  },
  {
    "codigo":15664681000119107,
    "descripcion":"TUMOR TENOSINOVIAL DE CÉLULAS GIGANTES DIFUSO DE AMBAS ARTICULACIONES GLENOHUMERALES"
  },
  {
    "codigo":407645004,
    "descripcion":"MAREO AL PONERSE DE PIE"
  },
  {
    "codigo":322601000119109,
    "descripcion":"SINOVITIS TRANSITORIA DE CODO DERECHO"
  },
  {
    "codigo":15741481000119109,
    "descripcion":"CONTRACTURA CONGÉNITA DE ARTICULACIÓN DE DEDO DE PIES BILATERALES"
  },
  {
    "codigo":702557004,
    "descripcion":"BAJA PROVOCACIÓN BACTERIANA"
  },
  {
    "codigo":276573008,
    "descripcion":"ASFIXIA PARCIAL CRÓNICA DEL RECIÉN NACIDO"
  },
  {
    "codigo":211037008,
    "descripcion":"ABRASIÓN DEL TRONCO"
  },
  {
    "codigo":1259613001,
    "descripcion":"SARCOMA DE EWING DE CÉLULAS GRANDES PRIMARIO DE HUESO"
  },
  {
    "codigo":405810005,
    "descripcion":"SÍNDROME DE COGAN"
  },
  {
    "codigo":373042007,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM MAGERITENSE"
  },
  {
    "codigo":209202009,
    "descripcion":"SUBLUXACIÓN NO EXPUESTA DEL SACRO"
  },
  {
    "codigo":305671002,
    "descripcion":"ATENDIDO POR UN ENDOCRINÓLOGO"
  },
  {
    "codigo":698887005,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: AYMARA"
  },
  {
    "codigo":403975006,
    "descripcion":"LINFANGIOMA PROGRESIVO ADQUIRIDO"
  },
  {
    "codigo":402140003,
    "descripcion":"INFESTACIÓN CON NEMATODO HUMANO"
  },
  {
    "codigo":860892003,
    "descripcion":"ENFERMEDAD GLOMERULAR DEBIDA A ENFERMEDAD INFECCIOSA"
  },
  {
    "codigo":205532005,
    "descripcion":"APLASIA MUSCULAR"
  },
  {
    "codigo":74460005,
    "descripcion":"DEPÓSITO CORNEAL"
  },
  {
    "codigo":16636821000119106,
    "descripcion":"TRASTORNO DE AMBOS NERVIOS MEDIANOS"
  },
  {
    "codigo":762588005,
    "descripcion":"URANOESTAFILOSQUISIS CON LABIO LEPORINO DERECHO Y FISURA ALVEOLAR DERECHA"
  },
  {
    "codigo":269233004,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO SUPERFICIAL DEL PABELLÓN AURICULAR"
  },
  {
    "codigo":302001007,
    "descripcion":"NO SE MUEVE"
  },
  {
    "codigo":7089008,
    "descripcion":"FLEBITIS RETINIANA"
  },
  {
    "codigo":334741000119108,
    "descripcion":"ESOTROPÍA MONOCULAR INTERMITENTE DE OJO DERECHO"
  },
  {
    "codigo":234630002,
    "descripcion":"DEFICIENCIA DEL RECEPTOR 3 DEL COMPLEMENTO"
  },
  {
    "codigo":1217670003,
    "descripcion":"ENDOFTALMITIS BACTERIANA POSQUIRÚRGICA CRÓNICA"
  },
  {
    "codigo":431238002,
    "descripcion":"ABSCESO DE VÁLVULA PULMONAR"
  },
  {
    "codigo":300166005,
    "descripcion":"HUESECILLOS DEL OÍDO, NO OBSERVADOS"
  },
  {
    "codigo":298331001,
    "descripcion":"RESPUESTA MOTORA NORMAL LUEGO DE UNA ORDEN"
  },
  {
    "codigo":365702009,
    "descripcion":"HALLAZGO RELACIONADO CON EL CRECIMIENTO DE PARÁSITOS"
  },
  {
    "codigo":462171004,
    "descripcion":"CARDIOMEGALIA FETAL"
  },
  {
    "codigo":3419005,
    "descripcion":"DIFTERIA FAUCIAL"
  },
  {
    "codigo":429403006,
    "descripcion":"SIN PREFERENCIA RELIGIOSA"
  },
  {
    "codigo":296496002,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE METOCARBAMOL"
  },
  {
    "codigo":165424007,
    "descripcion":"RECUENTO DE ERITROCITOS POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1179397005,
    "descripcion":"HIPOTIROIDISMO CONGÉNITO DEBIDO A MUTACIÓN DE SIMPORTADOR"
  },
  {
    "codigo":818949005,
    "descripcion":"AUSENCIA CONGÉNITA DE CUERPO DE ÚTERO"
  },
  {
    "codigo":12104751000119108,
    "descripcion":"QUEMADURA QUÍMICA DE MANO IZQUIERDA"
  },
  {
    "codigo":32517009,
    "descripcion":"PRODUCCIÓN NORMAL DE GRANULOCITOS"
  },
  {
    "codigo":292826004,
    "descripcion":"REACCIÓN ADVERSA A FÁRMACO ANTIVIRAL"
  },
  {
    "codigo":784346006,
    "descripcion":"NEUROHEPATOPATÍA TIPO NAVAJO"
  },
  {
    "codigo":127151000,
    "descripcion":"LINFADENOPATÍA CÓLICA IZQUIERDA"
  },
  {
    "codigo":63450009,
    "descripcion":"ALBINISMO RUFO"
  },
  {
    "codigo":94383004,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE HUESO LARGO DE LA EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":1306799004,
    "descripcion":"ARTERITIS DE CÉLULAS GIGANTES DE GRANDES VASOS"
  },
  {
    "codigo":290991006,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR ZOLPIDEM"
  },
  {
    "codigo":225455004,
    "descripcion":"HUMOR SOCIABLE"
  },
  {
    "codigo":192687008,
    "descripcion":"ENCEFALITIS ARBOVIRAL"
  },
  {
    "codigo":92548003,
    "descripcion":"CARCINOMA IN SITU DEL CUERPO DEL PENE"
  },
  {
    "codigo":289156007,
    "descripcion":"HALLAZGO RELACIONADO CON LA ALIMENTACIÓN"
  },
  {
    "codigo":715140008,
    "descripcion":"HIPERPLASIA REGENERATIVA NODULAR DE HÍGADO"
  },
  {
    "codigo":27012009,
    "descripcion":"ENFERMEDAD CARDÍACA HIPERCINÉTICA"
  },
  {
    "codigo":189017000,
    "descripcion":"LIPOMA DE MÉDULA ESPINAL"
  },
  {
    "codigo":254553001,
    "descripcion":"CARCINOMA DEL CARDIAS"
  },
  {
    "codigo":1268526001,
    "descripcion":"CARCINOSARCOMA PRIMARIO DE OVARIO"
  },
  {
    "codigo":285486002,
    "descripcion":"INCAPAZ DE ESTIRAR LOS LABIOS"
  },
  {
    "codigo":416558007,
    "descripcion":"EXOFTALMÍA POR ENFERMEDAD TIROIDEA OCULAR"
  },
  {
    "codigo":56110009,
    "descripcion":"TRAUMATISMO OBSTÉTRICO FETAL"
  },
  {
    "codigo":21507006,
    "descripcion":"ESTILO DE VESTIMENTA DESINHIBIDO"
  },
  {
    "codigo":283651008,
    "descripcion":"HERIDA POR PINCHAZO DE CLAVO EN LA CABEZA Y EL CUELLO"
  },
  {
    "codigo":87043009,
    "descripcion":"ANOXIA CEREBRAL POSTERIOR A PROCEDIMIENTO OBSTÉTRICO"
  },
  {
    "codigo":1363160002,
    "descripcion":"ASTILLA EN PARED ABDOMINAL"
  },
  {
    "codigo":871640001,
    "descripcion":"MIOCARDITIS DEBIDA A ENFERMEDAD AUTOINMUNITARIA"
  },
  {
    "codigo":609496007,
    "descripcion":"COMPLICACIÓN PRODUCIDA DURANTE EL EMBARAZO"
  },
  {
    "codigo":707800008,
    "descripcion":"CAPTURA MECÁNICA DE VENTRÍCULO DESPUÉS DE LA COLOCACIÓN DE MARCAPASOS TEMPORARIO"
  },
  {
    "codigo":443821001,
    "descripcion":"NÓDULO DOMINANTE DE GLÁNDULA TIROIDES"
  },
  {
    "codigo":1074531000119107,
    "descripcion":"OSTEOARTROSIS DE PIE IZQUIERDO DEBIDA A TRAUMATISMO"
  },
  {
    "codigo":279981003,
    "descripcion":"DOLOR NEUROPÁTICO PERIFÉRICO"
  },
  {
    "codigo":247213004,
    "descripcion":"VASOS OPTICOCILIARES"
  },
  {
    "codigo":83373005,
    "descripcion":"SÍNDROME DE ANTON"
  },
  {
    "codigo":15957501000119101,
    "descripcion":"ONCOCITOMA RENAL BILATERAL"
  },
  {
    "codigo":11806051000119108,
    "descripcion":"SUBLUXACIÓN LATERAL DE ARTICULACIÓN FEMORORROTULIANA DERECHA"
  },
  {
    "codigo":310781000119103,
    "descripcion":"MIOSITIS INFECCIOSA DE BRAZO DERECHO"
  },
  {
    "codigo":16002006,
    "descripcion":"INTERCAMBIO ANORMAL DE SOLUTOS DEL LÍQUIDO CEFALORRAQUÍDEO"
  },
  {
    "codigo":704130006,
    "descripcion":"RITMO CARDÍACO SUSCEPTIBLE DE CHOQUE DETECTADO MEDIANTE DESFIBRILADOR EXTERNO AUTOMÁTICO"
  },
  {
    "codigo":866135007,
    "descripcion":"INFILTRADOS INFECCIOSOS DE CÓRNEA CAUSADOS POR LENTE DE CONTACTO"
  },
  {
    "codigo":1259351008,
    "descripcion":"CARCINOMA PRIMARIO DE FUNDUS GÁSTRICO"
  },
  {
    "codigo":733228005,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA A LA ALTURA DE ARTICULACIÓN DEL HOMBRO DERECHO"
  },
  {
    "codigo":12332005,
    "descripcion":"PSEUDOLOGÍA FANTÁSTICA"
  },
  {
    "codigo":71711000112103,
    "descripcion":"SANGRE OCULTA DETECTADA EN HECES POR INMUNOENSAYO"
  },
  {
    "codigo":208940006,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE LA ARTICULACIÓN DE LA RODILLA, EXTERNA"
  },
  {
    "codigo":405548009,
    "descripcion":"ABSCESO DE TABIQUE CARDÍACO"
  },
  {
    "codigo":698625002,
    "descripcion":"DEMENCIA ASOCIADA CON HIDROCEFALIA CON PRESIÓN NORMAL"
  },
  {
    "codigo":403713003,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS ASOCIADO CON FOTOQUIMIOTERAPIA CON PSORALENO Y RADIACIÓN ULTRAVIOLETA DE ONDA LARGA"
  },
  {
    "codigo":239873007,
    "descripcion":"ARTROSIS DE LA RODILLA"
  },
  {
    "codigo":238038003,
    "descripcion":"HIPERLIPOPROTEINEMIA FAMILIAR"
  },
  {
    "codigo":74198004,
    "descripcion":"QUEMADURA PROFUNDA DE TERCER GRADO DEL CUELLO"
  },
  {
    "codigo":762326005,
    "descripcion":"TRASTORNO PSICÓTICO CON ALUCINACIONES CAUSADO POR ESTIMULANTE"
  },
  {
    "codigo":11835031000119103,
    "descripcion":"SUBLUXACIÓN DE ARTICULACIÓN CARPOMETACARPIANA DE PULGAR IZQUIERDO"
  },
  {
    "codigo":205270008,
    "descripcion":"MÚSCULO FLEXOR DEL ANTEBRAZO ECTÓPICO"
  },
  {
    "codigo":39595001,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":400043005,
    "descripcion":"QUERATOSIS PILOSA ROJA"
  },
  {
    "codigo":203435007,
    "descripcion":"OSTEOPOROSIS LOCALIZADA - LEQUESNE"
  },
  {
    "codigo":301739008,
    "descripcion":"REALIZA ACTIVIDADES DE OFICINA"
  },
  {
    "codigo":299904003,
    "descripcion":"DISCRIMINACIÓN DE FRÍO-CALOR AUSENTE"
  },
  {
    "codigo":398208003,
    "descripcion":"BLOQUEO DE LA CONDUCCIÓN NERVIOSA MOTORA - NINGUNO"
  },
  {
    "codigo":16012951000119106,
    "descripcion":"TROMBOSIS DE ARTERIA POPLÍTEA DERECHA"
  },
  {
    "codigo":37760005,
    "descripcion":"BLOQUEO DE LA RAMA IZQUIERDA ANTERIOR DEL HAZ DE HIS"
  },
  {
    "codigo":70528007,
    "descripcion":"MUCOLIPIDOSIS"
  },
  {
    "codigo":430976005,
    "descripcion":"RETENCIÓN URINARIA DEBIDA A OBSTRUCCIÓN DE SONDA DE FOLEY"
  },
  {
    "codigo":103296009,
    "descripcion":"VÉRTIGO PRECEDIDO POR MASTICACIÓN"
  },
  {
    "codigo":298069001,
    "descripcion":"CUERPO EXTRAÑO EN LA PIEL DE LA REGIÓN OCULAR"
  },
  {
    "codigo":10907441000119101,
    "descripcion":"HERIDA POR DISPARO DE ARMA DE FUEGO DE BRAZO DERECHO"
  },
  {
    "codigo":199765007,
    "descripcion":"PARTO OBSTACULIZADO POR ANOMALÍA DE LOS ÓRGANOS PÉLVICOS MATERNOS"
  },
  {
    "codigo":230698000,
    "descripcion":"INFARTO LACUNAR"
  },
  {
    "codigo":296234000,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE PROMAZINA"
  },
  {
    "codigo":66858001,
    "descripcion":"RETORNO VENOSO PULMONAR ANÓMALO HACIA LA VENA CAVA SUPERIOR"
  },
  {
    "codigo":427306008,
    "descripcion":"HEMOGLOBINOPATÍA HEREDITARIA"
  },
  {
    "codigo":294399008,
    "descripcion":"ALERGIA A HALOFANTRINA"
  },
  {
    "codigo":16697291000119100,
    "descripcion":"NEOPLASIA DE AMBOS RIÑONES"
  },
  {
    "codigo":126889000,
    "descripcion":"NEOPLASIA DE LA PARED ANTERIOR DE LA VEJIGA"
  },
  {
    "codigo":292564009,
    "descripcion":"REACCIÓN ADVERSA AL COLFOSCERILO"
  },
  {
    "codigo":15740721000119107,
    "descripcion":"ALMOHADILLAS DE LOS NUDILLOS DE AMBAS MANOS"
  },
  {
    "codigo":421801003,
    "descripcion":"MICROPSIA"
  },
  {
    "codigo":94121005,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE URÉTER"
  },
  {
    "codigo":290729008,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR RAZOXANO"
  },
  {
    "codigo":714878003,
    "descripcion":"NO MANTIENE LA POSICIÓN EN CUCLILLAS"
  },
  {
    "codigo":92286008,
    "descripcion":"NEOPLASIA BENIGNA DE PENE"
  },
  {
    "codigo":419966009,
    "descripcion":"HALLAZGO RELACIONADO CON EL REFLEJO SUPRARROTULIANO"
  },
  {
    "codigo":876883006,
    "descripcion":"FALLECIDO EN CIRUGÍA"
  },
  {
    "codigo":88616000,
    "descripcion":"ACNÉ VULGAR"
  },
  {
    "codigo":449064001,
    "descripcion":"ENFERMEDAD DE BOWEN DE LA PIEL DE LA NALGA"
  },
  {
    "codigo":285224004,
    "descripcion":"CAPAZ DE RECORDAR OBJETOS"
  },
  {
    "codigo":416296007,
    "descripcion":"ENDOFTALMITIS CRIPTOCÓCICA"
  },
  {
    "codigo":840445001,
    "descripcion":"DACRIOADENITIS CAUSADA POR BLASTOMYCES"
  },
  {
    "codigo":23080009,
    "descripcion":"VÓLVULO GÁSTRICO CRÓNICO"
  },
  {
    "codigo":54013005,
    "descripcion":"FRACTURA NO EXPUESTA DE PRIMER METATARSIANO"
  },
  {
    "codigo":283389006,
    "descripcion":"LACERACIÓN DE LA PANTORRILLA"
  },
  {
    "codigo":250621009,
    "descripcion":"OBSERVACIONES DE UREA Y ELECTRÓLITOS - HALLAZGO"
  },
  {
    "codigo":707538002,
    "descripcion":"CARCINOMA PRIMARIO DE CÉLULAS ESCAMOSAS DE VALÉCULA"
  },
  {
    "codigo":248786003,
    "descripcion":"EYACULACIÓN SIN EXCITACIÓN"
  },
  {
    "codigo":281554004,
    "descripcion":"SECCIÓN TRAUMÁTICA DE TENDÓN DE MIEMBRO INFERIOR"
  },
  {
    "codigo":445394005,
    "descripcion":"COLORACIÓN OSCURA DE LA PIEL"
  },
  {
    "codigo":1297362005,
    "descripcion":"DISPLASIA CONGÉNITA DE ARTICULACIÓN DE REGIÓN DE HOMBRO"
  },
  {
    "codigo":1295527000,
    "descripcion":"SÍNDROME MEDULAR ANTERIOR CAUSADO POR RADIACIÓN"
  },
  {
    "codigo":84946008,
    "descripcion":"AGOTAMIENTO EXTREMO"
  },
  {
    "codigo":246951001,
    "descripcion":"PUNTOS DE TRANTAS"
  },
  {
    "codigo":771239007,
    "descripcion":"DISPLASIA ECTODÉRMICA HIDRÓTICA TIPO CHRISTIANSON FOURIE"
  },
  {
    "codigo":736636000,
    "descripcion":"PÓLIPO DE FOSA NASAL DERECHA"
  },
  {
    "codigo":1079551000119100,
    "descripcion":"CONDROSARCOMA PRIMARIO DE HUESO DE EXTREMIDAD SUPERIOR IZQUIERDA"
  },
  {
    "codigo":441724008,
    "descripcion":"HIDROTÓRAX A TENSIÓN"
  },
  {
    "codigo":308817005,
    "descripcion":"ESTADO DE CITA"
  },
  {
    "codigo":1259089005,
    "descripcion":"ENCEFALOMIELITIS AUTÓNOMA ADQUIRIDA AUTOINMUNITARIA"
  },
  {
    "codigo":276049006,
    "descripcion":"APOYO DE GRUPO DE AUTOAYUDA"
  },
  {
    "codigo":439889008,
    "descripcion":"HERIDA CAUSADA POR DISPOSITIVO CON CLAVOS"
  },
  {
    "codigo":46673008,
    "descripcion":"INTOXICACIÓN POR IDOXURIDINA"
  },
  {
    "codigo":12070002,
    "descripcion":"ESTENOSIS CONGÉNITA DE LARINGE"
  },
  {
    "codigo":1290022003,
    "descripcion":"TUMOR NEUROENDOCRINO BIEN DIFERENCIADO PRIMARIO DE CONDUCTO BILIAR PERIHILIAR"
  },
  {
    "codigo":208678005,
    "descripcion":"FRACTURA NO EXPUESTA DEL CALCÁNEO, INTRARTICULAR"
  },
  {
    "codigo":110374006,
    "descripcion":"HIERRO DE LA MÉDULA ÓSEA: AUSENTE"
  },
  {
    "codigo":44838007,
    "descripcion":"INTOXICACIÓN POR LEVALORFANO"
  },
  {
    "codigo":274214008,
    "descripcion":"APNEA CAUSADA POR ANESTÉSICOS"
  },
  {
    "codigo":732966008,
    "descripcion":"ANEMIA HEMOLÍTICA AUTOINMUNITARIA SECUNDARIA CONCOMITANTE CON COLITIS ULCEROSA Y DEBIDA A ELLA"
  },
  {
    "codigo":698363002,
    "descripcion":"TROMBOEMBOLIA POSOPERATORIA DE ARTERIA CEREBRAL ANTERIOR"
  },
  {
    "codigo":403451002,
    "descripcion":"ATROFIA DE LA LENGUA POR DESNERVACIÓN"
  },
  {
    "codigo":1255419000,
    "descripcion":"ASTA POSTERIOR DE MENISCO INTERNO DE RODILLA DISCOIDE CONGÉNITO"
  },
  {
    "codigo":10235002,
    "descripcion":"INTOXICACIÓN POR TETRACLOROETILENO"
  },
  {
    "codigo":41168002,
    "descripcion":"TRASTORNO FETAL QUE SE ORIGINA EN PERÍODO PERINATAL"
  },
  {
    "codigo":203173002,
    "descripcion":"OSTEOMIELITIS AGUDA DE PERONÉ"
  },
  {
    "codigo":301477003,
    "descripcion":"DIFICULTAD PARA SUPERAR OBSTÁCULOS"
  },
  {
    "codigo":39333005,
    "descripcion":"DILATACIÓN CERVICAL, 8CM"
  },
  {
    "codigo":234106000,
    "descripcion":"ASCITIS QUILOSA POR FILARIASIS CAUSADA POR WUCHERERIA BANCROFTI"
  },
  {
    "codigo":365178001,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA REALIZAR ACTIVIDADES DE CUIDADO PERSONAL"
  },
  {
    "codigo":1348218001,
    "descripcion":"PATRÓN PERJUDICIAL DE USO DE SUSTANCIAS MIXTAS SIN DEPENDENCIA EN REMISIÓN"
  },
  {
    "codigo":235941008,
    "descripcion":"PANCREATITIS AGUDA POR CÁLCULO EN LA VESÍCULA BILIAR"
  },
  {
    "codigo":1163101003,
    "descripcion":"ENCEFALITIS POR VIRUS DEL DENGUE"
  },
  {
    "codigo":12112281000119102,
    "descripcion":"QUEMADURA QUÍMICA DE SEGUNDO GRADO DE PIE DERECHO"
  },
  {
    "codigo":299642007,
    "descripcion":"ARTICULACIÓN DEL DEDO DEL PIE - FRÍA"
  },
  {
    "codigo":232271003,
    "descripcion":"TRASTORNO INTRACRANEAL DEBIDO A MASTOIDITIS AGUDA Y POSTERIOR A ELLA"
  },
  {
    "codigo":166735007,
    "descripcion":"URATO EN SANGRE FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":363343008,
    "descripcion":"TRASTORNO HEREDITARIO DEL APARATO VISUAL"
  },
  {
    "codigo":428879008,
    "descripcion":"QUISTE EPIDERMOIDE DE LA MANO"
  },
  {
    "codigo":164900003,
    "descripcion":"ELECTROCARDIOGRAMA: BLOQUEO SINOAURICULAR PARCIAL"
  },
  {
    "codigo":263204007,
    "descripcion":"FRACTURA DE DIÁFISIS DE CÚBITO"
  },
  {
    "codigo":359673001,
    "descripcion":"FIEBRE HEMORRÁGICA VENEZOLANA"
  },
  {
    "codigo":425209002,
    "descripcion":"NO FAMILIARIZADO CON EL PROCESO PARA OBTENER SERVICIOS COMUNITARIOS"
  },
  {
    "codigo":294137002,
    "descripcion":"ALERGIA A FENINDAMINA"
  },
  {
    "codigo":427044009,
    "descripcion":"HEPATITIS FULMINANTE"
  },
  {
    "codigo":31993003,
    "descripcion":"MIOCARDITIS TÓXICA"
  },
  {
    "codigo":10965401000119108,
    "descripcion":"HERIDA ABIERTA DE CADERA DERECHA DEBIDA A MORDEDURA HUMANA"
  },
  {
    "codigo":95694000,
    "descripcion":"DESPIGMENTACIÓN RETINIANA"
  },
  {
    "codigo":64761009,
    "descripcion":"FUNCIÓN CORPORAL GENERAL NO ASIGNADA"
  },
  {
    "codigo":11784601000119108,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE REGIÓN DE MUÑECA DERECHA"
  },
  {
    "codigo":128462008,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA"
  },
  {
    "codigo":292302009,
    "descripcion":"REACCIÓN ADVERSA A INHIBIDOR SELECTIVO DE LA RECAPTACIÓN DE SEROTONINA"
  },
  {
    "codigo":126627003,
    "descripcion":"NEOPLASIA DE MÚSCULO DE LA PELVIS"
  },
  {
    "codigo":716451005,
    "descripcion":"CAPAZ DE DEJAR DE UTILIZAR ENERGÍA"
  },
  {
    "codigo":61091005,
    "descripcion":"ANEURISMA DE LA ARTERIA CARÓTIDA EXTERNA"
  },
  {
    "codigo":1339043007,
    "descripcion":"TC DE SISTEMA NERVIOSO CON CONTRASTE NORMAL"
  },
  {
    "codigo":288632000,
    "descripcion":"DIFICULTAD PARA JUGAR CON LAS PALABRAS Y LOS SIGNIFICADOS"
  },
  {
    "codigo":92024004,
    "descripcion":"NEOPLASIA BENIGNA DE HUESO DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":188493000,
    "descripcion":"RETICULOSARCOMA DE GANGLIOS LINFÁTICOS DE REGIÓN INGUINAL Y EXTREMIDAD INFERIOR"
  },
  {
    "codigo":286797007,
    "descripcion":"RASGO DE LA PERSONALIDAD: NIVEL DE HOSTILIDAD - HALLAZGO"
  },
  {
    "codigo":22818000,
    "descripcion":"GRANULOSIS RUBRA DE LA NARIZ"
  },
  {
    "codigo":344781000119102,
    "descripcion":"MIOSITIS DE AMBAS ÓRBITAS"
  },
  {
    "codigo":284962000,
    "descripcion":"CAPAZ DE MANTENER UN NIVEL DE HIGIENE PERSONAL"
  },
  {
    "codigo":186658007,
    "descripcion":"ENFERMEDAD CAUSADA POR VIRUS COXSACKIE"
  },
  {
    "codigo":1004023000,
    "descripcion":"TRASTORNO NEONATAL DEBIDO A ENFERMEDAD RESPIRATORIA CRÓNICA MATERNA"
  },
  {
    "codigo":283127002,
    "descripcion":"AMPOLLA TRAUMÁTICA DEL PULGAR"
  },
  {
    "codigo":709111008,
    "descripcion":"INSUFICIENCIA RESPIRATORIA AGUDA HIPOXÉMICA"
  },
  {
    "codigo":248524000,
    "descripcion":"MASA RECTAL INDENTADA POR LA APLICACIÓN DE PRESIÓN"
  },
  {
    "codigo":53751009,
    "descripcion":"PÚRPURA SENIL"
  },
  {
    "codigo":281292004,
    "descripcion":"ESPÉCIMEN EXTREMADAMENTE LIPÉMICO"
  },
  {
    "codigo":838348004,
    "descripcion":"NEUROPATÍA AUTONÓMICA DEBIDA A ENFERMEDAD DE TANGIER"
  },
  {
    "codigo":312225001,
    "descripcion":"TRASTORNO MUSCULOESQUELÉTICO Y DEL TEJIDO CONJUNTIVO"
  },
  {
    "codigo":707276009,
    "descripcion":"SÍNDROME DE HOYERAAL-HREIDARSSON"
  },
  {
    "codigo":1082061000119108,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE CONJUNTIVA DE OJO IZQUIERDO"
  },
  {
    "codigo":1295265008,
    "descripcion":"TUMOR TENOSINOVIAL DE CÉLULAS GIGANTES DIFUSO"
  },
  {
    "codigo":408694001,
    "descripcion":"SENSACIÓN DE OPRESIÓN"
  },
  {
    "codigo":246689009,
    "descripcion":"POSTURA OCULAR AL DIRIGIR EL MENTÓN HACIA ARRIBA"
  },
  {
    "codigo":277622004,
    "descripcion":"LINFOMA ASOCIADO A LA MUCOSA"
  },
  {
    "codigo":212086007,
    "descripcion":"QUEMADURA QUE COMPROMETE 60-69 PORCIENTO DE LA SUPERFICIE DEL CUERPO, CON QUEMADURA DE ESPESOR COMPLETO QUE AFECTA 10-19 PORCIENTO DE LA SUPERFICIE CORPORAL"
  },
  {
    "codigo":275787002,
    "descripcion":"BACILOS ACIDORRESISTENTES EN EL ESPUTO"
  },
  {
    "codigo":79179003,
    "descripcion":"TRABAJO DE PARTO INTERMITENTE"
  },
  {
    "codigo":243019007,
    "descripcion":"LESIÓN POR FRAGMENTO DE MINA TERRESTRE"
  },
  {
    "codigo":308555008,
    "descripcion":"ESTADO DEL NIÑO EN EXAMEN MÉDICO"
  },
  {
    "codigo":111947009,
    "descripcion":"PRESENCIA DE TRASTORNO FUNCIONAL, CONDICIÓN TERMINAL"
  },
  {
    "codigo":208416005,
    "descripcion":"FRACTURA EXPUESTA DE CUELLO DE METACARPIANO"
  },
  {
    "codigo":110112006,
    "descripcion":"LACERACIÓN COMPLEJA CONTAMINADA DEL VESTÍBULO MAXILAR"
  },
  {
    "codigo":403189002,
    "descripcion":"ERITROCIANOSIS CON NÓDULOS"
  },
  {
    "codigo":1156853004,
    "descripcion":"OFTALMOPLEJÍA EXTERNA PROGRESIVA AUTOSÓMICA DOMINANTE TIPO 5"
  },
  {
    "codigo":235679000,
    "descripcion":"TRICOBEZOAR"
  },
  {
    "codigo":301215002,
    "descripcion":"LESIÓN SUPRAGLÓTICA"
  },
  {
    "codigo":1251487003,
    "descripcion":"METÁSTASIS DE CARCINOMA DE VÍA BILIAR"
  },
  {
    "codigo":202911004,
    "descripcion":"TENOSINOVITIS DE FLEXOR DE LA MUÑECA"
  },
  {
    "codigo":4468000,
    "descripcion":"MARCHA DE OPPENHEIM"
  },
  {
    "codigo":6303009,
    "descripcion":"LACERACIÓN ANTIGUA DE LA VAGINA"
  },
  {
    "codigo":233844002,
    "descripcion":"ENFERMEDAD CORONARIA ACELERADA EN EL CORAZÓN TRASPLANTADO"
  },
  {
    "codigo":299380002,
    "descripcion":"CREPITACIÓN AUDIBLE DE ARTICULACIÓN DE RODILLA"
  },
  {
    "codigo":364916004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA PONERSE DE PIE LUEGO DE ESTAR SENTADO"
  },
  {
    "codigo":461385004,
    "descripcion":"TRAYECTO ANÓMALO DE ARTERIA CORONARIA A TRAVÉS DE TABIQUE INFUNDIBULAR"
  },
  {
    "codigo":723529006,
    "descripcion":"DIPLOCOCO GRAMNEGATIVO EXTRACELULAR"
  },
  {
    "codigo":264777008,
    "descripcion":"ALTERACIÓN DE LA CONCENTRACIÓN DE LA HEMOGLOBINA"
  },
  {
    "codigo":262942001,
    "descripcion":"SECCIÓN DE ARTERIA CARÓTIDA"
  },
  {
    "codigo":295710000,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE TIOGUANINA"
  },
  {
    "codigo":232009009,
    "descripcion":"DESPRENDIMIENTO REGMATÓGENO DE RETINA - FUERA DE LA MÁCULA"
  },
  {
    "codigo":230174006,
    "descripcion":"ENCEFALITIS POR RHABDOVIRUS"
  },
  {
    "codigo":721694007,
    "descripcion":"PÓLIPO FIBROIDE INFLAMATORIO DE INTESTINO GRUESO"
  },
  {
    "codigo":347291000119104,
    "descripcion":"CANALICULITIS LAGRIMAL AGUDA DE AMBAS REGIONES OCULARES"
  },
  {
    "codigo":228339006,
    "descripcion":"CAPAZ DE CONTROLAR LA BEBIDA"
  },
  {
    "codigo":293875008,
    "descripcion":"ALERGIA A ZOLPIDEM"
  },
  {
    "codigo":160968000,
    "descripcion":"PARTICIPACIÓN EN UNA ACTIVIDAD RIESGOSA"
  },
  {
    "codigo":128200000,
    "descripcion":"SÍNDROME DE DOLOR REGIONAL COMPLEJO"
  },
  {
    "codigo":292040004,
    "descripcion":"REACCIÓN ADVERSA A ANALGÉSICOS"
  },
  {
    "codigo":95432005,
    "descripcion":"NECROSIS DE LOS CORNETES NASALES"
  },
  {
    "codigo":15912091000119107,
    "descripcion":"FRACTURA EXPUESTA DE CABEZA DE FÉMUR DERECHO"
  },
  {
    "codigo":93597003,
    "descripcion":"OSIFICACIÓN INCOMPLETA DEL PREMAXILAR"
  },
  {
    "codigo":716189005,
    "descripcion":"SÍNDROME DE OSTEOPOROSIS Y MACROCEFALIA CON CEGUERA E HIPERMOVILIDAD ARTICULAR"
  },
  {
    "codigo":191901005,
    "descripcion":"PATRÓN DE USO NOCIVO DE ALUCINÓGENO SIN DEPENDENCIA, EN REMISIÓN"
  },
  {
    "codigo":386674000,
    "descripcion":"EYACULACIÓN ANORMAL"
  },
  {
    "codigo":28061009,
    "descripcion":"FORÚNCULO DE CADERA"
  },
  {
    "codigo":124530000,
    "descripcion":"DEFICIENCIA DE TRIMETAFOSFATASA"
  },
  {
    "codigo":58994008,
    "descripcion":"COCCIDIOSIS HEPÁTICA"
  },
  {
    "codigo":253767001,
    "descripcion":"TRASTORNOS FUNCIONALES CONGÉNITOS DEL INTESTINO DELGADO"
  },
  {
    "codigo":1236807002,
    "descripcion":"ENCEFALOPATÍA POR DEFECTO EN FISIÓN MITOCONDRIAL Y PEROXISOMAL"
  },
  {
    "codigo":286535000,
    "descripcion":"NO PREPARA LOS ALIMENTOS HIGIÉNICAMENTE"
  },
  {
    "codigo":288370009,
    "descripcion":"INCAPAZ DE PASAR OBJETOS DE UNA MANO A OTRA"
  },
  {
    "codigo":89927005,
    "descripcion":"PARÁLISIS DE LA LARINGE"
  },
  {
    "codigo":88092000,
    "descripcion":"ATROFIA DE MÚSCULO"
  },
  {
    "codigo":417607009,
    "descripcion":"INFECCIÓN NEUROINVASIVA POR VIRUS DE LA ENCEFALITIS DE SAINT LOUIS"
  },
  {
    "codigo":1234972007,
    "descripcion":"TRASTORNO NEONATAL DEBIDO A TORSIÓN DE CORDÓN UMBILICAL"
  },
  {
    "codigo":53489000,
    "descripcion":"TENSIÓN PSICOLÓGICA"
  },
  {
    "codigo":315633001,
    "descripcion":"LARINGOCELE ADQUIRIDO"
  },
  {
    "codigo":250097000,
    "descripcion":"COMPROMISO MONOARTICULAR"
  },
  {
    "codigo":20721001,
    "descripcion":"TRASTORNO DE VÁLVULA TRICÚSPIDE"
  },
  {
    "codigo":282865003,
    "descripcion":"INCAPAZ DE ADAPTARSE A UNA POSICIÓN"
  },
  {
    "codigo":413937003,
    "descripcion":"TRASTORNO CUTÁNEO CAUSADO POR EL VIRUS DE LA ESTOMATITIS PAPULAR BOVINA"
  },
  {
    "codigo":248262001,
    "descripcion":"SIEMPRE SOMNOLIENTO"
  },
  {
    "codigo":1296838004,
    "descripcion":"HIPERTENSIÓN OCULAR DE OJO DERECHO DEBIDA A HEMÓLISIS POSTERIOR A HEMORRAGIA INTRAOCULAR"
  },
  {
    "codigo":1264070009,
    "descripcion":"TRASTORNO NEONATAL CAUSADO POR DIETILESTILBESTROL TRANSMITIDO POR LECHE MATERNA"
  },
  {
    "codigo":770715005,
    "descripcion":"ALERGIA A FACTOR DE COAGULACIÓN XI"
  },
  {
    "codigo":703344003,
    "descripcion":"REQUIERE VACUNACIÓN CONTRA VARICELA"
  },
  {
    "codigo":1260400009,
    "descripcion":"DISTONÍA DEBIDA A TRAUMATISMO CRANEOENCEFÁLICO"
  },
  {
    "codigo":275525005,
    "descripcion":"ABSCESO AGUDO DE GANGLIO LINFÁTICO"
  },
  {
    "codigo":373829006,
    "descripcion":"HALLAZGO RELACIONADO CON LA PRESENCIA DE TUMORES SINCRÓNICOS EN LA LOCALIZACIÓN PRIMARIA"
  },
  {
    "codigo":406597005,
    "descripcion":"INFECCIÓN CAUSADA POR VIRUS NIPAH"
  },
  {
    "codigo":765210000,
    "descripcion":"TRASTORNO EN REMISIÓN EN RESPUESTA AL TRATAMIENTO"
  },
  {
    "codigo":472133008,
    "descripcion":"TORTUOSIDAD CONGÉNITA DE RAMA DEL CAYADO AÓRTICO"
  },
  {
    "codigo":371994002,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA CARA LARÍNGEA DEL PLIEGUE ARITENOEPIGLÓTICO"
  },
  {
    "codigo":109850001,
    "descripcion":"CARCINOMA IN SITU DE ÓRGANO DIGESTIVO"
  },
  {
    "codigo":370159000,
    "descripcion":"PAÍS DE ORIGEN - HALLAZGO"
  },
  {
    "codigo":42479003,
    "descripcion":"LESIÓN TRAUMÁTICA DE GLÚTEO"
  },
  {
    "codigo":763375003,
    "descripcion":"PARAPLEJÍA ESPÁSTICA AUTOSÓMICA DOMINANTE TIPO 19"
  },
  {
    "codigo":1156591005,
    "descripcion":"DEFECTO DE OXIDACIÓN DE ÁCIDOS GRASOS"
  },
  {
    "codigo":1287663006,
    "descripcion":"TUMOR NEUROENDOCRINO BIEN DIFERENCIADO PRIMARIO DE DUODENO"
  },
  {
    "codigo":1254895007,
    "descripcion":"FISURA DOLOROSA DE CARA DORSOLATERAL DE PIEL DE PULPEJO DE DEDO DE MANO"
  },
  {
    "codigo":239087008,
    "descripcion":"SÍNDROME DE CANTU"
  },
  {
    "codigo":402927009,
    "descripcion":"CELULITIS POR BACTERIAS GRAMNEGATIVAS"
  },
  {
    "codigo":1187524005,
    "descripcion":"DEFICIENCIA DE PEX19"
  },
  {
    "codigo":237252008,
    "descripcion":"TUMOR TROFOBLÁSTICO EN EL SITIO PLACENTARIO"
  },
  {
    "codigo":169881002,
    "descripcion":"PERÍMETRO CEFÁLICO AL NACER: ENTRE PERCENTILOS 50 Y 74"
  },
  {
    "codigo":268185002,
    "descripcion":"ESTENOSIS AÓRTICA SUPRAVALVULAR"
  },
  {
    "codigo":399257006,
    "descripcion":"SANGRADO POR SUPRESIÓN"
  },
  {
    "codigo":71577007,
    "descripcion":"DEFORMIDAD DE PÁRPADO DEBIDA A DERMATITIS INFECCIOSA DE PÁRPADO"
  },
  {
    "codigo":366489006,
    "descripcion":"HALLAZGO RELACIONADO CON LA AMPLITUD DE MOVIMIENTO ACTIVO DE ROTACIÓN EXTERNA DE HOMBRO"
  },
  {
    "codigo":300953009,
    "descripcion":"DOLOR DE AXILA"
  },
  {
    "codigo":266350000,
    "descripcion":"NEUMONÍA LOBAR NEUMOCÓCICA"
  },
  {
    "codigo":102510006,
    "descripcion":"ADOLESCENTE DE SEXO MASCULINO SANO"
  },
  {
    "codigo":69742007,
    "descripcion":"ESCLEROSIS DE LA TÚNICA MEDIA DE MONCKEBERG"
  },
  {
    "codigo":1149251000,
    "descripcion":"FUNCIÓN NEUROVASCULAR PERIFÉRICA ALTERADA"
  },
  {
    "codigo":299118009,
    "descripcion":"HALLAZGO RELACIONADO CON TEMPERATURA DE ARTICULACIÓN DE DEDO DE MANO"
  },
  {
    "codigo":428355002,
    "descripcion":"VIDRIO EN REGIÓN ANTERIOR DEL CUELLO"
  },
  {
    "codigo":788803005,
    "descripcion":"REACCIÓN ALÉRGICA A GALACTOSA-ALFA 1,3 GALACTOSA"
  },
  {
    "codigo":262680002,
    "descripcion":"FRACTURA DE TRÁQUEA"
  },
  {
    "codigo":721432002,
    "descripcion":"LESIÓN COMPLETA DE MÉDULA ESPINAL AL NIVEL DEL TERCER SEGMENTO DORSAL"
  },
  {
    "codigo":536002,
    "descripcion":"CIRROSIS DE GLISSON"
  },
  {
    "codigo":162541000,
    "descripcion":"EL CÓNYUGE PREPARA LA COMIDA"
  },
  {
    "codigo":295448009,
    "descripcion":"SOBREDOSIS DE SULFATO DE MAGNESIO"
  },
  {
    "codigo":719597005,
    "descripcion":"SÍNDROME DE MICRODELECIÓN 19P13.12"
  },
  {
    "codigo":293613006,
    "descripcion":"ALERGIA A DICLOFENACO"
  },
  {
    "codigo":424685008,
    "descripcion":"HERIDA CUTÁNEA POR MORDEDURA"
  },
  {
    "codigo":129773009,
    "descripcion":"LOCALIZACIÓN EN HORA 2 EN LA MAMOGRAFÍA"
  },
  {
    "codigo":193474002,
    "descripcion":"RUPTURA Y HEMORRAGIA COROIDEAS"
  },
  {
    "codigo":95170004,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA VAGINA"
  },
  {
    "codigo":226242006,
    "descripcion":"DIETA VIETNAMITA"
  },
  {
    "codigo":160706007,
    "descripcion":"FALTA DE ESPACIO EN LA CASA"
  },
  {
    "codigo":191639000,
    "descripcion":"TRASTORNO AFECTIVO BIPOLAR MIXTO, MODERADO"
  },
  {
    "codigo":781463005,
    "descripcion":"ENFERMEDAD CAUSADA POR THYSANOSOMATINAE"
  },
  {
    "codigo":224407007,
    "descripcion":"TRABAJA EN EL HOGAR"
  },
  {
    "codigo":93335009,
    "descripcion":"POSICIÓN ANÓMALA CONGÉNITA DEL METACARPO"
  },
  {
    "codigo":124268002,
    "descripcion":"DEFICIENCIA DE 1, 4 - ALFA - GLUCANO GALFA - GLUCOSILTRANSFERASA"
  },
  {
    "codigo":1303916006,
    "descripcion":"MIELOSQUISIS SACULAR DORSAL LIMITADA"
  },
  {
    "codigo":1172844009,
    "descripcion":"DEFICIENCIA COMBINADA DE LA FOSFORILACIÓN OXIDATIVA TIPO 27"
  },
  {
    "codigo":286273002,
    "descripcion":"DIFICULTAD PARA USAR LA ARTICULACIÓN SECUNDARIA"
  },
  {
    "codigo":24129002,
    "descripcion":"FASCITIS EOSINÓFILA"
  },
  {
    "codigo":187969004,
    "descripcion":"NEOPLASIA MALIGNA DEL CUNEIFORME INTERMEDIO"
  },
  {
    "codigo":55062001,
    "descripcion":"PASAJERO EN ASIENTO DELANTERO EN ACCIDENTE VEHICULAR Y\/O DE TRÁNSITO"
  },
  {
    "codigo":448278002,
    "descripcion":"DRENAJE DE SENO CORONARIO POR ENCIMA DE VENA CAVA SUPERIOR IZQUIERDA"
  },
  {
    "codigo":253505009,
    "descripcion":"ANOMALÍA EN ARCADA DE CUERDAS TENDINOSAS DE VÁLVULA AURICULOVENTRICULAR IZQUIERDA"
  },
  {
    "codigo":415510005,
    "descripcion":"ESTILO DE VIDA SEDENTARIO"
  },
  {
    "codigo":186134009,
    "descripcion":"INFECCIÓN DEL TRACTO GASTROINTESTINAL POR SALMONELLA ENTERICA ARIZONAE"
  },
  {
    "codigo":85995004,
    "descripcion":"TRASTORNO HEREDITARIO AUTOSÓMICO RECESIVO"
  },
  {
    "codigo":282603005,
    "descripcion":"NO SALTA"
  },
  {
    "codigo":446443005,
    "descripcion":"INTOXICACIÓN POR INGESTIÓN DE TOXINA DE PESCADO"
  },
  {
    "codigo":18624000,
    "descripcion":"ENFERMEDAD CAUSADA POR ROTAVIRUS"
  },
  {
    "codigo":774123009,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE PIE DERECHO"
  },
  {
    "codigo":248000000,
    "descripcion":"CONDUCTA PROVOCATIVA"
  },
  {
    "codigo":29741000175108,
    "descripcion":"ÚLCERA POR PRESIÓN EN CADERA DERECHA, ESTADIO II"
  },
  {
    "codigo":84160009,
    "descripcion":"HEMIPLEJÍA LARÍNGEA"
  },
  {
    "codigo":442773002,
    "descripcion":"ORGANISMO AISLADO EN CULTIVO MICROBIANO DE ESPUTO"
  },
  {
    "codigo":278933001,
    "descripcion":"FRACTURA DE CORONA DENTAL"
  },
  {
    "codigo":735850001,
    "descripcion":"LUXACIÓN TRAUMÁTICA LATERAL DE ARTICULACIÓN TIBIOFEMORAL"
  },
  {
    "codigo":734015000,
    "descripcion":"CARCINOMA RENAL PAPILAR DE CÉLULAS CLARAS"
  },
  {
    "codigo":275263003,
    "descripcion":"SÍNDROME DE KLINEFELTER, XXXY"
  },
  {
    "codigo":404500000,
    "descripcion":"HALLAZGO DE LEVADURA CON SEUDOHIFAS"
  },
  {
    "codigo":308031009,
    "descripcion":"ATENDIDO EN DEPARTAMENTO"
  },
  {
    "codigo":240660003,
    "descripcion":"HERPETOSOMA"
  },
  {
    "codigo":109588005,
    "descripcion":"RESORCIÓN DE VÉRTICE DE RAÍZ DENTAL"
  },
  {
    "codigo":15726801000119106,
    "descripcion":"ANQUILOSIS DE AMBAS ARTICULACIONES DE CADERA"
  },
  {
    "codigo":402665000,
    "descripcion":"DERMATOSIS POR INSUFICIENCIA VASCULAR"
  },
  {
    "codigo":271593001,
    "descripcion":"MORIBUNDO"
  },
  {
    "codigo":42217008,
    "descripcion":"INFECCIÓN CAUSADA POR PYTHIUM"
  },
  {
    "codigo":11768171000119102,
    "descripcion":"AMPUTACIÓN PARCIAL TRAUMÁTICA DE EXTREMIDAD SUPERIOR IZQUIERDA"
  },
  {
    "codigo":40382002,
    "descripcion":"TOXICIDAD POR ÁCIDO ASCÓRBICO"
  },
  {
    "codigo":398995000,
    "descripcion":"PROLAPSO DE VÁLVULA CARDÍACA"
  },
  {
    "codigo":38547003,
    "descripcion":"TRASTORNO DEL ESTADO DE ÁNIMO, EN REMISIÓN TOTAL"
  },
  {
    "codigo":202387004,
    "descripcion":"DERRAME DE LA PRIMERA ARTICULACIÓN METATARSOFALÁNGICA"
  },
  {
    "codigo":705220971000119104,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN DE TEJIDO PROFUNDO DE CADERA DERECHA"
  },
  {
    "codigo":300691006,
    "descripcion":"NO MANEJA DINERO"
  },
  {
    "codigo":71315007,
    "descripcion":"DISPAREUNIA"
  },
  {
    "codigo":366227008,
    "descripcion":"INCLINACIÓN DE MOLAR - HALLAZGO"
  },
  {
    "codigo":298856001,
    "descripcion":"ARTICULACIÓN DE HOMBRO DOLOROSA A LA PALPACIÓN"
  },
  {
    "codigo":41321000087106,
    "descripcion":"HEMATOMA DE SEGUNDO DEDO DE PIE IZQUIERDO"
  },
  {
    "codigo":43881000087101,
    "descripcion":"HERIDA CORTANTE DE PIEL DE DEDO MEDIO IZQUIERDO"
  },
  {
    "codigo":724840004,
    "descripcion":"EPIDERMÓLISIS BULLOSA SIMPLE SUPRABASAL"
  },
  {
    "codigo":3944006,
    "descripcion":"DEFICIENCIA DE SULFATASA PLACENTARIA"
  },
  {
    "codigo":297021002,
    "descripcion":"SOBREDOSIS DE BUMETANIDA"
  },
  {
    "codigo":2109003,
    "descripcion":"DEFICIENCIA AISLADA DE HORMONA DEL CRECIMIENTO"
  },
  {
    "codigo":723005006,
    "descripcion":"EFLUVIO TELÓGENO AGUDO"
  },
  {
    "codigo":231485007,
    "descripcion":"DEPRESIÓN POSESQUIZOFRÉNICA"
  },
  {
    "codigo":1148989006,
    "descripcion":"INGESTA EXCESIVA DE SAL DE SULFATO"
  },
  {
    "codigo":67645006,
    "descripcion":"TRASTORNO RELACIONADO CON GESTACIÓN CORTA Y\/O BAJO PESO AL NACER"
  },
  {
    "codigo":33042004,
    "descripcion":"INFESTACIÓN PARASITARIA DE LA PIEL"
  },
  {
    "codigo":229650007,
    "descripcion":"VOZ BUCAL"
  },
  {
    "codigo":295186009,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE MORFINA"
  },
  {
    "codigo":293351004,
    "descripcion":"REACCIÓN ADVERSA AL COLÁGENO"
  },
  {
    "codigo":424423005,
    "descripcion":"BARRERAS IDIOMÁTICAS DIFICULTAN LA CAPACIDAD PARA UTILIZAR RECURSOS COMUNITARIOS"
  },
  {
    "codigo":1145319006,
    "descripcion":"RAFE MEDIO CONGÉNITO DE SURCO NASOLABIAL"
  },
  {
    "codigo":63975004,
    "descripcion":"LUXACIÓN NO EXPUESTA POSTERIOR DE LA CADERA"
  },
  {
    "codigo":162279009,
    "descripcion":"ALTERACIÓN VISUAL TRANSITORIA"
  },
  {
    "codigo":422588002,
    "descripcion":"NEUMONÍA POR ASPIRACIÓN"
  },
  {
    "codigo":291516002,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR ESPECTINOMICINA"
  },
  {
    "codigo":94908004,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE AMÍGDALA LINGUAL"
  },
  {
    "codigo":193212008,
    "descripcion":"SÍNDROME MIASTÉNICO POR HIPOTIROIDISMO"
  },
  {
    "codigo":191377002,
    "descripcion":"LINFADENITIS MESENTÉRICA CRÓNICA"
  },
  {
    "codigo":93073002,
    "descripcion":"HIPERTROFIA CONGÉNITA DE OVARIO"
  },
  {
    "codigo":224145003,
    "descripcion":"VIVE COMO ACOMPAÑANTE"
  },
  {
    "codigo":715665006,
    "descripcion":"NEUROPATÍA SENSITIVA Y MOTRIZ HEREDITARIA, TIPO OKINAWA"
  },
  {
    "codigo":1141649007,
    "descripcion":"FAMILIA QUE FUNCIONA EFICIENTEMENTE"
  },
  {
    "codigo":781201007,
    "descripcion":"ASCARIASIS CAUSADA POR ASCARIS ADULTO"
  },
  {
    "codigo":289681009,
    "descripcion":"ÚTERO GRÁVIDO PEQUEÑO PARA LA EDAD GESTACIONAL"
  },
  {
    "codigo":25702006,
    "descripcion":"INTOXICACIÓN ALCOHÓLICA"
  },
  {
    "codigo":124006006,
    "descripcion":"MANOHEPTULOSA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":418918009,
    "descripcion":"INFARTO MACULAR"
  },
  {
    "codigo":286011002,
    "descripcion":"ENCIENDE UN DISPOSITIVO DOMÉSTICO"
  },
  {
    "codigo":1269051002,
    "descripcion":"MEDULOBLASTOMA NODULAR DESMOPLÁSICO PRIMARIO DE CEREBRO"
  },
  {
    "codigo":253243008,
    "descripcion":"DISTOPÍA VERTICAL DE ÓRBITA"
  },
  {
    "codigo":448016001,
    "descripcion":"ANEURISMA CONGÉNITO DE ARTERIA SISTÉMICA"
  },
  {
    "codigo":22032002,
    "descripcion":"FACTOR SOCIAL RELACIONADO CON LA FAMILIA"
  },
  {
    "codigo":710160002,
    "descripcion":"LENGUA HIPERACTIVA"
  },
  {
    "codigo":249573001,
    "descripcion":"LOCALIZACIÓN DEL BORDE ESPLÉNICO"
  },
  {
    "codigo":870330000,
    "descripcion":"PANUVEÍTIS CAUSADA POR PARÁSITO"
  },
  {
    "codigo":83898004,
    "descripcion":"VALVULOPATÍA MITRAL REUMÁTICA"
  },
  {
    "codigo":1263546008,
    "descripcion":"HIPERTENSIÓN INTRACRANEAL BENIGNA DEBIDA A TRASTORNO ENDOCRINO"
  },
  {
    "codigo":247738008,
    "descripcion":"ALUCINACIONES DE DOLOR"
  },
  {
    "codigo":213135007,
    "descripcion":"DISPOSITIVO PROTÉSICO INTERNO QUE PROVOCA ESTENOSIS"
  },
  {
    "codigo":80228000,
    "descripcion":"DESCENSO DEL FETO"
  },
  {
    "codigo":442511009,
    "descripcion":"SÍNDROME DE ENCEFALOPATÍA PROGRESIVA CON EDEMA, HIPSARRITMIA Y ATROFIA ÓPTICA"
  },
  {
    "codigo":276836002,
    "descripcion":"LINFOMA CEREBRAL PRIMARIO"
  },
  {
    "codigo":278671007,
    "descripcion":"ANGULACIÓN DE DIENTE INCISIVO - DISTAL"
  },
  {
    "codigo":473444001,
    "descripcion":"ORIGEN ANÓMALO DE ARTERIA CORONARIA IZQUIERDA"
  },
  {
    "codigo":735588005,
    "descripcion":"ASMA ALÉRGICA SIN COMPLICACIONES"
  },
  {
    "codigo":209465006,
    "descripcion":"ESGUINCE INTERFALÁNGICO"
  },
  {
    "codigo":897593008,
    "descripcion":"RUPTURA CONGÉNITA DE ARTERIA ONFALOMESENTÉRICA"
  },
  {
    "codigo":78393008,
    "descripcion":"HIPOPLASIA CONGÉNITA DE DEDO DE LA MANO"
  },
  {
    "codigo":404238002,
    "descripcion":"MENINGITIS CAUSADA POR VIRUS JAMESTOWN CANYON"
  },
  {
    "codigo":764686003,
    "descripcion":"PARAPLEJÍA ESPÁSTICA AUTOSÓMICA RECESIVA TIPO 15"
  },
  {
    "codigo":109326005,
    "descripcion":"OSTEOMIELITIS ESCLEROSANTE CRÓNICA NO SUPURATIVA DE COMPLEJO ORBITONASAL"
  },
  {
    "codigo":240398007,
    "descripcion":"PASTEURELOSIS DE PARTES BLANDAS"
  },
  {
    "codigo":402403000,
    "descripcion":"URTICARIA SECUNDARIA A INFECCIÓN"
  },
  {
    "codigo":830222008,
    "descripcion":"DESGARRO DE MUCOSA DE ESÓFAGO"
  },
  {
    "codigo":271331002,
    "descripcion":"PIE DE INMERSIÓN"
  },
  {
    "codigo":369635003,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA DEL URÉTER, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":1187000005,
    "descripcion":"MONONUCLEOSIS INFECCIOSA CAUSADA POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":236728006,
    "descripcion":"DESPLAZAMIENTO DE LA PRÓTESIS TESTICULAR"
  },
  {
    "codigo":269496008,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE GLÁNDULAS ENDOCRINAS Y SISTEMA NERVIOSO"
  },
  {
    "codigo":72888009,
    "descripcion":"HERNIA MESENTÉRICA"
  },
  {
    "codigo":431501001,
    "descripcion":"FÍSTULA PIELOCUTÁNEA"
  },
  {
    "codigo":365965002,
    "descripcion":"HALLAZGO RELACIONADO CON LA LIBIDO"
  },
  {
    "codigo":38285004,
    "descripcion":"APÓFISIS ALVEOLAR IRREGULAR"
  },
  {
    "codigo":300429005,
    "descripcion":"HALLAZGO RELACIONADO CON LOS RUIDOS INTESTINALES"
  },
  {
    "codigo":398733004,
    "descripcion":"RUPTURA PARCIAL DE LIGAMENTO"
  },
  {
    "codigo":433336009,
    "descripcion":"CABEZA ACOMODADA EN PINZA DE CUATRO PUNTOS"
  },
  {
    "codigo":890253008,
    "descripcion":"DERMATITIS IRRITATIVA DE CONTACTO POR CONCRETO"
  },
  {
    "codigo":2241000124104,
    "descripcion":"SEGUNDO MOLAR INFERIOR IZQUIERDO TEMPORARIO SUPERNUMERARIO"
  },
  {
    "codigo":611521000124106,
    "descripcion":"DISPONE DE MEDIO DE TRANSPORTE PARA ACCEDER A ATENCIÓN SANITARIA"
  },
  {
    "codigo":298594006,
    "descripcion":"COLUMNA LUMBAR TUMEFACTA"
  },
  {
    "codigo":724578006,
    "descripcion":"NEOPLASIA OSTEÓGENA BENIGNA DE CARTÍLAGO ARTICULAR DE MIEMBRO"
  },
  {
    "codigo":67383002,
    "descripcion":"ENTROPIÓN CICATRIZAL"
  },
  {
    "codigo":15649901000119104,
    "descripcion":"GANGRENA DE MIEMBRO INFERIOR DERECHO DEBIDA A ATEROSCLEROSIS"
  },
  {
    "codigo":296759005,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE MINOCICLINA"
  },
  {
    "codigo":460599007,
    "descripcion":"DISFUNCIÓN DE MÚSCULO PAPILAR DE VÁLVULA TRICÚSPIDE"
  },
  {
    "codigo":34615008,
    "descripcion":"HEMATOSPERMIA"
  },
  {
    "codigo":294924001,
    "descripcion":"ALERGIA A VITAMINA D Y\/O DERIVADO DE VITAMINA D"
  },
  {
    "codigo":1847009,
    "descripcion":"ENDOFTALMITIS"
  },
  {
    "codigo":131084000,
    "descripcion":"NIVEL DE CORTISONA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":330861000119105,
    "descripcion":"XERODERMIA DE PÁRPADO INFERIOR IZQUIERDO"
  },
  {
    "codigo":16033031000119100,
    "descripcion":"NECROSIS AVASCULAR DE AMBAS CLAVÍCULAS"
  },
  {
    "codigo":1145057000,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE CLORAZEPATO"
  },
  {
    "codigo":425996009,
    "descripcion":"NEUMONÍA BASAL BILATERAL"
  },
  {
    "codigo":293089002,
    "descripcion":"REACCIÓN ADVERSA AL LINDANO"
  },
  {
    "codigo":30945003,
    "descripcion":"FIEBRE TAHYNA"
  },
  {
    "codigo":194785008,
    "descripcion":"HIPERTENSIÓN ARTERIAL BENIGNA SECUNDARIA"
  },
  {
    "codigo":12100871000119102,
    "descripcion":"QUEMADURA DE REGIÓN AXILAR IZQUIERDA"
  },
  {
    "codigo":782774004,
    "descripcion":"SÍNDROME DE MEIGS ATÍPICO"
  },
  {
    "codigo":29110005,
    "descripcion":"AUSENCIA CONGÉNITA DEL INTESTINO DELGADO"
  },
  {
    "codigo":60043000,
    "descripcion":"CALAMBRES DEL ABDOMEN MEDIO"
  },
  {
    "codigo":94646009,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL NERVIO TRIGÉMINO"
  },
  {
    "codigo":92811003,
    "descripcion":"LEUCEMIA CRÓNICA EN REMISIÓN"
  },
  {
    "codigo":715403006,
    "descripcion":"TUMOR CARDÍACO EN PACIENTE ADULTO"
  },
  {
    "codigo":289419006,
    "descripcion":"FONTANELA POSTERIOR PALPABLE EN LA REGIÓN POSTERIOR"
  },
  {
    "codigo":713568000,
    "descripcion":"OCASIONALMENTE CANSADO"
  },
  {
    "codigo":1010315009,
    "descripcion":"TRASTORNO NEONATAL DEBIDO A OBESIDAD MATERNA CON UN ÍNDICE DE MASA CORPORAL PARA ADULTO DE 40 O SUPERIOR"
  },
  {
    "codigo":189280002,
    "descripcion":"CARCINOMA IN SITU DE PIEL DE CONDUCTO AUDITIVO EXTERNO"
  },
  {
    "codigo":1303392004,
    "descripcion":"FRACTURA ÓSEA DE ARTICULACIÓN DE CODO IZQUIERDO"
  },
  {
    "codigo":25440005,
    "descripcion":"INTOXICACIÓN POR TETRACLORODIBENZODIOXINA"
  },
  {
    "codigo":89141000,
    "descripcion":"MIOCARDITIS VIRAL"
  },
  {
    "codigo":449589001,
    "descripcion":"ESTENOSIS ÚNICA DE ARTERIA PULMONAR DERECHA"
  },
  {
    "codigo":285749004,
    "descripcion":"LESIÓN DE LA VENA SISTÉMICA"
  },
  {
    "codigo":251146004,
    "descripcion":"VOLTAJES DEL QRS BAJOS"
  },
  {
    "codigo":54538006,
    "descripcion":"MICROANGIOPATÍA DIETÉTICA"
  },
  {
    "codigo":413151002,
    "descripcion":"BAJO ATENCIÓN DE ENFERMERA ESPECIALIZADA EN PEDIATRÍA"
  },
  {
    "codigo":183775004,
    "descripcion":"INSCRIPTO EN LISTA DE ADMISIÓN GASTROENTEROLÓGICA"
  },
  {
    "codigo":85471005,
    "descripcion":"ÁNTRAX DE MAMA"
  },
  {
    "codigo":314847007,
    "descripcion":"EL PACIENTE POSEE SEGURO MÉDICO PRIVADO"
  },
  {
    "codigo":118239008,
    "descripcion":"HALLAZGO EN EL SISTEMA LINFÁTICO"
  },
  {
    "codigo":83636001,
    "descripcion":"SIGNO OMEGA"
  },
  {
    "codigo":52703008,
    "descripcion":"INTOXICACIÓN POR PROPRANOLOL"
  },
  {
    "codigo":249311009,
    "descripcion":"NARIZ GRANDE"
  },
  {
    "codigo":247476001,
    "descripcion":"MARCA CONGÉNITA ELEVADA"
  },
  {
    "codigo":1163145003,
    "descripcion":"COLITIS CAUSADA POR ACTINOMYCES"
  },
  {
    "codigo":737161008,
    "descripcion":"TRASTORNO DE ARTERIOLA"
  },
  {
    "codigo":473182001,
    "descripcion":"OBSTRUCCIÓN DE DISPOSITIVO DE ACCESO VENOSO COMPLETAMENTE IMPLANTABLE"
  },
  {
    "codigo":14430002,
    "descripcion":"ESTENOSIS CONGÉNITA DEL INTESTINO DELGADO"
  },
  {
    "codigo":211038003,
    "descripcion":"ABRASIÓN DE PIEL DE REGIÓN INTERESCAPULAR DE DORSO"
  },
  {
    "codigo":333371000119102,
    "descripcion":"ESCOTOMA PARACENTRAL DERECHO"
  },
  {
    "codigo":1259614007,
    "descripcion":"COREA DEBIDA A ENFERMEDAD NEOPLÁSICA MALIGNA GENERALIZADA"
  },
  {
    "codigo":702558009,
    "descripcion":"PROVOCACIÓN BACTERIANA INTERMEDIA"
  },
  {
    "codigo":373043002,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM MICROTI"
  },
  {
    "codigo":274739003,
    "descripcion":"TUMEFACCIÓN TORÁCICA"
  },
  {
    "codigo":11802371000119100,
    "descripcion":"AMPOLLA TRAUMÁTICA DE PIEL DE GENITALES FEMENINOS"
  },
  {
    "codigo":341251000119101,
    "descripcion":"VASO FANTASMA DE CÓRNEA DE OJO IZQUIERDO"
  },
  {
    "codigo":10752771000119100,
    "descripcion":"INSUFICIENCIA RENAL DESPUÉS DE EMBARAZO ECTÓPICO"
  },
  {
    "codigo":674051000119103,
    "descripcion":"DOLOR CERVICAL CRÓNICO DURANTE MÁS DE 3 MESES"
  },
  {
    "codigo":698888000,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: AZERÍ"
  },
  {
    "codigo":139011000119104,
    "descripcion":"ARTERIOESCLEROSIS CORONARIA DESPUÉS DE INJERTO-PUENTE DE ARTERIA CORONARIA"
  },
  {
    "codigo":346371000119105,
    "descripcion":"DACRIOLITO DE AMBOS OJOS"
  },
  {
    "codigo":305411000119106,
    "descripcion":"CONTRACTURA DE MÚSCULO DE MUSLO DERECHO"
  },
  {
    "codigo":3331000119108,
    "descripcion":"DISTONÍA LARÍNGEA"
  },
  {
    "codigo":771000119108,
    "descripcion":"ENFERMEDAD RENAL CRÓNICA DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":1088771000119102,
    "descripcion":"ABSCESO DE OÍDO EXTERNO IZQUIERDO"
  },
  {
    "codigo":5891000119102,
    "descripcion":"DIARREA POR CLOSTRIDIUM DIFFICILE"
  },
  {
    "codigo":151811000119109,
    "descripcion":"PROBLEMA DE SALUD TEMIDO PERO NO PRESENTE"
  },
  {
    "codigo":1075971000119104,
    "descripcion":"RUPTURA DE QUISTE SINOVIAL DE RODILLA DERECHA"
  },
  {
    "codigo":762589002,
    "descripcion":"DOLOR VISCERAL PRIMARIO CRÓNICO"
  },
  {
    "codigo":10947331000119109,
    "descripcion":"HERIDA ABIERTA DE DEDO ÍNDICE IZQUIERDO DEBIDA A MORDEDURA DE PERRO"
  },
  {
    "codigo":402141004,
    "descripcion":"LEISHMANIASIS MUCOCUTÁNEA\/CUTÁNEA NORTEAMERICANA"
  },
  {
    "codigo":85251000119108,
    "descripcion":"ALTERACIÓN DE ARTICULACIÓN RADIOCARPIANA"
  },
  {
    "codigo":331011000119109,
    "descripcion":"ALTERACIÓN VASCULAR DE PÁRPADO SUPERIOR DERECHO"
  },
  {
    "codigo":403976007,
    "descripcion":"HEMANGIOMA GLOMERULOIDE"
  },
  {
    "codigo":302002000,
    "descripcion":"DIFICULTAD PARA MOVERSE"
  },
  {
    "codigo":1286877004,
    "descripcion":"NEOPLASIA COLORRECTAL MALIGNA"
  },
  {
    "codigo":860893008,
    "descripcion":"ENFERMEDAD GLOMERULAR DEBIDA A ENFERMEDAD PARASITARIA"
  },
  {
    "codigo":170930003,
    "descripcion":"NUEVA PRESCRIPCIÓN REVISADA POR EL HOSPITAL"
  },
  {
    "codigo":236466005,
    "descripcion":"SÍNDROME DE FANCONI CONGÉNITO"
  },
  {
    "codigo":15953621000119103,
    "descripcion":"ABSCESO DE MAMA IZQUIERDA ASOCIADO CON LA LACTANCIA"
  },
  {
    "codigo":38023001,
    "descripcion":"SÍNDROME DE DESCONEXIÓN PONTINA"
  },
  {
    "codigo":300167001,
    "descripcion":"MARTILLO-HALLAZGO"
  },
  {
    "codigo":234631003,
    "descripcion":"INMUNODEFICIENCIA CON ANOMALÍAS MAYORES"
  },
  {
    "codigo":1217671004,
    "descripcion":"CONJUNTIVITIS FOLICULAR CRÓNICA POR CHLAMYDIA"
  },
  {
    "codigo":365703004,
    "descripcion":"AISLAMIENTO POSTMORTEM: ORGANISMO - HALLAZGO"
  },
  {
    "codigo":36188001,
    "descripcion":"SHIGELOSIS"
  },
  {
    "codigo":462172006,
    "descripcion":"INSUFICIENCIA CARDÍACA FETAL"
  },
  {
    "codigo":298332008,
    "descripcion":"RESPUESTA MOTORA LOCALIZADA LUEGO DE UNA ORDEN"
  },
  {
    "codigo":296497006,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE METOCARBAMOL"
  },
  {
    "codigo":1179398000,
    "descripcion":"INFECCIÓN PERINATAL MATERNA"
  },
  {
    "codigo":294662001,
    "descripcion":"ALERGIA A COMPONENTE DE VACUNA QUE CONTIENE ANTÍGENOS DE MORBILIVIRUS DEL SARAMPIÓN, ORTORUBULAVIRUS DE LA PAROTIDITIS Y VIRUS DE LA RUBÉOLA"
  },
  {
    "codigo":67121008,
    "descripcion":"EFECTO TÓXICO DEL DIÓXIDO DE PLOMO"
  },
  {
    "codigo":32518004,
    "descripcion":"INTOXICACIÓN POR DIAZÓXIDO"
  },
  {
    "codigo":818950005,
    "descripcion":"SÍNDROME DE BLAU"
  },
  {
    "codigo":784347002,
    "descripcion":"SÍNDROME DE ATAXIA ESPÁSTICA AUTOSÓMICA RECESIVA, ATROFIA ÓPTICA Y DISARTRIA"
  },
  {
    "codigo":292827008,
    "descripcion":"REACCIÓN ADVERSA A INOSINA PRANOBEX"
  },
  {
    "codigo":94384005,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA ENCÍA INFERIOR"
  },
  {
    "codigo":127152007,
    "descripcion":"LINFADENOPATÍA CÓLICA"
  },
  {
    "codigo":289157003,
    "descripcion":"HALLAZGO RELACIONADO CON LA VELOCIDAD DE LA ALIMENTACIÓN"
  },
  {
    "codigo":92549006,
    "descripcion":"CARCINOMA IN SITU DEL CUERPO DEL ESTÓMAGO"
  },
  {
    "codigo":1335898006,
    "descripcion":"ANTICUERPO CONTRA LENTIVIRUS DETECTADO"
  },
  {
    "codigo":285487006,
    "descripcion":"ESTIRA LOS LABIOS"
  },
  {
    "codigo":283652001,
    "descripcion":"HERIDA POR PINCHAZO DE CLAVO EN LA CABEZA"
  },
  {
    "codigo":52441000,
    "descripcion":"VAGINITIS ATRÓFICA"
  },
  {
    "codigo":609497003,
    "descripcion":"COMPLICACIÓN VENOSA EN EL PUERPERIO"
  },
  {
    "codigo":1363161003,
    "descripcion":"ASTILLA EN PARED ABDOMINAL CON INFECCIÓN"
  },
  {
    "codigo":85209005,
    "descripcion":"INTOXICACIÓN CAUSADA POR NITRITO"
  },
  {
    "codigo":50606000,
    "descripcion":"SELECCIÓN GENÉTICA"
  },
  {
    "codigo":83374004,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE LA MUÑECA, CON INFECCIÓN"
  },
  {
    "codigo":279982005,
    "descripcion":"DEGENERACIÓN CEREBRAL QUE SE MANIFIESTA PRINCIPALMENTE CON DEMENCIA"
  },
  {
    "codigo":16003001,
    "descripcion":"ENFISEMA BULLOSO GIGANTE"
  },
  {
    "codigo":278147001,
    "descripcion":"GRUPO SANGUÍNEO 0 RH(D) POSITIVO"
  },
  {
    "codigo":81539007,
    "descripcion":"METATARSO PRIMUS VARO"
  },
  {
    "codigo":1162883007,
    "descripcion":"INESTABILIDAD CONGÉNITA BILATERAL DE CADERA"
  },
  {
    "codigo":1259352001,
    "descripcion":"CARCINOMA PRIMARIO DE CUERPO DE ESTÓMAGO"
  },
  {
    "codigo":448819009,
    "descripcion":"ORIENTACIÓN DE VÁLVULA AÓRTICA BICÚSPIDE DE DERECHA A IZQUIERDA"
  },
  {
    "codigo":309080005,
    "descripcion":"NIVEL DE HORMONA TIROESTIMULANTE POR ENCIMA DE RANGO DE REFERENCIA"
  },
  {
    "codigo":14168008,
    "descripcion":"RABIA"
  },
  {
    "codigo":405549001,
    "descripcion":"ABSCESO DE TEJIDO CONJUNTIVO"
  },
  {
    "codigo":733229002,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA A LA ALTURA DE ARTICULACIÓN DEL HOMBRO IZQUIERDO"
  },
  {
    "codigo":866136008,
    "descripcion":"INFECCIÓN DE VAINA DE TENDÓN CAUSADA POR MYCOBACTERIUM"
  },
  {
    "codigo":208941005,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE LA ARTICULACIÓN DE LA RODILLA, ROTATORIA"
  },
  {
    "codigo":895234000,
    "descripcion":"FORMA ANCHA ANORMAL CONGÉNITA DE FALANGE DE DEDO MEDIO DE MANO"
  },
  {
    "codigo":239874001,
    "descripcion":"ARTROSIS DE TOBILLO"
  },
  {
    "codigo":698626001,
    "descripcion":"DEMENCIA ASOCIADA CON ESCLEROSIS MÚLTIPLE"
  },
  {
    "codigo":403714009,
    "descripcion":"MELANOMA MALIGNO ASOCIADO CON FOTOQUIMIOTERAPIA CON PSORALENO Y RADIACIÓN ULTRAVIOLETA DE ONDA LARGA"
  },
  {
    "codigo":762327001,
    "descripcion":"TRASTORNO PSICÓTICO CON IDEAS DELIRANTES CAUSADO POR ESTIMULANTE"
  },
  {
    "codigo":41431007,
    "descripcion":"CAPACIDAD PULMONAR TOTAL NORMAL"
  },
  {
    "codigo":8663007,
    "descripcion":"SÍNDROME DE COLA DE CABALLO SIN VEJIGA NEUROGÉNICA"
  },
  {
    "codigo":205271007,
    "descripcion":"MÚSCULO EXTENSOR DEL ANTEBRAZO ABERRANTE"
  },
  {
    "codigo":400044004,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE PIEL"
  },
  {
    "codigo":301740005,
    "descripcion":"NO REALIZA ACTIVIDADES DE OFICINA"
  },
  {
    "codigo":103297000,
    "descripcion":"VÉRTIGO CAUSADO POR MEDICAMENTO"
  },
  {
    "codigo":430977001,
    "descripcion":"PÉRDIDA DE LA AUDICIÓN NEURAL BILATERAL"
  },
  {
    "codigo":299905002,
    "descripcion":"SENSACIÓN DE CALOR REDUCIDA"
  },
  {
    "codigo":168833002,
    "descripcion":"SERIADA GASTROINTESTINAL CON BARIO, NORMAL"
  },
  {
    "codigo":70529004,
    "descripcion":"HIPERPLASIA LINFOIDEA DE APÉNDICE ILEOCECAL"
  },
  {
    "codigo":365441007,
    "descripcion":"IMPULSO - HALLAZGO"
  },
  {
    "codigo":298070000,
    "descripcion":"CUERPO EXTRAÑO EN CUERO CABELLUDO"
  },
  {
    "codigo":37761009,
    "descripcion":"QUISTE DE IRIS"
  },
  {
    "codigo":1217409009,
    "descripcion":"DEFICIENCIA DE PROTEÍNA S ADQUIRIDA"
  },
  {
    "codigo":3158007,
    "descripcion":"TRASTORNO DE PÁNICO CON AGORAFOBIA, EVITACIÓN AGORAFÓBICA EN REMISIÓN PARCIAL Y ATAQUES DE PÁNICO EN REMISIÓN PARCIAL"
  },
  {
    "codigo":296235004,
    "descripcion":"SOBREDOSIS INTENCIONAL DE PROMAZINA"
  },
  {
    "codigo":1323006,
    "descripcion":"INTOXICACIÓN POR KANAMICINA"
  },
  {
    "codigo":230699008,
    "descripcion":"HEMIPARESIA MOTORA PURA DEBIDA A INFARTO LACUNAR Y SECUNDARIO A ÉL"
  },
  {
    "codigo":294400001,
    "descripcion":"ALERGIA A QUINACRINA"
  },
  {
    "codigo":390869002,
    "descripcion":"TÉCNICA DE INHALACIÓN - MODERADA"
  },
  {
    "codigo":11780721000119102,
    "descripcion":"CONTUSIÓN DE ANTEBRAZO DERECHO"
  },
  {
    "codigo":716714003,
    "descripcion":"BORDE GINGIVAL INCONSTANTE"
  },
  {
    "codigo":94122003,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL ORIFICIO URETERAL DE LA VEJIGA"
  },
  {
    "codigo":419967000,
    "descripcion":"ALERGIA A OSTRA"
  },
  {
    "codigo":126890009,
    "descripcion":"NEOPLASIA DE LA PARED POSTERIOR DE LA VEJIGA"
  },
  {
    "codigo":288895002,
    "descripcion":"CAPAZ DE CONTROLAR EL BOLO ALIMENTICIO"
  },
  {
    "codigo":11862641000119104,
    "descripcion":"HERIDA DE TOBILLO IZQUIERDO DEBIDA A PICADURA DE INSECTO NO VENENOSO"
  },
  {
    "codigo":92287004,
    "descripcion":"NEOPLASIA BENIGNA DEL TEJIDO PERISUPRARRENAL"
  },
  {
    "codigo":876884000,
    "descripcion":"FALLECIDO EN CENTRO DE CUIDADOS DE PACIENTES CRÓNICOS CON ATENCIÓN DE ENFERMERÍA"
  },
  {
    "codigo":385364001,
    "descripcion":"ESTADIO PARA TUMOR OVÁRICO DE LA FEDERACIÓN INTERNACIONAL DE GINECOLOGÍA Y OBSTETRICIA (FIGO) - HALLAZGO"
  },
  {
    "codigo":15712881000119105,
    "descripcion":"INFARTO AGUDO DE PARED ANTEROLATERAL DE MIOCARDIO CON ELEVACIÓN DEL SEGMENTO ST"
  },
  {
    "codigo":57684003,
    "descripcion":"HIPERTENSIÓN RENAL PARENQUIMATOSA"
  },
  {
    "codigo":449065000,
    "descripcion":"LINFOMA NO HODGKIN DIFUSO DE NARIZ"
  },
  {
    "codigo":416297003,
    "descripcion":"PROLAPSO UVEAL"
  },
  {
    "codigo":55849004,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DEL DORSO, CON INFECCIÓN"
  },
  {
    "codigo":285225003,
    "descripcion":"INCAPAZ DE RECORDAR OBJETOS"
  },
  {
    "codigo":840446000,
    "descripcion":"DACRIOADENITIS CAUSADA POR MYCOBACTERIUM TUBERCULOSIS"
  },
  {
    "codigo":283390002,
    "descripcion":"LACERACIÓN DE TOBILLO"
  },
  {
    "codigo":1297363000,
    "descripcion":"LUXACIÓN DE ARTICULACIÓN DE HOMBRO DEBIDA A DISPLASIA CONGÉNITA"
  },
  {
    "codigo":185086009,
    "descripcion":"BRONQUITIS OBSTRUCTIVA CRÓNICA"
  },
  {
    "codigo":281555003,
    "descripcion":"SECCIÓN TRAUMÁTICA DE TENDÓN EXTENSOR DE DEDO DEL PIE"
  },
  {
    "codigo":19411004,
    "descripcion":"SIGNO DE SPURLING"
  },
  {
    "codigo":84947004,
    "descripcion":"PARÁLISIS FACIAL COMO MANIFESTACIÓN DE TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":52179003,
    "descripcion":"INFECCIÓN CAUSADA POR SCHISTOSOMA INTERCALATUM"
  },
  {
    "codigo":248787007,
    "descripcion":"EYACULACIÓN SIN ERECCIÓN"
  },
  {
    "codigo":707539005,
    "descripcion":"CARCINOMA ADENOIDEO QUÍSTICO PRIMARIO DE HIPOFARINGE"
  },
  {
    "codigo":1295528005,
    "descripcion":"DEFICIENCIA AISLADA DE 3-CETOACIL COENZIMA A TIOLASA DE CADENA LARGA"
  },
  {
    "codigo":246952008,
    "descripcion":"HALLAZGO DE LA MEMBRANA DE BOWMAN"
  },
  {
    "codigo":771240009,
    "descripcion":"SÍNDROME DE DISPLASIA PILODENTAL Y ERRORES DE REFRACCIÓN"
  },
  {
    "codigo":15741007,
    "descripcion":"FRACTURA NO EXPUESTA DE PALADAR"
  },
  {
    "codigo":11809701000119102,
    "descripcion":"HERIDA INFECTADA DE RODILLA IZQUIERDA DEBIDA A PICADURA DE INSECTO NO VENENOSO"
  },
  {
    "codigo":1259090001,
    "descripcion":"ENFERMEDAD AUTOINMUNITARIA DE SISTEMA NERVIOSO AUTÓNOMO"
  },
  {
    "codigo":441725009,
    "descripcion":"ALERGIA A ERTAPENEM"
  },
  {
    "codigo":46674002,
    "descripcion":"RETINOPATÍA PROLIFERATIVA NO DIABÉTICA"
  },
  {
    "codigo":439890004,
    "descripcion":"EXTENDIDO VAGINAL DE PAPANICOLAOU POSITIVO PARA NEOPLASIA MALIGNA"
  },
  {
    "codigo":13906002,
    "descripcion":"ANAPLASMOSIS"
  },
  {
    "codigo":276050006,
    "descripcion":"PÉRDIDA DE LA LICENCIA PARA CONDUCIR"
  },
  {
    "codigo":79442007,
    "descripcion":"SÍNDROME DE DEGENERACIÓN RETINIANA - SORDOMUDEZ"
  },
  {
    "codigo":208679002,
    "descripcion":"FRACTURA EXPUESTA DEL CALCÁNEO, EXTRARTICULAR"
  },
  {
    "codigo":732967004,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE CODO, ANTEBRAZO Y MUÑECA"
  },
  {
    "codigo":77607006,
    "descripcion":"ANEMIA SIDEROBLÁSTICA INDUCIDA POR DROGAS"
  },
  {
    "codigo":405287008,
    "descripcion":"FORMA INTERMEDIA DE ENFERMEDAD DE ORINA EN JARABE DE ARCE"
  },
  {
    "codigo":1290023008,
    "descripcion":"TUMOR NEUROENDOCRINO BIEN DIFERENCIADO PRIMARIO DE ANTRO PILÓRICO DE ESTÓMAGO"
  },
  {
    "codigo":1255420006,
    "descripcion":"ASTA ANTERIOR DE MENISCO INTERNO DE RODILLA DISCOIDE CONGÉNITO"
  },
  {
    "codigo":403452009,
    "descripcion":"GLOSITIS POR DEFICIENCIA DE FOLATO"
  },
  {
    "codigo":237777008,
    "descripcion":"HIPERPLASIA CORTICOSUPRARRENAL"
  },
  {
    "codigo":235942001,
    "descripcion":"PANCREATITIS AGUDA PRODUCIDA POR ALCOHOL"
  },
  {
    "codigo":72102005,
    "descripcion":"ABSCESO SUBPERIÓSTICO DE LA APÓFISIS MASTOIDEA"
  },
  {
    "codigo":203174008,
    "descripcion":"OSTEOMIELITIS AGUDA DE CALCÁNEO"
  },
  {
    "codigo":168571002,
    "descripcion":"RADIOGRAFÍA SIMPLE DE COLUMNA VERTEBRAL: NORMAL"
  },
  {
    "codigo":299643002,
    "descripcion":"ARTICULACIÓN DEL DEDO DEL PIE - HELADA"
  },
  {
    "codigo":314431000119104,
    "descripcion":"SÍNDROME COMPARTIMENTAL NO TRAUMÁTICO DE EXTREMIDAD INFERIOR IZQUIERDA"
  },
  {
    "codigo":234107009,
    "descripcion":"QUILOCELE"
  },
  {
    "codigo":365179009,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA REALIZAR ACTIVIDADES DE HIGIENE PERSONAL"
  },
  {
    "codigo":232272005,
    "descripcion":"CAVIDAD MASTOIDEA SECRETANTE"
  },
  {
    "codigo":66597000,
    "descripcion":"FÍSTULA CERVICOAURAL CONGÉNITA"
  },
  {
    "codigo":33829000,
    "descripcion":"FRACTURAS MÚLTIPLES NO EXPUESTAS DE MIEMBRO SUPERIOR Y ESTERNÓN"
  },
  {
    "codigo":230437002,
    "descripcion":"EPILEPSIA MIOCLÓNICA SEVERA INFANTIL"
  },
  {
    "codigo":164901004,
    "descripcion":"BLOQUEO SINOAURICULAR COMPLETO EN EL ELECTROCARDIOGRAMA"
  },
  {
    "codigo":295973004,
    "descripcion":"SOBREDOSIS DE GABAPENTINA"
  },
  {
    "codigo":263205008,
    "descripcion":"FRACTURA DE EXTREMO DISTAL DE CÚBITO"
  },
  {
    "codigo":195834004,
    "descripcion":"EDEMA DE FARINGE O NASOFARINGE"
  },
  {
    "codigo":294138007,
    "descripcion":"ALERGIA A FENIRAMINA"
  },
  {
    "codigo":128463003,
    "descripcion":"NEOPLASIA BENIGNA DE CARTÍLAGO ARTICULAR"
  },
  {
    "codigo":95695004,
    "descripcion":"DEGENERACIÓN DE LA RETINA"
  },
  {
    "codigo":292303004,
    "descripcion":"REACCIÓN ADVERSA A LA SERTRALINA"
  },
  {
    "codigo":290468000,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR FENOLFTALEÍNA"
  },
  {
    "codigo":1177039008,
    "descripcion":"ESOFAGITIS POR ASPERGILLUS"
  },
  {
    "codigo":93860002,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA PORCIÓN LATERAL DEL PISO DE LA BOCA"
  },
  {
    "codigo":716452003,
    "descripcion":"CAPAZ DE MANTENER LA ATENCIÓN"
  },
  {
    "codigo":1339044001,
    "descripcion":"TC DE SISTEMA NERVIOSO CON CONTRASTE ANORMAL"
  },
  {
    "codigo":343411000119100,
    "descripcion":"ESPASMO DE ACOMODACIÓN DE AMBOS OJOS"
  },
  {
    "codigo":28324007,
    "descripcion":"CONGESTIÓN DE LA PRÓSTATA"
  },
  {
    "codigo":126628008,
    "descripcion":"NEOPLASIA DE MÚSCULO DE LAS NALGAS"
  },
  {
    "codigo":92025003,
    "descripcion":"NEOPLASIA BENIGNA DE HUESO DEL CRÁNEO"
  },
  {
    "codigo":59257003,
    "descripcion":"HIPERFORIA ALTERNANTE"
  },
  {
    "codigo":26489008,
    "descripcion":"ASPECTO DE LA SUPERFICIE DE UNA COLONIA BACTERIANA"
  },
  {
    "codigo":286798002,
    "descripcion":"CARÁCTER AGRESIVO"
  },
  {
    "codigo":24654003,
    "descripcion":"SÍNDROME DE WEBER - GUBLER"
  },
  {
    "codigo":186659004,
    "descripcion":"HERPANGINA"
  },
  {
    "codigo":284963005,
    "descripcion":"INCAPAZ DE MANTENER UN NIVEL DE HIGIENE PERSONAL"
  },
  {
    "codigo":22819008,
    "descripcion":"LACERACIÓN DEL CEREBRO CON HERIDA INTRACRANEAL ABIERTA"
  },
  {
    "codigo":219427009,
    "descripcion":"HERIDA DE GUERRA POR ARMAS LÁSER"
  },
  {
    "codigo":1004024006,
    "descripcion":"TRASTORNO FETAL DEBIDO A ENFERMEDAD RENAL MATERNA"
  },
  {
    "codigo":283128007,
    "descripcion":"AMPOLLA TRAUMÁTICA SUPERFICIAL DE TRONCO"
  },
  {
    "codigo":707277000,
    "descripcion":"ENFERMEDAD INFECCIOSA TRANSMITIDA POR EL AGUA"
  },
  {
    "codigo":838349007,
    "descripcion":"ADENOCARCINOMA DE DIVERTÍCULO DE MECKEL"
  },
  {
    "codigo":246690000,
    "descripcion":"POSTURA OCULAR CON EL MENTÓN HACIA ABAJO"
  },
  {
    "codigo":281293009,
    "descripcion":"ESPÉCIMEN LEVEMENTE LIPÉMICO"
  },
  {
    "codigo":1080691000119109,
    "descripcion":"LIPOSARCOMA PRIMARIO DE PARTES BLANDAS DE CADERA IZQUIERDA"
  },
  {
    "codigo":48247000,
    "descripcion":"PERÍODO POSTCOITAL"
  },
  {
    "codigo":1295266009,
    "descripcion":"TUMOR MESENQUIMATOSO FOSFATÚRICO MALIGNO"
  },
  {
    "codigo":212087003,
    "descripcion":"QUEMADURA QUE COMPROMETE 60-69 PORCIENTO DE LA SUPERFICIE DEL CUERPO, CON QUEMADURA DE ESPESOR COMPLETO QUE AFECTA 20-29 PORCIENTO DE LA SUPERFICIE CORPORAL"
  },
  {
    "codigo":1162359007,
    "descripcion":"ENFERMEDAD ÓSEA POSINFECCIOSA"
  },
  {
    "codigo":243020001,
    "descripcion":"LESIÓN POR FRAGMENTO DE MORTERO"
  },
  {
    "codigo":277623009,
    "descripcion":"LINFOMA DE CÉLULAS B MONOCITOIDE"
  },
  {
    "codigo":110113001,
    "descripcion":"AVULSIÓN DEL VESTÍBULO MAXILAR"
  },
  {
    "codigo":208417001,
    "descripcion":"FRACTURA EXPUESTA DE CABEZA DE METACARPIANO"
  },
  {
    "codigo":13644009,
    "descripcion":"HIPERCOLESTEROLEMIA"
  },
  {
    "codigo":290471000119103,
    "descripcion":"HEMIPLEJÍA ESPÁSTICA DE LADO IZQUIERDO NO DOMINANTE"
  },
  {
    "codigo":403190006,
    "descripcion":"QUEMADURA EPIDÉRMICA DE PIEL"
  },
  {
    "codigo":40907002,
    "descripcion":"SOPA DE PALABRAS"
  },
  {
    "codigo":39072000,
    "descripcion":"CONFLICTO MATRIMONIAL"
  },
  {
    "codigo":301216001,
    "descripcion":"REGIÓN SUPRAGLÓTICA NORMAL"
  },
  {
    "codigo":235680002,
    "descripcion":"FITOBEZOAR"
  },
  {
    "codigo":237515009,
    "descripcion":"HIPOTIROIDISMO CONGÉNITO SIN BOCIO"
  },
  {
    "codigo":202912006,
    "descripcion":"TENOSINOVITIS DE FLEXOR DE DEDO DE LA MANO"
  },
  {
    "codigo":1251488008,
    "descripcion":"SÍNDROME DE EHLERS-DANLOS ESPONDILODISPLÁSICO"
  },
  {
    "codigo":233845001,
    "descripcion":"SÍNDROME CARDÍACO X"
  },
  {
    "codigo":168309003,
    "descripcion":"ORGANISMO NO AISLADO EN CULTIVO DE HISOPADO DE PIEL"
  },
  {
    "codigo":397685007,
    "descripcion":"HALLAZGO RELACIONADO CON EL ENFOQUE VISUAL"
  },
  {
    "codigo":201077008,
    "descripcion":"ECCEMA ASTEATÓSICO"
  },
  {
    "codigo":126631000119108,
    "descripcion":"DERMATITIS POR CONTACTO CAUSADA POR VENDAJE ADHESIVO"
  },
  {
    "codigo":364917008,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA TOMAR IMPULSO PARA PONERSE DE PIE DESDE LA POSICIÓN SEDENTE"
  },
  {
    "codigo":461386003,
    "descripcion":"CONDUCTO ARTERIOSO PERMEABLE CON ORIGEN E INSERCIÓN NORMALES"
  },
  {
    "codigo":232010004,
    "descripcion":"DESPRENDIMIENTO DE RETINA POR TRACCIÓN CON COMPROMISO MACULAR"
  },
  {
    "codigo":2634004,
    "descripcion":"VOLUMEN ERITROCÍTICO DISMINUIDO"
  },
  {
    "codigo":295711001,
    "descripcion":"SOBREDOSIS INTENCIONAL DE TIOGUANINA"
  },
  {
    "codigo":426783006,
    "descripcion":"ELECTROCARDIOGRAMA: RITMO SINUSAL"
  },
  {
    "codigo":230175007,
    "descripcion":"ENCEFALITIS POR MONONUCLEOSIS INFECCIOSA"
  },
  {
    "codigo":262943006,
    "descripcion":"SECCIÓN DE AORTA"
  },
  {
    "codigo":31732001,
    "descripcion":"PRUEBA DE WEBER, LATERALIZADO HACIA LA DERECHA"
  },
  {
    "codigo":799008,
    "descripcion":"ÚLCERA DE COLON SIGMOIDE"
  },
  {
    "codigo":721695008,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE COLON ASCENDENTE Y ÁNGULO COLÓNICO DERECHO"
  },
  {
    "codigo":424948003,
    "descripcion":"OBSTRUCCIÓN DE LAS VÍAS DE ENTRADA DEL LUGAR DE RESIDENCIA"
  },
  {
    "codigo":719860006,
    "descripcion":"CONJUNTIVITIS INFECCIOSA AGUDA"
  },
  {
    "codigo":95433000,
    "descripcion":"TRASTORNO DEL TABIQUE NASAL"
  },
  {
    "codigo":293876009,
    "descripcion":"ALERGIA A CLORMEZANONA"
  },
  {
    "codigo":228340008,
    "descripcion":"INCAPAZ DE CONTROLAR LA BEBIDA"
  },
  {
    "codigo":292041000,
    "descripcion":"REACCIÓN ADVERSA A ANALGÉSICOS NO OPIÁCEOS"
  },
  {
    "codigo":160969008,
    "descripcion":"BOXEADOR AFICIONADO"
  },
  {
    "codigo":290206001,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR MEPERIDINA"
  },
  {
    "codigo":28062002,
    "descripcion":"SACACORCHOS"
  },
  {
    "codigo":421278000,
    "descripcion":"COROIDITIS CAUSADA POR CRYPTOCOCCUS NEOFORMANS"
  },
  {
    "codigo":93598008,
    "descripcion":"OSIFICACIÓN INCOMPLETA DE HUESO PREESFENOIDAL"
  },
  {
    "codigo":124531001,
    "descripcion":"DEFICIENCIA DE ADENOSINATRIFOSFATASA"
  },
  {
    "codigo":386675004,
    "descripcion":"EYACULACIÓN ANÓMALA"
  },
  {
    "codigo":288371008,
    "descripcion":"PASA COSAS DE UNA MANO A LA OTRA"
  },
  {
    "codigo":712520002,
    "descripcion":"ARTRITIS DE MIEMBRO INFERIOR DEBIDA A INFECCIÓN PARASITARIA"
  },
  {
    "codigo":286536004,
    "descripcion":"DIFICULTAD PARA PREPARAR LOS ALIMENTOS HIGIÉNICAMENTE"
  },
  {
    "codigo":253768006,
    "descripcion":"DISMOTILIDAD CONGÉNITA DEL INTESTINO DELGADO"
  },
  {
    "codigo":57160007,
    "descripcion":"SÍNDROME DE FELTY"
  },
  {
    "codigo":24392008,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA MÉDULA ESPINAL A NIVEL DE C1 - C4 Y SIN LESIÓN ÓSEA"
  },
  {
    "codigo":450376009,
    "descripcion":"HEMORRAGIA DE ESPACIO MENÍNGEO INTRACRANEAL"
  },
  {
    "codigo":1234973002,
    "descripcion":"TRASTORNO FETAL DEBIDO A TORSIÓN DE CORDÓN UMBILICAL"
  },
  {
    "codigo":22557000,
    "descripcion":"CISTITIS AMPOLLAR"
  },
  {
    "codigo":186397005,
    "descripcion":"MADUROMICOSIS - ACTINOMICÓTICO"
  },
  {
    "codigo":251933008,
    "descripcion":"VELOCIDAD DE FLUJO ESPIRATORIO PICO PREVISTO INFERIOR AL 60%"
  },
  {
    "codigo":86258000,
    "descripcion":"ÚLCERA DUODENAL CRÓNICA CON HEMORRAGIA, PERFORACIÓN Y OBSTRUCCIÓN"
  },
  {
    "codigo":282866002,
    "descripcion":"SE ACOMODA EN UNA POSICIÓN"
  },
  {
    "codigo":15638491000119109,
    "descripcion":"IRITIS DE OJO IZQUIERDO"
  },
  {
    "codigo":250098005,
    "descripcion":"COMPROMISO OLIGOARTICULAR"
  },
  {
    "codigo":413938008,
    "descripcion":"CISTOCELE CON PROLAPSO UTERINO DE PRIMER GRADO"
  },
  {
    "codigo":84423002,
    "descripcion":"QUISTE ÓSEO LATENTE DE LA MANDÍBULA"
  },
  {
    "codigo":51655004,
    "descripcion":"ANOMALÍA CONGÉNITA DEL CRÁNEO"
  },
  {
    "codigo":1296839007,
    "descripcion":"HIPERTENSIÓN OCULAR DE OJO IZQUIERDO DEBIDA A ANOMALÍA DE SEGMENTO ANTERIOR"
  },
  {
    "codigo":1264071008,
    "descripcion":"APLASIA DE CONDUCTO AUDITIVO EXTERNO"
  },
  {
    "codigo":17052005,
    "descripcion":"INTOXICACIÓN POR ABRUS PRECATORIUS"
  },
  {
    "codigo":80753001,
    "descripcion":"CARIES DENTAL INACTIVA"
  },
  {
    "codigo":703345002,
    "descripcion":"REQUIERE VACUNACIÓN ANTITETÁNICA Y ANTIDIFTÉRICA"
  },
  {
    "codigo":1085711000119101,
    "descripcion":"DIVISIÓN CONGÉNITA DE LÓBULO DE LA OREJA"
  },
  {
    "codigo":1260401008,
    "descripcion":"CIERRE DE EPÍFISIS"
  },
  {
    "codigo":406598000,
    "descripcion":"INFECCIÓN DEL SISTEMA NERVIOSO CENTRAL POR PARÁSITO"
  },
  {
    "codigo":373830001,
    "descripcion":"TUMORES SINCRÓNICOS EN LA LOCALIZACIÓN PRIMARIA, PRESENTES"
  },
  {
    "codigo":371995001,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA LARINGE"
  },
  {
    "codigo":109851002,
    "descripcion":"NEOPLASIA SUPERPUESTA MALIGNA DEL RETROPERITONEO Y PERITONEO"
  },
  {
    "codigo":11547003,
    "descripcion":"HEMORRAGIA PRERRETINIANA"
  },
  {
    "codigo":208155003,
    "descripcion":"FRACTURA EXPUESTA DE ACETÁBULO, SÓLO LABIO ANTERIOR"
  },
  {
    "codigo":44315004,
    "descripcion":"AUSENCIA CONGÉNITA DE PABELLÓN AURICULAR CON ESTENOSIS DE CONDUCTO AUDITIVO"
  },
  {
    "codigo":1287664000,
    "descripcion":"TUMOR NEUROENDOCRINO BIEN DIFERENCIADO PRIMARIO DE YEYUNO"
  },
  {
    "codigo":763376002,
    "descripcion":"PARAPLEJÍA ESPÁSTICA AUTOSÓMICA RECESIVA TIPO 28"
  },
  {
    "codigo":239088003,
    "descripcion":"DERMATOPATÍA PIGMENTOSA RETICULAR"
  },
  {
    "codigo":402928004,
    "descripcion":"CELULITIS POR HAEMOPHILUS"
  },
  {
    "codigo":1254896008,
    "descripcion":"XANTOMATOSIS DE PIEL DE PALMA DE MANO"
  },
  {
    "codigo":827077001,
    "descripcion":"PATRÓN ELECTROCARDIOGRÁFICO DE INVERSIÓN VENTRICULAR"
  },
  {
    "codigo":237253003,
    "descripcion":"FETO VIABLE EN EMBARAZO ABDOMINAL"
  },
  {
    "codigo":7877005,
    "descripcion":"INFECCIÓN CAUSADA POR DIPHYLLOBOTHRIUM LATUM"
  },
  {
    "codigo":1187525006,
    "descripcion":"DEFICIENCIA DE PEX2"
  },
  {
    "codigo":73413009,
    "descripcion":"CONTUSIÓN CORTICAL CEREBRAL CON HERIDA INTRACRANEAL ABIERTA Y CONMOCIÓN"
  },
  {
    "codigo":366490002,
    "descripcion":"HALLAZGO RELACIONADO CON LA AMPLITUD DE MOVIMIENTO PASIVO DE ROTACIÓN EXTERNA DE HOMBRO"
  },
  {
    "codigo":300954003,
    "descripcion":"DOLOR DE PANTORRILLA"
  },
  {
    "codigo":6042001,
    "descripcion":"ASPERGILOSIS PULMONAR"
  },
  {
    "codigo":71578002,
    "descripcion":"DEFICIENCIA DE ESTEROIDE 21 - MONOOXIGENASA, TIPO PERDEDORA DE SODIO"
  },
  {
    "codigo":36975000,
    "descripcion":"ÚLCERA DUODENAL CRÓNICA CON HEMORRAGIA Y PERFORACIÓN"
  },
  {
    "codigo":169882009,
    "descripcion":"PERÍMETRO CEFÁLICO AL NACER: ENTRE PERCENTILOS 75 Y 89"
  },
  {
    "codigo":299119001,
    "descripcion":"ARTICULACIÓN DE DEDO DE LA MANO CALIENTE AL TACTO"
  },
  {
    "codigo":69743002,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN LA REGIÓN DE LA MANO, SIN INFECCIÓN"
  },
  {
    "codigo":102511005,
    "descripcion":"ADOLESCENTE DE SEXO FEMENINO SANA"
  },
  {
    "codigo":264516005,
    "descripcion":"DACTILITIS"
  },
  {
    "codigo":1149252007,
    "descripcion":"MEJORÍA EN LA RESPUESTA AL TRAUMA"
  },
  {
    "codigo":295449001,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE SULFATO DE MAGNESIO"
  },
  {
    "codigo":197145002,
    "descripcion":"URGENCIA EVACUATORIA"
  },
  {
    "codigo":262681003,
    "descripcion":"CONTUSIÓN DE TRÁQUEA"
  },
  {
    "codigo":66073004,
    "descripcion":"TRASTORNO DE LA FUNCIÓN DEL GUSTO DEL NERVIO GLOSOFARÍNGEO"
  },
  {
    "codigo":721433007,
    "descripcion":"LESIÓN COMPLETA DE MÉDULA ESPINAL AL NIVEL DEL CUARTO SEGMENTO DORSAL"
  },
  {
    "codigo":293614000,
    "descripcion":"ALERGIA A ETODOLACO"
  },
  {
    "codigo":129774003,
    "descripcion":"LOCALIZACIÓN EN HORA 3 EN LA MAMOGRAFÍA"
  },
  {
    "codigo":162542007,
    "descripcion":"SE PREPARA LA COMIDA A SÍ MISMO\/MISMA"
  },
  {
    "codigo":95171000,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL NERVIO VAGO"
  },
  {
    "codigo":226243001,
    "descripcion":"DIETA DE ÁFRICA OCCIDENTAL"
  },
  {
    "codigo":160707003,
    "descripcion":"CONDICIONES SANITARIAS INADECUADAS"
  },
  {
    "codigo":816067005,
    "descripcion":"SÍNDROME DE DIABETES, HIPOGONADISMO, SORDERA Y DISCAPACIDAD INTELECTUAL"
  },
  {
    "codigo":62403005,
    "descripcion":"ANEMIA POR DEFICIENCIA DE GLUCOSA - 6 - FOSFATO DESHIDROGENASA"
  },
  {
    "codigo":224408002,
    "descripcion":"ASIGNACIONES LABORALES"
  },
  {
    "codigo":93336005,
    "descripcion":"POSICIÓN ANÓMALA CONGÉNITA DE HUESO METATARSIANO"
  },
  {
    "codigo":714093000,
    "descripcion":"CON ACTIVIDAD SEXUAL EN LOS ÚLTIMOS SEIS MESES"
  },
  {
    "codigo":124269005,
    "descripcion":"DEFICIENCIA DE 1, 3 - BETA - GLUCANO SINTASA"
  },
  {
    "codigo":187970003,
    "descripcion":"NEOPLASIA MALIGNA DEL CUNEIFORME EXTERNO"
  },
  {
    "codigo":1269314004,
    "descripcion":"PERFORACIÓN DE VESÍCULA BILIAR DEBIDA A COLECISTITIS LITIÁSICA CRÓNICA"
  },
  {
    "codigo":253506005,
    "descripcion":"ANOMALÍA CONGÉNITA DE MÚSCULO PAPILAR DE VÁLVULA AURICULOVENTRICULAR IZQUIERDA"
  },
  {
    "codigo":448279005,
    "descripcion":"VENTRÍCULO DERECHO POR DELANTE DE VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":218903005,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR RESERPINA"
  },
  {
    "codigo":184300000,
    "descripcion":"HALLADO FALLECIDO EN EL LUGAR DEL ACCIDENTE"
  },
  {
    "codigo":415511009,
    "descripcion":"ATENDIDO POR TRABAJADOR DE APOYO SANITARIO"
  },
  {
    "codigo":774124003,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE PIE IZQUIERDO"
  },
  {
    "codigo":315372005,
    "descripcion":"NACIDO EN ARGENTINA"
  },
  {
    "codigo":84161008,
    "descripcion":"GINGIVITIS HIPERPLÁSICA"
  },
  {
    "codigo":11793271000119102,
    "descripcion":"SUBLUXACIÓN DE ARTICULACIÓN DE DEDO DE PIE DERECHO"
  },
  {
    "codigo":49558004,
    "descripcion":"SALPINGITIS TUBERCULOSA"
  },
  {
    "codigo":442774008,
    "descripcion":"VECTOCARDIOGRAMA ANORMAL"
  },
  {
    "codigo":14955004,
    "descripcion":"INFECCIÓN CAUSADA POR SPIROCERCA SANGUINOLENTA"
  },
  {
    "codigo":1260139006,
    "descripcion":"OBESIDAD GENÉTICA NO SINDRÓMICA INFANTIL"
  },
  {
    "codigo":111424000,
    "descripcion":"PRODUCTOS DE LA CONCEPCIÓN RETENIDOS NO CONSECUTIVOS A ABORTO"
  },
  {
    "codigo":308032002,
    "descripcion":"VISTO POR EL SERVICIO DE RADIOLOGÍA"
  },
  {
    "codigo":22791000175108,
    "descripcion":"CON MAYOR RIESGO DE VIOLENCIA CONYUGAL"
  },
  {
    "codigo":7431000175109,
    "descripcion":"HIPOTENSIÓN POSQUIRÚRGICA REFRACTARIA"
  },
  {
    "codigo":12491000132101,
    "descripcion":"PROTEINURIA AISLADA"
  },
  {
    "codigo":734016004,
    "descripcion":"SÍNDROME DE MICRODUPLICACIÓN 17P11.2"
  },
  {
    "codigo":275264009,
    "descripcion":"SÍNDROME DE KLINEFELTER, XXXXY"
  },
  {
    "codigo":76821002,
    "descripcion":"MIALGIA CERVICAL EPIDÉMICA"
  },
  {
    "codigo":355468491000132106,
    "descripcion":"ESTENOSIS DE ÍLEON"
  },
  {
    "codigo":240661004,
    "descripcion":"INFECCIÓN AMEBIANA NO INTESTINAL"
  },
  {
    "codigo":402666004,
    "descripcion":"DERMATOSIS POR INSUFICIENCIA ARTERIAL"
  },
  {
    "codigo":271594007,
    "descripcion":"SÍNCOPE"
  },
  {
    "codigo":1156330008,
    "descripcion":"APARATO RESPIRATORIO NORMAL"
  },
  {
    "codigo":204223000,
    "descripcion":"ANOMALÍAS CONGÉNITAS DE OREJAS, CARA Y CUELLO"
  },
  {
    "codigo":40383007,
    "descripcion":"ENFERMEDAD POR EL VIRUS BHANJA"
  },
  {
    "codigo":169620001,
    "descripcion":"SIN LUGAR RESERVADO PARA EL PARTO"
  },
  {
    "codigo":366228003,
    "descripcion":"ÁNGULO DENTARIO INTERINCISAL - HALLAZGO"
  },
  {
    "codigo":300692004,
    "descripcion":"DIFICULTAD PARA MANEJAR DINERO"
  },
  {
    "codigo":724841000,
    "descripcion":"LIPODISTROFIA GENÉTICA"
  },
  {
    "codigo":202388009,
    "descripcion":"DERRAME DE SEGUNDA A QUINTA ARTICULACIÓN METATARSOFALÁNGICA"
  },
  {
    "codigo":107691000119101,
    "descripcion":"NEOPLASIA DE CÉLULAS GERMINALES DE TESTÍCULO, NO SEMINOMATOSA"
  },
  {
    "codigo":298857005,
    "descripcion":"ARTICULACIÓN DE HOMBRO DOLOROSA CON EL MOVIMIENTO"
  },
  {
    "codigo":167785006,
    "descripcion":"MOTILIDAD DE LOS ESPERMATOZOIDES A LAS 6-8 HORAS, BUENA: >40%"
  },
  {
    "codigo":1148990002,
    "descripcion":"LUXACIÓN NO EXPUESTA DE COLUMNA VERTEBRAL DORSAL Y LUMBAR"
  },
  {
    "codigo":723006007,
    "descripcion":"FRAGILIDAD CUTÁNEA RELACIONADA CON LA EDAD"
  },
  {
    "codigo":297022009,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE BUMETANIDA"
  },
  {
    "codigo":229651006,
    "descripcion":"VOZ FARÍNGEA"
  },
  {
    "codigo":721171007,
    "descripcion":"LIQUEN PLANO HIPERTRÓFICO DE VULVA"
  },
  {
    "codigo":1145320000,
    "descripcion":"SURCO NASOLABIAL LISO"
  },
  {
    "codigo":47171000087104,
    "descripcion":"DISTENSIÓN DE TENDÓN DE CABEZA LARGA DE BÍCEPS BRAQUIAL IZQUIERDO"
  },
  {
    "codigo":63976003,
    "descripcion":"VARIACIÓN NORMAL EN EL PESO"
  },
  {
    "codigo":42051000087107,
    "descripcion":"QUEMADURA DE TERCER DEDO DE PIE DERECHO"
  },
  {
    "codigo":44611000087109,
    "descripcion":"FUSOBACTERIUM NAVIFORME O FUSOBACTERIUM NUCLEATUM"
  },
  {
    "codigo":293352006,
    "descripcion":"REACCIÓN ADVERSA A LA APROTININA"
  },
  {
    "codigo":193213003,
    "descripcion":"SÍNDROME MIASTÉNICO POR ANEMIA PERNICIOSA"
  },
  {
    "codigo":94909007,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LABIO"
  },
  {
    "codigo":29373008,
    "descripcion":"SUEÑO LIVIANO"
  },
  {
    "codigo":289682002,
    "descripcion":"HALLAZGO RELACIONADO CON LA ALTURA DEL ÚTERO GRÁVIDO"
  },
  {
    "codigo":27538003,
    "descripcion":"HIPERTIROIDISMO CON ENFERMEDAD DE HASHIMOTO"
  },
  {
    "codigo":224146002,
    "descripcion":"VIVE COMO ACOMPAÑANTE RENTADO"
  },
  {
    "codigo":1141650007,
    "descripcion":"DEMUESTRA CONOCIMIENTO SOBRE PROCESO DE CAMBIO CONDUCTUAL"
  },
  {
    "codigo":715666007,
    "descripcion":"ENFERMEDAD DE CHARCOT-MARIE-TOOTH TIPO IE"
  },
  {
    "codigo":93074008,
    "descripcion":"HIPERTROFIA CONGÉNITA DE TROMPA DE FALOPIO"
  },
  {
    "codigo":124007002,
    "descripcion":"MANOHEPTULOSA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":713831005,
    "descripcion":"NEURALGIA PERIFÉRICA POSINFECCIOSA"
  },
  {
    "codigo":253244002,
    "descripcion":"DISTOPÍA ROTACIONAL DE ÓRBITA"
  },
  {
    "codigo":187708004,
    "descripcion":"NEOPLASIA MALIGNA DEL REPLIEGUE ARIEPIGLÓTICO- CARA HIPOFARÍNGEA"
  },
  {
    "codigo":218641001,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR SUCCINIMIDA"
  },
  {
    "codigo":286012009,
    "descripcion":"NO ENCIENDE UN ARTEFACTO ELECTRODOMÉSTICO"
  },
  {
    "codigo":1269052009,
    "descripcion":"MEDULOBLASTOMA DE CÉLULAS GRANDES PRIMARIO DE CEREBRO"
  },
  {
    "codigo":251409007,
    "descripcion":"PRUEBA GENITOURINARIA - HALLAZGO"
  },
  {
    "codigo":22033007,
    "descripcion":"RETARDO DEL CRECIMIENTO FETAL"
  },
  {
    "codigo":10950111000119103,
    "descripcion":"HERIDA POR DISPARO DE ARMA DE FUEGO DE ANTEBRAZO IZQUIERDO"
  },
  {
    "codigo":249574007,
    "descripcion":"PUNTA DEL BAZO PALPABLE"
  },
  {
    "codigo":247739000,
    "descripcion":"ALUCINACIONES DE TEMPERATURA"
  },
  {
    "codigo":870331001,
    "descripcion":"PANUVEÍTIS CAUSADA POR TREPONEMA PALLIDUM"
  },
  {
    "codigo":1263547004,
    "descripcion":"HIPERTENSIÓN INTRACRANEAL BENIGNA DEBIDA A TROMBOSIS VENOSA INTRACRANEAL"
  },
  {
    "codigo":442512002,
    "descripcion":"ESTADO EPILÉPTICO SIN SÍNTOMAS MOTORES PROMINENTES"
  },
  {
    "codigo":1163408002,
    "descripcion":"GEMINACIÓN DENTAL"
  },
  {
    "codigo":213136008,
    "descripcion":"DISPOSITIVO PROTÉSICO INTERNO QUE PROVOCA TROMBOS"
  },
  {
    "codigo":473445000,
    "descripcion":"ANOMALÍA ADQUIRIDA DE VENA ILÍACA"
  },
  {
    "codigo":735589002,
    "descripcion":"ASMA NO ALÉRGICA SIN COMPLICACIONES"
  },
  {
    "codigo":10923641000119101,
    "descripcion":"FRACTURA NO EXPUESTA DE BASE DE PRIMER HUESO METACARPIANO DE MANO DERECHA"
  },
  {
    "codigo":47461006,
    "descripcion":"PORTADOR DE UN TRASTORNO GENÉTICO"
  },
  {
    "codigo":276837006,
    "descripcion":"QUISTE EPIDERMOIDE DE CEREBRO"
  },
  {
    "codigo":1290810000,
    "descripcion":"LIPOSARCOMA PLEOMÓRFICO MIXOIDE"
  },
  {
    "codigo":897594002,
    "descripcion":"FÍSTULA ANORRECTAL CONGÉNITA DEBIDA A MALFORMACIÓN ANORRECTAL ALTA"
  },
  {
    "codigo":242234003,
    "descripcion":"PARACAIDISTA LESIONADO AL ATERRIZAR"
  },
  {
    "codigo":45626005,
    "descripcion":"HEMOPERITONEO ATRAUMÁTICO"
  },
  {
    "codigo":209466007,
    "descripcion":"ESGUINCE DE ARTICULACIÓN MEDIOCARPIANA"
  },
  {
    "codigo":109327001,
    "descripcion":"ABSCESO DE HUESO FACIAL"
  },
  {
    "codigo":11023001,
    "descripcion":"PERIARTRITIS CALCIFICADA AGUDA"
  },
  {
    "codigo":240399004,
    "descripcion":"ABSCESO POR PASTEURELLA"
  },
  {
    "codigo":404239005,
    "descripcion":"MENINGITIS CAUSADA POR ORTHOBUNYAVIRUS DE SEROGRUPO CALIFORNIA"
  },
  {
    "codigo":74724001,
    "descripcion":"VIRUELA SIN ERUPCIÓN"
  },
  {
    "codigo":369636002,
    "descripcion":"MARGEN RADIAL PROFUNDO DE RESECCIÓN QUIRÚRGICA DE PARTES BLANDAS PERIURETERALES, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":238564003,
    "descripcion":"ECCEMA PSORIASIFORME"
  },
  {
    "codigo":402404006,
    "descripcion":"ANGIOEDEMA EPISÓDICO CON EOSINOFILIA"
  },
  {
    "codigo":236729003,
    "descripcion":"INFECCIÓN DE LA PRÓTESIS TESTICULAR"
  },
  {
    "codigo":269497004,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA MAMA"
  },
  {
    "codigo":105657007,
    "descripcion":"ENFERMEDAD CAUSADA POR NOSEMATIDAE"
  },
  {
    "codigo":300430000,
    "descripcion":"SIGNO ABDOMINAL CON NOMBRE PROPIO"
  },
  {
    "codigo":365966001,
    "descripcion":"OLOR CORPORAL ANORMAL"
  },
  {
    "codigo":1187001009,
    "descripcion":"MONONUCLEOSIS INFECCIOSA CAUSADA POR VIRUS DE INMUNODEFICIENCIA HUMANA TIPO I"
  },
  {
    "codigo":431502008,
    "descripcion":"CICATRIZ DE PÁRPADO"
  },
  {
    "codigo":69219001,
    "descripcion":"INTOXICACIÓN POR ALBIZIA"
  },
  {
    "codigo":724579003,
    "descripcion":"NEOPLASIA OSTEÓGENA BENIGNA DE HUESO DE LA CABEZA"
  },
  {
    "codigo":298595007,
    "descripcion":"TUMEFACCIÓN ÓSEA DE LA COLUMNA LUMBAR"
  },
  {
    "codigo":296760000,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE MINOCICLINA"
  },
  {
    "codigo":453531000124101,
    "descripcion":"CONOCIMIENTO DEFICIENTE SOBRE ALMACENAMIENTO DE MEDICACIÓN"
  },
  {
    "codigo":460600005,
    "descripcion":"DISFUNCIÓN DE MÚSULO PAPILAR DE VÁLVULA AURICULOVENTRICULAR IZQUIERDA (MORFOLÓGICAMENTE NO MITRAL)"
  },
  {
    "codigo":427832005,
    "descripcion":"DEHISCENCIA DE HERIDA CUTÁNEA"
  },
  {
    "codigo":294925000,
    "descripcion":"ALERGIA A VITAMINA K Y\/O DERIVADO DE VITAMINA K"
  },
  {
    "codigo":440731000124104,
    "descripcion":"INGESTA INADECUADA DE BIOTINA"
  },
  {
    "codigo":198456009,
    "descripcion":"INFERTILIDAD UTERINA PRIMARIA"
  },
  {
    "codigo":1145058005,
    "descripcion":"SOBREDOSIS DE CLORAZEPATO"
  },
  {
    "codigo":293090006,
    "descripcion":"REACCIÓN ADVERSA A PLAGUICIDA ORGANOFOSFORADO"
  },
  {
    "codigo":94647000,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL TRÍGONO VESICAL"
  },
  {
    "codigo":715404000,
    "descripcion":"SÍNDROME AMELOONICOHIPOHIDRÓTICO"
  },
  {
    "codigo":289420000,
    "descripcion":"FONTANELA POSTERIOR PALPABLE EN LA REGIÓN EXTERNA DERECHA"
  },
  {
    "codigo":1010316005,
    "descripcion":"TRASTORNO FETAL DEBIDO A OBESIDAD MATERNA CON UN ÍNDICE DE MASA CORPORAL PARA ADULTO DE 30 O SUPERIOR PERO INFERIOR A 40"
  },
  {
    "codigo":92812005,
    "descripcion":"LEUCEMIA CRÓNICA"
  },
  {
    "codigo":254817005,
    "descripcion":"NEVO DE OTA"
  },
  {
    "codigo":1303393009,
    "descripcion":"FRACTURA ÓSEA DE CODO DERECHO"
  },
  {
    "codigo":23606001,
    "descripcion":"TIMPANOESCLEROSIS"
  },
  {
    "codigo":285750004,
    "descripcion":"LESIÓN VENOSA EN LA CABEZA Y EL CUELLO"
  },
  {
    "codigo":416822007,
    "descripcion":"HALLAZGO RELACIONADO CON EL MOVIMIENTO DEL SACRO"
  },
  {
    "codigo":89142007,
    "descripcion":"OCLUSIÓN ARTERIAL INTRACRANEAL PROGRESIVA"
  },
  {
    "codigo":218379001,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR CICLOGUANIL"
  },
  {
    "codigo":54539003,
    "descripcion":"ALOPECIA ENDOCRINA"
  },
  {
    "codigo":283915004,
    "descripcion":"CONTUSIÓN DE VEJIGA URINARIA"
  },
  {
    "codigo":11827271000119104,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA DE DEDO GORDO DERECHO"
  },
  {
    "codigo":447755005,
    "descripcion":"HALLAZGO RELACIONADO CON LA SATURACIÓN DE OXÍGENO"
  },
  {
    "codigo":10680391000119104,
    "descripcion":"NÓDULO DE PIEL DE AMBOS ANTEBRAZOS"
  },
  {
    "codigo":185611008,
    "descripcion":"EXTENDIDO CERVICAL ANORMAL, ANOTADO, RECONVOCATORIA ANULADA"
  },
  {
    "codigo":19936001,
    "descripcion":"LESIÓN TRAUMÁTICA DE VESÍCULA BILIAR SIN HERIDA ABIERTA HACIA CAVIDAD ABDOMINAL"
  },
  {
    "codigo":314848002,
    "descripcion":"CONSENTIMIENTO PARA VACUNACIÓN ANTINEUMOCÓCICA OTORGADO"
  },
  {
    "codigo":183776003,
    "descripcion":"INSCRIPTO EN LISTA DE ADMISIÓN PSIQUIÁTRICA"
  },
  {
    "codigo":445920003,
    "descripcion":"VACUOLIZACIÓN CITOPLASMÁTICA DE LINFOCITOS"
  },
  {
    "codigo":118240005,
    "descripcion":"HALLAZGO MEDIANTE UN MÉTODO"
  },
  {
    "codigo":282080005,
    "descripcion":"CUERPO EXTRAÑO EN INTESTINO DELGADO"
  },
  {
    "codigo":16005191000119106,
    "descripcion":"AMIOTROFIA NEURÁLGICA DE PLEXO BRAQUIAL IZQUIERDO"
  },
  {
    "codigo":251147008,
    "descripcion":"VOLTAJES DEL QRS BAJOS EN LAS DERIVACIONES DE LOS MIEMBROS"
  },
  {
    "codigo":413152009,
    "descripcion":"BAJO ATENCIÓN DE NUTRICIONISTA PEDIÁTRICA"
  },
  {
    "codigo":247477005,
    "descripcion":"MARCA CONGÉNITA PLANA"
  },
  {
    "codigo":50869007,
    "descripcion":"SÍNDROME DE EHLERS-DANLOS PERIODONTAL"
  },
  {
    "codigo":1197749008,
    "descripcion":"LIPODISTROFIA PARCIAL FAMILIAR ASOCIADA AL GEN CIDEC"
  },
  {
    "codigo":16266001,
    "descripcion":"ABUSO DE LA VOZ"
  },
  {
    "codigo":18101008,
    "descripcion":"RUIDOS POR HIPERACTIVIDAD INTESTINAL"
  },
  {
    "codigo":1163146002,
    "descripcion":"COLITIS CAUSADA POR ASPERGILLUS"
  },
  {
    "codigo":276575001,
    "descripcion":"TROMBOCITOPENIA NEONATAL AUTOINMUNITARIA"
  },
  {
    "codigo":295688006,
    "descripcion":"SOBREDOSIS DE EPIRUBICINA"
  },
  {
    "codigo":768095003,
    "descripcion":"HERNIA CRURAL DERECHA RECURRENTE IRREDUCTIBLE"
  },
  {
    "codigo":450728161000119104,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN DE TEJIDO PROFUNDO DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":211039006,
    "descripcion":"ABRASIÓN DE PIEL DE PARED TORÁCICA"
  },
  {
    "codigo":407647007,
    "descripcion":"ESTADO DE EVALUACIÓN DEL RIESGO"
  },
  {
    "codigo":473183006,
    "descripcion":"OBSTRUCCIÓN DE CATÉTER SUPRAPÚBICO"
  },
  {
    "codigo":274740001,
    "descripcion":"GANGLIO LINFÁTICO SUBMAXILAR AGRANDADO"
  },
  {
    "codigo":1259615008,
    "descripcion":"SARCOMA DE EWING PRIMARIO DE HUESO DE PELVIS"
  },
  {
    "codigo":733492003,
    "descripcion":"TRÍADA DE CARNEY"
  },
  {
    "codigo":373044008,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM MORIOKAENSE"
  },
  {
    "codigo":403977003,
    "descripcion":"ANGIOSARCOMA"
  },
  {
    "codigo":305673004,
    "descripcion":"ATENDIDO POR UN MÉDICO GENERAL"
  },
  {
    "codigo":240137005,
    "descripcion":"CONTUSIÓN DE CARTÍLAGO ARTICULAR"
  },
  {
    "codigo":698889008,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: BASKIR"
  },
  {
    "codigo":860894002,
    "descripcion":"EPIESCLERITIS DEBIDA A SÍFILIS TARDÍA"
  },
  {
    "codigo":402142006,
    "descripcion":"TRIPANOSOMIASIS QUE AFECTA LA PIEL"
  },
  {
    "codigo":762590006,
    "descripcion":"DOLOR GENERALIZADO PRIMARIO CRÓNICO"
  },
  {
    "codigo":1286878009,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚLTIPLES SITIOS DE COLORRECTO CON HERIDA ABIERTA A CAVIDAD ABDOMINAL"
  },
  {
    "codigo":236467001,
    "descripcion":"SÍNDROME DE FANCONI ADQUIRIDO"
  },
  {
    "codigo":11774331000119104,
    "descripcion":"CONTUSIÓN DE PULGAR IZQUIERDO"
  },
  {
    "codigo":303581000119100,
    "descripcion":"PABELLÓN AURICULAR DERECHO EN COLIFLOR ADQUIRIDO"
  },
  {
    "codigo":302003005,
    "descripcion":"TENSIÓN MAMARIA PREMENSTRUAL"
  },
  {
    "codigo":15937501000119102,
    "descripcion":"QUISTE EPIDERMOIDE DE DEDO DE MANO IZQUIERDA"
  },
  {
    "codigo":15643101000119103,
    "descripcion":"ENFERMEDAD POR REFLUJO GASTROESOFÁGICO EN EL EMBARAZO"
  },
  {
    "codigo":1076701000119104,
    "descripcion":"HIPERTROFIA DE ALMOHADILLA ADIPOSA DE RODILLA DERECHA"
  },
  {
    "codigo":10850781000119103,
    "descripcion":"ALIMENTO ASPIRADO EN FARINGE"
  },
  {
    "codigo":12202461000119106,
    "descripcion":"ANURIA DESPUÉS DE PROCEDIMIENTO"
  },
  {
    "codigo":1089501000119106,
    "descripcion":"ESTENOSIS DE CONDUCTO AUDITIVO EXTERNO IZQUIERDO DEBIDO A Y DESPUÉS DE INFECCIÓN"
  },
  {
    "codigo":267400004,
    "descripcion":"FALLA OVÁRICA SECUNDARIA"
  },
  {
    "codigo":68061000119109,
    "descripcion":"POLIURIA RELACIONADA A VASOPRESINA PARCIAL"
  },
  {
    "codigo":10756061000119109,
    "descripcion":"DOLOR DURANTE PERÍODO POSPARTO DEBIDO A CESÁREA Y POSTERIOR A ELLA"
  },
  {
    "codigo":365704005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA UTILIZAR EL RAZONAMIENTO VISUOESPACIAL"
  },
  {
    "codigo":690141000119103,
    "descripcion":"CARCINOMA BASOCELULAR PRIMARIO DE PIEL DE GENITALES MASCULINOS"
  },
  {
    "codigo":938000861000119106,
    "descripcion":"ESPONDILOARTRITIS AXIAL NO RADIOGRÁFICA DE REGIÓN LUMBAR"
  },
  {
    "codigo":167261002,
    "descripcion":"PRUEBA DE GLUCOSA EN ORINA NEGATIVA"
  },
  {
    "codigo":298333003,
    "descripcion":"RESPUESTA MOTRIZ DE RETRACCIÓN ANTE UNA ORDEN"
  },
  {
    "codigo":308701000119107,
    "descripcion":"GANGLIÓN DE MANO DERECHA"
  },
  {
    "codigo":234632005,
    "descripcion":"INMUNODEFICIENCIA ASOCIADA A ANOMALÍA CROMOSÓMICA"
  },
  {
    "codigo":306141000119109,
    "descripcion":"GOTA CRÓNICA DE TOBILLO Y\/O PIE SIN TOFO CAUSADA POR FÁRMACO"
  },
  {
    "codigo":3421000,
    "descripcion":"FRACTURA EXPUESTA EN ESTALLIDO DE PISO ORBITARIO"
  },
  {
    "codigo":460338001,
    "descripcion":"MIOCARDITIS CAUSADA POR ASPERGILLUS"
  },
  {
    "codigo":294663006,
    "descripcion":"ALERGIA A VACUNA CONTRA HEPATITIS A"
  },
  {
    "codigo":1179399008,
    "descripcion":"HIPOTIROIDISMO CONGÉNITO DEBIDO A MUTACIÓN DE TIROGLOBULINA"
  },
  {
    "codigo":818951009,
    "descripcion":"FÍSTULA BILIAR-RESPIRATORIA CONGÉNITA"
  },
  {
    "codigo":292828003,
    "descripcion":"REACCIÓN ADVERSA A LA ZIDOVUDINA"
  },
  {
    "codigo":30684005,
    "descripcion":"PRODUCCIÓN DE LINFOCITOS AUMENTADA"
  },
  {
    "codigo":784348007,
    "descripcion":"MOVIMIENTOS EN ESPEJO CONGÉNITOS FAMILIARES"
  },
  {
    "codigo":782513000,
    "descripcion":"EXACERBACIÓN SEVERA AGUDA DE ASMA ALÉRGICA"
  },
  {
    "codigo":127153002,
    "descripcion":"LINFADENOPATÍA DEL COLÉDOCO"
  },
  {
    "codigo":422065006,
    "descripcion":"ESTATURA BAJA CONSTITUCIONAL"
  },
  {
    "codigo":225457007,
    "descripcion":"SIENTE DESEOS SUICIDAS"
  },
  {
    "codigo":192689006,
    "descripcion":"ENCEFALITIS POR RUBÉOLA"
  },
  {
    "codigo":334511000119103,
    "descripcion":"FÍSTULA DEL APARATO LAGRIMAL DERECHO"
  },
  {
    "codigo":92550006,
    "descripcion":"CARCINOMA IN SITU DEL CUERPO DEL ÚTERO"
  },
  {
    "codigo":289158008,
    "descripcion":"HALLAZGO RELACIONADO CON EL PATRÓN DE ALIMENTACIÓN"
  },
  {
    "codigo":1303131001,
    "descripcion":"TUMOR NOTOCORDAL BENIGNO"
  },
  {
    "codigo":1335899003,
    "descripcion":"ANTICUERPO CONTRA RETROVIRIDAE"
  },
  {
    "codigo":418395004,
    "descripcion":"ASMA DE LOS FABRICANTES DE TÉ"
  },
  {
    "codigo":1268528000,
    "descripcion":"NEUROBLASTOMA OLFATORIO PRIMARIO"
  },
  {
    "codigo":90715009,
    "descripcion":"GRANULOMA DE LA CONJUNTIVA"
  },
  {
    "codigo":56112001,
    "descripcion":"DEFECTO EN EL TRANSPORTE DE TIROXINA"
  },
  {
    "codigo":285488001,
    "descripcion":"NO ESTIRA LOS LABIOS"
  },
  {
    "codigo":23344004,
    "descripcion":"HERNIA LUMBAR"
  },
  {
    "codigo":254555008,
    "descripcion":"CARCINOMA DEL FONDO DEL ESTÓMAGO"
  },
  {
    "codigo":15709001000119101,
    "descripcion":"LUXACIÓN RECURRENTE DE ARTICULACIÓN DE AMBOS CODOS"
  },
  {
    "codigo":283653006,
    "descripcion":"HERIDA POR PINCHAZO DE CLAVO EN EL CUELLO"
  },
  {
    "codigo":1363162005,
    "descripcion":"ASTILLA EN TRONCO CON INFECCIÓN"
  },
  {
    "codigo":19674006,
    "descripcion":"INMERSIÓN"
  },
  {
    "codigo":609498008,
    "descripcion":"INTERRUPCIÓN INDUCIDA DE EMBARAZO COMPLICADA POR LACERACIÓN DE VEJIGA URINARIA"
  },
  {
    "codigo":871642009,
    "descripcion":"HIPERTENSIÓN DEBIDA A OBSTRUCCIÓN DE CAYADO AÓRTICO"
  },
  {
    "codigo":247215006,
    "descripcion":"CAMBIOS MIÓPICOS EN LA PAPILA ÓPTICA"
  },
  {
    "codigo":441988000,
    "descripcion":"ESTUDIO POR IMÁGENES DEL ABDOMEN, ANORMAL"
  },
  {
    "codigo":308041000119106,
    "descripcion":"HIPERLAXITUD ARTICULAR DE CODO DERECHO"
  },
  {
    "codigo":10957641000119106,
    "descripcion":"HERIDA ABIERTA DE PULGAR DERECHO DEBIDA A MORDEDURA"
  },
  {
    "codigo":278148006,
    "descripcion":"GRUPO SANGUÍNEO 0 RH(D) NEGATIVO"
  },
  {
    "codigo":14169000,
    "descripcion":"LUXACIÓN POSTERIOR DEL CRISTALINO"
  },
  {
    "codigo":79705001,
    "descripcion":"LESIÓN TRAUMÁTICA DEL PLEXO LUMBOSACRO"
  },
  {
    "codigo":276313002,
    "descripcion":"LUBRICACIÓN VAGINAL"
  },
  {
    "codigo":866137004,
    "descripcion":"INFECCIÓN DE VAINA DE TENDÓN CAUSADA POR PARÁSITO"
  },
  {
    "codigo":1259353006,
    "descripcion":"CARCINOMA PRIMARIO DE ANTRO PILÓRICO"
  },
  {
    "codigo":405550001,
    "descripcion":"TRAUMATISMO DE VÁLVULA AÓRTICA"
  },
  {
    "codigo":309081009,
    "descripcion":"EXTENDIDO CERVICAL ANORMAL"
  },
  {
    "codigo":208942003,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE LA CABEZA DEL PERONÉ"
  },
  {
    "codigo":733230007,
    "descripcion":"LESIONES TRAUMÁTICAS MÚLTIPLES DE REGIÓN DEL HOMBRO"
  },
  {
    "codigo":370947000,
    "descripcion":"DEHISCENCIA ZONULAR"
  },
  {
    "codigo":895235004,
    "descripcion":"FORMA ANCHA ANORMAL CONGÉNITA DE FALANGE DE DEDO ANULAR"
  },
  {
    "codigo":403715005,
    "descripcion":"QUERATOSIS ASOCIADA CON FOTOQUIMIOTERAPIA CON PSORALENO Y RADIACIÓN ULTRAVIOLETA DE ONDA LARGA"
  },
  {
    "codigo":76035004,
    "descripcion":"ABSCESO DE LA REGIÓN PECTORAL"
  },
  {
    "codigo":762328006,
    "descripcion":"TRASTORNO DEL ESTADO DE ÁNIMO CAUSADO POR ESTIMULANTE"
  },
  {
    "codigo":72365000,
    "descripcion":"DISNEA, CLASE II"
  },
  {
    "codigo":238040008,
    "descripcion":"HIPERLIPIDEMIA COMBINADA FAMILIAR"
  },
  {
    "codigo":400045003,
    "descripcion":"LACERACIÓN SUPERFICIAL DE PIEL"
  },
  {
    "codigo":249646051000119108,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE TENDÓN DE AQUILES DERECHO"
  },
  {
    "codigo":365442000,
    "descripcion":"PH DEL VÓMITO - HALLAZGO"
  },
  {
    "codigo":299906001,
    "descripcion":"SENSACIÓN DE CALOR AUSENTE"
  },
  {
    "codigo":301741009,
    "descripcion":"DIFICULTAD PARA REALIZAR ACTIVIDADES DE OFICINA"
  },
  {
    "codigo":1217410004,
    "descripcion":"DEFICIENCIA DE PROTEÍNA C ADQUIRIDA"
  },
  {
    "codigo":103298005,
    "descripcion":"VÉRTIGO SEVERO"
  },
  {
    "codigo":168834008,
    "descripcion":"SERIADA GASTROINTESTINAL ANORMAL"
  },
  {
    "codigo":298071001,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE CUELLO"
  },
  {
    "codigo":199767004,
    "descripcion":"TRABAJO DE PARTO OBSTRUIDO POR PARTES BLANDAS PÉLVICAS"
  },
  {
    "codigo":230700009,
    "descripcion":"INFARTO LACUNAR SENSITIVO PURO"
  },
  {
    "codigo":425473004,
    "descripcion":"DOLOR IRRADIADO AL HOMBRO IZQUIERDO"
  },
  {
    "codigo":310551000119102,
    "descripcion":"INFECCIÓN PIÓGENA DE DISCO INTERVERTEBRAL SACROCOCCÍGEO"
  },
  {
    "codigo":390870001,
    "descripcion":"DISNEA AL VESTIRSE Y DESVESTIRSE"
  },
  {
    "codigo":1074301000119109,
    "descripcion":"ARTRITIS DE PIE DERECHO DEBIDA A TRAUMATISMO"
  },
  {
    "codigo":1144534006,
    "descripcion":"BUENA RECUPERACIÓN DE SITUACIÓN DE MALTRATO"
  },
  {
    "codigo":290731004,
    "descripcion":"INTOXICACIÓN POR CRISANTASPASA"
  },
  {
    "codigo":126891008,
    "descripcion":"NEOPLASIA DEL CUELLO DE LA VEJIGA"
  },
  {
    "codigo":288896001,
    "descripcion":"INCAPAZ DE CONTROLAR EL BOLO ALIMENTICIO"
  },
  {
    "codigo":94123008,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA URETRA"
  },
  {
    "codigo":10878231000119106,
    "descripcion":"HERIDA POR DISPARO DE ARMA DE FUEGO DE REGIÓN DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":26752006,
    "descripcion":"ACTIVIDAD HORMONAL DISMINUIDA"
  },
  {
    "codigo":120241000119100,
    "descripcion":"GLOMERULONEFRITIS DEBIDA A HEPATITIS C"
  },
  {
    "codigo":92288009,
    "descripcion":"NEOPLASIA BENIGNA DE LA PIEL PERIANAL"
  },
  {
    "codigo":714880009,
    "descripcion":"CAPAZ DE MANTENERSE EN CUCLILLAS"
  },
  {
    "codigo":90453003,
    "descripcion":"MEDIASTINOPERICARDITIS REUMÁTICA CRÓNICA"
  },
  {
    "codigo":876885004,
    "descripcion":"FALLECIDO EN LA CALLE"
  },
  {
    "codigo":713045003,
    "descripcion":"ESOFAGITIS CAUSADA POR CITOMEGALOVIRUS"
  },
  {
    "codigo":55850004,
    "descripcion":"ENDOSALPINGIOSIS"
  },
  {
    "codigo":449066004,
    "descripcion":"NEOPLASIA MALIGNA DEL TRACTO RESPIRATORIO SUPERIOR"
  },
  {
    "codigo":447231001,
    "descripcion":"QUISTE EPIDERMOIDE DE PIEL DE CUELLO"
  },
  {
    "codigo":21247003,
    "descripcion":"FIBROSIS DEL MEDIASTINO"
  },
  {
    "codigo":202161000119104,
    "descripcion":"ESTREÑIMIENTO DEBIDO A OBSTRUCCIÓN DEL ESTRECHO INFERIOR DEL PISO DE LA PELVIS"
  },
  {
    "codigo":414463005,
    "descripcion":"CONJUNTIVITIS INMUNOMEDIADA"
  },
  {
    "codigo":283391003,
    "descripcion":"LACERACIÓN DE DEDO GORDO DEL PIE"
  },
  {
    "codigo":840447009,
    "descripcion":"QUISTE DE ESPACIO SUBDURAL CAUSADO POR PARÁSITO"
  },
  {
    "codigo":248788002,
    "descripcion":"EYACULACIÓN SIN ORGASMO"
  },
  {
    "codigo":1297364006,
    "descripcion":"LUXACIÓN CONGÉNITA DE ARTICULACIÓN DE REGIÓN DE HOMBRO"
  },
  {
    "codigo":707540007,
    "descripcion":"DIFICULTAD RESPIRATORIA AGUDA NEONATAL"
  },
  {
    "codigo":1295529002,
    "descripcion":"SÍNDROME DE DELECIÓN XP21"
  },
  {
    "codigo":246953003,
    "descripcion":"ANILLO BLANCO DE COATS"
  },
  {
    "codigo":15742000,
    "descripcion":"TROMBOSIS DEL SENO SAGITAL INFERIOR"
  },
  {
    "codigo":11998641000119109,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO DE MUSLO DERECHO"
  },
  {
    "codigo":439891000,
    "descripcion":"NEOPLASIA MALIGNA DETECTADA POR EXTENDIDO DE PAPANICOLAOU ANAL"
  },
  {
    "codigo":112211004,
    "descripcion":"TRADUCCIÓN GENÉTICA"
  },
  {
    "codigo":276051005,
    "descripcion":"EQUIPAMIENTO FIJO EN EL HOGAR"
  },
  {
    "codigo":13907006,
    "descripcion":"OSTEOCONDROSIS JUVENIL DEL CÚBITO"
  },
  {
    "codigo":77608001,
    "descripcion":"SÍNDROME DE BALLER - GEROLD"
  },
  {
    "codigo":405288003,
    "descripcion":"ENFERMEDAD DE LA ORINA EN JARABE DE ARCE, TIPO INTERMITENTE"
  },
  {
    "codigo":208680004,
    "descripcion":"FRACTURA EXPUESTA DEL CALCÁNEO, INTRARTICULAR"
  },
  {
    "codigo":16697061000119100,
    "descripcion":"ANOMALÍA CONGÉNITA DE ARTERIA RENAL IZQUIERDA"
  },
  {
    "codigo":732968009,
    "descripcion":"CRISIS POR FEOCROMOCITOMA"
  },
  {
    "codigo":403453004,
    "descripcion":"GLOSITIS POR DEFICIENCIA DE VITAMINA B12"
  },
  {
    "codigo":1255421005,
    "descripcion":"MENISCO INTERNO DE RODILLA DISCOIDE CONGÉNITO"
  },
  {
    "codigo":43005009,
    "descripcion":"MARCHA CON ARRASTRE DE LOS PIES"
  },
  {
    "codigo":698365009,
    "descripcion":"INFECCIÓN POSOPERATORIA DE HERIDA DE TIROIDECTOMÍA"
  },
  {
    "codigo":237778003,
    "descripcion":"HIPERPLASIA SUPRARRENAL MACRONODULAR"
  },
  {
    "codigo":1351890004,
    "descripcion":"HEMANGIOBLASTOMA DE CEREBELO"
  },
  {
    "codigo":301479000,
    "descripcion":"CAPAZ DE EVITAR OBSTÁCULOS EN UN CAMINO"
  },
  {
    "codigo":39335003,
    "descripcion":"FRACTURA NO EXPUESTA DE CUATRO COSTILLAS"
  },
  {
    "codigo":235943006,
    "descripcion":"PANCREATITIS AGUDA IDIOPÁTICA"
  },
  {
    "codigo":203175009,
    "descripcion":"OSTEOMIELITIS AGUDA DE ASTRÁGALO"
  },
  {
    "codigo":397948002,
    "descripcion":"BLOQUEO DE LA CONDUCCIÓN NERVIOSA SENSITIVA - PARCIAL"
  },
  {
    "codigo":296157000,
    "descripcion":"SOBREDOSIS DE SULPIRIDA"
  },
  {
    "codigo":234108004,
    "descripcion":"QUILOCELE FILARIÁSICO BANCROFTIANO"
  },
  {
    "codigo":365180007,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA REALIZAR ACTIVIDADES DE LAVADO Y SECADO DE SÍ MISMO"
  },
  {
    "codigo":299644008,
    "descripcion":"HALLAZGO RELACIONADO CON LA EXTREMIDAD INFERIOR LUEGO DE UN PROCEDIMIENTO"
  },
  {
    "codigo":168572009,
    "descripcion":"RADIOGRAFÍA SIMPLE DE COLUMNA VERTEBRAL ANORMAL"
  },
  {
    "codigo":201340008,
    "descripcion":"LESIÓN DE PIEL PIGMENTADA"
  },
  {
    "codigo":232273000,
    "descripcion":"CAVIDAD MASTOIDEA SECRETANTE - MOCO"
  },
  {
    "codigo":2897005,
    "descripcion":"TROMBOCITOPENIA INMUNITARIA"
  },
  {
    "codigo":428881005,
    "descripcion":"LESIÓN TRAUMÁTICA DE TIBIA"
  },
  {
    "codigo":68433009,
    "descripcion":"NIÑEZ"
  },
  {
    "codigo":66598005,
    "descripcion":"PORTADOR DE ORGANISMO INFECCIOSO"
  },
  {
    "codigo":164902006,
    "descripcion":"ELECTROCARDIOGRAMA: BLOQUEO AURICULOVENTRICULAR PARCIAL - PR PROLONGADO"
  },
  {
    "codigo":427046006,
    "descripcion":"NEUMONITIS CAUSADA POR FÁRMACO"
  },
  {
    "codigo":230438007,
    "descripcion":"AFASIA EPILÉPTICA ADQUIRIDA"
  },
  {
    "codigo":263206009,
    "descripcion":"FRACTURA DE EXTREMO PROXIMAL DE RADIO Y CÚBITO"
  },
  {
    "codigo":295974005,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE GABAPENTINA"
  },
  {
    "codigo":16015231000119104,
    "descripcion":"PELLIZCAMIENTO DE ARTICULACIÓN DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":294139004,
    "descripcion":"ALERGIA A TRIPROLIDINA"
  },
  {
    "codigo":16670591000119105,
    "descripcion":"FRACTURA NO EXPUESTA DE CUERPO DE MANDÍBULA DERECHA"
  },
  {
    "codigo":95696003,
    "descripcion":"DEGENERACIÓN RETINIANA GLAUCOMATOSA"
  },
  {
    "codigo":292304005,
    "descripcion":"REACCIÓN ADVERSA A LA PAROXETINA"
  },
  {
    "codigo":126629000,
    "descripcion":"NEOPLASIA DE MÚSCULO DE LA REGIÓN INGUINAL"
  },
  {
    "codigo":128464009,
    "descripcion":"NEOPLASIA DE CARTÍLAGO ARTICULAR"
  },
  {
    "codigo":93861003,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA PARED LATERAL DE LA NASOFARINGE"
  },
  {
    "codigo":342041000119101,
    "descripcion":"BLEFAROCONJUNTIVITIS ANGULAR DE OJO IZQUIERDO"
  },
  {
    "codigo":716453008,
    "descripcion":"CAPAZ DE MANTENER EL NIVEL DE ENERGÍA"
  },
  {
    "codigo":290469008,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR FENOLFTALEÍNA"
  },
  {
    "codigo":92026002,
    "descripcion":"NEOPLASIA BENIGNA DE HUESO DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":190330002,
    "descripcion":"COMA HIPEROSMOLAR DEBIDO A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":288634004,
    "descripcion":"CAPAZ DE ENTABLAR CONVERSACIÓN"
  },
  {
    "codigo":860851007,
    "descripcion":"GRANULOMA DE LÓBULO DE HEMISFERIO CEREBRAL"
  },
  {
    "codigo":59258008,
    "descripcion":"INFECCIÓN CAUSADA POR DEUTEROMYCETES"
  },
  {
    "codigo":219428004,
    "descripcion":"HERIDA DE GUERRA - GUERRA BACTERIOLÓGICA"
  },
  {
    "codigo":284964004,
    "descripcion":"MANTIENE ESTÁNDAR DE HIGIENE PERSONAL"
  },
  {
    "codigo":88356006,
    "descripcion":"COMPLEJO PRIMARIO TUBERCULOSO"
  },
  {
    "codigo":448804008,
    "descripcion":"SÍNDROME DE COMPRESIÓN DE VENA ILÍACA"
  },
  {
    "codigo":96281000119107,
    "descripcion":"NEOPLASIA MALIGNA SUPERPUESTA DE COLON Y RECTO"
  },
  {
    "codigo":283129004,
    "descripcion":"AMPOLLA TRAUMÁTICA DE LA REGIÓN PÉLVICA"
  },
  {
    "codigo":1004025007,
    "descripcion":"TRASTORNO NEONATAL DEBIDO A ENFERMEDAD RENAL MATERNA"
  },
  {
    "codigo":838350007,
    "descripcion":"ADENOMA DE NEUROEPITELIO DE IRIS"
  },
  {
    "codigo":246691001,
    "descripcion":"POSTURA OCULAR CON LA CABEZA GIRADA"
  },
  {
    "codigo":277624003,
    "descripcion":"LINFOMA MALIGNO FOLICULAR - TIPO DE CÉLULAS MIXTAS"
  },
  {
    "codigo":48248005,
    "descripcion":"TROMBOFLEBITIS DEL SENO SAGITAL INFERIOR"
  },
  {
    "codigo":212088008,
    "descripcion":"QUEMADURA QUE COMPROMETE 60-69 PORCIENTO DE LA SUPERFICIE DEL CUERPO, CON QUEMADURA DE ESPESOR COMPLETO QUE AFECTA 30-39 PORCIENTO DE LA SUPERFICIE CORPORAL"
  },
  {
    "codigo":243021002,
    "descripcion":"LESIÓN POR FRAGMENTO DE GRANADA DE MANO"
  },
  {
    "codigo":13645005,
    "descripcion":"ENFERMEDAD PULMONAR OBSTRUCTIVA CRÓNICA"
  },
  {
    "codigo":767309006,
    "descripcion":"DOBLE CAYADO AÓRTICO CON CAYADO IZQUIERDO DOMINANTE E HIPOPLASIA DEL CAYADO DERECHO"
  },
  {
    "codigo":208418006,
    "descripcion":"FRACTURA EXPUESTA DE METACARPIANO"
  },
  {
    "codigo":110114007,
    "descripcion":"LACERACIÓN SIMPLE DE LA ENCÍA ALVEOLAR DE LA MANDÍBULA"
  },
  {
    "codigo":403191005,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL"
  },
  {
    "codigo":75511006,
    "descripcion":"DEFORMIDAD CONGÉNITA DE LA PARED TORÁCICA"
  },
  {
    "codigo":1156855006,
    "descripcion":"OFTALMOPLEJÍA EXTERNA PROGRESIVA AUTOSÓMICA DOMINANTE TIPO 3"
  },
  {
    "codigo":204748003,
    "descripcion":"BRIDAS INTESTINALES CONGÉNITAS"
  },
  {
    "codigo":237516005,
    "descripcion":"HIPOPLASIA TIROIDEA CONGÉNITA"
  },
  {
    "codigo":1251489000,
    "descripcion":"METÁSTASIS DE CARCINOMA DE FRENILLO LINGUAL"
  },
  {
    "codigo":202913001,
    "descripcion":"TENOSINOVITIS DE FLEXOR DEL PULGAR"
  },
  {
    "codigo":235681003,
    "descripcion":"BEZOAR MEDICAMENTOSO"
  },
  {
    "codigo":344551000119101,
    "descripcion":"PTERIGIÓN PERIFÉRICO PROGRESIVO BILATERAL"
  },
  {
    "codigo":301217005,
    "descripcion":"CUERDA VOCAL PRESENTE"
  },
  {
    "codigo":233846000,
    "descripcion":"DEFECTO DEL TABIQUE INTERVENTRICULAR CONSECUTIVO A INFARTO"
  },
  {
    "codigo":170145009,
    "descripcion":"EXAMEN DEL NIÑO A LOS 2.5 AÑOS: NORMAL"
  },
  {
    "codigo":1081831000119102,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE PIEL DE CADERA IZQUIERDA"
  },
  {
    "codigo":70006003,
    "descripcion":"PENETRACIÓN PERCUTÁNEA DISMINUIDA"
  },
  {
    "codigo":98791000119102,
    "descripcion":"EVIDENCIA CITOLÓGICA DE NEOPLASIA MALIGNA EN EXTENDIDO DE PAPANICOLAOU CERVICAL"
  },
  {
    "codigo":299382005,
    "descripcion":"ARTICULACIÓN DE LA RODILLA ERITEMATOSA"
  },
  {
    "codigo":364918003,
    "descripcion":"ESTABILIDAD DE LA UNIDAD MOTORA-HALLAZGO"
  },
  {
    "codigo":232011000,
    "descripcion":"DESPRENDIMIENTO DE RETINA POR TRACCIÓN SIN COMPROMISO MACULAR"
  },
  {
    "codigo":4470009,
    "descripcion":"BLANQUEAMIENTO DE LA PIEL"
  },
  {
    "codigo":37238008,
    "descripcion":"HERNIA DEL MEDIASTINO"
  },
  {
    "codigo":168310008,
    "descripcion":"ORGANISMO AISLADO EN CULTIVO DE HISOPADO DE EXTENDIDO CUTÁNEO"
  },
  {
    "codigo":35403005,
    "descripcion":"SÍNDROME MEDULAR POSTERIOR DEBIDO A FRACTURA NO EXPUESTA A NIVEL DE C5 - C7"
  },
  {
    "codigo":461387007,
    "descripcion":"ORIGEN ANÓMALO DE CONDUCTO ARTERIOSO IZQUIERDO EN CAYADO AÓRTICO DERECHO"
  },
  {
    "codigo":262944000,
    "descripcion":"SECCIÓN DE ARTERIA ESPINAL ANTERIOR"
  },
  {
    "codigo":293877000,
    "descripcion":"ALERGIA A METIPRILÓN"
  },
  {
    "codigo":230176008,
    "descripcion":"ENCEFALITIS POR HERPES ZÓSTER"
  },
  {
    "codigo":721696009,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE COLON TRANSVERSO"
  },
  {
    "codigo":457717005,
    "descripcion":"PERFORACIÓN DE VALVA DE VÁLVULA TRONCAL"
  },
  {
    "codigo":228341007,
    "descripcion":"INCAPAZ DE ABSTENERSE DE BEBER"
  },
  {
    "codigo":783562005,
    "descripcion":"SÍNDROME DE SINDACTILIA Y NISTAGMO DEBIDO A MICRODUPLICACIÓN 2Q31.1"
  },
  {
    "codigo":95434006,
    "descripcion":"TRAQUEOMALACIA"
  },
  {
    "codigo":292042007,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR PARACETAMOL"
  },
  {
    "codigo":93599000,
    "descripcion":"OSIFICACIÓN INCOMPLETA DEL PUBIS"
  },
  {
    "codigo":160970009,
    "descripcion":"ALADELTISTA"
  },
  {
    "codigo":716191002,
    "descripcion":"SÍNDROME DE PERNIOLA KRAJEWSKA CARNEVALE"
  },
  {
    "codigo":423114009,
    "descripcion":"CARCINOMA DUCTAL INFILTRANTE DE MAMA, ESTADIO 3"
  },
  {
    "codigo":26228000,
    "descripcion":"MENSTRUACIÓN RETENIDA"
  },
  {
    "codigo":288372001,
    "descripcion":"NO PASA OBJETOS DE UNA MANO A OTRA"
  },
  {
    "codigo":890461000,
    "descripcion":"SIMBLÉFARON CONGÉNITO BILATERAL"
  },
  {
    "codigo":450377000,
    "descripcion":"HEMORRAGIA EN ESPACIO MENÍNGEO DE NEUROEJE"
  },
  {
    "codigo":124532008,
    "descripcion":"DEFICIENCIA DE NUCLEÓSIDO - DIFOSFATASA"
  },
  {
    "codigo":712521003,
    "descripcion":"ARTRITIS BACTERIANA CAUSADA POR HAEMOPHILUS INFLUENZAE TIPO B"
  },
  {
    "codigo":253769003,
    "descripcion":"ESTENOSIS CONGÉNITA DE COLON"
  },
  {
    "codigo":251934002,
    "descripcion":"VELOCIDAD DE FLUJO ESPIRATORIO PICO PREVISTO ENTRE EL 60-80%"
  },
  {
    "codigo":11786881000119109,
    "descripcion":"CONTUSIÓN DE CADERA DERECHA"
  },
  {
    "codigo":22558005,
    "descripcion":"DEFECTO EN EL TRANSPORTE DE YODURO"
  },
  {
    "codigo":284702005,
    "descripcion":"ARRANCARSE PARTES DEL CUERPO"
  },
  {
    "codigo":1234974008,
    "descripcion":"TRASTORNO FETAL DEBIDO A CIRCULAR DE CORDÓN ALREDEDOR DE CUELLO"
  },
  {
    "codigo":448542008,
    "descripcion":"PANCREATITIS AUTOINMUNITARIA"
  },
  {
    "codigo":250099002,
    "descripcion":"COMPROMISO POLIARTICULAR"
  },
  {
    "codigo":20723003,
    "descripcion":"VÍCTIMA DE CONTIENDA NAVAL"
  },
  {
    "codigo":413939000,
    "descripcion":"CISTOCELE CON PROLAPSO UTERINO DE SEGUNDO GRADO"
  },
  {
    "codigo":282867006,
    "descripcion":"NO SE ADAPTA A UNA POSICIÓN"
  },
  {
    "codigo":248264000,
    "descripcion":"SIN QUEJAS"
  },
  {
    "codigo":1264072001,
    "descripcion":"TRASTORNO FETAL CAUSADO POR TRANSFERENCIA PLACENTARIA DE AGENTE ALUCINÓGENO"
  },
  {
    "codigo":18888002,
    "descripcion":"DISTENSIÓN DEL MÚSCULO Y\/O DEL TENDÓN DEL SUPRAESPINOSO"
  },
  {
    "codigo":1296840009,
    "descripcion":"HIPERTENSIÓN OCULAR DE OJO DERECHO DEBIDA A ANOMALÍA DE SEGMENTO ANTERIOR"
  },
  {
    "codigo":703346001,
    "descripcion":"REQUIERE VACUNACIÓN CONTRA VIRUS SINCICIAL RESPIRATORIO"
  },
  {
    "codigo":11842331000119109,
    "descripcion":"DISTENSIÓN DE TENDÓN DE PIE DERECHO"
  },
  {
    "codigo":47986005,
    "descripcion":"ANOMALÍA GENÉTICA DE LOS LEUCOCITOS"
  },
  {
    "codigo":277362007,
    "descripcion":"BLOQUEO ESPINAL TOTAL"
  },
  {
    "codigo":373831002,
    "descripcion":"SIN TUMORES SINCRÓNICOS PRESENTES EN LA LOCALIZACIÓN PRIMARIA"
  },
  {
    "codigo":78919003,
    "descripcion":"TRASTORNO AUTÓNOMO DEL NERVIO GLOSOFARÍNGEO"
  },
  {
    "codigo":347061000119104,
    "descripcion":"QUERATOPATÍA BULLOSA DE AMBOS OJOS"
  },
  {
    "codigo":767047005,
    "descripcion":"TUMOR NEUROECTODÉRMICO MELANÓTICO DE LA INFANCIA"
  },
  {
    "codigo":406599008,
    "descripcion":"INFECCIÓN DEL SISTEMA NERVIOSO CENTRAL POR PARVOVIRUS"
  },
  {
    "codigo":371996000,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LABIO"
  },
  {
    "codigo":208156002,
    "descripcion":"FRACTURA EXPUESTA DE ACETÁBULO, SÓLO LABIO POSTERIOR"
  },
  {
    "codigo":44316003,
    "descripcion":"FRECUENCIA DE DEFECACIÓN DISMINUIDA"
  },
  {
    "codigo":77084001,
    "descripcion":"ANEMIA APLÁSICA INMUNOLÓGICA"
  },
  {
    "codigo":699676006,
    "descripcion":"INFECCIÓN CAUSADA POR MICROSPORIDIA"
  },
  {
    "codigo":765212008,
    "descripcion":"SÍNDROME DE BALINT"
  },
  {
    "codigo":109852009,
    "descripcion":"NEOPLASIA BENIGNA DEL TEJIDO MESOTELIAL DEL PERITONEO"
  },
  {
    "codigo":9713002,
    "descripcion":"PROSTATITIS"
  },
  {
    "codigo":1254897004,
    "descripcion":"REACCIÓN FOTOTÓXICA OCUPACIONAL A ALQUITRÁN"
  },
  {
    "codigo":1287665004,
    "descripcion":"TUMOR NEUROENDOCRINO BIEN DIFERENCIADO PRIMARIO DE PÁNCREAS"
  },
  {
    "codigo":271857006,
    "descripcion":"DOLOR EN FLANCO"
  },
  {
    "codigo":402929007,
    "descripcion":"CELULITIS BACTERIANA"
  },
  {
    "codigo":106182000,
    "descripcion":"HALLAZGO DEL SISTEMA INMUNOLÓGICO"
  },
  {
    "codigo":239089006,
    "descripcion":"ACROMELANOSIS"
  },
  {
    "codigo":763377006,
    "descripcion":"PARAPLEJÍA ESPÁSTICA AUTOSÓMICA TIPO 30"
  },
  {
    "codigo":73414003,
    "descripcion":"LARINGOTRAQUEOBRONQUITIS POR HAEMOPHILUS INFLUENZAE"
  },
  {
    "codigo":827078006,
    "descripcion":"DEFECTO DE TABIQUE INTERVENTRICULAR DE EISENMENGER"
  },
  {
    "codigo":1187526007,
    "descripcion":"DEFICIENCIA DE PEX16"
  },
  {
    "codigo":237254009,
    "descripcion":"EMBARAZO TUBÁRICO SIN RUPTURA"
  },
  {
    "codigo":300955002,
    "descripcion":"DOLOR DE PULGAR"
  },
  {
    "codigo":366491003,
    "descripcion":"REFLEJO SACRO - HALLAZGO"
  },
  {
    "codigo":169883004,
    "descripcion":"PERÍMETRO CEFÁLICO AL NACER: ENTRE PERCENTILOS 90 Y 96"
  },
  {
    "codigo":268187005,
    "descripcion":"ANEURISMA CONGÉNITO DE ARTERIA PULMONAR"
  },
  {
    "codigo":4208000,
    "descripcion":"FRACTURAS MÚLTIPLES NO EXPUESTAS DE AMBAS EXTREMIDADES INFERIORES"
  },
  {
    "codigo":399259009,
    "descripcion":"SÍNDROME DEL SUPRAESPINOSO"
  },
  {
    "codigo":102512003,
    "descripcion":"ADULTO SANO"
  },
  {
    "codigo":36976004,
    "descripcion":"HIPOPARATIROIDISMO"
  },
  {
    "codigo":299120007,
    "descripcion":"ARTICULACIÓN DE DEDO DE LA MANO TIBIA AL TACTO"
  },
  {
    "codigo":297285002,
    "descripcion":"INSUFICIENCIA PULMONAR PARAPROTÉSICA"
  },
  {
    "codigo":1149253002,
    "descripcion":"LACTANCIA MATERNA SUSPENDIDA TEMPORARIAMENTE"
  },
  {
    "codigo":67909005,
    "descripcion":"RETRACCIÓN DE LA PARED TORÁCICA"
  },
  {
    "codigo":35141006,
    "descripcion":"TRASTORNO DE NERVIO COCLEAR"
  },
  {
    "codigo":428357005,
    "descripcion":"FRACTURA NO EXPUESTA TIPO III DE SALTER-HARRIS DE EPÍFISIS DISTAL DE FÉMUR"
  },
  {
    "codigo":721434001,
    "descripcion":"LESIÓN COMPLETA DE MÉDULA ESPINAL AL NIVEL DEL QUINTO SEGMENTO DORSAL"
  },
  {
    "codigo":295450001,
    "descripcion":"SOBREDOSIS INTENCIONAL DE SULFATO DE MAGNESIO"
  },
  {
    "codigo":66074005,
    "descripcion":"LEPTOMENINGITIS"
  },
  {
    "codigo":262682005,
    "descripcion":"LESIÓN TRAUMÁTICA VAGINAL"
  },
  {
    "codigo":129775002,
    "descripcion":"LOCALIZACIÓN EN HORA 4 EN LA MAMOGRAFÍA"
  },
  {
    "codigo":293615004,
    "descripcion":"ALERGIA A FELBINACO"
  },
  {
    "codigo":816068000,
    "descripcion":"HETEROTOPÍA NODULAR PERIVENTRICULAR"
  },
  {
    "codigo":719599008,
    "descripcion":"SÍNDROME DE MICRODELECIÓN 19P13.11"
  },
  {
    "codigo":95172007,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA VALÉCULA"
  },
  {
    "codigo":160708008,
    "descripcion":"ESCALERAS EN LA CASA"
  },
  {
    "codigo":93337001,
    "descripcion":"POSICIÓN ANÓMALA CONGÉNITA DE NARINAS"
  },
  {
    "codigo":60569002,
    "descripcion":"RELACIÓN VENTILACIÓN - PERFUSIÓN NORMAL"
  },
  {
    "codigo":191641004,
    "descripcion":"TRASTORNO AFECTIVO BIPOLAR MIXTO, GRAVE, CON SÍNTOMAS PSICÓTICOS"
  },
  {
    "codigo":25966003,
    "descripcion":"ACIDOSIS METABÓLICA CAUSADA POR METANOL"
  },
  {
    "codigo":419182006,
    "descripcion":"PROVISIONES NO DISPONIBLES"
  },
  {
    "codigo":124270006,
    "descripcion":"DEFICIENCIA DE ALFA - 1, 4 - GLUCANO - PROTEÍNA SINTASA (FORMADOR DE UDP)"
  },
  {
    "codigo":91502009,
    "descripcion":"ENFERMEDAD ESPINOCEREBELOSA"
  },
  {
    "codigo":253507001,
    "descripcion":"MALFORMACIÓN CONGÉNITA EN PARACAÍDAS DE VÁLVULA AURICULOVENTRICULAR IZQUIERDA"
  },
  {
    "codigo":11818371000119104,
    "descripcion":"ESGUINCE DE LIGAMENTO DE ARTICULACIÓN INTERFALÁNGICA DE PULGAR DERECHO"
  },
  {
    "codigo":417347005,
    "descripcion":"DISFUNCIÓN SOMÁTICA CERVICAL"
  },
  {
    "codigo":286275009,
    "descripcion":"CAPAZ DE ARTICULAR PALABRAS"
  },
  {
    "codigo":415512002,
    "descripcion":"ATENDIDO POR HERBALISTA"
  },
  {
    "codigo":186136006,
    "descripcion":"INFECCIÓN DEL TRACTO GASTROINTESTINAL POR PROTEUS"
  },
  {
    "codigo":448280008,
    "descripcion":"MALA ALINEACIÓN DE SENO AÓRTICO EN RELACIÓN CON EL SENO PULMONAR"
  },
  {
    "codigo":315373000,
    "descripcion":"NACIDO EN ARMENIA"
  },
  {
    "codigo":282605003,
    "descripcion":"DIFICULTAD PARA SALTAR"
  },
  {
    "codigo":248002008,
    "descripcion":"INTIMIDACIÓN FÍSICA"
  },
  {
    "codigo":442775009,
    "descripcion":"ORGANISMO AISLADO EN CULTIVO MICROBIOLÓGICO DE ESPÉCIMEN DE LÍQUIDO CEFALORRAQUÍDEO"
  },
  {
    "codigo":47724003,
    "descripcion":"COMPLICACIÓN DE PROCEDIMIENTO DE INYECCIÓN"
  },
  {
    "codigo":211564003,
    "descripcion":"LESIÓN TRAUMÁTICA CERRADA POR APLASTAMIENTO, ANTEBRAZO"
  },
  {
    "codigo":1260140008,
    "descripcion":"SÍNDROME CONGÉNITO DE CATARATAS, HEPATOPATÍA NEONATAL GRAVE Y RETRASO GLOBAL DEL DESARROLLO"
  },
  {
    "codigo":209729000,
    "descripcion":"SECCIÓN EXPUESTA DE LIGAMENTO DEL CUELLO"
  },
  {
    "codigo":45889003,
    "descripcion":"DISTRIQUIASIS"
  },
  {
    "codigo":308033007,
    "descripcion":"VISTO POR EL SERVICIO DE PATOLOGÍA"
  },
  {
    "codigo":734017008,
    "descripcion":"SÍNDROME DE DISPLASIA ECTODÉRMICA, DISCAPACIDAD INTELECTUAL Y MALFORMACIÓN DEL SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":764950001,
    "descripcion":"SÍNDROME DE CRIPTORQUIDIA, ARACNODACTILIA Y DISCAPACIDAD INTELECTUAL"
  },
  {
    "codigo":109590006,
    "descripcion":"SENSIBILIDAD DENTAL EN LA UNIÓN CEMENTO - ESMALTE"
  },
  {
    "codigo":44054006,
    "descripcion":"DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":1156331007,
    "descripcion":"EUFORIA EXCESIVA"
  },
  {
    "codigo":433600001,
    "descripcion":"RECHAZO HIPERAGUDO DE TRASPLANTE DE INTESTINO"
  },
  {
    "codigo":204224006,
    "descripcion":"ANOMALÍAS DEL OÍDO, CON ALTERACIÓN EN LA AUDICIÓN"
  },
  {
    "codigo":202389001,
    "descripcion":"DERRAME DE ARTICULACIÓN INTERFALÁNGICA DE DEDO DEL PIE"
  },
  {
    "codigo":366229006,
    "descripcion":"HALLAZGO RELACIONADO CON LA COLORACIÓN DE DIENTE"
  },
  {
    "codigo":398997008,
    "descripcion":"SÍNDROME DE DOLOR VERTEBROGÉNICO"
  },
  {
    "codigo":298858000,
    "descripcion":"ARTICULACIÓN DE HOMBRO - AMPLITUD DE MOVIMIENTO DOLOROSA"
  },
  {
    "codigo":69482004,
    "descripcion":"PSICOSIS DE KORSAKOFF"
  },
  {
    "codigo":167786007,
    "descripcion":"MOVILIDAD DE LOS ESPERMATOZOIDES A LAS 6-8 HORAS, MODERADA: 30-40%"
  },
  {
    "codigo":724842007,
    "descripcion":"MALFORMACIÓN VENOSA CONGÉNITA DE VENA CUTÁNEA"
  },
  {
    "codigo":266090008,
    "descripcion":"ACTINOMICOSIS ILEOCECAL"
  },
  {
    "codigo":723007003,
    "descripcion":"SIMBLÉFARON ADQUIRIDO"
  },
  {
    "codigo":231487004,
    "descripcion":"TRASTORNO DELIRANTE PERSISTENTE"
  },
  {
    "codigo":297023004,
    "descripcion":"SOBREDOSIS INTENCIONAL DE BUMETANIDA"
  },
  {
    "codigo":34879005,
    "descripcion":"HABITUACIÓN VULVOCLITORÍDEA AUTOMANIPULATORIA"
  },
  {
    "codigo":721172000,
    "descripcion":"HIPOMAGNESEMIA CONCOMITANTE CON NORMOCALCIURIA"
  },
  {
    "codigo":428095009,
    "descripcion":"LESIÓN TRAUMÁTICA DEL PERONÉ"
  },
  {
    "codigo":196884002,
    "descripcion":"EVENTRACIÓN OBSTRUIDA"
  },
  {
    "codigo":229652004,
    "descripcion":"TRASTORNO ADQUIRIDO DEL LENGUAJE"
  },
  {
    "codigo":295188005,
    "descripcion":"SOBREDOSIS DE SUSTANCIA ANÁLOGA A LA MEPERIDINA"
  },
  {
    "codigo":276008,
    "descripcion":"INTOXICACIÓN POR OXITOCINA"
  },
  {
    "codigo":1145321001,
    "descripcion":"SURCO NASOLABIAL EN CARPA"
  },
  {
    "codigo":63977007,
    "descripcion":"SEBORREA ADIPOSA"
  },
  {
    "codigo":352081000119108,
    "descripcion":"CARCINOMA DE CÉLULAS DE MERKEL PRIMARIO DE PIEL DE LABIO"
  },
  {
    "codigo":291518001,
    "descripcion":"INTOXICACIÓN POR VANCOMICINA"
  },
  {
    "codigo":94910002,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE HÍGADO"
  },
  {
    "codigo":193214009,
    "descripcion":"SÍNDROME MIASTÉNICO POR HIPERTIROIDISMO"
  },
  {
    "codigo":781203005,
    "descripcion":"ÚLCERA DE CURLING DEL ESTÓMAGO"
  },
  {
    "codigo":1141651006,
    "descripcion":"DEMUESTRA CONOCIMIENTO SOBRE TRABAJO DE PARTO Y PARTO"
  },
  {
    "codigo":289683007,
    "descripcion":"ALTURA DEL FONDO UTERINO ELEVADA PARA LA EDAD GESTACIONAL"
  },
  {
    "codigo":42781000087101,
    "descripcion":"DISCO INTERVERTEBRAL TORÁCICO PROLAPSADO, T7-T8"
  },
  {
    "codigo":53021000087105,
    "descripcion":"AUMENTO DE NIVEL DE DESORIENTACIÓN ESPACIAL"
  },
  {
    "codigo":93075009,
    "descripcion":"HIPERTROFIA CONGÉNITA DE VÁLVULA PULMONAR"
  },
  {
    "codigo":47901000087107,
    "descripcion":"FRACTURA DE DÉCIMA COSTILLA IZQUIERDA"
  },
  {
    "codigo":224147006,
    "descripcion":"VIVE COMO ACOMPAÑANTE NO RENTADO"
  },
  {
    "codigo":1172584005,
    "descripcion":"SÍNDROME DE DEGENERACIÓN DE GANGLIOS BASALES DE INICIO EN LA INFANCIA"
  },
  {
    "codigo":124008007,
    "descripcion":"PENTOSA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":91240008,
    "descripcion":"DEGENERACIÓN DE DISCO INTERVERTEBRAL TORACOLUMBAR"
  },
  {
    "codigo":449853003,
    "descripcion":"DEFICIENCIA DE INTERLEUCINA 12"
  },
  {
    "codigo":1269053004,
    "descripcion":"LESIONES MÚLTIPLES DE VASO SANGUÍNEO DE PELVIS"
  },
  {
    "codigo":286013004,
    "descripcion":"DIFICULTAD PARA ENCENDER UN ARTEFACTO ELECTRODOMÉSTICO"
  },
  {
    "codigo":187709007,
    "descripcion":"NEOPLASIA MALIGNA DE LA REGIÓN POSTERIOR DE LA FARINGE"
  },
  {
    "codigo":23869008,
    "descripcion":"PARAFASIA LITERAL"
  },
  {
    "codigo":89405008,
    "descripcion":"FÍSTULA VESICOVAGINAL"
  },
  {
    "codigo":11849861000119102,
    "descripcion":"HERIDA DE LA CABEZA DEBIDA A PICADURA DE INSECTO NO VENENOSO"
  },
  {
    "codigo":87570008,
    "descripcion":"INTOXICACIÓN POR PSILOCAULON"
  },
  {
    "codigo":52967002,
    "descripcion":"MIELOFIBROSIS"
  },
  {
    "codigo":249575008,
    "descripcion":"ESCOTADURA ESPLÉNICA PALPABLE"
  },
  {
    "codigo":247740003,
    "descripcion":"ALUCINACIONES EN VARIAS MODALIDADES AL MISMO TIEMPO"
  },
  {
    "codigo":870332008,
    "descripcion":"PANUVEÍTIS CAUSADA POR HERPESVIRUS"
  },
  {
    "codigo":1263548009,
    "descripcion":"LESIÓN DE PORCIÓN CEREBRAL DE ARTERIA CARÓTIDA INTERNA"
  },
  {
    "codigo":82065001,
    "descripcion":"FRACTURA DE HUESO DEL CARPO"
  },
  {
    "codigo":975231000000107,
    "descripcion":"HERNIA UMBILICAL CONGÉNITA"
  },
  {
    "codigo":213137004,
    "descripcion":"REACCIÓN INFECCIOSA E INFLAMATORIA DEBIDA A DISPOSITIVO PROTÉSICO, IMPLANTE E INJERTO EN LA VÍA URINARIA"
  },
  {
    "codigo":278673005,
    "descripcion":"ANGULACIÓN DE DIENTE CANINO - MESIAL"
  },
  {
    "codigo":682271000119102,
    "descripcion":"ANGIOSARCOMA PRIMARIO DE ABDOMEN"
  },
  {
    "codigo":704657009,
    "descripcion":"RECUPERACIÓN FÍSICA RETARDADA"
  },
  {
    "codigo":211302003,
    "descripcion":"LESIÓN SUPERFICIAL EN LA MANO, EXCLUIDOS LOS DEDOS"
  },
  {
    "codigo":473446004,
    "descripcion":"ANOMALÍA ADQUIRIDA DE VENA FEMORAL"
  },
  {
    "codigo":440678006,
    "descripcion":"ATENDIDO EN CONSULTORIO HOSPITALARIO ESPECIALIZADO EN ANTICOAGULACIÓN"
  },
  {
    "codigo":897595001,
    "descripcion":"FÍSTULA ANORRECTAL CONGÉNITA DEBIDA A MALFORMACIÓN ANORRECTAL BAJA"
  },
  {
    "codigo":242235002,
    "descripcion":"PARACAIDISTA LESIONADO AL ACCIONAR EL ASIENTO EYECTOR"
  },
  {
    "codigo":78395001,
    "descripcion":"EDAD GESTACIONAL, 33 SEMANAS"
  },
  {
    "codigo":12859005,
    "descripcion":"PISOTEAR"
  },
  {
    "codigo":764688002,
    "descripcion":"PARAPLEJÍA ESPÁSTICA AUTOSÓMICA RECESIVA TIPO 35"
  },
  {
    "codigo":109328006,
    "descripcion":"ABSCESO DE HUESO FRONTAL"
  },
  {
    "codigo":404240007,
    "descripcion":"MENINGITIS CAUSADA POR VIRUS LA CROSSE"
  },
  {
    "codigo":74725000,
    "descripcion":"ERITROCIANOSIS"
  },
  {
    "codigo":238565002,
    "descripcion":"DERMATITIS SEBORREICA DEL TRONCO"
  },
  {
    "codigo":369637006,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA DE URÉTER PROXIMAL, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":1187002002,
    "descripcion":"MONONUCLEOSIS POR ADENOVIRUS"
  },
  {
    "codigo":105658002,
    "descripcion":"ENFERMEDAD CAUSADA POR PROTOZOARIOS CILIADOS"
  },
  {
    "codigo":15729081000119103,
    "descripcion":"LUXACIÓN DE ARTICULACIÓN DE PIE DERECHO DEBIDA A DISPLASIA CONGÉNITA"
  },
  {
    "codigo":40122008,
    "descripcion":"NEUMOCONIOSIS"
  },
  {
    "codigo":236730008,
    "descripcion":"EXTRUSIÓN DE LA PRÓTESIS TESTICULAR"
  },
  {
    "codigo":71055004,
    "descripcion":"SORDERA DE FRECUENCIA MEDIA"
  },
  {
    "codigo":365967005,
    "descripcion":"INGESTA DE ALCOHOL - HALLAZGO"
  },
  {
    "codigo":724580000,
    "descripcion":"NEOPLASIA OSTEÓGENA BENIGNA DE CARTÍLAGO ARTICULAR DE CABEZA"
  },
  {
    "codigo":429668008,
    "descripcion":"NEURITIS DE NERVIO SAFENO"
  },
  {
    "codigo":298596008,
    "descripcion":"TUMEFACCIÓN DE PARTES BLANDAS DE LA COLUMNA LUMBAR"
  },
  {
    "codigo":263993001,
    "descripcion":"EPOÓFORO"
  },
  {
    "codigo":427833000,
    "descripcion":"ANAFILAXIA CAUSADA POR MOLUSCO"
  },
  {
    "codigo":198457000,
    "descripcion":"INFERTILIDAD SECUNDARIA DE ORIGEN UTERINO"
  },
  {
    "codigo":460601009,
    "descripcion":"DISFUNCIÓN DE MÚSCULO PAPILAR DE VÁLVULA AURICULOVENTRICULAR (MORFOLÓGICAMENTE NO TRICÚSPIDE) DERECHA"
  },
  {
    "codigo":131086003,
    "descripcion":"NIVEL DE CORTICOSTERONA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":294926004,
    "descripcion":"ALERGIA A ALFA-TOCOFEROL"
  },
  {
    "codigo":293091005,
    "descripcion":"REACCIÓN ADVERSA AL MALATIÓN"
  },
  {
    "codigo":291256001,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR MESCALINA"
  },
  {
    "codigo":94648005,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL NERVIO TROCLEAR"
  },
  {
    "codigo":472181000124101,
    "descripcion":"ASISTENCIA REQUERIDA PARA LIMPIAR PRÓTESIS DENTAL PROPIA"
  },
  {
    "codigo":92813000,
    "descripcion":"LEUCEMIA LINFOIDE CRÓNICA EN REMISIÓN"
  },
  {
    "codigo":27277001,
    "descripcion":"TOFO GOTOSO DE CORAZÓN"
  },
  {
    "codigo":661621000124106,
    "descripcion":"ARTRITIS DE ARTICULACIÓN DE REGIÓN DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":1010317001,
    "descripcion":"TRASTORNO NEONATAL DEBIDO A OBESIDAD MATERNA CON UN ÍNDICE DE MASA CORPORAL PARA ADULTO DE 30 O SUPERIOR PERO INFERIOR A 40"
  },
  {
    "codigo":289421001,
    "descripcion":"FONTANELA POSTERIOR PALPABLE EN LA REGIÓN LATERAL IZQUIERDA"
  },
  {
    "codigo":60045007,
    "descripcion":"DEFICIENCIA MODERADA DE ESTEROIDE 21 - HIDROXILASA"
  },
  {
    "codigo":254818000,
    "descripcion":"NEVO CUTÁNEO DISPLÁSICO"
  },
  {
    "codigo":1303394003,
    "descripcion":"FRACTURA ÓSEA DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":285751000,
    "descripcion":"LESIÓN VENOSA EN EL TRONCO"
  },
  {
    "codigo":713570009,
    "descripcion":"GASTROENTERITIS INFECCIOSA CONCOMITANTE CON INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":89143002,
    "descripcion":"ENFERMEDAD POR EL VIRUS PICHINDE"
  },
  {
    "codigo":351287008,
    "descripcion":"DISGENESIA RETICULAR CON ALEUCOCITOSIS CONGÉNITA"
  },
  {
    "codigo":29421000119105,
    "descripcion":"ADENOCARCINOMA EN PÓLIPO ADENOMATOSO"
  },
  {
    "codigo":283916003,
    "descripcion":"LACERACIÓN DE VEJIGA URINARIA"
  },
  {
    "codigo":251148003,
    "descripcion":"VOLTAJES DEL QRS BAJOS EN LAS DERIVACIONES PRECORDIALES"
  },
  {
    "codigo":447756006,
    "descripcion":"POSICIÓN QUIRÚRGICA EN NAVAJA"
  },
  {
    "codigo":52705001,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN LOS DEDOS DE LA MANO, CON INFECCIÓN"
  },
  {
    "codigo":445921004,
    "descripcion":"CUERPO EXTRAÑO MAGNÉTICO EN CUERPO CILIAR"
  },
  {
    "codigo":183777007,
    "descripcion":"INSCRIPTO EN LISTA DE ADMISIÓN REUMATOLÓGICA"
  },
  {
    "codigo":247478000,
    "descripcion":"LIVEDO"
  },
  {
    "codigo":118241009,
    "descripcion":"HALLAZGO POR AUSCULTACIÓN"
  },
  {
    "codigo":216545008,
    "descripcion":"INTOXICACIÓN ACCIDENTAL CAUSADA POR ANTIDEPRESIVOS"
  },
  {
    "codigo":1163147006,
    "descripcion":"FIBROSIS PULMONAR CRÓNICA POR ASPERGILLUS"
  },
  {
    "codigo":276576000,
    "descripcion":"NEUTROPENIA DE BEBÉ PEQUEÑO PARA LA EDAD GESTACIONAL"
  },
  {
    "codigo":49035009,
    "descripcion":"CAPACIDAD RESIDUAL FUNCIONAL NORMAL"
  },
  {
    "codigo":407648002,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: ALBANÉS"
  },
  {
    "codigo":16059271000119105,
    "descripcion":"DEFECTO DEL CAMPO VISUAL CON ESCALÓN NASAL DE OJO IZQUIERDO"
  },
  {
    "codigo":47200007,
    "descripcion":"EMBARAZO DE ALTO RIESGO"
  },
  {
    "codigo":211040008,
    "descripcion":"ABRASIÓN DE PIEL DE MAMA"
  },
  {
    "codigo":1259616009,
    "descripcion":"SARCOMA DE EWING PRIMARIO DE ESTRUCTURA ÓSEA DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":274741002,
    "descripcion":"GANGLIOS LINFÁTICOS AGRANDADOS GENERALIZADOS"
  },
  {
    "codigo":45365002,
    "descripcion":"PERITONITIS PROLIFERATIVA CRÓNICA"
  },
  {
    "codigo":241973007,
    "descripcion":"RETINOPATÍA POR ALTITUD ELEVADA"
  },
  {
    "codigo":240138000,
    "descripcion":"DEFECTO DE CARTÍLAGO ARTICULAR"
  },
  {
    "codigo":373045009,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM MUCOGENICUM"
  },
  {
    "codigo":698890004,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: BISLAMA"
  },
  {
    "codigo":305674005,
    "descripcion":"ATENDIDO POR UN GENETISTA"
  },
  {
    "codigo":403978008,
    "descripcion":"SARCOMA DE KAPOSI ESPORÁDICO"
  },
  {
    "codigo":860895001,
    "descripcion":"ATIPIA EPITELIAL PLANA DE MAMA"
  },
  {
    "codigo":1155807002,
    "descripcion":"REACCIÓN ADVERSA POSTERIOR A INYECCIÓN DE SUSTANCIA"
  },
  {
    "codigo":402143001,
    "descripcion":"TRICOMONIASIS QUE AFECTA PIEL"
  },
  {
    "codigo":1286879001,
    "descripcion":"NEOPLASIA MALIGNA DE CIEGO Y\/O COLON Y\/O RECTO QUE EXPRESA FACTOR DE CRECIMIENTO EPIDÉRMICO HUMANO 2"
  },
  {
    "codigo":762591005,
    "descripcion":"DOLOR MUSCULOESQUELÉTICO CRÓNICO PRIMARIO"
  },
  {
    "codigo":302004004,
    "descripcion":"TEMBLOR TIROTÓXICO"
  },
  {
    "codigo":170932006,
    "descripcion":"ENFERMEDAD CRÓNICA - ORGANIZACIÓN DE LA ATENCIÓN"
  },
  {
    "codigo":236468006,
    "descripcion":"SÍNDROME DE FANCONI EN EL ADULTO"
  },
  {
    "codigo":234633000,
    "descripcion":"INESTABILIDAD CENTROMÉRICA DE LOS CROMOSOMAS 1, 9 Y 16 E INMUNODEFICIENCIA"
  },
  {
    "codigo":1217673001,
    "descripcion":"CONJUNTIVITIS CICATRIZAL TÓXICA CRÓNICA"
  },
  {
    "codigo":269236007,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO SUPERFICIAL DE MENTÓN"
  },
  {
    "codigo":300169003,
    "descripcion":"MARTILLO: AUSENTE"
  },
  {
    "codigo":365705006,
    "descripcion":"SENSIBILIDAD ANTIMICROBIANA - HALLAZGO"
  },
  {
    "codigo":462174007,
    "descripcion":"INSUFICIENCIA CARDÍACA FETAL CON HIPERTROFIA MIOCÁRDICA"
  },
  {
    "codigo":427571000,
    "descripcion":"NEUROPATÍA DE PLEXO RADICULAR LUMBOSACRO DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":298334009,
    "descripcion":"RESPUESTA MOTORA FLEXORA LUEGO DE UNA ORDEN"
  },
  {
    "codigo":167262009,
    "descripcion":"PRUEBA DE GLUCOSA EN ORINA = TRAZAS"
  },
  {
    "codigo":165427000,
    "descripcion":"RECUENTO DE GLÓBULOS ROJOS FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":11844791000119100,
    "descripcion":"LESIÓN TRAUMÁTICA DE ARTERIA VERTEBRAL DERECHA"
  },
  {
    "codigo":296631000119101,
    "descripcion":"HIPERLAXITUD ARTICULAR DE PIE"
  },
  {
    "codigo":79031000119101,
    "descripcion":"DEPENDENCIA DE RESPIRADOR"
  },
  {
    "codigo":1092791000119103,
    "descripcion":"CAMBIO TEMPORARIO DEL UMBRAL AUDITIVO"
  },
  {
    "codigo":1082551000119101,
    "descripcion":"INFLAMACIÓN AGUDA RECURRENTE DE GLÁNDULA SALIVAL"
  },
  {
    "codigo":425736001,
    "descripcion":"EXACERBACIÓN TUMORAL"
  },
  {
    "codigo":10759351000119103,
    "descripcion":"ANEMIA DREPANOCÍTICA MATERNA QUE COMPLICA EL NACIMIENTO"
  },
  {
    "codigo":99511000119105,
    "descripcion":"MUCOSITIS ULCEROSA DE VULVA"
  },
  {
    "codigo":586464951000119108,
    "descripcion":"MELANOMA MALIGNO PRIMARIO DE MEMBRANA MUCOSA DE LARINGE"
  },
  {
    "codigo":15986871000119102,
    "descripcion":"HIPERPLASIA PRIMARIA PERSISTENTE DE CUERPO VÍTREO DE OJO DERECHO"
  },
  {
    "codigo":10682551000119103,
    "descripcion":"TUMORACIÓN DE LA PIEL DE LA EXTREMIDAD SUPERIOR DERECHA"
  },
  {
    "codigo":322231000119104,
    "descripcion":"QUISTE SINOVIAL DE RODILLA DERECHA"
  },
  {
    "codigo":1144797000,
    "descripcion":"VÁRICES VENOSAS DE AMBAS EXTREMIDADES INFERIORES EN EL PUERPERIO"
  },
  {
    "codigo":12239031000119106,
    "descripcion":"TRASTORNO DE BOLSA SEROSA DE HOMBRO DERECHO"
  },
  {
    "codigo":296499009,
    "descripcion":"SOBREDOSIS DE SAL DE ORO"
  },
  {
    "codigo":10633911000119107,
    "descripcion":"CELULITIS DE MIEMBRO SUPERIOR DERECHO"
  },
  {
    "codigo":784349004,
    "descripcion":"PIEL LAXA CON ANOMALÍAS URINARIAS, GASTROINTESTINALES Y PULMONARES SEVERAS"
  },
  {
    "codigo":15981751000119108,
    "descripcion":"SÍNDROME DE HIPERLAXITUD PALPEBRAL DEL OJO IZQUIERDO"
  },
  {
    "codigo":317111000119109,
    "descripcion":"REUMATISMO PALINDRÓMICO DE RODILLA DERECHA"
  },
  {
    "codigo":292829006,
    "descripcion":"REACCIÓN ADVERSA AL GANCICLOVIR"
  },
  {
    "codigo":10818901000119102,
    "descripcion":"FRACTURA TRIMALEOLAR EXPUESTA DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":28850000,
    "descripcion":"INFECCIÓN CAUSADA POR PROSTHOGONIMUS"
  },
  {
    "codigo":61618002,
    "descripcion":"FUNCIÓN CARDIOVASCULAR NORMAL"
  },
  {
    "codigo":290994003,
    "descripcion":"INTOXICACIÓN POR CLORMEZANONA"
  },
  {
    "codigo":225458002,
    "descripcion":"CUIDA A LOS DEMÁS"
  },
  {
    "codigo":94386007,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE MIEMBRO INFERIOR"
  },
  {
    "codigo":289159000,
    "descripcion":"HALLAZGO DE SED"
  },
  {
    "codigo":127154008,
    "descripcion":"LINFADENOPATÍA RETROPERITONEAL"
  },
  {
    "codigo":190855004,
    "descripcion":"HIPOMAGNESEMIA"
  },
  {
    "codigo":715143005,
    "descripcion":"INTOXICACIÓN ACCIDENTAL CAUSADA POR ENDRINA"
  },
  {
    "codigo":92551005,
    "descripcion":"CARCINOMA IN SITU DEL LIGAMENTO ANCHO"
  },
  {
    "codigo":59783007,
    "descripcion":"MIEMBRO DE TRIPULACIÓN EN ACCIDENTE AÉREO"
  },
  {
    "codigo":90716005,
    "descripcion":"TIENDE A NO SER SOCIABLE"
  },
  {
    "codigo":57948007,
    "descripcion":"AGNOSIA GUSTATIVA"
  },
  {
    "codigo":1335900008,
    "descripcion":"ANTICUERPO CONTRA ADENOVIRUS DETECTADO"
  },
  {
    "codigo":449329002,
    "descripcion":"TUMEFACCIÓN DE TRONCO"
  },
  {
    "codigo":283654000,
    "descripcion":"HERIDA POR PINCHAZO DE CLAVO EN EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":416561008,
    "descripcion":"TUMOR POSITIVO PARA RECEPTOR DE PROGESTERONA"
  },
  {
    "codigo":1332230002,
    "descripcion":"INCONGRUENCIA DE GÉNERO"
  },
  {
    "codigo":285489009,
    "descripcion":"DIFICULTAD PARA ESTIRAR LOS LABIOS"
  },
  {
    "codigo":10874351000119102,
    "descripcion":"HERIDA ABIERTA DE MEJILLA DERECHA"
  },
  {
    "codigo":609499000,
    "descripcion":"INTERRUPCIÓN INDUCIDA DEL EMBARAZO COMPLICADA POR LACERACIÓN DE TEJIDO PERIURETRAL"
  },
  {
    "codigo":249051004,
    "descripcion":"FETO PEQUEÑO"
  },
  {
    "codigo":871643004,
    "descripcion":"DEFECTO DE TABIQUE AURICULOVENTRICULAR CON VENTRÍCULOS EQUILIBRADOS"
  },
  {
    "codigo":50608004,
    "descripcion":"INCOMPETENCIA DEL MÚSCULO PAPILAR"
  },
  {
    "codigo":247216007,
    "descripcion":"PAPILA ÓPTICA MIÓPICA SEMILUNAR"
  },
  {
    "codigo":278149003,
    "descripcion":"GRUPO SANGUÍNEO A RH(D) POSITIVO"
  },
  {
    "codigo":689801000119101,
    "descripcion":"CARCINOMA DE CÉLULAS DE TRANSICIÓN DE PARED LATERAL DE VEJIGA URINARIA"
  },
  {
    "codigo":1259354000,
    "descripcion":"CARCINOMA PRIMARIO DE PÍLORO"
  },
  {
    "codigo":309082002,
    "descripcion":"MASA EPIGÁSTRICA"
  },
  {
    "codigo":276314008,
    "descripcion":"TOS INEFECTIVA"
  },
  {
    "codigo":866138009,
    "descripcion":"INFECCIÓN DE VAINA DE TENDÓN CAUSADA POR BACTERIA"
  },
  {
    "codigo":405551002,
    "descripcion":"TRAUMATISMO DE VÁLVULA MITRAL"
  },
  {
    "codigo":700463002,
    "descripcion":"TRASTORNO POR DEFICIENCIA DE ALFA-METILACIL-COA RACEMASA"
  },
  {
    "codigo":10929801000119104,
    "descripcion":"FRACTURA NO EXPUESTA DE CUARTO HUESO METATARSIANO DE PIE DERECHO"
  },
  {
    "codigo":733231006,
    "descripcion":"MÚLTIPLES LESIONES TRAUMÁTICAS DE BRAZO"
  },
  {
    "codigo":698628000,
    "descripcion":"ENFERMEDAD INFLAMATORIA PÉLVICA POSTERIOR A ABORTO"
  },
  {
    "codigo":895236003,
    "descripcion":"FORMA ANCHA ANORMAL CONGÉNITA DE FALANGE DE DEDO MEÑIQUE"
  },
  {
    "codigo":239876004,
    "descripcion":"ARTROSIS DE LA ARTICULACIÓN SUBASTRAGALINA"
  },
  {
    "codigo":16909961000119106,
    "descripcion":"LAGOFTALMOS CICATRIZAL DE PÁRPADO SUPERIOR E INFERIOR IZQUIERDO"
  },
  {
    "codigo":403716006,
    "descripcion":"LENTIGINOSIS POR FOTOQUIMIOTERAPIA POR MÉTODO PUVA"
  },
  {
    "codigo":762329003,
    "descripcion":"TRASTORNO DEL ESTADO DE ÁNIMO CON SÍNTOMAS DEPRESIVOS CAUSADO POR ESTIMULANTE"
  },
  {
    "codigo":205273005,
    "descripcion":"PULGAR INCLUIDO CONGÉNITO"
  },
  {
    "codigo":238041007,
    "descripcion":"HIPOLIPOPROTEINEMIA FAMILIAR"
  },
  {
    "codigo":72366004,
    "descripcion":"TRASTORNO DE LA CONDUCTA ALIMENTARIA"
  },
  {
    "codigo":1217411000,
    "descripcion":"DEFICIENCIA ADQUIRIDA DE COFACTOR II DE HEPARINA"
  },
  {
    "codigo":203438009,
    "descripcion":"OSTEOPOROSIS VERTEBRAL"
  },
  {
    "codigo":103299002,
    "descripcion":"VÉRTIGO SEVERO, INICIO AGUDO"
  },
  {
    "codigo":365443005,
    "descripcion":"ASPECTO DEL ESPUTO - HALLAZGO"
  },
  {
    "codigo":299907005,
    "descripcion":"SENSACIÓN DE FRÍO REDUCIDA"
  },
  {
    "codigo":70531008,
    "descripcion":"MOLESTIA VULVOVAGINAL"
  },
  {
    "codigo":724056005,
    "descripcion":"NEOPLASIA MALIGNA DE LÓBULO INFERIOR DE PULMÓN DERECHO"
  },
  {
    "codigo":35928006,
    "descripcion":"ANGINA DE PECHO NOCTURNA"
  },
  {
    "codigo":298072008,
    "descripcion":"CUERPO EXTRAÑO EN LA PIEL DE LA GARGANTA"
  },
  {
    "codigo":3160009,
    "descripcion":"INFERTILIDAD FEMENINA DE ORIGEN CERVICAL"
  },
  {
    "codigo":296237007,
    "descripcion":"SOBREDOSIS DE TIORIDAZINA"
  },
  {
    "codigo":230701008,
    "descripcion":"INFARTO LACUNAR SENSORIOMOTOR PURO"
  },
  {
    "codigo":1072931000119109,
    "descripcion":"RUPTURA PARCIAL NO TRAUMÁTICA DE MANGUITO ROTADOR DERECHO"
  },
  {
    "codigo":12105661000119103,
    "descripcion":"QUEMADURA DE PALMA DERECHA"
  },
  {
    "codigo":11804451000119109,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA DISTAL DE DEDO MEDIO IZQUIERDO"
  },
  {
    "codigo":390871002,
    "descripcion":"DISNEA CON EJERCICIO EXTENUANTE"
  },
  {
    "codigo":292567002,
    "descripcion":"REACCIÓN ADVERSA A ANTIHISTAMÍNICO H1"
  },
  {
    "codigo":718551002,
    "descripcion":"ENFERMEDAD DE MOYAMOYA CON ACALASIA DE COMIENZO TEMPRANO"
  },
  {
    "codigo":15955901000119104,
    "descripcion":"CARCINOMA MICROCÍTICO PRIMARIO DE PULMÓN DERECHO"
  },
  {
    "codigo":259799004,
    "descripcion":"NIVEL DE INMUNOGLOBULINAS TOTALES"
  },
  {
    "codigo":1144535007,
    "descripcion":"HIPOPLASIA CONGÉNITA DE AMBAS MAMAS"
  },
  {
    "codigo":126892001,
    "descripcion":"NEOPLASIA DE ORIFICIO URETERAL DE LA VEJIGA"
  },
  {
    "codigo":716716001,
    "descripcion":"DEFICIENCIA DE PROTEÍNA CINASA 70 ASOCIADA A LA CADENA ZETA"
  },
  {
    "codigo":94124002,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL CUELLO VESICAL"
  },
  {
    "codigo":290732006,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR CRISANTASPASA"
  },
  {
    "codigo":61356009,
    "descripcion":"INTOXICACIÓN CAUSADA POR FÁRMACO PARASIMPATICOMIMÉTICO"
  },
  {
    "codigo":92289001,
    "descripcion":"NEOPLASIA BENIGNA DEL PERICARDIO"
  },
  {
    "codigo":288897005,
    "descripcion":"CONTROLA EL BOLO ALIMENTARIO"
  },
  {
    "codigo":714881008,
    "descripcion":"INCAPAZ DE MANTENERSE EN CUCLILLAS"
  },
  {
    "codigo":57686001,
    "descripcion":"BULLA ENFISEMATOSA DEL PULMÓN"
  },
  {
    "codigo":876886003,
    "descripcion":"FALLECIDO EN EL LUGAR DE RESIDENCIA HABITUAL"
  },
  {
    "codigo":385366004,
    "descripcion":"ESTADIO DE LA FEDERACIÓN INTERNACIONAL DE GINECOLOGÍA Y OBSTETRICIA (FIGO) PARA TUMOR EPITELIAL DEL OVARIO - HALLAZGO"
  },
  {
    "codigo":287062005,
    "descripcion":"OSTEOCONDRITIS JUVENIL - PIERNA\/PIE"
  },
  {
    "codigo":418134006,
    "descripcion":"NEOPLASIA INTRAEPITELIAL CONJUNTIVAL"
  },
  {
    "codigo":285227006,
    "descripcion":"CAPAZ DE RECORDAR CARAS"
  },
  {
    "codigo":449067008,
    "descripcion":"NEOPLASIA MALIGNA DE PLEURA PARIETAL"
  },
  {
    "codigo":54016002,
    "descripcion":"BLOQUEO AURICULOVENTRICULAR INCOMPLETO DE MOBITZ TIPO I"
  },
  {
    "codigo":840448004,
    "descripcion":"HIGROMA QUÍSTICO FETAL CONCOMITANTE CON HIDROPESÍA"
  },
  {
    "codigo":447232008,
    "descripcion":"QUISTE EPENDIMARIO DE VENTRÍCULO CEREBRAL"
  },
  {
    "codigo":11833431000119107,
    "descripcion":"ESGUINCE DE LIGAMENTO INTERNO DE ARTICULACIÓN DE TOBILLO DERECHO"
  },
  {
    "codigo":707541006,
    "descripcion":"DIFICULTAD RESPIRATORIA AGUDA NEONATAL CON TRASTORNO DEL SURFACTANTE"
  },
  {
    "codigo":1295530007,
    "descripcion":"HIPERTENSIÓN OCULAR DE OJO DERECHO CAUSADA POR ACEITE DE SILICONA"
  },
  {
    "codigo":246954009,
    "descripcion":"HALLAZGO DEL ESTROMA CORNEAL"
  },
  {
    "codigo":212351002,
    "descripcion":"LESIÓN DE LOS NERVIOS PERIFÉRICOS DEL CUELLO"
  },
  {
    "codigo":441727001,
    "descripcion":"RUPTURA DE MEMBRANA AMNIÓTICA NO DETECTADA MEDIANTE PRUEBA CON AMARILLO DE NITRAZINA"
  },
  {
    "codigo":15743005,
    "descripcion":"OSTEOPOROSIS POSTRAUMÁTICA"
  },
  {
    "codigo":46676000,
    "descripcion":"PERICARDITIS SECUNDARIA A TUMOR PRIMARIO BENIGNO"
  },
  {
    "codigo":1193556001,
    "descripcion":"TRASTORNO FETAL Y\/O NEONATAL PRECOZ DURANTE LA SEGUNDA ETAPA DEL PERÍODO INTRAPARTO DEBIDO A PARTO CON FÓRCEPS"
  },
  {
    "codigo":112212006,
    "descripcion":"HERENCIA EXTRACROMOSÓMICA"
  },
  {
    "codigo":1259092009,
    "descripcion":"ATAXIA DEBIDA A SIDEROSIS SUBPIAL"
  },
  {
    "codigo":274217001,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR DETERGENTE"
  },
  {
    "codigo":15630731000119102,
    "descripcion":"TENDINITIS DE AMBAS MANOS"
  },
  {
    "codigo":77609009,
    "descripcion":"HERNIA ISQUIORRECTAL"
  },
  {
    "codigo":1255422003,
    "descripcion":"ASTA ANTERIOR DE MENISCO EXTERNO DE RODILLA DISCOIDE CONGÉNITO"
  },
  {
    "codigo":403454005,
    "descripcion":"GLOSITIS POR DEFICIENCIA DE HIERRO"
  },
  {
    "codigo":237779006,
    "descripcion":"HIPERPLASIA SUPRARRENAL MICRONODULAR"
  },
  {
    "codigo":235944000,
    "descripcion":"PANCREATITIS AGUDA FARMACÓGENA"
  },
  {
    "codigo":301480002,
    "descripcion":"INCAPAZ DE EVITAR OBSTÁCULOS EN UN CAMINO"
  },
  {
    "codigo":4733001,
    "descripcion":"ENFERMEDAD POR EL VIRUS ORUNGA"
  },
  {
    "codigo":397949005,
    "descripcion":"CRECIMIENTO FETAL DEFICIENTE AFECTA EL MANEJO"
  },
  {
    "codigo":365181006,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA LAVARSE"
  },
  {
    "codigo":234109007,
    "descripcion":"LINFOCELE"
  },
  {
    "codigo":363346000,
    "descripcion":"NEOPLASIA MALIGNA"
  },
  {
    "codigo":299645009,
    "descripcion":"AMPUTADO A NIVEL DEL CUARTO TRASERO"
  },
  {
    "codigo":68434003,
    "descripcion":"EXCITACIÓN CATATÓNICA"
  },
  {
    "codigo":35666006,
    "descripcion":"PANNUS CORNEAL"
  },
  {
    "codigo":232274006,
    "descripcion":"CAVIDAD MASTOIDEA SECRETANTE - PURULENTO"
  },
  {
    "codigo":263207000,
    "descripcion":"FRACTURA DIAFISARIA DE RADIO Y\/O CÚBITO"
  },
  {
    "codigo":164903001,
    "descripcion":"ELECTROCARDIOGRAMA: BLOQUEO AURICULOVENTRICULAR PARCIAL - 2:1"
  },
  {
    "codigo":197671004,
    "descripcion":"DISFUNCIÓN RENAL CON RETRASO DEL CRECIMIENTO"
  },
  {
    "codigo":230439004,
    "descripcion":"ESTADO ELÉCTRICO EPILÉPTICO DE SUEÑO DE ONDA LENTA"
  },
  {
    "codigo":295975006,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE GABAPENTINA"
  },
  {
    "codigo":64764001,
    "descripcion":"POLIOMIELITIS PARALÍTICA AGUDA, DE TIPO BULBAR"
  },
  {
    "codigo":294140002,
    "descripcion":"ALERGIA A ALIMEMAZINA"
  },
  {
    "codigo":31996006,
    "descripcion":"VASCULITIS"
  },
  {
    "codigo":367141000119107,
    "descripcion":"TRASTORNO ERÉCTIL MASCULINO DEBIDO A OCLUSIÓN CORPOROCAVERNOSA"
  },
  {
    "codigo":1144273005,
    "descripcion":"SIRENOMELIA FETAL"
  },
  {
    "codigo":128465005,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE CARTÍLAGO ARTICULAR"
  },
  {
    "codigo":292305006,
    "descripcion":"REACCIÓN ADVERSA A LA NEFAZODONA"
  },
  {
    "codigo":95697007,
    "descripcion":"DEGENERACIÓN RETINIANA GENERALIZADA"
  },
  {
    "codigo":340671000119102,
    "descripcion":"CICLITIS HETEROCRÓMICA DE FUCHS DE OJO IZQUIERDO"
  },
  {
    "codigo":716454002,
    "descripcion":"CAPAZ DE PENSAR CREATIVAMENTE"
  },
  {
    "codigo":61094002,
    "descripcion":"ENCEFALITIS DE LA CROSSE"
  },
  {
    "codigo":1177041009,
    "descripcion":"ENTEROCOLITIS TUBERCULOSA"
  },
  {
    "codigo":126630005,
    "descripcion":"NEOPLASIA DE MÚSCULO DEL PERINEO"
  },
  {
    "codigo":93862005,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA PARED LATERAL DE LA OROFARINGE"
  },
  {
    "codigo":190331003,
    "descripcion":"COMA HIPEROSMOLAR DEBIDO A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":288635003,
    "descripcion":"INCAPAZ DE ENTABLAR UNA CONVERSACIÓN"
  },
  {
    "codigo":92027006,
    "descripcion":"NEOPLASIA BENIGNA DE HUESO"
  },
  {
    "codigo":10662591000119105,
    "descripcion":"ÚLCERA DE REGIÓN MEDIA DE PIE DERECHO"
  },
  {
    "codigo":417872000,
    "descripcion":"INFECCIÓN INVASIVA POR VIRUS DE LA ENCEFALITIS DEL VALLE CACHE"
  },
  {
    "codigo":15987391000119105,
    "descripcion":"OPACIDAD CONGÉNITA DE CÓRNEA IZQUIERDA"
  },
  {
    "codigo":286800009,
    "descripcion":"CARÁCTER TRANQUILO"
  },
  {
    "codigo":284965003,
    "descripcion":"NO MANTIENE UN NIVEL DE HIGIENE PERSONAL"
  },
  {
    "codigo":15715161000119101,
    "descripcion":"HIPOPLASIA ADQUIRIDA DE AMBOS HUESOS CIGOMÁTICOS"
  },
  {
    "codigo":219429007,
    "descripcion":"HERIDA DE GUERRA POR GASES, HUMOS Y SUSTANCIAS QUÍMICAS"
  },
  {
    "codigo":53754001,
    "descripcion":"INTOXICACIÓN ACCIDENTAL AUTOPROVOCADA"
  },
  {
    "codigo":1004026008,
    "descripcion":"TRASTORNO FETAL DEBIDO A ENFERMEDAD DE VÍAS URINARIAS MATERNA"
  },
  {
    "codigo":283130009,
    "descripcion":"AMPOLLA TRAUMÁTICA GENITAL"
  },
  {
    "codigo":445135003,
    "descripcion":"ANGIOMATOSIS DE MENINGES"
  },
  {
    "codigo":1002191006,
    "descripcion":"NIVEL AUMENTADO DE AMINOÁCIDOS EN ORINA DEBIDO A FUNCIÓN RENAL DISMINUIDA"
  },
  {
    "codigo":248527007,
    "descripcion":"TUMORACIÓN ÚNICA"
  },
  {
    "codigo":838351006,
    "descripcion":"CONVULSIÓN AGUDA DEBIDA A INFECCIÓN DEL SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":212089000,
    "descripcion":"QUEMADURA QUE COMPROMETE 60-69 PORCIENTO DE LA SUPERFICIE DEL CUERPO, CON QUEMADURA DE ESPESOR COMPLETO QUE AFECTA 40-49 PORCIENTO DE LA SUPERFICIE CORPORAL"
  },
  {
    "codigo":82852009,
    "descripcion":"TRASTORNO HEREDITARIO LIGADO AL SEXO"
  },
  {
    "codigo":48249002,
    "descripcion":"ANISOCORIA CONGÉNITA"
  },
  {
    "codigo":1162361003,
    "descripcion":"OSTEOSARCOMA DE CARTÍLAGO ARTICULAR DE CLAVÍCULA"
  },
  {
    "codigo":277625002,
    "descripcion":"LINFOMA MALIGNO FOLICULAR - DE CÉLULAS PEQUEÑAS CLIVADAS"
  },
  {
    "codigo":11864921000119108,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DE RODILLA IZQUIERDA"
  },
  {
    "codigo":111950007,
    "descripcion":"FIEBRE FACTICIA"
  },
  {
    "codigo":159891000146105,
    "descripcion":"SIEMPRE SE SIENTE INSEGURO EN RELACIÓN AL CUIDADO DE UN NIÑO"
  },
  {
    "codigo":243022009,
    "descripcion":"LESIÓN POR FRAGMENTO DE BOMBA ANTIPERSONAL"
  },
  {
    "codigo":110115008,
    "descripcion":"LACERACIÓN SIMPLE CONTAMINADA DE LA ENCÍA ALVEOLAR DE LA MANDÍBULA"
  },
  {
    "codigo":403192003,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO"
  },
  {
    "codigo":343181000119100,
    "descripcion":"ENOFTALMOS TRAUMÁTICO BILATERAL"
  },
  {
    "codigo":1156856007,
    "descripcion":"OFTALMOPLEJÍA EXTERNA PROGRESIVA AUTOSÓMICA DOMINANTE TIPO 4"
  },
  {
    "codigo":237517001,
    "descripcion":"ATROFIA CONGÉNITA DE GLÁNDULA TIROIDES"
  },
  {
    "codigo":301218000,
    "descripcion":"LESIÓN DE CUERDA VOCAL"
  },
  {
    "codigo":170146005,
    "descripcion":"EXAMEN DEL NIÑO A LOS 2,5 AÑOS: ANORMAL - PARA OBSERVACIÓN"
  },
  {
    "codigo":235682005,
    "descripcion":"LACTOBEZOAR"
  },
  {
    "codigo":399522007,
    "descripcion":"NO SE PUEDEN VALORAR LOS GANGLIOS LINFÁTICOS REGIONALES"
  },
  {
    "codigo":299383000,
    "descripcion":"HALLAZGO RELACIONADO CON TEMPERATURA DE ARTICULACIÓN DE RODILLA"
  },
  {
    "codigo":202914007,
    "descripcion":"TENOSINOVITIS DE EXTENSOR DE LA MUÑECA"
  },
  {
    "codigo":1251490009,
    "descripcion":"METÁSTASIS DE CARCINOMA DE VESÍCULA BILIAR Y VÍA BILIAR EXTRAHEPÁTICA"
  },
  {
    "codigo":1080461000119104,
    "descripcion":"CARCINOMA DE CÉLULAS GRANDES PRIMARIO DE BRONQUIO PRINCIPAL IZQUIERDO"
  },
  {
    "codigo":364919006,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA PONERSE DE PIE Y SENTARSE EN FORMA ALTERNADA"
  },
  {
    "codigo":233847009,
    "descripcion":"RUPTURA CARDÍACA POSTERIOR A INFARTO AGUDO DE MIOCARDIO"
  },
  {
    "codigo":68172002,
    "descripcion":"TRASTORNO DE TENDÓN"
  },
  {
    "codigo":461388002,
    "descripcion":"ORIGEN ANÓMALO DE CONDUCTO ARTERIOSO EN CAYADO AÓRTICO DERECHO"
  },
  {
    "codigo":232012007,
    "descripcion":"DESPRENDIMIENTO COMBINADO DE RETINA, REGMATÓGENO Y POR TRACCIÓN"
  },
  {
    "codigo":721697000,
    "descripcion":"CARCINOMA NEUROENDOCRINO PRIMARIO DE COLON"
  },
  {
    "codigo":1149516009,
    "descripcion":"OBSTRUCCIÓN DEL ORIFICIO URETERAL"
  },
  {
    "codigo":16235661000119107,
    "descripcion":"ECTROPIÓN SENIL DE AMBOS PÁRPADOS INFERIORES"
  },
  {
    "codigo":295713003,
    "descripcion":"SOBREDOSIS DE PENTOSTATINA"
  },
  {
    "codigo":262945004,
    "descripcion":"SECCIÓN DE ARTERIA TRASPLANTADA"
  },
  {
    "codigo":230177004,
    "descripcion":"ENCEFALITIS POR HERPES SIMIAE"
  },
  {
    "codigo":801006,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN LA REGIÓN DEL PIE, CON INFECCIÓN"
  },
  {
    "codigo":228342000,
    "descripcion":"INCAPAZ DE CONTROLAR LA BEBIDA UNA VEZ QUE EMPEZÓ"
  },
  {
    "codigo":293878005,
    "descripcion":"ALERGIA A PARALDEHÍDO"
  },
  {
    "codigo":62667002,
    "descripcion":"DESVIACIÓN CONGÉNITA DEL TABIQUE NASAL"
  },
  {
    "codigo":128203003,
    "descripcion":"NEUROPATÍA SENSITIVA Y MOTORA HEREDITARIA CON ATROFIA ÓPTICA"
  },
  {
    "codigo":29899005,
    "descripcion":"EMBOLIA DE ARTERIA CORONARIA"
  },
  {
    "codigo":423115005,
    "descripcion":"NO BUSCA ATENCIÓN PREVENTIVA DE LA SALUD"
  },
  {
    "codigo":95435007,
    "descripcion":"FÍSTULA TRAQUEOESOFÁGICA"
  },
  {
    "codigo":160971008,
    "descripcion":"ESQUIADOR"
  },
  {
    "codigo":290208000,
    "descripcion":"INTOXICACIÓN POR FENOPERIDINA"
  },
  {
    "codigo":93600002,
    "descripcion":"OSIFICACIÓN INCOMPLETA DEL RADIO"
  },
  {
    "codigo":58997001,
    "descripcion":"APENDICITIS CRÓNICA"
  },
  {
    "codigo":716192009,
    "descripcion":"SÍNDROME DE BAJA ESTATURA Y SORDERA CON DISFUNCIÓN DE NEUTRÓFILOS Y DISMORFISMO FACIAL"
  },
  {
    "codigo":124533003,
    "descripcion":"DEFICIENCIA DE ACILFOSFATASA"
  },
  {
    "codigo":288373006,
    "descripcion":"DIFICULTAD PARA PASAR OBJETOS DE UNA MANO A OTRA"
  },
  {
    "codigo":419445007,
    "descripcion":"SÍNDROME DE DISTENSIÓN DE SACO CAPSULAR"
  },
  {
    "codigo":253770002,
    "descripcion":"ESTENOSIS CONGÉNITA DE APÉNDICE ILEOCECAL"
  },
  {
    "codigo":286538003,
    "descripcion":"CAPAZ DE GUARDAR LOS ALIMENTOS HIGIÉNICAMENTE"
  },
  {
    "codigo":450378005,
    "descripcion":"HEMORRAGIA EN ESPACIO EXTRADURAL DEL NEUROEJE"
  },
  {
    "codigo":188234005,
    "descripcion":"NEOPLASIA MALIGNA DE VESÍCULA SEMINAL"
  },
  {
    "codigo":284703000,
    "descripcion":"ARRANCARSE LA CARNE"
  },
  {
    "codigo":251935001,
    "descripcion":"VELOCIDAD DE FLUJO ESPIRATORIO PICO PREVISTO MAYOR AL 80%"
  },
  {
    "codigo":1234975009,
    "descripcion":"TRASTORNO NEONATAL DEBIDO A CIRCULAR DE CORDÓN UMBILICAL ALREDEDOR DE CUELLO"
  },
  {
    "codigo":282868001,
    "descripcion":"DIFICULTAD PARA ADAPTARSE A UNA POSICIÓN"
  },
  {
    "codigo":86260003,
    "descripcion":"DOLOR ALREDEDOR EL OJO"
  },
  {
    "codigo":413940003,
    "descripcion":"CISTOCELE CON PROLAPSO UTERINO DE TERCER GRADO"
  },
  {
    "codigo":281033004,
    "descripcion":"VISTO POR AGENTE SANITARIO"
  },
  {
    "codigo":1264073006,
    "descripcion":"TRASTORNO NEONATAL CAUSADO POR AGENTE ALUCINÓGENO TRANSMITIDO POR LECHE MATERNA"
  },
  {
    "codigo":1296841008,
    "descripcion":"HIPERTENSIÓN OCULAR BILATERAL DEBIDA A ANOMALÍA DE SEGMENTO ANTERIOR"
  },
  {
    "codigo":49822004,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN SACROILÍACA"
  },
  {
    "codigo":1082971000119103,
    "descripcion":"OTITIS EXTERNA NO INFECCIOSA AGUDA DE AMBOS CONDUCTOS AUDITIVOS EXTERNOS"
  },
  {
    "codigo":703347005,
    "descripcion":"REQUIERE VACUNACIÓN ANTISARAMPIONOSA, ANTIPAROTIDÍTICA Y ANTIRRUBEÓLICA"
  },
  {
    "codigo":13384007,
    "descripcion":"ABORTO ESPONTÁNEO COMPLICADO POR TRASTORNO METABÓLICO"
  },
  {
    "codigo":46152009,
    "descripcion":"INSUFICIENCIA DE LA PELÍCULA LAGRIMAL"
  },
  {
    "codigo":78920009,
    "descripcion":"ENVENENAMIENTO DEBIDO A MORDEDURA DE LAGARTO"
  },
  {
    "codigo":765213003,
    "descripcion":"TRASTORNO EN REMISIÓN PARCIAL ESPONTÁNEA"
  },
  {
    "codigo":109853004,
    "descripcion":"MESOTELIOMA DEL PERITONEO"
  },
  {
    "codigo":373832009,
    "descripcion":"MOTIVO PARA UN CAMBIO EN LA QUIMIOTERAPIA PLANIFICADA"
  },
  {
    "codigo":208157006,
    "descripcion":"FRACTURA EXPUESTA DE ACETÁBULO, COLUMNA ANTERIOR"
  },
  {
    "codigo":271858001,
    "descripcion":"DOLOR ABDOMINAL AGUDO RECURRENTE"
  },
  {
    "codigo":402930002,
    "descripcion":"PARONIQUIA BACTERIANA AGUDA"
  },
  {
    "codigo":371997009,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA ENCÍA INFERIOR"
  },
  {
    "codigo":1287666003,
    "descripcion":"TUMOR NEUROENDOCRINO BIEN DIFERENCIADO PRIMARIO DE RECTO"
  },
  {
    "codigo":75250006,
    "descripcion":"QUISTE DEL CUERPO BLANCO DEL OVARIO"
  },
  {
    "codigo":1254898009,
    "descripcion":"DERMATITIS POR CONTACTO CON PROTEÍNA OCUPACIONAL"
  },
  {
    "codigo":73415002,
    "descripcion":"PÉRDIDA DE LA AUDICIÓN INDUCIDA POR RUIDO"
  },
  {
    "codigo":1187527003,
    "descripcion":"DEFICIENCIA DE PEX13"
  },
  {
    "codigo":300956001,
    "descripcion":"DISTENSIÓN LUMBAR"
  },
  {
    "codigo":366492005,
    "descripcion":"HALLAZGO RELACIONADO CON LA AMPLITUD DE MOVIMIENTO DE CIRCUNDUCCIÓN DE HOMBRO"
  },
  {
    "codigo":169884005,
    "descripcion":"PERÍMETRO CEFÁLICO AL NACER: > PERCENTILO 97"
  },
  {
    "codigo":725105006,
    "descripcion":"TRASTORNO HEMORRÁGICO DEBIDO A DEFICIENCIA DE CALCIO Y FACTOR I DE INTERCAMBIO DE NUCLEÓTIDOS DE GUANINA REGULADO POR DIACILGLICEROL"
  },
  {
    "codigo":299121006,
    "descripcion":"ARTICULACIÓN DE DEDO DE LA MANO FRÍA AL TACTO"
  },
  {
    "codigo":428358000,
    "descripcion":"INESTABILIDAD DE MÚLTIPLES ARTICULACIONES"
  },
  {
    "codigo":102513008,
    "descripcion":"ADULTO DE SEXO MASCULINO SANO"
  },
  {
    "codigo":297286001,
    "descripcion":"INSUFICIENCIA TRICUSPÍDEA PARAPROTÉSICA"
  },
  {
    "codigo":2374000,
    "descripcion":"BLOQUEO MONOFASCICULAR"
  },
  {
    "codigo":262683000,
    "descripcion":"LESIÓN POR EXPLOSIÓN DE ÓRGANOS INTERNOS"
  },
  {
    "codigo":1149254008,
    "descripcion":"DISRUPCIÓN TEMPORARIA EN LOS PROCESOS FAMILIARES"
  },
  {
    "codigo":721435000,
    "descripcion":"LESIÓN COMPLETA DE MÉDULA ESPINAL AL NIVEL DEL SEXTO SEGMENTO DORSAL"
  },
  {
    "codigo":292751000119104,
    "descripcion":"PARÁLISIS TARDÍA DEL NERVIO CUBITAL DERECHO"
  },
  {
    "codigo":539009,
    "descripcion":"ARGIROSIS CONJUNTIVAL"
  },
  {
    "codigo":129776001,
    "descripcion":"LOCALIZACIÓN EN HORA 5 EN LA MAMOGRAFÍA"
  },
  {
    "codigo":293616003,
    "descripcion":"ALERGIA A FENBUFÉN"
  },
  {
    "codigo":719600006,
    "descripcion":"SÍNDROME DE MICRODELECIÓN 1P21.3"
  },
  {
    "codigo":162544008,
    "descripcion":"COME EN RESTAURANTES"
  },
  {
    "codigo":717765001,
    "descripcion":"SÍNDROME DE MALFORMACIÓN CAPILAR DE LABIO INFERIOR, MALFORMACIÓN LINFÁTICA DE CARA Y CUELLO, ASIMETRÍA DE CARA Y EXTREMIDADES Y CRECIMIENTO EXCESIVO"
  },
  {
    "codigo":95173002,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE CONDUCTO DEFERENTE"
  },
  {
    "codigo":422853008,
    "descripcion":"LINFOMA DE ESPACIO RETROPERITONEAL"
  },
  {
    "codigo":816069008,
    "descripcion":"FIBROSIS GLOMERULAR"
  },
  {
    "codigo":60570001,
    "descripcion":"INFECCIÓN CAUSADA POR TRICHURIS TRICHIURA"
  },
  {
    "codigo":1141914003,
    "descripcion":"TIENE LICENCIA PARA ARMAS DE FUEGO"
  },
  {
    "codigo":224410000,
    "descripcion":"TRABAJA AFUERA PARTE DE LA SEMANA"
  },
  {
    "codigo":93338006,
    "descripcion":"POSICIÓN ANÓMALA CONGÉNITA DE CORNETE NASAL"
  },
  {
    "codigo":1303919004,
    "descripcion":"LIPOMA ESPINAL INTRAMEDULAR NO DISRÁFICO"
  },
  {
    "codigo":25967007,
    "descripcion":"HIPERTRICOSIS LANUGINOSA"
  },
  {
    "codigo":714095007,
    "descripcion":"CON ACTIVIDAD SEXUAL EN EL ÚLTIMO AÑO"
  },
  {
    "codigo":56900004,
    "descripcion":"INFARTO DE TROMPA DE FALOPIO"
  },
  {
    "codigo":286276005,
    "descripcion":"INCAPAZ DE ARTICULAR PALABRAS"
  },
  {
    "codigo":253508006,
    "descripcion":"AUSENCIA CONGÉNITA DE MÚSCULO PAPILAR DE VÁLVULA AURICULOVENTRICULAR IZQUIERDA"
  },
  {
    "codigo":187972006,
    "descripcion":"NEOPLASIA MALIGNA DE HUESO NAVICULAR DE PIE"
  },
  {
    "codigo":404115006,
    "descripcion":"MICOSIS FUNGOIDE AMPOLLAR"
  },
  {
    "codigo":186137002,
    "descripcion":"INFECCIÓN DEL TRACTO GASTROINTESTINAL POR PROTEUS MIRABILIS"
  },
  {
    "codigo":251673004,
    "descripcion":"DESACELERACIÓN CARDÍACA FETAL"
  },
  {
    "codigo":55065004,
    "descripcion":"INFECCIÓN CAUSADA POR GIGANTOCOTYLE"
  },
  {
    "codigo":536681000221102,
    "descripcion":"SOLICITUD DE CUD (CERTIFICADO UNICO DE DISCAPACIDAD)"
  },
  {
    "codigo":448281007,
    "descripcion":"ANOMALÍA DE VENA HEPÁTICA"
  },
  {
    "codigo":15749161000119108,
    "descripcion":"CONDROMALACIA DE RÓTULA DERECHA"
  },
  {
    "codigo":413678004,
    "descripcion":"NÓDULO DE BOHN"
  },
  {
    "codigo":315374006,
    "descripcion":"NACIDO EN AUSTRALIA"
  },
  {
    "codigo":1003502008,
    "descripcion":"FRACTURA TRAUMÁTICA DE HUESO"
  },
  {
    "codigo":248003003,
    "descripcion":"AGRESIÓN VERBAL"
  },
  {
    "codigo":321731000119104,
    "descripcion":"ARTRITIS DE CODO DERECHO CAUSADA POR STAPHYLOCOCCUS"
  },
  {
    "codigo":442776005,
    "descripcion":"HELICOBACTER PYLORI AISLADO EN LÍQUIDO GÁSTRICO POR CULTIVO ESPECÍFICO PARA ORGANISMO"
  },
  {
    "codigo":82328006,
    "descripcion":"AMPOLLA DE LA PARED ABDOMINAL, SIN INFECCIÓN"
  },
  {
    "codigo":211565002,
    "descripcion":"LESIÓN TRAUMÁTICA CERRADA POR APLASTAMIENTO EN REGIÓN DE CODO"
  },
  {
    "codigo":735853004,
    "descripcion":"LACERACIÓN DE ARTERIA POPLÍTEA"
  },
  {
    "codigo":734018003,
    "descripcion":"DISPLASIA ECTODÉRMICA TIPO TRICO-ODONTO-ONIQUIAL"
  },
  {
    "codigo":275266006,
    "descripcion":"METÁSTASIS A ÓRGANOS DIGESTIVOS"
  },
  {
    "codigo":240663001,
    "descripcion":"AMEBIASIS DE PENE"
  },
  {
    "codigo":207895002,
    "descripcion":"FRACTURA NO EXPUESTA DEL ATLAS, ARCO O APÓFISIS ARTICULAR EXCLUSIVAMENTE"
  },
  {
    "codigo":404503003,
    "descripcion":"HALLAZGO RELACIONADO CON CANDIDA NO-ALBICANS"
  },
  {
    "codigo":764951002,
    "descripcion":"CARCINOSARCOMA DE CUELLO UTERINO"
  },
  {
    "codigo":1156332000,
    "descripcion":"AUTOEFICACIA"
  },
  {
    "codigo":402668003,
    "descripcion":"DERMATOSIS POR INSUFICIENCIA DE PEQUEÑOS VASOS"
  },
  {
    "codigo":1087991000119100,
    "descripcion":"OTITIS EXTERNA AGUDA DE CONDUCTO AUDITIVO EXTERNO IZQUIERDO CAUSADA POR SUSTANCIA QUÍMICA"
  },
  {
    "codigo":40385000,
    "descripcion":"SECRECIÓN PANCREÁTICA NORMAL"
  },
  {
    "codigo":271596009,
    "descripcion":"SUFRIMIENTO PSICOLÓGICO"
  },
  {
    "codigo":238828009,
    "descripcion":"ANETODERMIA"
  },
  {
    "codigo":300694003,
    "descripcion":"CAPAZ DE USAR UNA CUENTA FINANCIERA"
  },
  {
    "codigo":36715001,
    "descripcion":"ERITEMA POLIMORFO"
  },
  {
    "codigo":724843002,
    "descripcion":"PRURITO CAUSADO POR FÁRMACO"
  },
  {
    "codigo":167787003,
    "descripcion":"MOVILIDAD DE LOS ESPERMATOZOIDES A LAS 6-8 HORAS, BAJA: 10-30%"
  },
  {
    "codigo":3947004,
    "descripcion":"POLICITEMIA CON HEMOGLOBINA DE ALTA AFINIDAD POR OXÍGENO"
  },
  {
    "codigo":678391000119104,
    "descripcion":"RUPTURA DE ESFÍNTER DE PUPILA DE OJO DERECHO"
  },
  {
    "codigo":266091007,
    "descripcion":"GANGRENA GASEOSA OCASIONADA POR CLOSTRIDIUM HISTOLYTICUM"
  },
  {
    "codigo":298859008,
    "descripcion":"CREPITACIÓN DE ARTICULACIÓN DE HOMBRO"
  },
  {
    "codigo":196885001,
    "descripcion":"HERNIA EPIGÁSTRICA OBSTRUIDA"
  },
  {
    "codigo":14070001000004105,
    "descripcion":"SÍNDROME DE ARLEQUÍN"
  },
  {
    "codigo":231488009,
    "descripcion":"DOLOR ALUCINATORIO"
  },
  {
    "codigo":295189002,
    "descripcion":"SOBREDOSIS DE ALFENTANILO"
  },
  {
    "codigo":721173005,
    "descripcion":"SÍNDROME DE CISTINURIA-HIPOTONÍA"
  },
  {
    "codigo":29110001000004106,
    "descripcion":"FRACTURA DE PEDÍCULO DE CUARTA VÉRTEBRA CERVICAL"
  },
  {
    "codigo":15725201000119103,
    "descripcion":"DERRAME ARTICULAR DE AMBOS HOMBROS"
  },
  {
    "codigo":293354007,
    "descripcion":"REACCIÓN ADVERSA AL HIERRO"
  },
  {
    "codigo":29375001,
    "descripcion":"CANTIDAD ANORMAL DE VALVAS"
  },
  {
    "codigo":94911003,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE HUESO LARGO DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":289684001,
    "descripcion":"ALTURA DEL FONDO UTERINO APROPIADA PARA LA EDAD GESTACIONAL"
  },
  {
    "codigo":291519009,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR VANCOMICINA"
  },
  {
    "codigo":420756003,
    "descripcion":"CATARATA DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":1141652004,
    "descripcion":"DEMUESTRA CONOCIMIENTO SOBRE SERVICIOS COMUNITARIOS"
  },
  {
    "codigo":93076005,
    "descripcion":"HIPERTROFIA CONGÉNITA DE VÁLVULA TRICÚSPIDE"
  },
  {
    "codigo":224148001,
    "descripcion":"VIVE EN UNA COMUNIDAD ESCOLAR"
  },
  {
    "codigo":27540008,
    "descripcion":"SIGNO DE LASÈGUE"
  },
  {
    "codigo":715668008,
    "descripcion":"DEFICIENCIA HIPOFISARIA DEBIDA A SÍNDROME DE LA SILLA TURCA VACÍA"
  },
  {
    "codigo":124009004,
    "descripcion":"PENTOSA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1172585006,
    "descripcion":"ENFERMEDAD DE CHARCOT-MARIE-TOOTH AUTOSÓMICA DOMINANTE TIPO 2 ASOCIADA AL GEN MME"
  },
  {
    "codigo":255081007,
    "descripcion":"CARCINOMA DE CIEGO"
  },
  {
    "codigo":1269054005,
    "descripcion":"LESIONES MÚLTIPLES DE VASO SANGUÍNEO DE ABDOMEN"
  },
  {
    "codigo":22035000,
    "descripcion":"INFARTO DE LA PRÓSTATA"
  },
  {
    "codigo":218643003,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR FENOSUXIMIDA"
  },
  {
    "codigo":263176000,
    "descripcion":"FRACTURA DE MANDÍBULA DESDENTADA"
  },
  {
    "codigo":46071000087100,
    "descripcion":"ESGUINCE DE LIGAMENTO ISQUIOFEMORAL IZQUIERDO"
  },
  {
    "codigo":415251008,
    "descripcion":"HERNIA RECURRENTE DE PARED ABDOMINAL ANTERIOR"
  },
  {
    "codigo":38391000087104,
    "descripcion":"HIPOCINESIA DE SEGMENTO INFEROSEPTAL MEDIO DE VENTRÍCULO CARDÍACO IZQUIERDO"
  },
  {
    "codigo":43511000087107,
    "descripcion":"DESGARRO DE MENISCO EXTERNO DE ARTICULACIÓN DE RODILLA DERECHA"
  },
  {
    "codigo":40951000087107,
    "descripcion":"QUEMADURA DE PABELLÓN AURICULAR IZQUIERDO"
  },
  {
    "codigo":1263549001,
    "descripcion":"HIPERTENSIÓN INTRACRANEAL BENIGNA DEBIDA A ANEMIA"
  },
  {
    "codigo":249576009,
    "descripcion":"BAZO PALPABLE AL INSPIRAR"
  },
  {
    "codigo":83901003,
    "descripcion":"SÍNDROME DE SJÖGREN"
  },
  {
    "codigo":870333003,
    "descripcion":"PANUVEÍTIS CAUSADA POR MYCOBACTERIUM TUBERCULOSIS"
  },
  {
    "codigo":216808009,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR NUTRIENTE PARA PLANTAS"
  },
  {
    "codigo":51133006,
    "descripcion":"ESQUIZOFRENIA RESIDUAL EN REMISIÓN"
  },
  {
    "codigo":116669003,
    "descripcion":"FACODONESIS"
  },
  {
    "codigo":49298003,
    "descripcion":"ABSCESO DEL TRONCO"
  },
  {
    "codigo":704658004,
    "descripcion":"NIÑO CON MAYOR RIESGO DE SER VÍCTIMA DE NEGLIGENCIA"
  },
  {
    "codigo":278674004,
    "descripcion":"ANGULACIÓN DE DIENTE CANINO - DISTAL"
  },
  {
    "codigo":213138009,
    "descripcion":"REACCIÓN INFECCIOSA E INFLAMATORIA DEBIDA A DISPOSITIVO PROTÉSICO, IMPLANTE E INJERTO EN TRACTO GENITAL"
  },
  {
    "codigo":735591005,
    "descripcion":"APENDICITIS FLEMONOSA AGUDA"
  },
  {
    "codigo":1259879005,
    "descripcion":"NÓDULO DE TESTÍCULO"
  },
  {
    "codigo":473447008,
    "descripcion":"EJERCE PRESIÓN PARENTAL INAPROPIADA"
  },
  {
    "codigo":78396000,
    "descripcion":"LUXACIÓN EXPUESTA DE LA SÉPTIMA VÉRTEBRA CERVICAL"
  },
  {
    "codigo":307772002,
    "descripcion":"ÚLCERA AFTOSA ORAL MENOR"
  },
  {
    "codigo":1290841000000104,
    "descripcion":"SEPSIS CAUSADA POR VIRUS DE VIRUELA DE MONO"
  },
  {
    "codigo":109329003,
    "descripcion":"ABSCESO DE HUESO MALAR"
  },
  {
    "codigo":1075801000000108,
    "descripcion":"INCAPAZ DE COMPRAR EN SUPERMERCADO"
  },
  {
    "codigo":830225005,
    "descripcion":"CON MAYOR RIESGO DE ESTRÉS"
  },
  {
    "codigo":240401005,
    "descripcion":"LEPRA TUBERCULOIDE TIPO NEURAL"
  },
  {
    "codigo":404241006,
    "descripcion":"MENINGITIS CAUSADA POR VIRUS SNOWSHOE HARE"
  },
  {
    "codigo":238566001,
    "descripcion":"DERMATITIS SEBORREICA DE LOS PLIEGUES"
  },
  {
    "codigo":369638001,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA DE URÉTER DISTAL, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":205798005,
    "descripcion":"CICLOPÍA"
  },
  {
    "codigo":41958008,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN LA REGIÓN DEL DORSO, CON INFECCIÓN"
  },
  {
    "codigo":1156070008,
    "descripcion":"HEMANGIOMA INFANTIL SUPERFICIAL DE REGIÓN PERIORBITARIA"
  },
  {
    "codigo":105659005,
    "descripcion":"ENFERMEDAD CAUSADA POR MYXOZOA"
  },
  {
    "codigo":236731007,
    "descripcion":"TRASTORNO DE PRÓTESIS DE PENE IMPLANTADA"
  },
  {
    "codigo":365968000,
    "descripcion":"HÁBITO DE BEBIDA - HALLAZGO"
  },
  {
    "codigo":267664003,
    "descripcion":"NISTAGMO Y OTROS MOVIMIENTOS IRREGULARES DEL OJO"
  },
  {
    "codigo":429669000,
    "descripcion":"ARTRITIS VIRAL DE RODILLA"
  },
  {
    "codigo":724581001,
    "descripcion":"NEOPLASIA OSTEÓGENA BENIGNA DE HUESO DE MAXILAR INFERIOR"
  },
  {
    "codigo":298597004,
    "descripcion":"COLUMNA LUMBAR INFLAMADA"
  },
  {
    "codigo":460602002,
    "descripcion":"DILATACIÓN DE VÁLVULA AURICULOVENTRICULAR DERECHA (MORFOLÓGICAMENTE NO TRICÚSPIDE) EN VENTRÍCULO CON DOBLE TRACTO DE ENTRADA"
  },
  {
    "codigo":1148730006,
    "descripcion":"INTOXICACIÓN CAUSADA POR DIGITALIS"
  },
  {
    "codigo":296762008,
    "descripcion":"SOBREDOSIS DE OXITETRACICLINA"
  },
  {
    "codigo":131087007,
    "descripcion":"NIVEL DE CORTICOSTERONA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":196623008,
    "descripcion":"EROSIONES ESOFÁGICAS"
  },
  {
    "codigo":162020001,
    "descripcion":"DIFICULTAD PARA MASTICAR"
  },
  {
    "codigo":194788005,
    "descripcion":"HIPERTENSIÓN ARTERIAL SECUNDARIA A ENDOCRINOPATÍA"
  },
  {
    "codigo":717241000,
    "descripcion":"FUNCIÓN SENSITIVA MEJORADA"
  },
  {
    "codigo":61881000,
    "descripcion":"SIGNO DE OSIANDER"
  },
  {
    "codigo":94649002,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL TRONCO"
  },
  {
    "codigo":715406003,
    "descripcion":"LISENCEFALIA AISLADA TIPO 1 SIN DEFECTO GENÉTICO CONOCIDO"
  },
  {
    "codigo":27278006,
    "descripcion":"EMPIEMA AGUDO DE SENO ESFENOIDAL"
  },
  {
    "codigo":92814006,
    "descripcion":"LEUCEMIA LINFOIDE CRÓNICA, ENFERMEDAD"
  },
  {
    "codigo":60046008,
    "descripcion":"DERRAME PLEURAL"
  },
  {
    "codigo":289422008,
    "descripcion":"FONTANELA POSTERIOR PALPABLE EN LA REGIÓN CENTRAL"
  },
  {
    "codigo":1303395002,
    "descripcion":"FRACTURA ÓSEA DE MUÑECA DERECHA"
  },
  {
    "codigo":90979004,
    "descripcion":"AMIGDALITIS CRÓNICA"
  },
  {
    "codigo":25443007,
    "descripcion":"ANEMIA SIDEROBLÁSTICA SENSIBLE A PIRIDOXINA LIGADA AL CROMOSOMA X"
  },
  {
    "codigo":713571008,
    "descripcion":"TRASTORNO DEL SISTEMA NERVIOSO CENTRAL CONCOMITANTE CON INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":254819008,
    "descripcion":"SÍNDROME DEL NEVO ATÍPICO"
  },
  {
    "codigo":1871000124103,
    "descripcion":"TRANSICIÓN DE LA ATENCIÓN AGUDA A ATENCIÓN DOMICILIARIA"
  },
  {
    "codigo":285752007,
    "descripcion":"LESIÓN VENOSA EN LAS EXTREMIDADES SUPERIORES"
  },
  {
    "codigo":416824008,
    "descripcion":"HEMANGIOMA CAVERNOSO"
  },
  {
    "codigo":447757002,
    "descripcion":"ANGIOSARCOMA DE MEJILLA"
  },
  {
    "codigo":1581000119101,
    "descripcion":"DEMENCIA DE TIPO ALZHEIMER CON TRASTORNO DEL COMPORTAMIENTO"
  },
  {
    "codigo":21773007,
    "descripcion":"FIBROADENOSIS PERIÓDICA DE LA MAMA"
  },
  {
    "codigo":118242002,
    "descripcion":"HALLAZGO POR PALPACIÓN"
  },
  {
    "codigo":183778002,
    "descripcion":"EN LISTA PARA ADMISIÓN EN NEUMONOLOGÍA"
  },
  {
    "codigo":282082002,
    "descripcion":"QUEMADURA DE DUODENO"
  },
  {
    "codigo":314850005,
    "descripcion":"ATENDIDO POR ENFERMERA DE TRIAJE"
  },
  {
    "codigo":445922006,
    "descripcion":"ADHERENCIA DE MEMBRANA PUPILAR"
  },
  {
    "codigo":216546009,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR AMITRIPTILINA"
  },
  {
    "codigo":1197751007,
    "descripcion":"LIPODISTROFIA PARCIAL FAMILIAR ASOCIADA A LIPASA E SENSIBLE A HORMONAS"
  },
  {
    "codigo":247479008,
    "descripcion":"ENFERMEDAD TELANGIECTÁSICA"
  },
  {
    "codigo":1163148001,
    "descripcion":"OTITIS MEDIA SUPURATIVA CRÓNICA CAUSADA POR ASPERGILLUS"
  },
  {
    "codigo":16268000,
    "descripcion":"AUSENCIA DE RUIDOS INTESTINALES"
  },
  {
    "codigo":49036005,
    "descripcion":"REFLEJO DE PARPADEO ACÚSTICO"
  },
  {
    "codigo":1259617000,
    "descripcion":"COREA DEBIDA A LESIÓN TRAUMÁTICA CRANEOENCEFÁLICA Y POSTERIOR A ELLA"
  },
  {
    "codigo":16467501000119107,
    "descripcion":"MELORREOSTOSIS DE COSTILLA IZQUIERDA"
  },
  {
    "codigo":79969004,
    "descripcion":"DEFORMIDAD EN VARO CONGÉNITA DEL DEDO GORDO"
  },
  {
    "codigo":702561005,
    "descripcion":"FRACTURA POR INSUFICIENCIA"
  },
  {
    "codigo":45366001,
    "descripcion":"DISFIBRINOGENEMIA HEREDITARIA"
  },
  {
    "codigo":438582003,
    "descripcion":"LESIÓN TRAUMÁTICA AGUDA DE LIGAMENTO CRUZADO ANTERIOR"
  },
  {
    "codigo":373046005,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM NEOAURUM"
  },
  {
    "codigo":209206007,
    "descripcion":"SUBLUXACIÓN EXPUESTA DEL CÓCCIX"
  },
  {
    "codigo":403979000,
    "descripcion":"SARCOMA DE KAPOSI ENDÉMICO"
  },
  {
    "codigo":698891000,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: BIRMANO"
  },
  {
    "codigo":1255947006,
    "descripcion":"VÍCTIMA DE ABUSO INSTITUCIONAL"
  },
  {
    "codigo":305675006,
    "descripcion":"ATENDIDO POR UN GENETISTA CLÍNICO"
  },
  {
    "codigo":860896000,
    "descripcion":"AMPOLLA EN LUGAR DE INFECCIÓN"
  },
  {
    "codigo":240139008,
    "descripcion":"CONDRÓLISIS DE CARTÍLAGO ARTICULAR"
  },
  {
    "codigo":762592003,
    "descripcion":"CEFALEA PRIMARIA CRÓNICA"
  },
  {
    "codigo":402144007,
    "descripcion":"DERMATOSIS CAUSADA POR INSECTA"
  },
  {
    "codigo":72629001,
    "descripcion":"OSTEOCONDROSIS JUVENIL DE LA SÍNFISIS DEL PUBIS"
  },
  {
    "codigo":7093002,
    "descripcion":"CÓLICO RENAL"
  },
  {
    "codigo":236469003,
    "descripcion":"SÍNDROME TIPO FANCONI"
  },
  {
    "codigo":269237003,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO SUPERFICIAL DE LA NARIZ"
  },
  {
    "codigo":5258001,
    "descripcion":"AUSENCIA DE REFLEJO NAUSEOSO"
  },
  {
    "codigo":300170002,
    "descripcion":"MARTILLO: NO VISTO"
  },
  {
    "codigo":70794004,
    "descripcion":"PSEUDOARTROSIS CONGÉNITA DE CLAVÍCULA"
  },
  {
    "codigo":12236641000119103,
    "descripcion":"NEURITIS BRAQUIAL DE MIEMBRO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":234634006,
    "descripcion":"SÍNDROME DEL CROMOSOMA 18 Y DEFICIENCIA DE ANTICUERPOS"
  },
  {
    "codigo":267402007,
    "descripcion":"HIPOFUNCIÓN TESTICULAR DEBIDA A DEFECTO EN LA SÍNTESIS HORMONAL ADRENOCORTICAL"
  },
  {
    "codigo":1217674007,
    "descripcion":"QUERATITIS NEUROTRÓFICA DIABÉTICA"
  },
  {
    "codigo":112481000119103,
    "descripcion":"RESTAURACIÓN DENTAL INSATISFACTORIA"
  },
  {
    "codigo":685921000119104,
    "descripcion":"LIPOSARCOMA PRIMARIO DE PARTES BLANDAS DE CUELLO"
  },
  {
    "codigo":298335005,
    "descripcion":"RESPUESTA MOTORA EXTENSORA LUEGO DE UNA ORDEN"
  },
  {
    "codigo":462175008,
    "descripcion":"INSUFICIENCIA CARDÍACA FETAL CON REDISTRIBUCIÓN DEL GASTO CARDÍACO"
  },
  {
    "codigo":296500000,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE SAL DE ORO"
  },
  {
    "codigo":1588003,
    "descripcion":"PUBERTAD PRECOZ HETEROSEXUAL"
  },
  {
    "codigo":1179401002,
    "descripcion":"HIPOTIROIDISMO CONGÉNITO DEBIDO A RESISTENCIA PERIFÉRICA A HORMONA TIROIDEA"
  },
  {
    "codigo":32521002,
    "descripcion":"INTOXICACIÓN POR TOXICODENDRON VERNIX"
  },
  {
    "codigo":63454000,
    "descripcion":"ESCLERITIS ANTERIOR"
  },
  {
    "codigo":784350004,
    "descripcion":"CRANEORRINIA"
  },
  {
    "codigo":290995002,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR CLORMEZANONA"
  },
  {
    "codigo":15713681000119100,
    "descripcion":"COXA VALGA BILATERAL ADQUIRIDA"
  },
  {
    "codigo":1078161000119101,
    "descripcion":"DEFORMIDAD EN VALGO CONGÉNITA DE PRIMER DEDO DE PIE DERECHO"
  },
  {
    "codigo":225459005,
    "descripcion":"EMOCIONALMENTE CÁLIDO"
  },
  {
    "codigo":369041000119103,
    "descripcion":"HEMATOMA NO TRAUMÁTICO DE CORDÓN ESPERMÁTICO"
  },
  {
    "codigo":15718801000119104,
    "descripcion":"ENTESOPATÍA DE DEDO DE MANO DERECHA"
  },
  {
    "codigo":322961000119104,
    "descripcion":"DEDO DE LA MANO EN GATILLO ADQUIRIDO, DEDO MEÑIQUE DERECHO"
  },
  {
    "codigo":15698321000119106,
    "descripcion":"OSTEÍTIS DE MITAD DERECHA DE PELVIS"
  },
  {
    "codigo":190856003,
    "descripcion":"TETANIA HIPOMAGNESÉMICA"
  },
  {
    "codigo":10760081000119108,
    "descripcion":"EMBOLIA PIÉMICA Y SÉPTICA EN EL MOMENTO DEL NACIMIENTO"
  },
  {
    "codigo":12209041000119109,
    "descripcion":"FRACTURA DE HUESO ADYACENTE A PRÓTESIS DE ARTICULACIÓN DE HOMBRO DERECHO"
  },
  {
    "codigo":12398481000119109,
    "descripcion":"TRASTORNO MENTAL CAUSADO POR PSICOESTIMULANTE"
  },
  {
    "codigo":289160005,
    "descripcion":"SED NORMAL"
  },
  {
    "codigo":401000119107,
    "descripcion":"ASMA CON OBSTRUCCIÓN IRREVERSIBLE DE LA VÍA AÉREA"
  },
  {
    "codigo":335761000119108,
    "descripcion":"PIGMENTACIÓN CONJUNTIVAL DE OJO DERECHO"
  },
  {
    "codigo":338321000119109,
    "descripcion":"PTERIGIÓN RECIDIVANTE DEL OJO IZQUIERDO"
  },
  {
    "codigo":95121000119108,
    "descripcion":"TRASTORNO DE MAMA POSPARTO"
  },
  {
    "codigo":11996561000119108,
    "descripcion":"DOLOR EN MUÑÓN DE AMPUTACIÓN DE EXTREMIDAD INFERIOR IZQUIERDA"
  },
  {
    "codigo":36241000119108,
    "descripcion":"ESGUINCE DE LIGAMENTO DE REGIÓN DE COLUMNA VERTEBRAL CERVICAL"
  },
  {
    "codigo":305301000119100,
    "descripcion":"CONTRACTURA DE MÚSCULO DE MANO IZQUIERDA"
  },
  {
    "codigo":418397007,
    "descripcion":"ALERGIA A LA CANELA"
  },
  {
    "codigo":15952021000119101,
    "descripcion":"TROMBOFLEBITIS DE VENA AXILAR DERECHA"
  },
  {
    "codigo":416562001,
    "descripcion":"DOLOR A LA PRESIÓN AXIAL"
  },
  {
    "codigo":1137458004,
    "descripcion":"SÍNDROME DE FÓRNIX GIGANTE"
  },
  {
    "codigo":21511000,
    "descripcion":"INTOXICACIÓN POR CROTOXIFOS"
  },
  {
    "codigo":1332231003,
    "descripcion":"INCONGRUENCIA DE GÉNERO EN LA INFANCIA"
  },
  {
    "codigo":185351004,
    "descripcion":"RAZÓN ADMINISTRATIVA PARA EL ENCUENTRO"
  },
  {
    "codigo":87047005,
    "descripcion":"QUISTE CONGÉNITO DE ESÓFAGO"
  },
  {
    "codigo":283655004,
    "descripcion":"HERIDA POR PINCHAZO DE CLAVO EN EL HOMBRO"
  },
  {
    "codigo":250887008,
    "descripcion":"HALLAZGO EN LA PRUEBA AUDITIVA"
  },
  {
    "codigo":249052006,
    "descripcion":"FETO GRANDE"
  },
  {
    "codigo":1363164006,
    "descripcion":"SINUSITIS MAXILAR DEBIDA A ENFERMEDAD ENDODÓNCICA"
  },
  {
    "codigo":609500009,
    "descripcion":"INTERRUPCIÓN INDUCIDA DE EMBARAZO COMPLICADA POR PERFORACIÓN DE VEJIGA URINARIA"
  },
  {
    "codigo":1197489003,
    "descripcion":"SÍNDROME DE QUILOMICRONEMIA FAMILIAR"
  },
  {
    "codigo":247217003,
    "descripcion":"PLIEGUE POR TRACCIÓN EN PAPILA ÓPTICA MIÓPICA"
  },
  {
    "codigo":278150003,
    "descripcion":"GRUPO SANGUÍNEO B RH(D) POSITIVO"
  },
  {
    "codigo":441990004,
    "descripcion":"TROMBOFILIA DEBIDA A HEMOGLOBINURIA PAROXÍSTICA NOCTURNA"
  },
  {
    "codigo":46939000,
    "descripcion":"ENFERMEDAD DE KESHAN"
  },
  {
    "codigo":16006009,
    "descripcion":"LESIÓN TRAUMÁTICA DEL NERVIO PERONEO PROFUNDO"
  },
  {
    "codigo":866139001,
    "descripcion":"INFECCIÓN DE VAINA DE TENDÓN CAUSADA POR HONGO"
  },
  {
    "codigo":210779003,
    "descripcion":"LESIÓN DE MÚLTIPLES VASOS SANGUÍNEOS A NIVEL DEL CUELLO"
  },
  {
    "codigo":11829551000119104,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DE DEDO PULGAR DERECHO"
  },
  {
    "codigo":1259355004,
    "descripcion":"CARCINOMA PRIMARIO DE CURVATURA MENOR DE ESTÓMAGO"
  },
  {
    "codigo":309083007,
    "descripcion":"ABSCESO DE DORSO"
  },
  {
    "codigo":276315009,
    "descripcion":"SENSACIÓN - COMO SI..."
  },
  {
    "codigo":733232004,
    "descripcion":"LACERACIÓN DE ANTEBRAZO CON CUERPO EXTRAÑO"
  },
  {
    "codigo":12336008,
    "descripcion":"DOLOR REFERIDO EN OÍDO"
  },
  {
    "codigo":405552009,
    "descripcion":"TRAUMATISMO DE VÁLVULA PULMONAR"
  },
  {
    "codigo":403717002,
    "descripcion":"PSEUDOPORFIRIA POR FOTOQUIMIOTERAPIA POR MÉTODO PUVA"
  },
  {
    "codigo":370949002,
    "descripcion":"CONTRACCIÓN DE LA CÁPSULA ANTERIOR"
  },
  {
    "codigo":10501004,
    "descripcion":"PROTEINOSIS ALVEOLAR PULMONAR"
  },
  {
    "codigo":895237007,
    "descripcion":"FORMA ANCHA ANORMAL CONGÉNITA DE FALANGE DISTAL DE DEDO DE MANO"
  },
  {
    "codigo":76037007,
    "descripcion":"CUELLO UTERINO RÍGIDO QUE AFECTA AL EMBARAZO"
  },
  {
    "codigo":239877008,
    "descripcion":"ARTROSIS DE PRIMERA ARTICULACIÓN METATARSOFALÁNGICA"
  },
  {
    "codigo":74202002,
    "descripcion":"ANTEVERSIÓN DEL ÚTERO"
  },
  {
    "codigo":8666004,
    "descripcion":"DIENTES SUPERNUMERARIOS"
  },
  {
    "codigo":762330008,
    "descripcion":"TRASTORNO DEL ESTADO DE O ÁNIMO CON SÍNTOMAS DEPRESIVOS Y MANÍACOS MIXTOS CAUSADO POR ESTIMULANTE"
  },
  {
    "codigo":400047006,
    "descripcion":"ENFERMEDAD VASCULAR PERIFÉRICA"
  },
  {
    "codigo":301743007,
    "descripcion":"CAPAZ DE REALIZAR ACTIVIDADES DE TECNOLOGÍA INFORMÁTICA"
  },
  {
    "codigo":299908000,
    "descripcion":"SENSACIÓN TÉRMICA NORMAL"
  },
  {
    "codigo":430980000,
    "descripcion":"ANAFILAXIA CAUSADA POR VENENO DE HIMENÓPTEROS"
  },
  {
    "codigo":4996001,
    "descripcion":"HIPOFOSFATEMIA"
  },
  {
    "codigo":170671007,
    "descripcion":"CAMBIO DE SÍNTOMA DEL TRACTO GASTROINTESTINAL"
  },
  {
    "codigo":365444004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CONSISTENCIA DEL ESPUTO"
  },
  {
    "codigo":103300005,
    "descripcion":"VÉRTIGO PRECEDIDO POR SENSACIÓN DE INESTABILIDAD"
  },
  {
    "codigo":334281000119106,
    "descripcion":"BLEFARITIS DE PÁRPADO INFERIOR DERECHO"
  },
  {
    "codigo":398212009,
    "descripcion":"MATERIA FECAL LÍQUIDA"
  },
  {
    "codigo":35929003,
    "descripcion":"SÍNDROME DE LA VAINA TENDINOSA DE BROWN"
  },
  {
    "codigo":298073003,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":230702001,
    "descripcion":"HEMIPARESIA ATÁXICA LACUNAR"
  },
  {
    "codigo":296238002,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE TIORIDAZINA"
  },
  {
    "codigo":11311561000119109,
    "descripcion":"FRACTURA PATOLÓGICA DE VÉRTEBRA CERVICAL EN SITIO DE NEOPLASIA"
  },
  {
    "codigo":427310006,
    "descripcion":"DOLOR IRRADIADO AL CUELLO"
  },
  {
    "codigo":63192007,
    "descripcion":"NIVEL DE ÁCIDO ÚRICO POR DEBAJO DE RANGO DE REFERENCIA"
  },
  {
    "codigo":1144536008,
    "descripcion":"HIPOPLASIA CONGÉNITA DE CENTRO VERTEBRAL"
  },
  {
    "codigo":718552009,
    "descripcion":"FISURA MEDIANA FAMILIAR DE LABIOS SUPERIOR E INFERIOR"
  },
  {
    "codigo":94125001,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL APARATO URINARIO"
  },
  {
    "codigo":290733001,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR CRISANTASPASA"
  },
  {
    "codigo":1306541002,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE PROLONGACIÓN AXILAR DE MAMA IZQUIERDA"
  },
  {
    "codigo":716717005,
    "descripcion":"RETINOPATÍA CAUSADA POR CANTAXANTINA"
  },
  {
    "codigo":126893006,
    "descripcion":"NEOPLASIA DEL URACO"
  },
  {
    "codigo":288898000,
    "descripcion":"NO CONTROLA EL BOLO ALIMENTICIO"
  },
  {
    "codigo":714882001,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA PASAR DE UNA UBICACIÓN A OTRA"
  },
  {
    "codigo":92290005,
    "descripcion":"NEOPLASIA BENIGNA DEL TEJIDO PERIRRENAL"
  },
  {
    "codigo":285228001,
    "descripcion":"INCAPACIDAD DE RECORDAR CARAS"
  },
  {
    "codigo":10658711000119100,
    "descripcion":"ÚLCERA NEUROPÁTICA DE PIE MEDIO IZQUIERDO"
  },
  {
    "codigo":55852007,
    "descripcion":"FOCOMELIA COMPLETA DE MIEMBRO INFERIOR"
  },
  {
    "codigo":283393000,
    "descripcion":"LACERACIÓN DEL DORSO DEL PIE"
  },
  {
    "codigo":86785008,
    "descripcion":"BIGAMIA"
  },
  {
    "codigo":248790001,
    "descripcion":"FRACASO DEL ORGASMO"
  },
  {
    "codigo":707542004,
    "descripcion":"MANIFESTACIÓN OTORRINOLARINGOLÓGICA CONCOMITANTE CON FIBROSIS QUÍSTICA CLÁSICA Y DEBIDA A ELLA"
  },
  {
    "codigo":52182008,
    "descripcion":"TRASTORNO DEL DUODENO"
  },
  {
    "codigo":445398008,
    "descripcion":"TOMOGRAFÍA COMPUTARIZADA DE CABEZA ANORMAL"
  },
  {
    "codigo":9111000119104,
    "descripcion":"PROBLEMA MUSCULOESQUELÉTICO EN EL EMBARAZO"
  },
  {
    "codigo":312491004,
    "descripcion":"COROIDITIS SERPIGINOSA"
  },
  {
    "codigo":246955005,
    "descripcion":"INFILTRACIÓN ESTROMAL INFLAMATORIA DE LA CÓRNEA"
  },
  {
    "codigo":1295531006,
    "descripcion":"HIPERTENSIÓN OCULAR DE OJO IZQUIERDO CAUSADA POR CORTICOIDES"
  },
  {
    "codigo":736640009,
    "descripcion":"HIDRONEFROSIS DEBIDA A CÁLCULO DE RIÑÓN Y URÉTER"
  },
  {
    "codigo":310321000119101,
    "descripcion":"ARTRITIS GOTOSA DE MUÑECA DERECHA"
  },
  {
    "codigo":1193557005,
    "descripcion":"TRASTORNO FETAL Y\/O NEONATAL PRECOZ DURANTE LA SEGUNDA ETAPA DEL PERÍODO INTRAPARTO DEBIDO A PARTO INSTRUMENTAL"
  },
  {
    "codigo":1290026000,
    "descripcion":"ASMA NO CONTROLADO"
  },
  {
    "codigo":46677009,
    "descripcion":"GRADO DE GLEASON: 3"
  },
  {
    "codigo":210517008,
    "descripcion":"SECCIÓN COMPLETA DE TENDÓN DE TRÍCEPS"
  },
  {
    "codigo":44842005,
    "descripcion":"ARREFLEXIA GENERAL"
  },
  {
    "codigo":10959921000119104,
    "descripcion":"HERIDA ABIERTA DE REGIÓN DE CODO IZQUIERDO"
  },
  {
    "codigo":403455006,
    "descripcion":"GRANULOMA ULCERATIVO TRAUMÁTICO DE LA LENGUA CON EOSINOFILIA ESTROMAL"
  },
  {
    "codigo":1255423008,
    "descripcion":"ASTA POSTERIOR DE MENISCO EXTERNO DE RODILLA DISCOIDE CONGÉNITO"
  },
  {
    "codigo":1222655009,
    "descripcion":"SÍNDROME DE ATROFIA ÓPTICA, ATAXIA, NEUROPATÍA PERIFÉRICA Y RETRASO GLOBAL DEL DESARROLLO"
  },
  {
    "codigo":41172003,
    "descripcion":"INTOXICACIÓN POR NOLINA TEXANA"
  },
  {
    "codigo":1351892007,
    "descripcion":"INMUNODEFICIENCIA COMBINADA DEBIDA A DEFICIENCIA DE CARD11"
  },
  {
    "codigo":203177001,
    "descripcion":"OSTEOMIELITIS AGUDA DE METATARSIANO"
  },
  {
    "codigo":301481003,
    "descripcion":"EVITA OBSTÁCULOS EN UN CAMINO"
  },
  {
    "codigo":235945004,
    "descripcion":"PANCREATITIS AGUDA DEBIDA A INFECCIÓN"
  },
  {
    "codigo":234110002,
    "descripcion":"QUISTE LINFÁTICO"
  },
  {
    "codigo":37502002,
    "descripcion":"RUPTURA DEL RECTO"
  },
  {
    "codigo":365182004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA DUCHARSE"
  },
  {
    "codigo":397950005,
    "descripcion":"PRESENCIA MÉDICA"
  },
  {
    "codigo":299646005,
    "descripcion":"AMPUTADO A NIVEL DE LA CADERA"
  },
  {
    "codigo":232275007,
    "descripcion":"CAVIDAD MASTOIDEA SECRETANTE - SECRECIÓN SANGUINOLENTA"
  },
  {
    "codigo":2899008,
    "descripcion":"BLOQUEO MENTAL"
  },
  {
    "codigo":428883008,
    "descripcion":"RUPTURA DE TENDÓN DEL BÍCEPS"
  },
  {
    "codigo":33832002,
    "descripcion":"TRASTORNO DE LA TERCERA DIVISIÓN DEL QUINTO PAR CRANEAL"
  },
  {
    "codigo":230440002,
    "descripcion":"EPILEPSIA SECUNDARIA DE LA LECTURA"
  },
  {
    "codigo":263208005,
    "descripcion":"FRACTURA DE EXTREMO DISTAL DE RADIO Y CÚBITO"
  },
  {
    "codigo":164904007,
    "descripcion":"ELECTROCARDIOGRAMA: BLOQUEO AURICULOVENTRICULAR PARCIAL - 3:1"
  },
  {
    "codigo":425213009,
    "descripcion":"CARCINOMA DE COLON, ESTADIO I"
  },
  {
    "codigo":1177042002,
    "descripcion":"ENCEFALITIS POR VIRUS TOSCANA"
  },
  {
    "codigo":128466006,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE CARTÍLAGO ARTICULAR"
  },
  {
    "codigo":292306007,
    "descripcion":"REACCIÓN ADVERSA AL CITALOPRAM"
  },
  {
    "codigo":93863000,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA PARED LATERAL DE LA VEJIGA"
  },
  {
    "codigo":716455001,
    "descripcion":"CAPAZ DE TOLERAR QUE LO ASEEN DESPUÉS DE IR AL BAÑO"
  },
  {
    "codigo":126631009,
    "descripcion":"NEOPLASIA DE LA CABEZA"
  },
  {
    "codigo":288636002,
    "descripcion":"ENTABLA UNA CONVERSACIÓN"
  },
  {
    "codigo":92028001,
    "descripcion":"NEOPLASIA BENIGNA DE LOS GANGLIOS LINFÁTICOS AXILARES LATERALES"
  },
  {
    "codigo":26492007,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DEL CUERO CABELLUDO, CON INFECCIÓN"
  },
  {
    "codigo":254033007,
    "descripcion":"DEFORMIDAD CONGÉNITA DE LA REGIÓN LUMBOSACRA"
  },
  {
    "codigo":286801008,
    "descripcion":"RASGO DE LA PERSONALIDAD: FLEXIBILIDAD - HALLAZGO"
  },
  {
    "codigo":284966002,
    "descripcion":"DIFICULTAD PARA MANTENER UN NIVEL DE HIGIENE PERSONAL"
  },
  {
    "codigo":219430002,
    "descripcion":"LESIÓN DE GUERRA CAUSADA POR GAS"
  },
  {
    "codigo":339301000119109,
    "descripcion":"MIOPÍA DE OJO IZQUIERDO"
  },
  {
    "codigo":55590009,
    "descripcion":"ÁNGULO NORMAL DE ERECCIÓN"
  },
  {
    "codigo":119291004,
    "descripcion":"TRASTORNO DEL TRACTO GASTROINTESTINAL SUPERIOR"
  },
  {
    "codigo":1004027004,
    "descripcion":"TRASTORNO NEONATAL DEBIDO A TRASTORNO URINARIO MATERNO"
  },
  {
    "codigo":20987006,
    "descripcion":"SÍNDROME DE MCKITTRICK - WHEELOCK"
  },
  {
    "codigo":283131008,
    "descripcion":"AMPOLLA TRAUMÁTICA SUPERFICIAL DE LA EXTREMIDAD INFERIOR"
  },
  {
    "codigo":248528002,
    "descripcion":"TUMORACIONES MÚLTIPLES"
  },
  {
    "codigo":51920004,
    "descripcion":"TRABAJO DE PARTO PRECIPITADO"
  },
  {
    "codigo":838352004,
    "descripcion":"ADENOCARCINOMA IN SITU DE ESÓFAGO"
  },
  {
    "codigo":1295269002,
    "descripcion":"XEROSIS DE CÓRNEA"
  },
  {
    "codigo":286361000119101,
    "descripcion":"CONEXIÓN VENOSA PULMONAR TOTALMENTE ANÓMALA A VENA CAVA SUPERIOR"
  },
  {
    "codigo":1196965006,
    "descripcion":"ENFERMEDAD GINGIVAL POR SARCOIDOSIS"
  },
  {
    "codigo":277626001,
    "descripcion":"LINFOMA B DE ALTO GRADO DIFUSO"
  },
  {
    "codigo":48250002,
    "descripcion":"SÍNDROME DE GAISBOCK"
  },
  {
    "codigo":1162362005,
    "descripcion":"SÍNDROME DE FELTY CON ARTRITIS REUMATOIDE EROSIVA SERONEGATIVA"
  },
  {
    "codigo":212090009,
    "descripcion":"QUEMADURA QUE COMPROMETE 60-69 PORCIENTO DE LA SUPERFICIE DEL CUERPO, CON QUEMADURA DE ESPESOR COMPLETO QUE AFECTA 50-59 PORCIENTO DE LA SUPERFICIE CORPORAL"
  },
  {
    "codigo":308559002,
    "descripcion":"SITUACIÓN DE REUNIÓN Y CONFERENCIA"
  },
  {
    "codigo":767311002,
    "descripcion":"DOBLE CAYADO AÓRTICO CON CAYADO DERECHO DOMINANTE E HIPOPLASIA DEL CAYADO IZQUIERDO"
  },
  {
    "codigo":243023004,
    "descripcion":"LESIÓN POR FRAGMENTO DE MISIL AUTOPROPULSADO"
  },
  {
    "codigo":1079091000119100,
    "descripcion":"CARCINOMA BASOCELULAR PRIMARIO DE MIEMBRO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":208420009,
    "descripcion":"FRACTURA EXPUESTA DE METACARPIANO DE PULGAR"
  },
  {
    "codigo":9977002,
    "descripcion":"AMPOLLA DE TOBILLO, CON INFECCIÓN"
  },
  {
    "codigo":1156857003,
    "descripcion":"OFTALMOPLEJÍA EXTERNA PROGRESIVA AUTOSÓMICA DOMINANTE TIPO 1"
  },
  {
    "codigo":110116009,
    "descripcion":"LACERACIÓN COMPLEJA DE LA ENCÍA ALVEOLAR DE LA MANDÍBULA"
  },
  {
    "codigo":368281000119108,
    "descripcion":"PRIAPISMO CAUSADO POR FÁRMACO"
  },
  {
    "codigo":403193008,
    "descripcion":"CICATRIZ DE QUEMADURA"
  },
  {
    "codigo":881637171000119102,
    "descripcion":"MASTITIS GRANULOMATOSA DE AMBAS MAMAS"
  },
  {
    "codigo":15687321000119109,
    "descripcion":"ARTRITIS REUMATOIDE DE AMBAS MANOS"
  },
  {
    "codigo":237518006,
    "descripcion":"BOCIO HIPOTIROIDEO, ADQUIRIDO"
  },
  {
    "codigo":204750006,
    "descripcion":"ROTACIÓN ANÓMALA DE COLON Y CIEGO"
  },
  {
    "codigo":235683000,
    "descripcion":"NECROSIS GÁSTRICA"
  },
  {
    "codigo":170147001,
    "descripcion":"EXAMEN DEL NIÑO A LOS 2.5 AÑOS: ANORMAL - DERIVADO"
  },
  {
    "codigo":71843006,
    "descripcion":"SIGNO DEL PRONADOR DE WILSON"
  },
  {
    "codigo":202915008,
    "descripcion":"TENOSINOVITIS DE EXTENSOR DE DEDO DE LA MANO"
  },
  {
    "codigo":301219008,
    "descripcion":"ÚLCERA DE CUERDA VOCAL"
  },
  {
    "codigo":364920000,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA LEVANTARSE DESDE POSICIÓN DE CUCLILLAS"
  },
  {
    "codigo":37240003,
    "descripcion":"AFRONTAMIENTO FAMILIAR INEFICAZ: COMPROMETIDO"
  },
  {
    "codigo":1251491008,
    "descripcion":"METÁSTASIS DE CARCINOMA DE LARINGE"
  },
  {
    "codigo":430456005,
    "descripcion":"TORSIÓN DE APÉNDICES DEL EPOÓFORO"
  },
  {
    "codigo":299384006,
    "descripcion":"ARTICULACIÓN DE LA RODILLA CALIENTE AL TACTO"
  },
  {
    "codigo":397688009,
    "descripcion":"HALLAZGO RELACIONADO CON LA PARTICIPACIÓN EN EL TRATAMIENTO"
  },
  {
    "codigo":232013002,
    "descripcion":"RETINOSQUISIS MACULAR"
  },
  {
    "codigo":461389005,
    "descripcion":"ORIGEN ANÓMALO DE CONDUCTO ARTERIOSO EN DIVERTÍCULO AÓRTICO"
  },
  {
    "codigo":426786003,
    "descripcion":"EL PACIENTE NO DEBE CONDUCIR NI OPERAR MAQUINARIA"
  },
  {
    "codigo":197410004,
    "descripcion":"ANGIOCOLECISTITIS AGUDA"
  },
  {
    "codigo":721698005,
    "descripcion":"NEOPLASIA NEUROENDOCRINA MALIGNA PRIMARIA DE COLON"
  },
  {
    "codigo":295714009,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE PENTOSTATINA"
  },
  {
    "codigo":228343005,
    "descripcion":"INCAPAZ DE CONTROLAR ATAQUES ESPONTÁNEOS DE BEBIDA"
  },
  {
    "codigo":64503007,
    "descripcion":"ESPUTO MUCOIDE"
  },
  {
    "codigo":719863008,
    "descripcion":"MOVILIDAD DE MEMBRANA TIMPÁNICA DISMINUIDA"
  },
  {
    "codigo":160972001,
    "descripcion":"PILOTO DE AVIONES MICROLIVIANOS"
  },
  {
    "codigo":95436008,
    "descripcion":"CONSOLIDACIÓN DE PULMÓN"
  },
  {
    "codigo":128204009,
    "descripcion":"NEUROPATÍA SENSITIVA Y MOTORA HEREDITARIA CON RETINITIS PIGMENTARIA"
  },
  {
    "codigo":292044008,
    "descripcion":"REACCIÓN ADVERSA A ASPIRINA"
  },
  {
    "codigo":93601003,
    "descripcion":"OSIFICACIÓN INCOMPLETA DE COSTILLA"
  },
  {
    "codigo":716193004,
    "descripcion":"SÍNDROME DE BAJA ESTATURA CON VALVULOPATÍA CARDÍACA Y FACIES CARACTERÍSTICA"
  },
  {
    "codigo":28065000,
    "descripcion":"SECUESTRO BRONCOPULMONAR INTRALOBULAR"
  },
  {
    "codigo":290209008,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR FENOPERIDINA"
  },
  {
    "codigo":124534009,
    "descripcion":"DEFICIENCIA DE ATP PIROFOSFATASA"
  },
  {
    "codigo":450379002,
    "descripcion":"HEMORRAGIA EN ESPACIO EXTRADURAL DE COLUMNA VERTEBRAL"
  },
  {
    "codigo":417611003,
    "descripcion":"ONICOMICOSIS CAUSADA POR NEOCUCURBITARIA UNGUIS-HOMINIS"
  },
  {
    "codigo":253771003,
    "descripcion":"MALFORMACIÓN ANORRECTAL ALTA"
  },
  {
    "codigo":16017511000119104,
    "descripcion":"ALTERACIÓN DE ASTA POSTERIOR DE MENISCO EXTERNO DE AMBAS RODILLAS"
  },
  {
    "codigo":188235006,
    "descripcion":"NEOPLASIA MALIGNA DE TÚNICA VAGINAL"
  },
  {
    "codigo":286539006,
    "descripcion":"INCAPAZ DE GUARDAR LOS ALIMENTOS HIGIÉNICAMENTE"
  },
  {
    "codigo":1234976005,
    "descripcion":"TRASTORNO FETAL DEBIDO A VÁRICES DE CORDÓN UMBILICAL"
  },
  {
    "codigo":344321000119100,
    "descripcion":"QUISTE PRIMARIO DE ANILLO CILIAR DE AMBOS OJOS"
  },
  {
    "codigo":20725005,
    "descripcion":"NEUROPATÍA VISCERAL FAMILIAR"
  },
  {
    "codigo":1264074000,
    "descripcion":"TRASTORNO FETAL CAUSADO POR TRANSFERENCIA PLACENTARIA DE OPIÁCEOS"
  },
  {
    "codigo":1296842001,
    "descripcion":"CRISIS GLAUCOMATOCICLÍTICA DE OJO IZQUIERDO"
  },
  {
    "codigo":770719004,
    "descripcion":"SÍNDROME DE MICRODELECIÓN 3Q27.3"
  },
  {
    "codigo":208051009,
    "descripcion":"FRACTURA VERTEBRAL EXPUESTA CON LESIÓN POSTERIOR DE MÉDULA ESPINAL DORSAL, D7-12"
  },
  {
    "codigo":49823009,
    "descripcion":"OFTALMOPLEJÍA INTERNUCLEAR"
  },
  {
    "codigo":47988006,
    "descripcion":"COMPLICACIÓN DEBIDA A INMUNIZACIÓN"
  },
  {
    "codigo":80756009,
    "descripcion":"FRACTURA NO EXPUESTA DE RÓTULA"
  },
  {
    "codigo":111689003,
    "descripcion":"HERIDA DE LOS ANEXOS OCULARES"
  },
  {
    "codigo":46153004,
    "descripcion":"ESTUPOR CATATÓNICO"
  },
  {
    "codigo":373833004,
    "descripcion":"CAMBIO EN LA QUIMIOTERAPIA - ENFERMEDAD PROGRESIVA DURANTE LA QUIMIOTERAPIA"
  },
  {
    "codigo":1081601000119108,
    "descripcion":"RETINOBLASTOMA PRIMARIO DERECHO"
  },
  {
    "codigo":78921008,
    "descripcion":"ALBINISMO OCULAR AUTOSÓMICO RECESIVO"
  },
  {
    "codigo":208158001,
    "descripcion":"FRACTURA EXPUESTA DE ACETÁBULO, COLUMNA POSTERIOR"
  },
  {
    "codigo":44318002,
    "descripcion":"POSTITIS"
  },
  {
    "codigo":371998004,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL TERCIO INFERIOR DEL ESÓFAGO"
  },
  {
    "codigo":109854005,
    "descripcion":"MESOTELIOMA DEL PERITONEO PARIETAL"
  },
  {
    "codigo":1254899001,
    "descripcion":"URTICARIA NO ALÉRGICA POR CONTACTO OCUPACIONAL"
  },
  {
    "codigo":239091003,
    "descripcion":"DERMATOSIS DE LA INFANCIA"
  },
  {
    "codigo":402931003,
    "descripcion":"PARONIQUIA BACTERIANA NEONATAL"
  },
  {
    "codigo":317851000119104,
    "descripcion":"ARTRITIS DE TOBILLO DERECHO CAUSADA POR STREPTOCOCCUS PNEUMONIAE"
  },
  {
    "codigo":1287667007,
    "descripcion":"TUMOR NEUROENDOCRINO BIEN DIFERENCIADO PRIMARIO DE INTESTINO DELGADO"
  },
  {
    "codigo":237256006,
    "descripcion":"TRASTORNO RELACIONADO CON EL TAMAÑO Y LA DESPROPORCIÓN DE LA PELVIS"
  },
  {
    "codigo":366493000,
    "descripcion":"HALLAZGO RELACIONADO CON LA AMPLITUD DE MOVIMIENTO ACTIVO DE CIRCUNDUCCIÓN DE HOMBRO"
  },
  {
    "codigo":1187528008,
    "descripcion":"DEFICIENCIA DE PEX14"
  },
  {
    "codigo":300957005,
    "descripcion":"DOLOR LUMBAR POSTURAL"
  },
  {
    "codigo":102514002,
    "descripcion":"ADULTO DE SEXO FEMENINO SANA"
  },
  {
    "codigo":4210003,
    "descripcion":"HIPERTENSIÓN OCULAR"
  },
  {
    "codigo":299122004,
    "descripcion":"ARTICULACIÓN DE DEDO DE LA MANO HELADA AL TACTO"
  },
  {
    "codigo":428359008,
    "descripcion":"NEURITIS DEL NERVIO ILIOINGUINAL"
  },
  {
    "codigo":1149255009,
    "descripcion":"ATENCIÓN POSNATAL BRINDADA POR CONSULTOR"
  },
  {
    "codigo":33308003,
    "descripcion":"TRASTORNO DE LA ESPALDA"
  },
  {
    "codigo":721436004,
    "descripcion":"LESIÓN COMPLETA DE MÉDULA ESPINAL AL NIVEL DEL SÉPTIMO SEGMENTO DORSAL"
  },
  {
    "codigo":15993551000119100,
    "descripcion":"TRASTORNO OCULAR CONCOMITANTE CON SÍNDROME DE MARFAN Y DEBIDO A ÉL"
  },
  {
    "codigo":31473001,
    "descripcion":"PRESIÓN DE ENCLAVAMIENTO VENOSA NORMAL"
  },
  {
    "codigo":195313002,
    "descripcion":"ESPASMO DE ARTERIA PERIFÉRICA"
  },
  {
    "codigo":295452009,
    "descripcion":"SOBREDOSIS DE LAXANTE DE VOLUMEN"
  },
  {
    "codigo":719601005,
    "descripcion":"HALLAZGO RADIOLÓGICO DE INVASIÓN NEOPLÁSICA EN TEJIDO ADYACENTE"
  },
  {
    "codigo":129777005,
    "descripcion":"LOCALIZACIÓN EN HORA 6 EN LA MAMOGRAFÍA"
  },
  {
    "codigo":293617007,
    "descripcion":"ALERGIA A FENOPROFENO"
  },
  {
    "codigo":717766000,
    "descripcion":"SÍNDROME DE ALPORT AUTOSÓMICO DOMINANTE"
  },
  {
    "codigo":162545009,
    "descripcion":"COME EN UN CAFÉ O CANTINA"
  },
  {
    "codigo":16894671000119102,
    "descripcion":"DEFICIENCIA DE INMUNOGLOBULINA G DEBIDA A GAMMAPATÍA MONOCLONAL DE SIGNIFICACIÓN INDETERMINADA"
  },
  {
    "codigo":291782006,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR TIOURACILO"
  },
  {
    "codigo":95174008,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA SUPERFICIE VENTRAL DE LA LENGUA"
  },
  {
    "codigo":191643001,
    "descripcion":"TRASTORNO AFECTIVO BIPOLAR MIXTO, EN REMISIÓN TOTAL"
  },
  {
    "codigo":224411001,
    "descripcion":"TRABAJA AFUERA LA MAYOR PARTE DE LA SEMANA"
  },
  {
    "codigo":93339003,
    "descripcion":"POSICIÓN ANÓMALA CONGÉNITA DEL TABIQUE NASAL"
  },
  {
    "codigo":346831000119104,
    "descripcion":"DACRIOCISTITS CRÓNICA DE AMBOS SACOS LAGRIMALES"
  },
  {
    "codigo":27803006,
    "descripcion":"REACCIÓN PSICÓTICA DE QI - GONG"
  },
  {
    "codigo":421019006,
    "descripcion":"HIPOGONADISMO HIPOGONADOTRÓFICO POR DEFICIENCIA DE HORMONA FOLICULOESTIMULANTE"
  },
  {
    "codigo":124272003,
    "descripcion":"DEFICIENCIA DE URIDINA FOSFORILASA"
  },
  {
    "codigo":91504005,
    "descripcion":"TROMBOPOYESIS INEFICAZ"
  },
  {
    "codigo":714096008,
    "descripcion":"CON ACTIVIDAD SEXUAL EN EL ÚLTIMO MES"
  },
  {
    "codigo":286277001,
    "descripcion":"ARTICULA PALABRAS"
  },
  {
    "codigo":187973001,
    "descripcion":"NEOPLASIA MALIGNA DEL PRIMER METATARSIANO"
  },
  {
    "codigo":253509003,
    "descripcion":"FUSIÓN CONGÉNITA DE MÚSCULOS PAPILARES DE VÁLVULA AURICULOVENTRICULAR IZQUIERDA"
  },
  {
    "codigo":11789161000119101,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO DE DEDO DE MANO IZQUIERDA"
  },
  {
    "codigo":417349008,
    "descripcion":"FRACTURA-LUXACIÓN NO EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA PROXIMAL DE DEDO DE LA MANO"
  },
  {
    "codigo":251674005,
    "descripcion":"DESACELERACIÓN TEMPRANA DEL CORAZÓN FETAL"
  },
  {
    "codigo":22298006,
    "descripcion":"INFARTO DE MIOCARDIO"
  },
  {
    "codigo":186138007,
    "descripcion":"INFECCIÓN DEL TRACTO GASTROINTESTINAL POR MORGANELLA MORGANII"
  },
  {
    "codigo":320361000119104,
    "descripcion":"ARTROSIS SECUNDARIA DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":20463003,
    "descripcion":"INFECCIÓN CAUSADA POR GLOBOCEPHALUS UROSUBULATUS"
  },
  {
    "codigo":282607006,
    "descripcion":"CAPAZ DE GATEAR"
  },
  {
    "codigo":315375007,
    "descripcion":"NACIDO EN AUSTRIA"
  },
  {
    "codigo":15639401000119105,
    "descripcion":"CATARATA SUBCAPSULAR POSTERIOR DE OJO DERECHO"
  },
  {
    "codigo":248004009,
    "descripcion":"AGRESIÓN FÍSICA"
  },
  {
    "codigo":49561003,
    "descripcion":"RUPTURA DEL ÚTERO ANTES DEL INICIO DEL TRABAJO DE PARTO"
  },
  {
    "codigo":1260142000,
    "descripcion":"SÍNDROME CONGÉNITO DE ANOMALÍAS VERTEBRALES, CARDÍACAS Y RENALES"
  },
  {
    "codigo":211566001,
    "descripcion":"LESIÓN TRAUMÁTICA ABIERTA POR APLASTAMIENTO, ANTEBRAZO"
  },
  {
    "codigo":735854005,
    "descripcion":"LACERACIÓN DE ARTERIA PERONEA"
  },
  {
    "codigo":308035000,
    "descripcion":"VISTO EN EL SERVICIO DE FISIOTERAPIA"
  },
  {
    "codigo":471875005,
    "descripcion":"MIOCARDIOPATÍA NO COMPACTADA DE MIOCARDIO VENTRICULAR"
  },
  {
    "codigo":734019006,
    "descripcion":"SÍNDROME DE DIARREA CRÓNICA CON ATROFIA DE VELLOSIDADES"
  },
  {
    "codigo":209731009,
    "descripcion":"SECCIÓN EXPUESTA DE LIGAMENTO LUMBAR"
  },
  {
    "codigo":207896001,
    "descripcion":"FRACTURA CONMINUTA NO EXPUESTA DE ATLAS"
  },
  {
    "codigo":109592003,
    "descripcion":"SENSIBILIDAD DENTAL AL CEPILLADO O AL HILO DENTAL"
  },
  {
    "codigo":677021000119100,
    "descripcion":"CATARATA TRAUMÁTICA CON RESOLUCIÓN PARCIAL DE OJO IZQUIERDO"
  },
  {
    "codigo":240664007,
    "descripcion":"ABSCESO AMÉBICO DE LA PIEL"
  },
  {
    "codigo":371736008,
    "descripcion":"CON MAYOR RIESGO DE ASPIRACIÓN"
  },
  {
    "codigo":238829001,
    "descripcion":"ANETODERMA PRIMARIO"
  },
  {
    "codigo":764952009,
    "descripcion":"CARCINOSARCOMA DE CUERPO UTERINO"
  },
  {
    "codigo":402669006,
    "descripcion":"DERMATOSIS POR TROMBOSIS INTRAVASCULAR"
  },
  {
    "codigo":300695002,
    "descripcion":"INCAPAZ DE USAR UNA CUENTA FINANCIERA"
  },
  {
    "codigo":398999006,
    "descripcion":"ALTERACIÓN PARA DEGLUTIR NO COMPENSADA"
  },
  {
    "codigo":266092000,
    "descripcion":"GANGRENA GASEOSA OCASIONADA POR CLOSTRIDIUM EDEMATIENS"
  },
  {
    "codigo":202391009,
    "descripcion":"DERRAME ARTICULAR CRÓNICO"
  },
  {
    "codigo":298860003,
    "descripcion":"CREPITACIÓN PALPABLE DE ARTICULACIÓN DE HOMBRO"
  },
  {
    "codigo":724844008,
    "descripcion":"PRURITO DEBIDO A TRASTORNO NEUROLÓGICO"
  },
  {
    "codigo":723009000,
    "descripcion":"LIPOMA SUBFACIAL PROFUNDO"
  },
  {
    "codigo":428097001,
    "descripcion":"TRASTORNO DE LA ARTICULACIÓN DE LA CADERA"
  },
  {
    "codigo":231489001,
    "descripcion":"TRASTORNO PSICÓTICO TRANSITORIO AGUDO"
  },
  {
    "codigo":167788008,
    "descripcion":"MOVILIDAD DE LOS ESPERMATOZOIDES A LAS 6-8 HORAS, MUY BAJA: MENOS DE 10%"
  },
  {
    "codigo":297025006,
    "descripcion":"SOBREDOSIS DE ÁCIDO ETACRÍNICO"
  },
  {
    "codigo":786710002,
    "descripcion":"NEOPLASIA SÓLIDA CON FUSIÓN DE GEN DEL RECEPTOR DE TIROSINA CINASA NEUROTRÓFICO"
  },
  {
    "codigo":229654003,
    "descripcion":"DISFASIA DE BROCA"
  },
  {
    "codigo":295190006,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE ALFENTANILO"
  },
  {
    "codigo":65814009,
    "descripcion":"SUBLUXACIÓN DEL CRISTALINO"
  },
  {
    "codigo":1145323003,
    "descripcion":"ASPECTO DE LÍQUIDO CEFALORRAQUÍDEO: OPACO"
  },
  {
    "codigo":30101000175103,
    "descripcion":"ÚLCERA POR PRESIÓN EN TOBILLO DERECHO, ESTADIO II"
  },
  {
    "codigo":31211008,
    "descripcion":"ESPERMATEMPRAXIS"
  },
  {
    "codigo":62144003,
    "descripcion":"ALBINOIDISMO OCULOCUTÁNEO PUNTEADO"
  },
  {
    "codigo":291520003,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR VANCOMICINA"
  },
  {
    "codigo":94912005,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE HUESO LARGO DE LA EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":715669000,
    "descripcion":"DISPLASIA EPITELIAL CONGÉNITA DE INTESTINO"
  },
  {
    "codigo":289685000,
    "descripcion":"ALTURA DEL FONDO UTERINO DISMINUIDA PARA LA EDAD GESTACIONAL"
  },
  {
    "codigo":93077001,
    "descripcion":"HIPERTROFIA CONGÉNITA DE TESTÍCULO"
  },
  {
    "codigo":10864081000119102,
    "descripcion":"HERIDA POR DISPARO DE ARMA DE FUEGO DE PIERNA DERECHA"
  },
  {
    "codigo":224149009,
    "descripcion":"VIVE EN UNA COMUNA"
  },
  {
    "codigo":713834002,
    "descripcion":"VÍCTIMA DE EXPLOTACIÓN SEXUAL INFANTIL"
  },
  {
    "codigo":58474006,
    "descripcion":"PERICARDITIS SECUNDARIA A COLAGENOPATÍA VASCULAR"
  },
  {
    "codigo":1172586007,
    "descripcion":"SÍNDROME DE ANOMALÍAS OCULARES, NEUROPATÍA AXONAL Y RETRASO DEL DESARROLLO"
  },
  {
    "codigo":449855005,
    "descripcion":"PÓLIPO SERRADO DE COLON"
  },
  {
    "codigo":1269055006,
    "descripcion":"LESIÓN DE ARTERIA CELÍACA"
  },
  {
    "codigo":286015006,
    "descripcion":"CAPAZ DE APAGAR UN ARTEFACTO ELECTRODOMÉSTICO"
  },
  {
    "codigo":253247009,
    "descripcion":"ESTRECHEZ CONGÉNITA DE MEATO ÓSEO"
  },
  {
    "codigo":415252001,
    "descripcion":"HERNIA RECURRENTE DE PARED ABDOMINAL ANTERIOR CON GANGRENA"
  },
  {
    "codigo":249577000,
    "descripcion":"BAZO PALPABLE EN POSICIÓN LATERAL DERECHA"
  },
  {
    "codigo":216809001,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR FERTILIZANTES"
  },
  {
    "codigo":1263550001,
    "descripcion":"INFARTO CEREBRAL DEBIDO A MIGRAÑA"
  },
  {
    "codigo":679531000119103,
    "descripcion":"LESIÓN VASCULAR DE PÁRPADO INFERIOR DERECHO"
  },
  {
    "codigo":247742006,
    "descripcion":"ALUCINACIONES ASOCIADAS CON UNA PÉRDIDA"
  },
  {
    "codigo":442515000,
    "descripcion":"TAQUICARDIA REFLEJA"
  },
  {
    "codigo":870334009,
    "descripcion":"SARCOIDOSIS PALMOPLANTAR"
  },
  {
    "codigo":213139001,
    "descripcion":"PROBLEMA OCASIONADO POR PESARIO VAGINAL"
  },
  {
    "codigo":351851000119104,
    "descripcion":"FIBROXANTOMA ATÍPICO DE PIEL DE CUERO CABELLUDO"
  },
  {
    "codigo":278675003,
    "descripcion":"INCLINACIÓN BUCAL DE DIENTE - BUCAL"
  },
  {
    "codigo":34001000087101,
    "descripcion":"LESIONES TRAUMÁTICAS MÚLTIPLES DE APARATO URINARIO"
  },
  {
    "codigo":704659007,
    "descripcion":"NIÑO CON MAYOR RIESGO DE SER VÍCTIMA DE ABUSO"
  },
  {
    "codigo":46801000087104,
    "descripcion":"STENT INTESTINAL IN SITU"
  },
  {
    "codigo":440680000,
    "descripcion":"INCAPAZ DE CONCURRIR A LA ESCUELA POR ENFERMEDAD"
  },
  {
    "codigo":211304002,
    "descripcion":"ABRASIÓN DE PIEL DE PALMA DE MANO"
  },
  {
    "codigo":735592003,
    "descripcion":"PERITONITIS PRIMARIA"
  },
  {
    "codigo":44241000087108,
    "descripcion":"CONTUSIÓN DE CÓNDILO INTERNO DE FÉMUR IZQUIERDO"
  },
  {
    "codigo":41681000087103,
    "descripcion":"QUEMADURA DE PÁRPADO INFERIOR DERECHO"
  },
  {
    "codigo":39121000087105,
    "descripcion":"DOLOR CRÓNICO POSTERIOR A LATIGAZO CERVICAL"
  },
  {
    "codigo":11820651000119105,
    "descripcion":"SUBLUXACIÓN INFERIOR DE ARTICULACIÓN GLENOHUMERAL IZQUIERDA"
  },
  {
    "codigo":1259880008,
    "descripcion":"CERVICITIS ATRÓFICA"
  },
  {
    "codigo":209469000,
    "descripcion":"ESGUINCE DE PULGAR, ARTICULACIÓN CARPOMETACARPIANA"
  },
  {
    "codigo":15916651000119107,
    "descripcion":"PIE PLANO CONGÉNITO BILATERAL"
  },
  {
    "codigo":45629003,
    "descripcion":"ABSCESO DE LA RINOFARINGE"
  },
  {
    "codigo":897597009,
    "descripcion":"AUSENCIA DE CÉLULAS EPITELIALES EN ORINA AL EXAMEN MICROSCÓPICO"
  },
  {
    "codigo":764690001,
    "descripcion":"TETRASOMÍA 21"
  },
  {
    "codigo":76562003,
    "descripcion":"CATARATA SUBCAPSULAR CONGÉNITA"
  },
  {
    "codigo":240402003,
    "descripcion":"LEPRA TUBERCULOIDE LIMÍTROFE"
  },
  {
    "codigo":109330008,
    "descripcion":"ABSCESO DE ESFENOIDES"
  },
  {
    "codigo":11026009,
    "descripcion":"ABORTO ESPONTÁNEO CON NECROSIS TUBULAR RENAL"
  },
  {
    "codigo":402407004,
    "descripcion":"ANGIOEDEMA DE LENGUA"
  },
  {
    "codigo":1187004001,
    "descripcion":"ENCEFALOPATÍA TRAUMÁTICA CRÓNICA"
  },
  {
    "codigo":72892002,
    "descripcion":"EMBARAZO NORMAL"
  },
  {
    "codigo":369639009,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA DE URÉTER Y PELVIS RENAL, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":267665002,
    "descripcion":"OTITIS EXTERNA INFECCIOSA AGUDA"
  },
  {
    "codigo":431505005,
    "descripcion":"RECHAZO DE TRASPLANTE DE INTESTINO"
  },
  {
    "codigo":11794181000119108,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":365969008,
    "descripcion":"HALLAZGO RELACIONADO CON EL AMBIENTE DONDE SE BEBE"
  },
  {
    "codigo":36454001,
    "descripcion":"XERODERMIA PIGMENTOSA, GRUPO G"
  },
  {
    "codigo":71057007,
    "descripcion":"INFECCIÓN CAUSADA POR ESCHERICHIA COLI"
  },
  {
    "codigo":429670004,
    "descripcion":"INFECCIÓN DE BOLSA SEROSA PRERROTULIANA"
  },
  {
    "codigo":724582008,
    "descripcion":"NEOPLASIA OSTEÓGENA BENIGNA DE CARTÍLAGO ARTICULAR DE MAXILAR INFERIOR"
  },
  {
    "codigo":298598009,
    "descripcion":"HALLAZGO RELACIONADO CON EL MOVIMIENTO DE LA COLUMNA LUMBAR"
  },
  {
    "codigo":198459002,
    "descripcion":"INFERTILIDAD CERVICAL PRIMARIA"
  },
  {
    "codigo":296763003,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE OXITETRACICLINA"
  },
  {
    "codigo":1148731005,
    "descripcion":"SOBREDOSIS DE AGENTE BLOQUEANTE NEUROMUSCULAR"
  },
  {
    "codigo":460603007,
    "descripcion":"ANOMALÍA DE CONDUCTO ARTERIOSO"
  },
  {
    "codigo":426000000,
    "descripcion":"FIEBRE SUPERIOR A 38 GRADOS CELSIUS"
  },
  {
    "codigo":10948511000119105,
    "descripcion":"HERIDA ABIERTA DE MANO DERECHA DEBIDA A MORDEDURA DE PERRO"
  },
  {
    "codigo":131088002,
    "descripcion":"HORMONA TIROIDEA ANORMAL"
  },
  {
    "codigo":1343504005,
    "descripcion":"HIPERTROFIA SINOVIAL DE MANO"
  },
  {
    "codigo":682041000119100,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE ORIFICIO URETERAL"
  },
  {
    "codigo":719077007,
    "descripcion":"CON ALTO RIESGO DE FIBRILACIÓN AURICULAR"
  },
  {
    "codigo":63717008,
    "descripcion":"EXOSTOSIS ORBITARIA"
  },
  {
    "codigo":293093008,
    "descripcion":"REACCIÓN ADVERSA A LA FENOTRINA"
  },
  {
    "codigo":94650002,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL CÚBITO"
  },
  {
    "codigo":717242007,
    "descripcion":"EMPLEADOR CONSCIENTE DEL DIAGNÓSTICO"
  },
  {
    "codigo":125583000,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE LOS MIEMBROS SUPERIORES"
  },
  {
    "codigo":1208762007,
    "descripcion":"FLUJO DE SANGRE PERSISTENTE HACIA SACO ANEURISMÁTICO POSTERIOR A INSERCIÓN ENDOVASCULAR DE STENT CON CUBIERTA"
  },
  {
    "codigo":1010319003,
    "descripcion":"TRASTORNO FETAL DEBIDO A TRASTORNO NUTRICIONAL MATERNO"
  },
  {
    "codigo":289423003,
    "descripcion":"AMBAS FONTANELAS PALPABLES"
  },
  {
    "codigo":713572001,
    "descripcion":"ENFERMEDAD NEOPLÁSICA MALIGNA CONCOMITANTE CON INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":254820002,
    "descripcion":"ATROFODERMIA FOLICULAR Y EPITELIOMAS BASOCELULARES"
  },
  {
    "codigo":1303396001,
    "descripcion":"FRACTURA ÓSEA DE AMBAS MUÑECAS"
  },
  {
    "codigo":285753002,
    "descripcion":"LESIÓN VENOSA EN LAS EXTREMIDADES INFERIORES"
  },
  {
    "codigo":354361000119107,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE RIÑÓN DERECHO"
  },
  {
    "codigo":11823161000119108,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE REGIÓN DE HOMBRO DERECHO"
  },
  {
    "codigo":449593007,
    "descripcion":"AURÍCULA IZQUIERDA DIVIDIDA CON DESEMBOCADURA DE ALGUNAS VENAS PULMONARES EN LA CÁMARA PROXIMAL Y DRENAJE EN LA AURÍCULA IZQUIERDA Y OTRAS CONECTADAS DIRECTAMENTE A LA AURÍCULA IZQUIERDA"
  },
  {
    "codigo":89145009,
    "descripcion":"CATARRO TUBOTIMPÁNICO SUBAGUDO"
  },
  {
    "codigo":283918002,
    "descripcion":"CONTUSIÓN DE LA URETRA"
  },
  {
    "codigo":87310001,
    "descripcion":"MONORQUIDIA"
  },
  {
    "codigo":1091641000119109,
    "descripcion":"PERFORACIÓN DEL BORDE DEL TÍMPANO DERECHO"
  },
  {
    "codigo":251150006,
    "descripcion":"RITMO SINUSAL"
  },
  {
    "codigo":218382006,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR EMETINA"
  },
  {
    "codigo":216547000,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR IMIPRAMINA"
  },
  {
    "codigo":445923001,
    "descripcion":"DEFECTO DE CAMPO VISUAL DE TIPO SECTORIAL"
  },
  {
    "codigo":183779005,
    "descripcion":"INSCRIPTO EN LISTA DE ADMISIÓN PSICOGERIÁTRICA"
  },
  {
    "codigo":118243007,
    "descripcion":"HALLAZGO POR INSPECCIÓN"
  },
  {
    "codigo":18104000,
    "descripcion":"ACIDOSIS METABÓLICA, BRECHA ANIÓNICA NORMAL, SALES ACIDIFICANTES"
  },
  {
    "codigo":247480006,
    "descripcion":"HALLAZGO DE LAS UÑAS"
  },
  {
    "codigo":2601000124103,
    "descripcion":"CANINO SUPERIOR DERECHO PERMANENTE SUPERNUMERARIO"
  },
  {
    "codigo":440361000124107,
    "descripcion":"INFUSIÓN PARA NUTRICIÓN ENTERAL INADECUADA"
  },
  {
    "codigo":211042000,
    "descripcion":"ABRASIÓN DE PIEL DE DORSO"
  },
  {
    "codigo":1163149009,
    "descripcion":"COREA POSENCEFALÍTICA"
  },
  {
    "codigo":768098001,
    "descripcion":"HERNIA CRURAL IZQUIERDA RECURRENTE IRREDUCTIBLE"
  },
  {
    "codigo":473186003,
    "descripcion":"MIGRACIÓN DE CATÉTER DE TENCKHOFF"
  },
  {
    "codigo":276578004,
    "descripcion":"ANEMIA FISIOLÓGICA DE LA LACTANCIA"
  },
  {
    "codigo":407650005,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: CROATA"
  },
  {
    "codigo":14434006,
    "descripcion":"LACERACIÓN CEREBELOSA CON HERIDA INTRACRANEAL ABIERTA Y SIN PÉRDIDA DE CONSCIENCIA"
  },
  {
    "codigo":16269008,
    "descripcion":"NEURALGIA"
  },
  {
    "codigo":241975000,
    "descripcion":"MAL DE LA MONTAÑA CRÓNICO"
  },
  {
    "codigo":1259618005,
    "descripcion":"ADENOCARCINOMA SEBÁCEO PRIMARIO DE PÁRPADO"
  },
  {
    "codigo":373047001,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM NONCHROMOGENICUM"
  },
  {
    "codigo":274743004,
    "descripcion":"TUMEFACCIÓN DE REGIÓN INGUINAL"
  },
  {
    "codigo":438583008,
    "descripcion":"SÍNDROME PERISILVIANO BILATERAL CONGÉNITO"
  },
  {
    "codigo":403980002,
    "descripcion":"HEMANGIOENDOTELIOMA"
  },
  {
    "codigo":240140005,
    "descripcion":"DESGARRO DE FIBROCARTÍLAGO ARTICULAR"
  },
  {
    "codigo":43532007,
    "descripcion":"ANGIOPATÍA AMILOIDE OCULOLEPTOMENÍNGEA HEREDITARIA"
  },
  {
    "codigo":698892007,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: CATALÁN"
  },
  {
    "codigo":74465000,
    "descripcion":"FRACTURA DE HUESO TRAPECIO DE LA MUÑECA"
  },
  {
    "codigo":305676007,
    "descripcion":"ATENDIDO POR UN CITOGENETISTA CLÍNICO"
  },
  {
    "codigo":1286881004,
    "descripcion":"MELANOMA IN SITU DE PIEL DE PÁRPADO SUPERIOR"
  },
  {
    "codigo":762593008,
    "descripcion":"DOLOR OROFACIAL CRÓNICO PRIMARIO"
  },
  {
    "codigo":402145008,
    "descripcion":"DERMATOSIS CAUSADA POR DIPTERA"
  },
  {
    "codigo":302006002,
    "descripcion":"INCAPAZ DE OPONER EL PULGAR"
  },
  {
    "codigo":367542003,
    "descripcion":"EOSINOFILIA PULMONAR"
  },
  {
    "codigo":236470002,
    "descripcion":"DEFECTO DE TRANSPORTE ESPECÍFICO DEL TÚBULO RENAL"
  },
  {
    "codigo":860897009,
    "descripcion":"ERUPCIÓN EN LUGAR DE INFECCIÓN"
  },
  {
    "codigo":269238008,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO SUPERFICIAL DE CUERO CABELLUDO"
  },
  {
    "codigo":267403002,
    "descripcion":"EUNUQUISMO"
  },
  {
    "codigo":70795003,
    "descripcion":"QUISTE URETRAL"
  },
  {
    "codigo":16003591000119104,
    "descripcion":"TENDINITIS DE MANGUITO ROTADOR DERECHO"
  },
  {
    "codigo":300171003,
    "descripcion":"MARTILLO: NORMAL"
  },
  {
    "codigo":234635007,
    "descripcion":"ANORMALIDADES DEL CROMOSOMA 22 CON HIPOGAMMAGLOBULINEMIA"
  },
  {
    "codigo":1217675008,
    "descripcion":"CONJUNTIVITIS CICATRIZAL CRÓNICA DEBIDA A SÍNDROME DE STEVENS-JOHNSON"
  },
  {
    "codigo":429408002,
    "descripcion":"GLIOMA CEREBRAL DE BAJO GRADO"
  },
  {
    "codigo":167264005,
    "descripcion":"PRUEBA DE GLUCOSA EN ORINA = +"
  },
  {
    "codigo":298336006,
    "descripcion":"SIN RESPUESTA MOTORA LUEGO DE UNA ORDEN"
  },
  {
    "codigo":10678791000119106,
    "descripcion":"TUMEFACCIÓN LOCALIZADA DE DEDOS DE AMBAS MANOS"
  },
  {
    "codigo":3424008,
    "descripcion":"TAQUICARDIA"
  },
  {
    "codigo":296501001,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE SAL DE ORO"
  },
  {
    "codigo":67125004,
    "descripcion":"SÍFILIS LATENTE CON SEROLOGÍA POSITIVA"
  },
  {
    "codigo":722485007,
    "descripcion":"NEOPLASIA DE CABEZA DE COSTILLA"
  },
  {
    "codigo":11825671000119109,
    "descripcion":"LACERACIÓN DE TENDÓN DE LA MANO DERECHA"
  },
  {
    "codigo":784351000,
    "descripcion":"SÍNDROME DE PTERIGIÓN ANTECUBITAL"
  },
  {
    "codigo":292831002,
    "descripcion":"REACCIÓN ADVERSA AL FAMCICLOVIR"
  },
  {
    "codigo":30687003,
    "descripcion":"TRASTORNO BIPOLAR II, EPISODIO MÁS RECIENTE DE CARACTERÍSTICAS DEPRESIVAS PROFUNDAS, CON INICIO EN EL PERÍODO POSTPARTO"
  },
  {
    "codigo":423903007,
    "descripcion":"DENDRITA CORNEAL"
  },
  {
    "codigo":225460000,
    "descripcion":"LLORA CONSTANTEMENTE"
  },
  {
    "codigo":290996001,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR CLORMEZANONA"
  },
  {
    "codigo":15731361000119106,
    "descripcion":"PAPILEDEMA DE OJO DERECHO DEBIDO A PRESIÓN INTRAOCULAR POR DEBAJO DE RANGO DE REFERENCIA"
  },
  {
    "codigo":127156005,
    "descripcion":"LINFADENOPATÍA RETROCECAL"
  },
  {
    "codigo":94388008,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL TERCIO INFERIOR DEL ESÓFAGO"
  },
  {
    "codigo":27017003,
    "descripcion":"PERICARDITIS CRÓNICA CON DERRAME"
  },
  {
    "codigo":715145003,
    "descripcion":"INFECCIÓN CAUSADA POR ESCHERICHIA COLI SEROGRUPO O158"
  },
  {
    "codigo":92553008,
    "descripcion":"CARCINOMA IN SITU DE BRONQUIO DEL LÓBULO SUPERIOR IZQUIERDO DEL PULMÓN"
  },
  {
    "codigo":289161009,
    "descripcion":"HALLAZGO RELACIONADO CON EL APETITO"
  },
  {
    "codigo":287326003,
    "descripcion":"ATONÍA DE LA VESÍCULA BILIAR"
  },
  {
    "codigo":285491001,
    "descripcion":"CAPAZ DE SELLAR LABIOS"
  },
  {
    "codigo":187187002,
    "descripcion":"ANGIOESTRONGILIASIS INTESTINAL"
  },
  {
    "codigo":88171000119100,
    "descripcion":"ADENOIDITIS AGUDA"
  },
  {
    "codigo":164971000119101,
    "descripcion":"DIABETES MELLITUS TIPO 2 CONTROLADA CON DIETA"
  },
  {
    "codigo":610412651000119100,
    "descripcion":"INFARTO DE INTESTINO DELGADO DEBIDO A TROMBOSIS DE VENA MESENTÉRICA"
  },
  {
    "codigo":331371000119103,
    "descripcion":"HEMORRAGIA DE CUERPO VÍTREO DERECHO"
  },
  {
    "codigo":19051000119100,
    "descripcion":"DEFORMIDAD DE LECHO UNGUEAL"
  },
  {
    "codigo":134251000119105,
    "descripcion":"FALTA DE PROGRESO EN EL RECIÉN NACIDO"
  },
  {
    "codigo":1131000119105,
    "descripcion":"SECUELA DE ACCIDENTE CEREBROVASCULAR"
  },
  {
    "codigo":239965291000119107,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DEBIDO A OCLUSIÓN DE ARTERIA BASILAR"
  },
  {
    "codigo":16715371000119107,
    "descripcion":"DISFUNCIÓN ERÉCTIL DEBIDA A ABLACIÓN DE PRÓSTATA Y POSTERIOR A ELLA"
  },
  {
    "codigo":12240491000119107,
    "descripcion":"CALAMBRE DE MÚSCULO DE EXTREMIDAD INFERIOR DERECHA"
  },
  {
    "codigo":318571000119109,
    "descripcion":"HIPERLORDOSIS POSTURAL ADQUIRIDA DE COLUMNA VERTEBRAL LUMBAR"
  },
  {
    "codigo":292971000119105,
    "descripcion":"TRASTORNO DEBIDO A LESIÓN TRAUMÁTICA DE MÉDULA ESPINAL DORSAL Y POSTERIOR A ELLA"
  },
  {
    "codigo":303211000119109,
    "descripcion":"TENDINITIS CALCIFICANTE DE BRAZO IZQUIERDO"
  },
  {
    "codigo":1332232005,
    "descripcion":"INCONGRUENCIA DE GÉNERO EN LA ADOLESCENCIA"
  },
  {
    "codigo":54280009,
    "descripcion":"ENFERMEDAD DE KUGELBERG - WELANDER"
  },
  {
    "codigo":283656003,
    "descripcion":"HERIDA POR PINCHAZO DE CLAVO EN LA AXILA"
  },
  {
    "codigo":313451000119108,
    "descripcion":"ARTROFITO EN ARTICULACIÓN DE DEDO DE PIE DERECHO"
  },
  {
    "codigo":399426008,
    "descripcion":"COMPROMISO TUMORAL DE MARGEN DE RESECCIÓN QUIRÚRGICA DE VÍAS BILIARES, NO PUEDE SER EVALUADO"
  },
  {
    "codigo":871645006,
    "descripcion":"AURÍCULA COMÚN CON UNIONES AURICULOVENTRICULARES SEPARADAS"
  },
  {
    "codigo":1363165007,
    "descripcion":"SINUSITIS MAXILAR DEBIDA A TRASTORNO DENTAL"
  },
  {
    "codigo":609501008,
    "descripcion":"INTERRUPCIÓN INDUCIDA DEL EMBARAZO COMPLICADA POR PERFORACIÓN DE LIGAMENTO ANCHO"
  },
  {
    "codigo":17842005,
    "descripcion":"CONFABULACIÓN"
  },
  {
    "codigo":443826006,
    "descripcion":"HEMORRAGIA EN CAVIDAD PERITONEAL"
  },
  {
    "codigo":687061000119103,
    "descripcion":"NEUROFIBROMA ABDOMINAL"
  },
  {
    "codigo":441991000,
    "descripcion":"HEMIPARESIA COMO EFECTO TARDÍO DE ACCIDENTE CEREBROVASCULAR"
  },
  {
    "codigo":278151004,
    "descripcion":"GRUPO SANGUÍNEO AB RH(D) POSITIVO"
  },
  {
    "codigo":81543006,
    "descripcion":"FORMACIÓN DE TEJIDO DURO ANORMAL EN LA PULPA"
  },
  {
    "codigo":309084001,
    "descripcion":"PÓLIPO ADENOMATOSO VELLOSO DE COLON"
  },
  {
    "codigo":1259356003,
    "descripcion":"CARCINOMA PRIMARIO DE CURVATURA MAYOR DE ESTÓMAGO"
  },
  {
    "codigo":866140004,
    "descripcion":"INFECCIÓN DE NERVIO PERIFÉRICO CAUSADA POR MUCORALES"
  },
  {
    "codigo":276316005,
    "descripcion":"CONTRACCIÓN DE LA CONJUNTIVA"
  },
  {
    "codigo":12337004,
    "descripcion":"TRASTORNO DEL ÚTERO"
  },
  {
    "codigo":405553004,
    "descripcion":"TRAUMATISMO DE VÁLVULA TRICÚSPIDE"
  },
  {
    "codigo":77873007,
    "descripcion":"CATARATA NEGRA"
  },
  {
    "codigo":733233009,
    "descripcion":"HERIDA PUNZANTE DE ANTEBRAZO CON CUERPO EXTRAÑO"
  },
  {
    "codigo":895238002,
    "descripcion":"FORMA ANCHA ANORMAL CONGÉNITA DE FALANGE MEDIA DE DEDO DE MANO"
  },
  {
    "codigo":370950002,
    "descripcion":"OPACIDAD INTERLENTICULAR"
  },
  {
    "codigo":239878003,
    "descripcion":"ARTROSIS DE LA ARTICULACIÓN DE DEDO DEL PIE"
  },
  {
    "codigo":43270005,
    "descripcion":"OSTEÍTIS DEL ANTEBRAZO"
  },
  {
    "codigo":403718007,
    "descripcion":"QUEMADURA POR FOTOQUIMIOTERAPIA CON PSORALENO Y RADIACIÓN ULTRAVIOLETA DE ONDA LARGA"
  },
  {
    "codigo":41435003,
    "descripcion":"ALTERACIÓN EN LA ESTRUCTURA DE LAS ASOCIACIONES"
  },
  {
    "codigo":238043005,
    "descripcion":"TRASTORNO DEL METABOLISMO DE GLUCOSAMINOGLUCANOS"
  },
  {
    "codigo":762331007,
    "descripcion":"TRASTORNO DE ANSIEDAD CAUSADO POR ESTIMULANTE"
  },
  {
    "codigo":170672000,
    "descripcion":"EFECTO COLATERAL DE FÁRMACO GASTROINTESTINAL"
  },
  {
    "codigo":301744001,
    "descripcion":"INCAPAZ DE REALIZAR ACTIVIDADES DE TECNOLOGÍA INFORMÁTICA"
  },
  {
    "codigo":430981001,
    "descripcion":"AVULSIÓN DE UÑA DE DEDO DE LA MANO"
  },
  {
    "codigo":365445003,
    "descripcion":"HALLAZGO RELACIONADO CON EL COLOR DEL ESPUTO"
  },
  {
    "codigo":15707401000119101,
    "descripcion":"MIOSITIS OSIFICANTE TRAUMÁTICA DE MANOS BILATERALES"
  },
  {
    "codigo":4997005,
    "descripcion":"TIROTOXICOSIS FICTICIA"
  },
  {
    "codigo":70533006,
    "descripcion":"AFRONTAMIENTO FAMILIAR: POTENCIAL DE DESARROLLO"
  },
  {
    "codigo":299909008,
    "descripcion":"HALLAZGO RELACIONADO CON LA SENSIBILIDAD AL TACTO"
  },
  {
    "codigo":103301009,
    "descripcion":"VÉRTIGO, INICIO AGUDO CON VÓMITOS E INCAPACIDAD PARA ESTAR DE PIE"
  },
  {
    "codigo":10900591000119109,
    "descripcion":"ENUCLEACIÓN TRAUMÁTICA DE OJO DERECHO"
  },
  {
    "codigo":724058006,
    "descripcion":"NEOPLASIA MALIGNA DE LÓBULO SUPERIOR DE PULMÓN IZQUIERDO"
  },
  {
    "codigo":722223000,
    "descripcion":"QUISTE DE RIÑÓN"
  },
  {
    "codigo":298074009,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE HOMBRO"
  },
  {
    "codigo":296239005,
    "descripcion":"SOBREDOSIS INTENCIONAL DE TIORIDAZINA"
  },
  {
    "codigo":230703006,
    "descripcion":"SÍNDROME DE DISARTRIA-MANO TORPE DEBIDO A INFARTO LACUNAR Y POSTERIOR A ÉL"
  },
  {
    "codigo":34095006,
    "descripcion":"DESHIDRATACIÓN"
  },
  {
    "codigo":785924000,
    "descripcion":"MYCOBACTERIUM AFRICANUM O MYCOBACTERIUM PINNIPEDII"
  },
  {
    "codigo":294404005,
    "descripcion":"ALERGIA A ÁCIDO ACÉTICO"
  },
  {
    "codigo":425476007,
    "descripcion":"PARASOMNIA NO ORGÁNICA"
  },
  {
    "codigo":1144537004,
    "descripcion":"BUENA RECUPERACIÓN DE AGRESIÓN SEXUAL"
  },
  {
    "codigo":292569004,
    "descripcion":"REACCIÓN ADVERSA AL ASTEMIZOL"
  },
  {
    "codigo":718553004,
    "descripcion":"SÍNDROME DE PLAQUETAS BLANCAS"
  },
  {
    "codigo":390873004,
    "descripcion":"VELOCIDAD DE FLUJO ESPIRATORIO PICO - BUENA DISTENSIBILIDAD"
  },
  {
    "codigo":94126000,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LOS ANEXOS UTERINOS"
  },
  {
    "codigo":28590005,
    "descripcion":"LINFEDEMA ADQUIRIDO CRÓNICO"
  },
  {
    "codigo":34211000119103,
    "descripcion":"OBSTRUCCIÓN DISTAL DE TROMPA DE FALOPIO"
  },
  {
    "codigo":1306542009,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE PROLONGACIÓN AXILAR DE MAMA DERECHA"
  },
  {
    "codigo":714883006,
    "descripcion":"CAPAZ DE PASAR DE UNA UBICACIÓN A OTRA"
  },
  {
    "codigo":59523007,
    "descripcion":"QUERATITIS DISCIFORME POR VIRUS DEL HERPES SIMPLE"
  },
  {
    "codigo":288899008,
    "descripcion":"DIFICULTAD PARA CONTROLAR EL BOLO ALIMENTICIO"
  },
  {
    "codigo":92291009,
    "descripcion":"NEOPLASIA BENIGNA DE FALANGE DEL PIE"
  },
  {
    "codigo":24920002,
    "descripcion":"REACCIÓN DE HUIDA DE LA INFANCIA"
  },
  {
    "codigo":385368003,
    "descripcion":"ESTADIO DE LA FEDERACIÓN INTERNACIONAL DE GINECOLOGÍA Y OBSTETRICIA (FIGO) PARA CARCINOMA CERVICAL - HALLAZGO"
  },
  {
    "codigo":16745891000119105,
    "descripcion":"RETINOPATÍA NO PROLIFERATIVA LEVE DE OJO IZQUIERDO DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":287064006,
    "descripcion":"FRACTURA PATOLÓGICA - HOMBRO"
  },
  {
    "codigo":116131000119107,
    "descripcion":"RESONANCIA MAGNÉTICA DE CABEZA ANORMAL"
  },
  {
    "codigo":23085004,
    "descripcion":"ESTRÉS AUMENTADO"
  },
  {
    "codigo":285229009,
    "descripcion":"CAPAZ DE RECORDAR SONIDOS"
  },
  {
    "codigo":283394006,
    "descripcion":"LACERACIÓN DE LA PLANTA DEL PIE"
  },
  {
    "codigo":248791002,
    "descripcion":"ORGASMO INHIBIDO"
  },
  {
    "codigo":1297367004,
    "descripcion":"LUXACIÓN CONGÉNITA DE ARTICULACIÓN GLENOHUMERAL IZQUIERDA"
  },
  {
    "codigo":609239004,
    "descripcion":"VIVE EN ALOJAMIENTO NO INSTITUCIONAL"
  },
  {
    "codigo":771244000,
    "descripcion":"QUEMADURA PROFUNDA DE ESPESOR TOTAL CON COMPROMISO MUSCULAR"
  },
  {
    "codigo":443564001,
    "descripcion":"DISPUESTO A SER DONANTE DE ÓRGANO"
  },
  {
    "codigo":410796000,
    "descripcion":"POLIARTRITIS JUVENIL SEROPOSITIVA"
  },
  {
    "codigo":1295532004,
    "descripcion":"HIPERTENSIÓN OCULAR BILATERAL CAUSADA POR ACEITE DE SILICONA"
  },
  {
    "codigo":246956006,
    "descripcion":"ABSCESO DE ESTROMA CORNEAL"
  },
  {
    "codigo":335421000119107,
    "descripcion":"RUPTURA DE MEMBRANA DE DESCEMET DE OJO DERECHO"
  },
  {
    "codigo":1193558000,
    "descripcion":"TRASTORNO FETAL Y\/O NEONATAL PRECOZ DURANTE LA SEGUNDA ETAPA DEL PERÍODO INTRAPARTO DEBIDO A PARTO POR EXTRACCIÓN CON VENTOSA"
  },
  {
    "codigo":243286001,
    "descripcion":"OCLUSIÓN ARTERIAL MESENTÉRICA AGUDA"
  },
  {
    "codigo":10630871000119102,
    "descripcion":"LINFANGITIS AGUDA DE MUSLO DERECHO"
  },
  {
    "codigo":210518003,
    "descripcion":"SECCIÓN PARCIAL DEL TENDÓN DE LA PORCIÓN LARGA DEL MÚSCULO BÍCEPS"
  },
  {
    "codigo":1259094005,
    "descripcion":"ATAXIA DEBIDA A ATROFIA MULTISISTÉMICA, TIPO CEREBELOSA"
  },
  {
    "codigo":865878007,
    "descripcion":"ALERGIA A SUBNITRATO DE BISMUTO Y\/O YODOFORMO"
  },
  {
    "codigo":44843000,
    "descripcion":"HEMORRAGIA DE LA PRÓSTATA"
  },
  {
    "codigo":274219003,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR SUSTANCIA CORROSIVA"
  },
  {
    "codigo":16037591000119104,
    "descripcion":"OSTEOCONDROPATÍA DE AMBAS MANOS"
  },
  {
    "codigo":12075007,
    "descripcion":"HIPOPLASIA CONGÉNITA DE AORTA ASCENDENTE"
  },
  {
    "codigo":1222656005,
    "descripcion":"ENCEFALOPATÍA EPILÉPTICA Y DEL DESARROLLO ASOCIADA AL GEN SYNGAP-1"
  },
  {
    "codigo":403456007,
    "descripcion":"PIGMENTACIÓN GINGIVAL"
  },
  {
    "codigo":1351893002,
    "descripcion":"HEMANGIOBLASTOMA DE TRONCO ENCEFÁLICO"
  },
  {
    "codigo":237781008,
    "descripcion":"HIPERPLASIA SUPRARRENAL MEDULAR"
  },
  {
    "codigo":432554001,
    "descripcion":"ESTADO DE RECUPERACIÓN CARDÍACA DESPUÉS DEL ESFUERZO"
  },
  {
    "codigo":235946003,
    "descripcion":"PANCREATITIS AGUDA VIRAL"
  },
  {
    "codigo":301482005,
    "descripcion":"NO EVITA OBSTÁCULOS EN UN CAMINO"
  },
  {
    "codigo":203178006,
    "descripcion":"OSTEOMIELITIS AGUDA DE FALANGE DE DEDO DEL PIE"
  },
  {
    "codigo":299647001,
    "descripcion":"AMPUTADO POR SOBRE LA RODILLA"
  },
  {
    "codigo":1348223001,
    "descripcion":"PATRÓN DE USO NOCIVO DE ANTIDEPRESIVO SIN DEPENDENCIA, EN REMISIÓN"
  },
  {
    "codigo":234111003,
    "descripcion":"VESÍCULA LINFÁTICA"
  },
  {
    "codigo":168575006,
    "descripcion":"RADIOGRAFÍA SIMPLE DE COLUMNA VERTEBRAL CERVICAL NORMAL"
  },
  {
    "codigo":365183009,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA REALIZAR ACTIVIDADES DE BAÑO"
  },
  {
    "codigo":363348004,
    "descripcion":"NEOPLASIA MALIGNA DE LABIO"
  },
  {
    "codigo":263209002,
    "descripcion":"FRACTURA DE BASE DE QUINTO METACARPIANO"
  },
  {
    "codigo":230441003,
    "descripcion":"EPILEPSIA FARMACÓGENA"
  },
  {
    "codigo":164905008,
    "descripcion":"BLOQUEO AURICULOVENTRICULAR DE SEGUNDO GRADO TIPO MOBITZ I EN ELECTROCARDIOGRAMA"
  },
  {
    "codigo":64766004,
    "descripcion":"COLITIS ULCEROSA"
  },
  {
    "codigo":294142005,
    "descripcion":"ALERGIA A NEDOCROMILO"
  },
  {
    "codigo":128467002,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL CARTÍLAGO ARTICULAR"
  },
  {
    "codigo":292307003,
    "descripcion":"EFECTO ADVERSO DE LA FLUOXETINA"
  },
  {
    "codigo":10823691000119104,
    "descripcion":"FRACTURA EXPUESTA DE LA FALANGE PROXIMAL DEL DEDO ÍNDICE DE LA MANO IZQUIERDA"
  },
  {
    "codigo":95699005,
    "descripcion":"DEGENERACIÓN RETINIANA MULTIFOCAL"
  },
  {
    "codigo":1177043007,
    "descripcion":"ENCEFALOMIELITIS POR SCHISTOSOMA"
  },
  {
    "codigo":61096000,
    "descripcion":"EXHUMACIÓN PARA ESTABLECER LA CAUSA DE MUERTE"
  },
  {
    "codigo":716456000,
    "descripcion":"SÍNDROME DE MICRODELECIÓN 3Q29"
  },
  {
    "codigo":126632002,
    "descripcion":"NEOPLASIA DE LA CARA"
  },
  {
    "codigo":28328005,
    "descripcion":"MARCACIONES RADIOLÓGICAS"
  },
  {
    "codigo":93864006,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LÓBULO INFERIOR DE PULMÓN IZQUIERDO"
  },
  {
    "codigo":288637006,
    "descripcion":"NO ESTABLECE CONVERSACIÓN"
  },
  {
    "codigo":1237074000,
    "descripcion":"DEFECTO CONGÉNITO DE TABIQUE AURICULOVENTRICULAR"
  },
  {
    "codigo":254034001,
    "descripcion":"DEFORMIDAD CONGÉNITA DE LA ARTICULACIÓN LUMBOSACRA"
  },
  {
    "codigo":286802001,
    "descripcion":"AMÍGDALA PALATINA CONGESTIONADA"
  },
  {
    "codigo":92029009,
    "descripcion":"NEOPLASIA BENIGNA DEL TRONCO ENCEFÁLICO"
  },
  {
    "codigo":15958181000119103,
    "descripcion":"ADENOCARCINOMA METASTÁSICO DE AMBOS RIÑONES"
  },
  {
    "codigo":188498009,
    "descripcion":"LINFOSARCOMA"
  },
  {
    "codigo":219431003,
    "descripcion":"LESIÓN DE GUERRA DEBIDA A HUMOS"
  },
  {
    "codigo":283132001,
    "descripcion":"AMPOLLA TRAUMÁTICA DE TOBILLO"
  },
  {
    "codigo":119292006,
    "descripcion":"TRASTORNO DEL TRACTO GASTROINTESTINAL"
  },
  {
    "codigo":86524007,
    "descripcion":"INFECCIÓN CAUSADA POR ACUARIA"
  },
  {
    "codigo":51921000,
    "descripcion":"AMNESIA RETRÓGRADA"
  },
  {
    "codigo":445137006,
    "descripcion":"ACUMULACIÓN DE BILIS EN CAVIDAD ABDOMINAL"
  },
  {
    "codigo":1231569006,
    "descripcion":"TRASTORNO DE POLEA ORBITARIA"
  },
  {
    "codigo":19153009,
    "descripcion":"BIORRITMO CIRCANUAL NORMAL"
  },
  {
    "codigo":312230002,
    "descripcion":"HIPERHIDROSIS"
  },
  {
    "codigo":838353009,
    "descripcion":"PIELONEFRITIS AGUDA CAUSADA POR BACTERIA"
  },
  {
    "codigo":17318002,
    "descripcion":"SÍNDROME VIRILIZANTE DE ORIGEN SUPRARRENAL"
  },
  {
    "codigo":1196966007,
    "descripcion":"ENFERMEDAD GINGIVAL POR ENFERMEDAD CELÍACA"
  },
  {
    "codigo":1162363000,
    "descripcion":"OSTEONECROSIS DE REGIÓN PÉLVICA DEBIDA A HEMOGLOBINOPATÍA"
  },
  {
    "codigo":246694009,
    "descripcion":"VERGENCIA EN EL MOVIMIENTO VERTICAL DE LOS OJOS"
  },
  {
    "codigo":48251003,
    "descripcion":"MANO EN PALA"
  },
  {
    "codigo":284991000119104,
    "descripcion":"ENFERMEDAD RENAL CRÓNICA DEBIDA A HIPERTENSIÓN BENIGNA, ESTADIO 3"
  },
  {
    "codigo":277627005,
    "descripcion":"LINFOMA NODULAR DE CÉLULAS B DE ALTO GRADO"
  },
  {
    "codigo":212091008,
    "descripcion":"QUEMADURA QUE COMPROMETE 60-69 PORCIENTO DE LA SUPERFICIE DEL CUERPO, CON QUEMADURA DE ESPESOR COMPLETO QUE AFECTA 60-69 PORCIENTO DE LA SUPERFICIE CORPORAL"
  },
  {
    "codigo":11835711000119106,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN METATARSOFALÁNGICA DE DEDO GORDO IZQUIERDO"
  },
  {
    "codigo":243024005,
    "descripcion":"LESIÓN POR FRAGMENTO DE BOMBA CASERA"
  },
  {
    "codigo":110117000,
    "descripcion":"LACERACIÓN COMPLEJA CONTAMINADA DE LA ENCÍA ALVEOLAR DE LA MANDÍBULA"
  },
  {
    "codigo":79184009,
    "descripcion":"VEJIGA URINARIA TRABECULADA"
  },
  {
    "codigo":208421008,
    "descripcion":"FRACTURA EXPUESTA INTRARTICULAR DE BASE DE METACARPIANO DE PULGAR, ROLANDO"
  },
  {
    "codigo":403194002,
    "descripcion":"ERITEMA SOLAR"
  },
  {
    "codigo":42746002,
    "descripcion":"GONORREA DEL RECTO"
  },
  {
    "codigo":16668991000119109,
    "descripcion":"FRACTURA NO EXPUESTA DE PARED INTERNA DE ÓRBITA DERECHA"
  },
  {
    "codigo":206586007,
    "descripcion":"INSUFICIENCIA CARDÍACA CONGÉNITA"
  },
  {
    "codigo":1156858008,
    "descripcion":"OFTALMOPLEJÍA EXTERNA PROGRESIVA AUTOSÓMICA DOMINANTE TIPO 2"
  },
  {
    "codigo":303055001,
    "descripcion":"LINFOMA MALIGNO, CÉLULA DEL CENTRO FOLICULAR"
  },
  {
    "codigo":237519003,
    "descripcion":"HIPOTIROIDISMO AUTOINMUNITARIO"
  },
  {
    "codigo":40911008,
    "descripcion":"DERMATOFITOSIS DISEMINADA"
  },
  {
    "codigo":1251492001,
    "descripcion":"METÁSTASIS DE CARCINOMA DE LABIO"
  },
  {
    "codigo":301220002,
    "descripcion":"POSICIÓN DE LAS CUERDAS VOCALES EN REPOSO, NORMAL"
  },
  {
    "codigo":71844000,
    "descripcion":"INFECCIÓN CAUSADA POR STRONGYLOIDES RATTI"
  },
  {
    "codigo":235684006,
    "descripcion":"NECROSIS DE CURVATURA MENOR POSVAGOTOMÍA"
  },
  {
    "codigo":170148006,
    "descripcion":"EXAMEN DEL NIÑO A LOS 2.5 AÑOS: ANORMAL - EN TRATAMIENTO"
  },
  {
    "codigo":399524008,
    "descripcion":"TUMOR QUE INVADE EL IRIS"
  },
  {
    "codigo":202916009,
    "descripcion":"TENOSINOVITIS DE EXTENSOR DEL PULGAR"
  },
  {
    "codigo":340441000119107,
    "descripcion":"TRASTORNO DE RETINA IZQUIERDA CONCOMITANTE CON HIPERTENSIÓN Y DEBIDO A ELLA"
  },
  {
    "codigo":364921001,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA LEVANTARSE DESDE POSICIÓN DE CUCLILLAS SIN USAR LAS MANOS"
  },
  {
    "codigo":4473006,
    "descripcion":"MIGRAÑA CON AURA"
  },
  {
    "codigo":299385007,
    "descripcion":"ARTICULACIÓN DE LA RODILLA TIBIA AL TACTO"
  },
  {
    "codigo":233849007,
    "descripcion":"ENFERMEDAD VALVULAR SIFILÍTICA"
  },
  {
    "codigo":166478001,
    "descripcion":"NIVEL DE CORTISOL DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":461390001,
    "descripcion":"INSERCIÓN ANÓMALA DE CONDUCTO ARTERIOSO EN LOCALIZACIÓN DESCONOCIDA"
  },
  {
    "codigo":2638001,
    "descripcion":"HIPERCALCEMIA CAUSADA POR FÁRMACO"
  },
  {
    "codigo":10963571000119103,
    "descripcion":"LACERACIÓN DE DEDO ÍNDICE DERECHO"
  },
  {
    "codigo":232014008,
    "descripcion":"RETINOQUISIS MACULAR Y PERIFÉRICA"
  },
  {
    "codigo":230179001,
    "descripcion":"ENCEFALITIS VIRAL CRÓNICA"
  },
  {
    "codigo":721699002,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE COLON DESCENDENTE Y ÁNGULO ESPLÉNICO"
  },
  {
    "codigo":295715005,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE PENTOSTATINA"
  },
  {
    "codigo":262947007,
    "descripcion":"ANEURISMA DE VENA TRASPLANTADA"
  },
  {
    "codigo":424952003,
    "descripcion":"SARCOMA DE PARTES BLANDAS"
  },
  {
    "codigo":293880004,
    "descripcion":"ALERGIA A AMILOBARBITAL"
  },
  {
    "codigo":228344004,
    "descripcion":"INCAPAZ DE PARAR DE TOMAR ANTES DE INTOXICARSE"
  },
  {
    "codigo":95437004,
    "descripcion":"EDEMA PULMONAR NO CARDIOGÉNICO"
  },
  {
    "codigo":128205005,
    "descripcion":"NEUROPATÍA SENSITIVA Y AUTÓNOMA HEREDITARIA"
  },
  {
    "codigo":783565007,
    "descripcion":"TRASTORNO LINFOPROLIFERATIVO INDOLENTE DE LINFOCITOS T DEL TRACTO GASTROINTESTINAL"
  },
  {
    "codigo":292045009,
    "descripcion":"REACCIÓN ADVERSA A ANALGÉSICOS OPIÁCEOS"
  },
  {
    "codigo":290210003,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR FENOPERIDINA"
  },
  {
    "codigo":716194005,
    "descripcion":"SÍNDROME DE PELO RETORCIDO CON RETRASO DEL DESARROLLO Y ANOMALÍA NEUROLÓGICA"
  },
  {
    "codigo":93602005,
    "descripcion":"OSIFICACIÓN INCOMPLETA DEL OMÓPLATO"
  },
  {
    "codigo":419447004,
    "descripcion":"REACCIÓN ALÉRGICA CAUSADA POR POLVO DE HARINA"
  },
  {
    "codigo":124535005,
    "descripcion":"DEFICIENCIA DE NUCLEÓTIDO PIROFOSFATASA"
  },
  {
    "codigo":288375004,
    "descripcion":"CAPAZ DE PASAR PÁGINAS"
  },
  {
    "codigo":778060000,
    "descripcion":"LEUCOENCEFALOPATÍA VASCULAR FAMILIAR RELACIONADA CON CADENAS ALFA 1 DEL COLÁGENO TIPO IV"
  },
  {
    "codigo":253772005,
    "descripcion":"MALFORMACIÓN ANORRECTAL BAJA"
  },
  {
    "codigo":712524006,
    "descripcion":"ARTRITIS BACTERIANA DE ARTICULACIÓN ATLOAXOIDEA"
  },
  {
    "codigo":286540008,
    "descripcion":"ALIMENTA LOS ALIMENTOS HIGIÉNICAMENTE"
  },
  {
    "codigo":1234977001,
    "descripcion":"TRASTORNO NEONATAL DEBIDO A VÁRICES DE CORDÓN UMBILICAL"
  },
  {
    "codigo":448545005,
    "descripcion":"EFECTO DE ARIAS-STELLA EN EL ENDOMETRIO"
  },
  {
    "codigo":284705007,
    "descripcion":"ARRANCARSE EL RECTO"
  },
  {
    "codigo":250102002,
    "descripcion":"RODILLA INESTABLE"
  },
  {
    "codigo":446710005,
    "descripcion":"NEOPLASIA INTRAEPITELIAL PROSTÁTICA DE BAJO GRADO"
  },
  {
    "codigo":1264075004,
    "descripcion":"TRASTORNO NEONATAL CAUSADO POR NARCÓTICO TRANSMITIDO POR LECHE MATERNA"
  },
  {
    "codigo":281035006,
    "descripcion":"VISTO POR UN PROFESIONAL"
  },
  {
    "codigo":1296843006,
    "descripcion":"CRISIS GLAUCOMATOCICLÍTICA DE OJO DERECHO"
  },
  {
    "codigo":770720005,
    "descripcion":"PARAPLEJÍA ESPÁSTICA AUTOSÓMICA RECESIVA TIPO 58"
  },
  {
    "codigo":16782401000119100,
    "descripcion":"CARCINOMA BASOCELULAR PRIMARIO DE PIEL DE ANO"
  },
  {
    "codigo":10966081000119100,
    "descripcion":"LACERACIÓN DE TOBILLO DERECHO"
  },
  {
    "codigo":15717441000119101,
    "descripcion":"OSTEOCONDRITIS DISECANTE DE AMBOS CODOS"
  },
  {
    "codigo":1260405004,
    "descripcion":"HEMICOREA DEBIDA A HEMORRAGIA CEREBRAL"
  },
  {
    "codigo":11785281000119101,
    "descripcion":"AMPOLLA TRAUMÁTICA DE DEDO ANULAR DERECHO"
  },
  {
    "codigo":1293173007,
    "descripcion":"ANEURISMA DE ARTERIA INTRACRANEAL"
  },
  {
    "codigo":277365009,
    "descripcion":"SÍNDROME DE RESECCIÓN TRANSURETRAL"
  },
  {
    "codigo":406602003,
    "descripcion":"INFECCIÓN CAUSADA POR STAPHYLOCOCCUS AUREUS"
  },
  {
    "codigo":472138004,
    "descripcion":"TORTUOSIDAD ADQUIRIDA DE RAMA DEL CAYADO AÓRTICO"
  },
  {
    "codigo":46154005,
    "descripcion":"VOLUMEN ESPIRATORIO FORZADO DISMINUIDO"
  },
  {
    "codigo":15989671000119109,
    "descripcion":"ESTRABISMO RESTRICTIVO BILATERAL DEBIDO A FIBROSIS ORBITARIA"
  },
  {
    "codigo":373834005,
    "descripcion":"CAMBIO EN LA QUIMIOTERAPIA - TOXICIDAD AGUDA POR QUIMIOTERAPIA"
  },
  {
    "codigo":275530009,
    "descripcion":"EXTREMIDAD AMPUTADA"
  },
  {
    "codigo":13386009,
    "descripcion":"ABSCESO EMBÓLICO INTRAESPINAL"
  },
  {
    "codigo":109855006,
    "descripcion":"MESOTELIOMA DEL PERITONEO PÉLVICO"
  },
  {
    "codigo":371999007,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL TERCIO MEDIO DEL ESÓFAGO"
  },
  {
    "codigo":208159009,
    "descripcion":"FRACTURA EXPUESTA DE ACETÁBULO, PISO"
  },
  {
    "codigo":1287668002,
    "descripcion":"TUMOR NEUROENDOCRINO BIEN DIFERENCIADO PRIMARIO DE ESTÓMAGO"
  },
  {
    "codigo":75252003,
    "descripcion":"RALES INSPIRATORIOS"
  },
  {
    "codigo":271860004,
    "descripcion":"MASA ABDOMINAL"
  },
  {
    "codigo":239092005,
    "descripcion":"PUSTULOSIS NEONATAL TRANSITORIA"
  },
  {
    "codigo":206324006,
    "descripcion":"ACROCIANOSIS NEONATAL"
  },
  {
    "codigo":402932005,
    "descripcion":"INFECCIÓN UNGUEAL POR PSEUDOMONAS AERUGINOSA"
  },
  {
    "codigo":1254900006,
    "descripcion":"DERMATITIS FOTOTÓXICA OCUPACIONAL CAUSADA POR MATERIAL VEGETAL"
  },
  {
    "codigo":42484009,
    "descripcion":"ANEMIA HEMOLÍTICA NO ESFEROCÍTICA HEREDITARIA POR DEFICIENCIA DE HEXOCINASA"
  },
  {
    "codigo":237257002,
    "descripcion":"CONTRACCIÓN PÉLVICA MEDIA"
  },
  {
    "codigo":269064009,
    "descripcion":"FRACTURA NO EXPUESTA DEL AXIS"
  },
  {
    "codigo":1187529000,
    "descripcion":"DEFICIENCIA DE PEX10"
  },
  {
    "codigo":7881005,
    "descripcion":"PANCREATITIS NECROSANTE AGUDA"
  },
  {
    "codigo":300958000,
    "descripcion":"RECONCILIACIÓN CON LA PAREJA"
  },
  {
    "codigo":268190004,
    "descripcion":"ANEURISMA PERIFÉRICO CONGÉNITO"
  },
  {
    "codigo":366494006,
    "descripcion":"HALLAZGO RELACIONADO CON LA AMPLITUD DE MOVIMIENTO PASIVO DE CIRCUNDUCCIÓN DE HOMBRO"
  },
  {
    "codigo":102515001,
    "descripcion":"ANCIANO SANO"
  },
  {
    "codigo":266355005,
    "descripcion":"ENFISEMA BULLOSO CON ATELECTASIA"
  },
  {
    "codigo":297288000,
    "descripcion":"CÁLCULO HEPÁTICO"
  },
  {
    "codigo":299123009,
    "descripcion":"TUMEFACCIÓN DE ARTICULACIÓN DE DEDO DE MANO"
  },
  {
    "codigo":428360003,
    "descripcion":"ARTROPATÍA DE ARTICULACIÓN DE LA MANO"
  },
  {
    "codigo":35144003,
    "descripcion":"ASPIRACIÓN DE DIENTE O MATERIAL DENTAL"
  },
  {
    "codigo":1149256005,
    "descripcion":"ATENCIÓN POSNATAL COMPARTIDA"
  },
  {
    "codigo":426525004,
    "descripcion":"TAQUICARDIA VENTRICULAR SOSTENIDA"
  },
  {
    "codigo":295453004,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE LAXANTE DE VOLUMEN"
  },
  {
    "codigo":721437008,
    "descripcion":"LESIÓN COMPLETA DE MÉDULA ESPINAL AL NIVEL DEL OCTAVO SEGMENTO DORSAL"
  },
  {
    "codigo":129778000,
    "descripcion":"LOCALIZACIÓN EN HORA 7 EN LA MAMOGRAFÍA"
  },
  {
    "codigo":293618002,
    "descripcion":"ALERGIA A FLURBIPROFENO"
  },
  {
    "codigo":719602003,
    "descripcion":"HALLAZGO RADIOLÓGICO DE INVASIÓN NEOPLÁSICA QUE PENETRA LA SEROSA DEL COLON"
  },
  {
    "codigo":162546005,
    "descripcion":"COME EN RESTAURANTES DE COMIDAS RÁPIDAS"
  },
  {
    "codigo":31474007,
    "descripcion":"ABSCESO CRÓNICO DEL PARAMETRIO"
  },
  {
    "codigo":291783001,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR TIOURACILO"
  },
  {
    "codigo":421020000,
    "descripcion":"MICROSPORIDIOSIS ASOCIADA CON SÍNDROME DE INMUNODEFICIENCIA ADQUIRIDA"
  },
  {
    "codigo":93340001,
    "descripcion":"POSICIÓN ANÓMALA CONGÉNITA DE NARIZ"
  },
  {
    "codigo":717767009,
    "descripcion":"SÍNDROME DE ALPORT AUTOSÓMICO RECESIVO"
  },
  {
    "codigo":95175009,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE BORDE BERMELLÓN DE LABIO"
  },
  {
    "codigo":11814261000119107,
    "descripcion":"RUPTURA DE LIGAMENTO DE DEDO MEÑIQUE DE MANO IZQUIERDA"
  },
  {
    "codigo":124273008,
    "descripcion":"DEFICIENCIA DE TIMIDINA FOSFORILASA"
  },
  {
    "codigo":351814001,
    "descripcion":"SANGRADO INTERMENSTRUAL PROFUSO"
  },
  {
    "codigo":286278006,
    "descripcion":"NO ARTICULA PALABRAS"
  },
  {
    "codigo":187974007,
    "descripcion":"NEOPLASIA MALIGNA DEL SEGUNDO METATARSIANO"
  },
  {
    "codigo":417350008,
    "descripcion":"CONDUCTA ALTERADA"
  },
  {
    "codigo":253510008,
    "descripcion":"HIPOPLASIA CONGÉNITA DE MÚSCULO PAPILAR DE VÁLVULA AURICULOVENTRICULAR IZQUIERDA"
  },
  {
    "codigo":1201947005,
    "descripcion":"ESCLEROSIS LATERAL AMIOTRÓFICA JUVENIL TIPO 2"
  },
  {
    "codigo":251675006,
    "descripcion":"DESACELERACIÓN TARDÍA DE LA FRECUENCIA CARDÍACA FETAL"
  },
  {
    "codigo":282608001,
    "descripcion":"INCAPAZ DE GATEAR"
  },
  {
    "codigo":708592001,
    "descripcion":"RESTAURACIÓN DENTAL COLOREADA NO METÁLICA PRESENTE"
  },
  {
    "codigo":413680005,
    "descripcion":"HALLAZGO RELACIONADO CON HIERRO EN LA MÉDULA ÓSEA"
  },
  {
    "codigo":444613000,
    "descripcion":"TRASTORNO DE HIPERACTIVIDAD Y DÉFICIT DE ATENCIÓN DEL ADULTO"
  },
  {
    "codigo":315376008,
    "descripcion":"NACIDO EN AZERBAIYÁN"
  },
  {
    "codigo":248005005,
    "descripcion":"PELEA"
  },
  {
    "codigo":49562005,
    "descripcion":"GANGLIOSIDOSIS GM 2 CRÓNICA DEL ADULTO"
  },
  {
    "codigo":442778006,
    "descripcion":"TUMEFACCIÓN BILATERAL DE AMÍGDALAS"
  },
  {
    "codigo":292521000119104,
    "descripcion":"NEURALGIA DE NERVIO DE MIEMBRO INFERIOR DERECHO"
  },
  {
    "codigo":1260143005,
    "descripcion":"SÍNDROME DE MEGALENCEFALIA, CIFOESCOLIOSIS GRAVE Y SOBRECRECIMIENTO"
  },
  {
    "codigo":735855006,
    "descripcion":"LACERACIÓN DE VENA POPLÍTEA"
  },
  {
    "codigo":211567005,
    "descripcion":"LESIÓN TRAUMÁTICA ABIERTA POR APLASTAMIENTO EN REGIÓN DE CODO"
  },
  {
    "codigo":439108000,
    "descripcion":"LESIÓN DENTAL POR FRICCIÓN EXTENDIDA HASTA LA PULPA"
  },
  {
    "codigo":80495009,
    "descripcion":"SONAMBULISMO"
  },
  {
    "codigo":209732002,
    "descripcion":"SECCIÓN EXPUESTA DE LIGAMENTO SACRO"
  },
  {
    "codigo":734020000,
    "descripcion":"ATAXIA ESPINOCEREBELOSA TIPO 40"
  },
  {
    "codigo":699417003,
    "descripcion":"MANDÍBULA SOBRESALIENTE"
  },
  {
    "codigo":44057004,
    "descripcion":"PÉRDIDA DE LA AUDICIÓN CONDUCTIVA"
  },
  {
    "codigo":207897005,
    "descripcion":"FRACTURA NO EXPUESTA DEL AXIS, APÓFISIS ODONTOIDES"
  },
  {
    "codigo":240665008,
    "descripcion":"INFECCIÓN COCCIDIAL NO INTESTINAL"
  },
  {
    "codigo":109593008,
    "descripcion":"SENSIBILIDAD DENTAL AL CALOR"
  },
  {
    "codigo":15693481000119109,
    "descripcion":"QUERATITIS BILATERAL CAUSADA POR MYCOBACTERIUM"
  },
  {
    "codigo":74990005,
    "descripcion":"DISACUSIA"
  },
  {
    "codigo":238830006,
    "descripcion":"ANETODERMIA SECUNDARIA"
  },
  {
    "codigo":402670007,
    "descripcion":"LINFEDEMA DE MIEMBROS POR INMOVILIDAD, DEPENDENCIA CRÓNICA Y\/O INSUFICIENCIA"
  },
  {
    "codigo":73155008,
    "descripcion":"PULSO PERIFÉRICO ANORMAL"
  },
  {
    "codigo":300696001,
    "descripcion":"UTILIZA UNA CUENTA FINANCIERA"
  },
  {
    "codigo":202392002,
    "descripcion":"DERRAME ARTICULAR AGUDO"
  },
  {
    "codigo":40387008,
    "descripcion":"SÍNDROME DE ERITROCITO POLIAGLUTINABLE"
  },
  {
    "codigo":735752002,
    "descripcion":"LESIÓN TRAUMÁTICA DE PLEXO HIPOGÁSTRICO"
  },
  {
    "codigo":431768007,
    "descripcion":"MALFORMACIÓN CONGÉNITA DEL ALA DEL ESFENOIDES"
  },
  {
    "codigo":167789000,
    "descripcion":"ESPERMATOZOIDES INMÓVILES A LAS 6-8 HORAS"
  },
  {
    "codigo":366232009,
    "descripcion":"REACCIÓN PRIMARIA AL CAMINAR - HALLAZGO"
  },
  {
    "codigo":298861004,
    "descripcion":"CREPITACIÓN AUDIBLE DE ARTICULACIÓN DE HOMBRO"
  },
  {
    "codigo":266093005,
    "descripcion":"GANGRENA GASEOSA POR CLOSTRIDIUM PERFRINGENS"
  },
  {
    "codigo":724845009,
    "descripcion":"CONDUCTA DE RASCADO COMPULSIVO"
  },
  {
    "codigo":2114004,
    "descripcion":"INFECCIÓN CAUSADA POR CYSTICERCUS PISIFORMIS"
  },
  {
    "codigo":723010005,
    "descripcion":"ERUPCIÓN CUTÁNEA AGUDA"
  },
  {
    "codigo":428098006,
    "descripcion":"HIPERTROFIA DEL PREPUCIO DEL CLÍTORIS"
  },
  {
    "codigo":264258007,
    "descripcion":"VENA VERTICAL PERSISTENTE"
  },
  {
    "codigo":297026007,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE ÁCIDO ETACRÍNICO"
  },
  {
    "codigo":279001,
    "descripcion":"MIOCARDITIS SENIL"
  },
  {
    "codigo":229655002,
    "descripcion":"DISFASIA MOTORA TRANSCORTICAL"
  },
  {
    "codigo":721175003,
    "descripcion":"ENFERMEDAD GLOMERULAR IDIOPÁTICA"
  },
  {
    "codigo":33047005,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DE CODO"
  },
  {
    "codigo":426263006,
    "descripcion":"INSUFICIENCIA CARDÍACA CONGESTIVA DEBIDA A DISFUNCIÓN SISTÓLICA DEL VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":295191005,
    "descripcion":"SOBREDOSIS INTENCIONAL DE ALFENTANILO"
  },
  {
    "codigo":719340007,
    "descripcion":"RETIRADO DE PROGRAMA DE DESTOXIFICACIÓN ALCOHÓLICA"
  },
  {
    "codigo":94913000,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA ENCÍA INFERIOR"
  },
  {
    "codigo":293356009,
    "descripcion":"REACCIÓN ADVERSA AL COMPLEJO DE HIERRO Y POLISACÁRIDOS"
  },
  {
    "codigo":1145324009,
    "descripcion":"LÍQUIDO PLEURAL TURBIO"
  },
  {
    "codigo":225985003,
    "descripcion":"MOVILIDAD ÓPTIMA"
  },
  {
    "codigo":422593004,
    "descripcion":"INSUFICIENCIA RENAL AGUDA CAUSADA POR INHIBIDOR DE LA ENZIMA CONVERTIDORA DE ANGIOTENSINA"
  },
  {
    "codigo":781206002,
    "descripcion":"ARTRITIS REUMATOIDE DE ARTICULACIÓN DE LA COLUMNA VERTEBRAL"
  },
  {
    "codigo":715670004,
    "descripcion":"DISPLASIA ESPONDILOEPIFISARIA LEVE DEBIDA A MUTACIÓN DE COL2A1 CON ARTROSIS DE COMIENZO TEMPRANO"
  },
  {
    "codigo":289686004,
    "descripcion":"ABDOMEN GESTANTE OVOIDE"
  },
  {
    "codigo":93078006,
    "descripcion":"HIPERTROFIA CONGÉNITA DEL VENTRÍCULO CARDÍACO"
  },
  {
    "codigo":713835001,
    "descripcion":"CONSENTIMIENTO REHUSADO PARA UTILIZACIÓN DE DATOS DEL PACIENTE EN ESTRATIFICACIÓN DE RIESGO PARA ADMISIÓN HOSPITALARIA NO PLANEADA"
  },
  {
    "codigo":191382009,
    "descripcion":"ESPLENOMEGALIA CONGESTIVA CRÓNICA"
  },
  {
    "codigo":124011008,
    "descripcion":"GLUCÓGENO POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":10291000132101,
    "descripcion":"PORCIÓN DE MUCOSA DE SEGMENTO COLÓNICO VISIBLE, PERO OTRAS ÁREAS DEL SEGMENTO COLÓNICO NO SE VISUALIZAN CLARAMENTE DEBIDO A LA PRESENCIA DE TINCIÓN, HECES RESIDUALES Y\/O LÍQUIDO OPACO"
  },
  {
    "codigo":1269056007,
    "descripcion":"LESIÓN DE ARTERIA MESENTÉRICA"
  },
  {
    "codigo":286016007,
    "descripcion":"INCAPAZ DE APAGAR UN ARTEFACTO ELECTRODOMÉSTICO"
  },
  {
    "codigo":318784009,
    "descripcion":"TRASTORNO DE ESTRÉS POSTRAUMÁTICO, INICIO TARDÍO"
  },
  {
    "codigo":415253006,
    "descripcion":"HERNIA DE PARED ANTERIOR DE ABDOMEN RECURRENTE OBSTRUIDA"
  },
  {
    "codigo":249578005,
    "descripcion":"HALLAZGO DE RIÑÓN"
  },
  {
    "codigo":16898321000119103,
    "descripcion":"FRACTURA NO EXPUESTA DE FALANGE DISTAL DE DEDO ANULAR DE MANO DERECHA"
  },
  {
    "codigo":20202008,
    "descripcion":"INTOXICACIÓN POR COUMAFOS"
  },
  {
    "codigo":247743001,
    "descripcion":"ALUCINACIONES SEXUALES"
  },
  {
    "codigo":1263551002,
    "descripcion":"INFLAMACIÓN DE PLEXO LUMBOSACRO"
  },
  {
    "codigo":18367003,
    "descripcion":"ÚLCERA DUODENAL CON HEMORRAGIA Y OBSTRUCCIÓN"
  },
  {
    "codigo":870335005,
    "descripcion":"PANUVEÍTIS CAUSADA POR BORRELIA BURGDORFERI"
  },
  {
    "codigo":704660002,
    "descripcion":"ALTERACIÓN DEL DESARROLLO DEL ADULTO MAYOR"
  },
  {
    "codigo":278676002,
    "descripcion":"INCLINACIÓN BUCAL DE DIENTE - PALATINA-LINGUAL"
  },
  {
    "codigo":444808002,
    "descripcion":"HIPERPLASIA PROSTÁTICA BENIGNA LOCALIZADA"
  },
  {
    "codigo":440681001,
    "descripcion":"ATENDIDO EN CONSULTORIO ESPECIALIZADO EN GENÉTICA"
  },
  {
    "codigo":211305001,
    "descripcion":"ABRASIÓN DE PIEL DE REGIÓN DORSAL DE MANO"
  },
  {
    "codigo":473449006,
    "descripcion":"ENFERMEDAD DE ARTERIA NO CORONARIA SISTÉMICA"
  },
  {
    "codigo":1259881007,
    "descripcion":"CISTOMA ENDOMETRIAL ROTO DE OVARIO"
  },
  {
    "codigo":735593008,
    "descripcion":"DIVERTICULITIS DE INTESTINO"
  },
  {
    "codigo":678161000119108,
    "descripcion":"HIFEMA DE AMBOS OJOS"
  },
  {
    "codigo":897598004,
    "descripcion":"AUSENCIA DE LEUCOCITOS EN ORINA AL EXAMEN MICROSCÓPICO"
  },
  {
    "codigo":42411000087100,
    "descripcion":"LESIÓN TRAUMÁTICA DE TENDÓN DE AQUILES IZQUIERDO"
  },
  {
    "codigo":109331007,
    "descripcion":"ABSCESO DE HUESO TEMPORAL"
  },
  {
    "codigo":1156072000,
    "descripcion":"HALLAZGO SOBRE DISPOSITIVO"
  },
  {
    "codigo":55211000087105,
    "descripcion":"ESTRATEGIAS DE AFRONTAMIENTO INEFECTIVAS"
  },
  {
    "codigo":404243009,
    "descripcion":"MENINGITIS CAUSADA POR VIRUS KEYSTONE"
  },
  {
    "codigo":205800003,
    "descripcion":"SÍNDROME DE GORLIN-CHAUDHRY-MOSS"
  },
  {
    "codigo":34731000087107,
    "descripcion":"CORYNEBACTERIUM MUCIFACIENS O CORYNEBACTERIUM UREICELERIVORANS"
  },
  {
    "codigo":74728003,
    "descripcion":"INSUFICIENCIA HIPOFISARIA"
  },
  {
    "codigo":1287144006,
    "descripcion":"NEVO EPIDÉRMICO PILOSO PIGMENTADO DE PÁRPADO INFERIOR"
  },
  {
    "codigo":39851000087107,
    "descripcion":"HEMATOMA DE TALÓN IZQUIERDO"
  },
  {
    "codigo":16845381000119100,
    "descripcion":"CONDROSARCOMA PRIMARIO DE ESTERNÓN"
  },
  {
    "codigo":402408009,
    "descripcion":"URTICARIA AGUDA"
  },
  {
    "codigo":105661001,
    "descripcion":"ENFERMEDAD CAUSADA POR SCHISTOSOMATIDAE"
  },
  {
    "codigo":369640006,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA DE TESTÍCULO, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":302269003,
    "descripcion":"CAPAZ DE REALIZAR TRASLADOS CON SILLA DE RUEDAS"
  },
  {
    "codigo":236733005,
    "descripcion":"EXTRUSIÓN DE PRÓTESIS DE PENE"
  },
  {
    "codigo":72893007,
    "descripcion":"NEURITIS BRAQUIAL"
  },
  {
    "codigo":431506006,
    "descripcion":"RECHAZO DE TRASPLANTE DE PÁNCREAS"
  },
  {
    "codigo":365970009,
    "descripcion":"COMPAÑÍA MIENTRAS BEBE - HALLAZGO"
  },
  {
    "codigo":724583003,
    "descripcion":"NEOPLASIA OSTEÓGENA BENIGNA DE HUESO DE LA COLUMNA VERTEBRAL"
  },
  {
    "codigo":460604001,
    "descripcion":"ORIGEN ANÓMALO DE CONDUCTO ARTERIOSO EN ARTERIA CARÓTIDA DERECHA"
  },
  {
    "codigo":1148732003,
    "descripcion":"SOBREDOSIS DE XANTINA Y\/O DERIVADO DE XANTINA"
  },
  {
    "codigo":1852004,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO MOTOR OCULAR EXTERNO"
  },
  {
    "codigo":1074701000000101,
    "descripcion":"INCAPAZ DE VALORAR RIESGO"
  },
  {
    "codigo":269533000,
    "descripcion":"CARCINOMA DEL COLON"
  },
  {
    "codigo":198460007,
    "descripcion":"INFERTILIDAD SECUNDARIA DE ORIGEN CERVICAL"
  },
  {
    "codigo":426001001,
    "descripcion":"DEPENDENCIA DE FENTANILO"
  },
  {
    "codigo":296764009,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE OXITETRACICLINA"
  },
  {
    "codigo":131089005,
    "descripcion":"NIVEL DE HORMONA TIROIDEA POR ENCIMA DE RANGO DE REFERENCIA"
  },
  {
    "codigo":294929006,
    "descripcion":"ALERGIA A ÁCIDO NICOTÍNICO"
  },
  {
    "codigo":65553006,
    "descripcion":"ASPERGILOSIS"
  },
  {
    "codigo":293094002,
    "descripcion":"REACCIÓN ADVERSA A LA PERMETRINA"
  },
  {
    "codigo":30950009,
    "descripcion":"DIETA BLANDA, ESTADIO 4"
  },
  {
    "codigo":424166009,
    "descripcion":"INSATISFACCIÓN CON LAS RESPONSABILIDADES DE CUIDADO"
  },
  {
    "codigo":225723003,
    "descripcion":"FUNCIÓN SEXUAL DISMINUIDA"
  },
  {
    "codigo":94651003,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE TESTÍCULO RETENIDO"
  },
  {
    "codigo":125584006,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE LOS MIEMBROS INFERIORES"
  },
  {
    "codigo":1010320009,
    "descripcion":"TRASTORNO NEONATAL DEBIDO A TRASTORNO NUTRICIONAL MATERNO"
  },
  {
    "codigo":58213005,
    "descripcion":"ANGIOMATOSIS BACILAR"
  },
  {
    "codigo":1303397005,
    "descripcion":"FRACTURA ÓSEA DE MUÑECA"
  },
  {
    "codigo":10674911000119108,
    "descripcion":"OTITIS MEDIA CAUSADA POR VIRUS INFLUENZA A"
  },
  {
    "codigo":449594001,
    "descripcion":"AURÍCULA IZQUIERDA DIVIDIDA CON DESEMBOCADURA DE ALGUNAS VENAS PULMONARES EN LA CÁMARA PROXIMAL Y DRENAJE EN LA AURÍCULA IZQUIERDA Y OTRAS CON CONEXIONES ANÓMALAS"
  },
  {
    "codigo":23610003,
    "descripcion":"ANONIQUIA"
  },
  {
    "codigo":416826005,
    "descripcion":"DREPANOCITOSIS-TALASEMIA CON CRISIS HEMOLÍTICA"
  },
  {
    "codigo":252986008,
    "descripcion":"EMBOLIA TUMORAL"
  },
  {
    "codigo":185615004,
    "descripcion":"INFLAMACIÓN EN EL EXTENDIDO CERVICAL - RECONVOCATORIA ANULADA"
  },
  {
    "codigo":283919005,
    "descripcion":"QUEMADURA DE LA URETRA"
  },
  {
    "codigo":414991007,
    "descripcion":"SANGRADO RECTAL DOLOROSO"
  },
  {
    "codigo":11795321000119105,
    "descripcion":"LESIÓN TRAUMÁTICA DE VENA BRAQUIOCEFÁLICA IZQUIERDA"
  },
  {
    "codigo":118244001,
    "descripcion":"HALLAZGO POR PERCUSIÓN"
  },
  {
    "codigo":282084001,
    "descripcion":"QUEMADURA DE CIEGO"
  },
  {
    "codigo":249316004,
    "descripcion":"DESVIACIÓN NASAL"
  },
  {
    "codigo":216548005,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR INHIBIDORES DE LA MONOAMINO OXIDASA"
  },
  {
    "codigo":183780008,
    "descripcion":"INSCRIPTO EN LISTA DE ADMISIÓN ONCOLÓGICA"
  },
  {
    "codigo":313017000,
    "descripcion":"ANHIDRAMNIOS"
  },
  {
    "codigo":1197753005,
    "descripcion":"TRASTORNO CONGÉNITO DE LA GLICOSILACIÓN RELACIONADO CON GEN COG2"
  },
  {
    "codigo":718558008,
    "descripcion":"ACIDURIA MEVALÓNICA"
  },
  {
    "codigo":737166003,
    "descripcion":"INFECCIÓN DE RECTO CAUSADA POR VIRUS HERPES SIMPLE HUMANO"
  },
  {
    "codigo":704398006,
    "descripcion":"FRACTURA EXPUESTA TRANSVERSAL DE ACETÁBULO"
  },
  {
    "codigo":1163150009,
    "descripcion":"CAVITACIÓN PULMONAR CRÓNICA POR ASPERGILLUS"
  },
  {
    "codigo":1259619002,
    "descripcion":"COREA DEBIDA A TRASTORNO METABÓLICO"
  },
  {
    "codigo":440419004,
    "descripcion":"SONDA GASTROINTESTINAL IN SITU"
  },
  {
    "codigo":211043005,
    "descripcion":"ABRASIÓN DE PIEL DE GLÚTEO"
  },
  {
    "codigo":276579007,
    "descripcion":"ANEMIA TARDÍA DEL RECIÉN NACIDO"
  },
  {
    "codigo":702563008,
    "descripcion":"FARMACOTERAPIA NO DECLARADA"
  },
  {
    "codigo":407651009,
    "descripcion":"EVALUACIÓN DEL RIESGO AMBIENTAL OMITIDA"
  },
  {
    "codigo":241976004,
    "descripcion":"EBULLISMO"
  },
  {
    "codigo":671491000124101,
    "descripcion":"INCAPAZ DE OBTENER SERVICIO TELEFÓNICO DEBIDO A RECURSOS ECONÓMICOS LIMITADOS"
  },
  {
    "codigo":274744005,
    "descripcion":"GANGLIOS LINFÁTICOS LOCALIZADOS AGRANDADOS"
  },
  {
    "codigo":373048006,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM NOVOCASTRENSE"
  },
  {
    "codigo":209208008,
    "descripcion":"SUBLUXACIÓN EXPUESTA DEL SACRO"
  },
  {
    "codigo":540931000124106,
    "descripcion":"MASA DE MUCOSA YUGAL"
  },
  {
    "codigo":698893002,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: KHMER CENTRAL"
  },
  {
    "codigo":403981003,
    "descripcion":"HEMANGIOENDOTELIOMA EPITELIOIDE"
  },
  {
    "codigo":1255949009,
    "descripcion":"EFECTO TÓXICO DE JABÓN"
  },
  {
    "codigo":762594002,
    "descripcion":"DOLOR CRÓNICO POSTERIOR A PROCEDIMIENTO QUIRÚRGICO POR CÁNCER"
  },
  {
    "codigo":76301009,
    "descripcion":"CIRROSIS FLORIDA"
  },
  {
    "codigo":269239000,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO SUPERFICIAL DE FRENTE"
  },
  {
    "codigo":402146009,
    "descripcion":"DERMATOSIS CAUSADA POR PULGA"
  },
  {
    "codigo":236471003,
    "descripcion":"UMBRAL RENAL BAJO PARA LA GLUCOSA"
  },
  {
    "codigo":302007006,
    "descripcion":"OPONE LOS PULGARES"
  },
  {
    "codigo":170935008,
    "descripcion":"ASISTENCIA COMPLETA EN CENTRO DE CUIDADOS PALIATIVOS"
  },
  {
    "codigo":7095009,
    "descripcion":"INFECCIÓN CAUSADA POR LENTOSPORA"
  },
  {
    "codigo":300172005,
    "descripcion":"MARTILLO: ANORMAL"
  },
  {
    "codigo":365708008,
    "descripcion":"HALLAZGO RELACIONADO CON LA PRESENCIA DE BRUCELLA"
  },
  {
    "codigo":234636008,
    "descripcion":"MONOSOMÍA 22 Y AUSENCIA DE INMUNOGLOBULINA A"
  },
  {
    "codigo":298337002,
    "descripcion":"HALLAZGO RELACIONADO CON LA FUNCIÓN MOTORA LOCAL"
  },
  {
    "codigo":36193003,
    "descripcion":"SÍNDROME DE EMBRIOPATÍA POR TALIDOMIDA"
  },
  {
    "codigo":265569002,
    "descripcion":"ENFERMEDAD OCULAR DE ALAND Y ALBINISMO OCULAR"
  },
  {
    "codigo":1217676009,
    "descripcion":"CONTRAPULSIÓN OCULAR"
  },
  {
    "codigo":167265006,
    "descripcion":"PRUEBA DE GLUCOSA EN ORINA = ++"
  },
  {
    "codigo":198198001,
    "descripcion":"ENFERMEDADES INFLAMATORIAS CERVICALES, VAGINALES Y VULVARES"
  },
  {
    "codigo":165430007,
    "descripcion":"ÍNDICE DE COLOR ERITROCÍTICO DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1179403004,
    "descripcion":"ASTEATOSIS CUTÁNEA CAUSADA POR MYCOBACTERIUM LEPRAE"
  },
  {
    "codigo":294667007,
    "descripcion":"ALERGIA A TOXINA DE CLOSTRIDIUM BOTULINUM"
  },
  {
    "codigo":425739008,
    "descripcion":"DIARREA DE BRAINERD"
  },
  {
    "codigo":63456003,
    "descripcion":"LUXACIÓN EXPUESTA ANTERIOR DEL EXTREMO PROXIMAL DE LA TIBIA"
  },
  {
    "codigo":784352007,
    "descripcion":"DISTROFIA MUSCULAR ESCAPULOPERONEA LIGADA AL CROMOSOMA X"
  },
  {
    "codigo":94389000,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA COLUMNA VERTEBRAL LUMBAR"
  },
  {
    "codigo":127157001,
    "descripcion":"LINFADENOPATÍA APENDICULAR"
  },
  {
    "codigo":292832009,
    "descripcion":"REACCIÓN ADVERSA A LA DIDANOSINA"
  },
  {
    "codigo":15703521000119101,
    "descripcion":"CONTRACTURA DE TENDÓN DE AQUILES IZQUIERDO"
  },
  {
    "codigo":289162002,
    "descripcion":"HALLAZGO RELACIONADO CON LA MAGNITUD DEL APETITO"
  },
  {
    "codigo":92554002,
    "descripcion":"CARCINOMA IN SITU DE BRONQUIO DEL LÓBULO INFERIOR DERECHO DEL PULMÓN"
  },
  {
    "codigo":59786004,
    "descripcion":"TOS DE LOS TEJEDORES"
  },
  {
    "codigo":715146002,
    "descripcion":"INFECCIÓN CAUSADA POR PENICILLIUM CHRYSOGENUM"
  },
  {
    "codigo":254559002,
    "descripcion":"CARCINOMA DEL ANTRO PILÓRICO"
  },
  {
    "codigo":1335903005,
    "descripcion":"ANTICUERPO CONTRA VIRUS HERPES SIMPLE HUMANO DETECTADO"
  },
  {
    "codigo":1268532006,
    "descripcion":"CARCINOMA PRIMARIO DE AMPOLLA DE VATER"
  },
  {
    "codigo":1332233000,
    "descripcion":"INCONGRUENCIA DE GÉNERO EN LA VIDA ADULTA"
  },
  {
    "codigo":185353001,
    "descripcion":"FECHA DE CITACIÓN"
  },
  {
    "codigo":285492008,
    "descripcion":"INCAPAZ DE SELLAR LOS LABIOS"
  },
  {
    "codigo":283657007,
    "descripcion":"HERIDA POR PINCHAZO DE CLAVO EN EL BRAZO"
  },
  {
    "codigo":87049008,
    "descripcion":"TRASTORNO DEL METABOLISMO DEL FÓSFORO"
  },
  {
    "codigo":609502001,
    "descripcion":"INTERRUPCIÓN INDUCIDA DEL EMBARAZO COMPLICADA POR PERFORACIÓN DE TEJIDO PERIURETRAL"
  },
  {
    "codigo":871646007,
    "descripcion":"MIOCARDIOPATÍA INFILTRANTE"
  },
  {
    "codigo":1363166008,
    "descripcion":"DIENTE NO FUNCIONAL"
  },
  {
    "codigo":247219000,
    "descripcion":"ATROFIA DE UN SECTOR DE LA PAPILA ÓPTICA"
  },
  {
    "codigo":443827002,
    "descripcion":"HERNIA DE ESTRUCTURA DE CAVIDAD CORPORAL"
  },
  {
    "codigo":16237381000119100,
    "descripcion":"DISFUNCIÓN DE GLÁNDULA DE MEIBOMIO DE OJO DERECHO"
  },
  {
    "codigo":15930181000119101,
    "descripcion":"EDEMA DE ESTROMA DE CÓRNEA DERECHA"
  },
  {
    "codigo":10851141000119101,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR AGENTE PSICOTRÓPICO"
  },
  {
    "codigo":303941000119103,
    "descripcion":"GOTA TOFÁCEA CRÓNICA DE CADERA DEBIDA A DISFUNCIÓN RENAL"
  },
  {
    "codigo":15973701000119104,
    "descripcion":"PARESTESIA DE EXTREMIDAD SUPERIOR DERECHA"
  },
  {
    "codigo":16442181000119104,
    "descripcion":"DOLOR PERIORBITARIO DE OJO DERECHO"
  },
  {
    "codigo":10835781000119105,
    "descripcion":"EMBOLIA DE LÍQUIDO AMNIÓTICO DURANTE EL NACIMIENTO"
  },
  {
    "codigo":332101000119100,
    "descripcion":"DESPRENDIMIENTO SEROSO DE RETINA DE OJO DERECHO"
  },
  {
    "codigo":355141000119106,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE PIEL DE EXTREMIDAD SUPERIOR DERECHA"
  },
  {
    "codigo":140101000119109,
    "descripcion":"HIPERTENSIÓN EN ENFERMEDAD RENAL CRÓNICA EN ESTADIO 5 DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":367941000119109,
    "descripcion":"ESTRECHEZ DE URETRA MEMBRANOSA CONSECUTIVA A PROCEDIMIENTO"
  },
  {
    "codigo":441992007,
    "descripcion":"ALERGIA A REMIFENTANILO"
  },
  {
    "codigo":866141000,
    "descripcion":"INFECCIÓN DE ESTÓMAGO CAUSADA POR ANISAKIS MARINA"
  },
  {
    "codigo":276317001,
    "descripcion":"CONTRACCIÓN DEL FÓRNIX CONJUNTIVAL"
  },
  {
    "codigo":91461000119108,
    "descripcion":"TRASTORNO DEL RITMO CIRCADIANO CAUSADO POR FÁRMACO"
  },
  {
    "codigo":15948101000119108,
    "descripcion":"ÚLCERA DE PANTORRILLA IZQUIERDA DEBIDA A SÍNDROME POSTROMBÓTICO"
  },
  {
    "codigo":309085000,
    "descripcion":"UÑA DEL DEDO DEL PIE ENGROSADA"
  },
  {
    "codigo":278152006,
    "descripcion":"GRUPO SANGUÍNEO A RH(D) NEGATIVO"
  },
  {
    "codigo":1259357007,
    "descripcion":"CARCINOMA PRIMARIO DE DUODENO"
  },
  {
    "codigo":208946000,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE LA ARTICULACIÓN DE LA RODILLA, ANTERIOR"
  },
  {
    "codigo":77874001,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN REGIÓN DE HOMBRO, CON INFECCIÓN"
  },
  {
    "codigo":331541000119102,
    "descripcion":"LAGOFTALMÍA PARALÍTICA DE PÁRPADO SUPERIOR DERECHO"
  },
  {
    "codigo":733234003,
    "descripcion":"MORDEDURA ABIERTA DE ANTEBRAZO"
  },
  {
    "codigo":405554005,
    "descripcion":"ABSCESO DE RAÍZ AÓRTICA"
  },
  {
    "codigo":1290290008,
    "descripcion":"ACTITUD COOPERATIVA"
  },
  {
    "codigo":10503001,
    "descripcion":"VOZ NORMAL"
  },
  {
    "codigo":370951003,
    "descripcion":"LENTE INTRAOCULAR TIPO PIGGYBACK COLOCADA"
  },
  {
    "codigo":403719004,
    "descripcion":"ACNÉ POR FOTOQUIMIOTERAPIA CON PSORALENO Y RADIACIÓN ULTRAVIOLETA DE ONDA LARGA"
  },
  {
    "codigo":76039005,
    "descripcion":"TRASTORNO DE LA ATENCIÓN"
  },
  {
    "codigo":1255687003,
    "descripcion":"ENFERMEDAD DE HODGKIN CON DEPLECIÓN DE LINFOCITOS DE GANGLIOS LINFÁTICOS DE CABEZA Y CUELLO"
  },
  {
    "codigo":762332000,
    "descripcion":"TRASTORNO OBSESIVO COMPULSIVO CAUSADO POR ESTIMULANTE"
  },
  {
    "codigo":205276002,
    "descripcion":"SINOSTOSIS DE HUESO SEMILUNAR-PIRAMIDAL"
  },
  {
    "codigo":238044004,
    "descripcion":"MUCOPOLISACARIDOSIS, TIPO IVB"
  },
  {
    "codigo":301745000,
    "descripcion":"REALIZA ACTIVIDADES DE TECNOLOGÍA INFORMÁTICA"
  },
  {
    "codigo":72369006,
    "descripcion":"LINGUATULIASIS NASOFARÍNGEA"
  },
  {
    "codigo":4998000,
    "descripcion":"APENDICITIS OBSTRUCTIVA AGUDA"
  },
  {
    "codigo":70534000,
    "descripcion":"SECUENCIA DE DISRAFISMO ESPINAL OCULTO"
  },
  {
    "codigo":365446002,
    "descripcion":"HALLAZGO RELACIONADO CON EL VOLUMEN DEL ESPUTO"
  },
  {
    "codigo":299910003,
    "descripcion":"HALLAZGO RELACIONADO CON LA SENSIBILIDAD AL TACTO LIGERO"
  },
  {
    "codigo":103302002,
    "descripcion":"VÉRTIGO DURANTE EL INTENTO DE ORINAR"
  },
  {
    "codigo":37766004,
    "descripcion":"DIURESIS ACUOSA"
  },
  {
    "codigo":168838006,
    "descripcion":"ENEMA DE BARIO: NORMAL"
  },
  {
    "codigo":724059003,
    "descripcion":"NEOPLASIA MALIGNA DE LÓBULO INFERIOR DE PULMÓN IZQUIERDO"
  },
  {
    "codigo":298075005,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE LA AXILA"
  },
  {
    "codigo":3163006,
    "descripcion":"CONJUNTIVITIS FOLICULAR ADENOVIRAL AGUDA"
  },
  {
    "codigo":429147006,
    "descripcion":"ALIVIO DEL DOLOR RELACIONADO CON LA POSICIÓN"
  },
  {
    "codigo":16908361000119101,
    "descripcion":"CARCINOMA ESCAMOCELULAR IN SITU DE PIEL DE PÁRPADO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":294405006,
    "descripcion":"ALERGIA A HIDRARGAFENO"
  },
  {
    "codigo":10626991000119108,
    "descripcion":"FORÚNCULO DE DEDO DE PIE DERECHO"
  },
  {
    "codigo":292570003,
    "descripcion":"REACCIÓN ADVERSA A LA TERFENADINA"
  },
  {
    "codigo":718554005,
    "descripcion":"SÍNDROME DE PLAQUETAS GIGANTES DE MEDICH"
  },
  {
    "codigo":63194008,
    "descripcion":"INFECCIÓN CAUSADA POR CLOSTRIDIUM NOVYI"
  },
  {
    "codigo":1144538009,
    "descripcion":"HIPOPLASIA CONGÉNITA DE ARTICULACIÓN CIGOAPOFISARIA DE COLUMNA VERTEBRAL CERVICAL"
  },
  {
    "codigo":126895004,
    "descripcion":"NEOPLASIA DE LOS ÓRGANOS GENITALES MASCULINOS"
  },
  {
    "codigo":421807004,
    "descripcion":"HIPOMOTILIDAD GASTROINTESTINAL"
  },
  {
    "codigo":1306543004,
    "descripcion":"NEOPLASIA MALIGNA CON METÁSTASIS A PORCIÓN CENTRAL DE MAMA"
  },
  {
    "codigo":290735008,
    "descripcion":"INTOXICACIÓN POR PACLITAXEL"
  },
  {
    "codigo":714884000,
    "descripcion":"DIFICULTAD PARA PASAR DE UNA UBICACIÓN A OTRA"
  },
  {
    "codigo":92292002,
    "descripcion":"NEOPLASIA BENIGNA DE FALANGE DE LA MANO"
  },
  {
    "codigo":11802851000119100,
    "descripcion":"ESGUINCE DE LIGAMENTO DE ARTICULACIÓN RADIOCARPIANA DE MUÑECA DERECHA"
  },
  {
    "codigo":419972009,
    "descripcion":"ALERGIA A LOS CAMARONES"
  },
  {
    "codigo":24921003,
    "descripcion":"DISNEA CON BRAZOS ELEVADOS"
  },
  {
    "codigo":1237337007,
    "descripcion":"MIELINIZACIÓN EXTENSA DE FIBRAS NERVIOSAS PERIPAPILARES DE RETINA"
  },
  {
    "codigo":416302000,
    "descripcion":"DERIVACIÓN RÁPIDA DESDE CONSULTORIO ESPECIALIZADO EN ENFERMEDADES MENORES"
  },
  {
    "codigo":713049009,
    "descripcion":"FALLECIDO EN HOSPITAL COMUNITARIO"
  },
  {
    "codigo":287065007,
    "descripcion":"FRACTURA PATOLÓGICA - BRAZO"
  },
  {
    "codigo":15679561000119109,
    "descripcion":"IRITIS DE OJO IZQUIERDO CAUSADA POR TREPONEMA PALLIDUM"
  },
  {
    "codigo":285230004,
    "descripcion":"INCAPAZ DE RECORDAR SONIDOS"
  },
  {
    "codigo":449070007,
    "descripcion":"ARTRITIS INFECCIOSA DE ARTICULACIÓN METATARSOFALÁNGICA DE SEGUNDO A QUINTO DEDO DE PIE"
  },
  {
    "codigo":86787000,
    "descripcion":"CONDROCALCINOSIS CAUSADA POR CRISTALES DE HIDROXIAPATITA DE CALCIO"
  },
  {
    "codigo":840451006,
    "descripcion":"CLINODACTILIA DE DEDOS DE LOS PIES BILATERAL"
  },
  {
    "codigo":283395007,
    "descripcion":"LACERACIÓN DEL TALÓN"
  },
  {
    "codigo":609240002,
    "descripcion":"VIVE EN DEPARTAMENTO DE PLANTA BAJA"
  },
  {
    "codigo":281560004,
    "descripcion":"NEUROBLASTOMA DE CEREBRO"
  },
  {
    "codigo":19416009,
    "descripcion":"ANOMALÍA CONGÉNITA DE OJO"
  },
  {
    "codigo":246957002,
    "descripcion":"OPACIDAD ESTROMAL DE LA CÓRNEA"
  },
  {
    "codigo":52184009,
    "descripcion":"PROBLEMA EN LA RELACIÓN PADRE - HIJO"
  },
  {
    "codigo":771245004,
    "descripcion":"QUEMADURA PROFUNDA DE ESPESOR TOTAL CON COMPROMISO ARTICULAR"
  },
  {
    "codigo":1297368009,
    "descripcion":"LUXACIÓN CONGÉNITA DE ARTICULACIÓN GLENOHUMERAL DERECHA"
  },
  {
    "codigo":334051000119107,
    "descripcion":"XANTOMA DE PÁRPADO INFERIOR DERECHO"
  },
  {
    "codigo":10901731000119108,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO HIPOGLOSO DERECHO"
  },
  {
    "codigo":50349008,
    "descripcion":"INFESTACIÓN CAUSADA POR ARGAS"
  },
  {
    "codigo":410797009,
    "descripcion":"POLIARTRITIS JUVENIL SERONEGATIVA"
  },
  {
    "codigo":277890004,
    "descripcion":"TUMEFACCIÓN DE DEDO DE PIE"
  },
  {
    "codigo":276055001,
    "descripcion":"ACCESO A O DENTRO DE LA RESIDENCIA"
  },
  {
    "codigo":15954301000119104,
    "descripcion":"NECROSIS ADIPOSA DE AMBAS MAMAS"
  },
  {
    "codigo":1259095006,
    "descripcion":"TRASTORNO AUTONÓMICO CAUSADO POR METAL PESADO"
  },
  {
    "codigo":765740002,
    "descripcion":"ADENOSARCOMA DE CUERPO UTERINO"
  },
  {
    "codigo":1290028004,
    "descripcion":"TRASTORNO DE REGIÓN DE OJO DERECHO"
  },
  {
    "codigo":10684951000119100,
    "descripcion":"NÓDULO DEL TEJIDO CELULAR SUBCUTÁNEO DE LA CABEZA"
  },
  {
    "codigo":208684008,
    "descripcion":"FRACTURA NO EXPUESTA DE CABEZA DE ASTRÁGALO"
  },
  {
    "codigo":1222657001,
    "descripcion":"SÍNDROME NEUROLÓGICO ASOCIADO AL GEN PRUNE EXOPOLIFOSFATASA 1"
  },
  {
    "codigo":403457003,
    "descripcion":"RINITIS CONGESTIVA NO ALÉRGICA"
  },
  {
    "codigo":117271000119102,
    "descripcion":"INFECCIÓN CAUSADA POR STREPTOCOCCUS GALLOLYTICUS"
  },
  {
    "codigo":237782001,
    "descripcion":"GLÁNDULA SUPRARRENAL AGRANDADA"
  },
  {
    "codigo":41174002,
    "descripcion":"LINFADENITIS AGUDA EXCEPTO MESENTÉRICA"
  },
  {
    "codigo":270550006,
    "descripcion":"ENFERMEDAD INFLAMATORIA PÉLVICA CAUSADA POR METAMYCOPLASMA HOMINIS"
  },
  {
    "codigo":268715000,
    "descripcion":"TRASTORNO MOTOR DISOCIATIVO"
  },
  {
    "codigo":301483000,
    "descripcion":"DIFICULTAD PARA EVITAR OBSTÁCULOS EN UN CAMINO"
  },
  {
    "codigo":1351894008,
    "descripcion":"CAMPO MIXTO EN TIPIFICACIÓN RHD"
  },
  {
    "codigo":203179003,
    "descripcion":"OSTEOMIELITIS HEMATÓGENA AGUDA"
  },
  {
    "codigo":16910871000119104,
    "descripcion":"NEVO MELANOCÍTICO CONGÉNITO DE PIEL DE PÁRPADO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":235947007,
    "descripcion":"PANCREATITIS POR CITOMEGALOVIRUS"
  },
  {
    "codigo":397952002,
    "descripcion":"TRAUMATISMO PERINEAL DURANTE EL PARTO"
  },
  {
    "codigo":365184003,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA BAÑARSE"
  },
  {
    "codigo":234112005,
    "descripcion":"HIPERPLASIA DE VASOS LINFÁTICOS"
  },
  {
    "codigo":70272006,
    "descripcion":"HIPERTENSIÓN ARTERIAL MALIGNA"
  },
  {
    "codigo":168576007,
    "descripcion":"RADIOGRAFÍA SIMPLE DE COLUMNA VERTEBRAL CERVICAL ANORMAL"
  },
  {
    "codigo":299648006,
    "descripcion":"AMPUTADO A NIVEL DE REGIÓN SUPERIOR DE MUSLO"
  },
  {
    "codigo":428885001,
    "descripcion":"BACTERIEMIA ASOCIADA CON VÍA INTRAVASCULAR"
  },
  {
    "codigo":1348224007,
    "descripcion":"PATRÓN DE USO NOCIVO CONTINUO DE ANTIDEPRESIVO SIN DEPENDENCIA"
  },
  {
    "codigo":166741000,
    "descripcion":"NIVEL DE ZINC SÉRICO DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":2901004,
    "descripcion":"MELENA"
  },
  {
    "codigo":232277004,
    "descripcion":"FRACTURA LONGITUDINAL DE HUESO TEMPORAL"
  },
  {
    "codigo":68437005,
    "descripcion":"MIOPATÍA TIROTÓXICA"
  },
  {
    "codigo":363349007,
    "descripcion":"NEOPLASIA MALIGNA DE ESTÓMAGO"
  },
  {
    "codigo":263210007,
    "descripcion":"FRACTURA DE CUELLO DE QUINTO METACARPIANO"
  },
  {
    "codigo":164906009,
    "descripcion":"BLOQUEO AURICULOVENTRICULAR COMPLETO EN EL ELECTROCARDIOGRAMA"
  },
  {
    "codigo":31999004,
    "descripcion":"ENDOMETRITIS GONOCÓCICA CRÓNICA"
  },
  {
    "codigo":64767008,
    "descripcion":"INFESTACIÓN CAUSADA POR AMBLYOMMA"
  },
  {
    "codigo":1177044001,
    "descripcion":"ENCEFALITIS POR VIRUS SIN NOMBRE"
  },
  {
    "codigo":95700006,
    "descripcion":"DEGENERACIÓN RETINIANA ADQUIRIDA SÚBITA"
  },
  {
    "codigo":128468007,
    "descripcion":"TRASTORNO DE LA COROIDES DEL OJO"
  },
  {
    "codigo":292308008,
    "descripcion":"REACCIÓN ADVERSA A LA FLUVOXAMINA"
  },
  {
    "codigo":1339049006,
    "descripcion":"FIBROSARCOMA INFANTIL METASTÁSICO"
  },
  {
    "codigo":126633007,
    "descripcion":"NEOPLASIA DE LA MEJILLA"
  },
  {
    "codigo":93865007,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LÓBULO SUPERIOR DE PULMÓN IZQUIERDO"
  },
  {
    "codigo":716457009,
    "descripcion":"CAPAZ DE TOLERAR EL CAMBIO DE ALMOHADILLA PARA INCONTINENCIA"
  },
  {
    "codigo":288638001,
    "descripcion":"DIFICULTAD PARA ENTABLAR UNA CONVERSACIÓN"
  },
  {
    "codigo":92030004,
    "descripcion":"NEOPLASIA BENIGNA DEL ENCÉFALO"
  },
  {
    "codigo":1237075004,
    "descripcion":"ENFISEMA SUBCUTÁNEO DURANTE PROCEDIMIENTO QUIRÚRGICO"
  },
  {
    "codigo":284968001,
    "descripcion":"CAPAZ DE REALIZAR ACTIVIDAD RELACIONADA CON EL VESTIRSE"
  },
  {
    "codigo":219432005,
    "descripcion":"LESIÓN DE GUERRA CAUSADA POR SUSTANCIAS QUÍMICAS"
  },
  {
    "codigo":283133006,
    "descripcion":"AMPOLLA TRAUMÁTICA DEL DORSO DEL PIE"
  },
  {
    "codigo":1002194003,
    "descripcion":"AUMENTO TRANSITORIO DE NIVEL DE AMINOÁCIDOS EN ORINA"
  },
  {
    "codigo":838354003,
    "descripcion":"PERITONITIS LOCALIZADA AGUDA CAUSADA POR INFECCIÓN"
  },
  {
    "codigo":15848421000119103,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE DEDO DE AMBAS MANOS"
  },
  {
    "codigo":1231570007,
    "descripcion":"MIOPATÍA CAUSADA POR ANESTÉSICO LOCAL"
  },
  {
    "codigo":707282007,
    "descripcion":"CONDUCTO CERVICAL NORMAL"
  },
  {
    "codigo":1295271002,
    "descripcion":"LESIÓN TRAUMÁTICA CAUSADA POR ANIMAL MARINO"
  },
  {
    "codigo":246695005,
    "descripcion":"PATRÓN DE VERGENCIA EN A"
  },
  {
    "codigo":50087006,
    "descripcion":"LUXACIÓN EXPUESTA DE LA TERCERA VÉRTEBRA CERVICAL"
  },
  {
    "codigo":277628000,
    "descripcion":"LINFOMA MALIGNO DIFUSO DE CÉLULAS GRANDES CLIVADAS"
  },
  {
    "codigo":212092001,
    "descripcion":"CORROSIÓN QUE COMPROMETE EL 60 - 69 PORCIENTO DE LA SUPERFICIE CORPORAL"
  },
  {
    "codigo":48252005,
    "descripcion":"INFECCIÓN CAUSADA POR ENTAMOEBA"
  },
  {
    "codigo":1162364006,
    "descripcion":"SÍNDROME DE FELTY CON ARTRITIS REUMATOIDE SERONEGATIVA"
  },
  {
    "codigo":769148006,
    "descripcion":"HALLAZGO RELACIONADO CON LA PRESENCIA DE HONGO UNICELULAR"
  },
  {
    "codigo":81020007,
    "descripcion":"CÓLERA CAUSADO POR VIBRIO CHOLERAE EL TOR"
  },
  {
    "codigo":15985791000119101,
    "descripcion":"DISTONÍA DE LA MANO DERECHA"
  },
  {
    "codigo":13649004,
    "descripcion":"BRAQUICEFALIA"
  },
  {
    "codigo":1076351000119101,
    "descripcion":"INFECCIÓN DE BOLSA SEROSA DE OLÉCRANON DE CODO DERECHO"
  },
  {
    "codigo":243025006,
    "descripcion":"LESIÓN POR RÁFAGA EXPLOSIVA DE ARMA"
  },
  {
    "codigo":699942000,
    "descripcion":"ARTRITIS DESTRUCTIVA DE HOMBRO ASOCIADA CON APATITA"
  },
  {
    "codigo":339071000119102,
    "descripcion":"AGRANDAMIENTO DE ÓRBITA IZQUIERDA"
  },
  {
    "codigo":111953009,
    "descripcion":"POSTURA ANTÁLGICA"
  },
  {
    "codigo":208422001,
    "descripcion":"FRACTURA EXPUESTA DE DIÁFISIS DE METACARPIANO DE PULGAR"
  },
  {
    "codigo":110118005,
    "descripcion":"AVULSIÓN DE LA ENCÍA ALVEOLAR DE LA MANDÍBULA"
  },
  {
    "codigo":9979004,
    "descripcion":"TRASTORNO DEL RECEPTOR ANDROGÉNICO"
  },
  {
    "codigo":303056000,
    "descripcion":"LINFOMA MALIGNO, CÉLULA DEL CENTRO FOLICULAR, CLIVADA"
  },
  {
    "codigo":40912001,
    "descripcion":"ATROFIA ROJA AGUDA DEL HÍGADO"
  },
  {
    "codigo":202917000,
    "descripcion":"TENOSINOVITIS DE AQUILES"
  },
  {
    "codigo":237520009,
    "descripcion":"HIPOTIROIDISMO POR TIROIDITIS DE HASHIMOTO"
  },
  {
    "codigo":301221003,
    "descripcion":"MOVIMIENTO DE LA CUERDA VOCAL NORMAL"
  },
  {
    "codigo":432293006,
    "descripcion":"ANOMALÍA CONGÉNITA DE VASO SANGUÍNEO DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":235685007,
    "descripcion":"HAMARTOMA DE ESTÓMAGO"
  },
  {
    "codigo":1251493006,
    "descripcion":"METÁSTASIS DE CARCINOMA DE LABIO, CAVIDAD ORAL Y\/O FARINGE"
  },
  {
    "codigo":399525009,
    "descripcion":"INFLAMACIÓN DE AMPOLLA DE VATER"
  },
  {
    "codigo":39077006,
    "descripcion":"CARÁCTER AGRESIVO-PASIVO"
  },
  {
    "codigo":233850007,
    "descripcion":"ENDOCARDITIS INFECCIOSA"
  },
  {
    "codigo":299386008,
    "descripcion":"ARTICULACIÓN DE LA RODILLA FRÍA AL TACTO"
  },
  {
    "codigo":364922008,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD DE SENTARSE"
  },
  {
    "codigo":461391002,
    "descripcion":"HALLAZGO RELACIONADO CON EL CONDUCTO ARTERIOSO"
  },
  {
    "codigo":428623008,
    "descripcion":"USO INAPROPIADO DE BARBITÚRICOS"
  },
  {
    "codigo":166479009,
    "descripcion":"NIVEL DE CORTISOL FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":426788002,
    "descripcion":"VÉRTIGO COMO EFECTO TARDÍO DE ACCIDENTE CEREBROVASCULAR"
  },
  {
    "codigo":230180003,
    "descripcion":"LEUCOENCEFALOPATÍA POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":721700001,
    "descripcion":"NEOPLASIA NEUROENDOCRINA MALIGNA PRIMARIA DE RECTO"
  },
  {
    "codigo":232015009,
    "descripcion":"DESPRENDIMIENTO SÓLIDO DE RETINA"
  },
  {
    "codigo":293881000,
    "descripcion":"ALERGIA A BUTOBARBITAL"
  },
  {
    "codigo":719865001,
    "descripcion":"GRIPE CAUSADA POR VIRUS INFLUENZA PANDÉMICO"
  },
  {
    "codigo":292046005,
    "descripcion":"REACCIÓN ADVERSA A LA PENTAZOCINA"
  },
  {
    "codigo":128206006,
    "descripcion":"NEUROPATÍA SENSITIVA CONGÉNITA CON PÉRDIDA SELECTIVA DE PEQUEÑAS FIBRAS MIELINIZADAS"
  },
  {
    "codigo":783566008,
    "descripcion":"ÚLCERA MUCOCUTÁNEA CAUSADA POR VIRUS EPSTEIN-BARR"
  },
  {
    "codigo":95438009,
    "descripcion":"PARESIA DEL DIAFRAGMA"
  },
  {
    "codigo":93603000,
    "descripcion":"OSIFICACIÓN INCOMPLETA DE HUESO ESCAMOSO"
  },
  {
    "codigo":39201000146106,
    "descripcion":"TRASTORNO DEL SUEÑO DEBIDO A DEPENDENCIA DE SEDANTE"
  },
  {
    "codigo":716195006,
    "descripcion":"SÍNDROME DE BRAQUIOLMIA Y AMELOGÉNESIS IMPERFECTA AUTOSÓMICO RECESIVO"
  },
  {
    "codigo":421283008,
    "descripcion":"LINFOMA PRIMARIO DE CEREBRO ASOCIADO CON SIDA"
  },
  {
    "codigo":288376003,
    "descripcion":"INCAPAZ DE PASAR PÁGINAS"
  },
  {
    "codigo":124536006,
    "descripcion":"DEFICIENCIA DE FUMARILACETOACETASA"
  },
  {
    "codigo":13901000119100,
    "descripcion":"HIPERCALCEMIA HIPOCALCIÚRICA"
  },
  {
    "codigo":417613000,
    "descripcion":"FRACTURA-LUXACIÓN EXPUESTA DE MÚLTIPLES DEDOS DE LA MANO"
  },
  {
    "codigo":778061001,
    "descripcion":"DISECCIÓN DE ARTERIA CERVICAL FAMILIAR"
  },
  {
    "codigo":89933001,
    "descripcion":"ENFERMEDAD INTESTINAL POR PROTOZOARIOS"
  },
  {
    "codigo":253773000,
    "descripcion":"FÍSTULA CONGÉNITA DE RECTO"
  },
  {
    "codigo":712525007,
    "descripcion":"NEOPLASIA MALIGNA DE HUESO CORTO DE MIEMBRO INFERIOR"
  },
  {
    "codigo":286541007,
    "descripcion":"NO GUARDA LOS ALIMENTOS HIGIÉNICAMENTE"
  },
  {
    "codigo":22562004,
    "descripcion":"CONTUSIÓN DEL CUERO CABELLUDO"
  },
  {
    "codigo":1234978006,
    "descripcion":"TRASTORNO FETAL DEBIDO A VASA PREVIA DE CORDÓN UMBILICAL"
  },
  {
    "codigo":284706008,
    "descripcion":"GOLPEARSE LA CABEZA CONTRA UN OBJETO"
  },
  {
    "codigo":86263001,
    "descripcion":"COBALTOSIS"
  },
  {
    "codigo":1296844000,
    "descripcion":"CRISIS GLAUCOMATOCICLÍTICA DE AMBOS OJOS"
  },
  {
    "codigo":282871009,
    "descripcion":"CAPAZ DE PARARSE"
  },
  {
    "codigo":248268002,
    "descripcion":"SE CANSA RÁPIDAMENTE"
  },
  {
    "codigo":1264076003,
    "descripcion":"TRASTORNO FETAL CAUSADO POR TRANSFERENCIA PLACENTARIA DE SUSTANCIA NOCIVA"
  },
  {
    "codigo":446711009,
    "descripcion":"NEOPLASIA INTRAEPITELIAL PROSTÁTICA DE ALTO GRADO"
  },
  {
    "codigo":18892009,
    "descripcion":"ÁNTRAX DEL ANTEBRAZO"
  },
  {
    "codigo":17057004,
    "descripcion":"APNEA INDUCIDA"
  },
  {
    "codigo":82593008,
    "descripcion":"INFERTILIDAD FEMENINA SECUNDARIA A ANOMALÍA CONGÉNITA DE LAS TROMPAS DE FALOPIO"
  },
  {
    "codigo":770721009,
    "descripcion":"SÍNDROME DE MICROCEFALIA, CUERPO CALLOSO DELGADO Y DISCAPACIDAD INTELECTUAL"
  },
  {
    "codigo":1293174001,
    "descripcion":"ANEURISMA DE VENA INTRACRANEAL"
  },
  {
    "codigo":1260406003,
    "descripcion":"NEOPLASIA MIELODISPLÁSICA CON INACTIVACIÓN BIALÉLICA DE GEN TP53"
  },
  {
    "codigo":80758005,
    "descripcion":"EMBOLIA DE SENO VENOSO LATERAL"
  },
  {
    "codigo":111691006,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DE SITIOS MÚLTIPLES"
  },
  {
    "codigo":373835006,
    "descripcion":"CAMBIO EN LA QUIMIOTERAPIA POR PROBLEMAS TÉCNICOS U ORGANIZATIVOS"
  },
  {
    "codigo":406603008,
    "descripcion":"INFECCIÓN CAUSADA POR STAPHYLOCOCCUS AUREUS CON RESISTENCIA INTERMEDIA A GLUCOPÉPTIDOS"
  },
  {
    "codigo":372000001,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE GLÁNDULA SALIVAL MENOR"
  },
  {
    "codigo":208160004,
    "descripcion":"FRACTURA EXPUESTA DE ACETÁBULO, TRANSVERSAL DE AMBAS COLUMNAS"
  },
  {
    "codigo":765216006,
    "descripcion":"EPILEPSIA AUDIOGÉNICA"
  },
  {
    "codigo":109856007,
    "descripcion":"MESOTELIOMA DEL MESENTERIO"
  },
  {
    "codigo":271861000,
    "descripcion":"LÍQUIDO EN CAVIDAD PERITONEAL"
  },
  {
    "codigo":402933000,
    "descripcion":"INFECCIÓN DE MEMBRANA INTERDIGITAL DEL PIE POR GRAMNEGATIVOS"
  },
  {
    "codigo":239093000,
    "descripcion":"DERMATITIS PERIANAL DEL RECIÉN NACIDO"
  },
  {
    "codigo":1010440003,
    "descripcion":"PÉRDIDA DE AUDICIÓN CONDUCTIVA DE OÍDO DERECHO CON AUDICIÓN NORMAL DEL OÍDO IZQUIERDO"
  },
  {
    "codigo":11552008,
    "descripcion":"OBSTRUCCIÓN DUODENAL CONGÉNITA COMPLETA"
  },
  {
    "codigo":1287669005,
    "descripcion":"CONVULSIÓN EPILÉPTICA DE LÓBULO TEMPORAL"
  },
  {
    "codigo":1254901005,
    "descripcion":"DERMATOSIS OCUPACIONAL CAUSADA POR ALTAS TEMPERATURAS"
  },
  {
    "codigo":204490005,
    "descripcion":"HIPOPLASIA DE VASO SANGUÍNEO RAQUÍDEO"
  },
  {
    "codigo":1187530005,
    "descripcion":"DEFICIENCIA DE PEX12"
  },
  {
    "codigo":40650009,
    "descripcion":"OBSTRUCCIÓN DE COLON"
  },
  {
    "codigo":169887003,
    "descripcion":"TALLA AL NACER MENOR O IGUAL AL PERCENTILO 3"
  },
  {
    "codigo":71583005,
    "descripcion":"GASTROENTERITIS TÓXICA"
  },
  {
    "codigo":366495007,
    "descripcion":"AMPLITUD DE LA FLEXIÓN HORIZONTAL DE HOMBRO - HALLAZGO"
  },
  {
    "codigo":300959008,
    "descripcion":"TOS ALÉRGICA"
  },
  {
    "codigo":102516000,
    "descripcion":"ANCIANO DE SEXO MASCULINO SANO"
  },
  {
    "codigo":266356006,
    "descripcion":"ENFISEMA ATRÓFICO SENIL"
  },
  {
    "codigo":36980009,
    "descripcion":"INMUNODEFICIENCIA COMBINADA SEVERA POR AUSENCIA DE ADENOSINA DESAMINASA"
  },
  {
    "codigo":35145002,
    "descripcion":"ENCEFALOPATÍA URÉMICA"
  },
  {
    "codigo":428361004,
    "descripcion":"ARTRITIS VIRAL DE MANO"
  },
  {
    "codigo":264521008,
    "descripcion":"EUTIROIDEO"
  },
  {
    "codigo":721438003,
    "descripcion":"LESIÓN COMPLETA DE MÉDULA ESPINAL AL NIVEL DEL NOVENO SEGMENTO DORSAL"
  },
  {
    "codigo":295454005,
    "descripcion":"SOBREDOSIS INTENCIONAL DE LAXANTE DE VOLUMEN"
  },
  {
    "codigo":66078008,
    "descripcion":"DEFICIENCIA LONGITUDINAL DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":197150008,
    "descripcion":"FISURA Y FÍSTULA ANAL"
  },
  {
    "codigo":293619005,
    "descripcion":"ALERGIA A IBUPROFENO"
  },
  {
    "codigo":129779008,
    "descripcion":"POSICIÓN DE LAS OCHO EN PUNTO EN LA MAMOGRAFÍA"
  },
  {
    "codigo":160712002,
    "descripcion":"OCUPACIÓN MÚLTIPLE"
  },
  {
    "codigo":717768004,
    "descripcion":"SÍNDROME DE ALPORT LIGADO AL CROMOSOMA X"
  },
  {
    "codigo":95176005,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE BORDE BERMELLÓN DE LABIO INFERIOR"
  },
  {
    "codigo":93341002,
    "descripcion":"POSICIÓN ANÓMALA CONGÉNITA DE OVARIO"
  },
  {
    "codigo":60573004,
    "descripcion":"ESTENOSIS DE VÁLVULA AÓRTICA"
  },
  {
    "codigo":58738001,
    "descripcion":"REACCIÓN A UNA TRANSFUSIÓN, CAUSADA POR EL ALMACENAMIENTO DEFECTUOSO DE LA SANGRE"
  },
  {
    "codigo":124274002,
    "descripcion":"DEFICIENCIA DE ADENINA FOSFORRIBOSILTRANSFERASA"
  },
  {
    "codigo":286279003,
    "descripcion":"DIFICULTAD PARA ARTICULAR PALABRAS"
  },
  {
    "codigo":253511007,
    "descripcion":"ANOMALÍA CONGÉNITA VENTRICULAR Y DE SEPTUM VENTRICULAR"
  },
  {
    "codigo":187975008,
    "descripcion":"NEOPLASIA MALIGNA DEL TERCER METATARSIANO"
  },
  {
    "codigo":251676007,
    "descripcion":"ACELERACIÓN CARDÍACA FETAL"
  },
  {
    "codigo":315377004,
    "descripcion":"NACIDO EN BAHAMAS"
  },
  {
    "codigo":1003505005,
    "descripcion":"AGENESIA DE COSTILLA"
  },
  {
    "codigo":708593006,
    "descripcion":"RESTAURACIÓN DENTAL COLOREADA METÁLICA PRESENTE"
  },
  {
    "codigo":774129008,
    "descripcion":"ARTROPATÍA DE ARTICULACIÓN DE RODILLA IZQUIERDA"
  },
  {
    "codigo":446449009,
    "descripcion":"SÍNDROME DE COLOBOMA RENAL"
  },
  {
    "codigo":282609009,
    "descripcion":"GATEA"
  },
  {
    "codigo":413681009,
    "descripcion":"BORBORIGMOS"
  },
  {
    "codigo":248006006,
    "descripcion":"TORTURA"
  },
  {
    "codigo":49563000,
    "descripcion":"EDEMA PERIORBITARIO"
  },
  {
    "codigo":16019791000119106,
    "descripcion":"SINOTIVIS TRANSITORIA DE PIE IZQUIERDO"
  },
  {
    "codigo":735856007,
    "descripcion":"LESIÓN TRAUMÁTICA DE TENDÓN DE AQUILES"
  },
  {
    "codigo":734021001,
    "descripcion":"ATAXIA ESPINOCEREBELOSA TIPO 38"
  },
  {
    "codigo":13125003,
    "descripcion":"MIOMETRITIS CRÓNICA"
  },
  {
    "codigo":275269004,
    "descripcion":"NEOPLASIA BENIGNA DE CEREBRO"
  },
  {
    "codigo":207898000,
    "descripcion":"FRACTURA NO EXPUESTA DEL AXIS, ESPONDILÓLISIS"
  },
  {
    "codigo":109594002,
    "descripcion":"SENSIBILIDAD DENTAL AL FRÍO"
  },
  {
    "codigo":15665641000119103,
    "descripcion":"ANOFTALMÍA DE AMBOS OJOS"
  },
  {
    "codigo":699418008,
    "descripcion":"INCISIVO CON FORMA DE PALA"
  },
  {
    "codigo":240666009,
    "descripcion":"TOXOPLASMOSIS CUTÁNEA"
  },
  {
    "codigo":271599002,
    "descripcion":"SE SIENTE SATISFECHO"
  },
  {
    "codigo":15747561000119105,
    "descripcion":"MASA DE PARTES BLANDAS DE EXTREMIDAD SUPERIOR DERECHA"
  },
  {
    "codigo":74991009,
    "descripcion":"ENFERMEDAD POR DEFICIENCIA DE COBALTO"
  },
  {
    "codigo":1285572006,
    "descripcion":"HIPERTENSIÓN OCULAR DEBIDA A RETRACCIÓN DE ÁNGULO"
  },
  {
    "codigo":7620006,
    "descripcion":"ENFERMEDAD DE CROHN DEL INTESTINO GRUESO"
  },
  {
    "codigo":431769004,
    "descripcion":"TRASTORNO DEL QUIASMA ÓPTICO DEBIDO A NEOPLASIA"
  },
  {
    "codigo":366233004,
    "descripcion":"HALLAZGO RELACIONADO CON TAMAÑO DE LENGUA"
  },
  {
    "codigo":300697005,
    "descripcion":"NO USA UNA CUENTA FINANCIERA"
  },
  {
    "codigo":3950001,
    "descripcion":"NACIMIENTO"
  },
  {
    "codigo":266094004,
    "descripcion":"GANGRENA GASEOSA OCASIONADA POR CLOSTRIDIUM SEPTICUM"
  },
  {
    "codigo":724846005,
    "descripcion":"CONDUCTA COMPULSIVA DE MORDERSE A SÍ MISMO"
  },
  {
    "codigo":428099003,
    "descripcion":"FRACTURA NO EXPUESTA DE BASE DEL CRÁNEO"
  },
  {
    "codigo":297027003,
    "descripcion":"SOBREDOSIS INTENCIONAL DE ÁCIDO ETACRÍNICO"
  },
  {
    "codigo":34883005,
    "descripcion":"PENSAMIENTO AUTISTA"
  },
  {
    "codigo":428552000,
    "descripcion":"CAPTACIÓN DE TRAZADOR EXTRACARDÍACO NORMAL"
  },
  {
    "codigo":33048000,
    "descripcion":"DEFECTO DEL CAMPO VISUAL PERIFÉRICO"
  },
  {
    "codigo":723011009,
    "descripcion":"ERUPCIÓN CUTÁNEA AGUDA PURPÚRICA"
  },
  {
    "codigo":721176002,
    "descripcion":"INSUFICIENCIA OVÁRICA PREMATURA IDIOPÁTICA"
  },
  {
    "codigo":229656001,
    "descripcion":"DISFASIA DINÁMICA FRONTAL"
  },
  {
    "codigo":293357000,
    "descripcion":"REACCIÓN ADVERSA A EDETATO SÓDICO DE HIERRO"
  },
  {
    "codigo":719341006,
    "descripcion":"RESULTADO DE BIOPSIA RENAL EN EL LÍMITE DE LA ANORMALIDAD"
  },
  {
    "codigo":63981007,
    "descripcion":"HIPOPARATIROIDISMO NEONATAL"
  },
  {
    "codigo":424429009,
    "descripcion":"DISPRAXIA DE LA MARCHA"
  },
  {
    "codigo":291522006,
    "descripcion":"INTOXICACIÓN POR TRIMETOPRIMA"
  },
  {
    "codigo":289687008,
    "descripcion":"ABDOMEN GESTANTE REDONDEADO"
  },
  {
    "codigo":124012001,
    "descripcion":"GLUCÓGENO POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":224151008,
    "descripcion":"SIN MASCOTAS"
  },
  {
    "codigo":255084004,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS DEL MARGEN ANAL"
  },
  {
    "codigo":1172588008,
    "descripcion":"SÍNDROME DE ENCEFALOPATÍA PROGRESIVA, ATAXIA ESPÁSTICA, ATROFIA MUSCULAR ESPINAL DISTAL DE INICIO TEMPRANO"
  },
  {
    "codigo":89409002,
    "descripcion":"GASTROTORACÓPAGO DÍPIGO"
  },
  {
    "codigo":1269057003,
    "descripcion":"LESIÓN DE VASO SANGUÍNEO DE ABDOMEN"
  },
  {
    "codigo":286017003,
    "descripcion":"APAGA UN DISPOSITIVO DOMÉSTICO"
  },
  {
    "codigo":56641006,
    "descripcion":"DIAGNÓSTICO EN EL EJE II"
  },
  {
    "codigo":415254000,
    "descripcion":"EVENTRACIÓN RECURRENTE DE PARED ANTERIOR ABDOMINAL"
  },
  {
    "codigo":417089009,
    "descripcion":"DEFICIENCIA DE CÉLULAS MADRE DEL LIMBO"
  },
  {
    "codigo":448022005,
    "descripcion":"HEMANGIOMA RETROAURICULAR"
  },
  {
    "codigo":710166008,
    "descripcion":"ÚLCERA CRÓNICA DE ESPALDA"
  },
  {
    "codigo":249579002,
    "descripcion":"RIÑÓN PALPABLE"
  },
  {
    "codigo":870336006,
    "descripcion":"VASCULITIS NECROSANTE CUTÁNEA DEBIDA A DERMATOMIOSITIS DE TIPO INFANTIL"
  },
  {
    "codigo":247744007,
    "descripcion":"ALUCINACIONES DISOCIATIVAS"
  },
  {
    "codigo":1360021000,
    "descripcion":"RETINITIS OCULAR DEBIDA A SÍFILIS SECUNDARIA"
  },
  {
    "codigo":1263552009,
    "descripcion":"TRASTORNO DE PLEXO LUMBOSACRO DEBIDO A ENFERMEDAD NEOPLÁSICA"
  },
  {
    "codigo":903952141000132105,
    "descripcion":"ESTENOSIS DE YEYUNO"
  },
  {
    "codigo":704661003,
    "descripcion":"INCUMPLIMIENTO CON EL ESQUEMA DE VACUNACIÓN"
  },
  {
    "codigo":606202961000119101,
    "descripcion":"ATRAPAMIENTO DE MÚSCULO RECTO INTERNO"
  },
  {
    "codigo":49301004,
    "descripcion":"INTOXICACIÓN POR STIPA"
  },
  {
    "codigo":278677006,
    "descripcion":"ÁNGULO DENTARIO INTERINCISAL AUMENTADO"
  },
  {
    "codigo":82069007,
    "descripcion":"PÓLIPO DE LABIOS VULVARES"
  },
  {
    "codigo":211306000,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE MANO, INFECTADA"
  },
  {
    "codigo":349111000119108,
    "descripcion":"DEGENERACIÓN POSTERIOR DEL VÍTREO DE AMBOS OJOS"
  },
  {
    "codigo":209471000,
    "descripcion":"ESGUINCE DE PULGAR, ARTICULACIÓN METACARPOFALÁNGICA, LIGAMENTO LATERAL RADIAL"
  },
  {
    "codigo":897599007,
    "descripcion":"AUSENCIA DE CÉLULAS EN ORINA AL EXAMEN MICROSCÓPICO"
  },
  {
    "codigo":109332000,
    "descripcion":"ABSCESO DE COMPLEJO ÓRBITO-NASAL"
  },
  {
    "codigo":76564002,
    "descripcion":"SECRECIÓN DE CATECOLAMINAS POR FEOCROMOCITOMA"
  },
  {
    "codigo":240404002,
    "descripcion":"LEPRA LEPROMATOSA DIFUSA"
  },
  {
    "codigo":322641000119106,
    "descripcion":"SINOVITIS TRANSITORIA DE ARTICULACIÓN GLENOHUMERAL DERECHA"
  },
  {
    "codigo":402409001,
    "descripcion":"URTICARIA EPISÓDICA"
  },
  {
    "codigo":1156073005,
    "descripcion":"CATÉTER BLOQUEADO"
  },
  {
    "codigo":369641005,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA DE LA PRÓSTATA, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":1287145007,
    "descripcion":"NEVO EPIDÉRMICO PILOSO PIGMENTADO DE PÁRPADO SUPERIOR"
  },
  {
    "codigo":238569008,
    "descripcion":"DERMATITIS POR CONTACTO CON ACEITE"
  },
  {
    "codigo":72894001,
    "descripcion":"HIPERTROFIA DE ALMOHADILLA ADIPOSA INFRARROTULIANA"
  },
  {
    "codigo":7358000,
    "descripcion":"SÍNDROME DE DISURIA - POLAQUIURIA"
  },
  {
    "codigo":302270002,
    "descripcion":"INCAPAZ DE REALIZAR TRASLADOS CON SILLA DE RUEDAS"
  },
  {
    "codigo":236734004,
    "descripcion":"DESPLAZAMIENTO DE PRÓTESIS DE PENE"
  },
  {
    "codigo":105662008,
    "descripcion":"ENFERMEDAD CAUSADA POR FASCIOLIDAE"
  },
  {
    "codigo":5523002,
    "descripcion":"MIOGLOBINURIA IDIOPÁTICA"
  },
  {
    "codigo":431507002,
    "descripcion":"RECHAZO ACELERADO DE TRASPLANTE DE PULMÓN"
  },
  {
    "codigo":202131004,
    "descripcion":"CONDROPATÍA ARTICULAR, NO ROTULIANA"
  },
  {
    "codigo":48261000087100,
    "descripcion":"FRACTURA DE ESCAFOIDES DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":71059005,
    "descripcion":"INTOXICACIÓN POR SAL FERROSA"
  },
  {
    "codigo":43141000087103,
    "descripcion":"HEMATOMA DE DEDO PULGAR DERECHO"
  },
  {
    "codigo":38021000087104,
    "descripcion":"ACINESIA DE SEGMENTO ANTEROLATERAL BASAL DE VENTRÍCULO CARDÍACO IZQUIERDO"
  },
  {
    "codigo":35461000087105,
    "descripcion":"ISQUEMIA DE MIOCARDIO ANTERIOR"
  },
  {
    "codigo":40581000087106,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE SEGUNDO DEDO DE PIE IZQUIERDO"
  },
  {
    "codigo":36456004,
    "descripcion":"HALLAZGO DEL ESTADO MENTAL"
  },
  {
    "codigo":296171000119106,
    "descripcion":"ALTERACIÓN DE CUERNO ANTERIOR DE MENISCO EXTERNO DEBIDA A LESIÓN TRAUMÁTICA DE RODILLA"
  },
  {
    "codigo":429672007,
    "descripcion":"TRASTORNO DEL ESTADO DE ÁNIMO CAUSADO POR FÁRMACO"
  },
  {
    "codigo":460605000,
    "descripcion":"ORIGEN ANÓMALO DE CONDUCTO ARTERIOSO EN ARTERIA CARÓTIDA IZQUIERDA"
  },
  {
    "codigo":724584009,
    "descripcion":"NEOPLASIA OSTEÓGENA BENIGNA DE CARTÍLAGO ARTICULAR DE COLUMNA VERTEBRAL"
  },
  {
    "codigo":1148733008,
    "descripcion":"SOBREDOSIS DE HIERRO Y\/O COMPUESTO DE HIERRO"
  },
  {
    "codigo":294930001,
    "descripcion":"ALERGIA A ÁCIDO FÓLICO"
  },
  {
    "codigo":131090001,
    "descripcion":"NIVEL DE HORMONA TIROIDEA POR DEBAJO DE RANGO DE REFERENCIA"
  },
  {
    "codigo":1343506007,
    "descripcion":"SÍNDROME DE CORDÓN POSTERIOR TRAUMÁTICO"
  },
  {
    "codigo":424167000,
    "descripcion":"CON MAYOR RIESGO DE GLUCEMIA INESTABLE"
  },
  {
    "codigo":426002008,
    "descripcion":"BOLSA SEROSA DEL OLÉCRANON INFECTADA"
  },
  {
    "codigo":360466009,
    "descripcion":"OSTEONECROSIS DE HUESO SEMILUNAR"
  },
  {
    "codigo":194791005,
    "descripcion":"HIPERTENSIÓN CAUSADA POR FÁRMACO"
  },
  {
    "codigo":129255007,
    "descripcion":"PELLIZCO ARTICULAR"
  },
  {
    "codigo":1145063009,
    "descripcion":"QUISTE MANDIBULAR"
  },
  {
    "codigo":94652005,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA ENCÍA SUPERIOR"
  },
  {
    "codigo":782780007,
    "descripcion":"SÍNDROME DE HÁBITO MARFANOIDE, HERNIA INGUINAL Y EDAD ÓSEA AVANZADA"
  },
  {
    "codigo":61884008,
    "descripcion":"NEUMONÍA POR ACHROMOBACTER"
  },
  {
    "codigo":27281001,
    "descripcion":"ÚLCERA DUODENAL CON HEMORRAGIA"
  },
  {
    "codigo":92817004,
    "descripcion":"LEUCEMIA MIELOIDE CRÓNICA EN REMISIÓN"
  },
  {
    "codigo":289425005,
    "descripcion":"HALLAZGO RELACIONADO CON EL DESCENSO DE LA PRESENTACIÓN"
  },
  {
    "codigo":715409005,
    "descripcion":"SÍNDROME DE TRIGONOCEFALIA C"
  },
  {
    "codigo":125585007,
    "descripcion":"INFECCIÓN DEL APARATO GENITAL FEMENINO"
  },
  {
    "codigo":1303398000,
    "descripcion":"FRACTURA DE FALANGE DE MANO DERECHA"
  },
  {
    "codigo":351621000119108,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE PELVIS RENAL DERECHA"
  },
  {
    "codigo":23941000119108,
    "descripcion":"ARNOLD CHIARI TIPO 2 SIN HIDROCEFALIA"
  },
  {
    "codigo":58214004,
    "descripcion":"ESQUIZOFRENIA"
  },
  {
    "codigo":449595000,
    "descripcion":"AURÍCULA IZQUIERDA DIVIDIDA CON DESEMBOCADURA DE ALGUNAS VENAS PULMONARES EN LA CÁMARA PROXIMAL Y DRENAJE EN LA AURÍCULA DERECHA Y OTRAS CON CONEXIONES ANÓMALAS"
  },
  {
    "codigo":12203551000119104,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DE CODO IZQUIERDO"
  },
  {
    "codigo":23611004,
    "descripcion":"FRACTURA EXPUESTA DE MANDÍBULA"
  },
  {
    "codigo":414992000,
    "descripcion":"SANGRADO RECTAL INDOLORO"
  },
  {
    "codigo":285755009,
    "descripcion":"SIMULTAGNOSIA"
  },
  {
    "codigo":251152003,
    "descripcion":"ARRITMIA SINUSAL SEVERA"
  },
  {
    "codigo":283920004,
    "descripcion":"SECCIÓN DE URETRA"
  },
  {
    "codigo":118245000,
    "descripcion":"HALLAZGO RELACIONADO CON MEDICIÓN"
  },
  {
    "codigo":282085000,
    "descripcion":"DESGARRO SEROSO DE ÍLEON"
  },
  {
    "codigo":447760009,
    "descripcion":"ADENOCARCINOMA ENDOCERVICAL IN SITU"
  },
  {
    "codigo":183781007,
    "descripcion":"INSCRIPTO EN LISTA DE ADMISIÓN DIABETOLÓGICA"
  },
  {
    "codigo":249317008,
    "descripcion":"DESVIACIÓN NASAL, HUESO"
  },
  {
    "codigo":247482003,
    "descripcion":"UÑAS QUE NO CRECEN"
  },
  {
    "codigo":1197754004,
    "descripcion":"SÍNDROME CONGÉNITO DE BRAQUIESÓFAGO, ESTÓMAGO INTRATORÁCICO, Y ANOMALÍAS VERTEBRALES"
  },
  {
    "codigo":50874004,
    "descripcion":"GASTRITIS NO EROSIVA NO ESPECÍFICA"
  },
  {
    "codigo":737167007,
    "descripcion":"INFLAMACIÓN ULCEROSA DE VULVA Y VAGINA"
  },
  {
    "codigo":735332000,
    "descripcion":"LINFOMA CUTÁNEO PRIMARIO DIFUSO DE GRANDES LINFOCITOS B DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":1163151008,
    "descripcion":"CRIPTOCOCOMA CEREBRAL"
  },
  {
    "codigo":473188002,
    "descripcion":"MAREO CAUSADO POR FÁRMACO"
  },
  {
    "codigo":407652002,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: GRIEGO"
  },
  {
    "codigo":211044004,
    "descripcion":"ABRASIÓN DE ANO"
  },
  {
    "codigo":276580005,
    "descripcion":"ISOINMUNIZACIÓN ATÍPICA DEL RECIÉN NACIDO"
  },
  {
    "codigo":440420005,
    "descripcion":"ÁCIDO RIBONUCLEICO DE VIRUS DE HEPATITIS C NO DETECTADO POR REACCIÓN EN CADENA DE POLIMERASA"
  },
  {
    "codigo":79972006,
    "descripcion":"OTITIS CIRCUNSCRIPTA EXTERNA"
  },
  {
    "codigo":1259620008,
    "descripcion":"CARCINOMA ESCAMOSO PAPILAR PRIMARIO DE NASOFARINGE"
  },
  {
    "codigo":354131000119101,
    "descripcion":"NEOPLASIA BENIGNA DE OJO IZQUIERDO"
  },
  {
    "codigo":373049003,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM OBUENSE"
  },
  {
    "codigo":1290553006,
    "descripcion":"ANGIODISPLASIA DE INTESTINO GRUESO"
  },
  {
    "codigo":45369008,
    "descripcion":"DIABETES INSÍPIDA CENTRAL"
  },
  {
    "codigo":405817008,
    "descripcion":"FRACTURA DE FALANGE DE MANO"
  },
  {
    "codigo":241977008,
    "descripcion":"BAROTRAUMA POR INMERSIÓN"
  },
  {
    "codigo":733497009,
    "descripcion":"SUPURACIÓN CRÓNICA DE BRONQUIO"
  },
  {
    "codigo":240142002,
    "descripcion":"OSTEOMIELITIS AGUDA DE PIE"
  },
  {
    "codigo":403982005,
    "descripcion":"HEMANGIOENDOTELIOMA RETIFORME"
  },
  {
    "codigo":402147000,
    "descripcion":"DERMATOSIS CAUSADA POR HYMENOPTERA"
  },
  {
    "codigo":762595001,
    "descripcion":"POLINEUROPATÍA CRÓNICA DOLOROSA POSTERIOR A QUIMIOTERAPIA"
  },
  {
    "codigo":698894008,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: DANÉS"
  },
  {
    "codigo":305678008,
    "descripcion":"ATENDIDO POR UN GENETISTA MOLECULAR CLÍNICO"
  },
  {
    "codigo":302008001,
    "descripcion":"NO OPONE EL PULGAR"
  },
  {
    "codigo":72632003,
    "descripcion":"ESTADIO L2"
  },
  {
    "codigo":269240003,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO SUPERFICIAL DE MEJILLA"
  },
  {
    "codigo":236472005,
    "descripcion":"UMBRAL RENAL ELEVADO PARA LA GLUCOSA"
  },
  {
    "codigo":365709000,
    "descripcion":"REDUCCIÓN DE AZUL DE METILENO - HALLAZGO"
  },
  {
    "codigo":300173000,
    "descripcion":"YUNQUE PRESENTE"
  },
  {
    "codigo":170936009,
    "descripcion":"ASISTENCIA COMPARTIDA - CENTRO DE CUIDADOS PALIATIVOS Y MÉDICO GENERAL"
  },
  {
    "codigo":621021000124107,
    "descripcion":"DESAPARICIÓN DE FAMILIAR"
  },
  {
    "codigo":234637004,
    "descripcion":"DELECIÓN DEL CROMOSOMA X E HIPOGAMMAGLOBULINEMIA"
  },
  {
    "codigo":108371000119108,
    "descripcion":"VAGINITIS INFLAMATORIA DESCAMATIVA"
  },
  {
    "codigo":68962001,
    "descripcion":"MIALGIA"
  },
  {
    "codigo":3426005,
    "descripcion":"CUERPO EXTRAÑO MAGNÉTICO RETENIDO EN EL OJO"
  },
  {
    "codigo":167266007,
    "descripcion":"PRUEBA DE GLUCOSA EN ORINA = +++"
  },
  {
    "codigo":296503003,
    "descripcion":"SOBREDOSIS DE ESPASMOLÍTICO"
  },
  {
    "codigo":34359005,
    "descripcion":"OSTEOCONDROSIS JUVENIL DE HUESO NAVICULAR DE TARSO"
  },
  {
    "codigo":1345079007,
    "descripcion":"PATRÓN DE USO NOCIVO DE ESTEROIDE ANABÓLICO"
  },
  {
    "codigo":15974381000119105,
    "descripcion":"NEOPLASIA BENIGNA DE HUESO DE AMBOS MIEMBROS INFERIORES"
  },
  {
    "codigo":198199009,
    "descripcion":"CERVICITIS Y ENDOCERVICITIS"
  },
  {
    "codigo":294668002,
    "descripcion":"ALERGIA A ANTITOXINA BOTULÍNICA"
  },
  {
    "codigo":1179404005,
    "descripcion":"HIPOTIROIDISMO CONGÉNITO POR ANOMALÍA CONGÉNITA DE TIROIDES"
  },
  {
    "codigo":425740005,
    "descripcion":"INFECCIÓN CON VIRUS LINFOTRÓPICO HUMANO 2"
  },
  {
    "codigo":30689000,
    "descripcion":"ADHERENCIA DE LA PARED ABDOMINAL"
  },
  {
    "codigo":784353002,
    "descripcion":"SÍNDROME DE AGENESIA DE VÁLVULA PULMONAR, TABIQUE INTERVENTRICULAR INTACTO Y CONDUCTO ARTERIOSO PERSISTENTE"
  },
  {
    "codigo":1073331000119104,
    "descripcion":"ARTRITIS DE RODILLA IZQUIERDA CAUSADA POR BACTERIAS"
  },
  {
    "codigo":292833004,
    "descripcion":"REACCIÓN ADVERSA A LA ZALCITABINA"
  },
  {
    "codigo":290998000,
    "descripcion":"INTOXICACIÓN POR METIPRILÓN"
  },
  {
    "codigo":18321000122100,
    "descripcion":"HIPERSENSIBILIDAD NO ALÉRGICA A BENAZEPRIL"
  },
  {
    "codigo":127158006,
    "descripcion":"LINFADENOPATÍA PÉLVICA"
  },
  {
    "codigo":225462008,
    "descripcion":"ACTITUD NEGATIVA"
  },
  {
    "codigo":92555001,
    "descripcion":"CARCINOMA IN SITU DE BRONQUIO DEL LÓBULO MEDIO DERECHO DEL PULMÓN"
  },
  {
    "codigo":27019000,
    "descripcion":"QUERATITIS SUPERFICIAL"
  },
  {
    "codigo":94390009,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE HUESO SEMILUNAR"
  },
  {
    "codigo":190859005,
    "descripcion":"HIPOFOSFATASIA"
  },
  {
    "codigo":289163007,
    "descripcion":"PROBLEMA DEL APETITO"
  },
  {
    "codigo":189024004,
    "descripcion":"NEOPLASIA BENIGNA DE PARTES BLANDAS DE LA COLUMNA VERTEBRAL CERVICAL"
  },
  {
    "codigo":713312005,
    "descripcion":"BURSITIS CAUSADA POR INFECCIÓN BACTERIANA"
  },
  {
    "codigo":1268533001,
    "descripcion":"SARCOMA DE EWING PRIMARIO DE HUESO"
  },
  {
    "codigo":285493003,
    "descripcion":"LOGRA SELLAR LOS LABIOS"
  },
  {
    "codigo":416565004,
    "descripcion":"DESPLAZAMIENTO DE LAS COSTILLAS SUPERIORES EN DIRECCIÓN CEFÁLICA DURANTE LA INSPIRACIÓN"
  },
  {
    "codigo":283658002,
    "descripcion":"HERIDA POR PINCHAZO DE CLAVO EN EL CODO"
  },
  {
    "codigo":447498008,
    "descripcion":"RETORNO VENOSO PULMONAR OBSTRUIDO POR COMPRESIÓN EXTRÍNSECA ENTRE ARTERIA PULMONAR DERECHA Y TRÁQUEA"
  },
  {
    "codigo":871647003,
    "descripcion":"TRONCO ARTERIAL COMÚN CON PREDOMINIO PULMONAR"
  },
  {
    "codigo":1363167004,
    "descripcion":"NEUROPATÍA ÓPTICA ISQUÉMICA ANTERIOR NO ARTERÍTICA"
  },
  {
    "codigo":15675681000119104,
    "descripcion":"TENDINITIS CALCIFICANTE DE AMBOS TOBILLOS"
  },
  {
    "codigo":609503006,
    "descripcion":"INTERRUPCIÓN INDUCIDA DE EMBARAZO COMPLICADA POR DAÑO DE VEJIGA URINARIA"
  },
  {
    "codigo":247220006,
    "descripcion":"PALIDEZ TEMPORAL DE PAPILA ÓPTICA"
  },
  {
    "codigo":443828007,
    "descripcion":"ENZIMA PANCREÁTICA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":278153001,
    "descripcion":"GRUPO SANGUÍNEO B RH(D) NEGATIVO"
  },
  {
    "codigo":48777005,
    "descripcion":"CRANEOSQUISIS"
  },
  {
    "codigo":212617005,
    "descripcion":"INTOXICACIÓN CON TRIMETADIONA"
  },
  {
    "codigo":1259358002,
    "descripcion":"CARCINOMA PRIMARIO DE PÁNCREAS ENDOCRINO"
  },
  {
    "codigo":309086004,
    "descripcion":"PARESTESIA DE LA MANO"
  },
  {
    "codigo":276318006,
    "descripcion":"OBLITERACIÓN DEL FÓRNIX CONJUNTIVAL"
  },
  {
    "codigo":866142007,
    "descripcion":"INFECCIÓN DE HÍGADO CAUSADA POR PARÁSITO"
  },
  {
    "codigo":700467001,
    "descripcion":"SÍNDROME DE VASOCONSTRICCIÓN CEREBRAL REVERSIBLE"
  },
  {
    "codigo":733235002,
    "descripcion":"FRACTURA DE DIÁFISIS DE CÚBITO Y RADIO"
  },
  {
    "codigo":10752031000119100,
    "descripcion":"CERVICITIS POSPARTO"
  },
  {
    "codigo":859422751000119101,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DEBIDO A EMBOLIA DE ARTERIA CARÓTIDA IZQUIERDA"
  },
  {
    "codigo":405555006,
    "descripcion":"HEMORRAGIA DE URETRA"
  },
  {
    "codigo":253967391000119103,
    "descripcion":"DEFECTO TRANSITORIO DE TABIQUE AURICULOVENTRICULAR"
  },
  {
    "codigo":343071000119104,
    "descripcion":"PROLAPSO DE VÍTREO DE AMBOS OJOS"
  },
  {
    "codigo":350751000119104,
    "descripcion":"NEOPLASIA LIPOMATOSA BENIGNA DE PIEL Y\/O DE TEJIDO CELULAR SUBCUTÁNEO DE EXTREMIDAD INFERIOR DERECHA"
  },
  {
    "codigo":16668191000119106,
    "descripcion":"FRACTURA NO EXPUESTA DE PORCIÓN ORBITARIA DE HUESO CIGOMÁTICO IZQUIERDO"
  },
  {
    "codigo":17951000119105,
    "descripcion":"ABSCESO PÉLVICO AGUDO EN EL HOMBRE"
  },
  {
    "codigo":16302111000119105,
    "descripcion":"LESIÓN DE HUESO DE PIERNA IZQUIERDA"
  },
  {
    "codigo":16012831000119109,
    "descripcion":"TROMBOSIS DE ARTERIA DE EXTREMIDAD INFERIOR IZQUIERDA"
  },
  {
    "codigo":10682911000119108,
    "descripcion":"TUMEFACCIÓN DEL TEJIDO CELULAR SUBCUTÁNEO DE EXTREMIDAD INFERIOR DERECHA"
  },
  {
    "codigo":683509791000119109,
    "descripcion":"ÚLCERA AGUDA DE PÍLORO CAUSADA POR HELICOBACTER PYLORI"
  },
  {
    "codigo":403720005,
    "descripcion":"PRURITO INDUCIDO POR FOTOQUIMIOTERAPIA CON PSORALENO Y RADIACIÓN ULTRAVIOLETA DE ONDA LARGA"
  },
  {
    "codigo":239880009,
    "descripcion":"ESPONDILOSIS LUMBAR"
  },
  {
    "codigo":348191000119108,
    "descripcion":"RUPTURA DE CÁPSULA POSTERIOR DE CRISTALINO DERECHO DURANTE PROCEDIMIENTO QUIRÚRGICO"
  },
  {
    "codigo":238045003,
    "descripcion":"TRASTORNO DEL METABOLISMO DE LAS GLUCOPROTEÍNAS"
  },
  {
    "codigo":895240007,
    "descripcion":"FORMA ANCHA ANORMAL CONGÉNITA DE FALANGE DISTAL DE DEDO ÍNDICE"
  },
  {
    "codigo":762333005,
    "descripcion":"DISFUNCIÓN SEXUAL CAUSADA POR ESTIMULANTE"
  },
  {
    "codigo":291871000119109,
    "descripcion":"TRASTORNO DE NERVIO PERIFÉRICO DE MIEMBRO SUPERIOR DERECHO"
  },
  {
    "codigo":205277006,
    "descripcion":"SINOSTOSIS DE HUESO GRANDE-GANCHOSO"
  },
  {
    "codigo":301746004,
    "descripcion":"NO REALIZA ACTIVIDADES DE TECNOLOGÍA INFORMÁTICA"
  },
  {
    "codigo":299911004,
    "descripcion":"SENSIBILIDAD DE TACTO SUAVE: PRESENTE"
  },
  {
    "codigo":234375006,
    "descripcion":"ERITROBLASTOPENIA TRANSITORIA DE LA NIÑEZ"
  },
  {
    "codigo":37767008,
    "descripcion":"DEFORMIDAD CONGÉNITA DE PARED DE SENO PARANASAL"
  },
  {
    "codigo":68700003,
    "descripcion":"ANEMIA MEGALOBLÁSTICA POR ERROR DEL METABOLISMO DE COBALAMINA"
  },
  {
    "codigo":298076006,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE BRAZO"
  },
  {
    "codigo":724060008,
    "descripcion":"NEOPLASIA MALIGNA DE LÓBULO SUPERIOR DE PULMÓN DERECHO"
  },
  {
    "codigo":15950421000119107,
    "descripcion":"CARCINOMA DE CÉLULAS DE MERKEL PRIMARIO DE PIEL DE MAMA IZQUIERDA"
  },
  {
    "codigo":296241006,
    "descripcion":"SOBREDOSIS DE PERFENAZINA"
  },
  {
    "codigo":66865009,
    "descripcion":"DUPLICACIÓN CONGÉNITA DE ESÓFAGO"
  },
  {
    "codigo":196102003,
    "descripcion":"NEUMOTÓRAX ESPONTÁNEO A TENSIÓN"
  },
  {
    "codigo":16005871000119103,
    "descripcion":"ARTRITIS REACTIVA DE ARTICULACIÓN DE AMBOS CODOS"
  },
  {
    "codigo":294406007,
    "descripcion":"ALERGIA A POLINOXILINA"
  },
  {
    "codigo":1144539001,
    "descripcion":"HIPOPLASIA CONGÉNITA DE COLUMNA DE SUSTANCIA BLANCA DE MÉDULA ESPINAL"
  },
  {
    "codigo":292571004,
    "descripcion":"REACCIÓN ADVERSA A LA ACRIVASTINA"
  },
  {
    "codigo":227035005,
    "descripcion":"TRISOMÍA DISTAL PARCIAL 21Q"
  },
  {
    "codigo":718555006,
    "descripcion":"ESCLEROSIS LATERAL AMIOTRÓFICA JUVENIL"
  },
  {
    "codigo":63195009,
    "descripcion":"AGOTAMIENTO SEXUAL"
  },
  {
    "codigo":126896003,
    "descripcion":"NEOPLASIA DEL PENE"
  },
  {
    "codigo":94128004,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE TRACTO UVEAL DEL OJO"
  },
  {
    "codigo":1306544005,
    "descripcion":"NEOPLASIA MALIGNA CON METÁSTASIS A CUADRANTE INFERIOR INTERNO DE MAMA"
  },
  {
    "codigo":290736009,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR PACLITAXEL"
  },
  {
    "codigo":419973004,
    "descripcion":"HALLADO MUERTO"
  },
  {
    "codigo":288901004,
    "descripcion":"CAPAZ DE RETENER EL ALIMENTO EN LA BOCA"
  },
  {
    "codigo":714885004,
    "descripcion":"NO PASA DE UNA UBICACIÓN A OTRA"
  },
  {
    "codigo":92293007,
    "descripcion":"NEOPLASIA BENIGNA DE LA FARINGE"
  },
  {
    "codigo":1237338002,
    "descripcion":"HIPERTERMIA MALIGNA INDUCIDA POR EJERCICIO"
  },
  {
    "codigo":90458007,
    "descripcion":"HEMORROIDES INTERNAS"
  },
  {
    "codigo":385370007,
    "descripcion":"ESTADIO DE LA FEDERACIÓN INTERNACIONAL DE GINECOLOGÍA Y OBSTETRICIA (FIGO) PARA CARCINOMA VULVAR - HALLAZGO"
  },
  {
    "codigo":418138009,
    "descripcion":"HALLAZGO RELACIONADO CON EL ESTADO DEL PACIENTE"
  },
  {
    "codigo":713050009,
    "descripcion":"FALLECIDO EN UNIDAD DE APRENDIZAJE PARA DISCAPACITADOS"
  },
  {
    "codigo":287066008,
    "descripcion":"FRACTURA PATOLÓGICA - ANTEBRAZO"
  },
  {
    "codigo":55855009,
    "descripcion":"TRASTORNO DEL PERICARDIO"
  },
  {
    "codigo":840452004,
    "descripcion":"ENFERMEDAD DE CREUTZFELDT-JAKOB CLÁSICA ESPORÁDICA"
  },
  {
    "codigo":283396008,
    "descripcion":"HERIDA CORTANTE"
  },
  {
    "codigo":281561000,
    "descripcion":"TERATOMA SACROCOCCÍGEO"
  },
  {
    "codigo":609241003,
    "descripcion":"VIVE EN DEPARTAMENTO CON ACCESO POR ASCENSOR"
  },
  {
    "codigo":248793004,
    "descripcion":"ERECCIÓN SIN ORGASMO"
  },
  {
    "codigo":702771005,
    "descripcion":"USO DE DROGAS ILÍCITAS DESCONOCIDO"
  },
  {
    "codigo":771246003,
    "descripcion":"QUEMADURA PROFUNDA DE ESPESOR TOTAL CON COMPROMISO ÓSEO"
  },
  {
    "codigo":410798004,
    "descripcion":"ARTRITIS IDIOPÁTICA JUVENIL, OLIGOARTRITIS"
  },
  {
    "codigo":17582006,
    "descripcion":"INTOXICACIÓN POR MEDICAGO DENTICULATUM"
  },
  {
    "codigo":246958007,
    "descripcion":"OPACIDADES REGULARES DEL ESTROMA DE LA CÓRNEA"
  },
  {
    "codigo":277891000,
    "descripcion":"DEDO DEL PIE EN SALCHICHA"
  },
  {
    "codigo":310659001,
    "descripcion":"PESO AL NACER: 1000-2499 G"
  },
  {
    "codigo":1229998009,
    "descripcion":"HAMARTOMA COMBINADO DE RETINA Y EPITELIO PIGMENTARIO RETINIANO"
  },
  {
    "codigo":212355006,
    "descripcion":"LESIÓN DE LOS NERVIOS Y LA MÉDULA ESPINAL A NIVEL DEL CUELLO"
  },
  {
    "codigo":210520000,
    "descripcion":"SECCIÓN PARCIAL DE TENDÓN DE TRÍCEPS"
  },
  {
    "codigo":1259096007,
    "descripcion":"TRASTORNO AUTONÓMICO CAUSADO POR TOXINA MARINA"
  },
  {
    "codigo":732973003,
    "descripcion":"DIAGNÓSTICO MORFOLÓGICO, SE REQUIEREN ESTUDIOS ADICIONALES"
  },
  {
    "codigo":765741003,
    "descripcion":"ADENOCARCINOMA DE VESÍCULA BILIAR Y VÍA BILIAR EXTRAHEPÁTICA"
  },
  {
    "codigo":1290029007,
    "descripcion":"TRASTORNO DE REGIÓN DE OJO IZQUIERDO"
  },
  {
    "codigo":11775011000119108,
    "descripcion":"CONTUSIÓN DE MANO DERECHA"
  },
  {
    "codigo":208685009,
    "descripcion":"FRACTURA NO EXPUESTA DE CUELLO DE ASTRÁGALO"
  },
  {
    "codigo":1222658006,
    "descripcion":"SÍNDROME DE RETRASO GLOBAL DE DESARROLLO, ALOPECIA, MACROCEFALIA, DISMORFISMO FACIAL Y ANOMALÍAS CEREBRALES ESTRUCTURALES"
  },
  {
    "codigo":403458008,
    "descripcion":"COMPROMISO CUTÁNEO LOCALIZADO POR CARCINOMA MAMARIO"
  },
  {
    "codigo":73943003,
    "descripcion":"POSICIÓN ANÓMALA DE LOS ÓRGANOS DIGESTIVOS"
  },
  {
    "codigo":237783006,
    "descripcion":"MASA SUPRARRENAL"
  },
  {
    "codigo":1351895009,
    "descripcion":"HEMANGIOBLASTOMA DE MÉDULA ESPINAL"
  },
  {
    "codigo":235948002,
    "descripcion":"PANCREATITIS AGUDA POSQUIRÚRGICA"
  },
  {
    "codigo":37505000,
    "descripcion":"ESTADO HOMÓLOGO"
  },
  {
    "codigo":234113000,
    "descripcion":"VASO LINFÁTICO HIPOPLÁSICO"
  },
  {
    "codigo":1153452008,
    "descripcion":"MIOCARDIOPATÍA DILATADA DEBIDA A MIOCARDITIS PARASITARIA"
  },
  {
    "codigo":168577003,
    "descripcion":"RADIOGRAFÍA SIMPLE DE COLUMNA VERTEBRAL DORSAL NORMAL"
  },
  {
    "codigo":133141000112108,
    "descripcion":"CON RIESGO ELEVADO DE INTUBACIÓN TRAQUEAL DIFICULTOSA"
  },
  {
    "codigo":10261000112105,
    "descripcion":"SALMONELLA EBRIE O SALMONELLA MONSCHAUI"
  },
  {
    "codigo":299649003,
    "descripcion":"AMPUTADO A NIVEL DE REGIÓN MEDIA DE MUSLO"
  },
  {
    "codigo":70273001,
    "descripcion":"INTOXICACIÓN CAUSADA POR PARACETAMOL"
  },
  {
    "codigo":12240061000119108,
    "descripcion":"MICROCALCIFICACIÓN MAMOGRÁFICA DE MAMA IZQUIERDA"
  },
  {
    "codigo":365185002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA SENTARSE EN LA BAÑERA"
  },
  {
    "codigo":2902006,
    "descripcion":"TIEMPO DE VIDA DE LOS LINFOCITOS DISMINUIDO"
  },
  {
    "codigo":363350007,
    "descripcion":"NEOPLASIA MALIGNA DE CIEGO"
  },
  {
    "codigo":164907000,
    "descripcion":"BLOQUEO DE RAMA DERECHA EN EL ELECTROCARDIOGRAMA"
  },
  {
    "codigo":232278009,
    "descripcion":"FRACTURA TRANSVERSAL DE HUESO TEMPORAL"
  },
  {
    "codigo":230443000,
    "descripcion":"EPILEPSIA POR SUSPENSIÓN DE NARCÓTICOS"
  },
  {
    "codigo":166742007,
    "descripcion":"NIVEL DE ZINC SÉRICO POR DEBAJO DE RANGO DE REFERENCIA"
  },
  {
    "codigo":263211006,
    "descripcion":"FRACTURA DE HUESO SESAMOIDEO DE MANO"
  },
  {
    "codigo":32000005,
    "descripcion":"DIFICULTAD PARA LA COMUNICACIÓN VERBAL"
  },
  {
    "codigo":294144006,
    "descripcion":"ALERGIA A KETOTIFENO"
  },
  {
    "codigo":11777521000119100,
    "descripcion":"DESGARRO DE TRÍCEPS BRAQUIAL IZQUIERDO"
  },
  {
    "codigo":292309000,
    "descripcion":"REACCIÓN ADVERSA A FÁRMACOS ANTIDEPRESIVOS TETRACÍCLICOS"
  },
  {
    "codigo":1177045000,
    "descripcion":"ENCEFALITIS POR VIRUS STRATFORD"
  },
  {
    "codigo":194005002,
    "descripcion":"CELULITIS ORBITARIA"
  },
  {
    "codigo":95701005,
    "descripcion":"ATROFIA RETINIANA PROGRESIVA GENERALIZADA"
  },
  {
    "codigo":30165006,
    "descripcion":"NACIMIENTO PREMATURO DE GEMELOS DICIGÓTICOS, UNO VIVO, UNO MUERTO"
  },
  {
    "codigo":290474000,
    "descripcion":"INTOXICACIÓN POR FÁRMACO ANTIESPASMÓDICO"
  },
  {
    "codigo":126634001,
    "descripcion":"NEOPLASIA MANDIBULAR"
  },
  {
    "codigo":716458004,
    "descripcion":"CAPAZ DE TOLERAR EL CAMBIO DE PAÑAL"
  },
  {
    "codigo":308721000119103,
    "descripcion":"GANGLIÓN DE RODILLA DERECHA"
  },
  {
    "codigo":1339050006,
    "descripcion":"GLIOMA MALIGNO METASTÁSICO"
  },
  {
    "codigo":92031000,
    "descripcion":"NEOPLASIA BENIGNA DEL LIGAMENTO ANCHO"
  },
  {
    "codigo":286804000,
    "descripcion":"CARÁCTER FLEXIBLE"
  },
  {
    "codigo":417876002,
    "descripcion":"VÍCTIMA DE RELACIÓN SEXUAL ABUSIVA"
  },
  {
    "codigo":1237076003,
    "descripcion":"DEFECTO DE TABIQUE AURICULOVENTRICULAR ADQUIRIDO"
  },
  {
    "codigo":188500005,
    "descripcion":"LINFOSARCOMA DE GANGLIOS LINFÁTICOS DE CABEZA, CARA Y CUELLO"
  },
  {
    "codigo":448809003,
    "descripcion":"TRONCO ARTERIAL COMÚN CON OBSTRUCCIÓN DEL CAYADO AÓRTICO"
  },
  {
    "codigo":88361008,
    "descripcion":"CELULITIS DE LA INGLE"
  },
  {
    "codigo":284969009,
    "descripcion":"INCAPAZ DE REALIZAR ACTIVIDAD RELACIONADA CON EL VESTIRSE"
  },
  {
    "codigo":709118002,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO A NIVEL DE PIERNA"
  },
  {
    "codigo":283134000,
    "descripcion":"AMPOLLA TRAUMÁTICA DEL TALÓN"
  },
  {
    "codigo":838355002,
    "descripcion":"LEUCEMIA MIELOIDE AGUDA CON FUSIÓN CBFB::MYH11"
  },
  {
    "codigo":50088001,
    "descripcion":"HEMATOMA DE BAZO SIN RUPTURA DE LA CÁPSULA Y SIN HERIDA ABIERTA HACIA CAVIDAD ABDOMINAL"
  },
  {
    "codigo":246696006,
    "descripcion":"PATRÓN DE VERGENCIA EN V"
  },
  {
    "codigo":1074981000119100,
    "descripcion":"ARTRITIS DE ARTICULACIÓN SACROILÍACA DERECHA"
  },
  {
    "codigo":81021006,
    "descripcion":"MIOMA DE LA PRÓSTATA"
  },
  {
    "codigo":1162365007,
    "descripcion":"OSTEONECROSIS DE REGIÓN DE HOMBRO DEBIDA A HEMOGLOBINOPATÍA"
  },
  {
    "codigo":277629008,
    "descripcion":"LINFOMA MALIGNO DIFUSO DE CÉLULAS GRANDES NO CLIVADAS"
  },
  {
    "codigo":111954003,
    "descripcion":"CONTRACCIÓN MUSCULAR AUMENTADA DE MANERA ANORMAL"
  },
  {
    "codigo":243026007,
    "descripcion":"LESIÓN POR RÁFAGA EXPLOSIVA DE PROYECTIL DE ARTILLERÍA"
  },
  {
    "codigo":44583001,
    "descripcion":"ENFERMEDAD POR EL VIRUS BWAMBA"
  },
  {
    "codigo":110119002,
    "descripcion":"LACERACIÓN SIMPLE DE LA ENCÍA ALVEOLAR DEL MAXILAR SUPERIOR"
  },
  {
    "codigo":699943005,
    "descripcion":"ANOMALÍA CONGÉNITA DE REGIÓN VERTEBRAL DEL DORSO"
  },
  {
    "codigo":208423006,
    "descripcion":"FRACTURA EXPUESTA DE CUELLO DE METACARPIANO DE PULGAR"
  },
  {
    "codigo":372263007,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA LATERAL, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":206588008,
    "descripcion":"HIPERTONÍA CONGÉNITA"
  },
  {
    "codigo":432294000,
    "descripcion":"DISPLASIA VASCULAR RENAL"
  },
  {
    "codigo":237521008,
    "descripcion":"HIPOTIROIDISMO POR ANTICUERPO BLOQUEANTE DEL RECEPTOR DE TSH"
  },
  {
    "codigo":1251494000,
    "descripcion":"METÁSTASIS DE CARCINOMA DE REGIÓN RETROMOLAR"
  },
  {
    "codigo":303057009,
    "descripcion":"LINFOMA MALIGNO, CÉLULA DEL CENTRO FOLICULAR, NO CLIVADA"
  },
  {
    "codigo":202918005,
    "descripcion":"TENOSINOVITIS TIBIAL ANTERIOR"
  },
  {
    "codigo":301222005,
    "descripcion":"CUERDAS VOCALES NORMALES"
  },
  {
    "codigo":235686008,
    "descripcion":"POLIPOSIS DE GLÁNDULA FÚNDICA ESTOMACAL"
  },
  {
    "codigo":364923003,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA SENTARSE EN UNA SILLA"
  },
  {
    "codigo":299387004,
    "descripcion":"ARTICULACIÓN DE LA RODILLA HELADA AL TACTO"
  },
  {
    "codigo":233851006,
    "descripcion":"ENDOCARDITIS RICKÉTSICA"
  },
  {
    "codigo":199248002,
    "descripcion":"ANEMIA FERROPÉNICA DEL EMBARAZO"
  },
  {
    "codigo":232016005,
    "descripcion":"VITREORRETINOPATÍA PROLIFERATIVA"
  },
  {
    "codigo":2640006,
    "descripcion":"ESTADIO CLÍNICO IV"
  },
  {
    "codigo":461392009,
    "descripcion":"CONDUCTO ARTERIOSO EN POSICIÓN NORMAL EN EL LADO IZQUIERDO"
  },
  {
    "codigo":295717002,
    "descripcion":"SOBREDOSIS DE CITARABINA"
  },
  {
    "codigo":805002,
    "descripcion":"NEUMOCONIOSIS CAUSADA POR SÍLICE"
  },
  {
    "codigo":230181004,
    "descripcion":"ENCEFALITIS BACTERIANA"
  },
  {
    "codigo":262949005,
    "descripcion":"HEMATOMA INTRACRANEAL EXTRADURAL TRAUMÁTICO"
  },
  {
    "codigo":721701002,
    "descripcion":"CARCINOMA NEUROENDOCRINO PRIMARIO DE RECTO"
  },
  {
    "codigo":11999321000119102,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO DE ANTEBRAZO IZQUIERDO"
  },
  {
    "codigo":424954002,
    "descripcion":"CARCINOMATOSIS DE CÉLULAS GRANDES INDIFERENCIADAS"
  },
  {
    "codigo":228346002,
    "descripcion":"NO TIENE ESTRATEGIAS PARA CONTROLAR LA BEBIDA"
  },
  {
    "codigo":457722005,
    "descripcion":"RUPTURA DE VALVA DE VÁLVULA TRONCAL"
  },
  {
    "codigo":293882007,
    "descripcion":"ALERGIA A CICLOBARBITAL"
  },
  {
    "codigo":292047001,
    "descripcion":"REACCIÓN ADVERSA A LA FENAZOCINA"
  },
  {
    "codigo":128207002,
    "descripcion":"NEUROPATÍA AXÓNICA GIGANTE"
  },
  {
    "codigo":29903003,
    "descripcion":"AISLAMIENTO POR PRIVACIÓN SENSITIVA"
  },
  {
    "codigo":95439001,
    "descripcion":"AFONÍA PSICÓGENA"
  },
  {
    "codigo":61277005,
    "descripcion":"RITMO IDIOVENTRICULAR ACELERADO"
  },
  {
    "codigo":290212006,
    "descripcion":"INTOXICACIÓN POR MEPTAZINOL"
  },
  {
    "codigo":93604006,
    "descripcion":"OSIFICACIÓN INCOMPLETA DE ESTERNEBRA"
  },
  {
    "codigo":716196007,
    "descripcion":"ENFERMEDAD POLIQUÍSTICA HEPÁTICA AISLADA"
  },
  {
    "codigo":286542000,
    "descripcion":"INANICIÓN POR FALTA DE ALIMENTO"
  },
  {
    "codigo":417614006,
    "descripcion":"EXTENSIÓN SACRA"
  },
  {
    "codigo":89934007,
    "descripcion":"CORONAMIENTO"
  },
  {
    "codigo":778062008,
    "descripcion":"QUERATODERMIA PALMOPLANTAR DIFUSA CON FISURAS DOLOROSAS"
  },
  {
    "codigo":253774006,
    "descripcion":"FÍSTULA CONGÉNITA DEL ANO"
  },
  {
    "codigo":712526008,
    "descripcion":"TUMOR DE CÉLULAS GIGANTES DE HUESO CORTO DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":1234979003,
    "descripcion":"TRASTORNO NEONATAL DEBIDO A VASA PREVIA DE CORDÓN UMBILICAL"
  },
  {
    "codigo":284707004,
    "descripcion":"GOLPEARSE LA CABEZA CONTRA OTRAS PARTES DEL CUERPO"
  },
  {
    "codigo":55331005,
    "descripcion":"REGURGITACIÓN DE COMIDA EN EL RECIÉN NACIDO"
  },
  {
    "codigo":250104001,
    "descripcion":"INESTABILIDAD DEL LIGAMENTO LATERAL INTERNO"
  },
  {
    "codigo":446712002,
    "descripcion":"TROMBOEMBOLIA DE ARTERIA PRECEREBRAL"
  },
  {
    "codigo":282872002,
    "descripcion":"INCAPAZ DE PONERSE DE PIE"
  },
  {
    "codigo":340211000119107,
    "descripcion":"ANILLO DE KAYSER-FLEISCHER DE OJO IZQUIERDO"
  },
  {
    "codigo":281037003,
    "descripcion":"SALUD DEL NIÑO - OBSERVACIONES"
  },
  {
    "codigo":1296845004,
    "descripcion":"EDEMA DE PREPUCIO DE PENE"
  },
  {
    "codigo":248269005,
    "descripcion":"CANSADO CON EL MÍNIMO EJERCICIO"
  },
  {
    "codigo":1231309005,
    "descripcion":"SÍNDROME DE DEPLECIÓN DE ADN MITOCONDRIAL, FORMA MIOPÁTICA"
  },
  {
    "codigo":770722002,
    "descripcion":"MIOPATÍA PROXIMAL CON SIGNOS EXTRAPIRAMIDALES"
  },
  {
    "codigo":443042003,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL SISTEMA ESQUELÉTICO"
  },
  {
    "codigo":1260407007,
    "descripcion":"EPILEPSIA GENÉTICA GENERALIZADA"
  },
  {
    "codigo":406604002,
    "descripcion":"INFECCIÓN CAUSADA POR STAPHYLOCOCCUS AUREUS CON RESISTENCIA INTERMEDIA A VANCOMICINA"
  },
  {
    "codigo":46156007,
    "descripcion":"QUEMADURA DE PRIMER GRADO DE LA PARED DEL TÓRAX"
  },
  {
    "codigo":373836007,
    "descripcion":"CAMBIO EN LA QUIMIOTERAPIA - DECISIÓN DEL PACIENTE"
  },
  {
    "codigo":765217002,
    "descripcion":"TRASTORNO EN REMISIÓN PARCIAL EN RESPUESTA AL TRATAMIENTO"
  },
  {
    "codigo":372001002,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA CAVIDAD BUCAL"
  },
  {
    "codigo":699681002,
    "descripcion":"ARTRITIS GOTOSA DE ARTICULACIÓN TEMPOROMANDIBULAR"
  },
  {
    "codigo":109857003,
    "descripcion":"MESOTELIOMA DEL MESOCOLON"
  },
  {
    "codigo":16015911000119102,
    "descripcion":"ARTRITIS GOTOSA DE AMBOS TOBILLOS"
  },
  {
    "codigo":1254902003,
    "descripcion":"DERMATOSIS OCUPACIONAL CAUSADA POR BAJAS TEMPERATURAS"
  },
  {
    "codigo":1287670006,
    "descripcion":"CONVULSIÓN EPILÉPTICA DE LÓBULO PARIETAL"
  },
  {
    "codigo":239094006,
    "descripcion":"NECROSIS GRASA SUBCUTÁNEA DEL RECIÉN NACIDO"
  },
  {
    "codigo":402934006,
    "descripcion":"CELULITIS ESTREPTOCÓCICA DEL OÍDO EXTERNO"
  },
  {
    "codigo":237259004,
    "descripcion":"VARIEDAD DE POSICIÓN PLACENTARIA"
  },
  {
    "codigo":1187531009,
    "descripcion":"OBESIDAD DEBIDA A ENFERMEDAD HIPOFISARIA"
  },
  {
    "codigo":6048002,
    "descripcion":"DERMATITIS EXFOLIATIVA GENERALIZADA SUBAGUDA"
  },
  {
    "codigo":200821000,
    "descripcion":"DERMATITIS DE CONTACTO CAUSADA POR PLANTAS"
  },
  {
    "codigo":169888008,
    "descripcion":"TALLA AL NACER = ENTRE PERCENTILOS 3 Y 9"
  },
  {
    "codigo":299125002,
    "descripcion":"TUMEFACCIÓN ÓSEA DE DEDO DE LA MANO"
  },
  {
    "codigo":366496008,
    "descripcion":"HALLAZGO RELACIONADO CON LA AMPLITUD DE MOVIMIENTO ACTIVO DE FLEXIÓN HORIZONTAL DE HOMBRO"
  },
  {
    "codigo":397429008,
    "descripcion":"TRASTORNO SIMILAR A LA DIFTERIA CAUSADO POR CORYNEBACTERIUM ULCERANS"
  },
  {
    "codigo":102517009,
    "descripcion":"ANCIANA SANA"
  },
  {
    "codigo":262687004,
    "descripcion":"CONTUSIÓN Y LACERACIÓN CEREBELOSA"
  },
  {
    "codigo":721439006,
    "descripcion":"LESIÓN COMPLETA DE MÉDULA ESPINAL AL NIVEL DEL DÉCIMO SEGMENTO DORSAL"
  },
  {
    "codigo":197151007,
    "descripcion":"FISURA ANAL AGUDA"
  },
  {
    "codigo":293620004,
    "descripcion":"ALERGIA A INDOMETACINA"
  },
  {
    "codigo":1080001000119106,
    "descripcion":"SARCOMA DE EWING PRIMARIO DE HUESO DE PIE IZQUIERDO"
  },
  {
    "codigo":129780006,
    "descripcion":"LOCALIZACIÓN EN HORA 9 EN LA MAMOGRAFÍA"
  },
  {
    "codigo":15743681000119106,
    "descripcion":"DOLOR EN AMBOS OMÓPLATOS"
  },
  {
    "codigo":95177001,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE BORDE BERMELLÓN DE LABIO SUPERIOR"
  },
  {
    "codigo":15635291000119101,
    "descripcion":"BEBÉ PREMATURO, 35 SEMANAS"
  },
  {
    "codigo":160713007,
    "descripcion":"NO HAY BAÑO DENTRO DE LA CASA"
  },
  {
    "codigo":291785008,
    "descripcion":"INTOXICACIÓN POR CARBIMAZOL"
  },
  {
    "codigo":422857009,
    "descripcion":"PELIGROS FÍSICOS EN EL AMBIENTE"
  },
  {
    "codigo":27806003,
    "descripcion":"PERICARDITIS POR VIRUS COXSACKIE"
  },
  {
    "codigo":60574005,
    "descripcion":"PLACENTA GEMELAR"
  },
  {
    "codigo":124275001,
    "descripcion":"DEFICIENCIA DE HIPOXANTINA FOSFORRIBOSILTRANSFERASA"
  },
  {
    "codigo":93342009,
    "descripcion":"POSICIÓN ANÓMALA CONGÉNITA DE TROMPA DE FALOPIO"
  },
  {
    "codigo":224414009,
    "descripcion":"SIN INSTALACIONES SANITARIAS EN EL TRABAJO"
  },
  {
    "codigo":25971005,
    "descripcion":"PEDOFILIA, TIPO EXCLUSIVO"
  },
  {
    "codigo":89672000,
    "descripcion":"MASTITIS RETROMAMARIA ASOCIADA CON EL PARTO"
  },
  {
    "codigo":253512000,
    "descripcion":"TETRALOGÍA DE FALLOT CON ESTENOSIS PULMONAR"
  },
  {
    "codigo":187976009,
    "descripcion":"NEOPLASIA MALIGNA DEL CUARTO METATARSIANO"
  },
  {
    "codigo":55069005,
    "descripcion":"ABSCESO PERIURETRAL"
  },
  {
    "codigo":708594000,
    "descripcion":"RESTAURACIÓN DENTAL INDIRECTA PRESENTE"
  },
  {
    "codigo":774130003,
    "descripcion":"ARTROPATÍA DE ARTICULACIÓN DE RODILLA DERECHA"
  },
  {
    "codigo":282610004,
    "descripcion":"NO GATEA"
  },
  {
    "codigo":51399001,
    "descripcion":"ENCEFALOPATÍA TÓXICA CAUSADA POR PLOMO"
  },
  {
    "codigo":315378009,
    "descripcion":"NACIDO EN BAHRAIN"
  },
  {
    "codigo":410012006,
    "descripcion":"SECUELA DE FLEBITIS"
  },
  {
    "codigo":49564006,
    "descripcion":"TRASTORNO DE PÁNICO CON AGORAFOBIA, EVITACIÓN AGORAFÓBICA LEVE Y ATAQUES DE PÁNICO MODERADOS"
  },
  {
    "codigo":80497001,
    "descripcion":"ÚLCERA NASAL"
  },
  {
    "codigo":1260145003,
    "descripcion":"DOLOR DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":211569008,
    "descripcion":"LESIÓN ABIERTA POR APLASTAMIENTO, MUÑECA O MANO"
  },
  {
    "codigo":1082511000119102,
    "descripcion":"COMA HEPÁTICO DEBIDO A INSUFICIENCIA HEPÁTICA AGUDA"
  },
  {
    "codigo":703089009,
    "descripcion":"CÚSPIDE EN ÉMBOLO"
  },
  {
    "codigo":45894003,
    "descripcion":"MEDIONECROSIS AÓRTICA"
  },
  {
    "codigo":373574007,
    "descripcion":"ARTROPATÍA TRAUMÁTICA DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":699419000,
    "descripcion":"INFLAMACIÓN DE LIGAMENTO ESTILOMANDIBULAR"
  },
  {
    "codigo":734022008,
    "descripcion":"SÍNDROME SEMEJANTE AL SÍNDROME DE WOLFRAM"
  },
  {
    "codigo":404507002,
    "descripcion":"HIFAS DEL REINO FUNGI DETECTADAS"
  },
  {
    "codigo":240667000,
    "descripcion":"MICROSPORIDIOSIS NO INTESTINAL"
  },
  {
    "codigo":764955006,
    "descripcion":"SÍNDROME DE LAUBRY PEZZI"
  },
  {
    "codigo":207899008,
    "descripcion":"FRACTURA NO EXPUESTA DEL AXIS, APÓFISIS ESPINOSA"
  },
  {
    "codigo":345231000119105,
    "descripcion":"RETINITIS FOCAL BILATERAL DE MÁCULAS"
  },
  {
    "codigo":238832003,
    "descripcion":"ELASTODERMIA"
  },
  {
    "codigo":402672004,
    "descripcion":"LINFEDEMA IATROGÉNICO"
  },
  {
    "codigo":1285573001,
    "descripcion":"HIPERTENSIÓN OCULAR POR CÉLULAS FANTASMAS"
  },
  {
    "codigo":40389006,
    "descripcion":"SÍNDROME DE TRISOMÍA PARCIAL 12Q"
  },
  {
    "codigo":300698000,
    "descripcion":"DIFICULTAD PARA USAR UNA CUENTA FINANCIERA"
  },
  {
    "codigo":431770003,
    "descripcion":"MACROCEFALIA FETAL"
  },
  {
    "codigo":71322004,
    "descripcion":"SÍNDROME DE HIPERMOVILIDAD ARTICULAR FAMILIAR"
  },
  {
    "codigo":366234005,
    "descripcion":"HALLAZGO RELACIONADO CON EL COLOR DE LAS ENCÍAS"
  },
  {
    "codigo":298863001,
    "descripcion":"ARTICULACIÓN DE HOMBRO ERITEMATOSA"
  },
  {
    "codigo":724847001,
    "descripcion":"MELANOSIS DE MUCOSA DE ORIFICIO CORPORAL"
  },
  {
    "codigo":266095003,
    "descripcion":"GANGRENA GASEOSA CAUSADA POR PAENICLOSTRIDIUM SORDELLII"
  },
  {
    "codigo":296627008,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE ESPECTINOMICINA"
  },
  {
    "codigo":3951002,
    "descripcion":"PROCTITIS"
  },
  {
    "codigo":11787561000119104,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE DEDO MEDIO DERECHO"
  },
  {
    "codigo":2116002,
    "descripcion":"FORMACIÓN ÓSEA INTRAMEMBRANOSA"
  },
  {
    "codigo":723012002,
    "descripcion":"ERUPCIÓN CUTÁNEA AGUDA MACULOPAPULAR"
  },
  {
    "codigo":428100006,
    "descripcion":"NEOPLASIA MALIGNA DE ESTRUCTURA DE LA CAVIDAD TORÁCICA"
  },
  {
    "codigo":1148996008,
    "descripcion":"INTOXICACIÓN POR METANO"
  },
  {
    "codigo":10968361000119107,
    "descripcion":"LACERACIÓN DE DEDO DEL PIE DERECHO"
  },
  {
    "codigo":281004,
    "descripcion":"DEMENCIA ASOCIADA CON ALCOHOLISMO"
  },
  {
    "codigo":721177006,
    "descripcion":"LESIÓN TRAUMÁTICA QUE COMPLICA EL EMBARAZO"
  },
  {
    "codigo":196889007,
    "descripcion":"EVENTRACIÓN IRREDUCTIBLE"
  },
  {
    "codigo":295193008,
    "descripcion":"SOBREDOSIS DE FENTANILO"
  },
  {
    "codigo":15883561000119108,
    "descripcion":"ECOGRAFÍA DE RIÑÓN ANORMAL"
  },
  {
    "codigo":291523001,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR TRIMETOPRIMA"
  },
  {
    "codigo":94915007,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":93080000,
    "descripcion":"FENESTRACIÓN CONGÉNITA DE HUESO EXOCCIPITAL"
  },
  {
    "codigo":781208001,
    "descripcion":"EXTENDIDA, ROTADA E INCLINADA HACIA UN LADO - POSICIÓN VERTEBRAL"
  },
  {
    "codigo":29379007,
    "descripcion":"SÍNDROME DE MONOSOMÍA PARCIAL 8Q"
  },
  {
    "codigo":289688003,
    "descripcion":"ABDOMEN GESTANTE AUMENTADO TRANSVERSALMENTE DE TAMAÑO"
  },
  {
    "codigo":27544004,
    "descripcion":"TRASTORNO DEL DESARROLLO DE LA COORDINACIÓN"
  },
  {
    "codigo":191384005,
    "descripcion":"BAZO FLOTANTE"
  },
  {
    "codigo":224152001,
    "descripcion":"TIENE MASCOTAS"
  },
  {
    "codigo":715672007,
    "descripcion":"DISPLASIA EPIFISARIA MÚLTIPLE TIPO 4"
  },
  {
    "codigo":1172589000,
    "descripcion":"SÍNDROME CONGÉNITO DE ONFALOCELE, HERNIA DIAFRAGMÁTICA, ANOMALÍAS CARDIOVASCULARES, DEFECTO DEL RAYO RADIAL"
  },
  {
    "codigo":11843011000119108,
    "descripcion":"LACERACIÓN DE ARTERIA CARÓTIDA IZQUIERDA"
  },
  {
    "codigo":23874000,
    "descripcion":"AMEBIASIS CRÓNICA"
  },
  {
    "codigo":713837009,
    "descripcion":"NEURALGIA PERIFÉRICA SEGMENTARIA POSINFECCIOSA"
  },
  {
    "codigo":417090000,
    "descripcion":"HALLAZGO RELACIONADO CON EL MOVIMIENTO VERTEBRAL"
  },
  {
    "codigo":56642004,
    "descripcion":"FRACTURA DE EXTREMO ESTERNAL DE CLAVÍCULA"
  },
  {
    "codigo":675421000119103,
    "descripcion":"BLEFARITIS DE AMBOS PÁRPADOS CAUSADA POR STAPHYLOCOCCUS"
  },
  {
    "codigo":89410007,
    "descripcion":"AFASIA DE CONDUCCIÓN"
  },
  {
    "codigo":1269058008,
    "descripcion":"LESIÓN DE VASO SANGUÍNEO DE PELVIS"
  },
  {
    "codigo":286018008,
    "descripcion":"NO APAGA UN ARTEFACTO ELECTRODOMÉSTICO"
  },
  {
    "codigo":710167004,
    "descripcion":"TROMBOSIS RECURRENTE DE VENA PROFUNDA"
  },
  {
    "codigo":415255004,
    "descripcion":"EVENTRACIÓN RECURRENTE DE PARED ABDOMINAL ANTERIOR CON GANGRENA"
  },
  {
    "codigo":284183005,
    "descripcion":"TRASTORNO DESCAMATIVO ERITEMATOSO RECALCITRANTE"
  },
  {
    "codigo":282348002,
    "descripcion":"FÍSTULA ARTERIOVENOSA RENAL ADQUIRIDA"
  },
  {
    "codigo":216812003,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR PEGAMENTOS"
  },
  {
    "codigo":249580004,
    "descripcion":"POLO INFERIOR DE RIÑÓN, PALPABLE"
  },
  {
    "codigo":870337002,
    "descripcion":"QUISTE EPIDURAL ESPINAL CAUSADO POR PARÁSITO"
  },
  {
    "codigo":568191000005104,
    "descripcion":"USO INAPROPIADO DE SUSTANCIAS ANTES DE CONFIRMACIÓN DE EMBARAZO"
  },
  {
    "codigo":278678001,
    "descripcion":"ÁNGULO INTERINCISAL DENTAL REDUCIDO"
  },
  {
    "codigo":247745008,
    "descripcion":"ALUCINACIONES AUDITIVAS DISOCIATIVAS"
  },
  {
    "codigo":668031000005107,
    "descripcion":"ERITROCITOS EN ORINA = NEGATIVO"
  },
  {
    "codigo":704662005,
    "descripcion":"INCUMPLIMIENTO CON EL RÉGIMEN DE EJERCICIOS"
  },
  {
    "codigo":735595001,
    "descripcion":"ISQUEMIA INTESTINAL AGUDA DEBIDA A OBSTRUCCIÓN DE LA VASCULATURA INTESTINAL"
  },
  {
    "codigo":473451005,
    "descripcion":"HALLAZGO RELACIONADO CON LA AORTA"
  },
  {
    "codigo":29731000175102,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN EN CADERA DERECHA ESTADIO I"
  },
  {
    "codigo":80235008,
    "descripcion":"EMBOLIA DE ARTERIA HEPÁTICA"
  },
  {
    "codigo":1290816006,
    "descripcion":"LIPOMA ATÍPICO DE CÉLULAS FUSIFORMES"
  },
  {
    "codigo":209472007,
    "descripcion":"ESGUINCE DE PULGAR, ARTICULACIÓN METACARPOFALÁNGICA, LIGAMENTO LATERAL CUBITAL"
  },
  {
    "codigo":12864009,
    "descripcion":"FORÚNCULO DEL ESCROTO"
  },
  {
    "codigo":43797002,
    "descripcion":"ESTRECHEZ DE VÍA BILIAR"
  },
  {
    "codigo":11029002,
    "descripcion":"APOPLEJÍA PULMONAR"
  },
  {
    "codigo":240405001,
    "descripcion":"REACCIÓN INVERSA DE LA LEPRA"
  },
  {
    "codigo":109333005,
    "descripcion":"OSTEORRADIONECROSIS"
  },
  {
    "codigo":41962002,
    "descripcion":"SECUENCIA DE OLIGOHIDRAMNIOS"
  },
  {
    "codigo":369642003,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA DE PRÓSTATA APICAL, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":1156074004,
    "descripcion":"FALLA DE DISPOSITIVO"
  },
  {
    "codigo":402410006,
    "descripcion":"DERMOGRAFISMO SINTOMÁTICO"
  },
  {
    "codigo":205802006,
    "descripcion":"SÍNDROME OCULOPALATODIGITAL"
  },
  {
    "codigo":236735003,
    "descripcion":"SONDA URINARIA INTERNA OBSTRUIDA"
  },
  {
    "codigo":105663003,
    "descripcion":"ENFERMEDAD CAUSADA POR DIPLOSTOMATIDAE"
  },
  {
    "codigo":302271003,
    "descripcion":"SE TRASLADA CON LA SILLA DE RUEDAS"
  },
  {
    "codigo":365972001,
    "descripcion":"PATRÓN DE BEBIDA DURANTE EL DÍA - HALLAZGO"
  },
  {
    "codigo":38292009,
    "descripcion":"TRASTORNO DE LOS ERITROCITOS"
  },
  {
    "codigo":429673002,
    "descripcion":"ARTERIOSCLEROSIS EN INJERTO-PUENTE DE ARTERIA CORONARIA"
  },
  {
    "codigo":724585005,
    "descripcion":"NEOPLASIA OSTEÓGENA BENIGNA DE COSTILLA"
  },
  {
    "codigo":34622000,
    "descripcion":"SUBLUXACIÓN TEMPOROMANDIBULAR"
  },
  {
    "codigo":1148734002,
    "descripcion":"INTOXICACIÓN POR ANTAGONISTA DE RECEPTOR DE ACETILCOLINA"
  },
  {
    "codigo":460606004,
    "descripcion":"ORIGEN ANÓMALO DE CONDUCTO ARTERIOSO EN AORTA ASCENDENTE"
  },
  {
    "codigo":11819051000119103,
    "descripcion":"ESGUINCE DE LIGAMENTO ACROMIOCLAVICULAR IZQUIERDO"
  },
  {
    "codigo":677931000119103,
    "descripcion":"PSEUDOAGUJERO MACULAR DE OJO IZQUIERDO"
  },
  {
    "codigo":296766006,
    "descripcion":"SOBREDOSIS DE TETRACICLINA"
  },
  {
    "codigo":131091002,
    "descripcion":"TIROXINA ANORMAL"
  },
  {
    "codigo":294931002,
    "descripcion":"ALERGIA A ÁCIDO FOLÍNICO"
  },
  {
    "codigo":1343507003,
    "descripcion":"SÍNDROME DE CORDÓN POSTERIOR DEBIDO A ESCLEROSIS MÚLTIPLE"
  },
  {
    "codigo":41311000087103,
    "descripcion":"HEMATOMA DE CUARTO DEDO DE PIE IZQUIERDO"
  },
  {
    "codigo":63720000,
    "descripcion":"HEMORRAGIA DE PÁRPADO"
  },
  {
    "codigo":293096000,
    "descripcion":"REACCIÓN ADVERSA A PRODUCTOS DE INMUNOGLOBULINAS"
  },
  {
    "codigo":43871000087103,
    "descripcion":"CORTE EN PIEL DE PULGAR DERECHO"
  },
  {
    "codigo":38751000087108,
    "descripcion":"SÍNDROME DE DOLOR TORÁCICO CRÓNICO PRIMARIO"
  },
  {
    "codigo":162024005,
    "descripcion":"DIFICULTAD PARA DEGLUTIR SÓLIDOS"
  },
  {
    "codigo":46431000087109,
    "descripcion":"FRACTURA DE CALCÁNEO IZQUIERDO"
  },
  {
    "codigo":291261004,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR CRACK DE COCAÍNA"
  },
  {
    "codigo":782781006,
    "descripcion":"OSTEOGÉNESIS IMPERFECTA CON MASA ÓSEA ELEVADA"
  },
  {
    "codigo":289426006,
    "descripcion":"DESCENSO DE LA PRESENTACIÓN"
  },
  {
    "codigo":125586008,
    "descripcion":"TRASTORNO PLACENTARIO"
  },
  {
    "codigo":92818009,
    "descripcion":"LEUCEMIA MIELOIDE CRÓNICA"
  },
  {
    "codigo":713575004,
    "descripcion":"EMBARAZO GEMELAR DICIGÓTICO"
  },
  {
    "codigo":418663008,
    "descripcion":"EL MARGEN DE RESECCIÓN QUIRÚRGICA INTERNO ES EL MARGEN NO AFECTADO MÁS CERCANO A LA NEOPLASIA MALIGNA"
  },
  {
    "codigo":1303399008,
    "descripcion":"FRACTURA DE FALANGE DE MANO IZQUIERDA"
  },
  {
    "codigo":449596004,
    "descripcion":"AURÍCULA IZQUIERDA DIVIDIDA CON DESEMBOCADURA DE ALGUNAS VENAS PULMONARES EN LA CÁMARA PROXIMAL Y DRENAJE EN LA AURÍCULA DERECHA Y OTRAS CONECTADAS DIRECTAMENTE A LA AURÍCULA IZQUIERDA"
  },
  {
    "codigo":283921000,
    "descripcion":"HEMATOMA DE LA URETRA"
  },
  {
    "codigo":12202181000119108,
    "descripcion":"LUXACIÓN RECURRENTE DE PRÓTESIS DE ARTICULACIÓN DE CADERA DERECHA"
  },
  {
    "codigo":216550002,
    "descripcion":"INTOXICACIÓN ACCIDENTAL CAUSADA POR ALUCINÓGENOS"
  },
  {
    "codigo":249318003,
    "descripcion":"DESVIACIÓN NASAL, CARTÍLAGO"
  },
  {
    "codigo":85478004,
    "descripcion":"TRASTORNO DEL IRIS"
  },
  {
    "codigo":247483008,
    "descripcion":"CRECIMIENTO EXCESIVO DE LAS UÑAS"
  },
  {
    "codigo":1163152001,
    "descripcion":"INFECCIÓN DE CEREBRO CAUSADA POR ORGANISMO DE LA FAMILIA FORMA DEMATIACEAE"
  },
  {
    "codigo":737168002,
    "descripcion":"ALTERACIÓN SENSITIVA DE VULVA"
  },
  {
    "codigo":81808003,
    "descripcion":"HEMARTROSIS"
  },
  {
    "codigo":1359760004,
    "descripcion":"TRASTORNO GENÉTICO DE OBESIDAD EN LA INFANCIA"
  },
  {
    "codigo":704400005,
    "descripcion":"CONOCIMIENTO DEFICIENTE SOBRE SERVICIOS COMUNITARIOS"
  },
  {
    "codigo":211045003,
    "descripcion":"ABRASIÓN DE PIEL DE FLANCO"
  },
  {
    "codigo":352761000119101,
    "descripcion":"MELANOMA MALIGNO PRIMARIO DE NERVIO PERIFÉRICO DE CADERA DERECHA"
  },
  {
    "codigo":735333005,
    "descripcion":"EQUIPAMIENTO DISPONIBLE"
  },
  {
    "codigo":473189005,
    "descripcion":"EN TRATAMIENTO CON INSULINA SUBCUTÁNEA PARA DIABETES MELLITUS"
  },
  {
    "codigo":1259621007,
    "descripcion":"COREA DEBIDA A TRASTORNO INMUNOLÓGICO"
  },
  {
    "codigo":440421009,
    "descripcion":"INCONTINENCIA FECAL POR TRASTORNO ANORRECTAL"
  },
  {
    "codigo":276581009,
    "descripcion":"REACCIÓN MEDICAMENTOSA EN EL RECIÉN NACIDO"
  },
  {
    "codigo":241978003,
    "descripcion":"BAROTRAUMA POR DESCENSO"
  },
  {
    "codigo":373050003,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM PARAFORTUITUM"
  },
  {
    "codigo":307514008,
    "descripcion":"DEFICIENCIA IDIOPÁTICA DE FACTOR VIII"
  },
  {
    "codigo":12602008,
    "descripcion":"ACRODERMITIS ENTEROPÁTICA ADQUIRIDA"
  },
  {
    "codigo":403983000,
    "descripcion":"HEMANGIOENDOTELIOMA KAPOSIFORME"
  },
  {
    "codigo":305679000,
    "descripcion":"ATENDIDO POR MÉDICO ESPECIALISTA EN VÍAS GENITOURINARIAS"
  },
  {
    "codigo":240143007,
    "descripcion":"OSTEOMIELITIS AGUDA DE TOBILLO"
  },
  {
    "codigo":762596000,
    "descripcion":"DOLOR CRÓNICO POSTERIOR A RADIOTERAPIA"
  },
  {
    "codigo":698895009,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: JONKHA"
  },
  {
    "codigo":860900002,
    "descripcion":"ALERGIA A BARBITURATO"
  },
  {
    "codigo":41700004,
    "descripcion":"CELULITIS DE LA REGIÓN SUBMANDIBULAR"
  },
  {
    "codigo":402148005,
    "descripcion":"DERMATOSIS CAUSADA POR LIENDRES"
  },
  {
    "codigo":433081000,
    "descripcion":"AMNESIA ORGÁNICA DEL LENGUAJE"
  },
  {
    "codigo":39865000,
    "descripcion":"INTOXICACIÓN POR ORNITHOGLOSSUM VIRIDE"
  },
  {
    "codigo":367545001,
    "descripcion":"ESTADO DE ÁNIMO TEMEROSO"
  },
  {
    "codigo":170937000,
    "descripcion":"ASISTENCIA COMPARTIDA: ENFERMERA DE ATENCIÓN PRIMARIA Y MÉDICO GENERAL"
  },
  {
    "codigo":269241004,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO SUPERFICIAL DE CUELLO"
  },
  {
    "codigo":7097001,
    "descripcion":"PLEURESÍA ESTREPTOCÓCICA CON DERRAME"
  },
  {
    "codigo":72633008,
    "descripcion":"SECUENCIA DE BASE"
  },
  {
    "codigo":302009009,
    "descripcion":"DIFICULTAD PARA OPONER EL PULGAR"
  },
  {
    "codigo":365710005,
    "descripcion":"HALLAZGO RELACIONADO CON LA VISCOSIDAD DEL LÍQUIDO SINOVIAL"
  },
  {
    "codigo":1217678005,
    "descripcion":"NEOVASCULARIZACIÓN DE ÁNGULO IRIDOCORNEAL DEBIDA A OCLUSIÓN DE VENA CENTRAL DE LA RETINA"
  },
  {
    "codigo":5262007,
    "descripcion":"ATROFIA MUSCULAR ESPINAL"
  },
  {
    "codigo":396643000,
    "descripcion":"EXTENSIÓN EXTRACAPSULAR DE TUMOR GANGLIONAR, AUSENTE"
  },
  {
    "codigo":234638009,
    "descripcion":"MICROCEFALIA, INTELIGENCIA NORMAL E INMUNODEFICIENCIA"
  },
  {
    "codigo":3427001,
    "descripcion":"MELITURIA NO GLUCOSÚRICA"
  },
  {
    "codigo":167267003,
    "descripcion":"PRUEBA DE GLUCOSA EN ORINA = ++++"
  },
  {
    "codigo":298339004,
    "descripcion":"HALLAZGO RELACIONADO CON EL CONTROL CORPORAL"
  },
  {
    "codigo":300174006,
    "descripcion":"YUNQUE, NO SE VISUALIZA"
  },
  {
    "codigo":68963006,
    "descripcion":"TRASTORNO DE LA IDENTIDAD SEXUAL EN LA ADOLESCENCIA, PREVIAMENTE HETEROSEXUAL"
  },
  {
    "codigo":165432004,
    "descripcion":"ÍNDICE DE COLOR ERITROCÍTICO POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1592005,
    "descripcion":"INTENTO FALLIDO DE ABORTO CON UREMIA"
  },
  {
    "codigo":1345080005,
    "descripcion":"EPISODIO DE USO NOCIVO DE ESTEROIDE ANABÓLICO"
  },
  {
    "codigo":611511000124103,
    "descripcion":"DISPONE DE MEDIO DE TRANSPORTE PARA ACCEDER A RECURSOS COMUNITARIOS"
  },
  {
    "codigo":722488009,
    "descripcion":"NEURODEGENERACIÓN DEBIDA A DEFICIENCIA DE 3-HIDROXIISOBUTIRIL COENZIMA A HIDROLASA"
  },
  {
    "codigo":296504009,
    "descripcion":"SOBREDOSIS DE PAPAVERINA"
  },
  {
    "codigo":294669005,
    "descripcion":"ALERGIA A ANTITOXINA DIFTÉRICA"
  },
  {
    "codigo":450231000124109,
    "descripcion":"TRASTORNO DE TENDÓN DE BÍCEPS BRAQUIAL IZQUIERDO"
  },
  {
    "codigo":1179405006,
    "descripcion":"ARTRITIS TIFOIDEA"
  },
  {
    "codigo":2231000124109,
    "descripcion":"PRIMER MOLAR INFERIOR DERECHO TEMPORARIO SUPERNUMERARIO"
  },
  {
    "codigo":292834005,
    "descripcion":"REACCIÓN ADVERSA AL VALACICLOVIR"
  },
  {
    "codigo":422071000,
    "descripcion":"FILTRACIÓN POR INCISIÓN CORNEAL"
  },
  {
    "codigo":127159003,
    "descripcion":"LINFADENOPATÍA ILÍACA"
  },
  {
    "codigo":225463003,
    "descripcion":"ACTITUD POSITIVA"
  },
  {
    "codigo":190860000,
    "descripcion":"RAQUITISMO POR HIPOFOSFATASIA"
  },
  {
    "codigo":289164001,
    "descripcion":"HALLAZGO RELACIONADO CON LA INGESTA DE LÍQUIDOS"
  },
  {
    "codigo":94391008,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE PULMÓN"
  },
  {
    "codigo":92556000,
    "descripcion":"CARCINOMA IN SITU DE BRONQUIO DEL LÓBULO SUPERIOR DERECHO DEL PULMÓN"
  },
  {
    "codigo":290999008,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR METIPRILÓN"
  },
  {
    "codigo":297096001,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE ESTREPTOQUINASA"
  },
  {
    "codigo":27020006,
    "descripcion":"CONJUNTIVITIS TRACOMATOSA FOLICULAR"
  },
  {
    "codigo":713313000,
    "descripcion":"TRASTORNO MINERAL Y ÓSEO POR ENFERMEDAD RENAL CRÓNICA"
  },
  {
    "codigo":1335905003,
    "descripcion":"SÍNDROME DE SKEETER"
  },
  {
    "codigo":254561006,
    "descripcion":"CARCINOMA DEL PÍLORO"
  },
  {
    "codigo":56118002,
    "descripcion":"ESPLENOMEGALIA SIFILÍTICA CONGÉNITA"
  },
  {
    "codigo":299821000119109,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE TENDÓN EXTENSOR DE BRAZO"
  },
  {
    "codigo":1137462005,
    "descripcion":"QUILOTÓRAX ADQUIRIDO"
  },
  {
    "codigo":1268534007,
    "descripcion":"SARCOMA DE EWING PRIMARIO DE PARTES BLANDAS"
  },
  {
    "codigo":285494009,
    "descripcion":"NO PUEDE CERRAR LOS LABIOS"
  },
  {
    "codigo":283659005,
    "descripcion":"HERIDA POR PINCHAZO DE CLAVO EN EL ANTEBRAZO"
  },
  {
    "codigo":1332235007,
    "descripcion":"CARCINOMA DE CÉLULAS DE MERKEL PRIMARIO DE PIEL DE PÁRPADO SUPERIOR"
  },
  {
    "codigo":609504000,
    "descripcion":"INTERRUPCIÓN INDUCIDA DEL EMBARAZO COMPLICADA POR DAÑO DEL INTESTINO"
  },
  {
    "codigo":52448006,
    "descripcion":"DEMENCIA"
  },
  {
    "codigo":85216006,
    "descripcion":"DESPLAZAMIENTO DE DISCO INTERVERTEBRAL CERVICAL, SIN MIELOPATÍA"
  },
  {
    "codigo":871648008,
    "descripcion":"DEFECTO PERIMEMBRANOSO DEL TABIQUE INTERVENTRICULAR EN EL CONO DE SALIDA CON MALA ALINEACIÓN DEL TABIQUE AURICULOVENTRICULAR EN SU PORCIÓN POSTERIOR"
  },
  {
    "codigo":249056009,
    "descripcion":"HALLAZGO RELACIONADO CON LAS PARTES FETALES"
  },
  {
    "codigo":771509001,
    "descripcion":"MIOCARDIOPATÍA HIPERTRÓFICA Y ENFERMEDAD DE LOS TÚBULOS RENALES DEBIDA A MUTACIÓN DE ÁCIDO DESOXIRRIBONUCLEICO"
  },
  {
    "codigo":247221005,
    "descripcion":"PAPILA ÓPTICA - MUESCA SECTORIAL"
  },
  {
    "codigo":116149007,
    "descripcion":"PORCENTAJE DE DISCAPACIDAD"
  },
  {
    "codigo":81546003,
    "descripcion":"ABSCESO DE TEJIDO ORAL"
  },
  {
    "codigo":278154007,
    "descripcion":"GRUPO SANGUÍNEO AB RH(D) NEGATIVO"
  },
  {
    "codigo":16010007,
    "descripcion":"FÍSTULA DUODENOCÓLICA"
  },
  {
    "codigo":866143002,
    "descripcion":"INFECCIÓN DE NERVIO PERIFÉRICO CAUSADA POR HONGO"
  },
  {
    "codigo":276319003,
    "descripcion":"HALLAZGO RELACIONADO CON EL SANGRADO MENSTRUAL"
  },
  {
    "codigo":1259359005,
    "descripcion":"ESTENOSIS DE UNIÓN VESICOURETERAL"
  },
  {
    "codigo":309087008,
    "descripcion":"PARESTESIA DEL PIE"
  },
  {
    "codigo":733236001,
    "descripcion":"LUXACIÓN TRAUMÁTICA DE CABEZA DE RADIO"
  },
  {
    "codigo":208948004,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE LA ARTICULACIÓN DE LA RODILLA, INTERNA"
  },
  {
    "codigo":700468006,
    "descripcion":"ALERGIA A COMPONENTE DE VACUNA QUE CONTIENE ANTÍGENO DE ROTAVIRUS"
  },
  {
    "codigo":405556007,
    "descripcion":"ESTENOSIS DE ARTERIA DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":370953000,
    "descripcion":"CÁPSULA ABIERTA DEL CRISTALINO EN LA SEUDOFAQUIA"
  },
  {
    "codigo":698633001,
    "descripcion":"MENINGITIS POSOPERATORIA"
  },
  {
    "codigo":895241006,
    "descripcion":"FORMA ANCHA ANORMAL CONGÉNITA DE FALANGE DISTAL DE DEDO MEDIO DE MANO"
  },
  {
    "codigo":239881008,
    "descripcion":"PELVIS DE OTTO"
  },
  {
    "codigo":403721009,
    "descripcion":"REACCIÓN ADVERSA A FOTOTERAPIA POR RADIACIÓN UVB"
  },
  {
    "codigo":205278001,
    "descripcion":"SINOSTOSIS ESCAFOIDES-SEMILUNAR"
  },
  {
    "codigo":41438001,
    "descripcion":"EDAD GESTACIONAL, 21 SEMANAS"
  },
  {
    "codigo":762334004,
    "descripcion":"TRASTORNO DEL SUEÑO CAUSADO POR ESTIMULANTE"
  },
  {
    "codigo":74206004,
    "descripcion":"INTOXICACIÓN POR SAPIUM SEBIFERUM"
  },
  {
    "codigo":323321000119100,
    "descripcion":"ARTROSIS DE RODILLA DERECHA"
  },
  {
    "codigo":11825401000119101,
    "descripcion":"HEMATOMA DE MUSLO DERECHO"
  },
  {
    "codigo":761000119102,
    "descripcion":"DISLIPIDEMIA DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":679161000119103,
    "descripcion":"EROSIÓN DE CÓRNEA DE OJO DERECHO"
  },
  {
    "codigo":400051008,
    "descripcion":"ECCEMA ASTEATÓTICO SENIL"
  },
  {
    "codigo":365448001,
    "descripcion":"HALLAZGO EN LOS ANTECEDENTES PERSONALES Y SOCIALES"
  },
  {
    "codigo":31481000119106,
    "descripcion":"TRASTORNO DE COLUMNA VERTEBRAL CERVICAL SIN MIELOPATÍA"
  },
  {
    "codigo":11787001000119107,
    "descripcion":"LESIÓN TRAUMÁTICA DE REGIÓN DE CADERA IZQUIERDA"
  },
  {
    "codigo":15639801000119108,
    "descripcion":"PTOSIS DE CEJA IZQUIERDA"
  },
  {
    "codigo":12245241000119105,
    "descripcion":"HEMORRAGIA DE SISTEMA MUSCULOESQUELÉTICO DEBIDA A PROCEDIMIENTO SOBRE SISTEMA MUSCULOESQUELÉTICO Y POSTERIOR A ÉL"
  },
  {
    "codigo":299912006,
    "descripcion":"SENSACIÓN AL TACTO LIGERO AUSENTE"
  },
  {
    "codigo":758664007,
    "descripcion":"DEFICIENCIA AISLADA DE HORMONA FOLICULOESTIMULANTE"
  },
  {
    "codigo":234376007,
    "descripcion":"APLASIA ADQUIRIDA DE LA SERIE ROJA"
  },
  {
    "codigo":15724281000119105,
    "descripcion":"ENTESOPATÍA DE PIE DERECHO"
  },
  {
    "codigo":305401000119108,
    "descripcion":"CONTRACTURA DE MÚSCULO DE REGIÓN DE HOMBRO DERECHO"
  },
  {
    "codigo":16098041000119106,
    "descripcion":"ARTROFIBROSIS DE PIE DERECHO"
  },
  {
    "codigo":16917241000119108,
    "descripcion":"TRASTORNO DE NERVIO MOTOR OCULAR EXTERNO IZQUIERDO"
  },
  {
    "codigo":34041000119108,
    "descripcion":"NEOPLASIA BENIGNA EXTRAMEDULAR DE MÉDULA ESPINAL"
  },
  {
    "codigo":10957561000119109,
    "descripcion":"HERIDA ABIERTA DE PULGAR DERECHO"
  },
  {
    "codigo":430984009,
    "descripcion":"FRACTURA NO EXPUESTA DE HUESO FACIAL"
  },
  {
    "codigo":298077002,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE CODO"
  },
  {
    "codigo":197938001,
    "descripcion":"HEMATURIA INDOLORA"
  },
  {
    "codigo":1344818002,
    "descripcion":"ALTERACIÓN DE ALINEACIÓN DE ARTICULACIÓN DE PIE"
  },
  {
    "codigo":230706003,
    "descripcion":"INFARTO CEREBRAL HEMORRÁGICO"
  },
  {
    "codigo":296242004,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE PERFENAZINA"
  },
  {
    "codigo":294407003,
    "descripcion":"ALERGIA A HEXETIDINA"
  },
  {
    "codigo":32263004,
    "descripcion":"LINFANGITIS AGUDA DE LA FRENTE"
  },
  {
    "codigo":1144540004,
    "descripcion":"HIPOPLASIA CONGÉNITA DE CAVIDAD GLENOIDEA"
  },
  {
    "codigo":194268005,
    "descripcion":"SALPINGITIS AGUDA DE TROMPA DE EUSTAQUIO"
  },
  {
    "codigo":292572006,
    "descripcion":"REACCIÓN ADVERSA A LA LORATADINA"
  },
  {
    "codigo":718556007,
    "descripcion":"SÍNDROME DE DISPLASIA CRÁNEO-CEREBELO-CARDÍACA"
  },
  {
    "codigo":290737000,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR PACLITAXEL"
  },
  {
    "codigo":421809001,
    "descripcion":"FENÓMENO ENTÓPTICO"
  },
  {
    "codigo":10735151000119100,
    "descripcion":"FIBROADENOSIS DE MAMA IZQUIERDA"
  },
  {
    "codigo":716721003,
    "descripcion":"MIOGLOBINURIA RECURRENTE GENÉTICA"
  },
  {
    "codigo":1306545006,
    "descripcion":"NEOPLASIA MALIGNA CON METÁSTASIS A CUADRANTE INFERIOR EXTERNO DE MAMA"
  },
  {
    "codigo":28593007,
    "descripcion":"PETROSITIS CRÓNICA"
  },
  {
    "codigo":126897007,
    "descripcion":"NEOPLASIA DEL PREPUCIO"
  },
  {
    "codigo":92294001,
    "descripcion":"NEOPLASIA BENIGNA DE LA GLÁNDULA PINEAL"
  },
  {
    "codigo":94129007,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA ÚVULA"
  },
  {
    "codigo":714886003,
    "descripcion":"PASA DE UNA UBICACIÓN A OTRA"
  },
  {
    "codigo":288902006,
    "descripcion":"INCAPAZ DE RETENER EL ALIMENTO EN LA BOCA"
  },
  {
    "codigo":287067004,
    "descripcion":"FRACTURA PATOLÓGICA - MANO"
  },
  {
    "codigo":1237339005,
    "descripcion":"TRIMETILAMINURIA PRIMARIA SEVERA"
  },
  {
    "codigo":713051008,
    "descripcion":"FALLECIDO EN UNIDAD DE SALUD MENTAL"
  },
  {
    "codigo":23088002,
    "descripcion":"AMBIDESTREZA"
  },
  {
    "codigo":449072004,
    "descripcion":"LINFOMA DE TRACTO GASTROINTESTINAL"
  },
  {
    "codigo":55856005,
    "descripcion":"HIPERPLASIA CONGÉNITA DEL RIÑÓN"
  },
  {
    "codigo":283397004,
    "descripcion":"CORTE EN CABEZA Y CUELLO"
  },
  {
    "codigo":414469009,
    "descripcion":"CHOQUE INMINENTE"
  },
  {
    "codigo":840453009,
    "descripcion":"QUILOCELE DE TÚNICA VAGINAL CAUSADA POR LOA LOA"
  },
  {
    "codigo":19418005,
    "descripcion":"RASGO DE PERSONALIDAD PSICOPÁTICA"
  },
  {
    "codigo":52186006,
    "descripcion":"SIALIDOSIS DISMÓRFICA"
  },
  {
    "codigo":248794005,
    "descripcion":"NUNCA HA ALCANZADO UN ORGASMO"
  },
  {
    "codigo":281562007,
    "descripcion":"NEUROBLASTOMA SUPRARRENAL"
  },
  {
    "codigo":1229999001,
    "descripcion":"SÍNDROME DE MIOPÍA AUTOSÓMICA DOMINANTE, RETRUSIÓN DE TERCIO MEDIO FACIAL, HIPOACUSIA NEUROSENSORIAL Y DISPLASIA RIZOMÉLICA"
  },
  {
    "codigo":609242005,
    "descripcion":"VIVE EN DEPARTAMENTO SIN ACCESO A ASCENSOR"
  },
  {
    "codigo":246959004,
    "descripcion":"OPACIDADES IRREGULARES DEL ESTROMA DE LA CÓRNEA"
  },
  {
    "codigo":771247007,
    "descripcion":"HERIDA POR QUEMADURA PROFUNDA DE ESPESOR TOTAL"
  },
  {
    "codigo":83119008,
    "descripcion":"INSUFICIENCIA CONGÉNITA DE VÁLVULA TRICÚSPIDE"
  },
  {
    "codigo":410799007,
    "descripcion":"ARTRITIS IDIOPÁTICA JUVENIL, OLIGOARTRITIS PERSISTENTE"
  },
  {
    "codigo":310660006,
    "descripcion":"PESO AL NACER: 999 G O MENOS"
  },
  {
    "codigo":277892007,
    "descripcion":"INMOVILIDAD RÍGIDA"
  },
  {
    "codigo":48516007,
    "descripcion":"LINFOCITOSIS INFECCIOSA AGUDA"
  },
  {
    "codigo":212356007,
    "descripcion":"CONMOCIÓN Y EDEMA DE LA MÉDULA ESPINAL CERVICAL"
  },
  {
    "codigo":1259097003,
    "descripcion":"TRASTORNO DE SISTEMA NERVIOSO AUTÓNOMO CAUSADO POR ACRILAMIDA"
  },
  {
    "codigo":767577006,
    "descripcion":"AUMENTO MODERADO DE ALBUMINURIA DEBIDO A EJERCICIO"
  },
  {
    "codigo":15705801000119108,
    "descripcion":"DEPÓSITO DE CALCIO EN BOLSA SEROSA DE AMBAS MANOS"
  },
  {
    "codigo":1290030002,
    "descripcion":"TRASTORNO DE OJO IZQUIERDO PROPIAMENTE DICHO"
  },
  {
    "codigo":304841000119109,
    "descripcion":"DETENCIÓN TOTAL DE CRECIMIENTO EPIFISARIO DE TIBIA PROXIMAL IZQUIERDA"
  },
  {
    "codigo":208686005,
    "descripcion":"FRACTURA NO EXPUESTA DE CUERPO DE ASTRÁGALO"
  },
  {
    "codigo":403459000,
    "descripcion":"HIPERQUERATOSIS DE PEZÓN"
  },
  {
    "codigo":1222659003,
    "descripcion":"ENCEFALOPATÍA EPILÉPTICA GRAVE DE INICIO TEMPRANO ASOCIADA AL GEN RNF13"
  },
  {
    "codigo":434392000,
    "descripcion":"MAL FUNCIONAMIENTO DE MARCAPASO CARDÍACO BIVENTRICULAR"
  },
  {
    "codigo":237784000,
    "descripcion":"QUISTE SUPRARRENAL"
  },
  {
    "codigo":205016000,
    "descripcion":"MALFORMACIÓN DEL URACO"
  },
  {
    "codigo":1255427009,
    "descripcion":"QUISTE DE ASTA ANTERIOR DE MENISCO INTERNO DE RODILLA"
  },
  {
    "codigo":235949005,
    "descripcion":"PANCREATITIS AGUDA FAMILIAR"
  },
  {
    "codigo":39341005,
    "descripcion":"COLITIS INFECCIOSA"
  },
  {
    "codigo":6573007,
    "descripcion":"PELVIS RENIFORME"
  },
  {
    "codigo":301485007,
    "descripcion":"CAPAZ DE DOBLAR ESQUINAS"
  },
  {
    "codigo":365186001,
    "descripcion":"HALLAZGO RELACIONADO CON LA EXPRESIÓN DE EMOCIONES"
  },
  {
    "codigo":299650003,
    "descripcion":"AMPUTADO A NIVEL DE REGIÓN INFERIOR DE MUSLO"
  },
  {
    "codigo":37506004,
    "descripcion":"SÍNDROME DE MONOSOMÍA PARCIAL 4Q"
  },
  {
    "codigo":135810007,
    "descripcion":"MIELINIZACIÓN RETARDADA"
  },
  {
    "codigo":168578008,
    "descripcion":"RADIOGRAFÍA SIMPLE DE COLUMNA VERTEBRAL DORSAL ANORMAL"
  },
  {
    "codigo":232279001,
    "descripcion":"FRACTURA COMPLEJA DE HUESO TEMPORAL"
  },
  {
    "codigo":363351006,
    "descripcion":"NEOPLASIA MALIGNA DE RECTO"
  },
  {
    "codigo":333821000119105,
    "descripcion":"EXOTROPÍA MONOCULAR DE OJO DERECHO"
  },
  {
    "codigo":428887009,
    "descripcion":"PÉRDIDA DE LA AUDICIÓN NEUROSENSORIAL ASIMÉTRICA"
  },
  {
    "codigo":230444006,
    "descripcion":"EPILEPSIA MENSTRUAL"
  },
  {
    "codigo":425217005,
    "descripcion":"HIPERTROFIA DEL EPITELIO PIGMENTARIO DE LA RETINA"
  },
  {
    "codigo":294145007,
    "descripcion":"ALERGIA A LODOXAMIDA"
  },
  {
    "codigo":128470003,
    "descripcion":"TRASTORNO DE LA GLÁNDULA PINEAL"
  },
  {
    "codigo":95702003,
    "descripcion":"ATROFIA RETINIANA PROGRESIVA CENTRAL"
  },
  {
    "codigo":292310005,
    "descripcion":"REACCIÓN ADVERSA A LA MAPROTILINA"
  },
  {
    "codigo":1177046004,
    "descripcion":"INFECCIÓN CAUSADA POR LARVAS DE TRICHINELLA PSEUDOSPIRALIS"
  },
  {
    "codigo":126635000,
    "descripcion":"NEOPLASIA DEL CUELLO"
  },
  {
    "codigo":290475004,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR FÁRMACO ANTIESPASMÓDICO"
  },
  {
    "codigo":1339051005,
    "descripcion":"GERMINOMA METASTÁSICO"
  },
  {
    "codigo":93867004,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA CURVATURA MENOR DEL ESTÓMAGO"
  },
  {
    "codigo":61099007,
    "descripcion":"RUBÉOLA ESCARLATINOIDE"
  },
  {
    "codigo":716459007,
    "descripcion":"CAPAZ DE TOLERAR DOLOR GENERALIZADO"
  },
  {
    "codigo":143511000119105,
    "descripcion":"PERIHEPATITIS CAUSADA POR CHLAMYDIA TRACHOMATIS"
  },
  {
    "codigo":288640006,
    "descripcion":"CAPAZ DE COMENZAR UNA CONVERSACIÓN"
  },
  {
    "codigo":92032007,
    "descripcion":"NEOPLASIA BENIGNA DE LOS GANGLIOS LINFÁTICOS BRONCOPULMONARES"
  },
  {
    "codigo":24661004,
    "descripcion":"VARIANTE DE ANEMIA POR DEFICIENCIA DE GLUCOSA-6-FOSFATO DESHIDROGENASA CLASE III"
  },
  {
    "codigo":286805004,
    "descripcion":"CARÁCTER PERFECCIONISTA"
  },
  {
    "codigo":188501009,
    "descripcion":"LINFOSARCOMA DE GANGLIOS LINFÁTICOS INTRATORÁCICOS"
  },
  {
    "codigo":710954001,
    "descripcion":"BACTERIAS PRESENTES"
  },
  {
    "codigo":284970005,
    "descripcion":"REALIZA ACTIVIDADES DE VESTIDO"
  },
  {
    "codigo":86527000,
    "descripcion":"HIPOPLASIA DE OJO"
  },
  {
    "codigo":20991001,
    "descripcion":"TRASTORNO LINFOPROLIFERATIVO ATÍPICO"
  },
  {
    "codigo":11831601000119104,
    "descripcion":"LESIÓN DE VASO SANGUÍNEO DE PULGAR IZQUIERDO"
  },
  {
    "codigo":283135004,
    "descripcion":"CONTUSIÓN SUPERFICIAL DE CABEZA Y CUELLO"
  },
  {
    "codigo":709119005,
    "descripcion":"EFECTO TÓXICO DE ANTIMONIO Y\/O COMPUESTOS DE ANTIMONIO"
  },
  {
    "codigo":53759006,
    "descripcion":"CONTUSIÓN DE LA REGIÓN AXILAR"
  },
  {
    "codigo":838356001,
    "descripcion":"ENDOCARDITIS AGUDA DE LADO DERECHO DEL CORAZÓN DEBIDA A INFECCIÓN"
  },
  {
    "codigo":1297108003,
    "descripcion":"DERRAME DE ARTICULACIÓN RADIOCARPIANA"
  },
  {
    "codigo":445140006,
    "descripcion":"MOVIMIENTOS PERIÓDICOS DE LAS PIERNAS DURANTE EL SUEÑO"
  },
  {
    "codigo":1264340007,
    "descripcion":"NEOPLASIA NEUROENDOCRINA GÁSTRICA FAMILIAR TIPO 1"
  },
  {
    "codigo":707284008,
    "descripcion":"APOYO DISPONIBLE EN LAS PRIMERAS 24 HORAS DESPUÉS DEL ALTA"
  },
  {
    "codigo":246697002,
    "descripcion":"PATRÓN DE VERGENCIA EN Y"
  },
  {
    "codigo":16582961000119107,
    "descripcion":"ARTRITIS DE TOBILLO DERECHO DEBIDA A TRAUMATISMO"
  },
  {
    "codigo":1073611000119103,
    "descripcion":"ARTRITIS REUMATOIDEA SEROPOSITIVA DE ARTICULACIÓN DE PIE IZQUIERDO"
  },
  {
    "codigo":703614006,
    "descripcion":"FIBROMA APONEURÓTICO CALCIFICANTE"
  },
  {
    "codigo":111955002,
    "descripcion":"CLONO DE CIERRE ANÓDICO"
  },
  {
    "codigo":243027003,
    "descripcion":"LESIÓN POR RÁFAGA DE BOMBA AÉREA"
  },
  {
    "codigo":208424000,
    "descripcion":"FRACTURA EXPUESTA DE LA CABEZA METACARPIANA DEL PULGAR"
  },
  {
    "codigo":765480005,
    "descripcion":"VÓMITOS CONCOMITANTES CON ENFERMEDAD INFECCIOSA Y DEBIDOS A ELLA"
  },
  {
    "codigo":11805131000119106,
    "descripcion":"SUBLUXACIÓN DE ARTICULACIÓN INTERFALÁNGICA PROXIMAL DE DEDO DE MANO IZQUIERDA"
  },
  {
    "codigo":110120008,
    "descripcion":"LACERACIÓN SIMPLE CONTAMINADA DE LA ENCÍA ALVEOLAR DEL MAXILAR SUPERIOR"
  },
  {
    "codigo":336331000119108,
    "descripcion":"QUERATOPATÍA EN BANDA DE OJO DERECHO"
  },
  {
    "codigo":403197009,
    "descripcion":"ARRUGAS POR EXPOSICIÓN SOLAR"
  },
  {
    "codigo":301223000,
    "descripcion":"LESIÓN SUBGLÓTICA"
  },
  {
    "codigo":399527001,
    "descripcion":"TUMOR INVASIVO DE OVARIO CON IMPLANTES EPIPLOICOS PRESENTES"
  },
  {
    "codigo":202919002,
    "descripcion":"TENOSINOVITIS TIBIAL POSTERIOR"
  },
  {
    "codigo":8146009,
    "descripcion":"HERNIA DE COOPER"
  },
  {
    "codigo":1251495004,
    "descripcion":"METÁSTASIS DE CARCINOMA DE OMÓPLATO"
  },
  {
    "codigo":233852004,
    "descripcion":"ENDOCARDITIS DE CULTIVO NEGATIVO"
  },
  {
    "codigo":37244007,
    "descripcion":"INTOXICACIÓN POR XANTHIUM"
  },
  {
    "codigo":299388009,
    "descripcion":"SIGNO CON NOMBRE PROPIO DE LA RODILLA"
  },
  {
    "codigo":364924009,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA ENDEREZARSE EN EL ASIENTO"
  },
  {
    "codigo":232017001,
    "descripcion":"VITREORRETINOPATÍA PROLIFERATIVA ANTERIOR"
  },
  {
    "codigo":461393004,
    "descripcion":"ORIGEN NORMAL DE CONDUCTO ARTERIOSO EN AORTA DESCENDENTE PROXIMAL"
  },
  {
    "codigo":363089008,
    "descripcion":"TRASTORNO DE LA ALIMENTACIÓN FETAL"
  },
  {
    "codigo":230182006,
    "descripcion":"ENCEFALITIS SIFILÍTICA TARDÍA"
  },
  {
    "codigo":295718007,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE CITARABINA"
  },
  {
    "codigo":721702009,
    "descripcion":"ENFERMEDAD DE CROHN DE CONDUCTO ANAL"
  },
  {
    "codigo":16012031000119104,
    "descripcion":"TROMBOFLEBITIS DE AMBAS VENAS FEMORALES"
  },
  {
    "codigo":228347006,
    "descripcion":"USA ESTRATEGIAS PARA CONTROLAR LA BEBIDA"
  },
  {
    "codigo":95440004,
    "descripcion":"ANEURISMA AURICULAR SEPTAL"
  },
  {
    "codigo":11834111000119106,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN METACARPOFALÁNGICA DE PULGAR DERECHO"
  },
  {
    "codigo":292048006,
    "descripcion":"REACCIÓN ADVERSA A UNA SUSTANCIA ANÁLOGA A LA METADONA"
  },
  {
    "codigo":128208007,
    "descripcion":"NEUROPATÍA AXÓNICA PERIFÉRICA"
  },
  {
    "codigo":29904009,
    "descripcion":"SÍNDROME DE LERMOYEZ"
  },
  {
    "codigo":290213001,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR MEPTAZINOL"
  },
  {
    "codigo":716197003,
    "descripcion":"PTERIGIÓN CONJUNTIVAL AUTOSÓMICO DOMINANTE"
  },
  {
    "codigo":1142181004,
    "descripcion":"REACCIÓN ADVERSA A VACUNA ARNM CONTRA COVID-19"
  },
  {
    "codigo":16667391000119107,
    "descripcion":"FRACTURA NO EXPUESTA DE LADO IZQUIERDO DE MAXILAR SUPERIOR"
  },
  {
    "codigo":880037003,
    "descripcion":"ANEURISMA ADQUIRIDO DE VENTRÍCULO CARDÍACO IZQUIERDO"
  },
  {
    "codigo":93605007,
    "descripcion":"OSIFICACIÓN INCOMPLETA DE HUESO SUPRAOCCIPITAL"
  },
  {
    "codigo":191909007,
    "descripcion":"PATRÓN DE USO NOCIVO DE OPIOIDE SIN DEPENDENCIA"
  },
  {
    "codigo":288378002,
    "descripcion":"DA VUELTA LAS PÁGINAS"
  },
  {
    "codigo":124538007,
    "descripcion":"DEFICIENCIA DE DIISOPROPILO - FLUOROFOSFATASA"
  },
  {
    "codigo":188239000,
    "descripcion":"NEOPLASIA MALIGNA DE TRÍGONO VESICAL"
  },
  {
    "codigo":778063003,
    "descripcion":"ESPASMOS EPILÉPTICOS CRIPTOGÉNICOS DE INICIO TARDÍO"
  },
  {
    "codigo":712527004,
    "descripcion":"TUMOR DE CÉLULAS GIGANTES DE HUESO CORTO DE MIEMBRO INFERIOR"
  },
  {
    "codigo":286543005,
    "descripcion":"DIFICULTAD PARA GUARDAR LOS ALIMENTOS HIGIÉNICAMENTE"
  },
  {
    "codigo":22564003,
    "descripcion":"COMPLICACIÓN TEMPRANA DE UN TRAUMATISMO"
  },
  {
    "codigo":448548007,
    "descripcion":"DERMOIDE ANGULAR EXTERNO"
  },
  {
    "codigo":250105000,
    "descripcion":"INESTABILIDAD DEL LIGAMENTO LATERAL EXTERNO"
  },
  {
    "codigo":315641001,
    "descripcion":"CARTA DE CONVOCATORIA PARA INMUNIZACIÓN CONTRA INFLUENZA: ENVIADA"
  },
  {
    "codigo":284708009,
    "descripcion":"MORDERSE UN BRAZO"
  },
  {
    "codigo":282873007,
    "descripcion":"SE PONE DE PIE"
  },
  {
    "codigo":338841000119108,
    "descripcion":"OPACIDAD PERIFÉRICA DE CÓRNEA IZQUIERDA"
  },
  {
    "codigo":444878001,
    "descripcion":"SÍNDROME DE CONDUCTO TARSIANO"
  },
  {
    "codigo":1264078002,
    "descripcion":"TRASTORNO NEONATAL CAUSADO POR SUERO INMUNE TRANSMITIDO POR LECHE MATERNA"
  },
  {
    "codigo":1296846003,
    "descripcion":"EDEMA DE PREPUCIO DE CLÍTORIS"
  },
  {
    "codigo":248270006,
    "descripcion":"EXHAUSTO RÁPIDAMENTE"
  },
  {
    "codigo":51662008,
    "descripcion":"DISMINUCIÓN EN LA MOVILIDAD DEL MARTILLO"
  },
  {
    "codigo":17059001,
    "descripcion":"BURSITIS PRERROTULIANA"
  },
  {
    "codigo":145621000146106,
    "descripcion":"CEFALEA POR ESFUERZO"
  },
  {
    "codigo":49827005,
    "descripcion":"DISTOCLUSIÓN DE LOS DIENTES"
  },
  {
    "codigo":770723007,
    "descripcion":"SÍNDROME DE ATROFIA ÓPTICA Y DISCAPACIDAD INTELECTUAL"
  },
  {
    "codigo":736120001,
    "descripcion":"AMPOLLA NO TRAUMÁTICA DE PIEL"
  },
  {
    "codigo":441208006,
    "descripcion":"NO LEE LOS LABIOS"
  },
  {
    "codigo":734285001,
    "descripcion":"ÁCIDO DESOXIRRIBONUCLEICO DE VIRUS VARICELA-ZÓSTER NATURAL DETECTADO"
  },
  {
    "codigo":1356877007,
    "descripcion":"HIPERTENSIÓN ESTABLE"
  },
  {
    "codigo":111693009,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DEL ANTEBRAZO"
  },
  {
    "codigo":77090002,
    "descripcion":"PENFIGOIDE AMPOLLAR"
  },
  {
    "codigo":765218007,
    "descripcion":"TRASTORNO EN REMISIÓN COMPLETA ESPONTÁNEA"
  },
  {
    "codigo":109858008,
    "descripcion":"MESOTELIOMA MALIGNO DE EPIPLÓN"
  },
  {
    "codigo":699682009,
    "descripcion":"DOLOR LOCALIZADO DE MÚSCULO MASTICATORIO"
  },
  {
    "codigo":271863002,
    "descripcion":"COLOR ANORMAL DE LA MATERIA FECAL"
  },
  {
    "codigo":304631003,
    "descripcion":"HALLAZGO RELACIONADO CON LA POSICIÓN DE LA CABEZA"
  },
  {
    "codigo":372002009,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL PALADAR"
  },
  {
    "codigo":1287671005,
    "descripcion":"CONVULSIÓN EPILÉPTICA DE LÓBULO OCCIPITAL"
  },
  {
    "codigo":239095007,
    "descripcion":"ONFALITIS"
  },
  {
    "codigo":1254903008,
    "descripcion":"DERMATITIS POR CONTACTO OCUPACIONAL DE MANO"
  },
  {
    "codigo":302796001,
    "descripcion":"HALLAZGO CITOLÓGICO A NIVEL CERVICAL"
  },
  {
    "codigo":1187532002,
    "descripcion":"DEFICIENCIA DE PEX1"
  },
  {
    "codigo":402935007,
    "descripcion":"BARTOLINITIS PIOCÓCICA AGUDA"
  },
  {
    "codigo":367821000119106,
    "descripcion":"HIPERTENSIÓN DEBIDA A COMPRESIÓN DE PARÉNQUIMA RENAL"
  },
  {
    "codigo":169889000,
    "descripcion":"TALLA AL NACER = ENTRE PERCENTILOS 10 Y 24"
  },
  {
    "codigo":827084009,
    "descripcion":"REFLEJO RADIAL NORMAL"
  },
  {
    "codigo":202657000,
    "descripcion":"ESPONDILOSIS CERVICAL EN UN NIVEL SIN MIELOPATÍA"
  },
  {
    "codigo":15932621000119107,
    "descripcion":"LESIÓN DE TROMPA DE FALOPIO IZQUIERDA"
  },
  {
    "codigo":366497004,
    "descripcion":"HALLAZGO RELACIONADO CON LA AMPLITUD DEL MOVIMIENTO PASIVO DE FLEXIÓN HORIZONTAL DE HOMBRO"
  },
  {
    "codigo":6049005,
    "descripcion":"NEGATIVISMO EN LA CATATONÍA"
  },
  {
    "codigo":299126001,
    "descripcion":"TUMEFACCIÓN DE PARTES BLANDAS DE ARTICULACIÓN DE DEDO DE MANO"
  },
  {
    "codigo":36982001,
    "descripcion":"ADENOMA DE FUCHS"
  },
  {
    "codigo":397430003,
    "descripcion":"DIFTERIA CAUSADA POR CORYNEBACTERIUM DIPHTHERIAE"
  },
  {
    "codigo":428363001,
    "descripcion":"CUERPO EXTRAÑO EN MANO CON INFECCIÓN"
  },
  {
    "codigo":1149259003,
    "descripcion":"FÍSTULA DE HERIDA DEBIDA A TRAQUEOSTOMÍA Y POSTERIOR A ELLA"
  },
  {
    "codigo":35147005,
    "descripcion":"ENTRECRUZAMIENTO DE GENES"
  },
  {
    "codigo":67915005,
    "descripcion":"TRICOMONIASIS INTESTINAL"
  },
  {
    "codigo":197152000,
    "descripcion":"FISURA ANAL CRÓNICA"
  },
  {
    "codigo":295456007,
    "descripcion":"SOBREDOSIS DE LAXANTE CON ANTRAQUINONA"
  },
  {
    "codigo":721440008,
    "descripcion":"LESIÓN COMPLETA DE MÉDULA ESPINAL AL NIVEL DEL DECIMOPRIMER SEGMENTO DORSAL"
  },
  {
    "codigo":262688009,
    "descripcion":"CONTUSIÓN Y LACERACIÓN DE CORTEZA CEREBRAL"
  },
  {
    "codigo":195317001,
    "descripcion":"EMBOLIA Y TROMBOSIS DE LA AORTA TORÁCICA"
  },
  {
    "codigo":293621000,
    "descripcion":"ALERGIA A KETOPROFENO"
  },
  {
    "codigo":31477000,
    "descripcion":"POSICIÓN OCCIPITOILÍACA IZQUIERDA POSTERIOR"
  },
  {
    "codigo":15988071000119107,
    "descripcion":"COLOBOMA CONGÉNITO DE PÁRPADO DERECHO"
  },
  {
    "codigo":129781005,
    "descripcion":"LOCALIZACIÓN EN HORA 10 EN LA MAMOGRAFÍA"
  },
  {
    "codigo":64245008,
    "descripcion":"PROPÓSITO"
  },
  {
    "codigo":29642000,
    "descripcion":"ADHERENCIAS CONGÉNITAS DEL PERITONEO"
  },
  {
    "codigo":62410004,
    "descripcion":"FIBRINÓLISIS POSTPARTO CON HEMORRAGIA"
  },
  {
    "codigo":95178006,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL VESTÍBULO DE LA BOCA"
  },
  {
    "codigo":717770008,
    "descripcion":"NEFROPATÍA POR ÁCIDO ARISTOLÓQUICO"
  },
  {
    "codigo":291786009,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR CARBIMAZOL"
  },
  {
    "codigo":421023003,
    "descripcion":"DEMENCIA PRESENIL CON SIDA (SÍNDROME DE INMUNODEFICIENCIA ADQUIRIDA)"
  },
  {
    "codigo":93343004,
    "descripcion":"POSICIÓN ANÓMALA CONGÉNITA DEL PALADAR RUGOSO"
  },
  {
    "codigo":224415005,
    "descripcion":"INSTALACIONES SANITARIAS ADECUADAS EN EL TRABAJO"
  },
  {
    "codigo":124276000,
    "descripcion":"DEFICIENCIA DE URACILO FOSFORRIBOSILTRANSFERASA"
  },
  {
    "codigo":1303924001,
    "descripcion":"HEMORRAGIA RECTAL CAUSADA POR FÁRMACO"
  },
  {
    "codigo":25972003,
    "descripcion":"AUSENCIA CONGÉNITA DEL RECTO"
  },
  {
    "codigo":419188005,
    "descripcion":"CANTIDAD DE LEUCOCITOS POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":187977000,
    "descripcion":"NEOPLASIA MALIGNA DEL QUINTO METATARSIANO"
  },
  {
    "codigo":286281001,
    "descripcion":"CAPAZ DE UTILIZAR CLICS AL HABLAR"
  },
  {
    "codigo":253513005,
    "descripcion":"TETRALOGÍA DE FALLOT CON ATRESIA PULMONAR"
  },
  {
    "codigo":56905009,
    "descripcion":"PERFORACIÓN DE INTESTINO"
  },
  {
    "codigo":448286002,
    "descripcion":"COLECISTITIS XANTOGRANULOMATOSA"
  },
  {
    "codigo":87838003,
    "descripcion":"EVALUACIÓN DE DISCAPACIDAD: ALTERACIÓN CLASE 6"
  },
  {
    "codigo":15633921000119109,
    "descripcion":"ECOGRAFÍA DE ABDOMEN ANORMAL"
  },
  {
    "codigo":1201950008,
    "descripcion":"ESCLEROSIS LATERAL AMIOTRÓFICA TIPO 3"
  },
  {
    "codigo":282611000,
    "descripcion":"DIFICULTAD PARA GATEAR"
  },
  {
    "codigo":184307002,
    "descripcion":"INFORME POSTMORTEM - RECIBIDO"
  },
  {
    "codigo":1003507002,
    "descripcion":"AGENESIA DE LÓBULO PULMONAR"
  },
  {
    "codigo":774131004,
    "descripcion":"ARTROPATÍA DE ARTICULACIÓN DE MANO DERECHA"
  },
  {
    "codigo":708595004,
    "descripcion":"RESTAURACIÓN DENTAL DIRECTA PRESENTE"
  },
  {
    "codigo":315379001,
    "descripcion":"NACIDO EN BANGLADESH"
  },
  {
    "codigo":446451008,
    "descripcion":"LACERACIÓN PROFUNDA DE UÑA DE DEDO DE MANO"
  },
  {
    "codigo":86003009,
    "descripcion":"TROMBOSIS DE ARTERIA CARÓTIDA"
  },
  {
    "codigo":18632008,
    "descripcion":"DETERMINACIÓN DEL ESTADO DEL PACIENTE, DECESO"
  },
  {
    "codigo":410013001,
    "descripcion":"DERMATOSIS POSFLEBÍTICA DE PIERNA"
  },
  {
    "codigo":16797001,
    "descripcion":"CONDUCCIÓN AURICULOVENTRICULAR ACELERADA"
  },
  {
    "codigo":442781001,
    "descripcion":"DISFUNCIÓN DEL EJE HIPOTALÁMICO-HIPOFISARIO-OVÁRICO"
  },
  {
    "codigo":1260146002,
    "descripcion":"DOLOR DE HOMBRO DERECHO"
  },
  {
    "codigo":209735000,
    "descripcion":"SECCIÓN EXPUESTA DE LIGAMENTO MANDIBULAR"
  },
  {
    "codigo":735858008,
    "descripcion":"LACERACIÓN DE TENDÓN DE AQUILES"
  },
  {
    "codigo":734023003,
    "descripcion":"ATAXIA ESPORÁDICA DE COMIENZO EN LA VIDA ADULTA DE ETIOLOGÍA DESCONOCIDA"
  },
  {
    "codigo":275271004,
    "descripcion":"APRAXIA CONGÉNITA"
  },
  {
    "codigo":16181000119104,
    "descripcion":"SEROMA INFECTADO DEBIDO A PROCEDIMIENTO Y POSTERIOR A ÉL"
  },
  {
    "codigo":13127006,
    "descripcion":"PSICOSIS FACTICIA"
  },
  {
    "codigo":343861000119104,
    "descripcion":"DEGENERACIÓN EN ENCAJE DE AMBAS RETINAS"
  },
  {
    "codigo":373575008,
    "descripcion":"ARTROPATÍA TRAUMÁTICA DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":1081141000119104,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE MÚSCULO DE HOMBRO DERECHO"
  },
  {
    "codigo":207900003,
    "descripcion":"FRACTURA NO EXPUESTA DEL AXIS, APÓFISIS TRANSVERSA"
  },
  {
    "codigo":240668005,
    "descripcion":"BORRELIOSIS"
  },
  {
    "codigo":699420006,
    "descripcion":"MIOHIPERPLASIA HEMIFACIAL"
  },
  {
    "codigo":764956007,
    "descripcion":"SÍNDROME DE DISPLASIA ÓSEA TIPO LARSEN Y BAJA ESTATURA"
  },
  {
    "codigo":1285574007,
    "descripcion":"SÍNDROME HEPATORRENAL CON LESIÓN RENAL AGUDA"
  },
  {
    "codigo":366235006,
    "descripcion":"COMPETENCIA DE LABIO - HALLAZGO"
  },
  {
    "codigo":69488000,
    "descripcion":"MONILETRIX"
  },
  {
    "codigo":167792001,
    "descripcion":"MORFOLOGÍA DE LOS ESPERMATOZOIDES - BUENA: MÁS DE 80% NORMALES"
  },
  {
    "codigo":266096002,
    "descripcion":"INFECCIÓN POR STAPHYLOCOCCUS AUREUS RESISTENTE A LA METICILINA"
  },
  {
    "codigo":16046031000119106,
    "descripcion":"ALTERACIÓN DE ARTICULACIÓN DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":724848006,
    "descripcion":"ROSÁCEA FIMATOSA"
  },
  {
    "codigo":298864007,
    "descripcion":"HALLAZGO RELACIONADO CON LA TEMPERATURA DE ARTICULACIÓN DE HOMBRO"
  },
  {
    "codigo":297029000,
    "descripcion":"SOBREDOSIS DE DIURÉTICO AHORRADOR DE POTASIO"
  },
  {
    "codigo":67653003,
    "descripcion":"EPIDERMÓLISIS BULLOSA PRETIBIAL"
  },
  {
    "codigo":428101005,
    "descripcion":"ACNÉ INFLAMATORIO"
  },
  {
    "codigo":723013007,
    "descripcion":"ERUPCIÓN CUTÁNEA AGUDA PAPULAR"
  },
  {
    "codigo":229658000,
    "descripcion":"DISFASIA SENSORIAL TRANSCORTICAL"
  },
  {
    "codigo":721178001,
    "descripcion":"DILATACIÓN VENOSA INTRAMUCOSA DE ESÓFAGO"
  },
  {
    "codigo":12277711000119108,
    "descripcion":"DISFORIA DE GÉNERO EN LA ADOLESCENCIA Y LA VIDA ADULTA"
  },
  {
    "codigo":426266003,
    "descripcion":"MIELITIS POSINFECCIOSA"
  },
  {
    "codigo":196890003,
    "descripcion":"HERNIA EPIGÁSTRICA IRREDUCTIBLE"
  },
  {
    "codigo":295194002,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE FENTANILO"
  },
  {
    "codigo":293359002,
    "descripcion":"REACCIÓN ADVERSA AL HIERRO SORBITOL"
  },
  {
    "codigo":63983005,
    "descripcion":"TRASTORNO PSICÓTICO CON ALUCINACIONES INDUCIDO POR INHALANTES"
  },
  {
    "codigo":422596007,
    "descripcion":"DIFICULTAD DEL CUIDADOR PARA INTERPRETAR LA COMUNICACIÓN NO VERBAL"
  },
  {
    "codigo":291524007,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR TRIMETOPRIMA"
  },
  {
    "codigo":93081001,
    "descripcion":"EXOFTALMÍA CONGÉNITA"
  },
  {
    "codigo":715673002,
    "descripcion":"DISPLASIA EPIFISARIA MÚLTIPLE TIPO 1"
  },
  {
    "codigo":27545003,
    "descripcion":"VOLUMEN MINUTO AUMENTADO"
  },
  {
    "codigo":15691881000119107,
    "descripcion":"ARTRITIS REUMATOIDEA SEROPOSITIVA BILATERAL DE RODILLA"
  },
  {
    "codigo":60313005,
    "descripcion":"HIPERTROFIA DEL CUERPO CAVERNOSO"
  },
  {
    "codigo":289689006,
    "descripcion":"HALLAZGO RELACIONADO CON LA POSICIÓN ANATÓMICA DEL ÚTERO GRÁVIDO"
  },
  {
    "codigo":781209009,
    "descripcion":"POSICIÓN VERTEBRAL NEUTRAL, INCLINADA A UN LADO Y ROTADA"
  },
  {
    "codigo":255086002,
    "descripcion":"CARCINOMA DE COLÉDOCO"
  },
  {
    "codigo":286019000,
    "descripcion":"DIFICULTAD PARA APAGAR UN ARTEFACTO ELECTRODOMÉSTICO"
  },
  {
    "codigo":1172590009,
    "descripcion":"SÍNDROME DE CIFOESCOLIOSIS, ATROFIA LATERAL DE LA LENGUA Y PARAPARESIA ESPÁSTICA HEREDITARIA"
  },
  {
    "codigo":417091001,
    "descripcion":"QUERATITIS EPITELIAL POR VIRUS DEL HERPES SIMPLE"
  },
  {
    "codigo":23875004,
    "descripcion":"SIN HALLAZGOS PATOLÓGICOS"
  },
  {
    "codigo":253251006,
    "descripcion":"OREJA ROTADA HACIA ATRÁS"
  },
  {
    "codigo":415256003,
    "descripcion":"EVENTRACIÓN DE PARED ANTERIOR DE ABDOMEN RECURRENTE OBSTRUIDA"
  },
  {
    "codigo":284184004,
    "descripcion":"SÍNDROME DE LEPTHANGAMUSHI"
  },
  {
    "codigo":249581000,
    "descripcion":"RIÑÓN NO PALPABLE"
  },
  {
    "codigo":710168009,
    "descripcion":"PESO DE NACIMIENTO MENOR DE 500 G"
  },
  {
    "codigo":1083651000119108,
    "descripcion":"EXOSTOSIS DE AMBOS CONDUCTOS AUDITIVOS EXTERNOS"
  },
  {
    "codigo":446189008,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE CONDUCTO BILIAR EXTRAHEPÁTICO"
  },
  {
    "codigo":1263554005,
    "descripcion":"NEUROPATÍA AUTONÓMICA AUTOINMUNITARIA LIMITADA"
  },
  {
    "codigo":870338007,
    "descripcion":"CALCIFICACIÓN DISTRÓFICA IATROGÉNICA NEONATAL"
  },
  {
    "codigo":83906008,
    "descripcion":"CALAMBRE DURANTE EL BAÑO"
  },
  {
    "codigo":247746009,
    "descripcion":"ALUCINACIONES VISUALES DISOCIATIVAS"
  },
  {
    "codigo":735596000,
    "descripcion":"DISESTESIA DE CUERO CABELLUDO"
  },
  {
    "codigo":278679009,
    "descripcion":"DIENTE CON ALTERACIÓN DE LA COLORACIÓN"
  },
  {
    "codigo":47468000,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA ARTERIA GÁSTRICA"
  },
  {
    "codigo":473452003,
    "descripcion":"PSICOSIS ATÍPICA"
  },
  {
    "codigo":14700006,
    "descripcion":"ALUMINOSIS"
  },
  {
    "codigo":240406000,
    "descripcion":"COMPLICACIONES CUTÁNEAS LEPROMATOSAS"
  },
  {
    "codigo":897601009,
    "descripcion":"LESIÓN TRAUMÁTICA DE CABEZA Y\/O CUELLO"
  },
  {
    "codigo":76566000,
    "descripcion":"ESQUIZOFRENIA RESIDUAL SUBCRÓNICA"
  },
  {
    "codigo":109334004,
    "descripcion":"OSTEORRADIONECROSIS DE HUESOS FACIALES"
  },
  {
    "codigo":764694005,
    "descripcion":"CARCINOMA DE CÉLULAS RENALES CON TRANSLOCACIÓN DE LA FAMILIA MIT"
  },
  {
    "codigo":402411005,
    "descripcion":"ANGIOEDEMA COLINÉRGICO"
  },
  {
    "codigo":369643008,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA DE PRÓSTATA Y URETRA, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":302272005,
    "descripcion":"NO REALIZA TRASLADOS CON SILLA DE RUEDAS"
  },
  {
    "codigo":202133001,
    "descripcion":"TRASTORNO DE CARTÍLAGO ARTICULAR DE REGIÓN DE HOMBRO"
  },
  {
    "codigo":300437002,
    "descripcion":"HALLAZGO RELACIONADO CON MEDICIONES ABDOMINALES"
  },
  {
    "codigo":105664009,
    "descripcion":"ENFERMEDAD CAUSADA POR ECHINOSTOMATIDAE"
  },
  {
    "codigo":365973006,
    "descripcion":"PATRÓN DE CONSUMO DE ALCOHOL DURANTE LA SEMANA - HALLAZGO"
  },
  {
    "codigo":298602006,
    "descripcion":"AMPLITUD DE FLEXIÓN ACTIVA DE LA COLUMNA LUMBAR NORMAL"
  },
  {
    "codigo":724586006,
    "descripcion":"NEOPLASIA OSTEÓGENA BENIGNA DE ESTERNÓN"
  },
  {
    "codigo":1855002,
    "descripcion":"TRASTORNO DEL DESARROLLO ACADÉMICO"
  },
  {
    "codigo":296767002,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE TETRACICLINA"
  },
  {
    "codigo":34623005,
    "descripcion":"GLAUCOMA CON PRESIÓN VENOSA EPIESCLERAL AUMENTADA"
  },
  {
    "codigo":67391006,
    "descripcion":"ENDOCARDITIS SIFILÍTICA"
  },
  {
    "codigo":460607008,
    "descripcion":"ORIGEN ANÓMALO DE CONDUCTO ARTERIOSO EN CAYADO AÓRTICO"
  },
  {
    "codigo":1343508008,
    "descripcion":"SÍNDROME DE CORDÓN POSTERIOR DEBIDO A NEUROSÍFILIS TABÉTICA"
  },
  {
    "codigo":63721001,
    "descripcion":"VÍCTIMA DE ENFRENTAMIENTO ARMADO"
  },
  {
    "codigo":424169002,
    "descripcion":"MACULOPATÍA EN OJO DE BUEY"
  },
  {
    "codigo":1145065002,
    "descripcion":"SOBREDOSIS INTENCIONAL DE TRICLOFÓS"
  },
  {
    "codigo":227561004,
    "descripcion":"INFERTILIDAD FEMENINA ASOCIADA CON ANOVULACIÓN"
  },
  {
    "codigo":131092009,
    "descripcion":"NIVEL DE TIROXINA POR ENCIMA DE RANGO DE REFERENCIA"
  },
  {
    "codigo":162025006,
    "descripcion":"DIFICULTAD PARA TRAGAR LÍQUIDOS"
  },
  {
    "codigo":293097009,
    "descripcion":"REACCIÓN ADVERSA A INMUNOGLOBULINA HUMANA"
  },
  {
    "codigo":782782004,
    "descripcion":"DISPLASIA ESPONDILOMETAFISARIA AUTOSÓMICA RECESIVA TIPO MEGARBANE"
  },
  {
    "codigo":291262006,
    "descripcion":"ANEMIA CRÓNICA SIMPLE"
  },
  {
    "codigo":94654006,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":192958009,
    "descripcion":"PARÁLISIS CEREBRAL HIPOTÓNICA"
  },
  {
    "codigo":289427002,
    "descripcion":"PRESENTACIÓN QUE DESCIENDE LENTAMENTE"
  },
  {
    "codigo":125587004,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL"
  },
  {
    "codigo":1010323006,
    "descripcion":"EXTENSIÓN DE LADO IZQUIERDO DE COLUMNA VERTEBRAL SACRA"
  },
  {
    "codigo":39481000087102,
    "descripcion":"CEFALEA CRÓNICA DEBIDA A TRASTORNO DE ARTICULACIÓN TEMPOROMANDIBULAR"
  },
  {
    "codigo":420499009,
    "descripcion":"HIPOGONADISMO HIPOGONADOTRÓFICO DEBIDO A DEFICIENCIA AISLADA DE GONADOTROFINA"
  },
  {
    "codigo":1303400001,
    "descripcion":"FRACTURA DE FALANGE DE DEDO PULGAR DERECHO"
  },
  {
    "codigo":713576003,
    "descripcion":"EMBARAZO GEMELAR MONOCIGÓTICO"
  },
  {
    "codigo":47161000087108,
    "descripcion":"DISTENSIÓN DE TENDÓN DE MÚSCULO PSOAS IZQUIERDO"
  },
  {
    "codigo":42041000087109,
    "descripcion":"QUEMADURA DE EXTREMIDAD SUPERIOR DERECHA"
  },
  {
    "codigo":254824006,
    "descripcion":"NEOPLASIA MALIGNA DE MESOTELIO"
  },
  {
    "codigo":123752003,
    "descripcion":"GLOMERULONEFRITIS POR INMUNOCOMPLEJOS"
  },
  {
    "codigo":285757001,
    "descripcion":"AGNOSIA VISUAL PARA LOS OBJETOS"
  },
  {
    "codigo":416829003,
    "descripcion":"ENFERMEDAD CAUSADA POR RICKETTSIA"
  },
  {
    "codigo":283922007,
    "descripcion":"LACERACIÓN DE LA URETRA"
  },
  {
    "codigo":52711003,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA VENA CÍSTICA"
  },
  {
    "codigo":183783005,
    "descripcion":"INSCRIPTO EN LISTA DE ADMISIÓN DE CIRUGÍA GENERAL"
  },
  {
    "codigo":85479007,
    "descripcion":"CAMBIOS DE COLOR DURANTE LA FORMACIÓN DEL DIENTE"
  },
  {
    "codigo":118247008,
    "descripcion":"HALLAZGO RADIOLÓGICO"
  },
  {
    "codigo":19943007,
    "descripcion":"CIRROSIS HEPÁTICA"
  },
  {
    "codigo":1197756002,
    "descripcion":"MIOPATÍA PROXIMAL CON DEPLECIÓN MITOCONDRIAL FOCAL"
  },
  {
    "codigo":247484002,
    "descripcion":"UÑAS DE RÁPIDO CRECIMIENTO"
  },
  {
    "codigo":18108002,
    "descripcion":"INTOXICACIÓN POR METOHEXITAL"
  },
  {
    "codigo":83644001,
    "descripcion":"DOLOR SORDO"
  },
  {
    "codigo":1359761000,
    "descripcion":"OBESIDAD INFANTIL POLIGENÉTICA COMÚN"
  },
  {
    "codigo":737169005,
    "descripcion":"COMEDOCARCINOMA IN SITU INTRADUCTAL DE MAMA"
  },
  {
    "codigo":1259622000,
    "descripcion":"COREA DEBIDA A ERROR INNATO DE METABOLISMO"
  },
  {
    "codigo":407654001,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: JAPONÉS"
  },
  {
    "codigo":440422002,
    "descripcion":"MIELOMA MÚLTIPLE ASINTOMÁTICO"
  },
  {
    "codigo":211046002,
    "descripcion":"ABRASIÓN DE PIEL DE INGLE"
  },
  {
    "codigo":276582002,
    "descripcion":"INTOXICACIÓN POR MEDICAMENTOS EN EL RECIÉN NACIDO"
  },
  {
    "codigo":473190001,
    "descripcion":"FILTRACIÓN DE CATÉTER DE DIÁLISIS PERITONEAL"
  },
  {
    "codigo":47206001,
    "descripcion":"DUPLICACIÓN INTESTINAL TUBULAR LARGA"
  },
  {
    "codigo":79974007,
    "descripcion":"ENFERMEDAD POR ARAÑAZO DE GATO"
  },
  {
    "codigo":351391000119103,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE PELVIS RENAL IZQUIERDA"
  },
  {
    "codigo":12603003,
    "descripcion":"PSEUDOCOLOBOMA DEL IRIS"
  },
  {
    "codigo":373051004,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM PEREGRINUM"
  },
  {
    "codigo":241979006,
    "descripcion":"BAROTRAUMA AURAL POR DESCENSO"
  },
  {
    "codigo":733499007,
    "descripcion":"ÍNDICE DE VOLUMEN SISTÓLICO CARDÍACO DISMINUIDO"
  },
  {
    "codigo":557571231000119105,
    "descripcion":"ANEURISMA ROTO DE AORTA ASCENDENTE"
  },
  {
    "codigo":209211009,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA NO EXPUESTA DEL ESTERNÓN"
  },
  {
    "codigo":76304001,
    "descripcion":"SÍNDROME DE POLIPOSIS MÚLTIPLE GASTROINTESTINAL"
  },
  {
    "codigo":307515009,
    "descripcion":"DEFICIENCIA AUTOINMUNITARIA DE FACTOR VIII"
  },
  {
    "codigo":305680002,
    "descripcion":"ATENDIDO POR GERIATRA"
  },
  {
    "codigo":698896005,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: ESPERANTO"
  },
  {
    "codigo":403984006,
    "descripcion":"HEMANGIOENDOTELIOMA COMPUESTO"
  },
  {
    "codigo":8933000,
    "descripcion":"SÍNDROME DE CRIGLER - NAJJAR, TIPO I"
  },
  {
    "codigo":402149002,
    "descripcion":"DERMATOSIS CAUSADA POR ESCARABAJO"
  },
  {
    "codigo":271077003,
    "descripcion":"VIRILISMO SUPRARRENAL"
  },
  {
    "codigo":860901003,
    "descripcion":"ALERGIA A CARBAMATO"
  },
  {
    "codigo":74469006,
    "descripcion":"DISTROFIA COROIDEA HEREDITARIA"
  },
  {
    "codigo":679071000119108,
    "descripcion":"DESPRENDIMIENTO DE MEMBRANA DE DESCEMET DE OJO DERECHO"
  },
  {
    "codigo":762597009,
    "descripcion":"DOLOR MUSCULOESQUELÉTICO CRÓNICO DEBIDO A INFLAMACIÓN PERSISTENTE"
  },
  {
    "codigo":72634002,
    "descripcion":"ESGUINCE DE LIGAMENTO DE ARTICULACIÓN TARSOMETATARSIANA"
  },
  {
    "codigo":236474006,
    "descripcion":"HIPERCISTINURIA AISLADA"
  },
  {
    "codigo":433082007,
    "descripcion":"ESTADO MENTAL ALTERADO EN FORMA TRANSITORIA"
  },
  {
    "codigo":234639001,
    "descripcion":"SÍNDROME DE TRIPLE X, EPILEPSIA E HIPOGAMMAGLOBULINEMIA"
  },
  {
    "codigo":1217679002,
    "descripcion":"INFLAMACIÓN CRÓNICA CICATRIZAL DE CONJUNTIVA CAUSADA POR FÁRMACO"
  },
  {
    "codigo":300175007,
    "descripcion":"YUNQUE NORMAL"
  },
  {
    "codigo":365711009,
    "descripcion":"HALLAZGO RELACIONADO CON LA COMPOSICIÓN DEL LÍQUIDO SINOVIAL"
  },
  {
    "codigo":298340002,
    "descripcion":"SOPORTE DE PESO - HALLAZGO"
  },
  {
    "codigo":396644006,
    "descripcion":"EXTENSIÓN EXTRACAPSULAR DE TUMOR GANGLIONAR, PRESENTE"
  },
  {
    "codigo":1593000,
    "descripcion":"HEMIPLEJÍA INFANTIL"
  },
  {
    "codigo":34361001,
    "descripcion":"CATARATA TRAUMÁTICA"
  },
  {
    "codigo":460345001,
    "descripcion":"MIOCARDITIS CAUSADA POR ECHOVIRUS"
  },
  {
    "codigo":296505005,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE PAPAVERINA"
  },
  {
    "codigo":1345081009,
    "descripcion":"PATRÓN DE USO NOCIVO DE CORTICOSTEROIDE"
  },
  {
    "codigo":165433009,
    "descripcion":"ÍNDICE DE COLOR ERITROCÍTICO POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1179406007,
    "descripcion":"INFECCIÓN DE VÍAS URINARIAS POR PSEUDOMONAS AERUGINOSA"
  },
  {
    "codigo":196366009,
    "descripcion":"PERIODONTITIS CRÓNICA SIMPLE"
  },
  {
    "codigo":63459005,
    "descripcion":"INFECCIÓN CLÍNICA"
  },
  {
    "codigo":292835006,
    "descripcion":"REACCIÓN ADVERSA A LOS INTERFERONES"
  },
  {
    "codigo":94392001,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE GANGLIO LINFÁTICO"
  },
  {
    "codigo":440721000124102,
    "descripcion":"INGESTA INADECUADA DE ÁCIDO PANTOTÉNICO"
  },
  {
    "codigo":782520007,
    "descripcion":"EXACERBACIÓN DE ASMA ALÉRGICA POR INFECCIÓN"
  },
  {
    "codigo":61624008,
    "descripcion":"ERISIPELA ESTREPTOCÓCICA CRÓNICA RECURRENTE"
  },
  {
    "codigo":291000007,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR METIPRILÓN"
  },
  {
    "codigo":127160008,
    "descripcion":"LINFADENOPATÍA ILÍACA COMÚN INTERNA"
  },
  {
    "codigo":715149009,
    "descripcion":"INTOXICACIÓN POR MARISCOS CAUSADA POR GONYAULAX CATENELLA"
  },
  {
    "codigo":92557009,
    "descripcion":"CARCINOMA IN SITU DE BRONQUIO"
  },
  {
    "codigo":713314006,
    "descripcion":"HALLAZGO RELACIONADO CON LA SENSIBILIDAD DE MIEMBRO INFERIOR"
  },
  {
    "codigo":1303138007,
    "descripcion":"ARTRITIS DE ARTICULACIÓN DE REGIÓN DE AMBAS MUÑECAS"
  },
  {
    "codigo":57954008,
    "descripcion":"FALSIFICACIÓN"
  },
  {
    "codigo":418402006,
    "descripcion":"DEPÓSITOS DE HIERRO EN LA CÓRNEA"
  },
  {
    "codigo":449335002,
    "descripcion":"SEPSIS CAUSADA POR LISTERIA MONOCYTOGENES"
  },
  {
    "codigo":88887003,
    "descripcion":"SÍNDROME DE HIPOTENSIÓN MATERNA"
  },
  {
    "codigo":285495005,
    "descripcion":"DIFICULTAD PARA SELLAR LOS LABIOS"
  },
  {
    "codigo":283660000,
    "descripcion":"HERIDA POR PINCHAZO DE CLAVO EN LA MUÑECA"
  },
  {
    "codigo":1268535008,
    "descripcion":"TRABAJO DE PARTO OBSTRUIDO DEBIDO A GEMELOS ENGANCHADOS"
  },
  {
    "codigo":54284000,
    "descripcion":"INFESTACIÓN CAUSADA POR DEMODEX CRICETI"
  },
  {
    "codigo":249057000,
    "descripcion":"PARTES FETALES NO PALPABLES A TRAVÉS DEL ABDOMEN"
  },
  {
    "codigo":871649000,
    "descripcion":"MIOCARDIOPATÍA HIPERTRÓFICA DEBIDA A ENFERMEDAD LISOSÓMICA"
  },
  {
    "codigo":16711431000119101,
    "descripcion":"EDEMA DE MÁCULA RETINIANA DEBIDO A OCLUSIÓN DE RAMA DE VENA DE LA RETINA DERECHA"
  },
  {
    "codigo":609505004,
    "descripcion":"INTERRUPCIÓN INDUCIDA DEL EMBARAZO COMPLICADA POR DAÑO DE LIGAMENTO ANCHO"
  },
  {
    "codigo":773345007,
    "descripcion":"SÍNDROME DE OLIGODONCIA Y PREDISPOSICIÓN AL CÁNCER"
  },
  {
    "codigo":707809009,
    "descripcion":"DOLOR PROVOCADO POR TRAUMATISMO"
  },
  {
    "codigo":1197494003,
    "descripcion":"SÍNDROME DE FIBROMATOSIS HIALINA"
  },
  {
    "codigo":279990005,
    "descripcion":"LIVEDO RETICULARIS SIN ULCERACIÓN"
  },
  {
    "codigo":771510006,
    "descripcion":"HIPOTIROIDISMO CONGÉNITO CENTRAL LIGADO AL CROMOSOMA X CON AUMENTO DE TAMAÑO TESTICULAR DE COMIENZO TARDÍO"
  },
  {
    "codigo":116150007,
    "descripcion":"CLASE DE DETERIORO"
  },
  {
    "codigo":1230262006,
    "descripcion":"PATRÓN DE USO NOCIVO DE HORMONA ESTEROIDE"
  },
  {
    "codigo":212619008,
    "descripcion":"INTOXICACIÓN POR DERIVADO DE HIDANTOÍNA"
  },
  {
    "codigo":309088003,
    "descripcion":"MASA RENAL"
  },
  {
    "codigo":276320009,
    "descripcion":"LESIÓN DE MUCOSA"
  },
  {
    "codigo":405557003,
    "descripcion":"OCLUSIÓN DE ARTERIA DE MIEMBRO INFERIOR"
  },
  {
    "codigo":45109003,
    "descripcion":"INFECCIÓN CAUSADA POR OESOPHAGODONTUS"
  },
  {
    "codigo":208949007,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE LA ARTICULACIÓN DE LA RODILLA, EXTERNA"
  },
  {
    "codigo":403722002,
    "descripcion":"ULCERACIÓN DE PIEL DEBIDA A RADIOTERAPIA"
  },
  {
    "codigo":895242004,
    "descripcion":"FORMA ANCHA ANORMAL CONGÉNITA DE FALANGE DISTAL DE DEDO ANULAR"
  },
  {
    "codigo":762335003,
    "descripcion":"TRASTORNO DEL ESTADO DE ÁNIMO CON SÍNTOMAS MANÍACOS CAUSADO POR ALUCINÓGENO"
  },
  {
    "codigo":238047006,
    "descripcion":"BETA-D-MANOSIDOSIS"
  },
  {
    "codigo":74207008,
    "descripcion":"DERMATITIS VESICULAR AGUDA"
  },
  {
    "codigo":6836001,
    "descripcion":"LESIÓN TRAUMÁTICA DEL PLEXO BRAQUIAL"
  },
  {
    "codigo":41439009,
    "descripcion":"INTOXICACIÓN POR MICROCYSTIS FLOS-AQUAE"
  },
  {
    "codigo":103305000,
    "descripcion":"VOZ SENIL"
  },
  {
    "codigo":299913001,
    "descripcion":"SENSACIÓN AL TACTO SUAVE: ALTERADA"
  },
  {
    "codigo":203444008,
    "descripcion":"FRACTURA OSTEOPORÓTICA DEBIDA A OSTEOPOROSIS POSOOFORECTOMÍA"
  },
  {
    "codigo":398217003,
    "descripcion":"LACERACIÓN DE VÍA AÉREA"
  },
  {
    "codigo":430985005,
    "descripcion":"PÉRDIDA DE AUDICIÓN SENSITIVA BILATERAL"
  },
  {
    "codigo":70537007,
    "descripcion":"SIGNO DE HEGAR"
  },
  {
    "codigo":365449009,
    "descripcion":"HALLAZGO EN LOS ANTECEDENTES DEMOGRÁFICOS"
  },
  {
    "codigo":298078007,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE ANTEBRAZO"
  },
  {
    "codigo":306131000119100,
    "descripcion":"GOTA TOFÁCEA CRÓNICA DE TOBILLO Y\/O PIE CAUSADA POR FÁRMACO"
  },
  {
    "codigo":10948051000119101,
    "descripcion":"HERIDA ABIERTA DE DEDO MEDIO DE MANO DERECHA DEBIDA A MORDEDURA DE ANIMAL"
  },
  {
    "codigo":687571000119101,
    "descripcion":"NEVO EPIDÉRMICO PILOSO PIGMENTADO DE TRONCO"
  },
  {
    "codigo":339411000119103,
    "descripcion":"EXOTROPÍA MONOCULAR CON PATRÓN A DE OJO IZQUIERDO"
  },
  {
    "codigo":11808211000119102,
    "descripcion":"PERFORACIÓN TRAUMÁTICA DE ÍLEON"
  },
  {
    "codigo":1076691000119104,
    "descripcion":"TENDINITIS DEL MÚSCULO FLEXOR LARGO DEL DEDO GORDO IZQUIERDO"
  },
  {
    "codigo":16068051000119106,
    "descripcion":"NEOPLASIA LIPOMATOSA BENIGNA DE PIEL Y\/O DEL TEJIDO CELULAR SUBCUTÁNEO DE AMBAS EXTREMIDADES SUPERIORES"
  },
  {
    "codigo":197939009,
    "descripcion":"HEMATURIA DOLOROSA"
  },
  {
    "codigo":295891000119108,
    "descripcion":"TRAYECTO FISTULOSO CON DRENAJE CONCOMITANTE CON OSTEOMIELITIS CRÓNICA DE HOMBRO Y DEBIDO A ELLA"
  },
  {
    "codigo":334291000119109,
    "descripcion":"ENTROPIÓN SENIL DE PÁRPADO INFERIOR DERECHO"
  },
  {
    "codigo":106451000119106,
    "descripcion":"BOCIO DEBIDO A TIROIDITIS"
  },
  {
    "codigo":142291000119107,
    "descripcion":"DÉFICIT COGNITIVO EN LA FUNCIÓN PSICOMOTRIZ"
  },
  {
    "codigo":308691000119107,
    "descripcion":"GANGLIÓN DE CODO DERECHO"
  },
  {
    "codigo":292573001,
    "descripcion":"REACCIÓN ADVERSA A LA AZELASTINA"
  },
  {
    "codigo":270291000119109,
    "descripcion":"TRASTORNO DE IDENTIDAD DE LA INFANCIA"
  },
  {
    "codigo":294408008,
    "descripcion":"ALERGIA A PERBORATO DE SODIO"
  },
  {
    "codigo":194269002,
    "descripcion":"SALPINGITIS CRÓNICA DE TROMPA DE EUSTAQUIO"
  },
  {
    "codigo":352211000119108,
    "descripcion":"MELANOMA MALIGNO DE PIEL DE OREJA IZQUIERDA"
  },
  {
    "codigo":1144541000,
    "descripcion":"HIPOPLASIA DE PRÓSTATA"
  },
  {
    "codigo":423645007,
    "descripcion":"SEMINOMA DE TESTÍCULO, ESTADIO 2"
  },
  {
    "codigo":126898002,
    "descripcion":"NEOPLASIA DEL GLANDE DEL PENE"
  },
  {
    "codigo":716722005,
    "descripcion":"SÍNDROME AXONAL SENSITIVO-MOTOR AGUDO DE GUILLAIN-BARRÉ"
  },
  {
    "codigo":15648981000119103,
    "descripcion":"ANEURISMA DE ARTERIA ILÍACA COMÚN DERECHA"
  },
  {
    "codigo":1306546007,
    "descripcion":"NEOPLASIA MALIGNA CON METÁSTASIS A CUADRANTE SUPERIOR INTERNO DE MAMA"
  },
  {
    "codigo":288903001,
    "descripcion":"RETIENE ALIMENTOS EN LA BOCA"
  },
  {
    "codigo":714887007,
    "descripcion":"INCAPAZ DE PASAR DE UNA UBICACIÓN A OTRA"
  },
  {
    "codigo":59527008,
    "descripcion":"INFECCIÓN POR CITOMEGALOVIRUS CONGÉNITA"
  },
  {
    "codigo":385372004,
    "descripcion":"ESTADIO FIGO PARA MELANOMA VULVAR - HALLAZGO"
  },
  {
    "codigo":10625391000119100,
    "descripcion":"BRONCONEUMONÍA CAUSADA POR STAPHYLOCOCCUS AUREUS SENSIBLE A LA METICILINA"
  },
  {
    "codigo":90460009,
    "descripcion":"LESIÓN TRAUMÁTICA DEL CUELLO"
  },
  {
    "codigo":449073009,
    "descripcion":"NEOPLASIA EPITELIAL MALIGNA DE CUERPO DE ÚTERO"
  },
  {
    "codigo":840454003,
    "descripcion":"QUISTE DE MÉDULA ESPINAL CAUSADA POR PARÁSITO"
  },
  {
    "codigo":54022006,
    "descripcion":"FÍSTULA URETROPERINEAL"
  },
  {
    "codigo":609243000,
    "descripcion":"VIVE EN CASA SEMI-INDEPENDIENTE"
  },
  {
    "codigo":283398009,
    "descripcion":"CORTE EN LA CABEZA"
  },
  {
    "codigo":281563002,
    "descripcion":"NEUROBLASTOMA TORÁCICO"
  },
  {
    "codigo":19419002,
    "descripcion":"SÍNDROME DE MONOSOMÍA PARCIAL 8P"
  },
  {
    "codigo":248795006,
    "descripcion":"YA NO ALCANZA EL ORGASMO"
  },
  {
    "codigo":83120002,
    "descripcion":"INFECCIÓN CAUSADA POR ASCARIDIA GALLI"
  },
  {
    "codigo":410800006,
    "descripcion":"ARTRITIS IDIOPÁTICA JUVENIL, OLIGOARTRITIS EXTENDIDA"
  },
  {
    "codigo":246960009,
    "descripcion":"HERIDA DEL ESTROMA DE LA CÓRNEA"
  },
  {
    "codigo":312496009,
    "descripcion":"ESTENOSIS DE ARTERIA ILÍACA"
  },
  {
    "codigo":212357003,
    "descripcion":"LESIÓN DE LOS NERVIOS Y DE LA MÉDULA ESPINAL A NIVEL DORSAL"
  },
  {
    "codigo":16906761000119101,
    "descripcion":"CARCINOMA IN SITU DE PIEL DE PÁRPADO SUPERIOR DERECHO"
  },
  {
    "codigo":310661005,
    "descripcion":"LACTANTE PREMATURO: 28-37 SEMANAS"
  },
  {
    "codigo":81285006,
    "descripcion":"PÉNFIGO VEGETANTE"
  },
  {
    "codigo":204040004,
    "descripcion":"AGENESIA CEREBRAL"
  },
  {
    "codigo":277893002,
    "descripcion":"SÍNDROME DE GLUCOPROTEÍNA DEFICIENTE EN CARBOHIDRATOS, TIPO I"
  },
  {
    "codigo":112218005,
    "descripcion":"FOSFENO"
  },
  {
    "codigo":1259098008,
    "descripcion":"TRASTORNO DE SISTEMA NERVIOSO AUTÓNOMO CAUSADO POR FÁRMACO"
  },
  {
    "codigo":208687001,
    "descripcion":"FRACTURA NO EXPUESTA DE BASE DE METATARSIANO"
  },
  {
    "codigo":1255428004,
    "descripcion":"QUISTE DE ASTA POSTERIOR DE MENISCO INTERNO DE RODILLA"
  },
  {
    "codigo":403460005,
    "descripcion":"CONDUCTO VITELINO PERMEABLE"
  },
  {
    "codigo":1222660008,
    "descripcion":"SÍNDROME DE AGENESIA PANCREÁTICA Y HOLOPROSENCEFALIA"
  },
  {
    "codigo":237785004,
    "descripcion":"HIPOADRENALISMO"
  },
  {
    "codigo":686601000119109,
    "descripcion":"FEOCROMOCITOMA MALIGNO PRIMARIO DE GLÁNDULA SUPRARRENAL DERECHA"
  },
  {
    "codigo":235950005,
    "descripcion":"PANCREATITIS AGUDA TRAUMÁTICA"
  },
  {
    "codigo":168579000,
    "descripcion":"RADIOGRAFÍA SIMPLE DE COLUMNA VERTEBRAL LUMBAR NORMAL"
  },
  {
    "codigo":301486008,
    "descripcion":"INCAPAZ DE DOBLAR ESQUINAS"
  },
  {
    "codigo":299651004,
    "descripcion":"AMPUTADO A NIVEL DE LA RODILLA"
  },
  {
    "codigo":365187005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA PARARSE EN LA BAÑERA"
  },
  {
    "codigo":234115007,
    "descripcion":"LINFORROIDES"
  },
  {
    "codigo":232280003,
    "descripcion":"OTORREA CEREBROESPINAL POSTRAUMÁTICA"
  },
  {
    "codigo":363352004,
    "descripcion":"NEOPLASIA MALIGNA DE CONDUCTO ANAL"
  },
  {
    "codigo":2904007,
    "descripcion":"INFERTILIDAD MASCULINA"
  },
  {
    "codigo":166744008,
    "descripcion":"NIVEL DE MAGNESIO EN SANGRE DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":164909002,
    "descripcion":"BLOQUEO DE RAMA IZQUIERDA EN EL ELECTROCARDIOGRAMA"
  },
  {
    "codigo":425218000,
    "descripcion":"ESTADOS CONFLICTIVOS DEL DUELO"
  },
  {
    "codigo":849488701000119104,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DEBIDO A EMBOLIA DE ARTERIA CEREBRAL ANTERIOR DERECHA"
  },
  {
    "codigo":95703008,
    "descripcion":"ATROFIA RETINIANA PROGRESIVA MULTIFOCAL"
  },
  {
    "codigo":292311009,
    "descripcion":"REACCIÓN ADVERSA A LA MIANSERINA"
  },
  {
    "codigo":716460002,
    "descripcion":"CAPAZ DE TOLERAR DOLOR EN PARTE CORPORAL"
  },
  {
    "codigo":290476003,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR FÁRMACO ANTIESPASMÓDICO"
  },
  {
    "codigo":28332004,
    "descripcion":"RUPTURA FAMILIAR"
  },
  {
    "codigo":126636004,
    "descripcion":"NEOPLASIA DE LA REGIÓN SUPRACLAVICULAR"
  },
  {
    "codigo":1081801000112104,
    "descripcion":"SÍNDROME NEFRÓTICO AGUDO"
  },
  {
    "codigo":59265000,
    "descripcion":"DISNEA PAROXÍSTICA"
  },
  {
    "codigo":92033002,
    "descripcion":"NEOPLASIA BENIGNA DE BRONQUIO DEL LÓBULO INFERIOR IZQUIERDO DEL PULMÓN"
  },
  {
    "codigo":93868009,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA AMÍGDALA LINGUAL"
  },
  {
    "codigo":288641005,
    "descripcion":"INCAPAZ DE COMENZAR UNA CONVERSACIÓN"
  },
  {
    "codigo":15952701000119108,
    "descripcion":"FIBROADENOSIS DE AMBAS MAMAS"
  },
  {
    "codigo":10683351000119102,
    "descripcion":"MASA DE TEJIDO SUBCUTÁNEO"
  },
  {
    "codigo":188502002,
    "descripcion":"LINFOSARCOMA DE GANGLIOS LINFÁTICOS INTRABDOMINALES"
  },
  {
    "codigo":254038003,
    "descripcion":"AGENESIA DE COLUMNA VERTEBRAL"
  },
  {
    "codigo":286806003,
    "descripcion":"CARÁCTER TESTARUDO"
  },
  {
    "codigo":24662006,
    "descripcion":"GRIPE CAUSADA POR VIRUS INFLUENZA B"
  },
  {
    "codigo":284971009,
    "descripcion":"NO REALIZA ACTIVIDAD RELACIONADA CON EL VESTIRSE"
  },
  {
    "codigo":283136003,
    "descripcion":"CONTUSIÓN SUPERFICIAL DE PIEL DE CUELLO"
  },
  {
    "codigo":84693004,
    "descripcion":"HEMORRAGIA INTERVELLOSA DE LA PLACENTA"
  },
  {
    "codigo":838357005,
    "descripcion":"NEUROPATÍA AGUDA DE NERVIO GLOSOFARÍNGEO CAUSADA POR HERPES ZÓSTER"
  },
  {
    "codigo":15735921000119103,
    "descripcion":"PERFORACIÓN DE CÓRNEA DE AMBOS OJOS"
  },
  {
    "codigo":17322007,
    "descripcion":"ENFERMEDAD PARASITARIA"
  },
  {
    "codigo":246698007,
    "descripcion":"PATRÓN DE VERGENCIA EN Y INVERTIDA"
  },
  {
    "codigo":212095004,
    "descripcion":"QUEMADURA QUE COMPROMETE 70-79 PORCIENTO DE LA SUPERFICIE DEL CUERPO, CON QUEMADURA DE ESPESOR COMPLETO QUE AFECTA 10-19 PORCIENTO DE LA SUPERFICIE CORPORAL"
  },
  {
    "codigo":210260000,
    "descripcion":"LESIÓN TRAUMÁTICA DE GLÁNDULA SUPRARRENAL CON HERIDA ABIERTA HACIA CAVIDAD ABDOMINAL"
  },
  {
    "codigo":111956001,
    "descripcion":"FUNCIÓN OSTEOBLÁSTICA DISMINUIDA"
  },
  {
    "codigo":334961000119105,
    "descripcion":"GLAUCOMA SECUNDARIO DE ÁNGULO CERRADO DE OJO DERECHO DEBIDO A BLOQUEO PUPILAR"
  },
  {
    "codigo":46420000,
    "descripcion":"ÍLEO MECÁNICO"
  },
  {
    "codigo":372265000,
    "descripcion":"INVASIÓN TUMORAL DE PEQUEÑOS VASOS PRESENTE"
  },
  {
    "codigo":243028008,
    "descripcion":"LESIÓN POR RÁFAGA DE MINA TERRESTRE"
  },
  {
    "codigo":699945003,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: BÚLGARO"
  },
  {
    "codigo":11817007,
    "descripcion":"INFECCIÓN ACTINOMICÓTICA"
  },
  {
    "codigo":110121007,
    "descripcion":"LACERACIÓN COMPLEJA DE LA ENCÍA ALVEOLAR DEL MAXILAR SUPERIOR"
  },
  {
    "codigo":765481009,
    "descripcion":"XANTOMA DE HUESO"
  },
  {
    "codigo":763646004,
    "descripcion":"PRÓTESIS DE ARTICULACIÓN DE MUÑECA PRESENTE"
  },
  {
    "codigo":403198004,
    "descripcion":"QUERATOSIS ACTÍNICA LIQUENOIDE"
  },
  {
    "codigo":9982009,
    "descripcion":"INTOXICACIÓN CAUSADA POR COCAÍNA"
  },
  {
    "codigo":40915004,
    "descripcion":"TRASTORNO DEL ORGASMO"
  },
  {
    "codigo":303059007,
    "descripcion":"HIPOINSULINEMIA POSPANCREATECTOMÍA"
  },
  {
    "codigo":1251496003,
    "descripcion":"METÁSTASIS DE CARCINOMA DE ÚVULA"
  },
  {
    "codigo":301224006,
    "descripcion":"REGIÓN SUBGLÓTICA NORMAL"
  },
  {
    "codigo":202920008,
    "descripcion":"TENOSINOVITIS DEL EXTENSOR LARGO DEL DEDO GORDO"
  },
  {
    "codigo":299389001,
    "descripcion":"CHOQUE ROTULIANO PRESENTE"
  },
  {
    "codigo":235688009,
    "descripcion":"ÚLCERA DE DUODENO POR ESTRÉS"
  },
  {
    "codigo":70013003,
    "descripcion":"SIAMESES ASIMÉTRICOS"
  },
  {
    "codigo":364925005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA ACOSTARSE"
  },
  {
    "codigo":168317006,
    "descripcion":"CRYPTOSPORIDIUM AISLADO EN MATERIA FECAL POR CULTIVO"
  },
  {
    "codigo":4477007,
    "descripcion":"MIOPATÍA JUVENIL Y ACIDOSIS LÁCTICA"
  },
  {
    "codigo":233853009,
    "descripcion":"ENDOCARDITIS DE PRÓTESIS VALVULAR"
  },
  {
    "codigo":264786003,
    "descripcion":"DIAGRAMA DE AMSLER - HALLAZGO"
  },
  {
    "codigo":363090004,
    "descripcion":"TRASTORNO DEL METABOLISMO PROTEICO"
  },
  {
    "codigo":461394005,
    "descripcion":"ORIGEN NORMAL DE CONDUCTO ARTERIOSO EN CAYADO AÓRTICO IZQUIERDO"
  },
  {
    "codigo":232018006,
    "descripcion":"VITREORRETINOPATÍA PROLIFERATIVA POSTERIOR"
  },
  {
    "codigo":230183001,
    "descripcion":"ENCEFALITIS POR HONGOS"
  },
  {
    "codigo":721703004,
    "descripcion":"HEMORROIDES INTERNAS, GRADO I"
  },
  {
    "codigo":424956000,
    "descripcion":"HIPERPLASIA DEL EPITELIO PIGMENTARIO DE LA RETINA"
  },
  {
    "codigo":228348001,
    "descripcion":"ESTABLECE REGLAS ACERCA DE LA BEBIDA"
  },
  {
    "codigo":95441000,
    "descripcion":"ESTENOSIS DE ARTERIA PULMONAR"
  },
  {
    "codigo":293884008,
    "descripcion":"ALERGIA A SECOBARBITAL"
  },
  {
    "codigo":292049003,
    "descripcion":"EFECTO ADVERSO DE LA DEXTROMORAMIDA"
  },
  {
    "codigo":128209004,
    "descripcion":"POLIRRADICULOPATÍA DESMIELINIZANTE INFLAMATORIA CRÓNICA"
  },
  {
    "codigo":193745007,
    "descripcion":"VISIÓN ESCASA EN UN OJO"
  },
  {
    "codigo":10659391000119102,
    "descripcion":"ÚLCERA DE TALÓN DERECHO"
  },
  {
    "codigo":423121009,
    "descripcion":"CARCINOMA PULMONAR NO MICROCÍTICO, TNM ESTADIO 4"
  },
  {
    "codigo":1142182006,
    "descripcion":"REACCIÓN ADVERSA A VACUNA CON ANTÍGENO DE COVID-19"
  },
  {
    "codigo":290214007,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR MEPTAZINOL"
  },
  {
    "codigo":716198008,
    "descripcion":"SÍNDROME DE RETRASO DEL CRECIMIENTO CON HIDROCEFALIA E HIPOPLASIA PULMONAR"
  },
  {
    "codigo":93606008,
    "descripcion":"OSIFICACIÓN INCOMPLETA DEL ASTRÁGALO"
  },
  {
    "codigo":28070007,
    "descripcion":"HIPERPLASIA MAXILAR CONGÉNITA"
  },
  {
    "codigo":880038008,
    "descripcion":"MIOCARDIOPATÍA DILATADA CAUSADA POR ENFERMEDAD DE ALMACENAMIENTO LISOSÓMICO"
  },
  {
    "codigo":124539004,
    "descripcion":"DEFICIENCIA DE FOSFOAMIDASA"
  },
  {
    "codigo":288379005,
    "descripcion":"NO PASA PÁGINAS"
  },
  {
    "codigo":188240003,
    "descripcion":"NEOPLASIA MALIGNA DE CÚPULA DE VEJIGA URINARIA"
  },
  {
    "codigo":778064009,
    "descripcion":"NEOPLASIA CON PRODUCCIÓN ECTÓPICA DE ALDOSTERONA"
  },
  {
    "codigo":89936009,
    "descripcion":"ENSAMBLE MOLECULAR DEFECTUOSO"
  },
  {
    "codigo":284709001,
    "descripcion":"MORDERSE LA LENGUA"
  },
  {
    "codigo":448549004,
    "descripcion":"FIBROMA DE MIEMBRO INFERIOR"
  },
  {
    "codigo":311001000119102,
    "descripcion":"DERRAME INTERMITENTE DE ARTICULACIÓN DE CADERA DERECHA"
  },
  {
    "codigo":282874001,
    "descripcion":"NO SE PONE DE PIE"
  },
  {
    "codigo":86266009,
    "descripcion":"OFTALMOPLEJÍA INTERNA TOTAL"
  },
  {
    "codigo":11779801000119104,
    "descripcion":"ABRASIÓN DE PIEL DE REGIÓN DE CODO IZQUIERDO"
  },
  {
    "codigo":248271005,
    "descripcion":"EXHAUSTO CON EL MÍNIMO EJERCICIO"
  },
  {
    "codigo":1264079005,
    "descripcion":"TRASTORNO FETAL CAUSADO POR TRANSFERENCIA PLACENTARIA DE SUERO INMUNE"
  },
  {
    "codigo":1296847007,
    "descripcion":"DEFICIENCIA DE METILCOBALAMINA TIPO CBIE"
  },
  {
    "codigo":444879009,
    "descripcion":"ESTENOSIS DE AGUJERO OCCIPITAL"
  },
  {
    "codigo":770724001,
    "descripcion":"PARAPLEJÍA ESPÁSTICA AUTOSÓMICA RECESIVA TIPO 70"
  },
  {
    "codigo":736121002,
    "descripcion":"REQUIERE TRATAMIENTO CON WARFARINA DE POR VIDA"
  },
  {
    "codigo":277369003,
    "descripcion":"HAMARTOMA DE CEREBRO"
  },
  {
    "codigo":80761006,
    "descripcion":"PSEUDO-OBSTRUCCIÓN CRÓNICA PRIMARIA DEL INTESTINO GRUESO"
  },
  {
    "codigo":11861721000119108,
    "descripcion":"RUPTURA TRAUMÁTICA DE LIGAMENTO CRUZADO POSTERIOR DE RODILLA DERECHA"
  },
  {
    "codigo":47993009,
    "descripcion":"PRODUCCIÓN NORMAL DE LINFOCITOS"
  },
  {
    "codigo":111694003,
    "descripcion":"LESIÓN TRAUMÁTICA DE UNA RAMA DEL TRONCO CELÍACO"
  },
  {
    "codigo":109859000,
    "descripcion":"HIPOVITAMINOSIS C CON HEMORRAGIA"
  },
  {
    "codigo":44323002,
    "descripcion":"TUBERCULOSIS DEL RIÑÓN"
  },
  {
    "codigo":77091003,
    "descripcion":"DESNUTRICIÓN MODERADA (SEGÚN LA CLASIFICACIÓN DE GÓMEZ PESO ENTRE 60% Y MENOS DEL 75% DEL PESO ESTÁNDAR)"
  },
  {
    "codigo":372003004,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL PÁNCREAS"
  },
  {
    "codigo":699683004,
    "descripcion":"DIENTE CARIADO NO RESTAURABLE"
  },
  {
    "codigo":75256000,
    "descripcion":"INFECCIÓN CAUSADA POR PARAGONIMUS KELLICOTTI"
  },
  {
    "codigo":1254904002,
    "descripcion":"PIGMENTACIÓN OCUPACIONAL NO MELÁNICA DEBIDA A SUSTANCIA EXÓGENA"
  },
  {
    "codigo":1287672003,
    "descripcion":"CONVULSIÓN EPILÉPTICA DE LÓBULO FRONTAL"
  },
  {
    "codigo":304632005,
    "descripcion":"CABEZA UBICADA EN PINZA DE TRES PUNTAS"
  },
  {
    "codigo":339981000119100,
    "descripcion":"LEUCOCORIA IZQUIERDA"
  },
  {
    "codigo":42488007,
    "descripcion":"ÍNDICE CARDÍACO AUMENTADO"
  },
  {
    "codigo":239096008,
    "descripcion":"PÓLIPO DE ANEXOS EN EL RECIÉN NACIDO"
  },
  {
    "codigo":271864008,
    "descripcion":"MOCO EN MATERIA FECAL"
  },
  {
    "codigo":402936008,
    "descripcion":"BOTRIOMICOSIS PSEUDOMONIÁSICA"
  },
  {
    "codigo":9720009,
    "descripcion":"CICATRIZ DEL CUELLO UTERINO, QUE AFECTA EL EMBARAZO"
  },
  {
    "codigo":827085005,
    "descripcion":"REFLEJO DE MICCIÓN NORMAL"
  },
  {
    "codigo":204493007,
    "descripcion":"MALFORMACIÓN ARTERIOVENOSA DE VASOS PRECEREBRALES"
  },
  {
    "codigo":237261008,
    "descripcion":"CORDÓN UMBILICAL LARGO"
  },
  {
    "codigo":1187533007,
    "descripcion":"DISTONÍA DEBIDA A SÍNDROME DE LEIGH"
  },
  {
    "codigo":202658005,
    "descripcion":"ESPONDILOSIS CERVICAL EN DOS NIVELES SIN MIELOPATÍA"
  },
  {
    "codigo":432034007,
    "descripcion":"LIPASA PANCREÁTICA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":169890009,
    "descripcion":"TALLA AL NACER = ENTRE PERCENTILOS 25 Y 49"
  },
  {
    "codigo":366498009,
    "descripcion":"AMPLITUD DE EXTENSIÓN HORIZONTAL DE HOMBRO - HALLAZGO"
  },
  {
    "codigo":200823002,
    "descripcion":"DERMATITIS DE CONTACTO CAUSADA POR URUSHIOL DE HIEDRA VENENOSA ORIENTAL"
  },
  {
    "codigo":299127005,
    "descripcion":"ARTICULACIÓN DE DEDO DE LA MANO - TUMEFACCIÓN SINOVIAL"
  },
  {
    "codigo":262689001,
    "descripcion":"CONTUSIÓN DE CEREBRO"
  },
  {
    "codigo":66081003,
    "descripcion":"PIGMENTACIÓN CONJUNTIVAL"
  },
  {
    "codigo":33313004,
    "descripcion":"SINOSTOSIS RADIOCUBITAL"
  },
  {
    "codigo":295457003,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE LAXANTE CON ANTRAQUINONA"
  },
  {
    "codigo":721441007,
    "descripcion":"LESIÓN COMPLETA DE MÉDULA ESPINAL AL NIVEL DEL DECIMOSEGUNDO SEGMENTO DORSAL"
  },
  {
    "codigo":424694002,
    "descripcion":"CLASE II DE MALLAMPATI"
  },
  {
    "codigo":129782003,
    "descripcion":"POSICIÓN DE LAS ONCE EN PUNTO EN LA MAMOGRAFÍA"
  },
  {
    "codigo":162550003,
    "descripcion":"REALIZA TRES COMIDAS POR DÍA REGULARMENTE"
  },
  {
    "codigo":293622007,
    "descripcion":"ALERGIA A KETOROLACO"
  },
  {
    "codigo":291787000,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR CARBIMAZOL"
  },
  {
    "codigo":64246009,
    "descripcion":"TRASTORNO DEL QUIASMA ÓPTICO ASOCIADO CON NEOPLASIA NO PITUITARIA"
  },
  {
    "codigo":160715000,
    "descripcion":"VIVIENDA INFECTADA"
  },
  {
    "codigo":95179003,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL VESTÍBULO DE LA NARIZ"
  },
  {
    "codigo":717771007,
    "descripcion":"SÍNDROME DE CRÁNEO EN HOJA DE TRÉBOL CON MÚLTIPLES ANOMALÍAS CONGÉNITAS"
  },
  {
    "codigo":1137416002,
    "descripcion":"DEBILIDAD DE MÚSCULO INTRÍNSECO DE MANO"
  },
  {
    "codigo":67751000119106,
    "descripcion":"AGRANDAMIENTO DE AURÍCULA DERECHA"
  },
  {
    "codigo":60576007,
    "descripcion":"DEGENERACIÓN COMBINADA SUBAGUDA DE LA MÉDULA ESPINAL"
  },
  {
    "codigo":1303925000,
    "descripcion":"HEMORRAGIA RECTAL CAUSADA POR APIXABÁN"
  },
  {
    "codigo":224416006,
    "descripcion":"INSTALACIONES SANITARIAS INADECUADAS EN EL TRABAJO"
  },
  {
    "codigo":25973008,
    "descripcion":"INTOXICACIÓN POR HORDEUM VULGARE"
  },
  {
    "codigo":124277009,
    "descripcion":"DEFICIENCIA DE OROTATO FOSFORRIBOSILTRANSFERASA"
  },
  {
    "codigo":253514004,
    "descripcion":"DEXTROPOSICIÓN DE AORTA EN LA TETRALOGÍA DE FALLOT"
  },
  {
    "codigo":56906005,
    "descripcion":"HEMATOMA DE RIÑÓN SIN RUPTURA DE LA CÁPSULA Y CON HERIDA ABIERTA HACIA CAVIDAD ABDOMINAL"
  },
  {
    "codigo":187978005,
    "descripcion":"NEOPLASIA MALIGNA DE FALANGES DE PIE"
  },
  {
    "codigo":15688001000119103,
    "descripcion":"CAPSULITIS DE ARTICULACIONES INTERTARSIANAS DE AMBOS PIES"
  },
  {
    "codigo":286282008,
    "descripcion":"INCAPAZ DE USAR CLICS AL HABLAR"
  },
  {
    "codigo":315380003,
    "descripcion":"NACIDO EN BARBADOS"
  },
  {
    "codigo":708596003,
    "descripcion":"PÉRDIDA DE MATERIAL DE RELLENO EN ORIFICIO DE ACCESO"
  },
  {
    "codigo":774132006,
    "descripcion":"ARTROPATÍA DE ARTICULACIÓN DE MANO IZQUIERDA"
  },
  {
    "codigo":96731000119100,
    "descripcion":"CARDIOPATÍA Y ENFERMEDAD RENAL CRÓNICA POR HIPERTENSIÓN, ESTADIO 3"
  },
  {
    "codigo":410014007,
    "descripcion":"HIDROCEFALIA COMUNICANTE POSTRAUMÁTICA"
  },
  {
    "codigo":442782008,
    "descripcion":"DISFUNCIÓN DEL EJE HIPOTALÁMICO-HIPOFISARIO-TESTICULAR"
  },
  {
    "codigo":80499003,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA VÍA ÓPTICA"
  },
  {
    "codigo":1260147006,
    "descripcion":"INFECCIÓN DE CUELLO DE ÚTERO"
  },
  {
    "codigo":211571008,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO, MANO, EXCLUIDOS LOS DEDOS"
  },
  {
    "codigo":471880001,
    "descripcion":"INSUFICIENCIA CARDÍACA DEBIDA A CARDIOPATÍA CONGÉNITA EN ESTADIO TERMINAL"
  },
  {
    "codigo":209736004,
    "descripcion":"SECCIÓN EXPUESTA DE LIGAMENTO TEMPOROMANDIBULAR"
  },
  {
    "codigo":734024009,
    "descripcion":"MALFORMACIÓN ANORRECTAL INTERMEDIA"
  },
  {
    "codigo":240669002,
    "descripcion":"ENFERMEDAD CONGÉNITA DE LYME"
  },
  {
    "codigo":764957003,
    "descripcion":"SÍNDROME DE KING DENBOROUGH"
  },
  {
    "codigo":404509004,
    "descripcion":"GRANDES COCOBACILOS GRAMNEGATIVOS"
  },
  {
    "codigo":699421005,
    "descripcion":"DISPLASIA DEL ESMALTE"
  },
  {
    "codigo":373576009,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM TUBERCULOSIS"
  },
  {
    "codigo":207901004,
    "descripcion":"FRACTURA NO EXPUESTA DEL AXIS, ARCO POSTERIOR"
  },
  {
    "codigo":109597009,
    "descripcion":"MANCHADO DENTAL EXTRÍNSECO ASOCIADO CON HIGIENE ORAL INADECUADA"
  },
  {
    "codigo":238834002,
    "descripcion":"POIQUILODERMIA ESCLEROSANTE HEREDITARIA"
  },
  {
    "codigo":402674003,
    "descripcion":"LINFEDEMA DE ETIOLOGÍA DESCONOCIDA"
  },
  {
    "codigo":304370001,
    "descripcion":"TRASTORNO DEL YEYUNO"
  },
  {
    "codigo":271602007,
    "descripcion":"MUJER MASCULINIZADA"
  },
  {
    "codigo":1285575008,
    "descripcion":"HIPERTENSIÓN OCULAR DEBIDA A NEOPLASIA INTRAOCULAR"
  },
  {
    "codigo":11511000224100,
    "descripcion":"TUMOR RESECABLE QUIRÚRGICAMENTE"
  },
  {
    "codigo":38556006,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN DE MUÑECA"
  },
  {
    "codigo":366236007,
    "descripcion":"HALLAZGO RELACIONADO CON EL OLOR DEL ALIENTO"
  },
  {
    "codigo":169628008,
    "descripcion":"RESERVA DE LUGAR PARA EL PARTO - DURACIÓN DE LA ESTADÍA"
  },
  {
    "codigo":300700009,
    "descripcion":"CAPAZ DE EMITIR CHEQUES"
  },
  {
    "codigo":724849003,
    "descripcion":"FRAGILIDAD UNGUEAL"
  },
  {
    "codigo":167793006,
    "descripcion":"MORFOLOGÍA DE LOS ESPERMATOZOIDES - MODERADA: 30-50% NORMALES"
  },
  {
    "codigo":298865008,
    "descripcion":"ARTICULACIÓN DE HOMBRO CALIENTE AL TACTO"
  },
  {
    "codigo":723014001,
    "descripcion":"ERUPCIÓN CUTÁNEA AGUDA EXUDATIVA"
  },
  {
    "codigo":231494001,
    "descripcion":"MANÍA"
  },
  {
    "codigo":428102003,
    "descripcion":"COMPLICACIÓN POSQUIRÚRGICA DE LA FIJACIÓN DEL ESTERNÓN CON ALAMBRES"
  },
  {
    "codigo":297030005,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE DIURÉTICO AHORRADOR DE POTASIO"
  },
  {
    "codigo":1148998009,
    "descripcion":"INTOXICACIÓN POR ALCANO"
  },
  {
    "codigo":295195001,
    "descripcion":"SOBREDOSIS INTENCIONAL DE FENTANILO"
  },
  {
    "codigo":229659008,
    "descripcion":"DISFASIA MIXTA TRANSCORTICAL"
  },
  {
    "codigo":721179009,
    "descripcion":"HEMORRAGIA INTRAMURAL DE ESÓFAGO"
  },
  {
    "codigo":31216003,
    "descripcion":"RETRASO MENTAL PROFUNDO"
  },
  {
    "codigo":293360007,
    "descripcion":"REACCIÓN ADVERSA A LA SAL FERROSA"
  },
  {
    "codigo":94917004,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL TERCIO INFERIOR DEL ESÓFAGO"
  },
  {
    "codigo":289690002,
    "descripcion":"ÚTERO GRÁVIDO CENTRAL"
  },
  {
    "codigo":781210004,
    "descripcion":"FLEXIONADA, ROTADA E INCLINADA HACIA UN LADO - POSICIÓN VERTEBRAL"
  },
  {
    "codigo":93082008,
    "descripcion":"FENESTRACIÓN CONGÉNITA DE HUESO FRONTAL"
  },
  {
    "codigo":715674008,
    "descripcion":"DISPLASIA EPIFISARIA MÚLTIPLE TIPO 5"
  },
  {
    "codigo":255087006,
    "descripcion":"PÓLIPO MALIGNO DE VÍA BILIAR"
  },
  {
    "codigo":713839007,
    "descripcion":"NEURALGIA INTERCOSTAL COMO EFECTO TARDÍO DE TRAUMATISMO"
  },
  {
    "codigo":1172591008,
    "descripcion":"SÍNDROME DE CIFOSIS, ATROFIA LATERAL DE LA LENGUA Y MIOPATÍA MIOFIBRILAR"
  },
  {
    "codigo":1082281000119105,
    "descripcion":"CARCINOMA DE CÉLULAS DE TRANSICIÓN DE PELVIS RENAL IZQUIERDA"
  },
  {
    "codigo":56644003,
    "descripcion":"CELULITIS DEL OMBLIGO"
  },
  {
    "codigo":89412004,
    "descripcion":"ESTADO POSTINFECCIOSO"
  },
  {
    "codigo":253252004,
    "descripcion":"OREJA PUNTIAGUDA"
  },
  {
    "codigo":23876003,
    "descripcion":"LUXACIÓN CONGÉNITA DE HOMBRO"
  },
  {
    "codigo":187716008,
    "descripcion":"NEOPLASIA MALIGNA DE ANILLO LINFÁTICO FARINGEO"
  },
  {
    "codigo":710169001,
    "descripcion":"ÚLCERA CRÓNICA DE NALGA"
  },
  {
    "codigo":249582007,
    "descripcion":"RIÑÓN AUSENTE"
  },
  {
    "codigo":313283000,
    "descripcion":"RUPTURA DE PRÓTESIS ARTICULAR"
  },
  {
    "codigo":10849941000119100,
    "descripcion":"HERIDA ABIERTA DE MAMA DERECHA"
  },
  {
    "codigo":247747000,
    "descripcion":"ALUCINACIONES OLFATIVAS DISOCIATIVAS"
  },
  {
    "codigo":870339004,
    "descripcion":"GRANULOMA EPIDURAL ESPINAL CAUSADO POR PARÁSITO"
  },
  {
    "codigo":1263555006,
    "descripcion":"ENFERMEDAD DE ALZHEIMER SIN AMNESIA LOGOPÉNICA"
  },
  {
    "codigo":442520000,
    "descripcion":"INFLAMACIÓN DE TENDÓN DEL MANGUITO ROTADOR"
  },
  {
    "codigo":292061000119100,
    "descripcion":"TRASTORNO DE NERVIO CIÁTICO POPLÍTEO EXTERNO DERECHO"
  },
  {
    "codigo":278680007,
    "descripcion":"LÍNEA MEDIA DENTAL CORRECTA"
  },
  {
    "codigo":1360024008,
    "descripcion":"OCLUSIÓN DE VENA DE CUERPO CAVERNOSO DE PENE"
  },
  {
    "codigo":702829000,
    "descripcion":"SÍNDROME DE ROTURA CROMOSÓMICA DE VARSOVIA."
  },
  {
    "codigo":704664006,
    "descripcion":"CORYNEBACTERIUM DIPHTHERIAE, NO AISLADO"
  },
  {
    "codigo":735597009,
    "descripcion":"PSEUDOTUMOR FIBRO-ÓSEO DE PIEL DE DÍGITO"
  },
  {
    "codigo":897602002,
    "descripcion":"LESIÓN TRAUMÁTICA DE HOMBRO Y\/O BRAZO"
  },
  {
    "codigo":307778003,
    "descripcion":"ATENDIDO EN ESTABLECIMIENTO DE ATENCIÓN PRIMARIA"
  },
  {
    "codigo":45634004,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN CARPOMETACARPIANA"
  },
  {
    "codigo":15938781000119103,
    "descripcion":"NEVO MELANOCÍTICO DE AMBAS EXTREMIDADES SUPERIORES"
  },
  {
    "codigo":209474008,
    "descripcion":"ESGUINCE DE PULGAR, ARTICULACIÓN INTERFALÁNGICA, LIGAMENTO LATERAL RADIAL"
  },
  {
    "codigo":109335003,
    "descripcion":"OSTEORRADIONECROSIS DE HUESO FRONTAL"
  },
  {
    "codigo":240407009,
    "descripcion":"REACCIÓN DE LA LEPRA TIPO 1"
  },
  {
    "codigo":238572001,
    "descripcion":"DERMATITIS POR CONTACTO CON LANOLINA"
  },
  {
    "codigo":402412003,
    "descripcion":"DERMOGRAFISMO COLINÉRGICO"
  },
  {
    "codigo":369644002,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA DE PRÓSTATA Y BASE DE VESÍCULA SEMINAL, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":302273000,
    "descripcion":"DIFICULTAD PARA REALIZAR TRASLADOS CON SILLA DE RUEDAS"
  },
  {
    "codigo":74732009,
    "descripcion":"TRASTORNO MENTAL"
  },
  {
    "codigo":105665005,
    "descripcion":"ENFERMEDAD CAUSADA POR STRIGEIDAE"
  },
  {
    "codigo":236737006,
    "descripcion":"SANGRADO POR DISPOSITIVO ANTICONCEPTIVO INTRAUTERINO"
  },
  {
    "codigo":300438007,
    "descripcion":"TRACTO GASTROINTESTINAL NORMAL"
  },
  {
    "codigo":200299000,
    "descripcion":"TROMBOEMBOLISMO PULMONAR OBSTÉTRICO"
  },
  {
    "codigo":298603001,
    "descripcion":"AMPLITUD DE FLEXIÓN ACTIVA DE LA COLUMNA LUMBAR AUMENTADA"
  },
  {
    "codigo":724587002,
    "descripcion":"NEOPLASIA OSTEÓGENA BENIGNA DE PARTE ÓSEA DE CLAVÍCULA"
  },
  {
    "codigo":396907008,
    "descripcion":"HALLAZGO DEL ESTADIO DE NEOPLASIA EPITELIAL DEL TIMO"
  },
  {
    "codigo":1856001,
    "descripcion":"NARIZ ACCESORIA"
  },
  {
    "codigo":198464003,
    "descripcion":"INFERTILIDAD PRIMARIA DE ORIGEN VAGINAL"
  },
  {
    "codigo":34624004,
    "descripcion":"DÉFICIT DE PULSO"
  },
  {
    "codigo":460608003,
    "descripcion":"ORIGEN ANÓMALO DE CONDUCTO ARTERIOSO EN ARTERIA BRAQUIOCEFÁLICA IZQUIERDA"
  },
  {
    "codigo":16705041000119100,
    "descripcion":"QUISTE COMPLEJO DE AMBOS OVARIOS"
  },
  {
    "codigo":296768007,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE TETRACICLINA"
  },
  {
    "codigo":294933004,
    "descripcion":"ALERGIA A HIDROXOCOBALAMINA"
  },
  {
    "codigo":131093004,
    "descripcion":"NIVEL DE TIROXINA POR DEBAJO DE RANGO DE REFERENCIA"
  },
  {
    "codigo":1145066001,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE TRICLOFÓS"
  },
  {
    "codigo":293098004,
    "descripcion":"REACCIÓN ADVERSA A INMUNOGLOBULINA POR VÍA INTRAMUSCULAR"
  },
  {
    "codigo":15722001000119103,
    "descripcion":"INFECCIÓN DE BOLSA SEROSA DE OLÉCRANON BILATERAL DE CODOS"
  },
  {
    "codigo":63722008,
    "descripcion":"VÓMITO CRÓNICO"
  },
  {
    "codigo":291263001,
    "descripcion":"INTOXICACIÓN INTENCIONAL CAUSADA POR CRACK DE COCAÍNA"
  },
  {
    "codigo":782783009,
    "descripcion":"SÍNDROME OCULOAURICULOFRONTONASAL"
  },
  {
    "codigo":289428007,
    "descripcion":"PRESENTACIÓN QUE NO DESCIENDE"
  },
  {
    "codigo":715412008,
    "descripcion":"NEOPLASIA MALIGNA DE PRÓSTATA FAMILIAR"
  },
  {
    "codigo":125588009,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA LARINGE"
  },
  {
    "codigo":189289001,
    "descripcion":"CARCINOMA IN SITU DE LA PIEL DE LA MANDÍBULA"
  },
  {
    "codigo":1303401002,
    "descripcion":"FRACTURA DE FALANGE DE DEDO PULGAR IZQUIERDO"
  },
  {
    "codigo":387732009,
    "descripcion":"DISTROFIA MUSCULAR DE BECKER"
  },
  {
    "codigo":58217006,
    "descripcion":"INFECCIÓN CAUSADA POR BORDETELLA BRONCHISEPTICA"
  },
  {
    "codigo":254825007,
    "descripcion":"NEOPLASIA BENIGNA DE TEJIDO MESOTELIAL"
  },
  {
    "codigo":713577007,
    "descripcion":"TUMOR DE CÉLULAS GERMINALES DE TESTÍCULO"
  },
  {
    "codigo":123753008,
    "descripcion":"NEFRITIS SÉRICA NEFROTÓXICA"
  },
  {
    "codigo":285758006,
    "descripcion":"AGNOSIA VISUOESPACIAL"
  },
  {
    "codigo":416830008,
    "descripcion":"ESPASTICIDAD MUSCULAR DE ORIGEN VERTEBRAL"
  },
  {
    "codigo":251155001,
    "descripcion":"TAQUICARDIA ECTÓPICA DE LA UNIÓN AURICULOVENTRICULAR"
  },
  {
    "codigo":1332499002,
    "descripcion":"HEMORRAGIA INTRAPARENQUIMATOSA CEREBRAL TRAUMÁTICA"
  },
  {
    "codigo":40211000087100,
    "descripcion":"HERIDA ABIERTA DE MUÑECA DERECHA POR MORDEDURA"
  },
  {
    "codigo":53011000087102,
    "descripcion":"AUMENTO DE NIVEL DE DESORIENTACIÓN EN RELACIÓN A LAS PERSONAS"
  },
  {
    "codigo":42771000087103,
    "descripcion":"DISCO INTERVERTEBRAL TORÁCICO PROLAPSADO, T6-T7"
  },
  {
    "codigo":21779006,
    "descripcion":"TESTÍCULO RETRÁCTIL"
  },
  {
    "codigo":47891000087106,
    "descripcion":"FRACTURA DE DUODÉCIMA COSTILLA IZQUIERDA"
  },
  {
    "codigo":282088003,
    "descripcion":"RUPTURA DE TESTÍCULO"
  },
  {
    "codigo":183784004,
    "descripcion":"INSCRIPTO EN LISTA DE ADMISIÓN OFTALMOLÓGICA"
  },
  {
    "codigo":413160005,
    "descripcion":"LEE LITUANO"
  },
  {
    "codigo":445928005,
    "descripcion":"SÍNDROME DE EISENMENGER"
  },
  {
    "codigo":18109005,
    "descripcion":"CÁLCULO EN DIVERTÍCULO DE VEJIGA URINARIA"
  },
  {
    "codigo":1197757006,
    "descripcion":"KERNÍCTERUS AGUDO"
  },
  {
    "codigo":313021007,
    "descripcion":"METAPLASIA ESCAMOSA DE PULMÓN"
  },
  {
    "codigo":704402002,
    "descripcion":"CONOCIMIENTO DEFICIENTE SOBRE FISIOTERAPIA"
  },
  {
    "codigo":407655000,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: COREANO"
  },
  {
    "codigo":49042009,
    "descripcion":"INTOXICACIÓN POR MYOPORUM"
  },
  {
    "codigo":243815002,
    "descripcion":"ESTADO PREVENTIVO"
  },
  {
    "codigo":473191002,
    "descripcion":"SILLA DE RUEDAS QUE REQUIERE REPARACIÓN"
  },
  {
    "codigo":1259623005,
    "descripcion":"OSTEOSARCOMA PRIMARIO DE HUESO DE CABEZA"
  },
  {
    "codigo":211047006,
    "descripcion":"ABRASIÓN DE PERINEO"
  },
  {
    "codigo":276583007,
    "descripcion":"DISFUNCIÓN RENAL DEL RECIÉN NACIDO"
  },
  {
    "codigo":702567009,
    "descripcion":"TRASTORNO DE TENDÓN DE MÚSCULO TIBIAL POSTERIOR"
  },
  {
    "codigo":209212002,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA NO EXPUESTA DE LA PELVIS"
  },
  {
    "codigo":733500003,
    "descripcion":"DESCONEXIÓN DE SISTEMA RESPIRATORIO"
  },
  {
    "codigo":373052006,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM PHLEI"
  },
  {
    "codigo":698897001,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: FIYIANO"
  },
  {
    "codigo":241980009,
    "descripcion":"BAROTITIS EXTERNA"
  },
  {
    "codigo":305681003,
    "descripcion":"ATENDIDO POR UN MÉDICO ESPECIALISTA EN ENFERMEDADES INFECCIOSAS"
  },
  {
    "codigo":906101000000109,
    "descripcion":"CONCURRE A GRUPO DE APOYO PARA PADRES"
  },
  {
    "codigo":403985007,
    "descripcion":"ANGIOSARCOMA INTRAVASCULAR"
  },
  {
    "codigo":402150002,
    "descripcion":"REACCIÓN A PICADURA DE INSECTO"
  },
  {
    "codigo":762598004,
    "descripcion":"DOLOR MUSCULOESQUELÉTICO CRÓNICO DEBIDO A ENFERMEDAD DEL SISTEMA NERVIOSO"
  },
  {
    "codigo":860902005,
    "descripcion":"ALERGIA A AMINOQUINOLINA"
  },
  {
    "codigo":302011000,
    "descripcion":"FORÚNCULO DE MIEMBRO INFERIOR"
  },
  {
    "codigo":269243001,
    "descripcion":"QUEMADURA EPIDÉRMICA DE MUÑECA Y MANO"
  },
  {
    "codigo":433083002,
    "descripcion":"CONVULSIÓN FEBRIL COMPLEJA"
  },
  {
    "codigo":170939002,
    "descripcion":"ATENCIÓN COMPLETA: ENFERMERA PRACTICANTE"
  },
  {
    "codigo":236475007,
    "descripcion":"AMINOACIDURIA DIABÉTICA"
  },
  {
    "codigo":365712002,
    "descripcion":"HALLAZGO RELACIONADO CON ASPECTO DE LÍQUIDO SINOVIAL"
  },
  {
    "codigo":38032004,
    "descripcion":"DEFICIENCIA DE LACTASA AISLADA DE INICIO TARDÍO"
  },
  {
    "codigo":1217680004,
    "descripcion":"NEOVASCULARIZACIÓN DE IRIS DEBIDA A OCLUSIÓN DE VENA CENTRAL DE LA RETINA"
  },
  {
    "codigo":234640004,
    "descripcion":"INMUNODEFICIENCIA ASOCIADA CON SÍNDROME DE 18P"
  },
  {
    "codigo":1119376007,
    "descripcion":"AUSENCIA DE SENSACIÓN DEL LADO IZQUIERDO DE LA CARA"
  },
  {
    "codigo":300176008,
    "descripcion":"YUNQUE ANORMAL"
  },
  {
    "codigo":232805002,
    "descripcion":"NEOPLASIA BENIGNA DE LA PARED NASOFARÍNGEA"
  },
  {
    "codigo":298341003,
    "descripcion":"HALLAZGO RELACIONADO CON LA POSTURA CORPORAL"
  },
  {
    "codigo":67130000,
    "descripcion":"FRACTURA EXPUESTA DE HUESO TRAPECIO DE MUÑECA"
  },
  {
    "codigo":230970001,
    "descripcion":"PROTEINURIA NO NEFRÓTICA AISLADA"
  },
  {
    "codigo":1345082002,
    "descripcion":"EPISODIO DE USO NOCIVO DE CORTICOESTEROIDE"
  },
  {
    "codigo":11792351000119109,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN DE MEÑIQUE IZQUIERDO"
  },
  {
    "codigo":427578006,
    "descripcion":"HERPES SIMPLE DE GENITALES FEMENINOS"
  },
  {
    "codigo":296506006,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE PAPAVERINA"
  },
  {
    "codigo":196367000,
    "descripcion":"PERIODONTITIS CRÓNICA COMPLEJA"
  },
  {
    "codigo":65295003,
    "descripcion":"ENDOMETRITIS GONOCÓCICA AGUDA"
  },
  {
    "codigo":1179407003,
    "descripcion":"INFLAMACIÓN DE COLON CAUSADA POR SALMONELLA ENTERICA ENTERICA SEROVARIEDAD TYPHI"
  },
  {
    "codigo":294671005,
    "descripcion":"ALERGIA A GLUCAGÓN"
  },
  {
    "codigo":818959006,
    "descripcion":"SÍNDROME TRICORRINOFALÁNGICO TIPOS 1 Y 3"
  },
  {
    "codigo":425743007,
    "descripcion":"DISFUNCIÓN PSICÓGENA DE CUERDAS VOCALES"
  },
  {
    "codigo":63460000,
    "descripcion":"CALIDAD VOCAL ANORMAL"
  },
  {
    "codigo":32527003,
    "descripcion":"ENTEROCOLITIS ESTAFILOCÓCICA"
  },
  {
    "codigo":225465005,
    "descripcion":"REACIO"
  },
  {
    "codigo":94393006,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LOS GANGLIOS LINFÁTICOS DE LA CARA"
  },
  {
    "codigo":127161007,
    "descripcion":"LINFADENOPATÍA ILÍACA COMÚN INTERMEDIA"
  },
  {
    "codigo":61625009,
    "descripcion":"ADHERENCIAS POR CUERPO EXTRAÑO DEJADO ACCIDENTALMENTE EN HERIDA OPERATORIA Y\/O EN CAVIDAD CORPORAL DURANTE PROCEDIMIENTO"
  },
  {
    "codigo":59790002,
    "descripcion":"HIPERNASALIDAD DE LAS VOCALES Y DE LAS CONSONANTES FUERTES"
  },
  {
    "codigo":92558004,
    "descripcion":"CARCINOMA IN SITU DE LA MUCOSA YUGAL"
  },
  {
    "codigo":158094009,
    "descripcion":"LESIÓN TRAUMÁTICA NO ACCIDENTAL INFANTIL"
  },
  {
    "codigo":226184006,
    "descripcion":"DIETA CON BAJO CONTENIDO DE ALIMENTOS ANTIOXIDANTES"
  },
  {
    "codigo":11821331000119104,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN CARPOMETACARPIANA DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":1303139004,
    "descripcion":"ARTRITIS DE AMBAS ARTICULACIONES RADIOCARPIANAS"
  },
  {
    "codigo":713315007,
    "descripcion":"INFECCIÓN DISEMINADA CAUSADA POR TALAROMYCES MARNEFFEI"
  },
  {
    "codigo":711480000,
    "descripcion":"SÍNDROME DE PI3K-DELTA ACTIVADO"
  },
  {
    "codigo":254563009,
    "descripcion":"CARCINOMA DE CURVATURA MENOR DE ESTÓMAGO"
  },
  {
    "codigo":416568002,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE MÚLTIPLES DEDOS DE LA MANO"
  },
  {
    "codigo":187192000,
    "descripcion":"TOXOPLASMOSIS"
  },
  {
    "codigo":56120004,
    "descripcion":"SÍNDROME DE A. SCHMIDT"
  },
  {
    "codigo":1089811000119106,
    "descripcion":"MENINGOENCEFALITIS CAUSADA POR ACANTHAMOEBA"
  },
  {
    "codigo":472171000124104,
    "descripcion":"ASISTENCIA REQUERIDA PARA CEPILLARSE LOS DIENTES"
  },
  {
    "codigo":283661001,
    "descripcion":"HERIDA POR PINCHAZO DE CLAVO EN LA MANO"
  },
  {
    "codigo":1268536009,
    "descripcion":"CARCINOMA ADENOIDE BASAL PRIMARIO DE CUELLO UTERINO"
  },
  {
    "codigo":871650000,
    "descripcion":"TRONCO ARTERIAL COMÚN CON PREDOMINIO PULMONAR Y COARTACIÓN AÓRTICA"
  },
  {
    "codigo":609506003,
    "descripcion":"INTERRUPCIÓN INDUCIDA DEL EMBARAZO COMPLICADA POR PARO CARDÍACO"
  },
  {
    "codigo":707810004,
    "descripcion":"SE CUIDA POR SÍ MISMO"
  },
  {
    "codigo":249058005,
    "descripcion":"PARTES FETALES PALPABLES A TRAVÉS DEL ABDOMEN"
  },
  {
    "codigo":19682006,
    "descripcion":"HEPATITIS POR LUPUS"
  },
  {
    "codigo":52450003,
    "descripcion":"FRACTURA NO EXPUESTA DE SECCIÓN MEDIOCERVICAL DE FÉMUR"
  },
  {
    "codigo":773346008,
    "descripcion":"SÍNDROME DE MICRODELECIÓN 20P13"
  },
  {
    "codigo":771511005,
    "descripcion":"TROMBOCITEMIA CON DEFECTO DISTAL DE EXTREMIDAD"
  },
  {
    "codigo":247223008,
    "descripcion":"PAPILA Y EXCAVACIÓN DE LA PAPILA ÓPTICA GRANDES"
  },
  {
    "codigo":81548002,
    "descripcion":"ÁNIMO ELEVADO"
  },
  {
    "codigo":48780006,
    "descripcion":"NEURITIS CRANEAL"
  },
  {
    "codigo":309089006,
    "descripcion":"MASA PROSTÁTICA"
  },
  {
    "codigo":276321008,
    "descripcion":"PLACA MUCOSA"
  },
  {
    "codigo":733238000,
    "descripcion":"LESIONES TRAUMÁTICAS MÚLTIPLES DE ANTEBRAZO"
  },
  {
    "codigo":208950007,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE LA ARTICULACIÓN DE LA RODILLA, ROTATORIA"
  },
  {
    "codigo":43275000,
    "descripcion":"OTITIS"
  },
  {
    "codigo":405558008,
    "descripcion":"INVAGINACIÓN DE ÍLEON"
  },
  {
    "codigo":45110008,
    "descripcion":"INTOXICACIÓN POR CLOROQUINA"
  },
  {
    "codigo":239883006,
    "descripcion":"ARTROSIS ENDÉMICA"
  },
  {
    "codigo":403723007,
    "descripcion":"POIQUILODERMIA CAUSADA POR RADIACIÓN IONIZANTE"
  },
  {
    "codigo":895243009,
    "descripcion":"FORMA ANCHA ANORMAL CONGÉNITA DE FALANGE DISTAL DE DEDO MEÑIQUE"
  },
  {
    "codigo":238048001,
    "descripcion":"DEFICIENCIA DE ALFA-N-ACETIL GALACTOSAMINIDASA"
  },
  {
    "codigo":762336002,
    "descripcion":"TRASTORNO DEL ESTADO DE ÁNIMO CON SÍNTOMAS DEPRESIVOS CAUSADO POR ALUCINÓGENO"
  },
  {
    "codigo":205280007,
    "descripcion":"SINFALANGIA DE ARTICULACIÓN INTERFALÁNGICA PROXIMAL"
  },
  {
    "codigo":301749006,
    "descripcion":"CAPAZ DE REALIZAR ACTIVIDADES DE ADMINISTRACIÓN Y SUPERVISIÓN"
  },
  {
    "codigo":5002000,
    "descripcion":"DEPENDENCIA DE INHALANTE VOLÁTIL"
  },
  {
    "codigo":11823841000119102,
    "descripcion":"HERIDA DE HOMBRO IZQUIERDO DEBIDA A PICADURA DE INSECTO NO VENENOSO"
  },
  {
    "codigo":725898002,
    "descripcion":"DELIRIO CONCOMITANTE CON DEMENCIA"
  },
  {
    "codigo":299914007,
    "descripcion":"SENSACIÓN AL TACTO SUAVE: NORMAL"
  },
  {
    "codigo":398218008,
    "descripcion":"MARCHA PROPULSIVA"
  },
  {
    "codigo":37770007,
    "descripcion":"SÍNDROME DE MELKERSSON"
  },
  {
    "codigo":365450009,
    "descripcion":"HALLAZGO RELACIONADO CON EL LUGAR DE ORIGEN"
  },
  {
    "codigo":187784000,
    "descripcion":"NEOPLASIA MALIGNA DE CONDUCTO HEPÁTICO"
  },
  {
    "codigo":298079004,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE LA MUÑECA"
  },
  {
    "codigo":724063005,
    "descripcion":"VASCULITIS DEBIDA A INFECCIÓN VIRAL Y POSTERIOR A ELLA"
  },
  {
    "codigo":230708002,
    "descripcion":"INFARTO HEMORRÁGICO DE LA CIRCULACIÓN CEREBRAL POSTERIOR"
  },
  {
    "codigo":197940006,
    "descripcion":"HEMATURIA MICROSCÓPICA"
  },
  {
    "codigo":1332008,
    "descripcion":"DESVIACIÓN VISUAL CONJUGADA"
  },
  {
    "codigo":65033000,
    "descripcion":"ANOMALÍA CONGÉNITA DEL PELO"
  },
  {
    "codigo":34100008,
    "descripcion":"NACIMIENTO PREMATURO DE GEMELOS MONOCIGÓTICOS, AMBOS VIVOS"
  },
  {
    "codigo":63198006,
    "descripcion":"CONDROMALACIA"
  },
  {
    "codigo":292574007,
    "descripcion":"REACCIÓN ADVERSA A LA CETIRIZINA"
  },
  {
    "codigo":716723000,
    "descripcion":"SÍNDROME DE GUILLAIN-BARRÉ, FORMA POLIRRADICULONEUROPÁTICA DESMIELINIZANTE INFLAMATORIA AGUDA"
  },
  {
    "codigo":1144542007,
    "descripcion":"HIPOPLASIA CONGÉNITA DE ARÉOLA"
  },
  {
    "codigo":290739002,
    "descripcion":"INTOXICACIÓN POR FLUDARABINA"
  },
  {
    "codigo":94131003,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL NERVIO VAGO"
  },
  {
    "codigo":9901000119100,
    "descripcion":"OCLUSIÓN DE ARTERIA CEREBRAL CON ACCIDENTE CEREBROVASCULAR"
  },
  {
    "codigo":1072301000119101,
    "descripcion":"NECROSIS AVASCULAR DE CLAVÍCULA"
  },
  {
    "codigo":342701000119100,
    "descripcion":"QUISTE DE PÁRPADO DERECHO"
  },
  {
    "codigo":868431021000119100,
    "descripcion":"DISTROFIA DE CÓRNEA HEREDITARIA DE AMBOS OJOS"
  },
  {
    "codigo":117421000119104,
    "descripcion":"ACÚFENO PULSÁTIL SUBJECTIVO"
  },
  {
    "codigo":15935661000119105,
    "descripcion":"DEFORMIDAD EN FLEXIÓN DE ARTICULACIÓN DE PIE DERECHO"
  },
  {
    "codigo":332461000119106,
    "descripcion":"DEGENERACIÓN CISTOIDE PERIFÉRICA DE RETINA DERECHA"
  },
  {
    "codigo":16698541000119106,
    "descripcion":"QUISTE DE OVARIO IZQUIERDO DURANTE EMBARAZO"
  },
  {
    "codigo":79021000119104,
    "descripcion":"DEPENDENCIA DE ASPIRADOR"
  },
  {
    "codigo":32941000119104,
    "descripcion":"INGESTIÓN DE SUSTANCIA TÓXICA"
  },
  {
    "codigo":527072941000119107,
    "descripcion":"ESTENOSIS DE ESTOMA DE GASTROSTOMÍA"
  },
  {
    "codigo":12057261000119109,
    "descripcion":"POSICIÓN ANÓMALA DE DISPOSITIVO DE FIJACIÓN INTERNA"
  },
  {
    "codigo":143021000119109,
    "descripcion":"ESTADO DE NO REANIMACIÓN CON DOCUMENTACIÓN DE APOYO"
  },
  {
    "codigo":288904007,
    "descripcion":"NO RETIENE EL ALIMENTO EN LA BOCA"
  },
  {
    "codigo":16703661000119105,
    "descripcion":"DÉFICIT DE MEMORIA DEBIDO A ACCIDENTE CEREBROVASCULAR Y POSTERIOR A ÉL"
  },
  {
    "codigo":834298541000119106,
    "descripcion":"LACERACIÓN DE VASO SANGUÍNEO DE ANULAR"
  },
  {
    "codigo":92296004,
    "descripcion":"NEOPLASIA BENIGNA DE LA GLÁNDULA HIPÓFISIS"
  },
  {
    "codigo":287069001,
    "descripcion":"FRACTURA PATOLÓGICA - PIERNA"
  },
  {
    "codigo":713053006,
    "descripcion":"TESTIGO DE USO INDEBIDO DE SUSTANCIA POR PARTE DE UN ADULTO"
  },
  {
    "codigo":1237341006,
    "descripcion":"NEOPLASIA TUBULOPAPILAR INTRADUCTAL MALIGNA DE PÁNCREAS"
  },
  {
    "codigo":449074003,
    "descripcion":"LINFOMA DE INTESTINO DELGADO"
  },
  {
    "codigo":285234008,
    "descripcion":"SECUELAS DE LAS LESIONES ENCEFÁLICAS"
  },
  {
    "codigo":185095001,
    "descripcion":"RENOTIFICACIÓN DE DROGADICTO: PENDIENTE"
  },
  {
    "codigo":840455002,
    "descripcion":"VASCULITIS CUTÁNEA DEBIDA A DERMATOMIOSITIS DE TIPO INFANTIL"
  },
  {
    "codigo":283399001,
    "descripcion":"CORTE EN EL CUERO CABELLUDO"
  },
  {
    "codigo":21255005,
    "descripcion":"INFESTACIÓN CAUSADA POR LUCILIA"
  },
  {
    "codigo":445404003,
    "descripcion":"NEFROPATÍA FAMILIAR POR INMUNOGLOBULINA A"
  },
  {
    "codigo":609244006,
    "descripcion":"VIVE EN CASA ADOSADA"
  },
  {
    "codigo":248796007,
    "descripcion":"ORGASMO DÉBIL"
  },
  {
    "codigo":281564008,
    "descripcion":"NEUROBLASTOMA PÉLVICO"
  },
  {
    "codigo":83121003,
    "descripcion":"NACIMIENTO DE TÉRMINO DE GEMELOS DICIGÓTICOS, AMBOS MUERTOS"
  },
  {
    "codigo":410801005,
    "descripcion":"ARTRITIS IDIOPÁTICA JUVENIL, ARTRITIS RELACIONADA CON ENTESITIS"
  },
  {
    "codigo":246961008,
    "descripcion":"PÉRDIDA DEL ESTROMA DE LA CÓRNEA"
  },
  {
    "codigo":17585008,
    "descripcion":"ATROFIA DE TESTÍCULO"
  },
  {
    "codigo":10761391000119102,
    "descripcion":"CONSUMO DE TABACO EN LA MADRE QUE COMPLICA EL NACIMIENTO"
  },
  {
    "codigo":212358008,
    "descripcion":"CONMOCIÓN Y EDEMA DE LA MÉDULA ESPINAL DORSAL"
  },
  {
    "codigo":1259099000,
    "descripcion":"NEUROPATÍA SENSITIVA AUTOINMUNITARIA"
  },
  {
    "codigo":48518008,
    "descripcion":"HEMORRAGIA SUBARACNOIDEA TRAUMÁTICA CON HERIDA INTRACRANEAL ABIERTA Y CONCUSIÓN"
  },
  {
    "codigo":277894008,
    "descripcion":"SÍNDROME DE GLUCOPROTEÍNA DEFICIENTE EN CARBOHIDRATOS, TIPO II"
  },
  {
    "codigo":79451004,
    "descripcion":"RESPIRACIÓN BRONQUIAL"
  },
  {
    "codigo":46683007,
    "descripcion":"DEFICIENCIA COMPLEJA DE PIRUVATO DESHIDROGENASA"
  },
  {
    "codigo":276059007,
    "descripcion":"ABANDONO DEL TRABAJO"
  },
  {
    "codigo":13915009,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN LA REGIÓN DE LA NALGA, SIN INFECCIÓN"
  },
  {
    "codigo":765744006,
    "descripcion":"ENFERMEDAD DE CHARCOT-MARIE-TOOTH AUTOSÓMICA DOMINANTE TIPO A"
  },
  {
    "codigo":208688006,
    "descripcion":"FRACTURA NO EXPUESTA DE DIÁFISIS DE METATARSIANO"
  },
  {
    "codigo":10679471000119107,
    "descripcion":"NÓDULO DE PIEL DE ESPALDA"
  },
  {
    "codigo":1222661007,
    "descripcion":"LEUCOENCEFALOPATÍA CALCIFICANTE Y DISPLASIA ESQUELÉTICA DE INICIO TEMPRANO"
  },
  {
    "codigo":1255429007,
    "descripcion":"QUISTE DE ASTA ANTERIOR DE MENISCO EXTERNO DE RODILLA"
  },
  {
    "codigo":403461009,
    "descripcion":"PÓLIPO DE CONDUCTO VITELINO"
  },
  {
    "codigo":237786003,
    "descripcion":"TRASTORNO ENDOCRINO-GINECOLÓGICO"
  },
  {
    "codigo":8410006,
    "descripcion":"DICROCOELIASIS"
  },
  {
    "codigo":1351898006,
    "descripcion":"HEMANGIOBLASTOMA DE CEREBRO"
  },
  {
    "codigo":6575000,
    "descripcion":"EXHUMACIÓN"
  },
  {
    "codigo":15732041000119104,
    "descripcion":"QUISTE DERMOIDE BILATERAL DE CONJUNTIVAS"
  },
  {
    "codigo":301487004,
    "descripcion":"SORTEA ESQUINAS"
  },
  {
    "codigo":432559006,
    "descripcion":"MARCHA ANORMAL POR DEBILIDAD MUSCULAR"
  },
  {
    "codigo":4740000,
    "descripcion":"HERPES ZÓSTER"
  },
  {
    "codigo":365188000,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA ARRODILLARSE EN LA BAÑERA"
  },
  {
    "codigo":168580002,
    "descripcion":"RADIOGRAFÍA SIMPLE DE COLUMNA VERTEBRAL LUMBAR ANORMAL"
  },
  {
    "codigo":1348228005,
    "descripcion":"PATRÓN DE USO EPISÓDICO NOCIVO SIN DEPENDENCIA DE ANTIDEPRESIVO"
  },
  {
    "codigo":299652006,
    "descripcion":"AMPUTADO POR DEBAJO DE LA RODILLA"
  },
  {
    "codigo":11855331000119101,
    "descripcion":"AMPOLLA TRAUMÁTICA DE PIEL DE MENTÓN"
  },
  {
    "codigo":232281004,
    "descripcion":"OTORREA CEREBROESPINAL POSOPERATORIA"
  },
  {
    "codigo":428889007,
    "descripcion":"ATENDIDO EN CONSULTORIO ESPECIALIZADO EN TRASTORNOS DEL SUEÑO"
  },
  {
    "codigo":1070000,
    "descripcion":"MIOQUIMIA FACIAL"
  },
  {
    "codigo":68441009,
    "descripcion":"INTOXICACIÓN POR NIQUETAMIDA"
  },
  {
    "codigo":363353009,
    "descripcion":"NEOPLASIA MALIGNA DE VESÍCULA BILIAR"
  },
  {
    "codigo":166745009,
    "descripcion":"NIVEL DE MAGNESIO EN SANGRE FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":33838003,
    "descripcion":"DIVERTICULITIS DEL DUODENO"
  },
  {
    "codigo":359683002,
    "descripcion":"ATROFIA ÓPTICA TOTAL"
  },
  {
    "codigo":326915002,
    "descripcion":"PROTEINURIA DE LA ADOLESCENCIA"
  },
  {
    "codigo":32003007,
    "descripcion":"ANOMALÍA CONGÉNITA DE LOS HUESOS DE LA CARA"
  },
  {
    "codigo":425219008,
    "descripcion":"ATAXIA ESPINAL PROGRESIVA"
  },
  {
    "codigo":292312002,
    "descripcion":"REACCIÓN ADVERSA A LA TRAZODONA"
  },
  {
    "codigo":62936002,
    "descripcion":"ÚLCERA DUODENAL AGUDA CON PERFORACIÓN Y OBSTRUCCIÓN"
  },
  {
    "codigo":1177048003,
    "descripcion":"INFECCIÓN CAUSADA POR TRICHINELLA NELSONI"
  },
  {
    "codigo":30168008,
    "descripcion":"EPIDIDIMORQUITIS GONOCÓCICA AGUDA"
  },
  {
    "codigo":423384009,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE CONDUCTO DE GLÁNDULA LAGRIMAL"
  },
  {
    "codigo":716461003,
    "descripcion":"CAPAZ DE TOLERAR LA RUTINA DE LAS ACTIVIDADES RELACIONADAS CON EL USO DEL BAÑO"
  },
  {
    "codigo":126637008,
    "descripcion":"NEOPLASIA DEL TRONCO"
  },
  {
    "codigo":288642003,
    "descripcion":"INICIA UNA CONVERSACIÓN"
  },
  {
    "codigo":26498006,
    "descripcion":"INFESTACIÓN CAUSADA POR BOOPHILUS"
  },
  {
    "codigo":92034008,
    "descripcion":"NEOPLASIA BENIGNA DE BRONQUIO DEL LÓBULO SUPERIOR IZQUIERDO DEL PULMÓN"
  },
  {
    "codigo":1237079005,
    "descripcion":"FRACTURA TRAUMÁTICA DE MAXILAR"
  },
  {
    "codigo":254039006,
    "descripcion":"FUSIÓN LUMBOSACRA CONGÉNITA"
  },
  {
    "codigo":188503007,
    "descripcion":"LINFOSARCOMA DE GANGLIOS LINFÁTICOS DE AXILA Y EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":57431005,
    "descripcion":"ENVENENAMIENTO POR VENENO DE REPTIL"
  },
  {
    "codigo":448812000,
    "descripcion":"SEPSIS CAUSADA POR STAPHYLOCOCCUS AUREUS RESISTENTE A METICILINA"
  },
  {
    "codigo":186668002,
    "descripcion":"MONONUCLEOSIS POR HERPESVIRUS DEL GRUPO GAMMA"
  },
  {
    "codigo":284972002,
    "descripcion":"DIFICULTAD PARA REALIZAR ACTIVIDAD RELACIONADA CON EL VESTIRSE"
  },
  {
    "codigo":219436008,
    "descripcion":"LESIÓN POR OPERACIONES DE GUERRA PRODUCIDA DESPUÉS DEL CESE DE HOSTILIDADES"
  },
  {
    "codigo":283137007,
    "descripcion":"CONTUSIÓN DE REGIÓN PÉLVICA"
  },
  {
    "codigo":248534009,
    "descripcion":"BALANITIS POR TRICOMONAS"
  },
  {
    "codigo":246699004,
    "descripcion":"PATRÓN DE VERGENCIA EN X"
  },
  {
    "codigo":212096003,
    "descripcion":"QUEMADURA QUE COMPROMETE 70-79 PORCIENTO DE LA SUPERFICIE DEL CUERPO, CON QUEMADURA DE ESPESOR COMPLETO QUE AFECTA 20-29 PORCIENTO DE LA SUPERFICIE CORPORAL"
  },
  {
    "codigo":307121000119100,
    "descripcion":"ARTRITIS ENTEROPÁTICA DE CADERA IZQUIERDA"
  },
  {
    "codigo":15488007,
    "descripcion":"MELANODERMATITIS TÓXICA LIQUENOIDE"
  },
  {
    "codigo":243029000,
    "descripcion":"LESIÓN POR EXPLOSIÓN DE MORTERO"
  },
  {
    "codigo":277632006,
    "descripcion":"LINFOMA MALIGNO DIFUSO CENTROBLÁSTICO POLIMORFO"
  },
  {
    "codigo":111957005,
    "descripcion":"SIGNO DE LASÈGUE EN EL BRAZO"
  },
  {
    "codigo":110122000,
    "descripcion":"LACERACIÓN COMPLEJA CONTAMINADA DE LA ENCÍA ALVEOLAR DEL MAXILAR SUPERIOR"
  },
  {
    "codigo":11818002,
    "descripcion":"ÚLCERA GASTROYEYUNAL CON PERFORACIÓN PERO SIN OBSTRUCCIÓN"
  },
  {
    "codigo":403199007,
    "descripcion":"QUERATOSIS ACTÍNICA ACANTOLÍTICA"
  },
  {
    "codigo":304895008,
    "descripcion":"COMPLEJOS PSICODINÁMICOS"
  },
  {
    "codigo":1220564001,
    "descripcion":"INTERRUPCIÓN INDUCIDA DEL EMBARAZO INCOMPLETA COMPLICADA POR SHOCK"
  },
  {
    "codigo":303060002,
    "descripcion":"ANEMIA NORMOCÍTICA LUEGO DE HEMORRAGIA AGUDA"
  },
  {
    "codigo":8148005,
    "descripcion":"QUEMOSIS DE LA CONJUNTIVA"
  },
  {
    "codigo":235689001,
    "descripcion":"ÚLCERA DE CUSHING DE DUODENO"
  },
  {
    "codigo":6313001,
    "descripcion":"CORIORRETINITIS Y COROIDITIS FOCAL YUXTAPAPILAR"
  },
  {
    "codigo":399529003,
    "descripcion":"TAMAÑO TUMORAL NO PUEDE SER EVALUADO, ESPÉCIMEN FRAGMENTADO"
  },
  {
    "codigo":301225007,
    "descripcion":"LARINGE NORMAL"
  },
  {
    "codigo":202921007,
    "descripcion":"TENOSINOVITIS DEL EXTENSOR LARGO DE LOS DEDOS"
  },
  {
    "codigo":168318001,
    "descripcion":"CRYPTOSPORIDIUM NO AISLADO EN CULTIVO DE MATERIA FECAL"
  },
  {
    "codigo":4478002,
    "descripcion":"FRACTURAS MÚLTIPLES DE LAS EXTREMIDADES SUPERIORES E INFERIORES"
  },
  {
    "codigo":233854003,
    "descripcion":"MIXOMA AURICULAR"
  },
  {
    "codigo":10956721000119109,
    "descripcion":"HERIDA ABIERTA DE DEDO ÍNDICE DERECHO"
  },
  {
    "codigo":299390005,
    "descripcion":"CHOQUE ROTULIANO AUSENTE"
  },
  {
    "codigo":364926006,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA SENTARSE LUEGO DE ESTAR ACOSTADO"
  },
  {
    "codigo":1251497007,
    "descripcion":"METÁSTASIS DE CARCINOMA EN BORDE BERMELLÓN DE LABIO INFERIOR"
  },
  {
    "codigo":363091000,
    "descripcion":"TRASTORNO DE LA VAINA DEL MÚSCULO RECTO ABDOMINAL"
  },
  {
    "codigo":70014009,
    "descripcion":"INTOXICACIÓN ALIMENTARIA CAUSADA POR CLOSTRIDIUM PERFRINGENS"
  },
  {
    "codigo":37246009,
    "descripcion":"ENFERMEDAD CAUSADA POR RICKETSIAS"
  },
  {
    "codigo":461395006,
    "descripcion":"INSERCIÓN NORMAL DE CONDUCTO ARTERIOSO EN ARTERIA PULMONAR IZQUIERDA PROXIMAL"
  },
  {
    "codigo":33576002,
    "descripcion":"PELO TEÑIDO"
  },
  {
    "codigo":262952002,
    "descripcion":"HEMATOMA SUBDURAL INTRACRANEAL TRAUMÁTICO"
  },
  {
    "codigo":197416005,
    "descripcion":"OCLUSIÓN DE VESÍCULA BILIAR"
  },
  {
    "codigo":295720005,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE CITARABINA"
  },
  {
    "codigo":66344007,
    "descripcion":"DEPRESIÓN MAYOR RECURRENTE"
  },
  {
    "codigo":721704005,
    "descripcion":"HEMORROIDES INTERNAS, GRADO II"
  },
  {
    "codigo":426792009,
    "descripcion":"COLUMNA VERTEBRAL CERVICAL NORMAL"
  },
  {
    "codigo":64509006,
    "descripcion":"TRASTORNO ADQUIRIDO DE INHIBIDOR DE FACTOR DE COAGULACIÓN"
  },
  {
    "codigo":292050003,
    "descripcion":"REACCIÓN ADVERSA AL DEXTROPROPOXIFENO"
  },
  {
    "codigo":95442007,
    "descripcion":"CIANOSIS PERIFÉRICA"
  },
  {
    "codigo":880039000,
    "descripcion":"ANOMALÍA ADQUIRIDA DE NEOVÁLVULA AÓRTICA POSTERIOR A REPARACIÓN BIVENTRICULAR DE TRONCO ARTERIAL COMÚN"
  },
  {
    "codigo":128210009,
    "descripcion":"SÍNDROME DE LA ABERTURA DE SALIDA TORÁCICA"
  },
  {
    "codigo":716199000,
    "descripcion":"SÍNDROME DE RETRASO DEL HABLA Y ASIMETRÍA FACIAL CON ESTRABISMO Y PLIEGUE CUTÁNEO EN EL LÓBULO DE LA OREJA"
  },
  {
    "codigo":62674007,
    "descripcion":"FIEBRE BATAI"
  },
  {
    "codigo":93607004,
    "descripcion":"OSIFICACIÓN INCOMPLETA DEL TARSO"
  },
  {
    "codigo":714364005,
    "descripcion":"CAPAZ DE ASIMILARSE CULTURALMENTE"
  },
  {
    "codigo":288380008,
    "descripcion":"DIFICULTAD PARA PASAR PÁGINAS"
  },
  {
    "codigo":419452009,
    "descripcion":"REACCIÓN ALÉRGICA CAUSADA POR ALIMENTO"
  },
  {
    "codigo":286545003,
    "descripcion":"MIEDO A LOS PÁJAROS"
  },
  {
    "codigo":188241004,
    "descripcion":"NEOPLASIA MALIGNA DE LA PARED LATERAL DE LA VEJIGA URINARIA"
  },
  {
    "codigo":778065005,
    "descripcion":"DEFECTO COMBINADO DE LA FOSFORILACIÓN OXIDATIVA TIPO 14"
  },
  {
    "codigo":448550004,
    "descripcion":"LEIOMIOMA DE DUODENO"
  },
  {
    "codigo":247859007,
    "descripcion":"MIEDO A NO DESPERTAR DE LA ANESTESIA GENERAL"
  },
  {
    "codigo":219174008,
    "descripcion":"EFECTO TARDÍO DE LESIÓN TRAUMÁTICA AUTOINFLIGIDA"
  },
  {
    "codigo":88102009,
    "descripcion":"BLASTEMA RENAL NODULAR"
  },
  {
    "codigo":315643003,
    "descripcion":"FRACTURA-LUXACIÓN DE DUPUYTREN DE TOBILLO"
  },
  {
    "codigo":250107008,
    "descripcion":"INESTABILIDAD DEL LIGAMENTO CRUZADO ANTERIOR"
  },
  {
    "codigo":20731008,
    "descripcion":"INTOXICACIÓN POR HOMERIA PALLIDA"
  },
  {
    "codigo":1296848002,
    "descripcion":"TUMOR DE BRENNER MALIGNO DE OVARIO"
  },
  {
    "codigo":188253000,
    "descripcion":"NEOPLASIA MALIGNA DE UNIÓN URETEROPÉLVICA"
  },
  {
    "codigo":1264080008,
    "descripcion":"TRASTORNO FETAL DEBIDO A TRANSFERENCIA PLACENTARIA DE SUSTANCIA DEBIDA A LA EXPOSICIÓN DE MADRE A SUSTANCIA QUÍMICA AMBIENTAL"
  },
  {
    "codigo":770725000,
    "descripcion":"ATROFIA CEREBRAL Y CEREBELOSA INFANTIL CON MICROCEFALIA PROGRESIVA POSTNATAL"
  },
  {
    "codigo":49829008,
    "descripcion":"REACCIÓN A TRANSFUSIÓN CAUSADA POR ANTICUERPOS ANTI A"
  },
  {
    "codigo":82597009,
    "descripcion":"TIÑA DE LA CABEZA CAUSADA POR TRICHOPHYTON TONSURANS"
  },
  {
    "codigo":211834002,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO SUPERFICIAL DE ANTEBRAZO"
  },
  {
    "codigo":1356879005,
    "descripcion":"LESIÓN LOCALIZADA DE ENCÉFALO"
  },
  {
    "codigo":273700000,
    "descripcion":"HIPER-BETA-CARNOSINEMIA"
  },
  {
    "codigo":406607009,
    "descripcion":"INFECCIÓN CAUSADA POR STAPHYLOCOCCUS AUREUS CON RESISTENCIA INTERMEDIA\/COMPLETAMENTE RESISTENTE A GLUCOPÉPTIDOS"
  },
  {
    "codigo":734287009,
    "descripcion":"ÁCIDO DESOXIRRIBONUCLEICO DE CEPA DE VACUNA CONTRA VIRUS VARICELA-ZÓSTER DETECTADO"
  },
  {
    "codigo":765220005,
    "descripcion":"TRASTORNO EN REMISIÓN COMPLETA EN RESPUESTA AL TRATAMIENTO"
  },
  {
    "codigo":699684005,
    "descripcion":"MUCOSITIS PERIIMPLANTE DENTAL"
  },
  {
    "codigo":372004005,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA GLÁNDULA PARÓTIDA"
  },
  {
    "codigo":208164008,
    "descripcion":"FRACTURA NO EXPUESTA DE PUBIS"
  },
  {
    "codigo":1254905001,
    "descripcion":"URTICARIA ALÉRGICA POR CONTACTO OCUPACIONAL"
  },
  {
    "codigo":304633000,
    "descripcion":"CABEZA POSICIONADA SOBRE ANILLO"
  },
  {
    "codigo":77092005,
    "descripcion":"ASPECTO DE LA SUPERFICIE DE UNA COLONIA BACTERIANA, ÁSPERA"
  },
  {
    "codigo":239097004,
    "descripcion":"GANGRENA DEL RECIÉN NACIDO"
  },
  {
    "codigo":402937004,
    "descripcion":"INFECCIÓN ESTREPTOCÓCICA DE LA PIEL"
  },
  {
    "codigo":109860005,
    "descripcion":"VASITIS NUDOSA PROLIFERATIVA"
  },
  {
    "codigo":1287673008,
    "descripcion":"CONVULSIÓN EPILÉPTICA DE LÓBULO TEMPORAL LATERAL"
  },
  {
    "codigo":271865009,
    "descripcion":"PUS EN MATERIA FECAL"
  },
  {
    "codigo":1187534001,
    "descripcion":"DEFICIENCIA DE FLAVOPROTEÍNA UBIQUINONA REDUCTASA DE TRANSFERENCIA DE ELECTRONES"
  },
  {
    "codigo":11997721000119109,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DE PIERNA DERECHA"
  },
  {
    "codigo":827086006,
    "descripcion":"SENSACIÓN TÁCTIL NORMAL"
  },
  {
    "codigo":366499001,
    "descripcion":"HALLAZGO RELACIONADO CON LA AMPLITUD DEL MOVIMIENTO ACTIVO DE EXTENSIÓN HORIZONTAL DE HOMBRO"
  },
  {
    "codigo":202659002,
    "descripcion":"ESPONDILOSIS CERVICAL EN MÚLTIPLES NIVELES SIN MIELOPATÍA"
  },
  {
    "codigo":71587006,
    "descripcion":"CONVULSIÓN POR TÉTANOS"
  },
  {
    "codigo":169891008,
    "descripcion":"TALLA AL NACER = ENTRE PERCENTILOS 50 Y 74"
  },
  {
    "codigo":6051009,
    "descripcion":"DEFECTO DE ARTICULACIÓN DEBIDO A DEFECTO DENTAL"
  },
  {
    "codigo":102520001,
    "descripcion":"EDAD MENOR DE 20 AÑOS"
  },
  {
    "codigo":299128000,
    "descripcion":"HALLAZGO RELACIONADO CON LA ESTRUCTURA MUSCULOESQUELÉTICA DEL PULGAR"
  },
  {
    "codigo":268195009,
    "descripcion":"TEJIDO ECTÓPICO EN EL PULMÓN"
  },
  {
    "codigo":1075891000119105,
    "descripcion":"SINOVITIS DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":69752006,
    "descripcion":"HIPOMETRÍA"
  },
  {
    "codigo":200824008,
    "descripcion":"DERMATITIS DE CONTACTO CAUSADA POR URUSHIOL DE ROBLE VENENOSO"
  },
  {
    "codigo":338611000119108,
    "descripcion":"COROIDITIS FOCAL DE POLO POSTERIOR DE OJO IZQUIERDO"
  },
  {
    "codigo":721442000,
    "descripcion":"SÍNDROME DEL CORDÓN CENTRAL DE MÉDULA ESPINAL DORSAL"
  },
  {
    "codigo":33314005,
    "descripcion":"HIPOAFECTIVIDAD"
  },
  {
    "codigo":360994007,
    "descripcion":"DEFICIENCIA DE PROLIDASA"
  },
  {
    "codigo":295458008,
    "descripcion":"SOBREDOSIS INTENCIONAL DE LAXANTE CON ANTRAQUINONA"
  },
  {
    "codigo":293623002,
    "descripcion":"ALERGIA A ÁCIDO MEFENÁMICO"
  },
  {
    "codigo":195319003,
    "descripcion":"EMBOLIA Y TROMBOSIS DE ARTERIA HUMERAL"
  },
  {
    "codigo":162551004,
    "descripcion":"HORARIOS IRREGULARES PARA LAS COMIDAS"
  },
  {
    "codigo":717772000,
    "descripcion":"SÍNDROME CEREBRO-ÓCULO-DENTO-AURÍCULO- ESQUELÉTICO"
  },
  {
    "codigo":95180000,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA PLEURA VISCERAL"
  },
  {
    "codigo":129783008,
    "descripcion":"LOCALIZACIÓN EN HORA 12 EN LA MAMOGRAFÍA"
  },
  {
    "codigo":160716004,
    "descripcion":"VIVIENDA SUSCEPTIBLE A VANDALISMO"
  },
  {
    "codigo":93345006,
    "descripcion":"POSICIÓN ANÓMALA CONGÉNITA DEL PABELLÓN AURICULAR"
  },
  {
    "codigo":16014311000119102,
    "descripcion":"TROMBOFLEBITIS DE AMBOS MIEMBROS INFERIORES"
  },
  {
    "codigo":209459006,
    "descripcion":"ESGUINCE DEL LIGAMENTO INTERCARPIANO DORSAL"
  },
  {
    "codigo":124278004,
    "descripcion":"DEFICIENCIA DE NICOTINATO FOSFORRIBOSILTRANSFERASA"
  },
  {
    "codigo":91510005,
    "descripcion":"ESPASMO COORDINADO"
  },
  {
    "codigo":189814006,
    "descripcion":"PANCREATOBLASTOMA"
  },
  {
    "codigo":89675003,
    "descripcion":"TRASTORNO DE TERRORES NOCTURNOS"
  },
  {
    "codigo":286283003,
    "descripcion":"USA CLICS AL HABLAR"
  },
  {
    "codigo":253515003,
    "descripcion":"DEFECTO DEL TABIQUE INTERVENTRICULAR EN LA TETRALOGÍA DE FALLOT"
  },
  {
    "codigo":120608000,
    "descripcion":"AMPOLLA CON INFECCIÓN"
  },
  {
    "codigo":415520000,
    "descripcion":"PARAPROTEÍNA DETECTADA EN SUERO"
  },
  {
    "codigo":22304002,
    "descripcion":"GASTRITIS SUPERFICIAL"
  },
  {
    "codigo":87840008,
    "descripcion":"GALACTOCELE ASOCIADO CON EL PARTO"
  },
  {
    "codigo":774133001,
    "descripcion":"DOLOR EN EL ANTEBRAZO DERECHO"
  },
  {
    "codigo":1003509004,
    "descripcion":"AGENESIA DE PIE"
  },
  {
    "codigo":315381004,
    "descripcion":"NACIDO EN BÉLGICA"
  },
  {
    "codigo":11836391000119108,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN INTERTARSIANA DE PIE DERECHO"
  },
  {
    "codigo":249845008,
    "descripcion":"PÉRDIDA DEL SENTIDO POSTURAL"
  },
  {
    "codigo":51402000,
    "descripcion":"RECIÉN NACIDO HIPERTÓNICO"
  },
  {
    "codigo":84170006,
    "descripcion":"CONTUSIÓN DEL CEREBRO CON HERIDA INTRACRANEAL ABIERTA"
  },
  {
    "codigo":442783003,
    "descripcion":"CAPTACIÓN DE YODO RADIACTIVO POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":49567004,
    "descripcion":"COITO INTRAMENSTRUAL"
  },
  {
    "codigo":410015008,
    "descripcion":"HIDROCEFALIA NO COMUNICANTE POSTRAUMÁTICA"
  },
  {
    "codigo":211572001,
    "descripcion":"LESIÓN TRAUMÁTICA CERRADA POR APLASTAMIENTO DE LA MUÑECA, DORSO"
  },
  {
    "codigo":735860005,
    "descripcion":"MÚLTIPLES LESIONES TRAUMÁTICAS DE PIERNA"
  },
  {
    "codigo":275273001,
    "descripcion":"INFECCIÓN DE INJERTO"
  },
  {
    "codigo":45897005,
    "descripcion":"SÍNDROME DE JERVIS"
  },
  {
    "codigo":734025005,
    "descripcion":"SEPARACIÓN EXCESIVA DE DIENTES COMPLETAMENTE ERUPCIONADOS"
  },
  {
    "codigo":240670001,
    "descripcion":"ENFERMEDAD ESQUELÉTICA DE LYME"
  },
  {
    "codigo":699422003,
    "descripcion":"PERIIMPLANTITIS DENTAL"
  },
  {
    "codigo":44062003,
    "descripcion":"MENARCA TEMPRANA"
  },
  {
    "codigo":109598004,
    "descripcion":"MANCHADO DENTAL EXTRÍNSECO ASOCIADO CON HÁBITOS ORALES"
  },
  {
    "codigo":207902006,
    "descripcion":"FRACTURA TRICOLUMNAR DE AXIS NO EXPUESTA"
  },
  {
    "codigo":764958008,
    "descripcion":"QUERATODERMIA PALMOPLANTAR ESTRIADA"
  },
  {
    "codigo":404510009,
    "descripcion":"BACILOS GRAMNEGATIVOS GRANDES"
  },
  {
    "codigo":402675002,
    "descripcion":"TRASTORNO DE VASODILATACIÓN DE LAS EXTREMIDADES"
  },
  {
    "codigo":238835001,
    "descripcion":"POIQUILODERMIA ACROQUERATÓSICA HEREDITARIA DE WEARY"
  },
  {
    "codigo":304371002,
    "descripcion":"FÍSTULA DE YEYUNO"
  },
  {
    "codigo":73160007,
    "descripcion":"DIAFRAGMITIS"
  },
  {
    "codigo":1187272007,
    "descripcion":"INESTABILIDAD HABITACIONAL DEBIDA A CARGA DE COSTO DE VIVIENDA"
  },
  {
    "codigo":1285576009,
    "descripcion":"RINOSINUSITIS CRÓNICA CON PÓLIPOS NASALES MÚLTIPLES"
  },
  {
    "codigo":71325002,
    "descripcion":"LIPODISTROFIA"
  },
  {
    "codigo":366237003,
    "descripcion":"ACTIVIDAD DE LA CARIES DENTAL - HALLAZGO"
  },
  {
    "codigo":167794000,
    "descripcion":"MORFOLOGÍA DE LOS ESPERMATOZOIDES - BAJA : 30-50% NORMALES"
  },
  {
    "codigo":300701008,
    "descripcion":"INCAPAZ DE EMITIR CHEQUES"
  },
  {
    "codigo":724850003,
    "descripcion":"FRAGILIDAD EPIDÉRMICA"
  },
  {
    "codigo":286728005,
    "descripcion":"CARÁCTER CUMPLIDOR"
  },
  {
    "codigo":723015000,
    "descripcion":"ERUPCIÓN CUTÁNEA AGUDA DISCOIDE"
  },
  {
    "codigo":298866009,
    "descripcion":"ARTICULACIÓN DE HOMBRO TIBIA AL TACTO"
  },
  {
    "codigo":231495000,
    "descripcion":"ESTUPOR MANÍACO"
  },
  {
    "codigo":34887006,
    "descripcion":"MADAROSIS PALPEBRAL"
  },
  {
    "codigo":428103008,
    "descripcion":"TRASTORNO DE MÉDULA ÓSEA TRASPLANTADA"
  },
  {
    "codigo":297031009,
    "descripcion":"SOBREDOSIS INTENCIONAL DE DIURÉTICO AHORRADOR DE POTASIO"
  },
  {
    "codigo":229660003,
    "descripcion":"DISFASIA ANTERIOR"
  },
  {
    "codigo":721180007,
    "descripcion":"LÍQUEN PLANO PILAR DE VULVA"
  },
  {
    "codigo":719345002,
    "descripcion":"INADECUADO PARA PROGRAMA DE REHABILITACIÓN CARDÍACA"
  },
  {
    "codigo":293361006,
    "descripcion":"REACCIÓN ADVERSA AL FUMARATO FERROSO"
  },
  {
    "codigo":193222002,
    "descripcion":"MIOPATÍA CONGÉNITA BENIGNA"
  },
  {
    "codigo":94918009,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA COLUMNA VERTEBRAL LUMBAR"
  },
  {
    "codigo":291526009,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR DERIVADO DE NITROFURANO"
  },
  {
    "codigo":93083003,
    "descripcion":"FENESTRACIÓN CONGÉNITA DE HUESO INTERPARIETAL"
  },
  {
    "codigo":289691003,
    "descripcion":"ÚTERO GRÁVIDO DESVIADO A LA IZQUIERDA"
  },
  {
    "codigo":1080911000119105,
    "descripcion":"MELANOMA IN SITU DE OÍDO IZQUIERDO"
  },
  {
    "codigo":255088001,
    "descripcion":"NEOPLASIA MALIGNA DE PÁNCREAS EXOCRINO"
  },
  {
    "codigo":418928000,
    "descripcion":"CANTIDAD DE EOSINÓFILOS EN SANGRE POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":124016003,
    "descripcion":"METAHEMALBÚMINA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":417093003,
    "descripcion":"ENFERMEDAD CAUSADA POR VIRUS DEL NILO OCCIDENTAL"
  },
  {
    "codigo":286021005,
    "descripcion":"CAPAZ DE PONER UN ENCHUFE ELÉCTRICO EN UN TOMACORRIENTE"
  },
  {
    "codigo":23877007,
    "descripcion":"INTOXICACIÓN CAUSADA POR BUTABARBITAL"
  },
  {
    "codigo":11785961000119102,
    "descripcion":"HERIDA DE MUÑECA IZQUIERDA DEBIDA A PICADURA DE INSECTO NO VENENOSO"
  },
  {
    "codigo":253253009,
    "descripcion":"OREJA DE GATO"
  },
  {
    "codigo":284186002,
    "descripcion":"QUEMADURA DE ESTRUCTURA DEL SISTEMA NERVIOSO"
  },
  {
    "codigo":343631000119108,
    "descripcion":"ESCLEROPERIQUERATITIS BILATERAL"
  },
  {
    "codigo":92595004,
    "descripcion":"CARCINOMA IN SITU DEL PISO DE LA BOCA"
  },
  {
    "codigo":448026008,
    "descripcion":"VALVA AURICULOVENTRICULAR IZQUIERDA BIFOLIADA CON VALVA FUSIONADA DEL LADO IZQUIERDO E INFERIOR EN PUENTE"
  },
  {
    "codigo":216815001,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR COSMÉTICOS"
  },
  {
    "codigo":870340002,
    "descripcion":"GRANULOMA DE MÉDULA ESPINAL CAUSADO POR MYCOBACTERIUM"
  },
  {
    "codigo":247748005,
    "descripcion":"ALUCINACIONES SOMÁTICAS DISOCIATIVAS"
  },
  {
    "codigo":16674691000119100,
    "descripcion":"FRACTURA EXPUESTA DE PISO DE ÓRBITA DERECHA"
  },
  {
    "codigo":1263556007,
    "descripcion":"LESIÓN DE NERVIO SAFENO EXTERNO"
  },
  {
    "codigo":16537000,
    "descripcion":"ATELECTASIA POR COMPRESIÓN"
  },
  {
    "codigo":280516007,
    "descripcion":"INFECCIÓN DE OVARIO"
  },
  {
    "codigo":10966761000119107,
    "descripcion":"HERIDA ABIERTA DE PIERNA IZQUIERDA DEBIDA A MORDEDURA HUMANA"
  },
  {
    "codigo":536671000221100,
    "descripcion":"NIÑO VICTIMA DE TRABAJO INFANTIL"
  },
  {
    "codigo":278681006,
    "descripcion":"LÍNEA MEDIA DENTAL COINCIDENTE Y CORRECTA"
  },
  {
    "codigo":704665007,
    "descripcion":"STREPTOCOCCUS DEL GRUPO A, NO AISLADO"
  },
  {
    "codigo":473454002,
    "descripcion":"TRASTORNO DE VÁLVULA AURICULOVENTRICULAR IZQUIERDA (MORFOLÓGICAMENTE NO MITRAL)"
  },
  {
    "codigo":735598004,
    "descripcion":"OLIGOOSTEOARTROSIS"
  },
  {
    "codigo":12867002,
    "descripcion":"SUFRIMIENTO FETAL QUE AFECTA EL MANEJO DE LA SITUACIÓN MATERNA"
  },
  {
    "codigo":78403003,
    "descripcion":"PARÁLISIS ESPÁSTICA"
  },
  {
    "codigo":307779006,
    "descripcion":"ATENDIDO EN ALOJAMIENTO SUPERVISADO"
  },
  {
    "codigo":897603007,
    "descripcion":"LESIÓN TRAUMÁTICA DE MUÑECA Y\/O MANO"
  },
  {
    "codigo":43800000,
    "descripcion":"BURSITIS DE MUÑECA"
  },
  {
    "codigo":1354520000,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO SENSITIVO CUTÁNEO DE DEDO DE PIE"
  },
  {
    "codigo":109336002,
    "descripcion":"OSTEORRADIONECROSIS DE HUESO CIGOMÁTICO"
  },
  {
    "codigo":240408004,
    "descripcion":"REACCIÓN DE LA LEPRA TIPO 1, EN FASE PROLIFERATIVA"
  },
  {
    "codigo":764696007,
    "descripcion":"SÍNDROME DE MICRODELECIÓN 17P13.13 DISTAL"
  },
  {
    "codigo":369645001,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA RADIAL PROFUNDA DE PRÓSTATA, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":346141000119101,
    "descripcion":"ESTAFILOMA ECUATORIAL BILATERAL"
  },
  {
    "codigo":238573006,
    "descripcion":"DERMATITIS POR CONTACTO CON PERFUME"
  },
  {
    "codigo":402413008,
    "descripcion":"URTICARIA TIPO ARTHUS"
  },
  {
    "codigo":236738001,
    "descripcion":"PERFORACIÓN UTERINA POR DISPOSITIVO ANTICONCEPTIVO INTRAUTERINO"
  },
  {
    "codigo":10831901000119102,
    "descripcion":"FRACTURA EXPUESTA DE BASE DE TERCER METACARPIANO DERECHO"
  },
  {
    "codigo":72898003,
    "descripcion":"NÓDULOS ELASTÓTICOS DEL ANTIHÉLIX"
  },
  {
    "codigo":11814941000119103,
    "descripcion":"RUPTURA TRAUMÁTICA DE PLACA PALMAR DE ARTICULACIÓN DE DEDO ANULAR IZQUIERDO"
  },
  {
    "codigo":105666006,
    "descripcion":"ENFERMEDAD CAUSADA POR PARAMPHISTOMATIDAE"
  },
  {
    "codigo":1083421000119103,
    "descripcion":"OTITIS MEDIA CRÓNICA SEROSANGUINOLENTA BILATERAL"
  },
  {
    "codigo":40130009,
    "descripcion":"ESPINA BÍFIDA SIN HIDROCEFALIA"
  },
  {
    "codigo":300439004,
    "descripcion":"PROBLEMAS DEL TRACTO GASTROINTESTINAL"
  },
  {
    "codigo":365975004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA CONTROLAR EL HÁBITO DE BEBER"
  },
  {
    "codigo":38295006,
    "descripcion":"PARAFRENIA INVOLUTIVA"
  },
  {
    "codigo":396908003,
    "descripcion":"ESTADIO I: MACRO Y MICROSCÓPICAMENTE ENCAPSULADO (TIMO)"
  },
  {
    "codigo":724588007,
    "descripcion":"NEOPLASIA OSTEÓGENA BENIGNA DE CARTÍLAGO ARTICULAR DE COSTILLA"
  },
  {
    "codigo":298604007,
    "descripcion":"AMPLITUD DE FLEXIÓN ACTIVA DE LA COLUMNA LUMBAR DISMINUIDA"
  },
  {
    "codigo":198465002,
    "descripcion":"INFERTILIDAD SECUNDARIA DE ORIGEN VAGINAL"
  },
  {
    "codigo":1857005,
    "descripcion":"SÍNDROME DE RUBÉOLA CONGÉNITA"
  },
  {
    "codigo":460609006,
    "descripcion":"INSERCIÓN ANÓMALA DE CONDUCTO ARTERIOSO"
  },
  {
    "codigo":131094005,
    "descripcion":"TRIYODOTIRONINA ANORMAL"
  },
  {
    "codigo":426006006,
    "descripcion":"TRICOMICOSIS PÚBICA"
  },
  {
    "codigo":294934005,
    "descripcion":"ALERGIA A CIANOCOBALAMINA"
  },
  {
    "codigo":1343510005,
    "descripcion":"SÍNDROME DE CORDÓN POSTERIOR DEBIDO A NEOPLASIA"
  },
  {
    "codigo":16048311000119103,
    "descripcion":"ARTRITIS VIRAL DE ARTICULACIÓN DE MUÑECA, BILATERAL"
  },
  {
    "codigo":1145067005,
    "descripcion":"SOBREDOSIS DE TRICLOFÓS"
  },
  {
    "codigo":293099007,
    "descripcion":"REACCIÓN ADVERSA A INMUNOGLOBULINA POR VÍA INTRAVENOSA"
  },
  {
    "codigo":29120000,
    "descripcion":"COLITIS EOSINÓFILA"
  },
  {
    "codigo":29361000175106,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN DE REGIÓN SACRA DE ESPALDA GRADO 4"
  },
  {
    "codigo":1208768006,
    "descripcion":"FLUJO DE SANGRE PERSISTENTE HACIA SACO ANEURISMÁTICO POSTERIOR A INSERCIÓN ENDOVASCULAR DE STENT CON CUBIERTA EN AORTA"
  },
  {
    "codigo":94656008,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LAS VÍAS RESPIRATORIAS SUPERIORES"
  },
  {
    "codigo":125589001,
    "descripcion":"LESIÓN TRAUMÁTICA DE LAS VÍAS RESPIRATORIAS SUPERIORES"
  },
  {
    "codigo":420501001,
    "descripcion":"DRUSAS MACULARES DURAS"
  },
  {
    "codigo":289429004,
    "descripcion":"PRESENTACIÓN EN PERINEO"
  },
  {
    "codigo":418666000,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA SUPERIOR AFECTADO POR NEOPLASIA MALIGNA"
  },
  {
    "codigo":123754002,
    "descripcion":"PIELONEFRITIS FOCAL"
  },
  {
    "codigo":1336170004,
    "descripcion":"RABDOMIOSARCOMA FUSOCELULAR METASTÁSICO"
  },
  {
    "codigo":254826008,
    "descripcion":"MESOTELIOMA BENIGNO DE PERICARDIO"
  },
  {
    "codigo":285759003,
    "descripcion":"LESIÓN DE VENA DIGITAL"
  },
  {
    "codigo":449599006,
    "descripcion":"FIJACIÓN ANÓMALA DEL TABIQUE INTERAURICULAR A CARA POSTERIOR DE SEPTUM PRIMUM A LA IZQUIERDA"
  },
  {
    "codigo":23615008,
    "descripcion":"DERMATITIS ESPONGIÓTICA"
  },
  {
    "codigo":251156000,
    "descripcion":"TAQUICARDIA VENTRICULAR CON COMPLEJO QRS AMPLIO"
  },
  {
    "codigo":414996002,
    "descripcion":"UVEÍTIS PRODUCIDA POR ÁCIDO PAMIDRÓNICO"
  },
  {
    "codigo":185620004,
    "descripcion":"EXTENDIDO CERVICAL INFECTADO - RECONVOCATORIA ANULADA"
  },
  {
    "codigo":1332500006,
    "descripcion":"COMPRESIÓN DE NERVIO GENITOFEMORAL IZQUIERDO"
  },
  {
    "codigo":52713000,
    "descripcion":"DISTROFIA NEUROAXÓNICA INFANTIL"
  },
  {
    "codigo":21780009,
    "descripcion":"PERIOSTITIS DE LA MANDÍBULA"
  },
  {
    "codigo":445929002,
    "descripcion":"HEMATOMA DE ESPACIO EXTRAPERITONEAL"
  },
  {
    "codigo":249321001,
    "descripcion":"NARIZ ANCHA"
  },
  {
    "codigo":183785003,
    "descripcion":"INSCRIPTO EN LISTA DE ADMISIÓN OTORRINOLARINGOLÓGICA"
  },
  {
    "codigo":247486000,
    "descripcion":"DEFORMIDAD DE LA UÑA EN TENAZA"
  },
  {
    "codigo":1197758001,
    "descripcion":"TRASTORNO DEL ESPECTRO DE KERNÍCTERUS"
  },
  {
    "codigo":413161009,
    "descripcion":"EVALUACIÓN DE EJERCICIO COMPLETADA"
  },
  {
    "codigo":1359763002,
    "descripcion":"OBESIDAD INFANTIL SINDRÓMICA DE CAUSA GENÉTICA"
  },
  {
    "codigo":81811002,
    "descripcion":"MÚSCULOS PÉLVICOS DEFECTUOSOS"
  },
  {
    "codigo":737171005,
    "descripcion":"DERMATITIS DE GENITALES MASCULINOS"
  },
  {
    "codigo":38381000087101,
    "descripcion":"HIPOCINESIA DE SEGMENTO INFEROLATERAL MEDIO DE VENTRÍCULO CARDÍACO IZQUIERDO"
  },
  {
    "codigo":704403007,
    "descripcion":"CONOCIMIENTO DEFICIENTE SOBRE PREVENCIÓN DE CAÍDAS"
  },
  {
    "codigo":278419008,
    "descripcion":"MOTRICIDAD GRUESA CORPORAL EN RESPUESTA A SONIDO"
  },
  {
    "codigo":243816001,
    "descripcion":"ESTADO ANTICONCEPTIVO"
  },
  {
    "codigo":276584001,
    "descripcion":"NEFROCALCINOSIS NEONATAL"
  },
  {
    "codigo":43501000087105,
    "descripcion":"DESGARRO DE MENISCO EXTERNO DE ARTICULACIÓN DE RODILLA IZQUIERDA"
  },
  {
    "codigo":178280004,
    "descripcion":"INFECCIÓN POSTNATAL"
  },
  {
    "codigo":407656004,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: LITUANO"
  },
  {
    "codigo":40941000087109,
    "descripcion":"QUEMADURA DE ANEXOS OCULARES IZQUIERDOS"
  },
  {
    "codigo":211048001,
    "descripcion":"ABRASIÓN DE PIEL DE PENE"
  },
  {
    "codigo":1259624004,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE CUERPO CAROTÍDEO"
  },
  {
    "codigo":473192009,
    "descripcion":"SILLA DE RUEDAS BIEN REPARADA"
  },
  {
    "codigo":307517001,
    "descripcion":"DEFICIENCIA DE FACTOR VIII RELACIONADA CON EL EMBARAZO"
  },
  {
    "codigo":78141002,
    "descripcion":"PARÁLISIS DE ERB - DUCHENNE"
  },
  {
    "codigo":405821001,
    "descripcion":"OTITIS EXTERNA ALÉRGICA"
  },
  {
    "codigo":373053001,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM PISCIUM"
  },
  {
    "codigo":46061000087109,
    "descripcion":"ESGUINCE DE LIGAMENTO ILIOFEMORAL DERECHO"
  },
  {
    "codigo":209213007,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA NO EXPUESTA DE LA ARTICULACIÓN ESTERNOCLAVICULAR"
  },
  {
    "codigo":305682005,
    "descripcion":"ATENDIDO POR UN OFTALMÓLOGO"
  },
  {
    "codigo":698898006,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: GEORGIANO"
  },
  {
    "codigo":403986008,
    "descripcion":"LINFANGIOSARCOMA"
  },
  {
    "codigo":860903000,
    "descripcion":"ALERGIA A BENZIMIDAZOL"
  },
  {
    "codigo":402151003,
    "descripcion":"DERMATOSIS CAUSADA POR ARACHNIDA"
  },
  {
    "codigo":15968901000119104,
    "descripcion":"TROMBOFLEBITIS DE AMBAS VENAS ILÍACAS"
  },
  {
    "codigo":762599007,
    "descripcion":"DOLOR VISCERAL CRÓNICO MECÁNICO"
  },
  {
    "codigo":170940000,
    "descripcion":"ATENCIÓN COMPARTIDA: ENFERMERA DE CONSULTORIO Y MÉDICO GENERAL"
  },
  {
    "codigo":203708004,
    "descripcion":"DISFUNCIÓN SEGMENTARIA Y SOMÁTICA"
  },
  {
    "codigo":302012007,
    "descripcion":"REFLEJOS PERIFÉRICOS DE RELAJACIÓN LENTA"
  },
  {
    "codigo":433084008,
    "descripcion":"INFECCIÓN DE PRÓTESIS TOTAL DE ARTICULACIÓN DE RODILLA"
  },
  {
    "codigo":269244007,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO DE MUÑECA Y MANO"
  },
  {
    "codigo":234641000,
    "descripcion":"INMUNODEFICIENCIA ASOCIADA CON ANOMALÍAS MULTIORGÁNICAS"
  },
  {
    "codigo":1119377003,
    "descripcion":"AUSENCIA DE SENSACIÓN DEL LADO IZQUIERDO DEL TRONCO"
  },
  {
    "codigo":300177004,
    "descripcion":"ESTRIBO PRESENTE"
  },
  {
    "codigo":365713007,
    "descripcion":"RECUENTO DE CÉLULAS EN EL LÍQUIDO SINOVIAL - HALLAZGO"
  },
  {
    "codigo":36198007,
    "descripcion":"VÍCTIMA DE ACCIDENTE VEHICULAR Y\/O DE TRÁNSITO"
  },
  {
    "codigo":34363003,
    "descripcion":"PRURITO DE LA VAGINA"
  },
  {
    "codigo":1345083007,
    "descripcion":"DEPENDENCIA DE CORTICOESTEROIDE DEBIDA A PATRÓN DE USO NOCIVO"
  },
  {
    "codigo":198203009,
    "descripcion":"CERVICITIS Y QUISTE DE NABOTH"
  },
  {
    "codigo":196368005,
    "descripcion":"PIORREA ALVEOLAR"
  },
  {
    "codigo":1179408008,
    "descripcion":"SÍNDROME DE RETRASO DEL DESARROLLO, RETRASO DEL HABLA, DISCAPACIDAD INTELECTUAL, ANOMALÍAS VISUALES, DISMORFIA FACIAL ASOCIADO A CHD3"
  },
  {
    "codigo":128997002,
    "descripcion":"TRASTORNO INFLAMATORIO DE LAS VÍAS RESPIRATORIAS INFERIORES"
  },
  {
    "codigo":292837003,
    "descripcion":"REACCIÓN ADVERSA AL INTERFERÓN-A-2A"
  },
  {
    "codigo":30693006,
    "descripcion":"AEROFAGIA"
  },
  {
    "codigo":16024351000119108,
    "descripcion":"TROMBOFLEBITIS DE VENA SUBCLAVIA DERECHA"
  },
  {
    "codigo":1144805008,
    "descripcion":"POLIANGEÍTIS MICROSCÓPICA"
  },
  {
    "codigo":94394000,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE GANGLIOS LINFÁTICOS DE LA CABEZA"
  },
  {
    "codigo":10755001000119102,
    "descripcion":"TRASTORNO DEL ESTADO DE ÁNIMO POSPARTO"
  },
  {
    "codigo":127162000,
    "descripcion":"LINFADENOPATÍA ILÍACA COMÚN EXTERNA"
  },
  {
    "codigo":678841000119102,
    "descripcion":"NÉBULA DE CÓRNEA DERECHA"
  },
  {
    "codigo":15670201000119103,
    "descripcion":"ELEVACIÓN CONGÉNITA DE AMBOS OMÓPLATOS"
  },
  {
    "codigo":225466006,
    "descripcion":"DISPUESTO"
  },
  {
    "codigo":92559007,
    "descripcion":"CARCINOMA IN SITU DEL CIEGO"
  },
  {
    "codigo":27023008,
    "descripcion":"DERMATITIS INFECCIOSA DE PÁRPADO"
  },
  {
    "codigo":1303140002,
    "descripcion":"ARTRITIS DE ARTICULACIÓN RADIOCARPIANA IZQUIERDA"
  },
  {
    "codigo":25188002,
    "descripcion":"PEDICULOSIS CORPORAL"
  },
  {
    "codigo":254564003,
    "descripcion":"CARCINOMA IN SITU DE CURVATURA MENOR DE ESTÓMAGO"
  },
  {
    "codigo":713316008,
    "descripcion":"ERUPCIÓN DE LA PIEL CONCOMITANTE CON INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":711481001,
    "descripcion":"INMUNODEFICIENCIA LIGADA AL CROMOSOMA X CON DEFICIENCIA DE MAGNESIO, INFECCIÓN POR VIRUS DE EPSTEIN-BARR Y NEOPLASIA"
  },
  {
    "codigo":285497002,
    "descripcion":"CAPAZ DE MOVER LA LENGUA"
  },
  {
    "codigo":1268537000,
    "descripcion":"CARCINOMA ADENOIDE QUÍSTICO PRIMARIO DE CUELLO UTERINO"
  },
  {
    "codigo":449337005,
    "descripcion":"PERMEABILIDAD RESIDUAL DE CONDUCTO ARTERIOSO"
  },
  {
    "codigo":283662008,
    "descripcion":"HERIDA POR PINCHAZO DE CLAVO EN EL DORSO DE LA MANO"
  },
  {
    "codigo":871651001,
    "descripcion":"COMPLICACIÓN DE CONDUCTO ARTERIAL DEBIDA A PROCEDIMIENTO Y POSTERIOR A ÉL"
  },
  {
    "codigo":249059002,
    "descripcion":"MÚLTIPLES PARTES FETALES PALPABLES"
  },
  {
    "codigo":609507007,
    "descripcion":"INTERRUPCIÓN INDUCIDA DEL EMBARAZO COMPLICADA POR INSUFICIENCIA CARDÍACA"
  },
  {
    "codigo":279992002,
    "descripcion":"CAÍDAS RECURRENTES"
  },
  {
    "codigo":771512003,
    "descripcion":"TRASTORNO DEL ESPECTRO AUTISTA POR DEFICIENCIA DEL ACTIVADOR DE TRANSCRIPCIÓN Y REGULADOR DEL DESARROLLO AUTS2"
  },
  {
    "codigo":247224002,
    "descripcion":"EXCAVACIÓN PATOLÓGICA DE PAPILA ÓPTICA"
  },
  {
    "codigo":736909000,
    "descripcion":"COLESTEATOMA RECURRENTE DE CAVIDAD MASTOIDEA"
  },
  {
    "codigo":1861000124105,
    "descripcion":"TRANSICIÓN DE LA ATENCIÓN"
  },
  {
    "codigo":276322001,
    "descripcion":"PLACA CUTÁNEA"
  },
  {
    "codigo":16013009,
    "descripcion":"FÓRMULA DE HIPERALIMENTACIÓN PARA EL TRATAMIENTO DEL SÍNDROME DE INTESTINO CORTO"
  },
  {
    "codigo":309090002,
    "descripcion":"INFECCIÓN DEL PENE"
  },
  {
    "codigo":210786006,
    "descripcion":"LESIÓN TRAUMÁTICA NO EXPUESTA DE ARTERIA SUBCLAVIA"
  },
  {
    "codigo":14178006,
    "descripcion":"PELVIS RENAL DOBLE"
  },
  {
    "codigo":405559000,
    "descripcion":"HEMATOMA HEPÁTICO SUBCAPSULAR ESPONTÁNEO"
  },
  {
    "codigo":46946009,
    "descripcion":"TORSIÓN DE TROMPA DE FALOPIO"
  },
  {
    "codigo":1259362008,
    "descripcion":"ESTRECHEZ DE UNIÓN VESICOURETERAL"
  },
  {
    "codigo":208951006,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE LA CABEZA DEL PERONÉ"
  },
  {
    "codigo":45111007,
    "descripcion":"FUNCIÓN NORMAL DE EXCRECIÓN"
  },
  {
    "codigo":239884000,
    "descripcion":"ENFERMEDAD DE MALEMUD"
  },
  {
    "codigo":403724001,
    "descripcion":"TELANGIECTASIA CAUSADA POR RADIACIÓN IONIZANTE"
  },
  {
    "codigo":733239008,
    "descripcion":"MÚLTIPLES LESIONES TRAUMÁTICAS SUPERFICIALES DE MUÑECA"
  },
  {
    "codigo":895244003,
    "descripcion":"FORMA TRIANGULAR ANORMAL CONGÉNITA DE FALANGE DE DEDO ÍNDICE"
  },
  {
    "codigo":370956008,
    "descripcion":"DEFECTO DE EPITELIO CORNEAL"
  },
  {
    "codigo":205281006,
    "descripcion":"SINFALANGIA DE ARTICULACIÓN INTERFALÁNGICA DISTAL"
  },
  {
    "codigo":762337006,
    "descripcion":"TRASTORNO DEL ESTADO DE ÁNIMO CON SÍNTOMAS DEPRESIVOS Y MANÍACOS MIXTOS CAUSADO POR ALUCINÓGENO"
  },
  {
    "codigo":6838000,
    "descripcion":"FÍSTULA ARTERIOVENOSA MESENTÉRICA"
  },
  {
    "codigo":400054000,
    "descripcion":"VASCULITIS REUMATOIDE"
  },
  {
    "codigo":238049009,
    "descripcion":"SÍNDROME DE LA GLUCOPROTEÍNA DEFICIENTE EN CARBOHIDRATOS"
  },
  {
    "codigo":170678001,
    "descripcion":"CAMBIOS DE SÍNTOMAS PSIQUIÁTRICOS"
  },
  {
    "codigo":203446005,
    "descripcion":"OSTEOPOROSIS POSQUIRÚRGICA POR MALABSORCIÓN CON FRACTURA PATOLÓGICA"
  },
  {
    "codigo":301750006,
    "descripcion":"INCAPAZ DE REALIZAR ACTIVIDADES DE ADMINISTRACIÓN Y SUPERVISIÓN"
  },
  {
    "codigo":299915008,
    "descripcion":"HALLAZGO RELACIONADO CON LA SENSIBILIDAD AL TACTO FIRME"
  },
  {
    "codigo":298080001,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE LA MANO"
  },
  {
    "codigo":3168002,
    "descripcion":"TROMBOFLEBITIS DE SENO VENOSO INTRACRANEAL"
  },
  {
    "codigo":724064004,
    "descripcion":"SÍNDROME DE FUSIÓN POSTERIOR DE VÉRTEBRAS LUMBOSACRAS Y BLEFAROPTOSIS"
  },
  {
    "codigo":722229001,
    "descripcion":"SARCOMA PRIMARIO DE RETROPERITONEO"
  },
  {
    "codigo":296245002,
    "descripcion":"SOBREDOSIS DE PROCLORPERAZINA"
  },
  {
    "codigo":197941005,
    "descripcion":"HEMATURIA MACROSCÓPICA"
  },
  {
    "codigo":230709005,
    "descripcion":"HEMORRAGIA CEREBRAL SUPRATENTORIAL MASIVA"
  },
  {
    "codigo":353671000119108,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA SUPERPUESTA DE HUESO Y CARTÍLAGO ARTICULAR DE MIEMBRO SUPERIOR DERECHO"
  },
  {
    "codigo":427317009,
    "descripcion":"PROTRUSIÓN MANDIBULAR NORMAL"
  },
  {
    "codigo":65034006,
    "descripcion":"RINOLITO"
  },
  {
    "codigo":32266007,
    "descripcion":"LEPTOSPIROSIS ANICTÉRICA"
  },
  {
    "codigo":718559000,
    "descripcion":"DISPLASIA ACROMESOMÉLICA TIPO MAROTEAUX"
  },
  {
    "codigo":390879000,
    "descripcion":"TREPONEMA PALLIDUM NO DETECTADO MEDIANTE ENSAYO DE INMUNOADSORCIÓN LIGADO A ENZIMAS"
  },
  {
    "codigo":1144543002,
    "descripcion":"HIPOPLASIA CONGÉNITA DE CONDUCTO CAROTÍDEO"
  },
  {
    "codigo":720394008,
    "descripcion":"FÍSTULA TRAQUEOBILIAR CONGÉNITA"
  },
  {
    "codigo":1275615004,
    "descripcion":"ROTURA DE RETINA"
  },
  {
    "codigo":126900000,
    "descripcion":"NEOPLASIA DE TESTÍCULO"
  },
  {
    "codigo":290740000,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR FLUDARABINA"
  },
  {
    "codigo":94132005,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA VALÉCULA"
  },
  {
    "codigo":716724006,
    "descripcion":"ATAXIA ESPINOCEREBELOSA TIPO 15\/16"
  },
  {
    "codigo":1306548008,
    "descripcion":"NEOPLASIA MALIGNA DE PORCIÓN CENTRAL DE MAMA"
  },
  {
    "codigo":419977003,
    "descripcion":"LEIOMIOMA COROIDEO"
  },
  {
    "codigo":92297008,
    "descripcion":"NEOPLASIA BENIGNA DE LA PLACENTA"
  },
  {
    "codigo":287070000,
    "descripcion":"FRACTURA PATOLÓGICA - TOBILLO\/PIE"
  },
  {
    "codigo":713054000,
    "descripcion":"TESTIGO DE CONSUMO INDEBIDO DE ALCOHOL POR PARTE DE UN ADULTO"
  },
  {
    "codigo":288905008,
    "descripcion":"DIFICULTAD PARA RETENER EL ALIMENTO EN LA BOCA"
  },
  {
    "codigo":1237342004,
    "descripcion":"SÍNDROME DE AGENESIA O HIPOPLASIA CEREBRORRENOGENITOURINARIA FETAL LETAL"
  },
  {
    "codigo":385374003,
    "descripcion":"ESTADIO DE LA FEDERACIÓN INTERNACIONAL DE GINECOLOGÍA Y OBSTETRICIA (FIGO) PARA TUMOR UTERINO - HALLAZGO"
  },
  {
    "codigo":186931002,
    "descripcion":"INFECCIÓN ANAL GONOCÓCICA"
  },
  {
    "codigo":88627003,
    "descripcion":"EFECTO TÓXICO DEL CROMO"
  },
  {
    "codigo":15982471000119100,
    "descripcion":"DEBILIDAD DE MÚSCULO FACIAL IZQUIERDO DEBIDA A HEMORRAGIA SUBARACNOIDEA INTRACRANEAL NO TRAUMÁTICA Y POSTERIOR A ELLA"
  },
  {
    "codigo":10642311000119101,
    "descripcion":"NECROSIS DE MÚSCULO DEL SACRO CONCOMITANTE CON ÚLCERA CRÓNICA DE SACRO Y DEBIDA A ELLA"
  },
  {
    "codigo":10629511000119102,
    "descripcion":"RINITIS DEL EMBARAZO"
  },
  {
    "codigo":1073031000119102,
    "descripcion":"ARTRITIS ESTAFILOCÓCICA DE PIE IZQUIERDO"
  },
  {
    "codigo":1085831000119104,
    "descripcion":"OBSTRUCCIÓN INTESTINAL DEBIDA A ENFERMEDAD DE CROHN DE INTESTINO DELGADO Y GRUESO"
  },
  {
    "codigo":16000391000119104,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DEBIDO A OCLUSIÓN DE ARTERIA CEREBRAL POSTERIOR DERECHA"
  },
  {
    "codigo":23431000119106,
    "descripcion":"RUPTURA DE ÚTERO DURANTE EL TRABAJO DE PARTO"
  },
  {
    "codigo":348551000119107,
    "descripcion":"EDEMA PERIORBITARIO DE OJO IZQUIERDO"
  },
  {
    "codigo":16018311000119108,
    "descripcion":"INESTABILIDAD DE ARTICULACIÓN DEL PIE DERECHO"
  },
  {
    "codigo":16041351000119108,
    "descripcion":"ARTRITIS IDIOPÁTICA JUVENIL DE INICIO SISTÉMICO DE RODILLA IZQUIERDA"
  },
  {
    "codigo":16302471000119107,
    "descripcion":"LESIÓN DE HUESO DE RADIO Y\/O CÚBITO DERECHOS"
  },
  {
    "codigo":148871000119109,
    "descripcion":"DEBILIDAD COMO EFECTO TARDÍO DE ACCIDENTE CEREBROVASCULAR"
  },
  {
    "codigo":15997831000119104,
    "descripcion":"DEFECTO DE CAPA DE FIBRAS NERVIOSAS DE RETINA IZQUIERDA"
  },
  {
    "codigo":285235009,
    "descripcion":"SECUELAS OCASIONADAS POR LESIONES DEL CUELLO Y TRONCO"
  },
  {
    "codigo":33671000119105,
    "descripcion":"DEFORMIDAD DE MANDÍBULA QUE AFECTA A LA CAVIDAD BUCAL"
  },
  {
    "codigo":10675591000119109,
    "descripcion":"ASMA ALÉRGICA PERSISTENTE SEVERA CONTROLADA"
  },
  {
    "codigo":18311000119109,
    "descripcion":"HIJO DE MADRE DIABÉTICA"
  },
  {
    "codigo":16002951000119109,
    "descripcion":"DOLOR EN AMBAS PIERNAS CONCOMITANTE CON ISQUEMIA Y DEBIDO A ELLA"
  },
  {
    "codigo":283400008,
    "descripcion":"CORTE EN LA CARA"
  },
  {
    "codigo":248797003,
    "descripcion":"ORGASMO SIN EXCITACIÓN PREVIA"
  },
  {
    "codigo":609245007,
    "descripcion":"VIVE EN CASA INDEPENDIENTE"
  },
  {
    "codigo":246962001,
    "descripcion":"PÉRDIDA DEL ESTROMA CENTRAL DE LA CÓRNEA"
  },
  {
    "codigo":281565009,
    "descripcion":"NEUROBLASTOMA PARAESPINAL"
  },
  {
    "codigo":410802003,
    "descripcion":"ARTRITIS IDIOPÁTICA JUVENIL, ARTRITIS INDIFERENCIADA"
  },
  {
    "codigo":1230002004,
    "descripcion":"ADENOMATOSIS HEPÁTICA"
  },
  {
    "codigo":771250005,
    "descripcion":"DERMATITIS COMO EFECTO TARDÍO DE RADIACIÓN"
  },
  {
    "codigo":212359000,
    "descripcion":"LESIÓN DE LOS NERVIOS Y LA MÉDULA ESPINAL LUMBAR A NIVEL DEL ABDOMEN, REGIÓN LUMBAR Y PELVIS"
  },
  {
    "codigo":1162631002,
    "descripcion":"PLACENTA BILOBULADA"
  },
  {
    "codigo":441735003,
    "descripcion":"TRASTORNO SENSITIVO COMO EFECTO TARDÍO DE ENFERMEDAD CEREBROVASCULAR"
  },
  {
    "codigo":277895009,
    "descripcion":"SÍNDROME DE GLUCOPROTEÍNA DEFICIENTE EN CARBOHIDRATOS, TIPO III"
  },
  {
    "codigo":13916005,
    "descripcion":"HERNIA CRURAL BILATERAL RECURRENTE CON GANGRENA Y OBSTRUCCIÓN"
  },
  {
    "codigo":1290033000,
    "descripcion":"TRASTORNO DE OJO DERECHO PROPIAMENTE DICHO"
  },
  {
    "codigo":1259100008,
    "descripcion":"ENFERMEDAD AUTOINMUNITARIA MOTORA Y SENSITIVA DE NERVIO"
  },
  {
    "codigo":112220008,
    "descripcion":"REFLEJO CORNEAL ANORMAL"
  },
  {
    "codigo":210524009,
    "descripcion":"LESIÓN POR DESOLLAMIENTO DE REGIÓN DE HOMBRO"
  },
  {
    "codigo":700209003,
    "descripcion":"VIVE EN UNA EMBARCACIÓN"
  },
  {
    "codigo":208689003,
    "descripcion":"FRACTURA NO EXPUESTA DE CUELLO DE METATARSIANO"
  },
  {
    "codigo":896817006,
    "descripcion":"FORMA DELGADA ANORMAL CONGÉNITA DE CÚBITO"
  },
  {
    "codigo":765745007,
    "descripcion":"ENFERMEDAD DE CHARCOT-MARIE-TOOTH AUTOSÓMICA DOMINANTE TIPO B"
  },
  {
    "codigo":1222662000,
    "descripcion":"ENCEFALOPATÍA EPILÉPTICA NEONATAL DEBIDA A DEFICIENCIA DE GLUTAMINASA"
  },
  {
    "codigo":403462002,
    "descripcion":"BALANITIS TRAUMÁTICA"
  },
  {
    "codigo":1255430002,
    "descripcion":"QUISTE DE ASTA POSTERIOR DE MENISCO EXTERNO DE RODILLA"
  },
  {
    "codigo":16058351000119104,
    "descripcion":"PLEXOPATÍA BRAQUIAL DE AMBOS MIEMBROS SUPERIORES"
  },
  {
    "codigo":237787007,
    "descripcion":"INSUFICIENCIA OVÁRICA POSQUIMIOTERAPIA"
  },
  {
    "codigo":41179007,
    "descripcion":"ERECCIÓN DE PENE AUMENTADA"
  },
  {
    "codigo":235952002,
    "descripcion":"PANCREATITIS CRÓNICA PRODUCIDA POR ALCOHOL"
  },
  {
    "codigo":39344002,
    "descripcion":"EROSIÓN AGUDA DEL DUODENO"
  },
  {
    "codigo":299653001,
    "descripcion":"PIE AMPUTADO"
  },
  {
    "codigo":203184009,
    "descripcion":"OSTEOMIELITIS CRÓNICA DE HOMBRO"
  },
  {
    "codigo":430725003,
    "descripcion":"SÍNDROME DE ESTRÉS ROTULOFEMORAL"
  },
  {
    "codigo":301488009,
    "descripcion":"NO DOBLA ESQUINAS"
  },
  {
    "codigo":365189008,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA SECARSE"
  },
  {
    "codigo":363354003,
    "descripcion":"NEOPLASIA MALIGNA DE CUELLO UTERINO"
  },
  {
    "codigo":232282006,
    "descripcion":"SÍNDROME DE MÉNIÈRE COCLEAR"
  },
  {
    "codigo":15931221000119100,
    "descripcion":"HEMORRAGIA DE QUISTE DE CUERPO LÚTEO IZQUIERDO"
  },
  {
    "codigo":295983000,
    "descripcion":"SOBREDOSIS DE METILFENOBARBITAL"
  },
  {
    "codigo":197679002,
    "descripcion":"ENFERMEDAD GLOMERULAR"
  },
  {
    "codigo":230447004,
    "descripcion":"CRISIS DE AUSENCIA CON MIOCLONÍA DE PÁRPADO"
  },
  {
    "codigo":33839006,
    "descripcion":"HERPES SIMPLE GENITAL"
  },
  {
    "codigo":164911006,
    "descripcion":"ONDA P ELECTROCARDIOGRÁFICA NORMAL"
  },
  {
    "codigo":427055009,
    "descripcion":"METALOSIS OCULAR NO FERROSA"
  },
  {
    "codigo":195844002,
    "descripcion":"PARÁLISIS DE CUERDAS VOCALES PARCIAL BILATERAL"
  },
  {
    "codigo":30169000,
    "descripcion":"SORDERA PSICÓGENA"
  },
  {
    "codigo":294148009,
    "descripcion":"ALERGIA A ISOAMINILO"
  },
  {
    "codigo":128473001,
    "descripcion":"UVEÍTIS"
  },
  {
    "codigo":95705001,
    "descripcion":"NÓDULOS DE IRIS EN BORDE PUPILAR"
  },
  {
    "codigo":423385005,
    "descripcion":"DIFICULTAD PARA ESTABLECER EL VÍNCULO CON EL NIÑO NO NACIDO"
  },
  {
    "codigo":1177049006,
    "descripcion":"INFECCIÓN CAUSADA POR LARVAS DE TRICHINELLA PAPUAE"
  },
  {
    "codigo":292313007,
    "descripcion":"REACCIÓN ADVERSA A LA VILOXAZINA"
  },
  {
    "codigo":93870000,
    "descripcion":"NEOPLASIA MALIGNA DE HÍGADO"
  },
  {
    "codigo":126638003,
    "descripcion":"NEOPLASIA DE LOS ÓRGANOS INTRATORÁCICOS"
  },
  {
    "codigo":716462005,
    "descripcion":"CAPAZ DE TRANSPORTAR ALIMENTOS Y BEBIDAS"
  },
  {
    "codigo":61102007,
    "descripcion":"ESCALA DEL COMA DE GLASGOW, 11"
  },
  {
    "codigo":124803004,
    "descripcion":"NIVEL DE 17-CETOSTEROIDES POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":288643008,
    "descripcion":"NO COMIENZA UNA CONVERSACIÓN"
  },
  {
    "codigo":188504001,
    "descripcion":"LINFOSARCOMA DE GANGLIOS LINFÁTICOS DE REGIÓN INGUINAL Y EXTREMIDAD INFERIOR"
  },
  {
    "codigo":92035009,
    "descripcion":"NEOPLASIA BENIGNA DE BRONQUIO DEL LÓBULO INFERIOR DERECHO DEL PULMÓN"
  },
  {
    "codigo":332221000119100,
    "descripcion":"QUERATITIS ESCLEROSANTE DE OJO DERECHO"
  },
  {
    "codigo":417880007,
    "descripcion":"HALLAZGO RELACIONADO CON LA AGUDEZA VISUAL DEL OJO DERECHO"
  },
  {
    "codigo":254040008,
    "descripcion":"ANOMALÍA SACROCOCCÍGEA CONGÉNITA"
  },
  {
    "codigo":1237080008,
    "descripcion":"FRACTURA TRAUMÁTICA DE MANDÍBULA"
  },
  {
    "codigo":24664007,
    "descripcion":"OVULACIÓN MÚLTIPLE"
  },
  {
    "codigo":219437004,
    "descripcion":"EFECTOS TARDÍOS DE LESIÓN POR OPERACIONES DE GUERRA"
  },
  {
    "codigo":448813005,
    "descripcion":"SEPSIS CAUSADA POR PSEUDOMONAS"
  },
  {
    "codigo":284973007,
    "descripcion":"CAPAZ DE VESTIRSE"
  },
  {
    "codigo":283138002,
    "descripcion":"CONTUSIÓN DE DORSO DEL PIE"
  },
  {
    "codigo":772823005,
    "descripcion":"ANTICUERPO ANTIPÉPTIDO CÍCLICO CITRULINADO DETECTADO"
  },
  {
    "codigo":445143008,
    "descripcion":"UTILIZA INTÉRPRETE PARA LECTURA DE LABIOS"
  },
  {
    "codigo":838359008,
    "descripcion":"LUPUS ERITEMATOSO CUTÁNEO AGUDO"
  },
  {
    "codigo":246700003,
    "descripcion":"DESVIACIÓN DURANTE EL MOVIMIENTO HORIZONTAL DE LOS OJOS"
  },
  {
    "codigo":1295276007,
    "descripcion":"SINOVITIS CRÓNICA DE RODILLA DEBIDA A HEMARTROSIS"
  },
  {
    "codigo":48257004,
    "descripcion":"ANARTRIA"
  },
  {
    "codigo":212097007,
    "descripcion":"QUEMADURA QUE COMPROMETE 70-79 PORCIENTO DE LA SUPERFICIE DEL CUERPO, CON QUEMADURA DE ESPESOR COMPLETO QUE AFECTA 30-39 PORCIENTO DE LA SUPERFICIE CORPORAL"
  },
  {
    "codigo":111958000,
    "descripcion":"SIGNO DE KEHR"
  },
  {
    "codigo":10817981000119109,
    "descripcion":"FRACTURA MEDIOCERVICAL EXPUESTA DE FÉMUR DERECHO"
  },
  {
    "codigo":243030005,
    "descripcion":"LESIÓN POR ESTALLIDO DE GRANADA DE MANO"
  },
  {
    "codigo":210262008,
    "descripcion":"LESIÓN TRAUMÁTICA DEL PERITONEO CON HERIDA ABIERTA HACIA CAVIDAD"
  },
  {
    "codigo":77355000,
    "descripcion":"TRASTORNO MENTAL ORGÁNICO INDUCIDO POR CANNABIS"
  },
  {
    "codigo":46422008,
    "descripcion":"FRACTURA CERRADA DE LA DIÁFISIS DE HUESO METACARPIANO"
  },
  {
    "codigo":110123005,
    "descripcion":"AVULSIÓN DE LA ENCÍA ALVEOLAR DEL MAXILAR SUPERIOR"
  },
  {
    "codigo":208427007,
    "descripcion":"FRACTURA NO EXPUESTA DE HUESO SESAMOIDEO DE LA MANO"
  },
  {
    "codigo":9984005,
    "descripcion":"EXFOLIACIÓN DE DIENTES POR ENFERMEDAD SISTÉMICA"
  },
  {
    "codigo":403200005,
    "descripcion":"QUERATOSIS ACTÍNICA ATRÓFICA"
  },
  {
    "codigo":1255168008,
    "descripcion":"EDEMA DE MUÑÓN DE AMPUTACIÓN DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":304896009,
    "descripcion":"COMPLEJO DE ANGUSTIA POR CASTRACIÓN"
  },
  {
    "codigo":303061003,
    "descripcion":"ABSCESO PIÓGENO CEREBELOSO"
  },
  {
    "codigo":40917007,
    "descripcion":"CONFUSIÓN"
  },
  {
    "codigo":202922000,
    "descripcion":"TENOSINOVITIS DEL MÚSCULO PERONEO LATERAL LARGO"
  },
  {
    "codigo":268458002,
    "descripcion":"UTILIZA ANTICONCEPTIVO ORAL COMBINADO"
  },
  {
    "codigo":1251498002,
    "descripcion":"METÁSTASIS DE SARCOMA EN RETROPERITONEO"
  },
  {
    "codigo":71850005,
    "descripcion":"DOLOR ABDOMINAL QUE EMPEORA CON EL MOVIMIENTO"
  },
  {
    "codigo":235690005,
    "descripcion":"ÚLCERA DE CURLING DE DUODENO"
  },
  {
    "codigo":170154007,
    "descripcion":"EXAMEN PEDIÁTRICO A LOS 3,5 AÑOS: NORMAL"
  },
  {
    "codigo":301226008,
    "descripcion":"HALLAZGO EN VÍAS RESPIRATORIAS INFERIORES"
  },
  {
    "codigo":397695000,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD DE CUMPLIR CON EL TRATAMIENTO"
  },
  {
    "codigo":233855002,
    "descripcion":"MIXOMA AURICULAR FAMILIAR"
  },
  {
    "codigo":364927002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA INCLINARSE"
  },
  {
    "codigo":168319009,
    "descripcion":"ORGANISMO AISLADO EN CULTIVO DE MATERIA FECAL"
  },
  {
    "codigo":299391009,
    "descripcion":"PRUEBA DE MCMURRAY POSITIVA"
  },
  {
    "codigo":166484003,
    "descripcion":"PRUEBA DE FUNCIÓN HIPOFISARIA FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":16909041000119106,
    "descripcion":"HIDROCISTOMA APOCRINO DE PÁRPADO SUPERIOR DERECHO"
  },
  {
    "codigo":363092007,
    "descripcion":"TRASTORNO RELACIONADO CON LA VITAMINA E"
  },
  {
    "codigo":461396007,
    "descripcion":"CIERRE FUNCIONAL DE CONDUCTO ARTERIOSO PRESENTE"
  },
  {
    "codigo":232020009,
    "descripcion":"TRASTORNO DE LA MÁCULA DEBIDO A DIABETES MELLITUS"
  },
  {
    "codigo":721705006,
    "descripcion":"HEMORROIDES INTERNAS, GRADO III"
  },
  {
    "codigo":66345008,
    "descripcion":"AUSENCIA CONGÉNITA DE DEDO DE PIE"
  },
  {
    "codigo":230185008,
    "descripcion":"ENCEFALITIS AMÉBICA"
  },
  {
    "codigo":11803531000119102,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA PROXIMAL DE DEDO DE MANO IZQUIERDA"
  },
  {
    "codigo":31742004,
    "descripcion":"DISPLASIA ARTERIOHEPÁTICA"
  },
  {
    "codigo":293886005,
    "descripcion":"ALERGIA A FLUNITRAZEPAM"
  },
  {
    "codigo":424958004,
    "descripcion":"TEMOR A LA REACCIÓN EN RELACIÓN CON LAS ELECCIONES DE PLANIFICACIÓN FAMILIAR"
  },
  {
    "codigo":228350009,
    "descripcion":"TOLERANCIA CONDUCTUAL AL ALCOHOL"
  },
  {
    "codigo":95443002,
    "descripcion":"CLAUDICACIÓN VENOSA INTERMITENTE"
  },
  {
    "codigo":334731000119104,
    "descripcion":"EXOTROPÍA MONOCULAR INTERMITENTE DE OJO DERECHO"
  },
  {
    "codigo":292051004,
    "descripcion":"REACCIÓN ADVERSA A LA DIPIPANONA"
  },
  {
    "codigo":423123007,
    "descripcion":"QUEMADURA CAUSADA POR FUEGO"
  },
  {
    "codigo":128211008,
    "descripcion":"SÍNDROME DE ABERTURA DE SALIDA TORÁCICA VASCULAR"
  },
  {
    "codigo":716200002,
    "descripcion":"SÍNDROME DE RESISTENCIA A ARGININA VASOPRESINA, CALCIFICACIÓN INTRACRANEAL, BAJA ESTATURA Y DISMORFISMO FACIAL"
  },
  {
    "codigo":880040003,
    "descripcion":"MIOCARDIOPATÍA ARRITMOGÉNICA DEL VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":28072004,
    "descripcion":"OREJA DE COLIFLOR"
  },
  {
    "codigo":191912005,
    "descripcion":"PATRÓN DE USO NOCIVO CONTINUO DE OPIOIDE SIN DEPENDENCIA"
  },
  {
    "codigo":26237000,
    "descripcion":"EDEMA DE TOBILLO"
  },
  {
    "codigo":93608009,
    "descripcion":"OSIFICACIÓN INCOMPLETA DE TIBIA"
  },
  {
    "codigo":290216009,
    "descripcion":"INTOXICACIÓN POR LEVORFANOL"
  },
  {
    "codigo":124541003,
    "descripcion":"DEFICIENCIA DE ÉSTER CARBOXÍLICO HIDROLASA"
  },
  {
    "codigo":712530006,
    "descripcion":"ARTRITIS BACTERIANA DE ARTICULACIÓN COSTOVERTEBRAL"
  },
  {
    "codigo":188242006,
    "descripcion":"NEOPLASIA MALIGNA DE LA PARED ANTERIOR DE LA VEJIGA URINARIA"
  },
  {
    "codigo":448551000,
    "descripcion":"LEIOMIOMA DE YEYUNO"
  },
  {
    "codigo":253778009,
    "descripcion":"TRASTORNO FUNCIONAL CONGÉNITO DEL COLON"
  },
  {
    "codigo":778066006,
    "descripcion":"FIBROCARCINOMA DE CUERPO UTERINO"
  },
  {
    "codigo":88103004,
    "descripcion":"ONICOAUXIA CONGÉNITA"
  },
  {
    "codigo":22567005,
    "descripcion":"SÍNDROME DE DISPLASIA ESPONDILOEPIFISARIA SEUDOACONDROPLÁSICA"
  },
  {
    "codigo":250108003,
    "descripcion":"INESTABILIDAD DEL LIGAMENTO CRUZADO POSTERIOR"
  },
  {
    "codigo":282876004,
    "descripcion":"CAPAZ DE PARARSE SOLO"
  },
  {
    "codigo":86268005,
    "descripcion":"ACONDROPLASIA"
  },
  {
    "codigo":1003772006,
    "descripcion":"FLORA NORMAL DE FARINGE"
  },
  {
    "codigo":1296849005,
    "descripcion":"TUMOR DE BRENNER BENIGNO DE OVARIO"
  },
  {
    "codigo":51665005,
    "descripcion":"FACIES BOVINA"
  },
  {
    "codigo":1264081007,
    "descripcion":"VENA CAVA SUPERIOR IZQUIERDA PERSISTENTE QUE CONECTA CON AURÍCULA IZQUIERDA A TRAVÉS DE SENO CORONARIO"
  },
  {
    "codigo":15954981000119108,
    "descripcion":"PTOSIS DE MAMA IZQUIERDA"
  },
  {
    "codigo":49830003,
    "descripcion":"HIPOTIROIDISMO CAUSADO POR SUSTANCIAS ALIMENTARIAS"
  },
  {
    "codigo":770726004,
    "descripcion":"INFERTILIDAD FEMENINA POR DEFECTO DE LA ZONA PELÚCIDA"
  },
  {
    "codigo":82598004,
    "descripcion":"HIPOTIROIDISMO SECUNDARIO"
  },
  {
    "codigo":211835001,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO SUPERFICIAL DE CODO"
  },
  {
    "codigo":703355003,
    "descripcion":"HIPERTENSIÓN PULMONAR DEBIDA A VASCULITIS"
  },
  {
    "codigo":308872007,
    "descripcion":"DISPLASIA MODERADA DE COLON"
  },
  {
    "codigo":11832511000119105,
    "descripcion":"LACERACIÓN DE VASO SANGUÍNEO DE MEÑIQUE IZQUIERDO"
  },
  {
    "codigo":111696001,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA VENA FEMORAL"
  },
  {
    "codigo":406608004,
    "descripcion":"INFECCIÓN CAUSADA POR STAPHYLOCOCCUS EPIDERMIDIS"
  },
  {
    "codigo":1356880008,
    "descripcion":"LESIÓN INTRACRANEAL LOCALIZADA"
  },
  {
    "codigo":699685006,
    "descripcion":"SURCO OCLUSAL PROFUNDO"
  },
  {
    "codigo":372005006,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL PENE"
  },
  {
    "codigo":1254906000,
    "descripcion":"NEOPLASIA IN SITU DE PIEL"
  },
  {
    "codigo":109861009,
    "descripcion":"ENDOMETRIOSIS DE CORDÓN ESPERMÁTICO POSTERIOR A TERAPIA ESTROGÉNICA"
  },
  {
    "codigo":765221009,
    "descripcion":"XANTOMA PAPULAR"
  },
  {
    "codigo":1287674002,
    "descripcion":"CONVULSIÓN EPILÉPTICA DE LÓBULO TEMPORAL MESIAL"
  },
  {
    "codigo":75258004,
    "descripcion":"INTOXICACIÓN POR ALIMENTOS"
  },
  {
    "codigo":44325009,
    "descripcion":"SIGNOS ELECTROCARDIOGRÁFICOS DE FUERZAS VENTRICULARES DERECHAS DISMINUIDAS"
  },
  {
    "codigo":270031000,
    "descripcion":"ESPUTO: CONTIENE SANGRE"
  },
  {
    "codigo":1187535000,
    "descripcion":"DEFICIENCIA DE TIMIDINA CINASA 2"
  },
  {
    "codigo":239098009,
    "descripcion":"ACROPUSTULOSIS DEL LACTANTE"
  },
  {
    "codigo":402938009,
    "descripcion":"INFECCIÓN ESTAFILOCÓCICA DE LA PIEL"
  },
  {
    "codigo":73423000,
    "descripcion":"ESTOMATITIS VESICULAR POR VIRUS ALAGOAS"
  },
  {
    "codigo":169892001,
    "descripcion":"TALLA AL NACER = ENTRE PERCENTILOS 75 Y 89"
  },
  {
    "codigo":366500005,
    "descripcion":"HALLAZGO RELACIONADO CON LA AMPLITUD DE MOVIMIENTO PASIVO DE EXTENSIÓN HORIZONTAL DE HOMBRO"
  },
  {
    "codigo":397433001,
    "descripcion":"COLAPSO TRAQUEAL CONGÉNITO"
  },
  {
    "codigo":102521002,
    "descripcion":"EDAD MENOR DE 25 AÑOS"
  },
  {
    "codigo":36985004,
    "descripcion":"ALTERACIÓN HEREDITARIA DEL METABOLISMO TIROIDEO"
  },
  {
    "codigo":266361008,
    "descripcion":"ASMA NO ALÉRGICA"
  },
  {
    "codigo":1074521000119109,
    "descripcion":"ARTROSIS DE PIE DERECHO DEBIDA A TRAUMATISMO"
  },
  {
    "codigo":197155003,
    "descripcion":"FÍSTULA INTERESFINTERIANA"
  },
  {
    "codigo":721443005,
    "descripcion":"SÍNDROME DEL CORDÓN CENTRAL DE MÉDULA ESPINAL AL NIVEL DEL PRIMER SEGMENTO DORSAL"
  },
  {
    "codigo":547009,
    "descripcion":"HIPERSECRECIÓN DE CALCITONINA"
  },
  {
    "codigo":262691009,
    "descripcion":"LACERACIÓN DEL CEREBRO"
  },
  {
    "codigo":129784002,
    "descripcion":"POSICIÓN SUBAREOLAR EN LA MAMOGRAFÍA"
  },
  {
    "codigo":162552006,
    "descripcion":"FRECUENCIA IRREGULAR DE LAS COMIDAS"
  },
  {
    "codigo":293624008,
    "descripcion":"ALERGIA A NABUMETONA"
  },
  {
    "codigo":95181001,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LAS CUERDAS VOCALES"
  },
  {
    "codigo":556301811000119107,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE ESPACIO EXTRAMEDULAR INTRADURAL ESPINAL"
  },
  {
    "codigo":195320009,
    "descripcion":"EMBOLIA Y TROMBOSIS DE LA ARTERIA RADIAL"
  },
  {
    "codigo":717773005,
    "descripcion":"TRASTORNO CONGÉNITO DE LA GLICOSILACIÓN POR ALTERACIÓN DE COG7"
  },
  {
    "codigo":27810000,
    "descripcion":"NEFRITIS TUBULOINTERSTICIAL AGUDA VIRAL"
  },
  {
    "codigo":781474001,
    "descripcion":"TRASTORNO ALÉRGICO"
  },
  {
    "codigo":160717008,
    "descripcion":"PAREJA DIVORCIADA QUE COMPARTE LA VIVIENDA"
  },
  {
    "codigo":93346007,
    "descripcion":"POSICIÓN ANÓMALA CONGÉNITA DEL PUBIS"
  },
  {
    "codigo":224418007,
    "descripcion":"SIN INSTALACIONES PARA LAVADO DE MANOS EN EL TRABAJO"
  },
  {
    "codigo":714103006,
    "descripcion":"ENFERMEDAD GINGIVAL DEBIDA AL CICLO MENSTRUAL"
  },
  {
    "codigo":189815007,
    "descripcion":"BLASTOMA PULMONAR"
  },
  {
    "codigo":124279007,
    "descripcion":"DEFICIENCIA DE NICOTINAMIDA FOSFORRIBOSILTRANSFERASA"
  },
  {
    "codigo":1303927008,
    "descripcion":"GLAUCOMA DE ÁNGULO ABIERTO SECUNDARIO DE OJO DERECHO"
  },
  {
    "codigo":253516002,
    "descripcion":"ANOMALÍA DEL VENTRÍCULO DERECHO"
  },
  {
    "codigo":24140005,
    "descripcion":"QUISTE MANDIBULAR MEDIANO"
  },
  {
    "codigo":286284009,
    "descripcion":"NO USA CLICS AL HABLAR"
  },
  {
    "codigo":284449005,
    "descripcion":"LIPODISTROFIA TOTAL CONGÉNITA"
  },
  {
    "codigo":87841007,
    "descripcion":"INTOXICACIÓN POR METILOXIDEMETONA"
  },
  {
    "codigo":15931021000119108,
    "descripcion":"SARCOMA PRIMARIO DE OVARIO IZQUIERDO"
  },
  {
    "codigo":86006001,
    "descripcion":"RUPTURA MASIVA DE PARÉNQUIMA DE BAZO SIN HERIDA ABIERTA HACIA CAVIDAD ABDOMINAL"
  },
  {
    "codigo":12071000119102,
    "descripcion":"ESPONDILÓLISIS ADQUIRIDA DE COLUMNA VERTEBRAL LUMBAR"
  },
  {
    "codigo":315382006,
    "descripcion":"NACIDO EN BELICE"
  },
  {
    "codigo":774134007,
    "descripcion":"DOLOR EN EL OMÓPLATO DERECHO"
  },
  {
    "codigo":282614008,
    "descripcion":"CAPAZ DE ARRASTRAR LOS PIES"
  },
  {
    "codigo":1003510009,
    "descripcion":"AGENESIA DE MANO"
  },
  {
    "codigo":15986471000119104,
    "descripcion":"ANOMALÍA CONGÉNITA DE RETINA DE OJO DERECHO"
  },
  {
    "codigo":1362123005,
    "descripcion":"DOLICOSTENOMELIA"
  },
  {
    "codigo":16800004,
    "descripcion":"INTOXICACIÓN POR TRISILICATO DE MAGNESIO"
  },
  {
    "codigo":442784009,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR SUSTANCIA GASEOSA"
  },
  {
    "codigo":410016009,
    "descripcion":"LIPODERMATOSCLEROSIS"
  },
  {
    "codigo":211573006,
    "descripcion":"LESIÓN TRAUMÁTICA CERRADA POR APLASTAMIENTO DE LA MUÑECA, PALMAR"
  },
  {
    "codigo":735861009,
    "descripcion":"MÚLTIPLES LESIONES TRAUMÁTICAS SUPERFICIALES DE TOBILLO"
  },
  {
    "codigo":209738003,
    "descripcion":"SECCIÓN EXPUESTA DE LIGAMENTO DE LA REGIÓN TIROIDEA"
  },
  {
    "codigo":373578005,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM PARATUBERCULOSIS"
  },
  {
    "codigo":734026006,
    "descripcion":"MEGALOCÓRNEA CONGÉNITA AISLADA"
  },
  {
    "codigo":275274007,
    "descripcion":"INFECCIÓN DE PRÓTESIS"
  },
  {
    "codigo":764959000,
    "descripcion":"SÍNDROME DE DISCAPACIDAD INTELECTUAL, MIOPATÍA, BAJA ESTATURA Y DEFECTO ENDOCRINO"
  },
  {
    "codigo":207903001,
    "descripcion":"FRACTURA NO EXPUESTA DE VÉRTEBRA CERVICAL, ESTALLIDO"
  },
  {
    "codigo":240671002,
    "descripcion":"SINOVITIS EROSIVA DE LYME"
  },
  {
    "codigo":109599007,
    "descripcion":"PULPITIS REVERSIBLE"
  },
  {
    "codigo":238836000,
    "descripcion":"EPIDERMÓLISIS BULLOSA DE KINDLER"
  },
  {
    "codigo":76831009,
    "descripcion":"ALTERACIÓN EN EL TRANSPORTE LINFÁTICO INTESTINAL DE NUTRIENTES"
  },
  {
    "codigo":402676001,
    "descripcion":"TRASTORNO DE VASOCONSTRICCIÓN DE LAS EXTREMIDADES"
  },
  {
    "codigo":173300003,
    "descripcion":"TRASTORNO DEL EMBARAZO"
  },
  {
    "codigo":404511008,
    "descripcion":"BACILOS GRAMPOSITIVOS GRANDES"
  },
  {
    "codigo":699423008,
    "descripcion":"HIPEROCLUSIÓN"
  },
  {
    "codigo":1156340006,
    "descripcion":"ENCEFALOPATÍA TÓXICA CAUSADA POR MONOMETIL MERCURIO"
  },
  {
    "codigo":42228007,
    "descripcion":"ACNÉ CONGLOBADA"
  },
  {
    "codigo":1285577000,
    "descripcion":"BOTULISMO INTESTINAL DEL ADULTO"
  },
  {
    "codigo":269769006,
    "descripcion":"HERIDA ACCIDENTAL EN INTERVENCIÓN QUIRÚRGICA"
  },
  {
    "codigo":73161006,
    "descripcion":"POSICIÓN TRANSVERSA DEL FETO"
  },
  {
    "codigo":300702001,
    "descripcion":"EXTIENDE CHEQUES"
  },
  {
    "codigo":298867000,
    "descripcion":"ARTICULACIÓN DE HOMBRO FRÍA AL TACTO"
  },
  {
    "codigo":366238008,
    "descripcion":"SUSCEPTIBILIDAD A LAS CARIES - HALLAZGO"
  },
  {
    "codigo":267934008,
    "descripcion":"ANQUILOSIS DE ARTICULACIÓN DE PELVIS Y\/O CADERA"
  },
  {
    "codigo":724851004,
    "descripcion":"FRAGILIDAD CUTÁNEA HEREDITARIA"
  },
  {
    "codigo":167795004,
    "descripcion":"MORFOLOGÍA DE LOS ESPERMATOZOIDES - MUY BAJA: MENOS DE 30% NORMALES"
  },
  {
    "codigo":428104002,
    "descripcion":"ARTRITIS DE ARTICULACIÓN MEDIOTARSIANA"
  },
  {
    "codigo":2120003,
    "descripcion":"LLANTO DÉBIL"
  },
  {
    "codigo":723016004,
    "descripcion":"EXCORIACIÓN AGUDA DE PIEL"
  },
  {
    "codigo":231496004,
    "descripcion":"HIPOMANÍA"
  },
  {
    "codigo":67656006,
    "descripcion":"PIEMIA PORTAL"
  },
  {
    "codigo":721181006,
    "descripcion":"EDEMA LOCALIZADO DEBIDO A SOBRECARGA DE LÍQUIDO"
  },
  {
    "codigo":360733009,
    "descripcion":"DEFICIENCIA DE HIDROLASA DE ACETIL COA"
  },
  {
    "codigo":31218002,
    "descripcion":"LINFANGITIS AGUDA DE TOBILLO"
  },
  {
    "codigo":63986002,
    "descripcion":"HERNIACIÓN DEL TRONCO ENCEFÁLICO"
  },
  {
    "codigo":293362004,
    "descripcion":"REACCIÓN ADVERSA AL GLUCONATO FERROSO"
  },
  {
    "codigo":162290004,
    "descripcion":"SEQUEDAD OCULAR"
  },
  {
    "codigo":295197009,
    "descripcion":"SOBREDOSIS DE MEPERIDINA"
  },
  {
    "codigo":719346001,
    "descripcion":"CAPAZ DE PONERSE DE PIE DESDE UNA SILLA AL PRIMER INTENTO"
  },
  {
    "codigo":422599000,
    "descripcion":"CARCINOMA ESCAMOCELULAR DEL DORSO"
  },
  {
    "codigo":94919001,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE HUESO SEMILUNAR"
  },
  {
    "codigo":291527000,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR DERIVADO DE NITROFURANO"
  },
  {
    "codigo":62151007,
    "descripcion":"HIPOGLUCEMIA INDUCIDA POR LEUCINA"
  },
  {
    "codigo":289692005,
    "descripcion":"ÚTERO GRÁVIDO DESVIADO HACIA LA DERECHA"
  },
  {
    "codigo":191388008,
    "descripcion":"METAHEMOGLOBINEMIA FAMILIAR"
  },
  {
    "codigo":93084009,
    "descripcion":"FENESTRACIÓN CONGÉNITA DE HUESO NASAL"
  },
  {
    "codigo":420764009,
    "descripcion":"INFECCIÓN POR SALMONELLA ASOCIADA CON SIDA"
  },
  {
    "codigo":1172593006,
    "descripcion":"SÍNDROME DE ATROFIA CEREBRAL DIFUSA PROGRESIVA DE INICIO TEMPRANO, MICROCEFALIA, DEBILIDAD MUSCULAR Y ATROFIA ÓPTICA"
  },
  {
    "codigo":232072004,
    "descripcion":"MANCHA DE FORSTER-FUCH"
  },
  {
    "codigo":124017007,
    "descripcion":"METAHEMALBÚMINA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":91249009,
    "descripcion":"CONDUCTA CRIMINAL"
  },
  {
    "codigo":89414003,
    "descripcion":"YODODERMIA"
  },
  {
    "codigo":253254003,
    "descripcion":"OREJA AZTECA"
  },
  {
    "codigo":286022003,
    "descripcion":"INCAPAZ DE PONER UN ENCHUFE ELÉCTRICO EN UN TOMACORRIENTE"
  },
  {
    "codigo":417094009,
    "descripcion":"ESCLEROSIS VALVULAR"
  },
  {
    "codigo":448027004,
    "descripcion":"ESTENOSIS SUPRAVALVULAR DE TRONCO PULMONAR"
  },
  {
    "codigo":22043005,
    "descripcion":"TRASTORNO NO INFLAMATORIO DEL ÚTERO"
  },
  {
    "codigo":184048005,
    "descripcion":"REGISTRO DEL PACIENTE - FORMULARIO EMPLEADO"
  },
  {
    "codigo":52976009,
    "descripcion":"CÉLULA SENSIBILIZADA"
  },
  {
    "codigo":247749002,
    "descripcion":"ALUCINACIONES TÁCTILES DISOCIATIVAS"
  },
  {
    "codigo":1263557003,
    "descripcion":"LESIÓN DE NERVIO OCCIPITAL MAYOR"
  },
  {
    "codigo":870341003,
    "descripcion":"GRANULOMA DE MÉDULA ESPINAL CAUSADO POR PARÁSITO"
  },
  {
    "codigo":82074004,
    "descripcion":"LESIONES ACRÓMICAS DE LA PIEL PROVOCADAS POR PINTA"
  },
  {
    "codigo":16538005,
    "descripcion":"PUERPERIO INMEDIATO"
  },
  {
    "codigo":278682004,
    "descripcion":"LÍNEA MEDIA DENTAL COINCIDENTE E INCORRECTA"
  },
  {
    "codigo":704666008,
    "descripcion":"STREPTOCOCCUS DEL GRUPO B, NO AISLADO"
  },
  {
    "codigo":473455001,
    "descripcion":"TRASTORNO DE VÁLVULA AURICULOVENTRICULAR DERECHA (MORFOLÓGICAMENTE NO TRICÚSPIDE)"
  },
  {
    "codigo":211311003,
    "descripcion":"CUERPO EXTRAÑO EN LA MANO"
  },
  {
    "codigo":735599007,
    "descripcion":"ARTRITIS REUMATOIDE CON EROSIÓN DE ARTICULACIÓN"
  },
  {
    "codigo":309615009,
    "descripcion":"PROBLEMA INTESTINAL"
  },
  {
    "codigo":45636002,
    "descripcion":"DEDO GORDO EN MARTILLO, ADQUIRIDO"
  },
  {
    "codigo":209476005,
    "descripcion":"ESGUINCE DE PULGAR, ARTICULACIÓN INTERFALÁNGICA, LIGAMENTO LATERAL CUBITAL"
  },
  {
    "codigo":344771000119100,
    "descripcion":"PERIOSTITIS DE AMBAS ÓRBITAS"
  },
  {
    "codigo":1354521001,
    "descripcion":"COLANGIOCARCINOMA PRIMARIO DE CONDUCTO BILIAR PERIHILIAR"
  },
  {
    "codigo":764697003,
    "descripcion":"SÍNDROME DE VERLOOVE VANHORICK BRUBAKK"
  },
  {
    "codigo":109337006,
    "descripcion":"OSTEORRADIONECROSIS DE HUESO ESFENOIDES"
  },
  {
    "codigo":371481006,
    "descripcion":"NEOPLASIA DE REGIÓN OCULAR"
  },
  {
    "codigo":76569007,
    "descripcion":"ANTIDIURESIS"
  },
  {
    "codigo":11033009,
    "descripcion":"SIGNO DE COURVOISIER"
  },
  {
    "codigo":402414002,
    "descripcion":"REACCIÓN URTICARIANA A HEMODERIVADO"
  },
  {
    "codigo":240409007,
    "descripcion":"REACCIÓN DE LEPRA TIPO 1, CLASIFICACIÓN DESCENDENTE"
  },
  {
    "codigo":369646000,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA DEL CUELLO DEL ÚTERO, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":105667002,
    "descripcion":"ENFERMEDAD CAUSADA POR GASTRODISCOIDES"
  },
  {
    "codigo":72899006,
    "descripcion":"ABSCESO DE LA CARA EXTERNA DE LA MEJILLA"
  },
  {
    "codigo":302275007,
    "descripcion":"CAPAZ DE TRASLADARSE DE LA SILLA DE RUEDAS AL INODORO"
  },
  {
    "codigo":236739009,
    "descripcion":"TRASTORNO DE LA ANASTOMOSIS UROLÓGICA"
  },
  {
    "codigo":300440002,
    "descripcion":"RIÑÓN PRESENTE"
  },
  {
    "codigo":365976003,
    "descripcion":"USO DE ESTRATEGIAS PARA CONTROLAR EL HÁBITO DE BEBER - HALLAZGO"
  },
  {
    "codigo":267672001,
    "descripcion":"PERFORACIÓN DE MEMBRANA TIMPÁNICA - SUPERIOR AL 50%"
  },
  {
    "codigo":38296007,
    "descripcion":"ANOMALÍA CONGÉNITA DE OVARIO"
  },
  {
    "codigo":71064009,
    "descripcion":"POLIQUISTOSIS RENAL ADQUIRIDA"
  },
  {
    "codigo":724589004,
    "descripcion":"NEOPLASIA OSTEÓGENA BENIGNA DE CARTÍLAGO ARTICULAR DE ESTERNÓN"
  },
  {
    "codigo":396909006,
    "descripcion":"ESTADIO IIA: INVASIÓN MICROSCÓPICA TRANSCAPSULAR (TIMO)"
  },
  {
    "codigo":298605008,
    "descripcion":"SIN FLEXIÓN ACTIVA DE LA COLUMNA LUMBAR"
  },
  {
    "codigo":460610001,
    "descripcion":"INSERCIÓN ANÓMALA DE CONDUCTO ARTERIOSO EN TRONCO PULMONAR"
  },
  {
    "codigo":67394003,
    "descripcion":"FRACTURA DE DIÁFISIS DE PERONÉ"
  },
  {
    "codigo":1148738004,
    "descripcion":"COMPRESIÓN DE ASTA INFERIOR DEL VENTRÍCULO LATERAL"
  },
  {
    "codigo":296770003,
    "descripcion":"SOBREDOSIS DE CLORANFENICOL"
  },
  {
    "codigo":788290007,
    "descripcion":"HEMANGIOMA DE PIEL DURANTE EL EMBARAZO"
  },
  {
    "codigo":131095006,
    "descripcion":"NIVEL DE TRIYODOTIRONINA POR ENCIMA DE RANGO DE REFERENCIA"
  },
  {
    "codigo":1343511009,
    "descripcion":"SÍNDROME DE CORDÓN POSTERIOR DEBIDO A ATAXIA DE FRIEDREICH"
  },
  {
    "codigo":162028008,
    "descripcion":"SIN INDIGESTIÓN"
  },
  {
    "codigo":422337001,
    "descripcion":"COCCIDIOIDOMICOSIS CON SIDA (SÍNDROME DE INMUNODEFICIENCIA ADQUIRIDA)"
  },
  {
    "codigo":782785002,
    "descripcion":"OSTEOPOROSIS LIGADA AL CROMOSOMA X CON FRACTURAS"
  },
  {
    "codigo":94657004,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL TERCIO SUPERIOR DEL ESÓFAGO"
  },
  {
    "codigo":1010326003,
    "descripcion":"EXTENSIÓN DE LADO DERECHO DE COLUMNA VERTEBRAL SACRA"
  },
  {
    "codigo":92822004,
    "descripcion":"FISURA DE MANDÍBULA"
  },
  {
    "codigo":125590005,
    "descripcion":"LESIÓN TRAUMÁTICA DEL ÁRBOL TRAQUEOBRONQUIAL"
  },
  {
    "codigo":27286006,
    "descripcion":"PENE CAUTIVO"
  },
  {
    "codigo":1336171000,
    "descripcion":"SARCOMA SINOVIAL METASTÁSICO"
  },
  {
    "codigo":289430009,
    "descripcion":"HALLAZGO RELACIONADO CON LAS MEDIDAS FETALES"
  },
  {
    "codigo":715414009,
    "descripcion":"NEOPLASIA MALIGNA DE PÁNCREAS FAMILIAR"
  },
  {
    "codigo":90987003,
    "descripcion":"INCONTINENCIA REFLEJA"
  },
  {
    "codigo":254827004,
    "descripcion":"TUMOR LIPOMATOSO"
  },
  {
    "codigo":25451005,
    "descripcion":"RIGIDEZ ABDOMINAL TIPO TABLA"
  },
  {
    "codigo":123755001,
    "descripcion":"PIELONEFRITIS DIFUSA"
  },
  {
    "codigo":56384000,
    "descripcion":"EMBOLIA DE SENO SAGITAL INFERIOR"
  },
  {
    "codigo":58219009,
    "descripcion":"LACTANCIA ANORMAL"
  },
  {
    "codigo":418667009,
    "descripcion":"ASUNTOS RELACIONADOS CON LA PROGRAMACIÓN DE PROCEDIMIENTOS"
  },
  {
    "codigo":30091000175105,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN EN TOBILLO DERECHO ESTADIO I"
  },
  {
    "codigo":189291009,
    "descripcion":"CARCINOMA IN SITU DE LA PIEL DE CUELLO Y CUERO CABELLUDO"
  },
  {
    "codigo":285760008,
    "descripcion":"AGNOSIA DE POSICIÓN"
  },
  {
    "codigo":54549000,
    "descripcion":"PERIOSTITIS HIPERTRÓFICA EN LA FRAMBESIA"
  },
  {
    "codigo":449600009,
    "descripcion":"FIJACIÓN ANÓMALA DEL TABIQUE INTERAURICULAR A CARA SUPERIOR DE SEPTUM PRIMUM A LA IZQUIERDA Y ATRÁS"
  },
  {
    "codigo":87317003,
    "descripcion":"PARO RESPIRATORIO"
  },
  {
    "codigo":447765004,
    "descripcion":"PAPILOMA DE VEJIGA INVERTIDO"
  },
  {
    "codigo":1332501005,
    "descripcion":"COMPRESIÓN DE NERVIO GENITOFEMORAL DERECHO"
  },
  {
    "codigo":14040001000004109,
    "descripcion":"DOLOR NO CONTROLADO"
  },
  {
    "codigo":347281000119102,
    "descripcion":"EPITELIOPATÍA PIGMENTARIA PLACOIDE MULTIFOCAL AGUDA DE AMBOS OJOS"
  },
  {
    "codigo":251157009,
    "descripcion":"TAQUICARDIA VENTRICULAR CON COMPLEJO QRS ESTRECHO"
  },
  {
    "codigo":183786002,
    "descripcion":"INSCRIPTO EN LISTA DE ADMISIÓN ORTOPÉDICA"
  },
  {
    "codigo":118250006,
    "descripcion":"VOZ - HALLAZGO"
  },
  {
    "codigo":773610007,
    "descripcion":"SÍNDROME DE CHUDLEY MCCULLOUGH"
  },
  {
    "codigo":249322008,
    "descripcion":"NARIZ ESTRECHA"
  },
  {
    "codigo":216554006,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR MESCALINA"
  },
  {
    "codigo":704404001,
    "descripcion":"CONOCIMIENTO DEFICIENTE SOBRE MANEJO DEL DOLOR"
  },
  {
    "codigo":247487009,
    "descripcion":"CURVATURA EXAGERADA DE LA UÑA"
  },
  {
    "codigo":737172003,
    "descripcion":"ECCEMA DE GENITALES MASCULINOS"
  },
  {
    "codigo":1084561000119106,
    "descripcion":"OTALGIA DE AMBOS OÍDOS, DERIVADA"
  },
  {
    "codigo":49044005,
    "descripcion":"BRADICARDIA SINUSAL SEVERA"
  },
  {
    "codigo":79977000,
    "descripcion":"ATRESIA DEL LIGAMENTO ANCHO"
  },
  {
    "codigo":276585000,
    "descripcion":"NEFRITIS CONGÉNITA"
  },
  {
    "codigo":81812009,
    "descripcion":"HWA - BYUNG"
  },
  {
    "codigo":1259625003,
    "descripcion":"COREA DEBIDA A HIPONATREMIA"
  },
  {
    "codigo":473193004,
    "descripcion":"MODALIDAD DE ACCESO PARA DIÁLISIS SEGÚN LA ELECCIÓN DEL PACIENTE"
  },
  {
    "codigo":243817005,
    "descripcion":"ESTADO DE ANTICONCEPCIÓN ORAL"
  },
  {
    "codigo":407657008,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: TURCO"
  },
  {
    "codigo":241982001,
    "descripcion":"BAROTITIS INTERNA"
  },
  {
    "codigo":209214001,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA NO EXPUESTA DE LA ARTICULACIÓN ESTERNOCLAVICULAR, ANTERIOR"
  },
  {
    "codigo":307518006,
    "descripcion":"DEFICIENCIA DE FACTOR VIII RELACIONADA CON NEOPLASIA MALIGNA"
  },
  {
    "codigo":373054007,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM PORCINUM"
  },
  {
    "codigo":405822008,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS DE LARINGE"
  },
  {
    "codigo":305683000,
    "descripcion":"ATENDIDO POR UN NEFRÓLOGO"
  },
  {
    "codigo":10771002,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE LA PRIMERA VÉRTEBRA CERVICAL"
  },
  {
    "codigo":698899003,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: GUARANÍ"
  },
  {
    "codigo":403987004,
    "descripcion":"FIBROMA DE LA NUCA"
  },
  {
    "codigo":764435003,
    "descripcion":"SÍNDROME DE MICRODUPLICACIÓN 17Q12"
  },
  {
    "codigo":44231000087102,
    "descripcion":"CONTUSIÓN DE CÓNDILO EXTERNO DE FÉMUR IZQUIERDO"
  },
  {
    "codigo":46791000087103,
    "descripcion":"DILATACIÓN DE INTESTINO GRUESO"
  },
  {
    "codigo":240147008,
    "descripcion":"OSTEOMIELITIS CRÓNICA DE PIE"
  },
  {
    "codigo":829971006,
    "descripcion":"ENFERMEDAD POR DEPÓSITO DE INMUNOGLOBULINA MONOCLONAL NO AMILOIDE"
  },
  {
    "codigo":39111000087102,
    "descripcion":"DOLOR CRÓNICO POSTERIOR A CIRUGÍA DE COLUMNA"
  },
  {
    "codigo":41671000087100,
    "descripcion":"HERIDA PUNZANTE DE PÁRPADO SUPERIOR DERECHO"
  },
  {
    "codigo":33991000087108,
    "descripcion":"MÚLTIPLES LESIONES TRAUMÁTICAS DE REGIÓN INTRABDOMINAL"
  },
  {
    "codigo":402152005,
    "descripcion":"DERMATOSIS CAUSADA POR ARAÑA"
  },
  {
    "codigo":860904006,
    "descripcion":"ALERGIA A AZOL"
  },
  {
    "codigo":762600005,
    "descripcion":"DOLOR VISCERAL CRÓNICO DEBIDO A TRASTORNO VASCULAR"
  },
  {
    "codigo":170941001,
    "descripcion":"ATENCIÓN COMPLETA POR MÉDICO GENERAL"
  },
  {
    "codigo":302013002,
    "descripcion":"ÁNTRAX DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":236477004,
    "descripcion":"GLICINURIA"
  },
  {
    "codigo":203709007,
    "descripcion":"COMPLEJO DE SUBLUXACIÓN (VERTEBRAL)"
  },
  {
    "codigo":269245008,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO DE MUÑECA Y MANO"
  },
  {
    "codigo":365714001,
    "descripcion":"HALLAZGO EN LA ALTURA\/CRECIMIENTO"
  },
  {
    "codigo":433085009,
    "descripcion":"INFECCIÓN DE PRÓTESIS UNICONDILAR DE RODILLA"
  },
  {
    "codigo":70802000,
    "descripcion":"INTOXICACIÓN POR LIPPIA"
  },
  {
    "codigo":234642007,
    "descripcion":"INMUNODEFICIENCIA RELACIONADA CON LA EDAD"
  },
  {
    "codigo":298343000,
    "descripcion":"HALLAZGO RELACIONADO CON LAS CAÍDAS"
  },
  {
    "codigo":1119378008,
    "descripcion":"AUSENCIA DE SENSACIÓN DEL LADO DERECHO DE LA CARA"
  },
  {
    "codigo":267410008,
    "descripcion":"RETARDO EN EL CRECIMIENTO POR DESNUTRICIÓN PROTEICO - CALÓRICA"
  },
  {
    "codigo":300178009,
    "descripcion":"ESTRIBO AUSENTE"
  },
  {
    "codigo":36199004,
    "descripcion":"MAMAS PÉNDULAS"
  },
  {
    "codigo":1345084001,
    "descripcion":"DEPENDENCIA DE ESTEROIDE ANABÓLICO DEBIDA A PATRÓN DE USO NOCIVO"
  },
  {
    "codigo":1279548003,
    "descripcion":"HALLAZGO RELACIONADO CON BAJO NIVEL DE RIESGO"
  },
  {
    "codigo":1179409000,
    "descripcion":"VERRUGA VIRAL DEBIDA A TERAPIA INMUNOSUPRESORA Y POSTERIOR A ELLA"
  },
  {
    "codigo":67132008,
    "descripcion":"NEFROSIS HIPÓXICA"
  },
  {
    "codigo":128998007,
    "descripcion":"TRASTORNO INFLAMATORIO DEL APARATO CARDIOVASCULAR"
  },
  {
    "codigo":292838008,
    "descripcion":"REACCIÓN ADVERSA AL INTERFERÓN-A-2B"
  },
  {
    "codigo":61627001,
    "descripcion":"HIPERCLORIDRIA"
  },
  {
    "codigo":63462008,
    "descripcion":"MIOCARDITIS POR VIRUS DE LA PAROTIDITIS URLIANA"
  },
  {
    "codigo":94395004,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LOS GANGLIOS LINFÁTICOS DE MIEMBRO INFERIOR"
  },
  {
    "codigo":127163005,
    "descripcion":"LINFADENOPATÍA ILÍACA COMÚN SUBAÓRTICA"
  },
  {
    "codigo":291003009,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR PARALDEHÍDO"
  },
  {
    "codigo":92560002,
    "descripcion":"CARCINOMA IN SITU DEL CARDIAS DEL ESTÓMAGO"
  },
  {
    "codigo":1303141003,
    "descripcion":"ARTRITIS EN ARTICULACIÓN RADIOCARPIANA DERECHA"
  },
  {
    "codigo":187194004,
    "descripcion":"CORIORRETINITIS POR TOXOPLASMA"
  },
  {
    "codigo":1268538005,
    "descripcion":"ADENOCARCINOMA DE CÉLULAS CLARAS PRIMARIO DE OVARIO"
  },
  {
    "codigo":285498007,
    "descripcion":"INCAPAZ DE MOVER LA LENGUA"
  },
  {
    "codigo":711482008,
    "descripcion":"MICROANGIOPATÍA CEREBRORRETINIANA CON CALCIFICACIONES Y QUISTES"
  },
  {
    "codigo":185359002,
    "descripcion":"DERIVADO POR OTRO MÉDICO GENERAL"
  },
  {
    "codigo":283663003,
    "descripcion":"HERIDA POR PINCHAZO DE CLAVO EN LA PALMA DE LA MANO"
  },
  {
    "codigo":250895007,
    "descripcion":"CAMBIO EN LA INTENSIDAD"
  },
  {
    "codigo":54287007,
    "descripcion":"OCENA LARÍNGEA"
  },
  {
    "codigo":609508002,
    "descripcion":"INTERRUPCIÓN INDUCIDA DEL EMBARAZO COMPLICADA POR DAÑO DE CUELLO UTERINO"
  },
  {
    "codigo":52452006,
    "descripcion":"DEFICIENCIA DE FUMARILACETOACETASA, TIPO CRÓNICO"
  },
  {
    "codigo":249060007,
    "descripcion":"PARTES FETALES NO DISTINGUIBLES A TRAVÉS DEL ABDOMEN"
  },
  {
    "codigo":1363172008,
    "descripcion":"NEUROPATÍA ÓPTICA ISQUÉMICA ANTERIOR NO ARTERÍTICA IDIOPÁTICA"
  },
  {
    "codigo":17849001,
    "descripcion":"TRASTORNO RESPIRATORIO FETAL Y\/O NEONATAL"
  },
  {
    "codigo":83385002,
    "descripcion":"FRACTURA DE HUESO PARIETAL"
  },
  {
    "codigo":19684007,
    "descripcion":"QUEMADURA DE RODILLA"
  },
  {
    "codigo":871652008,
    "descripcion":"ATRESIA MITRAL CON VÁLVULA MITRAL IMPERFORADA"
  },
  {
    "codigo":771513008,
    "descripcion":"MIOCARDIOPATÍA HIPERTRÓFICA INFANTIL DEBIDA A DEFICIENCIA DE PROTEÍNA RIBOSÓMICA MITOCONDRIAL L44"
  },
  {
    "codigo":48782003,
    "descripcion":"PARTO NORMAL"
  },
  {
    "codigo":11847571000119103,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE LENGUA"
  },
  {
    "codigo":441998006,
    "descripcion":"TUMEFACCIÓN SUBUNGUEAL"
  },
  {
    "codigo":210787002,
    "descripcion":"LESIÓN EXPUESTA, ARTERIA SUBCLAVIA"
  },
  {
    "codigo":1259363003,
    "descripcion":"OBSTRUCCIÓN DE UNIÓN VESICOURETERAL"
  },
  {
    "codigo":309091003,
    "descripcion":"BALANITIS INFECCIOSA"
  },
  {
    "codigo":276323006,
    "descripcion":"HALLAZGO RELACIONADO CON EL COLOR DE LA PIEL"
  },
  {
    "codigo":45112000,
    "descripcion":"DETERMINACIÓN DEL ESTADO DEL PACIENTE, AGRAVAMIENTO SERIO"
  },
  {
    "codigo":405560005,
    "descripcion":"FÍSTULA DE SENO CORONARIO"
  },
  {
    "codigo":733240005,
    "descripcion":"MÚLTIPLES LESIONES TRAUMÁTICAS SUPERFICIALES DE MANO"
  },
  {
    "codigo":10946451000119106,
    "descripcion":"LESIÓN POR DESOLLAMIENTO DE MANO DERECHA"
  },
  {
    "codigo":440351000124105,
    "descripcion":"INGESTA ORAL EXCESIVA"
  },
  {
    "codigo":10509002,
    "descripcion":"BRONQUITIS AGUDA"
  },
  {
    "codigo":77880009,
    "descripcion":"DOLOR RECTAL"
  },
  {
    "codigo":239885004,
    "descripcion":"FIBROESCLEROSIS - SISTÉMICA"
  },
  {
    "codigo":895245002,
    "descripcion":"FORMA ANCHA ANORMAL CONGÉNITA DE FALANGE MEDIA DE DEDO ÍNDICE"
  },
  {
    "codigo":2591000124106,
    "descripcion":"PRIMER MOLAR SUPERIOR DERECHO PERMANENTE SUPERNUMERARIO"
  },
  {
    "codigo":762338001,
    "descripcion":"TRASTORNO DEL ESTADO DE ÁNIMO CON SÍNTOMAS MANÍACOS CAUSADO POR INHALANTE VOLÁTIL"
  },
  {
    "codigo":352301000119103,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE PARTES BLANDAS DE EXTREMIDAD SUPERIOR DERECHA"
  },
  {
    "codigo":203447001,
    "descripcion":"FRACTURA OSTEOPORÓTICA DEBIDA A OSTEOPOROSIS INDUCIDA POR FÁRMACO"
  },
  {
    "codigo":238050009,
    "descripcion":"TRASTORNO DEL METABOLISMO DEL ÁCIDO SIÁLICO"
  },
  {
    "codigo":301751005,
    "descripcion":"REALIZA ACTIVIDADES DE ADMINISTRACIÓN Y SUPERVISIÓN"
  },
  {
    "codigo":679981000119105,
    "descripcion":"BLEFAROFIMOSIS CONGÉNITA DE HENDIDURA PALPEBRAL DERECHA"
  },
  {
    "codigo":365452001,
    "descripcion":"HALLAZGO RELACIONADO CON EL SENTIDO DE INTENCIONALIDAD"
  },
  {
    "codigo":234380002,
    "descripcion":"ISOINMUNIZACIÓN DEL RECIÉN NACIDO POR GRUPO SANGUÍNEO KELL"
  },
  {
    "codigo":6839008,
    "descripcion":"SÍNDROME VACTEL"
  },
  {
    "codigo":299916009,
    "descripcion":"SENSACIÓN AL TACTO FIRME: PRESENTE"
  },
  {
    "codigo":298081002,
    "descripcion":"CUERPO EXTRAÑO EN LA PIEL DEL DORSO DE LA MANO"
  },
  {
    "codigo":724065003,
    "descripcion":"ATAXIA AUTOSÓMICA RECESIVA DE COLUMNA POSTERIOR Y RETINITIS PIGMENTOSA"
  },
  {
    "codigo":10838061000119108,
    "descripcion":"FRACTURA MEDIOCERVICAL EXPUESTA DE FÉMUR IZQUIERDO"
  },
  {
    "codigo":230710000,
    "descripcion":"HEMORRAGIA DE LÓBULO CEREBRAL"
  },
  {
    "codigo":34102000,
    "descripcion":"CONTRACTURA ADQUIRIDA DE CUELLO DE VEJIGA URINARIA"
  },
  {
    "codigo":66870002,
    "descripcion":"HEPATITIS VIRAL CRÓNICA ACTIVA"
  },
  {
    "codigo":197942003,
    "descripcion":"HEMATURIA CON PRESENCIA DE COÁGULOS"
  },
  {
    "codigo":296246001,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE PROCLORPERAZINA"
  },
  {
    "codigo":80071000119103,
    "descripcion":"CARCINOMA BASOCELULAR DE PIEL IN SITU"
  },
  {
    "codigo":65035007,
    "descripcion":"EDAD GESTACIONAL, 22 SEMANAS"
  },
  {
    "codigo":16054471000119105,
    "descripcion":"HIPOPLASIA CONGÉNITA DE AMBOS NERVIOS ÓPTICOS"
  },
  {
    "codigo":196107009,
    "descripcion":"ABSCESO DE PULMÓN Y MEDIASTINO"
  },
  {
    "codigo":390880002,
    "descripcion":"TREPONEMA PALLIDUM DETECTADO MEDIANTE ENSAYO DE INMUNOADSORCIÓN LIGADO A ENZIMAS"
  },
  {
    "codigo":1275616003,
    "descripcion":"LESIÓN DE RETINA"
  },
  {
    "codigo":94133000,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE CONDUCTO DEFERENTE"
  },
  {
    "codigo":292576009,
    "descripcion":"REACCIÓN ADVERSA A LA CLEMASTINA"
  },
  {
    "codigo":126901001,
    "descripcion":"NEOPLASIA DE TESTÍCULO RETENIDO"
  },
  {
    "codigo":290741001,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR FLUDARABINA"
  },
  {
    "codigo":194272009,
    "descripcion":"OBSTRUCCIÓN ÓSEA DE TROMPA DE EUSTAQUIO"
  },
  {
    "codigo":1144544008,
    "descripcion":"HIPOPLASIA CONGÉNITA DE COLON"
  },
  {
    "codigo":59530001,
    "descripcion":"SÍFILIS RENAL"
  },
  {
    "codigo":92298003,
    "descripcion":"NEOPLASIA BENIGNA DE PLEURA"
  },
  {
    "codigo":190602008,
    "descripcion":"DESNUTRICIÓN CALORICOPROTEICA MODERADA (60-74% DEL PESO ESTÁNDAR PARA LA EDAD)"
  },
  {
    "codigo":287071001,
    "descripcion":"CONSOLIDACIÓN DEFECTUOSA DE FRACTURA MÚLTIPLE"
  },
  {
    "codigo":418143002,
    "descripcion":"DEGENERACIÓN CEREBRAL"
  },
  {
    "codigo":713055004,
    "descripcion":"BUEN VÍNCULO CON CUIDADOR PRIMARIO"
  },
  {
    "codigo":1237343009,
    "descripcion":"SÍNDROME OTODENTAL"
  },
  {
    "codigo":416308001,
    "descripcion":"CONSENTIMIENTO PARA INCLUSIÓN DE DATOS EN REGISTRO MÉDICO ELECTRÓNICO COMPARTIDO A NIVEL NACIONAL REHUSADO"
  },
  {
    "codigo":57695009,
    "descripcion":"INTOXICACIÓN POR CLOFIBRATO"
  },
  {
    "codigo":285236005,
    "descripcion":"TRASTORNO DEBIDO A LESIÓN TRAUMÁTICA DE MIEMBRO SUPERIOR Y POSTERIOR A ELLA"
  },
  {
    "codigo":55860008,
    "descripcion":"ESTENOSIS DE ESTÓMAGO"
  },
  {
    "codigo":23092009,
    "descripcion":"REACCIÓN AUTOINMUNITARIA MEDIADA POR LA INMUNIDAD CELULAR"
  },
  {
    "codigo":283401007,
    "descripcion":"CORTE EN LA FRENTE"
  },
  {
    "codigo":445406001,
    "descripcion":"LINFOMA HEPATOESPLÉNICO DE LINFOCITOS T"
  },
  {
    "codigo":281566005,
    "descripcion":"NEUROBLASTOMA ABDOMINOTORÁCICO"
  },
  {
    "codigo":52190008,
    "descripcion":"CELULITIS DEL CUERO CABELLUDO"
  },
  {
    "codigo":248798008,
    "descripcion":"ALCANZA EL ORGASMO CON FACILIDAD"
  },
  {
    "codigo":10812001000119100,
    "descripcion":"SEPSIS DEBIDA A ABORTO ESPONTÁNEO INCOMPLETO"
  },
  {
    "codigo":679521000119101,
    "descripcion":"LESIÓN VASCULAR DE PÁRPADO DERECHO"
  },
  {
    "codigo":333921000119102,
    "descripcion":"ECTROPIÓN MECÁNICO DE PÁRPADO DERECHO"
  },
  {
    "codigo":21601000119103,
    "descripcion":"ENCEFALOPATÍA HIPÓXICA ISQUÉMICA DEBIDA A TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":124001000119104,
    "descripcion":"ESTADO MIGRAÑOSO CONCOMITANTE CON MIGRAÑA SIN AURA Y DEBIDO A ELLA"
  },
  {
    "codigo":15729761000119105,
    "descripcion":"ARTROPATÍA DE CADERA IZQUIERDA"
  },
  {
    "codigo":736648002,
    "descripcion":"RESORCIÓN DE CÓNDILO MANDIBULAR"
  },
  {
    "codigo":323681000119107,
    "descripcion":"TUMOR TENOSINOVIAL DIFUSO DE CÉLULAS GIGANTES DE CADERA DERECHA"
  },
  {
    "codigo":674401000119108,
    "descripcion":"DÉFICIT DEL HABLA Y DEL LENGUAJE DEBIDO A ACCIDENTE CEREBROVASCULAR ISQUÉMICO Y POSTERIOR A ÉL"
  },
  {
    "codigo":1230003009,
    "descripcion":"DEFICIENCIA DE HEMO OXIGENASA 1"
  },
  {
    "codigo":1121000119107,
    "descripcion":"DOLOR CRÓNICO DE CUELLO"
  },
  {
    "codigo":339041000119109,
    "descripcion":"HEMORRAGIA DE ÓRBITA IZQUIERDA"
  },
  {
    "codigo":212360005,
    "descripcion":"CONMOCIÓN Y EDEMA DE LA MÉDULA ESPINAL LUMBAR"
  },
  {
    "codigo":1089121000119109,
    "descripcion":"TRASTORNO DE OÍDO MEDIO IZQUIERDO"
  },
  {
    "codigo":12217441000119107,
    "descripcion":"OSTEÓLISIS DE HUESO ADYACENTE A PRÓTESIS DE ARTICULACIÓN DE RODILLA IZQUIERDA"
  },
  {
    "codigo":303201000119106,
    "descripcion":"TENDINITIS CALCIFICANTE DE MUSLO IZQUIERDO"
  },
  {
    "codigo":15732321000119108,
    "descripcion":"EDEMA PALPEBRAL BILATERAL"
  },
  {
    "codigo":210525005,
    "descripcion":"LESIÓN POR DESOLLAMIENTO DE REGIÓN ESCAPULAR"
  },
  {
    "codigo":1076321000119109,
    "descripcion":"BURSITIS DE ILIOPSOAS EN LA CADERA IZQUIERDA"
  },
  {
    "codigo":1259101007,
    "descripcion":"GANGLIONOPATÍA SENSITIVA AUTOINMUNITARIA"
  },
  {
    "codigo":15975061000119102,
    "descripcion":"QUISTE DE ASTA POSTERIOR DE MENISCO INTERNO DE AMBAS RODILLAS"
  },
  {
    "codigo":276061003,
    "descripcion":"TRABAJO NO REMUNERADO"
  },
  {
    "codigo":13917001,
    "descripcion":"INFECCIÓN CAUSADA POR BERTIELLA"
  },
  {
    "codigo":12206741000119103,
    "descripcion":"SUBLUXACIÓN DE PRÓTESIS DE CADERA DERECHA"
  },
  {
    "codigo":208690007,
    "descripcion":"FRACTURA NO EXPUESTA DE CABEZA DE METATARSIANO"
  },
  {
    "codigo":700210008,
    "descripcion":"ESTIMULADOR DE NERVIO VAGO IN SITU"
  },
  {
    "codigo":765746008,
    "descripcion":"ENFERMEDAD DE CHARCOT-MARIE-TOOTH AUTOSÓMICA DOMINANTE INTERMEDIA TIPO C"
  },
  {
    "codigo":403463007,
    "descripcion":"BALANITIS IRRITATIVA"
  },
  {
    "codigo":237788002,
    "descripcion":"INSUFICIENCIA OVÁRICA PREMATURA"
  },
  {
    "codigo":73948007,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO DE LA PARED ABDOMINAL"
  },
  {
    "codigo":301489001,
    "descripcion":"DIFICULTAD PARA DOBLAR ESQUINAS"
  },
  {
    "codigo":203185005,
    "descripcion":"OSTEOMIELITIS CRÓNICA DE BRAZO"
  },
  {
    "codigo":235953007,
    "descripcion":"PANCREATITIS CRÓNICA IDIOPÁTICA"
  },
  {
    "codigo":365190004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA REALIZAR ACTIVIDADES PARA EL CUIDADO DE LA BOCA"
  },
  {
    "codigo":299654007,
    "descripcion":"AMPUTADO A NIVEL DE TOBILLO"
  },
  {
    "codigo":234118009,
    "descripcion":"MALFORMACIÓN CAPILAR"
  },
  {
    "codigo":363355002,
    "descripcion":"NEOPLASIA MALIGNA DE GLÁNDULA SUPRARRENAL"
  },
  {
    "codigo":232283001,
    "descripcion":"SÍNDROME VESTIBULAR DE MÉNIÈRE"
  },
  {
    "codigo":263216001,
    "descripcion":"FRACTURA VERTICAL DEL ÍLEON"
  },
  {
    "codigo":164912004,
    "descripcion":"ONDA P ELECTROCARDIOGRÁFICA ANORMAL"
  },
  {
    "codigo":427056005,
    "descripcion":"LEUCEMIA SUBAGUDA EN REMISIÓN"
  },
  {
    "codigo":295984006,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE METILFENOBARBITAL"
  },
  {
    "codigo":230448009,
    "descripcion":"EPILEPSIA DE LA ESCRITURA"
  },
  {
    "codigo":62938001,
    "descripcion":"RELACIÓN NORMAL FUERZA - DURACIÓN ENTRE NEURONAS Y FIBRAS NERVIOSAS"
  },
  {
    "codigo":292314001,
    "descripcion":"REACCIÓN ADVERSA A FÁRMACO ANTIEPILÉPTICO"
  },
  {
    "codigo":359685009,
    "descripcion":"INTOXICACIÓN POR SARCOBATUS VERMICULATUS"
  },
  {
    "codigo":1177050006,
    "descripcion":"INFECCIÓN CAUSADA POR LARVAS DE TRICHINELLA NATIVA"
  },
  {
    "codigo":128474007,
    "descripcion":"ADENOMA PARATIROIDEO"
  },
  {
    "codigo":716463000,
    "descripcion":"CAPAZ DE COMPRENDER Y UTILIZAR DINERO"
  },
  {
    "codigo":93871001,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE HUESO LARGO DE MIEMBRO INFERIOR"
  },
  {
    "codigo":126639006,
    "descripcion":"NEOPLASIA DE LA AXILA"
  },
  {
    "codigo":1306287007,
    "descripcion":"GLAUCOMA DE ÁNGULO ABIERTO PRIMARIO DE OJO IZQUIERDO"
  },
  {
    "codigo":714628002,
    "descripcion":"PREDIABETES"
  },
  {
    "codigo":288644002,
    "descripcion":"DIFICULTAD PARA COMENZAR UNA CONVERSACIÓN"
  },
  {
    "codigo":92036005,
    "descripcion":"NEOPLASIA BENIGNA DE BRONQUIO DE LÓBULO MEDIO DE PULMÓN DERECHO"
  },
  {
    "codigo":188505000,
    "descripcion":"LINFOSARCOMA DE GANGLIOS LINFÁTICOS INTRAPÉLVICOS"
  },
  {
    "codigo":254041007,
    "descripcion":"MALFORMACIÓN CONGÉNITA DEL ESTERNÓN"
  },
  {
    "codigo":12235721000119108,
    "descripcion":"PTOSIS CONGÉNITA DE PÁRPADO SUPERIOR DERECHO"
  },
  {
    "codigo":284974001,
    "descripcion":"INCAPAZ DE VESTIRSE"
  },
  {
    "codigo":57433008,
    "descripcion":"GASTRITIS POR REFLUJO"
  },
  {
    "codigo":448814004,
    "descripcion":"CIERRE ESPONTÁNEO DE COMPONENTE AURICULAR DE DEFECTO DE TABIQUE AURICULOVENTRICULAR"
  },
  {
    "codigo":22830006,
    "descripcion":"CISTINOSIS NEFROPÁTICA JUVENIL"
  },
  {
    "codigo":250371001,
    "descripcion":"ANTICUERPO ANTI - LUPUS ERITEMATOSO, PRESENTE"
  },
  {
    "codigo":53763004,
    "descripcion":"AGRESIÓN SEXUAL"
  },
  {
    "codigo":20995005,
    "descripcion":"SIGNO DE TINEL"
  },
  {
    "codigo":283139005,
    "descripcion":"CUERPO EXTRAÑO METÁLICO SUPERFICIAL"
  },
  {
    "codigo":184835005,
    "descripcion":"INFORME PRELIMINAR DE SEGURO DE VIDA COMPLETADO"
  },
  {
    "codigo":446979005,
    "descripcion":"FRACTURA EXPUESTA DE TIBIA"
  },
  {
    "codigo":445144002,
    "descripcion":"DEFORMIDAD DE MIEMBRO"
  },
  {
    "codigo":838360003,
    "descripcion":"ARTRITIS CAUSADA POR MYCOBACTERIUM LEPRAE"
  },
  {
    "codigo":51928006,
    "descripcion":"PARESIA GENERAL - NEUROSÍFILIS"
  },
  {
    "codigo":246701004,
    "descripcion":"DESVIACIÓN HACIA ARRIBA DE LOS OJOS"
  },
  {
    "codigo":330851000119108,
    "descripcion":"XERODERMIA DE PÁRPADO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":1162370000,
    "descripcion":"PUNTEADO DE PIEL"
  },
  {
    "codigo":212098002,
    "descripcion":"QUEMADURA QUE COMPROMETE 70-79 PORCIENTO DE LA SUPERFICIE DEL CUERPO, CON QUEMADURA DE ESPESOR COMPLETO QUE AFECTA 40-49 PORCIENTO DE LA SUPERFICIE CORPORAL"
  },
  {
    "codigo":310402006,
    "descripcion":"LA AGENCIA DE SUBSIDIOS INFORMA APTITUD PARA TRABAJAR"
  },
  {
    "codigo":210263003,
    "descripcion":"LESIÓN TRAUMÁTICA DE RETROPERITONEO CON HERIDA ABIERTA HACIA CAVIDAD"
  },
  {
    "codigo":15951101000119104,
    "descripcion":"MELANOMA MALIGNO DE PIEL DE AMBOS HOMBROS"
  },
  {
    "codigo":79191007,
    "descripcion":"ANOMALÍA CONGÉNITA DE MÚSCULO Y\/O TENDÓN"
  },
  {
    "codigo":111959008,
    "descripcion":"PARÁLISIS DE LOS TAMBORILLEROS"
  },
  {
    "codigo":765484001,
    "descripcion":"SÍNDROME DE CROMOSOMA 19 EN ANILLO"
  },
  {
    "codigo":208428002,
    "descripcion":"FRACTURA EXPUESTA DE HUESO SESAMOIDEO DE LA MANO"
  },
  {
    "codigo":243031009,
    "descripcion":"LESIÓN POR RÁFAGA DE MISIL AUTOPROPULSADO"
  },
  {
    "codigo":110124004,
    "descripcion":"LACERACIÓN SIMPLE DEL PALADAR DURO"
  },
  {
    "codigo":10681751000119100,
    "descripcion":"MASA DE PIEL DE AMBAS PIERNAS"
  },
  {
    "codigo":1255169000,
    "descripcion":"RUPTURA TRAUMÁTICA DE TENDÓN DE HOMBRO"
  },
  {
    "codigo":403201009,
    "descripcion":"QUERATOSIS ACTÍNICA PROLIFERATIVA"
  },
  {
    "codigo":237526003,
    "descripcion":"EUTIROIDISMO CON ANTICUERPOS TIROIDEOS"
  },
  {
    "codigo":1220566004,
    "descripcion":"DESPLAZAMIENTO COMPLEJO DE GLOBO OCULAR"
  },
  {
    "codigo":720435007,
    "descripcion":"HEMORRAGIA POSOPERATORIA DE HERIDA DESPUÉS DE PROCEDIMIENTO QUIRÚRGICO ODONTOLÓGICO"
  },
  {
    "codigo":303062005,
    "descripcion":"MALABSORCIÓN DEBIDA A INTOLERANCIA A LA GRASA"
  },
  {
    "codigo":301227004,
    "descripcion":"HALLAZGO TRAQUEOBRONQUIAL"
  },
  {
    "codigo":1251499005,
    "descripcion":"SÍNDROME DE EHLERS-DANLOS ESPONDILODISPLÁSICO ASOCIADO A GEN B3GALT6"
  },
  {
    "codigo":202923005,
    "descripcion":"TENOSINOVITIS DEL MÚSCULO PERONEO LATERAL CORTO"
  },
  {
    "codigo":268459005,
    "descripcion":"ASESORAMIENTO SOBRE MÉTODOS ANTICONCEPTIVOS ORALES"
  },
  {
    "codigo":170155008,
    "descripcion":"EXAMEN DEL NIÑO A LOS 3.5 AÑOS: ANORMAL - PARA OBSERVACIÓN"
  },
  {
    "codigo":71851009,
    "descripcion":"VÓLVULO GÁSTRICO"
  },
  {
    "codigo":299392002,
    "descripcion":"PRUEBA DE MCMURRAY NEGATIVA"
  },
  {
    "codigo":233856001,
    "descripcion":"REESTENOSIS MITRAL"
  },
  {
    "codigo":397696004,
    "descripcion":"ENTEROCOLITIS POR ANTIBIÓTICOS"
  },
  {
    "codigo":364928007,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA INCLINARSE HACIA ABAJO"
  },
  {
    "codigo":363093002,
    "descripcion":"TRASTORNOS RELACIONADOS CON EL MOVIMIENTO FETAL"
  },
  {
    "codigo":461397003,
    "descripcion":"CONDUCTO ARTERIOSO PERMEABLE CON ORIGEN E INSERCIÓN NORMALES Y DENTRO DEL PERÍODO PARA EL CIERRE FUNCIONAL NORMAL"
  },
  {
    "codigo":166485002,
    "descripcion":"PRUEBA DE FUNCIÓN HIPOFISARIA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":232021008,
    "descripcion":"RETINOPATÍA PROLIFERATIVA CON NEOVASCULARIZACIÓN DE PAPILA ÓPTICA DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":11310641000119102,
    "descripcion":"FRACTURA NO EXPUESTA DE CUARTA VÉRTEBRA DORSAL"
  },
  {
    "codigo":295722002,
    "descripcion":"SOBREDOSIS DE FLUOROURACILO"
  },
  {
    "codigo":426794005,
    "descripcion":"ORIENTADO EN TIEMPO"
  },
  {
    "codigo":197418006,
    "descripcion":"OCLUSIÓN DE CONDUCTO CÍSTICO"
  },
  {
    "codigo":721706007,
    "descripcion":"HEMORROIDES INTERNAS, GRADO IV"
  },
  {
    "codigo":293887001,
    "descripcion":"ALERGIA A FLURAZEPAM"
  },
  {
    "codigo":230186009,
    "descripcion":"ENCEFALITIS AMÉBICA PRIMARIA"
  },
  {
    "codigo":457727004,
    "descripcion":"TROMBOSIS DE VÁLVULA AURICULOVENTRICULAR COMÚN"
  },
  {
    "codigo":424959007,
    "descripcion":"CUERPO EXTRAÑO CERVICAL"
  },
  {
    "codigo":228351008,
    "descripcion":"TOLERANCIA FÍSICA AL ALCOHOL"
  },
  {
    "codigo":423124001,
    "descripcion":"JUICIO DISMINUIDO"
  },
  {
    "codigo":128212001,
    "descripcion":"ATROFIA MUSCULAR ESPINAL, TIPO II"
  },
  {
    "codigo":292052006,
    "descripcion":"REACCIÓN ADVERSA A LA METADONA"
  },
  {
    "codigo":290217000,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR LEVORFANOL"
  },
  {
    "codigo":93609001,
    "descripcion":"OSIFICACIÓN INCOMPLETA DEL ANILLO TIMPÁNICO"
  },
  {
    "codigo":783572008,
    "descripcion":"TIENE NECESIDADES DE EDUCACIÓN ESPECIAL"
  },
  {
    "codigo":62676009,
    "descripcion":"PALUDISMO POR PLASMODIUM FALCIPARUM"
  },
  {
    "codigo":880041004,
    "descripcion":"ANOMALÍA ADQUIRIDA DE VENTRÍCULO DERECHO"
  },
  {
    "codigo":191913000,
    "descripcion":"PATRÓN DE USO EPISÓDICO NOCIVO SIN DEPENDENCIA DE OPIOIDES"
  },
  {
    "codigo":288382000,
    "descripcion":"CAPAZ DE UTILIZAR UNA LLAVE"
  },
  {
    "codigo":59006007,
    "descripcion":"OBSTRUCCIÓN DE ORIFICIO DE TRAQUEOSTOMÍA"
  },
  {
    "codigo":417619001,
    "descripcion":"GLIOMA DE NERVIO ÓPTICO INTRACRANEAL"
  },
  {
    "codigo":778067002,
    "descripcion":"CONDRODISPLASIA PUNTEADA BRAQUITELEFALÁNGICA"
  },
  {
    "codigo":188243001,
    "descripcion":"NEOPLASIA MALIGNA DE LA PARED POSTERIOR DE LA VEJIGA URINARIA"
  },
  {
    "codigo":712531005,
    "descripcion":"INFECCIÓN BACTERIANA CAUSADA POR GRUPO DE STREPTOCOCCUS MILLERI"
  },
  {
    "codigo":286547006,
    "descripcion":"QUEMADURA EN LA CAVIDAD BUCAL"
  },
  {
    "codigo":306891000119105,
    "descripcion":"DERRAME ARTICULAR DE RODILLA IZQUIERDA"
  },
  {
    "codigo":24403008,
    "descripcion":"ANTÍGENO DE GRUPO SANGUÍNEO P"
  },
  {
    "codigo":88104005,
    "descripcion":"TIROIDITIS FOCAL"
  },
  {
    "codigo":1003773001,
    "descripcion":"HEMARTROSIS TRAUMÁTICA DE ARTICULACIÓN ESCAPULOHUMERAL"
  },
  {
    "codigo":413949002,
    "descripcion":"DETRITUS EN LA INTERFAZ DE COLGAJO CORNEAL"
  },
  {
    "codigo":86269002,
    "descripcion":"LESIÓN TRAUMÁTICA DEL NERVIO CIÁTICO"
  },
  {
    "codigo":1264082000,
    "descripcion":"TRASTORNO NEONATAL DEBIDO A EXPOSICIÓN MATERNA A SUSTANCIA QUÍMICA AMBIENTAL TRANSMITIDA A TRAVÉS DE LECHE MATERNA"
  },
  {
    "codigo":217341008,
    "descripcion":"XANTOMA DIABÉTICO"
  },
  {
    "codigo":248274002,
    "descripcion":"FALTA DE ENERGÍA"
  },
  {
    "codigo":282877008,
    "descripcion":"INCAPAZ DE PONERSE DE PIE SOLO"
  },
  {
    "codigo":1296850005,
    "descripcion":"TUMOR DE BRENNER BORDERLINE DE OVARIO"
  },
  {
    "codigo":16746341000119103,
    "descripcion":"RETINOPATÍA NO PROLIFERATIVA MODERADA BILATERAL DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":770727008,
    "descripcion":"ATROFIA DE MÚSCULOS ESPINALES CON DIFICULTAD RESPIRATORIA TIPO 2"
  },
  {
    "codigo":211836000,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO SUPERFICIAL DE BRAZO"
  },
  {
    "codigo":703356002,
    "descripcion":"OCLUSIÓN DE ARTERIA CORONARIA DEBIDA A ENFERMEDAD NEOPLÁSICA"
  },
  {
    "codigo":15228007,
    "descripcion":"ENFERMEDAD DE NORRIE"
  },
  {
    "codigo":1260412008,
    "descripcion":"DERMATOSIS TERRA FIRMA FORME"
  },
  {
    "codigo":439377004,
    "descripcion":"REMOCIÓN ACCIDENTAL DE CATÉTER"
  },
  {
    "codigo":111697005,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA VENA POPLÍTEA"
  },
  {
    "codigo":1356881007,
    "descripcion":"LESIÓN LOCALIZADA DE HUESO DE CRÁNEO"
  },
  {
    "codigo":15927141000119108,
    "descripcion":"LESIÓN DE AMBOS PÁRPADOS INFERIORES"
  },
  {
    "codigo":109862002,
    "descripcion":"QUISTE DE LA RED TESTICULAR"
  },
  {
    "codigo":208166005,
    "descripcion":"FRACTURA NO EXPUESTA ESTABLE DE RAMAS PÚBICAS MÚLTIPLES"
  },
  {
    "codigo":699686007,
    "descripcion":"AFLOJAMIENTO DE TORNILLO DE IMPLANTE DENTAL"
  },
  {
    "codigo":372006007,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL PREPUCIO"
  },
  {
    "codigo":271867001,
    "descripcion":"SALIVA ANORMAL"
  },
  {
    "codigo":1287675001,
    "descripcion":"CONVULSIÓN EPILÉPTICA DE CORTEZA MOTORA SUPLEMENTARIA DE LÓBULO FRONTAL"
  },
  {
    "codigo":239099001,
    "descripcion":"ERUPCIÓN FACIAL AFROCARIBEÑA DE LA INFANCIA"
  },
  {
    "codigo":402939001,
    "descripcion":"PIODERMIA BACTERIANA"
  },
  {
    "codigo":763387005,
    "descripcion":"DISTROFIA MACULAR VITELIFORME DE BEST"
  },
  {
    "codigo":9723006,
    "descripcion":"HIPERFOSFATASEMIA CON ENFERMEDAD ÓSEA"
  },
  {
    "codigo":8191000119104,
    "descripcion":"ARTROPATÍA DE MUÑECA DEBIDA A TRASTORNO NEUROLÓGICO"
  },
  {
    "codigo":237264000,
    "descripcion":"RUPTURA ESPONTÁNEA DE LA MEMBRANA AMNIÓTICA POR DETRÁS DE LA PRESENTACIÓN FETAL"
  },
  {
    "codigo":1254907009,
    "descripcion":"DERMATITIS ATÓPICA INFANTIL IMPETIGINIZADA"
  },
  {
    "codigo":514793471000119104,
    "descripcion":"SÍNDROME DE USHER TIPO 1F"
  },
  {
    "codigo":335871000119105,
    "descripcion":"CATARATA POLAR SUBCAPSULAR ANTERIOR CONGÉNITA DE OJO DERECHO"
  },
  {
    "codigo":1187536004,
    "descripcion":"FORMA INFANTIL SEVERA DE DEFICIENCIA DE CARNITINA PALMITOILTRANSFERASA II"
  },
  {
    "codigo":7888004,
    "descripcion":"NACIMIENTO DE TÉRMINO DE CUATRILLIZOS"
  },
  {
    "codigo":827088007,
    "descripcion":"REFLEJO DE ACOMODACIÓN REACTIVO"
  },
  {
    "codigo":268197001,
    "descripcion":"PALADAR HENDIDO CENTRAL INCOMPLETO"
  },
  {
    "codigo":1073151000119107,
    "descripcion":"ARTRITIS DE CADERA IZQUIERDA CAUSADA POR STREPTOCOCCUS"
  },
  {
    "codigo":399269003,
    "descripcion":"ARTROPATÍA"
  },
  {
    "codigo":169893006,
    "descripcion":"TALLA AL NACER = ENTRE PERCENTILOS 90 Y 96"
  },
  {
    "codigo":299130003,
    "descripcion":"DEFORMIDAD DEL PULGAR"
  },
  {
    "codigo":397434007,
    "descripcion":"INFECCIÓN CAUSADA POR CORYNEBACTERIUM"
  },
  {
    "codigo":102522009,
    "descripcion":"EDAD ENTRE 19 Y 59 AÑOS"
  },
  {
    "codigo":227481000119105,
    "descripcion":"MESOTELIOMA MALIGNO DE MESOCOLON"
  },
  {
    "codigo":262692002,
    "descripcion":"ESTALLIDO DE LÓBULO DEL CEREBRO"
  },
  {
    "codigo":721444004,
    "descripcion":"SÍNDROME DEL CORDÓN CENTRAL DE MÉDULA ESPINAL AL NIVEL DEL SEGUNDO SEGMENTO DORSAL"
  },
  {
    "codigo":295460005,
    "descripcion":"SOBREDOSIS DE CÁSCARA SAGRADA"
  },
  {
    "codigo":548004,
    "descripcion":"SÍNDROME DE TRISOMÍA PARCIAL 13P"
  },
  {
    "codigo":33316007,
    "descripcion":"GANGLIOSIDOSIS GM 2"
  },
  {
    "codigo":31481000,
    "descripcion":"ANOMALÍA VASCULAR DEL CORDÓN UMBILICAL"
  },
  {
    "codigo":129785001,
    "descripcion":"POSICIÓN DE LA PROLONGACIÓN AXILAR EN LA MAMOGRAFÍA"
  },
  {
    "codigo":64249002,
    "descripcion":"EOSINOFILIA ALÉRGICA"
  },
  {
    "codigo":162553001,
    "descripcion":"SUELE DESAYUNAR"
  },
  {
    "codigo":1078222000,
    "descripcion":"SEPARACIÓN IRREGULAR DE DIENTES"
  },
  {
    "codigo":293625009,
    "descripcion":"ALERGIA A NAPROXENO"
  },
  {
    "codigo":195321008,
    "descripcion":"EMBOLIA Y TROMBOSIS DE LA ARTERIA CUBITAL"
  },
  {
    "codigo":160718003,
    "descripcion":"NO SE PERMITEN NIÑOS EN LA CASA"
  },
  {
    "codigo":717774004,
    "descripcion":"TRASTORNO CONGÉNITO DE LA GLICOSILACIÓN POR ALTERACIÓN DE COG8"
  },
  {
    "codigo":95182008,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL VÓMER"
  },
  {
    "codigo":93347003,
    "descripcion":"POSICIÓN ANÓMALA CONGÉNITA DE LA ARTERIA PULMONAR"
  },
  {
    "codigo":224419004,
    "descripcion":"INSTALACIONES PARA EL LAVADO DE MANOS ADECUADAS EN EL TRABAJO"
  },
  {
    "codigo":58744002,
    "descripcion":"INTOXICACIÓN POR VINCA"
  },
  {
    "codigo":1303928003,
    "descripcion":"GLAUCOMA DE ÁNGULO ABIERTO SECUNDARIO DE OJO IZQUIERDO"
  },
  {
    "codigo":124280005,
    "descripcion":"DEFICIENCIA DE AMIDOFOSFORRIBOSILTRANSFERASA"
  },
  {
    "codigo":286285005,
    "descripcion":"DIFICULTAD PARA USAR CLICS AL HABLAR"
  },
  {
    "codigo":417357006,
    "descripcion":"DREPANOCITOSIS POR HEMOGLOBINA S"
  },
  {
    "codigo":22306000,
    "descripcion":"DEFICIENCIA TRANSITORIA DE SOMATOTROFINA"
  },
  {
    "codigo":87842000,
    "descripcion":"SÍNDROME DE AGOTAMIENTO NEUROMUSCULAR GENERALIZADO"
  },
  {
    "codigo":415522008,
    "descripcion":"PRESCRIPCIÓN DE ATENCIÓN COMPARTIDA"
  },
  {
    "codigo":249847000,
    "descripcion":"POSTURA DISTÓNICA"
  },
  {
    "codigo":315383001,
    "descripcion":"NACIDO EN BIELORRUSIA"
  },
  {
    "codigo":446455004,
    "descripcion":"LACERACIÓN PROFUNDA DE MUSLO"
  },
  {
    "codigo":774135008,
    "descripcion":"DOLOR EN EL OMÓPLATO IZQUIERDO"
  },
  {
    "codigo":282615009,
    "descripcion":"INCAPAZ DE ARRASTRAR LOS PIES"
  },
  {
    "codigo":248012001,
    "descripcion":"PROBLEMA DE CARÁCTER"
  },
  {
    "codigo":84172003,
    "descripcion":"ESPONDILITIS"
  },
  {
    "codigo":444620007,
    "descripcion":"INCONTINENCIA URINARIA DE ESFUERZO MASCULINA"
  },
  {
    "codigo":410017000,
    "descripcion":"LIPODERMATOSCLEROSIS POSFLEBÍTICA"
  },
  {
    "codigo":211574000,
    "descripcion":"LESIÓN TRAUMÁTICA CERRADA POR APLASTAMIENTO DE LA MANO, DORSO"
  },
  {
    "codigo":735862002,
    "descripcion":"MÚLTIPLES LESIONES TRAUMÁTICAS SUPERFICIALES DE PIE"
  },
  {
    "codigo":13131000,
    "descripcion":"ESPONDILOLISTESIS, GRADO 3"
  },
  {
    "codigo":734027002,
    "descripcion":"DIASTEMA DENTAL DE LA LÍNEA MEDIA"
  },
  {
    "codigo":209739006,
    "descripcion":"SECCIÓN EXPUESTA DE LIGAMENTO CRICOARITENOIDE"
  },
  {
    "codigo":78667006,
    "descripcion":"DISTIMIA"
  },
  {
    "codigo":699424002,
    "descripcion":"ESCARA ASOCIADA A DENTÍFRICO"
  },
  {
    "codigo":76832002,
    "descripcion":"AMPOLLA DE LA MUÑECA, CON INFECCIÓN"
  },
  {
    "codigo":764960005,
    "descripcion":"INSUFICIENCIA SUPRARRENAL HEREDITARIA AISLADA DEBIDA A DEFICIENCIA PARCIAL DE CYP11A1"
  },
  {
    "codigo":109600005,
    "descripcion":"PULPITIS IRREVERSIBLE"
  },
  {
    "codigo":11296007,
    "descripcion":"ESTENOSIS DE LA TRÁQUEA"
  },
  {
    "codigo":10633831000119106,
    "descripcion":"CELULITIS DE ANTEBRAZO IZQUIERDO"
  },
  {
    "codigo":207904007,
    "descripcion":"FRACTURA NO EXPUESTA DE VÉRTEBRA CERVICAL, EN CUÑA"
  },
  {
    "codigo":402677005,
    "descripcion":"FENÓMENO DE RAYNAUD DEBIDO A TRAUMATISMO"
  },
  {
    "codigo":238837009,
    "descripcion":"DERMATOSIS ATRÓFICA DIFUSA Y MACULAR DE STEVANOVIC"
  },
  {
    "codigo":73162004,
    "descripcion":"PÚRPURA POST - TRANSFUSIÓN"
  },
  {
    "codigo":1285578005,
    "descripcion":"INFECCIÓN DE INTESTINO CAUSADA POR CLOSTRIDIUM BOTULINUM EN VIDA ADULTA"
  },
  {
    "codigo":366239000,
    "descripcion":"PERMEABILIDAD DE CONDUCTO SALIVAL - HALLAZGO"
  },
  {
    "codigo":5791006,
    "descripcion":"CICATRIZ DE ADENOIDE"
  },
  {
    "codigo":300703006,
    "descripcion":"NO EMITE CHEQUES"
  },
  {
    "codigo":10935041000119105,
    "descripcion":"FRACTURA NO EXPUESTA DE FALANGE DISTAL DE DEDO ANULAR DE MANO IZQUIERDA"
  },
  {
    "codigo":167796003,
    "descripcion":"MORFOLOGÍA DE LOS ESPERMATOZOIDES - AUSENCIA DE FORMAS NORMALES"
  },
  {
    "codigo":298868005,
    "descripcion":"ARTICULACIÓN DE HOMBRO HELADA AL TACTO"
  },
  {
    "codigo":724852006,
    "descripcion":"LIPOMATOSIS DE TEJIDO SUBCUTÁNEO"
  },
  {
    "codigo":397172008,
    "descripcion":"ENFERMEDAD DE CROHN GASTROINTESTINAL"
  },
  {
    "codigo":2121004,
    "descripcion":"INTOXICACIÓN POR PROFENAMINA"
  },
  {
    "codigo":297033007,
    "descripcion":"SOBREDOSIS DE DIURÉTICO OSMÓTICO"
  },
  {
    "codigo":723017008,
    "descripcion":"DESPLAZAMIENTO DE LENTE INTRAOCULAR"
  },
  {
    "codigo":340891000119102,
    "descripcion":"EPÍFORA DE OJO IZQUIERDO"
  },
  {
    "codigo":33054004,
    "descripcion":"POLIMERIZACIÓN"
  },
  {
    "codigo":721182004,
    "descripcion":"ATRESIA DE ESÓFAGO CON BRECHA AMPLIA"
  },
  {
    "codigo":229662006,
    "descripcion":"DISFASIA MIXTA"
  },
  {
    "codigo":426270006,
    "descripcion":"ANEURISMA DE AORTA SUPRARRENAL"
  },
  {
    "codigo":295198004,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE MEPERIDINA"
  },
  {
    "codigo":719347005,
    "descripcion":"SALE DE LA SILLA SIN USAR LOS BRAZOS"
  },
  {
    "codigo":29384001,
    "descripcion":"TRASTORNO DEL ESTÓMAGO"
  },
  {
    "codigo":424435009,
    "descripcion":"PSEUDODENDRITAS POR HERPES ZÓSTER"
  },
  {
    "codigo":293363009,
    "descripcion":"REACCIÓN ADVERSA AL SULFATO FERROSO DE GLICINA"
  },
  {
    "codigo":94920007,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE PULMÓN"
  },
  {
    "codigo":191389000,
    "descripcion":"METAHEMOGLOBINEMIA IDIOPÁTICA"
  },
  {
    "codigo":289693000,
    "descripcion":"POSICIÓN NORMAL DEL ÚTERO GRÁVIDO"
  },
  {
    "codigo":1141661004,
    "descripcion":"MELANOSIS NEUROCUTÁNEA"
  },
  {
    "codigo":93085005,
    "descripcion":"FENESTRACIÓN CONGÉNITA DE HUESO PARIETAL"
  },
  {
    "codigo":60317006,
    "descripcion":"CONVULSIÓN SENSIBLE A CIERTOS PATRONES"
  },
  {
    "codigo":224157007,
    "descripcion":"INSTALACIONES DE TELEFONÍA PÚBLICA"
  },
  {
    "codigo":1172594000,
    "descripcion":"SÍNDROME DE AGENESIA LABIOESCROTAL CONGÉNITA, MALFORMACIÓN CEREBELOSA, DISTROFIA CORNEAL, DISMORFIA FACIAL"
  },
  {
    "codigo":255090000,
    "descripcion":"NEOPLASIA MALIGNA DE HUESOS DEL CARPO"
  },
  {
    "codigo":89415002,
    "descripcion":"HIPERSOMNIA RELACIONADA CON OTRO TRASTORNO MENTAL"
  },
  {
    "codigo":253255002,
    "descripcion":"OREJA SIMPLE"
  },
  {
    "codigo":286023008,
    "descripcion":"CONECTA EL ENCHUFE"
  },
  {
    "codigo":284188001,
    "descripcion":"QUEMADURA DE VÍA RESPIRATORIA"
  },
  {
    "codigo":52977000,
    "descripcion":"EXANGUINACIÓN FETAL"
  },
  {
    "codigo":448028009,
    "descripcion":"ANEURISMA CONGÉNITO DE REGIÓN SUBMITRAL DE VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":85745007,
    "descripcion":"ORIENTACIÓN SEXUAL EGOSINTÓNICA"
  },
  {
    "codigo":249585009,
    "descripcion":"HALLAZGO DE VEJIGA URINARIA"
  },
  {
    "codigo":870342005,
    "descripcion":"COMPRESIÓN DE MÉDULA ESPINAL DEBIDA A TRASTORNO GRANULOMATOSO"
  },
  {
    "codigo":1263558008,
    "descripcion":"LESIÓN DE NERVIO SAFENO"
  },
  {
    "codigo":16539002,
    "descripcion":"SENSIBILIDAD AUMENTADA DE LA PIEL"
  },
  {
    "codigo":442523003,
    "descripcion":"HALLAZGO RELACIONADO CON CICATRIZ QUIRÚRGICA"
  },
  {
    "codigo":704667004,
    "descripcion":"HIPERTENSIÓN CONCOMITANTE CON ENFERMEDAD RENAL TERMINAL EN DIÁLISIS Y DEBIDA A ELLA"
  },
  {
    "codigo":473456000,
    "descripcion":"TRASTORNO COMPULSIVO DE LA PERSONALIDAD"
  },
  {
    "codigo":14704002,
    "descripcion":"ENFERMEDAD POR VIRUS DUVENHAGE"
  },
  {
    "codigo":406085003,
    "descripcion":"TAMAÑO DE NÓDULO TUMORAL, NO PUEDE SER EVALUADO"
  },
  {
    "codigo":12869004,
    "descripcion":"TRASTORNO PRIMARIO DEL SENTIDO DEL GUSTO DE LOS SABORES SALADOS"
  },
  {
    "codigo":78405005,
    "descripcion":"EFECTO TÓXICO DE COMPUESTO DE PLOMO ORGÁNICO"
  },
  {
    "codigo":109338001,
    "descripcion":"OSTEORRADIONECROSIS DE HUESO TEMPORAL"
  },
  {
    "codigo":240410002,
    "descripcion":"REACCIÓN LEPROSA TIPO 2"
  },
  {
    "codigo":343401000119103,
    "descripcion":"ESTAFILOMA POSTERIOR DE AMBOS OJOS"
  },
  {
    "codigo":402415001,
    "descripcion":"SÍNDROME DE SCHNITZLER"
  },
  {
    "codigo":238575004,
    "descripcion":"DERMATITIS POR CONTACTO ALÉRGICA"
  },
  {
    "codigo":72900001,
    "descripcion":"SÍNDROME DE POLIPOSIS MÚLTIPLE FAMILIAR"
  },
  {
    "codigo":369647009,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA DE LA VAGINA, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":236740006,
    "descripcion":"NEOPLASIA DE VESÍCULA SEMINAL"
  },
  {
    "codigo":105668007,
    "descripcion":"ENFERMEDAD CAUSADA POR DICROCOELIIDAE"
  },
  {
    "codigo":202137000,
    "descripcion":"CONDROPATÍA ARTICULAR DE LA REGIÓN PÉLVICA Y EL MUSLO"
  },
  {
    "codigo":302276008,
    "descripcion":"INCAPAZ DE TRASLADARSE DE LA SILLA DE RUEDAS AL INODORO"
  },
  {
    "codigo":300441003,
    "descripcion":"HALLAZGO RELACIONADO CON LA APARIENCIA DE LOS RIÑONES"
  },
  {
    "codigo":38297003,
    "descripcion":"OSTEOMIELITIS CRÓNICA DE LA MANDÍBULA"
  },
  {
    "codigo":365977007,
    "descripcion":"HALLAZGO RELACIONADO CON EL PATRÓN DE FIEBRE"
  },
  {
    "codigo":396910001,
    "descripcion":"ESTADIO IIB: INVASIÓN CAPSULAR MACROSCÓPICA HACIA LA GRASA TÍMICA O PERIVISCERAL, O MACROSCÓPICAMENTE ADHERIDO A, PERO ATRAVESÁNDOLA, A LA PLEURA MEDIASTÍNICA O PERICARDIO (TIMO)"
  },
  {
    "codigo":724590008,
    "descripcion":"NEOPLASIA OSTEÓGENA BENIGNA DE CARTÍLAGO ARTICULAR DE CLAVÍCULA"
  },
  {
    "codigo":67395002,
    "descripcion":"RUIDOS RESPIRATORIOS ANFÓRICOS"
  },
  {
    "codigo":460611002,
    "descripcion":"INSERCIÓN ANÓMALA DE CONDUCTO ARTERIOSO EN ARTERIA PULMONAR DERECHA"
  },
  {
    "codigo":296771004,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE CLORANFENICOL"
  },
  {
    "codigo":34627006,
    "descripcion":"CAPACIDAD DE DIFUSIÓN PULMONAR DISMINUIDA"
  },
  {
    "codigo":1148739007,
    "descripcion":"HIDROCEFALIA OBSTRUCTIVA DEBIDA A COMPRESIÓN DE ASTA INFERIOR DEL VENTRÍCULO LATERAL"
  },
  {
    "codigo":788291006,
    "descripcion":"LINFANGIECTASIA ADQUIRIDA"
  },
  {
    "codigo":1343512002,
    "descripcion":"SÍNDROME DE CORDÓN POSTERIOR DEBIDO A MALFORMACIÓN VASCULAR"
  },
  {
    "codigo":196632005,
    "descripcion":"ÚLCERA GÁSTRICA AGUDA CON OBSTRUCCIÓN"
  },
  {
    "codigo":131096007,
    "descripcion":"NIVEL DE TRIYODOTIRONINA POR DEBAJO DE RANGO DE REFERENCIA"
  },
  {
    "codigo":293101000,
    "descripcion":"REACCIÓN ADVERSA A INMUNOGLOBULINA ANTI-HEPATITIS B"
  },
  {
    "codigo":424173004,
    "descripcion":"VISIÓN A DISTANCIA 6\/120"
  },
  {
    "codigo":63725005,
    "descripcion":"LESIÓN DE CÓRNEA"
  },
  {
    "codigo":782786001,
    "descripcion":"HIPEROSTOSIS DE LA CALOTA CRANEAL LIGADA AL CROMOSOMA X"
  },
  {
    "codigo":153091000119109,
    "descripcion":"COMA HEPÁTICO DEBIDO A HEPATITIS B CRÓNICA CON AGENTE DELTA"
  },
  {
    "codigo":422338006,
    "descripcion":"TRASTORNO DEGENERATIVO DE LA MÁCULA"
  },
  {
    "codigo":291266009,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR CAFEÍNA"
  },
  {
    "codigo":94658009,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL URACO"
  },
  {
    "codigo":715415005,
    "descripcion":"SÍNDROME DE RICHARDS-RUNDLE"
  },
  {
    "codigo":289431008,
    "descripcion":"MOVIMIENTOS FETALES, PRESENTES"
  },
  {
    "codigo":123756000,
    "descripcion":"SÍNDROME MENOPÁUSICO"
  },
  {
    "codigo":189292002,
    "descripcion":"CARCINOMA IN SITU DEL CUERO CABELLUDO"
  },
  {
    "codigo":125591009,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA FARINGE"
  },
  {
    "codigo":1336172007,
    "descripcion":"GANGLIONEUROBLASTOMA METASTÁSICO"
  },
  {
    "codigo":15992631000119101,
    "descripcion":"NEURORRETINITIS DE OJO DERECHO"
  },
  {
    "codigo":56385004,
    "descripcion":"LESIÓN TRAUMÁTICA DE VESÍCULA BILIAR CON HERIDA ABIERTA HACIA CAVIDAD ABDOMINAL"
  },
  {
    "codigo":416833005,
    "descripcion":"FRACTURA-LUXACIÓN NO EXPUESTA DE ARTICULACIÓN DE LA CINTURA ESCAPULAR"
  },
  {
    "codigo":285761007,
    "descripcion":"AGNOSIA PARA EL DOLOR"
  },
  {
    "codigo":449601008,
    "descripcion":"FENESTRACIÓN DE CÚSPIDE DE VÁLVULA PULMONAR"
  },
  {
    "codigo":21782001,
    "descripcion":"ESTREÑIMIENTO MEDICAMENTOSO"
  },
  {
    "codigo":447766003,
    "descripcion":"LINFOMA DE ANTRO PILÓRICO DE ESTÓMAGO"
  },
  {
    "codigo":251158004,
    "descripcion":"TAQUICARDIA VENTRICULAR, MONOMORFA"
  },
  {
    "codigo":290461000119109,
    "descripcion":"HEMIPLEJÍA ESPÁSTICA DE LADO IZQUIERDO DOMINANTE"
  },
  {
    "codigo":283926005,
    "descripcion":"RUPTURA DE LA URETRA"
  },
  {
    "codigo":87318008,
    "descripcion":"SÍFILIS CONGÉNITA CON GOMA SIFILÍTICO"
  },
  {
    "codigo":249323003,
    "descripcion":"TABIQUE NASAL ANORMALMENTE ALTO"
  },
  {
    "codigo":445931006,
    "descripcion":"INTOXICACIÓN POR HUMOS"
  },
  {
    "codigo":183787006,
    "descripcion":"INSCRIPTO EN LISTA DE ADMISIÓN NEUROQUIRÚRGICA"
  },
  {
    "codigo":216555007,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR PSILOCINA"
  },
  {
    "codigo":52715007,
    "descripcion":"FIEBRE CÍCLICA"
  },
  {
    "codigo":247488004,
    "descripcion":"BRAQUIONIQUIA"
  },
  {
    "codigo":10281000132103,
    "descripcion":"SEGMENTO DE COLON NO PREPARADO CON MUCOSA NO VISIBLE DEBIDO A LA PRESENCIA DE HECES SÓLIDAS QUE NO PUEDEN ELIMINARSE"
  },
  {
    "codigo":81813004,
    "descripcion":"LUXACIÓN CERRADA MEDIAL DE CODO"
  },
  {
    "codigo":243818000,
    "descripcion":"ESTADO DE ANTICONCEPCIÓN CON DISPOSITIVO INTRAUTERINO"
  },
  {
    "codigo":737173008,
    "descripcion":"INFLAMACIÓN DE CORDÓN ESPERMÁTICO"
  },
  {
    "codigo":1259626002,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE PARAGANGLIOS"
  },
  {
    "codigo":276586004,
    "descripcion":"ACIDOSIS TUBULAR RENAL TRANSITORIA DEL RECIÉN NACIDO"
  },
  {
    "codigo":473194005,
    "descripcion":"AFLOJAMIENTO DE DISPOSITIVO ORTOPÉDICO"
  },
  {
    "codigo":79978005,
    "descripcion":"FRACTURA EXPUESTA DE FÉMUR, SUPRACONDÍLEA"
  },
  {
    "codigo":209215000,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA NO EXPUESTA DE LA ARTICULACIÓN ESTERNOCLAVICULAR, POSTERIOR"
  },
  {
    "codigo":274751001,
    "descripcion":"MASA DE CABEZA Y\/O CUELLO"
  },
  {
    "codigo":211050009,
    "descripcion":"ABRASIÓN DE VULVA"
  },
  {
    "codigo":307519003,
    "descripcion":"TRASTORNO DE ESTOMA UROLÓGICO"
  },
  {
    "codigo":11788241000119104,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE DEDO DE MANO IZQUIERDA"
  },
  {
    "codigo":241983006,
    "descripcion":"BAROTRAUMA DESCENDENTE DE SENOS PARANASALES"
  },
  {
    "codigo":373055008,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM PORIFERAE"
  },
  {
    "codigo":15720401000119105,
    "descripcion":"TRASTORNO DE CARTÍLAGO ARTICULAR DE AMBAS MANOS"
  },
  {
    "codigo":240148003,
    "descripcion":"OSTEOMIELITIS CRÓNICA DE TOBILLO"
  },
  {
    "codigo":829972004,
    "descripcion":"HEMORRAGIA DIFUSA DE ALVÉOLOS PULMONARES"
  },
  {
    "codigo":305684006,
    "descripcion":"ATENDIDO POR UN NEURÓLOGO"
  },
  {
    "codigo":698900008,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: HÚNGARO"
  },
  {
    "codigo":402153000,
    "descripcion":"DERMATOSIS CAUSADA POR ESCORPIÓN"
  },
  {
    "codigo":403988009,
    "descripcion":"FASCITIS NODULAR INTRADÉRMICA"
  },
  {
    "codigo":205545009,
    "descripcion":"ELEFANTIASIS CONGÉNITA"
  },
  {
    "codigo":203710002,
    "descripcion":"ESTENOSIS DE CONDUCTO VERTEBRAL DEBIDA A SUBLUXACIÓN"
  },
  {
    "codigo":7102003,
    "descripcion":"QUISTE EPIPLOICO"
  },
  {
    "codigo":762601009,
    "descripcion":"DOLOR VISCERAL CRÓNICO DEBIDO A INFLAMACIÓN PERSISTENTE"
  },
  {
    "codigo":1119379000,
    "descripcion":"AUSENCIA DE SENSACIÓN DEL LADO DERECHO DEL TRONCO"
  },
  {
    "codigo":302014008,
    "descripcion":"RETRACCIÓN DE PÁRPADO SUPERIOR"
  },
  {
    "codigo":234643002,
    "descripcion":"INMUNODEFICIENCIA TRANSITORIA DEL LACTANTE"
  },
  {
    "codigo":300179001,
    "descripcion":"NO SE VISUALIZA ESTRIBO"
  },
  {
    "codigo":236478009,
    "descripcion":"HIPOURICEMIA RENAL FAMILIAR"
  },
  {
    "codigo":42401000087102,
    "descripcion":"HERIDA PUNZANTE DE EXTREMIDAD SUPERIOR IZQUIERDA CON CUERPO EXTRAÑO"
  },
  {
    "codigo":34721000087105,
    "descripcion":"ASPERGILLUS OCHRACEUS O ASPERGILLUS WESTERDIJKIAE"
  },
  {
    "codigo":47521000087106,
    "descripcion":"CONSENTIMIENTO LIBRE E INFORMADO PARA SEDACIÓN ENTREGADO"
  },
  {
    "codigo":55201000087108,
    "descripcion":"CON MAYOR RIESGO DE TROMBOFLEBITIS"
  },
  {
    "codigo":39841000087109,
    "descripcion":"LUXACIÓN DE ARTICULACIÓN DE TOBILLO DERECHO"
  },
  {
    "codigo":298344006,
    "descripcion":"CAÍDA DE UN ANCIANO"
  },
  {
    "codigo":1345085000,
    "descripcion":"ENTEROCOLITIS INDUCIDA POR TRATAMIENTO CON INHIBIDOR DE PUNTO DE CONTROL INMUNITARIO"
  },
  {
    "codigo":427581001,
    "descripcion":"ELECTROCARDIOGRAMA: LATIDOS ECTÓPICOS CON CONTRACCIONES VENTRICULARES MULTIFOCALES PREMATURAS"
  },
  {
    "codigo":296509004,
    "descripcion":"SOBREDOSIS DE PROSTAGLANDINA"
  },
  {
    "codigo":165437005,
    "descripcion":"HEMOGLOBINA CORPUSCULAR MEDIA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":722493007,
    "descripcion":"DISGENESIA CAUDAL FAMILIAR"
  },
  {
    "codigo":294674002,
    "descripcion":"ALERGIA A CARBIMAZOL"
  },
  {
    "codigo":425746004,
    "descripcion":"DOLOR PROVOCADO POR LUZ"
  },
  {
    "codigo":1179410005,
    "descripcion":"TRASTORNO INFECCIOSO PERINATAL DE FETO Y\/O NEONATO"
  },
  {
    "codigo":1144807000,
    "descripcion":"VÁRICES VENOSAS DE AMBAS EXTREMIDADES INFERIORES EN EL EMBARAZO"
  },
  {
    "codigo":292839000,
    "descripcion":"REACCIÓN ADVERSA AL INTERFERÓN-A-N1"
  },
  {
    "codigo":818962009,
    "descripcion":"CISTADENOMA SEROMUCINOSO DE OVARIO EN LA INFANCIA"
  },
  {
    "codigo":128999004,
    "descripcion":"TRASTORNO INFLAMATORIO DEL TUBO DIGESTIVO"
  },
  {
    "codigo":94396003,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LOS GANGLIOS LINFÁTICOS DE SITIOS MÚLTIPLES"
  },
  {
    "codigo":127164004,
    "descripcion":"LINFADENOPATÍA DEL PROMONTORIO"
  },
  {
    "codigo":422076005,
    "descripcion":"TRASTORNO ALÉRGICO MEDIADO POR IGE"
  },
  {
    "codigo":225468007,
    "descripcion":"TOLERANCIA CON RESIGNACIÓN"
  },
  {
    "codigo":27025001,
    "descripcion":"SÍNDROME DE DISPLASIA ECTODÉRMICA HIPOHIDRÓTICA AUTOSÓMICA RECESIVA"
  },
  {
    "codigo":816131000000108,
    "descripcion":"ACORTAMIENTO PROGRESIVO DE CUELLO DE ÚTERO"
  },
  {
    "codigo":57958006,
    "descripcion":"MIOPATÍA ENDOCRINA"
  },
  {
    "codigo":713318009,
    "descripcion":"MIOCARDITIS CONCOMITANTE CON INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":1268539002,
    "descripcion":"CARCINOMA METAPLÁSICO PRIMARIO DE MAMA"
  },
  {
    "codigo":711483003,
    "descripcion":"ATROFIA DE MÚSCULOS ESPINALES CON DISTRÉS RESPIRATORIO TIPO 1"
  },
  {
    "codigo":285499004,
    "descripcion":"MUEVE LA LENGUA"
  },
  {
    "codigo":187195003,
    "descripcion":"MIOCARDITIS POR TOXOPLASMA"
  },
  {
    "codigo":416571005,
    "descripcion":"ALUCINACIONES TRANSITORIAS"
  },
  {
    "codigo":54288002,
    "descripcion":"ENFISEMA SUBCUTÁNEO TRAUMÁTICO"
  },
  {
    "codigo":185360007,
    "descripcion":"DERIVADO POR MÉDICO DEL HOSPITAL"
  },
  {
    "codigo":283664009,
    "descripcion":"HERIDA POR PINCHAZO DE CLAVO EN DEDO DE LA MANO"
  },
  {
    "codigo":871653003,
    "descripcion":"PERFORACIÓN DE CONDUCTO ARTERIOSO DESPUÉS DE PROCEDIMIENTO"
  },
  {
    "codigo":183525003,
    "descripcion":"DERIVADO A ESPECIALISTA EN ENFERMEDADES VENÉREAS"
  },
  {
    "codigo":249061006,
    "descripcion":"PARTES FETALES DISTINGUIBLES A TRAVÉS DEL ABDOMEN"
  },
  {
    "codigo":247226000,
    "descripcion":"DRUSAS DE PAPILA ÓPTICA - ELEVADAS"
  },
  {
    "codigo":771514002,
    "descripcion":"SÍNDROME DE NEURODEGENERACIÓN PROGRESIVA, CEGUERA, ATAXIA Y ESPASTICIDAD DE INICIO TEMPRANO"
  },
  {
    "codigo":1230266009,
    "descripcion":"PATRÓN DE USO PERJUDICIAL DE ANFETAMINA Y\/O DERIVADO DE ANFETAMINA EN REMISIÓN"
  },
  {
    "codigo":14180000,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA VENA ESPLÉNICA"
  },
  {
    "codigo":81551009,
    "descripcion":"INFECCIÓN CAUSADA POR LEISHMANIA INFANTUM"
  },
  {
    "codigo":1461851000168101,
    "descripcion":"TIEMPO DE PANTALLA EXCESIVO"
  },
  {
    "codigo":210788007,
    "descripcion":"LESIÓN TRAUMÁTICA NO EXPUESTA DE VENA SUBCLAVIA"
  },
  {
    "codigo":45113005,
    "descripcion":"SUSTANCIA SIN CÓDIGO ASIGNADO EN SNOMED"
  },
  {
    "codigo":77881008,
    "descripcion":"OSTEOCONDROPATÍA"
  },
  {
    "codigo":405561009,
    "descripcion":"LESIÓN TRAUMÁTICA DE LIGAMENTO DE COLUMNA CERVICAL"
  },
  {
    "codigo":12345009,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DEL TRONCO, CON INFECCIÓN"
  },
  {
    "codigo":76046001,
    "descripcion":"ÚLCERA DE PENE"
  },
  {
    "codigo":403726004,
    "descripcion":"CICATRIZ DEBIDA A RADIOTERAPIA Y POSTERIOR A ELLA"
  },
  {
    "codigo":698638005,
    "descripcion":"HIPERTENSIÓN INDUCIDA POR EL EMBARAZO CON EDEMA PULMONAR"
  },
  {
    "codigo":733241009,
    "descripcion":"LACERACIÓN DE DEDO DE LA MANO CON CUERPO EXTRAÑO"
  },
  {
    "codigo":239886003,
    "descripcion":"LUPUS ERITEMATOSO LIMITADO"
  },
  {
    "codigo":895246001,
    "descripcion":"FORMA TRIANGULAR ANORMAL CONGÉNITA DE FALANGE DISTAL DE DEDO ÍNDICE"
  },
  {
    "codigo":370958009,
    "descripcion":"FUGA DE HUMOR ACUOSO NO DETECTADA POR PRUEBA DE SEIDEL"
  },
  {
    "codigo":208953009,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA NO EXPUESTA DE LA ARTICULACIÓN FEMORORROTULIANA"
  },
  {
    "codigo":238051008,
    "descripcion":"SIALURIA"
  },
  {
    "codigo":762339009,
    "descripcion":"TRASTORNO DEL ESTADO DE ÁNIMO CON SÍNTOMAS DEPRESIVOS CAUSADO POR INHALANTE VOLÁTIL"
  },
  {
    "codigo":72376001,
    "descripcion":"EFECTO TÓXICO DEL DIELDRÍN"
  },
  {
    "codigo":301752003,
    "descripcion":"NO REALIZA ACTIVIDADES DE ADMINISTRACIÓN Y SUPERVISIÓN"
  },
  {
    "codigo":41443008,
    "descripcion":"SÍNDROME DE MALFORMACIÓN MÚLTIPLE CON ANOMALÍA DE LOS MIEMBROS COMO CARACTERÍSTICA PRINCIPAL"
  },
  {
    "codigo":299917000,
    "descripcion":"SENSACIÓN AL TACTO FIRME AUSENTE"
  },
  {
    "codigo":234381003,
    "descripcion":"ANEMIA HEMOLÍTICA AUTOINMUNITARIA MATERNA"
  },
  {
    "codigo":540921000124108,
    "descripcion":"MASA DE REGIÓN DE CODO"
  },
  {
    "codigo":365453006,
    "descripcion":"LENGUAJE HABLADO - HALLAZGO"
  },
  {
    "codigo":724066002,
    "descripcion":"SÍNDROME DE POLISINDACTILIA Y MALFORMACIÓN CARDÍACA"
  },
  {
    "codigo":15954901000119100,
    "descripcion":"MAMA IZQUIERDA PÉNDULA"
  },
  {
    "codigo":230711001,
    "descripcion":"HEMORRAGIA TALÁMICA"
  },
  {
    "codigo":298082009,
    "descripcion":"CUERPO EXTRAÑO EN LA PIEL DE LA PALMA DE LA MANO"
  },
  {
    "codigo":722231005,
    "descripcion":"SÍNDROME DE PERLMAN"
  },
  {
    "codigo":1335005,
    "descripcion":"INDURACIÓN PLÁSTICA DE PENE"
  },
  {
    "codigo":296247005,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE PROCLORPERAZINA"
  },
  {
    "codigo":196108004,
    "descripcion":"ABSCESO ÚNICO DE PULMÓN"
  },
  {
    "codigo":65036008,
    "descripcion":"ERITEMA ESCARLATINIFORME"
  },
  {
    "codigo":292577000,
    "descripcion":"REACCIÓN ADVERSA A LA MEBHIDROLINA"
  },
  {
    "codigo":32268008,
    "descripcion":"TUBERCULOSIS DE VEJIGA URINARIA"
  },
  {
    "codigo":194273004,
    "descripcion":"OBSTRUCCIÓN CARTILAGINOSA DE TROMPA DE EUSTAQUIO"
  },
  {
    "codigo":1275617007,
    "descripcion":"MÚLTIPLES LESIONES DE RETINA SIN DESPRENDIMIENTO"
  },
  {
    "codigo":1144545009,
    "descripcion":"HIPOPLASIA CONGÉNITA DE APARATO PILOSEBÁCEO"
  },
  {
    "codigo":16026631000119103,
    "descripcion":"SÍNDROME AURICULOTEMPORAL DE NERVIO AURICULOTEMPORAL IZQUIERDO"
  },
  {
    "codigo":94134006,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA SUPERFICIE VENTRAL DE LA LENGUA"
  },
  {
    "codigo":288907000,
    "descripcion":"CAPAZ DE MOVER EL ALIMENTO EN LA BOCA"
  },
  {
    "codigo":126902008,
    "descripcion":"NEOPLASIA DEL EPIDÍDIMO"
  },
  {
    "codigo":59531002,
    "descripcion":"SÍNDROME DE MALABSORCIÓN DE TRIPTÓFANO"
  },
  {
    "codigo":190603003,
    "descripcion":"DESNUTRICIÓN CALORICOPROTEICA LEVE (75-89% DEL PESO ESTÁNDAR PARA LA EDAD)"
  },
  {
    "codigo":92299006,
    "descripcion":"NEOPLASIA BENIGNA DE GANGLIOS LINFÁTICOS POPLÍTEOS"
  },
  {
    "codigo":385376001,
    "descripcion":"ESTADIO DE LA FEDERACIÓN INTERNACIONAL DE GINECOLOGÍA Y OBSTETRICIA (FIGO) PARA CARCINOMA ENDOMETRIAL - HALLAZGO"
  },
  {
    "codigo":188768003,
    "descripcion":"LEUCEMIA MIELOMONOCÍTICA"
  },
  {
    "codigo":1237344003,
    "descripcion":"FORMA SINTOMÁTICA DEL SÍNDROME DE X FRÁGIL EN MUJERES PORTADORAS"
  },
  {
    "codigo":24928009,
    "descripcion":"DISTENSIÓN DEL MÚSCULO Y\/O DEL TENDÓN DEL INFRAESPINOSO"
  },
  {
    "codigo":449077005,
    "descripcion":"NEOPLASIA EPITELIAL MALIGNA DE MAXILAR SUPERIOR"
  },
  {
    "codigo":55861007,
    "descripcion":"PUERPERIO, 5 DÍAS"
  },
  {
    "codigo":283402000,
    "descripcion":"CORTE EN LA REGIÓN OCULAR"
  },
  {
    "codigo":414474001,
    "descripcion":"EVENTRACIÓN EN PARED ABDOMINAL ANTERIOR"
  },
  {
    "codigo":840458000,
    "descripcion":"COLOBOMA DE AMBOS CRISTALINOS"
  },
  {
    "codigo":21258007,
    "descripcion":"TROMBOSIS DE SENO VENOSO LATERAL"
  },
  {
    "codigo":248799000,
    "descripcion":"ORGASMO EXCESIVO"
  },
  {
    "codigo":54026009,
    "descripcion":"CISTITIS CON INFESTACIÓN POR ECHINOCOCCUS"
  },
  {
    "codigo":445407005,
    "descripcion":"TEMBLOR CRÓNICO"
  },
  {
    "codigo":707551007,
    "descripcion":"GLUCOGENOSIS INTERSTICIAL PULMONAR"
  },
  {
    "codigo":246964000,
    "descripcion":"HALLAZGO RELACIONADO CON LA MEMBRANA DE DESCEMET"
  },
  {
    "codigo":1230004003,
    "descripcion":"DISPLASIA CONGÉNITA DE PUNTA DE NARIZ"
  },
  {
    "codigo":17588005,
    "descripcion":"SACO DE YEMA DE HUEVO ANORMAL"
  },
  {
    "codigo":736649005,
    "descripcion":"MUERDE OBJETOS"
  },
  {
    "codigo":441737006,
    "descripcion":"DEHISCENCIA DE FASCIA"
  },
  {
    "codigo":1259102000,
    "descripcion":"NEUROPATÍA MOTORA PERIFÉRICA AUTOINMUNITARIA"
  },
  {
    "codigo":112222000,
    "descripcion":"PRESIÓN INTRAOCULAR AUMENTADA"
  },
  {
    "codigo":276062005,
    "descripcion":"REGRESO AL TRABAJO LUEGO DE ENFERMEDAD"
  },
  {
    "codigo":210526006,
    "descripcion":"LESIÓN POR DESOLLAMIENTO DE AXILA"
  },
  {
    "codigo":11718971000119100,
    "descripcion":"DIARREA EN EMBARAZO"
  },
  {
    "codigo":1082171000119101,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE PIEL DE EXTREMIDAD SUPERIOR DERECHA"
  },
  {
    "codigo":286011000119101,
    "descripcion":"CALCIFICACIÓN DE ANILLO DE VÁLVULA MITRAL REUMÁTICA"
  },
  {
    "codigo":117051000119103,
    "descripcion":"OCLUSIÓN TOTAL CRÓNICA DE ARTERIA CORONARIA"
  },
  {
    "codigo":334651000119101,
    "descripcion":"NEUROPATÍA ÓPTICA ISQUÉMICA DE OJO DERECHO"
  },
  {
    "codigo":288571000119100,
    "descripcion":"PROBLEMAS PSICOSOCIALES RELACIONADOS CON LA MULTIPARIDAD"
  },
  {
    "codigo":403464001,
    "descripcion":"BALANITIS INFECCIOSA AGUDA"
  },
  {
    "codigo":303931000119107,
    "descripcion":"GOTA CRÓNICA DE MANO, SIN TOFO, DEBIDA A DISFUNCIÓN RENAL"
  },
  {
    "codigo":16908091000119105,
    "descripcion":"NEVO EPIDÉRMICO PILOSO PIGMENTADO DE PÁRPADO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":672571000119109,
    "descripcion":"DÉFICIT COGNITIVO DEBIDO A ACCIDENTE CEREBROVASCULAR HEMORRÁGICO Y POSTERIOR A ÉL"
  },
  {
    "codigo":1087291000119106,
    "descripcion":"HERNIA INTRABDOMINAL INCARCERADA"
  },
  {
    "codigo":274227007,
    "descripcion":"CORTE ACCIDENTAL"
  },
  {
    "codigo":11800891000119109,
    "descripcion":"LACERACIÓN DE RIÑÓN IZQUIERDO"
  },
  {
    "codigo":332091000119105,
    "descripcion":"DESPRENDIMIENTO SEROSO DEL EPITELIO PIGMENTARIO RETINIANO DEL OJO DERECHO"
  },
  {
    "codigo":914587451000119107,
    "descripcion":"ANAFILAXIA CAUSADA POR COMPONENTE DE VACUNA CONTRA SARS-COV-2"
  },
  {
    "codigo":16662331000119106,
    "descripcion":"ANEURISMA DE ARTERIA VERTEBRAL DERECHA"
  },
  {
    "codigo":337211000119109,
    "descripcion":"ORZUELO INTERNO DE PÁRPADO SUPERIOR DE OJO IZQUIERDO"
  },
  {
    "codigo":682811000119109,
    "descripcion":"NEOPLASIA NEUROENDOCRINA BENIGNA DE HÍGADO"
  },
  {
    "codigo":344891000119109,
    "descripcion":"PAPILITIS ÓPTICA BILATERAL"
  },
  {
    "codigo":1351901007,
    "descripcion":"HEMANGIOBLASTOMA DE NERVIO PERIFÉRICO"
  },
  {
    "codigo":235954001,
    "descripcion":"PANCREATITIS CRÓNICA OBSTRUCTIVA"
  },
  {
    "codigo":203186006,
    "descripcion":"OSTEOMIELITIS CRÓNICA DE ANTEBRAZO"
  },
  {
    "codigo":268722008,
    "descripcion":"TRASTORNO NO ORGÁNICO DEL PATRÓN SUEÑO - VIGILIA"
  },
  {
    "codigo":234119001,
    "descripcion":"MALFORMACIÓN ARTERIAL"
  },
  {
    "codigo":135815002,
    "descripcion":"ESTADO GENERAL DE SALUD, BUENO"
  },
  {
    "codigo":300501000119104,
    "descripcion":"TRASTORNO DE TENDÓN DE MANO IZQUIERDA"
  },
  {
    "codigo":365191000,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA LAVARSE LA BOCA"
  },
  {
    "codigo":299655008,
    "descripcion":"AMPUTADO A NIVEL DE LA CURVATURA PLANTAR"
  },
  {
    "codigo":166748006,
    "descripcion":"NIVEL DE COBRE EN SANGRE DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":232284007,
    "descripcion":"VÉRTIGO MIGRAÑOSO"
  },
  {
    "codigo":197681000,
    "descripcion":"SÍNDROME NEFRÍTICO AGUDO, ANOMALÍA GLOMERULAR MENOR"
  },
  {
    "codigo":35676009,
    "descripcion":"INFECCIÓN CAUSADA POR BUXTONELLA"
  },
  {
    "codigo":1073003,
    "descripcion":"XERODERMIA PIGMENTOSA, GRUPO B"
  },
  {
    "codigo":10677871000119101,
    "descripcion":"TUMEFACCIÓN LOCALIZADA DE LA PARED ABDOMINAL"
  },
  {
    "codigo":263217005,
    "descripcion":"FRACTURA DE CRESTA ILÍACA"
  },
  {
    "codigo":66609003,
    "descripcion":"ALUCINACIÓN TÁCTIL"
  },
  {
    "codigo":33841007,
    "descripcion":"NÁUSEAS Y VÓMITOS DISMINUIDOS"
  },
  {
    "codigo":295985007,
    "descripcion":"SOBREDOSIS INTENCIONAL DE METILFENOBARBITAL"
  },
  {
    "codigo":164913009,
    "descripcion":"P MITRAL"
  },
  {
    "codigo":359686005,
    "descripcion":"LEUCOENCEFALITIS ESCLEROSANTE DE VAN BOGAERT"
  },
  {
    "codigo":30171000,
    "descripcion":"TRASTORNO DE GLÁNDULA SUPRARRENAL"
  },
  {
    "codigo":292315000,
    "descripcion":"REACCIÓN ADVERSA A LA BECLAMIDA"
  },
  {
    "codigo":1177051005,
    "descripcion":"INFECCIÓN CAUSADA POR LARVAS DE TRICHINELLA BRITOVI"
  },
  {
    "codigo":128475008,
    "descripcion":"ADENOMA PARATIROIDEO ECTÓPICO"
  },
  {
    "codigo":1306288002,
    "descripcion":"GLAUCOMA DE ÁNGULO ABIERTO PRIMARIO DE OJO DERECHO"
  },
  {
    "codigo":16002671000119106,
    "descripcion":"DOLOR CRÓNICO DE AMBOS MIEMBROS SUPERIORES"
  },
  {
    "codigo":716464006,
    "descripcion":"CAPAZ DE COMPRENDER EL DOLOR GENERALIZADO"
  },
  {
    "codigo":126640008,
    "descripcion":"NEOPLASIA DE LA PARED DEL TÓRAX"
  },
  {
    "codigo":61104008,
    "descripcion":"TRASTORNOS MENTALES ORGÁNICOS INDUCIDOS POR INHALANTES"
  },
  {
    "codigo":92037001,
    "descripcion":"NEOPLASIA BENIGNA DE BRONQUIO DEL LÓBULO SUPERIOR DERECHO DEL PULMÓN"
  },
  {
    "codigo":93872008,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE HUESO LARGO DEL MIEMBRO SUPERIOR"
  },
  {
    "codigo":188506004,
    "descripcion":"LINFOSARCOMA ESPLÉNICO"
  },
  {
    "codigo":417882004,
    "descripcion":"ATENCIÓN PERIOPERATORIA COMPATIBLE CON PLAN DE ATENCIÓN PERIOPERATORIA INDIVIDUALIZADA"
  },
  {
    "codigo":284975000,
    "descripcion":"SE VISTE"
  },
  {
    "codigo":15730441000119105,
    "descripcion":"ESOTROPÍA POR DEPRIVACIÓN SENSITIVA DE AMBOS OJOS"
  },
  {
    "codigo":184836006,
    "descripcion":"INFORME PRELIMINAR DE SEGURO DE VIDA ENVIADO"
  },
  {
    "codigo":283140007,
    "descripcion":"CUERPO EXTRAÑO METÁLICO EN CABEZA Y CUELLO"
  },
  {
    "codigo":709124008,
    "descripcion":"TIROIDITIS FIBROSA CRÓNICA"
  },
  {
    "codigo":445145001,
    "descripcion":"NECROSIS CAUSADA POR RADIACIÓN IONIZANTE"
  },
  {
    "codigo":248537002,
    "descripcion":"ENTRENAMIENTO ESFINTERIANO TARDÍO"
  },
  {
    "codigo":84697003,
    "descripcion":"VOLUMEN PLASMÁTICO DISMINUIDO"
  },
  {
    "codigo":838361004,
    "descripcion":"ARTROPATÍA DEBIDA A HEMOCROMATOSIS"
  },
  {
    "codigo":281305005,
    "descripcion":"FECUNDACIÓN NO DESEADA"
  },
  {
    "codigo":446980008,
    "descripcion":"FRACTURA EXPUESTA DE PLATILLO TIBIAL"
  },
  {
    "codigo":15648521000119107,
    "descripcion":"ANEURISMA DE ARTERIA CARÓTIDA DERECHA"
  },
  {
    "codigo":276360005,
    "descripcion":"PREOCUPACIÓN POR EL PESO CORPORAL"
  },
  {
    "codigo":17326005,
    "descripcion":"BIEN CONSIGO MISMO"
  },
  {
    "codigo":246702006,
    "descripcion":"DESVIACIÓN HACIA ABAJO DE LOS OJOS"
  },
  {
    "codigo":11853731000119103,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DE TOBILLO DERECHO"
  },
  {
    "codigo":703619001,
    "descripcion":"DOLOR EN CINTURA PÉLVICA"
  },
  {
    "codigo":408707005,
    "descripcion":"ESTASIS ARTERIAL"
  },
  {
    "codigo":212099005,
    "descripcion":"QUEMADURA QUE COMPROMETE 70-79 PORCIENTO DE LA SUPERFICIE DEL CUERPO, CON QUEMADURA DE ESPESOR COMPLETO QUE AFECTA 50-59 PORCIENTO DE LA SUPERFICIE CORPORAL"
  },
  {
    "codigo":243032002,
    "descripcion":"LESIÓN POR RÁFAGA DE BOMBA CASERA"
  },
  {
    "codigo":111960003,
    "descripcion":"CAMINAR DESCALZO"
  },
  {
    "codigo":765485000,
    "descripcion":"SÍNDROME DE CROMOSOMA 2 EN ANILLO"
  },
  {
    "codigo":273965001,
    "descripcion":"DERMATOSIS POR CUERPO EXTRAÑO"
  },
  {
    "codigo":110125003,
    "descripcion":"LACERACIÓN SIMPLE CONTAMINADA DEL PALADAR DURO"
  },
  {
    "codigo":372269006,
    "descripcion":"TIPO HISTOLÓGICO: NO PUEDE SER DETERMINADO"
  },
  {
    "codigo":77357008,
    "descripcion":"INTOXICACIÓN POR DESBANIA PUNICEA"
  },
  {
    "codigo":699949009,
    "descripcion":"PLACENTA RETENIDA DEBIDA A ADHERENCIA PLACENTARIA MÓRBIDA"
  },
  {
    "codigo":403202002,
    "descripcion":"QUERATOSIS ACTÍNICA MÚLTIPLE"
  },
  {
    "codigo":1255170004,
    "descripcion":"RUPTURA TRAUMÁTICA DE TENDÓN DE MÚSCULO SUBESCAPULAR DE HOMBRO"
  },
  {
    "codigo":304898005,
    "descripcion":"CAPAZ DE CUMPLIR CON EL TRATAMIENTO"
  },
  {
    "codigo":303063000,
    "descripcion":"ECLAMPSIA EN EL PUERPERIO"
  },
  {
    "codigo":237527007,
    "descripcion":"HIPOTIROIDISMO POSABLATIVO"
  },
  {
    "codigo":1220567008,
    "descripcion":"CONDUCTA SEXUAL CON ALTO RIESGO DE EXPOSICIÓN A ENFERMEDAD TRANSMISIBLE"
  },
  {
    "codigo":235692002,
    "descripcion":"EROSIÓN DUODENAL"
  },
  {
    "codigo":39084003,
    "descripcion":"TIÑA CRURAL CAUSADA POR EPIDERMOPHYTON FLOCCOSUM"
  },
  {
    "codigo":202924004,
    "descripcion":"SINOVITIS TRANSITORIA"
  },
  {
    "codigo":301228009,
    "descripcion":"HALLAZGO RELACIONADO CON LA TRÁQUEA"
  },
  {
    "codigo":170156009,
    "descripcion":"EXAMEN DEL NIÑO A LOS 3.5 AÑOS: ANORMAL - DERIVADO"
  },
  {
    "codigo":331991000119101,
    "descripcion":"ESTAFILOMA POSTERIOR DE OJO DERECHO"
  },
  {
    "codigo":364929004,
    "descripcion":"MORFOLOGÍA DE LA UNIDAD MOTORA-HALLAZGO"
  },
  {
    "codigo":6316009,
    "descripcion":"INFECCIÓN CAUSADA POR THEILERIA ANNULATA"
  },
  {
    "codigo":4481007,
    "descripcion":"REGULACIÓN DE LA SECRECIÓN GÁSTRICA ANORMAL"
  },
  {
    "codigo":299393007,
    "descripcion":"PRUEBA DE LACHMAN POSITIVA"
  },
  {
    "codigo":232022001,
    "descripcion":"RETINOPATÍA PROLIFERATIVA CON NEOVASCULARIZACIÓN EN OTRA LOCALIZACIÓN DIFERENTE A LA PAPILA DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":16224471000119103,
    "descripcion":"ALERGIA A VENENO DE AVISPÓN CHAQUETA AMARILLA"
  },
  {
    "codigo":723542006,
    "descripcion":"SONDA URINARIA URETRAL IN SITU"
  },
  {
    "codigo":262955000,
    "descripcion":"HEMORRAGIA SUBARACNOIDEA DEBIDA A LESIÓN TRAUMÁTICA"
  },
  {
    "codigo":461398008,
    "descripcion":"PATRÓN DE RAMIFICACIÓN DE CAYADO AÓRTICO IZQUIERDO NORMAL"
  },
  {
    "codigo":66347000,
    "descripcion":"TRASTORNO DEL CONTROL DE LOS IMPULSOS"
  },
  {
    "codigo":230187000,
    "descripcion":"ENCEFALOMIELITIS GRANULOMATOSA AMEBIANA"
  },
  {
    "codigo":721707003,
    "descripcion":"PÓLIPO INFLAMATORIO DE ANO"
  },
  {
    "codigo":811004,
    "descripcion":"MOVIMIENTO INESTABLE"
  },
  {
    "codigo":197419003,
    "descripcion":"ESTENOSIS DE CONDUCTO CÍSTICO"
  },
  {
    "codigo":295723007,
    "descripcion":"CARTÍLAGO LARÍNGEO FRACTURADO"
  },
  {
    "codigo":228352001,
    "descripcion":"TOLERANCIA PSICOLÓGICA AL ALCOHOL"
  },
  {
    "codigo":424960002,
    "descripcion":"INJERTO DE QUERATOPLASTIA PENETRANTE EN SU LUGAR"
  },
  {
    "codigo":293888006,
    "descripcion":"ALERGIA A LOPRAZOLAM"
  },
  {
    "codigo":423125000,
    "descripcion":"FRACTURA ÓSEA NO EXPUESTA"
  },
  {
    "codigo":292053001,
    "descripcion":"REACCIÓN ADVERSA A OPIOIDE"
  },
  {
    "codigo":29909004,
    "descripcion":"PIODERMIA FACIAL"
  },
  {
    "codigo":128213006,
    "descripcion":"TRASTORNO DE LA UNIÓN NEUROMUSCULAR"
  },
  {
    "codigo":95445009,
    "descripcion":"TROMBOFLEBITIS DE LA VENA CAVA"
  },
  {
    "codigo":290218005,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR LEVORFANOL"
  },
  {
    "codigo":93610006,
    "descripcion":"OSIFICACIÓN INCOMPLETA DEL CÚBITO"
  },
  {
    "codigo":191914006,
    "descripcion":"PATRÓN DE USO NOCIVO DE OPIOIDE SIN DEPENDENCIA, EN REMISIÓN"
  },
  {
    "codigo":124543000,
    "descripcion":"DEFICIENCIA DE TIOLÉSTER HIDROLASA"
  },
  {
    "codigo":880042006,
    "descripcion":"MIOCARDIOPATÍA DILATADA POR ANTRACILINA"
  },
  {
    "codigo":288383005,
    "descripcion":"INCAPAZ DE UTILIZAR UNA LLAVE"
  },
  {
    "codigo":419455006,
    "descripcion":"TRASTORNO CARACTERIZADO POR EOSINOFILIA"
  },
  {
    "codigo":286548001,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DE ESTRUCTURA MUSCULOESQUELÉTICA"
  },
  {
    "codigo":253780003,
    "descripcion":"AGANGLIONOSIS COLÓNICA TOTAL"
  },
  {
    "codigo":778068007,
    "descripcion":"CUTIS LAXA AUTOSÓMICA RECESIVA TIPO 2B"
  },
  {
    "codigo":188244007,
    "descripcion":"NEOPLASIA MALIGNA DE CUELLO DE VEJIGA URINARIA"
  },
  {
    "codigo":448553002,
    "descripcion":"LINFOMA DE PELVIS"
  },
  {
    "codigo":250110001,
    "descripcion":"MOVILIDAD EXCESIVA DE LA RÓTULA"
  },
  {
    "codigo":413950002,
    "descripcion":"ABLACIÓN DESCENTRADA DEL ESTROMA CORNEAL"
  },
  {
    "codigo":282878003,
    "descripcion":"SE PARA SIN AYUDA"
  },
  {
    "codigo":18899000,
    "descripcion":"SÍNDROME DE SCHINZEL - GIEDION"
  },
  {
    "codigo":53502009,
    "descripcion":"ABSCESO DE MENTÓN"
  },
  {
    "codigo":51667002,
    "descripcion":"ANEMIA POR DEFICIENCIA DE RIBOFLAVINA"
  },
  {
    "codigo":281043001,
    "descripcion":"OBSERVACIONES DE LA EVALUACIÓN DEL INTESTINO"
  },
  {
    "codigo":1264083005,
    "descripcion":"TRASTORNO FETAL CAUSADO POR TRANSFERENCIA PLACENTARIA DE SUPLEMENTO NUTRICIONAL"
  },
  {
    "codigo":1296851009,
    "descripcion":"METÁSTASIS DE MELANOMA MALIGNO DE PRIMARIO DESCONOCIDO"
  },
  {
    "codigo":770728003,
    "descripcion":"SÍNDROME DE DISMORFIA FACIAL, LUXACIÓN DE CRISTALINO, ANOMALÍAS DEL SEGMENTO ANTERIOR Y AMPOLLA FILTRANTE ESPONTÁNEA"
  },
  {
    "codigo":277373000,
    "descripcion":"DISTROFIA MUSCULAR GRAVE AUTOSÓMICA RECESIVA DE LA INFANCIA"
  },
  {
    "codigo":10820261000119101,
    "descripcion":"FRACTURA EXPUESTA DE CODO IZQUIERDO"
  },
  {
    "codigo":703357006,
    "descripcion":"DISCONTINUIDAD ADQUIRIDA DE ARTERIAS PULMONARES"
  },
  {
    "codigo":211837009,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO SUPERFICIAL DE AXILA"
  },
  {
    "codigo":13394002,
    "descripcion":"SUBEROSIS"
  },
  {
    "codigo":406610002,
    "descripcion":"ENFERMEDAD ESTREPTOCÓCICA INVASORA"
  },
  {
    "codigo":699687003,
    "descripcion":"OSTEONECROSIS DE MANDÍBULA CAUSADA POR BISFOSFONATO"
  },
  {
    "codigo":372007003,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL TEJIDO RETROCECAL"
  },
  {
    "codigo":109863007,
    "descripcion":"HIPERPLASIA ADENOMATOSA DE LA RED TESTICULAR"
  },
  {
    "codigo":1287676000,
    "descripcion":"CONVULSIÓN EPILÉPTICA DE CORTEZA MOTORA PRIMARIA DE LÓBULO FRONTAL"
  },
  {
    "codigo":42492000,
    "descripcion":"CICLITIS AGUDA"
  },
  {
    "codigo":75260002,
    "descripcion":"FÍSTULA DE GLÁNDULA SALIVAL"
  },
  {
    "codigo":370172004,
    "descripcion":"PIGMENTACIÓN CUTÁNEA - HALLAZGO"
  },
  {
    "codigo":1254908004,
    "descripcion":"ICTIOSIS PARANEOPLÁSICA ADQUIRIDA"
  },
  {
    "codigo":271868006,
    "descripcion":"FLUJO VAGINAL ANORMAL"
  },
  {
    "codigo":402940004,
    "descripcion":"CHANCRO SIFILÍTICO DEL PENE"
  },
  {
    "codigo":304636008,
    "descripcion":"DUELO GUIADO"
  },
  {
    "codigo":239100009,
    "descripcion":"ERUPCIÓN PAPULAR EN PERSONAS DE RAZA NEGRA"
  },
  {
    "codigo":827089004,
    "descripcion":"SECRECIÓN CEROSA DEL OÍDO"
  },
  {
    "codigo":237265004,
    "descripcion":"RUPTURA ESPONTÁNEA DE LA MEMBRANA AMNIÓTICA POR DELANTE DE LA PRESENTACIÓN FETAL"
  },
  {
    "codigo":827644581000119108,
    "descripcion":"ADENOCARCINOMA DE CÉLULAS CLARAS DE PELVIS RENAL DE ORIGEN MULLERIANO"
  },
  {
    "codigo":1187537008,
    "descripcion":"ESTEATOSIS"
  },
  {
    "codigo":169894000,
    "descripcion":"TALLA AL NACER MAYOR O IGUAL AL PERCENTILO 97"
  },
  {
    "codigo":71590000,
    "descripcion":"PROSTATITIS POR TRICOMONAS"
  },
  {
    "codigo":366502002,
    "descripcion":"REFLEJO ANAL - HALLAZGO"
  },
  {
    "codigo":38822007,
    "descripcion":"CISTITIS"
  },
  {
    "codigo":102523004,
    "descripcion":"EDAD ENTRE 40 Y 49 AÑOS, SEXO FEMENINO"
  },
  {
    "codigo":299131004,
    "descripcion":"HALLAZGO RELACIONADO CON ARTICULACIÓN DE PULGAR"
  },
  {
    "codigo":198992004,
    "descripcion":"ECLAMPSIA DURANTE EL EMBARAZO"
  },
  {
    "codigo":428368005,
    "descripcion":"FÍSTULA DE ARTICULACIÓN DE LA MANO"
  },
  {
    "codigo":1332491004,
    "descripcion":"NEOPLASIA INTRAEPITELIAL ESCAMOSA DE ESÓFAGO GRADO 3"
  },
  {
    "codigo":426533003,
    "descripcion":"DISPOSICIÓN PARA FORTALECER EL BIENESTAR ESPIRITUAL"
  },
  {
    "codigo":721445003,
    "descripcion":"SÍNDROME DEL CORDÓN CENTRAL DE MÉDULA ESPINAL AL NIVEL DEL TERCER SEGMENTO DORSAL"
  },
  {
    "codigo":262693007,
    "descripcion":"LESIÓN CEREBRAL DIFUSA"
  },
  {
    "codigo":66085007,
    "descripcion":"ANESTESIA EN CALCETÍN"
  },
  {
    "codigo":295461009,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE CÁSCARA SAGRADA"
  },
  {
    "codigo":64250002,
    "descripcion":"INFECCIÓN POR FUSARIUM"
  },
  {
    "codigo":129786000,
    "descripcion":"PORCIÓN CENTRAL DE LA MAMA EN LA MAMOGRAFÍA"
  },
  {
    "codigo":293626005,
    "descripcion":"ALERGIA A NEFOPAM"
  },
  {
    "codigo":162554007,
    "descripcion":"NO SUELE DESAYUNAR"
  },
  {
    "codigo":95183003,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA VULVA"
  },
  {
    "codigo":1078223005,
    "descripcion":"TROMBOSIS DE SENO VENOSO CEREBRAL DEBIDA A PROCEDIMIENTO QUIRÚRGICO Y POSTERIOR A ÉL"
  },
  {
    "codigo":11996121000119105,
    "descripcion":"INFECCIÓN DE MUÑÓN DE AMPUTACIÓN DE EXTREMIDAD SUPERIOR DERECHA"
  },
  {
    "codigo":62415009,
    "descripcion":"DESARROLLO RETRASADO DEL LENGUAJE Y DE LA ARTICULACIÓN DEL HABLA"
  },
  {
    "codigo":193487008,
    "descripcion":"IRIDOCICLITIS INFECTADA SECUNDARIA"
  },
  {
    "codigo":224420005,
    "descripcion":"INSTALACIONES PARA EL LAVADO DE MANOS INADECUADAS EN EL TRABAJO"
  },
  {
    "codigo":93348008,
    "descripcion":"POSICIÓN ANÓMALA CONGÉNITA DEL RADIO"
  },
  {
    "codigo":1303929006,
    "descripcion":"GLAUCOMA DE ÁNGULO ABIERTO SECUNDARIO BILATERAL"
  },
  {
    "codigo":419193008,
    "descripcion":"ÚLCERA DE TOBILLO"
  },
  {
    "codigo":124281009,
    "descripcion":"DEFICIENCIA DE DIMETILALILTRANSTRANSFERASA"
  },
  {
    "codigo":253518001,
    "descripcion":"HIPOPLASIA DIFUSA DEL VENTRÍCULO DERECHO"
  },
  {
    "codigo":11805811000119105,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA PROXIMAL DE DEDO MEÑIQUE DERECHO"
  },
  {
    "codigo":1003512001,
    "descripcion":"AGENESIA DE OVARIO"
  },
  {
    "codigo":446456003,
    "descripcion":"LACERACIÓN PROFUNDA DE PULGAR"
  },
  {
    "codigo":282616005,
    "descripcion":"ARRASTRA"
  },
  {
    "codigo":315384007,
    "descripcion":"NACIDO EN BENIN"
  },
  {
    "codigo":774136009,
    "descripcion":"DOLOR EN ARTICULACIÓN ACROMIOCLAVICULAR DERECHA"
  },
  {
    "codigo":18637002,
    "descripcion":"ANEMIA MEGALOBLÁSTICA DEL LACTANTE PREMATURO"
  },
  {
    "codigo":248013006,
    "descripcion":"CONDUCTA DESTRUCTIVA HACIA LA PROPIEDAD"
  },
  {
    "codigo":15957261000119102,
    "descripcion":"SARCOMA DE KAPOSI DE AMBOS PULMONES"
  },
  {
    "codigo":211575004,
    "descripcion":"LESIÓN TRAUMÁTICA CERRADA POR APLASTAMIENTO DE LA MANO, PALMA"
  },
  {
    "codigo":703095005,
    "descripcion":"PIGMENTACIÓN LOCAL EXÓGENA DE PARTES BLANDAS BUCALES"
  },
  {
    "codigo":735863007,
    "descripcion":"LACERACIÓN DE TOBILLO CON CUERPO EXTRAÑO"
  },
  {
    "codigo":80503009,
    "descripcion":"INTOXICACIÓN POR DIÓXIDO DE NITRÓGENO"
  },
  {
    "codigo":373580004,
    "descripcion":"AMPOLLA EN PALMA DE LA MANO"
  },
  {
    "codigo":734028007,
    "descripcion":"SÍNDROME 49,XYYYY"
  },
  {
    "codigo":209740008,
    "descripcion":"SECCIÓN EXPUESTA DE LIGAMENTO CRICOTIROIDEO"
  },
  {
    "codigo":44065001,
    "descripcion":"INFESTACIÓN CAUSADA POR SARCOPTES SCABIEI VARIEDAD CANIS"
  },
  {
    "codigo":11834791000119101,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN DE PULGAR IZQUIERDO"
  },
  {
    "codigo":240673004,
    "descripcion":"RASH POR LEPTOSPIRA"
  },
  {
    "codigo":207905008,
    "descripcion":"FRACTURA NO EXPUESTA DE VÉRTEBRA CERVICAL, ESPONDILÓLISIS"
  },
  {
    "codigo":109601009,
    "descripcion":"PUENTE DE DENTINA"
  },
  {
    "codigo":764961009,
    "descripcion":"CARCINOMA RENAL DE CÉLULAS CLARAS HEREDITARIO PRIMARIO"
  },
  {
    "codigo":238838004,
    "descripcion":"SÍNDROME DE DEGOS-TOURAINE"
  },
  {
    "codigo":271606005,
    "descripcion":"SENTADO ERGUIDO"
  },
  {
    "codigo":1285579002,
    "descripcion":"HIPERTENSIÓN OCULAR CAUSADA POR ACEITE DE SILICONA"
  },
  {
    "codigo":71328000,
    "descripcion":"DISFUNCIÓN SEXUAL INDUCIDA POR OPIÁCEOS"
  },
  {
    "codigo":300704000,
    "descripcion":"DIFICULTAD PARA EMITIR CHEQUES"
  },
  {
    "codigo":169632002,
    "descripcion":"CLASES DE OFICIO PARA LOS PADRES"
  },
  {
    "codigo":399008001,
    "descripcion":"FOLICULITIS BACTERIANA PROFUNDA"
  },
  {
    "codigo":366240003,
    "descripcion":"TEXTURA DE CONDUCTO SALIVAL - HALLAZGO"
  },
  {
    "codigo":267936005,
    "descripcion":"ANQUILOSIS DE ARTICULACIÓN DE TOBILLO Y\/O PIE"
  },
  {
    "codigo":724853001,
    "descripcion":"HIGROMA QUÍSTICO FETAL"
  },
  {
    "codigo":298869002,
    "descripcion":"ARTICULACIÓN DE CODO - HALLAZGO"
  },
  {
    "codigo":397173003,
    "descripcion":"ENFERMEDAD DE CROHN DE INTESTINO"
  },
  {
    "codigo":890528009,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE PULMÓN IZQUIERDO"
  },
  {
    "codigo":428106000,
    "descripcion":"ARTROPATÍA DE MÚLTIPLES ARTICULACIONES ASOCIADA CON UN TRASTORNO NEUROLÓGICO"
  },
  {
    "codigo":297034001,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE DIURÉTICO OSMÓTICO"
  },
  {
    "codigo":723018003,
    "descripcion":"MICROGNATIA ADQUIRIDA"
  },
  {
    "codigo":295199007,
    "descripcion":"SOBREDOSIS INTENCIONAL DE MEPERIDINA"
  },
  {
    "codigo":721183009,
    "descripcion":"FOSFATASA ALCALINA BAJA DEBIDA A ENFERMEDAD RENAL CRÓNICA"
  },
  {
    "codigo":195060002,
    "descripcion":"PREEXCITACIÓN VENTRICULAR"
  },
  {
    "codigo":293364003,
    "descripcion":"REACCIÓN ADVERSA AL SUCCINATO FERROSO"
  },
  {
    "codigo":31220004,
    "descripcion":"ENFERMEDAD DE COBALAMINA D"
  },
  {
    "codigo":63988001,
    "descripcion":"EXOTROPÍA INTERMITENTE"
  },
  {
    "codigo":193225000,
    "descripcion":"MIODISTROFIA PROGRESIVA HEREDITARIA"
  },
  {
    "codigo":291529002,
    "descripcion":"INTOXICACIÓN POR ÁCIDO FUSÍDICO"
  },
  {
    "codigo":94921006,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE GANGLIO LINFÁTICO"
  },
  {
    "codigo":60318001,
    "descripcion":"SÍNDROME DE DUANE"
  },
  {
    "codigo":93086006,
    "descripcion":"FENESTRACIÓN CONGÉNITA DEL PREMAXILAR"
  },
  {
    "codigo":289694006,
    "descripcion":"HALLAZGO RELACIONADO CON LA SENSIBILIDAD DEL ÚTERO GRÁVIDO"
  },
  {
    "codigo":27550009,
    "descripcion":"VASCULOPATÍA"
  },
  {
    "codigo":191390009,
    "descripcion":"METAHEMOGLOBINEMIA MEDICAMENTOSA"
  },
  {
    "codigo":255091001,
    "descripcion":"NEOPLASIA MALIGNA DE HUESOS METACARPIANOS"
  },
  {
    "codigo":1172595004,
    "descripcion":"LEUCODISTROFIA HIPOMIELINIZANTE AUTOSÓMICA RECESIVA ASOCIADA AL GEN C11ORF73"
  },
  {
    "codigo":124019005,
    "descripcion":"GLOBULINA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":286024002,
    "descripcion":"NO PONE UN ENCHUFE ELÉCTRICO EN UN TOMACORRIENTE"
  },
  {
    "codigo":23880008,
    "descripcion":"ANOMALÍA CONGÉNITA DE LOS NERVIOS"
  },
  {
    "codigo":22045003,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DEL CUERO CABELLUDO"
  },
  {
    "codigo":284189009,
    "descripcion":"QUEMADURA DE LARINGE Y TRÁQUEA"
  },
  {
    "codigo":282354001,
    "descripcion":"AMILOIDE DE PRÓSTATA"
  },
  {
    "codigo":216818004,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR GAS DISTRIBUIDO POR TUBERÍA"
  },
  {
    "codigo":249586005,
    "descripcion":"VEJIGA URINARIA PALPABLE"
  },
  {
    "codigo":870343000,
    "descripcion":"GRANULOMA DE MÉDULA ESPINAL CAUSADO POR BACTERIA"
  },
  {
    "codigo":1263559000,
    "descripcion":"LESIÓN DE NERVIO GLÚTEO"
  },
  {
    "codigo":85746008,
    "descripcion":"ANEMIA POR DEFICIENCIA DE PROTEÍNAS"
  },
  {
    "codigo":313287004,
    "descripcion":"HALLAZGO RELACIONADO CON CONVULSIONES"
  },
  {
    "codigo":278684003,
    "descripcion":"OCLUSIÓN FUNCIONAL"
  },
  {
    "codigo":49308005,
    "descripcion":"PERIOSTITIS AGUDA DE LA MANDÍBULA"
  },
  {
    "codigo":213148006,
    "descripcion":"RECHAZO DE ÓRGANO TRASPLANTADO"
  },
  {
    "codigo":1163420005,
    "descripcion":"DERRAME PERICÁRDICO POSTERIOR A INFARTO DE MIOCARDIO"
  },
  {
    "codigo":15988751000119100,
    "descripcion":"CONJUNTIVITIS ALÉRGICA PERENNE DE OJO DERECHO"
  },
  {
    "codigo":80241001,
    "descripcion":"MANO DE PARTERO"
  },
  {
    "codigo":735601009,
    "descripcion":"PIE CAÍDO ADQUIRIDO"
  },
  {
    "codigo":473457009,
    "descripcion":"TRASTORNO DE PERSONALIDAD OBSESIVO"
  },
  {
    "codigo":45638001,
    "descripcion":"INTOXICACIÓN POR CROTALARIA SPARTIOIDES"
  },
  {
    "codigo":111174006,
    "descripcion":"DIETA POSTLARINGECTOMÍA"
  },
  {
    "codigo":76571007,
    "descripcion":"CHOQUE SÉPTICO"
  },
  {
    "codigo":402416000,
    "descripcion":"VASCULITIS URTICARIANA CON COMPONENTE DE IGM MONOCLONAL - SÍNDROME DE SCHNITZLER"
  },
  {
    "codigo":109339009,
    "descripcion":"OSTEORRADIONECROSIS DEL COMPLEJO ORBITONASAL"
  },
  {
    "codigo":238576003,
    "descripcion":"DERMATITIS ALÉRGICA DE CONTACTO CAUSADA POR NÍQUEL DE UN IMPLANTE"
  },
  {
    "codigo":369648004,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA DE PARAMETRIO DERECHO, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":205808005,
    "descripcion":"SÍNDROMES DE MALFORMACIÓN CONGÉNITA ASOCIADOS CON TALLA BAJA"
  },
  {
    "codigo":1079311000119106,
    "descripcion":"NEOPLASIA BENIGNA DE PULMÓN DERECHO"
  },
  {
    "codigo":72901002,
    "descripcion":"INFESTACIÓN CAUSADA POR MACRONYSSIDAE"
  },
  {
    "codigo":105669004,
    "descripcion":"ENFERMEDAD CAUSADA POR PLAGIORCHIIDAE"
  },
  {
    "codigo":302277004,
    "descripcion":"SE TRASLADA ENTRE LA SILLA DE RUEDAS Y EL INODORO"
  },
  {
    "codigo":267674000,
    "descripcion":"COLESTEATOMA Y PÓLIPO AURICULAR"
  },
  {
    "codigo":11784361000119102,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE DEDO ÍNDICE IZQUIERDO"
  },
  {
    "codigo":365978002,
    "descripcion":"TOLERANCIA AL ALCOHOL - HALLAZGO"
  },
  {
    "codigo":202138005,
    "descripcion":"TRASTORNO DE CARTÍLAGO ARTICULAR DE TOBILLO Y PIE"
  },
  {
    "codigo":300442005,
    "descripcion":"HALLAZGO RELACIONADO CON EL TAMAÑO RENAL"
  },
  {
    "codigo":298607000,
    "descripcion":"AMPLITUD DE FLEXIÓN PASIVA DE LA COLUMNA LUMBAR NORMAL"
  },
  {
    "codigo":398746009,
    "descripcion":"SENSIBILIDAD VIBRATORIA DEL PIE NORMAL"
  },
  {
    "codigo":396911002,
    "descripcion":"ESTADIO III: INVASIÓN MACROSCÓPICA DE ÓRGANOS VECINOS (TIMO)"
  },
  {
    "codigo":69231004,
    "descripcion":"DERMATITIS FOTOTÓXICA CRÓNICA"
  },
  {
    "codigo":724591007,
    "descripcion":"NEOPLASIA OSTEÓGENA BENIGNA DE HUESO DE LA PELVIS"
  },
  {
    "codigo":1860003,
    "descripcion":"TRASTORNO DEL VOLUMEN DE LÍQUIDOS"
  },
  {
    "codigo":788292004,
    "descripcion":"LINFANGIECTASIA CONGÉNITA"
  },
  {
    "codigo":296772006,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE CLORANFENICOL"
  },
  {
    "codigo":786457000,
    "descripcion":"VEJIGA URINARIA HIPERACTIVA"
  },
  {
    "codigo":1148740009,
    "descripcion":"SIGNO DE JORISSENNE"
  },
  {
    "codigo":460612009,
    "descripcion":"CIRCULACIÓN PULMONAR DEPENDIENTE DE CONDUCTO ARTERIOSO"
  },
  {
    "codigo":131097003,
    "descripcion":"3, 3' DIYODOTIRONINA ANORMAL"
  },
  {
    "codigo":294937003,
    "descripcion":"ALERGIA A INOSITOL"
  },
  {
    "codigo":360473004,
    "descripcion":"ESTENOSIS SUBAÓRTICA MUSCULAR CONGÉNITA"
  },
  {
    "codigo":1343513007,
    "descripcion":"HERNIA INGUINAL POR DESLIZAMIENTO"
  },
  {
    "codigo":30958002,
    "descripcion":"COMPLICACIÓN DE UNA ANASTOMOSIS INTERNA"
  },
  {
    "codigo":162030005,
    "descripcion":"ARDOR EN EL ESTÓMAGO"
  },
  {
    "codigo":293102007,
    "descripcion":"REACCIÓN ADVERSA A INMUNOGLOBULINA ANTITETÁNICA"
  },
  {
    "codigo":94659001,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE URÉTER"
  },
  {
    "codigo":422339003,
    "descripcion":"TRASTORNO ALÉRGICO NO MEDIADO POR IGE"
  },
  {
    "codigo":29123003,
    "descripcion":"ESTADO POSTPARTO, 3 SEMANAS"
  },
  {
    "codigo":125592002,
    "descripcion":"LESIÓN TRAUMÁTICA DEL TEGUMENTO"
  },
  {
    "codigo":92824003,
    "descripcion":"NEUROFIBROMATOSIS TIPO 1"
  },
  {
    "codigo":191128004,
    "descripcion":"ANEMIA FERROPÉNICA POR CAUSAS ALIMENTARIAS"
  },
  {
    "codigo":1081821000119100,
    "descripcion":"SEMINOMA PRIMARIO DE TESTÍCULO DERECHO NO DESCENDIDO"
  },
  {
    "codigo":27288007,
    "descripcion":"CUERPO EXTRAÑO EN LA ZONA RETROBULBAR"
  },
  {
    "codigo":254829001,
    "descripcion":"LIPOSARCOMA"
  },
  {
    "codigo":1336173002,
    "descripcion":"MELANOMA DE EXTENSIÓN SUPERFICIAL METASTÁSICO"
  },
  {
    "codigo":58221004,
    "descripcion":"CONTUSIÓN DE SITIOS MÚLTIPLES DE LA EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":285762000,
    "descripcion":"AGNOSIA PARA LA TEMPERATURA"
  },
  {
    "codigo":123757009,
    "descripcion":"TRASTORNO ENDOCRINO COMPLEJO QUE AFECTA A LAS GÓNADAS"
  },
  {
    "codigo":449602001,
    "descripcion":"OBSTRUCCIÓN SUBAÓRTICA DEL TRACTO DE SALIDA EN VENTRÍCULO INDETERMINADO SOLITARIO"
  },
  {
    "codigo":416834004,
    "descripcion":"DEPÓSITO EPICAPSULAR DE PIGMENTO"
  },
  {
    "codigo":344541000119103,
    "descripcion":"PTERIGIÓN PERIFÉRICO ESTACIONARIO BILATERAL"
  },
  {
    "codigo":21783006,
    "descripcion":"LAGOFTALMOS MECÁNICO"
  },
  {
    "codigo":251159007,
    "descripcion":"TAQUICARDIA VENTRICULAR, POLIMORFA"
  },
  {
    "codigo":183788001,
    "descripcion":"INSCRIPTO EN LISTA DE ADMISIÓN DE CIRUGÍA PEDIÁTRICA"
  },
  {
    "codigo":216556008,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR PSILOCIBINA"
  },
  {
    "codigo":83649006,
    "descripcion":"SECRECIÓN HORMONAL AUMENTADA"
  },
  {
    "codigo":247489007,
    "descripcion":"MAL ALINEAMIENTO UNGUEAL"
  },
  {
    "codigo":737174002,
    "descripcion":"INFLAMACIÓN DE TÚNICA VAGINAL"
  },
  {
    "codigo":704406004,
    "descripcion":"CONOCIMIENTO DEFICIENTE SOBRE SÍNTOMA"
  },
  {
    "codigo":407659006,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: UCRANIANO"
  },
  {
    "codigo":473195006,
    "descripcion":"FUNCIÓN RENAL DE RIÑÓN TRASPLANTADO DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":241984000,
    "descripcion":"EFECTOS LOCALES DE LA PRESIÓN"
  },
  {
    "codigo":276587008,
    "descripcion":"TRASTORNO NEUROLÓGICO PERINATAL"
  },
  {
    "codigo":243819008,
    "descripcion":"ESTADO DE CAPUCHÓN ANTICONCEPTIVO"
  },
  {
    "codigo":211051008,
    "descripcion":"ABRASIÓN DE VAGINA"
  },
  {
    "codigo":209216004,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA NO EXPUESTA DEL CARTÍLAGO LARÍNGEO"
  },
  {
    "codigo":78144005,
    "descripcion":"HEMORRAGIA PULMONAR"
  },
  {
    "codigo":1259627006,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE GLÁNDULA PARATIROIDES"
  },
  {
    "codigo":733504007,
    "descripcion":"NO SE DESPIERTA FÁCILMENTE"
  },
  {
    "codigo":403989001,
    "descripcion":"FASCITIS NODULAR PAROSTEAL"
  },
  {
    "codigo":373056009,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM PULVERIS"
  },
  {
    "codigo":764437006,
    "descripcion":"BRAQUIDACTILIA CON DISPLASIA DE CODO Y MUÑECA"
  },
  {
    "codigo":698901007,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: INDONESIO"
  },
  {
    "codigo":240149006,
    "descripcion":"OSTEOMIELITIS CRÓNICA DE FÉMUR"
  },
  {
    "codigo":829973009,
    "descripcion":"SÍNDROME AUTOINFLAMATORIO CON INFECCIÓN BACTERIANA PIÓGENA Y AMILOPECTINOSIS"
  },
  {
    "codigo":762602002,
    "descripcion":"DOLOR NEUROPÁTICO CRÓNICO CENTRAL"
  },
  {
    "codigo":74474003,
    "descripcion":"HEMORRAGIA DIGESTIVA"
  },
  {
    "codigo":305685007,
    "descripcion":"ATENDIDO POR UN MÉDICO ESPECIALISTA EN MEDICINA NUCLEAR"
  },
  {
    "codigo":402154006,
    "descripcion":"DERMATOSIS CAUSADA POR GARRAPATA"
  },
  {
    "codigo":433087001,
    "descripcion":"FALLO PRIMARIO DE INJERTO CORNEAL LUEGO DE QUERATOPLASTIA PENETRANTE"
  },
  {
    "codigo":236479001,
    "descripcion":"NEFROPATÍA CON PÉRDIDA DE MAGNESIO"
  },
  {
    "codigo":203711003,
    "descripcion":"ESTENOSIS DE CONDUCTO VERTEBRAL DEBIDA A HUESO"
  },
  {
    "codigo":39871006,
    "descripcion":"FALLA RESPIRATORIA CRÓNICA"
  },
  {
    "codigo":267412000,
    "descripcion":"DEFICIENCIA DE NIACINA Y TIAMINA"
  },
  {
    "codigo":302015009,
    "descripcion":"RETRACCIÓN DE PÁRPADO INFERIOR"
  },
  {
    "codigo":300180003,
    "descripcion":"ESTRIBO NORMAL"
  },
  {
    "codigo":70804004,
    "descripcion":"ESTABILIDAD MOLECULAR"
  },
  {
    "codigo":365716004,
    "descripcion":"CITOLOGÍA GENERAL - HALLAZGO"
  },
  {
    "codigo":5268006,
    "descripcion":"DISMENORREA MECÁNICA"
  },
  {
    "codigo":429417002,
    "descripcion":"HERIDA PENETRANTE DE PARTES BLANDAS"
  },
  {
    "codigo":167273002,
    "descripcion":"PRUEBA DE PROTEÍNAS EN ORINA NEGATIVA"
  },
  {
    "codigo":298345007,
    "descripcion":"NO SE CAE"
  },
  {
    "codigo":722494001,
    "descripcion":"CONSUMIDOR DE NICOTINA"
  },
  {
    "codigo":198206001,
    "descripcion":"ENDOCERVICITIS Y QUISTE DE NABOTH"
  },
  {
    "codigo":1345086004,
    "descripcion":"DEPENDENCIA DE HORMONA ESTEROIDEA DEBIDA A PATRÓN DE USO NOCIVO"
  },
  {
    "codigo":15692561000119109,
    "descripcion":"QUERATITIS DE OJO DERECHO CAUSADA POR ADENOVIRUS"
  },
  {
    "codigo":1279550006,
    "descripcion":"TRASTORNO DE ÓRGANO SENSITIVO"
  },
  {
    "codigo":296510009,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE PROSTAGLANDINA"
  },
  {
    "codigo":818963004,
    "descripcion":"HIPOSPADIAS POSTERIOR"
  },
  {
    "codigo":48251000087103,
    "descripcion":"FRACTURA DE RÓTULA IZQUIERDA"
  },
  {
    "codigo":129000002,
    "descripcion":"GRANULOMA EOSINOFÍLICO"
  },
  {
    "codigo":38011000087107,
    "descripcion":"ACINESIA DE SEGMENTO ANTERIOR BASAL DE VENTRÍCULO CARDÍACO IZQUIERDO"
  },
  {
    "codigo":292840003,
    "descripcion":"REACCIÓN ADVERSA A LA TRIBAVIRINA"
  },
  {
    "codigo":43131000087109,
    "descripcion":"HEMATOMA DE DEDO ANULAR DERECHO"
  },
  {
    "codigo":391144006,
    "descripcion":"CONSENTIMIENTO PARA PRUEBA DE PAPILOMAVIRUS HUMANO OTORGADO"
  },
  {
    "codigo":35451000087107,
    "descripcion":"INFARTO ANTIGUO DE MIOCARDIO DE TABIQUE INTERVENTRICULAR"
  },
  {
    "codigo":784360008,
    "descripcion":"TRASTORNO DEBIDO A INTOXICACIÓN POR SUSTANCIA BIOLÓGICA Y POSTERIOR A ELLA"
  },
  {
    "codigo":192701001,
    "descripcion":"ENCEFALITIS POR TOXOPLASMA"
  },
  {
    "codigo":40571000087109,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE DEDO MEÑIQUE DERECHO"
  },
  {
    "codigo":225469004,
    "descripcion":"INTERESADO"
  },
  {
    "codigo":94397007,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE GANGLIOS LINFÁTICOS DEL CUELLO"
  },
  {
    "codigo":28861008,
    "descripcion":"SÍNDROME DE CROUZON"
  },
  {
    "codigo":1084331000119108,
    "descripcion":"OTOESCLEROSIS DE LOS HUESECILLOS DE AMBOS OÍDOS"
  },
  {
    "codigo":15967301000119102,
    "descripcion":"ESTENOSIS DE AMBAS ARTERIAS SUBCLAVIAS"
  },
  {
    "codigo":190866006,
    "descripcion":"HIPERCALCEMIA IDIOPÁTICA"
  },
  {
    "codigo":254567005,
    "descripcion":"CARCINOMA DE CURVATURA MAYOR DE ESTÓMAGO"
  },
  {
    "codigo":90727007,
    "descripcion":"DERRAME PLEURAL POR INSUFICIENCIA CARDÍACA CONGESTIVA"
  },
  {
    "codigo":1268540000,
    "descripcion":"CARCINOMA NEUROENDOCRINO MICROCÍTICO PRIMARIO DE OVARIO"
  },
  {
    "codigo":1237607009,
    "descripcion":"VENA VARICOSA DE REGIÓN DE TOBILLO"
  },
  {
    "codigo":187196002,
    "descripcion":"NEUMONÍA CAUSADA POR TOXOPLASMA"
  },
  {
    "codigo":285500008,
    "descripcion":"NO MUEVE LA LENGUA"
  },
  {
    "codigo":840721004,
    "descripcion":"SÍNDROME DE LA MÉDULA ESPINAL INCOMPLETO"
  },
  {
    "codigo":283665005,
    "descripcion":"HERIDA POR PINCHAZO DE CLAVO EN EL PULGAR"
  },
  {
    "codigo":185361006,
    "descripcion":"DERIVADO POR MÉDICO DE LA COMUNIDAD"
  },
  {
    "codigo":609510000,
    "descripcion":"INTERRUPCIÓN INDUCIDA DEL EMBARAZO COMPLICADA POR ENFERMEDAD INFECCIOSA"
  },
  {
    "codigo":183526002,
    "descripcion":"DERIVADO AL REUMATÓLOGO"
  },
  {
    "codigo":771515001,
    "descripcion":"SÍNDROME DE DISMORFIA FACIAL, INMUNODEFICIENCIA, LIVEDO, BAJA ESTATURA"
  },
  {
    "codigo":871654009,
    "descripcion":"HIPOPLASIA CONGÉNITA DE ANILLO FIBROSO DE AORTA"
  },
  {
    "codigo":443835004,
    "descripcion":"LIPOPROTEÍNA DE ALTA DENSIDAD POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":247227009,
    "descripcion":"DRUSA DE PAPILA ÓPTICA - ENTERRADA"
  },
  {
    "codigo":81552002,
    "descripcion":"INSUFICIENCIA DE VÁLVULA MITRAL Y ESTENOSIS DE VÁLVULA AÓRTICA DE CAUSA REUMÁTICA"
  },
  {
    "codigo":276325004,
    "descripcion":"ESTADO GENERAL DE LA PIEL"
  },
  {
    "codigo":210789004,
    "descripcion":"LESIÓN EXPUESTA, VENA SUBCLAVIA"
  },
  {
    "codigo":1259365005,
    "descripcion":"FÍSTULA POSOPERATORIA DE URÉTER"
  },
  {
    "codigo":405562002,
    "descripcion":"ABSCESO VERTEBRAL"
  },
  {
    "codigo":733242002,
    "descripcion":"HERIDA PUNZANTE DE DEDO DE LA MANO CON CUERPO EXTRAÑO"
  },
  {
    "codigo":208954003,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA NO EXPUESTA DE LA ARTICULACIÓN FEMORORROTULIANA, EXTERNA"
  },
  {
    "codigo":76047005,
    "descripcion":"OOFORITIS"
  },
  {
    "codigo":239887007,
    "descripcion":"LUPUS ERITEMATOSO SISTÉMICO CON COMPROMISO DE ÓRGANO\/SISTEMA"
  },
  {
    "codigo":403727008,
    "descripcion":"ALOPECIA CICATRIZAL CAUSADA POR RADIACIÓN IONIZANTE"
  },
  {
    "codigo":8676001,
    "descripcion":"MIOCARDITIS POR ESTADO DE HIPERSENSIBILIDAD"
  },
  {
    "codigo":205284003,
    "descripcion":"DUPLICACIÓN DE TODA LA EXTREMIDAD"
  },
  {
    "codigo":762340006,
    "descripcion":"TRASTORNO DEL ESTADO DE ÁNIMO CON SÍNTOMAS DEPRESIVOS Y MANÍACOS MIXTOS CAUSADO POR INHALANTE VOLÁTIL"
  },
  {
    "codigo":203449003,
    "descripcion":"FRACTURA PATOLÓGICA DE HUESO EN SITIO DE NEOPLASIA"
  },
  {
    "codigo":170681006,
    "descripcion":"EFECTOS COLATERALES PSIQUIÁTRICOS DE UN FÁRMACO"
  },
  {
    "codigo":400057007,
    "descripcion":"CARCINOMA BASOCELULAR DEL SURCO AURICULAR"
  },
  {
    "codigo":365454000,
    "descripcion":"SEGUNDO IDIOMA - HALLAZGO"
  },
  {
    "codigo":301753008,
    "descripcion":"DIFICULTAD PARA REALIZAR ACTIVIDADES DE ADMINISTRACIÓN Y SUPERVISIÓN"
  },
  {
    "codigo":5006002,
    "descripcion":"PERFUSIÓN VASCULAR DE ÓRGANO O TEJIDO, DISMINUIDA"
  },
  {
    "codigo":37774003,
    "descripcion":"HEMÓLISIS DE UNA COLONIA BACTERIANA"
  },
  {
    "codigo":299918005,
    "descripcion":"SENSACIÓN AL TACTO FIRME: ALTERADA"
  },
  {
    "codigo":298083004,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE DEDO"
  },
  {
    "codigo":724067006,
    "descripcion":"SÍNDROME DE DIABETES MELLITUS NEONATAL PERMANENTE CON AGENESIA DE CEREBELO"
  },
  {
    "codigo":429011000124100,
    "descripcion":"FÍSICAMENTE CAPAZ DE TRABAJAR"
  },
  {
    "codigo":449491000124101,
    "descripcion":"INCAPAZ DE ORINAR"
  },
  {
    "codigo":230712008,
    "descripcion":"HEMORRAGIA LACUNAR"
  },
  {
    "codigo":196109007,
    "descripcion":"MÚLTIPLES ABSCESOS DE PULMÓN"
  },
  {
    "codigo":294413007,
    "descripcion":"ALERGIA A TIMOL"
  },
  {
    "codigo":1275618002,
    "descripcion":"MÚLTIPLES ROTURAS DE RETINA SIN DESPRENDIMIENTO"
  },
  {
    "codigo":1144546005,
    "descripcion":"HIPOPLASIA CONGÉNITA DE ARTERIA COMUNICANTE POSTERIOR"
  },
  {
    "codigo":292578005,
    "descripcion":"REACCIÓN ADVERSA A LA MEQUITAZINA"
  },
  {
    "codigo":290743003,
    "descripcion":"INTOXICACIÓN POR AMINOGLUTETIMIDA"
  },
  {
    "codigo":126903003,
    "descripcion":"NEOPLASIA DE CONDUCTO DEFERENTE"
  },
  {
    "codigo":61367005,
    "descripcion":"SÍNDROME DE JARCHO-LEVIN"
  },
  {
    "codigo":28599006,
    "descripcion":"SÍNDROME DE ASCHER"
  },
  {
    "codigo":94135007,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE BORDE BERMELLÓN DE LABIO"
  },
  {
    "codigo":92300003,
    "descripcion":"NEOPLASIA BENIGNA DE REGIÓN POSCRICOIDEA"
  },
  {
    "codigo":288908005,
    "descripcion":"INCAPAZ DE MOVER EL ALIMENTO EN LA BOCA"
  },
  {
    "codigo":59532009,
    "descripcion":"CELULITIS DE LA PARED TORÁCICA"
  },
  {
    "codigo":1237345002,
    "descripcion":"SÍNDROME DE DISGENESIA OVÁRICA 46, XX Y TALLA BAJA"
  },
  {
    "codigo":24929001,
    "descripcion":"INFESTACIÓN CAUSADA POR CYTODITES"
  },
  {
    "codigo":90465004,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DE LA CARA"
  },
  {
    "codigo":385377005,
    "descripcion":"PUNTAJE DE GLEASON PARA CÁNCER DE PRÓSTATA - HALLAZGO"
  },
  {
    "codigo":287073003,
    "descripcion":"CONSOLIDACIÓN DEFECTUOSA DE FRACTURA - HOMBRO"
  },
  {
    "codigo":414475000,
    "descripcion":"EVENTRACIÓN DE PARED ABDOMINAL ANTERIOR CON GANGRENA"
  },
  {
    "codigo":283403005,
    "descripcion":"CORTE EN LA REGIÓN AURICULAR"
  },
  {
    "codigo":707552000,
    "descripcion":"NEUMONITIS LIPOIDE EXÓGENA AGUDA"
  },
  {
    "codigo":445408000,
    "descripcion":"OSTEOMIELITIS DE TIBIA"
  },
  {
    "codigo":248800001,
    "descripcion":"DESARROLLO TARDÍO DE LAS MAMAS"
  },
  {
    "codigo":840459008,
    "descripcion":"NEUROPATÍA CRANEAL DEBIDA A SINUSITIS"
  },
  {
    "codigo":314336009,
    "descripcion":"LIPOMA DE PARED TORÁCICA LATERAL"
  },
  {
    "codigo":1230005002,
    "descripcion":"SÍNDROME DE DEFECTOS DE LA PIGMENTACIÓN, QUERATODERMIA PALMOPLANTAR Y CARCINOMA CUTÁNEO"
  },
  {
    "codigo":246965004,
    "descripcion":"DESGARROS DE LA MEMBRANA DE DESCEMET"
  },
  {
    "codigo":83125007,
    "descripcion":"ERUPCIÓN AMPOLLAR DE LA INFANCIA"
  },
  {
    "codigo":441738001,
    "descripcion":"EXCESO DE GRASA SUBCUTÁNEA DE MIEMBRO INFERIOR"
  },
  {
    "codigo":212362002,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO CUBITAL A NIVEL DEL BRAZO"
  },
  {
    "codigo":48522003,
    "descripcion":"MIELOPATÍA"
  },
  {
    "codigo":736650005,
    "descripcion":"QUEMADURA DE MEMBRANA MUCOSA DE CAVIDAD BUCAL"
  },
  {
    "codigo":276063000,
    "descripcion":"RETORNÓ AL TRABAJO LUEGO DE TENER FAMILIA"
  },
  {
    "codigo":210527002,
    "descripcion":"LESIÓN POR DESOLLAMIENTO DE BRAZO"
  },
  {
    "codigo":1259103005,
    "descripcion":"NEURITIS AUTOINMUNE DE RAÍZ Y\/O PLEXO NERVIOSO"
  },
  {
    "codigo":11794401000119105,
    "descripcion":"RUPTURA TRAUMÁTICA DE TENDÓN DE MÚSCULO PECTORAL MAYOR IZQUIERDO"
  },
  {
    "codigo":208692004,
    "descripcion":"FRACTURA NO EXPUESTA DE MÚLTIPLES HUESOS TARSIANOS"
  },
  {
    "codigo":403465000,
    "descripcion":"BALANITIS INFECCIOSA CRÓNICA"
  },
  {
    "codigo":44852009,
    "descripcion":"ASPECTO ENVEJECIDO PARA LA EDAD"
  },
  {
    "codigo":765748009,
    "descripcion":"APLASIA ERITROCÍTICA PURA DEL ADULTO"
  },
  {
    "codigo":1222665003,
    "descripcion":"MACULOPATÍA MEDIA PARACENTRAL AGUDA"
  },
  {
    "codigo":43017006,
    "descripcion":"INFECCIÓN CAUSADA POR GASTRODISCOIDES HOMINIS"
  },
  {
    "codigo":75785007,
    "descripcion":"INTOXICACIÓN POR PHALARIS MINOR"
  },
  {
    "codigo":237790001,
    "descripcion":"INSUFICIENCIA OVÁRICA PRIMARIA AUTOINMUNITARIA"
  },
  {
    "codigo":8414002,
    "descripcion":"ABSCESO NASAL"
  },
  {
    "codigo":235955000,
    "descripcion":"PANCREATITIS CRÓNICA FARMACÓGENA"
  },
  {
    "codigo":72115001,
    "descripcion":"CONJUNTIVITIS PSEUDOMEMBRANOSA"
  },
  {
    "codigo":205022009,
    "descripcion":"HERNIA CONGÉNITA DE VEJIGA URINARIA"
  },
  {
    "codigo":268723003,
    "descripcion":"AUSENCIA DE RESPUESTA GENITAL"
  },
  {
    "codigo":317461000119100,
    "descripcion":"DETENCIÓN PARCIAL DE CRECIMIENTO EPIFISARIO DE RADIO DISTAL DERECHO"
  },
  {
    "codigo":12275221000119100,
    "descripcion":"SÍNDROME DE LINFEDEMA DE MIEMBRO SUPERIOR IZQUIERDO POSTERIOR A MASTECTOMÍA"
  },
  {
    "codigo":11760661000119101,
    "descripcion":"ESGUINCE DE RODILLA DERECHA"
  },
  {
    "codigo":384430101000119103,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DEBIDO A EMBOLIA DE ARTERIA CARÓTIDA DERECHA"
  },
  {
    "codigo":11793941000119104,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE DEDO GORDO DE PIE DERECHO"
  },
  {
    "codigo":71701000119105,
    "descripcion":"HIPERTENSIÓN EN ENFERMEDAD RENAL CRÓNICA DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":10762261000119105,
    "descripcion":"ANEMIA POSTERIOR A SANGRADO POSOPERATORIO AGUDO"
  },
  {
    "codigo":33301000119105,
    "descripcion":"SECUELA DE ACCIDENTE CEREBROVASCULAR CARDIOEMBÓLICO"
  },
  {
    "codigo":12403221000119108,
    "descripcion":"INESTABILIDAD DE PRÓTESIS DE ARTICULACIÓN DE CADERA IZQUIERDA"
  },
  {
    "codigo":135816001,
    "descripcion":"ESTADO GENERAL DE SALUD, EXCELENTE"
  },
  {
    "codigo":168584006,
    "descripcion":"RADIOGRAFÍA SIMPLE DE SACRO NORMAL"
  },
  {
    "codigo":1085461000119109,
    "descripcion":"INFECCIÓN DE COLOSTOMÍA"
  },
  {
    "codigo":977021461000119108,
    "descripcion":"CICATRIZACIÓN RENAL DEBIDA A REFLUJO VESICOURETERAL"
  },
  {
    "codigo":1090581000119106,
    "descripcion":"LÓBULO DESGARRADO ADQUIRIDO DE OREJA DERECHA"
  },
  {
    "codigo":299656009,
    "descripcion":"AMPUTADO A NIVEL DEL ANTEPIÉ"
  },
  {
    "codigo":330261000119106,
    "descripcion":"COMPRESIÓN DE NERVIO SAFENO EXTERNO IZQUIERDO"
  },
  {
    "codigo":81121301000119109,
    "descripcion":"TROMBOSIS VENOSA PROFUNDA AGUDA DE AMBAS VENAS PERONEAS"
  },
  {
    "codigo":365192007,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA LAVARSE LOS DIENTES"
  },
  {
    "codigo":166749003,
    "descripcion":"NIVEL DE COBRE EN SANGRE FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":15863931000119108,
    "descripcion":"SÍNDROME DE DUANE DE AMBOS OJOS"
  },
  {
    "codigo":232285008,
    "descripcion":"VÉRTIGO RECURRENTE BENIGNO"
  },
  {
    "codigo":230450001,
    "descripcion":"EPILEPSIA DEL COMER"
  },
  {
    "codigo":164914003,
    "descripcion":"P PULMONAR"
  },
  {
    "codigo":197682007,
    "descripcion":"SÍNDROME NEFRÍTICO AGUDO, LESIONES GLOMERULARES FOCALES Y SEGMENTARIAS"
  },
  {
    "codigo":66610008,
    "descripcion":"CARDIOPATÍA Y NEFROPATÍA HIPERTENSIVAS MALIGNAS"
  },
  {
    "codigo":721970009,
    "descripcion":"SÍNDROME DE DERIVADO DE CONDUCTO DE MULLER PERSISTENTE CON LINFANGIECTASIA Y POLIDACTILIA"
  },
  {
    "codigo":359687001,
    "descripcion":"NISTAGMO PENDULAR ADQUIRIDO"
  },
  {
    "codigo":64775002,
    "descripcion":"TROMBOSIS DE ARTERIA VERTEBRAL"
  },
  {
    "codigo":195847009,
    "descripcion":"PÓLIPO DE CUERDA VOCAL O LARINGE"
  },
  {
    "codigo":785671009,
    "descripcion":"HALLAZGO RELACIONADO CON EL NIVEL DE SUSTANCIA"
  },
  {
    "codigo":1177052003,
    "descripcion":"INFECCIÓN POR TRICHINELLA MURELLI"
  },
  {
    "codigo":292316004,
    "descripcion":"REACCIÓN ADVERSA A LA LAMOTRIGINA"
  },
  {
    "codigo":224945002,
    "descripcion":"AUTOINCINERACIÓN"
  },
  {
    "codigo":1306289005,
    "descripcion":"GLAUCOMA DE ÁNGULO ABIERTO PRIMARIO BILATERAL"
  },
  {
    "codigo":126641007,
    "descripcion":"NEOPLASIA DE LA ESPALDA"
  },
  {
    "codigo":716465007,
    "descripcion":"CAPAZ DE COMPRENDER EL ESTADO DE ÁNIMO"
  },
  {
    "codigo":682261000119108,
    "descripcion":"ASTROCITOMA ANAPLÁSICO PRIMARIO DE LÓBULO TEMPORAL"
  },
  {
    "codigo":288646000,
    "descripcion":"CAPAZ DE ELEGIR TEMAS DE CONVERSACIÓN"
  },
  {
    "codigo":1091861000119109,
    "descripcion":"OTITIS MEDIA NO SUPURATIVA DE OÍDO MEDIO DERECHO"
  },
  {
    "codigo":92038006,
    "descripcion":"NEOPLASIA BENIGNA DE BRONQUIO"
  },
  {
    "codigo":254043005,
    "descripcion":"DEFECTOS DE HUESOS LARGOS (Y PLANOS) Y\/O DEL ESQUELETO AXIAL"
  },
  {
    "codigo":188507008,
    "descripcion":"LINFOSARCOMA DE GANGLIOS LINFÁTICOS DE MÚLTIPLES LOCALIZACIONES"
  },
  {
    "codigo":417883009,
    "descripcion":"APERTURA BUCAL APROPIADA PARA LA EDAD"
  },
  {
    "codigo":284976004,
    "descripcion":"NO SE VISTE"
  },
  {
    "codigo":250373003,
    "descripcion":"HALLAZGO RELACIONADO CON LA TRANSFUSIÓN DE SANGRE"
  },
  {
    "codigo":283141006,
    "descripcion":"CUERPO EXTRAÑO METÁLICO EN LA CABEZA"
  },
  {
    "codigo":446981007,
    "descripcion":"FRACTURA EXPUESTA DE PILÓN TIBIAL"
  },
  {
    "codigo":772826002,
    "descripcion":"ARTRALGIA CON ANTICUERPOS ANTIPÉPTIDO CÍCLICO CITRULINADO POSITIVOS"
  },
  {
    "codigo":838362006,
    "descripcion":"APLASIA CUTÁNEA CONGÉNITA DE EXTREMIDAD"
  },
  {
    "codigo":408708000,
    "descripcion":"ARTERIA CON STENT"
  },
  {
    "codigo":15492000,
    "descripcion":"ATROFIA DE CRESTA ALVEOLAR DE MAXILAR SUPERIOR DESDENTADO"
  },
  {
    "codigo":212100002,
    "descripcion":"QUEMADURA QUE COMPROMETE 70-79 PORCIENTO DE LA SUPERFICIE DEL CUERPO, CON QUEMADURA DE ESPESOR COMPLETO QUE AFECTA 60-69 PORCIENTO DE LA SUPERFICIE CORPORAL"
  },
  {
    "codigo":48260006,
    "descripcion":"QUEMADURA PROFUNDA DE TERCER GRADO DEL CUERO CABELLUDO"
  },
  {
    "codigo":277636009,
    "descripcion":"NEUMOPERITONEO PERINATAL"
  },
  {
    "codigo":111961004,
    "descripcion":"HISTÉRESIS PULMONAR"
  },
  {
    "codigo":275801007,
    "descripcion":"PARÁSITOS EN LA MICROSCOPIA"
  },
  {
    "codigo":208430000,
    "descripcion":"FRACTURA NO EXPUESTA DE UNA O MÁS FALANGES DE LA MANO"
  },
  {
    "codigo":243033007,
    "descripcion":"LESIÓN POR EXPLOSIÓN ACCIDENTAL DE MUNICIONES"
  },
  {
    "codigo":110126002,
    "descripcion":"LACERACIÓN COMPLEJA DEL PALADAR DURO"
  },
  {
    "codigo":765486004,
    "descripcion":"SÍNDROME DE CROMOSOMA 3 EN ANILLO"
  },
  {
    "codigo":1255171000,
    "descripcion":"RUPTURA TRAUMÁTICA DE TENDÓN DE MÚSCULO DELTOIDES"
  },
  {
    "codigo":699950009,
    "descripcion":"ISOINMUNIZACIÓN ANTI-D QUE AFECTA AL EMBARAZO"
  },
  {
    "codigo":403203007,
    "descripcion":"QUERATOSIS ACTÍNICAS MÚLTIPLES CON COMPROMISO DEL CUERO CABELLUDO"
  },
  {
    "codigo":237528002,
    "descripcion":"HIPOTIROIDISMO POSINFECCIOSO"
  },
  {
    "codigo":1220568003,
    "descripcion":"SÍNDROME DE DISCAPACIDAD INTELECTUAL Y CONDRODISPLASIA ASOCIADO A GEN DE PROTEÍNA RICA EN GLUTAMINA 1"
  },
  {
    "codigo":170157000,
    "descripcion":"EXAMEN DEL NIÑO A LOS 3.5 AÑOS: ANORMAL - EN TRATAMIENTO"
  },
  {
    "codigo":301229001,
    "descripcion":"HALLAZGO BRONQUIAL"
  },
  {
    "codigo":39085002,
    "descripcion":"SÍFILIS SECUNDARIA DE MEMBRANAS MUCOSAS"
  },
  {
    "codigo":202925003,
    "descripcion":"SINOVITIS CREPITANTE CRÓNICA DE MANO Y MUÑECA"
  },
  {
    "codigo":235693007,
    "descripcion":"DUODENITIS CRÓNICA"
  },
  {
    "codigo":233858000,
    "descripcion":"PROLAPSO DE VÁLVULA MITRAL FAMILIAR"
  },
  {
    "codigo":299394001,
    "descripcion":"PRUEBA DE LACHMAN NEGATIVA"
  },
  {
    "codigo":168322006,
    "descripcion":"ORGANISMO AISLADO EN CULTIVO DE HISOPADO BUCAL"
  },
  {
    "codigo":461399000,
    "descripcion":"ORIGEN ANÓMALO DE LIGAMENTO ARTERIOSO EN CAYADO AÓRTICO IZQUIERDO"
  },
  {
    "codigo":364930009,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA INCLINARSE PARA LEVANTAR UN OBJETO, SIN CAERSE"
  },
  {
    "codigo":428631003,
    "descripcion":"SALVAVIDAS UTILIZADO"
  },
  {
    "codigo":232023006,
    "descripcion":"DESPRENDIMIENTO DE RETINA POR TRACCIÓN DEBIDO A DIABETES MELLITUS"
  },
  {
    "codigo":295724001,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE FLUOROURACILO"
  },
  {
    "codigo":230188005,
    "descripcion":"ENCEFALITIS POSINFLUENZA"
  },
  {
    "codigo":2571000112102,
    "descripcion":"EPISTAXIS RECURRENTE"
  },
  {
    "codigo":153611000112104,
    "descripcion":"INSUFICIENCIA DE ÓRGANO EN ESTADIO TERMINAL"
  },
  {
    "codigo":721708008,
    "descripcion":"PÓLIPO LINFOIDE DE ANO"
  },
  {
    "codigo":293889003,
    "descripcion":"ALERGIA A LORMETAZEPAM"
  },
  {
    "codigo":228353006,
    "descripcion":"TOLERANCIA INVERSA AL ALCOHOL"
  },
  {
    "codigo":95446005,
    "descripcion":"TROMBOSIS DE LA VENA MESENTÉRICA"
  },
  {
    "codigo":292054007,
    "descripcion":"REACCIÓN ADVERSA A LA BUPRENORFINA"
  },
  {
    "codigo":716203000,
    "descripcion":"CIRROSIS HEPÁTICA DESCOMPENSADA"
  },
  {
    "codigo":880043001,
    "descripcion":"ANEURISMA DE VENTRÍCULO IZQUIERDO POSTERIOR A PROCEDIMIENTO"
  },
  {
    "codigo":60843004,
    "descripcion":"FRACTURA NO EXPUESTA DE HUESOS MÚLTIPLES DE LA EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":93611005,
    "descripcion":"OSIFICACIÓN CONGÉNITA DEL VÓMER"
  },
  {
    "codigo":288384004,
    "descripcion":"UTILIZA UNA LLAVE"
  },
  {
    "codigo":253781004,
    "descripcion":"SÍNDROME DE MEGAVEJIGA, MICROCOLON E HIPOPERISTALTISMO"
  },
  {
    "codigo":778069004,
    "descripcion":"PROGNATISMO MANDIBULAR AUTOSÓMICO DOMINANTE"
  },
  {
    "codigo":417621006,
    "descripcion":"ENLENTECIMIENTO TEMPORAL"
  },
  {
    "codigo":10626071000119108,
    "descripcion":"FORÚNCULO DE DEDO IZQUIERDO"
  },
  {
    "codigo":188245008,
    "descripcion":"NEOPLASIA MALIGNA DE ORIFICIO URETERAL"
  },
  {
    "codigo":16032791000119109,
    "descripcion":"OSTEONECROSIS DE HUESO SEMILUNAR IZQUIERDO"
  },
  {
    "codigo":448554008,
    "descripcion":"LIPOSARCOMA DE TEJIDO CONJUNTIVO"
  },
  {
    "codigo":250111002,
    "descripcion":"DESLIZAMIENTO DE RÓTULA"
  },
  {
    "codigo":20735004,
    "descripcion":"AORTITIS SIFILÍTICA"
  },
  {
    "codigo":282879006,
    "descripcion":"NO SE PONE DE PIE SIN AYUDA"
  },
  {
    "codigo":248276000,
    "descripcion":"VIGOR"
  },
  {
    "codigo":444884003,
    "descripcion":"PIEL INTACTA"
  },
  {
    "codigo":1264084004,
    "descripcion":"TRASTORNO NEONATAL CAUSADO POR SUSTANCIA NUTRICIONAL TRANSMITIDA A TRAVÉS DE LECHE MATERNA"
  },
  {
    "codigo":18900005,
    "descripcion":"PERIPORITIS"
  },
  {
    "codigo":298973000,
    "descripcion":"AMPLITUD DE ABDUCCIÓN ACTIVA DE ARTICULACIÓN DE MUÑECA, DISMINUIDA"
  },
  {
    "codigo":16907441000119106,
    "descripcion":"ECTROPIÓN PARALÍTICO DE PÁRPADO INFERIOR IZQUIERDO"
  },
  {
    "codigo":703358001,
    "descripcion":"INSUFICIENCIA MITRAL POSTERIOR A PROCEDIMIENTO DEBIDA A RUPTURA DE MÚSCULO PAPILAR Y CUERDA TENDINOSA"
  },
  {
    "codigo":82601009,
    "descripcion":"FRACTURAS MÚLTIPLES NO EXPUESTAS DE CRÁNEO Y\/O CARA SIN LESIÓN TRAUMÁTICA INTRACRANEAL"
  },
  {
    "codigo":211838004,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO SUPERFICIAL DE HOMBRO"
  },
  {
    "codigo":277374006,
    "descripcion":"MIOEDEMA"
  },
  {
    "codigo":15230009,
    "descripcion":"TRASTORNO HEPÁTICO EN EL EMBARAZO"
  },
  {
    "codigo":13395001,
    "descripcion":"PAUSA SINOAURICULAR CON ESCAPE NODAL\/VENTRICULAR"
  },
  {
    "codigo":406611003,
    "descripcion":"ENFERMEDAD INVASIVA POR ESTREPTOCOCOS BETAHEMOLÍTICOS"
  },
  {
    "codigo":208168006,
    "descripcion":"FRACTURA NO EXPUESTA INESTABLE DE RAMAS PÚBICAS MÚLTIPLES"
  },
  {
    "codigo":77096008,
    "descripcion":"AISLAMIENTO SOCIAL (RECHAZO)"
  },
  {
    "codigo":402941000,
    "descripcion":"CHANCRO SIFILÍTICO DE LA VULVA"
  },
  {
    "codigo":372008008,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE HUESO ESCAFOIDES"
  },
  {
    "codigo":699688008,
    "descripcion":"EPILEPSIA GENÉTICA CON CONVULSIONES FEBRILES"
  },
  {
    "codigo":1254909007,
    "descripcion":"FUNCIÓN DE NERVIO MOTOR ALTERADA DEBIDA A INTERVENCIÓN QUIRÚRGICA EN PIEL Y POSTERIOR A ELLA"
  },
  {
    "codigo":239101008,
    "descripcion":"ERUPCIÓN DEL EMBARAZO"
  },
  {
    "codigo":7890003,
    "descripcion":"CONTRACTURA DE ARTICULACIÓN"
  },
  {
    "codigo":1187538003,
    "descripcion":"ANGIOPATÍA AMILOIDE CEREBRAL SECUNDARIA SISTÉMICA"
  },
  {
    "codigo":73426008,
    "descripcion":"SECRECIÓN ANORMAL DE BILIS"
  },
  {
    "codigo":6055000,
    "descripcion":"QUEMADURA DE LA EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":38823002,
    "descripcion":"CEFALEA AURICULAR"
  },
  {
    "codigo":827090008,
    "descripcion":"SECRECIÓN MALOLIENTE POR LA NARIZ"
  },
  {
    "codigo":71591001,
    "descripcion":"FORÚNCULO DE OREJA"
  },
  {
    "codigo":366503007,
    "descripcion":"HALLAZGO RELACIONADO CON EL COLOR DE ARTICULACIÓN DE HOMBRO"
  },
  {
    "codigo":102524005,
    "descripcion":"EDAD MAYOR DE 50 AÑOS"
  },
  {
    "codigo":299132006,
    "descripcion":"TUMEFACCIÓN DE ARTICULACIÓN DE PULGAR"
  },
  {
    "codigo":428369002,
    "descripcion":"FÍSTULA DE ARTICULACIÓN DE LA CADERA"
  },
  {
    "codigo":2385003,
    "descripcion":"CELULITIS DE LA REGIÓN PECTORAL"
  },
  {
    "codigo":723281005,
    "descripcion":"MELANOMA MALIGNO PRIMARIO DE ANO"
  },
  {
    "codigo":689791000119102,
    "descripcion":"CARCINOMA DE CÉLULAS DE TRANSICIÓN DE CÚPULA DE VEJIGA URINARIA"
  },
  {
    "codigo":262694001,
    "descripcion":"EDEMA CEREBRAL GENERALIZADO TRAUMÁTICO"
  },
  {
    "codigo":721446002,
    "descripcion":"SÍNDROME DEL CORDÓN CENTRAL DE MÉDULA ESPINAL AL NIVEL DEL CUARTO SEGMENTO DORSAL"
  },
  {
    "codigo":295462002,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE CÁSCARA SAGRADA"
  },
  {
    "codigo":293627001,
    "descripcion":"ALERGIA A OXIFENBUTAZONA"
  },
  {
    "codigo":195323006,
    "descripcion":"EMBOLIA Y TROMBOSIS DE LA ARTERIA FEMORAL"
  },
  {
    "codigo":424699007,
    "descripcion":"VARIANTES DE MIGRAÑA NO INTRATABLE"
  },
  {
    "codigo":162555008,
    "descripcion":"COME BOCADILLOS FRECUENTEMENTE"
  },
  {
    "codigo":129787009,
    "descripcion":"ASPECTO DEL TEJIDO MAMARIO SEGÚN LA MAMOGRAFÍA"
  },
  {
    "codigo":717776002,
    "descripcion":"HIDRONEFROSIS ADQUIRIDA DEBIDA A OBSTRUCCIÓN DE VEJIGA URINARIA"
  },
  {
    "codigo":160720000,
    "descripcion":"HOSTIGAMIENTO POR PARTE DEL PROPIETARIO"
  },
  {
    "codigo":93349000,
    "descripcion":"POSICIÓN ANÓMALA CONGÉNITA DE COSTILLA"
  },
  {
    "codigo":95184009,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL ANILLO DE WALDEYER"
  },
  {
    "codigo":10684031000119107,
    "descripcion":"NÓDULO DEL TEJIDO CELULAR SUBCUTÁNEO DE LA MANO IZQUIERDA"
  },
  {
    "codigo":421029004,
    "descripcion":"RETINITIS POR HERPES ZÓSTER"
  },
  {
    "codigo":781477008,
    "descripcion":"ECOENCEFALOGRAMA NORMAL"
  },
  {
    "codigo":91514001,
    "descripcion":"ÚLCERA CORNEAL"
  },
  {
    "codigo":124282002,
    "descripcion":"DEFICIENCIA DE TIAMINA PIRIDINILASA"
  },
  {
    "codigo":286287002,
    "descripcion":"CAPAZ DE IMITAR SONIDOS DEL HABLA"
  },
  {
    "codigo":335641000119104,
    "descripcion":"VASO FANTASMA DE CÓRNEA DE OJO DERECHO"
  },
  {
    "codigo":253519009,
    "descripcion":"HIPOPLASIA DEL TRACTO DE ENTRADA DEL VENTRÍCULO DERECHO"
  },
  {
    "codigo":417359009,
    "descripcion":"ATENDIDO POR ENFERMERA EXTRAHOSPITALARIA ESPECIALIZADA EN INSUFICIENCIA CARDÍACA"
  },
  {
    "codigo":87844004,
    "descripcion":"MIOPATÍA HIPOTIROIDEA"
  },
  {
    "codigo":218916005,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR FÁRMACO VASOACTIVO A NIVEL CAPILAR"
  },
  {
    "codigo":251684006,
    "descripcion":"PRUEBA OFTALMOLÓGICA - HALLAZGO"
  },
  {
    "codigo":774137000,
    "descripcion":"DOLOR EN ARTICULACIÓN ACROMIOCLAVICULAR IZQUIERDA"
  },
  {
    "codigo":415524009,
    "descripcion":"PRESCRIPCIÓN DE ATENCIÓN COMPARTIDA DERIVADA NUEVAMENTE AL HOSPITAL"
  },
  {
    "codigo":249849002,
    "descripcion":"POSTURA PARAPLÉJICA"
  },
  {
    "codigo":282617001,
    "descripcion":"NO ARRASTRA LOS PIES"
  },
  {
    "codigo":1003513006,
    "descripcion":"AGENESIA DE FÉMUR"
  },
  {
    "codigo":86009008,
    "descripcion":"PERFORACIÓN POSOPERATORIA DE VEJIGA URINARIA"
  },
  {
    "codigo":315385008,
    "descripcion":"NACIDO EN BHUTAN"
  },
  {
    "codigo":1362126002,
    "descripcion":"SINUSITIS MAXILAR ODONTÓGENA DEBIDA A FÍSTULA OROANTRAL"
  },
  {
    "codigo":51406002,
    "descripcion":"TONO VOCAL ALTO"
  },
  {
    "codigo":248014000,
    "descripcion":"INCENDIO PREMEDITADO"
  },
  {
    "codigo":18638007,
    "descripcion":"HIDRADENITIS SUPURATIVA DEL ANO"
  },
  {
    "codigo":68081000146106,
    "descripcion":"TRASTORNO DE TENDÓN FLEXOR DE MANO"
  },
  {
    "codigo":82339009,
    "descripcion":"TRASTORNO DE ANSIEDAD INDUCIDO POR ANFETAMINA"
  },
  {
    "codigo":735864001,
    "descripcion":"LACERACIÓN DE PIE CON CUERPO EXTRAÑO"
  },
  {
    "codigo":211576003,
    "descripcion":"LESIÓN TRAUMÁTICA ABIERTA POR APLASTAMIENTO DE LA MUÑECA, DORSO"
  },
  {
    "codigo":373581000,
    "descripcion":"AMPOLLA EN PLANTA DEL PIE"
  },
  {
    "codigo":275277000,
    "descripcion":"AMNESIA, POSTRAUMÁTICA"
  },
  {
    "codigo":734029004,
    "descripcion":"SÍNDROME DE MICRODELECIÓN DISTAL 22Q11.2"
  },
  {
    "codigo":471885006,
    "descripcion":"MIOCARDIOPATÍA HIPERTRÓFICA CON MARCADOR GENÉTICO"
  },
  {
    "codigo":209741007,
    "descripcion":"SECCIÓN EXPUESTA DE LIGAMENTO DEL CARTÍLAGO TIROIDES"
  },
  {
    "codigo":109602002,
    "descripcion":"ABSCESO APICAL AGUDO"
  },
  {
    "codigo":764962002,
    "descripcion":"HEPATOENCEFALOPATÍA DEBIDA A DEFECTO COMBINADO DE LA FOSFORILACIÓN OXIDATIVA TIPO 1"
  },
  {
    "codigo":1354786006,
    "descripcion":"SECCIÓN DE ARTERIA MESENTÉRICA SUPERIOR"
  },
  {
    "codigo":271607001,
    "descripcion":"CRECIMIENTO EXCESIVO DE CABELLO"
  },
  {
    "codigo":207906009,
    "descripcion":"FRACTURA NO EXPUESTA DE VÉRTEBRA CERVICAL, APÓFISIS ESPINOSA"
  },
  {
    "codigo":763127004,
    "descripcion":"DESVIACIÓN PAROXÍSTICA TÓNICA DE LA MIRADA HACIA ARRIBA DE LA INFANCIA CON ATAXIA, BENIGNA"
  },
  {
    "codigo":9463006,
    "descripcion":"AMPOLLA DE LA REGIÓN INTERESCAPULAR, SIN INFECCIÓN"
  },
  {
    "codigo":238839007,
    "descripcion":"POIQUILODERMIA ADQUIRIDA"
  },
  {
    "codigo":402679008,
    "descripcion":"PANATROFIA"
  },
  {
    "codigo":890529001,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE PULMÓN DERECHO"
  },
  {
    "codigo":366241004,
    "descripcion":"HALLAZGO RELACIONADO CON EL ASPECTO DE LA RESTAURACIÓN DENTAL"
  },
  {
    "codigo":5793009,
    "descripcion":"TRASTORNO DE CONDUCTA Y EMOCIONAL MIXTO"
  },
  {
    "codigo":298870001,
    "descripcion":"TUMEFACCIÓN DE ARTICULACIÓN DE CODO"
  },
  {
    "codigo":724854007,
    "descripcion":"PÚRPURA DE PIEL Y\/O MEMBRANAS MUCOSAS ASOCIADAS A PIEL CONCOMITANTE CON TRASTORNO DE COAGULACIÓN Y DEBIDA A ÉL"
  },
  {
    "codigo":69494008,
    "descripcion":"TRASTORNO DE TROMPA DE EUSTAQUIO"
  },
  {
    "codigo":397174009,
    "descripcion":"TRASTORNO DE REGIÓN ANAL"
  },
  {
    "codigo":297035000,
    "descripcion":"SOBREDOSIS INTENCIONAL DE DIURÉTICO OSMÓTICO"
  },
  {
    "codigo":723019006,
    "descripcion":"POSICIÓN ANÓMALA ADQUIRIDA DE PÁRPADO"
  },
  {
    "codigo":231499006,
    "descripcion":"DEPRESIÓN ENDÓGENA, PRIMER EPISODIO"
  },
  {
    "codigo":428107009,
    "descripcion":"TRASTORNO DE ARTICULACIÓN DE LA MUÑECA"
  },
  {
    "codigo":33056002,
    "descripcion":"QUEMADURA PROFUNDA DE TERCER GRADO DEL MENTÓN"
  },
  {
    "codigo":721184003,
    "descripcion":"ANEMIA MEGALOBLÁSTICA DEBIDA A DEFICIENCIA DE FOLATO POR AUMENTO DE LOS REQUERIMIENTOS"
  },
  {
    "codigo":426272003,
    "descripcion":"OLIGO-OVULACIÓN"
  },
  {
    "codigo":229664007,
    "descripcion":"DISFASIA RECEPTIVA"
  },
  {
    "codigo":293365002,
    "descripcion":"REACCIÓN ADVERSA AL SULFATO FERROSO"
  },
  {
    "codigo":94922004,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE BRONQUIO PRINCIPAL"
  },
  {
    "codigo":291530007,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ÁCIDO FUSÍDICO"
  },
  {
    "codigo":93087002,
    "descripcion":"FENESTRACIÓN CONGÉNITA DE HUESO PREESFENOIDAL"
  },
  {
    "codigo":224159005,
    "descripcion":"PRISIONERO DE GUERRA EN JAPÓN"
  },
  {
    "codigo":289695007,
    "descripcion":"CICATRIZ DE ÚTERO GRÁVIDO DOLOROSA A LA PALPACIÓN"
  },
  {
    "codigo":713844000,
    "descripcion":"DEMENCIA CONCOMITANTE CON INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":124020004,
    "descripcion":"GLOBULINA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":286025001,
    "descripcion":"DIFICULTAD PARA PONER UN ENCHUFE ELÉCTRICO EN UN TOMACORRIENTE"
  },
  {
    "codigo":417097002,
    "descripcion":"GRANULOMA POR TOXOCARA"
  },
  {
    "codigo":284190000,
    "descripcion":"QUEMADURA DE ESTRUCTURA CARDIOVASCULAR"
  },
  {
    "codigo":12081691000119102,
    "descripcion":"QUEMADURA DE SACO CONJUNTIVAL DE OJO DERECHO"
  },
  {
    "codigo":282355000,
    "descripcion":"AMILOIDOSIS TESTICULAR"
  },
  {
    "codigo":52979002,
    "descripcion":"INFECCIÓN POR CAPILLARIA"
  },
  {
    "codigo":216819007,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR MONÓXIDO DE CARBONO DE COMBUSTIÓN INCOMPLETA DE TUBERÍA"
  },
  {
    "codigo":446195009,
    "descripcion":"FRACTURA DEPRIMIDA EXPUESTA DE CRÁNEO"
  },
  {
    "codigo":1263560005,
    "descripcion":"LESIÓN DE NERVIO AURICULAR MAYOR"
  },
  {
    "codigo":870344006,
    "descripcion":"DERMATITIS SEBORREICA DEBIDA A INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":16541001,
    "descripcion":"FIEBRE AMARILLA"
  },
  {
    "codigo":311453002,
    "descripcion":"SENO PILONIDAL DE SURCO INTERGLÚTEO"
  },
  {
    "codigo":278685002,
    "descripcion":"OCLUSIÓN FUNCIONAL GUIADA EN LOS PERROS"
  },
  {
    "codigo":409757005,
    "descripcion":"INVASIÓN TUMORAL CIRCUNSCRIPTA A LA DERMIS"
  },
  {
    "codigo":82077006,
    "descripcion":"MIOPATÍA MIOTUBULAR"
  },
  {
    "codigo":735602002,
    "descripcion":"DESGASTE DE SUPERFICIE ARTICULAR DE PRÓTESIS ARTICULAR DE CADERA"
  },
  {
    "codigo":473458004,
    "descripcion":"INSUFICIENCIA DE VÁLVULA AURICULOVENTRICULAR (MORFOLÓGICAMENTE NO MITRAL NI TRICÚSPIDE) FETAL"
  },
  {
    "codigo":1290823007,
    "descripcion":"RADIOGRAFÍA DE PARTES BLANDAS DE CAVIDAD BUCAL NORMAL"
  },
  {
    "codigo":111175007,
    "descripcion":"DIETA HIPOSÓDICA PARA USO DURANTE EL EMBARAZO"
  },
  {
    "codigo":45639009,
    "descripcion":"ANGIOPATÍA AMILOIDE CEREBRAL HEREDITARIA, TIPO ISLÁNDICO"
  },
  {
    "codigo":240412005,
    "descripcion":"LEPRA HISTIOIDE"
  },
  {
    "codigo":109340006,
    "descripcion":"SECUESTRO DE LOS HUESOS FACIALES"
  },
  {
    "codigo":11809461000119107,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE PIERNA IZQUIERDA"
  },
  {
    "codigo":41969006,
    "descripcion":"ENFERMEDAD IDIOPÁTICA"
  },
  {
    "codigo":369649007,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA DE PARAMETRIO IZQUIERDO, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":9201008,
    "descripcion":"INFESTACIÓN CAUSADA POR KNEMIDOKOPTES"
  },
  {
    "codigo":402417009,
    "descripcion":"URTICARIA NEUTROFÍLICA"
  },
  {
    "codigo":340661000119108,
    "descripcion":"CORIORRETINITIS DISEMINADA GENERALIZADA DE OJO IZQUIERDO"
  },
  {
    "codigo":7366009,
    "descripcion":"CICATRIZ COROIDEA POSTINFLAMATORIA"
  },
  {
    "codigo":71067002,
    "descripcion":"ESTADO ANORMAL DEL APARATO REPRODUCTOR"
  },
  {
    "codigo":302278009,
    "descripcion":"NO SE TRASLADA DE LA SILLA DE RUEDAS AL INODORO"
  },
  {
    "codigo":267675004,
    "descripcion":"OTOTOXICIDAD - LABERÍNTICA"
  },
  {
    "codigo":365979005,
    "descripcion":"ACTITUD PARA BEBER - HALLAZGO"
  },
  {
    "codigo":724592000,
    "descripcion":"NEOPLASIA OSTEÓGENA BENIGNA DE CARTÍLAGO ARTICULAR DE PELVIS"
  },
  {
    "codigo":298608005,
    "descripcion":"AMPLITUD DE FLEXIÓN PASIVA DE LA COLUMNA LUMBAR AUMENTADA"
  },
  {
    "codigo":3696007,
    "descripcion":"DISPEPSIA NO ULCEROSA"
  },
  {
    "codigo":396912009,
    "descripcion":"ESTADIO IVA: DISEMINACIÓN PLEURAL O PERICÁRDICA (TIMO)"
  },
  {
    "codigo":460613004,
    "descripcion":"CIRCULACIÓN SISTÉMICA DEPENDIENTE DE CONDUCTO ARTERIOSO"
  },
  {
    "codigo":1148741008,
    "descripcion":"NECROSIS DE CEREBRO CAUSADA POR RADIACIÓN IONIZANTE"
  },
  {
    "codigo":32794000,
    "descripcion":"TASA DE RENOVACIÓN ÓSEA DISMINUIDA"
  },
  {
    "codigo":34629009,
    "descripcion":"ANEMIA POR DEFICIENCIA DE CINC"
  },
  {
    "codigo":788293009,
    "descripcion":"LINFANGIECTASIA CUTÁNEA ADQUIRIDA"
  },
  {
    "codigo":1343514001,
    "descripcion":"SÍNDROME DE CORDÓN POSTERIOR DEBIDO A ESPONDILOSIS CERVICAL"
  },
  {
    "codigo":10963791000119109,
    "descripcion":"LACERACIÓN DE MUSLO IZQUIERDO"
  },
  {
    "codigo":131098008,
    "descripcion":"NIVEL DE 3, 3' DIIODOTIRONINA SOBRE EL RANGO DE REFERENCIA"
  },
  {
    "codigo":293103002,
    "descripcion":"REACCIÓN ADVERSA A INMUNOGLOBULINA ANTI-VARICELA ZÓSTER"
  },
  {
    "codigo":30959005,
    "descripcion":"ENSOÑACIÓN ERÓTICA DIURNA"
  },
  {
    "codigo":424175006,
    "descripcion":"DESGARRO NO TRAUMÁTICO DE MANGUITO ROTADOR"
  },
  {
    "codigo":162031009,
    "descripcion":"INDIGESTIÓN"
  },
  {
    "codigo":192964002,
    "descripcion":"TETRAPLEJÍA FLÁCCIDA"
  },
  {
    "codigo":422340001,
    "descripcion":"PLACA ENDOTELIAL DE CÓRNEA"
  },
  {
    "codigo":291268005,
    "descripcion":"INTOXICACIÓN POR ATENOLOL"
  },
  {
    "codigo":94660006,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL ORIFICIO URETERAL DE LA VEJIGA"
  },
  {
    "codigo":92825002,
    "descripcion":"OBSTRUCCIÓN DEL ASA PROXIMAL DEL INTESTINO"
  },
  {
    "codigo":1080451000119101,
    "descripcion":"CARCINOMA DE CÉLULAS GRANDES PRIMARIO DE LÓBULO INFERIOR DE PULMÓN IZQUIERDO"
  },
  {
    "codigo":420505005,
    "descripcion":"RECHAZO DEL AUTOINJERTO ENDOTELIAL CORNEAL"
  },
  {
    "codigo":289433006,
    "descripcion":"NO SE OBSERVAN MOVIMIENTOS FETALES"
  },
  {
    "codigo":125593007,
    "descripcion":"LESIÓN TRAUMÁTICA EN LA CARA"
  },
  {
    "codigo":123758004,
    "descripcion":"TRASTORNO ENDOCRINO COMPLEJO QUE AFECTA A LA GLÁNDULA HIPÓFISIS"
  },
  {
    "codigo":254830006,
    "descripcion":"TUMOR LIPOMATOSO BENIGNO"
  },
  {
    "codigo":90990009,
    "descripcion":"INFECCIÓN CAUSADA POR OPISTHORCHIS NOVERCA"
  },
  {
    "codigo":89155008,
    "descripcion":"ESCLEROSIS SISTÉMICA"
  },
  {
    "codigo":251160002,
    "descripcion":"TAQUICARDIA VENTRICULAR, POLIMORFA SIN PROLONGACIÓN DEL INTERVALO Q-T"
  },
  {
    "codigo":447768002,
    "descripcion":"ADENOMA FOLICULAR DE TEJIDO TIROIDEO ECTÓPICO"
  },
  {
    "codigo":283928006,
    "descripcion":"CONTUSIÓN DE LA PRÓSTATA"
  },
  {
    "codigo":185624008,
    "descripcion":"EXTENDIDO CERVICAL INADECUADO - RECONVOCATORIA ANULADA"
  },
  {
    "codigo":282093000,
    "descripcion":"REACCIÓN ALÉRGICA CAUSADA POR VENENO"
  },
  {
    "codigo":54552008,
    "descripcion":"TRASTORNO DE ACOMODACIÓN"
  },
  {
    "codigo":314861002,
    "descripcion":"OBSTRUCCIÓN ADQUIRIDA DE CONDUCTO NASOLAGRIMAL"
  },
  {
    "codigo":445933009,
    "descripcion":"EFECTO DE EXPOSICIÓN A LA LUZ"
  },
  {
    "codigo":183789009,
    "descripcion":"INSCRIPTO EN LISTA DE ADMISIÓN OBSTÉTRICA"
  },
  {
    "codigo":247490003,
    "descripcion":"TEJIDO UNGUEAL - HALLAZGO"
  },
  {
    "codigo":50882004,
    "descripcion":"ÚLCERA TRAUMÁTICA DE LA MUCOSA ORAL"
  },
  {
    "codigo":737175001,
    "descripcion":"INFLAMACIÓN DE CONDUCTO DEFERENTE"
  },
  {
    "codigo":16279005,
    "descripcion":"ALTERACIÓN DE LA REGULACIÓN NEUROMETABÓLICA"
  },
  {
    "codigo":1259628001,
    "descripcion":"COREA DEBIDA A HIPOPARATIROIDISMO"
  },
  {
    "codigo":243820002,
    "descripcion":"ESTADO DEL PRESERVATIVO FEMENINO"
  },
  {
    "codigo":276588003,
    "descripcion":"LACERACIÓN INTRACRANEAL PERINATAL"
  },
  {
    "codigo":373057000,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM RHODESIAE"
  },
  {
    "codigo":241985004,
    "descripcion":"PRESIÓN DE LA MÁSCARA FACIAL"
  },
  {
    "codigo":45377007,
    "descripcion":"SALPINGITIS GONOCÓCICA AGUDA"
  },
  {
    "codigo":698902000,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: OCCIDENTAL"
  },
  {
    "codigo":209217008,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA NO EXPUESTA DE LA ARTICULACIÓN COSTOVERTEBRAL"
  },
  {
    "codigo":76310001,
    "descripcion":"PRIMER RUIDO CARDÍACO ANORMAL, R>1<"
  },
  {
    "codigo":829974003,
    "descripcion":"SÍNDROME DE TRISOMÍA 1 EN MOSAICO"
  },
  {
    "codigo":668021000005109,
    "descripcion":"ERITROCITOS EN ORINA = +++"
  },
  {
    "codigo":403990005,
    "descripcion":"FASCITIS ISQUÉMICA"
  },
  {
    "codigo":240150006,
    "descripcion":"OSTEOMIELITIS CRÓNICA DE PELVIS"
  },
  {
    "codigo":305686008,
    "descripcion":"ATENDIDO POR UN MÉDICO ESPECIALISTA EN CUIDADOS PALIATIVOS"
  },
  {
    "codigo":8939001,
    "descripcion":"LESIÓN INCOMPLETA DE LA MÉDULA ESPINAL A NIVEL DE C1 - C4 SIN LESIÓN TRAUMÁTICA ÓSEA"
  },
  {
    "codigo":860907004,
    "descripcion":"ALERGIA A MACRÓLIDO"
  },
  {
    "codigo":402155007,
    "descripcion":"DERMATOSIS CAUSADA POR ÁCARO PARASITARIO DE MAMÍFERO"
  },
  {
    "codigo":467643831000119105,
    "descripcion":"FIBRILACIÓN AURICULAR PAROXÍSTICA DEBIDA A TRASTORNO DE VÁLVULA CARDÍACA"
  },
  {
    "codigo":762603007,
    "descripcion":"DOLOR NEUROPÁTICO PERIFÉRICO CRÓNICO"
  },
  {
    "codigo":236480003,
    "descripcion":"NEFROPATÍA HEREDITARIA CON PÉRDIDA DE MAGNESIO"
  },
  {
    "codigo":302016005,
    "descripcion":"ÁNTRAX DE MIEMBRO INFERIOR"
  },
  {
    "codigo":203712005,
    "descripcion":"ESTENOSIS DE CONDUCTO VERTEBRAL DEBIDA A TEJIDO CONJUNTIVO"
  },
  {
    "codigo":300181004,
    "descripcion":"ESTRIBO ANORMAL"
  },
  {
    "codigo":365717008,
    "descripcion":"RESULTADO DE EXTENDIDO DE BÓVEDA VAGINAL - HALLAZGO"
  },
  {
    "codigo":234645009,
    "descripcion":"INMUNODEFICIENCIA FARMACÓGENA"
  },
  {
    "codigo":673361000119102,
    "descripcion":"OSTEOMIELITIS DE RADIO"
  },
  {
    "codigo":3434004,
    "descripcion":"MIOTONÍA"
  },
  {
    "codigo":429418007,
    "descripcion":"LACERACIÓN DE PIEL DE LA MANO"
  },
  {
    "codigo":298346008,
    "descripcion":"HALLAZGO RELACIONADO CON LA FRECUENCIA DE CAÍDAS"
  },
  {
    "codigo":167274008,
    "descripcion":"PRUEBA DE PROTEÍNAS EN ORINA = TRAZAS"
  },
  {
    "codigo":36202009,
    "descripcion":"FRACTURA DE DIENTE"
  },
  {
    "codigo":34367002,
    "descripcion":"INTENTO FALLIDO DE ABORTO CON PERFORACIÓN DE INTESTINO"
  },
  {
    "codigo":67135005,
    "descripcion":"TEJIDO RESECADO DURANTE LA AUTOPSIA"
  },
  {
    "codigo":1345087008,
    "descripcion":"DEPENDENCIA DE HORMONA ESTEROIDEA EN USO TERAPÉUTICO"
  },
  {
    "codigo":294676000,
    "descripcion":"ALERGIA A PROPILTIOURACILO"
  },
  {
    "codigo":296511008,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE PROSTAGLANDINA"
  },
  {
    "codigo":425748003,
    "descripcion":"EXACERBACIÓN AGUDA DE BRONQUITIS CRÓNICA"
  },
  {
    "codigo":165439008,
    "descripcion":"HEMOGLOBINA CORPUSCULAR MEDIA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1144809002,
    "descripcion":"TRASTORNO DEL SISTEMA RESPIRATORIO DEBIDO A POLIANGEÍTIS MICROSCÓPICA"
  },
  {
    "codigo":129001003,
    "descripcion":"ACTIVIDAD DIARIA BÁSICA"
  },
  {
    "codigo":292841004,
    "descripcion":"REACCIÓN ADVERSA A LA TRIFLUOROTIMIDINA"
  },
  {
    "codigo":291006001,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR AMILOBARBITAL"
  },
  {
    "codigo":94398002,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LOS GANGLIOS LINFÁTICOS DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":225470003,
    "descripcion":"INDOLENTE"
  },
  {
    "codigo":15746641000119109,
    "descripcion":"PUPILA DE OJO IZQUIERDO ATÓNICA"
  },
  {
    "codigo":127166002,
    "descripcion":"LINFADENOPATÍA ILÍACA EXTERNA"
  },
  {
    "codigo":92563000,
    "descripcion":"CARCINOMA IN SITU DEL ESÓFAGO CERVICAL"
  },
  {
    "codigo":41301000087100,
    "descripcion":"HEMATOMA DE DEDO GORDO DE PIE IZQUIERDO"
  },
  {
    "codigo":10581000087102,
    "descripcion":"LESIÓN TRAUMÁTICA DE URÉTER DURANTE PROCEDIMIENTO QUIRÚRGICO"
  },
  {
    "codigo":38741000087105,
    "descripcion":"DOLOR CERVICAL CRÓNICO PRIMARIO"
  },
  {
    "codigo":51541000087106,
    "descripcion":"GLOBICATELLA SANGUINIS O GLOBICATELLA SULFIDIFACIENS"
  },
  {
    "codigo":46421000087107,
    "descripcion":"FRACTURA DE PRIMER HUESO METACARPIANO DE MANO DERECHA"
  },
  {
    "codigo":1237608004,
    "descripcion":"VENA VARICOSA DE PANTORRILLA"
  },
  {
    "codigo":43861000087107,
    "descripcion":"HERIDA CORTANTE DE PIEL DE DEDO PULGAR IZQUIERDO"
  },
  {
    "codigo":713320007,
    "descripcion":"RADICULITIS CONCOMITANTE CON INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":1268541001,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS PRIMARIO DE HÍGADO Y VÍA BILIAR INTRAHEPÁTICA"
  },
  {
    "codigo":25192009,
    "descripcion":"NACIMIENTO PREMATURO DE GEMELOS DICIGÓTICOS, AMBOS VIVOS"
  },
  {
    "codigo":285501007,
    "descripcion":"DIFICULTAD PARA MOVER LA LENGUA"
  },
  {
    "codigo":416573008,
    "descripcion":"CONVOCATORIA VERBAL PARA CONTROL DE DISFUNCIÓN VENTRICULAR IZQUIERDA"
  },
  {
    "codigo":21522001,
    "descripcion":"DOLOR ABDOMINAL"
  },
  {
    "codigo":56125009,
    "descripcion":"HEMORRAGIA DEL IRIS Y\/O DEL CUERPO CILIAR"
  },
  {
    "codigo":87058001,
    "descripcion":"TRASTORNO MOTOR DEL NERVIO VAGO"
  },
  {
    "codigo":185362004,
    "descripcion":"DERIVADO POR PERSONAL DE ENFERMERÍA"
  },
  {
    "codigo":319211000119109,
    "descripcion":"LUXACIÓN RECURRENTE DE ARTICULACIÓN DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":283666006,
    "descripcion":"HERIDA POR PINCHAZO DE CLAVO EN EL TRONCO"
  },
  {
    "codigo":609511001,
    "descripcion":"INTERRUPCIÓN INDUCIDA DEL EMBARAZO COMPLICADA POR DAÑO DE TEJIDO PERIURETRAL"
  },
  {
    "codigo":871655005,
    "descripcion":"ATRESIA DE VÁLVULA TRICÚSPIDE CON CONEXIÓN AURICULOVENTRICULAR DERECHA AUSENTE"
  },
  {
    "codigo":183527006,
    "descripcion":"DERIVADO AL NEUMONÓLOGO"
  },
  {
    "codigo":85223007,
    "descripcion":"COMPLICACIÓN DE LA HEMODIÁLISIS"
  },
  {
    "codigo":771516000,
    "descripcion":"TRASTORNO CONGÉNITO DE LA GLICOSILACIÓN POR ALTERACIÓN DEL MIEMBRO A DE LA FAMILIA 35 DE PORTADORES DE SOLUTOS"
  },
  {
    "codigo":249063009,
    "descripcion":"SITUACIÓN LONGITUDINAL"
  },
  {
    "codigo":52455008,
    "descripcion":"PATERNIDAD O MATERNIDAD INEFICAZ"
  },
  {
    "codigo":50620007,
    "descripcion":"NEUROPATÍA AUTONÓMICA DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":769681006,
    "descripcion":"PRIMER ENCUENTRO POR SUJETO"
  },
  {
    "codigo":212625007,
    "descripcion":"INTOXICACIÓN POR IMINOESTILBENOS"
  },
  {
    "codigo":276326003,
    "descripcion":"INDURACIÓN DE MUCOSA"
  },
  {
    "codigo":1259366006,
    "descripcion":"CARCINOMA ADENOIDE QUÍSTICO PRIMARIO DE TRÁQUEA"
  },
  {
    "codigo":210790008,
    "descripcion":"LESIÓN DE VASO SANGUÍNEO PULMONAR"
  },
  {
    "codigo":12347001,
    "descripcion":"ALTERACIÓN EN EL ESTILO DE VIDA, ASOCIADA CON LA FAMILIA"
  },
  {
    "codigo":208955002,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA NO EXPUESTA DE LA ARTICULACIÓN FEMORORROTULIANA, INTERNA"
  },
  {
    "codigo":45115003,
    "descripcion":"INFECCIÓN POR ECHINOCOCCUS VOGELI"
  },
  {
    "codigo":405563007,
    "descripcion":"SEUDOQUISTE PANCREÁTICO INFECTADO"
  },
  {
    "codigo":698640000,
    "descripcion":"HIPERTENSIÓN EN EL PUERPERIO CON EDEMA PULMONAR"
  },
  {
    "codigo":733243007,
    "descripcion":"MORDEDURA ABIERTA DE DEDO DE LA MANO"
  },
  {
    "codigo":239888002,
    "descripcion":"PANICULITIS POR LUPUS"
  },
  {
    "codigo":403728003,
    "descripcion":"QUERATOSIS CAUSADA POR RADIACIÓN"
  },
  {
    "codigo":895248000,
    "descripcion":"FORMA TRIANGULAR ANORMAL CONGÉNITA DE FALANGE MEDIA DE DEDO ÍNDICE"
  },
  {
    "codigo":370960006,
    "descripcion":"TRASTORNO DE PRESIÓN INTRAOCULAR"
  },
  {
    "codigo":41445001,
    "descripcion":"DAÑO RETINIANO"
  },
  {
    "codigo":205285002,
    "descripcion":"DUPLICACIÓN DE HÚMERO"
  },
  {
    "codigo":238053006,
    "descripcion":"PROTOPORFIRIA ERITROPOYÉTICA HOMOCIGOTA"
  },
  {
    "codigo":39610001,
    "descripcion":"ESQUIZOFRENIA INDIFERENCIADA EN REMISIÓN"
  },
  {
    "codigo":301754002,
    "descripcion":"DOLOR EN EL CUADRANTE INFERODERECHO"
  },
  {
    "codigo":203450003,
    "descripcion":"FRACTURA OSTEOPORÓTICA DE VÉRTEBRA LUMBAR"
  },
  {
    "codigo":400058002,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE VASO SANGUÍNEO DE PIERNA"
  },
  {
    "codigo":166579007,
    "descripcion":"FOSFATASA ÁCIDA SÉRICA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":234383000,
    "descripcion":"TALASEMIA ALFA HOMOCIGOTA"
  },
  {
    "codigo":299919002,
    "descripcion":"SENSACIÓN AL TACTO FIRME: NORMAL"
  },
  {
    "codigo":725903003,
    "descripcion":"MIOGLOBINURIA AUTOSÓMICA DOMINANTE"
  },
  {
    "codigo":724068001,
    "descripcion":"SÍNDROME DE DEFECTOS PERICÁRDICO Y DIAFRAGMÁTICO"
  },
  {
    "codigo":70543009,
    "descripcion":"INFECCIÓN CAUSADA POR LEPTOSPIRA GRIPPOTYPHOSA"
  },
  {
    "codigo":298084005,
    "descripcion":"CUERPO EXTRAÑO EN LA PIEL DEL PULGAR"
  },
  {
    "codigo":230713003,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DE PATOLOGÍA INCIERTA"
  },
  {
    "codigo":296249008,
    "descripcion":"SOBREDOSIS DE TRIFLUOPERAZINA"
  },
  {
    "codigo":11790521000119109,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE MANO DERECHA"
  },
  {
    "codigo":1144547001,
    "descripcion":"HIPOPLASIA CONGÉNITA DE ESTRUCTURA DE PIRÁMIDE RENAL"
  },
  {
    "codigo":292579002,
    "descripcion":"REACCIÓN ADVERSA A LA OXATOMIDA"
  },
  {
    "codigo":65038009,
    "descripcion":"MILIARIA APOCRINA"
  },
  {
    "codigo":1275619005,
    "descripcion":"MÚLTIPLES ROTURAS DE AMBAS RETINAS SIN DESPRENDIMIENTO"
  },
  {
    "codigo":611501000124101,
    "descripcion":"DISPONE DE MEDIO DE TRANSPORTE QUE SATISFACE NECESIDADES FUNCIONALES"
  },
  {
    "codigo":1306552008,
    "descripcion":"CARCINOMA DUCTAL INFILTRANTE DE PROLONGACIÓN AXILAR DE MAMA IZQUIERDA"
  },
  {
    "codigo":126904009,
    "descripcion":"NEOPLASIA DEL CORDÓN ESPERMÁTICO"
  },
  {
    "codigo":450221000124106,
    "descripcion":"MASA DE MÚSCULO DE EXTREMIDAD INFERIOR IZQUIERDA"
  },
  {
    "codigo":288909002,
    "descripcion":"MUEVE EL ALIMENTO EN LA BOCA"
  },
  {
    "codigo":290744009,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR AMINOGLUTETIMIDA"
  },
  {
    "codigo":92301004,
    "descripcion":"NEOPLASIA BENIGNA DE LA PARED POSTERIOR DE LA HIPOFARINGE"
  },
  {
    "codigo":2221000124106,
    "descripcion":"CANINO INFERIOR DERECHO TEMPORARIO SUPERNUMERARIO"
  },
  {
    "codigo":678381000119102,
    "descripcion":"RUPTURA DE ESFÍNTER DE PUPILA DE OJO IZQUIERDO"
  },
  {
    "codigo":1237346001,
    "descripcion":"SÍNDROME DE CAROLI"
  },
  {
    "codigo":188770007,
    "descripcion":"LEUCEMIA MIELOMONOCÍTICA SUBAGUDA"
  },
  {
    "codigo":287074009,
    "descripcion":"CONSOLIDACIÓN DEFECTUOSA DE FRACTURA - ANTEBRAZO"
  },
  {
    "codigo":840460003,
    "descripcion":"COLITIS CAUSADA POR CRYPTOSPORIDIUM"
  },
  {
    "codigo":283404004,
    "descripcion":"CORTE EN LA NARIZ"
  },
  {
    "codigo":414476004,
    "descripcion":"EVENTRACIÓN VENTRAL OBSTRUIDA CON GANGRENA"
  },
  {
    "codigo":248801002,
    "descripcion":"MAMAS EXCESIVAMENTE DESARROLLADAS"
  },
  {
    "codigo":707553005,
    "descripcion":"NEUMONITIS LIPOIDE EXÓGENA CRÓNICA"
  },
  {
    "codigo":246966003,
    "descripcion":"HALLAZGO DEL ENDOTELIO CORNEAL"
  },
  {
    "codigo":104941000119109,
    "descripcion":"ISQUEMIA DE RETINA DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":212363007,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚLTIPLES NERVIOS A NIVEL DE HOMBRO Y BRAZO"
  },
  {
    "codigo":48523008,
    "descripcion":"PERFORACIÓN TIMPÁNICA CICATRIZADA"
  },
  {
    "codigo":703883009,
    "descripcion":"PIEL FRÍA"
  },
  {
    "codigo":441739009,
    "descripcion":"TRASTORNO DE VENA DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":1259104004,
    "descripcion":"NEURITIS AUTOINMUNITARIA"
  },
  {
    "codigo":276064006,
    "descripcion":"MENINGITIS LINFOCÍTICA"
  },
  {
    "codigo":210528007,
    "descripcion":"DAÑO POLIHÍSTICO GRAVE DEL BRAZO"
  },
  {
    "codigo":13920009,
    "descripcion":"ENCEFALOPATÍA HEPÁTICA"
  },
  {
    "codigo":700213005,
    "descripcion":"TRASTORNO DE RESTRICCIÓN DE LA INGESTA ALIMENTARIA POR EVITACIÓN"
  },
  {
    "codigo":1222666002,
    "descripcion":"HIDROPESÍA FETAL LINFÁTICA ASOCIADA AL GEN EPHB4"
  },
  {
    "codigo":403466004,
    "descripcion":"BALANITIS MICÁCEA Y QUERATÓSICA"
  },
  {
    "codigo":297761000119104,
    "descripcion":"DERRAME INTERMITENTE DE ARTICULACIÓN DE TOBILLO"
  },
  {
    "codigo":205023004,
    "descripcion":"PROLAPSO CONGÉNITO DE MUCOSA DE VEJIGA URINARIA"
  },
  {
    "codigo":301492002,
    "descripcion":"INCAPAZ DE SUBIR Y BAJAR DEL CORDÓN DE LA ACERA"
  },
  {
    "codigo":235956004,
    "descripcion":"PANCREATITIS CRÓNICA FAMILIAR"
  },
  {
    "codigo":299657000,
    "descripcion":"DEDO DEL PIE AMPUTADO"
  },
  {
    "codigo":268724009,
    "descripcion":"IMPULSO SEXUAL EXCESIVO"
  },
  {
    "codigo":397961002,
    "descripcion":"ENCEFALOMIELITIS CAUSADA POR VIRUS DE LA CORIOMENINGITIS LINFOCÍTICA"
  },
  {
    "codigo":365193002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA HIGIENIZAR LA PRÓTESIS DENTAL"
  },
  {
    "codigo":135817005,
    "descripcion":"ESTADO GENERAL DE SALUD, REGULAR"
  },
  {
    "codigo":234121006,
    "descripcion":"HIPOPLASIA DE ARTERIA"
  },
  {
    "codigo":168585007,
    "descripcion":"RADIOGRAFÍA SIMPLE DE SACRO ANORMAL"
  },
  {
    "codigo":363358000,
    "descripcion":"NEOPLASIA MALIGNA DE PULMÓN"
  },
  {
    "codigo":1348233009,
    "descripcion":"PATRÓN DE USO EPISÓDICO NOCIVO DE SUSTANCIA"
  },
  {
    "codigo":166750003,
    "descripcion":"NIVEL SÉRICO DE COBRE DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":35678005,
    "descripcion":"DOLOR DE MÚLTIPLES ARTICULACIONES"
  },
  {
    "codigo":2910007,
    "descripcion":"SECRECIÓN DEL PENE"
  },
  {
    "codigo":232286009,
    "descripcion":"VÉRTIGO SINCOPAL"
  },
  {
    "codigo":197683002,
    "descripcion":"SÍNDROME NEFRÍTICO AGUDO, GLOMERULONEFRITIS MEMBRANOSA DIFUSA"
  },
  {
    "codigo":16010991000119100,
    "descripcion":"ARTROPATÍA DE PIE IZQUIERDO"
  },
  {
    "codigo":1086191000119101,
    "descripcion":"ABSCESO DE DUODENO CONCOMITANTE CON DIVERTICULITIS Y DEBIDO A ELLA"
  },
  {
    "codigo":354031000119102,
    "descripcion":"NEOPLASIA BENIGNA DE ÓRBITA DERECHA"
  },
  {
    "codigo":36591000119102,
    "descripcion":"TERATOMA"
  },
  {
    "codigo":10627311000119101,
    "descripcion":"FORÚNCULO DE ANTEBRAZO DERECHO"
  },
  {
    "codigo":681711000119105,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE CABEZA"
  },
  {
    "codigo":305391000119106,
    "descripcion":"CONTRACTURA DE MÚSCULO DE PIERNA DERECHA"
  },
  {
    "codigo":190191000119107,
    "descripcion":"HEMORRAGIA DE COLON DEBIDA A DIVERTICULOSIS"
  },
  {
    "codigo":16266991000119108,
    "descripcion":"TRASTORNO DEPRESIVO MAYOR SEVERO CONCOMITANTE CON EPISODIO ÚNICO DE ANSIEDAD"
  },
  {
    "codigo":785672002,
    "descripcion":"HALLAZGO RELACIONADO CON EL NIVEL DE SUSTANCIA EN ORINA"
  },
  {
    "codigo":12204271000119108,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DE REGIÓN LUMBAR"
  },
  {
    "codigo":10949871000119106,
    "descripcion":"HERIDA ABIERTA DE ANTEBRAZO IZQUIERDO DEBIDA A MORDEDURA DE ANIMAL"
  },
  {
    "codigo":128477000,
    "descripcion":"ABSCESO"
  },
  {
    "codigo":294152009,
    "descripcion":"ALERGIA A NOSCAPINA"
  },
  {
    "codigo":30173002,
    "descripcion":"FIBROSITIS PRIMARIA"
  },
  {
    "codigo":341231000119107,
    "descripcion":"NEOVASCULARIZACIÓN DE LA CÓRNEA IZQUIERDA"
  },
  {
    "codigo":423389004,
    "descripcion":"PAPILA ÓPTICA PEQUEÑA"
  },
  {
    "codigo":1075951000119108,
    "descripcion":"TENOSINOVITIS DE PIE IZQUIERDO"
  },
  {
    "codigo":15995631000119109,
    "descripcion":"GLAUCOMA DE OJO DERECHO DEBIDO A IRIS PLANO"
  },
  {
    "codigo":95709007,
    "descripcion":"IRIS ATRÓFICO"
  },
  {
    "codigo":126642000,
    "descripcion":"NEOPLASIA DE FLANCO"
  },
  {
    "codigo":1177053008,
    "descripcion":"HIDROCEFALIA DEBIDA A INFECCIÓN SUPURATIVA"
  },
  {
    "codigo":292317008,
    "descripcion":"REACCIÓN ADVERSA AL PIRACETAM"
  },
  {
    "codigo":224946001,
    "descripcion":"AUTOELECTROCUCIÓN"
  },
  {
    "codigo":716466008,
    "descripcion":"CAPAZ DE COMPRENDER EL DOLOR EN UNA PARTE DEL CUERPO"
  },
  {
    "codigo":92039003,
    "descripcion":"NEOPLASIA BENIGNA DE LA MUCOSA YUGAL"
  },
  {
    "codigo":90204000,
    "descripcion":"ÁNTRAX DEL CUERO CABELLUDO"
  },
  {
    "codigo":57436000,
    "descripcion":"AUSENCIA CONGÉNITA DEL OÍDO EXTERNO"
  },
  {
    "codigo":288647009,
    "descripcion":"INCAPAZ DE ELEGIR TEMAS DE CONVERSACIÓN"
  },
  {
    "codigo":254044004,
    "descripcion":"EXOSTOSIS MÚLTIPLE CONGÉNITA"
  },
  {
    "codigo":88369005,
    "descripcion":"PRODUCCIÓN ANORMAL DE BASÓFILOS"
  },
  {
    "codigo":284977008,
    "descripcion":"DIFICULTAD PARA VESTIRSE"
  },
  {
    "codigo":283142004,
    "descripcion":"ANZUELO EN CUERO CABELLUDO"
  },
  {
    "codigo":15973461000119109,
    "descripcion":"DISPLASIA CONGÉNITA DE EXTREMIDAD INFERIOR IZQUIERDA"
  },
  {
    "codigo":838363001,
    "descripcion":"NEUROPATÍA ÓPTICA ISQUÉMICA ANTERIOR ARTERÍTICA DEBIDA A ARTERITIS DE CÉLULAS GIGANTES"
  },
  {
    "codigo":281307002,
    "descripcion":"VIABILIDAD DEL EMBARAZO, INCIERTA"
  },
  {
    "codigo":248539004,
    "descripcion":"PROBLEMAS DE FAMILIA"
  },
  {
    "codigo":1002203008,
    "descripcion":"NIVEL DE ÁCIDO 4-HIDROXIFENILPIRÚVICO EN ORINA AUMENTADO"
  },
  {
    "codigo":212101003,
    "descripcion":"QUEMADURA QUE COMPROMETE 70-79 PORCIENTO DE LA SUPERFICIE DEL CUERPO, CON QUEMADURA DE ESPESOR COMPLETO QUE AFECTA 70-79 PORCIENTO DE LA SUPERFICIE CORPORAL"
  },
  {
    "codigo":703621006,
    "descripcion":"SÍNDROME MULTIFOCAL CLÍNICAMENTE AISLADO"
  },
  {
    "codigo":408709008,
    "descripcion":"APOSICIÓN INCOMPLETA DE STENT VASCULAR EN EL MOMENTO DE LA COLOCACIÓN"
  },
  {
    "codigo":275802000,
    "descripcion":"HONGO EN EL EXAMEN MICROSCÓPICO"
  },
  {
    "codigo":243034001,
    "descripcion":"LESIÓN POR EXPLOSIÓN DE OBTURADOR"
  },
  {
    "codigo":111962006,
    "descripcion":"TOS POSTURAL"
  },
  {
    "codigo":13658006,
    "descripcion":"OSTEOCONDROSIS JUVENIL DE PELVIS"
  },
  {
    "codigo":110127006,
    "descripcion":"LACERACIÓN COMPLEJA CONTAMINADA DEL PALADAR DURO"
  },
  {
    "codigo":699951008,
    "descripcion":"GANGRENA GASEOSA DE MIEMBRO INFERIOR"
  },
  {
    "codigo":765487008,
    "descripcion":"SÍNDROME DE CROMOSOMA 5 EN ANILLO"
  },
  {
    "codigo":403204001,
    "descripcion":"QUERATOSIS ACTÍNICAS MÚLTIPLES CON COMPROMISO DE LA CARA"
  },
  {
    "codigo":206596003,
    "descripcion":"HIPERTENSIÓN NEONATAL"
  },
  {
    "codigo":42756003,
    "descripcion":"PÉRDIDA DE DIENTES PREMATURA"
  },
  {
    "codigo":75524006,
    "descripcion":"DIABETES MELLITUS RELACIONADA CON LA DESNUTRICIÓN"
  },
  {
    "codigo":304900007,
    "descripcion":"DIFICULTAD PARA CUMPLIR CON EL TRATAMIENTO"
  },
  {
    "codigo":237529005,
    "descripcion":"TIROIDITIS VIRAL AGUDA"
  },
  {
    "codigo":235694001,
    "descripcion":"DUODENITIS TUBERCULOSA"
  },
  {
    "codigo":202926002,
    "descripcion":"SINOVITIS DE LA CADERA"
  },
  {
    "codigo":301230006,
    "descripcion":"HALLAZGO PULMONAR"
  },
  {
    "codigo":299395000,
    "descripcion":"PRUEBA DEL CAJÓN ANTERIOR POSITIVA"
  },
  {
    "codigo":1251502009,
    "descripcion":"RETRACCIÓN DE PIEL DE MAMA"
  },
  {
    "codigo":201091002,
    "descripcion":"FIBROMA BLANDO"
  },
  {
    "codigo":37251003,
    "descripcion":"REFLEJO AUDITIVO"
  },
  {
    "codigo":168323001,
    "descripcion":"ORGANISMO NO AISLADO EN CULTIVO DE HISOPADO DE BOCA"
  },
  {
    "codigo":4483005,
    "descripcion":"ÚLCERA EN SACABOCADOS SIFILÍTICA"
  },
  {
    "codigo":397699006,
    "descripcion":"DEMUESTRA CONOCIMIENTO DEL MANEJO DE LA MEDICACIÓN"
  },
  {
    "codigo":232024000,
    "descripcion":"TELANGIECTASIA PARAFOVEAL"
  },
  {
    "codigo":364931008,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA INCLINARSE PARA TOCARSE LOS PIES"
  },
  {
    "codigo":723544007,
    "descripcion":"TRICODISPLASIA ESPINULOSA CAUSADA POR POLYOMAVIRUS"
  },
  {
    "codigo":461400007,
    "descripcion":"ORIGEN ANÓMALO DE LIGAMENTO ARTERIOSO EN DIVERTÍCULO AÓRTICO"
  },
  {
    "codigo":813001,
    "descripcion":"INESTABILIDAD DE TOBILLO"
  },
  {
    "codigo":230189002,
    "descripcion":"ENCEFALITIS FOCAL"
  },
  {
    "codigo":295725000,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE FLUOROURACILO"
  },
  {
    "codigo":721709000,
    "descripcion":"CARCINOMA CLOACOGÉNICO PRIMARIO DE CONDUCTO ANAL"
  },
  {
    "codigo":262957008,
    "descripcion":"CONTUSIÓN DE NERVIO CRANEAL"
  },
  {
    "codigo":228354000,
    "descripcion":"CONDUCIR ALCOHOLIZADO"
  },
  {
    "codigo":64514005,
    "descripcion":"PERCEPCIÓN DELIRANTE"
  },
  {
    "codigo":293890007,
    "descripcion":"ALERGIA A NITRAZEPAM"
  },
  {
    "codigo":95447001,
    "descripcion":"TROMBOFLEBITIS DE LA VENA MESENTÉRICA"
  },
  {
    "codigo":128215004,
    "descripcion":"NEUROPATÍA LEPROSA"
  },
  {
    "codigo":292055008,
    "descripcion":"REACCIÓN ADVERSA A LA CODEÍNA"
  },
  {
    "codigo":93612003,
    "descripcion":"OSIFICACIÓN INCOMPLETA DE HUESO CIGOMÁTICO"
  },
  {
    "codigo":60844005,
    "descripcion":"INVERSIÓN GENÉTICA"
  },
  {
    "codigo":880044007,
    "descripcion":"ANEURISMA DE VENTRÍCULO DERECHO POSTERIOR A PROCEDIMIENTO"
  },
  {
    "codigo":714369000,
    "descripcion":"CAPAZ DE ALCANZAR UNA FRECUENCIA CARDÍACA OBJETIVO"
  },
  {
    "codigo":26241001,
    "descripcion":"ARTROPATÍA DE LA MANO POR CRISTALES"
  },
  {
    "codigo":191916008,
    "descripcion":"PATRÓN DE USO NOCIVO DE COCAÍNA SIN DEPENDENCIA"
  },
  {
    "codigo":288385003,
    "descripcion":"NO UTILIZA UNA LLAVE"
  },
  {
    "codigo":386689009,
    "descripcion":"HIPOTERMIA"
  },
  {
    "codigo":778070003,
    "descripcion":"MICROCEFALIA PRIMARIA AUTOSÓMICA DOMINANTE"
  },
  {
    "codigo":253782006,
    "descripcion":"SÍNDROME DE COLON IZQUIERDO PEQUEÑO"
  },
  {
    "codigo":448555009,
    "descripcion":"LINFOMA DE CUERPO DEL ESTÓMAGO"
  },
  {
    "codigo":20736003,
    "descripcion":"LUXACIÓN NO EXPUESTA POSTERIOR DE EXTREMO DISTAL DE FÉMUR"
  },
  {
    "codigo":282880009,
    "descripcion":"DIFICULTAD PARA PONERSE DE PIE SIN AYUDA"
  },
  {
    "codigo":1264085003,
    "descripcion":"DESCAMACIÓN ANORMAL DE MEMBRANA MUCOSA"
  },
  {
    "codigo":35431000087103,
    "descripcion":"INFARTO ANTIGUO DE PARED LATERAL ALTA DE MIOCARDIO"
  },
  {
    "codigo":84437006,
    "descripcion":"NEUMOTÓRAX AGUDO"
  },
  {
    "codigo":248277009,
    "descripcion":"FALTA DE VIGOR"
  },
  {
    "codigo":18901009,
    "descripcion":"DIFTERIA CUTÁNEA"
  },
  {
    "codigo":180906006,
    "descripcion":"PARO CARDÍACO NEONATAL"
  },
  {
    "codigo":80767005,
    "descripcion":"FRACTURA NO EXPUESTA DE EPÍFISIS DISTAL DE HÚMERO"
  },
  {
    "codigo":211839007,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO SUPERFICIAL DE REGIÓN ESCAPULAR"
  },
  {
    "codigo":47999008,
    "descripcion":"AGNOSIA IDEATIVA"
  },
  {
    "codigo":703359009,
    "descripcion":"PROLAPSO DE VÁLVULA MITRAL DEGENERATIVO"
  },
  {
    "codigo":331761000119105,
    "descripcion":"DEFORMIDAD DE ÓRBITA DE OJO DERECHO DEBIDA A LESIÓN TRAUMÁTICA"
  },
  {
    "codigo":767060004,
    "descripcion":"LESIÓN CORONAL NO CAVITADA"
  },
  {
    "codigo":406612005,
    "descripcion":"ENFERMEDAD INVASIVA POR ESTREPTOCOCO BETAHEMOLÍTICO DEL GRUPO B"
  },
  {
    "codigo":372009000,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL ESCROTO"
  },
  {
    "codigo":15732721000119107,
    "descripcion":"PTOSIS PALPEBRAL ADQUIRIDA BILATERAL"
  },
  {
    "codigo":77097004,
    "descripcion":"DISTROFIA MUSCULAR OCULOFARÍNGEA"
  },
  {
    "codigo":239102001,
    "descripcion":"PRURITO DEL EMBARAZO"
  },
  {
    "codigo":1254910002,
    "descripcion":"DESPIGMENTACIÓN DE PIEL DEBIDA A CIRUGÍA PLÁSTICA Y POSTERIOR A ELLA"
  },
  {
    "codigo":11774091000119103,
    "descripcion":"CONTUSIÓN DE DEDO MEDIO DE LA MANO IZQUIERDA"
  },
  {
    "codigo":402942007,
    "descripcion":"CHANCRO SIFILÍTICO DE LAS MUCOSAS BUCALES"
  },
  {
    "codigo":1187539006,
    "descripcion":"ANGIOPATÍA AMILOIDE DE CEREBRO FAMILIAR NO NEUROPÁTICA"
  },
  {
    "codigo":237267007,
    "descripcion":"RUPTURA PRETÉRMINO PROLONGADA DE LAS MEMBRANAS"
  },
  {
    "codigo":366504001,
    "descripcion":"HALLAZGO RELACIONADO CON EL MOVIMIENTO DEL HOMBRO"
  },
  {
    "codigo":202664003,
    "descripcion":"MIELOPATÍA CERVICAL"
  },
  {
    "codigo":169896003,
    "descripcion":"PUNTAJE DE APGAR AL MINUTO = 0"
  },
  {
    "codigo":38824008,
    "descripcion":"ANOMALÍA CONGÉNITA DEL TIMO"
  },
  {
    "codigo":299133001,
    "descripcion":"TUMEFACCIÓN ÓSEA DEL PULGAR"
  },
  {
    "codigo":69757000,
    "descripcion":"AFASIA PATEMÁTICA"
  },
  {
    "codigo":36989005,
    "descripcion":"PAROTIDITIS"
  },
  {
    "codigo":102525006,
    "descripcion":"EDAD MAYOR DE 50 AÑOS, SEXO MASCULINO"
  },
  {
    "codigo":428370001,
    "descripcion":"ABSTINENCIA DE PSICOESTIMULANTE"
  },
  {
    "codigo":35154004,
    "descripcion":"PÉNFIGO FOLIÁCEO"
  },
  {
    "codigo":262695000,
    "descripcion":"EDEMA CEREBRAL FOCALIZADO TRAUMÁTICO"
  },
  {
    "codigo":721447006,
    "descripcion":"SÍNDROME DEL CORDÓN CENTRAL DE MÉDULA ESPINAL AL NIVEL DEL QUINTO SEGMENTO DORSAL"
  },
  {
    "codigo":195324000,
    "descripcion":"EMBOLIA Y TROMBOSIS DE LA ARTERIA POPLÍTEA"
  },
  {
    "codigo":129788004,
    "descripcion":"HALLAZGO MAMOGRÁFICO DE MASA MAMARIA"
  },
  {
    "codigo":64252005,
    "descripcion":"APENDICITIS GANGRENOSA AGUDA CON PERFORACIÓN Y PERITONITIS"
  },
  {
    "codigo":293628006,
    "descripcion":"ALERGIA A FENILBUTAZONA"
  },
  {
    "codigo":160721001,
    "descripcion":"VIVIENDA QUE NO CUBRE LAS NECESIDADES"
  },
  {
    "codigo":95185005,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE HUESO CIGOMÁTICO"
  },
  {
    "codigo":193489006,
    "descripcion":"IRITIS DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":816081007,
    "descripcion":"PÉRDIDA DE VOLUMEN DE LÍQUIDO EXTRACELULAR"
  },
  {
    "codigo":93350000,
    "descripcion":"POSICIÓN ANÓMALA CONGÉNITA DE VÉRTEBRA SACRA"
  },
  {
    "codigo":224422002,
    "descripcion":"SIN INSTALACIONES DE DUCHAS EN EL TRABAJO"
  },
  {
    "codigo":714107007,
    "descripcion":"INCAPACIDAD PARA REVERTIR EL BLOQUEO NEUROMUSCULAR"
  },
  {
    "codigo":124283007,
    "descripcion":"DEFICIENCIA DE METIONINA ADENOSILTRANSFERASA"
  },
  {
    "codigo":15980991000119105,
    "descripcion":"BLEFAROFIMOSIS ADQUIRIDA DE PÁRPADOS DE AMBOS OJOS"
  },
  {
    "codigo":253520003,
    "descripcion":"HIPOPLASIA DEL TRACTO DE SALIDA DEL VENTRÍCULO DERECHO"
  },
  {
    "codigo":286288007,
    "descripcion":"INCAPAZ DE IMITAR SONIDOS DEL HABLA"
  },
  {
    "codigo":415525005,
    "descripcion":"ENCEFALITIS CAUSADA POR VIRUS TRANSMITIDO POR LA GARRAPATA SIBERIANA"
  },
  {
    "codigo":334271000119108,
    "descripcion":"BLEFAROCALASIA DE PÁRPADO INFERIOR DERECHO"
  },
  {
    "codigo":1003514000,
    "descripcion":"AGENESIA DE HÍGADO"
  },
  {
    "codigo":249850002,
    "descripcion":"POSTURA ESPÁSTICA"
  },
  {
    "codigo":774138005,
    "descripcion":"INESTABILIDAD DE ARTICULACIÓN DE LA CADERA DERECHA"
  },
  {
    "codigo":282618006,
    "descripcion":"DIFICULTAD PARA ARRASTRAR LOS PIES"
  },
  {
    "codigo":20474007,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚLTIPLES SITIOS DEL PÁNCREAS SIN HERIDA ABIERTA HACIA CAVIDAD ABDOMINAL"
  },
  {
    "codigo":315386009,
    "descripcion":"NACIDO EN BOLIVIA"
  },
  {
    "codigo":248015004,
    "descripcion":"INICIACIÓN DE INCENDIOS"
  },
  {
    "codigo":15708761000119105,
    "descripcion":"LUXACIÓN RECURRENTE DE AMBAS ARTICULACIONES DE RODILLAS"
  },
  {
    "codigo":410020008,
    "descripcion":"POLIARTRITIS POR ERYSIPELOTHRIX RHUSIOPATHIAE"
  },
  {
    "codigo":14969004,
    "descripcion":"LARINGITIS CATARRAL"
  },
  {
    "codigo":211577007,
    "descripcion":"LESIÓN ABIERTA POR APLASTAMIENTO DE LA MUÑECA, PALMAR"
  },
  {
    "codigo":275278005,
    "descripcion":"DIFICULTAD PARA RECORDAR FECHAS"
  },
  {
    "codigo":373582007,
    "descripcion":"QUISTE DE BOLSA SEROSA CAUSADO POR FRICCIÓN"
  },
  {
    "codigo":111438007,
    "descripcion":"HIPERTENSIÓN SECUNDARIA A NEFROPATÍA EN EL CONTEXTO OBSTÉTRICO"
  },
  {
    "codigo":734030009,
    "descripcion":"SÍNDROME DE MICRODELECIÓN 12Q15Q21.1"
  },
  {
    "codigo":207907000,
    "descripcion":"FRACTURA NO EXPUESTA DE VÉRTEBRA CERVICAL, APÓFISIS TRANSVERSA"
  },
  {
    "codigo":764963007,
    "descripcion":"QUERATODERMIA PALMOPLANTAR Y GINGIVAL FOCAL"
  },
  {
    "codigo":109603007,
    "descripcion":"ABSCESO APICAL CRÓNICO"
  },
  {
    "codigo":271608006,
    "descripcion":"PUPILAS PUNTIFORMES"
  },
  {
    "codigo":1187277001,
    "descripcion":"SÍNDROME DE BAJA TALLA, BRAQUIDACTILIA, OBESIDAD Y RETRASO GLOBAL DEL DESARROLLO"
  },
  {
    "codigo":238840009,
    "descripcion":"SEUDOATROFODERMA COLLI"
  },
  {
    "codigo":763128009,
    "descripcion":"ASTRÁGALO BIPARTITO"
  },
  {
    "codigo":16638861000119102,
    "descripcion":"COMPRESIÓN DE AMBOS NERVIOS PERONEOS SUPERFICIALES"
  },
  {
    "codigo":300706003,
    "descripcion":"DEPRESIÓN ENDÓGENA"
  },
  {
    "codigo":5794003,
    "descripcion":"CAMPESINO"
  },
  {
    "codigo":366242006,
    "descripcion":"HALLAZGO RELACIONADO CON EL ASPECTO DEL EMPASTE DENTAL"
  },
  {
    "codigo":298871002,
    "descripcion":"TUMEFACCIÓN ÓSEA DE CODO"
  },
  {
    "codigo":11987671000119100,
    "descripcion":"QUEMADURA EPIDÉRMICA DE PIERNA DERECHA"
  },
  {
    "codigo":724855008,
    "descripcion":"PÚRPURA CUTÁNEA CAUSADA POR FUERZA MECÁNICA"
  },
  {
    "codigo":723020000,
    "descripcion":"DESPLAZAMIENTO AXIAL DE GLOBO OCULAR"
  },
  {
    "codigo":231500002,
    "descripcion":"DEPRESIÓN ENCUBIERTA"
  },
  {
    "codigo":10632231000119100,
    "descripcion":"ABSCESO DE PULGAR DE MANO IZQUIERDA"
  },
  {
    "codigo":721185002,
    "descripcion":"ANEMIA MEGALOBLÁSTICA DEBIDA A DEFICIENCIA DE FOLATO EN EL EMBARAZO Y LA LACTANCIA"
  },
  {
    "codigo":1074061000119108,
    "descripcion":"CONDROCALCINOSIS DE HOMBRO DERECHO"
  },
  {
    "codigo":229665008,
    "descripcion":"DISFASIA EXPRESIVA"
  },
  {
    "codigo":63990000,
    "descripcion":"URTICARIA PSICÓGENA"
  },
  {
    "codigo":293366001,
    "descripcion":"REACCIÓN ADVERSA AL FOSFATO FERROSO"
  },
  {
    "codigo":295201009,
    "descripcion":"SOBREDOSIS DE FENOPERIDINA"
  },
  {
    "codigo":162294008,
    "descripcion":"TIENE DIFICULTAD CON EL HABLA"
  },
  {
    "codigo":719350008,
    "descripcion":"CAPAZ DE COMPRENDER EL LENGUAGE VERBAL"
  },
  {
    "codigo":291531006,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR ÁCIDO FUSÍDICO"
  },
  {
    "codigo":224160000,
    "descripcion":"PRISIONERO DE GUERRA EN ALEMANIA"
  },
  {
    "codigo":93088007,
    "descripcion":"FENESTRACIÓN CONGÉNITA DE HUESO ESCAMOSO"
  },
  {
    "codigo":124021000,
    "descripcion":"ALFAGLOBULINA DE ESTRUCTURA ANORMAL"
  },
  {
    "codigo":289696008,
    "descripcion":"CICATRIZ DEL SEGMENTO UTERINO SUPERIOR DOLOROSA A LA PALPACIÓN"
  },
  {
    "codigo":255093003,
    "descripcion":"NEOPLASIA MALIGNA DE ANEXOS CUTÁNEOS"
  },
  {
    "codigo":713845004,
    "descripcion":"INFECCIÓN CAUSADA POR CRYPTOSPORIDIUM CONCOMITANTE CON INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":449866003,
    "descripcion":"DISPLASIA VITREORRETINIANA"
  },
  {
    "codigo":187722004,
    "descripcion":"NEOPLASIA MALIGNA DE ESÓFAGO CERVICAL"
  },
  {
    "codigo":417098007,
    "descripcion":"TORSIÓN DEL SACRO"
  },
  {
    "codigo":284191001,
    "descripcion":"QUEMADURA DE ESTRUCTURA LINFORRETICULAR"
  },
  {
    "codigo":446196005,
    "descripcion":"SUBLUXACIÓN DE ESTERNÓN"
  },
  {
    "codigo":249588006,
    "descripcion":"FRICCIÓN ESPLÉNICA DETECTADA"
  },
  {
    "codigo":413428007,
    "descripcion":"CIFOSIS ADQUIRIDA"
  },
  {
    "codigo":247753000,
    "descripcion":"PÉRDIDA DE INTERÉS"
  },
  {
    "codigo":18377001,
    "descripcion":"PIGMENTACIÓN CORNEAL ANTERIOR"
  },
  {
    "codigo":870345007,
    "descripcion":"COMPRESIÓN DE MÉDULA ESPINAL DEBIDA A HEMANGIOMA CAVERNOSO"
  },
  {
    "codigo":704670000,
    "descripcion":"PÉRDIDA DE DIMENSIÓN DE OCLUSIÓN VERTICAL DEBIDA A PRÓTESIS DENTAL PARCIAL REMOVIBLE DESGASTADA"
  },
  {
    "codigo":278686001,
    "descripcion":"OCLUSIÓN FUNCIONAL GRUPAL"
  },
  {
    "codigo":213150003,
    "descripcion":"FALLA Y RECHAZO DEL TRASPLANTE RENAL"
  },
  {
    "codigo":168840001,
    "descripcion":"ENEMA DE BARIO: ANORMAL"
  },
  {
    "codigo":276851006,
    "descripcion":"PAPILOMA INTRADUCTAL DE PÁNCREAS"
  },
  {
    "codigo":473459007,
    "descripcion":"COMPLICACIÓN DE PROCEDIMIENTO EN SISTEMA CARDIOVASCULAR"
  },
  {
    "codigo":735603007,
    "descripcion":"DESGASTE DE SUPERFICIE ARTICULAR DE PRÓTESIS ARTICULAR DE RODILLA"
  },
  {
    "codigo":1290824001,
    "descripcion":"RADIOGRAFÍA DE PARTES BLANDAS DE CAVIDAD BUCAL ANORMAL"
  },
  {
    "codigo":209480000,
    "descripcion":"ESGUINCE DE DEDO DE LA MANO, ARTICULACIÓN METACARPOFALÁNGICA, LIGAMENTO LATERAL RADIAL"
  },
  {
    "codigo":45640006,
    "descripcion":"ÚLCERA GASTROYEYUNAL CRÓNICA CON HEMORRAGIA Y PERFORACIÓN"
  },
  {
    "codigo":111176008,
    "descripcion":"DIETA CÁLCICA"
  },
  {
    "codigo":240413000,
    "descripcion":"INFECCIÓN MICOBACTERIANA ATÍPICA DISEMINADA"
  },
  {
    "codigo":109341005,
    "descripcion":"SECUESTRO DE HUESO FRONTAL"
  },
  {
    "codigo":238578002,
    "descripcion":"DERMATITIS POR CONTACTO ALÉRGICA OCUPACIONAL"
  },
  {
    "codigo":369650007,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA DE ENDOMETRIO EN ESPÉCIMEN DE HISTERECTOMÍA, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":302279001,
    "descripcion":"DIFICULTAD PARA TRASLADARSE DE LA SILLA DE RUEDAS AL INODORO"
  },
  {
    "codigo":105671004,
    "descripcion":"ENFERMEDAD CAUSADA POR CYCLOCOELIDAE"
  },
  {
    "codigo":1285319006,
    "descripcion":"APLASIA AISLADA DE NERVIO ÓPTICO"
  },
  {
    "codigo":236743008,
    "descripcion":"BALANITIS CIRCUMSCRIPTA PLASMOCELULAR"
  },
  {
    "codigo":300444006,
    "descripcion":"RIÑÓN GRANDE"
  },
  {
    "codigo":365980008,
    "descripcion":"HALLAZGO RELACIONADO CON EL CONSUMO Y LA EXPOSICIÓN AL TABACO"
  },
  {
    "codigo":69233001,
    "descripcion":"MOVIMIENTOS FACIALES PARADÓJICOS"
  },
  {
    "codigo":298609002,
    "descripcion":"AMPLITUD DE FLEXIÓN PASIVA DE LA COLUMNA LUMBAR DISMINUIDA"
  },
  {
    "codigo":396913004,
    "descripcion":"ESTADIO IVB: DISEMINACIÓN HEMATÓGENA O LINFÁTICA (TIMO)"
  },
  {
    "codigo":724593005,
    "descripcion":"SÍNDROME AUTOINFLAMATORIO MONOGÉNICO"
  },
  {
    "codigo":788294003,
    "descripcion":"LINFANGIECTASIA CUTÁNEA CONGÉNITA"
  },
  {
    "codigo":34630004,
    "descripcion":"PITIRIASIS"
  },
  {
    "codigo":460614005,
    "descripcion":"DILATACIÓN DE VÁLVULA AURICULOVENTRICULAR IZQUIERDA (MORFOLÓGICAMENTE NO MITRAL) EN VENTRÍCULO CON DOBLE TRACTO DE ENTRADA"
  },
  {
    "codigo":286351000119103,
    "descripcion":"CONEXIÓN VENOSA PULMONAR TOTALMENTE ANÓMALA A AURÍCULA DERECHA"
  },
  {
    "codigo":722758004,
    "descripcion":"GLOMERULOPATÍA POR COMPONENTE 3 DEL COMPLEMENTO"
  },
  {
    "codigo":131099000,
    "descripcion":"NIVEL DE 3,3' DIYODOTIRONINA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":293104008,
    "descripcion":"REACCIÓN ADVERSA A COMPONENTE DE VACUNA"
  },
  {
    "codigo":192965001,
    "descripcion":"TETRAPLEJÍA ESPÁSTICA"
  },
  {
    "codigo":291269002,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ATENOLOL"
  },
  {
    "codigo":717253001,
    "descripcion":"DOLOR CON CUALIDAD PERFORANTE"
  },
  {
    "codigo":16670351000119107,
    "descripcion":"FRACTURA NO EXPUESTA DE CUERPO DE MANDÍBULA IZQUIERDA"
  },
  {
    "codigo":94661005,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA URETRA"
  },
  {
    "codigo":289434000,
    "descripcion":"HALLAZGO RELACIONADO CON EL PATRÓN DE MOVIMIENTO FETAL"
  },
  {
    "codigo":1010330000,
    "descripcion":"FLEXIÓN DE LADO IZQUIERDO DE COLUMNA VERTEBRAL SACRA"
  },
  {
    "codigo":125594001,
    "descripcion":"LESIÓN TRAUMÁTICA EN REGIÓN DE HOMBRO"
  },
  {
    "codigo":1079081000119103,
    "descripcion":"ANGIOSARCOMA PRIMARIO DE REGIÓN DE HOMBRO DERECHO"
  },
  {
    "codigo":715418007,
    "descripcion":"SÍNDROME LETAL DE CONTRACTURAS CONGÉNITAS TIPO 1"
  },
  {
    "codigo":60058008,
    "descripcion":"ESGUINCE DE LIGAMENTO CRUZADO DE RODILLA"
  },
  {
    "codigo":1303407003,
    "descripcion":"VISTE SÓLO ROPA INTERIOR"
  },
  {
    "codigo":254831005,
    "descripcion":"NEOPLASIA DE TEJIDO ADIPOSO"
  },
  {
    "codigo":713583005,
    "descripcion":"DEPENDENCIA DE ALCOHOL, LEVE"
  },
  {
    "codigo":123759007,
    "descripcion":"HIPERFUNCIÓN ADENOHIPOFISARIA PREPUBERAL"
  },
  {
    "codigo":449604000,
    "descripcion":"OBSTRUCCIÓN SUBPULMONAR DEL TRACTO DE SALIDA EN VENTRÍCULO INDETERMINADO SOLITARIO"
  },
  {
    "codigo":285764004,
    "descripcion":"NISTAGMO MANIFIESTO"
  },
  {
    "codigo":283929003,
    "descripcion":"HEMATOMA DE LA PRÓSTATA"
  },
  {
    "codigo":54553003,
    "descripcion":"ESTENOSIS DE CONDUCTO SALIVAL"
  },
  {
    "codigo":251161003,
    "descripcion":"RESPUESTA VENTRICULAR LENTA"
  },
  {
    "codigo":183790000,
    "descripcion":"INSCRIPTO EN LISTA DE ADMISIÓN GINECOLÓGICA"
  },
  {
    "codigo":185625009,
    "descripcion":"RENUNCIA A LA REALIZACIÓN DE EXTENDIDO CERVICAL, RECIBIDA"
  },
  {
    "codigo":249326006,
    "descripcion":"PUNTA BÍFIDA DE LA NARIZ"
  },
  {
    "codigo":282094006,
    "descripcion":"REACCIÓN ALÉRGICA CAUSADA POR VENENO DE INSECTO"
  },
  {
    "codigo":314862009,
    "descripcion":"OBSTRUCCIÓN PRIMARIA ADQUIRIDA DE CONDUCTO NASOLAGRIMAL"
  },
  {
    "codigo":247491004,
    "descripcion":"ANOMALÍA DEL TEJIDO UNGUEAL"
  },
  {
    "codigo":737176000,
    "descripcion":"HIPERMAGNESURIA"
  },
  {
    "codigo":407661002,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: VIETNAMÉS"
  },
  {
    "codigo":243821003,
    "descripcion":"ESTADO DEL MÉTODO DEL RITMO"
  },
  {
    "codigo":276589006,
    "descripcion":"LACERACIÓN TENTORIAL PERINATAL"
  },
  {
    "codigo":211053006,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE TRONCO, INFECTADA"
  },
  {
    "codigo":1259629009,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE HIPÓFISIS"
  },
  {
    "codigo":209218003,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA NO EXPUESTA DE LA ARTICULACIÓN COSTOCONDRAL"
  },
  {
    "codigo":241986003,
    "descripcion":"PRESIÓN DEL TRAJE"
  },
  {
    "codigo":373058005,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM SENEGALENSE"
  },
  {
    "codigo":78146007,
    "descripcion":"MIXEDEMA PRETIBIAL"
  },
  {
    "codigo":274754009,
    "descripcion":"TUMEFACCIÓN PÉLVICA"
  },
  {
    "codigo":733506009,
    "descripcion":"NEUROPATÍA ÓPTICA ISQUÉMICA ANTERIOR ARTERÍTICA"
  },
  {
    "codigo":305687004,
    "descripcion":"ATENDIDO POR UN MÉDICO ESPECIALISTA EN REHABILITACIÓN"
  },
  {
    "codigo":698903005,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: JAVANÉS"
  },
  {
    "codigo":762604001,
    "descripcion":"DOLOR FACIAL CRÓNICO SECUNDARIO"
  },
  {
    "codigo":303852004,
    "descripcion":"INTOLERANCIA PROTEICA LISINÚRICA"
  },
  {
    "codigo":205548006,
    "descripcion":"ICTIOSIS TIPO ARLEQUÍN"
  },
  {
    "codigo":41708006,
    "descripcion":"CUERPO EXTRAÑO NO MAGNÉTICO RETENIDO EN LA PARED POSTERIOR DEL OJO"
  },
  {
    "codigo":203713000,
    "descripcion":"ESTENOSIS DE CONDUCTO VERTEBRAL DEBIDA A DISCO INTERVERTEBRAL"
  },
  {
    "codigo":302017001,
    "descripcion":"OJO DOLOROSO"
  },
  {
    "codigo":402156008,
    "descripcion":"DERMATOSIS CAUSADA POR ÁCARO PARASITARIO DE AVE"
  },
  {
    "codigo":1081591000119101,
    "descripcion":"RETINOBLASTOMA PRIMARIO IZQUIERDO"
  },
  {
    "codigo":236481004,
    "descripcion":"NEFROPATÍA ADQUIRIDA CON PÉRDIDA DE MAGNESIO"
  },
  {
    "codigo":365718003,
    "descripcion":"LÍQUIDO CEFALORRAQUÍDEO: COMPOSICIÓN QUÍMICA, GENERAL - HALLAZGO"
  },
  {
    "codigo":267414004,
    "descripcion":"JUMPING (ENFERMEDAD DE LOS FRANCESES DEL MAINE)"
  },
  {
    "codigo":234646005,
    "descripcion":"ENFERMEDAD DE INJERTO VERSUS HUÉSPED"
  },
  {
    "codigo":300182006,
    "descripcion":"HUESECILLOS DEL OÍDO NORMALES"
  },
  {
    "codigo":298347004,
    "descripcion":"CAÍDAS INFRECUENTES"
  },
  {
    "codigo":429419004,
    "descripcion":"ARTROPATÍA DE MUÑECA POR CRISTALES"
  },
  {
    "codigo":167275009,
    "descripcion":"PRUEBA DE PROTEÍNAS EN ORINA = +"
  },
  {
    "codigo":1345088003,
    "descripcion":"DEPENDENCIA DE CORTICOESTEROIDE EN USO TERAPÉUTICO"
  },
  {
    "codigo":460352004,
    "descripcion":"MIOCARDITIS CAUSADA POR SPIROCHAETALES"
  },
  {
    "codigo":165440005,
    "descripcion":"HEMOGLOBINA CORPUSCULAR MEDIA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":11786641000119100,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO DE REGIÓN INGUINAL DERECHA"
  },
  {
    "codigo":427584009,
    "descripcion":"FRACTURA NO EXPUESTA DE SALTER-HARRIS TIPO II DE EPÍFISIS DISTAL DE FÉMUR"
  },
  {
    "codigo":818965006,
    "descripcion":"NECROSIS AVASCULAR DE TARSO"
  },
  {
    "codigo":12114321000119102,
    "descripcion":"QUEMADURA QUÍMICA DE PALMA IZQUIERDA"
  },
  {
    "codigo":294677009,
    "descripcion":"ALERGIA A CORTICOSTEROIDE Y\/O DERIVADO DE CORTICOSTEROIDE"
  },
  {
    "codigo":292842006,
    "descripcion":"REACCIÓN ADVERSA AL FOSCARNET"
  },
  {
    "codigo":225471004,
    "descripcion":"ENTUSIASTA"
  },
  {
    "codigo":94399005,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE BRONQUIO PRINCIPAL"
  },
  {
    "codigo":127167006,
    "descripcion":"LINFADENOPATÍA ILÍACA EXTERNA MEDIAL"
  },
  {
    "codigo":420244003,
    "descripcion":"ENCEFALITIS ASOCIADA CON SIDA"
  },
  {
    "codigo":92564006,
    "descripcion":"CARCINOMA IN SITU DE CUELLO UTERINO"
  },
  {
    "codigo":1237609007,
    "descripcion":"VENA VARICOSA DE PIE"
  },
  {
    "codigo":88894000,
    "descripcion":"SÍNDROME DE TRISOMÍA PARCIAL 4Q"
  },
  {
    "codigo":416574002,
    "descripcion":"INFECCIÓN CAUSADA POR NANOPHYETUS"
  },
  {
    "codigo":1268542008,
    "descripcion":"CARCINOMA MUCINOSO PAPILAR INTRADUCTAL INVASIVO PRIMARIO DE PÁNCREAS"
  },
  {
    "codigo":250899001,
    "descripcion":"HALLAZGO RELACIONADO CON EL ESTRIBO"
  },
  {
    "codigo":283667002,
    "descripcion":"HERIDA POR PINCHAZO DE CLAVO EN EXTREMIDAD INFERIOR"
  },
  {
    "codigo":21523006,
    "descripcion":"GOMA SIFILÍTICO DEL SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":42031000087103,
    "descripcion":"QUEMADURA DE PABELLÓN AURICULAR DERECHO"
  },
  {
    "codigo":11842091000119105,
    "descripcion":"LACERACIÓN DE TENDÓN DEL PIE DERECHO"
  },
  {
    "codigo":47151000087105,
    "descripcion":"ESGUINCE DE LIGAMENTO DE EXTREMIDAD SUPERIOR DERECHA"
  },
  {
    "codigo":185363009,
    "descripcion":"DERIVADO POR OBSTÉTRICA"
  },
  {
    "codigo":249064003,
    "descripcion":"POSICIÓN OBLICUA, CABEZA EN FOSA ILÍACA"
  },
  {
    "codigo":127531000119106,
    "descripcion":"INFECCIÓN CAUSADA POR ESCHERICHIA COLI O157"
  },
  {
    "codigo":871656006,
    "descripcion":"ANOMALÍA ADQUIRIDA DE RAMA DEL CAYADO AÓRTICO"
  },
  {
    "codigo":609512008,
    "descripcion":"INTERRUPCIÓN INDUCIDA DEL EMBARAZO COMPLICADA POR OLIGURIA"
  },
  {
    "codigo":1230269002,
    "descripcion":"QUISTE CONGÉNITO DE CONDUCTO NASOLAGRIMAL"
  },
  {
    "codigo":247229007,
    "descripcion":"COLATERALES VENOSAS DE LA PAPILA ÓPTICA"
  },
  {
    "codigo":346821000119102,
    "descripcion":"CONJUNTIVITIS FOLICULAR CRÓNICA BILATERAL"
  },
  {
    "codigo":81554001,
    "descripcion":"TUBERCULOSIS DEL PULMÓN CON COMPROMISO DE LOS BRONQUIOS"
  },
  {
    "codigo":442002001,
    "descripcion":"INFECCIÓN CAUSADA POR VIRUS HERPES HUMANO 7"
  },
  {
    "codigo":1259367002,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE BRONQUIO"
  },
  {
    "codigo":14183003,
    "descripcion":"TRASTORNO DEPRESIVO MAYOR CRÓNICO, UN SOLO EPISODIO"
  },
  {
    "codigo":11815621000119104,
    "descripcion":"RUPTURA TRAUMÁTICA DE PLACA PALMAR DE ARTICULACIÓN DE DEDO ÍNDICE DERECHO"
  },
  {
    "codigo":866151004,
    "descripcion":"LINFOCITOPENIA DEBIDA A COVID-19"
  },
  {
    "codigo":767847006,
    "descripcion":"QUISTE ÓSEO DE TOBILLO"
  },
  {
    "codigo":733244001,
    "descripcion":"HERIDA PUNZANTE DE MUÑECA CON CUERPO EXTRAÑO"
  },
  {
    "codigo":45116002,
    "descripcion":"DEFICIENCIA DE SEPIAPTERINA REDUCTASA"
  },
  {
    "codigo":405564001,
    "descripcion":"ESTENOSIS DE ARTERIA HEPÁTICA"
  },
  {
    "codigo":208956001,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA EXPUESTA DE LA ARTICULACIÓN FEMORORROTULIANA"
  },
  {
    "codigo":12348006,
    "descripcion":"DEMENCIA PRESENIL"
  },
  {
    "codigo":698641001,
    "descripcion":"MENINGITIS ASÉPTICA POSOPERATORIA"
  },
  {
    "codigo":320351000119101,
    "descripcion":"ARTROSIS SECUNDARIA DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":239889005,
    "descripcion":"LUPUS ERITEMATOSO SISTÉMICO BULLOSO"
  },
  {
    "codigo":403729006,
    "descripcion":"NEOPLASIA MALIGNA DE PIEL CAUSADA POR RADIACIÓN"
  },
  {
    "codigo":370961005,
    "descripcion":"TRASTORNO DEL CAMPO VISUAL POR GLAUCOMA"
  },
  {
    "codigo":41446000,
    "descripcion":"BLEFARITIS"
  },
  {
    "codigo":205286001,
    "descripcion":"DUPLICACIÓN DE RADIO"
  },
  {
    "codigo":895249008,
    "descripcion":"FORMA ANCHA ANORMAL CONGÉNITA DE FALANGE MEDIA DE DEDO MEDIO DE MANO"
  },
  {
    "codigo":238054000,
    "descripcion":"PORFIRIA AGUDA INTERMITENTE HOMOCIGOTA"
  },
  {
    "codigo":301755001,
    "descripcion":"PIE ISQUÉMICO"
  },
  {
    "codigo":203451004,
    "descripcion":"FRACTURA OSTEOPORÓTICA DE VÉRTEBRA DORSAL"
  },
  {
    "codigo":400059005,
    "descripcion":"QUERATOSIS PILOSA ATRÓFICA"
  },
  {
    "codigo":37776001,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE PERINEO CON INFECCIÓN"
  },
  {
    "codigo":365456003,
    "descripcion":"HALLAZGO RELACIONADO CON DATOS ÉTNICOS \/ DE NACIONALIDAD"
  },
  {
    "codigo":299920008,
    "descripcion":"HALLAZGO RELACIONADO CON LA DISCRIMINACIÓN TÁCTIL"
  },
  {
    "codigo":725904009,
    "descripcion":"GENOCONDROMATOSIS TIPO 2"
  },
  {
    "codigo":68709002,
    "descripcion":"INTOXICACIÓN POR DIFENILPIRALINA"
  },
  {
    "codigo":298085006,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DEL TRONCO"
  },
  {
    "codigo":724069009,
    "descripcion":"SÍNDROME DE PIE HENDIDO CON DISOSTOSIS MANDIBULOFACIAL"
  },
  {
    "codigo":34106002,
    "descripcion":"POSICIÓN DE TRENDELENBURG"
  },
  {
    "codigo":294415000,
    "descripcion":"ALERGIA A CLOROXILENOL"
  },
  {
    "codigo":230714009,
    "descripcion":"ACCIDENTE CEREBROVASCULAR (ACV) DE LA CIRCULACIÓN ANTERIOR DE PATOLOGÍA INCIERTA"
  },
  {
    "codigo":296250008,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE TRIFLUOPERAZINA"
  },
  {
    "codigo":32271000,
    "descripcion":"INTOXICACIÓN POR ARISAEMA TRIPHYLLUM"
  },
  {
    "codigo":292580004,
    "descripcion":"REACCIÓN ADVERSA A LA CICLIZINA"
  },
  {
    "codigo":1275620004,
    "descripcion":"MÚLTIPLES LESIONES DE AMBAS RETINAS SIN DESPRENDIMIENTO"
  },
  {
    "codigo":390884006,
    "descripcion":"SEGUIMIENTO DE INSUFICIENCIA CARDÍACA"
  },
  {
    "codigo":1144548006,
    "descripcion":"APLASIA DE VEJIGA"
  },
  {
    "codigo":63204009,
    "descripcion":"BOUFFÉE DELIRANTE"
  },
  {
    "codigo":126905005,
    "descripcion":"NEOPLASIA DEL ESCROTO"
  },
  {
    "codigo":290745005,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR AMINOGLUTETIMIDA"
  },
  {
    "codigo":419982005,
    "descripcion":"DEGENERACIÓN DEL ESTROMA CORNEAL"
  },
  {
    "codigo":59534005,
    "descripcion":"MECONIO EN LÍQUIDO AMNIÓTICO, SIN SEGURIDAD DE HABER SIDO NOTADO ANTES O DESPUÉS DEL INICIO DEL TRABAJO DE PARTO EN INFANTE NACIDO VIVO"
  },
  {
    "codigo":288910007,
    "descripcion":"NO MUEVE EL ALIMENTO EN LA BOCA"
  },
  {
    "codigo":92302006,
    "descripcion":"NEOPLASIA BENIGNA DEL MEDIASTINO POSTERIOR"
  },
  {
    "codigo":190606006,
    "descripcion":"DESNUTRICIÓN CALORICOPROTEICA MODERADA"
  },
  {
    "codigo":11818131000119104,
    "descripcion":"ESGUINCE DE LIGAMENTO DE ARTICULACIÓN METACARPOFALÁNGICA DE DEDO ÍNDICE DERECHO"
  },
  {
    "codigo":287075005,
    "descripcion":"CONSOLIDACIÓN DEFECTUOSA DE FRACTURA - MANO"
  },
  {
    "codigo":713059005,
    "descripcion":"DELINCUENTE JOVEN"
  },
  {
    "codigo":55864004,
    "descripcion":"ARRODILLARSE"
  },
  {
    "codigo":23096007,
    "descripcion":"NEURALGIA CRANEAL"
  },
  {
    "codigo":283405003,
    "descripcion":"CORTE EN LA MEJILLA"
  },
  {
    "codigo":840461004,
    "descripcion":"NEUROPATÍA CRANEAL CAUSADA POR INFECCIÓN DE PORCIÓN PETROSA DE HUESO TEMPORAL"
  },
  {
    "codigo":21261008,
    "descripcion":"CAPACIDAD FUNCIONAL RESIDUAL DISMINUIDA"
  },
  {
    "codigo":445410003,
    "descripcion":"FRACTURA NO EXPUESTA DE TIBIA Y PERONÉ DISTALES"
  },
  {
    "codigo":248802009,
    "descripcion":"AUSENCIA DE MAMA"
  },
  {
    "codigo":246967007,
    "descripcion":"OPACIDAD CORNEAL CENTRAL POSTERIOR"
  },
  {
    "codigo":212364001,
    "descripcion":"LESIÓN TRAUMÁTICA DE VENA SUPERFICIAL A NIVEL DE HOMBRO Y BRAZO"
  },
  {
    "codigo":736652002,
    "descripcion":"TRASTORNO METABÓLICO NEONATAL"
  },
  {
    "codigo":277900008,
    "descripcion":"ESPUTO GRISÁCEO"
  },
  {
    "codigo":1259105003,
    "descripcion":"INFLAMACIÓN AUTOINMUNITARIA DE PLEXO BRAQUIAL"
  },
  {
    "codigo":210529004,
    "descripcion":"DAÑO POLIHÍSTICO MASIVO DEL BRAZO"
  },
  {
    "codigo":46689006,
    "descripcion":"HIPERTROFIA DE AMÍGDALAS"
  },
  {
    "codigo":276065007,
    "descripcion":"REGRESO AL TRABAJO DESPUÉS DE JUBILARSE"
  },
  {
    "codigo":274230000,
    "descripcion":"HERIDA DE GUERRA"
  },
  {
    "codigo":765750001,
    "descripcion":"SÍNDROME ANGIO-OSTEOHIPOTRÓFICO"
  },
  {
    "codigo":1222667006,
    "descripcion":"DISPLASIA LINFÁTICA GENERALIZADA ASOCIADA AL GEN PIEZO1 CON HIDROPESÍA FETAL NO INMUNOLÓGICA"
  },
  {
    "codigo":403467008,
    "descripcion":"NEOPLASIA INTRAEPITELIAL DE PENE ASOCIADA CON LIQUEN ESCLEROSO"
  },
  {
    "codigo":43019009,
    "descripcion":"SÍNDROME DE NELSON"
  },
  {
    "codigo":205024005,
    "descripcion":"VEJIGA URINARIA EN RELOJ DE ARENA CONGÉNITA"
  },
  {
    "codigo":351841000119101,
    "descripcion":"FIBROXANTOMA ATÍPICO DE PIEL DEL CUELLO"
  },
  {
    "codigo":203189004,
    "descripcion":"OSTEOMIELITIS CRÓNICA DE PIERNA"
  },
  {
    "codigo":301493007,
    "descripcion":"SUBE EL CORDÓN DE LA VEREDA"
  },
  {
    "codigo":135818000,
    "descripcion":"ESTADO GENERAL DE SALUD, MALO"
  },
  {
    "codigo":235957008,
    "descripcion":"COLECCIÓN PANCREÁTICA"
  },
  {
    "codigo":234122004,
    "descripcion":"ARTERIA PRIMITIVA PERSISTENTE"
  },
  {
    "codigo":299658005,
    "descripcion":"HALLAZGO RELACIONADO CON EL TAMAÑO DE LA PELVIS"
  },
  {
    "codigo":168586008,
    "descripcion":"RADIOGRAFÍA SIMPLE DE CÓCCIX NORMAL"
  },
  {
    "codigo":365194008,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA SONARSE LA NARIZ"
  },
  {
    "codigo":166751004,
    "descripcion":"NIVEL SÉRICO DE COBRE FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":66612000,
    "descripcion":"ANEMIA NUTRICIONAL"
  },
  {
    "codigo":721972001,
    "descripcion":"SÍNDROME DE MIEMBROS Y MAMAS"
  },
  {
    "codigo":263220002,
    "descripcion":"FRACTURA DE ISQUION"
  },
  {
    "codigo":363359008,
    "descripcion":"NEOPLASIA MALIGNA DE OÍDO MEDIO"
  },
  {
    "codigo":164916001,
    "descripcion":"ELECTROCARDIOGRAMA: ONDA Q NORMAL"
  },
  {
    "codigo":197684008,
    "descripcion":"SÍNDROME NEFRÍTICO AGUDO, GLOMERULONEFRITIS PROLIFERATIVA MESANGIAL DIFUSA"
  },
  {
    "codigo":295988009,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE FENOBARBITAL"
  },
  {
    "codigo":230452009,
    "descripcion":"EPILEPSIA DEL CEPILLADO DENTAL"
  },
  {
    "codigo":294153004,
    "descripcion":"ALERGIA A FOLCODINA"
  },
  {
    "codigo":32009006,
    "descripcion":"ALUCINOSIS POR ALUCINÓGENOS"
  },
  {
    "codigo":425225007,
    "descripcion":"TUMOR MALIGNO MIXTO DE GLÁNDULA SALIVAL"
  },
  {
    "codigo":95710002,
    "descripcion":"PECA DEL IRIS"
  },
  {
    "codigo":1177054002,
    "descripcion":"HIDROCEFALIA DEBIDA A INFECCIÓN DEL SISTEMA NERVIOSO CENTRAL Y POSTERIOR A ELLA"
  },
  {
    "codigo":62942003,
    "descripcion":"INTOXICACIÓN POR TETRAETILPIROFOSFATO"
  },
  {
    "codigo":128478005,
    "descripcion":"TRASTORNO INFLAMATORIO DE LOS ÓRGANOS GENITALES MASCULINOS"
  },
  {
    "codigo":292318003,
    "descripcion":"REACCIÓN ADVERSA A LA GABAPENTINA"
  },
  {
    "codigo":30174008,
    "descripcion":"HIPOFOSFATASIA DE LA NIÑEZ"
  },
  {
    "codigo":1306291002,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE MAMA DERECHA"
  },
  {
    "codigo":716467004,
    "descripcion":"CAPAZ DE REALIZAR UNA SOLA TAREA"
  },
  {
    "codigo":11047881000119101,
    "descripcion":"SÍNDROME DE HIPEREMESIS POR CANNABIS CONCOMITANTE CON ABUSO DE CANNABIS Y DEBIDO A ÉL"
  },
  {
    "codigo":126643005,
    "descripcion":"NEOPLASIA DE LOS ÓRGANOS INTRABDOMINALES"
  },
  {
    "codigo":12077001000119100,
    "descripcion":"LUXACIÓN DE PRÓTESIS DE ARTICULACIÓN DE CADERA IZQUIERDA"
  },
  {
    "codigo":679881000119104,
    "descripcion":"REACCIÓN PUPILAR TÓNICA DE OJO IZQUIERDO"
  },
  {
    "codigo":352201000119105,
    "descripcion":"MELANOMA MALIGNO DE PIEL DE MIEMBRO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":15735241000119104,
    "descripcion":"TRASTORNO DE RETINA DE OJO IZQUIERDO"
  },
  {
    "codigo":295881000119105,
    "descripcion":"FÍSTULA PRODUCTIVA CONCOMITANTE CON OSTEOMIELITIS CRÓNICA DE PIERNA Y DEBIDA A ELLA"
  },
  {
    "codigo":121801000119105,
    "descripcion":"ANOMALÍA GASTROINTESTINAL FETAL"
  },
  {
    "codigo":324041000119107,
    "descripcion":"HEMARTROSIS DE ARTICULACIÓN DE PIE"
  },
  {
    "codigo":142281000119109,
    "descripcion":"DÉFICIT COGNITIVO EN LA FUNCIÓN VISUOESPACIAL"
  },
  {
    "codigo":12217801000119108,
    "descripcion":"FRACTURA DE HUESO ADYACENTE A PRÓTESIS DE ARTICULACIÓN DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":303561000119109,
    "descripcion":"DEPÓSITO DE CALCIO EN BOLSA SEROSA DE MUÑECA DERECHA"
  },
  {
    "codigo":313801000119107,
    "descripcion":"ATROFIA DE MÚSCULO DE MANO IZQUIERDA"
  },
  {
    "codigo":91081000119109,
    "descripcion":"CONDROSARCOMA PRIMARIO DE HUESO DE MIEMBRO INFERIOR"
  },
  {
    "codigo":687561000119107,
    "descripcion":"NEVO EPIDÉRMICO PILOSO PIGMENTADO DE CUERO CABELLUDO"
  },
  {
    "codigo":15725001000119108,
    "descripcion":"ENTESOPATÍA BILATERAL DE CODOS"
  },
  {
    "codigo":344521000119109,
    "descripcion":"DACRIOCISTITIS FLEMONOSA DE AMBOS OJOS"
  },
  {
    "codigo":690121000119109,
    "descripcion":"CARCINOMA BASOCELULAR PRIMARIO DE PIEL DE ESCROTO"
  },
  {
    "codigo":254045003,
    "descripcion":"ESPONDILODISPLASIA"
  },
  {
    "codigo":55602000,
    "descripcion":"SÍNDROME DE NEZELOF"
  },
  {
    "codigo":416050006,
    "descripcion":"SÍNDROME DE ENMASCARAMIENTO NEOPLÁSICO"
  },
  {
    "codigo":283143009,
    "descripcion":"ANZUELO EN LA REGIÓN DEL OJO"
  },
  {
    "codigo":1002204002,
    "descripcion":"NIVEL DE ÁCIDO 4-HIDROXIFENILACÉTICO EN ORINA AUMENTADO"
  },
  {
    "codigo":772828001,
    "descripcion":"GRIPE CAUSADA POR VIRUS INFLUENZA A SUBTIPO H5N1"
  },
  {
    "codigo":1231580006,
    "descripcion":"OBSTRUCCIÓN DE LUMEN DE VÍA RESPIRATORIA CAUSADA POR INHALACIÓN DE JUGUETE"
  },
  {
    "codigo":838364007,
    "descripcion":"ANEURISMA DE AORTA DEBIDA A SÍNDROME DE LOEYS-DIETZ"
  },
  {
    "codigo":1091631000119100,
    "descripcion":"OTITIS EXTERNA MALIGNA DE CONDUCTO AUDITIVO EXTERNO DERECHO"
  },
  {
    "codigo":17329003,
    "descripcion":"CÓLICO URETERAL"
  },
  {
    "codigo":11849621000119108,
    "descripcion":"ABRASIÓN DE PIEL DE PARED TORÁCICA DERECHA"
  },
  {
    "codigo":408710003,
    "descripcion":"APOSICIÓN INCOMPLETA DE STENT ARTERIAL LUEGO DE LA COLOCACIÓN"
  },
  {
    "codigo":703622004,
    "descripcion":"SÍNDROME MONOFOCAL CLÍNICAMENTE AISLADO"
  },
  {
    "codigo":769158005,
    "descripcion":"EXCESO DE PARTE ANTERIOR DE CRESTA ALVEOLAR INFERIOR"
  },
  {
    "codigo":212102005,
    "descripcion":"CORROSIÓN QUE COMPROMETE EL 70 AL 79 PORCIENTO DE LA SUPERFICIE CORPORAL"
  },
  {
    "codigo":243035000,
    "descripcion":"LESIÓN POR EXPLOSIÓN DE ARMA MARINA"
  },
  {
    "codigo":310406009,
    "descripcion":"DENSIDAD DE LA ORINA"
  },
  {
    "codigo":79195003,
    "descripcion":"CORRESPONDENCIA RETINIANA ANORMAL"
  },
  {
    "codigo":275803005,
    "descripcion":"ANOMALÍA NUCLEAR EN EL EXTENDIDO"
  },
  {
    "codigo":354351000119105,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE RIÑÓN IZQUIERDO"
  },
  {
    "codigo":699952001,
    "descripcion":"GANGRENA GASEOSA DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":110128001,
    "descripcion":"AVULSIÓN DEL PALADAR DURO"
  },
  {
    "codigo":77360001,
    "descripcion":"ABSCESO CRÓNICO DEL LIGAMENTO ANCHO"
  },
  {
    "codigo":765488003,
    "descripcion":"SÍNDROME DE CROMOSOMA 6 EN ANILLO"
  },
  {
    "codigo":9989000,
    "descripcion":"ANOMALÍA CONGÉNITA DE DEDO DEL PIE"
  },
  {
    "codigo":11824008,
    "descripcion":"AMPOLLA DE MAMA, SIN INFECCIÓN"
  },
  {
    "codigo":1255173002,
    "descripcion":"FRACTURA EXPUESTA DE FALANGE MEDIA DE MÚLTIPLES DEDOS DE MANO"
  },
  {
    "codigo":403205000,
    "descripcion":"QUERATOSIS ACTÍNICAS MÚLTIPLES CON COMPROMISO DE FRENTE Y SIENES"
  },
  {
    "codigo":16001071000119107,
    "descripcion":"DESPLAZAMIENTO DE AMBOS OJOS"
  },
  {
    "codigo":763653008,
    "descripcion":"PRÓTESIS DE ARTICULACIÓN DE TOBILLO PRESENTE"
  },
  {
    "codigo":682031000119109,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE URACO"
  },
  {
    "codigo":204762005,
    "descripcion":"TRANSPOSICIÓN DEL CIEGO"
  },
  {
    "codigo":71855000,
    "descripcion":"ANEMIA MEGALOBLÁSTICA AGUDA SECUNDARIA A ALIMENTACIÓN PARENTERAL TOTAL"
  },
  {
    "codigo":1351642008,
    "descripcion":"INMUNODEFICIENCIA VARIABLE COMÚN LIGADA AL CROMOSOMA X DEBIDA A DEFICIENCIA DEL GEN SH3KBP1"
  },
  {
    "codigo":268463003,
    "descripcion":"UTILIZA ANTICONCEPCIÓN POSTCOITAL"
  },
  {
    "codigo":82121000119104,
    "descripcion":"HERPES SIMPLE NO GENITAL"
  },
  {
    "codigo":301231005,
    "descripcion":"HALLAZGO RELACIONADO CON LOS CAMPOS PULMONARES"
  },
  {
    "codigo":364932001,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA ENDEREZARSE"
  },
  {
    "codigo":233860003,
    "descripcion":"RUPTURA DEL MÚSCULO PAPILAR MITRAL POSINFARTO"
  },
  {
    "codigo":299396004,
    "descripcion":"PRUEBA DEL CAJÓN ANTERIOR NEGATIVA"
  },
  {
    "codigo":70020005,
    "descripcion":"ADENOIDITIS"
  },
  {
    "codigo":397700007,
    "descripcion":"ATENCIÓN PERIOPERATORIA CONSISTENTE CON PLANIFICACIÓN"
  },
  {
    "codigo":428633000,
    "descripcion":"EXANTEMA CAUSADO POR HERPES ZÓSTER"
  },
  {
    "codigo":15728841000119107,
    "descripcion":"TRASTORNO DE ARTICULACIÓN DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":461401006,
    "descripcion":"ORIGEN ANÓMALO DE LIGAMENTO ARTERIOSO EN LOCALIZACIÓN DESCONOCIDA"
  },
  {
    "codigo":199257008,
    "descripcion":"TRASTORNOS MENTALES DURANTE EL EMBARAZO, EL PARTO Y EL PUERPERIO"
  },
  {
    "codigo":197422001,
    "descripcion":"RUPTURA DE CONDUCTO CÍSTICO"
  },
  {
    "codigo":66350002,
    "descripcion":"NECROBIOSIS LIPOIDEA, TIPO GRANULOMATOSA"
  },
  {
    "codigo":262958003,
    "descripcion":"SECCIÓN PARCIAL DE NERVIO CRANEAL"
  },
  {
    "codigo":721710005,
    "descripcion":"FIBROSIS DE HÍGADO CAUSADA POR ALCOHOL"
  },
  {
    "codigo":230190006,
    "descripcion":"ENCEFALITIS DEL TRONCO ENCEFÁLICO"
  },
  {
    "codigo":426798008,
    "descripcion":"DISPOSICIÓN PARA MEJORAR LOS PROCESOS FAMILIARES"
  },
  {
    "codigo":228355004,
    "descripcion":"ACUSADO DE AGRESIÓN POR CONDUCIR ALCOHOLIZADO"
  },
  {
    "codigo":31747005,
    "descripcion":"ESTADIO B1 DE DUKES MODIFICADO"
  },
  {
    "codigo":293891006,
    "descripcion":"ALERGIA A TRIAZOLAM"
  },
  {
    "codigo":95448006,
    "descripcion":"TROMBOSIS DE LA VENA PÉLVICA"
  },
  {
    "codigo":292056009,
    "descripcion":"REACCIÓN ADVERSA A LA DIAMORFINA"
  },
  {
    "codigo":421293001,
    "descripcion":"PÉRDIDA DE LA VISIÓN SIN CAUSA APARENTE"
  },
  {
    "codigo":60845006,
    "descripcion":"DISNEA DE ESFUERZO"
  },
  {
    "codigo":93613008,
    "descripcion":"DISTANCIA ANOGENITAL AUMENTADA"
  },
  {
    "codigo":880045008,
    "descripcion":"ESTENOSIS ADQUIRIDA DE ESTRUCTURA VENTRICULAR DERECHA DE LA VÁLVULA AURICULOVENTRICULAR COMÚN POSTERIOR A REPARACIÓN DE COMUNICACIÓN BIVENTRICULAR"
  },
  {
    "codigo":288386002,
    "descripcion":"DIFICULTAD PARA UTILIZAR UNA LLAVE"
  },
  {
    "codigo":10760701000119102,
    "descripcion":"CUATRILLIZOS, TODOS NACIDOS VIVOS"
  },
  {
    "codigo":714370004,
    "descripcion":"CAPAZ DE ADAPTARSE DESPUÉS DE UNA CRISIS PERSONAL"
  },
  {
    "codigo":188247000,
    "descripcion":"NEOPLASIA MALIGNA DE LOCALIZACIONES SUPERPUESTAS DE VEJIGA URINARIA"
  },
  {
    "codigo":253783001,
    "descripcion":"DISPLASIA NEURONAL INTESTINAL"
  },
  {
    "codigo":24407009,
    "descripcion":"PANCREATITIS SUPURATIVA"
  },
  {
    "codigo":84438001,
    "descripcion":"INSUFICIENCIA AUTONÓMICA PURA"
  },
  {
    "codigo":1264086002,
    "descripcion":"DESCAMACIÓN ANORMAL DE EPITELIO"
  },
  {
    "codigo":248278004,
    "descripcion":"ATAQUES DE DEBILIDAD"
  },
  {
    "codigo":16059031000119103,
    "descripcion":"DEFECTO BILATERAL DEL CAMPO VISUAL"
  },
  {
    "codigo":15232001,
    "descripcion":"TRAMA VASCULAR PULMONAR AUMENTADA"
  },
  {
    "codigo":48000002,
    "descripcion":"VÓMITO EN EL RECIÉN NACIDO"
  },
  {
    "codigo":17067009,
    "descripcion":"ÚLCERA GÁSTRICA AGUDA CON HEMORRAGIA Y PERFORACIÓN PERO SIN OBSTRUCCIÓN"
  },
  {
    "codigo":703360004,
    "descripcion":"INFARTO DE MIOCARDIO SIN ELEVACIÓN ULTERIOR DE SEGMENTO ST"
  },
  {
    "codigo":46165000,
    "descripcion":"ENDOCARDITIS REUMÁTICA CRÓNICA"
  },
  {
    "codigo":406613000,
    "descripcion":"ENFERMEDAD INVASIVA POR ESTREPTOCOCOS BETAHEMOLÍTICOS NO PERTENECIENTES A LOS GRUPOS A NI B"
  },
  {
    "codigo":109866004,
    "descripcion":"PELVIS FEMENINA RÍGIDA"
  },
  {
    "codigo":372010005,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE PARTES BLANDAS"
  },
  {
    "codigo":77098009,
    "descripcion":"SEUDOHIPOALDOSTERONISMO"
  },
  {
    "codigo":402943002,
    "descripcion":"BALANITIS SIFILÍTICA"
  },
  {
    "codigo":1254911003,
    "descripcion":"MOSAICISMO PIGMENTARIO HIPERMELANÓTICO"
  },
  {
    "codigo":239103006,
    "descripcion":"PRURIGO DEL EMBARAZO"
  },
  {
    "codigo":237268002,
    "descripcion":"CORIOANGIOMA"
  },
  {
    "codigo":366505000,
    "descripcion":"HALLAZGO RELACIONADO CON ARTICULACIÓN DE CODO - AMPLITUD DE MOVIMIENTO"
  },
  {
    "codigo":1187540008,
    "descripcion":"AMILOIDOSIS CARDÍACA SECUNDARIA SISTÉMICA"
  },
  {
    "codigo":268201001,
    "descripcion":"ATRESIA, ESTENOSIS Y FÍSTULA ESOFÁGICA"
  },
  {
    "codigo":169897007,
    "descripcion":"PUNTAJE DE APGAR AL MINUTO = 1"
  },
  {
    "codigo":38825009,
    "descripcion":"DEFICIENCIA EN LA BIOSÍNTESIS DE TESTOSTERONA"
  },
  {
    "codigo":36990001,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE LA PARED TORÁCICA, SIN INFECCIÓN"
  },
  {
    "codigo":266366003,
    "descripcion":"ENFERMEDAD PULMONAR POR AGENTES EXTERNOS"
  },
  {
    "codigo":430206002,
    "descripcion":"LACERACIÓN DE TENDÓN EXTENSOR DE PIE"
  },
  {
    "codigo":69758005,
    "descripcion":"HIDROURÉTER"
  },
  {
    "codigo":102526007,
    "descripcion":"EDAD MAYOR DE 50 AÑOS, SEXO FEMENINO"
  },
  {
    "codigo":299134007,
    "descripcion":"TUMEFACCIÓN DE PARTES BLANDAS DE ARTICULACIÓN DE PULGAR"
  },
  {
    "codigo":233598009,
    "descripcion":"BRONQUITIS BACTERIANA AGUDA"
  },
  {
    "codigo":249267003,
    "descripcion":"HALLAZGO RELACIONADO CON EL ESMEGMA"
  },
  {
    "codigo":721448001,
    "descripcion":"SÍNDROME DEL CORDÓN CENTRAL DE MÉDULA ESPINAL AL NIVEL DEL SEXTO SEGMENTO DORSAL"
  },
  {
    "codigo":295464001,
    "descripcion":"SOBREDOSIS DE SEN"
  },
  {
    "codigo":262696004,
    "descripcion":"CONTUSIÓN DE MÉDULA ESPINAL"
  },
  {
    "codigo":426536006,
    "descripcion":"MONOPLEJÍA DEL MIEMBRO SUPERIOR QUE AFECTA AL LADO NO DOMINANTE"
  },
  {
    "codigo":33320006,
    "descripcion":"ORINA TRANSPARENTE"
  },
  {
    "codigo":5221000119100,
    "descripcion":"DISFUNCIÓN DE ESTÓMAGO DESPUÉS DE GASTROSTOMÍA"
  },
  {
    "codigo":293629003,
    "descripcion":"ALERGIA A PIROXICAM"
  },
  {
    "codigo":195325004,
    "descripcion":"EMBOLIA Y TROMBOSIS DE ARTERIA TIBIAL ANTERIOR"
  },
  {
    "codigo":129789007,
    "descripcion":"TEJIDO MAMARIO FOCAL ASIMÉTRICO"
  },
  {
    "codigo":816082000,
    "descripcion":"HIPOVOLEMIA"
  },
  {
    "codigo":332901000119103,
    "descripcion":"ATROFIA PRIMARIA DE GLÁNDULA LAGRIMAL DE OJO DERECHO"
  },
  {
    "codigo":95186006,
    "descripcion":"LINFOMA NODULAR DE LOS GANGLIOS LINFÁTICOS INTRABDOMINALES"
  },
  {
    "codigo":93351001,
    "descripcion":"POSICIÓN ANÓMALA CONGÉNITA DEL BAZO"
  },
  {
    "codigo":224423007,
    "descripcion":"INSTALACIONES DE DUCHAS ADECUADAS EN EL TRABAJO"
  },
  {
    "codigo":124284001,
    "descripcion":"DEFICIENCIA DE ASPARTATO AMINOTRANSFERASA"
  },
  {
    "codigo":58748004,
    "descripcion":"DIENTE NEONATAL"
  },
  {
    "codigo":25980005,
    "descripcion":"INTOXICACIÓN POR SECOBARBITAL"
  },
  {
    "codigo":417361000,
    "descripcion":"CON MAYOR RIESGO DE ABUSO SEXUAL"
  },
  {
    "codigo":253521004,
    "descripcion":"HIPOPLASIA DEL TRACTO DE SALIDA Y ÁREA TRABECULAR DEL VENTRÍCULO DERECHO"
  },
  {
    "codigo":122449004,
    "descripcion":"NEUMORRETROPERITONEO"
  },
  {
    "codigo":56913005,
    "descripcion":"INFECCIÓN CAUSADA POR COLLYRICULUM FABA"
  },
  {
    "codigo":87141000119108,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE MÉDULA ESPINAL INTRAMEDULAR"
  },
  {
    "codigo":186150001,
    "descripcion":"ENTERITIS CAUSADA POR ROTAVIRUS"
  },
  {
    "codigo":87846002,
    "descripcion":"ADHESIVIDAD DEL ESTRATO CÓRNEO DISMINUIDA"
  },
  {
    "codigo":22310002,
    "descripcion":"MONOCITOSIS IDIOPÁTICA CRÓNICA"
  },
  {
    "codigo":315387000,
    "descripcion":"NACIDO EN BOSNIA - HERZEGOVINA"
  },
  {
    "codigo":774139002,
    "descripcion":"INESTABILIDAD DE ARTICULACIÓN DE LA CADERA IZQUIERDA"
  },
  {
    "codigo":249851003,
    "descripcion":"POSICIÓN ESPÁSTICA"
  },
  {
    "codigo":1003515004,
    "descripcion":"AGENESIA DE TIBIA"
  },
  {
    "codigo":53243005,
    "descripcion":"LESIONES HIPERCRÓMICAS PROVOCADAS POR PINTA"
  },
  {
    "codigo":248016003,
    "descripcion":"VANDALISMO"
  },
  {
    "codigo":870608005,
    "descripcion":"ALERGIA A TIOMERSAL"
  },
  {
    "codigo":34201000119101,
    "descripcion":"OBSTRUCCIÓN DISTAL BILATERAL DE TROMPAS DE FALOPIO"
  },
  {
    "codigo":16805009,
    "descripcion":"TRASTORNO DE LA PERSONALIDAD DEL GRUPO A"
  },
  {
    "codigo":211578002,
    "descripcion":"LESIÓN TRAUMÁTICA ABIERTA POR APLASTAMIENTO DE LA MANO, DORSO"
  },
  {
    "codigo":16909721000119103,
    "descripcion":"TRASTORNO DE METABOLISMO DE GABA (GAMMA AMINOBUTYRIC ACID)"
  },
  {
    "codigo":277114007,
    "descripcion":"POTENCIALES EVOCADOS VISUALES SIMÉTRICOS"
  },
  {
    "codigo":373583002,
    "descripcion":"MEGAURÉTER OBSTRUCTIVO CONGÉNITO"
  },
  {
    "codigo":209743005,
    "descripcion":"SECCIÓN EXPUESTA DE LIGAMENTO COSTAL"
  },
  {
    "codigo":734031008,
    "descripcion":"AUSENCIA CONGÉNITA DE QUIASMA ÓPTICO"
  },
  {
    "codigo":109604001,
    "descripcion":"ABSCESO PERIAPICAL CON COMPROMISO FACIAL"
  },
  {
    "codigo":207908005,
    "descripcion":"FRACTURA NO EXPUESTA DE VÉRTEBRA CERVICAL, ARCO POSTERIOR"
  },
  {
    "codigo":335411000119100,
    "descripcion":"QUERATITIS INTERSTICIAL DIFUSA DE OJO DERECHO"
  },
  {
    "codigo":240676007,
    "descripcion":"FRAMBESIA MACULAR"
  },
  {
    "codigo":763129001,
    "descripcion":"QUISTE DERMOIDE DEL CUELLO"
  },
  {
    "codigo":271609003,
    "descripcion":"PRÓTESIS OCULAR IN SITU"
  },
  {
    "codigo":402681005,
    "descripcion":"TRASTORNO POR ANORMALIDAD DE LA ELASTINA DÉRMICA"
  },
  {
    "codigo":238841008,
    "descripcion":"CICATRIZ ATRÓFICA DE LA MEJILLA"
  },
  {
    "codigo":7731000119103,
    "descripcion":"HEMIANOPIA ALTITUDINAL HOMÓNIMA BILATERAL"
  },
  {
    "codigo":1187278006,
    "descripcion":"SÍNDROME DE PARAPLEJÍA ESPÁSTICA, RETRASO SEVERO DEL DESARROLLO Y EPILEPSIA"
  },
  {
    "codigo":366243001,
    "descripcion":"REFLEJO TÓNICO CERVICAL - HALLAZGO"
  },
  {
    "codigo":202403002,
    "descripcion":"HEMARTROSIS DE ARTICULACIÓN ESTERNOCLAVICULAR"
  },
  {
    "codigo":300707007,
    "descripcion":"CAPAZ DE USAR UNA TARJETA DE CRÉDITO"
  },
  {
    "codigo":397176006,
    "descripcion":"ASTILLA EN LA PIEL, CON INFECCIÓN"
  },
  {
    "codigo":298872009,
    "descripcion":"TUMEFACCIÓN DE PARTES BLANDAS DE ARTICULACIÓN DE CODO"
  },
  {
    "codigo":723021001,
    "descripcion":"ATROFIA DE PARTES BLANDAS DE ÓRBITA"
  },
  {
    "codigo":724856009,
    "descripcion":"OCLUSIÓN DE MICROVASCULATURA CUTÁNEA CAUSADA POR TAPÓN PLAQUETARIO"
  },
  {
    "codigo":231501003,
    "descripcion":"FOBIA A LAS AGUJAS"
  },
  {
    "codigo":11804211000119107,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA DISTAL DE DEDO MEÑIQUE DERECHO"
  },
  {
    "codigo":10821171000119107,
    "descripcion":"FRACTURA EXPUESTA DE DIÁFISIS DE QUINTO HUESO METACARPIANO DE MANO DERECHA"
  },
  {
    "codigo":145101000119102,
    "descripcion":"PATRÓN DE USO NOCIVO DE COCAÍNA INTRAVENOSA"
  },
  {
    "codigo":721186001,
    "descripcion":"ANEMIA MEGALOBLÁSTICA DEBIDA A DEFICIENCIA DE FOLATO EN EL PREMATURO"
  },
  {
    "codigo":297037008,
    "descripcion":"SOBREDOSIS DE DIURÉTICO MERCURIAL"
  },
  {
    "codigo":295202002,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE FENOPERIDINA"
  },
  {
    "codigo":33058001,
    "descripcion":"PLACENTA ACRETA SIN HEMORRAGIA"
  },
  {
    "codigo":290006,
    "descripcion":"SÍNDROME DE MELNICK - FRASER"
  },
  {
    "codigo":229666009,
    "descripcion":"DISFASIA EFERENTE MOTORA"
  },
  {
    "codigo":210867008,
    "descripcion":"CONTUSIÓN, ARTERIA FEMORAL SUPERFICIAL"
  },
  {
    "codigo":293367005,
    "descripcion":"REACCIÓN ADVERSA A LA NUTRICIÓN PARENTERAL"
  },
  {
    "codigo":1259443009,
    "descripcion":"CARCINOMA PRIMARIO DE MAMA CON RASGOS DUCTALES Y LOBULILLARES"
  },
  {
    "codigo":224161001,
    "descripcion":"PARTIDA DE LOS HIJOS DEL HOGAR, EVENTO DEL CICLO VITAL"
  },
  {
    "codigo":308941000119107,
    "descripcion":"TENDINITIS CALCIFICANTE DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":93089004,
    "descripcion":"FENESTRACIÓN CONGÉNITA DE HUESO SUPRAOCCIPITAL"
  },
  {
    "codigo":289697004,
    "descripcion":"CICATRIZ DEL SEGMENTO UTERINO INFERIOR DOLOROSA A LA PALPACIÓN"
  },
  {
    "codigo":16011111000119102,
    "descripcion":"OSTEONECROSIS DE ASTRÁGALO IZQUIERDO"
  },
  {
    "codigo":15955661000119109,
    "descripcion":"NEOPLASIA BENIGNA DE AMBOS EPIDÍDIMOS"
  },
  {
    "codigo":124022007,
    "descripcion":"NIVEL DE ALFAGLOBULINA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":11833191000119104,
    "descripcion":"ESGUINCE DE LIGAMENTO DE ARTICULACIÓN METATARSOFALÁNGICA DE SEGUNDO A QUINTO DEDOS DE PIE DERECHO"
  },
  {
    "codigo":449867007,
    "descripcion":"UTILIZA TABACO HÚMEDO OCASIONALMENTE"
  },
  {
    "codigo":1269067008,
    "descripcion":"TRASTORNO FETAL DEBIDO A TRASTORNO DE TRABAJO DE PARTO MATERNO"
  },
  {
    "codigo":89419008,
    "descripcion":"PÉRDIDA DEL EQUILIBRIO"
  },
  {
    "codigo":286027009,
    "descripcion":"CAPAZ DE SACAR UN ENCHUFE ELÉCTRICO DE UN TOMACORRIENTE"
  },
  {
    "codigo":54816003,
    "descripcion":"HEMATOMA ATRAUMÁTICO DE PENE"
  },
  {
    "codigo":11997031000119105,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DE OÍDO DERECHO"
  },
  {
    "codigo":187723009,
    "descripcion":"NEOPLASIA MALIGNA DEL ESÓFAGO TORÁCICO"
  },
  {
    "codigo":253259008,
    "descripcion":"SENO DE FÍSTULA BRANQUIAL"
  },
  {
    "codigo":284192008,
    "descripcion":"QUEMADURA DE ESTRUCTURA UROGENITAL"
  },
  {
    "codigo":446197001,
    "descripcion":"HERIDA PENETRANTE DE PERINEO"
  },
  {
    "codigo":216821002,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR GAS DE PETRÓLEO LÍQUIDO DISTRIBUIDO POR TUBERÍA"
  },
  {
    "codigo":249589003,
    "descripcion":"MURMULLO VENOSO ABDOMINAL"
  },
  {
    "codigo":413429004,
    "descripcion":"DESVIACIÓN RADIAL ADQUIRIDA DE MANO"
  },
  {
    "codigo":20213006,
    "descripcion":"LESIÓN TRAUMÁTICA DE BAZO SIN HERIDA ABIERTA HACIA CAVIDAD ABDOMINAL"
  },
  {
    "codigo":282357008,
    "descripcion":"AMILOIDE DE URÉTER"
  },
  {
    "codigo":1263562002,
    "descripcion":"NECROSIS TARDÍA DE NEURONA DEBIDA A RADIOTERAPIA Y POSTERIOR A ELLA"
  },
  {
    "codigo":18378006,
    "descripcion":"EVENTRACIÓN CON GANGRENA"
  },
  {
    "codigo":870346008,
    "descripcion":"RETINOPATÍA DEBIDA A ATEROSCLEROSIS"
  },
  {
    "codigo":213151004,
    "descripcion":"FALLA Y RECHAZO DEL TRASPLANTE CARDÍACO"
  },
  {
    "codigo":278687005,
    "descripcion":"OCLUSIÓN FUNCIONAL GUIADA ANTERIOR"
  },
  {
    "codigo":1360031007,
    "descripcion":"GINGIVITIS LOCALIZADA CON TEJIDO PERIODONTAL DISMINUIDO SIN PERIODONTITIS"
  },
  {
    "codigo":735604001,
    "descripcion":"PROLAPSO DE DISCO INTERVERTEBRAL CERVICAL CONCOMITANTE CON DEGENERACIÓN Y DEBIDO A ELLA"
  },
  {
    "codigo":473460002,
    "descripcion":"CONJUNTIVITIS ALÉRGICA"
  },
  {
    "codigo":276852004,
    "descripcion":"TUMOR PAPILAR DE LA AMPOLLA DE VATER"
  },
  {
    "codigo":1290825000,
    "descripcion":"SARCOMA EPITELIOIDE CLÁSICO"
  },
  {
    "codigo":209481001,
    "descripcion":"ESGUINCE DE DEDO DE LA MANO, ARTICULACIÓN METACARPOFALÁNGICA, LIGAMENTO LATERAL CUBITAL"
  },
  {
    "codigo":111177004,
    "descripcion":"DIETA PARA LACTANTES DE 6 A 8 MESES: VERDURAS, FRUTAS Y JUGO DE FRUTAS"
  },
  {
    "codigo":11315201000119108,
    "descripcion":"FRACTURA PATOLÓGICA DE MANDÍBULA"
  },
  {
    "codigo":371486001,
    "descripcion":"NEOPLASIA DE OJO PROPIAMENTE DICHO"
  },
  {
    "codigo":109342003,
    "descripcion":"SECUESTRO DE HUESO CIGOMÁTICO"
  },
  {
    "codigo":240414006,
    "descripcion":"LINFADENITIS MICOBACTERIANA ATÍPICA DISEMINADA"
  },
  {
    "codigo":444851003,
    "descripcion":"VÉRTICE CARDÍACO BÍFIDO"
  },
  {
    "codigo":402419007,
    "descripcion":"ERITEMA ROSEOLAR"
  },
  {
    "codigo":369651006,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA DE TROMPA DE FALOPIO, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":236744002,
    "descripcion":"BALANITIS CIRCINATA CONCOMITANTE DON TRÍADA DE ARTRITIS REACTIVA"
  },
  {
    "codigo":40136003,
    "descripcion":"ANEURISMA DE ARTERIA SUBCLAVIA"
  },
  {
    "codigo":7368005,
    "descripcion":"DOBLE SALIDA DEL VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":105672006,
    "descripcion":"ENFERMEDAD CAUSADA POR OPISTHORCHIIDAE"
  },
  {
    "codigo":202141001,
    "descripcion":"LESIÓN DE HILL-SACHS"
  },
  {
    "codigo":300445007,
    "descripcion":"HALLAZGO RELACIONADO CON LA SENSIBILIDAD DEL RIÑÓN"
  },
  {
    "codigo":365981007,
    "descripcion":"HALLAZGO RELACIONADO CON LA CONDUCTA DE TABAQUISMO"
  },
  {
    "codigo":38301007,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN DE PULGAR"
  },
  {
    "codigo":267677007,
    "descripcion":"OTOTOXICIDAD - SORDERA"
  },
  {
    "codigo":284981000119102,
    "descripcion":"ENFERMEDAD RENAL CRÓNICA DEBIDA A HIPERTENSIÓN BENIGNA, ESTADIO 2"
  },
  {
    "codigo":69234007,
    "descripcion":"FÍSTULA DE ARTICULACIÓN"
  },
  {
    "codigo":298610007,
    "descripcion":"SIN FLEXIÓN PASIVA DE LA COLUMNA LUMBAR"
  },
  {
    "codigo":788295002,
    "descripcion":"LINFANGIECTASIA CONGÉNITA CON REFLUJO QUILOSO"
  },
  {
    "codigo":722759007,
    "descripcion":"GLOMERULOPATÍA CON DEPÓSITOS DE FIBRONECTINA 2"
  },
  {
    "codigo":294940003,
    "descripcion":"ALERGIA A ÁCIDO ASCÓRBICO"
  },
  {
    "codigo":786460007,
    "descripcion":"HIPERACTIVIDAD DE DETRUSOR"
  },
  {
    "codigo":131100008,
    "descripcion":"GONADOTROFINA CORIÓNICA HUMANA ANORMAL"
  },
  {
    "codigo":1145073006,
    "descripcion":"INTOXICACIÓN CAUSADA POR CLORFENESINA"
  },
  {
    "codigo":192966000,
    "descripcion":"PARAPLEJÍA FLÁCCIDA"
  },
  {
    "codigo":293105009,
    "descripcion":"REACCIÓN ADVERSA A VACUNA CONTRA EL CARBUNCO"
  },
  {
    "codigo":291270001,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR ATENOLOL"
  },
  {
    "codigo":94662003,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL CUELLO DE LA VEJIGA"
  },
  {
    "codigo":15987151000119103,
    "descripcion":"MICROFTALMÍA DE AMBOS OJOS"
  },
  {
    "codigo":717254007,
    "descripcion":"PSEUDOHIPERPOTASEMIA FAMILIAR"
  },
  {
    "codigo":125595000,
    "descripcion":"LESIÓN TRAUMÁTICA DE BRAZO"
  },
  {
    "codigo":1010331001,
    "descripcion":"FLEXIÓN DE LADO DERECHO DE COLUMNA VERTEBRAL SACRA"
  },
  {
    "codigo":715419004,
    "descripcion":"SÍNDROME LETAL DE CONTRACTURAS CONGÉNITAS TIPO 2"
  },
  {
    "codigo":289435004,
    "descripcion":"HALLAZGO RELACIONADO CON MEDIDAS DEL MOVIMIENTO FETAL"
  },
  {
    "codigo":123760002,
    "descripcion":"INSUFICIENCIA ADENOHIPOFISARIA PREPUBERAL"
  },
  {
    "codigo":1336176005,
    "descripcion":"FIBROSARCOMA METASTÁSICO"
  },
  {
    "codigo":11864681000119100,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DE PIERNA IZQUIERDA"
  },
  {
    "codigo":1303408008,
    "descripcion":"TRASTORNO PERCEPTIVO PERSISTENTE POR ALUCINÓGENO"
  },
  {
    "codigo":285765003,
    "descripcion":"NISTAGMO MANIFIESTO-LATENTE"
  },
  {
    "codigo":449605004,
    "descripcion":"DEFICIENCIA DE CÚSPIDE DE VÁLVULA PULMONAR"
  },
  {
    "codigo":252997008,
    "descripcion":"TRICOFOLICULOMA SEBÁCEO"
  },
  {
    "codigo":218394002,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR HEXILRESORCINOL"
  },
  {
    "codigo":87322003,
    "descripcion":"FIBROSIS DEL ÚTERO"
  },
  {
    "codigo":251162005,
    "descripcion":"BRADICARDIA DE LA UNIÓN AV (NODAL)"
  },
  {
    "codigo":283930008,
    "descripcion":"LACERACIÓN DE LA PRÓSTATA"
  },
  {
    "codigo":183791001,
    "descripcion":"INSCRIPTO EN LISTA DE ADMISIÓN DE CIRUGÍA PLÁSTICA"
  },
  {
    "codigo":249327002,
    "descripcion":"PUNTA DE LA NARIZ ANCHA"
  },
  {
    "codigo":54554009,
    "descripcion":"PÁNCREAS DIVIDIDO"
  },
  {
    "codigo":314863004,
    "descripcion":"OBSTRUCCIÓN SECUNDARIA ADQUIRIDA DE CONDUCTO NASOLAGRIMAL"
  },
  {
    "codigo":282095007,
    "descripcion":"REACCIÓN ALÉRGICA CAUSADA POR PICADURA DE ABEJA"
  },
  {
    "codigo":85487008,
    "descripcion":"FOSFATURIA RENAL"
  },
  {
    "codigo":708079007,
    "descripcion":"SOBREDOSIS DE DROGA ILÍCITA"
  },
  {
    "codigo":83652003,
    "descripcion":"TUBERCULOSIS DE EPIDÍDIMO"
  },
  {
    "codigo":247492006,
    "descripcion":"DESPRENDIMIENTO UNGUEAL"
  },
  {
    "codigo":444100007,
    "descripcion":"ENFERMEDAD EXANTEMÁTICA DEL SUDESTE ASOCIADA A GARRAPATAS"
  },
  {
    "codigo":49049000,
    "descripcion":"ENFERMEDAD DE PARKINSON"
  },
  {
    "codigo":18116006,
    "descripcion":"NOMA"
  },
  {
    "codigo":81817003,
    "descripcion":"ATEROSCLEROSIS DE AORTA"
  },
  {
    "codigo":211054000,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE REGIÓN INTERESCAPULAR DE ESPALDA"
  },
  {
    "codigo":409497009,
    "descripcion":"MEDIASTINITIS HEMORRÁGICA"
  },
  {
    "codigo":276590002,
    "descripcion":"SÍNDROME AGUDO DE LACERACIÓN TENTORIAL"
  },
  {
    "codigo":735342003,
    "descripcion":"MÚLTIPLES LESIONES TRAUMÁTICAS DE CABEZA Y TÓRAX"
  },
  {
    "codigo":1259630004,
    "descripcion":"SÍNDROME CLÍNICAMENTE AISLADO DE TRONCO ENCEFÁLICO"
  },
  {
    "codigo":243822005,
    "descripcion":"ESTADO DEL ANTICONCEPTIVO DE DEPÓSITO"
  },
  {
    "codigo":737177009,
    "descripcion":"PROLAPSO COMPLETO DE ÚTERO CONCOMITANTE CON PROLAPSO DE PARED ANTERIOR DE LA VAGINA"
  },
  {
    "codigo":79982007,
    "descripcion":"INTOXICACIÓN POR PROGESTÁGENO"
  },
  {
    "codigo":373059002,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM SHIMOIDEI"
  },
  {
    "codigo":274755005,
    "descripcion":"TUMEFACCIÓN DE CABEZA Y CUELLO"
  },
  {
    "codigo":241987007,
    "descripcion":"BAROTRAUMA POR ASCENSO"
  },
  {
    "codigo":1255960000,
    "descripcion":"ANSIEDAD POR CONSULTA ODONTOLÓGICA"
  },
  {
    "codigo":829976001,
    "descripcion":"ASMA POR TORMENTA ELÉCTRICA"
  },
  {
    "codigo":403992002,
    "descripcion":"FIBROMA DE VAINA TENDINOSA"
  },
  {
    "codigo":240152003,
    "descripcion":"OSTEOMIELITIS CRÓNICA CON TRAYECTO FISTULOSO CON DRENAJE"
  },
  {
    "codigo":698904004,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: KALAALLISUT"
  },
  {
    "codigo":764440006,
    "descripcion":"SÍNDROME DE MICRODELECIÓN 19P13.13"
  },
  {
    "codigo":762605000,
    "descripcion":"DOLOR BUCAL SECUNDARIO CRÓNICO"
  },
  {
    "codigo":305688009,
    "descripcion":"ATENDIDO POR UN REUMATÓLOGO"
  },
  {
    "codigo":402157004,
    "descripcion":"DERMATOSIS CAUSADA POR ÁCARO DE LAS COSECHAS"
  },
  {
    "codigo":236482006,
    "descripcion":"INSUFICIENCIA TUBULORRENAL HEREDADA CON ICTERICIA COLESTÁSICA"
  },
  {
    "codigo":302018006,
    "descripcion":"CAMBIO EN LOS RASGOS FACIALES"
  },
  {
    "codigo":203714006,
    "descripcion":"ESTENOSIS ÓSEA Y POR SUBLUXACIÓN DE LOS AGUJEROS INTERVERTEBRALES"
  },
  {
    "codigo":300183001,
    "descripcion":"HUESECILLOS DEL OÍDO ANORMALES"
  },
  {
    "codigo":365719006,
    "descripcion":"ALMIDÓN EN MATERIA FECAL - HALLAZGO"
  },
  {
    "codigo":38039008,
    "descripcion":"EDAD GESTACIONAL, 10 SEMANAS"
  },
  {
    "codigo":167276005,
    "descripcion":"PRUEBA DE PROTEÍNAS EN ORINA = ++"
  },
  {
    "codigo":429420005,
    "descripcion":"ARTROPATÍA DE RODILLA POR CRISTALES"
  },
  {
    "codigo":294678004,
    "descripcion":"ALERGIA A BETAMETASONA"
  },
  {
    "codigo":818966007,
    "descripcion":"NECROSIS AVASCULAR DE HUESO METATARSIANO"
  },
  {
    "codigo":292843001,
    "descripcion":"REACCIÓN ADVERSA A LA VIDARABINA"
  },
  {
    "codigo":63467002,
    "descripcion":"BLOQUEO DE LA RAMA IZQUIERDA DEL HAZ DE HIS"
  },
  {
    "codigo":5581000175102,
    "descripcion":"MEZCLA MEDICAMENTO CON ALCOHOL"
  },
  {
    "codigo":28864000,
    "descripcion":"TRASTORNO DEL ESTADO DE ÁNIMO INDUCIDO POR SEDANTES, HIPNÓTICOS Y\/O ANSIOLÍTICOS"
  },
  {
    "codigo":1208512000,
    "descripcion":"ATAXIA ESPINOCEREBELOSA TIPO 41"
  },
  {
    "codigo":127168001,
    "descripcion":"LINFADENOPATÍA ILÍACA EXTERNA INTERMEDIA"
  },
  {
    "codigo":94400003,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE GLÁNDULA SALIVAL MAYOR"
  },
  {
    "codigo":13201000132100,
    "descripcion":"ECCEMA DE CUERO CABELLUDO"
  },
  {
    "codigo":225472006,
    "descripcion":"SIENTE QUE LA VIDA NO TIENE SENTIDO"
  },
  {
    "codigo":192704009,
    "descripcion":"ENCEFALITIS POSINMUNIZACIÓN"
  },
  {
    "codigo":190869004,
    "descripcion":"TETANIA HIPOCALCÉMICA"
  },
  {
    "codigo":27029007,
    "descripcion":"FÓRMULA DE HIPERALIMENTACIÓN"
  },
  {
    "codigo":92565007,
    "descripcion":"CARCINOMA IN SITU DE LA COROIDES"
  },
  {
    "codigo":1237610002,
    "descripcion":"VENA VARICOSA DE TALÓN"
  },
  {
    "codigo":25194005,
    "descripcion":"SECUENCIA ANORMAL DE BASE DE UN NUCLEÓTIDO"
  },
  {
    "codigo":1335914008,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS DE CABEZA Y\/O CUELLO"
  },
  {
    "codigo":254570009,
    "descripcion":"CARCINOMA DEL DUODENO"
  },
  {
    "codigo":1268543003,
    "descripcion":"SARCOMA DE CÉLULAS CLARAS PRIMARIO DE RIÑÓN"
  },
  {
    "codigo":88895004,
    "descripcion":"FATIGA DURANTE EMBARAZO"
  },
  {
    "codigo":23359005,
    "descripcion":"SÍNDROME DE MALFORMACIÓN MÚLTIPLE CON ANOMALÍAS FACIAL Y DE MIEMBROS COMO CARACTERÍSTICA PRINCIPAL"
  },
  {
    "codigo":285503005,
    "descripcion":"PROTRUYE LA LENGUA"
  },
  {
    "codigo":21524000,
    "descripcion":"RELAJACIÓN DEL DIAFRAGMA"
  },
  {
    "codigo":187199009,
    "descripcion":"TOXOPLASMOSIS DE MÚLTIPLES LOCALIZACIONES"
  },
  {
    "codigo":283668007,
    "descripcion":"HERIDA POR PINCHAZO DE CLAVO EN EL GLÚTEO"
  },
  {
    "codigo":85225000,
    "descripcion":"MUCOCELE DE SENO PARANASAL"
  },
  {
    "codigo":52457000,
    "descripcion":"ILEÍTIS"
  },
  {
    "codigo":314601002,
    "descripcion":"RECIDIVA DE TUMOR ANASTOMÓTICO GASTROINTESTINAL"
  },
  {
    "codigo":609513003,
    "descripcion":"INTERRUPCIÓN INDUCIDA DEL EMBARAZO COMPLICADA POR DAÑO UTERINO"
  },
  {
    "codigo":249065002,
    "descripcion":"POSICIÓN OBLICUA, NALGA EN FOSA ILÍACA"
  },
  {
    "codigo":19689002,
    "descripcion":"INFESTACIÓN CAUSADA POR CYTODITES NUDUS"
  },
  {
    "codigo":1230270001,
    "descripcion":"COMPLEJO EXTROFIA EPISPADIAS"
  },
  {
    "codigo":247230002,
    "descripcion":"LATIDO VENOSO ESPONTÁNEO DE LA PAPILA ÓPTICA"
  },
  {
    "codigo":126161000119109,
    "descripcion":"AUSENCIA ADQUIRIDA DE CUELLO DE ÚTERO"
  },
  {
    "codigo":81555000,
    "descripcion":"FIBROADENOMA DE PRÓSTATA"
  },
  {
    "codigo":442003006,
    "descripcion":"LEISHMANIASIS CUTÁNEA DIFUSA CAUSADA POR LEISHMANIA AETHIOPICA"
  },
  {
    "codigo":40201000087102,
    "descripcion":"HERIDA ABIERTA DE MUÑECA IZQUIERDA POR MORDEDURA"
  },
  {
    "codigo":767848001,
    "descripcion":"QUISTE ÓSEO DE FÉMUR"
  },
  {
    "codigo":42761000087107,
    "descripcion":"PROLAPSO DE DISCO INTERVERTEBRAL T5-T6"
  },
  {
    "codigo":47881000087109,
    "descripcion":"FRACTURA DE UNDÉCIMA COSTILLA DERECHA"
  },
  {
    "codigo":866152006,
    "descripcion":"TROMBOCITOPENIA DEBIDA A COVID-19"
  },
  {
    "codigo":79720007,
    "descripcion":"HEPATOPATÍA CRÓNICA NO ASOCIADA AL ALCOHOL"
  },
  {
    "codigo":405565000,
    "descripcion":"FÍSTULA COLOVASCULAR"
  },
  {
    "codigo":733245000,
    "descripcion":"HERIDA PUNZANTE DE MANO CON CUERPO EXTRAÑO"
  },
  {
    "codigo":702312009,
    "descripcion":"SÍNDROME DE COALICIÓN TARSOCARPIANA"
  },
  {
    "codigo":12349003,
    "descripcion":"SIGNO DE DANFORTH"
  },
  {
    "codigo":1259368007,
    "descripcion":"CARCINOMA DE CÉLULAS GRANDES PRIMARIO DE PULMÓN"
  },
  {
    "codigo":208957005,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA EXPUESTA DE LA ARTICULACIÓN FEMORORROTULIANA, EXTERNA"
  },
  {
    "codigo":403730001,
    "descripcion":"XEROSTOMÍA CAUSADA POR RADIACIÓN IONIZANTE"
  },
  {
    "codigo":239890001,
    "descripcion":"LUPUS ERITEMATOSO SISTÉMICO CON COMPROMISO MULTIORGÁNICO"
  },
  {
    "codigo":895250008,
    "descripcion":"FORMA TRIANGULAR ANORMAL CONGÉNITA DE FALANGE PROXIMAL DE DEDO ÍNDICE"
  },
  {
    "codigo":76050008,
    "descripcion":"RASGO DE HEMOGLOBINA C"
  },
  {
    "codigo":400060000,
    "descripcion":"ENFERMEDAD DE BARMAH FOREST"
  },
  {
    "codigo":15965701000119105,
    "descripcion":"ENDOMETRIOSIS EN LIGAMENTO ANCHO DERECHO"
  },
  {
    "codigo":301756000,
    "descripcion":"ADENOCARCINOMA DEL COLON SIGMOIDE"
  },
  {
    "codigo":203452006,
    "descripcion":"FRACTURA OSTEOPORÓTICA DE VÉRTEBRA CERVICAL"
  },
  {
    "codigo":70545002,
    "descripcion":"CONSUMIDOR DE NARCÓTICOS"
  },
  {
    "codigo":758673004,
    "descripcion":"DIENTE SUPERNUMERARIO PARAMOLAR RUDIMENTARIO"
  },
  {
    "codigo":725905005,
    "descripcion":"SÍNDROME DE RIÑÓN MULTIQUÍSTICO CON ESTENOSIS INFUNDIBULOPÉLVICA"
  },
  {
    "codigo":37777005,
    "descripcion":"HOMOEROTISMO JUVENIL FEMENINO"
  },
  {
    "codigo":365457007,
    "descripcion":"ANTECEDENTES DE VIAJES AL EXTERIOR - HALLAZGO"
  },
  {
    "codigo":299921007,
    "descripcion":"DISCRIMINACIÓN TÁCTIL: PRESENTE"
  },
  {
    "codigo":234385007,
    "descripcion":"RASGO DE ALFATALASEMIA 2"
  },
  {
    "codigo":35942003,
    "descripcion":"ENVENENAMIENTO HOMICIDA"
  },
  {
    "codigo":724070005,
    "descripcion":"SÍNDROME DE MICRODELECIÓN 20Q13.2Q13.3 PATERNA"
  },
  {
    "codigo":298086007,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DEL DORSO"
  },
  {
    "codigo":230715005,
    "descripcion":"ACCIDENTE CEREBROVASCULAR (ACV) DE LA CIRCULACIÓN POSTERIOR DE PATOLOGÍA INCIERTA"
  },
  {
    "codigo":165179006,
    "descripcion":"CI - COEFICIENTE DE INTELIGENCIA NORMAL"
  },
  {
    "codigo":296251007,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE TRIFLUOPERAZINA"
  },
  {
    "codigo":294416004,
    "descripcion":"ALERGIA A HEXACLOROFENO"
  },
  {
    "codigo":196112005,
    "descripcion":"ABSCESO DE PULMÓN CON NEUMONÍA"
  },
  {
    "codigo":292581000,
    "descripcion":"REACCIÓN ADVERSA AL DIMENHIDRINATO"
  },
  {
    "codigo":1275621000,
    "descripcion":"MÚLTIPLES ROTURAS DE RETINA DE OJO DERECHO SIN DESPRENDIMIENTO"
  },
  {
    "codigo":11843231000119107,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE OÍDO DERECHO"
  },
  {
    "codigo":30437004,
    "descripcion":"EMPIEMA CON FÍSTULA BRONCOCUTÁNEA"
  },
  {
    "codigo":126906006,
    "descripcion":"NEOPLASIA DE LA PRÓSTATA"
  },
  {
    "codigo":92303001,
    "descripcion":"NEOPLASIA BENIGNA DE LA PARED POSTERIOR DE LA NASOFARINGE"
  },
  {
    "codigo":94138009,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL VESTÍBULO DE LA BOCA"
  },
  {
    "codigo":1306554009,
    "descripcion":"CARCINOMA DUCTAL INFILTRANTE DE PROLONGACIÓN AXILAR DE MAMA DERECHA"
  },
  {
    "codigo":26767005,
    "descripcion":"INTOXICACIÓN POR BISMUTO"
  },
  {
    "codigo":288911006,
    "descripcion":"DIFICULTAD PARA MOVER EL ALIMENTO EN LA BOCA"
  },
  {
    "codigo":713060000,
    "descripcion":"ENFERMEDAD DE CREUTZFELDT-JAKOB ESPORÁDICA"
  },
  {
    "codigo":285241002,
    "descripcion":"LÚCIDO"
  },
  {
    "codigo":23097003,
    "descripcion":"ENFERMEDAD DE LA SELVA DE KYASANUR"
  },
  {
    "codigo":10971091000119102,
    "descripcion":"HERIDA ABIERTA DE BRAZO IZQUIERDO DEBIDA A MORDEDURA HUMANA"
  },
  {
    "codigo":283406002,
    "descripcion":"CORTE EN LA BOCA"
  },
  {
    "codigo":414478003,
    "descripcion":"NÚMERO DE LEUCOCITOS EN SANGRE POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":840462006,
    "descripcion":"DERMATOFITOSIS CAUSADA POR MICROSPORUM PRAECOX"
  },
  {
    "codigo":447246008,
    "descripcion":"CICATRIZ CONTRAÍDA"
  },
  {
    "codigo":445411004,
    "descripcion":"BLANQUEAMIENTO DE LA PIEL DE LA PIERNA AL ELEVARLA"
  },
  {
    "codigo":246968002,
    "descripcion":"PLACAS POLIMÓRFICAS POSTERIORES EN LA CÓRNEA"
  },
  {
    "codigo":17592003,
    "descripcion":"DISFUNCIÓN PLAQUETARIA CAUSADA POR ASPIRINA"
  },
  {
    "codigo":212365000,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚLTIPLES VASOS SANGUÍNEOS A NIVEL DE HOMBRO Y BRAZO"
  },
  {
    "codigo":83128009,
    "descripcion":"OLIGURIA"
  },
  {
    "codigo":703885002,
    "descripcion":"MAL USO DE ANALGÉSICO"
  },
  {
    "codigo":736653007,
    "descripcion":"TRASTORNO NEONATAL DEL SISTEMA ENDOCRINO"
  },
  {
    "codigo":321491000119108,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE TENDÓN EXTENSOR DE BRAZO DERECHO"
  },
  {
    "codigo":46690002,
    "descripcion":"TRASTORNO DE LA PIGMENTACIÓN CUTÁNEA"
  },
  {
    "codigo":1259106002,
    "descripcion":"ENFERMEDAD DE ALEXANDER TIPO I"
  },
  {
    "codigo":276066008,
    "descripcion":"TRABAJADOR DE TURNO NOCTURNO"
  },
  {
    "codigo":865890009,
    "descripcion":"OBSTRUCCIÓN DE FARINGE CAUSADA POR ALIMENTO"
  },
  {
    "codigo":765751002,
    "descripcion":"ENCEFALOPATÍA AUTOINMUNITARIA CON PARASOMNIA Y APNEA OBSTRUCTIVA DEL SUEÑO"
  },
  {
    "codigo":1222668001,
    "descripcion":"LINFEDEMA PRIMARIO DE INICIO TARDÍO ASOCIADO A GEN CELSR1"
  },
  {
    "codigo":403468003,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS DE PENE"
  },
  {
    "codigo":237793004,
    "descripcion":"SÍNDROME DE HIPERANDROGENIZACIÓN"
  },
  {
    "codigo":301494001,
    "descripcion":"NO PUEDE SUBIR O BAJAR EL CORDÓN DE LA ACERA"
  },
  {
    "codigo":235958003,
    "descripcion":"ACUMULACIÓN AGUDA DE LÍQUIDOS PANCREÁTICOS"
  },
  {
    "codigo":299659002,
    "descripcion":"HALLAZGO RELACIONADO CON MEDICIONES DE LA DISPOSICIÓN DE LA PELVIS"
  },
  {
    "codigo":168587004,
    "descripcion":"RADIOGRAFÍA SIMPLE DE CÓCCIX ANORMAL"
  },
  {
    "codigo":135819008,
    "descripcion":"ESTADO GENERAL DE SALUD, MUY MALO"
  },
  {
    "codigo":234123009,
    "descripcion":"PERSISTENCIA DE ARTERIA EMBRIONARIA CEREBRAL"
  },
  {
    "codigo":363360003,
    "descripcion":"NEOPLASIA MALIGNA DE DOS TERCIOS ANTERIORES DE LENGUA"
  },
  {
    "codigo":2912004,
    "descripcion":"ENFERMEDAD QUÍSTICA - BULLOSA DEL PULMÓN"
  },
  {
    "codigo":232288005,
    "descripcion":"VÉRTIGO ISQUÉMICO VERTEBROBASILAR"
  },
  {
    "codigo":428896009,
    "descripcion":"HIPEROSMOLALIDAD POR DIABETES MELLITUS TIPO 1 NO CONTROLADA"
  },
  {
    "codigo":295989001,
    "descripcion":"SOBREDOSIS INTENCIONAL DE FENOBARBITAL"
  },
  {
    "codigo":33845003,
    "descripcion":"EFECTO IDIOSINCRÁTICO DE UN FÁRMACO"
  },
  {
    "codigo":263221003,
    "descripcion":"FRACTURA DE TUBEROSIDAD ISQUIÁTICA"
  },
  {
    "codigo":164917005,
    "descripcion":"ONDA Q ELECTROCARDIOGRÁFICA ANORMAL"
  },
  {
    "codigo":721973006,
    "descripcion":"SÍNDROME DE LIPODISTROFIA, DISCAPACIDAD INTELECTUAL Y SORDERA"
  },
  {
    "codigo":1077002,
    "descripcion":"SIGNOS ELECTROCARDIOGRÁFICOS DE INFARTO SEPTAL"
  },
  {
    "codigo":230453004,
    "descripcion":"EPILEPSIA RELACIONADA CON LA TOMA DE DECISIONES"
  },
  {
    "codigo":197685009,
    "descripcion":"SÍNDROME NEFRÍTICO AGUDO, GLOMERULONEFRITIS PROLIFERATIVA ENDOCAPILAR DIFUSA"
  },
  {
    "codigo":1177055001,
    "descripcion":"GRANULOMA ESQUISTOSÓMICO DEL SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":95711003,
    "descripcion":"NEVO DEL IRIS"
  },
  {
    "codigo":292319006,
    "descripcion":"REACCIÓN ADVERSA AL VALPROATO SÓDICO"
  },
  {
    "codigo":423391007,
    "descripcion":"HERPES SIMPLE GENITAL DE TIPO 2"
  },
  {
    "codigo":224948000,
    "descripcion":"SE TIRA DELANTE DE UN VEHÍCULO"
  },
  {
    "codigo":62943008,
    "descripcion":"INTOXICACIÓN POR LANTANA"
  },
  {
    "codigo":126644004,
    "descripcion":"NEOPLASIA DE LA PELVIS"
  },
  {
    "codigo":290484004,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR ÓXIDO NITROSO"
  },
  {
    "codigo":61108006,
    "descripcion":"MUCOSA INTESTINAL ECTÓPICA"
  },
  {
    "codigo":1306292009,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE MAMA IZQUIERDA"
  },
  {
    "codigo":716468009,
    "descripcion":"CAPAZ DE UTILIZAR LA TARJETA DE DÉBITO"
  },
  {
    "codigo":714633003,
    "descripcion":"ENFERMEDAD GINGIVAL CAUSADA POR STREPTOCOCCUS"
  },
  {
    "codigo":288649007,
    "descripcion":"NO ELIGE TEMAS DE CONVERSACIÓN"
  },
  {
    "codigo":254046002,
    "descripcion":"ESPONDILODISPLASIA, TIPO SAN DIEGO"
  },
  {
    "codigo":90206003,
    "descripcion":"VULVOVAGINITIS AGUDA"
  },
  {
    "codigo":712798003,
    "descripcion":"GANGLIOS LINFÁTICOS SEMEJANTES A PERDIGONES"
  },
  {
    "codigo":186675001,
    "descripcion":"FARINGOCONJUNTIVITIS VIRAL"
  },
  {
    "codigo":306851000119100,
    "descripcion":"DERRAME ARTICULAR DE CODO IZQUIERDO"
  },
  {
    "codigo":317091000119101,
    "descripcion":"REUMATISMO PALINDRÓMICO DE ARTICULACIÓN DE MANO DERECHA"
  },
  {
    "codigo":1090211000119102,
    "descripcion":"DIFTERIA FARÍNGEA"
  },
  {
    "codigo":337571000119103,
    "descripcion":"PIGMENTACIÓN CORNEAL ESTROMAL DE OJO IZQUIERDO"
  },
  {
    "codigo":1092771000119104,
    "descripcion":"NEURITIS TUBERCULOSA"
  },
  {
    "codigo":11801251000119105,
    "descripcion":"CONTUSIÓN DE RIÑÓN IZQUIERDO"
  },
  {
    "codigo":368291000119106,
    "descripcion":"PRIAPISMO DEBIDO A TRAUMATISMO"
  },
  {
    "codigo":11842211000119107,
    "descripcion":"LACERACIÓN DE TENDÓN DE DEDO DE PIE IZQUIERDO"
  },
  {
    "codigo":35491000119107,
    "descripcion":"MECÁNICA PULMONAR RESTRICTIVA DEBIDA A ENFERMEDAD NEUROMUSCULAR"
  },
  {
    "codigo":299171000119103,
    "descripcion":"HEMARTROSIS DE HOMBRO DERECHO"
  },
  {
    "codigo":788062371000119104,
    "descripcion":"TOS AGUDA"
  },
  {
    "codigo":135331000119105,
    "descripcion":"TRASTORNO DEL RITMO CIRCADIANO DEL SUEÑO CAUSADO POR ALCOHOL"
  },
  {
    "codigo":332451000119109,
    "descripcion":"NEOVASCULARIZACIÓN RETINIANA DERECHA"
  },
  {
    "codigo":210321571000119107,
    "descripcion":"LACERACIÓN DE VASO SANGUÍNEO DE DEDO MEDIO DE MANO"
  },
  {
    "codigo":283144003,
    "descripcion":"ANZUELO EN LA REGIÓN DE OREJA"
  },
  {
    "codigo":340131000119107,
    "descripcion":"QUERATOPATÍA IZQUIERDA POSTERIOR A CIRUGÍA DE CATARATA"
  },
  {
    "codigo":281309004,
    "descripcion":"SANGRADO DEL FONDO DE SACO VAGINAL"
  },
  {
    "codigo":10866851000119108,
    "descripcion":"HERIDA POR DISPARO DE ARMA DE FUEGO DE REGIÓN LUMBAR"
  },
  {
    "codigo":294051000119109,
    "descripcion":"HEMIPLEJÍA FLÁCCIDA DE LADO IZQUIERDO NO DOMINANTE"
  },
  {
    "codigo":445149007,
    "descripcion":"ENFERMEDAD TROFOBLÁSTICA RESIDUAL"
  },
  {
    "codigo":838365008,
    "descripcion":"AMEBOMA DE INTESTINO DELGADO"
  },
  {
    "codigo":443314009,
    "descripcion":"VIVE COMO INQUILINO ILEGAL"
  },
  {
    "codigo":769159002,
    "descripcion":"DEFICIENCIA DE PARTE ANTERIOR DE CRESTA ALVEOLAR INFERIOR"
  },
  {
    "codigo":703623009,
    "descripcion":"PSEUDOARTROSIS DE ARTICULACIÓN DE TOBILLO SIN INFECCIÓN"
  },
  {
    "codigo":243036004,
    "descripcion":"LESIÓN POR EXPLOSIÓN DE CARGA DE PROFUNDIDAD"
  },
  {
    "codigo":46428007,
    "descripcion":"RUIDO OCULAR"
  },
  {
    "codigo":352981000119107,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE HUESO DE PIE IZQUIERDO"
  },
  {
    "codigo":699953006,
    "descripcion":"ABSCESO DE TENDÓN DE MIEMBRO INFERIOR"
  },
  {
    "codigo":765489006,
    "descripcion":"SÍNDROME DE CROMOSOMA 7 EN ANILLO"
  },
  {
    "codigo":44593008,
    "descripcion":"DISMINUCIÓN DE LA SEPARACIÓN ORBITARIA"
  },
  {
    "codigo":110129009,
    "descripcion":"LACERACIÓN SIMPLE DEL PALADAR BLANDO"
  },
  {
    "codigo":763654002,
    "descripcion":"PRÓTESIS DE ARTICULACIÓN DE CADERA PRESENTE"
  },
  {
    "codigo":42758002,
    "descripcion":"MUCOCELE LAGRIMAL"
  },
  {
    "codigo":206598002,
    "descripcion":"FIEBRE RECIDIVANTE DEL SUDOESTE DE EE.UU. Y\/O MÉXICO"
  },
  {
    "codigo":403206004,
    "descripcion":"QUERATOSIS ACTÍNICAS MÚLTIPLES CON COMPROMISO DE MANOS"
  },
  {
    "codigo":306737006,
    "descripcion":"BAJO ATENCIÓN DEL CIRUJANO DENTAL GENERAL"
  },
  {
    "codigo":1156870007,
    "descripcion":"AUSENCIA DE HÍGADO"
  },
  {
    "codigo":1255174008,
    "descripcion":"FRACTURA EXPUESTA CONMINUTA DE FALANGE MEDIA DE DEDO DE MANO"
  },
  {
    "codigo":16055151000119105,
    "descripcion":"HEMORRAGIA GASTROINTESTINAL NEONATAL"
  },
  {
    "codigo":202928001,
    "descripcion":"BUNIO INFECTADO"
  },
  {
    "codigo":301232003,
    "descripcion":"LESIÓN DE PULMÓN"
  },
  {
    "codigo":235696004,
    "descripcion":"FÍSTULA DUODENOENTÉRICA"
  },
  {
    "codigo":37253000,
    "descripcion":"FRAGILIDAD OSMÓTICA DISMINUIDA"
  },
  {
    "codigo":268464009,
    "descripcion":"UTILIZA ANTICONCEPTIVO DE DEPÓSITO"
  },
  {
    "codigo":201093004,
    "descripcion":"PIEL EXCEDENTE"
  },
  {
    "codigo":233861004,
    "descripcion":"INSUFICIENCIA MITRAL FUNCIONAL"
  },
  {
    "codigo":299397008,
    "descripcion":"PRUEBA DEL CAJÓN POSTERIOR POSITIVA"
  },
  {
    "codigo":168325008,
    "descripcion":"ORGANISMO AISLADO EN CULTIVO DE HISOPADO ANAL"
  },
  {
    "codigo":15701001000119102,
    "descripcion":"ADHERENCIA DE TENDONES DE AMBAS MANOS"
  },
  {
    "codigo":68186003,
    "descripcion":"MIOPATÍA CONGÉNITA CON ORGANELAS SUBCELULARES ANORMALES"
  },
  {
    "codigo":461402004,
    "descripcion":"HALLAZGO RELACIONADO CON EL LIGAMENTO ARTERIOSO"
  },
  {
    "codigo":66351003,
    "descripcion":"SÍNDROME FETAL POR TRIMETADIONA"
  },
  {
    "codigo":230191005,
    "descripcion":"SÍNDROME DE RASMUSSEN"
  },
  {
    "codigo":262959006,
    "descripcion":"SECCIÓN COMPLETA DE NERVIO CRANEAL"
  },
  {
    "codigo":815008,
    "descripcion":"EPISCLERITIS"
  },
  {
    "codigo":721711009,
    "descripcion":"HEPATITIS AUTOINMUNITARIA, TIPO 1"
  },
  {
    "codigo":295727008,
    "descripcion":"SOBREDOSIS DE ETOPÓSIDO"
  },
  {
    "codigo":228356003,
    "descripcion":"CONVICTO POR CONDUCIR ALCOHOLIZADO"
  },
  {
    "codigo":457732003,
    "descripcion":"CALCIFICACIÓN DE VÁLVULA AURICULOVENTRICULAR COMÚN"
  },
  {
    "codigo":293892004,
    "descripcion":"ALERGIA A ALPRAZOLAM"
  },
  {
    "codigo":361263009,
    "descripcion":"QUISTE PARAVAGINAL ORIGINADO EN EL CONDUCTO MESONÉFRICO"
  },
  {
    "codigo":33583009,
    "descripcion":"INFECCIÓN CAUSADA POR CATATROPIS"
  },
  {
    "codigo":292057000,
    "descripcion":"REACCIÓN ADVERSA A LA DIHIDROCODEÍNA"
  },
  {
    "codigo":95449003,
    "descripcion":"TROMBOFLEBITIS DE LA VENA PÉLVICA"
  },
  {
    "codigo":128217007,
    "descripcion":"TRASTORNO DE LA PIEL Y\/O DEL TEJIDO CELULAR SUBCUTÁNEO DE LA CABEZA"
  },
  {
    "codigo":28078000,
    "descripcion":"FRACTURA DIAFISARIA NO EXPUESTA DE ANTEBRAZO"
  },
  {
    "codigo":93614002,
    "descripcion":"INFECCIÓN CAUSADA POR BAYLISASCARIS PROCYONIS"
  },
  {
    "codigo":714371000,
    "descripcion":"CAPAZ DE ADHERIR A REGLAS Y LÍMITES"
  },
  {
    "codigo":419459000,
    "descripcion":"FOTOTOXICIDAD RETINIANA"
  },
  {
    "codigo":880046009,
    "descripcion":"ESTENOSIS ADQUIRIDA DE VÁLVULA AURICULOVENTRICULAR COMÚN POSTERIOR A REPARACIÓN DE COMUNICACIÓN BIVENTRICULAR"
  },
  {
    "codigo":26243003,
    "descripcion":"PALINOACUSIA"
  },
  {
    "codigo":124547004,
    "descripcion":"DEFICIENCIA DE DIÉSTER FOSFÓRICO HIDROLASA"
  },
  {
    "codigo":191918009,
    "descripcion":"PATRÓN DE USO NOCIVO CONTINUO DE COCAÍNA SIN DEPENDENCIA"
  },
  {
    "codigo":286552001,
    "descripcion":"CUERPO EXTRAÑO EN ESTRUCTURA NEUROLÓGICA"
  },
  {
    "codigo":24408004,
    "descripcion":"PARÁLISIS DE MOCHILA"
  },
  {
    "codigo":253784007,
    "descripcion":"HIPERGANGLIONOSIS"
  },
  {
    "codigo":55341008,
    "descripcion":"TRASTORNO HISTRIÓNICO DE LA PERSONALIDAD"
  },
  {
    "codigo":282882001,
    "descripcion":"CAPAZ DE PARARSE DESDE POSICIÓN SENTADA"
  },
  {
    "codigo":250114005,
    "descripcion":"CLIC DE MULDER"
  },
  {
    "codigo":1003778005,
    "descripcion":"CONTRACTURA EN FLEXIÓN DE ARTICULACIÓN INTERFALÁNGICA DISTAL DE DEDO MEÑIQUE"
  },
  {
    "codigo":1231319004,
    "descripcion":"DEPENDENCIA DE ÉXTASIS"
  },
  {
    "codigo":444887005,
    "descripcion":"FLUJO INSUFICIENTE PARA SOSTENER EL FLUJO SANGUÍNEO DE DIÁLISIS PRESCRITO"
  },
  {
    "codigo":248279007,
    "descripcion":"DEBILIDAD"
  },
  {
    "codigo":18903007,
    "descripcion":"EFECTO CARCINÓGENO"
  },
  {
    "codigo":17068004,
    "descripcion":"BIORRITMO CIRCATRENTANO NORMAL"
  },
  {
    "codigo":768897007,
    "descripcion":"PSICOLÓGICAMENTE PREPARADO PARA SOMETERSE A UN PROCEDIMIENTO"
  },
  {
    "codigo":211841008,
    "descripcion":"QUEMADURA DE TERCER GRADO PROFUNDA DE ANTEBRAZO"
  },
  {
    "codigo":46166004,
    "descripcion":"ACIDOSIS METABÓLICA COMPENSADA"
  },
  {
    "codigo":406614006,
    "descripcion":"ENFERMEDAD INVASIVA POR ESTREPTOCOCO BETA-HEMOLÍTICO DEL GRUPO A"
  },
  {
    "codigo":239104000,
    "descripcion":"FOLICULITIS PRURIGINOSA DEL EMBARAZO"
  },
  {
    "codigo":372011009,
    "descripcion":"NEOPLASIA MALIGNA DE PARTES BLANDAS DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":42496002,
    "descripcion":"CISTINURIA, TIPO 3"
  },
  {
    "codigo":109867008,
    "descripcion":"CERVICITIS FOLICULAR"
  },
  {
    "codigo":1254912005,
    "descripcion":"HIPOHIDROSIS DEBIDA A TRASTORNO NEUROLÓGICO"
  },
  {
    "codigo":402944008,
    "descripcion":"CONDILOMAS PLANOS SIFILÍTICOS DE LA PIEL PERIANAL"
  },
  {
    "codigo":40661001,
    "descripcion":"TRASTORNO DE LA FORMACIÓN ARTICULAR"
  },
  {
    "codigo":204501003,
    "descripcion":"ESTENOSIS CONGÉNITA DE ARTERIA CEREBRAL"
  },
  {
    "codigo":1187541007,
    "descripcion":"DEFICIENCIA DE FLAVOPROTEÍNA DE TRANSFERENCIA DE ELECTRONES DE CADENA BETA"
  },
  {
    "codigo":202666001,
    "descripcion":"ESPONDILOSIS DORSAL EN UN NIVEL SIN MIELOPATÍA"
  },
  {
    "codigo":169898002,
    "descripcion":"PUNTAJE DE APGAR AL MINUTO = 2"
  },
  {
    "codigo":6058003,
    "descripcion":"CUERPO EXTRAÑO RESIDUAL EN PARTES BLANDAS"
  },
  {
    "codigo":366506004,
    "descripcion":"AMPLITUD DE LA FLEXIÓN DE CODO - HALLAZGO"
  },
  {
    "codigo":233599001,
    "descripcion":"BRONQUITIS MICOPLÁSMICA AGUDA"
  },
  {
    "codigo":36991002,
    "descripcion":"FRACTURA NO EXPUESTA DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":102527003,
    "descripcion":"EDAD ENTRE 60 Y 64 AÑOS"
  },
  {
    "codigo":4223005,
    "descripcion":"PARKINSONISMO CAUSADO POR FÁRMACO"
  },
  {
    "codigo":725119006,
    "descripcion":"ERUPCIÓN GENERALIZADA"
  },
  {
    "codigo":299135008,
    "descripcion":"ARTICULACIÓN DEL PULGAR - TUMEFACCIÓN SINOVIAL"
  },
  {
    "codigo":2388001,
    "descripcion":"VARIACIÓN NORMAL EN LA TRANSLUCIDEZ"
  },
  {
    "codigo":35156002,
    "descripcion":"HIPOPLASIA DEL CEMENTO"
  },
  {
    "codigo":67924001,
    "descripcion":"VIRUELA"
  },
  {
    "codigo":295465000,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE SEN"
  },
  {
    "codigo":262697008,
    "descripcion":"CONTUSIÓN DE MÉDULA ESPINAL CERVICAL"
  },
  {
    "codigo":721449009,
    "descripcion":"SÍNDROME DEL CORDÓN CENTRAL DE MÉDULA ESPINAL AL NIVEL DEL SÉPTIMO SEGMENTO DORSAL"
  },
  {
    "codigo":195326003,
    "descripcion":"EMBOLIA Y TROMBOSIS DE ARTERIA PEDIA"
  },
  {
    "codigo":129790003,
    "descripcion":"TEJIDO MAMARIO ASIMÉTRICO"
  },
  {
    "codigo":64254006,
    "descripcion":"EMBARAZO DE TRILLIZOS"
  },
  {
    "codigo":293630008,
    "descripcion":"ALERGIA A SULINDACO"
  },
  {
    "codigo":95187002,
    "descripcion":"LINFOMA NODULAR DE LOS GANGLIOS LINFÁTICOS INTRAPÉLVICOS"
  },
  {
    "codigo":224424001,
    "descripcion":"INSTALACIONES DE DUCHAS INADECUADAS EN EL TRABAJO"
  },
  {
    "codigo":93352008,
    "descripcion":"POSICIÓN ANÓMALA CONGÉNITA DE LA ESTERNEBRA"
  },
  {
    "codigo":124285000,
    "descripcion":"DEFICIENCIA DE ALANINA AMINOTRANSFERASA"
  },
  {
    "codigo":58749007,
    "descripcion":"CAMBIOS CORNEALES SENILES"
  },
  {
    "codigo":419197009,
    "descripcion":"DISTROFIA CORNEAL EN REJA, TIPO I"
  },
  {
    "codigo":24146004,
    "descripcion":"QUINTILLIZOS RECIÉN NACIDOS PREMATUROS"
  },
  {
    "codigo":253522006,
    "descripcion":"DILATACIÓN DEL VENTRÍCULO CARDÍACO DERECHO"
  },
  {
    "codigo":286290008,
    "descripcion":"IMITA SONIDOS DEL HABLA"
  },
  {
    "codigo":415527002,
    "descripcion":"SIGMOIDOSCOPIA NORMAL"
  },
  {
    "codigo":774140000,
    "descripcion":"INESTABILIDAD DE ARTICULACIÓN DEL HOMBRO DERECHO"
  },
  {
    "codigo":1003516003,
    "descripcion":"AGENESIA DE HUESO ILÍACO"
  },
  {
    "codigo":53244004,
    "descripcion":"SUPOSICIÓN DE UNA NUEVA IDENTIDAD"
  },
  {
    "codigo":315388005,
    "descripcion":"NACIDO EN BOTSWANA"
  },
  {
    "codigo":282620009,
    "descripcion":"CAPAZ DE RODAR"
  },
  {
    "codigo":15951781000119108,
    "descripcion":"NEVO EPIDÉRMICO DE PIEL DE AMBOS MIEMBROS INFERIORES"
  },
  {
    "codigo":410022000,
    "descripcion":"SEUDOANEURISMA FEMORAL POSCATETERISMO ARTERIAL"
  },
  {
    "codigo":1362129009,
    "descripcion":"AYUNO INTERMITENTE"
  },
  {
    "codigo":248017007,
    "descripcion":"ESCRITURA EN LAS PAREDES"
  },
  {
    "codigo":82342003,
    "descripcion":"ALBINISMO OCULOCUTÁNEO MUTANTE AMARILLO"
  },
  {
    "codigo":47739002,
    "descripcion":"MIELOTISIS"
  },
  {
    "codigo":80507005,
    "descripcion":"OSTEOMIELITIS AGUDA DE LA REGIÓN PÉLVICA"
  },
  {
    "codigo":211579005,
    "descripcion":"LESIÓN TRAUMÁTICA ABIERTA POR APLASTAMIENTO DE LA MANO, PALMA"
  },
  {
    "codigo":277115008,
    "descripcion":"ASIMETRÍA DE LATENCIA INTEROCULAR"
  },
  {
    "codigo":735867008,
    "descripcion":"HERIDA PUNZANTE CONCOMITANTE CON CUERPO EXTRAÑO DE TOBILLO"
  },
  {
    "codigo":10682431000119105,
    "descripcion":"TUMORACIÓN DEL TEJIDO CELULAR SUBCUTÁNEO DE EXTREMIDAD INFERIOR IZQUIERDA"
  },
  {
    "codigo":275280004,
    "descripcion":"LLORIQUEO"
  },
  {
    "codigo":209744004,
    "descripcion":"SECCIÓN EXPUESTA DE LIGAMENTO DE ARTICULACIÓN CONDROCOSTAL"
  },
  {
    "codigo":764965000,
    "descripcion":"ANEURISMA DE AORTA TORÁCICA Y DISECCIÓN AÓRTICA FAMILIAR"
  },
  {
    "codigo":373584008,
    "descripcion":"OBSTRUCCIÓN CONGÉNITA DE UNIÓN URETEROPÉLVICA"
  },
  {
    "codigo":207909002,
    "descripcion":"FRACTURA NO EXPUESTA DE VÉRTEBRA CERVICAL, TRICOLUMNAR"
  },
  {
    "codigo":240677003,
    "descripcion":"FRAMBESIA MACULOPAPULAR"
  },
  {
    "codigo":1354789004,
    "descripcion":"SECCIÓN TRAUMÁTICA DE VENA MESENTÉRICA SUPERIOR"
  },
  {
    "codigo":11301007,
    "descripcion":"ESTRECHAMIENTO DE ESPACIO DE DISCO INTERVERTEBRAL"
  },
  {
    "codigo":238842001,
    "descripcion":"ATROFODERMIA FOLICULAR"
  },
  {
    "codigo":1254650002,
    "descripcion":"SÍNDROME DE MICROCEFALIA, HIPOPLASIA DEL CUERPO CALLOSO, DISCAPACIDAD INTELECTUAL, DISMORFIA FACIAL"
  },
  {
    "codigo":402682003,
    "descripcion":"ELASTOSIS DÉRMICA"
  },
  {
    "codigo":16007231000119109,
    "descripcion":"GANGRENA DE DEDO DE MANO IZQUIERDA"
  },
  {
    "codigo":763130006,
    "descripcion":"SÍNDROME DE FISURA DE PALADAR, OREJAS GRANDES, CABEZA PEQUEÑA"
  },
  {
    "codigo":7631003,
    "descripcion":"FÓRMULA PARA LACTANTES, CON TRIGLICÉRIDOS DE CADENA INTERMEDIA"
  },
  {
    "codigo":1187279003,
    "descripcion":"PARAPLEJÍA ESPÁSTICA AUTOSÓMICA RECESIVA HEREDITARIA"
  },
  {
    "codigo":300708002,
    "descripcion":"INCAPAZ DE USAR UNA TARJETA DE CRÉDITO"
  },
  {
    "codigo":71332006,
    "descripcion":"PIODERMIA PSEUDOBLASTOMICÓTICA"
  },
  {
    "codigo":366244007,
    "descripcion":"HALLAZGO RELACIONADO CON EL ASPECTO DE LA CORONA DENTAL"
  },
  {
    "codigo":36729000,
    "descripcion":"DOLOR DE PRÓSTATA"
  },
  {
    "codigo":202404008,
    "descripcion":"HEMARTROSIS DE ARTICULACIÓN ACROMIOCLAVICULAR"
  },
  {
    "codigo":397177002,
    "descripcion":"LESIÓN TRAUMÁTICA ABIERTA CON CUERPO EXTRAÑO EN HERIDA"
  },
  {
    "codigo":724857000,
    "descripcion":"OCLUSIÓN DE MICROVASCULATURA CUTÁNEA CAUSADA POR ÉMBOLO"
  },
  {
    "codigo":298873004,
    "descripcion":"ARTICULACIÓN DE CODO - TUMEFACCIÓN SINOVIAL"
  },
  {
    "codigo":428110002,
    "descripcion":"SEUDOANEURISMA DE INJERTO ARTERIOVENOSO"
  },
  {
    "codigo":297038003,
    "descripcion":"SOBREDOSIS DE MERSALILO"
  },
  {
    "codigo":231502005,
    "descripcion":"ATAQUE DE PÁNICO SITUACIONAL"
  },
  {
    "codigo":229667000,
    "descripcion":"DISFUNCIÓN SEMÁNTICA"
  },
  {
    "codigo":723022008,
    "descripcion":"QUERATITIS AUTOINMUNITARIA"
  },
  {
    "codigo":721187005,
    "descripcion":"DEFICIENCIA DE METILCOBALAMINA TIPO CBL G"
  },
  {
    "codigo":295203007,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE FENOPERIDINA"
  },
  {
    "codigo":424440001,
    "descripcion":"ADENOCARCINOMA DE INTESTINO DELGADO"
  },
  {
    "codigo":94925002,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LOS ÓRGANOS GENITALES MASCULINOS"
  },
  {
    "codigo":191394000,
    "descripcion":"GANGLIOS LINFÁTICOS CALCIFICADOS"
  },
  {
    "codigo":224162008,
    "descripcion":"MATRIMONIO INMINENTE"
  },
  {
    "codigo":124023002,
    "descripcion":"ALFAGLOBULINA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":713847007,
    "descripcion":"NEURALGIA DEL OBTURADOR POSTERIOR A PROCEDIMIENTO QUIRÚRGICO"
  },
  {
    "codigo":89420002,
    "descripcion":"ENFERMEDAD VENOCLUSIVA PULMONAR"
  },
  {
    "codigo":1269068003,
    "descripcion":"TRASTORNO NEONATAL PRECOZ DEBIDO A TRASTORNO MATERNO DE TRABAJO DE PARTO"
  },
  {
    "codigo":187724003,
    "descripcion":"NEOPLASIA MALIGNA DE ESÓFAGO ABDOMINAL"
  },
  {
    "codigo":23884004,
    "descripcion":"SUPURACIÓN AGUDA DE SENO MAXILAR"
  },
  {
    "codigo":286028004,
    "descripcion":"INCAPAZ DE SACAR UN ENCHUFE ELÉCTRICO DE UN TOMACORRIENTE"
  },
  {
    "codigo":449868002,
    "descripcion":"FUMA TABACO DIARIAMENTE"
  },
  {
    "codigo":22049009,
    "descripcion":"ECTASIA DE CONDUCTO GALACTÓFORO"
  },
  {
    "codigo":85750001,
    "descripcion":"INFECCIÓN CAUSADA POR MESOCESTOIDES LINEATUS"
  },
  {
    "codigo":16747021000119109,
    "descripcion":"RETINOPATÍA NO PROLIFERATIVA SEVERA BILATERAL DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":446198006,
    "descripcion":"DISTENSIÓN DE MÚSCULO INFRAESPINOSO"
  },
  {
    "codigo":249590007,
    "descripcion":"SOPLO ABDOMINAL"
  },
  {
    "codigo":216822009,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR GAS NATURAL DE TUBERÍA"
  },
  {
    "codigo":90791000119104,
    "descripcion":"ENFERMEDAD RENAL TERMINAL EN DIÁLISIS DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":870347004,
    "descripcion":"NEURITIS RETROBULBAR DEBIDA A SÍFILIS TARDÍA"
  },
  {
    "codigo":51147005,
    "descripcion":"INSUFICIENCIA VASCULAR CRÓNICA"
  },
  {
    "codigo":247755007,
    "descripcion":"RETRAÍDO"
  },
  {
    "codigo":1360032000,
    "descripcion":"FIBROSIS DE PULPA DENTAL"
  },
  {
    "codigo":313291009,
    "descripcion":"ANEMIA DURANTE EL PUERPERIO"
  },
  {
    "codigo":15983271000119105,
    "descripcion":"POSICIÓN ANÓMALA CONGÉNITA DE OÍDO EXTERNO IZQUIERDO"
  },
  {
    "codigo":278688000,
    "descripcion":"OCLUSIÓN FUNCIONAL QUE NO PRODUCE INTERFERENCIA LABORAL"
  },
  {
    "codigo":213152006,
    "descripcion":"FALLA Y RECHAZO DEL TRASPLANTE CORAZÓN-PULMÓN"
  },
  {
    "codigo":442528007,
    "descripcion":"FIBROMATOSIS CON CONTRACTURA DE LA FASCIA PLANTAR"
  },
  {
    "codigo":735605000,
    "descripcion":"DEGENERACIÓN DE DISCO INTERVERTEBRAL CERVICAL CONCOMITANTE CON OSTEOFITO DE VÉRTEBRA CERVICAL"
  },
  {
    "codigo":310081000119100,
    "descripcion":"GOTA PRIMARIA CRÓNICA DE VÉRTEBRA, SIN TOFO"
  },
  {
    "codigo":1073831000119107,
    "descripcion":"ARTRITIS REUMATOIDE DE LA MUÑECA DERECHA"
  },
  {
    "codigo":473461003,
    "descripcion":"EDUCADO HASTA EL NIVEL SECUNDARIO DE ESCOLARIDAD"
  },
  {
    "codigo":211317004,
    "descripcion":"ABRASIÓN DE PIEL DE DEDO DE MANO"
  },
  {
    "codigo":276853009,
    "descripcion":"LESIÓN AUTOINFLIGIDA"
  },
  {
    "codigo":336551000119109,
    "descripcion":"CONJUNTIVITIS FOLICULAR AGUDA DE OJO DERECHO"
  },
  {
    "codigo":1290826004,
    "descripcion":"CARCINOMA BASOCELULAR CON DIFERENCIACIÓN SARCOMATOIDE"
  },
  {
    "codigo":764703002,
    "descripcion":"SÍNDROME DE MICRODUPLICACIÓN 7P22.1"
  },
  {
    "codigo":240415007,
    "descripcion":"INFECCIÓN MIOBACTERIANA ATÍPICA DE PIEL Y PARTES BLANDAS"
  },
  {
    "codigo":109343008,
    "descripcion":"SECUESTRO DE HUESO ESFENOIDES"
  },
  {
    "codigo":402420001,
    "descripcion":"INFECCIÓN DE PIEL POR HERPESVIRUS HUMANO TIPO 6"
  },
  {
    "codigo":41972004,
    "descripcion":"FRACTURA DE CUERPO DE CLAVÍCULA"
  },
  {
    "codigo":369652004,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA DE OVARIO, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":238580008,
    "descripcion":"DERMATITIS IRRITATIVA SUBAGUDA POR CONTACTO"
  },
  {
    "codigo":105673001,
    "descripcion":"ENFERMEDAD CAUSADA POR NOTOCOTYLIDAE"
  },
  {
    "codigo":7369002,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA ARTERIA PALMAR"
  },
  {
    "codigo":236745001,
    "descripcion":"BALANITIS BACTERIANA"
  },
  {
    "codigo":1285321001,
    "descripcion":"MELANOMA NEVOIDE"
  },
  {
    "codigo":365982000,
    "descripcion":"TABAQUISMO - HALLAZGO"
  },
  {
    "codigo":38302000,
    "descripcion":"INFECCIÓN CAUSADA POR ECHINOSTOMA LINDOENSE"
  },
  {
    "codigo":5534004,
    "descripcion":"ARTERITIS SENIL"
  },
  {
    "codigo":202142008,
    "descripcion":"LESIÓN DE HILL-SACHS INVERSA"
  },
  {
    "codigo":300446008,
    "descripcion":"DOLOR A LA PALPACIÓN EN RIÑÓN"
  },
  {
    "codigo":3699000,
    "descripcion":"DEFICIENCIA TRANSVERSA DE LA EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":724595003,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE MIEMBRO EN VALGO"
  },
  {
    "codigo":36467003,
    "descripcion":"TALASEMIA ALFA MÁS"
  },
  {
    "codigo":429683003,
    "descripcion":"INTIMIDACIÓN DE NIÑO"
  },
  {
    "codigo":396915006,
    "descripcion":"INVASIÓN PLEURAL POR TUMOR AUSENTE"
  },
  {
    "codigo":788296001,
    "descripcion":"LINFANGIECTASIA ADQUIRIDA CON REFLUJO QUILOSO"
  },
  {
    "codigo":722760002,
    "descripcion":"ENFERMEDAD POR DEPÓSITOS DENSOS"
  },
  {
    "codigo":395080004,
    "descripcion":"TRASTORNO SENSITIVO EN EXTREMIDAD"
  },
  {
    "codigo":131101007,
    "descripcion":"NIVEL DE GONADOTROFINA CORIÓNICA HUMANA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":194802003,
    "descripcion":"INFARTO DE MIOCARDIO POSTERIOR VERDADERO"
  },
  {
    "codigo":94663008,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL APARATO URINARIO"
  },
  {
    "codigo":192967009,
    "descripcion":"PARAPLEJÍA ESPÁSTICA"
  },
  {
    "codigo":717255008,
    "descripcion":"LINFANGIECTASIA INTESTINAL SECUNDARIA"
  },
  {
    "codigo":125596004,
    "descripcion":"LESIÓN TRAUMÁTICA DE CODO"
  },
  {
    "codigo":715420005,
    "descripcion":"SÍNDROME LETAL DE CONTRACTURAS CONGÉNITAS TIPO 3"
  },
  {
    "codigo":1336177001,
    "descripcion":"MELANOMA FUSOCELULAR METASTÁSICO"
  },
  {
    "codigo":123761003,
    "descripcion":"SÍNDROME DE MASCULINIZACIÓN OVÁRICA"
  },
  {
    "codigo":254833008,
    "descripcion":"TUMOR DE PARTES BLANDAS DE CARA, CABEZA Y CUELLO"
  },
  {
    "codigo":251163000,
    "descripcion":"PARO DEL NÓDULO AURICULOVENTRICULAR (NODAL)"
  },
  {
    "codigo":218395001,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR OLEORRESINA DE HELECHO MACHO"
  },
  {
    "codigo":185627001,
    "descripcion":"PACIENTE QUE NO CONCURRE A REALIZARSE EXTENDIDO CERVICAL"
  },
  {
    "codigo":413168003,
    "descripcion":"ESTADO DE REGISTRO DE SALUD MENTAL"
  },
  {
    "codigo":871920005,
    "descripcion":"REACCIÓN ALÉRGICA CAUSADA POR PICADURA DE INSECTO"
  },
  {
    "codigo":216560006,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR CAFEÍNA"
  },
  {
    "codigo":249328007,
    "descripcion":"PUNTA DA LA NARIZ COLGANTE"
  },
  {
    "codigo":183792008,
    "descripcion":"INSCRIPTO EN LISTA DE ADMISIÓN DE CIRUGÍA MAXILOFACIAL"
  },
  {
    "codigo":247493001,
    "descripcion":"GRIETAS UNGUEALES"
  },
  {
    "codigo":18117002,
    "descripcion":"RASGO DE PERSONALIDAD PARANOIDE"
  },
  {
    "codigo":314864005,
    "descripcion":"OBSTRUCCIÓN FUNCIONAL DE CONDUCTO NASOLAGRIMAL"
  },
  {
    "codigo":444101006,
    "descripcion":"INFECCIÓN CAUSADA POR STAPHYLOCOCCUS INTERMEDIUS RESISTENTE A LA METICILINA"
  },
  {
    "codigo":704410001,
    "descripcion":"FRACTURA NO EXPUESTA TRANSCONDÍLEA DE HÚMERO DISTAL"
  },
  {
    "codigo":409498004,
    "descripcion":"CARBUNCO"
  },
  {
    "codigo":737178004,
    "descripcion":"GINATRESIA DE VAGINA"
  },
  {
    "codigo":243823000,
    "descripcion":"ESTADO DE LA ESPONJA ANTICONCEPTIVA"
  },
  {
    "codigo":14447001,
    "descripcion":"SÍNDROME DE DANDY - WALKER"
  },
  {
    "codigo":1259631000,
    "descripcion":"CARCINOMA PRIMARIO DE ENCÍA INFERIOR"
  },
  {
    "codigo":276591003,
    "descripcion":"SÍNDROME SUBAGUDO DE LACERACIÓN TENTORIAL"
  },
  {
    "codigo":702575003,
    "descripcion":"VASCULOPATÍA RETINOCOCLEOCEREBRAL"
  },
  {
    "codigo":211055004,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE LA PARED TORÁCICA"
  },
  {
    "codigo":15687081000119105,
    "descripcion":"SINOVITIS DE AMBOS TOBILLOS"
  },
  {
    "codigo":241988002,
    "descripcion":"ALTERACIÓN CUTÁNEA POR DESCOMPRESIÓN"
  },
  {
    "codigo":373060007,
    "descripcion":"ESTADO DE DISPOSITIVO"
  },
  {
    "codigo":78148008,
    "descripcion":"FIBROADENOSIS SEGMENTARIA DE LA MAMA"
  },
  {
    "codigo":1255961001,
    "descripcion":"ULCERACIÓN TRAUMÁTICA DE ESTRUCTURA GINGIVAL DEBIDA A CEPILLADO DE DIENTES"
  },
  {
    "codigo":1290564009,
    "descripcion":"COMPLICACIÓN DE MÚLTIPLES DEDOS REIMPLANTADOS"
  },
  {
    "codigo":698905003,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: CANARÉS"
  },
  {
    "codigo":305689001,
    "descripcion":"ATENDIDO POR UN TOCOGINECÓLOGO"
  },
  {
    "codigo":403993007,
    "descripcion":"COLAGENOMA ESTORIFORME"
  },
  {
    "codigo":205550003,
    "descripcion":"ICTIOSIS LAMINAR"
  },
  {
    "codigo":105411000,
    "descripcion":"RETRAIMIENTO SOCIAL"
  },
  {
    "codigo":271086008,
    "descripcion":"DEFORMIDAD DE HÚMERO"
  },
  {
    "codigo":402158009,
    "descripcion":"DERMATOSIS DEBIDA A INFESTACIÓN DE ÁCAROS EN PRODUCTO ALMACENADO"
  },
  {
    "codigo":236483001,
    "descripcion":"ESCAPE DE ORINA DEL RIÑÓN"
  },
  {
    "codigo":302019003,
    "descripcion":"FACIES DEL HIPOPITUITARISMO"
  },
  {
    "codigo":203715007,
    "descripcion":"ESTENOSIS DE DISCO INTERVERTEBRAL Y DEL TEJIDO CONJUNTIVO DE LOS AGUJEROS INTERVERTEBRALES"
  },
  {
    "codigo":365720000,
    "descripcion":"NIVEL DE INMUNOGLOBULINA - HALLAZGO"
  },
  {
    "codigo":431256002,
    "descripcion":"ENTEROCOCCUS RESISTENTE A VANCOMICINA AISLADO EN CULTIVO"
  },
  {
    "codigo":1217688006,
    "descripcion":"LEUCOMA CONGÉNITO DE CÓRNEA"
  },
  {
    "codigo":300184007,
    "descripcion":"MASTOIDES - HALLAZGO"
  },
  {
    "codigo":298349001,
    "descripcion":"TUMEFACCIÓN DE PARTES BLANDAS"
  },
  {
    "codigo":167277001,
    "descripcion":"PRUEBA DE PROTEÍNAS EN ORINA = +++"
  },
  {
    "codigo":11892291000119107,
    "descripcion":"QUERATITIS ULCERATIVA PERIFÉRICA DE OJO IZQUIERDO"
  },
  {
    "codigo":296514000,
    "descripcion":"SOBREDOSIS DE ANTÍDOTO"
  },
  {
    "codigo":429421009,
    "descripcion":"LESIÓN TRAUMÁTICA DE ARTERIA DE LA MANO"
  },
  {
    "codigo":1345090002,
    "descripcion":"SÍNDROME DE ABSTINENCIA DE HORMONA ESTEROIDE POSTERIOR A PATRÓN DE USO NOCIVO"
  },
  {
    "codigo":165442002,
    "descripcion":"HEMOGLOBINA CORPUSCULAR MEDIA FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":427586006,
    "descripcion":"OPRESIÓN CEFÁLICA"
  },
  {
    "codigo":818967003,
    "descripcion":"MEDULOEPITELIOMA DE SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":294679007,
    "descripcion":"ALERGIA A HIDROCORTISONA"
  },
  {
    "codigo":1144812004,
    "descripcion":"INGESTA INADECUADA DE VITAMINA B6 Y\/O DERIVADO DE VITAMINA B6"
  },
  {
    "codigo":292844007,
    "descripcion":"REACCIÓN ADVERSA AL ACICLOVIR"
  },
  {
    "codigo":225473001,
    "descripcion":"SIENTE QUE TODO ES INÚTIL"
  },
  {
    "codigo":1208513005,
    "descripcion":"ATAXIA ESPINOCEREBELOSA TIPO 42"
  },
  {
    "codigo":192705005,
    "descripcion":"ENCEFALITIS POSVACUNACIÓN CON BCG"
  },
  {
    "codigo":782529008,
    "descripcion":"ALERGIA A GLUCÓSIDO DIGITÁLICO"
  },
  {
    "codigo":127169009,
    "descripcion":"LINFADENOPATÍA ILÍACA EXTERNA LATERAL"
  },
  {
    "codigo":289174003,
    "descripcion":"HIPERESTESIA DE SENTIDOS ESPECIALES"
  },
  {
    "codigo":92566008,
    "descripcion":"CARCINOMA IN SITU DEL CUERPO CILIAR"
  },
  {
    "codigo":59798009,
    "descripcion":"TRASTORNO SENSITIVO DEL NERVIO VAGO"
  },
  {
    "codigo":90731001,
    "descripcion":"ASINCLITISMO POSTERIOR"
  },
  {
    "codigo":1237611003,
    "descripcion":"VENA VARICOSA DE MUSLO"
  },
  {
    "codigo":288631000119104,
    "descripcion":"DEMENCIA VASCULAR CON ALTERACIÓN DE LA CONDUCTA"
  },
  {
    "codigo":57963005,
    "descripcion":"ÚLCERA DE CONDUCTO DEFERENTE"
  },
  {
    "codigo":285504004,
    "descripcion":"NO SACA LA LENGUA"
  },
  {
    "codigo":29351000175109,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN DE REGIÓN SACRA DE ESPALDA GRADO 3"
  },
  {
    "codigo":56128006,
    "descripcion":"FRACTURA EXPUESTA DE HUESOS DE TARSO Y METATARSO"
  },
  {
    "codigo":1268544009,
    "descripcion":"CARCINOMA PRIMARIO DE VESÍCULA BILIAR Y VÍA BILIAR EXTRAHEPÁTICA"
  },
  {
    "codigo":185365002,
    "descripcion":"DERIVADO POR ASISTENTE SOCIAL"
  },
  {
    "codigo":283669004,
    "descripcion":"HERIDA POR PINCHAZO DE CLAVO EN LA CADERA"
  },
  {
    "codigo":1081361000119102,
    "descripcion":"OSTEOSARCOMA PRIMARIO DE OMÓPLATO DERECHO"
  },
  {
    "codigo":249066001,
    "descripcion":"SITUACIÓN INCIERTA"
  },
  {
    "codigo":19690006,
    "descripcion":"INFESTACIÓN CAUSADA POR PHTHIRUS"
  },
  {
    "codigo":871658007,
    "descripcion":"ABERTURA DE DEFECTO DEL TABIQUE VENTRICULAR MUSCULAR HACIA ENTRADA DE VENTRÍCULO DERECHO"
  },
  {
    "codigo":314602009,
    "descripcion":"ESTENOSIS DE ANASTOMOSIS ENTEROBILIAR"
  },
  {
    "codigo":1230271002,
    "descripcion":"DEFORMIDAD CONGÉNITA DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":609514009,
    "descripcion":"ABORTO INDUCIDO COMPLICADO POR DAÑO VAGINAL"
  },
  {
    "codigo":247231003,
    "descripcion":"PAPILA ÓPTICA - LATIDO VENOSO SÓLO A LA PRESIÓN"
  },
  {
    "codigo":344081000119104,
    "descripcion":"AMBLIOPÍA REFRACTARIA BILATERAL"
  },
  {
    "codigo":704148002,
    "descripcion":"FRACTURA EXPUESTA DE FALANGE PROXIMAL DE DEDO ÍNDICE"
  },
  {
    "codigo":48788004,
    "descripcion":"TROMBOCITOPENIA CÍCLICA"
  },
  {
    "codigo":15745041000119107,
    "descripcion":"INESTABILIDAD CRÓNICA BILATERAL DE RODILLAS"
  },
  {
    "codigo":702313004,
    "descripcion":"SÍNDROME DE TETRAAMELIA"
  },
  {
    "codigo":1259369004,
    "descripcion":"CARCINOMA PRIMARIO DE CÉLULAS GIGANTES DE PULMÓN"
  },
  {
    "codigo":208958000,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA EXPUESTA DE LA ARTICULACIÓN FEMORORROTULIANA, INTERNA"
  },
  {
    "codigo":767849009,
    "descripcion":"QUISTE ÓSEO DE PIE"
  },
  {
    "codigo":733246004,
    "descripcion":"MORDEDURA ABIERTA DE MUÑECA"
  },
  {
    "codigo":405566004,
    "descripcion":"HIPONATREMIA PARANEOPLÁSICA"
  },
  {
    "codigo":403731002,
    "descripcion":"TRASTORNO DE PIEL CAUSADO POR RADIACIÓN"
  },
  {
    "codigo":239891002,
    "descripcion":"LUPUS ERITEMATOSO CUTÁNEO SUBAGUDO"
  },
  {
    "codigo":43491000087102,
    "descripcion":"HERIDA ABIERTA DE PÁRPADO SUPERIOR DERECHO"
  },
  {
    "codigo":40931000087103,
    "descripcion":"QUEMADURA DE EXTREMIDAD INFERIOR IZQUIERDA"
  },
  {
    "codigo":895251007,
    "descripcion":"FORMA TRIANGULAR ANORMAL CONGÉNITA DE FALANGE DISTAL DE DEDO MEDIO"
  },
  {
    "codigo":205288000,
    "descripcion":"DUPLICACIÓN DE TODA LA MANO"
  },
  {
    "codigo":762344002,
    "descripcion":"TRASTORNO DEL ESTADO DE ÁNIMO CON SÍNTOMAS MANÍACOS CAUSADO POR FÁRMACO DISOCIATIVO"
  },
  {
    "codigo":238056003,
    "descripcion":"COPROPORFIRIA HEREDITARIA HOMOCIGOTA"
  },
  {
    "codigo":76051007,
    "descripcion":"INFECCIÓN CAUSADA POR ENTODINIUM"
  },
  {
    "codigo":38371000087103,
    "descripcion":"HIPOCINESIA DE SEGMENTO MEDIO INFERIOR DE VENTRÍCULO CARDÍACO IZQUIERDO"
  },
  {
    "codigo":821000172102,
    "descripcion":"DUELO POR PÉRDIDA DE AMIGO"
  },
  {
    "codigo":46051000087106,
    "descripcion":"ESGUINCE DE LIGAMENTO ILIOFEMORAL IZQUIERDO"
  },
  {
    "codigo":299922000,
    "descripcion":"DISCRIMINACIÓN TÁCTIL: AUSENTE"
  },
  {
    "codigo":301757009,
    "descripcion":"FRACTURA - LUXACIÓN CENTRAL DEL ACETÁBULO"
  },
  {
    "codigo":365458002,
    "descripcion":"HALLAZGO EN EL NIVEL DE EDUCACIÓN Y\/O INSTRUCCIÓN"
  },
  {
    "codigo":70546001,
    "descripcion":"TRASTORNO BIPOLAR GRAVE CON SÍNTOMAS PSICÓTICOS, CONGRUENTE CON EL ESTADO DE ÁNIMO"
  },
  {
    "codigo":758674005,
    "descripcion":"ESPUTO DESLIGADO"
  },
  {
    "codigo":725906006,
    "descripcion":"DISCAPACIDAD INTELECTUAL TIPO BUENOS AIRES"
  },
  {
    "codigo":234386008,
    "descripcion":"RASGO DE HEMOGLOBINA CONSTANT SPRING"
  },
  {
    "codigo":298087003,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE TÓRAX"
  },
  {
    "codigo":34108001,
    "descripcion":"POSICIÓN ENROLLADA"
  },
  {
    "codigo":724071009,
    "descripcion":"HIPOPLASIA CONGÉNITA DE RÓTULA"
  },
  {
    "codigo":230716006,
    "descripcion":"ATAQUE ISQUÉMICO TRANSITORIO DE TERRITORIO DE ARTERIA CARÓTIDA"
  },
  {
    "codigo":66876008,
    "descripcion":"ENFERMEDAD DE CADENA LIVIANA LAMBDA"
  },
  {
    "codigo":1290821000000106,
    "descripcion":"QUERATOPATÍA CAUSADA POR VIRUS DE VIRUELA SÍMICA"
  },
  {
    "codigo":294417008,
    "descripcion":"ALERGIA A TRICLOSÁN"
  },
  {
    "codigo":720401009,
    "descripcion":"SÍNDROME DE FIBROSIS QUÍSTICA CON GASTRITIS Y ANEMIA MEGALOBLÁSTICA"
  },
  {
    "codigo":346591000119103,
    "descripcion":"CONJUNTIVOCALASIA DE AMBOS OJOS"
  },
  {
    "codigo":1275622007,
    "descripcion":"MÚLTIPLES LESIONES DE RETINA DE OJO DERECHO SIN DESPRENDIMIENTO"
  },
  {
    "codigo":390886008,
    "descripcion":"VELOCIDAD DE FLUJO ESPIRATORIO PICO - DISTENSIBILIDAD MODERADA"
  },
  {
    "codigo":94139001,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL VESTÍBULO DE LA NARIZ"
  },
  {
    "codigo":126907002,
    "descripcion":"NEOPLASIA DE LOS ÓRGANOS GENITALES FEMENINOS"
  },
  {
    "codigo":290747002,
    "descripcion":"INTOXICACIÓN POR ANTAGONISTA ESTROGÉNICO"
  },
  {
    "codigo":15911391000119104,
    "descripcion":"RETINOPATÍA DE OJO DERECHO CAUSADA POR TALCO"
  },
  {
    "codigo":1306555005,
    "descripcion":"CARCINOMA DUCTAL INFILTRANTE DE PROLONGACIÓN AXILAR DE MAMA"
  },
  {
    "codigo":26768000,
    "descripcion":"INTOXICACIÓN POR TIROGLOBULINA"
  },
  {
    "codigo":15993311000119106,
    "descripcion":"IRITIS DE OJO DERECHO POR SÍFILIS SECUNDARIA"
  },
  {
    "codigo":92304007,
    "descripcion":"NEOPLASIA BENIGNA DE LA PARED POSTERIOR DE LA OROFARINGE"
  },
  {
    "codigo":287077002,
    "descripcion":"CONSOLIDACIÓN DEFECTUOSA DE FRACTURA - PIERNA"
  },
  {
    "codigo":90469005,
    "descripcion":"NO SE IDENTIFICA TEJIDO ORGANOIDE"
  },
  {
    "codigo":1237349008,
    "descripcion":"SÍNDROME DE HIDROPESÍA, ACIDOSIS LÁCTICA, ANEMIA SIDEROBLÁSTICA Y FALLO MULTIORGÁNICO"
  },
  {
    "codigo":55866002,
    "descripcion":"INFECCIÓN CAUSADA POR SPIROCERCA LUPI"
  },
  {
    "codigo":449082003,
    "descripcion":"SEPSIS CAUSADA POR BACTERIAS GRAMNEGATIVAS"
  },
  {
    "codigo":840463001,
    "descripcion":"DERMATOSIS CAUSADA POR CENTÍPEDO"
  },
  {
    "codigo":285242009,
    "descripcion":"BRADIFRENIA"
  },
  {
    "codigo":21263006,
    "descripcion":"COMA HIPOTIROIDEO"
  },
  {
    "codigo":283407006,
    "descripcion":"CORTE EN EL CUELLO"
  },
  {
    "codigo":86799007,
    "descripcion":"INTOXICACIÓN POR LABURNUM ANAGYROIDES"
  },
  {
    "codigo":414479006,
    "descripcion":"VISCOSIDAD SANGUÍNEA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":248804005,
    "descripcion":"MAMA PTÓSICA"
  },
  {
    "codigo":17593008,
    "descripcion":"ÚLCERA GÁSTRICA CON HEMORRAGIA, PERFORACIÓN Y OBSTRUCCIÓN"
  },
  {
    "codigo":277902000,
    "descripcion":"ESPUTO VISCOSO"
  },
  {
    "codigo":15758002,
    "descripcion":"TRASTORNO DE LAS MENINGES"
  },
  {
    "codigo":441742003,
    "descripcion":"HALLAZGO RELACIONADO CON UNA EVALUACIÓN"
  },
  {
    "codigo":1230009008,
    "descripcion":"ADENOMA SERRADO SÉSIL DE COLON"
  },
  {
    "codigo":1162638008,
    "descripcion":"FIBROLIPOMA DE REGIÓN INFRACLAVICULAR"
  },
  {
    "codigo":79459002,
    "descripcion":"SÍNDROME DEL GATO DE CHESHIRE"
  },
  {
    "codigo":276067004,
    "descripcion":"TRABAJADOR DE TURNO ROTATIVO"
  },
  {
    "codigo":13923006,
    "descripcion":"NECROSIS HEPÁTICA CENTROLOBULILLAR"
  },
  {
    "codigo":77624000,
    "descripcion":"HIPERVOLEMIA POR RETENCIÓN RENAL PRIMARIA DE SODIO"
  },
  {
    "codigo":865891008,
    "descripcion":"OBSTRUCCIÓN DE FARINGE CAUSADA POR CUERPO EXTRAÑO"
  },
  {
    "codigo":307000000,
    "descripcion":"ESTRECHEZ DE CONDUCTO HEPÁTICO"
  },
  {
    "codigo":700216002,
    "descripcion":"ATENDIDO POR PSICÓLOGO INFANTOJUVENIL"
  },
  {
    "codigo":208696001,
    "descripcion":"FRACTURA EXPUESTA DEL ASTRÁGALO, CABEZA"
  },
  {
    "codigo":12088005,
    "descripcion":"ENFERMEDAD DE LOS CRIADORES DE PERIQUITO AUSTRALIANO"
  },
  {
    "codigo":75789001,
    "descripcion":"ONICÓLISIS"
  },
  {
    "codigo":43021004,
    "descripcion":"VERRUGA PERIUNGUEAL"
  },
  {
    "codigo":403469006,
    "descripcion":"GANGRENA DEL PENE"
  },
  {
    "codigo":1086381000119102,
    "descripcion":"PERFORACIÓN DE COLON SIGMOIDE DEBIDA A DIVERTICULITIS"
  },
  {
    "codigo":1222669009,
    "descripcion":"LINFEDEMA PRIMARIO CONGÉNITO DE GORDON"
  },
  {
    "codigo":237794005,
    "descripcion":"HIPERTRICOSIS NO ANDROGÉNICA"
  },
  {
    "codigo":205026007,
    "descripcion":"EPISPADIAS FEMENINO"
  },
  {
    "codigo":301495000,
    "descripcion":"DIFICULTAD PARA SUBIR Y BAJAR DEL CORDÓN DE LA ACERA"
  },
  {
    "codigo":235959006,
    "descripcion":"NECROSIS PANCREÁTICA Y PERIPANCREÁTICA"
  },
  {
    "codigo":135820002,
    "descripcion":"INCERTIDUMBRE ACERCA DEL ESTADO GENERAL DE SALUD"
  },
  {
    "codigo":234124003,
    "descripcion":"MALFORMACIÓN VENOSA"
  },
  {
    "codigo":365196005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA REALIZAR ACTIVIDADES DE CUIDADO DEL PELO"
  },
  {
    "codigo":35681000,
    "descripcion":"ÚLCERA PÉPTICA AGUDA CON PERFORACIÓN Y OBSTRUCCIÓN"
  },
  {
    "codigo":232289002,
    "descripcion":"MAREO MULTISENSORIAL"
  },
  {
    "codigo":68449006,
    "descripcion":"COXITIS"
  },
  {
    "codigo":721974000,
    "descripcion":"SÍNDROME DE LOWRY MACLEAN"
  },
  {
    "codigo":164918000,
    "descripcion":"ONDA Q PATOLÓGICA"
  },
  {
    "codigo":21421000119109,
    "descripcion":"TAQUICARDIA VENTRICULAR PAROXÍSTICA NO SOSTENIDA"
  },
  {
    "codigo":263222005,
    "descripcion":"FRACTURAS PÉLVICAS MÚLTIPLES"
  },
  {
    "codigo":197686005,
    "descripcion":"SÍNDROME NEFRÍTICO AGUDO, GLOMERULONEFRITIS MESANGIOCAPILAR DIFUSA"
  },
  {
    "codigo":230454005,
    "descripcion":"EPILEPSIA HIDRÓGENA"
  },
  {
    "codigo":425227004,
    "descripcion":"OBSTRUCCIÓN DE VÍA AÉREA CAUSADA POR LENGUA"
  },
  {
    "codigo":64779008,
    "descripcion":"TRASTORNO DE LA COAGULACIÓN SANGUÍNEA"
  },
  {
    "codigo":292320000,
    "descripcion":"REACCIÓN ADVERSA A BARBITÚRICO ANTIEPILÉPTICO"
  },
  {
    "codigo":95712005,
    "descripcion":"ENTROPIÓN DE LA ÚVEA"
  },
  {
    "codigo":716469001,
    "descripcion":"CAPAZ DE UTILIZAR UNA CONSOLA DE JUEGOS"
  },
  {
    "codigo":194016009,
    "descripcion":"EXOFTALMÍA POR HEMORRAGIA ORBITARIA"
  },
  {
    "codigo":126645003,
    "descripcion":"NEOPLASIA DE LA REGIÓN INGUINAL"
  },
  {
    "codigo":1306293004,
    "descripcion":"CARCINOMA PRIMARIO DE MAMA"
  },
  {
    "codigo":255155005,
    "descripcion":"ADENOMA PLEOMÓRFICO DE LA GLÁNDULA PARÓTIDA"
  },
  {
    "codigo":224949008,
    "descripcion":"TIRARSE DELANTE DE UN TREN"
  },
  {
    "codigo":288650007,
    "descripcion":"DIFICULTAD PARA ELEGIR TEMAS DE CONVERSACIÓN"
  },
  {
    "codigo":714634009,
    "descripcion":"ENFERMEDAD GINGIVAL DEBIDA A QUEMADURA QUÍMICA"
  },
  {
    "codigo":92042009,
    "descripcion":"NEOPLASIA BENIGNA DEL CARDIAS DEL ESTÓMAGO"
  },
  {
    "codigo":188511002,
    "descripcion":"LINFOMA DE BURKITT DE GANGLIOS LINFÁTICOS INTRATORÁCICOS"
  },
  {
    "codigo":286815005,
    "descripcion":"RASGO DE LA PERSONALIDAD: ORDEN - HALLAZGO"
  },
  {
    "codigo":254047006,
    "descripcion":"ESPONDILODISPLASIA, TIPO TORRANCE"
  },
  {
    "codigo":90207007,
    "descripcion":"BRUXISMO"
  },
  {
    "codigo":874804000,
    "descripcion":"CONTUSIÓN DE CABEZA Y\/O CUELLO"
  },
  {
    "codigo":448820003,
    "descripcion":"VALVA DE VÁLVULA MITRAL ENGROSADA"
  },
  {
    "codigo":21001001,
    "descripcion":"DÉJÀ PENSÉ"
  },
  {
    "codigo":283145002,
    "descripcion":"ANZUELO EN LA NARIZ"
  },
  {
    "codigo":446985003,
    "descripcion":"VERRUGA VULGAR DE PIEL DE MEJILLA"
  },
  {
    "codigo":351611000119101,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE RIÑÓN DERECHO"
  },
  {
    "codigo":284980009,
    "descripcion":"INCAPAZ DE CALZARSE"
  },
  {
    "codigo":1231582003,
    "descripcion":"OBSTRUCCIÓN DE LUZ DE VÍA RESPIRATORIA CAUSADA POR INHALACIÓN DE FRUTO SECO"
  },
  {
    "codigo":445150007,
    "descripcion":"SUPERVIVENCIA SIN RECURRENCIA DE ENFERMEDAD NEOPLÁSICA"
  },
  {
    "codigo":838366009,
    "descripcion":"SÍNDROME ANTI-SINTETASA DEBIDO A DERMATOMIOSITIS"
  },
  {
    "codigo":23931000119104,
    "descripcion":"HIDROCEFALIA DEBIDA A MALFORMACIÓN DE ARNOLD CHIARI TIPO 2"
  },
  {
    "codigo":1073021000119100,
    "descripcion":"ARTRITIS ESTAFILOCÓCICA DE PIE DERECHO"
  },
  {
    "codigo":754097021000119101,
    "descripcion":"PORTADOR DE SÍNDROME DE JOUBERT CON DEFECTO OCULORRENAL"
  },
  {
    "codigo":1085821000119102,
    "descripcion":"FÍSTULA DE INTESTINO DEBIDA A ENFERMEDAD DE CROHN DE INTESTINO DELGADO Y GRUESO"
  },
  {
    "codigo":10752381000119101,
    "descripcion":"TROMBOCITOPENIA FETAL"
  },
  {
    "codigo":410547008,
    "descripcion":"HALLAZGO RELACIONADO CON LA COMUNICACIÓN DE LOS ANTECEDENTES MÉDICOS PERSONALES"
  },
  {
    "codigo":15931261000119105,
    "descripcion":"QUISTE EMBRIONARIO DE OVARIO DERECHO"
  },
  {
    "codigo":5501000119106,
    "descripcion":"HIPERTENSIÓN POSPERATORIA"
  },
  {
    "codigo":720261501000119107,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DEBIDO A OCLUSIÓN DE AMBAS ARTERIAS CEREBRALES ANTERIORES"
  },
  {
    "codigo":79741000119108,
    "descripcion":"ARTROPATÍA DE ARTICULACIÓN CIGOAPOFISARIA VERTEBRAL CONCOMITANTE CON DERRAME ARTICULAR Y DEBIDA A ÉL"
  },
  {
    "codigo":1080701000119109,
    "descripcion":"LIPOSARCOMA PRIMARIO DE PARTES BLANDAS DE EXTREMIDAD INFERIOR IZQUIERDA"
  },
  {
    "codigo":381000119107,
    "descripcion":"TRASTORNO DE DOLOR CON FACTOR PSICOLÓGICO"
  },
  {
    "codigo":769160007,
    "descripcion":"EXCESO DE PARTE POSTERIOR DE CRESTA ALVEOLAR INFERIOR"
  },
  {
    "codigo":16819581000119103,
    "descripcion":"RUPTURA TRAUMÁTICA DE FASCIA PLANTAR DE PIE DERECHO"
  },
  {
    "codigo":130941000119107,
    "descripcion":"CORDOMA PRIMARIO DE HUESO DE CRÁNEO"
  },
  {
    "codigo":340861000119109,
    "descripcion":"EPIESCLERITIS DE OJO IZQUIERDO"
  },
  {
    "codigo":703624003,
    "descripcion":"PSEUDOARTROSIS DE ARTICULACIÓN DEL PIE SIN INFECCIÓN"
  },
  {
    "codigo":11817341000119107,
    "descripcion":"ESGUINCE DE LIGAMENTO DE ARTICULACIÓN CARPOMETACARPIANA DE MANO DERECHA"
  },
  {
    "codigo":320381000119108,
    "descripcion":"ARTROSIS SECUNDARIA DE CODO DERECHO"
  },
  {
    "codigo":1075581000119109,
    "descripcion":"INESTABILIDAD DE ARTICULACIÓN FEMORORROTULIANA IZQUIERDA"
  },
  {
    "codigo":275805003,
    "descripcion":"CAMBIOS VIRALES EN EL EXTENDIDO CERVICAL"
  },
  {
    "codigo":699954000,
    "descripcion":"ABSCESO DE TENDÓN DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":11820411000119107,
    "descripcion":"SUBLUXACIÓN DE ARTICULACIÓN GLENOHUMERAL IZQUIERDA"
  },
  {
    "codigo":44594002,
    "descripcion":"SIGNO DE BARANY"
  },
  {
    "codigo":243037008,
    "descripcion":"LESIÓN POR EXPLOSIÓN DE MINA MARINA"
  },
  {
    "codigo":110130004,
    "descripcion":"LACERACIÓN SIMPLE CONTAMINADA DEL PALADAR BLANDO"
  },
  {
    "codigo":11826005,
    "descripcion":"EFECTO TÓXICO DE LA CLOROACETOFENONA"
  },
  {
    "codigo":306738001,
    "descripcion":"VISTO POR CIRUJANO DENTAL GENERAL"
  },
  {
    "codigo":763655001,
    "descripcion":"PRÓTESIS DE ARTICULACIÓN DE HOMBRO PRESENTE"
  },
  {
    "codigo":77362009,
    "descripcion":"ASFIXIA NEONATAL DE LEVE A MODERADA"
  },
  {
    "codigo":208434009,
    "descripcion":"FRACTURA NO EXPUESTA DE FALANGE PROXIMAL DEL PULGAR"
  },
  {
    "codigo":9991008,
    "descripcion":"CÓLICO ABDOMINAL"
  },
  {
    "codigo":1255175009,
    "descripcion":"FRACTURA EXPUESTA CONMINUTA DE FALANGE DISTAL DE DEDO DE MANO"
  },
  {
    "codigo":403207008,
    "descripcion":"QUERATOSIS ACTÍNICAS MÚLTIPLES CON COMPROMISO DE MIEMBROS INFERIORES"
  },
  {
    "codigo":15971861000119106,
    "descripcion":"HERNIA INGUINAL IZQUIERDA INDIRECTA"
  },
  {
    "codigo":73692007,
    "descripcion":"DERMATITIS MEDICAMENTOSA FIJA"
  },
  {
    "codigo":1251505006,
    "descripcion":"RUPTURA TRAUMÁTICA DE TENDÓN DE MÚSCULO ADUCTOR DE ARTICULACIÓN DE CADERA"
  },
  {
    "codigo":364934000,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA TRASLADARSE EN SILLA DE RUEDAS"
  },
  {
    "codigo":299398003,
    "descripcion":"PRUEBA DEL CAJÓN POSTERIOR NEGATIVA"
  },
  {
    "codigo":397702004,
    "descripcion":"PUNTAJE DE DISNEA DE BORG, HALLAZGO"
  },
  {
    "codigo":233862006,
    "descripcion":"ESTENOSIS AÓRTICA CALCIFICADA - VÁLVULA BICÚSPIDE"
  },
  {
    "codigo":168326009,
    "descripcion":"ORGANISMO NO AISLADO EN CULTIVO DE HISOPADO ANAL"
  },
  {
    "codigo":2651006,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN DE CODO"
  },
  {
    "codigo":232027007,
    "descripcion":"QUEMADURA DE LA RETINA POR FOTOCOAGULACIÓN"
  },
  {
    "codigo":428635007,
    "descripcion":"ENCEFALITIS VIRAL PRIMARIA"
  },
  {
    "codigo":262960001,
    "descripcion":"LESIÓN POR TRACCIÓN DE NERVIO CRANEAL"
  },
  {
    "codigo":461403009,
    "descripcion":"LIGAMENTO ARTERIOSO EN POSICIÓN NORMAL EN EL LADO IZQUIERDO"
  },
  {
    "codigo":230192003,
    "descripcion":"ENCEFALITIS LÍMBICA"
  },
  {
    "codigo":426800001,
    "descripcion":"GRANULOCITOPENIA FEBRIL"
  },
  {
    "codigo":361264003,
    "descripcion":"FÍSTULA ARTERIOVENOSA CONGÉNITA DE RIÑÓN"
  },
  {
    "codigo":721712002,
    "descripcion":"HEPATITIS AUTOINMUNITARIA, TIPO 2"
  },
  {
    "codigo":295728003,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE ETOPÓSIDO"
  },
  {
    "codigo":33584003,
    "descripcion":"EXCICLOTROPÍA"
  },
  {
    "codigo":816009,
    "descripcion":"RECOMBINACIÓN GENÉTICA"
  },
  {
    "codigo":228357007,
    "descripcion":"EFECTO PERSISTENTE DEL ALCOHOL"
  },
  {
    "codigo":29914000,
    "descripcion":"DEFICIENCIA DE DIHIDROLIPOAMIDA DESHIDROGENASA"
  },
  {
    "codigo":423130001,
    "descripcion":"CANTIDAD EXCESIVA DE MASCOTAS"
  },
  {
    "codigo":128218002,
    "descripcion":"TRASTORNO DE SENO VENOSO INTRACRANEAL"
  },
  {
    "codigo":95450003,
    "descripcion":"TROMBOFLEBITIS DE LAS EXTREMIDADES SUPERIORES"
  },
  {
    "codigo":293893009,
    "descripcion":"ALERGIA A BROMAZEPAM"
  },
  {
    "codigo":292058005,
    "descripcion":"REACCIÓN ADVERSA A LA NALBUFINA"
  },
  {
    "codigo":62682007,
    "descripcion":"DIETA CON 50 GRAMOS DE GRASA"
  },
  {
    "codigo":880047000,
    "descripcion":"ESTENOSIS ADQUIRIDA DE ESTRUCTURA VENTRICULAR IZQUIERDA DE LA VÁLVULA AURICULOVENTRICULAR COMÚN POSTERIOR A REPARACIÓN DE COMUNICACIÓN BIVENTRICULAR"
  },
  {
    "codigo":93615001,
    "descripcion":"COSTILLA INTERCOSTAL"
  },
  {
    "codigo":191919001,
    "descripcion":"PATRÓN DE USO EPISÓDICO NOCIVO SIN DEPENDENCIA DE COCAÍNA"
  },
  {
    "codigo":28079008,
    "descripcion":"MULTÍPARA"
  },
  {
    "codigo":1091401000119105,
    "descripcion":"LESIÓN DE CONDUCTO AUDITIVO EXTERNO DERECHO"
  },
  {
    "codigo":288388001,
    "descripcion":"CAPAZ DE RETORCER ROPA"
  },
  {
    "codigo":11822921000119105,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE BRAZO DERECHO"
  },
  {
    "codigo":714372007,
    "descripcion":"CAPAZ DE ADAPTARSE A SITUACIÓN LABORAL"
  },
  {
    "codigo":386692008,
    "descripcion":"MENORRAGIA"
  },
  {
    "codigo":778073001,
    "descripcion":"SÍNDROME DE MICRODUPLICACIÓN 3Q26"
  },
  {
    "codigo":253785008,
    "descripcion":"DISMOTILIDAD INTESTINAL CONGÉNITA GENERALIZADA"
  },
  {
    "codigo":55342001,
    "descripcion":"ENFERMEDAD NEOPLÁSICA"
  },
  {
    "codigo":712537009,
    "descripcion":"SÍNDROME DE DOLOR REGIONAL COMPLEJO DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":22574000,
    "descripcion":"TRASTORNO DEL SUEÑO INDUCIDO POR COCAÍNA"
  },
  {
    "codigo":186414001,
    "descripcion":"GANGRENA GASEOSA DE CUELLO"
  },
  {
    "codigo":88110005,
    "descripcion":"ENFERMEDAD CAUSADA POR BIRNAVIRUS"
  },
  {
    "codigo":448558006,
    "descripcion":"NEOPLASIA MALIGNA DE HUESO MAXILOFACIAL"
  },
  {
    "codigo":250115006,
    "descripcion":"CREPITACIÓN ARTICULAR PALPABLE"
  },
  {
    "codigo":282883006,
    "descripcion":"INCAPAZ DE PARARSE DESDE POSICIÓN SENTADA"
  },
  {
    "codigo":444888000,
    "descripcion":"REDUCCIÓN TRANSITORIA DE LA CIRCULACIÓN PERIFÉRICA COMO UN TODO"
  },
  {
    "codigo":1264088001,
    "descripcion":"TRASTORNO NEONATAL CAUSADO POR AGENTE MEDICINAL TRANSMITIDO POR LECHE MATERNA"
  },
  {
    "codigo":248280005,
    "descripcion":"ENVEJECIMIENTO"
  },
  {
    "codigo":211842001,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO PROFUNDA DE CODO"
  },
  {
    "codigo":768898002,
    "descripcion":"FÍSICAMENTE PREPARADO PARA SOMETERSE A UN PROCEDIMIENTO"
  },
  {
    "codigo":80770009,
    "descripcion":"SÍFILIS SECUNDARIA DEL HÍGADO"
  },
  {
    "codigo":111703006,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE CARA CON INFECCIÓN"
  },
  {
    "codigo":13399007,
    "descripcion":"VÍCTIMA DURANTE ACTIVIDADES DEPORTIVAS"
  },
  {
    "codigo":44332000,
    "descripcion":"SÍNDROME DE MALABSORCIÓN DE ÁCIDOS BILIARES"
  },
  {
    "codigo":406615007,
    "descripcion":"INFECCIÓN CAUSADA POR STAPHYLOCOCCUS AUREUS RESISTENTE A VANCOMICINA, COAGULASA POSITIVO"
  },
  {
    "codigo":372012002,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE PARTES BLANDAS DE LA EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":109868003,
    "descripcion":"APÉNDICE HIMENAL"
  },
  {
    "codigo":271873000,
    "descripcion":"SENILIDAD"
  },
  {
    "codigo":42497006,
    "descripcion":"SECRECIÓN HORMONAL DISMINUIDA"
  },
  {
    "codigo":1187542000,
    "descripcion":"DEFICIENCIA DE CADENA ALFA DE FLAVOPROTEÍNA DE TRANSFERENCIA DE ELECTRONES"
  },
  {
    "codigo":402945009,
    "descripcion":"CONDILOMAS PLANOS SIFILÍTICOS DEL PENE"
  },
  {
    "codigo":73430006,
    "descripcion":"APNEA DEL SUEÑO"
  },
  {
    "codigo":106198007,
    "descripcion":"REACCIÓN A UN INJERTO Y\/O REACCIÓN AUTOINMUNITARIA"
  },
  {
    "codigo":237270006,
    "descripcion":"HEMORRAGIA PREPARTO CON HIPOFIBRINOGENEMIA"
  },
  {
    "codigo":38827001,
    "descripcion":"FUSIÓN CONGÉNITA DE LA COLUMNA VERTEBRAL"
  },
  {
    "codigo":432043003,
    "descripcion":"ZONA DE TRANSFORMACIÓN DE CUELLO UTERINO VISIBLE"
  },
  {
    "codigo":169899005,
    "descripcion":"PUNTAJE DE APGAR AL MINUTO = 3"
  },
  {
    "codigo":202667005,
    "descripcion":"ESPONDILOSIS DORSAL EN DOS NIVELES SIN MIELOPATÍA"
  },
  {
    "codigo":725120000,
    "descripcion":"VASOCONSTRICCIÓN PERIFÉRICA"
  },
  {
    "codigo":366507008,
    "descripcion":"AMPLITUD DE FLEXIÓN ACTIVA DE CODO"
  },
  {
    "codigo":266368002,
    "descripcion":"FIBROSIS PULMONAR POSINFLAMATORIA"
  },
  {
    "codigo":233600003,
    "descripcion":"BRONQUITIS AGUDA POR CHLAMYDIA"
  },
  {
    "codigo":4224004,
    "descripcion":"COMPLICACIÓN DE PROCEDIMIENTO DE INFUSIÓN"
  },
  {
    "codigo":102528008,
    "descripcion":"EDAD MAYOR DE 65 AÑOS"
  },
  {
    "codigo":36992009,
    "descripcion":"SECRECIÓN HORMONAL INAPROPIADA"
  },
  {
    "codigo":299136009,
    "descripcion":"DEFORMIDAD DE ARTICULACIÓN DE PULGAR"
  },
  {
    "codigo":198997005,
    "descripcion":"PREECLAMPSIA O ECLAMPSIA CON HIPERTENSIÓN PREEXISTENTE"
  },
  {
    "codigo":262698003,
    "descripcion":"CONTUSIÓN DE MÉDULA ESPINAL DORSAL"
  },
  {
    "codigo":33322003,
    "descripcion":"DEFORMIDAD CONGÉNITA DE LA FRENTE"
  },
  {
    "codigo":554003,
    "descripcion":"SÍNDROME DE TRISOMÍA PARCIAL 2P"
  },
  {
    "codigo":295466004,
    "descripcion":"SOBREDOSIS INTENCIONAL DE SEN"
  },
  {
    "codigo":426538007,
    "descripcion":"ACELERACIÓN PROLONGADA DE LA FRECUENCIA CARDÍACA FETAL"
  },
  {
    "codigo":197162007,
    "descripcion":"ABSCESO ANORRECTAL SUBMUCOSO"
  },
  {
    "codigo":31487001,
    "descripcion":"HIPEROSTOSIS ESQUELÉTICA IDIOPÁTICA DISEMINADA"
  },
  {
    "codigo":721450009,
    "descripcion":"SÍNDROME DEL CORDÓN CENTRAL DE MÉDULA ESPINAL AL NIVEL DEL OCTAVO SEGMENTO DORSAL"
  },
  {
    "codigo":129791004,
    "descripcion":"MAMOGRAFÍA EN POSICIÓN AXILAR"
  },
  {
    "codigo":424703005,
    "descripcion":"VISIÓN A DISTANCIA 20\/30"
  },
  {
    "codigo":293631007,
    "descripcion":"ALERGIA A TENOXICAM"
  },
  {
    "codigo":291796000,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR CORTICOSTEROIDE FLUORADO"
  },
  {
    "codigo":195327007,
    "descripcion":"EMBOLIA Y TROMBOSIS DE ARTERIA TIBIAL POSTERIOR"
  },
  {
    "codigo":717780007,
    "descripcion":"LINFOCITOSIS MONOCLONAL DE CÉLULAS B"
  },
  {
    "codigo":95188007,
    "descripcion":"LINFOMA NODULAR DE LOS GANGLIOS LINFÁTICOS INTRATORÁCICOS"
  },
  {
    "codigo":422868009,
    "descripcion":"DESCENSO DE PESO INEXPLICABLE"
  },
  {
    "codigo":27817002,
    "descripcion":"LESIÓN TRAUMÁTICA INTERNA DEL TÓRAX"
  },
  {
    "codigo":93353003,
    "descripcion":"POSICIÓN ANÓMALA CONGÉNITA DE LA ARTERIA SUBCLAVIA"
  },
  {
    "codigo":160724009,
    "descripcion":"VIVIENDA INDEPENDIENTE, NO ESTÁ SOLO"
  },
  {
    "codigo":60585007,
    "descripcion":"VIVIR EN UN BARRIO CARENCIADO"
  },
  {
    "codigo":124286004,
    "descripcion":"DEFICIENCIA DE CISTEÍNA AMINOTRANSFERASA"
  },
  {
    "codigo":58750007,
    "descripcion":"PESTE"
  },
  {
    "codigo":187987001,
    "descripcion":"NEOPLASIA MALIGNA DE CARTÍLAGO AURICULAR"
  },
  {
    "codigo":253523001,
    "descripcion":"FIBROELASTOSIS ENDOCÁRDICA PRIMARIA DE VENTRÍCULO DERECHO"
  },
  {
    "codigo":286291007,
    "descripcion":"NO IMITA SONIDOS DEL HABLA"
  },
  {
    "codigo":24147008,
    "descripcion":"INFECCIÓN CAUSADA POR ASPERGILLUS FLAVUS"
  },
  {
    "codigo":22312005,
    "descripcion":"INFECCIÓN CAUSADA POR LEPTOSPIRA BATAVIAE"
  },
  {
    "codigo":448296006,
    "descripcion":"DERMATOFIBROSARCOMA PROTUBERANS DE PIEL DEL TÓRAX"
  },
  {
    "codigo":774141001,
    "descripcion":"INESTABILIDAD DE ARTICULACIÓN DEL HOMBRO IZQUIERDO"
  },
  {
    "codigo":315389002,
    "descripcion":"NACIDO EN BRASIL"
  },
  {
    "codigo":10871371000119108,
    "descripcion":"FIBROMA DE OVARIO DERECHO"
  },
  {
    "codigo":282621008,
    "descripcion":"INCAPAZ DE RODAR"
  },
  {
    "codigo":248018002,
    "descripcion":"DAÑO DOLOSO"
  },
  {
    "codigo":84178004,
    "descripcion":"EDEMA CONJUNTIVAL"
  },
  {
    "codigo":49575005,
    "descripcion":"DOLOR FULGURANTE"
  },
  {
    "codigo":47740000,
    "descripcion":"ASPECTO DE LA SUPERFICIE DE UNA COLONIA BACTERIANA, OPACA"
  },
  {
    "codigo":735868003,
    "descripcion":"HERIDA PUNZANTE CONCOMITANTE CON CUERPO EXTRAÑO DE PIE"
  },
  {
    "codigo":277116009,
    "descripcion":"ASIMETRÍA DE AMPLITUD INTEROCULAR"
  },
  {
    "codigo":209745003,
    "descripcion":"SECCIÓN EXPUESTA DE LIGAMENTO DE CARTÍLAGO COSTAL"
  },
  {
    "codigo":373585009,
    "descripcion":"OBSTRUCCIÓN CONGÉNITA URETEROVESICAL"
  },
  {
    "codigo":109606004,
    "descripcion":"ABSCESO RECIDIVANTE"
  },
  {
    "codigo":207910007,
    "descripcion":"FRACTURAS MÚLTIPLES NO EXPUESTAS DE VÉRTEBRAS CERVICALES"
  },
  {
    "codigo":240678008,
    "descripcion":"FRAMBESIA MICROPAPULAR"
  },
  {
    "codigo":1254651003,
    "descripcion":"SÍNDROME DE MICROCEFALIA, DISCAPACIDAD INTELECTUAL, HIPOACUSIA NEUROSENSORIAL, EPILEPSIA, TONO MUSCULAR ANÓMALO"
  },
  {
    "codigo":763131005,
    "descripcion":"ADENOCARCINOMA DE CÉLULAS CLARAS DE OVARIO"
  },
  {
    "codigo":238843006,
    "descripcion":"PANATROFIA LOCAL"
  },
  {
    "codigo":271611007,
    "descripcion":"CABEZA PEQUEÑA"
  },
  {
    "codigo":402683008,
    "descripcion":"DERMATOSIS PERFORADA"
  },
  {
    "codigo":9467007,
    "descripcion":"ARTRITIS CAUSADA POR NEISSERIA MENINGITIDIS"
  },
  {
    "codigo":7632005,
    "descripcion":"URTICARIA DERMATOGRÁFICA"
  },
  {
    "codigo":10900351000119106,
    "descripcion":"LACERACIÓN DE CÓRNEA DERECHA"
  },
  {
    "codigo":10955801000119100,
    "descripcion":"HERIDA PUNZANTE DE DEDO ANULAR DE MANO IZQUIERDA"
  },
  {
    "codigo":300709005,
    "descripcion":"UTILIZA TARJETA DE CRÉDITO"
  },
  {
    "codigo":169637008,
    "descripcion":"OFICIOS DE LOS PADRES - CLASES INDIVIDUALES"
  },
  {
    "codigo":202405009,
    "descripcion":"HEMARTROSIS DE CODO"
  },
  {
    "codigo":366245008,
    "descripcion":"HALLAZGO RELACIONADO CON EL ASPECTO DEL ENCHAPADO DENTAL"
  },
  {
    "codigo":15979391000119109,
    "descripcion":"COLESTEATOSIS DIFUSA DE AMBOS OÍDOS MEDIOS"
  },
  {
    "codigo":724858005,
    "descripcion":"EDEMA DE PARTES BLANDAS DEBIDO A AUMENTO DE LA PRESIÓN CAPILAR"
  },
  {
    "codigo":298874005,
    "descripcion":"DEFORMIDAD DE ARTICULACIÓN DE CODO"
  },
  {
    "codigo":36730005,
    "descripcion":"TEMBLOR ARSENICAL"
  },
  {
    "codigo":231503000,
    "descripcion":"ATAQUE DE PÁNICO NO SITUACIONAL"
  },
  {
    "codigo":428111003,
    "descripcion":"MELIOIDOSIS"
  },
  {
    "codigo":723023003,
    "descripcion":"RETINOSQUISIS DEL ADULTO"
  },
  {
    "codigo":297039006,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE MERSALILO"
  },
  {
    "codigo":721188000,
    "descripcion":"NEOPLASIA ENDOCRINA MÚLTIPLE TIPO 2A"
  },
  {
    "codigo":292003,
    "descripcion":"HALLAZGO EEG"
  },
  {
    "codigo":229668005,
    "descripcion":"DÉFICIT DEL ANÁLISIS ACÚSTICO"
  },
  {
    "codigo":63993003,
    "descripcion":"FIEBRE REMITENTE"
  },
  {
    "codigo":16745651000119101,
    "descripcion":"RETINOPATÍA NO PROLIFERATIVA LEVE DE OJO DERECHO DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":62158001,
    "descripcion":"ESTADO MARMÓREO"
  },
  {
    "codigo":94926001,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA MANDÍBULA"
  },
  {
    "codigo":193230001,
    "descripcion":"MIODISTROFIA DISTAL DE INICIO EN LA JUVENTUD"
  },
  {
    "codigo":289699001,
    "descripcion":"HALLAZGO RELACIONADO CON LAS CONTRACCIONES UTERINAS"
  },
  {
    "codigo":224163003,
    "descripcion":"MATRIMONIO RECIENTE"
  },
  {
    "codigo":93091007,
    "descripcion":"FÍSTULA CONGÉNITA DEL TRACTO INTESTINAL"
  },
  {
    "codigo":255096006,
    "descripcion":"NEOPLASIA MALIGNA DE DERMIS"
  },
  {
    "codigo":335181000119100,
    "descripcion":"QUISTE EXUDATIVO DE IRIS DE OJO DERECHO"
  },
  {
    "codigo":124024008,
    "descripcion":"ALFA>1< GLOBULINA DE ESTRUCTURA ANORMAL"
  },
  {
    "codigo":418936009,
    "descripcion":"ECTROPIÓN INTERNO"
  },
  {
    "codigo":187725002,
    "descripcion":"NEOPLASIA MALIGNA DE TERCIO SUPERIOR DE ESÓFAGO"
  },
  {
    "codigo":23885003,
    "descripcion":"INVERSIÓN DEL ÚTERO DURANTE EL PARTO"
  },
  {
    "codigo":89421003,
    "descripcion":"INFECCIÓN CAUSADA POR PNEUMOCAULUS"
  },
  {
    "codigo":449869005,
    "descripcion":"UTILIZA TABACO HÚMEDO DIARIAMENTE"
  },
  {
    "codigo":1269069006,
    "descripcion":"TRASTORNO FETAL DEBIDO A TRASTORNO DE PARTO MATERNO"
  },
  {
    "codigo":286029007,
    "descripcion":"DESCONECTA EL ENCHUFE"
  },
  {
    "codigo":56653005,
    "descripcion":"SÍNDROME DE MONOSOMÍA PARCIAL 18P"
  },
  {
    "codigo":284194009,
    "descripcion":"QUEMADURA DE ESTRUCTURA ENDOCRINA"
  },
  {
    "codigo":52983002,
    "descripcion":"QUERIÓN CAUSADO POR MICROSPORUM"
  },
  {
    "codigo":446199003,
    "descripcion":"DISTENSIÓN DE MÚSCULO SUPRAESPINOSO"
  },
  {
    "codigo":20215004,
    "descripcion":"INTOXICACIÓN POR CARBOFENOTIONA"
  },
  {
    "codigo":708343006,
    "descripcion":"CHASQUIDO DE ARTICULACIÓN TEMPOROMANDIBULAR DURANTE LA APERTURA"
  },
  {
    "codigo":249591006,
    "descripcion":"SOPLO SOBRE EL HÍGADO"
  },
  {
    "codigo":83916000,
    "descripcion":"TROMBOFLEBITIS EN EL PUERPERIO"
  },
  {
    "codigo":282359006,
    "descripcion":"DOLOR DE EPIDÍDIMO POSVASECTOMÍA"
  },
  {
    "codigo":213153001,
    "descripcion":"FALLA Y RECHAZO DEL TRASPLANTE HEPÁTICO"
  },
  {
    "codigo":870348009,
    "descripcion":"LINFADENOPATÍA REGIONAL CAUSADA POR BACILO DE CALMETTE-GUÉRIN"
  },
  {
    "codigo":409761004,
    "descripcion":"AUSENCIA DE NECROSIS HISTOLÓGICA LUEGO DE QUIMIOTERAPIA DE INDUCCIÓN"
  },
  {
    "codigo":1360033005,
    "descripcion":"CONDUCTO RADICULAR DE DIENTE CON FORMA DE TRABUCO"
  },
  {
    "codigo":16037351000119102,
    "descripcion":"DETENCIÓN DE CRECIMIENTO EPIFISARIO DE AMBAS PIERNAS"
  },
  {
    "codigo":276854003,
    "descripcion":"EDUCATIVAMENTE SUBNORMAL"
  },
  {
    "codigo":735606004,
    "descripcion":"DEGENERACIÓN DE DISCO INTERVERTEBRAL DORSAL SIN PROLAPSO"
  },
  {
    "codigo":473462005,
    "descripcion":"RECIBIÓ EDUCACIÓN EN LA PRIMERA INFANCIA"
  },
  {
    "codigo":211318009,
    "descripcion":"ABRASIÓN DE PIEL DE DEDO PULGAR"
  },
  {
    "codigo":209483003,
    "descripcion":"ESGUINCE DE DEDO DE LA MANO, ARTICULACIÓN INTERFALÁNGICA PROXIMAL, LIGAMENTO LATERAL RADIAL"
  },
  {
    "codigo":10630631000119104,
    "descripcion":"LINFANGITIS AGUDA DE DEDO DE MANO DERECHA"
  },
  {
    "codigo":1290827008,
    "descripcion":"LIPOSARCOMA BIEN DIFERENCIADO"
  },
  {
    "codigo":109344002,
    "descripcion":"SECUESTRO DE HUESO TEMPORAL"
  },
  {
    "codigo":43808007,
    "descripcion":"DILATACIÓN CERVICAL, 4CM"
  },
  {
    "codigo":240416008,
    "descripcion":"INFECCIÓN CUTÁNEA POR MICOBACTERIAS MARINAS"
  },
  {
    "codigo":271349002,
    "descripcion":"EXAMEN MICROSCÓPICO DE ORINA: ERITROCITOS PRESENTES"
  },
  {
    "codigo":402421002,
    "descripcion":"LIQUEN ESCLEROSO EXTRAGENITAL GENERALIZADO"
  },
  {
    "codigo":15683201000119101,
    "descripcion":"INFLAMACIÓN DE BOLSA SEROSA DE MÚSCULO SEMIMEMBRANOSO DE AMBAS RODILLAS"
  },
  {
    "codigo":238581007,
    "descripcion":"DERMATITIS IRRITATIVA POR CONTACTO CRÓNICA"
  },
  {
    "codigo":236746000,
    "descripcion":"BALANITIS POR ANAEROBIOS"
  },
  {
    "codigo":105674007,
    "descripcion":"ENFERMEDAD CAUSADA POR HETEROPHYIDAE"
  },
  {
    "codigo":1285322008,
    "descripcion":"TRIOPÍA"
  },
  {
    "codigo":5535003,
    "descripcion":"FALLA DE LA REPETICIÓN"
  },
  {
    "codigo":365983005,
    "descripcion":"CONSUMO DE RAPÉ - HALLAZGO"
  },
  {
    "codigo":724596002,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE MIEMBRO EN VARO"
  },
  {
    "codigo":396916007,
    "descripcion":"INVASIÓN PLEURAL POR TUMOR PRESENTE"
  },
  {
    "codigo":722761003,
    "descripcion":"GLOMERULONEFRITIS POR COMPONENTE 3 DEL COMPLEMENTO"
  },
  {
    "codigo":1148745004,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR DEXTROPROPOXIFENO Y\/O PARACETAMOL"
  },
  {
    "codigo":1865008,
    "descripcion":"ALTERACIÓN EN LA ABSORCIÓN INTESTINAL DE PROTEÍNAS"
  },
  {
    "codigo":426014000,
    "descripcion":"FÍSTULA DE PALADAR DURO"
  },
  {
    "codigo":32798002,
    "descripcion":"PARKINSONISMO"
  },
  {
    "codigo":131102000,
    "descripcion":"NIVEL DE GONADOTROFINA CORIÓNICA HUMANA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1074971000119103,
    "descripcion":"ARTRITIS DE ARTICULACIÓN SACROILÍACA IZQUIERDA"
  },
  {
    "codigo":337691000119103,
    "descripcion":"COROIDITIS SERPIGINOSA DE OJO IZQUIERDO"
  },
  {
    "codigo":1145075004,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR CLORAZEPATO"
  },
  {
    "codigo":94664002,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LOS ANEXOS UTERINOS"
  },
  {
    "codigo":717256009,
    "descripcion":"HIPOTRICOSIS SIMPLE DE CUERO CABELLUDO HEREDITARIA"
  },
  {
    "codigo":10823451000119107,
    "descripcion":"FRACTURA EXPUESTA EN MARTILLO DE FALANGE DISTAL DE DEDO ÍNDICE DE MANO IZQUIERDA"
  },
  {
    "codigo":1010333003,
    "descripcion":"ENFISEMA DE PULMÓN IZQUIERDO"
  },
  {
    "codigo":291272009,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR PROPRANOLOL"
  },
  {
    "codigo":289437007,
    "descripcion":"HALLAZGO RELACIONADO CON LA FRECUENCIA CARDÍACA FETAL"
  },
  {
    "codigo":125597008,
    "descripcion":"LESIÓN TRAUMÁTICA DEL ANTEBRAZO"
  },
  {
    "codigo":715421009,
    "descripcion":"DISPLASIA CRANEOFRONTONASAL"
  },
  {
    "codigo":92829008,
    "descripcion":"GLAUCOMA POR MECANISMOS COMBINADOS"
  },
  {
    "codigo":25458004,
    "descripcion":"GASTRITIS AGUDA"
  },
  {
    "codigo":123762005,
    "descripcion":"HIPOINSULINISMO"
  },
  {
    "codigo":1336178006,
    "descripcion":"TRASTORNO POR USO DE BARBITÚRICO"
  },
  {
    "codigo":56391002,
    "descripcion":"NECROBIOSIS LIPOIDEA DE LOS DIABÉTICOS"
  },
  {
    "codigo":23623005,
    "descripcion":"MASTITIS INFECCIOSA"
  },
  {
    "codigo":285767006,
    "descripcion":"MADURACIÓN VISUAL TARDÍA"
  },
  {
    "codigo":447772003,
    "descripcion":"QUINTO ARCO AÓRTICO PERSISTENTE CON CAYADO DOBLE EN BARRIL"
  },
  {
    "codigo":1332508004,
    "descripcion":"SÍNDROME DE HIPOPLASIA CEREBELOSA, DISCAPACIDAD INTELECTUAL, MICROCEFALIA CONGÉNITA, DISTONÍA, ANEMIA, RETRASO DEL CRECIMIENTO"
  },
  {
    "codigo":54556006,
    "descripcion":"FRACTURA DE CÚBITO"
  },
  {
    "codigo":251164006,
    "descripcion":"COMPLEJO NODAL AURICULOVENTRICULAR PREMATURO"
  },
  {
    "codigo":183793003,
    "descripcion":"INSCRIPTO EN LISTA DE ADMISIÓN UROLÓGICA"
  },
  {
    "codigo":249329004,
    "descripcion":"NARIZ CHATA"
  },
  {
    "codigo":413169006,
    "descripcion":"REGISTRADO COMO CON DEPRESIÓN"
  },
  {
    "codigo":52721006,
    "descripcion":"TUBERCULOSIS DE SENO PARANASAL"
  },
  {
    "codigo":444102004,
    "descripcion":"INFECCIÓN CAUSADA POR STAPHYLOCOCCUS PSEUDINTERMEDIUS RESISTENTE A LA METICILINA"
  },
  {
    "codigo":18118007,
    "descripcion":"INFECCIÓN CAUSADA POR POROCEPHALUS MONILIFORME"
  },
  {
    "codigo":49051001,
    "descripcion":"REFLEJO TENDINOSO NORMAL"
  },
  {
    "codigo":442267002,
    "descripcion":"ANGIODISPLASIA DEL DUODENO"
  },
  {
    "codigo":704411002,
    "descripcion":"FRACTURA EXPUESTA TRANSCONDÍLEA DE HÚMERO DISTAL"
  },
  {
    "codigo":737179007,
    "descripcion":"MUCOCELE DE LA CAVIDAD NASAL"
  },
  {
    "codigo":211056003,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE MAMA"
  },
  {
    "codigo":276592005,
    "descripcion":"DIÁSTASIS OCCIPITAL PERINATAL"
  },
  {
    "codigo":14448006,
    "descripcion":"INGESTIÓN DE CUERPO EXTRAÑO"
  },
  {
    "codigo":243824006,
    "descripcion":"ESTADO DE LA ANTICONCEPCIÓN SINTOTÉRMICA"
  },
  {
    "codigo":1259632007,
    "descripcion":"SÍNDROME CLÍNICAMENTE AISLADO DE CEREBELO"
  },
  {
    "codigo":209221001,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA EXPUESTA DEL ESTERNÓN"
  },
  {
    "codigo":10825961000119101,
    "descripcion":"FRACTURA EXPUESTA DE CUARTO HUESO METATARSIANO DE PIE DERECHO"
  },
  {
    "codigo":241989005,
    "descripcion":"LESIÓN POR DESCOMPRESIÓN LINFÁTICA"
  },
  {
    "codigo":373061006,
    "descripcion":"DISPOSITIVO APLICADO AL PACIENTE"
  },
  {
    "codigo":403994001,
    "descripcion":"COLAGENOMA ESTORIFORME DE CÉLULAS GRANDES"
  },
  {
    "codigo":240154002,
    "descripcion":"OSTEOPOROSIS IDIOPÁTICA EN EL EMBARAZO"
  },
  {
    "codigo":764442003,
    "descripcion":"ALERGIA A FENOL CLORADO"
  },
  {
    "codigo":698906002,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: CACHEMIR"
  },
  {
    "codigo":76314005,
    "descripcion":"TRASTORNO HIDROELECTROLÍTICO"
  },
  {
    "codigo":11835471000119109,
    "descripcion":"SUBLUXACIÓN DE ARTICULACIÓN INTERFALÁNGICA DE SEGUNDO A QUINTO DEDOS DE PIE IZQUIERDO"
  },
  {
    "codigo":305690005,
    "descripcion":"ATENDIDO POR UN GINECÓLOGO"
  },
  {
    "codigo":402159001,
    "descripcion":"DERMATOSIS CAUSADA POR ÁCARO DE INSECTO"
  },
  {
    "codigo":271087004,
    "descripcion":"DEFORMIDAD DE RADIO"
  },
  {
    "codigo":74479008,
    "descripcion":"METABOLOPATÍA LOCALIZADA"
  },
  {
    "codigo":762607008,
    "descripcion":"DOLOR NEUROPÁTICO OROFACIAL"
  },
  {
    "codigo":72644000,
    "descripcion":"REACOMODAMIENTO GENÉTICO, CADENA ALFA, RECEPTOR DE ANTÍGENOS DE CÉLULAS T"
  },
  {
    "codigo":15632771000119100,
    "descripcion":"EXOTROPÍA DE OJO IZQUIERDO"
  },
  {
    "codigo":105412007,
    "descripcion":"EXCLUSIÓN SOCIAL"
  },
  {
    "codigo":236484007,
    "descripcion":"FÍSTULA DEL CÁLIZ RENAL"
  },
  {
    "codigo":365721001,
    "descripcion":"EQUILIBRIO ACIDOBÁSICO - HALLAZGO"
  },
  {
    "codigo":431257006,
    "descripcion":"ENFERMEDAD CAUSADA POR POLIOMAVIRUS TIPO JC"
  },
  {
    "codigo":300185008,
    "descripcion":"HALLAZGO RELACIONADO CON LA HUMEDAD DE LA CAVIDAD MASTOIDEA"
  },
  {
    "codigo":298350001,
    "descripcion":"AUSENCIA ÓSEA"
  },
  {
    "codigo":200046004,
    "descripcion":"COMPLICACIONES DE LA ANESTESIA DURANTE EL TRABAJO DE PARTO Y EL PARTO"
  },
  {
    "codigo":167278006,
    "descripcion":"PRUEBA DE PROTEÍNAS EN ORINA = ++++"
  },
  {
    "codigo":1345091003,
    "descripcion":"SÍNDROME DE ABSTINENCIA DE HORMONA ESTEROIDE POSTERIOR A USO TERAPÉUTICO"
  },
  {
    "codigo":296515004,
    "descripcion":"SOBREDOSIS DE ANTAGONISTA OPIÁCEO"
  },
  {
    "codigo":722499006,
    "descripcion":"USUARIO DE CIGARRILLO ELECTRÓNICO"
  },
  {
    "codigo":540681000220102,
    "descripcion":"OCLUSIÓN DE RAMA COLATERAL DE ARTERIA CORONARIA DEBIDA A INTERVENCIÓN CORONARIA PERCUTÁNEA Y POSTERIOR A ELLA"
  },
  {
    "codigo":196376007,
    "descripcion":"LESIÓN DE ENCÍA Y CRESTA ALVEOLAR DESDENTADA DEBIDA A TRAUMATISMO"
  },
  {
    "codigo":292845008,
    "descripcion":"REACCIÓN ADVERSA A LA IDOXURIDINA"
  },
  {
    "codigo":1144813009,
    "descripcion":"INGESTA EXCESIVA DE VITAMINA B6 Y\/O DERIVADO DE VITAMINA B6"
  },
  {
    "codigo":782530003,
    "descripcion":"ALERGIA A DERIVADO DE CLORAL"
  },
  {
    "codigo":291010003,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR BUTABARBITAL"
  },
  {
    "codigo":127170005,
    "descripcion":"LINFADENOPATÍA LACUNAR MEDIAL"
  },
  {
    "codigo":716994006,
    "descripcion":"VARIANTE CONDUCTUAL DE DEMENCIA FRONTOTEMPORAL"
  },
  {
    "codigo":225474007,
    "descripcion":"HALLAZGO RELACIONADO CON LA COMUNICACIÓN NO VERBAL"
  },
  {
    "codigo":192706006,
    "descripcion":"ENCEFALITIS POSVACUNACIÓN CONTRA LA FIEBRE TIFOIDEA"
  },
  {
    "codigo":94402006,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LOS ÓRGANOS GENITALES MASCULINOS"
  },
  {
    "codigo":27031003,
    "descripcion":"TRIPANOSOMIASIS AFRICANA"
  },
  {
    "codigo":92567004,
    "descripcion":"CARCINOMA IN SITU DEL CLÍTORIS"
  },
  {
    "codigo":449345000,
    "descripcion":"FUMABA ANTES DE LA CONFIRMACIÓN DEL EMBARAZO"
  },
  {
    "codigo":1079991000119101,
    "descripcion":"SARCOMA DE EWING PRIMARIO DE HUESO DE EXTREMIDAD SUPERIOR IZQUIERDA"
  },
  {
    "codigo":285505003,
    "descripcion":"DIFICULTAD PARA SACAR LA LENGUA"
  },
  {
    "codigo":1268545005,
    "descripcion":"CARCINOMA PRIMARIO DE CÉLULAS TRANSICIONALES DE CUERPO DE ÚTERO"
  },
  {
    "codigo":342711000119102,
    "descripcion":"QUISTE DE PÁRPADO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":185366001,
    "descripcion":"DERIVADO POR ODONTÓLOGO"
  },
  {
    "codigo":250902003,
    "descripcion":"RESPUESTA MIOGÉNICA POSAURICULAR"
  },
  {
    "codigo":283670003,
    "descripcion":"HERIDA POR PINCHAZO DE CLAVO EN EL MUSLO"
  },
  {
    "codigo":314603004,
    "descripcion":"MASA EN PARED ABDOMINAL ANTERIOR"
  },
  {
    "codigo":249067005,
    "descripcion":"ACTITUD FETAL DEFLEXIONADA"
  },
  {
    "codigo":609515005,
    "descripcion":"TUMOR TROFOBLÁSTICO EPITELIOIDE"
  },
  {
    "codigo":871659004,
    "descripcion":"DOBLE ENTRADA A VENTRÍCULO ÚNICO DE MORFOLOGÍA INDETERMINADA"
  },
  {
    "codigo":247232005,
    "descripcion":"PAPILA ÓPTICA - LATIDO VENOSO AUSENTE"
  },
  {
    "codigo":1230272009,
    "descripcion":"HIPOTIROIDISMO CONGÉNITO DEBIDO A MUTACIÓN EN EL RECEPTOR DE HORMONA ESTIMULANTE DE TIROIDES"
  },
  {
    "codigo":16021003,
    "descripcion":"ARTIFICIO DEBIDO A CONGELACIÓN"
  },
  {
    "codigo":442005004,
    "descripcion":"ATENDIDO EN DEPARTAMENTO DE BIOQUÍMICA CLÍNICA"
  },
  {
    "codigo":704149005,
    "descripcion":"FRACTURA EXPUESTA DE FALANGE PROXIMAL DE DEDO MEÑIQUE"
  },
  {
    "codigo":276330000,
    "descripcion":"ARTICULACIÓN CALIENTE"
  },
  {
    "codigo":81557008,
    "descripcion":"ENFERMEDAD PARASITARIA EN LA MADRE QUE COMPLICA EL EMBARAZO, EL NACIMIENTO Y\/O EL PUERPERIO"
  },
  {
    "codigo":11785041000119102,
    "descripcion":"AMPOLLA TRAUMÁTICA DE DEDO ANULAR IZQUIERDO"
  },
  {
    "codigo":735082004,
    "descripcion":"ANGIOQUERATOMA DE ESCROTO DE FORDYCE"
  },
  {
    "codigo":702314005,
    "descripcion":"PARÁLISIS CEREBRAL NO ESPÁSTICA"
  },
  {
    "codigo":767850009,
    "descripcion":"QUISTE ÓSEO DE MANO"
  },
  {
    "codigo":12351004,
    "descripcion":"APIÑAMIENTO DENTAL"
  },
  {
    "codigo":733247008,
    "descripcion":"MORDEDURA ABIERTA DE MANO"
  },
  {
    "codigo":895252000,
    "descripcion":"FORMA ANCHA ANORMAL CONGÉNITA DE FALANGE MEDIA DE DEDO ANULAR"
  },
  {
    "codigo":405567008,
    "descripcion":"FÍSTULA ESOFAGOENTÉRICA"
  },
  {
    "codigo":208959008,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA NO EXPUESTA DE LA ARTICULACIÓN DE LA RODILLA"
  },
  {
    "codigo":403732009,
    "descripcion":"SEUDOPORFIRIA ASOCIADA CON HEMODIÁLISIS"
  },
  {
    "codigo":762345001,
    "descripcion":"TRASTORNO DEL ESTADO DE ÁNIMO CON SÍNTOMAS DEPRESIVOS CAUSADO POR FÁRMACO DISOCIATIVO"
  },
  {
    "codigo":74217003,
    "descripcion":"ENFERMEDAD LOCAL"
  },
  {
    "codigo":239892009,
    "descripcion":"SÍNDROME ANTIFOSFOLIPÍDICO PRIMARIO"
  },
  {
    "codigo":41449007,
    "descripcion":"DIETA GENERAL"
  },
  {
    "codigo":238057007,
    "descripcion":"PORFIRIA VARIEGATA HOMOCIGOTA"
  },
  {
    "codigo":10965841000119108,
    "descripcion":"HERIDA PUNZANTE DE DEDO DE PIE DERECHO"
  },
  {
    "codigo":400062008,
    "descripcion":"SIRINGOMATA ERUPTIVA"
  },
  {
    "codigo":168851001,
    "descripcion":"PIELOGRAFÍA INTRAVENOSA NORMAL"
  },
  {
    "codigo":725907002,
    "descripcion":"DISTROFIA MUSCULAR DE LAS CINTURAS DE LAS EXTREMIDADES TIPO 2Y AUTOSÓMICA RECESIVA"
  },
  {
    "codigo":46781000087100,
    "descripcion":"SANGRE EN INTESTINO GRUESO"
  },
  {
    "codigo":299923005,
    "descripcion":"DISCRIMINACIÓN TÁCTIL: ALTERADA"
  },
  {
    "codigo":365459005,
    "descripcion":"NIVEL DE EDUCACIÓN ACTUAL - HALLAZGO"
  },
  {
    "codigo":234387004,
    "descripcion":"RASGO DE HEMOGLOBINA LEPORE"
  },
  {
    "codigo":44221000087104,
    "descripcion":"ABRASIÓN DE ANEXOS OCULARES DE OJO DERECHO"
  },
  {
    "codigo":398227009,
    "descripcion":"CONSENTIMIENTO INADECUADO"
  },
  {
    "codigo":33981000087106,
    "descripcion":"LESIONES TRAUMÁTICAS MÚLTIPLES DE GENITALES EXTERNOS"
  },
  {
    "codigo":724072002,
    "descripcion":"DISCINESIA PAROXÍSTICA INDUCIDA POR EJERCICIO"
  },
  {
    "codigo":68712004,
    "descripcion":"HIPOPLASIA LINFOCÍTICA"
  },
  {
    "codigo":37779008,
    "descripcion":"PIELOURETERITIS QUÍSTICA"
  },
  {
    "codigo":39101000087104,
    "descripcion":"DOLOR CRÓNICO POSTERIOR A HISTERECTOMÍA"
  },
  {
    "codigo":41661000087109,
    "descripcion":"HERIDA PUNZANTE DE PÁRPADO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":298088008,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE MAMA"
  },
  {
    "codigo":230717002,
    "descripcion":"ACCIDENTE ISQUÉMICO TRANSITORIO DEL TERRITORIO VERTEBROBASILAR"
  },
  {
    "codigo":66877004,
    "descripcion":"FLEGMASIA CERÚLEA DOLENS"
  },
  {
    "codigo":296253005,
    "descripcion":"SOBREDOSIS DE TIOXANTENO"
  },
  {
    "codigo":294418003,
    "descripcion":"ALERGIA A FENOL"
  },
  {
    "codigo":425490005,
    "descripcion":"EQUIPO PROTECTOR UTILIZADO"
  },
  {
    "codigo":65042007,
    "descripcion":"TRASTORNO BIPOLAR I, EPISODIO MÁS RECIENTE MIXTO DE INICIO EN EL PERÍODO POSTPARTO"
  },
  {
    "codigo":292583002,
    "descripcion":"REACCIÓN ADVERSA A LA ANTAZOLINA"
  },
  {
    "codigo":1275623002,
    "descripcion":"MÚLTIPLES ROTURAS DE RETINA DE OJO IZQUIERDO SIN DESPRENDIMIENTO"
  },
  {
    "codigo":1144551004,
    "descripcion":"APLASIA DE MAMA"
  },
  {
    "codigo":390887004,
    "descripcion":"VELOCIDAD DE FLUJO ESPIRATORIO PICO - DISTENSIBILIDAD ESCASA"
  },
  {
    "codigo":61372001,
    "descripcion":"CONDUCTA AGRESIVA"
  },
  {
    "codigo":94140004,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA PLEURA VISCERAL"
  },
  {
    "codigo":1306556006,
    "descripcion":"CARCINOMA DUCTAL INFILTRANTE DE PORCIÓN CENTRAL DE MAMA"
  },
  {
    "codigo":126908007,
    "descripcion":"NEOPLASIA DEL ÚTERO"
  },
  {
    "codigo":290748007,
    "descripcion":"INTOXICACIÓN POR TRILOSTANO"
  },
  {
    "codigo":345221000119107,
    "descripcion":"QUERATITIS MACULAR BILATERAL"
  },
  {
    "codigo":92305008,
    "descripcion":"NEOPLASIA BENIGNA DE LA PARED POSTERIOR DE LA VEJIGA"
  },
  {
    "codigo":288913009,
    "descripcion":"CAPAZ DE RETIRAR ALIMENTO DEL SURCO YUGAL"
  },
  {
    "codigo":418150003,
    "descripcion":"VÍCTIMA DE RELACIÓN SEXUAL ABUSIVA CON LA PAREJA"
  },
  {
    "codigo":57702005,
    "descripcion":"NEUMONÍA NO RESUELTA"
  },
  {
    "codigo":287078007,
    "descripcion":"CONSOLIDACIÓN DEFECTUOSA DE FRACTURA - TOBILLO\/PIE"
  },
  {
    "codigo":186939000,
    "descripcion":"PERITONITIS GONOCÓCICA"
  },
  {
    "codigo":285243004,
    "descripcion":"PENSAMIENTO LENTO"
  },
  {
    "codigo":449083008,
    "descripcion":"SEPSIS CAUSADA POR SALMONELLA"
  },
  {
    "codigo":283408001,
    "descripcion":"CORTE EN LA GARGANTA"
  },
  {
    "codigo":15693241000119100,
    "descripcion":"QUERATITIS DE OJO IZQUIERDO CAUSADA POR ACANTHAMOEBA"
  },
  {
    "codigo":840464007,
    "descripcion":"DEMENCIA DEBIDA A INTOXICACIÓN POR MONÓXIDO DE CARBONO"
  },
  {
    "codigo":445413001,
    "descripcion":"PIEL BRILLANTE"
  },
  {
    "codigo":414480009,
    "descripcion":"PATRÓN VASCULAR COLÓNICO AUMENTADO"
  },
  {
    "codigo":19429009,
    "descripcion":"ÚLCERA CRÓNICA DE LA PIEL"
  },
  {
    "codigo":17594002,
    "descripcion":"BRADICARDIA FETAL QUE AFECTA EL MANEJO DE LA SITUACIÓN MATERNA"
  },
  {
    "codigo":246970006,
    "descripcion":"AUMENTO DE TAMAÑO DE CÉLULAS ENDOTELIALES DE CÓRNEA"
  },
  {
    "codigo":1162639000,
    "descripcion":"REACCIÓN ADVERSA A COMPONENTE DE VACUNA QUE CONTIENE ANTÍGENOS DE B. PERTUSSIS ACELULAR, C. TETANI, CORYNEBACTERIUM DIPHTHERIAE, HAEMOPHILUS INFLUENZAE TIPO B, VIRUS DE LA HEPATITIS B Y POLIOVIRUS HUMANO INACTIVADO COMO ÚNICOS INGREDIENTES"
  },
  {
    "codigo":277903005,
    "descripcion":"ESPUTO ESPESO"
  },
  {
    "codigo":865892001,
    "descripcion":"OBSTRUCCIÓN DE TRACTO RESPIRATORIO DEBIDO A ALIMENTO ALOJADO EN EL ESÓFAGO"
  },
  {
    "codigo":276068009,
    "descripcion":"CAMBIÓ DE TRABAJO"
  },
  {
    "codigo":15912531000119101,
    "descripcion":"FRACTURA NO EXPUESTA DE TROCÁNTER DE FÉMUR IZQUIERDO"
  },
  {
    "codigo":765753004,
    "descripcion":"PARAPLEJÍA ESPÁSTICA AUTOSÓMICA RECESIVA TIPO 45"
  },
  {
    "codigo":208697005,
    "descripcion":"FRACTURA EXPUESTA DEL ASTRÁGALO, CUELLO"
  },
  {
    "codigo":1222670005,
    "descripcion":"LINFEDEMA PRIMARIO DE INICIO TARDÍO ASOCIADO A GEN GJC2"
  },
  {
    "codigo":403470007,
    "descripcion":"EDEMA VENÉREO DE PENE"
  },
  {
    "codigo":205027003,
    "descripcion":"HIPOSPADIAS FEMENINO"
  },
  {
    "codigo":237795006,
    "descripcion":"TUMOR OVÁRICO VIRILIZANTE"
  },
  {
    "codigo":238899009,
    "descripcion":"LIPODISTROFIA CENTRÍFUGA ABDOMINAL INFANTIL"
  },
  {
    "codigo":235960001,
    "descripcion":"NECROSIS PANCREÁTICA INFECTADA"
  },
  {
    "codigo":72120001,
    "descripcion":"INTOXICACIÓN POR METANDRIOL"
  },
  {
    "codigo":365197001,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA CONTROLAR LAS EMOCIONES"
  },
  {
    "codigo":234125002,
    "descripcion":"ANOMALÍA VALVULAR VENOSA"
  },
  {
    "codigo":135821003,
    "descripcion":"TIENE UN ASISTENTE"
  },
  {
    "codigo":4749004,
    "descripcion":"QUISTE DE CONDUCTO INCISIVO"
  },
  {
    "codigo":440341000124108,
    "descripcion":"INGESTA ENERGÉTICA PREVISTA EXCESIVA"
  },
  {
    "codigo":299661006,
    "descripcion":"ASIMETRÍA DE LA PELVIS"
  },
  {
    "codigo":2581000124108,
    "descripcion":"TERCER MOLAR SUPERIOR IZQUIERDO PERMANENTE SUPERNUMERARIO"
  },
  {
    "codigo":197687001,
    "descripcion":"SÍNDROME NEFRÍTICO AGUDO, ENFERMEDAD DE DEPÓSITOS DENSOS"
  },
  {
    "codigo":721975004,
    "descripcion":"SÍNDROME DE DISPLASIA EPIFISARIA, MICROCEFALIA Y NISTAGMO"
  },
  {
    "codigo":1079004,
    "descripcion":"QUISTE DE LA MÁCULA DE LA RETINA"
  },
  {
    "codigo":33847006,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO TORÁCICO"
  },
  {
    "codigo":295991009,
    "descripcion":"SOBREDOSIS DE PRIMIDONA"
  },
  {
    "codigo":359692004,
    "descripcion":"ALTERACIÓN DE LA COLORACIÓN DEL ESMALTE DENTAL INTRÍNSECA DE LA PORFIRIA"
  },
  {
    "codigo":128481000,
    "descripcion":"ENFERMEDAD AGUDA DEL SISTEMA MUSCULOESQUELÉTICO"
  },
  {
    "codigo":95713000,
    "descripcion":"LIPIDOSIS DEL HUMOR ACUOSO"
  },
  {
    "codigo":716470000,
    "descripcion":"CAPAZ DE UTILIZAR REDES SOCIALES EN LÍNEA"
  },
  {
    "codigo":1177057009,
    "descripcion":"CONJUNTIVITIS CAUSADA POR PROTOZOOS"
  },
  {
    "codigo":126646002,
    "descripcion":"NEOPLASIA DE LA REGIÓN PRESACRA"
  },
  {
    "codigo":1306294005,
    "descripcion":"NEOPLASIA MALIGNA EN TEJIDO ECTÓPICO DE MAMA"
  },
  {
    "codigo":93878007,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA COLUMNA VERTEBRAL LUMBAR"
  },
  {
    "codigo":224950008,
    "descripcion":"SALTAR DESDE UN ACANTILADO"
  },
  {
    "codigo":59275002,
    "descripcion":"OTITIS MEDIA AGUDA SEROSA ALÉRGICA"
  },
  {
    "codigo":714635005,
    "descripcion":"DEFORMIDAD DE LA UNIÓN MUCOGINGIVAL"
  },
  {
    "codigo":26507005,
    "descripcion":"CÓNYUGE COMETIÓ ADULTERIO"
  },
  {
    "codigo":254048001,
    "descripcion":"ESPONDILODISPLASIA, TIPO LUTON"
  },
  {
    "codigo":286816006,
    "descripcion":"TIENDE A PREOCUPARSE POR EL ORDEN"
  },
  {
    "codigo":188512009,
    "descripcion":"LINFOMA DE BURKITT DE GANGLIOS LINFÁTICOS INTRABDOMINALES"
  },
  {
    "codigo":677921000119101,
    "descripcion":"AGUJERO MACULAR DE ESPESOR PARCIAL DE OJO IZQUIERDO"
  },
  {
    "codigo":874805004,
    "descripcion":"CONTUSIÓN SUPERFICIAL DE LA PIEL DEL MUSLO"
  },
  {
    "codigo":448821004,
    "descripcion":"ANOMALÍA DE CÚSPIDE DE VÁLVULA TRONCAL"
  },
  {
    "codigo":416053008,
    "descripcion":"TUMOR POSITIVO PARA RECEPTOR DE ESTRÓGENO"
  },
  {
    "codigo":283146001,
    "descripcion":"ANZUELO EN LA BOCA"
  },
  {
    "codigo":446986002,
    "descripcion":"DERRAME PLEURAL TUBERCULOSO"
  },
  {
    "codigo":284981008,
    "descripcion":"SE COLOCA CALZADO"
  },
  {
    "codigo":53770004,
    "descripcion":"ÁNTRAX DE LA REGIÓN DEL TRONCO"
  },
  {
    "codigo":184842005,
    "descripcion":"EXAMEN PARA EL SEGURO DE VIDA COMPLETADO"
  },
  {
    "codigo":838367000,
    "descripcion":"RINOSINUSITIS ALÉRGICA CAUSADA POR ASPERGILLUS"
  },
  {
    "codigo":21002008,
    "descripcion":"INTOXICACIÓN POR FAMFUR"
  },
  {
    "codigo":19167000,
    "descripcion":"RIÑONES DE TAMAÑO DESIGUAL"
  },
  {
    "codigo":445151006,
    "descripcion":"ABSCESO INTRACRANEAL SUBARACNOIDEO"
  },
  {
    "codigo":1196980000,
    "descripcion":"LESIÓN DE PLACENTA DEBIDA A OPERACIÓN CESÁREA"
  },
  {
    "codigo":1231583008,
    "descripcion":"OBSTRUCCIÓN DE LUZ DE VÍA RESPIRATORIA CAUSADA POR INHALACIÓN DE CUENTA"
  },
  {
    "codigo":17332000,
    "descripcion":"ACNÉ POR COSMÉTICOS"
  },
  {
    "codigo":410548003,
    "descripcion":"DESORGANIZACIÓN EN EL ARMADO DE LA HISTORIA CLÍNICA"
  },
  {
    "codigo":246708005,
    "descripcion":"MOVIMIENTOS OCULARES CONVERGEN SOBRE OBJETO QUE SE DIRIGE HACIA LA CARA"
  },
  {
    "codigo":1295284006,
    "descripcion":"QUILORREA"
  },
  {
    "codigo":703625002,
    "descripcion":"SARCOMA DE KAPOSI NO ASOCIADO CON SÍNDROME DE INMUNODEFICIENCIA ADQUIRIDA"
  },
  {
    "codigo":441481004,
    "descripcion":"INSUFICIENCIA CARDÍACA SISTÓLICA CRÓNICA"
  },
  {
    "codigo":769161006,
    "descripcion":"DEFICIENCIA DE LA PARTE POSTERIOR DE LA CRESTA ALVEOLAR INFERIOR"
  },
  {
    "codigo":212105007,
    "descripcion":"QUEMADURA QUE COMPROMETE 80-89 PORCIENTO DE LA SUPERFICIE DEL CUERPO, CON QUEMADURA DE ESPESOR COMPLETO QUE AFECTA 10-19 PORCIENTO DE LA SUPERFICIE CORPORAL"
  },
  {
    "codigo":767326000,
    "descripcion":"AUSENCIA CONGÉNITA DE HEMIDIAFRAGMA IZQUIERDO"
  },
  {
    "codigo":243038003,
    "descripcion":"LESIÓN POR EXPLOSIÓN DE PROYECTIL DE ARTILLERÍA MARÍTIMA"
  },
  {
    "codigo":110131000,
    "descripcion":"LACERACIÓN COMPLEJA DEL PALADAR BLANDO"
  },
  {
    "codigo":44595001,
    "descripcion":"PERICARDITIS MICÓTICA"
  },
  {
    "codigo":765491003,
    "descripcion":"CONDUCTA CRUEL"
  },
  {
    "codigo":699955004,
    "descripcion":"NEOPLASIA DE MÚSCULO ESQUELÉTICO"
  },
  {
    "codigo":16034391000119101,
    "descripcion":"HIPERTROFIA ÓSEA DE HÚMERO IZQUIERDO"
  },
  {
    "codigo":10750551000119100,
    "descripcion":"OBESIDAD EN LA MADRE QUE COMPLICA EL NACIMIENTO"
  },
  {
    "codigo":136791000119103,
    "descripcion":"DOLOR DORSAL CRÓNICO"
  },
  {
    "codigo":10627671000119104,
    "descripcion":"FORÚNCULO DE MUÑECA DERECHA"
  },
  {
    "codigo":16039511000119104,
    "descripcion":"CONDROMALACIA DE PIE DERECHO"
  },
  {
    "codigo":674391000119106,
    "descripcion":"DÉFICIT DEL HABLA Y DEL LENGUAJE DEBIDO A ACCIDENTE CEREBROVASCULAR HEMORRÁGICO Y POSTERIOR A ÉL"
  },
  {
    "codigo":15993431000119107,
    "descripcion":"QUERATITIS INTERSTICIAL DE OJO IZQUIERDO DEBIDA A SÍFILIS CONGÉNITA"
  },
  {
    "codigo":16057431000119103,
    "descripcion":"TRASTORNO DE NERVIO FACIAL DERECHO"
  },
  {
    "codigo":341591000119109,
    "descripcion":"CONJUNTIVITIS PAPILAR GIGANTE CRÓNICA DE OJO IZQUIERDO"
  },
  {
    "codigo":323671000119109,
    "descripcion":"TUMOR TENOSINOVIAL DIFUSO DE CÉLULAS GIGANTES DE MANO DERECHA"
  },
  {
    "codigo":16047191000119109,
    "descripcion":"ENFERMEDAD POR DEPÓSITO DE HIDROXIAPATITA DE CADERA DERECHA"
  },
  {
    "codigo":763656000,
    "descripcion":"PRÓTESIS DE ARTICULACIÓN DE CODO PRESENTE"
  },
  {
    "codigo":83031000119105,
    "descripcion":"MALFORMACIÓN CONGÉNITA DE TABIQUE NASAL"
  },
  {
    "codigo":403208003,
    "descripcion":"HIPERQUERATOSIS ACTÍNICA DIFUSA"
  },
  {
    "codigo":333911000119109,
    "descripcion":"ENTROPIÓN MECÁNICO DE PÁRPADO DERECHO"
  },
  {
    "codigo":303191000119108,
    "descripcion":"TENDINITIS CALCIFICADA DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":15637591000119109,
    "descripcion":"QUISTE SINOVIAL DE AMBAS RODILLAS"
  },
  {
    "codigo":11825751000119109,
    "descripcion":"RUPTURA TRAUMÁTICA DE TENDÓN DE REGIÓN DE MUÑECA DERECHA"
  },
  {
    "codigo":1220573009,
    "descripcion":"DISTONÍA PRIMARIA TIPO 27"
  },
  {
    "codigo":235698003,
    "descripcion":"PERFORACIÓN TRAUMÁTICA DE DUODENO"
  },
  {
    "codigo":71858003,
    "descripcion":"HIPOGLUCEMIA AUTOINMUNITARIA"
  },
  {
    "codigo":39090004,
    "descripcion":"TAMAÑO DE UNA COLONIA BACTERIANA, PEQUEÑA"
  },
  {
    "codigo":268466006,
    "descripcion":"UTILIZA ANTICONCEPCIÓN CON ESPERMICIDA"
  },
  {
    "codigo":233863001,
    "descripcion":"ESTENOSIS AÓRTICA SENIL"
  },
  {
    "codigo":364935004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA TRASLADARSE DE LA SILLA DE RUEDAS AL INODORO"
  },
  {
    "codigo":299399006,
    "descripcion":"PRUEBA DE COMPRESIÓN ROTULIANA POSITIVA"
  },
  {
    "codigo":232028002,
    "descripcion":"QUEMADURA DE LA RETINA POR COAGULACIÓN CON LÁSER"
  },
  {
    "codigo":461404003,
    "descripcion":"INSERCIÓN NORMAL DE LIGAMENTO ARTERIOSO EN ARTERIA PULMONAR IZQUIERDA PROXIMAL"
  },
  {
    "codigo":11848021000119106,
    "descripcion":"ABRASIÓN INFECTADA DE MEJILLA"
  },
  {
    "codigo":262961002,
    "descripcion":"AVULSIÓN DE NERVIO CRANEAL"
  },
  {
    "codigo":361265002,
    "descripcion":"ESTENOSIS CONGÉNITA DE CONDUCTO AUDITIVO EXTERNO"
  },
  {
    "codigo":295729006,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE ETOPÓSIDO"
  },
  {
    "codigo":721713007,
    "descripcion":"HEPATITIS AUTOINMUNITARIA, TIPO 3"
  },
  {
    "codigo":230193008,
    "descripcion":"NEUROSARCOIDOSIS"
  },
  {
    "codigo":228358002,
    "descripcion":"SIENTE LOS EFECTOS DEL ALCOHOL EN EL TRABAJO"
  },
  {
    "codigo":293894003,
    "descripcion":"ALERGIA A CLORDIAZEPÓXIDO"
  },
  {
    "codigo":64518008,
    "descripcion":"SÍNDROME PARATRIGEMINAL"
  },
  {
    "codigo":292059002,
    "descripcion":"REACCIÓN ADVERSA A LA MORFINA"
  },
  {
    "codigo":95451004,
    "descripcion":"TROMBOFLEBITIS DE LAS VENAS SUPERFICIALES DE LAS EXTREMIDADES SUPERIORES"
  },
  {
    "codigo":128219005,
    "descripcion":"DISOSTOSIS DE HUESO CRANEAL"
  },
  {
    "codigo":93616000,
    "descripcion":"LEIOMIOMA INTRAMURAL DEL ÚTERO"
  },
  {
    "codigo":880048005,
    "descripcion":"INSUFICIENCIA ADQUIRIDA DE ESTRUCTURA VENTRICULAR IZQUIERDA DE LA VÁLVULA AURICULOVENTRICULAR COMÚN POSTERIOR A REPARACIÓN DE COMUNICACIÓN BIVENTRICULAR"
  },
  {
    "codigo":191920007,
    "descripcion":"PATRÓN DE USO NOCIVO DE COCAÍNA SIN DEPENDENCIA, EN REMISIÓN"
  },
  {
    "codigo":124549001,
    "descripcion":"DEFICIENCIA DE MONOÉSTER TRIFOSFÓRICO HIDROLASA"
  },
  {
    "codigo":15999471000119107,
    "descripcion":"QUERATOPATÍA DE OJO DERECHO CAUSADA POR FÁRMACO"
  },
  {
    "codigo":286554000,
    "descripcion":"LESIÓN DEL PERINEO FEMENINO"
  },
  {
    "codigo":417626001,
    "descripcion":"PÚRPURA TROMBOCITOPÉNICA ASOCIADA CON TRASTORNO METABÓLICO"
  },
  {
    "codigo":288389009,
    "descripcion":"INCAPAZ DE RETORCER ROPA"
  },
  {
    "codigo":188250002,
    "descripcion":"NEOPLASIA MALIGNA DE PARÉNQUIMA RENAL"
  },
  {
    "codigo":10812041000119103,
    "descripcion":"INFECCIÓN DEL TRACTO URINARIO DEBIDA A ABORTO INCOMPLETO"
  },
  {
    "codigo":186415000,
    "descripcion":"GANGRENA GASEOSA DE ESPALDA"
  },
  {
    "codigo":253786009,
    "descripcion":"VÓLVULO CONGÉNITO"
  },
  {
    "codigo":448559003,
    "descripcion":"TERATOMA MALIGNO DE RETROPERITONEO"
  },
  {
    "codigo":55343006,
    "descripcion":"QUEMADURA DEL DORSO DE LA MANO"
  },
  {
    "codigo":282884000,
    "descripcion":"SE PONDE DE PIE DESDE LA POSICIÓN SEDENTE"
  },
  {
    "codigo":88111009,
    "descripcion":"HÁBITOS INTESTINALES ANORMAL"
  },
  {
    "codigo":86276007,
    "descripcion":"ENCÍAS SANGRANTES"
  },
  {
    "codigo":250116007,
    "descripcion":"CREPITACIÓN PALPABLE DE LA RODILLA"
  },
  {
    "codigo":18905000,
    "descripcion":"POSICIÓN OCCIPITOILÍACA IZQUIERDA TRANSVERSA"
  },
  {
    "codigo":51673001,
    "descripcion":"FRACTURAS MÚLTIPLES NO EXPUESTAS DE AMBAS EXTREMIDADES SUPERIORES"
  },
  {
    "codigo":15727241000119107,
    "descripcion":"HIPERLAXITUD ARTICULAR BILATERAL DE CODOS"
  },
  {
    "codigo":1264089009,
    "descripcion":"TRASTORNO FETAL CAUSADO POR TRANSFERENCIA PLACENTARIA DE AGENTE MEDICINAL"
  },
  {
    "codigo":211843006,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO PROFUNDA DEL BRAZO"
  },
  {
    "codigo":111704000,
    "descripcion":"AMPOLLA DE LABIO, SIN INFECCIÓN"
  },
  {
    "codigo":441219009,
    "descripcion":"CÉLULAS GLANDULARES ATÍPICAS EN EL EXTENDIDO CERVICAL DE PAPANICOLAOU"
  },
  {
    "codigo":46168003,
    "descripcion":"GLAUCOMA PIGMENTARIO"
  },
  {
    "codigo":406616008,
    "descripcion":"INFECCIÓN POR STREPTOCOCCUS DEL SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":208173000,
    "descripcion":"FRACTURA EXPUESTA ESTABLE DE RAMAS PÚBICAS MÚLTIPLES"
  },
  {
    "codigo":44333005,
    "descripcion":"LUXACIÓN EXPUESTA MEDIAL DEL EXTREMO PROXIMAL DE LA TIBIA"
  },
  {
    "codigo":109869006,
    "descripcion":"FIMOSIS DEL CLÍTORIS"
  },
  {
    "codigo":372013007,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL CORDÓN ESPERMÁTICO"
  },
  {
    "codigo":1092541000119102,
    "descripcion":"CHOQUE SÉPTICO CONCOMITANTE CON DISFUNCIÓN ORGÁNICA AGUDA DEBIDO A ESTREPTOCOCO DEL GRUPO B"
  },
  {
    "codigo":402946005,
    "descripcion":"CONDILOMAS PLANOS SIFILÍTICOS DE LA VULVA"
  },
  {
    "codigo":304642007,
    "descripcion":"CAPAZ DE RAZONAR"
  },
  {
    "codigo":40663003,
    "descripcion":"COLITIS QUÍSTICA PROFUNDA"
  },
  {
    "codigo":106199004,
    "descripcion":"REACCIÓN Y\/O RECHAZO DE UN INJERTO"
  },
  {
    "codigo":237271005,
    "descripcion":"HEMORRAGIA PREPARTO CON HIPERFIBRINÓLISIS"
  },
  {
    "codigo":73431005,
    "descripcion":"NEURITIS ÓPTICA MENINGOCÓCICA"
  },
  {
    "codigo":1187543005,
    "descripcion":"DISTROFIA RETINIANA DEBIDA A GANGLIOSIDOSIS GM 2"
  },
  {
    "codigo":7895008,
    "descripcion":"INTOXICACIÓN CAUSADA POR FÁRMACO Y\/O SUSTANCIA MEDICINAL"
  },
  {
    "codigo":202668000,
    "descripcion":"ESPONDILOSIS DORSAL EN MÚLTIPLES NIVELES SIN MIELOPATÍA"
  },
  {
    "codigo":366508003,
    "descripcion":"HALLAZGO RELACIONADO CON LA AMPLITUD DE FLEXIÓN PASIVA DE CODO"
  },
  {
    "codigo":299137000,
    "descripcion":"DESVIACIÓN CUBITAL DEL PULGAR"
  },
  {
    "codigo":725121001,
    "descripcion":"SÍNDROME DE DISCONTINUACIÓN DE ISRS (INHIBIDOR SELECTIVO DE LA RECAPTACIÓN DE SEROTONINA)"
  },
  {
    "codigo":4225003,
    "descripcion":"TUBERCULOSIS DE LA NARIZ"
  },
  {
    "codigo":233601004,
    "descripcion":"BRONQUITIS VIRAL AGUDA"
  },
  {
    "codigo":200833005,
    "descripcion":"ERITEMA SOLAR DE PRIMER GRADO"
  },
  {
    "codigo":2390000,
    "descripcion":"VULVOVAGINITIS GONOCÓCICA AGUDA"
  },
  {
    "codigo":35158001,
    "descripcion":"PARESIA DE LOS MÚSCULOS EXTRAOCULARES"
  },
  {
    "codigo":264534009,
    "descripcion":"LESIÓN HIPOTALÁMICA"
  },
  {
    "codigo":197163002,
    "descripcion":"ABSCESO PELVIRRECTAL"
  },
  {
    "codigo":555002,
    "descripcion":"INTOXICACIÓN POR DICENTRA"
  },
  {
    "codigo":262699006,
    "descripcion":"CONTUSIÓN DE MÉDULA ESPINAL LUMBAR"
  },
  {
    "codigo":293632000,
    "descripcion":"ALERGIA A ÁCIDO TIAPROFÉNICO"
  },
  {
    "codigo":66091009,
    "descripcion":"ENFERMEDAD CONGÉNITA"
  },
  {
    "codigo":721451008,
    "descripcion":"SÍNDROME DEL CORDÓN CENTRAL DE MÉDULA ESPINAL AL NIVEL DEL NOVENO SEGMENTO DORSAL"
  },
  {
    "codigo":33323008,
    "descripcion":"TRASTORNO DELIRANTE SOMÁTICO"
  },
  {
    "codigo":424704004,
    "descripcion":"ESQUEMA ALIMENTARIO INADECUADO PARA LA EDAD"
  },
  {
    "codigo":15703281000119100,
    "descripcion":"TENDÓN DE AQUILES CORTO ADQUIRIDO BILATERAL"
  },
  {
    "codigo":129792006,
    "descripcion":"DISTORSIÓN ESTRUCTURAL DE LA MAMA"
  },
  {
    "codigo":422869001,
    "descripcion":"AISLAMIENTO FAMILIAR"
  },
  {
    "codigo":10624241000119101,
    "descripcion":"DERMATITIS ECCEMATOSA DE PÁRPADOS SUPERIOR E INFERIOR DERECHOS"
  },
  {
    "codigo":160725005,
    "descripcion":"VIVE SOLO - AYUDA DISPONIBLE"
  },
  {
    "codigo":1078229009,
    "descripcion":"SEGURIDAD ALIMENTARIA"
  },
  {
    "codigo":291797009,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR CORTICOSTEROIDE FLUORADO"
  },
  {
    "codigo":224426004,
    "descripcion":"SIN CANTINA EN EL TRABAJO"
  },
  {
    "codigo":714111001,
    "descripcion":"DEFORMIDAD MAMARIA POSTERIOR A MASTECTOMÍA"
  },
  {
    "codigo":93354009,
    "descripcion":"POSICIÓN ANÓMALA CONGÉNITA DE LA VENA CAVA SUPERIOR"
  },
  {
    "codigo":191658009,
    "descripcion":"TRASTORNO MANÍACO ATÍPICO"
  },
  {
    "codigo":286292000,
    "descripcion":"DIFICULTAD PARA IMITAR SONIDOS DEL HABLA"
  },
  {
    "codigo":124287008,
    "descripcion":"DEFICIENCIA DE TIROSINA AMINOTRANSFERASA"
  },
  {
    "codigo":56916002,
    "descripcion":"INTOXICACIÓN CAUSADA POR ACETILCISTEÍNA"
  },
  {
    "codigo":89684003,
    "descripcion":"ENFERMEDAD POR DESCOMPRESIÓN"
  },
  {
    "codigo":187988006,
    "descripcion":"NEOPLASIA MALIGNA DEL TARSO PALPEBRAL"
  },
  {
    "codigo":253524007,
    "descripcion":"VENTRÍCULO DERECHO DE DOBLE CÁMARA"
  },
  {
    "codigo":417364008,
    "descripcion":"NÓDULO DEL SITIO PLACENTARIO"
  },
  {
    "codigo":251689001,
    "descripcion":"HALLAZGO DE LA ECOGRAFÍA OCULAR"
  },
  {
    "codigo":1201961000,
    "descripcion":"ESCLEROSIS LATERAL AMIOTRÓFICA JUVENIL TIPO 5"
  },
  {
    "codigo":282622001,
    "descripcion":"RUEDA"
  },
  {
    "codigo":1003518002,
    "descripcion":"AGENESIA DE PUBIS"
  },
  {
    "codigo":249854006,
    "descripcion":"BUEN CONTROL DEL TRONCO"
  },
  {
    "codigo":86014007,
    "descripcion":"BLOQUEO TRIFASCICULAR"
  },
  {
    "codigo":18643000,
    "descripcion":"SINUSITIS ETMOIDAL"
  },
  {
    "codigo":774142008,
    "descripcion":"INESTABILIDAD DE ARTICULACIÓN DE CODO IZQUIERDO"
  },
  {
    "codigo":315390006,
    "descripcion":"NACIDO EN GUYANA BRITÁNICA"
  },
  {
    "codigo":248019005,
    "descripcion":"CONDUCTA DESTRUCTIVA SIN PROPÓSITO"
  },
  {
    "codigo":82344002,
    "descripcion":"CONTUSIÓN CEREBELOSA CON HERIDA INTRACRANEAL ABIERTA"
  },
  {
    "codigo":277117000,
    "descripcion":"FORMA DE ONDA INTEROCULAR ASIMÉTRICA"
  },
  {
    "codigo":14973001,
    "descripcion":"ESCLEROSIS RENAL CON HIPERTENSIÓN"
  },
  {
    "codigo":735869006,
    "descripcion":"MORDEDURA ABIERTA DE TOBILLO"
  },
  {
    "codigo":373586005,
    "descripcion":"OBSTRUCCIÓN CONGÉNITA DEL MEATO URINARIO"
  },
  {
    "codigo":240679000,
    "descripcion":"FRAMBESIA PAPULAR"
  },
  {
    "codigo":471890009,
    "descripcion":"MIOCARDIOPATÍA DILATADA CON MARCADOR GENÉTICO"
  },
  {
    "codigo":109607008,
    "descripcion":"CICATRIZ DENTAL APICAL"
  },
  {
    "codigo":238844000,
    "descripcion":"PANATROFIA DE GOWER"
  },
  {
    "codigo":402684002,
    "descripcion":"MILIUM COLOIDE"
  },
  {
    "codigo":764967008,
    "descripcion":"CONSENTIMIENTO OTORGADO PARA PROCEDIMIENTO TERAPÉUTICO A REALIZAR POR ESTUDIANTE"
  },
  {
    "codigo":271612000,
    "descripcion":"GLÁNDULA SALIVAL - HALLAZGO"
  },
  {
    "codigo":1254652005,
    "descripcion":"SÍNDROME DE DISCAPACIDAD INTELECTUAL, MACROCEFALIA, HIPOTONÍA Y ALTERACIONES CONDUCTUALES"
  },
  {
    "codigo":9468002,
    "descripcion":"FRACTURA NO EXPUESTA DE HUESO DE CARPO"
  },
  {
    "codigo":763132003,
    "descripcion":"COLOBOMA DE PÁRPADO SUPERIOR"
  },
  {
    "codigo":300710000,
    "descripcion":"NO USA TARJETA DE CRÉDITO"
  },
  {
    "codigo":890534002,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA BILATERAL DE PULMÓN"
  },
  {
    "codigo":169638003,
    "descripcion":"OFICIOS DE LOS PADRES - CLASES GRUPALES"
  },
  {
    "codigo":38566003,
    "descripcion":"BLOQUEO DE RAMA DERECHA, HEMIBLOQUEO ANTERIOR Y BLOQUEO DE RAMA IZQUIERDA INCOMPLETO"
  },
  {
    "codigo":202406005,
    "descripcion":"HEMARTROSIS DE ARTICULACIÓN RADIOCUBITAL DISTAL"
  },
  {
    "codigo":366246009,
    "descripcion":"HALLAZGO RELACIONADO CON EL ASPECTO DEL PUENTE DENTAL"
  },
  {
    "codigo":724859002,
    "descripcion":"LINFEDEMA DEBIDO A RADIOTERAPIA Y POSTERIOR A ELLA"
  },
  {
    "codigo":298875006,
    "descripcion":"DEFORMIDAD FIJA EN FLEXIÓN DE ARTICULACIÓN DE CODO"
  },
  {
    "codigo":2128005,
    "descripcion":"TRASTORNO DE ADENOIDES"
  },
  {
    "codigo":460880006,
    "descripcion":"FÍSTULA ARTERIOVENOSA DE LA GRAN VENA CEREBRAL DE GALENO"
  },
  {
    "codigo":231504006,
    "descripcion":"TRASTORNO MIXTO DE ANGUSTIA Y DEPRESIÓN"
  },
  {
    "codigo":295205000,
    "descripcion":"SOBREDOSIS DE MEPTAZINOL"
  },
  {
    "codigo":723024009,
    "descripcion":"QUERATOPATÍA AFÁQUICA AMPOLLAR POSTERIOR A CIRUGÍA DE CATARATAS"
  },
  {
    "codigo":229669002,
    "descripcion":"DÉFICIT DE LA CONVERSIÓN GRAFEMA-FONEMA"
  },
  {
    "codigo":16033471000119106,
    "descripcion":"HIPERTROFIA BILATERAL DE RADIOS"
  },
  {
    "codigo":297040008,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE MERSALILO"
  },
  {
    "codigo":428112005,
    "descripcion":"CONSOLIDACIÓN DEFECTUOSA DE FRACTURA DE FÉMUR PROXIMAL"
  },
  {
    "codigo":687961000119102,
    "descripcion":"SARCOMA PRIMARIO DE AXILA"
  },
  {
    "codigo":426277009,
    "descripcion":"DOLOR PROVOCADO POR COMER"
  },
  {
    "codigo":293370009,
    "descripcion":"REACCIÓN ADVERSA A LA NUTRICIÓN PARENTERAL (VITAMINAS)"
  },
  {
    "codigo":225999004,
    "descripcion":"CON MAYOR RIESGO DE TROMBOSIS VENOSA PROFUNDA"
  },
  {
    "codigo":783055005,
    "descripcion":"EPILEPSIA MIOCLÓNICA PROGRESIVA TIPO 5"
  },
  {
    "codigo":422607004,
    "descripcion":"CARCINOMA IN SITU DEL APARATO DE DRENAJE LAGRIMAL"
  },
  {
    "codigo":289700000,
    "descripcion":"CONTRACCIONES UTERINAS PRESENTES"
  },
  {
    "codigo":187726001,
    "descripcion":"NEOPLASIA MALIGNA DE TERCIO MEDIO DE ESÓFAGO"
  },
  {
    "codigo":23886002,
    "descripcion":"TRASTORNOS DE LA PUBERTAD FEMENINA"
  },
  {
    "codigo":286030002,
    "descripcion":"NO SACA UN ENCHUFE ELÉCTRICO DE UN TOMACORRIENTE"
  },
  {
    "codigo":124025009,
    "descripcion":"NIVEL DE ALFA 1 GLOBULINA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":449870006,
    "descripcion":"ANOMALÍA CONGÉNITA DE VASO SANGUÍNEO DE MIEMBRO"
  },
  {
    "codigo":1269070007,
    "descripcion":"TRASTORNO NEONATAL PRECOZ DEBIDO A TRASTORNO MATERNO DE PARTO"
  },
  {
    "codigo":10901491000119104,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO ACCESORIO DERECHO"
  },
  {
    "codigo":284195005,
    "descripcion":"QUEMADURA DE ESTRUCTURA MUSCULOESQUELÉTICA"
  },
  {
    "codigo":185891006,
    "descripcion":"OMISIÓN DE CRIBADO - PACIENTE NUEVO"
  },
  {
    "codigo":54819005,
    "descripcion":"FRACTURA NO EXPUESTA DE DIÁFISIS DE RADIO Y CÚBITO"
  },
  {
    "codigo":446200000,
    "descripcion":"LUXACIÓN TRAUMÁTICA DE DEDO GORDO"
  },
  {
    "codigo":282360001,
    "descripcion":"DOLOR TESTICULAR PERSISTENTE"
  },
  {
    "codigo":413432001,
    "descripcion":"HALLAZGO RELACIONADO CON EL TIEMPO PARCIAL DE TROMBOPLASTINA ACTIVADA"
  },
  {
    "codigo":249592004,
    "descripcion":"SOPLO SOBRE RIÑÓN"
  },
  {
    "codigo":52984008,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA ARTERIA FEMORAL COMÚN"
  },
  {
    "codigo":870349001,
    "descripcion":"ENTERITIS NO INFECCIOSA POR VASCULITIS POR INMUNOGLOBULINA A"
  },
  {
    "codigo":247757004,
    "descripcion":"SIN PROPÓSITO"
  },
  {
    "codigo":313293007,
    "descripcion":"RESPIRACIÓN NASAL"
  },
  {
    "codigo":11858061000119103,
    "descripcion":"DISTENSIÓN DE MÚSCULO DE REGIÓN POSTERIOR DE PIERNA DERECHA"
  },
  {
    "codigo":409762006,
    "descripcion":"PRESENCIA DE NECROSIS HISTOLÓGICA LUEGO DE QUIMIOTERAPIA DE INDUCCIÓN"
  },
  {
    "codigo":473463000,
    "descripcion":"RECIBIÓ EDUCACIÓN PRIMARIA"
  },
  {
    "codigo":704674009,
    "descripcion":"CON MAYOR RIESGO DE DUELO FAMILIAR DISFUNCIONAL"
  },
  {
    "codigo":735607008,
    "descripcion":"PROLAPSO DE DISCO INTERVERTEBRAL DORSAL CONCOMITANTE CON DEGENERACIÓN Y DEBIDO A ELLA"
  },
  {
    "codigo":1290828003,
    "descripcion":"SARCOMA MIOFIBROBLÁSTICO DE BAJO GRADO"
  },
  {
    "codigo":109345001,
    "descripcion":"SECUESTRO DEL COMPLEJO ÓRBITO - NASAL"
  },
  {
    "codigo":209484009,
    "descripcion":"ESGUINCE DE DEDO DE LA MANO, ARTICULACIÓN INTERFALÁNGICA PROXIMAL, LIGAMENTO LATERAL CUBITAL"
  },
  {
    "codigo":12876009,
    "descripcion":"INTOXICACIÓN CAUSADA POR GLUCÓSIDO DIGITÁLICO"
  },
  {
    "codigo":240417004,
    "descripcion":"GRANULOMA DE LOS ESTANQUES"
  },
  {
    "codigo":271350002,
    "descripcion":"EXAMEN MICROSCÓPICO DE ORINA: LEUCOCITOS PRESENTES"
  },
  {
    "codigo":369654003,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA DE TROFOBLASTO EN ESPÉCIMEN DE HISTERECTOMÍA, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":402422009,
    "descripcion":"LIQUEN ESCLEROSO BULLOSO EXTRAGENITAL"
  },
  {
    "codigo":302283001,
    "descripcion":"AYUDA A VESTIRSE"
  },
  {
    "codigo":1285323003,
    "descripcion":"SÍNDROME DE KLIPPEL TRÉNAUNAY INVERTIDO"
  },
  {
    "codigo":269515006,
    "descripcion":"CARCINOMA DE LABIO"
  },
  {
    "codigo":105675008,
    "descripcion":"ENFERMEDAD CAUSADA POR DACCTYLOGIRIDAE"
  },
  {
    "codigo":365984004,
    "descripcion":"CONDUCTA RELACIONADA CON LA INYECCIÓN DE DROGAS - HALLAZGO"
  },
  {
    "codigo":431520004,
    "descripcion":"INFLAMACIÓN DE LA MÉDULA ESPINAL CAUSADA POR TOXINA"
  },
  {
    "codigo":15737281000119100,
    "descripcion":"OPACIFICACIÓN DE CÁPSULA POSTERIOR, BILATERAL"
  },
  {
    "codigo":202144009,
    "descripcion":"CONDRÓLISIS DE CABEZA DE FÉMUR"
  },
  {
    "codigo":300448009,
    "descripcion":"HALLAZGO RELACIONADO CON MEDICIONES RENALES"
  },
  {
    "codigo":396917003,
    "descripcion":"INVASIÓN DEL PARÉNQUIMA PULMONAR POR TUMOR AUSENTE"
  },
  {
    "codigo":16638401000119101,
    "descripcion":"NEURALGIA DE AMBOS MIEMBROS INFERIORES"
  },
  {
    "codigo":1073601000119101,
    "descripcion":"ARTRITIS REUMATOIDEA SEROPOSITIVA DE ARTICULACIÓN DE PIE DERECHO"
  },
  {
    "codigo":724597006,
    "descripcion":"VASCULITIS DE GRAN ARTERIA"
  },
  {
    "codigo":298613009,
    "descripcion":"AMPLITUD DE EXTENSIÓN ACTIVA DE LA COLUMNA LUMBAR NORMAL"
  },
  {
    "codigo":1148746003,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR DEXTROPROPOXIFENO Y\/O PARACETAMOL"
  },
  {
    "codigo":722762005,
    "descripcion":"DEFICIENCIA DE GANGLIÓSIDO GM3 SINTASA"
  },
  {
    "codigo":460618008,
    "descripcion":"ENDOCARDITIS CAUSADA POR CHLAMYDIA"
  },
  {
    "codigo":196639001,
    "descripcion":"ÚLCERA GÁSTRICA CRÓNICA CON OBSTRUCCIÓN"
  },
  {
    "codigo":262175005,
    "descripcion":"EN BIPEDESTACIÓN\/INCLINADO"
  },
  {
    "codigo":131103005,
    "descripcion":"NIVEL DE INSULINA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1145076003,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR CLORAZEPATO"
  },
  {
    "codigo":293108006,
    "descripcion":"REACCIÓN ADVERSA A VACUNA ANTIDIFTÉRICA Y ANTITETÁNICA"
  },
  {
    "codigo":717257000,
    "descripcion":"LIQUEN MIXEDEMATOSO NODULAR"
  },
  {
    "codigo":94665001,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL ÚTERO"
  },
  {
    "codigo":291273004,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR PROPRANOLOL"
  },
  {
    "codigo":289438002,
    "descripcion":"FRECUENCIA CARDÍACA FETAL, PRESENTE"
  },
  {
    "codigo":125598003,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA MUÑECA"
  },
  {
    "codigo":715422002,
    "descripcion":"DISPLASIA CRANEOTELENCEFÁLICA"
  },
  {
    "codigo":415112005,
    "descripcion":"PLASMOCITOMA"
  },
  {
    "codigo":387742006,
    "descripcion":"AMBLIOPÍA"
  },
  {
    "codigo":92830003,
    "descripcion":"ESTENOSIS PULMONAR VALVULAR - SUBVALVULAR COMBINADA"
  },
  {
    "codigo":58227000,
    "descripcion":"SÍFILIS SECUNDARIA DE LAS VÍSCERAS"
  },
  {
    "codigo":420510009,
    "descripcion":"PRODUCCIÓN DE PRECURSOR ERITROIDE DISMINUIDA"
  },
  {
    "codigo":123763000,
    "descripcion":"SÍNDROME DE HOUSSAY"
  },
  {
    "codigo":418675003,
    "descripcion":"BLASTOMICOSIS OCULAR"
  },
  {
    "codigo":1010334009,
    "descripcion":"ENFISEMA DE PULMÓN DERECHO"
  },
  {
    "codigo":1303411009,
    "descripcion":"FLASKBACK DEBIDO A EVENTO TRAUMÁTICO Y POSTERIOR A ÉL"
  },
  {
    "codigo":23624004,
    "descripcion":"ASPECTO DE LA SUPERFICIE DE UNA COLONIA BACTERIANA, CREMOSA"
  },
  {
    "codigo":253000007,
    "descripcion":"CARCINOMA NEUROENDOCRINO"
  },
  {
    "codigo":415005004,
    "descripcion":"PANLEUCOPENIA"
  },
  {
    "codigo":1332509007,
    "descripcion":"INSUFICIENCIA OVÁRICA PRIMARIA ASOCIADA AL CROMOSOMA X FRÁGIL"
  },
  {
    "codigo":447773008,
    "descripcion":"VENTANA AORTOPULMONAR PROXIMAL CON BORDE INFERIOR MÍNIMO"
  },
  {
    "codigo":251165007,
    "descripcion":"TAQUICARDIA NODAL"
  },
  {
    "codigo":871922002,
    "descripcion":"REACCIÓN ADVERSA A EXTRACTO ALERGÉNICO"
  },
  {
    "codigo":413170007,
    "descripcion":"RETIRADO DEL REGISTRO DE DEPRESIÓN"
  },
  {
    "codigo":249330009,
    "descripcion":"COLUMELA COLGANTE"
  },
  {
    "codigo":83655001,
    "descripcion":"NISTAGMO POR REBOTE"
  },
  {
    "codigo":247495008,
    "descripcion":"UÑAS QUE SE DESINTEGRAN"
  },
  {
    "codigo":212892002,
    "descripcion":"EFECTOS TÓXICOS PROVOCADO POR EL CONTACTO CON PESCADO"
  },
  {
    "codigo":737180005,
    "descripcion":"BRONQUIOLITIS CRÓNICA"
  },
  {
    "codigo":276593000,
    "descripcion":"LACERACIÓN PERINATAL DE LA HOZ"
  },
  {
    "codigo":1259633002,
    "descripcion":"CARCINOMA PRIMARIO DE ENCÍA SUPERIOR"
  },
  {
    "codigo":702577006,
    "descripcion":"GINGIVITIS CAUSADA POR HISTOPLASMA"
  },
  {
    "codigo":243825007,
    "descripcion":"ESTADO DE ANTICONCEPCIÓN POSCOITAL"
  },
  {
    "codigo":78150000,
    "descripcion":"DIETA BLANDA"
  },
  {
    "codigo":241990001,
    "descripcion":"ENFERMEDAD MUSCULOESQUELÉTICA POR DESCOMPRESIÓN"
  },
  {
    "codigo":211057007,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE PARED ABDOMINAL ANTERIOR"
  },
  {
    "codigo":45382000,
    "descripcion":"PLIEGUES Y\/O RUPTURA DE LA MEMBRANA DE BOWMAN"
  },
  {
    "codigo":373062004,
    "descripcion":"DISPOSITIVO UTILIZADO"
  },
  {
    "codigo":15930101000119109,
    "descripcion":"EDEMA DE AMBOS PÁRPADOS SUPERIORES"
  },
  {
    "codigo":1290566006,
    "descripcion":"RADIOGRAFÍA RADIOCUBITAL NORMAL"
  },
  {
    "codigo":274758007,
    "descripcion":"MASA UMBILICAL"
  },
  {
    "codigo":733510007,
    "descripcion":"EXTENSIÓN DE CUELLO"
  },
  {
    "codigo":240155001,
    "descripcion":"OSTEOPOROSIS GENERALIZADA IDIOPÁTICA DEL ADULTO"
  },
  {
    "codigo":209222008,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA EXPUESTA DE LA PELVIS"
  },
  {
    "codigo":1255963003,
    "descripcion":"DISARTRIA HIPERCINÉTICA"
  },
  {
    "codigo":403995000,
    "descripcion":"DERMATOMIOFIBROMA"
  },
  {
    "codigo":338831000119104,
    "descripcion":"CORIORRETINITIS DISEMINADA PERIFÉRICA IZQUIERDA"
  },
  {
    "codigo":698907006,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: RUANDA"
  },
  {
    "codigo":764443008,
    "descripcion":"REACCIÓN ADVERSA A FENOL CLORADO"
  },
  {
    "codigo":1286896000,
    "descripcion":"CARCINOMA DE CÉLULAS RENALES DE TÚBULO COLECTOR METASTÁSICO"
  },
  {
    "codigo":829979008,
    "descripcion":"CEGUERA COMPLETA DE OJO DERECHO"
  },
  {
    "codigo":762608003,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE LABIO"
  },
  {
    "codigo":305691009,
    "descripcion":"ATENDIDO POR UN OBSTETRA"
  },
  {
    "codigo":402160006,
    "descripcion":"DERMATOSIS CAUSADA POR ÁCARO DE LOS FOLÍCULOS PILOSOS"
  },
  {
    "codigo":271088009,
    "descripcion":"DEFORMIDAD DEL CÚBITO"
  },
  {
    "codigo":105413002,
    "descripcion":"DIFICULTAD EN LA ACULTURACIÓN"
  },
  {
    "codigo":72645004,
    "descripcion":"ÚTERO BICORNE BICERVICAL"
  },
  {
    "codigo":302021008,
    "descripcion":"FALTA DE CRECIMIENTO DE LA BARBA"
  },
  {
    "codigo":236485008,
    "descripcion":"FÍSTULA DE LA PELVIS RENAL"
  },
  {
    "codigo":11781161000119102,
    "descripcion":"RUPTURA TRAUMÁTICA DE TENDÓN DE MÚSCULO ISQUIOTIBIAL DE MIEMBRO INFERIOR DERECHO"
  },
  {
    "codigo":431258001,
    "descripcion":"ENFERMEDAD CAUSADA POR POLIOMAVIRUS TIPO BK"
  },
  {
    "codigo":1119386008,
    "descripcion":"PÉRDIDA DE LA AUDICIÓN NEUROSENSORIAL DE OÍDO DERECHO"
  },
  {
    "codigo":365722008,
    "descripcion":"NIVEL DE BICARBONATO - HALLAZGO"
  },
  {
    "codigo":300186009,
    "descripcion":"HUMEDAD EN CAVIDAD MASTOIDEA"
  },
  {
    "codigo":3439009,
    "descripcion":"INMUNODEFICIENCIA COMBINADA SEVERA POR AUSENCIA DE MADURACIÓN DE CÉLULAS T PERIFÉRICAS"
  },
  {
    "codigo":296516003,
    "descripcion":"SOBREDOSIS DE NALOXONA"
  },
  {
    "codigo":1345092005,
    "descripcion":"SÍNDROME DE ABSTINENCIA DE CORTICOSTEROIDE POSTERIOR A USO TERAPÉUTICO"
  },
  {
    "codigo":1148484005,
    "descripcion":"MEMBRANA UTERINA RETENIDA"
  },
  {
    "codigo":11863081000119106,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE PIEL DE DEDO GORDO DE PIE DERECHO"
  },
  {
    "codigo":15713321000119107,
    "descripcion":"DEFORMIDAD EN VALGO ADQUIRIDA DE ARTICULACIÓN DE AMBAS REGIONES DE LA MUÑECA"
  },
  {
    "codigo":720665007,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR SUCCINATO DE METROPROLOL"
  },
  {
    "codigo":1144814003,
    "descripcion":"RETRASO PSICOMOTOR"
  },
  {
    "codigo":94403001,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA MANDÍBULA"
  },
  {
    "codigo":28867007,
    "descripcion":"GRANULOMA INGUINAL"
  },
  {
    "codigo":225475008,
    "descripcion":"CONDUCTA ABUSIVA EN EL ASPECTO RACIAL"
  },
  {
    "codigo":127171009,
    "descripcion":"LINFADENOPATÍA INTERILÍACA"
  },
  {
    "codigo":92568009,
    "descripcion":"CARCINOMA IN SITU DE COLON"
  },
  {
    "codigo":713325002,
    "descripcion":"LINFOMA CEREBRAL PRIMARIO CONCOMITANTE CON INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":254573006,
    "descripcion":"PÓLIPO DEL ESÓFAGO"
  },
  {
    "codigo":418413009,
    "descripcion":"FÍSTULA EN EL SACO LAGRIMAL"
  },
  {
    "codigo":88898002,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA RAMA PRINCIPAL DE LA ARTERIA MESENTÉRICA SUPERIOR"
  },
  {
    "codigo":1268546006,
    "descripcion":"CISTOADENOCARCINOMA MUCINOSO PRIMARIO DE PÁNCREAS"
  },
  {
    "codigo":283671004,
    "descripcion":"HERIDA POR PINCHAZO DE CLAVO EN LA RODILLA"
  },
  {
    "codigo":185367005,
    "descripcion":"MICROSPOROSIS NIGRA"
  },
  {
    "codigo":21527007,
    "descripcion":"ENFERMEDAD GRANULOMATOSA CRÓNICA, TIPO IV"
  },
  {
    "codigo":609516006,
    "descripcion":"LESIÓN TROFOBLÁSTICA GESTACIONAL"
  },
  {
    "codigo":247233000,
    "descripcion":"HEMORRAGIA DE PAPILA ÓPTICA"
  },
  {
    "codigo":871660009,
    "descripcion":"ANOMALÍA CONGÉNITA DE VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":1230273004,
    "descripcion":"DISTROFIA MUSCULAR CONGÉNITA MEGACONIAL"
  },
  {
    "codigo":769686001,
    "descripcion":"ENCUENTRO ULTERIOR POR SUJETO"
  },
  {
    "codigo":736918003,
    "descripcion":"INFECCIÓN DE TORRENTE SANGUÍNEO ASOCIADA A CATÉTER PARA HEMODIÁLISIS IN SITU"
  },
  {
    "codigo":704150005,
    "descripcion":"FRACTURA EXPUESTA DE FALANGE PROXIMAL DE DEDO MAYOR DE LA MANO"
  },
  {
    "codigo":212630006,
    "descripcion":"INTOXICACIÓN POR COMPUESTO DE BROMO"
  },
  {
    "codigo":276331001,
    "descripcion":"ESCROTO GRANDE"
  },
  {
    "codigo":1259371004,
    "descripcion":"CARCINOMA ESCAMOSO PRIMARIO DE PULMÓN"
  },
  {
    "codigo":702315006,
    "descripcion":"PARÁLISIS CEREBRAL DISTÓNICA"
  },
  {
    "codigo":77888002,
    "descripcion":"ARTRITIS CLIMATÉRICA"
  },
  {
    "codigo":733248003,
    "descripcion":"MÚLTIPLES HERIDAS ABIERTAS DE MUÑECA"
  },
  {
    "codigo":16250001000004107,
    "descripcion":"FRACTURA DE HOMBRO"
  },
  {
    "codigo":403733004,
    "descripcion":"PRURITO ASOCIADO CON HEMODIÁLISIS"
  },
  {
    "codigo":895253005,
    "descripcion":"FORMA TRIANGULAR ANORMAL CONGÉNITA DE FALANGE DE DEDO MEDIO"
  },
  {
    "codigo":16426641000119101,
    "descripcion":"ARTRITIS DE ARTICULACIÓN CIGOAPOFISARIA DE COLUMNA VERTEBRAL LUMBAR"
  },
  {
    "codigo":762346000,
    "descripcion":"TRASTORNO DEL ESTADO DE ÁNIMO CON SÍNTOMAS DEPRESIVOS Y MANÍACOS MIXTOS CAUSADO POR FÁRMACO DISOCIATIVO"
  },
  {
    "codigo":11839121000119103,
    "descripcion":"DISTENSIÓN DE MÚSCULO INTRÍNSECO DEL PULGAR DERECHO"
  },
  {
    "codigo":74218008,
    "descripcion":"ARTERIA CORONARIA EMERGENTE DE LA ARTERIA PULMONAR PRINCIPAL"
  },
  {
    "codigo":400063003,
    "descripcion":"NEOPLASIA DE REGIÓN CUTÁNEA"
  },
  {
    "codigo":365460000,
    "descripcion":"EDUCACIÓN RECIBIDA PREVIAMENTE - HALLAZGO"
  },
  {
    "codigo":299924004,
    "descripcion":"DISCRIMINACIÓN TÁCTIL: NORMAL"
  },
  {
    "codigo":37780006,
    "descripcion":"ENFERMEDAD POR EL VIRUS ILESHA"
  },
  {
    "codigo":725908007,
    "descripcion":"SÍNDROME NEUROFACIODIGITORRENAL"
  },
  {
    "codigo":298089000,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DEL ABDOMEN"
  },
  {
    "codigo":168852008,
    "descripcion":"PIELOGRAFÍA INTRAVENOSA ANORMAL"
  },
  {
    "codigo":234388009,
    "descripcion":"TALASEMIA DELTA-BETA"
  },
  {
    "codigo":396393005,
    "descripcion":"INVASIÓN PERINEURAL POR TUMOR NO DETERMINADO"
  },
  {
    "codigo":68713009,
    "descripcion":"INFECCIÓN CAUSADA POR ANATRICHOSOMA"
  },
  {
    "codigo":230718007,
    "descripcion":"HEMORRAGIA SUBARACNOIDEA POR RUPTURA DE MALFORMACIÓN ARTERIOVENOSA"
  },
  {
    "codigo":42391000087100,
    "descripcion":"HERIDA PUNZANTE DE REGIÓN DE RODILLA IZQUIERDA CON CUERPO EXTRAÑO"
  },
  {
    "codigo":34711000087102,
    "descripcion":"ASPERGILLUS CALIDOUSTUS O ASPERGILLUS USTUS"
  },
  {
    "codigo":196115007,
    "descripcion":"CONGESTIÓN E HIPOSTASIS PULMONAR"
  },
  {
    "codigo":47511000087103,
    "descripcion":"CONSENTIMIENTO LIBRE E INFORMADO PARA PROCEDIMIENTO ENTREGADO"
  },
  {
    "codigo":425491009,
    "descripcion":"CONTRACTURA DE MÚSCULOS GEMELOS POR PARÁLISIS"
  },
  {
    "codigo":55191000087106,
    "descripcion":"CON MAYOR RIESGO DE SÍNDROME DE ABSTINENCIA DE SUSTANCIA"
  },
  {
    "codigo":39831000087103,
    "descripcion":"LUXACIÓN ANTERIOR DE HOMBRO DERECHO"
  },
  {
    "codigo":30440004,
    "descripcion":"LINFOMA ESTADIO I"
  },
  {
    "codigo":52631000087109,
    "descripcion":"CITROBACTER AMALONATICUS O CITROBACTER FARMERI"
  },
  {
    "codigo":1144552006,
    "descripcion":"APLASIA DE COLON"
  },
  {
    "codigo":423656007,
    "descripcion":"INGRESOS INSUFICIENTES PARA COMPRAR LO INDISPENSABLE"
  },
  {
    "codigo":292584008,
    "descripcion":"REACCIÓN ADVERSA A LA PROMETAZINA"
  },
  {
    "codigo":1275624008,
    "descripcion":"NEUROPATÍA DE NERVIO TIBIAL POSTERIOR IZQUIERDO"
  },
  {
    "codigo":421821002,
    "descripcion":"HIPOGONADISMO HIPOGONADOTRÓFICO POR DEFICIENCIA DE LA HORMONA LUTEINIZANTE"
  },
  {
    "codigo":317381000119101,
    "descripcion":"DETENCIÓN PARCIAL DEL CRECIMIENTO EPIFISARIO DE HÚMERO DISTAL IZQUIERDO"
  },
  {
    "codigo":126909004,
    "descripcion":"NEOPLASIA DEL CUERPO DEL ÚTERO"
  },
  {
    "codigo":290749004,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR TRILOSTANO"
  },
  {
    "codigo":61373006,
    "descripcion":"BACTERIURIA"
  },
  {
    "codigo":1306557002,
    "descripcion":"CARCINOMA DUCTAL INFILTRANTE DE PORCIÓN CENTRAL DE MAMA IZQUIERDA"
  },
  {
    "codigo":288914003,
    "descripcion":"INCAPAZ DE RETIRAR ALIMENTO DEL SURCO YUGAL"
  },
  {
    "codigo":59538008,
    "descripcion":"INTOXICACIÓN POR ACONITUM"
  },
  {
    "codigo":92306009,
    "descripcion":"NEOPLASIA BENIGNA DE LOS GANGLIOS LINFÁTICOS PREAURICULARES"
  },
  {
    "codigo":450919004,
    "descripcion":"PARO AURICULAR"
  },
  {
    "codigo":90471005,
    "descripcion":"CONFLICTO DE ACERCAMIENTO - ACERCAMIENTO"
  },
  {
    "codigo":449084002,
    "descripcion":"SEPSIS CAUSADA POR SERRATIA"
  },
  {
    "codigo":416316005,
    "descripcion":"BLEFARITIS ANGULAR"
  },
  {
    "codigo":447249001,
    "descripcion":"QUISTE BENIGNO DE OVARIO"
  },
  {
    "codigo":21265004,
    "descripcion":"ENANISMO INFANTIL"
  },
  {
    "codigo":86801005,
    "descripcion":"EDAD GESTACIONAL, 6 SEMANAS"
  },
  {
    "codigo":773094000,
    "descripcion":"HERNIA DE PARED ABDOMINAL CON GANGRENA"
  },
  {
    "codigo":283409009,
    "descripcion":"CORTE EN EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":1231846001,
    "descripcion":"PSICOSIS CAUSADA POR ETANOL"
  },
  {
    "codigo":52198001,
    "descripcion":"TENDENCIA AMBIVALENTE"
  },
  {
    "codigo":840465008,
    "descripcion":"DEMENCIA DEBIDA A DEFICIENCIA DE HIERRO"
  },
  {
    "codigo":248806007,
    "descripcion":"MAMAS DE DIFERENTE TAMAÑO"
  },
  {
    "codigo":246971005,
    "descripcion":"RUPTURA DE PATRÓN ENDOTELIAL DE LA CÓRNEA"
  },
  {
    "codigo":277904004,
    "descripcion":"ESPUTO LÍQUIDO"
  },
  {
    "codigo":48528004,
    "descripcion":"EPIDERMÓLISIS BULLOSA DISTRÓFICA RECESIVA"
  },
  {
    "codigo":276069001,
    "descripcion":"AUSENTE POR RAZONES SOCIALES"
  },
  {
    "codigo":865893006,
    "descripcion":"COMPRESIÓN DE TRÁQUEA DEBIDA A ALIMENTO ALOJADO EN EL ESÓFAGO"
  },
  {
    "codigo":208698000,
    "descripcion":"FRACTURA EXPUESTA DEL ASTRÁGALO, CUERPO ASTRAGALINO"
  },
  {
    "codigo":1259109009,
    "descripcion":"RINORRAQUIA DEBIDA A HIDROCEFALIA"
  },
  {
    "codigo":15665401000119102,
    "descripcion":"COLOBOMA CORIORRETINIANO CONGÉNITO DE AMBOS OJOS"
  },
  {
    "codigo":1255439001,
    "descripcion":"HERIDA ABIERTA DE REGIÓN DE CODO DEBIDA A MORDEDURA DE ANIMAL"
  },
  {
    "codigo":346361000119104,
    "descripcion":"DACRIOPS BILATERAL"
  },
  {
    "codigo":403471006,
    "descripcion":"AFTOSIS DE GLANDE DE PENE"
  },
  {
    "codigo":1222671009,
    "descripcion":"ACIDURIA 3-METILGLUTACÓNICA TIPO 8"
  },
  {
    "codigo":41188003,
    "descripcion":"TRASTORNO DE PARTES BLANDAS DE LA CAVIDAD BUCAL"
  },
  {
    "codigo":270564006,
    "descripcion":"PACIENTE REGISTRADO: FORMULARIO ENVIADO A AUTORIDADES SANITARIAS"
  },
  {
    "codigo":237796007,
    "descripcion":"TUMOR SUPRARRENAL VIRILIZANTE"
  },
  {
    "codigo":235961002,
    "descripcion":"ENFERMEDAD POLIQUÍSTICA DEL PÁNCREAS"
  },
  {
    "codigo":268729004,
    "descripcion":"CAMBIO PERSISTENTE DE LA PERSONALIDAD DESPUÉS DE UNA EXPERIENCIA CATASTRÓFICA"
  },
  {
    "codigo":203193005,
    "descripcion":"OSTEOMIELITIS CRÓNICA DE LA COLUMNA VERTEBRAL CERVICAL"
  },
  {
    "codigo":301497008,
    "descripcion":"CAPAZ DE MOVILIZARSE EN EL INTERIOR DE UN LUGAR"
  },
  {
    "codigo":234126001,
    "descripcion":"APLASIA VENOSA PROFUNDA"
  },
  {
    "codigo":299662004,
    "descripcion":"PELVIS SIMÉTRICA"
  },
  {
    "codigo":4750004,
    "descripcion":"FRACTURA EXPUESTA DE CÓNDILO INTERNO DE HÚMERO"
  },
  {
    "codigo":15638931000119103,
    "descripcion":"DERRAME DE ARTICULACIÓN DE AMBAS RODILLAS"
  },
  {
    "codigo":365198006,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA LAVARSE EL PELO"
  },
  {
    "codigo":363363001,
    "descripcion":"NEOPLASIA MALIGNA DE PARTES BLANDAS DE HOMBRO"
  },
  {
    "codigo":68451005,
    "descripcion":"ARTRITIS GOTOSA CRÓNICA"
  },
  {
    "codigo":232291005,
    "descripcion":"DISFUNCIÓN LABERÍNTICA HIPERACTIVA"
  },
  {
    "codigo":295992002,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE PRIMIDONA"
  },
  {
    "codigo":721976003,
    "descripcion":"SÍNDROME DE AGENESIA PULMONAR CON DEFECTO CARDÍACO Y ANOMALÍA DE PULGAR"
  },
  {
    "codigo":164920002,
    "descripcion":"ELECTROCARDIOGRAMA: ONDA R NORMAL"
  },
  {
    "codigo":671471000124102,
    "descripcion":"INCAPAZ DE OBTENER CUIDADOR PARA ADULTO DEPENDIENTE DEBIDO A RECURSOS ECONÓMICOS LIMITADOS"
  },
  {
    "codigo":230456007,
    "descripcion":"ESTADO EPILÉPTICO"
  },
  {
    "codigo":650991000124104,
    "descripcion":"VÍCTIMA DE VIOLENCIA POR PARTE DE PAREJA ÍNTIMA DURANTE EMBARAZO"
  },
  {
    "codigo":197688006,
    "descripcion":"SÍNDROME NEFRÍTICO AGUDO, GLOMERULONEFRITIS SEMILUNAR DIFUSA"
  },
  {
    "codigo":294157003,
    "descripcion":"ALERGIA A XANTINA"
  },
  {
    "codigo":392461003,
    "descripcion":"PUPILA ECTÓPICA CONGÉNITA"
  },
  {
    "codigo":64781005,
    "descripcion":"FORMA DE UNA COLONIA BACTERIANA, CIRCULAR"
  },
  {
    "codigo":1177058004,
    "descripcion":"TRASTORNO DE TICS DEBIDO A ENCEFALITIS"
  },
  {
    "codigo":194018005,
    "descripcion":"EXOFTALMÍA POR DESPLAZAMIENTO LATERAL DEL GLOBO OCULAR"
  },
  {
    "codigo":95714006,
    "descripcion":"HIPOPLASIA DEL IRIS"
  },
  {
    "codigo":128482007,
    "descripcion":"TRASTORNO INFLAMATORIO AGUDO"
  },
  {
    "codigo":1339063000,
    "descripcion":"FRACTURA DE FALANGE DE PIE IZQUIERDO"
  },
  {
    "codigo":292322008,
    "descripcion":"REACCIÓN ADVERSA AL METILFENOBARBITAL"
  },
  {
    "codigo":716471001,
    "descripcion":"CAPAZ DE UTILIZAR UN PATIO DE JUEGOS"
  },
  {
    "codigo":156051000119109,
    "descripcion":"RINITIS ALÉRGICA CAUSADA POR PELO Y CASPA DE ANIMAL"
  },
  {
    "codigo":93879004,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE HUESO SEMILUNAR"
  },
  {
    "codigo":126647006,
    "descripcion":"NEOPLASIA DE LA REGIÓN SACROCOCCÍGEA"
  },
  {
    "codigo":224951007,
    "descripcion":"PERSONALIDAD MADURA"
  },
  {
    "codigo":290487006,
    "descripcion":"INTOXICACIÓN POR ETOMIDATO"
  },
  {
    "codigo":59276001,
    "descripcion":"RETINOPATÍA PROLIFERATIVA DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":1306295006,
    "descripcion":"NEOPLASIA MALIGNA DE PEZÓN Y ARÉOLA"
  },
  {
    "codigo":288652004,
    "descripcion":"CAPAZ DE SUMARSE A UNA CONVERSACIÓN"
  },
  {
    "codigo":92044005,
    "descripcion":"NEOPLASIA BENIGNA DEL CUERPO CAROTÍDEO"
  },
  {
    "codigo":714636006,
    "descripcion":"BORDE GINGIVAL INCONSTANTE DEBIDO A DEFORMIDAD DE LA UNIÓN MUCOGINGIVAL"
  },
  {
    "codigo":450657002,
    "descripcion":"BOMBA DE INSULINA PRESENTE"
  },
  {
    "codigo":286817002,
    "descripcion":"TIENDE A SER DESORGANIZADO"
  },
  {
    "codigo":1237089009,
    "descripcion":"EFECTO TÓXICO CAUSADO POR AGENTE PARA ACUARIO"
  },
  {
    "codigo":416054002,
    "descripcion":"CONJUNTIVITIS CICATRIZANTE POSINFECCIOSA"
  },
  {
    "codigo":254049009,
    "descripcion":"DISPLASIA DE SCHNECKENBECKEN"
  },
  {
    "codigo":88374002,
    "descripcion":"QUEMADURA DE DEDO DEL PIE"
  },
  {
    "codigo":186678004,
    "descripcion":"QUERATOCONJUNTIVITIS CAUSADA POR ADENOVIRUS"
  },
  {
    "codigo":284982001,
    "descripcion":"NO SE CALZA"
  },
  {
    "codigo":679701000119100,
    "descripcion":"NEURITIS ÓPTICA RETROBULBAR DE OJO IZQUIERDO"
  },
  {
    "codigo":184843000,
    "descripcion":"EXAMEN Y ELECTROCARDIOGRAMA PARA SEGURO DE VIDA COMPLETADOS"
  },
  {
    "codigo":53771000,
    "descripcion":"ESOFAGITIS POR REGURGITACIÓN"
  },
  {
    "codigo":448822006,
    "descripcion":"DEFICIENCIA DE VALVA DE VÁLVULA AURICULOVENTRICULAR EN DEFECTO DE TABIQUE AURICULOVENTRICULAR"
  },
  {
    "codigo":8968000,
    "descripcion":"INTOXICACIÓN POR GÉNERO GEIGERIA"
  },
  {
    "codigo":283147005,
    "descripcion":"ANZUELO EN EL LABIO"
  },
  {
    "codigo":707296001,
    "descripcion":"XEROSTOMÍA DEBIDA A DESHIDRATACIÓN"
  },
  {
    "codigo":1231584002,
    "descripcion":"OBSTRUCCIÓN DE LUMEN DE VÍA RESPIRATORIA CAUSADA POR INHALACIÓN DE ALIMENTO"
  },
  {
    "codigo":445152004,
    "descripcion":"INFLAMACIÓN DE INTESTINO CAUSADA POR NOROVIRUS"
  },
  {
    "codigo":838368005,
    "descripcion":"HIPERTRICOSIS GENERALIZADA CONGÉNITA"
  },
  {
    "codigo":443317002,
    "descripcion":"PROGENITOR BRINDA CUIDADO A TIEMPO COMPLETO"
  },
  {
    "codigo":246709002,
    "descripcion":"MOVIMIENTOS OCULARES QUE ANTICIPAN LA TRAYECTORIA DE UNA PELOTA QUE RUEDA"
  },
  {
    "codigo":17333005,
    "descripcion":"NACIMIENTO DE TÉRMINO DE RECIÉN NACIDOS MÚLTIPLES"
  },
  {
    "codigo":1295285007,
    "descripcion":"QUILORREA DE GENITALES EXTERNOS"
  },
  {
    "codigo":703626001,
    "descripcion":"LINFOMA ANAPLÁSICO DE CÉLULAS GRANDES, LINFOCITOS T\/NULOS, TIPO SISTÉMICO PRIMARIO"
  },
  {
    "codigo":10670791000119109,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN EN CODO IZQUIERDO NO ESTADIFICABLE"
  },
  {
    "codigo":15995591000119109,
    "descripcion":"GLAUCOMA DE OJO IZQUIERDO DEBIDO A IRIS PLANO"
  },
  {
    "codigo":81034007,
    "descripcion":"INTOXICACIÓN POR ALGAS AZUL-VERDES"
  },
  {
    "codigo":212106008,
    "descripcion":"QUEMADURA QUE COMPROMETE 80-89 PORCIENTO DE LA SUPERFICIE DEL CUERPO, CON QUEMADURA DE ESPESOR COMPLETO QUE AFECTA 20-29 PORCIENTO DE LA SUPERFICIE CORPORAL"
  },
  {
    "codigo":277642008,
    "descripcion":"LINFOMA T DE BAJO GRADO"
  },
  {
    "codigo":275807006,
    "descripcion":"TINCIÓN ERITROCÍTICA - HALLAZGO"
  },
  {
    "codigo":243039006,
    "descripcion":"LESIÓN POR EXPLOSIÓN DE TORPEDO"
  },
  {
    "codigo":767327009,
    "descripcion":"AUSENCIA CONGÉNITA DE HEMIDIAFRAGMA DERECHO"
  },
  {
    "codigo":11791201000119106,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE MANO DERECHA"
  },
  {
    "codigo":208436006,
    "descripcion":"FRACTURA NO EXPUESTA DE FALANGE PROXIMAL DE PULGAR, DIÁFISIS"
  },
  {
    "codigo":110132007,
    "descripcion":"LACERACIÓN COMPLEJA CONTAMINADA DEL PALADAR BLANDO"
  },
  {
    "codigo":75529001,
    "descripcion":"INTOXICACIÓN POR FÓSFORO"
  },
  {
    "codigo":322401000119107,
    "descripcion":"HIPERTROFIA DE MEMBRANA SINOVIAL DE ARTICULACIÓN GLENOHUMERAL DERECHA"
  },
  {
    "codigo":303070000,
    "descripcion":"MALFORMACIÓN ARTERIOVENOSA PULMONAR"
  },
  {
    "codigo":763657009,
    "descripcion":"SIGMOIDOSTOMÍA PRESENTE"
  },
  {
    "codigo":1220574003,
    "descripcion":"TRASTORNO CONGÉNITO DE LA GLICOSILACIÓN TIPO IIL"
  },
  {
    "codigo":40926005,
    "descripcion":"TRASTORNO BIPOLAR I MIXTO MODERADO"
  },
  {
    "codigo":204766008,
    "descripcion":"QUISTE ENTERÓGENO"
  },
  {
    "codigo":268467002,
    "descripcion":"INTENCIÓN ALIMENTARIA"
  },
  {
    "codigo":132091000119104,
    "descripcion":"TROMBOSIS VENOSA PROFUNDA CRÓNICA DE MIEMBRO INFERIOR DEBIDA A Y DESPUÉS DE INJERTO-PUENTE DE ARTERIA CORONARIA"
  },
  {
    "codigo":355121000119100,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE HUESO DE MANO"
  },
  {
    "codigo":15663921000119101,
    "descripcion":"HEMARTROSIS DE ARTICULACIÓN DE AMBAS MANOS"
  },
  {
    "codigo":321841000119102,
    "descripcion":"RIGIDEZ DE ARTICULACIÓN DE LA CADERA DERECHA"
  },
  {
    "codigo":672561000119103,
    "descripcion":"DÉFICIT COGNITIVO DEBIDO A ACCIDENTE CEREBROVASCULAR ISQUÉMICO Y POSTERIOR A ÉL"
  },
  {
    "codigo":15676721000119104,
    "descripcion":"MIOSITIS DE MANO DERECHA"
  },
  {
    "codigo":16623921000119105,
    "descripcion":"VIRUS HEPATITIS C EN MADRE DURANTE EMBARAZO"
  },
  {
    "codigo":339761000119106,
    "descripcion":"LAGOFTALMOS DE PÁRPADO INFERIOR IZQUIERDO"
  },
  {
    "codigo":10953521000119107,
    "descripcion":"HERIDA ABIERTA DE DEDO MEDIO DE MANO DERECHA DEBIDA A MORDEDURA DE GATO"
  },
  {
    "codigo":288561000119106,
    "descripcion":"PROBLEMA RELACIONADO CON LA LIBERACIÓN DE PRISIÓN"
  },
  {
    "codigo":303921000119109,
    "descripcion":"GOTA TOFÁCEA CRÓNICA DE MANO DEBIDA A DISFUNCIÓN RENAL"
  },
  {
    "codigo":296241000119107,
    "descripcion":"TRASTORNO DEL SISTEMA RESPIRATORIO DEBIDO A DERMATOMIOSITIS"
  },
  {
    "codigo":11995441000119103,
    "descripcion":"CONTRACTURA DE MUÑÓN DE AMPUTACIÓN DE EXTREMIDAD INFERIOR DERECHA"
  },
  {
    "codigo":364936003,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD DE CONTROLAR LA POSTURA"
  },
  {
    "codigo":15748401000119109,
    "descripcion":"ESPASMO MUSCULAR DE AMBAS PANTORRILLAS"
  },
  {
    "codigo":461405002,
    "descripcion":"ORIGEN NORMAL DE LIGAMENTO ARTERIOSO EN CAYADO AÓRTICO IZQUIERDO"
  },
  {
    "codigo":91441000119109,
    "descripcion":"APNEA DEL SUEÑO CENTRAL CAUSADA POR ALTITUD ELEVADA"
  },
  {
    "codigo":428637004,
    "descripcion":"MASA DE ARTICULACIÓN DE LA CADERA"
  },
  {
    "codigo":232029005,
    "descripcion":"CRIOTERAPIA EN LA RETINA"
  },
  {
    "codigo":40241000119109,
    "descripcion":"HEMORRAGIA GÁSTRICA DEBIDA A GASTRITIS ALCOHÓLICA"
  },
  {
    "codigo":233864007,
    "descripcion":"INSUFICIENCIA AÓRTICA POR NECROSIS MEDIA QUÍSTICA DE LA AORTA"
  },
  {
    "codigo":351381000119101,
    "descripcion":"NEOPLASIA BENIGNA DE MAMA DERECHA"
  },
  {
    "codigo":33586001,
    "descripcion":"SENTADO"
  },
  {
    "codigo":721714001,
    "descripcion":"FÍSTULA ARTERIOVENOSA DE LA CIRCULACIÓN ESPLÁCNICA"
  },
  {
    "codigo":197426003,
    "descripcion":"FÍSTULA COLECISTOGÁSTRICA"
  },
  {
    "codigo":230194002,
    "descripcion":"ENCEFALOPATÍA EN LA ENFERMEDAD DE WHIPPLE"
  },
  {
    "codigo":818005,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO DE MÚLTIPLES SITIOS DE MIEMBRO INFERIOR"
  },
  {
    "codigo":66354006,
    "descripcion":"COMPLICACIÓN DE PROCEDIMIENTO DE PERFUSIÓN"
  },
  {
    "codigo":679061000119102,
    "descripcion":"DESPRENDIMIENTO DE MEMBRANA DE DESCEMET DE OJO IZQUIERDO"
  },
  {
    "codigo":293895002,
    "descripcion":"ALERGIA A CLOBAZAM"
  },
  {
    "codigo":228359005,
    "descripcion":"DIFICULTAD PARA LEVANTARSE DESPUÉS DE BEBER"
  },
  {
    "codigo":128220004,
    "descripcion":"ABSCESO DE HUESO CRANEAL"
  },
  {
    "codigo":95452006,
    "descripcion":"TROMBOFLEBITIS DE LAS VENAS PROFUNDAS DE LAS EXTREMIDADES SUPERIORES"
  },
  {
    "codigo":292060007,
    "descripcion":"REACCIÓN ADVERSA A UN ALCALOIDE OPIÁCEO"
  },
  {
    "codigo":193756007,
    "descripcion":"SÍNDROME DE CHARLES BONNET"
  },
  {
    "codigo":880049002,
    "descripcion":"INSUFICIENCIA ADQUIRIDA DE ESTRUCTURA VENTRICULAR DERECHA DE LA VÁLVULA AURICULOVENTRICULAR COMÚN POSTERIOR A REPARACIÓN DE COMUNICACIÓN BIVENTRICULAR"
  },
  {
    "codigo":28081005,
    "descripcion":"FRACTURA EXPUESTA DE MÚLTIPLES COSTILLAS"
  },
  {
    "codigo":288390000,
    "descripcion":"ESCURRE ROPA"
  },
  {
    "codigo":93617009,
    "descripcion":"FALTA DE OSIFICACIÓN DE HUESO ALIESFENOIDAL"
  },
  {
    "codigo":10837141000119109,
    "descripcion":"FRACTURA EXPUESTA DE DIÁFISIS DE SEGUNDO HUESO METACARPIANO DE MANO IZQUIERDA"
  },
  {
    "codigo":286555004,
    "descripcion":"LESIÓN DEL PERINEO MASCULINO"
  },
  {
    "codigo":778075008,
    "descripcion":"PITIRIASIS SIMPLE DEL CUERO CABELLUDO"
  },
  {
    "codigo":12203311000119105,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DE PIERNA IZQUIERDA"
  },
  {
    "codigo":186416004,
    "descripcion":"GANGRENA GASEOSA DE HOMBRO"
  },
  {
    "codigo":53509000,
    "descripcion":"MIOPATÍA EN LA ENFERMEDAD DE CUSHING"
  },
  {
    "codigo":448560008,
    "descripcion":"LINFOMA NO HODGKIN DIFUSO DE LOCALIZACIÓN EXTRAGANGLIONAR"
  },
  {
    "codigo":250117003,
    "descripcion":"CREPITACIÓN RETRORROTULIANA"
  },
  {
    "codigo":282885004,
    "descripcion":"NO SE PARA DESDE POSICIÓN SENTADA"
  },
  {
    "codigo":281050002,
    "descripcion":"PARTO DE FETO VIVO"
  },
  {
    "codigo":211844000,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO PROFUNDA DE AXILA"
  },
  {
    "codigo":15236003,
    "descripcion":"CUERPO EXTRAÑO MAGNÉTICO RETENIDO EN LA PARED POSTERIOR DEL OJO"
  },
  {
    "codigo":13401001,
    "descripcion":"ABLÉFARON"
  },
  {
    "codigo":111705004,
    "descripcion":"AMPOLLA DEL TRONCO, CON INFECCIÓN"
  },
  {
    "codigo":406617004,
    "descripcion":"ENFERMEDAD INVASORA POR STREPTOCOCCUS PNEUMONIAE"
  },
  {
    "codigo":699694000,
    "descripcion":"CEFALEA CRÓNICA POST-CONMOCIÓN"
  },
  {
    "codigo":372014001,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL ESTÓMAGO"
  },
  {
    "codigo":208174006,
    "descripcion":"FRACTURA EXPUESTA INESTABLE DE RAMAS PÚBICAS MÚLTIPLES"
  },
  {
    "codigo":109870007,
    "descripcion":"NEOPLASIA SUPERPUESTA MALIGNA DE LAS VÍAS URINARIAS"
  },
  {
    "codigo":402947001,
    "descripcion":"SÍFILIS SECUNDARIA TARDÍA"
  },
  {
    "codigo":304643002,
    "descripcion":"INCAPAZ DE RAZONAR"
  },
  {
    "codigo":239107007,
    "descripcion":"NEVO EPIDÉRMICO"
  },
  {
    "codigo":1254915007,
    "descripcion":"HIDRADENITIS SUPURATIVA DE SITIOS MÚLTIPLES"
  },
  {
    "codigo":106200001,
    "descripcion":"HALLAZGO EN EL SISTEMA HEMATOPOYÉTICO"
  },
  {
    "codigo":237272003,
    "descripcion":"HEMORRAGIA PREPARTO CON AFIBRINOGENEMIA"
  },
  {
    "codigo":169901001,
    "descripcion":"PUNTAJE DE APGAR AL MINUTO = 4"
  },
  {
    "codigo":71597002,
    "descripcion":"INTOXICACIÓN POR SAL DE FOSFATO"
  },
  {
    "codigo":268205005,
    "descripcion":"ATRESIA Y ESTENOSIS DE INTESTINO GRUESO, RECTO Y CONDUCTO ANAL"
  },
  {
    "codigo":366509006,
    "descripcion":"AMPLITUD DE LA EXTENSIÓN DE CODO - HALLAZGO"
  },
  {
    "codigo":200834004,
    "descripcion":"QUEMADURA SOLAR DE SEGUNDO GRADO"
  },
  {
    "codigo":36994005,
    "descripcion":"PÉRDIDA VISUAL TRANSITORIA"
  },
  {
    "codigo":266370006,
    "descripcion":"TRAUMA E INSUFICIENCIA PULMONAR POSOPERATORIA"
  },
  {
    "codigo":233602006,
    "descripcion":"BRONQUIOLITIS VIRAL AGUDA"
  },
  {
    "codigo":725122008,
    "descripcion":"MICROGRAFISMO"
  },
  {
    "codigo":2391001,
    "descripcion":"ACONDROGÉNESIS"
  },
  {
    "codigo":721452001,
    "descripcion":"SÍNDROME DEL CORDÓN CENTRAL DE MÉDULA ESPINAL AL NIVEL DEL DÉCIMO SEGMENTO DORSAL"
  },
  {
    "codigo":262700007,
    "descripcion":"CONTUSIÓN DE MÉDULA ESPINAL SACRA"
  },
  {
    "codigo":197164008,
    "descripcion":"ABSCESO DE FISURA ANORRECTAL"
  },
  {
    "codigo":129793001,
    "descripcion":"DENSIDAD MAMARIA SEGÚN LA MAMOGRAFÍA"
  },
  {
    "codigo":293633005,
    "descripcion":"ALERGIA A TOLMETINA"
  },
  {
    "codigo":162561006,
    "descripcion":"PREOCUPADO POR EL ASPECTO FÍSICO"
  },
  {
    "codigo":1078230004,
    "descripcion":"DERMATITIS IRRITATIVA POR CONTACTO CON JOYAS"
  },
  {
    "codigo":160726006,
    "descripcion":"VIVE SOLO SIN AYUDA DISPONIBLE"
  },
  {
    "codigo":191659001,
    "descripcion":"TRASTORNO DEPRESIVO ATÍPICO"
  },
  {
    "codigo":27819004,
    "descripcion":"OSIFICACIÓN PULMONAR"
  },
  {
    "codigo":224427008,
    "descripcion":"CANTINA ADECUADA EN EL TRABAJO"
  },
  {
    "codigo":124288003,
    "descripcion":"DEFICIENCIA DE LEUCINA AMINOTRANSFERASA"
  },
  {
    "codigo":187989003,
    "descripcion":"NEOPLASIA MALIGNA DE PARTES BLANDAS DE LA COLUMNA VERTEBRAL CERVICAL"
  },
  {
    "codigo":24149006,
    "descripcion":"ENFERMEDAD HEMORRÁGICA DEL RECIÉN NACIDO POR DEFICIENCIA DE FACTOR II"
  },
  {
    "codigo":253525008,
    "descripcion":"DIVERTÍCULO VENTRICULAR DERECHO CONGÉNITO"
  },
  {
    "codigo":55082002,
    "descripcion":"INTOXICACIÓN POR CICLOSERINA"
  },
  {
    "codigo":448298007,
    "descripcion":"MELANOMA MALIGNO DE PIEL DEL PENE"
  },
  {
    "codigo":415530009,
    "descripcion":"OBESIDAD SIMPLE"
  },
  {
    "codigo":317226009,
    "descripcion":"GRANULOCITOSIS"
  },
  {
    "codigo":774143003,
    "descripcion":"ESPASMO DEL MÚSCULO PIRAMIDAL DERECHO"
  },
  {
    "codigo":1003519005,
    "descripcion":"AGENESIA DE ASTRÁGALO"
  },
  {
    "codigo":282623006,
    "descripcion":"NO RUEDA"
  },
  {
    "codigo":249855007,
    "descripcion":"POBRE CONTROL DEL TRONCO"
  },
  {
    "codigo":315391005,
    "descripcion":"NACIDO EN BRUNEI"
  },
  {
    "codigo":248020004,
    "descripcion":"CONDUCTA EXTRAVAGANTE"
  },
  {
    "codigo":18644006,
    "descripcion":"TONICIDAD GÁSTRICA AUMENTADA"
  },
  {
    "codigo":82345001,
    "descripcion":"SIGNO DE BRUDZINSKI"
  },
  {
    "codigo":15675441000119107,
    "descripcion":"TENDINITIS DE PIE DERECHO"
  },
  {
    "codigo":28721000119108,
    "descripcion":"MIELITIS POSTERIOR A VARICELA"
  },
  {
    "codigo":211582000,
    "descripcion":"LESIÓN TRAUMÁTICA CERRADA POR APLASTAMIENTO DE DEDO DE MANO"
  },
  {
    "codigo":277118005,
    "descripcion":"LATENCIA INTERHEMISFÉRICA CRUZADA ASIMÉTRICA"
  },
  {
    "codigo":735870007,
    "descripcion":"MORDEDURA ABIERTA DE PIE"
  },
  {
    "codigo":45907000,
    "descripcion":"PULSO LÁBIL"
  },
  {
    "codigo":78675000,
    "descripcion":"SÍNDROME DE STICKLER"
  },
  {
    "codigo":373587001,
    "descripcion":"MALFORMACIÓN DE CHIARI, TIPO II"
  },
  {
    "codigo":209747006,
    "descripcion":"SECCIÓN EXPUESTA DE LIGAMENTO ESTERNAL"
  },
  {
    "codigo":109608003,
    "descripcion":"QUISTE RESIDUAL"
  },
  {
    "codigo":404520004,
    "descripcion":"SIN HALLAZGO DE CHLAMYDIA TRACHOMATIS"
  },
  {
    "codigo":1254653000,
    "descripcion":"INESTABILIDAD MULTIDIRECCIONAL DE ARTICULACIÓN ESCAPULOHUMERAL"
  },
  {
    "codigo":402685001,
    "descripcion":"POIQUILODERMIA"
  },
  {
    "codigo":76840008,
    "descripcion":"HIPERTROFIA DE LA VESÍCULA SEMINAL"
  },
  {
    "codigo":271613005,
    "descripcion":"TUMEFACCIÓN PAROTÍDEA"
  },
  {
    "codigo":763133008,
    "descripcion":"COLOBOMA DE PÁRPADO INFERIOR"
  },
  {
    "codigo":366247000,
    "descripcion":"FUNCIÓN DE LA PRÓTESIS MAXILOFACIAL - HALLAZGO"
  },
  {
    "codigo":202407001,
    "descripcion":"HEMARTROSIS DE MUÑECA"
  },
  {
    "codigo":890535001,
    "descripcion":"DERMATITIS PAPILOMATOSA CRÓNICA POR CONTACTO CON ORINA Y\/O MATERIA FECAL"
  },
  {
    "codigo":300711001,
    "descripcion":"DIFICULTAD PARA USAR TARJETA DE CRÉDITO"
  },
  {
    "codigo":38567007,
    "descripcion":"FRACTURA DE TECHO DE ÓRBITA"
  },
  {
    "codigo":5799008,
    "descripcion":"REFLEJO NAUSEOSO HIPOACTIVO"
  },
  {
    "codigo":397180001,
    "descripcion":"HERIDA ABIERTA EN CABEZA Y\/O CUELLO"
  },
  {
    "codigo":724860007,
    "descripcion":"BOLSA OCULAR POR DEFORMIDAD DEL PÁRPADO INFERIOR"
  },
  {
    "codigo":69500007,
    "descripcion":"TRASTORNO DE LA COAGULACIÓN SANGUÍNEA POR ENFERMEDAD HEPÁTICA"
  },
  {
    "codigo":266108008,
    "descripcion":"ESTOMATITIS VESICULAR ENTEROVIRAL CON EXANTEMA"
  },
  {
    "codigo":2129002,
    "descripcion":"EDEMA DE FARINGE"
  },
  {
    "codigo":428113000,
    "descripcion":"ANEUPLOIDÍA AUTOSÓMICA"
  },
  {
    "codigo":298876007,
    "descripcion":"DEFORMIDAD EN EXTENSIÓN DE ARTICULACIÓN DE CODO"
  },
  {
    "codigo":723025005,
    "descripcion":"AUSENCIA ADQUIRIDA DE AMBAS MAMAS"
  },
  {
    "codigo":102268008,
    "descripcion":"DIETA MACROBIÓTICA"
  },
  {
    "codigo":686591000119102,
    "descripcion":"FEOCROMOCITOMA MALIGNO PRIMARIO DE GLÁNDULA SUPRARRENAL IZQUIERDA"
  },
  {
    "codigo":229670001,
    "descripcion":"DÉFICIT DE LA CONVERSIÓN FONEMA-GRAFEMA"
  },
  {
    "codigo":721190004,
    "descripcion":"DEFICIENCIA DE MAGNESIO DEBIDA A MIOPATÍA"
  },
  {
    "codigo":295206004,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE MEPTAZINOL"
  },
  {
    "codigo":162299003,
    "descripcion":"CEFALEA GENERALIZADA"
  },
  {
    "codigo":293371008,
    "descripcion":"REACCIÓN ADVERSA A LA NUTRICIÓN PARENTERAL (AMINOÁCIDOS)"
  },
  {
    "codigo":94928000,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL MAXILAR SUPERIOR"
  },
  {
    "codigo":12237311000119105,
    "descripcion":"ANEURISMA DE ARTERIA RENAL DERECHA"
  },
  {
    "codigo":10680831000119106,
    "descripcion":"NÓDULO DE PIEL DE PIERNA IZQUIERDA"
  },
  {
    "codigo":783056006,
    "descripcion":"ADENOCARCINOMA PARATESTICULAR"
  },
  {
    "codigo":289701001,
    "descripcion":"CONTRACCIONES UTERINAS AUSENTES"
  },
  {
    "codigo":224165005,
    "descripcion":"ECONÓMICAMENTE SEGURO"
  },
  {
    "codigo":93093005,
    "descripcion":"AGRANDAMIENTO FOCAL CONGÉNITO DE COSTILLA"
  },
  {
    "codigo":1172602000,
    "descripcion":"COREA BENIGNA DE INICIO EN LA INFANCIA CON COMPROMISO ESTRIATAL"
  },
  {
    "codigo":124026005,
    "descripcion":"ALFA 1 GLOBULINA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":286031003,
    "descripcion":"DIFICULTAD PARA SACAR UN ENCHUFE ELÉCTRICO DE UN TOMACORRIENTE"
  },
  {
    "codigo":449871005,
    "descripcion":"ANOMALÍA CONGÉNITA DE VASO SANGUÍNEO DE MIEMBRO INFERIOR"
  },
  {
    "codigo":187727005,
    "descripcion":"NEOPLASIA MALIGNA DE TERCIO INFERIOR DE ESÓFAGO"
  },
  {
    "codigo":284196006,
    "descripcion":"QUEMADURA DE PIEL"
  },
  {
    "codigo":332441000119107,
    "descripcion":"DEGENERACIÓN DE RETINA EN EMPEDRADO DE OJO DERECHO"
  },
  {
    "codigo":216825006,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR GAS LICUADO DE PETRÓLEO DISTRIBUIDO EN CONTENEDORES MÓVILES"
  },
  {
    "codigo":313294001,
    "descripcion":"DEGENERACIÓN DEL MENISCO EXTERNO"
  },
  {
    "codigo":249593009,
    "descripcion":"CONDUCTO INGUINAL - HALLAZGO"
  },
  {
    "codigo":52985009,
    "descripcion":"ASCITIS QUILOSA"
  },
  {
    "codigo":870350001,
    "descripcion":"ARTERIOLOPATÍA CALCIFICADA NO URÉMICA"
  },
  {
    "codigo":409763001,
    "descripcion":"NECROSIS HISTOLÓGICA LUEGO DE QUIMIOTERAPIA DE INDUCCIÓN: NO PUEDE DETERMINARSE"
  },
  {
    "codigo":247758009,
    "descripcion":"NO INTENTARÁ"
  },
  {
    "codigo":39181000146107,
    "descripcion":"TRASTORNO DEL SUEÑO DEBIDO A DEPENDENCIA DE POLISUSTANCIAS"
  },
  {
    "codigo":704675005,
    "descripcion":"CONTROL INADECUADO DEL DOLOR"
  },
  {
    "codigo":213155008,
    "descripcion":"COMPLICACIONES DE EXTREMIDAD REIMPLANTADA"
  },
  {
    "codigo":276856001,
    "descripcion":"TRASTORNO ANDROLÓGICO ENDÓCRINO"
  },
  {
    "codigo":442531008,
    "descripcion":"ATENDIDO POR RADIÓLOGO INTERVENCIONISTA"
  },
  {
    "codigo":735608003,
    "descripcion":"DEGENERACIÓN DE DISCO INTERVERTEBRAL DORSAL CONCOMITANTE CON OSTEOFITO"
  },
  {
    "codigo":211320007,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE DEDO DE LA MANO, INFECTADA"
  },
  {
    "codigo":109346000,
    "descripcion":"DEFECTO OSTEOPORÓTICO DE LA MÉDULA ÓSEA"
  },
  {
    "codigo":242253008,
    "descripcion":"SOBREDOSIS DE OPIÁCEOS"
  },
  {
    "codigo":240418009,
    "descripcion":"INFECCIÓN DE PIEL CAUSADA POR MYCOBACTERIUM HAEMOPHILIUM"
  },
  {
    "codigo":41975002,
    "descripcion":"INSOMNIO CON APNEA DEL SUEÑO"
  },
  {
    "codigo":271351003,
    "descripcion":"HECES: PARÁSITOS PRESENTES"
  },
  {
    "codigo":402423004,
    "descripcion":"LIQUEN ESCLEROSO DEL ADULTO"
  },
  {
    "codigo":238583005,
    "descripcion":"DERMATITIS DE CONTACTO CAUSADA POR SALIVA"
  },
  {
    "codigo":369655002,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA DE TROFOBLASTO EN ESPÉCIMEN CERVICAL\/VAGINAL DE HISTERECTOMÍA, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":203980004,
    "descripcion":"MENINGOCELE ESPINAL CERVICAL"
  },
  {
    "codigo":236748004,
    "descripcion":"BALANITIS POR MICOPLASMA"
  },
  {
    "codigo":302284007,
    "descripcion":"COOPERA AL VESTIRSE"
  },
  {
    "codigo":269516007,
    "descripcion":"CARCINOMA DE LENGUA"
  },
  {
    "codigo":300449001,
    "descripcion":"HALLAZGO DE URÉTER"
  },
  {
    "codigo":105676009,
    "descripcion":"ENFERMEDAD CAUSADA POR SANGUINICOLIDAE"
  },
  {
    "codigo":365985003,
    "descripcion":"HALLAZGO RELACIONADO CON LA HIGIENE DE EQUIPO DE INYECCIÓN DE FÁRMACO"
  },
  {
    "codigo":431521000,
    "descripcion":"DOLOR AGUDO POR LESIÓN TRAUMÁTICA"
  },
  {
    "codigo":724598001,
    "descripcion":"VASCULITIS DE VASO DE MEDIANO CALIBRE"
  },
  {
    "codigo":298614003,
    "descripcion":"AMPLITUD DE EXTENSIÓN ACTIVA DE LA COLUMNA LUMBAR AUMENTADA"
  },
  {
    "codigo":460619000,
    "descripcion":"ABSCESO DE PARED DE TRONCO ARTERIOSO"
  },
  {
    "codigo":722763000,
    "descripcion":"PARKINSONISMO-DISTONÍA INFANTIL"
  },
  {
    "codigo":296779002,
    "descripcion":"SOBREDOSIS DE FÁRMACO ANTIPROTOZOARIO"
  },
  {
    "codigo":1148747007,
    "descripcion":"INTOXICACIÓN POR DEXTROPROPOXIFENO Y\/O PARACETAMOL"
  },
  {
    "codigo":131104004,
    "descripcion":"NIVEL DE INSULINA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":65568007,
    "descripcion":"FUMADOR DE CIGARRILLOS"
  },
  {
    "codigo":7271000119107,
    "descripcion":"OTITIS MEDIA AGUDA BILATERAL CON DERRAME"
  },
  {
    "codigo":424181003,
    "descripcion":"PLAN DE TRATAMIENTO INADECUADO"
  },
  {
    "codigo":293109003,
    "descripcion":"REACCIÓN ADVERSA A VACUNA CONTRA LA DIFTERIA, EL TÉTANOS Y LA TOS FERINA"
  },
  {
    "codigo":1145077007,
    "descripcion":"INTOXICACIÓN POR CLORAZEPATO"
  },
  {
    "codigo":94666000,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL TRACTO UVEAL"
  },
  {
    "codigo":15981671000119108,
    "descripcion":"BLEFAROPTOSIS BILATERAL POSQUIRÚRGICA"
  },
  {
    "codigo":717258005,
    "descripcion":"LIQUEN MIXEDEMATOSO PAPULAR DISCRETO"
  },
  {
    "codigo":192970008,
    "descripcion":"SÍNDROME DE LA COLA DE CABALLO"
  },
  {
    "codigo":29130009,
    "descripcion":"MATIDEZ CARDÍACA AUMENTADA"
  },
  {
    "codigo":387743001,
    "descripcion":"AMBLIOPÍA FUNCIONAL"
  },
  {
    "codigo":92831004,
    "descripcion":"COMPLICACIÓN DEL EMBRIÓN TRASPLANTADO"
  },
  {
    "codigo":289439005,
    "descripcion":"FRECUENCIA CARDÍACA FETAL, AUSENTE"
  },
  {
    "codigo":125599006,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA MANO"
  },
  {
    "codigo":254836000,
    "descripcion":"LINFANGIOMA CONGÉNITO"
  },
  {
    "codigo":1336180000,
    "descripcion":"TRASTORNO POR USO DE INHALANTE VOLÁTIL"
  },
  {
    "codigo":10958081000119105,
    "descripcion":"HERIDA ABIERTA DE DEDO DEL PIE IZQUIERDO"
  },
  {
    "codigo":90996003,
    "descripcion":"PELVIS CORDATA"
  },
  {
    "codigo":123764006,
    "descripcion":"TRASTORNO ENDOCRINO SUPRARRENAL COMPLEJO"
  },
  {
    "codigo":416841005,
    "descripcion":"RESONANCIA MAGNÉTICA DE COLUMNA VERTEBRAL DORSAL, ANORMAL"
  },
  {
    "codigo":89161006,
    "descripcion":"FRACTURA EXPUESTA DE HUESO PISIFORME DE MUÑECA"
  },
  {
    "codigo":253001006,
    "descripcion":"CARCINOMA DE CÉLULAS DE MERKEL"
  },
  {
    "codigo":87326000,
    "descripcion":"FARINGITIS HIPERTRÓFICA"
  },
  {
    "codigo":285769009,
    "descripcion":"LEUCEMIA PROMIELOCÍTICA AGUDA - VARIANTE HIPOGRANULAR"
  },
  {
    "codigo":1332510002,
    "descripcion":"TRASTORNO DEL NEURODESARROLLO ASOCIADO AL GEN CHD4"
  },
  {
    "codigo":447774002,
    "descripcion":"ANILLO HEMIVALVULAR CONGÉNITO DE VALVA DE VÁLVULA MITRAL"
  },
  {
    "codigo":445939008,
    "descripcion":"SÍNDROME VIRAL"
  },
  {
    "codigo":52723009,
    "descripcion":"LESIÓN TRAUMÁTICA DEL GANGLIO ESTRELLADO"
  },
  {
    "codigo":249331008,
    "descripcion":"EXTREMO DE LA NARIZ PELLIZCADO"
  },
  {
    "codigo":1197768006,
    "descripcion":"DUODENITIS POR SARCOIDOSIS"
  },
  {
    "codigo":247496009,
    "descripcion":"HALLAZGO RELACIONADO CON LA SUPERFICIE UNGUEAL"
  },
  {
    "codigo":409501004,
    "descripcion":"MENINGITIS HEMORRÁGICA"
  },
  {
    "codigo":704413004,
    "descripcion":"CON MAYOR RIESGO DE VÓMITO"
  },
  {
    "codigo":737181009,
    "descripcion":"ENFERMEDAD PULMONAR INTERSTICIAL DEBIDA A ENFERMEDAD SISTÉMICA"
  },
  {
    "codigo":211058002,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE ESPALDA"
  },
  {
    "codigo":276594006,
    "descripcion":"RUPTURA PERINATAL DE VENA CEREBRAL SUPERFICIAL"
  },
  {
    "codigo":407666007,
    "descripcion":"TRASTORNO ALIMENTARIO RELACIONADO CON EL SUEÑO NOCTURNO"
  },
  {
    "codigo":243826008,
    "descripcion":"SITUACIÓN DEL CUIDADO PRENATAL"
  },
  {
    "codigo":1259634008,
    "descripcion":"INFLAMACIÓN CRÓNICA DE CAPA ARACNOIDEA DE MENINGES CRANEANAS"
  },
  {
    "codigo":241991002,
    "descripcion":"SÍNDROME DE DESCOMPRESIÓN NEUROLÓGICA"
  },
  {
    "codigo":1290567002,
    "descripcion":"RADIOGRAFÍA DE ANTEBRAZO NORMAL"
  },
  {
    "codigo":274759004,
    "descripcion":"TUMEFACCIÓN UMBILICAL"
  },
  {
    "codigo":209223003,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA EXPUESTA DE LA ARTICULACIÓN ESTERNOCLAVICULAR"
  },
  {
    "codigo":733511006,
    "descripcion":"ROTACIÓN DEL CUELLO"
  },
  {
    "codigo":438599002,
    "descripcion":"ENFERMEDAD MODERADA POR DEFICIENCIA HEREDITARIA DE FACTOR VIII CON INHIBIDORES"
  },
  {
    "codigo":240156000,
    "descripcion":"OSTEOPOROSIS GENERALIZADA IDIOPÁTICA JUVENIL"
  },
  {
    "codigo":698908001,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: KIRGUÍS"
  },
  {
    "codigo":764444002,
    "descripcion":"ALOINMUNIZACIÓN ERITROCÍTICA"
  },
  {
    "codigo":305692002,
    "descripcion":"ATENDIDO POR UN MÉDICO LABORAL"
  },
  {
    "codigo":403996004,
    "descripcion":"FIBROSARCOMA INFANTIL"
  },
  {
    "codigo":829980006,
    "descripcion":"CEGUERA COMPLETA DE OJO IZQUIERDO"
  },
  {
    "codigo":43548008,
    "descripcion":"DOLOR OVULATORIO"
  },
  {
    "codigo":271089001,
    "descripcion":"DEFORMIDAD DE HUESO DEL CARPO"
  },
  {
    "codigo":41713005,
    "descripcion":"SÍNDROME DE BENEDIKT"
  },
  {
    "codigo":402161005,
    "descripcion":"DERMATOSIS CAUSADA POR ALGAS"
  },
  {
    "codigo":762609006,
    "descripcion":"LESIÓN TRAUMÁTICA DE CORAZÓN SIN HEMOPERICARDIO"
  },
  {
    "codigo":105414008,
    "descripcion":"FRACASO EN LAS RELACIONES PERSONALES"
  },
  {
    "codigo":300187000,
    "descripcion":"HALLAZGO RELACIONADO CON LA SENSIBILIDAD MASTOIDEA"
  },
  {
    "codigo":236486009,
    "descripcion":"EXTRAVASACIÓN DE ORINA DE LA PELVIS RENAL"
  },
  {
    "codigo":365723003,
    "descripcion":"PH - HALLAZGO"
  },
  {
    "codigo":1119387004,
    "descripcion":"PÉRDIDA DE LA AUDICIÓN NEUROSENSORIAL DE OÍDO IZQUIERDO"
  },
  {
    "codigo":1345093000,
    "descripcion":"DEPENDENCIA DE ESTEROIDE ANABÓLICO EN USO TERAPÉUTICO"
  },
  {
    "codigo":298352009,
    "descripcion":"HUESO ALARGADO"
  },
  {
    "codigo":165445000,
    "descripcion":"CONCENTRACIÓN DE HEMOGLOBINA CORPUSCULAR MEDIA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":67141003,
    "descripcion":"MARCHA ANTÁLGICA"
  },
  {
    "codigo":427589004,
    "descripcion":"DUELO COMPLICADO"
  },
  {
    "codigo":11999081000119101,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO DE MANO IZQUIERDA"
  },
  {
    "codigo":296517007,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE NALOXONA"
  },
  {
    "codigo":294682002,
    "descripcion":"ALERGIA A PREDNISONA"
  },
  {
    "codigo":720666008,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR TARTRATO DE METOPROLOL"
  },
  {
    "codigo":292847000,
    "descripcion":"REACCIÓN ADVERSA A FÁRMACO ANTIPALÚDICO"
  },
  {
    "codigo":423919000,
    "descripcion":"CALIECTASIA ADQUIRIDA"
  },
  {
    "codigo":1208516002,
    "descripcion":"ATAXIA ESPINOCEREBELOSA TIPO 43"
  },
  {
    "codigo":127172002,
    "descripcion":"LINFADENOPATÍA OBTURATRIZ"
  },
  {
    "codigo":94404007,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LAS CELDILLAS AÉREAS MASTOIDEAS"
  },
  {
    "codigo":716996008,
    "descripcion":"SÍNDROME DE HIPOPLASIA DE CUERPO CALLOSO, DISCAPACIDAD INTELECTUAL, PULGARES EN ADUCCIÓN, ESPASTICIDAD E HIDROCEFALIA"
  },
  {
    "codigo":192708007,
    "descripcion":"ENCEFALITIS POSVACUNACIÓN CONTRA EL CÓLERA"
  },
  {
    "codigo":225476009,
    "descripcion":"CONDUCTA ABUSIVA EN EL ASPECTO FINANCIERO"
  },
  {
    "codigo":92569001,
    "descripcion":"CARCINOMA IN SITU DE LA COMISURA LABIAL"
  },
  {
    "codigo":254574000,
    "descripcion":"LEIOMIOMATOSIS DIFUSA DE ESÓFAGO"
  },
  {
    "codigo":11808771000119103,
    "descripcion":"PERFORACIÓN TRAUMÁTICA DE COLON SIGMOIDE"
  },
  {
    "codigo":1268547002,
    "descripcion":"SARCOMA EPITELIOIDE PRIMARIO"
  },
  {
    "codigo":88899005,
    "descripcion":"REACCIÓN DE HIPERSENSIBILIDAD CON ANTICUERPOS BLOQUEANTES"
  },
  {
    "codigo":285507006,
    "descripcion":"CAPAZ DE SACAR LA LENGUA TOTALMENTE"
  },
  {
    "codigo":416579007,
    "descripcion":"DISMINUCIÓN EN EL VOLUMEN DE EYACULACIÓN"
  },
  {
    "codigo":185368000,
    "descripcion":"DERIVADO POR ÓPTICO"
  },
  {
    "codigo":449347008,
    "descripcion":"CONOCE EL MÉTODO ANTICONCEPTIVO DE LA PAREJA"
  },
  {
    "codigo":250904002,
    "descripcion":"MICROFONÍA COCLEAR"
  },
  {
    "codigo":840728005,
    "descripcion":"NEUMONITIS CAUSADA POR INHALACIÓN DE ACEITE"
  },
  {
    "codigo":283672006,
    "descripcion":"HERIDA POR PINCHAZO DE CLAVO EN LA PIERNA"
  },
  {
    "codigo":54296007,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DE MANO"
  },
  {
    "codigo":249069008,
    "descripcion":"NO SE PRESENTA PARTES FETALES EN LA VAGINA"
  },
  {
    "codigo":871661008,
    "descripcion":"ANEURISMA DE AORTA EN SITIO DE COARTACIÓN DESPUÉS DE PROCEDIMIENTO"
  },
  {
    "codigo":19693008,
    "descripcion":"SIGNO DE TRENDELENBURG"
  },
  {
    "codigo":12109981000119103,
    "descripcion":"CONGELAMIENTO DE PIERNA DERECHA"
  },
  {
    "codigo":247234006,
    "descripcion":"HALLAZGO RELACIONADO CON EL OÍDO"
  },
  {
    "codigo":767852001,
    "descripcion":"QUISTE ÓSEO DE HÚMERO"
  },
  {
    "codigo":704151009,
    "descripcion":"FRACTURA EXPUESTA DE FALANGE PROXIMAL DE DEDO ANULAR"
  },
  {
    "codigo":1259372006,
    "descripcion":"CARCINOMA ESCAMOSO PRIMARIO DE CÉLULAS CLARAS DE PIEL"
  },
  {
    "codigo":702316007,
    "descripcion":"PARÁLISIS CEREBRAL COREICA"
  },
  {
    "codigo":14188007,
    "descripcion":"TUBERCULOSIS DE LA CADERA"
  },
  {
    "codigo":276332008,
    "descripcion":"ESCROTO PEQUEÑO"
  },
  {
    "codigo":208961004,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA NO EXPUESTA DE LA ARTICULACIÓN DE LA RODILLA, ANTERIOR"
  },
  {
    "codigo":77889005,
    "descripcion":"INTOXICACIÓN POR MAREA ROJA"
  },
  {
    "codigo":405569006,
    "descripcion":"NEUMONITIS POSTERIOR A RADIOTERAPIA"
  },
  {
    "codigo":733249006,
    "descripcion":"MÚLTIPLES HERIDAS ABIERTAS DE MANO"
  },
  {
    "codigo":370966000,
    "descripcion":"ANOMALÍA CONGÉNITA DE LA FUNCIÓN ENDOCRINA DEL OVARIO"
  },
  {
    "codigo":895254004,
    "descripcion":"FORMA TRIANGULAR ANORMAL CONGÉNITA DE FALANGE MEDIA DE DEDO MEDIO"
  },
  {
    "codigo":403734005,
    "descripcion":"REACCIÓN SEMEJANTE A ESCLERODERMIA CAUSADA POR VENENO"
  },
  {
    "codigo":239894005,
    "descripcion":"SÍNDROME ANTIFOSFOLIPÍDICO PRIMARIO CON COMPROMISO MULTIORGÁNICO"
  },
  {
    "codigo":67741000119109,
    "descripcion":"AGRANDAMIENTO DE AURÍCULA IZQUIERDA"
  },
  {
    "codigo":205291000,
    "descripcion":"SOBRECRECIMIENTO DE TODA LA EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":238059005,
    "descripcion":"TRASTORNO DE LA FUNCIÓN DE LOS PEROXISOMAS"
  },
  {
    "codigo":762347009,
    "descripcion":"TRASTORNO DE CONDUCTA DISOCIAL DE COMIENZO EN LA INFANCIA"
  },
  {
    "codigo":365461001,
    "descripcion":"HALLAZGO RELACIONADO CON LOGROS EDUCATIVOS"
  },
  {
    "codigo":234389001,
    "descripcion":"TALASEMIA ALFA-BETA"
  },
  {
    "codigo":299925003,
    "descripcion":"HALLAZGO RELACIONADO CON LA DISCRIMINACIÓN DE PINCHAZOS"
  },
  {
    "codigo":725909004,
    "descripcion":"FIBROELASTOMA PAPILAR DE CORAZÓN"
  },
  {
    "codigo":1217429005,
    "descripcion":"BRADICARDIA ASINTOMÁTICA"
  },
  {
    "codigo":398229007,
    "descripcion":"POLINEUROPATÍA AMILOIDE, TIPO I"
  },
  {
    "codigo":396394004,
    "descripcion":"HALLAZGO RELACIONADO CON INVASIÓN PERINEURAL"
  },
  {
    "codigo":96721000119103,
    "descripcion":"CARDIOPATÍA HIPERTENSIVA Y ENFERMEDAD RENAL CRÓNICA, ESTADIO 4"
  },
  {
    "codigo":1343000,
    "descripcion":"DETENCIÓN TRANSVERSA PROFUNDA"
  },
  {
    "codigo":34111000,
    "descripcion":"ANOMALÍA CONGÉNITA DE MANO"
  },
  {
    "codigo":298090009,
    "descripcion":"CUERPO EXTRAÑO EN PIEL PERINEAL"
  },
  {
    "codigo":427327003,
    "descripcion":"DEPENDENCIA DE SEDANTE"
  },
  {
    "codigo":230719004,
    "descripcion":"HEMORRAGIA SUBARACNOIDEA INTRACRANEAL DEBIDA A RUPTURA DE ANEURISMA"
  },
  {
    "codigo":425492002,
    "descripcion":"DISTONÍA GENERALIZADA"
  },
  {
    "codigo":196116008,
    "descripcion":"HIPOSTASIA PULMONAR"
  },
  {
    "codigo":1144553001,
    "descripcion":"APLASIA DE PEZÓN"
  },
  {
    "codigo":423657003,
    "descripcion":"LESIÓN TRAUMÁTICA POR HIPEREXTENSIÓN DE DEDO DE LA MANO"
  },
  {
    "codigo":194281003,
    "descripcion":"OTITIS MEDIA AGUDA SUPURATIVA"
  },
  {
    "codigo":718569006,
    "descripcion":"MATERIAL DE SUTURA PRESENTE"
  },
  {
    "codigo":292585009,
    "descripcion":"REACCIÓN ADVERSA A LA AZATADINA"
  },
  {
    "codigo":1275625009,
    "descripcion":"NEUROPATÍA DE NERVIO TIBIAL POSTERIOR DERECHO"
  },
  {
    "codigo":290750004,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR TRILOSTANO"
  },
  {
    "codigo":15635051000119103,
    "descripcion":"TUMORACIÓN DE GLÁNDULA PARÓTIDA IZQUIERDA"
  },
  {
    "codigo":94142007,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL VÓMER"
  },
  {
    "codigo":92307000,
    "descripcion":"NEOPLASIA BENIGNA DE LA REGIÓN PRESACRA"
  },
  {
    "codigo":126910009,
    "descripcion":"NEOPLASIA DEL MIOMETRIO"
  },
  {
    "codigo":288915002,
    "descripcion":"SE SACA RESTOS DE ALIMENTOS DEL SURCO VESTIBULAR"
  },
  {
    "codigo":1306558007,
    "descripcion":"CARCINOMA DUCTAL INFILTRANTE DE PORCIÓN CENTRAL DE MAMA DERECHA"
  },
  {
    "codigo":48241000087101,
    "descripcion":"FRACTURA DE HUESO PARIETAL IZQUIERDO"
  },
  {
    "codigo":24936000,
    "descripcion":"ÁNIMO DESAFECTADO"
  },
  {
    "codigo":287080001,
    "descripcion":"ANOMALÍA CONGÉNITA DEL SISTEMA NERVIOSO DE LA REGIÓN DE CABEZA\/CUELLO"
  },
  {
    "codigo":38001000087105,
    "descripcion":"ACINESIA DE SEGMENTO SEPTAL APICAL DE VENTRÍCULO CARDÍACO IZQUIERDO"
  },
  {
    "codigo":43121000087107,
    "descripcion":"HEMATOMA DE DEDO MEDIO DE MANO DERECHA"
  },
  {
    "codigo":35441000087109,
    "descripcion":"INFARTO ANTIGUO DE MIOCARDIO DE REGIÓN POSTEROLATERAL"
  },
  {
    "codigo":449085001,
    "descripcion":"CONEXIÓN DE ARTERIA PULMONAR A ARTERIA CORONARIA A TRAVÉS DE ARTERIA COLATERAL"
  },
  {
    "codigo":285245006,
    "descripcion":"DEDUCCIÓN ARBITRARIA"
  },
  {
    "codigo":54034003,
    "descripcion":"SÍNDROME DE BEHCET, TIPO INTESTINAL"
  },
  {
    "codigo":283410004,
    "descripcion":"CORTE EN EL HOMBRO"
  },
  {
    "codigo":19431000,
    "descripcion":"ARTRITIS RUBEÓLICA"
  },
  {
    "codigo":248807003,
    "descripcion":"MAMAS DE DIFERENTE FORMA"
  },
  {
    "codigo":773095004,
    "descripcion":"HERNIA INTERNA DE ABDOMEN CON GANGRENA"
  },
  {
    "codigo":84967008,
    "descripcion":"INFECCIÓN CAUSADA POR MACRACANTHORHYNCHUS"
  },
  {
    "codigo":83132003,
    "descripcion":"DOLOR ABDOMINAL SUPERIOR"
  },
  {
    "codigo":246972003,
    "descripcion":"LÍNEA DE RECHAZO DE INJERTO"
  },
  {
    "codigo":277905003,
    "descripcion":"TRASTORNO DE LA QUERATINIZACIÓN"
  },
  {
    "codigo":276070000,
    "descripcion":"ENTRENAMIENTO LABORAL NECESARIO"
  },
  {
    "codigo":1259110004,
    "descripcion":"RINORRAQUIA DEBIDA A NEOPLASIA DE HIPÓFISIS"
  },
  {
    "codigo":46694006,
    "descripcion":"MALESTAR DE LA VULVA"
  },
  {
    "codigo":765755006,
    "descripcion":"ESPECTRO DE DISPLASIA MESODÉRMICA AXIAL"
  },
  {
    "codigo":208699008,
    "descripcion":"FRACTURA EXPUESTA DE BASE DE METATARSIANO"
  },
  {
    "codigo":700219009,
    "descripcion":"HIPOTENSIÓN INTRACRANEANA IDIOPÁTICA"
  },
  {
    "codigo":1222672002,
    "descripcion":"ACIDURIA 3-METILGLUTACÓNICA TIPO 9"
  },
  {
    "codigo":1157136003,
    "descripcion":"TUMOR EN TURBANTE"
  },
  {
    "codigo":403472004,
    "descripcion":"ULCERACIÓN DE PENE DEBIDA A ENFERMEDAD DE BEHÇET"
  },
  {
    "codigo":1255440004,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO DE DEDO ÍNDICE"
  },
  {
    "codigo":8421002,
    "descripcion":"ENDOMETRIOSIS DE APÉNDICE ILEOCECAL"
  },
  {
    "codigo":1082271000119107,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE LÓBULO SUPERIOR DE PULMÓN DERECHO"
  },
  {
    "codigo":41189006,
    "descripcion":"DELUSIÓN DE AUTORREFERENCIA"
  },
  {
    "codigo":301498003,
    "descripcion":"INCAPAZ DE MOVILIZARSE EN EL INTERIOR DE UN LUGAR"
  },
  {
    "codigo":203194004,
    "descripcion":"OSTEOMIELITIS CRÓNICA DE LA COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":235962009,
    "descripcion":"QUISTE PANCREÁTICO POR RETENCIÓN"
  },
  {
    "codigo":365199003,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA PONERSE PELUCA"
  },
  {
    "codigo":234127005,
    "descripcion":"HIPOPLASIA VENOSA PROFUNDA"
  },
  {
    "codigo":299663009,
    "descripcion":"PLIEGUE GLÚTEO SIMÉTRICO"
  },
  {
    "codigo":232292003,
    "descripcion":"DISFUNCIÓN LABERÍNTICA HIPOACTIVA"
  },
  {
    "codigo":363364007,
    "descripcion":"NEOPLASIA MALIGNA DE PARTES BLANDAS DE CADERA"
  },
  {
    "codigo":164921003,
    "descripcion":"ONDA R ELECTROCARDIOGRÁFICA ANORMAL"
  },
  {
    "codigo":427065003,
    "descripcion":"MONOPLEJÍA DEL MIEMBRO SUPERIOR DOMINANTE COMO EFECTO TARDÍO DE ACCIDENTE CEREBROVASCULAR"
  },
  {
    "codigo":197689003,
    "descripcion":"SÍNDROME NEFRÍTICO RÁPIDAMENTE PROGRESIVO"
  },
  {
    "codigo":230457003,
    "descripcion":"ESTADO EPILÉPTICO DE AUSENCIA TÍPICO"
  },
  {
    "codigo":721977007,
    "descripcion":"SÍNDROME DE FIBROSIS PULMONAR, INMUNODEFICIENCIA Y DISGENESIA GONADAL 46,XX"
  },
  {
    "codigo":292051000119102,
    "descripcion":"NEUROPATÍA POR COMPRESIÓN DE NERVIO CIÁTICO POPLÍTEO EXTERNO DERECHO"
  },
  {
    "codigo":263225007,
    "descripcion":"FRACTURA DE FÉMUR PROXIMAL"
  },
  {
    "codigo":295993007,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE PRIMIDONA"
  },
  {
    "codigo":359694003,
    "descripcion":"GLOMERULONEFRITIS PROLIFERATIVA IDIOPÁTICA, TIPO II"
  },
  {
    "codigo":195854003,
    "descripcion":"CORDITIS FIBRINOSA"
  },
  {
    "codigo":425230006,
    "descripcion":"CARCINOMA ESCAMOCELULAR DEL PULMÓN, TNM ESTADIO 3"
  },
  {
    "codigo":294158008,
    "descripcion":"ALERGIA A AMINOFILINA"
  },
  {
    "codigo":128483002,
    "descripcion":"ENFERMEDAD AGUDA DE ÓRBITA"
  },
  {
    "codigo":292323003,
    "descripcion":"REACCIÓN ADVERSA AL FENOBARBITAL"
  },
  {
    "codigo":95715007,
    "descripcion":"ESPASMO DEL CUERPO CILIAR"
  },
  {
    "codigo":1177059007,
    "descripcion":"QUISTE DE PULMÓN POR PNEUMOCYSTIS JIROVECII"
  },
  {
    "codigo":126648001,
    "descripcion":"NEOPLASIA DEL TABIQUE RECTOVAGINAL"
  },
  {
    "codigo":93880001,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE PULMÓN"
  },
  {
    "codigo":61112000,
    "descripcion":"ARTRITIS PIÓGENA DE LA MANO"
  },
  {
    "codigo":290488001,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ETOMIDATO"
  },
  {
    "codigo":224952000,
    "descripcion":"INTROVERTIDO"
  },
  {
    "codigo":1339064006,
    "descripcion":"FRACTURA DE FALANGE DE PIE DERECHO"
  },
  {
    "codigo":429001000124103,
    "descripcion":"PATRÓN DE USO NOCIVO DE CATHA EDULIS"
  },
  {
    "codigo":716472008,
    "descripcion":"CAPAZ DE LAVAR LA PARTE INFERIOR DEL CUERPO"
  },
  {
    "codigo":59277005,
    "descripcion":"CIGOMICOSIS"
  },
  {
    "codigo":92045006,
    "descripcion":"NEOPLASIA BENIGNA DE HUESO DEL CARPO"
  },
  {
    "codigo":1237090000,
    "descripcion":"AGENTE DE ESTANQUE QUE CAUSA EFECTO TÓXICO"
  },
  {
    "codigo":288653009,
    "descripcion":"INCAPAZ DE SUMARSE A UNA CONVERSACIÓN"
  },
  {
    "codigo":286818007,
    "descripcion":"CARÁCTER PEDANTE"
  },
  {
    "codigo":448823001,
    "descripcion":"OBSTRUCCIÓN AL TRACTO DE SALIDA DEL VENTRÍCULO IZQUIERDO DEBIDO A PROLAPSO DE VÁLVULA DE EUSTAQUIO"
  },
  {
    "codigo":254050009,
    "descripcion":"DISPLASIA DE COSTILLA CORTA"
  },
  {
    "codigo":55607006,
    "descripcion":"PROBLEMA"
  },
  {
    "codigo":284983006,
    "descripcion":"DIFICULTAD PARA CALZARSE"
  },
  {
    "codigo":283148000,
    "descripcion":"ANZUELO EN LA CARA"
  },
  {
    "codigo":186679007,
    "descripcion":"CONJUNTIVITIS CAUSADA POR ADENOVIRUS"
  },
  {
    "codigo":446988001,
    "descripcion":"INFECCIÓN INTESTINAL CAUSADA POR AEROMONAS HYDROPHILA"
  },
  {
    "codigo":86540005,
    "descripcion":"AMPOLLA DE PIERNA, SIN INFECCIÓN"
  },
  {
    "codigo":184844006,
    "descripcion":"INFORME DEL EXAMEN PARA EL SEGURO DE VIDA ENVIADO"
  },
  {
    "codigo":53772007,
    "descripcion":"DESPRENDIMIENTO DEL VÍTREO"
  },
  {
    "codigo":1231585001,
    "descripcion":"OBSTRUCCIÓN DE VÍA RESPIRATORIA CAUSADA POR JUGUETE EN NARIZ"
  },
  {
    "codigo":838369002,
    "descripcion":"REACCIÓN ADVERSA A SUSTANCIA APLICADA A LA PIEL DE RECIÉN NACIDO"
  },
  {
    "codigo":19169002,
    "descripcion":"ABORTO ESPONTÁNEO EN EL PRIMER TRIMESTRE"
  },
  {
    "codigo":707297005,
    "descripcion":"XEROSTOMÍA DEBIDA A ENFERMEDAD AUTOINMUNITARIA"
  },
  {
    "codigo":445153009,
    "descripcion":"INESTABILIDAD DE ARTICULACIÓN DE PIE"
  },
  {
    "codigo":82870007,
    "descripcion":"PORNOGRAFOMANÍA"
  },
  {
    "codigo":1295286008,
    "descripcion":"RADIOGRAFÍA DE SISTEMA MUSCULOESQUELÉTICO NORMAL"
  },
  {
    "codigo":13181000122107,
    "descripcion":"ALERGIA A LEVOFLOXACINO"
  },
  {
    "codigo":212107004,
    "descripcion":"QUEMADURA QUE COMPROMETE 80-89 PORCIENTO DE LA SUPERFICIE DEL CUERPO, CON QUEMADURA DE ESPESOR COMPLETO QUE AFECTA 30-39 PORCIENTO DE LA SUPERFICIE CORPORAL"
  },
  {
    "codigo":703627005,
    "descripcion":"ENFERMEDAD POR DEPÓSITO DE PIROFOSFATO DE CALCIO ASINTOMÁTICA"
  },
  {
    "codigo":277643003,
    "descripcion":"LINFOMA DE CÉLULAS T DE ALTO GRADO"
  },
  {
    "codigo":46432001,
    "descripcion":"PROMISCUIDAD"
  },
  {
    "codigo":767328004,
    "descripcion":"AUSENCIA CONGÉNITA DE TESTÍCULO IZQUIERDO"
  },
  {
    "codigo":111968005,
    "descripcion":"APNEA POSTANESTESIA"
  },
  {
    "codigo":177504007,
    "descripcion":"AGENESIA DE MANOS Y PIES"
  },
  {
    "codigo":243040008,
    "descripcion":"LESIÓN CAUSADA POR EXPLOSIÓN SUBMARINA"
  },
  {
    "codigo":110133002,
    "descripcion":"AVULSIÓN DEL PALADAR BLANDO"
  },
  {
    "codigo":208437002,
    "descripcion":"FRACTURA NO EXPUESTA DE LA FALANGE PROXIMAL DEL PULGAR, CUELLO"
  },
  {
    "codigo":306741005,
    "descripcion":"DESTREZA MANUAL ESCASA"
  },
  {
    "codigo":77365006,
    "descripcion":"DEFICIENCIA DE DIHIDROURACILO DESHIDROGENASA"
  },
  {
    "codigo":403210001,
    "descripcion":"PRURIGO ACTÍNICO FAMILIAR DE LABIO"
  },
  {
    "codigo":763658004,
    "descripcion":"SÍNDROME DE HIPOTRICOSIS, OSTEÓLISIS, PERIODONTITIS Y QUERATODERMIA PALMOPLANTAR"
  },
  {
    "codigo":75530006,
    "descripcion":"CERVICITIS ESTREPTOCÓCICA"
  },
  {
    "codigo":1220575002,
    "descripcion":"SÍNDROME ENCAPSULANTE FETAL"
  },
  {
    "codigo":1351647002,
    "descripcion":"AGAMMAGLOBULINEMIA AUTOSÓMICA DOMINANTE DEBIDA A DEFICIENCIA DE PU.1"
  },
  {
    "codigo":301236000,
    "descripcion":"TOS EFECTIVA"
  },
  {
    "codigo":170164003,
    "descripcion":"EXAMEN DEL NIÑO A LOS 4.5 AÑOS: ANORMAL - PARA OBSERVACIÓN"
  },
  {
    "codigo":11818811000119100,
    "descripcion":"ESGUINCE DE LIGAMENTO DE ARTICULACIÓN INTERFALÁNGICA DE CUARTO DEDO DE MANO DERECHA"
  },
  {
    "codigo":235700007,
    "descripcion":"HIPERPLASIA DE LAS GLÁNDULAS DE BRUNNER DEL DUODENO"
  },
  {
    "codigo":1251508008,
    "descripcion":"RETRACCIÓN DE SEGMENTO SUPERIOR DE ÚTERO DURANTE TRABAJO DE PARTO"
  },
  {
    "codigo":202932007,
    "descripcion":"DEPÓSITOS DE CALCIO EN BOLSA SEROSA"
  },
  {
    "codigo":299401000,
    "descripcion":"PRUEBA DE HIPERFLEXIÓN DE LA RODILLA: POSITIVA"
  },
  {
    "codigo":39092007,
    "descripcion":"MIELOMENIA"
  },
  {
    "codigo":364937007,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA CONTROLAR LA POSICIÓN DE LA CABEZA"
  },
  {
    "codigo":233865008,
    "descripcion":"INSUFICIENCIA FUNCIONAL DE VÁLVULA TRICÚSPIDE"
  },
  {
    "codigo":461406001,
    "descripcion":"ORIGEN NORMAL DE LIGAMENTO ARTERIOSO EN AORTA DESCENDENTE PROXIMAL"
  },
  {
    "codigo":232030000,
    "descripcion":"RETINOPATÍA DE PURTSCHER"
  },
  {
    "codigo":721715000,
    "descripcion":"LESIÓN DE HÍGADO POR ISQUEMIA-REPERFUSIÓN"
  },
  {
    "codigo":428638009,
    "descripcion":"ENCEFALITIS HERPÉTICA"
  },
  {
    "codigo":295731002,
    "descripcion":"SOBREDOSIS DE AMSACRINA"
  },
  {
    "codigo":89907009,
    "descripcion":"EXOFTALMÍA FIJA"
  },
  {
    "codigo":291851000119100,
    "descripcion":"NEUROPATÍA POR COMPRESIÓN DE NERVIO PERIFÉRICO DE MANO DERECHA"
  },
  {
    "codigo":361267005,
    "descripcion":"CRISIS CONVULSIVA RELACIONADA CON EL CONSUMO DE ALCOHOL"
  },
  {
    "codigo":317451000119102,
    "descripcion":"DETENCIÓN PARCIAL DEL CRECIMIENTO EPIFISARIO DE HÚMERO DISTAL DERECHO"
  },
  {
    "codigo":11776011000119101,
    "descripcion":"LESIÓN TRAUMÁTICA DE REGIÓN DE CODO IZQUIERDO"
  },
  {
    "codigo":10941451000119104,
    "descripcion":"HEMORRAGIA CEREBRAL DERECHA TRAUMÁTICA"
  },
  {
    "codigo":16227851000119101,
    "descripcion":"PRURITO DE OJO DERECHO"
  },
  {
    "codigo":322571000119103,
    "descripcion":"SINOVITIS TRANSITORIA DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":110091000119107,
    "descripcion":"CANDIDIASIS DE VAGINA EN EL EMBARAZO"
  },
  {
    "codigo":1085451000119107,
    "descripcion":"HEMORRAGIA POR COLOSTOMÍA"
  },
  {
    "codigo":1090571000119108,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE LÓBULO DE LA OREJA DERECHA PERFORADO"
  },
  {
    "codigo":345611000119102,
    "descripcion":"NEUROPATÍA ÓPTICA ISQUÉMICA DE AMBOS OJOS"
  },
  {
    "codigo":31752000,
    "descripcion":"INTOXICACIÓN CAUSADA POR ALOPURINOL"
  },
  {
    "codigo":128221000,
    "descripcion":"OSTEORRADIONECROSIS DE HUESO CRANEAL"
  },
  {
    "codigo":95453001,
    "descripcion":"HEMATOMA SUBDURAL INTRACRANEAL"
  },
  {
    "codigo":350731000119105,
    "descripcion":"NEOPLASIA BENIGNA DE PARTES BLANDAS DE EXTREMIDAD SUPERIOR IZQUIERDA"
  },
  {
    "codigo":10821131000119109,
    "descripcion":"FRACTURA EXPUESTA DE PERONÉ IZQUIERDO"
  },
  {
    "codigo":10862091000119107,
    "descripcion":"HERIDA POR DISPARO DE ARMA DE FUEGO DE REGIÓN DE RODILLA DERECHA"
  },
  {
    "codigo":424968009,
    "descripcion":"AUSENCIA DE APTITUD PARA LA COMUNICACIÓN ALTERNATIVA"
  },
  {
    "codigo":292061006,
    "descripcion":"REACCIÓN ADVERSA A ANÁLOGO DE MEPERIDINA"
  },
  {
    "codigo":677691000119107,
    "descripcion":"NEOVASCULARIZACIÓN POLIPOIDE COROIDEA DE OJO DERECHO"
  },
  {
    "codigo":15970261000119101,
    "descripcion":"HEMORROIDE INTERNA SANGRANTE GRADO I"
  },
  {
    "codigo":290226002,
    "descripcion":"INTOXICACIÓN POR ACEMETACINA"
  },
  {
    "codigo":28082003,
    "descripcion":"ÚLCERA DUODENAL CRÓNICA SIN HEMORRAGIA Y SIN PERFORACIÓN PERO CON OBSTRUCCIÓN"
  },
  {
    "codigo":880050002,
    "descripcion":"OBSTRUCCIÓN ADQUIRIDA DEL TRACTO DE SALIDA DEL VENTRÍCULO DERECHO"
  },
  {
    "codigo":288391001,
    "descripcion":"NO RETUERCE ROPA"
  },
  {
    "codigo":24412005,
    "descripcion":"DIARREA SECRETORA CONGÉNITA CON PÉRDIDA DE CLORO"
  },
  {
    "codigo":188252005,
    "descripcion":"NEOPLASIA MALIGNA DE CÁLIZ RENAL"
  },
  {
    "codigo":89948007,
    "descripcion":"TRASTORNO DE PÁNICO CON AGORAFOBIA Y ATAQUES DE PÁNICO LEVES"
  },
  {
    "codigo":57180008,
    "descripcion":"PRODUCCIÓN ANORMAL DE EOSINÓFILOS"
  },
  {
    "codigo":448561007,
    "descripcion":"LINFOMA NO HODGKIN FOLICULAR DE LOCALIZACIÓN EXTRAGANGLIONAR"
  },
  {
    "codigo":186417008,
    "descripcion":"GANGRENA GASEOSA DE BRAZO"
  },
  {
    "codigo":282886003,
    "descripcion":"DIFICULTAD PARA PARARSE DESDE POSICIÓN SENTADA"
  },
  {
    "codigo":343214191000119103,
    "descripcion":"OSTEÍTIS DEFORMANTE DE AMBOS CÚBITOS Y RADIOS"
  },
  {
    "codigo":250118008,
    "descripcion":"CREPITACIÓN TIBIOFEMORAL"
  },
  {
    "codigo":1264091001,
    "descripcion":"TRASTORNO FETAL CAUSADO POR TRANSFERENCIA PLACENTARIA DE AGENTE ANTINEOPLÁSICO"
  },
  {
    "codigo":49840000,
    "descripcion":"SILICOSIS COMPLICADA"
  },
  {
    "codigo":82608003,
    "descripcion":"DILATACIÓN DE AURÍCULA CARDÍACA"
  },
  {
    "codigo":211845004,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO PROFUNDA DE HOMBRO"
  },
  {
    "codigo":80773006,
    "descripcion":"SÍNDROME DE ESCOBAR"
  },
  {
    "codigo":111706003,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE LA NALGA, SIN INFECCIÓN"
  },
  {
    "codigo":734298005,
    "descripcion":"TROMBOEMBOLIA DE ARTERIA ILÍACA INTERNA"
  },
  {
    "codigo":372015000,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL MESENTERIO"
  },
  {
    "codigo":406618009,
    "descripcion":"ENFERMEDAD INVASIVA POR STREPTOCOCCUS PNEUMONIAE FARMACORRESISTENTE"
  },
  {
    "codigo":77103006,
    "descripcion":"ANILLO DE KAYSER - FLEISCHER"
  },
  {
    "codigo":239108002,
    "descripcion":"NEVO EPIDÉRMICO SISTEMATIZADO"
  },
  {
    "codigo":402948006,
    "descripcion":"DISTROFIA UNGUEAL POR SÍFILIS SECUNDARIA"
  },
  {
    "codigo":304644008,
    "descripcion":"DIFICULTAD PARA RAZONAR"
  },
  {
    "codigo":1254916008,
    "descripcion":"COMPLEJO PIODERMA GANGRENOSO HIDRADENITIS SUPURATIVA"
  },
  {
    "codigo":1187545003,
    "descripcion":"DISTONÍA CON RESPUESTA A LEVODOPA DEBIDA A DEFICIENCIA DE SEPIAPTERINA REDUCTASA"
  },
  {
    "codigo":1089801000119108,
    "descripcion":"NEURITIS RETROBULBAR MENINGOCÓCICA"
  },
  {
    "codigo":237273008,
    "descripcion":"DESPRENDIMIENTO DE PLACENTA EVIDENCIADO"
  },
  {
    "codigo":366510001,
    "descripcion":"AMPLITUD DE EXTENSIÓN ACTIVA DE CODO"
  },
  {
    "codigo":302809008,
    "descripcion":"INFECCIÓN POR STREPTOCOCCUS PYOGENES"
  },
  {
    "codigo":169902008,
    "descripcion":"PUNTAJE DE APGAR AL MINUTO = 5"
  },
  {
    "codigo":202670009,
    "descripcion":"ESPONDILOSIS DORSAL EN UN NIVEL CON MIELOPATÍA"
  },
  {
    "codigo":233603001,
    "descripcion":"BRONQUIOLITIS AGUDA CAUSADA POR ADENOVIRUS"
  },
  {
    "codigo":200835003,
    "descripcion":"QUEMADURA SOLAR DE TERCER GRADO"
  },
  {
    "codigo":69763009,
    "descripcion":"OFTALMOPLEJÍA EXOFTÁLMICA"
  },
  {
    "codigo":35160004,
    "descripcion":"LUXACIONES EXPUESTAS MÚLTIPLES DEL BRAZO"
  },
  {
    "codigo":33325001,
    "descripcion":"ENFISEMA COMPENSATORIO"
  },
  {
    "codigo":262701006,
    "descripcion":"EDEMA DE MÉDULA ESPINAL CERVICAL"
  },
  {
    "codigo":721453006,
    "descripcion":"SÍNDROME DEL CORDÓN CENTRAL DE MÉDULA ESPINAL AL NIVEL DEL DECIMOPRIMER SEGMENTO DORSAL"
  },
  {
    "codigo":295469006,
    "descripcion":"SOBREDOSIS DE DOCUSATO"
  },
  {
    "codigo":162562004,
    "descripcion":"PREOCUPACIÓN POR LA FORMA DE LA NARIZ"
  },
  {
    "codigo":31490007,
    "descripcion":"NEURALGIA DE NERVIO NASOCILIAR"
  },
  {
    "codigo":1078231000,
    "descripcion":"DERMATITIS ALÉRGICA POR CONTACTO CAUSADA POR JOYAS"
  },
  {
    "codigo":129794007,
    "descripcion":"DENSIDAD TUBULAR"
  },
  {
    "codigo":160727002,
    "descripcion":"VIVE SOLO - NECESITA AMA DE LLAVES"
  },
  {
    "codigo":291799007,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR GLUCAGÓN"
  },
  {
    "codigo":224428003,
    "descripcion":"CANTINA INADECUADA EN EL TRABAJO"
  },
  {
    "codigo":61441000112102,
    "descripcion":"SÍNTOMA MECÁNICO DE ARTICULACIÓN DE RODILLA"
  },
  {
    "codigo":92161000112103,
    "descripcion":"HERIDA CRÓNICA"
  },
  {
    "codigo":276481000112102,
    "descripcion":"TRASTORNO DEL ESTADO DE ÁNIMO DEBIDO A ACV Y POSTERIOR A ÉL"
  },
  {
    "codigo":122881000112102,
    "descripcion":"ESCHERICHIA COLI SEROTIPO O151:H16 O O118:H16"
  },
  {
    "codigo":2561000112106,
    "descripcion":"TOS CRÓNICA REFRACTARIA"
  },
  {
    "codigo":714113003,
    "descripcion":"ERITEMA GINGIVAL LINEAL CAUSADO POR HONGOS"
  },
  {
    "codigo":30721000112104,
    "descripcion":"ACTINOMYCES ORIS O ACTINOMYCES VISCOSUS"
  },
  {
    "codigo":20481000112108,
    "descripcion":"ACTINOBACILLUS LIGNIERESII O ACTINOBACILLUS PLEUROPNEUMONIAE"
  },
  {
    "codigo":93356006,
    "descripcion":"POSICIÓN ANÓMALA CONGÉNITA DEL ASTRÁGALO"
  },
  {
    "codigo":124289006,
    "descripcion":"DEFICIENCIA DE CINURENINA - OXOGLUTARATO AMINOTRANSFERASA"
  },
  {
    "codigo":56918001,
    "descripcion":"NEUTROPENIA INDUCIDA POR DROGAS DEPENDIENTES DE LA DOSIS"
  },
  {
    "codigo":286294004,
    "descripcion":"CAPAZ DE ARTICULAR CLARAMENTE LA PALABRA"
  },
  {
    "codigo":448299004,
    "descripcion":"NEOPLASIA MALIGNA DE APÓFISIS MASTOIDES"
  },
  {
    "codigo":55083007,
    "descripcion":"PERIOSTITIS DE PIERNA"
  },
  {
    "codigo":415531008,
    "descripcion":"HALLAZGO RELACIONADO CON LA PIEL Y\/O LA MUCOSA"
  },
  {
    "codigo":282624000,
    "descripcion":"DIFICULTAD PARA RODAR"
  },
  {
    "codigo":315392003,
    "descripcion":"NACIDO EN BULGARIA"
  },
  {
    "codigo":1003520004,
    "descripcion":"AGENESIA DE HUESO VÓMER"
  },
  {
    "codigo":249856008,
    "descripcion":"PÉRDIDA DEL CONTROL DEL TRONCO"
  },
  {
    "codigo":774144009,
    "descripcion":"ESPASMO DEL MÚSCULO PIRAMIDAL IZQUIERDO"
  },
  {
    "codigo":248021000,
    "descripcion":"CONDUCTA PARA LLAMAR LA ATENCIÓN"
  },
  {
    "codigo":1362133002,
    "descripcion":"ECOGRAFÍA PRENATAL CONFIRMA EMBARAZO MÚLTIPLE"
  },
  {
    "codigo":18645007,
    "descripcion":"ACTIVIDAD GÁSTRICA ELÉCTRICA AUMENTADA"
  },
  {
    "codigo":82346000,
    "descripcion":"HIDROCEFALIA OBSTRUCTIVA ADQUIRIDA"
  },
  {
    "codigo":881000119102,
    "descripcion":"RESERVA OVÁRICA DISMINUIDA EVIDENCIADA POR RECUENTO BAJO DE FOLÍCULOS ANTRALES"
  },
  {
    "codigo":462029681000119103,
    "descripcion":"MALFORMACIÓN CAVERNOSA DE MÉDULA ESPINAL FAMILIAR"
  },
  {
    "codigo":49578007,
    "descripcion":"INTERVALO P - R ACORTADO"
  },
  {
    "codigo":277119002,
    "descripcion":"ASIMETRÍA INTERHEMISFÉRICA DE LA LATENCIA, NO CRUZADA"
  },
  {
    "codigo":47743003,
    "descripcion":"EFECTO DE ADMINISTRACIÓN INCORRECTA DE DROGA"
  },
  {
    "codigo":80511004,
    "descripcion":"ERITROCITOSIS POR TRASTORNO ENDOCRINO"
  },
  {
    "codigo":211583005,
    "descripcion":"LESIÓN TRAUMÁTICA CERRADA POR APLASTAMIENTO, PULGAR"
  },
  {
    "codigo":768639006,
    "descripcion":"CARIES CORONAL EN ESTADIO INICIAL"
  },
  {
    "codigo":735871006,
    "descripcion":"MÚLTIPLES HERIDAS ABIERTAS DE TOBILLO"
  },
  {
    "codigo":209748001,
    "descripcion":"SECCIÓN EXPUESTA DE LIGAMENTO ESTERNOCLAVICULAR"
  },
  {
    "codigo":13140001,
    "descripcion":"QUEMADURA DEL TUBO DIGESTIVO"
  },
  {
    "codigo":373588006,
    "descripcion":"FRACTURA DE ESMALTE Y DENTINA"
  },
  {
    "codigo":699433000,
    "descripcion":"PORTADOR DE VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":240681003,
    "descripcion":"OSTEÍTIS POR FRAMBESIA"
  },
  {
    "codigo":109609006,
    "descripcion":"ENROLLAMIENTO DEL BORDE GINGIVAL"
  },
  {
    "codigo":764969006,
    "descripcion":"DISTROFIA RETINIANA ASOCIADA CON MUTACIÓN DE RETINOIDE ISOMEROHIDROLASA RPE65 BIALÉLICA"
  },
  {
    "codigo":402686000,
    "descripcion":"PANICULITIS POR TRASTORNO INMUNOLÓGICO"
  },
  {
    "codigo":15729521000119108,
    "descripcion":"ARTROPATÍA DE AMBOS HOMBROS DEBIDA A SÍNDROME DE BEHCET"
  },
  {
    "codigo":763134002,
    "descripcion":"SÍNDROME DE DISPLASIA CONDROECTODÉRMICA CON CEGUERA NOCTURNA"
  },
  {
    "codigo":238846003,
    "descripcion":"TRASTORNO DEL COLÁGENO Y DEL TEJIDO ELÁSTICO QUE AFECTA LA PIEL"
  },
  {
    "codigo":271614004,
    "descripcion":"TUMEFACCIÓN DE GLÁNDULA SALIVAL SUBMAXILAR"
  },
  {
    "codigo":732201008,
    "descripcion":"CARCINOSARCOMA DE ENDOMETRIO"
  },
  {
    "codigo":1254654006,
    "descripcion":"SÍNDROME DE DISCAPACIDAD INTELECTUAL LIGADA AL CROMOSOMA X, HIPOTONÍA, TRASTORNO DEL MOVIMIENTO"
  },
  {
    "codigo":75006000,
    "descripcion":"INFECCIÓN POR ECHINOCOCCUS GRANULOSUS"
  },
  {
    "codigo":11770891000119104,
    "descripcion":"ESGUINCE DE LIGAMENTO COLATERAL RADIAL DE ARTICULACIÓN DE CODO DERECHO"
  },
  {
    "codigo":366248005,
    "descripcion":"HALLAZGO RELACIONADO CON EL ASPECTO DE LA PRÓTESIS DENTAL"
  },
  {
    "codigo":202408006,
    "descripcion":"HEMARTROSIS DE ARTICULACIÓN METACARPOFALÁNGICA"
  },
  {
    "codigo":16905381000119100,
    "descripcion":"CARCINOMA BASOCELULAR PRIMARIO DE PÁRPADO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":71336009,
    "descripcion":"TRASTORNO DEPRESIVO MAYOR RECURRENTE DE INICIO EN EL PERÍODO POSTPARTO"
  },
  {
    "codigo":397181002,
    "descripcion":"FRACTURA EXPUESTA"
  },
  {
    "codigo":298877003,
    "descripcion":"CÚBITO VALGO (AUMENTADO)"
  },
  {
    "codigo":724861006,
    "descripcion":"DERMATOSIS DE GENITALES EXTERNOS"
  },
  {
    "codigo":69501006,
    "descripcion":"TRASTORNO MOTOR DEL NERVIO FACIAL"
  },
  {
    "codigo":297042000,
    "descripcion":"SOBREDOSIS DE INHIBIDOR DE ANHIDRASA CARBÓNICA"
  },
  {
    "codigo":428114006,
    "descripcion":"LINFOCELE LUEGO DE PROCEDIMIENTO QUIRÚRGICO"
  },
  {
    "codigo":34898007,
    "descripcion":"MORFOLOGÍA DE UNA COLONIA BACTERIANA"
  },
  {
    "codigo":721191000,
    "descripcion":"NECROSIS CAPILAR RENAL DEBIDA A ENFERMEDAD GLOMERULAR"
  },
  {
    "codigo":229671002,
    "descripcion":"TRASTORNO DEL LENGUAJE ASOCIADO CON DAÑO DEL HEMISFERIO CEREBRAL DERECHO"
  },
  {
    "codigo":295207008,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE MEPTAZINOL"
  },
  {
    "codigo":293372001,
    "descripcion":"REACCIÓN ADVERSA A LA NUTRICIÓN PARENTERAL (CARBOHIDRATOS)"
  },
  {
    "codigo":196903009,
    "descripcion":"HERNIA DIAFRAGMÁTICA OBSTRUIDA"
  },
  {
    "codigo":162300006,
    "descripcion":"CEFALEA UNILATERAL"
  },
  {
    "codigo":783057002,
    "descripcion":"SÍNDROME DE DELECIÓN DE ÁCIDO DESOXIRRIBONUCLEICO MITOCONDRIAL RELACIONADO CON HELICASA\/NUCLEASA 2 DEL ÁCIDO DESOXIRRIBONUCLEICO"
  },
  {
    "codigo":291537005,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR AMPICILINA"
  },
  {
    "codigo":94929008,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE SENO MAXILAR"
  },
  {
    "codigo":224166006,
    "descripcion":"RICO"
  },
  {
    "codigo":420774007,
    "descripcion":"SÍNDROME CEREBRAL ORGÁNICO CON SIDA (SÍNDROME DE INMUNODEFICIENCIA ADQUIRIDA)"
  },
  {
    "codigo":846758008,
    "descripcion":"ANGIOEDEMA-URTICARIA MEDICAMENTOSO"
  },
  {
    "codigo":289702008,
    "descripcion":"CONTRACCIONES UTERINAS, DETENIDAS"
  },
  {
    "codigo":1172603005,
    "descripcion":"DISCINESIA GENERALIZADA CON AFECTACIÓN OROFACIAL DE INICIO EN LA LACTANCIA"
  },
  {
    "codigo":91259005,
    "descripcion":"SARCOIDOSIS, TIPO ANGIOLUPOIDE"
  },
  {
    "codigo":253264007,
    "descripcion":"ENFERMEDAD CONGÉNITA DE CORAZÓN, ANOMALÍAS SEPTALES Y BULBARES"
  },
  {
    "codigo":284197002,
    "descripcion":"QUEMADURA SUPERFICIAL DEL CUERO CABELLUDO POR AGENTE CORROSIVO"
  },
  {
    "codigo":22053006,
    "descripcion":"SÍNDROME DE KLINEFELTER"
  },
  {
    "codigo":249594003,
    "descripcion":"CONDUCTO INGUINAL VACÍO"
  },
  {
    "codigo":216826007,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR BUTANO"
  },
  {
    "codigo":870351002,
    "descripcion":"ENTERITIS NO INFECCIOSA DEBIDA A ENFERMEDAD DE INJERTO VERSUS HUÉSPED"
  },
  {
    "codigo":51151007,
    "descripcion":"ILEÍTIS NO INFECCIOSA"
  },
  {
    "codigo":82084003,
    "descripcion":"INFECCIÓN CAUSADA POR METASTRONGYLUS"
  },
  {
    "codigo":704676006,
    "descripcion":"CON MAYOR RIESGO DE RESPUESTA NEGATIVA A ANALGESIA CONTROLADA POR PERSONAL DE ENFERMERÍA"
  },
  {
    "codigo":278692007,
    "descripcion":"ASPIRACIÓN A TRACTO RESPIRATORIO INFERIOR"
  },
  {
    "codigo":15705561000119107,
    "descripcion":"CONCRECIÓN EN CONJUNTIVA DE AMBOS PÁRPADOS SUPERIORES"
  },
  {
    "codigo":80249004,
    "descripcion":"DISTRIBUCIÓN VENTILATORIA NORMAL"
  },
  {
    "codigo":735609006,
    "descripcion":"DEGENERACIÓN DE DISCO INTERVERTEBRAL LUMBAR SIN PROLAPSO"
  },
  {
    "codigo":47481007,
    "descripcion":"ACLORHIDRIA"
  },
  {
    "codigo":45646000,
    "descripcion":"SÍNDROME LACTOALCALINO SUBAGUDO"
  },
  {
    "codigo":1290830001,
    "descripcion":"ATAXIA CAUSADA POR METAL PESADO"
  },
  {
    "codigo":209486006,
    "descripcion":"ESGUINCE DE DEDO DE LA MANO, ARTICULACIÓN INTERFALÁNGICA DISTAL, LIGAMENTO LATERAL RADIAL"
  },
  {
    "codigo":237128009,
    "descripcion":"METROPATÍA HEMORRÁGICA"
  },
  {
    "codigo":240419001,
    "descripcion":"REACCIÓN CUTÁNEA HIPERINMUNITARIA CAUSADA POR MICOBACTERIAS ATÍPICAS"
  },
  {
    "codigo":109347009,
    "descripcion":"NEOPLASIA MALIGNA SUPERPUESTA DE HUESO Y CARTÍLAGO ARTICULAR"
  },
  {
    "codigo":369656001,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA DE PULMÓN, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":238584004,
    "descripcion":"DERMATITIS DE CONTACTO CAUSADA POR MATERIA FECAL"
  },
  {
    "codigo":402424005,
    "descripcion":"LIQUEN ESCLEROSO DE LA INFANCIA"
  },
  {
    "codigo":271352005,
    "descripcion":"VÓMITO BILIOSO"
  },
  {
    "codigo":74744007,
    "descripcion":"TIFLOCOLITIS"
  },
  {
    "codigo":203981000,
    "descripcion":"MENINGOCELE ESPINAL DORSAL"
  },
  {
    "codigo":236749007,
    "descripcion":"BALANITIS POR CLAMIDIA"
  },
  {
    "codigo":302285008,
    "descripcion":"LESIÓN OCUPANTE DE ESPACIO EN HÍGADO"
  },
  {
    "codigo":300450001,
    "descripcion":"URÉTER PRESENTE"
  },
  {
    "codigo":38306002,
    "descripcion":"LACERACIÓN ESTRELLADA DE HÍGADO CON HERIDA ABIERTA HACIA CAVIDAD ABDOMINAL"
  },
  {
    "codigo":398754006,
    "descripcion":"FIBROSIS ENDOMIOCÁRDICA CON MIOCARDIOPATÍA RESTRICTIVA"
  },
  {
    "codigo":396919000,
    "descripcion":"TAMAÑO TUMORAL QUE NO PUEDE SER EVALUADO"
  },
  {
    "codigo":36471000,
    "descripcion":"MIOCARDIOPATÍA DILATADA DEBIDA A LUPUS ERITEMATOSO SISTÉMICO"
  },
  {
    "codigo":298615002,
    "descripcion":"AMPLITUD DE EXTENSIÓN ACTIVA DE LA COLUMNA LUMBAR DISMINUIDA"
  },
  {
    "codigo":724599009,
    "descripcion":"VASCULITIS DE PEQUEÑOS VASOS"
  },
  {
    "codigo":1148748002,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR SULFAMETOXAZOL Y\/O TRIMETOPRIMA"
  },
  {
    "codigo":296780004,
    "descripcion":"SOBREDOSIS DE COMPUESTO DE ANTIMONIO"
  },
  {
    "codigo":722764006,
    "descripcion":"HERNIA PARAESTOMAL OBSTRUIDA"
  },
  {
    "codigo":10629031000119100,
    "descripcion":"LINFADENITIS AGUDA DE CUELLO"
  },
  {
    "codigo":460620006,
    "descripcion":"MIOCARDITIS CAUSADA POR BORRELIA"
  },
  {
    "codigo":10819341000119107,
    "descripcion":"FRACTURA EXPUESTA BILATERAL DE MÚLTIPLES COSTILLAS"
  },
  {
    "codigo":131105003,
    "descripcion":"GLUCAGÓN ANORMAL"
  },
  {
    "codigo":360481003,
    "descripcion":"CONDUCTO AURICULOVENTRICULAR COMÚN"
  },
  {
    "codigo":32801008,
    "descripcion":"PIELITIS AGUDA"
  },
  {
    "codigo":294945008,
    "descripcion":"ALERGIA A SULFONATO SÓDICO DE POLIESTIRENO"
  },
  {
    "codigo":1145078002,
    "descripcion":"DIRECCIÓN DE REMOLINO DE PELO OPUESTA A RESTO DE PELO DE CUERO CABELLUDO"
  },
  {
    "codigo":162038003,
    "descripcion":"DOLOR ABDOMINAL NO CÓLICO"
  },
  {
    "codigo":293110008,
    "descripcion":"REACCIÓN ADVERSA VACUNA CONTRA HEPATITIS B"
  },
  {
    "codigo":717259002,
    "descripcion":"MUCINOSIS PAPULAR DE LA LACTANCIA"
  },
  {
    "codigo":291275006,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR PRACTOLOL"
  },
  {
    "codigo":192971007,
    "descripcion":"SÍNDROME DE LA COLA DE CABALLO SIN COMPROMISO VESICAL"
  },
  {
    "codigo":94667009,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA ÚVULA"
  },
  {
    "codigo":10874791000119106,
    "descripcion":"LACERACIÓN DE PÁRPADO DERECHO"
  },
  {
    "codigo":387744007,
    "descripcion":"HEMOGLOBINURIA DE LA MARCHA"
  },
  {
    "codigo":191136008,
    "descripcion":"ANEMIA HIPOCRÓMICA IDIOPÁTICA"
  },
  {
    "codigo":289440007,
    "descripcion":"FRECUENCIA CARDÍACA FETAL, NO OBSERVADA"
  },
  {
    "codigo":125600009,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA REGIÓN DE LA CADERA"
  },
  {
    "codigo":307111000119107,
    "descripcion":"ARTRITIS ENTEROPÁTICA DE MANO IZQUIERDA"
  },
  {
    "codigo":123765007,
    "descripcion":"TRASTORNO DE LA ALDOSTERONA"
  },
  {
    "codigo":16035751000119108,
    "descripcion":"OSTEÓLISIS BILATERAL DE FÉMURES"
  },
  {
    "codigo":254837009,
    "descripcion":"NEOPLASIA MALIGNA DE MAMA"
  },
  {
    "codigo":416842003,
    "descripcion":"TERATOMA MALIGNO DEL SACRO"
  },
  {
    "codigo":285770005,
    "descripcion":"HALLAZGO RELACIONADO CON EL DESEMPEÑO PERCEPTIVO"
  },
  {
    "codigo":447775001,
    "descripcion":"COLAPSO ESCAFOSEMILUNAR AVANZADO"
  },
  {
    "codigo":15681601000119104,
    "descripcion":"ENOFTALMÍA DE OJO DERECHO DEBIDA A SÍNDROME DEL SENO SILENCIOSO"
  },
  {
    "codigo":54559004,
    "descripcion":"SOPLO UTERINO"
  },
  {
    "codigo":251167004,
    "descripcion":"COMPLEJOS DE LATIDOS PREMATUROS ABERRANTES"
  },
  {
    "codigo":19956000,
    "descripcion":"OSTEOMIELITIS AGUDA DEL ANTEBRAZO"
  },
  {
    "codigo":216564002,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ANTAGONISTAS OPIÁCEOS"
  },
  {
    "codigo":52724003,
    "descripcion":"DEFECTO EN LA OXIDACIÓN DEL YODURO"
  },
  {
    "codigo":413172004,
    "descripcion":"ESTADO DE MONITOREO DEL EJERCICIO"
  },
  {
    "codigo":247497000,
    "descripcion":"SUPERFICIE UNGUEAL RUGOSA"
  },
  {
    "codigo":1073371000119101,
    "descripcion":"ARTRITIS DE TOBILLO IZQUIERDO CAUSADA POR BACTERIAS"
  },
  {
    "codigo":18121009,
    "descripcion":"BERILIOSIS CRÓNICA"
  },
  {
    "codigo":737182002,
    "descripcion":"ENFERMEDAD PULMONAR INTERSTICIAL DEBIDA A ENFERMEDAD GRANULOMATOSA"
  },
  {
    "codigo":704414005,
    "descripcion":"CON MAYOR RIESGO DE ALTERACIÓN DE SUEÑO"
  },
  {
    "codigo":47219002,
    "descripcion":"ENCAJAMIENTO FETAL"
  },
  {
    "codigo":243827004,
    "descripcion":"ESTADO PRENATAL DE ANTICUERPOS ANTI-RHD"
  },
  {
    "codigo":211059005,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE GLÚTEO"
  },
  {
    "codigo":276595007,
    "descripcion":"DISFUNCIÓN PERINATAL NO ESPECÍFICA DEL CEREBRO"
  },
  {
    "codigo":1259635009,
    "descripcion":"OSTEOSARCOMA PRIMARIO DE CARTÍLAGO ARTICULAR DE COSTILLA"
  },
  {
    "codigo":45384004,
    "descripcion":"NACIMIENTO MÚLTIPLE"
  },
  {
    "codigo":733512004,
    "descripcion":"CUELLO ROTADO HACIA LA DERECHA"
  },
  {
    "codigo":78152008,
    "descripcion":"PARÁLISIS MÚLTIPLE DE NERVIO CRANEAL"
  },
  {
    "codigo":241992009,
    "descripcion":"LESIÓN DE LA MÉDULA ESPINAL POR DESCOMPRESIÓN"
  },
  {
    "codigo":274760009,
    "descripcion":"EXAMEN DE MANO SIN ANOMALÍAS DETECTADAS"
  },
  {
    "codigo":76317003,
    "descripcion":"VARIACIÓN NORMAL EN EL COLOR"
  },
  {
    "codigo":209224009,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA EXPUESTA DE LA ARTICULACIÓN ESTERNOCLAVICULAR, ANTERIOR"
  },
  {
    "codigo":829981005,
    "descripcion":"PÚSTULA PROFUNDA"
  },
  {
    "codigo":53256003,
    "descripcion":"FRACTURA EXPUESTA DE HUESO SEMILUNAR DE LA MUÑECA"
  },
  {
    "codigo":895517007,
    "descripcion":"OBSTRUCCIÓN DEL TRACTO DE SALIDA DE LA UNIÓN ESOFAGOGÁSTRICA"
  },
  {
    "codigo":305693007,
    "descripcion":"ATENDIDO POR UN PSIQUIATRA"
  },
  {
    "codigo":698909009,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: LETÓN"
  },
  {
    "codigo":860914002,
    "descripcion":"DISFUNCIÓN ERÉCTIL"
  },
  {
    "codigo":762610001,
    "descripcion":"LESIÓN TRAUMÁTICA DE VÁLVULA CARDÍACA"
  },
  {
    "codigo":10821851000119109,
    "descripcion":"FRACTURA ABIERTA DE BASE DE CUELLO DE FÉMUR DERECHO"
  },
  {
    "codigo":271090005,
    "descripcion":"DEFORMIDAD DE HUESO METACARPIANO"
  },
  {
    "codigo":336091000119109,
    "descripcion":"CORIORRETINITIS DE OJO DERECHO"
  },
  {
    "codigo":240157009,
    "descripcion":"OSTEOPOROSIS GENERALIZADA SECUNDARIA"
  },
  {
    "codigo":1286898004,
    "descripcion":"CARCINOMA QUÍSTICO DE CÉLULAS RENALES METASTÁSICO"
  },
  {
    "codigo":236487000,
    "descripcion":"URINOMA PARARRENAL"
  },
  {
    "codigo":269255007,
    "descripcion":"LESIÓN DEL NERVIO SUPERFICIAL DE CABEZA Y CUELLO"
  },
  {
    "codigo":15956341000119105,
    "descripcion":"ADENOCARCINOMA DE PULMÓN IZQUIERDO"
  },
  {
    "codigo":105415009,
    "descripcion":"COMPROMISO DE CASAMIENTO DISUELTO"
  },
  {
    "codigo":36209000,
    "descripcion":"MELASMA"
  },
  {
    "codigo":1119388009,
    "descripcion":"REDUCCIÓN DE LA ACTIVIDAD ALFA EN EL HEMISFERIO CEREBRAL IZQUIERDO"
  },
  {
    "codigo":365724009,
    "descripcion":"HALLAZGO RELACIONADO CON LA PRESENCIA DE UN AMINOÁCIDO"
  },
  {
    "codigo":298353004,
    "descripcion":"HUESO ACORTADO"
  },
  {
    "codigo":3441005,
    "descripcion":"TRASTORNO DE GLÁNDULA SEBÁCEA"
  },
  {
    "codigo":460358000,
    "descripcion":"ENDOCARDITIS INFECCIOSA EN LOCALIZACIÓN DE PARCHE DE DEFECTO DE TABIQUE INTERVENTRICULAR"
  },
  {
    "codigo":296518002,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE NALOXONA"
  },
  {
    "codigo":1345094006,
    "descripcion":"SÍNDROME DE ABSTINENCIA DE ESTEROIDE ANABÓLICO POSTERIOR A PATRÓN PERJUDICIAL DE CONSUMO"
  },
  {
    "codigo":427590008,
    "descripcion":"SOBREDOSIS DE CLORPROTIXENO"
  },
  {
    "codigo":1606009,
    "descripcion":"INFECCIÓN CAUSADA POR MACRACANTHORHYNCHUS HIRUDINACEUS"
  },
  {
    "codigo":294683007,
    "descripcion":"ALERGIA A FLUOROMETOLONA"
  },
  {
    "codigo":1144816001,
    "descripcion":"INTOXICACIÓN POR PENTAMETONIO"
  },
  {
    "codigo":30704002,
    "descripcion":"ERITEMA EN ALAS DE MARIPOSA"
  },
  {
    "codigo":292848005,
    "descripcion":"REACCIÓN ADVERSA A LA PIRIMETAMINA"
  },
  {
    "codigo":225477000,
    "descripcion":"CONDUCTA ABUSIVA EN EL ASPECTO SEXUAL"
  },
  {
    "codigo":16011791000119107,
    "descripcion":"TROMBOFLEBITIS DE VENA SAFENA DERECHA"
  },
  {
    "codigo":258245003,
    "descripcion":"TUMOR, GRADO G4"
  },
  {
    "codigo":716997004,
    "descripcion":"SÍNDROME DE JOUBERT"
  },
  {
    "codigo":192709004,
    "descripcion":"ENCEFALITIS POSVACUNACIÓN CONTRA LA PESTE"
  },
  {
    "codigo":28869005,
    "descripcion":"MIOCARDIOPATÍA DILATADA DEBIDA A DISTROFIA MUSCULAR"
  },
  {
    "codigo":127173007,
    "descripcion":"LINFADENOPATÍA HIPOGÁSTRICA"
  },
  {
    "codigo":94405008,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL MAXILAR SUPERIOR"
  },
  {
    "codigo":92570000,
    "descripcion":"CARCINOMA IN SITU DEL COLÉDOCO"
  },
  {
    "codigo":27034006,
    "descripcion":"PROBLEMA DE FERTILIDAD"
  },
  {
    "codigo":418415002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD DE EXPRESAR VERBALMENTE LA COMPRENSIÓN"
  },
  {
    "codigo":713327005,
    "descripcion":"MENINGIOMA MALIGNO DE MENINGES CEREBRAL"
  },
  {
    "codigo":338601000119105,
    "descripcion":"RETINITIS FOCAL DE POLO POSTERIOR DE OJO IZQUIERDO"
  },
  {
    "codigo":285508001,
    "descripcion":"PROTRUYE LA LENGUA TOTALMENTE"
  },
  {
    "codigo":1268548007,
    "descripcion":"CARCINOMA PRIMARIO DE ESÓFAGO TIPO GLÁNDULA SALIVAL"
  },
  {
    "codigo":283673001,
    "descripcion":"HERIDA POR PINCHAZO DE CLAVO EN LA ESPINILLA"
  },
  {
    "codigo":21529005,
    "descripcion":"ACIDURIA BETA-AMINOISOBUTÍRICA"
  },
  {
    "codigo":185369008,
    "descripcion":"DERIVADO POR FARMACÉUTICO"
  },
  {
    "codigo":871662001,
    "descripcion":"DISECCIÓN DE AORTA EN SITIO DE COARTACIÓN DESPUÉS DE PROCEDIMIENTO"
  },
  {
    "codigo":87065009,
    "descripcion":"DISTROFIA DE UÑAS"
  },
  {
    "codigo":19694002,
    "descripcion":"DISTIMIA DE INICIO TARDÍO"
  },
  {
    "codigo":183534008,
    "descripcion":"DERIVADO AL ANESTESIÓLOGO"
  },
  {
    "codigo":249070009,
    "descripcion":"POSICIÓN OCCIPITOPOSTERIOR DIRECTA"
  },
  {
    "codigo":312771007,
    "descripcion":"TRASTORNO DEL CUERPO VÍTREO Y DE LA RETINA"
  },
  {
    "codigo":736920000,
    "descripcion":"INFECCIÓN DE TORRENTE SANGUÍNEO ASOCIADA A CATÉTER PARA HEMODIÁLISIS TUNELIZADO IN SITU"
  },
  {
    "codigo":704152002,
    "descripcion":"NEUROBLASTOMA METASTÁSICO"
  },
  {
    "codigo":212632003,
    "descripcion":"INTOXICACIÓN POR BROMO"
  },
  {
    "codigo":15631171000119106,
    "descripcion":"RUPTURA PARCIAL NO TRAUMÁTICA DE AMBOS MANGUITOS ROTADORES"
  },
  {
    "codigo":15932381000119100,
    "descripcion":"ABSCESO DE TROMPA DE FALOPIO IZQUIERDA Y OVARIO IZQUIERDO"
  },
  {
    "codigo":48792006,
    "descripcion":"DEFERENTITIS"
  },
  {
    "codigo":1259373001,
    "descripcion":"CARCINOMA ESCAMOSO FUSOCELULAR PRIMARIO DE PIEL"
  },
  {
    "codigo":440173001,
    "descripcion":"NEOPLASIA DE PULMÓN DE CÉLULAS NO MICROCÍTICAS NO ESCAMOSAS"
  },
  {
    "codigo":702317003,
    "descripcion":"PARÁLISIS CEREBRAL COREOATETOIDE"
  },
  {
    "codigo":14189004,
    "descripcion":"SARAMPIÓN"
  },
  {
    "codigo":276333003,
    "descripcion":"PENE PEQUEÑO"
  },
  {
    "codigo":767853006,
    "descripcion":"QUISTE ÓSEO DE CINTURA ESCAPULAR"
  },
  {
    "codigo":733250006,
    "descripcion":"LUXACIÓN TRAUMÁTICA DE ARTICULACIÓN RADIOCUBITAL DISTAL"
  },
  {
    "codigo":405570007,
    "descripcion":"FIBROSIS PULMONAR DEBIDA A RADIOTERAPIA Y POSTERIOR A ELLA"
  },
  {
    "codigo":208962006,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA NO EXPUESTA DE LA ARTICULACIÓN DE LA RODILLA, POSTERIOR"
  },
  {
    "codigo":895255003,
    "descripcion":"FORMA TRIANGULAR ANORMAL CONGÉNITA DE FALANGE PROXIMAL DE DEDO MEDIO"
  },
  {
    "codigo":403735006,
    "descripcion":"SÍNDROME DE EOSINOFILIA-MIALGIA CAUSADO POR TRIPTÓFANO"
  },
  {
    "codigo":239895006,
    "descripcion":"SÍNDROME ANTIFOSFOLIPÍDICO SECUNDARIO"
  },
  {
    "codigo":238060000,
    "descripcion":"PÉRDIDA GENERAL DE LA FUNCIÓN PEROXISÓMICA"
  },
  {
    "codigo":370967009,
    "descripcion":"RETINOBLASTOMA"
  },
  {
    "codigo":8684002,
    "descripcion":"TRASTORNO DEL JUICIO"
  },
  {
    "codigo":762348004,
    "descripcion":"INSOMNIO AGUDO"
  },
  {
    "codigo":41452004,
    "descripcion":"ÚTERO ACERVICAL"
  },
  {
    "codigo":205292007,
    "descripcion":"SOBRECRECIMIENTO PARCIAL DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":367581000119107,
    "descripcion":"ANOMALÍA GLOMERULAR MENOR HEREDITARIA"
  },
  {
    "codigo":568171000005100,
    "descripcion":"BEBEDORA DE ALCOHOL PREVIO A CONFIRMACIÓN DE EMBARAZO"
  },
  {
    "codigo":6849006,
    "descripcion":"RUPTURA DE TENDÓN DE MÚSCULO CUÁDRICEPS"
  },
  {
    "codigo":668011000005103,
    "descripcion":"ERITROCITOS EN ORINA = ++"
  },
  {
    "codigo":299926002,
    "descripcion":"DISCRIMINACIÓN TOCO-PINCHO PRESENTE"
  },
  {
    "codigo":234390005,
    "descripcion":"TALASEMIA GAMMA"
  },
  {
    "codigo":365462008,
    "descripcion":"HALLAZGO RELACIONADO CON EL NIVEL DE INTERÉS"
  },
  {
    "codigo":167019000,
    "descripcion":"GASES EN SANGRE DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":725910009,
    "descripcion":"DUPLICACIÓN CONGÉNITA DE RECTO"
  },
  {
    "codigo":70550008,
    "descripcion":"CINTILLA OVÁRICA"
  },
  {
    "codigo":298091008,
    "descripcion":"CUERPO EXTRAÑO EN LA PIEL DE LOS GENITALES"
  },
  {
    "codigo":363627009,
    "descripcion":"PARATIROMATOSIS"
  },
  {
    "codigo":66880003,
    "descripcion":"TEMBLOR OPIOPHAGORUM"
  },
  {
    "codigo":230720005,
    "descripcion":"TROMBOSIS VENOSA CEREBRAL DE SENO RECTO"
  },
  {
    "codigo":29711000175109,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN EN CADERA DERECHA"
  },
  {
    "codigo":294421001,
    "descripcion":"ALERGIA A VAPOR INDUSTRIAL METILADO"
  },
  {
    "codigo":341111000119107,
    "descripcion":"DACRIOLITO DE OJO IZQUIERDO"
  },
  {
    "codigo":12111121000119102,
    "descripcion":"QUEMADURA QUÍMICA DE SEGUNDO GRADO DE PIE IZQUIERDO"
  },
  {
    "codigo":292586005,
    "descripcion":"REACCIÓN ADVERSA A LA BROMFENIRAMINA"
  },
  {
    "codigo":1144554007,
    "descripcion":"APLASIA DE OVARIO"
  },
  {
    "codigo":63210009,
    "descripcion":"MANCHADO POSTERUPTIVO DE DIENTE CAUSADO POR METAL"
  },
  {
    "codigo":94143002,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA VULVA"
  },
  {
    "codigo":314641000119105,
    "descripcion":"ESTENOSIS ÓSEA Y SUBLUXACIÓN DE AGUJEROS INTERVERTEBRALES LUMBARES"
  },
  {
    "codigo":288916001,
    "descripcion":"NO RETIRA ALIMENTO DEL SURCO YUGAL"
  },
  {
    "codigo":190612001,
    "descripcion":"HIPOVITAMINOSIS A CON XEROSIS CORNEAL Y ÚLCERA"
  },
  {
    "codigo":59540003,
    "descripcion":"DESIGUALDAD EN EL TAMAÑO DE LOS VENTRÍCULOS CEREBRALES"
  },
  {
    "codigo":126911008,
    "descripcion":"NEOPLASIA DEL ISTMO UTERINO"
  },
  {
    "codigo":92308005,
    "descripcion":"NEOPLASIA BENIGNA DE LA PRÓSTATA"
  },
  {
    "codigo":11783441000119106,
    "descripcion":"HERIDA INFECTADA DE CADERA IZQUIERDA DEBIDA A PICADURA DE INSECTO NO VENENOSO"
  },
  {
    "codigo":16207121000119107,
    "descripcion":"DOLOR EN MUÑÓN DE AMPUTACIÓN DE AMBAS EXTREMIDADES SUPERIORES"
  },
  {
    "codigo":11838891000119101,
    "descripcion":"DISTENSIÓN DE MÚSCULO INTRÍNSECO DE DEDO ÍNDICE DE MANO IZQUIERDA"
  },
  {
    "codigo":713065005,
    "descripcion":"CALIDAD DEL SOPLO CARDÍACO, CRUJIENTE"
  },
  {
    "codigo":449086000,
    "descripcion":"ANOMALÍA DE EBSTEIN DE VÁLVULA AURICULOVENTRICULAR IZQUIERDA EN CORAZÓN FUNCIONALMENTE UNIVENTRICULAR"
  },
  {
    "codigo":416318006,
    "descripcion":"RESONANCIA MAGNÉTICA CEREBRAL, NORMAL"
  },
  {
    "codigo":285246007,
    "descripcion":"ABSTRACCIÓN SELECTIVA"
  },
  {
    "codigo":283411000,
    "descripcion":"CORTE EN LA AXILA"
  },
  {
    "codigo":51531000087100,
    "descripcion":"DYSGONOMONAS MOSSII O DYSGONOMONAS ORYZARVI"
  },
  {
    "codigo":38731000087104,
    "descripcion":"SÍNDROME DE DOLOR CRÓNICO PRIMARIO DE VEJIGA"
  },
  {
    "codigo":46411000087104,
    "descripcion":"FRACTURA DE PRIMER HUESO METACARPIANO DE MANO IZQUIERDA"
  },
  {
    "codigo":41291000087104,
    "descripcion":"HEMATOMA DE QUINTO DEDO DE PIE IZQUIERDO"
  },
  {
    "codigo":1231848000,
    "descripcion":"LESIÓN ESOFÁGICA CAUSADA POR ÁLCALI"
  },
  {
    "codigo":86803008,
    "descripcion":"NACIMIENTO DE TÉRMINO DE QUINTILLIZOS"
  },
  {
    "codigo":43851000087109,
    "descripcion":"CORTE EN PIEL DE DEDO ÍNDICE DE MANO DERECHA"
  },
  {
    "codigo":410813000,
    "descripcion":"CONTRACTURA DE LA FASCIA PALMAR"
  },
  {
    "codigo":1197245001,
    "descripcion":"OPCIONES DE TRANSPORTE DISPONIBLES PARA FACILITAR LA LOGÍSTICA HASTA EL LUGAR DE DESTINO"
  },
  {
    "codigo":771261002,
    "descripcion":"APLASIA DE MÚSCULO EXTENSOR DIGITAL CON POLINEUROPATÍA"
  },
  {
    "codigo":441746000,
    "descripcion":"INFARTO DE PULMÓN DEBIDO A EMBOLIA PULMONAR IATROGÉNICA"
  },
  {
    "codigo":246973008,
    "descripcion":"HALLAZGO RELACIONADO CON LA ESCLERÓTICA Y LA EPIESCLERÓTICA"
  },
  {
    "codigo":277906002,
    "descripcion":"ESPUTO CREMOSO"
  },
  {
    "codigo":1162642006,
    "descripcion":"DEGENERACIÓN DE FIBROMA UTERINO"
  },
  {
    "codigo":1259111000,
    "descripcion":"RINORRAQUIA DEBIDA A SÍNDROME DE LA SILLA TURCA VACÍA"
  },
  {
    "codigo":276071001,
    "descripcion":"EL ASESOR DE CARRERAS LO CONOCE"
  },
  {
    "codigo":210535004,
    "descripcion":"HERIDA ABIERTA DE LA MUÑECA, VOLAR"
  },
  {
    "codigo":110396000,
    "descripcion":"SIN EVIDENCIA DE CÁNCER"
  },
  {
    "codigo":343621000119105,
    "descripcion":"ESCLEROQUERATITIS DE AMBOS OJOS"
  },
  {
    "codigo":77628002,
    "descripcion":"VASCULITIS RETINIANA"
  },
  {
    "codigo":700220003,
    "descripcion":"OTITIS EXTERNA BACTERIANA AGUDA"
  },
  {
    "codigo":765756007,
    "descripcion":"SÍNDROME DE CONVULSIÓN INFANTIL BENIGNA CON GASTROENTERITIS LEVE"
  },
  {
    "codigo":1255441000,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO DE DEDO DE PIE (SEGUNDO A QUINTO)"
  },
  {
    "codigo":208700009,
    "descripcion":"FRACTURA EXPUESTA DE DIÁFISIS METATARSIANA"
  },
  {
    "codigo":43025008,
    "descripcion":"TOS PAROXÍSTICA"
  },
  {
    "codigo":403473009,
    "descripcion":"LIPOGRANULOMA ESCLEROSANTE DE PENE"
  },
  {
    "codigo":237798008,
    "descripcion":"VIRILIZACIÓN MEDICAMENTOSA"
  },
  {
    "codigo":203195003,
    "descripcion":"OSTEOMIELITIS CRÓNICA DE LA COLUMNA VERTEBRAL LUMBAR"
  },
  {
    "codigo":72123004,
    "descripcion":"POBREZA DEL HABLA"
  },
  {
    "codigo":301499006,
    "descripcion":"SE MOVILIZA EN EL INTERIOR"
  },
  {
    "codigo":234128000,
    "descripcion":"VENA ECTÁSICA"
  },
  {
    "codigo":365200000,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA REALIZAR ACTIVIDADES DE CUIDADO DE LAS UÑAS"
  },
  {
    "codigo":299664003,
    "descripcion":"SIGNO PÉLVICO CON NOMBRE PROPIO"
  },
  {
    "codigo":1348240005,
    "descripcion":"PATRÓN DE USO NOCIVO DE SUSTANCIA SIN DEPENDENCIA, EN REMISIÓN"
  },
  {
    "codigo":2917005,
    "descripcion":"HIPOTIROIDISMO TRANSITORIO"
  },
  {
    "codigo":363365008,
    "descripcion":"NEOPLASIA MALIGNA DE PARTES BLANDAS DE TÓRAX"
  },
  {
    "codigo":66618001,
    "descripcion":"FUNCIÓN CORPORAL GENERAL DISMINUIDA"
  },
  {
    "codigo":721978002,
    "descripcion":"SÍNDROME DE LINFEDEMA, DEFECTO DEL TABIQUE INTERAURICULAR Y CAMBIOS FACIALES"
  },
  {
    "codigo":164922005,
    "descripcion":"ONDA R ELEVADA"
  },
  {
    "codigo":197690007,
    "descripcion":"SÍNDROME NEFRÍTICO RÁPIDAMENTE PROGRESIVO, ANOMALÍA GLOMERULAR MENOR"
  },
  {
    "codigo":263226008,
    "descripcion":"FRACTURA SUBCAPITAL DE CUELLO DE FÉMUR"
  },
  {
    "codigo":230458008,
    "descripcion":"ESTADO EPILÉPTICO DE AUSENCIA ATÍPICO"
  },
  {
    "codigo":359695002,
    "descripcion":"COROIDITIS PARASITARIA"
  },
  {
    "codigo":195855002,
    "descripcion":"CORDITIS VOCAL INFERIOR"
  },
  {
    "codigo":425231005,
    "descripcion":"CARCINOMA DE VEJIGA, SUPERFICIAL"
  },
  {
    "codigo":1177060002,
    "descripcion":"TRASTORNO DE TICS DEBIDO A NEUROSÍFILIS"
  },
  {
    "codigo":128484008,
    "descripcion":"ENFERMEDAD AGUDA DE VASO LINFÁTICO"
  },
  {
    "codigo":292324009,
    "descripcion":"REACCIÓN ADVERSA A LA PRIMIDONA"
  },
  {
    "codigo":95716008,
    "descripcion":"SINEQUIAS ANTERIORES FOCALES DEL IRIS"
  },
  {
    "codigo":716473003,
    "descripcion":"CAPAZ DE LAVAR LA PARTE SUPERIOR DEL CUERPO"
  },
  {
    "codigo":421561005,
    "descripcion":"REDUCCIÓN CONCÉNTRICA DEL CAMPO VISUAL"
  },
  {
    "codigo":224953005,
    "descripcion":"PERSONALIDAD ALEGRE"
  },
  {
    "codigo":1339065007,
    "descripcion":"FRACTURA DE FALANGE DE SEGUNDO DEDO DE PIE"
  },
  {
    "codigo":126649009,
    "descripcion":"NEOPLASIA DEL TABIQUE RECTOVESICAL"
  },
  {
    "codigo":290489009,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR ETOMIDATO"
  },
  {
    "codigo":288654003,
    "descripcion":"PARTICIPA EN UNA CONVERSACIÓN"
  },
  {
    "codigo":92046007,
    "descripcion":"NEOPLASIA BENIGNA DE CARTÍLAGO DE LA NARIZ"
  },
  {
    "codigo":286819004,
    "descripcion":"RASGO DE LA PERSONALIDAD: AUTOSUFICIENCIA - HALLAZGO"
  },
  {
    "codigo":188515006,
    "descripcion":"LINFOMA DE BURKITT DE GANGLIOS LINFÁTICOS INTRAPÉLVICOS"
  },
  {
    "codigo":254051008,
    "descripcion":"SÍNDROME DE POLIDACTILIA Y COSTILLA CORTA TIPO III"
  },
  {
    "codigo":55608001,
    "descripcion":"PRURIGO SIMPLE"
  },
  {
    "codigo":1083411000119105,
    "descripcion":"INFLAMACIÓN CRÓNICA DE PORCIÓN PETROSA DE AMBOS HUESOS TEMPORALES"
  },
  {
    "codigo":2211000124103,
    "descripcion":"CANINO INFERIOR IZQUIERDO DECIDUO SUPERNUMERARIO"
  },
  {
    "codigo":53773002,
    "descripcion":"MUCOCELE DEL APÉNDICE"
  },
  {
    "codigo":445091000124106,
    "descripcion":"RECIBE TODO EL APOYO SOCIAL QUE DESEA"
  },
  {
    "codigo":21005005,
    "descripcion":"DOLOR EPIGÁSTRICO URENTE"
  },
  {
    "codigo":611491000124109,
    "descripcion":"DISPONE DE MEDIO DE TRANSPORTE QUE SATISFACE NECESIDADES COGNITIVAS"
  },
  {
    "codigo":1231586000,
    "descripcion":"OBSTRUCCIÓN DE VÍA RESPIRATORIA CAUSADA POR POROTO EN NARIZ"
  },
  {
    "codigo":283149008,
    "descripcion":"ANZUELO EN LA FRENTE"
  },
  {
    "codigo":446989009,
    "descripcion":"NEFRONOPTISIS TIPO 4"
  },
  {
    "codigo":838370001,
    "descripcion":"AGENESIA DE AMBOS PULMONES"
  },
  {
    "codigo":84706005,
    "descripcion":"INFECCIÓN CAUSADA POR NEMATODOS"
  },
  {
    "codigo":1295287004,
    "descripcion":"ICTERICIA NEONATAL DEBIDA A CONTUSIÓN"
  },
  {
    "codigo":246711006,
    "descripcion":"CONVERGENCIA EN EL ESTRABISMO MANIFIESTO"
  },
  {
    "codigo":1162380001,
    "descripcion":"HIPERTROFIA DE CUELLO DE VEJIGA URINARIA"
  },
  {
    "codigo":212108009,
    "descripcion":"QUEMADURA QUE COMPROMETE 80-89 PORCIENTO DE LA SUPERFICIE DEL CUERPO, CON QUEMADURA DE ESPESOR COMPLETO QUE AFECTA 40-49 PORCIENTO DE LA SUPERFICIE CORPORAL"
  },
  {
    "codigo":277644009,
    "descripcion":"SÍNDROME DE VARICELA CONGÉNITA"
  },
  {
    "codigo":10860871000119101,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR DETERGENTE"
  },
  {
    "codigo":15966381000119107,
    "descripcion":"ESTENOSIS CONGÉNITA DE ARTERIA RENAL IZQUIERDA"
  },
  {
    "codigo":243041007,
    "descripcion":"LESIÓN POR EXPLOSIÓN NUCLEAR"
  },
  {
    "codigo":767329007,
    "descripcion":"AUSENCIA CONGÉNITA DE TESTÍCULO DERECHO"
  },
  {
    "codigo":172734791000119103,
    "descripcion":"TROMBOSIS VENOSA PROFUNDA CRÓNICA DURANTE PERÍODO POSPARTO"
  },
  {
    "codigo":208438007,
    "descripcion":"FRACTURA NO EXPUESTA DE LA FALANGE PROXIMAL DEL PULGAR,CABEZA"
  },
  {
    "codigo":110134008,
    "descripcion":"LACERACIÓN SIMPLE DE AMÍGDALA PALATINA"
  },
  {
    "codigo":403211002,
    "descripcion":"FORMA PAPULAR DE ERITEMA MULTIFORME"
  },
  {
    "codigo":443144000,
    "descripcion":"SARCOMA METASTÁSICO"
  },
  {
    "codigo":763659007,
    "descripcion":"STENT DOBLE J PRESENTE"
  },
  {
    "codigo":1351648007,
    "descripcion":"AGAMMAGLOBULINEMIA AUTOSÓMICA RECESIVA DEBIDA A DEFICIENCIA DE FNIP1"
  },
  {
    "codigo":39093002,
    "descripcion":"RESPUESTA POST - TRAUMÁTICA"
  },
  {
    "codigo":170165002,
    "descripcion":"EXAMEN DEL NIÑO A LOS 4,5 AÑOS: ANORMAL - DERIVADO"
  },
  {
    "codigo":202933002,
    "descripcion":"BURSITIS SIFILÍTICA"
  },
  {
    "codigo":397706001,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA AFRONTAR SITUACIONES"
  },
  {
    "codigo":364938002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA CONTROLAR LA POSICIÓN DE LA CINTURA ESCAPULAR"
  },
  {
    "codigo":430474001,
    "descripcion":"CAPSULITIS ADHESIVA SECUNDARIA"
  },
  {
    "codigo":11843911000119109,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA PARCIAL DE OÍDO EXTERNO IZQUIERDO"
  },
  {
    "codigo":299402007,
    "descripcion":"PRUEBA DE HIPERFLEXIÓN DE LA RODILLA: NEGATIVA"
  },
  {
    "codigo":232031001,
    "descripcion":"RETINOPATÍA DE VALSALVA"
  },
  {
    "codigo":2655002,
    "descripcion":"INVALIDEZ"
  },
  {
    "codigo":723551003,
    "descripcion":"TRICOTIODISTROFIA"
  },
  {
    "codigo":233866009,
    "descripcion":"INSUFICIENCIA FUNCIONAL DE VÁLVULA PULMONAR"
  },
  {
    "codigo":461407005,
    "descripcion":"ESTENOSIS ADQUIRIDA DE ESTRUCTURA VENOSA PULMONAR"
  },
  {
    "codigo":35423006,
    "descripcion":"HERNIA RETROPERITONEAL CON GANGRENA"
  },
  {
    "codigo":363103008,
    "descripcion":"COMPLICACIÓN DE PROCEDIMIENTO EN EL SISTEMA ENDOCRINO"
  },
  {
    "codigo":361268000,
    "descripcion":"EPILEPSIA INDUCIDA POR ALCOHOL"
  },
  {
    "codigo":721716004,
    "descripcion":"COLANGIOCARCINOMA PRIMARIO DE VÍA BILIAR INTRAHEPÁTICA"
  },
  {
    "codigo":66356008,
    "descripcion":"ÁNTRAX DE HOMBRO"
  },
  {
    "codigo":228361001,
    "descripcion":"AVERGONZADO DE BEBER"
  },
  {
    "codigo":295732009,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE AMSACRINA"
  },
  {
    "codigo":293897005,
    "descripcion":"ALERGIA A KETAZOLAM"
  },
  {
    "codigo":457737009,
    "descripcion":"TROMBOSIS DE VÁLVULA AURICULOVENTRICULAR DERECHA (MORFOLÓGICAMENTE NO TRICÚSPIDE)"
  },
  {
    "codigo":292062004,
    "descripcion":"REACCIÓN ADVERSA AL ALFENTANILO"
  },
  {
    "codigo":326855291000119103,
    "descripcion":"MELANOMA MALIGNO DE PIEL DE AMBOS ANTEBRAZOS"
  },
  {
    "codigo":128222007,
    "descripcion":"SECUESTRO DE HUESO CRANEAL"
  },
  {
    "codigo":95454007,
    "descripcion":"HEMORRAGIA DEL TRONCO ENCEFÁLICO"
  },
  {
    "codigo":880051003,
    "descripcion":"INSUFICIENCIA ADQUIRIDA DE VÁLVULA AURICULOVENTRICULAR COMÚN POSTERIOR A REPARACIÓN DE COMUNICACIÓN BIVENTRICULAR"
  },
  {
    "codigo":13015781000119100,
    "descripcion":"MELANOCITOSIS OCULAR CONGÉNITA DE OJO DERECHO"
  },
  {
    "codigo":113381000119100,
    "descripcion":"CODEPENDENCIA"
  },
  {
    "codigo":1091301000119102,
    "descripcion":"LESIÓN DEL OÍDO DERECHO"
  },
  {
    "codigo":10760421000119102,
    "descripcion":"TRASTORNO PSICÓTICO EN LA MADRE QUE COMPLICA EL NACIMIENTO"
  },
  {
    "codigo":336101000119104,
    "descripcion":"CICATRIZ CORIORRETINIANA DE OJO DERECHO"
  },
  {
    "codigo":93619007,
    "descripcion":"FALTA DE OSIFICACIÓN DE ARCO DE VÉRTEBRA CERVICAL"
  },
  {
    "codigo":300261000119100,
    "descripcion":"DESIGUALDAD ADQUIRIDA DE LA LONGITUD DE MIEMBROS"
  },
  {
    "codigo":15959781000119107,
    "descripcion":"QUISTE DE LIGAMENTO ANCHO IZQUIERDO"
  },
  {
    "codigo":59016004,
    "descripcion":"INFESTACIÓN CAUSADA POR VARROA"
  },
  {
    "codigo":305381000119108,
    "descripcion":"CONTRACTURA DE MÚSCULO DE MANO DERECHA"
  },
  {
    "codigo":11858661000119108,
    "descripcion":"LESIÓN TRAUMÁTICA DE ARTERIA TIBIAL ANTERIOR IZQUIERDA"
  },
  {
    "codigo":323301000119109,
    "descripcion":"ARTROSIS DE RODILLA IZQUIERDA"
  },
  {
    "codigo":10809061000119106,
    "descripcion":"PALUDISMO EN LA MADRE QUE COMPLICA EL NACIMIENTO"
  },
  {
    "codigo":16466661000119106,
    "descripcion":"MELORREOSTOSIS DE REGIÓN DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":253789002,
    "descripcion":"ROTACIÓN ANÓMALA FAMILIAR DE INTESTINO"
  },
  {
    "codigo":15629541000119106,
    "descripcion":"INSUFICIENCIA CARDÍACA CONGESTIVA EN ESTADIO C DEBIDA A MIOCARDIOPATÍA ISQUÉMICA"
  },
  {
    "codigo":16881381000119108,
    "descripcion":"INTOXICACIÓN CAUSADA POR GAS PIMIENTA"
  },
  {
    "codigo":307941000119108,
    "descripcion":"FÍSTULA DE ARTICULACIÓN DE MUÑECA DERECHA"
  },
  {
    "codigo":12104421000119109,
    "descripcion":"NECROSIS TISULAR DE PIE DERECHO DEBIDA A CONGELAMIENTO Y POSTERIOR A ÉL"
  },
  {
    "codigo":57181007,
    "descripcion":"ENDOCARDITIS TROMBÓTICA ABACTERIANA"
  },
  {
    "codigo":448562000,
    "descripcion":"NEUROFIBROMA DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":288392008,
    "descripcion":"DIFICULTAD PARA RETORCER ROPA"
  },
  {
    "codigo":186418003,
    "descripcion":"GANGRENA GASEOSA DE ANTEBRAZO"
  },
  {
    "codigo":55346003,
    "descripcion":"PÉRDIDA DE LAS ASOCIACIONES"
  },
  {
    "codigo":250119000,
    "descripcion":"RUIDOS EN ARTICULACIÓN"
  },
  {
    "codigo":86279000,
    "descripcion":"OTITIS MEDIA AGUDA SUPURATIVA CON RUPTURA ESPONTÁNEA DEL TÍMPANO"
  },
  {
    "codigo":18908003,
    "descripcion":"TEMBLOR TÓXICO"
  },
  {
    "codigo":281052005,
    "descripcion":"NACIMIENTO DE TRILLIZOS"
  },
  {
    "codigo":16898991000119100,
    "descripcion":"ECOGRAFÍA DE VÍA BILIAR ANORMAL"
  },
  {
    "codigo":1264092008,
    "descripcion":"TRASTORNO NEONATAL CAUSADO POR AGENTE ANTINEOPLÁSICO TRANSMITIDO POR LECHE MATERNA"
  },
  {
    "codigo":15238002,
    "descripcion":"HEMORRAGIA DE ESÓFAGO"
  },
  {
    "codigo":211846003,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO PROFUNDA DE REGIÓN ESCAPULAR"
  },
  {
    "codigo":406619001,
    "descripcion":"INFECCIÓN CAUSADA POR TOXOCARA"
  },
  {
    "codigo":734299002,
    "descripcion":"TROMBOEMBOLIA DE ARTERIA ILÍACA EXTERNA"
  },
  {
    "codigo":308315007,
    "descripcion":"SITUACIÓN DE EXENCIÓN DEL PAGO DE PRESCRIPCIÓN"
  },
  {
    "codigo":111707007,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE PARED TORÁCICA CON INFECCIÓN"
  },
  {
    "codigo":351151000119105,
    "descripcion":"NEOPLASIA BENIGNA DE CONJUNTIVA IZQUIERDA"
  },
  {
    "codigo":11568002,
    "descripcion":"CADERA EN RESORTE"
  },
  {
    "codigo":44336002,
    "descripcion":"EFECTO TÓXICO CAUSADO POR ALDRÍN"
  },
  {
    "codigo":372016004,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE PERITONEO"
  },
  {
    "codigo":678831000119106,
    "descripcion":"NÉBULA DE CÓRNEA IZQUIERDA"
  },
  {
    "codigo":75269001,
    "descripcion":"FUNCIÓN VASOMOTORA NORMAL"
  },
  {
    "codigo":42501001,
    "descripcion":"OSTEÍTIS NO SUPURATIVA AGUDA DE LA MANDÍBULA"
  },
  {
    "codigo":9733003,
    "descripcion":"REFLUJO GASTRODUODENAL"
  },
  {
    "codigo":271877004,
    "descripcion":"SOFOCACIÓN"
  },
  {
    "codigo":763397001,
    "descripcion":"COLITIS ISQUÉMICA GANGRENOSA"
  },
  {
    "codigo":402949003,
    "descripcion":"SIFÍLIDE NODULAR"
  },
  {
    "codigo":206341008,
    "descripcion":"GRANULOMA INFECCIOSO"
  },
  {
    "codigo":237274002,
    "descripcion":"DESPRENDIMIENTO DE PLACENTA OCULTO"
  },
  {
    "codigo":302810003,
    "descripcion":"INFECCIONES VIRALES DEL SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":1187546002,
    "descripcion":"NEFROPATÍA TUBULOINTERSTICIAL DEBIDA A CISTINOSIS"
  },
  {
    "codigo":399279001,
    "descripcion":"OBSTRUCCIÓN ADQUIRIDA DE CUELLO DE VEJIGA URINARIA"
  },
  {
    "codigo":366511002,
    "descripcion":"HALLAZGO RELACIONADO CON LA AMPLITUD DE EXTENSIÓN PASIVA DE CODO"
  },
  {
    "codigo":169903003,
    "descripcion":"PUNTAJE DE APGAR AL MINUTO = 6"
  },
  {
    "codigo":38831007,
    "descripcion":"ESPLENOSIS"
  },
  {
    "codigo":202671008,
    "descripcion":"ESPONDILOSIS DORSAL EN DOS NIVELES CON MIELOPATÍA"
  },
  {
    "codigo":200836002,
    "descripcion":"DERMATITIS DE BERLOQUE"
  },
  {
    "codigo":233604007,
    "descripcion":"NEUMONÍA"
  },
  {
    "codigo":721454000,
    "descripcion":"SÍNDROME DEL CORDÓN CENTRAL DE MÉDULA ESPINAL AL NIVEL DEL DECIMOSEGUNDO SEGMENTO DORSAL"
  },
  {
    "codigo":262702004,
    "descripcion":"EDEMA DE MÉDULA ESPINAL DORSAL"
  },
  {
    "codigo":426542005,
    "descripcion":"HIPOVENTILACIÓN DURANTE EL SUEÑO POR OBSTRUCCIÓN DE LA VÍA AÉREA INFERIOR"
  },
  {
    "codigo":197166005,
    "descripcion":"ABSCESO RECTAL"
  },
  {
    "codigo":295470007,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE DOCUSATO"
  },
  {
    "codigo":293635003,
    "descripcion":"ALERGIA A PROTEÍNA PURIFICADA DE TUBERCULINA"
  },
  {
    "codigo":129795008,
    "descripcion":"ENGROSAMIENTO DE LAS TRABÉCULAS MAMARIAS"
  },
  {
    "codigo":95192000,
    "descripcion":"LINFOMA NODULAR DE GANGLIOS LINFÁTICOS DE LOCALIZACIONES MÚLTIPLES"
  },
  {
    "codigo":291800006,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR GLUCAGÓN"
  },
  {
    "codigo":289965001,
    "descripcion":"TOS CRUPAL"
  },
  {
    "codigo":93357002,
    "descripcion":"POSICIÓN ANÓMALA CONGÉNITA DE HUESO DEL TARSO"
  },
  {
    "codigo":715949008,
    "descripcion":"PROBLEMA SERIO DE SALUD FÍSICA"
  },
  {
    "codigo":353661000119102,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA SUPERPUESTA DE HUESO Y CARTÍLAGO ARTICULAR DE MIEMBRO INFERIOR"
  },
  {
    "codigo":25981000119102,
    "descripcion":"SÍNDROME DE ABERTURA DE SALIDA TORÁCICA VENOSO"
  },
  {
    "codigo":124290002,
    "descripcion":"DEFICIENCIA DE 2, 5 - DIAMINOVALERATO AMINOTRANSFERASA"
  },
  {
    "codigo":253527000,
    "descripcion":"ANEURISMA VENTRICULAR DERECHO CONGÉNITO"
  },
  {
    "codigo":286295003,
    "descripcion":"INCAPAZ DE ARTICULAR CLARAMENTE"
  },
  {
    "codigo":89687005,
    "descripcion":"SÍNDROME DE SUMERSIÓN - POSTINMERSIÓN"
  },
  {
    "codigo":218924000,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR ALEXITOL SÓDICO"
  },
  {
    "codigo":448300007,
    "descripcion":"MELANOMA MALIGNO DE PIEL DE VULVA"
  },
  {
    "codigo":1201964008,
    "descripcion":"MIOPATÍA CONGÉNITA POR DESPROPORCIÓN DEL TIPO DE FIBRA DEBIDA A MUTACIÓN DE GEN ZAK"
  },
  {
    "codigo":249857004,
    "descripcion":"PÉRDIDA DE PERCEPCIÓN DE LA LÍNEA MEDIA"
  },
  {
    "codigo":446465005,
    "descripcion":"RUPTURA TRAUMÁTICA DE VASO MESENTÉRICO"
  },
  {
    "codigo":315393008,
    "descripcion":"NACIDO EN BURKINA FASO"
  },
  {
    "codigo":248022007,
    "descripcion":"CONDUCTA IRREVERENTE"
  },
  {
    "codigo":211584004,
    "descripcion":"LESIÓN TRAUMÁTICA CERRADA POR APLASTAMIENTO, MÚLTIPLES DEDOS DE MANO"
  },
  {
    "codigo":10649111000119106,
    "descripcion":"ÚLCERA DE PANTORRILLA IZQUIERDA"
  },
  {
    "codigo":735872004,
    "descripcion":"MÚLTIPLES HERIDAS ABIERTAS DE PIE"
  },
  {
    "codigo":277120008,
    "descripcion":"ASIMETRÍA INTERHEMISFÉRICA CRUZADA DE LA AMPLITUD"
  },
  {
    "codigo":13141002,
    "descripcion":"CALCINOSIS CIRCUNSCRIPTA"
  },
  {
    "codigo":78677008,
    "descripcion":"ANEMIA POR DEFICIENCIA DE ÁCIDO PANTOTÉNICO"
  },
  {
    "codigo":209749009,
    "descripcion":"SECCIÓN EXPUESTA, LIGAMENTO CONDROESTERNAL"
  },
  {
    "codigo":109610001,
    "descripcion":"ABSCESO GINGIVAL"
  },
  {
    "codigo":76842000,
    "descripcion":"AFALANGIA COMPLETA DE LA EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":11306002,
    "descripcion":"INTOXICACIÓN POR DEXTROTIROXINA"
  },
  {
    "codigo":240682005,
    "descripcion":"PERIOSTITIS POR FRAMBESIA"
  },
  {
    "codigo":16711191000119109,
    "descripcion":"EDEMA DE MÁCULA RETINIANA DEBIDO A OCLUSIÓN DE AMBAS VENAS CENTRALES DE LA RETINA"
  },
  {
    "codigo":404522007,
    "descripcion":"HALLAZGO DE HONGO HIALINO NO ESPORULADO"
  },
  {
    "codigo":15701681000119102,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE AMBOS TENDONES DE CABEZA LARGA DE MÚSCULO BÍCEPS BRAQUIAL"
  },
  {
    "codigo":763135001,
    "descripcion":"ENFERMEDAD DE CHARCOT-MARIE-TOOTH TIPO 4E"
  },
  {
    "codigo":271615003,
    "descripcion":"TUMEFACCIÓN DE GLÁNDULA SALIVAL SUBLINGUAL"
  },
  {
    "codigo":42239005,
    "descripcion":"DIETA CON CARBOHIDRATOS"
  },
  {
    "codigo":402687009,
    "descripcion":"PANICULITIS POR ACCIÓN DE ENZIMAS LIPOLÍTICAS"
  },
  {
    "codigo":75007009,
    "descripcion":"ALGOFOBIA"
  },
  {
    "codigo":1285588006,
    "descripcion":"EPITELIOPATÍA PIGMENTARIA PAQUICOROIDEA"
  },
  {
    "codigo":366249002,
    "descripcion":"HALLAZGO RELACIONADO CON LA APARIENCIA DEL ORIFICIO ANAL"
  },
  {
    "codigo":202409003,
    "descripcion":"HEMARTROSIS DE ARTICULACIÓN INTERFALÁNGICA PROXIMAL DE DEDO DE LA MANO"
  },
  {
    "codigo":300713003,
    "descripcion":"CAPAZ DE HACER UN PRESUPUESTO"
  },
  {
    "codigo":169641007,
    "descripcion":"INTENCIÓN SOBRE LA ALIMENTACIÓN DEL RECIÉN NACIDO - DESCONOCIDA"
  },
  {
    "codigo":36734001,
    "descripcion":"POSTURA CATATÓNICA"
  },
  {
    "codigo":724862004,
    "descripcion":"TRASTORNO DE LA PIEL POSTERIOR A PROCEDIMIENTO"
  },
  {
    "codigo":397182009,
    "descripcion":"LESIÓN TRAUMÁTICA ABIERTA POR APLASTAMIENTO"
  },
  {
    "codigo":231507004,
    "descripcion":"ESTADIO DE MIEDO"
  },
  {
    "codigo":297043005,
    "descripcion":"SOBREDOSIS DE ACETAZOLAMIDA"
  },
  {
    "codigo":67667007,
    "descripcion":"ENDOMETRITIS AGUDA"
  },
  {
    "codigo":196904003,
    "descripcion":"HERNIA DIAFRAGMÁTICA IRREDUCTIBLE"
  },
  {
    "codigo":33064008,
    "descripcion":"TRASTORNO DE LA ESCLERÓTICA"
  },
  {
    "codigo":229672009,
    "descripcion":"TRASTORNO DEL LENGUAJE POR CUADRO DEMENCIAL"
  },
  {
    "codigo":195069001,
    "descripcion":"TAQUICARDIA AURICULAR PAROXÍSTICA"
  },
  {
    "codigo":162301005,
    "descripcion":"CEFALEA BILATERAL"
  },
  {
    "codigo":424445006,
    "descripcion":"DIFICULTAD PARA VESTIR LA PARTE SUPERIOR DEL CUERPO"
  },
  {
    "codigo":293373006,
    "descripcion":"REACCIÓN ADVERSA A LA NUTRICIÓN PARENTERAL (GRASAS)"
  },
  {
    "codigo":291538000,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR AMPICILINA"
  },
  {
    "codigo":94930003,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL DIVERTÍCULO DE MECKEL"
  },
  {
    "codigo":29394006,
    "descripcion":"INTOXICACIÓN POR NERIUM OLEANDER"
  },
  {
    "codigo":783058007,
    "descripcion":"NEUTROPENIA CONGÉNITA AUTOSÓMICA RECESIVA SEVERA DEBIDA A DEFICIENCIA DE G6PC3"
  },
  {
    "codigo":93095003,
    "descripcion":"HIPEREXTENSIÓN CONGÉNITA DE MIEMBRO"
  },
  {
    "codigo":289703003,
    "descripcion":"HALLAZGO RELACIONADO CON EL PATRÓN DE CONTRACCIONES UTERINAS"
  },
  {
    "codigo":420775008,
    "descripcion":"ENVENENAMIENTO DEBIDO A PICADURA DE CENTRUROIDES EXILICAUDA"
  },
  {
    "codigo":1172604004,
    "descripcion":"SÍNDROME DE HIPOACUSIA NEUROSENSORIAL - TROMBOCITOPENIA ASOCIADO AL GEN DIAPH1"
  },
  {
    "codigo":329701000119107,
    "descripcion":"COMPRESIÓN DE NERVIO PERIFÉRICO DE EXTREMIDAD INFERIOR DERECHA"
  },
  {
    "codigo":449873008,
    "descripcion":"RUPTURA DE PLACA ATEROSCLERÓTICA CON TROMBOSIS DE ARTERIA"
  },
  {
    "codigo":1269073009,
    "descripcion":"TRASTORNO FETAL DEBIDO A TRASTORNO DE CAVIDAD Y\/O MEMBRANA AMNIÓTICA"
  },
  {
    "codigo":448038004,
    "descripcion":"OSTEOCONDRITIS DISECANTE DE FÉMUR DISTAL"
  },
  {
    "codigo":284198007,
    "descripcion":"QUEMADURA SUPERFICIAL DE LA FRENTE POR AGENTE CORROSIVO"
  },
  {
    "codigo":54822007,
    "descripcion":"ÚLCERA YEYUNAL"
  },
  {
    "codigo":52987001,
    "descripcion":"TUBERCULOSIS DEL ENDOCARDIO"
  },
  {
    "codigo":249595002,
    "descripcion":"PROTRUSIÓN DE INTESTINO EN CONDUCTO INGUINAL"
  },
  {
    "codigo":216827003,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR PROPANO"
  },
  {
    "codigo":51152000,
    "descripcion":"ABSCESO DE LAS CUERDAS VOCALES"
  },
  {
    "codigo":83920001,
    "descripcion":"DEFICIENCIA DE SELENIO"
  },
  {
    "codigo":313296004,
    "descripcion":"ENFERMEDAD PULMONAR OBSTRUCTIVA CRÓNICA, LEVE"
  },
  {
    "codigo":213157000,
    "descripcion":"COMPLICACIÓN DE ANTEBRAZO REIMPLANTADO"
  },
  {
    "codigo":870352009,
    "descripcion":"ULCERACIÓN NEUROPÁTICA DE PIEL CAUSADA POR MYCOBACTERIUM LEPRAE"
  },
  {
    "codigo":278693002,
    "descripcion":"CONTENIDO GÁSTRICO ASPIRADO EN LA VÍA RESPIRATORIA INFERIOR"
  },
  {
    "codigo":704677002,
    "descripcion":"TARSALGIA"
  },
  {
    "codigo":10625151000119107,
    "descripcion":"BRONCONEUMONÍA CAUSADA POR STREPTOCOCCUS DEL GRUPO A"
  },
  {
    "codigo":442533006,
    "descripcion":"MANTIENE CONTACTO CON LA FAMILIA"
  },
  {
    "codigo":409765008,
    "descripcion":"LUXACIÓN NO EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA DEL PULGAR"
  },
  {
    "codigo":735610001,
    "descripcion":"PROLAPSO DE DISCO INTERVERTEBRAL LUMBAR CONCOMITANTE CON DEGENERACIÓN Y DEBIDO A ELLA"
  },
  {
    "codigo":16906521000119103,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE PÁRPADO INFERIOR DERECHO"
  },
  {
    "codigo":111183001,
    "descripcion":"ABSCESO DE DEDO DE PIE"
  },
  {
    "codigo":1290831002,
    "descripcion":"ATAXIA CAUSADA POR ETANOL"
  },
  {
    "codigo":209487002,
    "descripcion":"ESGUINCE DE DEDO DE LA MANO, ARTICULACIÓN INTERFALÁNGICA DISTAL, LIGAMENTO LATERAL CUBITAL"
  },
  {
    "codigo":12879002,
    "descripcion":"ENFERMEDAD POR EL VIRUS PUNTA TORO"
  },
  {
    "codigo":109348004,
    "descripcion":"NEOPLASIA MALIGNA SUPERPUESTA DE HUESO Y CARTÍLAGO ARTICULAR DE EXTREMIDAD"
  },
  {
    "codigo":240420007,
    "descripcion":"REACCIÓN CUTÁNEA HIPERINMUNITARIA CAUSADA POR MICOBACTERIAS AVIUM-INTRACELULARE"
  },
  {
    "codigo":9209005,
    "descripcion":"ABDOMEN AGUDO"
  },
  {
    "codigo":402425006,
    "descripcion":"DERMATOMIOSITIS DE INICIO EN EL ADULTO"
  },
  {
    "codigo":205817005,
    "descripcion":"SÍNDROME DE AGLOSIA-ADACTILIA"
  },
  {
    "codigo":369657005,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA DE VÍAS AERODIGESTIVAS SUPERIORES, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":41977005,
    "descripcion":"FRACTURA NO EXPUESTA DE TERCER HUESO CUNEIFORME DE TARSO"
  },
  {
    "codigo":203982007,
    "descripcion":"MENINGOCELE ESPINAL LUMBAR"
  },
  {
    "codigo":236750007,
    "descripcion":"TRASTORNO FUNCIONAL DEL PENE"
  },
  {
    "codigo":300451002,
    "descripcion":"URÉTER AUSENTE"
  },
  {
    "codigo":298616001,
    "descripcion":"SIN AMPLITUD DE MOVIMIENTO DE EXTENSIÓN DE LA COLUMNA VERTEBRAL LUMBAR"
  },
  {
    "codigo":36472007,
    "descripcion":"ENFERMEDAD POR HEMOGLOBINA S - F"
  },
  {
    "codigo":3704008,
    "descripcion":"GLOMERULONEFRITIS PROLIFERATIVA DIFUSA ENDOCAPILAR"
  },
  {
    "codigo":724600007,
    "descripcion":"VASCULITIS DE PEQUEÑOS VASOS CAUSADA POR COMPLEJOS INMUNITARIOS"
  },
  {
    "codigo":1869002,
    "descripcion":"RUPTURA DEL ESFÍNTER DE LA PUPILA"
  },
  {
    "codigo":296781000,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE COMPUESTO DE ANTIMONIO"
  },
  {
    "codigo":1148749005,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR SULFAMETOXAZOL Y\/O TRIMETOPRIMA"
  },
  {
    "codigo":67405006,
    "descripcion":"DETERMINACIÓN DEL ESTADO DEL PACIENTE, LIGERA MEJORÍA"
  },
  {
    "codigo":1179682002,
    "descripcion":"PROSTATITIS CATEGORÍA I"
  },
  {
    "codigo":131106002,
    "descripcion":"NIVEL DE GLUCAGÓN POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":30967002,
    "descripcion":"PARÁLISIS PERIÓDICA TIROTÓXICA"
  },
  {
    "codigo":1145079005,
    "descripcion":"TRES O MÁS REMOLINOS DE CABELLO"
  },
  {
    "codigo":162039006,
    "descripcion":"DOLOR REFERIDO EN HOMBRO DESDE EL ABDOMEN"
  },
  {
    "codigo":61900003,
    "descripcion":"DEFICIENCIA LONGITUDINAL DE RADIO"
  },
  {
    "codigo":94668004,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA VAGINA"
  },
  {
    "codigo":717260007,
    "descripcion":"HIPERPLASIA SUPRARRENAL CONGÉNITA LIPOIDE DEBIDA A DEFICIENCIA DE PROTEÍNA REGULADORA AGUDA ESTEROIDEOGÉNICA"
  },
  {
    "codigo":422348008,
    "descripcion":"SÍNDROME DE ANDERSEN TAWIL"
  },
  {
    "codigo":92833001,
    "descripcion":"FUSIÓN ANORMAL CONGÉNITA DE LAS GLÁNDULAS SUPRARRENALES"
  },
  {
    "codigo":291276007,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR PRACTOLOL"
  },
  {
    "codigo":715425000,
    "descripcion":"CONVULSIÓN FOCAL BENIGNA DE LA ADOLESCENCIA"
  },
  {
    "codigo":289441006,
    "descripcion":"FRECUENCIA CARDÍACA FETAL, NORMAL"
  },
  {
    "codigo":387745008,
    "descripcion":"ANEMIA SECUNDARIA A LA PRÁCTICA DEPORTIVA"
  },
  {
    "codigo":125601008,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA RODILLA"
  },
  {
    "codigo":254838004,
    "descripcion":"CARCINOMA DE MAMA"
  },
  {
    "codigo":25462005,
    "descripcion":"PALINOPSIA"
  },
  {
    "codigo":58230007,
    "descripcion":"ALTERACIÓN DE LA EVACUACIÓN INTESTINAL: ESTREÑIMIENTO"
  },
  {
    "codigo":123766008,
    "descripcion":"TRASTORNO ENDOCRINO COMPLEJO DE LA GLÁNDULA TIROIDES"
  },
  {
    "codigo":1336182008,
    "descripcion":"MIXOFIBROSARCOMA METASTÁSICO"
  },
  {
    "codigo":23627006,
    "descripcion":"PERICARDITIS CRÓNICA"
  },
  {
    "codigo":447776000,
    "descripcion":"TRAYECTO EN ESPIRAL DE AORTA Y ARTERIA PULMONAR"
  },
  {
    "codigo":16007911000119106,
    "descripcion":"TROMBOSIS DE ARTERIA CUBITAL IZQUIERDA"
  },
  {
    "codigo":54560009,
    "descripcion":"WINDIGO"
  },
  {
    "codigo":251168009,
    "descripcion":"BIGEMINISMO SUPRAVENTRICULAR"
  },
  {
    "codigo":773621003,
    "descripcion":"SÍNDROME DE DISCAPACIDAD INTELECTUAL, HIPOTONÍA, BRAQUICEFALIA, ESTENOSIS PILÓRICA Y CRIPTORQUIDIA"
  },
  {
    "codigo":249333006,
    "descripcion":"PUNTA DE LA NARIZ CUADRADA"
  },
  {
    "codigo":334721000119102,
    "descripcion":"OFTALMOPLEJÍA INTERNA TOTAL DERECHA"
  },
  {
    "codigo":1197770002,
    "descripcion":"HEMORRAGIA PLACENTARIA"
  },
  {
    "codigo":18122002,
    "descripcion":"ONDA NORMAL DE CONTRACCIONES UTERINAS"
  },
  {
    "codigo":50890004,
    "descripcion":"FRACTURA DE DIÁFISIS DE HÚMERO"
  },
  {
    "codigo":247498005,
    "descripcion":"RANURAS DE LA UÑA"
  },
  {
    "codigo":278431005,
    "descripcion":"HALLAZGO DE MASTICACIÓN"
  },
  {
    "codigo":704415006,
    "descripcion":"CON MAYOR RIESGO DE ALTERACIÓN DE DESEMPEÑO ESCOLAR"
  },
  {
    "codigo":737183007,
    "descripcion":"ENFERMEDAD PULMONAR INTERSTICIAL DEBIDA A ENFERMEDAD METABÓLICA"
  },
  {
    "codigo":81823008,
    "descripcion":"CELULITIS DE LA TÚNICA VAGINAL"
  },
  {
    "codigo":211060000,
    "descripcion":"ABRASIÓN INFECTADA DE ANO"
  },
  {
    "codigo":1259636005,
    "descripcion":"ENFERMEDAD INFLAMATORIA DESMIELINIZANTE CRÓNICA DE SISTEMA NERVIOSO PERIFÉRICO Y SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":15735681000119106,
    "descripcion":"QUERATOPATÍA EN VÓRTICE DE OJO IZQUIERDO"
  },
  {
    "codigo":702580007,
    "descripcion":"UNIÓN TARDÍA DE ARTICULACIÓN DE TOBILLO"
  },
  {
    "codigo":276596008,
    "descripcion":"IRRITACIÓN CEREBRAL"
  },
  {
    "codigo":243828009,
    "descripcion":"SITUACIÓN DE LA PRUEBA DE ALFA-FETOPROTEÍNA SÉRICA"
  },
  {
    "codigo":407668008,
    "descripcion":"DETERMINACIÓN SERIADA DE VELOCIDAD DE FLUJO ESPIRATORIO PICO, ANORMAL"
  },
  {
    "codigo":78153003,
    "descripcion":"HABITANTE URBANO"
  },
  {
    "codigo":241993004,
    "descripcion":"LESIÓN POR DESCOMPRESIÓN CEREBRAL"
  },
  {
    "codigo":209225005,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA EXPUESTA DE LA ARTICULACIÓN ESTERNOCLAVICULAR, POSTERIOR"
  },
  {
    "codigo":11312001000119108,
    "descripcion":"FRACTURA EXPUESTA DE CUARTA VÉRTEBRA LUMBAR"
  },
  {
    "codigo":274761008,
    "descripcion":"MOVIMIENTO ARTICULAR - NO SE DETECTARON ANOMALÍAS"
  },
  {
    "codigo":733513009,
    "descripcion":"CUELLO ROTADO HACIA LA IZQUIERDA"
  },
  {
    "codigo":305694001,
    "descripcion":"ATENDIDO POR UN PSIQUIATRA INFANTOJUVENIL"
  },
  {
    "codigo":403998003,
    "descripcion":"HISTIOCITOMA PIGMENTADO DE PIEL"
  },
  {
    "codigo":698910004,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: MALTÉS"
  },
  {
    "codigo":240158004,
    "descripcion":"OSTEOPOROSIS REGIONAL MIGRATORIA"
  },
  {
    "codigo":76318008,
    "descripcion":"TRASTORNO DE TENDÓN DE REGIÓN DE HOMBRO"
  },
  {
    "codigo":860915001,
    "descripcion":"DISFUNCIÓN ERÉCTIL CAUSADA POR FÁRMACO"
  },
  {
    "codigo":762611002,
    "descripcion":"INFECCIÓN DE SITIO QUIRÚRGICO DE ÓRGANO POSTERIOR A PROCEDIMIENTO QUIRÚRGICO"
  },
  {
    "codigo":402163008,
    "descripcion":"DERMATOSIS POR PELO COMO CUERPO EXTRAÑO"
  },
  {
    "codigo":271091009,
    "descripcion":"DEFORMIDAD DE FALANGE DE DEDO DE LA MANO O DEL PULGAR"
  },
  {
    "codigo":433096001,
    "descripcion":"DEFORMIDAD DE HUESO DE LA CARA"
  },
  {
    "codigo":105416005,
    "descripcion":"RUPTURA DE UNA RELACIÓN AMOROSA"
  },
  {
    "codigo":236488005,
    "descripcion":"OCLUSIÓN DE ARTERIA RENAL"
  },
  {
    "codigo":431261000,
    "descripcion":"ABSCESO BACTERIANO DE VÁLVULA PULMONAR"
  },
  {
    "codigo":1119389001,
    "descripcion":"REDUCCIÓN DE LA ACTIVIDAD ALFA EN EL HEMISFERIO CEREBRAL DERECHO"
  },
  {
    "codigo":5277004,
    "descripcion":"CILINDRURIA"
  },
  {
    "codigo":365725005,
    "descripcion":"NIVELES SÉRICOS DE AMINOÁCIDOS - HALLAZGO"
  },
  {
    "codigo":68978004,
    "descripcion":"HIPERVENTILACIÓN"
  },
  {
    "codigo":298354005,
    "descripcion":"HUESO ENSANCHADO"
  },
  {
    "codigo":788039000,
    "descripcion":"ESPECIE DE CLONORCHIS O ESPECIE DE OPISTHORCHIS"
  },
  {
    "codigo":1148487003,
    "descripcion":"CAPAZ DE REALIZAR MANTENIMIENTO DEL HOGAR"
  },
  {
    "codigo":691381000119104,
    "descripcion":"ANEMIA POR ENFERMEDAD RENAL CRÓNICA ESTADIO 1"
  },
  {
    "codigo":1345095007,
    "descripcion":"SÍNDROME DE ABSTINENCIA DE CORTICOSTEROIDE POSTERIOR A PATRÓN DE USO NOCIVO"
  },
  {
    "codigo":425756000,
    "descripcion":"MIELITIS TRANSVERSA IDIOPÁTICA"
  },
  {
    "codigo":294684001,
    "descripcion":"ALERGIA A FLUNISOLIDA"
  },
  {
    "codigo":165447008,
    "descripcion":"CONCENTRACIÓN DE HEMOGLOBINA CORPUSCULAR MEDIA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":292849002,
    "descripcion":"REACCIÓN ADVERSA A FÁRMACO ANTIPALÚDICO A BASE DE AMINOQUINOLINA"
  },
  {
    "codigo":1144817005,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR PROTAMINA"
  },
  {
    "codigo":1074511000119102,
    "descripcion":"ARTROSIS DE PRIMERA ARTICULACIÓN METATARSOFALÁNGICA DE PIE IZQUIERDO"
  },
  {
    "codigo":127174001,
    "descripcion":"LINFADENOPATÍA GLÚTEA"
  },
  {
    "codigo":225478005,
    "descripcion":"CONDUCTA ABUSIVA EN EL ASPECTO VERBAL"
  },
  {
    "codigo":716998009,
    "descripcion":"SÍNDROME DE JOUBERT CON DEFECTO OCULAR"
  },
  {
    "codigo":192710009,
    "descripcion":"ENCEFALITIS POSVACUNACIÓN ANTITETÁNICA"
  },
  {
    "codigo":92571001,
    "descripcion":"CARCINOMA IN SITU DE LA CONJUNTIVA"
  },
  {
    "codigo":94406009,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE SENO MAXILAR"
  },
  {
    "codigo":337231000119104,
    "descripcion":"RETRACCIÓN ANORMAL DE PÁRPADO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":251144001,
    "descripcion":"CAMBIOS ELECTROCARDIOGRÁFICOS POSTOPERATORIOS"
  },
  {
    "codigo":15983951000119105,
    "descripcion":"MÚSCULO OCULAR SUPERNUMERARIO DE OJO DERECHO"
  },
  {
    "codigo":189040001,
    "descripcion":"NEOPLASIA BENIGNA DE PARTES BLANDAS DE LA COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":11861481000119100,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO CRURAL POSTERIOR DE PIERNA DERECHA"
  },
  {
    "codigo":11779561000119100,
    "descripcion":"HERIDA INFECTADA DE ANTEBRAZO DERECHO DEBIDA A PICADURA DE INSECTO NO VENENOSO"
  },
  {
    "codigo":250906000,
    "descripcion":"HALLAZGO INVESTIGATIVO CARDÍACO"
  },
  {
    "codigo":416581009,
    "descripcion":"PRECIPITADOS CORNEALES SEMEJANTES A GOTAS"
  },
  {
    "codigo":285509009,
    "descripcion":"NO SACA LA LENGUA TOTALMENTE"
  },
  {
    "codigo":21530000,
    "descripcion":"CEFALOTORACÓPAGO"
  },
  {
    "codigo":87066005,
    "descripcion":"FIBRINÓLISIS DISMINUIDA"
  },
  {
    "codigo":283674007,
    "descripcion":"HERIDA POR PINCHAZO DE CLAVO EN LA PANTORRILLA"
  },
  {
    "codigo":185370009,
    "descripcion":"DERIVADO POR FISIOTERAPEUTA"
  },
  {
    "codigo":1363183004,
    "descripcion":"CONDUCTA DE DOLOR"
  },
  {
    "codigo":609519004,
    "descripcion":"NEOPLASIA TROFOBLÁSTICA GESTACIONAL"
  },
  {
    "codigo":871663006,
    "descripcion":"TRASTORNO DE AORTA DEBIDO A CORRECCIÓN DE ANOMALÍA CONGÉNITA DEL CORAZÓN Y POSTERIOR A ELLA"
  },
  {
    "codigo":249071008,
    "descripcion":"POSICIÓN OCCIPITOILÍACA TRANSVERSA"
  },
  {
    "codigo":183535009,
    "descripcion":"DERIVADO AL ENDOCRINÓLOGO"
  },
  {
    "codigo":247236008,
    "descripcion":"PABELLÓN AURICULAR - HALLAZGO"
  },
  {
    "codigo":442009005,
    "descripcion":"CUTIS LAXO DE PÁRPADO INFERIOR"
  },
  {
    "codigo":767854000,
    "descripcion":"QUISTE ÓSEO DE TIBIA"
  },
  {
    "codigo":212633008,
    "descripcion":"INTOXICACIÓN POR CARBROMAL"
  },
  {
    "codigo":1259374007,
    "descripcion":"CARCINOMA ESCAMOSO CUTÁNEO ACANTOLÍTICO PRIMARIO"
  },
  {
    "codigo":702318008,
    "descripcion":"PARÁLISIS CEREBRAL MIXTA"
  },
  {
    "codigo":276334009,
    "descripcion":"POSICIÓN ARTICULAR"
  },
  {
    "codigo":208963001,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA NO EXPUESTA DE LA ARTICULACIÓN DE LA RODILLA, INTERNA"
  },
  {
    "codigo":733251005,
    "descripcion":"LUXACIÓN TRAUMÁTICA DE ARTICULACIÓN RADIOCARPIANA"
  },
  {
    "codigo":405571006,
    "descripcion":"QUEMADURA POR ELECTRICIDAD"
  },
  {
    "codigo":12355008,
    "descripcion":"ÚLCERA DUODENAL CON HEMORRAGIA, PERFORACIÓN Y OBSTRUCCIÓN"
  },
  {
    "codigo":895256002,
    "descripcion":"FORMA TRIANGULAR ANORMAL CONGÉNITA DE FALANGE DE DEDO ANULAR"
  },
  {
    "codigo":370968004,
    "descripcion":"PRUEBA DE PROVOCACIÓN REPETIDA, TOLERADA"
  },
  {
    "codigo":238061001,
    "descripcion":"ADRENOLEUCODISTROFIA DEL RECIÉN NACIDO"
  },
  {
    "codigo":762349007,
    "descripcion":"TEMOR A TRASTORNO MENTAL"
  },
  {
    "codigo":400066006,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS INTRAEPITELIAL"
  },
  {
    "codigo":365463003,
    "descripcion":"CALIFICACIONES OBTENIDAS - HALLAZGO"
  },
  {
    "codigo":299927006,
    "descripcion":"DISCRIMINACIÓN DE PINCHAZOS AUSENTE"
  },
  {
    "codigo":70551007,
    "descripcion":"INEFICACIA"
  },
  {
    "codigo":725911008,
    "descripcion":"SÍNDROME DE SECUENCIA DE PIERRE ROBIN, CARDIOPATÍA CONGÉNITA Y PIES ZAMBOS"
  },
  {
    "codigo":68716001,
    "descripcion":"SITUS INVERSUS ABDOMINAL"
  },
  {
    "codigo":396396002,
    "descripcion":"INFILTRACIÓN TUMORAL POR AUSENCIA DE LINFOCITOS"
  },
  {
    "codigo":234391009,
    "descripcion":"ANEMIA DREPANOCÍTICA CON HEMOGLOBINA F ELEVADA"
  },
  {
    "codigo":298092001,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE LA EXTREMIDAD INFERIOR"
  },
  {
    "codigo":339741000119107,
    "descripcion":"ECTROPIÓN MECÁNICO DE PÁRPADO INFERIOR IZQUIERDO"
  },
  {
    "codigo":787777003,
    "descripcion":"FUGA DE CATÉTER DE TENCKHOFF"
  },
  {
    "codigo":66881004,
    "descripcion":"COREOACANTOCITOSIS"
  },
  {
    "codigo":165185004,
    "descripcion":"DERMATOGLIFIA"
  },
  {
    "codigo":1345007,
    "descripcion":"PADRASTRO"
  },
  {
    "codigo":230721009,
    "descripcion":"TROMBOSIS VENOSA CEREBRAL DE SENO SIGMOIDE"
  },
  {
    "codigo":720406004,
    "descripcion":"BACTERIURIA ASINTOMÁTICA"
  },
  {
    "codigo":32278006,
    "descripcion":"RIÑÓN DEL MIELOMA"
  },
  {
    "codigo":292587001,
    "descripcion":"REACCIÓN ADVERSA A CLORFENAMINA"
  },
  {
    "codigo":22761000175104,
    "descripcion":"CON MAYOR RIESGO DE AISLAMIENTO SOCIAL"
  },
  {
    "codigo":1144555008,
    "descripcion":"APLASIA DE PÁNCREAS"
  },
  {
    "codigo":126912001,
    "descripcion":"NEOPLASIA DEL ENDOCÉRVIX"
  },
  {
    "codigo":11837521000119100,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE PIERNA IZQUIERDA"
  },
  {
    "codigo":290752007,
    "descripcion":"INTOXICACIÓN POR TAMOXIFENO"
  },
  {
    "codigo":94144008,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL ANILLO DE WALDEYER"
  },
  {
    "codigo":419989001,
    "descripcion":"REACCIÓN ADVERSA A DERIVADO DEL ÁCIDO PROPIÓNICO"
  },
  {
    "codigo":92309002,
    "descripcion":"NEOPLASIA BENIGNA DEL PUBIS"
  },
  {
    "codigo":288917005,
    "descripcion":"DIFICULTAD PARA RETIRAR ALIMENTO DEL SURCO YUGAL"
  },
  {
    "codigo":188778000,
    "descripcion":"NEOPLASIA BENIGNA DE MUCOSA DE LABIO SUPERIOR"
  },
  {
    "codigo":713066006,
    "descripcion":"SOPLO TELEDIASTÓLICO"
  },
  {
    "codigo":285247003,
    "descripcion":"CATASTROFIZACIÓN"
  },
  {
    "codigo":368721000119104,
    "descripcion":"RETINOPATÍA NO PROLIFERATIVA DEBIDA A DIABETES MELLITUS SECUNDARIA"
  },
  {
    "codigo":54036001,
    "descripcion":"SÍNDROME OTOPALATODIGITAL, TIPO I"
  },
  {
    "codigo":86804002,
    "descripcion":"NÓDULOS DE SCHMORL DE LA REGIÓN TORÁCICA"
  },
  {
    "codigo":55871009,
    "descripcion":"DEFECTO DEL CAMPO VISUAL A NIVEL DEL ESCALÓN NASAL"
  },
  {
    "codigo":449087009,
    "descripcion":"ANOMALÍA DE EBSTEIN DE VÁLVULA AURICULOVENTRICULAR DERECHA EN CORAZÓN FUNCIONALMENTE UNIVENTRICULAR"
  },
  {
    "codigo":283412007,
    "descripcion":"CORTE EN EL BRAZO"
  },
  {
    "codigo":52201006,
    "descripcion":"HEMORRAGIA INTRACAPSULAR"
  },
  {
    "codigo":16097361000119108,
    "descripcion":"ARTROFIBROSIS DE ARTICULACIÓN DE AMBAS MANOS"
  },
  {
    "codigo":1231849008,
    "descripcion":"DERMATOSIS CAUSADA POR CUMARINA"
  },
  {
    "codigo":83134002,
    "descripcion":"DIARREA DIETÉTICA"
  },
  {
    "codigo":50366005,
    "descripcion":"NEUROPRAXIA MANDIBULAR"
  },
  {
    "codigo":1230014007,
    "descripcion":"SÍNDROME DE RETRACCIÓN DE DUANE CON SORDERA CONGÉNITA"
  },
  {
    "codigo":771262009,
    "descripcion":"SÍNDROME DE PSEUDO-LEPRECHAUNISMO TIPO PATTERSON"
  },
  {
    "codigo":48531003,
    "descripcion":"ACALASIA"
  },
  {
    "codigo":42021000087100,
    "descripcion":"QUEMADURA DE EXTREMIDAD INFERIOR DERECHA"
  },
  {
    "codigo":277907006,
    "descripcion":"ESPUTO AMARILLO"
  },
  {
    "codigo":210536003,
    "descripcion":"HERIDA ABIERTA DE DORSO DE MUÑECA"
  },
  {
    "codigo":47141000087107,
    "descripcion":"ESGUINCE DE LIGAMENTO DE EXTREMIDAD SUPERIOR IZQUIERDA"
  },
  {
    "codigo":1259112007,
    "descripcion":"OTORREA DE LÍQUIDO CEFALORRAQUÍDEO DEBIDA A GRANULACIÓN ARACNOIDEA GIGANTE"
  },
  {
    "codigo":46696008,
    "descripcion":"MIOCARDIOPATÍA DILATADA DEBIDA A DERMATOMIOSITIS"
  },
  {
    "codigo":439912007,
    "descripcion":"INFECCIÓN GENITAL RECURRENTE POR HERPES SIMPLEX TIPO 1"
  },
  {
    "codigo":276072008,
    "descripcion":"PROBLEMAS SEXUALES EN EL TRABAJO"
  },
  {
    "codigo":765757003,
    "descripcion":"POLIMICROGIRIA BILATERAL"
  },
  {
    "codigo":208701008,
    "descripcion":"FRACTURA EXPUESTA DE CUELLO METATARSIANO"
  },
  {
    "codigo":403474003,
    "descripcion":"TRAUMATISMO AUTOINFLIGIDO CON COMPROMISO DEL PENE"
  },
  {
    "codigo":237799000,
    "descripcion":"TRASTORNO MENSTRUAL DE CAUSA ENDOCRINA"
  },
  {
    "codigo":1351911000,
    "descripcion":"PÉNFIGO FOLIÁCEO ENDÉMICO"
  },
  {
    "codigo":41191003,
    "descripcion":"FRACTURA EXPUESTA DE CABEZA DE FÉMUR"
  },
  {
    "codigo":203196002,
    "descripcion":"OSTEOMIELITIS CRÓNICA DE SACRO"
  },
  {
    "codigo":301500002,
    "descripcion":"NO SE MOVILIZA EN EL INTERIOR DE UN LUGAR"
  },
  {
    "codigo":72124005,
    "descripcion":"FUNCIÓN PUPILAR ANORMAL"
  },
  {
    "codigo":365201001,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA CORTARSE LAS UÑAS"
  },
  {
    "codigo":299665002,
    "descripcion":"ESTRÍA UNGUEAL LONGITUDINAL"
  },
  {
    "codigo":1110151000000107,
    "descripcion":"HIPERTENSIÓN OCULAR SECUNDARIA"
  },
  {
    "codigo":2918000,
    "descripcion":"INFECCIÓN CAUSADA POR BACTEROIDES"
  },
  {
    "codigo":1348241009,
    "descripcion":"PATRÓN DE USO EPISÓDICO PERJUDICIAL SIN DEPENDENCIA DE SUSTANCIA"
  },
  {
    "codigo":232294002,
    "descripcion":"TRAUMA VESTIBULAR"
  },
  {
    "codigo":68454002,
    "descripcion":"SÍNDROME DE TRISOMÍA 8 COMPLETA"
  },
  {
    "codigo":234129008,
    "descripcion":"VENAS VARICOSAS VERDADERAS CONGÉNITAS"
  },
  {
    "codigo":295995000,
    "descripcion":"SOBREDOSIS DE CARBAMAZEPINA"
  },
  {
    "codigo":363366009,
    "descripcion":"NEOPLASIA MALIGNA DE PARTES BLANDAS DE PELVIS"
  },
  {
    "codigo":263227004,
    "descripcion":"FRACTURA MEDIOCERVICAL DE CUELLO DE FÉMUR"
  },
  {
    "codigo":721979005,
    "descripcion":"SÍNDROME DE LINFEDEMA Y ANOMALÍA ARTERIOVENOSA CEREBRAL"
  },
  {
    "codigo":197691006,
    "descripcion":"SÍNDROME NEFRÍTICO RÁPIDAMENTE PROGRESIVO, LESIONES GLOMERULARES FOCALES Y SEGMENTARIAS"
  },
  {
    "codigo":294160005,
    "descripcion":"ALERGIA A TEOFILINA"
  },
  {
    "codigo":15663801000119100,
    "descripcion":"HEMARTROSIS DE ARTICULACIÓN DE AMBOS PIES"
  },
  {
    "codigo":1177061003,
    "descripcion":"ESPONDILITIS POR SHIGELOSIS"
  },
  {
    "codigo":95717004,
    "descripcion":"GLAUCOMA SECUNDARIO"
  },
  {
    "codigo":292325005,
    "descripcion":"REACCIÓN ADVERSA A LA CARBAMAZEPINA"
  },
  {
    "codigo":128485009,
    "descripcion":"NEUROPATÍA RETROBULBAR"
  },
  {
    "codigo":224954004,
    "descripcion":"EXTROVERTIDO"
  },
  {
    "codigo":1339066008,
    "descripcion":"FRACTURA DE FALANGE DE TERCER DEDO DE PIE"
  },
  {
    "codigo":126650009,
    "descripcion":"NEOPLASIA DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":716474009,
    "descripcion":"DIFICULTAD PARA COMPRENDER UN IDIOMA"
  },
  {
    "codigo":92047003,
    "descripcion":"NEOPLASIA BENIGNA DE LA COLA DE CABALLO"
  },
  {
    "codigo":93882009,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE BRONQUIO PRINCIPAL"
  },
  {
    "codigo":1306298008,
    "descripcion":"GLAUCOMA DE ÁNGULO CERRADO DE OJO DERECHO"
  },
  {
    "codigo":288655002,
    "descripcion":"NO SE SUMA A UNA CONVERSACIÓN"
  },
  {
    "codigo":254052001,
    "descripcion":"SÍNDROME DE POLIDACTILIA Y COSTILLA CORTA TIPO IV"
  },
  {
    "codigo":344761000119106,
    "descripcion":"PANOFTALMITIS DE AMBOS OJOS"
  },
  {
    "codigo":286820005,
    "descripcion":"TIENDE A SER EXCESIVAMENTE AUTOSUFICIENTE"
  },
  {
    "codigo":417892007,
    "descripcion":"SENSIBILIDAD VIBRATORIA DEL PIE IZQUIERDO ALTERADA"
  },
  {
    "codigo":188516007,
    "descripcion":"LINFOMA DE BURKITT DEL BAZO"
  },
  {
    "codigo":284985004,
    "descripcion":"CAPAZ DE DESVESTIRSE"
  },
  {
    "codigo":1525471000168108,
    "descripcion":"APOYO FAMILIAR LIMITADO"
  },
  {
    "codigo":22841008,
    "descripcion":"FOCOMELIA"
  },
  {
    "codigo":709134004,
    "descripcion":"JUICIO INTACTO"
  },
  {
    "codigo":1082041000119109,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS INTRAEPIDÉRMICO DE MIEMBRO INFERIOR DERECHO"
  },
  {
    "codigo":283150008,
    "descripcion":"ANZUELO EN LA MEJILLA"
  },
  {
    "codigo":838371002,
    "descripcion":"ABSCESO DE LÓBULO DE HEMISFERIO CEREBRAL"
  },
  {
    "codigo":1231587009,
    "descripcion":"OBSTRUCCIÓN DE VÍA RESPIRATORIA CAUSADA POR CUERPO EXTRAÑO EN NARIZ"
  },
  {
    "codigo":246712004,
    "descripcion":"CONVERGENCIA EN EL ESTRABISMO MANIFIESTO, INTERSECCIÓN DIVERGENTE DE LOS EJES VISUALES"
  },
  {
    "codigo":82872004,
    "descripcion":"HEMORRAGIA POR ESTOMA DE TRAQUEOTOMÍA"
  },
  {
    "codigo":443320005,
    "descripcion":"UTILIZA UN SOLO BASTÓN"
  },
  {
    "codigo":212109001,
    "descripcion":"QUEMADURA QUE COMPROMETE 80-89 PORCIENTO DE LA SUPERFICIE DEL CUERPO, CON QUEMADURA DE ESPESOR COMPLETO QUE AFECTA 50-59 PORCIENTO DE LA SUPERFICIE CORPORAL"
  },
  {
    "codigo":48269007,
    "descripcion":"PAROTITIS ALÉRGICA"
  },
  {
    "codigo":441485008,
    "descripcion":"INFECCIÓN DE PRÓTESIS TOTAL DE HOMBRO"
  },
  {
    "codigo":111970001,
    "descripcion":"FUNCIÓN CARDIOVASCULAR ANORMAL"
  },
  {
    "codigo":703629008,
    "descripcion":"DESMOIDE PERIÓSTICO"
  },
  {
    "codigo":46434000,
    "descripcion":"PELVIS DE ASIMILACIÓN"
  },
  {
    "codigo":243042000,
    "descripcion":"LESIÓN TRAUMÁTICA POR EFECTO DE ESTALLIDO DE EXPLOSIÓN NUCLEAR"
  },
  {
    "codigo":208439004,
    "descripcion":"FRACTURA NO EXPUESTA DE LA FALANGE DISTAL DEL PULGAR"
  },
  {
    "codigo":44599007,
    "descripcion":"HEMOTÓRAX TRAUMÁTICO SIN HERIDA ABIERTA HACIA TÓRAX"
  },
  {
    "codigo":110135009,
    "descripcion":"LACERACIÓN SIMPLE CONTAMINADA DE AMÍGDALA PALATINA"
  },
  {
    "codigo":75532003,
    "descripcion":"LATIDO DE ESCAPE VENTRICULAR"
  },
  {
    "codigo":347271000119100,
    "descripcion":"LEUCOMA ADHERENTE DE AMBOS OJOS"
  },
  {
    "codigo":403212009,
    "descripcion":"ERITEMA MULTIFORME VESICOAMPOLLOSO"
  },
  {
    "codigo":73697001,
    "descripcion":"DETERMINACIÓN DEL RESULTADO: INSATISFACTORIO PARA EL MÉDICO"
  },
  {
    "codigo":40929003,
    "descripcion":"NEVO ANÉMICO"
  },
  {
    "codigo":204769001,
    "descripcion":"FÍSTULA FECAL CONGÉNITA"
  },
  {
    "codigo":170166001,
    "descripcion":"EXAMEN PEDIÁTRICO A LOS 4,5 AÑOS: ANORMAL - EN TRATAMIENTO"
  },
  {
    "codigo":268470003,
    "descripcion":"PERCEPCIÓN DE LOS MOVIMIENTOS FETALES"
  },
  {
    "codigo":301238004,
    "descripcion":"REFLEJO TUSÍGENO PRESENTE"
  },
  {
    "codigo":235702004,
    "descripcion":"ÚLCERA GÁSTRICA CICATRIZADA"
  },
  {
    "codigo":233867000,
    "descripcion":"MIOCARDITIS POR FIEBRE Q"
  },
  {
    "codigo":37259001,
    "descripcion":"CRISIS OCULAR"
  },
  {
    "codigo":299403002,
    "descripcion":"PRUEBA PARA ACCIDENTE CEREBROVASCULAR POSITIVA"
  },
  {
    "codigo":364939005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA CONTROLAR LA POSTURA DEL TRONCO"
  },
  {
    "codigo":461408000,
    "descripcion":"ANOMALÍA ADQUIRIDA DE ESTRUCTURA DE VENA PULMONAR"
  },
  {
    "codigo":363104002,
    "descripcion":"TRASTORNO HEREDITARIO DEL SISTEMA ENDOCRINO"
  },
  {
    "codigo":723552005,
    "descripcion":"DEFICIENCIA NEONATAL TRANSITORIA DE ACIL-COENZIMA A DESHIDROGENASA MÚLTIPLE"
  },
  {
    "codigo":232032008,
    "descripcion":"RETINOPATÍA FARMACÓGENA"
  },
  {
    "codigo":295733004,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE AMSACRINA"
  },
  {
    "codigo":262965006,
    "descripcion":"DISTENSIÓN DE MÚSCULO DE LA ESPALDA"
  },
  {
    "codigo":293898000,
    "descripcion":"ALERGIA A MEDAZEPAM"
  },
  {
    "codigo":230197009,
    "descripcion":"MIELITIS TRANSVERSA VIRAL AGUDA"
  },
  {
    "codigo":424970000,
    "descripcion":"CARCINOMA PULMONAR MACROCÍTICO, TNM ESTADIO 3"
  },
  {
    "codigo":721717008,
    "descripcion":"PERFORACIÓN DE CONDUCTO CÍSTICO"
  },
  {
    "codigo":228362008,
    "descripcion":"SIENTE QUE DEBE DISMINUIR LA TOMA DE BEBIDA"
  },
  {
    "codigo":128223002,
    "descripcion":"ANOMALÍA CONGÉNITA DEL MAXILAR"
  },
  {
    "codigo":95455008,
    "descripcion":"TROMBOSIS DE LAS VENAS CEREBRALES"
  },
  {
    "codigo":93620001,
    "descripcion":"FALTA DE OSIFICACIÓN DEL ARCO DE LA VÉRTEBRA LUMBAR"
  },
  {
    "codigo":292063009,
    "descripcion":"REACCIÓN ADVERSA AL FENTANILO"
  },
  {
    "codigo":290228001,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR ACEMETACINA"
  },
  {
    "codigo":880052005,
    "descripcion":"HIPERTROFIA ADQUIRIDA DE VENTRÍCULO CARDÍACO IZQUIERDO"
  },
  {
    "codigo":124553004,
    "descripcion":"DEFICIENCIA DE MONOÉSTER DIFOSFÓRICO HIDROLASA"
  },
  {
    "codigo":26249004,
    "descripcion":"INFECCIÓN INTESTINAL CAUSADA POR CESTODOS Y\/O TREMATODOS Y\/O NEMATODOS"
  },
  {
    "codigo":57182000,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO"
  },
  {
    "codigo":59017008,
    "descripcion":"AMILOIDOSIS CONJUNTIVAL"
  },
  {
    "codigo":712542001,
    "descripcion":"CON ABSTINENCIA DE USO INAPROPIADO DE DROGAS"
  },
  {
    "codigo":11789601000119109,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO DE DEDO ÍNDICE DE MANO DERECHA"
  },
  {
    "codigo":10862011000119103,
    "descripcion":"HERIDA PUNZANTE DE PIE DERECHO"
  },
  {
    "codigo":24414006,
    "descripcion":"FUNCIÓN MAMARIA ANORMAL"
  },
  {
    "codigo":311231000119100,
    "descripcion":"RADICULOPATÍA CONCOMITANTE CON TRASTORNO DE DISCO INTERVERTEBRAL DORSAL Y DEBIDA A ÉL"
  },
  {
    "codigo":44991000119100,
    "descripcion":"SANGRADO UTERINO ANORMAL"
  },
  {
    "codigo":10743231000119101,
    "descripcion":"ENFERMEDAD DE CROHN DE INTESTINO DELGADO CON ESTENOSIS"
  },
  {
    "codigo":10942911000119103,
    "descripcion":"LESIÓN TRAUMÁTICA DE GLOBO OCULAR IZQUIERDO"
  },
  {
    "codigo":10676671000119102,
    "descripcion":"ASMA PERSISTENTE MODERADA NO CONTROLADA CONCOMITANTE CON RINITIS ALÉRGICA"
  },
  {
    "codigo":306111000119105,
    "descripcion":"TRASTORNO DE LIGAMENTO DE ARTICULACIÓN DE LA MUÑECA DERECHA"
  },
  {
    "codigo":1076671000119100,
    "descripcion":"TENDINITIS DEL MÚSCULO FLEXOR LARGO DEL DEDO GORDO DERECHO"
  },
  {
    "codigo":16057791000119107,
    "descripcion":"PARÁLISIS FACIAL DERECHA DE GRADO IV DE HOUSE-BRACKMANN"
  },
  {
    "codigo":352191000119107,
    "descripcion":"MELANOMA IN SITU DE MIEMBRO INFERIOR DERECHO"
  },
  {
    "codigo":16060351000119105,
    "descripcion":"EXPOSICIÓN NEONATAL A HUMO DE TABACO"
  },
  {
    "codigo":16027071000119105,
    "descripcion":"MIOQUIMIA DE MÚSCULO FACIAL DERECHO"
  },
  {
    "codigo":295871000119107,
    "descripcion":"OSTEOMIELITIS CRÓNICA DE HÚMERO CON FÍSTULA PRODUCTIVA"
  },
  {
    "codigo":1086911000119107,
    "descripcion":"INCONTINENCIA FECAL COMPLETA"
  },
  {
    "codigo":677311000119109,
    "descripcion":"HIPOTONÍA DE OJO DERECHO DEBIDA A FÍSTULA OCULAR"
  },
  {
    "codigo":10860991000119107,
    "descripcion":"HEMATOMA DE ÓRBITA DERECHA"
  },
  {
    "codigo":142271000119106,
    "descripcion":"DÉFICIT COGNITIVO EN LAS HABILIDADES DE COMUNICACIÓN"
  },
  {
    "codigo":121791000119109,
    "descripcion":"ANOMALÍA GENITOURINARIA FETAL"
  },
  {
    "codigo":84445001,
    "descripcion":"RIGIDEZ ARTICULAR"
  },
  {
    "codigo":103871000119109,
    "descripcion":"ENFERMEDAD PULMONAR RESTRICTIVA DEBIDA A ENFERMEDAD DE PARKINSON"
  },
  {
    "codigo":1264093003,
    "descripcion":"TRASTORNO FETAL CAUSADO POR TRANSFERENCIA PLACENTARIA DE AGENTE HIPOGLUCEMIANTE"
  },
  {
    "codigo":1296861002,
    "descripcion":"DEFICIENCIA DE PROTEÍNA PORTADORA DE ESTEROL X"
  },
  {
    "codigo":51677000,
    "descripcion":"ATEROEMBOLIA DE LAS ARTERIAS RENALES"
  },
  {
    "codigo":836274002,
    "descripcion":"CARCINOMATOSIS DE PERITONEO"
  },
  {
    "codigo":78940002,
    "descripcion":"TRIPANOSOMIASIS"
  },
  {
    "codigo":406620007,
    "descripcion":"TOXOCARIASIS DEL SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":13404009,
    "descripcion":"TRANSFUSIÓN SANGUÍNEA DE UN GEMELO AL OTRO"
  },
  {
    "codigo":699697007,
    "descripcion":"HALLAZGO RELACIONADO CON LA SENSACIÓN POR LOCALIZACIÓN"
  },
  {
    "codigo":372017008,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL ESÓFAGO TORÁCICO"
  },
  {
    "codigo":239110000,
    "descripcion":"NEVO EPIDÉRMICO DISQUERATÓSICO ACANTOLÍTICO"
  },
  {
    "codigo":75270000,
    "descripcion":"DIVERTÍCULO CONGÉNITO DEL VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":402950003,
    "descripcion":"LEUCOPLASIA SIFILÍTICA DE LA LENGUA"
  },
  {
    "codigo":304646005,
    "descripcion":"CAPAZ DE REALIZAR UNA SECUENCIA LÓGICA"
  },
  {
    "codigo":763398006,
    "descripcion":"COLITIS ISQUÉMICA NO GANGRENOSA"
  },
  {
    "codigo":237275001,
    "descripcion":"DESPRENDIMIENTO DE PLACENTA MIXTO"
  },
  {
    "codigo":173574009,
    "descripcion":"PERICARDITIS BENIGNA AGUDA"
  },
  {
    "codigo":302811004,
    "descripcion":"ENCEFALOMIELITIS CONGÉNITA PROGRESIVA POR VIRUS DE LA RUBÉOLA"
  },
  {
    "codigo":1187547006,
    "descripcion":"DEGENERACIÓN HIPOFISARIA"
  },
  {
    "codigo":71600001,
    "descripcion":"GIRAR"
  },
  {
    "codigo":202672001,
    "descripcion":"ESPONDILOSIS DORSAL EN MÚLTIPLES NIVELES CON MIELOPATÍA"
  },
  {
    "codigo":169904009,
    "descripcion":"PUNTAJE DE APGAR AL MINUTO = 7"
  },
  {
    "codigo":366512009,
    "descripcion":"HALLAZGO RELACIONADO CON LA AMPLITUD DE SUPINACIÓN DE CODO"
  },
  {
    "codigo":323311000119107,
    "descripcion":"ARTROSIS DE CADERA DERECHA"
  },
  {
    "codigo":299141001,
    "descripcion":"AMPLITUD DE FLEXIÓN ACTIVA DEL PULGAR NORMAL"
  },
  {
    "codigo":200837006,
    "descripcion":"HIDROA VACCINIFORME"
  },
  {
    "codigo":102533007,
    "descripcion":"EJERCICIO EXCESIVO"
  },
  {
    "codigo":10645231000119108,
    "descripcion":"ÚLCERA VARICOSA DE PANTORRILLA DERECHA"
  },
  {
    "codigo":67930001,
    "descripcion":"SIRINGOENCEFALIA"
  },
  {
    "codigo":16051951000119109,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE TENDÓN DE MÚSCULO PLANTAR DE EXTREMIDAD INFERIOR IZQUIERDA"
  },
  {
    "codigo":35162007,
    "descripcion":"RUPTURA DE SENO DE VALSALVA EN EL VENTRÍCULO DERECHO"
  },
  {
    "codigo":66095000,
    "descripcion":"HIPOGLUCEMIA MIXTA"
  },
  {
    "codigo":721455004,
    "descripcion":"SÍNDROME DEL CORDÓN ANTERIOR DE MÉDULA ESPINAL DORSAL"
  },
  {
    "codigo":295471006,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE DOCUSATO"
  },
  {
    "codigo":262703009,
    "descripcion":"EDEMA DE MÉDULA ESPINAL LUMBAR"
  },
  {
    "codigo":293636002,
    "descripcion":"ALERGIA A RADIOFÁRMACO"
  },
  {
    "codigo":31492004,
    "descripcion":"MIEDO A LA ESCUELA"
  },
  {
    "codigo":129796009,
    "descripcion":"RETRACCIÓN DE PIEL DE MAMA SEGÚN LA MAMOGRAFÍA"
  },
  {
    "codigo":717785002,
    "descripcion":"SÍNDROME DE COLOBOMA MACULAR CON BRADIDACTILIA TIPO B"
  },
  {
    "codigo":1078233002,
    "descripcion":"AGENESIA DE TODAS LAS FALANGES DISTALES DE MANO"
  },
  {
    "codigo":193497004,
    "descripcion":"ENFERMEDAD DE VOGT-KOYANAGI-HARADA"
  },
  {
    "codigo":62425004,
    "descripcion":"CICATRIZ COROIDEA POSTQUIRÚRGICA"
  },
  {
    "codigo":95193005,
    "descripcion":"LINFOMA NODULAR DEL BAZO"
  },
  {
    "codigo":29657007,
    "descripcion":"DIAGNÓSTICO APLAZADO EN EL EJE IV"
  },
  {
    "codigo":160729004,
    "descripcion":"VIVE EN HOGAR PROTEGIDO"
  },
  {
    "codigo":224430001,
    "descripcion":"SIN MÁQUINA EXPENDEDORA EN EL TRABAJO"
  },
  {
    "codigo":60590005,
    "descripcion":"EFECTO DE FCU MATERNA EN EL FETO"
  },
  {
    "codigo":93358007,
    "descripcion":"POSICIÓN ANÓMALA CONGÉNITA DE TESTÍCULO"
  },
  {
    "codigo":715950008,
    "descripcion":"LINFOMA DE LINFOCITOS B GRANDES QUINASA-POSITIVO, ANAPLÁSICO"
  },
  {
    "codigo":124291003,
    "descripcion":"DEFICIENCIA DE ALANINA - OXO - ÁCIDO AMINOTRANSFERASA"
  },
  {
    "codigo":286296002,
    "descripcion":"ARTICULA PALABRAS CLARAMENTE"
  },
  {
    "codigo":24152003,
    "descripcion":"DERMATITIS NODULAR"
  },
  {
    "codigo":253528005,
    "descripcion":"DISPLASIA ARRITMOGÉNICA DEL VENTRÍCULO DERECHO"
  },
  {
    "codigo":218925004,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR CARBONATO DE MAGNESIO"
  },
  {
    "codigo":315394002,
    "descripcion":"NACIDO EN BURMA"
  },
  {
    "codigo":1167362003,
    "descripcion":"ASFIXIA NEONATAL MODERADA"
  },
  {
    "codigo":282626003,
    "descripcion":"CAPAZ DE RODAR HACIA UN COSTADO"
  },
  {
    "codigo":86018005,
    "descripcion":"CONGELAMIENTO DE LA CARA"
  },
  {
    "codigo":446466006,
    "descripcion":"RUPTURA DE MEMBRANA PUPILAR"
  },
  {
    "codigo":249858009,
    "descripcion":"MALA POSTURA"
  },
  {
    "codigo":248023002,
    "descripcion":"CONDUCTA HISTRIÓNICA"
  },
  {
    "codigo":15972541000119104,
    "descripcion":"TROMBOSIS DE AMBAS ARTERIAS ILÍACAS"
  },
  {
    "codigo":14977000,
    "descripcion":"TROMBOSIS MÚLTIPLE Y BILATERAL DE LA ARTERIA CEREBRAL ANTERIOR"
  },
  {
    "codigo":211585003,
    "descripcion":"LESIÓN TRAUMÁTICA ABIERTA POR APLASTAMIENTO, DEDO DE LA MANO"
  },
  {
    "codigo":277121007,
    "descripcion":"ASIMETRÍA INTERHEMISFÉRICA DE LA AMPLITUD, NO CRUZADA"
  },
  {
    "codigo":768641007,
    "descripcion":"CARIES ACTIVA CORONAL EN ESTADIO INICIAL"
  },
  {
    "codigo":735873009,
    "descripcion":"LACERACIÓN DE DEDO DE PIE SIN CUERPO EXTRAÑO"
  },
  {
    "codigo":373590007,
    "descripcion":"NISTAGMO DE CONVERGENCIA-RETRACCIÓN"
  },
  {
    "codigo":45910007,
    "descripcion":"FRACTURA EXPUESTA DE COSTILLA"
  },
  {
    "codigo":209750009,
    "descripcion":"SECCIÓN EXPUESTA DE LIGAMENTO DEL APÉNDICE XIFOIDES"
  },
  {
    "codigo":404523002,
    "descripcion":"ORGANISMO NO VIABLE"
  },
  {
    "codigo":109611002,
    "descripcion":"CELULITIS DE LA ENCÍA"
  },
  {
    "codigo":763136000,
    "descripcion":"SÍNDROME DE ENFERMEDAD DE CHARCOT-MARIE-TOOTH, SORDERA Y DISCAPACIDAD INTELECTUAL"
  },
  {
    "codigo":135511000119105,
    "descripcion":"MIELOPATÍA DEBIDA A ENFERMEDAD NEOPLÁSICA MALIGNA"
  },
  {
    "codigo":271616002,
    "descripcion":"HALLAZGO RELACIONADO CON EL DESARROLLO FISIOLÓGICO GENERAL"
  },
  {
    "codigo":75008004,
    "descripcion":"PATERNIDAD INEFICAZ"
  },
  {
    "codigo":402688004,
    "descripcion":"PANICULITIS POR DEPÓSITOS DE CRISTALES"
  },
  {
    "codigo":11823601000119100,
    "descripcion":"ABRASIÓN DE PIEL DE REGIÓN DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":682481000119100,
    "descripcion":"ASTROCITOMA PRIMARIO DE LÓBULO TEMPORAL"
  },
  {
    "codigo":1285589003,
    "descripcion":"ATROFIA NO GEOGRÁFICA DE MÁCULA LÚTEA"
  },
  {
    "codigo":204245004,
    "descripcion":"TRAGO ACCESORIO"
  },
  {
    "codigo":1187285005,
    "descripcion":"CARCINOMA DE CÉLULAS CLARAS METASTÁSICO DE RIÑÓN"
  },
  {
    "codigo":73173006,
    "descripcion":"ESPASMO ARTERIAL CEREBRAL"
  },
  {
    "codigo":169642000,
    "descripcion":"INTENCIÓN SOBRE LA ALIMENTACIÓN DEL RECIÉN NACIDO - INSEGURA"
  },
  {
    "codigo":366250002,
    "descripcion":"HALLAZGO RELACIONADO CON LA PERMEABILIDAD DEL ANO"
  },
  {
    "codigo":399018006,
    "descripcion":"AUSENCIA DE PELO - NO CRECE"
  },
  {
    "codigo":202410008,
    "descripcion":"HEMARTROSIS DE ARTICULACIÓN INTERFALÁNGICA DISTAL DE DEDO DE LA MANO"
  },
  {
    "codigo":300714009,
    "descripcion":"INCAPAZ DE HACER UN PRESUPUESTO"
  },
  {
    "codigo":724863009,
    "descripcion":"HEMATOMA DE HERIDA QUIRÚRGICA DE PIEL DEBIDO A PROCEDIMIENTO QUIRÚRGICO Y POSTERIOR A ÉL"
  },
  {
    "codigo":2132004,
    "descripcion":"MECONIO EN LÍQUIDO AMNIÓTICO DETECTADO ANTES DEL TRABAJO DE PARTO EN NIÑO NACIDO VIVO"
  },
  {
    "codigo":297044004,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE ACETAZOLAMIDA"
  },
  {
    "codigo":428116008,
    "descripcion":"PROBLEMA DE LA MARCHA MULTIFACTORIAL"
  },
  {
    "codigo":360745000,
    "descripcion":"DEFICIENCIA DE ACIL-COA HIDROLASA DE ÁCIDOS GRASOS DE CADENA LARGA"
  },
  {
    "codigo":721193002,
    "descripcion":"NEOPLASIA NEUROENDOCRINA DE TRACTO GASTROINTESTINAL"
  },
  {
    "codigo":231508009,
    "descripcion":"MIEDO A LOS EXÁMENES"
  },
  {
    "codigo":229673004,
    "descripcion":"TRASTORNO DEL LENGUAJE ASOCIADO CON TRASTORNO DEL PENSAMIENTO"
  },
  {
    "codigo":295209006,
    "descripcion":"SOBREDOSIS DE LEVORFANOL"
  },
  {
    "codigo":195070000,
    "descripcion":"TAQUICARDIA AURICULOVENTRICULAR PAROXÍSTICA"
  },
  {
    "codigo":297009,
    "descripcion":"MIRINGITIS AGUDA"
  },
  {
    "codigo":293374000,
    "descripcion":"REACCIÓN ADVERSA A LA NUTRICIÓN PARENTERAL (MEZCLADA)"
  },
  {
    "codigo":15673841000119109,
    "descripcion":"MIOSITIS INFECCIOSA DE AMBOS HOMBROS"
  },
  {
    "codigo":16220811000119103,
    "descripcion":"ANAFILAXIA CAUSADA POR VENENO DE AVISPÓN"
  },
  {
    "codigo":63998007,
    "descripcion":"VEGETACIONES DE LA PIEL"
  },
  {
    "codigo":94931004,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL MEDIASTINO"
  },
  {
    "codigo":422611005,
    "descripcion":"ESTIMULACIÓN SOCIAL EXTERNA MÍNIMA"
  },
  {
    "codigo":783059004,
    "descripcion":"DISPLASIA ATÍPICA DE DENTINA DEBIDA A DEFICIENCIA DE PROTEÍNA MODULAR 1 DE UNIÓN A CALCIO RELACIONADA CON SPARC"
  },
  {
    "codigo":93096002,
    "descripcion":"AUSENCIA DE OSIFICACIÓN DEL PERONÉ"
  },
  {
    "codigo":60328005,
    "descripcion":"EMBARAZOS PREVIOS: 4"
  },
  {
    "codigo":289704009,
    "descripcion":"HALLAZGO RELACIONADO CON LA FRECUENCIA DE LAS CONTRACCIONES UTERINAS"
  },
  {
    "codigo":82571000119107,
    "descripcion":"DESPRENDIMIENTO DE RETINA POR TRACCIÓN DEBIDO A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":1172605003,
    "descripcion":"SÍNDROME DE RETINITIS PIGMENTARIA, HIPOACUSIA, ENVEJECIMIENTO PREMATURO, TALLA BAJA Y DISMORFIA FACIAL"
  },
  {
    "codigo":124029003,
    "descripcion":"YODO LIGADO A PROTEÍNAS POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":713853007,
    "descripcion":"EPIESCLERITIS SECTORIAL"
  },
  {
    "codigo":23890000,
    "descripcion":"APOFISITIS CALCÁNEA"
  },
  {
    "codigo":189565007,
    "descripcion":"CARCINOMA ESCAMOCELULAR IN SITU"
  },
  {
    "codigo":449874002,
    "descripcion":"DIENTE SUPERIOR CADUCO SUPERNUMERARIO"
  },
  {
    "codigo":1269074003,
    "descripcion":"TRASTORNO MATERNO DURANTE PARTO"
  },
  {
    "codigo":328331000119109,
    "descripcion":"PANCITOPENIA CAUSADA POR AGENTE ANTIINFLAMATORIO NO ESTEROIDE"
  },
  {
    "codigo":286034006,
    "descripcion":"CAPAZ DE CUIDAR LA ROPA"
  },
  {
    "codigo":54823002,
    "descripcion":"HIPOTIROIDISMO SUBCLÍNICO"
  },
  {
    "codigo":218663005,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR BARBITAL"
  },
  {
    "codigo":448039007,
    "descripcion":"OSTEOCONDRITIS DISECANTE DE PERONÉ"
  },
  {
    "codigo":249596001,
    "descripcion":"IMPULSO TUSIVO EN EL CONDUCTO INGUINAL"
  },
  {
    "codigo":20220004,
    "descripcion":"INFECCIÓN CAUSADA POR METROLIASTHES"
  },
  {
    "codigo":282364005,
    "descripcion":"NEFROPATÍA POR IGA ASOCIADA CON ENFERMEDAD HEPÁTICA"
  },
  {
    "codigo":448563005,
    "descripcion":"NEOPLASIA HIPOFISARIA NO FUNCIONANTE"
  },
  {
    "codigo":870353004,
    "descripcion":"NOMA NEONATAL"
  },
  {
    "codigo":313297008,
    "descripcion":"ENFERMEDAD PULMONAR OBSTRUCTIVA CRÓNICA, MODERADA"
  },
  {
    "codigo":704678007,
    "descripcion":"ESTADO DE ÁNIMO DEPRIMIDO INICIADO EN EL PERÍODO DEL PUERPERIO"
  },
  {
    "codigo":278694008,
    "descripcion":"PARTICULADO"
  },
  {
    "codigo":735611002,
    "descripcion":"DEGENERACIÓN DE DISCO INTERVERTEBRAL LUMBAR CONCOMITANTE CON OSTEOFITO DE VÉRTEBRA LUMBAR"
  },
  {
    "codigo":11826111000119104,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO ADUCTOR Y TENDÓN DE MUSLO IZQUIERDO"
  },
  {
    "codigo":10679231000119105,
    "descripcion":"TUMEFACCIÓN LOCALIZADA DE EXTREMIDAD SUPERIOR IZQUIERDA"
  },
  {
    "codigo":276859008,
    "descripcion":"RETRACCIÓN SUPRAESTERNAL"
  },
  {
    "codigo":242256000,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE ANTIDEPRESIVO TRICÍCLICO"
  },
  {
    "codigo":111184007,
    "descripcion":"ABSCESO DE LA REGIÓN TEMPORAL"
  },
  {
    "codigo":11045000,
    "descripcion":"PARÁLISIS SUPRANUCLEAR DEL NERVIO FACIAL"
  },
  {
    "codigo":1290832009,
    "descripcion":"ATAXIA CAUSADA POR SUSTANCIA"
  },
  {
    "codigo":16004031000119107,
    "descripcion":"OSTEOPATÍA DE HÚMERO IZQUIERDO POSTERIOR A POLIOMIELITIS"
  },
  {
    "codigo":209488007,
    "descripcion":"LESIÓN DE PLACA PALMAR DE ARTICULACIÓN METACARPOFALÁNGICA"
  },
  {
    "codigo":76581006,
    "descripcion":"COLECISTITIS"
  },
  {
    "codigo":109349007,
    "descripcion":"NEOPLASIA MALIGNA SUPERPUESTA DE PARTES BLANDAS"
  },
  {
    "codigo":9210000,
    "descripcion":"HIPOVITAMINOSIS P"
  },
  {
    "codigo":240421006,
    "descripcion":"REACCIÓN CUTÁNEA HIPERINMUNITARIA CAUSADA POR MYCOBACTEROIUM KANSASII"
  },
  {
    "codigo":238586002,
    "descripcion":"PRURIGO SUBAGUDO"
  },
  {
    "codigo":369658000,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA DE BRONQUIO Y PULMÓN, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":271354006,
    "descripcion":"VÓMITO: PUS PRESENTE"
  },
  {
    "codigo":402426007,
    "descripcion":"NODULOSIS REUMATOIDE"
  },
  {
    "codigo":105679002,
    "descripcion":"ENFERMEDAD CAUSADA POR DIPHYLLOBOTHRIIDAE"
  },
  {
    "codigo":15731801000119104,
    "descripcion":"TRASTORNO DE NERVIO ÓPTICO IZQUIERDO"
  },
  {
    "codigo":365988001,
    "descripcion":"HALLAZGO EN EL ASPECTO, RELACIONADO CON LA EDAD"
  },
  {
    "codigo":330841000119106,
    "descripcion":"XERODERMIA DE PÁRPADO DERECHO"
  },
  {
    "codigo":202148007,
    "descripcion":"ARTROFITO EN ARTICULACIÓN DE REGIÓN DE HOMBRO"
  },
  {
    "codigo":431524008,
    "descripcion":"MARCHA ANORMAL POR ALTERACIÓN DEL EQUILIBRIO"
  },
  {
    "codigo":300452009,
    "descripcion":"HALLAZGO RELACIONADO CON LA APARIENCIA DE LOS URÉTERES"
  },
  {
    "codigo":396921005,
    "descripcion":"HALLAZGO RELACIONADO CON GRADO TUMORAL DE SISTEMA NERVIOSO CENTRAL DE LA OMS"
  },
  {
    "codigo":3705009,
    "descripcion":"ANOMALÍA CONGÉNITA DE LA CÁMARA ANTERIOR DEL OJO"
  },
  {
    "codigo":1148750005,
    "descripcion":"INTOXICACIÓN POR SULFAMETOXAZOL Y\/O TRIMETOPRIMA"
  },
  {
    "codigo":67406007,
    "descripcion":"COAGULACIÓN INTRAVASCULAR DISEMINADA"
  },
  {
    "codigo":296782007,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE COMPUESTO DE ANTIMONIO"
  },
  {
    "codigo":131107006,
    "descripcion":"NIVEL DE GLUCAGÓN POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":304371000119106,
    "descripcion":"INESTABILIDAD CRÓNICA DE ARTICULACIÓN DE RODILLA DERECHA"
  },
  {
    "codigo":719096006,
    "descripcion":"SÍNDROME DE CÓRNEA FRÁGIL"
  },
  {
    "codigo":1145080008,
    "descripcion":"POSICIÓN DE REMOLINO DE PELO ANORMAL"
  },
  {
    "codigo":61901004,
    "descripcion":"TRASTORNO DE CONDUCTA, TIPO INDIFERENCIADO"
  },
  {
    "codigo":717261006,
    "descripcion":"HIPERPLASIA SUPRARRENAL CONGÉNITA CLÁSICA DEBIDA A DEFICIENCIA DE 21-HIDROXILASA"
  },
  {
    "codigo":94669007,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL NERVIO VAGO"
  },
  {
    "codigo":420514000,
    "descripcion":"PROTEINURIA PERSISTENTE DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":125602001,
    "descripcion":"LESIÓN TRAUMÁTICA DE PIERNA"
  },
  {
    "codigo":289442004,
    "descripcion":"FRECUENCIA CARDÍACA FETAL BASAL - HALLAZGO"
  },
  {
    "codigo":715426004,
    "descripcion":"DERMOIDE CORNEAL LIGADO AL CROMOSOMA X"
  },
  {
    "codigo":1010338007,
    "descripcion":"BABEO POR EL LADO IZQUIERDO DE LA BOCA"
  },
  {
    "codigo":92834007,
    "descripcion":"FUSIÓN ANORMAL CONGÉNITA DE HUESO ALIESFENOIDAL"
  },
  {
    "codigo":25463000,
    "descripcion":"OBSTRUCCIÓN DE URÉTER SECUNDARIA A LITIASIS"
  },
  {
    "codigo":1338018007,
    "descripcion":"DESVIACIÓN ADQUIRIDA DE URÉTER"
  },
  {
    "codigo":123767004,
    "descripcion":"HEMOGLOBINEMIA"
  },
  {
    "codigo":254839007,
    "descripcion":"CARCINOMA ESCIRRO DE MAMA"
  },
  {
    "codigo":89164003,
    "descripcion":"TUMORACIÓN MAMARIA"
  },
  {
    "codigo":283937006,
    "descripcion":"CONTUSIÓN DE LA VESÍCULA SEMINAL"
  },
  {
    "codigo":54561008,
    "descripcion":"INTOXICACIÓN CAUSADA POR ADRENALINA"
  },
  {
    "codigo":447777009,
    "descripcion":"CIERRE ESPONTÁNEO DE COMPONENTE VENTRICULAR DE DEFECTO DE TABIQUE AURICULOVENTRICULAR"
  },
  {
    "codigo":871926004,
    "descripcion":"ANAFILAXIA CAUSADA POR MORDEDURA Y\/O PICADURA DE INSECTO"
  },
  {
    "codigo":773622005,
    "descripcion":"SÍNDROME DE DISPLASIA CRANEOFACIAL-OSTEOPENIA"
  },
  {
    "codigo":183798007,
    "descripcion":"ESTADÍA DE INTERNACIÓN SUPERIOR A 12 HORAS"
  },
  {
    "codigo":247499002,
    "descripcion":"RANURAS LONGITUDINALES DE LAS UÑAS"
  },
  {
    "codigo":1197771003,
    "descripcion":"ÚLCERA GÁSTRICA POR SARCOIDOSIS"
  },
  {
    "codigo":737184001,
    "descripcion":"ENFERMEDAD PULMONAR INTERSTICIAL CONCOMITANTE CON VASCULITIS SISTÉMICA Y DEBIDA A ELLA"
  },
  {
    "codigo":333351000119106,
    "descripcion":"PTOSIS PARALÍTICA DE PÁRPADO SUPERIOR DERECHO"
  },
  {
    "codigo":704416007,
    "descripcion":"CON MAYOR RIESGO DE RESPUESTA NEGATIVA A ANALGESIA CONTROLADA POR PACIENTE"
  },
  {
    "codigo":407669000,
    "descripcion":"IMÁGENES DE RESONANCIA MAGNÉTICA CEREBRAL ANORMALES"
  },
  {
    "codigo":243829001,
    "descripcion":"SITUACIÓN DE CRIBADO PARA RUBÉOLA"
  },
  {
    "codigo":1259637001,
    "descripcion":"OSTEOSARCOMA PRIMARIO DE CARTÍLAGO ARTICULAR DE VÉRTEBRA"
  },
  {
    "codigo":211061001,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE FLANCO"
  },
  {
    "codigo":10956481000119101,
    "descripcion":"HERIDA ABIERTA DE DEDO DE MANO IZQUIERDA"
  },
  {
    "codigo":702581006,
    "descripcion":"DIFICULTAD PARA COMER DEBIDA A DISNEA"
  },
  {
    "codigo":735349007,
    "descripcion":"ALIVIO DE SÍNTOMA AL ELEVAR EL MIEMBRO"
  },
  {
    "codigo":10655271000119108,
    "descripcion":"ÚLCERA ISQUÉMICA ATEROSCLERÓTICA DE PARTE MEDIA DE PIE IZQUIERDO"
  },
  {
    "codigo":274762001,
    "descripcion":"SIN ANOMALÍAS DETECTADAS EN EXAMEN DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":241994005,
    "descripcion":"LESIÓN CEREBELOSA POR DESCOMPRESIÓN"
  },
  {
    "codigo":209226006,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA EXPUESTA DEL CARTÍLAGO LARÍNGEO"
  },
  {
    "codigo":698911000,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: MOLDAVO"
  },
  {
    "codigo":305695000,
    "descripcion":"ATENDIDO POR UN PSIQUIATRA FORENSE"
  },
  {
    "codigo":403999006,
    "descripcion":"ANGIOMA ESCLEROSANTE DE LA PIEL"
  },
  {
    "codigo":240159007,
    "descripcion":"OSTEOPOROSIS TRANSITORIA DE CADERA"
  },
  {
    "codigo":860916000,
    "descripcion":"DISFUNCIÓN ERÉCTIL RELATIVA"
  },
  {
    "codigo":764447009,
    "descripcion":"TRISOMÍA DISTAL 11Q"
  },
  {
    "codigo":271092002,
    "descripcion":"DEFORMIDAD DE FÉMUR"
  },
  {
    "codigo":41716002,
    "descripcion":"SIGNOS DE ANORMALIDAD EN EL EEG, POR FOTOESTIMULACIÓN"
  },
  {
    "codigo":12103361000119106,
    "descripcion":"QUEMADURA DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":105417001,
    "descripcion":"DESAPARICIÓN DEL COMPAÑERO"
  },
  {
    "codigo":1285065002,
    "descripcion":"ATEROESCLEROSIS DE ARTERIA DE AMBOS MIEMBROS SUPERIORES"
  },
  {
    "codigo":306881000119107,
    "descripcion":"DERRAME ARTICULAR DE CADERA IZQUIERDA"
  },
  {
    "codigo":269257004,
    "descripcion":"INSUFICIENCIA RENAL AGUDA POR SÍNDROME DE APLASTAMIENTO"
  },
  {
    "codigo":433097005,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA BILATERAL DE MIEMBROS SUPERIORES"
  },
  {
    "codigo":236489002,
    "descripcion":"SÍNDROME DE ÉMBOLO POR COLESTEROL"
  },
  {
    "codigo":762612009,
    "descripcion":"CUATRILLIZOS MORTINATOS"
  },
  {
    "codigo":38046004,
    "descripcion":"GLOMERULOESCLEROSIS DIFUSA DE RIÑÓN DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":1119390005,
    "descripcion":"FISURA DE PALADAR DURO DERECHO"
  },
  {
    "codigo":431262007,
    "descripcion":"ABSCESO BACTERIANO DE VÁLVULA MITRAL"
  },
  {
    "codigo":70814008,
    "descripcion":"ESQUIZOFRENIA RESIDUAL SUBCRÓNICA CON EXACERBACIONES AGUDAS"
  },
  {
    "codigo":298355006,
    "descripcion":"ESTRECHAMIENTO ÓSEO"
  },
  {
    "codigo":68979007,
    "descripcion":"ENFERMEDAD DE CADENA PESADA"
  },
  {
    "codigo":427592000,
    "descripcion":"OCLUSIÓN DE ARTERIA MESENTÉRICA SUPERIOR"
  },
  {
    "codigo":429427008,
    "descripcion":"SINUSITIS MICÓTICA INVASIVA"
  },
  {
    "codigo":165448003,
    "descripcion":"CONCENTRACIÓN DE HEMOGLOBINA CORPUSCULAR MEDIA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1608005,
    "descripcion":"PERMEABILIDAD CAPILAR AUMENTADA"
  },
  {
    "codigo":722504006,
    "descripcion":"OBJETIVO DE PLAN DE ATENCIÓN ACORDADO"
  },
  {
    "codigo":67144006,
    "descripcion":"EPIDERMÓLISIS BULLOSA SIMPLE"
  },
  {
    "codigo":1148488008,
    "descripcion":"SIGNO DE DREHMANN"
  },
  {
    "codigo":294685000,
    "descripcion":"ALERGIA A DESONIDA"
  },
  {
    "codigo":198216009,
    "descripcion":"VAGINITIS ASOCIADA CON OTRO TRASTORNO"
  },
  {
    "codigo":32541007,
    "descripcion":"PARAMNESIA"
  },
  {
    "codigo":1144818000,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR PROTAMINA"
  },
  {
    "codigo":292850002,
    "descripcion":"REACCIÓN ADVERSA A LA AMODIAQUINA"
  },
  {
    "codigo":784370005,
    "descripcion":"MIOPATÍA MITOCONDRIAL CON DEFICIENCIA REVERSIBLE DE CITOCROMO C OXIDASA"
  },
  {
    "codigo":127175000,
    "descripcion":"LINFADENOPATÍA GLÚTEA INFERIOR"
  },
  {
    "codigo":716999001,
    "descripcion":"SÍNDROME DE JOUBERT CON DEFECTO RENAL"
  },
  {
    "codigo":225479002,
    "descripcion":"CONDUCTA ABUSIVA EN EL ASPECTO PSICOLÓGICO"
  },
  {
    "codigo":335861000119104,
    "descripcion":"CATARATA CONGÉNITA DE OJO DERECHO"
  },
  {
    "codigo":94407000,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL DIVERTÍCULO DE MECKEL"
  },
  {
    "codigo":422087002,
    "descripcion":"MICROPSIA CAUSADA POR ENFERMEDAD ORGÁNICA"
  },
  {
    "codigo":192711008,
    "descripcion":"ENCEFALITIS POSVACUNACIÓN ANTIDIFTÉRICA"
  },
  {
    "codigo":61639009,
    "descripcion":"SÍNDROME DE CASTRACIÓN DE ORIGEN NUTRICIONAL"
  },
  {
    "codigo":291015008,
    "descripcion":"INTOXICACIÓN CON CICLOBARBITAL"
  },
  {
    "codigo":1073141000119105,
    "descripcion":"ARTRITIS DE CADERA DERECHA CAUSADA POR STREPTOCOCCUS"
  },
  {
    "codigo":92572008,
    "descripcion":"CARCINOMA IN SITU DE LA CÓRNEA"
  },
  {
    "codigo":1237617004,
    "descripcion":"SÍNDROME HIPEREOSINOFÍLICO SECUNDARIO"
  },
  {
    "codigo":285510004,
    "descripcion":"DIFICULTAD PARA SACAR LA LENGUA TOTALMENTE"
  },
  {
    "codigo":449350006,
    "descripcion":"ARTERIA PULMONAR CON CONEXIÓN ARTERIAL PROXIMAL AUSENTE"
  },
  {
    "codigo":88902008,
    "descripcion":"CEGUERA DISOCIATIVA"
  },
  {
    "codigo":871664000,
    "descripcion":"ESTENOSIS DE CAYADO AÓRTICO DESPUÉS DE PROCEDIMIENTO"
  },
  {
    "codigo":283675008,
    "descripcion":"HERIDA POR PINCHAZO DE CLAVO EN EL TOBILLO"
  },
  {
    "codigo":609520005,
    "descripcion":"TRASTORNO DE ESTRUCTURA FETAL"
  },
  {
    "codigo":183536005,
    "descripcion":"DERIVADO AL NEFRÓLOGO"
  },
  {
    "codigo":1363184005,
    "descripcion":"DEMENCIA PRESENIL DEBIDA A ENFERMEDAD POR CUERPOS DE LEWY"
  },
  {
    "codigo":85232009,
    "descripcion":"INSUFICIENCIA VENTRICULAR IZQUIERDA"
  },
  {
    "codigo":16775311000119107,
    "descripcion":"MICOSIS FUNGOIDE DE GANGLIO LINFÁTICO FACIAL"
  },
  {
    "codigo":48794007,
    "descripcion":"INFECCIÓN POR VIH CON SÍNDROME TIPO MONONUCLEOSIS INFECCIOSA"
  },
  {
    "codigo":702319000,
    "descripcion":"PARÁLISIS CEREBRAL BILATERAL"
  },
  {
    "codigo":16026008,
    "descripcion":"HIPOPLASIA CEREBELOSA CONGÉNITA"
  },
  {
    "codigo":767855004,
    "descripcion":"CARIES DENTAL SECUNDARIA INACTIVA QUE SE EXTIENDE HASTA LA PULPA"
  },
  {
    "codigo":276335005,
    "descripcion":"CADERA MANTENIDA EN ROTACIÓN EXTERNA"
  },
  {
    "codigo":15683881000119105,
    "descripcion":"BURSITIS ESCAPULOTORÁCICA DE AMBOS HOMBROS"
  },
  {
    "codigo":1259375008,
    "descripcion":"CARCINOMA VERRUGOSO PLANTAR PRIMARIO"
  },
  {
    "codigo":733252003,
    "descripcion":"LUXACIÓN TRAUMÁTICA DE ARTICULACIÓN MEDIOCARPIANA"
  },
  {
    "codigo":405572004,
    "descripcion":"ESTERNÓN INESTABLE"
  },
  {
    "codigo":208964007,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA NO EXPUESTA DE LA ARTICULACIÓN DE LA RODILLA, EXTERNA"
  },
  {
    "codigo":77892009,
    "descripcion":"TROMBOSIS VENOSA PULMONAR"
  },
  {
    "codigo":239897003,
    "descripcion":"SÍNDROME ANTIFOSFOLIPÍDICO SECUNDARIO CON COMPROMISO MULTIORGÁNICO"
  },
  {
    "codigo":403737003,
    "descripcion":"PORFIRIA POR HEXACLOROBENCENO"
  },
  {
    "codigo":895257006,
    "descripcion":"FORMA TRIANGULAR ANORMAL CONGÉNITA DE FALANGE DISTAL DE DEDO ANULAR"
  },
  {
    "codigo":8686000,
    "descripcion":"DISFUNCIÓN SEXUAL INDUCIDA POR COCAÍNA"
  },
  {
    "codigo":41454003,
    "descripcion":"MENINGITIS LINFOCÍTICA BENIGNA CRÓNICA"
  },
  {
    "codigo":762350007,
    "descripcion":"DEMENCIA DEBIDA A ENFERMEDAD POR PRIONES"
  },
  {
    "codigo":205294008,
    "descripcion":"HIPOTONÍA NEONATAL"
  },
  {
    "codigo":238062008,
    "descripcion":"ENFERMEDAD INFANTIL DE REFSUM"
  },
  {
    "codigo":400067002,
    "descripcion":"NEVUS EPIDÉRMICO ACANTOLÍTICO"
  },
  {
    "codigo":299928001,
    "descripcion":"DISCRIMINACIÓN TOCO-PINCHO ALTERADA"
  },
  {
    "codigo":234392002,
    "descripcion":"TALASEMIA BETA\/HEMOGLOBINA E"
  },
  {
    "codigo":398232005,
    "descripcion":"DOSIS DEL FÁRMACO"
  },
  {
    "codigo":168856006,
    "descripcion":"CISTOGRAFÍA NORMAL"
  },
  {
    "codigo":365464009,
    "descripcion":"EDAD DE COMIENZO ESCOLAR - HALLAZGO"
  },
  {
    "codigo":396397006,
    "descripcion":"INFILTRACIÓN DEL TUMOR POR LINFOCITOS ENÉRGICOS"
  },
  {
    "codigo":298093006,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE GLÚTEO"
  },
  {
    "codigo":296258001,
    "descripcion":"SOBREDOSIS DE DECANOATO DE FLUPENTIXOL"
  },
  {
    "codigo":230722002,
    "descripcion":"TROMBOSIS VENOSA CEREBRAL DE VENA CORTICAL"
  },
  {
    "codigo":197954003,
    "descripcion":"CÁLCULO URINARIO EN LA ESQUISTOSOMIASIS"
  },
  {
    "codigo":32279003,
    "descripcion":"HALLAZGO RELACIONADO CON MOVIMIENTO FETAL"
  },
  {
    "codigo":294423003,
    "descripcion":"ALERGIA A GLUTARALDEHÍDO"
  },
  {
    "codigo":718572004,
    "descripcion":"MIOPATÍA DE BETHLEM"
  },
  {
    "codigo":292588006,
    "descripcion":"REACCIÓN ADVERSA A LA CINARIZINA"
  },
  {
    "codigo":1275628006,
    "descripcion":"LESIÓN DE NERVIO PLANTAR LATERAL"
  },
  {
    "codigo":1144556009,
    "descripcion":"APLASIA DE PIEL DE TRONCO"
  },
  {
    "codigo":290753002,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR TAMOXIFENO"
  },
  {
    "codigo":11836151000119101,
    "descripcion":"LUXACIÓN EXPUESTA DE ARTICULACIÓN DE TARSO IZQUIERDO"
  },
  {
    "codigo":126913006,
    "descripcion":"NEOPLASIA DEL HOCICO DE TENCA"
  },
  {
    "codigo":94145009,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE HUESO CIGOMÁTICO"
  },
  {
    "codigo":419990005,
    "descripcion":"LÍNEA DE STOCKER"
  },
  {
    "codigo":92310007,
    "descripcion":"NEOPLASIA BENIGNA DEL ANTRO PILÓRICO"
  },
  {
    "codigo":713067002,
    "descripcion":"REGISTRO EN VÍDEO DE ENCUENTRO CON EL PACIENTE DISPONIBLE"
  },
  {
    "codigo":188779008,
    "descripcion":"NEOPLASIA BENIGNA DE FRENILLO DE LABIO SUPERIOR"
  },
  {
    "codigo":340881000119100,
    "descripcion":"EPÍFORA DE OJO IZQUIERDO DEBIDA A PRODUCCIÓN EXCESIVA DE LÁGRIMAS"
  },
  {
    "codigo":285248008,
    "descripcion":"SOBREGENERALIZACIÓN"
  },
  {
    "codigo":283413002,
    "descripcion":"CORTE EN EL CODO"
  },
  {
    "codigo":15741841000119101,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE AMBOS PIES"
  },
  {
    "codigo":840469002,
    "descripcion":"VALVA MURAL DE COMPONENTE VENTRICULAR IZQUIERDO DE VÁLVULA AURICULOVENTRICULAR COMÚN DEFICIENTE"
  },
  {
    "codigo":447253004,
    "descripcion":"ARACNOIDITIS TUBERCULOSA"
  },
  {
    "codigo":84970007,
    "descripcion":"TRASTORNO DE CARTÍLAGO ARTICULAR DE TOBILLO Y\/O PIE"
  },
  {
    "codigo":281578009,
    "descripcion":"ASFIXIA PERINATAL"
  },
  {
    "codigo":246975001,
    "descripcion":"ESCLERÓTICAS ICTÉRICAS"
  },
  {
    "codigo":50367001,
    "descripcion":"EDAD GESTACIONAL, 11 SEMANAS"
  },
  {
    "codigo":771263004,
    "descripcion":"SÍNDROME DE PTOSIS Y PARÁLISIS DE CUERDAS VOCALES"
  },
  {
    "codigo":1230015008,
    "descripcion":"ANGIOEDEMA HEREDITARIO CON DEFICIENCIA DE INHIBIDOR DE C1 ESTERASA"
  },
  {
    "codigo":277908001,
    "descripcion":"ESPUTO VERDE"
  },
  {
    "codigo":212372004,
    "descripcion":"EMBOLIA GRASA"
  },
  {
    "codigo":48532005,
    "descripcion":"DISTENSIÓN MUSCULAR"
  },
  {
    "codigo":1162644007,
    "descripcion":"REACCIÓN ADVERSA A VACUNA PROTEÍNA DE ESPIGA RECOMBINANTE CONTRA COVID-19"
  },
  {
    "codigo":1259113002,
    "descripcion":"OTORREA DE LÍQUIDO CEFALORRAQUÍDEO DEBIDA A OTITIS MEDIA"
  },
  {
    "codigo":439913002,
    "descripcion":"INFECCIÓN GENITAL RECURRENTE POR HERPES SIMPLEX TIPO 2"
  },
  {
    "codigo":276073003,
    "descripcion":"INTIMIDADO EN EL TRABAJO"
  },
  {
    "codigo":208702001,
    "descripcion":"FRACTURA EXPUESTA DE CABEZA METATARSIANA"
  },
  {
    "codigo":765758008,
    "descripcion":"ENANISMO PRIMORDIAL MICROCEFÁLICO TIPO MONTREAL"
  },
  {
    "codigo":1222675000,
    "descripcion":"DESMOSIS COLI PRIMARIA"
  },
  {
    "codigo":403475002,
    "descripcion":"NEOPLASIA INTRAEPITELIAL VULVAR CON LIQUEN ESCLEROSO"
  },
  {
    "codigo":40191000087104,
    "descripcion":"HERIDA ABIERTA DE PIE DERECHO POR MORDEDURA"
  },
  {
    "codigo":237800001,
    "descripcion":"INFERTILIDAD FEMENINA DE CAUSA ENDOCRINA"
  },
  {
    "codigo":47871000087107,
    "descripcion":"FRACTURA DE DÉCIMA COSTILLA DERECHA"
  },
  {
    "codigo":42751000087109,
    "descripcion":"DISCO INTERVERTEBRAL TORÁCICO PROLAPSADO, T4-T5"
  },
  {
    "codigo":1351912007,
    "descripcion":"HEMANGIOBLASTOMA DE HUESO"
  },
  {
    "codigo":301501003,
    "descripcion":"DIFICULTAD PARA MOVILIZARSE EN EL INTERIOR DE UN LUGAR"
  },
  {
    "codigo":39357005,
    "descripcion":"TAQUICARDIA AURICULAR PAROXÍSTICA CON BLOQUEO"
  },
  {
    "codigo":203197006,
    "descripcion":"OSTEOMIELITIS CRÓNICA DEL CÓCCIX"
  },
  {
    "codigo":299666001,
    "descripcion":"ESTRÍA UNGUEAL TRANSVERSAL"
  },
  {
    "codigo":1348242002,
    "descripcion":"PATRÓN DE USO NOCIVO CONTINUO DE SUSTANCIA SIN DEPENDENCIA"
  },
  {
    "codigo":37522003,
    "descripcion":"DETERMINACIÓN DEL RESULTADO: MUERTE INEVITABLE"
  },
  {
    "codigo":234130003,
    "descripcion":"MALFORMACIÓN VENOSA ESPONJOSA"
  },
  {
    "codigo":4754008,
    "descripcion":"GINECOMASTIA"
  },
  {
    "codigo":232295001,
    "descripcion":"BAROTRAUMA VESTIBULAR"
  },
  {
    "codigo":363367000,
    "descripcion":"NEOPLASIA MALIGNA DE VULVA"
  },
  {
    "codigo":365202008,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA CORTARSE LAS UÑAS DE LOS PIES"
  },
  {
    "codigo":2919008,
    "descripcion":"NÁUSEAS, VÓMITOS Y DIARREA"
  },
  {
    "codigo":33852001,
    "descripcion":"BLOQUEO NEUROMUSCULAR PROLONGADO"
  },
  {
    "codigo":66620003,
    "descripcion":"NECROSIS HIALINA DE LA AORTA"
  },
  {
    "codigo":295996004,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE CARBAMAZEPINA"
  },
  {
    "codigo":197692004,
    "descripcion":"SÍNDROME NEFRÍTICO RÁPIDAMENTE PROGRESIVO, GLOMERULONEFRITIS MEMBRANOSA DIFUSA"
  },
  {
    "codigo":164924006,
    "descripcion":"ELECTROCARDIOGRAMA: ONDA S NORMAL"
  },
  {
    "codigo":263228009,
    "descripcion":"FRACTURA BASICERVICAL DE CUELLO DE FÉMUR"
  },
  {
    "codigo":11838661000119107,
    "descripcion":"LACERACIÓN DE MÚSCULO INTRÍNSECO DE DEDO ÍNDICE DERECHO"
  },
  {
    "codigo":493921000000107,
    "descripcion":"NECESITA ENFERMERA COMUNITARIA PARA ADMINISTRAR MEDICACIÓN"
  },
  {
    "codigo":194022000,
    "descripcion":"DEFORMIDAD ORBITARIA LOCAL ASOCIADA CON OSTEOPATÍA"
  },
  {
    "codigo":1177062005,
    "descripcion":"INSOMNIO FATAL ESPORÁDICO"
  },
  {
    "codigo":292326006,
    "descripcion":"REACCIÓN ADVERSA A LA VIGABATRINA"
  },
  {
    "codigo":62950007,
    "descripcion":"ENCEFALOMIELITIS"
  },
  {
    "codigo":30182008,
    "descripcion":"TROMBOCITOPENIA POR CIRCULACIÓN EXTRACORPÓREA"
  },
  {
    "codigo":95718009,
    "descripcion":"RUPTURA DEL CRISTALINO"
  },
  {
    "codigo":290491001,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR KETAMINA"
  },
  {
    "codigo":1339067004,
    "descripcion":"FRACTURA DE FALANGE DE CUARTO DEDO DE PIE"
  },
  {
    "codigo":716475005,
    "descripcion":"DIFICULTAD PARA COMPRENDER EL HABLA"
  },
  {
    "codigo":93883004,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE GLÁNDULA SALIVAL MAYOR"
  },
  {
    "codigo":126651008,
    "descripcion":"NEOPLASIA DE HOMBRO"
  },
  {
    "codigo":288656001,
    "descripcion":"DIFICULTAD PARA SUMARSE A UNA CONVERSACIÓN"
  },
  {
    "codigo":419728003,
    "descripcion":"CIRROSIS PORTAL"
  },
  {
    "codigo":12113401000119100,
    "descripcion":"QUEMADURA QUÍMICA DE PARED ABDOMINAL"
  },
  {
    "codigo":92048008,
    "descripcion":"NEOPLASIA BENIGNA DEL SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":417893002,
    "descripcion":"DEFORMIDAD"
  },
  {
    "codigo":188517003,
    "descripcion":"LINFOMA DE BURKITT DE GANGLIOS LINFÁTICOS DE MÚLTIPLES LOCALIZACIONES"
  },
  {
    "codigo":286821009,
    "descripcion":"TIENDE A SER EXCESIVAMENTE INDEPENDIENTE EN EL ASPECTO PSICOLÓGICO"
  },
  {
    "codigo":284986003,
    "descripcion":"INCAPAZ DE DESVESTIRSE"
  },
  {
    "codigo":446991001,
    "descripcion":"NEFRONOPTISIS TIPO 5"
  },
  {
    "codigo":21007002,
    "descripcion":"ENFERMEDAD DE WERNICKE"
  },
  {
    "codigo":184847004,
    "descripcion":"SEGURO DE VIDA - FORMULARIOS RECIBIDOS"
  },
  {
    "codigo":283151007,
    "descripcion":"CUERPO EXTRAÑO METÁLICO EN EL CUELLO"
  },
  {
    "codigo":11785721000119105,
    "descripcion":"ABRASIÓN DE PIEL DE DEDO ANULAR IZQUIERDO"
  },
  {
    "codigo":445156001,
    "descripcion":"FIBROSIS DE TEJIDO CELULAR SUBCUTÁNEO"
  },
  {
    "codigo":215780002,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR GASES O HUMOS A BORDO DE EMBARCACIÓN"
  },
  {
    "codigo":1231588004,
    "descripcion":"OBSTRUCCIÓN DE LUZ DE VÍA RESPIRATORIA CAUSADA POR INHALACIÓN DE GOLOSINA"
  },
  {
    "codigo":1295289001,
    "descripcion":"ICTERICIA PERINATAL MATERNA"
  },
  {
    "codigo":248548009,
    "descripcion":"DISNEA NOCTURNA"
  },
  {
    "codigo":838372009,
    "descripcion":"NEOPLASIA INTRAEPITELIAL PLANA DE ALTO GRADO DE AMPOLLA DE VATER"
  },
  {
    "codigo":17337006,
    "descripcion":"ARTERIA DOBLE"
  },
  {
    "codigo":246713009,
    "descripcion":"CONVERGENCIA EN EL ESTRABISMO MANIFIESTO, INTERSECCIÓN POR FUSIÓN DE LOS EJES VISUALES"
  },
  {
    "codigo":703630003,
    "descripcion":"OJO ROJO"
  },
  {
    "codigo":212110006,
    "descripcion":"QUEMADURA QUE COMPROMETE 80-89 PORCIENTO DE LA SUPERFICIE DEL CUERPO, CON QUEMADURA DE ESPESOR COMPLETO QUE AFECTA 60-69 PORCIENTO DE LA SUPERFICIE CORPORAL"
  },
  {
    "codigo":111971002,
    "descripcion":"PRESIÓN VENOSA ANORMAL"
  },
  {
    "codigo":243043005,
    "descripcion":"LESIÓN TRAUMÁTICA DEBIDA A EXPOSICIÓN DIRECTA A RADIACIÓN IONIZANTE DE EXPLOSIÓN NUCLEAR"
  },
  {
    "codigo":308579005,
    "descripcion":"SITUACIÓN DE EVALUACIÓN PARA SEGURO DE VIDA"
  },
  {
    "codigo":208440002,
    "descripcion":"FRACTURA NO EXPUESTA DE LA FALANGE DISTAL DEL PULGAR, BASE"
  },
  {
    "codigo":306744002,
    "descripcion":"CAPAZ DE MOVER LOS LABIOS SIMÉTRICAMENTE"
  },
  {
    "codigo":110136005,
    "descripcion":"LACERACIÓN COMPLEJA DE AMÍGDALA PALATINA"
  },
  {
    "codigo":44600005,
    "descripcion":"XERODERMIA PIGMENTOSA"
  },
  {
    "codigo":403213004,
    "descripcion":"ERITEMA MULTIFORME POR NEOPLASIA MALIGNA"
  },
  {
    "codigo":1351650004,
    "descripcion":"INMUNODEFICIENCIA COMBINADA AUTOSÓMICA RECESIVA DEBIDA A MUTACIÓN DE SUBUNIDAD NF-KB DE PROTO-ONCOGEN RELB"
  },
  {
    "codigo":237538007,
    "descripcion":"TIROIDITIS CRÓNICA CON TIROTOXICOSIS TRANSITORIA"
  },
  {
    "codigo":40930008,
    "descripcion":"HIPOTIROIDISMO"
  },
  {
    "codigo":673581000119104,
    "descripcion":"PSEUDOARTROSIS POSTERIOR A FUSIÓN ESPINAL"
  },
  {
    "codigo":268471004,
    "descripcion":"SANGRADO VAGINAL"
  },
  {
    "codigo":301239007,
    "descripcion":"CAPAZ DE ELIMINAR EL ESPUTO"
  },
  {
    "codigo":397708000,
    "descripcion":"PARTICIPA DEL PROCESO DE REHABILITACIÓN"
  },
  {
    "codigo":70028003,
    "descripcion":"PRESENTACIÓN CEFÁLICA DE VÉRTICE"
  },
  {
    "codigo":430476004,
    "descripcion":"PANBRONQUIOLITIS DIFUSA"
  },
  {
    "codigo":233868005,
    "descripcion":"MIOCARDITIS FÚNGICA"
  },
  {
    "codigo":37260006,
    "descripcion":"TUBERCULOSIS CONGÉNITA"
  },
  {
    "codigo":364940007,
    "descripcion":"HALLAZGO EN LA PREFERENCIA MANUAL"
  },
  {
    "codigo":723553000,
    "descripcion":"DERMÓLISIS BULLOSA TRANSITORIA DEL RECIÉN NACIDO"
  },
  {
    "codigo":299404008,
    "descripcion":"PRUEBA PARA ACCIDENTE CEREBROVASCULAR NEGATIVA"
  },
  {
    "codigo":232033003,
    "descripcion":"RETINOPATÍA DE CÉLULAS FALCIFORMES-HEMOGLOBINA C"
  },
  {
    "codigo":35425004,
    "descripcion":"ÍNDICE DE MASA CORPORAL NORMAL"
  },
  {
    "codigo":68193004,
    "descripcion":"SIGNO DE THOMAS"
  },
  {
    "codigo":2657005,
    "descripcion":"PROTEINURIA POR SOBRECARGA"
  },
  {
    "codigo":461409008,
    "descripcion":"ANOMALÍA ADQUIRIDA DE VENA FEMORAL DERECHA"
  },
  {
    "codigo":721718003,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE AMPOLLA DE VATER"
  },
  {
    "codigo":33590004,
    "descripcion":"VÍNCULO MADRE - HIJO DÉBIL"
  },
  {
    "codigo":230198004,
    "descripcion":"MIELITIS TRANSVERSA POR VARICELA"
  },
  {
    "codigo":262966007,
    "descripcion":"DESGARRO MUSCULAR"
  },
  {
    "codigo":361270009,
    "descripcion":"VÉRTIGO RECURRENTE EPISÓDICO"
  },
  {
    "codigo":228363003,
    "descripcion":"SIENTE QUE LA BEBIDA ESTÁ FUERA DE CONTROL"
  },
  {
    "codigo":293899008,
    "descripcion":"ALERGIA A OXAZEPAM"
  },
  {
    "codigo":292064003,
    "descripcion":"REACCIÓN ADVERSA A MEPERIDINA"
  },
  {
    "codigo":423136007,
    "descripcion":"DIFICULTAD PARA AFRONTAR LAS RESPUESTAS DE DUELO"
  },
  {
    "codigo":128224008,
    "descripcion":"ANOMALÍA CONGÉNITA DE MAXILAR INFERIOR"
  },
  {
    "codigo":28085001,
    "descripcion":"EMPIEMA CON FÍSTULA BRONCOPLEURAL"
  },
  {
    "codigo":93621002,
    "descripcion":"FALTA DE OSIFICACIÓN DE ARCO DE VÉRTEBRA SACRA"
  },
  {
    "codigo":60853003,
    "descripcion":"TRASTORNO DEL METABOLISMO DEL MAGNESIO"
  },
  {
    "codigo":95456009,
    "descripcion":"ISQUEMIA DEL TRONCO ENCEFÁLICO"
  },
  {
    "codigo":288394009,
    "descripcion":"CAPAZ DE DARLE CUERDA AL RELOJ"
  },
  {
    "codigo":253791005,
    "descripcion":"SÍNDROME CONGÉNITO DEL ASA CIEGA"
  },
  {
    "codigo":712543006,
    "descripcion":"CON ABSTINENCIA DE USO INAPROPIADO DE DROGAS EN AMBIENTE NORMAL"
  },
  {
    "codigo":1236831007,
    "descripcion":"ÚLCERA DE PIERNA DEBIDA A HIPERTENSIÓN ARTERIAL"
  },
  {
    "codigo":186420000,
    "descripcion":"GANGRENA GASEOSA DE REGIÓN PÉLVICA DEL TRONCO"
  },
  {
    "codigo":1234996002,
    "descripcion":"TRASTORNO FETAL DEBIDO A INSERCIÓN VELAMENTOSA DE CORDÓN UMBILICAL"
  },
  {
    "codigo":251956004,
    "descripcion":"PRUEBA UROLÓGICA - HALLAZGO"
  },
  {
    "codigo":88116004,
    "descripcion":"FRACTURA EXPUESTA DEL EXTREMO INFERIOR DE RADIO Y CÚBITO"
  },
  {
    "codigo":20745002,
    "descripcion":"INTOXICACIÓN POR FOSFURO DE CINC"
  },
  {
    "codigo":250121005,
    "descripcion":"DERRAME MODERADO EN LA RODILLA"
  },
  {
    "codigo":282889005,
    "descripcion":"INCAPAZ DE PARARSE DESDE LA POSICIÓN SENTADA"
  },
  {
    "codigo":16077051000119102,
    "descripcion":"DEPENDENCIA DE TABACO CAUSADA POR CIGARRILLOS EN REMISIÓN"
  },
  {
    "codigo":18910001,
    "descripcion":"FISURA DE LA ÚVULA"
  },
  {
    "codigo":1264094009,
    "descripcion":"TRASTORNO NEONATAL CAUSADO POR AGENTE HIPOGLUCEMIANTE TRANSMITIDO POR LECHE MATERNA"
  },
  {
    "codigo":1085691000119104,
    "descripcion":"ESTENOSIS CONGÉNITA DE RECTO"
  },
  {
    "codigo":304281000119100,
    "descripcion":"GOTA TOFÁCEA CRÓNICA DE HOMBRO DEBIDA A DISFUNCIÓN RENAL"
  },
  {
    "codigo":311961000119100,
    "descripcion":"OSTEOCONDROSIS JUVENIL DEL TARSO DERECHO"
  },
  {
    "codigo":197452441000119101,
    "descripcion":"DERMATOSIS GLÚTEA SENIL"
  },
  {
    "codigo":112281000119102,
    "descripcion":"CONSUMO EXCESIVO DE LECHE EN LA INFANCIA"
  },
  {
    "codigo":16317081000119100,
    "descripcion":"MASTITIS PURULENTA DE MAMA DERECHA DURANTE LA LACTANCIA"
  },
  {
    "codigo":11837081000119105,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE CADERA DERECHA"
  },
  {
    "codigo":309401000119105,
    "descripcion":"NECROSIS AVASCULAR DE CÚBITO DERECHO"
  },
  {
    "codigo":10959001000119107,
    "descripcion":"HERIDA ABIERTA DE MANO DERECHA DEBIDA A MORDEDURA HUMANA"
  },
  {
    "codigo":11778201000119108,
    "descripcion":"DISTENSIÓN DE MÚSCULO Y\/O TENDÓN SUBESCAPULAR IZQUIERDO"
  },
  {
    "codigo":1082521000119109,
    "descripcion":"GINGIVITIS AGUDA DEBIDA A ENFERMEDAD GINGIVAL NO INDUCIDA POR PLACA"
  },
  {
    "codigo":291481000119105,
    "descripcion":"HEMORRAGIA ESPONTÁNEA DE ARTERIA COMUNICANTE POSTERIOR DERECHA EN ESPACIO SUBARACNOIDEO"
  },
  {
    "codigo":16468121000119106,
    "descripcion":"INFECCIÓN POR VIRUS ZIKA DURANTE EMBARAZO"
  },
  {
    "codigo":10692761000119107,
    "descripcion":"SÍNDROME DE SUPERPOSICIÓN DE ASMA-ENFERMEDAD PULMONAR OBSTRUCTIVA CRÓNICA"
  },
  {
    "codigo":1079961000119108,
    "descripcion":"NEVO EPIDÉRMICO DE PIEL DE OREJA DERECHA"
  },
  {
    "codigo":89241000119108,
    "descripcion":"DEPENDENCIA DE OXIGENOTERAPIA NOCTURNA"
  },
  {
    "codigo":48008009,
    "descripcion":"MANO VARA"
  },
  {
    "codigo":135321000119107,
    "descripcion":"HIPERSOMNIA CAUSADA POR ALCOHOL"
  },
  {
    "codigo":299161000119109,
    "descripcion":"HEMARTROSIS DE RODILLA DERECHA"
  },
  {
    "codigo":337561000119109,
    "descripcion":"GLAUKOMFLECKEN DE OJO IZQUIERDO"
  },
  {
    "codigo":111709005,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DEL ESCROTO, CON INFECCIÓN"
  },
  {
    "codigo":1293192009,
    "descripcion":"ARTERIOSCLEROSIS CORONARIA PREMATURA"
  },
  {
    "codigo":406621006,
    "descripcion":"INFECCIÓN CAUSADA POR VIBRIO"
  },
  {
    "codigo":372018003,
    "descripcion":"NEOPLASIA MALIGNA DE LA COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":109874003,
    "descripcion":"NEOPLASIA SUPERPUESTA MALIGNA DE ÓRGANOS GENITALES MASCULINOS"
  },
  {
    "codigo":77106003,
    "descripcion":"VAGINITIS GRANULOSA"
  },
  {
    "codigo":239111001,
    "descripcion":"NEVO ESTRIADO SIMÉTRICO DEL PULGAR"
  },
  {
    "codigo":304647001,
    "descripcion":"DIFICULTAD PARA REALIZAR UNA SECUENCIA LÓGICA"
  },
  {
    "codigo":1254919001,
    "descripcion":"DERMATITIS DE CONTACTO IRRITATIVA DE PIEL DE CUERO CABELLUDO"
  },
  {
    "codigo":402951004,
    "descripcion":"LESIÓN DE MUCOSA BUCAL POR SÍFILIS TARDÍA"
  },
  {
    "codigo":237276000,
    "descripcion":"HEMORRAGIA PREPARTO INDETERMINADA"
  },
  {
    "codigo":1187548001,
    "descripcion":"DEFICIENCIA DE PEX5"
  },
  {
    "codigo":302812006,
    "descripcion":"INFECCIÓN ANOGENITAL POR PAPILOMA EN EL HUMANO"
  },
  {
    "codigo":40668007,
    "descripcion":"DEFORMIDAD MUSCULOESQUELÉTICA ADQUIRIDA"
  },
  {
    "codigo":401116008,
    "descripcion":"USA CINTURÓN DE SEGURIDAD"
  },
  {
    "codigo":204508009,
    "descripcion":"ATRESIA DE COANAS"
  },
  {
    "codigo":366513004,
    "descripcion":"REFLEJO CREMASTÉRICO - HALLAZGO"
  },
  {
    "codigo":169905005,
    "descripcion":"PUNTAJE DE APGAR AL MINUTO = 8"
  },
  {
    "codigo":299142008,
    "descripcion":"AMPLITUD DE FLEXIÓN ACTIVA DEL PULGAR AUMENTADA"
  },
  {
    "codigo":233606009,
    "descripcion":"NEUMONÍA ATÍPICA"
  },
  {
    "codigo":295471000119105,
    "descripcion":"CALCIFICACIÓN Y OSIFICACIÓN DE MÚSCULO DE TOBILLO DEBIDA A QUEMADURA"
  },
  {
    "codigo":297307009,
    "descripcion":"AGOTAMIENTO PLAQUETARIO"
  },
  {
    "codigo":262704003,
    "descripcion":"EDEMA DE MÉDULA ESPINAL SACRA"
  },
  {
    "codigo":786992004,
    "descripcion":"BREVIBACILLUS AGRI O BREVIBACILLUS BREVIS"
  },
  {
    "codigo":721456003,
    "descripcion":"SÍNDROME DEL CORDÓN ANTERIOR DE MÉDULA ESPINAL AL NIVEL DEL PRIMER SEGMENTO DORSAL"
  },
  {
    "codigo":129797000,
    "descripcion":"ENGROSAMIENTO DE LA PIEL DE LA MAMA"
  },
  {
    "codigo":293637006,
    "descripcion":"ALERGIA A MEDIO DE CONTRASTE"
  },
  {
    "codigo":29658002,
    "descripcion":"AUSENCIA DE APORTE DE OXÍGENO"
  },
  {
    "codigo":291802003,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR INSULINA"
  },
  {
    "codigo":1078234008,
    "descripcion":"AGENESIA DE EPÍFISIS DE FALANGE DISTAL DE MANO"
  },
  {
    "codigo":224431002,
    "descripcion":"MÁQUINA EXPENDEDORA ADECUADA EN EL TRABAJO"
  },
  {
    "codigo":1088201000119104,
    "descripcion":"OTITIS MEDIA SEROSA ALÉRGICA AGUDA DE OÍDO MEDIO IZQUIERDO"
  },
  {
    "codigo":93359004,
    "descripcion":"POSICIÓN ANÓMALA CONGÉNITA DE LA GLÁNDULA TIROIDES"
  },
  {
    "codigo":421039005,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA PROXIMAL COMPROMETIDO POR ADENOMA"
  },
  {
    "codigo":715951007,
    "descripcion":"SÍNDROME ACROCALLOSO"
  },
  {
    "codigo":58756001,
    "descripcion":"COREA DE HUNTINGTON"
  },
  {
    "codigo":253529002,
    "descripcion":"ANOMALÍA DEL TRACTO DE SALIDA DEL VENTRÍCULO DERECHO"
  },
  {
    "codigo":1269337005,
    "descripcion":"SUBLUXACIÓN DE PRÓTESIS DE ARTICULACIÓN DE RODILLA"
  },
  {
    "codigo":384601007,
    "descripcion":"RESPUESTA LINFOCÍTICA INTRATUMORAL\/PERITUMORAL AUSENTE"
  },
  {
    "codigo":89689008,
    "descripcion":"GENU VALGO CONGÉNITO"
  },
  {
    "codigo":15669961000119108,
    "descripcion":"LUXACIÓN CONGÉNITA DE CABEZA DE RADIO IZQUIERDO"
  },
  {
    "codigo":350921000119109,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE GLÁNDULA SUPRARRENAL IZQUIERDA"
  },
  {
    "codigo":249859001,
    "descripcion":"POSTURA FLÁCCIDA"
  },
  {
    "codigo":774147002,
    "descripcion":"ENFERMEDAD DE CHARCOT-MARIE-TOOTH TIPO 2R"
  },
  {
    "codigo":446467002,
    "descripcion":"RUPTURA DE MEMBRANA DE BOWMAN"
  },
  {
    "codigo":315395001,
    "descripcion":"NACIDO EN BURUNDI"
  },
  {
    "codigo":282627007,
    "descripcion":"INCAPAZ DE RODAR HACIA UN COSTADO"
  },
  {
    "codigo":248024008,
    "descripcion":"TIEMPO DE REACCIÓN RETARDADO - HALLAZGO"
  },
  {
    "codigo":16813005,
    "descripcion":"HIPERURICOSURIA"
  },
  {
    "codigo":277122000,
    "descripcion":"ASIMETRÍA INTERHEMISFÉRICA CRUZADA DE LA ONDA"
  },
  {
    "codigo":768642000,
    "descripcion":"CARIES CORONAL NO ACTIVA EN ESTADIO INICIAL"
  },
  {
    "codigo":211586002,
    "descripcion":"LESIÓN TRAUMÁTICA ABIERTA POR APLASTAMIENTO, PULGAR"
  },
  {
    "codigo":735874003,
    "descripcion":"LACERACIÓN DE DEDO DEL PIE CON CUERPO EXTRAÑO"
  },
  {
    "codigo":11848701000119104,
    "descripcion":"CONTUSIÓN PERIORBITARIA DERECHA"
  },
  {
    "codigo":111447004,
    "descripcion":"TRASTORNO PLACENTARIO, QUE AFECTA EL MANEJO DE LA SITUACIÓN MATERNA"
  },
  {
    "codigo":373591006,
    "descripcion":"TRASTORNOS DE PIEL CAUSADOS POR AGENTES FÍSICOS"
  },
  {
    "codigo":439127006,
    "descripcion":"TROMBOSIS"
  },
  {
    "codigo":11308001,
    "descripcion":"SUSTITUCIÓN FONATORIA COMPENSATORIA"
  },
  {
    "codigo":295432008,
    "descripcion":"SOBREDOSIS DE BISACODILO"
  },
  {
    "codigo":76844004,
    "descripcion":"INFECCIÓN LOCAL DE HERIDA"
  },
  {
    "codigo":404524008,
    "descripcion":"HALLAZGO DE BACILOS PARCIALMENTE ACIDORRESISTENTES"
  },
  {
    "codigo":109612009,
    "descripcion":"CELULITIS DENTOALVEOLAR"
  },
  {
    "codigo":371756009,
    "descripcion":"ATROFIA GENERALIZADA DEL IRIS"
  },
  {
    "codigo":1254657004,
    "descripcion":"ESTENOSIS DE PORCIÓN PROXIMAL DE ARTERIA CORONARIA DERECHA"
  },
  {
    "codigo":75009007,
    "descripcion":"DIVERTÍCULO POR TRACCIÓN ADQUIRIDO DEL ESÓFAGO"
  },
  {
    "codigo":9473008,
    "descripcion":"DEPÓSITO DE TABACO SOBRE LOS DIENTES"
  },
  {
    "codigo":402689007,
    "descripcion":"PANICULITIS POR FACTOR FÍSICO"
  },
  {
    "codigo":1285590007,
    "descripcion":"INFECCIÓN DE INTESTINO CAUSADA POR CLOSTRIDIUM BOTULINUM"
  },
  {
    "codigo":366251003,
    "descripcion":"TONO DEL ESFÍNTER ANAL - HALLAZGO"
  },
  {
    "codigo":300715005,
    "descripcion":"ELABORA UN PRESUPUESTO"
  },
  {
    "codigo":169643005,
    "descripcion":"INTENCIÓN SOBRE LA ALIMENTACIÓN DEL RECIÉN NACIDO - PECHO"
  },
  {
    "codigo":202411007,
    "descripcion":"HEMARTROSIS DE LA CADERA"
  },
  {
    "codigo":724864003,
    "descripcion":"RADIODERMATITIS AGUDA DEBIDA A RADIOTERAPIA Y POSTERIOR A ELLA"
  },
  {
    "codigo":16000151000119106,
    "descripcion":"SÍNDROME DE IRIS EN MESETA DE OJO DERECHO"
  },
  {
    "codigo":460885001,
    "descripcion":"TORTUOSIDAD DE ARTERIA SISTÉMICA"
  },
  {
    "codigo":231509001,
    "descripcion":"ASTASIA-ABASIA DISOCIATIVA"
  },
  {
    "codigo":297045003,
    "descripcion":"SOBREDOSIS INTENCIONAL DE ACETAZOLAMIDA"
  },
  {
    "codigo":295210001,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE LEVORFANOL"
  },
  {
    "codigo":426282002,
    "descripcion":"DISPOSICIÓN PARA MEJORAR EL CONCEPTO DE SÍ MISMO"
  },
  {
    "codigo":721194008,
    "descripcion":"NEOPLASIA NEUROENDOCRINA DE ESTÓMAGO"
  },
  {
    "codigo":195071001,
    "descripcion":"TAQUICARDIA PAROXÍSTICA DE LA UNIÓN"
  },
  {
    "codigo":293375004,
    "descripcion":"REACCIÓN ADVERSA A LA L-CARNITINA"
  },
  {
    "codigo":291540005,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR CLOXACILINA"
  },
  {
    "codigo":94932006,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE HUESO METACARPIANO"
  },
  {
    "codigo":783060009,
    "descripcion":"SÍNDROME DE ATAXIA CEREBELOSA AUTOSÓMICA RECESIVA Y RETRASO PSICOMOTOR"
  },
  {
    "codigo":27561001,
    "descripcion":"CELULITIS DE DEDO DE LA MANO"
  },
  {
    "codigo":224169004,
    "descripcion":"SIN INGRESO FAMILIAR"
  },
  {
    "codigo":289705005,
    "descripcion":"CONTRACCIONES UTERINAS INTERMITENTES"
  },
  {
    "codigo":713854001,
    "descripcion":"SEPSIS PERINATAL"
  },
  {
    "codigo":1172606002,
    "descripcion":"FIBROELASTOSIS PLEUROPARENQUIMATOSA IDIOPÁTICA"
  },
  {
    "codigo":25726008,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN LA REGIÓN DE LA INGLE, CON INFECCIÓN"
  },
  {
    "codigo":23891001,
    "descripcion":"PROTEINURIA FEBRIL"
  },
  {
    "codigo":1269075002,
    "descripcion":"TRASTORNO MATERNO DURANTE TRABAJO DE PARTO"
  },
  {
    "codigo":253267000,
    "descripcion":"ANOMALÍA CONGÉNITA DE RELACIÓN DE COMPONENTE CARDÍACO"
  },
  {
    "codigo":449875001,
    "descripcion":"DIENTE INFERIOR CADUCO SUPERNUMERARIO"
  },
  {
    "codigo":124030008,
    "descripcion":"YODO LIGADO A PROTEÍNAS POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":286035007,
    "descripcion":"INCAPAZ DE CUIDAR LA ROPA"
  },
  {
    "codigo":284200001,
    "descripcion":"QUEMADURA SUPERFICIAL DEL OÍDO POR AGENTE CORROSIVO"
  },
  {
    "codigo":87592007,
    "descripcion":"LUXACIONES TRAUMÁTICAS NO EXPUESTAS MÚLTIPLES DE ARTICULACIONES DE MANO"
  },
  {
    "codigo":448040009,
    "descripcion":"OSTEOCONDRITIS DISECANTE DE TIBIA"
  },
  {
    "codigo":184061005,
    "descripcion":"ESTADO DE REGISTRO DEL PACIENTE"
  },
  {
    "codigo":249597005,
    "descripcion":"HALLAZGO DE RECTO"
  },
  {
    "codigo":413437007,
    "descripcion":"ESOTROPÍA AGUDA"
  },
  {
    "codigo":247762003,
    "descripcion":"PERÍODO DE CONCENTRACIÓN REDUCIDO"
  },
  {
    "codigo":51154004,
    "descripcion":"COMPLICACIÓN PULMONAR OBSTÉTRICA POR LA ANESTESIA Y\/O SEDACIÓN"
  },
  {
    "codigo":870354005,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN CUTÁNEA NEONATAL"
  },
  {
    "codigo":409767000,
    "descripcion":"TUMOR CONTENIDO POR CÁPSULA DE ÓRGANO"
  },
  {
    "codigo":83922009,
    "descripcion":"ABORTO ESPONTÁNEO CON PARAMETRITIS"
  },
  {
    "codigo":278695009,
    "descripcion":"ASPIRACIÓN DE SANGRE EN LAS VÍAS RESPIRATORIAS INFERIORES"
  },
  {
    "codigo":276860003,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS DEL ESCROTO"
  },
  {
    "codigo":897617003,
    "descripcion":"FORMA DE CONO ANORMAL CONGÉNITA DE EPÍFISIS DE FALANGE SEGUNDO DEDO DE PIE"
  },
  {
    "codigo":209489004,
    "descripcion":"LESIÓN DE PLACA PALMAR DE ARTICULACIÓN INTERFALÁNGICA PROXIMAL DE DEDO DE LA MANO"
  },
  {
    "codigo":43814000,
    "descripcion":"ATELOSTEOGÉNESIS"
  },
  {
    "codigo":240422004,
    "descripcion":"DIFTERIA TRAQUEOBRONQUIAL"
  },
  {
    "codigo":109350007,
    "descripcion":"LIPOMA DE LA PIEL Y DEL TEJIDO CELULAR SUBCUTÁNEO DEL TRONCO"
  },
  {
    "codigo":402427003,
    "descripcion":"NODULOSIS REUMATOIDE ACELERADA"
  },
  {
    "codigo":238587006,
    "descripcion":"PRURIGO CRÓNICO"
  },
  {
    "codigo":271355007,
    "descripcion":"VÓMITO: PARÁSITOS PRESENTES"
  },
  {
    "codigo":205819008,
    "descripcion":"SÍNDROME DE PTERIGIÓN MÚLTIPLE"
  },
  {
    "codigo":1791000119105,
    "descripcion":"ESGUINCE DE TOBILLO DE PRIMER GRADO"
  },
  {
    "codigo":369659008,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA DE VASCULATURA PULMONAR, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":40144003,
    "descripcion":"RIGIDEZ MATUTINA - ARTICULAR"
  },
  {
    "codigo":105680004,
    "descripcion":"ENFERMEDAD CAUSADA POR CESTODO DE CYCLOPHYLLIDEA"
  },
  {
    "codigo":302288005,
    "descripcion":"COORDINACIÓN NORMAL"
  },
  {
    "codigo":300453004,
    "descripcion":"VEJIGA URINARIA AUSENTE"
  },
  {
    "codigo":298618000,
    "descripcion":"AMPLITUD DE EXTENSIÓN PASIVA DE LA COLUMNA LUMBAR NORMAL"
  },
  {
    "codigo":365989009,
    "descripcion":"HALLAZGO RELACIONADO CON LA FASE DE LA FIEBRE"
  },
  {
    "codigo":396922003,
    "descripcion":"TUMOR DEL SISTEMA NERVIOSO CENTRAL, GRADO I DE LA OMS"
  },
  {
    "codigo":724602004,
    "descripcion":"VASCULITIS DE ÚNICO ÓRGANO"
  },
  {
    "codigo":1052282008,
    "descripcion":"SÍNDROME DE PIERNAS INQUIETAS DEBIDO A UREMIA"
  },
  {
    "codigo":36474008,
    "descripcion":"DEPRESIÓN MAYOR RECURRENTE GRAVE SIN SÍNTOMAS PSICÓTICOS"
  },
  {
    "codigo":429690008,
    "descripcion":"INTIMIDACIÓN DE ADULTO"
  },
  {
    "codigo":34639003,
    "descripcion":"INTOXICACIÓN POR PRUNUS SEROTINA"
  },
  {
    "codigo":1148751009,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR ESTRÓGENO Y\/O PROGESTÁGENO"
  },
  {
    "codigo":131108001,
    "descripcion":"NIVEL DE SECRETINA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":426020004,
    "descripcion":"SÍNDROME DE SOBRECARGA LIPÍDICA"
  },
  {
    "codigo":360484006,
    "descripcion":"AUSENTISMO LABORAL"
  },
  {
    "codigo":719097002,
    "descripcion":"SÍNDROME BRANQUIOESQUELETOGENITAL"
  },
  {
    "codigo":1145081007,
    "descripcion":"LEVANTAMIENTO FRONTAL DE PELO ANTERIOR DE CUERO CABELLUDO"
  },
  {
    "codigo":194809007,
    "descripcion":"INFARTO AURICULAR AGUDO"
  },
  {
    "codigo":717262004,
    "descripcion":"ALACRIMA CONGÉNITA AISLADA"
  },
  {
    "codigo":94670008,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA VALÉCULA"
  },
  {
    "codigo":1338019004,
    "descripcion":"MENOPAUSIA CAUSADA POR RADIACIÓN IONIZANTE"
  },
  {
    "codigo":420515004,
    "descripcion":"TORTUOSIDAD VENOSA RETINIANA"
  },
  {
    "codigo":1010339004,
    "descripcion":"BABEO POR EL LADO DERECHO DE LA BOCA"
  },
  {
    "codigo":125603006,
    "descripcion":"LESIÓN TRAUMÁTICA DE TOBILLO"
  },
  {
    "codigo":715427008,
    "descripcion":"DISPLASIA FRONTONASAL ACROMÉLICA"
  },
  {
    "codigo":289443009,
    "descripcion":"FRECUENCIA CARDÍACA FETAL, REGULAR"
  },
  {
    "codigo":27299009,
    "descripcion":"HIPOPLASIA MAXILAR CONGÉNITA"
  },
  {
    "codigo":60067008,
    "descripcion":"INTOXICACIÓN POR PENNISETUM CLANDESTINUM"
  },
  {
    "codigo":254840009,
    "descripcion":"CARCINOMA INFLAMATORIO DE MAMA"
  },
  {
    "codigo":253005002,
    "descripcion":"PÉPTIDO INTESTINAL VASOACTIVO - TUMOR SECRETANTE"
  },
  {
    "codigo":1268813005,
    "descripcion":"TENDINITIS CALCIFICANTE DE MANO"
  },
  {
    "codigo":285773007,
    "descripcion":"CAPAZ DE RECONOCER A PERSONAS CONOCIDAS"
  },
  {
    "codigo":251170000,
    "descripcion":"CONTRACCIÓN AURICULAR PREMATURA BLOQUEADA"
  },
  {
    "codigo":283938001,
    "descripcion":"HEMATOMA DE LA VESÍCULA SEMINAL"
  },
  {
    "codigo":87330002,
    "descripcion":"ENFERMEDAD CAUSADA POR LYSSAVIRUS"
  },
  {
    "codigo":447778004,
    "descripcion":"DISMINUCIÓN ESPONTÁNEA DE TAMAÑO DE DEFECTO DE TABIQUE INTERVENTRICULAR"
  },
  {
    "codigo":21794005,
    "descripcion":"TENOSINOVITIS ESTILOIDEA RADIAL"
  },
  {
    "codigo":314871000,
    "descripcion":"ESTADO DE PRESCRIPCIÓN"
  },
  {
    "codigo":773623000,
    "descripcion":"SÍNDROME DE HERNIA DE SPIEGEL CON CRIPTORQUIDIA"
  },
  {
    "codigo":183799004,
    "descripcion":"ESTADÍA DE INTERNACIÓN, 1 DÍA"
  },
  {
    "codigo":85495007,
    "descripcion":"PIONEFROSIS AGUDA SIN NECROSIS MEDULAR RENAL"
  },
  {
    "codigo":444108000,
    "descripcion":"CRISIS AGUDA DE SECUESTRO ESPLÉNICO DE CÉLULAS DREPANOCÍTICAS"
  },
  {
    "codigo":871927008,
    "descripcion":"REACCIÓN ALÉRGICA CAUSADA POR MORDEDURA Y\/O PICADURA DE INSECTO"
  },
  {
    "codigo":247500006,
    "descripcion":"LIMADO DE UÑAS EN FORMA DE GOTA"
  },
  {
    "codigo":737185000,
    "descripcion":"HIPERPLASIA CONGÉNITA DE PULMÓN"
  },
  {
    "codigo":704417003,
    "descripcion":"CON MAYOR RIESGO DE EFECTO COLATERAL DE MEDICACIÓN"
  },
  {
    "codigo":47222000,
    "descripcion":"ABRASIÓN DE DIENTE"
  },
  {
    "codigo":16289009,
    "descripcion":"CRECIMIENTO BACTERIANO EN CULTIVO DE ORIGEN ANIMAL"
  },
  {
    "codigo":278433008,
    "descripcion":"INFILTRACIÓN MALIGNA DE PARTES BLANDAS"
  },
  {
    "codigo":407670004,
    "descripcion":"TOMOGRAFÍA AXIAL COMPUTARIZADA DE CEREBRO, ANORMAL"
  },
  {
    "codigo":1259638006,
    "descripcion":"COREA DEBIDA A AMINOACIDURIA HEREDITARIA"
  },
  {
    "codigo":79990007,
    "descripcion":"HERNIA CON GANGRENA"
  },
  {
    "codigo":211062008,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE INGLE"
  },
  {
    "codigo":209227002,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA EXPUESTA DE LA ARTICULACIÓN COSTOVERTEBRAL"
  },
  {
    "codigo":241995006,
    "descripcion":"LESIÓN DEL OÍDO INTERNO POR DESCOMPRESIÓN"
  },
  {
    "codigo":45387006,
    "descripcion":"LUXACIÓN EXPUESTA DE LA SEGUNDA VÉRTEBRA CERVICAL"
  },
  {
    "codigo":240160002,
    "descripcion":"OSTEOPOROSIS TRANSITORIA DE CADERA EN EL EMBARAZO"
  },
  {
    "codigo":305696004,
    "descripcion":"ATENDIDO POR UN PSIQUIATRA DE ENLACE"
  },
  {
    "codigo":698912007,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: NAURUANO"
  },
  {
    "codigo":205557000,
    "descripcion":"PLIEGUES PALMARES ANÓMALOS"
  },
  {
    "codigo":402165001,
    "descripcion":"EFECTO AGUDO DE LOS RAYOS ULTRAVIOLETAS SOBRE LA PIEL NORMAL"
  },
  {
    "codigo":305511000119107,
    "descripcion":"CONTRACTURA DE ARTICULACIÓN DE TOBILLO DERECHO"
  },
  {
    "codigo":15680001000119101,
    "descripcion":"CONJUNTIVITIS PRIMAVERAL DE OJO IZQUIERDO"
  },
  {
    "codigo":762613004,
    "descripcion":"QUINTILLIZOS MORTINATOS"
  },
  {
    "codigo":404000008,
    "descripcion":"DERMATOFIBROMA ATRÓFICO"
  },
  {
    "codigo":271093007,
    "descripcion":"DEFORMIDAD DE RÓTULA"
  },
  {
    "codigo":433098000,
    "descripcion":"RUPTURA DE PORCIÓN DISTAL DEL CUÁDRICEPS"
  },
  {
    "codigo":860917009,
    "descripcion":"DISFUNCIÓN ERÉCTIL ABSOLUTA"
  },
  {
    "codigo":302026003,
    "descripcion":"CARENCIA DE ENTRADA TEMPORAL"
  },
  {
    "codigo":7114006,
    "descripcion":"HIPERSENSIBILIDAD A ANTÍGENO EXTRAÑO"
  },
  {
    "codigo":105418006,
    "descripcion":"INSATISFACCIÓN CON EL AMBIENTE ESCOLAR"
  },
  {
    "codigo":236490006,
    "descripcion":"INFARTO RENAL - ARTERIAL"
  },
  {
    "codigo":431263002,
    "descripcion":"ARTRITIS BACTERIANA DE CODO"
  },
  {
    "codigo":365727002,
    "descripcion":"NIVEL DE FENILALANINA - HALLAZGO"
  },
  {
    "codigo":300191005,
    "descripcion":"HALLAZGO RELACIONADO CON DISPOSITIVO DE OÍDO MEDIO"
  },
  {
    "codigo":1119391009,
    "descripcion":"FISURA DE PALADAR DURO IZQUIERDO"
  },
  {
    "codigo":429428003,
    "descripcion":"HIPERCAPNIA CRÓNICA"
  },
  {
    "codigo":298356007,
    "descripcion":"DEFORMACIÓN ÓSEA"
  },
  {
    "codigo":1148489000,
    "descripcion":"IMPACTACIÓN FECAL DE RECTO"
  },
  {
    "codigo":198217000,
    "descripcion":"VULVITIS ASOCIADA CON OTRO TRASTORNO"
  },
  {
    "codigo":11803291000119101,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN METACARPOFALÁNGICA DE DEDO MEDIO DE MANO DERECHA"
  },
  {
    "codigo":722505007,
    "descripcion":"OBJETIVO DE PLAN DE ATENCIÓN NO ACORDADO"
  },
  {
    "codigo":294686004,
    "descripcion":"ALERGIA A DESOXIMETASONA"
  },
  {
    "codigo":292851003,
    "descripcion":"REACCIÓN ADVERSA A LA PRIMAQUINA"
  },
  {
    "codigo":63475008,
    "descripcion":"PERIOSTITIS DE LA MANO"
  },
  {
    "codigo":784371009,
    "descripcion":"TRASTORNO SIMILAR A ENFERMEDAD DE HUNTINGTON, TIPO 1"
  },
  {
    "codigo":192712001,
    "descripcion":"ENCEFALITIS POSVACUNACIÓN CONTRA LA TOS FERINA"
  },
  {
    "codigo":225480004,
    "descripcion":"CONDUCTA ABUSIVA EN EL ASPECTO FÍSICO"
  },
  {
    "codigo":94408005,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE GANGLIOS LINFÁTICOS MEDIASTÍNICOS"
  },
  {
    "codigo":61640006,
    "descripcion":"ENDOMETRIOSIS DEL CUELLO UTERINO"
  },
  {
    "codigo":422088007,
    "descripcion":"TRASTORNO DEL SISTEMA NERVIOSO DEBIDO A DIABETES MELLITUS"
  },
  {
    "codigo":127176004,
    "descripcion":"LINFADENOPATÍA GLÚTEA SUPERIOR"
  },
  {
    "codigo":291016009,
    "descripcion":"INTOXICACIÓN ACCIDENTAL CON CICLOBARBITAL"
  },
  {
    "codigo":92573003,
    "descripcion":"CARCINOMA IN SITU DE CONDUCTO CRANEOFARÍNGEO"
  },
  {
    "codigo":59805007,
    "descripcion":"INTOXICACIÓN POR LAS BATATAS DE IPOMEA"
  },
  {
    "codigo":1237618009,
    "descripcion":"SÍNDROME DE TALLA BAJA, ATROFIA ÓPTICA, ANOMALÍA DE PELGER-HUËT"
  },
  {
    "codigo":189042009,
    "descripcion":"NEOPLASIA BENIGNA DE PARTES BLANDAS DE LA COLUMNA VERTEBRAL LUMBAR"
  },
  {
    "codigo":449351005,
    "descripcion":"COMUNICACIÓN INTERAURICULAR RESIDUAL"
  },
  {
    "codigo":87068006,
    "descripcion":"POSICIÓN ENCORVADA"
  },
  {
    "codigo":11832271000119100,
    "descripcion":"LESIÓN TRAUMÁTICA DE VASO SANGUÍNEO DE DEDO ANULAR DE MANO IZQUIERDA"
  },
  {
    "codigo":283676009,
    "descripcion":"HERIDA POR PINCHAZO DE CLAVO EN EL PIE"
  },
  {
    "codigo":871665004,
    "descripcion":"DILATACIÓN ADQUIRIDA DE AORTA ASCENDENTE Y RAÍZ AÓRTICA"
  },
  {
    "codigo":249073006,
    "descripcion":"SUTURAS EN CONTACTO SIN SUPERPONERSE"
  },
  {
    "codigo":1363185006,
    "descripcion":"DEMENCIA DEBIDA A ENFERMEDAD DE CUERPOS DE LEWY"
  },
  {
    "codigo":609521009,
    "descripcion":"TRASTORNO DE ESTRUCTURA EMBRIONARIA"
  },
  {
    "codigo":704155000,
    "descripcion":"FRACTURA NO EXPUESTA DE FALANGE DE DEDO ANULAR"
  },
  {
    "codigo":247238009,
    "descripcion":"CICATRIZ DE PABELLÓN AURICULAR"
  },
  {
    "codigo":432776007,
    "descripcion":"AFECTO SEUDOBULBAR"
  },
  {
    "codigo":702320006,
    "descripcion":"PARÁLISIS CEREBRAL TRIPLÉGICA"
  },
  {
    "codigo":46960006,
    "descripcion":"LUMBOCIATALGIA SECUNDARIA A DESPLAZAMIENTO DE DISCO INTERVERTEBRAL LUMBAR"
  },
  {
    "codigo":1259376009,
    "descripcion":"CARCINOMA BASOESCAMOSO PRIMARIO DE PIEL"
  },
  {
    "codigo":733253008,
    "descripcion":"LUXACIÓN TRAUMÁTICA DE ARTICULACIÓN CARPOMETACARPIANA DE PULGAR"
  },
  {
    "codigo":895258001,
    "descripcion":"FORMA TRIANGULAR ANORMAL CONGÉNITA DE FALANGE MEDIA DE DEDO ANULAR"
  },
  {
    "codigo":405573009,
    "descripcion":"DEFECTO OBSTRUCTIVO ADQUIRIDO DE LA PELVIS RENAL"
  },
  {
    "codigo":208965008,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA NO EXPUESTA DE LA ARTICULACIÓN DE LA RODILLA, ROTATORIA"
  },
  {
    "codigo":370970008,
    "descripcion":"DETERMINACIÓN DEL RESULTADO, FRACASO"
  },
  {
    "codigo":239898008,
    "descripcion":"POLIMIOSITIS CON ENFERMEDAD MALIGNA"
  },
  {
    "codigo":41455002,
    "descripcion":"FRACTURA NO EXPUESTA DE SACRO Y\/O CÓCCIX CON LESIÓN COMPLETA DE LA COLA DE CABALLO"
  },
  {
    "codigo":238063003,
    "descripcion":"PÉRDIDA DE MÚLTIPLES FUNCIONES DE LOS PEROXISOMAS"
  },
  {
    "codigo":40671000087105,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE DEDO MEDIO DERECHO"
  },
  {
    "codigo":403738008,
    "descripcion":"PORFIRIA CAUSADA POR CLOROFENOL"
  },
  {
    "codigo":762351006,
    "descripcion":"DEMENCIA DEBIDA A TRAUMATISMO CRANEOENCEFÁLICO Y POSTERIOR A ÉL"
  },
  {
    "codigo":74223008,
    "descripcion":"CICATRIZ CONGÉNITA"
  },
  {
    "codigo":301764006,
    "descripcion":"HEMATOMA ENCEFÁLICO"
  },
  {
    "codigo":37785001,
    "descripcion":"TENDINITIS ROTULIANA"
  },
  {
    "codigo":168857002,
    "descripcion":"CISTOGRAFÍA ANORMAL"
  },
  {
    "codigo":201625003,
    "descripcion":"CONDROCALCINOSIS CAUSADA POR CRISTALES DE FOSFATO DICÁLCICO"
  },
  {
    "codigo":365465005,
    "descripcion":"GRADO DE INTERRUPCIÓN DE LA EDUCACIÓN - HALLAZGO"
  },
  {
    "codigo":234393007,
    "descripcion":"HEMOGLOBINA DE BAJA AFINIDAD"
  },
  {
    "codigo":298094000,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE LA CADERA"
  },
  {
    "codigo":396398001,
    "descripcion":"INFILTRACIÓN DE TUMOR POR LINFOCITOS, NO BRUSCA"
  },
  {
    "codigo":299929009,
    "descripcion":"DISCRIMINACIÓN TOCO-PINCHO NORMAL"
  },
  {
    "codigo":230723007,
    "descripcion":"TROMBOSIS VENOSA CEREBRAL DE VENA CEREBRAL MAYOR"
  },
  {
    "codigo":163352001,
    "descripcion":"EXAMEN GENITOURINARIO - NO SE DETECTARON ANOMALÍAS"
  },
  {
    "codigo":296259009,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE DECANOATO DE FLUPENTIXOL"
  },
  {
    "codigo":720408003,
    "descripcion":"DISOSTOSIS ACROFRONTOFACIONASAL"
  },
  {
    "codigo":65048006,
    "descripcion":"GLÁNDULA PARATIROIDES ACCESORIA"
  },
  {
    "codigo":1144557000,
    "descripcion":"APLASIA DE VASO LINFÁTICO"
  },
  {
    "codigo":292589003,
    "descripcion":"REACCIÓN ADVERSA A LA CIPROHEPTADINA"
  },
  {
    "codigo":126914000,
    "descripcion":"NEOPLASIA DEL FONDO DEL ÚTERO"
  },
  {
    "codigo":423661009,
    "descripcion":"COMPLICACIÓN DE LA QUIMIOTERAPIA"
  },
  {
    "codigo":718573009,
    "descripcion":"SÍNDROME DE MICROCEFALIA Y ACALASIA"
  },
  {
    "codigo":94146005,
    "descripcion":"OTITIS EXTERNA MALIGNA"
  },
  {
    "codigo":290754008,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR TAMOXIFENO"
  },
  {
    "codigo":190615004,
    "descripcion":"HIPOVITAMINOSIS A CON CICATRICES CORNEALES XEROFTÁLMICAS"
  },
  {
    "codigo":92311006,
    "descripcion":"NEOPLASIA BENIGNA DEL PÍLORO"
  },
  {
    "codigo":288919008,
    "descripcion":"CAPAZ DE MASTICAR"
  },
  {
    "codigo":419991009,
    "descripcion":"TUBO ENDOTRAQUEAL PRESENTE"
  },
  {
    "codigo":93751000119100,
    "descripcion":"MASA DE SENO PARANASAL"
  },
  {
    "codigo":188780006,
    "descripcion":"NEOPLASIA BENIGNA DE MUCOSA DE LABIO"
  },
  {
    "codigo":285249000,
    "descripcion":"PENSAMIENTO DICOTÓMICO"
  },
  {
    "codigo":54038000,
    "descripcion":"INSEGURIDAD"
  },
  {
    "codigo":10743351000119102,
    "descripcion":"CUTIS LAXO DE AMBOS PÁRPADOS INFERIORES"
  },
  {
    "codigo":283414008,
    "descripcion":"CORTE EN EL ANTEBRAZO"
  },
  {
    "codigo":281579001,
    "descripcion":"HIPOXIA PERINATAL"
  },
  {
    "codigo":248811009,
    "descripcion":"MAMA PEQUEÑA"
  },
  {
    "codigo":29341000175107,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN DE REGIÓN SACRA DE ESPALDA GRADO 2"
  },
  {
    "codigo":771264005,
    "descripcion":"SÍNDROME DE RADIO AUSENTE-ANOMALÍAS ANOGENITALES"
  },
  {
    "codigo":1230016009,
    "descripcion":"OBSTRUCCIÓN CONGÉNITA FAMILIAR DE CONDUCTO NASOLAGRIMAL"
  },
  {
    "codigo":15765005,
    "descripcion":"CHOQUE SÉPTICO POR UNA TRANSFUSIÓN"
  },
  {
    "codigo":13930000,
    "descripcion":"PRESENCIA ANORMAL DE PROTEÍNAS"
  },
  {
    "codigo":212373009,
    "descripcion":"HEMORRAGIA SECUNDARIA Y RECURRENTE"
  },
  {
    "codigo":15714001000119102,
    "descripcion":"DEFORMIDAD EN VARO ADQUIRIDA DE AMBAS RODILLAS"
  },
  {
    "codigo":1259114008,
    "descripcion":"OTORREA DE LÍQUIDO CEFALORRAQUÍDEO DEBIDA A MALFORMACIÓN CONGÉNITA DE LABERINTO"
  },
  {
    "codigo":276074009,
    "descripcion":"ESTRÉS EN EL TRABAJO"
  },
  {
    "codigo":46698009,
    "descripcion":"DICÉFALO DIPUS DIBRAQUIO"
  },
  {
    "codigo":44863007,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DEL DORSO, SIN INFECCIÓN"
  },
  {
    "codigo":403476001,
    "descripcion":"NEOPLASIA INTRAEPITELIAL VULVAR CON HIPERPLASIA EPITELIAL ESCAMOSA"
  },
  {
    "codigo":10260002,
    "descripcion":"DISFUNCIÓN UTERINA"
  },
  {
    "codigo":1222676004,
    "descripcion":"SÍNDROME DE MUELLER WEISS"
  },
  {
    "codigo":1351913002,
    "descripcion":"HEMANGIOBLASTOMA DE PARTES BLANDAS"
  },
  {
    "codigo":237801002,
    "descripcion":"GALACTORREA NORMOPROLACTINÉMICA"
  },
  {
    "codigo":268734000,
    "descripcion":"TRASTORNO MADURATIVO DEL LENGUAJE EXPRESIVO"
  },
  {
    "codigo":203198001,
    "descripcion":"ABSCESO DE BRODIE DE COLUMNA VERTEBRAL CERVICAL"
  },
  {
    "codigo":235966007,
    "descripcion":"CISTOADENOCARCINOMA DE PÁNCREAS"
  },
  {
    "codigo":168595000,
    "descripcion":"RADIOGRAFÍA SIMPLE DE CLAVÍCULA NORMAL"
  },
  {
    "codigo":365203003,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA CORTARSE LAS UÑAS DE LAS MANOS"
  },
  {
    "codigo":61401000087100,
    "descripcion":"PLASMODIUM KNOWLESI O PLASMODIUM MALARIAE"
  },
  {
    "codigo":299667005,
    "descripcion":"UÑA MANCHADA"
  },
  {
    "codigo":234131004,
    "descripcion":"ANOMALÍA VASCULAR ESPLENOPORTAL"
  },
  {
    "codigo":1348243007,
    "descripcion":"CON MAYOR RIESGO DE DESARROLLAR UN CURSO SEVERO DE COVID-19"
  },
  {
    "codigo":43481000087104,
    "descripcion":"HERIDA ABIERTA DE ANEXOS OCULARES DERECHOS"
  },
  {
    "codigo":135827004,
    "descripcion":"BAJO ATENCIÓN DE EQUIPO COMUNITARIO DE ACCIÓN CONTRA EL ALCOHOLISMO"
  },
  {
    "codigo":40921000087100,
    "descripcion":"QUEMADURA DE PÁRPADO INFERIOR IZQUIERDO"
  },
  {
    "codigo":38361000087107,
    "descripcion":"HIPOCINESIA DE SEGMENTO ANTEROSEPTAL MEDIO DE VENTRÍCULO CARDÍACO IZQUIERDO"
  },
  {
    "codigo":46041000087108,
    "descripcion":"ESGUINCE DE LIGAMENTO CORACOHUMERAL DERECHO"
  },
  {
    "codigo":56281000087109,
    "descripcion":"DIFICULTAD PARA COMUNICARSE DEBIDA A TRAQUEOTOMÍA Y POSTERIOR A ELLA"
  },
  {
    "codigo":35688006,
    "descripcion":"COMPLICACIÓN DE LA ATENCIÓN MÉDICA"
  },
  {
    "codigo":363368005,
    "descripcion":"CARCINOMA DEL CUERPO DEL PÁNCREAS"
  },
  {
    "codigo":263229001,
    "descripcion":"FRACTURA SUBTROCANTÉRICA DE FÉMUR"
  },
  {
    "codigo":1085006,
    "descripcion":"CANDIDIASIS DE LA VULVA"
  },
  {
    "codigo":164925007,
    "descripcion":"ONDA S ELECTROCARDIOGRÁFICA ANORMAL"
  },
  {
    "codigo":64786000,
    "descripcion":"FORÚNCULO DE DEDO PULGAR"
  },
  {
    "codigo":230461009,
    "descripcion":"TRASTORNO RELATIVO A LA CEFALEA"
  },
  {
    "codigo":295997008,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE CARBAMAZEPINA"
  },
  {
    "codigo":359698000,
    "descripcion":"CORIORRETINITIS PARASITARIA"
  },
  {
    "codigo":197693009,
    "descripcion":"SÍNDROME NEFRÍTICO RÁPIDAMENTE PROGRESIVO, GLOMERULONEFRITIS PROLIFERATIVA MESANGIAL DIFUSA"
  },
  {
    "codigo":425234002,
    "descripcion":"ESPACIO DE JUEGOS INADECUADO"
  },
  {
    "codigo":1177063000,
    "descripcion":"ESPONDILITIS POR BRUCELLA SUIS"
  },
  {
    "codigo":128487001,
    "descripcion":"ENFERMEDAD AGUDA DEL APARATO CARDIOVASCULAR"
  },
  {
    "codigo":292327002,
    "descripcion":"REACCIÓN ADVERSA A LA FENITOÍNA"
  },
  {
    "codigo":30183003,
    "descripcion":"ÚLCERA GASTROYEYUNAL CON PERFORACIÓN"
  },
  {
    "codigo":194023005,
    "descripcion":"DEFORMIDAD ORBITARIA ASOCIADA CON DEFORMIDAD CRANEOFACIAL"
  },
  {
    "codigo":126652001,
    "descripcion":"NEOPLASIA DE BRAZO"
  },
  {
    "codigo":224956002,
    "descripcion":"LABIOS ROSADOS"
  },
  {
    "codigo":28348003,
    "descripcion":"INTOXICACIÓN POR CITARABINA"
  },
  {
    "codigo":62011000000100,
    "descripcion":"HIPERTENSIÓN OCULAR CAUSADA POR CORTICOESTEROIDE"
  },
  {
    "codigo":716476006,
    "descripcion":"DIFICULTAD PARA COMPRENDER UN MATERIAL ESCRITO"
  },
  {
    "codigo":290492008,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR KETAMINA"
  },
  {
    "codigo":26513001,
    "descripcion":"ACIDEMIA Y\/O ACIDURIA NO AMINO ORGÁNICA"
  },
  {
    "codigo":1339068009,
    "descripcion":"FRACTURA DE FALANGE DE QUINTO DEDO DE PIE"
  },
  {
    "codigo":254054000,
    "descripcion":"DISPLASIA BOOMERANG"
  },
  {
    "codigo":448827000,
    "descripcion":"DEFECTO DEL TABIQUE INTERVENTRICULAR CON TABIQUE CORRESPONDIENTE AL TRACTO DE SALIDA AUSENTE Y CABALGAMIENTO DE VÁLVULA TRONCAL CON REBORDE MUSCULAR INFERIOR"
  },
  {
    "codigo":284987007,
    "descripcion":"SE DESVISTE"
  },
  {
    "codigo":53776005,
    "descripcion":"ENCEFALOCISTOCELE"
  },
  {
    "codigo":707301001,
    "descripcion":"LUPUS ERITEMATOSO DE LA MEMBRANA MUCOSA DE LA CAVIDAD BUCAL"
  },
  {
    "codigo":248549001,
    "descripcion":"RESPIRACIÓN TRABAJOSA"
  },
  {
    "codigo":215781003,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR GASES O HUMOS A BORDO DE BARCO, OCUPANTE DE PEQUEÑA EMBARCACIÓN SIN MOTOR LESIONADO"
  },
  {
    "codigo":838373004,
    "descripcion":"ABSCESO DE LÓBULO FRONTAL"
  },
  {
    "codigo":1264357006,
    "descripcion":"CISTADENOCARCINOMA MUCINOSO DE OVARIO METASTÁSICO"
  },
  {
    "codigo":1231589007,
    "descripcion":"OBSTRUCCIÓN DE VÍA RESPIRATORIA CAUSADA POR CANICA EN NARIZ"
  },
  {
    "codigo":246714003,
    "descripcion":"CONVERGENCIA EN EL ESTRABISMO MANIFIESTO, ANÓMALA CON ÁNGULO CONSTANTE"
  },
  {
    "codigo":769167005,
    "descripcion":"DOLOR VASOOCLUSIVO CONCOMITANTE CON DREPANOCITOSIS Y DEBIDO A ELLA"
  },
  {
    "codigo":212111005,
    "descripcion":"QUEMADURA QUE COMPROMETE 80-89 PORCIENTO DE LA SUPERFICIE DEL CUERPO, CON QUEMADURA DE ESPESOR COMPLETO QUE AFECTA 70-79 PORCIENTO DE LA SUPERFICIE CORPORAL"
  },
  {
    "codigo":79204003,
    "descripcion":"ESQUIZOFRENIA INDIFERENCIADA CRÓNICA CON EXACERBACIONES AGUDAS"
  },
  {
    "codigo":243044004,
    "descripcion":"LESIÓN POR CALOR RADIANTE DE EXPLOSIÓN NUCLEAR"
  },
  {
    "codigo":111972009,
    "descripcion":"FRECUENCIA ANORMAL DEL PULSO"
  },
  {
    "codigo":699961001,
    "descripcion":"SECCIÓN TRAUMÁTICA COMPLETA DE CABEZA CORTA DE TENDÓN DE BÍCEPS BRAQUIAL"
  },
  {
    "codigo":110137001,
    "descripcion":"LACERACIÓN COMPLEJA CONTAMINADA DE AMÍGDALA PALATINA"
  },
  {
    "codigo":306745001,
    "descripcion":"INCAPAZ DE MOVER LOS LABIOS DE MANERA SIMÉTRICA"
  },
  {
    "codigo":11833005,
    "descripcion":"TOS SECA"
  },
  {
    "codigo":372281005,
    "descripcion":"HIPERTROFIA DE MAMA"
  },
  {
    "codigo":208441003,
    "descripcion":"FRACTURA NO EXPUESTA DE LA FALANGE DISTAL DEL PULGAR, DIÁFISIS"
  },
  {
    "codigo":44601009,
    "descripcion":"ENDOMETRIOSIS DEL COLON"
  },
  {
    "codigo":1351651000,
    "descripcion":"INMUNODEFICIENCIA COMBINADA LIGADA AL CROMOSOMA X DEBIDA A DEFICIENCIA DE SASH3"
  },
  {
    "codigo":73699003,
    "descripcion":"TRONCO ARTERIAL COMÚN Y ORIGEN COMÚN DE ARTERIAS PULMONARES"
  },
  {
    "codigo":237539004,
    "descripcion":"TIROIDITIS MEDICAMENTOSA"
  },
  {
    "codigo":399544002,
    "descripcion":"PATRÓN MICROVASCULAR PRESENTE EN TUMOR"
  },
  {
    "codigo":268472006,
    "descripcion":"LACTANTE ALIMENTADO CON BIBERÓN"
  },
  {
    "codigo":301240009,
    "descripcion":"DIFICULTAD PARA ELIMINAR ESPUTO"
  },
  {
    "codigo":233869002,
    "descripcion":"MIOCARDITIS PARASITARIA"
  },
  {
    "codigo":344531000119107,
    "descripcion":"GLAUCOMA FACOLÍTICO DE AMBOS OJOS"
  },
  {
    "codigo":1081811000119107,
    "descripcion":"SEMINOMA PRIMARIO DE TESTÍCULO DERECHO"
  },
  {
    "codigo":364941006,
    "descripcion":"PATRÓN DE INTERFERENCIA DEL ELECTROMIOGRAMA-HALLAZGO"
  },
  {
    "codigo":201101007,
    "descripcion":"QUERATOSIS ACTÍNICA"
  },
  {
    "codigo":754555501000119102,
    "descripcion":"LEIOMIOMA CELULAR"
  },
  {
    "codigo":461410003,
    "descripcion":"ANOMALÍA ADQUIRIDA DE VENA FEMORAL IZQUIERDA"
  },
  {
    "codigo":68194005,
    "descripcion":"EMISIÓN NASAL DE LAS CONSONANTES PLOSIVAS"
  },
  {
    "codigo":723554006,
    "descripcion":"SÍNDROME DE APLASIA CUTÁNEA CONGÉNITA CON DERMOIDE EPIBULBAR"
  },
  {
    "codigo":72301000119103,
    "descripcion":"ASMA EN EL EMBARAZO"
  },
  {
    "codigo":33591000,
    "descripcion":"TROMBOSIS DE ARTERIAS DE LAS EXTREMIDADES"
  },
  {
    "codigo":232034009,
    "descripcion":"RETINOPATÍA CENTRAL SEROSA CON DEPRESIÓN DE PAPILA"
  },
  {
    "codigo":262967003,
    "descripcion":"DIVISIÓN TRAUMÁTICA DE MÚSCULO"
  },
  {
    "codigo":295735006,
    "descripcion":"SOBREDOSIS DE CARBOPLATINO"
  },
  {
    "codigo":230199007,
    "descripcion":"ENCEFALOMIELITIS POSINFECCIOSA"
  },
  {
    "codigo":361271008,
    "descripcion":"VESTIBULOPATÍA RECURRENTE"
  },
  {
    "codigo":721719006,
    "descripcion":"ADENOMA DE AMPOLLA DE VATER"
  },
  {
    "codigo":293900003,
    "descripcion":"ALERGIA A PRAZEPAM"
  },
  {
    "codigo":95457000,
    "descripcion":"INFARTO DE TRONCO ENCEFÁLICO"
  },
  {
    "codigo":228364009,
    "descripcion":"SIENTE MIEDO DE SER UN ALCOHÓLICO"
  },
  {
    "codigo":292065002,
    "descripcion":"REACCIÓN ADVERSA A LA FENOPIRIDINA"
  },
  {
    "codigo":128225009,
    "descripcion":"TRASTORNO DE LOS HUESOS FACIALES"
  },
  {
    "codigo":290230004,
    "descripcion":"INTOXICACIÓN POR AZAPROPAZONA"
  },
  {
    "codigo":880054006,
    "descripcion":"OBSTRUCCIÓN ADQUIRIDA DEL TRACTO DE SALIDA DEL VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":93622009,
    "descripcion":"FALTA DE OSIFICACIÓN DEL ARCO DE LA VÉRTEBRA DORSAL"
  },
  {
    "codigo":60854009,
    "descripcion":"POSICIÓN MENTOILÍACA IZQUIERDA ANTERIOR"
  },
  {
    "codigo":288395005,
    "descripcion":"INCAPAZ DE DARLE CUERDA AL RELOJ"
  },
  {
    "codigo":1236832000,
    "descripcion":"LESIÓN COMBINADA PERIODONTAL Y ENDODÓNTICA VERDADERA"
  },
  {
    "codigo":712544000,
    "descripcion":"CON ABSTINENCIA DE USO INAPROPIADO DE DROGAS EN AMBIENTE PROTEGIDO"
  },
  {
    "codigo":253792003,
    "descripcion":"DIVERTICULOSIS CONGÉNITA"
  },
  {
    "codigo":188256008,
    "descripcion":"NEOPLASIA MALIGNA DE LOCALIZACIONES SUPERPUESTAS DE ÓRGANOS URINARIOS"
  },
  {
    "codigo":186421001,
    "descripcion":"GANGRENA GASEOSA DE MUSLO"
  },
  {
    "codigo":415797006,
    "descripcion":"PRUEBA DE ORINA PARA CHLAMYDIA TRACHOMATIS NEGATIVA"
  },
  {
    "codigo":282890001,
    "descripcion":"SE AGARRA PARA PARARSE DESDE LA POSICIÓN SENTADA"
  },
  {
    "codigo":347041000119103,
    "descripcion":"OPACIDAD CENTRAL DE AMBAS CÓRNEAS"
  },
  {
    "codigo":293461000119100,
    "descripcion":"TROMBOSIS CRÓNICA DE VENA ILÍACA IZQUIERDA"
  },
  {
    "codigo":1264095005,
    "descripcion":"TRASTORNO FETAL CAUSADO POR TRANSFERENCIA PLACENTARIA DE AGENTE ENDOCRINO"
  },
  {
    "codigo":15666081000119105,
    "descripcion":"COSTILLAS ACCESORIAS BILATERALES"
  },
  {
    "codigo":1231327008,
    "descripcion":"DEPENDENCIA DE ANFETAMINA Y\/O DERIVADO DE ANFETAMINA, EPISÓDICA"
  },
  {
    "codigo":49844009,
    "descripcion":"PRESIÓN ARTERIAL DIASTÓLICA ANORMAL"
  },
  {
    "codigo":703369003,
    "descripcion":"SÍNDROME DE MICROCEFALIA-MALFORMACIÓN CAPILAR"
  },
  {
    "codigo":1293193004,
    "descripcion":"HÁBITOS TOXICOFÍLICOS"
  },
  {
    "codigo":15241006,
    "descripcion":"TRASTORNO DEL SISTEMA NERVIOSO AUTÓNOMO"
  },
  {
    "codigo":74811000119102,
    "descripcion":"NECESIDAD DE ASISTENCIA CON RECURSOS COMUNITARIOS"
  },
  {
    "codigo":406622004,
    "descripcion":"INFECCIÓN CAUSADA POR VIBRIO ALGINOLYTICUS"
  },
  {
    "codigo":109875002,
    "descripcion":"NEOPLASIA SUPERPUESTA MALIGNA DE PENE"
  },
  {
    "codigo":15636851000119100,
    "descripcion":"RIGIDEZ DE ARTICULACIONES DE AMBAS MANOS"
  },
  {
    "codigo":699699005,
    "descripcion":"TRASTORNO DE LA COLUMNA VERTEBRAL"
  },
  {
    "codigo":372019006,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":348531000119101,
    "descripcion":"SÍNDROME DE DISPERSIÓN PIGMENTARIA DE OJO IZQUIERDO"
  },
  {
    "codigo":72051000119101,
    "descripcion":"DESNUTRICIÓN SEVERA DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":683891000119105,
    "descripcion":"NEVO EPIDÉRMICO DE TRONCO"
  },
  {
    "codigo":100211000119106,
    "descripcion":"ESPASMO MUSCULAR DE REGIÓN DORSAL"
  },
  {
    "codigo":16740211000119107,
    "descripcion":"PROTEINURIA GESTACIONAL POSPARTO"
  },
  {
    "codigo":10749811000119108,
    "descripcion":"ANESTESIA OBSTÉTRICA CON COMPLICACIÓN DEL SISTEMA NERVIOSO CENTRAL DURANTE EL NACIMIENTO"
  },
  {
    "codigo":1085811000119109,
    "descripcion":"COMPLICACIÓN DEBIDA A ENFERMEDAD DE CROHN DE INTESTINO DELGADO Y GRUESO"
  },
  {
    "codigo":402952006,
    "descripcion":"ANETODERMIA SECUNDARIA A SÍFILIS"
  },
  {
    "codigo":304648006,
    "descripcion":"INCAPAZ DE REALIZAR UNA SECUENCIA LÓGICA"
  },
  {
    "codigo":371000119109,
    "descripcion":"ESTENOSIS DE AGUJEROS INTERVERTEBRALES"
  },
  {
    "codigo":1254920007,
    "descripcion":"PITIRIASIS RUBRA PILARIS JUVENIL"
  },
  {
    "codigo":763400005,
    "descripcion":"ENFERMEDAD DE CHARCOT-MARIE-TOOTH LIGADA AL CROMOSOMA X TIPO 4"
  },
  {
    "codigo":239112008,
    "descripcion":"SÍNDROME DEL NEVO EPIDÉRMICO"
  },
  {
    "codigo":146291000119108,
    "descripcion":"VÓMITOS SIN NÁUSEAS"
  },
  {
    "codigo":315251000119108,
    "descripcion":"OSTEOCONDRITIS DISECANTE DE HOMBRO DERECHO"
  },
  {
    "codigo":292211000119109,
    "descripcion":"TRASTORNO DE NERVIO PLANTAR EXTERNO IZQUIERDO"
  },
  {
    "codigo":302813001,
    "descripcion":"NEURITIS ACÚSTICA SIFILÍTICA - ESTADIO CUATERNARIO"
  },
  {
    "codigo":40669004,
    "descripcion":"DISFUNCIÓN POR ESTIMULACIÓN ARTIFICIAL"
  },
  {
    "codigo":1187549009,
    "descripcion":"QUISTE CRANEOFARÍNGEO"
  },
  {
    "codigo":237277009,
    "descripcion":"HEMORRAGIA PLACENTARIA MARGINAL"
  },
  {
    "codigo":401117004,
    "descripcion":"CONTROL DE HIPERTENSIÓN MODERADA"
  },
  {
    "codigo":202674000,
    "descripcion":"ESPONDILOSIS LUMBOSACRA EN UN NIVEL SIN MIELOPATÍA"
  },
  {
    "codigo":366514005,
    "descripcion":"AMPLITUD DE SUPINACIÓN ACTIVA DE CODO"
  },
  {
    "codigo":169906006,
    "descripcion":"PUNTAJE DE APGAR AL MINUTO = 9"
  },
  {
    "codigo":6066007,
    "descripcion":"ÁNTRAX DEL ANO"
  },
  {
    "codigo":36999000,
    "descripcion":"HELCOMENIA"
  },
  {
    "codigo":102535000,
    "descripcion":"POSICIÓN EN DECÚBITO LATERAL DERECHO"
  },
  {
    "codigo":233607000,
    "descripcion":"NEUMONÍA POR NEUMOCOCOS"
  },
  {
    "codigo":299143003,
    "descripcion":"AMPLITUD DE FLEXIÓN ACTIVA DEL PULGAR DISMINUIDA"
  },
  {
    "codigo":2396006,
    "descripcion":"PIODERMIA MALIGNA"
  },
  {
    "codigo":262705002,
    "descripcion":"LACERACIÓN DE MÉDULA ESPINAL"
  },
  {
    "codigo":721457007,
    "descripcion":"SÍNDROME DEL CORDÓN ANTERIOR DE MÉDULA ESPINAL AL NIVEL DEL SEGUNDO SEGMENTO DORSAL"
  },
  {
    "codigo":66097008,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN SIN INFECCIÓN"
  },
  {
    "codigo":162566001,
    "descripcion":"EL PACIENTE NO CONOCE EL DIAGNÓSTICO"
  },
  {
    "codigo":786993009,
    "descripcion":"RALSTONIA MANNITOLILYTICA O RALSTONIA PICKETTII"
  },
  {
    "codigo":295473009,
    "descripcion":"SOBREDOSIS DE CATÁRTICO IRRITANTE"
  },
  {
    "codigo":95195003,
    "descripcion":"ESCLERITIS NODULAR"
  },
  {
    "codigo":717787005,
    "descripcion":"SÍNDROME DE HIPOMAGNESEMIA, HIPERCALCIURIA Y NEFROCALCINOSIS FAMILIAR CON COMPROMISO OCULAR SEVERO"
  },
  {
    "codigo":62427007,
    "descripcion":"TOS VACUNA"
  },
  {
    "codigo":160731008,
    "descripcion":"TRASLADO CONVENIDO A ALOJAMIENTO SEGÚN EL INCISO III DE LA LEY NACIONAL DE ASISTENCIA SOCIAL DE 1948 DEL REINO UNIDO"
  },
  {
    "codigo":1078235009,
    "descripcion":"AGENESIA DE EPÍFISIS DE FALANGE MEDIA DE DEDO DE MANO"
  },
  {
    "codigo":715952000,
    "descripcion":"SÍNDROME DE WAARDENBURG SHAH"
  },
  {
    "codigo":291803008,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR INSULINA"
  },
  {
    "codigo":191664002,
    "descripcion":"CAMBIOS DE HUMOR DE REBOTE"
  },
  {
    "codigo":1086831000119106,
    "descripcion":"FUNCIONAMIENTO DEFECTUOSO DE ESOFAGOSTOMÍA"
  },
  {
    "codigo":10671471000119106,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN EN PIERNA IZQUIERDA"
  },
  {
    "codigo":421040007,
    "descripcion":"QUERATOPATÍA EN VÓRTICE"
  },
  {
    "codigo":124293000,
    "descripcion":"DEFICIENCIA DE ASPARAGINA-OXOÁCIDO AMINOTRANSFERASA"
  },
  {
    "codigo":93360009,
    "descripcion":"POSICIÓN ANÓMALA CONGÉNITA DE VÉRTEBRA DORSAL"
  },
  {
    "codigo":224432009,
    "descripcion":"MÁQUINA EXPENDEDORA INADECUADA EN EL TRABAJO"
  },
  {
    "codigo":1303941004,
    "descripcion":"INFECCIÓN ASOCIADA CON PRÓTESIS ARTICULAR DE REGIÓN DE MUÑECA"
  },
  {
    "codigo":91525005,
    "descripcion":"INCOMPATIBILIDAD SEXUAL"
  },
  {
    "codigo":384602000,
    "descripcion":"RESPUESTA LINFOCÍTICA INTRATUMORAL\/PERITUMORAL LEVE A MODERADA"
  },
  {
    "codigo":286298001,
    "descripcion":"NO ARTICULA CLARAMENTE"
  },
  {
    "codigo":417370002,
    "descripcion":"CONSENTIMIENTO PARA INCLUSIÓN DE DATOS EN REGISTRO MÉDICO ELECTRÓNICO COMPARTIDO A NIVEL NACIONAL, OTORGADO"
  },
  {
    "codigo":56922006,
    "descripcion":"ONICOMICOSIS CAUSADA POR TRICHOPHYTON RUBRUM"
  },
  {
    "codigo":253530007,
    "descripcion":"OBSTRUCCIÓN DEL TRACTO DE SALIDA DEL VENTRÍCULO DERECHO"
  },
  {
    "codigo":218927007,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR HIDROTALCITA"
  },
  {
    "codigo":55087008,
    "descripcion":"MIOCARDITIS POR AGENTE QUÍMICO"
  },
  {
    "codigo":448303009,
    "descripcion":"ANILLO VASCULAR CON CAYADO AÓRTICO IZQUIERDO A AORTA DESCENDENTE DERECHA Y LIGAMENTO ARTERIAL DERECHO"
  },
  {
    "codigo":282628002,
    "descripcion":"RUEDA HACIA UN COSTADO"
  },
  {
    "codigo":315396000,
    "descripcion":"NACIDO EN CAMBOYA"
  },
  {
    "codigo":249860006,
    "descripcion":"POSTURA APROPIADA PARA LA EDAD"
  },
  {
    "codigo":446468007,
    "descripcion":"ATIPIA CELULAR CAUSADA POR AGENTE ANTINEOPLÁSICO"
  },
  {
    "codigo":774148007,
    "descripcion":"MIOPATÍA CON CUERPOS DE POLIGLUCOSANO TIPO 1"
  },
  {
    "codigo":20484008,
    "descripcion":"ENFERMEDAD POR PRIONES"
  },
  {
    "codigo":1296601002,
    "descripcion":"HIPERTENSIÓN OCULAR DE OJO DERECHO DEBIDA A TRASTORNO VASCULAR OCULAR"
  },
  {
    "codigo":248025009,
    "descripcion":"ACUMULACIÓN"
  },
  {
    "codigo":16814004,
    "descripcion":"ENFERMEDAD INFECCIOSA NEUMOCÓCICA"
  },
  {
    "codigo":735875002,
    "descripcion":"HERIDA PUNZANTE DE DEDO DE PIE SIN CUERPO EXTRAÑO"
  },
  {
    "codigo":277123005,
    "descripcion":"ASIMETRÍA INTERHEMISFÉRICA DE LA ONDA, NO CRUZADA"
  },
  {
    "codigo":211587006,
    "descripcion":"LESIÓN EXPUESTA POR APLASTAMIENTO, DEDO DE MANO, MÚLTIPLES"
  },
  {
    "codigo":768643005,
    "descripcion":"CARIES CORONAL EN ESTADIO MODERADO"
  },
  {
    "codigo":80515008,
    "descripcion":"HEPATOMEGALIA"
  },
  {
    "codigo":439128001,
    "descripcion":"LINFEDEMA CAUSADO POR RADIACIÓN"
  },
  {
    "codigo":373592004,
    "descripcion":"AMPOLLA DE CAUSA TRAUMÁTICA"
  },
  {
    "codigo":13144005,
    "descripcion":"DEFICIENCIA DE METILCROTONIL-COENZIMA A CARBOXILASA"
  },
  {
    "codigo":45912004,
    "descripcion":"ALUCINOSIS ORGÁNICA"
  },
  {
    "codigo":1089341000119100,
    "descripcion":"OTITIS MEDIA IZQUIERDA"
  },
  {
    "codigo":296611000119106,
    "descripcion":"DISPLASIA FIBROSA MONOSTÓTICA DE HÚMERO"
  },
  {
    "codigo":734040007,
    "descripcion":"DIVERTÍCULO SOLITARIO EN COLON DERECHO"
  },
  {
    "codigo":109613004,
    "descripcion":"ENCÍA POCO ADHERIDA"
  },
  {
    "codigo":44077006,
    "descripcion":"ENTUMECIMIENTO"
  },
  {
    "codigo":240685007,
    "descripcion":"LESIÓN CUTÁNEA MIXTA POR PINTA"
  },
  {
    "codigo":271618001,
    "descripcion":"CURACIÓN DE HERIDA ALTERADA"
  },
  {
    "codigo":404525009,
    "descripcion":"HALLAZGO DE ESPECIE DE PLASMODIUM - IMPOSIBILIDAD DE ESPECIFICAR"
  },
  {
    "codigo":402690003,
    "descripcion":"PANICULITIS SECUNDARIA A NEOPLASIA MALIGNA"
  },
  {
    "codigo":238850005,
    "descripcion":"SÍNDROME DE ÚLCERAS BUCALES Y GENITALES CON INFLAMACIÓN DE CARTÍLAGO"
  },
  {
    "codigo":1254658009,
    "descripcion":"ESTENOSIS DE SEGMENTO MEDIO DE ARTERIA CORONARIA DERECHA"
  },
  {
    "codigo":240776000,
    "descripcion":"SEUDOALESQUERIOSIS SUBCUTÁNEA"
  },
  {
    "codigo":202412000,
    "descripcion":"HEMARTROSIS DE ARTICULACIÓN SACROILÍACA"
  },
  {
    "codigo":169644004,
    "descripcion":"INTENCIÓN SOBRE LA ALIMENTACIÓN DEL RECIÉN NACIDO - MAMADERA"
  },
  {
    "codigo":366252005,
    "descripcion":"HALLAZGO RELACIONADO CON LA INTEGRIDAD DEL ESFÍNTER ANAL - HALLAZGO"
  },
  {
    "codigo":12203991000119100,
    "descripcion":"TRASTORNO DE SISTEMA NERVIOSO CENTRAL DEBIDO A PROCEDIMIENTO Y POSTERIOR A ÉL"
  },
  {
    "codigo":300716006,
    "descripcion":"NO HACE UN PRESUPUESTO"
  },
  {
    "codigo":267948008,
    "descripcion":"HEMARTROSIS DE TOBILLO Y PIE"
  },
  {
    "codigo":399020009,
    "descripcion":"MIOCARDIOPATÍA CONGESTIVA"
  },
  {
    "codigo":724865002,
    "descripcion":"RADIODERMATITIS CRÓNICA DEBIDA A RADIOTERAPIA Y POSTERIOR A ELLA CAUSADA POR RADIACIÓN IONIZANTE"
  },
  {
    "codigo":298881003,
    "descripcion":"AMPLITUD DE FLEXIÓN ACTIVA DE CODO NORMAL"
  },
  {
    "codigo":397185006,
    "descripcion":"LESIÓN TRAUMÁTICA ABIERTA DE NERVIO"
  },
  {
    "codigo":266113007,
    "descripcion":"VERRUGA GENITAL"
  },
  {
    "codigo":2134003,
    "descripcion":"DOLOR DIFUSO"
  },
  {
    "codigo":295211002,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE LEVORFANOL"
  },
  {
    "codigo":229675006,
    "descripcion":"MUTISMO POSTRAUMÁTICO"
  },
  {
    "codigo":299007,
    "descripcion":"PARAFINOMA CUTÁNEO"
  },
  {
    "codigo":162304002,
    "descripcion":"CEFALEA PARIETAL"
  },
  {
    "codigo":293376003,
    "descripcion":"REACCIÓN ADVERSA A COMPUESTOS YODADOS"
  },
  {
    "codigo":719360004,
    "descripcion":"DIFICULTAD PARA UTILIZAR PALABRAS MULTISILÁBICAS"
  },
  {
    "codigo":195072008,
    "descripcion":"TAQUICARDIA PAROXÍSTICA NODAL"
  },
  {
    "codigo":94933001,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE HUESO DEL METATARSO"
  },
  {
    "codigo":193237003,
    "descripcion":"TRASTORNO MIOTÓNICO"
  },
  {
    "codigo":783061008,
    "descripcion":"SÍNDROME DE DISMORFISMO FACIAL, RETRASO DEL DESARROLLO Y ANOMALÍAS DE CONDUCTA DEBIDO A MICRODELECIÓN 10P11.21P12.31"
  },
  {
    "codigo":93098001,
    "descripcion":"FALTA DE OSIFICACIÓN DE HUESO FRONTAL"
  },
  {
    "codigo":291541009,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR CLOXACILINA"
  },
  {
    "codigo":224170003,
    "descripcion":"BAJO INGRESO FAMILIAR"
  },
  {
    "codigo":289706006,
    "descripcion":"HIPERTONO UTERINO OCASIONAL"
  },
  {
    "codigo":713855000,
    "descripcion":"DEFECTO PERSISTENTE DE EPITELIO CORNEAL"
  },
  {
    "codigo":418943003,
    "descripcion":"REACCIÓN ALÉRGICA CAUSADA POR POLEN DE ÁRBOL"
  },
  {
    "codigo":299121000119104,
    "descripcion":"HEMARTROSIS DE CODO DERECHO"
  },
  {
    "codigo":1172607006,
    "descripcion":"PLACA BACTERIANA DENTAL"
  },
  {
    "codigo":253268005,
    "descripcion":"RELACIÓN ANORMAL ENTRE VENTRÍCULOS DERECHO E IZQUIERDO"
  },
  {
    "codigo":187732006,
    "descripcion":"NEOPLASIA MALIGNA DE CARDIAS"
  },
  {
    "codigo":286036008,
    "descripcion":"CUIDA LA ROPA"
  },
  {
    "codigo":23892008,
    "descripcion":"ADIASPIROMICOSIS"
  },
  {
    "codigo":284201002,
    "descripcion":"QUEMADURA SUPERFICIAL DE LA NARIZ POR AGENTE CORROSIVO"
  },
  {
    "codigo":218665003,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR PENTOBARBITAL"
  },
  {
    "codigo":185897005,
    "descripcion":"CRIBADO DE PACIENTE NUEVO ANULADO"
  },
  {
    "codigo":249598000,
    "descripcion":"HALLAZGO RELACIONADO CON EL CONTENIDO DEL RECTO"
  },
  {
    "codigo":54825009,
    "descripcion":"GONORREA AGUDA DEL APARATO GENITOURINARIO INFERIOR"
  },
  {
    "codigo":413438002,
    "descripcion":"INSUFICIENCIA HEPÁTICA AGUDA DE CAUSA MEDICAMENTOSA"
  },
  {
    "codigo":184062003,
    "descripcion":"PACIENTE NO REGISTRADO"
  },
  {
    "codigo":216830005,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ACETILENO"
  },
  {
    "codigo":85758008,
    "descripcion":"ADICCIÓN PSICOLÓGICA"
  },
  {
    "codigo":51155003,
    "descripcion":"FRACTURAS MÚLTIPLES NO EXPUESTAS DE EXTREMIDADES SUPERIORES E INFERIORES"
  },
  {
    "codigo":83923004,
    "descripcion":"NEFRITIS INTERSTICIAL FAMILIAR"
  },
  {
    "codigo":313299006,
    "descripcion":"ENFERMEDAD PULMONAR OBSTRUCTIVA CRÓNICA, GRAVE"
  },
  {
    "codigo":870355006,
    "descripcion":"CARCINOMA NEUROENDOCRINO DE ANO"
  },
  {
    "codigo":82088000,
    "descripcion":"TRASTORNO DE LA FUNCIÓN MOTORA DEL UNDÉCIMO PAR CRANEAL"
  },
  {
    "codigo":704680001,
    "descripcion":"CONOCIMIENTO DEFICIENTE SOBRE PROCESO DE CAMBIO DE CONDUCTA"
  },
  {
    "codigo":247763008,
    "descripcion":"CONCENTRACIÓN EXCESIVA"
  },
  {
    "codigo":442536003,
    "descripcion":"INFECCIÓN MICÓTICA DE CEREBRO"
  },
  {
    "codigo":278696005,
    "descripcion":"ASPIRACIÓN DE CUERPO EXTRAÑO EN LAS VÍAS RESPIRATORIAS INFERIORES"
  },
  {
    "codigo":409768005,
    "descripcion":"EXTENSIÓN DE TUMOR HACIA CÁPSULA DE ÓRGANO"
  },
  {
    "codigo":682251000119106,
    "descripcion":"ASTROCITOMA ANAPLÁSICO PRIMARIO DE LÓBULO PARIETAL"
  },
  {
    "codigo":735613004,
    "descripcion":"OSTEOPENIA IDIOPÁTICA PREMENOPÁUSICA"
  },
  {
    "codigo":242258004,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE FENITOÍNA"
  },
  {
    "codigo":421000119103,
    "descripcion":"QUISTE COMPLEJO DE OVARIO"
  },
  {
    "codigo":406098007,
    "descripcion":"ESTADO DE LAS METÁSTASIS EN EL GANGLIO LINFÁTICO MARCADOR - DESCONOCIDO"
  },
  {
    "codigo":897618008,
    "descripcion":"FORMA DE CONO ANORMAL CONGÉNITA DE EPÍFISIS DE FALANGE DE TERCER DEDO DE PIE"
  },
  {
    "codigo":12882007,
    "descripcion":"RESISTENCIA COITAL"
  },
  {
    "codigo":209490008,
    "descripcion":"LESIÓN DE PLACA PALMAR DE ARTICULACIÓN INTERFALÁNGICA DISTAL DE DEDO DE LA MANO"
  },
  {
    "codigo":45650007,
    "descripcion":"CARDIOPATÍA CIFOESCOLIÓTICA"
  },
  {
    "codigo":109351006,
    "descripcion":"LIPOMA DE PIEL Y DE TEJIDO SUBCUTÁNEO DE EXTREMIDAD"
  },
  {
    "codigo":764711007,
    "descripcion":"SÍNDROME DE DUPLICACIÓN XQ12-Q13.3"
  },
  {
    "codigo":76583009,
    "descripcion":"CONDRODERMATITIS NODULAR HELICOIDAL"
  },
  {
    "codigo":369660003,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA DE PARÉNQUIMA PULMONAR, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":402428008,
    "descripcion":"NODULOSIS REUMATOIDE CAUSADA POR METOTREXATO"
  },
  {
    "codigo":271356008,
    "descripcion":"VÓMITO: HUEVOS PRESENTES"
  },
  {
    "codigo":302289002,
    "descripcion":"PROBLEMA DE COORDINACIÓN"
  },
  {
    "codigo":40145002,
    "descripcion":"DISFUNCIÓN CONGÉNITA DE LA ACTINA DEL NEUTRÓFILO"
  },
  {
    "codigo":7377003,
    "descripcion":"MEDIASTINITIS ESCLEROSANTE"
  },
  {
    "codigo":105681000,
    "descripcion":"ENFERMEDAD CAUSADA POR DILEPIDIDAE"
  },
  {
    "codigo":72913007,
    "descripcion":"SÍNDROME DE MOORE - FEDERMAN"
  },
  {
    "codigo":203985009,
    "descripcion":"MIELOMENINGOCELE CERVICAL"
  },
  {
    "codigo":300454005,
    "descripcion":"HALLAZGO RELACIONADO CON TAMAÑO VESICAL"
  },
  {
    "codigo":69243003,
    "descripcion":"GENIO (C.I.....)"
  },
  {
    "codigo":1052283003,
    "descripcion":"SÍNDROME DE PIERNAS INQUIETAS DEBIDO A ANEMIA FERROPÉNICA"
  },
  {
    "codigo":429691007,
    "descripcion":"NEOPLASIA BENIGNA DEL ESPACIO INTRADURAL RAQUÍDEO"
  },
  {
    "codigo":396923008,
    "descripcion":"TUMOR DEL SISTEMA NERVIOSO CENTRAL, GRADO II DE LA ORGANIZACIÓN MUNDIAL DE LA SALUD"
  },
  {
    "codigo":724603009,
    "descripcion":"ESCLEROSIS SISTÉMICA DE COMIENZO EN LA EDAD PEDIÁTRICA"
  },
  {
    "codigo":1148752002,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ESTRÓGENO Y\/O PROGESTÁGENO"
  },
  {
    "codigo":298619008,
    "descripcion":"AMPLITUD DE EXTENSIÓN PASIVA DE LA COLUMNA LUMBAR AUMENTADA"
  },
  {
    "codigo":67408008,
    "descripcion":"ESTADO PRENATAL DEL FETO"
  },
  {
    "codigo":65573001,
    "descripcion":"PELVIS DE ASIMILACIÓN ALTA"
  },
  {
    "codigo":296784008,
    "descripcion":"SOBREDOSIS DE HIDROXIQUINOLINA"
  },
  {
    "codigo":32805004,
    "descripcion":"FRACTURAS DE HUESOS MÚLTIPLES DE LA EXTREMIDAD INFERIOR"
  },
  {
    "codigo":1145082000,
    "descripcion":"PELO LARGO DE HÉLICE"
  },
  {
    "codigo":162042000,
    "descripcion":"DOLOR DE LA PARED ABDOMINAL"
  },
  {
    "codigo":131109009,
    "descripcion":"VITAMINA A POR ENCIMA DE RANGO DE REFERENCIA"
  },
  {
    "codigo":293114004,
    "descripcion":"REACCIÓN ADVERSA A VACUNA CONTRA LA PAROTIDITIS URLIANA"
  },
  {
    "codigo":719098007,
    "descripcion":"COREOATETOSIS CON HIPOTIROIDISMO CONGÉNITO Y SÍNDROME DE DISTRÉS RESPIRATORIO NEONATAL"
  },
  {
    "codigo":94671007,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE CONDUCTO DEFERENTE"
  },
  {
    "codigo":125604000,
    "descripcion":"LESIÓN TRAUMÁTICA DEL PIE"
  },
  {
    "codigo":717263009,
    "descripcion":"PSEUDOHIPOALDOSTERONISMO TRANSITORIO"
  },
  {
    "codigo":715428003,
    "descripcion":"SÍNDROME DE DISPLASIA ESQUELÉTICA CON EPILEPSIA Y BAJA ESTATURA"
  },
  {
    "codigo":289444003,
    "descripcion":"FRECUENCIA CARDÍACA FETAL, IRREGULAR"
  },
  {
    "codigo":1338020005,
    "descripcion":"MENOPAUSIA DEBIDA A RADIOTERAPIA Y POSTERIOR A ELLA"
  },
  {
    "codigo":123769001,
    "descripcion":"METAHEMOGLOBINURIA"
  },
  {
    "codigo":92836009,
    "descripcion":"FUSIÓN ANORMAL CONGÉNITA DE ARCO DE VÉRTEBRA CERVICAL"
  },
  {
    "codigo":10898291000119101,
    "descripcion":"HERIDA ABIERTA DE MEJILLA IZQUIERDA DEBIDA A MORDEDURA DE PERRO"
  },
  {
    "codigo":1336185005,
    "descripcion":"RABDOMIOSARCOMA PLEOMÓRFICO METASTÁSICO"
  },
  {
    "codigo":254841008,
    "descripcion":"CÁNCER DE MAMA EN CORAZA"
  },
  {
    "codigo":89166001,
    "descripcion":"ANOMALÍA CONGÉNITA DEL HÍGADO"
  },
  {
    "codigo":285774001,
    "descripcion":"INCAPAZ DE RECONOCER A PERSONAS CONOCIDAS"
  },
  {
    "codigo":253006001,
    "descripcion":"SOMATOSTATINOMA"
  },
  {
    "codigo":1268814004,
    "descripcion":"TENDINITIS CALCIFICANTE DE REGIÓN DE MUÑECA"
  },
  {
    "codigo":449614009,
    "descripcion":"TUMEFACCIÓN DE MIEMBRO INFERIOR"
  },
  {
    "codigo":251171001,
    "descripcion":"COMPLEJOS AURICULARES PREMATUROS MÚLTIPLES"
  },
  {
    "codigo":447779007,
    "descripcion":"VÁLVULA AURICULOVENTRICULAR IZQUIERDA TRIFOLIADA"
  },
  {
    "codigo":183800000,
    "descripcion":"ESTADÍA DE INTERNACIÓN, 2 DÍAS"
  },
  {
    "codigo":283939009,
    "descripcion":"LACERACIÓN DE VESÍCULA SEMINAL"
  },
  {
    "codigo":249336003,
    "descripcion":"NARINAS PEQUEÑAS"
  },
  {
    "codigo":773624006,
    "descripcion":"CARCINOMA AMELOBLÁSTICO PRIMARIO"
  },
  {
    "codigo":444109008,
    "descripcion":"INFECCIÓN DE HEMATOMA EN HERIDA"
  },
  {
    "codigo":212898003,
    "descripcion":"EFECTO TÓXICO DEL FORMALDEHÍDO"
  },
  {
    "codigo":704418008,
    "descripcion":"CON MAYOR RIESGO DE INFECCIÓN DE MEMBRANA MUCOSA DE LA CAVIDAD BUCAL"
  },
  {
    "codigo":276599001,
    "descripcion":"LEUCOMALACIA CEREBRAL"
  },
  {
    "codigo":409506009,
    "descripcion":"GASTROENTERITIS HEMORRÁGICA"
  },
  {
    "codigo":211063003,
    "descripcion":"ABRASIÓN INFECTADA DE PERINEO"
  },
  {
    "codigo":1259639003,
    "descripcion":"OSTEOSARCOMA PRIMARIO DE CARTÍLAGO ARTICULAR DE ESTERNÓN"
  },
  {
    "codigo":243831005,
    "descripcion":"SITUACIÓN DE LA EVALUACIÓN POSNATAL"
  },
  {
    "codigo":407671000,
    "descripcion":"NEUMONÍA BILATERAL"
  },
  {
    "codigo":15950861000119104,
    "descripcion":"MELANOMA MALIGNO DE PIEL DE MAMA DERECHA"
  },
  {
    "codigo":274764000,
    "descripcion":"SIN ANOMALÍAS DETECTADAS EN EXAMEN DE UÑA"
  },
  {
    "codigo":14455008,
    "descripcion":"PERICARDITIS CONSTRICTIVA SUBAGUDA"
  },
  {
    "codigo":241996007,
    "descripcion":"LESIÓN POR DESCOMPRESIÓN DEL NERVIO PERIFÉRICO"
  },
  {
    "codigo":209228007,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA EXPUESTA DE LA ARTICULACIÓN COSTOCONDRAL"
  },
  {
    "codigo":698913002,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: NDEBELE"
  },
  {
    "codigo":10785007,
    "descripcion":"NEUMOPATÍA DE LOS FUMIGADORES DE VIÑEDOS"
  },
  {
    "codigo":402166000,
    "descripcion":"EFECTO CRÓNICO DE RADIACIÓN ULTRAVIOLETA SOBRE PIEL NORMAL"
  },
  {
    "codigo":271094001,
    "descripcion":"DEFORMIDAD DE TIBIA"
  },
  {
    "codigo":404001007,
    "descripcion":"HISTIOCITOMA CELULAR DE PIEL"
  },
  {
    "codigo":305697008,
    "descripcion":"ATENDIDO POR PSICOGERIATRA"
  },
  {
    "codigo":860918004,
    "descripcion":"DISFUNCIÓN ERÉCTIL DEBIDA A TRASTORNO PSICOFISIOLÓGICO"
  },
  {
    "codigo":762614005,
    "descripcion":"SEXTILLIZOS MORTINATOS"
  },
  {
    "codigo":105419003,
    "descripcion":"RETRASO ESCOLAR"
  },
  {
    "codigo":236491005,
    "descripcion":"INFARTO RENAL - VENOSO"
  },
  {
    "codigo":302027007,
    "descripcion":"AUSENCIA DE VELLO SEXUAL SECUNDARIO"
  },
  {
    "codigo":1119392002,
    "descripcion":"FISURA COMPLETA DEL PALADAR DURO Y PALADAR BLANDO DERECHO"
  },
  {
    "codigo":300192003,
    "descripcion":"PRÓTESIS DE OÍDO MEDIO PRESENTE"
  },
  {
    "codigo":5280003,
    "descripcion":"PIEL LAXA SENIL"
  },
  {
    "codigo":267424007,
    "descripcion":"GLUCOGENOSIS GENERALIZADA"
  },
  {
    "codigo":431264008,
    "descripcion":"QUISTE DE MEDIASTINO"
  },
  {
    "codigo":298357003,
    "descripcion":"PROTRUSIÓN ÓSEA"
  },
  {
    "codigo":429429006,
    "descripcion":"MASA DE NASOFARINGE"
  },
  {
    "codigo":15734081000119102,
    "descripcion":"DESPRENDIMIENTO TOTAL DE RETINA ANTIGUO BILATERAL"
  },
  {
    "codigo":396661009,
    "descripcion":"MUSCULAR PROPIA AUSENTE EN ESPÉCIMEN"
  },
  {
    "codigo":68981009,
    "descripcion":"TIFO POR GARRAPATAS DE QUEENSLAND"
  },
  {
    "codigo":198218005,
    "descripcion":"VULVOVAGINITIS ASOCIADA CON OTRO TRASTORNO"
  },
  {
    "codigo":722506008,
    "descripcion":"VARIACIÓN CON RESPECTO A OBJETIVO DE PLAN DE ATENCIÓN"
  },
  {
    "codigo":294687008,
    "descripcion":"ALERGIA A FLUOCINONIDA"
  },
  {
    "codigo":784372002,
    "descripcion":"EPILEPSIA DE LÓBULO TEMPORAL MESIAL FAMILAR CON CONVULSIONES FEBRILES"
  },
  {
    "codigo":1144820002,
    "descripcion":"INTOXICACIÓN CAUSADA POR PROTAMINA"
  },
  {
    "codigo":292852005,
    "descripcion":"REACCIÓN ADVERSA A LA MEFLOQUINA"
  },
  {
    "codigo":225481000,
    "descripcion":"CONDUCTA ABUSIVA"
  },
  {
    "codigo":291017000,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR CICLOBARBITAL"
  },
  {
    "codigo":94409002,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE MEDIASTINO"
  },
  {
    "codigo":422089004,
    "descripcion":"ENCEFALOMIELITIS CON SÍNDROME DE INMUNODEFICIENCIA ADQUIRIDA"
  },
  {
    "codigo":192713006,
    "descripcion":"ENCEFALITIS POSVACUNACIÓN CONTRA LA VIRUELA"
  },
  {
    "codigo":127177008,
    "descripcion":"LINFADENOPATÍA SACRA"
  },
  {
    "codigo":258249009,
    "descripcion":"ESTADIO SX DE TUMOR DE LA ESCLERÓTICA"
  },
  {
    "codigo":1237619001,
    "descripcion":"DEFICIENCIA DE ACIL-COA REDUCTASA 1 DE ÁCIDOS GRASOS"
  },
  {
    "codigo":27038009,
    "descripcion":"QUISTE DE GLÁNDULA LAGRIMAL"
  },
  {
    "codigo":92574009,
    "descripcion":"CARCINOMA IN SITU DE CONDUCTO CÍSTICO"
  },
  {
    "codigo":90739004,
    "descripcion":"TIROTOXICOSIS"
  },
  {
    "codigo":57971009,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE ESCROTO SIN INFECCIÓN"
  },
  {
    "codigo":449352003,
    "descripcion":"OBSTRUCCIÓN AL TRACTO DE SALIDA DE VENTRÍCULO DERECHO POR BANDAS DE MÚSCULO CARDÍACO ANORMALES"
  },
  {
    "codigo":689781000119100,
    "descripcion":"CARCINOMA DE CÉLULAS DE TRANSICIÓN DE CUELLO DE VEJIGA URINARIA"
  },
  {
    "codigo":285512007,
    "descripcion":"CAPAZ DE RETRAER LA LENGUA"
  },
  {
    "codigo":283677000,
    "descripcion":"HERIDA POR PINCHAZO DE CLAVO EN DEDO DEL PIE"
  },
  {
    "codigo":185373006,
    "descripcion":"DERIVADO POR LA FAMILIA"
  },
  {
    "codigo":249074000,
    "descripcion":"SUPERPOSICIÓN DE SUTURAS REDUCTIBLE"
  },
  {
    "codigo":609522002,
    "descripcion":"TRASTORNO DE MEMBRANA EXTRAEMBRIONARIA"
  },
  {
    "codigo":871666003,
    "descripcion":"COMPONENTE ATÍPICO DE VENTRÍCULO IZQUIERDO DE VÁLVULA AURICULOVENTRICULAR COMÚN"
  },
  {
    "codigo":19698004,
    "descripcion":"INFESTACIÓN CAUSADA POR PULEX"
  },
  {
    "codigo":212636000,
    "descripcion":"INTOXICACIÓN POR GLUTETIMIDA"
  },
  {
    "codigo":704156004,
    "descripcion":"FRACTURA NO EXPUESTA DE FALANGE DE DEDO MAYOR DE LA MANO"
  },
  {
    "codigo":81564005,
    "descripcion":"OTITIS MEDIA CRÓNICA SEROSA"
  },
  {
    "codigo":1259377000,
    "descripcion":"CARCINOMA BASOCELULAR PRIMARIO CON DIFERENCIACIÓN ECRINA"
  },
  {
    "codigo":48796009,
    "descripcion":"SÍNDROME NEFRÓTICO CONGÉNITO"
  },
  {
    "codigo":702321005,
    "descripcion":"PARÁLISIS CEREBRAL PENTAPLÉJICA"
  },
  {
    "codigo":733254002,
    "descripcion":"LUXACIÓN TRAUMÁTICA DE ARTICULACIÓN CARPOMETACARPIANA"
  },
  {
    "codigo":405574003,
    "descripcion":"RUPTURA GÁSTRICA NO TRAUMÁTICA"
  },
  {
    "codigo":15982351000119103,
    "descripcion":"DEBILIDAD DE MÚSCULO FACIAL DERECHO DEBIDA A HEMORRAGIA SUBARACNOIDEA INTRACRANEAL NO TRAUMÁTICA Y POSTERIOR A ELLA"
  },
  {
    "codigo":403739000,
    "descripcion":"REACCIÓN CUTÁNEA A VENENO VESICANTE"
  },
  {
    "codigo":45126009,
    "descripcion":"ÁNTRAX DE RODILLA"
  },
  {
    "codigo":698651000,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: ABJASIO"
  },
  {
    "codigo":208966009,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA NO EXPUESTA DE LA CABEZA DEL PERONÉ"
  },
  {
    "codigo":239899000,
    "descripcion":"POLIMIOSITIS ASOCIADA CON ENFERMEDAD AUTOINMUNITARIA"
  },
  {
    "codigo":370971007,
    "descripcion":"SÍNDROME DE SOMNOLENCIA"
  },
  {
    "codigo":895259009,
    "descripcion":"FORMA TRIANGULAR ANORMAL CONGÉNITA DE FALANGE PROXIMAL DE DEDO ANULAR"
  },
  {
    "codigo":762352004,
    "descripcion":"DESMIELINIZACIÓN DEBIDA A VASCULITIS SISTÉMICA"
  },
  {
    "codigo":11777961000119100,
    "descripcion":"RUPTURA TRAUMÁTICA DEL TENDÓN DISTAL DE BÍCEPS BRAQUIAL DERECHO"
  },
  {
    "codigo":238064009,
    "descripcion":"SÍNDROME DE TIPO ZELLWEGER"
  },
  {
    "codigo":400069004,
    "descripcion":"PSORIASIS NEVOIDE"
  },
  {
    "codigo":39621005,
    "descripcion":"TRASTORNO DE LA VESÍCULA BILIAR"
  },
  {
    "codigo":301765007,
    "descripcion":"HEMATOMA CEREBELOSO"
  },
  {
    "codigo":234394001,
    "descripcion":"HEMOGLOBINA DE ALTA AFINIDAD"
  },
  {
    "codigo":299930004,
    "descripcion":"HALLAZGO RELACIONADO CON MEDICIONES DE LA SENSIBILIDAD AL TACTO"
  },
  {
    "codigo":10958761000119103,
    "descripcion":"HERIDA ABIERTA DE MANO DERECHA"
  },
  {
    "codigo":365466006,
    "descripcion":"HALLAZGO RELACIONADO CON LA CANTIDAD DE CAMBIOS DE ESCUELA"
  },
  {
    "codigo":5018006,
    "descripcion":"INFECCIÓN CAUSADA POR PROBSTMAYRIA"
  },
  {
    "codigo":298095004,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE LA INGLE"
  },
  {
    "codigo":230724001,
    "descripcion":"ANGIOPATÍA AMILOIDE CEREBRAL"
  },
  {
    "codigo":396399009,
    "descripcion":"MARGEN QUIRÚRGICO LATERAL NO COMPROMETIDO POR MELANOMA IN SITU"
  },
  {
    "codigo":296260004,
    "descripcion":"SOBREDOSIS INTENCIONAL DE DECANOATO DE FLUPENTIXOL"
  },
  {
    "codigo":34116005,
    "descripcion":"TRASTORNO DE PÁNICO CON AGORAFOBIA, EVITACIÓN AGORAFÓBICA EN REMISIÓN TOTAL Y ATAQUES DE PÁNICO GRAVES"
  },
  {
    "codigo":66884007,
    "descripcion":"INTOXICACIÓN POR NICOTINA"
  },
  {
    "codigo":65049003,
    "descripcion":"INFLAMACIÓN GONOCÓCICA AGUDA DE VESÍCULAS SEMINALES"
  },
  {
    "codigo":294425005,
    "descripcion":"ALERGIA A NOXITIOLINA"
  },
  {
    "codigo":720409006,
    "descripcion":"FARMACOTERAPIA ANTIPSICÓTICA EN ALTAS DOSIS"
  },
  {
    "codigo":63214000,
    "descripcion":"APNEA VAGAL"
  },
  {
    "codigo":718574003,
    "descripcion":"SÍNDROME DE FISURA DE PALADAR CON COLOBOMA OCULAR Y SORDERA"
  },
  {
    "codigo":292590007,
    "descripcion":"REACCIÓN ADVERSA AL DIMETINDENO"
  },
  {
    "codigo":194286008,
    "descripcion":"OTITIS MEDIA SUPURATIVA BILATERAL"
  },
  {
    "codigo":94147001,
    "descripcion":"MASA DEL MEDIASTINO"
  },
  {
    "codigo":421827003,
    "descripcion":"ENCEFALOPATÍA CON SÍNDROME DE INMUNODEFICIENCIA ADQUIRIDA"
  },
  {
    "codigo":126915004,
    "descripcion":"NEOPLASIA DE LOS ANEXOS UTERINOS"
  },
  {
    "codigo":288920002,
    "descripcion":"INCAPAZ DE MASTICAR"
  },
  {
    "codigo":26776003,
    "descripcion":"HIPOTONÍA VASOMOTORA"
  },
  {
    "codigo":92312004,
    "descripcion":"NEOPLASIA BENIGNA DEL SENO PIRIFORME"
  },
  {
    "codigo":713069004,
    "descripcion":"EN TRANSICIÓN DE SERVICIO DE GUARDA INFANTIL A GUARDA PARA ADULTOS"
  },
  {
    "codigo":188781005,
    "descripcion":"NEOPLASIA BENIGNA DE FRENILLO DE LABIO INFERIOR"
  },
  {
    "codigo":287085006,
    "descripcion":"ANOMALÍAS CONGÉNITAS GENITOURINARIAS"
  },
  {
    "codigo":385389007,
    "descripcion":"ESTADIO DE LINFOMA - HALLAZGO"
  },
  {
    "codigo":55874001,
    "descripcion":"FRACTURA DE CUELLO DE HUESO METACARPIANO"
  },
  {
    "codigo":186946009,
    "descripcion":"LINFOGRANULOMA VENÉREO"
  },
  {
    "codigo":840471002,
    "descripcion":"HIDROCEFALIA DEBIDA A MALFORMACIÓN DE DANDY-WALKER"
  },
  {
    "codigo":414487007,
    "descripcion":"MANTENIMIENTO DE LA SALUD INEFICAZ"
  },
  {
    "codigo":54039008,
    "descripcion":"VOZ FORZADA - ESTRANGULADA"
  },
  {
    "codigo":283415009,
    "descripcion":"CORTE EN MUÑECA"
  },
  {
    "codigo":442259005,
    "descripcion":"INFECCIÓN CAUSADA POR TRYPANOSOMA BRUCEI BRUCEI"
  },
  {
    "codigo":311671000119100,
    "descripcion":"DERMATOMIOSITIS JUVENIL CONCOMITANTE CON COMPROMISO RESPIRATORIO"
  },
  {
    "codigo":1230017000,
    "descripcion":"LESIÓN DEL PLEXO BRAQUIAL OBSTÉTRICA SIN RECUPERACIÓN"
  },
  {
    "codigo":771265006,
    "descripcion":"SÍNDROME DE TEEBI SHALTOUT"
  },
  {
    "codigo":17601009,
    "descripcion":"SUBLUXACIÓN CONGÉNITA DEL CARPO"
  },
  {
    "codigo":277910004,
    "descripcion":"ESPUTO MARRÓN"
  },
  {
    "codigo":81302005,
    "descripcion":"PREOCUPADO PERO BIEN"
  },
  {
    "codigo":48534006,
    "descripcion":"INTOXICACIÓN POR TRANQUILIZANTE FENOTIAZÍNICO"
  },
  {
    "codigo":46699001,
    "descripcion":"BURSITIS GONOCÓCICA"
  },
  {
    "codigo":276075005,
    "descripcion":"PREOCUPACIONES LABORALES"
  },
  {
    "codigo":407147006,
    "descripcion":"INTOXICACIÓN CON HEXACLOROBENCENO"
  },
  {
    "codigo":439915009,
    "descripcion":"COMPLICACIÓN DE INJERTO DE PIEL ARTIFICIAL Y ALODERMIS DESCELULARIZADA"
  },
  {
    "codigo":30071000175109,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN EN TOBILLO DERECHO"
  },
  {
    "codigo":1290048006,
    "descripcion":"FUGA DE AMPOLLA FILTRANTE DE AMBOS OJOS"
  },
  {
    "codigo":700224007,
    "descripcion":"LA PERSONA A CARGO DEL CUIDADO NO ENTIENDE EL PLAN DE ATENCIÓN"
  },
  {
    "codigo":285201000119100,
    "descripcion":"ESTENOSIS DE ARTERIA CARÓTIDA DERECHA"
  },
  {
    "codigo":43029002,
    "descripcion":"POSTURA ANORMAL"
  },
  {
    "codigo":10633591000119107,
    "descripcion":"CELULITIS DE PULGAR IZQUIERDO"
  },
  {
    "codigo":367121000119101,
    "descripcion":"PROLAPSO CONGÉNITO DE MEATO URINARIO"
  },
  {
    "codigo":403477005,
    "descripcion":"VULVITIS POR SEMEN"
  },
  {
    "codigo":1157141006,
    "descripcion":"ASTROBLASTOMA DEL SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":73962000,
    "descripcion":"ABSCESO DE PERITONEO"
  },
  {
    "codigo":1222677008,
    "descripcion":"ENFERMEDAD PULMONAR INTERSTICIAL DEBIDA A DEFICIENCIA DE PROTEÍNA C DE SURFACTANTE"
  },
  {
    "codigo":1351914008,
    "descripcion":"HEMANGIOBLASTOMA DE HÍGADO"
  },
  {
    "codigo":301503000,
    "descripcion":"CAPAZ DE ENTRAR Y SALIR DE LA DUCHA"
  },
  {
    "codigo":72127003,
    "descripcion":"HIPOSTASIS"
  },
  {
    "codigo":235967003,
    "descripcion":"CISTOADENOMA DE PÁNCREAS"
  },
  {
    "codigo":15686161000119104,
    "descripcion":"ARTRITIS INFECCIOSA DE ARTICULACIÓN DE AMBAS REGIONES DE HOMBRO"
  },
  {
    "codigo":299668000,
    "descripcion":"UÑAS GRISES"
  },
  {
    "codigo":203199009,
    "descripcion":"ABSCESO DE BRODIE DE LA COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":168596004,
    "descripcion":"RADIOGRAFÍA SIMPLE DE CLAVÍCULA ANORMAL"
  },
  {
    "codigo":234132006,
    "descripcion":"ALTERACIÓN CONGÉNITA DE GRANDES VENAS Y SENO CORONARIO"
  },
  {
    "codigo":397972007,
    "descripcion":"MORBILIDAD RESPIRATORIA"
  },
  {
    "codigo":135828009,
    "descripcion":"BAJO ATENCIÓN DE EQUIPO COMUNITARIO DE ACCIÓN CONTRA LAS DROGAS"
  },
  {
    "codigo":428905002,
    "descripcion":"NEOPLASIA MALIGNA DEL TRACTO GASTROINTESTINAL"
  },
  {
    "codigo":365204009,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA RASURARSE"
  },
  {
    "codigo":363369002,
    "descripcion":"CARCINOMA DE LA COLA DEL PÁNCREAS"
  },
  {
    "codigo":232297009,
    "descripcion":"TRASTORNO DEL OÍDO INTERNO"
  },
  {
    "codigo":230462002,
    "descripcion":"MIGRAÑA CON AURA TÍPICA"
  },
  {
    "codigo":197694003,
    "descripcion":"SÍNDROME NEFRÍTICO RÁPIDAMENTE PROGRESIVO, GLOMERULONEFRITIS PROLIFERATIVA ENDOCAPILAR DIFUSA"
  },
  {
    "codigo":66622006,
    "descripcion":"HIPERTROFIA DE AMÍGDALAS Y ADENOIDES"
  },
  {
    "codigo":164926008,
    "descripcion":"ONDA S PROFUNDA"
  },
  {
    "codigo":46771000087102,
    "descripcion":"ÚLCERA SANGRANTE DE MUCOSA DE INTESTINO GRUESO"
  },
  {
    "codigo":64787009,
    "descripcion":"DESPLAZAMIENTO DE DISCO INTERVERTEBRAL DORSAL, SIN MIELOPATÍA"
  },
  {
    "codigo":41651000087106,
    "descripcion":"CELULITIS DE PIERNA IZQUIERDA"
  },
  {
    "codigo":44211000087107,
    "descripcion":"CONTUSIÓN DE REGIÓN DE COLUMNA VERTEBRAL LUMBAR"
  },
  {
    "codigo":62952004,
    "descripcion":"QUEMADURA EPIDÉRMICA DE RODILLA"
  },
  {
    "codigo":33971000087109,
    "descripcion":"LESIONES TRAUMÁTICAS MÚLTIPLES DE APARATO DIGESTIVO"
  },
  {
    "codigo":39091000087109,
    "descripcion":"DOLOR CRÓNICO POSTERIOR A REPARACIÓN DE HERNIA"
  },
  {
    "codigo":95720007,
    "descripcion":"PIGMENTACIÓN CAPSULAR ANTERIOR ADQUIRIDA"
  },
  {
    "codigo":292328007,
    "descripcion":"REACCIÓN ADVERSA A LA ETOSUXIMIDA"
  },
  {
    "codigo":340651000119106,
    "descripcion":"COROIDITIS DISEMINADA GENERALIZADA DE OJO IZQUIERDO"
  },
  {
    "codigo":716477002,
    "descripcion":"DIFICULTAD PARA COMPRENDER INSTRUCCIONES DE MÁS DE DOS PARTES"
  },
  {
    "codigo":224957006,
    "descripcion":"HALLAZGO RELACIONADO CON EL COLOR DE LOS LABIOS"
  },
  {
    "codigo":126653006,
    "descripcion":"NEOPLASIA DEL ANTEBRAZO"
  },
  {
    "codigo":93885006,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE ÓRGANO GENITAL MASCULINO"
  },
  {
    "codigo":92050000,
    "descripcion":"NEOPLASIA BENIGNA DEL CEREBELO"
  },
  {
    "codigo":1306301007,
    "descripcion":"GLAUCOMA DE ÁNGULO CERRADO DE OJO IZQUIERDO"
  },
  {
    "codigo":59282003,
    "descripcion":"EMBOLIA PULMONAR"
  },
  {
    "codigo":288658000,
    "descripcion":"CAPAZ DE TURNARSE PARA HABLAR"
  },
  {
    "codigo":24679000,
    "descripcion":"TORACÓPAGO PARASITARIO"
  },
  {
    "codigo":254055004,
    "descripcion":"ATELOSTEOGÉNESIS TIPO 2"
  },
  {
    "codigo":286823007,
    "descripcion":"RASGO DE LA PERSONALIDAD: TENDENCIA SÁDICA - HALLAZGO"
  },
  {
    "codigo":417895009,
    "descripcion":"REACCIÓN ADVERSA A AGENTE TÓPICO"
  },
  {
    "codigo":284988002,
    "descripcion":"NO SE DESVISTE"
  },
  {
    "codigo":88380005,
    "descripcion":"SÍNDROME LACTOALCALINO AGUDO"
  },
  {
    "codigo":448828005,
    "descripcion":"DEFICIENCIA DE VALVA DE VÁLVULA MITRAL"
  },
  {
    "codigo":86545000,
    "descripcion":"FRAMBESIA LATENTE (SEROLOGÍA POSITIVA)"
  },
  {
    "codigo":446993003,
    "descripcion":"CALCIFICACIÓN DE MÚSCULO"
  },
  {
    "codigo":858901000000108,
    "descripcion":"EMBARAZO DE LOCALIZACIÓN DESCONOCIDA"
  },
  {
    "codigo":283153005,
    "descripcion":"CUERPO EXTRAÑO METÁLICO EN EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":709137006,
    "descripcion":"ESTADO DEL PACIENTE NO DETERMINADO"
  },
  {
    "codigo":21009004,
    "descripcion":"INFECCIÓN POR ECHINOCOCCUS MULTILOCULARIS"
  },
  {
    "codigo":445158000,
    "descripcion":"QUISTE COLOIDE DE GLÁNDULA HIPÓFISIS"
  },
  {
    "codigo":248550001,
    "descripcion":"NO PUEDE RESPIRAR LO SUFICIENTEMENTE PROFUNDO"
  },
  {
    "codigo":1264358001,
    "descripcion":"CISTADENOCARCINOMA MUCINOSO DE PÁNCREAS METASTÁSICO"
  },
  {
    "codigo":51942003,
    "descripcion":"ESPASMO DIFUSO"
  },
  {
    "codigo":1231590003,
    "descripcion":"OBSTRUCCIÓN DE LUZ DE VÍA RESPIRATORIA CAUSADA POR INHALACIÓN DE TAPA DE LAPICERA"
  },
  {
    "codigo":838374005,
    "descripcion":"NEOPLASIA INTRAEPITELIAL PLANA DE ALTO GRADO DE CONDUCTO BILIAR"
  },
  {
    "codigo":11838431000119102,
    "descripcion":"LACERACIÓN DE MÚSCULO INTRÍNSECO DE DEDO ÍNDICE IZQUIERDO"
  },
  {
    "codigo":215782005,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR GASES O HUMOS A BORDO DE BARCO, OCUPANTE DE PEQUEÑA EMBARCACIÓN MOTORIZADA LESIONADO"
  },
  {
    "codigo":707302008,
    "descripcion":"LESIÓN TRAUMÁTICA DE LABIO AUTOINFLIGIDA"
  },
  {
    "codigo":769168000,
    "descripcion":"NEOPLASIA INTRAEPITELIAL GLANDULAR CERVICAL DE BAJO GRADO"
  },
  {
    "codigo":1295291009,
    "descripcion":"SINOVITIS CRÓNICA DE CADERA DEBIDA A HEMARTROSIS"
  },
  {
    "codigo":212112003,
    "descripcion":"QUEMADURA QUE COMPROMETE 80-89 PORCIENTO DE LA SUPERFICIE DEL CUERPO, CON QUEMADURA DE ESPESOR COMPLETO QUE AFECTA 80-89 PORCIENTO DE LA SUPERFICIE CORPORAL"
  },
  {
    "codigo":210277000,
    "descripcion":"LACERACIÓN DE ESPESOR TOTAL DE PÁRPADO SIN COMPROMISO DE CONDUCTO LAGRIMAL"
  },
  {
    "codigo":15504009,
    "descripcion":"RUPTURA OBSTÉTRICA DEL ÚTERO"
  },
  {
    "codigo":243045003,
    "descripcion":"LESIÓN CAUSADA POR CONFLAGRACIÓN SECUNDARIA A EXPLOSIÓN NUCLEAR"
  },
  {
    "codigo":306746000,
    "descripcion":"DIFICULTAD PARA MOVER LOS LABIOS DE FORMA SIMÉTRICA"
  },
  {
    "codigo":44602002,
    "descripcion":"BRADICARDIA SINUSAL PERSISTENTE"
  },
  {
    "codigo":1080441000119103,
    "descripcion":"PAPILOMA INTRADUCTAL DE MAMA DERECHA"
  },
  {
    "codigo":110138006,
    "descripcion":"AVULSIÓN AMIGDALINA"
  },
  {
    "codigo":208442005,
    "descripcion":"FRACTURA EXPUESTA DE FALANGE DISTAL DE PULGAR, CONMINUTA"
  },
  {
    "codigo":699962008,
    "descripcion":"SECCIÓN TRAUMÁTICA COMPLETA DE AMBAS CABEZAS DE TENDÓN DE BÍCEPS BRAQUIAL"
  },
  {
    "codigo":1220580006,
    "descripcion":"COLANGITIS ESCLEROSANTE NEONATAL AISLADA"
  },
  {
    "codigo":1351652007,
    "descripcion":"INMUNODEFICIENCIA COMBINADA AUTOSÓMICA RECESIVA DEBIDA A DEFICIENCIA DE LA SUBUNIDAD GAMMA 1 DEL COMPLEJO DE CUBIERTA COPI"
  },
  {
    "codigo":39097001,
    "descripcion":"PERICARDITIS POSTRAUMÁTICA"
  },
  {
    "codigo":235705002,
    "descripcion":"ENTERITIS MEDICAMENTOSA"
  },
  {
    "codigo":399545001,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA DISTAL COMPROMETIDO POR LINFOMA"
  },
  {
    "codigo":301241008,
    "descripcion":"INCAPAZ DE ELIMINAR ESPUTO"
  },
  {
    "codigo":233870001,
    "descripcion":"PANCREATITIS RECURRENTE"
  },
  {
    "codigo":6329009,
    "descripcion":"LISTA DE REEMPLAZO DE CARNES MAGRAS"
  },
  {
    "codigo":430478003,
    "descripcion":"SÍNDROME DE ACTIVACIÓN MACROFÁGICA"
  },
  {
    "codigo":364942004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA CONTROLAR LA POSICIÓN PÉLVICA"
  },
  {
    "codigo":725390002,
    "descripcion":"LEUCEMIA MIELOIDE AGUDA CON TRANSLOCACIÓN T(8;16)(P11;P13)"
  },
  {
    "codigo":343161000119109,
    "descripcion":"GLAUCOMA UVEÍTICO BILATERAL"
  },
  {
    "codigo":4494009,
    "descripcion":"DIVERTICULITIS DEL INTESTINO GRUESO"
  },
  {
    "codigo":428643002,
    "descripcion":"ALIVIO DEL DOLOR EN DECÚBITO SUPINO"
  },
  {
    "codigo":461411004,
    "descripcion":"ANOMALÍA ADQUIRIDA DE VENA ILÍACA DERECHA"
  },
  {
    "codigo":232035005,
    "descripcion":"OCLUSIÓN DE ARTERIA DE LA RETINA"
  },
  {
    "codigo":723555007,
    "descripcion":"SÍNDROME DE DISPLASIA TÍMICA, RENAL, ANAL Y PULMONAR"
  },
  {
    "codigo":721720000,
    "descripcion":"HEMORRAGIA DE CONDUCTO BILIAR"
  },
  {
    "codigo":361272001,
    "descripcion":"ATAXIA CEREBELOSA POR ALCOHOLISMO"
  },
  {
    "codigo":440331000124103,
    "descripcion":"INGESTA ENERGÉTICA PREVISTA INADECUADA"
  },
  {
    "codigo":197432008,
    "descripcion":"DISCINESIA BILIAR"
  },
  {
    "codigo":262968008,
    "descripcion":"CONTUSIÓN INTRAMUSCULAR"
  },
  {
    "codigo":295736007,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE CARBOPLATINO"
  },
  {
    "codigo":2571000124105,
    "descripcion":"INCISIVO LATERAL SUPERIOR DERECHO PERMANENTE SUPERNUMERARIO"
  },
  {
    "codigo":460811000124108,
    "descripcion":"NO BUSCA ASISTENCIA EN SITUACIÓN DE CRISIS"
  },
  {
    "codigo":228365005,
    "descripcion":"DESEO VEHEMENTE DE ALCOHOL"
  },
  {
    "codigo":293901004,
    "descripcion":"ALERGIA A MIDAZOLAM"
  },
  {
    "codigo":292066001,
    "descripcion":"REACCIÓN ADVERSA AL MEPTAZINOL"
  },
  {
    "codigo":95458005,
    "descripcion":"OCLUSIÓN DE ARTERIA CEREBELOSA"
  },
  {
    "codigo":128226005,
    "descripcion":"TRASTORNO DE HUESO PALATINO"
  },
  {
    "codigo":290231000,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR AZAPROPAZONA"
  },
  {
    "codigo":93623004,
    "descripcion":"FALTA DE OSIFICACIÓN DE LOS HUESECILLOS DEL OÍDO"
  },
  {
    "codigo":880055007,
    "descripcion":"RIÑÓN ÚNICO FUNCIONAL"
  },
  {
    "codigo":59020000,
    "descripcion":"ADENITIS DE LA GLÁNDULA DE SKENE"
  },
  {
    "codigo":419468003,
    "descripcion":"VAGINITIS POR GARDNERELLA"
  },
  {
    "codigo":288396006,
    "descripcion":"DA CUERDA AL RELOJ"
  },
  {
    "codigo":26252007,
    "descripcion":"ENFERMEDAD GRANULOMATOSA CRÓNICA, TIPO IIA"
  },
  {
    "codigo":286561001,
    "descripcion":"CUERPO EXTRAÑO EN ESTRUCTURA CARDIOVASCULAR"
  },
  {
    "codigo":417633001,
    "descripcion":"ALUCINACIONES INDUCIDAS POR EL ALCOHOL"
  },
  {
    "codigo":57185003,
    "descripcion":"HIPOTIROIDISMO PRIMARIO"
  },
  {
    "codigo":24417004,
    "descripcion":"NEUMOPATÍA AMBIENTAL"
  },
  {
    "codigo":1236833005,
    "descripcion":"EXPOSICIÓN DE PULPA DENTAL DEBIDA A TRAUMATISMO DENTAL"
  },
  {
    "codigo":712545004,
    "descripcion":"CON ABSTINENCIA DE USO INAPROPIADO DE DROGAS EN FASE DE MANTENIMIENTO DE TERAPIA SUSTITUTIVA"
  },
  {
    "codigo":253793008,
    "descripcion":"MUCOSA RECTAL REDUNDANTE CONGÉNITA"
  },
  {
    "codigo":415798001,
    "descripcion":"PRUEBA DE ORINA PARA CHLAMYDIA TRACHOMATIS POSITIVA"
  },
  {
    "codigo":55350005,
    "descripcion":"HAMBRE DE ALIMENTOS"
  },
  {
    "codigo":186422008,
    "descripcion":"GANGRENA GASEOSA DE PIERNA"
  },
  {
    "codigo":282891002,
    "descripcion":"NO SE PARA DESDE LA POSICIÓN SENTADA"
  },
  {
    "codigo":345671000119105,
    "descripcion":"OFTALMOPLEJÍA INTERNUCLEAR DE AMBOS OJOS"
  },
  {
    "codigo":250123008,
    "descripcion":"DERRAME INTENSO EN LA BOLSA SUPRARROTULIANA"
  },
  {
    "codigo":1231328003,
    "descripcion":"DEPENDENCIA DE ANFETAMINA Y\/O DERIVADO DE ANFETAMINA, CONTINUA"
  },
  {
    "codigo":444896005,
    "descripcion":"RETARDO DE CRECIMIENTO"
  },
  {
    "codigo":1264096006,
    "descripcion":"TRASTORNO NEONATAL CAUSADO POR AGENTE ENDOCRINOLÓGICO TRANSMITIDO POR LECHE MATERNA"
  },
  {
    "codigo":262920002,
    "descripcion":"SECCIÓN DE CONDUCTO DEFERENTE"
  },
  {
    "codigo":1082951000119107,
    "descripcion":"OTITIS MEDIA MUCOIDE BILATERAL"
  },
  {
    "codigo":17077006,
    "descripcion":"FRECUENCIA RESPIRATORIA ANORMAL"
  },
  {
    "codigo":111711001,
    "descripcion":"AMPOLLA DE HOMBRO, CON INFECCIÓN"
  },
  {
    "codigo":15720161000119104,
    "descripcion":"TRASTORNO DE CARTÍLAGO ARTICULAR DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":372020000,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE AMÍGDALA"
  },
  {
    "codigo":109876001,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE TESTÍCULO DESCENDIDO"
  },
  {
    "codigo":406623009,
    "descripcion":"INFECCIÓN CAUSADA POR VIBRIO FLUVIALIS"
  },
  {
    "codigo":11788001000119106,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DE DEDO MEDIO IZQUIERDO"
  },
  {
    "codigo":699700006,
    "descripcion":"LABIO LEPORINO MEDIANO Y FISURA ALVEOLAR"
  },
  {
    "codigo":402953001,
    "descripcion":"PINTA CUTÁNEA GENERALIZADA"
  },
  {
    "codigo":206345004,
    "descripcion":"DACRIOCISTITIS Y CONJUNTIVITIS NEONATAL"
  },
  {
    "codigo":1254921006,
    "descripcion":"DERMATITIS DE CONTACTO IRRITATIVA DE PIEL DE ZONA PERIANAL"
  },
  {
    "codigo":763401009,
    "descripcion":"SÍNDROME DE ICTIOSIS Y PREMATUREZ"
  },
  {
    "codigo":237278004,
    "descripcion":"GINECORRAGIA ABUNDANTE"
  },
  {
    "codigo":73438004,
    "descripcion":"DESEMPLEADO"
  },
  {
    "codigo":302814007,
    "descripcion":"LESIÓN CUTÁNEA TEMPRANA DE FRAMBESIA"
  },
  {
    "codigo":300979000,
    "descripcion":"SÍNDROME DE ESTRÉS DEL CUIDADOR"
  },
  {
    "codigo":1187550009,
    "descripcion":"DEFICIENCIA DE PEX6"
  },
  {
    "codigo":169907002,
    "descripcion":"PUNTAJE DE APGAR AL MINUTO = 10"
  },
  {
    "codigo":71603004,
    "descripcion":"ASCITIS HEMORRÁGICA"
  },
  {
    "codigo":136781000119101,
    "descripcion":"TROMBOSIS VENOSA PROFUNDA AGUDA DE EXTREMIDAD INFERIOR COMO COMPLICACIÓN DE PROCEDIMIENTO"
  },
  {
    "codigo":318541000119102,
    "descripcion":"CIFOSIS CERVICODORSAL POSTURAL ADQUIRIDA"
  },
  {
    "codigo":323661000119103,
    "descripcion":"TUMOR TENOSINOVIAL DIFUSO DE CÉLULAS GIGANTES DE CODO DERECHO"
  },
  {
    "codigo":100941000119100,
    "descripcion":"EPILEPSIA MATERNA QUE COMPLICA EL EMBARAZO"
  },
  {
    "codigo":367181000119102,
    "descripcion":"MAL FUNCIONAMIENTO DE CISTOSTOMÍA"
  },
  {
    "codigo":341581000119106,
    "descripcion":"UVEÍTIS ANTERIOR CRÓNICA DE OJO IZQUIERDO"
  },
  {
    "codigo":295501000119104,
    "descripcion":"CALCIFICACIÓN Y OSIFICACIÓN DE MÚSCULO DEL PIE DEBIDA A QUEMADURA"
  },
  {
    "codigo":674381000119108,
    "descripcion":"DEBILIDAD DE MÚSCULO FACIAL DEBIDA A ACCIDENTE CEREBROVASCULAR ISQUÉMICO Y POSTERIOR A ÉL"
  },
  {
    "codigo":72781000119105,
    "descripcion":"ARTROFIBROSIS"
  },
  {
    "codigo":1101000119103,
    "descripcion":"APNEA OBSTRUCTIVA DEL SUEÑO DEL ADULTO"
  },
  {
    "codigo":397448007,
    "descripcion":"LINFOMA QUE COMPROMETE UNA ÚNICA REGIÓN GANGLIONAR"
  },
  {
    "codigo":4232007,
    "descripcion":"VULVITIS CRÓNICA"
  },
  {
    "codigo":15934541000119106,
    "descripcion":"DEFORMIDAD ADQUIRIDA EN CALCANEOVALGO DE PIE DERECHO"
  },
  {
    "codigo":11797581000119107,
    "descripcion":"AMPOLLA TRAUMÁTICA DE SACRO"
  },
  {
    "codigo":333901000119106,
    "descripcion":"LAGOFTALMOS MECÁNICO DE PÁRPADO DERECHO"
  },
  {
    "codigo":10852941000119107,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO DIGITAL DE DEDO MEÑIQUE IZQUIERDO"
  },
  {
    "codigo":102536004,
    "descripcion":"POSICIÓN EN DECÚBITO LATERAL IZQUIERDO"
  },
  {
    "codigo":233608005,
    "descripcion":"NEUMONÍA MENINGOCÓCICA"
  },
  {
    "codigo":299144009,
    "descripcion":"SIN AMPLITUD ACTIVA DE FLEXIÓN DE PULGAR"
  },
  {
    "codigo":199005000,
    "descripcion":"HIPERTENSIÓN PREEXISTENTE QUE COMPLICA EL EMBARAZO, PARTO Y PUERPERIO"
  },
  {
    "codigo":262706001,
    "descripcion":"LACERACIÓN DE MÉDULA ESPINAL CERVICAL"
  },
  {
    "codigo":721458002,
    "descripcion":"SÍNDROME DEL CORDÓN ANTERIOR DE MÉDULA ESPINAL AL NIVEL DEL TERCER SEGMENTO DORSAL"
  },
  {
    "codigo":67933004,
    "descripcion":"INTOXICACIÓN POR ISONIAZIDA"
  },
  {
    "codigo":295474003,
    "descripcion":"SOBREDOSIS DE ACEITE DE RICINO"
  },
  {
    "codigo":162567005,
    "descripcion":"LA FAMILIA CONOCE EL DIAGNÓSTICO"
  },
  {
    "codigo":195335005,
    "descripcion":"EMBOLIA Y\/O TROMBOSIS DE ARTERIA ILÍACA COMÚN"
  },
  {
    "codigo":717788000,
    "descripcion":"HIPOMAGNESEMIA PRIMARIA FAMILIAR CON NORMOCALCIURIA"
  },
  {
    "codigo":160732001,
    "descripcion":"RESIDENTE EN ALOJAMIENTO SEGÚN LA PARTE III DE LA LEY DE ASISTENCIA NACIONAL DE 1948"
  },
  {
    "codigo":95196002,
    "descripcion":"ESTRABISMO NO PARALÍTICO"
  },
  {
    "codigo":1078236005,
    "descripcion":"AGENESIA DE EPÍFISIS DE HUESO DE MUÑECA Y\/O MANO"
  },
  {
    "codigo":93361008,
    "descripcion":"POSICIÓN ANÓMALA CONGÉNITA DEL TIMO"
  },
  {
    "codigo":124294006,
    "descripcion":"DEFICIENCIA DE GLUTAMINA - PIRUVATO AMINOTRANSFERASA"
  },
  {
    "codigo":56923001,
    "descripcion":"ANQUILOSIS DE ARTICULACIÓN DE LA MANO"
  },
  {
    "codigo":417371003,
    "descripcion":"DESPLAZAMIENTO ANTERIOR DEL PUBIS"
  },
  {
    "codigo":384603005,
    "descripcion":"RESPUESTA LINFOCÍTICA INTRATUMORAL\/PERITUMORAL ACENTUADA"
  },
  {
    "codigo":253531006,
    "descripcion":"OBSTRUCCIÓN AL FLUJO DE SALIDA DEL VENTRÍCULO DERECHO - LOCALIZADA"
  },
  {
    "codigo":286299009,
    "descripcion":"DIFICULTAD PARA ARTICULAR CLARAMENTE"
  },
  {
    "codigo":218928002,
    "descripcion":"REACCIÓN ADVERSA CAUSADA.POR MAGALDRATO"
  },
  {
    "codigo":448304003,
    "descripcion":"ANILLO VASCULAR CON CAYADO AÓRTICO IZQUIERDO A AORTA DESCENDENTE DERECHA Y CONDUCTO ARTERIOSO DERECHO PERMEABLE"
  },
  {
    "codigo":774149004,
    "descripcion":"SÍNDROME DE DISCAPACIDAD INTELECTUAL SEVERA, MICROCEFALIA POSTNATAL PROGRESIVA, MOVIMIENTOS DE LAS MANOS ESTEREOTIPADOS EN LA LÍNEA MEDIA"
  },
  {
    "codigo":249861005,
    "descripcion":"POSTURA DE HOMBROS CAÍDOS"
  },
  {
    "codigo":282629005,
    "descripcion":"NO RUEDA HACIA UN COSTADO"
  },
  {
    "codigo":315397009,
    "descripcion":"NACIDO EN CAMERÚN"
  },
  {
    "codigo":248026005,
    "descripcion":"AMANERAMIENTOS COMPLEJOS - CONDUCTA"
  },
  {
    "codigo":1296602009,
    "descripcion":"HIPERTENSIÓN OCULAR DE OJO IZQUIERDO DEBIDA A SÍNDROME DE DISPERSIÓN PIGMENTARIA"
  },
  {
    "codigo":82351006,
    "descripcion":"CRANEOTABES"
  },
  {
    "codigo":735876001,
    "descripcion":"HERIDA PUNZANTE DE DEDO DE PIE CON CUERPO EXTRAÑO"
  },
  {
    "codigo":678371000119100,
    "descripcion":"RUPTURA DE ESFÍNTER DE PUPILA DE AMBOS OJOS"
  },
  {
    "codigo":734041006,
    "descripcion":"INSUFICIENCIA DE ARTERIA MESENTÉRICA"
  },
  {
    "codigo":209753006,
    "descripcion":"RUPTURA DE TENDÓN DE BRAZO"
  },
  {
    "codigo":439129009,
    "descripcion":"TROMBOSIS DE VASO SANGUÍNEO"
  },
  {
    "codigo":76846002,
    "descripcion":"ENDOARTERITIS PULMONAR"
  },
  {
    "codigo":45913009,
    "descripcion":"LARINGITIS"
  },
  {
    "codigo":373593009,
    "descripcion":"AMPOLLA TRAUMÁTICA DE LA PALMA DE LA MANO"
  },
  {
    "codigo":371758005,
    "descripcion":"RESULTADO POSTMORTEM"
  },
  {
    "codigo":109614005,
    "descripcion":"ENCÍA MAL ADHERIDA"
  },
  {
    "codigo":404526005,
    "descripcion":"HALLAZGO DE ESPECIE DE PLASMODIUM DIFERENTE A PLASMODIUM FALCIPARUM"
  },
  {
    "codigo":240686008,
    "descripcion":"BEJEL"
  },
  {
    "codigo":1254659001,
    "descripcion":"ESTENOSIS DE PORCIÓN DISTAL DE ARTERIA CORONARIA DERECHA"
  },
  {
    "codigo":402691004,
    "descripcion":"PANICULITIS SECUNDARIA A TRASTORNO HISTIOCÍTICO"
  },
  {
    "codigo":304387004,
    "descripcion":"CONTROL POR USO DE ANTICONCEPTIVOS ORALES"
  },
  {
    "codigo":238851009,
    "descripcion":"EROSIONES, VESÍCULAS Y CICATRICES RETICULARES CONGÉNITAS EXTENSAS"
  },
  {
    "codigo":7640004,
    "descripcion":"LINFANGITIS AGUDA DEL CUELLO"
  },
  {
    "codigo":366253000,
    "descripcion":"HALLAZGO RELACIONADO CON EL TAMAÑO DEL HÍGADO"
  },
  {
    "codigo":267949000,
    "descripcion":"DOLOR DE ARTICULACIÓN GLENOHUMERAL"
  },
  {
    "codigo":5805002,
    "descripcion":"IMPACTACIÓN DE BOLO"
  },
  {
    "codigo":300717002,
    "descripcion":"DIFICULTAD PARA HACER UN PRESUPUESTO"
  },
  {
    "codigo":202413005,
    "descripcion":"HEMARTROSIS DE ARTICULACIÓN ROTULIANA"
  },
  {
    "codigo":890541008,
    "descripcion":"EXTREMIDAD INFERIOR DE FETO PALPABLE POR VÍA VAGINAL"
  },
  {
    "codigo":38573008,
    "descripcion":"LEISHMANIASIS CUTÁNEA DIFUSA"
  },
  {
    "codigo":724866001,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE PIEL DEBIDA A RADIOTERAPIA Y POSTERIOR A ELLA"
  },
  {
    "codigo":266114001,
    "descripcion":"VERRUGAS PERIANALES"
  },
  {
    "codigo":399021008,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA ESCUCHAR LA VOZ DE LA CONVERSACIÓN"
  },
  {
    "codigo":298882005,
    "descripcion":"AMPLITUD DE FLEXIÓN ACTIVA DE CODO AUMENTADA"
  },
  {
    "codigo":102274008,
    "descripcion":"FALTA DE OSIFICACIÓN"
  },
  {
    "codigo":231511005,
    "descripcion":"NECESIDAD COMPULSIVA DE BEBER AGUA"
  },
  {
    "codigo":34903006,
    "descripcion":"QUEMADURA DEL RECTO"
  },
  {
    "codigo":297047006,
    "descripcion":"SOBREDOSIS DE FÁRMACO ANTIHIPERTENSIVO"
  },
  {
    "codigo":426284001,
    "descripcion":"QUEMADURA QUÍMICA"
  },
  {
    "codigo":721196005,
    "descripcion":"PÉNFIGO DE VULVA"
  },
  {
    "codigo":229676007,
    "descripcion":"TRASTORNO COGNITIVO RELACIONADO CON EL LENGUAJE"
  },
  {
    "codigo":424449000,
    "descripcion":"SECRECIÓN CONJUNTIVAL SEROSA"
  },
  {
    "codigo":719361000,
    "descripcion":"CAPAZ DE UTILIZAR PALABRAS MULTISILÁBICAS"
  },
  {
    "codigo":293377007,
    "descripcion":"REACCIÓN ADVERSA AL YODO"
  },
  {
    "codigo":783062001,
    "descripcion":"EPILEPSIA MIOCLÓNICA PROGRESIVA TIPO 6"
  },
  {
    "codigo":94934007,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL OÍDO MEDIO"
  },
  {
    "codigo":193238008,
    "descripcion":"MIOTONÍA INFANTIL"
  },
  {
    "codigo":1010603001,
    "descripcion":"CARCINOMA MUCOEPIDERMOIDE PRIMARIO DE NASOFARINGE"
  },
  {
    "codigo":289707002,
    "descripcion":"HALLAZGO RELACIONADO CON LA REGULARIDAD DE LA CONTRACCIÓN UTERINA"
  },
  {
    "codigo":420779002,
    "descripcion":"DRUSAS MACULARES CONFLUENTES"
  },
  {
    "codigo":224171004,
    "descripcion":"MODERADO INGRESO FAMILIAR"
  },
  {
    "codigo":60331006,
    "descripcion":"PERCEPCIÓN AUDITIVA ANORMAL"
  },
  {
    "codigo":124032000,
    "descripcion":"NIVEL DE ANGIOTENSINA II POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1172608001,
    "descripcion":"DEPÓSITO EN DIENTE"
  },
  {
    "codigo":16026391000119106,
    "descripcion":"TROMBOSIS DE AORTA"
  },
  {
    "codigo":56661000,
    "descripcion":"DEFICIENCIA DE ENTEROPEPTIDASA INTESTINAL"
  },
  {
    "codigo":418944009,
    "descripcion":"DEPRESIÓN DEL SISTEMA NERVIOSO CENTRAL DE ORIGEN MEDICAMENTOSO"
  },
  {
    "codigo":25728009,
    "descripcion":"SÍNDROME DE HIPERNASALIDAD"
  },
  {
    "codigo":253269002,
    "descripcion":"DISCORDANCIA AURICULOVENTRICULAR"
  },
  {
    "codigo":286037004,
    "descripcion":"NO CUIDA LA ROPA"
  },
  {
    "codigo":89429001,
    "descripcion":"FIBROSIS DE CONDUCTO DEFERENTE"
  },
  {
    "codigo":187733001,
    "descripcion":"NEOPLASIA MALIGNA DEL ORIFICIO DEL CARDIAS DEL ESTÓMAGO"
  },
  {
    "codigo":417109008,
    "descripcion":"SUBLUXACIÓN DE CABEZA DE RADIO"
  },
  {
    "codigo":15672241000119102,
    "descripcion":"MACRODACTILIA DE DEDO IZQUIERDO"
  },
  {
    "codigo":22058002,
    "descripcion":"FALTA DE ATENCIÓN"
  },
  {
    "codigo":284202009,
    "descripcion":"QUEMADURA SUPERFICIAL DE LA MEJILLA POR AGENTE CORROSIVO"
  },
  {
    "codigo":413439005,
    "descripcion":"CARDIOPATÍA ISQUÉMICA AGUDA"
  },
  {
    "codigo":184063008,
    "descripcion":"EL PACIENTE FIRMÓ FORMULARIO DE REGISTRO"
  },
  {
    "codigo":216831009,
    "descripcion":"INTOXICACIÓN ACCIDENTAL DE GAS DE AGUA"
  },
  {
    "codigo":51156002,
    "descripcion":"ESCLERODERMIA EN SABLAZO"
  },
  {
    "codigo":249599008,
    "descripcion":"AMPOLLA RECTAL VACÍA"
  },
  {
    "codigo":247764002,
    "descripcion":"DISTRACCIÓN FÁCIL"
  },
  {
    "codigo":25521000119106,
    "descripcion":"NEOPLASIA HIPOTALÁMICA DE COMPORTAMIENTO INCIERTO"
  },
  {
    "codigo":870356007,
    "descripcion":"INFECCIÓN NEONATAL DE CONDUCTO NASOLAGRIMAL CAUSADA POR PSEUDOMONAS"
  },
  {
    "codigo":278697001,
    "descripcion":"NEOPLASIA DE PÁRPADO"
  },
  {
    "codigo":409769002,
    "descripcion":"CALCIFICACIÓN TUMORAL"
  },
  {
    "codigo":704681002,
    "descripcion":"CON MAYOR RIESGO DE CALIDAD DE VIDA NEGATIVA"
  },
  {
    "codigo":49321003,
    "descripcion":"MELANODONTIA INFANTIL"
  },
  {
    "codigo":16553002,
    "descripcion":"COROIDITIS"
  },
  {
    "codigo":442537007,
    "descripcion":"LINFOMA NO HODGKIN ASOCIADO CON INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":735614005,
    "descripcion":"OSTEOPENIA POSTERIOR A LA MENOPAUSIA"
  },
  {
    "codigo":897619000,
    "descripcion":"FORMA DE CONO ANORMAL CONGÉNITA DE EPÍFISIS DE FALANGE DE CUARTO DEDO DE PIE"
  },
  {
    "codigo":14718009,
    "descripcion":"BLOQUEO DE RAMA DERECHA, HEMIBLOQUEO POSTERIOR Y BLOQUEO DE RAMA IZQUIERDA INCOMPLETO"
  },
  {
    "codigo":209491007,
    "descripcion":"LESIÓN DE PLACA PALMAR, PULGAR, ARTICULACIÓN METACARPOFALÁNGICA"
  },
  {
    "codigo":242259007,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE ISOPRENALINA"
  },
  {
    "codigo":240424003,
    "descripcion":"ÚLCERA CUTÁNEA ESTREPTOCÓCICA"
  },
  {
    "codigo":76584003,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN LA REGIÓN DE LA CADERA, CON INFECCIÓN"
  },
  {
    "codigo":402429000,
    "descripcion":"BANDAS SUBCUTÁNEAS LINEALES REUMATOIDEAS"
  },
  {
    "codigo":205821003,
    "descripcion":"ARACNODACTILIA CONGÉNITA CON CONTRACTURAS"
  },
  {
    "codigo":369661004,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA DE TEJIDO ADHERIDO AL PULMÓN, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":1187026000,
    "descripcion":"VITAMINA A DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":238589009,
    "descripcion":"PRURIGO PIGMENTOSO"
  },
  {
    "codigo":16301131000119109,
    "descripcion":"MELANOSIS ADQUIRIDA PRIMARIA DE CONJUNTIVA DE OJO DERECHO"
  },
  {
    "codigo":203986005,
    "descripcion":"MIELOMENINGOCELE DORSAL"
  },
  {
    "codigo":302290006,
    "descripcion":"HALLAZGO RELACIONADO CON UN DISPOSITIVO DEL OÍDO"
  },
  {
    "codigo":105682007,
    "descripcion":"ENFERMEDAD CAUSADA POR HYMENOLEPIDIDAE"
  },
  {
    "codigo":202151000,
    "descripcion":"ARTROFITO EN ARTICULACIÓN DE LA MANO"
  },
  {
    "codigo":890279004,
    "descripcion":"DERMATITIS IRRITATIVA POR CONTACTO POR ACEITE"
  },
  {
    "codigo":300455006,
    "descripcion":"VEJIGA URINARIA GRANDE"
  },
  {
    "codigo":396924002,
    "descripcion":"TUMOR DEL SISTEMA NERVIOSO CENTRAL, GRADO III DE LA OMS"
  },
  {
    "codigo":298620002,
    "descripcion":"AMPLITUD DE EXTENSIÓN PASIVA DE LA COLUMNA LUMBAR DISMINUIDA"
  },
  {
    "codigo":724604003,
    "descripcion":"DEGENERACIÓN DE DISCO INTERVERTEBRAL DE COLUMNA VERTEBRAL CERVICAL SIN PROLAPSO DE DISCO"
  },
  {
    "codigo":36476005,
    "descripcion":"OBSTRUCCIÓN CARTILAGINOSA EXTRÍNSECA DE TROMPA DE EUSTAQUIO"
  },
  {
    "codigo":69244009,
    "descripcion":"TRASTORNO DE LA LENGUA"
  },
  {
    "codigo":1052284009,
    "descripcion":"SÍNDROME DE PIERNAS INQUIETAS EN EL EMBARAZO"
  },
  {
    "codigo":1148753007,
    "descripcion":"INTOXICACIÓN POR ESTRÓGENO Y\/O PROGESTÁGENO"
  },
  {
    "codigo":296785009,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE HIDROXIQUINOLINA"
  },
  {
    "codigo":32806003,
    "descripcion":"ALTERACIÓN EN LA SUGESTIONABILIDAD"
  },
  {
    "codigo":131110004,
    "descripcion":"NIVEL DE VITAMINA A POR DEBAJO DE RANGO DE REFERENCIA"
  },
  {
    "codigo":10677631000119103,
    "descripcion":"HIPERHIDROSIS FOCAL PRIMARIA DE PALMA DE LA MANO"
  },
  {
    "codigo":293115003,
    "descripcion":"REACCIÓN ADVERSA A VACUNA CONTRA LA TOS FERINA"
  },
  {
    "codigo":1145083005,
    "descripcion":"CRECIMIENTO ANORMAL DE PELO DE CUERO CABELLUDO DESDE DELANTE DE PABELLONES AURICULARES HASTA PORCIÓN LATERAL DE ARCOS CIGOMÁTICOS"
  },
  {
    "codigo":63739005,
    "descripcion":"OCLUSIÓN CORONARIA"
  },
  {
    "codigo":162043005,
    "descripcion":"DOLOR POR HAMBRE"
  },
  {
    "codigo":94672000,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE SUPERFICIE VENTRAL DE LENGUA"
  },
  {
    "codigo":192976002,
    "descripcion":"PARÁLISIS SUPRANUCLEAR PROGRESIVA"
  },
  {
    "codigo":717264003,
    "descripcion":"BRAQUIOLMIA AUTOSÓMICA DOMINANTE"
  },
  {
    "codigo":422352008,
    "descripcion":"OBSTRUCCIÓN DE CATÉTER URINARIO"
  },
  {
    "codigo":92837000,
    "descripcion":"FUSIÓN ANORMAL CONGÉNITA DEL ARCO DE LA VÉRTEBRA LUMBAR"
  },
  {
    "codigo":289445002,
    "descripcion":"HALLAZGO RELACIONADO CON LOS RUIDOS CARDÍACOS FETALES"
  },
  {
    "codigo":1010341003,
    "descripcion":"SUDORACIÓN DE LA MITAD IZQUIERDA DEL CUERPO"
  },
  {
    "codigo":125605004,
    "descripcion":"FRACTURA DE HUESO"
  },
  {
    "codigo":715429006,
    "descripcion":"SÍNDROME DE DISTROFIA MUSCULAR CONGÉNITA CON CATARATAS INFANTILES E HIPOGONADISMO"
  },
  {
    "codigo":123770000,
    "descripcion":"METAHEMALBUMINEMIA"
  },
  {
    "codigo":91002001,
    "descripcion":"LEUCOPLASIA DE LA LENGUA"
  },
  {
    "codigo":1336186006,
    "descripcion":"MELANOMA LÉNTIGO MALIGNO METASTÁSICO"
  },
  {
    "codigo":713594009,
    "descripcion":"PRUEBA DE APREHENSIÓN ROTULIANA POSITIVA"
  },
  {
    "codigo":1268815003,
    "descripcion":"TENDINITIS CALCIFICANTE DE REGIÓN DE TOBILLO"
  },
  {
    "codigo":449615005,
    "descripcion":"TUMEFACCIÓN DE PIERNA"
  },
  {
    "codigo":447780005,
    "descripcion":"COMUNICACIÓN INTERAURICULAR RESTRICTIVA CON CORTOCIRCUITO OBLIGATORIO"
  },
  {
    "codigo":283940006,
    "descripcion":"RUPTURA DE LA VESÍCULA SEMINAL"
  },
  {
    "codigo":445945000,
    "descripcion":"ENFERMEDAD INFECCIOSA ASOCIADA CON SÍNDROME DE INMUNODEFICIENCIA ADQUIRIDA"
  },
  {
    "codigo":183801001,
    "descripcion":"ESTADÍA DE INTERNACIÓN, 3 DÍAS"
  },
  {
    "codigo":251172008,
    "descripcion":"CORRIDA DE COMPLEJOS AURICULARES PREMATUROS"
  },
  {
    "codigo":773625007,
    "descripcion":"SÍNDROME DE BAJA ESTATURA ONICODISPLASIA, DISMORFISMO FACIAL E HIPOTRICOSIS"
  },
  {
    "codigo":216569007,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR AMANTADINA"
  },
  {
    "codigo":15648281000119108,
    "descripcion":"ANEURISMA DE PORCIÓN EXTRACRANEAL DE ARTERIA CARÓTIDA INTERNA DERECHA"
  },
  {
    "codigo":444110003,
    "descripcion":"DIABETES MELLITUS TIPO 2 BIEN CONTROLADA"
  },
  {
    "codigo":11306521000119109,
    "descripcion":"FRACTURA EXPUESTA DE HUESO ILÍACO DERECHO"
  },
  {
    "codigo":704419000,
    "descripcion":"CON MAYOR RIESGO DE DIARREA"
  },
  {
    "codigo":737187008,
    "descripcion":"INFECCIÓN DE LABIO"
  },
  {
    "codigo":1259640001,
    "descripcion":"COREA DEBIDA A ENFERMEDAD PRIÓNICA"
  },
  {
    "codigo":243832003,
    "descripcion":"SITUACIÓN DEL CRIBADO PARA DETECCIÓN DE SÍNDROME DE DOWN"
  },
  {
    "codigo":79992004,
    "descripcion":"EDAD GESTACIONAL, 12 SEMANAS"
  },
  {
    "codigo":407672007,
    "descripcion":"ATENDIDO EN CONSULTORIO ESPECIALIZADO EN PIE DIABÉTICO"
  },
  {
    "codigo":211064009,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DEL PENE"
  },
  {
    "codigo":241997003,
    "descripcion":"LESIÓN PULMONAR POR DESCOMPRESIÓN"
  },
  {
    "codigo":274765004,
    "descripcion":"SIN ANOMALÍAS DETECTADAS EN EXAMEN DE RECTO"
  },
  {
    "codigo":829986000,
    "descripcion":"EDEMA DE AMBOS PIES"
  },
  {
    "codigo":373069008,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM SIMIAE"
  },
  {
    "codigo":404002000,
    "descripcion":"HISTIOCITOMA (SEUDOSARCOMATOSO) ATÍPICO DE LA PIEL"
  },
  {
    "codigo":240162005,
    "descripcion":"OSTEOPOROSIS LOCALIZADA SECUNDARIA"
  },
  {
    "codigo":271095000,
    "descripcion":"DEFORMIDAD DEL PERONÉ"
  },
  {
    "codigo":698914008,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: OCCITANO"
  },
  {
    "codigo":16906061000119104,
    "descripcion":"CARCINOMA DE CÉLULAS DE MERKEL PRIMARIO DE PIEL DE PÁRPADO INFERIOR DERECHO"
  },
  {
    "codigo":302028002,
    "descripcion":"VELLO SEXUAL SECUNDARIO RALO"
  },
  {
    "codigo":236492003,
    "descripcion":"ANEURISMA DE ARTERIA RENAL, CONGÉNITO"
  },
  {
    "codigo":170956005,
    "descripcion":"EFECTOS COLATERALES DE TERAPIA DE REEMPLAZO HORMONAL"
  },
  {
    "codigo":38049006,
    "descripcion":"PRESENTACIÓN PÉLVICA INCOMPLETA"
  },
  {
    "codigo":1119393007,
    "descripcion":"FISURA COMPLETA DE PALADAR DURO Y PALADAR BLANDO IZQUIERDO"
  },
  {
    "codigo":300193008,
    "descripcion":"PRÓTESIS DE OÍDO MEDIO AUSENTE"
  },
  {
    "codigo":3446000,
    "descripcion":"FRACTURA EXPUESTA A NIVEL DE T7 - T12 CON LESIÓN TRAUMÁTICA DE LA MÉDULA ESPINAL"
  },
  {
    "codigo":431265009,
    "descripcion":"MICROCEFALIA FETAL"
  },
  {
    "codigo":68982002,
    "descripcion":"TRASTORNO DEL NERVIO OLFATORIO"
  },
  {
    "codigo":396662002,
    "descripcion":"MUSCULAR PROPÍA PRESENTE EN ESPÉCIMEN"
  },
  {
    "codigo":429430001,
    "descripcion":"DIVERTICULOSIS DE COLON SIGMOIDE"
  },
  {
    "codigo":200054002,
    "descripcion":"ANESTESIA OBSTÉTRICA CON COMPLICACIONES CARDÍACAS"
  },
  {
    "codigo":685901000119108,
    "descripcion":"LIPOSARCOMA PRIMARIO DE PARTES BLANDAS DE REGIÓN INGUINAL"
  },
  {
    "codigo":298358008,
    "descripcion":"RETRACCIÓN ÓSEA"
  },
  {
    "codigo":1279563000,
    "descripcion":"COMPRESIÓN DE NERVIO PERONEO SUPERFICIAL"
  },
  {
    "codigo":1345099001,
    "descripcion":"OSTEOCONDROPATÍA RADIAL BILATERAL"
  },
  {
    "codigo":722507004,
    "descripcion":"ESTADO DE LOGRO DE OBJETIVO DE PLAN DE ATENCIÓN DESCONOCIDO"
  },
  {
    "codigo":65312002,
    "descripcion":"ARTERIOSCLEROSIS CEREBRAL"
  },
  {
    "codigo":294688003,
    "descripcion":"ALERGIA A FLUOCORTOLONA"
  },
  {
    "codigo":720672008,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR TELMISARTÁN"
  },
  {
    "codigo":292853000,
    "descripcion":"REACCIÓN ADVERSA A LA HIDROXICLOROQUINA"
  },
  {
    "codigo":30709007,
    "descripcion":"INFESTACIÓN CAUSADA POR TARSONEMIDAE"
  },
  {
    "codigo":192714000,
    "descripcion":"ENCEFALITIS POSVACUNACIÓN ANTIRRÁBICA"
  },
  {
    "codigo":784373007,
    "descripcion":"BETA-MERCAPTOLACTATO CISTEÍNA-DISULFIDURIA"
  },
  {
    "codigo":127178003,
    "descripcion":"LINFADENOPATÍA PARAMETRIAL"
  },
  {
    "codigo":15978471000119109,
    "descripcion":"TROMBOSIS DE ARTERIA VERTEBRAL IZQUIERDA"
  },
  {
    "codigo":782538005,
    "descripcion":"TENDINITIS DE TOBILLO"
  },
  {
    "codigo":225482007,
    "descripcion":"CARECE DE SEGURIDAD"
  },
  {
    "codigo":94410007,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LOS GANGLIOS LINFÁTICOS MESENTÉRICOS"
  },
  {
    "codigo":258250009,
    "descripcion":"ESTADIO S0 DE TUMOR DE LA ESCLERÓTICA"
  },
  {
    "codigo":92575005,
    "descripcion":"CARCINOMA IN SITU DE COLON DESCENDENTE"
  },
  {
    "codigo":141441000119107,
    "descripcion":"TARTAMUDEZ DE COMIENZO EN LA INFANCIA"
  },
  {
    "codigo":285513002,
    "descripcion":"INCAPAZ DE RETRAER LA LENGUA"
  },
  {
    "codigo":88905005,
    "descripcion":"SARCOSPORIDIOSIS"
  },
  {
    "codigo":711497006,
    "descripcion":"COLITIS INESPECÍFICA CRÓNICA"
  },
  {
    "codigo":54302000,
    "descripcion":"SECRECIÓN POR PEZÓN"
  },
  {
    "codigo":185374000,
    "descripcion":"DERIVADO POR SU LUGAR DE TRABAJO"
  },
  {
    "codigo":250910002,
    "descripcion":"PARED VENTRICULAR IZQUIERDA ACINÉTICA"
  },
  {
    "codigo":449353008,
    "descripcion":"HIPOPLASIA DE PORCIÓN TRABECULAR DE VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":283678005,
    "descripcion":"HERIDA POR PINCHAZO DE CLAVO EN EL DEDO GORDO"
  },
  {
    "codigo":281843000,
    "descripcion":"FRACTURA DE ESPINA DE TIBIA"
  },
  {
    "codigo":21534009,
    "descripcion":"ARTRITIS CAUSADA POR ESCHERICHIA COLI"
  },
  {
    "codigo":249075004,
    "descripcion":"SUPERPOSICIÓN DE SUTURAS FIJA"
  },
  {
    "codigo":871667007,
    "descripcion":"TRASTORNO DE AORTA ASCENDENTE DEBIDO A MALFORMACIÓN CONOTRUNCAL"
  },
  {
    "codigo":738760000,
    "descripcion":"FUNCIÓN ESCASA DE TRANSPORTADOR DE ANIONES ORGÁNICOS MIEMBRO DE LA FAMILIA 1B1"
  },
  {
    "codigo":704157008,
    "descripcion":"FRACTURA NO EXPUESTA DE FALANGE DE DEDO MEÑIQUE"
  },
  {
    "codigo":688411000119109,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE PIEL DE PUNTA DE LA NARIZ"
  },
  {
    "codigo":1259378005,
    "descripcion":"MELANOMA EXTENSIVO SUPERFICIAL CUTÁNEO PRIMARIO"
  },
  {
    "codigo":208967000,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA EXPUESTA DE LA ARTICULACIÓN DE LA RODILLA"
  },
  {
    "codigo":733255001,
    "descripcion":"LUXACIÓN TRAUMÁTICA DE ARTICULACIÓN METACARPOFALÁNGICA DE PULGAR"
  },
  {
    "codigo":405575002,
    "descripcion":"RUPTURA DUODENAL NO TRAUMÁTICA"
  },
  {
    "codigo":370972000,
    "descripcion":"RETRASO EN EL TRATAMIENTO FARMACOLÓGICO"
  },
  {
    "codigo":403740003,
    "descripcion":"ENFERMEDAD CUTÁNEA CAUSADA POR ARSÉNICO"
  },
  {
    "codigo":895260004,
    "descripcion":"FORMA TRIANGULAR ANORMAL CONGÉNITA DE FALANGE DE DEDO MEÑIQUE"
  },
  {
    "codigo":239900005,
    "descripcion":"POLIMIOSITIS FARMACÓGENA"
  },
  {
    "codigo":698652007,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: AFAR"
  },
  {
    "codigo":74225001,
    "descripcion":"PARÁLISIS POR GARRAPATAS"
  },
  {
    "codigo":205297001,
    "descripcion":"DESARROLLO INCOMPLETO DE TODA LA MANO"
  },
  {
    "codigo":238065005,
    "descripcion":"ENFERMEDAD SEUDOINFANTIL DE REFSUM"
  },
  {
    "codigo":762353009,
    "descripcion":"CEFALEA AGUDA DEBIDA A LESIÓN TRAUMÁTICA DE LA CABEZA"
  },
  {
    "codigo":400070003,
    "descripcion":"CALLOSIDAD PALMAR"
  },
  {
    "codigo":301766008,
    "descripcion":"LESIÓN ENCEFÁLICA"
  },
  {
    "codigo":234395000,
    "descripcion":"METAHEMOGLOBINEMIA CONGÉNITA CON SISTEMA REDUCTOR DE METAHEMOGLOBINA DEFECTUOSO"
  },
  {
    "codigo":365467002,
    "descripcion":"ASISTENCIA A LA ESCUELA - HALLAZGO"
  },
  {
    "codigo":170694008,
    "descripcion":"CAMBIOS DE SÍNTOMAS NEUROLÓGICOS"
  },
  {
    "codigo":201627006,
    "descripcion":"CONDROCALCINOSIS DE REGIÓN DE HOMBRO CAUSADA POR CRISTALES DE FOSFATO DICÁLCICO"
  },
  {
    "codigo":396400002,
    "descripcion":"MARGEN QUIRÚRGICO LATERAL COMPROMETIDO POR MELANOMA IN SITU"
  },
  {
    "codigo":298096003,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE MUSLO"
  },
  {
    "codigo":230725000,
    "descripcion":"ANGIOPATÍA AMILOIDE CEREBRAL ESPORÁDICA"
  },
  {
    "codigo":427333007,
    "descripcion":"ESOTROPÍA CON PATRÓN EN V"
  },
  {
    "codigo":720410001,
    "descripcion":"SÍNDROME ACRO-OTO-OCULAR"
  },
  {
    "codigo":294426006,
    "descripcion":"ALERGIA A OXIMETILENO"
  },
  {
    "codigo":718575002,
    "descripcion":"SÍNDROME DE ABLÉFARON Y MACROSTOMÍA"
  },
  {
    "codigo":1144559002,
    "descripcion":"HIPOPLASIA CONGÉNITA DE DIAFRAGMA"
  },
  {
    "codigo":194287004,
    "descripcion":"OTITIS MEDIA AGUDA RECURRENTE"
  },
  {
    "codigo":292591006,
    "descripcion":"REACCIÓN ADVERSA A LA DIFENHIDRAMINA"
  },
  {
    "codigo":1275631007,
    "descripcion":"ENCEFALOPATÍA EPILÉPTICA Y DE DESARROLLO"
  },
  {
    "codigo":16583401000119105,
    "descripcion":"ARTRITIS REACTIVA DE ARTICULACIÓN DE TOBILLO DERECHO"
  },
  {
    "codigo":1306564000,
    "descripcion":"CARCINOMA LOBULILLAR DE MAMA DERECHA"
  },
  {
    "codigo":126916003,
    "descripcion":"NEOPLASIA DE TROMPA DE FALOPIO"
  },
  {
    "codigo":290756005,
    "descripcion":"INTOXICACIÓN POR FORMESTANO"
  },
  {
    "codigo":94148006,
    "descripcion":"LEUCEMIA MEGACARIOCÍTICA EN REMISIÓN"
  },
  {
    "codigo":11805571000119100,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA PROXIMAL DE DEDO ÍNDICE IZQUIERDO"
  },
  {
    "codigo":716740009,
    "descripcion":"SÍNDROME DE POTTER, FISURA DE LABIO Y PALADAR Y CARDIOPATÍA"
  },
  {
    "codigo":288921003,
    "descripcion":"MASTICA"
  },
  {
    "codigo":24942001,
    "descripcion":"UROBILINOGENURIA"
  },
  {
    "codigo":92313009,
    "descripcion":"NEOPLASIA BENIGNA DE RADIO"
  },
  {
    "codigo":713070003,
    "descripcion":"USUARIO DE DROGAS DE MANERA INDEBIDA EN EL HOGAR"
  },
  {
    "codigo":285251001,
    "descripcion":"CAPAZ DE RESISTIRSE A LOS PENSAMIENTOS PELIGROSOS"
  },
  {
    "codigo":336771000119105,
    "descripcion":"CATARATA TRAUMÁTICA CON RESOLUCIÓN PARCIAL DE AMBOS OJOS"
  },
  {
    "codigo":414488002,
    "descripcion":"BOTULISMO INFANTIL"
  },
  {
    "codigo":86808004,
    "descripcion":"MOTIVACIÓN AUMENTADA"
  },
  {
    "codigo":283416005,
    "descripcion":"CORTE EN LA MANO"
  },
  {
    "codigo":840472009,
    "descripcion":"DEFICIENCIA DE INMUNOGLOBULINA A CON DEFICIENCIA DE SUBCLASE DE INMUNOGLOBULINA G"
  },
  {
    "codigo":281581004,
    "descripcion":"MALA CONDICIÓN EN EL MOMENTO DEL NACIMIENTO SIN ASFIXIA CONOCIDA"
  },
  {
    "codigo":10822531000119108,
    "descripcion":"FRACTURA EXPUESTA DE CODO DERECHO"
  },
  {
    "codigo":248813007,
    "descripcion":"DISTORSIÓN DEL CONTORNO MAMARIO"
  },
  {
    "codigo":17602002,
    "descripcion":"AMILOIDOSIS"
  },
  {
    "codigo":246978004,
    "descripcion":"HALLAZGO DE LA ESCLERÓTICA ANTERIOR"
  },
  {
    "codigo":1230018005,
    "descripcion":"SÍNDROME CORTICOBASAL"
  },
  {
    "codigo":312514006,
    "descripcion":"SÍNDROME DE NETHERTON"
  },
  {
    "codigo":771266007,
    "descripcion":"SÍNDROME DE TORTÍCOLIS, QUELOIDES, CRIPTORQUIDIA Y DISPLASIA RENAL"
  },
  {
    "codigo":410818009,
    "descripcion":"SEUDOARTROSIS"
  },
  {
    "codigo":245143005,
    "descripcion":"INTOXICACIÓN CRÓNICA POR FLÚOR"
  },
  {
    "codigo":79468000,
    "descripcion":"PÉNFIGO CRÓNICO BENIGNO FAMILIAR"
  },
  {
    "codigo":310301000119105,
    "descripcion":"ARTRITIS GOTOSA DE RODILLA DERECHA"
  },
  {
    "codigo":276076006,
    "descripcion":"EXCEDENTE DE LICENCIA POR ENFERMEDAD"
  },
  {
    "codigo":44865000,
    "descripcion":"POLICITEMIA SECUNDARIA"
  },
  {
    "codigo":403478000,
    "descripcion":"VULVITIS POR SALIVA"
  },
  {
    "codigo":765761009,
    "descripcion":"SÍNDROME DE BRAQUIDACTILIA, MESOMELIA, DISCAPACIDAD INTELECTUAL Y DEFECTO CARDÍACO"
  },
  {
    "codigo":700225008,
    "descripcion":"EL CUIDADOR ENTIENDE EL PLAN DE ATENCIÓN"
  },
  {
    "codigo":1222678003,
    "descripcion":"ENFERMEDAD PULMONAR INTERSTICIAL DEBIDA A DEFICIENCIA DE CASSETTE DE UNIÓN A ATP, SUBFAMILIA A, MIEMBRO 3"
  },
  {
    "codigo":75798003,
    "descripcion":"PLACENTA GEMELAR DIAMNIÓTICA DICORIÓNICA"
  },
  {
    "codigo":11834551000119103,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN DE PULGAR IZQUIERDO"
  },
  {
    "codigo":1255446005,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE DEDO ANULAR"
  },
  {
    "codigo":43030007,
    "descripcion":"ESTENOSIS DE CONDUCTO BILIAR"
  },
  {
    "codigo":1351915009,
    "descripcion":"HEMANGIOBLASTOMA DE PULMÓN"
  },
  {
    "codigo":301504006,
    "descripcion":"INCAPAZ DE ENTRAR Y SALIR DE LA DUCHA"
  },
  {
    "codigo":203200007,
    "descripcion":"ABSCESO DE BRODIE DE LA COLUMNA VERTEBRAL LUMBAR"
  },
  {
    "codigo":72128008,
    "descripcion":"TRASTORNO DE REFRACCIÓN Y\/O ACOMODACIÓN"
  },
  {
    "codigo":234133001,
    "descripcion":"MALFORMACIÓN VENO-CAPILAR"
  },
  {
    "codigo":235968008,
    "descripcion":"TUMOR QUÍSTICO BENIGNO DEL PÁNCREAS EXOCRINO"
  },
  {
    "codigo":712883005,
    "descripcion":"NEUROPATÍA AUTONÓMICA DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":365205005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA UTILIZAR PRODUCTOS DE TOCADOR"
  },
  {
    "codigo":299669008,
    "descripcion":"PELO CASTAÑO ROJIZO"
  },
  {
    "codigo":363370001,
    "descripcion":"NEOPLASIA MALIGNA DEL MESENTERIO"
  },
  {
    "codigo":232298004,
    "descripcion":"ANOMALÍA ESTRUCTURAL DE LA CÓCLEA Y LABERINTO VESTIBULAR"
  },
  {
    "codigo":197695002,
    "descripcion":"SÍNDROME NEFRÍTICO RÁPIDAMENTE PROGRESIVO, GLOMERULONEFRITIS MESANGIOCAPILAR DIFUSA"
  },
  {
    "codigo":263231005,
    "descripcion":"FRACTURA EXPUESTA DE BASE DE CUELLO DE FÉMUR"
  },
  {
    "codigo":295999006,
    "descripcion":"SOBREDOSIS DE VIGABATRINA"
  },
  {
    "codigo":787519008,
    "descripcion":"LESIÓN TRAUMÁTICA POR FUERZA NO PENETRANTE NO EXPUESTA DE OJO"
  },
  {
    "codigo":1076561000119105,
    "descripcion":"BURSITIS SUBDELTOIDEA DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":359700009,
    "descripcion":"ENFERMEDAD DE VON WILLEBRAND HEREDITARIA TIPO 1A"
  },
  {
    "codigo":292329004,
    "descripcion":"REACCIÓN ADVERSA AL CLONAZEPAM"
  },
  {
    "codigo":1177065007,
    "descripcion":"ESPONDILITIS POR BRUCELLA CANIS"
  },
  {
    "codigo":126654000,
    "descripcion":"NEOPLASIA DE LA MANO"
  },
  {
    "codigo":224958001,
    "descripcion":"RETRASO GLOBAL DEL DESARROLLO"
  },
  {
    "codigo":1306302000,
    "descripcion":"BLOQUEO PUPILAR DE OJO DERECHO"
  },
  {
    "codigo":10743121000119108,
    "descripcion":"TRASTORNO DE VÁLVULA AÓRTICA EN LA MADRE QUE COMPLICA EL NACIMIENTO"
  },
  {
    "codigo":716478007,
    "descripcion":"DIFICULTAD PARA COMPRENDER INSTRUCCIONES DE MÁS DE TRES PALABRAS"
  },
  {
    "codigo":93886007,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL MAXILAR INFERIOR"
  },
  {
    "codigo":92051001,
    "descripcion":"NEOPLASIA BENIGNA DE LAS MENINGES CEREBRALES"
  },
  {
    "codigo":290494009,
    "descripcion":"INTOXICACIÓN POR PROPOFOL"
  },
  {
    "codigo":1083121000119106,
    "descripcion":"OTITIS MEDIA ADHESIVA BILATERAL"
  },
  {
    "codigo":39821000087100,
    "descripcion":"LUXACIÓN ANTERIOR DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":714643000,
    "descripcion":"ATENDIDO POR MÉDICO BARIÁTRICO"
  },
  {
    "codigo":42381000087102,
    "descripcion":"HERIDA PUNZANTE DE REGIÓN DE CODO IZQUIERDO CON CUERPO EXTRAÑO"
  },
  {
    "codigo":26515008,
    "descripcion":"DAR TOPETADAS"
  },
  {
    "codigo":34701000087104,
    "descripcion":"AEROMONAS SALMONICIDA O AEROMONAS BESTIARUM"
  },
  {
    "codigo":286824001,
    "descripcion":"TIENDE A RESTRINGIR LA AUTONOMÍA DE LOS DEMÁS"
  },
  {
    "codigo":288659008,
    "descripcion":"INCAPAZ DE ESPERAR SU TURNO EN LA CONVERSACIÓN"
  },
  {
    "codigo":55181000087109,
    "descripcion":"CON MAYOR RIESGO DE CRISIS DE SITUACIÓN"
  },
  {
    "codigo":90216006,
    "descripcion":"SIMBLÉFARON"
  },
  {
    "codigo":286341000119100,
    "descripcion":"CONEXIÓN VENOSA PULMONAR TOTALMENTE ANÓMALA A VENA HEPÁTICA"
  },
  {
    "codigo":55613002,
    "descripcion":"INGURGITACIÓN DE MAMAS ASOCIADA CON EL PARTO"
  },
  {
    "codigo":416061003,
    "descripcion":"ENROLLAMIENTO VASCULAR EN ESPIRAL"
  },
  {
    "codigo":22845004,
    "descripcion":"TABICAMIENTO CONGÉNITO DE LA VESÍCULA BILIAR"
  },
  {
    "codigo":284989005,
    "descripcion":"DIFICULTAD PARA DESVESTIRSE"
  },
  {
    "codigo":283154004,
    "descripcion":"CUERPO EXTRAÑO METÁLICO EN EL HOMBRO"
  },
  {
    "codigo":1004050005,
    "descripcion":"CONTRACTURA EN FLEXIÓN DE ARTICULACIÓN METATARSOFALÁNGICA DE DEDO GORDO"
  },
  {
    "codigo":446994009,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR SUSTANCIA BIOLÓGICA"
  },
  {
    "codigo":248551002,
    "descripcion":"NO PUEDE SOPLAR"
  },
  {
    "codigo":707303003,
    "descripcion":"RESPUESTA ANORMAL DE PRESIÓN ARTERIAL SISTÓLICA CONSECUTIVA AL EJERCICIO"
  },
  {
    "codigo":117479003,
    "descripcion":"CRISTAL URINARIO, BILIRRUBINATO DE CALCIO"
  },
  {
    "codigo":1231591004,
    "descripcion":"OBSTRUCCIÓN DE VÍA RESPIRATORIA CAUSADA POR GOMA DE BORRAR EN NARIZ"
  },
  {
    "codigo":838375006,
    "descripcion":"PANCREATITIS INFECCIOSA CRÓNICA"
  },
  {
    "codigo":84711007,
    "descripcion":"ANOMALÍA DEL PAR DE CROMOSOMAS 4"
  },
  {
    "codigo":50108000,
    "descripcion":"OSTEOCONDRODISPLASIA CON OSTEOPETROSIS"
  },
  {
    "codigo":410556000,
    "descripcion":"IRIDODIÁLISIS TRAUMÁTICA"
  },
  {
    "codigo":445159008,
    "descripcion":"FRACTURA LINEAL DE CALOTA CRANEANA"
  },
  {
    "codigo":1264359009,
    "descripcion":"SUBLUXACIÓN DE ARTICULACIÓN METATARSOFALÁNGICA DE DEDO DE PIE (SEGUNDO A QUINTO)"
  },
  {
    "codigo":15933061000119104,
    "descripcion":"NEOPLASIA BENIGNA DE TROMPA DE FALOPIO DERECHA"
  },
  {
    "codigo":82876001,
    "descripcion":"VIVIR EN CASA MÓVIL"
  },
  {
    "codigo":17340006,
    "descripcion":"NECROSIS DE LA NARIZ"
  },
  {
    "codigo":11728671000119100,
    "descripcion":"LUXACIÓN TRAUMÁTICA INTERNA NO EXPUESTA DE RODILLA DERECHA"
  },
  {
    "codigo":1079071000119101,
    "descripcion":"ANGIOSARCOMA PRIMARIO DE EXTREMIDAD INFERIOR DERECHA"
  },
  {
    "codigo":48273005,
    "descripcion":"ANEURISMA DE ARTERIA POPLÍTEA"
  },
  {
    "codigo":769169008,
    "descripcion":"NEOPLASIA INTRAEPITELIAL GLANDULAR CERVICAL DE ALTO GRADO"
  },
  {
    "codigo":212113008,
    "descripcion":"CORROSIÓN QUE COMPROMETE EL 80 AL 89 PORCIENTO DE LA SUPERFICIE CORPORAL"
  },
  {
    "codigo":243046002,
    "descripcion":"HERIDA DE GUERRA POR INCENDIO EN AERONAVE"
  },
  {
    "codigo":13670005,
    "descripcion":"TRASTORNO DE LA IDENTIDAD SEXUAL DE LA EDAD ADULTA, PREVIAMENTE HETEROSEXUAL"
  },
  {
    "codigo":111974005,
    "descripcion":"SEGUNDO RUIDO CARDÍACO NORMAL, R>2<"
  },
  {
    "codigo":208443000,
    "descripcion":"FRACTURA NO EXPUESTA DE LA FALANGE DISTAL DEL PULGAR, MARTILLO"
  },
  {
    "codigo":11835003,
    "descripcion":"TASA DE RENOVACIÓN ÓSEA NORMAL"
  },
  {
    "codigo":110139003,
    "descripcion":"LACERACIÓN SIMPLE DE LA OROFARINGE"
  },
  {
    "codigo":699963003,
    "descripcion":"SECCIÓN TRAUMÁTICA COMPLETA DE TENDÓN DE CABEZA LARGA DE BÍCEPS BRAQUIAL"
  },
  {
    "codigo":372283008,
    "descripcion":"MAMA GRANDE"
  },
  {
    "codigo":10000006,
    "descripcion":"DOLOR DE PECHO IRRADIADO HACIA OTRAS ZONAS"
  },
  {
    "codigo":403216007,
    "descripcion":"ENFERMEDAD DE SWEET POSTERIOR A INFECCIÓN"
  },
  {
    "codigo":15988511000119107,
    "descripcion":"CONJUNTIVITIS DE OJO IZQUIERDO CAUSADA POR MYCOBACTERIUM TUBERCULOSIS"
  },
  {
    "codigo":237541003,
    "descripcion":"TIROIDITIS SILENTE"
  },
  {
    "codigo":73701003,
    "descripcion":"ENFERMEDAD POR EL VIRUS MURUTUCU"
  },
  {
    "codigo":40933005,
    "descripcion":"AMILOIDOSIS CORNEAL AISLADA"
  },
  {
    "codigo":301242001,
    "descripcion":"ELIMINA ESPUTO"
  },
  {
    "codigo":235706001,
    "descripcion":"ENTERITIS FLEMONOSA DE TRACTO GASTROINTESTINAL"
  },
  {
    "codigo":299407001,
    "descripcion":"PRUEBA DEL RESALTO, POSITIVA"
  },
  {
    "codigo":233871002,
    "descripcion":"CARDIOMIOPATÍA OBSTRUCTIVA CONGÉNITA"
  },
  {
    "codigo":397711004,
    "descripcion":"NIVEL DE ATENCIÓN CONSTANTE Y COMPARABLE SUMINISTRADO EN TODOS LOS ÁMBITOS"
  },
  {
    "codigo":102799005,
    "descripcion":"SECRECIÓN NORMAL DE RENINA"
  },
  {
    "codigo":430479006,
    "descripcion":"REACCIÓN DE MAZZOTTI"
  },
  {
    "codigo":4495005,
    "descripcion":"HIPERTROFIA CONGÉNITA DE VÁLVULA URETERAL"
  },
  {
    "codigo":15716281000119105,
    "descripcion":"ENOSTOSIS DE ASTRÁGALO DERECHO"
  },
  {
    "codigo":364943009,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA ACEPTAR UNA BASE DE APOYO"
  },
  {
    "codigo":11784121000119105,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE DEDO DE MANO DERECHA"
  },
  {
    "codigo":232036006,
    "descripcion":"OCLUSIÓN DE ARTERIA CILIORRETINIANA"
  },
  {
    "codigo":461412006,
    "descripcion":"ANOMALÍA ADQUIRIDA DE VENA ILÍACA IZQUIERDA"
  },
  {
    "codigo":262969000,
    "descripcion":"HEMATOMA INTRAMUSCULAR"
  },
  {
    "codigo":723556008,
    "descripcion":"SÍNDROME DE DISPLASIA TORACOLARINGOPÉLVICA"
  },
  {
    "codigo":246664003,
    "descripcion":"HEMIANOPSIA HOMÓNIMA COMPLETA"
  },
  {
    "codigo":197433003,
    "descripcion":"PÓLIPO DE VESÍCULA BILIAR"
  },
  {
    "codigo":825003,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE LA AXILA, CON INFECCIÓN"
  },
  {
    "codigo":295737003,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE CARBOPLATINO"
  },
  {
    "codigo":361273006,
    "descripcion":"DEGENERACIÓN CEREBELOSA ALCOHÓLICA"
  },
  {
    "codigo":457742001,
    "descripcion":"CALCIFICACIÓN DE VÁLVULA AURICULOVENTRICULAR DERECHA (MORFOLÓGICAMENTE NO TRICÚSPIDE)"
  },
  {
    "codigo":31758001,
    "descripcion":"ESTADO POSTCONVULSIVO"
  },
  {
    "codigo":228366006,
    "descripcion":"HALLAZGO RELACIONADO CON LA CONDUCTA DERIVADA DEL ABUSO DE SUSTANCIAS"
  },
  {
    "codigo":293902006,
    "descripcion":"ALERGIA A DIAZEPAM"
  },
  {
    "codigo":128227001,
    "descripcion":"TRASTORNO DE HUESO CIGOMÁTICO"
  },
  {
    "codigo":95459002,
    "descripcion":"TROMBOSIS DE ARTERIA CEREBELOSA"
  },
  {
    "codigo":292067005,
    "descripcion":"REACCIÓN ADVERSA AL LEVORFANOL"
  },
  {
    "codigo":62691006,
    "descripcion":"DETERMINACIÓN DEL RESULTADO: MUERTE EVITABLE DERIVADA DE UN ERROR EN EL CRITERIO"
  },
  {
    "codigo":191928000,
    "descripcion":"PATRÓN DE USO NOCIVO DE FÁRMACO ANTIDEPRESIVO"
  },
  {
    "codigo":93624005,
    "descripcion":"FALTA DE OSIFICACIÓN DE HUESO BASIOCCIPITAL"
  },
  {
    "codigo":60856006,
    "descripcion":"INSUFICIENCIA CARDÍACA LUEGO DE CIRUGÍA CARDÍACA"
  },
  {
    "codigo":540901000124103,
    "descripcion":"MASA DE CUERDA VOCAL"
  },
  {
    "codigo":880056008,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE DEDO DEL PIE CON INFECCIÓN"
  },
  {
    "codigo":59021001,
    "descripcion":"ANGINA DE PECHO DE REPOSO"
  },
  {
    "codigo":288397002,
    "descripcion":"NO LE DA CUERDA AL RELOJ"
  },
  {
    "codigo":124557003,
    "descripcion":"DEFICIENCIA DE NUCLEOSIDASA"
  },
  {
    "codigo":386701004,
    "descripcion":"TRASTORNO DE ARTICULACIÓN DEL DESARROLLO"
  },
  {
    "codigo":671461000124109,
    "descripcion":"INCAPAZ DE CONSEGUIR PERSONA PARA CUIDADO DE NIÑOS DEBIDO A RECURSOS ECONÓMICOS LIMITADOS"
  },
  {
    "codigo":419469006,
    "descripcion":"MOVILIDAD LIMITADA DE LA LARINGE LUEGO DE RADIOTERAPIA"
  },
  {
    "codigo":157325007,
    "descripcion":"HEMATOMA EXTRADURAL TRAUMÁTICO"
  },
  {
    "codigo":290232007,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR AZAPROPAZONA"
  },
  {
    "codigo":253794002,
    "descripcion":"COLON REDUNDANTE CONGÉNITO"
  },
  {
    "codigo":712546003,
    "descripcion":"CON ABSTINENCIA DE USO INAPROPIADO DE DROGAS AL RECIBIR TERAPIA BLOQUEANTE"
  },
  {
    "codigo":89954008,
    "descripcion":"TEJIDO PANCREÁTICO ECTÓPICO EN ESTÓMAGO"
  },
  {
    "codigo":186423003,
    "descripcion":"GANGRENA GASEOSA DE PIE"
  },
  {
    "codigo":22583005,
    "descripcion":"ERUPCIÓN MEDICAMENTOSA FIJA CAUSADA POR FENOLFTALEÍNA"
  },
  {
    "codigo":448567006,
    "descripcion":"NÓDULO DE PIEL DE NARIZ"
  },
  {
    "codigo":1234999009,
    "descripcion":"TRASTORNO NEONATAL DEBIDO A INSERCIÓN VELAMENTOSA DE CORDÓN UMBILICAL"
  },
  {
    "codigo":16046471000119100,
    "descripcion":"ENFERMEDAD POR DEPÓSITO DE HIDROXIAPATITA DE RODILLA DERECHA"
  },
  {
    "codigo":444897001,
    "descripcion":"HIPOPLASIA DE HUESO MANDIBULAR"
  },
  {
    "codigo":1264097002,
    "descripcion":"TRASTORNO NEONATAL CAUSADO POR ANTICONVULSIVANTE EN LECHE MATERNA"
  },
  {
    "codigo":282892009,
    "descripcion":"DIFICULTAD PARA PARARSE DESDE LA POSICIÓN SENTADA"
  },
  {
    "codigo":248289006,
    "descripcion":"DESARROLLO FÍSICO GENERAL"
  },
  {
    "codigo":84449007,
    "descripcion":"APÉNDICE PEQUEÑO DE PIEL ACCESORIA CONGÉNITO"
  },
  {
    "codigo":344301000119109,
    "descripcion":"IRIDOCICLITIS PRIMARIA DE AMBOS OJOS"
  },
  {
    "codigo":317831000119105,
    "descripcion":"ARTRITIS NEUMOCÓCICA DE REGIÓN DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":373856008,
    "descripcion":"MOTIVO PARA UN CAMBIO EN EL CURSO DE RADIOTERAPIA"
  },
  {
    "codigo":111712008,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE CODO CON INFECCIÓN"
  },
  {
    "codigo":372021001,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL TRAPECIO"
  },
  {
    "codigo":208181004,
    "descripcion":"FRACTURA NO EXPUESTA DE PELVIS, TUBEROSIDAD ISQUIÁTICA"
  },
  {
    "codigo":699701005,
    "descripcion":"OBLITERACIÓN DE CONDUCTO RADICULAR DE DIENTE DEBIDO A MINERALIZACIÓN ANORMAL DE PULPA DENTAL"
  },
  {
    "codigo":763402002,
    "descripcion":"SÍNDROME DE PARAPLEJÍA ESPÁSTICA, NEUROPATÍA Y POIQUILODERMIA"
  },
  {
    "codigo":304650003,
    "descripcion":"CAPAZ DE EMPLEAR ESTRATEGIAS PARA LA TOMA DE DECISIONES"
  },
  {
    "codigo":1254922004,
    "descripcion":"DERMATITIS DE CONTACTO IRRITATIVA DE PIEL DE PIERNA"
  },
  {
    "codigo":402954007,
    "descripcion":"CHANCROIDE DE PENE"
  },
  {
    "codigo":237279007,
    "descripcion":"HIPERTENSIÓN TRANSITORIA DURANTE EL EMBARAZO"
  },
  {
    "codigo":302815008,
    "descripcion":"NEOPLASIA MALIGNA DE FRENILLO LABIAL"
  },
  {
    "codigo":7903009,
    "descripcion":"SÍNDROME DE HALLERMANN - STREIFF"
  },
  {
    "codigo":300980002,
    "descripcion":"ANEMIA NORMOCÍTICA"
  },
  {
    "codigo":1187551008,
    "descripcion":"HIPERTECOSIS OVÁRICA"
  },
  {
    "codigo":202676003,
    "descripcion":"ESPONDILOSIS LUMBOSACRA EN MÚLTIPLES NIVELES SIN MIELOPATÍA"
  },
  {
    "codigo":366516007,
    "descripcion":"AMPLITUD DE PRONACIÓN DE CODO - HALLAZGO"
  },
  {
    "codigo":233609002,
    "descripcion":"NEUMONÍA CAUSADA POR CHLAMYDIACEAE"
  },
  {
    "codigo":37001003,
    "descripcion":"BRADILALIA"
  },
  {
    "codigo":397449004,
    "descripcion":"LINFOMA QUE COMPROMETE MÚLTIPLES REGIONES GANGLIONARES"
  },
  {
    "codigo":168073009,
    "descripcion":"CÁLCULO: HIDROXIAPATITA"
  },
  {
    "codigo":1149278003,
    "descripcion":"ENFERMEDAD POR DEPÓSITO DE HIDROXIAPATITA DE ARTICULACIÓN DE PIE"
  },
  {
    "codigo":199006004,
    "descripcion":"ENFERMEDAD CARDÍACA HIPERTENSIVA PREEXISTENTE QUE COMPLICA EMBARAZO, PARTO Y EL PUERPERIO"
  },
  {
    "codigo":2398007,
    "descripcion":"SIGNOS ELECTROCARDIOGRÁFICOS DE TOXICIDAD POR QUINIDINA"
  },
  {
    "codigo":563001,
    "descripcion":"NISTAGMO"
  },
  {
    "codigo":295475002,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE ACEITE DE RICINO"
  },
  {
    "codigo":197171003,
    "descripcion":"PERITONITIS BACTERIANA"
  },
  {
    "codigo":426547004,
    "descripcion":"HOLLÍN EN OROFARINGE"
  },
  {
    "codigo":262707005,
    "descripcion":"LACERACIÓN DE MÉDULA ESPINAL DORSAL"
  },
  {
    "codigo":10661671000119102,
    "descripcion":"ÚLCERA DE PIE DERECHO DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":137511000119103,
    "descripcion":"PORTADOR DE DISTROFIA MUSCULAR"
  },
  {
    "codigo":162568000,
    "descripcion":"LA FAMILIA NO CONOCE EL DIAGNÓSTICO"
  },
  {
    "codigo":10684711000119104,
    "descripcion":"NÓDULO DEL TEJIDO CELULAR SUBCUTÁNEO DE LA ESPALDA"
  },
  {
    "codigo":316711000119106,
    "descripcion":"OSTEOFITO DE VÉRTEBRA"
  },
  {
    "codigo":16045351000119106,
    "descripcion":"ALTERACIÓN LA ALINEACIÓN DE LA ARTICULACIÓN SACROILÍACA DERECHA"
  },
  {
    "codigo":12241191000119108,
    "descripcion":"TENDINITIS DE CODO DERECHO"
  },
  {
    "codigo":342311000119103,
    "descripcion":"PLIEGUE COROIDEO IDIOPÁTICO"
  },
  {
    "codigo":10679591000119107,
    "descripcion":"TUMEFACCIÓN LOCALIZADA DE LA PARED TORÁCICA"
  },
  {
    "codigo":10738471000119109,
    "descripcion":"QUISTE EPIDERMOIDE DE PIEL DE MAMA IZQUIERDA"
  },
  {
    "codigo":35111000119109,
    "descripcion":"MALFORMACIÓN QUÍSTICA DE LA FOSA POSTERIOR"
  },
  {
    "codigo":117031000119109,
    "descripcion":"FALLA BIOLÓGICA DE IMPLANTE DENTAL DESPUÉS DE LA OSTEOINTEGRACIÓN"
  },
  {
    "codigo":424712007,
    "descripcion":"DIFICULTAD PARA SEGUIR UNA DIETA DESPUÉS DEL PARTO"
  },
  {
    "codigo":12246311000119109,
    "descripcion":"INFECCIÓN POSTERIOR A PROCEDIMIENTO"
  },
  {
    "codigo":293671000119109,
    "descripcion":"TRASTORNO DE CONDUCTA DEBIDO A DEMENCIA VASCULAR"
  },
  {
    "codigo":422877002,
    "descripcion":"RESPUESTA ANORMAL A ESTÍMULOS VISUALES"
  },
  {
    "codigo":16260391000119109,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE PARTES BLANDAS DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":1078237001,
    "descripcion":"AGENESIA DE EPÍFISIS DE FALANGE PROXIMAL DE MANO"
  },
  {
    "codigo":717789008,
    "descripcion":"ENFERMEDAD DE DENT TIPO 1"
  },
  {
    "codigo":93362001,
    "descripcion":"POSICIÓN ANÓMALA CONGÉNITA DE TIBIA"
  },
  {
    "codigo":193501009,
    "descripcion":"TRASTORNO VASCULAR DEL IRIS Y CUERPO CILIAR"
  },
  {
    "codigo":320341000119103,
    "descripcion":"ARTROSIS SECUNDARIA DE MANO IZQUIERDA"
  },
  {
    "codigo":224434005,
    "descripcion":"SIN AGUA POTABLE EN EL TRABAJO"
  },
  {
    "codigo":124295007,
    "descripcion":"DEFICIENCIA DE GLUTAMINA - FRUCTOSA - 6 - FOSFATO AMINOTRANSFERASA (ISOMERIZANTE)"
  },
  {
    "codigo":58759008,
    "descripcion":"INTERTRIGO"
  },
  {
    "codigo":419207008,
    "descripcion":"PLACA SENIL DE LA ESCLERÓTICA"
  },
  {
    "codigo":448305002,
    "descripcion":"ANILLO VASCULAR CON ROTACIÓN ANÓMALA Y DEXTROVERSIÓN DE CORAZÓN E HIPOPLASIA DE PULMÓN DERECHO Y CONDUCTO ARTERIAL IZQUIERDO"
  },
  {
    "codigo":218929005,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR BICARBONATO DE SODIO"
  },
  {
    "codigo":284465006,
    "descripcion":"HALLAZGO RELACIONADO CON EL FUNCIONAMIENTO PSICOSOCIAL"
  },
  {
    "codigo":86022000,
    "descripcion":"MONOPLEJÍA"
  },
  {
    "codigo":1167366000,
    "descripcion":"AGRANDAMIENTO GINGIVAL EXACERBADO POR FÁRMACO"
  },
  {
    "codigo":251697008,
    "descripcion":"DRENAJE LAGRIMAL - LIBREMENTE PERMEABLE"
  },
  {
    "codigo":249862003,
    "descripcion":"SENTARSE ERGUIDO"
  },
  {
    "codigo":774150004,
    "descripcion":"SÍNDROME DE AGENESIA SACRA, OSIFICACIÓN ANORMAL DE LOS CUERPOS VERTEBRALES Y CANAL NOTOCORDAL PERSISTENTE"
  },
  {
    "codigo":282630000,
    "descripcion":"DIFICULTAD PARA RODAR HACIA UN COSTADO"
  },
  {
    "codigo":53254000,
    "descripcion":"ACIDOSIS METABÓLICA, BRECHA ANIÓNICA AUMENTADA, DISMINUCIÓN DE LA EXCRECIÓN DE ÁCIDOS INORGÁNICOS"
  },
  {
    "codigo":315398004,
    "descripcion":"NACIDO EN CANADÁ"
  },
  {
    "codigo":248027001,
    "descripcion":"ROBO"
  },
  {
    "codigo":357421000202109,
    "descripcion":"USO DE PSILOCIBINA"
  },
  {
    "codigo":16816002,
    "descripcion":"LEUCOEDEMA DE LA LENGUA"
  },
  {
    "codigo":49584005,
    "descripcion":"COR PULMONALE AGUDO"
  },
  {
    "codigo":14981000,
    "descripcion":"FÍSTULA URETRAL"
  },
  {
    "codigo":1260165005,
    "descripcion":"SINOVITIS Y TENOSINOVITIS DE ARTICULACIÓN DE CADERA"
  },
  {
    "codigo":735877005,
    "descripcion":"MORDEDURA ABIERTA DE DEDO DE PIE"
  },
  {
    "codigo":209754000,
    "descripcion":"RUPTURA DE TENDÓN DE MÚSCULO INFRAESPINOSO"
  },
  {
    "codigo":211589009,
    "descripcion":"LESIÓN TRAUMÁTICA DE CADERA Y MUSLO POR APLASTAMIENTO"
  },
  {
    "codigo":373594003,
    "descripcion":"AMPOLLA TRAUMÁTICA DE LA PLANTA DEL PIE"
  },
  {
    "codigo":699439001,
    "descripcion":"TERCIO INFERIOR DE LA CARA CORTO"
  },
  {
    "codigo":404527001,
    "descripcion":"HALLAZGO DE BACILOS GRAMPOSITIVOS PLEOMÓRFICOS SEMEJANTES A ACTINOMICETOS"
  },
  {
    "codigo":349321000119104,
    "descripcion":"FASE HIDRÓPICA AGUDA DE QUERATOCONO DE AMBOS OJOS"
  },
  {
    "codigo":240687004,
    "descripcion":"DICHUCHWA"
  },
  {
    "codigo":76847006,
    "descripcion":"GRATIFICACIÓN"
  },
  {
    "codigo":109615006,
    "descripcion":"ENCÍA ANGOSTA"
  },
  {
    "codigo":9476000,
    "descripcion":"TIROIDITIS CRÓNICA SUPURATIVA"
  },
  {
    "codigo":271620003,
    "descripcion":"MÚSCULOS RESPIRATORIOS ACCESORIOS UTILIZADOS"
  },
  {
    "codigo":402692006,
    "descripcion":"LIPOATROFIA DIFUSA"
  },
  {
    "codigo":1254660006,
    "descripcion":"ESTENOSIS DE RAMA MARGINAL DE ARTERIA CORONARIA DERECHA"
  },
  {
    "codigo":73177007,
    "descripcion":"INTOXICACIÓN POR KALANCHOE"
  },
  {
    "codigo":169646002,
    "descripcion":"AMNIOCENTESIS PRENATAL"
  },
  {
    "codigo":202414004,
    "descripcion":"HEMARTROSIS DE ARTICULACIÓN TIBIOPERONEA"
  },
  {
    "codigo":726702005,
    "descripcion":"ENCEFALOPATÍA EPILÉPTICA CON DESMIELINIZACIÓN CEREBRAL GLOBAL"
  },
  {
    "codigo":366254006,
    "descripcion":"REFLEJO EN OJOS DE MUÑECA - HALLAZGO"
  },
  {
    "codigo":298883000,
    "descripcion":"AMPLITUD DE FLEXIÓN ACTIVA DE CODO DISMINUIDA"
  },
  {
    "codigo":397187003,
    "descripcion":"LESIÓN TRAUMÁTICA ABIERTA DE ARTERIA"
  },
  {
    "codigo":724867005,
    "descripcion":"COMPLICACIÓN DEBIDA A CIRUGÍA COSMÉTICA Y POSTERIOR A ELLA"
  },
  {
    "codigo":36739006,
    "descripcion":"PÉNFIGO ERITEMATOSO"
  },
  {
    "codigo":102275009,
    "descripcion":"OSIFICACIÓN EN FORMA DE MANCUERNAS"
  },
  {
    "codigo":297048001,
    "descripcion":"SOBREDOSIS DE BLOQUEANTE ADRENÉRGICO NEURONAL"
  },
  {
    "codigo":67672003,
    "descripcion":"INCLINACIÓN TALAR"
  },
  {
    "codigo":428120007,
    "descripcion":"ATENDIDO EN CONSULTORIO DE CIRUGÍA CARDIOTORÁCICA"
  },
  {
    "codigo":426285000,
    "descripcion":"ELECTROCARDIOGRAMA: RITMO SINUSAL NORMAL"
  },
  {
    "codigo":721197001,
    "descripcion":"POLINEUROPATÍA DEBIDA A FIBROSIS QUÍSTICA CLÁSICA"
  },
  {
    "codigo":229677003,
    "descripcion":"DISGRAFÍA PROFUNDA"
  },
  {
    "codigo":459053006,
    "descripcion":"ESPESOR DE LA NUCA FETAL AUMENTADO"
  },
  {
    "codigo":293378002,
    "descripcion":"REACCIÓN ADVERSA AL YODÓFORO"
  },
  {
    "codigo":322851000119109,
    "descripcion":"LESIÓN TRAUMÁTICA DE REGIONES SACRA Y COCCÍGEA DE COLUMNA VERTEBRAL"
  },
  {
    "codigo":719362007,
    "descripcion":"CAPAZ DE COMPRENDER EL HABLA"
  },
  {
    "codigo":29399001,
    "descripcion":"PRIMIGESTA AÑOSA"
  },
  {
    "codigo":422615001,
    "descripcion":"DIFICULTAD DEL CUIDADOR PARA PROVEER CUIDADOS FÍSICOS"
  },
  {
    "codigo":291543007,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR CARBENICILINA"
  },
  {
    "codigo":94935008,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL TERCIO MEDIO DEL ESÓFAGO"
  },
  {
    "codigo":93100001,
    "descripcion":"FALTA DE OSIFICACIÓN DE HÚMERO"
  },
  {
    "codigo":60332004,
    "descripcion":"TRIQUIASIS"
  },
  {
    "codigo":224172006,
    "descripcion":"ALTO INGRESO FAMILIAR"
  },
  {
    "codigo":1010604007,
    "descripcion":"VENTRICULOMEGALIA CEREBRAL POR ANOMALÍA CONGÉNITA"
  },
  {
    "codigo":289708007,
    "descripcion":"CONTRACCIONES UTERINAS REGULARES"
  },
  {
    "codigo":10755671000119100,
    "descripcion":"VIRUS DE INMUNODEFICIENCIA HUMANA EN LA MADRE QUE COMPLICA EL NACIMIENTO"
  },
  {
    "codigo":124033005,
    "descripcion":"NIVEL DE ANGIOTENSINA II POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":58497009,
    "descripcion":"PARÁLISIS TARDÍA DE NERVIO CUBITAL"
  },
  {
    "codigo":253270001,
    "descripcion":"RELACIÓN ANORMAL ENTRE LOS ORIFICIOS AÓRTICO Y PULMONAR"
  },
  {
    "codigo":89430006,
    "descripcion":"EVALUACIÓN DE DISCAPACIDAD: 60%"
  },
  {
    "codigo":187734007,
    "descripcion":"NEOPLASIA MALIGNA DE LA UNIÓN CARDIOESOFÁGICA DEL ESTÓMAGO"
  },
  {
    "codigo":56662007,
    "descripcion":"INTOXICACIÓN POR EUCALIPTO CLADOCALYX"
  },
  {
    "codigo":286038009,
    "descripcion":"DIFICULTAD PARA CUIDAR LA ROPA"
  },
  {
    "codigo":23894009,
    "descripcion":"ACNÉ VARIOLIFORME"
  },
  {
    "codigo":306739009,
    "descripcion":"VISTO EN EL SERVICIO DE CIRUGÍA DENTAL GENERAL"
  },
  {
    "codigo":106071000119106,
    "descripcion":"INSUFICIENCIA HIPOTALÁMICA SECUNDARIA"
  },
  {
    "codigo":249600006,
    "descripcion":"RECTO VACÍO DISTENDIDO"
  },
  {
    "codigo":247765001,
    "descripcion":"PRESTA ATENCIÓN EFÍMERA"
  },
  {
    "codigo":870357003,
    "descripcion":"DEFICIENCIA NUTRICIONAL DE CINC EN EL PERÍODO NEONATAL"
  },
  {
    "codigo":18389004,
    "descripcion":"MICROCOLON"
  },
  {
    "codigo":679511000119108,
    "descripcion":"LESIÓN VASCULAR DE PÁRPADO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":10811121000119102,
    "descripcion":"TRASTORNO DEPRESIVO MAYOR EN LA MADRE QUE COMPLICA EL NACIMIENTO"
  },
  {
    "codigo":1263573009,
    "descripcion":"NEUROPATÍA AUTONÓMICA NUTRICIONAL"
  },
  {
    "codigo":442538002,
    "descripcion":"FRACTURA POR SOBRECARGA DE PERONÉ"
  },
  {
    "codigo":82090004,
    "descripcion":"DIVERTICULOSIS DEL DUODENO SIN DIVERTICULITIS"
  },
  {
    "codigo":704682009,
    "descripcion":"CON MAYOR RIESGO DE LESIÓN TRAUMÁTICA DURANTE TRASLADO"
  },
  {
    "codigo":735615006,
    "descripcion":"OSTEOPENIA CAUSADA POR DESUSO"
  },
  {
    "codigo":209492000,
    "descripcion":"LESIÓN DE PLACA PALMAR, PULGAR, ARTICULACIÓN INTERFALÁNGICA"
  },
  {
    "codigo":80255009,
    "descripcion":"NEUTROPENIA DE TRANSFERENCIA MATERNA"
  },
  {
    "codigo":242260002,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE FÁRMACO BETABLOQUEANTE"
  },
  {
    "codigo":78420004,
    "descripcion":"ENTERITIS VIRAL"
  },
  {
    "codigo":111188005,
    "descripcion":"ERUPCIÓN PSORIASIFORME DEL PAÑAL"
  },
  {
    "codigo":897620006,
    "descripcion":"FORMA DE CONO ANORMAL CONGÉNITA DE EPÍFISIS DE FALANGE DE QUINTO DEDO DE PIE"
  },
  {
    "codigo":406100007,
    "descripcion":"ATENDIDA POR ENFERMERA ESPECIALIZADA EN CÁNCER DE MAMA"
  },
  {
    "codigo":240425002,
    "descripcion":"ERISIPELAS FACIALES"
  },
  {
    "codigo":11049006,
    "descripcion":"RADICULITIS CERVICAL"
  },
  {
    "codigo":238590000,
    "descripcion":"DERMATOSIS PLANTAR JUVENIL"
  },
  {
    "codigo":41982003,
    "descripcion":"ANDROPAUSIA"
  },
  {
    "codigo":15726321000119109,
    "descripcion":"ARTROFITO EN ARTICULACIÓN DE PIE DERECHO"
  },
  {
    "codigo":1287166004,
    "descripcion":"ABRASIÓN DE PIEL DE QUINTO DEDO DE PIE"
  },
  {
    "codigo":369662006,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA PLEURAL, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":7379000,
    "descripcion":"PARÁLISIS PSEUDOBULBAR"
  },
  {
    "codigo":203987001,
    "descripcion":"MIELOMENINGOCELE LUMBAR"
  },
  {
    "codigo":105683002,
    "descripcion":"ENFERMEDAD CAUSADA POR TAENIIDAE"
  },
  {
    "codigo":236755002,
    "descripcion":"DEFORMIDAD DE LA ERECCIÓN"
  },
  {
    "codigo":302291005,
    "descripcion":"HALLAZGO RELACIONADO CON EL USO DE AUDÍFONOS"
  },
  {
    "codigo":1187027009,
    "descripcion":"VITAMINA B DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":398760006,
    "descripcion":"PARÁLISIS DE NERVIO MOTOR OCULAR EXTERNO"
  },
  {
    "codigo":300456007,
    "descripcion":"VEJIGA URINARIA PEQUEÑA"
  },
  {
    "codigo":365992008,
    "descripcion":"TOLERANCIA A LA DROGA - HALLAZGO"
  },
  {
    "codigo":396925001,
    "descripcion":"TUMOR DEL SISTEMA NERVIOSO CENTRAL, GRADO IV DE LA OMS"
  },
  {
    "codigo":724605002,
    "descripcion":"OSIFICACIÓN DE LIGAMENTO ESPINAL"
  },
  {
    "codigo":298621003,
    "descripcion":"SIN AMPLITUD PASIVA DE EXTENSIÓN DE COLUMNA LUMBAR"
  },
  {
    "codigo":11767691000119107,
    "descripcion":"RUPTURA TRAUMÁTICA DEL TENDÓN DISTAL DE BÍCEPS BRAQUIAL IZQUIERDO"
  },
  {
    "codigo":1052285005,
    "descripcion":"MIOCLONÍA PROPIOESPINAL AL COMIENZO DEL SUEÑO EN LA INFANCIA"
  },
  {
    "codigo":231250005,
    "descripcion":"TALIPES CALCÁNEO CONGÉNITO"
  },
  {
    "codigo":296786005,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE HIDROXIQUINOLINA"
  },
  {
    "codigo":131111000,
    "descripcion":"CAROTENO POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":294951003,
    "descripcion":"ALERGIA A FLUORURO"
  },
  {
    "codigo":293116002,
    "descripcion":"REACCIÓN ADVERSA A VACUNA ANTINEUMOCÓCICA"
  },
  {
    "codigo":1145084004,
    "descripcion":"PELO EN PENACHO"
  },
  {
    "codigo":63740007,
    "descripcion":"DIETA COMÚN MECÁNICA"
  },
  {
    "codigo":424188009,
    "descripcion":"NEFRITIS TUBULOINTERSTICIAL IDIOPÁTICA"
  },
  {
    "codigo":94673005,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE BORDE BERMELLÓN DE LABIO"
  },
  {
    "codigo":354341000119108,
    "descripcion":"CARCINOMA LOBAR IN SITU DE MAMA IZQUIERDA"
  },
  {
    "codigo":715430001,
    "descripcion":"EMBRIOFETOPATÍA CAUSADA POR INDOMETACINA"
  },
  {
    "codigo":125606003,
    "descripcion":"FRACTURA DE COLUMNA VERTEBRAL CERVICAL"
  },
  {
    "codigo":1010342005,
    "descripcion":"SUDORACIÓN DE LA MITAD DERECHA DEL CUERPO"
  },
  {
    "codigo":92838005,
    "descripcion":"FUSIÓN ANORMAL CONGÉNITA DE ARCO DE VÉRTEBRA SACRA"
  },
  {
    "codigo":191142007,
    "descripcion":"ANEMIA POR DEFICIENCIA DE VITAMINA B12 DEBIDA A MALABSORCIÓN CON PROTEINURIA"
  },
  {
    "codigo":123771001,
    "descripcion":"METAHEMALBUMINURIA"
  },
  {
    "codigo":27302009,
    "descripcion":"HERNIA PARAESOFÁGICA CON GANGRENA Y OBSTRUCCIÓN"
  },
  {
    "codigo":25467004,
    "descripcion":"HIPERAFECTIVIDAD"
  },
  {
    "codigo":254843006,
    "descripcion":"CÁNCER DE MAMA FAMILIAR"
  },
  {
    "codigo":91003006,
    "descripcion":"NEFROPATÍA CON PÉRDIDA DE SAL"
  },
  {
    "codigo":253008000,
    "descripcion":"APUDOMA"
  },
  {
    "codigo":418683009,
    "descripcion":"DILATACIÓN PUPILAR ESCASA LUEGO DE ADMINISTRACIÓN DE COLIRIO MIDRIÁTICO"
  },
  {
    "codigo":1268816002,
    "descripcion":"TENDINITIS CALCIFICANTE DE REGIÓN DE CODO"
  },
  {
    "codigo":285776004,
    "descripcion":"LINFOMA DE LINFOCITOS B, GRADO INTERMEDIO"
  },
  {
    "codigo":251173003,
    "descripcion":"BIGEMINISMO AURICULAR"
  },
  {
    "codigo":283941005,
    "descripcion":"CUERPO EXTRAÑO EN LA VESÍCULA SEMINAL"
  },
  {
    "codigo":447781009,
    "descripcion":"NEOPLASIA EPITELIAL MALIGNA DE PERITONEO"
  },
  {
    "codigo":871930001,
    "descripcion":"ANAFILAXIA DESPUÉS DE INMUNOTERAPIA CON ALÉRGENO"
  },
  {
    "codigo":708090002,
    "descripcion":"EXACERBACIÓN SEVERA AGUDA DE ASMA"
  },
  {
    "codigo":249338002,
    "descripcion":"ESTENOSIS DE NARINA"
  },
  {
    "codigo":19962005,
    "descripcion":"PRUEBA DE PERTHES"
  },
  {
    "codigo":773626008,
    "descripcion":"SÍNDROME DE CONTRACTURA ARTICULAR, CUELLO ALADO, MICROGNATISMO, PEZÓN HIPOPLÁSICO"
  },
  {
    "codigo":183802008,
    "descripcion":"ESTADÍA DE INTERNACIÓN, 4 DÍAS"
  },
  {
    "codigo":216570008,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR DERIVADO DE HIDANTOÍNA"
  },
  {
    "codigo":247503008,
    "descripcion":"UÑA DAÑADA"
  },
  {
    "codigo":704420006,
    "descripcion":"CON MAYOR RIESGO DE DESHIDRATACIÓN"
  },
  {
    "codigo":14457000,
    "descripcion":"FRACTURA EXPUESTA DE LARINGE"
  },
  {
    "codigo":442276009,
    "descripcion":"RADIOGRAFÍA SIMPLE DE CABEZA ANORMAL"
  },
  {
    "codigo":1259641002,
    "descripcion":"OSTEOSARCOMA PRIMARIO DE CLAVÍCULA"
  },
  {
    "codigo":15702361000119107,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE TENDÓN DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":440441004,
    "descripcion":"INSUFICIENCIA VASCULAR DE MIEMBRO"
  },
  {
    "codigo":16292008,
    "descripcion":"INTOXICACIÓN POR CANABIS SATIVA"
  },
  {
    "codigo":243833008,
    "descripcion":"SITUACIÓN DEL CUIDADO POSNATAL"
  },
  {
    "codigo":733518000,
    "descripcion":"SÍNDROME DE MICRODUPLICACIÓN 16P11.2P12.2"
  },
  {
    "codigo":45390000,
    "descripcion":"INMUNODEFICIENCIA COMBINADA SEVERA POR AUSENCIA DE PRODUCCIÓN DE INTERLEUCINA 2"
  },
  {
    "codigo":78158007,
    "descripcion":"ASPECTO SUCIO"
  },
  {
    "codigo":241998008,
    "descripcion":"LESIÓN CARDIOVASCULAR POR DESCOMPRESIÓN"
  },
  {
    "codigo":307534009,
    "descripcion":"INFECCIÓN URINARIA EN EMBARAZO"
  },
  {
    "codigo":240163000,
    "descripcion":"NEOPLASIA MALIGNA DE PARED NASOFARÍNGEA"
  },
  {
    "codigo":373070009,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM SPHAGNI"
  },
  {
    "codigo":404003005,
    "descripcion":"HISTIOCITOMA ANEURISMÁTICO DE LA PIEL"
  },
  {
    "codigo":305699006,
    "descripcion":"ATENDIDO POR UN PSIQUIATRA ESPECIALISTA EN REHABILITACIÓN"
  },
  {
    "codigo":829987009,
    "descripcion":"CABELLO SIN BRILLO"
  },
  {
    "codigo":698915009,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: ORIYA"
  },
  {
    "codigo":41720003,
    "descripcion":"ENDOFTALMITIS PURULENTA"
  },
  {
    "codigo":402168004,
    "descripcion":"REACCIÓN FOTOTÓXICA AGUDA"
  },
  {
    "codigo":271096004,
    "descripcion":"DEFORMIDAD DEL CALCÁNEO"
  },
  {
    "codigo":860920001,
    "descripcion":"DISFUNCIÓN ERÉCTIL DEBIDA A TRASTORNO DE ARTERIA"
  },
  {
    "codigo":15649421000119102,
    "descripcion":"ANEURISMA DE ARTERIA FEMORAL DERECHA"
  },
  {
    "codigo":236493008,
    "descripcion":"ANEURISMA DE ARTERIA RENAL, ADQUIRIDO"
  },
  {
    "codigo":300194002,
    "descripcion":"OÍDO MEDIO NORMAL"
  },
  {
    "codigo":431266005,
    "descripcion":"HEMATOMA INTRAPARENQUIMATOSO DE CEREBRO"
  },
  {
    "codigo":298359000,
    "descripcion":"HALLAZGO RELACIONADO CON DEFORMIDAD ANGULADA ÓSEA"
  },
  {
    "codigo":267426009,
    "descripcion":"MALA ABSORCIÓN DE GLUCOSA"
  },
  {
    "codigo":167287002,
    "descripcion":"PRUEBA DE CUERPOS CETÓNICOS EN ORINA NEGATIVA"
  },
  {
    "codigo":365730009,
    "descripcion":"NIVEL DE AMINOFILINA - HALLAZGO"
  },
  {
    "codigo":427596002,
    "descripcion":"DOLOR PROVOCADO POR TEMPERATURA"
  },
  {
    "codigo":165452003,
    "descripcion":"VOLUMEN CORPUSCULAR MEDIO DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":67148009,
    "descripcion":"ARTRITIS GOTOSA DE DEDO GORDO"
  },
  {
    "codigo":720673003,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR VALSARTÁN"
  },
  {
    "codigo":294689006,
    "descripcion":"ALERGIA A FLURANDRENOLONA"
  },
  {
    "codigo":303911000119102,
    "descripcion":"GOTA CRÓNICA DE CODO, SIN TOFO, DEBIDA A DISFUNCIÓN RENAL"
  },
  {
    "codigo":30710002,
    "descripcion":"ES HIJO ÚNICO"
  },
  {
    "codigo":1144822005,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR TIOPENTAL"
  },
  {
    "codigo":292854006,
    "descripcion":"REACCIÓN ADVERSA A LA CLOROQUINA"
  },
  {
    "codigo":1208523001,
    "descripcion":"TOMA DE MUESTRA POR PROFESIONAL DE LA SALUD"
  },
  {
    "codigo":717003001,
    "descripcion":"HEMANGIOMA CAVERNOSO DE CEREBRO HEREDITARIO"
  },
  {
    "codigo":192715004,
    "descripcion":"ENCEFALITIS POSVACUNACIÓN ANTITIFOIDEA"
  },
  {
    "codigo":127179006,
    "descripcion":"LINFADENOPATÍA EPIGÁSTRICA"
  },
  {
    "codigo":94411006,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE HUESO METACARPIANO"
  },
  {
    "codigo":258251008,
    "descripcion":"ESTADIO S1 DE TUMOR DE LA ESCLERÓTICA"
  },
  {
    "codigo":27040004,
    "descripcion":"ENCEFALOMIELITIS ALÉRGICA EXPERIMENTAL"
  },
  {
    "codigo":92576006,
    "descripcion":"CARCINOMA IN SITU DE LA SUPERFICIE DORSAL DE LA LENGUA"
  },
  {
    "codigo":15678401000119100,
    "descripcion":"ENDOFTALMITIS CRÓNICA DE AMBOS OJOS"
  },
  {
    "codigo":10927041000119100,
    "descripcion":"FRACTURA NO EXPUESTA DE DIÁFISIS DE CUARTO HUESO METACARPIANO DE MANO DERECHA"
  },
  {
    "codigo":10625831000119107,
    "descripcion":"NEUMONITIS QUÍMICA CAUSADA POR ANESTESIA"
  },
  {
    "codigo":16032551000119107,
    "descripcion":"NECROSIS AVASCULAR DE AMBOS HUESOS SEMILUNARES"
  },
  {
    "codigo":1237621006,
    "descripcion":"METÁSTASIS DE ADENOCARCINOMA EN GLÁNDULA DE MOLL"
  },
  {
    "codigo":449354002,
    "descripcion":"HIPOPLASIA DE CÚSPIDES PULMONARES TIPO VÁLVULA PULMONAR AUSENTE"
  },
  {
    "codigo":88906006,
    "descripcion":"ESGUINCE DE LIGAMENTO DELTOIDES DE TOBILLO"
  },
  {
    "codigo":285514008,
    "descripcion":"RETRAE LA LENGUA"
  },
  {
    "codigo":709663002,
    "descripcion":"SUPRAGLOTITIS"
  },
  {
    "codigo":250911003,
    "descripcion":"PARED VENTRICULAR IZQUIERDA DISCINÉTICA"
  },
  {
    "codigo":283679002,
    "descripcion":"HERIDA POR PINCHAZO DE CLAVO EN EL DORSO DEL PIE"
  },
  {
    "codigo":21535005,
    "descripcion":"DEFICIENCIA DIETÉTICA DE SELENIO Y VITAMINA E"
  },
  {
    "codigo":871668002,
    "descripcion":"ANOMALÍA CONGÉNITA DE VENTRÍCULO DERECHO"
  },
  {
    "codigo":247241000,
    "descripcion":"CONCHA DE LA OREJA GRANDE"
  },
  {
    "codigo":50633001,
    "descripcion":"FUNCIÓN SEXUAL FEMENINA NORMAL"
  },
  {
    "codigo":738761001,
    "descripcion":"FUNCIÓN DISMINUIDA DE TRANSPORTADOR DE ANIONES ORGÁNICOS MIEMBRO DE LA FAMILIA 1B1"
  },
  {
    "codigo":16907201000119108,
    "descripcion":"MELANOMA IN SITU DE PIEL DE PÁRPADO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":332891000119102,
    "descripcion":"ATROFIA ÓPTICA PRIMARIA DE OJO DERECHO"
  },
  {
    "codigo":83401009,
    "descripcion":"LUXACIÓN EXPUESTA DE LA ARTICULACIÓN INTERFALÁNGICA DEL PIE"
  },
  {
    "codigo":704158003,
    "descripcion":"FRACTURA NO EXPUESTA DE FALANGE DE DEDO ÍNDICE"
  },
  {
    "codigo":11801691000119103,
    "descripcion":"LESIÓN TRAUMÁTICA DE URÉTER IZQUIERDO"
  },
  {
    "codigo":81566007,
    "descripcion":"ÚLCERA DE BRONQUIO"
  },
  {
    "codigo":1259379002,
    "descripcion":"MELANOMA MALIGNO NODULAR DE PIEL PRIMARIO"
  },
  {
    "codigo":46963008,
    "descripcion":"COMPRESIÓN DEL ENCÉFALO"
  },
  {
    "codigo":405576001,
    "descripcion":"HEMOTÓRAX NO TRAUMÁTICO"
  },
  {
    "codigo":702323008,
    "descripcion":"DISTONÍA Y PARKINSONISMO DE COMIENZO RÁPIDO"
  },
  {
    "codigo":733256000,
    "descripcion":"LUXACIÓN TRAUMÁTICA DE ARTICULACIÓN INTERFALÁNGICA DE PULGAR"
  },
  {
    "codigo":700488005,
    "descripcion":"TUMOR MALIGNO DE CORDONES SEXUALES DE TESTÍCULO"
  },
  {
    "codigo":895261000,
    "descripcion":"FORMA TRIANGULAR ANORMAL CONGÉNITA DE FALANGE DISTAL DE DEDO MEÑIQUE"
  },
  {
    "codigo":698653002,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: AFRIKÁANS"
  },
  {
    "codigo":403741004,
    "descripcion":"QUERATOSIS POR ARSÉNICO"
  },
  {
    "codigo":43293004,
    "descripcion":"INTENTO FALLIDO DE ABORTO CON EMBOLIA SÉPTICA"
  },
  {
    "codigo":239901009,
    "descripcion":"DERMATOPOLIMIOSITIS EN LA NEOPLASIA"
  },
  {
    "codigo":762354003,
    "descripcion":"CEFALEA PERSISTENTE DEBIDA A TRAUMATISMO CRANEOENCEFÁLICO Y POSTERIOR A ÉL"
  },
  {
    "codigo":238066006,
    "descripcion":"PÉRDIDA DE UNA FUNCIÓN AISLADA DE LOS PEROXISOMAS"
  },
  {
    "codigo":72391004,
    "descripcion":"PERITONITIS ASÉPTICA POSTERIOR A PROCEDIMIENTO"
  },
  {
    "codigo":39623008,
    "descripcion":"CON MAYOR RIESGO DE LESIÓN POR INTOXICACIÓN"
  },
  {
    "codigo":725916003,
    "descripcion":"SINUSITIS AGUDA CAUSADA POR HONGO"
  },
  {
    "codigo":234396004,
    "descripcion":"METAHEMOGLOBINEMIA CONGÉNITA CON METAHEMOGLOBINAS ANORMALES"
  },
  {
    "codigo":299932007,
    "descripcion":"HALLAZGO RELACIONADO CON LA SENSIBILIDAD VIBRATORIA"
  },
  {
    "codigo":365468007,
    "descripcion":"GRADO DE INTEGRACIÓN EN LA EDUCACIÓN PRINCIPAL - HALLAZGO"
  },
  {
    "codigo":167025001,
    "descripcion":"NIVEL DE OXÍGENO EN SANGRE DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":3185000,
    "descripcion":"DELIRIO CONGRUENTE CON EL ESTADO DE ÁNIMO"
  },
  {
    "codigo":298097007,
    "descripcion":"CUERPO EXTRAÑO EN LA PIEL DE LA RODILLA"
  },
  {
    "codigo":296262007,
    "descripcion":"SOBREDOSIS DE DECANOATO DE ZUCLOPENTIXOL"
  },
  {
    "codigo":425499006,
    "descripcion":"TRASTORNO DE LA COMUNICACIÓN NO ORGÁNICO"
  },
  {
    "codigo":718576001,
    "descripcion":"SÍNDROME DE HIDROCEFALIA CON FISURA DE PALADAR Y CONTRACTURA ARTICULAR"
  },
  {
    "codigo":63216003,
    "descripcion":"QUERATOCONO CONGÉNITO"
  },
  {
    "codigo":292592004,
    "descripcion":"REACCIÓN ADVERSA A LA DIFENILPIRALINA"
  },
  {
    "codigo":194288009,
    "descripcion":"OTITIS MEDIA IZQUIERDA AGUDA"
  },
  {
    "codigo":290757001,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR FORMESTANO"
  },
  {
    "codigo":1306565004,
    "descripcion":"CARCINOMA LOBULILLAR DE MAMA IZQUIERDA"
  },
  {
    "codigo":126917007,
    "descripcion":"NEOPLASIA DEL LIGAMENTO ANCHO DEL ÚTERO"
  },
  {
    "codigo":716741008,
    "descripcion":"SÍNDROME DE HIPOPLASIA BILATERAL DE TIBIA Y POLIDACTILIA POSTAXIAL"
  },
  {
    "codigo":15736361000119102,
    "descripcion":"TRASTORNO DE CÓRNEA DE OJO IZQUIERDO"
  },
  {
    "codigo":92314003,
    "descripcion":"NEOPLASIA BENIGNA DE LA UNIÓN RECTOSIGMOIDE"
  },
  {
    "codigo":288922005,
    "descripcion":"NO MASTICA"
  },
  {
    "codigo":335401000119103,
    "descripcion":"ATROFIA SECUNDARIA DIFUSA DE COROIDES DE OJO DERECHO"
  },
  {
    "codigo":59546009,
    "descripcion":"ATAXIA MOTORA"
  },
  {
    "codigo":287087003,
    "descripcion":"LORDOSIS\/ESCOLIOSIS CONGÉNITA"
  },
  {
    "codigo":713071004,
    "descripcion":"CONSUMIDOR DE ALCOHOL DE MANERA INDEBIDA EN EL HOGAR"
  },
  {
    "codigo":1237359009,
    "descripcion":"PÓLIPO DE ENDOMETRIO"
  },
  {
    "codigo":449092006,
    "descripcion":"RIGIDEZ ABDOMINAL DE CUADRANTE SUPERIOR DERECHO"
  },
  {
    "codigo":285252008,
    "descripcion":"INCAPAZ DE RESISTIRSE A LOS PENSAMIENTOS PELIGROSOS"
  },
  {
    "codigo":283417001,
    "descripcion":"CORTE EN EL DORSO DE LA MANO"
  },
  {
    "codigo":840473004,
    "descripcion":"HIPERPLASIA SUPRARRENAL CONGÉNITA LIPOIDE DEBIDA A DEFICIENCIA DE PROTEÍNA REGULADORA AGUDA ESTEROIDOGÉNICA, FORMA NO CLÁSICA"
  },
  {
    "codigo":185113005,
    "descripcion":"TUBERCULOSIS DE GLÁNDULAS SUPRARRENALES"
  },
  {
    "codigo":414489005,
    "descripcion":"SÍNDROME DE NISTAGMO INFANTIL"
  },
  {
    "codigo":21273008,
    "descripcion":"ESCOTOMA RELATIVO"
  },
  {
    "codigo":248814001,
    "descripcion":"MAMA TUBULAR"
  },
  {
    "codigo":84974003,
    "descripcion":"VÓLVULO CONGÉNITO DE ESTÓMAGO"
  },
  {
    "codigo":1230019002,
    "descripcion":"PLEXOPATÍA INDUCIDA POR RADIACIÓN"
  },
  {
    "codigo":771267003,
    "descripcion":"DISTROFIA MUSCULAR CONGÉNITA CON DEFICIENCIA DE INTEGRINA ALFA-7"
  },
  {
    "codigo":81304006,
    "descripcion":"MONOSOMÍA PARCIAL 7Q"
  },
  {
    "codigo":46701001,
    "descripcion":"MIOCARDITIS AGUDA"
  },
  {
    "codigo":1259117001,
    "descripcion":"OTORREA DE LÍQUIDO CEFALORRAQUÍDEO DEBIDA A ENCEFALOCELE"
  },
  {
    "codigo":1193581003,
    "descripcion":"REACCIÓN ADVERSA A VACUNA DE PLÁSMIDO DE ADN DE COVID-19 QUE CODIFICA PROTEÍNA DE ESPIGA"
  },
  {
    "codigo":276077002,
    "descripcion":"CESE DE NEGOCIOS POR CAUSAS FINANCIERAS"
  },
  {
    "codigo":896834003,
    "descripcion":"FORMA TRIANGULAR ANORMAL CONGÉNITA DE EPÍFISIS"
  },
  {
    "codigo":700226009,
    "descripcion":"VÍCTIMA DE HOSTIGAMIENTO SEXUAL"
  },
  {
    "codigo":1255447001,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE DEDO MEDIO"
  },
  {
    "codigo":1222679006,
    "descripcion":"SÍNDROME DE ENFERMEDAD PULMONAR INTERSTICIAL AUTOINMUNITARIA Y ARTRITIS"
  },
  {
    "codigo":403479008,
    "descripcion":"ÚLCERA DE SUTTON (AFTOSIS VULVAR)"
  },
  {
    "codigo":1351916005,
    "descripcion":"HEMANGIOBLASTOMA DE PÁNCREAS"
  },
  {
    "codigo":237804005,
    "descripcion":"TESTÍCULOS AUSENTES"
  },
  {
    "codigo":72129000,
    "descripcion":"ACANTOSIS PIGMENTARIA ADQUIRIDA"
  },
  {
    "codigo":41196008,
    "descripcion":"DHAT"
  },
  {
    "codigo":235969000,
    "descripcion":"TRASTORNO DE CONDUCTO PANCREÁTICO"
  },
  {
    "codigo":203201006,
    "descripcion":"ABSCESO DE BRODIE DE COLUMNA VERTEBRAL SACRA"
  },
  {
    "codigo":301505007,
    "descripcion":"ENTRA Y SALE DE LA DUCHA"
  },
  {
    "codigo":70294003,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN LA REGIÓN DEL CUERO CABELLUDO, CON INFECCIÓN"
  },
  {
    "codigo":135830006,
    "descripcion":"PANGASTRITIS"
  },
  {
    "codigo":234134007,
    "descripcion":"MALFORMACIÓN VENOSA LINFÁTICA"
  },
  {
    "codigo":397974008,
    "descripcion":"HIPOESTESIA"
  },
  {
    "codigo":299670009,
    "descripcion":"PELO ONDULADO"
  },
  {
    "codigo":365206006,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA MAQUILLARSE"
  },
  {
    "codigo":35691006,
    "descripcion":"DEFICIENCIA COMBINADA DE SIALIDASA Y BETA GALACTOSIDASA"
  },
  {
    "codigo":232299007,
    "descripcion":"APLASIA DE LA CÓCLEA Y EL LABERINTO VESTIBULAR"
  },
  {
    "codigo":723819007,
    "descripcion":"PARAPLEJÍA ESPÁSTICA AUTOSÓMICA DOMINANTE TIPO 36"
  },
  {
    "codigo":199531009,
    "descripcion":"ENFERMEDAD HEREDITARIA FETAL"
  },
  {
    "codigo":230464001,
    "descripcion":"MIGRAÑA HEMIPLÉJICA ESPORÁDICA"
  },
  {
    "codigo":263232003,
    "descripcion":"FRACTURA DE FÉMUR DISTAL"
  },
  {
    "codigo":197696001,
    "descripcion":"SÍNDROME NEFRÍTICO RÁPIDAMENTE PROGRESIVO, ENFERMEDAD DE DEPÓSITOS DENSOS"
  },
  {
    "codigo":33856003,
    "descripcion":"INFECCIÓN CAUSADA POR OPISTHORCHIS CANINUS"
  },
  {
    "codigo":2460001000004103,
    "descripcion":"LIPOMA DE PLEURA"
  },
  {
    "codigo":296000008,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE VIGABATRINA"
  },
  {
    "codigo":31580001000004106,
    "descripcion":"FRACTURA DE SACRO POR INSUFICIENCIA, BILATERAL"
  },
  {
    "codigo":12700001000004106,
    "descripcion":"PSEUDOMONAS AISLADAS EN CULTIVO DE ESPUTO"
  },
  {
    "codigo":29340001000004108,
    "descripcion":"ABSCESO DE URACO"
  },
  {
    "codigo":32021005,
    "descripcion":"ABSCESO DE LA YEMA DE DEDO DE LA MANO"
  },
  {
    "codigo":8540001000004109,
    "descripcion":"FRACTURA DE MALGAIGNE EXPUESTA"
  },
  {
    "codigo":64789007,
    "descripcion":"LESIÓN TRAUMÁTICA INTERNA DE ÓRGANOS ABDOMINALES SIN HERIDA ABIERTA HACIA CAVIDAD"
  },
  {
    "codigo":95722004,
    "descripcion":"CATARATAS BILATERALES"
  },
  {
    "codigo":423402005,
    "descripcion":"VÍCTIMA DE MENSAJES NEGATIVOS CONSTANTES"
  },
  {
    "codigo":1177066008,
    "descripcion":"ESPONDILITIS POR BRUCELLA MELITENSIS"
  },
  {
    "codigo":93887003,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LAS CELDILLAS AÉREAS MASTOIDEAS"
  },
  {
    "codigo":126655004,
    "descripcion":"NEOPLASIA DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":716479004,
    "descripcion":"DIFICULTAD PARA COMPRENDER INSTRUCCIONES DE UNA SOLA PARTE"
  },
  {
    "codigo":1306303005,
    "descripcion":"BLOQUEO PUPILAR DE OJO IZQUIERDO"
  },
  {
    "codigo":290495005,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR PROPOFOL"
  },
  {
    "codigo":224959009,
    "descripcion":"DESARROLLO FISIOLÓGICO NORMAL"
  },
  {
    "codigo":288660003,
    "descripcion":"HABLA A SU TURNO EN UNA CONVERSACIÓN"
  },
  {
    "codigo":92052008,
    "descripcion":"NEOPLASIA BENIGNA DE VENTRÍCULO DE CEREBRO"
  },
  {
    "codigo":26516009,
    "descripcion":"TRASTORNO GRAVE DEL ESTADO DE ÁNIMO, CON SÍNTOMAS PSICÓTICOS"
  },
  {
    "codigo":286825000,
    "descripcion":"TIENDE A HUMILLAR A LOS DEMÁS"
  },
  {
    "codigo":22846003,
    "descripcion":"SÍNDROME HEPATORRENAL POSTERIOR AL PARTO"
  },
  {
    "codigo":11862161000119109,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE REGIÓN DE TOBILLO DERECHO"
  },
  {
    "codigo":283155003,
    "descripcion":"CUERPO EXTRAÑO METÁLICO EN LA AXILA"
  },
  {
    "codigo":446995005,
    "descripcion":"EPISODIOS DE ESTREMECIMIENTOS"
  },
  {
    "codigo":40551000087103,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE DEDO MEÑIQUE IZQUIERDO"
  },
  {
    "codigo":37991000087104,
    "descripcion":"ACINESIA DE MIOCARDIO APICAL DE VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":117480000,
    "descripcion":"CRISTAL URINARIO, FOSFATO DE HIDRÓGENO DE CALCIO"
  },
  {
    "codigo":43111000087104,
    "descripcion":"HEMATOMA DE DEDO MEÑIQUE DERECHO"
  },
  {
    "codigo":21011008,
    "descripcion":"PUPILA DE ARGYLL - ROBERTSON ATÍPICA"
  },
  {
    "codigo":1004051009,
    "descripcion":"CONTRACTURA EN FLEXIÓN DE ARTICULACIÓN METATARSOFALÁNGICA DE SEGUNDO DEDO DE PIE"
  },
  {
    "codigo":12081451000119105,
    "descripcion":"QUEMADURA QUÍMICA DE CÓRNEA DERECHA"
  },
  {
    "codigo":1231592006,
    "descripcion":"OBSTRUCCIÓN DE LUZ DE VÍA RESPIRATORIA CAUSADA POR INHALACIÓN DE CUERPO EXTRAÑO"
  },
  {
    "codigo":838376007,
    "descripcion":"MIOPATÍA CRÓNICA ALCOHÓLICA"
  },
  {
    "codigo":443325000,
    "descripcion":"DESFIBRILADOR CARDÍACO AUTOMÁTICO IMPLANTABLE IN SITU"
  },
  {
    "codigo":707304009,
    "descripcion":"RESPUESTA NORMAL DE PRESIÓN ARTERIAL SISTÓLICA DESPUÉS DEL EJERCICIO"
  },
  {
    "codigo":248552009,
    "descripcion":"SIN ALIENTO"
  },
  {
    "codigo":11809221000119101,
    "descripcion":"HERIDA INFECTADA DE REGIÓN LUMBAR DEBIDA A PICADURA DE INSECTO NO VENENOSO"
  },
  {
    "codigo":246717005,
    "descripcion":"PARÁLISIS DIVERGENTE"
  },
  {
    "codigo":48274004,
    "descripcion":"ESGUINCE DE CARTÍLAGO TIROIDES"
  },
  {
    "codigo":441490006,
    "descripcion":"FRACTURA POR SOBRECARGA DE HUESO NAVICULAR DE PIE"
  },
  {
    "codigo":81042008,
    "descripcion":"ANOMALÍA CONGÉNITA DE LA MÉDULA ESPINAL"
  },
  {
    "codigo":1258855004,
    "descripcion":"INFRAOCLUSIÓN DENTAL DEBIDA A TRAUMATISMO DENTAL Y POSTERIOR A ÉL"
  },
  {
    "codigo":111975006,
    "descripcion":"INTERVALO QT PROLONGADO"
  },
  {
    "codigo":243047006,
    "descripcion":"HERIDA DE GUERRA POR EXPLOSIÓN EN AERONAVE"
  },
  {
    "codigo":110140001,
    "descripcion":"LACERACIÓN SIMPLE CONTAMINADA DE LA OROFARINGE"
  },
  {
    "codigo":11836002,
    "descripcion":"PERITONITIS BACTERIANA PRIMARIA"
  },
  {
    "codigo":13671009,
    "descripcion":"ESTRECHEZ CONGÉNITA DE LA URETRA"
  },
  {
    "codigo":306748004,
    "descripcion":"CAPAZ DE MOVER LA LENGUA SIMÉTRICAMENTE"
  },
  {
    "codigo":208444006,
    "descripcion":"FRACTURA NO EXPUESTA DE FALANGE PROXIMAL DE DEDO DE LA MANO"
  },
  {
    "codigo":403217003,
    "descripcion":"DERMATOSIS PUSTULAR SUBCORNEAL CON PARAPROTEINEMIA"
  },
  {
    "codigo":42769004,
    "descripcion":"ENFERMEDAD DIFUSA DE CUERPOS DE LEWY CON CAMBIOS CORTICALES ESPONGIFORMES"
  },
  {
    "codigo":10001005,
    "descripcion":"SEPSIS BACTERIANA"
  },
  {
    "codigo":763665007,
    "descripcion":"SÍNDROME CRANEODIGITAL Y DE DISCAPACIDAD INTELECTUAL"
  },
  {
    "codigo":8166000,
    "descripcion":"TROMBOFLEBITIS DEL SENO BASILAR"
  },
  {
    "codigo":237542005,
    "descripcion":"SÍNDROME DEL ENFERMO EUTIROIDEO"
  },
  {
    "codigo":303078007,
    "descripcion":"PERFORACIÓN DEL INTESTINO GRUESO"
  },
  {
    "codigo":6331000,
    "descripcion":"ANGIOQUERATOMA DE FORDYCE"
  },
  {
    "codigo":235707005,
    "descripcion":"ENTERITIS AGUDA POR RADIACIÓN"
  },
  {
    "codigo":301243006,
    "descripcion":"NO ELIMINA ESPUTO"
  },
  {
    "codigo":364944003,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA REALIZAR FUNCIÓN MOTORA FINA"
  },
  {
    "codigo":725392005,
    "descripcion":"NEURODEGENERACIÓN ESTRIATAL AUTOSÓMICA DOMINANTE"
  },
  {
    "codigo":299408006,
    "descripcion":"PRUEBA DEL RESALTO, NEGATIVA"
  },
  {
    "codigo":102800009,
    "descripcion":"SECRECIÓN ANORMAL DE RENINA"
  },
  {
    "codigo":232037002,
    "descripcion":"OCLUSIÓN DE RAMA DE ARTERIA MACULAR"
  },
  {
    "codigo":461413001,
    "descripcion":"ANEURISMA SUBMITRAL ADQUIRIDO DE VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":723557004,
    "descripcion":"ENCEFALOPATÍA SENSIBLE A LA TIAMINA"
  },
  {
    "codigo":35429005,
    "descripcion":"ANSIEDAD ANTICIPATORIA"
  },
  {
    "codigo":361274000,
    "descripcion":"APRAXIA ORAL"
  },
  {
    "codigo":230202002,
    "descripcion":"MIELOPATÍA VACUOLAR"
  },
  {
    "codigo":262970004,
    "descripcion":"LESIÓN MUSCULAR POR APLASTAMIENTO"
  },
  {
    "codigo":721722008,
    "descripcion":"DISCINESIA DE ESFÍNTER DE ODDI"
  },
  {
    "codigo":293903001,
    "descripcion":"ALERGIA A LORAZEPAM"
  },
  {
    "codigo":193764001,
    "descripcion":"ÚLCERA DENDRÍTICA"
  },
  {
    "codigo":718052004,
    "descripcion":"PERIODONTITIS PERIAPICAL ASINTOMÁTICA"
  },
  {
    "codigo":128228006,
    "descripcion":"TRASTORNO DE HUESO NASAL"
  },
  {
    "codigo":95460007,
    "descripcion":"INFARTO CEREBELOSO"
  },
  {
    "codigo":421305000,
    "descripcion":"MICROALBUMINURIA PERSISTENTE DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":97171000119100,
    "descripcion":"QUISTE DE ANEXOS UTERINOS"
  },
  {
    "codigo":60857002,
    "descripcion":"INTOXICACIÓN POR THESIUM"
  },
  {
    "codigo":880057004,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DEL PIE CON INFECCIÓN"
  },
  {
    "codigo":93625006,
    "descripcion":"FALTA DE OSIFICACIÓN DE HUESO BASIESFENOIDAL"
  },
  {
    "codigo":386702006,
    "descripcion":"VÍCTIMA DE MALTRATO"
  },
  {
    "codigo":288398007,
    "descripcion":"DIFICULTAD PARA DARLE CUERDA AL RELOJ"
  },
  {
    "codigo":714382008,
    "descripcion":"LACERACIÓN ACCIDENTAL DURANTE UN PROCEDIMIENTO EN UN ÓRGANO"
  },
  {
    "codigo":26254008,
    "descripcion":"TRASTORNO POTENCIAL DE LA TOLERANCIA A LA GLUCOSA"
  },
  {
    "codigo":24419001,
    "descripcion":"DEFECTOS DEL SISTEMA DEL COMPLEMENTO"
  },
  {
    "codigo":286563003,
    "descripcion":"CUERPO EXTRAÑO EN ESTRUCTURA MUSCULOESQUELÉTICA"
  },
  {
    "codigo":253795001,
    "descripcion":"DUPLICACIÓN ENTÉRICA"
  },
  {
    "codigo":57187006,
    "descripcion":"NIÑO TORPE"
  },
  {
    "codigo":712547007,
    "descripcion":"ARTRITIS BACTERIANA DE ARTICULACIÓN CIGOAPOFISARIA DE LA COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":448568001,
    "descripcion":"NÓDULO DE REGIÓN SUPRAHIOIDEA"
  },
  {
    "codigo":55352002,
    "descripcion":"ENFERMEDAD NEOPLÁSICA FAMILIAR"
  },
  {
    "codigo":86285007,
    "descripcion":"TRASTORNO DE LA VESÍCULA SEMINAL"
  },
  {
    "codigo":248290002,
    "descripcion":"RETRASO CONGÉNITO"
  },
  {
    "codigo":444898006,
    "descripcion":"PÓLIPO ADENOMATOSO TUBULAR DE COLON"
  },
  {
    "codigo":51682007,
    "descripcion":"FIEBRE QUARANFIL"
  },
  {
    "codigo":17079009,
    "descripcion":"PERICARDITIS BACTERIANA AGUDA"
  },
  {
    "codigo":15244003,
    "descripcion":"SÍNDROME NEUROLÉPTICO MALIGNO"
  },
  {
    "codigo":48012003,
    "descripcion":"FORÚNCULO DE TÚNICA VAGINAL"
  },
  {
    "codigo":80780008,
    "descripcion":"BURSITIS SUBCORACOIDEA"
  },
  {
    "codigo":406625002,
    "descripcion":"INFECCIÓN CAUSADA POR VIBRIO MIMICUS"
  },
  {
    "codigo":111713003,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DEL ANTEBRAZO, CON INFECCIÓN"
  },
  {
    "codigo":373857004,
    "descripcion":"CAMBIO EN EL CURSO DE RADIOTERAPIA DEBIDO A ENFERMEDAD PROGRESIVA DURANTE LA RADIOTERAPIA"
  },
  {
    "codigo":46177005,
    "descripcion":"INSUFICIENCIA RENAL EN ESTADIO TERMINAL"
  },
  {
    "codigo":109878000,
    "descripcion":"NEOPLASIA SUPERPUESTA MALIGNA DE ÓRGANOS GENITALES FEMENINOS"
  },
  {
    "codigo":699702003,
    "descripcion":"CALCIFICACIÓN DE CARTÍLAGO LARÍNGEO"
  },
  {
    "codigo":208182006,
    "descripcion":"FRACTURA NO EXPUESTA DE PELVIS, ESPINA ILÍACA ANTEROSUPERIOR"
  },
  {
    "codigo":372022008,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA ENCÍA SUPERIOR"
  },
  {
    "codigo":304651004,
    "descripcion":"INCAPAZ DE EMPLEAR ESTRATEGIAS PARA LA TOMA DE DECISIONES"
  },
  {
    "codigo":239115005,
    "descripcion":"HAMARTOMA ANGIOMATOSO ECRINO"
  },
  {
    "codigo":763403007,
    "descripcion":"SÍNDROME DE PARAPLEJÍA ESPÁSTICA Y LESIÓN CUTÁNEA FACIAL"
  },
  {
    "codigo":402955008,
    "descripcion":"CHANCROIDE VULVAR"
  },
  {
    "codigo":1254923009,
    "descripcion":"DERMATITIS DE CONTACTO IRRITATIVA DE PIEL DE CUELLO"
  },
  {
    "codigo":1187552001,
    "descripcion":"HIPERTROFIA HIPOFISARIA"
  },
  {
    "codigo":302816009,
    "descripcion":"NEOPLASIA MALIGNA DE PARTES BLANDAS DE CABEZA Y\/O CUELLO"
  },
  {
    "codigo":300981003,
    "descripcion":"EDEMA DE PIERNA GRAVITACIONAL"
  },
  {
    "codigo":366517003,
    "descripcion":"AMPLITUD DE PRONACIÓN ACTIVA DE CODO"
  },
  {
    "codigo":1082721000119101,
    "descripcion":"NEUMONÍA CAUSADA POR ASCARIS"
  },
  {
    "codigo":38837006,
    "descripcion":"PORENCEFALIA ADQUIRIDA"
  },
  {
    "codigo":268213006,
    "descripcion":"ANOMALÍA CONGÉNITA DE HÍGADO Y\/O VÍA BILIAR"
  },
  {
    "codigo":202677007,
    "descripcion":"ESPONDILOSIS LUMBOSACRA CON MIELOPATÍA"
  },
  {
    "codigo":102538003,
    "descripcion":"POSICIÓN RECOSTADA"
  },
  {
    "codigo":397450004,
    "descripcion":"LINFOMA QUE COMPROMETE BAZO"
  },
  {
    "codigo":200842003,
    "descripcion":"DERMATITIS ALÉRGICA DE CONTACTO CAUSADA POR ADHESIVO"
  },
  {
    "codigo":299146006,
    "descripcion":"AMPLITUD DE FLEXIÓN PASIVA DEL PULGAR NORMAL"
  },
  {
    "codigo":233610007,
    "descripcion":"NEUMONÍA NEONATAL POR CHLAMYDIA"
  },
  {
    "codigo":428383000,
    "descripcion":"ANEMIA CAUSADA POR MEDICACIÓN"
  },
  {
    "codigo":168074003,
    "descripcion":"CÁLCULO: OXALATO DE CALCIO"
  },
  {
    "codigo":262708000,
    "descripcion":"LACERACIÓN DE MÉDULA ESPINAL LUMBAR"
  },
  {
    "codigo":15746401000119105,
    "descripcion":"MASA DE AMBOS OJOS"
  },
  {
    "codigo":199007008,
    "descripcion":"ENFERMEDAD RENAL Y CARDÍACA HIPERTENSIVA PREEXISTENTE QUE COMPLICA EMBARAZO, PARTO Y EL PUERPERIO"
  },
  {
    "codigo":721460000,
    "descripcion":"SÍNDROME DEL CORDÓN ANTERIOR DE MÉDULA ESPINAL AL NIVEL DEL QUINTO SEGMENTO DORSAL"
  },
  {
    "codigo":295476001,
    "descripcion":"SOBREDOSIS INTENCIONAL DE ACEITE DE CASTOR"
  },
  {
    "codigo":197172005,
    "descripcion":"PERITONITIS CLAMIDIAL"
  },
  {
    "codigo":318971000119102,
    "descripcion":"ARTRITIS REUMATOIDEA SEROPOSITIVA DE ARTICULACIÓN DE REGIÓN DE MUÑECA DERECHA"
  },
  {
    "codigo":95198001,
    "descripcion":"DISGENESIA GONADAL PURA 46, XX"
  },
  {
    "codigo":291806000,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ACETOHEXAMIDA"
  },
  {
    "codigo":160734000,
    "descripcion":"VIVE EN CENTRO DE CUIDADOS DE PACIENTES CRÓNICOS CON ATENCIÓN DE ENFERMERÍA"
  },
  {
    "codigo":717790004,
    "descripcion":"ENFERMEDAD DE DENT TIPO 2"
  },
  {
    "codigo":1078238006,
    "descripcion":"AGENESIA DE EPÍFISIS DE FALANGE DISTAL DE DEDO PULGAR"
  },
  {
    "codigo":11996161000119100,
    "descripcion":"INFECCIÓN DE MUÑÓN DE AMPUTACIÓN DE EXTREMIDAD INFERIOR DERECHA"
  },
  {
    "codigo":15674881000119101,
    "descripcion":"TENDINITIS BILATERAL DE TENDÓN ADUCTOR DE CADERA"
  },
  {
    "codigo":291841000119102,
    "descripcion":"NEUROPATÍA POR COMPRESIÓN DE NERVIO PERIFÉRICO DE MANO IZQUIERDA"
  },
  {
    "codigo":15920641000119103,
    "descripcion":"REACCIÓN ALÉRGICA CAUSADA POR ADITIVO ALIMENTARIO"
  },
  {
    "codigo":1075201000119103,
    "descripcion":"METATARSO ADUCTO DERECHO ADQUIRIDO"
  },
  {
    "codigo":15669761000119105,
    "descripcion":"TALIPES DEL PIE DERECHO"
  },
  {
    "codigo":11778561000119106,
    "descripcion":"DISTENSIÓN DE MÚSCULO Y\/O TENDÓN SUPRAESPINOSO IZQUIERDO"
  },
  {
    "codigo":128001000119105,
    "descripcion":"HIPERTENSIÓN CONCURRENTE Y DEBIDA A ENFERMEDAD RENAL TERMINAL EN DIÁLISIS CAUSADA POR DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":191667009,
    "descripcion":"TRASTORNO PARANOIDE"
  },
  {
    "codigo":110081000119109,
    "descripcion":"VAGINOSIS BACTERIANA EN EL EMBARAZO"
  },
  {
    "codigo":15697921000119106,
    "descripcion":"ABSCESO DE BOLSA SEROSA DE AMBOS CODOS"
  },
  {
    "codigo":133121000119109,
    "descripcion":"TRASTORNO AFECTIVO ESTACIONAL SEVERO"
  },
  {
    "codigo":337921000119109,
    "descripcion":"ÚLCERA CORNEAL EN ANILLO DE OJO IZQUIERDO"
  },
  {
    "codigo":12198401000119108,
    "descripcion":"DOLOR ASOCIADO A IMPLANTE DE MAMA DERECHA"
  },
  {
    "codigo":16606721000119107,
    "descripcion":"ARTRITIS REUMATOIDEA SEROPOSITIVA EN REMISIÓN"
  },
  {
    "codigo":343041000119106,
    "descripcion":"OJO IZQUIERDO CIEGO, VISIÓN NORMAL EN OJO DERECHO"
  },
  {
    "codigo":16097281000119108,
    "descripcion":"ARTROFIBROSIS DE ARTICULACIÓN DE REGIÓN DE TOBILLO DERECHO"
  },
  {
    "codigo":417373000,
    "descripcion":"POLIARTROPATÍA INFLAMATORIA"
  },
  {
    "codigo":124296008,
    "descripcion":"DEFICIENCIA DE TRANSOXIMINASA"
  },
  {
    "codigo":56925008,
    "descripcion":"FUNCIÓN SEXUAL ANORMAL"
  },
  {
    "codigo":253533009,
    "descripcion":"ATRESIA DEL TRACTO DE SALIDA DEL VENTRÍCULO DERECHO"
  },
  {
    "codigo":251698003,
    "descripcion":"SECRECIÓN LAGRIMAL - PERMEABILIDAD REDUCIDA"
  },
  {
    "codigo":774151000,
    "descripcion":"SÍNDROME FÉRRICO-CEREBRO-CUTÁNEO"
  },
  {
    "codigo":446471004,
    "descripcion":"INFECCIÓN DE EPIDÍDIMO CAUSADA POR CHLAMYDIA TRACHOMATIS"
  },
  {
    "codigo":249863008,
    "descripcion":"SENTARSE CON APOYO"
  },
  {
    "codigo":1167367009,
    "descripcion":"HIPERTROFIA GINGIVAL EXACERBADA POR CICLO MENSTRUAL"
  },
  {
    "codigo":84188003,
    "descripcion":"SÍNDROME TALASÉMICO"
  },
  {
    "codigo":1085231000119100,
    "descripcion":"ABSCESO DE INTESTINO CONCOMITANTE CON RECTOSIGMOIDITIS ULCEROSA CRÓNICA Y DEBIDO A ELLA"
  },
  {
    "codigo":248028006,
    "descripcion":"ROBO DE LA CASA"
  },
  {
    "codigo":211590000,
    "descripcion":"LESIÓN TRAUMÁTICA CERRADA POR APLASTAMIENTO, MUSLO"
  },
  {
    "codigo":82353009,
    "descripcion":"ENFERMEDAD INFECCIOSA CONGÉNITA"
  },
  {
    "codigo":277126002,
    "descripcion":"HALLAZGO RELACIONADO CON POTENCIALES EVOCADOS SOMATOSENSITIVOS"
  },
  {
    "codigo":768646002,
    "descripcion":"CARIES CORONAL ACTIVA EN ESTADIO MODERADO"
  },
  {
    "codigo":735878000,
    "descripcion":"FRACTURA DE HUESO CUNEIFORME EXTERNO"
  },
  {
    "codigo":111451002,
    "descripcion":"LESIÓN OBSTÉTRICA DE ÓRGANO PÉLVICO"
  },
  {
    "codigo":45915002,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN BRAZO, CON INFECCIÓN"
  },
  {
    "codigo":37939008,
    "descripcion":"ANOMALÍA CONGÉNITA DE VEJIGA URINARIA"
  },
  {
    "codigo":209755004,
    "descripcion":"RUPTURA DEL TENDÓN SUBESCAPULAR"
  },
  {
    "codigo":699440004,
    "descripcion":"TERCIO MEDIO FACIAL LARGO"
  },
  {
    "codigo":121098031000119106,
    "descripcion":"ENDOMETRIOMA BILATERIAL DE OVARIOS"
  },
  {
    "codigo":402693001,
    "descripcion":"LIPOMATOSIS"
  },
  {
    "codigo":42245002,
    "descripcion":"INSUFICIENCIA OVÁRICA IATROGÉNICA"
  },
  {
    "codigo":240688009,
    "descripcion":"NJOVERA"
  },
  {
    "codigo":271621004,
    "descripcion":"RESPIRACIÓN ESTERTOROSA"
  },
  {
    "codigo":1254661005,
    "descripcion":"ESTENOSIS DE RAMA LATERAL POSTERIOR DE ARTERIA CORONARIA DERECHA"
  },
  {
    "codigo":290483005,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ÓXIDO NITROSO"
  },
  {
    "codigo":238853007,
    "descripcion":"FIBROMATOSIS SUPERFICIAL"
  },
  {
    "codigo":40410004,
    "descripcion":"INFECCIÓN POR DIOCTOPHYME RENALE"
  },
  {
    "codigo":204250005,
    "descripcion":"ALTERACIÓN CONGÉNITA DE TROMPA DE EUSTAQUIO"
  },
  {
    "codigo":726703000,
    "descripcion":"QUISTE DE DUPLICACIÓN DIGESTIVA DE LENGUA"
  },
  {
    "codigo":38575001,
    "descripcion":"BIORRITMO CIRCANUAL ANORMAL"
  },
  {
    "codigo":1187290008,
    "descripcion":"HIPERLORDOSIS DE COLUMNA LUMBAR"
  },
  {
    "codigo":202415003,
    "descripcion":"HEMARTROSIS DE TOBILLO"
  },
  {
    "codigo":300719004,
    "descripcion":"CAPAZ DE REALIZAR ACTIVIDADES RELACIONADAS CON LAS COMPRAS"
  },
  {
    "codigo":366255007,
    "descripcion":"HALLAZGO EN EL PATRÓN DE DEGLUCIÓN"
  },
  {
    "codigo":724868000,
    "descripcion":"NECROSIS DE PIEL DEBIDA A INYECCIÓN DE RELLENO Y POSTERIOR A ELLA"
  },
  {
    "codigo":321481000119105,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE TENDÓN EXTENSOR DE MUSLO DERECHO"
  },
  {
    "codigo":11790281000119105,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE PIEL DE PULGAR IZQUIERDO"
  },
  {
    "codigo":3972004,
    "descripcion":"INSOMNIO PRIMARIO"
  },
  {
    "codigo":102276005,
    "descripcion":"OSIFICACIÓN BIPARTITA"
  },
  {
    "codigo":331652006,
    "descripcion":"DISFASIA SEMÁNTICA"
  },
  {
    "codigo":298884006,
    "descripcion":"SIN AMPLITUD ACTIVA DE FLEXIÓN DE CODO"
  },
  {
    "codigo":15722441000119106,
    "descripcion":"ARTROSIS DE ARTICULACIÓN SUBASTRAGALINA IZQUIERDA"
  },
  {
    "codigo":459054000,
    "descripcion":"ROTACIÓN ANÓMALA DE INTESTINO CON HERNIACIÓN INTERNA"
  },
  {
    "codigo":297049009,
    "descripcion":"SOBREDOSIS DE GUANETIDINA"
  },
  {
    "codigo":33070002,
    "descripcion":"PROBLEMA DEBIDO AL CUIDADO DE UNA PERSONA ENFERMA"
  },
  {
    "codigo":721198006,
    "descripcion":"INSUFICIENCIA OVÁRICA PREMATURA DEBIDA A OOFORITIS AUTOINMUNITARIA"
  },
  {
    "codigo":229678008,
    "descripcion":"DISGRAFÍA FONOLÓGICA"
  },
  {
    "codigo":719363002,
    "descripcion":"UTILIZA DISPOSITIVO DE COMUNICACIÓN DE ALTA TECNOLOGÍA"
  },
  {
    "codigo":31235003,
    "descripcion":"SÍNDROME MEDULAR ANTERIOR DEBIDO A FRACTURA NO EXPUESTA A NIVEL DE C5-C7"
  },
  {
    "codigo":293379005,
    "descripcion":"REACCIÓN ADVERSA AL YODO POVIDONA"
  },
  {
    "codigo":783064000,
    "descripcion":"EPILEPSIA MIOCLÓNICA PROGRESIVA TIPO 3"
  },
  {
    "codigo":162307009,
    "descripcion":"CEFALEA CONTINUA"
  },
  {
    "codigo":291544001,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR CARBENICILINA"
  },
  {
    "codigo":94936009,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA GLÁNDULA SALIVAL MENOR"
  },
  {
    "codigo":93101002,
    "descripcion":"FALTA DE OSIFICACIÓN DE HUESO HIOIDES"
  },
  {
    "codigo":289709004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CANTIDAD DE CONTRACCIONES UTERINAS"
  },
  {
    "codigo":60333009,
    "descripcion":"ESTADIO CLÍNICO II"
  },
  {
    "codigo":1303682002,
    "descripcion":"QUISTE ÓSEO ANEURISMÁTICO DE COLUMNA VERTEBRAL"
  },
  {
    "codigo":713858003,
    "descripcion":"TENOSINOVITIS PERONEA"
  },
  {
    "codigo":255106001,
    "descripcion":"TERATOMA DE TESTÍCULO"
  },
  {
    "codigo":25730006,
    "descripcion":"ESTRECHEZ DEL RECTO"
  },
  {
    "codigo":56663002,
    "descripcion":"INFECCIÓN AGUDA DEL PABELLÓN DE LA OREJA"
  },
  {
    "codigo":253271002,
    "descripcion":"IMAGEN CARDÍACA EN ESPEJO"
  },
  {
    "codigo":185900003,
    "descripcion":"VACUNADO CONTRA LA GRIPE EN SU DOMICILIO"
  },
  {
    "codigo":284204005,
    "descripcion":"QUEMADURA SUPERFICIAL DE LABIO POR AGENTE CORROSIVO"
  },
  {
    "codigo":54828006,
    "descripcion":"SECUENCIA DE BASE DE UN NUCLEÓTIDO"
  },
  {
    "codigo":11792791000119100,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN DE DEDO MEDIO IZQUIERDO"
  },
  {
    "codigo":249601005,
    "descripcion":"MATERIA FECAL EN RECTO"
  },
  {
    "codigo":413441006,
    "descripcion":"LEUCEMIA MONOCÍTICA AGUDA"
  },
  {
    "codigo":247766000,
    "descripcion":"PRESTA ATENCIÓN A LA ACTIVIDAD DE SU PROPIA ELECCIÓN"
  },
  {
    "codigo":85761009,
    "descripcion":"BISINOSIS"
  },
  {
    "codigo":444374006,
    "descripcion":"TIMOMA TIPO C"
  },
  {
    "codigo":870358008,
    "descripcion":"TRAUMATISMO IATROGÉNICO NEONATAL DE PIEL DEBIDO A INTERVENCIÓN PRENATAL Y POSTERIOR A ELLA"
  },
  {
    "codigo":409771002,
    "descripcion":"TUMOR MALIGNO CON COMPROMISO DE ÓRGANO POR PROPAGACIÓN DIRECTA DESDE ÓRGANO DE ORIGEN A ÓRGANO ADYACENTE"
  },
  {
    "codigo":211328000,
    "descripcion":"LESIÓN SUPERFICIAL DE MIEMBRO INFERIOR, SIN INCLUIR EL PIE"
  },
  {
    "codigo":80256005,
    "descripcion":"TROMBOSIS INTERVELLOSA"
  },
  {
    "codigo":735616007,
    "descripcion":"OSTEOPENIA CAUSADA POR FÁRMACO"
  },
  {
    "codigo":111189002,
    "descripcion":"DERMATITIS DE CONTACTO AGUDA"
  },
  {
    "codigo":242261003,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE DIGOXINA"
  },
  {
    "codigo":897621005,
    "descripcion":"FORMA DE CONO ANORMAL CONGÉNITA DE EPÍFISIS DE FALANGE DE DEDO GORDO"
  },
  {
    "codigo":240426001,
    "descripcion":"MENINGOCOCCEMIA CRÓNICA"
  },
  {
    "codigo":238591001,
    "descripcion":"ECCEMA SECUNDARIO GENERALIZADO"
  },
  {
    "codigo":369663001,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA DE PLEURA Y BRONQUIO, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":402431009,
    "descripcion":"ATROFIA CUTÁNEA POR ARTRITIS REUMATOIDE"
  },
  {
    "codigo":236756001,
    "descripcion":"PENE ESCONDIDO ADQUIRIDO"
  },
  {
    "codigo":302292003,
    "descripcion":"HALLAZGO RELACIONADO CON LA ESTRUCTURA DEL TRONCO"
  },
  {
    "codigo":1187028004,
    "descripcion":"VITAMINA D DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1285332001,
    "descripcion":"GLAUCOMA DE ÁNGULO CERRADO CAUSADO POR FÁRMACO"
  },
  {
    "codigo":105684008,
    "descripcion":"INFECCIÓN CAUSADA POR LARVAS DE TENIA"
  },
  {
    "codigo":890281002,
    "descripcion":"DERMATITIS IRRITATIVA POR CONTACTO DE MANO CAUSADA POR ACEITE"
  },
  {
    "codigo":365993003,
    "descripcion":"ANTECEDENTES DE PRÁCTICA DE EJERCICIOS - HALLAZGO"
  },
  {
    "codigo":300457003,
    "descripcion":"LESIÓN DE VEJIGA URINARIA"
  },
  {
    "codigo":724606001,
    "descripcion":"ESPONDILOARTRITIS PERIFÉRICA"
  },
  {
    "codigo":1052286006,
    "descripcion":"AUSENCIA ADQUIRIDA PARCIAL DE MAMA"
  },
  {
    "codigo":1148755000,
    "descripcion":"PRODUCTOS DE LA CONCEPCIÓN RETENIDOS SIN HEMORRAGIA"
  },
  {
    "codigo":34643004,
    "descripcion":"DISPLASIA DIAFISARIA"
  },
  {
    "codigo":680651000119105,
    "descripcion":"MEIBOMIANITIS DE PÁRPADO SUPERIOR DERECHO"
  },
  {
    "codigo":32808002,
    "descripcion":"POSICIÓN FRONTOILÍACA IZQUIERDA POSTERIOR"
  },
  {
    "codigo":131112007,
    "descripcion":"CAROTENO POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":426024008,
    "descripcion":"CUIDADO POR ENFERMERA NOCTURNA"
  },
  {
    "codigo":65576009,
    "descripcion":"PÓLIPO CERVICAL UTERINO"
  },
  {
    "codigo":63741006,
    "descripcion":"INFECCIÓN FÚNGICA DEL PULMÓN"
  },
  {
    "codigo":293117006,
    "descripcion":"REACCIÓN ADVERSA A VACUNA ANTIPOLIOMIELÍTICA"
  },
  {
    "codigo":717266001,
    "descripcion":"SÍNDROME DE NEUROPATÍA ATÁXICA SENSITIVA CON DISARTRIA Y OFTALMOPARESIA"
  },
  {
    "codigo":94674004,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE BORDE BERMELLÓN DE LABIO INFERIOR"
  },
  {
    "codigo":15973221000119103,
    "descripcion":"ANOMALÍA CONGÉNITA DE VASO SANGUÍNEO DE EXTREMIDAD INFERIOR DERECHA"
  },
  {
    "codigo":291282005,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR FENOXIBENZAMINA"
  },
  {
    "codigo":715431002,
    "descripcion":"EMBRIOPATÍA CAUSADA POR FENOBARBITAL"
  },
  {
    "codigo":92839002,
    "descripcion":"FUSIÓN ANORMAL CONGÉNITA DEL ARCO DE LA VÉRTEBRA DORSAL"
  },
  {
    "codigo":289447005,
    "descripcion":"HALLAZGO RELACIONADO CON EL CRECIMIENTO FETAL"
  },
  {
    "codigo":420519005,
    "descripcion":"LINFOMA MALIGNO DE LA REGIÓN OCULAR"
  },
  {
    "codigo":125607007,
    "descripcion":"FRACTURA DE LA COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":254844000,
    "descripcion":"TUMOR FILOIDE MALIGNO DE MAMA"
  },
  {
    "codigo":58236001,
    "descripcion":"CRECIMIENTO CORPORAL NORMAL"
  },
  {
    "codigo":189308005,
    "descripcion":"CARCINOMA IN SITU DE PIEL DE BRAZO"
  },
  {
    "codigo":1336188007,
    "descripcion":"CARCINOMA METASTÁSICO DE CÉLULAS EN VIDRIO ESMERILADO"
  },
  {
    "codigo":123772008,
    "descripcion":"HEMOGLOBINOPATÍA HOMOCIGÓTICA"
  },
  {
    "codigo":1268817006,
    "descripcion":"TENDINITIS CALCIFICANTE DE REGIÓN DE PIE"
  },
  {
    "codigo":285777008,
    "descripcion":"ERITROCITOSIS IDIOPÁTICA"
  },
  {
    "codigo":283942003,
    "descripcion":"RUPTURA DE CONDUCTO DEFERENTE"
  },
  {
    "codigo":218406006,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR ETIONAMIDA"
  },
  {
    "codigo":251174009,
    "descripcion":"TRIGEMINISMO AURICULAR"
  },
  {
    "codigo":871931002,
    "descripcion":"REACCIÓN ALÉRGICA DESPUÉS DE INMUNOTERAPIA CON ALÉRGENO"
  },
  {
    "codigo":183803003,
    "descripcion":"ESTADÍA DE INTERNACIÓN, 5 DÍAS"
  },
  {
    "codigo":773627004,
    "descripcion":"SÍNDROME DE PORENCEFALIA, MICROCEFALIA Y CATARATA BILATERAL CONGÉNITA"
  },
  {
    "codigo":249339005,
    "descripcion":"NARINA ESTRECHA"
  },
  {
    "codigo":445947008,
    "descripcion":"OSIFICACIÓN HETEROTÓPICA DE TENDÓN"
  },
  {
    "codigo":247504002,
    "descripcion":"UÑAS COMIDAS"
  },
  {
    "codigo":50896005,
    "descripcion":"USO INAPROPIADO DE LA VOZ"
  },
  {
    "codigo":83664006,
    "descripcion":"HIPOTIROIDISMO ATRÓFICO IDIOPÁTICO"
  },
  {
    "codigo":739024006,
    "descripcion":"CORAZÓN TRASPLANTADO PRESENTE"
  },
  {
    "codigo":11768831000119106,
    "descripcion":"HEMATOMA SUBUNGUEAL DE DEDO MEÑIQUE DE MANO DERECHA"
  },
  {
    "codigo":704421005,
    "descripcion":"CON MAYOR RIESGO DE ALTERACIÓN DE LA CAPACIDAD PARA AFRONTAR SITUACIONES"
  },
  {
    "codigo":737189006,
    "descripcion":"ÚLCERA DE ESÓFAGO DEBIDA A TRASTORNO ALÉRGICO"
  },
  {
    "codigo":309370004,
    "descripcion":"SITUACIÓN DE CONSENTIMIENTO"
  },
  {
    "codigo":211066006,
    "descripcion":"ABRASIÓN INFECTADA DE VULVA"
  },
  {
    "codigo":407674008,
    "descripcion":"ASMA POR ASPIRINA"
  },
  {
    "codigo":1259642009,
    "descripcion":"COREA DEBIDA A DISCINESIA TARDÍA"
  },
  {
    "codigo":45391001,
    "descripcion":"QUEMADURA PROFUNDA DE TERCER GRADO DE SITIOS MÚLTIPLES DE LA EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":241999000,
    "descripcion":"LESIÓN VISCERAL POR DESCOMPRESIÓN"
  },
  {
    "codigo":274767007,
    "descripcion":"SIN ANOMALÍAS DETECTADAS EN EXAMEN DE COLUMNA VERTEBRAL"
  },
  {
    "codigo":373071008,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM SZULGAI"
  },
  {
    "codigo":1092761000119105,
    "descripcion":"IRIDOCICLITIS CAUSADA POR TUBERCULOSIS"
  },
  {
    "codigo":733519008,
    "descripcion":"SÍNDROME DE MICRODELECIÓN 17Q12"
  },
  {
    "codigo":764452004,
    "descripcion":"MACROANEURISMA DE ARTERIA DE LA RETINA CON ESTENOSIS PULMONAR SUPRAVALVULAR"
  },
  {
    "codigo":829988004,
    "descripcion":"PÚRPURA DE REGIÓN DE BOCA"
  },
  {
    "codigo":698916005,
    "descripcion":"IDIOMA PRINCIPAL HABLADO:OROMO"
  },
  {
    "codigo":404004004,
    "descripcion":"HISTIOCITOMA QUELOIDE DE LA PIEL"
  },
  {
    "codigo":305700007,
    "descripcion":"ATENDIDO POR MÉDICO ESPECIALISTA EN SALUD PÚBLICA"
  },
  {
    "codigo":860921002,
    "descripcion":"DISFUNCIÓN ERÉCTIL DEBIDA A ENFERMEDAD ENDOCRINA"
  },
  {
    "codigo":762617003,
    "descripcion":"LESIÓN TRAUMÁTICA DE CORTEZA VISUAL DERECHA"
  },
  {
    "codigo":402169007,
    "descripcion":"CICATRIZ DEBIDA A TRATAMIENTO Y POSTERIOR A ÉL"
  },
  {
    "codigo":271097008,
    "descripcion":"DEFORMIDAD DEL ASTRÁGALO"
  },
  {
    "codigo":72654001,
    "descripcion":"ARRITMIA SUPRAVENTRICULAR"
  },
  {
    "codigo":105422001,
    "descripcion":"EDUCACIÓN POBRE"
  },
  {
    "codigo":11824281000119109,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE BRAZO DERECHO"
  },
  {
    "codigo":68061000146103,
    "descripcion":"TRASTORNO DE TENDÓN EXTENSOR DE MANO"
  },
  {
    "codigo":267427000,
    "descripcion":"DEFICIENCIA DE DISACARIDASA"
  },
  {
    "codigo":300195001,
    "descripcion":"PROBLEMA EN OÍDO MEDIO"
  },
  {
    "codigo":5283001,
    "descripcion":"FACIES DE SABUESO"
  },
  {
    "codigo":1217699008,
    "descripcion":"CICATRIZ DE ACNÉ QUELOIDE"
  },
  {
    "codigo":396664001,
    "descripcion":"SIN LESIÓN EPITELIAL ASOCIADA AL TUMOR IDENTIFICADA"
  },
  {
    "codigo":365731008,
    "descripcion":"AMINOFILINA: NIVEL SANGUÍNEO - HALLAZGO"
  },
  {
    "codigo":724344004,
    "descripcion":"SÍNDROME DE HIPERCOAGULABILIDAD DEBIDO A DEFICIENCIA DE GLUCOSILFOSFATIDILINOSITOL"
  },
  {
    "codigo":298360005,
    "descripcion":"DEFORMIDAD ÓSEA EN ARCO"
  },
  {
    "codigo":167288007,
    "descripcion":"PRUEBA DE CUERPOS CETÓNICOS EN ORINA: TRAZAS"
  },
  {
    "codigo":429432009,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO DE REGIÓN DE HOMBRO"
  },
  {
    "codigo":722509001,
    "descripcion":"RABDOMIOSARCOMA PRIMARIO DE CAVIDAD BUCAL"
  },
  {
    "codigo":460365008,
    "descripcion":"ARTERIA COLATERAL QUE DERIVA EL FLUJO SISTÉMICO HACIA LA CIRCULACIÓN PULMONAR DESDE LA ARTERIA RENAL DERECHA"
  },
  {
    "codigo":294690002,
    "descripcion":"ALERGIA A HALCINONIDA"
  },
  {
    "codigo":1144823000,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR TIOPENTAL"
  },
  {
    "codigo":720674009,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR OLMESARTÁN"
  },
  {
    "codigo":63479002,
    "descripcion":"ANCILOSTOMIASIS"
  },
  {
    "codigo":292855007,
    "descripcion":"REACCIÓN ADVERSA A FÁRMACO ANTIPALÚDICO A BASE DE BIGUANIDA"
  },
  {
    "codigo":28876000,
    "descripcion":"DETERMINACIÓN DEL ESTADO DE LA ENFERMEDAD: NO CONTROLADA"
  },
  {
    "codigo":258252001,
    "descripcion":"ESTADIO S2 DE TUMOR DE LA ESCLERÓTICA"
  },
  {
    "codigo":718771009,
    "descripcion":"ATAXIA ESPINOCEREBELOSA TIPO 20"
  },
  {
    "codigo":192716003,
    "descripcion":"ENCEFALITIS POSVACUNACIÓN CONTRA LA FIEBRE AMARILLA"
  },
  {
    "codigo":290952001,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR METILFENOBARBITAL"
  },
  {
    "codigo":94412004,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE HUESO DEL METATARSO"
  },
  {
    "codigo":1208524007,
    "descripcion":"RECOLECCIÓN DE ESPÉCIMEN SUPERVISADA EN PERSONA POR UN PROFESIONAL SANITARIO"
  },
  {
    "codigo":225484008,
    "descripcion":"CONFIANZA EXCESIVA"
  },
  {
    "codigo":291020008,
    "descripcion":"INTOXICACIÓN INTENCIONAL CON SECOBARBITAL"
  },
  {
    "codigo":92577002,
    "descripcion":"CARCINOMA IN SITU DE DUODENO"
  },
  {
    "codigo":127180009,
    "descripcion":"LINFADENOPATÍA PRESINFISIAL"
  },
  {
    "codigo":254582000,
    "descripcion":"ADENOCARCINOMA DEL RECTO"
  },
  {
    "codigo":418422005,
    "descripcion":"CLASE IV DEL CENTRO DE PREVENCIÓN Y CONTROL DE ENFERMEDADES\/SUCIO-INFECTADO"
  },
  {
    "codigo":187211004,
    "descripcion":"INFESTACIÓN MIXTA POR PEDICULOSIS"
  },
  {
    "codigo":23371004,
    "descripcion":"TALASEMIA ÉPSILON GAMMA DELTA BETA"
  },
  {
    "codigo":711499009,
    "descripcion":"GASTRITIS COLAGENOSA"
  },
  {
    "codigo":285515009,
    "descripcion":"NO RETRAE LA LENGUA"
  },
  {
    "codigo":54304004,
    "descripcion":"PARÁLISIS BULBAR PROGRESIVA"
  },
  {
    "codigo":250912005,
    "descripcion":"PARED DE VENTRÍCULO IZQUIERDO HIPOCINÉTICA"
  },
  {
    "codigo":283680004,
    "descripcion":"HERIDA POR PINCHAZO DE CLAVO EN LA PLANTA DEL PIE"
  },
  {
    "codigo":609525000,
    "descripcion":"ABORTO ESPONTÁNEO DE EMBARAZO ECTÓPICO TUBARIO"
  },
  {
    "codigo":1363189000,
    "descripcion":"CAPAZ DE SENTARSE EN ASIENTO DE INODORO"
  },
  {
    "codigo":871669005,
    "descripcion":"ANOMALÍA ADQUIRIDA DE AORTA DEBIDA A CARDIOPATÍA CONGÉNITA"
  },
  {
    "codigo":740597009,
    "descripcion":"COMPLICACIÓN DEL CORDÓN UMBILICAL DURANTE EL TRABAJO DE PARTO Y EL PARTO"
  },
  {
    "codigo":17866004,
    "descripcion":"OTITIS MEDIA AGUDA SANGUINOLENTA ALÉRGICA"
  },
  {
    "codigo":11826791000119109,
    "descripcion":"DISTENSIÓN DE TENDÓN DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":685671000119109,
    "descripcion":"LEIOMIOSARCOMA PRIMARIO DE CUELLO"
  },
  {
    "codigo":11718401000119103,
    "descripcion":"XANTOMA DE AMBOS PÁRPADOS INFERIORES"
  },
  {
    "codigo":738762008,
    "descripcion":"FUNCIÓN NORMAL DE TRANSPORTADOR DE ANIONES ORGÁNICOS MIEMBRO DE LA FAMILIA 1B1"
  },
  {
    "codigo":11308801000119104,
    "descripcion":"MÚLTIPLES FRACTURAS POR COMPRESIÓN ANTEROPOSTERIOR DE PELVIS CON ANILLO PÉLVICO INESTABLE"
  },
  {
    "codigo":15732481000119104,
    "descripcion":"ENTROPIÓN CON ECTROPIÓN DE PÁRPADO INFERIOR IZQUIERDO"
  },
  {
    "codigo":704159006,
    "descripcion":"FRACTURA NO EXPUESTA DE FALANGE MEDIA DE DEDO MEDIO DE LA MANO"
  },
  {
    "codigo":472948001,
    "descripcion":"TRAVESTISMO"
  },
  {
    "codigo":210804004,
    "descripcion":"LESIÓN DEL TRONCO DE LA ARTERIA MESENTÉRICA SUPERIOR"
  },
  {
    "codigo":1259380004,
    "descripcion":"MELANOMA ACRAL LENTIGINOSO MALIGNO PRIMARIO DE PIEL"
  },
  {
    "codigo":700489002,
    "descripcion":"SORDERA NEUROSENSORIAL E INFERTILIDAD MASCULINA"
  },
  {
    "codigo":77897003,
    "descripcion":"MIOMALACIA"
  },
  {
    "codigo":405577005,
    "descripcion":"DISECCIÓN NO TRAUMÁTICA DE AORTA TORÁCICA"
  },
  {
    "codigo":331521000119108,
    "descripcion":"ENTROPIÓN ESPÁSTICO DE PÁRPADO SUPERIOR DERECHO"
  },
  {
    "codigo":733257009,
    "descripcion":"LUXACIÓN TRAUMÁTICA DE ARTICULACIÓN METACARPOFALÁNGICA DE DEDO DE LA MANO"
  },
  {
    "codigo":370974004,
    "descripcion":"EXPULSIÓN DE LA ESCUELA"
  },
  {
    "codigo":403742006,
    "descripcion":"NEOPLASIA MALIGNA DE PIEL CAUSADA POR ARSÉNICO"
  },
  {
    "codigo":698654008,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: VASCO"
  },
  {
    "codigo":762355002,
    "descripcion":"LESIÓN DE TRONCO ENCEFÁLICO"
  },
  {
    "codigo":205299003,
    "descripcion":"SÍNDROME DE ANILLO CONSTRICTIVO DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":8691004,
    "descripcion":"ICTIOSIS ADQUIRIDA"
  },
  {
    "codigo":238067002,
    "descripcion":"DEFICIENCIA DE LA TIOLASA PEROXISÓMICA"
  },
  {
    "codigo":74227009,
    "descripcion":"APRAXIA DE FONACIÓN"
  },
  {
    "codigo":170696005,
    "descripcion":"PROBLEMA DE DISCAPACIDAD FÍSICA"
  },
  {
    "codigo":400072006,
    "descripcion":"REACCIÓN FIJA POR FÁRMACOS"
  },
  {
    "codigo":301768009,
    "descripcion":"CONTUSIÓN SUPRAORBITARIA"
  },
  {
    "codigo":299933002,
    "descripcion":"SENSIBILIDAD VIBRATORIA PRESENTE"
  },
  {
    "codigo":10846261000119101,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO PLANTAR EXTERNO IZQUIERDO"
  },
  {
    "codigo":365469004,
    "descripcion":"HALLAZGO EN LA ESTRUCTURA DEL HOGAR, LA FAMILIA Y REDES DE APOYO"
  },
  {
    "codigo":725917007,
    "descripcion":"SINUSITIS AGUDA CAUSADA POR VIRUS"
  },
  {
    "codigo":167026000,
    "descripcion":"NIVEL DE OXÍGENO EN SANGRE FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":298098002,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE PIERNA"
  },
  {
    "codigo":66887000,
    "descripcion":"SÍFILIS TARDÍA LATENTE (SEROLOGÍA POSITIVA, LÍQUIDO CEFALORRAQUÍDEO NEGATIVO 2 AÑOS DESPUÉS)"
  },
  {
    "codigo":1351002,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA ARTERIA ILÍACA"
  },
  {
    "codigo":296263002,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE DECANOATO DE ZUCLOPENTIXOL"
  },
  {
    "codigo":197959008,
    "descripcion":"HIPERPLASIA PROSTÁTICA DEL LÓBULO LATERAL"
  },
  {
    "codigo":425500002,
    "descripcion":"ESCLEROSIS MÚLTIPLE PROGRESIVA SECUNDARIA"
  },
  {
    "codigo":196124003,
    "descripcion":"BLOQUEO CAPILAR ALVEOLAR"
  },
  {
    "codigo":720412009,
    "descripcion":"SÍNDROME ACROPECTORAL"
  },
  {
    "codigo":32284009,
    "descripcion":"TRASTORNO DE LA TOLERANCIA A LA GLUCOSA EN INDIVIDUOS NO OBESOS"
  },
  {
    "codigo":194289001,
    "descripcion":"OTITIS MEDIA DERECHA AGUDA"
  },
  {
    "codigo":30449003,
    "descripcion":"PIE CALCANEOVARO"
  },
  {
    "codigo":718577005,
    "descripcion":"DISCAPACIDAD INTELECTUAL LIGADA AL CROMOSOMA X TIPO ATKIN"
  },
  {
    "codigo":1144561006,
    "descripcion":"SANITIZACIÓN ADECUADA"
  },
  {
    "codigo":390897008,
    "descripcion":"ABSCESO SUPURATIVO DE VAGINA"
  },
  {
    "codigo":716742001,
    "descripcion":"OSTEOCONDROMA MÚLTIPLE DE HUESOS LARGOS"
  },
  {
    "codigo":126918002,
    "descripcion":"NEOPLASIA DEL PARAMETRIO"
  },
  {
    "codigo":292593009,
    "descripcion":"REACCIÓN ADVERSA A LA HIDROXIZINA"
  },
  {
    "codigo":192454004,
    "descripcion":"INSOMNIO NO ORGÁNICO"
  },
  {
    "codigo":688181000119109,
    "descripcion":"NEURILEMOMA DE NERVIO DE LA PELVIS"
  },
  {
    "codigo":15980751000119103,
    "descripcion":"ARTRITIS DE AMBAS ARTICULACIONES TEMPOROMANDIBULARES"
  },
  {
    "codigo":1306566003,
    "descripcion":"CARCINOMA DUCTAL INFILTRANTE DE CUADRANTE SUPERIOR EXTERNO DE MAMA DERECHA"
  },
  {
    "codigo":290758006,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR FORMESTANO"
  },
  {
    "codigo":94150003,
    "descripcion":"DEFECTO DEL TABIQUE VENTRICULAR MEMBRANOSO"
  },
  {
    "codigo":92315002,
    "descripcion":"NEOPLASIA BENIGNA DEL FONDO DE SACO RECTOUTERINO"
  },
  {
    "codigo":59547000,
    "descripcion":"ENFERMEDAD DE KUESS"
  },
  {
    "codigo":90480005,
    "descripcion":"RESPIRACIÓN INTERRUMPIDA"
  },
  {
    "codigo":285253003,
    "descripcion":"CAPAZ DE RESISTIRSE A LOS PENSAMIENTOS PELIGROSOS CON FACILIDAD"
  },
  {
    "codigo":10957161000119101,
    "descripcion":"HERIDA ABIERTA DE DEDO ÍNDICE DERECHO DEBIDA A MORDEDURA HUMANA"
  },
  {
    "codigo":414490001,
    "descripcion":"INFECCIÓN CAUSADA POR UNCINARIA"
  },
  {
    "codigo":840474005,
    "descripcion":"HIPERPLASIA SUPRARRENAL CONGÉNITA LIPOIDE DEBIDA A DEFICIENCIA DE PROTEÍNA REGULADORA AGUDA ESTEROIDOGÉNICA, FORMA CLÁSICA"
  },
  {
    "codigo":283418006,
    "descripcion":"CORTE EN LA PALMA DE LA MANO"
  },
  {
    "codigo":281583001,
    "descripcion":"EMACIACIÓN DE CAUSA NUTRICIONAL"
  },
  {
    "codigo":445423005,
    "descripcion":"MIELOPATÍA NECRÓTICA SUBAGUDA PARANEOPLÁSICA"
  },
  {
    "codigo":246980005,
    "descripcion":"INYECCIÓN EN LA ESCLERÓTICA"
  },
  {
    "codigo":1230020008,
    "descripcion":"ESTAFILOMA PERIPAPILAR CONGÉNITO"
  },
  {
    "codigo":16527721000119108,
    "descripcion":"CARCINOMA NO MICROCÍTICO PRIMARIO DE LÓBULO SUPERIOR DE PULMÓN DERECHO"
  },
  {
    "codigo":1259118006,
    "descripcion":"HERNIA TRANSTENTORIAL CENTRAL"
  },
  {
    "codigo":276078007,
    "descripcion":"CESE DE NEGOCIOS POR CAUSAS PERSONALES"
  },
  {
    "codigo":896835002,
    "descripcion":"FORMA TRIANGULAR ANORMAL CONGÉNITA DE EPÍFISIS DE FALANGE DE DEDO ÍNDICE"
  },
  {
    "codigo":765763007,
    "descripcion":"QUISTE CONGÉNITO DE LARINGE"
  },
  {
    "codigo":403480006,
    "descripcion":"AFTOSIS VULVAR"
  },
  {
    "codigo":1255448006,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE DEDO ÍNDICE DE MANO"
  },
  {
    "codigo":1222680009,
    "descripcion":"EFICIENCIA COMBINADA DE FOSFORILACIÓN OXIDATIVA TIPO 24"
  },
  {
    "codigo":1351917001,
    "descripcion":"HEMANGIOBLASTOMA DE RIÑÓN"
  },
  {
    "codigo":90781000119102,
    "descripcion":"MICROALBUMINURIA DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":268738002,
    "descripcion":"DISORTOGRAFÍA"
  },
  {
    "codigo":203202004,
    "descripcion":"ABSCESO DE BRODIE DEL CÓCCIX"
  },
  {
    "codigo":6594005,
    "descripcion":"TRASTORNO CEREBROVASCULAR EN EL PUERPERIO"
  },
  {
    "codigo":301506008,
    "descripcion":"NO ENTRA NI SALE DE LA DUCHA"
  },
  {
    "codigo":365207002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA REALIZAR ACTIVIDADES DE EVACUACIÓN"
  },
  {
    "codigo":70295002,
    "descripcion":"VIOLACIÓN DE MENORES"
  },
  {
    "codigo":299671008,
    "descripcion":"PÉRDIDA DEL VELLO AXILAR"
  },
  {
    "codigo":397975009,
    "descripcion":"BLOQUEO DE LA CONDUCCIÓN NERVIOSA SENSITIVA - INERVACIÓN CEFÁLICA INADECUADA"
  },
  {
    "codigo":723820001,
    "descripcion":"PARAPLEJÍA ESPÁSTICA AUTOSÓMICA DOMINANTE TIPO 4"
  },
  {
    "codigo":232300004,
    "descripcion":"DEFORMIDAD CONGÉNITA DEL LABERINTO"
  },
  {
    "codigo":1089000,
    "descripcion":"SEPSIS FETAL INTRAUTERINA"
  },
  {
    "codigo":230465000,
    "descripcion":"AURA DE MIGRAÑA SIN CEFALEA"
  },
  {
    "codigo":164929001,
    "descripcion":"ELECTROCARDIOGRAMA: INTERVALO ST NORMAL"
  },
  {
    "codigo":363372009,
    "descripcion":"NEOPLASIA MALIGNA DE BORDE BERMELLÓN DE LABIO SUPERIOR"
  },
  {
    "codigo":668001000005101,
    "descripcion":"ERITROCITOS EN ORINA = +"
  },
  {
    "codigo":197697005,
    "descripcion":"SÍNDROME NEFRÍTICO RÁPIDAMENTE PROGRESIVO, GLOMERULONEFRITIS SEMILUNAR DIFUSA"
  },
  {
    "codigo":296001007,
    "descripcion":"SOBREDOSIS INTENCIONAL DE VIGABATRINA"
  },
  {
    "codigo":263233008,
    "descripcion":"FRACTURA NO EXPUESTA DE FÉMUR, EXTREMO DISTAL"
  },
  {
    "codigo":359702001,
    "descripcion":"COROIDITIS FÚNGICA"
  },
  {
    "codigo":32022003,
    "descripcion":"MIOPÍA ALTA PROGRESIVA DEGENERATIVA"
  },
  {
    "codigo":1073821000119109,
    "descripcion":"ARTRITIS REUMATOIDE DE HOMBRO DERECHO"
  },
  {
    "codigo":62955002,
    "descripcion":"CUERPO EXTRAÑO NO MAGNÉTICO RETENIDO EN EL CUERPO VÍTREO"
  },
  {
    "codigo":1177067004,
    "descripcion":"COMPRESIÓN DE MÉDULA ESPINAL DEBIDA A TUBERCULOSIS"
  },
  {
    "codigo":128491006,
    "descripcion":"OSIFICACIÓN HETEROTÓPICA"
  },
  {
    "codigo":292331008,
    "descripcion":"REACCIÓN ADVERSA A FÁRMACO SEDANTE"
  },
  {
    "codigo":716480001,
    "descripcion":"DIFICULTAD PARA COMPRENDER INSTRUCCIONES DE UNA SOLA PALABRA"
  },
  {
    "codigo":29701000175106,
    "descripcion":"ÚLCERA POR PRESIÓN EN CADERA, ESTADIO IV"
  },
  {
    "codigo":61120003,
    "descripcion":"HIPOCALIEMIA AGUDA"
  },
  {
    "codigo":224960004,
    "descripcion":"CANSADO"
  },
  {
    "codigo":126656003,
    "descripcion":"NEOPLASIA DE MUSLO"
  },
  {
    "codigo":290496006,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR PROPOFOL"
  },
  {
    "codigo":95723009,
    "descripcion":"CATARATA SUBCAPSULAR"
  },
  {
    "codigo":26517000,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE DEDO DE LA MANO"
  },
  {
    "codigo":93888008,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL MAXILAR SUPERIOR"
  },
  {
    "codigo":59285001,
    "descripcion":"SÍNDROME DE MALABSORCIÓN DE ÁCIDOS BILIARES, TIPO II"
  },
  {
    "codigo":589157321000132102,
    "descripcion":"DIVERTÍCULO DE TEJIDO PERIAMPULAR DE AMPOLLA HEPATOPANCREÁTICA"
  },
  {
    "codigo":288661004,
    "descripcion":"NO ESPERA SU TURNO EN LA CONVERSACIÓN"
  },
  {
    "codigo":254058002,
    "descripcion":"DISPLASIA PSEUDODIASTRÓFICA"
  },
  {
    "codigo":286826004,
    "descripcion":"TIENDE A SENTIR PLACER POR EL SUFRIMIENTO AJENO"
  },
  {
    "codigo":284991002,
    "descripcion":"CAPAZ DE DESCALZARSE"
  },
  {
    "codigo":283156002,
    "descripcion":"CUERPO EXTRAÑO METÁLICO EN EL BRAZO"
  },
  {
    "codigo":1004052002,
    "descripcion":"CONTRACTURA EN FLEXIÓN DE ARTICULACIÓN METATARSOFALÁNGICA DE TERCER DEDO DE PIE"
  },
  {
    "codigo":1264361000,
    "descripcion":"SUBLUXACIÓN DE ARTICULACIÓN INTERTARSIANA"
  },
  {
    "codigo":1231593001,
    "descripcion":"OBSTRUCCIÓN DE LUZ DE VÍA RESPIRATORIA CAUSADA POR CUERPO EXTRAÑO POSTERIOR A INGESTA"
  },
  {
    "codigo":117481001,
    "descripcion":"CRISTAL URINARIO, DIHIDRATO DE OXALATO DE CALCIO"
  },
  {
    "codigo":838377003,
    "descripcion":"HEPATITIS C CRÓNICA CON INFECCIÓN CONCOMITANTE POR VIRUS DE INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":445161004,
    "descripcion":"PRUEBA DE FUNCIÓN VESTIBULAR NORMAL"
  },
  {
    "codigo":50110003,
    "descripcion":"AUSENCIA DE CÉLULAS ENDOCERVICALES"
  },
  {
    "codigo":17342003,
    "descripcion":"ERITROCITOSIS PURA HEREDITARIA"
  },
  {
    "codigo":11807851000119103,
    "descripcion":"RUPTURA TRAUMÁTICA DE LIGAMENTO SEMILUNOPIRAMIDAL IZQUIERDO"
  },
  {
    "codigo":1162387003,
    "descripcion":"CONDUCTA DE ALIMENTACIÓN POR ATRACÓN"
  },
  {
    "codigo":41281000087101,
    "descripcion":"HEMATOMA DE HOMBRO DERECHO"
  },
  {
    "codigo":46401000087101,
    "descripcion":"FRACTURA DE EPÍFISIS DISTAL DE FÉMUR DERECHO"
  },
  {
    "codigo":33601000087105,
    "descripcion":"BRONQUIOLITIS AGUDA POR VAPORES QUÍMICOS"
  },
  {
    "codigo":243048001,
    "descripcion":"HERIDA DE GUERRA POR COLISIÓN DE AERONAVE"
  },
  {
    "codigo":43841000087106,
    "descripcion":"HERIDA CORTANTE DE PIEL DE DEDO ÍNDICE IZQUIERDO"
  },
  {
    "codigo":10561000087108,
    "descripcion":"LESIÓN TRAUMÁTICA DE DIAFRAGMA DURANTE INTERVENCIÓN QUIRÚRGICA"
  },
  {
    "codigo":439656005,
    "descripcion":"ARTRITIS DE CODO"
  },
  {
    "codigo":339051000119106,
    "descripcion":"GRANULOMA DE ÓRBITA IZQUIERDA"
  },
  {
    "codigo":111976007,
    "descripcion":"FRAGILIDAD CAPILAR DISMINUIDA"
  },
  {
    "codigo":1258856003,
    "descripcion":"HIPOMINERALIZACIÓN DE ESMALTE DE SEGUNDO MOLAR DECIDUO"
  },
  {
    "codigo":372285001,
    "descripcion":"GIGANTOMASTIA"
  },
  {
    "codigo":110141002,
    "descripcion":"LACERACIÓN COMPLEJA DE LA OROFARINGE"
  },
  {
    "codigo":208445007,
    "descripcion":"FRACTURA NO EXPUESTA DE FALANGE PROXIMAL DE DEDO DE LA MANO, BASE"
  },
  {
    "codigo":306749007,
    "descripcion":"INCAPAZ DE MOVER LA LENGUA DE MANERA SIMÉTRICA"
  },
  {
    "codigo":42770003,
    "descripcion":"SÍFILIS DE VÁLVULA TRICÚSPIDE"
  },
  {
    "codigo":304914007,
    "descripcion":"INFARTO AGUDO DE MIOCARDIO DE TIPO Q"
  },
  {
    "codigo":403218008,
    "descripcion":"PIGMENTACIÓN FISIOLÓGICA DE MEMBRANAS MUCOSAS"
  },
  {
    "codigo":237543000,
    "descripcion":"ANOMALÍA DE LA FIJACIÓN DE LA HORMONA TIROIDEA"
  },
  {
    "codigo":763666008,
    "descripcion":"LINFOMA DE LINFOCITOS B DE LA ZONA MARGINAL ESPLÉNICA"
  },
  {
    "codigo":235708000,
    "descripcion":"ENTEROPATÍA CRÓNICA POR RADIACIÓN"
  },
  {
    "codigo":1351655009,
    "descripcion":"SÍNDROME DE JANSEN-DE VRIES"
  },
  {
    "codigo":170172001,
    "descripcion":"EXAMEN DEL NIÑO A LOS 10 AÑOS: NORMAL"
  },
  {
    "codigo":8167009,
    "descripcion":"INFECCIÓN CAUSADA POR TAENIA HYDATIGENA"
  },
  {
    "codigo":725393000,
    "descripcion":"HIPOMAGNESEMIA PRIMARIA AUTOSÓMICA DOMINANTE CON HIPOCALCIURIA"
  },
  {
    "codigo":364945002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA REALIZAR FUNCIÓN MOTORA ORAL"
  },
  {
    "codigo":299409003,
    "descripcion":"PRUEBA DE DESPLAZAMIENTO DEL EJE - INESTABILIDAD"
  },
  {
    "codigo":233873004,
    "descripcion":"MIOCARDIOPATÍA HIPERTRÓFICA"
  },
  {
    "codigo":11836831000119101,
    "descripcion":"SUBLUXACIÓN DE ARTICULACIÓN TARSOMETATARSIANA DE PIE DERECHO"
  },
  {
    "codigo":102801008,
    "descripcion":"SECRECIÓN AUMENTADA DE RENINA"
  },
  {
    "codigo":232038007,
    "descripcion":"OCLUSIÓN DE LA VENA CENTRAL DE LA RETINA CON NEOVASCULARIZACIÓN"
  },
  {
    "codigo":262971000,
    "descripcion":"LESIÓN DE TENDÓN DE LA MANO"
  },
  {
    "codigo":295739000,
    "descripcion":"SOBREDOSIS DE CISPLATINO"
  },
  {
    "codigo":461414007,
    "descripcion":"ANEURISMA SUBAÓRTICO ADQUIRIDO DE VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":721723003,
    "descripcion":"ADENOMIOMATOSIS DE VESÍCULA BILIAR"
  },
  {
    "codigo":361275004,
    "descripcion":"DISPRAXIA ORAL"
  },
  {
    "codigo":827006,
    "descripcion":"SÍFILIS CONGÉNITA TARDÍA, LATENTE (SEROLOGÍA POSITIVA, LÍQUIDO CEFALORRAQUÍDEO NEGATIVO, 2 AÑOS O MÁS)"
  },
  {
    "codigo":230203007,
    "descripcion":"ABSCESO PIOGÉNICO INTRACRANEAL"
  },
  {
    "codigo":16260511000119105,
    "descripcion":"PARÁLISIS DE NERVIO RADIAL IZQUIERDO"
  },
  {
    "codigo":33595009,
    "descripcion":"QUISTE ARACNOIDEO"
  },
  {
    "codigo":293904007,
    "descripcion":"ALERGIA A TEMAZEPAM"
  },
  {
    "codigo":128229003,
    "descripcion":"TRASTORNO DE HUESO LAGRIMAL"
  },
  {
    "codigo":95461006,
    "descripcion":"TROMBOFLEBITIS DE VENA CEREBRAL"
  },
  {
    "codigo":292069008,
    "descripcion":"REACCIÓN ADVERSA A LA ACEMETACINA"
  },
  {
    "codigo":718053009,
    "descripcion":"PERIODONTITIS PERIAPICAL SINTOMÁTICA"
  },
  {
    "codigo":1142202002,
    "descripcion":"LESIÓN TRAUMÁTICA DE CUELLO POR HIPEREXTENSIÓN"
  },
  {
    "codigo":421306004,
    "descripcion":"ESCARA NECRÓTICA"
  },
  {
    "codigo":93626007,
    "descripcion":"FALTA DE OSIFICACIÓN DEL CALCÁNEO"
  },
  {
    "codigo":124559000,
    "descripcion":"DEFICIENCIA DE TIOÉTER HIDROLASA"
  },
  {
    "codigo":290234008,
    "descripcion":"INTOXICACIÓN POR DICLOFENACO"
  },
  {
    "codigo":714383003,
    "descripcion":"CAPAZ DE ADMINISTRARSE MEDICACIÓN NO PARENTERAL"
  },
  {
    "codigo":253796000,
    "descripcion":"YEYUNO DOBLE"
  },
  {
    "codigo":712548002,
    "descripcion":"ARTRITIS BACTERIANA DE ARTICULACIÓN CIGOAPOFISARIA DE LA COLUMNA VERTEBRAL LUMBAR"
  },
  {
    "codigo":286564009,
    "descripcion":"CUERPO EXTRAÑO EN LA MAMA"
  },
  {
    "codigo":22585003,
    "descripcion":"DERMATOSIS PAPULOESCAMOSA"
  },
  {
    "codigo":250126000,
    "descripcion":"ARTRITIS SIMÉTRICA"
  },
  {
    "codigo":448569009,
    "descripcion":"NÓDULO DE ESTRUCTURA UMBILICAL"
  },
  {
    "codigo":1231331002,
    "descripcion":"DEPENDENCIA DE PSICOESTIMULANTE EN REMISIÓN"
  },
  {
    "codigo":444899003,
    "descripcion":"DOLOR EN ANTEBRAZO"
  },
  {
    "codigo":1264099004,
    "descripcion":"AMPOLLA TRAUMÁTICA DE DEDO ANULAR"
  },
  {
    "codigo":15634131000119106,
    "descripcion":"TOMOGRAFÍA COMPUTARIZADA DE PARED ABDOMINAL ANORMAL"
  },
  {
    "codigo":2201000124101,
    "descripcion":"INCISIVO LATERAL INFERIOR DERECHO DECIDUO SUPERNUMERARIO"
  },
  {
    "codigo":10692461000119101,
    "descripcion":"TUMORACIÓN DE LA PIEL DEL PULGAR IZQUIERDO"
  },
  {
    "codigo":460441000124109,
    "descripcion":"PLESIOMONAS SHIGELLOIDES NO AISLADA"
  },
  {
    "codigo":15935341000119102,
    "descripcion":"DEFORMIDAD EN FLEXIÓN DE ARTICULACIÓN DE PIE IZQUIERDO"
  },
  {
    "codigo":288621000119102,
    "descripcion":"PATRÓN DE COMPORTAMIENTO DE TIPO A"
  },
  {
    "codigo":406626001,
    "descripcion":"INFECCIÓN CAUSADA POR VIBRIO PARAHAEMOLYTICUS"
  },
  {
    "codigo":78946008,
    "descripcion":"QUERATOCONJUNTIVITIS SECA, EN EL SÍNDROME DE SJÖGREN"
  },
  {
    "codigo":373858009,
    "descripcion":"CAMBIO EN EL CURSO DE RADIOTERAPIA DEBIDO A TOXICIDAD AGUDA POR RADIOTERAPIA"
  },
  {
    "codigo":208183001,
    "descripcion":"FRACTURA NO EXPUESTA DE PELVIS, ESPINA ILÍACA ANTEROINFERIOR"
  },
  {
    "codigo":372023003,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL TERCIO SUPERIOR DEL ESÓFAGO"
  },
  {
    "codigo":109879008,
    "descripcion":"NEOPLASIA SUPERPUESTA MALIGNA DEL CUERPO UTERINO"
  },
  {
    "codigo":763404001,
    "descripcion":"SÍNDROME DE ICTIOSIS, ALOPECIA, ECLABIÓN, ECTROPIÓN Y DISCAPACIDAD INTELECTUAL"
  },
  {
    "codigo":9740002,
    "descripcion":"MACROENCEFALIA"
  },
  {
    "codigo":1254924003,
    "descripcion":"DERMATITIS DE CONTACTO IRRITATIVA DE PIEL DE CARA"
  },
  {
    "codigo":304652006,
    "descripcion":"DIFICULTAD PARA EMPLEAR ESTRATEGIAS PARA LA TOMA DE DECISIONES"
  },
  {
    "codigo":239116006,
    "descripcion":"NEVO EXOCRINO"
  },
  {
    "codigo":40673001,
    "descripcion":"SÍNDROME POSTENCEFALÍTICO"
  },
  {
    "codigo":402956009,
    "descripcion":"INFECCIÓN CUTÁNEA GONOCÓCICA LOCALIZADA"
  },
  {
    "codigo":1187553006,
    "descripcion":"TRASTORNO GLOMERULAR DEBIDO A AMILOIDOSIS SISTÉMICA SECUNDARIA"
  },
  {
    "codigo":204513008,
    "descripcion":"ESTENOSIS CONGÉNITA DE NARINAS"
  },
  {
    "codigo":344071000119102,
    "descripcion":"ASTIGMATISMO REGULAR BILATERAL"
  },
  {
    "codigo":237281009,
    "descripcion":"PREECLAMPSIA MODERADA"
  },
  {
    "codigo":202678002,
    "descripcion":"ESPONDILOSIS LUMBOSACRA EN UN NIVEL CON MIELOPATÍA"
  },
  {
    "codigo":300982005,
    "descripcion":"ÚLCERA CUTÁNEA DEL DORSO DEL PIE"
  },
  {
    "codigo":397451000,
    "descripcion":"LINFOMA QUE COMPROMETE HÍGADO"
  },
  {
    "codigo":169910009,
    "descripcion":"PUNTAJE DE APGAR A LOS 5 MINUTOS = 0"
  },
  {
    "codigo":399286009,
    "descripcion":"TOXICIDAD DEL PESTICIDA CARBAMATO"
  },
  {
    "codigo":366518008,
    "descripcion":"HALLAZGO RELACIONADO CON LA AMPLITUD DE PRONACIÓN PASIVA DE CODO"
  },
  {
    "codigo":299147002,
    "descripcion":"AMPLITUD DE FLEXIÓN PASIVA DEL PULGAR AUMENTADA"
  },
  {
    "codigo":168075002,
    "descripcion":"CÁLCULO: FOSFATO"
  },
  {
    "codigo":102539006,
    "descripcion":"POSICIÓN SEMIERECTA"
  },
  {
    "codigo":200843008,
    "descripcion":"DERMATITIS ALÉRGICA DE CONTACTO CAUSADA POR COSMÉTICO"
  },
  {
    "codigo":69771008,
    "descripcion":"ANOMALÍA CONGÉNITA DEL ESÓFAGO"
  },
  {
    "codigo":199008003,
    "descripcion":"HIPERTENSIÓN SECUNDARIA PREEXISTENTE QUE COMPLICA EMBARAZO, PARTO Y PUERPERIO"
  },
  {
    "codigo":35168006,
    "descripcion":"EMPIEMA AGUDO DE SENO ETMOIDAL"
  },
  {
    "codigo":426549001,
    "descripcion":"ENFERMEDAD DE CROHN EN REMISIÓN"
  },
  {
    "codigo":1149280009,
    "descripcion":"ENFERMEDAD POR DEPÓSITO DE HIDROXIAPATITA DE ARTICULACIÓN DE TOBILLO"
  },
  {
    "codigo":12114081000119101,
    "descripcion":"QUEMADURA QUÍMICA DE OJO IZQUIERDO"
  },
  {
    "codigo":721461001,
    "descripcion":"SÍNDROME DEL CORDÓN ANTERIOR DE MÉDULA ESPINAL AL NIVEL DEL SEXTO SEGMENTO DORSAL"
  },
  {
    "codigo":262709008,
    "descripcion":"LACERACIÓN DE MÉDULA ESPINAL SACRA"
  },
  {
    "codigo":64266000,
    "descripcion":"JUEGO SEXUAL ENTRE HERMANA Y HERMANA"
  },
  {
    "codigo":717791000,
    "descripcion":"SÍNDROME DE BARTTER TIPO 4A"
  },
  {
    "codigo":29663003,
    "descripcion":"PRODUCCIÓN ANORMAL DE MONOCITOS"
  },
  {
    "codigo":11786401000119104,
    "descripcion":"AMPOLLA DE DEDO ANULAR DE MANO IZQUIERDA, CON INFECCIÓN"
  },
  {
    "codigo":93364000,
    "descripcion":"POSICIÓN ANÓMALA CONGÉNITA DEL CÚBITO"
  },
  {
    "codigo":95199009,
    "descripcion":"PALIDEZ HEPÁTICA"
  },
  {
    "codigo":291807009,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR ACETOHEXAMIDA"
  },
  {
    "codigo":191668004,
    "descripcion":"ESTADO PARANOIDE SIMPLE"
  },
  {
    "codigo":224436007,
    "descripcion":"INSTALACIONES DE AGUA POTABLE INADECUADAS EN EL TRABAJO"
  },
  {
    "codigo":91529004,
    "descripcion":"FALLO DE VÁLVULA CARDÍACA REUMÁTICA"
  },
  {
    "codigo":124297004,
    "descripcion":"DEFICIENCIA DE HEXOCINASA"
  },
  {
    "codigo":1269342002,
    "descripcion":"LESIÓN DE MÉDULA ESPINAL DORSAL DEBIDA A LUXACIÓN NO EXPUESTA DE ARTICULACIÓN DE COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":253534003,
    "descripcion":"TRACTO DE SALIDA DEL VENTRÍCULO DERECHO AUSENTE"
  },
  {
    "codigo":286302009,
    "descripcion":"CAPAZ DE UTILIZAR SONIDOS AISLADOS"
  },
  {
    "codigo":318171000119100,
    "descripcion":"TENDINITIS DE TIBIAL POSTERIOR IZQUIERDO"
  },
  {
    "codigo":16077531000119101,
    "descripcion":"CONJUNTIVITIS HEMORRÁGICA AGUDA DE AMBOS OJOS CAUSADA POR ENTEROVIRUS"
  },
  {
    "codigo":15632091000119101,
    "descripcion":"FIBROMATOSIS DE LA FASCIA PLANTAR DEL PIE IZQUIERDO"
  },
  {
    "codigo":295131000119103,
    "descripcion":"ABSCESO DE BOLSA SEROSA DE MANO"
  },
  {
    "codigo":307931000119104,
    "descripcion":"FÍSTULA DE ARTICULACIÓN DE REGIÓN DE HOMBRO DERECHO"
  },
  {
    "codigo":305371000119105,
    "descripcion":"CONTRACTURA DE MÚSCULO DE ANTEBRAZO DERECHO"
  },
  {
    "codigo":12214491000119106,
    "descripcion":"INFECCIÓN DE HÚMERO IZQUIERDO ASOCIADA CON DISPOSITIVO DE FIJACIÓN INTERNA"
  },
  {
    "codigo":22323009,
    "descripcion":"INFARTO AGUDO DE INTESTINO"
  },
  {
    "codigo":310491000119108,
    "descripcion":"INFECCIÓN PIÓGENA DE DISCO INTERVERTEBRAL CERVICAL"
  },
  {
    "codigo":500790491000119109,
    "descripcion":"ÚLCERA GÁSTRICA AGUDA CAUSADA POR CYTOMEGALOVIRUS"
  },
  {
    "codigo":12201691000119109,
    "descripcion":"DOLOR DEBIDO A ARTROPLASTIA DE MUÑECA IZQUIERDA Y POSTERIOR A ELLA"
  },
  {
    "codigo":774152007,
    "descripcion":"DISTROFIA RETINIANA CON DISFUNCIÓN RETINIANA INTERNA Y ANOMALÍAS DE LAS CÉLULAS GANGLIONARES"
  },
  {
    "codigo":323291000119108,
    "descripcion":"ARTROSIS DE CADERA IZQUIERDA"
  },
  {
    "codigo":333531000119105,
    "descripcion":"PAPILITIS ÓPTICA DE OJO DERECHO"
  },
  {
    "codigo":1362141002,
    "descripcion":"SINUSITIS MAXILAR ODONTÓGENA IATROGÉNICA POSTERIOR A PROCEDIMIENTO EN DIENTE"
  },
  {
    "codigo":5851000119107,
    "descripcion":"SOBREDOSIS DE AGENTE PSICOTRÓPICO"
  },
  {
    "codigo":18653004,
    "descripcion":"DELIRIUM POR INTOXICACIÓN ALCOHÓLICA"
  },
  {
    "codigo":16067291000119109,
    "descripcion":"ALERGIA A VENENO DE HIMENÓPTERO"
  },
  {
    "codigo":282632008,
    "descripcion":"CAPAZ DE RODAR SOBRE SÍ MISMO"
  },
  {
    "codigo":248029003,
    "descripcion":"ROBO A HERMANOS DE SEXO FEMENINO O MASCULINO"
  },
  {
    "codigo":82354003,
    "descripcion":"SÍNDROME DE MALFORMACIONES CONGÉNITAS MÚLTIPLES"
  },
  {
    "codigo":211591001,
    "descripcion":"LESIÓN TRAUMÁTICA ABIERTA POR APLASTAMIENTO, MUSLO"
  },
  {
    "codigo":277127006,
    "descripcion":"SIMETRÍA DE LOS POTENCIALES EVOCADOS SOMATOSENSORIALES"
  },
  {
    "codigo":735879008,
    "descripcion":"FRACTURA DE HUESO CUNEIFORME INTERMEDIO"
  },
  {
    "codigo":373596001,
    "descripcion":"FRACTURA DE PENE ERECTO"
  },
  {
    "codigo":766812005,
    "descripcion":"SÍNDROME DE TRICODISPLASIA Y XERODERMIA"
  },
  {
    "codigo":111452009,
    "descripcion":"AFIBRINOGENEMIA POSTPARTO CON HEMORRAGIA"
  },
  {
    "codigo":240689001,
    "descripcion":"RADESYGE"
  },
  {
    "codigo":109617003,
    "descripcion":"INFLAMACIÓN SUPURATIVA DEL ESPACIO SUBGINGIVAL"
  },
  {
    "codigo":207921003,
    "descripcion":"FRACTURA EXPUESTA DEL ATLAS, ARCO O APÓFISIS ARTICULAR EXCLUSIVAMENTE"
  },
  {
    "codigo":1254662003,
    "descripcion":"ESTENOSIS DE RAMA DESCENDENTE POSTERIOR DE ARTERIA CORONARIA DERECHA"
  },
  {
    "codigo":271622006,
    "descripcion":"RESPIRACIÓN AGONIZANTE"
  },
  {
    "codigo":402694007,
    "descripcion":"DERMATOSIS DE CUERO CABELLUDO"
  },
  {
    "codigo":5808000,
    "descripcion":"CONJUNTIVITIS ANGULAR"
  },
  {
    "codigo":38576000,
    "descripcion":"DEFICIENCIA AISLADA DE SOMATOTROFINA HIPERINSULINÉMICA NO FAMILIAR"
  },
  {
    "codigo":202416002,
    "descripcion":"HEMARTROSIS DE ARTICULACIÓN SUBASTRAGALINA"
  },
  {
    "codigo":300720005,
    "descripcion":"INCAPAZ DE REALIZAR ACTIVIDADES RELACIONADAS CON LAS COMPRAS"
  },
  {
    "codigo":726704006,
    "descripcion":"SÍNDROME DE CATARATA, CARDIOPATÍA CONGÉNITA Y DEFECTO DEL TUBO NEURAL"
  },
  {
    "codigo":267952008,
    "descripcion":"DOLOR DE ARTICULACIÓN DE PELVIS Y\/O MUSLO"
  },
  {
    "codigo":102277001,
    "descripcion":"OSIFICACIÓN INTERRUMPIDA"
  },
  {
    "codigo":366256008,
    "descripcion":"HALLAZGO RELACIONADO CON LA ACTIVIDAD INTESTINAL"
  },
  {
    "codigo":397189000,
    "descripcion":"MARGEN QUIRÚRGICO LATERAL (MUCOSA\/PARED) INVOLUCRADO POR CARCINOMA IN SITU\/ADENOMA"
  },
  {
    "codigo":2138000,
    "descripcion":"POSICIÓN SACROILÍACA IZQUIERDA POSTERIOR"
  },
  {
    "codigo":460890003,
    "descripcion":"ORIGEN COMÚN ANÓMALO DE ARTERIA BRAQUIOCEFÁLICA Y ARTERIA CARÓTIDA PRIMITIVA IZQUIERDA"
  },
  {
    "codigo":229679000,
    "descripcion":"DISGRAFÍA SUPERFICIAL"
  },
  {
    "codigo":297050009,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE GUANETIDINA"
  },
  {
    "codigo":303002,
    "descripcion":"PANCREATITIS APOPLÉJICA"
  },
  {
    "codigo":721199003,
    "descripcion":"LIQUEN ESCLEROSO DE VULVA PREPUBERAL"
  },
  {
    "codigo":459055004,
    "descripcion":"VEGETACIÓN CARDÍACA"
  },
  {
    "codigo":162308004,
    "descripcion":"CEFALEA PULSÁTIL"
  },
  {
    "codigo":719364008,
    "descripcion":"UTILIZA DISPOSITIVO DE COMUNICACIÓN DE BAJA TECNOLOGÍA"
  },
  {
    "codigo":293380008,
    "descripcion":"REACCIÓN ADVERSA A INFUSIÓN DE MÚLTIPLES ELECTRÓLITOS"
  },
  {
    "codigo":94937000,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA BOCA"
  },
  {
    "codigo":783065004,
    "descripcion":"ATROFIA ÓPTICA AUTOSÓMICA RECESIVA TIPO 7"
  },
  {
    "codigo":60334003,
    "descripcion":"HIPOCALCEMIA POR CARGA DE FOSFATO"
  },
  {
    "codigo":103331000119103,
    "descripcion":"MIOCARDIOPATÍA TÓXICA"
  },
  {
    "codigo":224174007,
    "descripcion":"SIN INGRESO PERSONAL"
  },
  {
    "codigo":1172611000,
    "descripcion":"SECRETINA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":93102009,
    "descripcion":"FALTA DE OSIFICACIÓN DEL ILION"
  },
  {
    "codigo":1010606009,
    "descripcion":"SÍNDROME DE WAARDENBURG TIPO 1"
  },
  {
    "codigo":289710009,
    "descripcion":"CONTRACCIÓN UTERINA EXCESIVA"
  },
  {
    "codigo":91267002,
    "descripcion":"INTOXICACIÓN POR FLUFENAZINA"
  },
  {
    "codigo":255107005,
    "descripcion":"SEMINOMA DE TESTÍCULO"
  },
  {
    "codigo":124035003,
    "descripcion":"BETAGLOBULINA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1303683007,
    "descripcion":"QUISTE ÓSEO ANEURISMÁTICO DE FÉMUR"
  },
  {
    "codigo":11817891000119105,
    "descripcion":"ESGUINCE DE LIGAMENTO DE ARTICULACIÓN METACARPOFALÁNGICA DE DEDO DE MANO IZQUIERDA"
  },
  {
    "codigo":322621000119100,
    "descripcion":"SINOVITIS TRANSITORIA DE CADERA DERECHA"
  },
  {
    "codigo":251437000,
    "descripcion":"PRUEBA DE ESFUERZO ARTICULAR-HALLAZGO"
  },
  {
    "codigo":22061001,
    "descripcion":"HOMOCIGOTO"
  },
  {
    "codigo":87597001,
    "descripcion":"RUPTURA DE QUISTE LUTEÍNICO"
  },
  {
    "codigo":253272009,
    "descripcion":"ANOMALÍA CONGÉNITA DE COMUNICACIÓN CARDÍACA"
  },
  {
    "codigo":448045004,
    "descripcion":"SÍNDROME DE TEMBLOR Y ATAXIA ASOCIADO AL CROMOSOMA X FRÁGIL"
  },
  {
    "codigo":185901004,
    "descripcion":"VACUNADO CONTRA LA GRIPE EN LA CIRUGÍA"
  },
  {
    "codigo":284205006,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DE LABIO"
  },
  {
    "codigo":187736009,
    "descripcion":"NEOPLASIA MALIGNA DE PÍLORO DE ESTÓMAGO"
  },
  {
    "codigo":52994003,
    "descripcion":"RESORCIÓN INTERNA DE DIENTE"
  },
  {
    "codigo":249602003,
    "descripcion":"AMPOLLA RECTAL OCUPADA"
  },
  {
    "codigo":870359000,
    "descripcion":"INFECCIÓN NEONATAL DE CONDUCTO NASOLAGRIMAL CAUSADA POR BACTERIA"
  },
  {
    "codigo":1263575002,
    "descripcion":"CEFALEA NUMULAR"
  },
  {
    "codigo":83927003,
    "descripcion":"DEDO DE LA MANO CAÍDO"
  },
  {
    "codigo":18391007,
    "descripcion":"ABORTO ELECTIVO"
  },
  {
    "codigo":247767009,
    "descripcion":"ATENCIÓN INTEGRADA DURANTE CRISIS DE AUSENCIA"
  },
  {
    "codigo":80257001,
    "descripcion":"BRONQUITIS AGUDA CON BRONCOESPASMO"
  },
  {
    "codigo":409772009,
    "descripcion":"TUMOR QUE INVADE MÚSCULO"
  },
  {
    "codigo":735617003,
    "descripcion":"OSTEOPOROSIS IDIOPÁTICA PREMENOPÁUSICA"
  },
  {
    "codigo":897622003,
    "descripcion":"FORMA DE CONO ANORMAL CONGÉNITA DE EPÍFISIS DE FALANGE DE DEDO DE PIE"
  },
  {
    "codigo":242262005,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE ANTAGONISTA H2"
  },
  {
    "codigo":111190006,
    "descripcion":"DERMATITIS DE CONTACTO CAUSADA POR FENOL"
  },
  {
    "codigo":109355002,
    "descripcion":"CARCINOMA IN SITU"
  },
  {
    "codigo":240427005,
    "descripcion":"ENFERMEDAD MENINGOCÓCICA DEL OJO"
  },
  {
    "codigo":11051005,
    "descripcion":"INFECCIÓN CAUSADA POR CYSTICERCUS TARANDI"
  },
  {
    "codigo":402432002,
    "descripcion":"DERMATITIS NEUTROFÍLICA REUMATOIDE"
  },
  {
    "codigo":205824006,
    "descripcion":"SÍNDROME DE NOONAN"
  },
  {
    "codigo":369664007,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA DE PLEURA Y VASCULATURA PULMONAR, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":236757005,
    "descripcion":"ESTRANGULACIÓN DE PENE"
  },
  {
    "codigo":1187029007,
    "descripcion":"VITAMINA E DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":302293008,
    "descripcion":"HALLAZGO EN LA ESTRUCTURA DE LAS EXTREMIDADES"
  },
  {
    "codigo":40149008,
    "descripcion":"QUERATITIS GONOCÓCICA"
  },
  {
    "codigo":15670641000119103,
    "descripcion":"LUXACIÓN CONGÉNITA DE RÓTULA DERECHA"
  },
  {
    "codigo":300458008,
    "descripcion":"HALLAZGO RELACIONADO CON TONO DE VEJIGA URINARIA"
  },
  {
    "codigo":365994009,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA CONTROLAR LA CONDUCTA"
  },
  {
    "codigo":1052287002,
    "descripcion":"MIOCARDITIS GONOCÓCICA"
  },
  {
    "codigo":351601000119104,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE GLÁNDULA SUPRARRENAL DERECHA"
  },
  {
    "codigo":724607005,
    "descripcion":"DEFECTO DE PLACA VERTEBRAL"
  },
  {
    "codigo":1279828000,
    "descripcion":"CON MAYOR RIESGO DE TRASTORNO DEBIDO A USO DE ANTICONCEPTIVO"
  },
  {
    "codigo":296788006,
    "descripcion":"SOBREDOSIS DE FÁRMACO ANTIMICOBACTERIANO"
  },
  {
    "codigo":360489001,
    "descripcion":"HERNIA INTERNA CERCANA AL LIGAMENTO DE TREITZ"
  },
  {
    "codigo":131113002,
    "descripcion":"VITAMINA D POR ENCIMA DE RANGO DE REFERENCIA"
  },
  {
    "codigo":32809005,
    "descripcion":"ANOMALÍA CONGÉNITA DE LA ESCLERÓTICA"
  },
  {
    "codigo":1179689006,
    "descripcion":"PROSTATITIS CATEGORÍA II"
  },
  {
    "codigo":293118001,
    "descripcion":"REACCIÓN ADVERSA A VACUNA ANTIRRÁBICA"
  },
  {
    "codigo":162046002,
    "descripcion":"DOLOR ABDOMINAL CENTRAL"
  },
  {
    "codigo":719102004,
    "descripcion":"SÍNDROME DE CATARATA CONGÉNITA CON ATAXIA Y SORDERA"
  },
  {
    "codigo":424190005,
    "descripcion":"MELANOMA MALIGNO DE LOCALIZACIÓN PRIMARIA DESCONOCIDA"
  },
  {
    "codigo":94675003,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE BORDE BERMELLÓN DE LABIO SUPERIOR"
  },
  {
    "codigo":717267005,
    "descripcion":"SÍNDROME DE ATRAPAMIENTO DE VENA RENAL IZQUIERDA"
  },
  {
    "codigo":29139005,
    "descripcion":"ALUCINACIONES GUSTATIVAS"
  },
  {
    "codigo":289448000,
    "descripcion":"FETO NORMAL"
  },
  {
    "codigo":92840000,
    "descripcion":"FUSIÓN ANORMAL CONGÉNITA DE HUESO BASIOCCIPITAL"
  },
  {
    "codigo":125608002,
    "descripcion":"FRACTURA DE LA COLUMNA VERTEBRAL LUMBAR"
  },
  {
    "codigo":713597002,
    "descripcion":"ANTÍGENO LEUCOCÍTICO HUMANO B5701 DETECTADO"
  },
  {
    "codigo":123773003,
    "descripcion":"HEMOGLOBINOPATÍA HETEROCIGÓTICA"
  },
  {
    "codigo":134821000119101,
    "descripcion":"ENCEFALOPATÍA HIPÓXICA ISQUÉMICA MODERADA DEL RECIÉN NACIDO"
  },
  {
    "codigo":11849381000119101,
    "descripcion":"HERIDA DE MITAD DERECHA DE PARED TORÁCICA DEBIDA A PICADURA DE INSECTO NO VENENOSO"
  },
  {
    "codigo":1336189004,
    "descripcion":"LINFANGIOGRAFÍA FLUOROSCÓPICA CON CONTRASTE NORMAL"
  },
  {
    "codigo":254845004,
    "descripcion":"FIBROADENOMA DE MAMA"
  },
  {
    "codigo":1268818001,
    "descripcion":"TENDINITIS CALCIFICANTE DE REGIÓN DE CADERA"
  },
  {
    "codigo":253010003,
    "descripcion":"MICROPROLACTINOMA"
  },
  {
    "codigo":449618007,
    "descripcion":"TUMEFACCIÓN DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":251175005,
    "descripcion":"COMPLEJOS VENTRICULARES PREMATUROS"
  },
  {
    "codigo":447783007,
    "descripcion":"SARCOMA DE PERITONEO"
  },
  {
    "codigo":54567007,
    "descripcion":"FRACTURA EXPUESTA DE CUELLO QUIRÚRGICO DE HÚMERO"
  },
  {
    "codigo":773628009,
    "descripcion":"SÍNDROME DE DISPLASIA FRONTONASAL, MICROFTALMÍA SEVERA Y HENDIDURA FACIAL SEVERA"
  },
  {
    "codigo":183804009,
    "descripcion":"ESTADÍA DE INTERNACIÓN, 6 DÍAS"
  },
  {
    "codigo":739025007,
    "descripcion":"BLOQUE CARDIOPULMONAR TRASPLANTADO PRESENTE"
  },
  {
    "codigo":11986751000119102,
    "descripcion":"QUEMADURA EPIDÉRMICA DE MUSLO IZQUIERDO"
  },
  {
    "codigo":737190002,
    "descripcion":"ÚLCERA DE ESÓFAGO DEBIDA A TRASTORNO DEL SISTEMA INMUNITARIO"
  },
  {
    "codigo":704422003,
    "descripcion":"CON MAYOR RIESGO DE APNEA"
  },
  {
    "codigo":81830002,
    "descripcion":"MONONEUROPATÍA SIMPLE DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":276603001,
    "descripcion":"TRASTORNO PERINATAL DE CRECIMIENTO Y\/O DESARROLLO"
  },
  {
    "codigo":79995002,
    "descripcion":"NIÑO POSMADURO, SIN PESO ALTO PARA EDAD GESTACIONAL"
  },
  {
    "codigo":16294009,
    "descripcion":"ESPLENOMEGALIA"
  },
  {
    "codigo":440443001,
    "descripcion":"CONVULSIÓN ANÓXICA REFLEJA"
  },
  {
    "codigo":211067002,
    "descripcion":"ABRASIÓN INFECTADA DE VAGINA"
  },
  {
    "codigo":1259643004,
    "descripcion":"OSTEOSARCOMA PRIMARIO DE COSTILLA"
  },
  {
    "codigo":209232001,
    "descripcion":"SEPARACIÓN TRAUMÁTICA DE LA SÍNFISIS PÚBICA"
  },
  {
    "codigo":407675009,
    "descripcion":"CONVULSIÓN EPILÉPTICA PARCIAL COMPLEJA"
  },
  {
    "codigo":373072001,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM TERRAE"
  },
  {
    "codigo":733520002,
    "descripcion":"SÍNDROME DE MICRODELECIÓN 20Q13.33"
  },
  {
    "codigo":10676031000119106,
    "descripcion":"ASMA ALÉRGICA PERSISTENTE LEVE CONTROLADA"
  },
  {
    "codigo":242000006,
    "descripcion":"SÍNDROME DE PRESURIZACIÓN PULMONAR EXCESIVA"
  },
  {
    "codigo":371237000,
    "descripcion":"TRASTORNO SIFILÍTICO DE LA PIEL"
  },
  {
    "codigo":78160009,
    "descripcion":"PÓLIPOS FIBROIDES INFLAMATORIOS DEL ESTÓMAGO"
  },
  {
    "codigo":698917001,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: ROMANCHE"
  },
  {
    "codigo":43557002,
    "descripcion":"ESTRECHEZ CONGÉNITA DE CONDUCTO AUDITIVO EXTERNO"
  },
  {
    "codigo":10789001,
    "descripcion":"INFECCIÓN BACTERIANA CAUSADA POR MORGANELLA MORGANII"
  },
  {
    "codigo":404005003,
    "descripcion":"HISTIOCITOMA CUTÁNEO EN EMPALIZADA"
  },
  {
    "codigo":305701006,
    "descripcion":"ATENDIDO POR UN RADIÓLOGO"
  },
  {
    "codigo":829989007,
    "descripcion":"AMPOLLA SEROPURULENTA"
  },
  {
    "codigo":1091391000119108,
    "descripcion":"EXOSTOSIS DE CONDUCTO AUDITIVO EXTERNO DERECHO"
  },
  {
    "codigo":764453009,
    "descripcion":"SÍNDROME DE MIOCLONÍA DE ACCIÓN E INSUFICIENCIA RENAL"
  },
  {
    "codigo":240165007,
    "descripcion":"OSTEOMALACIA CAUSADA POR FÁRMACO"
  },
  {
    "codigo":205562004,
    "descripcion":"ANGIOMATOSIS"
  },
  {
    "codigo":8954007,
    "descripcion":"SECUESTRO ÓSEO DE MANDÍBULA"
  },
  {
    "codigo":762618008,
    "descripcion":"SÍNDROME DE BRONQUIOLITIS OBLITERANTE DEBIDA A TRASPLANTE DE PULMÓN Y DESPUÉS DE ÉL"
  },
  {
    "codigo":72655000,
    "descripcion":"HEMIPLEJÍA ALTERNADA DEL HIPOGLOSO"
  },
  {
    "codigo":402170008,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA PIEL POR VIOLENCIA"
  },
  {
    "codigo":236495001,
    "descripcion":"NEFROPATÍA POR URATOS"
  },
  {
    "codigo":7119001,
    "descripcion":"LUPUS ERITEMATOSO CUTÁNEO"
  },
  {
    "codigo":860922009,
    "descripcion":"DISFUNCIÓN ERÉCTIL DEBIDA A NEUROPATÍA"
  },
  {
    "codigo":105423006,
    "descripcion":"BUENA EDUCACIÓN"
  },
  {
    "codigo":170959003,
    "descripcion":"TERAPIA DE RESTITUCIÓN HORMONAL: ESTRÓGENOS SIN OPOSICIÓN"
  },
  {
    "codigo":300196000,
    "descripcion":"OÍDO NORMAL"
  },
  {
    "codigo":365732001,
    "descripcion":"NIVEL SÉRICO DE AMINOFILINA - HALLAZGO"
  },
  {
    "codigo":302031001,
    "descripcion":"CONSISTENCIA TESTICULAR NORMAL"
  },
  {
    "codigo":431268006,
    "descripcion":"HEMORRAGIA CUTÁNEA EN EL RECIÉN NACIDO"
  },
  {
    "codigo":396665000,
    "descripcion":"TIPO HISTOLÓGICO DE LESIÓN EPITELIAL ASOCIADA AL TUMOR QUE NO PUEDE DETERMINARSE"
  },
  {
    "codigo":429433004,
    "descripcion":"LESIÓN TRAUMÁTICA DE PARTES BLANDAS DE LA CARA"
  },
  {
    "codigo":167289004,
    "descripcion":"PRUEBA DE CUERPOS CETÓNICOS EN ORINA: =+"
  },
  {
    "codigo":3449007,
    "descripcion":"AGNOSIA DE DEDOS DE LA MANO"
  },
  {
    "codigo":36217008,
    "descripcion":"TRASTORNO DE PERSONALIDAD DE ETIOLOGÍA ORGÁNICA"
  },
  {
    "codigo":298361009,
    "descripcion":"DEFORMIDAD ÓSEA ROTACIONAL"
  },
  {
    "codigo":67150001,
    "descripcion":"PRUEBA DE OCLUSIÓN ALTERNADA"
  },
  {
    "codigo":165454002,
    "descripcion":"VOLUMEN CORPUSCULAR MEDIO ELEVADO POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":296526005,
    "descripcion":"OBESIDAD DE INICIO EN LA ADULTEZ"
  },
  {
    "codigo":722510006,
    "descripcion":"RABDOMIOSARCOMA PRIMARIO DE FARINGE"
  },
  {
    "codigo":425763000,
    "descripcion":"TEMBLOR FISIOLÓGICO"
  },
  {
    "codigo":1279566008,
    "descripcion":"COMPRESIÓN DE NERVIO PERONEO PROFUNDO"
  },
  {
    "codigo":294691003,
    "descripcion":"ALERGIA A ALCLOMETASONA"
  },
  {
    "codigo":720675005,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR IRBESARTÁN"
  },
  {
    "codigo":63480004,
    "descripcion":"BRONQUITIS CRÓNICA"
  },
  {
    "codigo":1144824006,
    "descripcion":"INTOXICACIÓN CAUSADA POR TIOPENTAL"
  },
  {
    "codigo":292856008,
    "descripcion":"REACCIÓN ADVERSA A PROGUANIL"
  },
  {
    "codigo":192717007,
    "descripcion":"ENCEFALITIS POSVACUNACIÓN ANTISARAMPIONOSA"
  },
  {
    "codigo":1208525008,
    "descripcion":"SUPERVISIÓN VIRTUAL DE RECOLECCIÓN DE ESPÉCIMEN POR SUJETO REALIZADA POR PROFESIONAL DE LA SALUD"
  },
  {
    "codigo":289186000,
    "descripcion":"HALLAZGO RELACIONADO CON LA FONACIÓN"
  },
  {
    "codigo":94413009,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL OÍDO MEDIO"
  },
  {
    "codigo":225485009,
    "descripcion":"HABLA POSITIVAMENTE DE SÍ MISMO"
  },
  {
    "codigo":127181008,
    "descripcion":"LINFADENOPATÍA PARACERVICAL UTERINA"
  },
  {
    "codigo":190882007,
    "descripcion":"ACIDEMIA LÁCTICA"
  },
  {
    "codigo":1335927007,
    "descripcion":"INMUNODEFICIENCIA COMBINADA SEVERA NEGATIVA PARA LINFOCITOS T, POSITIVA PARA LINFOCITOS B"
  },
  {
    "codigo":1237623009,
    "descripcion":"INSENSIBILIDAD CONGÉNITA AL DOLOR CON DISCAPACIDAD INTELECTUAL GRAVE"
  },
  {
    "codigo":285516005,
    "descripcion":"DIFICULTAD PARA RETRAER LA LENGUA"
  },
  {
    "codigo":56140006,
    "descripcion":"VACCINA PROGRESIVA"
  },
  {
    "codigo":87073000,
    "descripcion":"PERIOSTITIS DEL BRAZO"
  },
  {
    "codigo":283681000,
    "descripcion":"HERIDA POR PINCHAZO DE CLAVO EN EL TALÓN"
  },
  {
    "codigo":609526004,
    "descripcion":"PRURITO REFERIDO"
  },
  {
    "codigo":1230283000,
    "descripcion":"VESTIMENTA INADECUADA DEBIDA A RECURSOS ECONÓMICOS LIMITADOS"
  },
  {
    "codigo":1363190009,
    "descripcion":"CAPAZ DE MANTENER LA POSICIÓN SEDENTE EN ASIENTO DE INODORO"
  },
  {
    "codigo":738763003,
    "descripcion":"FUNCIÓN AUMENTADA DE TRANSPORTADOR DE ANIONES ORGÁNICOS MIEMBRO DE LA FAMILIA 1B1"
  },
  {
    "codigo":704160001,
    "descripcion":"FRACTURA NO EXPUESTA DE FALANGE PROXIMAL DE DEDO MEDIO DE LA MANO"
  },
  {
    "codigo":1259381000,
    "descripcion":"FIBROSARCOMA CUTÁNEO PRIMARIO"
  },
  {
    "codigo":46965001,
    "descripcion":"AGENESIA DEL PULMÓN IZQUIERDO"
  },
  {
    "codigo":16058791000119108,
    "descripcion":"RECHAZO DE TRASPLANTE CORNEAL DE AMBOS OJOS"
  },
  {
    "codigo":405578000,
    "descripcion":"PERFORACIÓN NO TRAUMÁTICA DE INTESTINO DELGADO"
  },
  {
    "codigo":472949009,
    "descripcion":"TRAVESTISMO PRIMARIO"
  },
  {
    "codigo":208970001,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA EXPUESTA DE LA ARTICULACIÓN DE LA RODILLA, ANTERIOR"
  },
  {
    "codigo":733258004,
    "descripcion":"MÚLTIPLES LUXACIONES TRAUMÁTICAS DE DEDO DE LA MANO"
  },
  {
    "codigo":403743001,
    "descripcion":"PIGMENTACIÓN CUTÁNEA INDUCIDA POR ARSÉNICO"
  },
  {
    "codigo":895263002,
    "descripcion":"FORMA ANCHA ANORMAL CONGÉNITA DE FALANGE DE DEDO ÍNDICE"
  },
  {
    "codigo":370975003,
    "descripcion":"REMEDIADO"
  },
  {
    "codigo":305439002,
    "descripcion":"BAJO ATENCIÓN DE CONSEJERO"
  },
  {
    "codigo":43295006,
    "descripcion":"FRACTURA NO EXPUESTA DE HÚMERO"
  },
  {
    "codigo":698655009,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: BIELORRUSO"
  },
  {
    "codigo":762356001,
    "descripcion":"NEUROPATÍA INFLAMATORIA DEBIDA A VACUNACIÓN Y POSTERIOR A ELLA"
  },
  {
    "codigo":238068007,
    "descripcion":"DEFICIENCIA BIFUNCIONAL PEROXISÓMICA ENZIMÁTICA"
  },
  {
    "codigo":301769001,
    "descripcion":"ABSCESO DE VAINA RECTAL"
  },
  {
    "codigo":203465002,
    "descripcion":"QUISTE ÓSEO"
  },
  {
    "codigo":170697001,
    "descripcion":"EFECTO COLATERAL DE FÁRMACO NEUROLÓGICO"
  },
  {
    "codigo":39625001,
    "descripcion":"INFECCIÓN CAUSADA POR LEISHMANIA BRAZILIENSIS"
  },
  {
    "codigo":10953281000119108,
    "descripcion":"HERIDA ABIERTA DE DEDO MEÑIQUE IZQUIERDO DEBIDA A MORDEDURA DE GATO"
  },
  {
    "codigo":70558001,
    "descripcion":"EPIESCLERITIS NODULAR"
  },
  {
    "codigo":365470003,
    "descripcion":"DETALLES FAMILIARES Y COMPOSICIÓN DEL HOGAR - HALLAZGO"
  },
  {
    "codigo":201630004,
    "descripcion":"CONDROCALCINOSIS DE ARTICULACIÓN DE MANO CAUSADA POR CRISTALES DE FOSFATO DICÁLCICO"
  },
  {
    "codigo":396403000,
    "descripcion":"COMPROMISO DEL ESPÉCIMEN POR TUMOR MACROSCÓPICO PRESENTE"
  },
  {
    "codigo":299934008,
    "descripcion":"SENSIBILIDAD VIBRATORIA ALTERADA"
  },
  {
    "codigo":298099005,
    "descripcion":"CUERPO EXTRAÑO EN LA PIEL DE LA ESPINILLA"
  },
  {
    "codigo":230728003,
    "descripcion":"DISECCIÓN DE ARTERIA CERVICOCEREBRAL"
  },
  {
    "codigo":197960003,
    "descripcion":"HIPERPLASIA PROSTÁTICA DEL LÓBULO MEDIO"
  },
  {
    "codigo":1344840006,
    "descripcion":"DISECCIÓN DE AORTA DESCENDENTE TIPO III"
  },
  {
    "codigo":296264008,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE DECANOATO DE ZUCLOPENTIXOL"
  },
  {
    "codigo":196125002,
    "descripcion":"FIBROSIS PULMONAR INTERSTICIAL DIFUSA"
  },
  {
    "codigo":292594003,
    "descripcion":"REACCIÓN ADVERSA A LA MEPIRAMINA"
  },
  {
    "codigo":194290005,
    "descripcion":"OTITIS MEDIA BILATERAL AGUDA"
  },
  {
    "codigo":94151004,
    "descripcion":"CONJUNTIVITIS MENINGOCÓCICA"
  },
  {
    "codigo":61383005,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE PABELLÓN AURICULAR CON INFECCIÓN"
  },
  {
    "codigo":716743006,
    "descripcion":"HIPERTIROIDISMO FAMILIAR DEBIDO A MUTACIÓN DEL RECEPTOR DE HORMONA TIROESTIMULANTE"
  },
  {
    "codigo":126919005,
    "descripcion":"NEOPLASIA DEL LIGAMENTO REDONDO DEL ÚTERO"
  },
  {
    "codigo":1306567007,
    "descripcion":"CARCINOMA DUCTAL INFILTRANTE DE CUADRANTE SUPERIOR EXTERNO DE MAMA IZQUIERDA"
  },
  {
    "codigo":92316001,
    "descripcion":"NEOPLASIA BENIGNA DEL TABIQUE RECTOVAGINAL"
  },
  {
    "codigo":59548005,
    "descripcion":"ANEMIA DISERITROPOYÉTICA CONGÉNITA, TIPO I"
  },
  {
    "codigo":288924006,
    "descripcion":"CAPAZ DE IMPULSAR BOLO ALIMENTARIO HACIA LA FARINGE"
  },
  {
    "codigo":1237361000,
    "descripcion":"COLAPSO DE PULMÓN POR PRESIÓN DEBIDO A ANESTESIA DURANTE EMBARAZO"
  },
  {
    "codigo":26780008,
    "descripcion":"COARTACIÓN DE ARTERIA PULMONAR"
  },
  {
    "codigo":57713008,
    "descripcion":"CORDITIS"
  },
  {
    "codigo":88646002,
    "descripcion":"AMPOLLA DE PENE CON INFECCIÓN"
  },
  {
    "codigo":447259000,
    "descripcion":"LESIÓN TRAUMÁTICA DE GENITALES EXTERNOS"
  },
  {
    "codigo":1268294009,
    "descripcion":"VASCULITIS SISTÉMICA"
  },
  {
    "codigo":414491002,
    "descripcion":"ENDOFTALMITIS INFECCIOSA"
  },
  {
    "codigo":285254009,
    "descripcion":"CAPAZ DE RESISTIRSE A LOS PENSAMIENTOS PELIGROSOS CON DIFICULTAD"
  },
  {
    "codigo":283419003,
    "descripcion":"CORTE EN DEDO DE LA MANO"
  },
  {
    "codigo":840475006,
    "descripcion":"HIPERTROFIA CONGÉNITA DE PLIEGUE LATERAL DE DEDO GORDO DE PIE"
  },
  {
    "codigo":54043007,
    "descripcion":"DERMATITIS CERCARIANA DE LAS AVES DE AGUA DULCE"
  },
  {
    "codigo":52208000,
    "descripcion":"INFECCIÓN CAUSADA POR SPARGANUM MANSONI"
  },
  {
    "codigo":445424004,
    "descripcion":"DEBILIDAD DE CUERDA VOCAL"
  },
  {
    "codigo":248816004,
    "descripcion":"SUPERFICIE DE LA MAMA CON HOYUELOS"
  },
  {
    "codigo":771269000,
    "descripcion":"SÍNDROME DE PTERIGIÓN MÚLTIPLE AUTOSÓMICO DOMINANTE"
  },
  {
    "codigo":1230021007,
    "descripcion":"FRONTORRINIA"
  },
  {
    "codigo":246981009,
    "descripcion":"ESCLERÓTICA AVASCULAR"
  },
  {
    "codigo":15770003,
    "descripcion":"SÍNDROME DE ICTERICIA COLESTÁSICA AGUDA"
  },
  {
    "codigo":865903003,
    "descripcion":"QUISTE PILONIDAL RECURRENTE CRÓNICO"
  },
  {
    "codigo":1259119003,
    "descripcion":"MIOPATÍA DE MULTIMINICORES PRENATAL CON ARTROGRIPOSIS MÚLTIPLE CONGÉNITA"
  },
  {
    "codigo":439919003,
    "descripcion":"ATENDIDO POR TERAPEUTA FAMILIAR"
  },
  {
    "codigo":276079004,
    "descripcion":"PROBLEMAS DE SOCIEDAD"
  },
  {
    "codigo":79471008,
    "descripcion":"PÉRDIDA DE LA AUDICIÓN SÚBITA"
  },
  {
    "codigo":896836001,
    "descripcion":"FORMA TRIANGULAR ANORMAL CONGÉNITA DE EPÍFISIS DE FALANGE DE DEDO MEDIO"
  },
  {
    "codigo":407151008,
    "descripcion":"NIVEL DE PLOMO POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":700228005,
    "descripcion":"DESEA DONAR SU CUERPO DESPUÉS DE SU MUERTE PARA INVESTIGACIÓN MÉDICA"
  },
  {
    "codigo":1290052006,
    "descripcion":"NEOPLASIA NEUROENDOCRINA"
  },
  {
    "codigo":16909481000119106,
    "descripcion":"DISFUNCIÓN DE GLÁNDULA DE MEIBOMIO DE PÁRPADO SUPERIOR DERECHO"
  },
  {
    "codigo":1255449003,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE DEDO MEÑIQUE"
  },
  {
    "codigo":1222681008,
    "descripcion":"SÍNDROME DE ANEMIA HEMOLÍTICA AUTOINMUNITARIA, TROMBOCITOPENIA AUTOINMUNITARIA E INMUNODEFICIENCIA PRIMARIA"
  },
  {
    "codigo":11830441000119109,
    "descripcion":"LACERACIÓN DE ARCO PALMAR PROFUNDO DE ARTERIA RADIAL IZQUIERDA"
  },
  {
    "codigo":335171000119103,
    "descripcion":"QUISTE EXUDATIVO DE PARS PLANA DE CUERPO CILIAR DE OJO DERECHO"
  },
  {
    "codigo":1351918006,
    "descripcion":"HEMANGIOBLASTOMA DE INTESTINO"
  },
  {
    "codigo":237806007,
    "descripcion":"AUSENCIA DEL RECEPTOR DE ANDRÓGENOS"
  },
  {
    "codigo":235971000,
    "descripcion":"FILTRACIÓN DE CONDUCTO PANCREÁTICO"
  },
  {
    "codigo":1153475001,
    "descripcion":"FOSFATASA ÁCIDA SÉRICA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":301507004,
    "descripcion":"DIFICULTAD PARA ENTRAR Y SALIR DE LA DUCHA"
  },
  {
    "codigo":6595006,
    "descripcion":"CALCINOSIS"
  },
  {
    "codigo":299672001,
    "descripcion":"PÉRDIDA DEL VELLO PÚBICO"
  },
  {
    "codigo":37528004,
    "descripcion":"ROTACIÓN ANÓMALA DEL CIEGO"
  },
  {
    "codigo":430744005,
    "descripcion":"TRASTORNO FICTICIO CON SIGNOS Y SÍNTOMAS DE PREDOMINIO FÍSICO"
  },
  {
    "codigo":397976005,
    "descripcion":"MIEMBRO DEL PERSONAL INADECUADAMENTE SUPERVISADO"
  },
  {
    "codigo":365208007,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA CONTROLAR LA IRA"
  },
  {
    "codigo":4760008,
    "descripcion":"DACRIOADENITIS CRÓNICA"
  },
  {
    "codigo":232301000,
    "descripcion":"FORMACIÓN INCOMPLETA DE CÓCLEA ÓSEA"
  },
  {
    "codigo":234136009,
    "descripcion":"MALFORMACIÓN CAPILAR-VENOSA-LINFÁTICA"
  },
  {
    "codigo":723821002,
    "descripcion":"PARAPLEJÍA ESPÁSTICA AUTOSÓMICA RECESIVA TIPO 44"
  },
  {
    "codigo":363373004,
    "descripcion":"NEOPLASIA MALIGNA DE BORDE BERMELLÓN DE LABIO INFERIOR"
  },
  {
    "codigo":11803971000119106,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA DISTAL DE DEDO ÍNDICE IZQUIERDO"
  },
  {
    "codigo":15955421000119102,
    "descripcion":"NEOPLASIA GERMINAL NO SEMINOMATOSA PRIMARIA DE AMBOS TESTÍCULOS NO DESCENDIDOS"
  },
  {
    "codigo":263234002,
    "descripcion":"FRACTURA EXPUESTA DE FÉMUR, EXTREMO DISTAL"
  },
  {
    "codigo":230466004,
    "descripcion":"HEMIPLEJÍA ALTERNANTE DE LA INFANCIA"
  },
  {
    "codigo":164930006,
    "descripcion":"INTERVALO ST ELECTROCARDIOGRÁFICO ANORMAL"
  },
  {
    "codigo":292332001,
    "descripcion":"REACCIÓN ADVERSA A ZOPICLONA"
  },
  {
    "codigo":95724003,
    "descripcion":"CATARATA INTUMESCENTE"
  },
  {
    "codigo":30188007,
    "descripcion":"DEFICIENCIA DE ALFA-1-ANTITRIPSINA"
  },
  {
    "codigo":93889000,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE SENO MAXILAR"
  },
  {
    "codigo":1177068009,
    "descripcion":"ESPONDILITIS POR BRUCELLA ABORTUS"
  },
  {
    "codigo":716481002,
    "descripcion":"DIFICULTAD PARA COMPRENDER INSTRUCCIONES DE TRES PALABRAS"
  },
  {
    "codigo":126657007,
    "descripcion":"NEOPLASIA DE LA PIERNA"
  },
  {
    "codigo":995964381000119109,
    "descripcion":"ATRAPAMIENTO DE MÚSCULO RECTO EXTERNO DE OJO IZQUIERDO"
  },
  {
    "codigo":288662006,
    "descripcion":"DIFICULTAD PARA ESPERAR SU TURNO EN LA CONVERSACIÓN"
  },
  {
    "codigo":92054009,
    "descripcion":"NEOPLASIA BENIGNA DEL ESÓFAGO CERVICAL"
  },
  {
    "codigo":254059005,
    "descripcion":"DISPLASIA DE KNIEST-STICKLER"
  },
  {
    "codigo":286827008,
    "descripcion":"TIENDE A EXAGERAR LA EXPRESIÓN EMOCIONAL DE MANERA INAPROPIADA"
  },
  {
    "codigo":57451009,
    "descripcion":"TRAQUEOBRONQUIOMEGALIA CONGÉNITA"
  },
  {
    "codigo":22848002,
    "descripcion":"LUXACIÓN EXPUESTA DE ARTICULACIÓN SACROILÍACA"
  },
  {
    "codigo":16010871000119106,
    "descripcion":"GANGRENA DE DEDO DE PIE DERECHO"
  },
  {
    "codigo":250389000,
    "descripcion":"TIPO ANTIGÉNICO KELL"
  },
  {
    "codigo":284992009,
    "descripcion":"INCAPAZ DE DESCALZARSE"
  },
  {
    "codigo":709141005,
    "descripcion":"DOLOR DE CUELLO DEBIDO A ENFERMEDAD NEOPLÁSICA MALIGNA"
  },
  {
    "codigo":283157006,
    "descripcion":"CUERPO EXTRAÑO METÁLICO EN EL CODO"
  },
  {
    "codigo":1004053007,
    "descripcion":"CONTRACTURA EN FLEXIÓN DE ARTICULACIÓN METATARSOFALÁNGICA DE CUARTO DEDO DE PIE"
  },
  {
    "codigo":51946000,
    "descripcion":"SUSTO"
  },
  {
    "codigo":21013006,
    "descripcion":"FIEBRE SENNETSU"
  },
  {
    "codigo":248554005,
    "descripcion":"VÍA AÉREA PARCIALMENTE OBSTRUIDA"
  },
  {
    "codigo":445162006,
    "descripcion":"DIVERTICULITIS DE MECKEL SANGRANTE"
  },
  {
    "codigo":281322007,
    "descripcion":"FORMA Y DETALLES DEL ESPÉCIMEN DIFERENTES"
  },
  {
    "codigo":838378008,
    "descripcion":"VESTIBULOPATÍA IDIOPÁTICA BILATERAL CRÓNICA"
  },
  {
    "codigo":117482008,
    "descripcion":"CRISTAL URINARIO, MONOHIDRATO DE OXALATO DE CALCIO"
  },
  {
    "codigo":215786008,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR GASES O HUMOS A BORDO DE EMBARCACIÓN, NADADOR LESIONADO"
  },
  {
    "codigo":441492003,
    "descripcion":"ANAFILAXIA CAUSADA POR SEMILLA"
  },
  {
    "codigo":703636009,
    "descripcion":"MICROEMBOLIA OLEOSA PULMONAR"
  },
  {
    "codigo":111977003,
    "descripcion":"SOPLO ORBITARIO"
  },
  {
    "codigo":372286000,
    "descripcion":"HALLAZGOS ANATOMOPATOLÓGICOS PRESENTES"
  },
  {
    "codigo":243049009,
    "descripcion":"LESIÓN POR ARMA FILOSA"
  },
  {
    "codigo":273982004,
    "descripcion":"TRASTORNO OBSTÉTRICO QUE AFECTA AL FETO"
  },
  {
    "codigo":44606004,
    "descripcion":"ADHERENCIA DE EPIPLÓN"
  },
  {
    "codigo":306750007,
    "descripcion":"DIFICULTAD PARA MOVER LA LENGUA DE FORMA SIMÉTRICA"
  },
  {
    "codigo":403219000,
    "descripcion":"PIGMENTACIÓN CUTÁNEA INDUCIDA POR RADIACIÓN ULTRAVIOLETA - BRONCEADO"
  },
  {
    "codigo":110142009,
    "descripcion":"LACERACIÓN COMPLEJA CONTAMINADA DE LA OROFARINGE"
  },
  {
    "codigo":1255187002,
    "descripcion":"ESTENOSIS DE RAMA OBTUSA MARGINAL DE RAMA CIRCUNFLEJA DE ARTERIA CORONARIA IZQUIERDA"
  },
  {
    "codigo":208446008,
    "descripcion":"FRACTURA NO EXPUESTA DE FALANGE PROXIMAL DE DEDO DE LA MANO, DIÁFISIS"
  },
  {
    "codigo":39451000087105,
    "descripcion":"DOLOR NEUROPÁTICO CRÓNICO POSTERIOR A LESIÓN TRAUMÁTICA DE MÉDULA ESPINAL"
  },
  {
    "codigo":42011000087108,
    "descripcion":"CELULITIS DE TODOS LOS DEDOS DE PIE DERECHO"
  },
  {
    "codigo":237544006,
    "descripcion":"DEFICIENCIA DE GLOBULINA FIJADORA DE TIROXINA"
  },
  {
    "codigo":202941002,
    "descripcion":"QUISTE DE BOLSA SEROSA"
  },
  {
    "codigo":1344947005,
    "descripcion":"DELIRIO CAUSADO POR OPIOIDE"
  },
  {
    "codigo":301245004,
    "descripcion":"DIFICULTAD PARA ELIMINAR EL ESPUTO"
  },
  {
    "codigo":170173006,
    "descripcion":"EXAMEN DEL NIÑO A LOS 10 AÑOS: ANORMAL - PARA OBSERVACIÓN"
  },
  {
    "codigo":235709008,
    "descripcion":"ILEÍTIS TERMINAL"
  },
  {
    "codigo":364946001,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA MOVER LA MANDÍBULA"
  },
  {
    "codigo":102802001,
    "descripcion":"SECRECIÓN DE RENINA DISMINUIDA"
  },
  {
    "codigo":725394006,
    "descripcion":"ATAXIA AUTOSÓMICA RECESIVA DEBIDA A DEFICIENCIA DE UBIQUINONA"
  },
  {
    "codigo":299410008,
    "descripcion":"PRUEBA DE EXTENSIÓN DINÁMICA POSITIVA"
  },
  {
    "codigo":2663001,
    "descripcion":"PROTEINURIA PALPATORIA"
  },
  {
    "codigo":232039004,
    "descripcion":"OCLUSIÓN DE VENA CENTRAL DE LA RETINA CON EDEMA MACULAR"
  },
  {
    "codigo":461415008,
    "descripcion":"DISPLASIA HEREDITARIA DE VASO SANGUÍNEO"
  },
  {
    "codigo":230204001,
    "descripcion":"ABSCESO PIOGÉNICO SUPRATENTORIAL EXTRADURAL"
  },
  {
    "codigo":295740003,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE CISPLATINO"
  },
  {
    "codigo":262972007,
    "descripcion":"DISTENSIÓN TENDINOSA"
  },
  {
    "codigo":721724009,
    "descripcion":"PANCREATITIS CRÓNICA REAGUDIZADA"
  },
  {
    "codigo":1110141000000109,
    "descripcion":"HIPERTENSIÓN OCULAR DEBIDA A TRAUMATISMO OCULAR"
  },
  {
    "codigo":95462004,
    "descripcion":"ANOMALÍA DEL CROMOSOMA SEXUAL"
  },
  {
    "codigo":423142006,
    "descripcion":"APRAXIA DE PÁRPADO"
  },
  {
    "codigo":128230008,
    "descripcion":"TRASTORNO DE HUESO HIOIDES"
  },
  {
    "codigo":292070009,
    "descripcion":"REACCIÓN ADVERSA A LA AZAPROPAZONA"
  },
  {
    "codigo":93627003,
    "descripcion":"FALTA DE OSIFICACIÓN DEL CARPO"
  },
  {
    "codigo":1142203007,
    "descripcion":"PARÁLISIS DE NERVIO LARÍNGEO DEBIDA A TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":290235009,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR DICLOFENACO"
  },
  {
    "codigo":340191000119106,
    "descripcion":"QUERATOCONJUNTIVITIS DE OJO IZQUIERDO"
  },
  {
    "codigo":288400006,
    "descripcion":"CAPAZ DE ABRIR Y CERRAR RECIPIENTES"
  },
  {
    "codigo":386704007,
    "descripcion":"MENSTRUACIÓN ESCASA E INFRECUENTE"
  },
  {
    "codigo":714384009,
    "descripcion":"CAPAZ DE ADMINISTRARSE MEDICACIÓN PARENTERAL"
  },
  {
    "codigo":712549005,
    "descripcion":"ARTRITIS BACTERIANA DE ARTICULACIÓN CIGOAPOFISARIA DE COLUMNA VERTEBRAL CERVICAL"
  },
  {
    "codigo":188261005,
    "descripcion":"NEOPLASIA MALIGNA DEL GLOBO OCULAR, EXCLUIDAS CONJUNTIVA, CÓRNEA, RETINA Y MEMBRANA COROIDE"
  },
  {
    "codigo":253797009,
    "descripcion":"ÍLEON DOBLE"
  },
  {
    "codigo":86287004,
    "descripcion":"RINITIS HIPERTRÓFICA"
  },
  {
    "codigo":282895006,
    "descripcion":"CAPAZ DE ALTERNAR ENTRE SENTARSE Y PARARSE"
  },
  {
    "codigo":250127009,
    "descripcion":"ARTRITIS ASIMÉTRICA"
  },
  {
    "codigo":84452004,
    "descripcion":"ANOMALÍA HORMONAL"
  },
  {
    "codigo":248292005,
    "descripcion":"PATRÓN ESQUELÉTICO FACIAL CLASE I"
  },
  {
    "codigo":11782521000119106,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN DE RÓTULA DERECHA"
  },
  {
    "codigo":1264100007,
    "descripcion":"AMPOLLA TRAUMÁTICA DE DEDO MEDIO DE MANO"
  },
  {
    "codigo":279225001,
    "descripcion":"TRISTEZA MATERNA"
  },
  {
    "codigo":15246001,
    "descripcion":"INFECCIÓN CAUSADA POR CORYNEBACTERIUM PYOGENES"
  },
  {
    "codigo":313721000119109,
    "descripcion":"MONOARTRITIS DE MUÑECA DERECHA"
  },
  {
    "codigo":441230007,
    "descripcion":"CAPAZ DE COMPRENDER Y UTILIZAR NÚMEROS"
  },
  {
    "codigo":1293198008,
    "descripcion":"INSUFICIENCIA RENAL AGUDA POSRENAL"
  },
  {
    "codigo":1306547003,
    "descripcion":"NEOPLASIA MALIGNA CON METÁSTASIS A CUADRANTE SUPERIOR EXTERNO DE MAMA"
  },
  {
    "codigo":699704002,
    "descripcion":"MEDULOBLASTOMA CLÁSICO"
  },
  {
    "codigo":123411000119106,
    "descripcion":"HEMORRAGIA GÁSTRICA DEBIDA A GASTRITIS EOSINOFÍLICA"
  },
  {
    "codigo":109880006,
    "descripcion":"NEOPLASIA SUPERPUESTA MALIGNA DEL CUELLO UTERINO"
  },
  {
    "codigo":208184007,
    "descripcion":"FRACTURA NO EXPUESTA DE PELVIS, ALA ILÍACA"
  },
  {
    "codigo":763405000,
    "descripcion":"SÍNDROME DE CROMOSOMA 15 EN ANILLO"
  },
  {
    "codigo":402957000,
    "descripcion":"BARTOLINITIS GONOCÓCICA"
  },
  {
    "codigo":1254925002,
    "descripcion":"DERMATITIS DE CONTACTO IRRITATIVA DE PIEL DE PIE"
  },
  {
    "codigo":239117002,
    "descripcion":"NEVO ACROSIRÍNGEO"
  },
  {
    "codigo":372024009,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL CUELLO UTERINO"
  },
  {
    "codigo":1187554000,
    "descripcion":"TRASTORNO GLOMERULAR POR POLINEUROPATÍA AMILOIDE FAMILIAR"
  },
  {
    "codigo":73442001,
    "descripcion":"SÍNDROME DE STEVENS-JOHNSON"
  },
  {
    "codigo":237282002,
    "descripcion":"AMENAZA DE ECLAMPSIA"
  },
  {
    "codigo":300983000,
    "descripcion":"ÚLCERA CUTÁNEA DE LA NARIZ"
  },
  {
    "codigo":1079981000119104,
    "descripcion":"NEVO EPIDÉRMICO DE PIEL DE EXTREMIDAD INFERIOR DERECHA"
  },
  {
    "codigo":202679005,
    "descripcion":"ESPONDILOSIS LUMBOSACRA EN DOS NIVELES CON MIELOPATÍA"
  },
  {
    "codigo":169911008,
    "descripcion":"PUNTAJE DE APGAR A LOS 5 MINUTOS = 1"
  },
  {
    "codigo":725132001,
    "descripcion":"ACCIDENTE CEREBROVASCULAR ISQUÉMICO SIN DÉFICIT RESIDUAL"
  },
  {
    "codigo":200844002,
    "descripcion":"DERMATITIS ALÉRGICA DE CONTACTO CAUSADA POR FÁRMACO EN CONTACTO CON LA PIEL"
  },
  {
    "codigo":11811501000119105,
    "descripcion":"CONTUSIÓN DE CABEZA DE PÁNCREAS"
  },
  {
    "codigo":168076001,
    "descripcion":"CÁLCULO: ÁCIDO ÚRICO"
  },
  {
    "codigo":397452007,
    "descripcion":"LINFOMA QUE COMPROMETE MÉDULA ÓSEA"
  },
  {
    "codigo":102540008,
    "descripcion":"POSICIÓN DE CABEZA"
  },
  {
    "codigo":299148007,
    "descripcion":"AMPLITUD DE FLEXIÓN PASIVA DEL PULGAR DISMINUIDA"
  },
  {
    "codigo":428385007,
    "descripcion":"ARTRITIS INFECCIOSA DE ARTICULACIÓN DE LA MANO"
  },
  {
    "codigo":295478000,
    "descripcion":"SOBREDOSIS DE FENOLFTALEÍNA"
  },
  {
    "codigo":262710003,
    "descripcion":"SECCIÓN DE MÉDULA ESPINAL"
  },
  {
    "codigo":33334006,
    "descripcion":"CUERPO EXTRAÑO EN TRACTO DIGESTIVO"
  },
  {
    "codigo":66102006,
    "descripcion":"FUSIÓN CONGÉNITA DE LAS COSTILLAS"
  },
  {
    "codigo":721462008,
    "descripcion":"SÍNDROME DEL CORDÓN ANTERIOR DE MÉDULA ESPINAL AL NIVEL DEL SÉPTIMO SEGMENTO DORSAL"
  },
  {
    "codigo":195339004,
    "descripcion":"EMBOLIA Y TROMBOSIS DE LA ARTERIA SUBCLAVIA"
  },
  {
    "codigo":31499008,
    "descripcion":"ESTREÑIMIENTO CRÓNICO CON REBOSAMIENTO"
  },
  {
    "codigo":193504001,
    "descripcion":"DEGENERACIÓN DEL IRIS Y CUERPO CILIAR"
  },
  {
    "codigo":160736003,
    "descripcion":"VIVE EN UN HOGAR DE BENEFICENCIA"
  },
  {
    "codigo":95200007,
    "descripcion":"PALIDEZ PULMONAR"
  },
  {
    "codigo":717792007,
    "descripcion":"PSEUDOHIPOPARATIROIDISMO TIPO 1C"
  },
  {
    "codigo":93365004,
    "descripcion":"POSICIÓN ANÓMALA CONGÉNITA DE CONDUCTO DEFERENTE"
  },
  {
    "codigo":27829006,
    "descripcion":"ESTOMATITIS POR BRIZNAS DE PLANTAS"
  },
  {
    "codigo":1141941008,
    "descripcion":"CONDUCTA EFECTIVA DE AFRONTAMIENTO FAMILIAR"
  },
  {
    "codigo":419210001,
    "descripcion":"ALERGIA A POLEN DE HIERBA"
  },
  {
    "codigo":58762006,
    "descripcion":"ENCEFALOMALACIA"
  },
  {
    "codigo":124298009,
    "descripcion":"DEFICIENCIA DE GLUCOCINASA"
  },
  {
    "codigo":253535002,
    "descripcion":"ANOMALÍA DEL VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":286303004,
    "descripcion":"INCAPAZ DE UTILIZAR SONIDOS AISLADOS"
  },
  {
    "codigo":1269343007,
    "descripcion":"LESIÓN DE MÉDULA ESPINAL DORSAL DEBIDA A LUXACIÓN EXPUESTA DE ARTICULACIÓN DE COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":87860000,
    "descripcion":"MASA TESTICULAR"
  },
  {
    "codigo":24159007,
    "descripcion":"LINFOCITOSIS PERSISTENTE"
  },
  {
    "codigo":448308000,
    "descripcion":"OBSTRUCCIÓN AL TRACTO DE SALIDA DE VENTRÍCULO DERECHO DEBIDA A VÁLVULA AURICULOVENTRICULAR COMÚN"
  },
  {
    "codigo":125921000119106,
    "descripcion":"COMA HEPÁTICO DEBIDO A HEPATITIS C AGUDA"
  },
  {
    "codigo":345211000119100,
    "descripcion":"MEMBRANA EPIRRETINIANA DE AMBOS OJOS"
  },
  {
    "codigo":251700007,
    "descripcion":"SECRECIÓN LAGRIMAL - NO PERMEABLE"
  },
  {
    "codigo":315401001,
    "descripcion":"NACIDO EN CHAD"
  },
  {
    "codigo":774153002,
    "descripcion":"PARÁLISIS PERIÓDICA CON SÍNDROME PSEUDOCOMPARTIMENTAL TRANSITORIO"
  },
  {
    "codigo":282633003,
    "descripcion":"INCAPAZ DE ECHAR A RODAR"
  },
  {
    "codigo":53257007,
    "descripcion":"FRÉMITO TUSÍGENO"
  },
  {
    "codigo":1167369007,
    "descripcion":"GINGIVITIS EXACERBADA POR HIPOSALIVACIÓN"
  },
  {
    "codigo":84190002,
    "descripcion":"RESPUESTA TERAPÉUTICA, MÍNIMA"
  },
  {
    "codigo":248030008,
    "descripcion":"ROBO DE COMIDA EN LA CASA"
  },
  {
    "codigo":1362142009,
    "descripcion":"MUCOSITIS MAXILAR PERIAPICAL"
  },
  {
    "codigo":82355002,
    "descripcion":"ESTENOSIS AÓRTICA SIFILÍTICA"
  },
  {
    "codigo":142261000119100,
    "descripcion":"DÉFICIT COGNITIVO DE ATENCIÓN"
  },
  {
    "codigo":15934901000119101,
    "descripcion":"DEFORMIDAD EN FLEXIÓN DE AMBAS RODILLAS"
  },
  {
    "codigo":15973301000119100,
    "descripcion":"DEFORMIDAD CONGÉNITA DE AMBOS MIEMBROS INFERIORES"
  },
  {
    "codigo":15937461000119102,
    "descripcion":"QUISTE SEBÁCEO DE PIEL DE LAS MAMAS BILATERAL"
  },
  {
    "codigo":17531000119105,
    "descripcion":"INFARTO AGUDO DE MIOCARDIO DEBIDO A OCLUSIÓN DE ARTERIA CORONARIA IZQUIERDA"
  },
  {
    "codigo":12207541000119105,
    "descripcion":"INFECCIÓN DE HUESO DE PIE DERECHO ASOCIADA CON DISPOSITIVO DE FIJACIÓN INTERNA"
  },
  {
    "codigo":16467381000119106,
    "descripcion":"MELORREOSTOSIS DE CRÁNEO"
  },
  {
    "codigo":15755701000119105,
    "descripcion":"TRASTORNO EN LA FLUIDEZ DEL HABLA DEBIDO A ENFERMEDAD DE PARKINSON"
  },
  {
    "codigo":677301000119106,
    "descripcion":"HIPOTONÍA DE OJO IZQUIERDO DEBIDA A FÍSTULA OCULAR"
  },
  {
    "codigo":15929781000119106,
    "descripcion":"DISFUNCIÓN DE LA MANO IZQUIERDA"
  },
  {
    "codigo":101301000119106,
    "descripcion":"INSUFICIENCIA RESPIRATORIA AGUDA HIPERCÁPNICA DEBIDA A APNEA OBSTRUCTIVA DEL SUEÑO"
  },
  {
    "codigo":1089461000119106,
    "descripcion":"INFLAMACIÓN DE PORCIÓN PETROSA DE HUESO TEMPORAL IZQUIERDO"
  },
  {
    "codigo":211592008,
    "descripcion":"LESIÓN TRAUMÁTICA CERRADA POR APLASTAMIENTO, CADERA"
  },
  {
    "codigo":10850741000119108,
    "descripcion":"LESIÓN ACCIDENTAL POR PINCHAZO DE AGUJA"
  },
  {
    "codigo":766813000,
    "descripcion":"DISPLASIA TRICO-ODONTO-ONIQUIAL"
  },
  {
    "codigo":734045002,
    "descripcion":"TRASTORNO DE COMPARTIMIENTO RETROPERITONEAL"
  },
  {
    "codigo":306101000119107,
    "descripcion":"TRASTORNO DE LIGAMENTO DE ARTICULACIÓN DE HOMBRO DERECHO"
  },
  {
    "codigo":373597005,
    "descripcion":"HEMATOMA DE PARED DE VEJIGA URINARIA"
  },
  {
    "codigo":11828661000119109,
    "descripcion":"AMPOLLA DE CADERA IZQUIERDA, CON INFECCIÓN"
  },
  {
    "codigo":209757007,
    "descripcion":"RUPTURA DEL TENDÓN TRICIPITAL"
  },
  {
    "codigo":111453004,
    "descripcion":"PLACENTA RETENIDA, SIN HEMORRAGIA"
  },
  {
    "codigo":80520008,
    "descripcion":"VÍCTIMA DE APLASTAMIENTO"
  },
  {
    "codigo":207922005,
    "descripcion":"FRACTURA EXPUESTA DEL ATLAS, CONMINUTA"
  },
  {
    "codigo":11314008,
    "descripcion":"PÓLIPO DE CUERPO UTERINO"
  },
  {
    "codigo":271623001,
    "descripcion":"MOVIMIENTO TORÁCICO ASIMÉTRICO"
  },
  {
    "codigo":238855000,
    "descripcion":"CAMPODACTILIA HEREDITARIA"
  },
  {
    "codigo":402695008,
    "descripcion":"DERMATOSIS PRURIGINOSA DE CUERO CABELLUDO"
  },
  {
    "codigo":1187292000,
    "descripcion":"LORDOSIS CONGÉNITA DE COLUMNA DEBIDA A MALFORMACIÓN CONGÉNITA HUESO ESQUELÉTICO"
  },
  {
    "codigo":204252002,
    "descripcion":"ESTENOSIS CONGÉNITA DE TROMPA DE EUSTAQUIO"
  },
  {
    "codigo":1254663008,
    "descripcion":"ESTENOSIS DE PORCIÓN DISTAL DE RAMA DESCENDENTE ANTERIOR DE ARTERIA CORONARIA IZQUIERDA"
  },
  {
    "codigo":73180008,
    "descripcion":"ESGUINCE DE LIGAMENTO DE ARTICULACIÓN CRICOARITENOIDEA"
  },
  {
    "codigo":366257004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD DE DEFECAR"
  },
  {
    "codigo":202417006,
    "descripcion":"HEMARTROSIS DE ARTICULACIÓN ASTRAGALONAVICULAR"
  },
  {
    "codigo":726705007,
    "descripcion":"SÍNDROME DE MICRODELECIÓN 3Q13"
  },
  {
    "codigo":36742000,
    "descripcion":"SALPINGITIS ÍSTMICA NUDOSA"
  },
  {
    "codigo":38577009,
    "descripcion":"EFECTOS POR DESCARGA DE RAYOS"
  },
  {
    "codigo":200582002,
    "descripcion":"ÁNTRAX DE LA CARA (EXCLUIDOS LOS OJOS)"
  },
  {
    "codigo":300721009,
    "descripcion":"REALIZA ACTIVIDADES RELACIONADAS CON LAS COMPRAS"
  },
  {
    "codigo":102278006,
    "descripcion":"SECUESTRO DE ERITROCITOS"
  },
  {
    "codigo":298886008,
    "descripcion":"AMPLITUD DE FLEXIÓN PASIVA DE CODO NORMAL"
  },
  {
    "codigo":724870009,
    "descripcion":"SENSIBILIZACIÓN ALÉRGICA POR CONTACTO DE PIEL Y MEMBRANA MUCOSA ASOCIADA CON PIEL"
  },
  {
    "codigo":231515001,
    "descripcion":"DOLOR HIPOCONDRÍACO"
  },
  {
    "codigo":34907007,
    "descripcion":"OSTEOCONDROSIS JUVENIL DE LA CRESTA ILÍACA"
  },
  {
    "codigo":721200000,
    "descripcion":"ATROFIA ÓPTICA DE COMIENZO TEMPRANO LIGADA AL CROMOSOMA X"
  },
  {
    "codigo":428123009,
    "descripcion":"ABLANDAMIENTO DE LA ESCLERÓTICA"
  },
  {
    "codigo":229680002,
    "descripcion":"DISLEXIA PROFUNDA"
  },
  {
    "codigo":459056003,
    "descripcion":"ENDOCARDITIS INFECCIOSA AGUDA"
  },
  {
    "codigo":297051008,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE GUANETIDINA"
  },
  {
    "codigo":33072005,
    "descripcion":"HEMOTÓRAX TRAUMÁTICO CON HERIDA ABIERTA HACIA TÓRAX"
  },
  {
    "codigo":162309007,
    "descripcion":"CEFALEA FULGURANTE"
  },
  {
    "codigo":293381007,
    "descripcion":"REACCIÓN ADVERSA A LA ALIMENTACIÓN ENTERAL Y SUPLEMENTARIA"
  },
  {
    "codigo":719365009,
    "descripcion":"CAPAZ DE COMPRENDER EL LENGUAJE ESCRITO"
  },
  {
    "codigo":291546004,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR PENICILINA G"
  },
  {
    "codigo":94938005,
    "descripcion":"NEOPLASIAS DE COMPORTAMIENTO INCIERTO DE GLÁNDULAS ENDOCRINAS MÚLTIPLES"
  },
  {
    "codigo":15666761000119103,
    "descripcion":"HUESO ACCESORIO DEL CARPO DE AMBAS MUÑECAS"
  },
  {
    "codigo":1010607000,
    "descripcion":"CARCINOMA LINFOEPITELIAL PRIMARIO DE NASOFARINGE"
  },
  {
    "codigo":60335002,
    "descripcion":"QUERATOSIS GONOCÓCICA"
  },
  {
    "codigo":93103004,
    "descripcion":"FALTA DE OSIFICACIÓN DE HUESO INTERPARIETAL"
  },
  {
    "codigo":125871005,
    "descripcion":"FRACTURA DE CÓCCIX"
  },
  {
    "codigo":224175008,
    "descripcion":"INGRESO PERSONAL BAJO"
  },
  {
    "codigo":1303684001,
    "descripcion":"QUISTE ÓSEO ANEURISMÁTICO DE HÚMERO"
  },
  {
    "codigo":289711008,
    "descripcion":"CONTRACCIONES UTERINAS, REDUCIDAS"
  },
  {
    "codigo":255108000,
    "descripcion":"CARCINOMA DE VEJIGA URINARIA"
  },
  {
    "codigo":124036002,
    "descripcion":"BETAGLOBULINA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":91268007,
    "descripcion":"MELANOSIS CONJUNTIVAL"
  },
  {
    "codigo":1172612007,
    "descripcion":"SEROTONINA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":253273004,
    "descripcion":"DEFECTO CARDÍACO SEPTAL"
  },
  {
    "codigo":251438005,
    "descripcion":"PRUEBA DE ESFUERZO ARTICULAR: POSITIVA"
  },
  {
    "codigo":185902006,
    "descripcion":"RECIBE VACUNACIÓN ANTIGRIPAL EN EL HOSPITAL"
  },
  {
    "codigo":284206007,
    "descripcion":"QUEMADURA SUPERFICIAL DEL MENTÓN POR AGENTE CORROSIVO"
  },
  {
    "codigo":54830008,
    "descripcion":"MIOCARDIOPATÍA DILATADA DEBIDA A MIOCARDITIS BACTERIANA"
  },
  {
    "codigo":321251000119104,
    "descripcion":"ESPONDILOLISTESIS ADQUIRIDA DE COLUMNA VERTEBRAL LUMBOSACRA"
  },
  {
    "codigo":85763007,
    "descripcion":"AMPOLLA DE MUSLO, SIN INFECCIÓN"
  },
  {
    "codigo":249603008,
    "descripcion":"ÚLCERA DE LA MUCOSA RECTAL"
  },
  {
    "codigo":1263576001,
    "descripcion":"PRODUCCIÓN DE LÍQUIDO CEFALORRAQUÍDEO AUMENTADA DEBIDO A HIPERPLASIA DE PLEXO COROIDEO"
  },
  {
    "codigo":18392000,
    "descripcion":"SIGNO PSICOLÓGICO"
  },
  {
    "codigo":247768004,
    "descripcion":"PRESTA ATENCIÓN A LAS ACTIVIDADES ELEGIDAS POR LOS ADULTOS"
  },
  {
    "codigo":313304007,
    "descripcion":"HEMATOMA SUBDURAL ESPINAL ATRAUMÁTICO"
  },
  {
    "codigo":213165002,
    "descripcion":"FALLA PARCIAL DE REIMPLANTE DE EXTREMIDAD"
  },
  {
    "codigo":1163437003,
    "descripcion":"TAQUICARDIA VENTRICULAR IDIOPÁTICA"
  },
  {
    "codigo":409773004,
    "descripcion":"TUMOR QUE INVADE HUESO"
  },
  {
    "codigo":49325007,
    "descripcion":"DEFORMIDAD POR CICATRIZ"
  },
  {
    "codigo":211330003,
    "descripcion":"ABRASIÓN, CADERA"
  },
  {
    "codigo":80258006,
    "descripcion":"LUPUS ERITEMATOSO MEDICAMENTOSO"
  },
  {
    "codigo":735618008,
    "descripcion":"OSTEOPOROSIS DEBIDA A MALABSORCIÓN"
  },
  {
    "codigo":276866009,
    "descripcion":"NEOPLASIA BENIGNA DE UNIÓN URETEROPÉLVICA"
  },
  {
    "codigo":45655002,
    "descripcion":"RONQUERA VAGAL"
  },
  {
    "codigo":897623008,
    "descripcion":"FORMA TRIANGULAR ANORMAL CONGÉNITA DE EPÍFISIS DE FALANGE DE SEGUNDO DEDO DE PIE"
  },
  {
    "codigo":240428000,
    "descripcion":"ARTRITIS POSMENINGOCÓCICA"
  },
  {
    "codigo":406103009,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS IN SITU DE CUELLO UTERINO"
  },
  {
    "codigo":43820004,
    "descripcion":"PROTEINURIA POSTRENAL"
  },
  {
    "codigo":238593003,
    "descripcion":"ECCEMA PAPULAR CON ELIMINACIÓN DE EDEMA PAPILAR"
  },
  {
    "codigo":402433007,
    "descripcion":"ARTRITIS REUMATOIDE CON INFARTOS PERIUNGUEALES Y DE PULPEJOS"
  },
  {
    "codigo":236758000,
    "descripcion":"ERECCIÓN PROLONGADA DEL PENE"
  },
  {
    "codigo":369665008,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA DE PLEURA Y PARED TORÁCICA, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":1187030002,
    "descripcion":"VITAMINA K DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":105686005,
    "descripcion":"ENFERMEDAD CAUSADA POR ANOPLOCEPHALIDAE"
  },
  {
    "codigo":203990007,
    "descripcion":"MIELOCELE CERVICAL"
  },
  {
    "codigo":300459000,
    "descripcion":"VEJIGA URINARIA DOLOROSA A LA PALPACIÓN"
  },
  {
    "codigo":890283004,
    "descripcion":"DERMATITIS ALÉRGICA POR CONTACTO CON ACEITE"
  },
  {
    "codigo":365995005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA PREVENIR EL COMPORTAMIENTO INDESEADO"
  },
  {
    "codigo":724608000,
    "descripcion":"RUPTURA DE BOLSA SEROSA"
  },
  {
    "codigo":202155009,
    "descripcion":"ARTROFITO EN MÚLTIPLES ARTICULACIONES"
  },
  {
    "codigo":429696002,
    "descripcion":"INESTABILIDAD DE ARTICULACIÓN FEMORORROTULIANA"
  },
  {
    "codigo":36480000,
    "descripcion":"ALTERACIÓN DE LA PERCEPCIÓN ASOCIADA CON LOS FENÓMENOS DE CONVERSIÓN Y DISOCIACIÓN"
  },
  {
    "codigo":104471000119105,
    "descripcion":"ARTROPATÍA DE CHARCOT DEBIDA A SÍFILIS"
  },
  {
    "codigo":69248007,
    "descripcion":"ANOMALÍA CONGÉNITA DE LA FIJACIÓN DEL INTESTINO"
  },
  {
    "codigo":15724721000119101,
    "descripcion":"ENTESOPATÍA DE CADERA IZQUIERDA"
  },
  {
    "codigo":296789003,
    "descripcion":"SOBREDOSIS DE FÁRMACO ANTITUBERCULOSO"
  },
  {
    "codigo":1279829008,
    "descripcion":"TRASTORNO DEBIDO A USO DE ANTICONCEPTIVO"
  },
  {
    "codigo":1148757008,
    "descripcion":"MICROCEFALIA"
  },
  {
    "codigo":426026005,
    "descripcion":"DIFICULTAD PARA EL MANEJO DE LA MEDICACIÓN DEBIDO A NECESIDADES ESPECIALES"
  },
  {
    "codigo":131114008,
    "descripcion":"VITAMINA D POR DEBAJO DE RANGO DE REFERENCIA"
  },
  {
    "codigo":1145087006,
    "descripcion":"ESCASO CRECIMIENTO DE PESTAÑAS"
  },
  {
    "codigo":162047006,
    "descripcion":"DOLOR SUBCOSTAL IZQUIERDO"
  },
  {
    "codigo":293119009,
    "descripcion":"REACCIÓN ADVERSA A VACUNA ANTIRRUBEÓLICA"
  },
  {
    "codigo":94676002,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL VESTÍBULO DE LA BOCA"
  },
  {
    "codigo":719103009,
    "descripcion":"PARAPLEJÍA ESPÁSTICA AUTOSÓMICA RECESIVA TIPO 39"
  },
  {
    "codigo":291284006,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR NICOTINA"
  },
  {
    "codigo":92841001,
    "descripcion":"FUSIÓN ANORMAL CONGÉNITA DE HUESO BASIESFENOIDAL"
  },
  {
    "codigo":25470000,
    "descripcion":"DACRIOCISTITIS AGUDA"
  },
  {
    "codigo":418686001,
    "descripcion":"QUERATOSIS ACTÍNICA DE PÁRPADO"
  },
  {
    "codigo":254846003,
    "descripcion":"FIBROADENOMA GIGANTE DE MAMA"
  },
  {
    "codigo":1336190008,
    "descripcion":"CARCINOMA INFLAMATORIO METASTÁSICO"
  },
  {
    "codigo":123774009,
    "descripcion":"SULFAHEMOGLOBINURIA"
  },
  {
    "codigo":449619004,
    "descripcion":"TUMEFACCIÓN DE BRAZO"
  },
  {
    "codigo":253011004,
    "descripcion":"MACROPROLACTINOMA"
  },
  {
    "codigo":285779006,
    "descripcion":"CAPAZ DE RECONOCER PARTES DEL PROPIO CUERPO"
  },
  {
    "codigo":1268819009,
    "descripcion":"TENDINITIS CALCIFICANTE DE REGIÓN DE RODILLA"
  },
  {
    "codigo":283944002,
    "descripcion":"HEMATOMA DE TESTÍCULO"
  },
  {
    "codigo":251176006,
    "descripcion":"COMPLEJOS VENTRICULARES PREMATUROS MÚLTIPLES"
  },
  {
    "codigo":218408007,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR ÁCIDO PARA-AMINOSALICÍLICO"
  },
  {
    "codigo":708093000,
    "descripcion":"EXACERBACIÓN AGUDA DE ASMA ALÉRGICA MEDIADA POR INMUNOGLOBULINA E"
  },
  {
    "codigo":773629001,
    "descripcion":"ONICOMATRICOMA"
  },
  {
    "codigo":183805005,
    "descripcion":"ESTADÍA DE INTERNACIÓN, 7 DÍAS"
  },
  {
    "codigo":249341006,
    "descripcion":"LABIO LEPORINO CON DEFORMIDAD NASAL"
  },
  {
    "codigo":216573005,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR SUCCINIMIDAS"
  },
  {
    "codigo":247506000,
    "descripcion":"ESTRÍAS UNGUEALES MARRONES LONGITUDINALES"
  },
  {
    "codigo":739026008,
    "descripcion":"VÁLVULA CARDÍACA TRASPLANTADA PRESENTE"
  },
  {
    "codigo":442279002,
    "descripcion":"ERUPCIÓN DE GENITALES"
  },
  {
    "codigo":737191003,
    "descripcion":"TRASTORNO DE ESTRUCTURA VASCULAR DE DUODENO"
  },
  {
    "codigo":16295005,
    "descripcion":"TRASTORNO BIPOLAR II, EPISODIO MÁS RECIENTE DE CARACTERÍSTICAS DEPRESIVAS PROFUNDAS"
  },
  {
    "codigo":704423008,
    "descripcion":"TEMOR AL ABANDONO"
  },
  {
    "codigo":735356001,
    "descripcion":"COLOR DE PIEL DIFERENTE EN MIEMBRO CONTRALATERAL"
  },
  {
    "codigo":1259644005,
    "descripcion":"COREA DEBIDA A LESIÓN CEREBRAL POR TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":763528002,
    "descripcion":"SÍNDROME DE MONOSOMÍA 3P DISTAL"
  },
  {
    "codigo":14460007,
    "descripcion":"HEMORRAGIA EN LAS VAINAS DEL NERVIO ÓPTICO"
  },
  {
    "codigo":276604007,
    "descripcion":"ALTERACIÓN DEL CRECIMIENTO FETAL"
  },
  {
    "codigo":440444007,
    "descripcion":"LESIÓN EN RAMIFICACIÓN DE ARTERIA CORONARIA"
  },
  {
    "codigo":733521003,
    "descripcion":"SÍNDROME DE MICRODELECIÓN DISTAL 16P11.2"
  },
  {
    "codigo":242001005,
    "descripcion":"EMBOLIA AÉREA DISBÁRICA"
  },
  {
    "codigo":274769005,
    "descripcion":"ALBUMINURIA"
  },
  {
    "codigo":373073006,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM THAMNOPHIS"
  },
  {
    "codigo":12625009,
    "descripcion":"ÚLCERA PÉPTICA CON PERFORACIÓN PERO SIN OBSTRUCCIÓN"
  },
  {
    "codigo":404006002,
    "descripcion":"HISTIOCITOMA DE CÉLULAS CLARAS DE LA PIEL"
  },
  {
    "codigo":829990003,
    "descripcion":"FRAGILIDAD CAPILAR NO DETECTADA POR PRUEBA DE FRAGILIDAD CAPILAR"
  },
  {
    "codigo":764454003,
    "descripcion":"TRISOMÍA DISTAL 13Q"
  },
  {
    "codigo":305702004,
    "descripcion":"VISTO POR UN CIRUJANO"
  },
  {
    "codigo":698918006,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: SANGO"
  },
  {
    "codigo":41723001,
    "descripcion":"ENFERMEDAD POR EL VIRUS JAMESTOWN CANYON"
  },
  {
    "codigo":860923004,
    "descripcion":"OSTEOSARCOMA PRIMARIO DE CARTÍLAGO ARTICULAR DE MIEMBRO INFERIOR"
  },
  {
    "codigo":271099006,
    "descripcion":"DEFORMIDAD DE HUESO METATARSIANO"
  },
  {
    "codigo":236496000,
    "descripcion":"NEFROPATÍA AGUDA POR URATO"
  },
  {
    "codigo":16054911000119105,
    "descripcion":"ASTIGMATISMO IRREGULAR DE OJO DERECHO POSTQUIRÚRGICO"
  },
  {
    "codigo":8955008,
    "descripcion":"ESPUTO MUCOPURULENTO"
  },
  {
    "codigo":72656004,
    "descripcion":"NEUMONITIS GRANULOMATOSA"
  },
  {
    "codigo":11850521000119100,
    "descripcion":"CONTUSIÓN DE MAMA IZQUIERDA"
  },
  {
    "codigo":170960008,
    "descripcion":"TRATAMIENTO DE RESTITUCIÓN HORMONAL: ESTRÓGENO\/PROGESTÁGENO COMBINADOS"
  },
  {
    "codigo":302032008,
    "descripcion":"HALLAZGO RELACIONADO CON EL TAMAÑO TESTICULAR"
  },
  {
    "codigo":365733006,
    "descripcion":"NIVEL DE CARBAMAZEPINA - HALLAZGO"
  },
  {
    "codigo":300197009,
    "descripcion":"PROBLEMA DE OÍDO"
  },
  {
    "codigo":298362002,
    "descripcion":"HALLAZGO RELACIONADO CON EL MOVIMIENTO ÓSEO"
  },
  {
    "codigo":429434005,
    "descripcion":"TROMBOSIS DE VENA SUPERFICIAL DEL MIEMBRO INFERIOR"
  },
  {
    "codigo":167290008,
    "descripcion":"PRUEBA DE CUERPOS CETÓNICOS EN ORINA: =++"
  },
  {
    "codigo":165455001,
    "descripcion":"VOLUMEN CORPUSCULAR MEDIO POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":722511005,
    "descripcion":"RABDOMIOSARCOMA PRIMARIO DE ÓRGANO RESPIRATORIO"
  },
  {
    "codigo":294692005,
    "descripcion":"ALERGIA A BECLOMETASONA"
  },
  {
    "codigo":720676006,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR EPROSARTÁN"
  },
  {
    "codigo":15864601000119107,
    "descripcion":"SUPERPOSICIÓN CONGÉNITA DE LOS DEDOS DE AMBOS PIES"
  },
  {
    "codigo":784377008,
    "descripcion":"EPILEPSIA FAMILIAR CON CARACTERÍSTICAS AUDITIVAS"
  },
  {
    "codigo":127182001,
    "descripcion":"LINFADENOPATÍA PARAVESICULAR"
  },
  {
    "codigo":192718002,
    "descripcion":"ENCEFALITIS POSVACUNACIÓN ANTIPOLIOMIELÍTICA"
  },
  {
    "codigo":94414003,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL TERCIO MEDIO DEL ESÓFAGO"
  },
  {
    "codigo":225486005,
    "descripcion":"SEGURO"
  },
  {
    "codigo":1208526009,
    "descripcion":"RECOLECCIÓN DE ESPÉCIMEN REALIZADA POR SUJETO NO SUPERVISADA POR PROFESIONAL DE SALUD"
  },
  {
    "codigo":59811005,
    "descripcion":"COMPENSACIÓN"
  },
  {
    "codigo":289187009,
    "descripcion":"HALLAZGO RELACIONADO CON LA PRODUCCIÓN DEL TIPO DE VOZ"
  },
  {
    "codigo":1237624003,
    "descripcion":"LUXACIÓN DE PRÓTESIS DE ARTICULACIÓN DE RODILLA"
  },
  {
    "codigo":1092531000119106,
    "descripcion":"CHOQUE SÉPTICO CONCOMITANTE CON DISFUNCIÓN ORGÁNICA AGUDA DEBIDO A ESTREPTOCOCO DEL GRUPO A"
  },
  {
    "codigo":418424006,
    "descripcion":"SÍNDROME DE SOMNOLENCIA POSTERIOR A RADIOTERAPIA"
  },
  {
    "codigo":416589006,
    "descripcion":"RETINITIS POR TOXOPLASMA"
  },
  {
    "codigo":709666005,
    "descripcion":"DERMATITIS POR ESTASIS DE MIEMBRO INFERIOR DEBIDA A HIPERTENSIÓN VENOSA PERIFÉRICA CRÓNICA"
  },
  {
    "codigo":87074006,
    "descripcion":"ENFERMEDAD DE SALLA"
  },
  {
    "codigo":283682007,
    "descripcion":"MORDEDURA - HERIDA"
  },
  {
    "codigo":249079005,
    "descripcion":"PRESENTACIÓN DE FONTANELAS"
  },
  {
    "codigo":871671005,
    "descripcion":"ESTENOSIS ADQUIRIDA DE ÁREA SUPRAVALVULAR"
  },
  {
    "codigo":19703005,
    "descripcion":"SEDIMENTO URETERAL"
  },
  {
    "codigo":1363191008,
    "descripcion":"DIFICULTAD PARA SENTARSE EN ASIENTO PARA INODORO"
  },
  {
    "codigo":50636009,
    "descripcion":"APNEA TERMINAL"
  },
  {
    "codigo":738764009,
    "descripcion":"METABOLIZADOR LENTO DE LA FAMILIA 2 SUBFAMILIA B MIEMBRO 6 DEL CITOCROMO P450"
  },
  {
    "codigo":704161002,
    "descripcion":"FRACTURA NO EXPUESTA DE FALANGE PROXIMAL DE DEDO MEÑIQUE"
  },
  {
    "codigo":16030951000119102,
    "descripcion":"NECROSIS AVASCULAR DE MITAD DERECHA DE PELVIS"
  },
  {
    "codigo":866166001,
    "descripcion":"TUNELIZACIÓN DE HERIDA"
  },
  {
    "codigo":46966000,
    "descripcion":"COMPRESIÓN CEREBRAL TRAUMÁTICA"
  },
  {
    "codigo":702326000,
    "descripcion":"EPILEPSIA MIOCLÓNICA PROGRESIVA CON ATAXIA"
  },
  {
    "codigo":79734007,
    "descripcion":"TRASTORNO NO INFLAMATORIO DEL OVARIO"
  },
  {
    "codigo":1259382007,
    "descripcion":"SARCOMA DE CÉLULAS EPITELIOIDES PRIMARIO DE PIEL"
  },
  {
    "codigo":472950009,
    "descripcion":"TRAVESTISMO SECUNDARIO"
  },
  {
    "codigo":208971002,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA EXPUESTA DE LA ARTICULACIÓN DE LA RODILLA, POSTERIOR"
  },
  {
    "codigo":405579008,
    "descripcion":"PERFORACIÓN NO TRAUMÁTICA DE INTESTINO GRUESO"
  },
  {
    "codigo":609459003,
    "descripcion":"INTERRUPCIÓN INDUCIDA DEL EMBARAZO COMPLICADA POR EMBOLIA DE COÁGULO SANGUÍNEO"
  },
  {
    "codigo":305440000,
    "descripcion":"BAJO ATENCIÓN DE CONSEJERO ESPECIALIZADO EN DUELO"
  },
  {
    "codigo":698656005,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: BIHARI"
  },
  {
    "codigo":403744007,
    "descripcion":"HIPOMELANOSIS EN \"GOTA DE LLUVIA\" INDUCIDA POR ARSÉNICO"
  },
  {
    "codigo":895264008,
    "descripcion":"FORMA TRIANGULAR ANORMAL CONGÉNITA DE FALANGE MEDIA DE DEDO MEÑIQUE"
  },
  {
    "codigo":10528009,
    "descripcion":"LUPUS VULGAR"
  },
  {
    "codigo":238069004,
    "descripcion":"DEFICIENCIA DE ACIL-COENZIMA A OXIDASA"
  },
  {
    "codigo":762357005,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO ÓPTICO IZQUIERDO"
  },
  {
    "codigo":301770000,
    "descripcion":"MENINGITIS ASÉPTICA"
  },
  {
    "codigo":6858004,
    "descripcion":"CAPSULITIS"
  },
  {
    "codigo":400074007,
    "descripcion":"NEOPLASIA MALIGNA VASCULAR PRIMARIA DE PIERNA"
  },
  {
    "codigo":201631000,
    "descripcion":"CONDROCALCINOSIS DE REGIÓN PÉLVICA Y MUSLO CAUSADA POR CRISTALES DE FOSFATO DICÁLCICO"
  },
  {
    "codigo":365471004,
    "descripcion":"HALLAZGO RELACIONADO CON DETALLES DE LOS FAMILIARES"
  },
  {
    "codigo":299935009,
    "descripcion":"SENSIBILIDAD VIBRATORIA NORMAL"
  },
  {
    "codigo":298100002,
    "descripcion":"CUERPO EXTRAÑO EN LA PIEL DE LA PANTORRILLA"
  },
  {
    "codigo":396404006,
    "descripcion":"COMPROMISO DEL ESPÉCIMEN POR TUMOR MACROSCÓPICO AUSENTE"
  },
  {
    "codigo":68724006,
    "descripcion":"TRASTORNO DE LA SÍNTESIS DE TETRAHIDROBIOPTERINA"
  },
  {
    "codigo":66889002,
    "descripcion":"MEMBRANA ESOFÁGICA TERMINAL"
  },
  {
    "codigo":1344841005,
    "descripcion":"DISECCIÓN DE AORTA DESCENDENTE TIPO B DE STANFORD"
  },
  {
    "codigo":720414005,
    "descripcion":"SÍNDROME ACRO-RENO-MANDIBULAR"
  },
  {
    "codigo":32286006,
    "descripcion":"NEUMONÍA EN LA FIEBRE Q"
  },
  {
    "codigo":292595002,
    "descripcion":"REACCIÓN ADVERSA A LA FENINDAMINA"
  },
  {
    "codigo":30451004,
    "descripcion":"DERMATITIS DE CONTACTO CAUSADA POR DETERGENTES"
  },
  {
    "codigo":716744000,
    "descripcion":"HIPOSPADIAS DE PENE FAMILIAR"
  },
  {
    "codigo":718579008,
    "descripcion":"DISTROFIA DE ENDOTELIO CORNEAL LIGADA AL CROMOSOMA X"
  },
  {
    "codigo":1306568002,
    "descripcion":"CARCINOMA DUCTAL INFILTRANTE DE CUADRANTE SUPERIOR EXTERNO DE MAMA"
  },
  {
    "codigo":126920004,
    "descripcion":"NEOPLASIA DE LA PLACENTA"
  },
  {
    "codigo":94152006,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL ESÓFAGO ABDOMINAL"
  },
  {
    "codigo":290760008,
    "descripcion":"INTOXICACIÓN CON ALCALOIDE DE LA VINCA"
  },
  {
    "codigo":92317005,
    "descripcion":"NEOPLASIA BENIGNA DEL TABIQUE RECTOVESICAL"
  },
  {
    "codigo":288925007,
    "descripcion":"INCAPAZ DE IMPULSAR BOLO ALIMENTARIO HACIA LA FARINGE"
  },
  {
    "codigo":713074007,
    "descripcion":"TESTIGO DE ACTIVIDAD DELICTIVA POR PARTE DE UN ADULTO"
  },
  {
    "codigo":1237362007,
    "descripcion":"COLAPSO DE PULMÓN POR PRESIÓN DEBIDO A ANESTESIA EN PUERPERIO"
  },
  {
    "codigo":385394007,
    "descripcion":"INVASIÓN TUMORAL SEGÚN LOCALIZACIÓN"
  },
  {
    "codigo":1268295005,
    "descripcion":"VASCULITIS DEBIDA A ENFERMEDAD SISTÉMICA"
  },
  {
    "codigo":55879006,
    "descripcion":"PERICARDITIS SECUNDARIA A TUMOR PRIMARIO MALIGNO"
  },
  {
    "codigo":285255005,
    "descripcion":"COMPULSIÓN POR ACTUAR ANTE PENSAMIENTOS PELIGROSOS"
  },
  {
    "codigo":447260005,
    "descripcion":"LESIÓN TRAUMÁTICA DE ARTERIA CELÍACA"
  },
  {
    "codigo":840476007,
    "descripcion":"INESTABILIDAD CONGÉNITA DE COLUMNA VERTEBRAL"
  },
  {
    "codigo":414492009,
    "descripcion":"DERMATITIS INFECCIOSA ECCEMATOIDE"
  },
  {
    "codigo":19441002,
    "descripcion":"DISPLASIA OCCIPITAL"
  },
  {
    "codigo":283420009,
    "descripcion":"CORTE EN EL PULGAR"
  },
  {
    "codigo":10682191000119102,
    "descripcion":"TUMORACIÓN DE LA PIEL DEL PIE IZQUIERDO"
  },
  {
    "codigo":281585008,
    "descripcion":"ECTOPIA CRUZADA DE TESTÍCULOS"
  },
  {
    "codigo":246982002,
    "descripcion":"ADELGAZAMIENTO DE LA ESCLERÓTICA"
  },
  {
    "codigo":248817008,
    "descripcion":"AUMENTO DE LAS VENAS MAMARIAS SUPERFICIALES"
  },
  {
    "codigo":32591000119103,
    "descripcion":"HIPERESTIMULACIÓN OVÁRICA SEVERA"
  },
  {
    "codigo":81307004,
    "descripcion":"ISQUIOMELO"
  },
  {
    "codigo":407152001,
    "descripcion":"NIVEL DE PLOMO EN SANGRE POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":276080001,
    "descripcion":"RETIRO NO LIQUIDADO"
  },
  {
    "codigo":765765000,
    "descripcion":"SADISMO"
  },
  {
    "codigo":439920009,
    "descripcion":"VÍCTIMA DE HURTO"
  },
  {
    "codigo":1290053001,
    "descripcion":"USA ZAPATOS IZQUIERDO Y DERECHO DE DOS PARES DIFERENTES"
  },
  {
    "codigo":700229002,
    "descripcion":"VÍCTIMA DE ABUSO SEXUAL INFANTIL"
  },
  {
    "codigo":10737641000119101,
    "descripcion":"CISTOADENOCARCINOMA PAPILAR SEROSO PRIMARIO DE OVARIO IZQUIERDO"
  },
  {
    "codigo":896837005,
    "descripcion":"FORMA TRIANGULAR ANORMAL CONGÉNITA DE EPÍFISIS DE FALANGE DE DEDO ANULAR"
  },
  {
    "codigo":1071081000119102,
    "descripcion":"REUMATISMO PALINDRÓMICO DE RODILLA"
  },
  {
    "codigo":237807003,
    "descripcion":"INFRAVIRILIZACIÓN"
  },
  {
    "codigo":1351919003,
    "descripcion":"HEMANGIOBLASTOMA DE PIEL"
  },
  {
    "codigo":1153476000,
    "descripcion":"ALBÚMINA SÉRICA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":235972007,
    "descripcion":"ESTENOSIS DE CONDUCTO PANCREÁTICO"
  },
  {
    "codigo":397977001,
    "descripcion":"ÚLCERA CORNEAL MICÓTICA"
  },
  {
    "codigo":365209004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA USAR EL INODORO"
  },
  {
    "codigo":11311081000119109,
    "descripcion":"FRACTURA EXPUESTA DE SEGUNDA VÉRTEBRA DORSAL"
  },
  {
    "codigo":363374005,
    "descripcion":"NEOPLASIA MALIGNA DE COMISURA DE LABIOS"
  },
  {
    "codigo":232302007,
    "descripcion":"DEFECTO DE MONDINI"
  },
  {
    "codigo":66627000,
    "descripcion":"ORINA QUILOSA"
  },
  {
    "codigo":263235001,
    "descripcion":"FRACTURA SUPRACONDÍLEA DE FÉMUR"
  },
  {
    "codigo":427075000,
    "descripcion":"DOLOR IRRADIADO AL ABDOMEN SUPERIOR"
  },
  {
    "codigo":723822009,
    "descripcion":"PARAPLEJÍA ESPÁSTICA AUTOSÓMICA RECESIVA TIPO 46"
  },
  {
    "codigo":296003005,
    "descripcion":"SOBREDOSIS DE FENITOÍNA"
  },
  {
    "codigo":230467008,
    "descripcion":"ESTADO MIGRAÑOSO"
  },
  {
    "codigo":294168003,
    "descripcion":"ALERGIA A CALAMINA"
  },
  {
    "codigo":1177069001,
    "descripcion":"COMPRESIÓN DE MÉDULA ESPINAL DEBIDA A ENFERMEDAD PARASITARIA"
  },
  {
    "codigo":95725002,
    "descripcion":"LACERACIÓN CORNEAL"
  },
  {
    "codigo":30189004,
    "descripcion":"OSCILACIÓN"
  },
  {
    "codigo":292333006,
    "descripcion":"REACCIÓN ADVERSA AL ZOLPIDEM"
  },
  {
    "codigo":423405007,
    "descripcion":"INFILTRADOS SUBEPITELIALES POR HERPES SIMPLE"
  },
  {
    "codigo":194029009,
    "descripcion":"ENOFTALMÍA POR ATROFIA DEL TEJIDO ORBITARIO"
  },
  {
    "codigo":126658002,
    "descripcion":"NEOPLASIA DEL PIE"
  },
  {
    "codigo":224962007,
    "descripcion":"SUDORACIÓN CALIENTE"
  },
  {
    "codigo":716482009,
    "descripcion":"DIFICULTAD PARA COMPRENDER INSTRUCCIONES EN DOS PARTES"
  },
  {
    "codigo":93890009,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL DIVERTÍCULO DE MECKEL"
  },
  {
    "codigo":92055005,
    "descripcion":"NEOPLASIA BENIGNA DE COLUMNA VERTEBRAL CERVICAL"
  },
  {
    "codigo":419735006,
    "descripcion":"ECCEMA CON DESCAMACIÓN"
  },
  {
    "codigo":254060000,
    "descripcion":"DISPLASIA OTOESPONDILOMEGAEPIFISARIA"
  },
  {
    "codigo":188524002,
    "descripcion":"PARAGRANULOMA DE HODGKIN DE GANGLIOS LINFÁTICOS INTRATORÁCICOS"
  },
  {
    "codigo":55617001,
    "descripcion":"ÚLCERA PÉPTICA CON HEMORRAGIA Y PERFORACIÓN"
  },
  {
    "codigo":283158001,
    "descripcion":"CUERPO EXTRAÑO METÁLICO EN EL ANTEBRAZO"
  },
  {
    "codigo":1004054001,
    "descripcion":"CONTRACTURA EN FLEXIÓN DE ARTICULACIÓN METATARSOFALÁNGICA DE QUINTO DEDO DE PIE"
  },
  {
    "codigo":709142003,
    "descripcion":"ARTROPATÍA DREPANOCÍTICA"
  },
  {
    "codigo":838379000,
    "descripcion":"VESTIBULOPATÍA BILATERAL CRÓNICA DEBIDA A SCHWANNOMA BILATERAL"
  },
  {
    "codigo":445163001,
    "descripcion":"DIVERTÍCULO DE MECKEL SANGRANTE"
  },
  {
    "codigo":281323002,
    "descripcion":"SOLICITUD DE DETALLES INSUFICIENTE"
  },
  {
    "codigo":707307002,
    "descripcion":"CRIBADO DE TUBERCULOSIS MEDIANTE RADIOGRAFÍA SIMPLE DE TÓRAX, ANORMAL"
  },
  {
    "codigo":117483003,
    "descripcion":"CRISTAL URINARIO, HEXAHIDRATO DE FOSFATO AMÓNICO MAGNÉSICO"
  },
  {
    "codigo":19179000,
    "descripcion":"ISQUIÓPAGO"
  },
  {
    "codigo":248555006,
    "descripcion":"VÍA AÉREA COMPLETAMENTE OBSTRUIDA"
  },
  {
    "codigo":215787004,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR GASES O HUMOS A BORDO DE EMBARCACIÓN, CARGADOR DE MUELLES O ESTIBADOR LESIONADO"
  },
  {
    "codigo":1264363002,
    "descripcion":"SUBLUXACIÓN DE ARTICULACIÓN TARSOMETATARSIANA"
  },
  {
    "codigo":84715003,
    "descripcion":"INTOXICACIÓN POR CROTALARIA BURKEANA"
  },
  {
    "codigo":246720002,
    "descripcion":"ENFOQUE DEFICIENTE"
  },
  {
    "codigo":50112006,
    "descripcion":"EYACULACIÓN RETRÓGRADA"
  },
  {
    "codigo":115648009,
    "descripcion":"INFECCIÓN PERSISTENTE"
  },
  {
    "codigo":15509004,
    "descripcion":"HIPOVITAMINOSIS A CON CEGUERA NOCTURNA"
  },
  {
    "codigo":48277006,
    "descripcion":"IMPÉTIGO"
  },
  {
    "codigo":212117009,
    "descripcion":"QUEMADURA QUE COMPROMETE MÁS DEL 90 POR CIENTO DE LA SUPERFICIE CORPORAL, CON 10 - 19 POR CIENTO DE SUPERFICIE CORPORAL CON QUEMADURA DE TERCER GRADO"
  },
  {
    "codigo":1258858002,
    "descripcion":"DUPLICACIÓN DE RAÍZ DE DIENTE PERMANENTE DEBIDA A TRAUMATISMO DENTAL Y POSTERIOR A ÉL"
  },
  {
    "codigo":13674001,
    "descripcion":"ANOMALÍA DEL PAR DE CROMOSOMAS 3"
  },
  {
    "codigo":79210003,
    "descripcion":"COMPLEJO DE ELECTRA"
  },
  {
    "codigo":46442004,
    "descripcion":"ABSCESO DE LAS GLÁNDULAS DE LITTRÉ"
  },
  {
    "codigo":111978008,
    "descripcion":"EPIDERMOPOYESIS AUMENTADA"
  },
  {
    "codigo":243050009,
    "descripcion":"LESIÓN POR BAYONETA"
  },
  {
    "codigo":10959441000119104,
    "descripcion":"LACERACIÓN DE MUÑECA DERECHA"
  },
  {
    "codigo":110143004,
    "descripcion":"AVULSIÓN OROFARÍNGEA"
  },
  {
    "codigo":208447004,
    "descripcion":"FRACTURA NO EXPUESTA DE FALANGE PROXIMAL DE DEDO DE LA MANO, CUELLO"
  },
  {
    "codigo":273983009,
    "descripcion":"PROBLEMA DE PORCIÓN MATERNA DEL CORDÓN O PLACENTA"
  },
  {
    "codigo":1156884002,
    "descripcion":"EQUILIBRIO DE LÍQUIDOS COMPATIBLE CON REQUERIMIENTO"
  },
  {
    "codigo":77375009,
    "descripcion":"DISFONÍA ESPÁSTICA DE TIPO ADUCTOR POR REACCIÓN DE CONVERSIÓN"
  },
  {
    "codigo":372287009,
    "descripcion":"INVASIÓN TUMORAL VASCULAR PRESENTE"
  },
  {
    "codigo":403220006,
    "descripcion":"SENSIBILIDAD CONSTITUCIONAL AL SOL-HALLAZGO"
  },
  {
    "codigo":1255188007,
    "descripcion":"ESTENOSIS DE RAMA LATERAL POSTERIOR IZQUIERDA DE RAMA CIRCUNFLEJA DE ARTERIA CORONARIA IZQUIERDA"
  },
  {
    "codigo":763668009,
    "descripcion":"SÍNDROME DE LICHTENSTEIN"
  },
  {
    "codigo":303081002,
    "descripcion":"CLAUDICACIÓN NEUROGÉNICA"
  },
  {
    "codigo":237545007,
    "descripcion":"INTERFERENCIA FARMACOLÓGICA CON LA GLOBULINA FIJADORA DE HORMONA TIROIDEA"
  },
  {
    "codigo":170174000,
    "descripcion":"EXAMEN DEL NIÑO A LOS 10 AÑOS: ANORMAL - DERIVADO"
  },
  {
    "codigo":235710003,
    "descripcion":"ULCERACIÓN DEL INTESTINO DELGADO"
  },
  {
    "codigo":301246003,
    "descripcion":"ELIMINA EL ESPUTO"
  },
  {
    "codigo":268478005,
    "descripcion":"UNO DE LOS GEMELOS"
  },
  {
    "codigo":399550007,
    "descripcion":"TUMOR QUE INVADE VENA VORTICOSA"
  },
  {
    "codigo":202942009,
    "descripcion":"GANGLIÓN DE MUÑECA"
  },
  {
    "codigo":4499004,
    "descripcion":"LEISHMANIASIS ANÉRGICA DISEMINADA"
  },
  {
    "codigo":364947005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA MOVER LA MANDÍBULA REPETIDAMENTE"
  },
  {
    "codigo":102803006,
    "descripcion":"AUSENCIA DE SECRECIÓN DE RENINA"
  },
  {
    "codigo":233875006,
    "descripcion":"CARDIOMIOPATÍA POSMIOCARDÍTICA"
  },
  {
    "codigo":299411007,
    "descripcion":"PRUEBA DE EXTENSIÓN DINÁMICA NEGATIVA"
  },
  {
    "codigo":430483006,
    "descripcion":"SEUDOINVASIÓN EN PÓLIPO ADENOMATOSO DE INTESTINO GRUESO"
  },
  {
    "codigo":42741000087106,
    "descripcion":"DISCO INTERVERTEBRAL TORÁCICO PROLAPSADO, T3-T4"
  },
  {
    "codigo":52981000087100,
    "descripcion":"CAPAZ DE MOVILIZARSE SIN AYUDA"
  },
  {
    "codigo":232040002,
    "descripcion":"OCLUSIÓN DE VENA CENTRAL DE LA RETINA - JUVENIL"
  },
  {
    "codigo":40181000087101,
    "descripcion":"HERIDA ABIERTA DE PIE IZQUIERDO POR MORDEDURA"
  },
  {
    "codigo":47861000087103,
    "descripcion":"FRACTURA DE DUODÉCIMA COSTILLA DERECHA"
  },
  {
    "codigo":1153416009,
    "descripcion":"DEFORMIDAD ESCOLIÓTICA DE COLUMNA VERTEBRAL DEBIDA A EPIFISIOPATÍA"
  },
  {
    "codigo":461416009,
    "descripcion":"ENDOCARDITIS INFECCIOSA EN LOCALIZACIÓN DE DISPOSITIVO DE DERIVACIÓN VASCULAR IMPLANTADO"
  },
  {
    "codigo":295741004,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE CISPLATINO"
  },
  {
    "codigo":721725005,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE PERITONEO"
  },
  {
    "codigo":361277007,
    "descripcion":"DISPRAXIA VERBAL"
  },
  {
    "codigo":338821000119102,
    "descripcion":"COROIDITIS DISEMINADA PERIFÉRICA DE OJO IZQUIERDO"
  },
  {
    "codigo":719890004,
    "descripcion":"PROBLEMA CON YESO INMOVILIZADOR"
  },
  {
    "codigo":29927001,
    "descripcion":"FÍSTULA DEL INTESTINO A LA PARED ABDOMINAL"
  },
  {
    "codigo":293906009,
    "descripcion":"ALERGIA A MEPROBAMATO"
  },
  {
    "codigo":62695002,
    "descripcion":"INFARTO AGUDO DE MIOCARDIO ANTEROSEPTAL"
  },
  {
    "codigo":128231007,
    "descripcion":"TRASTORNO DE HUESO ETMOIDES"
  },
  {
    "codigo":292071008,
    "descripcion":"REACCIÓN ADVERSA A DICLOFENACO"
  },
  {
    "codigo":95463009,
    "descripcion":"ANOMALÍA CONGÉNITA DE LA ARTICULACIÓN"
  },
  {
    "codigo":1142204001,
    "descripcion":"TAQUICARDIA RECIPROCANTE AURICULOVENTRICULAR ORTODRÓMICA QUE UTILIZA VÍA ACCESORIA ESCONDIDA"
  },
  {
    "codigo":290236005,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR DICLOFENACO"
  },
  {
    "codigo":1323351000000104,
    "descripcion":"SANGRADO EN EL PRIMER TRIMESTRE"
  },
  {
    "codigo":714385005,
    "descripcion":"CAPAZ DE ADOPTAR EL PAPEL DE ENFERMO"
  },
  {
    "codigo":288401005,
    "descripcion":"INCAPAZ DE ABRIR Y CERRAR RECIPIENTES"
  },
  {
    "codigo":57190000,
    "descripcion":"MIOPÍA"
  },
  {
    "codigo":124561009,
    "descripcion":"DEFICIENCIA DE ÉTER HIDROLASA"
  },
  {
    "codigo":386705008,
    "descripcion":"ATURDIMIENTO"
  },
  {
    "codigo":286566006,
    "descripcion":"CUERPO EXTRAÑO EN ESTRUCTURA ENDOCRINA"
  },
  {
    "codigo":55355000,
    "descripcion":"LARINGOFARINGITIS AGUDA"
  },
  {
    "codigo":415803005,
    "descripcion":"UTILIZA EL LENGUAJE DE SIGNOS BRITÁNICO"
  },
  {
    "codigo":1235003006,
    "descripcion":"MALFORMACIÓN VASCULAR CONGÉNITA DE REGIÓN ORBITARIA"
  },
  {
    "codigo":312351000119105,
    "descripcion":"ENFERMEDAD DE BAASTRUP DE COLUMNA LUMBAR"
  },
  {
    "codigo":413968004,
    "descripcion":"NIEGA ABUSO DE ALCOHOL"
  },
  {
    "codigo":250128004,
    "descripcion":"ARTRITIS DE PEQUEÑA ARTICULACIÓN"
  },
  {
    "codigo":282896007,
    "descripcion":"INCAPAZ DE ALTERNAR ENTRE SENTARSE Y PARARSE"
  },
  {
    "codigo":248293000,
    "descripcion":"PATRÓN ESQUELÉTICO FACIAL CLASE II"
  },
  {
    "codigo":1296869000,
    "descripcion":"TRASTORNO RELACIONADO CON PROTEÍNA DE UNIÓN A METILCITOSINA FOSFATO GUANINA 2"
  },
  {
    "codigo":18917003,
    "descripcion":"HEPATITIS VIRAL TIPO A AGUDA FULMINANTE"
  },
  {
    "codigo":1231333004,
    "descripcion":"DEPENDENCIA DE PSICOESTIMULANTE, EPISÓDICA"
  },
  {
    "codigo":1264101006,
    "descripcion":"AMPOLLA TRAUMÁTICA DE DEDO ÍNDICE"
  },
  {
    "codigo":1293199000,
    "descripcion":"MASA DE ARTICULACIÓN DE CODO"
  },
  {
    "codigo":111716006,
    "descripcion":"QUEMADURA EPIDÉRMICA DE TRONCO"
  },
  {
    "codigo":699705001,
    "descripcion":"EMBOLIA DE METILMETACRILATO"
  },
  {
    "codigo":78948009,
    "descripcion":"ALTERACIÓN DE LA SECRECIÓN SALIVAL"
  },
  {
    "codigo":40121000119107,
    "descripcion":"DISTROFIA DE RETINA DEBIDA A TRASTORNO SISTÉMICO"
  },
  {
    "codigo":372025005,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA VAGINA"
  },
  {
    "codigo":109881005,
    "descripcion":"NEOPLASIA BENIGNA DE FONDO UTERINO"
  },
  {
    "codigo":208185008,
    "descripcion":"FRACTURA VERTICAL NO EXPUESTA DE HUESO ILÍACO"
  },
  {
    "codigo":1254926001,
    "descripcion":"PÁPULAS PODÁLICAS DEL LACTANTE"
  },
  {
    "codigo":763406004,
    "descripcion":"SÍNDROME DE CROMOSOMA 16 EN ANILLO"
  },
  {
    "codigo":9742005,
    "descripcion":"AMPOLLA DE LA VULVA, SIN INFECCIÓN"
  },
  {
    "codigo":402958005,
    "descripcion":"VASCULITIS PUSTULOSA DEBIDA A BACTERIEMIA GONOCÓCICA"
  },
  {
    "codigo":239118007,
    "descripcion":"NEVO POROQUERATÓSICO DE OSTIOS Y CONDUCTOS ECRINOS DE LA DERMIS"
  },
  {
    "codigo":302819002,
    "descripcion":"NEOPLASIA BENIGNA DE PARTE INFERIOR DE CUERPO DE LA LENGUA"
  },
  {
    "codigo":1187555004,
    "descripcion":"TRASTORNO GLOMERULAR DEBIDO A AMILOIDOSIS LIMITADA A UN ÓRGANO"
  },
  {
    "codigo":73443006,
    "descripcion":"ESTADO INTRAOPERATORIO"
  },
  {
    "codigo":237283007,
    "descripcion":"ECLAMPSIA EN EL TRABAJO DE PARTO"
  },
  {
    "codigo":169912001,
    "descripcion":"PUNTAJE DE APGAR A LOS 5 MINUTOS = 2"
  },
  {
    "codigo":366520006,
    "descripcion":"HALLAZGO RELACIONADO CON COLORACIÓN DE ARTICULACIÓN DE CODO"
  },
  {
    "codigo":6072007,
    "descripcion":"HEMORRAGIA DEL ANO"
  },
  {
    "codigo":300984006,
    "descripcion":"ÚLCERA CUTÁNEA DE LA PANTORRILLA"
  },
  {
    "codigo":200845001,
    "descripcion":"DERMATITIS ALÉRGICA DE CONTACTO CAUSADA POR TINTURA"
  },
  {
    "codigo":4237001,
    "descripcion":"PULPITIS SUPURATIVA"
  },
  {
    "codigo":202680008,
    "descripcion":"ESPONDILOSIS LUMBOSACRA EN MÚLTIPLES NIVELES CON MIELOPATÍA"
  },
  {
    "codigo":299149004,
    "descripcion":"SIN AMPLITUD PASIVA DE FLEXIÓN DE PULGAR"
  },
  {
    "codigo":168077005,
    "descripcion":"CÁLCULO: COLESTEROL"
  },
  {
    "codigo":102541007,
    "descripcion":"PIES EN PRIMERA POSICIÓN"
  },
  {
    "codigo":37005007,
    "descripcion":"EDAD GESTACIONAL, 5 SEMANAS"
  },
  {
    "codigo":233613009,
    "descripcion":"NEUMONÍA MICÓTICA"
  },
  {
    "codigo":16289261000119103,
    "descripcion":"DISECCIÓN DE ARTERIA SUBCLAVIA IZQUIERDA"
  },
  {
    "codigo":721463003,
    "descripcion":"SÍNDROME DEL CORDÓN ANTERIOR DE MÉDULA ESPINAL AL NIVEL DEL OCTAVO SEGMENTO DORSAL"
  },
  {
    "codigo":262711004,
    "descripcion":"SECCIÓN DE MÉDULA ESPINAL CERVICAL"
  },
  {
    "codigo":295479008,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE FENOLFTALEÍNA"
  },
  {
    "codigo":195340002,
    "descripcion":"EMBOLIA Y TROMBOSIS DE LA ARTERIA ESPLÉNICA"
  },
  {
    "codigo":64268004,
    "descripcion":"QUISTE PALATINO MEDIANO"
  },
  {
    "codigo":29665005,
    "descripcion":"NECATORIASIS CAUSADA POR NECATOR AMERICANUS"
  },
  {
    "codigo":95201006,
    "descripcion":"PALIDEZ DEL BAZO"
  },
  {
    "codigo":291809007,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR CLORPROPAMIDA"
  },
  {
    "codigo":879798000,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE DEDO DE LA MANO CON INFECCIÓN"
  },
  {
    "codigo":27830001,
    "descripcion":"RADICULITIS BRAQUIAL"
  },
  {
    "codigo":16017031000119102,
    "descripcion":"ALTERACIÓN DE MENISCOS DE AMBAS RODILLAS"
  },
  {
    "codigo":160737007,
    "descripcion":"VIVE EN UN HOGAR PARA ANCIANOS"
  },
  {
    "codigo":289974004,
    "descripcion":"CAPAZ DE REALIZAR ACTIVIDADES DE CUIDADO DE LAS UÑAS"
  },
  {
    "codigo":224438008,
    "descripcion":"SIN COBERTURA DE SEGURIDAD SOCIAL LABORAL"
  },
  {
    "codigo":58763001,
    "descripcion":"EMPIEMA AGUDO DE SENO PARANASAL"
  },
  {
    "codigo":124299001,
    "descripcion":"DEFICIENCIA DE CETOHEXOCINASA"
  },
  {
    "codigo":253536001,
    "descripcion":"HIPOPLASIA VENTRICULAR IZQUIERDA"
  },
  {
    "codigo":286304005,
    "descripcion":"DIFICULTAD PARA USAR SONIDOS AISLADOS"
  },
  {
    "codigo":22325002,
    "descripcion":"MARCHA ANORMAL"
  },
  {
    "codigo":218933003,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR CATÁRTICO IRRITANTE"
  },
  {
    "codigo":251701006,
    "descripcion":"REFLUJO LAGRIMAL"
  },
  {
    "codigo":448309008,
    "descripcion":"OBSTRUCCIÓN AL TRACTO DE SALIDA DE VENTRÍCULO DERECHO DEBIDA A REBORDE FIBROMUSCULAR"
  },
  {
    "codigo":343841000119103,
    "descripcion":"DEGENERACIÓN CISTOIDE PERIFÉRICA DE RETINAS DE AMBOS OJOS"
  },
  {
    "codigo":446474007,
    "descripcion":"CATARATA INMADURA"
  },
  {
    "codigo":774154008,
    "descripcion":"PARÁLISIS PERIÓDICA CON NEUROPATÍA MOTORA DISTAL DE INICIO TARDÍO"
  },
  {
    "codigo":1003530008,
    "descripcion":"SOSPECHA DE GLAUCOMA CAUSADO POR CORTICOSTEROIDES"
  },
  {
    "codigo":282634009,
    "descripcion":"RUEDA SOBRE SÍ MISMO"
  },
  {
    "codigo":20490007,
    "descripcion":"QUEMADURA EPIDÉRMICA DE PIERNA"
  },
  {
    "codigo":315402008,
    "descripcion":"NACIDO EN CHECHENIA"
  },
  {
    "codigo":51423006,
    "descripcion":"VIRUELA MODIFICADA"
  },
  {
    "codigo":248031007,
    "descripcion":"ROBO EN EL TRABAJO"
  },
  {
    "codigo":47753002,
    "descripcion":"ESOFAGITIS MEDICAMENTOSA"
  },
  {
    "codigo":211593003,
    "descripcion":"LESIÓN TRAUMÁTICA ABIERTA POR APLASTAMIENTO, CADERA"
  },
  {
    "codigo":735881005,
    "descripcion":"LUXACIÓN TRAUMÁTICA DE ARTICULACIÓN METATARSOFALÁNGICA DE DEDO GORDO DEL PIE"
  },
  {
    "codigo":768649009,
    "descripcion":"CARIES DE CORONA DENTAL EN ESTADIO EXTENSIVO"
  },
  {
    "codigo":766814006,
    "descripcion":"ATAXIA CEREBELOSA AUTOSÓMICA RECESIVA CON SÍNDROME DE INTRUSIÓN SACÁDICO"
  },
  {
    "codigo":207923000,
    "descripcion":"FRACTURA EXPUESTA DEL ATLAS, APÓFISIS ODONTOIDES"
  },
  {
    "codigo":317371000119104,
    "descripcion":"DETENCIÓN PARCIAL DEL CRECIMIENTO EPIFISARIO DE FÉMUR DISTAL IZQUIERDO"
  },
  {
    "codigo":16050831000119100,
    "descripcion":"ARTRITIS DE ARTICULACIÓN INTERVERTEBRAL DEBIDA A INMUNIZACIÓN Y POSTERIOR A ELLA"
  },
  {
    "codigo":10672271000119100,
    "descripcion":"INSUFICIENCIA RESPIRATORIA HIPOXÉMICA CRÓNICA REAGUDIZADA"
  },
  {
    "codigo":135311000119100,
    "descripcion":"INSOMNIO CAUSADO POR ALCOHOL"
  },
  {
    "codigo":11995791000119103,
    "descripcion":"EDEMA EN MUÑÓN DE AMPUTACIÓN DE EXTREMIDAD INFERIOR DERECHA"
  },
  {
    "codigo":15986831000119100,
    "descripcion":"HIPERPLASIA PRIMARIA PERSISTENTE DE CUERPO VÍTREO DE OJO IZQUIERDO"
  },
  {
    "codigo":10626191000119105,
    "descripcion":"CARBUNCO DE HOMBRO DERECHO"
  },
  {
    "codigo":340111000119102,
    "descripcion":"FÍSTULA DEL LAGRIMAL IZQUIERDO"
  },
  {
    "codigo":10669711000119102,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN DE REGIÓN COCCÍGEA DE ESPALDA ESTADIO I"
  },
  {
    "codigo":16027791000119108,
    "descripcion":"EXOSTOSIS DE CÚBITO DERECHO"
  },
  {
    "codigo":299151000119107,
    "descripcion":"HEMARTROSIS DE CADERA DERECHA"
  },
  {
    "codigo":464345231000119105,
    "descripcion":"ENDOMETRIOSIS DE PARED ABDOMINAL ANTERIOR"
  },
  {
    "codigo":240691009,
    "descripcion":"SÍFILIS NO VENÉREA INFANTIL"
  },
  {
    "codigo":10938511000119106,
    "descripcion":"SEROMA POSTOPERATORIO DEBIDO A BYPASS CON INJERTO FEMORAL Y POSTERIOR A ÉL"
  },
  {
    "codigo":231349391000119108,
    "descripcion":"PROCTITIS ULCEROSA CRÓNICA EN REMISIÓN"
  },
  {
    "codigo":10836111000119108,
    "descripcion":"LUXACIÓN DE LA SÍNFISIS DEL PUBIS DURANTE EL TRABAJO DE PARTO Y EL PARTO"
  },
  {
    "codigo":10631311000119109,
    "descripcion":"ABSCESO DE PIEL DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":402696009,
    "descripcion":"DERMATOSIS DE OÍDO EXTERNO"
  },
  {
    "codigo":102031000119109,
    "descripcion":"MASA PARATESTICULAR"
  },
  {
    "codigo":10633871000119109,
    "descripcion":"CELULITIS DE ANTEBRAZO DERECHO"
  },
  {
    "codigo":73181007,
    "descripcion":"PTERIGIÓN RECIDIVANTE"
  },
  {
    "codigo":7645009,
    "descripcion":"INFECCIÓN CAUSADA POR AELUROSTRONGYLUS"
  },
  {
    "codigo":300722002,
    "descripcion":"NO REALIZA ACTIVIDADES RELACIONADAS CON LAS COMPRAS"
  },
  {
    "codigo":726706008,
    "descripcion":"SÍNDROME DE MICRODUPLICACIÓN 4P16.3"
  },
  {
    "codigo":366258009,
    "descripcion":"HALLAZGO RELACIONADO CON LA CONCIENCIA DEL FUNCIONAMIENTO INTESTINAL"
  },
  {
    "codigo":267954009,
    "descripcion":"DOLOR DE ARTICULACIÓN DE TOBILLO Y\/O PIE"
  },
  {
    "codigo":169650009,
    "descripcion":"AMNIOCENTESIS PRENATAL DESEADA"
  },
  {
    "codigo":298887004,
    "descripcion":"AMPLITUD DE FLEXIÓN PASIVA DE CODO AUMENTADA"
  },
  {
    "codigo":3975002,
    "descripcion":"QUEMADURA PROFUNDA DE TERCER GRADO DE LA EXTREMIDAD INFERIOR"
  },
  {
    "codigo":231516000,
    "descripcion":"HIPOCONDRIASIS CUTÁNEA"
  },
  {
    "codigo":724871008,
    "descripcion":"EXACERBACIÓN DE DERMATITIS CONSTITUCIONAL DEBIDA A OCUPACIÓN"
  },
  {
    "codigo":721201001,
    "descripcion":"ENFERMEDAD POR PROTOZOARIO QUE COMPLICA EL EMBARAZO, PARTO Y PUERPERIO"
  },
  {
    "codigo":15993071000119101,
    "descripcion":"QUERATITIS INTERSTICIAL DE OJO DERECHO DEBIDA A SÍFILIS CONGÉNITA"
  },
  {
    "codigo":229681003,
    "descripcion":"DISLEXIA FONOLÓGICA"
  },
  {
    "codigo":295217003,
    "descripcion":"SOBREDOSIS DE AGENTES ANTIINFLAMATORIOS NO ESTEROIDES"
  },
  {
    "codigo":346351000119101,
    "descripcion":"NEOVASCULARIZACIÓN PROFUNDA DE AMBAS CÓRNEAS"
  },
  {
    "codigo":459057007,
    "descripcion":"ENDOCARDITIS VIRAL"
  },
  {
    "codigo":293382000,
    "descripcion":"REACCIÓN ADVERSA A LAS SALES DE REHIDRATACIÓN ORAL"
  },
  {
    "codigo":1083631000119102,
    "descripcion":"OBSTRUCCIÓN DE AMBAS TROMPAS DE EUSTAQUIO"
  },
  {
    "codigo":162310002,
    "descripcion":"CEFALEA MATUTINA"
  },
  {
    "codigo":424454009,
    "descripcion":"ADENOCARCINOMA DE PULMÓN, ESTADIO III"
  },
  {
    "codigo":94939002,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE MÚSCULO DEL ABDOMEN"
  },
  {
    "codigo":62171003,
    "descripcion":"DOLOR DEL TALÓN PLANTAR"
  },
  {
    "codigo":291547008,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR PENICILINA G"
  },
  {
    "codigo":289712001,
    "descripcion":"CONTRACCIONES UTERINAS INSIGNIFICANTES"
  },
  {
    "codigo":125872003,
    "descripcion":"FRACTURA DEL SACRO"
  },
  {
    "codigo":93104005,
    "descripcion":"FALTA DE OSIFICACIÓN DEL ISQUION"
  },
  {
    "codigo":1303685000,
    "descripcion":"QUISTE ÓSEO ANEURISMÁTICO DE TIBIA"
  },
  {
    "codigo":224176009,
    "descripcion":"INGRESO PERSONAL MODERADO"
  },
  {
    "codigo":713861002,
    "descripcion":"DERRAME SUBDURAL"
  },
  {
    "codigo":1172613002,
    "descripcion":"HORMONA FETOPLACENTARIA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":418949004,
    "descripcion":"REACCIÓN ADVERSA AL SUXAMETONIO"
  },
  {
    "codigo":255109008,
    "descripcion":"CARCINOMA DE CÉLULAS TRANSICIONALES DE VEJIGA URINARIA"
  },
  {
    "codigo":89434002,
    "descripcion":"AFALANGIA COMPLETA DE LA EXTREMIDAD INFERIOR"
  },
  {
    "codigo":187738005,
    "descripcion":"NEOPLASIA MALIGNA DE CONDUCTO PILÓRICO DEL ESTÓMAGO"
  },
  {
    "codigo":253274005,
    "descripcion":"CONEXIÓN AURICULOVENTRICULAR ANORMAL"
  },
  {
    "codigo":286042007,
    "descripcion":"CAPAZ DE CLASIFICAR LA ROPA SUCIA"
  },
  {
    "codigo":185903001,
    "descripcion":"NECESITA INMUNIZACIÓN ANTIGRIPAL"
  },
  {
    "codigo":251439002,
    "descripcion":"PRUEBA DE ESFUERZO ARTICULAR: NEGATIVA"
  },
  {
    "codigo":22063003,
    "descripcion":"DEFICIENCIA HORMONAL AISLADA, DISTINTA DE HORMONA DE CRECIMIENTO HUMANA"
  },
  {
    "codigo":284207003,
    "descripcion":"QUEMADURA DE GARGANTA"
  },
  {
    "codigo":417459008,
    "descripcion":"TORSIÓN DEL SACRO HACIA ADELANTE"
  },
  {
    "codigo":15720841000119105,
    "descripcion":"SUBLUXACIÓN CONGÉNITA DE CABEZA DE RADIO IZQUIERDO"
  },
  {
    "codigo":85764001,
    "descripcion":"MORFOLOGÍA DE UNA COLONIA BACTERIANA, BORDE ENRULADO"
  },
  {
    "codigo":249604002,
    "descripcion":"HALLAZGO DE PRÓSTATA"
  },
  {
    "codigo":413444003,
    "descripcion":"ISQUEMIA MIOCÁRDICA AGUDA"
  },
  {
    "codigo":216836004,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR GASES DE COMBUSTIÓN DE VEHÍCULOS"
  },
  {
    "codigo":1263577005,
    "descripcion":"PRODUCCIÓN DE LÍQUIDO CEFALORRAQUÍDEO AUMENTADA DEBIDA A PAPILOMA BENIGNO DE PLEXO COROIDEO"
  },
  {
    "codigo":247769007,
    "descripcion":"ATENCIÓN INTEGRADA BIEN CONTROLADA"
  },
  {
    "codigo":129571000119102,
    "descripcion":"REACCIÓN ALÉRGICA DEBIDA A PRUEBA DE ALERGIA CUTÁNEA"
  },
  {
    "codigo":213166001,
    "descripcion":"FALLA PARCIAL DE REIMPLANTE DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":311470005,
    "descripcion":"HALLAZGO RELACIONADO CON EL SENTIDO DE LA ORIENTACIÓN"
  },
  {
    "codigo":735619000,
    "descripcion":"PIOMETRA CONCOMITANTE CON ENFERMEDAD INFLAMATORIA AGUDA DEL ÚTERO Y DEBIDA A ELLA"
  },
  {
    "codigo":1163438008,
    "descripcion":"TAQUICARDIA VENTRICULAR FASCICULAR IDIOPÁTICA"
  },
  {
    "codigo":276867000,
    "descripcion":"ESTENOSIS DE ANASTOMOSIS UROLÓGICA"
  },
  {
    "codigo":211331004,
    "descripcion":"ABRASIÓN DE PIEL DE MUSLO"
  },
  {
    "codigo":897624002,
    "descripcion":"FORMA TRIANGULAR ANORMAL CONGÉNITA DE EPÍFISIS DE FALANGE DE TERCER DEDO DE PIE"
  },
  {
    "codigo":111192003,
    "descripcion":"DERMATITIS DE CONTACTO CAUSADA POR INSECTICIDA"
  },
  {
    "codigo":406104003,
    "descripcion":"VIRUS DE HEPATITIS C DETECTADO POR ENSAYO INMUNOABSORBENTE LIGADO A ENZIMAS"
  },
  {
    "codigo":240429008,
    "descripcion":"TÉTANOS LOCALIZADO"
  },
  {
    "codigo":402434001,
    "descripcion":"COMPLICACIÓN CUTÁNEA DE ENFERMEDAD REUMATOIDEA"
  },
  {
    "codigo":41986000,
    "descripcion":"ÚLCERA DUODENAL AGUDA CON HEMORRAGIA, CON PERFORACIÓN Y CON OBSTRUCCIÓN"
  },
  {
    "codigo":238594009,
    "descripcion":"ECCEMA POR DESECACIÓN"
  },
  {
    "codigo":302295001,
    "descripcion":"DEFORMIDAD EN CAVO VARO DE PIE"
  },
  {
    "codigo":1187031003,
    "descripcion":"VITAMINA K1 DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1285335004,
    "descripcion":"GLAUCOMA DE ÁNGULO ABIERTO DEBIDO A CIRUGÍA OCULAR"
  },
  {
    "codigo":369666009,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA DE PLEURA Y MEDIASTINO, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":203991006,
    "descripcion":"MIELOCELE DORSAL"
  },
  {
    "codigo":236759008,
    "descripcion":"PRIAPISMO IDIOPÁTICO FAMILIAR CONGÉNITO"
  },
  {
    "codigo":202156005,
    "descripcion":"ARTROFITO EN ARTICULACIÓN GLENOHUMERAL"
  },
  {
    "codigo":365996006,
    "descripcion":"HALLAZGO EN LA INTERACCIÓN SOCIAL"
  },
  {
    "codigo":71084008,
    "descripcion":"AUSENCIA CONGÉNITA DE BRAZO Y ANTEBRAZO"
  },
  {
    "codigo":298625007,
    "descripcion":"AMPLITUD DE FLEXIÓN LATERAL ACTIVA HACIA LA DERECHA DE LA COLUMNA VERTEBRAL LUMBAR, NORMAL"
  },
  {
    "codigo":724609008,
    "descripcion":"BURSITIS CAUSADA POR PRESIÓN MECÁNICA"
  },
  {
    "codigo":1279830003,
    "descripcion":"HEMORRAGIA DEBIDA A METABOLIZADOR RÁPIDO DE SUBUNIDAD 1 DE COMPLEJO VITAMINA K EPÓXIDO REDUCTASA"
  },
  {
    "codigo":1148758003,
    "descripcion":"MICROCEFALIA CONGÉNITA"
  },
  {
    "codigo":126515007,
    "descripcion":"NEOPLASIA DE LA PIEL DEL OMBLIGO"
  },
  {
    "codigo":296790007,
    "descripcion":"SOBREDOSIS DE RIFAMPICINA"
  },
  {
    "codigo":65579002,
    "descripcion":"DIETA PARA INSUFICIENCIA RENAL CRÓNICA"
  },
  {
    "codigo":131115009,
    "descripcion":"VITAMINA E POR ENCIMA DE RANGO DE REFERENCIA"
  },
  {
    "codigo":424192002,
    "descripcion":"VISIÓN A DISTANCIA 20\/400"
  },
  {
    "codigo":719104003,
    "descripcion":"SÍNDROME DE QUERATODERMIA PALMOPLANTAR AUTOSÓMICA RECESIVA Y ALOPECIA CONGÉNITA"
  },
  {
    "codigo":293120003,
    "descripcion":"REACCIÓN ADVERSA A VACUNA ANTIVARIÓLICA"
  },
  {
    "codigo":360491009,
    "descripcion":"ATRESIA CONGÉNITA DE YEYUNO"
  },
  {
    "codigo":162048001,
    "descripcion":"DOLOR SUBCOSTAL DERECHO"
  },
  {
    "codigo":15696881000119101,
    "descripcion":"OSTEOMIELITIS DE AMBAS TIBIAS"
  },
  {
    "codigo":192981006,
    "descripcion":"CRISIS EPILÉPTICA ATÓNICA"
  },
  {
    "codigo":291285007,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR NICOTINA"
  },
  {
    "codigo":125610000,
    "descripcion":"LESIÓN TRAUMÁTICA ARTICULAR"
  },
  {
    "codigo":717269008,
    "descripcion":"OBESIDAD DEBIDA A DEFICIENCIA DE RECEPTOR 4 DE MELANOCORTINA"
  },
  {
    "codigo":94677006,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL VESTÍBULO DE LA NARIZ"
  },
  {
    "codigo":1338026004,
    "descripcion":"TRASTORNO DE MÁCULA RETINIANA CAUSADO POR RADIACIÓN"
  },
  {
    "codigo":191146005,
    "descripcion":"ANEMIA POR MALABSORCIÓN CONGÉNITA DE FOLATO"
  },
  {
    "codigo":715434005,
    "descripcion":"SÍNDROME DE HOLOPROSENCEFALIA Y CRANEOSINOSTOSIS"
  },
  {
    "codigo":387754006,
    "descripcion":"DISENTERÍA AMEBIANA"
  },
  {
    "codigo":92842008,
    "descripcion":"FUSIÓN ANORMAL CONGÉNITA DEL CALCÁNEO"
  },
  {
    "codigo":25471001,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DEL OÍDO, SIN INFECCIÓN"
  },
  {
    "codigo":123775005,
    "descripcion":"CARBOXIHEMOGLOBINEMIA"
  },
  {
    "codigo":1336191007,
    "descripcion":"LINFANGIOGRAFÍA FLUOROSCÓPICA CON CONTRASTE ANORMAL"
  },
  {
    "codigo":58239008,
    "descripcion":"RINOLALIA POSTERIOR CERRADA"
  },
  {
    "codigo":254847007,
    "descripcion":"FIBROADENOMA JUVENIL DE MAMA"
  },
  {
    "codigo":449620005,
    "descripcion":"LINFEDEMA DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":447785000,
    "descripcion":"LEIOMIOSARCOMA DE ESTÓMAGO"
  },
  {
    "codigo":285780009,
    "descripcion":"INCAPAZ DE RECONOCER PARTES DEL PROPIO CUERPO"
  },
  {
    "codigo":21801002,
    "descripcion":"SÍNTOMA MENOPÁUSICO"
  },
  {
    "codigo":283945001,
    "descripcion":"LACERACIÓN DE TESTÍCULO"
  },
  {
    "codigo":251177002,
    "descripcion":"CORRIDA DE COMPLEJOS VENTRICULARES PREMATUROS"
  },
  {
    "codigo":54569005,
    "descripcion":"SÍNDROME DE BERNARD SOULIER"
  },
  {
    "codigo":1088651000119102,
    "descripcion":"DERMATITIS DE CONDUCTO AUDITIVO EXTERNO IZQUIERDO"
  },
  {
    "codigo":85502002,
    "descripcion":"HERNIA INGUINAL BILATERAL"
  },
  {
    "codigo":249342004,
    "descripcion":"HALLAZGO EN LA VÍA AÉREA NASAL"
  },
  {
    "codigo":183806006,
    "descripcion":"ESTADÍA DE INTERNACIÓN, 8 DÍAS"
  },
  {
    "codigo":708094006,
    "descripcion":"EXACERBACIÓN AGUDA DE ASMA INTRÍNSECA"
  },
  {
    "codigo":679051000119104,
    "descripcion":"DESPRENDIMIENTO DE MEMBRANA DE DESCEMET DE AMBOS OJOS"
  },
  {
    "codigo":739027004,
    "descripcion":"PIEL TRASPLANTADA PRESENTE"
  },
  {
    "codigo":247507009,
    "descripcion":"ESTRÍAS FISIOLÓGICAS MARRONES EN UÑAS"
  },
  {
    "codigo":704424002,
    "descripcion":"TEMOR A SER UNA CARGA PARA OTROS"
  },
  {
    "codigo":737192005,
    "descripcion":"TRASTORNO DE LA MOTILIDAD DEL INTESTINO DELGADO"
  },
  {
    "codigo":79997005,
    "descripcion":"CALCIFICACIÓN DE BRONQUIO"
  },
  {
    "codigo":768125005,
    "descripcion":"HEPATITIS C CRÓNICA CAUSADA POR GENOTIPO 2 DE VIRUS HEPATITIS C"
  },
  {
    "codigo":1259645006,
    "descripcion":"OSTEOSARCOMA PRIMARIO DE VÉRTEBRA"
  },
  {
    "codigo":373074000,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM THERMORESISTIBILE"
  },
  {
    "codigo":242002003,
    "descripcion":"BAROTRAUMA AUDITIVO DEL ASCENSO"
  },
  {
    "codigo":733522005,
    "descripcion":"SÍNDROME DE MEGALOCÓRNEA CON DISCAPACIDAD INTELECTUAL"
  },
  {
    "codigo":274770006,
    "descripcion":"FOSFATASA ALCALINA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":764455002,
    "descripcion":"SÍNDROME DE ALTERACIÓN COGNITIVA, FACIES TOSCA, DEFECTOS CARDÍACOS, OBESIDAD, COMPROMISO PULMONAR, BAJA ESTATURA Y DISPLASIA ESQUELÉTICA"
  },
  {
    "codigo":698919003,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: SINDHI"
  },
  {
    "codigo":829991004,
    "descripcion":"TEMBLOR EN AMBAS MANOS EXTENDIDAS"
  },
  {
    "codigo":240167004,
    "descripcion":"OSTEOMALACIA SECUNDARIA AL EMBARAZO"
  },
  {
    "codigo":11793701000119104,
    "descripcion":"HERIDA DE PIE DERECHO DEBIDA A PICADURA DE INSECTO NO VENENOSO"
  },
  {
    "codigo":404007006,
    "descripcion":"HISTIOCITOMA CUTÁNEO DE CÉLULAS GRANULOSAS"
  },
  {
    "codigo":402172000,
    "descripcion":"HIPERMELANOSIS DEBIDA A FITOFOTODERMATITIS"
  },
  {
    "codigo":305703009,
    "descripcion":"VISTO POR UN CIRUJANO DE MAMA"
  },
  {
    "codigo":271100003,
    "descripcion":"DEFORMIDAD DE FALANGE DE DEDO DEL PIE"
  },
  {
    "codigo":205564003,
    "descripcion":"ANOMALÍAS CUTÁNEAS PIGMENTARIAS CONGÉNITAS"
  },
  {
    "codigo":762620006,
    "descripcion":"ALUCINACIÓN SOMÁTICA"
  },
  {
    "codigo":1286908009,
    "descripcion":"HEMORRAGIA INTRAVENTRICULAR NO TRAUMÁTICA GRADO 1 DURANTE PERÍODO NEONATAL TEMPRANO"
  },
  {
    "codigo":39889007,
    "descripcion":"POSICIÓN OCCIPITOILÍACA DERECHA ANTERIOR"
  },
  {
    "codigo":365734000,
    "descripcion":"NIVEL SÉRICO DE CARBAMAZEPINA - HALLAZGO"
  },
  {
    "codigo":267430007,
    "descripcion":"GLUCOSURIA DE ORIGEN RENAL"
  },
  {
    "codigo":5286009,
    "descripcion":"AUSENCIA CONGÉNITA DE CONDUCTO DEFERENTE"
  },
  {
    "codigo":167291007,
    "descripcion":"PRUEBA DE CUERPOS CETÓNICOS EN ORINA: =+++"
  },
  {
    "codigo":722512003,
    "descripcion":"RABDOMIOSARCOMA PRIMARIO DE ÓRGANO INTRATORÁCICO"
  },
  {
    "codigo":34384008,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO DE LA PARED DEL TÓRAX"
  },
  {
    "codigo":294693000,
    "descripcion":"ALERGIA A CLOBETASOL"
  },
  {
    "codigo":720677002,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR CANDESARTÁN"
  },
  {
    "codigo":11822681000119102,
    "descripcion":"HERIDA DE AXILA DERECHA DEBIDA A PICADURA DE INSECTO NO VENENOSO"
  },
  {
    "codigo":1144826008,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR TOLAZOLINA"
  },
  {
    "codigo":292858009,
    "descripcion":"REACCIÓN ADVERSA A LA QUININA"
  },
  {
    "codigo":94415002,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA GLÁNDULA SALIVAL MENOR"
  },
  {
    "codigo":1091161000119104,
    "descripcion":"OTITIS MEDIA SEROSANGUINOLENTA CRÓNICA DE OÍDO MEDIO DERECHO"
  },
  {
    "codigo":192719005,
    "descripcion":"ENCEFALITIS POSVACUNACIÓN CONTRA LA PAROTIDITIS URLIANA"
  },
  {
    "codigo":291023005,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR BARBITAL"
  },
  {
    "codigo":127183006,
    "descripcion":"LINFADENOPATÍA PREVESICULAR"
  },
  {
    "codigo":353881000119105,
    "descripcion":"CARCINOMA IN SITU DE PIEL DE OÍDO IZQUIERDO"
  },
  {
    "codigo":92580001,
    "descripcion":"CARCINOMA IN SITU DEL ENDOCÉRVIX"
  },
  {
    "codigo":289188004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CALIDAD DE LA VOZ"
  },
  {
    "codigo":10977011000119100,
    "descripcion":"INTOXICACIÓN CAUSADA POR METANFETAMINA"
  },
  {
    "codigo":190884008,
    "descripcion":"ACIDEMIA RESPIRATORIA"
  },
  {
    "codigo":25209001,
    "descripcion":"DISNEA INSPIRATORIA"
  },
  {
    "codigo":1237625002,
    "descripcion":"ATAXIA CEREBELOSA AUTOSÓMICA RECESIVA POR DEFICIENCIA DE CWF19L1"
  },
  {
    "codigo":285518006,
    "descripcion":"CAPAZ DE MOVER LA PUNTA DE LA LENGUA"
  },
  {
    "codigo":187214007,
    "descripcion":"ACARIASIS"
  },
  {
    "codigo":23374007,
    "descripcion":"CRISIS DE AUSENCIA ATÍPICAS"
  },
  {
    "codigo":709667001,
    "descripcion":"BIOCORROSIÓN DE DIENTE"
  },
  {
    "codigo":283683002,
    "descripcion":"HERIDA POR MORDEDURA DE MAMÍFERO"
  },
  {
    "codigo":54307006,
    "descripcion":"ZOOFOBIA"
  },
  {
    "codigo":1363192001,
    "descripcion":"DIFICULTAD PARA MANTENERSE SENTADO EN ASIENTO PARA INODORO"
  },
  {
    "codigo":609528003,
    "descripcion":"QUISTE ARACNOIDEO DE FOSA POSTERIOR"
  },
  {
    "codigo":871672003,
    "descripcion":"COMPONENTE ATÍPICO DE VENTRÍCULO DERECHO DE VÁLVULA AURICULOVENTRICULAR COMÚN"
  },
  {
    "codigo":83405000,
    "descripcion":"RETINOSQUISIS PLANA"
  },
  {
    "codigo":443853005,
    "descripcion":"TEMBLOR PSICÓGENO"
  },
  {
    "codigo":738765005,
    "descripcion":"METABOLIZADOR INTERMEDIO DE LA FAMILIA 2 SUBFAMILIA B MIEMBRO 6 DEL CITOCROMO P450"
  },
  {
    "codigo":771533007,
    "descripcion":"INFECCIÓN SUPERFICIAL DEL TEJIDO CELULAR SUBCUTÁNEO EN EL LUGAR DEL BLOQUEO NERVIOSO NEUROAXIAL"
  },
  {
    "codigo":17869006,
    "descripcion":"EXCITACIÓN AURICULOVENTRICULAR ANÓMALA"
  },
  {
    "codigo":247245009,
    "descripcion":"PABELLÓN AURICULAR CON MUESCA"
  },
  {
    "codigo":212642001,
    "descripcion":"INTOXICACIÓN POR CARBAMATO"
  },
  {
    "codigo":16034002,
    "descripcion":"MELANOMA, NIVEL 5 DE CLARK"
  },
  {
    "codigo":442018007,
    "descripcion":"PORTADOR DE MUTACIÓN GENÉTICA DE DREPANOCITOSIS"
  },
  {
    "codigo":704162009,
    "descripcion":"FRACTURA NO EXPUESTA DE FALANGE PROXIMAL DE DEDO ÍNDICE"
  },
  {
    "codigo":1259383002,
    "descripcion":"CARCINOMA ESCIRRO PRIMARIO DE MAMA"
  },
  {
    "codigo":79735008,
    "descripcion":"INFECCIÓN CAUSADA POR DREPANIDOTAENIA LANCEOLATA"
  },
  {
    "codigo":702327009,
    "descripcion":"DEFICIENCIA DE TRANSPORTADOR 8 DE MONOCARBOXILATO"
  },
  {
    "codigo":472951008,
    "descripcion":"PARTICIPA EN ACTIVIDAD SEXUAL ANTES DEL MATRIMONIO"
  },
  {
    "codigo":12364003,
    "descripcion":"PROSTATISMO AGRAVADO"
  },
  {
    "codigo":405580006,
    "descripcion":"FÍSTULA AORTOCAVA TRAUMÁTICA"
  },
  {
    "codigo":698657001,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: BRETÓN"
  },
  {
    "codigo":305441001,
    "descripcion":"BAJO ATENCIÓN DE CONSEJERO ESPECIALIZADO EN GENÉTICA"
  },
  {
    "codigo":208972009,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA EXPUESTA DE LA ARTICULACIÓN DE LA RODILLA, INTERNA"
  },
  {
    "codigo":370977006,
    "descripcion":"CONGELAMIENTO"
  },
  {
    "codigo":403745008,
    "descripcion":"SIGNO CUTÁNEO POR TOXICIDAD AGUDA POR ARSÉNICO"
  },
  {
    "codigo":762358000,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO ÓPTICO DERECHO"
  },
  {
    "codigo":895265009,
    "descripcion":"FORMA TRIANGULAR ANORMAL CONGÉNITA DE FALANGE PROXIMAL DE MEÑIQUE"
  },
  {
    "codigo":238070003,
    "descripcion":"DEFICIENCIA DE GLUTARIL-COA OXIDASA"
  },
  {
    "codigo":41462006,
    "descripcion":"ANEMIA POR ALTERACIÓN EN LA PROLIFERACIÓN Y\/O DIFERENCIACIÓN DE LAS CÉLULAS PRECURSORAS ERITROIDES"
  },
  {
    "codigo":301771001,
    "descripcion":"ABSCESO DE GANGLIO LINFÁTICO CERVICAL"
  },
  {
    "codigo":432843002,
    "descripcion":"RECHAZO AGUDO DE TRASPLANTE CARDÍACO"
  },
  {
    "codigo":203467005,
    "descripcion":"QUISTE ÓSEO SOLITARIO"
  },
  {
    "codigo":400075008,
    "descripcion":"URTICARIA GIGANTE"
  },
  {
    "codigo":72395008,
    "descripcion":"ÚLCERA GASTROYEYUNAL AGUDA CON PERFORACIÓN PERO SIN OBSTRUCCIÓN"
  },
  {
    "codigo":725920004,
    "descripcion":"CHOQUE ELÉCTRICO CAUSADO POR RAYO"
  },
  {
    "codigo":299936005,
    "descripcion":"HALLAZGO RELACIONADO CON LA PROPIOCEPCIÓN"
  },
  {
    "codigo":234400004,
    "descripcion":"POLICITEMIA SECUNDARIA SIN EXCESO DE ERITROPOYETINA"
  },
  {
    "codigo":365472006,
    "descripcion":"FAMILIARES SOBREVIVIENTES - HALLAZGO"
  },
  {
    "codigo":429173001,
    "descripcion":"ASTILLA DE MADERA EN REGIÓN ANTERIOR DEL CUELLO"
  },
  {
    "codigo":298101003,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE TOBILLO"
  },
  {
    "codigo":35957005,
    "descripcion":"INFECCIÓN CAUSADA POR SYNGAMUS"
  },
  {
    "codigo":396405007,
    "descripcion":"COMPROMISO DEL ESPÉCIMEN POR TUMOR MACROSCÓPICO NO DETERMINADO"
  },
  {
    "codigo":350456001000119102,
    "descripcion":"SÍNDROME DE DEHISCENCIA DE CONDUCTO SEMICIRCULAR SUPERIOR DE OÍDO IZQUIERDO"
  },
  {
    "codigo":230730001,
    "descripcion":"DISECCIÓN DE ARTERIA VERTEBRAL"
  },
  {
    "codigo":167029007,
    "descripcion":"DIÓXIDO DE CARBONO EN SANGRE ARTERIAL DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1344842003,
    "descripcion":"DISECCIÓN DE AORTA DESCENDENTE TIPO IIIB"
  },
  {
    "codigo":15730881000119103,
    "descripcion":"PARÁLISIS PARCIAL DE AMBOS NERVIOS OCULOMOTORES"
  },
  {
    "codigo":32287002,
    "descripcion":"INTOXICACIÓN POR INHIBIDOR REVERSIBLE DE COLINESTERASA"
  },
  {
    "codigo":11307201000119104,
    "descripcion":"FRACTURA NO EXPUESTA DE ACETÁBULO DERECHO"
  },
  {
    "codigo":720415006,
    "descripcion":"SÍNDROME ACRO-RENO-OCULAR"
  },
  {
    "codigo":294431008,
    "descripcion":"ALERGIA A CLORHEXIDINA"
  },
  {
    "codigo":292596001,
    "descripcion":"REACCIÓN ADVERSA A LA FENIRAMINA"
  },
  {
    "codigo":126921000,
    "descripcion":"NEOPLASIA DE LA VAGINA"
  },
  {
    "codigo":94153001,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL NERVIO ABDUCTOR"
  },
  {
    "codigo":716745004,
    "descripcion":"SÍNDROME DE LIVEDO RETICULARIS Y ACCIDENTE CEREBROVASCULAR"
  },
  {
    "codigo":1306569005,
    "descripcion":"CARCINOMA DUCTAL INFILTRANTE DE CUADRANTE SUPERIOR INTERNO DE MAMA"
  },
  {
    "codigo":421833007,
    "descripcion":"HALLAZGO RELACIONADO CON LA SENSACIÓN DE DOLOR"
  },
  {
    "codigo":92318000,
    "descripcion":"NEOPLASIA BENIGNA DEL RECTO"
  },
  {
    "codigo":290761007,
    "descripcion":"INTOXICACIÓN CON VINBLASTINA"
  },
  {
    "codigo":288926008,
    "descripcion":"PROPULSA EL BOLO ALIMENTARIO HACIA LA FARINGE"
  },
  {
    "codigo":57715001,
    "descripcion":"TRASTORNO DE LA IDENTIDAD SEXUAL EN LA ADOLESCENCIA"
  },
  {
    "codigo":1237363002,
    "descripcion":"COLAPSO DE PULMÓN POR PRESIÓN DEBIDO A ANESTESIA DURANTE TRABAJO DE PARTO Y PARTO"
  },
  {
    "codigo":90483007,
    "descripcion":"DISFONÍA POR CONVERSIÓN"
  },
  {
    "codigo":287091008,
    "descripcion":"LUXACIONES\/ESGUINCES\/DISTENSIONES MUSCULARES"
  },
  {
    "codigo":285256006,
    "descripcion":"CAPAZ DE PENSAR DE MANERA INDEPENDIENTE"
  },
  {
    "codigo":449096009,
    "descripcion":"NEOPLASIA MALIGNA DE APARATO RESPIRATORIO"
  },
  {
    "codigo":840477003,
    "descripcion":"HIPERTROFIA CONGÉNITA DE AMBOS MIEMBROS INFERIORES"
  },
  {
    "codigo":11827701000119101,
    "descripcion":"SUBLUXACIÓN DE ARTICULACIÓN DE RODILLA IZQUIERDA"
  },
  {
    "codigo":283421008,
    "descripcion":"CORTE EN EL TRONCO"
  },
  {
    "codigo":248818003,
    "descripcion":"ULCERACIÓN MAMARIA"
  },
  {
    "codigo":771271000,
    "descripcion":"ENCEFALOPATÍA SENSIBLE A LOS ESTEROIDES ASOCIADA CON TIROIDITIS AUTOINMUNITARIA"
  },
  {
    "codigo":19442009,
    "descripcion":"TALASEMIA HETEROCIGOTA"
  },
  {
    "codigo":1230023005,
    "descripcion":"MEDULOEPITELIOMA INTRAOCULAR BENIGNO"
  },
  {
    "codigo":50375007,
    "descripcion":"DEFECTO DE RESPUESTA DE HORMONA TIROIDEA"
  },
  {
    "codigo":17607008,
    "descripcion":"INFESTACIÓN CAUSADA POR MUSCIDAE"
  },
  {
    "codigo":246983007,
    "descripcion":"ADELGAZAMIENTO FOCAL DE LA ESCLERÓTICA"
  },
  {
    "codigo":212380006,
    "descripcion":"SÍNDROME COMPARTIMENTAL DE BRAZO DEBIDO A LESIÓN TRAUMÁTICA"
  },
  {
    "codigo":81308009,
    "descripcion":"TRASTORNO DEL ENCÉFALO"
  },
  {
    "codigo":13937002,
    "descripcion":"HEMORRAGIA SUBRETINIANA"
  },
  {
    "codigo":112241002,
    "descripcion":"LINFOMA ESTADIO III 1"
  },
  {
    "codigo":276081002,
    "descripcion":"INADAPTACIÓN AL RETIRO"
  },
  {
    "codigo":407153006,
    "descripcion":"LESIÓN TRAUMÁTICA POR ACCIDENTE AUTOMOVILÍSTICO"
  },
  {
    "codigo":1259121008,
    "descripcion":"COMPLEJO DE ESCLEROSIS LATERAL AMIOTRÓFICA, PARKINSONISMO, DEMENCIA DE NUEVA GUINEA OCCIDENTAL"
  },
  {
    "codigo":896838000,
    "descripcion":"FORMA TRIANGULAR ANORMAL CONGÉNITA DE EPÍFISIS DE FALANGE DE MEÑIQUE"
  },
  {
    "codigo":208710000,
    "descripcion":"FRACTURA NO EXPUESTA DE FALANGE PROXIMAL DE DEDO DEL PIE"
  },
  {
    "codigo":15979151000119102,
    "descripcion":"MALFORMACIÓN CONGÉNITA DE HUESECILLOS DE AMBOS OÍDOS"
  },
  {
    "codigo":332431000119103,
    "descripcion":"TELANGIECTASIA DE RETINA DERECHA"
  },
  {
    "codigo":44870007,
    "descripcion":"EX CONSUMIDOR DE DROGAS"
  },
  {
    "codigo":43035002,
    "descripcion":"ÚLCERA DUODENAL DE LA NIÑEZ"
  },
  {
    "codigo":75803007,
    "descripcion":"RINORREA POSNASAL"
  },
  {
    "codigo":403483008,
    "descripcion":"CICATRIZACIÓN VULVOVAGINAL POR CIRCUNCISIÓN RITUAL"
  },
  {
    "codigo":305961000119100,
    "descripcion":"DISCITIS SACROCOCCÍGEA"
  },
  {
    "codigo":237808008,
    "descripcion":"ATROFIA TESTICULAR BILATERAL"
  },
  {
    "codigo":301509001,
    "descripcion":"CAPAZ DE ENTRAR EN LA DUCHA"
  },
  {
    "codigo":235973002,
    "descripcion":"OBSTRUCCIÓN DE CONDUCTO PANCREÁTICO"
  },
  {
    "codigo":10900111000119107,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE CONJUNTIVA DERECHA"
  },
  {
    "codigo":299674000,
    "descripcion":"PÉRDIDA EN PARCHES DEL CABELLO"
  },
  {
    "codigo":1153477009,
    "descripcion":"ALBÚMINA SÉRICA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":135834002,
    "descripcion":"SEUDOPARÁLISIS"
  },
  {
    "codigo":234138005,
    "descripcion":"SÍNDROME DE BANNAYAN"
  },
  {
    "codigo":232303002,
    "descripcion":"DILATACIÓN DEL ACUEDUCTO VESTIBULAR"
  },
  {
    "codigo":428911004,
    "descripcion":"ALIVIO DEL DOLOR AL CAMINAR"
  },
  {
    "codigo":723823004,
    "descripcion":"PARAPLEJÍA ESPÁSTICA AUTOSÓMICA RECESIVA TIPO 53"
  },
  {
    "codigo":363375006,
    "descripcion":"NEOPLASIA MALIGNA DE LENGUA"
  },
  {
    "codigo":263236000,
    "descripcion":"FRACTURA DE CÓNDILO FEMORAL"
  },
  {
    "codigo":230468003,
    "descripcion":"MIGRAÑA CON COMPLICACIÓN ISQUÉMICA"
  },
  {
    "codigo":296004004,
    "descripcion":"SOBREDOSIS INTENCIONAL DE FENITOÍNA"
  },
  {
    "codigo":294169006,
    "descripcion":"ALERGIA A ALQUITRÁN DE HULLA"
  },
  {
    "codigo":292334000,
    "descripcion":"REACCIÓN ADVERSA A LA CLORMEZANONA"
  },
  {
    "codigo":95726001,
    "descripcion":"CICATRIZ CORNEAL"
  },
  {
    "codigo":1177070000,
    "descripcion":"DUODENITIS POR STRONGYLOIDES"
  },
  {
    "codigo":128494003,
    "descripcion":"RUPTURA DE MÚSCULO LISO"
  },
  {
    "codigo":1144302003,
    "descripcion":"EN RIESGO DE HEMORRAGIA DEBIDO A METABOLIZADOR RÁPIDO DE LA SUBUNIDAD 1 DEL COMPLEJO VITAMINA K-EPÓXIDO REDUCTASA"
  },
  {
    "codigo":16745411000119104,
    "descripcion":"RETINOPATÍA NO PROLIFERATIVA LEVE BILATERAL POR DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":716483004,
    "descripcion":"DIFICULTAD PARA COMPRENDER INSTRUCCIONES DE DOS PALABRAS"
  },
  {
    "codigo":1306307006,
    "descripcion":"BLOQUEO PUPILAR BILATERAL"
  },
  {
    "codigo":421571007,
    "descripcion":"TUBERCULOSIS CON SIDA (SÍNDROME DE INMUNODEFICIENCIA ADQUIRIDA)"
  },
  {
    "codigo":93891008,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL MEDIASTINO"
  },
  {
    "codigo":59288004,
    "descripcion":"INFESTACIÓN CAUSADA POR HYALOMMA"
  },
  {
    "codigo":92056006,
    "descripcion":"NEOPLASIA BENIGNA DEL CUELLO UTERINO"
  },
  {
    "codigo":288664007,
    "descripcion":"CAPAZ DE MANTENER UNA CONVERSACIÓN"
  },
  {
    "codigo":26520008,
    "descripcion":"INFARTO DEL NERVIO ÓPTICO"
  },
  {
    "codigo":254061001,
    "descripcion":"ACONDROGÉNESIS, TIPO II"
  },
  {
    "codigo":286829006,
    "descripcion":"TIENDE A TOMAR UNA POSTURA DE INDIFERENCIA ANTE LA ALABANZA O LA CRÍTICA"
  },
  {
    "codigo":90221009,
    "descripcion":"INFECCIÓN CAUSADA POR LIGULA"
  },
  {
    "codigo":448834003,
    "descripcion":"DEFICIENCIA DE LIPOPROTEÍNAS DE ALTA DENSIDAD"
  },
  {
    "codigo":88386004,
    "descripcion":"ANOMALÍA CONGÉNITA DEL DIAFRAGMA"
  },
  {
    "codigo":284994005,
    "descripcion":"SE QUITA EL CALZADO"
  },
  {
    "codigo":1004055000,
    "descripcion":"CONTRACTURA EN FLEXIÓN DE ARTICULACIÓN INTERFALÁNGICA DISTAL DE SEGUNDO DEDO DE PIE"
  },
  {
    "codigo":53783003,
    "descripcion":"SÍNDROME DE ROWLEY - ROSENBERG"
  },
  {
    "codigo":709143008,
    "descripcion":"NEUROPATÍA PERIFÉRICA CAUSADA POR TOXINA"
  },
  {
    "codigo":283159009,
    "descripcion":"CUERPO EXTRAÑO METÁLICO EN LA MUÑECA"
  },
  {
    "codigo":19180002,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DEL BRAZO"
  },
  {
    "codigo":838380002,
    "descripcion":"HEPATITIS B CRÓNICA CONCOMITANTE CON HEPATITIS C Y HEPATITIS D"
  },
  {
    "codigo":250391008,
    "descripcion":"TIPO ANTIGÉNICO KIDD"
  },
  {
    "codigo":248556007,
    "descripcion":"SOFOCACIÓN DURANTE LA RESPIRACIÓN"
  },
  {
    "codigo":281324008,
    "descripcion":"DETALLES DEL PEDIDO, ILEGIBLES"
  },
  {
    "codigo":707308007,
    "descripcion":"CRIBADO DE TUBERCULOSIS MEDIANTE RADIOGRAFÍA SIMPLE DE TÓRAX, NORMAL"
  },
  {
    "codigo":117484009,
    "descripcion":"CRISTAL URINARIO, FOSFATO DE CALCIO, FORMA CARBONATO"
  },
  {
    "codigo":16037111000119101,
    "descripcion":"DETENCIÓN PARCIAL DE CRECIMIENTO EPIFISARIO DE AMBOS RADIOS DISTALES"
  },
  {
    "codigo":17345001,
    "descripcion":"INTOXICACIÓN POR NORBORMIDE"
  },
  {
    "codigo":445164007,
    "descripcion":"TIEMPO DE COAGULACIÓN POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1264364008,
    "descripcion":"ADENOCARCINOMA CERUMINOSO DE PIEL METASTÁSICO"
  },
  {
    "codigo":48278001,
    "descripcion":"CISTITIS DIFTÉRICA"
  },
  {
    "codigo":212118004,
    "descripcion":"QUEMADURA QUE COMPROMETE MÁS DEL 90 POR CIENTO DE LA SUPERFICIE CORPORAL, CON 20 - 29 POR CIENTO DE SUPERFICIE CORPORAL CON QUEMADURA DE TERCER GRADO"
  },
  {
    "codigo":111979000,
    "descripcion":"QUERATINIZACIÓN DISMINUIDA"
  },
  {
    "codigo":15510009,
    "descripcion":"FRECUENCIA DE DEFECACIÓN AUMENTADA"
  },
  {
    "codigo":277654008,
    "descripcion":"LINFOMA DE CÉLULAS T ASOCIADO A ENTEROPATÍA"
  },
  {
    "codigo":29331000175101,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN EN REGIÓN SACRA DE ESPALDA ESTADIO I"
  },
  {
    "codigo":243051008,
    "descripcion":"LESIÓN POR ESPADA"
  },
  {
    "codigo":273984003,
    "descripcion":"PROBLEMA DEL PARTO QUE AFECTA AL FETO"
  },
  {
    "codigo":372288004,
    "descripcion":"INVASIÓN TUMORAL LOCAL"
  },
  {
    "codigo":1171000175109,
    "descripcion":"ACTIVIDAD FÍSICA AUMENTADA"
  },
  {
    "codigo":77376005,
    "descripcion":"EDEMA GESTACIONAL SIN HIPERTENSIÓN"
  },
  {
    "codigo":11840006,
    "descripcion":"DIARREA DEL VIAJERO"
  },
  {
    "codigo":110144005,
    "descripcion":"LACERACIÓN SIMPLE DEL CUELLO"
  },
  {
    "codigo":208448009,
    "descripcion":"FRACTURA NO EXPUESTA DE FALANGE PROXIMAL DE DEDO DE LA MANO, CABEZA"
  },
  {
    "codigo":1156885001,
    "descripcion":"COMPOSICIÓN DE INGESTA NUTRICIONAL COMPATIBLE CON EL REQUERIMIENTO"
  },
  {
    "codigo":763669001,
    "descripcion":"ATAXIA ESPÁSTICA CON MIOSIS CONGÉNITA"
  },
  {
    "codigo":1255189004,
    "descripcion":"ESTENOSIS DE ARTERIA CORONARIA CIRCUNFLEJA POSTERIOR DESCENDENTE IZQUIERDA"
  },
  {
    "codigo":403221005,
    "descripcion":"FOTOTIPO CUTÁNEO I (SIEMPRE SE QUEMA Y NUNCA SE BRONCEA)"
  },
  {
    "codigo":1220586000,
    "descripcion":"INTERRUPCIÓN INDUCIDA DEL EMBARAZO INCOMPLETA COMPLICADA POR INSUFICIENCIA RENAL"
  },
  {
    "codigo":75541008,
    "descripcion":"EXPULSIÓN CAPSULAR DE LA CORTEZA SUPRARRENAL"
  },
  {
    "codigo":73706008,
    "descripcion":"GRITO EPILÉPTICO"
  },
  {
    "codigo":303082009,
    "descripcion":"GASTROPATÍA HIPERTENSIVA PORTAL"
  },
  {
    "codigo":268479002,
    "descripcion":"PLACENTA INCOMPLETA AL MOMENTO DEL ALUMBRAMIENTO"
  },
  {
    "codigo":237546008,
    "descripcion":"GLOBULINA FIJADORA DE HORMONA TIROIDEA ELEVADA"
  },
  {
    "codigo":202943004,
    "descripcion":"GANGLIÓN DE LA RODILLA"
  },
  {
    "codigo":170175004,
    "descripcion":"EXAMEN DEL NIÑO A LOS 10 AÑOS ANORMAL - EN TRATAMIENTO"
  },
  {
    "codigo":301247007,
    "descripcion":"NO ELIMINA EL ESPUTO"
  },
  {
    "codigo":299412000,
    "descripcion":"HALLAZGO RELACIONADO CON LA ESTRUCTURA DE LA RÓTULA"
  },
  {
    "codigo":364948000,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA ABRIR Y CERRAR LA BOCA"
  },
  {
    "codigo":201108001,
    "descripcion":"UÑA DE PRIMER DEDO DE PIE ENCARNADA"
  },
  {
    "codigo":37268004,
    "descripcion":"HIDROCELE DEL CORDÓN ESPERMÁTICO"
  },
  {
    "codigo":70036007,
    "descripcion":"NEUMONÍA POR HAEMOPHILUS INFLUENZAE"
  },
  {
    "codigo":461417000,
    "descripcion":"OCLUSIÓN ADQUIRIDA DE SENO CORONARIO"
  },
  {
    "codigo":232041003,
    "descripcion":"NEOVASCULARIZACIÓN OCULAR DEBIDA A OCLUSIÓN DE VENA CENTRAL DE LA RETINA DE NIÑEZ"
  },
  {
    "codigo":789097007,
    "descripcion":"AGENESIA DE ARTERIA"
  },
  {
    "codigo":426814001,
    "descripcion":"ISQUEMIA CEREBRAL TRANSITORIA POR FIBRILACIÓN AURICULAR"
  },
  {
    "codigo":361278002,
    "descripcion":"FLEBITIS DE MONDOR DEL PENE"
  },
  {
    "codigo":230206004,
    "descripcion":"ABSCESO PIÓGENO SUBDURAL SUPRATENTORIAL"
  },
  {
    "codigo":721726006,
    "descripcion":"INCONTINENCIA FECAL NO RETENTIVA"
  },
  {
    "codigo":197438007,
    "descripcion":"COLANGITIS LENTA"
  },
  {
    "codigo":719891000,
    "descripcion":"PROBLEMA CON INMOVILIZADOR DE FIBRA DE VIDRIO"
  },
  {
    "codigo":64531003,
    "descripcion":"SECRECIÓN NASAL"
  },
  {
    "codigo":228371004,
    "descripcion":"USUARIO DE FÁRMACOS DE MANERA INDEBIDA POR UN PERÍODO PROLONGADO"
  },
  {
    "codigo":43471000087101,
    "descripcion":"HERIDA ABIERTA DE PÁRPADO INFERIOR DERECHO"
  },
  {
    "codigo":46031000087102,
    "descripcion":"ESGUINCE DE LIGAMENTO CORACOHUMERAL IZQUIERDO"
  },
  {
    "codigo":457747007,
    "descripcion":"RUPTURA DE CUERDAS TENDINOSAS DE VÁLVULA AURICULOVENTRICULAR DERECHA (MORFOLÓGICAMENTE NO TRICÚSPIDE)"
  },
  {
    "codigo":128232000,
    "descripcion":"TRASTORNO DEL VÓMER"
  },
  {
    "codigo":48591000087105,
    "descripcion":"ESGUINCE DE LIGAMENTO SACROTUBERAL DERECHO"
  },
  {
    "codigo":292072001,
    "descripcion":"REACCIÓN ADVERSA AL ETODOLAC"
  },
  {
    "codigo":95464003,
    "descripcion":"AUSENCIA CONGÉNITA DE LA BÓVEDA CRANEAL"
  },
  {
    "codigo":56271000087107,
    "descripcion":"DIFICULTAD PARA COMUNICARSE DEBIDA A LARINGECTOMÍA Y POSTERIOR A ELLA"
  },
  {
    "codigo":40911000087108,
    "descripcion":"QUEMADURA DE CADERA IZQUIERDA"
  },
  {
    "codigo":29928006,
    "descripcion":"INSUFICIENCIA CONGÉNITA DE VÁLVULA MITRAL"
  },
  {
    "codigo":423144007,
    "descripcion":"ENCEFALOPATÍA MULTIFACTORIAL"
  },
  {
    "codigo":93629000,
    "descripcion":"FALTA DE OSIFICACIÓN DE CENTRO DE VÉRTEBRA CERVICAL"
  },
  {
    "codigo":28093001,
    "descripcion":"DEFICIENCIA DE METILENO THF REDUCTASA Y HOMOCISTINURIA"
  },
  {
    "codigo":1142205000,
    "descripcion":"FASCITIS NECROSANTE NEONATAL ESTREPTOCÓCICA"
  },
  {
    "codigo":310981000119101,
    "descripcion":"DERRAME INTERMITENTE DE ARTICULACIÓN DE CODO DERECHO"
  },
  {
    "codigo":38351000087109,
    "descripcion":"HIPOCINESIA DE SEGMENTO ANTEROLATERAL MEDIO DE VENTRÍCULO CARDÍACO IZQUIERDO"
  },
  {
    "codigo":337451000119106,
    "descripcion":"DESPRENDIMIENTO TOTAL DE RETINA IZQUIERDA"
  },
  {
    "codigo":15630021000119102,
    "descripcion":"DOLOR INGUINAL BILATERAL"
  },
  {
    "codigo":419474003,
    "descripcion":"ALERGIA A MOHO"
  },
  {
    "codigo":288402003,
    "descripcion":"ABRE Y CIERRA ENVASES"
  },
  {
    "codigo":59026006,
    "descripcion":"BLEFAROSPASMO"
  },
  {
    "codigo":286567002,
    "descripcion":"CUERPO EXTRAÑO EN LA CAVIDAD BUCAL Y GLÁNDULAS SALIVALES"
  },
  {
    "codigo":253799007,
    "descripcion":"DUPLICACIÓN PARCIAL DE APÉNDICE ILEOCECAL"
  },
  {
    "codigo":1235004000,
    "descripcion":"LINFADENITIS POR TOXOPLASMA"
  },
  {
    "codigo":188263008,
    "descripcion":"NEOPLASIA MALIGNA DE CUERPO CILIAR"
  },
  {
    "codigo":1290801000000102,
    "descripcion":"ENCEFALOPATÍA CAUSADA POR VIRUS DE VIRUELA SÍMICA"
  },
  {
    "codigo":1075761000000103,
    "descripcion":"INCAPAZ DE ESTABLECER OBJETIVOS PERSONALES"
  },
  {
    "codigo":282897003,
    "descripcion":"ALTERNA ENTRE SENTARSE Y PARARSE"
  },
  {
    "codigo":20753005,
    "descripcion":"CARDIOPATÍA HIPERTENSIVA QUE COMPLICA EL EMBARAZO Y\/O CONSTITUYE UN MOTIVO DE ATENCIÓN DURANTE ESTE PERÍODO"
  },
  {
    "codigo":250129007,
    "descripcion":"ARTRITIS DE ARTICULACIÓN GRANDE"
  },
  {
    "codigo":444902000,
    "descripcion":"ESPÉCIMEN COMPROMETIDO POR INVASIÓN MULTIFOCAL"
  },
  {
    "codigo":1296870004,
    "descripcion":"COLOR MARRÓN DE HECES"
  },
  {
    "codigo":1264102004,
    "descripcion":"TRASTORNO FETAL CAUSADO POR TRANSFERENCIA PLACENTARIA DE ANTICOAGULANTE"
  },
  {
    "codigo":248294006,
    "descripcion":"PATRÓN ESQUELÉTICO FACIAL CLASE III"
  },
  {
    "codigo":1293200002,
    "descripcion":"INSUFICIENCIA RENAL AGUDA PARENQUIMATOSA"
  },
  {
    "codigo":111717002,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO DE PARED DEL TÓRAX"
  },
  {
    "codigo":11835231000119107,
    "descripcion":"SUBLUXACIÓN DE PULGAR DERECHO"
  },
  {
    "codigo":699706000,
    "descripcion":"EMBOLIA DE ARTERIA CEREBRAL MEDIA"
  },
  {
    "codigo":109882003,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL FONDO UTERINO"
  },
  {
    "codigo":11578004,
    "descripcion":"INVAGINACIÓN DE RECTO"
  },
  {
    "codigo":372026006,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE BORDE BERMELLÓN DE LABIO INFERIOR"
  },
  {
    "codigo":208186009,
    "descripcion":"FRACTURA-LUXACIÓN NO EXPUESTA DE LA ARTICULACIÓN SACROILÍACA"
  },
  {
    "codigo":402959002,
    "descripcion":"LEPTOSPIROSIS CON COMPROMISO CUTÁNEO"
  },
  {
    "codigo":187059008,
    "descripcion":"HISTOPLASMOSIS CON PERICARDITIS"
  },
  {
    "codigo":1254927005,
    "descripcion":"INFECCIÓN DE PIEL DEBIDA A PROCEDIMIENTO LÁSER EN PIEL Y POSTERIOR A ÉL"
  },
  {
    "codigo":304655008,
    "descripcion":"CAPAZ DE EMPLEAR RAZONAMIENTO VISUOESPACIAL"
  },
  {
    "codigo":763407008,
    "descripcion":"SÍNDROME DE CROMOSOMA Y EN ANILLO"
  },
  {
    "codigo":827108008,
    "descripcion":"LUXACIÓN DE DÍGITO DE MANO"
  },
  {
    "codigo":302820008,
    "descripcion":"MENINGIOMA INTRACRANEAL"
  },
  {
    "codigo":399289002,
    "descripcion":"FALLA EN EL CRECIMIENTO DEL PELO"
  },
  {
    "codigo":366521005,
    "descripcion":"AMPLITUD DE MOVIMIENTO DE ARTICULACIÓN DE MUÑECA - HALLAZGO"
  },
  {
    "codigo":169913006,
    "descripcion":"PUNTAJE DE APGAR A LOS 5 MINUTOS = 3"
  },
  {
    "codigo":168078000,
    "descripcion":"CÁLCULO: BILIRRUBINA"
  },
  {
    "codigo":233614003,
    "descripcion":"MUCORMICOSIS PULMONAR"
  },
  {
    "codigo":313491000119103,
    "descripcion":"HIPERLORDOSIS DE COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":397454008,
    "descripcion":"INFECCIÓN CAUSADA POR CORYNEBACTERIUM JEIKEIUM"
  },
  {
    "codigo":35171003,
    "descripcion":"LUXACIÓN EXPUESTA DEL ASTRÁGALO"
  },
  {
    "codigo":2403008,
    "descripcion":"DEPENDENCIA DE SUSTANCIA PSICOACTIVA"
  },
  {
    "codigo":568005,
    "descripcion":"TRASTORNO DE TICS"
  },
  {
    "codigo":262712006,
    "descripcion":"SECCIÓN DE MÉDULA ESPINAL DORSAL"
  },
  {
    "codigo":295480006,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE FENOLFTALEÍNA"
  },
  {
    "codigo":197176008,
    "descripcion":"ABSCESO SUBPERITONEAL"
  },
  {
    "codigo":293645001,
    "descripcion":"ALERGIA A DICITRATO DE BISMUTO TRIPOTÁSICO"
  },
  {
    "codigo":721464009,
    "descripcion":"SÍNDROME DEL CORDÓN ANTERIOR DE MÉDULA ESPINAL AL NIVEL DEL NOVENO SEGMENTO DORSAL"
  },
  {
    "codigo":195341003,
    "descripcion":"EMBOLIA Y TROMBOSIS DE LA ARTERIA AXILAR"
  },
  {
    "codigo":66104007,
    "descripcion":"OPACIDAD MENOR DE LA CÓRNEA"
  },
  {
    "codigo":15632531000119107,
    "descripcion":"SÍNDROME DE DISFUNCIÓN DOLOROSA DE LA ARTICULACIÓN TEMPOROMANDIBULAR, BILATERAL"
  },
  {
    "codigo":426552009,
    "descripcion":"DEFECTO PERIODONTAL INTRAÓSEO"
  },
  {
    "codigo":64269007,
    "descripcion":"ALUCINACIÓN VISUAL"
  },
  {
    "codigo":129805008,
    "descripcion":"HALLAZGO DE UNA DIFERENCIA TEMPORAL EN LA MAMOGRAFÍA"
  },
  {
    "codigo":291810002,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR CLORPROPAMIDA"
  },
  {
    "codigo":160738002,
    "descripcion":"VIVE EN UN HOGAR INFANTIL"
  },
  {
    "codigo":95202004,
    "descripcion":"COLOBOMA DE PÁRPADO"
  },
  {
    "codigo":224439000,
    "descripcion":"COMODIDAD DE LAS INSTALACIONES EN EL LUGAR DE TRABAJO, ADECUADA"
  },
  {
    "codigo":422882009,
    "descripcion":"VISIÓN A DISTANCIA 20\/50"
  },
  {
    "codigo":289975003,
    "descripcion":"INCAPAZ DE REALIZAR ACTIVIDADES DE CUIDADO DE LAS UÑAS"
  },
  {
    "codigo":421047005,
    "descripcion":"CANDIDIASIS PULMONAR ASOCIADA CON SIDA (SÍNDROME DE INMUNODEFICIENCIA ADQUIRIDA)"
  },
  {
    "codigo":93367007,
    "descripcion":"ROTACIÓN ANÓMALA CONGÉNITA DE MIEMBRO"
  },
  {
    "codigo":58764007,
    "descripcion":"OSTEOMIELITIS TUBERCULOSA"
  },
  {
    "codigo":124300009,
    "descripcion":"DEFICIENCIA DE FRUCTOCINASA"
  },
  {
    "codigo":253537005,
    "descripcion":"HIPOPLASIA DIFUSA DEL VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":368941000119108,
    "descripcion":"NEFROPATÍA HEREDITARIA CONCOMITANTE CON GLOMERULONEFRITIS MEMBRANOPROLIFERATIVA TIPO III"
  },
  {
    "codigo":448310003,
    "descripcion":"OBSTRUCCIÓN AL TRACTO DE SALIDA DE VENTRÍCULO DERECHO DEBIDA A TABIQUE DE SALIDA MAL ALINEADO"
  },
  {
    "codigo":251702004,
    "descripcion":"REFLUJO LAGRIMAL ACUOSO"
  },
  {
    "codigo":284470004,
    "descripcion":"CONTRACCIÓN AURICULAR PREMATURA"
  },
  {
    "codigo":315403003,
    "descripcion":"NACIDO EN CHILE"
  },
  {
    "codigo":282635005,
    "descripcion":"NO RUEDA SOBRE SÍ MISMO"
  },
  {
    "codigo":20491006,
    "descripcion":"BARRA CALCANEONAVICULAR"
  },
  {
    "codigo":1167371007,
    "descripcion":"SÍNDROME DE POLIHIDRAMNIOS, MEGALENCEFALIA Y EPILEPSIA SINTOMÁTICA"
  },
  {
    "codigo":96711000119105,
    "descripcion":"CARDIOPATÍA HIPERTENSIVA Y ENFERMEDAD RENAL CRÓNICA, ESTADIO 5"
  },
  {
    "codigo":774155009,
    "descripcion":"SÍNDROME DE BAJA ESTATURA, ATRESIA DE CONDUCTO AUDITIVO, HIPOPLASIA MANDIBULAR Y ANOMALÍAS ESQUELÉTICAS"
  },
  {
    "codigo":1362144005,
    "descripcion":"CONDUCTO RADICULAR DE DIENTE CON FORMA DE C"
  },
  {
    "codigo":18656007,
    "descripcion":"GRAN MULTÍPARA"
  },
  {
    "codigo":49589000,
    "descripcion":"ENFERMEDAD POR EL VIRUS TACARIBE"
  },
  {
    "codigo":410037001,
    "descripcion":"EXAMEN DEL LÍQUIDO AMNIÓTICO, ANORMAL"
  },
  {
    "codigo":735882003,
    "descripcion":"LUXACIÓN TRAUMÁTICA DE ARTICULACIÓN INTERFALÁNGICA DE DEDO GORDO DEL PIE"
  },
  {
    "codigo":13151001,
    "descripcion":"BISINOSIS POR LINO"
  },
  {
    "codigo":766815007,
    "descripcion":"MIOCLONÍA PERIORAL CON AUSENCIAS"
  },
  {
    "codigo":10965601000119105,
    "descripcion":"HERIDA POR ARMA BLANCA DE REGIÓN DE CADERA IZQUIERDA"
  },
  {
    "codigo":373599008,
    "descripcion":"QUISTES RENALES ADQUIRIDOS MÚLTIPLES"
  },
  {
    "codigo":240692002,
    "descripcion":"SITI"
  },
  {
    "codigo":11316005,
    "descripcion":"GRANULOMA DE LAS CUERDAS VOCALES"
  },
  {
    "codigo":109620006,
    "descripcion":"FIBROMATOSIS GINGIVAL HEREDITARIA"
  },
  {
    "codigo":207924006,
    "descripcion":"FRACTURA EXPUESTA DEL ATLAS, ESPONDILÓLISIS"
  },
  {
    "codigo":699444008,
    "descripcion":"SIALORREA PAROXÍSTICA IDIOPÁTICA"
  },
  {
    "codigo":402697000,
    "descripcion":"INFECCIÓN DE OÍDO EXTERNO"
  },
  {
    "codigo":1254665001,
    "descripcion":"ESTENOSIS DE RAMA SEPTAL DE RAMA DESCENDENTE ANTERIOR DE ARTERIA CORONARIA IZQUIERDA"
  },
  {
    "codigo":75017004,
    "descripcion":"INTOXICACIÓN POR PARAQUAT"
  },
  {
    "codigo":238857008,
    "descripcion":"PAQUIDERMODACTILIA"
  },
  {
    "codigo":11784801000119109,
    "descripcion":"AMPOLLA TRAUMÁTICA DE SEGUNDO A QUINTO DEDO DE PIE IZQUIERDO"
  },
  {
    "codigo":366259001,
    "descripcion":"SENSACIÓN GASTROINTESTINAL - HALLAZGO"
  },
  {
    "codigo":107881000119100,
    "descripcion":"COLAPSO AVANZADO DE ARTICULACIÓN ESCAFOSEMILUNAR DEBIDO A ARTROSIS"
  },
  {
    "codigo":15698281000119101,
    "descripcion":"OSTEÍTIS DE FÉMUR IZQUIERDO"
  },
  {
    "codigo":2921000119101,
    "descripcion":"ASTIGMATISMO IRREGULAR POSOPERATORIO"
  },
  {
    "codigo":72041000119103,
    "descripcion":"OSTEOMIELITIS DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":169651008,
    "descripcion":"AMNIOCENTESIS PRENATAL - PENDIENTE"
  },
  {
    "codigo":313377641000119105,
    "descripcion":"FIBRILACIÓN AURICULAR DEBIDA A TRASTORNO DE VÁLVULA CARDÍACA"
  },
  {
    "codigo":1080681000119106,
    "descripcion":"LIPOSARCOMA PRIMARIO DE PARTES BLANDAS DE EXTREMIDAD SUPERIOR IZQUIERDA"
  },
  {
    "codigo":15685481000119107,
    "descripcion":"RETINITIS SIFILÍTICA DERECHA"
  },
  {
    "codigo":1085801000119106,
    "descripcion":"ABSCESO DE INTESTINO CONCOMITANTE CON ENFERMEDAD DE CROHN DE INTESTINO DELGADO Y GRUESO Y DEBIDO A ELLA"
  },
  {
    "codigo":16415081000119104,
    "descripcion":"TAQUICARDIA SUPRAVENTRICULAR POSTERIOR A INFARTO AGUDO DE MIOCARDIO"
  },
  {
    "codigo":10742121000119104,
    "descripcion":"ASMA EN LA MADRE COMO COMPLICACIÓN DEL NACIMIENTO"
  },
  {
    "codigo":310121000119103,
    "descripcion":"GOTA PRIMARIA CRÓNICA DE MUÑECA, SIN TOFO"
  },
  {
    "codigo":16520041000119104,
    "descripcion":"FENESTRACIÓN CONGÉNITA DE ARTERIA BASILAR"
  },
  {
    "codigo":15723881000119108,
    "descripcion":"HIPERTROFIA DE MEMBRANA SINOVIAL DE ARTICULACIÓN DE AMBOS TOBILLOS"
  },
  {
    "codigo":16279401000119108,
    "descripcion":"OCLUSIÓN DE ARTERIA CILIORRETINIANA DERECHA"
  },
  {
    "codigo":322921000119109,
    "descripcion":"DEDO ANULAR IZQUIERDO EN GATILLO ADQUIRIDO"
  },
  {
    "codigo":10757481000119107,
    "descripcion":"CARDIOPATÍA HIPERTENSIVA Y ENFERMEDAD RENAL CRÓNICA HIPERTENSIVA MATERNA PREEXISTENTES QUE COMPLICAN EL EMBARAZO"
  },
  {
    "codigo":15703401000119109,
    "descripcion":"DEDO DE LA MANO EN GATILLO ADQUIRIDO, AMBOS DEDOS ANULARES"
  },
  {
    "codigo":298888009,
    "descripcion":"AMPLITUD DE FLEXIÓN PASIVA DE CODO DISMINUIDA"
  },
  {
    "codigo":297053006,
    "descripcion":"SOBREDOSIS DE INHIBIDORES DE LA ENZIMA CONVERTIDORA DE ANGIOTENSINA"
  },
  {
    "codigo":231517009,
    "descripcion":"DISFUNCIÓN AUTÓNOMA SOMATOMORFA"
  },
  {
    "codigo":459058002,
    "descripcion":"ENDOCARDITIS INFECCIOSA DE HOMOINJERTO"
  },
  {
    "codigo":229682005,
    "descripcion":"DISLEXIA SUPERFICIAL"
  },
  {
    "codigo":295218008,
    "descripcion":"SOBREDOSIS DE ACEMETACINA"
  },
  {
    "codigo":162311003,
    "descripcion":"PESADEZ EN LA CABEZA"
  },
  {
    "codigo":293383005,
    "descripcion":"REACCIÓN ADVERSA A LOS PRODUCTOS VITAMÍNICOS"
  },
  {
    "codigo":424455005,
    "descripcion":"FRACTURA PATOLÓGICA DE CLAVÍCULA"
  },
  {
    "codigo":94940000,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE MÚSCULO DE LAS NALGAS"
  },
  {
    "codigo":224177000,
    "descripcion":"INGRESO PERSONAL ALTO"
  },
  {
    "codigo":1010609002,
    "descripcion":"DISPLASIA MESOMÉLICA DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":93105006,
    "descripcion":"FALTA DE OSIFICACIÓN DE HUESO LAGRIMAL"
  },
  {
    "codigo":124038001,
    "descripcion":"CEROIDE AUMENTADO"
  },
  {
    "codigo":255110003,
    "descripcion":"ADENOCARCINOMA DE VEJIGA URINARIA"
  },
  {
    "codigo":1303686004,
    "descripcion":"QUISTE ÓSEO ANEURISMÁTICO DE PERONÉ"
  },
  {
    "codigo":10830741000119109,
    "descripcion":"FRACTURA EXPUESTA EN MARTILLO DE FALANGE DISTAL DE DEDO ANULAR DE MANO DERECHA"
  },
  {
    "codigo":1172614008,
    "descripcion":"HORMONA FETOPLACENTARIA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":713862009,
    "descripcion":"DEPENDENCIA DE ALCOHOL, SEVERA"
  },
  {
    "codigo":286043002,
    "descripcion":"INCAPAZ DE CLASIFICAR LA ROPA SUCIA"
  },
  {
    "codigo":16047151000119104,
    "descripcion":"ENFERMEDAD POR DEPÓSITO DE HIDROXIAPATITA DE AMBAS CADERAS"
  },
  {
    "codigo":253275006,
    "descripcion":"COMUNICACIÓN AURICULOVENTRICULAR ANORMAL-BIVENTRICULAR"
  },
  {
    "codigo":1269083008,
    "descripcion":"TRASTORNO FETAL Y\/O MATERNO DURANTE TRABAJO DE PARTO"
  },
  {
    "codigo":251440000,
    "descripcion":"HALLAZGO NEUROELECTROFISIOLÓGICO"
  },
  {
    "codigo":417115008,
    "descripcion":"COROIDITIS CAUSADA POR ORGANISMO DEL GRUPO MYCOBACTERIUM AVIUM INTRACELLULARE"
  },
  {
    "codigo":415280004,
    "descripcion":"DERIVADO DE CENTRO DE DEMANDA ESPONTÁNEA"
  },
  {
    "codigo":284208008,
    "descripcion":"QUEMADURA SUPERFICIAL DEL CUELLO POR AGENTE CORROSIVO"
  },
  {
    "codigo":22064009,
    "descripcion":"PINTA"
  },
  {
    "codigo":413445002,
    "descripcion":"ADENOCARCINOMA DE APÉNDICE ILEOCECAL"
  },
  {
    "codigo":446213006,
    "descripcion":"CAPAZ DE PARTICIPAR EN ACTIVIDADES ESCOLARES"
  },
  {
    "codigo":1263578000,
    "descripcion":"PRODUCCIÓN DE LÍQUIDO CEFALORRAQUÍDEO AUMENTADA DEBIDA A CARCINOMA DE PLEXO COROIDEO"
  },
  {
    "codigo":110259006,
    "descripcion":"CONTUSIÓN DEL PALADAR DURO"
  },
  {
    "codigo":216837008,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR GASES DE TRACTORES DETENIDOS"
  },
  {
    "codigo":444378009,
    "descripcion":"DISPUESTO A SER DONANTE DE PÁNCREAS"
  },
  {
    "codigo":292041000119104,
    "descripcion":"NEUROPATÍA POR COMPRESIÓN DE NERVIO CIÁTICO POPLÍTEO EXTERNO IZQUIERDO"
  },
  {
    "codigo":213167005,
    "descripcion":"FALLA PARCIAL DE REIMPLANTE DE ANTEBRAZO"
  },
  {
    "codigo":442543009,
    "descripcion":"INFECCIÓN CAUSADA POR COCCIDIOIDES IMMITIS"
  },
  {
    "codigo":276868005,
    "descripcion":"RUPTURA DE ANASTOMOSIS UROLÓGICA"
  },
  {
    "codigo":735620006,
    "descripcion":"PIOMETRA CONCOMITANTE CON ENFERMEDAD INFLAMATORIA CRÓNICA DEL ÚTERO Y DEBIDA A ELLA"
  },
  {
    "codigo":211332006,
    "descripcion":"ABRASIÓN DE PIEL RODILLA"
  },
  {
    "codigo":897625001,
    "descripcion":"FORMA TRIANGULAR ANORMAL CONGÉNITA DE EPÍFISIS DE FALANGE DE CUARTO DEDO DE PIE"
  },
  {
    "codigo":406105002,
    "descripcion":"VIRUS DE HEPATITIS C NO DETECTADO POR ENSAYO INMUNOABSORBENTE LIGADO A ENZIMAS"
  },
  {
    "codigo":402435000,
    "descripcion":"ESPONGIOSIS EOSINOFÍLICA (PÉNFIGO PREBULLOSO)"
  },
  {
    "codigo":369667000,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA DE PLEURA Y PERICARDIO, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":302296000,
    "descripcion":"DEFORMIDAD EN DORSIFLEXIÓN ADQUIRIDA DEL PIE"
  },
  {
    "codigo":203992004,
    "descripcion":"MIELOCELE LUMBAR"
  },
  {
    "codigo":16076131000119106,
    "descripcion":"GOTA TOFÁCEA CRÓNICA DE CODO DERECHO"
  },
  {
    "codigo":1187032005,
    "descripcion":"VITAMINA K1 POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":105688006,
    "descripcion":"ENFERMEDAD CAUSADA POR DAVAINEIDAE"
  },
  {
    "codigo":365997002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD DE INTERACTUAR CON OTROS"
  },
  {
    "codigo":890285006,
    "descripcion":"POLIMICROGIRIA FRONTAL BILATERAL"
  },
  {
    "codigo":5549007,
    "descripcion":"VIVIENDA TEMPORAL"
  },
  {
    "codigo":300461009,
    "descripcion":"DISTENSIBILIDAD DE VEJIGA URINARIA NORMAL"
  },
  {
    "codigo":71085009,
    "descripcion":"FIEBRE PARATIFOIDEA TIPO B"
  },
  {
    "codigo":724610003,
    "descripcion":"BURSITIS DEBIDA A USO EXCESIVO"
  },
  {
    "codigo":298626008,
    "descripcion":"AMPLITUD DE FLEXIÓN LATERAL ACTIVA HACIA LA DERECHA DE LA COLUMNA VERTEBRAL LUMBAR, AUMENTADA"
  },
  {
    "codigo":1279831004,
    "descripcion":"INSENSIBILIDAD CONGÉNITA AL DOLOR, ANOSMIA, ARTROPATÍA NEUROPÁTICA"
  },
  {
    "codigo":1179692005,
    "descripcion":"PROSTATITIS CATEGORÍA IIIA"
  },
  {
    "codigo":196652006,
    "descripcion":"ÚLCERA DUODENAL AGUDA"
  },
  {
    "codigo":131116005,
    "descripcion":"VITAMINA K POR ENCIMA DE RANGO DE REFERENCIA"
  },
  {
    "codigo":720940008,
    "descripcion":"DEFICIENCIA DE LIPASA HEPÁTICA"
  },
  {
    "codigo":294956008,
    "descripcion":"ALERGIA A GEMFIBROZILO"
  },
  {
    "codigo":162049009,
    "descripcion":"DOLOR EN EL FLANCO IZQUIERDO"
  },
  {
    "codigo":94678001,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA PLEURA VISCERAL"
  },
  {
    "codigo":125611001,
    "descripcion":"LUXACIÓN TRAUMÁTICA DE LA ARTICULACIÓN SACROILÍACA"
  },
  {
    "codigo":92843003,
    "descripcion":"FUSIÓN ANORMAL CONGÉNITA DEL CARPO"
  },
  {
    "codigo":289451007,
    "descripcion":"ARCO PÚBICO - HALLAZGO"
  },
  {
    "codigo":1336192000,
    "descripcion":"TRASTORNO POR USO DE OPIOIDE"
  },
  {
    "codigo":1338027008,
    "descripcion":"TRASTORNO DE MÁCULA RETINIANA DEBIDO A RADIOTERAPIA Y POSTERIOR A ELLA"
  },
  {
    "codigo":254848002,
    "descripcion":"PAPILOMA INTRADUCTAL DE MAMA"
  },
  {
    "codigo":189312004,
    "descripcion":"INFLAMACIÓN PÉLVICA CON ESTERILIDAD FEMENINA CAUSADA POR CHLAMYDIA TRACHOMATIS"
  },
  {
    "codigo":123776006,
    "descripcion":"CARBOXIHEMOGLOBINURIA"
  },
  {
    "codigo":25472008,
    "descripcion":"ENFERMEDAD DE CÉLULAS FALCIFORMES - HEMOGLOBINA D"
  },
  {
    "codigo":23637001,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA ARTERIA SUBCLAVIA"
  },
  {
    "codigo":1268821004,
    "descripcion":"TENDINITIS CALCIFICANTE DE REGIÓN DE BRAZO"
  },
  {
    "codigo":449621009,
    "descripcion":"LINFEDEMA DE BRAZO"
  },
  {
    "codigo":1332522004,
    "descripcion":"ARTRITIS GOTOSA DE MUÑECA"
  },
  {
    "codigo":183807002,
    "descripcion":"ESTADÍA DE INTERNACIÓN, 9 DÍAS"
  },
  {
    "codigo":708095007,
    "descripcion":"EXACERBACIÓN SEVERA AGUDA DE ASMA ALÉRGICA MEDIADA POR INMUNOGLOBULINA E"
  },
  {
    "codigo":249343009,
    "descripcion":"CAVIDAD NASAL MUY PERMEABLE"
  },
  {
    "codigo":247508004,
    "descripcion":"UÑAS BLANCAS"
  },
  {
    "codigo":737193000,
    "descripcion":"ENTERITIS ALÉRGICA DE INTESTINO DELGADO"
  },
  {
    "codigo":18132009,
    "descripcion":"DEFORMIDAD CONGÉNITA DE LA ARTICULACIÓN SACROILÍACA"
  },
  {
    "codigo":704425001,
    "descripcion":"FIEBRE CRÓNICA"
  },
  {
    "codigo":16297002,
    "descripcion":"HIDRONEFROSIS CONGÉNITA"
  },
  {
    "codigo":212905006,
    "descripcion":"COMPLICACIÓN POR FOTOTERAPIA"
  },
  {
    "codigo":15669041000119108,
    "descripcion":"AUSENCIA CONGÉNITA DE MÚSCULO PECTORAL IZQUIERDO"
  },
  {
    "codigo":274905008,
    "descripcion":"LINFOMA MALIGNO - LINFOCÍTICO, DIFERENCIACIÓN INTERMEDIA"
  },
  {
    "codigo":677681000119109,
    "descripcion":"NEOVASCULARIZACIÓN DE COROIDES DE OJO DERECHO"
  },
  {
    "codigo":768126006,
    "descripcion":"HEPATITIS C CRÓNICA CAUSADA POR GENOTIPO 4 DE VIRUS HEPATITIS C"
  },
  {
    "codigo":1259646007,
    "descripcion":"OSTEOSARCOMA PRIMARIO DE ESTERNÓN"
  },
  {
    "codigo":276606009,
    "descripcion":"RETRASO ASIMÉTRICO DEL CRECIMIENTO"
  },
  {
    "codigo":373075004,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM TOKAIENSE"
  },
  {
    "codigo":274771005,
    "descripcion":"PROTEINURIA DE BENCE - JONES"
  },
  {
    "codigo":242003008,
    "descripcion":"BAROTRAUMA GASTROINTESTINAL"
  },
  {
    "codigo":405843009,
    "descripcion":"NEOPLASIA MALIGNA GENERALIZADA METASTÁSICA"
  },
  {
    "codigo":764456001,
    "descripcion":"ENCEFALOPATÍA HIPERAMONIÉMICA DEBIDA A DEFICIENCIA DE ANHIDRASA CARBÓNICA VA"
  },
  {
    "codigo":404008001,
    "descripcion":"DERMATOFIBROSARCOMA PROTUBERANTE CON DIFERENCIACIÓN MIOIDE"
  },
  {
    "codigo":305704003,
    "descripcion":"VISTO POR UN CIRUJANO CARDIOTORÁCICO"
  },
  {
    "codigo":133221000119100,
    "descripcion":"BAJA ESTATURA DE CAUSA IDIOPÁTICA"
  },
  {
    "codigo":240168009,
    "descripcion":"FLUOROSIS ESQUELÉTICA"
  },
  {
    "codigo":698920009,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: ESLOVACO"
  },
  {
    "codigo":1286909001,
    "descripcion":"HEMORRAGIA INTRAVENTRICULAR NO TRAUMÁTICA GRADO 1 DURANTE PERÍODO NEONATAL"
  },
  {
    "codigo":323531000119107,
    "descripcion":"DEFORMIDAD EN VARO ADQUIRIDA DE RODILLA DERECHA"
  },
  {
    "codigo":402173005,
    "descripcion":"REACCIÓN FOTOTÓXICA CAUSADA POR SUSTANCIA QUÍMICA DE USO TÓPICO"
  },
  {
    "codigo":72658003,
    "descripcion":"MILIARIA RUBRA"
  },
  {
    "codigo":236498004,
    "descripcion":"TRASTORNO RENAL EN UNA ENFERMEDAD SISTÉMICA"
  },
  {
    "codigo":39890003,
    "descripcion":"INTOXICACIÓN POR HERBICIDA"
  },
  {
    "codigo":302034009,
    "descripcion":"FRACTURA-SUBLUXACIÓN DE LA ARTICULACIÓN DE LA CADERA"
  },
  {
    "codigo":365735004,
    "descripcion":"NIVEL DE DIGOXINA - HALLAZGO"
  },
  {
    "codigo":267431006,
    "descripcion":"TRASTORNO DEL METABOLISMO LIPÍDICO"
  },
  {
    "codigo":300199007,
    "descripcion":"CAPAZ DE ESCUCHAR"
  },
  {
    "codigo":167292000,
    "descripcion":"PRUEBA DE CUERPOS CETÓNICOS EN ORINA: =++++"
  },
  {
    "codigo":298364001,
    "descripcion":"HALLAZGO RELACIONADO CON LA REGIÓN DE LA CABEZA"
  },
  {
    "codigo":429436007,
    "descripcion":"MIELITIS POSTINMUNIZACIÓN"
  },
  {
    "codigo":296529003,
    "descripcion":"SOBREDOSIS DE FÁRMACO ANTIINFECCIOSO"
  },
  {
    "codigo":67153004,
    "descripcion":"DIVERTICULITIS DEL ÍLEON"
  },
  {
    "codigo":722513008,
    "descripcion":"LEIOMIOSARCOMA PRIMARIO DE RETROPERITONEO"
  },
  {
    "codigo":294694006,
    "descripcion":"ALERGIA A CLOBETASONA"
  },
  {
    "codigo":720678007,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR AZILSARTÁN"
  },
  {
    "codigo":292859001,
    "descripcion":"REACCIÓN ADVERSA A LA HALOFANTRINA"
  },
  {
    "codigo":1144827004,
    "descripcion":"INTOXICACIÓN ACCIDENTAL CAUSADA POR TOLAZOLINA"
  },
  {
    "codigo":30715007,
    "descripcion":"QUEMADURA DE LA LENGUA"
  },
  {
    "codigo":127184000,
    "descripcion":"LINFADENOPATÍA POSVESICULAR"
  },
  {
    "codigo":94416001,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA BOCA"
  },
  {
    "codigo":192720004,
    "descripcion":"ENCEFALITIS POSVACUNACIÓN ANTIRRUBEÓLICA"
  },
  {
    "codigo":28880005,
    "descripcion":"CARDITIS REUMATOIDEA"
  },
  {
    "codigo":225488006,
    "descripcion":"INCAPAZ DE EMPLEAR ORACIONES EN PRIMERA PERSONA"
  },
  {
    "codigo":717008005,
    "descripcion":"ENFERMEDAD DE CHARCOT-MARIE-TOOTH TIPO 2B AUTOSÓMICA DOMINANTE"
  },
  {
    "codigo":15727001000119100,
    "descripcion":"LUXACIÓN DE RODILLA IZQUIERDA DEBIDA A DISPLASIA CONGÉNITA"
  },
  {
    "codigo":92581002,
    "descripcion":"CARCINOMA IN SITU DE GLÁNDULA ENDOCRINA"
  },
  {
    "codigo":289189007,
    "descripcion":"HALLAZGO RELACIONADO CON LA RESONANCIA DE LA VOZ"
  },
  {
    "codigo":1335930000,
    "descripcion":"OBSTRUCCIÓN INTERMITENTE DE COLÉDOCO CAUSADA POR CÁLCULO DE VESÍCULA BILIAR"
  },
  {
    "codigo":1237626001,
    "descripcion":"NEUROPATÍA AXONAL CONGÉNITA CON ENCEFALOPATÍA"
  },
  {
    "codigo":1303162002,
    "descripcion":"LACERACIÓN DE ARTERIA CARÓTIDA"
  },
  {
    "codigo":254586002,
    "descripcion":"NEOPLASIA MALIGNA DE UNIÓN ANORRECTAL"
  },
  {
    "codigo":285519003,
    "descripcion":"INCAPAZ DE MOVER LA PUNTA DE LA LENGUA"
  },
  {
    "codigo":709668006,
    "descripcion":"ENFERMEDAD VESICULOULCEROSA DE LA CAVIDAD BUCAL"
  },
  {
    "codigo":185380008,
    "descripcion":"PACIENTE \"RECONVOCADO\" - PREVENCIÓN"
  },
  {
    "codigo":283684008,
    "descripcion":"MORDEDURA HUMANA EN LA CABEZA Y EL CUELLO"
  },
  {
    "codigo":87076008,
    "descripcion":"ALEJAMIENTO DEL PENSAMIENTO"
  },
  {
    "codigo":19705003,
    "descripcion":"ACOSO SEXUAL POR PARTE DE UN HOMBRE"
  },
  {
    "codigo":609529006,
    "descripcion":"QUISTE DE LA BOLSA DE BLAKE PERSISTENTE"
  },
  {
    "codigo":249081007,
    "descripcion":"PRESENTACIÓN DE AMBAS FONTANELAS"
  },
  {
    "codigo":1363193006,
    "descripcion":"HALLAZGO RELACIONADO CON CAPACIDAD PARA SENTARSE EN ASIENTO DE INODORO"
  },
  {
    "codigo":871673008,
    "descripcion":"REACCIÓN ADVERSA A CLORAZEPATO"
  },
  {
    "codigo":286003007,
    "descripcion":"CAPAZ DE CERRAR LA TUBERÍA DE GAS MAESTRA"
  },
  {
    "codigo":738766006,
    "descripcion":"METABOLIZADOR NORMAL DE LA FAMILIA 2 SUBFAMILIA B MIEMBRO 6 DEL CITOCROMO P450"
  },
  {
    "codigo":247246005,
    "descripcion":"OREJA PELUDA"
  },
  {
    "codigo":81571000,
    "descripcion":"REACCIÓN DE DEGENERACIÓN POR ELECTROMIOGRAMA"
  },
  {
    "codigo":704163004,
    "descripcion":"FRACTURA NO EXPUESTA DE FALANGE MEDIA DE DEDO ANULAR"
  },
  {
    "codigo":212643006,
    "descripcion":"INTOXICACIÓN CON METOCARBAMOL"
  },
  {
    "codigo":1162915007,
    "descripcion":"TEJIDO ACCESORIO CONGÉNITO DE VÁLVULA TRICÚSPIDE"
  },
  {
    "codigo":210808001,
    "descripcion":"LESIÓN EN EL SISTEMA DE LA VENA PORTA"
  },
  {
    "codigo":472952001,
    "descripcion":"PARTICIPA EN ACTIVIDAD SEXUAL EXTRAMATRIMONIAL"
  },
  {
    "codigo":1259384008,
    "descripcion":"CISTOADENOCARCINOMA PAPILAR SEROSO PRIMARIO DE OVARIO"
  },
  {
    "codigo":733261003,
    "descripcion":"DISTENSIÓN DE DEDO DE LA MANO"
  },
  {
    "codigo":208973004,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA EXPUESTA DE LA ARTICULACIÓN DE LA RODILLA, EXTERNA"
  },
  {
    "codigo":405581005,
    "descripcion":"HIPOPOTASEMIA PARANEOPLÁSICA"
  },
  {
    "codigo":370978001,
    "descripcion":"FINALIZACIÓN DEL CRECIMIENTO LINEAL"
  },
  {
    "codigo":45133009,
    "descripcion":"INTOXICACIÓN POR MARISCOS NEUROTÓXICOS"
  },
  {
    "codigo":239906004,
    "descripcion":"DEFORMIDAD EN Z DEL PULGAR"
  },
  {
    "codigo":895266005,
    "descripcion":"FORMA ANCHA ANORMAL CONGÉNITA DE FALANGE MEDIA DE DEDO MEÑIQUE"
  },
  {
    "codigo":698658006,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: CORSO"
  },
  {
    "codigo":305442008,
    "descripcion":"BAJO ATENCIÓN DE CONSEJERO MATRIMONIAL"
  },
  {
    "codigo":403746009,
    "descripcion":"LESIÓN CUTÁNEA POR ABUSO DE DROGAS INTRAVENOSAS"
  },
  {
    "codigo":74231003,
    "descripcion":"SÍNDROME DEL ESPACIO RETROESFENOIDAL"
  },
  {
    "codigo":238071004,
    "descripcion":"ACIDEMIA POR ÁCIDOS DIHIDROXICOLESTANOICO Y TRIHIDROXICOLESTANOICO"
  },
  {
    "codigo":203468000,
    "descripcion":"QUISTE ÓSEO ANEURISMÁTICO"
  },
  {
    "codigo":871000119100,
    "descripcion":"LESIÓN DE CUERO CABELLUDO"
  },
  {
    "codigo":234401000,
    "descripcion":"DEFICIENCIA ENZIMÁTICA DEL ERITROCITO"
  },
  {
    "codigo":365473001,
    "descripcion":"VOLICIÓN - HALLAZGO"
  },
  {
    "codigo":201633002,
    "descripcion":"CONDROCALCINOSIS DE ARTICULACIÓN DE TOBILLO Y PIE CAUSADA POR CRISTALES DE FOSFATO DICÁLCICO"
  },
  {
    "codigo":301772008,
    "descripcion":"CON MAYOR RIESGO DE ENDOCARDITIS BACTERIANA"
  },
  {
    "codigo":299937001,
    "descripcion":"HALLAZGO RELACIONADO CON EL SENTIDO DE LA POSICIÓN CORPORAL"
  },
  {
    "codigo":400076009,
    "descripcion":"TUMOR NEUROECTODÉRMICO MELANÓTICO DE MAXILAR"
  },
  {
    "codigo":35958000,
    "descripcion":"LINFANGITIS AGUDA DE LA CARA EXTERNA DE LA NARIZ"
  },
  {
    "codigo":167030002,
    "descripcion":"DIÓXIDO DE CARBONO EN SANGRE ARTERIAL FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":15919821000119109,
    "descripcion":"REACCIÓN ALÉRGICA CAUSADA POR SULFONAMIDA"
  },
  {
    "codigo":298102005,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE DEDO DEL PIE"
  },
  {
    "codigo":429174007,
    "descripcion":"CUERPO EXTRAÑO DE METAL EN REGIÓN ANTERIOR DEL CUELLO"
  },
  {
    "codigo":29461000119100,
    "descripcion":"RESIDENCIA EN HOGAR SUSTITUTO PARA ADULTOS"
  },
  {
    "codigo":197963001,
    "descripcion":"PROSTATITIS ASOCIADA CON OTRO TRASTORNO"
  },
  {
    "codigo":230731002,
    "descripcion":"ARTERITIS CEREBRAL EN VASCULITIS SISTÉMICA"
  },
  {
    "codigo":720416007,
    "descripcion":"DISPLASIA ACROCAPITOFEMORAL"
  },
  {
    "codigo":30453001,
    "descripcion":"CRUZAMIENTO MOLECULAR ANORMAL"
  },
  {
    "codigo":292597005,
    "descripcion":"REACCIÓN ADVERSA A LA TRIPROLIDINA"
  },
  {
    "codigo":290762000,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR VINBLASTINA"
  },
  {
    "codigo":716746003,
    "descripcion":"DEFICIENCIA CONGÉNITA DE ALFA-2-ANTIPLASMINA"
  },
  {
    "codigo":1306570006,
    "descripcion":"CARCINOMA DUCTAL INFILTRANTE DE CUADRANTE SUPERIOR INTERNO DE MAMA DERECHA"
  },
  {
    "codigo":126922007,
    "descripcion":"NEOPLASIA DE LA VULVA"
  },
  {
    "codigo":94154007,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL NERVIO ACCESORIO"
  },
  {
    "codigo":288927004,
    "descripcion":"NO IMPULSA BOLO ALIMENTARIO HACIA LA FARINGE"
  },
  {
    "codigo":92319008,
    "descripcion":"NEOPLASIA BENIGNA DE LA PELVIS RENAL"
  },
  {
    "codigo":24948002,
    "descripcion":"FRACTURA EXPUESTA DE CALCÁNEO"
  },
  {
    "codigo":449097000,
    "descripcion":"ADENOMA FOLICULAR DE GLÁNDULA TIROIDES HIPERFUNCIONANTE"
  },
  {
    "codigo":285257002,
    "descripcion":"DIFICULTAD PARA PENSAR DE MANERA INDEPENDIENTE"
  },
  {
    "codigo":283422001,
    "descripcion":"CORTE EN LA ESPALDA"
  },
  {
    "codigo":447262002,
    "descripcion":"POLIOMIELITIS PARALÍTICA AGUDA CAUSADA POR POLIOVIRUS HUMANO 2"
  },
  {
    "codigo":414494005,
    "descripcion":"INFERTILIDAD POR HIPOPLASIA TESTICULAR"
  },
  {
    "codigo":86814006,
    "descripcion":"ÁNGULO LUMBOSACRO AUMENTADO"
  },
  {
    "codigo":840478008,
    "descripcion":"DISTIQUIASIS CONGÉNITA DE PESTAÑAS DE AMBOS OJOS"
  },
  {
    "codigo":281587000,
    "descripcion":"PENTALOGÍA DE CANTRELL"
  },
  {
    "codigo":445427006,
    "descripcion":"ASMA ESTACIONAL"
  },
  {
    "codigo":248819006,
    "descripcion":"PEZÓN - HALLAZGO"
  },
  {
    "codigo":246984001,
    "descripcion":"ADELGAZAMIENTO GENERALIZADO DE LA ESCLERÓTICA"
  },
  {
    "codigo":17608003,
    "descripcion":"SÍNDROME DE CHILD"
  },
  {
    "codigo":1230024004,
    "descripcion":"DEFORMIDAD CONGÉNITA DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":771272007,
    "descripcion":"DISTROFIA MUSCULAR CONGÉNITA DEBIDA A MUTACIÓN DE LÁMINA A\/C"
  },
  {
    "codigo":48541000,
    "descripcion":"ALTERACIÓN DE LA EVACUACIÓN INTESTINAL: DIARREA"
  },
  {
    "codigo":212381005,
    "descripcion":"SÍNDROME COMPARTIMENTAL DE ANTEBRAZO DEBIDO A LESIÓN TRAUMÁTICA"
  },
  {
    "codigo":1259122001,
    "descripcion":"ESCLEROSIS LATERAL AMIOTRÓFICA CON PARKINSONISMO"
  },
  {
    "codigo":208711001,
    "descripcion":"FRACTURA NO EXPUESTA DE SEGUNDA FALANGE DE DEDO DE PIE"
  },
  {
    "codigo":43036001,
    "descripcion":"ECTROMELIA"
  },
  {
    "codigo":403484002,
    "descripcion":"PAPULOSIS BOWENOIDE DEL ANO"
  },
  {
    "codigo":237809000,
    "descripcion":"ATROFIA TESTICULAR PRODUCIDA POR ANDRÓGENOS"
  },
  {
    "codigo":1351921008,
    "descripcion":"SÍNDROME DE BROWN-SÉQUARD DEBIDO A FRACTURA DE VÉRTEBRA"
  },
  {
    "codigo":1153478004,
    "descripcion":"FOSFATASA ALCALINA SÉRICA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":301510006,
    "descripcion":"INCAPAZ DE ENTRAR EN LA DUCHA"
  },
  {
    "codigo":235974008,
    "descripcion":"CÁLCULO DE CONDUCTO PANCREÁTICO"
  },
  {
    "codigo":234139002,
    "descripcion":"SÍNDROME VASCULAR NEUROCUTÁNEO"
  },
  {
    "codigo":37531003,
    "descripcion":"INTENSIDAD DEL SOPLO CARDÍACO, GRADO V"
  },
  {
    "codigo":299675004,
    "descripcion":"PÉRDIDA DIFUSA DEL CABELLO"
  },
  {
    "codigo":4763005,
    "descripcion":"CONGELAMIENTO DE LA MANO"
  },
  {
    "codigo":168603006,
    "descripcion":"RADIOGRAFÍA SIMPLE DE PELVIS NORMAL"
  },
  {
    "codigo":365211008,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA PARARSE EN EL INODORO"
  },
  {
    "codigo":723824005,
    "descripcion":"PARAPLEJÍA ESPÁSTICA AUTOSÓMICA RECESIVA TIPO 54"
  },
  {
    "codigo":363376007,
    "descripcion":"NEOPLASIA MALIGNA DE BASE DE LENGUA"
  },
  {
    "codigo":232304008,
    "descripcion":"AUSENCIA DE CONDUCTO SEMICIRCULAR"
  },
  {
    "codigo":33861001,
    "descripcion":"DIETA PARA MANTENIMIENTO DEL PESO"
  },
  {
    "codigo":10626511000119108,
    "descripcion":"CARBUNCO DE DEDO DE MANO IZQUIERDA"
  },
  {
    "codigo":164933008,
    "descripcion":"ELECTROCARDIOGRAMA: ONDA T NORMAL"
  },
  {
    "codigo":263237009,
    "descripcion":"FRACTURA NO EXPUESTA DE TUBEROSIDAD TIBIAL"
  },
  {
    "codigo":359706003,
    "descripcion":"INTOXICACIÓN POR YODO"
  },
  {
    "codigo":195866009,
    "descripcion":"PAQUIDERMIA LARÍNGEA"
  },
  {
    "codigo":128495002,
    "descripcion":"RUPTURA DE MÚSCULOS GEMELOS"
  },
  {
    "codigo":1177071001,
    "descripcion":"ENCEFALITIS POR VIRUS PUUMALA"
  },
  {
    "codigo":423407004,
    "descripcion":"INVERSIÓN DE LA SENSACIÓN TÉRMICA"
  },
  {
    "codigo":95727005,
    "descripcion":"ÚLCERA DE CORNEA EPITELIAL NO CICATRIZANTE"
  },
  {
    "codigo":292335004,
    "descripcion":"REACCIÓN ADVERSA A METIPRILÓN"
  },
  {
    "codigo":126660000,
    "descripcion":"DESVIACIÓN DEL TABIQUE NASAL"
  },
  {
    "codigo":1306308001,
    "descripcion":"NEOPLASIA DE ARÉOLA"
  },
  {
    "codigo":93892001,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE HUESO METACARPIANO"
  },
  {
    "codigo":1144303008,
    "descripcion":"LEIOMIOSARCOMA DE PÍLORO"
  },
  {
    "codigo":716484005,
    "descripcion":"DIFICULTAD PARA COMPRENDER LENGUAJE VERBAL"
  },
  {
    "codigo":224964008,
    "descripcion":"SIN LESIONES EVIDENTES"
  },
  {
    "codigo":92057002,
    "descripcion":"NEOPLASIA BENIGNA DE LA MEJILLA"
  },
  {
    "codigo":419737003,
    "descripcion":"DEPÓSITOS DE ADRENOCROMO EN LA CONJUNTIVA"
  },
  {
    "codigo":417902000,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR SUSTANCIA QUÍMICA INORGÁNICA"
  },
  {
    "codigo":286830001,
    "descripcion":"EXAGERACIÓN DE UN RASGO NORMAL DE LA PERSONALIDAD"
  },
  {
    "codigo":288665008,
    "descripcion":"INCAPAZ DE MANTENER UNA CONVERSACIÓN"
  },
  {
    "codigo":1204334005,
    "descripcion":"ESCLEROSIS LATERAL AMIOTRÓFICA TIPO 6"
  },
  {
    "codigo":254062008,
    "descripcion":"TRASTORNO ESPONDILOEPIMETAFISARIO"
  },
  {
    "codigo":284995006,
    "descripcion":"NO SE DESCALZA"
  },
  {
    "codigo":88387008,
    "descripcion":"PERÍODO POSTPARTO, 7 DÍAS"
  },
  {
    "codigo":250392001,
    "descripcion":"TIPO ANTIGÉNICO MNS"
  },
  {
    "codigo":709144002,
    "descripcion":"NEUROPATÍA PERIFÉRICA DE MIEMBRO SUPERIOR CAUSADA POR TOXINA"
  },
  {
    "codigo":283160004,
    "descripcion":"CUERPO EXTRAÑO METÁLICO EN LA MANO"
  },
  {
    "codigo":1004056004,
    "descripcion":"CONTRACTURA EN FLEXIÓN DE ARTICULACIÓN INTERFALÁNGICA DISTAL DE TERCER DEDO DE PIE"
  },
  {
    "codigo":838381003,
    "descripcion":"VESTIBULOPATÍA BILATERAL CRÓNICA DEBIDA A MENINGITIS Y POSTERIOR A ELLA"
  },
  {
    "codigo":117485005,
    "descripcion":"CRISTAL URINARIO, FOSFATO DE CALCIO, FORMA HIDROXILO"
  },
  {
    "codigo":17346000,
    "descripcion":"TRASTORNO DEL PÁNCREAS ENDOCRINO"
  },
  {
    "codigo":281325009,
    "descripcion":"HORA DE LA RECOLECCIÓN DEL ESPÉCIMEN NO SUMINISTRADA"
  },
  {
    "codigo":246722005,
    "descripcion":"ENFOQUE LENTO"
  },
  {
    "codigo":11857821000119103,
    "descripcion":"RUPTURA DE TENDÓN DE MÚSCULO PLANTAR DERECHO"
  },
  {
    "codigo":441495001,
    "descripcion":"ANAFILAXIA CAUSADA POR FRUTO SECO"
  },
  {
    "codigo":212119007,
    "descripcion":"QUEMADURA QUE COMPROMETE MÁS DEL 90 POR CIENTO DE LA SUPERFICIE CORPORAL, CON 30 - 39 POR CIENTO DE SUPERFICIE CORPORAL CON QUEMADURA DE TERCER GRADO"
  },
  {
    "codigo":243052001,
    "descripcion":"LESIÓN POR DAGA DURANTE BATALLA"
  },
  {
    "codigo":111980002,
    "descripcion":"SUDORACIÓN DISMINUIDA"
  },
  {
    "codigo":275820009,
    "descripcion":"DESARROLLO MOTOR EN EL NIÑO"
  },
  {
    "codigo":273985002,
    "descripcion":"ANEMIA POR ISOINMUNIZACIÓN"
  },
  {
    "codigo":77377001,
    "descripcion":"LEPTOSPIROSIS"
  },
  {
    "codigo":110145006,
    "descripcion":"LACERACIÓN SIMPLE CONTAMINADA DEL CUELLO"
  },
  {
    "codigo":658121000005103,
    "descripcion":"CON MAYOR RIESGO DE PLACENTA PREVIA"
  },
  {
    "codigo":75542001,
    "descripcion":"DESTRUCCIÓN ANORMAL DE PLAQUETAS"
  },
  {
    "codigo":403222003,
    "descripcion":"FOTOTIPO CUTÁNEO II (AL COMIENZO SIEMPRE EXISTE QUEMADURA, LUEGO GENERALMENTE BRONCEADO)"
  },
  {
    "codigo":307101000119109,
    "descripcion":"ARTRITIS ENTEROPÁTICA DE ARTICULACIÓN DE PIE IZQUIERDO"
  },
  {
    "codigo":1255190008,
    "descripcion":"CARCINOMA PAPILAR ESCLEROSANTE DIFUSO PRIMARIO DE TIROIDES"
  },
  {
    "codigo":237547004,
    "descripcion":"HIPERTIROXINEMIA DISALBUMINÉMICA FAMILIAR"
  },
  {
    "codigo":30061000175101,
    "descripcion":"ÚLCERA POR PRESIÓN EN DORSO DE PIE IZQUIERDO, ESTADIO IV"
  },
  {
    "codigo":39104002,
    "descripcion":"AFECCIÓN"
  },
  {
    "codigo":202944005,
    "descripcion":"GANGLIÓN DE LA ARTICULACIÓN TIBIOPERONEA SUPERIOR"
  },
  {
    "codigo":6336005,
    "descripcion":"ADHERENCIAS PERIPROSTÁTICAS"
  },
  {
    "codigo":16228561000119100,
    "descripcion":"DERRAME INTERMITENTE DE ARTICULACIÓN DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":235712006,
    "descripcion":"YEYUNITIS ULCEROSA"
  },
  {
    "codigo":12240951000119107,
    "descripcion":"CARCINOMA ESCAMOCELULAR DE PULMÓN IZQUIERDO"
  },
  {
    "codigo":233877003,
    "descripcion":"CARDIOMIOPATÍA RESTRICTIVA SIN FIBROSIS DEL ENDOMIOCARDIO"
  },
  {
    "codigo":299413005,
    "descripcion":"HALLAZGO RELACIONADO CON ARTICULACIÓN DE TOBILLO"
  },
  {
    "codigo":4501007,
    "descripcion":"ASCITIS TUBERCULOSA"
  },
  {
    "codigo":364949008,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA ABRIR LA BOCA"
  },
  {
    "codigo":201109009,
    "descripcion":"UÑA DE DEDO DEL PIE ENCARNADA (EXCEPTO LA DEL DEDO GORDO)"
  },
  {
    "codigo":68202005,
    "descripcion":"LEISÓN INTERMEDIA DE PINTA"
  },
  {
    "codigo":232042005,
    "descripcion":"EDEMA MACULAR DEBIDO A OCLUSIÓN DE VENA CENTRAL DE LA RETINA EN NIÑEZ"
  },
  {
    "codigo":461418005,
    "descripcion":"OCLUSIÓN ADQUIRIDA DE VENA ILÍACA"
  },
  {
    "codigo":35434009,
    "descripcion":"ENFERMEDAD DE CÉLULAS FALCIFORMES - HEMOGLOBINA C"
  },
  {
    "codigo":295743001,
    "descripcion":"SOBREDOSIS DE HIDROXIUREA"
  },
  {
    "codigo":197439004,
    "descripcion":"COLANGITIS OBLITERANTE"
  },
  {
    "codigo":361279005,
    "descripcion":"LINFANGITIS ESCLEROSANTE DEL PENE"
  },
  {
    "codigo":230207008,
    "descripcion":"ABSCESO PIOGÉNICO INFRATENTORIAL SUBDURAL"
  },
  {
    "codigo":424980001,
    "descripcion":"SIN DESEOS DE COMPLETAR EL CUIDADO PERSONAL"
  },
  {
    "codigo":66367009,
    "descripcion":"FÍSTULA COLEDOCODUODENAL"
  },
  {
    "codigo":262975009,
    "descripcion":"DISTENSIÓN DE TENDÓN DEL DORSO"
  },
  {
    "codigo":64532005,
    "descripcion":"ABSCESO CRÓNICO DE LA PELVIS FEMENINA"
  },
  {
    "codigo":293908005,
    "descripcion":"ALERGIA A HIDRATO DE CLORAL"
  },
  {
    "codigo":228372006,
    "descripcion":"USO INAPROPIADO DE MÚLTIPLES FÁRMACOS"
  },
  {
    "codigo":95465002,
    "descripcion":"DEDO DEL PIE EN GARRA CONGÉNITO"
  },
  {
    "codigo":29929003,
    "descripcion":"TRASTORNO BIPOLAR I, EPISODIO MÁS RECIENTE DEPRESIVO CON SÍNTOMAS ATÍPICOS"
  },
  {
    "codigo":128233005,
    "descripcion":"TRASTORNO DE LA MANDÍBULA"
  },
  {
    "codigo":292073006,
    "descripcion":"REACCIÓN ADVERSA A FELBINACO"
  },
  {
    "codigo":423145008,
    "descripcion":"EQUIMOSIS DE PÁRPADO"
  },
  {
    "codigo":60862001,
    "descripcion":"ACÚFENOS"
  },
  {
    "codigo":421310001,
    "descripcion":"TRASTORNO ATÓPICO NO MEDIADO POR IGE"
  },
  {
    "codigo":880062003,
    "descripcion":"DEFECTO RECURRENTE DEL TABIQUE INTERVENTRICULAR LUEGO DE PROCEDIMIENTO"
  },
  {
    "codigo":11805371000119106,
    "descripcion":"SUBLUXACIÓN DE ARTICULACIÓN INTERFALÁNGICA PROXIMAL DE DEDO ÍNDICE DE MANO DERECHA"
  },
  {
    "codigo":93630005,
    "descripcion":"FALTA DE OSIFICACIÓN DEL CENTRO DE LA VÉRTEBRA LUMBAR"
  },
  {
    "codigo":290238006,
    "descripcion":"INTOXICACIÓN POR ETODOLACO"
  },
  {
    "codigo":386707000,
    "descripcion":"INCONTINENCIA FECAL IDIOPÁTICA"
  },
  {
    "codigo":124563007,
    "descripcion":"DEFICIENCIA DE PÉPTIDO HIDROLASA"
  },
  {
    "codigo":288403008,
    "descripcion":"NO ABRE NI CIERRA RECIPIENTES"
  },
  {
    "codigo":44201000087105,
    "descripcion":"CONTUSIÓN DE REGIÓN DE COLUMNA VERTEBRAL CERVICAL"
  },
  {
    "codigo":46761000087106,
    "descripcion":"ÚLCERA SANGRANTE DE INTESTINO GRUESO"
  },
  {
    "codigo":24424003,
    "descripcion":"FRACTURA NO EXPUESTA DE FALANGE DE DEDO DE MANO"
  },
  {
    "codigo":188264002,
    "descripcion":"NEOPLASIA MALIGNA DE IRIS"
  },
  {
    "codigo":41641000087108,
    "descripcion":"CELULITIS DE DEDO MEÑIQUE IZQUIERDO"
  },
  {
    "codigo":39081000087107,
    "descripcion":"DOLOR CRÓNICO POSTERIOR A QUEMADURA"
  },
  {
    "codigo":286568007,
    "descripcion":"MIEDO ASOCIADO CON LA ATENCIÓN MÉDICA"
  },
  {
    "codigo":57192008,
    "descripcion":"APLASIA ERITROCÍTICA AGUDA PURA"
  },
  {
    "codigo":253800006,
    "descripcion":"DUPLICACIÓN COMPLETA DE APÉNDICE"
  },
  {
    "codigo":415805003,
    "descripcion":"USA LENGUAJE DE SIGNOS MAKATON"
  },
  {
    "codigo":88125005,
    "descripcion":"COREA DE HENOCH"
  },
  {
    "codigo":22589009,
    "descripcion":"AUSENCIA CONGÉNITA DE LA GLÁNDULA SALIVAL"
  },
  {
    "codigo":250130002,
    "descripcion":"ARTRITIS DE ARTICULACIÓN PEQUEÑA Y GRANDE"
  },
  {
    "codigo":20754004,
    "descripcion":"AQUILIA GÁSTRICA"
  },
  {
    "codigo":282898008,
    "descripcion":"NO ALTERNA ENTRE SENTARSE Y PARARSE"
  },
  {
    "codigo":84455002,
    "descripcion":"PARAPLEJÍA RAQUÍDEA"
  },
  {
    "codigo":1264103009,
    "descripcion":"TRASTORNO NEONATAL CAUSADO POR ANTICOAGULANTE EN LECHE MATERNA"
  },
  {
    "codigo":1293201003,
    "descripcion":"MASA DE ARTICULACIÓN DE REGIÓN DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":338591000119103,
    "descripcion":"ESCLERITIS POSTERIOR DE OJO IZQUIERDO"
  },
  {
    "codigo":372027002,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE BORDE BERMELLÓN DE LABIO SUPERIOR"
  },
  {
    "codigo":77115005,
    "descripcion":"REACCIÓN TRANSFUSIONAL DEBIDA A INMUNOGLOBULINA A"
  },
  {
    "codigo":1156624002,
    "descripcion":"SATÉLITE PLAQUETARIO"
  },
  {
    "codigo":763408003,
    "descripcion":"RABDOMIOSARCOMA DE CUELLO UTERINO"
  },
  {
    "codigo":239120005,
    "descripcion":"NEVO APOCRINO"
  },
  {
    "codigo":237285000,
    "descripcion":"EDEMA GESTACIONAL"
  },
  {
    "codigo":304656009,
    "descripcion":"INCAPAZ DE EMPLEAR RAZONAMIENTO VISUOESPACIAL"
  },
  {
    "codigo":827109000,
    "descripcion":"SUBLUXACIÓN DE DÍGITO DE MANO"
  },
  {
    "codigo":10906271000119107,
    "descripcion":"LACERACIÓN DE MENTÓN"
  },
  {
    "codigo":1187557007,
    "descripcion":"TRASTORNO GLOMERULAR POR AMILOIDOSIS"
  },
  {
    "codigo":169914000,
    "descripcion":"PUNTAJE DE APGAR A LOS 5 MINUTOS = 4"
  },
  {
    "codigo":366522003,
    "descripcion":"HALLAZGO RELACIONADO CON LA AMPLITUD DE LA FLEXIÓN DE LA MUÑECA"
  },
  {
    "codigo":71610005,
    "descripcion":"REACCIÓN LEUCEMOIDE NEUTROFÍLICA"
  },
  {
    "codigo":11862841000119103,
    "descripcion":"ABRASIÓN DE PIEL DE DEDO GORDO DERECHO"
  },
  {
    "codigo":233615002,
    "descripcion":"COCCIDIOIDOMICOSIS PULMONAR CRÓNICA"
  },
  {
    "codigo":725135004,
    "descripcion":"INMUNODEFICIENCIA COMBINADA DEBIDA A DEFICIENCIA DE CD3 GAMMA"
  },
  {
    "codigo":102543005,
    "descripcion":"CONTRACCIÓN MUSCULAR DISMINUIDA DE MANERA ANORMAL"
  },
  {
    "codigo":168079008,
    "descripcion":"CÁLCULO: FOSFATO TRIPLE"
  },
  {
    "codigo":200847009,
    "descripcion":"DERMATITIS ALÉRGICA DE CONTACTO CAUSADA POR ALIMENTO EN CONTACTO CON LA PIEL"
  },
  {
    "codigo":1473891000168100,
    "descripcion":"SIN ORDEN DE RESTRICCIÓN VIGENTE"
  },
  {
    "codigo":723300005,
    "descripcion":"DOLOR PARALIZANTE"
  },
  {
    "codigo":262713001,
    "descripcion":"SECCIÓN DE MÉDULA ESPINAL LUMBAR"
  },
  {
    "codigo":197177004,
    "descripcion":"ABSCESO PREILEAL"
  },
  {
    "codigo":361017005,
    "descripcion":"DEFICIENCIA DE CATEPSINA C"
  },
  {
    "codigo":721465005,
    "descripcion":"SÍNDROME DEL CORDÓN ANTERIOR DE MÉDULA ESPINAL AL NIVEL DEL DÉCIMO SEGMENTO DORSAL"
  },
  {
    "codigo":15713081000119108,
    "descripcion":"INFARTO AGUDO DE MIOCARDIO CON ELEVACIÓN DE SEGMENTO ST DEBIDO A OCLUSIÓN DE ARTERIA CORONARIA IZQUIERDA"
  },
  {
    "codigo":293646000,
    "descripcion":"ALERGIA A SUCRALFATO"
  },
  {
    "codigo":195342005,
    "descripcion":"EMBOLIA Y TROMBOSIS DE LA ARTERIA CELÍACA"
  },
  {
    "codigo":64270008,
    "descripcion":"TRASTORNO DE LA COMPRENSIÓN"
  },
  {
    "codigo":129806009,
    "descripcion":"DIFERENCIA DE TAMAÑO SEGÚN LA MAMOGRAFÍA"
  },
  {
    "codigo":422883004,
    "descripcion":"LA VIVIENDA CONTIENE ARTEFACTOS INSEGUROS"
  },
  {
    "codigo":160739005,
    "descripcion":"ADMITIDO EN HOGAR DE NIÑOS"
  },
  {
    "codigo":1078243004,
    "descripcion":"AGENESIA DE EPÍFISIS DE FALANGE PROXIMAL DE DEDO PULGAR"
  },
  {
    "codigo":191672000,
    "descripcion":"PARANOIA QUERELLANTE"
  },
  {
    "codigo":95203009,
    "descripcion":"RESORCIÓN PATOLÓGICA DE RAÍZ DE DIENTE"
  },
  {
    "codigo":289976002,
    "descripcion":"REALIZA ACTIVIDADES RELACIONADAS CON EL CUIDADO DE LAS UÑAS"
  },
  {
    "codigo":224440003,
    "descripcion":"COBERTURA DE SEGURIDAD SOCIAL LABORAL INADECUADA"
  },
  {
    "codigo":440321000124101,
    "descripcion":"INGESTA ORAL INADECUADA"
  },
  {
    "codigo":879800007,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE ANTEBRAZO CON INFECCIÓN"
  },
  {
    "codigo":2561000124103,
    "descripcion":"SEGUNDO PREMOLAR SUPERIOR DERECHO PERMANENTE SUPERNUMERARIO"
  },
  {
    "codigo":460801000124105,
    "descripcion":"BUSCA ASISTENCIA EN SITUACIÓN DE CRISIS"
  },
  {
    "codigo":60600009,
    "descripcion":"TRASTORNO DE LA LARINGE"
  },
  {
    "codigo":445441000124108,
    "descripcion":"COMPOSICIÓN DE NUTRICIÓN ENTERAL INADECUADA"
  },
  {
    "codigo":124301008,
    "descripcion":"DEFICIENCIA DE RAMNULOCINASA"
  },
  {
    "codigo":253538000,
    "descripcion":"HIPOPLASIA DEL TRACTO DE ENTRADA DEL VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":367571000119109,
    "descripcion":"LESIONES GLOMERULARES FOCALES Y SEGMENTARIAS HEREDITARIAS"
  },
  {
    "codigo":286306007,
    "descripcion":"CAPAZ DE UTILIZAR VOCALES AISLADAS"
  },
  {
    "codigo":11809901000119104,
    "descripcion":"ABRASIÓN DE PIEL RODILLA DERECHA"
  },
  {
    "codigo":448311004,
    "descripcion":"NEOPLASIA BENIGNA DE PARTES BLANDAS DEL MUSLO"
  },
  {
    "codigo":1167372000,
    "descripcion":"SÍNDROME DE ATRESIA DEL CONDUCTO AUDITIVO EXTERNO, CONDUCTO AUDITIVO INTERNO DILATADO Y DISMORFIA FACIAL LIGADO AL CROMOSOMA X"
  },
  {
    "codigo":86028001,
    "descripcion":"SÍFILIS DEL HÍGADO"
  },
  {
    "codigo":251703009,
    "descripcion":"REFLUJO LAGRIMAL MUCOIDE"
  },
  {
    "codigo":1003532000,
    "descripcion":"SOSPECHA DE GLAUCOMA DE OJO DERECHO CAUSADO POR CORTICOSTEROIDE"
  },
  {
    "codigo":282636006,
    "descripcion":"INTENTA GATEAR"
  },
  {
    "codigo":84193000,
    "descripcion":"DEFICIENCIA DE TREHALASA"
  },
  {
    "codigo":315404009,
    "descripcion":"NACIDO EN CHINA"
  },
  {
    "codigo":248033005,
    "descripcion":"ROBO EN LA ESCUELA"
  },
  {
    "codigo":1362145006,
    "descripcion":"CONDUCTO PULPAR LATERAL DE DIENTE"
  },
  {
    "codigo":870625007,
    "descripcion":"SÍNDROME DE RESECCIÓN ANTERIOR BAJA"
  },
  {
    "codigo":410038006,
    "descripcion":"MICETOMA EUMICÓTICO"
  },
  {
    "codigo":277131000,
    "descripcion":"SOBREDOSIS INTENCIONAL DE AGENTE ANTIINFLAMATORIO NO ESTEROIDE"
  },
  {
    "codigo":211595005,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO, RODILLA Y PIERNA"
  },
  {
    "codigo":735883008,
    "descripcion":"LUXACIÓN TRAUMÁTICA DE SEGUNDO A QUINTO DEDOS DEL PIE"
  },
  {
    "codigo":45920002,
    "descripcion":"PELVIS PLANA"
  },
  {
    "codigo":373600006,
    "descripcion":"CONTUSIONES MÚLTIPLES"
  },
  {
    "codigo":766816008,
    "descripcion":"SÍNDROME DE MICRODUPLICACIÓN 2Q23.1"
  },
  {
    "codigo":109621005,
    "descripcion":"FIBROMATOSIS GINGIVAL IDIOPÁTICA"
  },
  {
    "codigo":240693007,
    "descripcion":"SKERLIEVO"
  },
  {
    "codigo":1254666000,
    "descripcion":"ESTENOSIS DE ORIFICIO DE ARTERIA CORONARIA DERECHA"
  },
  {
    "codigo":207925007,
    "descripcion":"FRACTURA EXPUESTA DEL AXIS, APÓFISIS ESPINOSA"
  },
  {
    "codigo":238858003,
    "descripcion":"SÍNDROME DE POLIFIBROMATOSIS"
  },
  {
    "codigo":402698005,
    "descripcion":"DERMATITIS DE OÍDO EXTERNO"
  },
  {
    "codigo":1285599008,
    "descripcion":"HEMATOMA DE REGIÓN DE OJO"
  },
  {
    "codigo":169652001,
    "descripcion":"AMNIOCENTESIS PRENATAL, NORMAL"
  },
  {
    "codigo":202420003,
    "descripcion":"HEMARTROSIS DE ARTICULACIÓN METATARSOFALÁNGICA DE SEGUNDO A QUINTO DEDOS"
  },
  {
    "codigo":366260006,
    "descripcion":"TOLERANCIA A LA D-XILOSA - HALLAZGO"
  },
  {
    "codigo":726708009,
    "descripcion":"ASPLENIA CONGÉNITA AISLADA FAMILIAR"
  },
  {
    "codigo":298889001,
    "descripcion":"SIN AMPLITUD PASIVA DE FLEXIÓN DE CODO"
  },
  {
    "codigo":94003005,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE HUESO CORTO DE MIEMBRO INFERIOR"
  },
  {
    "codigo":724873006,
    "descripcion":"REACCIÓN FOTOTÓXICA OCUPACIONAL AL CONTACTO DE LA PIEL CON AGENTE FOTOACTIVO EXÓGENO"
  },
  {
    "codigo":297054000,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE INHIBIDORES DE LA ENZIMA CONVERTIDORA DE ANGIOTENSINA"
  },
  {
    "codigo":67678004,
    "descripcion":"CONJUNTIVITIS ATÓPICA AGUDA"
  },
  {
    "codigo":343611000119103,
    "descripcion":"ESCLEROMALACIA PERFORANTE DE AMBOS OJOS"
  },
  {
    "codigo":229683000,
    "descripcion":"TRASTORNO MOTRIZ DEL HABLA"
  },
  {
    "codigo":295219000,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE ACEMETACINA"
  },
  {
    "codigo":721203003,
    "descripcion":"SECUELA DE COMPLICACIÓN DEL EMBARAZO, PARTO Y PUERPERIO"
  },
  {
    "codigo":323651000119100,
    "descripcion":"TUMOR TENOSINOVIAL DE CÉLULAS GIGANTES DIFUSO DE ARTICULACIÓN DE TOBILLO DERECHO"
  },
  {
    "codigo":354371000119101,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE CONDUCTO DE GLÁNDULA LAGRIMAL IZQUIERDA"
  },
  {
    "codigo":459059005,
    "descripcion":"ENDOCARDITIS INFECCIOSA DE HETEROINJERTO"
  },
  {
    "codigo":83011000119100,
    "descripcion":"ÚLCERA POR ESTASIS VENOSA CONCOMITANTE CON EDEMA DE PIERNA"
  },
  {
    "codigo":136771000119104,
    "descripcion":"TROMBOSIS VENOSA PROFUNDA AGUDA DE EXTREMIDAD SUPERIOR COMO COMPLICACIÓN DE PROCEDIMIENTO"
  },
  {
    "codigo":426291003,
    "descripcion":"IMAGEN RADIOGRÁFICA CORRELACIONADA CON EL HALLAZGO TUMORAL DE ANATOMÍA PATOLÓGICA"
  },
  {
    "codigo":116291000119103,
    "descripcion":"OCLUSIÓN DE ARTERIA RENAL DEBIDA A EMBOLIA"
  },
  {
    "codigo":196915008,
    "descripcion":"HERNIA GLÚTEA"
  },
  {
    "codigo":336451000119108,
    "descripcion":"AMBLIOPÍA DE OJO DERECHO"
  },
  {
    "codigo":341571000119108,
    "descripcion":"IRITIS CRÓNICA DE OJO IZQUIERDO"
  },
  {
    "codigo":90691000119105,
    "descripcion":"INFECCIÓN ASINTOMÁTICA POR VIRUS DE LA INMUNODEFICIENCIA HUMANA A2"
  },
  {
    "codigo":301512771000119106,
    "descripcion":"DERIVACIÓN LUMBOPERITONEAL IN SITU"
  },
  {
    "codigo":72771000119107,
    "descripcion":"DOLOR POR EPISIOTOMÍA POSPARTO"
  },
  {
    "codigo":16715331000119109,
    "descripcion":"DISFUNCIÓN ERÉCTIL DEBIDA A IMPLANTE DE SEMILLA RADIACTIVA EN PRÓSTATA Y POSTERIOR A ÉL"
  },
  {
    "codigo":11802691000119106,
    "descripcion":"DESGARRO DE COMPLEJO FIBROCARTILAGINOSO TRIANGULAR DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":16546371000119109,
    "descripcion":"STENT EN ARTERIA CORONARIA RECUBIERTO CON MEDICACIÓN"
  },
  {
    "codigo":1091000119108,
    "descripcion":"APNEA OBSTRUCTIVA DEL SUEÑO INFANTIL"
  },
  {
    "codigo":719368006,
    "descripcion":"CAPAZ DE UTILIZAR APOYO RESPIRATORIO PARA LA VOZ"
  },
  {
    "codigo":29405003,
    "descripcion":"HIPERVITAMINOSIS, COMPLEJO B"
  },
  {
    "codigo":94941001,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE MÚSCULO DE LA CARA"
  },
  {
    "codigo":289714000,
    "descripcion":"HALLAZGO RELACIONADO CON LA INTENSIDAD DE LA CONTRACCIÓN UTERINA"
  },
  {
    "codigo":291549006,
    "descripcion":"INTOXICACIÓN POR FLUCLOXACILINA"
  },
  {
    "codigo":93106007,
    "descripcion":"FALTA DE OSIFICACIÓN DE LA MANDÍBULA"
  },
  {
    "codigo":1010610007,
    "descripcion":"SÍNDROME DE RETINITIS PIGMENTARIA - SORDERA TIPO 3"
  },
  {
    "codigo":91271004,
    "descripcion":"SUPERFETACIÓN"
  },
  {
    "codigo":255111004,
    "descripcion":"CARCINOMA ESCAMOSO DE VEJIGA URINARIA"
  },
  {
    "codigo":1303687008,
    "descripcion":"QUISTE DE MANO"
  },
  {
    "codigo":124039009,
    "descripcion":"CEROIDE DISMINUIDO"
  },
  {
    "codigo":1172615009,
    "descripcion":"HORMONA LIBERADORA DE CORTICOTROFINA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":449884001,
    "descripcion":"DOLOR DE CICATRIZ"
  },
  {
    "codigo":187740000,
    "descripcion":"NEOPLASIA MALIGNA DE ANTRO PILÓRICO"
  },
  {
    "codigo":253276007,
    "descripcion":"AURÍCULA COMÚN"
  },
  {
    "codigo":286044008,
    "descripcion":"CLASIFICA LA ROPA PARA LAVAR"
  },
  {
    "codigo":23900009,
    "descripcion":"FRACTURA NO EXPUESTA DE EXTREMO PROXIMAL DE TIBIA"
  },
  {
    "codigo":710193006,
    "descripcion":"NEOPLASIA ODONTÓGENA BENIGNA DE MAXILAR INFERIOR"
  },
  {
    "codigo":413446001,
    "descripcion":"ADENOCARCINOMA DE CIEGO"
  },
  {
    "codigo":216838003,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR GASES DE COMBUSTIÓN DE MOTORES A GAS"
  },
  {
    "codigo":16019311000119103,
    "descripcion":"ATEROSCLEROSIS DE INJERTO-PUENTE NO BIOLÓGICO DE EXTREMIDAD INFERIOR IZQUIERDA"
  },
  {
    "codigo":313307000,
    "descripcion":"CONVULSIÓN EPILÉPTICA"
  },
  {
    "codigo":247771007,
    "descripcion":"LLORA CON FACILIDAD"
  },
  {
    "codigo":1263579008,
    "descripcion":"TRASTORNO IDIOPÁTICO DE PLEXO LUMBOSACRO"
  },
  {
    "codigo":83931009,
    "descripcion":"PRÓDROMO"
  },
  {
    "codigo":442544003,
    "descripcion":"DEFORMIDAD DE COLUMNA VERTEBRAL POR LESIÓN TRAUMÁTICA"
  },
  {
    "codigo":1163440003,
    "descripcion":"INFARTO AGUDO DE MIOCARDIO POSOPERATORIO"
  },
  {
    "codigo":211333001,
    "descripcion":"ABRASIÓN DE PIEL DE PIERNA"
  },
  {
    "codigo":14725002,
    "descripcion":"HIPOGLUCEMIA POSTPRANDIAL IDIOPÁTICA"
  },
  {
    "codigo":47493003,
    "descripcion":"ABSCESO VISCERAL ABDOMINAL"
  },
  {
    "codigo":276869002,
    "descripcion":"FILTRACIÓN DE ANASTOMOSIS UROLÓGICA"
  },
  {
    "codigo":735621005,
    "descripcion":"ADHERENCIA DEBIDA A ENDOMETRIOSIS"
  },
  {
    "codigo":897626000,
    "descripcion":"FORMA TRIANGULAR ANORMAL CONGÉNITA DE EPÍFISIS DE FALANGE DE QUINTO DEDO DE PIE"
  },
  {
    "codigo":406106001,
    "descripcion":"RESTOS NEFROGÉNICOS AUSENTES EN EL ESPÉCIMEN"
  },
  {
    "codigo":44911000119109,
    "descripcion":"DUELO EN REMISIÓN"
  },
  {
    "codigo":43823002,
    "descripcion":"COLANGITIS BACTERIANA"
  },
  {
    "codigo":10749961000119104,
    "descripcion":"OCLUSIÓN DE ARTERIA AORTOILÍACA"
  },
  {
    "codigo":240431004,
    "descripcion":"TÉTANOS CEFÁLICO"
  },
  {
    "codigo":109359008,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE SITIOS MÚLTIPLES INDEPENDIENTES"
  },
  {
    "codigo":271364002,
    "descripcion":"HALLAZGO RELACIONADO CON LA ESPERA PARA UBICACIÓN O REUBICACIÓN EN VIVIENDA"
  },
  {
    "codigo":402436004,
    "descripcion":"ESPONGIOSIS EOSINOFÍLICA (PENFIGOIDE PREBULLOSO)"
  },
  {
    "codigo":369668005,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA DE PLEURA Y GRANDES VASOS, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":1156100006,
    "descripcion":"EMBARAZO CON PRUEBA DE TOLERANCIA A LA GLUCOSA NORMAL"
  },
  {
    "codigo":304132006,
    "descripcion":"APLASIA HEMATOPOYÉTICA"
  },
  {
    "codigo":1187033000,
    "descripcion":"VITAMINA K2 DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":205828009,
    "descripcion":"SÍNDROME DE BIEMOND"
  },
  {
    "codigo":346121000119107,
    "descripcion":"QUERATOCONJUNTIVITIS BILATERAL POR EXPOSICIÓN"
  },
  {
    "codigo":105689003,
    "descripcion":"ENFERMEDAD CAUSADA POR MESOCESTOIDIDAE"
  },
  {
    "codigo":171225004,
    "descripcion":"FACTORES DE RIESGO PRESENTES AL MOMENTO DE CRIBADO PARA HIPERTENSIÓN"
  },
  {
    "codigo":236761004,
    "descripcion":"FUNCIONAMIENTO DEFECTUOSO DE PRÓTESIS DE PENE"
  },
  {
    "codigo":302297009,
    "descripcion":"DEFORMIDAD CONGÉNITA DE PIE"
  },
  {
    "codigo":300462002,
    "descripcion":"HALLAZGO RELACIONADO CON VACIAMIENTO DE VEJIGA URINARIA"
  },
  {
    "codigo":71086005,
    "descripcion":"LEUCOPLASIA DE LAS CUERDAS VOCALES"
  },
  {
    "codigo":202158006,
    "descripcion":"ARTROFITO EN ARTICULACIÓN DE CODO"
  },
  {
    "codigo":365998007,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA HABLAR ACERCA DE PROBLEMAS"
  },
  {
    "codigo":890286007,
    "descripcion":"POLIMICROGIRIA FRONTOPARIETAL BILATERAL"
  },
  {
    "codigo":36483003,
    "descripcion":"CÁLCULO DE VÍA BILIAR CON COLECISTITIS"
  },
  {
    "codigo":724611004,
    "descripcion":"GRANULOMA POR CUERPO EXTRAÑO DE PARTES BLANDAS"
  },
  {
    "codigo":298627004,
    "descripcion":"AMPLITUD DE FLEXIÓN LATERAL ACTIVA HACIA LA DERECHA DE LA COLUMNA VERTEBRAL LUMBAR, DISMINUIDA"
  },
  {
    "codigo":1148760001,
    "descripcion":"CON MAYOR RIESGO DE NEOPLASIA MALIGNA RECURRENTE"
  },
  {
    "codigo":423816008,
    "descripcion":"SEMINOMA DE TESTÍCULO, ESTADIO 1"
  },
  {
    "codigo":296792004,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE RIFAMPICINA"
  },
  {
    "codigo":1279832006,
    "descripcion":"OCLUSIÓN AGUDA DE ARTERIA PERIFÉRICA DEBIDA A TROMBOSIS"
  },
  {
    "codigo":131117001,
    "descripcion":"NIVEL DE VITAMINA K POR DEBAJO DE RANGO DE REFERENCIA"
  },
  {
    "codigo":294957004,
    "descripcion":"ALERGIA A PROBUCOL"
  },
  {
    "codigo":360493007,
    "descripcion":"PIEL ANORMAL (ESPECIALMENTE DE LA CARA)"
  },
  {
    "codigo":1145090000,
    "descripcion":"PESTAÑAS BLANCAS"
  },
  {
    "codigo":720941007,
    "descripcion":"TRASTORNO CONGÉNITO DE GLICOSILACIÓN 1 VINCULADO A ASPARAGINA"
  },
  {
    "codigo":293122006,
    "descripcion":"REACCIÓN ADVERSA A VACUNA ANTITIFOIDEA"
  },
  {
    "codigo":162050009,
    "descripcion":"DOLOR EN EL FLANCO DERECHO"
  },
  {
    "codigo":291287004,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR BLOQUEANTE DEL CANAL DE CALCIO"
  },
  {
    "codigo":289452000,
    "descripcion":"ARCO PÚBICO PEQUEÑO"
  },
  {
    "codigo":94679009,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LAS CUERDAS VOCALES"
  },
  {
    "codigo":1338028003,
    "descripcion":"OSTEOPOROSIS CAUSADA POR RADIACIÓN IONIZANTE"
  },
  {
    "codigo":191148006,
    "descripcion":"ANEMIA MEDICAMENTOSA POR DEFICIENCIA DE FOLATOS"
  },
  {
    "codigo":715436007,
    "descripcion":"HIPOPLASIA CONGÉNITA DE CEREBELO CONCOMITANTE CON DEGENERACIÓN TAPETORRETINIANA"
  },
  {
    "codigo":125612008,
    "descripcion":"LUXACIÓN TRAUMÁTICA DEL ESTERNÓN"
  },
  {
    "codigo":92844009,
    "descripcion":"FUSIÓN ANORMAL CONGÉNITA DE CARTÍLAGO CENTRAL DE VÉRTEBRA CERVICAL"
  },
  {
    "codigo":123777002,
    "descripcion":"LEUCOPENIA AUTOINMUNITARIA"
  },
  {
    "codigo":102871000119101,
    "descripcion":"HIPOTIROIDISMO DEBIDO A TIROIDITIS"
  },
  {
    "codigo":420524008,
    "descripcion":"SARCOMA DE KAPOSI ASOCIADO CON SIDA (SÍNDROME DE INMUNODEFICIENCIA ADQUIRIDA)"
  },
  {
    "codigo":254849005,
    "descripcion":"TUMOR EPITELIAL MALIGNO DE OVARIO"
  },
  {
    "codigo":418689008,
    "descripcion":"ALERGIA A POLEN DE GRAMÍNEA"
  },
  {
    "codigo":1268822006,
    "descripcion":"INFECCIÓN ASOCIADA CON PRÓTESIS ARTICULAR DE CADERA"
  },
  {
    "codigo":251179004,
    "descripcion":"COMPLEJOS VENTRICULARES INTERPOLADOS MÚLTIPLES"
  },
  {
    "codigo":216576002,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ÉTER"
  },
  {
    "codigo":249344003,
    "descripcion":"VARIACIÓN EN LA PERMEABILIDAD DE LA VÍA AÉREA NASAL"
  },
  {
    "codigo":183808007,
    "descripcion":"ESTADÍA DE INTERNACIÓN, 10 DÍAS"
  },
  {
    "codigo":708096008,
    "descripcion":"EXACERBACIÓN SEVERA AGUDA DE ASMA INTRÍNSECA"
  },
  {
    "codigo":19968009,
    "descripcion":"COLECISTITIS ALITIÁSICA"
  },
  {
    "codigo":313045006,
    "descripcion":"HERIDA CAUSADA POR CLAVO METÁLICO"
  },
  {
    "codigo":247509007,
    "descripcion":"LEUCONIQUIA ESTRIADA"
  },
  {
    "codigo":704426000,
    "descripcion":"ALTERACIÓN DEL ESTADO DE ALERTA MENTAL"
  },
  {
    "codigo":409514003,
    "descripcion":"GANGRENA ACRAL"
  },
  {
    "codigo":737194006,
    "descripcion":"INFLAMACIÓN DE INTESTINO DELGADO DE CAUSA ALIMENTARIA"
  },
  {
    "codigo":276607000,
    "descripcion":"RETARDO SIMÉTRICO DEL CRECIMIENTO"
  },
  {
    "codigo":768127002,
    "descripcion":"HEPATITIS C CRÓNICA CAUSADA POR GENOTIPO 1 DE VIRUS HEPATITIS C"
  },
  {
    "codigo":1259647003,
    "descripcion":"COREA DEBIDA A POLICITEMIA RUBRA VERA"
  },
  {
    "codigo":15723121000119104,
    "descripcion":"ARTROSIS SECUNDARIA DE AMBAS CADERAS"
  },
  {
    "codigo":78164000,
    "descripcion":"PROBLEMAS DE ALIMENTACIÓN"
  },
  {
    "codigo":76401000119105,
    "descripcion":"ANOMALÍA CONGÉNITA DE URÉTER Y PELVIS RENAL"
  },
  {
    "codigo":242004002,
    "descripcion":"DAÑO TISULAR DIRECTO CAUSADO POR EXPLOSIÓN"
  },
  {
    "codigo":373076003,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM TRIPLEX"
  },
  {
    "codigo":829993001,
    "descripcion":"PIEL DE MANOS ÁSPERA"
  },
  {
    "codigo":305705002,
    "descripcion":"VISTO POR UN CIRUJANO DE TÓRAX"
  },
  {
    "codigo":764457005,
    "descripcion":"ARRITMIA CARDÍACA RELACIONADA CON ANQUIRINA B"
  },
  {
    "codigo":76329007,
    "descripcion":"INFESTACIÓN CAUSADA POR PNEUMONYSSUS"
  },
  {
    "codigo":698921008,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: ESLOVENO"
  },
  {
    "codigo":43561008,
    "descripcion":"OTITIS MEDIA CRÓNICA EXUDATIVA"
  },
  {
    "codigo":404009009,
    "descripcion":"DERMATOFIBROSARCOMA PROTUBERANTE CON CAMBIOS EN CÉLULAS DE LA GRANULOSA"
  },
  {
    "codigo":762622003,
    "descripcion":"PENSAMIENTOS REFERENCIALES"
  },
  {
    "codigo":402174004,
    "descripcion":"REACCIÓN FOTOTÓXICA CAUSADA POR COLORANTE"
  },
  {
    "codigo":11790961000119109,
    "descripcion":"CONTUSIÓN DE PIERNA DERECHA"
  },
  {
    "codigo":1286910006,
    "descripcion":"HEMORRAGIA INTRAVENTRICULAR NO TRAUMÁTICA GRADO 1 DURANTE PERÍODO FETAL"
  },
  {
    "codigo":302035005,
    "descripcion":"FRACTURA-LUXACIÓN NO EXPUESTA DE ARTICULACIÓN METATARSOFALÁNGICA"
  },
  {
    "codigo":236499007,
    "descripcion":"NEFROPATÍA DIABÉTICA MICROALBUMINÚRICA"
  },
  {
    "codigo":1217704000,
    "descripcion":"INFLAMACIÓN CRÓNICA DE BOLSA ILEAL REFRACTARIA A ANTIBIÓTICO"
  },
  {
    "codigo":365736003,
    "descripcion":"NIVEL SÉRICO DE DIGOXINA - HALLAZGO"
  },
  {
    "codigo":267432004,
    "descripcion":"HIPERCOLESTEROLEMIA PURA"
  },
  {
    "codigo":36221001,
    "descripcion":"CARDIOPATÍA HIPERTENSIVA BENIGNA"
  },
  {
    "codigo":200061003,
    "descripcion":"ANESTESIA OBSTÉTRICA CON COMPLICACIONES DEL SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":429437003,
    "descripcion":"ABSCESO EN ESPACIO EPIDURAL LUMBAR"
  },
  {
    "codigo":724349009,
    "descripcion":"SÍNDROME DE MIOPATÍA HEREDITARIA CON CUERPOS DE INCLUSIÓN, CONTRACTURAS ARTICULARES Y OFTALMOPLEJÍA"
  },
  {
    "codigo":722514002,
    "descripcion":"LEIOMIOSARCOMA PRIMARIO DE PERITONEO"
  },
  {
    "codigo":460370001,
    "descripcion":"ARTERIA COLATERAL QUE DERIVA EL FLUJO SISTÉMICO HACIA LA CIRCULACIÓN PULMONAR QUE CONECTA CON ARTERIA"
  },
  {
    "codigo":427602004,
    "descripcion":"ANEURISMA ROTO DE ARTERIA ILÍACA COMÚN"
  },
  {
    "codigo":296530008,
    "descripcion":"SOBREDOSIS DE ANTIBIÓTICO ANTIMICÓTICO"
  },
  {
    "codigo":720679004,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR CERIVASTATINA"
  },
  {
    "codigo":294695007,
    "descripcion":"ALERGIA A CORTISONA"
  },
  {
    "codigo":292860006,
    "descripcion":"REACCIÓN ADVERSA A LA MEPACRINA"
  },
  {
    "codigo":192721000,
    "descripcion":"ENCEFALITIS POSVACUNACIÓN ANTIGRIPAL"
  },
  {
    "codigo":784380009,
    "descripcion":"ATAXIA ESPÁSTICA AUTOSÓMICA DOMINANTE TIPO 1"
  },
  {
    "codigo":1144828009,
    "descripcion":"INTOXICACIÓN CAUSADA POR TOLAZOLINA"
  },
  {
    "codigo":225489003,
    "descripcion":"EMPLEA ORACIONES EN PRIMERA PERSONA"
  },
  {
    "codigo":63484008,
    "descripcion":"NEUTROFILIA MEDICAMENTOSA"
  },
  {
    "codigo":94417005,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE GLÁNDULAS ENDOCRINAS MÚLTIPLES"
  },
  {
    "codigo":127185004,
    "descripcion":"LINFADENOPATÍA VESICULAR LATERAL"
  },
  {
    "codigo":61649007,
    "descripcion":"HIPOPIGMENTACIÓN OCULOCUTÁNEA CONGÉNITA"
  },
  {
    "codigo":678821000119108,
    "descripcion":"NÉBULA DE AMBAS CÓRNEAS"
  },
  {
    "codigo":30716008,
    "descripcion":"INFECCIÓN CAUSADA POR OESOPHAGOSTOMUM COLUMBIANUM"
  },
  {
    "codigo":289190003,
    "descripcion":"VOZ NASAL"
  },
  {
    "codigo":1335931001,
    "descripcion":"MELANOMA MALIGNO DE CABEZA"
  },
  {
    "codigo":92582009,
    "descripcion":"CARCINOMA IN SITU DEL ENDOMETRIO"
  },
  {
    "codigo":713339002,
    "descripcion":"INFECCIÓN CAUSADA POR STRONGYLOIDES CONCOMITANTE CON INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":1303163007,
    "descripcion":"LACERACIÓN DE MÚSCULO DE PIERNA"
  },
  {
    "codigo":449360002,
    "descripcion":"CON DIETA ESPECIAL"
  },
  {
    "codigo":416592005,
    "descripcion":"CIZALLAMIENTO DE LA PORCIÓN INFERIOR DEL PUBIS"
  },
  {
    "codigo":285520009,
    "descripcion":"MUEVE LA PUNTA DE LA LENGUA"
  },
  {
    "codigo":250917004,
    "descripcion":"SANGRE ESTANCADA ECOGÉNICA EN EL VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":249082000,
    "descripcion":"PRESENTACIÓN DE FONTANELA ANTERIOR"
  },
  {
    "codigo":283685009,
    "descripcion":"MORDEDURA HUMANA EN LA CABEZA"
  },
  {
    "codigo":609530001,
    "descripcion":"NEUROPATÍA DE NERVIO PERONEO COMÚN EN RAMA DE CIÁTICO POPLÍTEO EXTERNO"
  },
  {
    "codigo":52474000,
    "descripcion":"ECTROMELIA DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":1363194000,
    "descripcion":"HALLAZGO RELACIONADO CON CAPACIDAD PARA MANTENER LA POSICIÓN SEDENTE EN ASIENTO DE INODORO"
  },
  {
    "codigo":871674002,
    "descripcion":"REACCIÓN ADVERSA A ÁCIDO PAMIDRÓNICO"
  },
  {
    "codigo":771535000,
    "descripcion":"INFECCIÓN SUPERFICIAL DEL TEJIDO CELULAR SUBCUTÁNEO EN EL LUGAR DE PUNCIÓN DE LA ANESTESIA POR BLOQUEO PERIFÉRICO"
  },
  {
    "codigo":707834009,
    "descripcion":"CISTITIS CRÓNICA REAGUDIZADA"
  },
  {
    "codigo":247247001,
    "descripcion":"HALLAZGO RELACIONADO CON EL CONDUCTO AUDITIVO"
  },
  {
    "codigo":50639002,
    "descripcion":"PARÁLISIS PALATINA DEL NERVIO VAGO"
  },
  {
    "codigo":16036000,
    "descripcion":"EMPIEMA AGUDO DE SENO FRONTAL"
  },
  {
    "codigo":212644000,
    "descripcion":"INTOXICACIÓN CON MEFENESINA"
  },
  {
    "codigo":442020005,
    "descripcion":"HEMIPLEJÍA FLÁCCIDA DE LADO DOMINANTE"
  },
  {
    "codigo":25971000119100,
    "descripcion":"MARCA DE NACIMIENTO VASCULAR"
  },
  {
    "codigo":704164005,
    "descripcion":"FRACTURA NO EXPUESTA DE FALANGE MEDIA DE DEDO MEÑIQUE"
  },
  {
    "codigo":1162916008,
    "descripcion":"ENFERMEDAD DE ALMACENAMIENTO DE GLUCÓGENO DEBIDA A DEFICIENCIA DE BETA-ENOLASA MUSCULAR"
  },
  {
    "codigo":210809009,
    "descripcion":"LESIÓN DE LA VENA MESENTÉRICA SUPERIOR"
  },
  {
    "codigo":1259385009,
    "descripcion":"CISTOADENOCARCINOMA MUCINOSO PRIMARIO DE OVARIO"
  },
  {
    "codigo":405582003,
    "descripcion":"INFECCIÓN RETROPERITONEAL"
  },
  {
    "codigo":15699161000119109,
    "descripcion":"ATROFIA ÓPTICA IZQUIERDA HEREDITARIA"
  },
  {
    "codigo":208974005,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA EXPUESTA DE LA ARTICULACIÓN DE LA RODILLA, ROTATORIA"
  },
  {
    "codigo":403747000,
    "descripcion":"NÓDULOS DE POPPERS POR ABUSO DE DROGAS INTRAVENOSAS"
  },
  {
    "codigo":76067001,
    "descripcion":"ESTORNUDO"
  },
  {
    "codigo":895267001,
    "descripcion":"FORMA ANCHA ANORMAL CONGÉNITA DE FALANGE PROXIMAL DE DEDO ÍNDICE"
  },
  {
    "codigo":698659003,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: ESTONIO"
  },
  {
    "codigo":1090931000119104,
    "descripcion":"TRASTORNO AUTOINMUNITARIO DE OÍDO INTERNO DERECHO"
  },
  {
    "codigo":305443003,
    "descripcion":"BAJO ATENCIÓN DE CONSEJERO ESPECIALIZADO EN SALUD MENTAL"
  },
  {
    "codigo":370979009,
    "descripcion":"ALANINA AMINOTRANSFERASA DENTRO DEL RANGO DE REFERENCIA CON VIREMIA PERSISTENTE DETECTADA POR REACCIÓN EN CADENA DE LA POLIMERASA"
  },
  {
    "codigo":205304002,
    "descripcion":"ANILLO DE CONSTRICCIÓN DE EXTREMIDAD SUPERIOR CON ACROSINDACTILIA Y AMPUTACIÓN"
  },
  {
    "codigo":762360003,
    "descripcion":"LESIÓN TRAUMÁTICA DE VÍA ÓPTICA IZQUIERDA"
  },
  {
    "codigo":238072006,
    "descripcion":"DEFICIENCIA AISLADA DE DIHIDROACETONA FOSFATO ACILTRANSFERASA"
  },
  {
    "codigo":400077000,
    "descripcion":"DISTROFIA UNGUEAL POR COMERSE LAS UÑAS"
  },
  {
    "codigo":301773003,
    "descripcion":"DOLOR DE FÉMUR"
  },
  {
    "codigo":6861003,
    "descripcion":"ARTRITIS PIÓGENA DEL PIE"
  },
  {
    "codigo":39629007,
    "descripcion":"GRANULOMA PIÓGENO DE LA PIEL"
  },
  {
    "codigo":431010004,
    "descripcion":"EFECTO TARDÍO DE RADIOTERAPIA"
  },
  {
    "codigo":299938006,
    "descripcion":"SOMATOESTESIA PRESENTE"
  },
  {
    "codigo":234402007,
    "descripcion":"ANEMIA HEMILÍTICA CRÓNICA NO ESFEROCÍTICA"
  },
  {
    "codigo":37794007,
    "descripcion":"RETRACCIÓN"
  },
  {
    "codigo":201634008,
    "descripcion":"CONDROCALCINOSIS DE MÚLTIPLES LOCALIZACIONES CAUSADA POR CRISTALES DE FOSFATO DICÁLCICO"
  },
  {
    "codigo":365474007,
    "descripcion":"HALLAZGO RELACIONADO CON DETALLES DE LA COMPOSICIÓN FAMILIAR"
  },
  {
    "codigo":298103000,
    "descripcion":"CUERPO EXTRAÑO EN LA PIEL DEL DEDO GORDO"
  },
  {
    "codigo":396407004,
    "descripcion":"COMPROMISO DEL ESPÉCIMEN POR GANGLIO(S) SATÉLITE(S): AUSENTE(S)"
  },
  {
    "codigo":34124000,
    "descripcion":"CUERPO EXTRAÑO EN LA VAGINA"
  },
  {
    "codigo":66892003,
    "descripcion":"INTENTO FALLIDO DE ABORTO CON INFECCIÓN DE LA VÍA URINARIA"
  },
  {
    "codigo":197964007,
    "descripcion":"PROSTATITIS ACTINOMICÓTICA"
  },
  {
    "codigo":1356007,
    "descripcion":"CÁLCULO DEL COLÉDOCO CON OBSTRUCCIÓN"
  },
  {
    "codigo":230732009,
    "descripcion":"ARTERITIS CEREBRAL EN ARTERITIS POR CÉLULAS GIGANTES"
  },
  {
    "codigo":720417003,
    "descripcion":"ACROCEFALOPOLIDACTILIA"
  },
  {
    "codigo":294433006,
    "descripcion":"ALERGIA A BORATO"
  },
  {
    "codigo":425505007,
    "descripcion":"UTILIZA PROTECCIÓN OCULAR"
  },
  {
    "codigo":292598000,
    "descripcion":"REACCIÓN ADVERSA A LA TRIMEPRAZINA"
  },
  {
    "codigo":1144566001,
    "descripcion":"LOGRA CONTROLAR SÍNTOMAS DE ABSTINENCIA"
  },
  {
    "codigo":126923002,
    "descripcion":"NEOPLASIA DE LABIOS MAYORES VULVARES"
  },
  {
    "codigo":28619004,
    "descripcion":"ASTENIA ANHIDRÓTICA TROPICAL"
  },
  {
    "codigo":290763005,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR VINBLASTINA"
  },
  {
    "codigo":61387006,
    "descripcion":"ANSIEDAD MODERADA"
  },
  {
    "codigo":716747007,
    "descripcion":"SÍNDROME DE AMINOACIDURIA DICARBOXÍLICA"
  },
  {
    "codigo":94155008,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE SENO PARANASAL"
  },
  {
    "codigo":1306571005,
    "descripcion":"CARCINOMA DUCTAL INFILTRANTE DE CUADRANTE SUPERIOR INTERNO DE MAMA IZQUIERDA"
  },
  {
    "codigo":92320002,
    "descripcion":"NEOPLASIA BENIGNA DEL TRACTO RESPIRATORIO"
  },
  {
    "codigo":59552005,
    "descripcion":"EYACULACIÓN NORMAL"
  },
  {
    "codigo":10923841000119100,
    "descripcion":"FRACTURA NO EXPUESTA DE BASE DE TERCER HUESO METACARPIANO DE MANO IZQUIERDA"
  },
  {
    "codigo":420000008,
    "descripcion":"ADHERENCIA CORNEOVÍTREA"
  },
  {
    "codigo":288928009,
    "descripcion":"DIFICULTAD PARA IMPULSAR BOLO ALIMENTARIO HACIA LA FARINGE"
  },
  {
    "codigo":287093006,
    "descripcion":"LUXACIÓN DE RODILLA CON DESGARRO DE MENISCO INTERNO"
  },
  {
    "codigo":1237365009,
    "descripcion":"ESPECTRO APROSENCEFALIA Y ATELENCEFALIA"
  },
  {
    "codigo":449098005,
    "descripcion":"ANOMALÍA CONGÉNITA DE CUERDAS TENDINOSAS DE VÁLVULA AURICULOVENTRICULAR IZQUIERDA EN VENTRÍCULO CON DOBLE TRACTO DE ENTRADA"
  },
  {
    "codigo":1268298007,
    "descripcion":"FRACTURA ABIERTA DE PARED SUPERIOR DE ÓRBITA"
  },
  {
    "codigo":840479000,
    "descripcion":"ENTROPIÓN CONGÉNITO BILATERAL"
  },
  {
    "codigo":283423006,
    "descripcion":"CORTE EN EL TÓRAX"
  },
  {
    "codigo":414495006,
    "descripcion":"INFESTACIÓN CAUSADA POR DEMODEX"
  },
  {
    "codigo":21279007,
    "descripcion":"TIROIDES LINGUAL"
  },
  {
    "codigo":248820000,
    "descripcion":"AUSENCIA DE PEZÓN"
  },
  {
    "codigo":84980006,
    "descripcion":"CARBUNCO CUTÁNEO"
  },
  {
    "codigo":52212006,
    "descripcion":"ANEMIA HEMOLÍTICA NO ESFEROCÍTICA HEREDITARIA POR DEFICIENCIA DE GLUTATIÓN REDUCTASA"
  },
  {
    "codigo":246985000,
    "descripcion":"CÁMARA ANTERIOR - HALLAZGO"
  },
  {
    "codigo":15648731000119101,
    "descripcion":"ATEROSCLEROSIS DE ARTERIA RENAL DERECHA"
  },
  {
    "codigo":83145004,
    "descripcion":"PATRÓN DERMATOGLÍFICO ANORMAL"
  },
  {
    "codigo":1230025003,
    "descripcion":"ÚTERO SEPTADO COMPLETO"
  },
  {
    "codigo":703902000,
    "descripcion":"ALERGIA A PROTEÍNA DE DERMATOPHAGOIDES FARINAE"
  },
  {
    "codigo":212382003,
    "descripcion":"SÍNDROME COMPARTIMENTAL DE MANO DEBIDO A LESIÓN TRAUMÁTICA"
  },
  {
    "codigo":15675201000119109,
    "descripcion":"TENDINITIS DE LA ARTICULACIÓN METATARSOFALÁNGICA DEL SEGUNDO DEDO DEL PIE IZQUIERDO"
  },
  {
    "codigo":1162654006,
    "descripcion":"ESPLENOMEGALIA DEBIDA A ENFERMEDAD POR DEPÓSITO"
  },
  {
    "codigo":210547005,
    "descripcion":"SECCIÓN COMPLETA DE TENDÓN EXTENSOR DE LA MUÑECA"
  },
  {
    "codigo":1259123006,
    "descripcion":"COMPLEJO ESCLEROSIS LATERAL AMIOTRÓFICA, PARKINSONISMO Y DEMENCIA DE PENÍNSULA KII"
  },
  {
    "codigo":896840005,
    "descripcion":"FORMA TRIANGULAR ANORMAL CONGÉNITA DE EPÍFISIS DE FALANGE DISTAL DE MANO"
  },
  {
    "codigo":12104008,
    "descripcion":"FÍSTULA RECTOCLOACAL CONGÉNITA"
  },
  {
    "codigo":10269001,
    "descripcion":"SÍNDROME DE ASPIRACIÓN MASIVA"
  },
  {
    "codigo":208712008,
    "descripcion":"FRACTURA NO EXPUESTA DE TERCERA FALANGE DE DEDO DE PIE"
  },
  {
    "codigo":403485001,
    "descripcion":"NEOPLASIA INTRAEPITELIAL ANAL (NIA III)"
  },
  {
    "codigo":1351922001,
    "descripcion":"SÍNDROME DE BROWN-SÉQUARD DEBIDO A HERIDA DE ARMA DE FUEGO"
  },
  {
    "codigo":237810005,
    "descripcion":"FEMINIZACIÓN POR TUMOR"
  },
  {
    "codigo":73970005,
    "descripcion":"LINFANGITIS AGUDA DE LA CARA"
  },
  {
    "codigo":39367000,
    "descripcion":"ENFERMEDAD INFLAMATORIA DEL SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":301511005,
    "descripcion":"ENTRA EN LA DUCHA"
  },
  {
    "codigo":1153479007,
    "descripcion":"AMINOÁCIDOS SÉRICOS POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":135836000,
    "descripcion":"ENFERMEDAD PULMONAR OBSTRUCTIVA CRÓNICA, ESTADIO TERMINAL"
  },
  {
    "codigo":168604000,
    "descripcion":"RADIOGRAFÍA SIMPLE DE PELVIS ANORMAL"
  },
  {
    "codigo":234140000,
    "descripcion":"HEMANGIOMAS CAVERNOSOS DE LA CARA Y DEL RAFE DE LA LÍNEA MEDIA SUPRAUMBILICAL"
  },
  {
    "codigo":299676003,
    "descripcion":"CRECIMIENTO EXCESIVO DEL VELLO FACIAL"
  },
  {
    "codigo":365212001,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA PONERSE EN CUCLILLAS EN EL INODORO"
  },
  {
    "codigo":37532005,
    "descripcion":"FÍSTULA URETEROVAGINAL"
  },
  {
    "codigo":11827471000119100,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN DE DEDO DEL PIE IZQUIERDO"
  },
  {
    "codigo":686351000119100,
    "descripcion":"HISTIOCITOMA FIBROSO MALIGNO PRIMARIO DE PARTES BLANDAS DE CUELLO"
  },
  {
    "codigo":235975009,
    "descripcion":"ESTENOSIS PAPILAR DUODENAL"
  },
  {
    "codigo":2929001,
    "descripcion":"OCLUSIÓN ARTERIAL"
  },
  {
    "codigo":363377003,
    "descripcion":"NEOPLASIA MALIGNA DE AMÍGDALA LINGUAL"
  },
  {
    "codigo":723825006,
    "descripcion":"PARAPLEJÍA ESPÁSTICA AUTOSÓMICA RECESIVA TIPO 55"
  },
  {
    "codigo":232305009,
    "descripcion":"DILATACIÓN DE CONDUCTO SEMICIRCULAR"
  },
  {
    "codigo":164934002,
    "descripcion":"ONDA T ANORMAL EN EL ELECTROCARDIOGRAMA"
  },
  {
    "codigo":296006002,
    "descripcion":"SOBREDOSIS DE ETOSUXIMIDA"
  },
  {
    "codigo":263238004,
    "descripcion":"FRACTURA EXPUESTA DE TUBEROSIDAD TIBIAL"
  },
  {
    "codigo":230470007,
    "descripcion":"CEFALEA TENSIONAL EPISÓDICA"
  },
  {
    "codigo":195867000,
    "descripcion":"QUISTE LARÍNGEO"
  },
  {
    "codigo":359707007,
    "descripcion":"CORIORRETINITIS FÚNGICA"
  },
  {
    "codigo":1144304002,
    "descripcion":"LEIOMIOSARCOMA DEL ANTRO PILÓRICO"
  },
  {
    "codigo":292336003,
    "descripcion":"REACCIÓN ADVERSA AL PARALDEHÍDO"
  },
  {
    "codigo":1177072008,
    "descripcion":"DUODENITIS MICOBACTERIANA NO TUBERCULOSA"
  },
  {
    "codigo":126661001,
    "descripcion":"TRASTORNO DE LA OROFARINGE"
  },
  {
    "codigo":716485006,
    "descripcion":"DIFICULTAD PARA COMPRENDER LENGUAJE ESCRITO"
  },
  {
    "codigo":93893006,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE HUESO METATARSIANO"
  },
  {
    "codigo":26522000,
    "descripcion":"RECHAZO HIPERAGUDO DE INJERTO"
  },
  {
    "codigo":28357009,
    "descripcion":"PERTURBACIÓN TRANSITORIA DEL ESTADO DE ÁNIMO EN EL PERÍODO POSTPARTO"
  },
  {
    "codigo":224965009,
    "descripcion":"HALLAZGO RELACIONADO CON EL DUELO"
  },
  {
    "codigo":1306309009,
    "descripcion":"NEOPLASIA MALIGNA DE ARÉOLA"
  },
  {
    "codigo":92058007,
    "descripcion":"NEOPLASIA BENIGNA DE LA PARED DEL TÓRAX"
  },
  {
    "codigo":419738008,
    "descripcion":"PAPILOMA CONJUNTIVAL PEDUNCULADO"
  },
  {
    "codigo":288666009,
    "descripcion":"MANTIENE LA CONVERSACIÓN"
  },
  {
    "codigo":286831002,
    "descripcion":"TIENDE A MENTIR CON FRECUENCIA SIN RAZÓN"
  },
  {
    "codigo":1204335006,
    "descripcion":"INFECCIÓN DE COLGAJO ÓSEO CRANEAL"
  },
  {
    "codigo":448836001,
    "descripcion":"VALVA DE VÁLVULA AURICULOVENTRICULAR ENGROSADA EN DEFECTO DE TABIQUE INTERVENTRICULAR"
  },
  {
    "codigo":284996007,
    "descripcion":"DIFICULTAD PARA DESCALZARSE"
  },
  {
    "codigo":283161000,
    "descripcion":"CUERPO EXTRAÑO METÁLICO EN EL DORSO DE LA MANO"
  },
  {
    "codigo":709145001,
    "descripcion":"NEUROPATÍA PERIFÉRICA DEBIDA A INFLAMACIÓN"
  },
  {
    "codigo":416068009,
    "descripcion":"LESIÓN PERFORANTE DEL CRISTALINO"
  },
  {
    "codigo":15733161000119107,
    "descripcion":"RETINOSQUISIS BULLOSA DE OJO IZQUIERDO"
  },
  {
    "codigo":53785005,
    "descripcion":"LESIÓN DEL PLEXO BRAQUIAL COMO MANIFESTACIÓN DE TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":1004057008,
    "descripcion":"CONTRACTURA EN FLEXIÓN DE ARTICULACIÓN INTERFALÁNGICA DISTAL DE CUARTO DEDO DE PIE"
  },
  {
    "codigo":281326005,
    "descripcion":"FECHA DE RECOLECCIÓN DEL ESPÉCIMEN NO SUMINISTRADA"
  },
  {
    "codigo":838382005,
    "descripcion":"VESTIBULOPATÍA BILATERAL CRÓNICA CAUSADA POR AGENTE OTOTÓXICO"
  },
  {
    "codigo":1264366005,
    "descripcion":"LACERACIÓN DE TENDÓN DE MUÑECA"
  },
  {
    "codigo":246723000,
    "descripcion":"EQUILIBRIO DE LOS MÚSCULOS OCULARES, NORMAL"
  },
  {
    "codigo":445166009,
    "descripcion":"DEGENERACIÓN QUÍSTICA DE CEREBRO"
  },
  {
    "codigo":1297134006,
    "descripcion":"CUELLO FEMORAL VALGO ADQUIRIDO DERECHO"
  },
  {
    "codigo":117486006,
    "descripcion":"CRISTAL URINARIO, DIHIDRATO DE FOSFATO DE HIDRÓGENO CÁLCICO"
  },
  {
    "codigo":707310009,
    "descripcion":"GLOBODONCIA"
  },
  {
    "codigo":82883008,
    "descripcion":"ALTERACIÓN EN EL RITMO DEL HABLA"
  },
  {
    "codigo":441496000,
    "descripcion":"FRACTURA TRANSCONDÍLEA DE HÚMERO DISTAL"
  },
  {
    "codigo":212120001,
    "descripcion":"QUEMADURA QUE COMPROMETE MÁS DEL 90 POR CIENTO DE LA SUPERFICIE CORPORAL, CON 40 - 49 POR CIENTO DE SUPERFICIE CORPORAL CON QUEMADURA DE TERCER GRADO"
  },
  {
    "codigo":277656005,
    "descripcion":"HIPOPLASIA PULMONAR PRIMARIA"
  },
  {
    "codigo":305731000119106,
    "descripcion":"QUISTE DE ASTA POSTERIOR DE MENISCO INTERNO DE RODILLA DERECHA"
  },
  {
    "codigo":111981003,
    "descripcion":"PH CUTÁNEO DISMINUIDO"
  },
  {
    "codigo":243053006,
    "descripcion":"LESIÓN POR JABALINA"
  },
  {
    "codigo":273986001,
    "descripcion":"TROMBOCITOPENIA PERINATAL"
  },
  {
    "codigo":208450001,
    "descripcion":"FRACTURA NO EXPUESTA DE LA FALANGE MEDIA DE DEDO DE LA MANO"
  },
  {
    "codigo":372290003,
    "descripcion":"AUSENCIA DE INVASIÓN TUMORAL EN LA GRASA PERIPROSTÁTICA"
  },
  {
    "codigo":306754003,
    "descripcion":"CAPAZ DE PRODUCIR SONIDOS VOCALES"
  },
  {
    "codigo":11774531000119109,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE PULGAR DERECHO"
  },
  {
    "codigo":210285009,
    "descripcion":"LACERACIÓN OCULAR CON PROLAPSO INTRAOCULAR"
  },
  {
    "codigo":110146007,
    "descripcion":"LACERACIÓN COMPLEJA DEL CUELLO"
  },
  {
    "codigo":75543006,
    "descripcion":"EMBOLIA CEREBRAL"
  },
  {
    "codigo":1255191007,
    "descripcion":"CARCINOMA PAPILAR PRIMARIO DE TIROIDES"
  },
  {
    "codigo":403223008,
    "descripcion":"FOTOSUBTIPO CUTÁNEO IIA (AL COMIENZO, SIEMPRE EXISTE QUEMADURA, LUEGO BRONCEADO SUAVE)"
  },
  {
    "codigo":10007009,
    "descripcion":"SÍNDROME DE COFFIN - SIRIS"
  },
  {
    "codigo":688861000119105,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE PALADAR DURO"
  },
  {
    "codigo":434156008,
    "descripcion":"AGENTE INFECCIOSO EN TORRENTE SANGUÍNEO"
  },
  {
    "codigo":237548009,
    "descripcion":"ANOMALÍA DE PREALBÚMINA FIJADORA DE HORMONA TIROIDEA"
  },
  {
    "codigo":235713001,
    "descripcion":"ULCERACIÓN PRIMARIA NO ESPECÍFICA DEL INTESTINO DELGADO"
  },
  {
    "codigo":202945006,
    "descripcion":"GANGLIÓN DE TOBILLO"
  },
  {
    "codigo":299414004,
    "descripcion":"TUMEFACCIÓN DE ARTICULACIÓN DE TOBILLO"
  },
  {
    "codigo":201110004,
    "descripcion":"UÑA DEL PULGAR ENCARNADA"
  },
  {
    "codigo":233878008,
    "descripcion":"MIOCARDIOPATÍA RESTRICTIVA FAMILIAR"
  },
  {
    "codigo":364950008,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA CERRAR LA BOCA"
  },
  {
    "codigo":461419002,
    "descripcion":"OCLUSIÓN ADQUIRIDA DE VENA FEMORAL"
  },
  {
    "codigo":232043000,
    "descripcion":"OCLUSIÓN DE VENA RETINIANA HEMISFÉRICA"
  },
  {
    "codigo":10738551000119104,
    "descripcion":"HIPERPLASIA ATÍPICA DE CONDUCTO GALACTÓFORO DE MAMA IZQUIERDA"
  },
  {
    "codigo":68203000,
    "descripcion":"INTOXICACIÓN POR URGINEA"
  },
  {
    "codigo":230208003,
    "descripcion":"ABSCESO PIOGÉNICO CEREBRAL"
  },
  {
    "codigo":262976005,
    "descripcion":"DISTENSIÓN DE TENDÓN DEL MÚSCULO ADUCTOR LARGO"
  },
  {
    "codigo":295744007,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE HIDROXIUREA"
  },
  {
    "codigo":361280008,
    "descripcion":"DISMENORREA ESPASMÓDICA"
  },
  {
    "codigo":832007,
    "descripcion":"DEPRESIÓN MAYOR MODERADA"
  },
  {
    "codigo":293909002,
    "descripcion":"ALERGIA A DICLORALFENAZONA"
  },
  {
    "codigo":228373001,
    "descripcion":"DROGADICTO"
  },
  {
    "codigo":721728007,
    "descripcion":"INFECCIÓN CAUSADA POR ENTEROBACTER"
  },
  {
    "codigo":95466001,
    "descripcion":"PERFORACIÓN CONGÉNITA DEL TABIQUE NASAL"
  },
  {
    "codigo":128234004,
    "descripcion":"TRASTORNO DEL MAXILAR"
  },
  {
    "codigo":290239003,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ETODOLAC"
  },
  {
    "codigo":1142207008,
    "descripcion":"EPIDERMÓLISIS BULLOSA ADQUIRIDA NEONATAL TRANSITORIA"
  },
  {
    "codigo":93631009,
    "descripcion":"FALTA DE OSIFICACIÓN DE CENTRO DE VÉRTEBRA SACRA"
  },
  {
    "codigo":288404002,
    "descripcion":"DIFICULTAD PARA ABRIR Y CERRAR RECIPIENTES"
  },
  {
    "codigo":419476001,
    "descripcion":"DEPÓSITO EPITELIAL EN LA CÓRNEA INDUCIDO POR AMIODARONA"
  },
  {
    "codigo":188265001,
    "descripcion":"NEOPLASIA MALIGNA DEL CRISTALINO"
  },
  {
    "codigo":10957841000119107,
    "descripcion":"HERIDA ABIERTA DE DEDO GRANDE DERECHO"
  },
  {
    "codigo":286569004,
    "descripcion":"DIFICULTAD PARA COMPRENDER LAS PROPIAS EMOCIONES"
  },
  {
    "codigo":253801005,
    "descripcion":"TRIPLICATION DE APÉNDICE ILEOCECAL"
  },
  {
    "codigo":448574001,
    "descripcion":"VENTRÍCULO DERECHO UNIPARTITO"
  },
  {
    "codigo":415806002,
    "descripcion":"UTILIZA ESTRATEGIAS PARA LA TOMA DE DECISIONES"
  },
  {
    "codigo":88126006,
    "descripcion":"INTOXICACIÓN POR STYPANDRA"
  },
  {
    "codigo":282899000,
    "descripcion":"DIFICULTAD PARA ALTERNAR ENTRE SENTARSE Y PARARSE"
  },
  {
    "codigo":250131003,
    "descripcion":"ARTRITIS DE ARTICULACIÓN DE MIEMBRO INFERIOR"
  },
  {
    "codigo":53523003,
    "descripcion":"INTOXICACIÓN CAUSADA POR CACTINOMICINA"
  },
  {
    "codigo":34691000087104,
    "descripcion":"CUTANEOTRICHOSPORON DERMATIS O CUTANEOTRICHOSPORON MUCOIDES"
  },
  {
    "codigo":42371000087104,
    "descripcion":"HERIDA PUNZANTE DE GLÚTEO IZQUIERDO CON CUERPO EXTRAÑO"
  },
  {
    "codigo":39811000087108,
    "descripcion":"ABRASIÓN DE PIEL DE PÁRPADO SUPERIOR DERECHO"
  },
  {
    "codigo":18920006,
    "descripcion":"ARTRITIS BACTERIANA AGUDA"
  },
  {
    "codigo":1231336007,
    "descripcion":"DEPENDENCIA DE PSICOESTIMULANTE, CONTINUA"
  },
  {
    "codigo":1074501000119100,
    "descripcion":"OSTEOARTROSIS DE ARTICULACIÓN MEDIOTARSIANA DE PIE IZQUIERDO"
  },
  {
    "codigo":80786002,
    "descripcion":"ACROSTEÓLISIS IDIOPÁTICA"
  },
  {
    "codigo":1293202005,
    "descripcion":"MASA DE ARTICULACIÓN DE REGIÓN DE HOMBRO DERECHO"
  },
  {
    "codigo":15250008,
    "descripcion":"TRASTORNO DE LA CÓRNEA"
  },
  {
    "codigo":46183008,
    "descripcion":"ABERRACIÓN ESFÉRICA DE LA VISIÓN"
  },
  {
    "codigo":9541000119105,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE VESÍCULA BILIAR"
  },
  {
    "codigo":813541000000100,
    "descripcion":"EMBARAZO PRODUCTO DE REPRODUCCIÓN ASISTIDA"
  },
  {
    "codigo":699708004,
    "descripcion":"FIBROSIS DE CÁPSULA DE ARTICULACIÓN TEMPOROMANDIBULAR"
  },
  {
    "codigo":762341000000102,
    "descripcion":"INCAPAZ DE USAR COMPUTADORA PERSONAL"
  },
  {
    "codigo":372028007,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA COLUMNA VERTEBRAL"
  },
  {
    "codigo":304657000,
    "descripcion":"DIFICULTAD PARA EMPLEAR RAZONAMIENTO VISUOESPACIAL"
  },
  {
    "codigo":10632671000119100,
    "descripcion":"ABSCESO DE MANO DERECHA"
  },
  {
    "codigo":77116006,
    "descripcion":"INFECCIÓN CAUSADA POR BORDETELLA PARAPERTUSSIS"
  },
  {
    "codigo":42513006,
    "descripcion":"QUERATITIS PUNTEADA SUPERFICIAL"
  },
  {
    "codigo":763409006,
    "descripcion":"RABDOMIOSARCOMA DE CUERPO UTERINO"
  },
  {
    "codigo":1254929008,
    "descripcion":"NECROSIS TOTAL DE COLGAJO MIOCUTÁNEO"
  },
  {
    "codigo":239121009,
    "descripcion":"SIRINGOCISTADENOMA PAPILÍFERO"
  },
  {
    "codigo":7910003,
    "descripcion":"ABORTO ESPONTÁNEO CON SALPINGITIS"
  },
  {
    "codigo":237286004,
    "descripcion":"VENAS VARICOSAS DE VULVA EN EL EMBARAZO"
  },
  {
    "codigo":827110005,
    "descripcion":"MASA ABDOMINAL BLANDA"
  },
  {
    "codigo":270054009,
    "descripcion":"PACIENTE REGISTRADO - FP4"
  },
  {
    "codigo":169915004,
    "descripcion":"PUNTAJE DE APGAR A LOS 5 MINUTOS = 5"
  },
  {
    "codigo":268219005,
    "descripcion":"QUISTE EMBRIONARIO DE TROMPA DE FALOPIO Y LIGAMENTO ANCHO"
  },
  {
    "codigo":399291005,
    "descripcion":"DIVERTÍCULO FARINGOESOFÁGICO"
  },
  {
    "codigo":366523008,
    "descripcion":"AMPLITUD DE MOVIMIENTO ACTIVO DE FLEXIÓN DE LA MUÑECA - HALLAZGO"
  },
  {
    "codigo":6075009,
    "descripcion":"GLUCOGENOSIS, FORMA HEPÁTICA"
  },
  {
    "codigo":4240001,
    "descripcion":"RUPTURA DE LA AORTA"
  },
  {
    "codigo":69776003,
    "descripcion":"GASTROENTERITIS AGUDA"
  },
  {
    "codigo":233616001,
    "descripcion":"BLASTOMICOSIS PULMONAR"
  },
  {
    "codigo":310751000119105,
    "descripcion":"MIOSITIS INFECCIOSA DE HOMBRO DERECHO"
  },
  {
    "codigo":725136003,
    "descripcion":"DEFICIENCIA DE COMPLEJO MAYOR DE HISTOCOMPATIBILIDAD DE CLASE I"
  },
  {
    "codigo":299152007,
    "descripcion":"AMPLITUD DE EXTENSIÓN ACTIVA DEL PULGAR NORMAL"
  },
  {
    "codigo":723301009,
    "descripcion":"CÁNCER DE PULMÓN ESCAMOCELULAR NO MICROCÍTICO"
  },
  {
    "codigo":295482003,
    "descripcion":"SOBREDOSIS DE CATÁRTICO EMOLIENTE"
  },
  {
    "codigo":15685241000119103,
    "descripcion":"QUERATITIS INTERSTICIAL BILATERAL CAUSADA POR ALFA HERPESVIRUS HUMANO 3"
  },
  {
    "codigo":721466006,
    "descripcion":"SÍNDROME DEL CORDÓN ANTERIOR DE MÉDULA ESPINAL AL NIVEL DEL DECIMOPRIMER SEGMENTO DORSAL"
  },
  {
    "codigo":262714007,
    "descripcion":"SECCIÓN DE MÉDULA ESPINAL SACRA"
  },
  {
    "codigo":195343000,
    "descripcion":"EMBOLIA Y TROMBOSIS DE ARTERIA HEPÁTICA"
  },
  {
    "codigo":197178009,
    "descripcion":"ABSCESO PARACÓLICO"
  },
  {
    "codigo":129807000,
    "descripcion":"DIFERENCIA DE OPACIDAD SEGÚN LA MAMOGRAFÍA"
  },
  {
    "codigo":293647009,
    "descripcion":"ALERGIA A REGALIZ"
  },
  {
    "codigo":95204003,
    "descripcion":"PERFORACIÓN DE DIVERTÍCULO FARÍNGEO"
  },
  {
    "codigo":193508003,
    "descripcion":"CAMBIOS DEGENERATIVOS EN EL CUERPO CILIAR"
  },
  {
    "codigo":291812005,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR TOLBUTAMIDA"
  },
  {
    "codigo":62436006,
    "descripcion":"PRESIÓN VENOSA YUGULAR ANORMAL"
  },
  {
    "codigo":29668007,
    "descripcion":"QUISTE IDIOPÁTICO EN EL CUERPO CILIAR"
  },
  {
    "codigo":1078244005,
    "descripcion":"AGENESIA DE EPÍFISIS DE HUESO METACARPIANO"
  },
  {
    "codigo":93369005,
    "descripcion":"MICROHEPATÍA CONGÉNITA"
  },
  {
    "codigo":879801006,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE MANO CON INFECCIÓN"
  },
  {
    "codigo":289977006,
    "descripcion":"NO REALIZA ACTIVIDADES DE CUIDADO DE LAS UÑAS"
  },
  {
    "codigo":60601008,
    "descripcion":"EMBOLIA OBSTÉTRICA DE COÁGULO DE SANGRE"
  },
  {
    "codigo":124302001,
    "descripcion":"DEFICIENCIA DE GALACTOCINASA"
  },
  {
    "codigo":714126004,
    "descripcion":"GINGIVITIS GENERALIZADA"
  },
  {
    "codigo":339731000119103,
    "descripcion":"ENTROPIÓN MECÁNICO DE PÁRPADO INFERIOR IZQUIERDO"
  },
  {
    "codigo":24163000,
    "descripcion":"MANTENIMIENTO DE LA MATRIZ ÓSEA DISMINUIDO"
  },
  {
    "codigo":58766009,
    "descripcion":"MENINGOENCEFALOMIELITIS GRANULOMATOSA"
  },
  {
    "codigo":25998009,
    "descripcion":"ACIDOSIS METABÓLICA, BRECHA ANIÓNICA AUMENTADA"
  },
  {
    "codigo":286307003,
    "descripcion":"INCAPAZ DE UTILIZAR VOCALES INDIVIDUALES"
  },
  {
    "codigo":1269347008,
    "descripcion":"CARCINOSARCOMA PRIMARIO DE CUERPO DE ÚTERO"
  },
  {
    "codigo":253539008,
    "descripcion":"HIPOPLASIA DEL TRACTO DE SALIDA DEL VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":251704003,
    "descripcion":"REFLUJO LAGRIMAL MUCOPURULENTO"
  },
  {
    "codigo":445960002,
    "descripcion":"ACÚMULOS DE TÚNELES DE ENDOCÉRVIX"
  },
  {
    "codigo":282637002,
    "descripcion":"NO INTENTA GATEAR"
  },
  {
    "codigo":671451000124107,
    "descripcion":"INSEGURIDAD FINANCIERA DEBIDA A BANCARROTA"
  },
  {
    "codigo":1167373005,
    "descripcion":"SÍNDROME DE REGRESIÓN MOTRIZ Y COGNITIVA DE INICIO EN LA INFANCIA CON TRASTORNO DEL MOVIMIENTO EXTRAPIRAMIDAL"
  },
  {
    "codigo":315405005,
    "descripcion":"NACIDO EN COLOMBIA"
  },
  {
    "codigo":248034004,
    "descripcion":"ROBO A LOS COMPAÑEROS DE ESCUELA"
  },
  {
    "codigo":1296610005,
    "descripcion":"HIPERTENSIÓN OCULAR DE OJO DERECHO DEBIDA A SÍNDROME DE DISPERSIÓN PIGMENTARIA"
  },
  {
    "codigo":84194006,
    "descripcion":"OOFORITIS TUBERCULOSA"
  },
  {
    "codigo":870626008,
    "descripcion":"VIVE CON EL CÓNYUGE SOLAMENTE"
  },
  {
    "codigo":410039003,
    "descripcion":"MICETOMA"
  },
  {
    "codigo":735884002,
    "descripcion":"LUXACIÓN TRAUMÁTICA DE ARTICULACIÓN METATARSOFALÁNGICA DE SEGUNDO A QUINTO DEDOS"
  },
  {
    "codigo":80524004,
    "descripcion":"DERMATOSIS INFLAMATORIA CON HIPERQUERATOSIS"
  },
  {
    "codigo":47756005,
    "descripcion":"LINFANGITIS AGUDA DE LA CARA EXTERNA DE LA MEJILLA"
  },
  {
    "codigo":211596006,
    "descripcion":"LESIÓN TRAUMÁTICA CERRADA POR APLASTAMIENTO, PIERNA"
  },
  {
    "codigo":209761001,
    "descripcion":"RUPTURA DE TENDÓN DEL ANTEBRAZO O DE LA MUÑECA"
  },
  {
    "codigo":766817004,
    "descripcion":"BAJA ESTATURA DEBIDA A DEFICIENCIA DE RECEPTOR SECRETAGOGO DE HORMONA DE CRECIMIENTO"
  },
  {
    "codigo":78689005,
    "descripcion":"SÍNDROME CEREBRAL CRÓNICO"
  },
  {
    "codigo":373601005,
    "descripcion":"QUERATOSIS LIQUENOIDE CRÓNICA"
  },
  {
    "codigo":11673671000119102,
    "descripcion":"CRISTALINO ARTIFICIAL PRESENTE EN OJO DERECHO"
  },
  {
    "codigo":44086001,
    "descripcion":"INFECCIÓN CAUSADA POR GNATHOSTOMA"
  },
  {
    "codigo":109622003,
    "descripcion":"FISURA GINGIVAL"
  },
  {
    "codigo":207926008,
    "descripcion":"FRACTURA EXPUESTA DEL AXIS, APÓFISIS TRANSVERSA"
  },
  {
    "codigo":75019001,
    "descripcion":"PARÁLISIS CEREBRAL ATETOIDE"
  },
  {
    "codigo":402699002,
    "descripcion":"CONDRODERMATITIS NODULAR"
  },
  {
    "codigo":238859006,
    "descripcion":"FIBROSIS NODULAR PROGRESIVA DE LA PIEL"
  },
  {
    "codigo":42251007,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE DEDO DE PIE"
  },
  {
    "codigo":1254667009,
    "descripcion":"FRAGMENTO DE CITOQUERATINA 19 POR ENCIMA DE RANGO DE REFERENCIA"
  },
  {
    "codigo":204256004,
    "descripcion":"OREJA PUNTIAGUDA CONGÉNITA"
  },
  {
    "codigo":1285600006,
    "descripcion":"HEMATOMA DE PÁRPADO SUPERIOR"
  },
  {
    "codigo":300725000,
    "descripcion":"CAPAZ DE REALIZAR ACTIVIDADES TELEFÓNICAS"
  },
  {
    "codigo":726709001,
    "descripcion":"SÍNDROME DE DISCAPACIDAD INTELECTUAL, CATARATAS, CALCIFICACIÓN DEL PABELLÓN AURICULAR Y MIOPATÍA"
  },
  {
    "codigo":202421004,
    "descripcion":"HEMARTROSIS DE ARTICULACIÓN INTERFALÁNGICA DE DEDO DEL PIE"
  },
  {
    "codigo":399029005,
    "descripcion":"TIÑA CRURAL"
  },
  {
    "codigo":169653006,
    "descripcion":"AMNIOCENTESIS PRENATAL, ANORMAL"
  },
  {
    "codigo":71349004,
    "descripcion":"INFERTILIDAD DEBIDA A OLIGOSPERMIA"
  },
  {
    "codigo":724874000,
    "descripcion":"TRASTORNO VASCULAR CUTÁNEO OCUPACIONAL"
  },
  {
    "codigo":3978000,
    "descripcion":"ANEMIA HEMOLÍTICA POR ANTICUERPOS CALIENTES"
  },
  {
    "codigo":36746002,
    "descripcion":"PERITONITIS BILIAR"
  },
  {
    "codigo":200586004,
    "descripcion":"ÁNTRAX DEL DORSO"
  },
  {
    "codigo":34911001,
    "descripcion":"HIPOPLASIA CONGÉNITA DEL PENE"
  },
  {
    "codigo":297055004,
    "descripcion":"SOBREDOSIS INTENCIONAL DE INHIBIDOR DE ENZIMA CONVERTIDORA DE ANGIOTENSINA"
  },
  {
    "codigo":231519007,
    "descripcion":"SÍNDROME DE DESPERSONALIZACIÓN-DESREALIZACIÓN"
  },
  {
    "codigo":342241000119105,
    "descripcion":"GLAUCOMA ABSOLUTO DE OJO IZQUIERDO"
  },
  {
    "codigo":459060000,
    "descripcion":"ENDOCARDITIS INFECCIOSA DE PARED DE VENTRÍCULO DERECHO"
  },
  {
    "codigo":229684006,
    "descripcion":"DISARTRIA ESPÁSTICA"
  },
  {
    "codigo":65844007,
    "descripcion":"ÁNTRAX DE LA MANO"
  },
  {
    "codigo":162313000,
    "descripcion":"CELOS MÓRBIDOS"
  },
  {
    "codigo":64009001,
    "descripcion":"INSUFICIENCIA VERTEBROBASILAR"
  },
  {
    "codigo":196916009,
    "descripcion":"HERNIA GLÚTEA CON GANGRENA"
  },
  {
    "codigo":719369003,
    "descripcion":"UTILIZA DISPOSITIVO DE COMUNICACIÓN"
  },
  {
    "codigo":293385003,
    "descripcion":"REACCIÓN ADVERSA A VITAMINAS LIPOSOLUBLES"
  },
  {
    "codigo":1145353005,
    "descripcion":"HIPOPLASIA CONGÉNITA DE TROCÁNTER MENOR DE FÉMUR"
  },
  {
    "codigo":308006,
    "descripcion":"PÁPULAS NACARADAS DE PENE"
  },
  {
    "codigo":295220006,
    "descripcion":"SOBREDOSIS INTENCIONAL DE ACEMETACINA"
  },
  {
    "codigo":721204009,
    "descripcion":"HIPERPLASIA SIMPLE DE GLÁNDULA ENDOMETRIAL CON ATIPIA"
  },
  {
    "codigo":291550006,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR FLUCLOXACILINA"
  },
  {
    "codigo":94942008,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE MÚSCULO DE LA CABEZA"
  },
  {
    "codigo":420787001,
    "descripcion":"NEUMONÍA NEUMOCÓCICA CON SÍNDROME DE INMUNODEFICIENCIA ADQUIRIDA"
  },
  {
    "codigo":224179002,
    "descripcion":"SALARIO PAGADO DIARIAMENTE"
  },
  {
    "codigo":93107003,
    "descripcion":"FALTA DE OSIFICACIÓN DEL MAXILAR"
  },
  {
    "codigo":16467741000119100,
    "descripcion":"MELORREOSTOSIS DE HUESO DE ANTEBRAZO DERECHO"
  },
  {
    "codigo":1092381000119100,
    "descripcion":"MESENTERITIS ESCLEROSANTE"
  },
  {
    "codigo":329501000119102,
    "descripcion":"OCLUSIÓN BILATERAL DE ARTERIAS CEREBRALES MEDIAS"
  },
  {
    "codigo":22301000119102,
    "descripcion":"PLAGIOCEFALIA POSICIONAL CONGÉNITA"
  },
  {
    "codigo":1089821000119104,
    "descripcion":"MENINGOENCEFALITIS DEBIDA A ENFERMEDAD DE CHAGAS"
  },
  {
    "codigo":342301000119101,
    "descripcion":"ALTERACIÓN DE LA SENSIBILIDAD VISUAL AL CONTRASTE"
  },
  {
    "codigo":117021000119106,
    "descripcion":"FALLA MECÁNICA DE IMPLANTE DENTAL DESPUÉS DE LA OSTEOINTEGRACIÓN"
  },
  {
    "codigo":972604701000119104,
    "descripcion":"MALFORMACIÓN ARTERIOVENOSA ADQUIRIDA DE ESTRUCTURA VASCULAR DEL TRACTO GASTROINTESTINAL"
  },
  {
    "codigo":321821000119108,
    "descripcion":"RIGIDEZ DE ARTICULACIÓN DE PIE DERECHO"
  },
  {
    "codigo":288541000119107,
    "descripcion":"PROBLEMA RELACIONADO CON LA CRIANZA"
  },
  {
    "codigo":1303688003,
    "descripcion":"QUISTE DE MANO IZQUIERDA"
  },
  {
    "codigo":12236061000119109,
    "descripcion":"DEFORMIDAD CONGÉNITA DE MIEMBRO SUPERIOR DERECHO"
  },
  {
    "codigo":35101000119106,
    "descripcion":"SANGRADO POSTERIOR A AMIGDALECTOMÍA"
  },
  {
    "codigo":15960861000119108,
    "descripcion":"SÍNDROME PREINFARTO DEBIDO A ARTERIOSCLEROSIS CORONARIA EN ARTERIA DE CORAZÓN TRASPLANTADO"
  },
  {
    "codigo":16442141000119109,
    "descripcion":"DOLOR PERIORBITARIO DE OJO IZQUIERDO"
  },
  {
    "codigo":449885000,
    "descripcion":"CLIP DE ANEURISMA CEREBRAL IN SITU"
  },
  {
    "codigo":316701000119108,
    "descripcion":"OSTEOFITO DE MUÑECA DERECHA"
  },
  {
    "codigo":15932701000119109,
    "descripcion":"PÓLIPO DE TROMPA UTERINA IZQUIERDA"
  },
  {
    "codigo":464713501000119109,
    "descripcion":"OSTEOCONDROSIS JUVENIL DE TIBIA PROXIMAL IZQUIERDA"
  },
  {
    "codigo":187741001,
    "descripcion":"NEOPLASIA MALIGNA DE FONDO DE ESTÓMAGO"
  },
  {
    "codigo":710194000,
    "descripcion":"NEOPLASIA ODONTÓGENA BENIGNA DE MAXILAR SUPERIOR"
  },
  {
    "codigo":89437009,
    "descripcion":"PARAPARESIA CEREBRAL"
  },
  {
    "codigo":286045009,
    "descripcion":"NO CLASIFICA LA ROPA SUCIA"
  },
  {
    "codigo":253277003,
    "descripcion":"COMUNICACIÓN AURICULOVENTRICULAR DISCORDANTE"
  },
  {
    "codigo":284210005,
    "descripcion":"QUEMADURAS MÚLTIPLES DE CABEZA Y CUELLO"
  },
  {
    "codigo":22066006,
    "descripcion":"ESTRABISMO"
  },
  {
    "codigo":15936021000119103,
    "descripcion":"FATIGA OCULAR BILATERAL"
  },
  {
    "codigo":251442008,
    "descripcion":"ARTIFICIO DEL ELECTROENCEFALOGRAMA"
  },
  {
    "codigo":216839006,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR GASES DE COMBUSTIÓN DE BOMBA"
  },
  {
    "codigo":247772000,
    "descripcion":"NO LLORA CON EMOCIÓN"
  },
  {
    "codigo":870364001,
    "descripcion":"SÍNDROME MEDULAR ANTERIOR TRAUMÁTICO"
  },
  {
    "codigo":249607009,
    "descripcion":"PRÓSTATA AGRANDADA"
  },
  {
    "codigo":51164008,
    "descripcion":"TIÑA DEL CUERPO CAUSADA POR MICROSPORUM"
  },
  {
    "codigo":442545002,
    "descripcion":"GLUCEMIA MEDIDA AL AZAR FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":16561007,
    "descripcion":"ENCEFALOPATÍA ANÓXICA AGUDA"
  },
  {
    "codigo":213169008,
    "descripcion":"FALLA PARCIAL DE REIMPLANTE DE MANO"
  },
  {
    "codigo":276870001,
    "descripcion":"CARCINOMA DE TROMPA DE FALOPIO"
  },
  {
    "codigo":735622003,
    "descripcion":"EDEMA CRÓNICO DE PENE"
  },
  {
    "codigo":211334007,
    "descripcion":"ABRASIÓN DE PIEL DE TOBILLO"
  },
  {
    "codigo":406107005,
    "descripcion":"NO SE PUEDE DETERMINAR LA PRESENCIA DE RESTOS NEFROGÉNICOS EN EL ESPÉCIMEN"
  },
  {
    "codigo":45659008,
    "descripcion":"HEMORRAGIA SUBDURAL POSTRAUMÁTICA CON HERIDA INTRACRANEAL ABIERTA Y PÉRDIDA DE LA CONSCIENCIA"
  },
  {
    "codigo":897627009,
    "descripcion":"FORMA TRIANGULAR ANORMAL CONGÉNITA DE EPÍFISIS DE FALANGE DE DEDO GORDO"
  },
  {
    "codigo":830256002,
    "descripcion":"GLOMANGIOPERICITOMA DE SENO PARANASAL"
  },
  {
    "codigo":1354544003,
    "descripcion":"AMILOIDOSIS HEREDITARIA ASOCIADA A TRANSTIRETINA"
  },
  {
    "codigo":109360003,
    "descripcion":"PÓLIPO HERNIADO DE SENO MAXILAR"
  },
  {
    "codigo":15991471000119106,
    "descripcion":"CORIORRETINITIS DE OJO IZQUIERDO CAUSADA POR MYCOBACTERIUM TUBERCULOSIS"
  },
  {
    "codigo":240432006,
    "descripcion":"TÉTANOS CON TRISMO"
  },
  {
    "codigo":699184009,
    "descripcion":"SÍNDROME DE PERRY"
  },
  {
    "codigo":238597002,
    "descripcion":"XERODERMIA SENIL"
  },
  {
    "codigo":369669002,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA DE PLEURA Y ESÓFAGO, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":402437008,
    "descripcion":"PENFIGOIDE BULLOSO LOCALIZADO DE VULVA"
  },
  {
    "codigo":1287173009,
    "descripcion":"TUMOR NEUROENDOCRINO BIEN DIFERENCIADO GRADO 1 DE PULMÓN"
  },
  {
    "codigo":203994003,
    "descripcion":"MIELOCISTOCELE"
  },
  {
    "codigo":302298004,
    "descripcion":"RETROPIÉ EN VALGO CONGÉNITO"
  },
  {
    "codigo":344751000119109,
    "descripcion":"PANUVEÍTIS BILATERAL"
  },
  {
    "codigo":1187034006,
    "descripcion":"XANTINA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":105690007,
    "descripcion":"ENFERMEDAD CAUSADA POR LINSTOWIIDAE"
  },
  {
    "codigo":72922008,
    "descripcion":"SÍNDROME DE POLIDACTILIA - COSTILLA CORTA, TIPO MAJEWSKI"
  },
  {
    "codigo":7386008,
    "descripcion":"ANCILOSTOMIASIS CAUSADA POR ANCYLOSTOMA DUODENALE"
  },
  {
    "codigo":890287003,
    "descripcion":"POLIMICROGIRIA GENERALIZADA BILATERAL"
  },
  {
    "codigo":365999004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CONCIENCIA DE REGLAS Y LÍMITES"
  },
  {
    "codigo":202159003,
    "descripcion":"ARTROFITO EN ARTICULACIÓN DE LA MUÑECA"
  },
  {
    "codigo":11787081000119104,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE DEDO ÍNDICE IZQUIERDO"
  },
  {
    "codigo":300463007,
    "descripcion":"EVACUACIÓN VESICAL EFICAZ"
  },
  {
    "codigo":3716002,
    "descripcion":"BOCIO"
  },
  {
    "codigo":724612006,
    "descripcion":"OSTEONECROSIS DEBIDA A DIÁLISIS RENAL Y POSTERIOR A ELLA"
  },
  {
    "codigo":34649000,
    "descripcion":"FRACTURA NO EXPUESTA DE HUESOS MALAR Y\/O MAXILAR SUPERIOR"
  },
  {
    "codigo":298628009,
    "descripcion":"SIN AMPLITUD DE FLEXIÓN LATERAL ACTIVA HACIA LA DERECHA DE LA COLUMNA VERTEBRAL LUMBAR"
  },
  {
    "codigo":296793009,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE RIFAMPICINA"
  },
  {
    "codigo":360494001,
    "descripcion":"ROTACIÓN PATOLÓGICA DEL INTESTINO TIPO IIID"
  },
  {
    "codigo":131118006,
    "descripcion":"SECRETINA ANORMAL"
  },
  {
    "codigo":1179694006,
    "descripcion":"PROSTATITIS CATEGORÍA IIIB"
  },
  {
    "codigo":1145091001,
    "descripcion":"HALLAZGO RELACIONADO CON PESTAÑA"
  },
  {
    "codigo":294958009,
    "descripcion":"ALERGIA A ACIPIMOX"
  },
  {
    "codigo":11842531000119104,
    "descripcion":"RUPTURA TRAUMÁTICA DE TENDÓN DE REGIÓN DE TOBILLO DERECHO"
  },
  {
    "codigo":162051008,
    "descripcion":"DOLOR EN FOSA ILÍACA DERECHA"
  },
  {
    "codigo":717272001,
    "descripcion":"HABLA ADECUADA PARA LA EDAD DE DESARROLLO"
  },
  {
    "codigo":94680007,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL VÓMER"
  },
  {
    "codigo":291288009,
    "descripcion":"INTOXICACIÓN INTENCIONAL CAUSADA POR FÁRMACOS BLOQUEANTES DE LOS CANALES DEL CALCIO"
  },
  {
    "codigo":125613003,
    "descripcion":"LUXACIÓN TRAUMÁTICA DE LA PELVIS"
  },
  {
    "codigo":191149003,
    "descripcion":"ANEMIA POR DEFICIENCIA DE FOLATOS, POR MALABSORCIÓN"
  },
  {
    "codigo":92845005,
    "descripcion":"FUSIÓN ANORMAL CONGÉNITA DEL CARTÍLAGO CENTRAL DE LA VÉRTEBRA LUMBAR"
  },
  {
    "codigo":1338029006,
    "descripcion":"OSTEOPOROSIS DEBIDA A RADIOTERAPIA Y POSTERIOR A ELLA"
  },
  {
    "codigo":715437003,
    "descripcion":"ENFERMEDAD POR INCLUSIÓN INTRANUCLEAR NEURONAL"
  },
  {
    "codigo":289453005,
    "descripcion":"ARCO PÚBICO ANGOSTO"
  },
  {
    "codigo":254850005,
    "descripcion":"CISTOADENOCARCINOMA PAPILAR SEROSO DE OVARIO"
  },
  {
    "codigo":25474009,
    "descripcion":"FÍSTULA UTEROVESICAL"
  },
  {
    "codigo":449623007,
    "descripcion":"QUEMADURA EPIDÉRMICA EN MÚLTIPLES LOCALIZACIONES DE PIERNA"
  },
  {
    "codigo":251180001,
    "descripcion":"TRIGEMINISMO VENTRICULAR"
  },
  {
    "codigo":283948004,
    "descripcion":"HEMATOMA DEL PENE"
  },
  {
    "codigo":347261000119106,
    "descripcion":"ATROFIA SENIL DE COROIDES DE AMBOS OJOS"
  },
  {
    "codigo":85505000,
    "descripcion":"ATROFIA MUSCULAR ESPINAL ADULTA"
  },
  {
    "codigo":249345002,
    "descripcion":"DESOBSTRUCCIÓN TRANSITORIA DE LA VÍA AÉREA NASAL"
  },
  {
    "codigo":183809004,
    "descripcion":"ESTADÍA DE INTERNACIÓN, 11 DÍAS"
  },
  {
    "codigo":50902000,
    "descripcion":"NEUMOPERICARDITIS AGUDA"
  },
  {
    "codigo":253491006,
    "descripcion":"ESTENOSIS DE VÁLVULA AURICULOVENTRICULAR IZQUIERDA"
  },
  {
    "codigo":247510002,
    "descripcion":"MOTEADO BLANCO UNGUEAL"
  },
  {
    "codigo":1197782006,
    "descripcion":"HIPERTERMIA"
  },
  {
    "codigo":737195007,
    "descripcion":"ENFERMEDAD DE CROHN DE TRACTO GASTROINTESTINAL SUPERIOR"
  },
  {
    "codigo":81835007,
    "descripcion":"ANTÍGENO DE GRUPO SANGUÍNEO C^V^"
  },
  {
    "codigo":704427009,
    "descripcion":"ALTERACIÓN DEL DESARROLLO DEL ADULTO"
  },
  {
    "codigo":276608005,
    "descripcion":"ALIMENTACIÓN FETAL POBRE"
  },
  {
    "codigo":1259648008,
    "descripcion":"OSTEOSARCOMA PRIMARIO DE CARTÍLAGO ARTICULAR DE CLAVÍCULA"
  },
  {
    "codigo":242005001,
    "descripcion":"LESIÓN EN LOS OÍDOS POR EXPLOSIÓN"
  },
  {
    "codigo":307541003,
    "descripcion":"SÍNTOMAS DE VÍAS URINARIAS INFERIORES"
  },
  {
    "codigo":373077007,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM TRIVIALE"
  },
  {
    "codigo":272938000,
    "descripcion":"DEFICIENCIA DE DEXTRINASA LÍMITE"
  },
  {
    "codigo":698922001,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: SOTHO DEL SUR"
  },
  {
    "codigo":305706001,
    "descripcion":"VISTO POR UN CIRUJANO CARDIOVASCULAR"
  },
  {
    "codigo":404010004,
    "descripcion":"DERMATOFIBROSARCOMA PROTUBERANTE CON FIBROBLASTOMA DE CÉLULAS GIGANTES"
  },
  {
    "codigo":829994007,
    "descripcion":"MÁCULA DE PIEL"
  },
  {
    "codigo":895530008,
    "descripcion":"INGESTA INADECUADA DE HIERRO"
  },
  {
    "codigo":860927003,
    "descripcion":"ALERGIA A ÁCIDO FÍBRICO Y\/O DERIVADO DE ÁCIDO FÍBRICO"
  },
  {
    "codigo":402175003,
    "descripcion":"REACCIÓN FOTOTÓXICA CAUSADA POR ALQUITRÁN O DERIVADO"
  },
  {
    "codigo":1286911005,
    "descripcion":"HEMORRAGIA INTRAVENTRICULAR NO TRAUMÁTICA GRADO 1 DURANTE PERÍODO INTRAPARTO FETAL"
  },
  {
    "codigo":236500003,
    "descripcion":"NEFROPATÍA DIABÉTICA PROTEINÚRICA"
  },
  {
    "codigo":302036006,
    "descripcion":"FRACTURA-LUXACIÓN NO EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA DE DEDO DEL PIE"
  },
  {
    "codigo":300201009,
    "descripcion":"RESPONDE AL SONIDO"
  },
  {
    "codigo":267433009,
    "descripcion":"HIPERGLICERIDEMIA PURA"
  },
  {
    "codigo":298366004,
    "descripcion":"HALLAZGO RELACIONADO CON ARTICULACIÓN TEMPOROMANDIBULAR"
  },
  {
    "codigo":36222008,
    "descripcion":"CARDIOPATÍA CARCINOIDE"
  },
  {
    "codigo":429438008,
    "descripcion":"SECUELA DE MENINGITIS INFECCIOSA"
  },
  {
    "codigo":724350009,
    "descripcion":"SÍNDROME DE HIPOTRICOSIS HEREDITARIA CON VESÍCULAS CUTÁNEAS RECURRENTES"
  },
  {
    "codigo":722515001,
    "descripcion":"LIPOSARCOMA PRIMARIO DE RETROPERITONEO"
  },
  {
    "codigo":198227006,
    "descripcion":"FORÚNCULO VULVAR"
  },
  {
    "codigo":67155006,
    "descripcion":"SÍNDROME DE GERSTMANN - STRAUSSLER - SCHEINKER"
  },
  {
    "codigo":165459007,
    "descripcion":"VISCOSIDAD DEL PLASMA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":427603009,
    "descripcion":"ASMA INTERMITENTE"
  },
  {
    "codigo":32552001,
    "descripcion":"TRASTORNO DELIRANTE ORGÁNICO CAUSADO POR SUSTANCIA PSICOACTIVA"
  },
  {
    "codigo":11818571000119105,
    "descripcion":"ESGUINCE DE LIGAMENTO DE ARTICULACIÓN INTERFALÁNGICA DE DEDO MEDIO IZQUIERDO"
  },
  {
    "codigo":720680001,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR PITAVASTATINA"
  },
  {
    "codigo":296531007,
    "descripcion":"SOBREDOSIS DE FLUCITOSINA"
  },
  {
    "codigo":10972901000119100,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO DIGITAL DE DEDO ÍNDICE DERECHO"
  },
  {
    "codigo":294696008,
    "descripcion":"ALERGIA A DIFLUCORTOLONA"
  },
  {
    "codigo":718845002,
    "descripcion":"SÍNDROME DE DISCAPACIDAD INTELECTUAL LIGADA AL CROMOSOMA X CON ATAXIA Y APRAXIA"
  },
  {
    "codigo":784381008,
    "descripcion":"PIEL LAXA AUTOSÓMICA RECESIVA TIPO 2A"
  },
  {
    "codigo":94418000,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE MÚSCULO DEL ABDOMEN"
  },
  {
    "codigo":291026002,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR PENTOBARBITAL"
  },
  {
    "codigo":28882002,
    "descripcion":"TRASTORNO DEL METABOLISMO DE LOS AMINOÁCIDOS SULFURADOS"
  },
  {
    "codigo":127186003,
    "descripcion":"LINFADENOPATÍA PARAVAGINAL"
  },
  {
    "codigo":15970021000119103,
    "descripcion":"HEMORROIDE INTERNA SANGRANTE GRADO III"
  },
  {
    "codigo":192722007,
    "descripcion":"ENCEFALITIS POSVACUNACIÓN CONTRA LA HEPATITIS A"
  },
  {
    "codigo":717010007,
    "descripcion":"ENFERMEDAD DE CHARCOT-MARIE-TOOTH TIPO 2C AUTOSÓMICA DOMINANTE"
  },
  {
    "codigo":289191004,
    "descripcion":"HALLAZGO RELACIONADO CON EL TONO DE LA VOZ"
  },
  {
    "codigo":92583004,
    "descripcion":"CARCINOMA IN SITU DE EPIDÍDIMO"
  },
  {
    "codigo":713340000,
    "descripcion":"TRASTORNO DE PIEL CONCOMITANTE CON INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":254588001,
    "descripcion":"PÓLIPO DE INTESTINO"
  },
  {
    "codigo":418428009,
    "descripcion":"EXPRESA VERBALMENTE UN PLAN PARA APOYAR EL EJERCICIO"
  },
  {
    "codigo":1268561007,
    "descripcion":"CISTOADENOCARCINOMA SEROSO PRIMARIO DE PÁNCREAS"
  },
  {
    "codigo":285521008,
    "descripcion":"NO MUEVE LA PUNTA DE LA LENGUA"
  },
  {
    "codigo":21542005,
    "descripcion":"SÍNDROME DE BEHCET, TIPO NEUROLÓGICO"
  },
  {
    "codigo":283686005,
    "descripcion":"MORDEDURA HUMANA EN EL CUERO CABELLUDO"
  },
  {
    "codigo":871675001,
    "descripcion":"REACCIÓN ADVERSA A ÁCIDO ETIDRÓNICO"
  },
  {
    "codigo":609531002,
    "descripcion":"PARÁLISIS DE NERVIO FEMORAL"
  },
  {
    "codigo":52475004,
    "descripcion":"XERODERMIA"
  },
  {
    "codigo":249083005,
    "descripcion":"PRESENTACIÓN DE FONTANELA POSTERIOR"
  },
  {
    "codigo":19707006,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE MAMA SIN INFECCIÓN"
  },
  {
    "codigo":1363195004,
    "descripcion":"INCAPAZ DE SENTARSE EN ASIENTO DE INODORO"
  },
  {
    "codigo":247248006,
    "descripcion":"PERMEABILIDAD DE CONDUCTO AUDITIVO"
  },
  {
    "codigo":81573002,
    "descripcion":"ENFERMEDAD DEL COLÁGENO"
  },
  {
    "codigo":16025471000119107,
    "descripcion":"ANEURISMA DE ARTERIA CORONARIA DEBIDO A SÍNDROME GANGLIONAR MUCOCUTÁNEO FEBRIL AGUDO Y POSTERIOR A ÉL"
  },
  {
    "codigo":704165006,
    "descripcion":"FRACTURA NO EXPUESTA DE FALANGE MEDIA DE DEDO ÍNDICE"
  },
  {
    "codigo":48805008,
    "descripcion":"INFESTACIÓN CAUSADA POR HAEMAPHYSALIS"
  },
  {
    "codigo":79738005,
    "descripcion":"PRODUCCIÓN AUMENTADA DE PLAQUETAS"
  },
  {
    "codigo":1259386005,
    "descripcion":"CARCINOMA INDIFERENCIADO PRIMARIO DE OVARIO"
  },
  {
    "codigo":733263000,
    "descripcion":"LESIÓN TRAUMÁTICA DE VASO SANGUÍNEO DE DEDO DE LA MANO"
  },
  {
    "codigo":46970008,
    "descripcion":"NEUMONÍA CAUSADA POR MYCOPLASMA PNEUMONIAE"
  },
  {
    "codigo":45135002,
    "descripcion":"FÍSTULA DE LA VAGINA"
  },
  {
    "codigo":208975006,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA EXPUESTA DE LA CABEZA DEL PERONÉ"
  },
  {
    "codigo":10532003,
    "descripcion":"DEMENCIA DEGENERATIVA PRIMARIA TIPO ALZHEIMER, DE INICIO EN LA EDAD PRESENIL, CON DEPRESIÓN"
  },
  {
    "codigo":403748005,
    "descripcion":"ACROCIANOSIS Y LIVEDO RETICULARIS INDUCIDAS POR COCAÍNA"
  },
  {
    "codigo":895268006,
    "descripcion":"FORMA ANCHA ANORMAL CONGÉNITA DE FALANGE PROXIMAL DE DEDO MEDIO DE MANO"
  },
  {
    "codigo":43300008,
    "descripcion":"PTERIGIÓN CENTRAL"
  },
  {
    "codigo":698660008,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: FEROÉS"
  },
  {
    "codigo":305444009,
    "descripcion":"BAJO ATENCIÓN DE TERAPEUTA ESPECIALISTA EN TERAPIA COMPLEMENTARIA"
  },
  {
    "codigo":8697000,
    "descripcion":"INTOXICACIÓN POR FAGOPYRUM"
  },
  {
    "codigo":762361004,
    "descripcion":"LESIÓN TRAUMÁTICA DE VÍA ÓPTICA DERECHA"
  },
  {
    "codigo":238073001,
    "descripcion":"DEFICIENCIA AISLADA DE ALQUILDIHIDROXIACETONA FOSFATO SINTASA"
  },
  {
    "codigo":15671321000119109,
    "descripcion":"BRAQUIDACTILIA DE DEDOS DE AMBOS PIES"
  },
  {
    "codigo":431011000,
    "descripcion":"SEUDOARTROSIS DE FRACTURA DE CLAVÍCULA"
  },
  {
    "codigo":203470009,
    "descripcion":"FIBROMA DE HUESO NO OSIFICADO"
  },
  {
    "codigo":234403002,
    "descripcion":"DEFICIENCIA DE FOSFOGLICEROQUINASA"
  },
  {
    "codigo":299939003,
    "descripcion":"SENTIDO DE LA POSICIÓN DEL CUERPO NORMAL"
  },
  {
    "codigo":37795008,
    "descripcion":"HERIDA PENETRANTE DE ÓRBITA SIN CUERPO EXTRAÑO"
  },
  {
    "codigo":365475008,
    "descripcion":"POSICIÓN\/LUGAR EN EL ORDEN FAMILIAR - HALLAZGO"
  },
  {
    "codigo":298104006,
    "descripcion":"CUERPO EXTRAÑO EN LA PIEL DEL DORSO DEL PIE"
  },
  {
    "codigo":396408009,
    "descripcion":"COMPROMISO DEL ESPÉCIMEN POR GANGLIO(S) SATÉLITE(S): PRESENTE(S)"
  },
  {
    "codigo":429176009,
    "descripcion":"HEMANGIOENDOTELIOMA DE ABDOMEN"
  },
  {
    "codigo":34125004,
    "descripcion":"HERNIA ISQUIORRECTAL CON GANGRENA"
  },
  {
    "codigo":230733004,
    "descripcion":"ANGEÍTIS AISLADA DEL SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":427341007,
    "descripcion":"DOLOR PROVOCADO POR EJERCICIO"
  },
  {
    "codigo":66893008,
    "descripcion":"ENDOCARDITIS SUBAGUDA"
  },
  {
    "codigo":197965008,
    "descripcion":"PROSTATITIS BLASTOMICÓTICA"
  },
  {
    "codigo":294434000,
    "descripcion":"ALERGIA A ÁCIDO BÓRICO"
  },
  {
    "codigo":292360004,
    "descripcion":"REACCIÓN ADVERSA AL DIAZEPAM"
  },
  {
    "codigo":720418008,
    "descripcion":"DISOSTOSIS ACROCRANEOFACIAL"
  },
  {
    "codigo":32290008,
    "descripcion":"HERNIA DE TROMPA DE FALOPIO"
  },
  {
    "codigo":63223002,
    "descripcion":"PUBERTAD FEMENINA TARDÍA"
  },
  {
    "codigo":1144567005,
    "descripcion":"HIPOPLASIA CONGÉNITA DE INTESTINO DELGADO"
  },
  {
    "codigo":1306572003,
    "descripcion":"CARCINOMA DUCTAL INFILTRANTE DE CUADRANTE INFERIOR EXTERNO DE MAMA"
  },
  {
    "codigo":126924008,
    "descripcion":"NEOPLASIA DE LABIOS MENORES VULVARES"
  },
  {
    "codigo":94156009,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE NERVIO VESTIBULOCOCLEAR"
  },
  {
    "codigo":1092071000119101,
    "descripcion":"INFLAMACIÓN DE PORCIÓN PETROSA DE HUESO TEMPORAL DERECHO"
  },
  {
    "codigo":92321003,
    "descripcion":"NEOPLASIA BENIGNA DE LA RETINA"
  },
  {
    "codigo":287094000,
    "descripcion":"LUXACIÓN DE RODILLA CON DESGARRO DE MENISCO EXTERNO"
  },
  {
    "codigo":1237366005,
    "descripcion":"APROSENCEFALIA Y DISGENESIA CEREBELOSA"
  },
  {
    "codigo":713078005,
    "descripcion":"EMBOLIA PULMONAR EN TRATAMIENTO ANTICOAGULANTE PROLONGADO"
  },
  {
    "codigo":24950005,
    "descripcion":"DISTROFIA COROIDEA GENERALIZADA PARCIAL"
  },
  {
    "codigo":682471000119103,
    "descripcion":"ASTROCITOMA PRIMARIO DE LÓBULO PARIETAL"
  },
  {
    "codigo":449099002,
    "descripcion":"ESTENOSIS DE VÁLVULA AURICULOVENTRICULAR IZQUIERDA EN VENTRÍCULO CON DOBLE TRACTO DE ENTRADA"
  },
  {
    "codigo":1268299004,
    "descripcion":"FRACTURA ABIERTA DE PARED LATERAL DE ÓRBITA"
  },
  {
    "codigo":23115009,
    "descripcion":"ANEURISMA ARTERIAL ROTO"
  },
  {
    "codigo":840480002,
    "descripcion":"OREJA ARRUGADA CONGÉNITA"
  },
  {
    "codigo":54048003,
    "descripcion":"AMENAZA DE ABORTO"
  },
  {
    "codigo":19445006,
    "descripcion":"TRASTORNO PSICÓTICO CON ALUCINACIONES INDUCIDO POR OPIÁCEOS"
  },
  {
    "codigo":1197258000,
    "descripcion":"CARCINOMA PRIMARIO DE PALADAR DE TIPO GLANDULAR SALIVAL"
  },
  {
    "codigo":17610001,
    "descripcion":"QUEMADURA PROFUNDA DE TERCER GRADO DE DEDO DEL PIE"
  },
  {
    "codigo":1230026002,
    "descripcion":"TRASTORNO EROSIVO ACANTOLÍTICO LETAL"
  },
  {
    "codigo":246986004,
    "descripcion":"CÁMARA OCULAR ANTERIOR POCO PROFUNDA"
  },
  {
    "codigo":48543002,
    "descripcion":"NEVO DE ITO"
  },
  {
    "codigo":703903005,
    "descripcion":"RINITIS ALÉRGICA CAUSADA POR DERMATOPHAGOIDES FARINAE"
  },
  {
    "codigo":441759008,
    "descripcion":"VISIÓN ANORMAL COMO EFECTO TARDÍO DE ENFERMEDAD CEREBROVASCULAR"
  },
  {
    "codigo":212383008,
    "descripcion":"SÍNDROME COMPARTIMENTAL DE GLÚTEO DEBIDO A LESIÓN TRAUMÁTICA"
  },
  {
    "codigo":1259124000,
    "descripcion":"ESCLEROSIS LATERAL AMIOTRÓFICA CON DEMENCIA FRONTOTEMPORAL"
  },
  {
    "codigo":210548000,
    "descripcion":"SECCIÓN COMPLETA DE TENDÓN FLEXOR DE LA MUÑECA"
  },
  {
    "codigo":641000119106,
    "descripcion":"ASMA INTERMITENTE BIEN CONTROLADA"
  },
  {
    "codigo":328321000119106,
    "descripcion":"PANCITOPENIA CAUSADA POR COLCHICINA"
  },
  {
    "codigo":46708007,
    "descripcion":"ÚLCERA GÁSTRICA AGUDA CON HEMORRAGIA Y OBSTRUCCIÓN"
  },
  {
    "codigo":865908007,
    "descripcion":"INTERRUPCIÓN DE LA RESPIRACIÓN DEBIDA A ALIMENTO ALOJADO EN EL ESÓFAGO"
  },
  {
    "codigo":208713003,
    "descripcion":"FRACTURA NO EXPUESTA DE FALANGES MÚLTIPLES DE DEDO DE PIE"
  },
  {
    "codigo":403486000,
    "descripcion":"LUPUS ERITEMATOSO SISTÉMICO AGUDO"
  },
  {
    "codigo":896841009,
    "descripcion":"FORMA TRIANGULAR ANORMAL CONGÉNITA DE EPÍFISIS DE HUESO METACARPIANO"
  },
  {
    "codigo":15729281000119109,
    "descripcion":"LUXACIÓN BILATERAL DE ARTICULACIONES DE AMBOS PIES DEBIDA A DISPLASIA CONGÉNITA"
  },
  {
    "codigo":8435000,
    "descripcion":"TROMBOANGEÍTIS"
  },
  {
    "codigo":205043005,
    "descripcion":"DEFORMIDAD CONGÉNITA DE LA COLUMNA VERTEBRAL"
  },
  {
    "codigo":237811009,
    "descripcion":"FEMINIZACIÓN FARMACÓGENA"
  },
  {
    "codigo":301512003,
    "descripcion":"NO ENTRA EN LA DUCHA"
  },
  {
    "codigo":235976005,
    "descripcion":"HIPERTROFIA FAMILIAR DEL ESFÍNTER DE ODDI"
  },
  {
    "codigo":1153480005,
    "descripcion":"AMINOÁCIDOS SÉRICOS POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":234141001,
    "descripcion":"MALFORMACIÓN ARTERIOVENOSA CONGÉNITA"
  },
  {
    "codigo":365213006,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA UTILIZAR LA SILLA INODORO"
  },
  {
    "codigo":299677007,
    "descripcion":"CRECIMIENTO EXCESIVO DE VELLO CORPORAL"
  },
  {
    "codigo":11770651000119108,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA ANTERIOR DE CABEZA RADIAL IZQUIERDA"
  },
  {
    "codigo":135837009,
    "descripcion":"SOLICITÓ SILLA DE RUEDAS"
  },
  {
    "codigo":232306005,
    "descripcion":"DEGENERACIÓN COCLEAR HEREDADA"
  },
  {
    "codigo":723826007,
    "descripcion":"PARAPLEJÍA ESPÁSTICA AUTOSÓMICA RECESIVA TIPO 57"
  },
  {
    "codigo":363378008,
    "descripcion":"NEOPLASIA MALIGNA DE LA GLÁNDULA SALIVAL MAYOR"
  },
  {
    "codigo":230471006,
    "descripcion":"CEFALEA TENSIONAL CRÓNICA"
  },
  {
    "codigo":296007006,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE ETOSUXIMIDA"
  },
  {
    "codigo":425244000,
    "descripcion":"TURGENCIA CUTÁNEA DISMINUIDA"
  },
  {
    "codigo":66631006,
    "descripcion":"TRASTORNO BIPOLAR I DEPRESIVO MODERADO"
  },
  {
    "codigo":294172004,
    "descripcion":"ALERGIA A BUFEXAMACO"
  },
  {
    "codigo":15758261000119106,
    "descripcion":"PRESENCIA DE VARIANTE DE HEMOGLOBINA NO IDENTIFICADA"
  },
  {
    "codigo":15977551000119100,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE AMBOS OJOS"
  },
  {
    "codigo":423409001,
    "descripcion":"ESTADO DE DESEMPEÑO ECOG - GRADO 5"
  },
  {
    "codigo":16905141000119107,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE PIEL DE PÁRPADO SUPERIOR DERECHO"
  },
  {
    "codigo":1177073003,
    "descripcion":"ÚLCERA DUODENAL PARASITARIA"
  },
  {
    "codigo":10761141000119107,
    "descripcion":"TRABAJO DE PARTO PRETÉRMINO EN EL SEGUNDO TRIMESTRE CON PARTO PRETÉRMINO EN EL SEGUNDO TRIMESTRE DE GESTACIÓN"
  },
  {
    "codigo":1144305001,
    "descripcion":"LEIOMIOSARCOMA DEL CUERPO DEL ESTÓMAGO"
  },
  {
    "codigo":95729008,
    "descripcion":"QUISTE EPITELIAL DE INCLUSIÓN DE LA CÓRNEA"
  },
  {
    "codigo":93894000,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL OÍDO MEDIO"
  },
  {
    "codigo":290502000,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR METOHEXITAL"
  },
  {
    "codigo":330831000119102,
    "descripcion":"XERODERMIA DE PÁRPADO INFERIOR DERECHO"
  },
  {
    "codigo":28358004,
    "descripcion":"APENDICITIS OBSTRUCTIVA AGUDA CON PERFORACIÓN Y PERITONITIS"
  },
  {
    "codigo":1306310004,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE ARÉOLA"
  },
  {
    "codigo":716486007,
    "descripcion":"DIFICULTAD PARA UTILIZAR LA COMBINACIÓN DE CONSONANTE-VOCAL-CONSONANTE-VOCAL"
  },
  {
    "codigo":126662008,
    "descripcion":"ERITEMA DE MEMBRANA MUCOSA DE OROFARINGE"
  },
  {
    "codigo":61126009,
    "descripcion":"POLIARTRITIS INFECCIOSA"
  },
  {
    "codigo":288667000,
    "descripcion":"NO MANTIENE UNA CONVERSACIÓN"
  },
  {
    "codigo":59291004,
    "descripcion":"FETO MUERTO RETENIDO"
  },
  {
    "codigo":92059004,
    "descripcion":"NEOPLASIA BENIGNA DE LA COROIDES"
  },
  {
    "codigo":90224001,
    "descripcion":"COMA EN EL RECIÉN NACIDO"
  },
  {
    "codigo":304361000119100,
    "descripcion":"INESTABILIDAD CRÓNICA DE ARTICULACIÓN DE RODILLA IZQUIERDA"
  },
  {
    "codigo":286832009,
    "descripcion":"HALLAZGO RELACIONADO CON EL HABLA Y EL LENGUAJE"
  },
  {
    "codigo":416069001,
    "descripcion":"QUERATITIS PUNTIFORME SUPERFICIAL DE THYGESON"
  },
  {
    "codigo":254064009,
    "descripcion":"DISPLASIA DE CADERA TIPO NAMAQUALAND"
  },
  {
    "codigo":709146000,
    "descripcion":"MAL FUNCIONAMIENTO DE TRAQUEOSTOMÍA"
  },
  {
    "codigo":250394000,
    "descripcion":"TIPO ANTIGÉNICO LANDSTEINER-WEINER"
  },
  {
    "codigo":21018002,
    "descripcion":"NEUROPATÍA INFLAMATORIA"
  },
  {
    "codigo":1004058003,
    "descripcion":"CONTRACTURA EN FLEXIÓN DE ARTICULACIÓN INTERFALÁNGICA DE DEDO GORDO DE PIE"
  },
  {
    "codigo":283162007,
    "descripcion":"CUERPO EXTRAÑO METÁLICO EN LA PALMA DE MANO"
  },
  {
    "codigo":248559000,
    "descripcion":"MOVIMIENTOS TORÁCICOS SIMÉTRICOS"
  },
  {
    "codigo":281327001,
    "descripcion":"NO SE ESPECIFICÓ EL DESTINO DEL INFORME"
  },
  {
    "codigo":838383000,
    "descripcion":"COREA TÓXICA"
  },
  {
    "codigo":445167000,
    "descripcion":"DILATACIÓN CONGÉNITA DE ARTERIA PULMONAR DERECHA"
  },
  {
    "codigo":117487002,
    "descripcion":"CRISTAL URINARIO, URATO ÁCIDO DE SODIO"
  },
  {
    "codigo":1264367001,
    "descripcion":"ADENOCARCINOMA SEBÁCEO METASTÁSICO"
  },
  {
    "codigo":1297135007,
    "descripcion":"CUELLO FEMORAL VALGO ADQUIRIDO IZQUIERDO"
  },
  {
    "codigo":15705321000119106,
    "descripcion":"CONDROCALCINOSIS DE ARTICULACIÓN DE AMBOS CODOS"
  },
  {
    "codigo":277657001,
    "descripcion":"PRESIÓN INTRACRANEAL DISMINUIDA"
  },
  {
    "codigo":212121002,
    "descripcion":"QUEMADURA QUE COMPROMETE MÁS DEL 90 POR CIENTO DE LA SUPERFICIE CORPORAL, CON 50 - 59 POR CIENTO DE SUPERFICIE CORPORAL CON QUEMADURA DE TERCER GRADO"
  },
  {
    "codigo":243054000,
    "descripcion":"LESIÓN POR ARMA DE GAS TÓXICO"
  },
  {
    "codigo":111982005,
    "descripcion":"PAQUIONIQUIA"
  },
  {
    "codigo":79214007,
    "descripcion":"RÓTULA BÍFIDA"
  },
  {
    "codigo":208451002,
    "descripcion":"FRACTURA NO EXPUESTA DE LA FALANGE MEDIA DE DEDO DE LA MANO, BASE"
  },
  {
    "codigo":306755002,
    "descripcion":"INCAPAZ DE PRODUCIR SONIDOS SONOROS"
  },
  {
    "codigo":372291004,
    "descripcion":"INVASIÓN TUMORAL DE LA GRASA PERIPROSTÁTICA PRESENTE"
  },
  {
    "codigo":110147003,
    "descripcion":"LACERACIÓN COMPLEJA CONTAMINADA DEL CUELLO"
  },
  {
    "codigo":75544000,
    "descripcion":"DEPENDENCIA DE OPIÁCEOS"
  },
  {
    "codigo":1255192000,
    "descripcion":"CARCINOMA FOLICULAR PRIMARIO DE TIROIDES"
  },
  {
    "codigo":403224002,
    "descripcion":"FOTOSUBTIPO CUTÁNEO IIB (AL COMIENZO SIEMPRE EXISTE QUEMADURA, A VECES BRONCEADO MODERADO)"
  },
  {
    "codigo":237549001,
    "descripcion":"HIPERTIROXINEMIA EUTIROIDEA DISPREALBUMINÉMICA"
  },
  {
    "codigo":204781002,
    "descripcion":"AGENESIA DE CONDUCTOS HEPÁTICOS"
  },
  {
    "codigo":303085006,
    "descripcion":"QUISTE PARATUBÁRICO ORIGINADO EN EL CONDUCTO MESONÉFRICO"
  },
  {
    "codigo":1220589007,
    "descripcion":"SÍNDROME DE LIPODISTROFIA GENERALIZADA, RASGOS PROGEROIDES, DISCAPACIDAD INTELECTUAL GRAVE"
  },
  {
    "codigo":39106000,
    "descripcion":"RESPIRACIÓN DE BIOT"
  },
  {
    "codigo":1351661007,
    "descripcion":"INFLAMACIÓN DE URETRA CAUSADA POR SCHISTOSOMA"
  },
  {
    "codigo":399554003,
    "descripcion":"DISPLASIA DE TROMPA DE FALOPIO"
  },
  {
    "codigo":301250005,
    "descripcion":"HALLAZGO RELACIONADO CON EL BOSTEZO"
  },
  {
    "codigo":235714007,
    "descripcion":"ENTEROCOLITIS ULCEROSA"
  },
  {
    "codigo":71874008,
    "descripcion":"HIPERTENSIÓN ESENCIAL BENIGNA QUE COMPLICA EL PARTO Y\/O CONSTITUYE UN MOTIVO DE ATENCIÓN DURANTE ESTE PROCEDIMIENTO"
  },
  {
    "codigo":299415003,
    "descripcion":"TUMEFACCIÓN ÓSEA DE ARTICULACIÓN DE TOBILLO"
  },
  {
    "codigo":364951007,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA MOVER LOS LABIOS"
  },
  {
    "codigo":168343007,
    "descripcion":"ORGANISMO AISLADO EN CULTIVO DE HISOPADO URETRAL"
  },
  {
    "codigo":232044006,
    "descripcion":"NEOVASCULARIZACIÓN OCULAR DEBIDA A OCLUSIÓN VENOSA RETINIANA HEMISFÉRICA"
  },
  {
    "codigo":461420008,
    "descripcion":"ORIGEN ANÓMALO DE ARTERIA CORONARIA CON ÁNGULO AGUDO MENOR DE 45 GRADOS EN RELACIÓN CON LA AORTA"
  },
  {
    "codigo":262977001,
    "descripcion":"DISTENSIÓN DE TENDÓN DEL MÚSCULO PERONEO"
  },
  {
    "codigo":10819101000119107,
    "descripcion":"FRACTURA EXPUESTA DE ESPINA INTERCONDÍLEA DE TIBIA IZQUIERDA"
  },
  {
    "codigo":16035511000119101,
    "descripcion":"OSTEÓLISIS BILATERAL DE TIBIAS"
  },
  {
    "codigo":721729004,
    "descripcion":"MENINGITIS CAUSADA POR ENTEROBACTER"
  },
  {
    "codigo":197441003,
    "descripcion":"COLANGITIS ESCLEROSANTE PRIMARIA"
  },
  {
    "codigo":230209006,
    "descripcion":"ABSCESO CEREBRAL ACTINOMICÓTICO"
  },
  {
    "codigo":295745008,
    "descripcion":"SOBREDOSIS INTENCIONAL DE HIDROXIUREA"
  },
  {
    "codigo":178564791000119103,
    "descripcion":"DISTENSIÓN DE MÚSCULO INTRÍNSECO DE DEDO MEÑIQUE"
  },
  {
    "codigo":64534006,
    "descripcion":"COLECISTITIS HIPERPLÁSICA"
  },
  {
    "codigo":228374007,
    "descripcion":"DROGADICTO REGISTRADO"
  },
  {
    "codigo":423147000,
    "descripcion":"ALÉRGENOS EN EL AMBIENTE"
  },
  {
    "codigo":128235003,
    "descripcion":"TRASTORNO DE GANGLIOS LINFÁTICOS INTRABDOMINALES"
  },
  {
    "codigo":292075004,
    "descripcion":"REACCIÓN ADVERSA AL FENOPROFENO"
  },
  {
    "codigo":95467005,
    "descripcion":"TRAQUEOMALACIA CONGÉNITA"
  },
  {
    "codigo":409743031000119105,
    "descripcion":"TUMOR NEUROENDOCRINO BIEN DIFERENCIADO GRADO 2 DE PULMÓN DERECHO"
  },
  {
    "codigo":290240001,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR ETODOLAC"
  },
  {
    "codigo":93632002,
    "descripcion":"FALTA DE OSIFICACIÓN DEL CENTRO DE LA VÉRTEBRA DORSAL"
  },
  {
    "codigo":124565000,
    "descripcion":"DEFICIENCIA DE ALFA - AMINOACILPÉPTIDO HIDROLASA"
  },
  {
    "codigo":421312009,
    "descripcion":"AGRANULOCITOSIS ASOCIADA CON SIDA (SÍNDROME DE INMUNODEFICIENCIA ADQUIRIDA)"
  },
  {
    "codigo":89962000,
    "descripcion":"TROMBOCITOPENIA NEONATAL POR EXANGUINOTRANSFUSIÓN"
  },
  {
    "codigo":188266000,
    "descripcion":"NEOPLASIA MALIGNA DE LA ESCLERÓTICA"
  },
  {
    "codigo":253802003,
    "descripcion":"QUISTE MESENTÉRICO CONGÉNITO"
  },
  {
    "codigo":450410005,
    "descripcion":"HEMORRAGIA INTRACRANEAL CONSECUTIVA A LESIÓN TRAUMÁTICA"
  },
  {
    "codigo":448575000,
    "descripcion":"COMUNICACIÓN INTERAURICULAR FENESTRADA EN LA FOSA OVAL"
  },
  {
    "codigo":22591001,
    "descripcion":"DEGENERACIÓN DEL CARTÍLAGO Y\/O DEL MENISCO DE LA RODILLA"
  },
  {
    "codigo":57194009,
    "descripcion":"TRASTORNO DE ADAPTACIÓN, CON ESTADO DE ÁNIMO DEPRESIVO"
  },
  {
    "codigo":55359006,
    "descripcion":"INFESTACIÓN CAUSADA POR KNEMIDOKOPTES MUTANS"
  },
  {
    "codigo":186431008,
    "descripcion":"INFECCIÓN POR CLOSTRIDIOIDES DIFFICILE"
  },
  {
    "codigo":1003796001,
    "descripcion":"MIGRACIÓN TRANSUTERINA"
  },
  {
    "codigo":20756002,
    "descripcion":"HIPOFOSFATASIA DEL ADULTO"
  },
  {
    "codigo":15681361000119105,
    "descripcion":"INFECCIÓN DE PIEL DE AMBOS PÁRPADOS DEBIDA A HERPES ZÓSTER"
  },
  {
    "codigo":413972000,
    "descripcion":"REVISIÓN ANUAL POR DEPRESIÓN"
  },
  {
    "codigo":250132005,
    "descripcion":"HALLAZGO LIGAMENTARIO"
  },
  {
    "codigo":444905003,
    "descripcion":"MASA DE PARTES BLANDAS"
  },
  {
    "codigo":51689003,
    "descripcion":"DISTROFIA DE LA VULVA"
  },
  {
    "codigo":84457005,
    "descripcion":"INICIO ESPONTÁNEO DEL TRABAJO DE PARTO"
  },
  {
    "codigo":1073131000119101,
    "descripcion":"ARTRITIS ESTREPTOCÓCICA DE MANO IZQUIERDA"
  },
  {
    "codigo":335851000119101,
    "descripcion":"FORMA COMBINADA DE CATARATA CONGÉNITA DE OJO DERECHO"
  },
  {
    "codigo":770750002,
    "descripcion":"SÍNDROME DE DISCAPACIDAD INTELECTUAL, CONVULSIONES, MACROCEFALIA Y OBESIDAD"
  },
  {
    "codigo":1293203000,
    "descripcion":"MASA DE ARTICULACIÓN DE REGIÓN DE HOMBRO"
  },
  {
    "codigo":35421000087100,
    "descripcion":"INFARTO ANTIGUO DE MIOCARDIO DE REGIÓN INFEROLATERAL"
  },
  {
    "codigo":37981000087101,
    "descripcion":"ACINESIA DE SEGMENTO LATERAL APICAL DE VENTRÍCULO CARDÍACO IZQUIERDO"
  },
  {
    "codigo":736147006,
    "descripcion":"COLANGITIS OBSTRUCTIVA AGUDA"
  },
  {
    "codigo":43101000087101,
    "descripcion":"HEMATOMA DE DEDO ÍNDICE DERECHO"
  },
  {
    "codigo":40541000087101,
    "descripcion":"QUEMADURA DE TODOS LOS DEDOS DE PIE IZQUIERDO"
  },
  {
    "codigo":48221000087105,
    "descripcion":"FRACTURA DE CABEZA DE HÚMERO DERECHO"
  },
  {
    "codigo":767080003,
    "descripcion":"PORTACIÓN ENTÉRICA ASINTOMÁTICA DE ENTAMOEBA"
  },
  {
    "codigo":111720005,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DE MÚLTIPLES SITIOS DE MIEMBRO INFERIOR"
  },
  {
    "codigo":11804651000119106,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA DISTAL DE DEDO MEDIO DERECHO"
  },
  {
    "codigo":109885001,
    "descripcion":"NEOPLASIA SUPERPUESTA MALIGNA DE LA VULVA"
  },
  {
    "codigo":699709007,
    "descripcion":"SOBREDENTADURA MAXILAR DEFECTUOSA"
  },
  {
    "codigo":40679002,
    "descripcion":"ERITROCITOSIS POR HIPOVENTILACIÓN ALVEOLAR"
  },
  {
    "codigo":270055005,
    "descripcion":"PACIENTE REGISTRADO - FP4\/4B"
  },
  {
    "codigo":204519007,
    "descripcion":"FALTA DE DESARROLLO DE LA NARIZ"
  },
  {
    "codigo":827111009,
    "descripcion":"BORDE DEFINIDO DE TUMORACIÓN DE ABDOMEN"
  },
  {
    "codigo":71612002,
    "descripcion":"HIPERTROFIA UTERINA POSTPARTO"
  },
  {
    "codigo":366524002,
    "descripcion":"REFLEJO BULBOCAVERNOSO - HALLAZGO"
  },
  {
    "codigo":169916003,
    "descripcion":"PUNTAJE DE APGAR A LOS 5 MINUTOS = 6"
  },
  {
    "codigo":37009001,
    "descripcion":"METAPLASIA APOCRINA DE LA MAMA"
  },
  {
    "codigo":299153002,
    "descripcion":"AMPLITUD DE EXTENSIÓN ACTIVA DEL PULGAR AUMENTADA"
  },
  {
    "codigo":4241002,
    "descripcion":"LISTERIOSIS"
  },
  {
    "codigo":11860101000119107,
    "descripcion":"ESGUINCE DE LIGAMENTO CRUZADO DE RODILLA DERECHA"
  },
  {
    "codigo":233617005,
    "descripcion":"NEUMONÍA HEMORRÁGICA"
  },
  {
    "codigo":300988009,
    "descripcion":"CARCINOMA DE CÉLULAS DE TRANSICIÓN DE URÉTER"
  },
  {
    "codigo":725137007,
    "descripcion":"SÍNDROME DE NEUTROPENIA, MONOCITOPENIA Y SORDERA"
  },
  {
    "codigo":69777007,
    "descripcion":"GEMELOS ENGANCHADOS"
  },
  {
    "codigo":66107000,
    "descripcion":"INTOXICACIÓN ALIMENTARIA BACTERIANA"
  },
  {
    "codigo":197179001,
    "descripcion":"ABSCESO PERICECAL"
  },
  {
    "codigo":721467002,
    "descripcion":"SÍNDROME DEL CORDÓN ANTERIOR DE MÉDULA ESPINAL AL NIVEL DEL DECIMOSEGUNDO SEGMENTO DORSAL"
  },
  {
    "codigo":426555006,
    "descripcion":"DOLOR IRRADIADO A LA MANDÍBULA"
  },
  {
    "codigo":262715008,
    "descripcion":"LESIÓN TRAUMÁTICA DE VASCULATURA DE LA MÉDULA ESPINAL"
  },
  {
    "codigo":11833631000119105,
    "descripcion":"ESGUINCE DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":293648004,
    "descripcion":"ALERGIA A MISOPROSTOL"
  },
  {
    "codigo":129808005,
    "descripcion":"DIFERENCIA DE LOCALIZACIÓN SEGÚN LA MAMOGRAFÍA"
  },
  {
    "codigo":291813000,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR TOLBUTAMIDA"
  },
  {
    "codigo":95205002,
    "descripcion":"PERFORACIÓN DE LA FARINGE"
  },
  {
    "codigo":160741006,
    "descripcion":"INTERNACIÓN HOSPITALARIA DE LARGA DURACIÓN"
  },
  {
    "codigo":289978001,
    "descripcion":"DIFICULTAD PARA REALIZAR ACTIVIDADES DE CUIDADO DE LAS UÑAS"
  },
  {
    "codigo":224442006,
    "descripcion":"SIN ÁREA DE DESCANSO EN EL TRABAJO"
  },
  {
    "codigo":25999001,
    "descripcion":"ATROFIA DEL CUERPO CAVERNOSO"
  },
  {
    "codigo":124303006,
    "descripcion":"DEFICIENCIA DE MANOCINASA"
  },
  {
    "codigo":89700002,
    "descripcion":"DISTOCIA DE HOMBRO"
  },
  {
    "codigo":417380003,
    "descripcion":"EQUILIBRIO MEMBRANOSO DE LA DURAMADRE"
  },
  {
    "codigo":1269348003,
    "descripcion":"DERRAME PERICÁRDICO DEBIDO A ENFERMEDAD NEOPLÁSICA MALIGNA"
  },
  {
    "codigo":253540005,
    "descripcion":"HIPOPLASIA DEL TRACTO DE SALIDA Y ÁREA TRABECULAR DEL VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":15630931000119100,
    "descripcion":"BURSITIS DE AMBAS CADERAS"
  },
  {
    "codigo":286308008,
    "descripcion":"DIFICULTAD PARA UTILIZAR VOCALES INDIVIDUALES"
  },
  {
    "codigo":87865005,
    "descripcion":"PROTEINURIA CASUAL"
  },
  {
    "codigo":1003534004,
    "descripcion":"SOSPECHA DE GLAUCOMA DE OJO IZQUIERDO CAUSADO POR CORTICOSTEROIDES"
  },
  {
    "codigo":86030004,
    "descripcion":"AMENORREA FISIOLÓGICA SECUNDARIA"
  },
  {
    "codigo":315406006,
    "descripcion":"NACIDO EN LAS ISLAS COMORES"
  },
  {
    "codigo":282638007,
    "descripcion":"DIFICULTAD PARA RODAR SOBRE SÍ MISMO"
  },
  {
    "codigo":249870008,
    "descripcion":"FUNCIÓN MOTORA NO ASOCIADA CON LA LOCOMOCIÓN"
  },
  {
    "codigo":248035003,
    "descripcion":"ROBO EN LOS NEGOCIOS"
  },
  {
    "codigo":278968001,
    "descripcion":"INMUNE A RUBÉOLA"
  },
  {
    "codigo":410040001,
    "descripcion":"MICETOMA EUMICÓTICO DEL PIE"
  },
  {
    "codigo":735885001,
    "descripcion":"LUXACIÓN TRAUMÁTICA DE ARTICULACIÓN INTERFALÁNGICA DE SEGUNDO A QUINTOS DEDOS DEL PIE"
  },
  {
    "codigo":47757001,
    "descripcion":"DEFICIENCIA DE CORTICOSTERONA 18 - MONOOXIGENASA"
  },
  {
    "codigo":80525003,
    "descripcion":"SIGNO DE CAJÓN ANTERIOR"
  },
  {
    "codigo":211597002,
    "descripcion":"LESIÓN CERRADA POR APLASTAMIENTO, RODILLA"
  },
  {
    "codigo":277133002,
    "descripcion":"LESIÓN DE PARTE CORPORAL QUE SE PROYECTA HACIA AFUERA DE VEHÍCULO FERROVIARIO"
  },
  {
    "codigo":768653006,
    "descripcion":"CARIES ACTIVA DE CORONA DENTAL EN ESTADIO EXTENSIVO"
  },
  {
    "codigo":373602003,
    "descripcion":"LACERACIÓN DE LA NARIZ"
  },
  {
    "codigo":111458008,
    "descripcion":"TROMBOSIS VENOSA EN EL PUERPERIO"
  },
  {
    "codigo":766818009,
    "descripcion":"ATAXIA CEREBELOSA NO PROGRESIVA LIGADA AL CROMOSOMA X"
  },
  {
    "codigo":209762008,
    "descripcion":"RUPTURA DE LOS EXTENSORES DE LA MUÑECA"
  },
  {
    "codigo":699447001,
    "descripcion":"SÍNDROME DE ZIMMERMANN-LABAND"
  },
  {
    "codigo":207927004,
    "descripcion":"FRACTURA EXPUESTA DEL AXIS, ARCO POSTERIOR"
  },
  {
    "codigo":44087005,
    "descripcion":"SURCOS TRANSVERSALES DE BEAU"
  },
  {
    "codigo":109623008,
    "descripcion":"HIPOPLASIA GINGIVAL"
  },
  {
    "codigo":238860001,
    "descripcion":"MIOFIBROMATOSIS"
  },
  {
    "codigo":9484001,
    "descripcion":"QUISTE DE CONDUCTO BILIAR"
  },
  {
    "codigo":402700001,
    "descripcion":"DERMATOSIS DE PÁRPADO"
  },
  {
    "codigo":75020007,
    "descripcion":"ESTERILIDAD POSTRAUMÁTICA"
  },
  {
    "codigo":15932141000119107,
    "descripcion":"CINTILLA OVÁRICA DERECHA"
  },
  {
    "codigo":1285601005,
    "descripcion":"HEMATOMA DE PÁRPADO INFERIOR"
  },
  {
    "codigo":204257008,
    "descripcion":"OREJA PROMINENTE CONGÉNITA"
  },
  {
    "codigo":15987591000119102,
    "descripcion":"ANOMALÍA ESTRUCTURAL CONGÉNITA DE CÓRNEA DERECHA"
  },
  {
    "codigo":366262003,
    "descripcion":"TOLERANCIA A LA GLUCOSA EN EL INTESTINO DELGADO - HALLAZGO"
  },
  {
    "codigo":300726004,
    "descripcion":"INCAPAZ DE REALIZAR ACTIVIDADES TELEFÓNICAS"
  },
  {
    "codigo":1078151000119103,
    "descripcion":"DEFORMIDAD EN VALGO CONGÉNITA DE PRIMER DEDO DE PIE IZQUIERDO"
  },
  {
    "codigo":340871000119103,
    "descripcion":"EPÍFORA DE OJO IZQUIERDO DEBIDA A TRASTORNO DEL DRENAJE LAGRIMAL"
  },
  {
    "codigo":266123003,
    "descripcion":"BARTONELOSIS"
  },
  {
    "codigo":724875004,
    "descripcion":"TRASTORNO DE LA PIGMENTACIÓN CUTÁNEA DE CAUSA OCUPACIONAL"
  },
  {
    "codigo":428128000,
    "descripcion":"HERIDA ABIERTA DE LA PIEL POR MORDEDURA"
  },
  {
    "codigo":231520001,
    "descripcion":"SÍNDROME CONDUCTUAL ASOCIADO CON ALTERACIONES FISIOLÓGICAS Y FACTORES FÍSICOS"
  },
  {
    "codigo":426293000,
    "descripcion":"NEUROPATÍA SURAL"
  },
  {
    "codigo":196917000,
    "descripcion":"HERNIA GLÚTEA OBSTRUIDA"
  },
  {
    "codigo":459061001,
    "descripcion":"ENDOCARDITIS INFECCIOSA DE PARED DE VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":721205005,
    "descripcion":"HIPERPLASIA SIMPLE DE GLÁNDULA ENDOMETRIAL SIN ATIPIA"
  },
  {
    "codigo":229685007,
    "descripcion":"DISARTRIA FLÁCCIDA"
  },
  {
    "codigo":360757009,
    "descripcion":"DEFICIENCIA DE PALMITOIL-COA HIDROLASA"
  },
  {
    "codigo":719370002,
    "descripcion":"UTILIZA DISPOSITIVO DE COMUNICACIÓN NO MOTORIZADO"
  },
  {
    "codigo":293386002,
    "descripcion":"REACCIÓN ADVERSA A LA VITAMINA A"
  },
  {
    "codigo":162314006,
    "descripcion":"PENSAMIENTOS DAÑINOS"
  },
  {
    "codigo":193247000,
    "descripcion":"MIOPATÍA AMILOIDE"
  },
  {
    "codigo":94943003,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE MÚSCULO DE LA CADERA"
  },
  {
    "codigo":291551005,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR FLUCLOXACILINA"
  },
  {
    "codigo":289716003,
    "descripcion":"CONTRACCIONES UTERINAS MODERADAS"
  },
  {
    "codigo":1010612004,
    "descripcion":"TORSIÓN DE CORDÓN UMBILICAL"
  },
  {
    "codigo":224180004,
    "descripcion":"SALARIO PAGADO SEMANALMENTE"
  },
  {
    "codigo":27572006,
    "descripcion":"MIOCLONO DE INTENCIÓN"
  },
  {
    "codigo":60340005,
    "descripcion":"MASTITIS RETROMAMARIA"
  },
  {
    "codigo":93108008,
    "descripcion":"FALTA DE OSIFICACIÓN DEL METACARPO"
  },
  {
    "codigo":420788006,
    "descripcion":"LINFOMA MALIGNO INTRAOCULAR NO HODGKIN"
  },
  {
    "codigo":314401000119106,
    "descripcion":"ESCOLIOSIS NEUROMUSCULAR DORSOLUMBAR"
  },
  {
    "codigo":1172617001,
    "descripcion":"PRUEBA DE FUNCIÓN HIPOFISARIA POR DEBAJO DE RANGO DE REFERENCIA"
  },
  {
    "codigo":91273001,
    "descripcion":"ACIDOSIS LÁCTICA"
  },
  {
    "codigo":124041005,
    "descripcion":"LIPOPROTEÍNA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1303689006,
    "descripcion":"QUISTE DE MANO DERECHA"
  },
  {
    "codigo":713865006,
    "descripcion":"SEPSIS PERINATAL CAUSADA POR STREPTOCOCCUS AGALACTIAE"
  },
  {
    "codigo":449886004,
    "descripcion":"CATÉTER DE DERIVACIÓN PARA HIDROCEFALIA IN SITU"
  },
  {
    "codigo":286046005,
    "descripcion":"DIFICULTAD PARA CLASIFICAR LA ROPA SUCIA"
  },
  {
    "codigo":187742008,
    "descripcion":"NEOPLASIA MALIGNA DE CUERPO DE ESTÓMAGO"
  },
  {
    "codigo":253278008,
    "descripcion":"COMUNICACIÓN AURICULOVENTRICULAR AMBIGUA"
  },
  {
    "codigo":415283002,
    "descripcion":"SÍNDROME MIELODISPLÁSICO CON EXCESO DE BLASTOS -1"
  },
  {
    "codigo":87603003,
    "descripcion":"ESPOROTRICOSIS LINFOCUTÁNEA"
  },
  {
    "codigo":16020471000119100,
    "descripcion":"TENOSINOVITIS SUPURATIVA DE TENDÓN FLEXOR DE MANO BILATERAL"
  },
  {
    "codigo":15997431000119101,
    "descripcion":"PLIEGUE COROIDEO DE OJO DERECHO"
  },
  {
    "codigo":127991000119101,
    "descripcion":"HIPERTENSIÓN CONCOMITANTE Y DEBIDA A ENFERMEDAD RENAL TERMINAL EN DIÁLISIS DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":16302071000119103,
    "descripcion":"LESIÓN DE HUESO DE MUSLO DERECHO"
  },
  {
    "codigo":10741751000119100,
    "descripcion":"ANEMIA EN LA MADRE QUE COMPLICA EL NACIMIENTO"
  },
  {
    "codigo":10677751000119100,
    "descripcion":"NÓDULO DE PIEL DE ABDOMEN"
  },
  {
    "codigo":10631671000119106,
    "descripcion":"ONIQUIA DE DEDO DEL PIE DERECHO"
  },
  {
    "codigo":104951000119106,
    "descripcion":"HEMORRAGIA DEL VÍTREO DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":291831000119106,
    "descripcion":"INFLAMACIÓN DE NERVIO PERIFÉRICO DE EXTREMIDAD SUPERIOR DERECHA"
  },
  {
    "codigo":1085431000119101,
    "descripcion":"HEMORRAGIA RECTAL DEBIDA A PÓLIPOS INFLAMATORIOS DEL COLON"
  },
  {
    "codigo":10690551000119101,
    "descripcion":"ANEURISMA AGUDO DE ESTRUCTURA VENOSA"
  },
  {
    "codigo":10751991000119105,
    "descripcion":"CELULITIS DE MAMA POSPARTO"
  },
  {
    "codigo":16058871000119104,
    "descripcion":"FALLA DE TRASPLANTE DE CÓRNEA DE OJO IZQUIERDO"
  },
  {
    "codigo":1090551000119104,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE PABELLÓN AURICULAR DERECHO"
  },
  {
    "codigo":312311000119109,
    "descripcion":"ENFERMEDAD DE KASHIN-BECK DE MUÑECA DERECHA"
  },
  {
    "codigo":16025591000119107,
    "descripcion":"TROMBOFLEBITIS DE VENA YUGULAR DERECHA"
  },
  {
    "codigo":221365751000119108,
    "descripcion":"ENDOMETRIOSIS DE DIAFRAGMA"
  },
  {
    "codigo":247773005,
    "descripcion":"INCAPAZ DE LLORAR CON EMOCIÓN"
  },
  {
    "codigo":15989751000119109,
    "descripcion":"TRASTORNO DEGENERATIVO DE OJO IZQUIERDO"
  },
  {
    "codigo":1263581005,
    "descripcion":"HIDROCEFALIA DEBIDA A NEOPLASIA INTRACRANEAL"
  },
  {
    "codigo":216840008,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR GASES DE COMBUSTIÓN DE VEHÍCULO DETENIDO"
  },
  {
    "codigo":409778008,
    "descripcion":"ABSCESO DE HUESO"
  },
  {
    "codigo":213170009,
    "descripcion":"FALLA PARCIAL DE REIMPLANTE DE DEDO DE LA MANO"
  },
  {
    "codigo":276871002,
    "descripcion":"NEOPLASIA INTRAEPITELIAL VAGINAL, GRADO 1"
  },
  {
    "codigo":406108000,
    "descripcion":"VIRUS DE INMUNODEFICIENCIA HUMANA NO DETECTADO POR ENSAYO DE INMUNOADSORCIÓN LIGADO A ENZIMAS"
  },
  {
    "codigo":111196000,
    "descripcion":"DERMATITIS HERPETIFORME"
  },
  {
    "codigo":735623008,
    "descripcion":"ALBUMINURIA DE GRADO A2"
  },
  {
    "codigo":897628004,
    "descripcion":"FORMA TRIANGULAR ANORMAL CONGÉNITA DE EPÍFISIS DE FALANGE DE DEDO DE PIE"
  },
  {
    "codigo":240433001,
    "descripcion":"OPISTÓTONO TETÁNICO"
  },
  {
    "codigo":1354545002,
    "descripcion":"OCLUSIÓN DE VENA RETINIANA HEMISFÉRICA DE OJO DERECHO"
  },
  {
    "codigo":76593002,
    "descripcion":"INFARTO AGUDO DE MIOCARDIO DE PARED INFEROPOSTERIOR"
  },
  {
    "codigo":109361004,
    "descripcion":"QUISTE CILIADO QUIRÚRGICO"
  },
  {
    "codigo":699185005,
    "descripcion":"HIPERTROFIA MUSCULAR RELACIONADA CON MIOSTATINA"
  },
  {
    "codigo":271366000,
    "descripcion":"DIVERTICULITIS DEL TRACTO GASTROINTESTINAL"
  },
  {
    "codigo":369670001,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA DE PLEURA Y TRÁQUEA, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":402438003,
    "descripcion":"PENFIGOIDE NODULAR"
  },
  {
    "codigo":236763001,
    "descripcion":"TRASTORNO DE TESTÍCULO Y EPIDÍDIMO"
  },
  {
    "codigo":7387004,
    "descripcion":"TROMBOFLEBITIS DE VENA TIBIAL"
  },
  {
    "codigo":105691006,
    "descripcion":"ENFERMEDAD CAUSADA POR CESTODO DE CARYOPHYLLIDEA"
  },
  {
    "codigo":302299007,
    "descripcion":"ANTEPIÉ EN VALGO CONGÉNITO"
  },
  {
    "codigo":71151000119105,
    "descripcion":"TRIPLE CIRCULAR DE CORDÓN"
  },
  {
    "codigo":300464001,
    "descripcion":"EVACUACIÓN INEFICAZ DE VEJIGA URINARIA"
  },
  {
    "codigo":366000002,
    "descripcion":"TEMPERATURA COMPARATIVA EN EXTREMIDADES - HALLAZGO"
  },
  {
    "codigo":1187035007,
    "descripcion":"VISCOSIDAD SANGUÍNEA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":5552004,
    "descripcion":"TRASTORNO DE OVARIO"
  },
  {
    "codigo":398768004,
    "descripcion":"ERITROPLASIA DE QUEYRAT"
  },
  {
    "codigo":71088006,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DEL ANO, CON INFECCIÓN"
  },
  {
    "codigo":890288008,
    "descripcion":"POLIMICROGIRIA PARIETOOCCIPITAL PARASAGITAL BILATERAL"
  },
  {
    "codigo":38320009,
    "descripcion":"ESTADO POSTRAUMÁTICO"
  },
  {
    "codigo":202160008,
    "descripcion":"ARTROFITO EN ARTICULACIÓN DE LA CADERA"
  },
  {
    "codigo":36485005,
    "descripcion":"NEUMOPATÍA RESTRICTIVA"
  },
  {
    "codigo":34650000,
    "descripcion":"LESIONES CARDIOVASCULARES PROVOCADAS POR PINTA"
  },
  {
    "codigo":1279834007,
    "descripcion":"INSENSIBILIDAD CONGÉNITA AL DOLOR, HIPERHIDROSIS, AUSENCIA DE INERVACIÓN SENSITIVA CUTÁNEA"
  },
  {
    "codigo":360495000,
    "descripcion":"ANEMIA MEGALOBLÁSTICA FAMILIAR"
  },
  {
    "codigo":131119003,
    "descripcion":"NIVEL DE SECRETINA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":426031007,
    "descripcion":"ASISTENCIA DE ENFERMERÍA REQUERIDA"
  },
  {
    "codigo":237235009,
    "descripcion":"PRESENTACIÓN DE NALGAS NO DIAGNOSTICADA"
  },
  {
    "codigo":162052001,
    "descripcion":"DOLOR EN FOSA ILÍACA IZQUIERDA"
  },
  {
    "codigo":424196004,
    "descripcion":"SE SIENTE NERVIOSO"
  },
  {
    "codigo":1145092008,
    "descripcion":"PESTAÑAS CORTAS"
  },
  {
    "codigo":29145002,
    "descripcion":"SÍNDROME DE SCHWARTZ-JAMPEL"
  },
  {
    "codigo":94681006,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA VULVA"
  },
  {
    "codigo":191150003,
    "descripcion":"ANEMIA POR DEFICIENCIA DE FOLATO, DEBIDA A TRASTORNOS HEPÁTICOS"
  },
  {
    "codigo":289454004,
    "descripcion":"ESPINAS CIÁTICAS PROMINENTES"
  },
  {
    "codigo":92846006,
    "descripcion":"FUSIÓN ANORMAL CONGÉNITA DE CARTÍLAGO CENTRAL DE VÉRTEBRA SACRA"
  },
  {
    "codigo":715438008,
    "descripcion":"DELECIÓN PARCIAL DISTAL DE BRAZO LARGO DE CROMOSOMA 11"
  },
  {
    "codigo":125614009,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN GLENOHUMERAL"
  },
  {
    "codigo":91011001,
    "descripcion":"ENFERMEDAD DE MÉNIÈRE ACTIVA"
  },
  {
    "codigo":416856001,
    "descripcion":"EPIGLOTIS NO VISIBLE"
  },
  {
    "codigo":23640001,
    "descripcion":"PERIOSTITIS DEL ANTEBRAZO"
  },
  {
    "codigo":449624001,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO DE MÚLTIPLES LOCALIZACIONES DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":254851009,
    "descripcion":"CISTOADENOCARCINOMA MUCINOSO DE OVARIO"
  },
  {
    "codigo":1083171000119107,
    "descripcion":"PERFORACIÓN DE LA PORCIÓN FLÁCIDA DE MEMBRANA TIMPÁNICA BILATERAL"
  },
  {
    "codigo":251181002,
    "descripcion":"CUADRIGEMINISMO VENTRICULAR"
  },
  {
    "codigo":283949007,
    "descripcion":"LACERACIÓN DEL PENE"
  },
  {
    "codigo":249346001,
    "descripcion":"OBSTRUCCIÓN NASAL ALTERNANTE"
  },
  {
    "codigo":183810009,
    "descripcion":"ESTADÍA DE INTERNACIÓN, 12 DÍAS"
  },
  {
    "codigo":247511003,
    "descripcion":"LÚNULA GRANDE"
  },
  {
    "codigo":704428004,
    "descripcion":"ALTERACIÓN DEL DESARROLLO ADOLESCENTE"
  },
  {
    "codigo":16300007,
    "descripcion":"ABSCESO DE LA MÉDULA ESPINAL"
  },
  {
    "codigo":737196008,
    "descripcion":"TRASTORNO VASCULAR DE INTESTINO DELGADO"
  },
  {
    "codigo":276609002,
    "descripcion":"ANORMALIDAD RELACIONADA CON EL PESO AL NACER"
  },
  {
    "codigo":14465002,
    "descripcion":"AMIGDALITIS ULCERATIVA"
  },
  {
    "codigo":47233002,
    "descripcion":"FRACTURA EXPUESTA DEL QUINTO HUESO METATARSIANO"
  },
  {
    "codigo":242006000,
    "descripcion":"LESIÓN PULMONAR POR EXPLOSIÓN"
  },
  {
    "codigo":373078002,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM WOLINSKYI"
  },
  {
    "codigo":274774002,
    "descripcion":"NIVELES ELEVADOS DE TRANSAMINASAS Y ÁCIDO LÁCTICO DESHIDROGENASA"
  },
  {
    "codigo":209238002,
    "descripcion":"FRACTURA-LUXACIÓN NO EXPUESTA DE ARTICULACIÓN DE HOMBRO"
  },
  {
    "codigo":404011000,
    "descripcion":"TUMOR FIBROHISTIOCÍTICO PLEXIFORME DE LA PIEL"
  },
  {
    "codigo":240171001,
    "descripcion":"PLIEGUE SINOVIAL DE LA RODILLA"
  },
  {
    "codigo":1255979002,
    "descripcion":"TINCIÓN INTRÍNSECA DE DIENTE DEBIDA A TRAUMA DENTAL Y POSTERIOR A ÉL"
  },
  {
    "codigo":12630008,
    "descripcion":"IRIDOCICLITIS PRIMARIA"
  },
  {
    "codigo":305707005,
    "descripcion":"VISTO POR UN ODONTÓLOGO"
  },
  {
    "codigo":698923006,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: SUAZI"
  },
  {
    "codigo":829995008,
    "descripcion":"RIÑÓN IZQUIERDO PALPABLE"
  },
  {
    "codigo":764459008,
    "descripcion":"TRISOMÍA DISTAL 16Q"
  },
  {
    "codigo":402176002,
    "descripcion":"REACCIÓN FOTOTÓXICA CAUSADA POR MEDICAMENTO APLICADO EN FORMA TÓPICA"
  },
  {
    "codigo":8960007,
    "descripcion":"MIOTONÍA LEVIOR"
  },
  {
    "codigo":7125002,
    "descripcion":"MENINGOENCEFALITIS"
  },
  {
    "codigo":302037002,
    "descripcion":"FRACTURA-LUXACIÓN EXPUESTA DE ARTICULACIÓN METATARSOFALÁNGICA"
  },
  {
    "codigo":11843671000119107,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE OREJA IZQUIERDA"
  },
  {
    "codigo":72661002,
    "descripcion":"INTOXICACIÓN POR ONOCLEA SENSIBILIS"
  },
  {
    "codigo":1085681000119102,
    "descripcion":"FISURA RECTAL CONGÉNITA"
  },
  {
    "codigo":300202002,
    "descripcion":"RESPONDE A LA VOZ"
  },
  {
    "codigo":365738002,
    "descripcion":"HALLAZGO RELACIONADO CON EL NIVEL DE LITIO"
  },
  {
    "codigo":267434003,
    "descripcion":"HIPERLIPIDEMIA MIXTA"
  },
  {
    "codigo":429439000,
    "descripcion":"QUISTE COMPLEJO DE ANEXOS UTERINOS"
  },
  {
    "codigo":724351008,
    "descripcion":"HIPEREXPLEXIA HEREDITARIA"
  },
  {
    "codigo":298367008,
    "descripcion":"TUMEFACCIÓN DE ARTICULACIÓN TEMPOROMANDIBULAR"
  },
  {
    "codigo":296532000,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE FLUCITOSINA"
  },
  {
    "codigo":722516000,
    "descripcion":"LIPOSARCOMA PRIMARIO DE PERITONEO"
  },
  {
    "codigo":348401000119107,
    "descripcion":"BLEFAROFIMOSIS ADQUIRIDA DE HENDIDURA PALPEBRAL DERECHA"
  },
  {
    "codigo":720681002,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR LOVASTATINA"
  },
  {
    "codigo":294697004,
    "descripcion":"ALERGIA A FLUCLOROLONA"
  },
  {
    "codigo":32553006,
    "descripcion":"RESACA"
  },
  {
    "codigo":196393007,
    "descripcion":"ASIMETRÍA MANDIBULAR"
  },
  {
    "codigo":15667441000119108,
    "descripcion":"METATARSO ADUCTO BILATERAL"
  },
  {
    "codigo":784382001,
    "descripcion":"TRASTORNO DEBIDO A LESIÓN TRAUMÁTICA DE NERVIO DE HOMBRO Y POSTERIOR A ELLA"
  },
  {
    "codigo":1144830006,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR TRICLOFÓS"
  },
  {
    "codigo":192723002,
    "descripcion":"ENCEFALITIS POSVACUNACIÓN CONTRA LA HEPATITIS B"
  },
  {
    "codigo":717011006,
    "descripcion":"ENFERMEDAD DE CHARCOT-MARIE-TOOTH TIPO 2D AUTOSÓMICA DOMINANTE"
  },
  {
    "codigo":225491006,
    "descripcion":"USA ROPA SUCIA"
  },
  {
    "codigo":94419008,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE MÚSCULO DE GLÚTEO"
  },
  {
    "codigo":422099009,
    "descripcion":"TRASTORNO OCULAR DEBIDO A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":23560001,
    "descripcion":"TRASTORNO DE ASPERGER"
  },
  {
    "codigo":127187007,
    "descripcion":"LINFADENOPATÍA PARARRECTAL"
  },
  {
    "codigo":92584005,
    "descripcion":"CARCINOMA IN SITU DE LA EPIGLOTIS"
  },
  {
    "codigo":289192006,
    "descripcion":"HALLAZGO RELACIONADO CON LA CALIDAD DEL HABLA"
  },
  {
    "codigo":190888006,
    "descripcion":"ALCALEMIA METABÓLICA"
  },
  {
    "codigo":713341001,
    "descripcion":"MIELITIS CONCOMITANTE CON INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":1335933003,
    "descripcion":"EPILEPSIA OCCIPITAL FOTOSENSIBLE"
  },
  {
    "codigo":10971531000119108,
    "descripcion":"HERIDA ABIERTA DE REGIÓN DE CODO DERECHO DEBIDA A MORDEDURA DE ANIMAL"
  },
  {
    "codigo":57981008,
    "descripcion":"ACCIDENTE CEREBROVASCULAR EN CURSO"
  },
  {
    "codigo":254589009,
    "descripcion":"SÍNDROME DE POLIPOSIS INTESTINAL"
  },
  {
    "codigo":285522001,
    "descripcion":"DIFICULTAD PARA MOVER LA PUNTA DE LA LENGUA"
  },
  {
    "codigo":21543000,
    "descripcion":"OTITIS EXTERNA ACTÍNICA AGUDA"
  },
  {
    "codigo":283687001,
    "descripcion":"MORDEDURA HUMANA EN LA CARA"
  },
  {
    "codigo":185383005,
    "descripcion":"SE LE SOLICITÓ QUE CONCURRIERA - RESULTADO DE LA INVESTIGACIÓN"
  },
  {
    "codigo":871676000,
    "descripcion":"REACCIÓN ADVERSA A ÁCIDO CROMOGLÍCICO"
  },
  {
    "codigo":52476003,
    "descripcion":"ESTAFILOMA CORNEAL"
  },
  {
    "codigo":249084004,
    "descripcion":"POSICIÓN MENTOILÍACA ANTERIOR"
  },
  {
    "codigo":1363196003,
    "descripcion":"INCAPAZ DE MANTENER LA POSICIÓN SEDENTE EN ASIENTO DE INODORO"
  },
  {
    "codigo":707836006,
    "descripcion":"CAVIDAD PULMONAR CONSECUTIVA A INFECCIÓN POR COCCIDIOIDES"
  },
  {
    "codigo":609532009,
    "descripcion":"HIPERSENSIBILIDAD NO ALÉRGICA A TIOSULFATO DE SODIO"
  },
  {
    "codigo":247249003,
    "descripcion":"AUSENCIA DE CONDUCTO AUDITIVO"
  },
  {
    "codigo":1197521004,
    "descripcion":"MUCOSITIS DEBIDA A QUIMIOTERAPIA Y POSTERIOR A ELLA"
  },
  {
    "codigo":771537008,
    "descripcion":"INFECCIÓN DEL TEJIDO PROFUNDO EN EL LUGAR DE PUNCIÓN DEBIDO A BLOQUEO DE NERVIO PERIFÉRICO Y POSTERIOR A ELLA"
  },
  {
    "codigo":442022002,
    "descripcion":"ALERGIA A MEROPENEM"
  },
  {
    "codigo":16038004,
    "descripcion":"ABORTO DEBIDO A LEPTOSPIRA"
  },
  {
    "codigo":15997631000119103,
    "descripcion":"COROIDOPATÍA SEROSA CENTRAL DE AMBOS OJOS"
  },
  {
    "codigo":704166007,
    "descripcion":"HIPERCALCEMIA HIPOCALCIÚRICA ADQUIRIDA"
  },
  {
    "codigo":210811000,
    "descripcion":"LESIÓN DE VASO SANGUÍNEO RENAL"
  },
  {
    "codigo":1162918009,
    "descripcion":"DERMATITIS INFECCIOSA ASOCIADA AL HTLV-1"
  },
  {
    "codigo":1259387001,
    "descripcion":"CARCINOMA ADENOESCAMOSO PRIMARIO DE CUELLO UTERINO"
  },
  {
    "codigo":12368000,
    "descripcion":"CIRROSIS BILIAR SECUNDARIA"
  },
  {
    "codigo":405584002,
    "descripcion":"RUPTURA TRAUMÁTICA DE RIÑÓN"
  },
  {
    "codigo":733264006,
    "descripcion":"MÚLTIPLES LESIONES TRAUMÁTICAS DE MUÑECA"
  },
  {
    "codigo":766032007,
    "descripcion":"SÍNDROME DE HOLOPROSENCEFALIA, ECTRODACTILIA Y FISURA DE LABIO Y PALADAR"
  },
  {
    "codigo":403749002,
    "descripcion":"FORMACIÓN DE AMPOLLAS EN PIEL POR COMA FARMACOLÓGICO"
  },
  {
    "codigo":76069003,
    "descripcion":"ENFERMEDAD DE HUESO"
  },
  {
    "codigo":895269003,
    "descripcion":"FORMA ANCHA ANORMAL CONGÉNITA DE FALANGE PROXIMAL DE DEDO ANULAR"
  },
  {
    "codigo":305445005,
    "descripcion":"BAJO ATENCIÓN DE ACUPUNTURISTA"
  },
  {
    "codigo":678591000119107,
    "descripcion":"CATARATA SENIL POLAR SUBCAPSULAR ANTERIOR DE OJO DERECHO"
  },
  {
    "codigo":698661007,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: FRISIO"
  },
  {
    "codigo":205306000,
    "descripcion":"AGENESIA TOTAL DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":762362006,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA CINTILLA ÓPTICA IZQUIERDA"
  },
  {
    "codigo":238074007,
    "descripcion":"XANTOMATOSIS, FAMILIAR"
  },
  {
    "codigo":72399002,
    "descripcion":"ÍNDICE CARDÍACO NORMAL"
  },
  {
    "codigo":400079002,
    "descripcion":"ECCEMA INFECTADO"
  },
  {
    "codigo":301775005,
    "descripcion":"INFECCIÓN DE ÚTERO"
  },
  {
    "codigo":203471008,
    "descripcion":"TUMOR PARDO DEL HIPERPARATIROIDISMO"
  },
  {
    "codigo":299940001,
    "descripcion":"HALLAZGO RELACIONADO CON LA SENSACIÓN DE POSICIÓN ARTICULAR"
  },
  {
    "codigo":5028002,
    "descripcion":"PANSINUSITIS AGUDA"
  },
  {
    "codigo":234404008,
    "descripcion":"DEFICIENCIA DE GLUCOSAFOSFATO ISOMERASA"
  },
  {
    "codigo":37796009,
    "descripcion":"MIGRAÑA"
  },
  {
    "codigo":396409001,
    "descripcion":"COMPROMISO DEL ESPÉCIMEN POR GANGLIO(S) SATÉLITE(S): NO PUEDE DETERMINARSE"
  },
  {
    "codigo":365476009,
    "descripcion":"HALLAZGO RELACIONADO CON EL TIPO DE CRIANZA"
  },
  {
    "codigo":298105007,
    "descripcion":"CUERPO EXTRAÑO EN LA PIEL DE LA PLANTA DEL PIE"
  },
  {
    "codigo":216051000119102,
    "descripcion":"FILTRO DE VENA CAVA INFERIOR IN SITU"
  },
  {
    "codigo":296270002,
    "descripcion":"SOBREDOSIS DE FLUPENTIXOL"
  },
  {
    "codigo":34126003,
    "descripcion":"INSUFICIENCIA DE VÁLVULA PULMONAR REUMÁTICA"
  },
  {
    "codigo":230734005,
    "descripcion":"VASCULITIS GRANULOMATOSA DEL SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":720419000,
    "descripcion":"DISOSTOSIS ACROFACIAL TIPO CATANIA"
  },
  {
    "codigo":197966009,
    "descripcion":"PROSTATITIS SIFILÍTICA"
  },
  {
    "codigo":425507004,
    "descripcion":"DISPOSICIÓN PARA MEJORAR EL ESTADO DE INMUNIZACIÓN"
  },
  {
    "codigo":196131004,
    "descripcion":"COMPROMISO PULMONAR ASOCIADO CON OTRO TRASTORNO"
  },
  {
    "codigo":1144568000,
    "descripcion":"HIPOPLASIA CONGÉNITA DE MÚSCULO DELTOIDES"
  },
  {
    "codigo":292600006,
    "descripcion":"REACCIÓN ADVERSA AL NEDOCROMILO"
  },
  {
    "codigo":15918221000119100,
    "descripcion":"FRACTURA NO EXPUESTA DE CRESTA ALVEOLAR DE LADO IZQUIERDO DE MAXILAR SUPERIOR"
  },
  {
    "codigo":94157000,
    "descripcion":"NEOPLASIA SECUNDARIA MALIGNA DEL ACROMION"
  },
  {
    "codigo":290765003,
    "descripcion":"INTOXICACIÓN CON VINCRISTINA"
  },
  {
    "codigo":716749005,
    "descripcion":"FATIGA ASOCIADA CON ENFERMEDAD NEOPLÁSICA MALIGNA"
  },
  {
    "codigo":1306573008,
    "descripcion":"CARCINOMA DUCTAL INFILTRANTE DE CUADRANTE INFERIOR EXTERNO DE MAMA DERECHA"
  },
  {
    "codigo":126925009,
    "descripcion":"NEOPLASIA DEL CLÍTORIS"
  },
  {
    "codigo":420002000,
    "descripcion":"TAQUICARDIA INCISIONAL DE LA AURÍCULA IZQUIERDA"
  },
  {
    "codigo":714914005,
    "descripcion":"CAPACIDAD ALTERADA PARA PASAR DE UNA UBICACIÓN A OTRA"
  },
  {
    "codigo":288930006,
    "descripcion":"CAPAZ DE ELIMINAR RESIDUOS DE LA BOCA"
  },
  {
    "codigo":92322005,
    "descripcion":"NEOPLASIA BENIGNA DEL TEJIDO RETROCECAL"
  },
  {
    "codigo":59554006,
    "descripcion":"HOLOACARDIO ACORMO"
  },
  {
    "codigo":1237367001,
    "descripcion":"NEOPLASIA DE CÉLULAS EPITELIOIDES PERIVASCULARES DE COMPORTAMIENTO INCIERTO"
  },
  {
    "codigo":449100005,
    "descripcion":"SARCOMA DE HUESO DE PELVIS"
  },
  {
    "codigo":447265000,
    "descripcion":"CUERPO EXTRAÑO EN PIERNA"
  },
  {
    "codigo":285260009,
    "descripcion":"CAPAZ DE RESISTIRSE A PENSAMIENTOS OBSESIVOS"
  },
  {
    "codigo":186956008,
    "descripcion":"MENINGITIS LEPTOSPIRÓSICA"
  },
  {
    "codigo":840481003,
    "descripcion":"LUXACIÓN CONGÉNITA DE AMBAS RODILLAS"
  },
  {
    "codigo":283425004,
    "descripcion":"CORTE EN EL ABDOMEN"
  },
  {
    "codigo":54049006,
    "descripcion":"FIEBRE CAUSADA POR EL VIRUS DE LA FIEBRE SICILIANA TRANSMITIDA POR FLEBÓTOMOS"
  },
  {
    "codigo":248822008,
    "descripcion":"DESPLAZAMIENTO DEL PEZÓN"
  },
  {
    "codigo":12205351000119105,
    "descripcion":"INFECCIÓN DE PERONÉ DERECHO ASOCIADA CON DISPOSITIVO DE FIJACIÓN INTERNA"
  },
  {
    "codigo":1197259008,
    "descripcion":"MESOTELIOMA PLEURAL MALIGNO PRIMARIO SARCOMATOIDE"
  },
  {
    "codigo":212384002,
    "descripcion":"SÍNDROME COMPARTIMENTAL DE MUSLO DEBIDO A LESIÓN TRAUMÁTICA"
  },
  {
    "codigo":246987008,
    "descripcion":"CÁMARA OCULAR ANTERIOR UNIFORMEMENTE POCO PROFUNDA"
  },
  {
    "codigo":1259125004,
    "descripcion":"ESCLEROSIS LATERAL AMIOTRÓFICA CON ATROFIA DE MÚLTIPLES SISTEMAS"
  },
  {
    "codigo":308853007,
    "descripcion":"DISPLASIA LEVE DE ESTÓMAGO"
  },
  {
    "codigo":210549008,
    "descripcion":"SECCIÓN PARCIAL DE TENDÓN EXTENSOR DE LA MUÑECA"
  },
  {
    "codigo":43039008,
    "descripcion":"PELVIS MESATIPÉLICA"
  },
  {
    "codigo":403487009,
    "descripcion":"LUPUS ERITEMATOSO SISTÉMICO FULMINANTE"
  },
  {
    "codigo":237812002,
    "descripcion":"TRASTORNO DE LA PUBERTAD"
  },
  {
    "codigo":172276003,
    "descripcion":"AVULSIÓN DE NERVIO DE PÁRPADO"
  },
  {
    "codigo":73972002,
    "descripcion":"NEUROSIS POSTPARTO"
  },
  {
    "codigo":235977001,
    "descripcion":"MALFORMACIÓN CONGÉNITA DE PÁNCREAS"
  },
  {
    "codigo":365214000,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA USAR UNA BOTELLA URINARIA"
  },
  {
    "codigo":299678002,
    "descripcion":"CRECIMIENTO EXCESIVO DE VELLO EN EL BRAZO"
  },
  {
    "codigo":1348254002,
    "descripcion":"RADIONECROSIS DE PIEL DEBIDA A RADIOTERAPIA Y POSTERIOR A ELLA"
  },
  {
    "codigo":135838004,
    "descripcion":"PELVIS DEFORMADA"
  },
  {
    "codigo":234142008,
    "descripcion":"MALFORMACIÓN ARTERIOVENOSA CEREBRAL"
  },
  {
    "codigo":363379000,
    "descripcion":"NEOPLASIA MALIGNA DE GLÁNDULA PARÓTIDA"
  },
  {
    "codigo":723827003,
    "descripcion":"SÍNDROME DE GRANT"
  },
  {
    "codigo":68467004,
    "descripcion":"PÉRDIDA DE LA AUDICIÓN CENTRAL"
  },
  {
    "codigo":428915008,
    "descripcion":"ANTICUERPO CONTRA TOXOPLASMA GONDII DETECTADO"
  },
  {
    "codigo":296008001,
    "descripcion":"SOBREDOSIS INTENCIONAL DE ETOSUXIMIDA"
  },
  {
    "codigo":164936000,
    "descripcion":"ELECTROCARDIOGRAMA: ONDA U NORMAL"
  },
  {
    "codigo":230472004,
    "descripcion":"CEFALEA EN SALVAS EPISÓDICA"
  },
  {
    "codigo":263240009,
    "descripcion":"FRACTURA DE PILÓN TIBIAL"
  },
  {
    "codigo":1144306000,
    "descripcion":"LEIOMIOSARCOMA DE LA CURVATURA MENOR DEL ESTÓMAGO"
  },
  {
    "codigo":294173009,
    "descripcion":"ALERGIA A DITRANOL"
  },
  {
    "codigo":292338002,
    "descripcion":"REACCIÓN ADVERSA AL AMILOBARBITAL"
  },
  {
    "codigo":95730003,
    "descripcion":"QUERATITIS MARGINAL"
  },
  {
    "codigo":1306311000,
    "descripcion":"NEOPLASIA BENIGNA DE ARÉOLA"
  },
  {
    "codigo":1177074009,
    "descripcion":"DUODENITIS PARASITARIA"
  },
  {
    "codigo":126663003,
    "descripcion":"TRASTORNO DE LA HIPOFARINGE"
  },
  {
    "codigo":716487003,
    "descripcion":"DIFICULTAD EN UTILIZAR LA PRAGMÁTICA EN LA COMUNICACIÓN"
  },
  {
    "codigo":290503005,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR METOHEXITAL"
  },
  {
    "codigo":28359007,
    "descripcion":"FRACTURA NO EXPUESTA DE CABEZA DE PERONÉ"
  },
  {
    "codigo":288668005,
    "descripcion":"DIFICULTAD PARA MANTENER UNA CONVERSACIÓN"
  },
  {
    "codigo":59292006,
    "descripcion":"MIGRAÑA HEMIPLÉJICA"
  },
  {
    "codigo":92060009,
    "descripcion":"NEOPLASIA BENIGNA DEL CUERPO CILIAR"
  },
  {
    "codigo":1781000119107,
    "descripcion":"ESGUINCE DE TOBILLO DE SEGUNDO GRADO"
  },
  {
    "codigo":286833004,
    "descripcion":"TIENDE A NO APRENDER DE LAS EXPERIENCIAS NEGATIVAS"
  },
  {
    "codigo":254065005,
    "descripcion":"DISPLASIA SEUDORREUMATOIDE PROGRESIVA"
  },
  {
    "codigo":188529007,
    "descripcion":"PARAGRANULOMA DE HODGKIN DE GANGLIOS LINFÁTICOS INTRAPÉLVICOS"
  },
  {
    "codigo":448838000,
    "descripcion":"FRACTURA EXTRARTICULAR DE RADIO DISTAL NO EXPUESTA"
  },
  {
    "codigo":57231000119103,
    "descripcion":"FOTOGRAFÍA DE RETINA INCONCLUYENTE"
  },
  {
    "codigo":186694006,
    "descripcion":"TRANSPIRACIÓN POR FIEBRE"
  },
  {
    "codigo":284998008,
    "descripcion":"CAPAZ DE ABROCHAR LA ROPA"
  },
  {
    "codigo":86555001,
    "descripcion":"FIBROSIS QUÍSTICA DEL PULMÓN"
  },
  {
    "codigo":53787002,
    "descripcion":"LARINGISMO"
  },
  {
    "codigo":283163002,
    "descripcion":"CUERPO EXTRAÑO METÁLICO EN DEDO DE LA MANO"
  },
  {
    "codigo":250395004,
    "descripcion":"ANTÍGENO TIPO CARTWRIGHT"
  },
  {
    "codigo":21019005,
    "descripcion":"INTOXICACIÓN POR ORNITHOGALUM THYROSIDES"
  },
  {
    "codigo":1004059006,
    "descripcion":"CONTRACTURA EN FLEXIÓN DE ARTICULACIÓN INTERFALÁNGICA PROXIMAL DE SEGUNDO DEDO DE PIE"
  },
  {
    "codigo":709147009,
    "descripcion":"GINGIVITIS CONCOMITANTE CON DIABETES MELLITUS"
  },
  {
    "codigo":51952004,
    "descripcion":"DISPLASIA ESPONDILOEPIFISARIA TARDÍA"
  },
  {
    "codigo":248560005,
    "descripcion":"HEMITÓRAX IZQUIERDO SE MUEVE MENOS QUE EL HEMITÓRAX DERECHO"
  },
  {
    "codigo":281328006,
    "descripcion":"NO SE ESPECIFICÓ EL MÉDICO SOLICITANTE"
  },
  {
    "codigo":838384006,
    "descripcion":"ABSCESO DE ESPACIO SUBDURAL DE MÉDULA ESPINAL CAUSADO POR HONGO"
  },
  {
    "codigo":117488007,
    "descripcion":"CRISTAL URINARIO, FOSFATO TRICÁLCICO"
  },
  {
    "codigo":1264368006,
    "descripcion":"LACERACIÓN DE TENDÓN DE BRAZO"
  },
  {
    "codigo":50117000,
    "descripcion":"INTOXICACIÓN POR RHEUM RHAPONICUM"
  },
  {
    "codigo":10624911000119107,
    "descripcion":"OTITIS MEDIA CAUSADA POR VIRUS INFLUENZA H1N1"
  },
  {
    "codigo":443333004,
    "descripcion":"MEDULOBLASTOMA"
  },
  {
    "codigo":771013004,
    "descripcion":"SÍNDROME DE PILOTTO"
  },
  {
    "codigo":246725007,
    "descripcion":"DESPLAZAMIENTO DEL REFLEJO PUPILAR A LA LUZ"
  },
  {
    "codigo":17349007,
    "descripcion":"TRIADITIS PORTAL"
  },
  {
    "codigo":277658006,
    "descripcion":"CRECIMIENTO FETAL CLÍNICO ESCASO"
  },
  {
    "codigo":111983000,
    "descripcion":"DESGASTE DE UÑAS"
  },
  {
    "codigo":212122009,
    "descripcion":"QUEMADURA QUE COMPROMETE MÁS DEL 90 POR CIENTO DE LA SUPERFICIE CORPORAL, CON 60 - 69 POR CIENTO DE SUPERFICIE CORPORAL CON QUEMADURA DE TERCER GRADO"
  },
  {
    "codigo":1258863003,
    "descripcion":"TRASTORNO DE ERUPCIÓN DE DIENTE PERMANENTE DEBIDO A TRAUMATISMO DENTAL Y POSTERIOR A ÉL"
  },
  {
    "codigo":243055004,
    "descripcion":"INTOXICACIÓN POR GAS IRRITANTE"
  },
  {
    "codigo":10899004,
    "descripcion":"GALACTOSEMIA CLÁSICA, HOMOCIGOTA TIPO DUARTE"
  },
  {
    "codigo":79215008,
    "descripcion":"AGOTAMIENTO MUSCULAR DE ALTA FRECUENCIA"
  },
  {
    "codigo":306756001,
    "descripcion":"DIFICULTAD PARA PRODUCIR SONIDOS SONOROS"
  },
  {
    "codigo":110148008,
    "descripcion":"AVULSIÓN DEL CUELLO"
  },
  {
    "codigo":403225001,
    "descripcion":"FOTOSUBTIPO CUTÁNEO IIC (AL COMIENZO SIEMPRE EXISTE QUEMADURA, A VECES BRONCEADO INTENSO)"
  },
  {
    "codigo":208452009,
    "descripcion":"FRACTURA NO EXPUESTA DE LA FALANGE MEDIA DE DEDO DE LA MANO, DIÁFISIS"
  },
  {
    "codigo":1961000221101,
    "descripcion":"BOTULISMO DEL LACTANTE"
  },
  {
    "codigo":1255193005,
    "descripcion":"CARCINOMA PRIMARIO DE CÉLULAS DE HURTHLE DE TIROIDES"
  },
  {
    "codigo":1351662000,
    "descripcion":"ARTRITIS REACTIVA DEBIDA A URETRITIS INFECCIOSA Y POSTERIOR A ELLA"
  },
  {
    "codigo":237550001,
    "descripcion":"HIPOTIROXINEMIA EUTIROIDEA"
  },
  {
    "codigo":1220590003,
    "descripcion":"LUPUS ERITEMATOSO PERNIO FAMILIAR"
  },
  {
    "codigo":303086007,
    "descripcion":"VÁRICES DUODENALES"
  },
  {
    "codigo":204782009,
    "descripcion":"ATRESIA DE CONDUCTOS HEPÁTICOS"
  },
  {
    "codigo":268483002,
    "descripcion":"ENTRENAMIENTO ESFINTERIANO"
  },
  {
    "codigo":202947003,
    "descripcion":"GANGLIÓN DE VAINA TENDINOSA DE FLEXOR DE DEDO DE LA MANO"
  },
  {
    "codigo":399555002,
    "descripcion":"COMPROMISO TUMORAL DEL MARGEN QUIRÚRGICO DISTAL NO PUEDE EVALUARSE"
  },
  {
    "codigo":37272000,
    "descripcion":"SÍNDROME DE DEFICIENCIA DE RH"
  },
  {
    "codigo":301251009,
    "descripcion":"AUSENCIA DE BOSTEZO"
  },
  {
    "codigo":168344001,
    "descripcion":"ORGANISMO NO AISLADO EN CULTIVO DE HISOPADO URETRAL"
  },
  {
    "codigo":70040003,
    "descripcion":"ESCALA DEL COMA DE GLASGOW, 15"
  },
  {
    "codigo":233880002,
    "descripcion":"TRASTORNO CRÓNICO DE MIOCARDIO CAUSADO POR AGENTES QUÍMICOS O AGENTES EXTERNOS"
  },
  {
    "codigo":299416002,
    "descripcion":"TUMEFACCIÓN DE PARTES BLANDAS DE ARTICULACIÓN DE TOBILLO"
  },
  {
    "codigo":235715008,
    "descripcion":"ENFERMEDAD DIAFRAGMÁTICA DEL INTESTINO"
  },
  {
    "codigo":201112007,
    "descripcion":"UÑA DE DEDO DE LA MANO ENCARNADA (EXCEPTO LA DEL PULGAR)"
  },
  {
    "codigo":232045007,
    "descripcion":"EDEMA MACULAR DEBIDO A OCLUSIÓN VENOSA RETINIANA HEMISFÉRICA"
  },
  {
    "codigo":461421007,
    "descripcion":"ARTERIA CORONARIA ANÓMALA SIN ÁNGULO AGUDO MENOR DE 45 GRADOS EN RELACIÓN CON LA AORTA"
  },
  {
    "codigo":230210001,
    "descripcion":"ABSCESO PIOGÉNICO DEL TRONCO ENCEFÁLICO"
  },
  {
    "codigo":197442005,
    "descripcion":"COLANGITIS ESCLEROSANTE SECUNDARIA"
  },
  {
    "codigo":834008,
    "descripcion":"POSICIÓN COITAL SENTADA"
  },
  {
    "codigo":31767001,
    "descripcion":"MODIFICACIÓN DE LA TEXTURA DE LAS UÑAS"
  },
  {
    "codigo":721730009,
    "descripcion":"INFECCIÓN CAUSADA POR HELICOBACTER PYLORI"
  },
  {
    "codigo":293911006,
    "descripcion":"ALERGIA A BUSPIRONA"
  },
  {
    "codigo":95468000,
    "descripcion":"BRONCOMALACIA CONGÉNITA"
  },
  {
    "codigo":228375008,
    "descripcion":"EMPLEA FÁRMACOS DE MANERA INCORRECTA, POR VÍA ORAL"
  },
  {
    "codigo":128236002,
    "descripcion":"ENFERMEDAD CRÓNICA DE LA PIEL"
  },
  {
    "codigo":292076003,
    "descripcion":"REACCIÓN ADVERSA AL FLURBIPROFENO"
  },
  {
    "codigo":718060003,
    "descripcion":"PERIODONTITIS CRÓNICA GENERALIZADA LEVE"
  },
  {
    "codigo":423148005,
    "descripcion":"TRASTORNO DEBIDO A VARIANTE ENZIMÁTICA DE N-ACETILTRANSFERASA"
  },
  {
    "codigo":160904001,
    "descripcion":"TRABAJO DE MEDIA JORNADA"
  },
  {
    "codigo":880065001,
    "descripcion":"DEFICIENCIA DE ALFA-N-ACETIL GALACTOSAMINIDASA TIPO 2"
  },
  {
    "codigo":93633007,
    "descripcion":"FALTA DE OSIFICACIÓN DE LA CLAVÍCULA"
  },
  {
    "codigo":288406000,
    "descripcion":"CAPAZ DE ENROSCAR UNA TAPA"
  },
  {
    "codigo":386710007,
    "descripcion":"INCONTINENCIA NEUROGÉNICA"
  },
  {
    "codigo":417643003,
    "descripcion":"DISTENSIÓN DE LIGAMENTO ARTICULAR"
  },
  {
    "codigo":1236843008,
    "descripcion":"SÍNDROME DE HAPLOINSUFICIENCIA DE FOSFODIESTERASA 4D"
  },
  {
    "codigo":10682871000119105,
    "descripcion":"TUMEFACCIÓN DEL TEJIDO CELULAR SUBCUTÁNEO DEL PIE DERECHO"
  },
  {
    "codigo":29691000175106,
    "descripcion":"ÚLCERA POR PRESIÓN EN CADERA, ESTADIO III"
  },
  {
    "codigo":415808001,
    "descripcion":"ESTRABISMO CON PATRÓN EN V"
  },
  {
    "codigo":12030001000004100,
    "descripcion":"FRACTURA DE COSTILLA IZQUIERDA"
  },
  {
    "codigo":448576004,
    "descripcion":"FENESTRACIÓN DE CÚSPIDE DE VÁLVULA AÓRTICA"
  },
  {
    "codigo":250133000,
    "descripcion":"HALLAZGO DE TENDÓN"
  },
  {
    "codigo":14270001000004104,
    "descripcion":"DIFERENCIA DE POTENCIAL NASAL ANORMAL"
  },
  {
    "codigo":842853311000132105,
    "descripcion":"OBSTRUCCIÓN DE STENT PANCREÁTICO"
  },
  {
    "codigo":11829751000119107,
    "descripcion":"LACERACIÓN DE MÚSCULO DE MANO IZQUIERDA"
  },
  {
    "codigo":45235005,
    "descripcion":"DEFICIENCIA LEVE DE ESTEROIDE 21 - HIDROXILASA"
  },
  {
    "codigo":1003797005,
    "descripcion":"MIGRACIÓN TRANSPERITONEAL"
  },
  {
    "codigo":413973005,
    "descripcion":"REVISIÓN INTERINA SOBRE DEPRESIÓN"
  },
  {
    "codigo":11311761000119102,
    "descripcion":"FRACTURA PATOLÓGICA DE VÉRTEBRA SACRA"
  },
  {
    "codigo":1264106001,
    "descripcion":"TRASTORNO FETAL CAUSADO POR TRANSFERENCIA PLACENTARIA DE DEPRESOR UTERINO"
  },
  {
    "codigo":282901009,
    "descripcion":"CAPAZ DE LEVANTARSE DESDE POSICIÓN DE CUCLILLAS"
  },
  {
    "codigo":16007671000119109,
    "descripcion":"MALFORMACIÓN VASCULAR CONGÉNITA DE AMBOS MIEMBROS SUPERIORES"
  },
  {
    "codigo":1296874008,
    "descripcion":"DETENCIÓN PARCIAL DE CRECIMIENTO EPIFISARIO DE RADIO DISTAL"
  },
  {
    "codigo":248298009,
    "descripcion":"HÁBITO MARFANOIDE"
  },
  {
    "codigo":770751003,
    "descripcion":"SÍNDROME DE DISCAPACIDADES MOTRICES E INTELECTUALES SEVERAS, SORDERA NEUROSENSORIAL Y DISTONÍA"
  },
  {
    "codigo":17087005,
    "descripcion":"ÚLCERA EN SILLA DE MONTAR"
  },
  {
    "codigo":334481000119105,
    "descripcion":"GRANULOMA DE SACO LAGRIMAL DERECHO"
  },
  {
    "codigo":15252000,
    "descripcion":"SOPLO DE MAQUINARIA"
  },
  {
    "codigo":1293204006,
    "descripcion":"MASA DE ARTICULACIÓN DE REGIÓN DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":1260436007,
    "descripcion":"SINOVITIS Y TENOSINOVITIS DE ARTICULACIÓN DE MANO"
  },
  {
    "codigo":373865001,
    "descripcion":"MORBILIDAD RELACIONADA CON EL TRATAMIENTO ONCOLÓGICO"
  },
  {
    "codigo":111721009,
    "descripcion":"CONTUSIÓN DE SITIOS MÚLTIPLES"
  },
  {
    "codigo":699710002,
    "descripcion":"SOBREDENTADURA MANDIBULAR DEFECTUOSA"
  },
  {
    "codigo":372030009,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE CUERDA VOCAL"
  },
  {
    "codigo":1254931004,
    "descripcion":"VITILIGO DE MEMBRANA MUCOSA"
  },
  {
    "codigo":43831000087100,
    "descripcion":"CORTE EN PIEL DE ANTEBRAZO DERECHO"
  },
  {
    "codigo":33591000087102,
    "descripcion":"ALVEOLITIS PULMONAR AGUDA CAUSADA POR VAPORES QUÍMICOS"
  },
  {
    "codigo":41271000087103,
    "descripcion":"HEMATOMA DE REGIÓN DE CODO DERECHO"
  },
  {
    "codigo":239123007,
    "descripcion":"NEVO DE PELO RECTO"
  },
  {
    "codigo":46391000087104,
    "descripcion":"FRACTURA DE EPÍFISIS DISTAL DE FÉMUR IZQUIERDO"
  },
  {
    "codigo":827112002,
    "descripcion":"BORDE SUPERIOR DEFINIDO DE TUMORACIÓN DE ABDOMEN"
  },
  {
    "codigo":73448002,
    "descripcion":"NEUMOPATÍA DE LOS TRABAJADORES DE ALIMENTO PARA PECES"
  },
  {
    "codigo":40680004,
    "descripcion":"CARÁCTER EXPLOSIVO"
  },
  {
    "codigo":38711000087109,
    "descripcion":"AGITACIÓN VERBAL"
  },
  {
    "codigo":270056006,
    "descripcion":"PACIENTE REGISTRADO - FP1"
  },
  {
    "codigo":11776811000119106,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DE ANTEBRAZO IZQUIERDO"
  },
  {
    "codigo":16419781000119100,
    "descripcion":"PENACHO VITREORRETINIANO DE OJO IZQUIERDO"
  },
  {
    "codigo":6077001,
    "descripcion":"PIE PÉNDULO"
  },
  {
    "codigo":300989001,
    "descripcion":"VAGABUNDEO EN ESTADO DE AGITACIÓN"
  },
  {
    "codigo":366525001,
    "descripcion":"AMPLITUD DE MOVIMIENTO PASIVO DE FLEXIÓN DE LA MUÑECA - HALLAZGO"
  },
  {
    "codigo":308011000119107,
    "descripcion":"HIPERLAXITUD ARTICULAR DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":302824004,
    "descripcion":"GASTRINOMA"
  },
  {
    "codigo":169917007,
    "descripcion":"PUNTAJE DE APGAR A LOS 5 MINUTOS = 7"
  },
  {
    "codigo":233618000,
    "descripcion":"NEUMONÍA MICOBACTERIANA"
  },
  {
    "codigo":725138002,
    "descripcion":"SÍNDROME DE HEMANGIOMA PERINEAL, MALFORMACIÓN DE GENITALES EXTERNOS, LIPOMIELOMENINGOCELE, ANOMALÍAS VESICORRENALES Y ANO IMPERFORADO"
  },
  {
    "codigo":299154008,
    "descripcion":"AMPLITUD DE EXTENSIÓN ACTIVA DEL PULGAR DISMINUIDA"
  },
  {
    "codigo":4242009,
    "descripcion":"SÍNDROME DE MONOSOMÍA PARCIAL 18Q"
  },
  {
    "codigo":10849221000119104,
    "descripcion":"CUERPO EXTRAÑO EN REGIÓN EXTERNA DE OJO DERECHO"
  },
  {
    "codigo":197180003,
    "descripcion":"ABSCESO PELVIANO EN PACIENTE DE SEXO MASCULINO"
  },
  {
    "codigo":33340004,
    "descripcion":"CONCEPCIÓN MÚLTIPLE"
  },
  {
    "codigo":66108005,
    "descripcion":"DEMENCIA DEGENERATIVA PRIMARIA DE TIPO ALZHEIMER, DE INICIO EN LA EDAD SENIL, NO COMPLICADA"
  },
  {
    "codigo":721468007,
    "descripcion":"SÍNDROME DEL CORDÓN POSTERIOR DE MÉDULA ESPINAL DORSAL"
  },
  {
    "codigo":262716009,
    "descripcion":"LESIÓN DE ARTERIA ESPINAL ANTERIOR"
  },
  {
    "codigo":129809002,
    "descripcion":"DIFERENCIA DE PROXIMIDAD ESPACIAL SEGÚN LA MAMOGRAFÍA"
  },
  {
    "codigo":293649007,
    "descripcion":"ALERGIA A ANTAGONISTA DE RECEPTOR DE HISTAMINA H2"
  },
  {
    "codigo":16475231000119102,
    "descripcion":"MEIBOMIANITIS BILATERAL DE PÁRPADO SUPERIOR"
  },
  {
    "codigo":95206001,
    "descripcion":"PERFORACIÓN DE LA TRÁQUEA"
  },
  {
    "codigo":422886007,
    "descripcion":"NEUROBLASTOMA OLFATORIO"
  },
  {
    "codigo":715963002,
    "descripcion":"ATRIQUIA CON LESIONES PAPULARES"
  },
  {
    "codigo":91231000119104,
    "descripcion":"ADENOCARCINOMA METASTÁSICO DE PIEL"
  },
  {
    "codigo":124304000,
    "descripcion":"DEFICIENCIA DE GLUCOSAMINA CINASA"
  },
  {
    "codigo":289979009,
    "descripcion":"CAPAZ DE USAR ARTÍCULOS DE TOCADOR"
  },
  {
    "codigo":714128003,
    "descripcion":"ENFERMEDAD GINGIVAL DEBIDA A DEFICIENCIA DE ÁCIDO ASCÓRBICO"
  },
  {
    "codigo":91536003,
    "descripcion":"INTOXICACIÓN POR SORGO BICOLOR"
  },
  {
    "codigo":11779321000119101,
    "descripcion":"AMPOLLA DE ANTEBRAZO DERECHO CON INFECCIÓN"
  },
  {
    "codigo":253541009,
    "descripcion":"DILATACIÓN DEL VENTRÍCULO CARDÍACO IZQUIERDO"
  },
  {
    "codigo":87866006,
    "descripcion":"TRISMO"
  },
  {
    "codigo":218938007,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR HIGO"
  },
  {
    "codigo":448314007,
    "descripcion":"NEOPLASIA EPITELIAL MALIGNA DE MÉDULA ESPINAL"
  },
  {
    "codigo":315407002,
    "descripcion":"NACIDO EN EL CONGO"
  },
  {
    "codigo":1167375003,
    "descripcion":"SÍNDROME DE MICROCEFALIA, HIPOPLASIA DE CUERPO CALLOSO Y DEL VÉRMIX CEREBELOSO, DISMORFIA FACIAL Y DISCAPACIDAD INTELECTUAL"
  },
  {
    "codigo":1003535003,
    "descripcion":"SOSPECHA DE GLAUCOMA BILATERAL POR CORTICOSTEROIDES"
  },
  {
    "codigo":310521000119105,
    "descripcion":"INFECCIÓN PIÓGENA DE DISCO INTERVERTEBRAL LUMBOSACRO"
  },
  {
    "codigo":248036002,
    "descripcion":"CONDUCTA PROBLEMÁTICA EN NIÑOS"
  },
  {
    "codigo":1296612002,
    "descripcion":"HIPERTENSIÓN OCULAR BILATERAL DEBIDA A SÍNDROME DE DISPERSIÓN PIGMENTARIA"
  },
  {
    "codigo":18660005,
    "descripcion":"PRODUCCIÓN DE LINFOCITOS DISMINUIDA"
  },
  {
    "codigo":410041002,
    "descripcion":"OCRONOSIS EXÓGENA"
  },
  {
    "codigo":768654000,
    "descripcion":"CARIES DE CORONA DENTAL NO ACTIVA EN ESTADIO EXTENSIVO"
  },
  {
    "codigo":735886000,
    "descripcion":"LUXACIÓN TRAUMÁTICA DE ARTICULACIÓN DEL TARSO"
  },
  {
    "codigo":211598007,
    "descripcion":"LESIÓN TRAUMÁTICA ABIERTA POR APLASTAMIENTO, PIERNA"
  },
  {
    "codigo":111459000,
    "descripcion":"INFECCIÓN DEL PEZÓN, ASOCIADA CON EL PARTO"
  },
  {
    "codigo":766819001,
    "descripcion":"ARQUEAMIENTO LATERAL SEVERO DE TIBIA CON BAJA ESTATURA"
  },
  {
    "codigo":78691002,
    "descripcion":"MARCHA TITUBEANTE"
  },
  {
    "codigo":275299008,
    "descripcion":"SÍNTOMA DE ERUCTO"
  },
  {
    "codigo":44088000,
    "descripcion":"SÍNDROME DE BAJO GASTO CARDÍACO"
  },
  {
    "codigo":109624002,
    "descripcion":"HIPERPLASIA DE LA PAPILA INTERDENTAL"
  },
  {
    "codigo":240696004,
    "descripcion":"TIÑA FACIAL"
  },
  {
    "codigo":2191000124104,
    "descripcion":"INCISIVO CENTRAL INFERIOR DERECHO DECIDUO SUPERNUMERARIO"
  },
  {
    "codigo":445071000124105,
    "descripcion":"NO RECIBE APOYO SOCIAL"
  },
  {
    "codigo":402701002,
    "descripcion":"DERMATOSIS DE LABIO"
  },
  {
    "codigo":238861002,
    "descripcion":"FIBROMATOSIS HIALINA JUVENIL"
  },
  {
    "codigo":271629002,
    "descripcion":"TRÁQUEA EN POSICIÓN CENTRAL"
  },
  {
    "codigo":207928009,
    "descripcion":"FRACTURA EXPUESTA DEL AXIS, TRICOLUMNAR"
  },
  {
    "codigo":399031001,
    "descripcion":"LACERACIÓN PERINEAL DE CUARTO GRADO"
  },
  {
    "codigo":38583007,
    "descripcion":"CATARATA TÓXICA"
  },
  {
    "codigo":300727008,
    "descripcion":"REALIZA ACTIVIDADES TELEFÓNICAS"
  },
  {
    "codigo":366263008,
    "descripcion":"HALLAZGO RELACIONADO CON POSICIÓN DE RIÑÓN"
  },
  {
    "codigo":298892002,
    "descripcion":"AMPLITUD DE EXTENSIÓN ACTIVA DE CODO NORMAL"
  },
  {
    "codigo":200588003,
    "descripcion":"ÁNTRAX DE BRAZO Y ANTEBRAZO"
  },
  {
    "codigo":724876003,
    "descripcion":"LESIÓN DE PIEL DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":2145000,
    "descripcion":"ACTO SEXUAL ANAL"
  },
  {
    "codigo":69516009,
    "descripcion":"ESTADO FUNCIONAL POSTERIOR AL PASO DEL CÁLCULO RENAL"
  },
  {
    "codigo":231521002,
    "descripcion":"OBSESIÓN RELATIVA AL PESO CORPORAL"
  },
  {
    "codigo":297057007,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE FÁRMACO ANTIHIPERTENSIVO"
  },
  {
    "codigo":295222003,
    "descripcion":"SOBREDOSIS DE AZAPROPAZONA"
  },
  {
    "codigo":196918005,
    "descripcion":"HERNIA GLÚTEA IRREDUCTIBLE"
  },
  {
    "codigo":721206006,
    "descripcion":"VÁRICE SOLITARIA DE ESÓFAGO"
  },
  {
    "codigo":229686008,
    "descripcion":"DISARTRIA MIXTA"
  },
  {
    "codigo":65846009,
    "descripcion":"INSUFICIENCIA OVÁRICA PRIMARIA"
  },
  {
    "codigo":459062008,
    "descripcion":"GLUCOGENOSIS CARDÍACA NO LISOSÓMICA CONGÉNITA FATAL"
  },
  {
    "codigo":310008,
    "descripcion":"FORÚNCULO DEL PENE"
  },
  {
    "codigo":195083004,
    "descripcion":"FIBRILACIÓN Y ALETEO VENTRICULAR"
  },
  {
    "codigo":33078009,
    "descripcion":"DEPRESIÓN MAYOR RECURRENTE GRAVE CON SÍNTOMAS PSICÓTICOS, CONGRUENTE CON EL ESTADO DE ÁNIMO"
  },
  {
    "codigo":162315007,
    "descripcion":"PENSAMIENTOS MÓRBIDOS"
  },
  {
    "codigo":193248005,
    "descripcion":"MIOPATÍA POR LUPUS ERITEMATOSO DISEMINADO"
  },
  {
    "codigo":93109000,
    "descripcion":"FALTA DE OSIFICACIÓN DEL METATARSO"
  },
  {
    "codigo":224181000,
    "descripcion":"SALARIO PAGADO MENSUALMENTE"
  },
  {
    "codigo":94944009,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE MÚSCULO DE LA REGIÓN INGUINAL"
  },
  {
    "codigo":420789003,
    "descripcion":"RETINOPATÍA DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":62176008,
    "descripcion":"ESOFORIA"
  },
  {
    "codigo":289717007,
    "descripcion":"CONTRACCIONES UTERINAS ÚTILES"
  },
  {
    "codigo":1010613009,
    "descripcion":"TETRASOMÍA 15Q"
  },
  {
    "codigo":1303690002,
    "descripcion":"QUISTE ÓSEO ANEURISMÁTICO DE MANO"
  },
  {
    "codigo":124042003,
    "descripcion":"NIVEL DE LÍPIDOS POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":25738004,
    "descripcion":"SINOVITIS TUBERCULOSA"
  },
  {
    "codigo":91274007,
    "descripcion":"FLUJO CARDÍACO NORMAL"
  },
  {
    "codigo":713866007,
    "descripcion":"SEPSIS PERINATAL CAUSADA POR ESCHERICHIA COLI"
  },
  {
    "codigo":255114007,
    "descripcion":"SARCOMA DE KAPOSI DE CONJUNTIVA"
  },
  {
    "codigo":417119002,
    "descripcion":"ALTA DEL SERVICIO DE EMERGENTOLOGÍA"
  },
  {
    "codigo":11837281000119104,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE MUSLO DERECHO"
  },
  {
    "codigo":253279000,
    "descripcion":"AUSENCIA DE COMUNICACIÓN AURICULOVENTRICULAR CON CABALGAMIENTO VALVULAR"
  },
  {
    "codigo":449887008,
    "descripcion":"CON DIETA SÓLIDA A LOS 4 MESES"
  },
  {
    "codigo":710196003,
    "descripcion":"NEOPLASIA MALIGNA ODONTÓGENA DE MAXILAR SUPERIOR"
  },
  {
    "codigo":40801000119106,
    "descripcion":"DIABETES MELLITUS GESTACIONAL QUE COMPLICA EL EMBARAZO"
  },
  {
    "codigo":342011000119100,
    "descripcion":"LUXACIÓN ANTERIOR DE CRISTALINO IZQUIERDO"
  },
  {
    "codigo":415284008,
    "descripcion":"SÍNDROME MIELODISPLÁSICO CON EXCESO DE BLASTOS-2"
  },
  {
    "codigo":251444009,
    "descripcion":"ARTIFICIO DEL ELECTROENCEFALOGRAMA - PROBLEMAS TÉCNICOS"
  },
  {
    "codigo":184073005,
    "descripcion":"PACIENTE REGISTRADO NUEVAMENTE"
  },
  {
    "codigo":85769006,
    "descripcion":"ENFERMEDAD INFECCIOSA ESTREPTOCÓCICA"
  },
  {
    "codigo":53001008,
    "descripcion":"INTOXICACIÓN POR ESTREPTODORNASA"
  },
  {
    "codigo":18398001,
    "descripcion":"EFECTOS DE LA ALTURA SOBRE LOS OÍDOS"
  },
  {
    "codigo":1263582003,
    "descripcion":"NEUROPATÍA IDIOPÁTICA DE HIPOGLOSO"
  },
  {
    "codigo":409779000,
    "descripcion":"INFECCIÓN AGUDA DE HUESO"
  },
  {
    "codigo":39121000119100,
    "descripcion":"MASA PÉLVICA EN EL EMBARAZO"
  },
  {
    "codigo":15731921000119100,
    "descripcion":"AGRANDAMIENTO DE GLÁNDULA LAGRIMAL IZQUIERDA"
  },
  {
    "codigo":1091281000119101,
    "descripcion":"TRASTORNO DE OÍDO DERECHO"
  },
  {
    "codigo":15744721000119103,
    "descripcion":"MASA DE ARTICULACIÓN DE MANO IZQUIERDA"
  },
  {
    "codigo":15703761000119104,
    "descripcion":"CONTRACTURA DE MÚSCULO DE AMBAS PIERNAS"
  },
  {
    "codigo":15673041000119101,
    "descripcion":"GLAUCOMA CONGÉNITO DE OJO DERECHO"
  },
  {
    "codigo":336081000119106,
    "descripcion":"DEGENERACIÓN DE COROIDES DE OJO DERECHO"
  },
  {
    "codigo":1073361000119107,
    "descripcion":"ARTRITIS DEL PIE IZQUIERDO CAUSADA POR BACTERIAS"
  },
  {
    "codigo":15667921000119108,
    "descripcion":"DEFORMIDAD CONGÉNITA DE CADERA IZQUIERDA"
  },
  {
    "codigo":11781841000119108,
    "descripcion":"LESIÓN TRAUMÁTICA DE VASO SANGUÍNEO DE MUSLO IZQUIERDO"
  },
  {
    "codigo":36561000119109,
    "descripcion":"RUPTURA DE CÁPSULA POSTERIOR DE CRISTALINO COMO COMPLICACIÓN INTRAOPERATORIA"
  },
  {
    "codigo":318161000119106,
    "descripcion":"PELLIZCAMIENTO POSTERIOR DE PARTES BLANDAS SOBRE LOS DIENTES"
  },
  {
    "codigo":11786961000119107,
    "descripcion":"LESIÓN TRAUMÁTICA DE REGIÓN DE CADERA DERECHA"
  },
  {
    "codigo":211336009,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE MIEMBRO INFERIOR, INFECTADA"
  },
  {
    "codigo":10750161000119106,
    "descripcion":"COLESTASIS GESTACIONAL EN LA MADRE QUE COMPLICA EL NACIMIENTO"
  },
  {
    "codigo":16917201000119106,
    "descripcion":"TRASTORNO DE AMBOS NERVIOS MOTORES OCULARES EXTERNOS"
  },
  {
    "codigo":333521000119107,
    "descripcion":"QUISTE DE ORA SERRATA DE RETINA DE OJO DERECHO"
  },
  {
    "codigo":15698641000119109,
    "descripcion":"ABSCESO DE VAINA TENDINOSA DE AMBAS PIERNAS"
  },
  {
    "codigo":16098001000119109,
    "descripcion":"ARTROFIBROSIS DE ARTICULACIÓN DE REGIÓN DE AMBOS HOMBROS"
  },
  {
    "codigo":276872009,
    "descripcion":"NEOPLASIA INTRAEPITELIAL VAGINAL, GRADO 2"
  },
  {
    "codigo":406109008,
    "descripcion":"VIRUS DE INMUNODEFICIENCIA HUMANA DETECTADO POR ENSAYO DE INMUNOADSORCIÓN LIGADO A ENZIMAS"
  },
  {
    "codigo":111197009,
    "descripcion":"LIQUEN MIXEDEMATOSO"
  },
  {
    "codigo":1354546001,
    "descripcion":"OCLUSIÓN DE VENA RETINIANA HEMISFÉRICA DE OJO IZQUIERDO"
  },
  {
    "codigo":109362006,
    "descripcion":"CELULITIS DEL ESPACIO PARAFARÍNGEO"
  },
  {
    "codigo":240434007,
    "descripcion":"TÉTANOS GENERALIZADO"
  },
  {
    "codigo":369671002,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA DE PLEURA Y CUERPO VERTEBRAL, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":1287175002,
    "descripcion":"TUMOR NEUROENDOCRINO BIEN DIFERENCIADO GRADO 2 DE PULMÓN"
  },
  {
    "codigo":41991004,
    "descripcion":"ANGIECTASIA DEL EMBARAZO"
  },
  {
    "codigo":402439006,
    "descripcion":"PENFIGOIDE BULLOSO DE LA INFANCIA"
  },
  {
    "codigo":203996001,
    "descripcion":"MIELOCISTOCELE CERVICAL"
  },
  {
    "codigo":40156002,
    "descripcion":"ESTADO POSTPARTO, 7 SEMANAS"
  },
  {
    "codigo":302300004,
    "descripcion":"OCLUSIÓN FEMOROPOPLÍTEA"
  },
  {
    "codigo":105692004,
    "descripcion":"ENFERMEDAD CAUSADA POR CARYOPHYLLAEIDAE"
  },
  {
    "codigo":1187036008,
    "descripcion":"VISCOSIDAD SANGUÍNEA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":300465000,
    "descripcion":"HALLAZGO RELACIONADO CON COMPETENCIA DE CUELLO DE VEJIGA URINARIA"
  },
  {
    "codigo":366001003,
    "descripcion":"CUMPLIMIENTO DE REGLAS Y LÍMITES - HALLAZGO"
  },
  {
    "codigo":298630006,
    "descripcion":"AMPLITUD DE FLEXIÓN LATERAL PASIVA HACIA LA DERECHA DE LA COLUMNA VERTEBRAL LUMBAR, NORMAL"
  },
  {
    "codigo":724614007,
    "descripcion":"TRASTORNO DEL SISTEMA MUSCULOESQUELÉTICO POSTERIOR A PROCEDIMIENTO"
  },
  {
    "codigo":69254008,
    "descripcion":"ESTOMATITIS POR PRÓTESIS DENTAL"
  },
  {
    "codigo":296795002,
    "descripcion":"SOBREDOSIS DE ISONIAZIDA"
  },
  {
    "codigo":16754991000119104,
    "descripcion":"SANGRADO UTERINO ANORMAL POR HIPERPLASIA ENDOMETRIAL ATÍPICA"
  },
  {
    "codigo":1148763004,
    "descripcion":"FIEBRE REUMÁTICA AGUDA CON CARDITIS"
  },
  {
    "codigo":67419006,
    "descripcion":"ENFERMEDAD NAVICULAR"
  },
  {
    "codigo":426032000,
    "descripcion":"MAL FUNCIONAMIENTO DE TUBO DE GASTROSTOMÍA"
  },
  {
    "codigo":1279835008,
    "descripcion":"SÍNDROME DE DISPLASIA ECTODÉRMICA Y SINDACTILIA CUTÁNEA"
  },
  {
    "codigo":16017711000119105,
    "descripcion":"ALTERACIÓN CRÓNICA DE ASTA ANTERIOR DE MENISCO EXTERNO DE AMBAS RODILLAS"
  },
  {
    "codigo":30981000,
    "descripcion":"EOSINOFILIA SECUNDARIA"
  },
  {
    "codigo":131120009,
    "descripcion":"TRASTORNO DE LA VITAMINA A"
  },
  {
    "codigo":1145093003,
    "descripcion":"PESTAÑAS CORTAS DE PÁRPADO INFERIOR"
  },
  {
    "codigo":15663561000119101,
    "descripcion":"RETINOPATÍA DE PURTSCHER DE AMBOS OJOS"
  },
  {
    "codigo":162053006,
    "descripcion":"DOLOR SUPRAPÚBICO"
  },
  {
    "codigo":194821006,
    "descripcion":"TROMBOSIS CORONARIA QUE NO DERIVA EN INFARTO DE MIOCARDIO"
  },
  {
    "codigo":293125008,
    "descripcion":"REACCIÓN ADVERSA A VACUNA ANTISARAMPIONOSA, ANTIPAROTIDÍTICA Y ANTIRRUBEÓLICA"
  },
  {
    "codigo":63749008,
    "descripcion":"RITMO AURICULAR POR ESTIMULACIÓN ARTIFICIAL"
  },
  {
    "codigo":94682004,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL ANILLO DE WALDEYER"
  },
  {
    "codigo":715439000,
    "descripcion":"LIPODISTROFIA PARCIAL TIPO 2 FAMILIAR"
  },
  {
    "codigo":387759001,
    "descripcion":"ENFERMEDAD GRANULOMATOSA CRÓNICA"
  },
  {
    "codigo":92847002,
    "descripcion":"FUSIÓN ANORMAL CONGÉNITA DEL CARTÍLAGO CENTRAL DE LA VÉRTEBRA DORSAL"
  },
  {
    "codigo":289455003,
    "descripcion":"HALLAZGO RELACIONADO CON LA ESCOTADURA SACROCIÁTICA"
  },
  {
    "codigo":125615005,
    "descripcion":"LUXACIÓN TRAUMÁTICA DE REGIÓN DE HOMBRO"
  },
  {
    "codigo":58244001,
    "descripcion":"ANOMALÍA DE DIVERGENCIA"
  },
  {
    "codigo":254852002,
    "descripcion":"CARCINOMA ENDOMETRIOIDE DE OVARIO"
  },
  {
    "codigo":25476006,
    "descripcion":"TIROIDITIS SUPURATIVA AGUDA"
  },
  {
    "codigo":91012008,
    "descripcion":"CONCUSIÓN REPETIDA"
  },
  {
    "codigo":449625000,
    "descripcion":"QUEMADURA EPIDÉRMICA EN MÚLTIPLES LOCALIZACIONES DE BRAZO"
  },
  {
    "codigo":56409008,
    "descripcion":"PARÁLISIS CEREBRAL MONOPLÉJICA"
  },
  {
    "codigo":1268825008,
    "descripcion":"ATAXIA CEREBELOSA CAUSADA POR SUSTANCIA QUÍMICA"
  },
  {
    "codigo":54574002,
    "descripcion":"MASTITIS POR PSEUDOMONAS AERUGINOSA"
  },
  {
    "codigo":447790002,
    "descripcion":"ARTIFICIO DEBIDO A APLASTAMIENTO"
  },
  {
    "codigo":1081801000119109,
    "descripcion":"SEMINOMA PRIMARIO DE TESTÍCULO DERECHO DESCENDIDO"
  },
  {
    "codigo":21806007,
    "descripcion":"ACIDURIA"
  },
  {
    "codigo":283950007,
    "descripcion":"QUEMADURA DEL PENE"
  },
  {
    "codigo":251182009,
    "descripcion":"COMPLEJOS VENTRICULARES PREMATUROS PAREADOS"
  },
  {
    "codigo":314883003,
    "descripcion":"DESGARRO COMPLETO DE LIGAMENTO DE LA MANO"
  },
  {
    "codigo":1363459003,
    "descripcion":"DIENTES SALUDABLES"
  },
  {
    "codigo":249347005,
    "descripcion":"PROBLEMAS AL SONARSE LA NARIZ"
  },
  {
    "codigo":183811008,
    "descripcion":"ESTADÍA DE INTERNACIÓN, 13 DÍAS"
  },
  {
    "codigo":739032003,
    "descripcion":"HIPERQUERATOSIS DE MUCOSA DE LA CAVIDAD BUCAL DEBIDA A LESIÓN TRAUMÁTICA Y POSTERIOR A ELLA"
  },
  {
    "codigo":18136007,
    "descripcion":"ESCALA DEL COMA DE GLASGOW, 7"
  },
  {
    "codigo":1163181000,
    "descripcion":"HERIDA POR GOLPE CORTANTE"
  },
  {
    "codigo":737197004,
    "descripcion":"ESTENOSIS CONGÉNITA DE INTESTINO GRUESO"
  },
  {
    "codigo":704429007,
    "descripcion":"BALANCE ÁCIDO-BASE ANORMAL"
  },
  {
    "codigo":1259650000,
    "descripcion":"CARCINOMA GRANULOCÍTICO RENAL PRIMARIO"
  },
  {
    "codigo":14466001,
    "descripcion":"LISTA DE INTERCAMBIO DE PAN"
  },
  {
    "codigo":80002007,
    "descripcion":"PRESENTACIÓN FETAL ANÓMALA"
  },
  {
    "codigo":276610007,
    "descripcion":"BAJO PESO AL NACER"
  },
  {
    "codigo":209239005,
    "descripcion":"FRACTURA-LUXACIÓN NO EXPUESTA DE ARTICULACIÓN ACROMIOCLAVICULAR"
  },
  {
    "codigo":373079005,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM AVIUM BRUNESE"
  },
  {
    "codigo":12631007,
    "descripcion":"DIETA RESTRINGIDA EN CALCIO"
  },
  {
    "codigo":698924000,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: TÁRTARO"
  },
  {
    "codigo":242007009,
    "descripcion":"LESIÓN INTESTINAL POR EXPLOSIÓN"
  },
  {
    "codigo":405847005,
    "descripcion":"FENOTIPO FY(A+B-)"
  },
  {
    "codigo":764460003,
    "descripcion":"DISPLASIA ESPONDILOEPIMETAFISARIA TIPO ANAUXÉTICA"
  },
  {
    "codigo":305708000,
    "descripcion":"VISTO POR UN ODONTÓLOGO PEDIÁTRICO"
  },
  {
    "codigo":404012007,
    "descripcion":"FIBROXANTOMA ATÍPICO, TIPO FUSOCELULAR"
  },
  {
    "codigo":240172008,
    "descripcion":"TRASTORNO EPIFISARIO"
  },
  {
    "codigo":829996009,
    "descripcion":"RIÑÓN DERECHO PALPABLE"
  },
  {
    "codigo":41729002,
    "descripcion":"RIÑÓN EN HERRADURA"
  },
  {
    "codigo":1155841005,
    "descripcion":"COLESTASIS INTRAHEPÁTICA FAMILIAR PROGRESIVA TIPO 2"
  },
  {
    "codigo":402177006,
    "descripcion":"PRURITO SOLAR"
  },
  {
    "codigo":105430000,
    "descripcion":"ADOPCIÓN"
  },
  {
    "codigo":7126001,
    "descripcion":"OSTEOARTROSIS LOCALIZADA SECUNDARIA DE SITIOS MÚLTIPLES"
  },
  {
    "codigo":1285078002,
    "descripcion":"CRISIS EPILÉPTICA EMOCIONAL DE INICIO FOCAL"
  },
  {
    "codigo":138198004,
    "descripcion":"NIÑO EN RIESGO"
  },
  {
    "codigo":236502006,
    "descripcion":"COMPROMISO RENAL EN ESCLERODERMIA"
  },
  {
    "codigo":302038007,
    "descripcion":"FRACTURA - LUXACIÓN EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA DE DEDO DEL PIE"
  },
  {
    "codigo":267435002,
    "descripcion":"HIPERQUILOMICRONEMIA FAMILIAR"
  },
  {
    "codigo":5291005,
    "descripcion":"HIPOCALCEMIA"
  },
  {
    "codigo":365739005,
    "descripcion":"NIVEL DE LITIO EN SANGRE - HALLAZGO"
  },
  {
    "codigo":300203007,
    "descripcion":"RESPONDE A LA VOZ DE LOS PADRES"
  },
  {
    "codigo":38059007,
    "descripcion":"HEMORROIDES EXTERNAS PROLAPSADAS"
  },
  {
    "codigo":3456001,
    "descripcion":"COREA PROGRESIVA CRÓNICA NO HEREDITARIA"
  },
  {
    "codigo":298368003,
    "descripcion":"TUMEFACCIÓN ÓSEA DE ARTICULACIÓN TEMPOROMANDIBULAR"
  },
  {
    "codigo":347031000119107,
    "descripcion":"ÚLCERA CENTRAL DE AMBAS CÓRNEAS"
  },
  {
    "codigo":67157003,
    "descripcion":"NEUROPATÍA DEL PLEXO BRAQUIAL MEDIO"
  },
  {
    "codigo":165461003,
    "descripcion":"VISCOSIDAD PLASMÁTICA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":296533005,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE FLUCITOSINA"
  },
  {
    "codigo":1179434000,
    "descripcion":"FRECUENTEMENTE COME SOLO"
  },
  {
    "codigo":722517009,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE VAINA NERVIOSA DE ESTRUCTURA DE SISTEMA NERVIOSO PERIFÉRICO"
  },
  {
    "codigo":294698009,
    "descripcion":"ALERGIA A LA FLUDROCORTISONA"
  },
  {
    "codigo":720682009,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR ROSUVASTATINA"
  },
  {
    "codigo":30719001,
    "descripcion":"ENTERITIS DIETÉTICA"
  },
  {
    "codigo":129023004,
    "descripcion":"INDEPENDENCIA PARA MANTENER LA CONTINENCIA"
  },
  {
    "codigo":718847005,
    "descripcion":"SÍNDROME NEURODEGENERATIVO LIGADO AL CROMOSOMA X TIPO HAMEL"
  },
  {
    "codigo":784383006,
    "descripcion":"TRASTORNO DEBIDO A LESIÓN TRAUMÁTICA DE NERVIO DE MIEMBRO SUPERIOR Y POSTERIOR A ELLA"
  },
  {
    "codigo":1144831005,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR TRICLOFÓS"
  },
  {
    "codigo":291028001,
    "descripcion":"INTOXICACIÓN POR FLUNITRAZEPAM"
  },
  {
    "codigo":127188002,
    "descripcion":"LINFADENOPATÍA DE LA EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":94420002,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE MÚSCULO DE LA CARA"
  },
  {
    "codigo":717012004,
    "descripcion":"ENFERMEDAD DE CHARCOT-MARIE-TOOTH TIPO 2E AUTOSÓMICA DOMINANTE"
  },
  {
    "codigo":225492004,
    "descripcion":"USA ROPA DE DÍA DURANTE LA NOCHE"
  },
  {
    "codigo":28884001,
    "descripcion":"TRASTORNO BIPOLAR I MODERADO, UN SOLO EPISODIO MANÍACO"
  },
  {
    "codigo":192724008,
    "descripcion":"ENCEFALITIS POSVACUNACIÓN MIXTA"
  },
  {
    "codigo":289193001,
    "descripcion":"HALLAZGO RELACIONADO CON LA INTELIGIBILIDAD DE LA ARTICULACIÓN"
  },
  {
    "codigo":190889003,
    "descripcion":"ALCALEMIA RESPIRATORIA"
  },
  {
    "codigo":92585006,
    "descripcion":"CARCINOMA IN SITU DEL ESÓFAGO"
  },
  {
    "codigo":254590000,
    "descripcion":"POLIPOSIS INFLAMATORIA DEL INTESTINO"
  },
  {
    "codigo":59817009,
    "descripcion":"HIPOTRICOSIS DESPUÉS DE ENFERMEDAD INFECCIOSA"
  },
  {
    "codigo":57982001,
    "descripcion":"DIFICULTAD PARA BAÑARSE Y\/O HIGIENIZARSE POR SÍ MISMO"
  },
  {
    "codigo":713342008,
    "descripcion":"INFECCIÓN CAUSADA POR SALMONELLA CONCOMITANTE CON INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":1335934009,
    "descripcion":"EMBARAZO EN CICATRIZ DE CESÁREA"
  },
  {
    "codigo":294091000119104,
    "descripcion":"CEFALEA CAUSADA POR FÁRMACO"
  },
  {
    "codigo":1268563005,
    "descripcion":"CARCINOMA DE CÉLULAS ACINARES DE PÁNCREAS PRIMARIO"
  },
  {
    "codigo":447528003,
    "descripcion":"RETORNO VENOSO PULMONAR OBSTRUIDO POR COMPRESIÓN EXTRÍNSECA EN EL DIAFRAGMA"
  },
  {
    "codigo":185384004,
    "descripcion":"SE LE SOLICITÓ QUE CONCURRIERA - EVALUACIÓN DEL PROGRESO"
  },
  {
    "codigo":283688006,
    "descripcion":"CRIPTOCOCOSIS ÓSEA"
  },
  {
    "codigo":249085003,
    "descripcion":"POSICIÓN MENTOPÚBICA"
  },
  {
    "codigo":609533004,
    "descripcion":"HIPERSENSIBILIDAD NO ALÉRGICA A PENTALMIDÓN"
  },
  {
    "codigo":312786001,
    "descripcion":"SUBLUXACIÓN VERTEBRAL CON LESIÓN MEDULAR A NIVEL CERVICAL"
  },
  {
    "codigo":738770003,
    "descripcion":"LINFOMA ANAPLÁSICO DE CÉLULAS GRANDES POSITIVO PARA CINASA DE LINFOMA ANAPLÁSICO"
  },
  {
    "codigo":1230290005,
    "descripcion":"SÍNDROME DE LIBERACIÓN DE CITOCINAS ASOCIADO A TERAPIA CELULAR CON CÉLULAS T CON EL RECEPTOR DE ANTÍGENO QUIMÉRICO"
  },
  {
    "codigo":103781000119103,
    "descripcion":"MICOSIS BRONCOPULMONAR ALÉRGICA"
  },
  {
    "codigo":704167003,
    "descripcion":"FRACTURA PATOLÓGICA DE CÚBITO"
  },
  {
    "codigo":79740000,
    "descripcion":"CANDIDIASIS DE LA BOCA"
  },
  {
    "codigo":1259388006,
    "descripcion":"CARCINOMA PRIMARIO DE PRÓSTATA"
  },
  {
    "codigo":405585001,
    "descripcion":"FÍSTULA AORTOENTÉRICA TRAUMÁTICA"
  },
  {
    "codigo":208977003,
    "descripcion":"LESIÓN DE VARIAS ESTRUCTURAS DE LA RODILLA"
  },
  {
    "codigo":733265007,
    "descripcion":"LESIONES TRAUMÁTICAS MÚLTIPLES DE MANO"
  },
  {
    "codigo":698662000,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: GALLEGO"
  },
  {
    "codigo":43302000,
    "descripcion":"SOBREDOSIS DE ANTICOAGULANTE"
  },
  {
    "codigo":403750002,
    "descripcion":"REACCIÓN CUTÁNEA ADVERSA CAUSADA POR MEDICAMENTO A BASE DE HIERBAS"
  },
  {
    "codigo":895270002,
    "descripcion":"FORMA ANCHA ANORMAL CONGÉNITA DE FALANGE PROXIMAL DE DEDO MEÑIQUE"
  },
  {
    "codigo":370982004,
    "descripcion":"REPETICIÓN DE GRADO"
  },
  {
    "codigo":239910001,
    "descripcion":"SÍNDROME DEL ACEITE TÓXICO"
  },
  {
    "codigo":305446006,
    "descripcion":"BAJO ATENCIÓN DE QUIROPRÁCTICO"
  },
  {
    "codigo":762363001,
    "descripcion":"LESIÓN TRAUMÁTICA DE CINTILLA ÓPTICA DERECHA"
  },
  {
    "codigo":400080004,
    "descripcion":"POROQUERATOSIS"
  },
  {
    "codigo":365477000,
    "descripcion":"HALLAZGO RELACIONADO CON DETALLES DE LOS PADRES"
  },
  {
    "codigo":201637001,
    "descripcion":"CONDROCALCINOSIS CAUSADA POR CRISTALES DE PIROFOSFATO"
  },
  {
    "codigo":299941002,
    "descripcion":"SENSACIÓN DE POSICIÓN ARTICULAR: PRESENTE"
  },
  {
    "codigo":5029005,
    "descripcion":"ACORTAMIENTO ADQUIRIDO DEL TENDÓN DE AQUILES"
  },
  {
    "codigo":234405009,
    "descripcion":"DEFICIENCIA DE TRIOSAFOSFATO ISOMERASA"
  },
  {
    "codigo":35962006,
    "descripcion":"NEVO COMEDÓNICO"
  },
  {
    "codigo":197967000,
    "descripcion":"PROSTATITIS GONOCÓCICA"
  },
  {
    "codigo":66895001,
    "descripcion":"DILATACIÓN CERVICAL, 6CM"
  },
  {
    "codigo":298106008,
    "descripcion":"CUERPO EXTRAÑO EN LA PIEL DEL TALÓN"
  },
  {
    "codigo":296271003,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE FLUPENTIXOL"
  },
  {
    "codigo":230735006,
    "descripcion":"ARTERITIS CEREBRAL SIFILÍTICA"
  },
  {
    "codigo":1344847009,
    "descripcion":"ACCESO VENOSO ALTERADO"
  },
  {
    "codigo":294436003,
    "descripcion":"ALERGIA A SURFACTANTE DE AMONIO CUATERNARIO"
  },
  {
    "codigo":15697561000119106,
    "descripcion":"ABSCESO DE ÓRBITA DE AMBOS OJOS"
  },
  {
    "codigo":352051000119101,
    "descripcion":"CARCINOMA DE CÉLULAS DE MERKEL PRIMARIO DE PIEL DE OREJA IZQUIERDA"
  },
  {
    "codigo":1144569008,
    "descripcion":"HIPOPLASIA CONGÉNITA DE MÚSCULO DORSAL ANCHO"
  },
  {
    "codigo":63225009,
    "descripcion":"OLOR CORPORAL DESAGRADABLE"
  },
  {
    "codigo":290766002,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR VINCRISTINA"
  },
  {
    "codigo":423673009,
    "descripcion":"MELANOMA MALIGNO DE LA RETINA"
  },
  {
    "codigo":1306574002,
    "descripcion":"CARCINOMA DUCTAL INFILTRANTE DE CUADRANTE INFERIOR EXTERNO DE MAMA IZQUIERDA"
  },
  {
    "codigo":94158005,
    "descripcion":"NEOPLASIA MALIGNA SECUNDARIA DE ADENOIDES"
  },
  {
    "codigo":126926005,
    "descripcion":"NEOPLASIA DE MAMA"
  },
  {
    "codigo":92323000,
    "descripcion":"NEOPLASIA BENIGNA DEL ÁREA RETROMOLAR"
  },
  {
    "codigo":119981000146107,
    "descripcion":"DISNEA CAUSADA POR SARS-COV-2"
  },
  {
    "codigo":288931005,
    "descripcion":"INCAPAZ DE ELIMINAR RESIDUOS DE LA BOCA"
  },
  {
    "codigo":714915006,
    "descripcion":"CAPACIDAD PARA PASAR DE UNA UBICACIÓN A OTRA, INDEPENDIENTE"
  },
  {
    "codigo":11820851000119106,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA INFERIOR DE ARTICULACIÓN ESCAPULOHUMERAL DERECHA"
  },
  {
    "codigo":1237368006,
    "descripcion":"LEUCEMIA MIELOIDE AGUDA CON BCR-ABL1"
  },
  {
    "codigo":186957004,
    "descripcion":"FIEBRE POR LEPTOSPIRA CANICOLA"
  },
  {
    "codigo":1268301006,
    "descripcion":"ENROJECIMIENTO DE PIEL DE CARA"
  },
  {
    "codigo":285261008,
    "descripcion":"PENSAMIENTOS PELIGROSOS Y DAÑINOS"
  },
  {
    "codigo":449101009,
    "descripcion":"SARCOMA DE ESTERNÓN"
  },
  {
    "codigo":283426003,
    "descripcion":"CORTE EN LA REGIÓN PÉLVICA"
  },
  {
    "codigo":709410003,
    "descripcion":"INFECCIÓN POR HAEMOPHILUS INFLUENZAE TIPO B"
  },
  {
    "codigo":840482005,
    "descripcion":"ANOMALÍA CONGÉNITA DE LÓBULO DE OREJA"
  },
  {
    "codigo":447266004,
    "descripcion":"SARCOMA DE ENDOMETRIO"
  },
  {
    "codigo":445431000,
    "descripcion":"SÍNDROME DE FRASIER"
  },
  {
    "codigo":86818009,
    "descripcion":"ANQUILOSIS CONGÉNITA DE CODO"
  },
  {
    "codigo":281591005,
    "descripcion":"TUMOR PARATESTICULAR"
  },
  {
    "codigo":707575007,
    "descripcion":"CARCINOMA PRIMARIO DE CÉLULAS ESCAMOSAS DE SUPRAGLOTIS"
  },
  {
    "codigo":1197260003,
    "descripcion":"CARCINOMA ENDOCRINO ESCASAMENTE DIFERENCIADO PRIMARIO DE CUERPO UTERINO"
  },
  {
    "codigo":246988003,
    "descripcion":"CÁMARA OCULAR ANTERIOR LOCALMENTE POCO PROFUNDA"
  },
  {
    "codigo":443596009,
    "descripcion":"DEPENDENCIA DE DIÁLISIS PERITONEAL"
  },
  {
    "codigo":212385001,
    "descripcion":"SÍNDROME COMPARTIMENTAL DE EXTREMIDAD INFERIOR DEBIDO A LESIÓN TRAUMÁTICA"
  },
  {
    "codigo":277921008,
    "descripcion":"ATELENCEFALIA"
  },
  {
    "codigo":1259126003,
    "descripcion":"ESCLEROSIS LATERAL AMIOTRÓFICA CON DISFUNCIÓN AUTONÓMICA"
  },
  {
    "codigo":210550008,
    "descripcion":"SECCIÓN PARCIAL DE TENDÓN FLEXOR DE LA MUÑECA"
  },
  {
    "codigo":700235002,
    "descripcion":"MOVILIDAD DENTAL EXCESIVA"
  },
  {
    "codigo":208715005,
    "descripcion":"FRACTURA EXPUESTA DE FALANGE PROXIMAL DE DEDO DEL PIE"
  },
  {
    "codigo":896843007,
    "descripcion":"FORMA TRIANGULAR ANORMAL CONGÉNITA DE EPÍFISIS DE FALANGE MEDIA DE DEDO DE MANO"
  },
  {
    "codigo":403488004,
    "descripcion":"LUPUS ERITEMATOSO SISTÉMICO DE LA INFANCIA"
  },
  {
    "codigo":205045003,
    "descripcion":"ESCOLIOSIS CONGÉNITA DEBIDA A MALFORMACIÓN ÓSEA"
  },
  {
    "codigo":237813007,
    "descripcion":"RETRASO CONSTITUCIONAL DE CRECIMIENTO Y PUBERTAD"
  },
  {
    "codigo":39370001,
    "descripcion":"RESTRICCIÓN DEL AFECTO"
  },
  {
    "codigo":1153482002,
    "descripcion":"ANDROSTENEDIONA SÉRICA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":301514002,
    "descripcion":"DIFICULTAD PARA ENTRAR EN LA DUCHA"
  },
  {
    "codigo":235978006,
    "descripcion":"FIBROSIS QUÍSTICA DEL PÁNCREAS"
  },
  {
    "codigo":430751001,
    "descripcion":"TRASTORNO FICTICIO CON PREDOMINIO DE SIGNOS Y SÍNTOMAS PSICOLÓGICOS"
  },
  {
    "codigo":234143003,
    "descripcion":"SÍNDROME DE PARKES WEBER"
  },
  {
    "codigo":365215004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA USAR UN ORINAL DE CAMA"
  },
  {
    "codigo":299679005,
    "descripcion":"CRECIMIENTO EXCESIVO DE VELLO EN PIERNA"
  },
  {
    "codigo":135839007,
    "descripcion":"ESPÉCIMEN RECHAZADO"
  },
  {
    "codigo":37535007,
    "descripcion":"ANOMALÍA DEL PAR DE CROMOSOMAS 12"
  },
  {
    "codigo":266911008,
    "descripcion":"GRUPO SOCIAL 3 - TRABAJADOR MANUAL CALIFICADO"
  },
  {
    "codigo":363380002,
    "descripcion":"NEOPLASIA MALIGNA DE GLÁNDULA SUBMAXILAR"
  },
  {
    "codigo":11823361000119106,
    "descripcion":"HERIDA INFECTADA DE BRAZO IZQUIERDO DEBIDA A PICADURA DE INSECTO NO VENENOSO"
  },
  {
    "codigo":232308006,
    "descripcion":"TRASTORNO AUTOINMUNITARIO DEL OÍDO INTERNO"
  },
  {
    "codigo":723828008,
    "descripcion":"BESTROFINOPATÍA AUTOSÓMICA RECESIVA"
  },
  {
    "codigo":263241008,
    "descripcion":"FRACTURA DE TILLAUX"
  },
  {
    "codigo":230473009,
    "descripcion":"CEFALEA EN SALVAS CRÓNICA"
  },
  {
    "codigo":164937009,
    "descripcion":"ONDA U ANORMAL EN EL ELECTROCARDIOGRAMA"
  },
  {
    "codigo":682241000119109,
    "descripcion":"ASTROCITOMA ANAPLÁSICO PRIMARIO DE LÓBULO OCCIPITAL"
  },
  {
    "codigo":64798005,
    "descripcion":"PULSO AMPLIO"
  },
  {
    "codigo":1177075005,
    "descripcion":"DACRIOADENITIS POR STAPHYLOCOCCUS AUREUS"
  },
  {
    "codigo":292339005,
    "descripcion":"REACCIÓN ADVERSA AL BUTOBARBITAL"
  },
  {
    "codigo":1144307009,
    "descripcion":"LEIOMIOSARCOMA DE LA CURVATURA MAYOR DEL ESTÓMAGO"
  },
  {
    "codigo":1306312007,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE ARÉOLA"
  },
  {
    "codigo":716488008,
    "descripcion":"DIFICULTAD PARA UTILIZAR APOYO RESPIRATORIO PARA LA VOZ"
  },
  {
    "codigo":126664009,
    "descripcion":"FARINGITIS EXUDATIVA"
  },
  {
    "codigo":92061008,
    "descripcion":"NEOPLASIA BENIGNA DE CLAVÍCULA"
  },
  {
    "codigo":11852341000119102,
    "descripcion":"AMPUTACIÓN PARCIAL TRAUMÁTICA DE DEDO GORDO DE PIE IZQUIERDO"
  },
  {
    "codigo":417906002,
    "descripcion":"REACCIÓN ADVERSA A LA HIDROCORTISONA"
  },
  {
    "codigo":286834005,
    "descripcion":"TIENDE A CULPAR A LOS DEMÁS"
  },
  {
    "codigo":254066006,
    "descripcion":"DISPLASIA DE WOLCOTT-RALLISON"
  },
  {
    "codigo":284999000,
    "descripcion":"INCAPAZ DE ABROCHAR LA ROPA"
  },
  {
    "codigo":416071001,
    "descripcion":"CATARATAS ASOCIADA CON RADIACIÓN INFRARROJA"
  },
  {
    "codigo":712818008,
    "descripcion":"HIPERPLASIA LOCALIZADA BENIGNA DE PRÓSTATA SIN OBSTRUCCIÓN AL FLUJO"
  },
  {
    "codigo":55623006,
    "descripcion":"ENCEFALITIS TÓXICA CAUSADA POR MERCURIO"
  },
  {
    "codigo":1004060001,
    "descripcion":"CONTRACTURA EN FLEXIÓN DE ARTICULACIÓN INTERFALÁNGICA PROXIMAL DE TERCER DEDO DE PIE"
  },
  {
    "codigo":250396003,
    "descripcion":"ANTÍGENO TIPO DIEGO"
  },
  {
    "codigo":447004005,
    "descripcion":"ENTERITIS CAUSADA POR HONGOS"
  },
  {
    "codigo":283164008,
    "descripcion":"CUERPO EXTRAÑO METÁLICO EN EL PULGAR"
  },
  {
    "codigo":281329003,
    "descripcion":"NO SE ESPECÍFICA EL NOMBRE DEL CONSULTOR"
  },
  {
    "codigo":1264369003,
    "descripcion":"ADENOCARCINOMA SEBÁCEO DE PÁRPADO METASTÁSICO"
  },
  {
    "codigo":248561009,
    "descripcion":"HEMITÓRAX DERECHO SE MUEVE MENOS QUE EL HEMITÓRAX IZQUIERDO"
  },
  {
    "codigo":1196998001,
    "descripcion":"NEOPLASIA MALIGNA DE CÉLULA EPITELIOIDE PERIVASCULAR"
  },
  {
    "codigo":212123004,
    "descripcion":"QUEMADURA QUE COMPROMETE MÁS DEL 90 POR CIENTO DE LA SUPERFICIE CORPORAL, CON 70 - 79 POR CIENTO DE SUPERFICIE CORPORAL CON QUEMADURA DE TERCER GRADO"
  },
  {
    "codigo":441499007,
    "descripcion":"FRACTURA POR SOBRECARGA DEL PUBIS"
  },
  {
    "codigo":243056003,
    "descripcion":"INTOXICACIÓN POR GAS PARA CONTROL DE MULTITUDES"
  },
  {
    "codigo":110149000,
    "descripcion":"HEMORRAGIA TRAUMÁTICA"
  },
  {
    "codigo":79216009,
    "descripcion":"ABSCESO INGUINAL"
  },
  {
    "codigo":372293001,
    "descripcion":"AUSENCIA DE INVASIÓN TUMORAL EN EL TEJIDO DE LA VESÍCULA SEMINAL (PRÓSTATA)"
  },
  {
    "codigo":13680009,
    "descripcion":"CELULITIS DEL ANTEBRAZO"
  },
  {
    "codigo":208453004,
    "descripcion":"FRACTURA NO EXPUESTA DE LA FALANGE MEDIA DE DEDO DE LA MANO, CUELLO"
  },
  {
    "codigo":403226000,
    "descripcion":"FOTOTIPO CUTÁNEO III (AL COMIENZO A VECES EXISTE QUEMADURA, LUEGO GENERALMENTE BRONCEADO)"
  },
  {
    "codigo":281801000009108,
    "descripcion":"PROSTATITIS CAUSADA POR BACTERIAS"
  },
  {
    "codigo":1255194004,
    "descripcion":"CARCINOMA PAPILAR PRIMARIO DE TIROIDES CON NEOPLASIA PAPILAR RENAL"
  },
  {
    "codigo":237551002,
    "descripcion":"HIPERTIROXINEMIA EUTIROIDEA"
  },
  {
    "codigo":303087003,
    "descripcion":"SÍNDROME DE RESECCIÓN TRANSURETRAL DE PRÓSTATA"
  },
  {
    "codigo":1220591004,
    "descripcion":"GASTRITIS COLAGENOSA PEDIÁTRICA"
  },
  {
    "codigo":1351663005,
    "descripcion":"URETRITIS CONCOMITANTE CON ARTRITIS REACTIVA"
  },
  {
    "codigo":301252002,
    "descripcion":"HALLAZGO RELACIONADO CON LA OBSTRUCCIÓN RESPIRATORIA"
  },
  {
    "codigo":268484008,
    "descripcion":"EXAMEN NEONATAL - NORMAL"
  },
  {
    "codigo":1251524009,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE PIERNA CON INFECCIÓN"
  },
  {
    "codigo":12209001000119107,
    "descripcion":"FRACTURA DE HUESO ADYACENTE A PRÓTESIS DE ARTICULACIÓN DE RODILLA DERECHA"
  },
  {
    "codigo":233881003,
    "descripcion":"PERICARDITIS INFECCIOSA AGUDA"
  },
  {
    "codigo":70041004,
    "descripcion":"ERITROQUERATODERMIA VARIABILIS"
  },
  {
    "codigo":364953005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA REDONDEAR LOS LABIOS"
  },
  {
    "codigo":299417006,
    "descripcion":"TUMEFACCIÓN SINOVIAL EN ARTICULACIÓN DE TOBILLO"
  },
  {
    "codigo":37273005,
    "descripcion":"RASGO DE PERSONALIDAD DEPRESIVA DE LARGA DATA"
  },
  {
    "codigo":461422000,
    "descripcion":"FÍSTULA ARTERIOVENOSA DE ARTERIA CORONARIA A VENA CAVA SUPERIOR"
  },
  {
    "codigo":232046008,
    "descripcion":"OCLUSIÓN DE RAMA VENOSA RETINIANA CON NEOVASCULARIZACIÓN"
  },
  {
    "codigo":295747000,
    "descripcion":"SOBREDOSIS DE PROCARBAZINA"
  },
  {
    "codigo":230211002,
    "descripcion":"MÚLTIPLES ABSCESOS PIOGÉNICOS INTRACRANEALES"
  },
  {
    "codigo":33603003,
    "descripcion":"COMPLICACIÓN DE LA DIÁLISIS RENAL"
  },
  {
    "codigo":262979003,
    "descripcion":"RUPTURA TRAUMÁTICA DE TENDÓN DEL MÚSCULO BÍCEPS"
  },
  {
    "codigo":66371007,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE BRAZO CON INFECCIÓN"
  },
  {
    "codigo":457752002,
    "descripcion":"RUPTURA DE MÚSCULO PAPILAR DE VÁLVULA AURICULOVENTRICULAR DERECHA (MORFOLÓGICAMENTE NO TRICÚSPIDE)"
  },
  {
    "codigo":293912004,
    "descripcion":"ALERGIA A CLORMETIAZOL"
  },
  {
    "codigo":304131000119106,
    "descripcion":"GOTA CRÓNICA DE MÚLTIPLES SITIOS, SIN TOFO, DEBIDA A DISFUNCIÓN RENAL"
  },
  {
    "codigo":31768006,
    "descripcion":"SIGNO DE LA MUÑECA"
  },
  {
    "codigo":64536008,
    "descripcion":"INTOXICACIÓN POR CROTON"
  },
  {
    "codigo":228376009,
    "descripcion":"INHALA DROGAS"
  },
  {
    "codigo":718061004,
    "descripcion":"PERIODONTITIS CRÓNICA GENERALIZADA SEVERA"
  },
  {
    "codigo":128237006,
    "descripcion":"ENFERMEDAD CRÓNICA DEL SISTEMA MUSCULOESQUELÉTICO"
  },
  {
    "codigo":95469008,
    "descripcion":"PLIEGUES PLANTARES IRREGULARES"
  },
  {
    "codigo":93634001,
    "descripcion":"FALTA DE OSIFICACIÓN DE HUESO EXOCCIPITAL"
  },
  {
    "codigo":880066000,
    "descripcion":"DEFICIENCIA DE ALFA-N-ACETIL GALACTOSAMINIDASA TIPO 3"
  },
  {
    "codigo":290242009,
    "descripcion":"INTOXICACIÓN POR FELBINACO"
  },
  {
    "codigo":124567008,
    "descripcion":"DEFICIENCIA DE DIPÉPTIDO HIDROLASA"
  },
  {
    "codigo":288407009,
    "descripcion":"INCAPAZ DE ENROSCAR UNA TAPA"
  },
  {
    "codigo":1236844002,
    "descripcion":"SÍNDROME DE MIOPATÍA DE INICIO TEMPRANO, ARREFLEXIA, DIFICULTAD RESPIRATORIA Y DISFAGIA"
  },
  {
    "codigo":253804002,
    "descripcion":"ANOMALÍAS BILIARES"
  },
  {
    "codigo":188268004,
    "descripcion":"NEOPLASIA MALIGNA DE TEJIDO CONJUNTIVO DE ÓRBITA"
  },
  {
    "codigo":57196006,
    "descripcion":"FRECUENCIA GENÉTICA"
  },
  {
    "codigo":88129004,
    "descripcion":"ENDOCARDITIS POR VIRUS COXSACKIE"
  },
  {
    "codigo":10900791000119102,
    "descripcion":"CONTUSIÓN DE TEJIDO ORBITARIO DE OJO IZQUIERDO"
  },
  {
    "codigo":448577008,
    "descripcion":"ATRESIA SUBVALVULAR DE AORTA MUSCULAR"
  },
  {
    "codigo":282902002,
    "descripcion":"INCAPAZ DE LEVANTARSE DESDE POSICIÓN DE CUCLILLAS"
  },
  {
    "codigo":86294001,
    "descripcion":"NEUMONITIS CAUSADA POR INHALACIÓN DE ESENCIA"
  },
  {
    "codigo":250134006,
    "descripcion":"SEPARACIÓN EN TENDÓN"
  },
  {
    "codigo":1264107005,
    "descripcion":"TRASTORNO NEONATAL CAUSADO POR DEPRESOR UTERINO POR LECHE MATERNA"
  },
  {
    "codigo":1296875009,
    "descripcion":"DETENCIÓN PARCIAL DE CRECIMIENTO EPIFISARIO DE FÉMUR DISTAL"
  },
  {
    "codigo":770752005,
    "descripcion":"ATENDIDO EN CONSULTORIO ESPECIALIZADO EN ASESORAMIENTO PRECONCEPCIONAL PARA DIABÉTICOS"
  },
  {
    "codigo":180928006,
    "descripcion":"HIPERPNEA"
  },
  {
    "codigo":12441000132105,
    "descripcion":"ENFERMEDAD CUTÁNEA OCUPACIONAL"
  },
  {
    "codigo":333111000119107,
    "descripcion":"GLAUCOMA PIGMENTARIO DEL OJO DERECHO"
  },
  {
    "codigo":1260437003,
    "descripcion":"SINOVITIS Y TENOSINOVITIS DE ARTICULACIÓN DE RODILLA"
  },
  {
    "codigo":15253005,
    "descripcion":"ASIMETRÍA DE LA CARA"
  },
  {
    "codigo":1293205007,
    "descripcion":"MASA DE ARTICULACIÓN DE REGIÓN DE MUÑECA DERECHA"
  },
  {
    "codigo":111722002,
    "descripcion":"CONTUSIÓN DE MAMA"
  },
  {
    "codigo":306641000119103,
    "descripcion":"GOTA DE CADERA CAUSADA POR FÁRMACO"
  },
  {
    "codigo":767082006,
    "descripcion":"PRIMER VASO LÍMPIDO"
  },
  {
    "codigo":15707601000119104,
    "descripcion":"DEGENERACIÓN CALCÁREA DE CÓRNEA DE OJO IZQUIERDO"
  },
  {
    "codigo":699711003,
    "descripcion":"PRÓTESIS DENTAL MANDIBULAR COMPLETA DEFECTUOSA"
  },
  {
    "codigo":16690641000119105,
    "descripcion":"HEMORRAGIA DE QUISTES BILATERALES DE CUERPOS LÚTEOS"
  },
  {
    "codigo":239124001,
    "descripcion":"NEVO DE PELO LANOSO"
  },
  {
    "codigo":1156628004,
    "descripcion":"PROCESAMIENTO GENÉTICO DE ÁCIDO RIBONUCLEICO POSTRANSCRIPCIONAL"
  },
  {
    "codigo":206356004,
    "descripcion":"CANDIDIASIS NEONATAL DEL PERINEO"
  },
  {
    "codigo":1254932006,
    "descripcion":"REACCIÓN CUTÁNEA POR CONTACTO CON SCYPHOZOA"
  },
  {
    "codigo":304660007,
    "descripcion":"CAPAZ DE EMPLEAR RAZONAMIENTO ARITMÉTICO"
  },
  {
    "codigo":9748009,
    "descripcion":"DISCINESIA"
  },
  {
    "codigo":204521002,
    "descripcion":"HENDIDURA NASAL CONGÉNITA"
  },
  {
    "codigo":270057002,
    "descripcion":"PACIENTE REGISTRADO - FP58"
  },
  {
    "codigo":7913001,
    "descripcion":"FRACTURA EXPUESTA DE HUESO PIRAMIDAL DEL CARPO"
  },
  {
    "codigo":827113007,
    "descripcion":"BORDE INFERIOR DEFINIDO DE TUMORACIÓN DE ABDOMEN"
  },
  {
    "codigo":366526000,
    "descripcion":"HALLAZGO RELACIONADO CON LA AMPLITUD DE LA EXTENSIÓN DE LA MUÑECA"
  },
  {
    "codigo":16526801000119108,
    "descripcion":"LACERACIÓN DE CEJA DERECHA"
  },
  {
    "codigo":399294002,
    "descripcion":"QUISTE DE MAMA"
  },
  {
    "codigo":169918002,
    "descripcion":"PUNTAJE DE APGAR A LOS 5 MINUTOS = 8"
  },
  {
    "codigo":300990005,
    "descripcion":"HALLADO MUERTO EN LA CAMA"
  },
  {
    "codigo":689771000119103,
    "descripcion":"CARCINOMA DE CÉLULAS DE TRANSICIÓN DE PARED ANTERIOR DE VEJIGA URINARIA"
  },
  {
    "codigo":397459003,
    "descripcion":"TUMOR QUE INVADE LA FASCIA ENDOTORÁCICA"
  },
  {
    "codigo":725139005,
    "descripcion":"SÍNDROME DE PARAPLEJÍA ESPÁSTICA, ATROFIA ÓPTICA Y NEUROPATÍA"
  },
  {
    "codigo":200851006,
    "descripcion":"DERMATITIS IRRITATIVA POR CONTACTO CAUSADA POR COSMÉTICOS"
  },
  {
    "codigo":233619008,
    "descripcion":"NEUMONÍA NEONATAL"
  },
  {
    "codigo":723304001,
    "descripcion":"SÍNDROME DE MICROCEFALIA, CONVULSIONES, DISCAPACIDAD INTELECTUAL Y ENFERMEDAD CARDÍACA"
  },
  {
    "codigo":299155009,
    "descripcion":"SIN AMPLITUD ACTIVA DE EXTENSIÓN DE PULGAR"
  },
  {
    "codigo":42001000087106,
    "descripcion":"CELULITIS DE TODOS LOS DEDOS DE PIE IZQUIERDO"
  },
  {
    "codigo":39441000087107,
    "descripcion":"DOLOR NEUROPÁTICO CRÓNICO POSTERIOR A LESIÓN CEREBRAL"
  },
  {
    "codigo":67944007,
    "descripcion":"ENFERMEDAD DE LHERMITTE - DUCLOS"
  },
  {
    "codigo":262717000,
    "descripcion":"LESIÓN DE ARTERIA VERTEBRAL"
  },
  {
    "codigo":264552009,
    "descripcion":"DÉFICIT NEUROLÓGICO"
  },
  {
    "codigo":721469004,
    "descripcion":"SÍNDROME DEL CORDÓN POSTERIOR DE MÉDULA ESPINAL AL NIVEL DEL PRIMER SEGMENTO DORSAL"
  },
  {
    "codigo":424722001,
    "descripcion":"ELIMINACIÓN DE ALIMENTOS INADECUADA"
  },
  {
    "codigo":31506005,
    "descripcion":"ACTIVIDAD DE GLÁNDULA SEBÁCEA AUMENTADA"
  },
  {
    "codigo":293650007,
    "descripcion":"ALERGIA A CIMETIDINA"
  },
  {
    "codigo":129810007,
    "descripcion":"DIFERENCIA EN LA CANTIDAD DE CALCIFICACIONES SEGÚN LA MAMOGRAFÍA"
  },
  {
    "codigo":717799003,
    "descripcion":"SÍNDROME DE DEHISCENCIA DE CONDUCTO SEMICIRCULAR SUPERIOR"
  },
  {
    "codigo":95207005,
    "descripcion":"PTERIGIÓN PERIFÉRICO"
  },
  {
    "codigo":291815007,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR GLIBENCLAMIDA"
  },
  {
    "codigo":7941000119105,
    "descripcion":"HERNIA PERINEAL FEMENINA"
  },
  {
    "codigo":191676002,
    "descripcion":"PSICOSIS DEPRESIVA REACTIVA"
  },
  {
    "codigo":93372003,
    "descripcion":"DESALINEACIÓN CONGÉNITA DE ARCO DE VÉRTEBRA CERVICAL"
  },
  {
    "codigo":1110131000000100,
    "descripcion":"HIPERTENSIÓN OCULAR SECUNDARIA DEBIDA A NEOVASCULARIZACIÓN"
  },
  {
    "codigo":27836007,
    "descripcion":"TOS FERINA"
  },
  {
    "codigo":289980007,
    "descripcion":"INCAPAZ DE USAR ARTÍCULOS DE TOCADOR"
  },
  {
    "codigo":224444007,
    "descripcion":"ÁREA DE DESCANSO ADECUADA EN EL TRABAJO"
  },
  {
    "codigo":124305004,
    "descripcion":"DEFICIENCIA DE FOSFOGLUCOCINASA"
  },
  {
    "codigo":253542002,
    "descripcion":"BANDA MUSCULAR ANORMAL DEL VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":286310005,
    "descripcion":"CAPAZ DE UTILIZAR CONSONANTES INDIVIDUALES"
  },
  {
    "codigo":384614008,
    "descripcion":"MARGEN QUIRÚRGICO PROXIMAL NO AFECTADO POR NEOPLASIA MALIGNA"
  },
  {
    "codigo":251707005,
    "descripcion":"SACO LAGRIMAL, INGRESADO"
  },
  {
    "codigo":448315008,
    "descripcion":"NEOPLASIA EPITELIAL MALIGNA DE ANO"
  },
  {
    "codigo":284475009,
    "descripcion":"MANTIENE EL CONTROL DE SÍ MISMO"
  },
  {
    "codigo":282640002,
    "descripcion":"CAPAZ DE AGACHARSE"
  },
  {
    "codigo":315408007,
    "descripcion":"NACIDO EN COSTA RICA"
  },
  {
    "codigo":444645005,
    "descripcion":"ENFERMEDAD DE DENT"
  },
  {
    "codigo":248037006,
    "descripcion":"PROBLEMA DE DISCIPLINA"
  },
  {
    "codigo":1296613007,
    "descripcion":"HIPERTENSIÓN OCULAR DE OJO IZQUIERDO DEBIDA A TRAUMATISMO OCULAR"
  },
  {
    "codigo":18661009,
    "descripcion":"DISERITROPOYESIS"
  },
  {
    "codigo":82362006,
    "descripcion":"DESTRUCCIÓN ANORMAL DE GRANULOCITOS"
  },
  {
    "codigo":410042009,
    "descripcion":"OCRONOSIS POR DEFICIENCIA DE HOMOGENTISATO 1,2-DIOXIGENASA"
  },
  {
    "codigo":703119002,
    "descripcion":"CARDITIS DEBIDA A FIEBRE REUMÁTICA"
  },
  {
    "codigo":211599004,
    "descripcion":"LESIÓN TRAUMÁTICA ABIERTA POR APLASTAMIENTO, RODILLA"
  },
  {
    "codigo":80527006,
    "descripcion":"VESÍCULA BILIAR NO FUNCIONANTE"
  },
  {
    "codigo":275300000,
    "descripcion":"SÍNTOMA DE ESCURRIMIENTO FECAL"
  },
  {
    "codigo":735887009,
    "descripcion":"LUXACIÓN TRAUMÁTICA DE ARTICULACIÓN TARSOMETATARSIANA"
  },
  {
    "codigo":373604002,
    "descripcion":"ENFERMEDAD POR DEPÓSITO DE CADENAS LIVIANAS"
  },
  {
    "codigo":45924006,
    "descripcion":"NECROFILIA"
  },
  {
    "codigo":766820007,
    "descripcion":"DISPLASIA ESPONDILOEPIMETAFISARIA CON LUXACIONES MÚLTIPLES"
  },
  {
    "codigo":109625001,
    "descripcion":"CRÁTER PAPILAR GINGIVAL"
  },
  {
    "codigo":207929001,
    "descripcion":"FRACTURA EXPUESTA DE VÉRTEBRA CERVICAL, ESTALLIDO"
  },
  {
    "codigo":699449003,
    "descripcion":"PATRÓN DE USO NOCIVO DE METANFETAMINA"
  },
  {
    "codigo":371769008,
    "descripcion":"CHOQUE ENDOTÓXICO"
  },
  {
    "codigo":75022004,
    "descripcion":"DIABETES MELLITUS GESTACIONAL CLASE A1"
  },
  {
    "codigo":271630007,
    "descripcion":"TRÁQUEA DESPLAZADA HACIA LA IZQUIERDA"
  },
  {
    "codigo":402702009,
    "descripcion":"DERMATOSIS INFECCIOSA DE LABIO"
  },
  {
    "codigo":105955002,
    "descripcion":"DIETA DE SODIO, POTASIO Y\/O CALCIO"
  },
  {
    "codigo":238862009,
    "descripcion":"FIBROMA APONEURÓTICO JUVENIL"
  },
  {
    "codigo":1285603008,
    "descripcion":"HEMATOMA DE ANTEBRAZO"
  },
  {
    "codigo":366264002,
    "descripcion":"REFLEJO EN OJOS DE MUÑECA HORIZONTAL - HALLAZGO"
  },
  {
    "codigo":300728003,
    "descripcion":"NO REALIZA ACTIVIDADES TELEFÓNICAS"
  },
  {
    "codigo":361000124100,
    "descripcion":"ERROR EN PRESCRIPCIÓN PARA DIÁLISIS PERITONEAL"
  },
  {
    "codigo":450921000124103,
    "descripcion":"DEGENERACIÓN DE CÓRNEA DE OJO DERECHO"
  },
  {
    "codigo":202424007,
    "descripcion":"TUMOR TENOSINOVIAL DE CÉLULAS GIGANTES DIFUSO DE ARTICULACIÓN DE HOMBRO"
  },
  {
    "codigo":15958381000119101,
    "descripcion":"CARCINOMA ESCAMOCELULAR METASTÁSICO DE RIÑÓN IZQUIERDO"
  },
  {
    "codigo":266125005,
    "descripcion":"SÍFILIS CONGÉNITA TEMPRANA CON SÍNTOMAS"
  },
  {
    "codigo":200589006,
    "descripcion":"ÁNTRAX DE CODO"
  },
  {
    "codigo":724877007,
    "descripcion":"ERUPCIÓN CUTÁNEA LOCALIZADA"
  },
  {
    "codigo":298893007,
    "descripcion":"AMPLITUD DE EXTENSIÓN ACTIVA DE CODO AUMENTADA"
  },
  {
    "codigo":36749009,
    "descripcion":"INFECCIÓN CAUSADA POR TAENIA OVIS"
  },
  {
    "codigo":67682002,
    "descripcion":"ATEROMA DE ARTERIA CORONARIA"
  },
  {
    "codigo":297058002,
    "descripcion":"SOBREDOSIS INTENCIONAL DE FÁRMACO ANTIHIPERTENSIVO"
  },
  {
    "codigo":231522009,
    "descripcion":"ANOREXIA NERVIOSA ATÍPICA"
  },
  {
    "codigo":721207002,
    "descripcion":"SÍNDROME DE CONVULSIONES, SORDERA NEUROSENSORIAL, ATAXIA, DISCAPACIDAD INTELECTUAL Y DESEQUILIBRIO ELECTROLÍTICO"
  },
  {
    "codigo":12108141000119104,
    "descripcion":"QUEMADURA QUÍMICA DE LA BOCA"
  },
  {
    "codigo":229687004,
    "descripcion":"DISARTRIA CEREBELOSA"
  },
  {
    "codigo":459063003,
    "descripcion":"TRASTORNO CONGÉNITO DE LA GLUCOSILACIÓN TIPO IA"
  },
  {
    "codigo":295223008,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE AZAPROPAZONA"
  },
  {
    "codigo":1145356002,
    "descripcion":"LESIÓN HIPERINTENSA DE GANGLIO BASAL EN IMAGEN DE RESONANCIA MAGNÉTICA EN T2"
  },
  {
    "codigo":193249002,
    "descripcion":"MIOPATÍA POR POLIARTERITIS NUDOSA"
  },
  {
    "codigo":16833031000119101,
    "descripcion":"NEVO MELANOCÍTICO DE PIEL DE MENTÓN"
  },
  {
    "codigo":94945005,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE MÚSCULO DE LA EXTREMIDAD INFERIOR"
  },
  {
    "codigo":291553008,
    "descripcion":"INTOXICACIÓN POR PIPERACILINA"
  },
  {
    "codigo":60342002,
    "descripcion":"TRASTORNO DE LA MOVILIDAD"
  },
  {
    "codigo":289718002,
    "descripcion":"CONTRACCIONES UTERINAS BUENAS"
  },
  {
    "codigo":1010614003,
    "descripcion":"TETRASOMÍA 5P MOSAICO"
  },
  {
    "codigo":93110005,
    "descripcion":"FALTA DE OSIFICACIÓN DE HUESO NASAL"
  },
  {
    "codigo":285191000119103,
    "descripcion":"ESTENOSIS DE ARTERIA CARÓTIDA IZQUIERDA"
  },
  {
    "codigo":27574007,
    "descripcion":"FERTILIZACIÓN EN VIVO"
  },
  {
    "codigo":224182007,
    "descripcion":"SALARIO PAGADO TRIMESTRALMENTE"
  },
  {
    "codigo":1303691003,
    "descripcion":"QUISTE ÓSEO ANEURISMÁTICO DE RADIO"
  },
  {
    "codigo":25739007,
    "descripcion":"HIPERHIDROXIPROLINEMIA"
  },
  {
    "codigo":255115008,
    "descripcion":"SARCOMA DE KAPOSI DE CÓRNEA"
  },
  {
    "codigo":418955009,
    "descripcion":"TRASTORNO DEL SUEÑO DE CAUSA ORGÁNICA"
  },
  {
    "codigo":124043008,
    "descripcion":"NIVEL DE LÍPIDOS POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":449888003,
    "descripcion":"FUNCIÓN COGNITIVA NORMAL"
  },
  {
    "codigo":253280002,
    "descripcion":"COMUNICACIÓN AURICULOVENTRICULAR ANORMAL-UNIVENTRICULAR"
  },
  {
    "codigo":286048006,
    "descripcion":"CAPAZ DE LAVAR LA ROPA SUCIA"
  },
  {
    "codigo":87605005,
    "descripcion":"EMBARAZO CORNUAL"
  },
  {
    "codigo":54837006,
    "descripcion":"SÍNDROME DE LA ESPALDA RECTA"
  },
  {
    "codigo":249610002,
    "descripcion":"HALLAZGO RELACIONADO CON LA SUPERFICIE PROSTÁTICA"
  },
  {
    "codigo":11835911000119109,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN METATARSOFALÁNGICA DE DEDO GORDO IZQUIERDO"
  },
  {
    "codigo":444383001,
    "descripcion":"DISPUESTO A SER DONANTE DE INTESTINO DELGADO"
  },
  {
    "codigo":247775003,
    "descripcion":"SENSACIÓN DE ENLENTECIMIENTO"
  },
  {
    "codigo":15741601000119104,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE AMBAS MANOS"
  },
  {
    "codigo":1263583008,
    "descripcion":"HIDROCEFALIA DEBIDA A MALFORMACIÓN DE ARNOLD CHIARI"
  },
  {
    "codigo":870367008,
    "descripcion":"REACCIÓN ADVERSA A ALCALOIDE DE CINCHONA"
  },
  {
    "codigo":409780002,
    "descripcion":"OSTEOMIELITIS AGUDA"
  },
  {
    "codigo":442548000,
    "descripcion":"FUNCIÓN DE VEJIGA URINARIA ALTERADA"
  },
  {
    "codigo":213172001,
    "descripcion":"FALLA PARCIAL DE REIMPLANTE DE LOS DEDOS DE LA MANO"
  },
  {
    "codigo":311476004,
    "descripcion":"PRUEBA DE MEMORIA DE DÍGITOS HACIA ATRÁS"
  },
  {
    "codigo":1163444007,
    "descripcion":"HIPERSENSIBILIDAD AL MACROGOL"
  },
  {
    "codigo":211337000,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE CADERA"
  },
  {
    "codigo":735625001,
    "descripcion":"ANORGASMIA ADQUIRIDA GENERALIZADA"
  },
  {
    "codigo":278708009,
    "descripcion":"GRUPO DE ESPONDILODISPLASIAS"
  },
  {
    "codigo":276873004,
    "descripcion":"NEOPLASIA INTRAEPITELIAL VULVAR, GRADO 1"
  },
  {
    "codigo":78430008,
    "descripcion":"FARINGITIS POR ADENOVIRUS"
  },
  {
    "codigo":109363001,
    "descripcion":"NEUMOTÓRAX DERECHO"
  },
  {
    "codigo":16469931000119100,
    "descripcion":"FATIGA DEBIDA A ACCIDENTE CEREBROVASCULAR ISQUÉMICO Y POSTERIOR A ÉL"
  },
  {
    "codigo":16841131000119100,
    "descripcion":"GRANULOMA CALCIFICADO DE PULMÓN"
  },
  {
    "codigo":16661931000119102,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DEBIDO A ESTENOSIS BILATERAL DE ARTERIAS VERTEBRALES"
  },
  {
    "codigo":1079211000119103,
    "descripcion":"NEOPLASIA BENIGNA DE HUESO DE MIEMBRO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":306091000119102,
    "descripcion":"TRASTORNO DE LIGAMENTO DE ARTICULACIÓN DE LA CADERA DERECHA"
  },
  {
    "codigo":240435008,
    "descripcion":"GANGRENA GASEOSA DE LA PIEL"
  },
  {
    "codigo":142251000119102,
    "descripcion":"INCONTINENCIA FECAL CON URGENCIA FECAL"
  },
  {
    "codigo":19371000119107,
    "descripcion":"CIFOSIS DEGENERATIVA"
  },
  {
    "codigo":501661611000119107,
    "descripcion":"HERPES SIMPLE GENITAL LATENTE DURANTE EMBARAZO"
  },
  {
    "codigo":288171000119109,
    "descripcion":"NIÑO EN CUSTODIA DE SERVICIO SOCIAL"
  },
  {
    "codigo":134571000119103,
    "descripcion":"RUPTURA FAMILIAR DEBIDA A AUSENCIA PROLONGADA DE MIEMBRO DE LA FAMILIA"
  },
  {
    "codigo":964827051000119104,
    "descripcion":"TRASTORNO DE PIGMENTACIÓN SEGMENTARIA"
  },
  {
    "codigo":367531000119106,
    "descripcion":"GLOMERULONEFRITIS PROLIFERATIVA ENDOCAPILAR DIFUSA HEREDITARIA"
  },
  {
    "codigo":311211000119105,
    "descripcion":"RADICULOPATÍA DEBIDA A TRASTORNO DE DISCO INTERVERTEBRAL LUMBAR"
  },
  {
    "codigo":830259009,
    "descripcion":"ALERGIA A FLUOROQUINOLONA"
  },
  {
    "codigo":293291000119108,
    "descripcion":"PLAGIOCEFALIA POSTURAL ADQUIRIDA"
  },
  {
    "codigo":41992006,
    "descripcion":"ACIDEZ GÁSTRICA ANORMAL"
  },
  {
    "codigo":302301000,
    "descripcion":"PROBLEMA DE VEJIGA URINARIA"
  },
  {
    "codigo":1187037004,
    "descripcion":"RELACIÓN CARDIOTORÁCICA FETAL ANORMAL"
  },
  {
    "codigo":203997005,
    "descripcion":"MIELOCISTOCELE DORSAL"
  },
  {
    "codigo":72925005,
    "descripcion":"ENFERMEDAD QUÍSTICA CONGÉNITA DEL HÍGADO"
  },
  {
    "codigo":202162000,
    "descripcion":"ARTROFITO EN ARTICULACIÓN DE TOBILLO"
  },
  {
    "codigo":369672009,
    "descripcion":"MARGEN DIAFRAGMÁTICO DE RESECCIÓN QUIRÚRGICA DE PLEURA, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":300466004,
    "descripcion":"HALLAZGO RELACIONADO CON MEDICIONES VESICALES"
  },
  {
    "codigo":366002005,
    "descripcion":"VULNERABILIDAD A LA EXPLOTACIÓN - HALLAZGO"
  },
  {
    "codigo":298631005,
    "descripcion":"AMPLITUD DE FLEXIÓN LATERAL PASIVA HACIA LA DERECHA DE LA COLUMNA VERTEBRAL LUMBAR, AUMENTADA"
  },
  {
    "codigo":427868000,
    "descripcion":"SIN CAMBIOS EN EL ESTADO DEL PACIENTE"
  },
  {
    "codigo":724615008,
    "descripcion":"SILLA TURCA CON FORMA DE J CONGÉNITA"
  },
  {
    "codigo":296796001,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE ISONIAZIDA"
  },
  {
    "codigo":34652008,
    "descripcion":"XENOFOBIA"
  },
  {
    "codigo":1279836009,
    "descripcion":"SÍNDROME DE BOCIO MULTINODULAR FAMILIAR"
  },
  {
    "codigo":294961005,
    "descripcion":"ALERGIA A COLESTIPOL"
  },
  {
    "codigo":426033005,
    "descripcion":"DISFAGIA COMO EFECTO TARDÍO DE ACCIDENTE CEREBROVASCULAR"
  },
  {
    "codigo":97391000119102,
    "descripcion":"PARAPLEJÍA CON VEJIGA URINARIA NEUROGÉNICA"
  },
  {
    "codigo":131121008,
    "descripcion":"NIVEL DE VITAMINA K1 POR DEBAJO DE RANGO DE REFERENCIA"
  },
  {
    "codigo":30982007,
    "descripcion":"FIEBRE HEMORRÁGICA SUDAMERICANA"
  },
  {
    "codigo":63750008,
    "descripcion":"PRESENTACIÓN OBLICUA"
  },
  {
    "codigo":293126009,
    "descripcion":"REACCIÓN ADVERSA A VACUNA CONTRA HEPATITIS A"
  },
  {
    "codigo":1145094009,
    "descripcion":"PESTAÑAS CORTAS DE PÁRPADO SUPERIOR"
  },
  {
    "codigo":29147005,
    "descripcion":"CANDIDIASIS MUCOCUTÁNEA"
  },
  {
    "codigo":94683009,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE HUESO CIGOMÁTICO"
  },
  {
    "codigo":27312002,
    "descripcion":"DEFICIENCIA DE QUININÓGENO DE ALTO PESO MOLECULAR"
  },
  {
    "codigo":715440003,
    "descripcion":"MANOS Y PIES EN ESPEJO CON DEFECTO NASAL CONCOMITANTE"
  },
  {
    "codigo":289456002,
    "descripcion":"ESCOTADURA SACROCIÁTICA AMPLIA"
  },
  {
    "codigo":291291009,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR PILOCARPINA"
  },
  {
    "codigo":1080431000119107,
    "descripcion":"PAPILOMA INTRADUCTAL DE MAMA IZQUIERDA"
  },
  {
    "codigo":189317005,
    "descripcion":"CARCINOMA IN SITU DE PIEL DE PIERNA"
  },
  {
    "codigo":11785481000119102,
    "descripcion":"ABRASIÓN DE PIEL DE DEDO MEDIO DERECHO"
  },
  {
    "codigo":449626004,
    "descripcion":"LESIÓN TRAUMÁTICA DE VASO SANGUÍNEO DE BRAZO"
  },
  {
    "codigo":253018005,
    "descripcion":"CARCINOMA HEPATOCELULAR FIBROLAMINAR"
  },
  {
    "codigo":87343002,
    "descripcion":"ANGINA DE PRINZMETAL"
  },
  {
    "codigo":447791003,
    "descripcion":"ADENOMA DE COLON SIGMOIDE"
  },
  {
    "codigo":251183004,
    "descripcion":"COMPLEJO DE CONDUCCIÓN ABERRANTE"
  },
  {
    "codigo":283951006,
    "descripcion":"RUPTURA DEL PENE"
  },
  {
    "codigo":249348000,
    "descripcion":"INCAPAZ DE SOPLARSE LA NARIZ"
  },
  {
    "codigo":183812001,
    "descripcion":"ESTADÍA DE INTERNACIÓN, 14 DÍAS"
  },
  {
    "codigo":10966281000119106,
    "descripcion":"HERIDA PUNZANTE DE MUSLO IZQUIERDO"
  },
  {
    "codigo":216580007,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR TIOBARBITÚRICO"
  },
  {
    "codigo":247513000,
    "descripcion":"PARCHE SALMÓN DE UÑA"
  },
  {
    "codigo":19972008,
    "descripcion":"PARKINSONISMO POSTENCEFÁLICO"
  },
  {
    "codigo":15635721000119108,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE AMBOS OVARIOS"
  },
  {
    "codigo":737198009,
    "descripcion":"TRASTORNO DE LA MOTILIDAD DEL INTESTINO GRUESO"
  },
  {
    "codigo":80003002,
    "descripcion":"NEUMONÍA TUBERCULOSA"
  },
  {
    "codigo":81838009,
    "descripcion":"ESTIMULACIÓN MECÁNICA DEL CLÍTORIS"
  },
  {
    "codigo":276611006,
    "descripcion":"RECIÉN NACIDO DE MUY BAJO PESO AL NACER"
  },
  {
    "codigo":274776000,
    "descripcion":"HALLAZGO RELACIONADO CON LA PRESENCIA DE ALCOHOL EN SANGRE"
  },
  {
    "codigo":405848000,
    "descripcion":"FENOTIPO FY(A-B+)"
  },
  {
    "codigo":829997000,
    "descripcion":"BORDE HEPÁTICO PALPABLE POR DEBAJO DEL REBORDE COSTAL DERECHO"
  },
  {
    "codigo":733528009,
    "descripcion":"CAMBIO MORFOLÓGICO EN ENDOMETRIO DEBIDO A DISPOSITIVO ANTICONCEPTIVO INTRAUTERINO"
  },
  {
    "codigo":404013002,
    "descripcion":"FIBROHISTIOCITOMA ANGIOMATOIDE DE LA PIEL"
  },
  {
    "codigo":373080008,
    "descripcion":"NEOPLASIA MALIGNA DE CUADRANTE INFEROINTERNO DE MAMA"
  },
  {
    "codigo":764461004,
    "descripcion":"SÍNDROME DE TRISOMÍA 10 MOSAICO"
  },
  {
    "codigo":698925004,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: TELUGU"
  },
  {
    "codigo":305709008,
    "descripcion":"VISTO POR ODONTÓLOGO RESTAURADOR"
  },
  {
    "codigo":402178001,
    "descripcion":"PRURITO BRAQUIORRADIAL"
  },
  {
    "codigo":1155842003,
    "descripcion":"OLIGOSACARIDOSIS"
  },
  {
    "codigo":8962004,
    "descripcion":"CATADÍDIMO"
  },
  {
    "codigo":205570009,
    "descripcion":"SÍNDROME DE BRUGSCH"
  },
  {
    "codigo":236503001,
    "descripcion":"CRISIS RENAL POR ESCLERODERMIA AGUDA"
  },
  {
    "codigo":7127005,
    "descripcion":"OSTEÍTIS DE MÚLTIPLES LOCALIZACIONES"
  },
  {
    "codigo":39895008,
    "descripcion":"PERFORACIÓN DEL BORDE DE LA MEMBRANA TIMPÁNICA"
  },
  {
    "codigo":267436001,
    "descripcion":"TRASTORNO POR DÉFICIT DE LIPOPROTEIN LIPASA"
  },
  {
    "codigo":300204001,
    "descripcion":"APERTURA OCULAR EN RESPUESTA AL SONIDO"
  },
  {
    "codigo":365740007,
    "descripcion":"NIVEL SÉRICO DE LITIO - HALLAZGO"
  },
  {
    "codigo":36225005,
    "descripcion":"INSUFICIENCIA RENAL AGUDA DEBIDA A PROCEDIMIENTO"
  },
  {
    "codigo":167297006,
    "descripcion":"PRUEBA DE SANGRE EN ORINA = NEGATIVA"
  },
  {
    "codigo":298369006,
    "descripcion":"ARTICULACIÓN TEMPOROMANDIBULAR - TUMEFACCIÓN DE PARTES BLANDAS"
  },
  {
    "codigo":11814461000119108,
    "descripcion":"RUPTURA TRAUMÁTICA DE LIGAMENTO COLATERAL DE ARTICULACIÓN DE MEÑIQUE IZQUIERDO"
  },
  {
    "codigo":198230004,
    "descripcion":"ULCERACIÓN DE LA VULVA ASOCIADA CON OTRO TRASTORNO"
  },
  {
    "codigo":722518004,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE VAINA DE NERVIO AUTONÓMICO"
  },
  {
    "codigo":165462005,
    "descripcion":"VISCOSIDAD DEL PLASMA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":67158008,
    "descripcion":"TIRÓN TRAQUEAL"
  },
  {
    "codigo":294699001,
    "descripcion":"ALERGIA A FLUOCINOLONA"
  },
  {
    "codigo":425771001,
    "descripcion":"ANEURISMA DE AORTA ABDOMINAL EN AUMENTO"
  },
  {
    "codigo":65323003,
    "descripcion":"POLIMIALGIA REUMÁTICA"
  },
  {
    "codigo":16047831000119104,
    "descripcion":"ARTRITIS INFECCIOSA DE ARTICULACIÓN DE TOBILLO IZQUIERDO CAUSADA POR VIRUS"
  },
  {
    "codigo":720683004,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR ATORVASTATINA"
  },
  {
    "codigo":718848000,
    "descripcion":"SÍNDROME DE FRIED"
  },
  {
    "codigo":292864002,
    "descripcion":"REACCIÓN ADVERSA AL ÁCIDO ACÉTICO"
  },
  {
    "codigo":1144832003,
    "descripcion":"INTOXICACIÓN POR TRICLOFÓS"
  },
  {
    "codigo":94421003,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE MÚSCULO DE LA CABEZA"
  },
  {
    "codigo":127189005,
    "descripcion":"LINFADENOPATÍA AXILAR"
  },
  {
    "codigo":717013009,
    "descripcion":"ENFERMEDAD DE CHARCOT-MARIE-TOOTH TIPO 2I AUTOSÓMICA DOMINANTE"
  },
  {
    "codigo":225493009,
    "descripcion":"USA ROPA DE NOCHE DURANTE EL DÍA"
  },
  {
    "codigo":61653009,
    "descripcion":"FRACTURA-LUXACIÓN DE ARTICULACIÓN TRAPEZOMETACARPIANA"
  },
  {
    "codigo":59818004,
    "descripcion":"DENTINA SECUNDARIA"
  },
  {
    "codigo":291029009,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR FLUNITRAZEPAM"
  },
  {
    "codigo":289194007,
    "descripcion":"ARTICULACIÓN ININTELIGIBLE"
  },
  {
    "codigo":92586007,
    "descripcion":"CARCINOMA IN SITU DE SENO ETMOIDAL"
  },
  {
    "codigo":254591001,
    "descripcion":"POLIPOSIS FIBROIDE INFLAMATORIA DEL INTESTINO"
  },
  {
    "codigo":90751002,
    "descripcion":"LÍNEA NEGRA"
  },
  {
    "codigo":713343003,
    "descripcion":"PERIODONTITIS CAUSADA POR APARATO DENTAL"
  },
  {
    "codigo":285524000,
    "descripcion":"CAPAZ DE MOVER LA LENGUA REPETIDAMENTE"
  },
  {
    "codigo":1137492001,
    "descripcion":"DEBILIDAD DE MÚSCULO AXIAL"
  },
  {
    "codigo":416596008,
    "descripcion":"CAMBIOS EN LAS UÑAS"
  },
  {
    "codigo":15693681000119107,
    "descripcion":"QUERATITIS FÚNGICA BILATERAL"
  },
  {
    "codigo":185385003,
    "descripcion":"SE LE SOLICITÓ QUE CONCURRIERA - EN PRUEBA FARMACOLÓGICA"
  },
  {
    "codigo":283689003,
    "descripcion":"MORDEDURA HUMANA EN LA FRENTE"
  },
  {
    "codigo":21545007,
    "descripcion":"DOLOR DE TENDÓN"
  },
  {
    "codigo":183550000,
    "descripcion":"DERIVADO AL CIRUJANO PLÁSTICO"
  },
  {
    "codigo":414761008,
    "descripcion":"PROTEÍNA MONOCLONAL DE CADENA PESADA ANORMAL SIN CADENAS LIVIANAS DETECTADA"
  },
  {
    "codigo":52478002,
    "descripcion":"ABSCESO SUBDIAFRAGMÁTICO"
  },
  {
    "codigo":249086002,
    "descripcion":"POSICIÓN MENTOILÍACA POSTERIOR"
  },
  {
    "codigo":871678004,
    "descripcion":"REACCIÓN ADVERSA A ÁCIDO HIALURÓNICO"
  },
  {
    "codigo":609534005,
    "descripcion":"HIPERSENSIBILIDAD NO ALÉRGICA A LOSARTÁN"
  },
  {
    "codigo":1197523001,
    "descripcion":"ESCLEROSIS LATERAL AMIOTRÓFICA TIPO 1 AUTOSÓMICA DOMINANTE"
  },
  {
    "codigo":50643003,
    "descripcion":"LATAH"
  },
  {
    "codigo":738771004,
    "descripcion":"PSEUDOHERMAFRODITISMO MASCULINO DEBIDO A DEFICIENCIA DE 5-ALFA-REDUCTASA"
  },
  {
    "codigo":247251004,
    "descripcion":"RESIDUOS ESCAMOSOS EN CONDUCTO AUDITIVO"
  },
  {
    "codigo":771539006,
    "descripcion":"ABSCESO EN EL LUGAR DE PUNCIÓN DEBIDO A ANESTESIA POR BLOQUEO PERIFÉRICO Y POSTERIOR A ELLA"
  },
  {
    "codigo":442024001,
    "descripcion":"HEMIPLEJÍA COMO EFECTO TARDÍO DE ENFERMEDAD CEREBROVASCULAR"
  },
  {
    "codigo":1230291009,
    "descripcion":"SÍNDROME DE SOLAPAMIENTO DE COLANGITIS BILIAR PRIMARIA, COLANGITIS ESCLEROSANTE PRIMARIA Y HEPATITIS AUTOINMUNITARIA"
  },
  {
    "codigo":81576005,
    "descripcion":"FRACTURA NO EXPUESTA DE FALANGE DE PIE"
  },
  {
    "codigo":704168008,
    "descripcion":"FRACTURA PATOLÓGICA DE FALANGE DE DEDO DEL PIE"
  },
  {
    "codigo":276349001,
    "descripcion":"QUIMOTRIPSINA FECAL"
  },
  {
    "codigo":14205002,
    "descripcion":"POSICIÓN DORSOSACRA"
  },
  {
    "codigo":1259389003,
    "descripcion":"CARCINOMA PRIMARIO DE GLANDE DE PENE"
  },
  {
    "codigo":405586000,
    "descripcion":"FÍSTULA BRONCOPLEURAL TRAUMÁTICA"
  },
  {
    "codigo":241746002,
    "descripcion":"INTOXICACIÓN POR GLIBENCLAMIDA"
  },
  {
    "codigo":700498004,
    "descripcion":"ANTECEDENTE OBTENIDO DE PERSONA CON RESPONSABILIDAD PARENTAL"
  },
  {
    "codigo":733266008,
    "descripcion":"MÚLTIPLES LESIONES TRAUMÁTICAS SUPERFICIALES DE CADERA"
  },
  {
    "codigo":10535001,
    "descripcion":"ENDOMETRIOSIS DEL LIGAMENTO ANCHO"
  },
  {
    "codigo":305447002,
    "descripcion":"BAJO ATENCIÓN DE HOMEÓPATA"
  },
  {
    "codigo":698663005,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: ISLANDÉS"
  },
  {
    "codigo":205308004,
    "descripcion":"PULGAR TRIFALÁNGICO"
  },
  {
    "codigo":321701000119106,
    "descripcion":"ARTRITIS DE HOMBRO IZQUIERDO CAUSADA POR STAPHYLOCOCCUS"
  },
  {
    "codigo":762364007,
    "descripcion":"AVULSIÓN TRAUMÁTICA DE OJO IZQUIERDO"
  },
  {
    "codigo":400081000,
    "descripcion":"AMPOLLA SIN INFECCIÓN"
  },
  {
    "codigo":238076009,
    "descripcion":"HIPERCOLESTEROLEMIA PRIMARIA"
  },
  {
    "codigo":301777002,
    "descripcion":"TUMEFACCIÓN DEL CUELLO"
  },
  {
    "codigo":365478005,
    "descripcion":"HALLAZGO RELACIONADO CON LA EDAD DE LOS PADRES"
  },
  {
    "codigo":299942009,
    "descripcion":"ALTERACIÓN DE LA ARTRESTESIA"
  },
  {
    "codigo":724091002,
    "descripcion":"ENFERMEDAD MELANOLISOSÓMICA NEUROECTODÉRMICA"
  },
  {
    "codigo":134267003,
    "descripcion":"LEE URDU"
  },
  {
    "codigo":429179002,
    "descripcion":"USO INAPROPIADO DE ANTIDEPRESIVOS"
  },
  {
    "codigo":197968005,
    "descripcion":"PROSTATITIS CANDIDIÁSICA"
  },
  {
    "codigo":15669721000119100,
    "descripcion":"TALIPES DE AMBOS PIES"
  },
  {
    "codigo":296272005,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE FLUPENTIXOL"
  },
  {
    "codigo":230736007,
    "descripcion":"AMNESIA GLOBAL TRANSITORIA"
  },
  {
    "codigo":196133001,
    "descripcion":"NEUMOPATÍA CON ESCLEROSIS SISTÉMICA"
  },
  {
    "codigo":350681000119101,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE MÉDULA DE GLÁNDULA SUPRARRENAL DERECHA"
  },
  {
    "codigo":294437007,
    "descripcion":"ALERGIA A CETRIMIDA"
  },
  {
    "codigo":718586000,
    "descripcion":"CON MAYOR RIESGO DE LESIÓN TÉRMICA PERIOPERATORIA"
  },
  {
    "codigo":423674003,
    "descripcion":"HIPERTENSIÓN VENOSA PERIFÉRICA CRÓNICA"
  },
  {
    "codigo":292602003,
    "descripcion":"REACCIÓN ADVERSA AL KETOTIFENO"
  },
  {
    "codigo":1144570009,
    "descripcion":"HIPOPLASIA CONGÉNITA DE MÚSCULO SERRATO ANTERIOR"
  },
  {
    "codigo":94159002,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LOS ANEXOS EPIDÉRMICOS"
  },
  {
    "codigo":1306575001,
    "descripcion":"CARCINOMA DUCTAL INFILTRANTE DE MAMA IZQUIERDA"
  },
  {
    "codigo":290767006,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR VINCRISTINA"
  },
  {
    "codigo":288932003,
    "descripcion":"LIMPIA LOS RESIDUOS DE LA BOCA"
  },
  {
    "codigo":92324006,
    "descripcion":"NEOPLASIA BENIGNA DE LOS GANGLIOS LINFÁTICOS RETROPERITONEALES"
  },
  {
    "codigo":714916007,
    "descripcion":"CAPACIDAD PARA PASAR DE UNA UBICACIÓN A OTRA, DEPENDIENTE"
  },
  {
    "codigo":713081000,
    "descripcion":"DISECCIÓN DE ARTERIA CEREBRAL"
  },
  {
    "codigo":59556008,
    "descripcion":"FRACTURA EXPUESTA DEL EXTREMO SUPERIOR DEL PERONÉ"
  },
  {
    "codigo":1087961000119107,
    "descripcion":"LÓBULO DESGARRADO ADQUIRIDO DE OREJA IZQUIERDA"
  },
  {
    "codigo":90489006,
    "descripcion":"ÚLCERA PÉPTICA CON HEMORRAGIA Y PERFORACIÓN PERO SIN OBSTRUCCIÓN"
  },
  {
    "codigo":285262001,
    "descripcion":"PENSAMIENTOS VENGATIVOS"
  },
  {
    "codigo":840483000,
    "descripcion":"FISURA CORONAL CONGÉNITA DE VÉRTEBRA"
  },
  {
    "codigo":86819001,
    "descripcion":"AMNESIA TEMPORAL"
  },
  {
    "codigo":709411004,
    "descripcion":"HEMIATROFIA DE MIEMBRO INFERIOR"
  },
  {
    "codigo":54051005,
    "descripcion":"ESTÓMAGO EN CASCADA"
  },
  {
    "codigo":283427007,
    "descripcion":"CORTE EN EL PERINEO"
  },
  {
    "codigo":84984002,
    "descripcion":"TRASTORNO DE ADAPTACIÓN, CON ALTERACIÓN DE LA CONDUCTA"
  },
  {
    "codigo":19448008,
    "descripcion":"ATROFIA ÓPTICA ASOCIADA CON DISTROFIA RETINIANA"
  },
  {
    "codigo":707576008,
    "descripcion":"CARCINOMA PRIMARIO DE CÉLULAS ESCAMOSAS DE SUBGLOTIS"
  },
  {
    "codigo":248824009,
    "descripcion":"PEZONES DE DIFERENTE TAMAÑO"
  },
  {
    "codigo":1197261004,
    "descripcion":"HIPERPLASIA LINFOIDE REACTIVA DE SISTEMA DE DRENAJE LAGRIMAL"
  },
  {
    "codigo":212386000,
    "descripcion":"SÍNDROME COMPARTIMENTAL DE PIE DEBIDO A LESIÓN TRAUMÁTICA"
  },
  {
    "codigo":277922001,
    "descripcion":"APROSENCEFALIA"
  },
  {
    "codigo":441762006,
    "descripcion":"TROMBOFILIA DEBIDA A INMOVILIZACIÓN"
  },
  {
    "codigo":13943000,
    "descripcion":"INTENTO FALLIDO DE ABORTO COMPLICADO POR EMBOLIA"
  },
  {
    "codigo":308855000,
    "descripcion":"DISPLASIA MODERADA DE ESTÓMAGO"
  },
  {
    "codigo":472695004,
    "descripcion":"SUTURA FLOJA DE CÓRNEA"
  },
  {
    "codigo":79479005,
    "descripcion":"BRONQUITIS POR VIRUS RESPIRATORIO SINCICIAL"
  },
  {
    "codigo":734839006,
    "descripcion":"DESPLAZAMIENTO DE ESTRUCTURA DENTAL EN SENO MAXILAR"
  },
  {
    "codigo":1259127007,
    "descripcion":"ESCLEROSIS LATERAL AMIOTRÓFICA CON DISFUNCIÓN CEREBELOSA"
  },
  {
    "codigo":208716006,
    "descripcion":"FRACTURA EXPUESTA DE FALANGE MEDIA DE DEDO DEL PIE"
  },
  {
    "codigo":1290060007,
    "descripcion":"TUMOR NEUROENDOCRINO BIEN DIFERENCIADO METASTÁSICO"
  },
  {
    "codigo":10273003,
    "descripcion":"INFARTO AGUDO DEL MÚSCULO PAPILAR"
  },
  {
    "codigo":75809006,
    "descripcion":"INFECCIÓN CAUSADA POR TRYPANOSOMA GAMBIENSE"
  },
  {
    "codigo":403489007,
    "descripcion":"LUPUS ERITEMATOSO CUTÁNEO SUBAGUDO, TIPO ANULAR\/POLICÍCLICO"
  },
  {
    "codigo":237814001,
    "descripcion":"PUBERTAD DETENIDA"
  },
  {
    "codigo":6603000,
    "descripcion":"AMPOLLA ESCROTAL SIN INFECCIÓN"
  },
  {
    "codigo":235979003,
    "descripcion":"TRASTORNO DE ANASTOMOSIS DE CONDUCTO PANCREÁTICO"
  },
  {
    "codigo":353191000119104,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE EPIDÍDIMO DERECHO"
  },
  {
    "codigo":1153483007,
    "descripcion":"ANDROSTENEDIONA SÉRICA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":266912001,
    "descripcion":"GRUPO SOCIAL 3 - TRABAJADOR MANUAL NO CALIFICADO"
  },
  {
    "codigo":365216003,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA USAR ORINAL"
  },
  {
    "codigo":723829000,
    "descripcion":"SÍNDROME DE FIBROSIS PULMONAR, HIPERPLASIA HEPÁTICA E HIPOPLASIA DE MÉDULA ÓSEA"
  },
  {
    "codigo":234144009,
    "descripcion":"FÍSTULA ARTERIOVENOSA DE TRONCO"
  },
  {
    "codigo":232309003,
    "descripcion":"DEGENERACIÓN OTOTÓXICA DE LA CÓCLEA"
  },
  {
    "codigo":363381003,
    "descripcion":"NEOPLASIA MALIGNA DE GLÁNDULA SUBLINGUAL"
  },
  {
    "codigo":16219201000119101,
    "descripcion":"DEMENCIA DE ALZHEIMER DE APARICIÓN TARDÍA CON TRASTORNO DE CONDUCTA"
  },
  {
    "codigo":263242001,
    "descripcion":"FRACTURA DE PERONÉ DISTAL"
  },
  {
    "codigo":230474003,
    "descripcion":"CEFALEA CRÓNICA EN SALVAS SIN REMISIÓN DESDE EL INICIO"
  },
  {
    "codigo":164938004,
    "descripcion":"ELECTROCARDIOGRAMA: ONDA U EXAGERADA"
  },
  {
    "codigo":66634003,
    "descripcion":"OSTEOMIELITIS CRÓNICA DE MÚLTIPLES LOCALIZACIONES"
  },
  {
    "codigo":296010004,
    "descripcion":"SOBREDOSIS DE CLONAZEPAM"
  },
  {
    "codigo":296968001,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE ÁCIDO FÓLICO"
  },
  {
    "codigo":359711001,
    "descripcion":"ENFERMEDAD DE VON WILLEBRAND HEREDITARIA TIPO 2A"
  },
  {
    "codigo":261407007,
    "descripcion":"BANDA DE LADD"
  },
  {
    "codigo":425247007,
    "descripcion":"CLASE I DE MALLAMPATI"
  },
  {
    "codigo":95732006,
    "descripcion":"QUERATITIS NECROSANTE"
  },
  {
    "codigo":62964007,
    "descripcion":"SÍNDROME DE ANTLEY - BIXLER"
  },
  {
    "codigo":1177076006,
    "descripcion":"DACRIOADENITIS SIFILÍTICA"
  },
  {
    "codigo":716489000,
    "descripcion":"DIFICULTAD PARA UTILIZAR LA SEMÁNTICA EN LA COMUNICACIÓN"
  },
  {
    "codigo":292340007,
    "descripcion":"REACCIÓN ADVERSA AL CICLOBARBITAL"
  },
  {
    "codigo":224969003,
    "descripcion":"SE SIENTE EXCITADO"
  },
  {
    "codigo":1306313002,
    "descripcion":"NEOPLASIA DE TEJIDO ECTÓPICO DE MAMA"
  },
  {
    "codigo":126665005,
    "descripcion":"MUCOSITIS OROFARÍNGEA"
  },
  {
    "codigo":92062001,
    "descripcion":"NEOPLASIA BENIGNA DEL CLÍTORIS"
  },
  {
    "codigo":288670001,
    "descripcion":"CAPAZ DE RESTABLECER UNA CONVERSACIÓN"
  },
  {
    "codigo":712819000,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE TENDÓN EXTENSOR DE MANO Y MUÑECA"
  },
  {
    "codigo":254067002,
    "descripcion":"DISPLASIA INMUNO-ÓSEA"
  },
  {
    "codigo":11769051000119104,
    "descripcion":"DISTENSIÓN DE MÚSCULO DE ANTEBRAZO IZQUIERDO"
  },
  {
    "codigo":188531003,
    "descripcion":"PARAGRANULOMA DE HODGKIN DE GANGLIOS LINFÁTICOS DE MÚLTIPLES LOCALIZACIONES"
  },
  {
    "codigo":286835006,
    "descripcion":"TIENDE A MANIPULAR A OTROS"
  },
  {
    "codigo":285000000,
    "descripcion":"SE ABROCHA LA ROPA"
  },
  {
    "codigo":1004061002,
    "descripcion":"CONTRACTURA EN FLEXIÓN DE ARTICULACIÓN INTERFALÁNGICA PROXIMAL DE CUARTO DEDO DE PIE"
  },
  {
    "codigo":250397007,
    "descripcion":"ANTÍGENO TIPO CHIDO-ROGERS"
  },
  {
    "codigo":707314000,
    "descripcion":"ERITEMA MULTIFORME CONCOMITANTE CON ÚLCERA DE MEMBRANA MUCOSA BUCAL"
  },
  {
    "codigo":445170001,
    "descripcion":"NEFROPATÍA MACROALBUMINÚRICA DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":248562002,
    "descripcion":"MOVIMIENTO PARADÓJICO DEL TÓRAX"
  },
  {
    "codigo":51954003,
    "descripcion":"ABORTO ESPONTÁNEO CON PERFORACIÓN DE TEJIDO PERIURETRAL"
  },
  {
    "codigo":1264370002,
    "descripcion":"LACERACIÓN DE TENDÓN DE HOMBRO"
  },
  {
    "codigo":281330008,
    "descripcion":"NO SE SUMINISTRÓ SOLICITUD DE ESTUDIO"
  },
  {
    "codigo":838386008,
    "descripcion":"MIOPATÍA AGUDA ALCOHÓLICA"
  },
  {
    "codigo":117490008,
    "descripcion":"CRISTAL URINARIO, TRIHIDRATO DE FOSFATO DE HIDRÓGENO MAGNESIO"
  },
  {
    "codigo":246727004,
    "descripcion":"ESTRABISMO CONVERGENTE MANIFIESTO"
  },
  {
    "codigo":1196999009,
    "descripcion":"MASA EN PALADAR"
  },
  {
    "codigo":212124005,
    "descripcion":"QUEMADURA QUE COMPROMETE MÁS DEL 90 POR CIENTO DE LA SUPERFICIE CORPORAL, CON 80 - 89 POR CIENTO DE SUPERFICIE CORPORAL CON QUEMADURA DE TERCER GRADO"
  },
  {
    "codigo":11471000224106,
    "descripcion":"GLIOMA PONTINO INTRÍNSECO DIFUSO"
  },
  {
    "codigo":111985007,
    "descripcion":"DOLOR ABDOMINAL CRÓNICO"
  },
  {
    "codigo":110150000,
    "descripcion":"CONCUSIÓN DE LA MÉDULA ESPINAL"
  },
  {
    "codigo":306758000,
    "descripcion":"CAPAZ DE PRODUCIR SONIDOS SORDOS"
  },
  {
    "codigo":243057007,
    "descripcion":"INTOXICACIÓN POR GAS VESICANTE"
  },
  {
    "codigo":208454005,
    "descripcion":"FRACTURA NO EXPUESTA DE LA FALANGE MEDIA DE DEDO DE LA MANO, CABEZA"
  },
  {
    "codigo":16057871000119103,
    "descripcion":"PARÁLISIS FACIAL IZQUIERDA GRADO I DE HOUSE-BRACKMANN"
  },
  {
    "codigo":372294007,
    "descripcion":"INVASIÓN TUMORAL DE VESÍCULA SEMINAL PRESENTE"
  },
  {
    "codigo":42779002,
    "descripcion":"MIOPATÍA POR CUERPOS REDUCTORES"
  },
  {
    "codigo":75547007,
    "descripcion":"ESTENOSIS DE LA LARINGE"
  },
  {
    "codigo":403227009,
    "descripcion":"FOTOSUBTIPO CUTÁNEO IIIA (AL COMIENZO, A VECES EXISTE QUEMADURA, LUEGO BRONCEADO LEVE)"
  },
  {
    "codigo":303088008,
    "descripcion":"INCOMPETENCIA DE CUELLO DE VEJIGA URINARIA"
  },
  {
    "codigo":237552009,
    "descripcion":"HIPERPLASIA DE CÉLULAS C DE LA GLÁNDULA TIROIDES"
  },
  {
    "codigo":6341002,
    "descripcion":"QUEMADURA DE CUALQUIER GRADO QUE COMPROMETE MENOS DE 10 PORCIENTO DE LA SUPERFICIE DEL CUERPO"
  },
  {
    "codigo":170181007,
    "descripcion":"EXAMEN DEL NIÑO A LOS 15 AÑOS: NORMAL"
  },
  {
    "codigo":301253007,
    "descripcion":"OBSTRUCCIÓN PARCIAL DE LAS VÍAS AÉREAS DURANTE LA INSPIRACIÓN"
  },
  {
    "codigo":299418001,
    "descripcion":"DEFORMIDAD DE ARTICULACIÓN DE TOBILLO"
  },
  {
    "codigo":4506002,
    "descripcion":"PROBLEMA EDUCATIVO"
  },
  {
    "codigo":1551000119108,
    "descripcion":"RETINOPATÍA NO PROLIFERATIVA DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":168346004,
    "descripcion":"ORGANISMO AISLADO EN CULTIVO DE HISOPADO VAGINAL PROFUNDO"
  },
  {
    "codigo":364954004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA ESTIRAR LOS LABIOS"
  },
  {
    "codigo":70042006,
    "descripcion":"ALTERACIÓN VISUAL PSICOFÍSICA"
  },
  {
    "codigo":201114008,
    "descripcion":"DEFORMIDAD DE UÑA"
  },
  {
    "codigo":199279003,
    "descripcion":"TRASTORNOS ORTOPÉDICOS DURANTE EL EMBARAZO, PARTO Y PUERPERIO"
  },
  {
    "codigo":138921000119104,
    "descripcion":"RETINOPATÍA NO PROLIFERATIVA MODERADA DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":461423005,
    "descripcion":"FÍSTULA ARTERIOVENOSA DE ARTERIA CORONARIA A SENO CORONARIO"
  },
  {
    "codigo":721732001,
    "descripcion":"INFECCIÓN DE SISTEMA MUSCULOESQUELÉTICO CAUSADA POR MYCOBACTERIUM TUBERCULOSIS"
  },
  {
    "codigo":295748005,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE PROCARBAZINA"
  },
  {
    "codigo":228377000,
    "descripcion":"FUMA DROGAS"
  },
  {
    "codigo":31769003,
    "descripcion":"PERFUSIÓN VASCULAR DE ÓRGANO O TEJIDO, NORMAL"
  },
  {
    "codigo":62702001,
    "descripcion":"OCLUSIÓN DE VENA CEREBRAL"
  },
  {
    "codigo":128238001,
    "descripcion":"CARDIOPATÍA CRÓNICA"
  },
  {
    "codigo":292078002,
    "descripcion":"REACCIÓN ADVERSA A LA INDOMETACINA"
  },
  {
    "codigo":29934004,
    "descripcion":"RETORNO VENOSO PULMONAR ANÓMALO AL SENO CORONARIO"
  },
  {
    "codigo":15703721000119109,
    "descripcion":"DISFUNCIÓN DE TENDÓN TIBIAL POSTERIOR DE AMBOS PIES"
  },
  {
    "codigo":718062006,
    "descripcion":"PERIODONTITIS CRÓNICA MODERADA GENERALIZADA"
  },
  {
    "codigo":93635000,
    "descripcion":"FALTA DE OSIFICACIÓN DE FÉMUR"
  },
  {
    "codigo":95470009,
    "descripcion":"ANOMALÍA CONGÉNITA DEL TRACTO ALIMENTARIO"
  },
  {
    "codigo":191939002,
    "descripcion":"USO INDEBIDO DE FÁRMACOS DE VENTA CON RECETA"
  },
  {
    "codigo":290243004,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR FELBINACO"
  },
  {
    "codigo":421315006,
    "descripcion":"MIELITIS ASOCIADA CON SIDA"
  },
  {
    "codigo":60867007,
    "descripcion":"CISTITIS POR KLEBSIELLA"
  },
  {
    "codigo":1287062000,
    "descripcion":"HEMORRAGIA INTRAVENTRICULAR NO TRAUMÁTICA GRADO 2 DURANTE PERÍODO FETAL"
  },
  {
    "codigo":880067009,
    "descripcion":"ENFERMEDAD DE BLOUNT"
  },
  {
    "codigo":59032001,
    "descripcion":"LENGUA GEOGRÁFICA"
  },
  {
    "codigo":288408004,
    "descripcion":"ENROSCA UNA TAPA"
  },
  {
    "codigo":1236845001,
    "descripcion":"ESPECTRO DE MICROCEFALIA, TALLA BAJA, ANOMALÍAS DE EXTREMIDADES ASOCIADO A GEN DONSON"
  },
  {
    "codigo":188269007,
    "descripcion":"NEOPLASIA MALIGNA DE MÚSCULO EXTRAOCULAR DE ÓRBITA"
  },
  {
    "codigo":448578003,
    "descripcion":"SIN OBSTRUCCIÓN DEL TRACTO DE SALIDA DEL VENTRÍCULO DERECHO"
  },
  {
    "codigo":415810004,
    "descripcion":"VÁRICE DE VENA UMBILICAL"
  },
  {
    "codigo":4061000119104,
    "descripcion":"MIELOMENINGOCELE SIN HIDROCEFALIA"
  },
  {
    "codigo":250135007,
    "descripcion":"DESLIZAMIENTO DE TENDÓN"
  },
  {
    "codigo":282903007,
    "descripcion":"SE LEVANTA DE LA POSICIÓN EN CUCLILLAS"
  },
  {
    "codigo":20759009,
    "descripcion":"YEYUNITIS DIETÉTICA"
  },
  {
    "codigo":1296876005,
    "descripcion":"DETENCIÓN PARCIAL DE CRECIMIENTO EPIFISARIO DE TIBIA DISTAL"
  },
  {
    "codigo":331741000119106,
    "descripcion":"BLEFARITIS ULCEROSA DE PÁRPADO DERECHO"
  },
  {
    "codigo":246465007,
    "descripcion":"FUNCIÓN CLÍNICA"
  },
  {
    "codigo":1293206008,
    "descripcion":"MASA DE MÚSCULO DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":48022009,
    "descripcion":"DESTRUCCIÓN ANORMAL DE LINFOCITOS"
  },
  {
    "codigo":767083001,
    "descripcion":"EL PRIMER VASO CONTIENE MOCO"
  },
  {
    "codigo":111723007,
    "descripcion":"CONTUSIÓN DE SITIOS MÚLTIPLES DE LA EXTREMIDAD INFERIOR"
  },
  {
    "codigo":208192003,
    "descripcion":"FRACTURA EXPUESTA DE PELVIS, TUBEROSIDAD ISQUIÁTICA"
  },
  {
    "codigo":44352004,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN LA REGIÓN DE LA MANO, CON INFECCIÓN"
  },
  {
    "codigo":16033911000119106,
    "descripcion":"HIPERTROFIA DE HUESO DE AMBOS PIES"
  },
  {
    "codigo":109888004,
    "descripcion":"CARCINOMA LOBULILLAR IN SITU DE LA MAMA"
  },
  {
    "codigo":699712005,
    "descripcion":"PRÓTESIS DENTAL MAXILAR COMPLETA DEFECTUOSA"
  },
  {
    "codigo":1254933001,
    "descripcion":"REACCIÓN CUTÁNEA POR CONTACTO CON CUBOZOA"
  },
  {
    "codigo":402965002,
    "descripcion":"INFECCIÓN POR VIBRIO VULNIFICUS"
  },
  {
    "codigo":304661006,
    "descripcion":"INCAPAZ DE EMPLEAR RAZONAMIENTO ARITMÉTICO"
  },
  {
    "codigo":827114001,
    "descripcion":"MASA ABDOMINAL DURA"
  },
  {
    "codigo":302826002,
    "descripcion":"ADENOMA CORTICOSUPRARRENAL"
  },
  {
    "codigo":270058007,
    "descripcion":"PACIENTE REGISTRADO - FP19"
  },
  {
    "codigo":204522009,
    "descripcion":"DEFORMIDAD DE LA PARED DE SENO NASAL"
  },
  {
    "codigo":268223002,
    "descripcion":"FUSIÓN CONGÉNITA DE LABIOS VULVARES"
  },
  {
    "codigo":169919005,
    "descripcion":"PUNTAJE DE APGAR A LOS 5 MINUTOS = 9"
  },
  {
    "codigo":202687006,
    "descripcion":"ESPONDILOSIS CERVICAL CON COMPRESIÓN VASCULAR"
  },
  {
    "codigo":33041000119105,
    "descripcion":"HEMORROIDE INTERNA COMPLICADA"
  },
  {
    "codigo":366527009,
    "descripcion":"AMPLITUD DE MOVIMIENTO DE EXTENSIÓN ACTIVA DE LA MUÑECA - HALLAZGO"
  },
  {
    "codigo":233620002,
    "descripcion":"NEUMONÍA POR PARÁSITOS"
  },
  {
    "codigo":38847009,
    "descripcion":"SÍNDROME XXXXY"
  },
  {
    "codigo":200852004,
    "descripcion":"DERMATITIS IRRITATIVA POR CONTACTO CAUSADA POR FÁRMACO EN CONTACTO CON LA PIEL"
  },
  {
    "codigo":725140007,
    "descripcion":"SÍNDROME DE TEMPLE-BARAITSER"
  },
  {
    "codigo":397460008,
    "descripcion":"TUMOR QUE INVADE PARTES BLANDAS DE PARED TORÁCICA"
  },
  {
    "codigo":1149289005,
    "descripcion":"CAPAZ DE EJECUTAR HABILIDADES DE ALIMENTACIÓN Y\/O NUTRICIÓN CON DIFICULTAD"
  },
  {
    "codigo":721470003,
    "descripcion":"SÍNDROME DEL CORDÓN POSTERIOR DE MÉDULA ESPINAL AL NIVEL DEL SEGUNDO SEGMENTO DORSAL"
  },
  {
    "codigo":262718005,
    "descripcion":"HEMORRAGIA TRAUMÁTICA DE LA MÉDULA ESPINAL"
  },
  {
    "codigo":11803051000119103,
    "descripcion":"ESGUINCE DE MUÑECA DERECHA"
  },
  {
    "codigo":334251000119104,
    "descripcion":"ECTROPIÓN CICATRIZAL DE PÁRPADO INFERIOR DERECHO"
  },
  {
    "codigo":42731000087100,
    "descripcion":"DISCO INTERVERTEBRAL TORÁCICO PROLAPSADO, T2-T3"
  },
  {
    "codigo":47851000087101,
    "descripcion":"FRACTURA DE TERCERA COSTILLA DERECHA"
  },
  {
    "codigo":424723006,
    "descripcion":"DIFICULTAD PARA ESCUCHAR LO QUE SE HABLA EN UN GRAN GRUPO"
  },
  {
    "codigo":293651006,
    "descripcion":"ALERGIA A FAMOTIDINA"
  },
  {
    "codigo":40171000087103,
    "descripcion":"LACERACIÓN DE TENDÓN FLEXOR DE PULGAR IZQUIERDO"
  },
  {
    "codigo":95208000,
    "descripcion":"EPILEPSIA FOTOGÉNICA"
  },
  {
    "codigo":129811006,
    "descripcion":"DIFERENCIA DE FORMA SEGÚN LA MAMOGRAFÍA"
  },
  {
    "codigo":62440002,
    "descripcion":"GANGLIOSIDOSIS GM 2 INFANTIL"
  },
  {
    "codigo":60651000087108,
    "descripcion":"DIFICULTAD PARA REALIZAR ACTIVIDAD INSTRUMENTAL DE LA VIDA DIARIA"
  },
  {
    "codigo":160744003,
    "descripcion":"VIVE EN ALOJAMIENTO CON SERVICIO DE CAMA Y DESAYUNO"
  },
  {
    "codigo":27837003,
    "descripcion":"DISPLASIA METAFISARIA DE PYLE"
  },
  {
    "codigo":191677006,
    "descripcion":"PSICOSIS HISTÉRICA AGUDA"
  },
  {
    "codigo":289981006,
    "descripcion":"UTILIZA ARTÍCULOS DE TOCADOR"
  },
  {
    "codigo":93373008,
    "descripcion":"DESALINEACIÓN CONGÉNITA DE CENTRO DE VÉRTEBRA CERVICAL"
  },
  {
    "codigo":224445008,
    "descripcion":"ÁREA DE DESCANSO INADECUADA EN EL TRABAJO"
  },
  {
    "codigo":91538002,
    "descripcion":"OSTEOMIELITIS DE MÚLTIPLES LOCALIZACIONES"
  },
  {
    "codigo":124306003,
    "descripcion":"DEFICIENCIA DE 6 - FOSFOFRUCTOCINASA"
  },
  {
    "codigo":253543007,
    "descripcion":"FIBROELASTOSIS ENDOCÁRDICA PRIMARIA DE VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":251708000,
    "descripcion":"SACO LAGRIMAL NO INGRESADO"
  },
  {
    "codigo":286311009,
    "descripcion":"INCAPAZ DE UTILIZAR CONSONANTES INDIVIDUALES"
  },
  {
    "codigo":384615009,
    "descripcion":"MARGEN QUIRÚRGICO PROXIMAL AFECTADO POR NEOPLASIA MALIGNA"
  },
  {
    "codigo":186172004,
    "descripcion":"PLEURESÍA TUBERCULOSA EN LA TUBERCULOSIS PROGRESIVA PRIMARIA"
  },
  {
    "codigo":284476005,
    "descripcion":"LACERACIÓN SUPERFICIAL DE CARA"
  },
  {
    "codigo":282641003,
    "descripcion":"INCAPAZ DE AGACHARSE"
  },
  {
    "codigo":16009951000119101,
    "descripcion":"NECROSIS AVASCULAR DE CÓNDILO INTERNO DE AMBOS FÉMURES"
  },
  {
    "codigo":249873005,
    "descripcion":"INCAPAZ DE SACAR LA LENGUA"
  },
  {
    "codigo":315409004,
    "descripcion":"NACIDO EN CROACIA"
  },
  {
    "codigo":12241631000119102,
    "descripcion":"ARTROSIS DE ARTICULACIÓN DE DEDO DE LA MANO IZQUIERDA"
  },
  {
    "codigo":1296614001,
    "descripcion":"HIPERTENSIÓN OCULAR BILATERAL DEBIDA A TRAUMATISMO OCULAR"
  },
  {
    "codigo":18662002,
    "descripcion":"ANEMIA ADQUIRIDA CON CUERPOS DE HEINZ"
  },
  {
    "codigo":248038001,
    "descripcion":"DESOBEDIENCIA"
  },
  {
    "codigo":117471000119103,
    "descripcion":"BOTONES MAMARIOS DEL DESARROLLO PUBERAL NORMAL"
  },
  {
    "codigo":444646006,
    "descripcion":"PARONIQUIA DE DEDO DE LA MANO"
  },
  {
    "codigo":82363001,
    "descripcion":"QUISTE ADQUIRIDO DE CONDUCTO DE NUCK"
  },
  {
    "codigo":410043004,
    "descripcion":"ANQUILOSIS DE LA ARTICULACIÓN GLENOHUMERAL"
  },
  {
    "codigo":278971009,
    "descripcion":"INMUNE A HEPATITIS A"
  },
  {
    "codigo":14992004,
    "descripcion":"CONTUSIÓN DEL PENE"
  },
  {
    "codigo":735888004,
    "descripcion":"ESGUINCE DE ARTICULACIÓN INTERFALÁNGICA DE SEGUNDO A QUINTOS DEDOS DE PIE"
  },
  {
    "codigo":16665311000119106,
    "descripcion":"FRACTURA EXPUESTA DE LADO IZQUIERDO DE MAXILAR SUPERIOR"
  },
  {
    "codigo":11832031000119107,
    "descripcion":"LACERACIÓN DE VASO SANGUÍNEO DE ANULAR DERECHO"
  },
  {
    "codigo":78693004,
    "descripcion":"HIPOPLASIA CONGÉNITA DE PARTE DEL CEREBRO"
  },
  {
    "codigo":209765005,
    "descripcion":"RUPTURA DE TENDÓN DEL PULGAR"
  },
  {
    "codigo":766821006,
    "descripcion":"SÍNDROME DE DISPLASIA ESPONDILOEPIMETAFISARIA, MIEMBROS CORTOS Y CALCIFICACIÓN ANORMAL"
  },
  {
    "codigo":109626000,
    "descripcion":"CONTUSIÓN DE LAS PAPILAS DE LA ENCÍA"
  },
  {
    "codigo":699450003,
    "descripcion":"APERTURA EXCESIVA DE LA MANDÍBULA"
  },
  {
    "codigo":207930006,
    "descripcion":"FRACTURA EXPUESTA DE VÉRTEBRA CERVICAL, EN CUÑA"
  },
  {
    "codigo":371770009,
    "descripcion":"ENDOTOXEMIA"
  },
  {
    "codigo":336761000119104,
    "descripcion":"CATARATA TRAUMÁTICA CON RESOLUCIÓN PARCIAL DE OJO DERECHO"
  },
  {
    "codigo":402703004,
    "descripcion":"DERMATOSIS DE LENGUA"
  },
  {
    "codigo":238863004,
    "descripcion":"FIBROBLASTOMA CUTÁNEO DE CÉLULAS GIGANTES"
  },
  {
    "codigo":271631006,
    "descripcion":"TRÁQUEA DESPLAZADA HACIA LA DERECHA"
  },
  {
    "codigo":105956001,
    "descripcion":"FÓRMULA Y\/O DIETA PARA LACTANTES"
  },
  {
    "codigo":75023009,
    "descripcion":"EPILEPSIA POSTRAUMÁTICA"
  },
  {
    "codigo":1285604002,
    "descripcion":"HEMATOMA DE TALÓN"
  },
  {
    "codigo":366265001,
    "descripcion":"HALLAZGO RELACIONADO CON ASPECTO DE VEJIGA URINARIA"
  },
  {
    "codigo":300729006,
    "descripcion":"DIFICULTAD PARA REALIZAR ACTIVIDADES TELEFÓNICAS"
  },
  {
    "codigo":169657007,
    "descripcion":"ESTADO DE ECOGRAFÍA PRENATAL"
  },
  {
    "codigo":202425008,
    "descripcion":"TUMOR TENOSINOVIAL DE CÉLULAS GIGANTES DIFUSO DE BRAZO"
  },
  {
    "codigo":298894001,
    "descripcion":"AMPLITUD DE EXTENSIÓN ACTIVA DE CODO DISMINUIDA"
  },
  {
    "codigo":69518005,
    "descripcion":"ANOMALÍA CONGÉNITA DEL APARATO DIGESTIVO"
  },
  {
    "codigo":266126006,
    "descripcion":"NEUROSÍFILIS CONGÉNITA TARDÍA"
  },
  {
    "codigo":460899002,
    "descripcion":"ORIGEN ANÓMALO DE ARTERIA CARÓTIDA PRIMITIVA IZQUIERDA EN ARTERIA BRAQUIOCEFÁLICA"
  },
  {
    "codigo":231523004,
    "descripcion":"BULIMIA NERVIOSA ATÍPICA"
  },
  {
    "codigo":67683007,
    "descripcion":"PULSO ANORMAL"
  },
  {
    "codigo":295224002,
    "descripcion":"SOBREDOSIS INTENCIONAL DE AZAPROPAZONA"
  },
  {
    "codigo":721208007,
    "descripcion":"SÍNDROME DE DISPLASIA ECTODÉRMICA CON CEGUERA"
  },
  {
    "codigo":719373000,
    "descripcion":"UTILIZA DISPOSITIVO DE COMUNICACIÓN MOTORIZADO"
  },
  {
    "codigo":459064009,
    "descripcion":"ENDARTERITIS INFECCIOSA DE CONDUCTO ARTERIOSO"
  },
  {
    "codigo":229688009,
    "descripcion":"DISARTRIA EXTRAPIRAMIDAL"
  },
  {
    "codigo":454211000124107,
    "descripcion":"INCUMPLIMIENTO DE RÉGIMEN DE MEDICACIÓN DEBIDO A ALTERACIÓN VISUAL"
  },
  {
    "codigo":15930541000119101,
    "descripcion":"NEOPLASIA CON BAJO POTENCIAL DE COMPORTAMIENTO MALIGNO DE OVARIO DERECHO"
  },
  {
    "codigo":1145357006,
    "descripcion":"LESIÓN HIPERINTENSA DE TRONCO ENCEFÁLICO EN IMAGEN DE RESONANCIA MAGNÉTICA EN T2"
  },
  {
    "codigo":424461008,
    "descripcion":"CONDUCTA ALTERADA DEBIDO A USO DE SUSTANCIA"
  },
  {
    "codigo":293389009,
    "descripcion":"REACCIÓN ADVERSA A ALFA-TOCOFERILO"
  },
  {
    "codigo":193250002,
    "descripcion":"MIOPATÍA POR ARTRITIS REUMATOIDE"
  },
  {
    "codigo":291554002,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR PIPERACILINA"
  },
  {
    "codigo":94946006,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE MÚSCULO DEL CUELLO"
  },
  {
    "codigo":422626007,
    "descripcion":"HALLAZGO RELACIONADO CON EL FLUJO DE LÍQUIDO CEFALORRAQUÍDEO"
  },
  {
    "codigo":160482007,
    "descripcion":"GRUPO SOCIAL 1 - PROFESIONAL"
  },
  {
    "codigo":224183002,
    "descripcion":"SALARIO PAGADO SEMESTRALMENTE"
  },
  {
    "codigo":1010615002,
    "descripcion":"SÍFILIS PULMONAR TARDÍA"
  },
  {
    "codigo":781239004,
    "descripcion":"TENDINITIS DE LA PATA DE GANSO IZQUIERDA"
  },
  {
    "codigo":289719005,
    "descripcion":"CONTRACCIONES UTERINAS FUERTES"
  },
  {
    "codigo":420791006,
    "descripcion":"FENÓMENO DE CEPILLOS DE HAIDINGER"
  },
  {
    "codigo":93111009,
    "descripcion":"FALTA DE OSIFICACIÓN DE HUESO PALATINO"
  },
  {
    "codigo":124044002,
    "descripcion":"FOSFOLÍPIDO DE ESTRUCTURA ANORMAL"
  },
  {
    "codigo":1303692005,
    "descripcion":"PÓLIPO ADENOMATOSO DE APÉNDICE"
  },
  {
    "codigo":253281003,
    "descripcion":"VENTRÍCULO CON DOBLE TRACTO DE ENTRADA"
  },
  {
    "codigo":286049003,
    "descripcion":"INCAPAZ DE LAVAR LA ROPA SUCIA"
  },
  {
    "codigo":449889006,
    "descripcion":"DEMORA EN LA BÚSQUEDA DE CONSEJO MÉDICO"
  },
  {
    "codigo":448054001,
    "descripcion":"LEUCODISTROFIA AUTOSÓMICA DOMINANTE DE COMIENZO EN LA VIDA ADULTA"
  },
  {
    "codigo":251446006,
    "descripcion":"ACTIVIDAD DOMINANTE ALFA"
  },
  {
    "codigo":185910007,
    "descripcion":"OMISIÓN DE CONTROL DE TRATAMIENTO DE RESTITUCIÓN HORMONAL"
  },
  {
    "codigo":87606006,
    "descripcion":"TONO VOCAL EXCESIVAMENTE BAJO"
  },
  {
    "codigo":184075003,
    "descripcion":"ESTADO DE REGISTRO DEL PACIENTE - DESCONOCIDO"
  },
  {
    "codigo":249611003,
    "descripcion":"PÉRDIDA DEL SURCO MEDIO DE LA PRÓSTATA"
  },
  {
    "codigo":216843005,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR MONÓXIDO DE CARBONO POR COMBUSTIÓN INCOMPLETA DE CARBÓN EN ESTUFA O COCINA DE USO DOMÉSTICO"
  },
  {
    "codigo":1263584002,
    "descripcion":"HIDROCEFALIA DEBIDA A OBSTRUCCIÓN DE FLUJO DE SALIDA DE CUARTO VENTRÍCULO"
  },
  {
    "codigo":870368003,
    "descripcion":"INTOLERANCIA ORTOSTÁTICA"
  },
  {
    "codigo":247776002,
    "descripcion":"PREOCUPACIÓN DEPRESIVA"
  },
  {
    "codigo":339271000119107,
    "descripcion":"QUERATOCONJUNTIVITIS NEUROTRÓFICA DE OJO IZQUIERDO"
  },
  {
    "codigo":11863521000119101,
    "descripcion":"CONTUSIÓN DE DEDO DE PIE DERECHO"
  },
  {
    "codigo":213173006,
    "descripcion":"FALLA PARCIAL DE REIMPLANTE DE MIEMBRO INFERIOR"
  },
  {
    "codigo":49333008,
    "descripcion":"FETO INMADURO"
  },
  {
    "codigo":1163445008,
    "descripcion":"HIPERSENSIBILIDAD AL POLISORBATO 80"
  },
  {
    "codigo":735626000,
    "descripcion":"ANORGASMIA SITUACIONAL ADQUIRIDA"
  },
  {
    "codigo":442549008,
    "descripcion":"RESPIRACIÓN PERIÓDICA DURANTE EL SUEÑO POR ALTURA ELEVADA"
  },
  {
    "codigo":276874005,
    "descripcion":"NEOPLASIA INTRAEPITELIAL DE VULVA, GRADO 2"
  },
  {
    "codigo":440714005,
    "descripcion":"INFECCIÓN GENITAL POR HERPES SIMPLEX TIPO 1"
  },
  {
    "codigo":211338005,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE MUSLO"
  },
  {
    "codigo":111199007,
    "descripcion":"PÚRPURA PIGMENTARIA CRÓNICA"
  },
  {
    "codigo":830260004,
    "descripcion":"ALERGIA A INMUNOGLOBULINA"
  },
  {
    "codigo":109364007,
    "descripcion":"NEUMOTÓRAX IZQUIERDO"
  },
  {
    "codigo":764724007,
    "descripcion":"PARÁLISIS DE CUERDA VOCAL IZQUIERDA"
  },
  {
    "codigo":240436009,
    "descripcion":"ACTINOMICOSIS PARAMANDIBULAR"
  },
  {
    "codigo":1156105001,
    "descripcion":"DOLOR EN SACRO"
  },
  {
    "codigo":238601002,
    "descripcion":"PSORIASIS INESTABLE"
  },
  {
    "codigo":369673004,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA DE PLEURA: PARED TORÁCICA EXTRAPLEURAL, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":402441007,
    "descripcion":"COMPROMISO BUCAL POR PENFIGOIDE DE MEMBRANA MUCOSA"
  },
  {
    "codigo":203998000,
    "descripcion":"MIELOCISTOCELE LUMBAR"
  },
  {
    "codigo":40158001,
    "descripcion":"SÍNDROME DE PAPILLON - LEFÈVRE"
  },
  {
    "codigo":271369007,
    "descripcion":"NACIDO EN PARTO CON FÓRCEPS INTERMEDIO"
  },
  {
    "codigo":105694003,
    "descripcion":"ENFERMEDAD CAUSADA POR ANCYLOSTOMATOIDEA"
  },
  {
    "codigo":762889007,
    "descripcion":"OBSTRUCCIÓN DE TROMPA DE FALOPIO IZQUIERDA"
  },
  {
    "codigo":366003000,
    "descripcion":"EXPRESIÓN FACIAL - HALLAZGO"
  },
  {
    "codigo":1187038009,
    "descripcion":"DISCAPACIDAD INTELECTUAL SINDRÓMICA INESPECÍFICA"
  },
  {
    "codigo":236766009,
    "descripcion":"EPIDIDIMITIS GONOCÓCICA"
  },
  {
    "codigo":15935621000119100,
    "descripcion":"DEFORMIDAD EN FLEXIÓN DE AMBAS ARTICULACIONES DE REGIÓN DE MUÑECA"
  },
  {
    "codigo":202163005,
    "descripcion":"ARTROFITO EN ARTICULACIÓN DEL PIE"
  },
  {
    "codigo":759950981000119101,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DEBIDO A TROMBOSIS DE ARTERIA VERTEBRAL IZQUIERDA"
  },
  {
    "codigo":135301000119103,
    "descripcion":"PARASOMNIA CAUSADA POR ALCOHOL"
  },
  {
    "codigo":340101000119100,
    "descripcion":"QUISTE DE GLÁNDULA LAGRIMAL IZQUIERDA"
  },
  {
    "codigo":309381000119105,
    "descripcion":"NECROSIS AVASCULAR DE TIBIA DERECHA"
  },
  {
    "codigo":337541000119105,
    "descripcion":"PÉRDIDA SÚBITA DE LA VISIÓN DEL OJO IZQUIERDO"
  },
  {
    "codigo":298632003,
    "descripcion":"AMPLITUD DE FLEXIÓN LATERAL PASIVA HACIA LA DERECHA DE LA COLUMNA VERTEBRAL LUMBAR, DISMINUIDA"
  },
  {
    "codigo":317061000119108,
    "descripcion":"REUMATISMO PALINDRÓMICO DE REGIÓN DE ARTICULACIÓN DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":16823941000119108,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE ESTROMA GASTROINTESTINAL, DE PÁNCREAS"
  },
  {
    "codigo":299141000119105,
    "descripcion":"HEMARTROSIS DE MANO DERECHA"
  },
  {
    "codigo":38323006,
    "descripcion":"SÍNDROME FETAL POR WARFARINA"
  },
  {
    "codigo":1279837000,
    "descripcion":"CATARATA CONGÉNITA CON MICROCÓRNEA Y OPACIDAD CORNEAL"
  },
  {
    "codigo":12400261000119105,
    "descripcion":"DOLOR CRÓNICO POSTERIOR A ARTROPLASTIA TOTAL DE RODILLA IZQUIERDA"
  },
  {
    "codigo":724616009,
    "descripcion":"OCCIPITALIZACIÓN DEL ATLAS"
  },
  {
    "codigo":306821000119108,
    "descripcion":"GOTA DE VÉRTEBRA CAUSADA POR FÁRMACO"
  },
  {
    "codigo":1079941000119109,
    "descripcion":"NEVO EPIDÉRMICO DE PIEL DE EXTREMIDAD INFERIOR IZQUIERDA"
  },
  {
    "codigo":722781002,
    "descripcion":"ESTOMATITIS AFTOSA RECURRENTE"
  },
  {
    "codigo":1148765006,
    "descripcion":"CARDITIS CRÓNICA DEBIDA A CARDIOPATÍA REUMÁTICA"
  },
  {
    "codigo":296797005,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE ISONIAZIDA"
  },
  {
    "codigo":131122001,
    "descripcion":"VITAMINA K2 POR ENCIMA DE RANGO DE REFERENCIA"
  },
  {
    "codigo":294962003,
    "descripcion":"ALERGIA A COLESTIRAMINA"
  },
  {
    "codigo":286331000119109,
    "descripcion":"CONEXIÓN VENOSA PULMONAR TOTALMENTE ANÓMALA A SENO CORONARIO"
  },
  {
    "codigo":196658005,
    "descripcion":"ÚLCERA DUODENAL AGUDA CON OBSTRUCCIÓN"
  },
  {
    "codigo":293127000,
    "descripcion":"REACCIÓN ADVERSA A COMPONENTE DE VACUNA QUE CONTIENE ANTÍGENO DE HAEMOPHILUS INFLUENZAE TIPO B"
  },
  {
    "codigo":1145095005,
    "descripcion":"AUSENCIA DE PESTAÑAS DE ÁNGULO INTERNO DE PÁRPADO"
  },
  {
    "codigo":63751007,
    "descripcion":"SÍFILIS SECUNDARIA DE HUESO"
  },
  {
    "codigo":194823009,
    "descripcion":"INSUFICIENCIA CORONARIA AGUDA"
  },
  {
    "codigo":94684003,
    "descripcion":"MICROBLEFARIA"
  },
  {
    "codigo":717276003,
    "descripcion":"SÍNDROME CONVULSIVO SENSIBLE A ÁCIDO FOLÍNICO"
  },
  {
    "codigo":125617002,
    "descripcion":"LUXACIÓN TRAUMÁTICA DE ARTICULACIÓN DE CODO"
  },
  {
    "codigo":92849004,
    "descripcion":"FUSIÓN ANORMAL CONGÉNITA DE CENTRO DE VÉRTEBRA CERVICAL"
  },
  {
    "codigo":715441004,
    "descripcion":"SÍNDROME DE MCDONOUGH"
  },
  {
    "codigo":289457006,
    "descripcion":"ESCOTADURA SACROCIÁTICA ANGOSTA"
  },
  {
    "codigo":15634351000119102,
    "descripcion":"HALLAZGO MAMOGRÁFICO DE MASA BILATERAL DE MAMAS"
  },
  {
    "codigo":1172358003,
    "descripcion":"HIPERTROFIA GINGIVAL DEBIDA A SÍNDROME DE STURGE-WEBER"
  },
  {
    "codigo":58246004,
    "descripcion":"INTOXICACIÓN POR CONVALLARIA MAJALIS"
  },
  {
    "codigo":123782009,
    "descripcion":"DISGAMMAGLOBULINEMIA"
  },
  {
    "codigo":91014009,
    "descripcion":"INTOXICACIÓN CAUSADA POR AMINOFILINA"
  },
  {
    "codigo":54576000,
    "descripcion":"ESTEATORREA PANCREÁTICA"
  },
  {
    "codigo":449627008,
    "descripcion":"NEOPLASIA MALIGNA DE HUESO LARGO DE MIEMBRO INFERIOR"
  },
  {
    "codigo":218416003,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR HEXAMINA"
  },
  {
    "codigo":283952004,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DEL PENE"
  },
  {
    "codigo":251184005,
    "descripcion":"LATIDO DE FUSIÓN"
  },
  {
    "codigo":447792005,
    "descripcion":"CONDROSARCOMA DE HUESO"
  },
  {
    "codigo":249349008,
    "descripcion":"INEFICACIA PARA SONARSE LA NARIZ"
  },
  {
    "codigo":247514006,
    "descripcion":"MEDIA LUNA AZUL DE UÑA"
  },
  {
    "codigo":737199001,
    "descripcion":"HIPOGANGLIONOSIS ADQUIRIDA DE INTESTINO GRUESO"
  },
  {
    "codigo":15689801000119104,
    "descripcion":"ARTRITIS DE ARTICULACIÓN DE PIES BILATERAL CAUSADA POR STAPHYLOCOCCUS"
  },
  {
    "codigo":49071005,
    "descripcion":"PUERPERIO, 2 DÍAS"
  },
  {
    "codigo":276612004,
    "descripcion":"LACTANTE DE EXTREMADO BAJO PESO AL NACER"
  },
  {
    "codigo":47236005,
    "descripcion":"HEMORRAGIA DE TERCER ESTADIO"
  },
  {
    "codigo":763101411000119100,
    "descripcion":"CARCINOMA PRIMARIO DE CÉLULAS RENALES DE RIÑÓN IZQUIERDO"
  },
  {
    "codigo":1259652008,
    "descripcion":"COREA DEBIDO A SÍNDROME PARANEOPLÁSICO"
  },
  {
    "codigo":733529001,
    "descripcion":"CAMBIOS CELULARES REACTIVOS DEBIDOS A DISPOSITIVO ANTICONCEPTIVO INTRAUTERINO"
  },
  {
    "codigo":78169005,
    "descripcion":"SOBRERROTACIÓN FETAL"
  },
  {
    "codigo":373081007,
    "descripcion":"NEOPLASIA MALIGNA DE CUADRANTE INFEROEXTERNO DE MAMA"
  },
  {
    "codigo":405849008,
    "descripcion":"FENOTIPO FY(A+B+)"
  },
  {
    "codigo":274777009,
    "descripcion":"HALLAZGO RELACIONADO CON LA PRESENCIA DE COCAÍNA EN SANGRE"
  },
  {
    "codigo":698926003,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: TIBETANO"
  },
  {
    "codigo":43566003,
    "descripcion":"LESIÓN TRAUMÁTICA DE LOS ÓRGANOS GENITALES EXTERNOS MASCULINOS"
  },
  {
    "codigo":829998005,
    "descripcion":"BORDE HEPÁTICO PALPABLE EN LA LÍNEA MEDIA DEL ABDOMEN"
  },
  {
    "codigo":305710003,
    "descripcion":"ATENDIDO POR CIRUJANO ESPECIALISTA EN OTORRINOLARINGOLOGÍA"
  },
  {
    "codigo":1255982007,
    "descripcion":"SINOVITIS Y TENOSINOVITIS DE ARTICULACIÓN DE MUÑECA"
  },
  {
    "codigo":271107000,
    "descripcion":"AMPOLLA TRAUMÁTICA DE LA CARA"
  },
  {
    "codigo":404014008,
    "descripcion":"FIBROHISTIOCITOMA MALIGNO DE LA PIEL"
  },
  {
    "codigo":170968001,
    "descripcion":"PRONÓSTICO BUENO"
  },
  {
    "codigo":402179009,
    "descripcion":"AGRAVAMIENTO DE UN TRASTORNO POR LA LUZ"
  },
  {
    "codigo":860931009,
    "descripcion":"ALERGIA A CELULOSA Y \/O DERIVADO DE CELULOSA"
  },
  {
    "codigo":302040002,
    "descripcion":"CAPAZ DE SENTARSE SIN SOSTÉN"
  },
  {
    "codigo":72664005,
    "descripcion":"INTOXICACIÓN POR LIDNERIA"
  },
  {
    "codigo":236504007,
    "descripcion":"NEFRITIS DE HENOCH-SCHÖNLEIN"
  },
  {
    "codigo":300205000,
    "descripcion":"LOS OJOS GIRAN EN RESPUESTA AL SONIDO"
  },
  {
    "codigo":105432008,
    "descripcion":"HIJO DADO EN ADOPCIÓN"
  },
  {
    "codigo":38061003,
    "descripcion":"SOPLO CRANEAL"
  },
  {
    "codigo":365741006,
    "descripcion":"HALLAZGO RELACIONADO CON EL NIVEL DE FENOBARBITAL"
  },
  {
    "codigo":3458000,
    "descripcion":"POLIMIOSITIS OSIFICANTE"
  },
  {
    "codigo":167298001,
    "descripcion":"TRAZAS DE SANGRE NO HEMOLIZADA EN ORINA"
  },
  {
    "codigo":429442006,
    "descripcion":"DUPLICACIÓN AUTOSÓMICA"
  },
  {
    "codigo":394839000,
    "descripcion":"VALORES (COMUNIDAD)"
  },
  {
    "codigo":198231000,
    "descripcion":"ULCERACIÓN VULVAR EN LA ENFERMEDAD DE BEHCET"
  },
  {
    "codigo":72061000119104,
    "descripcion":"OSTEOMIELITIS DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":296535003,
    "descripcion":"SOBREDOSIS DE GRISEOFULVINA"
  },
  {
    "codigo":460375006,
    "descripcion":"ARTERIA COLATERAL QUE DERIVA EL FLUJO SISTÉMICO HACIA LA CIRCULACIÓN PULMONAR DESDE LA ARTERIA RENAL IZQUIERDA"
  },
  {
    "codigo":722519007,
    "descripcion":"SARCOMA PRIMARIO DE PERITONEO"
  },
  {
    "codigo":294700000,
    "descripcion":"ALERGIA A FLUTICASONA"
  },
  {
    "codigo":32556003,
    "descripcion":"ENFERMEDAD POR EL VIRUS WYEOMYIA"
  },
  {
    "codigo":425772008,
    "descripcion":"TENDINITIS DEL PIE"
  },
  {
    "codigo":292865001,
    "descripcion":"REACCIÓN ADVERSA A HIDRARGAFENO"
  },
  {
    "codigo":65324009,
    "descripcion":"LACERACIÓN MENOR DE HÍGADO SIN HERIDA ABIERTA HACIA CAVIDAD ABDOMINAL"
  },
  {
    "codigo":317821000119107,
    "descripcion":"ARTRITIS DE RODILLA IZQUIERDA CAUSADA POR STREPTOCOCCUS PNEUMONIAE"
  },
  {
    "codigo":16675351000119101,
    "descripcion":"ECOGRAFÍA DE RIÑÓN DERECHO ANORMAL"
  },
  {
    "codigo":30721006,
    "descripcion":"TEMBLOR INTENCIONAL"
  },
  {
    "codigo":718849008,
    "descripcion":"SÍNDROME NEURODEGENERATIVO LIGADO AL CROMOSOMA X TIPO BERTINI"
  },
  {
    "codigo":127190001,
    "descripcion":"LINFADENOPATÍA AXILAR EXTERNA"
  },
  {
    "codigo":717014003,
    "descripcion":"ENFERMEDAD DE CHARCOT-MARIE-TOOTH TIPO 2J AUTOSÓMICA DOMINANTE"
  },
  {
    "codigo":225494003,
    "descripcion":"USA ROPA INDIGNA"
  },
  {
    "codigo":94422005,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE MÚSCULO DE LA CADERA"
  },
  {
    "codigo":291030004,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR FLUNITRAZEPAM"
  },
  {
    "codigo":92587003,
    "descripcion":"CARCINOMA IN SITU DE TROMPA DE EUSTAQUIO"
  },
  {
    "codigo":59819007,
    "descripcion":"ULCERACIÓN HERPÉTICA DE LA VULVA"
  },
  {
    "codigo":289195008,
    "descripcion":"HABLA INCOMPRENSIBLE"
  },
  {
    "codigo":674481000119100,
    "descripcion":"HEMATOMA ESPONTÁNEO DE MÉDULA ESPINAL"
  },
  {
    "codigo":254592008,
    "descripcion":"POLIPOSIS LINFOIDE BENIGNA DEL INTESTINO"
  },
  {
    "codigo":713344009,
    "descripcion":"ENFERMEDAD GINGIVAL DEBIDA A LESIÓN TRAUMÁTICA"
  },
  {
    "codigo":10750641000119101,
    "descripcion":"PARO CARDÍACO DEBIDO A INTENTO FALLIDO DE ABORTO"
  },
  {
    "codigo":416597004,
    "descripcion":"LEPRA RESISTENTE A LA DAPSONA"
  },
  {
    "codigo":182961000119101,
    "descripcion":"ENCEFALOMIELITIS DISEMINADA AGUDA CONSECUTIVA A ENFERMEDAD INFECCIOSA"
  },
  {
    "codigo":1137493006,
    "descripcion":"CALCIFICACIÓN PUNTEADA DE EPÍFISIS DE PRIMER HUESO METATARSIANO"
  },
  {
    "codigo":285525004,
    "descripcion":"INCAPAZ DE MOVER LA LENGUA REPETIDAMENTE"
  },
  {
    "codigo":15665841000119102,
    "descripcion":"CATARATA CAPSULAR CONGÉNITA DE OJO DERECHO"
  },
  {
    "codigo":414762001,
    "descripcion":"CADENAS PESADAS ALFA MONOCLONALES PRESENTE"
  },
  {
    "codigo":185386002,
    "descripcion":"SOLICITUD DE INGRESO - INVESTIGACIÓN"
  },
  {
    "codigo":15747761000119103,
    "descripcion":"MASA DE MÚSCULO BILATERAL DE EXTREMIDADES SUPERIORES"
  },
  {
    "codigo":283690007,
    "descripcion":"MORDEDURA HUMANA EN LA REGIÓN OCULAR"
  },
  {
    "codigo":54314008,
    "descripcion":"SÍNDROME DE PUTTI - CHAVANY"
  },
  {
    "codigo":609535006,
    "descripcion":"HIPERSENSIBILIDAD NO ALÉRGICA A HETALMIDÓN"
  },
  {
    "codigo":871679007,
    "descripcion":"REACCIÓN ADVERSA A NITROPRUSIATO"
  },
  {
    "codigo":281855006,
    "descripcion":"HEMATURIA FRANCA PERSISTENTE"
  },
  {
    "codigo":312788000,
    "descripcion":"SUBLUXACIÓN VERTEBRAL CON LESIÓN MEDULAR A NIVEL LUMBAR"
  },
  {
    "codigo":249087006,
    "descripcion":"POSICIÓN MENTOPOSTERIOR DIRECTA"
  },
  {
    "codigo":247252006,
    "descripcion":"DISPOSITIVO PARA VENTILACIÓN TIMPÁNICA EN CONDUCTO AUDITIVO EXTERNO"
  },
  {
    "codigo":1197524007,
    "descripcion":"ESCLEROSIS LATERAL AMIOTRÓFICA TIPO 1 AUTOSÓMICA RECESIVA"
  },
  {
    "codigo":771540008,
    "descripcion":"MENINGITIS DEBIDA A BLOQUEO NERVIOSO NEUROAXIAL CENTRAL Y POSTERIOR A ÉL"
  },
  {
    "codigo":442025000,
    "descripcion":"EXACERBACIÓN AGUDA DE BRONQUITIS ASMÁTICA CRÓNICA"
  },
  {
    "codigo":83412009,
    "descripcion":"ABSCESO PERIODONTAL"
  },
  {
    "codigo":81577001,
    "descripcion":"ANOMALÍA CONGÉNITA DE LA VENA CAVA INFERIOR"
  },
  {
    "codigo":704169000,
    "descripcion":"FRACTURA PATOLÓGICA DE COSTILLA"
  },
  {
    "codigo":16041008,
    "descripcion":"SÍNDROME DE HIPOGONADISMO FEMENINO"
  },
  {
    "codigo":1259390007,
    "descripcion":"CARCINOMA PRIMARIO DE PREPUCIO"
  },
  {
    "codigo":210814008,
    "descripcion":"LESIÓN DE VASOS SANGUÍNEOS ILÍACOS"
  },
  {
    "codigo":733267004,
    "descripcion":"MÚLTIPLES LESIONES TRAUMÁTICAS SUPERFICIALES DE MUSLO"
  },
  {
    "codigo":241747006,
    "descripcion":"INTOXICACIÓN POR METFORMINA"
  },
  {
    "codigo":12371008,
    "descripcion":"OFTALMÍA NODOSA"
  },
  {
    "codigo":405587009,
    "descripcion":"PERFORACIÓN TRAUMÁTICA DE VEJIGA URINARIA"
  },
  {
    "codigo":45139008,
    "descripcion":"EDAD GESTACIONAL, 29 SEMANAS"
  },
  {
    "codigo":698664004,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: INTERLINGUA"
  },
  {
    "codigo":403752005,
    "descripcion":"REACCIÓN CUTÁNEA ADVERSA A MEDICINA HOMEOPÁTICA"
  },
  {
    "codigo":130021000119100,
    "descripcion":"CELULITIS DE MEMBRANA MUCOSA NASAL"
  },
  {
    "codigo":305448007,
    "descripcion":"BAJO ATENCIÓN DE HIPNOTERAPEUTA"
  },
  {
    "codigo":238077000,
    "descripcion":"HIPERCOLESTEROLEMIA POLIGÉNICA"
  },
  {
    "codigo":239912009,
    "descripcion":"SÍNDROME DE SJÖGREN PRIMARIO"
  },
  {
    "codigo":320331000119107,
    "descripcion":"ARTROSIS SECUNDARIA DE CODO IZQUIERDO"
  },
  {
    "codigo":293861000119102,
    "descripcion":"SÍNDROME DEL TÚNEL CARPIANO DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":762365008,
    "descripcion":"AVULSIÓN TRAUMÁTICA DE OJO DERECHO"
  },
  {
    "codigo":39634006,
    "descripcion":"HIPERPLASIA EPITELIAL FOCAL DE LA LENGUA"
  },
  {
    "codigo":400082007,
    "descripcion":"TRASTORNO DE PIEL DE CABEZA"
  },
  {
    "codigo":234407001,
    "descripcion":"DEFICIENCIA DE URIDINA MONOFOSFATO HIDROLASA"
  },
  {
    "codigo":365479002,
    "descripcion":"DETALLES DE LOS PROPIOS HIJOS - HALLAZGO"
  },
  {
    "codigo":201639003,
    "descripcion":"CONDROCALCINOSIS DE REGIÓN DE HOMBRO CAUSADA POR CRISTALES DE PIROFOSFATO"
  },
  {
    "codigo":299943004,
    "descripcion":"SENSACIÓN DE POSICIÓN ARTICULAR NORMAL"
  },
  {
    "codigo":403080000,
    "descripcion":"TIÑA CAUSADA POR TRICHOPHYTON MENTAGROPHYTES"
  },
  {
    "codigo":68732003,
    "descripcion":"ESTADO NO VIRGINAL"
  },
  {
    "codigo":35964007,
    "descripcion":"ANOMALÍA CONGÉNITA DE UÑA"
  },
  {
    "codigo":724092009,
    "descripcion":"SÍNDROME DE NEFROSIS, SORDERA Y MALFORMACIONES DE LA VÍA URINARIA Y DIGITALES"
  },
  {
    "codigo":34129005,
    "descripcion":"PERICONDRITIS DE PABELLÓN DE LA OREJA"
  },
  {
    "codigo":1361009,
    "descripcion":"LEUCOCORIA"
  },
  {
    "codigo":294438002,
    "descripcion":"ALERGIA A BENZALCONIO"
  },
  {
    "codigo":32294004,
    "descripcion":"QUEMADURA PROFUNDA DE TERCER GRADO DE PIERNA"
  },
  {
    "codigo":63227001,
    "descripcion":"INFECCIÓN CAUSADA POR DIORCHIS"
  },
  {
    "codigo":423675002,
    "descripcion":"DIFICULTAD PARA CUMPLIR UNA RUTINA DE EJERCICIOS DESPUÉS DEL PARTO"
  },
  {
    "codigo":1144571008,
    "descripcion":"HIPOPLASIA CONGÉNITA DE MÚSCULO DE PARED ABDOMINAL"
  },
  {
    "codigo":21631000119105,
    "descripcion":"ISQUEMIA DE MIEMBRO"
  },
  {
    "codigo":292603008,
    "descripcion":"REACCIÓN ADVERSA A LA LODOXAMIDA"
  },
  {
    "codigo":1306576000,
    "descripcion":"CARCINOMA DUCTAL INFILTRANTE DE MAMA DERECHA"
  },
  {
    "codigo":349311000119106,
    "descripcion":"GLAUCOMA SECUNDARIO DEBIDO A AFAQUIA DE AMBOS OJOS"
  },
  {
    "codigo":15723801000119100,
    "descripcion":"HIPERTROFIA DE MEMBRANA SINOVIAL DE ARTICULACIÓN DE AMBAS MANOS"
  },
  {
    "codigo":94160007,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA CORTEZA SUPRARRENAL"
  },
  {
    "codigo":1086591000119107,
    "descripcion":"HEMORRAGIA DE COLON SIGMOIDE CONCOMITANTE CON DIVERTICULOSIS Y DEBIDA A ELLA"
  },
  {
    "codigo":92325007,
    "descripcion":"NEOPLASIA BENIGNA DE LOS GANGLIOS LINFÁTICOS RETROFARÍNGEOS"
  },
  {
    "codigo":288933008,
    "descripcion":"NO ELIMINA RESIDUOS DE LA BOCA"
  },
  {
    "codigo":385402001,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA BRONQUIAL AFECTADO POR CARCINOMA IN SITU DE CÉLULAS ESCAMOSAS"
  },
  {
    "codigo":1237370002,
    "descripcion":"CAPA DE FIBRA NERVIOSA MIELINIZADA DE RETINA"
  },
  {
    "codigo":10671231000119109,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN EN CADERA IZQUIERDA NO ESTADIFICABLE"
  },
  {
    "codigo":57722009,
    "descripcion":"ERITROCITO SENSIBILIZADO"
  },
  {
    "codigo":23119003,
    "descripcion":"LESIÓN TRAUMÁTICA DE LOS NERVIOS SUPERFICIALES DE LA CABEZA Y\/O DEL CUELLO"
  },
  {
    "codigo":285263006,
    "descripcion":"PENSAMIENTOS DE VIOLENCIA"
  },
  {
    "codigo":1335987009,
    "descripcion":"MELANOMA DESMOPLÁSICO MALIGNO METASTÁSICO"
  },
  {
    "codigo":283428002,
    "descripcion":"CORTE EN LOS GENITALES"
  },
  {
    "codigo":709412006,
    "descripcion":"TRASTORNO CONGÉNITO DE LA GLUCOSILACIÓN TIPO 1C"
  },
  {
    "codigo":86820007,
    "descripcion":"ENFERMEDAD ENDÉMICA"
  },
  {
    "codigo":840484006,
    "descripcion":"CONJUNTIVITIS CAUSADA POR ACANTHAMOEBA"
  },
  {
    "codigo":707577004,
    "descripcion":"INFERTILIDAD FEMENINA DEBIDA A FIBROSIS QUÍSTICA"
  },
  {
    "codigo":248825005,
    "descripcion":"ARÉOLAS DE DIFERENTE TAMAÑO"
  },
  {
    "codigo":773113008,
    "descripcion":"HEPATITIS AGUDA CAUSADA POR INFECCIÓN"
  },
  {
    "codigo":246990002,
    "descripcion":"CÁMARA ANTERIOR OCULAR DE PROFUNDIDAD INTERMEDIA"
  },
  {
    "codigo":83150005,
    "descripcion":"DERMATITIS DE CONTACTO CAUSADA POR YODO"
  },
  {
    "codigo":1197262006,
    "descripcion":"ADENOMA PLEOMORFO DE APARATO LAGRIMAL"
  },
  {
    "codigo":132531000119105,
    "descripcion":"TROMBOSIS CRÓNICA DE VENA SUPERFICIAL DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":865912001,
    "descripcion":"EXACERBACIÓN DE ÚLCERA PÉPTICA"
  },
  {
    "codigo":1259128002,
    "descripcion":"ENFERMEDAD DE ALZHEIMER CON PSICOSIS"
  },
  {
    "codigo":472696003,
    "descripcion":"SUTURA FLOJA DE INJERTO DE CÓRNEA"
  },
  {
    "codigo":308856004,
    "descripcion":"DISPLASIA GRAVE DE ESTÓMAGO"
  },
  {
    "codigo":1089101000119100,
    "descripcion":"COLESTEATOMA DEL OÍDO MEDIO IZQUIERDO"
  },
  {
    "codigo":896845000,
    "descripcion":"FORMA TRIANGULAR ANORMAL CONGÉNITA DE EPÍFISIS DE FALANGE DE MANO"
  },
  {
    "codigo":276088008,
    "descripcion":"OBJECIÓN DE CONCIENCIA"
  },
  {
    "codigo":208717002,
    "descripcion":"FRACTURA EXPUESTA DE FALANGE DISTAL DE DEDO DEL PIE"
  },
  {
    "codigo":700237005,
    "descripcion":"SUPRAERUPCIÓN DE DIENTE"
  },
  {
    "codigo":77645007,
    "descripcion":"MENINGITIS POR SALMONELLA"
  },
  {
    "codigo":765773009,
    "descripcion":"ATROFIA DE RIÑÓN IZQUIERDO"
  },
  {
    "codigo":403490003,
    "descripcion":"LUPUS ERITEMATOSO CUTÁNEO SUBAGUDO, TIPO PAPULOESCAMOSO"
  },
  {
    "codigo":272418005,
    "descripcion":"TUMOR PEQUEÑO"
  },
  {
    "codigo":237815000,
    "descripcion":"PUBARQUIA PRECOZ"
  },
  {
    "codigo":73975000,
    "descripcion":"DEFICIENCIA DE FACTOR II"
  },
  {
    "codigo":41207000,
    "descripcion":"NEUMONÍA POR ADENOVIRUS"
  },
  {
    "codigo":1351927007,
    "descripcion":"ALERGIA A CARNE ROJA DEBIDA A SÍNDROME DE ALFA-GALACTOSIDASA"
  },
  {
    "codigo":679501000119105,
    "descripcion":"LESIÓN VASCULAR DE PÁRPADO INFERIOR IZQUIERDO"
  },
  {
    "codigo":235980000,
    "descripcion":"FILTRACIÓN POR ANASTOMOSIS DE PÁNCREAS"
  },
  {
    "codigo":1153484001,
    "descripcion":"BICARBONATO SÉRICO POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":301516000,
    "descripcion":"CAPAZ DE SALIR DE LA DUCHA"
  },
  {
    "codigo":234145005,
    "descripcion":"FÍSTULA ARTERIOVENOSA DIFUSA"
  },
  {
    "codigo":70305005,
    "descripcion":"SOBREMORDIDA HORIZONTAL"
  },
  {
    "codigo":365217007,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA ACOMODARSE LA VESTIMENTA PARA IR AL BAÑO"
  },
  {
    "codigo":135841008,
    "descripcion":"ECCEMA SECO"
  },
  {
    "codigo":723830005,
    "descripcion":"SÍNDROME DE QUERATOSIS FOLICULAR, ENANISMO Y ATROFIA CEREBRAL"
  },
  {
    "codigo":363382005,
    "descripcion":"NEOPLASIA MALIGNA DE ENCÍA"
  },
  {
    "codigo":232310008,
    "descripcion":"INFECCIÓN CON COMPROMISO DEL OÍDO INTERNO"
  },
  {
    "codigo":296011000,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE CLONAZEPAM"
  },
  {
    "codigo":230475002,
    "descripcion":"CEFALEA CRÓNICA EN SALVAS QUE SE MANIFIESTA A PARTIR DE LA FORMA EPISÓDICA"
  },
  {
    "codigo":197707007,
    "descripcion":"SÍNDROME NEFRÍTICO CRÓNICO"
  },
  {
    "codigo":425248002,
    "descripcion":"ATENCIÓN DISPERSA"
  },
  {
    "codigo":785696007,
    "descripcion":"SÍNDROME DE MALABSORCIÓN DEBIDO A INTOLERANCIA A LA LACTOSA"
  },
  {
    "codigo":95733001,
    "descripcion":"QUERATITIS EOSINOFÍLICA"
  },
  {
    "codigo":1177077002,
    "descripcion":"DACRIOADENITIS POR PROTOZOOS"
  },
  {
    "codigo":12203751000119107,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DE REGIÓN DORSAL DE MANO IZQUIERDA"
  },
  {
    "codigo":1144309007,
    "descripcion":"CICATRIZ CUTÁNEA POSINFLAMATORIA"
  },
  {
    "codigo":290506002,
    "descripcion":"INTOXICACIÓN POR ENFLURANO"
  },
  {
    "codigo":93898002,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE GLÁNDULAS ENDOCRINAS MÚLTIPLES"
  },
  {
    "codigo":224970002,
    "descripcion":"SE SIENTE HERIDO"
  },
  {
    "codigo":126666006,
    "descripcion":"ÚLCERA DE LA FARINGE"
  },
  {
    "codigo":1306314008,
    "descripcion":"NEOPLASIA DE PEZÓN"
  },
  {
    "codigo":716490009,
    "descripcion":"COMPRENDE EL IDIOMA"
  },
  {
    "codigo":419743001,
    "descripcion":"RUPTURA DE LA MEMBRANA DE DESCEMET POR TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":26527006,
    "descripcion":"POSICIÓN DE TRENDELENBURG INVERSA"
  },
  {
    "codigo":92063006,
    "descripcion":"NEOPLASIA BENIGNA DEL CUERPO COCCÍGEO"
  },
  {
    "codigo":24692002,
    "descripcion":"EFECTO TÓXICO DEL FOSGENO"
  },
  {
    "codigo":712820006,
    "descripcion":"PSEUDOATROFIA CEREBRAL"
  },
  {
    "codigo":286836007,
    "descripcion":"CARÁCTER EXCÉNTRICO"
  },
  {
    "codigo":88393000,
    "descripcion":"SÍNDROME DE SANFILIPPO"
  },
  {
    "codigo":285001001,
    "descripcion":"DIFICULTAD PARA ABROCHAR LA ROPA"
  },
  {
    "codigo":254068007,
    "descripcion":"OPSISMODISPLASIA"
  },
  {
    "codigo":250398002,
    "descripcion":"ANTÍGENO TIPO H"
  },
  {
    "codigo":86558004,
    "descripcion":"CONO DE PRESIÓN CEREBELOSA"
  },
  {
    "codigo":283166005,
    "descripcion":"CUERPO EXTRAÑO METÁLICO EN EL TRONCO"
  },
  {
    "codigo":447006007,
    "descripcion":"RECIDIVA DE TUBERCULOSIS PULMONAR"
  },
  {
    "codigo":414238007,
    "descripcion":"INFERTILIDAD FEMENINA POR ANTICUERPOS CONTRA LOS ESPERMATOZOIDES"
  },
  {
    "codigo":84723001,
    "descripcion":"TORTÍCOLIS INFANTIL POR FIJACIÓN ROTATORIA ATLANTOAXOIDEA"
  },
  {
    "codigo":53790008,
    "descripcion":"PELVIS PICUDA"
  },
  {
    "codigo":1004062009,
    "descripcion":"CONTRACTURA EN FLEXIÓN DE ARTICULACIÓN INTERFALÁNGICA DISTAL DE QUINTO DEDO DE PIE"
  },
  {
    "codigo":838387004,
    "descripcion":"ABSCESO DE ESPACIO SUBDURAL ESPINAL CAUSADO POR MYCOBACTERIUM"
  },
  {
    "codigo":248563007,
    "descripcion":"HEMITÓRAX INMÓVIL"
  },
  {
    "codigo":281331007,
    "descripcion":"SE ESPECIFICAN DETALLES CLÍNICOS INSUFICIENTES"
  },
  {
    "codigo":1197000007,
    "descripcion":"MASA EN ÍLEON"
  },
  {
    "codigo":50120008,
    "descripcion":"EQUILIBRIO ACIDOBÁSICO ANORMAL QUE AFECTA EL MANEJO DE LA SITUACIÓN MATERNA"
  },
  {
    "codigo":410568009,
    "descripcion":"OPACIFICACIÓN DE CÁPSULA ANTERIOR POSTERIOR A EXTRACCIÓN DE CATARATA"
  },
  {
    "codigo":48285002,
    "descripcion":"INSULTOS"
  },
  {
    "codigo":443336007,
    "descripcion":"PATRÓN NEOPLÁSICO TIPO COMEDÓN"
  },
  {
    "codigo":246728009,
    "descripcion":"ESTRABISMO CONVERGENTE MANIFIESTO ALTERNANTE"
  },
  {
    "codigo":279496009,
    "descripcion":"ERUPCIÓN VARICELIFORME DE KAPOSI CAUSADA POR VIRUS HERPES SIMPLE"
  },
  {
    "codigo":212125006,
    "descripcion":"QUEMADURA QUE COMPROMETE MÁS DEL 90 POR CIENTO DE LA SUPERFICIE CORPORAL, CON MÁS DEL 90 POR CIENTO DE SUPERFICIE CORPORAL CON QUEMADURA DE TERCER GRADO"
  },
  {
    "codigo":769181007,
    "descripcion":"RETINOPATÍA PREPROLIFERATIVA DEL OJO DERECHO DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":15974581000119103,
    "descripcion":"LIPOMAS BILATERALES DE MIEMBROS INFERIORES"
  },
  {
    "codigo":110151001,
    "descripcion":"LESIÓN SUPERFICIAL DE LA BOCA"
  },
  {
    "codigo":306759008,
    "descripcion":"INCAPAZ DE PRODUCIR SONIDOS SORDOS"
  },
  {
    "codigo":75548002,
    "descripcion":"OOFORITIS POR VIRUS DE LA PAROTIDITIS URLIANA"
  },
  {
    "codigo":42780004,
    "descripcion":"LOBULACIÓN CONGÉNITA DEL BAZO"
  },
  {
    "codigo":403228004,
    "descripcion":"FOTOSUBTIPO CUTÁNEO IIIB (AL COMIENZO SIEMPRE EXISTE QUEMADURA, A VECES BRONCEADO MODERADO)"
  },
  {
    "codigo":303089000,
    "descripcion":"HIPERHIDROSIS AXILAR"
  },
  {
    "codigo":1351665003,
    "descripcion":"AGAMMAGLOBULINEMIA AUTOSÓMICA RECESIVA DEBIDA A DEFICIENCIA DE TRANSPORTADOR DE SOLUTOS DE FAMILIA 39 MIEMBRO 7"
  },
  {
    "codigo":434161005,
    "descripcion":"PICO DE ESTADO DE ESTRÉS CARDÍACO"
  },
  {
    "codigo":399558000,
    "descripcion":"TUMOR PRESENTE A 1 MM DE LA PAPILA ÓPTICA"
  },
  {
    "codigo":170182000,
    "descripcion":"EXAMEN A LOS 15 AÑOS ANORMAL - PARA OBSERVACIÓN"
  },
  {
    "codigo":301254001,
    "descripcion":"OBSTRUCCIÓN PARCIAL DE LAS VÍAS AÉREAS DURANTE LA ESPIRACIÓN"
  },
  {
    "codigo":233883000,
    "descripcion":"PERICARDITIS BACTERIANA"
  },
  {
    "codigo":70043001,
    "descripcion":"TRASTORNO GRAVE DEL ESTADO DE ÁNIMO CON SÍNTOMAS PSICÓTICOS, INCONGRUENTE CON EL ESTADO DE ÁNIMO"
  },
  {
    "codigo":364955003,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD DE SELLAR LOS LABIOS"
  },
  {
    "codigo":168347008,
    "descripcion":"ORGANISMO NO AISLADO EN CULTIVO DE HISOPADO VAGINAL ALTO"
  },
  {
    "codigo":299419009,
    "descripcion":"DEFORMIDAD DE ARTICULACIÓN DE TOBILLO FIJA EN FLEXIÓN"
  },
  {
    "codigo":461424004,
    "descripcion":"FÍSTULA DE ARTERIA CORONARIA CON DILATACIÓN DE ARTERIA CORONARIA PROXIMAL Y SIN DILATACIÓN DE ARTERIA CORONARIA DISTAL"
  },
  {
    "codigo":15675881000119100,
    "descripcion":"TENDINITIS CALCIFICANTE BILATERAL DE MUSLOS"
  },
  {
    "codigo":232048009,
    "descripcion":"OCLUSIÓN DE RAMA VENOSA RETINIANA CON EDEMA MACULAR"
  },
  {
    "codigo":262981001,
    "descripcion":"RUPTURA DE TENDÓN DE MÚSCULO GEMELO"
  },
  {
    "codigo":295749002,
    "descripcion":"SOBREDOSIS INTENCIONAL DE PROCARBAZINA"
  },
  {
    "codigo":230213004,
    "descripcion":"ABSCESO CEREBRAL CANDIDIÁSICO"
  },
  {
    "codigo":293914003,
    "descripcion":"ALERGIA A SULPIRIDA"
  },
  {
    "codigo":228378005,
    "descripcion":"FUMA DROGAS EN FORMA DE CIGARRILLO"
  },
  {
    "codigo":29935003,
    "descripcion":"FIBROSIS DEL CORDÓN ESPERMÁTICO"
  },
  {
    "codigo":62703006,
    "descripcion":"ENDOCARDITIS CON ANEURISMA INFECCIOSO"
  },
  {
    "codigo":95471008,
    "descripcion":"MALFORMACIÓN ARTERIOVENOSA CONGÉNITA DEL TRACTO GASTROINTESTINAL"
  },
  {
    "codigo":128239009,
    "descripcion":"LESIÓN TRAUMÁTICA DEL SISTEMA NERVIOSO"
  },
  {
    "codigo":880068004,
    "descripcion":"DEFORMIDAD EN VARO DE TIBIA"
  },
  {
    "codigo":93636004,
    "descripcion":"MELANOMA MALIGNO DE LA PIEL DE LA MANO"
  },
  {
    "codigo":290244005,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR FELBINACO"
  },
  {
    "codigo":124569006,
    "descripcion":"DEFICIENCIA DE DIPEPTIDILPÉPTIDO HIDROLASA"
  },
  {
    "codigo":59033006,
    "descripcion":"ANOMALÍA DEL PAR DE CROMOSOMAS 18"
  },
  {
    "codigo":288409007,
    "descripcion":"NO ENROSCA UNA TAPA"
  },
  {
    "codigo":253806000,
    "descripcion":"APLASIA DE VESÍCULA"
  },
  {
    "codigo":89966002,
    "descripcion":"HEMATOMA DEL ESCROTO"
  },
  {
    "codigo":417646006,
    "descripcion":"DISFUNCIÓN SOMÁTICA DE COLUMNA VERTEBRAL SACRA"
  },
  {
    "codigo":186435004,
    "descripcion":"INFECCIÓN BACTERIANA CAUSADA POR KLEBSIELLA PNEUMONIAE"
  },
  {
    "codigo":282904001,
    "descripcion":"NO SE LEVANTA DESDE POSICIÓN DE CUCLILLAS"
  },
  {
    "codigo":303901000119100,
    "descripcion":"GOTA TOFÁCEA CRÓNICA DE CODO DEBIDA A DISFUNCIÓN RENAL"
  },
  {
    "codigo":250136008,
    "descripcion":"DISPARADOR EN TENDÓN"
  },
  {
    "codigo":84461004,
    "descripcion":"EXENCEFALIA"
  },
  {
    "codigo":281069007,
    "descripcion":"DIVERTÍCULO SOLITARIO DEL CIEGO"
  },
  {
    "codigo":248301008,
    "descripcion":"AUMENTO DE LA GRASA CORPORAL"
  },
  {
    "codigo":51693009,
    "descripcion":"AUSENCIA CONGÉNITA DE LA PRÓSTATA"
  },
  {
    "codigo":1264109008,
    "descripcion":"AMPOLLA TRAUMÁTICA DE DEDO MEÑIQUE"
  },
  {
    "codigo":770754006,
    "descripcion":"SÍNDROME DE MICRODELECIÓN 2P21 SIN CISTINURIA"
  },
  {
    "codigo":1293207004,
    "descripcion":"MELANOMA LENTIGINOSO DE MUCOSAS"
  },
  {
    "codigo":441239008,
    "descripcion":"INCAPAZ DE LEER LOS LABIOS"
  },
  {
    "codigo":13420004,
    "descripcion":"OTITIS MEDIA SECUNDARIA A SARAMPIÓN"
  },
  {
    "codigo":767084007,
    "descripcion":"EL PRIMER VASO CONTIENE PARTÍCULAS O SEDIMENTO"
  },
  {
    "codigo":699713000,
    "descripcion":"PRÓTESIS DENTAL MANDIBULAR PARCIAL REMOVIBLE DEFECTUOSA"
  },
  {
    "codigo":109889007,
    "descripcion":"CARCINOMA DUCTAL IN SITU DE MAMA"
  },
  {
    "codigo":208193008,
    "descripcion":"FRACTURA EXPUESTA DE PELVIS, ESPINA ILÍACA ANTEROSUPERIOR"
  },
  {
    "codigo":77121009,
    "descripcion":"SÍNDROME LINFOPROLIFERATIVO LIGADO AL CROMOSOMA X"
  },
  {
    "codigo":9750001,
    "descripcion":"ÚLCERA DEL ESCROTO"
  },
  {
    "codigo":206358003,
    "descripcion":"CANDIDIASIS INTESTINAL NEONATAL"
  },
  {
    "codigo":304662004,
    "descripcion":"DIFICULTAD PARA EMPLEAR RAZONAMIENTO ARITMÉTICO"
  },
  {
    "codigo":239126004,
    "descripcion":"MALFORMACIÓN PILOSA DE LAS PALMAS Y LAS PLANTAS"
  },
  {
    "codigo":75286007,
    "descripcion":"OSTEOMIELITIS DEL BRAZO"
  },
  {
    "codigo":827115000,
    "descripcion":"OFTALMOPLEJÍA EXTERNA PROGRESIVA AUTOSÓMICA DOMINANTE"
  },
  {
    "codigo":1187563003,
    "descripcion":"ENFERMEDAD DE CHARCOT MARIE TOOTH AUTOSÓMICA RECESIVA TIPO 2X"
  },
  {
    "codigo":270059004,
    "descripcion":"PACIENTE REGISTRADO - FP32"
  },
  {
    "codigo":1161000175101,
    "descripcion":"CONSUMO DE ALCOHOL DISMINUIDO"
  },
  {
    "codigo":202688001,
    "descripcion":"ESPONDILOSIS DORSAL CON RADICULOPATÍA"
  },
  {
    "codigo":300992002,
    "descripcion":"ATAXIA CEREBELOSA ALCOHÓLICA"
  },
  {
    "codigo":169920004,
    "descripcion":"PUNTAJE DE APGAR A LOS 5 MINUTOS = 10"
  },
  {
    "codigo":366528004,
    "descripcion":"AMPLITUD DE MOVIMIENTO DE EXTENSIÓN PASIVA DE LA MUÑECA - HALLAZGO"
  },
  {
    "codigo":299157001,
    "descripcion":"AMPLITUD DE EXTENSIÓN PASIVA DEL PULGAR NORMAL"
  },
  {
    "codigo":233621003,
    "descripcion":"NEUMONÍA POR RICKETTSIAS"
  },
  {
    "codigo":725141006,
    "descripcion":"ATELOSTEOGÉNESIS TIPO 1"
  },
  {
    "codigo":397461007,
    "descripcion":"TUMOR QUE INVADE DIAFRAGMA"
  },
  {
    "codigo":87121000119102,
    "descripcion":"GLIOMA MALIGNO DE CEREBELO"
  },
  {
    "codigo":102549009,
    "descripcion":"CALAMBRE EN PIERNA ASOCIADO CON REPOSO"
  },
  {
    "codigo":723306004,
    "descripcion":"SÍNDROME DE NEURONOPATÍA SENSITIVA Y MOTRIZ DE COMIENZO FACIAL"
  },
  {
    "codigo":262719002,
    "descripcion":"HEMORRAGIA SUBARACNOIDEA TRAUMÁTICA DE MÉDULA ESPINAL"
  },
  {
    "codigo":721471004,
    "descripcion":"SÍNDROME DEL CORDÓN POSTERIOR DE MÉDULA ESPINAL AL NIVEL DEL TERCER SEGMENTO DORSAL"
  },
  {
    "codigo":295487009,
    "descripcion":"SOBREDOSIS DE ANTIESPASMÓDICO"
  },
  {
    "codigo":293652004,
    "descripcion":"ALERGIA A NIZATIDINA"
  },
  {
    "codigo":129812004,
    "descripcion":"DIFERENCIA EN LOS BORDES SEGÚN LA MAMOGRAFÍA"
  },
  {
    "codigo":160745002,
    "descripcion":"VIVE EN ALBERGUES"
  },
  {
    "codigo":291817004,
    "descripcion":"INTOXICACIÓN INTENCIONAL CAUSADA POR GLIBENCLAMIDA"
  },
  {
    "codigo":95209008,
    "descripcion":"LEUCEMIA PLASMOCÍTICA EN REMISIÓN"
  },
  {
    "codigo":191678001,
    "descripcion":"CONFUSIÓN REACTIVA"
  },
  {
    "codigo":93374002,
    "descripcion":"DESALINEAMIENTO CONGÉNITO DEL ARCO DE LA VÉRTEBRA LUMBAR"
  },
  {
    "codigo":11775211000119102,
    "descripcion":"LACERACIÓN DE TENDÓN DE BRAZO DERECHO"
  },
  {
    "codigo":289982004,
    "descripcion":"NO USA ARTÍCULOS DE TOCADOR"
  },
  {
    "codigo":419219000,
    "descripcion":"NÁUSEAS Y VÓMITOS CAUSADOS POR FÁRMACO"
  },
  {
    "codigo":27838008,
    "descripcion":"ARTERIA RETINIANA EN HILO DE PLATA"
  },
  {
    "codigo":224446009,
    "descripcion":"ACTITUD DE LOS EMPLEADORES ANTE UN PROBLEMA DE SALUD"
  },
  {
    "codigo":56261000087103,
    "descripcion":"CON MAYOR RIESGO DE TRASTORNO DEPRESIVO"
  },
  {
    "codigo":124307007,
    "descripcion":"DEFICIENCIA DE GLUCONOCINASA"
  },
  {
    "codigo":253544001,
    "descripcion":"ANEURISMA CONGÉNITO DEL VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":286312002,
    "descripcion":"DIFICULTAD PARA UTILIZAR CONSONANTES INDIVIDUALES"
  },
  {
    "codigo":1269352003,
    "descripcion":"HIPERSENSIBILIDAD A SUCCINILCOLINA"
  },
  {
    "codigo":40901000087106,
    "descripcion":"QUEMADURA DE OJO IZQUIERDO PROPIAMENTE DICHO"
  },
  {
    "codigo":38341000087106,
    "descripcion":"HIPOCINESIA DE SEGMENTO ANTERIOR MEDIO DE VENTRÍCULO CARDÍACO IZQUIERDO"
  },
  {
    "codigo":89704006,
    "descripcion":"UÑAS PUNTEADAS"
  },
  {
    "codigo":384616005,
    "descripcion":"MARGEN QUIRÚRGICO PROXIMAL NO AFECTADO POR CARCINOMA IN SITU"
  },
  {
    "codigo":448317000,
    "descripcion":"LINFOMA NO HODGKIN FOLICULAR DE PARTES BLANDAS"
  },
  {
    "codigo":284477001,
    "descripcion":"INDIGENTE"
  },
  {
    "codigo":43461000087105,
    "descripcion":"HERIDA ABIERTA DE PÁRPADO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":218941003,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR FENOLFTALEÍNA"
  },
  {
    "codigo":48581000087108,
    "descripcion":"ESGUINCE DE LIGAMENTO SACROTUBERAL IZQUIERDO"
  },
  {
    "codigo":365149002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA INSERTAR UN OBJETO DENTRO DE OTRO"
  },
  {
    "codigo":34181000119102,
    "descripcion":"INFARTO CEREBRAL DEBIDO A OCLUSIÓN DE ARTERIA BASILAR"
  },
  {
    "codigo":249874004,
    "descripcion":"INCAPAZ DE SACAR LA LENGUA COMPLETAMENTE"
  },
  {
    "codigo":282642005,
    "descripcion":"SE AGACHA"
  },
  {
    "codigo":1296615000,
    "descripcion":"HIPERTENSIÓN OCULAR DE OJO DERECHO DEBIDA A PSEUDOEXFOLIACIÓN"
  },
  {
    "codigo":1362151001,
    "descripcion":"HIPOPLASIA CONGÉNITA DE TRACTO CORTICOESPINAL"
  },
  {
    "codigo":315410009,
    "descripcion":"NACIDO EN CUBA"
  },
  {
    "codigo":248039009,
    "descripcion":"CONDUCTA PROVOCADORA"
  },
  {
    "codigo":278972002,
    "descripcion":"NO INMUNE A HEPATITIS A"
  },
  {
    "codigo":335391000119100,
    "descripcion":"FIBROSIS SUBRETINIANA DIFUSA DE OJO DERECHO"
  },
  {
    "codigo":735889007,
    "descripcion":"DISTENSIÓN DE SEGUNDO A QUINTO DEDOS DE PIE"
  },
  {
    "codigo":373606000,
    "descripcion":"ACCIDENTE CEREBROVASCULAR OCLUSIVO"
  },
  {
    "codigo":47761007,
    "descripcion":"ENFERMEDAD DE BRILL - ZINSSER"
  },
  {
    "codigo":766822004,
    "descripcion":"CONFUSIÓN CON RESPECTO A LA ORIENTACIÓN SEXUAL"
  },
  {
    "codigo":209766006,
    "descripcion":"RUPTURA DEL FLEXOR LARGO DEL PULGAR"
  },
  {
    "codigo":13158007,
    "descripcion":"FÍSTULA DE LA VENTANA REDONDA"
  },
  {
    "codigo":305543001,
    "descripcion":"BAJO ATENCIÓN DE NEUROCIRUJANO"
  },
  {
    "codigo":275302008,
    "descripcion":"AGRANDAMIENTO PROSTÁTICO, DETECTADO POR TACTO RECTAL"
  },
  {
    "codigo":207931005,
    "descripcion":"FRACTURA EXPUESTA DE VÉRTEBRA CERVICAL, ESPONDILÓLISIS"
  },
  {
    "codigo":240699006,
    "descripcion":"PRURITO DE MALABAR"
  },
  {
    "codigo":109627009,
    "descripcion":"HIPERPLASIA DE ENCÍA RETROMOLAR"
  },
  {
    "codigo":271632004,
    "descripcion":"HALLAZGO EN LA PERCUSIÓN DEL TÓRAX"
  },
  {
    "codigo":238864005,
    "descripcion":"FIBROMATOSIS AGRESIVA INFANTIL"
  },
  {
    "codigo":402704005,
    "descripcion":"ANOMALÍA DEL DESARROLLO DE CONDUCTO VITELINO"
  },
  {
    "codigo":1285605001,
    "descripcion":"HEMATOMA DE REGIÓN DE MUÑECA"
  },
  {
    "codigo":7653001,
    "descripcion":"DIFICULTAD PARA ALIMENTARSE POR SÍ MISMO"
  },
  {
    "codigo":105957005,
    "descripcion":"DIETA LÍQUIDA Y\/O BLANDA"
  },
  {
    "codigo":366266000,
    "descripcion":"HALLAZGO RELACIONADO CON DISTENSIBILIDAD DE VEJIGA URINARIA"
  },
  {
    "codigo":298895000,
    "descripcion":"SIN AMPLITUD ACTIVA DE EXTENSIÓN DE CODO"
  },
  {
    "codigo":429967001,
    "descripcion":"CRIPTOTIA"
  },
  {
    "codigo":266127002,
    "descripcion":"SÍFILIS PRIMARIA"
  },
  {
    "codigo":724879005,
    "descripcion":"TEMOR A ENFERMEDAD CUTÁNEA"
  },
  {
    "codigo":167823007,
    "descripcion":"EXAMEN DEL VÓMITO, NORMAL"
  },
  {
    "codigo":297060000,
    "descripcion":"SOBREDOSIS DE AGENTE INOTRÓPICO CARDÍACO"
  },
  {
    "codigo":36751008,
    "descripcion":"ENFERMEDAD POR VIRUS KOUTANGO"
  },
  {
    "codigo":231524005,
    "descripcion":"TRASTORNO DE COMPORTAMIENTO INTERICTAL"
  },
  {
    "codigo":1149028005,
    "descripcion":"NEUROPATÍA INTERSTICIAL HIPERTRÓFICA DE NERVIO TRIGÉMINO"
  },
  {
    "codigo":34916006,
    "descripcion":"ALTERACIÓN EN LA MOTILIDAD DEL NEUTRÓFILO"
  },
  {
    "codigo":721209004,
    "descripcion":"QUISTE PARAFIMBRIAL ADQUIRIDO DE TROMPA DE FALOPIO"
  },
  {
    "codigo":313005,
    "descripcion":"DÉJÀ VU"
  },
  {
    "codigo":459065005,
    "descripcion":"ATRESIA CONGÉNITA DE TRONCO DE ARTERIA CORONARIA IZQUIERDA"
  },
  {
    "codigo":11777721000119108,
    "descripcion":"RUPTURA TRAUMÁTICA DE TENDÓN DE MÚSCULO INFRAESPINOSO IZQUIERDO"
  },
  {
    "codigo":293390000,
    "descripcion":"REACCIÓN ADVERSA A LAS VITAMINAS HIDROSOLUBLES"
  },
  {
    "codigo":1145358001,
    "descripcion":"LESIÓN HIPERINTENSA DE TÁLAMO EN IMAGEN DE RESONANCIA MAGNÉTICA EN T2"
  },
  {
    "codigo":719374006,
    "descripcion":"CAPAZ DE COMPRENDER INSTRUCCIONES DE UNA PARTE"
  },
  {
    "codigo":29411000,
    "descripcion":"ESPECTADOR EN ACCIDENTE DURANTE ACTIVIDAD DEPORTIVA"
  },
  {
    "codigo":162318009,
    "descripcion":"CRISIS VITAL"
  },
  {
    "codigo":94947002,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE MÚSCULO DE LA PELVIS"
  },
  {
    "codigo":193251003,
    "descripcion":"MIOPATÍA POR SARCOIDOSIS"
  },
  {
    "codigo":291555001,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR PIPERACILINA"
  },
  {
    "codigo":160483002,
    "descripcion":"GRUPO SOCIAL 2 - GERENCIAL"
  },
  {
    "codigo":715704001,
    "descripcion":"POLIDACTILIA POSTAXIAL TIPO A"
  },
  {
    "codigo":93112002,
    "descripcion":"FALTA DE OSIFICACIÓN DE HUESO PARIETAL"
  },
  {
    "codigo":781240002,
    "descripcion":"TENDINITIS DE LA PATA DE GANSO DERECHA"
  },
  {
    "codigo":289720004,
    "descripcion":"CONTRACCIONES UTERINAS MUY FUERTES"
  },
  {
    "codigo":1010616001,
    "descripcion":"CIRROSIS HEPÁTICA DEBIDA A FIBROSIS QUÍSTICA CLÁSICA"
  },
  {
    "codigo":713869000,
    "descripcion":"ENFERMEDAD CONGÉNITA POR DEPÓSITO DE CRISTALES DE PIROFOSFATO DE CALCIO DIHIDRATO"
  },
  {
    "codigo":27576009,
    "descripcion":"SECRECIÓN NORMAL DE GLÁNDULA EXOCRINA"
  },
  {
    "codigo":1141688009,
    "descripcion":"DEMUESTRA CONOCIMIENTO SOBRE ANTICONCEPCIÓN"
  },
  {
    "codigo":224184008,
    "descripcion":"SALARIO PAGADO ANUALMENTE"
  },
  {
    "codigo":1303693000,
    "descripcion":"ATEROSCLEROSIS DE ARTERIA CORONARIA DERECHA"
  },
  {
    "codigo":124045001,
    "descripcion":"FOSFOLÍPIDO POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":449890002,
    "descripcion":"SÍNDROME DE DOLOR ABDOMINAL FUNCIONAL"
  },
  {
    "codigo":286050003,
    "descripcion":"LAVA LA ROPA SUCIA"
  },
  {
    "codigo":253282005,
    "descripcion":"VENTRÍCULO DERECHO CON DOBLE TRACTO DE ENTRADA"
  },
  {
    "codigo":284215000,
    "descripcion":"QUEMADURA SUPERFICIAL DE LA ESPALDA POR AGENTE CORROSIVO"
  },
  {
    "codigo":448055000,
    "descripcion":"HEMANGIOMA DE CUELLO"
  },
  {
    "codigo":251447002,
    "descripcion":"ACTIVIDAD DOMINANTE BETA"
  },
  {
    "codigo":87607002,
    "descripcion":"ENFERMEDAD DE PELIZAEUS - MERZBACHER, FORMA CLÁSICA"
  },
  {
    "codigo":1075181000119104,
    "descripcion":"DEFORMIDAD ADQUIRIDA EN CAVOVARO DE PIE DERECHO"
  },
  {
    "codigo":415287001,
    "descripcion":"LEUCEMIA MIELOIDE CRÓNICA RECIDIVANTE"
  },
  {
    "codigo":184076002,
    "descripcion":"EL PACIENTE PUEDE NO REGISTRARSE"
  },
  {
    "codigo":20236002,
    "descripcion":"TRABAJO DE PARTO EN CURSO"
  },
  {
    "codigo":446220004,
    "descripcion":"SÍNDROME QUEIRO-ORAL"
  },
  {
    "codigo":249612005,
    "descripcion":"HALLAZGO EN LA MATERIA FECAL"
  },
  {
    "codigo":708364005,
    "descripcion":"NOROVIRUS GI Y GII DETECTADOS"
  },
  {
    "codigo":1263585001,
    "descripcion":"VARIANTE FRONTAL NO AMNÉSICA DE ENFERMEDAD DE ALZHEIMER"
  },
  {
    "codigo":51169003,
    "descripcion":"MENINGITIS NEUMOCÓCICA"
  },
  {
    "codigo":444385008,
    "descripcion":"DISPUESTO A SER DONANTE DE CORAZÓN"
  },
  {
    "codigo":213174000,
    "descripcion":"FALLA PARCIAL DE REIMPLANTE DE PIERNA"
  },
  {
    "codigo":83937008,
    "descripcion":"INFECCIÓN CAUSADA POR BABESIA BOVIS"
  },
  {
    "codigo":16639981000119109,
    "descripcion":"COMPRESIÓN DE AMBOS NERVIOS RADIALES"
  },
  {
    "codigo":409782005,
    "descripcion":"TUMOR QUE INVADE PIEL"
  },
  {
    "codigo":211339002,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE RODILLA"
  },
  {
    "codigo":276875006,
    "descripcion":"NEOPLASIA INTRAEPITELIAL VULVAR, GRADO 3"
  },
  {
    "codigo":735627009,
    "descripcion":"ANORGASMIA GENERALIZADA PERMANENTE"
  },
  {
    "codigo":111200005,
    "descripcion":"ELASTOSIS NODULAR CON QUISTES Y COMEDONES DE FAVRE Y RACOUCHOT"
  },
  {
    "codigo":16040071000119106,
    "descripcion":"GOTA TOFÁCEA CRÓNICA DE AMBAS MANOS"
  },
  {
    "codigo":240437000,
    "descripcion":"ACTINOMICOSIS SUBMAXILAR"
  },
  {
    "codigo":76597001,
    "descripcion":"FRACTURA DE BENNETT EXPUESTA"
  },
  {
    "codigo":11061003,
    "descripcion":"TRASTORNO POR CONSUMO DE SUSTANCIA PSICOACTIVA"
  },
  {
    "codigo":43829003,
    "descripcion":"ARTROSIS CRÓNICA"
  },
  {
    "codigo":699189004,
    "descripcion":"CIRROSIS INFANTIL DE LOS INDÍGENAS DE NORTEAMÉRICA"
  },
  {
    "codigo":402442000,
    "descripcion":"PENFIGOIDE CICATRIZAL TIPO BRUNSTING-PERRY"
  },
  {
    "codigo":1354549008,
    "descripcion":"AGENESIA DE PALADAR BLANDO"
  },
  {
    "codigo":205834002,
    "descripcion":"ACARDIA"
  },
  {
    "codigo":762890003,
    "descripcion":"OBSTRUCCIÓN DE TROMPA DE FALOPIO DERECHA"
  },
  {
    "codigo":764725008,
    "descripcion":"SÍNDROME DE MICRODELECIÓN 9P13"
  },
  {
    "codigo":369674005,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA ESOFÁGICO, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":74762003,
    "descripcion":"INFECCIÓN CAUSADA POR UNCINARIA STENOCEPHALA"
  },
  {
    "codigo":271370008,
    "descripcion":"PARTOS POR EXTRACCIÓN DE NALGAS"
  },
  {
    "codigo":238602009,
    "descripcion":"PSORIASIS CON ECCEMA"
  },
  {
    "codigo":1187039001,
    "descripcion":"SÍNDROME DE LABIO LEPORINO Y PALADAR HENDIDO, DISMORFIA CRANEOFACIAL, DEFECTO CARDÍACO CONGÉNITO E HIPOACUSIA"
  },
  {
    "codigo":105695002,
    "descripcion":"ENFERMEDAD CAUSADA POR PROTOSTRONGYLOIDEA"
  },
  {
    "codigo":236767000,
    "descripcion":"EPIDIDIMITIS POR CLAMIDIA"
  },
  {
    "codigo":40159009,
    "descripcion":"MACROSTOMÍA CONGÉNITA"
  },
  {
    "codigo":7391009,
    "descripcion":"RASGO DE HEMOGLOBINA D"
  },
  {
    "codigo":71092004,
    "descripcion":"COMUNIDAD DE RETIRO"
  },
  {
    "codigo":366004006,
    "descripcion":"GRITO - HALLAZGO"
  },
  {
    "codigo":724617000,
    "descripcion":"SÍNFISIS PÚBICA ANCHA CONGÉNITA"
  },
  {
    "codigo":298633008,
    "descripcion":"SIN AMPLITUD DE FLEXIÓN LATERAL PASIVA HACIA LA DERECHA DE LA COLUMNA VERTEBRAL LUMBAR"
  },
  {
    "codigo":1279838005,
    "descripcion":"NEUROPATÍA SENSITIVA AUTONÓMICA HEREDITARIA TIPO 6"
  },
  {
    "codigo":1148766007,
    "descripcion":"ENFERMEDAD DENTAL HEREDITARIA"
  },
  {
    "codigo":67422008,
    "descripcion":"FRACTURA NO EXPUESTA DE PRIMER HUESO CUNEIFORME DE TARSO"
  },
  {
    "codigo":65587001,
    "descripcion":"ANOMALÍA CONGÉNITA DEL SISTEMA CEREBROVASCULAR"
  },
  {
    "codigo":32819004,
    "descripcion":"CIRCUNFERENCIA DE MUSLO AUMENTADA"
  },
  {
    "codigo":10678111000119101,
    "descripcion":"ÚLCERA DE DORSO"
  },
  {
    "codigo":1075551000119102,
    "descripcion":"INESTABILIDAD DE ARTICULACIÓN DE LA RODILLA DERECHA"
  },
  {
    "codigo":16013151000119102,
    "descripcion":"TROMBOSIS DE ARTERIA FEMORAL COMÚN IZQUIERDA"
  },
  {
    "codigo":115551000119104,
    "descripcion":"QUISTE SEBÁCEO DE PENE"
  },
  {
    "codigo":15990111000119104,
    "descripcion":"CATARATA SECUNDARIA DE OJO IZQUIERDO"
  },
  {
    "codigo":10637151000119101,
    "descripcion":"ÚLCERA POR PRESIÓN EN NALGA ESTADIO IV"
  },
  {
    "codigo":340831000119101,
    "descripcion":"ATROFIA ESENCIAL DE IRIS IZQUIERDO"
  },
  {
    "codigo":16002911000119108,
    "descripcion":"DOLOR CRÓNICO DE PIE IZQUIERDO"
  },
  {
    "codigo":1080671000119108,
    "descripcion":"LIPOMA DE MIEMBRO INFERIOR DERECHO"
  },
  {
    "codigo":16054111000119108,
    "descripcion":"DISPLASIA GLENOIDEA CONGÉNITA DE ESCÁPULA IZQUIERDA"
  },
  {
    "codigo":322911000119102,
    "descripcion":"DEDO MAYOR IZQUIERDO EN GATILLO ADQUIRIDO"
  },
  {
    "codigo":30984008,
    "descripcion":"INTOXICACIÓN POR PENTOBARBITAL"
  },
  {
    "codigo":11830111000119104,
    "descripcion":"HEMATOMA DE REGIÓN DE RODILLA IZQUIERDA"
  },
  {
    "codigo":72031000119107,
    "descripcion":"DESNUTRICIÓN SEVERA DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":15926111000119107,
    "descripcion":"DEFORMIDAD EN FLEXIÓN DE ARTICULACIÓN DE REGIÓN DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":683871000119109,
    "descripcion":"NEVO EPIDÉRMICO DE CUELLO"
  },
  {
    "codigo":947256671000119109,
    "descripcion":"ENDOMETRIOSIS DE CONDUCTO INGUINAL"
  },
  {
    "codigo":16302431000119109,
    "descripcion":"LESIÓN DE HUESO DE BRAZO IZQUIERDO"
  },
  {
    "codigo":94685002,
    "descripcion":"MICRODACTILIA"
  },
  {
    "codigo":16206421000119101,
    "descripcion":"RUPTURA TRAUMÁTICA DE MANGUITO ROTADOR DE AMBOS HOMBROS"
  },
  {
    "codigo":289458001,
    "descripcion":"ESCOTADURA SACROCIÁTICA REDONDEADA"
  },
  {
    "codigo":61917005,
    "descripcion":"HEMIANOPSIA BITEMPORAL"
  },
  {
    "codigo":92850004,
    "descripcion":"FUSIÓN ANORMAL CONGÉNITA DEL CENTRO DE LA VÉRTEBRA LUMBAR"
  },
  {
    "codigo":715442006,
    "descripcion":"SINDACTILIA DE DEDOS DE LA MANO TIPO 8"
  },
  {
    "codigo":191154007,
    "descripcion":"ANEMIA POR DEFICIENCIA COMBINADA DE VITAMINA B 12 Y FOLATOS"
  },
  {
    "codigo":254855000,
    "descripcion":"TUMOR EPITELIAL MIXTO DE OVARIO"
  },
  {
    "codigo":125618007,
    "descripcion":"LUXACIÓN TRAUMÁTICA DE ARTICULACIÓN DE MUÑECA"
  },
  {
    "codigo":25479004,
    "descripcion":"CUERPO EXTRAÑO EN LA FARINGE"
  },
  {
    "codigo":1336199009,
    "descripcion":"TRASTORNO POR USO DE ESTIMULANTE"
  },
  {
    "codigo":449628003,
    "descripcion":"NEOPLASIA MALIGNA DE HUESO LARGO DE PIERNA"
  },
  {
    "codigo":21809000,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE ANO SIN INFECCIÓN"
  },
  {
    "codigo":253020008,
    "descripcion":"HIDRADENOMA CUTÁNEO"
  },
  {
    "codigo":251185006,
    "descripcion":"LATIDO DE ESCAPE"
  },
  {
    "codigo":183814000,
    "descripcion":"ESTADO DE FONDOS DE ADMISIÓN"
  },
  {
    "codigo":283953009,
    "descripcion":"QUEMADURA DEL ESCROTO"
  },
  {
    "codigo":18139000,
    "descripcion":"FRACTURA DE FISURA DE DIENTE"
  },
  {
    "codigo":247515007,
    "descripcion":"PLIEGUE UNGUEAL - HALLAZGO"
  },
  {
    "codigo":737200003,
    "descripcion":"TRASTORNO VASCULAR DE INTESTINO GRUESO"
  },
  {
    "codigo":47237001,
    "descripcion":"INTOXICACIÓN POR VITAMINA A"
  },
  {
    "codigo":373082000,
    "descripcion":"NEOPLASIA MALIGNA DE CUADRANTE SUPEROINTERNO DE MAMA"
  },
  {
    "codigo":276613009,
    "descripcion":"ALTO PESO DE NACIMIENTO"
  },
  {
    "codigo":274778004,
    "descripcion":"HALLAZGO RELACIONADO CON LA PRESENCIA DE UN ALUCINÓGENO EN SANGRE"
  },
  {
    "codigo":209242004,
    "descripcion":"FRACTURA-LUXACIÓN EXPUESTA DE ARTICULACIÓN DE HOMBRO"
  },
  {
    "codigo":16016111000119109,
    "descripcion":"ARTRITIS DE AMBAS ARTICULACIONES SUBASTRAGALINAS"
  },
  {
    "codigo":405850008,
    "descripcion":"FENOTIPO FY(A-)"
  },
  {
    "codigo":764463001,
    "descripcion":"SÍNDROME DE TRISOMÍA 12 MOSAICO"
  },
  {
    "codigo":829999002,
    "descripcion":"HIPEREMIA DE AMBAS AMÍGDALAS PALATINAS"
  },
  {
    "codigo":305711004,
    "descripcion":"ATENDIDO POR CIRUJANO ENDOCRINÓLOGO"
  },
  {
    "codigo":698927007,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: TONGANO"
  },
  {
    "codigo":404015009,
    "descripcion":"HISTIOCITOMA FIBROSO MALIGNO SUPERFICIAL CUTÁNEO"
  },
  {
    "codigo":41732004,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE LA AXILA, SIN INFECCIÓN"
  },
  {
    "codigo":271108005,
    "descripcion":"AMPOLLA TRAUMÁTICA DEL CUELLO"
  },
  {
    "codigo":302041003,
    "descripcion":"SE SIENTA SIN SOSTÉN"
  },
  {
    "codigo":105433003,
    "descripcion":"MATRIMONIO HOMOSEXUAL"
  },
  {
    "codigo":7129008,
    "descripcion":"ÚLCERA DE TESTÍCULO"
  },
  {
    "codigo":726190000,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO INTRÍNSECO DE PULGAR"
  },
  {
    "codigo":170969009,
    "descripcion":"PRONÓSTICO MALO"
  },
  {
    "codigo":5294002,
    "descripcion":"TRASTORNO DEL DESARROLLO"
  },
  {
    "codigo":236505008,
    "descripcion":"GLOMERULONEFRITIS CRIOGLOBULINÉMICA"
  },
  {
    "codigo":38062005,
    "descripcion":"CRECIMIENTO NORMAL DEL PELO"
  },
  {
    "codigo":300206004,
    "descripcion":"SOBRESALTO EN RESPUESTA AL SONIDO"
  },
  {
    "codigo":15635491000119102,
    "descripcion":"RECIÉN NACIDO GRANDE PARA LA EDAD GESTACIONAL"
  },
  {
    "codigo":365742004,
    "descripcion":"NIVEL SÉRICO DE FENOBARBITAL - HALLAZGO"
  },
  {
    "codigo":298371006,
    "descripcion":"ARTICULACIÓN TEMPOROMANDIBULAR ESTABLE"
  },
  {
    "codigo":68995007,
    "descripcion":"ESQUIZOFRENIA CATATÓNICA CRÓNICA"
  },
  {
    "codigo":167299009,
    "descripcion":"TRAZAS DE SANGRE HEMOLIZADA DETECTADAS EN ORINA"
  },
  {
    "codigo":722520001,
    "descripcion":"INFECCIÓN NO ULCEROSA DE TRANSMISIÓN SEXUAL CAUSADA POR CHLAMYDIA TRACHOMATIS"
  },
  {
    "codigo":296536002,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE GRISEOFULVINA"
  },
  {
    "codigo":294701001,
    "descripcion":"ALERGIA A MOMETASONA"
  },
  {
    "codigo":720685006,
    "descripcion":"ATENDIDO POR ENFERMERA ESPECIALIZADA EN DIABETES"
  },
  {
    "codigo":292866000,
    "descripcion":"REACCIÓN ADVERSA A LA POLINOXILINA"
  },
  {
    "codigo":1144834002,
    "descripcion":"INTOXICACIÓN INTENCIONAL CAUSADA POR VALPROATO"
  },
  {
    "codigo":129026007,
    "descripcion":"INDEPENDENCIA PARA REALIZAR LAS COMPRAS"
  },
  {
    "codigo":94423000,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE MÚSCULO DE LA REGIÓN INGUINAL"
  },
  {
    "codigo":192727001,
    "descripcion":"ENCEFALITIS POSINFECCIOSA"
  },
  {
    "codigo":225495002,
    "descripcion":"USA VARIAS CAPAS DE ROPA"
  },
  {
    "codigo":127191002,
    "descripcion":"LINFADENOPATÍA AXILAR CENTRAL"
  },
  {
    "codigo":718850008,
    "descripcion":"DISTROFIA MUSCULAR DE LAS CINTURAS DE LAS EXTREMIDADES TIPO 2E AUTOSÓMICA RECESIVA"
  },
  {
    "codigo":15936701000119105,
    "descripcion":"ERISIPELA DE EXTREMIDAD INFERIOR DERECHA"
  },
  {
    "codigo":27052006,
    "descripcion":"PALUDISMO POR PLASMODIUM VIVAX"
  },
  {
    "codigo":92588008,
    "descripcion":"CARCINOMA IN SITU DEL HOCICO DE TENCA"
  },
  {
    "codigo":289196009,
    "descripcion":"HALLAZGO RELACIONADO CON LA FLUIDEZ DEL HABLA"
  },
  {
    "codigo":189057002,
    "descripcion":"NEOPLASIA BENIGNA DE LA PIEL AURICULAR"
  },
  {
    "codigo":254593003,
    "descripcion":"POLIPOSIS METAPLÁSICA DEL INTESTINO"
  },
  {
    "codigo":90753004,
    "descripcion":"ESQUISTOSOMIASIS HEPÁTICA"
  },
  {
    "codigo":10939581000119107,
    "descripcion":"HERIDA ABIERTA DE REGIÓN DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":1303169006,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO INTRÍNSECO DE DEDO ÍNDICE"
  },
  {
    "codigo":16673981000119108,
    "descripcion":"ESGUINCE DE LIGAMENTO DE ARTICULACIÓN TEMPOROMANDIBULAR IZQUIERDA"
  },
  {
    "codigo":187222000,
    "descripcion":"MIASIS NASOFARÍNGEA"
  },
  {
    "codigo":713345005,
    "descripcion":"DESPRENDIMIENTO PARCIAL DE RETINA"
  },
  {
    "codigo":285526003,
    "descripcion":"MUEVE LA PUNTA DE LA LENGUA REPETIDAMENTE"
  },
  {
    "codigo":673111000119103,
    "descripcion":"ARTRITIS INFECCIOSA DE ARTICULACIÓN DE COLUMNA VERTEBRAL"
  },
  {
    "codigo":386824000,
    "descripcion":"REACCIÓN ADAPTATIVA DE LA INFANCIA"
  },
  {
    "codigo":1332267005,
    "descripcion":"DISECCIÓN DE ARTERIA SUBCLAVIA"
  },
  {
    "codigo":283691006,
    "descripcion":"MORDEDURA HUMANA EN LA REGIÓN AURICULAR"
  },
  {
    "codigo":414763006,
    "descripcion":"PARAPROTEÍNA DETECTADA"
  },
  {
    "codigo":249088001,
    "descripcion":"POSICIÓN MENTOILÍACA TRANSVERSA"
  },
  {
    "codigo":85248005,
    "descripcion":"TRASTORNO BIPOLAR EN REMISIÓN"
  },
  {
    "codigo":281856007,
    "descripcion":"HEMATURIA FRANCA RECURRENTE"
  },
  {
    "codigo":609536007,
    "descripcion":"HIPERSENSIBILIDAD NO ALÉRGICA A DEXTRAN"
  },
  {
    "codigo":247253001,
    "descripcion":"TUBO DE VENTILACIÓN EN EL TÍMPANO"
  },
  {
    "codigo":183552008,
    "descripcion":"DERIVADO AL URÓLOGO"
  },
  {
    "codigo":1363200008,
    "descripcion":"FRACTURA NO EXPUESTA EN ESTALLIDO DE ÓRBITA"
  },
  {
    "codigo":1082711000119108,
    "descripcion":"HEMORRAGIA GÁSTRICA DEBIDA A ANGIODISPLASIA DE ESTÓMAGO"
  },
  {
    "codigo":12115441000119102,
    "descripcion":"QUEMADURA QUÍMICA DE PIE DERECHO"
  },
  {
    "codigo":442026004,
    "descripcion":"MASA DE DEDO DEL PIE"
  },
  {
    "codigo":704170004,
    "descripcion":"FRACTURA PATOLÓGICA DE RADIO"
  },
  {
    "codigo":345431000119109,
    "descripcion":"EVERSIÓN DE PUNTO LAGRIMAL DE AMBOS PÁRPADOS"
  },
  {
    "codigo":48810007,
    "descripcion":"LEUCOPLASIA DE LA PIEL"
  },
  {
    "codigo":46975003,
    "descripcion":"TRASTORNO MENTAL ORGÁNICO INDUCIDO POR COCAÍNA"
  },
  {
    "codigo":1259391006,
    "descripcion":"CISTOADENOCARCIMOMA PRIMARIO DE RIÑÓN"
  },
  {
    "codigo":241748001,
    "descripcion":"INTOXICACIÓN CAUSADA POR DROGAS ANALGÉSICAS"
  },
  {
    "codigo":12372001,
    "descripcion":"ENFERMEDAD POR EL VIRUS APEU"
  },
  {
    "codigo":405588004,
    "descripcion":"ESTENOSIS DE ARTERIA DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":11787761000119106,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE DEDO MEDIO DE MANO DERECHA CON INFECCIÓN"
  },
  {
    "codigo":403753000,
    "descripcion":"REACCIÓN CUTÁNEA ADVERSA A ACUPUNTURA"
  },
  {
    "codigo":733268009,
    "descripcion":"LACERACIÓN DE CADERA CON CUERPO EXTRAÑO"
  },
  {
    "codigo":370985002,
    "descripcion":"ATENDIDO POR UN MÉDICO LOCAL"
  },
  {
    "codigo":698665003,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: INUKTITUT"
  },
  {
    "codigo":305449004,
    "descripcion":"BAJO ATENCIÓN DE OSTEÓPATA"
  },
  {
    "codigo":318961000119108,
    "descripcion":"ARTRITIS REUMATOIDEA SEROPOSITIVA DE ARTICULACIÓN DE REGIÓN DE HOMBRO DERECHO"
  },
  {
    "codigo":372481521000119108,
    "descripcion":"OSTEOCONDROSIS JUVENIL DE AMBAS TIBIAS PROXIMALES"
  },
  {
    "codigo":238078005,
    "descripcion":"HIPERCOLESTEROLEMIA FAMILIAR - HOMOCIGOTA"
  },
  {
    "codigo":8702009,
    "descripcion":"ENURESIS EXCLUSIVAMENTE DIURNA"
  },
  {
    "codigo":400083002,
    "descripcion":"HAMARTOMA CONGÉNITO DE PIEL"
  },
  {
    "codigo":762366009,
    "descripcion":"PROLAPSO DE OJO IZQUIERDO CONCOMITANTE CON LACERACIÓN"
  },
  {
    "codigo":203475004,
    "descripcion":"OSTEONECROSIS DE CABEZA DE HÚMERO"
  },
  {
    "codigo":301779004,
    "descripcion":"INFLAMACIÓN ANAL"
  },
  {
    "codigo":6867004,
    "descripcion":"EMBARAZOS PREVIOS: MÁS DE 10"
  },
  {
    "codigo":37800003,
    "descripcion":"TRASTORNO DEL METABOLISMO DE PROLINA Y\/O HIDROXIPROLINA"
  },
  {
    "codigo":365480004,
    "descripcion":"DIFERENCIA ETARIA DE LOS NIÑOS EN UNA FAMILIA - HALLAZGO"
  },
  {
    "codigo":234408006,
    "descripcion":"PRODUCCIÓN EXCESIVA DE ADENOSINA DEAMINASA"
  },
  {
    "codigo":134269000,
    "descripcion":"LEE TAMIL"
  },
  {
    "codigo":724093004,
    "descripcion":"SÍNDROME DE NEFROPATÍA, SORDERA E HIPERPARATIROIDISMO"
  },
  {
    "codigo":427346002,
    "descripcion":"CONDUCTA CON RESPECTO A LA SALUD: PROPENSIÓN AL RIESGO"
  },
  {
    "codigo":296274006,
    "descripcion":"SOBREDOSIS DE OXIPERTINA"
  },
  {
    "codigo":230738008,
    "descripcion":"ENFERMEDAD CEREBROVASCULAR ASINTOMÁTICA"
  },
  {
    "codigo":32295003,
    "descripcion":"ILEÍTIS ALÉRGICA"
  },
  {
    "codigo":294439005,
    "descripcion":"ALERGIA A DOMIFENO"
  },
  {
    "codigo":196135008,
    "descripcion":"AMILOIDOSIS PULMONAR"
  },
  {
    "codigo":1144572001,
    "descripcion":"HIPOPLASIA CONGÉNITA DE MÚSCULO DE PELVIS"
  },
  {
    "codigo":16050111000119101,
    "descripcion":"ARTRITIS DE ARTICULACIÓN DE RODILLA DERECHA DEBIDA A INMUNIZACIÓN Y POSTERIOR A ELLA"
  },
  {
    "codigo":94161006,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE GLÁNDULA SUPRARRENAL"
  },
  {
    "codigo":290769009,
    "descripcion":"INTOXICACIÓN POR VINDESINA"
  },
  {
    "codigo":288934002,
    "descripcion":"DIFICULTAD PARA ELIMINAR RESIDUOS DE LA BOCA"
  },
  {
    "codigo":420006002,
    "descripcion":"ENFERMEDAD ARTERIAL CORONARIA OBLITERANTE"
  },
  {
    "codigo":92326008,
    "descripcion":"NEOPLASIA BENIGNA DE COSTILLA"
  },
  {
    "codigo":713083002,
    "descripcion":"GRIPE CAUSADA POR VIRUS INFLUENZA A SUBTIPO H5"
  },
  {
    "codigo":1237371003,
    "descripcion":"NEOPLASIA BENIGNA DE CÉLULAS EPITELIOIDES PERIVASCULARES"
  },
  {
    "codigo":385403006,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA BRONQUIAL AFECTADO POR EL TUMOR"
  },
  {
    "codigo":418171008,
    "descripcion":"APENDICITIS COMPLICADA"
  },
  {
    "codigo":188795008,
    "descripcion":"TUMOR BENIGNO DEL PILAR AMIGDALINO ANTERIOR"
  },
  {
    "codigo":285264000,
    "descripcion":"PENSAMIENTOS PIROMANÍACOS"
  },
  {
    "codigo":88656003,
    "descripcion":"AUSENCIA CONGÉNITA DE CORDÓN ESPERMÁTICO"
  },
  {
    "codigo":709413001,
    "descripcion":"HIPERCLORHIDRIA AISLADA"
  },
  {
    "codigo":283429005,
    "descripcion":"CORTE EN LA INGLE"
  },
  {
    "codigo":86821006,
    "descripcion":"AMPOLLA DE LA NARIZ, CON INFECCIÓN"
  },
  {
    "codigo":840485007,
    "descripcion":"CÓRNEAS PLANAS BILATERALES"
  },
  {
    "codigo":447269006,
    "descripcion":"VENA PULMONAR COMÚN PERSISTENTE"
  },
  {
    "codigo":54053008,
    "descripcion":"ÚLCERA GÁSTRICA AGUDA SIN HEMORRAGIA, SIN PERFORACIÓN Y SIN OBSTRUCCIÓN"
  },
  {
    "codigo":248826006,
    "descripcion":"PEZÓN GRANDE"
  },
  {
    "codigo":707578009,
    "descripcion":"PERFORACIÓN DE INTESTINO DEBIDA A FIBROSIS QUÍSTICA CON ÍLEO MECONIAL"
  },
  {
    "codigo":1197263001,
    "descripcion":"CARCINOMA ENDOCRINO ESCASAMENTE DIFERENCIADO PRIMARIO DE CUELLO UTERINO"
  },
  {
    "codigo":246991003,
    "descripcion":"CÁMARA OCULAR ANTERIOR PROFUNDA"
  },
  {
    "codigo":17615006,
    "descripcion":"HEMORRAGIA DE PARED DE VEJIGA URINARIA"
  },
  {
    "codigo":276089000,
    "descripcion":"NO COMBATIENTE"
  },
  {
    "codigo":16079091000119101,
    "descripcion":"ÁCIDO DESOXIRRIBONUCLEICO DE PAPILOMAVIRUS HUMANO DE BAJO RIESGO DETECTADO EN MUESTRA OBTENIDA DE VAGINA"
  },
  {
    "codigo":1259129005,
    "descripcion":"ESCLEROSIS LATERAL AMIOTRÓFICA CON ATAXIA ESPINOCEREBELOSA"
  },
  {
    "codigo":243321006,
    "descripcion":"CONJUNTIVITIS PURULENTA"
  },
  {
    "codigo":472697007,
    "descripcion":"SÍNDROME PARATRIGEMINAL TIPO I"
  },
  {
    "codigo":700238000,
    "descripcion":"REABSORCIÓN INTRACORONAL PREERUPTIVA DE DIENTE"
  },
  {
    "codigo":308857008,
    "descripcion":"DISPLASIA DE ESÓFAGO"
  },
  {
    "codigo":210553005,
    "descripcion":"LESIÓN POR DESOLLAMIENTO, ANTEBRAZO"
  },
  {
    "codigo":765774003,
    "descripcion":"ATROFIA DE RIÑÓN DERECHO"
  },
  {
    "codigo":272419002,
    "descripcion":"TUMOR GRANDE"
  },
  {
    "codigo":698403003,
    "descripcion":"TRASTORNO NEONATAL CAUSADO POR AGENTE ANTIINFECCIOSO TRANSMITIDO A TRAVÉS DE LECHE MATERNA"
  },
  {
    "codigo":237816004,
    "descripcion":"PUBERTAD PRECOZ CENTRAL"
  },
  {
    "codigo":11819251000119106,
    "descripcion":"ESGUINCE DE LIGAMENTO CORACOCLAVICULAR DERECHO"
  },
  {
    "codigo":323981000119100,
    "descripcion":"MASA DE ARTICULACIÓN DE PIE"
  },
  {
    "codigo":39373004,
    "descripcion":"BIORRITMO CIRCATRENTANO ANORMAL"
  },
  {
    "codigo":6605007,
    "descripcion":"INFECCIÓN CAUSADA POR TRYPANOSOMA VIVAX"
  },
  {
    "codigo":301517009,
    "descripcion":"INCAPAZ DE SALIR DE LA DUCHA"
  },
  {
    "codigo":365218002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA HIGIENIZARSE LUEGO DE IR AL BAÑO"
  },
  {
    "codigo":234146006,
    "descripcion":"SÍNDROME DE LINFANGIECTASIA-LINFEDEMA DE HENNEKAM"
  },
  {
    "codigo":363383000,
    "descripcion":"NEOPLASIA MALIGNA DE ENCÍA DE MAXILAR SUPERIOR"
  },
  {
    "codigo":1217186009,
    "descripcion":"PERIOSTITIS DE TOBILLO"
  },
  {
    "codigo":428919002,
    "descripcion":"PALPITACIONES CON RITMO REGULAR"
  },
  {
    "codigo":2935001,
    "descripcion":"INTOXICACIÓN POR ANTIASMÁTICO"
  },
  {
    "codigo":35703006,
    "descripcion":"HEMOGLOBINURIA PAROXÍSTICA TRANSITORIA INDUCIDA POR FRÍO"
  },
  {
    "codigo":232311007,
    "descripcion":"INFECCIÓN ENDOCOCLEAR POR CITOMEGALOVIRUS"
  },
  {
    "codigo":427084000,
    "descripcion":"ELECTROCARDIOGRAMA: TAQUICARDIA SINUSAL"
  },
  {
    "codigo":230476001,
    "descripcion":"CEFALEA ATÍPICA EN SALVAS"
  },
  {
    "codigo":66636001,
    "descripcion":"ÚLCERA GASTROYEYUNAL AGUDA CON PERFORACIÓN"
  },
  {
    "codigo":197708002,
    "descripcion":"SÍNDROME NEFRÍTICO CRÓNICO, ANOMALÍA GLOMERULAR MENOR"
  },
  {
    "codigo":263244000,
    "descripcion":"FRACTURA BIMALEOLAR DE TOBILLO"
  },
  {
    "codigo":296012007,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE CLONAZEPAM"
  },
  {
    "codigo":164940009,
    "descripcion":"ECG: ONDA F - HALLAZGO"
  },
  {
    "codigo":392481002,
    "descripcion":"SÍNDROME DE CHANDLER"
  },
  {
    "codigo":294177005,
    "descripcion":"ALERGIA A ICTAMOL"
  },
  {
    "codigo":261409005,
    "descripcion":"FÍSTULA ANAL DIRECTA"
  },
  {
    "codigo":1144310002,
    "descripcion":"FRENTE ANGOSTA"
  },
  {
    "codigo":292342004,
    "descripcion":"REACCIÓN ADVERSA AL SECOBARBITAL"
  },
  {
    "codigo":95734007,
    "descripcion":"QUERATITIS GRANULOMATOSA"
  },
  {
    "codigo":1177078007,
    "descripcion":"DACRIOADENITIS POR SCHISTOSOMA HAEMATOBIUM"
  },
  {
    "codigo":126667002,
    "descripcion":"NEOPLASIA DE LAS VÍAS RESPIRATORIAS"
  },
  {
    "codigo":224971003,
    "descripcion":"SENTIMIENTO DE AGRESIÓN"
  },
  {
    "codigo":16026151000119104,
    "descripcion":"MALFORMACIÓN ARTERIOVENOSA CONGÉNITA DE MIEMBRO INFERIOR IZQUIERDO"
  },
  {
    "codigo":93899005,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE MÚSCULO ABDOMINAL"
  },
  {
    "codigo":290507006,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ENFLURANO"
  },
  {
    "codigo":61131006,
    "descripcion":"INFECCIÓN CAUSADA POR PARANOPLOCEPHALA MAMMILLANA"
  },
  {
    "codigo":716491008,
    "descripcion":"COMPRENDE EL HABLA"
  },
  {
    "codigo":92064000,
    "descripcion":"NEOPLASIA BENIGNA DEL CÓCCIX"
  },
  {
    "codigo":190368000,
    "descripcion":"DIABETES MELLITUS TIPO 1 CON ÚLCERA"
  },
  {
    "codigo":1306315009,
    "descripcion":"NEOPLASIA MALIGNA DE PEZÓN"
  },
  {
    "codigo":714656007,
    "descripcion":"DESARROLLO FETAL ALTERADO"
  },
  {
    "codigo":288672009,
    "descripcion":"INCAPAZ DE RESTABLECER UNA CONVERSACIÓN"
  },
  {
    "codigo":286837003,
    "descripcion":"CARÁCTER GRANDIOSO"
  },
  {
    "codigo":254069004,
    "descripcion":"DISOSTOSIS MÚLTIPLE"
  },
  {
    "codigo":24693007,
    "descripcion":"FIBROMIOSITIS"
  },
  {
    "codigo":417909009,
    "descripcion":"EL MARGEN DE RESECCIÓN QUIRÚRGICA PROFUNDO ES EL MARGEN NO AFECTADO MÁS CERCANO AL CARCINOMA DUCTAL IN SITU"
  },
  {
    "codigo":448842002,
    "descripcion":"TÚNEL AORTOVENTRICULAR IZQUIERDO DE TIPO SIMPLE"
  },
  {
    "codigo":352961000119103,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE PELVIS RENAL DERECHA"
  },
  {
    "codigo":283167001,
    "descripcion":"CUERPO EXTRAÑO METÁLICO EN LA ESPALDA"
  },
  {
    "codigo":416074009,
    "descripcion":"CAVITACIÓN ARTICULAR"
  },
  {
    "codigo":186698009,
    "descripcion":"HEPATITIS POR CITOMEGALOVIRUS"
  },
  {
    "codigo":414239004,
    "descripcion":"INFERTILIDAD FEMENINA POR DISFUNCIÓN DEL MOCO CERVICAL"
  },
  {
    "codigo":1004063004,
    "descripcion":"CONTRACTURA EN FLEXIÓN DE ARTICULACIÓN INTERFALÁNGICA PROXIMAL DE QUINTO DEDO DE PIE"
  },
  {
    "codigo":250399005,
    "descripcion":"ANTÍGENO TIPO KX"
  },
  {
    "codigo":86559007,
    "descripcion":"FRACTURA NO EXPUESTA DE RAMA DE MANDÍBULA"
  },
  {
    "codigo":281332000,
    "descripcion":"NO SE ESPECÍFICA LA FECHA DE NACIMIENTO"
  },
  {
    "codigo":248564001,
    "descripcion":"RESPIRACIÓN FRUNCIENDO LOS LABIOS"
  },
  {
    "codigo":84724007,
    "descripcion":"LINFANGITIS AGUDA DE NALGA"
  },
  {
    "codigo":279497000,
    "descripcion":"INTIMIDACIÓN"
  },
  {
    "codigo":445172009,
    "descripcion":"GRANULOMA DE COLESTEROL DE OÍDO MEDIO Y MASTOIDES"
  },
  {
    "codigo":246729001,
    "descripcion":"ESTRABISMO DIVERGENTE MANIFIESTO"
  },
  {
    "codigo":838388009,
    "descripcion":"ABSCESO DE ESPACIO EPIDURAL ESPINAL CAUSADO POR MYCOBACTERIUM"
  },
  {
    "codigo":1197001006,
    "descripcion":"MASA EN NALGA"
  },
  {
    "codigo":82889007,
    "descripcion":"RUPTURA DE VASO PULMONAR"
  },
  {
    "codigo":11821761000119108,
    "descripcion":"SUBLUXACIÓN ANTERIOR DE ARTICULACIÓN ESTERNOCLAVICULAR IZQUIERDA"
  },
  {
    "codigo":48286001,
    "descripcion":"TRASTORNO DEL METABOLISMO DE LIPOPROTEÍNAS Y\/O LÍPIDOS"
  },
  {
    "codigo":769182000,
    "descripcion":"RETINOPATÍA PREPROLIFERATIVA DEL OJO IZQUIERDO DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":212126007,
    "descripcion":"CORROSIONES QUE COMPROMETEN 90% DE LA SUPERFICIE CORPORAL O MÁS"
  },
  {
    "codigo":1258867002,
    "descripcion":"ABSCESO DE MAMA POSPARTO"
  },
  {
    "codigo":111987004,
    "descripcion":"EXPECTORACIÓN DE ESPUTO EN GELATINA DE GROSELLA"
  },
  {
    "codigo":243059005,
    "descripcion":"INTOXICACIÓN POR GAS NEUROTÓXICO"
  },
  {
    "codigo":306760003,
    "descripcion":"DIFICULTAD PARA PRODUCIR SONIDOS SORDOS"
  },
  {
    "codigo":208456007,
    "descripcion":"FRACTURA NO EXPUESTA DE LA FALANGE DISTAL DE DEDO DE LA MANO, BASE"
  },
  {
    "codigo":110152008,
    "descripcion":"ABRASIÓN DE MUCOSA YUGAL"
  },
  {
    "codigo":372296009,
    "descripcion":"PRESENCIA DE INVASIÓN TUMORAL EN EL TEJIDO PERINEURAL (PRÓSTATA)"
  },
  {
    "codigo":75549005,
    "descripcion":"INFECCIÓN CAUSADA POR PNEUMOCYSTIS JIROVECI"
  },
  {
    "codigo":403229007,
    "descripcion":"FOTOSUBTIPO CUTÁNEO IIIC (AL COMIENZO, A VECES EXISTE QUEMADURA, LUEGO BRONCEADO INTENSO)"
  },
  {
    "codigo":40946000,
    "descripcion":"COMA HEPÁTICO DEBIDO A HEPATITIS VIRAL"
  },
  {
    "codigo":300021000119102,
    "descripcion":"ARTRITIS ESTAFILOCÓCICA DE CADERA"
  },
  {
    "codigo":8178001,
    "descripcion":"INFECCIÓN CAUSADA POR TRICHOBILHARZIA"
  },
  {
    "codigo":237554005,
    "descripcion":"BOCIO DISHORMONOGENÉTICO FAMILIAR"
  },
  {
    "codigo":1220594007,
    "descripcion":"SÍNDROME DE PIERPONT"
  },
  {
    "codigo":301255000,
    "descripcion":"OBSTRUCCIÓN PARCIAL DE LAS VÍAS AÉREAS DURANTE LA INSPIRACIÓN Y LA ESPIRACIÓN"
  },
  {
    "codigo":303090009,
    "descripcion":"HIPERHIDROSIS PALMAR"
  },
  {
    "codigo":235719002,
    "descripcion":"INTOLERANCIA ALIMENTARIA"
  },
  {
    "codigo":39111003,
    "descripcion":"TIFO TRANSMITIDO POR PIOJOS"
  },
  {
    "codigo":170183005,
    "descripcion":"EXAMEN A LOS 15 AÑOS ANORMAL - DERIVADO"
  },
  {
    "codigo":364956002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA MOVER LOS LABIOS EN FORMA SIMÉTRICA"
  },
  {
    "codigo":168348003,
    "descripcion":"CULTIVO DE HISOPADO VAGINAL PROFUNDO: TRICHOMONAS VAGINALIS"
  },
  {
    "codigo":397724004,
    "descripcion":"DEMUESTRA CONOCIMIENTO DE MANEJO DEL DOLOR"
  },
  {
    "codigo":233884006,
    "descripcion":"PERICARDITIS POR FIEBRE Q"
  },
  {
    "codigo":232049001,
    "descripcion":"DISTROFIA FOVEOMACULAR VITELIFORME DE INICIO EN EL ADULTO"
  },
  {
    "codigo":461425003,
    "descripcion":"FÍSTULA DE ARTERIA CORONARIA CON DILATACIÓN DE TODA LA ARTERIA CORONARIA"
  },
  {
    "codigo":721734000,
    "descripcion":"INFECCIÓN CAUSADA POR FRANCISELLA"
  },
  {
    "codigo":262982008,
    "descripcion":"RUPTURA DE TENDÓN DEL MÚSCULO PERONEO"
  },
  {
    "codigo":197446008,
    "descripcion":"OCLUSIÓN DE VÍA BILIAR"
  },
  {
    "codigo":293915002,
    "descripcion":"ALERGIA A LOXAPINA"
  },
  {
    "codigo":10759311000119104,
    "descripcion":"EMBOLIA PULMONAR DURANTE EL NACIMIENTO"
  },
  {
    "codigo":228379002,
    "descripcion":"FUMA DROGAS EN PIPA"
  },
  {
    "codigo":62704000,
    "descripcion":"ADAPTACIÓN A LAS ALTAS TEMPERATURAS"
  },
  {
    "codigo":193776001,
    "descripcion":"QUERATOCONJUNTIVITIS SECA (EXCLUIDO EL SÍNDROME DE SJÖGREN)"
  },
  {
    "codigo":718064007,
    "descripcion":"PERIODONTITIS AGUDA GENERALIZADA LEVE"
  },
  {
    "codigo":292080008,
    "descripcion":"REACCIÓN ADVERSA AL KETOROLACO"
  },
  {
    "codigo":93637008,
    "descripcion":"MELANOMA MALIGNO DE LA PIEL DE LA CADERA"
  },
  {
    "codigo":288410002,
    "descripcion":"DIFICULTAD PARA ENROSCAR UNA TAPA"
  },
  {
    "codigo":714394004,
    "descripcion":"LUPUS VULGAR DE NARIZ"
  },
  {
    "codigo":417647002,
    "descripcion":"MEDULOEPITELIOMA BENIGNO DE CUERPO CILIAR"
  },
  {
    "codigo":253807009,
    "descripcion":"ATRESIA BILIAR INTRAHEPÁTICA"
  },
  {
    "codigo":415812007,
    "descripcion":"CONSENTIMIENTO ORAL PARA EL EXAMEN"
  },
  {
    "codigo":282905000,
    "descripcion":"DIFICULTAD PARA LEVANTARSE DESDE POSICIÓN DE CUCLILLAS"
  },
  {
    "codigo":53529004,
    "descripcion":"SALPINGITIS GONOCÓCICA CRÓNICA"
  },
  {
    "codigo":11771331000119102,
    "descripcion":"SUBLUXACIÓN DE CODO IZQUIERDO"
  },
  {
    "codigo":248302001,
    "descripcion":"EXCESO DE GRASA SUBCUTÁNEA"
  },
  {
    "codigo":51694003,
    "descripcion":"CUERPO EXTRAÑO GÁSTRICO"
  },
  {
    "codigo":444910004,
    "descripcion":"LINFOMA PRIMARIO MEDIASTÍNICO (TÍMICO) DE LINFOCITOS B GRANDES"
  },
  {
    "codigo":401681000221109,
    "descripcion":"ENFERMEDAD RENAL CRÓNICA IDIOPÁTICA"
  },
  {
    "codigo":1264110003,
    "descripcion":"AMPOLLA TRAUMÁTICA DE DEDO MEÑIQUE IZQUIERDO"
  },
  {
    "codigo":17091000,
    "descripcion":"HIPERVITAMINOSIS, MÚLTIPLES VITAMINAS"
  },
  {
    "codigo":770755007,
    "descripcion":"SÍNDROME DE DISCAPACIDAD INTELECTUAL, CONVULSIONES, HIPOTONÍA Y ANOMALÍAS OFTALMOLÓGICAS Y ESQUELÉTICAS"
  },
  {
    "codigo":736152001,
    "descripcion":"INFECCIÓN DE TORRENTE SANGUÍNEO ASOCIADA A CATÉTER VENOSO CENTRAL IN SITU"
  },
  {
    "codigo":1260440003,
    "descripcion":"SINOVITIS Y TENOSINOVITIS DE MÚLTIPLES ARTICULACIONES"
  },
  {
    "codigo":1293208009,
    "descripcion":"MASA DE MÚSCULO DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":767085008,
    "descripcion":"EL PRIMER VASO CONTIENE HEBRAS O FILAMENTOS"
  },
  {
    "codigo":208194002,
    "descripcion":"FRACTURA EXPUESTA DE PELVIS, ESPINA ILÍACA ANTEROINFERIOR"
  },
  {
    "codigo":699714006,
    "descripcion":"PRÓTESIS DENTAL MAXILAR PARCIAL REMOVIBLE DEFECTUOSA"
  },
  {
    "codigo":402967005,
    "descripcion":"SÍNDROME NEONATAL ESTAFILOCÓCICO DE PIEL ESCALDA"
  },
  {
    "codigo":206359006,
    "descripcion":"CANDIDIASIS NEONATAL DE PULMÓN"
  },
  {
    "codigo":239127008,
    "descripcion":"NEVO DEL FOLÍCULO PILOSO"
  },
  {
    "codigo":302828001,
    "descripcion":"SIRINGOMA"
  },
  {
    "codigo":73452002,
    "descripcion":"ABSCESO DE PULMÓN"
  },
  {
    "codigo":1254935008,
    "descripcion":"REACCIÓN CUTÁNEA POR CONTACTO CON PHYSALIA"
  },
  {
    "codigo":204524005,
    "descripcion":"PERFORACIÓN CONGÉNITA DE LA PARED DE SENO NASAL"
  },
  {
    "codigo":237292005,
    "descripcion":"INSUFICIENCIA PLACENTARIA"
  },
  {
    "codigo":7916009,
    "descripcion":"POLINEUROPATÍA ALCOHÓLICA"
  },
  {
    "codigo":1187564009,
    "descripcion":"ENFERMEDAD DE CHARCOT MARIE TOOTH AUTOSÓMICA DOMINANTE TIPO 2Z"
  },
  {
    "codigo":432065003,
    "descripcion":"LACERACIÓN DE NERVIO DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":270060009,
    "descripcion":"PACIENTE REGISTRADO - FP106"
  },
  {
    "codigo":300993007,
    "descripcion":"DISCINESIA OROFACIAL MEDICAMENTOSA"
  },
  {
    "codigo":366529007,
    "descripcion":"AMPLITUD DE MOVIMIENTO DE ABDUCCIÓN DE LA MUÑECA - HALLAZGO"
  },
  {
    "codigo":202689009,
    "descripcion":"ESPONDILOSIS DORSAL EN UN NIVEL CON RADICULOPATÍA"
  },
  {
    "codigo":200854003,
    "descripcion":"DERMATITIS IRRITATIVA POR CONTACTO CAUSADA POR ALIMENTOS EN CONTACTO CON LA PIEL"
  },
  {
    "codigo":725142004,
    "descripcion":"ATELOSTEOGÉNESIS TIPO 3"
  },
  {
    "codigo":299158006,
    "descripcion":"AMPLITUD DE EXTENSIÓN PASIVA DEL PULGAR AUMENTADA"
  },
  {
    "codigo":30051000175103,
    "descripcion":"ÚLCERA POR PRESIÓN EN DORSO DE PIE IZQUIERDO, ESTADIO III"
  },
  {
    "codigo":723307008,
    "descripcion":"ENCEFALOPATÍA ETILMALÓNICA"
  },
  {
    "codigo":66112004,
    "descripcion":"FRACTURA NO EXPUESTA DE ESTERNÓN"
  },
  {
    "codigo":426560005,
    "descripcion":"DISFUNCIÓN SOMÁTICA DE REGIÓN CERVICODORSAL"
  },
  {
    "codigo":721472006,
    "descripcion":"SÍNDROME DEL CORDÓN POSTERIOR DE MÉDULA ESPINAL AL NIVEL DEL CUARTO SEGMENTO DORSAL"
  },
  {
    "codigo":295488004,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE ANTIESPASMÓDICO"
  },
  {
    "codigo":719637000,
    "descripcion":"LENGUA PÁLIDA"
  },
  {
    "codigo":262720008,
    "descripcion":"HEMATOMA EXTRADURAL TRAUMÁTICO DE MÉDULA ESPINAL"
  },
  {
    "codigo":33344008,
    "descripcion":"ENFERMEDAD POR DEFICIENCIA HEREDITARIA MODERADA DE FACTOR VIII"
  },
  {
    "codigo":293653009,
    "descripcion":"ALERGIA A RANITIDINA"
  },
  {
    "codigo":129813009,
    "descripcion":"DIFERENCIA EN LA SIMETRÍA SEGÚN LA MAMOGRAFÍA"
  },
  {
    "codigo":95210003,
    "descripcion":"LEUCEMIA PLASMOCÍTICA"
  },
  {
    "codigo":160746001,
    "descripcion":"VIVE EN HABITACIÓN AMUEBLADA"
  },
  {
    "codigo":224447000,
    "descripcion":"EL EMPLEADOR IGNORA EL PROBLEMA DE SALUD"
  },
  {
    "codigo":93375001,
    "descripcion":"DESALINEAMIENTO CONGÉNITO DEL CENTRO DE LA VÉRTEBRA LUMBAR"
  },
  {
    "codigo":60607007,
    "descripcion":"INSUFICIENCIA DEL TÚBULO SEMINÍFERO EN EL ADULTO"
  },
  {
    "codigo":16279441000119105,
    "descripcion":"OCLUSIÓN DE ARTERIA CILIORRETINIANA IZQUIERDA"
  },
  {
    "codigo":289983009,
    "descripcion":"DIFICULTAD PARA USAR ARTÍCULOS DE TOCADOR"
  },
  {
    "codigo":124308002,
    "descripcion":"DEFICIENCIA DE DEHIDROGLUCONOCINASA"
  },
  {
    "codigo":253545000,
    "descripcion":"ANOMALÍA DEL TRACTO DE SALIDA DEL VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":384617001,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA PROXIMAL AFECTADO POR CARCINOMA IN SITU"
  },
  {
    "codigo":56937005,
    "descripcion":"ABSCESO DE TRÁQUEA"
  },
  {
    "codigo":1269353008,
    "descripcion":"HIPERSENSIBILIDAD A GENTAMICINA"
  },
  {
    "codigo":1234750000,
    "descripcion":"MIOCARDIOPATÍA ALCOHÓLICA"
  },
  {
    "codigo":55102001,
    "descripcion":"INFECCIÓN CAUSADA POR MENINGONEMA"
  },
  {
    "codigo":16662571000119103,
    "descripcion":"DISECCIÓN DE ARTERIA POPLÍTEA IZQUIERDA"
  },
  {
    "codigo":282643000,
    "descripcion":"NO SE AGACHA"
  },
  {
    "codigo":249875003,
    "descripcion":"PROTRUSIÓN DE LENGUA AUMENTADA"
  },
  {
    "codigo":413715004,
    "descripcion":"CONDUCTA MELANCÓLICA"
  },
  {
    "codigo":41631000087102,
    "descripcion":"CELULITIS DE DEDO ÍNDICE IZQUIERDO"
  },
  {
    "codigo":315411008,
    "descripcion":"NACIDO EN CHIPRE"
  },
  {
    "codigo":184339009,
    "descripcion":"ABORTO ESPONTÁNEO ENTRE LAS SEMANAS 8 Y 28"
  },
  {
    "codigo":39071000087105,
    "descripcion":"DOLOR CRÓNICO POSTERIOR A CIRUGÍA MAMARIA"
  },
  {
    "codigo":46751000087108,
    "descripcion":"NEOPLASIA BENIGNA DE INTESTINO GRUESO CON HEMORRAGIA"
  },
  {
    "codigo":1296616004,
    "descripcion":"HIPERTENSIÓN OCULAR DE OJO IZQUIERDO DEBIDA A PSEUDOEXFOLIACIÓN"
  },
  {
    "codigo":44191000087108,
    "descripcion":"CORTE DE DEDO DE PIE DERECHO"
  },
  {
    "codigo":248040006,
    "descripcion":"EXCEDE EL CONTROL DE LOS PADRES"
  },
  {
    "codigo":410045006,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE LA ARTICULACIÓN ESCAPULOTORÁCICA"
  },
  {
    "codigo":735890003,
    "descripcion":"DISTENSIÓN DE DEDO GORDO DE PIE"
  },
  {
    "codigo":277138006,
    "descripcion":"ARTRALGIA POR RUBÉOLA"
  },
  {
    "codigo":211602009,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO, TOBILLO Y PIE, EXCLUIDOS LOS DEDOS"
  },
  {
    "codigo":209767002,
    "descripcion":"RUPTURA DEL EXTENSOR LARGO DEL PULGAR"
  },
  {
    "codigo":334021000119104,
    "descripcion":"DRUSAS DE MÁCULA DERECHA"
  },
  {
    "codigo":45927004,
    "descripcion":"NEFRITIS TUBULOINTERSTICIAL MEDIADA INMUNOLÓGICAMENTE"
  },
  {
    "codigo":439143004,
    "descripcion":"SÍNDROME DE SIMPSON-GOLABI-BEHMEL"
  },
  {
    "codigo":78695006,
    "descripcion":"INTOXICACIÓN CAUSADA POR AMITRIPTILINA"
  },
  {
    "codigo":16636101000119105,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE ESTROMA GASTROINTESTINAL, DE RECTO"
  },
  {
    "codigo":373607009,
    "descripcion":"OXALOSIS"
  },
  {
    "codigo":207932003,
    "descripcion":"FRACTURA EXPUESTA DE VÉRTEBRA CERVICAL, APÓFISIS ESPINOSA"
  },
  {
    "codigo":109628004,
    "descripcion":"BOLSILLO GINGIVAL"
  },
  {
    "codigo":240700007,
    "descripcion":"INFECCIÓN MICÓTICA DEL CABELLO"
  },
  {
    "codigo":238865006,
    "descripcion":"FIBROMATOSIS COLLI"
  },
  {
    "codigo":402705006,
    "descripcion":"DERMATOSIS INFECCIOSA DE GENITALES MASCULINOS"
  },
  {
    "codigo":105958000,
    "descripcion":"DIETA RELACIONADA CON UN ESTUDIO Y\/O UNA ENFERMEDAD"
  },
  {
    "codigo":1285606000,
    "descripcion":"HEMATOMA DE MANO"
  },
  {
    "codigo":73190000,
    "descripcion":"TALASEMIA ÉPSILON GAMMA DELTA BETA^0^"
  },
  {
    "codigo":9489006,
    "descripcion":"TRASTORNO POR INHIBIDOR DEL FACTOR X"
  },
  {
    "codigo":202427000,
    "descripcion":"TUMOR TENOSINOVIAL DIFUSO DE CÉLULAS GIGANTES DE MANO"
  },
  {
    "codigo":1187302009,
    "descripcion":"CON MAYOR RIESGO DE ESCAPARSE"
  },
  {
    "codigo":300731002,
    "descripcion":"CAPAZ DE USAR EL TELÉFONO"
  },
  {
    "codigo":366267009,
    "descripcion":"HALLAZGO SOBRE POSICIÓN DE CUELLO VESICAL"
  },
  {
    "codigo":167824001,
    "descripcion":"EXAMEN DEL VÓMITO, ANORMAL"
  },
  {
    "codigo":36752001,
    "descripcion":"ESPLENOMEGALIA CONGÉNITA"
  },
  {
    "codigo":71355009,
    "descripcion":"EDAD GESTACIONAL, 30 SEMANAS"
  },
  {
    "codigo":10629471000119106,
    "descripcion":"RINITIS ALÉRGICA CAUSADA POR MOHO"
  },
  {
    "codigo":429968006,
    "descripcion":"HALLAZGO RELACIONADO CON FLEXIÓN DE LA CABEZA FETAL"
  },
  {
    "codigo":266128007,
    "descripcion":"ERUPCIÓN DE SÍFILIS SECUNDARIA"
  },
  {
    "codigo":724880008,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO DEL TÓRAX"
  },
  {
    "codigo":397200008,
    "descripcion":"PRESENCIA DE MICROCALCIFICACIONES EN NEOPLASIA MALIGNA"
  },
  {
    "codigo":34917002,
    "descripcion":"INTOXICACIÓN POR HALOTANO"
  },
  {
    "codigo":67685000,
    "descripcion":"PROSTATOCISTITIS"
  },
  {
    "codigo":2149006,
    "descripcion":"PRODUCCIÓN HORMONAL DISMINUIDA"
  },
  {
    "codigo":231525006,
    "descripcion":"TRASTORNO DE PERSONALIDAD MANIPULADORA"
  },
  {
    "codigo":295226000,
    "descripcion":"SOBREDOSIS DE DICLOFENACO"
  },
  {
    "codigo":229690005,
    "descripcion":"DISARTRIANEUMOFONÍA"
  },
  {
    "codigo":11831801000119103,
    "descripcion":"LESIÓN TRAUMÁTICA DE VASO SANGUÍNEO DE DEDO ÍNDICE DE MANO DERECHA"
  },
  {
    "codigo":459066006,
    "descripcion":"ORIGEN ANÓMALO DE ARTERIA CORONARIA ACCESORIA EN ARTERIA PULMONAR"
  },
  {
    "codigo":721210009,
    "descripcion":"EDEMA DEBIDO A SOBRECARGA DE LÍQUIDOS"
  },
  {
    "codigo":64015001,
    "descripcion":"UVEÍTIS ANTERIOR SUBAGUDA"
  },
  {
    "codigo":10930681000119104,
    "descripcion":"FRACTURA NO EXPUESTA DE METÁFISIS DE HUESO METATARSIANO DE PIE DERECHO"
  },
  {
    "codigo":424463006,
    "descripcion":"INFECCIÓN DE PARTES BLANDAS DE LA COLUMNA VERTEBRAL CERVICAL"
  },
  {
    "codigo":1145359009,
    "descripcion":"LESIÓN HIPOINTENSA DE GANGLIO BASAL EN IMAGEN DE RESONANCIA MAGNÉTICA EN T2"
  },
  {
    "codigo":193252005,
    "descripcion":"MIOPATÍA DEBIDO A ESCLERODERMIA"
  },
  {
    "codigo":90771000119100,
    "descripcion":"ENFERMEDAD RENAL TERMINAL EN DIÁLISIS DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":94948007,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE MÚSCULO DEL PERINEO"
  },
  {
    "codigo":289721000,
    "descripcion":"CONTRACCIONES UTERINAS DE INTENSIDAD VARIABLE"
  },
  {
    "codigo":1141689001,
    "descripcion":"DEMUESTRA CONOCIMIENTO SOBRE PREVENCIÓN DE CAÍDAS"
  },
  {
    "codigo":160484008,
    "descripcion":"GRUPO SOCIAL 3 - CALIFICADO"
  },
  {
    "codigo":781241003,
    "descripcion":"TENDINITIS DE LA PORCIÓN LARGA DEL MÚSCULO BÍCEPS BRAQUIAL DEL HOMBRO DERECHO"
  },
  {
    "codigo":1473881000168103,
    "descripcion":"ORDEN DE RESTRICCIÓN VIGENTE"
  },
  {
    "codigo":93113007,
    "descripcion":"FALTA DE OSIFICACIÓN DEL PREMAXILAR"
  },
  {
    "codigo":714023571000119102,
    "descripcion":"NÓDULO DE DESGASTE DE HÉLICE DE PABELLÓN AURICULAR IZQUIERDO"
  },
  {
    "codigo":1073811000119102,
    "descripcion":"ARTRITIS REUMATOIDE DE RODILLA DERECHA"
  },
  {
    "codigo":1172622001,
    "descripcion":"VÍCTIMA DE INCESTO"
  },
  {
    "codigo":124046000,
    "descripcion":"FOSFOLÍPIDO POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":255118005,
    "descripcion":"CARCINOMA LINFANGÍTICO METASTÁSICO"
  },
  {
    "codigo":1303694006,
    "descripcion":"OSTEOMIELITIS CRÓNICA DE HUESO METATARSIANO"
  },
  {
    "codigo":336531000119103,
    "descripcion":"IRITIS AGUDA DE OJO DERECHO"
  },
  {
    "codigo":253283000,
    "descripcion":"VENTRÍCULO IZQUIERDO CON DOBLE TRACTO DE ENTRADA"
  },
  {
    "codigo":449891003,
    "descripcion":"HERIDA DE PERINEO EN CICATRIZACIÓN"
  },
  {
    "codigo":286051004,
    "descripcion":"NO LAVA LA ROPA SUCIA"
  },
  {
    "codigo":417123005,
    "descripcion":"DEFICIENCIA EN LA CAPA DE MUCINA LAGRIMAL"
  },
  {
    "codigo":56675007,
    "descripcion":"INSUFICIENCIA CARDÍACA AGUDA"
  },
  {
    "codigo":448056004,
    "descripcion":"INTERVALO DE ADMINISTRACIÓN DE MEDICACIÓN EXCESIVAMENTE LARGO"
  },
  {
    "codigo":284216004,
    "descripcion":"QUEMADURA SUPERFICIAL DE LA PARED DEL TÓRAX POR AGENTE CORROSIVO"
  },
  {
    "codigo":54840006,
    "descripcion":"FALTA DE PROGRESO"
  },
  {
    "codigo":445431000124103,
    "descripcion":"COMPOSICIÓN DE NUTRICIÓN PARENTERAL INADECUADA"
  },
  {
    "codigo":251448007,
    "descripcion":"ACTIVIDAD DOMINANTE THETA"
  },
  {
    "codigo":446221000,
    "descripcion":"INSUFICIENCIA CARDÍACA CON FRACCIÓN DE EYECCIÓN NORMAL"
  },
  {
    "codigo":2551000124100,
    "descripcion":"INCISIVO CENTRAL SUPERIOR DERECHO PERMANENTE SUPERNUMERARIO"
  },
  {
    "codigo":216845003,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR MONÓXIDO DE CARBONO POR COMBUSTIÓN INCOMPLETA DE COQUE EN ESTUFA O COCINA DE USO DOMÉSTICO"
  },
  {
    "codigo":440311000124109,
    "descripcion":"VELOCIDAD DE CRECIMIENTO EXCESIVA"
  },
  {
    "codigo":11805331000119108,
    "descripcion":"SUBLUXACIÓN DE ARTICULACIÓN INTERFALÁNGICA PROXIMAL DE DEDO DE MANO DERECHA"
  },
  {
    "codigo":1263586000,
    "descripcion":"CEFALEA CAUSADA POR GLUTAMATO MONOSÓDICO"
  },
  {
    "codigo":83938003,
    "descripcion":"TROMBOSIS DE LA VENA CAVA"
  },
  {
    "codigo":409783000,
    "descripcion":"INVASIÓN TUMORAL CIRCUNSCRIPTA A LA PIEL"
  },
  {
    "codigo":1360055002,
    "descripcion":"TRAYECTO FISTULOSO DE PIEL Y\/O TEJIDO CELULAR SUBCUTÁNEO"
  },
  {
    "codigo":213175004,
    "descripcion":"FALLA PARCIAL DE REIMPLANTE DE PIE"
  },
  {
    "codigo":16567006,
    "descripcion":"MESOCARDIA"
  },
  {
    "codigo":442551007,
    "descripcion":"CARIES DENTAL QUE SE EXTIENDE HASTA LA DENTINA"
  },
  {
    "codigo":211340000,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE PIERNA"
  },
  {
    "codigo":735628004,
    "descripcion":"ANORGASMIA GENERALIZADA SITUACIONAL"
  },
  {
    "codigo":276876007,
    "descripcion":"CARCINOMA DE LA GLÁNDULA DE BARTOLINO"
  },
  {
    "codigo":12897005,
    "descripcion":"ESTENOSIS CONGÉNITA DE UNIÓN URETEROPÉLVICA"
  },
  {
    "codigo":45665008,
    "descripcion":"FRACTURAS MÚLTIPLES DE LA EXTREMIDAD INFERIOR Y DEL ESTERNÓN"
  },
  {
    "codigo":240438005,
    "descripcion":"ACTINOMICOSIS CUTÁNEA PRIMARIA"
  },
  {
    "codigo":76598006,
    "descripcion":"TROMBOSIS DE VENA DEL PENE"
  },
  {
    "codigo":43830008,
    "descripcion":"LINFANGITIS AGUDA DE LA REGIÓN PECTORAL"
  },
  {
    "codigo":205835001,
    "descripcion":"ACEFALOBRAQUIA"
  },
  {
    "codigo":109366009,
    "descripcion":"NEOPLASIA MALIGNA SUPERPUESTA DE LOS SENOS PARANASALES"
  },
  {
    "codigo":764726009,
    "descripcion":"PARÁLISIS DE CUERDA VOCAL DERECHA"
  },
  {
    "codigo":238603004,
    "descripcion":"PSORIASIS ECCEMATIZADA"
  },
  {
    "codigo":699190008,
    "descripcion":"TRASTORNO DE DOLOR EXTREMO PAROXÍSTICO"
  },
  {
    "codigo":369675006,
    "descripcion":"MARGEN PROXIMAL DE RESECCIÓN QUIRÚRGICA DE ESÓFAGO, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":105696001,
    "descripcion":"ENFERMEDAD CAUSADA POR ASCARIDOIDEA"
  },
  {
    "codigo":7392002,
    "descripcion":"DERMATITIS DEL RECIÉN NACIDO"
  },
  {
    "codigo":1156107009,
    "descripcion":"CÚSPIDE DENTAL SUPERNUMERARIA"
  },
  {
    "codigo":1187040004,
    "descripcion":"SÍNDROME NEFRÓTICO RESISTENTE A ESTEROIDES CON INSUFICIENCIA SUPRARRENAL FAMILIAR"
  },
  {
    "codigo":236768005,
    "descripcion":"EPIDIDIMITIS CRÓNICA"
  },
  {
    "codigo":300469006,
    "descripcion":"HALLAZGO RELACIONADO CON MEDICIONES URETRALES"
  },
  {
    "codigo":16012231000119108,
    "descripcion":"TROMBOFLEBITIS DE VENA TIBIAL DERECHA"
  },
  {
    "codigo":366005007,
    "descripcion":"VOZ POSLARINGECTOMÍA - HALLAZGO"
  },
  {
    "codigo":1052298001,
    "descripcion":"RUPTURA DE TENDÓN FLEXOR DE MANO"
  },
  {
    "codigo":724618005,
    "descripcion":"DEDOS DE LA MANO EN PALILLO DE TAMBOR CONGÉNITOS"
  },
  {
    "codigo":1279839002,
    "descripcion":"ATAXIA ESPINOCEREBELOSA TIPO 46"
  },
  {
    "codigo":131124000,
    "descripcion":"VITAMINA B POR ENCIMA DE RANGO DE REFERENCIA"
  },
  {
    "codigo":296799008,
    "descripcion":"SOBREDOSIS DE ETAMBUTOL"
  },
  {
    "codigo":294964002,
    "descripcion":"ALERGIA A BEZAFIBRATO"
  },
  {
    "codigo":293129002,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR ANTISUERO"
  },
  {
    "codigo":1145097002,
    "descripcion":"AUSENCIA DE PESTAÑAS DE PÁRPADO SUPERIOR"
  },
  {
    "codigo":63753005,
    "descripcion":"GRANULOMA DE MÚSCULO POR TALCO"
  },
  {
    "codigo":94686001,
    "descripcion":"LINFOSARCOMA DE CÉLULAS MIXTAS DE LOS GANGLIOS LINFÁTICOS INTRABDOMINALES"
  },
  {
    "codigo":30985009,
    "descripcion":"BOCIO NODULAR TÓXICO CON TORMENTA TIROTÓXICA"
  },
  {
    "codigo":291294001,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR ACETILCOLINA"
  },
  {
    "codigo":192990004,
    "descripcion":"EPILEPSIA MIOCLÓNICA DE LACTANTE"
  },
  {
    "codigo":92851000,
    "descripcion":"FUSIÓN ANORMAL CONGÉNITA DE CENTRO DE VÉRTEBRA SACRA"
  },
  {
    "codigo":595899961000119100,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DE GANGLIOS BASALES"
  },
  {
    "codigo":88121000119101,
    "descripcion":"COJERA PRODUCIDA DURANTE LA INFANCIA"
  },
  {
    "codigo":341561000119102,
    "descripcion":"CANALICULITIS LAGRIMAL CRÓNICA DE OJO IZQUIERDO"
  },
  {
    "codigo":15732281000119103,
    "descripcion":"TRIQUIASIS DE AMBOS OJOS"
  },
  {
    "codigo":323641000119102,
    "descripcion":"TUMOR TENOSINOVIAL DIFUSO DE CÉLULAS GIGANTES DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":674361000119104,
    "descripcion":"APRAXIA DEBIDA A ACCIDENTE CEREBROVASCULAR ISQUÉMICO Y POSTERIOR A ÉL"
  },
  {
    "codigo":12245561000119106,
    "descripcion":"SHOCK POSTPROCEDURAL"
  },
  {
    "codigo":90681000119107,
    "descripcion":"INFECCIÓN ASINTOMÁTICA POR VIRUS DE LA INMUNODEFICIENCIA HUMANA A1"
  },
  {
    "codigo":15747641000119107,
    "descripcion":"MASA DE MÚSCULO DE EXTREMIDAD SUPERIOR IZQUIERDA"
  },
  {
    "codigo":292921000119109,
    "descripcion":"GRANULOMA INTRAESPINAL"
  },
  {
    "codigo":10960441000119103,
    "descripcion":"HERIDA ABIERTA DE ANTEBRAZO DERECHO DEBIDA A MORDEDURA HUMANA"
  },
  {
    "codigo":1336200007,
    "descripcion":"TRASTORNO POR USO DE CANNABIS"
  },
  {
    "codigo":713608008,
    "descripcion":"INVOLUCIÓN DE UÑA DE DEDO DEL PIE"
  },
  {
    "codigo":1089081000119107,
    "descripcion":"ENFERMEDAD DE MÉNIÈRE DEL OÍDO INTERNO IZQUIERDO"
  },
  {
    "codigo":12217401000119105,
    "descripcion":"OSTEÓLISIS DE HUESO ADYACENTE A PRÓTESIS DE ARTICULACIÓN DE CADERA IZQUIERDA"
  },
  {
    "codigo":308281000119107,
    "descripcion":"DEFORMIDAD EN FLEXIÓN DE ARTICULACIÓN DE MUÑECA DERECHA"
  },
  {
    "codigo":313401000119109,
    "descripcion":"ARTROFITO EN ARTICULACIÓN DE TOBILLO DERECHO"
  },
  {
    "codigo":15709241000119108,
    "descripcion":"INFESTACIÓN PARASITARIA DE PÁRPADO DERECHO"
  },
  {
    "codigo":23645006,
    "descripcion":"TRASTORNO ORGÁNICO DEL ESTADO DE ÁNIMO"
  },
  {
    "codigo":449629006,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE PIERNA"
  },
  {
    "codigo":253021007,
    "descripcion":"ADENOMA PAPILAR ECRINO"
  },
  {
    "codigo":283954003,
    "descripcion":"LACERACIÓN DEL ESCROTO"
  },
  {
    "codigo":251186007,
    "descripcion":"COMPLEJO DE ESCAPE VENTRICULAR"
  },
  {
    "codigo":183815004,
    "descripcion":"PROCEDIMIENTO DE ADMISIÓN FINANCIADO"
  },
  {
    "codigo":249351007,
    "descripcion":"SANGRE EN LA CAVIDAD NASAL"
  },
  {
    "codigo":216583009,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR COCAÍNA"
  },
  {
    "codigo":18140003,
    "descripcion":"RINOSPORIDIOSIS"
  },
  {
    "codigo":15932821000119106,
    "descripcion":"OBSTRUCCIÓN COMPLETA DE EXTREMO DISTAL DE TROMPA UTERINA DERECHA"
  },
  {
    "codigo":247516008,
    "descripcion":"HEMORRAGIAS EN EL PLIEGUE UNGUEAL"
  },
  {
    "codigo":704433000,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA REALIZAR ACTIVIDADES DE ACICALAMIENTO PERSONAL"
  },
  {
    "codigo":737201004,
    "descripcion":"TRASTORNO DE CONDUCTO ANAL"
  },
  {
    "codigo":49073008,
    "descripcion":"ESCOTOMA ABSOLUTO"
  },
  {
    "codigo":276614003,
    "descripcion":"TRASTORNO DE LA GESTACIÓN"
  },
  {
    "codigo":80006005,
    "descripcion":"TRASTORNO DEL METABOLISMO DE LA BILIRRUBINA"
  },
  {
    "codigo":1259654009,
    "descripcion":"COREA DEBIDA A SÍNDROME DE LESCH-NYHAN"
  },
  {
    "codigo":242011003,
    "descripcion":"LESIÓN POR CORRIENTE EN TIERRA PROVOCADA POR RAYO"
  },
  {
    "codigo":78171005,
    "descripcion":"HEMORRAGIA TRAUMÁTICA DEL HÍGADO"
  },
  {
    "codigo":373083005,
    "descripcion":"NEOPLASIA MALIGNA DE CUADRANTE SUPEROEXTERNO DE MAMA"
  },
  {
    "codigo":405851007,
    "descripcion":"FENOTIPO FY(A+)"
  },
  {
    "codigo":209243009,
    "descripcion":"FRACTURA-LUXACIÓN EXPUESTA DE ARTICULACIÓN ACROMIOCLAVICULAR"
  },
  {
    "codigo":698928002,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: TURCOMANO"
  },
  {
    "codigo":43568002,
    "descripcion":"TRASTORNO BIPOLAR II, EPISODIO MÁS RECIENTE DE CARACTERÍSTICAS DEPRESIVAS PROFUNDAS CON SÍNTOMAS ATÍPICOS"
  },
  {
    "codigo":404016005,
    "descripcion":"FIBROHISTIOCITOMA MALIGNO GIGANTOCELULAR DE LA PIEL"
  },
  {
    "codigo":305712006,
    "descripcion":"ATENDIDO POR CIRUJANO ESPECIALISTA EN TRACTO GASTROINTESTINAL"
  },
  {
    "codigo":830000008,
    "descripcion":"HIPEREMIA DE FARINGE"
  },
  {
    "codigo":76336008,
    "descripcion":"TALASEMIA DELTA BETA CERO"
  },
  {
    "codigo":271109002,
    "descripcion":"AMPOLLA TRAUMÁTICA DEL CUERO CABELLUDO"
  },
  {
    "codigo":205573006,
    "descripcion":"HIPOPLASIA DÉRMICA FOCAL"
  },
  {
    "codigo":762629007,
    "descripcion":"OCLUSIÓN DE ARTERIA CEREBRAL MEDIA DERECHA POR ÉMBOLO"
  },
  {
    "codigo":402181006,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DE LA PIEL"
  },
  {
    "codigo":39898005,
    "descripcion":"TRASTORNO DEL SUEÑO"
  },
  {
    "codigo":170970005,
    "descripcion":"PRONÓSTICO INCIERTO"
  },
  {
    "codigo":302042005,
    "descripcion":"CAPAZ DE MOVILIZARSE"
  },
  {
    "codigo":38063000,
    "descripcion":"DIABETES MELLITUS PREGESTACIONAL Y\/O ALTERACIÓN DE LA TOLERANCIA A LA GLUCOSA, CLASE C DE WHITE MODIFICADA"
  },
  {
    "codigo":726191001,
    "descripcion":"LESIÓN TRAUMÁTICA DE FASCIA DE MÚSCULO INTRÍNSECO DE PULGAR"
  },
  {
    "codigo":105434009,
    "descripcion":"MATRIMONIO HOMOSEXUAL ENTRE HOMBRES"
  },
  {
    "codigo":300207008,
    "descripcion":"PERMANECE INACTIVO EN RESPUESTA AL SONIDO"
  },
  {
    "codigo":167300001,
    "descripcion":"PRUEBA DE SANGRE EN ORINA = +"
  },
  {
    "codigo":365743009,
    "descripcion":"NIVEL DE FENITOÍNA - HALLAZGO"
  },
  {
    "codigo":724356003,
    "descripcion":"DEFICIENCIA HEREDITARIA COMBINADA DE FACTORES DE COAGULACIÓN DEPENDIENTES DE LA VITAMINA K"
  },
  {
    "codigo":298372004,
    "descripcion":"ARTICULACIÓN TEMPOROMANDIBULAR INESTABLE"
  },
  {
    "codigo":267439008,
    "descripcion":"LIPOSINOVITIS PRERROTULIANA"
  },
  {
    "codigo":68996008,
    "descripcion":"TRASTORNO DEL OÍDO MEDIO"
  },
  {
    "codigo":200068009,
    "descripcion":"REACCIÓN TÓXICA OBSTÉTRICA CAUSADA POR ANESTESIA LOCAL"
  },
  {
    "codigo":722521002,
    "descripcion":"VERRUGA DE MUCOSA ANAL CAUSADA POR PAPILOMAVIRUS HUMANO"
  },
  {
    "codigo":296537006,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE GRISEOFULVINA"
  },
  {
    "codigo":165465007,
    "descripcion":"ERITROSEDIMENTACIÓN FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":196398003,
    "descripcion":"DESVIACIÓN HACIA LA LÍNEA MEDIA DEL ARCO DENTAL"
  },
  {
    "codigo":294702008,
    "descripcion":"ALERGIA A DEXAMETASONA"
  },
  {
    "codigo":1144835001,
    "descripcion":"INTOXICACIÓN ACCIDENTAL CAUSADA POR VALPROATO"
  },
  {
    "codigo":2355008,
    "descripcion":"SÍNDROME DE RUD"
  },
  {
    "codigo":63491006,
    "descripcion":"CLAUDICACIÓN INTERMITENTE"
  },
  {
    "codigo":718851007,
    "descripcion":"SÍNDROME DE CATARATA Y GLAUCOMA"
  },
  {
    "codigo":717016001,
    "descripcion":"ENFERMEDAD DE CHARCOT-MARIE-TOOTH TIPO 2A1 AUTOSÓMICA DOMINANTE"
  },
  {
    "codigo":225496001,
    "descripcion":"USA ROPA DE UN SOLO COLOR"
  },
  {
    "codigo":292867009,
    "descripcion":"REACCIÓN ADVERSA A LA HEXETIDINA"
  },
  {
    "codigo":94424006,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE MÚSCULO DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":782552007,
    "descripcion":"ALERGIA A ASERRÍN"
  },
  {
    "codigo":289197000,
    "descripcion":"FALTA DE FLUIDEZ EN EL HABLA"
  },
  {
    "codigo":715181000,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR COLUTORIO"
  },
  {
    "codigo":258264009,
    "descripcion":"EXTENSIÓN MÍNIMA"
  },
  {
    "codigo":127192009,
    "descripcion":"LINFADENOPATÍA AXILAR APICAL"
  },
  {
    "codigo":1081341000119101,
    "descripcion":"OSTEOSARCOMA PRIMARIO DE HUESO DE MANO DERECHA"
  },
  {
    "codigo":92589000,
    "descripcion":"CARCINOMA IN SITU DE LAS VÍAS BILIARES EXTRAHEPÁTICAS"
  },
  {
    "codigo":713346006,
    "descripcion":"LESIÓN TÉRMICA"
  },
  {
    "codigo":189058007,
    "descripcion":"NEOPLASIA BENIGNA DE LA PIEL DEL MEATO AUDITIVO EXTERNO"
  },
  {
    "codigo":254594009,
    "descripcion":"HAMARTOMA DEL INTESTINO"
  },
  {
    "codigo":1137495004,
    "descripcion":"CALCIFICACIÓN PUNTEADA DE FALANGE DE DEDO DE PIE"
  },
  {
    "codigo":187223005,
    "descripcion":"MIASIS AURICULAR"
  },
  {
    "codigo":285527007,
    "descripcion":"NO MUEVE LA LENGUA REPETIDAMENTE"
  },
  {
    "codigo":414764000,
    "descripcion":"CADENAS LIVIANAS KAPPA LIBRE MONOCLONALES DETECTADAS"
  },
  {
    "codigo":185388001,
    "descripcion":"EXAMEN DE SEGUIMIENTO NORMAL"
  },
  {
    "codigo":283692004,
    "descripcion":"MORDEDURA HUMANA EN LA NARIZ"
  },
  {
    "codigo":609537003,
    "descripcion":"HIPERSENSIBILIDAD NO ALÉRGICA A INHIBIDOR DE ENZIMA CONVERTIDORA DE ANGIOTENSINA"
  },
  {
    "codigo":281857003,
    "descripcion":"HEMATURIA MICROSCÓPICA PERSISTENTE"
  },
  {
    "codigo":183553003,
    "descripcion":"DERIVADO AL CIRUJANO DE TÓRAX"
  },
  {
    "codigo":1363201007,
    "descripcion":"FRACTURA EXPUESTA POR ESTALLIDO DE ÓRBITA"
  },
  {
    "codigo":771542000,
    "descripcion":"EXTREMIDAD FRÍA"
  },
  {
    "codigo":249089009,
    "descripcion":"PRESENTACIÓN DE BOCA DEL FETO"
  },
  {
    "codigo":871681009,
    "descripcion":"REACCIÓN ADVERSA A INTERFERÓN GAMMA-1B"
  },
  {
    "codigo":83414005,
    "descripcion":"ANEMIA MACROCÍTICA"
  },
  {
    "codigo":704171000,
    "descripcion":"FRACTURA PATOLÓGICA DE EPÍFISIS PROXIMAL DE FÉMUR"
  },
  {
    "codigo":81579003,
    "descripcion":"INTOXICACIÓN POR ACACIA GEORGINAE"
  },
  {
    "codigo":442027008,
    "descripcion":"INFLAMACIÓN CUTÁNEA POR PARÁSITOS"
  },
  {
    "codigo":866176003,
    "descripcion":"ADENOCARCINOMA DE CÉLULAS CLARAS DE PERITONEO"
  },
  {
    "codigo":1259392004,
    "descripcion":"CISTADENOCARCINOMA PAPILAR PRIMARIO DE RIÑÓN"
  },
  {
    "codigo":210816005,
    "descripcion":"LESIÓN DE LA VENA ILÍACA INTERNA"
  },
  {
    "codigo":733269001,
    "descripcion":"LACERACIÓN DE MUSLO CON CUERPO EXTRAÑO"
  },
  {
    "codigo":208981003,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN DE TOBILLO"
  },
  {
    "codigo":12373006,
    "descripcion":"BARTOLINITIS GONOCÓCICA CRÓNICA"
  },
  {
    "codigo":405589007,
    "descripcion":"PERFORACIÓN INFLAMATORIA DE INTESTINO DELGADO"
  },
  {
    "codigo":698666002,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: INUPIAQ"
  },
  {
    "codigo":43306002,
    "descripcion":"ABORTO ESPONTÁNEO COMPLICADO POR EMBOLIA"
  },
  {
    "codigo":305450004,
    "descripcion":"BAJO ATENCIÓN DE MÉDICO"
  },
  {
    "codigo":291121000119103,
    "descripcion":"MONOPLEJÍA DE MIEMBRO SUPERIOR DEBIDA A ACCIDENTE CEREBROVASCULAR Y POSTERIOR A ÉL"
  },
  {
    "codigo":76074006,
    "descripcion":"AGENESIA DEL PULMÓN DERECHO"
  },
  {
    "codigo":762367000,
    "descripcion":"PROLAPSO DE OJO DERECHO CONCOMITANTE CON LACERACIÓN"
  },
  {
    "codigo":238079002,
    "descripcion":"HIPERCOLESTEROLEMIA FAMILIAR - HETEROCIGOTA"
  },
  {
    "codigo":205311003,
    "descripcion":"BRAQUIDACTILIA DE TRES FALANGES"
  },
  {
    "codigo":203476003,
    "descripcion":"OSTEONECROSIS DE CABEZA DE FÉMUR"
  },
  {
    "codigo":400084008,
    "descripcion":"NEOPLASIA VASCULAR DE PIERNA"
  },
  {
    "codigo":365481000,
    "descripcion":"COMPOSICIÓN FAMILIAR - HALLAZGO"
  },
  {
    "codigo":5033003,
    "descripcion":"FUNCIÓN DE EXCRECIÓN AUSENTE"
  },
  {
    "codigo":234409003,
    "descripcion":"ANOMALÍA DE LA MEMBRANA DEL ERITROCITO"
  },
  {
    "codigo":299945006,
    "descripcion":"GRAFESTESIA ALTERADA"
  },
  {
    "codigo":10750411000119102,
    "descripcion":"MASTITIS NO PURULENTA ASOCIADA CON LA LACTANCIA"
  },
  {
    "codigo":68734002,
    "descripcion":"LESIÓN TRAUMÁTICA DE INTESTINO DELGADO SIN HERIDA ABIERTA HACIA CAVIDAD ABDOMINAL"
  },
  {
    "codigo":199806003,
    "descripcion":"TRABAJO DE PARTO OBSTRUIDO POR FETO INUSUALMENTE GRANDE"
  },
  {
    "codigo":134270004,
    "descripcion":"LEE ESPAÑOL"
  },
  {
    "codigo":363646005,
    "descripcion":"MEDIASTINO ENSANCHADO"
  },
  {
    "codigo":724094005,
    "descripcion":"SÍNDROME DE DIABETES NEONATAL, HIPOTIROIDISMO CONGÉNITO, GLAUCOMA CONGÉNITO, FIBROSIS HEPÁTICA Y RIÑÓN POLIQUÍSTICO"
  },
  {
    "codigo":230739000,
    "descripcion":"APOPLEJÍA DE MÉDULA ESPINAL"
  },
  {
    "codigo":296275007,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE OXIPERTINA"
  },
  {
    "codigo":425512003,
    "descripcion":"CÓRNEA SECA"
  },
  {
    "codigo":65064003,
    "descripcion":"TRASTORNO DE PÁNICO SIN AGORAFOBIA CON ATAQUES DE PÁNICO MODERADOS"
  },
  {
    "codigo":294440007,
    "descripcion":"ALERGIA A SURFACTANTE DE PIRIDINIO CUATERNARIO"
  },
  {
    "codigo":390909000,
    "descripcion":"EXTRUSIÓN POR CERCLAJE ESCLERAL"
  },
  {
    "codigo":292605001,
    "descripcion":"REACCIÓN ADVERSA A UN ANTITUSÍGENO"
  },
  {
    "codigo":196136009,
    "descripcion":"ENFERMEDAD PULMONAR CONCOMITANTE CON POLIMIOSITIS"
  },
  {
    "codigo":1144573006,
    "descripcion":"HIPOPLASIA CONGÉNITA DE MÚSCULO DE CUELLO"
  },
  {
    "codigo":94162004,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA MÉDULA SUPRARRENAL"
  },
  {
    "codigo":290770005,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR VINDESINA"
  },
  {
    "codigo":28626004,
    "descripcion":"FÍSTULA VESICOCOLÓNICA"
  },
  {
    "codigo":1306578004,
    "descripcion":"CARCINOMA DUCTAL INFILTRANTE DE CUADRANTE INFERIOR INTERNO DE MAMA"
  },
  {
    "codigo":92327004,
    "descripcion":"NEOPLASIA BENIGNA DEL LÓBULO INFERIOR DERECHO DEL PULMÓN"
  },
  {
    "codigo":190631007,
    "descripcion":"DEFICIENCIA DEL COMPLEJO VITAMÍNICO B"
  },
  {
    "codigo":24956004,
    "descripcion":"SÍNDROME DE LOCULACIÓN"
  },
  {
    "codigo":1237372005,
    "descripcion":"METÁSTASIS DE CARCINOMA DE VAGINA"
  },
  {
    "codigo":713084008,
    "descripcion":"NEUMONÍA CAUSADA POR CORONAVIRUS HUMANO"
  },
  {
    "codigo":188796009,
    "descripcion":"TUMOR BENIGNO DEL PILAR AMIGDALINO POSTERIOR"
  },
  {
    "codigo":285265004,
    "descripcion":"PLANES PELIGROSOS"
  },
  {
    "codigo":283430000,
    "descripcion":"CORTE EN EXTREMIDAD INFERIOR"
  },
  {
    "codigo":21286004,
    "descripcion":"AMPOLLA DE PABELLÓN AURICULAR, SIN INFECCIÓN"
  },
  {
    "codigo":447270007,
    "descripcion":"CIERRE ESPONTÁNEO DE AGUJERO OVAL"
  },
  {
    "codigo":709414007,
    "descripcion":"DEFICIENCIA DE COMPLEJO MITOCONDRIAL III"
  },
  {
    "codigo":281595001,
    "descripcion":"TROMBOSIS DE VENA CAVA INFERIOR"
  },
  {
    "codigo":52219002,
    "descripcion":"INTOXICACIÓN POR GOMPHRENA CELOSIODES"
  },
  {
    "codigo":840486008,
    "descripcion":"RETRACCIÓN ANORMAL CONGÉNITA DE AMBOS PÁRPADOS"
  },
  {
    "codigo":707579001,
    "descripcion":"CARCINOMA BASALOIDE PRIMARIO DE CÉLULAS ESCAMOSAS DE OROFARINGE"
  },
  {
    "codigo":248827002,
    "descripcion":"PEZÓN PEQUEÑO"
  },
  {
    "codigo":181456001,
    "descripcion":"TRASTORNO ANTIPROTROMBINA"
  },
  {
    "codigo":445435009,
    "descripcion":"VÉRTICE CARDÍACO POR DETRÁS DE LA BASE CARDÍACA"
  },
  {
    "codigo":246992005,
    "descripcion":"INFLAMACIÓN DE LA CÁMARA ANTERIOR"
  },
  {
    "codigo":17616007,
    "descripcion":"FRACTURA DE HUESO ILÍACO, NO EXPUESTA"
  },
  {
    "codigo":48549003,
    "descripcion":"FIBROSIS DE LA TÚNICA VAGINAL"
  },
  {
    "codigo":15750041000119101,
    "descripcion":"BEBÉ PREMATURO, 29 SEMANAS"
  },
  {
    "codigo":1259130000,
    "descripcion":"TRASTORNO AUTONÓMICO DEBIDO A SÍNDROME DE ABSTINENCIA DE SUSTANCIA"
  },
  {
    "codigo":472698002,
    "descripcion":"SÍNDROME PARATRIGEMINAL TIPO II"
  },
  {
    "codigo":308858003,
    "descripcion":"DISPLASIA LEVE DE ESÓFAGO"
  },
  {
    "codigo":210554004,
    "descripcion":"LESIÓN POR DESOLLAMIENTO DE REGIÓN DE CODO"
  },
  {
    "codigo":11844351000119109,
    "descripcion":"AMPOLLA DE OREJA DERECHA CON INFECCIÓN"
  },
  {
    "codigo":276090009,
    "descripcion":"NO APTO PARA TODO SERVICIO"
  },
  {
    "codigo":765775002,
    "descripcion":"DISPLASIA DE RIÑÓN IZQUIERDO"
  },
  {
    "codigo":208719004,
    "descripcion":"FRACTURA DE DEDO GORDO"
  },
  {
    "codigo":896847008,
    "descripcion":"FORMA TRIANGULAR ANORMAL CONGÉNITA DE EPÍFISIS DE FALANGE PROXIMAL DE MANO"
  },
  {
    "codigo":1157156002,
    "descripcion":"LINFANGIOMA CAVERNOSO"
  },
  {
    "codigo":403492006,
    "descripcion":"LUPUS ERITEMATOSO DISCOIDE TIPO HIPERTRÓFICO"
  },
  {
    "codigo":272420008,
    "descripcion":"TUMOR MUY GRANDE"
  },
  {
    "codigo":1351929005,
    "descripcion":"UN SOLO NACIDO VIVO DE EMBARAZO MÚLTIPLE"
  },
  {
    "codigo":237817008,
    "descripcion":"PUBERTAD PRECOZ CENTRAL IDIOPÁTICA"
  },
  {
    "codigo":1153486004,
    "descripcion":"BICARBONATO SÉRICO POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":301518004,
    "descripcion":"SALE DE LA DUCHA"
  },
  {
    "codigo":1217187000,
    "descripcion":"PERIOSTITIS DE PIE"
  },
  {
    "codigo":235982008,
    "descripcion":"ESTENOSIS DE ANASTOMOSIS DE CONDUCTO PANCREÁTICO"
  },
  {
    "codigo":299683005,
    "descripcion":"PELVIS CONGELADA MALIGNA"
  },
  {
    "codigo":365219005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA ENTENDER LAS EMOCIONES PROPIAS"
  },
  {
    "codigo":103075007,
    "descripcion":"DEFECTO INMUNOLÓGICO HUMORAL"
  },
  {
    "codigo":232312000,
    "descripcion":"RUBÉOLA ENDOCOCLEAR"
  },
  {
    "codigo":4771009,
    "descripcion":"INTOXICACIÓN CAUSADA POR ANTIBIÓTICO DEL GRUPO DE LAS CEFALOSPORINAS"
  },
  {
    "codigo":135843006,
    "descripcion":"EXACERBACIÓN DE ECCEMA"
  },
  {
    "codigo":35704000,
    "descripcion":"INTOXICACIÓN POR BOWIEA"
  },
  {
    "codigo":396152005,
    "descripcion":"ANTÍGENO PROSTÁTICO ESPECÍFICO POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":363384006,
    "descripcion":"NEOPLASIA MALIGNA DE ENCÍA DE MAXILAR INFERIOR"
  },
  {
    "codigo":428920008,
    "descripcion":"CAPTACIÓN PULMONAR DEL TRAZADOR AUMENTADA"
  },
  {
    "codigo":263245004,
    "descripcion":"FRACTURA DE HUESO DEL TARSO"
  },
  {
    "codigo":230477005,
    "descripcion":"CEFALEA CRÓNICA POSTRAUMÁTICA"
  },
  {
    "codigo":66637005,
    "descripcion":"HEMIBALISMO"
  },
  {
    "codigo":197709005,
    "descripcion":"SÍNDROME NEFRÍTICO CRÓNICO, LESIONES GLOMERULARES FOCALES Y SEGMENTARIAS"
  },
  {
    "codigo":164941008,
    "descripcion":"ELECTROCARDIOGRAMA: ONDA F AUSENTE"
  },
  {
    "codigo":294178000,
    "descripcion":"ALERGIA A CALCIPOTRIOL"
  },
  {
    "codigo":62967000,
    "descripcion":"INTENSIDAD DEL SOPLO CARDÍACO, GRADO VI"
  },
  {
    "codigo":1144311003,
    "descripcion":"FRENTE INCLINADA"
  },
  {
    "codigo":95735008,
    "descripcion":"ESTROMA CORNEAL NEBULOSO"
  },
  {
    "codigo":716492001,
    "descripcion":"COMPRENDE UN MATERIAL ESCRITO"
  },
  {
    "codigo":93900000,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE MÚSCULO DE LA NALGA"
  },
  {
    "codigo":30199009,
    "descripcion":"GLOSOLALIA"
  },
  {
    "codigo":290508001,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR ENFLURANO"
  },
  {
    "codigo":224972005,
    "descripcion":"SENSACIÓN DE AMARGURA"
  },
  {
    "codigo":1306316005,
    "descripcion":"NEOPLASIA BENIGNA DE PEZÓN"
  },
  {
    "codigo":126668007,
    "descripcion":"NEOPLASIA DE LAS VÍAS RESPIRATORIAS SUPERIORES"
  },
  {
    "codigo":714657003,
    "descripcion":"CON MAYOR RIESGO DE LESIÓN POR RADIACIÓN"
  },
  {
    "codigo":92065004,
    "descripcion":"NEOPLASIA BENIGNA DEL COLON"
  },
  {
    "codigo":288673004,
    "descripcion":"RESTABLECE LA CONVERSACIÓN"
  },
  {
    "codigo":24694001,
    "descripcion":"INTOXICACIÓN POR ACACIA NILOTICA"
  },
  {
    "codigo":15998311000119103,
    "descripcion":"TRASTORNO DE LA MÁCULA DEL OJO IZQUIERDO"
  },
  {
    "codigo":286838008,
    "descripcion":"TIENDE A GUARDAR RENCOR"
  },
  {
    "codigo":285003003,
    "descripcion":"CAPAZ DE DESABROCHAR LA ROPA"
  },
  {
    "codigo":416075005,
    "descripcion":"INSCRIPTO EN REGISTRO DE DISCAPACIDAD DE APRENDIZAJE"
  },
  {
    "codigo":448843007,
    "descripcion":"TÚNEL AORTOVENTRICULAR IZQUIERDO CON ANEURISMA DE PARED SEPTAL INTRACARDÍACA Y DE PARED AÓRTICA EXTRACARDÍACA"
  },
  {
    "codigo":874827008,
    "descripcion":"CUERPO EXTRAÑO SUPERFICIAL EN VULVA"
  },
  {
    "codigo":53792000,
    "descripcion":"FRACTURA NO EXPUESTA DE DIÁFISIS DE CÚBITO"
  },
  {
    "codigo":1088871000119105,
    "descripcion":"OBSTRUCCIÓN EXTRÍNSECA DE TROMPA DE EUSTAQUIO IZQUIERDA"
  },
  {
    "codigo":250400003,
    "descripcion":"TIPO ANTIGÉNICO DE BAJA INCIDENCIA"
  },
  {
    "codigo":1004064005,
    "descripcion":"CONTRACTURA EN FLEXIÓN PLANTAR DE ARTICULACIÓN DE TOBILLO"
  },
  {
    "codigo":283168006,
    "descripcion":"CUERPO EXTRAÑO METÁLICO EN EL TÓRAX"
  },
  {
    "codigo":19189001,
    "descripcion":"PLACER PREVIO AL ACTO SEXUAL"
  },
  {
    "codigo":838389001,
    "descripcion":"ABSCESO DE ESPACIO SUBDURAL ESPINAL CAUSADO POR BACTERIA"
  },
  {
    "codigo":281333005,
    "descripcion":"NO SE SUMINISTRÓ EL NÚMERO DE CONTACTO"
  },
  {
    "codigo":50122000,
    "descripcion":"SÍNDROME CEREBRAL METABÓLICO"
  },
  {
    "codigo":1002229008,
    "descripcion":"MILIARIA APOCRINA DE ARÉOLA"
  },
  {
    "codigo":84725008,
    "descripcion":"MIOCARDIOPATÍA RESTRICTIVA DEBIDA A MUCOPOLISACARIDOSIS"
  },
  {
    "codigo":17354003,
    "descripcion":"ABSCESO DE HOMBRO"
  },
  {
    "codigo":246730006,
    "descripcion":"ESTRABISMO DIVERGENTE ALTERNANTE MANIFIESTO"
  },
  {
    "codigo":277663005,
    "descripcion":"PÉRDIDA DE LA AUDICIÓN SIMULADA"
  },
  {
    "codigo":769183005,
    "descripcion":"RETINOPATÍA NO PROLIFERATIVA LEVE DEL OJO DERECHO DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":243060000,
    "descripcion":"LESIÓN POR ARMA LÁSER"
  },
  {
    "codigo":408735009,
    "descripcion":"ECTROPIÓN DEL TARSO DEL PÁRPADO INFERIOR"
  },
  {
    "codigo":372297000,
    "descripcion":"AUSENCIA DE INVASIÓN TUMORAL EN EL TEJIDO PERINEURAL (PRÓSTATA)"
  },
  {
    "codigo":110153003,
    "descripcion":"ABRASIÓN DEL VESTÍBULO MAXILAR"
  },
  {
    "codigo":208457003,
    "descripcion":"FRACTURA NO EXPUESTA DE LA FALANGE DISTAL DE DEDO DE LA MANO, DIÁFISIS"
  },
  {
    "codigo":11849007,
    "descripcion":"RITMO DE LA UNIÓN AURICULOVENTRICULAR"
  },
  {
    "codigo":403230002,
    "descripcion":"HALLAZGO DE TOLERANCIA SOLAR CONSTITUCIONAL"
  },
  {
    "codigo":12367361000119109,
    "descripcion":"ARTROSIS DE ARTICULACIÓN ROTULOFEMORAL DERECHA"
  },
  {
    "codigo":204787003,
    "descripcion":"AUSENCIA CONGÉNITA DE HÍGADO Y VESÍCULA BILIAR"
  },
  {
    "codigo":237555006,
    "descripcion":"HIPOTIROIDISMO POR DEFECTO DE ATRAPAMIENTO DE YODO"
  },
  {
    "codigo":1351667006,
    "descripcion":"AGAMMAGLOBULINEMIA AUTOSÓMICA RECESIVA DEBIDA A DEFICIENCIA DE FACTOR DE TRANSCRIPCIÓN E47"
  },
  {
    "codigo":1220595008,
    "descripcion":"SÍNDROME DE CATARATA, DEFICIENCIA DE HORMONA DE CRECIMIENTO, NEUROPATÍA SENSITIVA, HIPOACUSIA NEUROSENSORIAL Y DISPLASIA ESQUELÉTICA"
  },
  {
    "codigo":301256004,
    "descripcion":"HALLAZGO PLEURAL"
  },
  {
    "codigo":170184004,
    "descripcion":"EXAMEN A LOS 15 AÑOS ANORMAL - EN TRATAMIENTO"
  },
  {
    "codigo":39112005,
    "descripcion":"DEFICIENCIA DE GLUTATIÓN SINTASA CON 5 - OXOPROLINURIA"
  },
  {
    "codigo":432328008,
    "descripcion":"NEUROBLASTOMA"
  },
  {
    "codigo":201117001,
    "descripcion":"UÑA EN CÁSCARA DE HUEVO"
  },
  {
    "codigo":235720008,
    "descripcion":"MALABSORCIÓN DEBIDA A INTOLERANCIA A HIDRATO DE CARBONO"
  },
  {
    "codigo":364957006,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA MOVER LA LENGUA"
  },
  {
    "codigo":233885007,
    "descripcion":"PERICARDITIS POSTERIOR A INFARTO"
  },
  {
    "codigo":168349006,
    "descripcion":"CULTIVO DE HISOPADO VAGINAL PROFUNDO: GARDNERELLA VAGINALIS"
  },
  {
    "codigo":232050001,
    "descripcion":"DISTROFIA MACULAR EN OJO DE BUEY"
  },
  {
    "codigo":461426002,
    "descripcion":"POSICIÓN NORMAL DE ORIFICIO DE ARTERIA CORONARIA"
  },
  {
    "codigo":35442005,
    "descripcion":"FRACTURA NO EXPUESTA DE EXTREMO DISTAL DE ANTEBRAZO"
  },
  {
    "codigo":68210006,
    "descripcion":"HIPOPIGMENTACIÓN DE PÁRPADO"
  },
  {
    "codigo":428658005,
    "descripcion":"ATENDIDO EN CONSULTORIO COMUNITARIO ESPECIALIZADO EN PATOLOGÍA RESPIRATORIA"
  },
  {
    "codigo":262983003,
    "descripcion":"DIVISIÓN TRAUMÁTICA DE TENDÓN"
  },
  {
    "codigo":295751003,
    "descripcion":"SOBREDOSIS DE RAZOXANO"
  },
  {
    "codigo":721735004,
    "descripcion":"INFECCIÓN CAUSADA POR BACILLUS CEREUS"
  },
  {
    "codigo":230215006,
    "descripcion":"CISTICERCOSIS CEREBRAL"
  },
  {
    "codigo":681781000119104,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE CURVATURA MENOR DEL ESTÓMAGO"
  },
  {
    "codigo":162844000,
    "descripcion":"PUBERTAD NORMAL"
  },
  {
    "codigo":293916001,
    "descripcion":"ALERGIA A CLOZAPINA"
  },
  {
    "codigo":64540004,
    "descripcion":"LIQUEN PLANOPILOSO"
  },
  {
    "codigo":31772005,
    "descripcion":"LESIONES CICATRIZALES DE LA PIEL PROVOCADAS POR PINTA"
  },
  {
    "codigo":128241005,
    "descripcion":"HEPATITIS"
  },
  {
    "codigo":95473006,
    "descripcion":"ANOMALÍA CONGÉNITA DE LA MANDÍBULA"
  },
  {
    "codigo":718065008,
    "descripcion":"PERIODONTITIS AGUDA SEVERA GENERALIZADA"
  },
  {
    "codigo":28102002,
    "descripcion":"DISTRACTIBILIDAD"
  },
  {
    "codigo":93638003,
    "descripcion":"MELANOMA MALIGNO DE LA PIEL DE LA RODILLA"
  },
  {
    "codigo":716230005,
    "descripcion":"SÍNDROME DE ONFALOCELE DE SHPRINTZEN GOLDBERG"
  },
  {
    "codigo":16711631000119103,
    "descripcion":"NEOVASCULARIZACIÓN DE LA RETINA DEBIDA A OCLUSIÓN DE RAMAS DE VENAS RETINIANAS DE AMBOS OJOS"
  },
  {
    "codigo":290246007,
    "descripcion":"ANEMIA SIDEROPÉNICA CON SIDEROSIS RETICULOENDOTELIAL"
  },
  {
    "codigo":59035004,
    "descripcion":"MALFORMACIÓN CONGÉNITA DEL APARATO GENITAL FEMENINO"
  },
  {
    "codigo":26267006,
    "descripcion":"HIPOPARATIROIDISMO NEONATAL PERSISTENTE AISLADO"
  },
  {
    "codigo":188272000,
    "descripcion":"NEOPLASIA MALIGNA DE GLÁNDULA LAGRIMAL"
  },
  {
    "codigo":253808004,
    "descripcion":"TORSIÓN CONGÉNITA DE CONDUCTO CÍSTICO"
  },
  {
    "codigo":88133006,
    "descripcion":"INTOXICACIÓN POR ROBINIA VISCOSA"
  },
  {
    "codigo":284741007,
    "descripcion":"DEGLUCIÓN DE SUSTANCIAS"
  },
  {
    "codigo":186437007,
    "descripcion":"INFECCIÓN POR PROTEUS"
  },
  {
    "codigo":444911000,
    "descripcion":"LEUCEMIA MIELOIDE AGUDA CON T(9:11)(P22;Q23); MLLT3-MLL"
  },
  {
    "codigo":250138009,
    "descripcion":"HALLAZGO EN EL CALZADO"
  },
  {
    "codigo":51695002,
    "descripcion":"INFESTACIÓN CAUSADA POR GASTEROPHILUS NASALIS"
  },
  {
    "codigo":1296879003,
    "descripcion":"MELORREOSTOSIS DE HÚMERO"
  },
  {
    "codigo":1264111004,
    "descripcion":"AMPOLLA TRAUMÁTICA DE DEDO MEÑIQUE DERECHO"
  },
  {
    "codigo":18927009,
    "descripcion":"ENFERMEDAD DE NIEMANN - PICK, TIPO D"
  },
  {
    "codigo":770756008,
    "descripcion":"SÍNDROME DE MICRODELECIÓN 2P13.2"
  },
  {
    "codigo":1293209001,
    "descripcion":"HIPERPLASIA MELANOCÍTICA ATÍPICA DE PIEL"
  },
  {
    "codigo":11851881000119107,
    "descripcion":"CONTUSIÓN DE MITAD IZQUIERDA DE PARED TORÁCICA POSTERIOR"
  },
  {
    "codigo":703385008,
    "descripcion":"ORIGEN ANÓMALO DE ARTERIA PULMONAR EN AORTA ASCENDENTE"
  },
  {
    "codigo":439406006,
    "descripcion":"ALERGIA A MEGLITINIDA"
  },
  {
    "codigo":767086009,
    "descripcion":"SEGUNDO VASO LÍMPIDO"
  },
  {
    "codigo":208195001,
    "descripcion":"FRACTURA EXPUESTA DE PELVIS, ALA ILÍACA"
  },
  {
    "codigo":109891004,
    "descripcion":"SEPARACIÓN DEL PRODUCTO DE LA CONCEPCIÓN"
  },
  {
    "codigo":699715007,
    "descripcion":"ARCADA MAXILAR ANCHA"
  },
  {
    "codigo":402968000,
    "descripcion":"ERITEMA NUDOSO DEBIDO A INFECCIÓN BACTERIANA"
  },
  {
    "codigo":77123007,
    "descripcion":"LINFOEDEMA PRECOZ"
  },
  {
    "codigo":304664003,
    "descripcion":"CAPAZ DE EMPLEAR RAZONAMIENTO VERBAL"
  },
  {
    "codigo":239128003,
    "descripcion":"HAMARTOMA MONILIFORME"
  },
  {
    "codigo":15921411000119106,
    "descripcion":"RETINOPATÍA BILATERAL CAUSADA POR HIDROXICLOROQUINA"
  },
  {
    "codigo":237293000,
    "descripcion":"HEMATOMA RETROPLACENTARIO"
  },
  {
    "codigo":106221001,
    "descripcion":"HALLAZGO GENÉTICO"
  },
  {
    "codigo":1254936009,
    "descripcion":"PSEUDOXANTOMA ELÁSTICO DEBIDO A HEMOGLOBINOPATÍA"
  },
  {
    "codigo":7917000,
    "descripcion":"INFESTACIÓN CAUSADA POR SARCOPTES SCABIEI VARIEDAD OVIS"
  },
  {
    "codigo":69985008,
    "descripcion":"ADHERENCIAS DEL CUELLO UTERINO"
  },
  {
    "codigo":1187565005,
    "descripcion":"ENFERMEDAD DE CHARCOT MARIE TOOTH AUTOSÓMICA DOMINANTE TIPO 2Y"
  },
  {
    "codigo":73453007,
    "descripcion":"COMA IRREVERSIBLE"
  },
  {
    "codigo":827117008,
    "descripcion":"OFTALMOPLEJÍA EXTERNA PROGRESIVA AUTOSÓMICA RECESIVA"
  },
  {
    "codigo":300994001,
    "descripcion":"REGISTRADO COMO: CON VISIÓN PARCIAL"
  },
  {
    "codigo":432066002,
    "descripcion":"TRASTORNO PULMONAR DEBIDO A TRASTORNO AUTOINMUNITARIO"
  },
  {
    "codigo":270061008,
    "descripcion":"FP13 - EX REGISTRADO EN FUERZAS HM"
  },
  {
    "codigo":366530002,
    "descripcion":"AMPLITUD DE MOVIMIENTO ACTIVO DE ABDUCCIÓN DE LA MUÑECA - HALLAZGO"
  },
  {
    "codigo":202690000,
    "descripcion":"ESPONDILOSIS DORSAL EN DOS NIVELES CON RADICULOPATÍA"
  },
  {
    "codigo":302829009,
    "descripcion":"ADENOMA DEL PEZÓN"
  },
  {
    "codigo":38850007,
    "descripcion":"ARTROPATÍA CRÓNICA"
  },
  {
    "codigo":233623000,
    "descripcion":"NEUMONITIS INTERSTICIAL MONONUCLEAR"
  },
  {
    "codigo":299159003,
    "descripcion":"AMPLITUD DE EXTENSIÓN PASIVA DEL PULGAR DISMINUIDA"
  },
  {
    "codigo":102551008,
    "descripcion":"CALAMBRES MUSCULARES EN EL PIE"
  },
  {
    "codigo":723308003,
    "descripcion":"EPIDERMÓLISIS BULLOSA SIMPLE CON DISTROFIA MUSCULAR"
  },
  {
    "codigo":264556007,
    "descripcion":"NEUROPATÍA OCULTA"
  },
  {
    "codigo":721473001,
    "descripcion":"SÍNDROME DEL CORDÓN POSTERIOR DE MÉDULA ESPINAL AL NIVEL DEL QUINTO SEGMENTO DORSAL"
  },
  {
    "codigo":262721007,
    "descripcion":"HEMATOMA SUBDURAL TRAUMÁTICO DE MÉDULA ESPINAL"
  },
  {
    "codigo":197185008,
    "descripcion":"SAPONIFICACIÓN DE GRASA MESENTÉRICA"
  },
  {
    "codigo":295489007,
    "descripcion":"SOBREDOSIS INTENCIONAL DE ANTIESPASMÓDICO"
  },
  {
    "codigo":293654003,
    "descripcion":"ALERGIA A INHIBIDOR DE ATPASA DE INTERCAMBIO DE H+\/K+"
  },
  {
    "codigo":129814003,
    "descripcion":"TALLA ANORMAL PARA LA EDAD"
  },
  {
    "codigo":719638005,
    "descripcion":"LENGUA AZUL"
  },
  {
    "codigo":291819001,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR METFORMINA"
  },
  {
    "codigo":95211004,
    "descripcion":"PÓLIPO DEL MEATO AUDITIVO EXTERNO"
  },
  {
    "codigo":160747005,
    "descripcion":"SIN CUIDADOR PERO NO SOLO"
  },
  {
    "codigo":93376000,
    "descripcion":"DESALINEAMIENTO CONGÉNITO DEL PALADAR RUGOSO"
  },
  {
    "codigo":289984003,
    "descripcion":"CAPAZ DE USAR BACINILLA"
  },
  {
    "codigo":224448005,
    "descripcion":"EL EMPLEADOR ES COMPASIVO ANTE EL PROBLEMA DE SALUD"
  },
  {
    "codigo":191680007,
    "descripcion":"PSICOSIS PARANOIDE PSICÓGENA"
  },
  {
    "codigo":124309005,
    "descripcion":"DEFICIENCIA DE SEDOHEPTULOCINASA"
  },
  {
    "codigo":91541006,
    "descripcion":"ABSCESO DE TALÓN"
  },
  {
    "codigo":10625591000119108,
    "descripcion":"BRONCONEUMONÍA CAUSADA POR STAPHYLOCOCCUS"
  },
  {
    "codigo":165264081000119102,
    "descripcion":"CARCINOMA ESCAMOCELULAR IN SITU DE PIEL DE PIE IZQUIERDO"
  },
  {
    "codigo":286314001,
    "descripcion":"CAPAZ DE UTILIZAR COMBINACIONES DE VOCALES Y CONSONANTES"
  },
  {
    "codigo":1269354002,
    "descripcion":"HIPERSENSIBILIDAD A ERITROMICINA"
  },
  {
    "codigo":253546004,
    "descripcion":"OBSTRUCCIÓN DEL TRACTO DE SALIDA DEL VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":16906961000119103,
    "descripcion":"NEVO MELANOCÍTICO DE PÁRPADO SUPERIOR DERECHO"
  },
  {
    "codigo":218943000,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR CATÁRTICO EMOLIENTE"
  },
  {
    "codigo":417386009,
    "descripcion":"COMPONENTE LESIONADO"
  },
  {
    "codigo":186175002,
    "descripcion":"TUBERCULOSIS PULMONAR INFILTRATIVA"
  },
  {
    "codigo":120639003,
    "descripcion":"SÍNDROME DE HANTAVIRUS PULMONAR"
  },
  {
    "codigo":448319002,
    "descripcion":"LINFOMA NO HODGKIN DIFUSO DE NASOFARINGE"
  },
  {
    "codigo":315412001,
    "descripcion":"NACIDO EN LA REPÚBLICA CHECA"
  },
  {
    "codigo":249876002,
    "descripcion":"DESVIACIÓN LATERAL DE LA LENGUA EN PROTRUSIÓN"
  },
  {
    "codigo":413716003,
    "descripcion":"UVEÍTIS POR BRUCELOSIS"
  },
  {
    "codigo":282644006,
    "descripcion":"DIFICULTAD PARA AGACHARSE"
  },
  {
    "codigo":18665000,
    "descripcion":"EROSIÓN AGUDA DE LA MUCOSA GÁSTRICA"
  },
  {
    "codigo":1362153003,
    "descripcion":"METABOLIZADOR INTERMEDIO DE FAMILIA 2 SUBFAMILIA C MIEMBRO 9 *1\/*5 DE CITOCROMO P450"
  },
  {
    "codigo":248041005,
    "descripcion":"CONDUCTA DESAFIANTE"
  },
  {
    "codigo":1296617008,
    "descripcion":"HIPERTENSIÓN OCULAR BILATERAL DEBIDA A PSEUDOEXFOLIACIÓN"
  },
  {
    "codigo":278974001,
    "descripcion":"INMUNE A HEPATITIS C"
  },
  {
    "codigo":410046007,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE LA ARTICULACIÓN ESCAPULOTORÁCICA"
  },
  {
    "codigo":82366009,
    "descripcion":"ALTERACIÓN EN EL TRANSPORTE INTESTINAL A TRAVÉS DE LAS CÉLULAS EPITELIALES"
  },
  {
    "codigo":735891004,
    "descripcion":"ESGUINCE DE LIGAMENTO DE ARTICULACIÓN METATARSOFALÁNGICA DE DEDO GORDO DE PIE"
  },
  {
    "codigo":47763005,
    "descripcion":"FORÚNCULO DE LA REGIÓN DEL CUELLO"
  },
  {
    "codigo":34681000087101,
    "descripcion":"SALMONELLA ENTERICA, SUBESPECIE ARIZONAE O SALMONELLA ENTERICA, SUBESPECIE DIARIZONAE"
  },
  {
    "codigo":55161000087103,
    "descripcion":"CON MAYOR RIESGO DE DISTRÉS RESPIRATORIO"
  },
  {
    "codigo":39801000087106,
    "descripcion":"ABRASIÓN CUTÁNEA DE MITAD DERECHA DE PARED TORÁCICA POSTERIOR"
  },
  {
    "codigo":766824003,
    "descripcion":"ANOMALÍAS CONGÉNITAS MÚLTIPLES, DISCAPACIDAD INTELECTUAL Y TRASTORNO DEL ESPECTRO AUTISTA RELACIONADOS CON LA PROTEÍNA NEUROPROTECTORA DEPENDIENTE DE ACTIVIDAD HOMEOBOX"
  },
  {
    "codigo":42361000087108,
    "descripcion":"QUEMADURA DE ANEXOS OCULARES DERECHOS"
  },
  {
    "codigo":209768007,
    "descripcion":"PULGAR EN MARTILLO CON LESIÓN NO EXPUESTA DE TENDÓN"
  },
  {
    "codigo":13160009,
    "descripcion":"COMPLICACIÓN DE INTESTINO TRASPLANTADO"
  },
  {
    "codigo":240701006,
    "descripcion":"ASPERGILOSIS SISTÉMICA"
  },
  {
    "codigo":109629007,
    "descripcion":"BOLSILLO PERIODONTAL"
  },
  {
    "codigo":207933008,
    "descripcion":"FRACTURA EXPUESTA DE VÉRTEBRA CERVICAL, APÓFISIS TRANSVERSA"
  },
  {
    "codigo":764989007,
    "descripcion":"SÍNDROME DE TRISOMÍA 9 MOSAICO"
  },
  {
    "codigo":271634003,
    "descripcion":"PECTORILOQUIA ÁFONA"
  },
  {
    "codigo":402706007,
    "descripcion":"DERMATOSIS INFECCIOSA DE GENITALES FEMENINOS"
  },
  {
    "codigo":238866007,
    "descripcion":"ELASTOFIBROMATOSIS JUVENIL"
  },
  {
    "codigo":1187303004,
    "descripcion":"SÍNDROME PROGRESIVO DE DISPLASIA ESPONDILOEPIMETAFISARIA, TALLA BAJA, CUARTOS METATARSIANOS CORTOS Y DISCAPACIDAD INTELECTUAL"
  },
  {
    "codigo":1285607009,
    "descripcion":"HEMATOMA DE QUINTO DE DEDO DE PIE"
  },
  {
    "codigo":431804003,
    "descripcion":"PRESENTACIÓN ESCLERAL ADQUIRIDA POR DEFORMIDAD DEL PÁRPADO"
  },
  {
    "codigo":366268004,
    "descripcion":"HALLAZGO DE DESCENSO DE CUELLO VESICAL"
  },
  {
    "codigo":5820008,
    "descripcion":"ENTEROCOLITIS ISQUÉMICA AGUDA"
  },
  {
    "codigo":36753006,
    "descripcion":"PSEUDOTUBERCULOSIS"
  },
  {
    "codigo":397201007,
    "descripcion":"PRESENCIA DE MICROCALCIFICACIONES EN CARCINOMA DUCTAL IN SITU"
  },
  {
    "codigo":69521007,
    "descripcion":"SINOVITIS CREPITANTE CRÓNICA DE LA MUÑECA"
  },
  {
    "codigo":724881007,
    "descripcion":"LESIÓN TRAUMÁTICA DE FASCIA DEL TÓRAX"
  },
  {
    "codigo":298897008,
    "descripcion":"AMPLITUD DE EXTENSIÓN PASIVA DE CODO NORMAL"
  },
  {
    "codigo":231526007,
    "descripcion":"PERSONALIDAD FANÁTICA"
  },
  {
    "codigo":360763000,
    "descripcion":"DEFICIENCIA DE FOSFOMONOESTERASA"
  },
  {
    "codigo":33083001,
    "descripcion":"QUISTE HEMORRÁGICO DE MANDÍBULA"
  },
  {
    "codigo":426299001,
    "descripcion":"INTOXICACIÓN INTENCIONAL CON MEDIO DE CONTRASTE RADIOLÓGICO"
  },
  {
    "codigo":459067002,
    "descripcion":"ENDOCARDITIS INFECCIOSA DE VÁLVULA CARDÍACA"
  },
  {
    "codigo":297062008,
    "descripcion":"SOBREDOSIS DE DIGOXINA"
  },
  {
    "codigo":196923005,
    "descripcion":"HERNIA ISQUIORRECTAL IRREDUCTIBLE"
  },
  {
    "codigo":315443008,
    "descripcion":"NACIDO EN ISLANDIA"
  },
  {
    "codigo":424464000,
    "descripcion":"CONJUNTIVA CERRADA"
  },
  {
    "codigo":229691009,
    "descripcion":"DISARTRIA DE LA VELOFARINGE"
  },
  {
    "codigo":689311000119105,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE PALADAR BLANDO"
  },
  {
    "codigo":295227009,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE DICLOFENACO"
  },
  {
    "codigo":1145360004,
    "descripcion":"LESIÓN HIPOINTENSA DE TRONCO ENCEFÁLICO EN IMAGEN DE RESONANCIA MAGNÉTICA EN T2"
  },
  {
    "codigo":31248004,
    "descripcion":"EPIGNATO"
  },
  {
    "codigo":193253000,
    "descripcion":"MIOPATÍA POR ENFERMEDAD DE SJÖGREN"
  },
  {
    "codigo":719376008,
    "descripcion":"OSTEOMIELITIS HEMATÓGENA CRÓNICA"
  },
  {
    "codigo":293392008,
    "descripcion":"REACCIÓN ADVERSA AL ÁCIDO NICOTÍNICO"
  },
  {
    "codigo":94949004,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE MÚSCULO DE HOMBRO"
  },
  {
    "codigo":1010618000,
    "descripcion":"SINDACTILIA DE DEDOS DE LA MANO BILATERAL"
  },
  {
    "codigo":93114001,
    "descripcion":"FALTA DE OSIFICACIÓN DE HUESO PREESFENOIDAL"
  },
  {
    "codigo":291557009,
    "descripcion":"INTOXICACIÓN POR CEFALOSPORINA DE PRIMERA GENERACIÓN"
  },
  {
    "codigo":160485009,
    "descripcion":"GRUPO SOCIAL 4 - SEMICALIFICADO"
  },
  {
    "codigo":1141690005,
    "descripcion":"DEMUESTRA CONOCIMIENTO SOBRE DESARROLLO FETAL"
  },
  {
    "codigo":781242005,
    "descripcion":"TENDINITIS DE LA PORCIÓN LARGA DEL MÚSCULO BÍCEPS BRAQUIAL DEL HOMBRO IZQUIERDO"
  },
  {
    "codigo":289722007,
    "descripcion":"CONTRACCIONES UTERINAS DE INTENSIDAD NORMAL"
  },
  {
    "codigo":224186005,
    "descripcion":"SÍNDROME DE DEFICIENCIA CEREBELOSA"
  },
  {
    "codigo":255119002,
    "descripcion":"LINFANGITIS CARCINOMATOSA"
  },
  {
    "codigo":89444000,
    "descripcion":"ESPECTRO DE HIPOGÉNESIS DE MIEMBRO-OROMANDIBULAR"
  },
  {
    "codigo":15736121000119105,
    "descripcion":"EDEMA MICROQUÍSTICO DE CÓRNEA DE AMBOS OJOS"
  },
  {
    "codigo":124047009,
    "descripcion":"ESFINGOMIELINA POR ENCIMA DE RANGO DE REFERENCIA"
  },
  {
    "codigo":449892005,
    "descripcion":"SENSACIÓN DE SEGURIDAD"
  },
  {
    "codigo":286052006,
    "descripcion":"DIFICULTAD PARA LAVAR LA ROPA SUCIA"
  },
  {
    "codigo":253284006,
    "descripcion":"DOBLE TRACTO DE ENTRADA AL VENTRÍCULO DE MORFOLOGÍA INDETERMINADA"
  },
  {
    "codigo":56676008,
    "descripcion":"HERNIA DIAFRAGMÁTICA CON GANGRENA"
  },
  {
    "codigo":22073001,
    "descripcion":"DIETA REGULAR PARA MANDÍBULA INMOVILIZADA CON CABLE"
  },
  {
    "codigo":251449004,
    "descripcion":"ACTIVIDAD DOMINANTE DELTA"
  },
  {
    "codigo":448057008,
    "descripcion":"INTERVALO DE ADMINISTRACIÓN DE MEDICACIÓN EXCESIVAMENTE BREVE"
  },
  {
    "codigo":284217008,
    "descripcion":"QUEMADURA SUPERFICIAL DE LA MAMA POR AGENTE CORROSIVO"
  },
  {
    "codigo":216846002,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR MONÓXIDO DE CARBONO POR COMBUSTIÓN INCOMPLETA DE LEÑA EN ESTUFA O COCINA DE USO DOMÉSTICO"
  },
  {
    "codigo":335161000119109,
    "descripcion":"RETINOPATÍA EXUDATIVA DE OJO DERECHO"
  },
  {
    "codigo":1360056001,
    "descripcion":"ÚLCERA CORNEAL DE OJO IZQUIERDO"
  },
  {
    "codigo":247779009,
    "descripcion":"ENERGÍA EXCESIVA"
  },
  {
    "codigo":213176003,
    "descripcion":"FALLA PARCIAL DE DEDO DE PIE REIMPLANTADO"
  },
  {
    "codigo":540881000124100,
    "descripcion":"MASA DE PLEURA"
  },
  {
    "codigo":16748141000119100,
    "descripcion":"RETINOPATÍA PROLIFERATIVA BILATERAL POR DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":430801000124103,
    "descripcion":"RETINOPATÍA PROLIFERATIVA"
  },
  {
    "codigo":409784006,
    "descripcion":"DERMATITIS DE CONTACTO CAUSADA POR URUSHIOL DE ROBLE VENENOSO DEL PACÍFICO"
  },
  {
    "codigo":671441000124105,
    "descripcion":"INSEGURIDAD FINANCIERA DEBIDA A DEUDA"
  },
  {
    "codigo":1259917002,
    "descripcion":"TRASTORNO FETAL DEBIDO A VERSIÓN EXTERNA ANTES DE TRABAJO DE PARTO"
  },
  {
    "codigo":276877003,
    "descripcion":"VAGINITIS TRICOMONIÁSICA"
  },
  {
    "codigo":211341001,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE TOBILLO"
  },
  {
    "codigo":735629007,
    "descripcion":"EYACULACIÓN PRECOZ GENERALIZADA PERMANENTE"
  },
  {
    "codigo":12898000,
    "descripcion":"INTOXICACIÓN POR PENTAZOCINA"
  },
  {
    "codigo":111202002,
    "descripcion":"LEUCONIQUIA"
  },
  {
    "codigo":209506006,
    "descripcion":"ESGUINCE ISQUIOCAPSULAR"
  },
  {
    "codigo":406114007,
    "descripcion":"ANTICUERPO CONTRA TREPONEMA PALLIDUM NO DETECTADO MEDIANTE PRUEBA DE HEMAGLUTINACIÓN"
  },
  {
    "codigo":109367000,
    "descripcion":"NEOPLASIA MALIGNA SUPERPUESTA DE LA NASOFARINGE"
  },
  {
    "codigo":45666009,
    "descripcion":"AMPOLLA DEL OÍDO, CON INFECCIÓN"
  },
  {
    "codigo":240439002,
    "descripcion":"ACTINOMICOSIS ESQUELÉTICA"
  },
  {
    "codigo":205836000,
    "descripcion":"ACEFALOGÁSTER"
  },
  {
    "codigo":271372000,
    "descripcion":"MASTITIS OBSTÉTRICA NO PURULENTA"
  },
  {
    "codigo":9228003,
    "descripcion":"ESQUISTOSOMIASIS PULMONAR"
  },
  {
    "codigo":402444004,
    "descripcion":"DERMATITIS HERPETIFORME QUE INVOLUCRA MUCOSA BUCAL"
  },
  {
    "codigo":238604005,
    "descripcion":"PSORIASIS UNGUEAL"
  },
  {
    "codigo":1156108004,
    "descripcion":"RAÍZ DENTAL SUPERNUMERARIA"
  },
  {
    "codigo":369676007,
    "descripcion":"MARGEN DISTAL DE RESECCIÓN QUIRÚRGICA DE ESÓFAGO, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":1187041000,
    "descripcion":"SÍNDROME DE DISCAPACIDAD INTELECTUAL, DISMORFIA FACIAL Y REFLUJO GASTROESOFÁGICO ASOCIADO AL GEN STAG1"
  },
  {
    "codigo":41996009,
    "descripcion":"RETORCIMIENTO REPETITIVO DE LAS MANOS"
  },
  {
    "codigo":236769002,
    "descripcion":"GRANULOMA ESPERMATOGÉNICO EN EPIDÍDIMO"
  },
  {
    "codigo":105697005,
    "descripcion":"ENFERMEDAD CAUSADA POR HETEROCHEILOIDEA"
  },
  {
    "codigo":7393007,
    "descripcion":"TRASTORNO DE SENOS PARANASALES"
  },
  {
    "codigo":300470007,
    "descripcion":"HALLAZGO RELACIONADO CON EL PATRÓN DE MICCIÓN"
  },
  {
    "codigo":366006008,
    "descripcion":"CONTENIDO DE LA CONVERSACIÓN - HALLAZGO"
  },
  {
    "codigo":3723001,
    "descripcion":"ARTRITIS"
  },
  {
    "codigo":724619002,
    "descripcion":"DESVIACIÓN RADIAL CONGÉNITA DE DEDO DE LA MANO"
  },
  {
    "codigo":36491007,
    "descripcion":"DISTRIBUCIÓN VENTILATORIA ANORMAL"
  },
  {
    "codigo":1279840000,
    "descripcion":"ATAXIA ESPINOCEREBELOSA TIPO 45"
  },
  {
    "codigo":1052299009,
    "descripcion":"RUPTURA DE TENDÓN FLEXOR DE MUÑECA"
  },
  {
    "codigo":34656006,
    "descripcion":"FRACTURA EXPUESTA DE HUESO GANCHOSO DE MUÑECA"
  },
  {
    "codigo":296800007,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE ETAMBUTOL"
  },
  {
    "codigo":294965001,
    "descripcion":"ALERGIA A CLOFIBRATO"
  },
  {
    "codigo":1074951000119107,
    "descripcion":"ARTRITIS DE AMBOS PIES"
  },
  {
    "codigo":131125004,
    "descripcion":"VITAMINA B POR DEBAJO DE RANGO DE REFERENCIA"
  },
  {
    "codigo":923166471000119109,
    "descripcion":"MELANOMA MALIGNO DE PIEL DE REGIÓN DE CODO DERECHO"
  },
  {
    "codigo":1145098007,
    "descripcion":"PESTAÑAS CURVAS"
  },
  {
    "codigo":192991000,
    "descripcion":"CRISIS EPILÉPTICAS - CLÓNICAS"
  },
  {
    "codigo":15630241000119104,
    "descripcion":"ESPASMO HEMIFACIAL DEL NERVIO FACIAL IZQUIERDO"
  },
  {
    "codigo":94687005,
    "descripcion":"LINFOSARCOMA DE CÉLULAS MIXTAS DE LOS GANGLIOS LINFÁTICOS INTRAPÉLVICOS"
  },
  {
    "codigo":11861921000119105,
    "descripcion":"RUPTURA TRAUMÁTICA DE LIGAMENTO LATERAL INTERNO DE RODILLA DERECHA"
  },
  {
    "codigo":125620005,
    "descripcion":"LUXACIÓN TRAUMÁTICA DE ARTICULACIÓN DE PULGAR"
  },
  {
    "codigo":92852007,
    "descripcion":"FUSIÓN ANORMAL CONGÉNITA DEL CENTRO DE LA VÉRTEBRA DORSAL"
  },
  {
    "codigo":713609000,
    "descripcion":"CARCINOMA INVASOR DE MAMA"
  },
  {
    "codigo":418697001,
    "descripcion":"CANTIDAD DE MONOCITOS EN SANGRE POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":123785006,
    "descripcion":"DEFICIENCIA DE SUBCLASE DE INMUNOGLOBULINA G"
  },
  {
    "codigo":1336201006,
    "descripcion":"TRASTORNO POR USO DE CANNABINOIDE SINTÉTICO"
  },
  {
    "codigo":89182000,
    "descripcion":"DEGENERACIÓN PERIFÉRICA DE LA CÓRNEA"
  },
  {
    "codigo":285790001,
    "descripcion":"CAPAZ DE RECONOCER LOS DEDOS DE SUS MANOS"
  },
  {
    "codigo":254857008,
    "descripcion":"TUMOR EPITELIAL BENIGNO DE OVARIO"
  },
  {
    "codigo":11780001000119108,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE ANTEBRAZO DERECHO"
  },
  {
    "codigo":449630001,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE PIEL DE PIERNA"
  },
  {
    "codigo":23646007,
    "descripcion":"NASALIDAD MIXTA"
  },
  {
    "codigo":283955002,
    "descripcion":"CUERPO EXTRAÑO EN OVARIO"
  },
  {
    "codigo":251187003,
    "descripcion":"COMPLEJO DE ESCAPE AURICULAR"
  },
  {
    "codigo":15630611000119100,
    "descripcion":"TENDINITIS DE REGIÓN DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":11775251000119101,
    "descripcion":"LACERACIÓN DE MÚSCULO DE BRAZO IZQUIERDO"
  },
  {
    "codigo":1077011000119102,
    "descripcion":"QUISTE ÓSEO DE HÚMERO IZQUIERDO"
  },
  {
    "codigo":1074451000119102,
    "descripcion":"OSTEOARTROSIS DE ARTICULACIÓN ESTERNOCLAVICULAR IZQUIERDA"
  },
  {
    "codigo":16076051000119104,
    "descripcion":"GOTA TOFÁCEA CRÓNICA DE CODO IZQUIERDO"
  },
  {
    "codigo":547665171000119105,
    "descripcion":"PSEUDOQUISTE DE OREJA DERECHA"
  },
  {
    "codigo":11808531000119105,
    "descripcion":"CONTUSIÓN DE COLON DESCENDENTE"
  },
  {
    "codigo":91411000119105,
    "descripcion":"INSOMNIO MEDICAMENTOSO"
  },
  {
    "codigo":316691000119108,
    "descripcion":"OSTEOFITO DE HOMBRO DERECHO"
  },
  {
    "codigo":249352000,
    "descripcion":"TAPONAJE EN CAVIDAD NASAL"
  },
  {
    "codigo":16818451000119104,
    "descripcion":"RITMO CARDÍACO FETAL ANORMAL"
  },
  {
    "codigo":329491000119109,
    "descripcion":"OCLUSIÓN DE ARTERIA CEREBRAL MEDIA IZQUIERDA"
  },
  {
    "codigo":140051000119109,
    "descripcion":"NEVO DE MUCOSA BUCAL"
  },
  {
    "codigo":85512009,
    "descripcion":"DERMATITIS DE CONTACTO CAUSADA POR JOYERÍA"
  },
  {
    "codigo":96531000119109,
    "descripcion":"DEFORMIDAD DE MANO DEBIDA A ARTRITIS REUMATOIDE"
  },
  {
    "codigo":672531000119106,
    "descripcion":"DISFASIA DEBIDA A ACCIDENTE CEREBROVASCULAR HEMORRÁGICO Y POSTERIOR A ÉL"
  },
  {
    "codigo":247517004,
    "descripcion":"PARONIQUIA BACTERIANA"
  },
  {
    "codigo":367891000119108,
    "descripcion":"ESTRECHEZ DE URETRA ANTERIOR CONSECUTIVA A PROCEDIMIENTO"
  },
  {
    "codigo":16091411000119109,
    "descripcion":"ANGIOSARCOMA PRIMARIO DE PIEL DE LABIO"
  },
  {
    "codigo":419033301000119102,
    "descripcion":"HEMATOMA NO TRAUMÁTICO DE RETROPERITONEO"
  },
  {
    "codigo":50909009,
    "descripcion":"OXALOSIS POR INGESTIÓN DE ANTICONGELANTE"
  },
  {
    "codigo":11808981000119103,
    "descripcion":"HERIDA DE REGIÓN DE CADERA DERECHA DEBIDA A PICADURA DE INSECTO NO VENENOSO"
  },
  {
    "codigo":737202006,
    "descripcion":"ENFERMEDAD FIBROPOLIQUÍSTICA DEL HÍGADO"
  },
  {
    "codigo":276615002,
    "descripcion":"GESTACIÓN FETAL CORTA"
  },
  {
    "codigo":405852000,
    "descripcion":"FENOTIPO FY(B-)"
  },
  {
    "codigo":78172003,
    "descripcion":"DESENCAJAMIENTO FETAL"
  },
  {
    "codigo":242012005,
    "descripcion":"QUEMADURAS TÉRMICAS POR RAYO"
  },
  {
    "codigo":404017001,
    "descripcion":"FIBROHISTIOCITOMA MALIGNO INFLAMATORIO DE LA PIEL"
  },
  {
    "codigo":240177002,
    "descripcion":"OSTEOCONDRITIS JUVENIL DE LA MANO"
  },
  {
    "codigo":698929005,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: UIGUR"
  },
  {
    "codigo":830001007,
    "descripcion":"HIPEREMIA DE ÁREA DE LITTLE"
  },
  {
    "codigo":313711000119102,
    "descripcion":"MONOARTRITIS DE HOMBRO DERECHO"
  },
  {
    "codigo":762630002,
    "descripcion":"OCLUSIÓN DE ARTERIA CEREBRAL MEDIA IZQUIERDA POR ÉMBOLO"
  },
  {
    "codigo":402182004,
    "descripcion":"CICATRIZ POSTRAUMÁTICA"
  },
  {
    "codigo":236507000,
    "descripcion":"COMPROMISO RENAL EN ENFERMEDAD MALIGNA"
  },
  {
    "codigo":302043000,
    "descripcion":"INCAPAZ DE MOVILIZARSE"
  },
  {
    "codigo":269275003,
    "descripcion":"EFECTO TÓXICO CAUSADO POR PESCADOS Y MARISCOS"
  },
  {
    "codigo":105435005,
    "descripcion":"MATRIMONIO HOMOSEXUAL ENTRE MUJERES"
  },
  {
    "codigo":300208003,
    "descripcion":"LLORA EN RESPUESTA AL SONIDO"
  },
  {
    "codigo":365744003,
    "descripcion":"NIVEL SÉRICO DE FENITOÍNA - HALLAZGO"
  },
  {
    "codigo":38064006,
    "descripcion":"MONOCITOSIS REACTIVA"
  },
  {
    "codigo":726192008,
    "descripcion":"LESIÓN TRAUMÁTICA DE TENDÓN DE MÚSCULO INTRÍNSECO DE PULGAR"
  },
  {
    "codigo":200069001,
    "descripcion":"REACCIÓN TÓXICA CAUSADA POR ANESTESIA LOCAL DURANTE EL EMBARAZO"
  },
  {
    "codigo":167301002,
    "descripcion":"PRUEBA DE SANGRE EN ORINA = ++"
  },
  {
    "codigo":16097801000119101,
    "descripcion":"ARTROFIBROSIS DE ARTICULACIÓN DE AMBAS MUÑECAS"
  },
  {
    "codigo":3461004,
    "descripcion":"QUEMADURA PROFUNDA DE TERCER GRADO DE DEDO PULGAR"
  },
  {
    "codigo":724357007,
    "descripcion":"HEMORRAGIA CEREBRAL HEREDITARIA CON AMILOIDOSIS"
  },
  {
    "codigo":429445008,
    "descripcion":"ÚLCERA CRÓNICA DEL PIE"
  },
  {
    "codigo":298373009,
    "descripcion":"INMOVILIZACIÓN DE ARTICULACIÓN TEMPOROMANDIBULAR"
  },
  {
    "codigo":67162002,
    "descripcion":"HUELE A ORINA"
  },
  {
    "codigo":34394003,
    "descripcion":"FÓRMULA DE HIPERALIMENTACIÓN PARA EL HIPERMETABOLISMO DEL PACIENTE QUEMADO"
  },
  {
    "codigo":263770000,
    "descripcion":"ARENOSO"
  },
  {
    "codigo":165466008,
    "descripcion":"ERITROSEDIMENTACIÓN POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":722522009,
    "descripcion":"ENFERMEDAD INFLAMATORIA DE PELVIS FEMENINA CAUSADA POR MYCOPLASMA GENITALIUM"
  },
  {
    "codigo":65327002,
    "descripcion":"MUCOPOLISACARIDOSIS, MPS - I - H"
  },
  {
    "codigo":261935004,
    "descripcion":"CONDUCTA MANIPULADORA"
  },
  {
    "codigo":1144836000,
    "descripcion":"INTOXICACIÓN CAUSADA POR VALPROATO"
  },
  {
    "codigo":292868004,
    "descripcion":"REACCIÓN ADVERSA AL PERBORATO SÓDICO"
  },
  {
    "codigo":342691000119100,
    "descripcion":"QUISTE DE PÁRPADO INFERIOR DERECHO"
  },
  {
    "codigo":129028008,
    "descripcion":"ASISTENCIA PARA LA ADMINISTRACIÓN DEL DINERO"
  },
  {
    "codigo":291033002,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR FLURAZEPAM"
  },
  {
    "codigo":127193004,
    "descripcion":"LINFADENOPATÍA AXILAR PECTORAL"
  },
  {
    "codigo":258265005,
    "descripcion":"EXTENSIÓN MODERADA"
  },
  {
    "codigo":225497005,
    "descripcion":"USA ROPA OPACA"
  },
  {
    "codigo":94425007,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE MÚSCULO DEL CUELLO"
  },
  {
    "codigo":235100004,
    "descripcion":"SOBREMORDIDA TRAUMÁTICA EN MUCOSA LABIAL"
  },
  {
    "codigo":420270002,
    "descripcion":"CETOACIDOSIS DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":190894003,
    "descripcion":"DESHIDRATACIÓN ISONATRÉMICA"
  },
  {
    "codigo":289198005,
    "descripcion":"HALLAZGO RELACIONADO CON EL USO Y EL CONTENIDO DEL LENGUAJE"
  },
  {
    "codigo":92590009,
    "descripcion":"CARCINOMA IN SITU DEL OJO"
  },
  {
    "codigo":713347002,
    "descripcion":"ENFERMEDAD GINGIVAL DEBIDA A LESIÓN TÉRMICA"
  },
  {
    "codigo":418435001,
    "descripcion":"DISTROFIA CORNEAL MACULAR, TIPO II"
  },
  {
    "codigo":254595005,
    "descripcion":"HIPERPLASIA LINFOIDEA NODULAR DEL INTESTINO"
  },
  {
    "codigo":90755006,
    "descripcion":"ABSTINENCIA DE NICOTINA"
  },
  {
    "codigo":285528002,
    "descripcion":"DIFICULTAD PARA MOVER LA PUNTA DE LA LENGUA REPETIDAMENTE"
  },
  {
    "codigo":1137496003,
    "descripcion":"FLACIDEZ DE MÚSCULO EPISÓDICA"
  },
  {
    "codigo":21549001,
    "descripcion":"LACERACIÓN SUPERFICIAL DE LA CÓRNEA"
  },
  {
    "codigo":54317001,
    "descripcion":"LUXACIÓN EXPUESTA DE VÉRTEBRA LUMBAR"
  },
  {
    "codigo":449368009,
    "descripcion":"DEJÓ DE FUMAR DURANTE EL EMBARAZO"
  },
  {
    "codigo":414765004,
    "descripcion":"CADENAS LIVIANAS LAMBDA LIBRE MONOCLONALES DETECTADAS"
  },
  {
    "codigo":249090000,
    "descripcion":"PRESENTACIÓN DE OREJA DEL FETO"
  },
  {
    "codigo":283693009,
    "descripcion":"MORDEDURA HUMANA EN LA MEJILLA"
  },
  {
    "codigo":707842005,
    "descripcion":"NIVEL DE ALFABETIZACIÓN: ALFABETIZACIÓN COMPLETA"
  },
  {
    "codigo":1230295000,
    "descripcion":"SÍNDROME DE INMUNODEFICIENCIA DE CÉLULAS B, ANOMALÍAS DE EXTREMIDADES Y MALFORMACIONES GENITOURINARIAS"
  },
  {
    "codigo":1197527000,
    "descripcion":"MUCOSITIS ULCEROSA ORAL DEBIDA A ADMINISTRACIÓN DE AGENTE ANTINEOPLÁSICO Y POSTERIOR A ELLA"
  },
  {
    "codigo":281858008,
    "descripcion":"HEMATURIA MICROSCÓPICA RECURRENTE"
  },
  {
    "codigo":609538008,
    "descripcion":"HIPERSENSIBILIDAD NO ALÉRGICA A CAPTOPRIL"
  },
  {
    "codigo":183554009,
    "descripcion":"DERIVADO AL CIRUJANO VASCULAR"
  },
  {
    "codigo":81580000,
    "descripcion":"MEDIASTINOPERICARDITIS AGUDA"
  },
  {
    "codigo":247255008,
    "descripcion":"TAPONAMIENTO EN EL CONDUCTO AUDITIVO"
  },
  {
    "codigo":48812004,
    "descripcion":"SÍNDROME DE TRISOMÍA PARCIAL 17Q"
  },
  {
    "codigo":704172007,
    "descripcion":"FRACTURA PATOLÓGICA DE FALANGE DE DEDO DE LA MANO"
  },
  {
    "codigo":735105001,
    "descripcion":"ELONGACIÓN DE RAMA IZQUIERDA DE MAXILAR INFERIOR"
  },
  {
    "codigo":79745005,
    "descripcion":"EPILEPSIA REFLEJA"
  },
  {
    "codigo":733270000,
    "descripcion":"HERIDA PUNZANTE DE CADERA CON CUERPO EXTRAÑO"
  },
  {
    "codigo":77910001,
    "descripcion":"FLEBITIS SUPURATIVA"
  },
  {
    "codigo":45142002,
    "descripcion":"LINFANGIECTASIA PULMONAR CONGÉNITA"
  },
  {
    "codigo":405590003,
    "descripcion":"COLANGITIS INFECCIOSA"
  },
  {
    "codigo":14209008,
    "descripcion":"PARA 1"
  },
  {
    "codigo":1259393009,
    "descripcion":"CARCINOMA ADENOIDE QUÍSTICO PRIMARIO DE GLÁNDULA LAGRIMAL"
  },
  {
    "codigo":1290326006,
    "descripcion":"QUISTE POPLÍTEO DE AMBAS RODILLAS"
  },
  {
    "codigo":305451000,
    "descripcion":"BAJO ATENCIÓN DE EMERGENTÓLOGO"
  },
  {
    "codigo":241750009,
    "descripcion":"ENVENENAMIENTO POR DIHIDROCODEÍNA"
  },
  {
    "codigo":16018391000119104,
    "descripcion":"PARESIA DE EXTREMIDAD INFERIOR IZQUIERDA"
  },
  {
    "codigo":370987005,
    "descripcion":"ASTROCITOMA ANAPLÁSICO DE MÉDULA ESPINAL"
  },
  {
    "codigo":698667006,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: IRLANDÉS"
  },
  {
    "codigo":239915006,
    "descripcion":"SÍNDROME DE SJÖGREN SECUNDARIO"
  },
  {
    "codigo":1255723009,
    "descripcion":"NEOPLASIA BENIGNA DE NERVIO PERIFÉRICO DE CABEZA Y CUELLO"
  },
  {
    "codigo":238080004,
    "descripcion":"HIPERALFALIPOPROTEINEMIA"
  },
  {
    "codigo":8704005,
    "descripcion":"FRACTURA DE APÓFISIS ACROMIAL DE OMÓPLATO"
  },
  {
    "codigo":205312005,
    "descripcion":"BRAQUIDACTILIA DE FALANGE FALTANTE"
  },
  {
    "codigo":762368005,
    "descripcion":"PROLAPSO DE OJO IZQUIERDO CONCOMITANTE CON RUPTURA"
  },
  {
    "codigo":15664241000119100,
    "descripcion":"NEVO DE IRIS BILATERAL"
  },
  {
    "codigo":6869001,
    "descripcion":"IRIDOCICLITIS RECURRENTE"
  },
  {
    "codigo":170709001,
    "descripcion":"EFECTO COLATERAL DE FÁRMACO ANTIEPILÉPTICO"
  },
  {
    "codigo":72405004,
    "descripcion":"APETITO ALIMENTARIO AUMENTADO"
  },
  {
    "codigo":400085009,
    "descripcion":"ACROQUERATOSIS VERRUCIFORME DE HOPF"
  },
  {
    "codigo":398250003,
    "descripcion":"LINFOHISTIOCITOSIS HEMOFAGOCÍTICA FAMILIAR"
  },
  {
    "codigo":299946007,
    "descripcion":"GRAFESTESIA AUSENTE"
  },
  {
    "codigo":134271000,
    "descripcion":"LEE SOMALÍ"
  },
  {
    "codigo":201642009,
    "descripcion":"CONDROCALCINOSIS DE ARTICULACIÓN DE MANO CAUSADA POR CRISTALES DE PIROFOSFATO"
  },
  {
    "codigo":3199001,
    "descripcion":"ESGUINCE DE HOMBRO"
  },
  {
    "codigo":234410008,
    "descripcion":"ELIPTOCITOSIS HEREDITARIA CON POIQUILOCITOSIS TRANSITORIA"
  },
  {
    "codigo":365482007,
    "descripcion":"POSESIÓN DE MASCOTAS - HALLAZGO"
  },
  {
    "codigo":724095006,
    "descripcion":"MIOPATÍA DEBIDA A SOBRECARGA DE CALSECUESTRINA Y PROTEÍNA ATPASA 1\/CALCIO DE RETÍCULO SARCOPLÁSMICO\/ENDOPLÁSMICO"
  },
  {
    "codigo":427348001,
    "descripcion":"ECCEMA CRÓNICO DE CONDUCTO AUDITIVO EXTERNO"
  },
  {
    "codigo":230740003,
    "descripcion":"TROMBOSIS DE ARTERIA ESPINAL ANTERIOR"
  },
  {
    "codigo":196137000,
    "descripcion":"ENFERMEDAD PULMONAR CON ENFERMEDAD DE SJÖGREN"
  },
  {
    "codigo":296276008,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE OXIPERTINA"
  },
  {
    "codigo":236811000119101,
    "descripcion":"ENFERMEDAD DE PAGET DE CONDUCTO ANAL"
  },
  {
    "codigo":294441006,
    "descripcion":"ALERGIA A CETILPIRIDINIO"
  },
  {
    "codigo":1144574000,
    "descripcion":"HIPOPLASIA CONGÉNITA DE MÚSCULO DE HOMBRO"
  },
  {
    "codigo":292606000,
    "descripcion":"REACCIÓN ADVERSA AL ISOAMINILO"
  },
  {
    "codigo":423678000,
    "descripcion":"INCUMPLIMIENTO DEL RÉGIMEN DE CONTROL DE INFECCIONES"
  },
  {
    "codigo":421843005,
    "descripcion":"LÍQUIDO SUBRETINIANO"
  },
  {
    "codigo":61395005,
    "descripcion":"TALASEMIA POR PERSISTENCIA HEREDITARIA DE HEMOGLOBINA FETAL GAMMA BETA MÁS"
  },
  {
    "codigo":1306579007,
    "descripcion":"CARCINOMA DUCTAL INFILTRANTE DE CUADRANTE INFERIOR INTERNO DE MAMA DERECHA"
  },
  {
    "codigo":288936000,
    "descripcion":"CAPAZ DE TRAGAR"
  },
  {
    "codigo":290771009,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR VINDESINA"
  },
  {
    "codigo":94163009,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE MUCOSA DE CRESTA ALVEOLAR"
  },
  {
    "codigo":90493000,
    "descripcion":"NEFROESCLEROSIS ARTERIOLAR"
  },
  {
    "codigo":92328009,
    "descripcion":"NEOPLASIA BENIGNA DE LÓBULO MEDIO DE PULMÓN DERECHO"
  },
  {
    "codigo":287101003,
    "descripcion":"LESIÓN DE COLON\/RECTO"
  },
  {
    "codigo":57725006,
    "descripcion":"BALANTIDIASIS"
  },
  {
    "codigo":23122001,
    "descripcion":"FIEBRE DEL RÍO BRAVO"
  },
  {
    "codigo":713085009,
    "descripcion":"EL CUIDADOR PRIMARIO CUENTA CON ESCASA RED DE APOYO"
  },
  {
    "codigo":285266003,
    "descripcion":"FANTASÍA PELIGROSA"
  },
  {
    "codigo":283431001,
    "descripcion":"CORTE EN EL GLÚTEO"
  },
  {
    "codigo":840487004,
    "descripcion":"ESTENOSIS CONGÉNITA DE CONDUCTO VERTEBRAL"
  },
  {
    "codigo":281596000,
    "descripcion":"TROMBOSIS DE VENA CAVA SUPERIOR"
  },
  {
    "codigo":709415008,
    "descripcion":"PROTEÍNA DE LA MEMBRANA MITOCONDRIAL ASOCIADA CON NEURODEGENERACIÓN"
  },
  {
    "codigo":707580003,
    "descripcion":"CARCINOMA BASALOIDE PRIMARIO DE OROFARINGE"
  },
  {
    "codigo":445436005,
    "descripcion":"VENA CAVA SUPERIOR IZQUIERDA PERSISTENTE EN AURÍCULA IZQUIERDA"
  },
  {
    "codigo":226446911000119100,
    "descripcion":"TUMOR NEUROENDOCRINO BIEN DIFERENCIADO GRADO 1 DE BRONQUIO"
  },
  {
    "codigo":248828007,
    "descripcion":"PEZÓN APLANADO"
  },
  {
    "codigo":19452008,
    "descripcion":"EDEMA NASAL"
  },
  {
    "codigo":246993000,
    "descripcion":"CÉLULAS DE LA CÁMARA ANTERIOR"
  },
  {
    "codigo":292261000119107,
    "descripcion":"NEURITIS ILIOHIPOGÁSTRICA DERECHA"
  },
  {
    "codigo":1197265008,
    "descripcion":"NEVO MELANOCÍTICO PERSISTENTE"
  },
  {
    "codigo":81318004,
    "descripcion":"COLITIS HEMORRÁGICA"
  },
  {
    "codigo":15782007,
    "descripcion":"PARKINSONISMO INDUCIDO POR MPTP"
  },
  {
    "codigo":441766009,
    "descripcion":"MASA DE NARIZ"
  },
  {
    "codigo":210555003,
    "descripcion":"LESIÓN POR DESOLLAMIENTO DE MUÑECA, CARA PALMAR"
  },
  {
    "codigo":472699005,
    "descripcion":"DIABETES MELLITUS GESTACIONAL NO CONTROLADA"
  },
  {
    "codigo":308859006,
    "descripcion":"DISPLASIA MODERADA DE ESÓFAGO"
  },
  {
    "codigo":276091008,
    "descripcion":"REGISTRO DE VANDALISMO"
  },
  {
    "codigo":765776001,
    "descripcion":"DISPLASIA DE RIÑÓN DERECHO"
  },
  {
    "codigo":896848003,
    "descripcion":"FORMA TRIANGULAR ANORMAL CONGÉNITA DE EPÍFISIS DE FALANGE DE PULGAR"
  },
  {
    "codigo":1290064003,
    "descripcion":"TUMOR NEUROENDOCRINO BIEN DIFERENCIADO DE ESTÓMAGO"
  },
  {
    "codigo":44880006,
    "descripcion":"UNIÓN MACROMOLECULAR DISMINUIDA"
  },
  {
    "codigo":403493001,
    "descripcion":"LUPUS ERITEMATOSO DISCOIDE TIPO ROSÁCEA"
  },
  {
    "codigo":10277002,
    "descripcion":"SÍNDROME DEL ÁNGULO PONTOCEREBELOSO"
  },
  {
    "codigo":698405005,
    "descripcion":"HERIDA ABIERTA DE TRONCO CON ABSCESO"
  },
  {
    "codigo":1157157006,
    "descripcion":"LEUCEMIA MIELOIDE AGUDA CON ANOMALÍAS EN 11Q23"
  },
  {
    "codigo":8442000,
    "descripcion":"RINITIS PURULENTA"
  },
  {
    "codigo":12199641000119102,
    "descripcion":"AFLOJAMIENTO DE PRÓTESIS DE ARTICULACIÓN DE RODILLA IZQUIERDA"
  },
  {
    "codigo":235983003,
    "descripcion":"PERITONITIS SUPURATIVA"
  },
  {
    "codigo":6607004,
    "descripcion":"SIRINGOENCEFALOMIELIA"
  },
  {
    "codigo":301519007,
    "descripcion":"NO SALE DE LA DUCHA"
  },
  {
    "codigo":1153487008,
    "descripcion":"CREATINA CINASA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":299684004,
    "descripcion":"PELVIS CONGELADA NO MALIGNA"
  },
  {
    "codigo":1217188005,
    "descripcion":"PERIOSTITIS DE TOBILLO Y PIE"
  },
  {
    "codigo":365220004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA MANTENER LA HIGIENE DURANTE EL PERÍODO MENSTRUAL"
  },
  {
    "codigo":397988007,
    "descripcion":"HALLAZGO RELACIONADO CON VENTILACIÓN-PERFUSIÓN"
  },
  {
    "codigo":234148007,
    "descripcion":"FÍSTULA ARTERIOVENOSA CONGÉNITA"
  },
  {
    "codigo":232313005,
    "descripcion":"SÍFILIS ENDOCOCLEAR"
  },
  {
    "codigo":428921007,
    "descripcion":"INFECCIÓN DE ETIOLOGÍA INCIERTA"
  },
  {
    "codigo":230478000,
    "descripcion":"CEFALEA POR BAJA PRESIÓN"
  },
  {
    "codigo":164942001,
    "descripcion":"ELECTROCARDIOGRAMA: ONDA F PRESENTE"
  },
  {
    "codigo":363385007,
    "descripcion":"NEOPLASIA MALIGNA DE PISO DE BOCA"
  },
  {
    "codigo":33870003,
    "descripcion":"POSICIÓN COITAL ACOSTADA LATERAL"
  },
  {
    "codigo":263246003,
    "descripcion":"FRACTURA DE ASTRÁGALO"
  },
  {
    "codigo":1102005,
    "descripcion":"PARASITOSIS INTRAERITROCÍTICA CAUSADA POR NUTTALLIA"
  },
  {
    "codigo":427086003,
    "descripcion":"ENCEFALITIS DE TRONCO DE BICKERSTAFF"
  },
  {
    "codigo":166777007,
    "descripcion":"PROTEÍNAS SÉRICAS DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":32035007,
    "descripcion":"LINFADENITIS CRÓNICA"
  },
  {
    "codigo":1177080001,
    "descripcion":"DACRIOADENITIS ESTREPTOCÓCICA"
  },
  {
    "codigo":292344003,
    "descripcion":"REACCIÓN ADVERSA AL FLUNITRAZEPAM"
  },
  {
    "codigo":1144312005,
    "descripcion":"FRENTE AMPLIA"
  },
  {
    "codigo":224973000,
    "descripcion":"SENSACIÓN DE FRUSTRACIÓN"
  },
  {
    "codigo":93901001,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE MÚSCULO DE LA CARA"
  },
  {
    "codigo":1306317001,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE PEZÓN"
  },
  {
    "codigo":95736009,
    "descripcion":"FIBROSIS CORNEAL"
  },
  {
    "codigo":126669004,
    "descripcion":"NEOPLASIA DE LA NARIZ"
  },
  {
    "codigo":421581006,
    "descripcion":"INFLAMACIÓN FARÍNGEA"
  },
  {
    "codigo":716493006,
    "descripcion":"NO COMPRENDE EL IDIOMA"
  },
  {
    "codigo":92066003,
    "descripcion":"NEOPLASIA BENIGNA DE LA COMISURA LABIAL"
  },
  {
    "codigo":26530004,
    "descripcion":"TRASTORNO BIPOLAR GRAVE CON SÍNTOMAS PSICÓTICOS, INCONGRUENTE CON EL ESTADO DE ÁNIMO"
  },
  {
    "codigo":288674005,
    "descripcion":"NO RESTABLECE UNA CONVERSACIÓN"
  },
  {
    "codigo":714658008,
    "descripcion":"CON MAYOR RIESGO DE EXPOSICIÓN A RADIACIÓN"
  },
  {
    "codigo":286839000,
    "descripcion":"HALLAZGO RELACIONADO CON RASGOS DE LA PERSONALIDAD: CAPACIDAD PARA APRENDER DE LAS EXPERIENCIAS ADVERSAS"
  },
  {
    "codigo":104461000119104,
    "descripcion":"OFTALMOPLEJÍA DEBIDA A ENFERMEDAD DE GRAVES"
  },
  {
    "codigo":57463004,
    "descripcion":"NEUMONITIS CAUSADA POR INHALACIÓN DE LÍQUIDO"
  },
  {
    "codigo":712823008,
    "descripcion":"DEPRESIÓN AGUDA"
  },
  {
    "codigo":448844001,
    "descripcion":"MÚSCULOS PAPILARES MÚLTIPLES DE VÁLVULA MITRAL CON VÁLVULA EN HAMACA"
  },
  {
    "codigo":677901000119105,
    "descripcion":"AGUJERO MACULAR DE OJO IZQUIERDO"
  },
  {
    "codigo":874828003,
    "descripcion":"CUERPO EXTRAÑO EN MUCOSA DE LA VAGINA"
  },
  {
    "codigo":447009000,
    "descripcion":"DEFECTO VENTILATORIO OBSTRUCTIVO"
  },
  {
    "codigo":285004009,
    "descripcion":"INCAPAZ DE DESABROCHAR LA ROPA"
  },
  {
    "codigo":283169003,
    "descripcion":"CUERPO EXTRAÑO METÁLICO EN LA MAMA"
  },
  {
    "codigo":1004065006,
    "descripcion":"CONTRACTURA EN FLEXIÓN DE SEGUNDO DEDO DE PIE"
  },
  {
    "codigo":11792551000119102,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN DE MEÑIQUE DERECHO"
  },
  {
    "codigo":707318002,
    "descripcion":"CANDIDIASIS MULTIFOCAL CRÓNICA DE LA CAVIDAD BUCAL"
  },
  {
    "codigo":248566004,
    "descripcion":"ESFUERZO RESPIRATORIO VISIBLE"
  },
  {
    "codigo":281334004,
    "descripcion":"NO SE SUMINISTRÓ EL NÚMERO DE REGISTRO"
  },
  {
    "codigo":838390005,
    "descripcion":"ABSCESO DE MÉDULA ESPINAL CAUSADO POR HONGO"
  },
  {
    "codigo":445174005,
    "descripcion":"EDEMA DE REGIÓN SUPRAPÚBICA"
  },
  {
    "codigo":443339000,
    "descripcion":"EDEMA DE PALMA DE MANO"
  },
  {
    "codigo":1264374006,
    "descripcion":"LACERACIÓN DE TENDÓN DE MANO"
  },
  {
    "codigo":17355002,
    "descripcion":"FÍSTULA AORTOESOFÁGICA"
  },
  {
    "codigo":279499002,
    "descripcion":"VULVITIS INFECCIOSA"
  },
  {
    "codigo":50123005,
    "descripcion":"SÍNDROME DE AURÍCULO - OSTEODISPLASIA DE BEALS"
  },
  {
    "codigo":15520004,
    "descripcion":"VOZ ASPIRADA SUSURRADA - INTERMITENTE"
  },
  {
    "codigo":16052391000119106,
    "descripcion":"TRASTORNO DE TENDÓN DE AMBOS ANTEBRAZOS"
  },
  {
    "codigo":277664004,
    "descripcion":"LINFOMA MALIGNO DE TESTÍCULO"
  },
  {
    "codigo":769184004,
    "descripcion":"RETINOPATÍA NO PROLIFERATIVA LEVE DEL OJO IZQUIERDO DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":243061001,
    "descripcion":"LESIÓN POR GUERRA BIOLÓGICA"
  },
  {
    "codigo":308597002,
    "descripcion":"ESTADO DE EXAMEN MÉDICO DE CORREDOR DE CARRERAS"
  },
  {
    "codigo":323751000119109,
    "descripcion":"SINDACTILIA SIMPLE DE DEDOS DE AMBOS PIES"
  },
  {
    "codigo":372298005,
    "descripcion":"DISTANCIA DEL TUMOR AL MARGEN ANAL, DESCONOCIDA"
  },
  {
    "codigo":77386006,
    "descripcion":"EMBARAZADA"
  },
  {
    "codigo":306762006,
    "descripcion":"CAPAZ DE EMITIR COMBINACIONES DE SONIDOS SONOROS Y SORDOS"
  },
  {
    "codigo":208458008,
    "descripcion":"FRACTURA NO EXPUESTA DE FALANGE DISTAL DE DEDO DE LA MANO, CONMINUTA"
  },
  {
    "codigo":110154009,
    "descripcion":"ABRASIÓN DEL VESTÍBULO MANDIBULAR"
  },
  {
    "codigo":42783002,
    "descripcion":"EXPULSIÓN PLACENTARIA ESPONTÁNEA, MECANISMO DE SCHULTZ"
  },
  {
    "codigo":403231003,
    "descripcion":"FOTOTIPO CUTÁNEO IV (CASI NUNCA EXISTE QUEMADURA, LUEGO SIEMPRE BRONCEADO)"
  },
  {
    "codigo":73716000,
    "descripcion":"ANGIOMATOSIS CUTÁNEA CONGÉNITA"
  },
  {
    "codigo":1351668001,
    "descripcion":"AGAMMAGLOBULINEMIA AUTOSÓMICA DOMINANTE DEBIDA A DEFICIENCIA DE FACTOR DE TRANSCRIPCIÓN E47"
  },
  {
    "codigo":303092001,
    "descripcion":"HIPERGLICINEMIA NO CETÓSICA POR DEFICIENCIA DE PROTEÍNA H"
  },
  {
    "codigo":15698241000119106,
    "descripcion":"INFLAMACIÓN DE AMBOS FÉMURES"
  },
  {
    "codigo":237556007,
    "descripcion":"HIPOTIROIDISMO POR DEFECTO DE LA ORGANIFICACIÓN DE YODO"
  },
  {
    "codigo":204788008,
    "descripcion":"ATROFIA CONGÉNITA DEL LÓBULO HEPÁTICO IZQUIERDO"
  },
  {
    "codigo":1220596009,
    "descripcion":"SÍNDROME DE TALLA BAJA SIGNIFICATIVA PRIMORDIAL MICROCEFÁLICA Y RESISTENCIA A LA INSULINA"
  },
  {
    "codigo":399561004,
    "descripcion":"TROMPA DE FALOPIO DERECHA NO FUSIONADA CON OVARIO DERECHO"
  },
  {
    "codigo":301257008,
    "descripcion":"HALLAZGO RESPIRATORIO DEL TÓRAX"
  },
  {
    "codigo":364958001,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA SACAR LA LENGUA"
  },
  {
    "codigo":37278001,
    "descripcion":"PERICARDITIS SECUNDARIA A TRAUMATISMO NO PENETRANTE"
  },
  {
    "codigo":4510004,
    "descripcion":"MENINGITIS ESTREPTOCÓCICA"
  },
  {
    "codigo":168350006,
    "descripcion":"HISOPADO VAGINAL PROFUNDO: ORGANISMO FÚNGICO AISLADO"
  },
  {
    "codigo":233886008,
    "descripcion":"PERICARDITIS INFECCIOSA CRÓNICA"
  },
  {
    "codigo":428659002,
    "descripcion":"USO INAPROPIADO DE ANFETAMINA"
  },
  {
    "codigo":232051002,
    "descripcion":"DISTROFIA DE MÁCULA EN PATRÓN"
  },
  {
    "codigo":461427006,
    "descripcion":"RESTRICCIÓN DE ORIFICIO DE ARTERIA CORONARIA DEBIDA A NEOPLASIA"
  },
  {
    "codigo":721736003,
    "descripcion":"INFECCIÓN CAUSADA POR BURKHOLDERIA"
  },
  {
    "codigo":295752005,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE RAZOXANO"
  },
  {
    "codigo":230216007,
    "descripcion":"ABSCESO PIOGÉNICO INTRAESPINAL"
  },
  {
    "codigo":64541000,
    "descripcion":"PUERPERIO, 3 DÍAS"
  },
  {
    "codigo":426824009,
    "descripcion":"TRASTORNO DE ASOCIACIÓN EN LA INSTAURACIÓN DEL SUEÑO"
  },
  {
    "codigo":228381000,
    "descripcion":"ASPIRA DROGAS"
  },
  {
    "codigo":15972981000119101,
    "descripcion":"ARTRITIS DE AMBAS ARTICULACIONES SACROILÍACAS"
  },
  {
    "codigo":293917005,
    "descripcion":"ALERGIA A RISPERIDONA"
  },
  {
    "codigo":95474000,
    "descripcion":"MALFORMACIÓN ARTERIOVENOSA DEL RIÑÓN"
  },
  {
    "codigo":457757008,
    "descripcion":"DEGENERACIÓN MIXOMATOSA DE VALVA DE VÁLVULA AURICULOVENTRICULAR DERECHA (MORFOLÓGICAMENTE NO MITRAL)"
  },
  {
    "codigo":29938001,
    "descripcion":"SECUESTRO BRONCOPULMONAR EXTRALOBULAR"
  },
  {
    "codigo":292082000,
    "descripcion":"REACCIÓN ADVERSA A LA NABUMETONA"
  },
  {
    "codigo":11821531000119109,
    "descripcion":"LUXACIÓN TRAUMÁTICA POSTERIOR NO EXPUESTA DE ARTICULACIÓN ESTERNOCLAVICULAR IZQUIERDA"
  },
  {
    "codigo":718066009,
    "descripcion":"PERIODONTITIS MODERADA AGUDA GENERALIZADA"
  },
  {
    "codigo":290247003,
    "descripcion":"INTOXICACIÓN POR FENBUFÉN"
  },
  {
    "codigo":60871005,
    "descripcion":"MALACOPLASIA DEL ESTÓMAGO"
  },
  {
    "codigo":716231009,
    "descripcion":"SÍNDROME DE ESPONDILOCAMPTODACTILIA"
  },
  {
    "codigo":288412005,
    "descripcion":"CAPAZ DE DESENROSCAR UNA TAPA"
  },
  {
    "codigo":16519951000119100,
    "descripcion":"ARTERIA CEREBRAL POSTERIOR DE ORIGEN FETAL"
  },
  {
    "codigo":16028431000119100,
    "descripcion":"EXOSTOSIS DE AMBOS PERONÉS"
  },
  {
    "codigo":286577000,
    "descripcion":"SENTIDO DE LA CAPACIDAD PERSONAL"
  },
  {
    "codigo":57201002,
    "descripcion":"SÍNDROME DE HIPERMOVILIDAD ARTICULAR MARFANOIDE"
  },
  {
    "codigo":299791000119101,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE TENDÓN EXTENSOR DE PIERNA"
  },
  {
    "codigo":10949391000119101,
    "descripcion":"HERIDA PUNZANTE DE MUÑECA DERECHA"
  },
  {
    "codigo":188273005,
    "descripcion":"NEOPLASIA MALIGNA DE SACO LAGRIMAL"
  },
  {
    "codigo":253809007,
    "descripcion":"FÍSTULA TRAQUEOBILIAR"
  },
  {
    "codigo":284742000,
    "descripcion":"AUTOINSERCIÓN DE CUERPOS EXTRAÑOS EN LOS ORIFICIOS CORPORALES"
  },
  {
    "codigo":55366007,
    "descripcion":"PÓLIPO AMIGDALINO"
  },
  {
    "codigo":708891002,
    "descripcion":"EMOCIONALMENTE ESTABLE"
  },
  {
    "codigo":86299006,
    "descripcion":"TETRALOGÍA DE FALLOT"
  },
  {
    "codigo":248304000,
    "descripcion":"DISTRIBUCIÓN MASCULINA DE LA GRASA"
  },
  {
    "codigo":51696001,
    "descripcion":"LIPOGRANULOMATOSIS SUBCUTÁNEA DE ROTHMANN Y MAKAI"
  },
  {
    "codigo":1296880000,
    "descripcion":"MELORREOSTOSIS DE FÉMUR"
  },
  {
    "codigo":282907008,
    "descripcion":"CAPAZ DE LEVANTARSE DESDE POSICIÓN DE CUCLILLAS SIN USAR LAS MANOS"
  },
  {
    "codigo":1264112006,
    "descripcion":"CITRULINEMIA TIPO I DE INICIO TARDÍO"
  },
  {
    "codigo":836293000,
    "descripcion":"INFARTO AGUDO DE MIOCARDIO DE VENTRÍCULO DERECHO"
  },
  {
    "codigo":17093002,
    "descripcion":"ATROFIA LAGRIMAL PRIMARIA"
  },
  {
    "codigo":770757004,
    "descripcion":"SÍNDROME DE PARKINSONISMO LIGADO AL CROMOSOMA X CON ESPASTICIDAD"
  },
  {
    "codigo":15674281000119102,
    "descripcion":"MIOSITIS INFECCIOSA DE AMBAS MANOS"
  },
  {
    "codigo":15258001,
    "descripcion":"SÍNDROME DE ROBO DE LA ARTERIA SUBCLAVIA"
  },
  {
    "codigo":312005008,
    "descripcion":"TRANSPOSICIÓN PENOESCROTAL CONGÉNITA"
  },
  {
    "codigo":1293210006,
    "descripcion":"MELANOCITOMA EPITELIOIDE PIGMENTADO"
  },
  {
    "codigo":48026007,
    "descripcion":"INANICIÓN"
  },
  {
    "codigo":767087000,
    "descripcion":"SEGUNDO VASO CON MOCO"
  },
  {
    "codigo":703386009,
    "descripcion":"FÍSTULA IATROGÉNICA DE ARTERIA CORONARIA"
  },
  {
    "codigo":439407002,
    "descripcion":"ACALORAMIENTO CAUSADO POR MEDICACIÓN"
  },
  {
    "codigo":13423002,
    "descripcion":"LIVIDEZ"
  },
  {
    "codigo":111727008,
    "descripcion":"EFECTO TARDÍO DE UNA LESIÓN TRAUMÁTICA SUPERFICIAL"
  },
  {
    "codigo":15920041000119105,
    "descripcion":"REACCIÓN ALÉRGICA CAUSADA POR AGENTE ANTIINFLAMATORIO NO ESTEROIDE"
  },
  {
    "codigo":404804003,
    "descripcion":"ASMA POR PLATINO"
  },
  {
    "codigo":109892006,
    "descripcion":"SEPARACIÓN DE LAS VELLOSIDADES CORIÓNICAS"
  },
  {
    "codigo":699716008,
    "descripcion":"EDAD MAYOR DE 40 AÑOS"
  },
  {
    "codigo":1254937000,
    "descripcion":"ESTRÍAS DE PIEL DEBIDAS A OBESIDAD"
  },
  {
    "codigo":304665002,
    "descripcion":"INCAPAZ DE EMPLEAR RAZONAMIENTO VERBAL"
  },
  {
    "codigo":9753004,
    "descripcion":"TRIPLEJÍA"
  },
  {
    "codigo":402969008,
    "descripcion":"ERITEMA NUDOSO DEBIDO A INFECCIÓN ESTREPTOCÓCICA"
  },
  {
    "codigo":270062001,
    "descripcion":"PACIENTE REGISTRADO EN FORMULARIO GMS1"
  },
  {
    "codigo":1187566006,
    "descripcion":"ENFERMEDAD DE CHARCOT MARIE TOOTH AUTOSÓMICA DOMINANTE TIPO 2 DEBIDA A MUTACIÓN DE GEN TFG"
  },
  {
    "codigo":204526007,
    "descripcion":"FISURA NASAL CONGÉNITA"
  },
  {
    "codigo":300995000,
    "descripcion":"ANGINA DE ESFUERZO"
  },
  {
    "codigo":169923002,
    "descripcion":"PUNTAJE DE APGAR A LOS 10 MINUTOS = 0"
  },
  {
    "codigo":366531003,
    "descripcion":"AMPLITUD DE MOVIMIENTO PASIVO DE ABDUCCIÓN DE LA MUÑECA - HALLAZGO"
  },
  {
    "codigo":71619006,
    "descripcion":"AUSENCIA CONGÉNITA DEL OÍDO"
  },
  {
    "codigo":38851006,
    "descripcion":"FÍSTULA INTESTINAL"
  },
  {
    "codigo":69784004,
    "descripcion":"RUPTURA DE VEJIGA URINARIA CON UROPERITONEO"
  },
  {
    "codigo":397464004,
    "descripcion":"CONFIGURACIÓN TUMORAL NO PUEDE DETERMINARSE"
  },
  {
    "codigo":233624006,
    "descripcion":"NEUMONÍA POR HERPES SIMPLE"
  },
  {
    "codigo":4248008,
    "descripcion":"SINOVITIS Y\/O TENOSINOVITIS ASOCIADA CON OTRA ENFERMEDAD"
  },
  {
    "codigo":299160008,
    "descripcion":"SIN AMPLITUD PASIVA DE EXTENSIÓN DE PULGAR"
  },
  {
    "codigo":264557003,
    "descripcion":"SÍNDROME DE LA VENA OVÁRICA"
  },
  {
    "codigo":723309006,
    "descripcion":"SÍNDROME DE OSTEODISPLASIA ENDOCRINA CEREBRAL"
  },
  {
    "codigo":33346005,
    "descripcion":"EPENDIMITIS GRANULOSA"
  },
  {
    "codigo":721474007,
    "descripcion":"SÍNDROME DEL CORDÓN POSTERIOR DE MÉDULA ESPINAL AL NIVEL DEL SEXTO SEGMENTO DORSAL"
  },
  {
    "codigo":129815002,
    "descripcion":"CRECIMIENTO Y DESARROLLO TARDÍOS"
  },
  {
    "codigo":719639002,
    "descripcion":"LENGUA MAGENTA"
  },
  {
    "codigo":293655002,
    "descripcion":"ALERGIA A OMEPRAZOL"
  },
  {
    "codigo":228119003,
    "descripcion":"CITADO\/A PARA PRESENTARSE EN LA CORTE"
  },
  {
    "codigo":160748000,
    "descripcion":"CÓNYUGE INCAPAZ DE CUIDAR AL PACIENTE"
  },
  {
    "codigo":95212006,
    "descripcion":"ENFERMEDAD GINGIVAL CAUSADA POR EL EMBARAZO"
  },
  {
    "codigo":291820007,
    "descripcion":"INTOXICACIÓN INTENCIONAL CAUSADA POR METFORMINA"
  },
  {
    "codigo":783340009,
    "descripcion":"OSTEÍTIS DE PELVIS"
  },
  {
    "codigo":289985002,
    "descripcion":"INCAPAZ DE USAR EL ORINAL"
  },
  {
    "codigo":224449002,
    "descripcion":"EL EMPLEADOR NO ES COMPASIVO ANTE EL PROBLEMA DE SALUD"
  },
  {
    "codigo":124310000,
    "descripcion":"DEFICIENCIA DE RIBOCINASA"
  },
  {
    "codigo":93377009,
    "descripcion":"DESALINEAMIENTO CONGÉNITO DEL PUBIS"
  },
  {
    "codigo":26006005,
    "descripcion":"GASTROENTERITIS ALÉRGICA"
  },
  {
    "codigo":286315000,
    "descripcion":"INCAPAZ DE UTILIZAR COMBINACIONES DE VOCALES Y CONSONANTES"
  },
  {
    "codigo":384619003,
    "descripcion":"COMPROMISO TUMORAL DEL MARGEN CIRCUNFERENCIAL DE RESECCIÓN QUIRÚRGICA, NO APLICABLE"
  },
  {
    "codigo":253547008,
    "descripcion":"ATRESIA DEL TRACTO DE SALIDA DEL VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":87872006,
    "descripcion":"ALOPECIA DE DISTRIBUCIÓN MASCULINA"
  },
  {
    "codigo":448320008,
    "descripcion":"AURÍCULA IZQUIERDA DIVIDIDA CON DESEMBOCADURA DE ALGUNAS VENAS PULMONARES EN LA CÁMARA PROXIMAL"
  },
  {
    "codigo":86037001,
    "descripcion":"INTOXICACIÓN POR SECALE CEREALE"
  },
  {
    "codigo":249877006,
    "descripcion":"LENGUA EN TROMBÓN"
  },
  {
    "codigo":315413006,
    "descripcion":"NACIDO EN LA REPÚBLICA DEMOCRÁTICA DE COREA"
  },
  {
    "codigo":248042003,
    "descripcion":"CONDUCTA NO COOPERATIVA"
  },
  {
    "codigo":1296618003,
    "descripcion":"HIPERTENSIÓN OCULAR DE OJO DERECHO DEBIDA A PROCEDIMIENTO QUIRÚRGICO OFTALMOLÓGICO"
  },
  {
    "codigo":299187007,
    "descripcion":"AMPLITUD DE OPOSICIÓN ACTIVA DEL PULGAR DISMINUIDA"
  },
  {
    "codigo":278975000,
    "descripcion":"NO INMUNE A HEPATITIS C"
  },
  {
    "codigo":410047003,
    "descripcion":"LUXACIÓN EXPUESTA DE REGIÓN DE HOMBRO"
  },
  {
    "codigo":16831006,
    "descripcion":"INDIFERENCIA AL DOLOR"
  },
  {
    "codigo":1260180004,
    "descripcion":"SÍNDROME DE TERATOMA CRECIENTE"
  },
  {
    "codigo":211604005,
    "descripcion":"LESIÓN TRAUMÁTICA CERRADA POR APLASTAMIENTO, PIE"
  },
  {
    "codigo":735892006,
    "descripcion":"ESGUINCE DE LIGAMENTO LATERAL DE ARTICULACIÓN INTERFALÁNGICA DE DEDO GORDO DE PIE"
  },
  {
    "codigo":11773611000119100,
    "descripcion":"HERIDA DE REGIÓN DE CODO DERECHO DEBIDA A PICADURA DE INSECTO NO VENENOSO"
  },
  {
    "codigo":111465000,
    "descripcion":"PARÁLISIS DE ERB - DUCHENNE COMO MANIFESTACIÓN DE TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":766825002,
    "descripcion":"FENÓMENO DE FLUJO CORONARIO LENTO"
  },
  {
    "codigo":78697003,
    "descripcion":"MASTITIS NO PURULENTA ASOCIADA CON EL PARTO"
  },
  {
    "codigo":439145006,
    "descripcion":"HIPOFIBRINOGENEMIA CONGÉNITA"
  },
  {
    "codigo":109630002,
    "descripcion":"ESPACIO LIGAMENTARIO PERIODONTAL ENSANCHADO"
  },
  {
    "codigo":207934002,
    "descripcion":"FRACTURA EXPUESTA DE VÉRTEBRA CERVICAL, ARCO POSTERIOR"
  },
  {
    "codigo":764990003,
    "descripcion":"CARCINOMA RENAL MUCINOSO DE CÉLULAS TUBULARES Y FUSIFORMES"
  },
  {
    "codigo":44094008,
    "descripcion":"TOXICIDAD DE COMPUESTO AMIDA"
  },
  {
    "codigo":402707003,
    "descripcion":"DERMATOSIS INFLAMATORIA DE GENITALES FEMENINOS"
  },
  {
    "codigo":9491003,
    "descripcion":"ATROFIA DE PAPILA LINGUAL"
  },
  {
    "codigo":238867003,
    "descripcion":"HIALINOSIS SISTÉMICA INFANTIL"
  },
  {
    "codigo":37971000087103,
    "descripcion":"ACINESIA DE SEGMENTO INFERIOR APICAL DE VENTRÍCULO CARDÍACO IZQUIERDO"
  },
  {
    "codigo":43091000087106,
    "descripcion":"HEMATOMA DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":40531000087107,
    "descripcion":"FRACTURA DE FALANGE PROXIMAL DE DEDO MEDIO DERECHO"
  },
  {
    "codigo":1285608004,
    "descripcion":"ANTICUERPO ANTIRRUBÉOLA DETECTADO"
  },
  {
    "codigo":1187304005,
    "descripcion":"SÍNDROME DE MACROCEFALIA, DISCAPACIDAD INTELECTUAL, TRASTORNO DEL NEURODESARROLLO Y TÓRAX PEQUEÑO"
  },
  {
    "codigo":35411000087108,
    "descripcion":"INFARTO ANTIGUO DE MIOCARDIO DE REGIÓN ANTEROLATERAL"
  },
  {
    "codigo":73192008,
    "descripcion":"ESTENOSIS MÚLTIPLE Y BILATERAL DE LA ARTERIA CEREBRAL ANTERIOR"
  },
  {
    "codigo":169661001,
    "descripcion":"ECOGRAFÍA PRENATAL DESEADA"
  },
  {
    "codigo":202429002,
    "descripcion":"TUMOR TENOSINOVIAL DE CÉLULAS GIGANTES DIFUSO DE PIERNA"
  },
  {
    "codigo":687941000119101,
    "descripcion":"SARCOMA PRIMARIO DE PARTES BLANDAS DE ABDOMEN"
  },
  {
    "codigo":300733004,
    "descripcion":"INCAPAZ DE USAR EL TELÉFONO"
  },
  {
    "codigo":32581000119101,
    "descripcion":"HIPERESTIMULACIÓN OVÁRICA LEVE A MODERADA"
  },
  {
    "codigo":38589006,
    "descripcion":"HEMOGLOBINOPATÍA MIXTA"
  },
  {
    "codigo":366269007,
    "descripcion":"HALLAZGO RELACIONADO CON VOLUMEN DE VEJIGA URINARIA"
  },
  {
    "codigo":724882000,
    "descripcion":"LESIÓN TRAUMÁTICA DEL TÓRAX"
  },
  {
    "codigo":298898003,
    "descripcion":"AMPLITUD DE EXTENSIÓN PASIVA DE CODO AUMENTADA"
  },
  {
    "codigo":200594006,
    "descripcion":"ÁNTRAX DE LA PIERNA (EXCLUIDO EL PIE)"
  },
  {
    "codigo":266130009,
    "descripcion":"SÍFILIS ADQUIRIDA LATENTE TEMPRANA"
  },
  {
    "codigo":231527003,
    "descripcion":"TRASTORNO DE LA PERSONALIDAD EXPLOSIVA"
  },
  {
    "codigo":165991003,
    "descripcion":"INMUNOELECTROFORESIS DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":297063003,
    "descripcion":"SOBREDOSIS INTENCIONAL DE DIGOXINA"
  },
  {
    "codigo":428135008,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE MÚLTIPLES LOCALIZACIONES, CON INFECCIÓN"
  },
  {
    "codigo":721212001,
    "descripcion":"LIQUEN PLANO EROSIVO DE VAGINA"
  },
  {
    "codigo":229692002,
    "descripcion":"DISTONÍA ORAL"
  },
  {
    "codigo":295228004,
    "descripcion":"SOBREDOSIS INTENCIONAL DE DICLOFENACO"
  },
  {
    "codigo":11829061000119106,
    "descripcion":"AMPOLLA TRAUMÁTICA DE MUSLO IZQUIERDO"
  },
  {
    "codigo":33084007,
    "descripcion":"TRASTORNO DE LA IDENTIDAD"
  },
  {
    "codigo":1145361000,
    "descripcion":"LESIÓN HIPOINTENSA DE TÁLAMO EN IMAGEN DE RESONANCIA MAGNÉTICA EN T2"
  },
  {
    "codigo":426300009,
    "descripcion":"MIOCARDIOPATÍA INDUCIDA POR TAQUICARDIA"
  },
  {
    "codigo":459068007,
    "descripcion":"ENDOCARDITIS INFECCIOSA DE VÁLVULA AÓRTICA"
  },
  {
    "codigo":293393003,
    "descripcion":"REACCIÓN ADVERSA AL ÁCIDO FÓLICO"
  },
  {
    "codigo":719377004,
    "descripcion":"SÍNDROME DE MICROCEFALIA CON ALBINISMO Y ANOMALÍA DIGITAL"
  },
  {
    "codigo":424465004,
    "descripcion":"OBSTRUCCIÓN DE LAS VÍAS DE SALIDA DEL LUGAR DE RESIDENCIA"
  },
  {
    "codigo":31249007,
    "descripcion":"OSTEOCONDROSIS JUVENIL DE LA MANO"
  },
  {
    "codigo":94950004,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE MÚSCULO DEL TÓRAX"
  },
  {
    "codigo":160486005,
    "descripcion":"GRUPO SOCIAL 5 - NO CALIFICADO"
  },
  {
    "codigo":62182006,
    "descripcion":"HEMORRAGIA DEL ESCROTO"
  },
  {
    "codigo":291558004,
    "descripcion":"INTOXICACIÓN POR CEFADROXILO"
  },
  {
    "codigo":93115000,
    "descripcion":"FALTA DE OSIFICACIÓN DEL PUBIS"
  },
  {
    "codigo":224187001,
    "descripcion":"INGRESO VARIABLE"
  },
  {
    "codigo":289723002,
    "descripcion":"HALLAZGO RELACIONADO CON LA DURACIÓN DE LA CONTRACCIÓN UTERINA"
  },
  {
    "codigo":25744000,
    "descripcion":"INTOLERANCIA FAMILIAR A LA LACTOSA GRAVE"
  },
  {
    "codigo":1141691009,
    "descripcion":"DEMUESTRA CONOCIMIENTO SOBRE CUIDADOS DEL LACTANTE"
  },
  {
    "codigo":1172624000,
    "descripcion":"SÍNDROME DEL NEURODESARROLLO ASOCIADO AL GEN RERE"
  },
  {
    "codigo":715707008,
    "descripcion":"POLIDACTILIA POSTAXIAL TIPO B"
  },
  {
    "codigo":91280004,
    "descripcion":"RESPIRACIÓN GLOSOFARÍNGEA"
  },
  {
    "codigo":1010619008,
    "descripcion":"PAPILOMA TRAQUEOBRONQUIAL INFLAMATORIO"
  },
  {
    "codigo":16527481000119100,
    "descripcion":"CARCINOMA NO MICROCÍTICO PRIMARIO DE LÓBULO MEDIO DE PULMÓN DERECHO"
  },
  {
    "codigo":124048004,
    "descripcion":"ESFINGOMIELINA POR DEBAJO DE RANGO DE REFERENCIA"
  },
  {
    "codigo":449893000,
    "descripcion":"TIEMPO DE PROTROMBINA DENTRO DEL RANGO OBJETIVO"
  },
  {
    "codigo":417125003,
    "descripcion":"HAMARTOMA DE RETINA"
  },
  {
    "codigo":89445004,
    "descripcion":"PULSO VENOSO YUGULAR ANORMAL"
  },
  {
    "codigo":56677004,
    "descripcion":"SÍNDROME DE PALLISTER - HALL"
  },
  {
    "codigo":253285007,
    "descripcion":"COMUNICACIÓN AURICULOVENTRICULAR AUSENTE DEL LADO DERECHO"
  },
  {
    "codigo":54842003,
    "descripcion":"OBSTRUCCIÓN INTESTINAL POR LECHE ESPESA EN EL RECIÉN NACIDO"
  },
  {
    "codigo":448058003,
    "descripcion":"DURACIÓN EXCESIVAMENTE BREVE DE TRATAMIENTO FARMACOLÓGICO"
  },
  {
    "codigo":251450004,
    "descripcion":"PATRÓN ELECTROENCEFALOGRÁFICO DE IMPORTANCIA INDETERMINADA"
  },
  {
    "codigo":284218003,
    "descripcion":"QUEMADURA DE LA REGIÓN PÉLVICA"
  },
  {
    "codigo":216847006,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR MONÓXIDO DE CARBONO POR COMBUSTIÓN INCOMPLETA DE QUEROSÉN O PARAFINA EN ESTUFA O COCINA DE USO DOMÉSTICO"
  },
  {
    "codigo":20239009,
    "descripcion":"PROLIFERACIÓN DE LA VÍA BILIAR"
  },
  {
    "codigo":10956921000119106,
    "descripcion":"HERIDA ABIERTA DE DEDO DE LA MANO IZQUIERDA DEBIDA A MORDEDURA HUMANA"
  },
  {
    "codigo":247780007,
    "descripcion":"SENTIMIENTOS EXCESIVOS DE EFICIENCIA FÍSICA"
  },
  {
    "codigo":83940008,
    "descripcion":"TROMBOSIS DE LA ARTERIA HEPÁTICA"
  },
  {
    "codigo":35091000119101,
    "descripcion":"DISTROFIA DE CÓRNEA POSTERIOR"
  },
  {
    "codigo":1360057005,
    "descripcion":"ÚLCERA CORNEAL DE OJO DERECHO"
  },
  {
    "codigo":213177007,
    "descripcion":"FALLA PARCIAL DE REIMPLANTE DE DEDOS DE LOS PIES"
  },
  {
    "codigo":278713008,
    "descripcion":"GRUPO DE DISPLASIA CONGÉNITA ESPONDILOEPIFISARIA"
  },
  {
    "codigo":16569009,
    "descripcion":"ANOMALÍA DEL PAR DE CROMOSOMAS 15"
  },
  {
    "codigo":735630002,
    "descripcion":"EYACULACIÓN PRECOZ SITUACIONAL PERMANENTE"
  },
  {
    "codigo":409785007,
    "descripcion":"DERMATITIS DE CONTACTO CAUSADA POR URUSHIOL DE ROBLE VENENOSO DEL ATLÁNTICO"
  },
  {
    "codigo":80270005,
    "descripcion":"INFECCIÓN CAUSADA POR GONGYLONEMA PULCHRUM"
  },
  {
    "codigo":1259918007,
    "descripcion":"TRASTORNO FETAL Y\/O NEONATAL PRECOZ DEBIDO A DESPROPORCIÓN FETOPELVIANA DURANTE TRABAJO DE PARTO Y\/O PARTO"
  },
  {
    "codigo":276878008,
    "descripcion":"HIPERPLASIA DE CÉLULAS ESCAMOSAS DE LA VULVA"
  },
  {
    "codigo":209507002,
    "descripcion":"DISTENSIÓN DEL TENDÓN DEL CUÁDRICEPS"
  },
  {
    "codigo":78435003,
    "descripcion":"GANGLIÓN DE ARTICULACIÓN"
  },
  {
    "codigo":1290851003,
    "descripcion":"FIBROSARCOMA EPITELIOIDE ESCLEROSANTE"
  },
  {
    "codigo":897635007,
    "descripcion":"FORMA DE CONO ANORMAL CONGÉNITA DE EPÍFISIS CON DETENCIÓN EPIFISARIA"
  },
  {
    "codigo":406115008,
    "descripcion":"HALLAZGO RELACIONADO CON LA PRUEBA PARA SÍFILIS"
  },
  {
    "codigo":307811009,
    "descripcion":"NINGÚN MICROORGANISMO AISLADO POR CULTIVO EN ESPÉCIMEN DE HECES"
  },
  {
    "codigo":699192000,
    "descripcion":"HIPERPLASIA ONCOCÍTICA NODULAR MULTIFOCAL DE GLÁNDULA PARÓTIDA"
  },
  {
    "codigo":240440000,
    "descripcion":"ACTINOMICOSIS MANDIBULAR"
  },
  {
    "codigo":1354552000,
    "descripcion":"EDEMA DE MÁCULA LEVE DEBIDO A DIABETES MELLITUS"
  },
  {
    "codigo":109368005,
    "descripcion":"NEOPLASIA MALIGNA SUPERPUESTA DE LA HIPOFARINGE"
  },
  {
    "codigo":41997000,
    "descripcion":"ALVEOLITIS PULMONAR ASMÁTICA"
  },
  {
    "codigo":402445003,
    "descripcion":"CONJUNTIVITIS CICATRIZAL POR ENFERMEDAD LINEAL POR IGA"
  },
  {
    "codigo":369677003,
    "descripcion":"MARGEN RADIAL DE RESECCIÓN QUIRÚRGICA DE ESÓFAGO, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":271373005,
    "descripcion":"PARTOS ESPONTÁNEOS EN PELVIANA"
  },
  {
    "codigo":238605006,
    "descripcion":"DISTROFIA UNGUEAL PSORIÁSICA"
  },
  {
    "codigo":105698000,
    "descripcion":"ENFERMEDAD CAUSADA POR SPIRUROIDEA"
  },
  {
    "codigo":236770001,
    "descripcion":"EPIDIDIMORQUITIS TUBERCULOSA"
  },
  {
    "codigo":302306005,
    "descripcion":"RUPTURA POSQUIRÚRGICA DEL DIAFRAGMA"
  },
  {
    "codigo":1187042007,
    "descripcion":"SÍNDROME DE CONVULSIONES DE COMIENZO TEMPRANO, ANOMALÍAS DE EXTREMIDADES DISTALES, DISMORFIA FACIAL Y RETRASO GLOBAL DEL DESARROLLO"
  },
  {
    "codigo":72930009,
    "descripcion":"TROMBOFLEBITIS MIGRATORIA SUPERFICIAL"
  },
  {
    "codigo":366007004,
    "descripcion":"HALLAZGO RELACIONADO CON EL ESTILO DE VESTIMENTA INDIVIDUAL"
  },
  {
    "codigo":300471006,
    "descripcion":"HALLAZGO RELACIONADO CON LA FRECUENCIA DE LA MICCIÓN"
  },
  {
    "codigo":202167006,
    "descripcion":"LUXACIÓN PATOLÓGICA DE REGIÓN DE HOMBRO"
  },
  {
    "codigo":5559008,
    "descripcion":"CITOLOGÍA NORMAL"
  },
  {
    "codigo":298636000,
    "descripcion":"AMPLITUD DE FLEXIÓN LATERAL ACTIVA HACIA LA IZQUIERDA DE LA COLUMNA VERTEBRAL LUMBAR, NORMAL"
  },
  {
    "codigo":1052300001,
    "descripcion":"PROCTOCOLITIS DEBIDA A SÍFILIS SECUNDARIA"
  },
  {
    "codigo":10877511000119100,
    "descripcion":"HERIDA ABIERTA DE PIERNA DERECHA DEBIDA A MORDEDURA"
  },
  {
    "codigo":724620008,
    "descripcion":"PROBLEMA DE CUELLO"
  },
  {
    "codigo":69260008,
    "descripcion":"COMPLICACIÓN DE DISPOSITIVO PROTÉSICO INTERNO"
  },
  {
    "codigo":1279841001,
    "descripcion":"CARCINOMA INDIFERENCIADO DE PÁNCREAS CON CÉLULAS GIGANTES DE TIPO OSTEOCLASTO"
  },
  {
    "codigo":67425005,
    "descripcion":"CONTRACTURA DE VAINA DE TENDÓN"
  },
  {
    "codigo":296801006,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE ETAMBUTOL"
  },
  {
    "codigo":294966000,
    "descripcion":"ALERGIA A FENOFIBRATO"
  },
  {
    "codigo":131126003,
    "descripcion":"VITAMINA B12 POR ENCIMA DE RANGO DE REFERENCIA"
  },
  {
    "codigo":720950009,
    "descripcion":"TROMBOCITOSIS FAMILIAR"
  },
  {
    "codigo":63755003,
    "descripcion":"ANESTESIA EN GUANTE"
  },
  {
    "codigo":1145099004,
    "descripcion":"PESTAÑAS LARGAS"
  },
  {
    "codigo":162059005,
    "descripcion":"MALESTAR GÁSTRICO"
  },
  {
    "codigo":293131006,
    "descripcion":"REACCIÓN ADVERSA A LA ANTITOXINA BOTULÍNICA"
  },
  {
    "codigo":94688000,
    "descripcion":"LINFOSARCOMA DE CÉLULAS MIXTAS DE LOS GANGLIOS LINFÁTICOS INTRATORÁCICOS"
  },
  {
    "codigo":92853002,
    "descripcion":"FUSIÓN ANORMAL CONGÉNITA DE HUESO EXOCCIPITAL"
  },
  {
    "codigo":125621009,
    "descripcion":"LUXACIÓN TRAUMÁTICA DE ARTICULACIÓN DE CADERA"
  },
  {
    "codigo":254858003,
    "descripcion":"CISTOADENOMA SEROSO PAPILAR DE OVARIO"
  },
  {
    "codigo":58250006,
    "descripcion":"DOLOR URENTE DURANTE LA MICCIÓN"
  },
  {
    "codigo":123786007,
    "descripcion":"TRASTORNO EN EL PROCESO DE COAGULACIÓN SANGUÍNEA CON DISMINUCIÓN DEL TIEMPO DE COAGULACIÓN"
  },
  {
    "codigo":285791002,
    "descripcion":"INCAPAZ DE RECONOCER LOS DEDOS DE SUS MANOS"
  },
  {
    "codigo":449631002,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE PIEL DE BRAZO"
  },
  {
    "codigo":89183005,
    "descripcion":"ERGOTISMO ESPASMÓDICO"
  },
  {
    "codigo":283956001,
    "descripcion":"CONTUSIÓN DE OVARIO"
  },
  {
    "codigo":11997921000119106,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DE BRAZO DERECHO"
  },
  {
    "codigo":251188008,
    "descripcion":"PARASÍSTOLE AURICULAR"
  },
  {
    "codigo":19977002,
    "descripcion":"EGOFONÍA"
  },
  {
    "codigo":445961003,
    "descripcion":"HEMATOPOYESIS INEFICAZ"
  },
  {
    "codigo":216585002,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR PROCAÍNA"
  },
  {
    "codigo":249353005,
    "descripcion":"HALLAZGO EN LA MUCOSA NASAL"
  },
  {
    "codigo":1363465003,
    "descripcion":"DESARROLLO Y ERUPCIÓN DENTAL NORMAL"
  },
  {
    "codigo":773641008,
    "descripcion":"MATRICOMA ONICOCÍTICO"
  },
  {
    "codigo":247518009,
    "descripcion":"HALLAZGO EN EL LECHO UNGUEAL"
  },
  {
    "codigo":737203001,
    "descripcion":"TRASTORNO DE HÍGADO CONCOMITANTE CON TRASTORNO DEL CICLO DE LA UREA Y DEBIDO A ÉL"
  },
  {
    "codigo":343021000119100,
    "descripcion":"OJO DERECHO CIEGO, VISIÓN NORMAL EN OJO IZQUIERDO"
  },
  {
    "codigo":1090541000119101,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE OREJA DERECHA"
  },
  {
    "codigo":12403181000119100,
    "descripcion":"FUGA DE AMPOLLA FILTRANTE POSTRABECULECTOMÍA DERECHA"
  },
  {
    "codigo":201395181000119103,
    "descripcion":"NEOPLASIA MUCINOSA APENDICULAR DE BAJO GRADO DE APÉNDICE"
  },
  {
    "codigo":1087981000119103,
    "descripcion":"OTITIS MEDIA ALÉRGICA AGUDA DEL OÍDO IZQUIERDO"
  },
  {
    "codigo":87021000119103,
    "descripcion":"TUMOR TENOSINOVIAL DIFUSO DE CÉLULAS GIGANTES DE ARTICULACIÓN DE VÉRTEBRA"
  },
  {
    "codigo":16279021000119106,
    "descripcion":"DELIRIO DEBIDO A ABSTINENCIA DE OPIOIDE"
  },
  {
    "codigo":66541000119103,
    "descripcion":"PORTADOR DE ENFERMEDAD QUÍSTICA RENAL CONGÉNITA"
  },
  {
    "codigo":10759661000119108,
    "descripcion":"RUPTURA PREMATURA DE MEMBRANAS CON COMIENZO DEL TRABAJO DE PARTO EN FECHA DESCONOCIDA"
  },
  {
    "codigo":332781000119109,
    "descripcion":"DEGENERACIÓN DE MARGEN PUPILAR DERECHO"
  },
  {
    "codigo":1259656006,
    "descripcion":"DEMENCIA DEBIDA A INSUFICIENCIA RENAL"
  },
  {
    "codigo":25581000119105,
    "descripcion":"ÚLCERA DE EXTREMIDAD INFERIOR DEBIDA A SÍNDROME POSFLEBÍTICO"
  },
  {
    "codigo":317421000119105,
    "descripcion":"DETENCIÓN PARCIAL DEL CRECIMIENTO EPIFISARIO DE HÚMERO PROXIMAL IZQUIERDO"
  },
  {
    "codigo":79341000119107,
    "descripcion":"DEMENCIA MIXTA"
  },
  {
    "codigo":242013000,
    "descripcion":"LESIÓN CAUSADA POR EFECTO EXPLOSIVO DE RAYO"
  },
  {
    "codigo":15935981000119108,
    "descripcion":"FATIGA OCULAR DE OJO IZQUIERDO"
  },
  {
    "codigo":1290589003,
    "descripcion":"RADIOGRAFÍA DE HÚMERO Y CINTURA ESCAPULAR NORMAL"
  },
  {
    "codigo":291821000119108,
    "descripcion":"INFLAMACIÓN DE NERVIO PERIFÉRICO DE EXTREMIDAD SUPERIOR IZQUIERDA"
  },
  {
    "codigo":10849261000119109,
    "descripcion":"CUERPO EXTRAÑO EN REGIÓN EXTERNA DE OJO IZQUIERDO"
  },
  {
    "codigo":373085003,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM AFRICANUM"
  },
  {
    "codigo":733533008,
    "descripcion":"FÍSTULA PERIANAL DEBIDA A ENFERMEDAD DE CROHN"
  },
  {
    "codigo":830002000,
    "descripcion":"PELO NORMAL"
  },
  {
    "codigo":698930000,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: UZBEKO"
  },
  {
    "codigo":15959061000119101,
    "descripcion":"CARCINOMA DE CÉLULAS DE TRANSICIÓN DE RIÑÓN IZQUIERDO"
  },
  {
    "codigo":405853005,
    "descripcion":"FENOTIPO FY(B+)"
  },
  {
    "codigo":1255986005,
    "descripcion":"TINCIÓN INTRÍNISECA DE DIENTE VITAL"
  },
  {
    "codigo":404018006,
    "descripcion":"NEUROMA CUTÁNEO"
  },
  {
    "codigo":240178007,
    "descripcion":"OSTEOCONDRITIS JUVENIL DEL BRAZO"
  },
  {
    "codigo":338811000119109,
    "descripcion":"CORIORRETINITIS FOCAL PERIFÉRICA IZQUIERDA"
  },
  {
    "codigo":76338009,
    "descripcion":"ÚLCERA DUODENAL FAMILIAR NORMOPEPSINOGENÉMICA"
  },
  {
    "codigo":764466009,
    "descripcion":"SÍNDROME DE TRISOMÍA 14 MOSAICO"
  },
  {
    "codigo":305714007,
    "descripcion":"ATENDIDO POR CIRUJANO ESPECIALISTA EN TRACTO GASTROINTESTINAL SUPERIOR"
  },
  {
    "codigo":271111006,
    "descripcion":"AMPOLLA TRAUMÁTICA DE LA CABEZA, INFECTADA"
  },
  {
    "codigo":74503008,
    "descripcion":"INFESTACIÓN CAUSADA POR SARCOPHAGA"
  },
  {
    "codigo":402183009,
    "descripcion":"DERMATITIS ATÓPICA DE LOS PLIEGUES"
  },
  {
    "codigo":236508005,
    "descripcion":"GLOMERULONEFRITIS ASOCIADA CON MALIGNIDAD"
  },
  {
    "codigo":302044006,
    "descripcion":"SE MOVILIZA"
  },
  {
    "codigo":11836591000119100,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN TARSOMETATARSIANA DE PIE IZQUIERDO"
  },
  {
    "codigo":365745002,
    "descripcion":"NIVEL DE VALPROATO - HALLAZGO"
  },
  {
    "codigo":726193003,
    "descripcion":"DISTENSIÓN DE MÚSCULO INTRÍNSECO DE PULGAR"
  },
  {
    "codigo":300209006,
    "descripcion":"CAMBIA EL RITMO DE ALIMENTACIÓN EN RESPUESTA AL SONIDO"
  },
  {
    "codigo":200070000,
    "descripcion":"REACCIÓN TÓXICA CAUSADA POR ANESTESIA LOCAL DURANTE EL PUERPERIO"
  },
  {
    "codigo":267441009,
    "descripcion":"UROLITIASIS DE ÁCIDO ÚRICO"
  },
  {
    "codigo":367791000119103,
    "descripcion":"OLIGOZOOSPERMIA CAUSADA POR RADIACIÓN"
  },
  {
    "codigo":167302009,
    "descripcion":"PRUEBA DE SANGRE EN ORINA = +++"
  },
  {
    "codigo":34395002,
    "descripcion":"TROMBOCITOPENIA DEBIDA A HIPOTERMIA"
  },
  {
    "codigo":427611004,
    "descripcion":"VESTIMENTAS PROTECTORAS UTILIZADAS"
  },
  {
    "codigo":165467004,
    "descripcion":"ERITROSEDIMENTACIÓN DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":722523004,
    "descripcion":"CARCINOMA DUCTAL Y LOBULAR MIXTO IN SITU DE MAMA"
  },
  {
    "codigo":16669871000119105,
    "descripcion":"FRACTURA NO EXPUESTA SUBCONDÍLEA DE LADO DERECHO DE LA MANDÍBULA"
  },
  {
    "codigo":198235009,
    "descripcion":"ÁNTRAX DE VAGINA"
  },
  {
    "codigo":296539009,
    "descripcion":"SOBREDOSIS DE AMFOTERICINA B"
  },
  {
    "codigo":129029000,
    "descripcion":"ASISTENCIA PARA MANTENER LA CONTINENCIA"
  },
  {
    "codigo":16014511000119107,
    "descripcion":"TROMBOFLEBITIS DE VENA SUPERFICIAL DE MIEMBRO INFERIOR DERECHO"
  },
  {
    "codigo":292869007,
    "descripcion":"REACCIÓN ADVERSA A LAS SOLUCIONES CLORADAS"
  },
  {
    "codigo":225498000,
    "descripcion":"USA ROPA DE COLORES BRILLANTES"
  },
  {
    "codigo":341321000119103,
    "descripcion":"BLEFAROCONJUNTIVITIS DE OJO IZQUIERDO POR CONTACTO"
  },
  {
    "codigo":258266006,
    "descripcion":"EXTENSIÓN AVANZADA"
  },
  {
    "codigo":127194005,
    "descripcion":"LINFADENOPATÍA AXILAR SUBESCAPULAR"
  },
  {
    "codigo":192730008,
    "descripcion":"ENCEFALITIS TÓXICA"
  },
  {
    "codigo":94426008,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE MÚSCULO DE LA PELVIS"
  },
  {
    "codigo":289199002,
    "descripcion":"PROLIJIDAD"
  },
  {
    "codigo":16561481000119103,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE AMBAS ARTICULACIONES TEMPOROMANDIBULARES"
  },
  {
    "codigo":418436000,
    "descripcion":"LENTE INTRAOCULAR INCLINADA"
  },
  {
    "codigo":92591008,
    "descripcion":"CARCINOMA IN SITU DE TROMPA DE FALOPIO"
  },
  {
    "codigo":13641000119106,
    "descripcion":"COLITIS VIRAL"
  },
  {
    "codigo":254596006,
    "descripcion":"GRANULOMA INTESTINAL POR CUERPO EXTRAÑO"
  },
  {
    "codigo":449369001,
    "descripcion":"DEJÓ DE FUMAR ANTES DEL EMBARAZO"
  },
  {
    "codigo":1137497007,
    "descripcion":"DEBILIDAD DE PRIMER MÚSCULO INTERÓSEO DORSAL DE MANO"
  },
  {
    "codigo":283694003,
    "descripcion":"MORDEDURA HUMANA EN LA BOCA"
  },
  {
    "codigo":414766003,
    "descripcion":"CADENA LIVIANA MONOCLONAL LIBRE DETECTADA"
  },
  {
    "codigo":54318006,
    "descripcion":"EDAD GESTACIONAL, 19 SEMANAS"
  },
  {
    "codigo":281859000,
    "descripcion":"HEMATURIA PERSISTENTE"
  },
  {
    "codigo":249091001,
    "descripcion":"PRESENTACIÓN DE NARIZ DEL FETO"
  },
  {
    "codigo":609539000,
    "descripcion":"HIPERSENSIBILIDAD NO ALÉRGICA A CILAZAPRIL"
  },
  {
    "codigo":707843000,
    "descripcion":"NIVEL DE ALFABETIZACIÓN: ANALFABETO"
  },
  {
    "codigo":52483005,
    "descripcion":"NACIMIENTO DE TÉRMINO DE SEXTILLIZOS"
  },
  {
    "codigo":871683007,
    "descripcion":"REACCIÓN ADVERSA A CLORAL Y\/O DERIVADO DE CLORAL"
  },
  {
    "codigo":8712002,
    "descripcion":"ESTENOSIS SUBAÓRTICA CONGÉNITA DEBIDA A CRESTA FIBROMUSCULAR"
  },
  {
    "codigo":312792007,
    "descripcion":"SUBLUXACIÓN VERTEBRAL CON LESIÓN DE LA COLA DE CABALLO"
  },
  {
    "codigo":81581001,
    "descripcion":"DERMATITIS DE CONTACTO CAUSADA POR MERCURIO"
  },
  {
    "codigo":704173002,
    "descripcion":"FRACTURA PATOLÓGICA DE TOBILLO"
  },
  {
    "codigo":247256009,
    "descripcion":"PROLAPSO DE PARED POSTERIOR DE CONDUCTO AUDITIVO"
  },
  {
    "codigo":15935101000119102,
    "descripcion":"DEFORMIDAD CONGÉNITA EN VALGO DE AMBOS CÚBITOS"
  },
  {
    "codigo":48813009,
    "descripcion":"LINFOCITOPENIA"
  },
  {
    "codigo":278189009,
    "descripcion":"LEUCEMIA PROMIELOCÍTICA HIPERGRANULAR"
  },
  {
    "codigo":14210003,
    "descripcion":"LIPOFUSCINOSIS"
  },
  {
    "codigo":1259394003,
    "descripcion":"CARCINOMA EX ADENOMA PLEOMORFO PRIMARIO DE GLÁNDULA LAGRIMAL"
  },
  {
    "codigo":208983000,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN DE TOBILLO"
  },
  {
    "codigo":733271001,
    "descripcion":"HERIDA PUNZANTE DE MUSLO CON CUERPO EXTRAÑO"
  },
  {
    "codigo":1290327002,
    "descripcion":"QUISTE POPLÍTEO IZQUIERDO"
  },
  {
    "codigo":77911002,
    "descripcion":"DEPRESIÓN MAYOR GRAVE, UN SOLO EPISODIO, CON SÍNTOMAS PSICÓTICOS, CONGRUENTE CON EL ESTADO DE ÁNIMO"
  },
  {
    "codigo":274519004,
    "descripcion":"RESULTADO ANORMAL, ESTUDIO FUNCIONAL DEL SISTEMA NERVIOSO PERIFÉRICO Y DE LOS SENTIDOS"
  },
  {
    "codigo":370988000,
    "descripcion":"ANTICUERPOS CONTRA HEPATITIS C DETECTADOS CON ELEVACIÓN DE ALANINA AMINOTRANSFERASA"
  },
  {
    "codigo":698668001,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: KAZAJO"
  },
  {
    "codigo":305452007,
    "descripcion":"BAJO ATENCIÓN DE ANESTESISTA"
  },
  {
    "codigo":205313000,
    "descripcion":"CAMPTODACTILIA DEL DEDO MEÑIQUE"
  },
  {
    "codigo":403756008,
    "descripcion":"APLASIA CUTÁNEA EN EL SÍNDROME DE TRISOMÍA 13"
  },
  {
    "codigo":762369002,
    "descripcion":"PROLAPSO DE OJO DERECHO CONCOMITANTE CON RUPTURA"
  },
  {
    "codigo":238081000,
    "descripcion":"APOLIPOPROTEÍNA B-100 FAMILIAR DEFECTUOSA"
  },
  {
    "codigo":203478002,
    "descripcion":"OSTEONECROSIS DEL ASTRÁGALO"
  },
  {
    "codigo":1284822005,
    "descripcion":"PH URINARIO EN RANGO DE REFERENCIA"
  },
  {
    "codigo":400086005,
    "descripcion":"ÚLCERA AMEBIANA DE LA PIEL"
  },
  {
    "codigo":365483002,
    "descripcion":"HALLAZGO RELACIONADO CON LAS ESTRUCTURAS DE CONTENCIÓN Y APOYO"
  },
  {
    "codigo":299947003,
    "descripcion":"GRAFESTESIA NORMAL"
  },
  {
    "codigo":201643004,
    "descripcion":"CONDROCALCINOSIS DE REGIÓN PÉLVICA Y MUSLO CAUSADA POR CRISTALES DE PIROFOSFATO"
  },
  {
    "codigo":234411007,
    "descripcion":"SÍNDROME DE DELECIÓN DE GRUPO SANGUÍNEO"
  },
  {
    "codigo":396416000,
    "descripcion":"COMPROMISO DEL ESPÉCIMEN POR GANGLIOS LINFÁTICOS CONGLOMERADOS: PRESENTE"
  },
  {
    "codigo":3200003,
    "descripcion":"SACROCOXALGIA"
  },
  {
    "codigo":724096007,
    "descripcion":"TRASTORNO CONGÉNITO DE LA GLICOSILACIÓN TIPO 1F"
  },
  {
    "codigo":343831000119107,
    "descripcion":"NEOVASCULARIZACIÓN BILATERAL DE RETINA"
  },
  {
    "codigo":15718321000119101,
    "descripcion":"PROTRUSIÓN INTRAPÉLVICA DE ACETÁBULO DE AMBAS CADERAS"
  },
  {
    "codigo":230741004,
    "descripcion":"INFARTO VENOSO DE LA MÉDULA ESPINAL"
  },
  {
    "codigo":197973004,
    "descripcion":"CONGESTIÓN O HEMORRAGIA PROSTÁTICA"
  },
  {
    "codigo":32298001,
    "descripcion":"INFECCIÓN INTESTINAL CAUSADA POR TRICHOMONAS VAGINALIS"
  },
  {
    "codigo":294442004,
    "descripcion":"ALERGIA A SURFACTANTE DE QUINOLINIO CUATERNARIO"
  },
  {
    "codigo":196138005,
    "descripcion":"NEUMOPATÍA CON LUPUS ERITEMATOSO SISTÉMICO"
  },
  {
    "codigo":1144575004,
    "descripcion":"HIPOPLASIA CONGÉNITA DE MÚSCULO PECTORAL MENOR"
  },
  {
    "codigo":718591004,
    "descripcion":"PAPILOMAVIRUS HUMANO DE ALTO RIESGO DETECTADO POR EXAMEN CITOLÓGICO"
  },
  {
    "codigo":389076003,
    "descripcion":"TRAZAS DE SANGRE OCULTA DETECTADA EN MATERIA FECAL"
  },
  {
    "codigo":94164003,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA AMPOLLA DE VATER"
  },
  {
    "codigo":1306580005,
    "descripcion":"CARCINOMA DUCTAL INFILTRANTE DE CUADRANTE INFERIOR INTERNO DE MAMA IZQUIERDA"
  },
  {
    "codigo":92329001,
    "descripcion":"NEOPLASIA BENIGNA DEL LÓBULO SUPERIOR DERECHO DEL PULMÓN"
  },
  {
    "codigo":190633005,
    "descripcion":"DEFICIENCIA DE ÁCIDO FÓLICO"
  },
  {
    "codigo":288937009,
    "descripcion":"DEGLUTE"
  },
  {
    "codigo":188798005,
    "descripcion":"TUMOR BENIGNO DE LA PARED OROFARÍNGEA"
  },
  {
    "codigo":55891002,
    "descripcion":"PROBLEMA DE ACOMODACIÓN VISUAL"
  },
  {
    "codigo":88659005,
    "descripcion":"QUEILOGNATOPROSOPOSQUISIS"
  },
  {
    "codigo":23123006,
    "descripcion":"TRASTORNO DEBIDO A FRACTURA DE MIEMBRO SUPERIOR Y POSTERIOR A ELLA"
  },
  {
    "codigo":285267007,
    "descripcion":"PENSAMIENTOS DE AGRESIÓN FÍSICA"
  },
  {
    "codigo":186963008,
    "descripcion":"FARINGITIS - ANGINA DE VINCENT"
  },
  {
    "codigo":283432008,
    "descripcion":"CORTE EN LA CADERA"
  },
  {
    "codigo":840488009,
    "descripcion":"INSUFICIENCIA CONGÉNITA DE VÁLVULA TRONCAL"
  },
  {
    "codigo":709416009,
    "descripcion":"SÍNDROME DE DESCAMACIÓN CUTÁNEA CON DISTRIBUCIÓN ACRA"
  },
  {
    "codigo":248829004,
    "descripcion":"LESIÓN DESTRUCTIVA DE PEZÓN"
  },
  {
    "codigo":707581004,
    "descripcion":"CARCINOMA PAPILAR PRIMARIO DE CÉLULAS ESCAMOSAS DE OROFARINGE"
  },
  {
    "codigo":100581000119102,
    "descripcion":"SECUELA DE HEMORRAGIA INTRACRANEAL TRAUMÁTICA"
  },
  {
    "codigo":773117009,
    "descripcion":"ESTRIDOR LARÍNGEO"
  },
  {
    "codigo":281597009,
    "descripcion":"TROMBOSIS DE LA VENA BRAQUIOCEFÁLICA"
  },
  {
    "codigo":346341000119103,
    "descripcion":"MIOPÍA ALTA PROGRESIVA DEGENERATIVA DE AMBOS OJOS"
  },
  {
    "codigo":441767000,
    "descripcion":"MASA DE REGIÓN SUMENTONIANA"
  },
  {
    "codigo":50386009,
    "descripcion":"ENFERMEDAD POR EL VIRUS TATAGUINE"
  },
  {
    "codigo":703911000,
    "descripcion":"ALERGIA A ALMEJA"
  },
  {
    "codigo":17618008,
    "descripcion":"EMBARAZOS PREVIOS: 9"
  },
  {
    "codigo":1197266009,
    "descripcion":"CARCINOMA PAPILAR PRIMARIO DE CUERPO DE ÚTERO"
  },
  {
    "codigo":81319007,
    "descripcion":"TRASTORNO BIPOLAR II GRAVE, EPISODIO MÁS RECIENTE DE CARACTERÍSTICAS DEPRESIVAS PROFUNDAS SIN SÍNTOMAS PSICÓTICOS"
  },
  {
    "codigo":1162663008,
    "descripcion":"OBSTRUCCIÓN DE CATÉTER DE TENCKHOFF"
  },
  {
    "codigo":308860001,
    "descripcion":"DISPLASIA GRAVE DE ESÓFAGO"
  },
  {
    "codigo":210556002,
    "descripcion":"LESIÓN POR DESOLLAMIENTO DE MUÑECA, CARA DORSAL"
  },
  {
    "codigo":276092001,
    "descripcion":"ARRESTADO BAJO CUSTODIA POLICIAL"
  },
  {
    "codigo":472700006,
    "descripcion":"DOMINIO DE CORAZÓN DERECHO FETAL"
  },
  {
    "codigo":1259132008,
    "descripcion":"DISFUNCIÓN DE COLUMNA VERTEBRAL CERVICAL"
  },
  {
    "codigo":1290065002,
    "descripcion":"TUMOR NEUROENDOCRINO BIEN DIFERENCIADO DE ÍLEON"
  },
  {
    "codigo":765777005,
    "descripcion":"REFLUJO VESICOURETERORRENAL IZQUIERDO CONGÉNITO"
  },
  {
    "codigo":698406006,
    "descripcion":"RUPTURA DE GLOBO OCULAR DEBIDA A QUEMADURA Y POSTERIOR A ELLA"
  },
  {
    "codigo":403494007,
    "descripcion":"LUPUS ERITEMATOSO DISCOIDE DE MEMBRANAS MUCOSAS"
  },
  {
    "codigo":8443005,
    "descripcion":"TRASTORNO SENSITIVO DEL NERVIO FACIAL"
  },
  {
    "codigo":237819006,
    "descripcion":"SEUDOPUBERTAD - VIRILIZACIÓN"
  },
  {
    "codigo":301520001,
    "descripcion":"DIFICULTAD PARA SALIR DE LA DUCHA"
  },
  {
    "codigo":858576003,
    "descripcion":"AUSENCIA DE AMBAS AMÍGDALAS PALATINAS"
  },
  {
    "codigo":1153488003,
    "descripcion":"CREATINA CINASA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":365221000,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA MANTENER UN NIVEL DE HIGIENE PERSONAL"
  },
  {
    "codigo":299685003,
    "descripcion":"ESTRECHEZ DE ANASTOMOSIS UROLÓGICA INJERTADA"
  },
  {
    "codigo":234149004,
    "descripcion":"FÍSTULA ARTERIOVENOSA CONGÉNITA DEL CEREBRO"
  },
  {
    "codigo":103077004,
    "descripcion":"INMUNODEFICIENCIA SECUNDARIA A NEOPLASIA"
  },
  {
    "codigo":266917007,
    "descripcion":"BEBEDOR OCASIONAL - MENOS DE 1 UNIDAD POR DÍA"
  },
  {
    "codigo":428922000,
    "descripcion":"HALLADO EN EL ASIENTO DEL CONDUCTOR DE UN AUTOMÓVIL"
  },
  {
    "codigo":166778002,
    "descripcion":"PROTEÍNAS SÉRICAS POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":232314004,
    "descripcion":"ENFERMEDAD DE LYME DEL OÍDO INTERNO"
  },
  {
    "codigo":363386008,
    "descripcion":"NEOPLASIA MALIGNA DE MUCOSA YUGAL"
  },
  {
    "codigo":33871004,
    "descripcion":"TRASTORNO PSICÓTICO CON ALUCINACIONES INDUCIDO POR FENCICLIDINA"
  },
  {
    "codigo":263247007,
    "descripcion":"FRACTURA DE CALCÁNEO"
  },
  {
    "codigo":230479008,
    "descripcion":"CEFALEA POSTERIOR A LA PUNCIÓN DURAL"
  },
  {
    "codigo":296015009,
    "descripcion":"SOBREDOSIS DE SEDANTE"
  },
  {
    "codigo":294180006,
    "descripcion":"ALERGIA A ÁCIDO AZELAICO"
  },
  {
    "codigo":95737000,
    "descripcion":"HEMORRAGIA CORNEAL ESTROMAL"
  },
  {
    "codigo":1144313000,
    "descripcion":"FRENTE PLANA"
  },
  {
    "codigo":1177081002,
    "descripcion":"DIENTE MOLAR EN MORA"
  },
  {
    "codigo":292345002,
    "descripcion":"REACCIÓN ADVERSA AL FLURAZEPAM"
  },
  {
    "codigo":129561000119108,
    "descripcion":"DAÑO RENAL AGUDO PRERRENAL"
  },
  {
    "codigo":716494000,
    "descripcion":"NO COMPRENDE EL HABLA"
  },
  {
    "codigo":423417009,
    "descripcion":"TENDINITIS DE LA MANO"
  },
  {
    "codigo":126670003,
    "descripcion":"NEOPLASIA DE LA CAVIDAD NASAL"
  },
  {
    "codigo":224974006,
    "descripcion":"SENSACIÓN DE ESTRÉS"
  },
  {
    "codigo":1306318006,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE PEZÓN"
  },
  {
    "codigo":28366008,
    "descripcion":"ARTERITIS CEREBRAL"
  },
  {
    "codigo":714659000,
    "descripcion":"CON MAYOR RIESGO DE ALTERACIÓN DE FUNCIÓN DE SISTEMA URINARIO"
  },
  {
    "codigo":93902008,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE MÚSCULO DE LA CABEZA"
  },
  {
    "codigo":288675006,
    "descripcion":"DIFICULTAD PARA RESTABLECER UNA CONVERSACIÓN"
  },
  {
    "codigo":92067007,
    "descripcion":"NEOPLASIA BENIGNA DEL COLÉDOCO"
  },
  {
    "codigo":712824002,
    "descripcion":"TRASTORNO PSICÓTICO POLIMÓRFICO AGUDO SIN SÍNTOMAS DE ESQUIZOFRENIA"
  },
  {
    "codigo":286840003,
    "descripcion":"CARÁCTER IRRESPONSABLE"
  },
  {
    "codigo":188536008,
    "descripcion":"GRANULOMA DE HODGKIN DE GANGLIOS LINFÁTICOS INTRABDOMINALES"
  },
  {
    "codigo":285005005,
    "descripcion":"SE DESABROCHA LA ROPA"
  },
  {
    "codigo":874829006,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE ESCROTO"
  },
  {
    "codigo":55629005,
    "descripcion":"INFECCIÓN CAUSADA POR STRONGYLOIDES TUMEFACIENS"
  },
  {
    "codigo":283170002,
    "descripcion":"CUERPO EXTRAÑO METÁLICO EN EL ABDOMEN"
  },
  {
    "codigo":447010005,
    "descripcion":"CUERPO EXTRAÑO MAGNÉTICO EN IRIS"
  },
  {
    "codigo":1004066007,
    "descripcion":"CONTRACTURA EN FLEXIÓN DE TERCER DEDO DE PIE"
  },
  {
    "codigo":84727000,
    "descripcion":"OSTEÍTIS FIBROSA QUÍSTICA"
  },
  {
    "codigo":281335003,
    "descripcion":"NO SE SUMINISTRÓ EL SEXO DEL PACIENTE"
  },
  {
    "codigo":445175006,
    "descripcion":"SIMBRAQUIDACTILIA DE DEDO DEL PIE"
  },
  {
    "codigo":1264375007,
    "descripcion":"LACERACIÓN DE TENDÓN DE CODO"
  },
  {
    "codigo":838391009,
    "descripcion":"ABSCESO DE ESPACIO EPIDURAL ESPINAL CAUSADO POR BACTERIA"
  },
  {
    "codigo":246732003,
    "descripcion":"ESTRABISMO VERTICAL MANIFIESTO, OJO ARRIBA"
  },
  {
    "codigo":50124004,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN GLÚTEO, CON INFECCIÓN"
  },
  {
    "codigo":322381000119107,
    "descripcion":"HIPERTROFIA DE MEMBRANA SINOVIAL DE ARTICULACIÓN DE MANO DERECHA"
  },
  {
    "codigo":769185003,
    "descripcion":"RETINOPATÍA NO PROLIFERATIVA MODERADA DEL OJO DERECHO DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":1162401004,
    "descripcion":"INFECCIÓN DE REGIÓN DORSOLUMBAR DE LA COLUMNA VERTEBRAL CAUSADA POR MYCOBACTERIUM TUBERCULOSIS"
  },
  {
    "codigo":79222000,
    "descripcion":"COMPRESIÓN DEL CORDÓN UMBILICAL"
  },
  {
    "codigo":1258870003,
    "descripcion":"DILACERACIÓN DE CORONA DE DIENTE PERMANENTE DEBIDA A TRAUMATISMO DENTAL Y POSTERIOR A ÉL"
  },
  {
    "codigo":210294003,
    "descripcion":"HERIDA ABIERTA EN EL OÍDO EXTERNO"
  },
  {
    "codigo":208459000,
    "descripcion":"FRACTURA NO EXPUESTA DE LA FALANGE DISTAL DE DEDO DE LA MANO, MARTILLO"
  },
  {
    "codigo":306763001,
    "descripcion":"INCAPAZ DE PRODUCIR COMBINACIONES DE SONIDOS SONOROS Y SORDOS"
  },
  {
    "codigo":110155005,
    "descripcion":"ABRASIÓN DE LA ENCÍA UNIDA AL MAXILAR SUPERIOR"
  },
  {
    "codigo":11851006,
    "descripcion":"TRASTORNO DE VÁLVULA MITRAL"
  },
  {
    "codigo":403232005,
    "descripcion":"FOTOSUBTIPO CUTÁNEO IVA (CASI NUNCA EXISTE QUEMADURA, LUEGO BRONCEADO LEVE)"
  },
  {
    "codigo":1220597000,
    "descripcion":"SÍNDROME DE RETINOSIS PIGMENTARIA, CATARATA JUVENIL, TALLA BAJA Y DISCAPACIDAD INTELECTUAL"
  },
  {
    "codigo":237557003,
    "descripcion":"TUMORACIÓN TIROIDEA"
  },
  {
    "codigo":679041000119101,
    "descripcion":"PLIEGUE DE MEMBRANA DE BOWMAN DE OJO DERECHO"
  },
  {
    "codigo":303093006,
    "descripcion":"HIPERGLICINEMIA NO CETÓSICA POR DEFICIENCIA DE PROTEÍNA L"
  },
  {
    "codigo":235722000,
    "descripcion":"MALABSORCIÓN PRIMARIA DE LA LACTANCIA"
  },
  {
    "codigo":1351669009,
    "descripcion":"AGAMMAGLOBULINEMIA AUTOSÓMICA RECESIVA DEBIDA A DEFICIENCIA DE P85"
  },
  {
    "codigo":301258003,
    "descripcion":"MOVIMIENTO TORÁCICO AUSENTE"
  },
  {
    "codigo":399562006,
    "descripcion":"OVARIO DERECHO NO COMPROMETIDO POR TUMOR"
  },
  {
    "codigo":6346007,
    "descripcion":"CESE DE LA MADURACIÓN LEUCOCÍTICA"
  },
  {
    "codigo":201119003,
    "descripcion":"UÑA EN PICO DE LORO"
  },
  {
    "codigo":233887004,
    "descripcion":"DERRAME PERICÁRDICO CRÓNICO CAUSADO POR COLESTEROL"
  },
  {
    "codigo":168351005,
    "descripcion":"HISOPADO VAGINAL PROFUNDO: OBSERVACIÓN DE LEUCOCITOS"
  },
  {
    "codigo":725407006,
    "descripcion":"EPIDERMÓLISIS BULLOSA DISTRÓFICA RECESIVA NO TIPO HALLOPEAU-SIEMENS"
  },
  {
    "codigo":364959009,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA SACAR LA LENGUA TOTALMENTE"
  },
  {
    "codigo":461428001,
    "descripcion":"RESTRICCIÓN DE ORIFICIO DE ARTERIA CORONARIA DEBIDA A TEJIDO DE VALVA DE VÁLVULA"
  },
  {
    "codigo":68212003,
    "descripcion":"AMPOLLA DE LA VULVA, CON INFECCIÓN"
  },
  {
    "codigo":363124003,
    "descripcion":"TRASTORNO DEL APARATO REPRODUCTOR FEMENINO"
  },
  {
    "codigo":295753000,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE RAZOXANO"
  },
  {
    "codigo":232052009,
    "descripcion":"RETINITIS PIGMENTARIA AUTOSÓMICA DOMINANTE"
  },
  {
    "codigo":841002,
    "descripcion":"AUSENCIA CONGÉNITA DE LOS HUESOS DEL CRÁNEO"
  },
  {
    "codigo":262985005,
    "descripcion":"SECCIÓN TRAUMÁTICA DE TENDÓN DEL MÚSCULO FLEXOR LARGO DEL ANTEBRAZO, LA MUÑECA O LA MANO"
  },
  {
    "codigo":721737007,
    "descripcion":"INFECCIÓN CAUSADA POR SPIRILLUM"
  },
  {
    "codigo":293918000,
    "descripcion":"ALERGIA A TETRABENAZINA"
  },
  {
    "codigo":228382007,
    "descripcion":"USO INAPROPIADO DE DROGAS POR VÍA VAGINAL"
  },
  {
    "codigo":718067000,
    "descripcion":"FALLA PRIMARIA DE LA OSTEOINTEGRACIÓN DE IMPLANTE DENTAL"
  },
  {
    "codigo":423155007,
    "descripcion":"MORADA CON BARRERAS ESTRUCTURALES PARA EL MOVIMIENTO"
  },
  {
    "codigo":28104001,
    "descripcion":"COMPLICACIÓN VASCULAR DE LA ATENCIÓN MÉDICA"
  },
  {
    "codigo":716232002,
    "descripcion":"DISOSTOSIS ESPONDILOCOSTAL AUTOSÓMICA DOMINANTE"
  },
  {
    "codigo":93640008,
    "descripcion":"MELANOMA MALIGNO DE LA PIEL DE LABIO"
  },
  {
    "codigo":290248008,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR FENBUFÉN"
  },
  {
    "codigo":288413000,
    "descripcion":"INCAPAZ DE DESENROSCAR UNA TAPA"
  },
  {
    "codigo":59037007,
    "descripcion":"INTOLERANCIA MEDICAMENTOSA"
  },
  {
    "codigo":124573009,
    "descripcion":"DEFICIENCIA DE RIBONUCLEASA"
  },
  {
    "codigo":253810002,
    "descripcion":"HAMARTOMA DE HÍGADO"
  },
  {
    "codigo":450418003,
    "descripcion":"HEMORRAGIA CEREBRAL DEBIDA A TRAUMATISMO"
  },
  {
    "codigo":188274004,
    "descripcion":"NEOPLASIA MALIGNA DE CONDUCTO NASOLAGRIMAL"
  },
  {
    "codigo":284743005,
    "descripcion":"TIRARSE AL PISO"
  },
  {
    "codigo":710727006,
    "descripcion":"AGRANDAMIENTO DE RAÍZ LINGUAL"
  },
  {
    "codigo":282908003,
    "descripcion":"INCAPAZ DE LEVANTARSE DESDE POSICIÓN DE CUCLILLAS SIN USAR LAS MANOS"
  },
  {
    "codigo":250140004,
    "descripcion":"CALZADO DEMASIADO AJUSTADO"
  },
  {
    "codigo":16846261000119106,
    "descripcion":"COMPRESIÓN DE COLA DE CABALLO"
  },
  {
    "codigo":1091151000119101,
    "descripcion":"INFLAMACIÓN CRÓNICA DE PORCIÓN PETROSA DE HUESO TEMPORAL DERECHO"
  },
  {
    "codigo":248305004,
    "descripcion":"DISTRIBUCIÓN FEMENINA DE LA GRASA"
  },
  {
    "codigo":18929007,
    "descripcion":"ÁNTRAX DEL PIE"
  },
  {
    "codigo":49862000,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO DE MUSLO"
  },
  {
    "codigo":108111000119103,
    "descripcion":"ANOMALÍA ADQUIRIDA DE LA BOCA"
  },
  {
    "codigo":836294006,
    "descripcion":"INFARTO AGUDO DE MIOCARDIO DE VÉRTICE DEL CORAZÓN"
  },
  {
    "codigo":703387000,
    "descripcion":"LEUCEMIA MIELOIDE AGUDA CON CARIOTIPO NORMAL"
  },
  {
    "codigo":770758009,
    "descripcion":"ESTADO EPILÉPTICO REFRACTARIO NUEVO"
  },
  {
    "codigo":80795005,
    "descripcion":"ENFERMEDAD POR EL VIRUS DUGBE"
  },
  {
    "codigo":78960005,
    "descripcion":"DEFICIENCIA DE TRIACILGLICEROL LIPASA PANCREÁTICA"
  },
  {
    "codigo":767088005,
    "descripcion":"SEGUNDO VASO CON PARTÍCULAS O SEDIMENTOS"
  },
  {
    "codigo":109893001,
    "descripcion":"SEPARACIÓN TROFOBLÁSTICA"
  },
  {
    "codigo":404805002,
    "descripcion":"PLATINOSIS"
  },
  {
    "codigo":699717004,
    "descripcion":"ARCADA MANDIBULAR ANCHA"
  },
  {
    "codigo":304666001,
    "descripcion":"DIFICULTAD PARA EMPLEAR RAZONAMIENTO VERBAL"
  },
  {
    "codigo":208197009,
    "descripcion":"FRACTURA EXPUESTA VERTICAL DE ILION"
  },
  {
    "codigo":11986511000119109,
    "descripcion":"QUEMADURA EPIDÉRMICA DE MANO IZQUIERDA"
  },
  {
    "codigo":1254938005,
    "descripcion":"PRURITO CAUSADO POR OPIOIDE"
  },
  {
    "codigo":370202007,
    "descripcion":"ASMA QUE PRODUCE SÍNTOMAS DIURNOS 1 O 2 VECES POR MES"
  },
  {
    "codigo":42522007,
    "descripcion":"ABSCESO DE MEDIASTINO"
  },
  {
    "codigo":402970009,
    "descripcion":"ERITEMA NUDOSO CAUSADO POR YERSINIA ENTEROCOLITICA"
  },
  {
    "codigo":7919002,
    "descripcion":"ALTERACIÓN DE LA INTEGRIDAD DE LA PIEL"
  },
  {
    "codigo":1187567002,
    "descripcion":"ENFERMEDAD DE CHARCOT MARIE TOOTH INTERMEDIA AUTOSÓMICA RECESIVA TIPO D"
  },
  {
    "codigo":11796201000119104,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN METACARPOFALÁNGICA DE DEDO ANULAR DE MANO IZQUIERDA"
  },
  {
    "codigo":827119006,
    "descripcion":"MASA QUE OCUPA TODOS LOS CUADRANTES DEL ABDOMEN"
  },
  {
    "codigo":71620000,
    "descripcion":"FRACTURA DE FÉMUR"
  },
  {
    "codigo":282931003,
    "descripcion":"INCAPAZ DE MOVERSE DE POSICIÓN ACOSTADA A SENTADA"
  },
  {
    "codigo":300996004,
    "descripcion":"FIBRILACIÓN AURICULAR CONTROLADA"
  },
  {
    "codigo":366532005,
    "descripcion":"HALLAZGO RELACIONADO CON LA AMPLITUD DE LA ADUCCIÓN DE LA MUÑECA"
  },
  {
    "codigo":268228006,
    "descripcion":"CRIPTORQUIDIA BILATERAL"
  },
  {
    "codigo":4249000,
    "descripcion":"HIPOPERFUSIÓN PERIFÉRICA"
  },
  {
    "codigo":169924008,
    "descripcion":"PUNTAJE DE APGAR A LOS 10 MINUTOS = 1"
  },
  {
    "codigo":725145002,
    "descripcion":"DEFECTO DEL TABIQUE INTERAURICULAR Y DE LA CONDUCCIÓN AURICULOVENTRICULAR"
  },
  {
    "codigo":202692008,
    "descripcion":"ESPONDILOSIS DORSAL EN MÚLTIPLES NIVELES CON RADICULOPATÍA"
  },
  {
    "codigo":102553006,
    "descripcion":"OSIFICACIÓN AUMENTADA"
  },
  {
    "codigo":233625007,
    "descripcion":"NEUMONITIS INTERSTICIAL DE CÉLULAS GIGANTES"
  },
  {
    "codigo":247816002,
    "descripcion":"TEMOR AL COLAPSO"
  },
  {
    "codigo":264558008,
    "descripcion":"HEMATOMA PÉLVICO"
  },
  {
    "codigo":66115002,
    "descripcion":"INESTABILIDAD MOLECULAR"
  },
  {
    "codigo":262723005,
    "descripcion":"SECCIÓN DE LA RAÍZ DE NERVIO ESPINAL"
  },
  {
    "codigo":719640000,
    "descripcion":"CONJUNTIVA PÁLIDA"
  },
  {
    "codigo":129816001,
    "descripcion":"ALTERACIÓN EN LAS ACTIVIDADES INSTRUMENTALES COTIDIANAS"
  },
  {
    "codigo":424728002,
    "descripcion":"ASA VASCULAR PREPAPILAR"
  },
  {
    "codigo":293656001,
    "descripcion":"ALERGIA A LANSOPRAZOL"
  },
  {
    "codigo":721475008,
    "descripcion":"SÍNDROME DEL CORDÓN POSTERIOR DE MÉDULA ESPINAL AL NIVEL DEL SÉPTIMO SEGMENTO DORSAL"
  },
  {
    "codigo":95213001,
    "descripcion":"GLAUCOMA PRIMARIO POR MECANISMOS COMBINADOS"
  },
  {
    "codigo":228120009,
    "descripcion":"NOTIFICACIÓN DE TESTIMONIO RECIBIDA"
  },
  {
    "codigo":422893006,
    "descripcion":"CARCINOMA IN SITU DE CONDUCTO DE GLÁNDULA LAGRIMAL"
  },
  {
    "codigo":160749008,
    "descripcion":"INCAPAZ DE CUIDAR A PROGENITOR ENFERMO"
  },
  {
    "codigo":289986001,
    "descripcion":"UTILIZA LA BACINILLA"
  },
  {
    "codigo":224450002,
    "descripcion":"SOLICITA ABANDONAR EL TRABAJO"
  },
  {
    "codigo":93378004,
    "descripcion":"DESALINEACIÓN CONGÉNITA DE COSTILLA"
  },
  {
    "codigo":124311001,
    "descripcion":"DEFICIENCIA DE RIBULOCINASA"
  },
  {
    "codigo":189847002,
    "descripcion":"TERATOMA MALIGNO"
  },
  {
    "codigo":1269356000,
    "descripcion":"CRISIS EPILÉPTICA CON AUTOMATISMOS Y CONCIENCIA PRESERVADA DE INICIO FOCAL"
  },
  {
    "codigo":253548003,
    "descripcion":"OBSTRUCCIÓN INDETERMINADA DEL TRACTO DE SALIDA VENTRICULAR"
  },
  {
    "codigo":286316004,
    "descripcion":"DIFICULTAD PARA UTILIZAR COMBINACIONES DE VOCALES Y CONSONANTES"
  },
  {
    "codigo":56940005,
    "descripcion":"ERITEMA PALMAR"
  },
  {
    "codigo":384620009,
    "descripcion":"MARGEN CIRCUNFERENCIAL DE RESECCIÓN QUIRÚRGICA AFECTADO POR NEOPLASIA MALIGNA (TUMOR PRESENTE A 0-1 MM DEL DEL MARGEN DE RESECCIÓN CIRCUNFERENCIAL)"
  },
  {
    "codigo":186177005,
    "descripcion":"TUBERCULOSIS DE PULMÓN CON CAVITACIÓN"
  },
  {
    "codigo":448321007,
    "descripcion":"OBSTRUCCIÓN COMPLETA DE CONDUCTO CARDÍACO"
  },
  {
    "codigo":315414000,
    "descripcion":"NACIDO EN DINAMARCA"
  },
  {
    "codigo":249878001,
    "descripcion":"FASCICULACIÓN DE LA LENGUA"
  },
  {
    "codigo":568141000005106,
    "descripcion":"EMBARAZO POSTERIOR A CONIZACIÓN CERVICAL"
  },
  {
    "codigo":20502007,
    "descripcion":"DOLOR EN ESCROTO"
  },
  {
    "codigo":282646008,
    "descripcion":"CAPAZ DE HACER EL PUENTE"
  },
  {
    "codigo":1296619006,
    "descripcion":"HIPERTENSIÓN OCULAR DE OJO IZQUIERDO DEBIDA A PROCEDIMIENTO QUIRÚRGICO OFTALMOLÓGICO"
  },
  {
    "codigo":248043008,
    "descripcion":"CONDUCTA DESOBEDIENTE"
  },
  {
    "codigo":704960000,
    "descripcion":"CUMPLE CON EL RÉGIMEN DE CONTROL DE INFECCIONES"
  },
  {
    "codigo":55281000175107,
    "descripcion":"EN LIBERTAD CONDICIONAL"
  },
  {
    "codigo":29681000175108,
    "descripcion":"ÚLCERA POR PRESIÓN EN CADERA, ESTADIO II"
  },
  {
    "codigo":278976004,
    "descripcion":"BULLA DE PULMÓN"
  },
  {
    "codigo":82368005,
    "descripcion":"ÍLEO TRANSITORIO DEL RECIÉN NACIDO"
  },
  {
    "codigo":1260181000,
    "descripcion":"TUMOR METANÉFRICO BENIGNO"
  },
  {
    "codigo":735893001,
    "descripcion":"ESGUINCE DE LIGAMENTO DE ARTICULACIÓN METATARSOFALÁNGICA DE SEGUNDO A QUINTO DEDOS DE PIE"
  },
  {
    "codigo":410048008,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE LA ARTICULACIÓN GLENOHUMERAL, POSTERIOR"
  },
  {
    "codigo":80533002,
    "descripcion":"ÚTERO BICORNE SELLADO"
  },
  {
    "codigo":14997005,
    "descripcion":"LACERACIÓN DE PIEL DE PÁRPADO Y REGIÓN PERIOCULAR"
  },
  {
    "codigo":211605006,
    "descripcion":"LESIÓN TRAUMÁTICA CERRADA POR APLASTAMIENTO, TOBILLO"
  },
  {
    "codigo":373610002,
    "descripcion":"PÓLIPO DE LA NASOFARINGE"
  },
  {
    "codigo":209770003,
    "descripcion":"RUPTURA DE TENDÓN DE DEDO DE LA MANO"
  },
  {
    "codigo":111466004,
    "descripcion":"ATELECTASIA PARCIAL PERINATAL"
  },
  {
    "codigo":275306006,
    "descripcion":"DATOS PUERPERALES"
  },
  {
    "codigo":45930006,
    "descripcion":"OSTEÍTIS DE TOBILLO Y\/O PIE"
  },
  {
    "codigo":308074007,
    "descripcion":"SENSACIÓN DE PINCHAZO EN EL PIE DERECHO ANORMAL"
  },
  {
    "codigo":207935001,
    "descripcion":"FRACTURA EXPUESTA DE VÉRTEBRA CERVICAL, TRICOLUMNAR"
  },
  {
    "codigo":76863003,
    "descripcion":"FRECUENCIA CARDÍACA NORMAL"
  },
  {
    "codigo":109631003,
    "descripcion":"ABSCESO PERICORONAL"
  },
  {
    "codigo":271636001,
    "descripcion":"PULSO REGULAR"
  },
  {
    "codigo":15704401000119106,
    "descripcion":"ATROFIA DE MÚSCULO QUE ACTÚA SOBRE ARTICULACIONES DE AMBOS TOBILLOS"
  },
  {
    "codigo":402708008,
    "descripcion":"TRASTORNO ULCEROSO NO INFECCIOSO DE GENITALES FEMENINOS"
  },
  {
    "codigo":40425004,
    "descripcion":"SÍNDROME POSCONMOCIONAL"
  },
  {
    "codigo":1187305006,
    "descripcion":"HEMANGIOMA CONGÉNITO DE INVOLUCIÓN PARCIAL"
  },
  {
    "codigo":5822000,
    "descripcion":"ATETOSIS CON PARAPLEJÍA ESPÁSTICA"
  },
  {
    "codigo":300734005,
    "descripcion":"UTILIZA EL TELÉFONO"
  },
  {
    "codigo":71358006,
    "descripcion":"DEDO DE LA MANO AUSENTE"
  },
  {
    "codigo":202430007,
    "descripcion":"TUMOR TENOSINOVIAL DE CÉLULAS GIGANTES DIFUSO DE TOBILLO Y PIE"
  },
  {
    "codigo":169662008,
    "descripcion":"ECOGRAFÍA PRENATAL PENDIENTE"
  },
  {
    "codigo":366270008,
    "descripcion":"FUNCIÓN URETRAL - HALLAZGO"
  },
  {
    "codigo":36755004,
    "descripcion":"TALIPES CAVUS"
  },
  {
    "codigo":724883005,
    "descripcion":"DISTENSIÓN DE MÚSCULO A LA ALTURA DEL TÓRAX"
  },
  {
    "codigo":298899006,
    "descripcion":"AMPLITUD DE EXTENSIÓN PASIVA DE CODO DISMINUIDA"
  },
  {
    "codigo":200595007,
    "descripcion":"ÁNTRAX DE LA PIERNA"
  },
  {
    "codigo":167827008,
    "descripcion":"ASPECTO DEL VÓMITO: NORMAL"
  },
  {
    "codigo":31021000087105,
    "descripcion":"MICROBIOTA NORMAL DEL APARATO GENITOURINARIO"
  },
  {
    "codigo":3987009,
    "descripcion":"AUSENCIA CONGÉNITA DE LA TRÁQUEA"
  },
  {
    "codigo":38701000087107,
    "descripcion":"NEFROSTOMÍA PRESENTE"
  },
  {
    "codigo":41261000087107,
    "descripcion":"HEMATOMA DE GLÚTEO DERECHO"
  },
  {
    "codigo":165992005,
    "descripcion":"INMUNOELECTROFORESIS FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":46381000087101,
    "descripcion":"LUXACIÓN DE ARTICULACIÓN GLENOHUMERAL DERECHA"
  },
  {
    "codigo":788584007,
    "descripcion":"SÍNDROME DE BLEFAROFIMOSIS, DISCAPACIDAD INTELECTUAL"
  },
  {
    "codigo":231528008,
    "descripcion":"TRASTORNO ANSIOSO DE LA PERSONALIDAD"
  },
  {
    "codigo":332421000119101,
    "descripcion":"VASCULITIS RETINIANA DE OJO DERECHO"
  },
  {
    "codigo":317006,
    "descripcion":"HIPOGLUCEMIA REACTIVA"
  },
  {
    "codigo":229693007,
    "descripcion":"MOVIMIENTO COREIFORME ORAL"
  },
  {
    "codigo":426301008,
    "descripcion":"DISFUNCIÓN DEL MÚSCULO OBLICUO SUPERIOR"
  },
  {
    "codigo":262461007,
    "descripcion":"INFECCIÓN CAUSADA POR BARTONELLA BACILLIFORMIS"
  },
  {
    "codigo":424466003,
    "descripcion":"PROVISIÓN DE AGUA INSUFICIENTE"
  },
  {
    "codigo":1145362007,
    "descripcion":"LESIÓN HIPERAUTOFLUORESCENTE DE MÁCULA LÚTEA"
  },
  {
    "codigo":94951000,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE MÚSCULO DEL TRONCO"
  },
  {
    "codigo":719378009,
    "descripcion":"SÍNDROME DE MICROCEFALIA CON BRAQUIDACTILIA Y CIFOESCOLIOSIS"
  },
  {
    "codigo":160487001,
    "descripcion":"GRUPO SOCIAL DESCONOCIDO"
  },
  {
    "codigo":293394009,
    "descripcion":"REACCIÓN ADVERSA AL ÁCIDO FOLÍNICO"
  },
  {
    "codigo":193255007,
    "descripcion":"MIOPATÍA PROXIMAL"
  },
  {
    "codigo":291559007,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR CEFADROXILO"
  },
  {
    "codigo":29415009,
    "descripcion":"INTOXICACIÓN POR LASIOSPERMUM BIPINNATUM"
  },
  {
    "codigo":1141692002,
    "descripcion":"DEMUESTRA CONOCIMIENTO SOBRE ALIMENTACIÓN DEL LACTANTE"
  },
  {
    "codigo":60348003,
    "descripcion":"DESPLAZAMIENTO DE DISPOSITIVO CARDÍACO"
  },
  {
    "codigo":93116004,
    "descripcion":"FALTA DE OSIFICACIÓN DEL RADIO"
  },
  {
    "codigo":1010620002,
    "descripcion":"INFECCIÓN PULMONAR POR MYCOBACTERIUM MALMOENSE"
  },
  {
    "codigo":224188006,
    "descripcion":"INGRESO ESTABLE"
  },
  {
    "codigo":10627871000119100,
    "descripcion":"ÁNTRAX DE MUSLO IZQUIERDO"
  },
  {
    "codigo":289724008,
    "descripcion":"CONTRACCIONES UTERINAS CONTINUAS"
  },
  {
    "codigo":10818181000119107,
    "descripcion":"FRACTURA EXPUESTA DE FALANGE DISTAL DE DEDO ÍNDICE IZQUIERDO"
  },
  {
    "codigo":1172625004,
    "descripcion":"SÍNDROME DE PREDISPOSICIÓN AL CÁNCER HEMATOLÓGICO ASOCIADO AL GEN DDX41"
  },
  {
    "codigo":124049007,
    "descripcion":"CEREBRÓSIDO DE ESTRUCTURA ANORMAL"
  },
  {
    "codigo":255121007,
    "descripcion":"CARCINOMATOSIS DE LA CAVIDAD PERITONEAL"
  },
  {
    "codigo":418961007,
    "descripcion":"MOSAICO ANTERIOR DE LA CÓRNEA EN PIEL DE COCODRILO"
  },
  {
    "codigo":417126002,
    "descripcion":"PUNTO MÓVIL"
  },
  {
    "codigo":449894006,
    "descripcion":"TOLERA DIETA NORMAL"
  },
  {
    "codigo":286054007,
    "descripcion":"CAPAZ DE LAVAR LA ROPA EN SECO"
  },
  {
    "codigo":251451000,
    "descripcion":"ESPIGAS POSITIVAS (INCLUIDAS 14 Y 6 POR SEGUNDO)"
  },
  {
    "codigo":253286008,
    "descripcion":"AURÍCULA IZQUIERDA COMUNICADA CON EL VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":284219006,
    "descripcion":"QUEMADURA DEL PERINEO"
  },
  {
    "codigo":448059006,
    "descripcion":"TRONCO PULMONAR AUSENTE CON ARTERIA PULMONAR IZQUIERDA AUSENTE"
  },
  {
    "codigo":22075008,
    "descripcion":"CEGUERA DE LA NIEVE"
  },
  {
    "codigo":115641000119100,
    "descripcion":"CON RIESGO AUMENTADO DE HIPERTERMIA MALIGNA"
  },
  {
    "codigo":247781006,
    "descripcion":"SENTIMIENTOS EXCESIVOS DE EFICIENCIA MENTAL"
  },
  {
    "codigo":739301006,
    "descripcion":"OSTEOPOROSIS CONCOMITANTE CON MIELOMA MÚLTIPLE Y DEBIDA A ÉL"
  },
  {
    "codigo":1360058000,
    "descripcion":"ÚLCERA CORNEAL DE AMBOS OJOS"
  },
  {
    "codigo":16909241000119102,
    "descripcion":"BLEFARITIS ULCEROSA DE PÁRPADOS SUPERIOR E INFERIOR IZQUIERDOS"
  },
  {
    "codigo":213178002,
    "descripcion":"FALLA TOTAL DE REIMPLANTE DE EXTREMIDAD"
  },
  {
    "codigo":735631003,
    "descripcion":"EYACULACIÓN PRECOZ ADQUIRIDA GENERALIZADA"
  },
  {
    "codigo":1259919004,
    "descripcion":"TRASTORNO FETAL DEBIDO A DESPROPORCIÓN FETOPELVIANA DURANTE TRABAJO DE PARTO"
  },
  {
    "codigo":14735008,
    "descripcion":"HIPEROSMOLARIDAD"
  },
  {
    "codigo":111204001,
    "descripcion":"ÚLCERA TRÓFICA CRÓNICA DE LA PIEL"
  },
  {
    "codigo":80271009,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO DE ANTEBRAZO"
  },
  {
    "codigo":78436002,
    "descripcion":"TUBERCULOSIS DE LOS GANGLIOS LINFÁTICOS INTRATORÁCICOS"
  },
  {
    "codigo":11830201000119106,
    "descripcion":"LACERACIÓN DE MÚSCULO PECTORAL IZQUIERDO"
  },
  {
    "codigo":1290852005,
    "descripcion":"FIBROSARCOMA"
  },
  {
    "codigo":209508007,
    "descripcion":"DISTENSIÓN DEL TENDÓN ROTULIANO"
  },
  {
    "codigo":406116009,
    "descripcion":"ANTICUERPO DE TREPONEMA PALLIDUM DETECTADO MEDIANTE PRUEBA DE HEMAGLUTINACIÓN"
  },
  {
    "codigo":240441001,
    "descripcion":"ACTINOMICOSIS VERTEBRAL"
  },
  {
    "codigo":109369002,
    "descripcion":"NEOPLASIA MALIGNA SUPERPUESTA DE LA LARINGE"
  },
  {
    "codigo":699193005,
    "descripcion":"DESPRENDIMIENTO DE VÍA DEL EJE DE DISPOSITIVO DE ACCESO VENOSO TOTALMENTE IMPLANTABLE"
  },
  {
    "codigo":1354553005,
    "descripcion":"EDEMA DE MÁCULA MODERADO DEBIDO A DIABETES MELLITUS"
  },
  {
    "codigo":402446002,
    "descripcion":"COMPROMISO DE MUCOSA BUCAL POR ENFERMEDAD LINEAL POR IGA"
  },
  {
    "codigo":205838004,
    "descripcion":"HEMIHIPERTROFIA CONGÉNITA"
  },
  {
    "codigo":238606007,
    "descripcion":"PUNTEADO UNGUEAL PSORIÁSICO"
  },
  {
    "codigo":7395000,
    "descripcion":"PERFORACIÓN DEL ÚTERO"
  },
  {
    "codigo":369678008,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA DE ESTÓMAGO, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":1187043002,
    "descripcion":"SÍNDROME DE REGRESIÓN PSICOMOTRIZ, APRAXIA OCULOMOTORA, TRASTORNOS DEL MOVIMIENTO Y NEFROPATÍA"
  },
  {
    "codigo":236771002,
    "descripcion":"EPIDIDIMORQUITIS POR VIRUS DE LA PAROTIDITIS URLIANA"
  },
  {
    "codigo":204003007,
    "descripcion":"ESPINA BÍFIDA CERVICAL SIN HIDROCEFALIA - ABIERTA"
  },
  {
    "codigo":105699008,
    "descripcion":"ENFERMEDAD CAUSADA POR THELAZIOIDEA"
  },
  {
    "codigo":71096001,
    "descripcion":"INVERSIÓN DE LA CONTRACCIÓN UTERINA"
  },
  {
    "codigo":38328002,
    "descripcion":"TRASTORNO DE PÁNICO CON AGORAFOBIA, EVITACIÓN AGORAFÓBICA GRAVE Y ATAQUES DE PÁNICO EN REMISIÓN TOTAL"
  },
  {
    "codigo":300472004,
    "descripcion":"HALLAZGO RELACIONADO CON EL DESEO DE ORINAR"
  },
  {
    "codigo":611461000124101,
    "descripcion":"CAPAZ DE AFRONTAR GASTO RELACIONADO A TRANSPORTE"
  },
  {
    "codigo":711301000124101,
    "descripcion":"SINOVITIS CRÓNICA DE REGIÓN DE HOMBRO DERECHO DEBIDA A HEMARTROSIS"
  },
  {
    "codigo":11803731000119106,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA PROXIMAL DE DEDO DE MANO DERECHA"
  },
  {
    "codigo":2181000124102,
    "descripcion":"PRIMER MOLAR INFERIOR IZQUIERDO TEMPORARIO SUPERNUMERARIO"
  },
  {
    "codigo":366008009,
    "descripcion":"HALLAZGO RELACIONADO CON EL ASPECTO GENERAL DEL OJO"
  },
  {
    "codigo":724621007,
    "descripcion":"PROBLEMA DE REGIÓN LUMBAR"
  },
  {
    "codigo":298637009,
    "descripcion":"AMPLITUD DE FLEXIÓN LATERAL ACTIVA HACIA LA IZQUIERDA DE LA COLUMNA VERTEBRAL LUMBAR, AUMENTADA"
  },
  {
    "codigo":395106006,
    "descripcion":"AUSENCIA DE AGITACIÓN PSICOMOTRIZ"
  },
  {
    "codigo":1279842008,
    "descripcion":"SUSCEPTIBILIDAD MENDELIANA AUTOSÓMICA RECESIVA A ENFERMEDAD MICOBACTERIANA DEBIDA A DEFICIENCIA PARCIAL DE CINASA JANUS 1"
  },
  {
    "codigo":131127007,
    "descripcion":"VITAMINA B12 POR DEBAJO DE RANGO DE REFERENCIA"
  },
  {
    "codigo":194828000,
    "descripcion":"ANGINA DE PECHO"
  },
  {
    "codigo":720951008,
    "descripcion":"ENFERMEDAD MITOCONDRIAL FATAL DEBIDA A DEFICIENCIA COMBINADA DE LA FOSFORILACIÓN OXIDATIVA 3"
  },
  {
    "codigo":294967009,
    "descripcion":"ALERGIA A CIPROFIBRATO"
  },
  {
    "codigo":1343543009,
    "descripcion":"CARCINOMA IN SITU DE PIEL DE PÁRPADO SUPERIOR"
  },
  {
    "codigo":293132004,
    "descripcion":"REACCIÓN ADVERSA A LA ANTITOXINA DIFTÉRICA"
  },
  {
    "codigo":78433671000119100,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN EN DEDO DE PIE IZQUIERDO NO ESTADIFICABLE"
  },
  {
    "codigo":1145100007,
    "descripcion":"PESTAÑAS LARGAS EN HILERA IRREGULAR"
  },
  {
    "codigo":192993002,
    "descripcion":"CONVULSIÓN EPILÉPTICA TÓNICA"
  },
  {
    "codigo":16665991000119101,
    "descripcion":"FRACTURA EXPUESTA DE ÓRBITA DERECHA"
  },
  {
    "codigo":60086000,
    "descripcion":"DEFICIENCIA DE ALDOSTERONA"
  },
  {
    "codigo":291297008,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR ANTICOLINESTERASA"
  },
  {
    "codigo":125622002,
    "descripcion":"LUXACIÓN TRAUMÁTICA DE ARTICULACIÓN DE TOBILLO"
  },
  {
    "codigo":15955181000119109,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE AMBOS TESTÍCULOS"
  },
  {
    "codigo":92854008,
    "descripcion":"FUSIÓN ANORMAL CONGÉNITA DE FÉMUR"
  },
  {
    "codigo":123787003,
    "descripcion":"TRASTORNO EN EL PROCESO DE COAGULACIÓN SANGUÍNEA CON AUMENTO DEL TIEMPO DE COAGULACIÓN"
  },
  {
    "codigo":91019004,
    "descripcion":"PARESTESIA"
  },
  {
    "codigo":416864007,
    "descripcion":"RETINOCITOMA"
  },
  {
    "codigo":449632009,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE PIERNA"
  },
  {
    "codigo":283957005,
    "descripcion":"CONTUSIÓN DE TROMPA DE FALOPIO"
  },
  {
    "codigo":773642001,
    "descripcion":"SÍNDROME DE DOLOR ORBITARIO Y NEUROFIBROMAS SISTÉMICOS, Y HÁBITO MARFANOIDE"
  },
  {
    "codigo":216586001,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR TETRACAÍNA"
  },
  {
    "codigo":16010631000119109,
    "descripcion":"OSTEONECROSIS DE HUESO METATARSIANO DE PIE IZQUIERDO"
  },
  {
    "codigo":85514005,
    "descripcion":"FLEBITIS DE VENA PORTA"
  },
  {
    "codigo":52746006,
    "descripcion":"INFECCIÓN CAUSADA POR ORIENTOBILHARZIA HARINASUTAI"
  },
  {
    "codigo":50911000,
    "descripcion":"TESTÍCULO ECTÓPICO"
  },
  {
    "codigo":247519001,
    "descripcion":"SEUDOACROPAQUIA"
  },
  {
    "codigo":442292004,
    "descripcion":"HIPERSOMNIA IDIOPÁTICA SIN PERÍODO DE SUEÑO PROLONGADO"
  },
  {
    "codigo":212916004,
    "descripcion":"HIPOTERMIA ACCIDENTAL"
  },
  {
    "codigo":737204007,
    "descripcion":"TRASTORNO DE HÍGADO DEBIDO A TRASTORNO DEL METABOLISMO MINERAL"
  },
  {
    "codigo":704436008,
    "descripcion":"INCAPAZ DE REALIZAR ACTIVIDAD DE ACICALAMIENTO PERSONAL"
  },
  {
    "codigo":147131000119101,
    "descripcion":"GLIOBLASTOMA MULTIFORME DEL SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":209246001,
    "descripcion":"FRACTURA-SUBLUXACIÓN NO EXPUESTA DE LA ARTICULACIÓN ACROMIOCLAVICULAR"
  },
  {
    "codigo":733534002,
    "descripcion":"BLOQUEO COMPLETO DE RAMA IZQUIERDA EN EL ELECTROCARDIOGRAMA"
  },
  {
    "codigo":373086002,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM TUBERCULOSIS HOMINIS"
  },
  {
    "codigo":274782002,
    "descripcion":"GAMMAGLUTAMIL TRANSFERASA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":405854004,
    "descripcion":"FENOTIPO JK(A+)"
  },
  {
    "codigo":1290590007,
    "descripcion":"RADIOGRAFÍA DE HÚMERO Y CINTURA ESCAPULAR ANORMAL"
  },
  {
    "codigo":1255987001,
    "descripcion":"TINCIÓN EXTRÍNSECA DE DIENTE VITAL"
  },
  {
    "codigo":404019003,
    "descripcion":"NEUROMA ENCAPSULADO EN EMPALIZADA"
  },
  {
    "codigo":240179004,
    "descripcion":"OSTEOCONDROPATÍA JUVENIL DE LA PELVIS"
  },
  {
    "codigo":333511000119100,
    "descripcion":"ATROFIA DE ÓRBITA DERECHA"
  },
  {
    "codigo":10627271000119101,
    "descripcion":"FORÚNCULO DE ANTEBRAZO IZQUIERDO"
  },
  {
    "codigo":10803007,
    "descripcion":"REACCIÓN DE JARISCH HERXHEIMER"
  },
  {
    "codigo":10683591000119104,
    "descripcion":"MASA SUBCUTÁNEA DE CUELLO"
  },
  {
    "codigo":123591000119103,
    "descripcion":"DEFORMIDAD DE MAMA RECONSTRUIDA"
  },
  {
    "codigo":1086151000119106,
    "descripcion":"PERFORACIÓN DE CIEGO DEBIDA A DIVERTICULITIS"
  },
  {
    "codigo":85191000119106,
    "descripcion":"INMUNIDAD CONTRA EL TÉTANOS DETERMINADA POR SEROLOGÍA"
  },
  {
    "codigo":16018631000119107,
    "descripcion":"DEDO EN GATILLO CONGÉNITO BILATERAL DE MANOS"
  },
  {
    "codigo":115911000119109,
    "descripcion":"ABSCESO DE PULGAR"
  },
  {
    "codigo":10962631000119106,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO DIGITAL DE DEDO PULGAR IZQUIERDO"
  },
  {
    "codigo":952177351000119104,
    "descripcion":"PORTADOR DE ENTEROBACTERIACEAE SENSIBLE A CARBAPENEM"
  },
  {
    "codigo":41671000119105,
    "descripcion":"HALLAZGO ANORMAL EN ESTUDIO DE FUNCIÓN AUDITIVA"
  },
  {
    "codigo":10632391000119106,
    "descripcion":"ABSCESO DE PULPEJO DE PULGAR DERECHO"
  },
  {
    "codigo":860936004,
    "descripcion":"HIPERSENSIBILIDAD NO ALÉRGICA A GADOLINIO Y\/O COMPUESTO CON GADOLINIO"
  },
  {
    "codigo":10742471000119108,
    "descripcion":"CIRUGÍA BARIÁTRICA PREVIA EN LA MADRE QUE COMPLICA EL NACIMIENTO"
  },
  {
    "codigo":762632005,
    "descripcion":"OCLUSIÓN DE ARTERIA CEREBELOSA IZQUIERDA POR ÉMBOLO"
  },
  {
    "codigo":72669000,
    "descripcion":"INTOXICACIÓN POR LATHYRUS SYLVESTRIS"
  },
  {
    "codigo":10675911000119109,
    "descripcion":"EXACERBACIÓN SEVERA AGUDA DE ASMA ALÉRGICA LEVE PERSISTENTE"
  },
  {
    "codigo":302045007,
    "descripcion":"NO SE MOVILIZA"
  },
  {
    "codigo":300210001,
    "descripcion":"SIN RESPUESTA AL SONIDO"
  },
  {
    "codigo":365746001,
    "descripcion":"NIVEL SÉRICO DE VALPROATO DE SODIO - HALLAZGO"
  },
  {
    "codigo":429447000,
    "descripcion":"TRASTORNO DE TENDÓN BICIPITAL"
  },
  {
    "codigo":200071001,
    "descripcion":"CEFALEA INDUCIDA POR ANESTESIA OBSTÉTRICA RAQUÍDEA Y EPIDURAL"
  },
  {
    "codigo":726194009,
    "descripcion":"DISTENSIÓN DE FASCIA DE MÚSCULO INTRÍNSECO DE PULGAR"
  },
  {
    "codigo":298375002,
    "descripcion":"ARTICULACIÓN TEMPOROMANDIBULAR DOLOROSA A LA PALPACIÓN"
  },
  {
    "codigo":460380002,
    "descripcion":"ARTERIA COLATERAL QUE DERIVA EL FLUJO SISTÉMICO HACIA LA CIRCULACIÓN PULMONAR DESDE ARTERIA BRAQUIOCEFÁLICA DERECHA"
  },
  {
    "codigo":198236005,
    "descripcion":"ÁNTRAX DE LABIO DE LA VULVA"
  },
  {
    "codigo":296540006,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE AMFOTERICINA B"
  },
  {
    "codigo":722524005,
    "descripcion":"CARCINOMA LOBULAR PLEOMÓRFICO INVASIVO PRIMARIO DE MAMA"
  },
  {
    "codigo":165468009,
    "descripcion":"ERITROSEDIMENTACIÓN POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":294705005,
    "descripcion":"SÍNDROME DE WEBER-COCKAYNE"
  },
  {
    "codigo":1144838004,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR WARFARINA"
  },
  {
    "codigo":129030005,
    "descripcion":"INDEPENDENCIA PARA LA PREPARACIÓN DE LAS COMIDAS"
  },
  {
    "codigo":292870008,
    "descripcion":"REACCIÓN ADVERSA AL PERMANGANATO POTÁSICO"
  },
  {
    "codigo":94427004,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE MÚSCULO DEL PERINEO"
  },
  {
    "codigo":127195006,
    "descripcion":"LINFADENOPATÍA PARAMAMARIA"
  },
  {
    "codigo":782555009,
    "descripcion":"ALERGIA A PROTEÍNA DE LA LECHE DE VACA"
  },
  {
    "codigo":291035009,
    "descripcion":"INTOXICACIÓN POR LOPRAZOLAM"
  },
  {
    "codigo":289200004,
    "descripcion":"HALLAZGO GENERAL SOBRE LENGUAJE Y COMUNICACIÓN"
  },
  {
    "codigo":420272005,
    "descripcion":"DRUSEN MACULARES BLANDOS"
  },
  {
    "codigo":254597002,
    "descripcion":"OLEOGRANULOMA DEL INTESTINO"
  },
  {
    "codigo":713349004,
    "descripcion":"ANEMIA CONCOMITANTE CON INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":285530000,
    "descripcion":"CAPAZ DE MOVER LA LÁMINA DE LA LENGUA"
  },
  {
    "codigo":1137498002,
    "descripcion":"CALCIFICACIÓN PUNTEADA DE EPÍFISIS DE FALANGE DE SEGUNDO DEDO DE PIE"
  },
  {
    "codigo":88922007,
    "descripcion":"TROMBOSIS DEL SENO BASILAR"
  },
  {
    "codigo":185391001,
    "descripcion":"FRECUENCIA DEL ENCUENTRO"
  },
  {
    "codigo":283695002,
    "descripcion":"MORDEDURA HUMANA EN EL CUELLO"
  },
  {
    "codigo":54319003,
    "descripcion":"TRASTORNO DE COMPORTAMIENTO PERTURBADOR"
  },
  {
    "codigo":414767007,
    "descripcion":"CADENAS PESADAS GAMMA MONOCLONALES DETECTADAS"
  },
  {
    "codigo":871684001,
    "descripcion":"REACCIÓN ADVERSA A HORMONA TIROIDEA"
  },
  {
    "codigo":609540003,
    "descripcion":"HIPERSENSIBILIDAD NO ALÉRGICA A ENALAPRIL"
  },
  {
    "codigo":281860005,
    "descripcion":"HEMATURIA RECURRENTE"
  },
  {
    "codigo":707844006,
    "descripcion":"INGESTA INCONSTANTE DE HIDRATOS DE CARBONO"
  },
  {
    "codigo":247257000,
    "descripcion":"FALSO FONDO DE CONDUCTO AUDITIVO EXTERNO"
  },
  {
    "codigo":11782281000119107,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXTERNA NO EXPUESTA DE ARTICULACIÓN FEMORORROTULIANA DERECHA"
  },
  {
    "codigo":771545003,
    "descripcion":"EXTREMIDAD INFERIOR DOLOROSA Y FRÍA"
  },
  {
    "codigo":50649004,
    "descripcion":"TOXICIDAD POR COMPUESTO DIPIRIDILO"
  },
  {
    "codigo":16046003,
    "descripcion":"RIGIDEZ MUSCULAR"
  },
  {
    "codigo":704174008,
    "descripcion":"SINOVITIS CRÓNICA"
  },
  {
    "codigo":702339001,
    "descripcion":"DISPLASIA ESPONDILOPERIFÉRICA"
  },
  {
    "codigo":1259395002,
    "descripcion":"CARCINOMA PRIMARIO PAPILAR Y FOLICULAR MIXTO DE TIROIDES"
  },
  {
    "codigo":866179005,
    "descripcion":"PORTADOR DE CLOSTRIDIOIDES DIFFICILE"
  },
  {
    "codigo":735107009,
    "descripcion":"ELONGACIÓN DE RAMA DERECHA DE MAXILAR INFERIOR"
  },
  {
    "codigo":46979009,
    "descripcion":"INFECCIÓN CAUSADA POR CRYPTOCOTYLE"
  },
  {
    "codigo":274520005,
    "descripcion":"RESULTADO ANORMAL DE ESTUDIO FUNCIONAL DEL SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":438360006,
    "descripcion":"ENFERMEDAD POR DEFICIENCIA HEREDITARIA DE FACTOR VIII SIN INHIBIDORES"
  },
  {
    "codigo":1290328007,
    "descripcion":"QUISTE POPLÍTEO DERECHO"
  },
  {
    "codigo":733272008,
    "descripcion":"MORDEDURA ABIERTA DE CADERA"
  },
  {
    "codigo":208984006,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN DE TOBILLO"
  },
  {
    "codigo":305453002,
    "descripcion":"BAJO ATENCIÓN DE ONCÓLOGO CLÍNICO"
  },
  {
    "codigo":1255725002,
    "descripcion":"ADENOCARCINOMA NO MICROCÍTICO DE PULMÓN"
  },
  {
    "codigo":403757004,
    "descripcion":"APLASIA CUTÁNEA EN EL SÍNDROME DE DELECIÓN DEL BRAZO CORTO DEL CROMOSOMA 4 (WOLF-HIRSCHHORN)"
  },
  {
    "codigo":698669009,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: LAOSIANO"
  },
  {
    "codigo":762370001,
    "descripcion":"PÉRDIDA DE TEJIDO DE OJO IZQUIERDO CONCOMITANTE CON LACERACIÓN"
  },
  {
    "codigo":238082007,
    "descripcion":"HIPERCOLESTEROLEMIA SECUNDARIA"
  },
  {
    "codigo":1284823000,
    "descripcion":"PH URINARIO POR DEBAJO DE RANGO DE REFERENCIA"
  },
  {
    "codigo":301783004,
    "descripcion":"HEMORRAGIA PERIMENOPÁUSICA ANORMAL"
  },
  {
    "codigo":203479005,
    "descripcion":"NECROSIS AVASCULAR DE CÓNDILO HUMERAL"
  },
  {
    "codigo":234412000,
    "descripcion":"SÍNDROME DE TRANSPORTE ANORMAL DE CATIONES"
  },
  {
    "codigo":70572005,
    "descripcion":"CANDIDIASIS DISEMINADA"
  },
  {
    "codigo":10637911000119100,
    "descripcion":"ÚLCERA CRÓNICA DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":5036006,
    "descripcion":"OBESIDAD HIPOGONADAL"
  },
  {
    "codigo":365484008,
    "descripcion":"ACTITUD - HALLAZGO"
  },
  {
    "codigo":299948008,
    "descripcion":"SENSACIÓN ASOCIADA CON UNA LESIÓN"
  },
  {
    "codigo":134273002,
    "descripcion":"LEE RUSO"
  },
  {
    "codigo":724097003,
    "descripcion":"SÍNDROME DE ANGIOPATÍA DE MOYAMOYA, BAJA ESTATURA, DISMORFISMO FACIAL E HIPOGONADISMO HIPERGONADOTRÓFICO"
  },
  {
    "codigo":96701000119107,
    "descripcion":"CARDIOPATÍA HIPERTENSIVA Y ENFERMEDAD RENAL CRÓNICA EN DIÁLISIS"
  },
  {
    "codigo":1079741000119106,
    "descripcion":"DERMATOFIBROMA DE PIEL DE OREJA IZQUIERDA"
  },
  {
    "codigo":1344854003,
    "descripcion":"BUEN ACCESO VENOSO"
  },
  {
    "codigo":34134009,
    "descripcion":"SHENJING SHUAIRUO"
  },
  {
    "codigo":425515001,
    "descripcion":"DISPUESTO A MEJORAR LA CAPACIDAD"
  },
  {
    "codigo":296278009,
    "descripcion":"SOBREDOSIS DE REMOXIPRIDA"
  },
  {
    "codigo":427350009,
    "descripcion":"CONCURRE A LA ESCUELA DE GRADUADOS"
  },
  {
    "codigo":63232000,
    "descripcion":"EXTRASÍSTOLES MULTIFOCALES"
  },
  {
    "codigo":720427009,
    "descripcion":"DISOSTOSIS ACROFACIAL TIPO KENNEDY TEEBI"
  },
  {
    "codigo":32299009,
    "descripcion":"ANOMALÍA DEL PAR DE CROMOSOMAS 2"
  },
  {
    "codigo":1144576003,
    "descripcion":"HIPOPLASIA CONGÉNITA DE MÚSCULO PECTORAL"
  },
  {
    "codigo":292608004,
    "descripcion":"REACCIÓN ADVERSA AL BROMHIDRATO DE DEXTROMETORFANO"
  },
  {
    "codigo":30464003,
    "descripcion":"METAPLASIA ESCAMOSA DE LA MUCOSA RECTAL"
  },
  {
    "codigo":294443009,
    "descripcion":"ALERGIA A DECUALINIO"
  },
  {
    "codigo":15690481000119100,
    "descripcion":"ARTRITIS INFECCIOSA DE AMBAS REGIONES DE MUÑECA"
  },
  {
    "codigo":94165002,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE CONDUCTO ANAL"
  },
  {
    "codigo":16044631000119108,
    "descripcion":"ARTRITIS IDIOPÁTICA JUVENIL DE ARTICULACIONES DE AMBAS REGIONES DE MUÑECAS"
  },
  {
    "codigo":288938004,
    "descripcion":"NO DEGLUTE"
  },
  {
    "codigo":190634004,
    "descripcion":"DEFICIENCIA DE COBALAMINA"
  },
  {
    "codigo":92330006,
    "descripcion":"NEOPLASIA BENIGNA DEL LIGAMENTO REDONDO DEL ÚTERO"
  },
  {
    "codigo":1255176005,
    "descripcion":"FRACTURA EXPUESTA DE FALANGE DISTAL DE MÚLTIPLES DEDOS DE MANO"
  },
  {
    "codigo":418175004,
    "descripcion":"DISFOTOPSIA POSITIVA"
  },
  {
    "codigo":416340002,
    "descripcion":"ESQUIZOFRENIA DE INICIO TARDÍO"
  },
  {
    "codigo":285268002,
    "descripcion":"PENSAMIENTOS DE VIOLENCIA SEXUAL"
  },
  {
    "codigo":55892009,
    "descripcion":"ERECCIÓN NOCTURNA DE PENE"
  },
  {
    "codigo":86825002,
    "descripcion":"RECHAZO ARTERIAL CRÓNICO DEL ALOINJERTO"
  },
  {
    "codigo":283433003,
    "descripcion":"CORTE EN EL MUSLO"
  },
  {
    "codigo":840489001,
    "descripcion":"OPACIDAD CONGÉNITA DE AMBAS CÓRNEAS"
  },
  {
    "codigo":281598004,
    "descripcion":"ESGUINCE DE LIGAMENTO ESPINAL"
  },
  {
    "codigo":1082251000119103,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE LÓBULO MEDIO DE PULMÓN DERECHO"
  },
  {
    "codigo":445438006,
    "descripcion":"ARTROFITO EN ARTICULACIÓN DE COLUMNA VERTEBRAL"
  },
  {
    "codigo":707582006,
    "descripcion":"CARCINOMA PRIMARIO DE CÉLULAS ESCAMOSAS FUSIFORMES DE OROFARINGE"
  },
  {
    "codigo":1197267000,
    "descripcion":"ADENOMA OXIFÍLICO DE APARATO LAGRIMAL"
  },
  {
    "codigo":248830009,
    "descripcion":"ARÉOLA - HALLAZGO"
  },
  {
    "codigo":246995007,
    "descripcion":"SEUDOHIPOPIÓN"
  },
  {
    "codigo":48552006,
    "descripcion":"HIPERTENSIÓN SECUNDARIA A NEFROPATÍA, QUE COMPLICA EL EMBARAZO Y\/O CONSTITUYE UN MOTIVO DE ATENCIÓN DURANTE ESTE PERÍODO"
  },
  {
    "codigo":308861002,
    "descripcion":"DISPLASIA DE VÍAS BILIARES"
  },
  {
    "codigo":472701005,
    "descripcion":"DOMINIO DE CORAZÓN IZQUIERDO FETAL"
  },
  {
    "codigo":210557006,
    "descripcion":"DAÑO POLIHÍSTICO GRAVE DEL ANTEBRAZO"
  },
  {
    "codigo":276093006,
    "descripcion":"LITIGACIÓN EN CURSO"
  },
  {
    "codigo":765778000,
    "descripcion":"REFLUJO VESICOURETERORRENAL DERECHO CONGÉNITO"
  },
  {
    "codigo":77650001,
    "descripcion":"INTOXICACIÓN POR FENOXIBENZAMINA"
  },
  {
    "codigo":700242002,
    "descripcion":"SÍNDROME DE FOWLER"
  },
  {
    "codigo":44882003,
    "descripcion":"BALANITIS"
  },
  {
    "codigo":1290066001,
    "descripcion":"TUMOR NEUROENDOCRINO BIEN DIFERENCIADO DE AMPOLLA DE VATER"
  },
  {
    "codigo":896850006,
    "descripcion":"FORMA ANCHA ANORMAL CONGÉNITA DE FALANGE MEDIA DE TERCER DEDO DE PIE"
  },
  {
    "codigo":237820000,
    "descripcion":"SEUDOPUBERTAD - FEMINIZACIÓN"
  },
  {
    "codigo":403495008,
    "descripcion":"LUPUS ERITEMATOSO DISCOIDE DE MUCOSA BUCAL"
  },
  {
    "codigo":1157159009,
    "descripcion":"MIOPERICITOMA"
  },
  {
    "codigo":205052001,
    "descripcion":"SUBLUXACIÓN CONGÉNITA DE LA CADERA, BILATERAL"
  },
  {
    "codigo":203217000,
    "descripcion":"INFECCIÓN DE LA COLUMNA VERTEBRAL CERVICAL"
  },
  {
    "codigo":72145003,
    "descripcion":"TOXICOSIS POR TRICOTECIUM"
  },
  {
    "codigo":235985005,
    "descripcion":"PERITONITIS FECAL"
  },
  {
    "codigo":1153489006,
    "descripcion":"CREATINQUINASA SÉRICA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":299686002,
    "descripcion":"FILTRACIÓN DE ANASTOMOSIS UROLÓGICA INJERTADA"
  },
  {
    "codigo":135846003,
    "descripcion":"CUENTA CON ASISTENTE CLAVE DE EQUIPO DE SALUD MENTAL"
  },
  {
    "codigo":234150004,
    "descripcion":"OCLUSIÓN DE FÍSTULA ARTERIOVENOSA CONGÉNITA"
  },
  {
    "codigo":365222007,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA REALIZAR ACTIVIDADES DE VESTIDO"
  },
  {
    "codigo":103078009,
    "descripcion":"INMUNODEFICIENCIA SECUNDARIA A TRAUMATISMO"
  },
  {
    "codigo":232315003,
    "descripcion":"TRAUMA COCLEAR"
  },
  {
    "codigo":363387004,
    "descripcion":"NEOPLASIA MALIGNA DE PALADAR DURO"
  },
  {
    "codigo":199547006,
    "descripcion":"TRASTORNO FETAL CAUSADO POR FÁRMACO O MEDICAMENTO"
  },
  {
    "codigo":168200001,
    "descripcion":"SALMONELLA NO CULTIVADA"
  },
  {
    "codigo":263248002,
    "descripcion":"FRACTURA DE HUESO NAVICULAR"
  },
  {
    "codigo":296016005,
    "descripcion":"SOBREDOSIS DE ZOPICLONA"
  },
  {
    "codigo":230480006,
    "descripcion":"CEFALEA CONSECUTIVA A MIELOGRAFÍA"
  },
  {
    "codigo":15666521000119100,
    "descripcion":"ESCAFOIDES ACCESORIO DEL TARSO DERECHO"
  },
  {
    "codigo":197712008,
    "descripcion":"SÍNDROME NEFRÍTICO CRÓNICO, GLOMERULONEFRITIS PROLIFERATIVA ENDOCAPILAR DIFUSA"
  },
  {
    "codigo":359717002,
    "descripcion":"ENFERMEDAD DE VON WILLEBRAND HEREDITARIA TIPO 2B"
  },
  {
    "codigo":64805008,
    "descripcion":"INTOXICACIÓN POR XANTHORRHOEA"
  },
  {
    "codigo":292346001,
    "descripcion":"REACCIÓN ADVERSA AL LOPRAZOLAM"
  },
  {
    "codigo":347481000119103,
    "descripcion":"FORMA COMBINADA DE CATARATA SENIL DE OJO DERECHO"
  },
  {
    "codigo":1144314006,
    "descripcion":"FRENTE ALTA"
  },
  {
    "codigo":95738005,
    "descripcion":"DESPRENDIMIENTO DE LA MEMBRANA DE DESCEMET"
  },
  {
    "codigo":290511000,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR ÉTER"
  },
  {
    "codigo":61135002,
    "descripcion":"PROTEINURIA RESIDUAL"
  },
  {
    "codigo":93903003,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE MÚSCULO DE LA CADERA"
  },
  {
    "codigo":126671004,
    "descripcion":"NEOPLASIA DE CARTÍLAGO DE LA NARIZ"
  },
  {
    "codigo":716495004,
    "descripcion":"NO COMPRENDE EL MATERIAL ESCRITO"
  },
  {
    "codigo":1306319003,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE TEJIDO ECTÓPICO DE MAMA"
  },
  {
    "codigo":224975007,
    "descripcion":"SIENTE DESEOS DE ESCAPAR"
  },
  {
    "codigo":190372001,
    "descripcion":"DIABETES MELLITUS TIPO 1 DE APARICIÓN EN LA MADUREZ"
  },
  {
    "codigo":92068002,
    "descripcion":"NEOPLASIA BENIGNA DE LA CONJUNTIVA"
  },
  {
    "codigo":419748005,
    "descripcion":"SUEÑO DESAGRADABLE"
  },
  {
    "codigo":714660005,
    "descripcion":"CON MAYOR RIESGO DE ALTERACIÓN DE ESTADO PSICOLÓGICO"
  },
  {
    "codigo":26532007,
    "descripcion":"DERMATITIS DE CONTACTO CAUSADA POR ESCABICIDA"
  },
  {
    "codigo":286841004,
    "descripcion":"CARÁCTER DESCUIDADO"
  },
  {
    "codigo":55630000,
    "descripcion":"RIGIDEZ EN RUEDA DENTADA"
  },
  {
    "codigo":874830001,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE ESCROTO"
  },
  {
    "codigo":285006006,
    "descripcion":"NO SE DESABROCHA LA ROPA"
  },
  {
    "codigo":86563000,
    "descripcion":"ERITEMA POLIMORFO, TIPO MIXTO DERMOEPIDÉRMICO"
  },
  {
    "codigo":135331000146104,
    "descripcion":"VÍCTIMA DE DISCRIMINACIÓN"
  },
  {
    "codigo":283171003,
    "descripcion":"CUERPO EXTRAÑO METÁLICO EN EL PERINEO"
  },
  {
    "codigo":1004067003,
    "descripcion":"CONTRACTURA EN FLEXIÓN DE DEDO GORDO DE PIE"
  },
  {
    "codigo":281336002,
    "descripcion":"NO SE SUMINISTRÓ EL NOMBRE DEL PACIENTE"
  },
  {
    "codigo":51960003,
    "descripcion":"SÍFILIS SECUNDARIA DE LA FARINGE"
  },
  {
    "codigo":838392002,
    "descripcion":"ABSCESO DE LÓBULO PARIETAL"
  },
  {
    "codigo":707320004,
    "descripcion":"PERIODONTITIS ULCEROSA NECROSANTE"
  },
  {
    "codigo":19192002,
    "descripcion":"FRAMBESIA ARTICULAR"
  },
  {
    "codigo":445176007,
    "descripcion":"DILATACIÓN CONGÉNITA DE AORTA ASCENDENTE"
  },
  {
    "codigo":1264376008,
    "descripcion":"LACERACIÓN DE TENDÓN EN REGIÓN AXILAR"
  },
  {
    "codigo":82893001,
    "descripcion":"ATROFIA ESPLÉNICA"
  },
  {
    "codigo":17357005,
    "descripcion":"SUPURACIÓN AGUDA DE SENO FRONTAL"
  },
  {
    "codigo":246733008,
    "descripcion":"ESTRABISMO VERTICAL MANIFIESTO, OJO HACIA ABAJO"
  },
  {
    "codigo":769186002,
    "descripcion":"RETINOPATÍA NO PROLIFERATIVA MODERADA DEL OJO IZQUIERDO DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":275831001,
    "descripcion":"UTILIZA MÉTODO ANTICONCEPTIVO DE BARRERA MASCULINO"
  },
  {
    "codigo":308599004,
    "descripcion":"ESTADO DE EXAMEN DE CONDUCTOR DISCAPACITADO"
  },
  {
    "codigo":699980004,
    "descripcion":"SECCIÓN EXPUESTA DE LIGAMENTO DE COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":110156006,
    "descripcion":"ABRASIÓN DE LA ENCÍA UNIDA A LA MANDÍBULA"
  },
  {
    "codigo":306764007,
    "descripcion":"DIFICULTAD PARA EMITIR COMBINACIONES DE SONIDOS SONOROS Y SORDOS"
  },
  {
    "codigo":1156897000,
    "descripcion":"INMUNE A DIFTERIA"
  },
  {
    "codigo":403233000,
    "descripcion":"FOTOSUBTIPO CUTÁNEO IVB (CASI NUNCA EXISTE QUEMADURA, LUEGO BRONCEADO MODERADO)"
  },
  {
    "codigo":10017004,
    "descripcion":"DESGASTE OCLUSAL DE LOS DIENTES"
  },
  {
    "codigo":303094000,
    "descripcion":"DEFICIENCIA DE ENZIMA PROPIONIL-COA-CARBOXILASA, GRUPO COMPLEMENTARIO PCCA"
  },
  {
    "codigo":42785009,
    "descripcion":"HIPOTIROIDISMO SECUNDARIO A CISTINOSIS"
  },
  {
    "codigo":1220598005,
    "descripcion":"LEUCOENCEFALOPATÍA CAVITADA PREDOMINANTEMENTE POSTERIOR NO PROGRESIVA CON NEUROPATÍA PERIFÉRICA"
  },
  {
    "codigo":1351670005,
    "descripcion":"AGAMMAGLOBULINEMIA AUTOSÓMICA RECESIVA DEBIDA A DEFICIENCIA DE P110 DELTA"
  },
  {
    "codigo":40950007,
    "descripcion":"ZAR"
  },
  {
    "codigo":237558008,
    "descripcion":"ATROFIA DE GLÁNDULA TIROIDES - ADQUIRIDA"
  },
  {
    "codigo":399563001,
    "descripcion":"DISPLASIA DE ANO"
  },
  {
    "codigo":204790009,
    "descripcion":"DUPLICACIÓN BILIAR Y\/O HEPÁTICA"
  },
  {
    "codigo":71883003,
    "descripcion":"INTOXICACIÓN POR TAMNOSMA TEXANA"
  },
  {
    "codigo":235723005,
    "descripcion":"MALABSORCIÓN INDUCIDA POR SUSTANCIAS QUÍMICAS"
  },
  {
    "codigo":725408001,
    "descripcion":"ATAXIA CEREBELOSA AUTOSÓMICA RECESIVA CON APRAXIA OCULOMOTRIZ TIPO 2"
  },
  {
    "codigo":364960004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA RETRAER LA LENGUA"
  },
  {
    "codigo":37280007,
    "descripcion":"REFLEJO AUSENTE"
  },
  {
    "codigo":4512007,
    "descripcion":"JUEGO SEXUAL GRUPAL"
  },
  {
    "codigo":233888009,
    "descripcion":"HEMOPERICARDIO POR TRAUMA"
  },
  {
    "codigo":363125002,
    "descripcion":"ASCITIS FETAL"
  },
  {
    "codigo":201120009,
    "descripcion":"UÑA CON FORMA DE CAÑA"
  },
  {
    "codigo":232053004,
    "descripcion":"RETINITIS PIGMENTARIA AUTOSÓMICA RECESIVA"
  },
  {
    "codigo":104231000119108,
    "descripcion":"ÚLCERA AGUDA DE PIEL"
  },
  {
    "codigo":461429009,
    "descripcion":"ENDOCARDITIS INFECCIOSA DE CONDUCTO VASCULAR CARDÍACO"
  },
  {
    "codigo":721738002,
    "descripcion":"INFECCIÓN CAUSADA POR STREPTOBACILLUS"
  },
  {
    "codigo":842009,
    "descripcion":"CONSANGUINIDAD"
  },
  {
    "codigo":228383002,
    "descripcion":"USO INAPROPIADO DE DROGAS POR VÍA RECTAL"
  },
  {
    "codigo":293919008,
    "descripcion":"ALERGIA A BUTIROFENONA"
  },
  {
    "codigo":292084004,
    "descripcion":"REACCIÓN ADVERSA AL NEFOPAM"
  },
  {
    "codigo":718068005,
    "descripcion":"LIQUEN PLANO DE ENCÍA"
  },
  {
    "codigo":290249000,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR FENBUFÉN"
  },
  {
    "codigo":716233007,
    "descripcion":"SÍNDROME DE STEINFELD"
  },
  {
    "codigo":93641007,
    "descripcion":"MELANOMA MALIGNO DE LA PIEL DE LAS EXTREMIDADES INFERIORES"
  },
  {
    "codigo":59038002,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DEL DORSO"
  },
  {
    "codigo":323521000119109,
    "descripcion":"DEFORMIDAD EN VARO ADQUIRIDA DE CODO DERECHO"
  },
  {
    "codigo":15724481000119109,
    "descripcion":"CADERA IZQUIERDA EN RESORTE"
  },
  {
    "codigo":288414006,
    "descripcion":"DESENROSCA UNA TAPA"
  },
  {
    "codigo":417651000,
    "descripcion":"DISTROFIA ENDOTELIAL CONGÉNITA HEREDITARIA"
  },
  {
    "codigo":253811003,
    "descripcion":"LOBULACIÓN HEPÁTICA ANORMAL"
  },
  {
    "codigo":57203004,
    "descripcion":"TRASTORNO DE LA PULPA DENTAL"
  },
  {
    "codigo":448584000,
    "descripcion":"HEMATOMA NEUROAXIAL"
  },
  {
    "codigo":710728001,
    "descripcion":"ELEVACIÓN DE LENGUA"
  },
  {
    "codigo":284744004,
    "descripcion":"QUEMARSE A SÍ MISMO"
  },
  {
    "codigo":250141000,
    "descripcion":"CALZADO DEMASIADO GRANDE"
  },
  {
    "codigo":282909006,
    "descripcion":"SE LEVANTA DE LA POSICIÓN EN CUCLILLAS SIN UTILIZAR LAS MANOS"
  },
  {
    "codigo":10946651000119108,
    "descripcion":"AVULSIÓN DE UNIDAD UNGUEAL DE DEDO ANULAR IZQUIERDO"
  },
  {
    "codigo":248306003,
    "descripcion":"HOYUELO DE GRASA EN LA PIEL"
  },
  {
    "codigo":1264114007,
    "descripcion":"MALFORMACIÓN ANORRECTAL CONGÉNITA NO SINDRÓMICA"
  },
  {
    "codigo":84466009,
    "descripcion":"TRASTORNO DE LA PERSONALIDAD POR DEPENDENCIA"
  },
  {
    "codigo":770759001,
    "descripcion":"ENFERMEDAD DE CHARCOT-MARIE-TOOTH INTERMEDIA TIPO F AUTOSÓMICA DOMINANTE"
  },
  {
    "codigo":836295007,
    "descripcion":"INFARTO AGUDO DE MIOCARDIO DE PARED INFEROLATERAL CON EXTENSIÓN POSTERIOR"
  },
  {
    "codigo":1293212003,
    "descripcion":"TUMOR GLÓMICO MALIGNO"
  },
  {
    "codigo":703388005,
    "descripcion":"RETRASO DEL CRECIMIENTO, AMINOACIDURIA, COLESTASIS, SOBRECARGA DE HIERRO, ACIDOSIS LÁCTICA Y MUERTE TEMPRANA"
  },
  {
    "codigo":768924008,
    "descripcion":"CISTADENOMA SEROSO DE OVARIO EN LA INFANCIA"
  },
  {
    "codigo":767089002,
    "descripcion":"EL SEGUNDO VASO CONTIENE HEBRAS O FILAMENTOS"
  },
  {
    "codigo":111729006,
    "descripcion":"TRASTORNO DEBIDO A LESIÓN TRAUMÁTICA DE NERVIO Y POSTERIOR A ELLA"
  },
  {
    "codigo":404806001,
    "descripcion":"ASMA DE LOS ARTESANOS QUESEROS"
  },
  {
    "codigo":208198004,
    "descripcion":"FRACTURA-LUXACIÓN EXPUESTA DE LA ARTICULACIÓN SACROILÍACA"
  },
  {
    "codigo":109894007,
    "descripcion":"PLACENTA RETENIDA"
  },
  {
    "codigo":699718009,
    "descripcion":"ARCADA MANDIBULAR ASIMÉTRICA"
  },
  {
    "codigo":1254939002,
    "descripcion":"PSEUDOXANTOMA ELÁSTICO CAUSADO POR PENICILAMINA"
  },
  {
    "codigo":42523002,
    "descripcion":"ENFERMEDAD POR EL VIRUS KEMEROVO"
  },
  {
    "codigo":370203002,
    "descripcion":"ASMA QUE PRODUCE SÍNTOMAS DIURNOS 1 O 2 VECES POR SEMANA"
  },
  {
    "codigo":7920008,
    "descripcion":"IMPACTACIÓN DE ALIMENTO EN LAS ENCÍAS"
  },
  {
    "codigo":237296008,
    "descripcion":"ESPECTRO DE ACRETISMO PLACENTARIO"
  },
  {
    "codigo":366533000,
    "descripcion":"AMPLITUD DE MOVIMIENTO ACTIVO DE ADUCCIÓN DE LA MUÑECA - HALLAZGO"
  },
  {
    "codigo":202693003,
    "descripcion":"ESPONDILOSIS LUMBOSACRA CON RADICULOPATÍA"
  },
  {
    "codigo":16054671000119108,
    "descripcion":"ESTRABISMO PARALÍTICO DE AMBOS OJOS"
  },
  {
    "codigo":300997008,
    "descripcion":"DISFUNCIÓN ASINTOMÁTICA DEL NÓDULO SINOAURICULAR"
  },
  {
    "codigo":102554000,
    "descripcion":"DOLOR A LA PALPACIÓN EN APÓFISIS ESPINOSA DE VÉRTEBRA CERVICAL"
  },
  {
    "codigo":169925009,
    "descripcion":"PUNTAJE DE APGAR A LOS 10 MINUTOS = 2"
  },
  {
    "codigo":725146001,
    "descripcion":"PARKINSONISMO JUVENIL ATÍPICO"
  },
  {
    "codigo":168090003,
    "descripcion":"LÍQUIDO AMNIÓTICO LÍMPIDO"
  },
  {
    "codigo":35183001,
    "descripcion":"OTITIS MEDIA AGUDA TRASUDATIVA"
  },
  {
    "codigo":2415007,
    "descripcion":"RADICULOPATÍA LUMBOSACRA"
  },
  {
    "codigo":231791008,
    "descripcion":"RUPTURA DE GLOBO OCULAR"
  },
  {
    "codigo":262724004,
    "descripcion":"SECCIÓN DE LA RAÍZ DE NERVIO CERVICAL"
  },
  {
    "codigo":33348006,
    "descripcion":"EMBARAZOS PREVIOS: 7"
  },
  {
    "codigo":721476009,
    "descripcion":"SÍNDROME DEL CORDÓN POSTERIOR DE MÉDULA ESPINAL AL NIVEL DEL OCTAVO SEGMENTO DORSAL"
  },
  {
    "codigo":195353004,
    "descripcion":"GRANULOMATOSIS CON POLIANGEÍTIS"
  },
  {
    "codigo":129817005,
    "descripcion":"HALLAZGO EN LA HIGIENE PERSONAL"
  },
  {
    "codigo":293657005,
    "descripcion":"ALERGIA A CARBENOXOLONA"
  },
  {
    "codigo":422894000,
    "descripcion":"ESTADO DE DESEMPEÑO ECOG - GRADO 2"
  },
  {
    "codigo":291822004,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR FENFORMINA"
  },
  {
    "codigo":95214007,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE HÍGADO"
  },
  {
    "codigo":160750008,
    "descripcion":"REALOJADO"
  },
  {
    "codigo":224451003,
    "descripcion":"SOLICITA LICENCIA POR MATERNIDAD"
  },
  {
    "codigo":715971003,
    "descripcion":"SÍNDROME DE INTERVALO QT PROLONGADO CAUSADO POR FÁRMACO"
  },
  {
    "codigo":289987005,
    "descripcion":"NO USA EL ORINAL"
  },
  {
    "codigo":781507007,
    "descripcion":"ENFERMEDAD CAUSADA POR FIMBRIIDAE"
  },
  {
    "codigo":93379007,
    "descripcion":"DESALINEAMIENTO CONGÉNITO DE ARCO DE VÉRTEBRA SACRA"
  },
  {
    "codigo":191683009,
    "descripcion":"ESTUPOR PSICÓGENO"
  },
  {
    "codigo":421059009,
    "descripcion":"VESÍCULAS EPITELIALES DE LA CÓRNEA"
  },
  {
    "codigo":124312008,
    "descripcion":"DEFICIENCIA DE XILULOCINASA"
  },
  {
    "codigo":417389002,
    "descripcion":"TRASTORNO DE LOS BASÓFILOS"
  },
  {
    "codigo":1092291000119107,
    "descripcion":"PERFORACIÓN TOTAL DE LA MEMBRANA TIMPÁNICA DERECHA"
  },
  {
    "codigo":253549006,
    "descripcion":"ANOMALÍA DEL TABIQUE INTERVENTRICULAR"
  },
  {
    "codigo":186178000,
    "descripcion":"TUBERCULOSIS DE BRONQUIO"
  },
  {
    "codigo":384621008,
    "descripcion":"MARGEN CIRCUNFERENCIAL DE RESECCIÓN QUIRÚRGICA NO AFECTADO POR NEOPLASIA MALIGNA"
  },
  {
    "codigo":56941009,
    "descripcion":"MIOCARDIOPATÍA RESTRICTIVA SECUNDARIA A HEMOCROMATOSIS"
  },
  {
    "codigo":282647004,
    "descripcion":"INCAPAZ DE HACER EL PUENTE"
  },
  {
    "codigo":53271004,
    "descripcion":"INTOXICACIÓN POR ÁCIDO TÁNICO"
  },
  {
    "codigo":315415004,
    "descripcion":"NACIDO EN DIJBOUTI"
  },
  {
    "codigo":1296620000,
    "descripcion":"HIPERTENSIÓN OCULAR BILATERAL DEBIDA A CIRUGÍA OFTALMOLÓGICA"
  },
  {
    "codigo":249879009,
    "descripcion":"MOVIMIENTO CONSTANTE DE LA LENGUA"
  },
  {
    "codigo":248044002,
    "descripcion":"COMPORTAMIENTO DESTRUCTIVO"
  },
  {
    "codigo":84204007,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE ESCROTO CON INFECCIÓN"
  },
  {
    "codigo":410049000,
    "descripcion":"DERMATITIS DE CONTACTO CAUSADA POR URUSHIOL DE TOXICODENDRON"
  },
  {
    "codigo":704961001,
    "descripcion":"CUMPLE CON EL REPOSO EN CAMA"
  },
  {
    "codigo":49601007,
    "descripcion":"TRASTORNO DEL APARATO CARDIOVASCULAR"
  },
  {
    "codigo":14998000,
    "descripcion":"CESE DE LA MADURACIÓN HEMATOPOYÉTICA"
  },
  {
    "codigo":211606007,
    "descripcion":"LESIÓN TRAUMÁTICA ABIERTA POR APLASTAMIENTO, PIE"
  },
  {
    "codigo":1260182007,
    "descripcion":"TUMOR FILODES DE PRÓSTATA"
  },
  {
    "codigo":275307002,
    "descripcion":"PUNTAJE DE APGAR NORMAL"
  },
  {
    "codigo":373611003,
    "descripcion":"PIOCISTITIS"
  },
  {
    "codigo":209771004,
    "descripcion":"RUPTURA DE TENDÓN FLEXOR SUPERFICIAL DE DEDO DE LA MANO"
  },
  {
    "codigo":308075008,
    "descripcion":"SENSACIÓN DE PINCHAZO EN EL PIE IZQUIERDO ANORMAL"
  },
  {
    "codigo":207936000,
    "descripcion":"FRACTURAS MÚLTIPLES EXPUESTAS DE VÉRTEBRAS CERVICALES"
  },
  {
    "codigo":240704003,
    "descripcion":"CANDIDIASIS FARÍNGEA"
  },
  {
    "codigo":109632005,
    "descripcion":"MALA OCLUSIÓN DEBIDA A HÁBITOS DE SUCCIÓN"
  },
  {
    "codigo":764992006,
    "descripcion":"FILAMINOPATÍA MUSCULAR"
  },
  {
    "codigo":12431000132102,
    "descripcion":"ÚLCERA DE PIEL CAUSADA POR HIDROCARBUROS AROMÁTICOS POLICÍCLICOS"
  },
  {
    "codigo":402709000,
    "descripcion":"DERMATOSIS INFECCIOSA DE LA PIEL PERIANAL"
  },
  {
    "codigo":12960001000004104,
    "descripcion":"FRACTURA DE RADIO IZQUIERDO"
  },
  {
    "codigo":42261000,
    "descripcion":"FRACTURA DE FOSA MEDIA"
  },
  {
    "codigo":699456009,
    "descripcion":"EXTRUSIÓN DE DISCO MIGRADO"
  },
  {
    "codigo":271637005,
    "descripcion":"PULSO IRREGULAR INTERMITENTE"
  },
  {
    "codigo":15676561000119102,
    "descripcion":"TENDINITIS BILATERAL DE TENDÓN EXTENSOR DE LA MANO"
  },
  {
    "codigo":204266007,
    "descripcion":"SENO EXTERNO DE LA HENDIDURA BRANQUIAL"
  },
  {
    "codigo":169663003,
    "descripcion":"ECOGRAFÍA PRENATAL NORMAL Y APROPIADA PARA LA EDAD GESTACIONAL"
  },
  {
    "codigo":300735006,
    "descripcion":"NO USA EL TELÉFONO"
  },
  {
    "codigo":366271007,
    "descripcion":"FUNCIÓN DEL ESFÍNTER URETRAL - HALLAZGO"
  },
  {
    "codigo":298900001,
    "descripcion":"SIN AMPLITUD PASIVA DE EXTENSIÓN DE CODO"
  },
  {
    "codigo":167828003,
    "descripcion":"ASPECTO DEL VÓMITO: ANORMAL"
  },
  {
    "codigo":724884004,
    "descripcion":"DISTENSIÓN DE FASCIA A LA ALTURA DEL TÓRAX"
  },
  {
    "codigo":428137000,
    "descripcion":"VIDRIO EN LA FARINGE"
  },
  {
    "codigo":297065005,
    "descripcion":"SOBREDOSIS DE INHIBIDOR DE LA FOSFODIESTERASA"
  },
  {
    "codigo":229694001,
    "descripcion":"DISCINESIA ORAL"
  },
  {
    "codigo":34921009,
    "descripcion":"ÚLCERA PÉPTICA AGUDA CON PERFORACIÓN PERO SIN OBSTRUCCIÓN"
  },
  {
    "codigo":295230002,
    "descripcion":"SOBREDOSIS DE ETODOLACO"
  },
  {
    "codigo":719379001,
    "descripcion":"SÍNDROME DE MICROCEFALIA CON DEFECTO CARDÍACO Y SEGMENTACIÓN PULMONAR ANORMAL"
  },
  {
    "codigo":1145363002,
    "descripcion":"LESIÓN HIPERAUTOFLUORESCENTE DE RETINA"
  },
  {
    "codigo":39431000087101,
    "descripcion":"CEFALEA CRÓNICA DEBIDA A TRASTORNO INTRACRANEAL NO VASCULAR"
  },
  {
    "codigo":293395005,
    "descripcion":"REACCIÓN ADVERSA A PREPARADO CON VITAMINA B12"
  },
  {
    "codigo":305544007,
    "descripcion":"BAJO ATENCIÓN DE OFTALMÓLOGO"
  },
  {
    "codigo":291560002,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR CEFADROXILO"
  },
  {
    "codigo":47111000087106,
    "descripcion":"FRACTURA TRIMALEOLAR DE TOBILLO DERECHO"
  },
  {
    "codigo":41991000087108,
    "descripcion":"ABRASIÓN DE CONJUNTIVA DERECHA"
  },
  {
    "codigo":160488006,
    "descripcion":"GRUPO SOCIAL 3 - MANUAL"
  },
  {
    "codigo":94952007,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE MÚSCULO DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":1141693007,
    "descripcion":"DEMUESTRA CONOCIMIENTO SOBRE HIGIENE ORAL"
  },
  {
    "codigo":93117008,
    "descripcion":"FALTA DE OSIFICACIÓN DE COSTILLA"
  },
  {
    "codigo":289725009,
    "descripcion":"CONTRACCIONES HIPERTÓNICAS"
  },
  {
    "codigo":1172626003,
    "descripcion":"TRASTORNO DE DISCAPACIDAD INTELECTUAL Y DEL NEURODESARROLLO ASOCIADO AL GEN TELO2"
  },
  {
    "codigo":124050007,
    "descripcion":"CEREBRÓSIDO POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":253287004,
    "descripcion":"AURÍCULA IZQUIERDA COMUNICADA CON EL VENTRÍCULO DERECHO"
  },
  {
    "codigo":449895007,
    "descripcion":"TUBO DE DRENAJE FUNCIONAL"
  },
  {
    "codigo":284220000,
    "descripcion":"QUEMADURA DE GENITALES"
  },
  {
    "codigo":448060001,
    "descripcion":"TRONCO PULMONAR AUSENTE CON ARTERIA PULMONAR DERECHA AUSENTE"
  },
  {
    "codigo":54844002,
    "descripcion":"PROLAPSO DE ÚTERO GRÁVIDO"
  },
  {
    "codigo":185916001,
    "descripcion":"CONTROL DE TRATAMIENTO DE SUSTITUCIÓN HORMONAL ANULADO"
  },
  {
    "codigo":286055008,
    "descripcion":"INCAPAZ DE LAVAR LA ROPA EN SECO"
  },
  {
    "codigo":1110121000000102,
    "descripcion":"HIPERTENSIÓN OCULAR DEBIDA A AFAQUIA"
  },
  {
    "codigo":251452007,
    "descripcion":"ONDA EN ESPIGA DE BAJA AMPLITUD - 6 POR SEGUNDO"
  },
  {
    "codigo":1366121000000108,
    "descripcion":"MACULOPATÍA EN CÚPULA"
  },
  {
    "codigo":85777005,
    "descripcion":"DACRIOCISTITIS"
  },
  {
    "codigo":184081006,
    "descripcion":"EL PACIENTE SE HA MUDADO"
  },
  {
    "codigo":83942000,
    "descripcion":"ENCEFALOMIELITIS DISEMINADA AGUDA"
  },
  {
    "codigo":446225009,
    "descripcion":"INTOXICACIÓN CAUSADA POR BERILIO"
  },
  {
    "codigo":247782004,
    "descripcion":"AUTOESTIMA EXCESIVA"
  },
  {
    "codigo":51174006,
    "descripcion":"MELANOSIS CONGÉNITA DE LA ESCLERÓTICA"
  },
  {
    "codigo":278715001,
    "descripcion":"GRUPO DE LA CONDRODISPLASIA PUNCTATA"
  },
  {
    "codigo":213179005,
    "descripcion":"FALLA TOTAL DE REIMPLANTE DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":735632005,
    "descripcion":"EYACULACIÓN PRECOZ SITUACIONAL ADQUIRIDA"
  },
  {
    "codigo":10737401000119100,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE TROMPA DE FALOPIO IZQUIERDA"
  },
  {
    "codigo":406117000,
    "descripcion":"ANTÍGENO DE SUPERFICIE DE HEPATITIS B DETECTADO POR ENSAYO INMUNOABSORBENTE LIGADO A ENZIMAS"
  },
  {
    "codigo":11310841000119101,
    "descripcion":"FRACTURA NO EXPUESTA DE PRIMERA VÉRTEBRA LUMBAR"
  },
  {
    "codigo":12901004,
    "descripcion":"ALTERACIÓN ELECTROLÍTICA NEONATAL TRANSITORIA"
  },
  {
    "codigo":209509004,
    "descripcion":"DISTENSIÓN DE TENDÓN FEMORAL DE LA CORVA"
  },
  {
    "codigo":109370001,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE CARTÍLAGO LARÍNGEO"
  },
  {
    "codigo":1354554004,
    "descripcion":"EDEMA DE MÁCULA SEVERO DEBIDO A DIABETES MELLITUS"
  },
  {
    "codigo":699194004,
    "descripcion":"MORDIDA CRUZADA MAXILAR POSTERIOR BUCAL"
  },
  {
    "codigo":764730007,
    "descripcion":"ENFERMEDAD DE CHARCOT-MARIE-TOOTH AUTOSÓMICA DOMINANTE TIPO 2 DEBIDA A MUTACIÓN DEL MIEMBRO 5A DE LA FAMILIA DE LAS QUINESINAS"
  },
  {
    "codigo":240442008,
    "descripcion":"INFLAMACIÓN DE CONDUCTO LAGRIMAL CAUSADA POR PSEUDOPROPIONIBACTERIUM PROPIONICUM"
  },
  {
    "codigo":76602008,
    "descripcion":"SUPERHELICIDAD"
  },
  {
    "codigo":369679000,
    "descripcion":"MARGEN PROXIMAL DE RESECCIÓN QUIRÚRGICA DE ESTÓMAGO, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":271375003,
    "descripcion":"RESUELLO NEONATAL"
  },
  {
    "codigo":238607003,
    "descripcion":"ONICÓLISIS PSORIÁSICA"
  },
  {
    "codigo":402447006,
    "descripcion":"EPIDERMÓLISIS BULLOSA ADQUIRIDA, TIPO ACRAL CLÁSICA"
  },
  {
    "codigo":204004001,
    "descripcion":"ESPINA BÍFIDA DORSAL SIN HIDROCEFALIA - ABIERTA"
  },
  {
    "codigo":366009001,
    "descripcion":"HALLAZGO RELACIONADO CON LA POSICIÓN DEL PÁRPADO"
  },
  {
    "codigo":236772009,
    "descripcion":"EPIDÍDIMO-ORQUITIS GONOCÓCICA"
  },
  {
    "codigo":105700009,
    "descripcion":"ENFERMEDAD CAUSADA POR TRICHINELLOIDEA"
  },
  {
    "codigo":724622000,
    "descripcion":"PROBLEMA DE TÓRAX"
  },
  {
    "codigo":300473009,
    "descripcion":"HALLAZGO RELACIONADO CON MEDICIONES DE LA MICCIÓN"
  },
  {
    "codigo":429710001,
    "descripcion":"DILATACIÓN ISQUÉMICA TRANSITORIA DE LA CAVIDAD DEL VENTRÍCULO IZQUIERDO DEL CORAZÓN"
  },
  {
    "codigo":298638004,
    "descripcion":"AMPLITUD DE FLEXIÓN LATERAL ACTIVA HACIA LA IZQUIERDA DE LA COLUMNA VERTEBRAL LUMBAR, DISMINUIDA"
  },
  {
    "codigo":1279843003,
    "descripcion":"SÍNDROME DE POLIDACTILIA Y COSTILLAS CORTAS TIPO 5"
  },
  {
    "codigo":720952001,
    "descripcion":"SÍNDROME DE APLASIA DE PERONÉ Y ECTRODACTILIA"
  },
  {
    "codigo":131128002,
    "descripcion":"ÁCIDO ASCÓRBICO POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":296803009,
    "descripcion":"SOBREDOSIS DE FÁRMACO ANTILEPROSO"
  },
  {
    "codigo":294968004,
    "descripcion":"ALERGIA A ACEITE DE PESCADO"
  },
  {
    "codigo":12103571000119106,
    "descripcion":"QUEMADURA DE MUSLO DERECHO"
  },
  {
    "codigo":11775891000119107,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE LA REGIÓN DE CODO IZQUIERDO"
  },
  {
    "codigo":63757006,
    "descripcion":"NÓDULO DE OSLER"
  },
  {
    "codigo":1145101006,
    "descripcion":"PESTAÑAS LARGAS DE PÁRPADO INFERIOR"
  },
  {
    "codigo":94690004,
    "descripcion":"LINFOSARCOMA DE CÉLULAS MIXTAS DE LOS GANGLIOS LINFÁTICOS DE CABEZA, CARA Y CUELLO"
  },
  {
    "codigo":61922005,
    "descripcion":"RETINITIS DISEMINADA"
  },
  {
    "codigo":289463002,
    "descripcion":"PELVIS INADECUADA PARA EL PARTO"
  },
  {
    "codigo":420535003,
    "descripcion":"ATROFIA PERIPAPILAR"
  },
  {
    "codigo":125623007,
    "descripcion":"LUXACIÓN TRAUMÁTICA DE ARTICULACIÓN DE PIE"
  },
  {
    "codigo":772232001,
    "descripcion":"CAPAZ DE MANTENER EL EQUILIBRIO AL PARARSE CON UN PIE DELANTE DE OTRO"
  },
  {
    "codigo":92855009,
    "descripcion":"FUSIÓN ANORMAL CONGÉNITA DEL PERONÉ"
  },
  {
    "codigo":254860001,
    "descripcion":"TUMOR MALIGNO DEL CORDÓN SEXUAL DEL OVARIO"
  },
  {
    "codigo":1303436003,
    "descripcion":"VISTE SÓLO PAÑAL"
  },
  {
    "codigo":189324006,
    "descripcion":"MELANOMA DE CUELLO Y\/O CUERO CABELLUDO"
  },
  {
    "codigo":156556008,
    "descripcion":"CONTRACTURA ARTICULAR DE TOBILLO Y PIE"
  },
  {
    "codigo":123788008,
    "descripcion":"TRASTORNO EN EL PROCESO DE COAGULACIÓN SANGUÍNEA CON DISMINUCIÓN DEL TIEMPO DE SANGRÍA"
  },
  {
    "codigo":23649000,
    "descripcion":"ÚLCERA DE CUSHING"
  },
  {
    "codigo":449633004,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE BRAZO"
  },
  {
    "codigo":283958000,
    "descripcion":"HEMATOMA DE TROMPA DE FALOPIO"
  },
  {
    "codigo":445963000,
    "descripcion":"EFECTO DE AGENTE ANTIESTROGÉNICO"
  },
  {
    "codigo":447798009,
    "descripcion":"NEOPLASIA BENIGNA DE TEJIDO CONJUNTIVO DE CABEZA Y\/O CUELLO"
  },
  {
    "codigo":249355003,
    "descripcion":"CORNETE NASAL - HALLAZGO"
  },
  {
    "codigo":773643006,
    "descripcion":"SÍNDROME DE ANOMALÍAS CONGÉNITAS MÚLTIPLES, HIPOTONÍA, CONVULSIONES TIPO 2"
  },
  {
    "codigo":1073351000119105,
    "descripcion":"ARTRITIS DEL PIE DERECHO CAUSADA POR BACTERIAS"
  },
  {
    "codigo":18144007,
    "descripcion":"BIORRITMO INFRADIANO NORMAL"
  },
  {
    "codigo":704437004,
    "descripcion":"INDEPENDIENTE PARA EL ACICALAMIENTO PERSONAL"
  },
  {
    "codigo":336071000119108,
    "descripcion":"DESPRENDIMIENTO DE COROIDES DE OJO DERECHO"
  },
  {
    "codigo":276618000,
    "descripcion":"PÓLIPO UMBILICAL DEL RECIÉN NACIDO"
  },
  {
    "codigo":212917008,
    "descripcion":"CONGELAMIENTO SUPERFICIAL DEL CUELLO"
  },
  {
    "codigo":10959201000119102,
    "descripcion":"HERIDA ABIERTA DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":737205008,
    "descripcion":"TRANSFORMACIÓN NODULAR PARCIAL DEL HÍGADO"
  },
  {
    "codigo":278453007,
    "descripcion":"LEUCEMIA BIFENOTÍPICA AGUDA"
  },
  {
    "codigo":243850005,
    "descripcion":"ESTADO DE COMPROMISO DE LA AGENCIA INFANTIL"
  },
  {
    "codigo":1259658007,
    "descripcion":"COREA DEBIDA A DERIVACIÓN VENTRICULOPERITONEAL Y POSTERIOR A ELLA"
  },
  {
    "codigo":80010008,
    "descripcion":"TUBERCULOSIS BRONQUIAL AISLADA"
  },
  {
    "codigo":766303001,
    "descripcion":"TALIPES TRANSVERSOPLANO"
  },
  {
    "codigo":405855003,
    "descripcion":"FENOTIPO JK(A+B+)"
  },
  {
    "codigo":1290591006,
    "descripcion":"RADIOGRAFÍA RADIOCUBITAL ANORMAL"
  },
  {
    "codigo":242015007,
    "descripcion":"AGOTAMIENTO - FISIOLÓGICO"
  },
  {
    "codigo":274783007,
    "descripcion":"CETONURIA"
  },
  {
    "codigo":240180001,
    "descripcion":"OSTEOCONDROPATÍA JUVENIL DE LA CADERA"
  },
  {
    "codigo":830004004,
    "descripcion":"SENSIBILIDAD VIBRATORIA DE PIE IZQUIERDO NORMAL"
  },
  {
    "codigo":762633000,
    "descripcion":"OCLUSIÓN DE ARTERIA CEREBELOSA DERECHA POR ÉMBOLO"
  },
  {
    "codigo":698932008,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: WÓLOF"
  },
  {
    "codigo":402185002,
    "descripcion":"DERMATITIS ATÓPICA DE LA MANO CON PATRÓN DISCOIDE"
  },
  {
    "codigo":404020009,
    "descripcion":"NEUROMA DE CORPÚSCULO DE PACINI DIGITAL"
  },
  {
    "codigo":305716009,
    "descripcion":"VISTO POR EL CIRUJANO GENERAL"
  },
  {
    "codigo":271113009,
    "descripcion":"AMPOLLA TRAUMÁTICA DEL CUELLO, INFECTADA"
  },
  {
    "codigo":72670004,
    "descripcion":"SIGNO"
  },
  {
    "codigo":12106081000119109,
    "descripcion":"QUEMADURA DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":7134007,
    "descripcion":"OSTEOGÉNESIS IMPERFECTA, PERINATAL MORTAL DOMINANTE"
  },
  {
    "codigo":302046008,
    "descripcion":"DIFICULTAD PARA MOVILIZARSE"
  },
  {
    "codigo":300211002,
    "descripcion":"RESPONDE A LOS SONIDOS DE FRECUENCIA ALTA"
  },
  {
    "codigo":295841000119100,
    "descripcion":"OSTEOMIELITIS CRÓNICA DE PIE CON TRAYECTO FISTULOSO CON DRENAJE"
  },
  {
    "codigo":11892641000119101,
    "descripcion":"SÍNDROME DE DOLOR PÉLVICO CRÓNICO EN LA MUJER"
  },
  {
    "codigo":15637921000119102,
    "descripcion":"LINFEDEMA DE MIEMBRO INFERIOR IZQUIERDO"
  },
  {
    "codigo":687521000119102,
    "descripcion":"NEVO EPIDÉRMICO PILOSO PIGMENTADO DE CARA"
  },
  {
    "codigo":1074081000119104,
    "descripcion":"CONDROCALCINOSIS DE CODO DERECHO"
  },
  {
    "codigo":341921000119102,
    "descripcion":"BLEFARITIS DE PÁRPADO DE OJO IZQUIERDO"
  },
  {
    "codigo":9121000119106,
    "descripcion":"DOLOR LUMBAR EN EL EMBARAZO"
  },
  {
    "codigo":336801000119107,
    "descripcion":"QUISTE PARASITARIO DE IRIS"
  },
  {
    "codigo":306081000119100,
    "descripcion":"TRASTORNO DE LIGAMENTO DE ARTICULACIÓN DE MANO DERECHA"
  },
  {
    "codigo":15724961000119109,
    "descripcion":"ENTESOPATÍA DE CODO DERECHO"
  },
  {
    "codigo":726195005,
    "descripcion":"DISTENSIÓN DE TENDÓN DE MÚSCULO INTRÍNSECO DE PULGAR"
  },
  {
    "codigo":15748001000119103,
    "descripcion":"MASA DE ARTICULACIÓN DE PIE DERECHO"
  },
  {
    "codigo":298376001,
    "descripcion":"ARTICULACIÓN TEMPOROMANDIBULAR DOLOROSA AL MOVIMIENTO"
  },
  {
    "codigo":101281000119107,
    "descripcion":"INSUFICIENCIA CARDÍACA CONGESTIVA DEBIDA A MIOCARDIOPATÍA"
  },
  {
    "codigo":15740321000119108,
    "descripcion":"DEFORMIDAD DE AMBAS ÓRBITAS PROPIAMENTE DICHAS"
  },
  {
    "codigo":15712161000119106,
    "descripcion":"TROMBOSIS AGUDA DE VENA CAVA INFERIOR"
  },
  {
    "codigo":10878881000119108,
    "descripcion":"HIPEMA TRAUMÁTICO DE OJO DERECHO"
  },
  {
    "codigo":200072008,
    "descripcion":"CEFALEA INDUCIDA POR ANESTESIA RAQUÍDEA Y EPIDURAL DURANTE EL EMBARAZO"
  },
  {
    "codigo":134561000119109,
    "descripcion":"RUPTURA FAMILIAR DEBIDA A MUERTE DE MIEMBRO DE LA FAMILIA"
  },
  {
    "codigo":338581000119101,
    "descripcion":"SINEQUIAS POSTERIORES DEL IRIS DEL OJO IZQUIERDO"
  },
  {
    "codigo":296541005,
    "descripcion":"SOBREDOSIS INTENCIONAL DE AMFOTERICINA B"
  },
  {
    "codigo":722525006,
    "descripcion":"FETO SIMÉTRICO, PEQUEÑO PARA LA EDAD GESTACIONAL"
  },
  {
    "codigo":34397005,
    "descripcion":"ERITROCITOSIS POR MIOMA UTERINO"
  },
  {
    "codigo":294706006,
    "descripcion":"ALERGIA A METILPREDNISOLONA"
  },
  {
    "codigo":784391002,
    "descripcion":"ATROFIA DE MÚSCULOS ESPINALES PROXIMALES DE COMIENZO EN LA VIDA ADULTA AUTOSÓMICA DOMINANTE"
  },
  {
    "codigo":1144839007,
    "descripcion":"INTOXICACIÓN CAUSADA POR WARFARINA"
  },
  {
    "codigo":129031009,
    "descripcion":"DEPENDENCIA PARA REALIZAR LAS TAREAS DOMÉSTICAS"
  },
  {
    "codigo":1306844002,
    "descripcion":"ALERGIA A CETUXIMAB DEBIDA A SÍNDROME DE ALFA-GALACTOSIDASA"
  },
  {
    "codigo":365619003,
    "descripcion":"HALLAZGO RELACIONADO CON LA MORFOLOGÍA DE LOS GLÓBULOS ROJOS"
  },
  {
    "codigo":225500004,
    "descripcion":"TIENDE A USAR ROPA ANTICUADA"
  },
  {
    "codigo":291036005,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR LOPRAZOLAM"
  },
  {
    "codigo":127196007,
    "descripcion":"LINFADENOPATÍA CUBITAL"
  },
  {
    "codigo":289201000,
    "descripcion":"FALTA DE DIRECCIÓN EN EL HABLA"
  },
  {
    "codigo":94428009,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE MÚSCULO DE HOMBRO"
  },
  {
    "codigo":354737001,
    "descripcion":"PROLAPSO DE PAREDES VAGINALES SIN PROLAPSO UTERINO"
  },
  {
    "codigo":123526007,
    "descripcion":"RETRASO DEL DESARROLLO SEXUAL Y\/O PUBERAL"
  },
  {
    "codigo":254598007,
    "descripcion":"GRANULOMA INTESTINAL POR BARIO"
  },
  {
    "codigo":23387001,
    "descripcion":"PERFORACIÓN DEL ESÓFAGO"
  },
  {
    "codigo":88923002,
    "descripcion":"ATROFIA MUSCULAR PROGRESIVA"
  },
  {
    "codigo":56155002,
    "descripcion":"AGENESIA CEREBRAL HEMISFÉRICA"
  },
  {
    "codigo":285531001,
    "descripcion":"INCAPAZ DE MOVER LA LÁMINA DE LA LENGUA"
  },
  {
    "codigo":1137499005,
    "descripcion":"DEBILIDAD DE MÚSCULO OCCIPITOFRONTAL"
  },
  {
    "codigo":187227006,
    "descripcion":"HIRUDINIASIS INTERNA"
  },
  {
    "codigo":414768002,
    "descripcion":"INMUNOGLOBULINA A MONOCLONAL DETECTADA"
  },
  {
    "codigo":185392008,
    "descripcion":"PACIENTE NUNCA ATENDIDO"
  },
  {
    "codigo":871685000,
    "descripcion":"REACCIÓN ADVERSA A TIERRA DE FULLER"
  },
  {
    "codigo":19717001,
    "descripcion":"VÍCTIMA DE ACCIDENTE DE NAVE ESPACIAL"
  },
  {
    "codigo":249093003,
    "descripcion":"PRESENTACIÓN DE REBORDE ORBITARIO DEL FETO"
  },
  {
    "codigo":609541004,
    "descripcion":"HIPERSENSIBILIDAD NO ALÉRGICA A FOSINOPRIL"
  },
  {
    "codigo":216325001,
    "descripcion":"HIPERBILIRRUBINEMIA ADQUIRIDA"
  },
  {
    "codigo":771546002,
    "descripcion":"EXTREMIDAD SUPERIOR DOLOROSA Y FRÍA"
  },
  {
    "codigo":738778005,
    "descripcion":"COMPLICACIÓN INTRAOPERATORIA"
  },
  {
    "codigo":247258005,
    "descripcion":"TÍMPANO - HALLAZGO"
  },
  {
    "codigo":367561000119103,
    "descripcion":"GLOMERULONEFRITIS MESANGIOCAPILAR DIFUSA HEREDITARIA"
  },
  {
    "codigo":1162927005,
    "descripcion":"INGESTA DIETARIA DE SODIO NORMAL"
  },
  {
    "codigo":704175009,
    "descripcion":"CORIOAMNIONITIS AGUDA"
  },
  {
    "codigo":1259396001,
    "descripcion":"CARCINOMA PRIMARIO DE ÓRGANO GENITOURINARIO"
  },
  {
    "codigo":79748007,
    "descripcion":"DISTOCIA MATERNA"
  },
  {
    "codigo":210820009,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚLTIPLES VASOS SANGUÍNEOS ABDOMINALES Y PÉLVICOS"
  },
  {
    "codigo":15686601000119107,
    "descripcion":"SINOVITIS TRANSITORIA DE RODILLA IZQUIERDA"
  },
  {
    "codigo":733273003,
    "descripcion":"MORDEDURA ABIERTA DE MUSLO"
  },
  {
    "codigo":241753006,
    "descripcion":"INTOXICACIÓN CAUSADA POR CARBAMAZEPINA"
  },
  {
    "codigo":12377007,
    "descripcion":"PRESIÓN VENOSA CENTRAL AUMENTADA"
  },
  {
    "codigo":274521009,
    "descripcion":"ANORMALIDAD EN EL ELECTROENCEFALOGRAMA"
  },
  {
    "codigo":1255726001,
    "descripcion":"GRANULOMA DE HODGKIN DE GANGLIOS LINFÁTICOS DE CABEZA"
  },
  {
    "codigo":698670005,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: MACEDONIO"
  },
  {
    "codigo":239918008,
    "descripcion":"CONECTIVOPATÍA NO DIFERENCIADA"
  },
  {
    "codigo":895278009,
    "descripcion":"DERMATITIS IRRITATIVA POR CONTACTO POR ESTOMA"
  },
  {
    "codigo":76078009,
    "descripcion":"ÚLCERA GÁSTRICA CRÓNICA CON HEMORRAGIA PERO SIN OBSTRUCCIÓN"
  },
  {
    "codigo":341091000119104,
    "descripcion":"NEOVASCULARIZACIÓN PROFUNDA DE CÓRNEA IZQUIERDA"
  },
  {
    "codigo":762371002,
    "descripcion":"PÉRDIDA DE TEJIDO DE OJO DERECHO CONCOMITANTE CON LACERACIÓN"
  },
  {
    "codigo":238083002,
    "descripcion":"HIPERTRIGLICERIDEMIA PRIMARIA"
  },
  {
    "codigo":305454008,
    "descripcion":"BAJO ATENCIÓN DE RADIOTERAPEUTA"
  },
  {
    "codigo":205315007,
    "descripcion":"CAMPTODACTILIA CON FALANGE DELTA"
  },
  {
    "codigo":72408002,
    "descripcion":"ÚLCERA GASTROYEYUNAL AGUDA CON HEMORRAGIA Y OBSTRUCCIÓN"
  },
  {
    "codigo":39640004,
    "descripcion":"ENFERMEDAD DE MINAMATA"
  },
  {
    "codigo":400088006,
    "descripcion":"ALOPECIA CICATRIZAL"
  },
  {
    "codigo":299949000,
    "descripcion":"SIGNO SENSORIAL CON NOMBRE PROPIO"
  },
  {
    "codigo":203480008,
    "descripcion":"OSTEONECROSIS DE CÓNDILO FEMORAL LATERAL"
  },
  {
    "codigo":201645006,
    "descripcion":"CONDROCALCINOSIS DE ARTICULACIÓN DE TOBILLO Y\/O PIE CAUSADA POR CRISTALES DE PIROFOSFATO"
  },
  {
    "codigo":365485009,
    "descripcion":"HALLAZGO RELACIONADO CON LA PROVISIÓN DE SERVICIOS DOMICILIARIOS"
  },
  {
    "codigo":396418004,
    "descripcion":"COMPROMISO DEL ESPÉCIMEN POR GANGLIOS CONGLOMERADOS: AUSENTE"
  },
  {
    "codigo":429186005,
    "descripcion":"FRACTURAS MÚLTIPLES NO EXPUESTAS DE LA PELVIS POR COMPRESIÓN ANTEROPOSTERIOR"
  },
  {
    "codigo":1078371000119109,
    "descripcion":"RODILLA VARA CONGÉNITA DERECHA"
  },
  {
    "codigo":134274008,
    "descripcion":"LEE PUNJABI"
  },
  {
    "codigo":296279001,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE REMOXIPRIDA"
  },
  {
    "codigo":724098008,
    "descripcion":"SÍNDROME DE MONOSOMÍA 9Q22.3"
  },
  {
    "codigo":1367008,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA ARTERIA MESENTÉRICA SUPERIOR"
  },
  {
    "codigo":1144577007,
    "descripcion":"HIPOPLASIA CONGÉNITA DE MÚSCULO PECTORAL MAYOR"
  },
  {
    "codigo":292609007,
    "descripcion":"REACCIÓN ADVERSA A LA NOSCAPINA"
  },
  {
    "codigo":290774001,
    "descripcion":"INTOXICACIÓN POR CICLOSPORINA"
  },
  {
    "codigo":28630001,
    "descripcion":"INTERVALO QRS ACORTADO"
  },
  {
    "codigo":94166001,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE CARA ANTERIOR DE EPIGLOTIS"
  },
  {
    "codigo":16016791000119104,
    "descripcion":"ARTRITIS REACTIVA BILATERAL DE ARTICULACIONES DE RODILLA"
  },
  {
    "codigo":92331005,
    "descripcion":"NEOPLASIA BENIGNA DE LA REGIÓN SACROCOCCÍGEA"
  },
  {
    "codigo":288939007,
    "descripcion":"DIFICULTAD PARA TRAGAR"
  },
  {
    "codigo":714923008,
    "descripcion":"DIFICULTAD PARA PASAR DE LA CAMA A LA SILLA DE RUEDAS"
  },
  {
    "codigo":418176003,
    "descripcion":"REACCIÓN ALÉRGICA CAUSADA POR VEGETAL, EXCEPTO VEGETAL COMESTIBLE"
  },
  {
    "codigo":188800003,
    "descripcion":"NEOPLASIA BENIGNA DE NASOFARINGE"
  },
  {
    "codigo":90496008,
    "descripcion":"EPIDERMÓLISIS BULLOSA SIMPLE GENERALIZADA"
  },
  {
    "codigo":343601000119101,
    "descripcion":"QUERATITIS ESCLEROSANTE DE AMBOS OJOS"
  },
  {
    "codigo":285269005,
    "descripcion":"PENSAMIENTOS DE VIOLACIÓN"
  },
  {
    "codigo":21290002,
    "descripcion":"PERICARDITIS SECUNDARIA A TRAUMATISMO PENETRANTE"
  },
  {
    "codigo":447274003,
    "descripcion":"RETORNO VENOSO PULMONAR OBSTRUIDO POR ESTRECHAMIENTO INTRÍNSECO"
  },
  {
    "codigo":709418005,
    "descripcion":"TRANSLOCACIÓN AUTOSÓMICA"
  },
  {
    "codigo":840490005,
    "descripcion":"MEGAURÉTER CONGÉNITO CON REFLUJO"
  },
  {
    "codigo":283434009,
    "descripcion":"CORTE EN LA RODILLA"
  },
  {
    "codigo":707583001,
    "descripcion":"CARCINOMA ADENOESCAMOSO PRIMARIO DE OROFARINGE"
  },
  {
    "codigo":52223005,
    "descripcion":"INSUFICIENCIA AGUDA"
  },
  {
    "codigo":281599007,
    "descripcion":"ESGUINCE DE LIGAMENTO DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":248831008,
    "descripcion":"ARÉOLA GRANDE"
  },
  {
    "codigo":83156004,
    "descripcion":"SENTIDO DEL OLFATO ALTERADO"
  },
  {
    "codigo":1197268005,
    "descripcion":"CARCINOMA PAPILAR PRIMARIO DE CUELLO DE ÚTERO"
  },
  {
    "codigo":48553001,
    "descripcion":"ENFERMEDAD POR HEMOGLOBINA H"
  },
  {
    "codigo":441769002,
    "descripcion":"DESFIBRILADOR CARDÍACO IN SITU"
  },
  {
    "codigo":276094000,
    "descripcion":"PROBLEMA LEGAL CON SEPARACIÓN"
  },
  {
    "codigo":210558001,
    "descripcion":"DAÑO POLIHÍSTICO MASIVO DEL ANTEBRAZO"
  },
  {
    "codigo":865918002,
    "descripcion":"EDEMA DE ESÓFAGO"
  },
  {
    "codigo":472702003,
    "descripcion":"OBSTRUCCIÓN DEL TRACTO DE SALIDA PULMONAR FETAL DEBIDA A SÍNDROME DE TRANSFUSIÓN INTERGEMELAR"
  },
  {
    "codigo":15636171000119102,
    "descripcion":"HALLUX LIMITUS ADQUIRIDO BILATERAL"
  },
  {
    "codigo":308862009,
    "descripcion":"DISPLASIA LEVE DE VÍAS BILIARES"
  },
  {
    "codigo":12115003,
    "descripcion":"ABSCESO DE PIE EXCEPTO DEDOS"
  },
  {
    "codigo":1290067005,
    "descripcion":"TUMOR NEUROENDOCRINO BIEN DIFERENCIADO DE INTESTINO DELGADO"
  },
  {
    "codigo":700243007,
    "descripcion":"INGESTA DE LÍQUIDOS POR VÍA ORAL INADECUADA PARA LAS NECESIDADES FISIOLÓGICAS"
  },
  {
    "codigo":765779008,
    "descripcion":"NEFROPATÍA POR REFLUJO DEL RIÑÓN IZQUIERDO DEBIDA A REFLUJO VESICOURETERAL"
  },
  {
    "codigo":403496009,
    "descripcion":"LUPUS ERITEMATOSO DISCOIDE DE LAS MEMBRANAS MUCOSAS GENITALES"
  },
  {
    "codigo":8445003,
    "descripcion":"NEOPLASIA DE VULVA QUE AFECTA EL EMBARAZO"
  },
  {
    "codigo":72146002,
    "descripcion":"SIGNO DE BRAGARD"
  },
  {
    "codigo":1153490002,
    "descripcion":"CREATINQUINASA SÉRICA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":203218005,
    "descripcion":"INFECCIÓN DE LA COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":235986006,
    "descripcion":"PERITONITIS FÚNGICA"
  },
  {
    "codigo":234151000,
    "descripcion":"ESTENOSIS DE FÍSTULA ARTERIOVENOSA CONGÉNITA"
  },
  {
    "codigo":103079001,
    "descripcion":"INMUNODEFICIENCIA CAUSADA POR CORTICOSTEROIDES"
  },
  {
    "codigo":365223002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA VESTIRSE"
  },
  {
    "codigo":301522009,
    "descripcion":"CAPAZ DE ENTRAR Y SALIR DE LA BAÑERA"
  },
  {
    "codigo":37543002,
    "descripcion":"INFESTACIÓN CAUSADA POR SARCOPTES SCABIEI VARIEDAD SUIS"
  },
  {
    "codigo":168615005,
    "descripcion":"RADIOGRAFÍA SIMPLE DE ARTICULACIÓN DE HOMBRO NORMAL"
  },
  {
    "codigo":299687006,
    "descripcion":"DESMANTELAMIENTO DE ANASTOMOSIS UROLÓGICA DE TRASPLANTE"
  },
  {
    "codigo":397991007,
    "descripcion":"PROBLEMA DE MONITOREO"
  },
  {
    "codigo":266919005,
    "descripcion":"NUNCA FUMÓ TABACO"
  },
  {
    "codigo":35708002,
    "descripcion":"ABSCESO DEL PERINEO"
  },
  {
    "codigo":232316002,
    "descripcion":"TRAUMA COCLEAR POR LESIÓN DE LA CABEZA"
  },
  {
    "codigo":68476006,
    "descripcion":"INTOXICACIÓN POR QUERCUS"
  },
  {
    "codigo":346111000119100,
    "descripcion":"HEMORRAGIA EXPULSIVA DE COROIDES DE AMBOS OJOS"
  },
  {
    "codigo":166780008,
    "descripcion":"PROTEÍNAS SÉRICAS TOTALES DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":363388009,
    "descripcion":"NEOPLASIA MALIGNA DE PALADAR BLANDO"
  },
  {
    "codigo":296017001,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE ZOPICLONA"
  },
  {
    "codigo":197713003,
    "descripcion":"SÍNDROME NEFRÍTICO CRÓNICO, GLOMERULONEFRITIS MESANGIOCAPILAR DIFUSA"
  },
  {
    "codigo":164945004,
    "descripcion":"ELECTROCARDIOGRAMA: INTERVALO P-R NORMAL"
  },
  {
    "codigo":230481005,
    "descripcion":"CEFALEA PUNZANTE IDIOPÁTICA"
  },
  {
    "codigo":427089005,
    "descripcion":"DIABETES MELLITUS POR FIBROSIS QUÍSTICA"
  },
  {
    "codigo":263249005,
    "descripcion":"FRACTURA DE HUESO CUBOIDES"
  },
  {
    "codigo":15992831000119102,
    "descripcion":"EPISCLERITIS DE OJO DERECHO CAUSADA POR MYCOBACTERIUM TUBERCULOSIS"
  },
  {
    "codigo":294182003,
    "descripcion":"ALERGIA A RESINA DE PODÓFILO"
  },
  {
    "codigo":288819007,
    "descripcion":"INCAPAZ DE IMITAR GESTOS"
  },
  {
    "codigo":195878008,
    "descripcion":"NEUMONÍA Y GRIPE"
  },
  {
    "codigo":32038009,
    "descripcion":"ABSCESO DE LA VESÍCULA BILIAR"
  },
  {
    "codigo":194043004,
    "descripcion":"ATROFIA ÓPTICA SECUNDARIA A ENFERMEDAD RETINIANA"
  },
  {
    "codigo":292347005,
    "descripcion":"REACCIÓN ADVERSA AL LORMETAZEPAM"
  },
  {
    "codigo":423419007,
    "descripcion":"EL AMBIENTE CONTIENE RIESGOS VEHICULARES"
  },
  {
    "codigo":1144315007,
    "descripcion":"FRENTE GRANDE"
  },
  {
    "codigo":716496003,
    "descripcion":"NO COMPRENDE INSTRUCCIONES DE MÁS DE TRES PALABRAS"
  },
  {
    "codigo":126672006,
    "descripcion":"NEOPLASIA DEL TABIQUE DE LA NARIZ"
  },
  {
    "codigo":224976008,
    "descripcion":"SE SIENTE ATRAPADO"
  },
  {
    "codigo":28368009,
    "descripcion":"ALUCINOSIS ORGÁNICA INDUCIDA POR SUSTANCIA PSICOACTIVA"
  },
  {
    "codigo":93904009,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE MÚSCULO DE LA REGIÓN INGUINAL"
  },
  {
    "codigo":1306320009,
    "descripcion":"NEOPLASIA BENIGNA DE TEJIDO ECTÓPICO DE MAMA"
  },
  {
    "codigo":26533002,
    "descripcion":"VIVIENDA EN EDIFICIO DE DEPARTAMENTOS"
  },
  {
    "codigo":92069005,
    "descripcion":"NEOPLASIA BENIGNA DE PARTES BLANDAS"
  },
  {
    "codigo":288677003,
    "descripcion":"CAPAZ DE FINALIZAR UNA CONVERSACIÓN"
  },
  {
    "codigo":712826000,
    "descripcion":"CEFALEA INTERMITENTE"
  },
  {
    "codigo":714661009,
    "descripcion":"CON MAYOR RIESGO DE ALTERACIÓN DE LA FUNCIÓN DEL SISTEMA GASTROINTESTINAL"
  },
  {
    "codigo":286842006,
    "descripcion":"CARÁCTER IMPRUDENTE"
  },
  {
    "codigo":1204346009,
    "descripcion":"DILATACIÓN QUÍSTICA CONGÉNITA DE COLÉDOCO"
  },
  {
    "codigo":874831002,
    "descripcion":"CUERPO EXTRAÑO EM PIEL DE REGIÓN ESCAPULAR"
  },
  {
    "codigo":285007002,
    "descripcion":"DIFICULTAD PARA DESABROCHAR LA ROPA"
  },
  {
    "codigo":55631001,
    "descripcion":"ANOMALÍA CONGÉNITA DE TESTÍCULO"
  },
  {
    "codigo":416079004,
    "descripcion":"PRECIPITADOS INFLAMATORIOS CORNEALES SEMEJANTES A GOTAS"
  },
  {
    "codigo":447012002,
    "descripcion":"TUBERCULOSIS DE MÉDULA ESPINAL"
  },
  {
    "codigo":53796002,
    "descripcion":"INTOXICACIÓN CAUSADA POR DOXICICLINA"
  },
  {
    "codigo":283172005,
    "descripcion":"CUERPO EXTRAÑO METÁLICO EN LOS GENITALES"
  },
  {
    "codigo":319641000119106,
    "descripcion":"ARTRITIS REACTIVA DE ARTICULACIÓN DE REGIÓN DE MUÑECA DERECHA"
  },
  {
    "codigo":1004068008,
    "descripcion":"CONTRACTURA EN FLEXIÓN DE CUARTO DEDO DE PIE"
  },
  {
    "codigo":1264377004,
    "descripcion":"LACERACIÓN DE TENDÓN DE DEDO DE PIE"
  },
  {
    "codigo":248569006,
    "descripcion":"RETRACCIÓN ESTERNAL"
  },
  {
    "codigo":281337006,
    "descripcion":"NO SE SUMINISTRARON DETALLES CLÍNICOS"
  },
  {
    "codigo":838393007,
    "descripcion":"ABSCESO DE PROTUBERANCIA"
  },
  {
    "codigo":703651000,
    "descripcion":"DIAFRAGMA MUCOSO DE ANTRO GÁSTRICO"
  },
  {
    "codigo":15523002,
    "descripcion":"EPILEPSIA FOCAL AUTOLIMITADA"
  },
  {
    "codigo":81059003,
    "descripcion":"POLUCIÓN"
  },
  {
    "codigo":769187006,
    "descripcion":"RETINOPATÍA NO PROLIFERATIVA SEVERA DE OJO DERECHO DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":275832008,
    "descripcion":"UTILIZA MÉTODO ANTICONCEPTIVO DE BARRERA FEMENINO"
  },
  {
    "codigo":110157002,
    "descripcion":"ABRASIÓN DEL PISO DE LA BOCA"
  },
  {
    "codigo":44621005,
    "descripcion":"ANOMALÍA CONGÉNITA DEL ÓRGANO DE CORTI"
  },
  {
    "codigo":184781000119102,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE CUELLO UTERINO"
  },
  {
    "codigo":1156898005,
    "descripcion":"NO INMUNE A DIFTERIA"
  },
  {
    "codigo":403234006,
    "descripcion":"FOTOSUBTIPO CUTÁNEO IVC (CASI NUNCA EXISTE QUEMADURA, LUEGO BRONCEADO INTENSO)"
  },
  {
    "codigo":42786005,
    "descripcion":"SÍNDROME DE PULGAR EN GATILLO"
  },
  {
    "codigo":237559000,
    "descripcion":"SÍNDROME DE RESISTENCIA A HORMONA TIROIDEA"
  },
  {
    "codigo":1287970008,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE AMBOS BRONQUIOS PRINCIPALES"
  },
  {
    "codigo":1220599002,
    "descripcion":"MANIFESTACIONES CUTÁNEAS SIMILARES AL PSEUDOXANTOMA ELÁSTICO CON RETINOSIS PIGMENTARIA"
  },
  {
    "codigo":303095004,
    "descripcion":"DEFICIENCIA DE ENZIMA PROPIONIL-COA CARBOXILASA, GRUPO COMPLEMENTARIO PCCBC"
  },
  {
    "codigo":40951006,
    "descripcion":"HIPEROXALURIA PRIMARIA, TIPO II"
  },
  {
    "codigo":301260001,
    "descripcion":"EXPANSIÓN TORÁCICA NORMAL"
  },
  {
    "codigo":1251532001,
    "descripcion":"RADIOGRAFÍA SIMPLE DE ESTRUCTURA ÓSEA DE COSTILLA ANORMAL"
  },
  {
    "codigo":1351671009,
    "descripcion":"AGAMMAGLOBULINEMIA AUTOSÓMICA RECESIVA DEBIDA A DEFICIENCIA DE BLNK"
  },
  {
    "codigo":235724004,
    "descripcion":"SÍNDROME DE INTESTINO CORTO ADQUIRIDO"
  },
  {
    "codigo":364961000,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA MOVER LA PUNTA DE LA LENGUA"
  },
  {
    "codigo":233889001,
    "descripcion":"HEMOPERICARDIO POSINFARTO"
  },
  {
    "codigo":6348008,
    "descripcion":"TRASTORNO PSICÓTICO CON ALUCINACIONES INDUCIDO POR COCAÍNA"
  },
  {
    "codigo":71884009,
    "descripcion":"DOLOR PRECORDIAL"
  },
  {
    "codigo":37281006,
    "descripcion":"CÍCLOPE HIPOGNATO"
  },
  {
    "codigo":201121008,
    "descripcion":"UÑA EN CAPARAZÓN DE TORTUGA"
  },
  {
    "codigo":363126001,
    "descripcion":"TRASTORNO DE LA REGIÓN ABDOMINAL FETAL"
  },
  {
    "codigo":68214002,
    "descripcion":"LINFANGITIS DE MAMA ASOCIADA CON EL PARTO"
  },
  {
    "codigo":397729009,
    "descripcion":"ENTEROCOLITIS NECROSANTE PERINATAL"
  },
  {
    "codigo":461430004,
    "descripcion":"ABSCESO DE CONDUCTO VASCULAR CARDÍACO"
  },
  {
    "codigo":725409009,
    "descripcion":"POLIDACTILIA DE PULGAR BIFALÁNGICO"
  },
  {
    "codigo":232054005,
    "descripcion":"RETINITIS PIGMENTARIA LIGADA AL CROMOSOMA X"
  },
  {
    "codigo":262987002,
    "descripcion":"SECCIÓN TRAUMÁTICA DE TENDÓN DE MÚSCULOS GEMELOS"
  },
  {
    "codigo":843004,
    "descripcion":"POLIOMIELOMALACIA"
  },
  {
    "codigo":721739005,
    "descripcion":"INFECCIÓN CAUSADA POR LISTERIA"
  },
  {
    "codigo":295755007,
    "descripcion":"SOBREDOSIS DE CRISANTASPASA"
  },
  {
    "codigo":66379009,
    "descripcion":"SÍNDROME DE SOBRECRECIMIENTO BACTERIANO"
  },
  {
    "codigo":293920002,
    "descripcion":"ALERGIA A BENPERIDOL"
  },
  {
    "codigo":228384008,
    "descripcion":"EMPLEA FÁRMACOS DE MANERA INCORRECTA, POR VÍA SUBLINGUAL"
  },
  {
    "codigo":718069002,
    "descripcion":"ENFERMEDAD GINGIVAL DEBIDA A LESIÓN FÍSICA TRAUMÁTICA"
  },
  {
    "codigo":292085003,
    "descripcion":"REACCIÓN ADVERSA A LA OXIFENBUTAZONA"
  },
  {
    "codigo":423157004,
    "descripcion":"TENSIÓN SIN ALIVIO"
  },
  {
    "codigo":62709005,
    "descripcion":"HABITANTE SUBURBANO"
  },
  {
    "codigo":95477007,
    "descripcion":"DEGENERACIÓN CONGÉNITA DEL SISTEMA NERVIOSO"
  },
  {
    "codigo":93642000,
    "descripcion":"MELANOMA MALIGNO DE LA PIEL DEL CUELLO"
  },
  {
    "codigo":880074004,
    "descripcion":"ESOTROPÍA NO ACOMODATIVA"
  },
  {
    "codigo":124575002,
    "descripcion":"DEFICIENCIA DE EXORRIBONUCLEASA"
  },
  {
    "codigo":288415007,
    "descripcion":"NO DESENROSCA UNA TAPA"
  },
  {
    "codigo":253812005,
    "descripcion":"HÍGADO TRILOBULAR"
  },
  {
    "codigo":1088411000119100,
    "descripcion":"INFLAMACIÓN CRÓNICA DE TROMPA FARINGOTIMPÁNICA IZQUIERDA"
  },
  {
    "codigo":24436009,
    "descripcion":"GORGOTEO"
  },
  {
    "codigo":11000731000119102,
    "descripcion":"DEPENDENCIA DE DIÁLISIS PERITONEAL CONTINUA AMBULATORIA"
  },
  {
    "codigo":710729009,
    "descripcion":"LENGUA LEÑOSA"
  },
  {
    "codigo":282910001,
    "descripcion":"NO SE LEVANTA DESDE POSICIÓN DE CUCLILLAS SIN USAR LAS MANOS"
  },
  {
    "codigo":250142007,
    "descripcion":"CALZADO MUY CORTO"
  },
  {
    "codigo":1296883003,
    "descripcion":"CON MAYOR RIESGO DE EXPOSICIÓN A LEPTOSPIRA"
  },
  {
    "codigo":248307007,
    "descripcion":"DISTRIBUCIÓN ADIPOSA CORPORAL PAREJA"
  },
  {
    "codigo":1264115008,
    "descripcion":"CARCINOMA METAPLÁSICO DE MAMA METASTÁSICO"
  },
  {
    "codigo":49864004,
    "descripcion":"GALOPE PROTODIASTÓLICO"
  },
  {
    "codigo":82632005,
    "descripcion":"ALTERACIÓN DE CUERNO ANTERIOR DE MENISCO EXTERNO"
  },
  {
    "codigo":770760006,
    "descripcion":"SÍNDROME DE MICRODELECIÓN 16Q24.1"
  },
  {
    "codigo":703389002,
    "descripcion":"DISCAPACIDAD INTELECTUAL RELACIONADA CON SERINA-PROTEÍNA QUINASA DEPENDIENTE DE CALCIO\/CALMODULINA"
  },
  {
    "codigo":80797002,
    "descripcion":"ESTRECHEZ CONGÉNITA DEL ORIFICIO VESICOURETRAL"
  },
  {
    "codigo":179101003,
    "descripcion":"URETRITIS CAUSADA POR CHLAMYDIA TRACHOMATIS"
  },
  {
    "codigo":11819931000119108,
    "descripcion":"SUBLUXACIÓN DE ARTICULACIÓN RADIOCUBITAL DISTAL IZQUIERDA"
  },
  {
    "codigo":768925009,
    "descripcion":"CISTOADENOMA MUCINOSO DE OVARIO EN LA INFANCIA"
  },
  {
    "codigo":78962002,
    "descripcion":"BESAR"
  },
  {
    "codigo":404807005,
    "descripcion":"PULMÓN DE LOS LAVADORES DE QUESO"
  },
  {
    "codigo":109895008,
    "descripcion":"RETENCIÓN DE FRAGMENTOS PLACENTARIOS"
  },
  {
    "codigo":1254940000,
    "descripcion":"PRURITO CAUSADO POR ALMIDÓN HIDROXIETÍLICO"
  },
  {
    "codigo":44359008,
    "descripcion":"LEUCODISTROFIA METACROMÁTICA, TIPO JUVENIL"
  },
  {
    "codigo":402972001,
    "descripcion":"COMPROMISO CUTÁNEO EN LA ENDOCARDITIS BACTERIANA"
  },
  {
    "codigo":370204008,
    "descripcion":"ASMA QUE PRODUCE SÍNTOMAS DIURNOS LA MAYORÍA DE LOS DÍAS"
  },
  {
    "codigo":827121001,
    "descripcion":"MASA DE CUADRANTE INFERIOR IZQUIERDO DE ABDOMEN"
  },
  {
    "codigo":42524008,
    "descripcion":"INTOXICACIÓN POR CORTICOTROFINA"
  },
  {
    "codigo":204529000,
    "descripcion":"MEMBRANA GLÓTICA CONGÉNITA DE LA LARINGE"
  },
  {
    "codigo":237297004,
    "descripcion":"PLACENTA ADHERIDA A UNA CICATRIZ PREVIA DE CESÁREA"
  },
  {
    "codigo":302833002,
    "descripcion":"PARAGANGLIOMA"
  },
  {
    "codigo":7921007,
    "descripcion":"DEFORMIDAD CONGÉNITA DE LA CLAVÍCULA"
  },
  {
    "codigo":169926005,
    "descripcion":"PUNTAJE DE APGAR A LOS 10 MINUTOS = 3"
  },
  {
    "codigo":366534006,
    "descripcion":"AMPLITUD DE MOVIMIENTO PASIVO DE ADUCCIÓN DE LA MUÑECA - HALLAZGO"
  },
  {
    "codigo":71622008,
    "descripcion":"EVALUACIÓN DE DISCAPACIDAD: ALTERACIÓN CLASE 4"
  },
  {
    "codigo":202694009,
    "descripcion":"ESPONDILOSIS LUMBOSACRA EN UN NIVEL CON RADICULOPATÍA"
  },
  {
    "codigo":102555004,
    "descripcion":"DOLOR DE CUELLO AGRAVADO POR LA POSICIÓN DE RECLINACIÓN"
  },
  {
    "codigo":233627004,
    "descripcion":"BRONQUIECTASIA QUÍSTICA CONGÉNITA"
  },
  {
    "codigo":299163005,
    "descripcion":"AMPLITUD DE ABDUCCIÓN ACTIVA DEL PULGAR NORMAL"
  },
  {
    "codigo":69787006,
    "descripcion":"CONTUSIÓN DE DEDO DE LA MANO"
  },
  {
    "codigo":721477000,
    "descripcion":"SÍNDROME DEL CORDÓN POSTERIOR DE MÉDULA ESPINAL AL NIVEL DEL NOVENO SEGMENTO DORSAL"
  },
  {
    "codigo":262725003,
    "descripcion":"SECCIÓN DE LA RAÍZ DE NERVIO DORSAL"
  },
  {
    "codigo":129818000,
    "descripcion":"ALTERACIÓN DE LAS ACTIVIDADES COTIDIANAS"
  },
  {
    "codigo":293658000,
    "descripcion":"ALERGIA A PIRENZEPINA"
  },
  {
    "codigo":228122001,
    "descripcion":"NIÑO EN ATENCIÓN RESIDENCIAL"
  },
  {
    "codigo":29679002,
    "descripcion":"PORTADOR DE ENFERMEDAD"
  },
  {
    "codigo":422895004,
    "descripcion":"EMETROPIZACIÓN"
  },
  {
    "codigo":160751007,
    "descripcion":"DESALOJO DE LA MORADA"
  },
  {
    "codigo":95215008,
    "descripcion":"PSEUDOESOTROPÍA"
  },
  {
    "codigo":289988000,
    "descripcion":"DIFICULTAD PARA USAR EL ORINAL"
  },
  {
    "codigo":291823009,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR FENFORMINA"
  },
  {
    "codigo":93380005,
    "descripcion":"DESALINEAMIENTO CONGÉNITO DE CENTRO DE VÉRTEBRA SACRA"
  },
  {
    "codigo":224452005,
    "descripcion":"SOLICITA LICENCIA POR PATERNIDAD"
  },
  {
    "codigo":60612008,
    "descripcion":"RUIDOS INTESTINALES ANORMALES"
  },
  {
    "codigo":91545002,
    "descripcion":"EVALUACIÓN DE DISCAPACIDAD: 18%"
  },
  {
    "codigo":714137003,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR PASTA DE DIENTES"
  },
  {
    "codigo":124313003,
    "descripcion":"DEFICIENCIA DE FOSFORRIBOCINASA"
  },
  {
    "codigo":1172889005,
    "descripcion":"SÍNDROME DE ANOMALÍAS PALATINAS, DIENTES AMPLIAMENTE ESPACIADOS, DISMORFIA FACIAL Y RETRASO DEL DESARROLLO"
  },
  {
    "codigo":58777003,
    "descripcion":"INFECCIÓN CAUSADA POR CRYPTOSPORIDIUM"
  },
  {
    "codigo":384622001,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA DISTAL AFECTADO POR NEOPLASIA MALIGNA"
  },
  {
    "codigo":286318003,
    "descripcion":"CAPAZ DE UTILIZAR COMBINACIONES DE CONSONANTE-VOCAL-CONSONANTE"
  },
  {
    "codigo":1269358004,
    "descripcion":"CRISIS EPILÉPTICA DE INICIO MOTOR CON ALTERACIÓN DE CONCIENCIA DE INICIO FOCAL"
  },
  {
    "codigo":253550006,
    "descripcion":"DEFECTOS MÚLTIPLES DEL TABIQUE INTERVENTRICULAR"
  },
  {
    "codigo":251715008,
    "descripcion":"MORFOMETRÍA DE CÉLULA ENDOTELIAL"
  },
  {
    "codigo":315416003,
    "descripcion":"NACIDO EN REPÚBLICA DOMINICANA"
  },
  {
    "codigo":249880007,
    "descripcion":"MOVIMIENTOS DE RUMIACIÓN DE LA LENGUA"
  },
  {
    "codigo":282648009,
    "descripcion":"HACE EL PUENTE"
  },
  {
    "codigo":248045001,
    "descripcion":"PROBLEMA DE DISCIPLINA ESCOLAR"
  },
  {
    "codigo":410050000,
    "descripcion":"MANIFESTACIÓN CLÍNICA DE DEFICIENCIA DE CARNOSINASA"
  },
  {
    "codigo":870637009,
    "descripcion":"DISECCIÓN DE ARTERIA CERVICAL"
  },
  {
    "codigo":278978003,
    "descripcion":"BEBÉ SANO"
  },
  {
    "codigo":1260183002,
    "descripcion":"CICATRIZ DE PIEL DE NARIZ"
  },
  {
    "codigo":768663003,
    "descripcion":"LEUCOENCEFALOPATÍA CON ATAXIA CEREBELOSA LEVE Y EDEMA DE SUSTANCIA BLANCA"
  },
  {
    "codigo":211607003,
    "descripcion":"LESIÓN TRAUMÁTICA ABIERTA POR APLASTAMIENTO, TOBILLO"
  },
  {
    "codigo":13164000,
    "descripcion":"AGUDEZA VISUAL REDUCIDA"
  },
  {
    "codigo":209772006,
    "descripcion":"RUPTURA DEL FLEXOR COMÚN PROFUNDO DE LOS DEDOS"
  },
  {
    "codigo":699457000,
    "descripcion":"INCLINACIÓN MESIAL DE DIENTE"
  },
  {
    "codigo":308076009,
    "descripcion":"SENSACIÓN DE PINCHAZO EN EL PIE DERECHO NORMAL"
  },
  {
    "codigo":240705002,
    "descripcion":"CANDIDIASIS TRAQUEAL"
  },
  {
    "codigo":764993001,
    "descripcion":"ENCEFALITIS CAUSADA POR MYCOPLASMA PNEUMONIAE"
  },
  {
    "codigo":109633000,
    "descripcion":"OCLUSIÓN DEFECTUOSA CAUSADA POR EL HÁBITO DE INTRODUCIRSE OBJETOS EN LA BOCA"
  },
  {
    "codigo":76865005,
    "descripcion":"FRACTURA NO EXPUESTA DE FALANGE DISTAL DE DEDO DE MANO"
  },
  {
    "codigo":271638000,
    "descripcion":"PULSO UNIFORMEMENTE IRREGULAR"
  },
  {
    "codigo":75030003,
    "descripcion":"GLUCOSURIA RENAL, TIPO A"
  },
  {
    "codigo":238870004,
    "descripcion":"SÍNDROME DE HUTCHINSON-GILFORD"
  },
  {
    "codigo":402710005,
    "descripcion":"DERMATOSIS DE MIEMBRO INFERIOR POR TRASTORNO DE VENAS DE PIERNA"
  },
  {
    "codigo":204267003,
    "descripcion":"SENO INTERNO DE LA HENDIDURA BRANQUIAL"
  },
  {
    "codigo":366272000,
    "descripcion":"MECANISMO DE CIERRE URETRAL - HALLAZGO"
  },
  {
    "codigo":399040002,
    "descripcion":"HIPOVENTILACIÓN CENTRAL CONGÉNITA"
  },
  {
    "codigo":267968002,
    "descripcion":"SÍNDROMES DE LA COLUMNA VERTEBRAL"
  },
  {
    "codigo":300736007,
    "descripcion":"DIFICULTAD PARA USAR EL TELÉFONO"
  },
  {
    "codigo":322112361000132104,
    "descripcion":"EPILEPSIA DEBIDA A CICATRIZ DE ENCÉFALO"
  },
  {
    "codigo":429973000,
    "descripcion":"FISURA DE PREPUCIO"
  },
  {
    "codigo":69525003,
    "descripcion":"ACIDURIA ORÓTICA HEREDITARIA, TIPO 1"
  },
  {
    "codigo":724885003,
    "descripcion":"DISTENSIÓN DE TENDÓN A LA ALTURA DEL TÓRAX"
  },
  {
    "codigo":266133006,
    "descripcion":"NEUROSÍFILIS CUATERNARIA TARDÍA"
  },
  {
    "codigo":460906001,
    "descripcion":"ANILLO VASCULAR CON RAMIFICACIÓN EN ESPEJO DE CAYADO AÓRTICO DERECHO Y LIGAMENTO ARTERIOSO IZQUIERDO"
  },
  {
    "codigo":231530005,
    "descripcion":"TRASTORNO DE PERSONALIDAD POSTERIOR A CONMOCIÓN"
  },
  {
    "codigo":297066006,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE INHIBIDOR DE LA FOSFODIESTERASA"
  },
  {
    "codigo":295231003,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE ETODOLACO"
  },
  {
    "codigo":719380003,
    "descripcion":"SÍNDROME DE MICROCEFALIA Y MIOCARDIOPATÍA"
  },
  {
    "codigo":293396006,
    "descripcion":"REACCIÓN ADVERSA A HIDROXOCOBALAMINA"
  },
  {
    "codigo":1145364008,
    "descripcion":"LESIÓN HIPOAUTOFLUORESCENTE DE MÁCULA LÚTEA"
  },
  {
    "codigo":94953002,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE MÚSCULO"
  },
  {
    "codigo":11853931000119101,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DE PIE IZQUIERDO"
  },
  {
    "codigo":160489003,
    "descripcion":"GRUPO SOCIAL 3 - NO MANUAL"
  },
  {
    "codigo":15730641000119107,
    "descripcion":"ESOTROPÍA NO ACOMODATIVA DE OJO IZQUIERDO"
  },
  {
    "codigo":62185008,
    "descripcion":"PANCARDITIS"
  },
  {
    "codigo":1141694001,
    "descripcion":"DEMUESTRA CONOCIMIENTO SOBRE CRIANZA"
  },
  {
    "codigo":715710001,
    "descripcion":"POLIDACTILIA DE PULGAR TRIFALÁNGICO"
  },
  {
    "codigo":93118003,
    "descripcion":"FALTA DE OSIFICACIÓN DEL OMÓPLATO"
  },
  {
    "codigo":289726005,
    "descripcion":"EFECTIVIDAD DE LA CONTRACCIÓN UTERINA - HALLAZGO"
  },
  {
    "codigo":60350006,
    "descripcion":"ABSCESO DE LA CARA EXTERNA DE LA NARIZ"
  },
  {
    "codigo":224190007,
    "descripcion":"INGRESO SUFICIENTE PARA SATISFACER LAS NECESIDADES"
  },
  {
    "codigo":1010622005,
    "descripcion":"INFECCIÓN PULMONAR POR MYCOBACTERIUM XENOPI"
  },
  {
    "codigo":255123005,
    "descripcion":"METÁSTASIS EN SISTEMA NERVIOSO CENTRAL Y OJO"
  },
  {
    "codigo":42721000087102,
    "descripcion":"DISCO INTERVERTEBRAL TORÁCICO PROLAPSADO, T9-T10"
  },
  {
    "codigo":1172627007,
    "descripcion":"SÍNDROME DE EPILEPSIA, DISCAPACIDAD INTELECTUAL, ANOMALÍAS CEREBRALES DE INICIO TEMPRANO"
  },
  {
    "codigo":47841000087104,
    "descripcion":"FRACTURA DE SEXTA COSTILLA DERECHA"
  },
  {
    "codigo":60641000087105,
    "descripcion":"DIFICULTAD PARA REALIZAR ACTIVIDAD DE LA VIDA DIARIA"
  },
  {
    "codigo":124051006,
    "descripcion":"CEREBRÓSIDO POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":40161000087107,
    "descripcion":"LACERACIÓN DE TENDÓN EXTENSOR DE PULGAR DERECHO"
  },
  {
    "codigo":187752007,
    "descripcion":"NEOPLASIA MALIGNA DE DIVERTÍCULO DE MECKEL"
  },
  {
    "codigo":449896008,
    "descripcion":"COMPRESIÓN DE VASO SANGUÍNEO"
  },
  {
    "codigo":284221001,
    "descripcion":"QUEMADURA SUPERFICIAL DE LOS GENITALES POR AGENTE CORROSIVO"
  },
  {
    "codigo":251453002,
    "descripcion":"OSCILACIONES PEQUEÑAS Y AGUZADAS DURANTE EL SUEÑO"
  },
  {
    "codigo":710205003,
    "descripcion":"NEOPLASIA DE CÉLULAS GIGANTES DE HUESOS CRANEOFACIALES"
  },
  {
    "codigo":448061002,
    "descripcion":"ESTENOSIS AÓRTICA SUPRAVALVULAR CON REBORDE"
  },
  {
    "codigo":185917005,
    "descripcion":"CONTROL DE TRATAMIENTO DE SUSTITUCIÓN HORMONAL REALIZADO"
  },
  {
    "codigo":87613006,
    "descripcion":"DIETA DE PURINAS"
  },
  {
    "codigo":286056009,
    "descripcion":"SECA LA ROPA LAVADA"
  },
  {
    "codigo":85778000,
    "descripcion":"LISTA DE REEMPLAZO DE LA LECHE"
  },
  {
    "codigo":686341000119102,
    "descripcion":"HISTIOCITOMA FIBROSO MALIGNO PRIMARIO DE PARTES BLANDAS DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":253288009,
    "descripcion":"AURÍCULA IZQUIERDA COMUNICADA CON AMBOS VENTRÍCULOS"
  },
  {
    "codigo":20242003,
    "descripcion":"DRENAJE DEFECTUOSO DE LAS LÁGRIMAS"
  },
  {
    "codigo":184082004,
    "descripcion":"EL PACIENTE HA VIAJADO AL EXTERIOR"
  },
  {
    "codigo":216850009,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR MONÓXIDO DE CARBONO POR EXPLOSIÓN DE HORNO A GAS"
  },
  {
    "codigo":83943005,
    "descripcion":"RABIETAS"
  },
  {
    "codigo":247783009,
    "descripcion":"AUMENTO DE LA AUTOESTIMA"
  },
  {
    "codigo":82108004,
    "descripcion":"NEUROPATÍA ÓPTICA NUTRICIONAL"
  },
  {
    "codigo":735633000,
    "descripcion":"EYACULACIÓN TARDÍA GENERALIZADA DE POR VIDA"
  },
  {
    "codigo":213180008,
    "descripcion":"FALLA TOTAL DE REIMPLANTE DE ANTEBRAZO"
  },
  {
    "codigo":49340009,
    "descripcion":"DEFICIENCIA DE VITAMINA A CON MANCHA DE BITOT Y XEROSIS CONJUNTIVAL"
  },
  {
    "codigo":276881003,
    "descripcion":"EMBARAZO ABDOMINAL SECUNDARIA"
  },
  {
    "codigo":47505003,
    "descripcion":"TRASTORNO POR ESTRÉS POSTRAUMÁTICO"
  },
  {
    "codigo":1259921009,
    "descripcion":"TRASTORNO FETAL DEBIDO A MALA PRESENTACIÓN DURANTE TRABAJO DE PARTO"
  },
  {
    "codigo":45670001,
    "descripcion":"HEMÓLISIS DE UNA COLONIA BACTERIANA, GAMMA"
  },
  {
    "codigo":78438001,
    "descripcion":"INTOXICACIÓN POR TAXUS BACCATA"
  },
  {
    "codigo":406118005,
    "descripcion":"ANTÍGENO DE SUPERFICIE DE HEPATITIS B NO DETECTADO POR ENSAYO INMUNOABSORBENTE LIGADO A ENZIMAS"
  },
  {
    "codigo":1290854006,
    "descripcion":"DERMATOFIBROSARCOMA PROTUBERANS FIBROSARCOMATOSO"
  },
  {
    "codigo":109371002,
    "descripcion":"NEOPLASIA MALIGNA SUPERPUESTA DE BRONQUIO Y PULMÓN"
  },
  {
    "codigo":240443003,
    "descripcion":"NOCARDIOSIS DISEMINADA"
  },
  {
    "codigo":402448001,
    "descripcion":"EPIDERMÓLISIS BULLOSA ADQUIRIDA, TIPO PENFIGOIDE BULLOSA"
  },
  {
    "codigo":271376002,
    "descripcion":"EMBOLIA GASEOSA"
  },
  {
    "codigo":369680002,
    "descripcion":"MARGEN DISTAL DE RESECCIÓN QUIRÚRGICA DE ESTÓMAGO, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":238608008,
    "descripcion":"PSORIASIS DEL CUERO CABELLUDO"
  },
  {
    "codigo":762896009,
    "descripcion":"TUMEFACCIÓN DE MIEMBRO INFERIOR IZQUIERDO"
  },
  {
    "codigo":204005000,
    "descripcion":"ESPINA BÍFIDA LUMBAR SIN HIDROCEFALIA - ABIERTA"
  },
  {
    "codigo":236773004,
    "descripcion":"EPIDIDIMORQUITIS POR CLAMIDIA"
  },
  {
    "codigo":72933006,
    "descripcion":"TRASTORNO DEBIDO A FRACTURAS DE MÚLTIPLES HUESOS Y DEBIDO A ELLAS"
  },
  {
    "codigo":7397008,
    "descripcion":"SÍNDROME DE IDENTIFICACIÓN CON EL AGRESOR"
  },
  {
    "codigo":1187045009,
    "descripcion":"SÍNDROME DE AICARDI GOUTIÈRES TIPO 1"
  },
  {
    "codigo":105701008,
    "descripcion":"ENFERMEDAD CAUSADA POR DIOCTOPHYMATOIDEA"
  },
  {
    "codigo":300474003,
    "descripcion":"HALLAZGO RELACIONADO CON LA DIURESIS"
  },
  {
    "codigo":202170005,
    "descripcion":"LUXACIÓN PATOLÓGICA DE LA MANO"
  },
  {
    "codigo":366010006,
    "descripcion":"HALLAZGO RELACIONADO CON EL MOVIMIENTO DEL PÁRPADO"
  },
  {
    "codigo":5562006,
    "descripcion":"ENDOMETRIOSIS DEL INTESTINO"
  },
  {
    "codigo":724623005,
    "descripcion":"PROBLEMA DE MANDÍBULA"
  },
  {
    "codigo":298639007,
    "descripcion":"SIN AMPLITUD DE FLEXIÓN LATERAL ACTIVA HACIA LA IZQUIERDA DE LA COLUMNA VERTEBRAL LUMBAR"
  },
  {
    "codigo":1892002,
    "descripcion":"MANCHA EN FORMA DE ESTRELLA EN LA MÁCULA"
  },
  {
    "codigo":296804003,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE FÁRMACO ANTILEPROSO"
  },
  {
    "codigo":395108007,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: PERSA"
  },
  {
    "codigo":32825000,
    "descripcion":"PERFORACIÓN POR CUERPO EXTRAÑO DEJADO ACCIDENTALMENTE EN HERIDA OPERATORIA Y\/O EN CAVIDAD CORPORAL DURANTE PROCEDIMIENTO"
  },
  {
    "codigo":1279844009,
    "descripcion":"VASCULOPATÍA MIOCÁRDICA PRIMARIA POR DEPÓSITO DE TRIGLICÉRIDOS"
  },
  {
    "codigo":131129005,
    "descripcion":"NIVEL DE ÁCIDO ASCÓRBICO POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":720953006,
    "descripcion":"SÍNDROME DE DIMELIA DIPLOPODIA DE PERONÉ"
  },
  {
    "codigo":305721000119108,
    "descripcion":"QUISTE DE ASTA POSTERIOR DE MENISCO INTERNO DE RODILLA IZQUIERDA"
  },
  {
    "codigo":294969007,
    "descripcion":"ALERGIA A ÁCIDO GRASO OMEGA 3 DERIVADO DE PESCADO"
  },
  {
    "codigo":65593009,
    "descripcion":"OCLUSIÓN PARCIAL DE LA VENA RETINIANA"
  },
  {
    "codigo":1145102004,
    "descripcion":"PESTAÑAS LARGAS DE PÁRPADO SUPERIOR"
  },
  {
    "codigo":29155003,
    "descripcion":"ECTROMELIA DE LA EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":212488000,
    "descripcion":"LESIONES ABIERTAS MÚLTIPLES DEL ABDOMEN, REGIÓN LUMBAR Y PELVIS"
  },
  {
    "codigo":291299006,
    "descripcion":"INTOXICACIÓN POR AGONISTAS ALFA-ADRENORRECEPTORES"
  },
  {
    "codigo":60088004,
    "descripcion":"ODONTOMA TEMPORAL"
  },
  {
    "codigo":289464008,
    "descripcion":"PROBLEMA DE LA PELVIS PARA EL PARTO"
  },
  {
    "codigo":123789000,
    "descripcion":"TRASTORNO EN EL PROCESO DE COAGULACIÓN SANGUÍNEA CON AUMENTO DEL TIEMPO DE SANGRÍA"
  },
  {
    "codigo":688851000119108,
    "descripcion":"CARCINOMA PRIMARIO DE CÉLULAS ESCAMOSAS DE GLANDE DE PENE"
  },
  {
    "codigo":449634005,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE PIEL DE PIERNA"
  },
  {
    "codigo":447799001,
    "descripcion":"TERATOMA BENIGNO DE TESTÍCULO"
  },
  {
    "codigo":54583007,
    "descripcion":"CODO VALGO ADQUIRIDO"
  },
  {
    "codigo":773644000,
    "descripcion":"SÍNDROME DE ASPECTO PROGEROIDE Y MARFANOIDE, Y LIPODISTROFIA"
  },
  {
    "codigo":283959008,
    "descripcion":"LACERACIÓN DE TROMPA DE FALOPIO"
  },
  {
    "codigo":216588000,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR COLINÉRGICO"
  },
  {
    "codigo":249356002,
    "descripcion":"EXTREMO POSTERIOR DE HIPERTROFIA DE CORNETE INFERIOR"
  },
  {
    "codigo":445964006,
    "descripcion":"TRASTORNO LINFOPROLIFERATIVO MONOMÓRFICO POSTRASPLANTE"
  },
  {
    "codigo":50913002,
    "descripcion":"SÍNDROME DE GROB"
  },
  {
    "codigo":83681002,
    "descripcion":"INTOXICACIÓN POR AMARANTO COMÚN"
  },
  {
    "codigo":212918003,
    "descripcion":"CONGELAMIENTO SUPERFICIAL DEL TÓRAX"
  },
  {
    "codigo":49078004,
    "descripcion":"INFECCIÓN CAUSADA POR TOXOCARA CANIS"
  },
  {
    "codigo":737206009,
    "descripcion":"LINFANGITIS CAUSADA POR BACTERIAS"
  },
  {
    "codigo":704438009,
    "descripcion":"REALIZA ACTIVIDAD DE ACICALAMIENTO PERSONAL"
  },
  {
    "codigo":276619008,
    "descripcion":"PETEQUIAS FACIALES NEONATALES"
  },
  {
    "codigo":274784001,
    "descripcion":"ÁCIDO VAINILLILMANDÉLICO URINARIO POR ENCIMA DE RANGO DE REFERENCIA"
  },
  {
    "codigo":243851009,
    "descripcion":"SITUACIÓN DEL MONITOREO DE ENFERMEDAD CRÓNICA"
  },
  {
    "codigo":373088001,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE CUADRANTE SUPEROEXTERNO DE MAMA"
  },
  {
    "codigo":1290592004,
    "descripcion":"RADIOGRAFÍA DE ANTEBRAZO ANORMAL"
  },
  {
    "codigo":405856002,
    "descripcion":"FENOTIPO JK(A+B-)"
  },
  {
    "codigo":209248000,
    "descripcion":"FRACTURA-SUBLUXACIÓN EXPUESTA DE ARTICULACIÓN DE HOMBRO"
  },
  {
    "codigo":76341000,
    "descripcion":"SÍNDROME DE KOENIG II"
  },
  {
    "codigo":305717000,
    "descripcion":"VISTO POR EL CIRUJANO DE MANO"
  },
  {
    "codigo":240181002,
    "descripcion":"OSTEOCONDRITIS DEL CÚBITO DISTAL"
  },
  {
    "codigo":830005003,
    "descripcion":"SENSIBILIDAD VIBRATORIA DE PIE DERECHO NORMAL"
  },
  {
    "codigo":698933003,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: XHOSA"
  },
  {
    "codigo":1255989003,
    "descripcion":"RUPTURA TRAUMÁTICA DE LIGAMENTO COLATERAL DE ARTICULACIÓN DE DEDO MEDIO DE MANO"
  },
  {
    "codigo":12104711000119107,
    "descripcion":"QUEMADURA QUÍMICA DE DORSO DE MANO DERECHA"
  },
  {
    "codigo":74506000,
    "descripcion":"DUELO"
  },
  {
    "codigo":404021008,
    "descripcion":"MENINGIOMA CUTÁNEO"
  },
  {
    "codigo":402186001,
    "descripcion":"DERMATITIS ATÓPICA GENERALIZADA"
  },
  {
    "codigo":271114003,
    "descripcion":"AMPOLLA TRAUMÁTICA DEL CUERO CABELLUDO, INFECTADA"
  },
  {
    "codigo":302047004,
    "descripcion":"NO SE SIENTA SIN SOSTÉN"
  },
  {
    "codigo":236511006,
    "descripcion":"NEFROPATÍA MACROGLOBULINÉMICA"
  },
  {
    "codigo":5300004,
    "descripcion":"SÍNDROME DE HIDROPESÍA POR HEMOGLOBINA DE BART"
  },
  {
    "codigo":726196006,
    "descripcion":"LACERACIÓN DE MÚSCULO INTRÍNSECO DE PULGAR"
  },
  {
    "codigo":300212009,
    "descripcion":"NO RESPONDE A LOS SONIDOS DE FRECUENCIA ALTA"
  },
  {
    "codigo":724361001,
    "descripcion":"SÍNDROME DE ENFERMEDAD HEPÁTICA VENO-OCLUSIVA CON INMUNODEFICIENCIA"
  },
  {
    "codigo":200073003,
    "descripcion":"CEFALEA INDUCIDA POR ANESTESIA RAQUÍDEA Y EPIDURAL DURANTE EL PUERPERIO"
  },
  {
    "codigo":429449002,
    "descripcion":"HIPOPLASIA CONGÉNITA DE MÁCULA"
  },
  {
    "codigo":298377005,
    "descripcion":"CREPITACIÓN DE ARTICULACIÓN TEMPOROMANDIBULAR"
  },
  {
    "codigo":36233006,
    "descripcion":"ESTENOSIS CONGÉNITA DE VÁLVULA TRICÚSPIDE"
  },
  {
    "codigo":301376008,
    "descripcion":"TEMEROSO CON DOLOR"
  },
  {
    "codigo":196403002,
    "descripcion":"PELLIZCAMIENTO DE PARTES BLANDAS"
  },
  {
    "codigo":294707002,
    "descripcion":"ALERGIA A PREDNISOLONA"
  },
  {
    "codigo":1074811000119100,
    "descripcion":"ARTRITIS DE PRIMERA ARTICULACIÓN CARPOMETACARPIANA DE MANO DERECHA"
  },
  {
    "codigo":299131000119101,
    "descripcion":"HEMARTROSIS DE PIE DERECHO"
  },
  {
    "codigo":25211000119101,
    "descripcion":"TRASTORNO METABÓLICO TRANSITORIO NEONATAL"
  },
  {
    "codigo":680035451000119103,
    "descripcion":"PORTADOR DE DISTROFIA MUSCULAR DE BECKER"
  },
  {
    "codigo":1090171000119104,
    "descripcion":"EDENTULISMO PARCIAL CLASE II DEBIDO A TRAUMATISMO"
  },
  {
    "codigo":99451000119105,
    "descripcion":"INFARTO CEREBRAL DEBIDO A ESTENOSIS DE ARTERIA CARÓTIDA"
  },
  {
    "codigo":340091000119105,
    "descripcion":"LUXACIÓN DE GLÁNDULA LAGRIMAL IZQUIERDA"
  },
  {
    "codigo":10866811000119107,
    "descripcion":"HERIDA POR DISPARO DE ARMA DE FUEGO DE PELVIS"
  },
  {
    "codigo":311931000119108,
    "descripcion":"OSTEOCONDROSIS JUVENIL DE LA COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":122491000119108,
    "descripcion":"TRASTORNO LINFOPROLIFERATIVO DESPUÉS DE TRASPLANTE DE MÉDULA ÓSEA"
  },
  {
    "codigo":368251000119101,
    "descripcion":"POLINEUROPATÍA POR DIABETES MELLITUS MEDICAMENTOSA"
  },
  {
    "codigo":346674811000119104,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DEBIDO A OCLUSIÓN DE AMBAS ARTERIAS CEREBELOSAS"
  },
  {
    "codigo":720691008,
    "descripcion":"ALERGIA A ÁCIDO BILIAR"
  },
  {
    "codigo":22651000119106,
    "descripcion":"PTOSIS DE PÁRPADO POSOPERATORIA"
  },
  {
    "codigo":129032002,
    "descripcion":"DEPENDENCIA PARA REALIZAR LAS COMPRAS"
  },
  {
    "codigo":784392009,
    "descripcion":"NEUTROPENIA IDIOPÁTICA CRÓNICA DEL ADULTO"
  },
  {
    "codigo":12003451000119107,
    "descripcion":"HEMORRAGIA DE ÓRGANO RESPIRATORIO DURANTE OPERACIÓN DE PULMÓN"
  },
  {
    "codigo":294011000119108,
    "descripcion":"RUPTURA ESPONTÁNEA DE DURAMADRE"
  },
  {
    "codigo":1306845001,
    "descripcion":"SÍNDROME DE ALFA-GALACTOSIDASA"
  },
  {
    "codigo":127197003,
    "descripcion":"LINFADENOPATÍA EPITROCLEAR"
  },
  {
    "codigo":225501000,
    "descripcion":"TIENDE A USAR ROPA DE MODA"
  },
  {
    "codigo":92594000,
    "descripcion":"CARCINOMA IN SITU DE LOS ÓRGANOS GENITALES FEMENINOS"
  },
  {
    "codigo":94429001,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE MÚSCULO DEL TÓRAX"
  },
  {
    "codigo":1074491000119107,
    "descripcion":"ARTROSIS DE PIE IZQUIERDO"
  },
  {
    "codigo":289202007,
    "descripcion":"HABLAR DE MÁS"
  },
  {
    "codigo":59826007,
    "descripcion":"INTOXICACIÓN POR QUINIDINA"
  },
  {
    "codigo":254599004,
    "descripcion":"GRANULOMA ALIMENTARIO DEL INTESTINO"
  },
  {
    "codigo":418439007,
    "descripcion":"PAPILOMA CONJUNTIVAL SÉSIL"
  },
  {
    "codigo":23388006,
    "descripcion":"ESCOTOMA"
  },
  {
    "codigo":88924008,
    "descripcion":"REACCIÓN DE INCOMPATIBILIDAD RH"
  },
  {
    "codigo":285532008,
    "descripcion":"MUEVE LA LÁMINA DE LA LENGUA"
  },
  {
    "codigo":185393003,
    "descripcion":"PACIENTE ATENDIDO SÓLO UNA VEZ"
  },
  {
    "codigo":283697005,
    "descripcion":"MORDEDURA HUMANA EN LA GARGANTA"
  },
  {
    "codigo":414769005,
    "descripcion":"INMUNOGLOBULINA D MONOCLONAL DETECTADA"
  },
  {
    "codigo":58419006,
    "descripcion":"FITOFOTODERMATITIS CRÓNICA"
  },
  {
    "codigo":281862002,
    "descripcion":"ENURESIS DIURNA"
  },
  {
    "codigo":52486002,
    "descripcion":"FASCITIS NECROSANTE"
  },
  {
    "codigo":871686004,
    "descripcion":"LATIDOS AURICULARES ECTÓPICOS MÚLTIPLES"
  },
  {
    "codigo":609542006,
    "descripcion":"HIPERSENSIBILIDAD NO ALÉRGICA A LISINOPRIL"
  },
  {
    "codigo":707846008,
    "descripcion":"INGESTA INADECUADA DE AMINOÁCIDO"
  },
  {
    "codigo":249094009,
    "descripcion":"POSICIÓN FRONTAL ANTERIOR (DEL FETO)"
  },
  {
    "codigo":738779002,
    "descripcion":"HEMORRAGIA INTRACRANEAL ESPONTÁNEA"
  },
  {
    "codigo":11834991000119104,
    "descripcion":"SUBLUXACIÓN DE ARTICULACIÓN CARPOMETACARPIANA IZQUIERDA"
  },
  {
    "codigo":314630009,
    "descripcion":"ABSCESO DE LABIOS VULVARES"
  },
  {
    "codigo":17883008,
    "descripcion":"ESGUINCE DE CADERA"
  },
  {
    "codigo":16012911000119105,
    "descripcion":"TROMBOSIS DE ARTERIA POPLÍTEA IZQUIERDA"
  },
  {
    "codigo":704176005,
    "descripcion":"FRACTURA NO EXPUESTA DE TERCER METACARPIANO"
  },
  {
    "codigo":276357003,
    "descripcion":"MASA PILÓRICA"
  },
  {
    "codigo":339721000119101,
    "descripcion":"LAGOFTALMOS MECÁNICO DE PÁRPADO INFERIOR IZQUIERDO"
  },
  {
    "codigo":15740681000119101,
    "descripcion":"ASTIGMATISMO ALTO BILATERAL"
  },
  {
    "codigo":46981006,
    "descripcion":"DEFICIENCIA DE FACTOR XII"
  },
  {
    "codigo":370991000,
    "descripcion":"FUNCIÓN REPRODUCTIVA MASCULINA NORMAL"
  },
  {
    "codigo":403759001,
    "descripcion":"TRASTORNO CROMOSÓMICO AUTOSÓMICO"
  },
  {
    "codigo":700506009,
    "descripcion":"TRAUMATISMO CRANEOENCEFÁLICO NO ACCIDENTAL EN UN NIÑO"
  },
  {
    "codigo":733274009,
    "descripcion":"MÚLTIPLES HERIDAS ABIERTAS DE CADERA"
  },
  {
    "codigo":1255727005,
    "descripcion":"GRANULOMA DE HODGKIN DE GANGLIOS LINFÁTICOS DE CUELLO"
  },
  {
    "codigo":698671009,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: MALGACHE"
  },
  {
    "codigo":305455009,
    "descripcion":"BAJO ATENCIÓN DE: MÉDICO GENERAL"
  },
  {
    "codigo":860676006,
    "descripcion":"EMBOLIA DE LÍQUIDO AMNIÓTICO DEBIDA A EMBARAZO MOLAR Y POSTERIOR A ÉL"
  },
  {
    "codigo":205316008,
    "descripcion":"CLINODACTILIA SIN FALANGE DELTA"
  },
  {
    "codigo":762372009,
    "descripcion":"PÉRDIDA DE TEJIDO DE OJO IZQUIERDO CONCOMITANTE CON RUPTURA"
  },
  {
    "codigo":8708008,
    "descripcion":"DOLOR INCISIVO"
  },
  {
    "codigo":238084008,
    "descripcion":"LIPOPROTEINEMIA DE MUY BAJA DENSIDAD"
  },
  {
    "codigo":72409005,
    "descripcion":"RINOESCLEROMA"
  },
  {
    "codigo":1284825007,
    "descripcion":"PH URINARIO POR ENCIMA DE RANGO DE REFERENCIA"
  },
  {
    "codigo":299950000,
    "descripcion":"SIGNO DE LA SILLA DE PELUQUERO"
  },
  {
    "codigo":234414004,
    "descripcion":"TRASTORNO LEUCOCITARIO NO MALIGNO"
  },
  {
    "codigo":365486005,
    "descripcion":"HALLAZGO RELACIONADO CON EL REQUERIMIENTO DE SERVICIO DOMICILIARIO"
  },
  {
    "codigo":201646007,
    "descripcion":"CONDROCALCINOSIS DE MÚLTIPLES LOCALIZACIONES CAUSADA POR CRISTALES DE PIROFOSFATO"
  },
  {
    "codigo":398254007,
    "descripcion":"PREECLAMPSIA"
  },
  {
    "codigo":429187001,
    "descripcion":"CONTINUACIÓN DE EMBARAZO LUEGO DE MUERTE INTRAUTERINA DE FETO GEMELAR"
  },
  {
    "codigo":724099000,
    "descripcion":"SÍNDROME DE FANCONI ADQUIRIDO ASOCIADO CON INMUNOGLOBULINA DE CADENA LIVIANA MONOCLONAL"
  },
  {
    "codigo":1184686008,
    "descripcion":"AUSENCIA DE APOYO EMOCIONAL"
  },
  {
    "codigo":134275009,
    "descripcion":"LEE PORTUGUÉS"
  },
  {
    "codigo":427352001,
    "descripcion":"TUMOR QUE INVADE MEDIASTINO"
  },
  {
    "codigo":230744007,
    "descripcion":"FILTRACIÓN DE LÍQUIDO CEFALORRAQUÍDEO"
  },
  {
    "codigo":720429007,
    "descripcion":"DISOSTOSIS ACROFACIAL TIPO PALAGONIA"
  },
  {
    "codigo":292610002,
    "descripcion":"REACCIÓN ADVERSA A LA FOLCODINA"
  },
  {
    "codigo":1144578002,
    "descripcion":"APLASIA DE MÚSCULO DE HOMBRO"
  },
  {
    "codigo":63234004,
    "descripcion":"DIVORCIO"
  },
  {
    "codigo":290775000,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR CICLOSPORINA"
  },
  {
    "codigo":94167005,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL MEDIASTINO ANTERIOR"
  },
  {
    "codigo":421847006,
    "descripcion":"COMA POR CETOACIDOSIS DEBIDO A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":92332003,
    "descripcion":"NEOPLASIA BENIGNA DEL SACRO"
  },
  {
    "codigo":1835003,
    "descripcion":"NECROSIS DEL PÁNCREAS"
  },
  {
    "codigo":449110001,
    "descripcion":"ONDULACIÓN CONGÉNITA DE VALVA DE VÁLVULA MITRAL"
  },
  {
    "codigo":285270006,
    "descripcion":"PLANES PARA MATAR"
  },
  {
    "codigo":447275002,
    "descripcion":"DISPLASIA CAPILAR ALVEOLAR CON DEFECTO DE ALINEACIÓN VENOSO PULMONAR"
  },
  {
    "codigo":283435005,
    "descripcion":"CORTE EN PIERNA"
  },
  {
    "codigo":840491009,
    "descripcion":"MALA ALINEACIÓN CONGÉNITA DE UÑA DE DEDO GORDO DEL PIE"
  },
  {
    "codigo":248832001,
    "descripcion":"CONDUCTOS GALACTÓFOROS - HALLAZGO"
  },
  {
    "codigo":445440001,
    "descripcion":"ANEURISMA DE VENTRÍCULO DERECHO"
  },
  {
    "codigo":84992006,
    "descripcion":"EVALUACIÓN DE DISCAPACIDAD: 2%"
  },
  {
    "codigo":707584007,
    "descripcion":"CARCINOMA LINFOEPITELIAL PRIMARIO DE OROFARINGE"
  },
  {
    "codigo":83157008,
    "descripcion":"INSOMNIO FAMILIAR MORTAL"
  },
  {
    "codigo":441770001,
    "descripcion":"TUBERCULOSIS DE ORIFICIO CORPORAL EXTERNO"
  },
  {
    "codigo":767615004,
    "descripcion":"QUISTE EMBRIONARIO DE ESTRUCTURA GENITAL FEMENINA"
  },
  {
    "codigo":276095004,
    "descripcion":"PROBLEMA LEGAL CON DIVORCIO"
  },
  {
    "codigo":308863004,
    "descripcion":"DISPLASIA MODERADA DE VÍAS BILIARES"
  },
  {
    "codigo":151921000119105,
    "descripcion":"CUIDA DE FAMILIAR ENFERMO O DISCAPACITADO"
  },
  {
    "codigo":272563009,
    "descripcion":"DECÚBITO VENTRAL CON ALMOHADA BAJO LAS CADERAS - PIE DE LA CAMA ELEVADO 45 CM"
  },
  {
    "codigo":1290068000,
    "descripcion":"TUMOR NEUROENDOCRINO BIEN DIFERENCIADO DE RECTO"
  },
  {
    "codigo":472703008,
    "descripcion":"PSEUDOACARDIA"
  },
  {
    "codigo":765780006,
    "descripcion":"NEFROPATÍA POR REFLUJO DEL RIÑÓN DERECHO DEBIDA A REFLUJO VESICOURETERAL"
  },
  {
    "codigo":1157161000,
    "descripcion":"MENINGIOMA DE COMPORTAMIENTO INCIERTO"
  },
  {
    "codigo":403497000,
    "descripcion":"LUPUS ERITEMATOSO DISCOIDE DE CUERO CABELLUDO"
  },
  {
    "codigo":75817003,
    "descripcion":"CELULITIS DE MAMA"
  },
  {
    "codigo":11784561000119108,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE MANO IZQUIERDA"
  },
  {
    "codigo":237822008,
    "descripcion":"ENFERMEDAD ENDOCRINA AUTOINMUNITARIA"
  },
  {
    "codigo":203219002,
    "descripcion":"INFECCIÓN DE LA COLUMNA VERTEBRAL LUMBAR"
  },
  {
    "codigo":235987002,
    "descripcion":"PERITONITIS PARASITARIA"
  },
  {
    "codigo":1153491003,
    "descripcion":"CREATINQUINASA SÉRICA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":301523004,
    "descripcion":"INCAPAZ DE ENTRAR Y SALIR DE LA BAÑERA"
  },
  {
    "codigo":397992000,
    "descripcion":"TRADUCCIÓN DE LA FORMA DE ONDA"
  },
  {
    "codigo":103080003,
    "descripcion":"INMUNODEFICIENCIA DEBIDA A RADIOTERAPIA"
  },
  {
    "codigo":4776004,
    "descripcion":"LIQUEN PLANO"
  },
  {
    "codigo":266920004,
    "descripcion":"FUMADOR OCASIONAL DE CIGARRILLOS (MENOS DE UN CIGARRILLO\/DÍA)"
  },
  {
    "codigo":168616006,
    "descripcion":"RADIOGRAFÍA SIMPLE DE ARTICULACIÓN DE HOMBRO ANORMAL"
  },
  {
    "codigo":234152007,
    "descripcion":"TROMBOSIS DE FÍSTULA ARTERIOVENOSA CONGÉNITA"
  },
  {
    "codigo":365224008,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA PONERSE ZAPATOS"
  },
  {
    "codigo":363389001,
    "descripcion":"NEOPLASIA MALIGNA DE ÚVULA"
  },
  {
    "codigo":35709005,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA ARTERIA CUBITAL"
  },
  {
    "codigo":232317006,
    "descripcion":"BAROTRAUMA COCLEAR"
  },
  {
    "codigo":166781007,
    "descripcion":"PROTEÍNAS SÉRICAS TOTALES FUERA DE RANGO DE REFERENCIA"
  },
  {
    "codigo":427090001,
    "descripcion":"ÍNDICE DE MASA CORPORAL MENOR DE 16,5"
  },
  {
    "codigo":722002002,
    "descripcion":"SÍNDROME DE DISCAPACIDAD INTELECTUAL, CALVICIE, LUXACIÓN DE RÓTULA Y ACROMICRIA"
  },
  {
    "codigo":230482003,
    "descripcion":"CAROTIDINIA"
  },
  {
    "codigo":164946003,
    "descripcion":"INTERVALO P-R ELECTROCARDIOGRÁFICO ANORMAL"
  },
  {
    "codigo":263250005,
    "descripcion":"FRACTURA DE HUESO DE ANTEPIÉ"
  },
  {
    "codigo":66642002,
    "descripcion":"TONO VOCAL ANORMAL"
  },
  {
    "codigo":296018006,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE ZOPICLONA"
  },
  {
    "codigo":1082021000119103,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS INTRAEPIDÉRMICO DE OÍDO DERECHO"
  },
  {
    "codigo":197714009,
    "descripcion":"SÍNDROME NEFRÍTICO CRÓNICO, ENFERMEDAD DE DEPÓSITOS DENSOS"
  },
  {
    "codigo":95740000,
    "descripcion":"ARCOS LIPOIDES DE LA CÓRNEA"
  },
  {
    "codigo":294183008,
    "descripcion":"ALERGIA A PODOFILOTOXINA"
  },
  {
    "codigo":292348000,
    "descripcion":"REACCIÓN ADVERSA AL NITRAZEPAM"
  },
  {
    "codigo":1177084005,
    "descripcion":"MIELOSUPRESIÓN DEBIDA A QUIMIOTERAPIA"
  },
  {
    "codigo":1144316008,
    "descripcion":"FRENTE PROMINENTE"
  },
  {
    "codigo":290513002,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR HALOTANO"
  },
  {
    "codigo":344741000119107,
    "descripcion":"ESCOTOMA PARACECAL BILATERAL"
  },
  {
    "codigo":224977004,
    "descripcion":"SENSACIÓN DE TRISTEZA"
  },
  {
    "codigo":61137005,
    "descripcion":"GRANULOMA FACIAL"
  },
  {
    "codigo":93905005,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE MÚSCULO DEL MIEMBRO INFERIOR"
  },
  {
    "codigo":716497007,
    "descripcion":"NO COMPRENDE INSTRUCCIONES DE MÁS DE DOS PARTES"
  },
  {
    "codigo":1306321008,
    "descripcion":"NEOPLASIA MALIGNA CON METÁSTASIS A PEZÓN"
  },
  {
    "codigo":714662002,
    "descripcion":"CON MAYOR RIESGO DE DESARROLLO FETAL ALTERADO"
  },
  {
    "codigo":92070006,
    "descripcion":"NEOPLASIA BENIGNA DE LA CÓRNEA"
  },
  {
    "codigo":288678008,
    "descripcion":"INCAPAZ DE FINALIZAR UNA CONVERSACIÓN"
  },
  {
    "codigo":286843001,
    "descripcion":"CARÁCTER AUTORREFERENCIAL"
  },
  {
    "codigo":57467003,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN RADIOCUBITAL DISTAL DE MUÑECA"
  },
  {
    "codigo":24699006,
    "descripcion":"INTERRUPCIÓN DE LA FASE ACTIVA DEL TRABAJO DE PARTO"
  },
  {
    "codigo":90235006,
    "descripcion":"FRACTURA NO EXPUESTA DE DIÁFISIS DE HÚMERO"
  },
  {
    "codigo":15637311000119105,
    "descripcion":"BURSITIS OLECRANIANA BILATERAL"
  },
  {
    "codigo":283173000,
    "descripcion":"CUERPO EXTRAÑO METÁLICO EN EXTREMIDAD INFERIOR"
  },
  {
    "codigo":874832009,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE REGIÓN ESCAPULAR"
  },
  {
    "codigo":1004069000,
    "descripcion":"CONTRACTURA EN FLEXIÓN DE QUINTO DEDO DE PIE"
  },
  {
    "codigo":250405008,
    "descripcion":"COMPATIBILIDAD SANGUÍNEA"
  },
  {
    "codigo":281338001,
    "descripcion":"NO SE INFORMÓ EL MÉDICO GENERAL SOLICITANTE"
  },
  {
    "codigo":838394001,
    "descripcion":"ABSCESO DE MESENCÉFALO"
  },
  {
    "codigo":84730007,
    "descripcion":"CRIOPATÍA"
  },
  {
    "codigo":445178008,
    "descripcion":"SENSACIÓN DE ARDOR EN VAGINA"
  },
  {
    "codigo":443343001,
    "descripcion":"INSUFICIENCIA CARDÍACA DIASTÓLICA AGUDA"
  },
  {
    "codigo":1264378009,
    "descripcion":"LACERACIÓN DE TENDÓN DE RODILLA"
  },
  {
    "codigo":291801000119104,
    "descripcion":"LESIÓN DE NERVIO TIBIAL IZQUIERDO"
  },
  {
    "codigo":50127006,
    "descripcion":"TENDINITIS TIBIAL"
  },
  {
    "codigo":82895008,
    "descripcion":"ANEMIA MEGALOBLÁSTICA POR ENFERMEDAD DEL INTESTINO DELGADO"
  },
  {
    "codigo":769188001,
    "descripcion":"RETINOPATÍA NO PROLIFERATIVA SEVERA DE OJO IZQUIERDO DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":1162404007,
    "descripcion":"INFECCIÓN DE REGIÓN CERVICODORSAL DE LA COLUMNA VERTEBRAL CAUSADA POR MYCOBACTERIUM TUBERCULOSIS"
  },
  {
    "codigo":81060008,
    "descripcion":"OBSTRUCCIÓN INTESTINAL"
  },
  {
    "codigo":308601002,
    "descripcion":"ESTADO MÉDICO DE CONDUCTOR AÑOSO"
  },
  {
    "codigo":13689005,
    "descripcion":"ANOMALÍA CONGÉNITA DE VÁLVULA AÓRTICA"
  },
  {
    "codigo":210297005,
    "descripcion":"HERIDA ABIERTA DE CONDUCTO AUDITIVO"
  },
  {
    "codigo":44622003,
    "descripcion":"HIPOPLASIA CONGÉNITA DE LA ARTERIA UMBILICAL"
  },
  {
    "codigo":110158007,
    "descripcion":"LESIÓN SUPERFICIAL DEL PALADAR"
  },
  {
    "codigo":1156899002,
    "descripcion":"INMUNIDAD CONTRA DIFTERIA DETERMINADA POR SEROLOGÍA"
  },
  {
    "codigo":763683004,
    "descripcion":"TRASTORNO OVOTESTICULAR 46,XY DEL DESARROLLO SEXUAL"
  },
  {
    "codigo":403235007,
    "descripcion":"FENOTIPO CUTÁNEO V (PIGMENTACIÓN MODERADA)"
  },
  {
    "codigo":1351672002,
    "descripcion":"AGAMMAGLOBULINEMIA AUTOSÓMICA RECESIVA DEBIDA A DEFICIENCIA DE LAMBDA 5"
  },
  {
    "codigo":303096003,
    "descripcion":"DEFICIENCIA DE ENDOPEPTIDASA"
  },
  {
    "codigo":1220600004,
    "descripcion":"LEUCODISTROFIA HIPOMIELINIZANTE AUTOSÓMICA RECESIVA ASOCIADA A GEN RARS"
  },
  {
    "codigo":237560005,
    "descripcion":"RESISTENCIA GENERALIZADA DE LA HORMONA TIROIDEA"
  },
  {
    "codigo":6349000,
    "descripcion":"PROYECCIÓN - MECANISMO DE DEFENSA PSICOLÓGICA"
  },
  {
    "codigo":301261002,
    "descripcion":"PERCUSIÓN TORÁCICA: TONO REPIQUETEANTE"
  },
  {
    "codigo":235725003,
    "descripcion":"MALABSORCIÓN CAUSADA POR AGENTE INFECCIOSO"
  },
  {
    "codigo":1251533006,
    "descripcion":"RADIOGRAFÍA SIMPLE DE ESTRUCTURA ÓSEA DE COSTILLA NORMAL"
  },
  {
    "codigo":397730004,
    "descripcion":"NOTIFICACIÓN DE CIRUGÍA, INADECUADA"
  },
  {
    "codigo":233890005,
    "descripcion":"QUILOPERICARDIO"
  },
  {
    "codigo":347251000119109,
    "descripcion":"DEGENERACIÓN RETICULAR SENIL DE LA RETINA DE AMBOS OJOS"
  },
  {
    "codigo":364962007,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA MOVER LA PUNTA DE LA LENGUA REPETIDAMENTE"
  },
  {
    "codigo":461431000,
    "descripcion":"FALLA DE PRÓTESIS DE VÁLVULA CARDÍACA"
  },
  {
    "codigo":35447004,
    "descripcion":"QUEMADURA DE LA FARINGE"
  },
  {
    "codigo":363127005,
    "descripcion":"TRASTORNO FETAL CAUSADO POR SUSTANCIAS QUÍMICAS"
  },
  {
    "codigo":232055006,
    "descripcion":"RETINITIS PIGMENTARIA LIGADA AL CROMOSOMA X HETEROCIGOTA"
  },
  {
    "codigo":844005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CONDUCTA"
  },
  {
    "codigo":230220006,
    "descripcion":"EMBOLIA SÉPTICA INTRACRANEAL"
  },
  {
    "codigo":262988007,
    "descripcion":"SECCIÓN TRAUMÁTICA DEL TENDÓN DE AQUILES"
  },
  {
    "codigo":295756008,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE CRISANTASPASA"
  },
  {
    "codigo":721740007,
    "descripcion":"INFECCIÓN CAUSADA POR STREPTOCOCCUS ALFA-HEMOLÍTICO"
  },
  {
    "codigo":293921003,
    "descripcion":"ALERGIA A TRIFLUPERIDOL"
  },
  {
    "codigo":424993006,
    "descripcion":"ADENOCARCINOMA DE PULMÓN, ESTADIO IV"
  },
  {
    "codigo":11845031000119102,
    "descripcion":"LACERACIÓN DE ARTERIA SUBCLAVIA DERECHA"
  },
  {
    "codigo":718070001,
    "descripcion":"MEMBRANA MUCOSA BUCAL Y TEJIDO ÓSEO OSTEOINTEGRADO ALREDEDOR DE IMPLANTE DENTAL NORMALES"
  },
  {
    "codigo":64545009,
    "descripcion":"PROTRUSIÓN DE DISPOSITIVO CARDÍACO"
  },
  {
    "codigo":95478002,
    "descripcion":"MENINGOCELE SACRO CONGÉNITO"
  },
  {
    "codigo":292086002,
    "descripcion":"REACCIÓN ADVERSA A LA FENILBUTAZONA"
  },
  {
    "codigo":290251001,
    "descripcion":"INTOXICACIÓN POR FENOPROFENO"
  },
  {
    "codigo":423158009,
    "descripcion":"CARCINOMA TIROIDEO DE CÉLULAS DE HURTHLE"
  },
  {
    "codigo":93643005,
    "descripcion":"MELANOMA MALIGNO DE LA PIEL DE LA NARIZ"
  },
  {
    "codigo":253813000,
    "descripcion":"HÍGADO ECTÓPICO"
  },
  {
    "codigo":288416008,
    "descripcion":"DIFICULTAD PARA DESENROSCAR UNA TAPA"
  },
  {
    "codigo":250143002,
    "descripcion":"CALZADO MUY LARGO"
  },
  {
    "codigo":282911002,
    "descripcion":"DIFICULTAD PARA LEVANTARSE DESDE POSICIÓN DE CUCLILLAS SIN USAR LAS MANOS"
  },
  {
    "codigo":248308002,
    "descripcion":"GRASA CORPORAL DISTRIBUIDA EN FORMA DESIGUAL"
  },
  {
    "codigo":182772006,
    "descripcion":"CONSENTIMIENTO PARA CIRUGÍA OTORGADO"
  },
  {
    "codigo":17097001,
    "descripcion":"ENFERMEDAD RESPIRATORIA CRÓNICA"
  },
  {
    "codigo":1296884009,
    "descripcion":"CON MAYOR RIESGO DE EXPOSICIÓN A ENFERMEDAD TRANSMISIBLE"
  },
  {
    "codigo":1264116009,
    "descripcion":"CARCINOMA ADENOESCAMOSO METASTÁSICO"
  },
  {
    "codigo":770761005,
    "descripcion":"SÍNDROME FALÁNGICO MICROGEÓDICO"
  },
  {
    "codigo":768926005,
    "descripcion":"PERINEUROMA EXTRANEURAL"
  },
  {
    "codigo":308339002,
    "descripcion":"ESTADO DE MÉDICO PACIENTE"
  },
  {
    "codigo":111731002,
    "descripcion":"TRASTORNO DEBIDO A LESIÓN TRAUMÁTICA DE ÓRGANO INTERNO Y DEBIDO A ELLA"
  },
  {
    "codigo":373875003,
    "descripcion":"CAMBIOS CELULARES COMPATIBLES CON HERPES SIMPLE"
  },
  {
    "codigo":404808000,
    "descripcion":"ASMA POR ISOCIANATO"
  },
  {
    "codigo":439411008,
    "descripcion":"ATENDIDO POR ESPECIALISTA EN ENTRENAMIENTO PARA UN ESTILO DE VIDA SALUDABLE"
  },
  {
    "codigo":109896009,
    "descripcion":"INDICACIÓN PARA LA MODIFICACIÓN DEL ESTADO DEL PACIENTE"
  },
  {
    "codigo":1254941001,
    "descripcion":"NEUROPATÍA SENSITIVA AUTÓNOMA HEREDITARIA TIPO IIC"
  },
  {
    "codigo":9757003,
    "descripcion":"REACCIÓN RETARDADA A LA PRUEBA CUTÁNEA"
  },
  {
    "codigo":239133004,
    "descripcion":"ACROPIGMENTACIÓN RETICULADA DE KITAMURA"
  },
  {
    "codigo":402973006,
    "descripcion":"LUPUS VULGAR INDUCIDO POR BCG"
  },
  {
    "codigo":206365006,
    "descripcion":"INFECCIÓN FETAL INTRAMNIÓTICA POR CLOSTRIDIUM"
  },
  {
    "codigo":370205009,
    "descripcion":"ASMA QUE PRODUCE SÍNTOMAS NOCTURNOS 1 O 2 VECES POR MES"
  },
  {
    "codigo":401138005,
    "descripcion":"SÍNDROME DE PENA-SHOKEIR TIPO I"
  },
  {
    "codigo":204530005,
    "descripcion":"MEMBRANA SUBGLÓTICA CONGÉNITA DE LA LARINGE"
  },
  {
    "codigo":827122008,
    "descripcion":"MASA DE ABDOMEN DE FORMA REGULAR"
  },
  {
    "codigo":169927001,
    "descripcion":"PUNTAJE DE APGAR A LOS 10 MINUTOS = 4"
  },
  {
    "codigo":302834008,
    "descripcion":"PARAGANGLIOMA EXTRASUPRARRENAL"
  },
  {
    "codigo":6087002,
    "descripcion":"CÁLCULO DE CONDUCTO HEPÁTICO CON OBSTRUCCIÓN"
  },
  {
    "codigo":237298009,
    "descripcion":"TRANSFUSIÓN MATERNOFETAL"
  },
  {
    "codigo":202695005,
    "descripcion":"ESPONDILOSIS LUMBOSACRA EN DOS NIVELES CON RADICULOPATÍA"
  },
  {
    "codigo":300999006,
    "descripcion":"NEUMONÍA BASAL"
  },
  {
    "codigo":366535007,
    "descripcion":"DISTRIBUCIÓN DE LA PÉRDIDA DE GRASA CORPORAL - HALLAZGO"
  },
  {
    "codigo":725148000,
    "descripcion":"LIQUEN MIXEDEMATOSO ATÍPICO"
  },
  {
    "codigo":102556003,
    "descripcion":"DOLOR EN MIEMBRO SUPERIOR"
  },
  {
    "codigo":299164004,
    "descripcion":"AMPLITUD DE ABDUCCIÓN ACTIVA DEL PULGAR AUMENTADA"
  },
  {
    "codigo":168092006,
    "descripcion":"LÍQUIDO AMNIÓTICO MECONIAL"
  },
  {
    "codigo":199025001,
    "descripcion":"HIPEREMESIS GRAVÍDICA CON TRASTORNO METABÓLICO"
  },
  {
    "codigo":233628009,
    "descripcion":"BRONQUIECTASIA ADQUIRIDA"
  },
  {
    "codigo":231793006,
    "descripcion":"ANOFTALMÍA ADQUIRIDA"
  },
  {
    "codigo":66118000,
    "descripcion":"PH ANORMAL DE LA PIEL"
  },
  {
    "codigo":35185008,
    "descripcion":"ENTESOPATÍA DE REGIÓN DE CODO"
  },
  {
    "codigo":262726002,
    "descripcion":"SECCIÓN DE LA RAÍZ DE NERVIO LUMBAR"
  },
  {
    "codigo":264561009,
    "descripcion":"FIBROMA PERIUNGUEAL"
  },
  {
    "codigo":426566004,
    "descripcion":"SÍNDROME DE DOLOR CENTRAL"
  },
  {
    "codigo":33350003,
    "descripcion":"MENOURIA"
  },
  {
    "codigo":679951000119103,
    "descripcion":"BLEFAROFIMOSIS CONGÉNITA DE HENDIDURA PALPEBRAL IZQUIERDA"
  },
  {
    "codigo":721478005,
    "descripcion":"SÍNDROME DEL CORDÓN POSTERIOR DE MÉDULA ESPINAL AL NIVEL DEL DÉCIMO SEGMENTO DORSAL"
  },
  {
    "codigo":31515003,
    "descripcion":"HIPOVENTILACIÓN"
  },
  {
    "codigo":228123006,
    "descripcion":"NIÑO EN ATENCIÓN FAMILIAR - HALLAZGO"
  },
  {
    "codigo":129819008,
    "descripcion":"HALLAZGO DE UNA CONDUCTA EN LA PAUTA POSOLÓGICA"
  },
  {
    "codigo":293659008,
    "descripcion":"ALERGIA A PANCREATINA"
  },
  {
    "codigo":64283009,
    "descripcion":"FÍSTULA RECTOVESICAL CONGÉNITA"
  },
  {
    "codigo":422896003,
    "descripcion":"MOHO EN EL AMBIENTE"
  },
  {
    "codigo":160752000,
    "descripcion":"NOTIFICACIÓN DE DESALOJO"
  },
  {
    "codigo":1078256006,
    "descripcion":"AGENESIA DE EPÍFISIS DE PRIMER HUESO METATARSIANO"
  },
  {
    "codigo":224453000,
    "descripcion":"SOLICITA LICENCIA POR ENFERMEDAD"
  },
  {
    "codigo":95216009,
    "descripcion":"PSEUDOEXOFORIA"
  },
  {
    "codigo":15998991000119108,
    "descripcion":"INFECCIÓN DE OJO IZQUIERDO CAUSADA POR NEISSERIA GONORRHOEAE"
  },
  {
    "codigo":289989008,
    "descripcion":"CAPAZ DE MANIPULAR ABOTONADURA"
  },
  {
    "codigo":93381009,
    "descripcion":"DESALINEAMIENTO CONGÉNITO DE LA ESTERNEBRA"
  },
  {
    "codigo":419226000,
    "descripcion":"ENFERMEDAD NO NEUROINVASIVA POR VIRUS DEL SEROGRUPO CALIFORNIA"
  },
  {
    "codigo":58778008,
    "descripcion":"PULSO POPLÍTEO NORMAL"
  },
  {
    "codigo":124314009,
    "descripcion":"DEFICIENCIA DE ADENOSINA CINASA"
  },
  {
    "codigo":253551005,
    "descripcion":"DEFECTO RESTRICTIVO DEL TABIQUE INTERVENTRICULAR"
  },
  {
    "codigo":286319006,
    "descripcion":"INCAPAZ DE UTILIZAR COMBINACIONES DE CONSONANTE-VOCAL-CONSONANTE"
  },
  {
    "codigo":56943007,
    "descripcion":"SORDERA A NIVEL DE LA TERMINACIÓN NERVIOSA SENSORIAL"
  },
  {
    "codigo":384623006,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA DISTAL NO AFECTADO POR NEOPLASIA MALIGNA"
  },
  {
    "codigo":1269359007,
    "descripcion":"ESPASMOS EPILÉPTICOS DE INICIO FOCAL"
  },
  {
    "codigo":11768131000119100,
    "descripcion":"AMPUTACIÓN PARCIAL TRAUMÁTICA DE EXTREMIDAD SUPERIOR DERECHA"
  },
  {
    "codigo":135491000119100,
    "descripcion":"MIELOPATÍA DEBIDA A ENFERMEDAD NEOPLÁSICA BENIGNA"
  },
  {
    "codigo":282649001,
    "descripcion":"NO HACE EL PUENTE"
  },
  {
    "codigo":86041002,
    "descripcion":"HIPERTENSIÓN PREEXISTENTE EN EL CONTEXTO OBSTÉTRICO"
  },
  {
    "codigo":11794601000119107,
    "descripcion":"DISTENSIÓN DE MÚSCULO PECTORAL IZQUIERDO"
  },
  {
    "codigo":536621000221101,
    "descripcion":"OCLUSIÓN DE ARTERIA TIBIAL POSTERIOR IZQUIERDA"
  },
  {
    "codigo":249881006,
    "descripcion":"INCAPACIDAD PARA IMITAR LOS MOVIMIENTOS DE LA LENGUA"
  },
  {
    "codigo":315417007,
    "descripcion":"NACIDO EN TIMOR ORIENTAL"
  },
  {
    "codigo":248046000,
    "descripcion":"ESCAPARSE"
  },
  {
    "codigo":410051001,
    "descripcion":"CARNOSINURIA"
  },
  {
    "codigo":704963003,
    "descripcion":"MEDIDAS DE CONTROL DE INFECCIONES ADECUADAS"
  },
  {
    "codigo":277144005,
    "descripcion":"LESIÓN CAUSADA POR BALA DE AMETRALLADORA DE BAJA VELOCIDAD"
  },
  {
    "codigo":10948931000119106,
    "descripcion":"HERIDA PUNZANTE DE BRAZO IZQUIERDO"
  },
  {
    "codigo":1260184008,
    "descripcion":"TATUAJE DE PIEL DE REGIÓN PERIORAL DE LA CARA"
  },
  {
    "codigo":308077000,
    "descripcion":"SENSACIÓN DE PINCHAZO EN EL PIE IZQUIERDO NORMAL"
  },
  {
    "codigo":735896009,
    "descripcion":"LACERACIÓN DE ARTERIA PEDIA"
  },
  {
    "codigo":373613000,
    "descripcion":"LIMPIA SUS AGUJAS"
  },
  {
    "codigo":111469006,
    "descripcion":"ENFERMEDAD HEMOLÍTICA DEL RECIÉN NACIDO POR ISOINMUNIZACIÓN NO ABO, NO RH"
  },
  {
    "codigo":240706001,
    "descripcion":"INFECCIÓN DE LA REGIÓN GENITAL POR CANDIDA"
  },
  {
    "codigo":207938004,
    "descripcion":"FRACTURA NO EXPUESTA DE VÉRTEBRA DORSAL"
  },
  {
    "codigo":699458005,
    "descripcion":"HIPERTROFIA DE MÚSCULO MASTICATORIO"
  },
  {
    "codigo":109634006,
    "descripcion":"MALA OCLUSIÓN DEBIDA A MASTICACIÓN DE PARTES BLANDAS INTRABUCALES"
  },
  {
    "codigo":764994007,
    "descripcion":"MIOPATÍA CON MATRICES TUBULARES RETICULADAS HEXAGONALES"
  },
  {
    "codigo":238871000,
    "descripcion":"METAGERIA"
  },
  {
    "codigo":402711009,
    "descripcion":"SÍNDROME DE SUPERPOSICIÓN CON LUPUS ERITEMATOSO"
  },
  {
    "codigo":237036002,
    "descripcion":"ABORTADORA HABITUAL - NO EMBARAZADA"
  },
  {
    "codigo":40428002,
    "descripcion":"RONQUIDO SIBILANTE"
  },
  {
    "codigo":1254679009,
    "descripcion":"ENVENENAMIENTO DEBIDO A MORDEDURA DE HORMIGA DE FUEGO"
  },
  {
    "codigo":1285612005,
    "descripcion":"HEMATOMA DE GLÚTEO"
  },
  {
    "codigo":38593000,
    "descripcion":"ATAQUES CIANÓTICOS DEL RECIÉN NACIDO"
  },
  {
    "codigo":204268008,
    "descripcion":"FÍSTULA BRANQUIAL"
  },
  {
    "codigo":726721002,
    "descripcion":"LINFOMA GANGLIONAR DE LINFOCITOS B DE LA ZONA MARGINAL"
  },
  {
    "codigo":366273005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD DE ORINAR"
  },
  {
    "codigo":267969005,
    "descripcion":"ESPONDILOSIS Y TRASTORNOS AFINES"
  },
  {
    "codigo":169665005,
    "descripcion":"ECOGRAFÍA PRENATAL ANORMAL"
  },
  {
    "codigo":36758002,
    "descripcion":"EFECTO TARDÍO DE LA FRACTURA DE LAS EXTREMIDADES INFERIORES"
  },
  {
    "codigo":397206002,
    "descripcion":"LATERALIDAD DEL ESPÉCIMEN, NO ESPECIFICADA"
  },
  {
    "codigo":724886002,
    "descripcion":"LACERACIÓN DE MÚSCULO DEL TÓRAX"
  },
  {
    "codigo":682461000119109,
    "descripcion":"ASTROCITOMA PRIMARIO DE LÓBULO OCCIPITAL"
  },
  {
    "codigo":429974006,
    "descripcion":"FÍSTULA DE PALADAR BLANDO"
  },
  {
    "codigo":297067002,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE INHIBIDOR DE LA FOSFODIESTERASA"
  },
  {
    "codigo":42111000175103,
    "descripcion":"ENFERMEDAD AUTOINFLAMATORIA"
  },
  {
    "codigo":34923007,
    "descripcion":"VÓMITO AUTOINDUCIDO"
  },
  {
    "codigo":196928001,
    "descripcion":"HERNIA LUMBAR IRREDUCTIBLE"
  },
  {
    "codigo":231531009,
    "descripcion":"PATOMIMIA DERMATOLÓGICA"
  },
  {
    "codigo":320003,
    "descripcion":"DILATACIÓN CERVICAL, 1CM"
  },
  {
    "codigo":29311000175108,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN DE GLÚTEO IZQUIERDO GRADO 4"
  },
  {
    "codigo":426304000,
    "descripcion":"LESIÓN PENETRANTE CAUSADA POR FLECHA"
  },
  {
    "codigo":295232005,
    "descripcion":"SOBREDOSIS INTENCIONAL DE ETODOLAC"
  },
  {
    "codigo":293397002,
    "descripcion":"REACCIÓN ADVERSA A LA CIANOCOBALAMINA"
  },
  {
    "codigo":1145365009,
    "descripcion":"LESIÓN HIPOAUTOFLUORESCENTE DE RETINA"
  },
  {
    "codigo":291562005,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR CEFALEXINA"
  },
  {
    "codigo":29418006,
    "descripcion":"QUEMADURA EPIDÉRMICA DE PALMA DE LA MANO"
  },
  {
    "codigo":1141695000,
    "descripcion":"DEMUESTRA CONOCIMIENTO SOBRE ANALGESIA CONTROLADA POR EL PACIENTE"
  },
  {
    "codigo":1010623000,
    "descripcion":"TRASTORNO PULMONAR POR VASCULITIS POR IGA"
  },
  {
    "codigo":94954008,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL MIOCARDIO"
  },
  {
    "codigo":289727001,
    "descripcion":"CONTRACCIONES UTERINAS EFECTIVAS"
  },
  {
    "codigo":93119006,
    "descripcion":"FALTA DE OSIFICACIÓN DE HUESO ESCAMOSO"
  },
  {
    "codigo":224191006,
    "descripcion":"INGRESO INSUFICIENTE PARA SATISFACER LAS NECESIDADES"
  },
  {
    "codigo":1172628002,
    "descripcion":"SÍNDROME DE DISCAPACIDAD INTELECTUAL ASOCIADA AL GEN TBCK"
  },
  {
    "codigo":255124004,
    "descripcion":"METÁSTASIS A NERVIO PERIFÉRICO"
  },
  {
    "codigo":124052004,
    "descripcion":"GANGLIÓSIDO POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":286057000,
    "descripcion":"NO LAVA LA ROPA EN SECO"
  },
  {
    "codigo":253289001,
    "descripcion":"AURÍCULA IZQUIERDA COMUNICADA CON VENTRÍCULO DE MORFOLOGÍA INDETERMINADA"
  },
  {
    "codigo":23913003,
    "descripcion":"HEMORROIDES EXTERNAS"
  },
  {
    "codigo":56681004,
    "descripcion":"TRASTORNO CEREBRAL"
  },
  {
    "codigo":89449005,
    "descripcion":"AMILOIDOSIS SISTÉMICA"
  },
  {
    "codigo":449897004,
    "descripcion":"SÍNDROME DE CONDUCTO DE LOS ADUCTORES"
  },
  {
    "codigo":87614000,
    "descripcion":"PINGUÉCULA"
  },
  {
    "codigo":415294003,
    "descripcion":"ESTADO RESPIRATORIO IGUAL O MEJORADO CON RESPECTO AL ESTADO PREQUIRÚRGICO"
  },
  {
    "codigo":251454008,
    "descripcion":"DESCARGAS ELECTROENCEFALOGRÁFICAS RÍTMICAS SUBCLÍNICAS EN ADULTOS"
  },
  {
    "codigo":446227001,
    "descripcion":"LACERACIÓN SUPERFICIAL DE MIEMBRO INFERIOR"
  },
  {
    "codigo":284222008,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO DE LOS GENITALES"
  },
  {
    "codigo":448062009,
    "descripcion":"DEFECTO DEL TABIQUE INTERVENTRICULAR CON MALA ALINEACIÓN DEL TABIQUE CORRESPONDIENTE AL TRACTO DE SALIDA"
  },
  {
    "codigo":38331000087100,
    "descripcion":"HIPOCINESIA DE MIOCARDIO DE REGIÓN INFEROSEPTAL DE VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":20243008,
    "descripcion":"NÓDULO DE BOUCHARD"
  },
  {
    "codigo":870376001,
    "descripcion":"REACCIÓN ADVERSA A AGONISTA DE RECEPTOR DE DOPAMINA"
  },
  {
    "codigo":184083009,
    "descripcion":"PACIENTE RECLUIDO EN UNA INSTITUCIÓN - PERMANENTEMENTE"
  },
  {
    "codigo":48571000087106,
    "descripcion":"FRACTURA DE MALÉOLO EXTERNO DE PERONÉ DERECHO"
  },
  {
    "codigo":772072004,
    "descripcion":"FRAGMENTO RETENIDO DE SONDA URETRAL"
  },
  {
    "codigo":43451000087107,
    "descripcion":"HERIDA ABIERTA DE ANEXOS OCULARES IZQUIERDOS"
  },
  {
    "codigo":40891000087105,
    "descripcion":"QUEMADURA DE GLÚTEO IZQUIERDO"
  },
  {
    "codigo":330821000119100,
    "descripcion":"XERODERMIA DE PÁRPADO SUPERIOR DERECHO"
  },
  {
    "codigo":51176008,
    "descripcion":"INFESTACIÓN CAUSADA POR WOHLFAHRTIA"
  },
  {
    "codigo":409789001,
    "descripcion":"ENFERMEDAD CAUSADA POR COCOS GRAMNEGATIVOS"
  },
  {
    "codigo":247784003,
    "descripcion":"OPTIMISMO EXCESIVO"
  },
  {
    "codigo":16573007,
    "descripcion":"AMILOIDOSIS CARDÍACA SENIL"
  },
  {
    "codigo":49341008,
    "descripcion":"CÁLCULO DE CONDUCTO CÍSTICO CON COLECISTITIS"
  },
  {
    "codigo":213181007,
    "descripcion":"FALLA TOTAL DE REIMPLANTE DE MANO"
  },
  {
    "codigo":1259922002,
    "descripcion":"TRASTORNO FETAL DEBIDO A MALA PRESENTACIÓN DURANTE PRE-TRABAJO DE PARTO"
  },
  {
    "codigo":276882005,
    "descripcion":"INFECCIÓN DE TROMPA DE FALOPIO"
  },
  {
    "codigo":735634006,
    "descripcion":"EYACULACIÓN TARDÍA SITUACIONAL PERMANENTE"
  },
  {
    "codigo":12903001,
    "descripcion":"CURVATURA ADQUIRIDA DE LA COLUMNA VERTEBRAL"
  },
  {
    "codigo":406119002,
    "descripcion":"DEDO DEL PIE-HALLAZGO"
  },
  {
    "codigo":1290855007,
    "descripcion":"MIXOFIBROSARCOMA EPITELIOIDE"
  },
  {
    "codigo":15649861000119105,
    "descripcion":"ANEURISMA DE ARTERIA DE MIEMBRO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":764732004,
    "descripcion":"SÍNDROME DE MICROCEFALIA, HIPOPLASIA DE CEREBELO Y DEFECTO DE CONDUCCIÓN CARDÍACA"
  },
  {
    "codigo":762897000,
    "descripcion":"TUMEFACCIÓN DE MIEMBRO INFERIOR DERECHO"
  },
  {
    "codigo":240444009,
    "descripcion":"AMIGDALITIS NECROSANTE FUSOBACTERIANA"
  },
  {
    "codigo":238609000,
    "descripcion":"PSORIASIS DE KÖBNER"
  },
  {
    "codigo":109372009,
    "descripcion":"NEOPLASIA BENIGNA DEL TEJIDO MESOTELIAL DE LA PLEURA"
  },
  {
    "codigo":9233004,
    "descripcion":"TOXICIDAD POR PIRIDOXINA"
  },
  {
    "codigo":369681003,
    "descripcion":"MARGEN MESENTÉRICO DE RESECCIÓN QUIRÚRGICA DE ESTÓMAGO, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":74769007,
    "descripcion":"ANOMALÍA DEL PAR DE CROMOSOMAS 1"
  },
  {
    "codigo":72934000,
    "descripcion":"CANDIDIASIS DE LA VAGINA"
  },
  {
    "codigo":402449009,
    "descripcion":"EPIDERMÓLISIS BULLOSA ADQUIRIDA, TIPO PENFIGOIDE CICATRIZAL"
  },
  {
    "codigo":105702001,
    "descripcion":"ENFERMEDAD CAUSADA POR OXYUROIDEA"
  },
  {
    "codigo":11717701000119108,
    "descripcion":"AUMENTO DE PESO LENTO"
  },
  {
    "codigo":204006004,
    "descripcion":"ESPINA BÍFIDA SACRA SIN HIDROCEFALIA - ABIERTA"
  },
  {
    "codigo":236774005,
    "descripcion":"QUISTE DE TESTÍCULO Y EPIDÍDIMO"
  },
  {
    "codigo":1187046005,
    "descripcion":"SÍNDROME DE AICARDI GOUTIERES TIPO 2"
  },
  {
    "codigo":10626271000119103,
    "descripcion":"CARBUNCO DE ANTEBRAZO DERECHO"
  },
  {
    "codigo":300475002,
    "descripcion":"HALLAZGO RELACIONADO CON MEDICIONES DE LA DIURESIS"
  },
  {
    "codigo":366011005,
    "descripcion":"HALLAZGO RELACIONADO CON LA TOLERANCIA DE LA TEMPERATURA AMBIENTE"
  },
  {
    "codigo":71099008,
    "descripcion":"VIVIR EN CONDICIONES SANITARIAS INAPROPIADAS"
  },
  {
    "codigo":724624004,
    "descripcion":"PROBLEMA DE HOMBRO"
  },
  {
    "codigo":16032991000119106,
    "descripcion":"NECROSIS AVASCULAR DE AMBOS PERONÉS"
  },
  {
    "codigo":15678841000119100,
    "descripcion":"IRIDOCICLITIS BILATERAL POR HERPES ZÓSTER"
  },
  {
    "codigo":167568007,
    "descripcion":"CULTIVO DE ORINA: AUSENCIA DE CRECIMIENTO"
  },
  {
    "codigo":296805002,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE FÁRMACO ANTILEPROSO"
  },
  {
    "codigo":395109004,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: CURDO"
  },
  {
    "codigo":1279845005,
    "descripcion":"DEFICIENCIA COMBINADA DE LA FOSFORILACIÓN OXIDATIVA TIPO 39"
  },
  {
    "codigo":720954000,
    "descripcion":"SÍNDROME DE FILIPPI"
  },
  {
    "codigo":131130000,
    "descripcion":"BIOTINA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":196666001,
    "descripcion":"ÚLCERA DUODENAL CRÓNICA CON OBSTRUCCIÓN"
  },
  {
    "codigo":294970008,
    "descripcion":"ALERGIA A INHIBIDOR DE 3-HIDROXI-3-METILGLUTARIL COENZIMA A REDUCTASA"
  },
  {
    "codigo":293135002,
    "descripcion":"REACCIÓN ADVERSA AL GLUCAGÓN"
  },
  {
    "codigo":1145103009,
    "descripcion":"PESTAÑAS PROMINENTES"
  },
  {
    "codigo":1208804002,
    "descripcion":"ALERGIA A PROTEÍNA DE CLASE AVES"
  },
  {
    "codigo":291300003,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR METARAMINOL"
  },
  {
    "codigo":125625000,
    "descripcion":"LESIÓN TRAUMÁTICA DE LOS INTESTINOS"
  },
  {
    "codigo":92857001,
    "descripcion":"FUSIÓN ANORMAL CONGÉNITA DE HUESO FRONTAL"
  },
  {
    "codigo":10901011000119101,
    "descripcion":"RUPTURA DE GLOBO OCULAR DERECHO"
  },
  {
    "codigo":1338041004,
    "descripcion":"SIBILANCIAS QUE SE ALIVIAN AL TOSER"
  },
  {
    "codigo":191161006,
    "descripcion":"ANEMIA POR DÉFICIT DE VITAMINA C"
  },
  {
    "codigo":16907641000119108,
    "descripcion":"NEVO DISPLÁSICO DE PIEL DE PÁRPADO SUPERIOR DERECHO"
  },
  {
    "codigo":1336206001,
    "descripcion":"MUTACIÓN DE PROMOTOR"
  },
  {
    "codigo":713614001,
    "descripcion":"ENFERMEDAD POR STREPTOCOCCUS PNEUMONIAE RESISTENTE"
  },
  {
    "codigo":123790009,
    "descripcion":"TRASTORNO EN EL PROCESO DE COAGULACIÓN SANGUÍNEA CON DISMINUCIÓN DEL TIEMPO DE RETRACCIÓN DEL COÁGULO"
  },
  {
    "codigo":56419002,
    "descripcion":"ENFERMEDAD CAUSADA POR ORBIVIRUS"
  },
  {
    "codigo":254862009,
    "descripcion":"TUMOR BENIGNO DEL CORDÓN SEXUAL DEL OVARIO"
  },
  {
    "codigo":449635006,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE PIERNA"
  },
  {
    "codigo":447800002,
    "descripcion":"ADENOCARCINOMA DE ESCROTO"
  },
  {
    "codigo":283960003,
    "descripcion":"CUERPO EXTRAÑO EN TROMPA DE FALOPIO"
  },
  {
    "codigo":87352006,
    "descripcion":"HIDROCELE DE CONDUCTO DE NUCK"
  },
  {
    "codigo":413197000,
    "descripcion":"CÁLCULO DE MUÑÓN DEL CÍSTICO"
  },
  {
    "codigo":773645004,
    "descripcion":"GIGANTISMO INFANTIL FAMILIAR"
  },
  {
    "codigo":314893005,
    "descripcion":"ARTROPATÍA DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":249357006,
    "descripcion":"TABIQUE NASAL - HALLAZGO"
  },
  {
    "codigo":445965007,
    "descripcion":"HIPERPLASIA DE FOSA GÁSTRICA"
  },
  {
    "codigo":11857581000119102,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA DE TENDÓN DE MÚSCULO PERONEO DERECHO"
  },
  {
    "codigo":52749004,
    "descripcion":"INTERRUPCIÓN PARCIAL DE LA ESPERMATOGENIA"
  },
  {
    "codigo":216589008,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ACETILCOLINA"
  },
  {
    "codigo":247522004,
    "descripcion":"HALLAZGO DE PELO"
  },
  {
    "codigo":306861000119103,
    "descripcion":"DERRAME DE ARTICULACIÓN DE PIE IZQUIERDO"
  },
  {
    "codigo":15953581000119103,
    "descripcion":"OCLUSIÓN DE CONDUCTO GALACTÓFORO DE MAMA DERECHA"
  },
  {
    "codigo":278455000,
    "descripcion":"DESVIACIÓN OCULAR EN RESPUESTA AL SONIDO"
  },
  {
    "codigo":704439001,
    "descripcion":"DIFICULTAD PARA REALIZAR ACTIVIDAD DE ACICALAMIENTO PERSONAL"
  },
  {
    "codigo":212919006,
    "descripcion":"CONGELAMIENTO SUPERFICIAL DE LA PARED ABDOMINAL, REGIÓN LUMBAR Y PELVIS"
  },
  {
    "codigo":276620002,
    "descripcion":"CIANOSIS FACIAL TRAUMÁTICA NEONATAL"
  },
  {
    "codigo":243852002,
    "descripcion":"SITUACIÓN DEL MONITOREO DE ENFERMEDAD CARDÍACA"
  },
  {
    "codigo":702604009,
    "descripcion":"OSTEOCONDROSIS DE CABEZA DE SEGUNDO METATARSIANO"
  },
  {
    "codigo":405857006,
    "descripcion":"FENOTIPO JK(A-)"
  },
  {
    "codigo":209249008,
    "descripcion":"FRACTURA-SUBLUXACIÓN EXPUESTA DE ARTICULACIÓN ACROMIOCLAVICULAR"
  },
  {
    "codigo":1290593009,
    "descripcion":"LESIÓN TRAUMÁTICA DE PARÉNQUIMA ENCEFÁLICO"
  },
  {
    "codigo":830006002,
    "descripcion":"AUSENCIA DE SENSIBILIDAD VIBRATORIA DE PIE DERECHO"
  },
  {
    "codigo":338486003,
    "descripcion":"QUEILOGNATOURANOSQUISIS"
  },
  {
    "codigo":373089009,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE CUADRANTE SUPEROINTERNO DE MAMA"
  },
  {
    "codigo":10684231000119103,
    "descripcion":"NÓDULO DE PIEL DE DEDO DE MANO DERECHA"
  },
  {
    "codigo":21191000122102,
    "descripcion":"ALERGIA A CONDIMENTO DE MOSTAZA"
  },
  {
    "codigo":1255990007,
    "descripcion":"RUPTURA TRAUMÁTICA DE LIGAMENTO DE ARTICULACIÓN DE DEDO MEDIO DE MANO"
  },
  {
    "codigo":305718005,
    "descripcion":"VISTO POR EL CIRUJANO HEPATOBILIAR"
  },
  {
    "codigo":240182009,
    "descripcion":"OSTEOCONDRITIS DE LA CABEZA FEMORAL"
  },
  {
    "codigo":698934009,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: ÍDISH"
  },
  {
    "codigo":2053831000122108,
    "descripcion":"INSUFICIENCIA HEPÁTICA REAGUDIZADA"
  },
  {
    "codigo":13511000122108,
    "descripcion":"ALERGIA A ANANÁ"
  },
  {
    "codigo":402187005,
    "descripcion":"DERMATITIS ATÓPICA CON PATRÓN DE PRURIGO"
  },
  {
    "codigo":762635007,
    "descripcion":"PROBLEMA DE PRESERVATIVO ANTICONCEPTIVO"
  },
  {
    "codigo":41739008,
    "descripcion":"PERICARDITIS INFECCIOSA"
  },
  {
    "codigo":8971008,
    "descripcion":"PSICALGIA"
  },
  {
    "codigo":236512004,
    "descripcion":"INFILTRADO LEUCÉMICO DEL RIÑÓN"
  },
  {
    "codigo":302048009,
    "descripcion":"DIFICULTAD PARA SENTARSE SIN SOSTÉN"
  },
  {
    "codigo":726197002,
    "descripcion":"LACERACIÓN DE FASCIA DE MÚSCULO INTRÍNSECO DEL PULGAR"
  },
  {
    "codigo":300213004,
    "descripcion":"RESPONDE A LOS SONIDOS DE FRECUENCIA BAJA"
  },
  {
    "codigo":298378000,
    "descripcion":"HALLAZGO EN LA REGIÓN DEL CUELLO"
  },
  {
    "codigo":429450002,
    "descripcion":"TRASTORNO RELACIONADO CON TRASPLANTE DE MÉDULA ÓSEA"
  },
  {
    "codigo":335841000119103,
    "descripcion":"CATARATA NUCLEAR CONGÉNITA DE OJO DERECHO"
  },
  {
    "codigo":722527003,
    "descripcion":"NEOPLASIA MALIGNA NEUROENDOCRINA PRIMARIA DE BRONQUIO"
  },
  {
    "codigo":1073121000119104,
    "descripcion":"ARTRITIS ESTREPTOCÓCICA DE MANO DERECHA"
  },
  {
    "codigo":67167008,
    "descripcion":"URETROTRIGONITIS"
  },
  {
    "codigo":65332001,
    "descripcion":"DIVERTICULITIS DE VEJIGA URINARIA"
  },
  {
    "codigo":296543008,
    "descripcion":"SOBREDOSIS DE NISTATINA"
  },
  {
    "codigo":8161000119106,
    "descripcion":"ARTRITIS CONCOMITANTE CON ENFERMEDAD DE CROHN Y DEBIDA A ELLA"
  },
  {
    "codigo":784393004,
    "descripcion":"INMUNODEFICIENCIA DE COMIENZO EN LA VIDA ADULTA CON AUTOANTICUERPOS ANTI-INTERFERÓN GAMMA"
  },
  {
    "codigo":292873005,
    "descripcion":"REACCIÓN ADVERSA AL TIMOL"
  },
  {
    "codigo":129033007,
    "descripcion":"ASISTENCIA PARA ALIMENTARSE"
  },
  {
    "codigo":1144841008,
    "descripcion":"CAPAZ DE CUIDAR"
  },
  {
    "codigo":94430006,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE MÚSCULO DEL TRONCO"
  },
  {
    "codigo":225502007,
    "descripcion":"SE EXPRESA A TRAVÉS DEL ESTILO DE LA VESTIMENTA"
  },
  {
    "codigo":127198008,
    "descripcion":"LINFADENOPATÍA DE LA EXTREMIDAD INFERIOR"
  },
  {
    "codigo":782558006,
    "descripcion":"ALERGIA A INMUNOGLOBULINA CONTRA ANTÍGENO DE SUPERFICIE DE HEPATITIS B"
  },
  {
    "codigo":27059002,
    "descripcion":"HIPOTIROIDISMO POSTQUIRÚRGICO"
  },
  {
    "codigo":289203002,
    "descripcion":"HALLAZGO RELACIONADO CON LAS CARACTERÍSTICAS DEL EMBARAZO"
  },
  {
    "codigo":16737621000119100,
    "descripcion":"EDEMA POSPARTO"
  },
  {
    "codigo":87381000119101,
    "descripcion":"DOLOR DE ARTICULACIÓN VERTEBRAL"
  },
  {
    "codigo":92501000119101,
    "descripcion":"REACCIÓN DE ESTRÉS CON AGITACIÓN PSICOMOTRIZ"
  },
  {
    "codigo":1080661000119102,
    "descripcion":"LIPOMA DE MIEMBRO SUPERIOR DERECHO"
  },
  {
    "codigo":46421000119102,
    "descripcion":"TRASTORNO DEL COMPORTAMIENTO COMO SECUELA DE INFARTO CEREBRAL"
  },
  {
    "codigo":683861000119103,
    "descripcion":"NEVO EPIDÉRMICO DE PIEL DE LABIO"
  },
  {
    "codigo":333141000119106,
    "descripcion":"DACRIOCISTITIS FLEMONOSA DE OJO DERECHO"
  },
  {
    "codigo":310101000119107,
    "descripcion":"GOTA PRIMARIA CRÓNICA SIN TOFO"
  },
  {
    "codigo":97621000119107,
    "descripcion":"ÚLCERA POR ESTASIS DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":11812181000119101,
    "descripcion":"LESIÓN TRAUMÁTICA PRIMARIA DE YEYUNO POR EXPLOSIÓN"
  },
  {
    "codigo":72021000119109,
    "descripcion":"DERMOPATÍA DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":575462741000119102,
    "descripcion":"EDEMA CEREBELOSO NO TRAUMÁTICO"
  },
  {
    "codigo":11817301000119105,
    "descripcion":"ESGUINCE DE LIGAMENTO DE ARTICULACIÓN ESTERNOCLAVICULAR IZQUIERDA"
  },
  {
    "codigo":1085781000119107,
    "descripcion":"OBSTRUCCIÓN INTESTINAL DEBIDA A ENFERMEDAD DE CROHN DEL INTESTINO GRUESO"
  },
  {
    "codigo":1137501002,
    "descripcion":"DEBILIDAD MUSCULAR GENERALIZADA"
  },
  {
    "codigo":309371000119107,
    "descripcion":"NECROSIS AVASCULAR DE CLAVÍCULA DERECHA"
  },
  {
    "codigo":15954261000119107,
    "descripcion":"NECROSIS ADIPOSA DE MAMA IZQUIERDA"
  },
  {
    "codigo":348501000119108,
    "descripcion":"ATROFIA DE NERVIO ÓPTICO IZQUIERDO DESPUÉS DE INFLAMACIÓN"
  },
  {
    "codigo":285533003,
    "descripcion":"NO MUEVE LA LÁMINA DE LA LENGUA"
  },
  {
    "codigo":57992009,
    "descripcion":"INFECCIÓN CAUSADA POR TRICHOBILHARZIA PHYSELLAE"
  },
  {
    "codigo":283698000,
    "descripcion":"MORDEDURA HUMANA EN EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":416605008,
    "descripcion":"OBSTRUCCIÓN ADQUIRIDA DEL PÍLORO"
  },
  {
    "codigo":414770006,
    "descripcion":"INMUNOGLOBULINA E MONOCLONAL DETECTADA"
  },
  {
    "codigo":185394009,
    "descripcion":"PACIENTE NO ATENDIDO DURANTE UN PERÍODO SUPERIOR A CINCO AÑOS"
  },
  {
    "codigo":609543001,
    "descripcion":"HIPERSENSIBILIDAD NO ALÉRGICA A PERINDOPRIL"
  },
  {
    "codigo":19719003,
    "descripcion":"INFILTRACIÓN LINFOCÍTICA BENIGNA DE JESSNER"
  },
  {
    "codigo":707847004,
    "descripcion":"DESEQUILIBRIO EN LA INGESTA DE NUTRIENTES"
  },
  {
    "codigo":249095005,
    "descripcion":"POSICIÓN FRONTAL POSTERIOR (DEL FETO)"
  },
  {
    "codigo":10686741000119105,
    "descripcion":"MELANOMA MALIGNO DE PIEL DE MANO IZQUIERDA"
  },
  {
    "codigo":314631008,
    "descripcion":"MENOMETRORRAGIA"
  },
  {
    "codigo":247260007,
    "descripcion":"GRANULACIONES EN MEMBRANA TIMPÁNICA"
  },
  {
    "codigo":704177001,
    "descripcion":"FRACTURA NO EXPUESTA DE SEGUNDO METACARPIANO"
  },
  {
    "codigo":1259398000,
    "descripcion":"CARCINOMA PRIMARIO DE CIEGO"
  },
  {
    "codigo":702342007,
    "descripcion":"DISPLASIA DOLICOESPONDÍLICA"
  },
  {
    "codigo":700507000,
    "descripcion":"MIEMBRO FANTASMA SUPERNUMERARIO"
  },
  {
    "codigo":276358008,
    "descripcion":"VE ARCO IRIS"
  },
  {
    "codigo":733275005,
    "descripcion":"MÚLTIPLES HERIDAS ABIERTAS DE MUSLO"
  },
  {
    "codigo":274523007,
    "descripcion":"ELECTROMIOGRAMA ANORMAL"
  },
  {
    "codigo":1255728000,
    "descripcion":"GRANULOMA DE HODGKIN DE GANGLIOS LINFÁTICOS DE CABEZA Y CUELLO"
  },
  {
    "codigo":698672002,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: MALAYO"
  },
  {
    "codigo":305456005,
    "descripcion":"BAJO ATENCIÓN DE SU MÉDICO GENERAL"
  },
  {
    "codigo":239920006,
    "descripcion":"ENFERMEDAD DE STILL DE INICIO EN LA EDAD ADULTA"
  },
  {
    "codigo":370992007,
    "descripcion":"DISLIPIDEMIA"
  },
  {
    "codigo":403760006,
    "descripcion":"SÍNDROME XXYY"
  },
  {
    "codigo":15712841000119100,
    "descripcion":"INFARTO AGUDO DE PARED POSTEROLATERAL DE MIOCARDIO CON ELEVACIÓN DE SEGMENTO ST"
  },
  {
    "codigo":860677002,
    "descripcion":"EMBOLIA DE LÍQUIDO AMNIÓTICO DEBIDA A EMBARAZO ECTÓPICO Y POSTERIOR A ÉL"
  },
  {
    "codigo":11862601000119101,
    "descripcion":"HERIDA DE TOBILLO DERECHO DEBIDA A PICADURA DE INSECTO NO VENENOSO"
  },
  {
    "codigo":205317004,
    "descripcion":"BRAQUIMESOFALANGIA"
  },
  {
    "codigo":762373004,
    "descripcion":"PÉRDIDA DE TEJIDO DE OJO DERECHO CONCOMITANTE CON RUPTURA"
  },
  {
    "codigo":74245009,
    "descripcion":"AUSENCIA CONGÉNITA DEL PERONÉ"
  },
  {
    "codigo":238085009,
    "descripcion":"HIPERLIPOPROTEINEMIA DE FREDRICKSON TIPO IV"
  },
  {
    "codigo":39642007,
    "descripcion":"TIFLITIS AGUDA CON PERFORACIÓN Y PERITONITIS"
  },
  {
    "codigo":6874009,
    "descripcion":"QUERATODERMIA CONGÉNITA"
  },
  {
    "codigo":365487001,
    "descripcion":"HALLAZGO RELACIONADO CON LA PROVISIÓN DE AYUDA DOMICILIARIA"
  },
  {
    "codigo":1184687004,
    "descripcion":"AUSENCIA DE APOYO FAMILIAR"
  },
  {
    "codigo":371976008,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA MUCOSA YUGAL"
  },
  {
    "codigo":134276005,
    "descripcion":"LEE POLACO"
  },
  {
    "codigo":429188006,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR MEDIO DE CONTRASTE ORAL"
  },
  {
    "codigo":363652006,
    "descripcion":"VÍCTIMA DE BIOTERRORISMO"
  },
  {
    "codigo":296281004,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE REMOXIPRIDA"
  },
  {
    "codigo":11780681000119108,
    "descripcion":"CONTUSIÓN DE CODO IZQUIERDO"
  },
  {
    "codigo":230745008,
    "descripcion":"HIDROCEFALIA"
  },
  {
    "codigo":720430002,
    "descripcion":"DISOSTOSIS ACROFACIAL TIPO RODRIGUEZ"
  },
  {
    "codigo":1144579005,
    "descripcion":"APLASIA DE MÚSCULO DE PARED ABDOMINAL"
  },
  {
    "codigo":423683008,
    "descripcion":"MIGRAÑA REFRACTARIA CON AURA"
  },
  {
    "codigo":1306584001,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ADHESIVO"
  },
  {
    "codigo":94168000,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA PORCIÓN ANTERIOR DEL PISO DE LA BOCA"
  },
  {
    "codigo":290776004,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR CICLOSPORINA"
  },
  {
    "codigo":61400006,
    "descripcion":"PSEUDOTUMOR INFLAMATORIO DE COLON"
  },
  {
    "codigo":26797002,
    "descripcion":"HIPEREMIA DE VEJIGA URINARIA"
  },
  {
    "codigo":288941008,
    "descripcion":"CAPAZ DE TRAGAR COMIDA"
  },
  {
    "codigo":92333008,
    "descripcion":"NEOPLASIA BENIGNA DE LOS GANGLIOS LINFÁTICOS ESCALENOS"
  },
  {
    "codigo":188802006,
    "descripcion":"TUMOR BENIGNO DE LA BOLSA FARÍNGEA"
  },
  {
    "codigo":287106008,
    "descripcion":"ASTILLA CLAVADA EN LA CARA"
  },
  {
    "codigo":24962009,
    "descripcion":"ANEMIA POR DEFICIENCIA DE VITAMINA E"
  },
  {
    "codigo":449111002,
    "descripcion":"DOBLE ORIFICIO DE VÁLVULA AURICULOVENTRICULAR DERECHA EN VENTRÍCULO CON DOBLE TRACTO DE ENTRADA"
  },
  {
    "codigo":285271005,
    "descripcion":"PLANES DE AGRESIÓN"
  },
  {
    "codigo":840492002,
    "descripcion":"MICROFTALMÍA CONCOMITANTE CON COLOBOMA OCULAR CONGÉNITO DE AMBOS OJOS"
  },
  {
    "codigo":194891000112100,
    "descripcion":"TRASTORNO ASOCIADO CON MALLA QUIRÚRGICA"
  },
  {
    "codigo":283436006,
    "descripcion":"CORTE DE ESPINILLA"
  },
  {
    "codigo":19457002,
    "descripcion":"CELULITIS DE LA AXILA"
  },
  {
    "codigo":248833006,
    "descripcion":"CONDUCTO GALACTÓFORO PROMINENTE"
  },
  {
    "codigo":707585008,
    "descripcion":"CARCINOMA PRIMARIO DE CÉLULAS ESCAMOSAS DE OROFARINGE"
  },
  {
    "codigo":1197270001,
    "descripcion":"PAPILOMA DE CÉLULAS ESCAMOSAS DE ESÓFAGO"
  },
  {
    "codigo":11809661000119109,
    "descripcion":"HERIDA INFECTADA DE RODILLA DERECHA DEBIDA A PICADURA DE INSECTO NO VENENOSO"
  },
  {
    "codigo":50390006,
    "descripcion":"ORQUITIS GRANULOMATOSA INESPECÍFICA"
  },
  {
    "codigo":246998009,
    "descripcion":"PRECIPITADOS QUERÁTICOS"
  },
  {
    "codigo":81323004,
    "descripcion":"FUNCIÓN CORPORAL NORMAL"
  },
  {
    "codigo":79488001,
    "descripcion":"DEFECTO EN EL TRANSPORTE DE MEMBRANA DE TIROXINA"
  },
  {
    "codigo":276096003,
    "descripcion":"PROBLEMAS DE DIVORCIO"
  },
  {
    "codigo":210560004,
    "descripcion":"HERIDA ABIERTA EN LA MANO, EXCLUIDAS LA\/S FALANGE\/S"
  },
  {
    "codigo":308864005,
    "descripcion":"DISPLASIA GRAVE DE VÍAS BILIARES"
  },
  {
    "codigo":1290069008,
    "descripcion":"TUMOR NEUROENDOCRINO BIEN DIFERENCIADO DE INTESTINO GRUESO"
  },
  {
    "codigo":403498005,
    "descripcion":"LUPUS ERITEMATOSO DISCOIDE FACIAL"
  },
  {
    "codigo":1157162007,
    "descripcion":"LINFOMA INTRAVASCULAR DE CÉLULAS B GRANDES"
  },
  {
    "codigo":41215002,
    "descripcion":"ANOMALÍA CONGÉNITA DEL ÚTERO, QUE AFECTA AL EMBARAZO"
  },
  {
    "codigo":8447006,
    "descripcion":"ANOMALÍA CONGÉNITA DE HUESO"
  },
  {
    "codigo":1153492005,
    "descripcion":"NIVEL PLASMÁTICO DE CREATINQUINASA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":301524005,
    "descripcion":"ENTRA Y SALE DE LA BAÑERA"
  },
  {
    "codigo":235988007,
    "descripcion":"PERITONITIS POR TALCO"
  },
  {
    "codigo":203220008,
    "descripcion":"INFECCIÓN DE SACRO"
  },
  {
    "codigo":858580008,
    "descripcion":"AMILOIDOSIS SISTÉMICA SECUNDARIA"
  },
  {
    "codigo":234153002,
    "descripcion":"INFECCIÓN DE FÍSTULA ARTERIOVENOSA CONGÉNITA"
  },
  {
    "codigo":168617002,
    "descripcion":"RADIOGRAFÍA SIMPLE DE OMÓPLATO NORMAL"
  },
  {
    "codigo":103081004,
    "descripcion":"INMUNODEFICIENCIA SECUNDARIA A QUIMIOTERAPIA"
  },
  {
    "codigo":124081000119107,
    "descripcion":"ESTADO DE MIGRAÑA MENSTRUAL"
  },
  {
    "codigo":135849005,
    "descripcion":"FORÚNCULO CIEGO"
  },
  {
    "codigo":332457007,
    "descripcion":"GANGLIO DE VIRCHOW"
  },
  {
    "codigo":343371000119101,
    "descripcion":"AMBLIOPÍA ESTRÁBICA DE AMBOS OJOS"
  },
  {
    "codigo":232318001,
    "descripcion":"TINNITUS CAUSADO POR RUIDOS"
  },
  {
    "codigo":37545009,
    "descripcion":"HIPERSENSIBILIDAD A ANTÍGENO ENDÓGENO"
  },
  {
    "codigo":365225009,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA DESVESTIRSE"
  },
  {
    "codigo":428926002,
    "descripcion":"APARICIÓN DEL DOLOR DURANTE EL REPOSO"
  },
  {
    "codigo":363390005,
    "descripcion":"NEOPLASIA MALIGNA DE PALADAR"
  },
  {
    "codigo":68478007,
    "descripcion":"OCLUSIÓN DE LA VENA RETINIANA CENTRAL"
  },
  {
    "codigo":1107004,
    "descripcion":"SÍFILIS TEMPRANA LATENTE, SEROLOGÍA POSITIVA, LÍQUIDO CEFALORRAQUÍDEO NEGATIVO, CON RECAÍDA DESPUÉS DEL TRATAMIENTO"
  },
  {
    "codigo":197715005,
    "descripcion":"SÍNDROME NEFRÍTICO CRÓNICO, GLOMERULONEFRITIS SEMILUNAR DIFUSA"
  },
  {
    "codigo":164947007,
    "descripcion":"INTERVALO PR PROLONGADO"
  },
  {
    "codigo":230483008,
    "descripcion":"DOLOR DE CABEZA RELACIONADO CON ABUSO DE UNA SUSTANCIA O DEPRIVACIÓN DE LA MISMA"
  },
  {
    "codigo":263251009,
    "descripcion":"FRACTURA DE METATARSIANO"
  },
  {
    "codigo":64808005,
    "descripcion":"INTOXICACIÓN CAUSADA POR TEOFILINA"
  },
  {
    "codigo":785704008,
    "descripcion":"SÍNDROME DE MALABSORCIÓN DEBIDO A INTOLERANCIA ADQUIRIDA A LA FRUCTOSA"
  },
  {
    "codigo":1193747006,
    "descripcion":"ENTERITIS POR SHIGELLA SONNEI"
  },
  {
    "codigo":423421002,
    "descripcion":"ENCONDROMA DE HUESO DE LA MANO"
  },
  {
    "codigo":1144317004,
    "descripcion":"FRENTE PEQUEÑA"
  },
  {
    "codigo":292349008,
    "descripcion":"REACCIÓN ADVERSA AL TRIAZOLAM"
  },
  {
    "codigo":1306322001,
    "descripcion":"NEOPLASIA MALIGNA CON METÁSTASIS EN TEJIDO ECTÓPICO DE MAMA"
  },
  {
    "codigo":716498002,
    "descripcion":"NO COMPRENDE INSTRUCCIONES DE UNA PARTE"
  },
  {
    "codigo":93906006,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE MÚSCULO DEL CUELLO"
  },
  {
    "codigo":126674007,
    "descripcion":"NEOPLASIA DEL CORNETE DE LA NARIZ"
  },
  {
    "codigo":290514008,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR HALOTANO"
  },
  {
    "codigo":224978009,
    "descripcion":"SENSACIÓN DE ALIVIO"
  },
  {
    "codigo":288679000,
    "descripcion":"FINALIZA UNA CONVERSACIÓN"
  },
  {
    "codigo":419751003,
    "descripcion":"REFLEJO ABDOMINAL ASIMÉTRICO"
  },
  {
    "codigo":92071005,
    "descripcion":"NEOPLASIA BENIGNA DE NERVIO CRANEAL"
  },
  {
    "codigo":714663007,
    "descripcion":"CON MAYOR RIESGO DE ALTERACIÓN DE LA CAPACIDAD PARA REALIZAR TAREAS DE CUIDADO"
  },
  {
    "codigo":26535009,
    "descripcion":"ÁNTRAX DE LA VULVA"
  },
  {
    "codigo":1204348005,
    "descripcion":"QUISTE COLEDOCIANO ADQUIRIDO"
  },
  {
    "codigo":24700007,
    "descripcion":"ESCLEROSIS MÚLTIPLE"
  },
  {
    "codigo":286844007,
    "descripcion":"CARÁCTER LITIGIOSO"
  },
  {
    "codigo":1237116009,
    "descripcion":"ÚLCERA VENOSA DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":416081002,
    "descripcion":"INSCRIPTO EN REGISTRO DE AGRESORES SEXUALES"
  },
  {
    "codigo":874833004,
    "descripcion":"CUERPO EXTRAÑO SUPERFICIAL EN PERINEO"
  },
  {
    "codigo":285009004,
    "descripcion":"CAPAZ DE AJUSTAR LA ROPA"
  },
  {
    "codigo":88401007,
    "descripcion":"AFINIDAD DE OXÍGENO AUMENTADA"
  },
  {
    "codigo":53798001,
    "descripcion":"HIPERVITAMINOSIS"
  },
  {
    "codigo":1004070004,
    "descripcion":"CONTRACTURA DE ADUCTOR LARGO"
  },
  {
    "codigo":283174006,
    "descripcion":"CUERPO EXTRAÑO METÁLICO EN EL GLÚTEO"
  },
  {
    "codigo":838395000,
    "descripcion":"ABSCESO DE LÓBULO OCCIPITAL"
  },
  {
    "codigo":19195000,
    "descripcion":"DISFUNCIÓN HIPOTALÁMICA - SUPRARRENAL"
  },
  {
    "codigo":1264379001,
    "descripcion":"LACERACIÓN DE TENDÓN DE TOBILLO"
  },
  {
    "codigo":722995008,
    "descripcion":"CONCUSIÓN DE MÉDULA ESPINAL SACRA"
  },
  {
    "codigo":707323002,
    "descripcion":"ANEMIA CON ENFERMEDAD RENAL CRÓNICA CONCOMITANTE Y DEBIDA A ELLA"
  },
  {
    "codigo":445179000,
    "descripcion":"AUTOCRÍTICA EXCESIVA"
  },
  {
    "codigo":250406009,
    "descripcion":"INCOMPATIBILIDAD SANGUÍNEA"
  },
  {
    "codigo":281339009,
    "descripcion":"PAPILOMA DE CARÚNCULA"
  },
  {
    "codigo":17360003,
    "descripcion":"SURCO HIPOCÁMPICO POR PRESIÓN"
  },
  {
    "codigo":443344007,
    "descripcion":"INSUFICIENCIA CARDÍACA DISTÓLICA CRÓNICA REAGUDIZADA"
  },
  {
    "codigo":441509002,
    "descripcion":"MARCAPASOS CARDÍACO IN SITU"
  },
  {
    "codigo":81061007,
    "descripcion":"QUISTE SEBÁCEO EN EL PÁRPADO"
  },
  {
    "codigo":1162405008,
    "descripcion":"INFECCIÓN DE VÉRTEBRA CAUSADA POR PARÁSITOS"
  },
  {
    "codigo":310437009,
    "descripcion":"CITOLOGÍA DE ORINA"
  },
  {
    "codigo":110159004,
    "descripcion":"ABRASIÓN DEL PALADAR DURO"
  },
  {
    "codigo":44623008,
    "descripcion":"RUIDO DE EYECCIÓN SISTÓLICA"
  },
  {
    "codigo":75556004,
    "descripcion":"INFECCIÓN CAUSADA POR CEPHALOSPORIUM RECIFEI"
  },
  {
    "codigo":763684005,
    "descripcion":"CRANEOSINOSTOSIS TIPO HERMANN OPITZ"
  },
  {
    "codigo":42788006,
    "descripcion":"PRESIÓN VENOSA YUGULAR DISMINUIDA"
  },
  {
    "codigo":370468006,
    "descripcion":"TRICOBLASTOMA QUÍSTICO"
  },
  {
    "codigo":403236008,
    "descripcion":"FENOTIPO CUTÁNEO VI (PIGMENTACIÓN INTENSA)"
  },
  {
    "codigo":8185002,
    "descripcion":"TRASTORNO DE PÁNICO CON AGORAFOBIA Y ATAQUES DE PÁNICO MODERADOS"
  },
  {
    "codigo":345881000119107,
    "descripcion":"GLAUCOMA SECUNDARIO DE ÁNGULO CERRADO DE AMBOS OJOS DEBIDO A BLOQUEO PUPILAR"
  },
  {
    "codigo":303097007,
    "descripcion":"TRASTORNO DEL METABOLISMO DE LA SERINA"
  },
  {
    "codigo":235726002,
    "descripcion":"ENTEROPATÍA POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":397731000,
    "descripcion":"HALLAZGO RELACIONADO CON GRUPO ÉTNICO"
  },
  {
    "codigo":168355001,
    "descripcion":"ORGANISMO AISLADO EN CULTIVO DE HISOPADO DE EXTENDIDO CERVICAL"
  },
  {
    "codigo":725411000,
    "descripcion":"ENFERMEDAD DE SCHEUERMANN FAMILIAR"
  },
  {
    "codigo":364963002,
    "descripcion":"CONDUCCIÓN NERVIOSA - HALLAZGO"
  },
  {
    "codigo":15638451000119104,
    "descripcion":"IRITIS DE OJO DERECHO"
  },
  {
    "codigo":363128000,
    "descripcion":"TRASTORNO ENDOCRINO FETAL"
  },
  {
    "codigo":68216000,
    "descripcion":"CATARATA TETÁNICA"
  },
  {
    "codigo":233891009,
    "descripcion":"TAQUICARDIA DEL NÓDULO SINOAURICULAR"
  },
  {
    "codigo":37283009,
    "descripcion":"LUXACIÓN ANTERIOR DEL CRISTALINO"
  },
  {
    "codigo":461432007,
    "descripcion":"ABSCESO EN LOCALIZACIÓN DE PRÓTESIS DE VÁLVULA CARDÍACA"
  },
  {
    "codigo":232056007,
    "descripcion":"DISTROFIA PROGRESIVA DE BASTONES"
  },
  {
    "codigo":262989004,
    "descripcion":"LESIÓN TENDINOSA POR APLASTAMIENTO"
  },
  {
    "codigo":230221005,
    "descripcion":"EMBOLIA ARTERIAL INTRACRANEAL SÉPTICA"
  },
  {
    "codigo":197453004,
    "descripcion":"PÉRDIDA BILIAR POSCOLECISTECTOMÍA"
  },
  {
    "codigo":721741006,
    "descripcion":"SINUSITIS CAUSADA POR STREPTOCOCCUS PNEUMONIAE"
  },
  {
    "codigo":424994000,
    "descripcion":"BARRERAS EDUCATIVAS IMPIDEN LA CAPACIDAD PARA UTILIZAR RECURSOS COMUNITARIOS"
  },
  {
    "codigo":426829004,
    "descripcion":"CAPSULITIS DE LA ARTICULACIÓN TEMPOROMANDIBULAR"
  },
  {
    "codigo":845006,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA ARTERIA MESENTÉRICA INFERIOR"
  },
  {
    "codigo":66381006,
    "descripcion":"TRASTORNO DE ADAPTACIÓN, CON ALTERACIÓN MIXTA DE LAS EMOCIONES Y LA CONDUCTA"
  },
  {
    "codigo":295757004,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE CRISANTASPASA"
  },
  {
    "codigo":292941000119103,
    "descripcion":"GRANULOMA EPIDURAL INTRAESPINAL"
  },
  {
    "codigo":228386005,
    "descripcion":"SE INYECTA DROGAS POR VÍA SUBCUTÁNEA"
  },
  {
    "codigo":457762009,
    "descripcion":"TROMBOSIS DE VÁLVULA AURICULOVENTRICULAR IZQUIERDA (MORFOLÓGICAMENTE NO MITRAL)"
  },
  {
    "codigo":95479005,
    "descripcion":"ESCLEROCÓRNEA CONGÉNITA"
  },
  {
    "codigo":60876000,
    "descripcion":"SÍNDROME DE GARDNER"
  },
  {
    "codigo":29943008,
    "descripcion":"QUERATITIS DENDRÍTICA POR VIRUS DEL HERPES SIMPLE"
  },
  {
    "codigo":421324002,
    "descripcion":"CÁMARA OCULAR ANTERIOR CON POSIBILIDAD DE OCLUSIÓN"
  },
  {
    "codigo":93644004,
    "descripcion":"MELANOMA MALIGNO DE LA PIEL DEL PERINEO"
  },
  {
    "codigo":1085671000119100,
    "descripcion":"MALFORMACIÓN CONGÉNITA DE LARINGE Y TRÁQUEA"
  },
  {
    "codigo":191948007,
    "descripcion":"SÍNTOMAS MUSCULOESQUELÉTICOS PSICOSOMÁTICOS"
  },
  {
    "codigo":290252008,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR FENOPROFENO"
  },
  {
    "codigo":124577005,
    "descripcion":"DEFICIENCIA DE ENDORRIBONUCLEASA"
  },
  {
    "codigo":102631000119103,
    "descripcion":"GANGRENA DEBIDA A ENFERMEDAD VASCULAR PERIFÉRICA"
  },
  {
    "codigo":253814006,
    "descripcion":"HIPOPLASIA NODULAR FOCAL DE HÍGADO"
  },
  {
    "codigo":286582007,
    "descripcion":"EXALTADO"
  },
  {
    "codigo":417654008,
    "descripcion":"CONTUSIÓN DE ANEXOS OCULARES Y TEJIDOS PERIOCULARES"
  },
  {
    "codigo":251979003,
    "descripcion":"PÉRDIDA URINARIA"
  },
  {
    "codigo":446752000,
    "descripcion":"INFECCIÓN DE PERITONEO CAUSADA POR CHLAMYDIA TRACHOMATIS"
  },
  {
    "codigo":20768006,
    "descripcion":"CONTRACTURA DEL CUELLO UTERINO"
  },
  {
    "codigo":250144008,
    "descripcion":"CALZADO MUY ANGOSTO"
  },
  {
    "codigo":182773001,
    "descripcion":"CONSENTIMIENTO PARA CIRUGÍA REHUSADO"
  },
  {
    "codigo":84469002,
    "descripcion":"INTOXICACIÓN POR ROBINIA PSEUDOACACIA"
  },
  {
    "codigo":1264117000,
    "descripcion":"CARCINOMA ADENOESCAMOSO DE CUELLO DE ÚTERO METASTÁSICO"
  },
  {
    "codigo":248309005,
    "descripcion":"GRASA CORPORAL EN PARTE INFERIOR DEL CUERPO, AUMENTADA"
  },
  {
    "codigo":17098006,
    "descripcion":"ENFERMEDAD INFECCIOSA SUBAGUDA"
  },
  {
    "codigo":82634006,
    "descripcion":"EMBARAZOS PREVIOS: 10"
  },
  {
    "codigo":768927001,
    "descripcion":"SÍNDROME DE TRISOMÍA 1Q"
  },
  {
    "codigo":16624001000119104,
    "descripcion":"HEMATOMA INTRAMURAL DE AORTA"
  },
  {
    "codigo":308340000,
    "descripcion":"SITUACIÓN DE LA LISTA DE ESPERA"
  },
  {
    "codigo":373876002,
    "descripcion":"ESTADO DE LAS CÉLULAS GLANDULARES POSHISTERECTOMÍA"
  },
  {
    "codigo":109897000,
    "descripcion":"INDICACIÓN PARA MODIFICACIÓN DEL ESTADO DE COMPORTAMIENTO DEL PACIENTE"
  },
  {
    "codigo":11593000,
    "descripcion":"INTOXICACIÓN POR MORAEA"
  },
  {
    "codigo":295451000119101,
    "descripcion":"TENDINITIS CALCIFICANTE DE MUSLO"
  },
  {
    "codigo":44361004,
    "descripcion":"FORÚNCULO DE PIE"
  },
  {
    "codigo":402974000,
    "descripcion":"ESCROFULODERMIA INDUCIDA POR BCG"
  },
  {
    "codigo":208201009,
    "descripcion":"FRACTURA COMPLETA NO EXPUESTA DE ANILLO PÉLVICO"
  },
  {
    "codigo":239134005,
    "descripcion":"LENTIGINOSIS MUCOSA"
  },
  {
    "codigo":370206005,
    "descripcion":"ASMA QUE LIMITA LA MARCHA EN TERRENO PLANO"
  },
  {
    "codigo":206366007,
    "descripcion":"INFECCIÓN FETAL INTRAMNIÓTICA POR ESCHERICHIA COLI"
  },
  {
    "codigo":1287710009,
    "descripcion":"CARCINOMA NEUROENDOCRINO DE VESÍCULA BILIAR"
  },
  {
    "codigo":401139002,
    "descripcion":"CON CUATRO O MÁS MEDICAMENTOS"
  },
  {
    "codigo":827123003,
    "descripcion":"MASA ABDOMINAL DE FORMA IRREGULAR"
  },
  {
    "codigo":7923005,
    "descripcion":"CLONACIÓN MOLECULAR"
  },
  {
    "codigo":73459006,
    "descripcion":"BLOQUEO DE RAMA DERECHA, HEMIBLOQUEO ANTERIOR INCOMPLETO Y HEMIBLOQUEO POSTERIOR INCOMPLETO IZQUIERDO"
  },
  {
    "codigo":268232000,
    "descripcion":"HIPOPLASIA RENAL BILATERAL"
  },
  {
    "codigo":302835009,
    "descripcion":"FEOCROMOCITOMA"
  },
  {
    "codigo":38856001,
    "descripcion":"ANOMALÍA CONGÉNITA DE APÉNDICE"
  },
  {
    "codigo":301000005,
    "descripcion":"NEUMONÍA DE LÓBULO INFERIOR IZQUIERDO"
  },
  {
    "codigo":350901000119100,
    "descripcion":"NEOPLASIA BENIGNA DE PARTES BLANDAS DE EXTREMIDAD SUPERIOR DERECHA"
  },
  {
    "codigo":169928006,
    "descripcion":"PUNTAJE DE APGAR A LOS 10 MINUTOS = 5"
  },
  {
    "codigo":366536008,
    "descripcion":"REFLEJO ROTULIANO - HALLAZGO"
  },
  {
    "codigo":233629001,
    "descripcion":"BRONQUIECTASIA IDIOPÁTICA"
  },
  {
    "codigo":1088181000119100,
    "descripcion":"OTITIS MEDIA AGUDA SUPURATIVA RECIDIVANTE DEL OÍDO IZQUIERDO CON RUPTURA ESPONTÁNEA DE LA MEMBRANA TIMPÁNICA"
  },
  {
    "codigo":299165003,
    "descripcion":"AMPLITUD DE ABDUCCIÓN ACTIVA DEL PULGAR DISMINUIDA"
  },
  {
    "codigo":200861004,
    "descripcion":"CAMBIOS CUTÁNEOS DEBIDOS A EXPOSICIÓN CRÓNICA A RADIACIÓN NO IONIZANTE"
  },
  {
    "codigo":202696006,
    "descripcion":"ESPONDILOSIS LUMBOSACRA EN MÚLTIPLES NIVELES CON RADICULOPATÍA"
  },
  {
    "codigo":430237002,
    "descripcion":"PÉRDIDA DE PESO INTENCIONAL ANORMAL"
  },
  {
    "codigo":102557007,
    "descripcion":"CLAUDICACIÓN DEL BRAZO"
  },
  {
    "codigo":231794000,
    "descripcion":"LESIÓN TRAUMÁTICA DE GLOBO OCULAR"
  },
  {
    "codigo":725149008,
    "descripcion":"SÍNDROME DE ANOMALÍAS AURICULARES Y OCULARES Y FISURA DE LABIO"
  },
  {
    "codigo":10836661000119102,
    "descripcion":"FRACTURA EXPUESTA DE BASE DE TERCER METACARPIANO IZQUIERDO"
  },
  {
    "codigo":10754741000119103,
    "descripcion":"CÁLCULO BILIAR POSPARTO"
  },
  {
    "codigo":2418009,
    "descripcion":"EFECTO TÓXICO DE HUMOS DE POLIÉSTER"
  },
  {
    "codigo":721479002,
    "descripcion":"SÍNDROME DEL CORDÓN POSTERIOR DE MÉDULA ESPINAL AL NIVEL DEL DECIMOPRIMER SEGMENTO DORSAL"
  },
  {
    "codigo":197191005,
    "descripcion":"ADHERENCIAS PILÓRICAS"
  },
  {
    "codigo":262727006,
    "descripcion":"SECCIÓN DE LA RAÍZ DE NERVIO SACRO"
  },
  {
    "codigo":66119008,
    "descripcion":"DEHISCENCIA DE REPARACIÓN DE LACERACIÓN PERINEAL EN EL PUERPERIO"
  },
  {
    "codigo":426567008,
    "descripcion":"ULCERACIÓN AFTOSA EN ÓRGANO GENITAL MASCULINO"
  },
  {
    "codigo":31516002,
    "descripcion":"ENFERMEDAD VIRAL EN LA MADRE QUE COMPLICA EL EMBARAZO, EL NACIMIENTO Y\/O EL PUERPERIO"
  },
  {
    "codigo":295495008,
    "descripcion":"SOBREDOSIS DE AGENTE ANESTÉSICO"
  },
  {
    "codigo":293660003,
    "descripcion":"ALERGIA A MESALAZINA"
  },
  {
    "codigo":228124000,
    "descripcion":"ATENCIÓN DE NIÑO ABANDONADO"
  },
  {
    "codigo":95217000,
    "descripcion":"PSEUDOFAQUIA"
  },
  {
    "codigo":816113001,
    "descripcion":"MIEMBRO INFERIOR IZQUIERDO AMPUTADO"
  },
  {
    "codigo":291825002,
    "descripcion":"INTOXICACIÓN POR HORMONA SEXUAL"
  },
  {
    "codigo":1078257002,
    "descripcion":"AGENESIA DE EPÍFISIS DE FALANGE DISTAL DE SEGUNDO DEDO DE PIE"
  },
  {
    "codigo":719644009,
    "descripcion":"HIFAS TABICADAS DEL REINO FUNGI DETECTADAS"
  },
  {
    "codigo":160753005,
    "descripcion":"DESALOJADO DE LA VIVIENDA POR LA FUERZA"
  },
  {
    "codigo":93382002,
    "descripcion":"DESALINEAMIENTO CONGÉNITO DEL ARCO DE LA VÉRTEBRA DORSAL"
  },
  {
    "codigo":1141958003,
    "descripcion":"COMPORTAMIENTO SOCIAL ANORMAL"
  },
  {
    "codigo":289990004,
    "descripcion":"INCAPAZ DE MANIPULAR ABOTONADURAS"
  },
  {
    "codigo":678581000119109,
    "descripcion":"CATARATA SENIL POLAR SUBCAPSULAR ANTERIOR DE OJO IZQUIERDO"
  },
  {
    "codigo":224454006,
    "descripcion":"SOLICITUD DE PERMISO POR ASUNTOS FAMILIARES"
  },
  {
    "codigo":879814007,
    "descripcion":"HIPERTENSIÓN PULMONAR POR HEMANGIOMATOSIS CAPILAR PULMONAR"
  },
  {
    "codigo":714139000,
    "descripcion":"REACCIÓN ADVERSA A ADITIVO ALIMENTARIO"
  },
  {
    "codigo":124315005,
    "descripcion":"DEFICIENCIA DE RIBOSILNICOTINAMIDA CINASA"
  },
  {
    "codigo":286320000,
    "descripcion":"DIFICULTAD PARA UTILIZAR COMBINACIONES DE CONSONANTE-VOCAL-CONSONANTE"
  },
  {
    "codigo":56944001,
    "descripcion":"LINFOMA ESTADIO III"
  },
  {
    "codigo":1269360002,
    "descripcion":"CRISIS EPILÉPTICA TÓNICA DE INICIO FOCAL"
  },
  {
    "codigo":253552003,
    "descripcion":"DEFECTO PERIMEMBRANOSO DEL TABIQUE INTERVENTRICULAR CON EXTENSIÓN HACIA LA ENTRADA DEL VENTRÍCULO DERECHO"
  },
  {
    "codigo":122480009,
    "descripcion":"DEFORMIDAD EN VALGO DEL PRIMER DEDO DEL PIE"
  },
  {
    "codigo":1003546000,
    "descripcion":"AGENESIA DE PERONÉ"
  },
  {
    "codigo":282650001,
    "descripcion":"DIFICULTAD PARA HACER EL PUENTE"
  },
  {
    "codigo":315418002,
    "descripcion":"NACIDO EN ECUADOR"
  },
  {
    "codigo":86042009,
    "descripcion":"MELANOSIS CONGÉNITA"
  },
  {
    "codigo":444655009,
    "descripcion":"CROMOSOMA ESTRUCTURALMENTE ANORMAL NO IDENTIFICADO ADICIONAL"
  },
  {
    "codigo":248047009,
    "descripcion":"HUIR DE CASA"
  },
  {
    "codigo":410052008,
    "descripcion":"CARNOSINEMIA"
  },
  {
    "codigo":735897000,
    "descripcion":"LESIÓN TRAUMÁTICA DE ARTERIA PLANTAR DE PIE"
  },
  {
    "codigo":15698921000119107,
    "descripcion":"HIPERTROFIA DE ALMOHADILLA ADIPOSA INFRARROTULIANA DE AMBAS RODILLAS"
  },
  {
    "codigo":277145006,
    "descripcion":"REACCIÓN A TRANSFUSIÓN POR INCOMPATIBILIDAD ANTÍGENO-ANTICUERPO DE GRUPO SANGUÍNEO"
  },
  {
    "codigo":1260185009,
    "descripcion":"CICATRIZ DE CEJA DE REGIÓN DE OJO IZQUIERDO"
  },
  {
    "codigo":681091000119103,
    "descripcion":"BLEFARITIS ANGULAR BILATERAL"
  },
  {
    "codigo":373614006,
    "descripcion":"DEFECTO PUPILAR AFERENTE ABSOLUTO"
  },
  {
    "codigo":209774007,
    "descripcion":"RUPTURA DE TENDÓN DE EXTENSOR COMÚN DE LOS DEDOS DE LA MANO"
  },
  {
    "codigo":76867002,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO DE BRAZO"
  },
  {
    "codigo":699459002,
    "descripcion":"NEOPLASIA DE MÚSCULO MASTICATORIO"
  },
  {
    "codigo":240707005,
    "descripcion":"CANDIDIASIS ANOGENITAL"
  },
  {
    "codigo":109635007,
    "descripcion":"MALA OCLUSIÓN DEBIDA A HIPERPLASIA GINGIVAL"
  },
  {
    "codigo":764995008,
    "descripcion":"SÍNDROME DE ANOMALÍAS UNGUEALES Y DENTALES, QUERATODERMIA PALMOPLANTAR MARGINAL E HIPERPIGMENTACIÓN DE LA CAVIDAD BUCAL"
  },
  {
    "codigo":207939007,
    "descripcion":"FRACTURA NO EXPUESTA DE VÉRTEBRA DORSAL, ESTALLIDO"
  },
  {
    "codigo":402712002,
    "descripcion":"ESCLERODERMIA OCUPACIONAL"
  },
  {
    "codigo":271640005,
    "descripcion":"PULSO SALTÓN"
  },
  {
    "codigo":107651000119106,
    "descripcion":"HIPOPLASIA MAXILAR TRANSVERSAL ADQUIRIDA"
  },
  {
    "codigo":238872007,
    "descripcion":"ACROGERIA"
  },
  {
    "codigo":1285613000,
    "descripcion":"HEMATOMA DE DEDO MEÑIQUE"
  },
  {
    "codigo":1254680007,
    "descripcion":"ENVENENAMIENTO DEBIDO A PICADURA DE HORMIGA DE FUEGO"
  },
  {
    "codigo":73197002,
    "descripcion":"DEFECTO EN CUÑA DE LOS DIENTES"
  },
  {
    "codigo":237037006,
    "descripcion":"ENFERMEDAD INFLAMATORIA PÉLVICA AGUDA"
  },
  {
    "codigo":202434003,
    "descripcion":"TUMOR TENOSINOVIAL DE CÉLULAS GIGANTES DIFUSO DE ARTICULACIÓN ESTERNOCLAVICULAR"
  },
  {
    "codigo":366274004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CONCIENCIA DE LA FUNCIÓN VESICAL"
  },
  {
    "codigo":267970006,
    "descripcion":"ESPONDILOSIS CERVICAL SIN MIELOPATÍA"
  },
  {
    "codigo":300738008,
    "descripcion":"CAPAZ DE PARTICIPAR EN ACTIVIDADES DE TIEMPO LIBRE"
  },
  {
    "codigo":726722009,
    "descripcion":"SÍNDROME DE MICROSOMÍA HEMIFACIAL CON DEFECTO RADIAL"
  },
  {
    "codigo":298903004,
    "descripcion":"AMPLITUD DE SUPINACIÓN ACTIVA DE CODO NORMAL"
  },
  {
    "codigo":724887006,
    "descripcion":"LACERACIÓN DE FASCIA DEL TÓRAX"
  },
  {
    "codigo":429975007,
    "descripcion":"DISFAGIA DE LA FASE ORAL"
  },
  {
    "codigo":397207006,
    "descripcion":"SIN EXTENSIÓN DIRECTA DE NEOPLASIA MALIGNA IDENTIFICADA"
  },
  {
    "codigo":231532002,
    "descripcion":"TRASTORNO SEXUAL"
  },
  {
    "codigo":15973661000119106,
    "descripcion":"PARESTESIA DE EXTREMIDAD SUPERIOR IZQUIERDA"
  },
  {
    "codigo":165996008,
    "descripcion":"HEPATITIS A NO DETECTADA"
  },
  {
    "codigo":33089002,
    "descripcion":"ENVENENAMIENTO POR SAPO MARINO"
  },
  {
    "codigo":10868151000119101,
    "descripcion":"SOBREDOSIS DE ESTATINA"
  },
  {
    "codigo":229697008,
    "descripcion":"DISPRAXIA ORAL-VERBAL"
  },
  {
    "codigo":658101000005106,
    "descripcion":"POSICIÓN DE PLACENTA EN FONDO UTERINO"
  },
  {
    "codigo":31254003,
    "descripcion":"EXOTROPÍA ALTERNANTE CON PATRÓN A"
  },
  {
    "codigo":719382006,
    "descripcion":"CAPAZ DE COMPRENDER UN MATERIAL ESCRITO"
  },
  {
    "codigo":293398007,
    "descripcion":"REACCIÓN ADVERSA A LA NIACINAMIDA"
  },
  {
    "codigo":291563000,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR CEFALEXINA"
  },
  {
    "codigo":64022009,
    "descripcion":"INTOXICACIÓN POR DICHAPETALUM CYMOSUM"
  },
  {
    "codigo":30041000175100,
    "descripcion":"ÚLCERA POR PRESIÓN EN DORSO DE PIE IZQUIERDO, ESTADIO II"
  },
  {
    "codigo":93120000,
    "descripcion":"FALTA DE OSIFICACIÓN DE LA VÉRTEBRA ESTERNAL"
  },
  {
    "codigo":10950071000119105,
    "descripcion":"HERIDA POR DISPARO DE ARMA DE FUEGO DE ANTEBRAZO DERECHO"
  },
  {
    "codigo":94955009,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL MIOMETRIO"
  },
  {
    "codigo":1141696004,
    "descripcion":"DEMUESTRA CONOCIMIENTO SOBRE EMBARAZO"
  },
  {
    "codigo":1010624006,
    "descripcion":"NEOPLASIA PRIMARIA DE NASOFARINGE TIPO GLÁNDULA SALIVAL"
  },
  {
    "codigo":289728006,
    "descripcion":"CONTRACCIONES UTERINAS NO EFECTIVAS"
  },
  {
    "codigo":1303701001,
    "descripcion":"GLAUCOMA DE OJO IZQUIERDO DEBIDO A NEOPLASIA INTRAOCULAR"
  },
  {
    "codigo":25749005,
    "descripcion":"DESPROPORCIÓN FETO-PÉLVICA"
  },
  {
    "codigo":1172629005,
    "descripcion":"SÍNDROME DE DEFICIENCIA GRAVE DEL CRECIMIENTO, ESTRABISMO, MELANOCITOSIS DÉRMICA EXTENSA Y DISCAPACIDAD INTELECTUAL"
  },
  {
    "codigo":91285009,
    "descripcion":"CORTEZA SUPRARRENAL ECTÓPICA"
  },
  {
    "codigo":124053009,
    "descripcion":"GANGLIÓSIDO POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":15674961000119103,
    "descripcion":"TENDINITIS BILATERAL DE CADERA"
  },
  {
    "codigo":286058005,
    "descripcion":"DIFICULTAD PARA LAVAR LA ROPA EN SECO"
  },
  {
    "codigo":253290005,
    "descripcion":"COMUNICACIÓN AURICULOVENTRICULAR AUSENTE DEL LADO IZQUIERDO"
  },
  {
    "codigo":23914009,
    "descripcion":"TEJIDO ESPLÉNICO ECTÓPICO"
  },
  {
    "codigo":415295002,
    "descripcion":"MIOCARDIOPATÍA RESTRICTIVA"
  },
  {
    "codigo":284223003,
    "descripcion":"QUEMADURA DE GLÚTEO"
  },
  {
    "codigo":448063004,
    "descripcion":"ANOMALÍA CONGÉNITA DE VENA CARDÍACA POSTERIOR DE VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":251455009,
    "descripcion":"DESCARGA RÍTMICA TEMPORAL MEDIA"
  },
  {
    "codigo":216852001,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR MONÓXIDO DE CARBONO DE COMBUSTIÓN INCOMPLETA DE COMBUSTIBLES DE USO INDUSTRIAL"
  },
  {
    "codigo":413460004,
    "descripcion":"EJERCICIO AERÓBICO CINCO VECES POR SEMANA"
  },
  {
    "codigo":249620007,
    "descripcion":"DEPOSICIÓN POR INANICIÓN"
  },
  {
    "codigo":247785002,
    "descripcion":"PLANIFICACIÓN IRREAL"
  },
  {
    "codigo":213182000,
    "descripcion":"FALLA TOTAL DE REIMPLANTE DE DEDO DE LA MANO"
  },
  {
    "codigo":16574001,
    "descripcion":"PARO CARDÍACO POSTERIOR A PROCEDIMIENTO OBSTÉTRICO"
  },
  {
    "codigo":49342001,
    "descripcion":"ESTRECHEZ DE VAGINA QUE AFECTA EL EMBARAZO"
  },
  {
    "codigo":28241000119109,
    "descripcion":"ECOGRAFÍA FETAL ANORMAL"
  },
  {
    "codigo":409790005,
    "descripcion":"ENFERMEDAD CAUSADA POR NEISSERIA"
  },
  {
    "codigo":1163454006,
    "descripcion":"HIPERTIROIDISMO POR ADENOMA TIROIDEO TÓXICO"
  },
  {
    "codigo":1360062006,
    "descripcion":"ÁNGULO ABIERTO DE OJO DERECHO"
  },
  {
    "codigo":276883000,
    "descripcion":"PERITONITIS ASOCIADA CON DIÁLISIS PERITONEAL"
  },
  {
    "codigo":39061000087101,
    "descripcion":"HEMATOMA DE PÁRPADO SUPERIOR DERECHO"
  },
  {
    "codigo":10901000087102,
    "descripcion":"HIPOTENSIÓN DURANTE PROCEDIMIENTO QUIRÚRGICO"
  },
  {
    "codigo":47507006,
    "descripcion":"SÍNDROME DE RIEGER"
  },
  {
    "codigo":735635007,
    "descripcion":"EYACULACIÓN TARDÍA ADQUIRIDA GENERALIZADA"
  },
  {
    "codigo":1259923007,
    "descripcion":"TRASTORNO FETAL DEBIDO A MALA PRESENTACIÓN DURANTE PARTO"
  },
  {
    "codigo":46741000087105,
    "descripcion":"DESGARRO COMPLETO DE LIGAMENTO ESCAFOSEMILUNAR DERECHO"
  },
  {
    "codigo":111208003,
    "descripcion":"MELASMA GRAVÍDICO"
  },
  {
    "codigo":307816004,
    "descripcion":"SÍNDROME DE LERICHE"
  },
  {
    "codigo":44181000087106,
    "descripcion":"CORTE DE DEDO DE PIE IZQUIERDO"
  },
  {
    "codigo":41621000087104,
    "descripcion":"HERIDA PUNZANTE DE PÁRPADO INFERIOR DERECHO"
  },
  {
    "codigo":1290856008,
    "descripcion":"OPACIDAD EVIDENCIADA EN RADIOGRAFÍA SIMPLE"
  },
  {
    "codigo":240445005,
    "descripcion":"INFECCIÓN EXTRAPULMONAR POR LEGIONELLA"
  },
  {
    "codigo":699197006,
    "descripcion":"PROTRUSIÓN BIMAXILAR"
  },
  {
    "codigo":764733009,
    "descripcion":"SÍNDROME DE OFTALMOPLEJÍA EXTERNA PROGRESIVA, MIOPATÍA Y EMACIACIÓN"
  },
  {
    "codigo":762898005,
    "descripcion":"TUMEFACCIÓN DE AMBOS MIEMBROS INFERIORES"
  },
  {
    "codigo":369682005,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA DE LA AMPOLLA DE VATER, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":1187047001,
    "descripcion":"SÍNDROME DE AICARDI GOUTIERES TIPO 3"
  },
  {
    "codigo":402450009,
    "descripcion":"EPIDERMÓLISIS BULLOSA ADQUIRIDA, TIPO BRUNSTING-PERRY"
  },
  {
    "codigo":236775006,
    "descripcion":"HIDROCELE ADQUIRIDO"
  },
  {
    "codigo":7399006,
    "descripcion":"GASTRITIS ENFISEMATOSA"
  },
  {
    "codigo":105703006,
    "descripcion":"ENFERMEDAD CAUSADA POR SYPHACIOIDEA"
  },
  {
    "codigo":366012003,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA CERRAR LOS OJOS"
  },
  {
    "codigo":1073911000000104,
    "descripcion":"DESPLAZA OBJETOS POR EL HOGAR"
  },
  {
    "codigo":724625003,
    "descripcion":"PROBLEMA DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":167569004,
    "descripcion":"CULTIVO DE ORINA: CRECIMIENTO MIXTO"
  },
  {
    "codigo":16005151000119101,
    "descripcion":"REUMATISMO PALINDRÓMICO DE ARTICULACIONES BILATERALES DE HOMBROS"
  },
  {
    "codigo":36497006,
    "descripcion":"EXTENSIÓN TRAUMÁTICA DE LA EPISIOTOMÍA"
  },
  {
    "codigo":298641008,
    "descripcion":"AMPLITUD DE FLEXIÓN LATERAL PASIVA HACIA LA IZQUIERDA DE LA COLUMNA VERTEBRAL LUMBAR, NORMAL"
  },
  {
    "codigo":396945009,
    "descripcion":"TAMAÑO TUMORAL LUEGO DE SU SECCIÓN, NO PUEDE SER DETERMINADO"
  },
  {
    "codigo":427878002,
    "descripcion":"ARTROPATÍA DE LA MANO ASOCIADA CON UN TRASTORNO NEUROLÓGICO"
  },
  {
    "codigo":1279846006,
    "descripcion":"DESPRENDIMIENTO DE RETINA IZQUIERDA CON ROTURA DE RETINA"
  },
  {
    "codigo":395110009,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: SHONA"
  },
  {
    "codigo":131131001,
    "descripcion":"NIVEL DE BIOTINA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":65595002,
    "descripcion":"FRACTURAS MÚLTIPLES DE LA EXTREMIDAD SUPERIOR Y COSTILLAS"
  },
  {
    "codigo":720955004,
    "descripcion":"SÍNDROME DE FINE-LUBINSKY"
  },
  {
    "codigo":294971007,
    "descripcion":"ALERGIA A SIMVASTATINA"
  },
  {
    "codigo":293136001,
    "descripcion":"REACCIÓN ADVERSA A FÁRMACO ANTITIROIDEO"
  },
  {
    "codigo":1145104003,
    "descripcion":"ESCASO CRECIMIENTO DE PESTAÑAS DE PÁRPADO INFERIOR"
  },
  {
    "codigo":291301004,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR METARAMINOL"
  },
  {
    "codigo":782821004,
    "descripcion":"DISPLASIA ESPONDILOMETAFISARIA TIPO ISIDOR"
  },
  {
    "codigo":125626004,
    "descripcion":"LESIÓN TRAUMÁTICA DEL ESTÓMAGO"
  },
  {
    "codigo":289466005,
    "descripcion":"VULVA PRESENTE"
  },
  {
    "codigo":1338042006,
    "descripcion":"DERMATITIS ASOCIADA A INCONTINENCIA"
  },
  {
    "codigo":10680351000119109,
    "descripcion":"NÓDULO DE PIEL DE DEDO DE AMBAS MANOS"
  },
  {
    "codigo":254863004,
    "descripcion":"TUMOR MALIGNO DE CÉLULAS DE GRANULOSA DE OVARIO"
  },
  {
    "codigo":123791008,
    "descripcion":"FIBRINÓGENO EN SANGRE POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":89188001,
    "descripcion":"EPITELIOPATÍA PIGMENTARIA PLACOIDEA MULTIFOCAL AGUDA"
  },
  {
    "codigo":285796007,
    "descripcion":"CAPAZ DE DESENVOLVERSE EN UN AMBIENTE FAMILIAR"
  },
  {
    "codigo":23652008,
    "descripcion":"DILATACIÓN CERVICAL, 3CM"
  },
  {
    "codigo":449636007,
    "descripcion":"MELANOMA MALIGNO DE PIEL DE PIERNA"
  },
  {
    "codigo":447801003,
    "descripcion":"ENDOMETRIO ENGROSADO"
  },
  {
    "codigo":283961004,
    "descripcion":"CONTUSIÓN DEL ÚTERO"
  },
  {
    "codigo":251193006,
    "descripcion":"ONDA P CON DESVIACIÓN DEL EJE HACIA LA IZQUIERDA"
  },
  {
    "codigo":331961000119108,
    "descripcion":"AMBLIOPÍA POR ESTRABISMO DEL OJO DERECHO"
  },
  {
    "codigo":249358001,
    "descripcion":"LUXACIÓN CAUDAL DEL TABIQUE NASAL"
  },
  {
    "codigo":773646003,
    "descripcion":"DEFICIENCIA DE ANTICUERPOS ASOCIADO A PLCG2 Y DESREGULACIÓN INMUNE"
  },
  {
    "codigo":216590004,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ANTICOLINESTERASA"
  },
  {
    "codigo":18147000,
    "descripcion":"LESIÓN TRAUMÁTICA DE COLON CON HERIDA ABIERTA HACIA CAVIDAD ABDOMINAL"
  },
  {
    "codigo":11774291000119105,
    "descripcion":"CONTUSIÓN DE PULGAR DERECHO"
  },
  {
    "codigo":704440004,
    "descripcion":"DEPENDIENTE PARA EL ACICALAMIENTO PERSONAL"
  },
  {
    "codigo":737208005,
    "descripcion":"TRAUMATISMO PERINATAL SUPERFICIAL DE PARTES BLANDAS DEBIDO A LESIÓN OBSTÉTRICA"
  },
  {
    "codigo":2541000124102,
    "descripcion":"INCISIVO CENTRAL SUPERIOR IZQUIERDO PERMANENTE SUPERNUMERARIO"
  },
  {
    "codigo":440301000124106,
    "descripcion":"VELOCIDAD DE CRECIMIENTO MENOR QUE LA ESPERADA"
  },
  {
    "codigo":276621003,
    "descripcion":"LESIÓN DEL CUERO CABELLUDO DEL NEONATO"
  },
  {
    "codigo":702605005,
    "descripcion":"TRASTORNO DE TENDÓN DE AQUILES"
  },
  {
    "codigo":243853007,
    "descripcion":"SITUACIÓN DEL MONITOREO DE ENFERMEDAD RESPIRATORIA"
  },
  {
    "codigo":1259661008,
    "descripcion":"DEMENCIA DEBIDA A TRASTORNO INFLAMATORIO DE APARATO MUSCULOESQUELÉTICO"
  },
  {
    "codigo":373090000,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE CUADRANTE INFEROINTERNO DE MAMA"
  },
  {
    "codigo":405858001,
    "descripcion":"FENOTIPO JK(A-B+)"
  },
  {
    "codigo":305719002,
    "descripcion":"NEUROMIOTONÍA"
  },
  {
    "codigo":698935005,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: CHUANG"
  },
  {
    "codigo":830007006,
    "descripcion":"AUSENCIA DE SENSIBILIDAD VIBRATORIA DE PIE IZQUIERDO"
  },
  {
    "codigo":1255991006,
    "descripcion":"RUPTURA TRAUMÁTICA DE PLACA PALMAR DE ARTICULACIÓN DE DEDO MEDIO DE MANO"
  },
  {
    "codigo":402188000,
    "descripcion":"DERMATITIS ATÓPICA AGRAVADA POR REACCIÓN INMUNITARIA DEL TIPO 1"
  },
  {
    "codigo":8972001,
    "descripcion":"TEMBLOR POSTHEMIPLÉJICO"
  },
  {
    "codigo":404023006,
    "descripcion":"SCHWANNOMA ANTIGUO"
  },
  {
    "codigo":41740005,
    "descripcion":"ANEURISMA DE ARTERIA AXILAR"
  },
  {
    "codigo":302049001,
    "descripcion":"SECUELA DE TRASTORNO"
  },
  {
    "codigo":39905002,
    "descripcion":"SÍNDROME DE LA CIMITARRA"
  },
  {
    "codigo":269281006,
    "descripcion":"EFECTO NO LETAL DE LA CORRIENTE ELÉCTRICA"
  },
  {
    "codigo":332982000,
    "descripcion":"VÓMITOS INCONTROLABLES"
  },
  {
    "codigo":236513009,
    "descripcion":"LINFOMA DE RIÑÓN"
  },
  {
    "codigo":38070000,
    "descripcion":"COHABITACIÓN"
  },
  {
    "codigo":267446004,
    "descripcion":"HIPEROSMOLALIDAD Y\/O HIPERNATREMIA"
  },
  {
    "codigo":300214005,
    "descripcion":"SIN RESPUESTA A LOS SONIDOS DE FRECUENCIA BAJA"
  },
  {
    "codigo":103606006,
    "descripcion":"FACIES DE MÁSCARA"
  },
  {
    "codigo":726198007,
    "descripcion":"LACERACIÓN DE TENDÓN DE MÚSCULO INTRÍNSECO DEL PULGAR"
  },
  {
    "codigo":429451003,
    "descripcion":"TRASTORNO RELACIONADO CON TRASPLANTE RENAL"
  },
  {
    "codigo":200075005,
    "descripcion":"REACCIÓN TÓXICA CAUSADA POR ANESTÉSICO LOCAL DURANTE EL TRABAJO DE PARTO Y EL PARTO"
  },
  {
    "codigo":298379008,
    "descripcion":"HALLAZGO RELACIONADO CON LA COLUMNA VERTEBRAL"
  },
  {
    "codigo":296544002,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE NISTATINA"
  },
  {
    "codigo":722528008,
    "descripcion":"NEOPLASIA MALIGNA NEUROENDOCRINA PRIMARIA DE PULMÓN"
  },
  {
    "codigo":425781002,
    "descripcion":"DOLOR PROVOCADO POR CORRER"
  },
  {
    "codigo":1144842001,
    "descripcion":"CAPAZ DE REALIZAR TAREAS DOMÉSTICAS"
  },
  {
    "codigo":127199000,
    "descripcion":"LINFADENOPATÍA INGUINAL"
  },
  {
    "codigo":61663001,
    "descripcion":"LIPOFUSCINOSIS CEROIDE NEURONAL JUVENIL"
  },
  {
    "codigo":782559003,
    "descripcion":"ASMA QUE NUNCA CAUSA SÍNTOMAS NOCTURNOS"
  },
  {
    "codigo":291039003,
    "descripcion":"INTOXICACIÓN POR LORMETAZEPAM"
  },
  {
    "codigo":94431005,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE MÚSCULO DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":92596003,
    "descripcion":"CARCINOMA IN SITU DEL PREPUCIO"
  },
  {
    "codigo":59828008,
    "descripcion":"CRISIS HEMOLÍTICA"
  },
  {
    "codigo":254601002,
    "descripcion":"SARCOMA DE HÍGADO"
  },
  {
    "codigo":57993004,
    "descripcion":"DISPLASIA MAMARIA BENIGNA"
  },
  {
    "codigo":25225006,
    "descripcion":"ENFERMEDAD CAUSADA POR ADENOVIRUS"
  },
  {
    "codigo":287369006,
    "descripcion":"INFECCIÓN CAUSADA POR SPOROTRICHUM GOUGEROTII"
  },
  {
    "codigo":15708961000119108,
    "descripcion":"LUXACIÓN RECURRENTE DE AMBAS ARTICULACIONES DE PIES"
  },
  {
    "codigo":711518002,
    "descripcion":"BOCIO HIPERPLÁSICO DIFUSO"
  },
  {
    "codigo":308001000119109,
    "descripcion":"HIPERLAXITUD ARTICULAR DE RODILLA IZQUIERDA"
  },
  {
    "codigo":88926005,
    "descripcion":"TRASTORNO DEL SUEÑO INDUCIDO POR OPIOIDE"
  },
  {
    "codigo":1137502009,
    "descripcion":"DEBILIDAD DE MÚSCULO INTERCOSTAL"
  },
  {
    "codigo":285534009,
    "descripcion":"DIFICULTAD PARA MOVER LA LÁMINA DE LA LENGUA"
  },
  {
    "codigo":10632751000119100,
    "descripcion":"ABSCESO DE PIEL DE HOMBRO DERECHO"
  },
  {
    "codigo":87091005,
    "descripcion":"INANICIÓN PARCIAL"
  },
  {
    "codigo":687151000119101,
    "descripcion":"NEUROFIBROMA DE TRONCO"
  },
  {
    "codigo":21555006,
    "descripcion":"OSTEÍTIS DE LA MANO"
  },
  {
    "codigo":10676271000119104,
    "descripcion":"EXACERBACIÓN AGUDA DE ASMA ALÉRGICO PERSISTENTE MODERADO"
  },
  {
    "codigo":15637551000119104,
    "descripcion":"RUPTURA DEGENERATIVA DE MENISCO INTERNO DE AMBAS RODILLAS"
  },
  {
    "codigo":12237871000119106,
    "descripcion":"TROMBOSIS AGUDA DE VENA SUPERFICIAL DE MIEMBRO SUPERIOR DERECHO"
  },
  {
    "codigo":15988271000119102,
    "descripcion":"ANOMALÍA CONGÉNITA DE SISTEMA DE DRENAJE LAGRIMAL DERECHO"
  },
  {
    "codigo":341551000119104,
    "descripcion":"AGRANDAMIENTO CRÓNICO DE GLÁNDULA LAGRIMAL IZQUIERDA"
  },
  {
    "codigo":16024111000119109,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DEBIDO A OCLUSIÓN DE ARTERIA CARÓTIDA IZQUIERDA"
  },
  {
    "codigo":10868271000119104,
    "descripcion":"SOBREDOSIS DE AGENTE ANTITUSIVO"
  },
  {
    "codigo":136751000119108,
    "descripcion":"TROMBOSIS VENOSA PROFUNDA CRÓNICA DE EXTREMIDAD SUPERIOR COMO COMPLICACIÓN DE PROCEDIMIENTO"
  },
  {
    "codigo":10637871000119103,
    "descripcion":"NECROSIS DE MÚSCULO DE TOBILLO CONCOMITANTE CON ÚLCERA CRÓNICA DE TOBILLO Y DEBIDA A ELLA"
  },
  {
    "codigo":707848009,
    "descripcion":"EL PACIENTE NIEGA EL USO DE DROGAS"
  },
  {
    "codigo":1071000119107,
    "descripcion":"LESIÓN BUCAL"
  },
  {
    "codigo":16057391000119108,
    "descripcion":"NEURALGIA DE NERVIO GLOSOFARÍNGEO DERECHO"
  },
  {
    "codigo":16039471000119108,
    "descripcion":"CONDROMALACIA DE PIE IZQUIERDO"
  },
  {
    "codigo":90671000119109,
    "descripcion":"PORTADOR DE MUTACIÓN GENÉTICA DE ALTO RIESGO DE CÁNCER"
  },
  {
    "codigo":308271000119109,
    "descripcion":"DEFORMIDAD EN FLEXIÓN DE ARTICULACIÓN DE HOMBRO DERECHO"
  },
  {
    "codigo":17885001,
    "descripcion":"DEFECTO EN LA DESYODINACIÓN DE LA YODOTIROSINA"
  },
  {
    "codigo":83421005,
    "descripcion":"IMPOSIBILIDAD PARA PERDER PESO"
  },
  {
    "codigo":91221000119102,
    "descripcion":"MELANOMA MALIGNO METASTÁSICO DE PLEURA"
  },
  {
    "codigo":212658003,
    "descripcion":"INTOXICACIÓN CON ESPIPERONA"
  },
  {
    "codigo":240051007,
    "descripcion":"DISTROFIA MUSCULAR DE LA CINTURA DE LAS EXTREMIDADES CON DISTROFINA NORMAL, LIGADA AL CROMOSOMA X"
  },
  {
    "codigo":704178006,
    "descripcion":"FRACTURA NO EXPUESTA DE CUELLO DE TERCER METACARPIANO"
  },
  {
    "codigo":702343002,
    "descripcion":"MIOPATÍA DE COMIENZO TEMPRANO CON MIOCARDIOPATÍA FATAL"
  },
  {
    "codigo":336981000119105,
    "descripcion":"HEMORRAGIA DE CUERPO VÍTREO IZQUIERDO"
  },
  {
    "codigo":274524001,
    "descripcion":"ELECTRORRETINOGRAMA ANORMAL"
  },
  {
    "codigo":440199008,
    "descripcion":"INTERNACIÓN PSIQUIÁTRICA PROLONGADA"
  },
  {
    "codigo":241756003,
    "descripcion":"INTOXICACIÓN CAUSADA POR AGENTE ANESTÉSICO"
  },
  {
    "codigo":1259399008,
    "descripcion":"CARCINOMA PRIMARIO DE COLÉDOCO"
  },
  {
    "codigo":766044005,
    "descripcion":"ENCEFALOPATÍA AGUDA CON CONVULSIONES BIFÁSICAS Y DIFUSIÓN TARDÍA DISMINUIDA"
  },
  {
    "codigo":733276006,
    "descripcion":"FRACTURA DE CABEZA DE FÉMUR"
  },
  {
    "codigo":12380008,
    "descripcion":"DISFUNCIÓN SEXUAL INDUCIDA POR SEDANTES, HIPNÓTICOS Y\/O ANSIOLÍTICOS"
  },
  {
    "codigo":305457001,
    "descripcion":"BAJO ATENCIÓN DE MÉDICO GENERAL ADJUNTO"
  },
  {
    "codigo":10632431000119101,
    "descripcion":"ABSCESO DE MUSLO IZQUIERDO"
  },
  {
    "codigo":239921005,
    "descripcion":"ENFERMEDAD DE BEHCET CON COMPROMISO ORGÁNICO\/SISTÉMICO"
  },
  {
    "codigo":403761005,
    "descripcion":"SÍNDROME POLI Y"
  },
  {
    "codigo":698673007,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: MAORÍ"
  },
  {
    "codigo":1255729008,
    "descripcion":"NEOPLASIA MASTOCITARIA MALIGNA DE GANGLIOS LINFÁTICOS DE CABEZA"
  },
  {
    "codigo":10878191000119102,
    "descripcion":"HERIDA POR DISPARO DE ARMA DE FUEGO DE NALGA DERECHA"
  },
  {
    "codigo":310511000119103,
    "descripcion":"INFECCIÓN PIÓGENA DE DISCO INTERVERTEBRAL LUMBAR"
  },
  {
    "codigo":762374005,
    "descripcion":"PARESTESIA DE DEDO DE LA MANO"
  },
  {
    "codigo":860678007,
    "descripcion":"EMBOLIA DE COÁGULO SANGUÍNEO DEBIDA A EMBARAZO MOLAR Y POSTERIOR A ÉL"
  },
  {
    "codigo":41478008,
    "descripcion":"DEFORMIDAD CORNEAL"
  },
  {
    "codigo":39643002,
    "descripcion":"ATRAGANTAMIENTO DEBIDO A PRESENCIA DE ALIMENTO EN LARINGE"
  },
  {
    "codigo":203483005,
    "descripcion":"OSTEONECROSIS DE HUESO CAUSADA POR FÁRMACO"
  },
  {
    "codigo":400091006,
    "descripcion":"NEVO DE TEJIDO CONJUNTIVO DE LA PIEL"
  },
  {
    "codigo":365488006,
    "descripcion":"HALLAZGO RELACIONADO CON DISPONIBILIDAD DE AYUDA DE CUIDADOR NO PROFESIONAL"
  },
  {
    "codigo":299952008,
    "descripcion":"SEUDOATETOSIS"
  },
  {
    "codigo":134277001,
    "descripcion":"LEE HINDÚ"
  },
  {
    "codigo":70576008,
    "descripcion":"ENCEFALOMIELITIS ENTEROVIRAL"
  },
  {
    "codigo":298117009,
    "descripcion":"LESIÓN DE NERVIO AXILAR"
  },
  {
    "codigo":1370007,
    "descripcion":"FRACTURA EXPUESTA DE HUESO METACARPIANO"
  },
  {
    "codigo":230746009,
    "descripcion":"1 HIDROCEFALIA OBSTRUCTIVA"
  },
  {
    "codigo":196143003,
    "descripcion":"ATELECTASIA POSQUIRÚRGICA"
  },
  {
    "codigo":294447005,
    "descripcion":"ALERGIA A VIOLETA CRISTAL"
  },
  {
    "codigo":30468000,
    "descripcion":"DOLICOCOLON"
  },
  {
    "codigo":65071008,
    "descripcion":"LESIÓN TRAUMÁTICA DE TRACTO GASTROINTESTINAL SIN HERIDA ABIERTA HACIA CAVIDAD ABDOMINAL"
  },
  {
    "codigo":15685001000119105,
    "descripcion":"PERIOSTITIS DE FÉMURES BILATERALES"
  },
  {
    "codigo":1144580008,
    "descripcion":"APLASIA DE MÚSCULO DE PELVIS"
  },
  {
    "codigo":11998601000119107,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO DE MUSLO IZQUIERDO"
  },
  {
    "codigo":28633004,
    "descripcion":"MICROESTRABISMO"
  },
  {
    "codigo":61401005,
    "descripcion":"HEMORRAGIA GÁSTRICA"
  },
  {
    "codigo":59566000,
    "descripcion":"OLIGOAMNIOS"
  },
  {
    "codigo":288942001,
    "descripcion":"INCAPAZ DE DEGLUTIR COMIDA"
  },
  {
    "codigo":92334002,
    "descripcion":"NEOPLASIA BENIGNA DE OMÓPLATO"
  },
  {
    "codigo":421849009,
    "descripcion":"CÓRNEA PROLATE"
  },
  {
    "codigo":94169008,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LOS DOS TERCIOS ANTERIORES DE LA LENGUA"
  },
  {
    "codigo":188803001,
    "descripcion":"TUMOR BENIGNO DEL PISO NASOFARÍNGEO"
  },
  {
    "codigo":24963004,
    "descripcion":"ANOMALÍA CONGÉNITA DEL MÚSCULO ESTERNOCLEIDOMASTOIDEO"
  },
  {
    "codigo":287107004,
    "descripcion":"ASTILLA CLAVADA EN EL CUERO CABELLUDO"
  },
  {
    "codigo":156035004,
    "descripcion":"AMENORREA PRIMARIA"
  },
  {
    "codigo":57731009,
    "descripcion":"ORQUIEPIDIDIMITIS SIN ABSCESO"
  },
  {
    "codigo":23128002,
    "descripcion":"DILATACIÓN CERVICAL, 5CM"
  },
  {
    "codigo":285272003,
    "descripcion":"PLANES DE LLEVAR A CABO UN CRIMEN SEXUAL"
  },
  {
    "codigo":186968004,
    "descripcion":"GOMA Y ÚLCERAS DE FRAMBESIA"
  },
  {
    "codigo":416344006,
    "descripcion":"LATEROFLEXIÓN VERTEBRAL"
  },
  {
    "codigo":449112009,
    "descripcion":"PROLAPSO DE CÚSPIDE NO CORONARIA DE VÁLVULA AÓRTICA"
  },
  {
    "codigo":339491000119107,
    "descripcion":"PTOSIS MECÁNICA DE PÁRPADO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":283437002,
    "descripcion":"CORTE EN LA PANTORRILLA"
  },
  {
    "codigo":840493007,
    "descripcion":"ENFISEMA LOBULAR CONGÉNITO DE AMBOS PULMONES"
  },
  {
    "codigo":248834000,
    "descripcion":"OBSTRUCCIÓN DE CONDUCTO GALACTÓFORO"
  },
  {
    "codigo":281602002,
    "descripcion":"AVULSIÓN DE LIGAMENTO CON FRAGMENTO ÓSEO"
  },
  {
    "codigo":443607001,
    "descripcion":"MASA PALPABLE"
  },
  {
    "codigo":246999001,
    "descripcion":"DEPÓSITOS DE LA CÁMARA ANTERIOR"
  },
  {
    "codigo":707586009,
    "descripcion":"CARCINOMA MIOEPITELIAL PRIMARIO DE OROFARINGE"
  },
  {
    "codigo":83159006,
    "descripcion":"ENCEFALITIS POR CITOMEGALOVIRUS"
  },
  {
    "codigo":16697021000119105,
    "descripcion":"MALFORMACIÓN CONGÉNITA DE VENA RENAL DERECHA"
  },
  {
    "codigo":15788006,
    "descripcion":"CARTÍLAGO TIROIDES HENDIDO CONGÉNITO"
  },
  {
    "codigo":46721000,
    "descripcion":"TRASTORNO DE LA PERSONALIDAD ORGÁNICO CAUSADO POR SUSTANCIA PSICOACTIVA"
  },
  {
    "codigo":472705001,
    "descripcion":"ESTRECHAMIENTO DE CONDUCTO ARTERIOSO FETAL"
  },
  {
    "codigo":441772009,
    "descripcion":"PRESENCIA ANORMAL DE ALFA-FETOPROTEÍNA"
  },
  {
    "codigo":308865006,
    "descripcion":"DISPLASIA DE CONDUCTO PANCREÁTICO"
  },
  {
    "codigo":276097007,
    "descripcion":"EL CÓNYUGE RETORNÓ AL HOGAR"
  },
  {
    "codigo":765782003,
    "descripcion":"INFECCIÓN DE LA PIEL DEL PÁRPADO CAUSADA POR MOLUSCO CONTAGIOSO"
  },
  {
    "codigo":1290070009,
    "descripcion":"TUMOR NEUROENDOCRINO BIEN DIFERENCIADO DE INTESTINO"
  },
  {
    "codigo":403499002,
    "descripcion":"LUPUS ERITEMATOSO DISCOIDE DE LABIO"
  },
  {
    "codigo":10283004,
    "descripcion":"ESTENOSIS CONGÉNITA DE CONDUCTO CERVICAL"
  },
  {
    "codigo":40791000119105,
    "descripcion":"DIABETES MELLITUS GESTACIONAL POSPARTO"
  },
  {
    "codigo":303360005,
    "descripcion":"CAPAZ DE DETENER LA CARRERA"
  },
  {
    "codigo":1153493000,
    "descripcion":"NIVEL PLASMÁTICO DE CREATINQUINASA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":237824009,
    "descripcion":"ENFERMEDAD JUVENIL DE GRAVES"
  },
  {
    "codigo":235989004,
    "descripcion":"PERITONITIS POR ALMIDÓN"
  },
  {
    "codigo":301525006,
    "descripcion":"NO ENTRA NI SALE DE LA BAÑERA"
  },
  {
    "codigo":203221007,
    "descripcion":"OSTEOMIELITIS DE CÓCCIX"
  },
  {
    "codigo":135850005,
    "descripcion":"INFECCIÓN EN PUNTO DE SUTURA"
  },
  {
    "codigo":365226005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA SACARSE LOS ZAPATOS"
  },
  {
    "codigo":823978007,
    "descripcion":"NERVIO HIPOGLOSO INTACTO"
  },
  {
    "codigo":168618007,
    "descripcion":"RADIOGRAFÍA SIMPLE DE OMÓPLATO ANORMAL"
  },
  {
    "codigo":234154008,
    "descripcion":"ANEURISMA DE FÍSTULA ARTERIOVENOSA CONGÉNITA"
  },
  {
    "codigo":342001000119103,
    "descripcion":"ESCLERITIS ANTERIOR DE OJO IZQUIERDO"
  },
  {
    "codigo":266922007,
    "descripcion":"EX - FUMADOR LEVE DE CIGARRILLOS (1 - 9\/DÍA)"
  },
  {
    "codigo":166783005,
    "descripcion":"ALBÚMINA SÉRICA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":428927006,
    "descripcion":"NUEVA ISQUEMIA DE MIOCARDIO EN COMPARACIÓN CON ESTUDIO PREVIO"
  },
  {
    "codigo":232319009,
    "descripcion":"ACÚFENO DE ORIGEN MUSCULAR"
  },
  {
    "codigo":263252002,
    "descripcion":"FRACTURA DE BASE DE QUINTO METATARSIANO"
  },
  {
    "codigo":363391009,
    "descripcion":"NEOPLASIA MALIGNA DE ÁREA RETROMOLAR"
  },
  {
    "codigo":722004001,
    "descripcion":"AGENESIA DE ARTERIA CARÓTIDA INTERNA"
  },
  {
    "codigo":1108009,
    "descripcion":"ALOPECIA DE DISTRIBUCIÓN FEMENINA"
  },
  {
    "codigo":296020009,
    "descripcion":"SOBREDOSIS DE ZOLPIDEM"
  },
  {
    "codigo":195881003,
    "descripcion":"NEUMONÍA CAUSADA POR VIRUS SINCICIAL RESPIRATORIO"
  },
  {
    "codigo":95742008,
    "descripcion":"RECHAZO DE INJERTO CORNEAL"
  },
  {
    "codigo":28371001,
    "descripcion":"GRANULOMA DE COLESTEROL DE OÍDO MEDIO"
  },
  {
    "codigo":224979001,
    "descripcion":"FANTASÍA INCONSCIENTE"
  },
  {
    "codigo":1144318009,
    "descripcion":"PLIEGUE VERTICAL DE PIEL DE FRENTE"
  },
  {
    "codigo":93907002,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE MÚSCULO DE LA PELVIS"
  },
  {
    "codigo":716499005,
    "descripcion":"NO COMPRENDE INSTRUCCIONES DE UNA SOLA PALABRA"
  },
  {
    "codigo":1306323006,
    "descripcion":"NEOPLASIA MALIGNA CON METÁSTASIS A ARÉOLA"
  },
  {
    "codigo":292350008,
    "descripcion":"REACCIÓN ADVERSA AL ALPRAZOLAM"
  },
  {
    "codigo":126675008,
    "descripcion":"NEOPLASIA DE SENO PARANASAL"
  },
  {
    "codigo":714664001,
    "descripcion":"CON MAYOR RIESGO DE ÚLCERA DE PIE DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":288680002,
    "descripcion":"NO FINALIZA UNA CONVERSACIÓN"
  },
  {
    "codigo":92072003,
    "descripcion":"NEOPLASIA BENIGNA DE CONDUCTO CRANEOFARÍNGEO"
  },
  {
    "codigo":419752005,
    "descripcion":"TAQUICARDIA NODAL POR REENTRADA SINOAURICULAR"
  },
  {
    "codigo":188541000,
    "descripcion":"GRANULOMA DE HODGKIN DE GANGLIOS LINFÁTICOS DE MÚLTIPLES LOCALIZACIONES"
  },
  {
    "codigo":1237117000,
    "descripcion":"ÚLCERA VENOSA DE PIERNA"
  },
  {
    "codigo":1204349002,
    "descripcion":"ESCLEROSIS LATERAL AMIOTRÓFICA TIPO 7"
  },
  {
    "codigo":57469000,
    "descripcion":"ABORTO ESPONTÁNEO CON INSUFICIENCIA RENAL AGUDA"
  },
  {
    "codigo":88402000,
    "descripcion":"EPIDERMOPOYESIS NORMAL"
  },
  {
    "codigo":286845008,
    "descripcion":"TIENDE A CRITICAR A LOS DEMÁS"
  },
  {
    "codigo":874834005,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DEL PENE"
  },
  {
    "codigo":186706006,
    "descripcion":"ENFERMEDAD GENERALIZADA POR EL VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":1004071000,
    "descripcion":"CONTRACTURA EN FLEXIÓN CONGÉNITA DE ARTICULACIÓN DE PIE"
  },
  {
    "codigo":285010009,
    "descripcion":"INCAPAZ DE AJUSTAR LA ROPA"
  },
  {
    "codigo":55634009,
    "descripcion":"HEMIANOPSIA HOMÓNIMA IZQUIERDA"
  },
  {
    "codigo":414247004,
    "descripcion":"TRASTORNO FETAL DEBIDO A HEMORRAGIA MATERNA PREPARTO"
  },
  {
    "codigo":283175007,
    "descripcion":"CUERPO EXTRAÑO METÁLICO EN LA CADERA"
  },
  {
    "codigo":445180002,
    "descripcion":"MARCADOR GENÉTICO DE SUSCEPTIBILIDAD A CÁNCER DE MAMA NEGATIVO"
  },
  {
    "codigo":1264380003,
    "descripcion":"LACERACIÓN DE TENDÓN DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":248572004,
    "descripcion":"ADOPTA UNA POSTURA PARTICULAR PARA RESPIRAR"
  },
  {
    "codigo":314108007,
    "descripcion":"ADHERENCIAS DE LA ARTICULACIÓN DE LA RODILLA"
  },
  {
    "codigo":115665000,
    "descripcion":"ATOPIA"
  },
  {
    "codigo":82897000,
    "descripcion":"ALUMBRAMIENTO ESPONTÁNEO DE PLACENTA, MECANISMO DE BAUDELOQUE - DUNCAN"
  },
  {
    "codigo":410577002,
    "descripcion":"SÍNDROME DE ENMASCARAMIENTO"
  },
  {
    "codigo":707324008,
    "descripcion":"ANEMIA CON ENFERMEDAD RENAL TERMINAL CONCOMITANTE Y DEBIDA A ELLA"
  },
  {
    "codigo":17361004,
    "descripcion":"RESPIRACIÓN TRAQUEAL"
  },
  {
    "codigo":344511000119102,
    "descripcion":"QUERATOCONJUNTIVITIS FLICTENULAR DE AMBOS OJOS"
  },
  {
    "codigo":769190000,
    "descripcion":"RETINOPATÍA NO PROLIFERATIVA MUY SEVERA DE OJO DERECHO DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":310438004,
    "descripcion":"CITOLOGÍA URINARIA NORMAL"
  },
  {
    "codigo":308603004,
    "descripcion":"SITUACIÓN DE EXENCIÓN PARA EL USO DE CINTURÓN DE SEGURIDAD"
  },
  {
    "codigo":110160009,
    "descripcion":"ABRASIÓN DEL PALADAR BLANDO"
  },
  {
    "codigo":1255205002,
    "descripcion":"RUPTURA TRAUMÁTICA DE LIGAMENTO CRUZADO DE ARTICULACIÓN DE RODILLA"
  },
  {
    "codigo":370469003,
    "descripcion":"SEROSITIS"
  },
  {
    "codigo":403237004,
    "descripcion":"COLOR CONSTITUCIONAL DE LA PIEL, BLANCA PÁLIDA"
  },
  {
    "codigo":1081791000119108,
    "descripcion":"SEMINOMA PRIMARIO DE TESTÍCULO IZQUIERDO NO DESCENDIDO"
  },
  {
    "codigo":8186001,
    "descripcion":"CORAZÓN AGRANDADO"
  },
  {
    "codigo":237562002,
    "descripcion":"SÍNDROME DE DEFICIENCIA DE YODO"
  },
  {
    "codigo":303098002,
    "descripcion":"DEFICIENCIA DE 3-FOSFOGLICERATO DESHIDROGENASA"
  },
  {
    "codigo":399567000,
    "descripcion":"TUMOR QUE INVADE ÁNGULO IRIDOCORNEAL"
  },
  {
    "codigo":301263004,
    "descripcion":"MATIDEZ CARDÍACA A LA PERCUSIÓN NORMAL"
  },
  {
    "codigo":235727006,
    "descripcion":"MALABSORCIÓN POSINFECCIOSA"
  },
  {
    "codigo":168356000,
    "descripcion":"ORGANISMO NO AISLADO EN CULTIVO DE HISOPADO CERVICAL"
  },
  {
    "codigo":233892002,
    "descripcion":"TAQUICARDIA AURICULAR ECTÓPICA"
  },
  {
    "codigo":12114521000119106,
    "descripcion":"QUEMADURA QUÍMICA DE BRAZO IZQUIERDO"
  },
  {
    "codigo":397732007,
    "descripcion":"DISFUNCIÓN NEUROGÉNICA DE VEJIGA URINARIA"
  },
  {
    "codigo":364964008,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD DE MOVER LA LÁMINA DE LA LENGUA"
  },
  {
    "codigo":461433002,
    "descripcion":"ARTERIA COLATERAL MAYOR QUE DERIVA EL FLUJO SISTÉMICO HACIA LA CIRCULACIÓN PULMONAR CON ARTERIAS PULMONARES PROXIMALES A LA BIFURCACIÓN HILIAR AUSENTES"
  },
  {
    "codigo":232057003,
    "descripcion":"SÍNDROME DE USHER TIPO 1"
  },
  {
    "codigo":318041000119108,
    "descripcion":"ARTRITIS REACTIVA DE ARTICULACIÓN DE CADERA IZQUIERDA DEBIDA A DISENTERÍA Y POSTERIOR A ELLA"
  },
  {
    "codigo":230222003,
    "descripcion":"TROMBOFLEBITIS SÉPTICA DEL SENO RECTO"
  },
  {
    "codigo":240520005,
    "descripcion":"FIEBRE POR ORBIVIRUS TRANSMITIDA POR EL MOSQUITO SIMÚLIDO"
  },
  {
    "codigo":721742004,
    "descripcion":"OTITIS MEDIA CAUSADA POR STREPTOCOCCUS PNEUMONIAE"
  },
  {
    "codigo":293923000,
    "descripcion":"ALERGIA A DROPERIDOL"
  },
  {
    "codigo":71691000146104,
    "descripcion":"USO DE ESTEROIDES"
  },
  {
    "codigo":262990008,
    "descripcion":"ESGUINCE DEL ANTEBRAZO"
  },
  {
    "codigo":228387001,
    "descripcion":"SE INYECTA DROGAS POR VÍA INTRAMUSCULAR"
  },
  {
    "codigo":719907006,
    "descripcion":"SÍNDROME DE TIMOTHY TIPO 2"
  },
  {
    "codigo":292088001,
    "descripcion":"REACCIÓN ADVERSA AL SULINDAC"
  },
  {
    "codigo":95480008,
    "descripcion":"LENTICONO ANTERIOR"
  },
  {
    "codigo":421325001,
    "descripcion":"LENTE INTRAOCULAR EN CÁMARA ANTERIOR PRESENTE"
  },
  {
    "codigo":93645003,
    "descripcion":"MELANOMA MALIGNO DE LA PIEL DEL HUECO POPLÍTEO"
  },
  {
    "codigo":290253003,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR FENOPROFENO"
  },
  {
    "codigo":288418009,
    "descripcion":"CAPAZ DE ENHEBRAR UNA AGUJA"
  },
  {
    "codigo":57207003,
    "descripcion":"QUERATOPATÍA BULLOSA"
  },
  {
    "codigo":253815007,
    "descripcion":"ANOMALÍA DE CONDUCTO PANCREÁTICO"
  },
  {
    "codigo":413985002,
    "descripcion":"EQUIPARACIÓN DE LA PRESIÓN DIASTÓLICA"
  },
  {
    "codigo":446753005,
    "descripcion":"TUBERCULOSIS DE OROFARINGE"
  },
  {
    "codigo":248310000,
    "descripcion":"GRASA CORPORAL EN LA PARTE SUPERIOR DEL CUERPO, AUMENTADA"
  },
  {
    "codigo":250145009,
    "descripcion":"CALZADO MUY HOLGADO"
  },
  {
    "codigo":347021000119109,
    "descripcion":"PTERIGIÓN CENTRAL BILATERAL"
  },
  {
    "codigo":1264118005,
    "descripcion":"ADENOCARCINOMA OXIFÍLICO METASTÁSICO"
  },
  {
    "codigo":444918006,
    "descripcion":"SECUELA DE ENFERMEDAD HEPÁTICA CRÓNICA"
  },
  {
    "codigo":182774007,
    "descripcion":"CONSENTIMIENTO PARA DONACIÓN DE ÓRGANOS OTORGADO"
  },
  {
    "codigo":17099003,
    "descripcion":"AGOTAMIENTO DE MÚSCULO PERIFÉRICO"
  },
  {
    "codigo":82635007,
    "descripcion":"URETRA ACCESORIA"
  },
  {
    "codigo":1293216000,
    "descripcion":"OSTEOCONDROMIXOMA"
  },
  {
    "codigo":703392003,
    "descripcion":"DISPLASIA ERITROIDE DE MÉDULA ÓSEA"
  },
  {
    "codigo":111733004,
    "descripcion":"EFECTO TARDÍO DE LAS COMPLICACIONES DE UN TRAUMATISMO"
  },
  {
    "codigo":373877006,
    "descripcion":"COMPONENTE INSUFICIENTE DE LA ZONA ENDOCERVICAL\/DE TRANSFORMACIÓN EN ESPÉCIMEN CERVICAL"
  },
  {
    "codigo":294081000119102,
    "descripcion":"CEFALEA RESISTENTE AL TRATAMIENTO CAUSADA POR FÁRMACO"
  },
  {
    "codigo":208202002,
    "descripcion":"RUPTURA TOTAL NO EXPUESTA DE LA SÍNFISIS PÚBICA"
  },
  {
    "codigo":404810003,
    "descripcion":"TUMOR NEUROENDOCRINO SECRETOR DE 5-HIDROXITRIPTAMINA"
  },
  {
    "codigo":109898005,
    "descripcion":"INDICACIÓN PARA LA MODIFICACIÓN DEL ESTADO COGNITIVO DEL PACIENTE"
  },
  {
    "codigo":348126401000119103,
    "descripcion":"FRACTURA ABIERTA DE PARED SUPERIOR DE ÓRBITA DERECHA"
  },
  {
    "codigo":44362006,
    "descripcion":"ENFERMEDAD POR EL VIRUS TACAIUMA"
  },
  {
    "codigo":370207001,
    "descripcion":"ASMA QUE LIMITA LA MARCHA EN PENDIENTE O EN ESCALERAS"
  },
  {
    "codigo":402975004,
    "descripcion":"TUBERCÚLIDE INDUCIDA POR BCG"
  },
  {
    "codigo":75295004,
    "descripcion":"HECES DURAS"
  },
  {
    "codigo":239135006,
    "descripcion":"LENTIGINOSIS GENITAL"
  },
  {
    "codigo":173599005,
    "descripcion":"GINGIVOESTOMATITIS ULCEROSA AGUDA NECROSANTE"
  },
  {
    "codigo":1287711008,
    "descripcion":"TUMOR NEUROENDOCRINO BIEN DIFERENCIADO DE VESÍCULA BILIAR"
  },
  {
    "codigo":302836005,
    "descripcion":"LENTIGO MALIGNO"
  },
  {
    "codigo":237300009,
    "descripcion":"EMBARAZO CON ISOINMUNIZACIÓN"
  },
  {
    "codigo":827124009,
    "descripcion":"MOVIMIENTO DE MASA ABDOMINAL DURANTE LA RESPIRACIÓN"
  },
  {
    "codigo":169929003,
    "descripcion":"PUNTAJE DE APGAR A LOS 10 MINUTOS = 6"
  },
  {
    "codigo":366537004,
    "descripcion":"HALLAZGO RELACIONADO CON LA AMPLITUD DE LA SUPINACIÓN DE LA MUÑECA"
  },
  {
    "codigo":1086811000119101,
    "descripcion":"HEMORRAGIA POR ESOFAGOSTOMÍA"
  },
  {
    "codigo":11818331000119102,
    "descripcion":"ESGUINCE DE LIGAMENTO DE ARTICULACIÓN METACARPOFALÁNGICA DE PULGAR IZQUIERDO"
  },
  {
    "codigo":399305009,
    "descripcion":"CATARATA NO SENIL"
  },
  {
    "codigo":102558002,
    "descripcion":"EDEMA DE LA EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":299166002,
    "descripcion":"SIN AMPLITUD ACTIVA DE ABDUCCIÓN DE PULGAR"
  },
  {
    "codigo":301001009,
    "descripcion":"NEUMONÍA DE LÓBULO INFERIOR DERECHO"
  },
  {
    "codigo":21851000119103,
    "descripcion":"FEOCROMOCITOMA MALIGNO"
  },
  {
    "codigo":233630006,
    "descripcion":"BRONQUIECTASIA OBSTRUCTIVA"
  },
  {
    "codigo":35187000,
    "descripcion":"SIGNO DE CULLEN"
  },
  {
    "codigo":725150008,
    "descripcion":"SUSCEPTIBILIDAD MENDELIANA AUTOSÓMICA DOMINANTE A ENFERMEDAD CAUSADA POR MICOBACTERIAS DEBIDA A DEFICIENCIA PARCIAL DE RECEPTOR 1 DE INTERFERÓN GAMMA"
  },
  {
    "codigo":231795004,
    "descripcion":"LACERACIÓN DEL GLOBO OCULAR"
  },
  {
    "codigo":262728001,
    "descripcion":"SECCIÓN PARCIAL DE LA RAÍZ DE NERVIO ESPINAL"
  },
  {
    "codigo":197192003,
    "descripcion":"ADHERENCIAS DUODENALES"
  },
  {
    "codigo":721480004,
    "descripcion":"SÍNDROME DEL CORDÓN POSTERIOR DE MÉDULA ESPINAL AL NIVEL DEL DECIMOSEGUNDO SEGMENTO DORSAL"
  },
  {
    "codigo":129821003,
    "descripcion":"RECUPERACIÓN POSQUIRÚRGICA RETARDADA"
  },
  {
    "codigo":228125004,
    "descripcion":"INTERRUPCIÓN DEL PROCESO DE ASIGNACIÓN DE UN NIÑO"
  },
  {
    "codigo":719645005,
    "descripcion":"HIFAS NO TABICADAS DEL REINO FUNGI DETECTADAS"
  },
  {
    "codigo":291826001,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR PROGESTÁGENO"
  },
  {
    "codigo":259058004,
    "descripcion":"MEGACOLON ADQUIRIDO EN INFANCIA"
  },
  {
    "codigo":95218005,
    "descripcion":"DISGENESIA GONADAL PURA 46, XY"
  },
  {
    "codigo":160754004,
    "descripcion":"INQUILINO DESALOJADO"
  },
  {
    "codigo":816114007,
    "descripcion":"MIEMBRO INFERIOR IZQUIERDO AMPUTADO POR ENCIMA DE LA RODILLA"
  },
  {
    "codigo":1078258007,
    "descripcion":"AGENESIA DE EPÍFISIS DE FALANGE DISTAL DE TERCER DEDO DE PIE"
  },
  {
    "codigo":289991000,
    "descripcion":"MANEJA LOS BROCHES PARA LA ROPA"
  },
  {
    "codigo":421063002,
    "descripcion":"CÓRNEA PLANA"
  },
  {
    "codigo":86451008,
    "descripcion":"INFECCIÓN CAUSADA POR HAEMATOXENUS"
  },
  {
    "codigo":191687005,
    "descripcion":"PSICOSIS QUE SE ORIGINA DURANTE LA INFANCIA"
  },
  {
    "codigo":1141959006,
    "descripcion":"COMPORTAMIENTO RELACIONADO CON ANSIEDAD ANORMAL"
  },
  {
    "codigo":93383007,
    "descripcion":"DESALINEAMIENTO CONGÉNITO DEL CENTRO DE LA VÉRTEBRA DORSAL"
  },
  {
    "codigo":879815008,
    "descripcion":"HIPERTENSIÓN PULMONAR POR ENFERMEDAD VENOCLUSIVA PULMONAR"
  },
  {
    "codigo":224455007,
    "descripcion":"SOLICITA LICENCIA SIN GOCE DE SUELDO"
  },
  {
    "codigo":58780002,
    "descripcion":"ANEURISMA ARTERIAL FALSO"
  },
  {
    "codigo":124316006,
    "descripcion":"DEFICIENCIA DE NAD^+^ CINASA"
  },
  {
    "codigo":1172892009,
    "descripcion":"SUSCEPTIBILIDAD MENDELIANA AUTOSÓMICA RECESIVA A ENFERMEDADES MICOBACTERIANAS POR DEFICIENCIA COMPLETA DEL RECEPTOR RORGAMMA"
  },
  {
    "codigo":296591000119101,
    "descripcion":"DISPLASIA FIBROSA MONOSTÓTICA DE HUESO DE CINTURA ESCAPULAR"
  },
  {
    "codigo":1269361003,
    "descripcion":"CRISIS EPILÉPTICA TÓNICA CON CONCIENCIA PRESERVADA DE INICIO FOCAL"
  },
  {
    "codigo":417393008,
    "descripcion":"BOLA DE NIEVE EN CUERPO VÍTREO"
  },
  {
    "codigo":218950001,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR AGENTE DIGESTIVO"
  },
  {
    "codigo":448326002,
    "descripcion":"VENA CAVA INFERIOR DERECHA CONECTADA A AURÍCULAS IZQUIERDA Y DERECHA"
  },
  {
    "codigo":122481008,
    "descripcion":"DEDO DE PIE EN MARTILLO"
  },
  {
    "codigo":186182003,
    "descripcion":"TUBERCULOSIS DE PLEURA"
  },
  {
    "codigo":253553008,
    "descripcion":"DEFECTO PERIMEMBRANOSO DEL TABIQUE INTERVENTRICULAR CON EXTENSIÓN HACIA EL COMPONENTE TRABECULAR DEL VENTRÍCULO DERECHO"
  },
  {
    "codigo":284486006,
    "descripcion":"CARENTE DE AFECTO"
  },
  {
    "codigo":315419005,
    "descripcion":"NACIDO EN EGIPTO"
  },
  {
    "codigo":249883009,
    "descripcion":"CAÍDA DEL PALADAR BLANDO"
  },
  {
    "codigo":280816001,
    "descripcion":"PARÁLISIS FACIAL"
  },
  {
    "codigo":1003547009,
    "descripcion":"AGENESIA DE URÉTER"
  },
  {
    "codigo":248048004,
    "descripcion":"HUIR DE LA ESCUELA"
  },
  {
    "codigo":84208005,
    "descripcion":"AMPOLLA DE CODO, SIN INFECCIÓN"
  },
  {
    "codigo":49605003,
    "descripcion":"MIGRAÑA OFTALMOPLÉJICA"
  },
  {
    "codigo":410053003,
    "descripcion":"MANIFESTACIÓN CLÍNICA DE DEFICIENCIA ENZIMÁTICA"
  },
  {
    "codigo":1260186005,
    "descripcion":"CICATRIZ DE CEJA DE REGIÓN DE OJO DERECHO"
  },
  {
    "codigo":735898005,
    "descripcion":"LACERACIÓN DE ARTERIA PLANTAR DE PIE"
  },
  {
    "codigo":106281000119103,
    "descripcion":"DIABETES MELLITUS PREEXISTENTE EN LA MADRE QUE COMPLICA EL NACIMIENTO"
  },
  {
    "codigo":352041000119103,
    "descripcion":"CARCINOMA DE CÉLULAS DE MERKEL PRIMARIO DE PIEL DE EXTREMIDAD SUPERIOR IZQUIERDA"
  },
  {
    "codigo":768666006,
    "descripcion":"ENCEFALOPATÍA POR PROTEÍNA 1 DE UNIÓN A SINTAXINA CON EPILEPSIA"
  },
  {
    "codigo":240708000,
    "descripcion":"CANDIDIASIS DE PENE"
  },
  {
    "codigo":209775008,
    "descripcion":"DEDO MARTILLO CON LESIÓN NO EXPUESTA DE TENDÓN"
  },
  {
    "codigo":15671081000119105,
    "descripcion":"GENU RECURVATUM CONGÉNITO BILATERAL"
  },
  {
    "codigo":275311008,
    "descripcion":"PIE ACROMEGÁLICO"
  },
  {
    "codigo":76868007,
    "descripcion":"TRASTORNO DE PÁNICO CON AGORAFOBIA, EVITACIÓN AGORAFÓBICA EN REMISIÓN TOTAL Y ATAQUES DE PÁNICO LEVES"
  },
  {
    "codigo":109636008,
    "descripcion":"MALA OCLUSIÓN DEBIDA A HÁBITOS DE MORDIDA"
  },
  {
    "codigo":207940009,
    "descripcion":"FRACTURA NO EXPUESTA DE VÉRTEBRA DORSAL, EN CUÑA"
  },
  {
    "codigo":764996009,
    "descripcion":"TRISOMÍA 13Q NO DISTAL"
  },
  {
    "codigo":402713007,
    "descripcion":"COMPLICACIÓN CUTÁNEA DE LA ESCLEROSIS MÚLTIPLE"
  },
  {
    "codigo":271641009,
    "descripcion":"PULSO EN MESETA"
  },
  {
    "codigo":425441000221106,
    "descripcion":"ESTRÉS DE MINORÍAS"
  },
  {
    "codigo":42265009,
    "descripcion":"URTICARIA IDIOPÁTICA"
  },
  {
    "codigo":237038001,
    "descripcion":"SALPINGITIS GONOCÓCICA"
  },
  {
    "codigo":1285614006,
    "descripcion":"HEMATOMA DE DEDO ANULAR"
  },
  {
    "codigo":73198007,
    "descripcion":"PLEURESÍA BACTERIANA"
  },
  {
    "codigo":300739000,
    "descripcion":"INCAPAZ DE PARTICIPAR EN ACTIVIDADES DE TIEMPO LIBRE"
  },
  {
    "codigo":202435002,
    "descripcion":"TUMOR TENOSINOVIAL DE CÉLULAS GIGANTES DIFUSO DE ARTICULACIÓN ACROMIOCLAVICULAR"
  },
  {
    "codigo":169667002,
    "descripcion":"ECOGRAFÍA PRENATAL POR RETRASO DEL CRECIMIENTO"
  },
  {
    "codigo":726723004,
    "descripcion":"SÍNDROME DE CROMOSOMA 13 EN ANILLO"
  },
  {
    "codigo":71363005,
    "descripcion":"ESPASMO DEL MÚSCULO CRICOFARÍNGEO"
  },
  {
    "codigo":267971005,
    "descripcion":"ESPONDILOSIS TORÁCICA SIN MIELOPATÍA"
  },
  {
    "codigo":366275003,
    "descripcion":"REFLEJO EN OJOS DE MUÑECA VERTICAL - HALLAZGO"
  },
  {
    "codigo":36760000,
    "descripcion":"HEPATOESPLENOMEGALIA"
  },
  {
    "codigo":724888001,
    "descripcion":"LACERACIÓN DE TENDÓN DEL TÓRAX"
  },
  {
    "codigo":200600003,
    "descripcion":"ÁNTRAX DE LA CABEZA (EXCLUIDA LA CARA)"
  },
  {
    "codigo":266136003,
    "descripcion":"SÍFILIS ADQUIRIDA LATENTE TARDÍA"
  },
  {
    "codigo":298904005,
    "descripcion":"AMPLITUD DE SUPINACIÓN ACTIVA DE CODO AUMENTADA"
  },
  {
    "codigo":34925000,
    "descripcion":"ANEMIA MEGALOBLÁSTICA POR ERRORES CONGÉNITOS DEL METABOLISMO"
  },
  {
    "codigo":428141001,
    "descripcion":"NEURITIS DEL NERVIO ILIOHIPOGÁSTRICO"
  },
  {
    "codigo":165997004,
    "descripcion":"HEPATITIS A DETECTADA"
  },
  {
    "codigo":229698003,
    "descripcion":"DISPRAXIA ARTICULATORIA"
  },
  {
    "codigo":33090006,
    "descripcion":"ENFERMEDAD CAUSADA POR VIRUS YABA"
  },
  {
    "codigo":295234006,
    "descripcion":"SOBREDOSIS DE FELBINACO"
  },
  {
    "codigo":719383001,
    "descripcion":"CAPAZ DE REALIZAR MÚLTIPLES TAREAS"
  },
  {
    "codigo":162327005,
    "descripcion":"PÉRDIDA DEL JUICIO"
  },
  {
    "codigo":422636004,
    "descripcion":"HIPEREMIA DE CUERDA VOCAL"
  },
  {
    "codigo":94956005,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE HUESO DE LA NARIZ"
  },
  {
    "codigo":62188005,
    "descripcion":"ACALASIA BILIAR"
  },
  {
    "codigo":682231000119100,
    "descripcion":"ASTROCITOMA ANAPLÁSICO PRIMARIO DE LÓBULO FRONTAL"
  },
  {
    "codigo":93121001,
    "descripcion":"FALTA DE OSIFICACIÓN DE HUESO SUPRAOCCIPITAL"
  },
  {
    "codigo":11849821000119107,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN FRENTE"
  },
  {
    "codigo":1091831000119101,
    "descripcion":"PÉRDIDA DE LA AUDICIÓN DE OÍDO DERECHO CAUSADA POR RUIDO"
  },
  {
    "codigo":289729003,
    "descripcion":"CONTRACCIONES UTERINAS EXPULSIVAS"
  },
  {
    "codigo":420801006,
    "descripcion":"MALESTAR ASOCIADO CON SIDA"
  },
  {
    "codigo":1141697008,
    "descripcion":"DEMUESTRA CONOCIMIENTO SOBRE PROCESO DE ENFERMEDAD"
  },
  {
    "codigo":1172630000,
    "descripcion":"SÍNDROME DE RETRASO DEL DESARROLLO GLOBAL, ANOMALÍAS NEUROOFTÁLMICAS, CRISIS CONVULSIVAS, DISCAPACIDAD INTELECTUAL"
  },
  {
    "codigo":27585009,
    "descripcion":"MENSTRUACIÓN ANOVULATORIA"
  },
  {
    "codigo":124054003,
    "descripcion":"ÉSTERES DE COLESTEROL POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1303702008,
    "descripcion":"GLAUCOMA DE OJO DERECHO CAUSADO POR ACEITE DE SILICONA"
  },
  {
    "codigo":449899001,
    "descripcion":"SÍNDROME DE LA CABEZA CAÍDA"
  },
  {
    "codigo":89451009,
    "descripcion":"TRASTORNO DEL ESTADO DE ÁNIMO INDUCIDO POR INHALANTES"
  },
  {
    "codigo":253291009,
    "descripcion":"AURÍCULA DERECHA COMUNICADA CON EL VENTRÍCULO DERECHO"
  },
  {
    "codigo":251456005,
    "descripcion":"ACTIVIDAD DE MU ASIMÉTRICA"
  },
  {
    "codigo":10231000132102,
    "descripcion":"EMBARAZO POR FERTILIZACIÓN IN VITRO"
  },
  {
    "codigo":448064005,
    "descripcion":"ANOMALÍA CONGÉNITA DE AURÍCULA DERECHA"
  },
  {
    "codigo":413461000,
    "descripcion":"EJERCICIO AERÓBICO CUATRO VECES POR SEMANA"
  },
  {
    "codigo":284224009,
    "descripcion":"QUEMADURA SUPERFICIAL DE GLÚTEO POR AGENTE CORROSIVO"
  },
  {
    "codigo":184085002,
    "descripcion":"PACIENTE MUDADO DENTRO DEL ÁREA"
  },
  {
    "codigo":249621006,
    "descripcion":"DEPOSICIONES DEL LACTANTE ALIMENTADO A PECHO"
  },
  {
    "codigo":16220561000119102,
    "descripcion":"PICADURA DE ABEJA MIELÍFERA"
  },
  {
    "codigo":247786001,
    "descripcion":"PLANIFICACIÓN DE PROYECTOS EXTRAVAGANTES"
  },
  {
    "codigo":18410006,
    "descripcion":"CICATRIZ MACULAR"
  },
  {
    "codigo":51178009,
    "descripcion":"SÍNDROME DE MUERTE SÚBITA DEL LACTANTE"
  },
  {
    "codigo":1360063001,
    "descripcion":"ÁNGULO ABIERTO DE OJO IZQUIERDO"
  },
  {
    "codigo":213183005,
    "descripcion":"FALLA TOTAL DE REIMPLANTE DEL DEDO PULGAR"
  },
  {
    "codigo":1163455007,
    "descripcion":"GINGIVITIS EXACERBADA POR RESTAURACIÓN RETENTIVA DE PLACA BACTERIANA"
  },
  {
    "codigo":409791009,
    "descripcion":"ENFERMEDAD CAUSADA POR MORAXELLA"
  },
  {
    "codigo":442559009,
    "descripcion":"TAQUICARDIA VENTRICULAR DE REENTRADA DE RAMA DE HAZ AURICULOVENTRICULAR"
  },
  {
    "codigo":735636008,
    "descripcion":"EYACULACIÓN TARDÍA SITUACIONAL ADQUIRIDA"
  },
  {
    "codigo":1290857004,
    "descripcion":"OPACIDAD DENTAL EN RADIOGRAFÍA SIMPLE"
  },
  {
    "codigo":45673004,
    "descripcion":"DEFORMIDAD DE LA MUÑECA EN VALGO ADQUIRIDA"
  },
  {
    "codigo":111209006,
    "descripcion":"DERMATITIS FOTOALÉRGICA"
  },
  {
    "codigo":15729041000119108,
    "descripcion":"ARTROPATÍA DE TOBILLO DERECHO POR SÍNDROME DE BEHCET"
  },
  {
    "codigo":12905008,
    "descripcion":"DIETA PARA EL TRATAMIENTO DE LA HIPOGLUCEMIA"
  },
  {
    "codigo":1354558001,
    "descripcion":"TRASTORNO POSTERIOR A PROCEDIMIENTO OBSTÉTRICO"
  },
  {
    "codigo":830270002,
    "descripcion":"CEGUERA COMPLETA DE OJO IZQUIERDO EVALUADA CON AGUJERO ESTENOPEICO"
  },
  {
    "codigo":764734003,
    "descripcion":"PARAPLEJÍA ESPÁSTICA AUTOSÓMICA RECESIVA TIPO 21"
  },
  {
    "codigo":109374005,
    "descripcion":"NEOPLASIA MALIGNA SUPERPUESTA DEL MEDIASTINO Y LA PLEURA"
  },
  {
    "codigo":240446006,
    "descripcion":"INFECCIÓN DISEMINADA POR LEGIONELLA"
  },
  {
    "codigo":369683000,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA DE LA AMPOLLA DE VATER, CARA PANCREÁTICA RETROPERITONEAL POSTERIOR CON COMPROMISO TUMORAL"
  },
  {
    "codigo":55151000087101,
    "descripcion":"CON MAYOR RIESGO DE EDEMA PULMONAR"
  },
  {
    "codigo":34671000087103,
    "descripcion":"PORPHYROMONAS ASACCHAROLYTICA O PORPHYROMONAS UENONIS"
  },
  {
    "codigo":402451008,
    "descripcion":"EPIDERMÓLISIS BULLOSA ADQUIRIDA CON COMPROMISO DE LA MUCOSA BUCAL"
  },
  {
    "codigo":238611009,
    "descripcion":"PSORIASIS TIPO LAPIERE"
  },
  {
    "codigo":42351000087105,
    "descripcion":"TRASTORNO DEGENERATIVO DE CARTÍLAGO ARTICULAR DE RODILLA DERECHA"
  },
  {
    "codigo":72936003,
    "descripcion":"ACNÉ ATRÓFICA"
  },
  {
    "codigo":11770411000119105,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE CABEZA RADIAL IZQUIERDA"
  },
  {
    "codigo":105704000,
    "descripcion":"ENFERMEDAD CAUSADA POR STRONGYLOIDEA"
  },
  {
    "codigo":1187048006,
    "descripcion":"SÍNDROME DE AICARDI GOUTIERES TIPO 4"
  },
  {
    "codigo":204008003,
    "descripcion":"ESPINA BÍFIDA SIN HIDROCEFALIA - CERRADA"
  },
  {
    "codigo":39791000087107,
    "descripcion":"ABRASIÓN DE PIEL DE PÁRPADO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":269544008,
    "descripcion":"CARCINOMA DE LA UNIÓN RECTOSIGMOIDE"
  },
  {
    "codigo":236776007,
    "descripcion":"TORSIÓN DE QUISTE DE EPIDÍDIMO"
  },
  {
    "codigo":38333003,
    "descripcion":"INFECCIÓN CAUSADA POR CALICOPHORON"
  },
  {
    "codigo":300477005,
    "descripcion":"MATERIA FECAL EN ORINA"
  },
  {
    "codigo":366013008,
    "descripcion":"HALLAZGO RELACIONADO CON LA POSICIÓN DEL GLOBO OCULAR"
  },
  {
    "codigo":5565008,
    "descripcion":"DIVERTÍCULO CONGÉNITO DE LA TRÁQUEA"
  },
  {
    "codigo":724626002,
    "descripcion":"PROBLEMA DE CODO"
  },
  {
    "codigo":167570003,
    "descripcion":"CULTIVO DE ORINA: E. COLI"
  },
  {
    "codigo":298642001,
    "descripcion":"AMPLITUD DE FLEXIÓN LATERAL PASIVA HACIA LA IZQUIERDA DE LA COLUMNA VERTEBRAL LUMBAR, AUMENTADA"
  },
  {
    "codigo":9651007,
    "descripcion":"SÍNDROME DE QT PROLONGADO"
  },
  {
    "codigo":1279847002,
    "descripcion":"DESPRENDIMIENTO DE RETINA DERECHA CON ROTURA DE RETINA"
  },
  {
    "codigo":10760901000119104,
    "descripcion":"SEXTILLIZOS, ALGUNOS NACIDOS VIVOS"
  },
  {
    "codigo":34663006,
    "descripcion":"CONTUSIÓN ENCEFÁLICA"
  },
  {
    "codigo":1343548000,
    "descripcion":"TC COMPUTARIZADA DE VESÍCULA BILIAR CON CONTRASTE NORMAL"
  },
  {
    "codigo":67431008,
    "descripcion":"RITUAL"
  },
  {
    "codigo":294972000,
    "descripcion":"ALERGIA A FLUVASTATINA"
  },
  {
    "codigo":720956003,
    "descripcion":"SÍNDROME DE FOIX-CHAVANY-MARIE"
  },
  {
    "codigo":131132008,
    "descripcion":"ÁCIDO FÓLICO POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1145105002,
    "descripcion":"AUSENCIA DE PESTAÑAS"
  },
  {
    "codigo":30993009,
    "descripcion":"ENTEROESPASMO"
  },
  {
    "codigo":717286002,
    "descripcion":"DISTROFIA DE CÓRNEA DE GRAYSON WILBRANDT"
  },
  {
    "codigo":29158001,
    "descripcion":"FOSFENO DE ACOMODACIÓN"
  },
  {
    "codigo":782822006,
    "descripcion":"DEGENERACIÓN INFANTIL DEL CEREBELO Y LA RETINA"
  },
  {
    "codigo":61926008,
    "descripcion":"FRÉMITO SISTÓLICO BASAL"
  },
  {
    "codigo":1338043001,
    "descripcion":"PACIENTE TOLERA VENTILACIÓN MECÁNICA"
  },
  {
    "codigo":289467001,
    "descripcion":"VULVA AUSENTE"
  },
  {
    "codigo":92859003,
    "descripcion":"FUSIÓN ANORMAL CONGÉNITA DE HÚMERO"
  },
  {
    "codigo":60091004,
    "descripcion":"ESTRECHEZ CONGÉNITA DE ARTERIA"
  },
  {
    "codigo":58256000,
    "descripcion":"DEFICIENCIA DE DISHIDROPTERIDINA REDUCTASA"
  },
  {
    "codigo":125627008,
    "descripcion":"LESIÓN TRAUMÁTICA DEL INTESTINO DELGADO"
  },
  {
    "codigo":254864005,
    "descripcion":"TUMOR DE CÉLULAS DE LA TECA DEL OVARIO"
  },
  {
    "codigo":25488008,
    "descripcion":"SIGNOS ELECTROCARDIOGRÁFICOS DE HIPERTROFIA DE VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":16059231000119107,
    "descripcion":"DEFECTO DE CAMPO VISUAL DE OJO IZQUIERDO"
  },
  {
    "codigo":23653003,
    "descripcion":"CEGUERA TRAUMÁTICA"
  },
  {
    "codigo":285797003,
    "descripcion":"INCAPAZ DE DESENVOLVERSE EN UN AMBIENTE FAMILIAR"
  },
  {
    "codigo":449637003,
    "descripcion":"MELANOMA MALIGNO DE PIEL DE BRAZO"
  },
  {
    "codigo":251194000,
    "descripcion":"ONDA P CON DESVIACIÓN DEL EJE HACIA LA DERECHA"
  },
  {
    "codigo":253029009,
    "descripcion":"PARAGANGLIOMA GANGLIOCÍTICO"
  },
  {
    "codigo":185658000,
    "descripcion":"CRIBADO EN EL ADULTO - RECONVOCATORIA ANULADA"
  },
  {
    "codigo":54586004,
    "descripcion":"DOLOR ABDOMINAL INFERIOR"
  },
  {
    "codigo":447802005,
    "descripcion":"ENCONDROMA DE MANDÍBULA"
  },
  {
    "codigo":283962006,
    "descripcion":"HEMATOMA DEL ÚTERO"
  },
  {
    "codigo":216591000,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR PILOCARPINA"
  },
  {
    "codigo":52751000,
    "descripcion":"MARCHA HEMIPLÉJICA"
  },
  {
    "codigo":445967004,
    "descripcion":"SÍNDROME CLÍNICAMENTE AISLADO"
  },
  {
    "codigo":773647007,
    "descripcion":"SÍNDROME NEFRÓTICO, SORDERA, SÍNDROME DE EPIDERMÓLISIS BULLOSA PRETIBIAL"
  },
  {
    "codigo":249359009,
    "descripcion":"ESPOLÓN DEL TABIQUE NASAL"
  },
  {
    "codigo":247524003,
    "descripcion":"LANUGO"
  },
  {
    "codigo":83684005,
    "descripcion":"ACNÉ CAUSADO POR CLORO"
  },
  {
    "codigo":704441000,
    "descripcion":"CAPAZ DE REALIZAR ACTIVIDAD DE ACICALAMIENTO PERSONAL"
  },
  {
    "codigo":212921001,
    "descripcion":"CONGELAMIENTO SUPERFICIAL DE LA CADERA Y EL MUSLO"
  },
  {
    "codigo":737209002,
    "descripcion":"POLICITEMIA NEONATAL DEBIDA A INSUFICIENCIA PLACENTARIA"
  },
  {
    "codigo":243854001,
    "descripcion":"SITUACIÓN DEL MONITOREO DE ENFERMEDAD DEL TRACTO GASTROINTESTINAL"
  },
  {
    "codigo":1259662001,
    "descripcion":"CARCINOMA UROTELIAL PRIMARIO DE RIÑÓN DERECHO"
  },
  {
    "codigo":276622005,
    "descripcion":"HEMORRAGIA SUBAPONEURÓTICA EPICRANEAL"
  },
  {
    "codigo":438627000,
    "descripcion":"LESIÓN TRAUMÁTICA POR FRICCIÓN DENTAL LIMITADA AL ESMALTE"
  },
  {
    "codigo":373091001,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE MAMA, CUADRANTE INFEROEXTERNO"
  },
  {
    "codigo":404024000,
    "descripcion":"SCHWANNOMA MELANÓTICO"
  },
  {
    "codigo":830008001,
    "descripcion":"RETINA DE OJO IZQUIERDO NORMAL"
  },
  {
    "codigo":405859009,
    "descripcion":"FENOTIPO JK(B+)"
  },
  {
    "codigo":1255992004,
    "descripcion":"RUPTURA TRAUMÁTICA DE TENDÓN DE ANTEBRAZO"
  },
  {
    "codigo":240184005,
    "descripcion":"OSTEOCONDRITIS DISECANTE DEL CÓNDILO FEMORAL INTERNO"
  },
  {
    "codigo":698936006,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: ZULÚ"
  },
  {
    "codigo":540871000124103,
    "descripcion":"MASA DE SACRO"
  },
  {
    "codigo":76344008,
    "descripcion":"INFESTACIÓN CAUSADA POR ARGASIDAE"
  },
  {
    "codigo":441031000124105,
    "descripcion":"INGESTA EXCESIVA DE COBALTO"
  },
  {
    "codigo":305720008,
    "descripcion":"VISTO POR UN NEUROCIRUJANO"
  },
  {
    "codigo":271117005,
    "descripcion":"AMPOLLA TRAUMÁTICA DE LA REGIÓN INTERESCAPULAR"
  },
  {
    "codigo":446151000124109,
    "descripcion":"SE IDENTIFICA COMO GÉNERO MASCULINO"
  },
  {
    "codigo":860941007,
    "descripcion":"REACCIÓN ADVERSA A ÁCIDO FÍBRICO Y\/O DERIVADO DE ÁCIDO FÍBRICO"
  },
  {
    "codigo":402189008,
    "descripcion":"XEROSIS POR DERMATITIS ATÓPICA"
  },
  {
    "codigo":236514003,
    "descripcion":"NEFROPATÍA TÓXICA"
  },
  {
    "codigo":7138005,
    "descripcion":"CARIES DE LA APÓFISIS MASTOIDEA"
  },
  {
    "codigo":103607002,
    "descripcion":"EXTENDIDO ACELULAR"
  },
  {
    "codigo":726199004,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO INTRÍNSECO DE DEDO DE LA MANO"
  },
  {
    "codigo":300215006,
    "descripcion":"PRESTA ATENCIÓN A LA COMUNICACIÓN VERBAL DIRECTA"
  },
  {
    "codigo":267447008,
    "descripcion":"HIPOSMOLALIDAD Y\/O HIPONATREMIA"
  },
  {
    "codigo":3468005,
    "descripcion":"MASTITIS INFECCIOSA NEONATAL"
  },
  {
    "codigo":298380006,
    "descripcion":"DEFORMIDAD DE LA COLUMNA VERTEBRAL"
  },
  {
    "codigo":200076006,
    "descripcion":"CEFALEA INDUCIDA POR ANESTESIA RAQUÍDEA Y EPIDURAL DURANTE EL TRABAJO DE PARTO Y EL PARTO"
  },
  {
    "codigo":427617000,
    "descripcion":"ULCERACIÓN AFTOSA DE PIEL Y\/O MEMBRANA MUCOSA"
  },
  {
    "codigo":722529000,
    "descripcion":"NEOPLASIA EPITELIAL MALIGNA PRIMARIA DE RINOFARINGE"
  },
  {
    "codigo":198241002,
    "descripcion":"ENFERMEDAD INFLAMATORIA PÉLVICA, TUBERCULOSA, FEMENINA"
  },
  {
    "codigo":296545001,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE NISTATINA"
  },
  {
    "codigo":165473003,
    "descripcion":"NORMOCITOSIS"
  },
  {
    "codigo":196406005,
    "descripcion":"IMBRICACIÓN DENTAL ANTERIOR"
  },
  {
    "codigo":32566006,
    "descripcion":"DISMETRÍA"
  },
  {
    "codigo":10874311000119103,
    "descripcion":"LACERACIÓN DE MEJILLA IZQUIERDA"
  },
  {
    "codigo":129035000,
    "descripcion":"INDEPENDENCIA PARA VESTIRSE"
  },
  {
    "codigo":292875003,
    "descripcion":"REACCIÓN ADVERSA AL CLOROXILENOL"
  },
  {
    "codigo":30731004,
    "descripcion":"GLOSODINIA"
  },
  {
    "codigo":391179008,
    "descripcion":"NEUMOPERICARDIO NO TRAUMÁTICO"
  },
  {
    "codigo":291040001,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR LORMETAZEPAM"
  },
  {
    "codigo":127200002,
    "descripcion":"LINFADENOPATÍA INGUINAL PROFUNDA"
  },
  {
    "codigo":94432003,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE MÚSCULO"
  },
  {
    "codigo":12103111000119105,
    "descripcion":"QUEMADURA DE DEDO DE PIE DERECHO"
  },
  {
    "codigo":782560008,
    "descripcion":"ALERGIA A INDANODIONA"
  },
  {
    "codigo":225504008,
    "descripcion":"AUTOESTIMA ELEVADA"
  },
  {
    "codigo":306631000119107,
    "descripcion":"GOTA DE MANO CAUSADA POR FÁRMACO"
  },
  {
    "codigo":16909921000119101,
    "descripcion":"LAGOFTALMOS CICATRIZAL DE AMBOS PÁRPADOS SUPERIORES E INFERIORES"
  },
  {
    "codigo":10628551000119108,
    "descripcion":"DERMATITIS IRRITATIVA POR CONTACTO CAUSADA POR GOMA"
  },
  {
    "codigo":92597007,
    "descripcion":"CARCINOMA IN SITU DE SENO FRONTAL"
  },
  {
    "codigo":289205009,
    "descripcion":"HALLAZGO RELACIONADO CON LAS MEDICIONES DEL EMBARAZO"
  },
  {
    "codigo":713354008,
    "descripcion":"ÚLCERA DE INTESTINO PERFORADA"
  },
  {
    "codigo":1137503004,
    "descripcion":"DEBILIDAD DE MÚSCULO DISTAL DE COMIENZO TARDÍO"
  },
  {
    "codigo":447540003,
    "descripcion":"QUISTE EPIDERMOIDE DE PIEL DE REGIÓN RETROAURICULAR"
  },
  {
    "codigo":414772003,
    "descripcion":"INMUNOGLOBULINA M MONOCLONAL DETECTADA"
  },
  {
    "codigo":185396006,
    "descripcion":"PACIENTE QUE CONCURRE ANUALMENTE"
  },
  {
    "codigo":281865000,
    "descripcion":"HEMATOMA INTRACRANEAL EXTRADURAL NO TRAUMÁTICO"
  },
  {
    "codigo":283700009,
    "descripcion":"MORDEDURA HUMANA EN LA AXILA"
  },
  {
    "codigo":249097002,
    "descripcion":"PRESENTACIÓN PODÁLICA"
  },
  {
    "codigo":7931000119101,
    "descripcion":"TROMBOSIS DE ARTERIA COROIDEA ANTERIOR"
  },
  {
    "codigo":19721008,
    "descripcion":"HIPOTONÍA OCULAR"
  },
  {
    "codigo":609545008,
    "descripcion":"HIPERSENSIBILIDAD NO ALÉRGICA A RAMIPRIL"
  },
  {
    "codigo":247262004,
    "descripcion":"BURBUJAS DETRÁS DEL TÍMPANO"
  },
  {
    "codigo":335611000119103,
    "descripcion":"PANNUS CORNEAL DE OJO DERECHO"
  },
  {
    "codigo":738782007,
    "descripcion":"ANTÍGENO LEUCOCÍTICO HUMANO A*31:01 NO DETECTADO"
  },
  {
    "codigo":48520006,
    "descripcion":"AUSENCIA CONGÉNITA DE VENA CARDÍACA"
  },
  {
    "codigo":704179003,
    "descripcion":"FRACTURA NO EXPUESTA DE CUELLO DE SEGUNDO METACARPIANO"
  },
  {
    "codigo":15748361000119100,
    "descripcion":"MASA DE ARTICULACIÓN DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":1077001000119100,
    "descripcion":"QUISTE ÓSEO DE HÚMERO DERECHO"
  },
  {
    "codigo":145161000119101,
    "descripcion":"ENCOPRESIS ORGÁNICA PRIMARIA"
  },
  {
    "codigo":303881000119102,
    "descripcion":"GOTA TOFÁCEA CRÓNICA DE TOBILLO DEBIDA A DISFUNCIÓN RENAL"
  },
  {
    "codigo":124681000119104,
    "descripcion":"PINGUECULITIS"
  },
  {
    "codigo":10735881000119104,
    "descripcion":"HEMATOMA TRAUMÁTICO DE LIGAMENTO ANCHO DE ÚTERO"
  },
  {
    "codigo":1801000119106,
    "descripcion":"ANEMIA, ENFERMEDAD RENAL EN ESTADIO PRETERMINAL EN PROTOCOLO DE ERITROPOYETINA"
  },
  {
    "codigo":15684361000119107,
    "descripcion":"PERIOSTITIS DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":15669001000119106,
    "descripcion":"AUSENCIA CONGÉNITA DE AMBOS MÚSCULOS PECTORALES"
  },
  {
    "codigo":329481000119106,
    "descripcion":"OCLUSIÓN DE ARTERIA CEREBRAL MEDIA DERECHA"
  },
  {
    "codigo":285961000119107,
    "descripcion":"RUPTURA MECÁNICA DE PRÓTESIS DE VÁLVULA CARDÍACA"
  },
  {
    "codigo":316681000119105,
    "descripcion":"OSTEOFITO DE RODILLA DERECHA"
  },
  {
    "codigo":702344008,
    "descripcion":"SÍNDROME DE PITT-HOPKINS"
  },
  {
    "codigo":815121161000119105,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR TRAMADOL"
  },
  {
    "codigo":228156681000119109,
    "descripcion":"INFARTO HEMORRÁGICO DE TIROIDES"
  },
  {
    "codigo":129801000119109,
    "descripcion":"MASA UTERINA"
  },
  {
    "codigo":672521000119108,
    "descripcion":"DISFASIA DEBIDA A ACCIDENTE CEREBROVASCULAR ISQUÉMICO Y POSTERIOR A ÉL"
  },
  {
    "codigo":15663881000119108,
    "descripcion":"HEMARTROSIS DE ARTICULACIÓN DE AMBAS REGIONES DE MUÑECA"
  },
  {
    "codigo":766045006,
    "descripcion":"LEUCEMIA MIELOIDE AGUDA Y SÍNDROME MIELODISPLÁSICO RELACIONADO CON AGENTE ALQUILANTE"
  },
  {
    "codigo":274525000,
    "descripcion":"RESULTADOS ANORMALES DE ESTUDIOS FUNCIONALES CARDIOVASCULARES"
  },
  {
    "codigo":241757007,
    "descripcion":"INTOXICACIÓN CAUSADA POR TEMAZEPAM"
  },
  {
    "codigo":698674001,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: MARATÍ"
  },
  {
    "codigo":11804411000119108,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA DISTAL DE DEDO MEÑIQUE IZQUIERDO"
  },
  {
    "codigo":239922003,
    "descripcion":"ENFERMEDAD DE BEHCET CON COMPROMISO MULTISISTÉMICO"
  },
  {
    "codigo":1255730003,
    "descripcion":"NEOPLASIA MASTOCITARIA MALIGNA DE GANGLIOS LINFÁTICOS DE CUELLO"
  },
  {
    "codigo":10821371000119109,
    "descripcion":"FRACTURA EXPUESTA DE QUINTO HUESO METACARPIANO DE MANO IZQUIERDA"
  },
  {
    "codigo":403762003,
    "descripcion":"DISPLASIA ODONTO-ONICO-DÉRMICA"
  },
  {
    "codigo":370994008,
    "descripcion":"SIN CONVULSIONES"
  },
  {
    "codigo":74247001,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DE LA VULVA"
  },
  {
    "codigo":238087001,
    "descripcion":"HIPERTRIGLICERIDEMIA SECUNDARIA"
  },
  {
    "codigo":860679004,
    "descripcion":"EMBOLIA DE COÁGULO SANGUÍNEO DEBIDA A EMBARAZO ECTÓPICO Y POSTERIOR A ÉL"
  },
  {
    "codigo":762375006,
    "descripcion":"ERITEMA MULTIFORME CAUSADA POR VIRUS"
  },
  {
    "codigo":400092004,
    "descripcion":"NEOPLASIA INTRAEPITELIAL DE PENE, GRADO III"
  },
  {
    "codigo":398257000,
    "descripcion":"CERTIFICADO POR EL CONSEJO MÉDICO"
  },
  {
    "codigo":185395005,
    "descripcion":"PACIENTE NO ATENDIDO DURANTE UN PERÍODO SUPERIOR A UN AÑO"
  },
  {
    "codigo":299953003,
    "descripcion":"HALLAZGO RELACIONADO CON LA TOLERANCIA AL DOLOR"
  },
  {
    "codigo":431025004,
    "descripcion":"AMPLITUD DE FLEXIÓN DE LA COLUMNA VERTEBRAL CERVICAL DISMINUIDA"
  },
  {
    "codigo":234417006,
    "descripcion":"LINFOCITOSIS DE CÉLULAS T"
  },
  {
    "codigo":365489003,
    "descripcion":"PERTENENCIA A GRUPO DE AUTOAYUDA - HALLAZGO"
  },
  {
    "codigo":12105621000119108,
    "descripcion":"QUEMADURA DE PALMA IZQUIERDA"
  },
  {
    "codigo":298118004,
    "descripcion":"LESIÓN DE NERVIO SUPRAESCAPULAR"
  },
  {
    "codigo":35974005,
    "descripcion":"GASTROENTERITIS POR CRIPTOCOCOS"
  },
  {
    "codigo":134278006,
    "descripcion":"LEE FRANCÉS"
  },
  {
    "codigo":429190007,
    "descripcion":"LUXACIÓN RECURRENTE DE CADERA"
  },
  {
    "codigo":230747000,
    "descripcion":"HIDROCEFALIA AISLADA DEL CUARTO VENTRÍCULO"
  },
  {
    "codigo":16011311000119104,
    "descripcion":"GANGRENA DE AMBOS PIES"
  },
  {
    "codigo":34139004,
    "descripcion":"DISCOPATÍA INTERVERTEBRAL DE LA REGIÓN LUMBAR, CON MIELOPATÍA"
  },
  {
    "codigo":427355004,
    "descripcion":"QUERATOPATÍA POR FALLA DE CÉLULAS MADRE CORNEALES"
  },
  {
    "codigo":294448000,
    "descripcion":"ALERGIA A VERDE BRILLANTE"
  },
  {
    "codigo":1144581007,
    "descripcion":"APLASIA DE MÚSCULO PECTORAL"
  },
  {
    "codigo":1075401000119102,
    "descripcion":"RUPTURA CRÓNICA DE LIGAMENTO LATERAL INTERNO DE RODILLA DERECHA"
  },
  {
    "codigo":290778003,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR AZATIOPRINA"
  },
  {
    "codigo":28634005,
    "descripcion":"ATAXIA CEREBRAL"
  },
  {
    "codigo":41791000087105,
    "descripcion":"CELULITIS DE DEDO ANULAR DERECHO"
  },
  {
    "codigo":92335001,
    "descripcion":"NEOPLASIA BENIGNA DE LA ESCLERÓTICA"
  },
  {
    "codigo":94170009,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA PARED ANTERIOR DE LA NASOFARINGE"
  },
  {
    "codigo":288943006,
    "descripcion":"DEGLUTE ALIMENTOS"
  },
  {
    "codigo":156036003,
    "descripcion":"AMENORREA SECUNDARIA"
  },
  {
    "codigo":90500005,
    "descripcion":"DEFICIENCIA DE CARNITINA PALMITOILTRANSFERASA"
  },
  {
    "codigo":385412008,
    "descripcion":"PUNTAJE DE GLEASON 7 - 10: ESCASAMENTE DIFERENCIADO"
  },
  {
    "codigo":287108009,
    "descripcion":"ASTILLA CLAVADA EN EL CUELLO"
  },
  {
    "codigo":285273008,
    "descripcion":"PLANES DE VIOLACIÓN"
  },
  {
    "codigo":840494001,
    "descripcion":"MACROFTALMÍA CONGÉNITA DE AMBOS OJOS"
  },
  {
    "codigo":283438007,
    "descripcion":"CORTE EN EL TOBILLO"
  },
  {
    "codigo":707587000,
    "descripcion":"CARCINOMA PRIMARIO EX ADENOMA PLEOMÓRFICO DE OROFARINGE"
  },
  {
    "codigo":1230040001,
    "descripcion":"PLACENTA ACRETA CORNUAL"
  },
  {
    "codigo":310701003,
    "descripcion":"SÍNDROME DE BEHCET"
  },
  {
    "codigo":441773004,
    "descripcion":"DETECTADO POR MEDICIÓN"
  },
  {
    "codigo":472706000,
    "descripcion":"CIERRE DE CONDUCTO ARTERIOSO FETAL"
  },
  {
    "codigo":276098002,
    "descripcion":"NIÑO ABANDONADO POR LA MADRE"
  },
  {
    "codigo":13954005,
    "descripcion":"ÚLCERA ISQUÉMICA"
  },
  {
    "codigo":15931901000119103,
    "descripcion":"TORSIÓN DE OVARIO DERECHO"
  },
  {
    "codigo":46722007,
    "descripcion":"ANOMALÍA CONGÉNITA DE LAS CISURAS PLEURALES"
  },
  {
    "codigo":308866007,
    "descripcion":"DISPLASIA LEVE DE CONDUCTO PANCREÁTICO"
  },
  {
    "codigo":765783008,
    "descripcion":"INFECCIÓN DE LA PIEL CAUSADA POR MOLUSCO CONTAGIOSO"
  },
  {
    "codigo":700247008,
    "descripcion":"SUCCIÓN DE LABIOS"
  },
  {
    "codigo":1290071008,
    "descripcion":"TUMOR NEUROENDOCRINO BIEN DIFERENCIADO DE TRACTO GASTROINTESTINAL"
  },
  {
    "codigo":367101000119105,
    "descripcion":"MALFORMACIÓN CONGÉNITA DE VEJIGA URINARIA Y URETRA"
  },
  {
    "codigo":340631000119100,
    "descripcion":"DESGARRO RETINIANO GIGANTE DE OJO IZQUIERDO"
  },
  {
    "codigo":403500006,
    "descripcion":"LUPUS ERITEMATOSO DISCOIDE DE MANOS"
  },
  {
    "codigo":1157164008,
    "descripcion":"TODAS LAS CÁMARAS CARDÍACAS PRESENTES"
  },
  {
    "codigo":237825005,
    "descripcion":"DERMOPATÍA ASOCIADA A LA GLÁNDULA TIROIDES"
  },
  {
    "codigo":205057007,
    "descripcion":"CADERA DISPLÁSICA BILATERAL"
  },
  {
    "codigo":203222000,
    "descripcion":"OSTEOMIELITIS DE CLAVÍCULA"
  },
  {
    "codigo":1153494006,
    "descripcion":"NIVEL PLASMÁTICO DE CREATINQUINASA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":301526007,
    "descripcion":"DIFICULTAD PARA ENTRAR Y SALIR DE LA BAÑERA"
  },
  {
    "codigo":235990008,
    "descripcion":"PERITONITIS POR BARIO"
  },
  {
    "codigo":299691001,
    "descripcion":"HALLAZGO RELACIONADO CON EL SISTEMA INMUNITARIO, LA SANGRE Y LOS LINFÁTICOS"
  },
  {
    "codigo":103083001,
    "descripcion":"RESPUESTA ANORMAL DEL HUÉSPED"
  },
  {
    "codigo":72150009,
    "descripcion":"INFARTO INTESTINAL NO OCLUSIVO"
  },
  {
    "codigo":365227001,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA ADAPTAR LA ROPA"
  },
  {
    "codigo":266923002,
    "descripcion":"EX FUMADOR MODERADO DE CIGARRILLOS (10 - 19\/DÍA)"
  },
  {
    "codigo":428928001,
    "descripcion":"LESIÓN TRAUMÁTICA POR IMPACTO DE OBJETO EN MOVIMIENTO CONTRA SUJETO DETENIDO"
  },
  {
    "codigo":363392002,
    "descripcion":"NEOPLASIA MALIGNA DE OROFARINGE"
  },
  {
    "codigo":234155009,
    "descripcion":"HEMORRAGIA DE FÍSTULA ARTERIOVENOSA CONGÉNITA"
  },
  {
    "codigo":135851009,
    "descripcion":"LESIÓN DE LOS TENDONES FEMORALES DE LA CORVA"
  },
  {
    "codigo":68480001,
    "descripcion":"DIVERTICULOSIS INTRAMURAL DEL ESÓFAGO"
  },
  {
    "codigo":232320003,
    "descripcion":"TINNITUS QUE SE ORIGINA EN EL TENSOR TIMPÁNICO"
  },
  {
    "codigo":722005000,
    "descripcion":"ANEMIA FERROPÉNICA REFRACTARIA AL HIERRO"
  },
  {
    "codigo":33877000,
    "descripcion":"FIEBRE DE SPONDWENI"
  },
  {
    "codigo":11864881000119101,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DE RODILLA DERECHA"
  },
  {
    "codigo":263253007,
    "descripcion":"FRACTURA POR MARCHA"
  },
  {
    "codigo":296021008,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE ZOLPIDEM"
  },
  {
    "codigo":64810007,
    "descripcion":"INFECCIÓN CAUSADA POR HAEMOPROTEUS"
  },
  {
    "codigo":95743003,
    "descripcion":"ALTERACIÓN DE LA COLORACIÓN CONJUNTIVAL"
  },
  {
    "codigo":423423004,
    "descripcion":"VISIÓN A DISTANCIA 20\/70"
  },
  {
    "codigo":259583007,
    "descripcion":"MEGACOLON IDIOPÁTICO EN INFANCIA"
  },
  {
    "codigo":292351007,
    "descripcion":"REACCIÓN ADVERSA AL BROMAZEPAM"
  },
  {
    "codigo":716500001,
    "descripcion":"NO COMPRENDE INSTRUCCIONES DE TRES PALABRAS"
  },
  {
    "codigo":1306324000,
    "descripcion":"CARCINOMA IN SITU DE ARÉOLA"
  },
  {
    "codigo":224980003,
    "descripcion":"CONTRATRANSFERENCIA"
  },
  {
    "codigo":290516005,
    "descripcion":"INTOXICACIÓN POR ISOFLURANO"
  },
  {
    "codigo":15715121000119106,
    "descripcion":"OSTEOFITO DE CODO BILATERAL"
  },
  {
    "codigo":93908007,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE MÚSCULO PERINEAL"
  },
  {
    "codigo":59305000,
    "descripcion":"SECRECIÓN GÁSTRICA NORMAL"
  },
  {
    "codigo":714665000,
    "descripcion":"CON MAYOR RIESGO DE INTERACCIÓN FARMACOLÓGICA ADVERSA"
  },
  {
    "codigo":126676009,
    "descripcion":"NEOPLASIA DE SENO MAXILAR"
  },
  {
    "codigo":288681003,
    "descripcion":"DIFICULTAD PARA FINALIZAR UNA CONVERSACIÓN"
  },
  {
    "codigo":92073008,
    "descripcion":"NEOPLASIA BENIGNA DE LOS GANGLIOS LINFÁTICOS CUBITALES"
  },
  {
    "codigo":1204350002,
    "descripcion":"ESCLEROSIS LATERAL AMIOTRÓFICA TIPO 8"
  },
  {
    "codigo":712830002,
    "descripcion":"INFECCIÓN DEBIDA A ENTEROBACTERIACEAE RESISTENTES A CARBAPENEM"
  },
  {
    "codigo":1237118005,
    "descripcion":"ÚLCERA VENOSA RECURRENTE DE PIERNA"
  },
  {
    "codigo":254078005,
    "descripcion":"DISPLASIA ESPONDILOMETAFISARIA - TIPO SUTCLIFFE"
  },
  {
    "codigo":417918006,
    "descripcion":"ALERGIA A LA CARNE DE CERDO"
  },
  {
    "codigo":286846009,
    "descripcion":"TIENDE A SER SENSIBLE A LAS CRÍTICAS"
  },
  {
    "codigo":186707002,
    "descripcion":"INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA CON ENFERMEDAD NEUROLÓGICA"
  },
  {
    "codigo":285011008,
    "descripcion":"ADAPTA LA ROPA"
  },
  {
    "codigo":447016004,
    "descripcion":"FRACTURA EXPUESTA DE BASE DE CRÁNEO"
  },
  {
    "codigo":11811941000119100,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE PULGAR IZQUIERDO"
  },
  {
    "codigo":1004072007,
    "descripcion":"CONTRACTURA EN FLEXIÓN PROGRESIVA DE ARTICULACIÓN"
  },
  {
    "codigo":283176008,
    "descripcion":"CUERPO EXTRAÑO METÁLICO EN LA INGLE"
  },
  {
    "codigo":1264381004,
    "descripcion":"LACERACIÓN DE TENDÓN DE PIERNA"
  },
  {
    "codigo":281341005,
    "descripcion":"SOLICITUD EN ESPERA"
  },
  {
    "codigo":224264004,
    "descripcion":"ESPACIO DE VIVIENDA SUFICIENTE PARA LAS NECESIDADES"
  },
  {
    "codigo":16235621000119102,
    "descripcion":"ECTROPIÓN CICATRIZAL DE AMBOS PÁRPADOS SUPERIORES"
  },
  {
    "codigo":84733009,
    "descripcion":"MIOCARDIOPATÍA DILATADA DEBIDA A DEFICIENCIA NUTRICIONAL"
  },
  {
    "codigo":248573009,
    "descripcion":"RESPIRACIÓN RUIDOSA"
  },
  {
    "codigo":115666004,
    "descripcion":"NEUMOPATÍA DE LOS MANIPULADORES DE ANIMALES DE LABORATORIO"
  },
  {
    "codigo":410578007,
    "descripcion":"ESCLERITIS INFECCIOSA"
  },
  {
    "codigo":769191001,
    "descripcion":"RETINOPATÍA NO PROLIFERATIVA MUY SEVERA DE OJO IZQUIERDO DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":310439007,
    "descripcion":"CITOLOGÍA URINARIA ANORMAL"
  },
  {
    "codigo":46460004,
    "descripcion":"RASGO DE PERSONALIDAD HIPOMANÍACA"
  },
  {
    "codigo":308604005,
    "descripcion":"SITUACIÓN DE EXAMEN PARA EXENCIÓN DEL USO DE CINTURÓN DE SEGURIDAD"
  },
  {
    "codigo":372305000,
    "descripcion":"AUSENCIA DE EXTENSIÓN TUMORAL EXTRAPROSTÁTICA"
  },
  {
    "codigo":767356009,
    "descripcion":"QUISTE DE RETENCIÓN MUCOSA DE CUELLO UTERINO"
  },
  {
    "codigo":306769002,
    "descripcion":"CAPAZ DE TRAGAR SÓLIDOS"
  },
  {
    "codigo":11857005,
    "descripcion":"ÁNTRAX DE LA NARIZ"
  },
  {
    "codigo":110161008,
    "descripcion":"ABRASIÓN AMIGDALINA"
  },
  {
    "codigo":1255206001,
    "descripcion":"RUPTURA TRAUMÁTICA DE TENDÓN DE PIE"
  },
  {
    "codigo":75558003,
    "descripcion":"VÍCTIMA EN ACCIDENTE ENTRE MÁS DE DOS VEHÍCULOS"
  },
  {
    "codigo":763686007,
    "descripcion":"SÍNDROME DE CABELLO ENRULADO, QUERATODERMIA DE ZONAS ACRAS Y CARIES"
  },
  {
    "codigo":1351675000,
    "descripcion":"AGAMMAGLOBULINEMIA AUTOSÓMICA RECESIVA DEBIDA A DEFICIENCIA DE REGIÓN CONSTANTE MU DE LA CADENA PESADA DE INMUNOGLOBULINA"
  },
  {
    "codigo":403238009,
    "descripcion":"COLOR CONSTITUTIVO DE LA PIEL, BLANCO"
  },
  {
    "codigo":204795004,
    "descripcion":"HÍGADO FLOTANTE CONGÉNITO"
  },
  {
    "codigo":235728001,
    "descripcion":"ENTEROPATÍA AUTOINMUNITARIA"
  },
  {
    "codigo":301264005,
    "descripcion":"MATIDEZ CARDÍACA A LA PERCUSIÓN AUSENTE"
  },
  {
    "codigo":399568005,
    "descripcion":"FIMBRIAS DE TROMPA DE FALOPIO DERECHA PERMEABLES"
  },
  {
    "codigo":39120007,
    "descripcion":"INTENTO FALLIDO DE ABORTO CON SALPINGOOFORITIS"
  },
  {
    "codigo":70053000,
    "descripcion":"ORQUITIS SIN ABSCESO"
  },
  {
    "codigo":725413002,
    "descripcion":"SÍNDROME DE EPILEPSIA RELACIONADA CON ENFERMEDAD FEBRIL"
  },
  {
    "codigo":233893007,
    "descripcion":"TAQUICARDIA AURICULAR POR REENTRADA"
  },
  {
    "codigo":168357009,
    "descripcion":"ORGANISMO NO AISLADO EN CULTIVO DE HISOPADO VAGINAL"
  },
  {
    "codigo":364965009,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA MOVER LA LENGUA LATERALMENTE"
  },
  {
    "codigo":723578001,
    "descripcion":"SÍNDROME DE DISPLASIA ÓSEA TERMINAL Y DEFECTO PIGMENTARIO"
  },
  {
    "codigo":232058008,
    "descripcion":"SÍNDROME DE USHER TIPO 2"
  },
  {
    "codigo":295759001,
    "descripcion":"SOBREDOSIS DE PACLITAXEL"
  },
  {
    "codigo":461434008,
    "descripcion":"ARTERIA COLATERAL MAYOR QUE DERIVA EL FLUJO SISTÉMICO HACIA LA CIRCULACIÓN PULMONAR CON ARTERIA PULMONAR PROXIMAL A LA BIFURCACIÓN HILIAR"
  },
  {
    "codigo":230223008,
    "descripcion":"TROMBOFLEBITIS SÉPTICA DE SENO SIGMOIDEO"
  },
  {
    "codigo":66383009,
    "descripcion":"GINGIVITIS"
  },
  {
    "codigo":721743009,
    "descripcion":"INFECCIÓN CAUSADA POR STREPTOCOCCUS BETA-HEMOLÍTICO"
  },
  {
    "codigo":293924006,
    "descripcion":"ALERGIA A HALOPERIDOL"
  },
  {
    "codigo":228388006,
    "descripcion":"ADICTO A DROGAS ENDOVENOSAS"
  },
  {
    "codigo":126361000119107,
    "descripcion":"EVIDENCIA CITOLÓGICA DE NEOPLASIA MALIGNA EN EXTENDIDO DE PAPANICOLAOU ANAL"
  },
  {
    "codigo":345651000119101,
    "descripcion":"IRIDODIÁLISIS DE AMBOS OJOS"
  },
  {
    "codigo":95481007,
    "descripcion":"LENTIGLOBO ANTERIOR"
  },
  {
    "codigo":421326000,
    "descripcion":"TRASTORNO DEL SISTEMA NERVIOSO DEBIDO A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":880078001,
    "descripcion":"SÍNDROME DE DELECIÓN 11P15"
  },
  {
    "codigo":93646002,
    "descripcion":"MELANOMA MALIGNO DE LA PIEL DEL CUERO CABELLUDO"
  },
  {
    "codigo":716238003,
    "descripcion":"SÍNDROME DE SORDERA CON DISPLASIA EPIFISARIA Y BAJA ESTATURA"
  },
  {
    "codigo":60878004,
    "descripcion":"QUISTE TECO-LUTEÍNICO DE OVARIO"
  },
  {
    "codigo":39141000146100,
    "descripcion":"TRASTORNO DEL SUEÑO DEBIDO A DEPENDENCIA DE AGENTE HIPNÓTICO"
  },
  {
    "codigo":191950004,
    "descripcion":"INFECCIÓN CAUSADA POR BLASTOMYCES DERMATITIDIS"
  },
  {
    "codigo":292089009,
    "descripcion":"REACCIÓN ADVERSA AL TENOXICAM"
  },
  {
    "codigo":26275000,
    "descripcion":"FIEBRE DE FORT BRAGG"
  },
  {
    "codigo":288419001,
    "descripcion":"INCAPAZ DE ENHEBRAR UNA AGUJA"
  },
  {
    "codigo":124579008,
    "descripcion":"DEFICIENCIA DE METALOCARBOXIPEPTIDASA"
  },
  {
    "codigo":188280007,
    "descripcion":"NEOPLASIA MALIGNA DEL CEREBRO (EXCLUIDOS LOS LÓBULOS Y LOS VENTRÍCULOS)"
  },
  {
    "codigo":710733002,
    "descripcion":"GOTA CRÓNICA SIN TOFO"
  },
  {
    "codigo":446754004,
    "descripcion":"ENTERITIS CAUSADA POR VIRUS COXSACKIE HUMANO"
  },
  {
    "codigo":282914005,
    "descripcion":"INCAPAZ DE SENTARSE"
  },
  {
    "codigo":248311001,
    "descripcion":"OBESIDAD CENTRAL"
  },
  {
    "codigo":84471002,
    "descripcion":"CHORRO DE ORINA LENTO"
  },
  {
    "codigo":18935007,
    "descripcion":"GRANULOMA IDIOPÁTICO AISLADO DEL ESTÓMAGO"
  },
  {
    "codigo":82636008,
    "descripcion":"TRASTORNO ORGÁSMICO"
  },
  {
    "codigo":836300009,
    "descripcion":"RUPTURA DE TENDÓN DE ABDUCTOR DE LA CADERA"
  },
  {
    "codigo":1260449002,
    "descripcion":"SÍNDROME POLIENDOCRINO POLINEUROPATÍA"
  },
  {
    "codigo":768929003,
    "descripcion":"SÍNDROME DE TRISOMÍA 8P"
  },
  {
    "codigo":15965901000119108,
    "descripcion":"HIPOPLASIA CONGÉNITA DE TESTÍCULO Y ESCROTO"
  },
  {
    "codigo":734326000,
    "descripcion":"ESTENOSIS DE ARTERIA VERTEBRAL IZQUIERDA"
  },
  {
    "codigo":1293217009,
    "descripcion":"HAMARTOMA CONDROMESENQUIMAL DE PARED TORÁCICA"
  },
  {
    "codigo":767094002,
    "descripcion":"TRASTORNO DEL PARÉNQUIMA RENAL"
  },
  {
    "codigo":308342008,
    "descripcion":"SITUACIÓN DE LA INFORMACIÓN DEL PACIENTE"
  },
  {
    "codigo":210038008,
    "descripcion":"LESIÓN CEREBRAL FOCAL"
  },
  {
    "codigo":109899002,
    "descripcion":"INDICACIÓN PARA LA MODIFICACIÓN DEL ESTADO EMOCIONAL DEL PACIENTE"
  },
  {
    "codigo":77131002,
    "descripcion":"INTOXICACIÓN POR TONZILAMINA"
  },
  {
    "codigo":404811004,
    "descripcion":"COLITIS INESPECÍFICA"
  },
  {
    "codigo":208203007,
    "descripcion":"RUPTURA COMPLETA NO EXPUESTA DE ARTICULACIÓN SACROILÍACA"
  },
  {
    "codigo":372043009,
    "descripcion":"HIDROPESÍA DE ALANTOIDES"
  },
  {
    "codigo":402976003,
    "descripcion":"INFECCIÓN CUTÁNEA POR EL MYCOBACTERIUM KANSASII"
  },
  {
    "codigo":9760005,
    "descripcion":"DIAGNÓSTICO APLAZADO EN EL EJE I"
  },
  {
    "codigo":370208006,
    "descripcion":"ASMA QUE NUNCA PRODUCE SÍNTOMAS DIURNOS"
  },
  {
    "codigo":16021351000119106,
    "descripcion":"BURSITIS SUBROTULIANA BILATERAL"
  },
  {
    "codigo":401141001,
    "descripcion":"PREOCUPACIÓN DE LOS PADRES SOBRE EL NIÑO"
  },
  {
    "codigo":302837001,
    "descripcion":"MELANOMA EN LENTIGO MALIGNO"
  },
  {
    "codigo":827125005,
    "descripcion":"MASA ABDOMINAL FIJA DURANTE LA RESPIRACIÓN"
  },
  {
    "codigo":204533007,
    "descripcion":"AGENESIA DE LARINGE, TRÁQUEA Y BRONQUIO"
  },
  {
    "codigo":301002002,
    "descripcion":"NEUMONÍA DE LÓBULO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":268234004,
    "descripcion":"ENFERMEDAD FIBROQUÍSTICA DE RIÑÓN"
  },
  {
    "codigo":202698007,
    "descripcion":"ESPONDILITIS POR BRUCELLA"
  },
  {
    "codigo":169930008,
    "descripcion":"PUNTAJE DE APGAR A LOS 10 MINUTOS = 7"
  },
  {
    "codigo":69791001,
    "descripcion":"PRESIÓN VENOSA AUMENTADA"
  },
  {
    "codigo":366538009,
    "descripcion":"AMPLITUD DE MOVIMIENTO ACTIVO DE SUPINACIÓN DE LA MUÑECA - HALLAZGO"
  },
  {
    "codigo":233631005,
    "descripcion":"BRONQUIECTASIA TÓXICA"
  },
  {
    "codigo":725151007,
    "descripcion":"SUSCEPTIBILIDAD MENDELIANA AUTOSÓMICA DOMINANTE A ENFERMEDAD CAUSADA POR MICOBACTERIAS DEBIDA A DEFICIENCIA PARCIAL DE RECEPTOR 2 DE INTERFERÓN GAMMA"
  },
  {
    "codigo":168095008,
    "descripcion":"MICROSCOPIA DE LÍQUIDO AMNIÓTICO, NO SE DETECTARON ANOMALÍAS"
  },
  {
    "codigo":1085441000119105,
    "descripcion":"FÍSTULA DE COLOSTOMÍA"
  },
  {
    "codigo":264564001,
    "descripcion":"HAMARTOMA DE LA PULPA ROJA"
  },
  {
    "codigo":231796003,
    "descripcion":"CELULITIS PALPEBRAL"
  },
  {
    "codigo":2420007,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO DE MÚLTIPLES SITIOS DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":721481000,
    "descripcion":"SÍNDROME DE BROWN-SEQUARD DE MÉDULA ESPINAL DORSAL"
  },
  {
    "codigo":723316007,
    "descripcion":"DOLOR TIPO CHOQUE ELÉCTRICO"
  },
  {
    "codigo":295497000,
    "descripcion":"SOBREDOSIS DE ÓXIDO NITROSO"
  },
  {
    "codigo":102401000119108,
    "descripcion":"INCOMPETENCIA VELOFARÍNGEA ADQUIRIDA"
  },
  {
    "codigo":197193008,
    "descripcion":"ADHERENCIAS YEYUNALES"
  },
  {
    "codigo":262729009,
    "descripcion":"SECCIÓN PARCIAL DE LA RAÍZ DE NERVIO CERVICAL"
  },
  {
    "codigo":64286001,
    "descripcion":"ENDOMETRIOSIS DEL FONDO DE SACO RECTOUTERINO"
  },
  {
    "codigo":228126003,
    "descripcion":"BAJO TUTELA DE LA CORTE"
  },
  {
    "codigo":129822005,
    "descripcion":"HALLAZGO RELACIONADO CON EL CRECIMIENTO Y\/O EL DESARROLLO EN LA INFANCIA"
  },
  {
    "codigo":293662006,
    "descripcion":"ALERGIA A OLSALAZINA"
  },
  {
    "codigo":719646006,
    "descripcion":"SÍNDROME DE DELECIÓN 8P11.2"
  },
  {
    "codigo":95219002,
    "descripcion":"DISGENESIA GONADAL PURA"
  },
  {
    "codigo":1078259004,
    "descripcion":"AGENESIA DE EPÍFISIS DE FALANGE DISTAL DE CUARTO DEDO DE PIE"
  },
  {
    "codigo":291827005,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR PROGESTÁGENO"
  },
  {
    "codigo":717811007,
    "descripcion":"INMUNODEFICIENCIA COMBINADA DEBIDA A DISFUNCIÓN DEL CANAL DE CALCIO ACTIVADO POR LIBERACIÓN DE CALCIO"
  },
  {
    "codigo":193523008,
    "descripcion":"PUPILA ECTÓPICA"
  },
  {
    "codigo":1141960001,
    "descripcion":"CONDUCTA RESTRICTIVA"
  },
  {
    "codigo":93384001,
    "descripcion":"ESTENOSIS CONGÉNITA DEL CAYADO AÓRTICO"
  },
  {
    "codigo":321691000119106,
    "descripcion":"ARTRITIS DE RODILLA IZQUIERDA CAUSADA POR STAPHYLOCOCCUS"
  },
  {
    "codigo":289992007,
    "descripcion":"NO PUEDE MANEJAR LA ABROCHADURA DE LA VESTIMENTA"
  },
  {
    "codigo":224456008,
    "descripcion":"CON LICENCIA LABORAL"
  },
  {
    "codigo":879816009,
    "descripcion":"HIPERTENSIÓN PULMONAR POR HEMANGIOMATOSIS CAPILAR PULMONAR FAMILIAR"
  },
  {
    "codigo":124317002,
    "descripcion":"DEFICIENCIA DE DEFOSFO - COA CINASA"
  },
  {
    "codigo":58781003,
    "descripcion":"TENDINITIS DE MÚSCULO GLÚTEO"
  },
  {
    "codigo":91549008,
    "descripcion":"HIPERPLASIA CELULAR HILIAR OVÁRICA"
  },
  {
    "codigo":122482001,
    "descripcion":"BOLSA SEROSA INFECTADA"
  },
  {
    "codigo":417394002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CURVA DE PRESIÓN VENOSA CENTRAL"
  },
  {
    "codigo":253554002,
    "descripcion":"DEFECTO PERIMEMBRANOSO DEL TABIQUE INTERVENTRICULAR CON EXTENSIÓN HACIA LA SALIDA DEL VENTRÍCULO DERECHO"
  },
  {
    "codigo":1269362005,
    "descripcion":"CRISIS EPILÉPTICA TÓNICA CON ALTERACIÓN DE CONCIENCIA DE INICIO FOCAL"
  },
  {
    "codigo":286322008,
    "descripcion":"CAPAZ DE USAR SONIDOS COMBINADOS"
  },
  {
    "codigo":218951002,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR PANCREATINA"
  },
  {
    "codigo":284487002,
    "descripcion":"EXTREMADAMENTE CARENTE DE AFECTO"
  },
  {
    "codigo":249884003,
    "descripcion":"DESVIACIÓN DE LA ÚVULA"
  },
  {
    "codigo":1003548004,
    "descripcion":"AGENESIA DE TESTÍCULO"
  },
  {
    "codigo":86044005,
    "descripcion":"ESCLEROSIS LATERAL AMIOTRÓFICA"
  },
  {
    "codigo":315420004,
    "descripcion":"NACIDO EN EL SALVADOR"
  },
  {
    "codigo":282652009,
    "descripcion":"CAPAZ DE TRANSFERIR PESO"
  },
  {
    "codigo":84209002,
    "descripcion":"AMNESIA PSICÓGENA"
  },
  {
    "codigo":444657001,
    "descripcion":"SÍNDROME DE ARTERIA CEREBELOSA SUPERIOR"
  },
  {
    "codigo":248049007,
    "descripcion":"ANÉCDOTAS FANTÁSTICAS"
  },
  {
    "codigo":16838000,
    "descripcion":"ENFISEMA DEL MEDIASTINO"
  },
  {
    "codigo":82374005,
    "descripcion":"LACTANCIA NORMAL"
  },
  {
    "codigo":1260187001,
    "descripcion":"CICATRIZ DE MEMBRANA MUCOSA DE LABIO INFERIOR"
  },
  {
    "codigo":768667002,
    "descripcion":"SÍNDROME DE YAO"
  },
  {
    "codigo":277147003,
    "descripcion":"REACCIÓN TRANSFUSIONAL TARDÍA"
  },
  {
    "codigo":735899002,
    "descripcion":"LACERACIÓN DE VENA DORSAL DEL PIE"
  },
  {
    "codigo":275312001,
    "descripcion":"FOSITA PARALELA A LA REGIÓN SACRA"
  },
  {
    "codigo":47771009,
    "descripcion":"LESIÓN TRAUMÁTICA DE TRACTO GASTROINTESTINAL"
  },
  {
    "codigo":764997000,
    "descripcion":"TRISOMÍA 9Q NO DISTAL"
  },
  {
    "codigo":109637004,
    "descripcion":"MALA OCLUSIÓN DEBIDA A INSERCIÓN ANORMAL DEL FRENILLO"
  },
  {
    "codigo":240709008,
    "descripcion":"CANDIDIASIS PERINEAL"
  },
  {
    "codigo":402714001,
    "descripcion":"LIQUEN ESCLEROSO DE GENITALES MASCULINOS"
  },
  {
    "codigo":271642002,
    "descripcion":"PARED ARTERIAL PALPABLE"
  },
  {
    "codigo":207941008,
    "descripcion":"FRACTURA NO EXPUESTA DE VÉRTEBRA DORSAL, ESPONDILÓLISIS"
  },
  {
    "codigo":238874008,
    "descripcion":"SÍNDROME PROGEROIDE NEONATAL SEUDOHIDROCEFÁLICO"
  },
  {
    "codigo":284339008,
    "descripcion":"DIFICULTAD PARA COLOCAR UN OBJETO SOBRE OTRO"
  },
  {
    "codigo":1285615007,
    "descripcion":"HEMATOMA DE DEDO MEDIO DE MANO"
  },
  {
    "codigo":202436001,
    "descripcion":"TUMOR TENOSINOVIAL DIFUSO DE CÉLULAS GIGANTES DE CODO"
  },
  {
    "codigo":366276002,
    "descripcion":"FLUJO URINARIO - HALLAZGO"
  },
  {
    "codigo":300740003,
    "descripcion":"PARTICIPA EN ACTIVIDADES DE TIEMPO LIBRE"
  },
  {
    "codigo":237039009,
    "descripcion":"SALPINGITIS POR CLAMIDIA"
  },
  {
    "codigo":726724005,
    "descripcion":"SÍNDROME DE FUSIÓN ESPLENOGONADAL, DEFECTO DE LOS MIEMBROS Y MICROGNATIA"
  },
  {
    "codigo":399044006,
    "descripcion":"GLOSOPIROSIS"
  },
  {
    "codigo":71364004,
    "descripcion":"QUEMADURA PROFUNDA DE TERCER GRADO DE MUSLO"
  },
  {
    "codigo":38596008,
    "descripcion":"CATARRO TUBOTIMPÁNICO CRÓNICO"
  },
  {
    "codigo":3993001,
    "descripcion":"INFECCIÓN CAUSADA POR MUELLERIUS"
  },
  {
    "codigo":167833004,
    "descripcion":"VÓMITO: MOCO PRESENTE"
  },
  {
    "codigo":298905006,
    "descripcion":"AMPLITUD DE SUPINACIÓN ACTIVA DE CODO DISMINUIDA"
  },
  {
    "codigo":724889009,
    "descripcion":"DISTENSIÓN DE FASCIA DE ABDOMEN"
  },
  {
    "codigo":397209009,
    "descripcion":"INVASIÓN TUMORAL DE LA ARTERIA (VASO GRANDE), PRESENTE"
  },
  {
    "codigo":297070003,
    "descripcion":"SOBREDOSIS DE ALCALOIDE DEL CORNEZUELO DE CENTENO"
  },
  {
    "codigo":2158004,
    "descripcion":"INFECCIÓN CAUSADA POR CONTRACAECUM"
  },
  {
    "codigo":360771001,
    "descripcion":"DEFICIENCIA DE GLICEROFOSFATASA"
  },
  {
    "codigo":721219005,
    "descripcion":"ENFERMEDAD POR PRIONES SIMILAR AL ALZHEIMER FAMILIAR"
  },
  {
    "codigo":229699006,
    "descripcion":"PRAXIA ARTICULATORIA INMADURA"
  },
  {
    "codigo":426307007,
    "descripcion":"ELECTROCARDIOGRAMA: RITMO DE LA UNIÓN AURICULOVENTRICULAR"
  },
  {
    "codigo":162328000,
    "descripcion":"METICULOSO"
  },
  {
    "codigo":295235007,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE FELBINACO"
  },
  {
    "codigo":1145368006,
    "descripcion":"LESIÓN EN BOLA DE NIEVE DE CUERPO CALLOSO"
  },
  {
    "codigo":293400006,
    "descripcion":"REACCIÓN ADVERSA AL INOSITOL"
  },
  {
    "codigo":94957001,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA CAVIDAD NASAL"
  },
  {
    "codigo":291565007,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR CEFALOTINA"
  },
  {
    "codigo":29421008,
    "descripcion":"INTENTO FALLIDO DE ABORTO COMPLICADO POR INSUFICIENCIA RENAL"
  },
  {
    "codigo":353181000119102,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE EPIDÍDIMO IZQUIERDO"
  },
  {
    "codigo":1141698003,
    "descripcion":"DEMUESTRA CONOCIMIENTO SOBRE EJERCICIO FÍSICO"
  },
  {
    "codigo":224194003,
    "descripcion":"NO CALIFICADO PARA RECIBIR SUBSIDIOS"
  },
  {
    "codigo":1010626008,
    "descripcion":"ABSCESO PERIAMIGDALINO RECIDIVANTE"
  },
  {
    "codigo":93122008,
    "descripcion":"FALTA DE OSIFICACIÓN DEL ASTRÁGALO"
  },
  {
    "codigo":289730008,
    "descripcion":"HALLAZGO RELACIONADO CON EL DOLOR DE LA CONTRACCIÓN UTERINA"
  },
  {
    "codigo":713879003,
    "descripcion":"GINGIVITIS DEBIDA A PLACA DENTAL CON FACTOR CONTRIBUYENTE LOCAL"
  },
  {
    "codigo":1303703003,
    "descripcion":"OSTEOMIELITIS CRÓNICA DE HUESO METATARSIANO IZQUIERDO"
  },
  {
    "codigo":1172631001,
    "descripcion":"PARAPLEJÍA ESPÁSTICA AUTOSÓMICA RECESIVA TIPO 76"
  },
  {
    "codigo":255127006,
    "descripcion":"METÁSTASIS TUMORAL LOCAL"
  },
  {
    "codigo":124055002,
    "descripcion":"ÉSTERES DE COLESTEROL POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":89452002,
    "descripcion":"PÓLIPO HIPERPLÁSICO DE INTESTINO"
  },
  {
    "codigo":23916006,
    "descripcion":"ENTERITIS PIOGRANULOMATOSA"
  },
  {
    "codigo":449900006,
    "descripcion":"FASCITIS NECROSANTE CAUSADA POR STREPTOCOCCUS PYOGENES"
  },
  {
    "codigo":286060007,
    "descripcion":"CAPAZ DE PLANCHAR"
  },
  {
    "codigo":251457001,
    "descripcion":"TRAZADO ELECTROENCEFALOGRÁFICO ALTERNANTE"
  },
  {
    "codigo":56684007,
    "descripcion":"NEUROPATÍA ATÁXICA NUTRICIONAL"
  },
  {
    "codigo":415297005,
    "descripcion":"RETINOPATÍA DE LA PREMATUREZ"
  },
  {
    "codigo":448065006,
    "descripcion":"ANOMALÍA CONGÉNITA DE VENA SISTÉMICA"
  },
  {
    "codigo":284225005,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DE NALGA"
  },
  {
    "codigo":710209009,
    "descripcion":"TUMOR DE CÉLULAS GIGANTES DE HUESO LARGO DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":85782003,
    "descripcion":"ÁNTRAX DE LA REGIÓN DEL CUELLO"
  },
  {
    "codigo":413462007,
    "descripcion":"EJERCICIO AERÓBICO TRES VECES POR SEMANA"
  },
  {
    "codigo":247787005,
    "descripcion":"PLANIFICACIÓN DE PROYECTOS NO REALIZABLES"
  },
  {
    "codigo":213184004,
    "descripcion":"FALLA TOTAL DE REIMPLANTE DE LOS DEDOS DE LA MANO"
  },
  {
    "codigo":82112005,
    "descripcion":"NEFRITIS TUBULOINTERSTICIAL CRÓNICA IDIOPÁTICA"
  },
  {
    "codigo":1360064007,
    "descripcion":"ÁNGULO ABIERTO AMPLIO DE OJO IZQUIERDO"
  },
  {
    "codigo":1259925000,
    "descripcion":"TRASTORNO FETAL DEBIDO A DESPROPORCIÓN FETOPELVIANA DURANTE PARTO"
  },
  {
    "codigo":14741001,
    "descripcion":"LUXACIÓN NO EXPUESTA POSTERIOR DE EXTREMO PROXIMAL DE TIBIA"
  },
  {
    "codigo":1163456008,
    "descripcion":"HIPERTROFIA GINGIVAL DEBIDA A SÍNDROME DE COWDEN"
  },
  {
    "codigo":735637004,
    "descripcion":"SEPSIS NEONATAL CAUSADA POR STREPTOCOCCUS PYOGENES"
  },
  {
    "codigo":406122000,
    "descripcion":"CABEZA-HALLAZGO"
  },
  {
    "codigo":111210001,
    "descripcion":"FIBROESCLEROSIS MULTIFOCAL"
  },
  {
    "codigo":80277008,
    "descripcion":"INFECCIÓN CAUSADA POR STRIGEA"
  },
  {
    "codigo":373354004,
    "descripcion":"COMPROMISO TUMORAL EN MARGEN DE RESECCIÓN QUIRÚRGICA, PRESENTE (MAMA)"
  },
  {
    "codigo":1290858009,
    "descripcion":"SARCOMA MIOFIBROBLÁSTICO INFLAMATORIO EPITELIOIDE"
  },
  {
    "codigo":764735002,
    "descripcion":"CARCINOMA ESCAMOCELULAR DE INTESTINO DELGADO"
  },
  {
    "codigo":240447002,
    "descripcion":"FIEBRE DE PONTIAC"
  },
  {
    "codigo":830271003,
    "descripcion":"CEGUERA COMPLETA DE OJO DERECHO EVALUADA CON AGUJERO ESTENOPEICO"
  },
  {
    "codigo":109375006,
    "descripcion":"NEOPLASIA BENIGNA DEL TEJIDO MESOTELIAL DE OTRO SITIO DISTINTO DE LA PLEURA Y EL PERICARDIO"
  },
  {
    "codigo":74772000,
    "descripcion":"MENINGOMIELITIS"
  },
  {
    "codigo":238612002,
    "descripcion":"PSORIASIS PUSTULOSA GENERALIZADA"
  },
  {
    "codigo":1287188004,
    "descripcion":"ERUPCIÓN DE PIEL CAUSADA POR SALMONELLA"
  },
  {
    "codigo":369684006,
    "descripcion":"MARGEN PANCREÁTICO DISTAL DE RESECCIÓN QUIRÚRGICA DE LA AMPOLLA DE VATER, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":9236007,
    "descripcion":"ALEXIA"
  },
  {
    "codigo":15701201000119107,
    "descripcion":"TRASTORNO DE TENDÓN DE AMBOS BÍCEPS BRAQUIALES"
  },
  {
    "codigo":1187049003,
    "descripcion":"SÍNDROME DE AICARDI GOUTIERES TIPO 5"
  },
  {
    "codigo":105705004,
    "descripcion":"ENFERMEDAD CAUSADA POR HETERAKOIDEA"
  },
  {
    "codigo":300478000,
    "descripcion":"HALLAZGO RELACIONADO CON MEDICIONES DE DIÁLISIS"
  },
  {
    "codigo":366014002,
    "descripcion":"ASPECTO GENERAL DE LA CONJUNTIVA DEL LIMBO - HALLAZGO"
  },
  {
    "codigo":38334009,
    "descripcion":"DÉFICIT EN EL MANEJO DE LA SALUD"
  },
  {
    "codigo":5566009,
    "descripcion":"TRIPANOSOMIASIS CON MENINGITIS"
  },
  {
    "codigo":167571004,
    "descripcion":"CULTIVO DE ORINA: PROTEUS"
  },
  {
    "codigo":724627006,
    "descripcion":"PROBLEMA DE MUÑECA"
  },
  {
    "codigo":298643006,
    "descripcion":"AMPLITUD DE FLEXIÓN LATERAL PASIVA HACIA LA IZQUIERDA DE LA COLUMNA VERTEBRAL LUMBAR, DISMINUIDA"
  },
  {
    "codigo":429715006,
    "descripcion":"GESTACIÓN DE MÁS DE 20 SEMANAS"
  },
  {
    "codigo":395112001,
    "descripcion":"CON MAYOR RIESGO DE EVENTO CARDIOVASCULAR"
  },
  {
    "codigo":48201000087104,
    "descripcion":"FRACTURA DE CABEZA DE HÚMERO IZQUIERDO"
  },
  {
    "codigo":37961000087107,
    "descripcion":"ACINESIA DE SEGMENTO ANTERIOR APICAL DE VENTRÍCULO CARDÍACO IZQUIERDO"
  },
  {
    "codigo":1896004,
    "descripcion":"TEJIDO MAMARIO ECTÓPICO"
  },
  {
    "codigo":43081000087109,
    "descripcion":"HEMATOMA DE PULGAR IZQUIERDO"
  },
  {
    "codigo":35401000087106,
    "descripcion":"INFARTO ANTIGUO DE MIOCARDIO DE VÉRTICE CARDÍACO"
  },
  {
    "codigo":40521000087105,
    "descripcion":"FRACTURA DE FALANGE PROXIMAL DE DEDO MEDIO IZQUIERDO"
  },
  {
    "codigo":1279848007,
    "descripcion":"DESPRENDIMIENTO DE RETINA CON ROTURA DE RETINA"
  },
  {
    "codigo":16903531000119107,
    "descripcion":"MENINGIOMA ATÍPICO DE LAS MENINGES CEREBRALES"
  },
  {
    "codigo":131133003,
    "descripcion":"NIVEL DE ÁCIDO FÓLICO POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":294973005,
    "descripcion":"ALERGIA A PRAVASTATINA"
  },
  {
    "codigo":720957007,
    "descripcion":"SÍNDROME DE SORDERA CON DISPLASIA ESQUELÉTICA Y GRANULOMA DE LABIO"
  },
  {
    "codigo":1343549008,
    "descripcion":"FLUOROSCOPIA DE VESÍCULA BILIAR CON CONTRASTE NORMAL"
  },
  {
    "codigo":293138000,
    "descripcion":"REACCIÓN ADVERSA AL CARBIMAZOL"
  },
  {
    "codigo":1145106001,
    "descripcion":"ESCASO CRECIMIENTO DE PESTAÑAS DE PÁRPADO SUPERIOR"
  },
  {
    "codigo":782823001,
    "descripcion":"SÍNDROME DE TELANGIECTASIA CUTÁNEA FAMILIAR Y PREDISPOSICIÓN AL CÁNCER OROFARÍNGEO"
  },
  {
    "codigo":422375001,
    "descripcion":"CARCINOMA DE COLON, ESTADIO III"
  },
  {
    "codigo":291303001,
    "descripcion":"INTOXICACIÓN POR AGONISTAS BETA-ADRENORRECEPTORES"
  },
  {
    "codigo":1003571002,
    "descripcion":"AGENESIA DE HUESO CALCÁNEO"
  },
  {
    "codigo":61927004,
    "descripcion":"CONVULSIÓN AUDITIVA"
  },
  {
    "codigo":1208807009,
    "descripcion":"ALERGIA A PROTEÍNA DE GATO DOMÉSTICO"
  },
  {
    "codigo":29159009,
    "descripcion":"DISAUTONOMÍA FAMILIAR"
  },
  {
    "codigo":125628003,
    "descripcion":"LESIÓN TRAUMÁTICA DEL DUODENO"
  },
  {
    "codigo":94695009,
    "descripcion":"ESOTROPÍA MONOCULAR CON PATRÓN X O Y"
  },
  {
    "codigo":289468006,
    "descripcion":"VULVA NO OBSERVADA"
  },
  {
    "codigo":91025000,
    "descripcion":"MIOCARDITIS IDIOPÁTICA"
  },
  {
    "codigo":92860008,
    "descripcion":"FUSIÓN ANORMAL CONGÉNITA DEL ILION"
  },
  {
    "codigo":16467461000119107,
    "descripcion":"MELORREOSTOSIS BILATERAL DE FÉMURES"
  },
  {
    "codigo":254865006,
    "descripcion":"FIBROMA DE OVARIO"
  },
  {
    "codigo":1336209008,
    "descripcion":"MUTACIÓN DE REGIÓN NO TRADUCIDA"
  },
  {
    "codigo":283963001,
    "descripcion":"LACERACIÓN DEL ÚTERO"
  },
  {
    "codigo":1332539002,
    "descripcion":"MELORREOSTOSIS DE COSTILLA"
  },
  {
    "codigo":251195004,
    "descripcion":"EJE DE LA ONDA P SUPERIOR"
  },
  {
    "codigo":415035006,
    "descripcion":"RABIA PARALÍTICA"
  },
  {
    "codigo":54587008,
    "descripcion":"FOBIA SIMPLE"
  },
  {
    "codigo":773648002,
    "descripcion":"SÍNDROME DE CATARATA CONGÉNITA, HIPOACUSIA Y RETRASO SEVERO DEL DESARROLLO"
  },
  {
    "codigo":249360004,
    "descripcion":"GRANULOMA DEL TABIQUE NASAL"
  },
  {
    "codigo":19984005,
    "descripcion":"INFESTACIÓN CAUSADA POR MYOCOPTES"
  },
  {
    "codigo":12236601000119100,
    "descripcion":"ARTRITIS DE DEDO DE LA MANO DERECHA"
  },
  {
    "codigo":15677241000119100,
    "descripcion":"MIOSITIS DE AMBOS HOMBROS"
  },
  {
    "codigo":138911000119106,
    "descripcion":"RETINOPATÍA NO PROLIFERATIVA LEVE DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":247525002,
    "descripcion":"CRECIMIENTO DEL PELO ESCASO"
  },
  {
    "codigo":444133002,
    "descripcion":"ESCLEROSIS SISTÉMICA PROGRESIVA"
  },
  {
    "codigo":442298000,
    "descripcion":"FRACTURA DE STENT DE ARTERIA CORONARIA"
  },
  {
    "codigo":1359802003,
    "descripcion":"COLONIZACIÓN CRÓNICA DE TRACTO RESPIRATORIO CAUSADA POR PANDORAEA"
  },
  {
    "codigo":737210007,
    "descripcion":"POLICITEMIA NEONATAL DEBIDA A RETRASO DEL CRECIMIENTO INTRAUTERINO"
  },
  {
    "codigo":276623000,
    "descripcion":"ABRASIÓN NEONATAL DE PIEL DE CUERO CABELLUDO"
  },
  {
    "codigo":212922008,
    "descripcion":"CONGELAMIENTO SUPERFICIAL DE RODILLA Y PIERNA"
  },
  {
    "codigo":243855000,
    "descripcion":"SITUACIÓN DEL MONITOREO DE TRASTORNO PSIQUIÁTRICO"
  },
  {
    "codigo":704442007,
    "descripcion":"DÉFICIT EN LA CAPACIDAD PARA VESTIRSE\/ACICALARSE POR SÍ MISMO"
  },
  {
    "codigo":1259663006,
    "descripcion":"DEMENCIA DEBIDA A POLIARTERITIS NODOSA"
  },
  {
    "codigo":209252000,
    "descripcion":"FRACTURA-LUXACIÓN NO EXPUESTA DE ARTICULACIÓN DE CODO"
  },
  {
    "codigo":405860004,
    "descripcion":"FENOTIPO JK(B-)"
  },
  {
    "codigo":438628005,
    "descripcion":"NEOPLASIA CON RECEPTORES HORMONALES NEGATIVOS"
  },
  {
    "codigo":685881000119106,
    "descripcion":"LIPOSARCOMA PRIMARIO DE PARTES BLANDAS DE CABEZA"
  },
  {
    "codigo":373092008,
    "descripcion":"FÍSTULA CORONARIA A LA AURÍCULA IZQUIERDA"
  },
  {
    "codigo":698937002,
    "descripcion":"COLOCACIÓN ERRÓNEA DE CATÉTER DE HEMODIÁLISIS"
  },
  {
    "codigo":404025004,
    "descripcion":"SCHWANNOMA PLEXIFORME"
  },
  {
    "codigo":240185006,
    "descripcion":"DESLIZAMIENTO DE LA EPÍFISIS RADIAL DISTAL"
  },
  {
    "codigo":10809006,
    "descripcion":"LARINGOTRAQUEÍTIS CAUSADA POR EL VIRUS PARAINFLUENZA"
  },
  {
    "codigo":271118000,
    "descripcion":"AMPOLLA TRAUMÁTICA DE LA PARED TORÁCICA"
  },
  {
    "codigo":43577009,
    "descripcion":"LISTA DE REEMPLAZO DE VEGETALES"
  },
  {
    "codigo":331731000119102,
    "descripcion":"ECTROPIÓN SENIL DE PÁRPADO SUPERIOR DERECHO"
  },
  {
    "codigo":830009009,
    "descripcion":"RETINA DE OJO DERECHO NORMAL"
  },
  {
    "codigo":305721007,
    "descripcion":"VISTO POR UN OFTALMÓLOGO"
  },
  {
    "codigo":236515002,
    "descripcion":"NEFROPATÍA TÓXICA AGUDA"
  },
  {
    "codigo":39907005,
    "descripcion":"INFESTACIÓN CAUSADA POR XENOPSYLLA"
  },
  {
    "codigo":726200001,
    "descripcion":"LESIÓN TRAUMÁTICA DE FASCIA DE MÚSCULO INTRÍNSECO DE DEDO DE LA MANO"
  },
  {
    "codigo":169144003,
    "descripcion":"GAMMAGRAFÍA ESTÁTICA DE RIÑONES NORMAL"
  },
  {
    "codigo":300216007,
    "descripcion":"NO PRESTA ATENCIÓN A LA COMUNICACIÓN VERBAL DIRECTA"
  },
  {
    "codigo":103608007,
    "descripcion":"ESPÉCIMEN SUBÓPTIMO PARA DIAGNÓSTICO POR FALTA DE INFORMACIÓN CLÍNICA"
  },
  {
    "codigo":200077002,
    "descripcion":"COMPLICACIONES CARDÍACAS DE LA ANESTESIA DURANTE EL TRABAJO DE PARTO Y EL PARTO"
  },
  {
    "codigo":3469002,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DE PULGAR"
  },
  {
    "codigo":722530005,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE AMÍGDALA FARÍNGEA"
  },
  {
    "codigo":165474009,
    "descripcion":"MICROCITOSIS, ERITROCITOS"
  },
  {
    "codigo":198242009,
    "descripcion":"ENFERMEDAD INFLAMATORIA PÉLVICA GONOCÓCICA"
  },
  {
    "codigo":196407001,
    "descripcion":"IMBRICACIÓN DENTAL POSTERIOR"
  },
  {
    "codigo":1144844000,
    "descripcion":"AUSENCIA DE PELO DE AXILA"
  },
  {
    "codigo":294711008,
    "descripcion":"ALERGIA A TRIAMCINOLONA"
  },
  {
    "codigo":292876002,
    "descripcion":"REACCIÓN ADVERSA AL HEXACLOROFANO"
  },
  {
    "codigo":391180006,
    "descripcion":"NEUMOPERICARDIO TRAUMÁTICO"
  },
  {
    "codigo":291041002,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR LORMETAZEPAM"
  },
  {
    "codigo":192737006,
    "descripcion":"ABSCESOS INTRACRANEAL E INTRAMEDULAR"
  },
  {
    "codigo":782561007,
    "descripcion":"ALERGIA A COMPUESTO QUE CONTIENE HIERRO"
  },
  {
    "codigo":61665008,
    "descripcion":"SÍNDROME DE TURCOT"
  },
  {
    "codigo":94433008,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL MIOCARDIO"
  },
  {
    "codigo":92598002,
    "descripcion":"CARCINOMA IN SITU DEL FONDO DEL ESTÓMAGO"
  },
  {
    "codigo":225505009,
    "descripcion":"DIFICULTAD PARA ACEPTAR EL ASPECTO CORPORAL ALTERADO"
  },
  {
    "codigo":12265581000119109,
    "descripcion":"RETRACCIÓN DE AMBOS PEZONES"
  },
  {
    "codigo":190902006,
    "descripcion":"DESEQUILIBRIO HÍDRICO"
  },
  {
    "codigo":715190007,
    "descripcion":"APTO PARA BUCEAR"
  },
  {
    "codigo":56160003,
    "descripcion":"HIDRORREA GRAVÍDICA"
  },
  {
    "codigo":1137504005,
    "descripcion":"DEBILIDAD DE MÚSCULO PROXIMAL DE COMIENZO TARDÍO"
  },
  {
    "codigo":285536006,
    "descripcion":"CAPAZ DE MOVER LA LENGUA LATERALMENTE"
  },
  {
    "codigo":185397002,
    "descripcion":"PACIENTE QUE CONCURRE SEIS VECES POR MES"
  },
  {
    "codigo":15735201000119101,
    "descripcion":"TRASTORNO DE VASO SANGUÍNEO DE RETINA DE OJO DERECHO"
  },
  {
    "codigo":334241000119101,
    "descripcion":"ENTROPIÓN CICATRIZAL DE PÁRPADO INFERIOR DERECHO"
  },
  {
    "codigo":16007431000119108,
    "descripcion":"TENOSINOVITIS DE AMBAS MANOS"
  },
  {
    "codigo":283701008,
    "descripcion":"MORDEDURA HUMANA EN EL BRAZO"
  },
  {
    "codigo":87093008,
    "descripcion":"FÍSTULA URETRORRECTAL CONGÉNITA"
  },
  {
    "codigo":414773008,
    "descripcion":"CADENA PESADA MU MONOCLONAL DETECTADA"
  },
  {
    "codigo":249098007,
    "descripcion":"PRESENTACIÓN DE RODILLAS"
  },
  {
    "codigo":1230303001,
    "descripcion":"MIOCARDIOPATÍA HIPERTRÓFICA FATAL CONGÉNITA DEBIDA A GLUCOGENOSIS"
  },
  {
    "codigo":609546009,
    "descripcion":"HIPERSENSIBILIDAD NO ALÉRGICA A TRANDOLAPRIL"
  },
  {
    "codigo":16636321000119104,
    "descripcion":"TRASTORNO DE AMBOS NERVIOS AXILARES"
  },
  {
    "codigo":738783002,
    "descripcion":"ANTÍGENO LEUCOCÍTICO HUMANO A*31:01 DETECTADO"
  },
  {
    "codigo":11311521000119104,
    "descripcion":"FRACTURA POR OSTEOPOROSIS SECUNDARIA DE VÉRTEBRA CERVICAL"
  },
  {
    "codigo":50655009,
    "descripcion":"FRACTURA DE APÓFISIS CORACOIDES DE OMÓPLATO"
  },
  {
    "codigo":247263009,
    "descripcion":"TÍMPANO ENGROSADO"
  },
  {
    "codigo":1259401002,
    "descripcion":"CARCINOMA UROTELIAL PRIMARIO DE VEJIGA URINARIA"
  },
  {
    "codigo":11776571000119101,
    "descripcion":"LACERACIÓN DE TENDÓN DE HOMBRO DERECHO"
  },
  {
    "codigo":1290334000,
    "descripcion":"RUPTURA DE QUISTE SINOVIAL POPLÍTEO"
  },
  {
    "codigo":702345009,
    "descripcion":"SÍNDROME DE CROMOSOMA 14 EN ANILLO"
  },
  {
    "codigo":307771000119103,
    "descripcion":"DISPLASIA FIBROSA MONOSTÓTICA DE FÉMUR DERECHO"
  },
  {
    "codigo":307294006,
    "descripcion":"ANTECEDENTES PERSONALES - HALLAZGO"
  },
  {
    "codigo":766046007,
    "descripcion":"LEUCEMIA MIELOIDE AGUDA Y SÍNDROME MIELODISPLÁSICO RELACIONADO CON INHIBIDOR DE TOPOISOMERASA TIPO 2"
  },
  {
    "codigo":698675000,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: MONGOL"
  },
  {
    "codigo":45150006,
    "descripcion":"ALUCINACIONES AUDITIVAS"
  },
  {
    "codigo":733278007,
    "descripcion":"LUXACIÓN TRAUMÁTICA POSTERIOR DE CADERA"
  },
  {
    "codigo":208990005,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN MEDIOTARSIANA"
  },
  {
    "codigo":104931000119100,
    "descripcion":"ENFERMEDAD RENAL CRÓNICA DEBIDA A HIPERTENSIÓN"
  },
  {
    "codigo":322531000119101,
    "descripcion":"SINOVITIS TRANSITORIA DE MANO IZQUIERDA"
  },
  {
    "codigo":11773411000119102,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE PULGAR DERECHO"
  },
  {
    "codigo":15628771000119100,
    "descripcion":"MANCHA DE FUCHS DE OJO DERECHO"
  },
  {
    "codigo":1082851000119104,
    "descripcion":"LÓBULO DESGARRADO ADQUIRIDO DE AMBAS OREJAS"
  },
  {
    "codigo":12275171000119105,
    "descripcion":"SÍNDROME DE LINFEDEMA DE MIEMBRO SUPERIOR DERECHO POSTERIOR A MASTECTOMÍA"
  },
  {
    "codigo":332771000119106,
    "descripcion":"ADHESIÓN DE MEMBRANA PUPILAR DE OJO DERECHO"
  },
  {
    "codigo":7651000119100,
    "descripcion":"DEFICIENCIA DE MINERALOCORTICOIDES"
  },
  {
    "codigo":11673571000119101,
    "descripcion":"EXOSTOSIS DE CRÁNEO"
  },
  {
    "codigo":302051000119106,
    "descripcion":"OSTEOCONDROSIS DEL ADULTO DE COLUMNA VERTEBRAL CERVICAL"
  },
  {
    "codigo":1085411000119106,
    "descripcion":"FÍSTULA DE INTESTINO DEBIDA A PÓLIPOS INFLAMATORIOS DE COLON"
  },
  {
    "codigo":350691000119103,
    "descripcion":"AGRANULOCITOSIS DEBIDA A ADMINISTRACIÓN DE AGENTE ANTINEOPLÁSICO Y POSTERIOR A ELLA"
  },
  {
    "codigo":337891000119104,
    "descripcion":"ABSCESO DE ESCLERÓTICA DE OJO IZQUIERDO"
  },
  {
    "codigo":1284829001,
    "descripcion":"OSTEOMA OSTEOIDE DE FÉMUR"
  },
  {
    "codigo":16066531000119106,
    "descripcion":"DOLOR EN REPOSO DE MIEMBRO SUPERIOR DERECHO DEBIDO A ATEROSCLEROSIS"
  },
  {
    "codigo":203485003,
    "descripcion":"OSTEONECROSIS DE HUESO DEBIDA A ENFERMEDAD DE CAISSON"
  },
  {
    "codigo":680931000119109,
    "descripcion":"HIPOTRICOSIS DE PÁRPADO SUPERIOR DERECHO"
  },
  {
    "codigo":1077731000119109,
    "descripcion":"OSTEOMIELITIS DE FÉMUR DERECHO"
  },
  {
    "codigo":348131000119109,
    "descripcion":"ATROFIA ÓPTICA PARCIAL DE OJO DERECHO"
  },
  {
    "codigo":301789000,
    "descripcion":"ADHERENCIAS DE ÚTERO"
  },
  {
    "codigo":15928021000119102,
    "descripcion":"DISTORSIÓN VISUAL BILATERAL"
  },
  {
    "codigo":234418001,
    "descripcion":"GRANULOCITOPENIA BENIGNA CRÓNICA"
  },
  {
    "codigo":725938001,
    "descripcion":"CIRROSIS HEPÁTICA CAUSADA POR METOTREXATO"
  },
  {
    "codigo":431026003,
    "descripcion":"FUNCIONAMIENTO DEFECTUOSO PARCIAL DE EQUIPAMIENTO"
  },
  {
    "codigo":104346171000119109,
    "descripcion":"TROMBOFLEBITIS DE VENA PERONEA DERECHA"
  },
  {
    "codigo":365490007,
    "descripcion":"HALLAZGO RELACIONADO CON DETALLES DEL CUIDADOR INFORMAL"
  },
  {
    "codigo":299954009,
    "descripcion":"SENSACIÓN DE ENVARAMIENTO"
  },
  {
    "codigo":298119007,
    "descripcion":"LESIÓN DEL NERVIO TORÁCICO LARGO"
  },
  {
    "codigo":197980002,
    "descripcion":"HIDROCELE ENQUISTADO DE CORDÓN ESPERMÁTICO"
  },
  {
    "codigo":427356003,
    "descripcion":"VASCULITIS EOSINOFÍLICA CUTÁNEA"
  },
  {
    "codigo":1372004,
    "descripcion":"ÚTERO UNICORNE"
  },
  {
    "codigo":230748005,
    "descripcion":"HIDROCEFALIA CON PRESIÓN ELEVADA EN FORMA INTERMITENTE"
  },
  {
    "codigo":1074031000119100,
    "descripcion":"ARTRITIS GOTOSA DE DEDO GORDO IZQUIERDO"
  },
  {
    "codigo":294449008,
    "descripcion":"ALERGIA A PERÓXIDO DE HIDRÓGENO"
  },
  {
    "codigo":63238001,
    "descripcion":"INGRESÓ CADÁVER"
  },
  {
    "codigo":1144582000,
    "descripcion":"APLASIA DE MÚSCULO PECTORAL MAYOR"
  },
  {
    "codigo":292614006,
    "descripcion":"REACCIÓN ADVERSA A LA XANTINA"
  },
  {
    "codigo":290779006,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR AZATIOPRINA"
  },
  {
    "codigo":288944000,
    "descripcion":"NO DEGLUTE ALIMENTOS"
  },
  {
    "codigo":421851008,
    "descripcion":"ANEMIA HEMOLÍTICA ADQUIRIDA ASOCIADA CON EL SIDA"
  },
  {
    "codigo":94171008,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA PARED ANTERIOR DE LA VEJIGA"
  },
  {
    "codigo":92336000,
    "descripcion":"NEOPLASIA BENIGNA DEL ESCROTO"
  },
  {
    "codigo":59568004,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA AORTA TORÁCICA"
  },
  {
    "codigo":61403008,
    "descripcion":"TRASTORNO BIPOLAR I DEPRESIVO GRAVE SIN SÍNTOMAS PSICÓTICOS"
  },
  {
    "codigo":190640006,
    "descripcion":"RAQUITISMO ACTIVO"
  },
  {
    "codigo":11779081000119100,
    "descripcion":"DISTENSIÓN DE BÍCEPS BRAQUIAL DERECHO"
  },
  {
    "codigo":287109001,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN EL TRONCO"
  },
  {
    "codigo":385413003,
    "descripcion":"PROPAGACIÓN TUMORAL - HALLAZGO"
  },
  {
    "codigo":23130000,
    "descripcion":"HIPERTENSIÓN ARTERIAL PAROXÍSTICA"
  },
  {
    "codigo":188805008,
    "descripcion":"TUMOR BENIGNO DEL PLIEGUE ARITENOIDEO"
  },
  {
    "codigo":11861001000119102,
    "descripcion":"LUXACIÓN TRAUMÁTICA INTERNA NO EXPUESTA DE RODILLA IZQUIERDA"
  },
  {
    "codigo":90501009,
    "descripcion":"ERITROCITOSIS POR TRANSPORTE DEFECTUOSO DE OXÍGENO"
  },
  {
    "codigo":15983471000119109,
    "descripcion":"PABELLÓN AURICULAR SUPERNUMERARIO IZQUIERDO"
  },
  {
    "codigo":285274002,
    "descripcion":"PLANEA INICIAR UN INCENDIO"
  },
  {
    "codigo":55898008,
    "descripcion":"HEMORRAGIA DE LA TÚNICA VAGINAL"
  },
  {
    "codigo":840495000,
    "descripcion":"UNIÓN AURICULOVENTRICULAR COMÚN CON CIERRE FIBROSO ESPONTÁNEO DE DEFECTO DE TABIQUE AURICULOVENTRICULAR"
  },
  {
    "codigo":1332015002,
    "descripcion":"OSTEÓLISIS DE TIBIA"
  },
  {
    "codigo":283439004,
    "descripcion":"CORTE EN EL PIE"
  },
  {
    "codigo":314372002,
    "descripcion":"CUELLO UTERINO VISUALIZADO"
  },
  {
    "codigo":248836003,
    "descripcion":"MAMA FRÍA"
  },
  {
    "codigo":310281000119106,
    "descripcion":"ARTRITIS GOTOSA DE MANO DERECHA"
  },
  {
    "codigo":707588005,
    "descripcion":"CARCINOMA EPITELIAL-MIOEPITELIAL PRIMARIO DE OROFARINGE"
  },
  {
    "codigo":247001004,
    "descripcion":"DEPÓSITOS CLAROS DE LA CÁMARA ANTERIOR"
  },
  {
    "codigo":50393008,
    "descripcion":"INTOXICACIÓN POR CARBÓN - ALQUITRÁN - BREA"
  },
  {
    "codigo":212398005,
    "descripcion":"LESIÓN NO EXPUESTA DE LA TRÁQUEA"
  },
  {
    "codigo":736686006,
    "descripcion":"CHANCRO CAUSADO POR TREPONEMA PALLIDUM"
  },
  {
    "codigo":210563002,
    "descripcion":"HERIDA ABIERTA DE LA MANO, PALMA"
  },
  {
    "codigo":308867003,
    "descripcion":"DISPLASIA MODERADA DE CONDUCTO PANCREÁTICO"
  },
  {
    "codigo":119971000119104,
    "descripcion":"PROTEÍNA C REACTIVA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":276099005,
    "descripcion":"SITUACIÓN PROBLEMÁTICA"
  },
  {
    "codigo":472707009,
    "descripcion":"MIOCARDITIS FETAL"
  },
  {
    "codigo":1290072001,
    "descripcion":"TUMOR NEUROENDOCRINO BIEN DIFERENCIADO DE RIÑÓN IZQUIERDO"
  },
  {
    "codigo":700248003,
    "descripcion":"LAMERSE LOS LABIOS"
  },
  {
    "codigo":339261000119101,
    "descripcion":"DEGENERACIÓN NODULAR DE LA CÓRNEA IZQUIERDA"
  },
  {
    "codigo":403501005,
    "descripcion":"LUPUS ERITEMATOSO DISCOIDE DE PIE"
  },
  {
    "codigo":237826006,
    "descripcion":"ACROPAQUIA TIROIDEA"
  },
  {
    "codigo":203223005,
    "descripcion":"INFECCIÓN DEL OMÓPLATO"
  },
  {
    "codigo":397996002,
    "descripcion":"LESIÓN TRAUMÁTICA POR EXPLOSIÓN"
  },
  {
    "codigo":234156005,
    "descripcion":"RUPTURA DE FÍSTULA ARTERIOVENOSA CONGÉNITA"
  },
  {
    "codigo":37548006,
    "descripcion":"ENFERMEDAD DE HIPOPIGMENTACIÓN - INMUNODEFICIENCIA"
  },
  {
    "codigo":365228006,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA MANEJAR UN ARTEFACTO MIENTRAS SE VISTE Y DESVISTE"
  },
  {
    "codigo":1076541000119106,
    "descripcion":"BURSITIS SUBACROMIAL DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":299692008,
    "descripcion":"TRASTORNO DE LA GLÁNDULA DE BARTOLINO"
  },
  {
    "codigo":266924008,
    "descripcion":"EX GRAN FUMADOR DE CIGARRILLOS (20 - 39\/DÍA)"
  },
  {
    "codigo":232321004,
    "descripcion":"TINNITUS QUE SE ORIGINA EN EL TENSOR PALATINO"
  },
  {
    "codigo":363393007,
    "descripcion":"NEOPLASIA MALIGNA DE AMÍGDALA"
  },
  {
    "codigo":428929009,
    "descripcion":"CHAPERONA NO DISPONIBLE"
  },
  {
    "codigo":296022001,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE ZOLPIDEM"
  },
  {
    "codigo":722006004,
    "descripcion":"SÍNDROME SIMILAR A LA EMBRIOPATÍA POR ISOTRETINOÍNA"
  },
  {
    "codigo":33878005,
    "descripcion":"HEMORRAGIA DEL CORDÓN ESPERMÁTICO"
  },
  {
    "codigo":164950005,
    "descripcion":"ELECTROCARDIOGRAMA: COMPLEJO QRS NORMAL"
  },
  {
    "codigo":197718007,
    "descripcion":"INFECCIÓN CAUSADA POR PASTEURELLA MULTOCIDA"
  },
  {
    "codigo":359723007,
    "descripcion":"HIPOFIBRINOGENEMIA ADQUIRIDA"
  },
  {
    "codigo":292352000,
    "descripcion":"REACCIÓN ADVERSA AL CLORDIAZEPÓXIDO"
  },
  {
    "codigo":423424005,
    "descripcion":"CARCINOMA MUCOEPIDERMOIDE DE GLÁNDULA SUBMAXILAR"
  },
  {
    "codigo":11837041000119100,
    "descripcion":"HERIDA INFECTADA DE PIERNA IZQUIERDA DEBIDA A PICADURA DE INSECTO NO VENENOSO"
  },
  {
    "codigo":126677000,
    "descripcion":"NEOPLASIA DE SENO ETMOIDAL"
  },
  {
    "codigo":95744009,
    "descripcion":"ÚLCERA CONJUNTIVAL"
  },
  {
    "codigo":716501002,
    "descripcion":"NO COMPRENDE INSTRUCCIONES EN DOS PARTES"
  },
  {
    "codigo":10634711000119107,
    "descripcion":"ÚLCERA CRÓNICA DE DEDO DE PIE IZQUIERDO"
  },
  {
    "codigo":224981004,
    "descripcion":"TRANSFERENCIA AMBIENTAL"
  },
  {
    "codigo":1306325004,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE SITIO ECTÓPICO DE MAMA"
  },
  {
    "codigo":93909004,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE MÚSCULO DE HOMBRO"
  },
  {
    "codigo":290517001,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ISOFLURANO"
  },
  {
    "codigo":92074002,
    "descripcion":"NEOPLASIA BENIGNA DE HUESO CUBOIDES"
  },
  {
    "codigo":714666004,
    "descripcion":"DIFICULTAD PARA OBTENER MEDICACIÓN"
  },
  {
    "codigo":92339007,
    "descripcion":"NEOPLASIA BENIGNA DEL TABIQUE DE LA NARIZ"
  },
  {
    "codigo":26538006,
    "descripcion":"DEGENERACIÓN DE DISCO INTERVERTEBRAL LUMBAR"
  },
  {
    "codigo":1237119002,
    "descripcion":"ÚLCERA VENOSA RECURRENTE DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":712831003,
    "descripcion":"CEFALEAS FRECUENTES"
  },
  {
    "codigo":1204351003,
    "descripcion":"ESCLEROSIS LATERAL AMIOTRÓFICA TIPO 9"
  },
  {
    "codigo":254079002,
    "descripcion":"ESPONDILOENCONDRODISPLASIA"
  },
  {
    "codigo":12246641000119104,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE AMBAS MAMAS"
  },
  {
    "codigo":285012001,
    "descripcion":"NO SE AJUSTA LA ROPA"
  },
  {
    "codigo":186708007,
    "descripcion":"VIRUS DE LA INMUNODEFICIENCIA HUMANA CON INFECCIÓN CLÍNICA SECUNDARIA"
  },
  {
    "codigo":22868008,
    "descripcion":"DEFICIENCIA LONGITUDINAL DE FALANGES DE MANO"
  },
  {
    "codigo":86569001,
    "descripcion":"PUERPERIO"
  },
  {
    "codigo":1004073002,
    "descripcion":"CONTRACTURA EN FLEXIÓN DE ARTICULACIONES DE AMBAS MUÑECAS"
  },
  {
    "codigo":283177004,
    "descripcion":"CUERPO EXTRAÑO METÁLICO EN EL MUSLO"
  },
  {
    "codigo":447017008,
    "descripcion":"FRACTURA EXPUESTA DE PERONÉ"
  },
  {
    "codigo":281342003,
    "descripcion":"GRANULACIÓN VULVAR"
  },
  {
    "codigo":248574003,
    "descripcion":"RESPIRACIÓN CRUPAL"
  },
  {
    "codigo":1231614004,
    "descripcion":"MEMBRANA NEOVASCULAR COROIDEA SUBFOVEAL"
  },
  {
    "codigo":17363001,
    "descripcion":"SARCOIDOSIS ESPLÉNICA"
  },
  {
    "codigo":1197011004,
    "descripcion":"NEOPLASIA MALIGNA DE INTESTINO DEBIDA A POLIPOSIS ADENOMATOSA FAMILIAR"
  },
  {
    "codigo":1079051000119105,
    "descripcion":"ANGIOSARCOMA PRIMARIO DE EXTREMIDAD SUPERIOR DERECHA"
  },
  {
    "codigo":441512004,
    "descripcion":"ENCEFALITIS CAUSADA POR INFECCIÓN POR HERPESVIRUS HUMANO 6"
  },
  {
    "codigo":15528006,
    "descripcion":"NECROSIS AGUDA DEL PÁNCREAS"
  },
  {
    "codigo":1258877000,
    "descripcion":"NEURALGIA DE NERVIO INTERCOSTOBRAQUIAL"
  },
  {
    "codigo":310440009,
    "descripcion":"CITOLOGÍA URINARIA LIMÍTROFE"
  },
  {
    "codigo":110162001,
    "descripcion":"ABRASIÓN DE LA OROFARINGE"
  },
  {
    "codigo":306770001,
    "descripcion":"INCAPAZ DE DEGLUTIR SÓLIDOS"
  },
  {
    "codigo":372306004,
    "descripcion":"EXTENSIÓN TUMORAL EXTRAPROSTÁTICA PRESENTE"
  },
  {
    "codigo":403239001,
    "descripcion":"COLOR CONSTITUTIVO DE LA PIEL, CETRINO"
  },
  {
    "codigo":370471003,
    "descripcion":"ESTENOSIS LUMBOSACRA"
  },
  {
    "codigo":1255207005,
    "descripcion":"FIBROSIS ANGIOCÉNTRICA EOSINOFÍLICA RELACIONADA CON INMUNOGLOBULINA G4"
  },
  {
    "codigo":8188000,
    "descripcion":"INTOXICACIÓN POR PAPAVER"
  },
  {
    "codigo":40956001,
    "descripcion":"SÍNDROME DE GUILLAIN-BARRÉ"
  },
  {
    "codigo":1351676004,
    "descripcion":"BOCIO CONCOMITANTE CON INFLAMACIÓN LINFOCÍTICA CRÓNICA DE GLÁNDULA TIROIDES Y DEBIDO A ELLA"
  },
  {
    "codigo":73724005,
    "descripcion":"INTOXICACIÓN POR HERBICIDA CON FENOXIACETATO"
  },
  {
    "codigo":301265006,
    "descripcion":"MATIDEZ CARDÍACA DESPLAZADA HACIA LA IZQUIERDA"
  },
  {
    "codigo":202961008,
    "descripcion":"RUPTURA DE TENDÓN DE EXTENSOR DE MANO Y MUÑECA"
  },
  {
    "codigo":235729009,
    "descripcion":"ATROFIA CONGÉNITA DE LAS MICROVELLOSIDADES"
  },
  {
    "codigo":233894001,
    "descripcion":"TAQUICARDIA AURICULAR INCESANTE"
  },
  {
    "codigo":168358004,
    "descripcion":"ORGANISMO AISLADO EN CULTIVO DE HISOPADO VAGINAL"
  },
  {
    "codigo":364966005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA MOVER LA LENGUA SIMÉTRICAMENTE"
  },
  {
    "codigo":232059000,
    "descripcion":"SÍNDROME DE LAURENCE-MOON"
  },
  {
    "codigo":397734008,
    "descripcion":"NEUROPATÍA SENSITIVA HEREDITARIA Y AUTONÓMICA TIPO I"
  },
  {
    "codigo":2683000,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN LA REGIÓN DE LA AXILA, SIN INFECCIÓN"
  },
  {
    "codigo":363131004,
    "descripcion":"FÍSTULA DEL OÍDO MEDIO"
  },
  {
    "codigo":723579009,
    "descripcion":"ENFERMEDAD DE TANGIER"
  },
  {
    "codigo":230224002,
    "descripcion":"TROMBOFLEBITIS SÉPTICA DE LA VENA CORTICAL"
  },
  {
    "codigo":461435009,
    "descripcion":"ORIGEN ANÓMALO DE ARTERIA CORONARIA DESCENDENTE ANTERIOR IZQUIERDA EN SENO AÓRTICO DE ARTERIA CORONARIA DERECHA"
  },
  {
    "codigo":295760006,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE PACLITAXEL"
  },
  {
    "codigo":197456007,
    "descripcion":"PANCREATITIS AGUDA"
  },
  {
    "codigo":228389003,
    "descripcion":"INYECTOR INGUINAL"
  },
  {
    "codigo":31781004,
    "descripcion":"TRASTORNO DE PÁNICO CON AGORAFOBIA, EVITACIÓN AGORAFÓBICA EN REMISIÓN PARCIAL Y ATAQUES DE PÁNICO LEVES"
  },
  {
    "codigo":293925007,
    "descripcion":"ALERGIA A DIFENILBUTILPIPERIDINA"
  },
  {
    "codigo":292090000,
    "descripcion":"REACCIÓN ADVERSA AL ÁCIDO TIAPROFÉNICO"
  },
  {
    "codigo":193786000,
    "descripcion":"QUERATITIS DEBIDA A SÍFILIS"
  },
  {
    "codigo":16017471000119108,
    "descripcion":"ALTERACIÓN DE LA ALINEACIÓN DEL ASTA POSTERIOR DEL MENISCO EXTERNO DE LA RODILLA DERECHA"
  },
  {
    "codigo":95482000,
    "descripcion":"LENTICONO POSTERIOR"
  },
  {
    "codigo":124991000119109,
    "descripcion":"ASMA PERSISTENTE SEVERA CONCOMITANTE CON RINITIS ALÉRGICA"
  },
  {
    "codigo":28111002,
    "descripcion":"RINITIS ATRÓFICA"
  },
  {
    "codigo":290255005,
    "descripcion":"INTOXICACIÓN POR FLURBIPROFENO"
  },
  {
    "codigo":716239006,
    "descripcion":"SÍNDROME DE HIPOACUSIA E INSENSIBILIDAD DE GLÁNDULAS SALIVALES A LA ALDOSTERONA"
  },
  {
    "codigo":93647006,
    "descripcion":"MELANOMA MALIGNO DE PIEL DE HOMBRO"
  },
  {
    "codigo":880079009,
    "descripcion":"SÍNDROME DE DUPLICACIÓN 11P15"
  },
  {
    "codigo":421327009,
    "descripcion":"TROMBOSIS DE STENT DE ARTERIA CORONARIA"
  },
  {
    "codigo":59044003,
    "descripcion":"CICATRIZ RETINIANA POSTQUIRÚRGICA"
  },
  {
    "codigo":317811000119100,
    "descripcion":"ARTRITIS NEUMOCÓCICA DE ARTICULACIÓN DE CADERA IZQUIERDA"
  },
  {
    "codigo":288420007,
    "descripcion":"ENHEBRA UNA AGUJA"
  },
  {
    "codigo":24441001,
    "descripcion":"ALTERACIÓN DEL MANTENIMIENTO DE LA SALUD"
  },
  {
    "codigo":253817004,
    "descripcion":"AGENESIA DE HEMIDIAFRAGMA - BILATERAL"
  },
  {
    "codigo":450425005,
    "descripcion":"HEMATOMA INTRACRANEAL"
  },
  {
    "codigo":188281006,
    "descripcion":"NEOPLASIA MALIGNA DE LOS GANGLIOS BASALES"
  },
  {
    "codigo":89977008,
    "descripcion":"ESPESOR AUMENTADO"
  },
  {
    "codigo":415822001,
    "descripcion":"GASTROENTERITIS VIRAL CAUSADA POR ROTAVIRUS"
  },
  {
    "codigo":710734008,
    "descripcion":"GOTA CRÓNICA SECUNDARIA SIN TOFO"
  },
  {
    "codigo":250147001,
    "descripcion":"TALONERA DEL CALZADO MUY PROFUNDA"
  },
  {
    "codigo":446755003,
    "descripcion":"ENTERITIS CAUSADA POR ECOVIRUS HUMANO"
  },
  {
    "codigo":282915006,
    "descripcion":"SE SIENTA A PARTIR DE ESTAR PARADO"
  },
  {
    "codigo":248312008,
    "descripcion":"OBESIDAD PERIFÉRICA"
  },
  {
    "codigo":444920009,
    "descripcion":"ESPASMO DE MÚSCULO ESQUELÉTICO DEL TÓRAX"
  },
  {
    "codigo":770765001,
    "descripcion":"RETINOPATÍA PROLIFERATIVA DEL OJO DERECHO DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":836301008,
    "descripcion":"TRASTORNO COGNITIVO AMNÉSICO LEVE"
  },
  {
    "codigo":1260450002,
    "descripcion":"ENFERMEDAD INFANTIL MULTISISTÉMICA NEUROLÓGICA, ENDOCRINA Y PANCREÁTICA"
  },
  {
    "codigo":210039000,
    "descripcion":"LESIÓN INTRACRANEAL CON COMA PROLONGADO"
  },
  {
    "codigo":768930008,
    "descripcion":"TRISOMÍA PARCIAL DEL BRAZO CORTO DEL CROMOSOMA 8"
  },
  {
    "codigo":111735006,
    "descripcion":"EFECTOS DEL CALOR"
  },
  {
    "codigo":208204001,
    "descripcion":"FRACTURA TOTAL EXPUESTA DEL ANILLO PÉLVICO"
  },
  {
    "codigo":734327009,
    "descripcion":"ESTENOSIS DE ARTERIA VERTEBRAL DERECHA"
  },
  {
    "codigo":109900007,
    "descripcion":"INDICACIÓN PARA LA MODIFICACIÓN DEL ESTADO FÍSICO DEL PACIENTE"
  },
  {
    "codigo":239137003,
    "descripcion":"COLAGENOMA ESTORIFORME CIRCUNSCRIPTO"
  },
  {
    "codigo":1254945005,
    "descripcion":"ONICÓLISIS DISTAL HEREDITARIA"
  },
  {
    "codigo":1287713006,
    "descripcion":"ANEMIA POR DEFICIENCIA DE HIERRO DURANTE PERÍODO INTRAPARTO MATERNO"
  },
  {
    "codigo":402977007,
    "descripcion":"INFECCIÓN CUTÁNEA POR MYCOBACTERIUM SCROFULACEUM"
  },
  {
    "codigo":237302001,
    "descripcion":"ISOINMUNIZACIÓN POR GRUPO SANGUÍNEO KELL DURANTE EL EMBARAZO"
  },
  {
    "codigo":7926002,
    "descripcion":"ESMALTE IRRADIADO"
  },
  {
    "codigo":204534001,
    "descripcion":"AGENESIA DE BRONQUIO"
  },
  {
    "codigo":302838006,
    "descripcion":"NEVO CELULAR DÉRMICO"
  },
  {
    "codigo":399307001,
    "descripcion":"PERDIDO PARA EL SEGUIMIENTO"
  },
  {
    "codigo":71627002,
    "descripcion":"QUISTE GLANDULAR APOCRINO"
  },
  {
    "codigo":73462009,
    "descripcion":"TRASTORNO DE TICS VOCALES CRÓNICOS"
  },
  {
    "codigo":202699004,
    "descripcion":"ESPONDILITIS ENTEROBACTERIANA"
  },
  {
    "codigo":366539001,
    "descripcion":"AMPLITUD DE MOVIMIENTO PASIVO DE SUPINACIÓN DE LA MUÑECA - HALLAZGO"
  },
  {
    "codigo":169931007,
    "descripcion":"PUNTAJE DE APGAR A LOS 10 MINUTOS = 8"
  },
  {
    "codigo":38859008,
    "descripcion":"SINDACTILIA DE LOS DEDOS DEL PIE CON FUSIÓN ÓSEA"
  },
  {
    "codigo":102560000,
    "descripcion":"EDEMA DE ANTEBRAZO"
  },
  {
    "codigo":299168001,
    "descripcion":"AMPLITUD DE ABDUCCIÓN PASIVA DEL PULGAR NORMAL"
  },
  {
    "codigo":233632003,
    "descripcion":"BRONQUIECTASIA CAUSADA POR ASPIRACIÓN DE SUSTANCIA TÓXICA"
  },
  {
    "codigo":346791000119105,
    "descripcion":"IRITIS CRÓNICA DE AMBOS OJOS"
  },
  {
    "codigo":301003007,
    "descripcion":"NEUMONÍA DE LÓBULO MEDIO DERECHO"
  },
  {
    "codigo":168096009,
    "descripcion":"MICROSCOPIA DE LÍQUIDO AMNIÓTICO, ANORMAL"
  },
  {
    "codigo":35189002,
    "descripcion":"AMPOLLAS Y NECROSIS DE GLÁNDULAS SUDORÍPARAS EN EL COMA MEDICAMENTOSO"
  },
  {
    "codigo":15639361000119101,
    "descripcion":"PSEUDOEXFOLIACIÓN DE CÁPSULAS DE AMBOS CRISTALINOS"
  },
  {
    "codigo":231797007,
    "descripcion":"BLEFARITIS SEBORREICA"
  },
  {
    "codigo":197194002,
    "descripcion":"ADHERENCIAS ILEALES"
  },
  {
    "codigo":262730004,
    "descripcion":"SECCIÓN PARCIAL DE LA RAÍZ DE NERVIO DORSAL"
  },
  {
    "codigo":295498005,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE ÓXIDO NITROSO"
  },
  {
    "codigo":426570007,
    "descripcion":"QUERATITIS INTERSTICIAL POR HERPES ZÓSTER"
  },
  {
    "codigo":129823000,
    "descripcion":"ALTERACIÓN DEL CRECIMIENTO Y\/O DEL DESARROLLO EN LA INFANCIA"
  },
  {
    "codigo":293663001,
    "descripcion":"ALERGIA A SULFASALAZINA"
  },
  {
    "codigo":787018009,
    "descripcion":"CUERPO EXTRAÑO DE REGIÓN OCULAR"
  },
  {
    "codigo":719647002,
    "descripcion":"VOZ HÚMEDA"
  },
  {
    "codigo":586008,
    "descripcion":"DERMATITIS DE CONTACTO CAUSADA POR PRIMULA OBCONICA"
  },
  {
    "codigo":721482007,
    "descripcion":"SÍNDROME DE BROWN-SEQUARD AL NIVEL DEL PRIMER SEGMENTO DORSAL"
  },
  {
    "codigo":717812000,
    "descripcion":"SÍNDROME DE CATARATA CONGÉNITA, MIOCARDIOPATÍA HIPERTRÓFICA Y MIOPATÍA MITOCONDRIAL"
  },
  {
    "codigo":879817000,
    "descripcion":"DESPROPORCIÓN FETOPÉLVICA POR NEOPLASIA FETAL"
  },
  {
    "codigo":1078260009,
    "descripcion":"AGENESIA DE EPÍFISIS DE FALANGE DISTAL DE QUINTO DEDO DE PIE"
  },
  {
    "codigo":62452009,
    "descripcion":"ACÚFENOS SUBJETIVO"
  },
  {
    "codigo":1141961002,
    "descripcion":"CONDUCTA SOCIALMENTE INAPROPIADA"
  },
  {
    "codigo":816116009,
    "descripcion":"MIEMBRO INFERIOR IZQUIERDO AMPUTADO POR DEBAJO DE LA RODILLA"
  },
  {
    "codigo":93385000,
    "descripcion":"ESTENOSIS CONGÉNITA DE TRONCO BRAQUIOCEFÁLICO"
  },
  {
    "codigo":715977004,
    "descripcion":"CAPAZ DE PARTICIPAR EN ACTIVIDADES DE CUIDADO DE SÍ MISMO EN LA ESCUELA"
  },
  {
    "codigo":289993002,
    "descripcion":"DIFICULTAD PARA ABROCHAR LA VESTIMENTA"
  },
  {
    "codigo":191689008,
    "descripcion":"AUTISMO INFANTIL ACTIVO"
  },
  {
    "codigo":224457004,
    "descripcion":"EN LICENCIA POR MATERNIDAD"
  },
  {
    "codigo":419230002,
    "descripcion":"SOPLO RENAL"
  },
  {
    "codigo":26014004,
    "descripcion":"PRESIÓN ARTERIAL MEDIA AUMENTADA"
  },
  {
    "codigo":124318007,
    "descripcion":"DEFICIENCIA DE ADENILILSULFATO CINASA"
  },
  {
    "codigo":1269363000,
    "descripcion":"CRISIS EPILÉPTICA CLÓNICA DE INICIO FOCAL"
  },
  {
    "codigo":417395001,
    "descripcion":"DISTROFIA ENDOTELIAL HEREDITARIA CONGÉNITA TIPO 2"
  },
  {
    "codigo":89715001,
    "descripcion":"INTOXICACIÓN POR FENILBUTAZONA"
  },
  {
    "codigo":286323003,
    "descripcion":"INCAPAZ DE USAR SONIDOS COMBINADOS"
  },
  {
    "codigo":253555001,
    "descripcion":"DEFECTO PERIMEMBRANOSO DEL TABIQUE INTERVENTRICULAR CON EXTENSIÓN HACIA TODOS LOS COMPONENTES DEL VENTRÍCULO DERECHO"
  },
  {
    "codigo":448328001,
    "descripcion":"ANEURISMA DE SENO DE VALSALVA AÓRTICO SIN RUPTURA"
  },
  {
    "codigo":10753141000119100,
    "descripcion":"COLESTASIS POSPARTO"
  },
  {
    "codigo":53277000,
    "descripcion":"VULVOVAGINITIS"
  },
  {
    "codigo":218952009,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR PAPAÍNA"
  },
  {
    "codigo":249885002,
    "descripcion":"ESCASA ELEVACIÓN DEL PALADAR BLANDO"
  },
  {
    "codigo":708637002,
    "descripcion":"DESPLIEGUE INCISAL AUMENTADO EN REPOSO"
  },
  {
    "codigo":282653004,
    "descripcion":"INCAPAZ DE TRANSFERIR PESO"
  },
  {
    "codigo":315421000,
    "descripcion":"NACIDO EN INGLATERRA"
  },
  {
    "codigo":1003549007,
    "descripcion":"AGENESIA DE RADIO"
  },
  {
    "codigo":51442005,
    "descripcion":"ATRESIA DE VÁLVULA AÓRTICA"
  },
  {
    "codigo":444658006,
    "descripcion":"TAQUICARDIA VENTRICULAR NO SOSTENIDA"
  },
  {
    "codigo":248050007,
    "descripcion":"INASISTENCIA ESCOLAR INTENCIONAL"
  },
  {
    "codigo":410055005,
    "descripcion":"HIPERIMIDODIPEPTIDURIA POR DEFICIENCIA DE PROLINA DIPEPTIDASA"
  },
  {
    "codigo":49607006,
    "descripcion":"ENFERMEDAD POR DEFICIENCIA DE BIOTINA"
  },
  {
    "codigo":440988005,
    "descripcion":"DEFICIENCIA HETEROCIGOTA DE PROTEÍNA S"
  },
  {
    "codigo":735900007,
    "descripcion":"MÚLTIPLES LESIONES TRAUMÁTICAS DE TOBILLO"
  },
  {
    "codigo":209777000,
    "descripcion":"RUPTURA DE TENDÓN DE MUSLO"
  },
  {
    "codigo":703132007,
    "descripcion":"DIENTE ECTÓPICO LINGUAL"
  },
  {
    "codigo":373617004,
    "descripcion":"AGRIETAMIENTO DEL ESMALTE"
  },
  {
    "codigo":275313006,
    "descripcion":"ARRASTRE DE PIERNA"
  },
  {
    "codigo":349301000119108,
    "descripcion":"HIALOSIS ASTEROIDE DE AMBOS OJOS"
  },
  {
    "codigo":734065009,
    "descripcion":"NEOPLASIA NEUROEPITELIAL EMBRIONARIA DEL SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":732230001,
    "descripcion":"DISECCIÓN DE ARTERIA CORONARIA"
  },
  {
    "codigo":240710003,
    "descripcion":"GRANULOMA GLÚTEO INFANTIL"
  },
  {
    "codigo":699462004,
    "descripcion":"MONOARTRITIS"
  },
  {
    "codigo":764998005,
    "descripcion":"ENCEFALITIS LÍMBICA AGUDA NO HERPÉTICA"
  },
  {
    "codigo":322831000119103,
    "descripcion":"LESIÓN TRAUMÁTICA DE REGIONES LUMBAR Y SACRA DE COLUMNA VERTEBRAL"
  },
  {
    "codigo":1086581000119109,
    "descripcion":"HEMORRAGIA DE YEYUNO CONCOMITANTE CON DIVERTICULOSIS Y DEBIDA A ELLA"
  },
  {
    "codigo":207942001,
    "descripcion":"FRACTURA NO EXPUESTA DE VÉRTEBRA DORSAL, APÓFISIS ESPINOSA"
  },
  {
    "codigo":109638009,
    "descripcion":"APERTURA MANDIBULAR ANORMAL"
  },
  {
    "codigo":271643007,
    "descripcion":"PARED ARTERIAL TIPO CORDÓN"
  },
  {
    "codigo":238875009,
    "descripcion":"SÍNDROME DE PIEL ARRUGADA"
  },
  {
    "codigo":237040006,
    "descripcion":"ABSCESO AGUDO DE LA PELVIS FEMENINA"
  },
  {
    "codigo":204272007,
    "descripcion":"FÍSTULA PREAURICULAR CONGÉNITA"
  },
  {
    "codigo":1285616008,
    "descripcion":"HEMATOMA DE DEDO ÍNDICE"
  },
  {
    "codigo":300741004,
    "descripcion":"NO PARTICIPA EN ACTIVIDADES DE TIEMPO LIBRE"
  },
  {
    "codigo":202437005,
    "descripcion":"TUMOR TENOSINOVIAL DE CÉLULAS GIGANTES DIFUSO DE ARTICULACIÓN RADIOCUBITAL DISTAL"
  },
  {
    "codigo":399045007,
    "descripcion":"FUCOSIDOSIS JUVENIL"
  },
  {
    "codigo":724890000,
    "descripcion":"DISTENSIÓN DE TENDÓN ABDOMINAL"
  },
  {
    "codigo":397210004,
    "descripcion":"INVASIÓN TUMORAL DE LA ARTERIA (VASO GRANDE), AUSENTE"
  },
  {
    "codigo":298906007,
    "descripcion":"SIN AMPLITUD ACTIVA DE SUPINACIÓN DE CODO"
  },
  {
    "codigo":428143003,
    "descripcion":"ARTRITIS EN ARTICULACIÓN DEL DEDO DEL PIE"
  },
  {
    "codigo":297071004,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE ALCALOIDE DEL CORNEZUELO DE CENTENO"
  },
  {
    "codigo":15697321000119105,
    "descripcion":"NEURITIS CUBITAL DERECHA"
  },
  {
    "codigo":721220004,
    "descripcion":"DISFASIA DEL DESARROLLO FAMILIAR"
  },
  {
    "codigo":65860006,
    "descripcion":"REGENERACIÓN HEPÁTICA"
  },
  {
    "codigo":229700007,
    "descripcion":"TRASTORNO DEL DESARROLLO MOTRIZ DEL HABLA"
  },
  {
    "codigo":324007,
    "descripcion":"ÚLCERA POR YESO"
  },
  {
    "codigo":295236008,
    "descripcion":"SOBREDOSIS INTENCIONAL DE FELBINACO"
  },
  {
    "codigo":293401005,
    "descripcion":"REACCIÓN ADVERSA A PREPARADO DE PIRIDOXINA"
  },
  {
    "codigo":719385008,
    "descripcion":"CAPAZ DE COMPRENDER INSTRUCCIONES EN DOS PARTES"
  },
  {
    "codigo":29422001,
    "descripcion":"NEUMOCONIOSIS DE LOS TRABAJADORES DEL CARBÓN"
  },
  {
    "codigo":401301000221106,
    "descripcion":"VULNERABILIDAD SOCIAL"
  },
  {
    "codigo":679491000119103,
    "descripcion":"LESIÓN VASCULAR DE PÁRPADO IZQUIERDO"
  },
  {
    "codigo":94958006,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL CORNETE ETMOIDAL DE LA NARIZ"
  },
  {
    "codigo":291566008,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR CEFALOTINA"
  },
  {
    "codigo":224195002,
    "descripcion":"DERECHO A BENEFICIOS, INCIERTO"
  },
  {
    "codigo":93123003,
    "descripcion":"FALTA DE OSIFICACIÓN DEL TARSO"
  },
  {
    "codigo":1010627004,
    "descripcion":"HIPERTENSIÓN PULMONAR DEBIDA A ANOMALÍA DEL DESARROLLO"
  },
  {
    "codigo":289731007,
    "descripcion":"CONTRACCIONES UTERINAS NO DOLOROSAS"
  },
  {
    "codigo":1089091000119105,
    "descripcion":"ENFERMEDAD DE MÉNIÈRE DE OÍDO INTERNO IZQUIERDO EN REMISIÓN"
  },
  {
    "codigo":713880000,
    "descripcion":"MICOSIS OPORTUNISTA CONCOMITANTE CON INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":255128001,
    "descripcion":"INFILTRACIÓN MALIGNA DE NERVIO PERIFÉRICO"
  },
  {
    "codigo":124056001,
    "descripcion":"AMINOÁCIDO POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1172632008,
    "descripcion":"DISPLASIA FRONTONASAL ASOCIADA AL GEN SIX2"
  },
  {
    "codigo":1303704009,
    "descripcion":"GLAUCOMA DE AMBOS OJOS DEBIDO A NEOPLASIA INTRAOCULAR"
  },
  {
    "codigo":449901005,
    "descripcion":"ENCEFALOPATÍA HEPÁTICA EN INSUFICIENCIA HEPÁTICA FULMINANTE"
  },
  {
    "codigo":286061006,
    "descripcion":"INCAPAZ DE PLANCHAR"
  },
  {
    "codigo":253293007,
    "descripcion":"AURÍCULA DERECHA COMUNICADA CON AMBOS VENTRÍCULOS"
  },
  {
    "codigo":1269101009,
    "descripcion":"TRASTORNO MATERNO DURANTE PERÍODO PRENATAL Y\/O INTRAPARTO Y\/O PUERPERIO"
  },
  {
    "codigo":11820611000119109,
    "descripcion":"SUBLUXACIÓN INFERIOR DE ARTICULACIÓN GLENOHUMERAL DERECHA"
  },
  {
    "codigo":11794141000119103,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE TOBILLO DERECHO"
  },
  {
    "codigo":251458006,
    "descripcion":"ANOMALÍA ELECTROENCEFALOGRÁFICA CONTINUA GENERALIZADA"
  },
  {
    "codigo":284226006,
    "descripcion":"QUEMADURA DE CADERA"
  },
  {
    "codigo":448066007,
    "descripcion":"AURÍCULA IZQUIERDA DIVIDIDA CON TRACTO DE SALIDA NO RESTRICTIVO DE LA CÁMARA PROXIMAL A LA AURÍCULA IZQUIERDA"
  },
  {
    "codigo":184087005,
    "descripcion":"PACIENTE ABANDONADO EN FORMA TRANSITORIA"
  },
  {
    "codigo":247788000,
    "descripcion":"FALTA DE JUICIO"
  },
  {
    "codigo":213185003,
    "descripcion":"FALLA TOTAL DE REIMPLANTE DEL MIEMBRO INFERIOR"
  },
  {
    "codigo":1163457004,
    "descripcion":"MIASIS OCULAR EXTERNA"
  },
  {
    "codigo":10948471000119101,
    "descripcion":"HERIDA ABIERTA DE MANO IZQUIERDA DEBIDA A MORDEDURA DE PERRO"
  },
  {
    "codigo":1360065008,
    "descripcion":"ÁNGULO ABIERTO AMPLIO DE OJO DERECHO"
  },
  {
    "codigo":15972061000119109,
    "descripcion":"HERNIAS INGUINALES BILATERALES INDIRECTAS"
  },
  {
    "codigo":12907000,
    "descripcion":"ANEMIA MEGALOBLÁSTICA SENSIBLE A TIAMINA"
  },
  {
    "codigo":735638009,
    "descripcion":"SEPSIS FETAL CAUSADA POR STREPTOCOCCUS PYOGENES"
  },
  {
    "codigo":111211002,
    "descripcion":"POLIARTRITIS MIGRATRIZ"
  },
  {
    "codigo":406123005,
    "descripcion":"HALLAZGO RELACIONADO CON UNA ESTRUCTURA VISCERAL"
  },
  {
    "codigo":16027511000119105,
    "descripcion":"QUISTE ÓSEO BILATERAL DE MANO"
  },
  {
    "codigo":29671000175105,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN DE CADERA, ESTADIO I"
  },
  {
    "codigo":764736001,
    "descripcion":"PARAPLEJÍA ESPÁSTICA AUTOSÓMICA RECESIVA TIPO 43"
  },
  {
    "codigo":240448007,
    "descripcion":"ENCEFALOPATÍA POR LEGIONELLA"
  },
  {
    "codigo":74773005,
    "descripcion":"SESAMOIDITIS"
  },
  {
    "codigo":402453006,
    "descripcion":"AMILOIDOSIS DE CADENA LIVIANA DEBIDA A MIELOMA MÚLTIPLE"
  },
  {
    "codigo":238613007,
    "descripcion":"PSORIASIS PUSTULOSA GENERALIZADA DEL EMBARAZO"
  },
  {
    "codigo":354321000119102,
    "descripcion":"CARCINOMA IN SITU DE PIEL DE OÍDO DERECHO"
  },
  {
    "codigo":204010001,
    "descripcion":"ESPINA BÍFIDA CERVICAL SIN HIDROCEFALIA - CERRADA"
  },
  {
    "codigo":1287189007,
    "descripcion":"ERUPCIÓN CUTÁNEA CAUSADA POR SALMONELLA TYPHI"
  },
  {
    "codigo":105706003,
    "descripcion":"ENFERMEDAD CAUSADA POR FILARIOIDEA"
  },
  {
    "codigo":306952005,
    "descripcion":"HALLAZGO RELACIONADO CON EL EQUILIBRIO EN POSICIÓN SENTADA"
  },
  {
    "codigo":11823121000119103,
    "descripcion":"AMPOLLA DE HOMBRO IZQUIERDO, CON INFECCIÓN"
  },
  {
    "codigo":369685007,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA DE PÁNCREAS, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":202175000,
    "descripcion":"LUXACIÓN PATOLÓGICA DE MÚLTIPLES ARTICULACIONES"
  },
  {
    "codigo":366015001,
    "descripcion":"APARIENCIA DE LA CONJUNTIVA PALPEBRAL - HALLAZGO"
  },
  {
    "codigo":71103003,
    "descripcion":"ESQUIZOFRENIA RESIDUAL CRÓNICA"
  },
  {
    "codigo":300479008,
    "descripcion":"HALLAZGO GENITAL"
  },
  {
    "codigo":724628001,
    "descripcion":"PROBLEMA DE MANO"
  },
  {
    "codigo":298644000,
    "descripcion":"SIN AMPLITUD DE FLEXIÓN LATERAL PASIVA HACIA LA IZQUIERDA DE LA COLUMNA VERTEBRAL LUMBAR"
  },
  {
    "codigo":167572006,
    "descripcion":"UROCULTIVO - STREPTOCOCCUS FAECALIS"
  },
  {
    "codigo":1897008,
    "descripcion":"INTOXICACIÓN POR AMSINCKIA"
  },
  {
    "codigo":720958002,
    "descripcion":"SÍNDROME DE FRANK-TER-HAAR"
  },
  {
    "codigo":1343550008,
    "descripcion":"RADIOGRAFÍA SIMPLE DE VESÍCULA BILIAR CON CONTRASTE NORMAL"
  },
  {
    "codigo":131134009,
    "descripcion":"ÁCIDO PANTOTÉNICO POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1145107005,
    "descripcion":"LESIÓN TRAUMÁTICA DEBIDA A AGRESIÓN CON AGUJA PARA INYECCIÓN USADA"
  },
  {
    "codigo":31011000087102,
    "descripcion":"MICROBIOTA NORMAL DE LA VAGINA"
  },
  {
    "codigo":46371000087103,
    "descripcion":"LUXACIÓN DE ARTICULACIÓN GLENOHUMERAL IZQUIERDA"
  },
  {
    "codigo":422376000,
    "descripcion":"RESULTADOS DE LABORATORIO RESPIRATORIO ANORMALES"
  },
  {
    "codigo":293139008,
    "descripcion":"REACCIÓN ADVERSA AL AGENTE ANTITIROIDEO TIOURACILO"
  },
  {
    "codigo":193000002,
    "descripcion":"EPILEPSIA DE LÓBULO TEMPORAL"
  },
  {
    "codigo":38691000087107,
    "descripcion":"PORTADOR ASINTOMÁTICO DE ORGANISMO INFECCIOSO"
  },
  {
    "codigo":1208808004,
    "descripcion":"ALERGIA A PROTEÍNA DE PERRO DOMÉSTICO"
  },
  {
    "codigo":41251000087109,
    "descripcion":"HEMATOMA DE EXTREMIDAD SUPERIOR DERECHA"
  },
  {
    "codigo":43811000087105,
    "descripcion":"RUPTURA DE MÚSCULO GEMELO DERECHO"
  },
  {
    "codigo":782824007,
    "descripcion":"NEUROPATÍA DE FIBRAS PEQUEÑAS LIGADA CON CANALOPATÍAS DE SODIO"
  },
  {
    "codigo":1010365000,
    "descripcion":"ESCLEROSIS DE EPÍFISIS DE FALANGE DISTAL DE DEDO ÍNDICE CON RADIOPACIDAD AUMENTADA"
  },
  {
    "codigo":291304007,
    "descripcion":"INTOXICACIÓN POR SALBUTAMOL"
  },
  {
    "codigo":289469003,
    "descripcion":"LABIOS MAYORES DE LA VULVA, PEQUEÑOS"
  },
  {
    "codigo":125629006,
    "descripcion":"LESIÓN TRAUMÁTICA DEL COLON"
  },
  {
    "codigo":92861007,
    "descripcion":"FUSIÓN ANORMAL CONGÉNITA DE HUESO INTERPARIETAL"
  },
  {
    "codigo":11852101000119102,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DE DEDO DEL PIE IZQUIERDO"
  },
  {
    "codigo":58258004,
    "descripcion":"LIPOFUSCINOSIS CEROIDE NEURONAL INFANTIL"
  },
  {
    "codigo":254866007,
    "descripcion":"TUMOR BENIGNO DE CÉLULAS DE SERTOLI-LEYDIG DE OVARIO"
  },
  {
    "codigo":253031000,
    "descripcion":"PARAGANGLIOMA TIMPÁNICO"
  },
  {
    "codigo":285799000,
    "descripcion":"ALUCINACIONES REFLEJAS"
  },
  {
    "codigo":1332540000,
    "descripcion":"MELORREOSTOSIS DE HUESO DE MANO"
  },
  {
    "codigo":447804006,
    "descripcion":"LEIOMIOSARCOMA DE TEJIDO CONJUNTIVO"
  },
  {
    "codigo":283964007,
    "descripcion":"CONTUSIÓN DEL CUELLO UTERINO"
  },
  {
    "codigo":413201000,
    "descripcion":"MUCOSA ATRÓFICA"
  },
  {
    "codigo":249361000,
    "descripcion":"VASOS PROMINENTES EN EL ÁREA DE LITTLE"
  },
  {
    "codigo":216593002,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ANTICOLINÉRGICO"
  },
  {
    "codigo":10678751000119101,
    "descripcion":"TUMEFACCIÓN LOCALIZADA DE LA EXTREMIDAD INFERIOR IZQUIERDA"
  },
  {
    "codigo":773649005,
    "descripcion":"HIPERTRIGLICERIDEMIA INFANTIL TRANSITORIA Y HEPATOESTEATOSIS"
  },
  {
    "codigo":85521005,
    "descripcion":"HEMORRAGIA DIGESTIVA BAJA AGUDA"
  },
  {
    "codigo":247526001,
    "descripcion":"AUSENCIA PARCIAL DEL CRECIMIENTO DEL PELO"
  },
  {
    "codigo":212923003,
    "descripcion":"CONGELAMIENTO SUPERFICIAL QUE COMPROMETE MÚLTIPLES REGIONES CORPORALES"
  },
  {
    "codigo":737211006,
    "descripcion":"TRASTORNO NEONATAL DE LA MUCOSA BUCAL"
  },
  {
    "codigo":1359803008,
    "descripcion":"COLONIZACIÓN CRÓNICA DE TRACTO RESPIRATORIO CAUSADA POR RALSTONIA"
  },
  {
    "codigo":16315008,
    "descripcion":"DESPOLIMERIZACIÓN"
  },
  {
    "codigo":1259664000,
    "descripcion":"CARCINOMA UROTELIAL PRIMARIO DE RIÑÓN IZQUIERDO"
  },
  {
    "codigo":243856004,
    "descripcion":"SITUACIÓN DEL MONITOREO DE TRASTORNO NEUROLÓGICO"
  },
  {
    "codigo":11825631000119106,
    "descripcion":"RUPTURA TRAUMÁTICA DE TENDÓN DE MANO IZQUIERDA"
  },
  {
    "codigo":276624006,
    "descripcion":"CONTUSIÓN NEONATAL DEL CUERO CABELLUDO"
  },
  {
    "codigo":45413000,
    "descripcion":"ESTADO AUTÓLOGO"
  },
  {
    "codigo":12645001,
    "descripcion":"AMPLIFICACIÓN GÉNICA"
  },
  {
    "codigo":405861000,
    "descripcion":"FENOTIPO LE(A+B-)"
  },
  {
    "codigo":373093003,
    "descripcion":"FÍSTULA DE ARTERIA CORONARIA"
  },
  {
    "codigo":471397004,
    "descripcion":"TERCIO INFERIOR DE LA CARA LARGO"
  },
  {
    "codigo":209253005,
    "descripcion":"FRACTURA-LUXACIÓN NO EXPUESTA DE ARTICULACIÓN RADIOCUBITAL PROXIMAL"
  },
  {
    "codigo":15731321000119101,
    "descripcion":"EDEMA DE DISCO ÓPTICO DE OJO DERECHO DEBIDO A PRESIÓN INTRACRANEAL POR ENCIMA DE RANGO DE REFERENCIA"
  },
  {
    "codigo":305722000,
    "descripcion":"ATENDIDO POR CIRUJANO BUCAL"
  },
  {
    "codigo":10810001,
    "descripcion":"TRASTORNO DEL CRISTALINO"
  },
  {
    "codigo":1255994003,
    "descripcion":"RUPTURA TRAUMÁTICA DE TENDÓN DE MANO"
  },
  {
    "codigo":830010004,
    "descripcion":"GENITALES NORMALES"
  },
  {
    "codigo":76346005,
    "descripcion":"INTOXICACIÓN POR CUMARINA"
  },
  {
    "codigo":16003551000119109,
    "descripcion":"PELLIZCAMIENTO INTERNO DE AMBOS HOMBROS"
  },
  {
    "codigo":404026003,
    "descripcion":"SCHWANNOMA CELULAR"
  },
  {
    "codigo":402191000,
    "descripcion":"DERMATITIS ATÓPICA DE CUERO CABELLUDO"
  },
  {
    "codigo":8975004,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN REGIÓN DE MUSLO, SIN INFECCIÓN"
  },
  {
    "codigo":205583005,
    "descripcion":"ACANTOSIS NIGRICANS BENIGNA HEREDITARIA"
  },
  {
    "codigo":39908000,
    "descripcion":"LISTA DE INTERCAMBIO DE ALIMENTOS"
  },
  {
    "codigo":271119008,
    "descripcion":"AMPOLLA TRAUMÁTICA DE LA MAMA"
  },
  {
    "codigo":236516001,
    "descripcion":"NEFROPATÍA AGUDA POR PLOMO"
  },
  {
    "codigo":72676005,
    "descripcion":"INTOXICACIÓN POR PACHYSTIGMA"
  },
  {
    "codigo":726201002,
    "descripcion":"LESIÓN TRAUMÁTICA DE TENDÓN DE MÚSCULO INTRÍNSECO DE DEDO DE LA MANO"
  },
  {
    "codigo":300217003,
    "descripcion":"DISCRIMINACIÓN AUDITIVA - HALLAZGO"
  },
  {
    "codigo":103609004,
    "descripcion":"ESPÉCIMEN CON PRESENCIA ANORMAL DE CÉLULAS ENDOMETRIALES"
  },
  {
    "codigo":169145002,
    "descripcion":"GAMMAGRAFÍA ESTÁTICA DE RIÑONES ANORMAL"
  },
  {
    "codigo":298382003,
    "descripcion":"DEFORMIDAD ESCOLIÓTICA DE LA COLUMNA"
  },
  {
    "codigo":200078007,
    "descripcion":"COMPLICACIONES DEL SISTEMA NERVIOSO CENTRAL POR LA ANESTESIA DURANTE EL TRABAJO DE PARTO Y EL PARTO"
  },
  {
    "codigo":303891000119104,
    "descripcion":"GOTA CRÓNICA DE TOBILLO SIN TOFO DEBIDA A DISFUNCIÓN RENAL"
  },
  {
    "codigo":34403004,
    "descripcion":"AMPOLLA DE LA NALGA, CON INFECCIÓN"
  },
  {
    "codigo":460387004,
    "descripcion":"ARTERIA COLATERAL QUE DERIVA EL FLUJO SISTÉMICO HACIA LA CIRCULACIÓN PULMONAR DESDE ARTERIA BRAQUIOCEFÁLICA IZQUIERDA"
  },
  {
    "codigo":165475005,
    "descripcion":"ERITROCITOS: ANISOCITOSIS"
  },
  {
    "codigo":294712001,
    "descripcion":"ALERGIA A BUDESONIDA"
  },
  {
    "codigo":722531009,
    "descripcion":"PERFORACIÓN INTRAUTERINA DE INTESTINO FETAL DEBIDA A VÓLVULO INTRAUTERINO"
  },
  {
    "codigo":65336003,
    "descripcion":"BORRAMIENTO CERVICAL, 60%"
  },
  {
    "codigo":296547009,
    "descripcion":"SOBREDOSIS DE FÁRMACO ANTIVIRAL"
  },
  {
    "codigo":2171000124100,
    "descripcion":"INCISIVO LATERAL INFERIOR IZQUIERDO TEMPORARIO SUPERNUMERARIO"
  },
  {
    "codigo":711291000124102,
    "descripcion":"SINOVITIS CRÓNICA DE HOMBRO IZQUIERDO DEBIDA A HEMARTROSIS"
  },
  {
    "codigo":452731000124103,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE CADERA IZQUIERDA POSTERIOR A REMOCIÓN DE PRÓTESIS"
  },
  {
    "codigo":63501000,
    "descripcion":"PRURIGO NODULAR"
  },
  {
    "codigo":423949003,
    "descripcion":"CON MAYOR RIESGO DE CONTAMINACIÓN AMBIENTAL"
  },
  {
    "codigo":292877006,
    "descripcion":"REACCIÓN ADVERSA AL TRICLOSÁN"
  },
  {
    "codigo":129037008,
    "descripcion":"ASISTENCIA PARA VIAJAR"
  },
  {
    "codigo":94434002,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL MIOMETRIO"
  },
  {
    "codigo":127202005,
    "descripcion":"LINFADENOPATÍA INGUINAL SUPERFICIAL"
  },
  {
    "codigo":225506005,
    "descripcion":"ACEPTACIÓN DEL ASPECTO CORPORAL ALTERADO"
  },
  {
    "codigo":1306850007,
    "descripcion":"MUTACIÓN CON CAMBIO DE SENTIDO"
  },
  {
    "codigo":420279001,
    "descripcion":"TRASTORNO RENAL DEBIDO A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":92599005,
    "descripcion":"CARCINOMA IN SITU DE LA VESÍCULA BILIAR"
  },
  {
    "codigo":713356005,
    "descripcion":"CICATRIZ ESOFÁGICA CRÓNICA"
  },
  {
    "codigo":254604005,
    "descripcion":"NEOPLASIA DE PÁNCREAS EXOCRINO"
  },
  {
    "codigo":187233002,
    "descripcion":"SARCOIDOSIS PULMONAR CON SARCOIDOSIS LINFOGANGLIONAR"
  },
  {
    "codigo":449377002,
    "descripcion":"NEOPLASIA MALIGNA DE PERITONEO PÉLVICO"
  },
  {
    "codigo":348437421000119107,
    "descripcion":"OSTEOCONDROSIS JUVENIL DE TIBIA PROXIMAL DERECHA"
  },
  {
    "codigo":285537002,
    "descripcion":"INCAPAZ DE MOVER LA LENGUA LATERALMENTE"
  },
  {
    "codigo":1137505006,
    "descripcion":"DEBILIDAD DE MÚSCULO RECTO EXTERNO"
  },
  {
    "codigo":283702001,
    "descripcion":"MORDEDURA HUMANA EN EL CODO"
  },
  {
    "codigo":87094002,
    "descripcion":"ÚLCERA CAUSADA POR BACTEROIDES"
  },
  {
    "codigo":414774002,
    "descripcion":"HALLAZGO RELACIONADO CON MONOCITOS"
  },
  {
    "codigo":332871000119103,
    "descripcion":"GLAUCOMA POR PSEUDOEXFOLIACIÓN DE OJO DERECHO"
  },
  {
    "codigo":185398007,
    "descripcion":"PACIENTE QUE CONCURRE TRES VECES POR MES"
  },
  {
    "codigo":21558008,
    "descripcion":"FOSAS NASALES ENSANCHADAS"
  },
  {
    "codigo":707851002,
    "descripcion":"NO SE REQUIERE MANEJO DEL PACIENTE EN INTERNACIÓN"
  },
  {
    "codigo":10900551000119104,
    "descripcion":"CONTUSIÓN DE GLOBO OCULAR IZQUIERDO"
  },
  {
    "codigo":249099004,
    "descripcion":"PRESENTACIÓN DE UNA SOLA RODILLA"
  },
  {
    "codigo":230152000,
    "descripcion":"MENINGITIS SIFILÍTICA CONGÉNITA TARDÍA"
  },
  {
    "codigo":10736711000119105,
    "descripcion":"HIPOPLASIA CONGÉNITA DE CUELLO UTERINO"
  },
  {
    "codigo":280032002,
    "descripcion":"TRASTORNO MADURATIVO DEL LENGUAJE"
  },
  {
    "codigo":247264003,
    "descripcion":"TÍMPANO CICATRIZADO"
  },
  {
    "codigo":443872005,
    "descripcion":"ESCLEROSIS SISTÉMICA CAUSADA POR SUSTANCIA QUÍMICA"
  },
  {
    "codigo":738784008,
    "descripcion":"ANTÍGENO LEUCOCÍTICO HUMANO B*15:02 NO DETECTADO"
  },
  {
    "codigo":704181001,
    "descripcion":"FRACTURA NO EXPUESTA DE CUELLO DE CUARTO METACARPIANO"
  },
  {
    "codigo":276362002,
    "descripcion":"RESPIRA SIN DIFICULTAD"
  },
  {
    "codigo":210826003,
    "descripcion":"CONTUSIÓN, ARTERIA AXILAR"
  },
  {
    "codigo":87111000119109,
    "descripcion":"GLIOMA MALIGNO DE HIPOTÁLAMO"
  },
  {
    "codigo":702346005,
    "descripcion":"SÍNDROME DE DELECIÓN CROMOSÓMICA 11P.11.2"
  },
  {
    "codigo":735114006,
    "descripcion":"OCLUSIÓN DE ARTERIA PONTINA DERECHA"
  },
  {
    "codigo":10956001000119103,
    "descripcion":"HERIDA PUNZANTE DE DEDO ANULAR DE MANO DERECHA"
  },
  {
    "codigo":77919000,
    "descripcion":"SINUSITIS ESFENOIDAL AGUDA"
  },
  {
    "codigo":1259402009,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE VEJIGA URINARIA"
  },
  {
    "codigo":79754008,
    "descripcion":"MIOCARDIOPATÍA RESTRICTIVA SECUNDARIA A AMILOIDOSIS"
  },
  {
    "codigo":1290335004,
    "descripcion":"RUPTURA DE QUISTE SINOVIAL POPLÍTEO DE RODILLA IZQUIERDA"
  },
  {
    "codigo":12383005,
    "descripcion":"MOVIMIENTO DIAFRAGMÁTICO ANORMAL"
  },
  {
    "codigo":733279004,
    "descripcion":"LUXACIÓN TRAUMÁTICA OBTURATRIZ DE CADERA"
  },
  {
    "codigo":307295007,
    "descripcion":"FÍSTULA COLECISTOYEYUNAL"
  },
  {
    "codigo":274527008,
    "descripcion":"HALLAZGOS ANORMALES EN IMÁGENES PARA DIAGNÓSTICO DE HÍGADO + VÍAS BILIARES"
  },
  {
    "codigo":239924002,
    "descripcion":"VASCULITIS SISTÉMICA NECROSANTE PRIMARIA"
  },
  {
    "codigo":403764002,
    "descripcion":"DISPLASIA ECTODÉRMICA CON ODONTOMICRONIQUIA"
  },
  {
    "codigo":698676004,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: NEPALÉS"
  },
  {
    "codigo":370996005,
    "descripcion":"ENFERMEDAD DEL PACIENTE RESUELTA"
  },
  {
    "codigo":860681002,
    "descripcion":"EMBOLIA PULMONAR DEBIDA A EMBARAZO MOLAR Y POSTERIOR A ÉL"
  },
  {
    "codigo":74249003,
    "descripcion":"MIOCARDIOPATÍA DILATADA DEBIDA A CÁNCER"
  },
  {
    "codigo":238089003,
    "descripcion":"HIPERLIPIDEMIA SECUNDARIA COMBINADA"
  },
  {
    "codigo":203486002,
    "descripcion":"OSTEONECROSIS DEBIDA A HEMOGLOBINOPATÍA"
  },
  {
    "codigo":432862004,
    "descripcion":"DIVERTICULOSIS DE RECTOSIGMOIDES"
  },
  {
    "codigo":1163059007,
    "descripcion":"ENCEFALITIS POR VIRUS JUNÍN"
  },
  {
    "codigo":1284830006,
    "descripcion":"OSTEOMA OSTEOIDE DE TIBIA"
  },
  {
    "codigo":301790009,
    "descripcion":"COMIDA VOMITADA"
  },
  {
    "codigo":1083581000119100,
    "descripcion":"TRASTORNO DE AMBAS MEMBRANAS TIMPÁNICAS"
  },
  {
    "codigo":208061000119101,
    "descripcion":"ADENOMA DE PÁNCREAS"
  },
  {
    "codigo":15959741000119102,
    "descripcion":"QUISTE DE LIGAMENTO ANCHO DERECHO"
  },
  {
    "codigo":431027007,
    "descripcion":"EFECTO TARDÍO DE VIOLENCIA FAMILIAR"
  },
  {
    "codigo":134280000,
    "descripcion":"LEE INGLÉS"
  },
  {
    "codigo":121021000119105,
    "descripcion":"NUEVA CEFALEA DIARIA PERSISTENTE"
  },
  {
    "codigo":10760381000119106,
    "descripcion":"TIROIDITIS EN EL EMBARAZO"
  },
  {
    "codigo":295101000119105,
    "descripcion":"NEFROPATÍA CONCOMITANTE CON LUPUS ERITEMATOSO SISTÉMICO Y DEBIDA A ELLA"
  },
  {
    "codigo":956321981000119108,
    "descripcion":"EROSIÓN GÁSTRICA CRÓNICA"
  },
  {
    "codigo":1081021000119109,
    "descripcion":"MELANOMA MALIGNO DE PIEL DE MIEMBRO INFERIOR IZQUIERDO"
  },
  {
    "codigo":11858621000119103,
    "descripcion":"LESIÓN TRAUMÁTICA DE ARTERIA TIBIAL ANTERIOR DERECHA"
  },
  {
    "codigo":701000119103,
    "descripcion":"HIPERLIPIDEMIA MIXTA DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":16899261000119106,
    "descripcion":"ATEROSCLEROSIS DE ARTERIA MESENTÉRICA SUPERIOR"
  },
  {
    "codigo":725939009,
    "descripcion":"CIRROSIS HEPÁTICA CAUSADA POR AMIODARONA"
  },
  {
    "codigo":298120001,
    "descripcion":"LESIÓN DEL NERVIO MUSCULOCUTÁNEO"
  },
  {
    "codigo":39101000119109,
    "descripcion":"EMBARAZO CON ISOINMUNIZACIÓN POR INCOMPATIBILIDAD CON GRUPO SANGUÍNEO IRREGULAR"
  },
  {
    "codigo":230749002,
    "descripcion":"HIDROCEFALIA DEBIDA A Y DESPUÉS DE MENINGITIS"
  },
  {
    "codigo":12206781000119108,
    "descripcion":"LUXACIÓN DE PRÓTESIS DE ARTICULACIÓN DE RODILLA DERECHA"
  },
  {
    "codigo":1075901000119109,
    "descripcion":"SINOVITIS DE TOBILLO DERECHO"
  },
  {
    "codigo":66909001,
    "descripcion":"SÍNDROME DE DEFICIENCIA DE FACTOR MÚLTIPLE FAMILIAR, TIPO IV"
  },
  {
    "codigo":296285008,
    "descripcion":"SOBREDOSIS DE INHIBIDOR DE DESCARBOXILASA"
  },
  {
    "codigo":65074000,
    "descripcion":"IRITIS"
  },
  {
    "codigo":335381000119103,
    "descripcion":"CICATRIZ CORIORRETINIANA DISEMINADA DE OJO DERECHO"
  },
  {
    "codigo":425522009,
    "descripcion":"ENCEFALOPATÍA HIPERAMONÉMICA"
  },
  {
    "codigo":1144583005,
    "descripcion":"BUENA RECUPERACIÓN POSTQUIRÚRGICA"
  },
  {
    "codigo":194311006,
    "descripcion":"MIRINGITIS AGUDA SIN OTITIS MEDIA"
  },
  {
    "codigo":292615007,
    "descripcion":"REACCIÓN ADVERSA A LA AMINOFILINA"
  },
  {
    "codigo":7701000119105,
    "descripcion":"ESOTROPÍA ALTERNANTE NO DIVERGENTE"
  },
  {
    "codigo":94172001,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL ANO"
  },
  {
    "codigo":10630831000119100,
    "descripcion":"LINFANGITIS AGUDA DE MUSLO IZQUIERDO"
  },
  {
    "codigo":288945004,
    "descripcion":"DIFICULTAD PARA TRAGAR ALIMENTOS"
  },
  {
    "codigo":190641005,
    "descripcion":"EFECTO TARDÍO DEL RAQUITISMO"
  },
  {
    "codigo":418182000,
    "descripcion":"ENFERMEDAD POR VIRUS DEL SEROGRUPO CALIFORNIA"
  },
  {
    "codigo":92337009,
    "descripcion":"NEOPLASIA BENIGNA DE GLÁNDULA SEBÁCEA"
  },
  {
    "codigo":287110006,
    "descripcion":"ASTILLA CLAVADA EN EL TRONCO"
  },
  {
    "codigo":55899000,
    "descripcion":"CUERPO EXTRAÑO EN EL OJO"
  },
  {
    "codigo":385414009,
    "descripcion":"INVASIÓN TUMORAL LINFÁTICA (VASOS DE PEQUEÑO CALIBRE) - HALLAZGO"
  },
  {
    "codigo":285275001,
    "descripcion":"FANTASÍA DE VIOLACIÓN"
  },
  {
    "codigo":449115006,
    "descripcion":"VÁLVULA AÓRTICA TRICÚSPIDE PRESENTE"
  },
  {
    "codigo":186971007,
    "descripcion":"NÓDULOS YUXTARTICULARES DE LA FRAMBESIA"
  },
  {
    "codigo":1332016001,
    "descripcion":"OSTEÓLISIS DE HÚMERO"
  },
  {
    "codigo":283440002,
    "descripcion":"CORTE EN DEDO DEL PIE"
  },
  {
    "codigo":709424004,
    "descripcion":"HEMORRAGIA POSOPERATORIA DE ANO"
  },
  {
    "codigo":840496004,
    "descripcion":"ENCEFALITIS CAUSADA POR BORRELIA"
  },
  {
    "codigo":54064006,
    "descripcion":"ENFERMEDAD DE ORINA EN JARABE DE ARCE CLÁSICA"
  },
  {
    "codigo":84997000,
    "descripcion":"INTOXICACIÓN POR INSECTICIDA"
  },
  {
    "codigo":707589002,
    "descripcion":"CISTOADENOCARCINOMA PRIMARIO DE OROFARINGE"
  },
  {
    "codigo":445445006,
    "descripcion":"COLESTEROL DE LIPOPROTEÍNA DE BAJA DENSIDAD POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":248837007,
    "descripcion":"CALOR EN MAMA"
  },
  {
    "codigo":247002006,
    "descripcion":"DEPÓSITOS SEUDOEXFOLIADOS DE LA CÁMARA ANTERIOR"
  },
  {
    "codigo":83162009,
    "descripcion":"QUISTE DE IMPLANTACIÓN EN LA CÁMARA OCULAR ANTERIOR"
  },
  {
    "codigo":212399002,
    "descripcion":"LESIÓN MUSCULAR Y TENDINOSA A NIVEL DEL CUELLO"
  },
  {
    "codigo":736687002,
    "descripcion":"ANTICUERPO ANTI-ANTÍGENO CORE DE VIRUS DE HEPATITIS B DETECTADO"
  },
  {
    "codigo":81327003,
    "descripcion":"QUEMADURAS PROFUNDAS DE TERCER GRADO DE SITIOS MÚLTIPLES"
  },
  {
    "codigo":441775006,
    "descripcion":"17-CETOESTEROIDES EN ESPÉCIMEN DE ORINA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":276100002,
    "descripcion":"FAMILIA PERTURBADA"
  },
  {
    "codigo":1259140002,
    "descripcion":"GLUCEMIA INESTABLE"
  },
  {
    "codigo":210564008,
    "descripcion":"HERIDA ABIERTA DE LA MANO, DORSO"
  },
  {
    "codigo":46724008,
    "descripcion":"NEOPLASIA ENDOCRINA MÚLTIPLE"
  },
  {
    "codigo":308868008,
    "descripcion":"DISPLASIA GRAVE DE CONDUCTO PANCREÁTICO"
  },
  {
    "codigo":700249006,
    "descripcion":"NEUMONITIS INTERSTICIAL IDIOPÁTICA"
  },
  {
    "codigo":1290073006,
    "descripcion":"TUMOR NEUROENDOCRINO BIEN DIFERENCIADO DE RIÑÓN DERECHO"
  },
  {
    "codigo":1075171000119102,
    "descripcion":"PIE CAVO ADQUIRIDO DERECHO"
  },
  {
    "codigo":403502003,
    "descripcion":"LUPUS ERITEMATOSO DISCOIDE DISEMINADO"
  },
  {
    "codigo":237827002,
    "descripcion":"HIPERFUNCIÓN POLIGLANDULAR"
  },
  {
    "codigo":303363007,
    "descripcion":"CAPAZ DE EMPUJAR"
  },
  {
    "codigo":203224004,
    "descripcion":"INFECCIÓN DE HÚMERO"
  },
  {
    "codigo":39384006,
    "descripcion":"INCOORDINACIÓN MUSCULAR"
  },
  {
    "codigo":301528008,
    "descripcion":"CAPAZ DE ENTRAR EN LA BAÑERA"
  },
  {
    "codigo":234157001,
    "descripcion":"MALFORMACIÓN ARTERIOVENOSA-LINFÁTICA"
  },
  {
    "codigo":823981002,
    "descripcion":"NERVIO GLOSOFARÍNGEO INTACTO"
  },
  {
    "codigo":365229003,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA MANEJAR UN ARTEFACTO MIENTRAS SE VISTE"
  },
  {
    "codigo":168621009,
    "descripcion":"RADIOGRAFÍA SIMPLE DE CODO NORMAL"
  },
  {
    "codigo":363394001,
    "descripcion":"NEOPLASIA MALIGNA DE FOSA AMIGDALINA"
  },
  {
    "codigo":2946003,
    "descripcion":"DIARREA OSMÓTICA"
  },
  {
    "codigo":166786002,
    "descripcion":"GAMMAGLOBULINA SÉRICA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":428930004,
    "descripcion":"GESTACIÓN DE 9 A 13 SEMANAS"
  },
  {
    "codigo":232322006,
    "descripcion":"ACÚFENOS DE ORIGEN VASCULAR"
  },
  {
    "codigo":266925009,
    "descripcion":"EX FUMADOR EXCESIVO DE CIGARRILLOS (40+\/DÍA)"
  },
  {
    "codigo":1111005,
    "descripcion":"ACTIVIDAD DE GLÁNDULA SEBÁCEA NORMAL"
  },
  {
    "codigo":164951009,
    "descripcion":"COMPLEJO QRS ELECTROCARDIOGRÁFICO ANORMAL"
  },
  {
    "codigo":62977003,
    "descripcion":"TÚNICA VASCULAR DEL CRISTALINO PERSISTENTE"
  },
  {
    "codigo":292353005,
    "descripcion":"REACCIÓN ADVERSA AL CLOBAZAM"
  },
  {
    "codigo":423425006,
    "descripcion":"NEOPLASIA MALIGNA DE LA PIEL DEL PÁRPADO"
  },
  {
    "codigo":61142002,
    "descripcion":"MICROFTALMÍA"
  },
  {
    "codigo":1306326003,
    "descripcion":"CARCINOMA IN SITU DE PEZÓN"
  },
  {
    "codigo":126678005,
    "descripcion":"NEOPLASIA DE SENO FRONTAL"
  },
  {
    "codigo":224982006,
    "descripcion":"TRANSFERENCIA"
  },
  {
    "codigo":290518006,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR ISOFLURANO"
  },
  {
    "codigo":288683000,
    "descripcion":"CAPAZ DE PRESUPONER EN UNA CONVERSACIÓN"
  },
  {
    "codigo":716502009,
    "descripcion":"NO COMPRENDE INSTRUCCIONES DE DOS PALABRAS"
  },
  {
    "codigo":93910009,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE MÚSCULO DEL TÓRAX"
  },
  {
    "codigo":92075001,
    "descripcion":"NEOPLASIA BENIGNA DE CONDUCTO CÍSTICO"
  },
  {
    "codigo":59307008,
    "descripcion":"ALOPECIA SIFILÍTICA"
  },
  {
    "codigo":714667008,
    "descripcion":"TEMOR A EFECTOS COLATERALES DE MEDICAMENTO"
  },
  {
    "codigo":254080004,
    "descripcion":"DISPLASIA EPIFISARIA"
  },
  {
    "codigo":286848005,
    "descripcion":"CAPAZ DE PLANIFICAR"
  },
  {
    "codigo":712832005,
    "descripcion":"HIPERTENSIÓN EN DECÚBITO SUPINO"
  },
  {
    "codigo":22869000,
    "descripcion":"EVALUACIÓN DE DISCAPACIDAD: ALTERACIÓN CLASE 3"
  },
  {
    "codigo":55637002,
    "descripcion":"HEMIPLEJÍA RAQUÍDEA"
  },
  {
    "codigo":874837003,
    "descripcion":"CUERPO EXTRAÑO SUPERFICIAL EN LABIO"
  },
  {
    "codigo":11835671000119107,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN METATARSOFALÁNGICA DE DEDO GORDO DERECHO"
  },
  {
    "codigo":285013006,
    "descripcion":"DIFICULTAR PARA AJUSTAR LA ROPA"
  },
  {
    "codigo":414250001,
    "descripcion":"FIBROHISTIOCITOMA DE ÓRBITA"
  },
  {
    "codigo":184874003,
    "descripcion":"INFORME DE SEGURIDAD SOCIAL ENVIADO"
  },
  {
    "codigo":447018003,
    "descripcion":"FRACTURA EXPUESTA DE EPICÓNDILO"
  },
  {
    "codigo":16914711000119109,
    "descripcion":"ESTRECHEZ DE URETRA MASCULINA"
  },
  {
    "codigo":1004074008,
    "descripcion":"CONTRACTURA EN FLEXIÓN DE ARTICULACIÓN DE MUÑECA DERECHA"
  },
  {
    "codigo":283178009,
    "descripcion":"CUERPO EXTRAÑO METÁLICO EN LA RODILLA"
  },
  {
    "codigo":248575002,
    "descripcion":"RESPIRACIÓN QUEJUMBROSA"
  },
  {
    "codigo":1231615003,
    "descripcion":"MIOSIS ESPÁSTICA"
  },
  {
    "codigo":405896000,
    "descripcion":"FENOTIPO K+K+"
  },
  {
    "codigo":767358005,
    "descripcion":"SURCO MENTOLABIAL SUPERFICIAL"
  },
  {
    "codigo":13694005,
    "descripcion":"POLINEUROPATÍA SENSITIVA"
  },
  {
    "codigo":306771002,
    "descripcion":"TRAGA SÓLIDOS"
  },
  {
    "codigo":110163006,
    "descripcion":"ABRASIÓN DE LA LENGUA"
  },
  {
    "codigo":11859008,
    "descripcion":"INFARTO DE LA GLÁNDULA TIROIDES"
  },
  {
    "codigo":208467008,
    "descripcion":"FRACTURA EXPUESTA DE FALANGE PROXIMAL DE PULGAR"
  },
  {
    "codigo":403240004,
    "descripcion":"COLOR CONSTITUTIVO DE LA PIEL, MORENO CLARO"
  },
  {
    "codigo":370472005,
    "descripcion":"HIPERTROFIA DEL MÚSCULO LISO INTESTINAL"
  },
  {
    "codigo":237565000,
    "descripcion":"SÍNDROME DE DEFICIENCIA CONGÉNITA DE YODO DE TIPO MIXTO"
  },
  {
    "codigo":763688008,
    "descripcion":"SÍNDROME DE SORDERA, ENCEFALONEUROPATÍA, OBESIDAD Y VALVULOPATÍA"
  },
  {
    "codigo":73725006,
    "descripcion":"ENGROSAMIENTO PLEURAL"
  },
  {
    "codigo":1351677008,
    "descripcion":"TIROIDITIS DE HASHIMOTO ATRÓFICA"
  },
  {
    "codigo":399570001,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA NO COMPROMETIDO POR LINFOMA"
  },
  {
    "codigo":290227006,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ACEMETACINA"
  },
  {
    "codigo":235730004,
    "descripcion":"AUSENCIA FAMILIAR DE VELLOSIDADES"
  },
  {
    "codigo":347218661000119103,
    "descripcion":"ABRASIÓN DE REGIÓN BUCAL"
  },
  {
    "codigo":301266007,
    "descripcion":"MATIDEZ CARDÍACA DESPLAZADA HACIA LA DERECHA"
  },
  {
    "codigo":233895000,
    "descripcion":"TAQUICARDIA ECTÓPICA DEL NÓDULO AURICULOVENTRICULAR"
  },
  {
    "codigo":364967001,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA IMITAR LOS MOVIMIENTOS DE LA LENGUA"
  },
  {
    "codigo":4519003,
    "descripcion":"HIPOURICEMIA"
  },
  {
    "codigo":428668000,
    "descripcion":"APRAXIA POR ACCIDENTE CEREBROVASCULAR"
  },
  {
    "codigo":789116000,
    "descripcion":"PANUVEÍTIS INFECCIOSA"
  },
  {
    "codigo":725415009,
    "descripcion":"ALVEOLITIS ALÉRGICA DOMÉSTICA"
  },
  {
    "codigo":15934181000119106,
    "descripcion":"DEDO EN MARTILLO ADQUIRIDO DE SEGUNDO A QUINTO DEDOS DE AMBOS PIES"
  },
  {
    "codigo":363132006,
    "descripcion":"COMPLICACIÓN GASTROINTESTINAL DE PROCEDIMIENTO"
  },
  {
    "codigo":723580007,
    "descripcion":"SÍNDROME DE OSTEÓLISIS ASTRAGALINA-ROTULIANA-DE ESCAFOIDES"
  },
  {
    "codigo":849000,
    "descripcion":"CATARATA MADURA"
  },
  {
    "codigo":230225001,
    "descripcion":"TROMBOFLEBITIS SÉPTICA DE LA VENA CEREBRAL MAGNA"
  },
  {
    "codigo":721745002,
    "descripcion":"CELULITIS INFANTIL DE LA REGIÓN PERIANAL CAUSADA POR STREPTOCOCCUS BETA-HEMOLÍTICO DEL GRUPO A"
  },
  {
    "codigo":35452009,
    "descripcion":"DILACERACIÓN DE DIENTE"
  },
  {
    "codigo":461436005,
    "descripcion":"ORIGEN ANÓMALO DE ARTERIAS CORONARIAS DESCENDENTES ANTERIORES IZQUIERDAS DOBLES"
  },
  {
    "codigo":33617007,
    "descripcion":"ACTO SEXUAL ORAL"
  },
  {
    "codigo":719910004,
    "descripcion":"SÍNDROME DE PELO DIFÍCIL DE PEINAR, DISTROFIA PIGMENTARIA DE LA RETINA, ANOMALIAS DENTALES Y BRAQUIDACTILIA"
  },
  {
    "codigo":293926008,
    "descripcion":"ALERGIA A PIMOZIDA"
  },
  {
    "codigo":292091001,
    "descripcion":"REACCIÓN ADVERSA A LA TOLMETINA"
  },
  {
    "codigo":342911000119104,
    "descripcion":"CATARATA POLAR SUBCAPSULAR ANTERIOR CONGÉNITA"
  },
  {
    "codigo":95483005,
    "descripcion":"LENTIGLOBO POSTERIOR"
  },
  {
    "codigo":718075006,
    "descripcion":"PERI-IMPLANTITIS DENTAL PARCIAL"
  },
  {
    "codigo":1163528001,
    "descripcion":"ERITEMA MULTIFORME DEBIDO A INFECCIÓN BACTERIANA"
  },
  {
    "codigo":193787009,
    "descripcion":"QUERATITIS DEBIDA A TUBERCULOSIS"
  },
  {
    "codigo":93648001,
    "descripcion":"MELANOMA MALIGNO DE LA PIEL DE LA REGIÓN TEMPORAL"
  },
  {
    "codigo":421328004,
    "descripcion":"HEMORRAGIA SUBFOVEAL"
  },
  {
    "codigo":15989631000119106,
    "descripcion":"ESTRABISMO RESTRICTIVO DE OJO DERECHO DEBIDO A FIBROSIS ORBITARIA"
  },
  {
    "codigo":290256006,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR FLURBIPROFENO"
  },
  {
    "codigo":191952007,
    "descripcion":"DISFUNCIÓN AUTÓNOMA SOMATOMORFA - VÍAS RESPIRATORIAS"
  },
  {
    "codigo":419493001,
    "descripcion":"6 METROS"
  },
  {
    "codigo":124581005,
    "descripcion":"DEFICIENCIA DE CISTEÍNA CARBOXIPEPTIDASA"
  },
  {
    "codigo":288421006,
    "descripcion":"NO ENHEBRA UNA AGUJA"
  },
  {
    "codigo":188282004,
    "descripcion":"NEOPLASIA MALIGNA DE LA CORTEZA CEREBRAL"
  },
  {
    "codigo":15717401000119103,
    "descripcion":"OSTEOCONDRITIS DISECANTE DE AMBOS TOBILLOS"
  },
  {
    "codigo":417658006,
    "descripcion":"HOLOANENCEFALIA"
  },
  {
    "codigo":253818009,
    "descripcion":"MALFORMACIÓN CONGÉNITA DE LA PARED ABDOMINAL ANTERIOR"
  },
  {
    "codigo":22607003,
    "descripcion":"ASBESTOSIS"
  },
  {
    "codigo":10966041000119105,
    "descripcion":"HERIDA PUNZANTE DE REGIÓN DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":446756002,
    "descripcion":"ENTERITIS CAUSADA POR ENTEROVIRUS HUMANO 71"
  },
  {
    "codigo":11785241000119106,
    "descripcion":"AMPOLLA TRAUMÁTICA DE DEDO MEDIO DERECHO"
  },
  {
    "codigo":250148006,
    "descripcion":"EL CONTRAFUERTE DEL CALZADO CAUSA IRRITACIÓN ALREDEDOR DEL TALÓN"
  },
  {
    "codigo":282916007,
    "descripcion":"NO TOMA ASIENTO"
  },
  {
    "codigo":248313003,
    "descripcion":"DEPÓSITOS DE GRASA LOCALIZADOS"
  },
  {
    "codigo":444921008,
    "descripcion":"MEMBRANA SUBGLÓTICA"
  },
  {
    "codigo":770766000,
    "descripcion":"RETINOPATÍA PROLIFERATIVA DEL OJO IZQUIERDO DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":153241000146104,
    "descripcion":"PACIENTE NO DISPONIBLE PARA RECIBIR MEDICACIÓN"
  },
  {
    "codigo":768931007,
    "descripcion":"TRISOMÍA PARCIAL DEL BRAZO LARGO DEL CROMOSOMA 1"
  },
  {
    "codigo":1293219007,
    "descripcion":"CONDROLIPOMA"
  },
  {
    "codigo":211875009,
    "descripcion":"CORROSIÓN DE PRIMER GRADO DE HOMBRO Y EXTREMIDAD SUPERIOR, EXCEPTO MUÑECA Y MANO"
  },
  {
    "codigo":78968003,
    "descripcion":"CONTUSIÓN DEL TRONCO ENCEFÁLICO CON HERIDA INTRACRANEAL ABIERTA"
  },
  {
    "codigo":734328004,
    "descripcion":"NO TIENE ÚLTIMA VOLUNTAD Y TESTAMENTO ACTUALIZADO"
  },
  {
    "codigo":46200004,
    "descripcion":"PRESENTACIÓN FUNICULAR"
  },
  {
    "codigo":373880007,
    "descripcion":"ESPÉCIMEN RECHAZADO \/ NO PROCESADO"
  },
  {
    "codigo":208205000,
    "descripcion":"RUPTURA TOTAL EXPUESTA DE LA SÍNFISIS PÚBICA"
  },
  {
    "codigo":404813001,
    "descripcion":"PÉRDIDA A TRAVÉS DE LA DIÁLISIS PERITONEAL"
  },
  {
    "codigo":11597004,
    "descripcion":"PROLAPSO UTERINO SIN PROLAPSO DE LA PARED VAGINAL"
  },
  {
    "codigo":109901006,
    "descripcion":"INDICACIÓN PARA LA MODIFICACIÓN DEL ESTADO PSICOLÓGICO DEL PACIENTE"
  },
  {
    "codigo":11814221000119102,
    "descripcion":"RUPTURA TRAUMÁTICA DE LIGAMENTO DE ARTICULACIÓN DE DEDO ÍNDICE IZQUIERDO"
  },
  {
    "codigo":402978002,
    "descripcion":"INFECCIÓN CUTÁNEA POR MYCOBACTERIUM SZULGAI"
  },
  {
    "codigo":206370004,
    "descripcion":"INFECCIÓN CONGÉNITA POR PSEUDOMONAS PYOCYANEUS"
  },
  {
    "codigo":1254946006,
    "descripcion":"SÍNDROME DE GRISCELLI TIPO 1"
  },
  {
    "codigo":204535000,
    "descripcion":"AGENESIA DE LARINGE"
  },
  {
    "codigo":42530008,
    "descripcion":"XERODERMIA PIGMENTOSA, GRUPO F"
  },
  {
    "codigo":270071005,
    "descripcion":"PACIENTE REGISTRADO POR CENTRO DE MEDICINA FAMILIAR"
  },
  {
    "codigo":7927006,
    "descripcion":"HEMATOMA PERIORBITARIO"
  },
  {
    "codigo":237303006,
    "descripcion":"ISOINMUNIZACIÓN POR GRUPO SANGUÍNEO DUFFY DURANTE EL EMBARAZO"
  },
  {
    "codigo":169932000,
    "descripcion":"PUNTAJE DE APGAR A LOS 10 MINUTOS = 9"
  },
  {
    "codigo":301004001,
    "descripcion":"NEUMONÍA DE LÓBULO SUPERIOR DERECHO"
  },
  {
    "codigo":268236002,
    "descripcion":"ESTENOSIS CONGÉNITA DE CUELLO DE VEJIGA URINARIA"
  },
  {
    "codigo":202700003,
    "descripcion":"ESPONDILOPATÍA NEUROPÁTICA"
  },
  {
    "codigo":366540004,
    "descripcion":"HALLAZGO RELACIONADO CON LA AMPLITUD DE LA PRONACIÓN DE LA MUÑECA"
  },
  {
    "codigo":345421000119106,
    "descripcion":"ESTENOSIS DE PUNTO LAGRIMAL DE AMBOS PÁRPADOS"
  },
  {
    "codigo":71628007,
    "descripcion":"PRESENCIA ANORMAL DE ALBÚMINA"
  },
  {
    "codigo":102561001,
    "descripcion":"DISPRAXIA DE BRAZO"
  },
  {
    "codigo":10640871000119101,
    "descripcion":"ÚLCERA CRÓNICA NO CAUSADA POR PRESIÓN DE PANTORRILLA QUE SE EXTIENDE HASTA EL TEJIDO ADIPOSO"
  },
  {
    "codigo":233633008,
    "descripcion":"BRONQUIECTASIA CAUSADA POR INHALACIÓN DE SUSTANCIA TÓXICA"
  },
  {
    "codigo":299169009,
    "descripcion":"AMPLITUD DE ABDUCCIÓN PASIVA DEL PULGAR AUMENTADA"
  },
  {
    "codigo":231798002,
    "descripcion":"ENFERMEDAD DEL MARGEN POSTERIOR PALPEBRAL"
  },
  {
    "codigo":428406005,
    "descripcion":"USO INAPROPIADO DE BENZODIAZEPINAS"
  },
  {
    "codigo":262731000,
    "descripcion":"SECCIÓN PARCIAL DE LA RAÍZ DE NERVIO LUMBAR"
  },
  {
    "codigo":66123000,
    "descripcion":"ÚLCERA DE LA LENGUA"
  },
  {
    "codigo":721483002,
    "descripcion":"SÍNDROME DE BROWN-SEQUARD AL NIVEL DEL SEGUNDO SEGMENTO DORSAL"
  },
  {
    "codigo":295499002,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE ÓXIDO NITROSO"
  },
  {
    "codigo":197195001,
    "descripcion":"ADHERENCIAS ILEOCECALES"
  },
  {
    "codigo":228128002,
    "descripcion":"MENOR CON CAUSA PENAL"
  },
  {
    "codigo":424736006,
    "descripcion":"NEUROPATÍA PERIFÉRICA DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":816117000,
    "descripcion":"MIEMBRO INFERIOR AMPUTADO"
  },
  {
    "codigo":193525001,
    "descripcion":"RETRACCIÓN DEL ÁNGULO"
  },
  {
    "codigo":717813005,
    "descripcion":"SÍNDROME DE RETRASO GLOBAL DEL DESARROLLO, OSTEOPENIA, SÍNDROME DE DEFECTO ECTODÉRMICO"
  },
  {
    "codigo":160757006,
    "descripcion":"FAMILIAR ANCIANO QUE VIVE CON SU FAMILIA"
  },
  {
    "codigo":95221007,
    "descripcion":"TRASTORNO DE RETINA CAUSADO POR RADIACIÓN"
  },
  {
    "codigo":1078261008,
    "descripcion":"AGENESIA DE EPÍFISIS DE FALANGE DISTAL DE DEDO GORDO"
  },
  {
    "codigo":191690004,
    "descripcion":"AUTISMO INFANTIL RESIDUAL"
  },
  {
    "codigo":879818005,
    "descripcion":"TERATOMA SACRO FETAL"
  },
  {
    "codigo":93386004,
    "descripcion":"ESTENOSIS CONGÉNITA DEL TRACTO INTESTINAL"
  },
  {
    "codigo":224458009,
    "descripcion":"BAJO LICENCIA POR PATERNIDAD"
  },
  {
    "codigo":26015003,
    "descripcion":"SÍNDROME DE MAROTEAUX - LAMY, FORMA INTERMEDIA"
  },
  {
    "codigo":124319004,
    "descripcion":"DEFICIENCIA DE RIBOFLAVINA CINASA"
  },
  {
    "codigo":15693441000119104,
    "descripcion":"QUERATITIS DE OJO DERECHO CAUSADA POR MYCOBACTERIUM"
  },
  {
    "codigo":1172895006,
    "descripcion":"SUSCEPTIBILIDAD MENDELIANA A LA ENFERMEDAD MICOBACTERIANA"
  },
  {
    "codigo":253556000,
    "descripcion":"DEFECTO DEL TABIQUE INTERVENTRICULAR CON TABIQUE DE SALIDA MAL ALINEADO HACIA LA DERECHA"
  },
  {
    "codigo":1269364006,
    "descripcion":"CRISIS EPILÉPTICA CLÓNICA CON CONCIENCIA PRESERVADA DE INICIO FOCAL"
  },
  {
    "codigo":415561000,
    "descripcion":"FIEBRE POR PICADURA DE GARRAPATA SUDAFRICANA"
  },
  {
    "codigo":286324009,
    "descripcion":"DIFICULTAD PARA USAR SONIDOS COMBINADOS"
  },
  {
    "codigo":218953004,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR PEPSINA"
  },
  {
    "codigo":284489004,
    "descripcion":"CONDUCTA DE EVASIÓN"
  },
  {
    "codigo":249886001,
    "descripcion":"DEBILIDAD DE MÚSCULOS MANDIBULARES"
  },
  {
    "codigo":448329009,
    "descripcion":"ANEURISMA DE VENA CAVA SUPERIOR IZQUIERDA"
  },
  {
    "codigo":282654005,
    "descripcion":"TRANSFIERE PESO"
  },
  {
    "codigo":708638007,
    "descripcion":"DESPLIEGUE INCISAL DISMINUIDO EN REPOSO"
  },
  {
    "codigo":51443000,
    "descripcion":"TRASTORNO PSICÓTICO CON ALUCINACIONES INDUCIDO POR ANFETAMINAS"
  },
  {
    "codigo":1003550007,
    "descripcion":"AGENESIA DE TIMO"
  },
  {
    "codigo":18675002,
    "descripcion":"FÍSTULA VESICOPERINEAL"
  },
  {
    "codigo":444659003,
    "descripcion":"AMPOLLA DE PIE"
  },
  {
    "codigo":20510008,
    "descripcion":"TORSIÓN DE UNA TROMPA DE FALOPIO ACCESORIA"
  },
  {
    "codigo":315422007,
    "descripcion":"NACIDO EN GUINEA ECUATORIAL"
  },
  {
    "codigo":248051006,
    "descripcion":"PADRES QUE IMPIDEN IR A LA ESCUELA"
  },
  {
    "codigo":1085211000119105,
    "descripcion":"OBSTRUCCIÓN INTESTINAL DEBIDA A PROCTITIS ULCEROSA CRÓNICA"
  },
  {
    "codigo":410056006,
    "descripcion":"TIROSINEMIA TIPO 1"
  },
  {
    "codigo":82376007,
    "descripcion":"ACTIVIDAD ANORMAL DE LA GLÁNDULA SEBÁCEA"
  },
  {
    "codigo":703133002,
    "descripcion":"REACCIÓN ALÉRGICA LIQUENOIDE POR CONTACTO CAUSADA POR AMALGAMA"
  },
  {
    "codigo":440989002,
    "descripcion":"MUTACIÓN G20210A EN EL GEN DE PROTROMBINA"
  },
  {
    "codigo":321461000119101,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE TENDÓN EXTENSOR DE PIERNA DERECHA"
  },
  {
    "codigo":735901006,
    "descripcion":"MÚLTIPLES LESIONES TRAUMÁTICAS DE PIE"
  },
  {
    "codigo":102171000119108,
    "descripcion":"PROBLEMAS DE RELACIÓN CON MIEMBROS DE LA FAMILIA DEBIDOS A AFECCIÓN CLÍNICA"
  },
  {
    "codigo":275314000,
    "descripcion":"DOLOR DEL MUÑÓN ANAL"
  },
  {
    "codigo":177010002,
    "descripcion":"ENFERMEDAD INFECCIOSA CRÓNICA"
  },
  {
    "codigo":111474003,
    "descripcion":"TRASTORNO FETAL Y\/O NEONATAL DE SISTEMA TEGUMENTARIO"
  },
  {
    "codigo":734066005,
    "descripcion":"LINFOMA DIFUSO DE LINFOCITOS B GRANDES DEL SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":766834007,
    "descripcion":"CATARATA SECUNDARIA"
  },
  {
    "codigo":109639001,
    "descripcion":"LIMITACIÓN PARA ABRIR LA BOCA"
  },
  {
    "codigo":764999002,
    "descripcion":"PARAGANGLIOMA NO FUNCIONANTE"
  },
  {
    "codigo":373618009,
    "descripcion":"TRASTORNO DEL ESPECTRO DE AUTISMO CON HABILIDADES AISLADAS"
  },
  {
    "codigo":240711004,
    "descripcion":"CANDIDIASIS DEL PAÑAL"
  },
  {
    "codigo":76871004,
    "descripcion":"CIRUGÍA PREVIA DE VAGINA QUE AFECTA EL EMBARAZO"
  },
  {
    "codigo":207943006,
    "descripcion":"FRACTURA NO EXPUESTA DE VÉRTEBRA DORSAL, APÓFISIS TRANSVERSA"
  },
  {
    "codigo":44103008,
    "descripcion":"ARRITMIA VENTRICULAR"
  },
  {
    "codigo":271644001,
    "descripcion":"PARED ARTERIAL EN BOQUILLA DE PIPA"
  },
  {
    "codigo":402716004,
    "descripcion":"ENFERMEDAD BULLOSA INMUNE"
  },
  {
    "codigo":105969002,
    "descripcion":"TRASTORNO DEL TEJIDO CONECTIVO"
  },
  {
    "codigo":7665002,
    "descripcion":"INTOXICACIÓN CAUSADA POR AMFOTERICINA B"
  },
  {
    "codigo":1285617004,
    "descripcion":"HEMATOMA DE PULGAR"
  },
  {
    "codigo":237041005,
    "descripcion":"SÍNDROME DE FITZ-HUGH-CURTIS"
  },
  {
    "codigo":202438000,
    "descripcion":"TUMOR TENOSINOVIAL DIFUSO DE CÉLULAS GIGANTES DE MUÑECA"
  },
  {
    "codigo":366278001,
    "descripcion":"HALLAZGO RELACIONADO CON LA FUERZA DEL CHORRO URINARIO"
  },
  {
    "codigo":267974002,
    "descripcion":"DISCO INTERVERTEBRAL CERVICAL PROLAPSADO SIN MIELOPATÍA"
  },
  {
    "codigo":300742006,
    "descripcion":"DIFICULTAD PARA PARTICIPAR EN ACTIVIDADES DE TIEMPO LIBRE"
  },
  {
    "codigo":397211000,
    "descripcion":"INVASIÓN ARTERIAL (VASO GRANDE) POR TUMOR INDETERMINADO"
  },
  {
    "codigo":724891001,
    "descripcion":"DISTENSIÓN DE FASCIA DE REGIÓN LUMBAR"
  },
  {
    "codigo":399046008,
    "descripcion":"LEVOTRANSPOSICIÓN DE LOS GRANDES VASOS"
  },
  {
    "codigo":167835006,
    "descripcion":"VÓMITO: COMIDA NO DIGERIDA PRESENTE"
  },
  {
    "codigo":231536004,
    "descripcion":"AUTISMO ATÍPICO"
  },
  {
    "codigo":297072006,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE ALCALOIDE DEL CORNEZUELO DE CENTENO"
  },
  {
    "codigo":721221000,
    "descripcion":"SÍNDROME DE ENFERMEDAD DE HIRSCHSPRUNG CON SORDERA Y POLIDACTILIA"
  },
  {
    "codigo":67696008,
    "descripcion":"INSUFICIENCIA DE VÁLVULA TRICÚSPIDE REUMÁTICA"
  },
  {
    "codigo":196933002,
    "descripcion":"HERNIA OBTURATRIZ IRREDUCTIBLE"
  },
  {
    "codigo":428144009,
    "descripcion":"ARTROPATÍA TRAUMÁTICA DE LA COLUMNA VERTEBRAL"
  },
  {
    "codigo":10836201000119101,
    "descripcion":"HIPERPLASIA LOBAR ATÍPICA DE MAMA IZQUIERDA"
  },
  {
    "codigo":229701006,
    "descripcion":"DISPRAXIA ARTICULATORIA DEL DESARROLLO"
  },
  {
    "codigo":16023631000119108,
    "descripcion":"VÁRICE DE VENA DE AMBAS EXTREMIDADES SUPERIORES"
  },
  {
    "codigo":31258000,
    "descripcion":"QUISTE DEL PÁNCREAS"
  },
  {
    "codigo":33093008,
    "descripcion":"INFECCIÓN SIMIANA POR ADENOVIRUS"
  },
  {
    "codigo":424474002,
    "descripcion":"DIFICULTAD PARA AFRONTAR LOS CAMBIOS PUERPERALES"
  },
  {
    "codigo":293402003,
    "descripcion":"REACCIÓN ADVERSA A PREPARADO DE TIAMINA"
  },
  {
    "codigo":129562004,
    "descripcion":"DERMOPATÍA PSICÓGENA"
  },
  {
    "codigo":719386009,
    "descripcion":"INFECCIÓN OCULAR POR PARAMIXOVIRUS AVIAR 1"
  },
  {
    "codigo":94959003,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA NASOFARINGE"
  },
  {
    "codigo":289732000,
    "descripcion":"CONTRACCIONES UTERINAS DOLOROSAS"
  },
  {
    "codigo":224196001,
    "descripcion":"SUBSIDIOS RECIBIDOS"
  },
  {
    "codigo":1141700007,
    "descripcion":"DEMUESTRA CONOCIMIENTO SOBRE CUIDADO DE HERIDA"
  },
  {
    "codigo":93124009,
    "descripcion":"FALTA DE OSIFICACIÓN TIBIAL"
  },
  {
    "codigo":1010628009,
    "descripcion":"HIPERTRICOSIS GENERALIZADA CONGÉNITA LIGADA AL CROMOSOMA X"
  },
  {
    "codigo":1172633003,
    "descripcion":"SÍNDROME DE CAMPTODACTILIA DE GUADALAJARA TIPO 3"
  },
  {
    "codigo":713881001,
    "descripcion":"INFECCIÓN CAUSADA POR MICROSPORIDIA CONCOMITANTE CON INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":1303705005,
    "descripcion":"OSTEOMIELITIS CRÓNICA DE HUESO METATARSIANO DERECHO"
  },
  {
    "codigo":124057005,
    "descripcion":"AMINOÁCIDO POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":25753007,
    "descripcion":"TRASTORNO DEL SUEÑO INDUCIDO POR ANFETAMINAS"
  },
  {
    "codigo":255129009,
    "descripcion":"INFILTRACIÓN MALIGNA DE PLEXO DE NERVIO PERIFÉRICO"
  },
  {
    "codigo":1269102002,
    "descripcion":"TRASTORNO FETAL DEBIDO A TRASTORNO MATERNO DURANTE EL EMBARAZO"
  },
  {
    "codigo":89454001,
    "descripcion":"SÍNDROME DE SHWACHMAN"
  },
  {
    "codigo":449902003,
    "descripcion":"ENCEFALOPATÍA PORTAL SISTÉMICA"
  },
  {
    "codigo":286062004,
    "descripcion":"PLANCHA"
  },
  {
    "codigo":253294001,
    "descripcion":"AURÍCULA DERECHA COMUNICADA CON VENTRÍCULO DE MORFOLOGÍA INDETERMINADA"
  },
  {
    "codigo":185923000,
    "descripcion":"PACIENTE INGRESADO A ESTUDIO CIENTÍFICO"
  },
  {
    "codigo":710211000,
    "descripcion":"NEOPLASIA DE CÉLULAS GIGANTES DE HUESO Y CARTÍLAGO ARTICULAR"
  },
  {
    "codigo":284227002,
    "descripcion":"QUEMADURA DE TOBILLO Y PIE"
  },
  {
    "codigo":251459003,
    "descripcion":"ACTIVIDAD DE FONDO DE BAJA FRECUENCIA"
  },
  {
    "codigo":448067003,
    "descripcion":"RECOARTACIÓN DE AORTA"
  },
  {
    "codigo":56686009,
    "descripcion":"INTOXICACIÓN POR ALFANAFTILTIOUREA"
  },
  {
    "codigo":184088000,
    "descripcion":"PACIENTE AUSENTE DE LA ESCUELA"
  },
  {
    "codigo":216856003,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ÓXIDOS DE NITRÓGENO"
  },
  {
    "codigo":1263597000,
    "descripcion":"MIELITIS DEBIDA A SARCOIDOSIS"
  },
  {
    "codigo":772077005,
    "descripcion":"METABOLIZADOR RÁPIDO DE CYP2B6"
  },
  {
    "codigo":870381005,
    "descripcion":"BOLSA CAPSULAR DE OJO COMPROMETIDA"
  },
  {
    "codigo":313325007,
    "descripcion":"CABEZA DE PÓLIPO"
  },
  {
    "codigo":213186002,
    "descripcion":"FALLA TOTAL DE REIMPLANTE DE PIERNA"
  },
  {
    "codigo":49346003,
    "descripcion":"FRACTURA NO EXPUESTA EN ESTALLIDO DE PISO DE ÓRBITA"
  },
  {
    "codigo":11848221000119103,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE PÁRPADO IZQUIERDO"
  },
  {
    "codigo":113047000,
    "descripcion":"FORMA DE UNA COLONIA BACTERIANA, RIZOIDE"
  },
  {
    "codigo":1163458009,
    "descripcion":"MIASIS OCULAR INTERNA"
  },
  {
    "codigo":735639001,
    "descripcion":"ADOLESCENTE CON LLANTO EXCESIVO"
  },
  {
    "codigo":1360066009,
    "descripcion":"ÁNGULO CERRADO DE OJO IZQUIERDO"
  },
  {
    "codigo":276887004,
    "descripcion":"GRADIENTE ENTRE TEMPERATURA CENTRAL Y PERIFÉRICA"
  },
  {
    "codigo":16845341000119105,
    "descripcion":"GLIOBLASTOMA MULTIFORME PRIMARIO DE TRONCO ENCEFÁLICO"
  },
  {
    "codigo":209516003,
    "descripcion":"FIEBRE RECIDIVANTE DE ÁFRICA DEL NORTE"
  },
  {
    "codigo":406124004,
    "descripcion":"FALTA DE CONCIENCIA"
  },
  {
    "codigo":12908005,
    "descripcion":"OBSTRUCCIÓN URETERAL EXTRÍNSECA"
  },
  {
    "codigo":45676007,
    "descripcion":"PÓLIPO GINGIVAL"
  },
  {
    "codigo":111212009,
    "descripcion":"ARTROPATÍA ASOCIADA CON UNA ENFERMEDAD BACTERIANA"
  },
  {
    "codigo":240449004,
    "descripcion":"LEGIONELOSIS CON COMPROMISO CUTÁNEO"
  },
  {
    "codigo":43841005,
    "descripcion":"LACERACIÓN MODERADA DE HÍGADO SIN HERIDA ABIERTA HACIA CAVIDAD ABDOMINAL"
  },
  {
    "codigo":764737005,
    "descripcion":"CARCINOMA ESCAMOCELULAR DE CUERPO UTERINO"
  },
  {
    "codigo":371521007,
    "descripcion":"TRASTORNO DEL DESARROLLO ÓSEO"
  },
  {
    "codigo":402454000,
    "descripcion":"AMILOIDOSIS SISTÉMICA PRIMARIA ASOCIADA CON DISCRASIA DE CÉLULAS PLASMÁTICAS OCULTA"
  },
  {
    "codigo":74774004,
    "descripcion":"URTICARIA CAUSADA POR FRÍO"
  },
  {
    "codigo":369686008,
    "descripcion":"MARGEN PROXIMAL DE RESECCIÓN QUIRÚRGICA DEL PÁNCREAS, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":236779000,
    "descripcion":"ANOMALÍA CONGÉNITA DEL ESCROTO"
  },
  {
    "codigo":204011002,
    "descripcion":"ESPINA BÍFIDA DORSAL SIN HIDROCEFALIA - CERRADA"
  },
  {
    "codigo":1187051004,
    "descripcion":"SALICILATO POR ENCIMA DE RANGO TERAPÉUTICO"
  },
  {
    "codigo":105707007,
    "descripcion":"ENFERMEDAD CAUSADA POR DRACUNCULOIDEA"
  },
  {
    "codigo":10674871000119105,
    "descripcion":"EDEMA PULMONAR CAUSADO POR VAPORES QUÍMICOS"
  },
  {
    "codigo":12481000175105,
    "descripcion":"TIENE ACCESO A ALCOHOL"
  },
  {
    "codigo":7361000175106,
    "descripcion":"INSUFICIENCIA RESPIRATORIA HIPERCÁPNICA CRÓNICA REAGUDIZADA"
  },
  {
    "codigo":202176004,
    "descripcion":"LUXACIÓN PATOLÓGICA DE ARTICULACIÓN DE HOMBRO"
  },
  {
    "codigo":11795281000119100,
    "descripcion":"LESIÓN TRAUMÁTICA DE VENA BRAQUIOCEFÁLICA DERECHA"
  },
  {
    "codigo":300480006,
    "descripcion":"ESCROTO NORMAL"
  },
  {
    "codigo":12421000132104,
    "descripcion":"INTOXICACIÓN CRÓNICA CAUSADA POR BENCENO"
  },
  {
    "codigo":167573001,
    "descripcion":"CULTIVO DE ORINA: STAPHYLOCOCCUS ALBUS"
  },
  {
    "codigo":1090231000119107,
    "descripcion":"POLINEUROPATÍA DEBIDA A MONONUCLEOSIS INFECCIOSA"
  },
  {
    "codigo":402503301000132107,
    "descripcion":"INFECCIÓN DE STENT PANCREÁTICO"
  },
  {
    "codigo":11303761000119101,
    "descripcion":"FRACTURA NO EXPUESTA DE PISO DE ÓRBITA"
  },
  {
    "codigo":71104009,
    "descripcion":"LESIONES ACRÓMICAS E HIPERCRÓMICAS DE LA PIEL PROVOCADAS POR PINTA"
  },
  {
    "codigo":67434000,
    "descripcion":"DEFICIENCIA DE CITOCROMO - C - OXIDASA"
  },
  {
    "codigo":3733009,
    "descripcion":"EVENTRACIÓN CONGÉNITA DEL ORIFICIO DIAFRAGMÁTICO DERECHO"
  },
  {
    "codigo":724629009,
    "descripcion":"PROBLEMA DE DEDO DE LA MANO"
  },
  {
    "codigo":294975003,
    "descripcion":"ALERGIA A ADENOSINA"
  },
  {
    "codigo":131135005,
    "descripcion":"NIVEL DE ÁCIDO PANTOTÉNICO POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1343551007,
    "descripcion":"RADIOGRAFÍA SIMPLE DE VESÍCULA BILIAR CON CONTRASTE ANORMAL"
  },
  {
    "codigo":196671008,
    "descripcion":"ÚLCERA DUODENAL RECURRENTE"
  },
  {
    "codigo":1145108000,
    "descripcion":"LESIÓN TRAUMÁTICA DEBIDA A AGRESIÓN CON AGUJA PARA INYECCIÓN NO USADA"
  },
  {
    "codigo":293140005,
    "descripcion":"REACCIÓN ADVERSA AL PROPILTIOURACILO"
  },
  {
    "codigo":162068007,
    "descripcion":"SÍNTOMA DE DISTENSIÓN ABDOMINAL"
  },
  {
    "codigo":63764008,
    "descripcion":"INFECCIÓN CAUSADA POR ASPERGILLUS FUMIGATUS"
  },
  {
    "codigo":15727441000119108,
    "descripcion":"ARTROFITO EN ARTICULACIÓN DE MANO DERECHA"
  },
  {
    "codigo":782825008,
    "descripcion":"SÍNDROME DE MICROCEFALIA PRIMARIA, EPILEPSIA Y DIABETES NEONATAL PERMANENTE"
  },
  {
    "codigo":92862000,
    "descripcion":"FUSIÓN ANORMAL CONGÉNITA DEL ISQUION"
  },
  {
    "codigo":125630001,
    "descripcion":"LESIÓN TRAUMÁTICA DEL APÉNDICE ILEOCECAL"
  },
  {
    "codigo":291305008,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR SALBUTAMOL"
  },
  {
    "codigo":289470002,
    "descripcion":"LABIOS MAYORES DE LA VULVA, GRANDES"
  },
  {
    "codigo":254867003,
    "descripcion":"GINANDROBLASTOMA DE OVARIO"
  },
  {
    "codigo":123795004,
    "descripcion":"ERUPCIÓN CUTÁNEA CAUSADA POR CONTACTO CON LARVAS DE ANÉMONA MARINA"
  },
  {
    "codigo":91027008,
    "descripcion":"ENVENENAMIENTO DEBIDO A PICADURA DE ABEJORRO"
  },
  {
    "codigo":285800001,
    "descripcion":"RUPTURA TRAUMÁTICA DEL ESTÓMAGO"
  },
  {
    "codigo":1303443009,
    "descripcion":"LIPOMA DE FILUM TERMINALE AISLADO"
  },
  {
    "codigo":41981000087106,
    "descripcion":"ABRASIÓN DE CONJUNTIVA IZQUIERDA"
  },
  {
    "codigo":47101000087109,
    "descripcion":"FRACTURA TRIMALEOLAR DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":253032007,
    "descripcion":"FEOCROMOCITOMA BENIGNO"
  },
  {
    "codigo":1332541001,
    "descripcion":"MELORREOSTOSIS DE HUESO DE ANTEBRAZO"
  },
  {
    "codigo":251197007,
    "descripcion":"EJE SUPERIOR"
  },
  {
    "codigo":283965008,
    "descripcion":"HEMATOMA DEL CUELLO UTERINO"
  },
  {
    "codigo":447805007,
    "descripcion":"LINFOMA DE CURVATURA MAYOR DEL ESTÓMAGO"
  },
  {
    "codigo":413202007,
    "descripcion":"MUCOSA FRIABLE DE ÓRGANO DEL APARATO DIGESTIVO"
  },
  {
    "codigo":249362007,
    "descripcion":"RINOFARINGE - HALLAZGO"
  },
  {
    "codigo":52754008,
    "descripcion":"POLIMENORREA"
  },
  {
    "codigo":216594008,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ATROPINA"
  },
  {
    "codigo":442300000,
    "descripcion":"ROMBENCEFALOSINAPSIS"
  },
  {
    "codigo":49084001,
    "descripcion":"DERMATITIS CAUSADA POR RADIACIÓN"
  },
  {
    "codigo":1359804002,
    "descripcion":"COLONIZACIÓN CRÓNICA DE TRACTO RESPIRATORIO CAUSADA POR STAPHYLOCOCCUS AUREUS"
  },
  {
    "codigo":810591000000100,
    "descripcion":"PESCETARIANO"
  },
  {
    "codigo":737212004,
    "descripcion":"DIABETES MELLITUS CAUSADA POR SUSTANCIA QUÍMICA"
  },
  {
    "codigo":212924009,
    "descripcion":"CONGELAMIENTO CON NECROSIS TISULAR"
  },
  {
    "codigo":389171005,
    "descripcion":"DISPLASIA DE YUNIS - VARON"
  },
  {
    "codigo":1110111000000108,
    "descripcion":"HIPERTENSIÓN OCULAR SECUNDARIA DEBIDA A UVEÍTIS"
  },
  {
    "codigo":1259665004,
    "descripcion":"DEMENCIA DEBIDA A GLIOSIS SUBCORTICAL PROGRESIVA"
  },
  {
    "codigo":243857008,
    "descripcion":"SITUACIÓN DEL MONITOREO DE EPILEPSIA"
  },
  {
    "codigo":45414006,
    "descripcion":"DEFICIENCIA DE GLUCOCORTICOIDES CON ACALASIA"
  },
  {
    "codigo":405862007,
    "descripcion":"FENOTIPO LE(A-B+)"
  },
  {
    "codigo":830011000,
    "descripcion":"TÓRAX NORMAL"
  },
  {
    "codigo":373094009,
    "descripcion":"FÍSTULA CORONARIA AL VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":1255995002,
    "descripcion":"RUPTURA TRAUMÁTICA DE TENDÓN DE REGIÓN DE MUÑECA"
  },
  {
    "codigo":305723005,
    "descripcion":"ATENDIDO POR CIRUJANO ORTOPÉDICO"
  },
  {
    "codigo":404027007,
    "descripcion":"SCHWANNOMA GLANDULAR"
  },
  {
    "codigo":271120002,
    "descripcion":"AMPOLLA TRAUMÁTICA DE LA PARED ABDOMINAL"
  },
  {
    "codigo":8976003,
    "descripcion":"TENONITIS"
  },
  {
    "codigo":402192007,
    "descripcion":"DERMATITIS ATÓPICA DE CARA"
  },
  {
    "codigo":15703481000119101,
    "descripcion":"CONTRACTURA DE TENDÓN DE AQUILES DERECHO"
  },
  {
    "codigo":236517005,
    "descripcion":"NEFROPATÍA AGUDA POR CADMIO"
  },
  {
    "codigo":70842005,
    "descripcion":"EFECTO TÓXICO DEL ACETATO DE PLOMO"
  },
  {
    "codigo":300218008,
    "descripcion":"LOCALIZACIÓN DE LA VOZ, NORMAL"
  },
  {
    "codigo":103610009,
    "descripcion":"PRESENCIA ANORMAL DE CÉLULAS ENDOMETRIALES EN ESPÉCIMEN OBTENIDO DE MUJER MENOPÁUSICA"
  },
  {
    "codigo":38074009,
    "descripcion":"DEFECTO DE LA GLOBULINA LIGADORA DE CORTISOL"
  },
  {
    "codigo":726202009,
    "descripcion":"DISTENSIÓN DE MÚSCULO INTRÍNSECO DE DEDO DE LA MANO"
  },
  {
    "codigo":429455007,
    "descripcion":"GRANULOMA DE PÁRPADO"
  },
  {
    "codigo":722532002,
    "descripcion":"PERFORACIÓN INTRAUTERINA DE INTESTINO FETAL DEBIDA A OBSTRUCCIÓN INTRALUMINAL INTRAUTERINA"
  },
  {
    "codigo":1148516004,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR ÁCIDO BILIAR Y\/O DERIVADO DE ÁCIDO BILIAR"
  },
  {
    "codigo":296548004,
    "descripcion":"SOBREDOSIS DE IDOXURIDINA"
  },
  {
    "codigo":292878001,
    "descripcion":"REACCIÓN ADVERSA AL FENOL"
  },
  {
    "codigo":1144846003,
    "descripcion":"AUSENCIA DE PELO DE ROSTRO"
  },
  {
    "codigo":302521000119109,
    "descripcion":"ANQUILOSIS DE ARTICULACIÓN DE CADERA IZQUIERDA"
  },
  {
    "codigo":129038003,
    "descripcion":"CAPACIDAD DE LEVANTARSE DE LA SILLA SIN AYUDA"
  },
  {
    "codigo":127203000,
    "descripcion":"LINFADENOPATÍA INGUINAL MEDIAL SUPERIOR"
  },
  {
    "codigo":94435001,
    "descripcion":"NEOPLASIA METASTÁSICA MALIGNA DE HUESO NASAL"
  },
  {
    "codigo":225507001,
    "descripcion":"IMAGEN CORPORAL ALTERADA"
  },
  {
    "codigo":782563005,
    "descripcion":"ALERGIA A COMPUESTO QUE CONTIENE LITIO"
  },
  {
    "codigo":1306851006,
    "descripcion":"MUTACIÓN DE SITIO DE EMPALME"
  },
  {
    "codigo":715192004,
    "descripcion":"ACALASIA IDIOPÁTICA DE ESÓFAGO"
  },
  {
    "codigo":289208006,
    "descripcion":"HALLAZGO RELACIONADO CON LA VIABILIDAD DEL EMBARAZO"
  },
  {
    "codigo":341000124104,
    "descripcion":"HALLAZGO RELACIONADO CON DIÁLISIS PERITONEAL"
  },
  {
    "codigo":90765000,
    "descripcion":"EFECTO TÓXICO DE GAS CLORADO"
  },
  {
    "codigo":92600008,
    "descripcion":"CARCINOMA IN SITU DEL TRACTO GASTROINTESTINAL"
  },
  {
    "codigo":1137506007,
    "descripcion":"DEBILIDAD DE MÚSCULO MASETERO"
  },
  {
    "codigo":709687000,
    "descripcion":"TROMBOSIS VENOSA PROFUNDA CRÓNICA DE VENA PÉLVICA"
  },
  {
    "codigo":414775001,
    "descripcion":"MONOVISIÓN"
  },
  {
    "codigo":285538007,
    "descripcion":"MUEVE LA LENGUA HACIA LOS COSTADOS"
  },
  {
    "codigo":416610007,
    "descripcion":"DISFUNCIÓN DIASTÓLICA DEL VENTRÍCULO DERECHO"
  },
  {
    "codigo":185399004,
    "descripcion":"PACIENTE QUE CONCURRE DOS VECES POR MES"
  },
  {
    "codigo":87095001,
    "descripcion":"CONVULSIÓN OLFATIVA"
  },
  {
    "codigo":283703006,
    "descripcion":"MORDEDURA HUMANA EN EL ANTEBRAZO"
  },
  {
    "codigo":609548005,
    "descripcion":"HIPERSENSIBILIDAD NO ALÉRGICA A ASPARTAMO"
  },
  {
    "codigo":871692005,
    "descripcion":"DISTENSIÓN DE MÚSCULO RECTO ABDOMINAL"
  },
  {
    "codigo":249100007,
    "descripcion":"PRESENTACIÓN DE LAS DOS RODILLAS"
  },
  {
    "codigo":16469741000119106,
    "descripcion":"HIMEN MICROPERFORADO"
  },
  {
    "codigo":707852009,
    "descripcion":"SE REQUIERE MANEJO DE PACIENTE EN INTERNACIÓN"
  },
  {
    "codigo":247265002,
    "descripcion":"CICATRIZ TRANSPARENTE DE LA MEMBRANA TIMPÁNICA"
  },
  {
    "codigo":17889007,
    "descripcion":"EXHUMACIÓN PARA RECUPERACIÓN DE EVIDENCIA"
  },
  {
    "codigo":738785009,
    "descripcion":"ANTÍGENO LEUCOCÍTICO HUMANO B*15:02 DETECTADO"
  },
  {
    "codigo":10626951000119103,
    "descripcion":"FORÚNCULO DE DEDO DE PIE IZQUIERDO"
  },
  {
    "codigo":702347001,
    "descripcion":"OSTEODISPLASIA LIPOMEMBRANOSA POLIQUÍSTICA CON LEUCOENCEFALOPATÍA ESCLEROSANTE"
  },
  {
    "codigo":1259403004,
    "descripcion":"CARCINOMA PRIMARIO DE COLON ASCENDENTE"
  },
  {
    "codigo":735115007,
    "descripcion":"OCLUSIÓN DE ARTERIA PONTINA IZQUIERDA"
  },
  {
    "codigo":210827007,
    "descripcion":"CONTUSIÓN, VENA AXILAR"
  },
  {
    "codigo":733280001,
    "descripcion":"LUXACIÓN TRAUMÁTICA ANTERIOR DE CADERA"
  },
  {
    "codigo":1290336003,
    "descripcion":"RUPTURA DE QUISTE SINOVIAL POPLÍTEO DE RODILLA DERECHA"
  },
  {
    "codigo":12384004,
    "descripcion":"ÚLCERA PÉPTICA CRÓNICA SIN HEMORRAGIA Y SIN PERFORACIÓN PERO CON OBSTRUCCIÓN"
  },
  {
    "codigo":77920006,
    "descripcion":"GANGRENA PULMONAR"
  },
  {
    "codigo":307296008,
    "descripcion":"HEMORRAGIA GASTROINTESTINAL RECURRENTE"
  },
  {
    "codigo":403765001,
    "descripcion":"HEMANGIOMA PLANO EN EL SÍNDROME DE RUBINSTEIN-TAYBI"
  },
  {
    "codigo":370997001,
    "descripcion":"FALLA TESTICULAR PRIMARIA"
  },
  {
    "codigo":766048008,
    "descripcion":"LEUCEMIA MIELOIDE AGUDA Y SÍNDROME MIELODISPLÁSICO RELACIONADO CON RADIACIÓN"
  },
  {
    "codigo":239925001,
    "descripcion":"POLIARTERITIS NODOSA CON COMPROMISO DE ÓRGANO ÚNICO"
  },
  {
    "codigo":698677008,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: QUECHUA"
  },
  {
    "codigo":205322004,
    "descripcion":"DISOSTOSIS RADIOCUBITAL"
  },
  {
    "codigo":41482005,
    "descripcion":"INFORMACIÓN DE UNA SECUENCIA MOLECULAR"
  },
  {
    "codigo":238090007,
    "descripcion":"HIPOLIPIDEMIA"
  },
  {
    "codigo":860682009,
    "descripcion":"EMBOLIA SÉPTICA DEBIDA A EMBARAZO MOLAR Y POSTERIOR A ÉL"
  },
  {
    "codigo":301791008,
    "descripcion":"EXUDADO EN AMÍGDALAS"
  },
  {
    "codigo":432863009,
    "descripcion":"ENFERMEDAD PILONIDAL"
  },
  {
    "codigo":365492004,
    "descripcion":"HALLAZGO RELACIONADO CON LA DISPONIBILIDAD DE CUIDADOR INFORMAL"
  },
  {
    "codigo":16908321000119106,
    "descripcion":"CARCINOMA ESCAMOCELULAR IN SITU DE PIEL DE PÁRPADO INFERIOR IZQUIERDO"
  },
  {
    "codigo":725940006,
    "descripcion":"CIRROSIS HEPÁTICA CAUSADA POR METILDOPA"
  },
  {
    "codigo":299956006,
    "descripcion":"SENSACIÓN NORMAL"
  },
  {
    "codigo":134281001,
    "descripcion":"LEE CHECO"
  },
  {
    "codigo":10901691000119101,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO ACÚSTICO IZQUIERDO"
  },
  {
    "codigo":429193009,
    "descripcion":"ARRUGA FRONTAL"
  },
  {
    "codigo":34142005,
    "descripcion":"GRUPO DE VOZ RONCA - ASPIRADA SUSURRADA - CONTINUA"
  },
  {
    "codigo":296286009,
    "descripcion":"SOBREDOSIS DE SELEGILINA"
  },
  {
    "codigo":32307003,
    "descripcion":"PÓLIPO DE SENO PARANASAL"
  },
  {
    "codigo":359987004,
    "descripcion":"TUMOR DE KRUKENBERG"
  },
  {
    "codigo":10676631000119100,
    "descripcion":"ASMA ALÉRGICA PERSISTENTE MODERADA NO CONTROLADA"
  },
  {
    "codigo":1074071000119102,
    "descripcion":"CONDROCALCINOSIS DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":16052631000119103,
    "descripcion":"TENDINOSIS DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":16006551000119104,
    "descripcion":"GOTA TOFÁCEA CRÓNICA DE MANO DERECHA"
  },
  {
    "codigo":10640791000119105,
    "descripcion":"ÚLCERA CRÓNICA DE PIEL DE PANTORRILLA"
  },
  {
    "codigo":336791000119106,
    "descripcion":"QUISTE PARASITARIO DE RETINA"
  },
  {
    "codigo":306071000119103,
    "descripcion":"TRASTORNO DE LIGAMENTO DE PIE DERECHO"
  },
  {
    "codigo":16434071000119108,
    "descripcion":"CON RIESGO DE ENFERMEDAD CARDIOVASCULAR"
  },
  {
    "codigo":91031000119108,
    "descripcion":"CONDROSARCOMA PRIMARIO DE HUESO DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":295831000119109,
    "descripcion":"OSTEOMIELITIS CRÓNICA DE TOBILLO CON TRAYECTO FISTULOSO CON DRENAJE"
  },
  {
    "codigo":341911000119109,
    "descripcion":"BLEFAROCALASIA DE PÁRPADO IZQUIERDO"
  },
  {
    "codigo":292616008,
    "descripcion":"REACCIÓN ADVERSA DE TEOFILINATO DE COLINA"
  },
  {
    "codigo":16034711000119106,
    "descripcion":"HIPERTROFIA DE HUESO DE CÚBITO IZQUIERDO"
  },
  {
    "codigo":16027031000119107,
    "descripcion":"MASA DE PARTES BLANDAS DE AMBOS MIEMBROS INFERIORES"
  },
  {
    "codigo":142231000119108,
    "descripcion":"INCONTINENCIA FECAL CON DEFECACIÓN INCOMPLETA"
  },
  {
    "codigo":308631000119108,
    "descripcion":"GANGLIÓN DE CADERA IZQUIERDA"
  },
  {
    "codigo":1086871000119109,
    "descripcion":"HIRUDINIASIS EXTERNA"
  },
  {
    "codigo":1091991000119109,
    "descripcion":"OTORRAGIA DEL OÍDO DERECHO"
  },
  {
    "codigo":126941005,
    "descripcion":"HEMORRAGIA SUBDURAL INTRACRANEAL DEBIDA A TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":28637003,
    "descripcion":"NEFRITIS TUBULOINTERSTICIAL AGUDA"
  },
  {
    "codigo":94173006,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL CUERPO AÓRTICO"
  },
  {
    "codigo":285276000,
    "descripcion":"PENSAMIENTOS OPTIMISTAS"
  },
  {
    "codigo":449116007,
    "descripcion":"VÁLVULA AÓRTICA TRICÚSPIDE PERO FUNCIONALMENTE BICÚSPIDE"
  },
  {
    "codigo":23132008,
    "descripcion":"AMILOIDOSIS CON AMILOIDE DE CADENA LIVIANA"
  },
  {
    "codigo":88668007,
    "descripcion":"DISOCIACIÓN MOLECULAR DISMINUIDA"
  },
  {
    "codigo":312371005,
    "descripcion":"BRONQUITIS INFECCIOSA AGUDA"
  },
  {
    "codigo":283441003,
    "descripcion":"CORTE EN PRIMER DEDO DEL PIE"
  },
  {
    "codigo":1332017005,
    "descripcion":"OSTEÓLISIS DE RADIO"
  },
  {
    "codigo":16665071000119101,
    "descripcion":"FRACTURA EXPUESTA DE ARCO CIGOMÁTICO DERECHO"
  },
  {
    "codigo":840497008,
    "descripcion":"DEFECTO DEL TABIQUE AURICULOVENTRICULAR CON COMPONENTES AURICULAR Y VENTRICULAR CON VÁLVULA AURICULOVENTRICULAR COMÚN DESEQUILIBRADA HACIA EL VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":248838002,
    "descripcion":"SANGRADO DEL PEZÓN"
  },
  {
    "codigo":52230004,
    "descripcion":"DERMATITIS PSORIASIFORME"
  },
  {
    "codigo":707590006,
    "descripcion":"CARCINOMA PRIMARIO DE CÉLULAS ACINARES DE OROFARINGE"
  },
  {
    "codigo":247003001,
    "descripcion":"CONTENIDOS ANORMALES EN LA CÁMARA ANTERIOR"
  },
  {
    "codigo":1197275006,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS PRIMARIO DE TROMPA DE FALOPIO"
  },
  {
    "codigo":1073801000119100,
    "descripcion":"ARTRITIS REUMATOIDE DE CADERA DERECHA"
  },
  {
    "codigo":441776007,
    "descripcion":"COBALTO EN ESPÉCIMEN DE SANGRE POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":81328008,
    "descripcion":"PREDOMINIO FÚNDICO DE LA CONTRACCIÓN UTERINA"
  },
  {
    "codigo":212400009,
    "descripcion":"LESIÓN DEL CUERO CABELLUDO"
  },
  {
    "codigo":13957003,
    "descripcion":"FÍSTULA AORTOCAVA"
  },
  {
    "codigo":276101003,
    "descripcion":"INFANCIA DESDICHADA"
  },
  {
    "codigo":1290074000,
    "descripcion":"TUMOR NEUROENDOCRINO BIEN DIFERENCIADO DE HÍGADO"
  },
  {
    "codigo":700250006,
    "descripcion":"FIBROSIS PULMONAR IDIOPÁTICA"
  },
  {
    "codigo":403503008,
    "descripcion":"ANETODERMIA ASOCIADA CON LUPUS ERITEMATOSO"
  },
  {
    "codigo":303364001,
    "descripcion":"INCAPAZ DE EMPUJAR"
  },
  {
    "codigo":90761000119106,
    "descripcion":"ESTADIO 5 DE ENFERMEDAD RENAL CRÓNICA DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":301529000,
    "descripcion":"INCAPAZ DE ENTRAR EN LA BAÑERA"
  },
  {
    "codigo":203225003,
    "descripcion":"INFECCIÓN DE RADIO"
  },
  {
    "codigo":235993005,
    "descripcion":"COLECCIÓN INTRABDOMINAL"
  },
  {
    "codigo":1348270000,
    "descripcion":"CANTIDAD MODERADA DE SANGRE NO HEMOLIZADA DETECTADA EN ORINA MEDIANTE TIRA REACTIVA"
  },
  {
    "codigo":6617009,
    "descripcion":"DOLOR REFERIDO"
  },
  {
    "codigo":168622002,
    "descripcion":"RADIOGRAFÍA SIMPLE DE CODO ANORMAL"
  },
  {
    "codigo":70318002,
    "descripcion":"ANOMALÍA CONGÉNITA DEL PENE"
  },
  {
    "codigo":234158006,
    "descripcion":"SÍNDROME VASCULAR ESPECÍFICO MIXTO"
  },
  {
    "codigo":365230008,
    "descripcion":"ADAPTACIÓN EMOCIONAL - HALLAZGO"
  },
  {
    "codigo":823982009,
    "descripcion":"NERVIO FACIAL INTACTO"
  },
  {
    "codigo":363395000,
    "descripcion":"NEOPLASIA MALIGNA DE VALÉCULA"
  },
  {
    "codigo":232323001,
    "descripcion":"TINITUS POR EMISIÓN OTOACÚSTICA ESPONTÁNEA"
  },
  {
    "codigo":723843005,
    "descripcion":"CONDROSARCOMA PRIMARIO DE HUESO DE EXTREMIDAD"
  },
  {
    "codigo":166787006,
    "descripcion":"GAMMAGLOBULINA SÉRICA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":296024000,
    "descripcion":"SOBREDOSIS DE CLORMEZANONA"
  },
  {
    "codigo":1112003,
    "descripcion":"TRASTORNO DEGENERATIVO DE PÁRPADO"
  },
  {
    "codigo":230488004,
    "descripcion":"HIPERSOMNIA DE ORIGEN NO ORGÁNICO"
  },
  {
    "codigo":722008003,
    "descripcion":"HIPOMAGNESEMIA AUTOSÓMICA DOMINANTE AISLADA TIPO GLAUDEMANS"
  },
  {
    "codigo":263256004,
    "descripcion":"FRACTURAS MÚLTIPLES DEL ESTERNÓN"
  },
  {
    "codigo":427096007,
    "descripcion":"HALLAZGO RELACIONADO CON LA RECONSTITUCIÓN INMUNOLÓGICA"
  },
  {
    "codigo":359725000,
    "descripcion":"ENFERMEDAD DE VON WILLEBRAND HEREDITARIA TIPO 2M"
  },
  {
    "codigo":294189007,
    "descripcion":"ALERGIA A ADHESIVO TISULAR DE USO QUIRÚRGICO"
  },
  {
    "codigo":95746006,
    "descripcion":"ABSCESO DE LA CONJUNTIVA"
  },
  {
    "codigo":62978008,
    "descripcion":"AUTOSENSIBILIDAD"
  },
  {
    "codigo":224983001,
    "descripcion":"REGRESIÓN A TRAVÉS DE LA ACTUALIZACIÓN"
  },
  {
    "codigo":126679002,
    "descripcion":"NEOPLASIA DE SENO ESFENOIDAL"
  },
  {
    "codigo":716503004,
    "descripcion":"NO COMPRENDE EL LENGUAJE VERBAL"
  },
  {
    "codigo":1306327007,
    "descripcion":"CARCINOMA IN SITU DE TEJIDO ECTÓPICO DE MAMA"
  },
  {
    "codigo":93911008,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE MÚSCULO DEL TRONCO"
  },
  {
    "codigo":92076000,
    "descripcion":"NEOPLASIA BENIGNA DE COLON DESCENDENTE"
  },
  {
    "codigo":714668003,
    "descripcion":"CONFLICTO ENTRE RECOMENDACIÓN DE ATENCIÓN MÉDICA Y CREENCIA RELIGIOSA"
  },
  {
    "codigo":339031000119100,
    "descripcion":"MIOSITIS DE ÓRBITA IZQUIERDA"
  },
  {
    "codigo":288684006,
    "descripcion":"INCAPAZ DE PRESUPONER EN UNA CONVERSACIÓN"
  },
  {
    "codigo":1204353000,
    "descripcion":"INFECCIÓN DE PLACA DE FIJACIÓN ÓSEA"
  },
  {
    "codigo":286849002,
    "descripcion":"INCAPAZ DE PLANIFICAR"
  },
  {
    "codigo":15930301000119107,
    "descripcion":"EDEMA DE PAPILA DE OJO DERECHO"
  },
  {
    "codigo":90241004,
    "descripcion":"PAPILITIS RENAL NECROSANTE"
  },
  {
    "codigo":1076311000119102,
    "descripcion":"BURSITIS ISQUIOGLÚTEA DE CADERA IZQUIERDA"
  },
  {
    "codigo":252246005,
    "descripcion":"PSEUDOXANTOMA ELÁSTICO"
  },
  {
    "codigo":874838008,
    "descripcion":"CUERPO EXTRAÑO EN MEMBRANA MUCOSA GINGIVAL"
  },
  {
    "codigo":283179001,
    "descripcion":"CUERPO EXTRAÑO METÁLICO EN PIERNA"
  },
  {
    "codigo":86571001,
    "descripcion":"HALLAZGO RELACIONADO CON LA MADURACIÓN DE LA SEXUALIDAD"
  },
  {
    "codigo":250411006,
    "descripcion":"HALLAZGO RELACIONADO CON LA MÉDULA ÓSEA"
  },
  {
    "codigo":447019006,
    "descripcion":"USA ANTEOJOS BIFOCALES"
  },
  {
    "codigo":248576001,
    "descripcion":"SISEO RESPIRATORIO"
  },
  {
    "codigo":1231616002,
    "descripcion":"ESTENOSIS DE CANALÍCULO LAGRIMAL CAUSADO POR FÁRMACO"
  },
  {
    "codigo":1004075009,
    "descripcion":"CONTRACTURA EN FLEXIÓN DE ARTICULACIÓN DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":445184006,
    "descripcion":"HALLAZGO RELACIONADO CON EL LÍQUIDO CEFALORRAQUÍDEO"
  },
  {
    "codigo":19200009,
    "descripcion":"PRIVACIÓN PSICOSOCIAL"
  },
  {
    "codigo":1197013001,
    "descripcion":"TUBERCULOSIS GINGIVAL"
  },
  {
    "codigo":79231000,
    "descripcion":"HIDROTÓRAX"
  },
  {
    "codigo":1258879002,
    "descripcion":"HEMORRAGIA INTRACRANEAL POSTERIOR A ADMINISTRACIÓN DE AGENTE TROMBOLÍTICO"
  },
  {
    "codigo":767359002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA PONERSE DE PIE"
  },
  {
    "codigo":110164000,
    "descripcion":"ABRASIÓN DE PIEL DE FRENTE"
  },
  {
    "codigo":208468003,
    "descripcion":"FRACTURA EXPUESTA DE FALANGE PROXIMAL DE PULGAR, BASE"
  },
  {
    "codigo":370473000,
    "descripcion":"ARTROGRIPOSIS CONGÉNITA CAUSADA POR TERATÓGENO"
  },
  {
    "codigo":403241000,
    "descripcion":"COLOR CONSTITUTIVO DE LA PIEL, MORENO OSCURO"
  },
  {
    "codigo":306772009,
    "descripcion":"NO DELUTE SÓLIDOS"
  },
  {
    "codigo":108329005,
    "descripcion":"HALLAZGO EN EL CONTEXTO SOCIAL"
  },
  {
    "codigo":204798002,
    "descripcion":"DIVERTÍCULO CONGÉNITO DE CONDUCTO BILIAR"
  },
  {
    "codigo":1351678003,
    "descripcion":"AGAMMAGLOBULINEMIA AUTOSÓMICA RECESIVA DEBIDA A DEFICIENCIA DE BETA INMUNOGLOBULINA"
  },
  {
    "codigo":237566004,
    "descripcion":"SÍNDROME DE DEFICIENCIA CONGÉNITA DE YODO DE TIPO NEUROLÓGICO"
  },
  {
    "codigo":235731000,
    "descripcion":"ESTEATORREA POSPROCEDIMIENTO"
  },
  {
    "codigo":399571002,
    "descripcion":"TUMOR OVÁRICO, IMPLANTACIÓN EPIPLOICA, NO CORRESPONDE"
  },
  {
    "codigo":301267003,
    "descripcion":"MATIDEZ HEPÁTICA A LA PERCUSIÓN, NORMAL"
  },
  {
    "codigo":202963006,
    "descripcion":"RUPTURA ATRAUMÁTICA DE TENDÓN ROTULIANO"
  },
  {
    "codigo":233896004,
    "descripcion":"TAQUICARDIA POR REENTRADA DEL NÓDULO AURICULOVENTRICULAR"
  },
  {
    "codigo":725416005,
    "descripcion":"MIOCARDIOPATÍA CIRRÓTICA"
  },
  {
    "codigo":364968006,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA MOVER EL PALADAR BLANDO"
  },
  {
    "codigo":70056008,
    "descripcion":"DEFECTO EN ARTICULACIÓN DEL HABLA"
  },
  {
    "codigo":363133001,
    "descripcion":"TRASTORNO GENÉTICO DE EXTREMIDAD"
  },
  {
    "codigo":461437001,
    "descripcion":"ABSCESO EN LOCALIZACIÓN DE DERIVACIÓN ARTERIAL SISTÉMICA - PULMONAR"
  },
  {
    "codigo":199293005,
    "descripcion":"ENFERMEDAD DEL APARATO RESPIRATORIO QUE COMPLICA EMBARAZO, PARTO Y\/O PUERPERIO"
  },
  {
    "codigo":723581006,
    "descripcion":"SÍNDROME DE SINDACTILIA, TELECANTO Y MALFORMACIONES ANOGENITALES Y RENALES"
  },
  {
    "codigo":230226000,
    "descripcion":"TRASTORNO SISTÉMICO DEL SISTEMA NERVIOSO"
  },
  {
    "codigo":232061009,
    "descripcion":"CEGUERA NOCTURNA ESTABLE CONGÉNITA"
  },
  {
    "codigo":33618002,
    "descripcion":"CARDITIS MENINGOCÓCICA"
  },
  {
    "codigo":295762003,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE PACLITAXEL"
  },
  {
    "codigo":721746001,
    "descripcion":"MENINGITIS CAUSADA POR STREPTOCOCCUS AGALACTIAE"
  },
  {
    "codigo":197458008,
    "descripcion":"PANCREATITIS RECURRENTE AGUDA"
  },
  {
    "codigo":719911000,
    "descripcion":"SÍNDROME DE TRICODISPLASIA CON AMELOGÉNESIS IMPERFECTA"
  },
  {
    "codigo":457767003,
    "descripcion":"DEGENERACIÓN MIXOMATOSA DE VALVA DE VÁLVULA AURICULOVENTRICULAR IZQUIERDA (MORFOLÓGICAMENTE NO MITRAL)"
  },
  {
    "codigo":293927004,
    "descripcion":"ALERGIA A FLUSPIRILENO"
  },
  {
    "codigo":95484004,
    "descripcion":"PIGMENTACIÓN CONGÉNITA DEL CRISTALINO"
  },
  {
    "codigo":783612007,
    "descripcion":"RETINOPATÍA ANULAR EXTERNA AGUDA"
  },
  {
    "codigo":292092008,
    "descripcion":"REACCIÓN ADVERSA A UNA SUSTANCIA DE USO DIAGNÓSTICO"
  },
  {
    "codigo":191953002,
    "descripcion":"DISNEA PSICÓGENA"
  },
  {
    "codigo":290257002,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR FLURBIPROFENO"
  },
  {
    "codigo":880081006,
    "descripcion":"SÍNDROME DE DELECIÓN 12Q15"
  },
  {
    "codigo":11810341000119108,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DE CADERA Y MUSLO IZQUIERDOS"
  },
  {
    "codigo":93649009,
    "descripcion":"MELANOMA MALIGNO DE PIEL DE MUSLO"
  },
  {
    "codigo":288422004,
    "descripcion":"DIFICULTAD PARA ENHEBRAR UNA AGUJA"
  },
  {
    "codigo":419494007,
    "descripcion":"ESOTROPÍA ACOMODATIVA"
  },
  {
    "codigo":450427002,
    "descripcion":"EQUIMOSIS CUTÁNEAS PERINATALES"
  },
  {
    "codigo":188283009,
    "descripcion":"NEOPLASIA MALIGNA DEL CUERPO ESTRIADO"
  },
  {
    "codigo":284752001,
    "descripcion":"DAÑO DE HERIDAS PROPIAS INFLIGIDO POR EL PACIENTE"
  },
  {
    "codigo":22608008,
    "descripcion":"CUERPO EXTRAÑO EN BRONQUIOLOS"
  },
  {
    "codigo":250149003,
    "descripcion":"HALLAZGO RELACIONADO CON LA SUELA DEL CALZADO"
  },
  {
    "codigo":282917003,
    "descripcion":"DIFICULTAD PARA TOMAR ASIENTO"
  },
  {
    "codigo":53541006,
    "descripcion":"RONQUIDO SONORO"
  },
  {
    "codigo":248314009,
    "descripcion":"HALLAZGO RELACIONADO CON LA PÉRDIDA DE GRASA CORPORAL"
  },
  {
    "codigo":82639001,
    "descripcion":"SÍNDROME DE TENSIÓN PREMENSTRUAL"
  },
  {
    "codigo":703396000,
    "descripcion":"COMBINACIÓN DE DESFIBRILADOR CARDÍACO INTERNO Y MARCAPASOS IN SITU"
  },
  {
    "codigo":1293220001,
    "descripcion":"HIPERACTIVACIÓN MELANOCÍTICA"
  },
  {
    "codigo":768932000,
    "descripcion":"COLOBOMA DE COROIDES Y RETINA"
  },
  {
    "codigo":48036004,
    "descripcion":"ABSCESO HEPÁTICO PIOGÉNICO"
  },
  {
    "codigo":211876005,
    "descripcion":"CORROSIÓN DE SEGUNDO GRADO DE HOMBRO Y EXTREMIDAD SUPERIOR, EXCEPTO MUÑECA Y MANO"
  },
  {
    "codigo":15268006,
    "descripcion":"PRESENCIA ANORMAL DE GALACTOSA"
  },
  {
    "codigo":373881006,
    "descripcion":"INSATISFACTORIO PARA EVALUACIÓN POR FALTA DE IDENTIFICACIÓN DEL PACIENTE EN EL ESPÉCIMEN Y\/O EN LA SOLICITUD DE ESTUDIO"
  },
  {
    "codigo":372046001,
    "descripcion":"PRUEBA DE TOLERANCIA A LA GLUCOSA DURANTE EMBARAZO, PARTO Y PUERPERIO FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":47721000087104,
    "descripcion":"FRACTURA DE NOVENA COSTILLA IZQUIERDA"
  },
  {
    "codigo":109902004,
    "descripcion":"MENINGITIS PURULENTA AGUDA"
  },
  {
    "codigo":208206004,
    "descripcion":"RUPTURA TOTAL EXPUESTA DE LA ARTICULACIÓN SACROILÍACA"
  },
  {
    "codigo":404814007,
    "descripcion":"TROMBOSIS ESPONTÁNEA DE FÍSTULA ARTERIOVENOSA"
  },
  {
    "codigo":239139000,
    "descripcion":"COLAGENOMA CUTÁNEO FAMILIAR"
  },
  {
    "codigo":1254947002,
    "descripcion":"SÍNDROME DE GRISCELLI TIPO 3"
  },
  {
    "codigo":362594291000119104,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS IN SITU DE PIEL DE AMBOS PIES"
  },
  {
    "codigo":75299005,
    "descripcion":"PARÁLISIS ESPINAL ESPÁSTICA SIFILÍTICA"
  },
  {
    "codigo":402979005,
    "descripcion":"INFECCIÓN CUTÁNEA POR MYCOBACTERIUM AVIUM INTRACELLULARE"
  },
  {
    "codigo":9763007,
    "descripcion":"SIBILANCIAS ESPIRATORIAS"
  },
  {
    "codigo":237304000,
    "descripcion":"ISOINMUNIZACIÓN POR GRUPO SANGUÍNEO LEWIS DURANTE EL EMBARAZO"
  },
  {
    "codigo":1081331000119105,
    "descripcion":"OSTEOSARCOMA PRIMARIO DE HUESO DE PIE DERECHO"
  },
  {
    "codigo":42531007,
    "descripcion":"MICROINFARTO CARDÍACO"
  },
  {
    "codigo":73464005,
    "descripcion":"ANQUILOSIS DE ARTICULACIÓN DE LA REGIÓN PÉLVICA"
  },
  {
    "codigo":301005000,
    "descripcion":"CICATRIZACIÓN PLEURAL"
  },
  {
    "codigo":366541000,
    "descripcion":"AMPLITUD DE MOVIMIENTO ACTIVO DE PRONACIÓN DE LA MUÑECA - HALLAZGO"
  },
  {
    "codigo":169933005,
    "descripcion":"PUNTAJE DE APGAR A LOS 10 MINUTOS = 10"
  },
  {
    "codigo":268237006,
    "descripcion":"ESTRECHEZ VALVULAR URETRAL CONGÉNITA"
  },
  {
    "codigo":233634002,
    "descripcion":"BRONQUIECTASIA POSTRASPLANTE PULMONAR"
  },
  {
    "codigo":725154004,
    "descripcion":"HERIDA DE REGIÓN AXILAR"
  },
  {
    "codigo":299170005,
    "descripcion":"AMPLITUD DE ABDUCCIÓN PASIVA DEL PULGAR DISMINUIDA"
  },
  {
    "codigo":102562008,
    "descripcion":"EDEMA DE CODO"
  },
  {
    "codigo":69794009,
    "descripcion":"INFECCIÓN CAUSADA POR SHIGELLA DEL GRUPO D"
  },
  {
    "codigo":231799005,
    "descripcion":"PIEL SARCOIDEA PALPEBRAL"
  },
  {
    "codigo":197196000,
    "descripcion":"ADHERENCIAS PERIAPENDICULARES"
  },
  {
    "codigo":16838951000119100,
    "descripcion":"EXACERBACIÓN AGUDA DE INSUFICIENCIA CARDÍACA CONGESTIVA CRÓNICA DERECHA"
  },
  {
    "codigo":262732007,
    "descripcion":"SECCIÓN PARCIAL DE LA RAÍZ DE NERVIO SACRO"
  },
  {
    "codigo":721484008,
    "descripcion":"SÍNDROME DE BROWN-SEQUARD AL NIVEL DEL TERCER SEGMENTO DORSAL"
  },
  {
    "codigo":719649004,
    "descripcion":"SÍNDROME DE MICRODELECIÓN 1Q44"
  },
  {
    "codigo":228129005,
    "descripcion":"NIÑO BAJO PROTECCIÓN POLICIAL"
  },
  {
    "codigo":129825007,
    "descripcion":"HALLAZGO RELACIONADO CON LA SUPERVISIÓN DE LA ATENCIÓN MÉDICA"
  },
  {
    "codigo":293665008,
    "descripcion":"ALERGIA A TRISILICATO DE MAGNESIO"
  },
  {
    "codigo":1078262001,
    "descripcion":"AGENESIA DE EPÍFISIS DE FALANGE MEDIA DE SEGUNDO DEDO DE PIE"
  },
  {
    "codigo":717814004,
    "descripcion":"ANQUILOSIS GLOSOPALATINA"
  },
  {
    "codigo":816118005,
    "descripcion":"EXAGERACIÓN DE REFLEJO BICIPITAL"
  },
  {
    "codigo":224459001,
    "descripcion":"EN LICENCIA POR ENFERMEDAD EN EL TRABAJO"
  },
  {
    "codigo":879819002,
    "descripcion":"DESPROPORCIÓN FETOPÉLVICA POR TERATOMA SACRO FETAL"
  },
  {
    "codigo":291111000119105,
    "descripcion":"MONOPLEJÍA DE MIEMBRO SUPERIOR DERECHO NO DOMINANTE DEBIDA A ACCIDENTE CEREBROVASCULAR Y POSTERIOR A ÉL"
  },
  {
    "codigo":93387008,
    "descripcion":"ESTENOSIS CONGÉNITA DE ESTÓMAGO"
  },
  {
    "codigo":26016002,
    "descripcion":"NEMATODIASIS CEFALORRAQUÍDEA"
  },
  {
    "codigo":124320005,
    "descripcion":"DEFICIENCIA DE ERITRITOL CINASA"
  },
  {
    "codigo":15747521000119100,
    "descripcion":"MASA DE PARTES BLANDAS DE AMBOS MIEMBROS SUPERIORES"
  },
  {
    "codigo":394709441000119100,
    "descripcion":"ATRAPAMIENTO DE MÚSCULO RECTO INTERNO DE OJO DERECHO"
  },
  {
    "codigo":24181002,
    "descripcion":"APLASIA DE TIMO CON INMUNODEFICIENCIA"
  },
  {
    "codigo":1269365007,
    "descripcion":"CRISIS EPILÉPTICA CLÓNICA CON ALTERACIÓN DE CONCIENCIA DE INICIO FOCAL"
  },
  {
    "codigo":251722000,
    "descripcion":"ÁNGULO ABIERTO"
  },
  {
    "codigo":448330004,
    "descripcion":"ANEURISMA DE TABIQUE MUSCULAR"
  },
  {
    "codigo":284490008,
    "descripcion":"HALLAZGO RELACIONADO CON CONDUCTAS COMPLEJAS Y SOCIALES"
  },
  {
    "codigo":774175000,
    "descripcion":"DISFUNCIÓN DEL MÚSCULO OBLICUO INFERIOR DEL OJO DERECHO"
  },
  {
    "codigo":446495002,
    "descripcion":"QUISTE EPENDIMARIO DE MENINGES ESPINALES"
  },
  {
    "codigo":53279002,
    "descripcion":"PTOSIS MIOGÉNICA"
  },
  {
    "codigo":315423002,
    "descripcion":"NACIDO EN ESTONIA"
  },
  {
    "codigo":282655006,
    "descripcion":"NO TRANSFIERE PESO"
  },
  {
    "codigo":20511007,
    "descripcion":"FRACTURA DE MANO"
  },
  {
    "codigo":346561000119105,
    "descripcion":"ABSCESO DE CÓRNEA DE AMBOS OJOS"
  },
  {
    "codigo":18676001,
    "descripcion":"AFRONTAMIENTO FAMILIAR INEFICAZ: INCAPACITANTE"
  },
  {
    "codigo":1003551006,
    "descripcion":"AGENESIA DE BAZO"
  },
  {
    "codigo":248052004,
    "descripcion":"RECHAZO ESCOLAR"
  },
  {
    "codigo":47774001,
    "descripcion":"OSTEOMALACIA INDUCIDA POR DROGAS ANTICONVULSIVANTES"
  },
  {
    "codigo":735902004,
    "descripcion":"LUXACIÓN TRAUMÁTICA DE ARTICULACIÓN DEL TRONCO"
  },
  {
    "codigo":440990006,
    "descripcion":"MYCOPLASMA PNEUMONIAE PRESENTE"
  },
  {
    "codigo":1260190007,
    "descripcion":"DISFUNCIÓN DIAFRAGMÁTICA INDUCIDA POR VENTILACIÓN MECÁNICA"
  },
  {
    "codigo":703134008,
    "descripcion":"HIPOPLASIA DE ESMALTE DENTAL DEBIDA A SÍFILIS CONGÉNITA"
  },
  {
    "codigo":111475002,
    "descripcion":"NEUROSIS"
  },
  {
    "codigo":209779002,
    "descripcion":"RUPTURA DE TENDÓN DEL PLANO FEMORAL DE LA CORVA"
  },
  {
    "codigo":45939007,
    "descripcion":"DESIGUALDAD EN LA LONGITUD DE LAS PIERNAS"
  },
  {
    "codigo":175176000,
    "descripcion":"TRASTORNO GENITOURINARIO AGUDO"
  },
  {
    "codigo":207944000,
    "descripcion":"FRACTURA NO EXPUESTA DE VÉRTEBRA DORSAL, ARCO POSTERIOR"
  },
  {
    "codigo":109640004,
    "descripcion":"DESVIACIÓN DE LA APERTURA MANDIBULAR"
  },
  {
    "codigo":240712006,
    "descripcion":"INTERTRIGO SUBMAMARIO"
  },
  {
    "codigo":76872006,
    "descripcion":"ENFERMEDAD POR EL VIRUS CHAGRES"
  },
  {
    "codigo":271645000,
    "descripcion":"PRESIÓN ARTERIAL NO REGISTRABLE"
  },
  {
    "codigo":75037000,
    "descripcion":"PULPITIS CRÓNICA"
  },
  {
    "codigo":238877001,
    "descripcion":"MILIUM COLOIDAL JUVENIL"
  },
  {
    "codigo":402717008,
    "descripcion":"PÉNFIGO POR INMUNOGLOBULINA A"
  },
  {
    "codigo":237042003,
    "descripcion":"PERIHEPATITIS GONOCÓCICA"
  },
  {
    "codigo":38599001,
    "descripcion":"DESPRENDIMIENTO DE RETINA SEROSO"
  },
  {
    "codigo":40434009,
    "descripcion":"ORINA DISPÉPTICA"
  },
  {
    "codigo":1285618009,
    "descripcion":"HEMATOMA DE HOMBRO"
  },
  {
    "codigo":726727003,
    "descripcion":"DISCAPACIDAD INTELECTUAL LIGADA AL CROMOSOMA X TIPO HEDERA"
  },
  {
    "codigo":202439008,
    "descripcion":"TUMOR TENOSINOVIAL DE CÉLULAS GIGANTES DIFUSO DE ARTICULACIÓN METACARPOFALÁNGICA"
  },
  {
    "codigo":366279009,
    "descripcion":"HALLAZGO RELACIONADO CON CONTROL DE VEJIGA URINARIA"
  },
  {
    "codigo":397212007,
    "descripcion":"TIPO DE ESPÉCIMEN NO ESPECIFICADO"
  },
  {
    "codigo":298908008,
    "descripcion":"AMPLITUD DE SUPINACIÓN PASIVA DE CODO NORMAL"
  },
  {
    "codigo":724892008,
    "descripcion":"DISTENSIÓN DE TENDÓN DE REGIÓN LUMBAR"
  },
  {
    "codigo":460913001,
    "descripcion":"ARTERIA COLATERAL QUE DERIVA EL FLUJO SISTÉMICO HACIA ARTERIA CORONARIA"
  },
  {
    "codigo":349071000119101,
    "descripcion":"DESTELLOS LUMINOSOS DEL HUMOR VÍTREO EN AMBOS OJOS"
  },
  {
    "codigo":231537008,
    "descripcion":"AGNOSIA CONGÉNITA"
  },
  {
    "codigo":33094002,
    "descripcion":"TRAQUEOCELE"
  },
  {
    "codigo":721222007,
    "descripcion":"SÍNDROME DE ENFERMEDAD DE HIRSCHSPRUNG CON BRAQUIDACTILIA TIPO D"
  },
  {
    "codigo":719387000,
    "descripcion":"CAPAZ DE COMPRENDER INSTRUCCIONES DE UNA SOLA PALABRA"
  },
  {
    "codigo":295238009,
    "descripcion":"SOBREDOSIS DE FENBUFÉN"
  },
  {
    "codigo":29424000,
    "descripcion":"BRONQUIOLECTASIA"
  },
  {
    "codigo":129563009,
    "descripcion":"OSTEOPERIOSTITIS REUMATOIDE"
  },
  {
    "codigo":160496001,
    "descripcion":"ADOPTADO"
  },
  {
    "codigo":62192003,
    "descripcion":"DIPROSOPO"
  },
  {
    "codigo":293403008,
    "descripcion":"REACCIÓN ADVERSA AL ÁCIDO ASCÓRBICO"
  },
  {
    "codigo":10670991000119106,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN EN CADERA DERECHA NO ESTADIFICABLE"
  },
  {
    "codigo":94960008,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE HUESO NAVICULAR DE PIE"
  },
  {
    "codigo":291568009,
    "descripcion":"INTOXICACIÓN POR CEFAZOLINA"
  },
  {
    "codigo":420805002,
    "descripcion":"CÓRNEA VERTICILLATA"
  },
  {
    "codigo":15723561000119101,
    "descripcion":"GANGLIÓN DE AMBAS RODILLAS"
  },
  {
    "codigo":93125005,
    "descripcion":"FALTA DE OSIFICACIÓN DEL ANILLO TIMPÁNICO"
  },
  {
    "codigo":224197005,
    "descripcion":"NO RECIBE TODOS LOS SUBSIDIOS CORRESPONDIENTES"
  },
  {
    "codigo":289733005,
    "descripcion":"CONTRACCIÓN UTERINA PREMATURA"
  },
  {
    "codigo":60357009,
    "descripcion":"PERICARDITIS FIBRINOSA"
  },
  {
    "codigo":418970005,
    "descripcion":"PUPILAS REDONDAS, SIMÉTRICAS Y REACTIVAS A LA LUZ"
  },
  {
    "codigo":1303706006,
    "descripcion":"GLAUCOMA DE OJO DERECHO DEBIDO A NEOPLASIA INTRAOCULAR"
  },
  {
    "codigo":253295000,
    "descripcion":"COMUNICACIÓN VENTRICULOARTERIAL ANORMAL"
  },
  {
    "codigo":1172634009,
    "descripcion":"ENFERMEDAD DE CHARCOT-MARIE-TOOTH AUTOSÓMICA DOMINANTE TIPO 2W"
  },
  {
    "codigo":23919004,
    "descripcion":"LABERINTITIS"
  },
  {
    "codigo":1269103007,
    "descripcion":"TRASTORNO NEONATAL PRECOZ DEBIDO A TRASTORNO MATERNO DURANTE EMBARAZO"
  },
  {
    "codigo":449903008,
    "descripcion":"FÍSTULA ARTERIOVENOSA DURAL DE MÉDULA ESPINAL"
  },
  {
    "codigo":286063009,
    "descripcion":"NO PLANCHA"
  },
  {
    "codigo":185924006,
    "descripcion":"PACIENTE RETIRADO DEL ESTUDIO"
  },
  {
    "codigo":710212007,
    "descripcion":"NEOPLASIA DE NERVIO ESPINAL CERVICAL"
  },
  {
    "codigo":251460008,
    "descripcion":"ACTIVIDAD ALFA DE BAJA FRECUENCIA"
  },
  {
    "codigo":284228007,
    "descripcion":"QUEMADURA SUPERFICIAL DEL DEDO GORDO"
  },
  {
    "codigo":249625002,
    "descripcion":"CONTENIDOS ANORMALES EN MATERIA FECAL"
  },
  {
    "codigo":11791401000119107,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":216857007,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR DIÓXIDO DE AZUFRE"
  },
  {
    "codigo":772078000,
    "descripcion":"METABOLIZADOR ULTRARRÁPIDO DE CYP2B6"
  },
  {
    "codigo":184089008,
    "descripcion":"PACIENTE AUSENTE DEL COLEGIO O UNIVERSIDAD"
  },
  {
    "codigo":313326008,
    "descripcion":"INVAGINACIÓN INTERNA DE RECTO"
  },
  {
    "codigo":1163459001,
    "descripcion":"QUISTE INFECCIOSO DE LÓBULO CEREBRAL"
  },
  {
    "codigo":1360067000,
    "descripcion":"ÁNGULO CERRADO DE OJO DERECHO"
  },
  {
    "codigo":213187006,
    "descripcion":"FALLA TOTAL DE REIMPLANTE DEL PIE"
  },
  {
    "codigo":49347007,
    "descripcion":"OSTEOESCLEROSIS"
  },
  {
    "codigo":735640004,
    "descripcion":"ADULTO CON LLANTO EXCESIVO"
  },
  {
    "codigo":132291000119106,
    "descripcion":"TROMBOSIS VENOSA PROFUNDA AGUDA DE VENA FEMORAL"
  },
  {
    "codigo":276888009,
    "descripcion":"RESPIRACIÓN ESPONTÁNEA NORMAL"
  },
  {
    "codigo":45677003,
    "descripcion":"TRASTORNO DEL DESARROLLO DE LA EXPRESIÓN ESCRITA"
  },
  {
    "codigo":111213004,
    "descripcion":"ARTROPATÍA ASOCIADA CON ENFERMEDAD VIRAL"
  },
  {
    "codigo":1290861005,
    "descripcion":"RADIOLUCENCIA DENTAL EN RADIOGRAFÍA SIMPLE"
  },
  {
    "codigo":209517007,
    "descripcion":"DESGARRO PARCIAL DEL LIGAMENTO LATERAL EXTERNO DE RODILLA"
  },
  {
    "codigo":371522000,
    "descripcion":"TRASTORNO DE ÓRBITA ÓSEA"
  },
  {
    "codigo":43842003,
    "descripcion":"LESIÓN TRAUMÁTICA DE PULMÓN CON HERIDA ABIERTA HACIA TÓRAX"
  },
  {
    "codigo":240450004,
    "descripcion":"SÍNDROME DE CHOQUE TÓXICO POR ESTAFILOCOCOS"
  },
  {
    "codigo":238615000,
    "descripcion":"PSORIASIS PUSTULOSA JUVENIL"
  },
  {
    "codigo":109378008,
    "descripcion":"MESOTELIOMA (MALIGNO, TRASTORNO CLÍNICO)"
  },
  {
    "codigo":402455004,
    "descripcion":"MACROGLOSIA POR AMILOIDOSIS"
  },
  {
    "codigo":369687004,
    "descripcion":"MARGEN DISTAL DE RESECCIÓN QUIRÚRGICA DEL PÁNCREAS, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":105708002,
    "descripcion":"ENFERMEDAD CAUSADA POR TRICHOSTRONGYLOIDEA"
  },
  {
    "codigo":236780002,
    "descripcion":"ESCROTO BÍFIDO"
  },
  {
    "codigo":40172005,
    "descripcion":"COMPLICACIÓN CARDÍACA"
  },
  {
    "codigo":12203511000119100,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":72940007,
    "descripcion":"ABSCESO AGUDO DE LA ARÉOLA"
  },
  {
    "codigo":204012009,
    "descripcion":"ESPINA BÍFIDA LUMBAR SIN HIDROCEFALIA - CERRADA"
  },
  {
    "codigo":300481005,
    "descripcion":"TESTÍCULOS PRESENTES"
  },
  {
    "codigo":71105005,
    "descripcion":"ENCEFALITIS POR VIRUS ILHEUS"
  },
  {
    "codigo":351581000119108,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE URÉTER IZQUIERDO"
  },
  {
    "codigo":724630004,
    "descripcion":"PROBLEMA DE CADERA"
  },
  {
    "codigo":167574007,
    "descripcion":"CULTIVO DE ORINA: PSEUDOMONAS"
  },
  {
    "codigo":429718008,
    "descripcion":"RUPTURA DE TENDÓN DISTAL DEL CUÁDRICEPS"
  },
  {
    "codigo":722795004,
    "descripcion":"LEUCEMIA MENÍNGEA"
  },
  {
    "codigo":427883005,
    "descripcion":"PERITONITIS POSQUIRÚRGICA"
  },
  {
    "codigo":1899006,
    "descripcion":"TRASTORNO HEREDITARIO AUTOSÓMICO"
  },
  {
    "codigo":1343552000,
    "descripcion":"FLUOROSCOPIA DE VESÍCULA BILIAR CON CONTRASTE ANORMAL"
  },
  {
    "codigo":231275009,
    "descripcion":"FASCITIS PLANTAR TRAUMÁTICA"
  },
  {
    "codigo":786496006,
    "descripcion":"HIPERACTIVIDAD IDIOPÁTICA DE DETRUSOR"
  },
  {
    "codigo":131136006,
    "descripcion":"INMUNOGLOBULINA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":13570001000004105,
    "descripcion":"INFARTO DE RECTO"
  },
  {
    "codigo":424213003,
    "descripcion":"ALERGIA A VENENO DE ABEJA"
  },
  {
    "codigo":63765009,
    "descripcion":"ANILLO HIMENEAL ESTRECHO"
  },
  {
    "codigo":293141009,
    "descripcion":"REACCIÓN ADVERSA A CORTICOSTEROIDES"
  },
  {
    "codigo":1208810002,
    "descripcion":"ALERGIA A PROTEÍNA DE COBAYO DOMÉSTICO"
  },
  {
    "codigo":422378004,
    "descripcion":"CARCINOMA ESCAMOCELULAR DEL PUENTE DE LA NARIZ"
  },
  {
    "codigo":94698006,
    "descripcion":"RIÑÓN MOTEADO"
  },
  {
    "codigo":29162007,
    "descripcion":"IMPACTACIÓN FECAL DEL COLON"
  },
  {
    "codigo":782826009,
    "descripcion":"ENFERMEDAD DE CHARCOT-MARIE-TOOTH TIPO 2P"
  },
  {
    "codigo":291306009,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR SALBUTAMOL"
  },
  {
    "codigo":125631002,
    "descripcion":"LESIÓN TRAUMÁTICA DEL COLON ASCENDENTE"
  },
  {
    "codigo":289471003,
    "descripcion":"LABIOS MENORES DE LA VULVA, PEQUEÑOS"
  },
  {
    "codigo":92863005,
    "descripcion":"FUSIÓN ANORMAL CONGÉNITA DE HUESO LAGRIMAL"
  },
  {
    "codigo":420543008,
    "descripcion":"ANEMIA ASOCIADA CON SIDA"
  },
  {
    "codigo":254868008,
    "descripcion":"TUMOR DE OVARIO DE CÉLULAS HILIARES"
  },
  {
    "codigo":285801002,
    "descripcion":"PERFORACIÓN TRAUMÁTICA DEL ESTÓMAGO"
  },
  {
    "codigo":56425003,
    "descripcion":"EDEMA DE PLACENTA"
  },
  {
    "codigo":681771000119102,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE PARED LATERAL DE VEJIGA URINARIA"
  },
  {
    "codigo":251198002,
    "descripcion":"ROTACIÓN CARDÍACA EN SENTIDO HORARIO"
  },
  {
    "codigo":1332542008,
    "descripcion":"ARTRITIS IDIOPÁTICA JUVENIL DE INICIO SISTÉMICO DE TOBILLO"
  },
  {
    "codigo":447806008,
    "descripcion":"LINFOMA DE CARDIAS"
  },
  {
    "codigo":413203002,
    "descripcion":"ESFÍNTER ESOFÁGICO INCOMPETENTE"
  },
  {
    "codigo":42711000087105,
    "descripcion":"DISCO INTERVERTEBRAL TORÁCICO PROLAPSADO, T10-T11"
  },
  {
    "codigo":216595009,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR HOMATROPINA"
  },
  {
    "codigo":47831000087105,
    "descripcion":"FRACTURA DE SÉPTIMA COSTILLA DERECHA"
  },
  {
    "codigo":40151000087109,
    "descripcion":"LUXACIÓN DE ARTICULACIÓN DE DEDO MEDIO DE MANO DERECHA"
  },
  {
    "codigo":49085000,
    "descripcion":"INFESTACIÓN CAUSADA POR OTODECTES CYNOTIS"
  },
  {
    "codigo":1359805001,
    "descripcion":"COLONIZACIÓN CRÓNICA DE TRACTO RESPIRATORIO CAUSADA POR STAPHYLOCOCCUS AUREUS RESISTENTE A METICILINA"
  },
  {
    "codigo":50920009,
    "descripcion":"MIOCARDITIS"
  },
  {
    "codigo":442301001,
    "descripcion":"HALLAZGO RELACIONADO CON CAMBIOS EN COMPARACIÓN CON EXAMEN RADIOLÓGICO PREVIO"
  },
  {
    "codigo":212925005,
    "descripcion":"CONGELAMIENTO CON NECROSIS TISULAR DE LA CABEZA"
  },
  {
    "codigo":14482000,
    "descripcion":"ORIGEN ANÓMALO DE LA ARTERIA SUBCLAVIA DERECHA"
  },
  {
    "codigo":737213009,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE MEMBRANA SINOVIAL"
  },
  {
    "codigo":80018001,
    "descripcion":"GASTRITIS GLANDULAR HIPERTRÓFICA"
  },
  {
    "codigo":243858003,
    "descripcion":"SITUACIÓN DEL MONITOREO OFTALMOLÓGICO"
  },
  {
    "codigo":1259666003,
    "descripcion":"CISTADENOCARCINOMA DE CÉLULAS ACINARES PRIMARIO DE PRÓSTATA"
  },
  {
    "codigo":702610009,
    "descripcion":"APLASIA CONGÉNITA DE CONDUCTO DEFERENTE"
  },
  {
    "codigo":405863002,
    "descripcion":"FENOTIPO LE(A-)"
  },
  {
    "codigo":209255003,
    "descripcion":"FRACTURA-LUXACIÓN EXPUESTA DE ARTICULACIÓN DE CODO"
  },
  {
    "codigo":373095005,
    "descripcion":"FÍSTULA CORONARIA A LA AURÍCULA DERECHA"
  },
  {
    "codigo":1290599008,
    "descripcion":"LESIÓN TRAUMÁTICA DE GANGLIO DE SISTEMA NERVIOSO"
  },
  {
    "codigo":698940002,
    "descripcion":"ARTROPATÍA ASOCIADA CON FIBROSIS QUÍSTICA"
  },
  {
    "codigo":404028002,
    "descripcion":"SCHWANNOMA DE LOS CORPÚSCULOS DE PACINI"
  },
  {
    "codigo":305724004,
    "descripcion":"ATENDIDO POR CIRUJANO PEDIÁTRICO"
  },
  {
    "codigo":830012007,
    "descripcion":"QUISTE DERMOIDE DE CUERO CABELLUDO"
  },
  {
    "codigo":1075001000000104,
    "descripcion":"INCAPAZ DE LEVANTARSE DE LA CAMA SIN ASISTENCIA"
  },
  {
    "codigo":402193002,
    "descripcion":"DERMATITIS ATÓPICA DE PÁRPADO"
  },
  {
    "codigo":271121003,
    "descripcion":"AMPOLLA TRAUMÁTICA DEL DORSO"
  },
  {
    "codigo":236518000,
    "descripcion":"NEFROPATÍA AGUDA POR MERCURIO"
  },
  {
    "codigo":39910003,
    "descripcion":"PUNTAJE DE APGAR 2"
  },
  {
    "codigo":70843000,
    "descripcion":"ATROFIA DEL CORDÓN ESPERMÁTICO"
  },
  {
    "codigo":300219000,
    "descripcion":"LOCALIZACIÓN DE LA VOZ, ALTERADA"
  },
  {
    "codigo":7142008,
    "descripcion":"TOS EN REPOSO"
  },
  {
    "codigo":365755003,
    "descripcion":"NIVEL DE UREA - HALLAZGO"
  },
  {
    "codigo":726203004,
    "descripcion":"DISTENSIÓN DE FASCIA DE MÚSCULO INTRÍNSECO DE DEDO DE LA MANO"
  },
  {
    "codigo":602822751000119104,
    "descripcion":"RETINOPATÍA DERECHA CAUSADA POR PENTOSANO POLISULFATO"
  },
  {
    "codigo":103611008,
    "descripcion":"ESPÉCIMEN DEMASIADO GRUESO PARA UNA INTERPRETACIÓN ÓPTIMA"
  },
  {
    "codigo":398523009,
    "descripcion":"BOTULISMO ALIMENTARIO"
  },
  {
    "codigo":69008006,
    "descripcion":"FRAMBESIA NODULAR TARDÍA"
  },
  {
    "codigo":429456008,
    "descripcion":"HIPOVENTILACIÓN DURANTE EL SUEÑO DEBIDA A TRASTORNO NEUROMUSCULAR"
  },
  {
    "codigo":3472009,
    "descripcion":"ESPONDILOLISTESIS, GRADO 4"
  },
  {
    "codigo":296549007,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE IDOXURIDINA"
  },
  {
    "codigo":294714000,
    "descripcion":"ALERGIA A INSULINA"
  },
  {
    "codigo":722533007,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE UNIÓN ESOFAGOGÁSTRICA"
  },
  {
    "codigo":63503002,
    "descripcion":"EDAD GESTACIONAL, 41 SEMANAS"
  },
  {
    "codigo":129039006,
    "descripcion":"NECESITA AYUDA PARA VESTIRSE"
  },
  {
    "codigo":1144847007,
    "descripcion":"AUSENCIA DE PELO DE PUBIS"
  },
  {
    "codigo":94436000,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA CAVIDAD NASAL"
  },
  {
    "codigo":292879009,
    "descripcion":"REACCIÓN ADVERSA A DESINFECTANTE ALCOHÓLICO"
  },
  {
    "codigo":422116004,
    "descripcion":"NÓDULO EPIESCLERAL"
  },
  {
    "codigo":61668005,
    "descripcion":"REORDENAMIENTO GENÉTICO, CADENA GAMMA, RECEPTOR ANTIGÉNICO DE LINFOCITOS T"
  },
  {
    "codigo":28900006,
    "descripcion":"OCLUSIÓN DE PUPILA"
  },
  {
    "codigo":127204006,
    "descripcion":"LINFADENOPATÍA INGUINAL LATERAL SUPERIOR"
  },
  {
    "codigo":291044005,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR NITRAZEPAM"
  },
  {
    "codigo":225508006,
    "descripcion":"MALA IMAGEN DE SÍ MISMO"
  },
  {
    "codigo":420281004,
    "descripcion":"ERUPCIÓN CUTÁNEA ASOCIADA CON SIDA"
  },
  {
    "codigo":92601007,
    "descripcion":"CARCINOMA IN SITU DE LA MUCOSA GINGIVAL"
  },
  {
    "codigo":190905008,
    "descripcion":"FIBROSIS QUÍSTICA"
  },
  {
    "codigo":123534001,
    "descripcion":"FRACTURA NO EXPUESTA DEL SACRO Y\/O DEL CÓCCIX CON LESIÓN TRAUMÁTICA DE LA COLA DE CABALLO"
  },
  {
    "codigo":285539004,
    "descripcion":"NO MUEVE LA LENGUA LATERALMENTE"
  },
  {
    "codigo":449379004,
    "descripcion":"DEFECTO DEL TABIQUE AURICULOVENTRICULAR CON COMPONENTE VENTRICULAR POR DEBAJO DE VALVA EN PUENTE INFERIOR CON CUERDAS TENDINOSAS EN CRESTA DE TABIQUE VENTRICULAR"
  },
  {
    "codigo":283704000,
    "descripcion":"MORDEDURA HUMANA EN MUÑECA"
  },
  {
    "codigo":21560005,
    "descripcion":"LEPRA LEPROMATOSA"
  },
  {
    "codigo":185400006,
    "descripcion":"PACIENTE QUE CONCURRE MENSUALMENTE"
  },
  {
    "codigo":609549002,
    "descripcion":"HIPERSENSIBILIDAD NO ALÉRGICA A ANTAGONISTA DE RECEPTOR DE ANGIOTENSINA II"
  },
  {
    "codigo":1363213002,
    "descripcion":"NEOVASCULARIZACIÓN DE CUADRANTE NASAL DE ÁNGULO IRIDOCORNEAL DE OJO DERECHO"
  },
  {
    "codigo":247266001,
    "descripcion":"MEMBRANA TIMPÁNICA SIN RASGOS CARACTERÍSTICOS"
  },
  {
    "codigo":17890003,
    "descripcion":"INFARTO HEPÁTICO"
  },
  {
    "codigo":738786005,
    "descripcion":"METABOLIZADOR LENTO DE LA FAMILIA 2 SUBFAMILIA C MIEMBRO 19 DEL CITOCROMO P450"
  },
  {
    "codigo":50658006,
    "descripcion":"DEFICIENCIA DE TESTOSTERONA 17 - BETA - DESHIDROGENASA"
  },
  {
    "codigo":443874006,
    "descripcion":"INFECCIÓN DE PICADURA DE GARRAPATA"
  },
  {
    "codigo":15950381000119103,
    "descripcion":"CARCINOMA DE CÉLULAS DE MERKEL PRIMARIO DE PIEL DE MAMA DERECHA"
  },
  {
    "codigo":704183003,
    "descripcion":"FRACTURA EXPUESTA EN MARTILLO DE FALANGE DISTAL DE DEDO ANULAR"
  },
  {
    "codigo":276364001,
    "descripcion":"PROBLEMA PARA LOGRAR UNA ERECCIÓN"
  },
  {
    "codigo":210828002,
    "descripcion":"LESIÓN EXPUESTA, ARTERIA AXILAR"
  },
  {
    "codigo":1259404005,
    "descripcion":"CARCINOSARCOMA PRIMARIO DE COLON TRANSVERSO"
  },
  {
    "codigo":405601000,
    "descripcion":"PROBLEMA CON EL MANGUITO DE DISPOSITIVO PARA LA VÍA AÉREA"
  },
  {
    "codigo":14220008,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN LA REGIÓN DE LABIO, SIN INFECCIÓN"
  },
  {
    "codigo":766049000,
    "descripcion":"NEUROPATÍA ATÁXICA SENSITIVA AGUDA"
  },
  {
    "codigo":241761001,
    "descripcion":"INTOXICACIÓN CAUSADA POR CRACK DE COCAÍNA"
  },
  {
    "codigo":307297004,
    "descripcion":"HEMORRAGIA GASTROINTESTINAL MASIVA"
  },
  {
    "codigo":733281002,
    "descripcion":"LUXACIÓN TRAUMÁTICA CENTRAL DE CADERA"
  },
  {
    "codigo":1290337007,
    "descripcion":"DOLOR DE REGIÓN DE PARTE INTERNA DE BOCA"
  },
  {
    "codigo":239926000,
    "descripcion":"POLIARTERITIS NODOSA CUTÁNEA"
  },
  {
    "codigo":403766000,
    "descripcion":"FENOTIPO ACROMEGALOIDE CON LEUCOMA CORNEAL Y CUTIS VERTICIS GYRATA"
  },
  {
    "codigo":208993007,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN METATARSOFALÁNGICA, ÚNICA"
  },
  {
    "codigo":698678003,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: RUMANO"
  },
  {
    "codigo":762379000,
    "descripcion":"DERMATITIS ALÉRGICA POR CONTACTO CAUSADA POR MATERIAL ODONTOLÓGICO"
  },
  {
    "codigo":41483000,
    "descripcion":"SÍNDROME DE MALFORMACIÓN MÚLTIPLE, BAJA ESTATURA, SIN DISPLASIA ESQUELÉTICA"
  },
  {
    "codigo":860683004,
    "descripcion":"EMBOLIA SÉPTICA DEBIDA A EMBARAZO ECTÓPICO Y POSTERIOR A ÉL"
  },
  {
    "codigo":238091006,
    "descripcion":"DEFICIENCIA DE LECITINA COLESTEROL ACILTRANSFERASA"
  },
  {
    "codigo":400096001,
    "descripcion":"NEVO MELANOCÍTICO"
  },
  {
    "codigo":301792001,
    "descripcion":"CÁLCULO DE UNIÓN VESICOURETERAL"
  },
  {
    "codigo":367328005,
    "descripcion":"POLICITEMIA SECUNDARIA CON EXCESO DE ERITROPOYETINA"
  },
  {
    "codigo":39648006,
    "descripcion":"PAQUIMENINGITIS CERVICAL HIPERTRÓFICA FIBROSA"
  },
  {
    "codigo":431029005,
    "descripcion":"MASA DE TEJIDO SUBCUTÁNEO DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":296115006,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE MIDAZOLAM"
  },
  {
    "codigo":365493009,
    "descripcion":"HALLAZGO RELACIONADO CON LA CERCANÍA DE CUIDADOR INFORMAL"
  },
  {
    "codigo":429194003,
    "descripcion":"FRACTURA DE MANDÍBULA DESPLAZADA"
  },
  {
    "codigo":134282008,
    "descripcion":"LEE CHINO"
  },
  {
    "codigo":296287000,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE SELEGILINA"
  },
  {
    "codigo":197983000,
    "descripcion":"ORQUITIS Y EPIDIDIMITIS"
  },
  {
    "codigo":230751003,
    "descripcion":"HIDROCEFALIA DESPUÉS DE LESIÓN TRAUMÁTICA"
  },
  {
    "codigo":427359005,
    "descripcion":"NÓDULO SOLITARIO DE PULMÓN"
  },
  {
    "codigo":294452000,
    "descripcion":"ALERGIA A PIRANTEL"
  },
  {
    "codigo":390921001,
    "descripcion":"AUSENCIA DEL TRABAJO O ESCUELA POR ASMA"
  },
  {
    "codigo":1144585003,
    "descripcion":"BUENA RESPUESTA AL DESTETE DE RESPIRADOR"
  },
  {
    "codigo":292617004,
    "descripcion":"REACCIÓN ADVERSA A LA TEOFILINA"
  },
  {
    "codigo":30473006,
    "descripcion":"DOLOR PÉLVICO"
  },
  {
    "codigo":61406000,
    "descripcion":"INTOXICACIÓN POR DIAZEPAM"
  },
  {
    "codigo":389086002,
    "descripcion":"HIPOXIA"
  },
  {
    "codigo":716766007,
    "descripcion":"MALACOPLAQUIA"
  },
  {
    "codigo":10958961000119100,
    "descripcion":"HERIDA ABIERTA DE MANO IZQUIERDA DEBIDA A MORDEDURA HUMANA"
  },
  {
    "codigo":15697521000119101,
    "descripcion":"ABSCESO DE ÓRBITA DERECHA"
  },
  {
    "codigo":10692721000119102,
    "descripcion":"ASMA OBSTRUCTIVA CRÓNICA CONCOMITANTE CON EXACERBACIÓN ASMÁTICA AGUDA"
  },
  {
    "codigo":329841000119103,
    "descripcion":"ESCOLIOSIS NEUROMUSCULAR DEBIDA A POLIOMIELITIS Y POSTERIOR A ELLA"
  },
  {
    "codigo":25201000119104,
    "descripcion":"VÉRTEBRA LUMBOSACRA DE TRANSICIÓN"
  },
  {
    "codigo":1090161000119105,
    "descripcion":"EDENTULISMO PARCIAL CLASE I DEBIDO A TRAUMATISMO"
  },
  {
    "codigo":294001000119105,
    "descripcion":"SÍNDROME DE VÓMITOS CÍCLICOS INTRATABLE"
  },
  {
    "codigo":288947007,
    "descripcion":"CAPAZ DE TRAGAR LÍQUIDOS"
  },
  {
    "codigo":11831921000119104,
    "descripcion":"LACERACIÓN DE VASO SANGUÍNEO DE DEDO DE MANO DERECHA"
  },
  {
    "codigo":11821681000119109,
    "descripcion":"SUBLUXACIÓN DE ARTICULACIÓN ESTERNOCLAVICULAR IZQUIERDA"
  },
  {
    "codigo":15677041000119109,
    "descripcion":"MIOSITIS DE HOMBRO DERECHO"
  },
  {
    "codigo":317041000119109,
    "descripcion":"REUMATISMO PALINDRÓMICO DE RODILLA IZQUIERDA"
  },
  {
    "codigo":11304561000119105,
    "descripcion":"FRACTURA EXPUESTA DE PORCIÓN NASO-ORBITARIA DE HUESO ETMOIDES"
  },
  {
    "codigo":337521000119104,
    "descripcion":"QUERATOCONJUNTIVITIS LÍMBICA SUPERIOR DE OJO IZQUIERDO"
  },
  {
    "codigo":89201000119106,
    "descripcion":"DEPENDENCIA DE OXÍGENO SUPLEMENTARIO AL CAMINAR"
  },
  {
    "codigo":418184004,
    "descripcion":"ALERGIA A CENTENO"
  },
  {
    "codigo":22641000119109,
    "descripcion":"PSICOSIS EN LA PRIMERA INFANCIA"
  },
  {
    "codigo":297845361000119109,
    "descripcion":"ENDOMETRIOSIS SUPERFICIAL DE APÉNDICE"
  },
  {
    "codigo":15741041000119109,
    "descripcion":"GANGLIÓN DE CARA PALMAR DE MUÑECA DERECHA"
  },
  {
    "codigo":23133003,
    "descripcion":"DISDIADOCOCINESIA"
  },
  {
    "codigo":416349001,
    "descripcion":"PRESCRIPCIÓN RECOGIDA POR FARMACIA"
  },
  {
    "codigo":1332018000,
    "descripcion":"OSTEÓLISIS DE FÉMUR"
  },
  {
    "codigo":449117003,
    "descripcion":"VÁLVULA PULMONAR TRICÚSPIDE PRESENTE"
  },
  {
    "codigo":840498003,
    "descripcion":"ENCEFALITIS CAUSADA POR VIRUS DE LA INMUNODEFICIENCIA HUMANA TIPO 1"
  },
  {
    "codigo":186973005,
    "descripcion":"FRAMBESIA LATENTE"
  },
  {
    "codigo":283442005,
    "descripcion":"CORTE EN EL DORSO DEL PIE"
  },
  {
    "codigo":285277009,
    "descripcion":"DELIRIO DE INDIGNIDAD"
  },
  {
    "codigo":447282003,
    "descripcion":"INFECCIÓN INTESTINAL CAUSADA POR VIBRIO CHOLERAE O1"
  },
  {
    "codigo":52231000,
    "descripcion":"PROCTITIS ULCEROSA CRÓNICA"
  },
  {
    "codigo":12240021000119103,
    "descripcion":"MICROCALCIFICACIÓN MAMOGRÁFICA DE AMBAS MAMAS"
  },
  {
    "codigo":248839005,
    "descripcion":"SECRECIÓN LÁCTEA - HALLAZGO"
  },
  {
    "codigo":707591005,
    "descripcion":"CARCINOMA MUCOEPIDERMOIDE PRIMARIO DE OROFARINGE"
  },
  {
    "codigo":1197276007,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS PRIMARIO DE ANILLO LINFOIDE FARÍNGEO"
  },
  {
    "codigo":247004007,
    "descripcion":"MEMBRANA DE LA CÁMARA ANTERIOR"
  },
  {
    "codigo":48561006,
    "descripcion":"FRACTURA NO EXPUESTA DE EXTREMO ESTERNAL DE CLAVÍCULA"
  },
  {
    "codigo":308870004,
    "descripcion":"DISPLASIA DE COLON"
  },
  {
    "codigo":77659000,
    "descripcion":"NEUROPATÍA PARANEOPLÁSICA"
  },
  {
    "codigo":208731002,
    "descripcion":"FRACTURAS MÚLTIPLES DE FÉMUR"
  },
  {
    "codigo":89391000119105,
    "descripcion":"RETARDO SEVERO DEL LENGUAJE RECEPTIVO"
  },
  {
    "codigo":1255472001,
    "descripcion":"DEFICIENCIA DE REPARACIÓN DE ÁCIDO DESOXIRRIBONUCLEICO POR RECOMBINACIÓN HOMÓLOGA"
  },
  {
    "codigo":403504002,
    "descripcion":"NÓDULO SUBCUTÁNEO ASOCIADO CON LUPUS ERITEMATOSO"
  },
  {
    "codigo":75824002,
    "descripcion":"LUXACIÓN CERRADA LATERAL DE CODO"
  },
  {
    "codigo":1222704008,
    "descripcion":"POLINEUROPATÍA AXONAL SENSITIVOMOTORA NEONATAL LETAL AUTOSÓMICA RECESIVA"
  },
  {
    "codigo":303365000,
    "descripcion":"EMPUJA"
  },
  {
    "codigo":237829004,
    "descripcion":"SECRECIÓN ECTÓPICA DE ACTH"
  },
  {
    "codigo":73989005,
    "descripcion":"INTOXICACIÓN POR CROTALARIA SPECTABILIS"
  },
  {
    "codigo":8453006,
    "descripcion":"RETRACCIÓN SUBCOSTAL"
  },
  {
    "codigo":203226002,
    "descripcion":"INFECCIÓN DEL CÚBITO"
  },
  {
    "codigo":235994004,
    "descripcion":"ABSCESO SUPRAHEPÁTICO"
  },
  {
    "codigo":6618004,
    "descripcion":"DERMATITIS POLIMORFA POR LUZ SOLAR, TIPO PLACA"
  },
  {
    "codigo":301530005,
    "descripcion":"ENTRA EN LA BAÑERA"
  },
  {
    "codigo":266927001,
    "descripcion":"TABAQUISMO DESCONOCIDO"
  },
  {
    "codigo":234159003,
    "descripcion":"SÍNDROME DE DISPLASIA MÚLTIPLE"
  },
  {
    "codigo":823983004,
    "descripcion":"NERVIO OCULOMOTOR INTACTO"
  },
  {
    "codigo":4783006,
    "descripcion":"DIABETES MELLITUS MATERNA CON HIPOGLUCEMIA QUE AFECTA AL FETO O RECIÉN NACIDO"
  },
  {
    "codigo":365231007,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA MANEJAR UN ARTEFACTO MIENTRAS SE DESVISTE"
  },
  {
    "codigo":723844004,
    "descripcion":"CONDROSARCOMA PRIMARIO DE CARTÍLAGO ARTICULAR DE EXTREMIDAD"
  },
  {
    "codigo":363396004,
    "descripcion":"NEOPLASIA MALIGNA DE HENDIDURA BRANQUIAL"
  },
  {
    "codigo":35716006,
    "descripcion":"PEZÓN AGRIETADO ASOCIADO CON EL PARTO"
  },
  {
    "codigo":232324007,
    "descripcion":"DISCAPACIDAD AUDITIVA CON AUDICIÓN NORMAL"
  },
  {
    "codigo":296025004,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE CLORMEZANONA"
  },
  {
    "codigo":230489007,
    "descripcion":"SOMNOLENCIA DIURNA EXCESIVA - SUEÑO NOCTURNO NORMAL"
  },
  {
    "codigo":263257008,
    "descripcion":"LESIÓN TRAUMÁTICA DE CARTÍLAGO COSTAL"
  },
  {
    "codigo":64814003,
    "descripcion":"ABORTO ESPONTÁNEO CON DESEQUILIBRIO ELECTROLÍTICO"
  },
  {
    "codigo":294190003,
    "descripcion":"ALERGIA A ENBUCRILATO"
  },
  {
    "codigo":32046005,
    "descripcion":"INTOXICACIÓN CAUSADA POR AMANTADINA"
  },
  {
    "codigo":195886008,
    "descripcion":"NEUMONÍA ESTREPTOCÓCICA DEL GRUPO B"
  },
  {
    "codigo":95747002,
    "descripcion":"CONJUNTIVITIS NECROSANTE"
  },
  {
    "codigo":423427003,
    "descripcion":"HIPERVENTILACIÓN INTERMITENTE"
  },
  {
    "codigo":128515003,
    "descripcion":"LESIÓN TRAUMÁTICA DE LOS ANEXOS OCULARES"
  },
  {
    "codigo":292355003,
    "descripcion":"REACCIÓN ADVERSA AL KETAZOLAM"
  },
  {
    "codigo":30211004,
    "descripcion":"INFECCIÓN CAUSADA POR HARTMANNELLA"
  },
  {
    "codigo":93912001,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE MÚSCULO DEL MIEMBRO SUPERIOR"
  },
  {
    "codigo":61144001,
    "descripcion":"TRASTORNO PSICÓTICO CON IDEAS DELIRANTES INDUCIDO POR EL ALCOHOL"
  },
  {
    "codigo":1306328002,
    "descripcion":"GLAUCOMA DE ÁNGULO CERRADO DE OJO DERECHO DEBIDO A SINEQUIA ANTERIOR PERIFÉRICA"
  },
  {
    "codigo":126680004,
    "descripcion":"NEOPLASIA DE LA NASOFARINGE"
  },
  {
    "codigo":716504005,
    "descripcion":"NO COMPRENDE EL LENGUAJE ESCRITO"
  },
  {
    "codigo":224984007,
    "descripcion":"REGRESIÓN A TRAVÉS DE LA REPRESENTACIÓN"
  },
  {
    "codigo":290520009,
    "descripcion":"INTOXICACIÓN POR TRICLOROETILENO"
  },
  {
    "codigo":714669006,
    "descripcion":"ACTITUD HACIA EL ESTADO NUTRICIONAL ALTERADA"
  },
  {
    "codigo":288685007,
    "descripcion":"PRESUPONE EN UNA CONVERSACIÓN"
  },
  {
    "codigo":92077009,
    "descripcion":"NEOPLASIA BENIGNA DEL DIAFRAGMA"
  },
  {
    "codigo":1204354006,
    "descripcion":"INFECCIÓN ÓSEA ASOCIADA A TORNILLO PARA FIJACIÓN ÓSEA"
  },
  {
    "codigo":254082007,
    "descripcion":"CONDRODISPLASIA PUNTEADA, DE TIPO RECESIVO, LIGADA AL CROMOSOMA X"
  },
  {
    "codigo":90242006,
    "descripcion":"ANQUILOSIS ARTICULAR DE SITIOS MÚLTIPLES"
  },
  {
    "codigo":55639004,
    "descripcion":"INTENTO FALLIDO DE ABORTO CON LACERACIÓN DE LA VAGINA"
  },
  {
    "codigo":285015004,
    "descripcion":"CAPAZ DE MANEJAR UN ARTEFACTO MIENTRAS SE VISTE Y DESVISTE"
  },
  {
    "codigo":1074941000119105,
    "descripcion":"ARTRITIS DE AMBOS TOBILLOS"
  },
  {
    "codigo":283180003,
    "descripcion":"CUERPO EXTRAÑO METÁLICO EN LA ESPINILLA"
  },
  {
    "codigo":250412004,
    "descripcion":"HALLAZGO RELACIONADO CON PRUEBA CON TIRA REACTIVA"
  },
  {
    "codigo":1004076005,
    "descripcion":"CONTRACTURA EN FLEXIÓN DE ARTICULACIÓN DE COLUMNA VERTEBRAL CERVICAL"
  },
  {
    "codigo":414252009,
    "descripcion":"HALLAZGO RELACIONADO CON EL DORSO"
  },
  {
    "codigo":248577005,
    "descripcion":"RESPIRACIÓN ESTREPITOSA"
  },
  {
    "codigo":1197014007,
    "descripcion":"PIOESTOMATITIS VEGETANTE DE MUCOSA GINGIVAL"
  },
  {
    "codigo":17366009,
    "descripcion":"ARRITMIA AURICULAR"
  },
  {
    "codigo":15531007,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA ARTERIA POPLÍTEA"
  },
  {
    "codigo":1258880004,
    "descripcion":"EQUIMOSIS POSTERIOR A PROCEDIMIENTO QUIRÚRGICO"
  },
  {
    "codigo":16039831000119107,
    "descripcion":"CONDROMALACIA DE AMBOS TOBILLOS"
  },
  {
    "codigo":110165004,
    "descripcion":"ABRASIÓN DE PIEL DE REGIÓN PERIORBITARIA DE CARA"
  },
  {
    "codigo":208469006,
    "descripcion":"FRACTURA EXPUESTA DE FALANGE PROXIMAL DE PULGAR, DIÁFISIS"
  },
  {
    "codigo":311191000119109,
    "descripcion":"MIELOPATÍA CONCOMITANTE CON TRASTORNO DE DISCO INTERVERTEBRAL LUMBOSACRO Y DEBIDA A ÉL"
  },
  {
    "codigo":370474006,
    "descripcion":"MIOSITIS EOSINÓFILA"
  },
  {
    "codigo":403242007,
    "descripcion":"COLOR CONSTITUCIONAL DE LA PIEL, MARRÓN OSCURO"
  },
  {
    "codigo":204799005,
    "descripcion":"HIPERPLASIA HEPÁTICA"
  },
  {
    "codigo":1351679006,
    "descripcion":"AGAMMAGLOBULINEMIA AUTOSÓMICA RECESIVA DEBIDA A DEFICIENCIA DE ALFA INMUNOGLOBULINA"
  },
  {
    "codigo":237567008,
    "descripcion":"HIPOTIROIDISMO POR DEFICIENCIA SUBCLÍNICA DE YODO"
  },
  {
    "codigo":71892000,
    "descripcion":"ASMA CARDÍACA"
  },
  {
    "codigo":40959008,
    "descripcion":"PERICARDITIS VIRAL AGUDA"
  },
  {
    "codigo":202964000,
    "descripcion":"RUPTURA ATRAUMÁTICA DE TENDÓN DE AQUILES"
  },
  {
    "codigo":120881000119106,
    "descripcion":"INSUFICIENCIA CARDÍACA DIASTÓLICA, ESTADIO D"
  },
  {
    "codigo":235732007,
    "descripcion":"ESTEATORREA LUEGO DE PROCEDIMIENTO INTESTINAL"
  },
  {
    "codigo":301268008,
    "descripcion":"MATIDEZ HEPÁTICA A LA PERCUSIÓN, DESPLAZADA"
  },
  {
    "codigo":725417001,
    "descripcion":"DISPLASIA ESQUELÉTICA RELACIONADA CON SULFOTRANSFERASA 3 DE CARBOHIDRATOS"
  },
  {
    "codigo":11999281000119107,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO DE MUÑECA DERECHA"
  },
  {
    "codigo":168361003,
    "descripcion":"ORGANISMO AISLADO EN CULTIVO DE HISOPADO DE PENE"
  },
  {
    "codigo":430505004,
    "descripcion":"OSTEOCONDRITIS DE TIBIA PROXIMAL"
  },
  {
    "codigo":364969003,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA ELEVAR EL PALADAR BLANDO"
  },
  {
    "codigo":233897008,
    "descripcion":"TAQUICARDIA AURICULOVENTRICULAR POR REENTRADA"
  },
  {
    "codigo":232062002,
    "descripcion":"VITREORRETINOPATÍA HEREDITARIA"
  },
  {
    "codigo":199294004,
    "descripcion":"ENFERMEDAD DEL APARATO DIGESTIVO QUE COMPLICA EMBARAZO, PARTO Y\/O PUERPERIO"
  },
  {
    "codigo":723582004,
    "descripcion":"DISTROFIA CORNEAL MUCINOSA SUBEPITELIAL"
  },
  {
    "codigo":461438006,
    "descripcion":"ORIFICIOS DOBLES DE ARTERIA CORONARIA EN DOBLE BARRIL DENTRO DE SENO ÓRTICO"
  },
  {
    "codigo":428670009,
    "descripcion":"MASA DE ARTICULACIÓN DE LA RODILLA"
  },
  {
    "codigo":264830009,
    "descripcion":"PRUEBA DEL OJO CUBIERTO - HALLAZGO"
  },
  {
    "codigo":262995003,
    "descripcion":"ESGUINCE DE LA ESPALDA, EXCLUIDA LA REGIÓN LUMBOSACRA"
  },
  {
    "codigo":721747005,
    "descripcion":"INFECCIÓN CAUSADA POR STREPTOCOCCUS GAMMA-HEMOLÍTICO"
  },
  {
    "codigo":230227009,
    "descripcion":"ATAXIA CEREBELOSA DE INICIO PRECOZ"
  },
  {
    "codigo":64552006,
    "descripcion":"TRASTORNO NO INFLAMATORIO DE TROMPA DE FALOPIO"
  },
  {
    "codigo":313701000119100,
    "descripcion":"MONOARTRITIS DE RODILLA DERECHA"
  },
  {
    "codigo":293928009,
    "descripcion":"ALERGIA A FENOTIAZINA"
  },
  {
    "codigo":95485003,
    "descripcion":"PIGMENTACIÓN CAPSULAR ANTERIOR CONGÉNITA"
  },
  {
    "codigo":292093003,
    "descripcion":"REACCIÓN ADVERSA A LA TUBERCULINA"
  },
  {
    "codigo":718077003,
    "descripcion":"PERIIMPLANTITIS DENTAL COMPLETA"
  },
  {
    "codigo":1142226000,
    "descripcion":"INFECCIÓN INTESTINAL CAUSADA POR SALMONELLA GRUPO A"
  },
  {
    "codigo":191954008,
    "descripcion":"TOS PSICÓGENA"
  },
  {
    "codigo":93650009,
    "descripcion":"MELANOMA MALIGNO DE LA PIEL DE DEDO DEL PIE"
  },
  {
    "codigo":59047005,
    "descripcion":"FÍSTULA AORTOINTESTINAL"
  },
  {
    "codigo":124583008,
    "descripcion":"DEFICIENCIA DE OMEGA PEPTIDASA"
  },
  {
    "codigo":16015871000119100,
    "descripcion":"ARTRITIS DE ARTICULACIONES DE AMBOS TOBILLOS CAUSADA POR STREPTOCOCCUS"
  },
  {
    "codigo":450428007,
    "descripcion":"PETEQUIAS CUTÁNEAS PERINATALES"
  },
  {
    "codigo":24444009,
    "descripcion":"INTENTO FALLIDO DE ABORTO CON SEPSIS"
  },
  {
    "codigo":89980009,
    "descripcion":"TROMBOSIS DE SENO VENOSO CAVERNOSO"
  },
  {
    "codigo":284753006,
    "descripcion":"REAPERTURA DE CICATRICES"
  },
  {
    "codigo":16206181000119108,
    "descripcion":"SÍNDROME DE ABERTURA DE SALIDA TORÁCICA NEUROGÉNICO DE AMBOS PLEXOS BRAQUIALES"
  },
  {
    "codigo":250150003,
    "descripcion":"SUELA DEL CALZADO MUY DELGADA"
  },
  {
    "codigo":296584006,
    "descripcion":"SOBREDOSIS INTENCIONAL DE TIABENDAZOL"
  },
  {
    "codigo":248315005,
    "descripcion":"LIPOATROFIA"
  },
  {
    "codigo":836304000,
    "descripcion":"CARCINOMA UROTELIAL DE ALTO GRADO HALLADO EN LA CITOLOGÍA URINARIA"
  },
  {
    "codigo":82640004,
    "descripcion":"FRACTURA DE STIEDA"
  },
  {
    "codigo":211877001,
    "descripcion":"CORROSIÓN DE TERCER GRADO DE HOMBRO Y EXTREMIDAD SUPERIOR EXCEPTO MUÑECA Y MANO"
  },
  {
    "codigo":408485004,
    "descripcion":"EXAMEN PEDIÁTRICO DE LOS 7 MESES ANORMAL - EN TRATAMIENTO"
  },
  {
    "codigo":768933005,
    "descripcion":"SÍNDROME DE DEHISCENCIA DE CONDUCTO SEMICIRCULAR"
  },
  {
    "codigo":80805005,
    "descripcion":"YEYUNITIS"
  },
  {
    "codigo":342681000119103,
    "descripcion":"QUISTE DE PÁRPADO SUPERIOR DERECHO"
  },
  {
    "codigo":46202007,
    "descripcion":"CAMBIO EN EL CALIBRE DE LAS HECES"
  },
  {
    "codigo":208207008,
    "descripcion":"RUPTURA TRAUMÁTICA DE SÍNFISIS PÚBICA"
  },
  {
    "codigo":9764001,
    "descripcion":"ANEMIA CAUSADA POR RADIACIÓN"
  },
  {
    "codigo":109903009,
    "descripcion":"EFECTOS TARDÍOS DE ABSCESO PIÓGENO INTRACRANEAL"
  },
  {
    "codigo":239140003,
    "descripcion":"NEVO ELÁSTICO"
  },
  {
    "codigo":370212000,
    "descripcion":"CANTIDAD DE VECES QUE UTILIZA BRONCODILATADOR EN 24 HORAS"
  },
  {
    "codigo":1254948007,
    "descripcion":"EDEMA DEBIDO A ALTERACIÓN DE CONTROL VASOMOTOR"
  },
  {
    "codigo":206372007,
    "descripcion":"HEPATITIS VIRAL CONGÉNITA"
  },
  {
    "codigo":402980008,
    "descripcion":"INFECCIÓN CUTÁNEA POR MYCOBACTERIUM FORTUITUM"
  },
  {
    "codigo":302841002,
    "descripcion":"LINFOMA MALIGNO - LINFOCÍTICO DE CÉLULAS PEQUEÑAS"
  },
  {
    "codigo":237305004,
    "descripcion":"PRESENTACIÓN EL CORDÓN"
  },
  {
    "codigo":73465006,
    "descripcion":"AUSENCIA CONGÉNITA DE EPITELIO GERMINAL DE TESTÍCULO"
  },
  {
    "codigo":204537008,
    "descripcion":"ANOMALÍA DE CARTÍLAGO LARÍNGEO Y TRAQUEAL"
  },
  {
    "codigo":366542007,
    "descripcion":"AMPLITUD DE MOVIMIENTO PASIVO DE PRONACIÓN DE LA MUÑECA - HALLAZGO"
  },
  {
    "codigo":397475000,
    "descripcion":"TEJIDO FETAL PRESENTE EN EL ESPÉCIMEN"
  },
  {
    "codigo":233635001,
    "descripcion":"TRASTORNO DE PLEURA Y CAVIDAD PLEURAL"
  },
  {
    "codigo":725155003,
    "descripcion":"HERIDA DE ABDOMEN"
  },
  {
    "codigo":102563003,
    "descripcion":"EDEMA DE MUÑECA"
  },
  {
    "codigo":266403005,
    "descripcion":"BRONQUITIS AGUDA POR SUSTANCIAS QUÍMICAS"
  },
  {
    "codigo":37027003,
    "descripcion":"FRACTURA DE LE FORT, TIPO III"
  },
  {
    "codigo":299171009,
    "descripcion":"SIN AMPLITUD PASIVA DE ABDUCCIÓN DE PULGAR"
  },
  {
    "codigo":262733002,
    "descripcion":"CONTUSIÓN DE LA RAÍZ DE NERVIO ESPINAL"
  },
  {
    "codigo":295501005,
    "descripcion":"SOBREDOSIS DE FÁRMACO USADO PARA ANESTESIA GENERAL"
  },
  {
    "codigo":721485009,
    "descripcion":"SÍNDROME DE BROWN-SEQUARD AL NIVEL DEL CUARTO SEGMENTO DORSAL"
  },
  {
    "codigo":197197009,
    "descripcion":"ADHERENCIAS COLÓNICAS"
  },
  {
    "codigo":64290004,
    "descripcion":"AEROEMBOLIA COMO COMPLICACIÓN TEMPRANA DE TRAUMATISMO"
  },
  {
    "codigo":719650004,
    "descripcion":"SÍNDROME DE MICRODELECIÓN 20P12.3"
  },
  {
    "codigo":129826008,
    "descripcion":"HALLAZGO RELACIONADO CON EL MANEJO DEL RÉGIMEN TERAPÉUTICO"
  },
  {
    "codigo":293666009,
    "descripcion":"ALERGIA A HIDRÓXIDO DE ALUMINIO"
  },
  {
    "codigo":816119002,
    "descripcion":"CATARATA DE OJO IZQUIERDO"
  },
  {
    "codigo":95223005,
    "descripcion":"CUERPO EXTRAÑO TRAUMÁTICO VIEJO RETENIDO EN EL OJO"
  },
  {
    "codigo":1078263006,
    "descripcion":"AGENESIA DE EPÍFISIS DE FALANGE MEDIA DE TERCER DEDO DE PIE"
  },
  {
    "codigo":10939341000119105,
    "descripcion":"LACERACIÓN DE BRAZO DERECHO"
  },
  {
    "codigo":715980003,
    "descripcion":"ENCEFALOPATÍA DEBIDA A DEFICIENCIA DE SULFITO OXIDASA"
  },
  {
    "codigo":93388003,
    "descripcion":"ESTENOSIS CONGÉNITA DE LA ARTERIA SUBCLAVIA"
  },
  {
    "codigo":224460006,
    "descripcion":"CON PERMISO POR ASUNTOS FAMILIARES"
  },
  {
    "codigo":191692007,
    "descripcion":"PSICOSIS DESINTEGRATIVAS ACTIVAS"
  },
  {
    "codigo":26017006,
    "descripcion":"PRODUCCIÓN HORMONAL NORMAL"
  },
  {
    "codigo":124321009,
    "descripcion":"DEFICIENCIA DE TRIOCINASA"
  },
  {
    "codigo":286326006,
    "descripcion":"CAPAZ DE EMITIR VOZ"
  },
  {
    "codigo":1269366008,
    "descripcion":"CRISIS EPILÉPTICA ATÓNICA DE INICIO FOCAL"
  },
  {
    "codigo":448331000,
    "descripcion":"DEFECTO DEL TABIQUE AURICULOVENTRICULAR CON COMPONENTE VENTRICULAR RESTRICTIVO"
  },
  {
    "codigo":22347002,
    "descripcion":"ANEMIA POR DISFUNCIÓN GONADAL"
  },
  {
    "codigo":251723005,
    "descripcion":"ÁNGULO ABIERTO AMPLIO"
  },
  {
    "codigo":284491007,
    "descripcion":"HALLAZGO RELACIONADO CON REFUERZO DE LA CONDUCTA"
  },
  {
    "codigo":249888000,
    "descripcion":"DEBILIDAD DEL ESTERNOCLEIDOMASTOIDEO"
  },
  {
    "codigo":446496001,
    "descripcion":"OSIFICACIÓN HETEROTÓPICA DE ARTICULACIÓN"
  },
  {
    "codigo":53280004,
    "descripcion":"DIPLOFONÍA"
  },
  {
    "codigo":774176004,
    "descripcion":"DISFUNCIÓN DEL MÚSCULO OBLICUO INFERIOR DEL OJO IZQUIERDO"
  },
  {
    "codigo":413728006,
    "descripcion":"BUFTALMOS"
  },
  {
    "codigo":282656007,
    "descripcion":"DIFICULTAD PARA TRANSFERIR PESO"
  },
  {
    "codigo":315424008,
    "descripcion":"NACIDO EN ETIOPÍA"
  },
  {
    "codigo":1003552004,
    "descripcion":"AGENESIA DE VEJIGA URINARIA"
  },
  {
    "codigo":444661007,
    "descripcion":"EMBARAZO DE ALTO RIESGO DEBIDO A ANTECEDENTE DE PARTO PRETÉRMINO"
  },
  {
    "codigo":51445007,
    "descripcion":"PROTANOPÍA"
  },
  {
    "codigo":248053009,
    "descripcion":"CONDUCTA DE AUTOCUIDADO"
  },
  {
    "codigo":10968321000119102,
    "descripcion":"LACERACIÓN DE DEDO GORDO IZQUIERDO"
  },
  {
    "codigo":410058007,
    "descripcion":"HISTIDINEMIA"
  },
  {
    "codigo":1260191006,
    "descripcion":"SÍNDROME DE IRRADIACIÓN AGUDA"
  },
  {
    "codigo":735903009,
    "descripcion":"ESGUINCE DE LIGAMENTO DE TRONCO"
  },
  {
    "codigo":703135009,
    "descripcion":"ANEMIA EN ENFERMEDAD NEOPLÁSICA MALIGNA"
  },
  {
    "codigo":13172003,
    "descripcion":"PÚRPURA TROMBOCITOPÉNICA IDIOPÁTICA CRÓNICA"
  },
  {
    "codigo":439156006,
    "descripcion":"DEFICIENCIA ADQUIRIDA COMBINADA DE FACTORES DE LA COAGULACIÓN"
  },
  {
    "codigo":11761051000119100,
    "descripcion":"RUPTURA TRAUMÁTICA DE LIGAMENTO CRUZADO POSTERIOR DE RODILLA IZQUIERDA"
  },
  {
    "codigo":109641000,
    "descripcion":"PELLIZCAMIENTO DE APÓFISIS CORONOIDES MANDIBULAR"
  },
  {
    "codigo":240713001,
    "descripcion":"CANDIDIASIS DE LA MEMBRANA DIGITAL"
  },
  {
    "codigo":11337002,
    "descripcion":"PRIMEROS MOVIMIENTOS FETALES"
  },
  {
    "codigo":76873001,
    "descripcion":"POLICITEMIA POR TRANSFUSIÓN MATERNO - FETAL"
  },
  {
    "codigo":207945004,
    "descripcion":"FRACTURA NO EXPUESTA DE VÉRTEBRA DORSAL, TRICOLUMNAR"
  },
  {
    "codigo":763272003,
    "descripcion":"TRISOMÍA DISTAL 2Q"
  },
  {
    "codigo":402718003,
    "descripcion":"PÉNFIGO PARANEOPLÁSICO"
  },
  {
    "codigo":11787521000119109,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE DEDO MEÑIQUE DERECHO"
  },
  {
    "codigo":75038005,
    "descripcion":"HEMORRAGIA CEREBELOSA"
  },
  {
    "codigo":238878006,
    "descripcion":"MILIUM COLOIDE ADQUIRIDO"
  },
  {
    "codigo":1285619001,
    "descripcion":"HEMATOMA DE REGIÓN DE CODO"
  },
  {
    "codigo":7667005,
    "descripcion":"ESPÉCIMEN MUESTRA CITÓLISIS EXCESIVA"
  },
  {
    "codigo":237043008,
    "descripcion":"PERIHEPATITIS POR CLAMIDIAS"
  },
  {
    "codigo":366280007,
    "descripcion":"VELOCIDAD DE FLUJO URINARIO - HALLAZGO"
  },
  {
    "codigo":298909000,
    "descripcion":"AMPLITUD DE SUPINACIÓN PASIVA DE CODO AUMENTADA"
  },
  {
    "codigo":300744007,
    "descripcion":"CAPAZ DE USAR INSTALACIONES RECREATIVAS PÚBLICAS"
  },
  {
    "codigo":724893003,
    "descripcion":"DISTENSIÓN DE MÚSCULO DE PELVIS"
  },
  {
    "codigo":11842971000119108,
    "descripcion":"LACERACIÓN DE ARTERIA CARÓTIDA DERECHA"
  },
  {
    "codigo":231538003,
    "descripcion":"TRASTORNO EMOCIONAL Y CONDUCTUAL, DE INICIO EN LA INFANCIA"
  },
  {
    "codigo":297074007,
    "descripcion":"SOBREDOSIS DE FÁRMACO VASODILATADOR"
  },
  {
    "codigo":67698009,
    "descripcion":"PENSAMIENTOS OBSESIVOS"
  },
  {
    "codigo":721223002,
    "descripcion":"ENFERMEDAD DE HIRSCHSPRUNG CON HIPOPLASIA UNGUEAL Y DISMORFISMO"
  },
  {
    "codigo":295239001,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE FENBUFÉN"
  },
  {
    "codigo":424476000,
    "descripcion":"EXCESO DE GRASA SUBCUTÁNEA EN EL DORSO"
  },
  {
    "codigo":229703009,
    "descripcion":"DISPRAXIA VERBAL DEL DESARROLLO"
  },
  {
    "codigo":293404002,
    "descripcion":"REACCIÓN ADVERSA A RESINA DE INTERCAMBIO IÓNICO"
  },
  {
    "codigo":719388005,
    "descripcion":"CAPAZ DE UTILIZAR COMBINACIONES DE CONSONANTE-VOCAL-CONSONANTE-VOCAL"
  },
  {
    "codigo":291569001,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR CEFAZOLINA"
  },
  {
    "codigo":675381000119107,
    "descripcion":"IRIDOCICLITIS SUBAGUDA DE OJO DERECHO"
  },
  {
    "codigo":160497005,
    "descripcion":"ALOJADO EN HOGAR SUSTITUTO"
  },
  {
    "codigo":783089006,
    "descripcion":"SÍNDROME DE MACROCEFALIA, DISCAPACIDAD INTELECTUAL Y AUTISMO"
  },
  {
    "codigo":94961007,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE HUESO ESCAFOIDES"
  },
  {
    "codigo":224198000,
    "descripcion":"RETRASO PARA RECIBIR LOS SUBSIDIOS"
  },
  {
    "codigo":289734004,
    "descripcion":"CONTRACCIÓN UTERINA RETRASADA"
  },
  {
    "codigo":138464821000119109,
    "descripcion":"CUERPO EXTRAÑO MAGNÉTICO RETENIDO EN CRISTALINO DE OJO DERECHO"
  },
  {
    "codigo":93126006,
    "descripcion":"FALTA DE OSIFICACIÓN DEL CÚBITO"
  },
  {
    "codigo":1010630006,
    "descripcion":"DISGENESIA DEL CUERPO CALLOSO COMPLEJA LIGADA AL CROMOSOMA X"
  },
  {
    "codigo":255131000,
    "descripcion":"CARCINOMA IN SITU DE CAVIDAD ORAL, LABIO Y GLÁNDULAS SALIVALES"
  },
  {
    "codigo":27590007,
    "descripcion":"ESOTROPÍA INTERMITENTE"
  },
  {
    "codigo":1303707002,
    "descripcion":"GLAUCOMA DE OJO IZQUIERDO CAUSADO POR ACEITE DE SILICONA"
  },
  {
    "codigo":1172635005,
    "descripcion":"SÍNDROME DE MALFORMACIÓN DE PIE HENDIDO Y POLIDACTILIA MESOAXIAL"
  },
  {
    "codigo":91291006,
    "descripcion":"ARTROPATÍA ASOCIADA CON OTRA ENFERMEDAD SISTÉMICA"
  },
  {
    "codigo":124059008,
    "descripcion":"NIVEL DE ÁCIDO BETAAMINOISOBUTÍRICO POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":449904002,
    "descripcion":"MALFORMACIÓN ARTERIOVENOSA DE MÉDULA ESPINAL, TIPO GLOMO INTRAMEDULAR"
  },
  {
    "codigo":286064003,
    "descripcion":"DIFICULTAD PARA PLANCHAR"
  },
  {
    "codigo":89456004,
    "descripcion":"VALVULITIS REUMÁTICA CRÓNICA"
  },
  {
    "codigo":56688005,
    "descripcion":"INFECCIÓN POR CLOSTRIDIOS"
  },
  {
    "codigo":187760008,
    "descripcion":"NEOPLASIA MALIGNA DEL RECTO, UNIÓN RECTOSIGMOIDE Y ANO"
  },
  {
    "codigo":87621000,
    "descripcion":"HIPEREMESIS GRAVÍDICA ANTES DEL FIN DE LA SEMANA 22 DE GESTACIÓN CON DESHIDRATACIÓN"
  },
  {
    "codigo":472328003,
    "descripcion":"SÍNDROME DE IMPACTACIÓN CUBITAL"
  },
  {
    "codigo":251461007,
    "descripcion":"ACTIVIDAD THETA DE BAJA FRECUENCIA"
  },
  {
    "codigo":216858002,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR FREÓN"
  },
  {
    "codigo":184090004,
    "descripcion":"PACIENTE QUE TRABAJA LEJOS"
  },
  {
    "codigo":446234004,
    "descripcion":"QUEMADURA DE SACO CONJUNTIVAL POR SUSTANCIA QUÍMICA ALCALINA"
  },
  {
    "codigo":20250007,
    "descripcion":"DEPRESIÓN MAYOR GRAVE, UN SOLO EPISODIO, CON SÍNTOMAS PSICÓTICOS, INCONGRUENTE CON EL ESTADO DE ÁNIMO"
  },
  {
    "codigo":51183001,
    "descripcion":"REACCIÓN DESFAVORABLE A LA PRUEBA CUTÁNEA"
  },
  {
    "codigo":313327004,
    "descripcion":"PÓLIPO CLOACÓGENO INFLAMATORIO"
  },
  {
    "codigo":724872001,
    "descripcion":"LESIÓN TRAUMÁTICA OCUPACIONAL DE LA PIEL CAUSADA POR SUSTANCIA CORROSIVA"
  },
  {
    "codigo":870383008,
    "descripcion":"DEFICIENCIA DE 24-HIDROXILASA"
  },
  {
    "codigo":213188001,
    "descripcion":"FALLA TOTAL DE REIMPLANTE DE DEDO DEL PIE"
  },
  {
    "codigo":409796004,
    "descripcion":"INFECCIÓN CAUSADA POR BACTERIAS RESISTENTES A AGENTES ANTIMICROBIANOS"
  },
  {
    "codigo":1360068005,
    "descripcion":"ÁNGULO ESTRECHO DE OJO DERECHO"
  },
  {
    "codigo":1163460006,
    "descripcion":"UVEÍTIS INTERMEDIA CAUSADA POR BORRELIA BURGDORFERI"
  },
  {
    "codigo":735641000,
    "descripcion":"FINGIMIENTO DE SÍNTOMAS"
  },
  {
    "codigo":82116008,
    "descripcion":"NEURALGIA ALUCINATORIA"
  },
  {
    "codigo":349731000221103,
    "descripcion":"LESIÓN PULMONAR ASOCIADA AL USO CIGARRILLO ELECTRÓNICO"
  },
  {
    "codigo":80281008,
    "descripcion":"LABIO LEPORINO"
  },
  {
    "codigo":536611000221106,
    "descripcion":"OCLUSIÓN DE ARTERIA TIBIAL POSTERIOR DERECHA"
  },
  {
    "codigo":111214005,
    "descripcion":"ARTROPATÍA ASOCIADA CON UNA MICOSIS"
  },
  {
    "codigo":897646005,
    "descripcion":"MELANOSIS ADQUIRIDA PRIMARIA BILATERAL DE CONJUNTIVA"
  },
  {
    "codigo":45678008,
    "descripcion":"FRACTURA DE MÚLTIPLES HUESOS DE LA EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":109379000,
    "descripcion":"DEFECTO TRAUMÁTICO DEL TABIQUE INTERVENTRICULAR"
  },
  {
    "codigo":240451000,
    "descripcion":"SÍNDROME DE CHOQUE TÓXICO POR ESTREPTOCOCOS"
  },
  {
    "codigo":11819011000119104,
    "descripcion":"ESGUINCE DE LIGAMENTO ACROMIOCLAVICULAR DERECHO"
  },
  {
    "codigo":22531000119104,
    "descripcion":"PROLAPSO DE DISCO INTERVERTEBRAL CERVICAL SIN RADICULOPATÍA"
  },
  {
    "codigo":830275007,
    "descripcion":"PUNCIÓN ACCIDENTAL DE DURAMADRE"
  },
  {
    "codigo":16652291000119105,
    "descripcion":"CHALACIÓN BILATERAL DE PÁRPADOS"
  },
  {
    "codigo":42008001,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE MUSLO, CON INFECCIÓN"
  },
  {
    "codigo":74776002,
    "descripcion":"PICAZÓN DE OJO"
  },
  {
    "codigo":402456003,
    "descripcion":"PSEUDOESCLERODERMIA DEBIDA A AMILOIDOSIS DE CADENA LIGERA"
  },
  {
    "codigo":238616004,
    "descripcion":"PSORIASIS PUSTULOSA INFANTIL"
  },
  {
    "codigo":677891000119106,
    "descripcion":"QUISTE MACULAR DE OJO IZQUIERDO"
  },
  {
    "codigo":764739008,
    "descripcion":"SÍNDROME DE DELECIÓN PROXIMAL DEL CROMOSOMA 18Q"
  },
  {
    "codigo":369688009,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA DEL COLÉDOCO, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":1187053001,
    "descripcion":"CLORURO EN SUERO POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":236781003,
    "descripcion":"INFLAMACIÓN DEL ESCROTO"
  },
  {
    "codigo":204013004,
    "descripcion":"ESPINA BÍFIDA SACRA SIN HIDROCEFALIA - CERRADA"
  },
  {
    "codigo":105709005,
    "descripcion":"ENFERMEDAD CAUSADA POR RHABDIASOIDEA"
  },
  {
    "codigo":7405009,
    "descripcion":"HIPERNATREMIA AGUDA"
  },
  {
    "codigo":300482003,
    "descripcion":"HALLAZGO RELACIONADO CON LA APARIENCIA DE LOS TESTÍCULOS"
  },
  {
    "codigo":202178003,
    "descripcion":"LUXACIÓN PATOLÓGICA DE LA ARTICULACIÓN HUMEROCUBITAL"
  },
  {
    "codigo":12202141000119103,
    "descripcion":"LUXACIÓN RECURRENTE DE PRÓTESIS DE ARTICULACIÓN DE CADERA IZQUIERDA"
  },
  {
    "codigo":366018004,
    "descripcion":"ASPECTO DEL ÁNGULO - HALLAZGO"
  },
  {
    "codigo":429719000,
    "descripcion":"CUERPO EXTRAÑO EN ANTEBRAZO"
  },
  {
    "codigo":724631000,
    "descripcion":"PROBLEMA DE MUSLO"
  },
  {
    "codigo":298647007,
    "descripcion":"AMPLITUD DE ROTACIÓN ACTIVA HACIA LA DERECHA DE LA COLUMNA LUMBAR NORMAL"
  },
  {
    "codigo":69271009,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DE LA MEJILLA"
  },
  {
    "codigo":34668002,
    "descripcion":"INTOXICACIÓN POR CARBOFURANO"
  },
  {
    "codigo":427884004,
    "descripcion":"DISFUNCIÓN DE MÚSCULO OBLICUO INFERIOR"
  },
  {
    "codigo":131137002,
    "descripcion":"NIVEL DE INMUNOGLOBULINA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1343553005,
    "descripcion":"TC DE VESÍCULA BILIAR CON CONTRASTE ANORMAL"
  },
  {
    "codigo":294977006,
    "descripcion":"ALERGIA A DISOPIRAMIDA"
  },
  {
    "codigo":293142002,
    "descripcion":"REACCIÓN ADVERSA A LA BETAMETASONA"
  },
  {
    "codigo":193003000,
    "descripcion":"EPILEPSIA DE LÓBULO TEMPORAL LÍMBICA MESIOBASAL"
  },
  {
    "codigo":782827000,
    "descripcion":"SARCOMA EPITELIOIDE"
  },
  {
    "codigo":94699003,
    "descripcion":"HÍGADO MOTEADO"
  },
  {
    "codigo":225771003,
    "descripcion":"CONDUCTA SUMISA"
  },
  {
    "codigo":1208811003,
    "descripcion":"ALERGIA A PROTEÍNA DE CABALLO"
  },
  {
    "codigo":422379007,
    "descripcion":"CARECE DE EDUCACIÓN EMOCIONAL"
  },
  {
    "codigo":29301000175105,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN DE GLÚTEO IZQUIERDO GRADO 3"
  },
  {
    "codigo":420544002,
    "descripcion":"NEUMONÍA BACTERIANA CON SÍNDROME DE INMUNODEFICIENCIA ADQUIRIDA"
  },
  {
    "codigo":8821000175107,
    "descripcion":"DÉFICIT NEUROVASCULAR"
  },
  {
    "codigo":92864004,
    "descripcion":"FUSIÓN ANORMAL CONGÉNITA DE LOS LÓBULOS HEPÁTICOS"
  },
  {
    "codigo":289472005,
    "descripcion":"LABIOS MENORES DE LA VULVA, GRANDES"
  },
  {
    "codigo":254869000,
    "descripcion":"TUMOR MALIGNO DE CÉLULAS GERMINALES DEL OVARIO"
  },
  {
    "codigo":125632009,
    "descripcion":"LESIÓN TRAUMÁTICA DEL COLON TRANSVERSO"
  },
  {
    "codigo":1303445002,
    "descripcion":"MALFORMACIÓN DORSAL LIMITADA MIÉLICA"
  },
  {
    "codigo":58261003,
    "descripcion":"POSICIÓN SACROILÍACA POSTERIOR"
  },
  {
    "codigo":416874005,
    "descripcion":"DESPLAZAMIENTO SUPERIOR DEL PUBIS"
  },
  {
    "codigo":449642006,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE PIERNA, CON INFECCIÓN"
  },
  {
    "codigo":283967000,
    "descripcion":"RUPTURA DE LA VAGINA"
  },
  {
    "codigo":89194009,
    "descripcion":"ABSCESO AGUDO DE SENO MAXILAR"
  },
  {
    "codigo":251199005,
    "descripcion":"ROTACIÓN CARDÍACA ANTIHORARIA"
  },
  {
    "codigo":1090001000119105,
    "descripcion":"OTITIS MEDIA DEBIDA A ESCARLATINA"
  },
  {
    "codigo":352721000119106,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE ÓRBITA IZQUIERDA"
  },
  {
    "codigo":216596005,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR HIOSCINA"
  },
  {
    "codigo":413204008,
    "descripcion":"MUCOSA GRANULAR DE ESTRUCTURA DE ÓRGANO DIGESTIVO"
  },
  {
    "codigo":249364008,
    "descripcion":"ADENOIDES REMANENTES"
  },
  {
    "codigo":1359806000,
    "descripcion":"COLONIZACIÓN CRÓNICA DE TRACTO RESPIRATORIO CAUSADA POR PSEUDOMONAS AERUGINOSA"
  },
  {
    "codigo":50921008,
    "descripcion":"PERIARTRITIS"
  },
  {
    "codigo":737214003,
    "descripcion":"ENTESOPATÍA DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":704446005,
    "descripcion":"CONOCIMIENTO DEFICIENTE SOBRE EJERCICIO"
  },
  {
    "codigo":212926006,
    "descripcion":"CONGELAMIENTO CON NECROSIS TISULAR DEL CUELLO"
  },
  {
    "codigo":81854007,
    "descripcion":"ENFERMEDAD DE ALEXANDER"
  },
  {
    "codigo":276627004,
    "descripcion":"UREMIA CONGÉNITA"
  },
  {
    "codigo":14483005,
    "descripcion":"CONSISTENCIA GRANULOSA GRUESA"
  },
  {
    "codigo":48561000087102,
    "descripcion":"FRACTURA DE MALÉOLO EXTERNO DE PERONÉ IZQUIERDO"
  },
  {
    "codigo":243859006,
    "descripcion":"SITUACIÓN DEL MONITOREO DE LA GOTA"
  },
  {
    "codigo":702611008,
    "descripcion":"APLASIA CONGÉNITA DE CEREBRO"
  },
  {
    "codigo":768147005,
    "descripcion":"LESIÓN TRAUMÁTICA DEBIDA A ACCIDENTE AUTOMOVILÍSTICO"
  },
  {
    "codigo":80019009,
    "descripcion":"ENFERMEDAD POR EL VIRUS LEBOMBO"
  },
  {
    "codigo":38321000087102,
    "descripcion":"HIPOCINESIA DE MIOCARDIO DE REGIÓN INFEROLATERAL DE VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":40881000087108,
    "descripcion":"QUEMADURA DE MAMA IZQUIERDA"
  },
  {
    "codigo":1259667007,
    "descripcion":"DEMENCIA DEBIDA A ENCEFALITIS PARANEOPLÁSICA"
  },
  {
    "codigo":373096006,
    "descripcion":"FÍSTULA CORONARIA AL VENTRÍCULO DERECHO"
  },
  {
    "codigo":209256002,
    "descripcion":"FRACTURA-LUXACIÓN EXPUESTA DE LA ARTICULACIÓN RADIOCUBITAL SUPERIOR"
  },
  {
    "codigo":45416008,
    "descripcion":"INTOXICACIÓN POR CHRYSOCOMA TENUIFOLIA"
  },
  {
    "codigo":43441000087109,
    "descripcion":"HERIDA ABIERTA DE PÁRPADO INFERIOR IZQUIERDO"
  },
  {
    "codigo":405864008,
    "descripcion":"FENOTIPO LE(A+)"
  },
  {
    "codigo":76349003,
    "descripcion":"ENFERMEDAD EXTRAPIRAMIDAL"
  },
  {
    "codigo":10813004,
    "descripcion":"BLEFAROCONJUNTIVITIS POR CONTACTO"
  },
  {
    "codigo":404029005,
    "descripcion":"NEUROFIBROMA"
  },
  {
    "codigo":305725003,
    "descripcion":"ATENDIDO POR CIRUJANO DE PÁNCREAS"
  },
  {
    "codigo":135941000119102,
    "descripcion":"CARCINOMA DE CÉLULAS DE MERKEL PRIMARIO DE PIEL DE GENITALES"
  },
  {
    "codigo":43581009,
    "descripcion":"TIÑA PEDIA CAUSADA POR EPIDERMOPHYTON"
  },
  {
    "codigo":271122005,
    "descripcion":"AMPOLLA TRAUMÁTICA DE GLÚTEO"
  },
  {
    "codigo":402194008,
    "descripcion":"QUEILITIS POR DERMATITIS ATÓPICA"
  },
  {
    "codigo":299781000119104,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE TENDÓN EXTENSOR DE MANO"
  },
  {
    "codigo":269287005,
    "descripcion":"HIPOTERMIA CAUSADA POR ANESTÉSICO"
  },
  {
    "codigo":302055006,
    "descripcion":"CAPAZ DE IMITAR LOS MOVIMIENTOS DE LA LENGUA"
  },
  {
    "codigo":236519008,
    "descripcion":"ENFERMEDAD RENAL CRÓNICA INDUCIDA POR FÁRMACO"
  },
  {
    "codigo":365756002,
    "descripcion":"NIVEL DE CREATININA - HALLAZGO"
  },
  {
    "codigo":726204005,
    "descripcion":"DISTENSIÓN DE TENDÓN DE MÚSCULO INTRÍNSECO DE DEDO DE LA MANO"
  },
  {
    "codigo":300220006,
    "descripcion":"AUDICIÓN DEL SUSURRO, NORMAL"
  },
  {
    "codigo":298385001,
    "descripcion":"HALLAZGO RELACIONADO CON LAS VÉRTEBRAS"
  },
  {
    "codigo":1092511000119101,
    "descripcion":"CHOQUE SÉPTICO CONCOMITANTE CON DISFUNCIÓN ORGÁNICA AGUDA DEBIDO A COCO GRAMPOSITIVO"
  },
  {
    "codigo":429457004,
    "descripcion":"HIPERTENSIÓN SISTÓLICA ESENCIAL"
  },
  {
    "codigo":36241006,
    "descripcion":"BOCIO MULTINODULAR NO TÓXICO"
  },
  {
    "codigo":722534001,
    "descripcion":"ULCERACIÓN NO INFECCIOSA DE INTESTINO DELGADO"
  },
  {
    "codigo":11768581000119109,
    "descripcion":"HEMATOMA SUBUNGUEAL DE DEDO ÍNDICE DE MANO IZQUIERDA"
  },
  {
    "codigo":34406007,
    "descripcion":"TRASTORNO OCULAR DE LOS MOVIMIENTOS DE SEGUIMIENTO LENTOS"
  },
  {
    "codigo":296550007,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE IDOXURIDINA"
  },
  {
    "codigo":165478007,
    "descripcion":"ERITROCITO DE FORMA NORMAL"
  },
  {
    "codigo":425787003,
    "descripcion":"NO PUEDE DETERMINARSE LA EXISTENCIA DE NECROSIS TUMORAL"
  },
  {
    "codigo":65339005,
    "descripcion":"ACCIDENTE RELACIONADO CON LA ACTIVIDAD LABORAL"
  },
  {
    "codigo":1144848002,
    "descripcion":"ESCASO CRECIMIENTO DE PELO"
  },
  {
    "codigo":423952006,
    "descripcion":"FASCICULACIÓN FACIAL BENIGNA"
  },
  {
    "codigo":129040008,
    "descripcion":"ASISTENCIA PARA EL BAÑO"
  },
  {
    "codigo":30736009,
    "descripcion":"DISFONÍA DE MIOCLONÍA PALATOFARINGOLARÍNGEA"
  },
  {
    "codigo":225509003,
    "descripcion":"IMAGEN DE SÍ MISMO SATISFACTORIA"
  },
  {
    "codigo":192741005,
    "descripcion":"ABSCESO INTRACRANEAL OTOGÉNICO"
  },
  {
    "codigo":127205007,
    "descripcion":"LINFADENOPATÍA INGUINAL INFERIOR"
  },
  {
    "codigo":92602000,
    "descripcion":"CARCINOMA IN SITU DEL GLANDE DEL PENE"
  },
  {
    "codigo":94437009,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL CORNETE ETMOIDAL DE LA NARIZ"
  },
  {
    "codigo":289210008,
    "descripcion":"HALLAZGO RELACIONADO CON LA PRIMERA ETAPA DEL TRABAJO DE PARTO"
  },
  {
    "codigo":123535000,
    "descripcion":"FRACTURA EXPUESTA DE SACRO Y\/O CÓCCIX CON LESIÓN DE LA COLA DE CABALLO"
  },
  {
    "codigo":1335951002,
    "descripcion":"EPISODIO DE USO NOCIVO DE ANSIOLÍTICO"
  },
  {
    "codigo":1081000119105,
    "descripcion":"DEPENDENCIA DE OPIÁCEOS, EN TRATAMIENTO CON AGONISTA"
  },
  {
    "codigo":285540002,
    "descripcion":"DIFICULTAD PARA MOVER LA LENGUA LATERALMENTE"
  },
  {
    "codigo":1137508008,
    "descripcion":"DEBILIDAD DE MÚSCULO RECTO INTERNO"
  },
  {
    "codigo":711524008,
    "descripcion":"ATROFODERMIA IDIOPÁTICA DE PASINI Y PIERINI"
  },
  {
    "codigo":250937000,
    "descripcion":"ECOGENICIDAD DE LA PARED VENTRICULAR IZQUIERDA"
  },
  {
    "codigo":11771091000119101,
    "descripcion":"ESGUINCE DE LIGAMENTO DE ARTICULACIÓN DE CODO IZQUIERDO"
  },
  {
    "codigo":283705004,
    "descripcion":"MORDEDURA HUMANA EN LA MANO"
  },
  {
    "codigo":185401005,
    "descripcion":"PACIENTE QUE CONCURRE MÁS DE UNA VEZ POR MES"
  },
  {
    "codigo":54329005,
    "descripcion":"INFARTO AGUDO DE MIOCARDIO DE PARED ANTERIOR"
  },
  {
    "codigo":19726003,
    "descripcion":"PIEL LAXA, FORMA ADQUIRIDA"
  },
  {
    "codigo":249102004,
    "descripcion":"POSICIÓN SACROPOSTERIOR DIRECTA"
  },
  {
    "codigo":183566003,
    "descripcion":"DERIVADO A RADIOTERAPIA"
  },
  {
    "codigo":85262003,
    "descripcion":"SÍNDROME MEDULAR POSTERIOR DEBIDO A FRACTURA EXPUESTA A NIVEL DE T1 - T6"
  },
  {
    "codigo":738787001,
    "descripcion":"METABOLIZADOR INTERMEDIO DE LA FAMILIA 2 SUBFAMILIA C MIEMBRO 19 DEL CITOCROMO P450"
  },
  {
    "codigo":17891004,
    "descripcion":"CLONO SOSTENIDO"
  },
  {
    "codigo":247267005,
    "descripcion":"TÍMPANO NO VISIBLE"
  },
  {
    "codigo":212664005,
    "descripcion":"INTOXICACIÓN CON HIDROXIZINA"
  },
  {
    "codigo":276365000,
    "descripcion":"ÚTERO FIJO"
  },
  {
    "codigo":702349003,
    "descripcion":"MIOPATÍA POR ACUMULACIÓN DE ACTINA"
  },
  {
    "codigo":210829005,
    "descripcion":"LESIÓN EXPUESTA, VENA AXILAR"
  },
  {
    "codigo":1259405006,
    "descripcion":"CARCINOMA PRIMARIO DE COLON DESCENDENTE"
  },
  {
    "codigo":766050000,
    "descripcion":"SÍNDROME DE MONOSOMÍA DISTAL 15Q"
  },
  {
    "codigo":208994001,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA DE DEDO DE PIE, ÚNICA"
  },
  {
    "codigo":1290338002,
    "descripcion":"ESFUERZO RESPIRATORIO NORMAL"
  },
  {
    "codigo":45154002,
    "descripcion":"GLUCOSURIA"
  },
  {
    "codigo":274530001,
    "descripcion":"HALLAZGOS ANORMALES EN IMÁGENES DIAGNÓSTICAS DE MAMA"
  },
  {
    "codigo":405602007,
    "descripcion":"HIPERINSUFLACIÓN DE MANGUITO DE DISPOSITIVO PARA LA VÍA AÉREA"
  },
  {
    "codigo":241762008,
    "descripcion":"INTOXICACIÓN CAUSADA POR BLOQUEANTE BETA-ADRENÉRGICO"
  },
  {
    "codigo":733282009,
    "descripcion":"LESIÓN TRAUMÁTICA DE ARTERIA FEMORAL"
  },
  {
    "codigo":370999003,
    "descripcion":"HIPOGONADISMO PRIMARIO"
  },
  {
    "codigo":698679006,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: RUNDI"
  },
  {
    "codigo":403767009,
    "descripcion":"ACROCEFALOPOLISINDACTILIA TIPO II"
  },
  {
    "codigo":239927009,
    "descripcion":"POLIARTERITIS NUDOSA CON COMPROMISO MULTIORGÁNICO"
  },
  {
    "codigo":238092004,
    "descripcion":"ENFERMEDAD DEL OJO DE PEZ"
  },
  {
    "codigo":72417002,
    "descripcion":"CONTRACCIÓN UTERINA TUMULTUOSA"
  },
  {
    "codigo":15977991000119101,
    "descripcion":"QUISTE DE AMBAS GLÁNDULAS PARÓTIDAS"
  },
  {
    "codigo":16905581000119107,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE PIEL DE PÁRPADO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":400097005,
    "descripcion":"UÑA ENCARNADA"
  },
  {
    "codigo":170721002,
    "descripcion":"CAMBIO DE SÍNTOMA OFTALMOLÓGICO"
  },
  {
    "codigo":203489009,
    "descripcion":"OSTEÍTIS CONDENSANTE ILÍACA"
  },
  {
    "codigo":37814003,
    "descripcion":"HIPERGLUCEMIA POSTPANCREATECTOMÍA"
  },
  {
    "codigo":398262004,
    "descripcion":"RUPTURA DE EPISIOTOMÍA EN EL PUERPERIO"
  },
  {
    "codigo":365494003,
    "descripcion":"HALLAZGO RELACIONADO CON LA CALIDAD DEL CUIDADO INFORMAL"
  },
  {
    "codigo":70582006,
    "descripcion":"CICATRIZ DE LA PIEL"
  },
  {
    "codigo":234422006,
    "descripcion":"PORFIRIA INTERMITENTE AGUDA"
  },
  {
    "codigo":35979000,
    "descripcion":"FLEBITIS DE LA VENA FEMOROPOPLÍTEA"
  },
  {
    "codigo":429195002,
    "descripcion":"RINITIS ALÉRGICA CAUSADA POR CASPA ANIMAL"
  },
  {
    "codigo":298123004,
    "descripcion":"LESIÓN SUPERFICIAL DE NERVIO RADIAL"
  },
  {
    "codigo":1376001,
    "descripcion":"TRASTORNO OBSESIVO-COMPULSIVO DE LA PERSONALIDAD"
  },
  {
    "codigo":296288005,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE SELEGILINA"
  },
  {
    "codigo":230752005,
    "descripcion":"HIDROCEFALIA POR DEFECTO DE ABSORCIÓN DEL LÍQUIDO CEFALORRAQUÍDEO"
  },
  {
    "codigo":294453005,
    "descripcion":"ALERGIA A NICLOSAMIDA"
  },
  {
    "codigo":1144586002,
    "descripcion":"DOLOR AUMENTADO"
  },
  {
    "codigo":718602007,
    "descripcion":"SÍNDROME HEREDITARIO DE MÚLTIPLES CALCIFICACIONES ARTERIALES Y ARTICULARES"
  },
  {
    "codigo":292618009,
    "descripcion":"REACCIÓN ADVERSA A PREPARADOS BRONCODILATADORES"
  },
  {
    "codigo":94175004,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE APÉNDICE"
  },
  {
    "codigo":389087006,
    "descripcion":"HIPOXEMIA"
  },
  {
    "codigo":126943008,
    "descripcion":"ANSIEDAD DE SEPARACIÓN"
  },
  {
    "codigo":59572000,
    "descripcion":"NECROSIS DE LA HIPÓFISIS"
  },
  {
    "codigo":288948002,
    "descripcion":"INCAPAZ DE TRAGAR LÍQUIDOS"
  },
  {
    "codigo":61407009,
    "descripcion":"MIELITIS POR PROTOZOARIOS"
  },
  {
    "codigo":190644002,
    "descripcion":"OSTEOMALACIA SENIL"
  },
  {
    "codigo":90505000,
    "descripcion":"RAQUITISMO HIPOFOSFATÉMICO AUTOSÓMICO RECESIVO, REFRACTARIO A VITAMINA D"
  },
  {
    "codigo":304801000119107,
    "descripcion":"DETENCIÓN TOTAL DEL CRECIMIENTO EPIFISARIO DE RADIO DISTAL IZQUIERDO"
  },
  {
    "codigo":418185003,
    "descripcion":"APERTURA BUCAL NO EVALUABLE"
  },
  {
    "codigo":140961000119107,
    "descripcion":"DEPÓSITOS EN LENTE INTRAOCULAR QUE DIFICULTAN LA VISIÓN"
  },
  {
    "codigo":416350001,
    "descripcion":"FLUCTUACIÓN DEL LÍQUIDO CEFALORRAQUÍDEO"
  },
  {
    "codigo":449118008,
    "descripcion":"OBSTRUCCIÓN DE TRACTO DE SALIDA DE VENTRÍCULO IZQUIERDO DEBIDA A VÁLVULA ARTERIAL PROLAPSADA"
  },
  {
    "codigo":283443000,
    "descripcion":"CORTE EN LA PLANTA DEL PIE"
  },
  {
    "codigo":54067004,
    "descripcion":"INTOXICACIÓN POR RONNEL"
  },
  {
    "codigo":368971000119101,
    "descripcion":"HEMATURIA CONCOMITANTE CON CISTITIS CRÓNICA Y DEBIDA A ELLA"
  },
  {
    "codigo":333131000119102,
    "descripcion":"QUERATOCONJUNTIVITIS FLICTENULAR DE OJO DERECHO"
  },
  {
    "codigo":232417611000119100,
    "descripcion":"MICROANGIOPATÍA TROMBÓTICA POSTERIOR A TRASPLANTE DE CÉLULAS MADRE HEMATOPOYÉTICAS"
  },
  {
    "codigo":1332019008,
    "descripcion":"OSTEÓLISIS DE FÉMUR IZQUIERDO"
  },
  {
    "codigo":16079691000119105,
    "descripcion":"ESTUDIO POR IMÁGENES DEL SISTEMA NERVIOSO CENTRAL ANORMAL"
  },
  {
    "codigo":351051000119106,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE EXTREMIDAD SUPERIOR DERECHA"
  },
  {
    "codigo":1080651000119104,
    "descripcion":"LIPOMA DE MIEMBRO INFERIOR IZQUIERDO"
  },
  {
    "codigo":322891000119104,
    "descripcion":"DEDO ÍNDICE IZQUIERDO EN GATILLO ADQUIRIDO"
  },
  {
    "codigo":12267851000119108,
    "descripcion":"TROMBOSIS ASOCIADA CON CATÉTER DE HEMODIÁLISIS"
  },
  {
    "codigo":1085771000119109,
    "descripcion":"FÍSTULA DE INTESTINO GRUESO DEBIDA A ENFERMEDAD DE CROHN"
  },
  {
    "codigo":12270411000119104,
    "descripcion":"SED DEBIDA A PRIVACIÓN DE AGUA"
  },
  {
    "codigo":292171000119107,
    "descripcion":"PARÁLISIS DE NERVIO CIÁTICO POPLÍTEO EXTERNO IZQUIERDO"
  },
  {
    "codigo":133451000119109,
    "descripcion":"ALTERACIÓN DE LA ALINEACIÓN DE LA SÍNFISIS DEL PUBIS"
  },
  {
    "codigo":52232007,
    "descripcion":"ÍLEO DUODENAL CRÓNICO"
  },
  {
    "codigo":1197277003,
    "descripcion":"COMPRESIÓN DE LA MÉDULA ESPINAL DEBIDA A NEOPLASIA"
  },
  {
    "codigo":248840007,
    "descripcion":"HALLAZGO RELACIONADO CON EL FLUJO DE LECHE MATERNA"
  },
  {
    "codigo":100171000119109,
    "descripcion":"RINOSINUSITIS MUCINOSA EOSINOFÍLICA"
  },
  {
    "codigo":153931000119109,
    "descripcion":"INSUFICIENCIA CARDÍACA AGUDA SISTÓLICA Y DIASTÓLICA COMBINADA"
  },
  {
    "codigo":445448008,
    "descripcion":"LEUCEMIA MIELOIDE AGUDA CON CAMBIOS RELACIONADOS CON MIELODISPLASIA"
  },
  {
    "codigo":247005008,
    "descripcion":"HUMOR VÍTREO EN CÁMARA ANTERIOR"
  },
  {
    "codigo":50397009,
    "descripcion":"FRACTURA NO EXPUESTA DE EXTREMO DISTAL DE CÚBITO"
  },
  {
    "codigo":13959000,
    "descripcion":"GINGIVITIS ULCERATIVA"
  },
  {
    "codigo":46727001,
    "descripcion":"TRASTORNO DEL METABOLISMO DEL CINC"
  },
  {
    "codigo":276103000,
    "descripcion":"HOGAR DESDICHADO"
  },
  {
    "codigo":210567001,
    "descripcion":"SECCIÓN TOTAL DEL TENDÓN DEL EXTENSOR DE LA MANO"
  },
  {
    "codigo":308871000,
    "descripcion":"DISPLASIA LEVE DE COLON"
  },
  {
    "codigo":12103791000119100,
    "descripcion":"QUEMADURA DE PIE DERECHO"
  },
  {
    "codigo":403505001,
    "descripcion":"CALCINOSIS ASOCIADA CON LUPUS ERITEMATOSO"
  },
  {
    "codigo":208732009,
    "descripcion":"FRACTURAS MÚLTIPLES DE PIERNA"
  },
  {
    "codigo":73990001,
    "descripcion":"EMBOLIA GASEOSA COMO COMPLICACIÓN DE INYECCIÓN"
  },
  {
    "codigo":1222705009,
    "descripcion":"FIBROMA DISCOIDE MÚLTIPLE FAMILIAR"
  },
  {
    "codigo":303366004,
    "descripcion":"NO EMPUJA"
  },
  {
    "codigo":41222005,
    "descripcion":"LACERACIÓN DEL TRONCO ENCEFÁLICO CON HERIDA INTRACRANEAL ABIERTA Y CONMOCIÓN"
  },
  {
    "codigo":237830009,
    "descripcion":"SECRECIÓN ECTÓPICA DE PROTEÍNA RELACIONADA CON HORMONA PARATIROIDEA"
  },
  {
    "codigo":235995003,
    "descripcion":"ABSCESO DE SACO DE RUTHERFORD MORISON"
  },
  {
    "codigo":203227006,
    "descripcion":"INFECCIÓN DE HUESO DEL CARPO"
  },
  {
    "codigo":365232000,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA MANEJAR EL CUIDADO DE LA SALUD PERSONAL"
  },
  {
    "codigo":301531009,
    "descripcion":"NO ENTRA EN LA BAÑERA"
  },
  {
    "codigo":398000003,
    "descripcion":"HALLAZGO DEL NIVEL DE CREATINCINASA SÉRICA"
  },
  {
    "codigo":70320004,
    "descripcion":"MALFORMACIÓN VALVULAR CARDÍACA"
  },
  {
    "codigo":11995401000119100,
    "descripcion":"CONTRACTURA DE MUÑÓN DE AMPUTACIÓN DE EXTREMIDAD SUPERIOR DERECHA"
  },
  {
    "codigo":266928006,
    "descripcion":"EX FUMADOR DE CIGARRILLOS - CANTIDAD DESCONOCIDA"
  },
  {
    "codigo":234160008,
    "descripcion":"FLEBARTERIECTASIA DIFUSA GENUINA DE WEBER"
  },
  {
    "codigo":723845003,
    "descripcion":"CONDROSARCOMA PRIMARIO DE CARTÍLAGO ARTICULAR DE PELVIS"
  },
  {
    "codigo":232325008,
    "descripcion":"SORDERA CRÓNICA"
  },
  {
    "codigo":16582921000119102,
    "descripcion":"ARTRITIS DE TOBILLO IZQUIERDO DEBIDA A TRAUMATISMO"
  },
  {
    "codigo":166789009,
    "descripcion":"PROTEÍNAS EN PLASMA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":263258003,
    "descripcion":"FRACTURA DE CARTÍLAGO COSTAL"
  },
  {
    "codigo":230490003,
    "descripcion":"SOMNOLENCIA EXCESIVA DURANTE EL DÍA Y LA NOCHE"
  },
  {
    "codigo":296026003,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE CLORMEZANONA"
  },
  {
    "codigo":33882007,
    "descripcion":"ESTEATITIS NUTRICIONAL"
  },
  {
    "codigo":64815002,
    "descripcion":"INTOXICACIÓN POR FUGU"
  },
  {
    "codigo":294191004,
    "descripcion":"ALERGIA A COLODIÓN"
  },
  {
    "codigo":359727008,
    "descripcion":"DEFICIENCIA DE FIBRINÓGENO"
  },
  {
    "codigo":128516002,
    "descripcion":"NEOPLASIA DE LOS ANEXOS OCULARES"
  },
  {
    "codigo":292356002,
    "descripcion":"REACCIÓN ADVERSA AL MEDAZEPAM"
  },
  {
    "codigo":8611000119100,
    "descripcion":"CRANEOSINOSTOSIS COMPLEJA"
  },
  {
    "codigo":95748007,
    "descripcion":"CONJUNTIVITIS GRANULOMATOSA"
  },
  {
    "codigo":423428008,
    "descripcion":"CUERPO EXTRAÑO FACIAL"
  },
  {
    "codigo":61145000,
    "descripcion":"ONFALITIS TETÁNICA"
  },
  {
    "codigo":126681000,
    "descripcion":"NEOPLASIA DE LA PARED SUPERIOR DE LA NASOFARINGE"
  },
  {
    "codigo":30212006,
    "descripcion":"POSICIÓN DE FOWLER"
  },
  {
    "codigo":1306329005,
    "descripcion":"GLAUCOMA DE ÁNGULO CERRADO DE OJO IZQUIERDO DEBIDO A SINEQUIA ANTERIOR PERIFÉRICA"
  },
  {
    "codigo":93913006,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE MÚSCULO"
  },
  {
    "codigo":716505006,
    "descripcion":"NO UTILIZA SONIDOS COMBINADOS"
  },
  {
    "codigo":290521008,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR TRICLOROETILENO"
  },
  {
    "codigo":224985008,
    "descripcion":"REGRESIÓN MEDIANTE ACTUACIÓN"
  },
  {
    "codigo":257753009,
    "descripcion":"ANGULACIÓN EN FLEXIÓN"
  },
  {
    "codigo":92078004,
    "descripcion":"NEOPLASIA BENIGNA DE LA CARA DORSAL DE LA LENGUA"
  },
  {
    "codigo":714670007,
    "descripcion":"CONOCIMIENTO DEFICIENTE DEL EMBARAZO"
  },
  {
    "codigo":288686008,
    "descripcion":"NO PRESUPONE EN UNA CONVERSACIÓN"
  },
  {
    "codigo":254083002,
    "descripcion":"CONDRODISPLASIA PUNTEADA, TIPO MT"
  },
  {
    "codigo":203059008,
    "descripcion":"CONTRACTURA DEL MÚSCULO PECTORAL MAYOR"
  },
  {
    "codigo":55640002,
    "descripcion":"DISCALCULIA"
  },
  {
    "codigo":874840003,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE OÍDO"
  },
  {
    "codigo":285016003,
    "descripcion":"INCAPAZ DE MANEJAR UN ARTEFACTO MIENTRAS SE VISTE Y DESVISTE"
  },
  {
    "codigo":1073571000119107,
    "descripcion":"ARTRITIS REACTIVA DE ARTICULACIÓN DE PIE IZQUIERDO"
  },
  {
    "codigo":86573003,
    "descripcion":"HIPEREMIA DE PÁRPADO"
  },
  {
    "codigo":414253004,
    "descripcion":"HALLAZGO RELACIONADO CON COMPONENTE CELULAR SANGUÍNEO"
  },
  {
    "codigo":283181004,
    "descripcion":"CUERPO EXTRAÑO METÁLICO EN LA PANTORRILLA"
  },
  {
    "codigo":248578000,
    "descripcion":"SOLLOZO RESPIRATORIO"
  },
  {
    "codigo":17367000,
    "descripcion":"FRACTURAS MÚLTIPLES EXPUESTAS DE LAS EXTREMIDADES SUPERIORES E INFERIORES"
  },
  {
    "codigo":1264386009,
    "descripcion":"HERIDAS ABIERTAS MÚLTIPLES DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":246743006,
    "descripcion":"MICROTROPÍA CONVERGENTE"
  },
  {
    "codigo":1197015008,
    "descripcion":"ENFERMEDAD GINGIVAL POR COLITIS ULCEROSA"
  },
  {
    "codigo":441516001,
    "descripcion":"FRACTURA POR SOBRECARGA DE HUESO DEL TARSO"
  },
  {
    "codigo":736428003,
    "descripcion":"ARTRALGIA CRÓNICA DE ARTICULACIÓN TEMPOROMANDIBULAR"
  },
  {
    "codigo":210305005,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE LA OREJA"
  },
  {
    "codigo":16667351000119102,
    "descripcion":"FRACTURA EXPUESTA DE MITAD DERECHA DE LA MANDÍBULA"
  },
  {
    "codigo":372310001,
    "descripcion":"PARÁLISIS POR LESIÓN DE MÉDULA ESPINAL"
  },
  {
    "codigo":44630002,
    "descripcion":"MIOCARDIOPATÍA DILATADA DEBIDA A MIOCARDITIS FÚNGICA"
  },
  {
    "codigo":110166003,
    "descripcion":"ABRASIÓN DE PIEL DE REGIÓN CIGOMÁTICA DE CARA"
  },
  {
    "codigo":306774005,
    "descripcion":"CAPAZ DE TRAGAR ALIMENTOS BLANDOS"
  },
  {
    "codigo":11862006,
    "descripcion":"MIELOPATÍA INDUCIDA POR DROGAS"
  },
  {
    "codigo":208470007,
    "descripcion":"FRACTURA EXPUESTA DE LA FALANGE PROXIMAL DEL PULGAR, CUELLO"
  },
  {
    "codigo":403243002,
    "descripcion":"COLOR CONSTITUTIVO DE LA PIEL, NEGRO"
  },
  {
    "codigo":11834071000119104,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN METACARPOFALÁNGICA DE PULGAR IZQUIERDO"
  },
  {
    "codigo":763691008,
    "descripcion":"CLINODACTILIA FAMILIAR AISLADA DE DEDO DE LA MANO"
  },
  {
    "codigo":40960003,
    "descripcion":"INTOXICACIÓN POR TRACHYMENE"
  },
  {
    "codigo":301269000,
    "descripcion":"MATIDEZ HEPÁTICA A LA PERCUSIÓN, DESPLAZADA HACIA ARRIBA"
  },
  {
    "codigo":235733002,
    "descripcion":"ESTEATORREA PANCREÁTICA POSPROCEDIMIENTO"
  },
  {
    "codigo":399573004,
    "descripcion":"TUMOR QUE INVADE NERVIO ÓPTICO"
  },
  {
    "codigo":4522001,
    "descripcion":"PLACA DENTAL EN DIENTE"
  },
  {
    "codigo":364970002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA MANTENER LA ELEVACIÓN DEL PALADAR BLANDO"
  },
  {
    "codigo":430506003,
    "descripcion":"OSTEOCONDRITIS DE PROTUBERANCIA TIBIAL"
  },
  {
    "codigo":233898003,
    "descripcion":"TAQUICARDIA REENTRANTE AURICULOVENTRICULAR ORTODRÓMICA"
  },
  {
    "codigo":168362005,
    "descripcion":"ORGANISMO NO AISLADO EN CULTIVO DE HISOPADO DE PENE"
  },
  {
    "codigo":397738006,
    "descripcion":"BLOQUEO DE LA CONDUCCIÓN NERVIOSA SENSITIVA - EN EXCESO"
  },
  {
    "codigo":199295003,
    "descripcion":"ENFERMEDAD DE PIEL Y TEJIDO CELULAR SUBCUTÁNEO QUE COMPLICA EMBARAZO, PARTO Y\/O PUERPERIO"
  },
  {
    "codigo":461439003,
    "descripcion":"ORIFICIOS DE ARTERIAS CORONARIAS DERECHA E IZQUIERDA AMPLIAMENTE ESPACIADOS CON SENO AÓRTICO ÚNICO"
  },
  {
    "codigo":35455006,
    "descripcion":"NECROSIS TUBULAR AGUDA"
  },
  {
    "codigo":789119007,
    "descripcion":"TRASTORNO DEL ESTADO DE ÁNIMO CAUSADO POR CANNABINOIDE SINTÉTICO"
  },
  {
    "codigo":1076081000119105,
    "descripcion":"QUISTE SINOVIAL DE VAINA TENDINOSA DE MANO IZQUIERDA"
  },
  {
    "codigo":363135008,
    "descripcion":"COMPLICACIÓN HEMATOLÓGICA POR UN PROCEDIMIENTO"
  },
  {
    "codigo":723583009,
    "descripcion":"SÍNDROME DE DEFICIENCIA DE DESHIDROGENASA DE ESTEROIDES Y ANOMALÍAS DENTALES"
  },
  {
    "codigo":428671008,
    "descripcion":"ARTROPATÍA DE ARTICULACIÓN CIGOAPOFISARIA LUMBAR"
  },
  {
    "codigo":232063007,
    "descripcion":"VITREORRETINOPATÍA EXUDATIVA FAMILIAR"
  },
  {
    "codigo":197460005,
    "descripcion":"PANCREATITIS SUPURATIVA AGUDA"
  },
  {
    "codigo":230228004,
    "descripcion":"ATAXIA CEREBELOSA DE COMIENZO TEMPRANO CON REFLEJOS TENDINOSOS CONSERVADOS"
  },
  {
    "codigo":426836003,
    "descripcion":"ABSCESO DE ARÉOLA NO PUERPERAL"
  },
  {
    "codigo":295764002,
    "descripcion":"SOBREDOSIS DE FLUDARABINA"
  },
  {
    "codigo":293929001,
    "descripcion":"ALERGIA A LEVOMEPROMAZINA"
  },
  {
    "codigo":64553001,
    "descripcion":"AUSENCIA DE GEN SECRETOR (SE)"
  },
  {
    "codigo":338801000119106,
    "descripcion":"COROIDITIS FOCAL PERIFÉRICA IZQUIERDA"
  },
  {
    "codigo":31785008,
    "descripcion":"SÍNDROME DE COLLET - SICARD"
  },
  {
    "codigo":95486002,
    "descripcion":"CEGUERA CONGÉNITA"
  },
  {
    "codigo":128254003,
    "descripcion":"HALLAZGO RESPIRATORIO DURANTE LA AUSCULTACIÓN"
  },
  {
    "codigo":62718007,
    "descripcion":"BABEAR"
  },
  {
    "codigo":783614008,
    "descripcion":"SÍNDROME NEFRÓTICO RESISTENTE A LOS ESTEROIDES FAMILIAR CON SORDERA NEUROSENSORIAL"
  },
  {
    "codigo":292094009,
    "descripcion":"REACCIÓN ADVERSA A RADIOFÁRMACOS"
  },
  {
    "codigo":716243005,
    "descripcion":"SÍNDROME DE SORDERA CON MALFORMACIÓN AURICULAR Y PARÁLISIS FACIAL"
  },
  {
    "codigo":93651008,
    "descripcion":"MELANOMA MALIGNO DE LA PIEL DEL TRONCO"
  },
  {
    "codigo":191955009,
    "descripcion":"HIPO PSICÓGENO"
  },
  {
    "codigo":880083009,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO DE PIERNA"
  },
  {
    "codigo":1142227009,
    "descripcion":"ARTRITIS DE LYME DE RODILLA"
  },
  {
    "codigo":288424003,
    "descripcion":"CAPAZ DE CORTAR CON TIJERA"
  },
  {
    "codigo":1337000006,
    "descripcion":"TRASTORNO POR USO DE KETAMINA"
  },
  {
    "codigo":285861000119100,
    "descripcion":"ENFERMEDAD RENAL CRÓNICA POR HIPERTENSIÓN MALIGNA, ESTADIO 2"
  },
  {
    "codigo":419496009,
    "descripcion":"QUELOIDE CORNEAL CONGÉNITO"
  },
  {
    "codigo":188285002,
    "descripcion":"NEOPLASIA MALIGNA DEL GLOBO PÁLIDO"
  },
  {
    "codigo":450429004,
    "descripcion":"HEMORRAGIA PERINATAL"
  },
  {
    "codigo":284754000,
    "descripcion":"ARRANCAR LAS SUTURAS"
  },
  {
    "codigo":282919000,
    "descripcion":"CAPAZ DE INCORPORARSE"
  },
  {
    "codigo":250151004,
    "descripcion":"SUELA DEL CALZADO DEMASIADO GRUESA"
  },
  {
    "codigo":248316006,
    "descripcion":"PÉRDIDA DE GRASA SUBCUTÁNEA"
  },
  {
    "codigo":443089001,
    "descripcion":"SEUDOANEURISMA"
  },
  {
    "codigo":15270002,
    "descripcion":"OBSTRUCCIÓN POR OBTURACIÓN DEL INTESTINO"
  },
  {
    "codigo":703398004,
    "descripcion":"IMPLANTE CARDÍACO IN SITU"
  },
  {
    "codigo":768934004,
    "descripcion":"PERINEUROMA INTRANEURAL"
  },
  {
    "codigo":734331003,
    "descripcion":"TIENE ÚLTIMA VOLUNTAD Y TESTAMENTO ACTUALIZADO"
  },
  {
    "codigo":767099007,
    "descripcion":"ALERGIA A ALDEHÍDO"
  },
  {
    "codigo":372048000,
    "descripcion":"EMBARAZO CON PRUEBA DE TOLERANCIA ANORMAL A LA GLUCOSA"
  },
  {
    "codigo":109904003,
    "descripcion":"MENINGOCELE ADQUIRIDO"
  },
  {
    "codigo":206373002,
    "descripcion":"INFECCIÓN CONGÉNITA POR HEPATITIS A"
  },
  {
    "codigo":1254949004,
    "descripcion":"EDEMA DEBIDO A AUMENTO DE FLUJO SANGUÍNEO PERIFÉRICO"
  },
  {
    "codigo":239141004,
    "descripcion":"NEVO ANELÁSTICO"
  },
  {
    "codigo":370213005,
    "descripcion":"CANTIDAD DE VECES QUE UTILIZA BRONCODILATADOR EN UNA SEMANA"
  },
  {
    "codigo":402981007,
    "descripcion":"INFECCIÓN CUTÁNEA POR MYCOBACTEROIDES CHELONAE"
  },
  {
    "codigo":15633881000119102,
    "descripcion":"ECOGRAFÍA DE HÍGADO ANORMAL"
  },
  {
    "codigo":270074002,
    "descripcion":"EL COMITÉ DE MÉDICOS DE FAMILIA (FPC) NOTIFICÓ AL PACIENTE SOBRE SU DESREGISTRO"
  },
  {
    "codigo":237306003,
    "descripcion":"CORDÓN UMBILICAL AL COSTADO DE LA CABEZA"
  },
  {
    "codigo":7930004,
    "descripcion":"NECROSIS ARTERIAL"
  },
  {
    "codigo":15988031000119109,
    "descripcion":"COLOBOMA CONGÉNITO DE PÁRPADO IZQUIERDO"
  },
  {
    "codigo":73466007,
    "descripcion":"TRASTORNO DE LA FUNCIÓN CARDIOVASCULAR PARASIMPÁTICA"
  },
  {
    "codigo":827130009,
    "descripcion":"PULSO EN ARTERIA PEDIA DERECHA AUSENTE"
  },
  {
    "codigo":302842009,
    "descripcion":"LINFOMA MALIGNO DIFUSO - CENTROBLÁSTICO"
  },
  {
    "codigo":6095003,
    "descripcion":"INFESTACIÓN CAUSADA POR LINOGNATHUS"
  },
  {
    "codigo":233636000,
    "descripcion":"PLEURITIS POR AMIANTO"
  },
  {
    "codigo":268239009,
    "descripcion":"ALTERACIÓN CONGÉNITA DE HUESOS DEL CRÁNEO Y DE LA CARA"
  },
  {
    "codigo":301007008,
    "descripcion":"EROSIÓN GASTROESOFÁGICA"
  },
  {
    "codigo":266404004,
    "descripcion":"ENFERMEDAD RESPIRATORIA CRÓNICA POR SUSTANCIAS QUÍMICAS"
  },
  {
    "codigo":397476004,
    "descripcion":"TEJIDO FETAL AUSENTE EN EL ESPÉCIMEN"
  },
  {
    "codigo":168100005,
    "descripcion":"ANÁLISIS BIOQUÍMICO DE LÍQUIDO AMNIÓTICO, NO SE DETECTARON ANOMALÍAS"
  },
  {
    "codigo":102564009,
    "descripcion":"EDEMA DE MANO"
  },
  {
    "codigo":4260009,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA MÉDULA ESPINAL SACRA SIN LESIÓN ÓSEA"
  },
  {
    "codigo":264569006,
    "descripcion":"INFECCIÓN SECUNDARIA"
  },
  {
    "codigo":11783641000119108,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE DEDOS SEGUNDO A QUINTO DE PIE IZQUIERDO"
  },
  {
    "codigo":231801008,
    "descripcion":"DERMATITIS BACTERIANA PALPEBRAL"
  },
  {
    "codigo":295502003,
    "descripcion":"SOBREDOSIS DE FÁRMACO ANESTÉSICO ADMINISTRADO POR VÍA ENDOVENOSA"
  },
  {
    "codigo":197198004,
    "descripcion":"ADHERENCIAS DEL ÁNGULO SIGMOIDEO"
  },
  {
    "codigo":590005,
    "descripcion":"ANEURISMA CONGÉNITO DE ARTERIA COMUNICANTE ANTERIOR"
  },
  {
    "codigo":33358005,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ESTERNÓN"
  },
  {
    "codigo":721486005,
    "descripcion":"SÍNDROME DE BROWN-SEQUARD AL NIVEL DEL QUINTO SEGMENTO DORSAL"
  },
  {
    "codigo":262734008,
    "descripcion":"CONTUSIÓN DE LA RAÍZ DE NERVIO CERVICAL"
  },
  {
    "codigo":719651000,
    "descripcion":"SÍNDROME DE MICRODELECIÓN 2P15P16.1"
  },
  {
    "codigo":228131001,
    "descripcion":"ACCESO AL NIÑO, AUTORIZADO"
  },
  {
    "codigo":129827004,
    "descripcion":"MANEJO INEFICAZ DEL RÉGIMEN TERAPÉUTICO"
  },
  {
    "codigo":424739004,
    "descripcion":"INGRESOS SUFICIENTES SÓLO PARA COMPRAR LO INDISPENSABLE"
  },
  {
    "codigo":195363007,
    "descripcion":"POLIARTERITIS JUVENIL"
  },
  {
    "codigo":1078264000,
    "descripcion":"AGENESIA DE EPÍFISIS DE FALANGE MEDIA DE CUARTO DEDO DE PIE"
  },
  {
    "codigo":717816002,
    "descripcion":"INFECCIÓN DE PEZÓN ASOCIADA CON DIFICULTAD EN EL APEGO EN EL NACIMIENTO"
  },
  {
    "codigo":160760004,
    "descripcion":"SERVICIOS DOMICILIARIOS"
  },
  {
    "codigo":95224004,
    "descripcion":"RETICULOSARCOMA DE LOS GANGLIOS LINFÁTICOS INTRABDOMINALES"
  },
  {
    "codigo":291832006,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ESTRÓGENO"
  },
  {
    "codigo":816120008,
    "descripcion":"CATARATA DE OJO DERECHO"
  },
  {
    "codigo":191693002,
    "descripcion":"PSICOSIS DESINTEGRATIVAS RESIDUALES"
  },
  {
    "codigo":1081101000119101,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE MÚSCULO DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":715981004,
    "descripcion":"MICROCEFALIA PRIMARIA AUTOSÓMICA RECESIVA"
  },
  {
    "codigo":224461005,
    "descripcion":"BAJO LICENCIA SIN GOCE DE SUELDO"
  },
  {
    "codigo":124322002,
    "descripcion":"DEFICIENCIA DE GLICEROL CINASA"
  },
  {
    "codigo":91554004,
    "descripcion":"CONDILOMA PLANO"
  },
  {
    "codigo":1172898008,
    "descripcion":"SÍNDROME DE SOBRECRECIMIENTO DE KOSAKI"
  },
  {
    "codigo":286327002,
    "descripcion":"INCAPAZ DE EMITIR VOZ"
  },
  {
    "codigo":1269367004,
    "descripcion":"CRISIS EPILÉPTICA ATÓNICA CON CONCIENCIA PRESERVADA DE INICIO FOCAL"
  },
  {
    "codigo":56951005,
    "descripcion":"INTOXICACIÓN CAUSADA POR GLUCÓSIDO CARDIOTÓNICO"
  },
  {
    "codigo":89719007,
    "descripcion":"TIROTOXICOSIS SIN BOCIO U OTRA CAUSA"
  },
  {
    "codigo":284492000,
    "descripcion":"CONDUCTA REFORZADA"
  },
  {
    "codigo":253559007,
    "descripcion":"DEFECTO DEL TABIQUE INTERVENTRICULAR CON TABIQUE DE SALIDA MAL ALINEADO HACIA LA IZQUIERDA"
  },
  {
    "codigo":251724004,
    "descripcion":"ÁNGULO ABIERTO MODERADO"
  },
  {
    "codigo":16045991000119100,
    "descripcion":"ALTERACIÓN DE ALINEACIÓN DE ARTICULACIÓN DE AMBOS PIES"
  },
  {
    "codigo":448332007,
    "descripcion":"VENA CAVA SUPERIOR IZQUIERDA PERSISTENTE CON DESEMBOCADURA EN AURÍCULA EN EL LADO DERECHO"
  },
  {
    "codigo":446497005,
    "descripcion":"TIENE LICENCIA PARA CONDUCIR"
  },
  {
    "codigo":249889008,
    "descripcion":"PRESIÓN HACIA ABAJO DEL MENTÓN; DÉBIL"
  },
  {
    "codigo":774177008,
    "descripcion":"CALAMBRE DE MÚSCULO DE EXTREMIDAD SUPERIOR DERECHA"
  },
  {
    "codigo":1003553009,
    "descripcion":"AGENESIA DE PESTAÑAS"
  },
  {
    "codigo":248054003,
    "descripcion":"AUTODESCUIDO"
  },
  {
    "codigo":343821000119109,
    "descripcion":"DEGENERACIÓN DE LA RETINA EN EMPEDRADO BILATERAL"
  },
  {
    "codigo":315425009,
    "descripcion":"NACIDO EN FIDJI"
  },
  {
    "codigo":410059004,
    "descripcion":"ACIDURIA POR DEFICIENCIA DE HIDROXIMETILGLUTARIL-COA-LIASA"
  },
  {
    "codigo":735904003,
    "descripcion":"LESIÓN TRAUMÁTICA DE PLEXO NERVIOSO DEL TRONCO"
  },
  {
    "codigo":211616004,
    "descripcion":"CUERPO EXTRAÑO EN ORIFICIO"
  },
  {
    "codigo":703136005,
    "descripcion":"DIABETES MELLITUS EN REMISIÓN"
  },
  {
    "codigo":80544005,
    "descripcion":"DEGENERACIÓN ESPONJOSA DE SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":439157002,
    "descripcion":"DEFICIENCIA HEREDITARIA COMBINADA DE FACTORES DE LA COAGULACIÓN"
  },
  {
    "codigo":111477005,
    "descripcion":"TRASTORNO REACTIVO DE LA VINCULACIÓN EN LA LACTANCIA O LA NIÑEZ TEMPRANA, TIPO DESINHIBIDO"
  },
  {
    "codigo":373621006,
    "descripcion":"SÍNDROME DE DOLOR CRÓNICO"
  },
  {
    "codigo":45941008,
    "descripcion":"ENFERMEDAD CRÓNICA POR RADIACIÓN"
  },
  {
    "codigo":15691841000119102,
    "descripcion":"ARTRITIS REUMATOIDEA SEROPOSITIVA DE ARTICULACIÓN DE AMBAS REGIONES DE HOMBRO"
  },
  {
    "codigo":12277671000119109,
    "descripcion":"DISFORIA DE GÉNERO EN LA INFANCIA"
  },
  {
    "codigo":11338007,
    "descripcion":"EPIESCLERITIS SIFILÍTICA"
  },
  {
    "codigo":240714007,
    "descripcion":"CANDIDIASIS MUCOCUTÁNEA CRÓNICA FAMILIAR - TIPO DOMINANTE"
  },
  {
    "codigo":238879003,
    "descripcion":"SEUDO AINHUM"
  },
  {
    "codigo":402719006,
    "descripcion":"AMILOIDOSIS SISTÉMICA QUE AFECTA PIEL"
  },
  {
    "codigo":7668000,
    "descripcion":"PSEUDOMASTURBACIÓN"
  },
  {
    "codigo":237044002,
    "descripcion":"ENFERMEDAD INFLAMATORIA PÉLVICA CRÓNICA"
  },
  {
    "codigo":1285620007,
    "descripcion":"HEMATOMA DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":105972009,
    "descripcion":"TRASTORNO DE SENO MAXILAR"
  },
  {
    "codigo":399049001,
    "descripcion":"ÚLCERA EOSINOFÍLICA DE LABIO"
  },
  {
    "codigo":366281006,
    "descripcion":"HALLAZGO RELACIONADO CON VELOCIDAD DE LLENADO VESICAL"
  },
  {
    "codigo":300745008,
    "descripcion":"INCAPAZ DE USAR INSTALACIONES RECREATIVAS PÚBLICAS"
  },
  {
    "codigo":202441009,
    "descripcion":"TUMOR TENOSINOVIAL DE CÉLULAS GIGANTES DIFUSO DE ARTICULACIÓN INTERFALÁNGICA DE DEDO DE MANO"
  },
  {
    "codigo":267977009,
    "descripcion":"NEURITIS BRAQUIAL (CERVICAL)"
  },
  {
    "codigo":298910005,
    "descripcion":"AMPLITUD DE SUPINACIÓN PASIVA DE CODO DISMINUIDA"
  },
  {
    "codigo":724894009,
    "descripcion":"DISTENSIÓN DE FASCIA DE PELVIS"
  },
  {
    "codigo":200606009,
    "descripcion":"FORÚNCULO DE CARA EXTERNA DE LA NARIZ"
  },
  {
    "codigo":231539006,
    "descripcion":"ADOLESCENTE - PROBLEMA EMOCIONAL"
  },
  {
    "codigo":297075008,
    "descripcion":"SOBREDOSIS DE DIAZÓXIDO"
  },
  {
    "codigo":65864002,
    "descripcion":"TEMBLOR DE LA VOZ DE ORIGEN ORGÁNICO"
  },
  {
    "codigo":229704003,
    "descripcion":"DISPRAXIA COREIFORME ADQUIRIDA"
  },
  {
    "codigo":295240004,
    "descripcion":"SOBREDOSIS INTENCIONAL DE FENBUFÉN"
  },
  {
    "codigo":293405001,
    "descripcion":"REACCIÓN ADVERSA A RESINA DE INTERCAMBIO CATIÓNICO"
  },
  {
    "codigo":129565002,
    "descripcion":"TRASTORNO DEL MÚSCULO LISO Y\/O ESQUELÉTICO"
  },
  {
    "codigo":195101003,
    "descripcion":"MARCAPASOS AURICULAR"
  },
  {
    "codigo":719389002,
    "descripcion":"CAPAZ DE UTILIZAR LA SEMÁNTICA EN LA COMUNICACIÓN"
  },
  {
    "codigo":1083611000119107,
    "descripcion":"TRASTORNO DE AMBAS TROMPAS DE EUSTAQUIO"
  },
  {
    "codigo":346331000119107,
    "descripcion":"AMBLIOPÍA POR DEPRIVACIÓN DE AMBOS OJOS"
  },
  {
    "codigo":94962000,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL CUELLO"
  },
  {
    "codigo":291570000,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR CEFAZOLINA"
  },
  {
    "codigo":783090002,
    "descripcion":"SÍNDROME DE VASCULITIS RETINIANA IDIOPÁTICA, ANEURISMAS Y NEURORRETINITIS"
  },
  {
    "codigo":29426003,
    "descripcion":"SÍNDROME PARALÍTICO"
  },
  {
    "codigo":226034001,
    "descripcion":"CONSUMIDOR DE DROGAS INYECTABLES"
  },
  {
    "codigo":93127002,
    "descripcion":"FALTA DE OSIFICACIÓN DEL VÓMER"
  },
  {
    "codigo":289735003,
    "descripcion":"CONTRACCIÓN UTERINA PERSISTENTE"
  },
  {
    "codigo":1010631005,
    "descripcion":"MELANOMA MALIGNO PRIMARIO DE LESIÓN SUPERPUESTA DE SENOS PARANASALES"
  },
  {
    "codigo":224199008,
    "descripcion":"PÉRDIDA DE SUBSIDIOS"
  },
  {
    "codigo":124060003,
    "descripcion":"ÁCIDO BETAAMINOISOBUTÍRICO POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":25756004,
    "descripcion":"HEMATOMA DE LA TÚNICA VAGINAL"
  },
  {
    "codigo":1172636006,
    "descripcion":"SÍNDROME DE DISTROFIA RETINIANA PROGRESIVA, COLOBOMA DE IRIS, CATARATA CONGÉNITA FAMILIAR"
  },
  {
    "codigo":58524006,
    "descripcion":"HISTOPLASMOSIS PULMONAR AGUDA"
  },
  {
    "codigo":1303708007,
    "descripcion":"GLAUCOMA DE AMBOS OJOS CAUSADO POR ACEITE DE SILICONA"
  },
  {
    "codigo":449905001,
    "descripcion":"MALFORMACIÓN ARTERIOVENOSA INTRAMEDULAR Y EXTRAMEDULAR DE MÉDULA ESPINAL"
  },
  {
    "codigo":56689002,
    "descripcion":"ENFERMEDAD DE CROHN DEL INTESTINO DELGADO"
  },
  {
    "codigo":251462000,
    "descripcion":"ACTIVIDAD DELTA DE BAJA FRECUENCIA"
  },
  {
    "codigo":253297008,
    "descripcion":"TRANSPOSICIÓN DE AORTA"
  },
  {
    "codigo":185926008,
    "descripcion":"MONITOREO DE LOS EPISODIOS RELACIONADOS CON LA PRESCRIPCIÓN SOLICITADO"
  },
  {
    "codigo":184091000,
    "descripcion":"PACIENTE EN EL HOSPITAL"
  },
  {
    "codigo":216859005,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR GAS LACRIMÓGENO"
  },
  {
    "codigo":11844111000119105,
    "descripcion":"LESIÓN TRAUMÁTICA DE OÍDO MEDIO DERECHO"
  },
  {
    "codigo":85787009,
    "descripcion":"ÚLCERA GÁSTRICA CRÓNICA CON HEMORRAGIA, PERFORACIÓN Y OBSTRUCCIÓN"
  },
  {
    "codigo":18416000,
    "descripcion":"HIPERTENSIÓN ESENCIAL QUE COMPLICA EL PARTO Y\/O CONSTITUYE UN MOTIVO DE ATENCIÓN DURANTE ESTE PROCEDIMIENTO"
  },
  {
    "codigo":247792007,
    "descripcion":"EMOCIÓN REPRIMIDA"
  },
  {
    "codigo":313328009,
    "descripcion":"FATIGA ACOMODATIVA"
  },
  {
    "codigo":1360069002,
    "descripcion":"ÁNGULO ESTRECHO DE OJO IZQUIERDO"
  },
  {
    "codigo":15667881000119101,
    "descripcion":"DEFORMIDAD CONGÉNITA DE CADERA DERECHA"
  },
  {
    "codigo":82117004,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN CON INFECCIÓN"
  },
  {
    "codigo":409797008,
    "descripcion":"INFECCIÓN CAUSADA POR HONGOS RESISTENTES A AGENTES ANTIMICROBIANOS"
  },
  {
    "codigo":80282001,
    "descripcion":"DETERMINACIÓN DEL RESULTADO: COMPLICACIÓN INEVITABLE"
  },
  {
    "codigo":213189009,
    "descripcion":"FALLA TOTAL DE REIMPLANTE DE DEDOS DE DE LOS PIES"
  },
  {
    "codigo":735642007,
    "descripcion":"LESIÓN AUTOINFLIGIDA SIN INTENCIÓN SUICIDA"
  },
  {
    "codigo":897647001,
    "descripcion":"MELANOSIS ADQUIRIDA PRIMARIA BILATERAL DE CÓRNEA"
  },
  {
    "codigo":15749801000119104,
    "descripcion":"DOLOR CRÓNICO DE AMBOS PIES"
  },
  {
    "codigo":209519005,
    "descripcion":"DESGARRO PARCIAL DEL LIGAMENTO LATERAL INTERNO DE RODILLA"
  },
  {
    "codigo":111215006,
    "descripcion":"ARTRITIS POSTERIOR A HELMINTIASIS"
  },
  {
    "codigo":76612001,
    "descripcion":"ESTADO DE HIPERCOAGULABILIDAD"
  },
  {
    "codigo":109380002,
    "descripcion":"OBSTRUCCIÓN MEMBRANOSA DE LA VENA CAVA INFERIOR"
  },
  {
    "codigo":240452007,
    "descripcion":"BARTONELOSIS ASINTOMÁTICA"
  },
  {
    "codigo":369689001,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA DEL INTESTINO GRUESO, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":9241004,
    "descripcion":"ENFERMEDAD CORONARIA GONOCÓCICA"
  },
  {
    "codigo":402457007,
    "descripcion":"AMILOIDOSIS SISTÉMICA SECUNDARIA CON AFECCIÓN CUTÁNEA (TIPO AA)"
  },
  {
    "codigo":238617008,
    "descripcion":"PSORIASIS PUSTULOSA ANULAR Y CIRCINADA"
  },
  {
    "codigo":105710000,
    "descripcion":"ENFERMEDAD CAUSADA POR RHABDITOIDEA"
  },
  {
    "codigo":236782005,
    "descripcion":"GANGRENA DE FOURNIER DEL ESCROTO"
  },
  {
    "codigo":1187054007,
    "descripcion":"CLORURO SÉRICO POR DEBAJO DE RANGO DE REFERENCIA"
  },
  {
    "codigo":234947003,
    "descripcion":"TRASTORNO DE DIENTE"
  },
  {
    "codigo":202179006,
    "descripcion":"LUXACIÓN PATOLÓGICA DE LA ARTICULACIÓN RADIOCUBITAL SUPERIOR"
  },
  {
    "codigo":366019007,
    "descripcion":"PERMEABILIDAD DEL ÁNGULO - HALLAZGO"
  },
  {
    "codigo":300483008,
    "descripcion":"TESTÍCULO DE TAMAÑO NORMAL"
  },
  {
    "codigo":298648002,
    "descripcion":"AMPLITUD DE ROTACIÓN ACTIVA HACIA LA DERECHA DE LA COLUMNA LUMBAR AUMENTADA"
  },
  {
    "codigo":724632007,
    "descripcion":"PROBLEMA DE MIEMBRO INFERIOR"
  },
  {
    "codigo":167576009,
    "descripcion":"UROCULTIVO - BACILOS ACIDORRESISTENTES"
  },
  {
    "codigo":34669005,
    "descripcion":"AUTOMATISMO ANTE UNA ORDEN"
  },
  {
    "codigo":67437007,
    "descripcion":"ESPONDILOSIS LUMBAR CON MIELOPATÍA"
  },
  {
    "codigo":294978001,
    "descripcion":"ALERGIA A QUINIDINA"
  },
  {
    "codigo":32834005,
    "descripcion":"PÉRDIDA BREVE DE LA CONSCIENCIA"
  },
  {
    "codigo":131138007,
    "descripcion":"SEROTONINA ANORMAL"
  },
  {
    "codigo":720962008,
    "descripcion":"QUISTE Y TROFOZOÍTO DE ENDOLIMAX NANA"
  },
  {
    "codigo":63767001,
    "descripcion":"ÁNTRAX DE LA OREJA"
  },
  {
    "codigo":94700002,
    "descripcion":"MOTEADO PULMONAR"
  },
  {
    "codigo":61932003,
    "descripcion":"MOVIMIENTO PARADÓJICO DE LA PARED CARDÍACA"
  },
  {
    "codigo":782828005,
    "descripcion":"RETRASO DEL DESARROLLO DEBIDO A DEFICIENCIA DE METILMALONATO SEMIALDEHÍDO DESHIDROGENASA"
  },
  {
    "codigo":291308005,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR METAPROTERENOL"
  },
  {
    "codigo":29164008,
    "descripcion":"ALTERACIÓN DEL HABLA"
  },
  {
    "codigo":420545001,
    "descripcion":"SÍNDROME INTRAOPERATORIO DE IRIS FLÁCCIDO POSTERIOR A ADMINISTRACIÓN DE TAMSULOSINA"
  },
  {
    "codigo":1338049002,
    "descripcion":"INFECCIÓN ASOCIADA CON PRÓTESIS DE AMBAS ARTICULACIONES DE CADERA"
  },
  {
    "codigo":92865003,
    "descripcion":"FUSIÓN ANORMAL CONGÉNITA DE MANDÍBULA"
  },
  {
    "codigo":125633004,
    "descripcion":"LESIÓN TRAUMÁTICA DEL COLON DESCENDENTE"
  },
  {
    "codigo":658091000005102,
    "descripcion":"PLACENTA UBICADA EN PARED LATERAL DERECHA DE ÚTERO"
  },
  {
    "codigo":191169008,
    "descripcion":"ELIPTOCITOSIS HEREDITARIA"
  },
  {
    "codigo":123798002,
    "descripcion":"ESPONDILOSIS LUMBOSACRA"
  },
  {
    "codigo":254870004,
    "descripcion":"CORIOCARCINOMA DE OVARIO"
  },
  {
    "codigo":58262005,
    "descripcion":"KWASHIORKOR"
  },
  {
    "codigo":449643001,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN PIERNA, CON INFECCIÓN"
  },
  {
    "codigo":416875006,
    "descripcion":"DESPLAZAMIENTO HACIA AFUERA DE HUESO INNOMINADO"
  },
  {
    "codigo":679031000119105,
    "descripcion":"PLIEGUE DE MEMBRANA DE BOWMAN DE OJO IZQUIERDO"
  },
  {
    "codigo":30031000175106,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN EN DORSO DE PIE IZQUIERDO, ESTADIO I"
  },
  {
    "codigo":283968005,
    "descripcion":"CONTUSIÓN DEL PERINEO FEMENINO"
  },
  {
    "codigo":494716691000132104,
    "descripcion":"DOSIS DE MEDICACIÓN ADECUADA AL PACIENTE"
  },
  {
    "codigo":251200008,
    "descripcion":"EJE CARDÍACO INDETERMINADO"
  },
  {
    "codigo":216597001,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR DERIVADOS DE AMONIO CUATERNARIO"
  },
  {
    "codigo":23671000119107,
    "descripcion":"SECUELA DE INFARTO CEREBRAL ISQUÉMICO"
  },
  {
    "codigo":52757001,
    "descripcion":"ESTENOSIS PULMONAR SUPRAVALVULAR CONGÉNITA"
  },
  {
    "codigo":1332544009,
    "descripcion":"ARTRITIS GOTOSA DE ARTICULACIÓN RADIOCARPIANA IZQUIERDA"
  },
  {
    "codigo":1363477008,
    "descripcion":"QUISTE EPENDIMARIO DE VENTRÍCULO LATERAL DE CEREBRO"
  },
  {
    "codigo":413205009,
    "descripcion":"PAPILA DUODENAL NO HALLADA"
  },
  {
    "codigo":247530003,
    "descripcion":"CRECIMIENTO PREMATURO DEL VELLO SEXUAL SECUNDARIO"
  },
  {
    "codigo":444138006,
    "descripcion":"PATRÓN DE ANTICUERPO ANTINUCLEAR MOTEADO"
  },
  {
    "codigo":704447001,
    "descripcion":"FALTA DE CONCIENCIA DE SÍ MISMO"
  },
  {
    "codigo":212927002,
    "descripcion":"CONGELAMIENTO CON NECROSIS TISULAR DEL TÓRAX"
  },
  {
    "codigo":737215002,
    "descripcion":"HIPOPLASIA CONGÉNITA DE APÓFISIS ODONTOIDES DEL AXIS"
  },
  {
    "codigo":278463004,
    "descripcion":"SUSCEPTIBILIDAD DEL OÍDO MEDIO"
  },
  {
    "codigo":768148000,
    "descripcion":"ADHERENCIA DE DISPOSITIVO"
  },
  {
    "codigo":1359807009,
    "descripcion":"COLONIZACIÓN CRÓNICA DE TRACTO RESPIRATORIO CAUSADA POR ACHROMOBACTER"
  },
  {
    "codigo":243860001,
    "descripcion":"SITUACIÓN DEL MONITOREO DIABÉTICO"
  },
  {
    "codigo":1259668002,
    "descripcion":"CISTADENOCARCINOMA DE CÉLULAS ACINARES PRIMARIO DE PULMÓN"
  },
  {
    "codigo":702612001,
    "descripcion":"APLASIA DE PULMÓN"
  },
  {
    "codigo":47252008,
    "descripcion":"ALTERACIÓN DE LOS PATRONES DE EVACUACIÓN URINARIA"
  },
  {
    "codigo":276628009,
    "descripcion":"NEUTROPENIA INDUCIDA POR CLORANFENICOL"
  },
  {
    "codigo":404030000,
    "descripcion":"NEUROFIBROMA SOLITARIO"
  },
  {
    "codigo":405865009,
    "descripcion":"FENOTIPO LE(B+)"
  },
  {
    "codigo":305726002,
    "descripcion":"VISTO POR UN CIRUJANO PLÁSTICO"
  },
  {
    "codigo":830014008,
    "descripcion":"QUISTE DERMOIDE DE CABEZA"
  },
  {
    "codigo":271123000,
    "descripcion":"AMPOLLA TRAUMÁTICA DEL ANO"
  },
  {
    "codigo":39051000087104,
    "descripcion":"HEMATOMA DE PÁRPADO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":46731000087104,
    "descripcion":"DESGARRO COMPLETO DE LIGAMENTO ESCAFOSEMILUNAR IZQUIERDO"
  },
  {
    "codigo":236520002,
    "descripcion":"NEFROPATÍA POR ORO"
  },
  {
    "codigo":402195009,
    "descripcion":"DERMATITIS ATÓPICA DE LA LACTANCIA"
  },
  {
    "codigo":41611000087107,
    "descripcion":"HERIDA PUNZANTE DE PÁRPADO INFERIOR IZQUIERDO"
  },
  {
    "codigo":44171000087109,
    "descripcion":"CORTE EN MUÑECA DERECHA"
  },
  {
    "codigo":39912006,
    "descripcion":"PARAPLEJÍA ESPÁSTICA HEREDITARIA"
  },
  {
    "codigo":302056007,
    "descripcion":"INCAPAZ DE IMITAR LOS MOVIMIENTOS DE LA LENGUA"
  },
  {
    "codigo":105448009,
    "descripcion":"ENFERMEDAD EN FAMILIA"
  },
  {
    "codigo":5309003,
    "descripcion":"HEMATOMA SUBCUTÁNEO"
  },
  {
    "codigo":726205006,
    "descripcion":"LACERACIÓN DE MÚSCULO INTRÍNSECO DE DEDO DE LA MANO"
  },
  {
    "codigo":365757006,
    "descripcion":"NIVEL DE CREATININA SÉRICA - HALLAZGO"
  },
  {
    "codigo":169149008,
    "descripcion":"GAMMAGRAFÍA ESPLÉNICA NORMAL"
  },
  {
    "codigo":298386000,
    "descripcion":"HALLAZGO RELACIONADO CON EL TAMAÑO DEL CUELLO"
  },
  {
    "codigo":3474005,
    "descripcion":"INTOXICACIÓN POR GLYCINE MAX"
  },
  {
    "codigo":722535000,
    "descripcion":"ENTERITIS TÓXICA DE INTESTINO DELGADO"
  },
  {
    "codigo":429458009,
    "descripcion":"DEMENCIA DEBIDA A ENFERMEDAD DE CREUTZFELDT JAKOB"
  },
  {
    "codigo":67175002,
    "descripcion":"MANEJO INEFICIENTE DEL HOGAR"
  },
  {
    "codigo":165479004,
    "descripcion":"POIQUILOCITOSIS"
  },
  {
    "codigo":1148519006,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ÁCIDO BILIAR Y\/O DERIVADO DE ÁCIDO BILIAR"
  },
  {
    "codigo":1639007,
    "descripcion":"ANOMALÍA DE ÓRGANOS Y\/O PARTES BLANDAS DE LA PELVIS QUE AFECTA EL EMBARAZO"
  },
  {
    "codigo":196412000,
    "descripcion":"INCISIVOS IMPACTADOS"
  },
  {
    "codigo":32572006,
    "descripcion":"INCAPACIDAD FÍSICA"
  },
  {
    "codigo":65340007,
    "descripcion":"ANEURISMA CARDÍACO"
  },
  {
    "codigo":1144849005,
    "descripcion":"ESCASO CRECIMIENTO DE PELO DE CUERO CABELLUDO ANTERIOR"
  },
  {
    "codigo":784401006,
    "descripcion":"HEMATOMA SUBAPONEURÓTICO EPICRANEAL"
  },
  {
    "codigo":292881006,
    "descripcion":"REACCIÓN ADVERSA A VAPORES METILADOS INDUSTRIALES"
  },
  {
    "codigo":129041007,
    "descripcion":"INDEPENDENCIA PARA EL BAÑO"
  },
  {
    "codigo":291046007,
    "descripcion":"INTOXICACIÓN POR TRIAZOLAM"
  },
  {
    "codigo":127206008,
    "descripcion":"LINFADENOPATÍA POPLÍTEA"
  },
  {
    "codigo":92603005,
    "descripcion":"CARCINOMA IN SITU DE LA GLOTIS"
  },
  {
    "codigo":289211007,
    "descripcion":"PRIMERA ETAPA DEL PARTO ESTABLECIDA"
  },
  {
    "codigo":418448002,
    "descripcion":"REACCIÓN ALÉRGICA CAUSADA POR ANIMAL"
  },
  {
    "codigo":123536004,
    "descripcion":"ESGUINCE DE LIGAMENTO DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":16711391000119106,
    "descripcion":"EDEMA DE MÁCULA RETINIANA DEBIDO A OCLUSIÓN DE RAMAS DE AMBAS VENAS DE LA RETINA"
  },
  {
    "codigo":1137509000,
    "descripcion":"DEBILIDAD DE MÚSCULO FLEXOR DE CUELLO"
  },
  {
    "codigo":1335952009,
    "descripcion":"PATRÓN DE USO NOCIVO DE ANSIOLÍTICO"
  },
  {
    "codigo":23397005,
    "descripcion":"CRECIMIENTO Y DESARROLLO NORMAL PARA LA EDAD"
  },
  {
    "codigo":1332282000,
    "descripcion":"PATRÓN DE USO NOCIVO CRÓNICO DE SUSTANCIA"
  },
  {
    "codigo":56165008,
    "descripcion":"DIVERTICULITIS DEL INTESTINO DELGADO"
  },
  {
    "codigo":185402003,
    "descripcion":"PACIENTE QUE CONCURRE MÁS DE UNA VEZ POR SEMANA"
  },
  {
    "codigo":283706003,
    "descripcion":"MORDEDURA HUMANA EN EL DORSO DE LA MANO"
  },
  {
    "codigo":15701881000119103,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE AMBOS TENDONES DE MÚSCULO BÍCEPS FEMORAL"
  },
  {
    "codigo":445711000,
    "descripcion":"LESIÓN TRAUMÁTICA DE ÁNGULO POSTEROEXTERNO DE RODILLA"
  },
  {
    "codigo":609551003,
    "descripcion":"HIPERSENSIBILIDAD NO ALÉRGICA A MEDIO DE CONTRASTE"
  },
  {
    "codigo":247268000,
    "descripcion":"AUSENCIA DE MEMBRANA TIMPÁNICA"
  },
  {
    "codigo":249103009,
    "descripcion":"POSICIÓN SACROILÍACA TRANSVERSA"
  },
  {
    "codigo":1230308005,
    "descripcion":"PERÍODOS \"OFF\" EN ENFERMEDAD DE PARKINSON QUE NO RESPONDEN A TRATAMIENTO ORAL"
  },
  {
    "codigo":738788006,
    "descripcion":"METABOLIZADOR NORMAL DE LA FAMILIA 2 SUBFAMILIA C MIEMBRO 19 DEL CITOCROMO P450"
  },
  {
    "codigo":443876008,
    "descripcion":"SÍNDROME DEL TÚNEL RADIAL"
  },
  {
    "codigo":704185005,
    "descripcion":"FRACTURA EXPUESTA DE FALANGE DISTAL DE DEDO MEÑIQUE"
  },
  {
    "codigo":48825007,
    "descripcion":"INTOXICACIÓN POR GÉNERO GNIDIA"
  },
  {
    "codigo":440206000,
    "descripcion":"ENFERMEDAD POR HEMOGLOBINA SS CON CRISIS VASOCLUSIVA"
  },
  {
    "codigo":702350003,
    "descripcion":"DISPLASIA ESPONDILOEPIMETAFISARIA, TIPO STRUDWICK"
  },
  {
    "codigo":276366004,
    "descripcion":"ÚTERO MÓVIL"
  },
  {
    "codigo":79758006,
    "descripcion":"SOPLO MESODIASTÓLICO"
  },
  {
    "codigo":1259406007,
    "descripcion":"CARCINOMA PRIMARIO DE ÁNGULO HEPÁTICO DE COLON"
  },
  {
    "codigo":208995000,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN METATARSOFALÁNGICA, MÚLTIPLE"
  },
  {
    "codigo":766051001,
    "descripcion":"SÍNDROME DE TRISOMÍA DISTAL 17Q"
  },
  {
    "codigo":405603002,
    "descripcion":"MANGUITO DE DISPOSITIVO PARA LA VÍA AÉREA CON INSUFLACIÓN INSUFICIENTE"
  },
  {
    "codigo":274531002,
    "descripcion":"HALLAZGOS ANORMALES EN IMÁGENES DIAGNÓSTICAS DE CORAZÓN + CIRCULACIÓN CORONARIA"
  },
  {
    "codigo":733283004,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO CUÁDRICEPS"
  },
  {
    "codigo":1290339005,
    "descripcion":"HIPOMINERALIZACIÓN DE ESMALTE DE DIENTE MOLAR"
  },
  {
    "codigo":10552002,
    "descripcion":"CALCIFICACIÓN DE PULMÓN"
  },
  {
    "codigo":371000004,
    "descripcion":"ATROFIA RADICULAR"
  },
  {
    "codigo":403768004,
    "descripcion":"ACROCEFALOPOLISINDACTILIA TIPO III"
  },
  {
    "codigo":305464004,
    "descripcion":"BAJO ATENCIÓN DE MÉDICO DE PLANIFICACIÓN FAMILIAR"
  },
  {
    "codigo":440291000124105,
    "descripcion":"REQUERIMIENTO DE NUTRIENTES MENOR QUE LO ESPERADO"
  },
  {
    "codigo":698680009,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: SAMOANO"
  },
  {
    "codigo":450531000124107,
    "descripcion":"MASA DE ARTICULACIÓN DE CODO DERECHO"
  },
  {
    "codigo":2531000124107,
    "descripcion":"TERCER MOLAR SUPERIOR DERECHO PERMANENTE SUPERNUMERARIO"
  },
  {
    "codigo":238093009,
    "descripcion":"HIPOBETALIPOPROTEINEMIA FAMILIAR - FORMA HOMOCIGOTA"
  },
  {
    "codigo":234423001,
    "descripcion":"NEUTROPENIA BENIGNA CRÓNICA"
  },
  {
    "codigo":431031001,
    "descripcion":"FRACTURA OSTEOPORÓTICA DE CUELLO DE FÉMUR"
  },
  {
    "codigo":170722009,
    "descripcion":"EFECTO COLATERAL OFTALMOLÓGICO DE UN FÁRMACO"
  },
  {
    "codigo":70583001,
    "descripcion":"DESARROLLO INCOMPLETO DEL LABERINTO MEMBRANOSO"
  },
  {
    "codigo":6882009,
    "descripcion":"INFECCIÓN CAUSADA POR DIPETALONEMA RECONDITUM"
  },
  {
    "codigo":398263009,
    "descripcion":"BLOQUEO DE LA CONDUCCIÓN NERVIOSA MOTORA- EN PARCHES"
  },
  {
    "codigo":429196001,
    "descripcion":"OBSTRUCCIÓN PARCIAL DE INTESTINO DELGADO"
  },
  {
    "codigo":298124005,
    "descripcion":"LESIÓN DE NERVIO CUTÁNEO EXTERNO DE ANTEBRAZO"
  },
  {
    "codigo":230753000,
    "descripcion":"HIDROCEFALIA POR SOBREPRODUCCIÓN DE LÍQUIDO CEFALORRAQUÍDEO"
  },
  {
    "codigo":134284009,
    "descripcion":"LEE CANTONÉS"
  },
  {
    "codigo":34145007,
    "descripcion":"FÍSTULA CERVICOVESICAL"
  },
  {
    "codigo":65078002,
    "descripcion":"MICCIÓN AUTOMÁTICA"
  },
  {
    "codigo":720438009,
    "descripcion":"CAPAZ DE ADOPTAR UNA DECISIÓN SOBRE EL INGRESO SEGURO DE VISITANTES"
  },
  {
    "codigo":292619001,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR CORTICOSTEROIDES ADMINISTRADOS POR INHALACIÓN"
  },
  {
    "codigo":718603002,
    "descripcion":"DEFICIENCIA DE AMINOTRANSFERASA DE FOSFOSERINA"
  },
  {
    "codigo":423691004,
    "descripcion":"NEOPLASIA MALIGNA DE ENCÍA Y LUGARES CONTIGUOS"
  },
  {
    "codigo":30475004,
    "descripcion":"ATROFIA SENIL DE LA PIEL"
  },
  {
    "codigo":194315002,
    "descripcion":"PERFORACIÓN DEL TÍMPANO A LA ALTURA DEL ÁTICO"
  },
  {
    "codigo":10625351000119105,
    "descripcion":"BRONCONEUMONÍA CAUSADA POR STAPHYLOCOCCUS AUREUS RESISTENTE A LA METICILINA"
  },
  {
    "codigo":389088001,
    "descripcion":"HIPOXIA CEREBRAL"
  },
  {
    "codigo":126944002,
    "descripcion":"TRASTORNO CEREBRAL LUEGO DE UN PERÍODO DE APORTE INSUFICIENTE DE OXÍGENO AL CEREBRO"
  },
  {
    "codigo":716768008,
    "descripcion":"DISPLASIA DE TRÓCLEA DE FÉMUR"
  },
  {
    "codigo":190645001,
    "descripcion":"OSTEOMALACIA DEL ADULTO POR MALA ABSORCIÓN"
  },
  {
    "codigo":321717001,
    "descripcion":"DEPRESIÓN INVOLUTIVA"
  },
  {
    "codigo":288949005,
    "descripcion":"TRAGA LÍQUIDOS"
  },
  {
    "codigo":92341008,
    "descripcion":"NEOPLASIA BENIGNA DE HUESO CORTO DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":418186002,
    "descripcion":"PELAGRA"
  },
  {
    "codigo":449119000,
    "descripcion":"OBSTRUCCIÓN DEL TRACTO DE SALIDA AÓRTICO"
  },
  {
    "codigo":1268319002,
    "descripcion":"HIPERTROFIA DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":711263002,
    "descripcion":"DISFUNCIÓN DEL PISO PÉLVICO"
  },
  {
    "codigo":416351002,
    "descripcion":"GLIOMA INTRAOCULAR DEL NERVIO ÓPTICO"
  },
  {
    "codigo":15677921000119104,
    "descripcion":"CORIORRETINITIS DE OJO DERECHO CAUSADA POR CITOMEGALOVIRUS HUMANO BETA 5"
  },
  {
    "codigo":1332020002,
    "descripcion":"OSTEÓLISIS DE FÉMUR DERECHO"
  },
  {
    "codigo":840500002,
    "descripcion":"EMBOLIA DEBIDA A VEGETACIÓN DE VÁLVULA CARDÍACA DE CAUSA INFECCIOSA"
  },
  {
    "codigo":447284002,
    "descripcion":"VENTRÍCULO DERECHO CON DOBLE TRACTO DE SALIDA Y TABIQUE INTERVENTRICULAR INTACTO"
  },
  {
    "codigo":16906721000119106,
    "descripcion":"CARCINOMA IN SITU DE PIEL DE PÁRPADO INFERIOR DERECHO"
  },
  {
    "codigo":283444006,
    "descripcion":"CORTE EN EL TALÓN"
  },
  {
    "codigo":54068009,
    "descripcion":"INTOXICACIÓN POR TREMA ASPERA"
  },
  {
    "codigo":248841006,
    "descripcion":"DERRAME DE LECHE POR PEZÓN"
  },
  {
    "codigo":707593008,
    "descripcion":"CARCINOMA PRIMARIO DE OROFARINGE TIPO GLÁNDULA SALIVAL"
  },
  {
    "codigo":738526005,
    "descripcion":"POLIMIOSITIS JUVENIL"
  },
  {
    "codigo":247006009,
    "descripcion":"SUSTANCIA DE LENTES BLANDAS EN LA CÁMARA ANTERIOR"
  },
  {
    "codigo":1162675003,
    "descripcion":"CABELLO RALO"
  },
  {
    "codigo":336421000119100,
    "descripcion":"PIGMENTACIÓN CORNEAL ANTERIOR DERECHA"
  },
  {
    "codigo":341541000119101,
    "descripcion":"MUCOCELE CRÓNICO LAGRIMAL IZQUIERDO"
  },
  {
    "codigo":21541000119102,
    "descripcion":"EL PACIENTE SE RETIRÓ SIN SER ATENDIDO"
  },
  {
    "codigo":290341000119103,
    "descripcion":"MONOPLEJÍA DE MIEMBRO INFERIOR DERECHO NO DOMINANTE"
  },
  {
    "codigo":1091621000119103,
    "descripcion":"INFLAMACIÓN DE ESTRUCTURA DEL LABERINTO DERECHO"
  },
  {
    "codigo":10852901000119105,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO DIGITAL DE DEDO MEÑIQUE DERECHO"
  },
  {
    "codigo":15960101000119104,
    "descripcion":"ANGINA DE PECHO DEBIDA A ARTERIOSCLEROSIS EN ARTERIA DE CORAZÓN TRASPLANTADO"
  },
  {
    "codigo":67621000119105,
    "descripcion":"DERMATITIS AGUDA DE CONTACTO CAUSADA POR LÁTEX"
  },
  {
    "codigo":11828261000119106,
    "descripcion":"RUPTURA TRAUMÁTICA DE TENDÓN DE CUÁDRICEPS DERECHO"
  },
  {
    "codigo":313381000119109,
    "descripcion":"ARTROFITO EN ARTICULACIÓN DE DEDO DE PIE IZQUIERDO"
  },
  {
    "codigo":1061000119101,
    "descripcion":"EXCESO DE PANÍCULO ABDOMINAL"
  },
  {
    "codigo":308261000119103,
    "descripcion":"DEFORMIDAD EN FLEXIÓN DE ARTICULACIÓN DE RODILLA DERECHA"
  },
  {
    "codigo":323621000119108,
    "descripcion":"TUMOR TENOSINOVIAL DE CÉLULAS GIGANTES DIFUSO DE ARTICULACIÓN DE RODILLA IZQUIERDA"
  },
  {
    "codigo":734856003,
    "descripcion":"INFECCIÓN DE BOLSILLO PARA IMPLANTE QUIRÚRGICO"
  },
  {
    "codigo":321061000119109,
    "descripcion":"ENTESOPATÍA ESPINAL DE REGIÓN TORACOLUMBAR"
  },
  {
    "codigo":276104006,
    "descripcion":"PERTURBACIÓN HOGAREÑA"
  },
  {
    "codigo":10850341000119107,
    "descripcion":"HERIDA ABIERTA DE PARED TORÁCICA IZQUIERDA"
  },
  {
    "codigo":15934501000119109,
    "descripcion":"COXA VALGA CONGÉNITA DE CADERA DERECHA"
  },
  {
    "codigo":208733004,
    "descripcion":"FRACTURAS MÚLTIPLES DE PIE"
  },
  {
    "codigo":332411000119108,
    "descripcion":"RETINOPATÍA POR PREMATUREZ DEL OJO DERECHO"
  },
  {
    "codigo":1290077007,
    "descripcion":"ESTENOSIS DE VÁLVULA TRICUSPÍDEA CON INSUFICIENCIA DEBIDA A TUMOR NEUROENDOCRINO"
  },
  {
    "codigo":403506000,
    "descripcion":"MUCINOSIS PAPULONODULAR ASOCIADA CON LUPUS ERITEMATOSO"
  },
  {
    "codigo":15952661000119101,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE AMBAS MAMAS"
  },
  {
    "codigo":77661009,
    "descripcion":"ÚLCERA PÉPTICA CRÓNICA CON HEMORRAGIA, PERFORACIÓN Y OBSTRUCCIÓN"
  },
  {
    "codigo":1222706005,
    "descripcion":"SÍNDROME DE PROTRUSIÓN MAXILAR ANTERIOR, ESTRABISMO Y DISCAPACIDAD INTELECTUAL"
  },
  {
    "codigo":205063003,
    "descripcion":"GENU RECURVATUM CONGÉNITO"
  },
  {
    "codigo":237831008,
    "descripcion":"HIPERSECRECIÓN NO PANCREÁTICA DE HORMONAS INTESTINALES"
  },
  {
    "codigo":303367008,
    "descripcion":"DIFICULTAD PARA EMPUJAR"
  },
  {
    "codigo":235996002,
    "descripcion":"ABSCESO DE SACO MENOR"
  },
  {
    "codigo":203228001,
    "descripcion":"INFECCIÓN DE METACARPIANO"
  },
  {
    "codigo":301532002,
    "descripcion":"DIFICULTAD PARA ENTRAR EN LA BAÑERA"
  },
  {
    "codigo":37553001,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA VENA AXILAR"
  },
  {
    "codigo":266929003,
    "descripcion":"TABAQUISMO INICIADO"
  },
  {
    "codigo":365233005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA MANEJAR LA MEDICACIÓN"
  },
  {
    "codigo":823985006,
    "descripcion":"NERVIO ACCESORIO ESPINAL INTACTO"
  },
  {
    "codigo":234161007,
    "descripcion":"HEMANGIOMATOSIS CAPILAR PULMONAR FAMILIAR"
  },
  {
    "codigo":199558002,
    "descripcion":"DAÑO FETAL CAUSADO POR DISPOSITIVO ANTICONCEPTIVO INTRAUTERINO"
  },
  {
    "codigo":363398003,
    "descripcion":"NEOPLASIA MALIGNA DE PARED LATERAL DE NASOFARINGE"
  },
  {
    "codigo":723846002,
    "descripcion":"CONDROSARCOMA ÓSEO PRIMARIO DE COSTILLA"
  },
  {
    "codigo":427099000,
    "descripcion":"TUBERCULOSIS ACTIVA"
  },
  {
    "codigo":164955000,
    "descripcion":"ELECTROCARDIOGRAMA: INTERVALO Q-T NORMAL"
  },
  {
    "codigo":230491004,
    "descripcion":"SOMNOLENCIA DIURNA EXCESIVA POSVIRAL"
  },
  {
    "codigo":66651005,
    "descripcion":"SÍNDROME DE TRIPLOIDÍA"
  },
  {
    "codigo":263259006,
    "descripcion":"LUXACIÓN DE CARTÍLAGO COSTAL"
  },
  {
    "codigo":334921000119100,
    "descripcion":"HEMORRAGIA INTRAOCULAR DE OJO DERECHO"
  },
  {
    "codigo":195888009,
    "descripcion":"NEUMONÍA POR PROTEUS"
  },
  {
    "codigo":1144325002,
    "descripcion":"ATROFIA DE AMBOS RIÑONES"
  },
  {
    "codigo":95749004,
    "descripcion":"CONJUNTIVITIS PIOGRANULOMATOSA"
  },
  {
    "codigo":292357006,
    "descripcion":"REACCIÓN ADVERSA AL OXAZEPAM"
  },
  {
    "codigo":93914000,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL MIOCARDIO"
  },
  {
    "codigo":290522001,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR TRICLOROETILENO"
  },
  {
    "codigo":1306330000,
    "descripcion":"GLAUCOMA DE ÁNGULO CERRADO BILATERAL DEBIDO A SINEQUIA ANTERIOR PERIFÉRICA"
  },
  {
    "codigo":257754003,
    "descripcion":"ANGULACIÓN EN EXTENSIÓN"
  },
  {
    "codigo":11312201000119103,
    "descripcion":"FRACTURA POR ESTRÉS DE VÉRTEBRA LUMBAR"
  },
  {
    "codigo":126682007,
    "descripcion":"NEOPLASIA DE LA PARED POSTERIOR DE LA NASOFARINGE"
  },
  {
    "codigo":716506007,
    "descripcion":"NO UTILIZA LA COMBINACIÓN CONSONANTE-VOCAL-CONSONANTE-VOCAL"
  },
  {
    "codigo":224986009,
    "descripcion":"REGRESIÓN A TRAVÉS DE LA RECAPITULACIÓN"
  },
  {
    "codigo":26543004,
    "descripcion":"INTOXICACIÓN POR DAUNORUBICINA"
  },
  {
    "codigo":288687004,
    "descripcion":"DIFICULTAD PARA PRESUPONER EN UNA CONVERSACIÓN"
  },
  {
    "codigo":354223006,
    "descripcion":"OSTEOCONDROSIS JUVENIL DE EXTREMIDAD INFERIOR, EXCLUIDO EL PIE"
  },
  {
    "codigo":92079007,
    "descripcion":"NEOPLASIA BENIGNA DE LA COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":90244007,
    "descripcion":"CONTUSIÓN DEL TALÓN"
  },
  {
    "codigo":254084008,
    "descripcion":"CONDRODISPLASIA METAFISARIA, TIPO SPAHR"
  },
  {
    "codigo":285017007,
    "descripcion":"MANEJA DISPOSITIVOS MIENTRAS SE VISTE O DESVISTE"
  },
  {
    "codigo":448857009,
    "descripcion":"VÍA AÉREA ARTIFICIAL PERMEABLE"
  },
  {
    "codigo":414254005,
    "descripcion":"HALLAZGO RELACIONADO CON LA FRECUENCIA DE LA ACTIVIDAD SEXUAL"
  },
  {
    "codigo":283182006,
    "descripcion":"CUERPO EXTRAÑO METÁLICO EN EL TOBILLO"
  },
  {
    "codigo":445187004,
    "descripcion":"SÍNDROME ANTISINTETASA"
  },
  {
    "codigo":246744000,
    "descripcion":"MICROTROPÍA DIVERGENTE"
  },
  {
    "codigo":248579008,
    "descripcion":"RESPIRACIÓN SIBILANTE"
  },
  {
    "codigo":1295320002,
    "descripcion":"ICTERICIA NEONATAL DEBIDA A SÍNDROME DE BILIS ESPESA"
  },
  {
    "codigo":84739008,
    "descripcion":"HERNIA ISQUIORRECTAL CON OBSTRUCCIÓN"
  },
  {
    "codigo":443352005,
    "descripcion":"DISTONÍA CRANEANA"
  },
  {
    "codigo":11777251000119106,
    "descripcion":"LACERACIÓN DE MÚSCULO BÍCEPS BRAQUIAL IZQUIERDO"
  },
  {
    "codigo":408749000,
    "descripcion":"SÍNDROME DE DOLOR REGIONAL COMPLEJO, TIPO II, MIEMBRO INFERIOR"
  },
  {
    "codigo":1197016009,
    "descripcion":"ENFERMEDAD GINGIVAL POR ESCLERODERMIA"
  },
  {
    "codigo":48301005,
    "descripcion":"AUSENCIA CONGÉNITA DE DEDO DE LA MANO"
  },
  {
    "codigo":212141007,
    "descripcion":"LESIÓN TRAUMÁTICA DEL TRAYECTO Y DEL NERVIO ÓPTICO"
  },
  {
    "codigo":308610005,
    "descripcion":"SITUACIÓN DE EXAMEN DE MANEJO DE CONDUCTOR DE TAXÍMETRO"
  },
  {
    "codigo":1258882007,
    "descripcion":"VÁRICE DE VENA YUGULAR EXTERNA"
  },
  {
    "codigo":44631003,
    "descripcion":"INTOXICACIÓN POR METILPARATIÓN"
  },
  {
    "codigo":16747901000119104,
    "descripcion":"RETINOPATÍA PROLIFERATIVA DE OJO IZQUIERDO DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":208471006,
    "descripcion":"FRACTURA EXPUESTA DE LA FALANGE PROXIMAL DEL PULGAR, CABEZA"
  },
  {
    "codigo":110167007,
    "descripcion":"ABRASIÓN DE PIEL DE REGIÓN PERIORAL DE CARA"
  },
  {
    "codigo":306775006,
    "descripcion":"INCAPAZ DE DEGLUTIR ALIMENTOS BLANDOS"
  },
  {
    "codigo":403244008,
    "descripcion":"PELO RUBIO ROJIZO"
  },
  {
    "codigo":237569006,
    "descripcion":"BOCIO UNINODULAR"
  },
  {
    "codigo":301270004,
    "descripcion":"MATIDEZ HEPÁTICA A LA PERCUSIÓN, DESPLAZADA HACIA ABAJO"
  },
  {
    "codigo":235734008,
    "descripcion":"FÍSTULA DEL INTESTINO DELGADO"
  },
  {
    "codigo":1216939003,
    "descripcion":"SÍNDROME DE PREDISPOSICIÓN A CARCINOMA HEPATOCELULAR Y A RASGOS PROGEROIDES"
  },
  {
    "codigo":364971003,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA DESCENDER EL PALADAR BLANDO"
  },
  {
    "codigo":400947008,
    "descripcion":"FIBROSIS CONGÉNITA DE MÚSCULO RECTO INFERIOR"
  },
  {
    "codigo":4523006,
    "descripcion":"SÍNDROME DE BABINSKI - NAGEOTTE"
  },
  {
    "codigo":725419003,
    "descripcion":"EPIDERMÓLISIS BULLOSA DISTRÓFICA RECESIVA CENTRÍPETA"
  },
  {
    "codigo":233899006,
    "descripcion":"TAQUICARDIA AURICULOVENTRICULAR REENTRANTE ANTIDRÓMICA"
  },
  {
    "codigo":264832001,
    "descripcion":"EOSINÓFILOS URINARIOS"
  },
  {
    "codigo":199296002,
    "descripcion":"ENDOCRINOPATÍAS, METABOLOPATÍAS Y TRASTORNOS ALIMENTARIOS QUE COMPLICAN EL EMBARAZO, EL PARTO Y EL PUERPERIO"
  },
  {
    "codigo":789120001,
    "descripcion":"QUISTE NEUROENTÉRICO"
  },
  {
    "codigo":723584003,
    "descripcion":"SÍNDROME DE STERN LUBINSKY"
  },
  {
    "codigo":461440001,
    "descripcion":"ANOMALÍA CONGÉNITA DE ARTERIA SISTÉMICA"
  },
  {
    "codigo":232064001,
    "descripcion":"SÍNDROME DE WAGNER"
  },
  {
    "codigo":295765001,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE FLUDARABINA"
  },
  {
    "codigo":230229007,
    "descripcion":"ATAXIA CEREBELOSA DE INICIO TEMPRANO CON HIPOGONADISMO"
  },
  {
    "codigo":1074711000119108,
    "descripcion":"ARTRITIS DE AMBOS CODOS"
  },
  {
    "codigo":11861681000119102,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO PERONEO IZQUIERDO"
  },
  {
    "codigo":721749008,
    "descripcion":"MENINGITIS CAUSADA POR STAPHYLOCOCCUS AUREUS RESISTENTE A LA METICILINA"
  },
  {
    "codigo":293930006,
    "descripcion":"ALERGIA A PERICIAZINA"
  },
  {
    "codigo":719914008,
    "descripcion":"CRISTALES DE URATO PRESENTES EN EL EXAMEN MICROSCÓPICO"
  },
  {
    "codigo":31786009,
    "descripcion":"ULCERACIÓN DE BRONQUIOLOS"
  },
  {
    "codigo":128255002,
    "descripcion":"HALLAZGO A LA PERCUSIÓN DE LOS CAMPOS PULMONARES"
  },
  {
    "codigo":147121000119104,
    "descripcion":"EPENDIMOMA DEL SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":292095005,
    "descripcion":"REACCIÓN ADVERSA A MEDIOS DE CONTRASTE"
  },
  {
    "codigo":29951006,
    "descripcion":"LARINGITIS CRÓNICA"
  },
  {
    "codigo":783615009,
    "descripcion":"UROPORFIRIA ERITROPOYÉTICA ASOCIADA CON NEOPLASIA MALIGNA MIELOIDE"
  },
  {
    "codigo":93652001,
    "descripcion":"MELANOMA MALIGNO DE LA PIEL DEL OMBLIGO"
  },
  {
    "codigo":880084003,
    "descripcion":"LESIÓN TRAUMÁTICA DE TENDÓN DE PIERNA"
  },
  {
    "codigo":191956005,
    "descripcion":"HIPERVENTILACIÓN PSICÓGENA"
  },
  {
    "codigo":28116007,
    "descripcion":"PASIVIDAD DE INICIATIVA"
  },
  {
    "codigo":124585001,
    "descripcion":"DEFICIENCIA DE SERINA PROTEINASA"
  },
  {
    "codigo":288425002,
    "descripcion":"INCAPAZ DE CORTAR CON TIJERA"
  },
  {
    "codigo":290260009,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR IBUPROFENO"
  },
  {
    "codigo":11779761000119107,
    "descripcion":"ABRASIÓN DE PIEL DE REGIÓN DE CODO DERECHO"
  },
  {
    "codigo":1337001005,
    "descripcion":"TRASTORNO POR USO DE FENCICLIDINA"
  },
  {
    "codigo":59049008,
    "descripcion":"CÁLCULO DE CONDUCTO HEPÁTICO"
  },
  {
    "codigo":188286001,
    "descripcion":"NEOPLASIA MALIGNA DE HIPOTÁLAMO"
  },
  {
    "codigo":26281008,
    "descripcion":"INFECCIÓN CAUSADA POR BUNOSTOMUM PHLEBOTOMUM"
  },
  {
    "codigo":253822004,
    "descripcion":"TORSIÓN CONGÉNITA DE OVARIO"
  },
  {
    "codigo":219219002,
    "descripcion":"HERIDA CORTANTE CON INTENCIÓN HOMICIDA EN CUALQUIER PARTE DEL CUERPO"
  },
  {
    "codigo":55379003,
    "descripcion":"PSEUDOARTROSIS CONGÉNITA DE TIBIA"
  },
  {
    "codigo":284755004,
    "descripcion":"DAÑO DE HERIDAS PROPIAS INFLIGIDO POR EL PACIENTE: CON INTRODUCCIÓN DE DEDOS DE LA MANO"
  },
  {
    "codigo":448595006,
    "descripcion":"SÍNDROME DE LA CIMITARRA CON CONEXIÓN VENOSA PULMONAR ANÓMALA ADICIONAL"
  },
  {
    "codigo":16750411000119105,
    "descripcion":"QUISTE SEROSO DE AMBOS OVARIOS"
  },
  {
    "codigo":22611009,
    "descripcion":"ENDOMETRIOSIS DE TROMPA DE FALOPIO"
  },
  {
    "codigo":250152006,
    "descripcion":"SUELA DEL CALZADO MUY RÍGIDA"
  },
  {
    "codigo":282920006,
    "descripcion":"INCAPAZ DE INCORPORARSE"
  },
  {
    "codigo":18941000,
    "descripcion":"TRASTORNO NEGATIVISTA DESAFIANTE"
  },
  {
    "codigo":444925004,
    "descripcion":"GLUCOSA AL AZAR FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":836306003,
    "descripcion":"AGUDEZA VISUAL DE OJO IZQUIERDO 6\/24"
  },
  {
    "codigo":82642007,
    "descripcion":"APLASIA UTERINA SEGMENTARIA"
  },
  {
    "codigo":768935003,
    "descripcion":"DISPLASIA EPIFISARIA MÚLTIPLE TIPO LOWRY"
  },
  {
    "codigo":111740003,
    "descripcion":"FALLA MECÁNICA DE DISPOSITIVO CARDÍACO"
  },
  {
    "codigo":373884003,
    "descripcion":"CÉLULAS ENDOMETRIALES DE MUJER DE CUARENTA AÑOS O MÁS"
  },
  {
    "codigo":439420004,
    "descripcion":"PENE NO CIRCUNCISO"
  },
  {
    "codigo":46204008,
    "descripcion":"INFECCIÓN CAUSADA POR FILAROIDES"
  },
  {
    "codigo":109905002,
    "descripcion":"MIELOCELE ADQUIRIDO"
  },
  {
    "codigo":175441005,
    "descripcion":"EFECTO HORMONAL EN EL TEJIDO EFECTOR"
  },
  {
    "codigo":94181000119108,
    "descripcion":"DUPLICACIÓN CONGÉNITA DEL SISTEMA COLECTOR RENAL SIN OBSTRUCCIÓN"
  },
  {
    "codigo":402982000,
    "descripcion":"INFECCIÓN CUTÁNEA POR MYCOBACTERIUM GORDONAE"
  },
  {
    "codigo":16697471000119102,
    "descripcion":"RETINOPATÍA NO PROLIFERATIVA MODERADA DE OJO DERECHO DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":1287718002,
    "descripcion":"ERROR EN DOSIS EN PRESCRIPCIÓN"
  },
  {
    "codigo":1254950004,
    "descripcion":"EDEMA DEBIDO A HIPOPROTEINEMIA"
  },
  {
    "codigo":239142006,
    "descripcion":"BEBÉ MICHELIN"
  },
  {
    "codigo":7931000,
    "descripcion":"ÁNTRAX DE LA REGIÓN PECTORAL"
  },
  {
    "codigo":270075001,
    "descripcion":"EL COMITÉ DE MÉDICOS DE FAMILIA (FPC) RECONOCE EL DESREGISTRO DEL PACIENTE"
  },
  {
    "codigo":204539006,
    "descripcion":"ANOMALÍA DE LA EPIGLOTIS"
  },
  {
    "codigo":237307007,
    "descripcion":"CIRCULAR DE CORDÓN UMBILICAL ALREDEDOR DEL CUERPO"
  },
  {
    "codigo":169936002,
    "descripcion":"FACTOR DE RIESGO - INTERNACIÓN EN UNIDAD DE CUIDADOS ESPECIALES PARA LACTANTES"
  },
  {
    "codigo":6096002,
    "descripcion":"PRESENTACIÓN PÉLVICA"
  },
  {
    "codigo":301008003,
    "descripcion":"HERNIA UMBILICAL REDUCTIBLE"
  },
  {
    "codigo":268240006,
    "descripcion":"TORTÍCOLIS CONGÉNITO"
  },
  {
    "codigo":366544008,
    "descripcion":"HALLAZGO RELACIONADO CON COLORACIÓN DE ARTICULACIÓN DE MUÑECA"
  },
  {
    "codigo":102565005,
    "descripcion":"EDEMA DE DEDO DE LA MANO"
  },
  {
    "codigo":725157006,
    "descripcion":"PÚRPURA FULMINANTE ADQUIRIDA"
  },
  {
    "codigo":16097561000119102,
    "descripcion":"ARTROFIBROSIS DE AMBOS PIES"
  },
  {
    "codigo":233637009,
    "descripcion":"PLEURITIS FARMACÓGENA"
  },
  {
    "codigo":168101009,
    "descripcion":"ANÁLISIS BIOQUÍMICO DE LÍQUIDO AMNIÓTICO FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":723322003,
    "descripcion":"DISFUNCIÓN SOMÁTICA DE ARTICULACIÓN ESCAPULOTORÁCICA"
  },
  {
    "codigo":67962003,
    "descripcion":"TROMBOSIS DE TESTÍCULO"
  },
  {
    "codigo":231802001,
    "descripcion":"IMPÉTIGO PALPEBRAL"
  },
  {
    "codigo":368921000119102,
    "descripcion":"SÍNDROME NEFRÍTICO CONCOMITANTE CON GLOMERULONEFRITIS MEMBRANOPROLIFERATIVA TIPO III Y DEBIDO A ELLA"
  },
  {
    "codigo":721487001,
    "descripcion":"SÍNDROME DE BROWN-SEQUARD AL NIVEL DEL SEXTO SEGMENTO DORSAL"
  },
  {
    "codigo":197199007,
    "descripcion":"ADHERENCIAS PERIRRECTALES"
  },
  {
    "codigo":295503008,
    "descripcion":"SOBREDOSIS DE ETOMIDATO"
  },
  {
    "codigo":262735009,
    "descripcion":"CONTUSIÓN DE LA RAÍZ DE NERVIO DORSAL"
  },
  {
    "codigo":817956002,
    "descripcion":"DERMATITIS EXÓGENA"
  },
  {
    "codigo":293668005,
    "descripcion":"ALERGIA A LOPERAMIDA"
  },
  {
    "codigo":882784691000119100,
    "descripcion":"NEUMONÍA CAUSADA POR SARS-COV-2"
  },
  {
    "codigo":719652007,
    "descripcion":"SÍNDROME DE MICRODELECIÓN 2P21"
  },
  {
    "codigo":31524007,
    "descripcion":"POLINEUROPATÍA POR VIRUS DE LA PAROTIDITIS URLIANA"
  },
  {
    "codigo":129828009,
    "descripcion":"MANEJO INEFICAZ DEL RÉGIMEN TERAPÉUTICO FAMILIAR"
  },
  {
    "codigo":291833001,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR ESTRÓGENO"
  },
  {
    "codigo":29689003,
    "descripcion":"MIOSITIS INFECCIOSA"
  },
  {
    "codigo":1078265004,
    "descripcion":"AGENESIA DE EPÍFISIS DE FALANGE MEDIA DE QUINTO DEDO DE PIE"
  },
  {
    "codigo":95225003,
    "descripcion":"RETICULOSARCOMA DE LOS GANGLIOS LINFÁTICOS INTRAPÉLVICOS"
  },
  {
    "codigo":717817006,
    "descripcion":"ABSCESO DE MAMA ASOCIADO CON DIFICULTAD EN EL APEGO EN EL NACIMIENTO"
  },
  {
    "codigo":816121007,
    "descripcion":"COLOR DE PIE DERECHO NORMAL"
  },
  {
    "codigo":160761000,
    "descripcion":"ASISTENCIA DE LA ENFERMERA DEL DISTRITO"
  },
  {
    "codigo":228132008,
    "descripcion":"ACCESO AL NIÑO, RECHAZADO"
  },
  {
    "codigo":93390002,
    "descripcion":"COLOBOMA OCULAR CONGÉNITO"
  },
  {
    "codigo":60622002,
    "descripcion":"INTOXICACIÓN POR PHYTOLACCA"
  },
  {
    "codigo":224462003,
    "descripcion":"SUSPENDIDO DEL TRABAJO"
  },
  {
    "codigo":289998006,
    "descripcion":"RADIONECROSIS DE LA PIEL"
  },
  {
    "codigo":715982006,
    "descripcion":"INMUNODEFICIENCIA COMBINADA SEVERA DEBIDA A DEFICIENCIA DE PROTEÍNA 1C DE REPARACIÓN DE LIGADURAS CRUZADAS DE ÁCIDO DESOXIRRIBONUCLEICO"
  },
  {
    "codigo":1172899000,
    "descripcion":"SÍNDROME DE DUPLICACIÓN DE GENES CONTIGUOS PMP22-RAI1"
  },
  {
    "codigo":91555003,
    "descripcion":"FÓRMULA PARA LACTANTES"
  },
  {
    "codigo":124323007,
    "descripcion":"DEFICIENCIA DE GLICERATO CINASA"
  },
  {
    "codigo":89720001,
    "descripcion":"QUEMADURA DE LOS ÓRGANOS GENITALES FEMENINOS"
  },
  {
    "codigo":24184005,
    "descripcion":"PRESIÓN ARTERIAL AUMENTADA"
  },
  {
    "codigo":286328007,
    "descripcion":"EMITE VOZ"
  },
  {
    "codigo":1269368009,
    "descripcion":"CRISIS EPILÉPTICA ATÓNICA CON ALTERACIÓN DE CONCIENCIA DE INICIO FOCAL"
  },
  {
    "codigo":894171571000119107,
    "descripcion":"CARCINOMA PRIMARIO DE CÉLULAS RENALES DE RIÑÓN DERECHO"
  },
  {
    "codigo":218957003,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR DIFENOXILATO"
  },
  {
    "codigo":284493005,
    "descripcion":"CONDUCTA NO REFORZADA"
  },
  {
    "codigo":774178003,
    "descripcion":"CALAMBRE DE MÚSCULO DE EXTREMIDAD SUPERIOR IZQUIERDA"
  },
  {
    "codigo":249890004,
    "descripcion":"MOVIMIENTO LATERAL DEL MENTÓN DÉBIL"
  },
  {
    "codigo":1003554003,
    "descripcion":"AGENESIA DE HÚMERO"
  },
  {
    "codigo":315426005,
    "descripcion":"NACIDO EN FINLANDIA"
  },
  {
    "codigo":282658008,
    "descripcion":"CAPAZ DE GOLPEAR"
  },
  {
    "codigo":84215002,
    "descripcion":"MUECA NASAL"
  },
  {
    "codigo":248055002,
    "descripcion":"DESCUIDO DE LA ROPA"
  },
  {
    "codigo":16844001,
    "descripcion":"ESTRANGURIA"
  },
  {
    "codigo":82380002,
    "descripcion":"CUERPO EXTRAÑO EN EL INTESTINO"
  },
  {
    "codigo":703137001,
    "descripcion":"DIABETES MELLITUS TIPO I EN REMISIÓN"
  },
  {
    "codigo":735905002,
    "descripcion":"MÚLTIPLES TAPONES MUCOSOS TRAQUEOBRONQUIALES"
  },
  {
    "codigo":10693351000119101,
    "descripcion":"DERMATOCALASIA DE AMBOS PÁRPADOS SUPERIORES"
  },
  {
    "codigo":111478000,
    "descripcion":"ENURESIS NOCTURNA Y DIURNA"
  },
  {
    "codigo":440993008,
    "descripcion":"ENFERMEDAD GRAVE POR DEFICIENCIA HEREDITARIA DE FACTOR VIII SIN INHIBIDORES"
  },
  {
    "codigo":275318002,
    "descripcion":"SÍNDROME DE PIERNA DOLORIDA"
  },
  {
    "codigo":439158007,
    "descripcion":"ESCURRIMIENTO DE LÍQUIDO FECAL"
  },
  {
    "codigo":78710008,
    "descripcion":"REFLEJO CORNEAL AUSENTE"
  },
  {
    "codigo":699467005,
    "descripcion":"TRASTORNO DE ARTICULACIÓN ACROMIOCLAVICULAR"
  },
  {
    "codigo":402720000,
    "descripcion":"AMILOIDOSIS LIMITADA A LA PIEL"
  },
  {
    "codigo":76875008,
    "descripcion":"HIPERTROFIA DE LA VESÍCULA BILIAR"
  },
  {
    "codigo":271648003,
    "descripcion":"HIPOTENSIÓN ORTOSTÁTICA"
  },
  {
    "codigo":1082241000119100,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE BRONQUIO PRINCIPAL DERECHO"
  },
  {
    "codigo":237045001,
    "descripcion":"PARAMETRITIS CRÓNICA"
  },
  {
    "codigo":105973004,
    "descripcion":"TRASTORNO DE SENO FRONTAL"
  },
  {
    "codigo":1285621006,
    "descripcion":"HEMATOMA DE DEDO GORDO DE PIE"
  },
  {
    "codigo":7669008,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN METACARPOFALÁNGICA DE PULGAR"
  },
  {
    "codigo":399050001,
    "descripcion":"GINGIVITIS ULCERATIVA NECROSANTE AGUDA"
  },
  {
    "codigo":202442002,
    "descripcion":"TUMOR TENOSINOVIAL DE CÉLULAS GIGANTES DIFUSO DE ARTICULACIÓN INTERFALÁNGICA DISTAL DE DEDO DE MANO"
  },
  {
    "codigo":366282004,
    "descripcion":"VOLUMEN URINARIO - HALLAZGO"
  },
  {
    "codigo":5834008,
    "descripcion":"HIPERTIROIDISMO CAUSADO POR YODURO DE POTASIO"
  },
  {
    "codigo":300746009,
    "descripcion":"UTILIZA INSTALACIONES DE RECREACIÓN PÚBLICAS"
  },
  {
    "codigo":3999002,
    "descripcion":"PIELITIS AGUDA SIN NECROSIS MEDULAR RENAL"
  },
  {
    "codigo":724895005,
    "descripcion":"DISTENSIÓN DE TENDÓN DE PELVIS"
  },
  {
    "codigo":266143009,
    "descripcion":"CHANCROIDE"
  },
  {
    "codigo":298911009,
    "descripcion":"SIN AMPLITUD PASIVA DE SUPINACIÓN DE CODO"
  },
  {
    "codigo":231540008,
    "descripcion":"TRASTORNO DE LA CONDUCTA - EN EL CONTEXTO FAMILIAR"
  },
  {
    "codigo":297076009,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE DIAZÓXIDO"
  },
  {
    "codigo":229705002,
    "descripcion":"DISPRAXIA MIXTA ADQUIRIDA"
  },
  {
    "codigo":293406000,
    "descripcion":"REACCIÓN ADVERSA AL FOSFATO SÓDICO CELULÓSICO"
  },
  {
    "codigo":129566001,
    "descripcion":"SÍNDROME DE DESMINERALIZACIÓN ÓSEA DE LOS ASTRONAUTAS"
  },
  {
    "codigo":721225009,
    "descripcion":"HOMOCISTINURIA SIN ACIDURIA METILMALÓNICA"
  },
  {
    "codigo":424478004,
    "descripcion":"DEFORMIDAD EN FLEXIÓN DE DEDO DE LA MANO SEMIFLEXIONADO"
  },
  {
    "codigo":64030005,
    "descripcion":"NEUMONITIS CAUSADA POR SÓLIDOS INHALADOS"
  },
  {
    "codigo":719390006,
    "descripcion":"CAPAZ DE COMPRENDER INSTRUCCIONES DE DOS PALABRAS"
  },
  {
    "codigo":783091003,
    "descripcion":"SÍNDROME DE DISGENESIA GONADAL 46,XY Y NEUROPATÍA SENSITIVOMOTRIZ"
  },
  {
    "codigo":94963005,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL SISTEMA NERVIOSO"
  },
  {
    "codigo":160499008,
    "descripcion":"NIÑO DE"
  },
  {
    "codigo":1209075008,
    "descripcion":"PERIODONTITIS DEBIDA A NEUTROPENIA CONGÉNITA"
  },
  {
    "codigo":289736002,
    "descripcion":"CONTRACCIÓN UTERINA INAPROPIADA"
  },
  {
    "codigo":1010632003,
    "descripcion":"PSEUDOQUISTE DE CORDÓN UMBILICAL"
  },
  {
    "codigo":715720006,
    "descripcion":"BRAQUIDACTILIA TIPO A1"
  },
  {
    "codigo":93128007,
    "descripcion":"FALTA DE OSIFICACIÓN DE HUESO CIGOMÁTICO"
  },
  {
    "codigo":1172637002,
    "descripcion":"INFERTILIDAD FEMENINA POR ARRESTO MEIÓTICO DEL OVOCITO"
  },
  {
    "codigo":124061004,
    "descripcion":"CISTINA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":58525007,
    "descripcion":"ATELECTASIA OBSTRUCTIVA"
  },
  {
    "codigo":449906000,
    "descripcion":"FÍSTULA ARTERIOVENOSA PERIMEDULAR DE MÉDULA ESPINAL"
  },
  {
    "codigo":418973007,
    "descripcion":"TRASTORNO DE LA AMÍGDALA LINGUAL"
  },
  {
    "codigo":286066001,
    "descripcion":"CAPAZ DE DOBLAR LA ROPA LAVADA"
  },
  {
    "codigo":89458003,
    "descripcion":"ESTUPOR"
  },
  {
    "codigo":16538651000119108,
    "descripcion":"SENSACIÓN DE BLOQUEO DE OÍDO DERECHO"
  },
  {
    "codigo":253298003,
    "descripcion":"DOBLE TRACTO DE SALIDA DE VENTRÍCULO DERECHO CON DEFECTO SUBAÓRTICO DE TABIQUE INTERVENTRICULAR"
  },
  {
    "codigo":448071000,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE ANO"
  },
  {
    "codigo":185927004,
    "descripcion":"CONTROL DE EVENTOS RELACIONADOS CON LA PRESCRIPCIÓN FINALIZADO"
  },
  {
    "codigo":251463005,
    "descripcion":"COMPLEJOS PERIÓDICOS"
  },
  {
    "codigo":249628000,
    "descripcion":"HALLAZGO RELACIONADO CON EL ANO"
  },
  {
    "codigo":216860000,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR BROMOBENCILO DE CIANURO"
  },
  {
    "codigo":10751311000119100,
    "descripcion":"SALPINGITIS DEBIDA A EMBARAZO ECTÓPICO"
  },
  {
    "codigo":184092007,
    "descripcion":"PACIENTE TEMPORARIAMENTE EN UNA INSTITUCIÓN"
  },
  {
    "codigo":1263601000,
    "descripcion":"METÁSTASIS DE CARCINOMA ESCIRROSO EN MAMA"
  },
  {
    "codigo":313329001,
    "descripcion":"INERCIA ACOMODATIVA"
  },
  {
    "codigo":347471000119101,
    "descripcion":"CATARATA CORTICAL SENIL DE OJO DERECHO"
  },
  {
    "codigo":15938741000119108,
    "descripcion":"NEVO MELANOCÍTICO DE PIEL DE AMBOS MIEMBROS INFERIORES"
  },
  {
    "codigo":1360070001,
    "descripcion":"HIPERACTIVIDAD DE LA ACIL-COA REDUCTASA 1 DE ÁCIDOS GRASOS"
  },
  {
    "codigo":18417009,
    "descripcion":"HIPOPLASIA OLIGOMEGANEFRÓNICA DE RIÑÓN"
  },
  {
    "codigo":409798003,
    "descripcion":"INFECCIÓN CAUSADA POR VIRUS RESISTENTES A AGENTES ANTIMICROBIANOS"
  },
  {
    "codigo":1163462003,
    "descripcion":"INFECCIÓN GÁSTRICA POR HISTOPLASMA"
  },
  {
    "codigo":442566005,
    "descripcion":"FÍSTULA ARTERIOVENOSA RADIOCUBITAL CONSTRUIDA QUIRÚRGICAMENTE"
  },
  {
    "codigo":82118009,
    "descripcion":"EDAD GESTACIONAL, 2 SEMANAS"
  },
  {
    "codigo":735643002,
    "descripcion":"BAJA ESTATURA EN LA INFANCIA"
  },
  {
    "codigo":101711000119105,
    "descripcion":"GLOMERULONEFRITIS CONCOMITANTE CON VASCULITIS POSITIVA PARA ANTICUERPOS CITOPLASMÁTICOS ANTI-NEUTRÓFILOS Y DEBIDA A ELLA"
  },
  {
    "codigo":406128001,
    "descripcion":"PIEL MOTEADA"
  },
  {
    "codigo":276891009,
    "descripcion":"LIPOMA DE MAMA"
  },
  {
    "codigo":1290864002,
    "descripcion":"OSTEOSARCOMA SECUNDARIO POSTERIOR A TRATAMIENTO O ENFERMEDAD"
  },
  {
    "codigo":209520004,
    "descripcion":"DESGARRO PARCIAL DE RODILLA, LIGAMENTO CRUZADO ANTERIOR"
  },
  {
    "codigo":47515009,
    "descripcion":"SILICOSIS SIMPLE"
  },
  {
    "codigo":897648006,
    "descripcion":"MELANOSIS ADQUIRIDA PRIMARIA DE CÓRNEA DE OJO IZQUIERDO"
  },
  {
    "codigo":307824009,
    "descripcion":"ESTADOS ADMINISTRATIVOS"
  },
  {
    "codigo":240453002,
    "descripcion":"FIEBRE DE OROYA"
  },
  {
    "codigo":109381003,
    "descripcion":"ESCLEROSIS DE VENA SAFENA"
  },
  {
    "codigo":830277004,
    "descripcion":"ALERGIA A INHIBIDOR DE ALDEHÍDO DESHIDROGENASA"
  },
  {
    "codigo":271386001,
    "descripcion":"INSUFICIENCIA ADENOHIPOFISARIA POSINFECCIOSA"
  },
  {
    "codigo":402458002,
    "descripcion":"AMILOIDOSIS DE PIEL SECUNDARIA ASOCIADA A HEMODIÁLISIS"
  },
  {
    "codigo":1354565009,
    "descripcion":"DISPOSITIVO CONTENEDOR DE ESPÉCIMEN ROTO"
  },
  {
    "codigo":238618003,
    "descripcion":"PITIRIASIS ROSADA CLÁSICA DEL ADULTO"
  },
  {
    "codigo":369690005,
    "descripcion":"MARGEN PROXIMAL DE RESECCIÓN QUIRÚRGICA DE INTESTINO GRUESO, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":105711001,
    "descripcion":"ENFERMEDAD CAUSADA POR METASTRONGYLOIDEA"
  },
  {
    "codigo":40175007,
    "descripcion":"DERMATITIS ALÉRGICA CAUSADA POR MORDEDURA DE CTENOCEPHALIDES FELIS"
  },
  {
    "codigo":11789801000119105,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE DEDO ÍNDICE IZQUIERDO"
  },
  {
    "codigo":366020001,
    "descripcion":"HALLAZGO RELACIONADO CON LA REGULARIDAD DE LA PUPILA"
  },
  {
    "codigo":300484002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CONSISTENCIA DE LOS TESTÍCULOS"
  },
  {
    "codigo":1187055008,
    "descripcion":"COBRE SÉRICO POR ENCIMA DE RANGO DE REFERENCIA"
  },
  {
    "codigo":234948008,
    "descripcion":"DIENTE AUSENTE"
  },
  {
    "codigo":202180009,
    "descripcion":"LUXACIÓN PATOLÓGICA DE LA CABEZA DEL RADIO"
  },
  {
    "codigo":724633002,
    "descripcion":"PROBLEMA DE TOBILLO"
  },
  {
    "codigo":298649005,
    "descripcion":"AMPLITUD DE ROTACIÓN ACTIVA HACIA LA DERECHA DE LA COLUMNA LUMBAR DISMINUIDA"
  },
  {
    "codigo":321001000119108,
    "descripcion":"ENTESOPATÍA ESPINAL DE REGIÓN LUMBAR"
  },
  {
    "codigo":67438002,
    "descripcion":"INTOXICACIÓN CAUSADA POR ANTICOAGULANTES"
  },
  {
    "codigo":720963003,
    "descripcion":"QUISTE Y TROFOZOÍTO DE RETORTAMONAS INTESTINALIS"
  },
  {
    "codigo":131139004,
    "descripcion":"NIVEL DE SEROTONINA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":65603008,
    "descripcion":"SIGNO PSIQUIÁTRICO"
  },
  {
    "codigo":294979009,
    "descripcion":"ALERGIA A FLECAINIDA"
  },
  {
    "codigo":293144001,
    "descripcion":"REACCIÓN ADVERSA A LA HIDROCORTISONA TÓPICA"
  },
  {
    "codigo":677661000119100,
    "descripcion":"NEOVASCULARIZACIÓN POLIPOIDE COROIDEA DE OJO IZQUIERDO"
  },
  {
    "codigo":1208813000,
    "descripcion":"ALERGIA A PROTEÍNA DE GANADO VACUNO"
  },
  {
    "codigo":782829002,
    "descripcion":"ENFERMEDAD DE CHARCOT-MARIE-TOOTH TIPO 2O"
  },
  {
    "codigo":94701003,
    "descripcion":"BAZO MOTEADO"
  },
  {
    "codigo":291309002,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR METAPROTERENOL"
  },
  {
    "codigo":61933008,
    "descripcion":"HIPOTENSIÓN POSTURAL HIPERADRENÉRGICA"
  },
  {
    "codigo":387778001,
    "descripcion":"ENFERMEDAD PURPÚRICA"
  },
  {
    "codigo":92866002,
    "descripcion":"FUSIÓN ANORMAL CONGÉNITA DE MAXILAR"
  },
  {
    "codigo":60098005,
    "descripcion":"QUISTE DE LA VULVA"
  },
  {
    "codigo":125634005,
    "descripcion":"LESIÓN TRAUMÁTICA DEL COLON SIGMOIDE"
  },
  {
    "codigo":289474006,
    "descripcion":"LESIÓN DE VULVA"
  },
  {
    "codigo":58263000,
    "descripcion":"SÍNDROME DE MAROTEAUX - LAMY, FORMA SEVERA"
  },
  {
    "codigo":191170009,
    "descripcion":"ANEMIA HEMOLÍTICA POR TRASTORNO DEL METABOLISMO DEL GLUTATIÓN"
  },
  {
    "codigo":418711005,
    "descripcion":"SENSIBILIDAD VIBRATORIA DEL PIE DERECHO ALTERADA"
  },
  {
    "codigo":123799005,
    "descripcion":"HIPERTENSIÓN ARTERIAL VASCULORRENAL"
  },
  {
    "codigo":247347003,
    "descripcion":"INCOMODIDAD"
  },
  {
    "codigo":416876007,
    "descripcion":"CORMACK-LEHANE GRADO 3"
  },
  {
    "codigo":283969002,
    "descripcion":"HEMATOMA DEL PERINEO FEMENINO"
  },
  {
    "codigo":1332545005,
    "descripcion":"ARTRITIS GOTOSA DE ARTICULACIÓN RADIOCARPIANA DERECHA"
  },
  {
    "codigo":87361006,
    "descripcion":"ALTERACIÓN DE LA MADURACIÓN LEUCOCÍTICA CON DESVIACIÓN HACIA LA IZQUIERDA"
  },
  {
    "codigo":323511000119102,
    "descripcion":"DEFORMIDAD EN VARO ADQUIRIDA DE TOBILLO DERECHO"
  },
  {
    "codigo":1363478003,
    "descripcion":"ALTURA CORPORAL POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":413206005,
    "descripcion":"PAPILA DUODENAL NO ALCANZADA"
  },
  {
    "codigo":249366005,
    "descripcion":"SANGRADO DE LA NARIZ"
  },
  {
    "codigo":708118007,
    "descripcion":"ORGANISMO NO AISLADO EN CULTIVO MICROBIOLÓGICO"
  },
  {
    "codigo":314902007,
    "descripcion":"ANGIOPATÍA PERIFÉRICA DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":16052151000119104,
    "descripcion":"TENDINITIS DE AMBOS TENDONES DEL CUÁDRICEPS"
  },
  {
    "codigo":247531004,
    "descripcion":"CRECIMIENTO TARDÍO DE VELLO SEXUAL SECUNDARIO"
  },
  {
    "codigo":23081000175101,
    "descripcion":"HERIDA POR ARMA DE FUEGO DE EXTREMIDAD"
  },
  {
    "codigo":50923006,
    "descripcion":"LEUCOPLAQUIA DEL CUELLO UTERINO"
  },
  {
    "codigo":16543671000119105,
    "descripcion":"FRACTURA ABIERTA DE METÁFISIS DE RADIO DISTAL IZQUIERDO"
  },
  {
    "codigo":737216001,
    "descripcion":"HIPOPLASIA DE SACRO"
  },
  {
    "codigo":1359808004,
    "descripcion":"COLONIZACIÓN CRÓNICA DE TRACTO RESPIRATORIO CAUSADA POR BURKHOLDERIA"
  },
  {
    "codigo":704448006,
    "descripcion":"TENDENCIA A VAGABUNDEAR"
  },
  {
    "codigo":212928007,
    "descripcion":"CONGELAMIENTO CON NECROSIS TISULAR DE LA PARED ABDOMINAL, REGIÓN LUMBAR Y PELVIS"
  },
  {
    "codigo":16320008,
    "descripcion":"AMBIVALENCIA PSICOLÓGICA"
  },
  {
    "codigo":81856009,
    "descripcion":"FOLICULITIS INFUNDIBULAR DISEMINADA"
  },
  {
    "codigo":276629001,
    "descripcion":"HIPOTIROXINEMIA TRANSITORIA"
  },
  {
    "codigo":735381003,
    "descripcion":"BLOQUEO INTERMITENTE DE ARTICULACIÓN TEMPOROMANDIBULAR"
  },
  {
    "codigo":22558701000132108,
    "descripcion":"HALLAZGO DE ENTEROSCOPIA"
  },
  {
    "codigo":442304009,
    "descripcion":"DISFUNCIÓN SISTÓLICA Y DIASTÓLICA COMBINADA"
  },
  {
    "codigo":702613006,
    "descripcion":"APLASIA DE DIAFRAGMA"
  },
  {
    "codigo":243861002,
    "descripcion":"SITUACIÓN DEL MONITOREO DE ENFERMEDAD TIROIDEA"
  },
  {
    "codigo":471402000,
    "descripcion":"FÍSTULA PLEUROPERITONEAL"
  },
  {
    "codigo":11792311000119108,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN DE DEDO ÍNDICE IZQUIERDO"
  },
  {
    "codigo":1259669005,
    "descripcion":"CARCINOMA DUCTAL INFILTRANTE PRIMARIO DE PRÓSTATA"
  },
  {
    "codigo":209258001,
    "descripcion":"FRACTURA-SUBLUXACIÓN NO EXPUESTA DE ARTICULACIÓN DE CODO"
  },
  {
    "codigo":405866005,
    "descripcion":"FENOTIPO LE(B-)"
  },
  {
    "codigo":12650007,
    "descripcion":"DETERMINACIÓN DEL ESTADO DE LA ENFERMEDAD: BASTANTE BIEN CONTROLADA"
  },
  {
    "codigo":45418009,
    "descripcion":"PROBLEMA BÁSICO PARA EL APRENDIZAJE DEL HABLA"
  },
  {
    "codigo":404031001,
    "descripcion":"NEUROFIBROMA MIXOIDE"
  },
  {
    "codigo":15698001000119104,
    "descripcion":"ABSCESO DE BOLSA SEROSA DE AMBAS REGIONES DE HOMBRO"
  },
  {
    "codigo":10815006,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO DE AXILA"
  },
  {
    "codigo":305727006,
    "descripcion":"VISTO POR UN CIRUJANO DE TRASPLANTE"
  },
  {
    "codigo":830015009,
    "descripcion":"QUISTE DERMOIDE DE MÉDULA ESPINAL"
  },
  {
    "codigo":402196005,
    "descripcion":"DERMATITIS ATÓPICA DE LA INFANCIA"
  },
  {
    "codigo":271124006,
    "descripcion":"AMPOLLA TRAUMÁTICA DE FLANCO"
  },
  {
    "codigo":74516008,
    "descripcion":"CRANEÓPAGO"
  },
  {
    "codigo":72681001,
    "descripcion":"YEYUNITIS ALÉRGICA"
  },
  {
    "codigo":236521003,
    "descripcion":"NEFROPATÍA PORPENICILAMINA"
  },
  {
    "codigo":302057003,
    "descripcion":"IMITA MOVIMIENTOS DE LA LENGUA"
  },
  {
    "codigo":365758001,
    "descripcion":"NIVELES DE ELECTRÓLITOS - HALLAZGO"
  },
  {
    "codigo":267454002,
    "descripcion":"ACATALASEMIA"
  },
  {
    "codigo":300222003,
    "descripcion":"AUDICIÓN DE LA VOZ EN LA CONVERSACIÓN, NORMAL"
  },
  {
    "codigo":726206007,
    "descripcion":"LACERACIÓN DE FASCIA DE MÚSCULO INTRÍNSECO DE DEDO DE LA MANO"
  },
  {
    "codigo":5310008,
    "descripcion":"PARÁLISIS PUPILAR"
  },
  {
    "codigo":429459001,
    "descripcion":"ARTRITIS DE ARTICULACIÓN ACROMIOCLAVICULAR"
  },
  {
    "codigo":724371004,
    "descripcion":"COLOBOMA DE IRIS ADQUIRIDO"
  },
  {
    "codigo":55141000087104,
    "descripcion":"CON MAYOR RIESGO DE DEPRESIÓN RESPIRATORIA INDUCIDA POR OPIOIDE"
  },
  {
    "codigo":298387009,
    "descripcion":"AGRANDAMIENTO DE CUELLO"
  },
  {
    "codigo":39781000087105,
    "descripcion":"ABRASIÓN CUTÁNEA DE MITAD IZQUIERDA DE PARED TORÁCICA"
  },
  {
    "codigo":1345128003,
    "descripcion":"SUSTANCIA ASPIRADA EN TRACTO RESPIRATORIO"
  },
  {
    "codigo":34661000087107,
    "descripcion":"NOCARDIA AFRICANA O NOCARDIA NOVA"
  },
  {
    "codigo":42341000087107,
    "descripcion":"TRASTORNO DEGENERATIVO DE CARTÍLAGO ARTICULAR DE RODILLA IZQUIERDA"
  },
  {
    "codigo":722536004,
    "descripcion":"ENTERITIS TÓXICA DE INTESTINO DELGADO CAUSADA POR FÁRMACO"
  },
  {
    "codigo":11821291000119105,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN CARPOMETACARPIANA DE PULGAR IZQUIERDO"
  },
  {
    "codigo":296552004,
    "descripcion":"SOBREDOSIS DE FÁRMACO ANTIPALÚDICO"
  },
  {
    "codigo":196413005,
    "descripcion":"DIENTE CANINO PERMANENTE IMPACTADO"
  },
  {
    "codigo":294717007,
    "descripcion":"ALERGIA A INSULINA CINC"
  },
  {
    "codigo":129042000,
    "descripcion":"INDEPENDENCIA PARA VIAJAR"
  },
  {
    "codigo":1144850005,
    "descripcion":"ESCASO CRECIMIENTO DE PELO DE CUERO CABELLUDO"
  },
  {
    "codigo":291047003,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR TRIAZOLAM"
  },
  {
    "codigo":127207004,
    "descripcion":"LINFADENOPATÍA POPLÍTEA PROFUNDA"
  },
  {
    "codigo":94439007,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA EN HUESO NAVICULAR DE PIE"
  },
  {
    "codigo":192743008,
    "descripcion":"ABSCESO INTRACRANEAL EPIDURAL"
  },
  {
    "codigo":289212000,
    "descripcion":"PRIMERA ETAPA DEL TRABAJO DE PARTO NO ESTABLECIDA"
  },
  {
    "codigo":27068000,
    "descripcion":"INTENTO FALLIDO DE ABORTO CON AFIBRINOGENEMIA"
  },
  {
    "codigo":92604004,
    "descripcion":"CARCINOMA IN SITU DE LA CURVATURA MAYOR DEL ESTÓMAGO"
  },
  {
    "codigo":296391000000100,
    "descripcion":"NECESITA ASISTENCIA CON EL RASURADO"
  },
  {
    "codigo":254609000,
    "descripcion":"CARCINOMA DE LA AMPOLLA DE VATER"
  },
  {
    "codigo":1303185001,
    "descripcion":"LACERACIÓN DE PARED POSTERIOR DE TÓRAX"
  },
  {
    "codigo":1335953004,
    "descripcion":"PATRÓN DE USO NOCIVO DE HIPNÓTICO"
  },
  {
    "codigo":416614003,
    "descripcion":"ESPONJOSIDAD TISULAR"
  },
  {
    "codigo":711526005,
    "descripcion":"PENFIGOIDE LOCALIZADO CRÓNICO"
  },
  {
    "codigo":285542005,
    "descripcion":"CAPAZ DE MOVER EL PALADAR BLANDO"
  },
  {
    "codigo":1137510005,
    "descripcion":"DEBILIDAD PROGRESIVA DE MÚSCULO DISTAL"
  },
  {
    "codigo":447547000,
    "descripcion":"OLOR DE HERIDA NAUSEABUNDO"
  },
  {
    "codigo":449382009,
    "descripcion":"ANOMALÍA CONGÉNITA DE VALVA DE VÁLVULA AURICULOVENTRICULAR EN DEFECTO DEL TABIQUE INTERVENTRICULAR"
  },
  {
    "codigo":283707007,
    "descripcion":"MORDEDURA HUMANA EN LA PALMA DE LA MANO"
  },
  {
    "codigo":208947009,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE LA ARTICULACIÓN DE LA RODILLA, POSTERIOR"
  },
  {
    "codigo":249104003,
    "descripcion":"PRESENTACIÓN DORSOANTERIOR DE HOMBRO"
  },
  {
    "codigo":609552005,
    "descripcion":"REACCIÓN ALÉRGICA CAUSADA POR MEDIO DE RADIOCONTRASTE"
  },
  {
    "codigo":1363216005,
    "descripcion":"CICATRIZACIÓN DE PÁRPADO SUPERIOR"
  },
  {
    "codigo":707856007,
    "descripcion":"CON BAJO RIESGO DE ENFERMEDAD POR VIRUS ÉBOLA"
  },
  {
    "codigo":52496006,
    "descripcion":"TROMBOFLEBITIS DE LA VENA FEMOROPOPLÍTEA"
  },
  {
    "codigo":738789003,
    "descripcion":"METABOLIZADOR RÁPIDO DE LA FAMILIA 2 SUBFAMILIA C MIEMBRO 19 DEL CITOCROMO P450"
  },
  {
    "codigo":16028191000119108,
    "descripcion":"EXOSTOSIS BILATERAL DE MANOS"
  },
  {
    "codigo":704186006,
    "descripcion":"FRACTURA EXPUESTA DE FALANGE DISTAL DE PRIMER DEDO DEL PIE"
  },
  {
    "codigo":48826008,
    "descripcion":"TRASTORNO DE CONDUCTA, DE INICIO EN LA ADOLESCENCIA"
  },
  {
    "codigo":46991000,
    "descripcion":"DISTRAÍDO"
  },
  {
    "codigo":11823801000119104,
    "descripcion":"HERIDA DE HOMBRO DERECHO DEBIDA A PICADURA DE INSECTO NO VENENOSO"
  },
  {
    "codigo":702351004,
    "descripcion":"SÍNDROME DE SINOSTOSIS ESPONDILOCARPOTARSIANA"
  },
  {
    "codigo":14223005,
    "descripcion":"VÁRICES ESOFÁGICAS NO SANGRANTES"
  },
  {
    "codigo":1259407003,
    "descripcion":"CARCINOMA PRIMARIO DE ÁNGULO ESPLÉNICO DE COLON"
  },
  {
    "codigo":276367008,
    "descripcion":"EMBARAZO DESEADO"
  },
  {
    "codigo":438372000,
    "descripcion":"ENFERMEDAD POR DEFICIENCIA HEREDITARIA DE FACTOR IX CON INHIBIDORES"
  },
  {
    "codigo":208996004,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA DE DEDO DEL PIE, MÚLTIPLE"
  },
  {
    "codigo":733284005,
    "descripcion":"LESIÓN TRAUMÁTICA DE TENDÓN DEL CUÁDRICEPS"
  },
  {
    "codigo":405604008,
    "descripcion":"HERNIACIÓN DE MANGUITO DE DISPOSITIVO PARA LA VÍA AÉREA"
  },
  {
    "codigo":371001000,
    "descripcion":"PACIENTE CURADO"
  },
  {
    "codigo":76089002,
    "descripcion":"SIAMESES SIMÉTRICOS"
  },
  {
    "codigo":274532009,
    "descripcion":"HALLAZGOS ANORMALES EN IMÁGENES DIAGNÓSTICAS DE EXTREMIDADES"
  },
  {
    "codigo":305465003,
    "descripcion":"BAJO ATENCIÓN DE ESPECIALISTA EN CUIDADOS INTENSIVOS"
  },
  {
    "codigo":1255737000,
    "descripcion":"ENFERMEDAD DE HODGKIN DE CONGLOMERADO LINFOGANGLIONAR DE CABEZA, PREDOMINIO LINFOCÍTICO-HISTIOCÍTICO"
  },
  {
    "codigo":766052008,
    "descripcion":"SÍNDROME DE TRISOMÍA DISTAL 19Q"
  },
  {
    "codigo":403769007,
    "descripcion":"SÍNDROME CARDIO-ACRO-FACIAL"
  },
  {
    "codigo":698681008,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: SUDANÉS"
  },
  {
    "codigo":82771000119102,
    "descripcion":"HIPERTENSIÓN QUE COMPLICA EL EMBARAZO"
  },
  {
    "codigo":10553007,
    "descripcion":"INTOXICACIÓN POR VITAMINA D"
  },
  {
    "codigo":238094003,
    "descripcion":"HIPOBETALIPOPROTEINEMIA FAMILIAR - FORMA HETEROCIGOTA"
  },
  {
    "codigo":860686007,
    "descripcion":"EMBOLIA GRASA DEBIDA A EMBARAZO MOLAR Y POSTERIOR A ÉL"
  },
  {
    "codigo":41486008,
    "descripcion":"PÚRPURA ECCEMATOIDE DE DOUCAS Y KAPETANAKIS"
  },
  {
    "codigo":328531000119104,
    "descripcion":"INFECCIÓN DE TRACTO RESPIRATORIO SUPERIOR CAUSADA POR VIRUS INFLUENZA A"
  },
  {
    "codigo":301795004,
    "descripcion":"ATAQUE CIANÓTICO"
  },
  {
    "codigo":400099008,
    "descripcion":"HIDROADENOMA ECRINO DE PIEL"
  },
  {
    "codigo":365496001,
    "descripcion":"INICIATIVA - HALLAZGO"
  },
  {
    "codigo":398264003,
    "descripcion":"CONJUNTIVITIS HEMORRÁGICA AGUDA"
  },
  {
    "codigo":671421000124103,
    "descripcion":"INCAPAZ DE OBTENER TELÉFONO DEBIDO A RECURSOS ECONÓMICOS LIMITADOS"
  },
  {
    "codigo":234424007,
    "descripcion":"NEUTROPENIA METABÓLICA"
  },
  {
    "codigo":299960009,
    "descripcion":"PROBLEMA DEL SISTEMA NERVIOSO"
  },
  {
    "codigo":540861000124105,
    "descripcion":"MASA DE TOBILLO"
  },
  {
    "codigo":441021000124107,
    "descripcion":"INGESTA EXCESIVA DE BORO"
  },
  {
    "codigo":446141000124107,
    "descripcion":"SE IDENTIFICA COMO GÉNERO FEMENINO"
  },
  {
    "codigo":134285005,
    "descripcion":"LEE BENGALÍ"
  },
  {
    "codigo":298125006,
    "descripcion":"LESIÓN DE NERVIO CUTÁNEO INTERNO DEL ANTEBRAZO"
  },
  {
    "codigo":429197005,
    "descripcion":"LESIÓN TRAUMÁTICA DE CÚBITO"
  },
  {
    "codigo":1378000,
    "descripcion":"LESIÓN TRAUMÁTICA DE TOBILLO EN SUPINACIÓN-EVERSIÓN"
  },
  {
    "codigo":431032008,
    "descripcion":"SUBLUXACIÓN ROTATORIA DE ARTICULACIÓN DEL ESCAFOIDES DEL CARPO"
  },
  {
    "codigo":872012781000119103,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS IN SITU DE PIEL DE PIE DERECHO"
  },
  {
    "codigo":230754006,
    "descripcion":"HERNIA DEL UNCUS"
  },
  {
    "codigo":296290006,
    "descripcion":"SOBREDOSIS DE ESTIMULANTE DEL SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":196151000,
    "descripcion":"INSUFICIENCIA PULMONAR LUEGO DE UN SHOCK"
  },
  {
    "codigo":427362008,
    "descripcion":"DISPOSICIÓN PARA MEJORAR EL MANEJO DEL RÉGIMEN TERAPÉUTICO"
  },
  {
    "codigo":294455003,
    "descripcion":"ALERGIA A BEFENIO"
  },
  {
    "codigo":425527003,
    "descripcion":"ÉMBOLO ATEROMATOSO DE MIEMBRO INFERIOR"
  },
  {
    "codigo":32311009,
    "descripcion":"FRACTURA NO EXPUESTA DE BASE DE PULGAR"
  },
  {
    "codigo":718604008,
    "descripcion":"CARCINOMA NEUROENDOCRINO MICROCÍTICO DE VEJIGA"
  },
  {
    "codigo":126945001,
    "descripcion":"LESIÓN CEREBRAL SECUNDARIA A ANOXIA - ISQUEMIA EN EL PERÍODO PERINATAL"
  },
  {
    "codigo":290785004,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR LEVODOPA"
  },
  {
    "codigo":190646000,
    "descripcion":"OSTEOMALACIA DEL ADULTO POR DESNUTRICIÓN"
  },
  {
    "codigo":389089009,
    "descripcion":"ANOXIA CEREBRAL"
  },
  {
    "codigo":92342001,
    "descripcion":"NEOPLASIA BENIGNA DE HOMBRO"
  },
  {
    "codigo":288950005,
    "descripcion":"NO TRAGA LÍQUIDOS"
  },
  {
    "codigo":287115001,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN LA MANO"
  },
  {
    "codigo":385419004,
    "descripcion":"INVASIÓN TUMORAL VENOSA (GRANDES VASOS)\/ LINFÁTICA (PEQUEÑOS VASOS) - HALLAZGO"
  },
  {
    "codigo":90507008,
    "descripcion":"TRASTORNO VENOSO"
  },
  {
    "codigo":170547009,
    "descripcion":"REQUIERE UNA DOSIS DE VACUNA CONTRA EL CÓLERA"
  },
  {
    "codigo":449120006,
    "descripcion":"OBSTRUCCIÓN DEL TRACTO DE SALIDA PULMONAR"
  },
  {
    "codigo":1268320008,
    "descripcion":"HIPERTROFIA DE PIERNA"
  },
  {
    "codigo":54069001,
    "descripcion":"PLACAS MUCOSAS SIFILÍTICAS CONGÉNITAS"
  },
  {
    "codigo":416352009,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA, ARTICULACIÓN INTERFALÁNGICA DISTAL DE DEDO DE LA MANO"
  },
  {
    "codigo":1332021003,
    "descripcion":"OSTEÓLISIS DE EXTREMO ACROMIAL DE CLAVÍCULA"
  },
  {
    "codigo":15732001000119101,
    "descripcion":"AGRANDAMIENTO DE GLÁNDULA LAGRIMAL DERECHA"
  },
  {
    "codigo":840501003,
    "descripcion":"DISTONÍA TÓXICA"
  },
  {
    "codigo":447285001,
    "descripcion":"DESEQUILIBRIO VENTRICULAR"
  },
  {
    "codigo":281610001,
    "descripcion":"HIPERBILIRRUBINEMIA NEONATAL"
  },
  {
    "codigo":707594002,
    "descripcion":"NEOPLASIA NEUROENDOCRINA DE PULMÓN"
  },
  {
    "codigo":19466003,
    "descripcion":"NEUROTOXICIDAD"
  },
  {
    "codigo":248842004,
    "descripcion":"HALLAZGO DE LOS GENITALES FEMENINOS"
  },
  {
    "codigo":1197279000,
    "descripcion":"NEOPLASIA MALIGNA SÓLIDA PRIMARIA PSEUDOPAPILAR DE PÁNCREAS"
  },
  {
    "codigo":738527001,
    "descripcion":"NEOPLASIA MIELOIDE Y\/O LINFOIDE ASOCIADA CON REORDENAMIENTO DE RECEPTOR ALFA DE FACTOR DE CRECIMIENTO DERIVADO DE LAS PLAQUETAS"
  },
  {
    "codigo":736692000,
    "descripcion":"HELICOBACTER PYLORI NO DETECTADO EN MATERIA FECAL"
  },
  {
    "codigo":15796001,
    "descripcion":"PROGNATISMO MAXILAR"
  },
  {
    "codigo":308873002,
    "descripcion":"DISPLASIA GRAVE DE COLON"
  },
  {
    "codigo":865929003,
    "descripcion":"INFECCIÓN CAUSADA POR CANDIDA AURIS"
  },
  {
    "codigo":210569003,
    "descripcion":"SECCIÓN PARCIAL DEL TENDÓN DEL EXTENSOR DE LA MANO"
  },
  {
    "codigo":734857007,
    "descripcion":"LESIÓN TRAUMÁTICA DE ÓRGANO GENITAL FEMENINO DEBIDA A PROCEDIMIENTO OBSTÉTRICO"
  },
  {
    "codigo":276105007,
    "descripcion":"POSEE UN AMANTE"
  },
  {
    "codigo":1290078002,
    "descripcion":"INSUFICIENCIA DE VÁLVULA TRICUSPÍDEA DEBIDA A TUMOR NEUROENDOCRINO"
  },
  {
    "codigo":896862005,
    "descripcion":"FORMA ANCHA ANORMAL CONGÉNITA DE FALANGE MEDIA DE CUARTO DEDO DE PIE"
  },
  {
    "codigo":11773371000119103,
    "descripcion":"ABRASIÓN DE PIEL DE PULGAR DERECHO"
  },
  {
    "codigo":1157171003,
    "descripcion":"NO UTILIZA NEGACIÓN COMO MECANISMO DE DEFENSA"
  },
  {
    "codigo":16836351000119100,
    "descripcion":"EMBARAZO ECTÓPICO DE OVARIO DERECHO"
  },
  {
    "codigo":10625791000119101,
    "descripcion":"BRONQUITIS CAUSADA POR SUSTANCIA QUÍMICA"
  },
  {
    "codigo":119551000119102,
    "descripcion":"MARCAPASOS CARDÍACO PERMANENTE"
  },
  {
    "codigo":145151000119103,
    "descripcion":"ENCOPRESIS ORGÁNICA SECUNDARIA"
  },
  {
    "codigo":16004351000119104,
    "descripcion":"TENOSINOVITIS DE APÓFISIS ESTILOIDES DE RADIO IZQUIERDA"
  },
  {
    "codigo":16045311000119105,
    "descripcion":"ALTERACIÓN DE ALINEACIÓN DE ARTICULACIÓN DE PIE IZQUIERDO"
  },
  {
    "codigo":10738431000119106,
    "descripcion":"QUISTE EPIDERMOIDE DE PIEL DE MAMA DERECHA"
  },
  {
    "codigo":137471000119107,
    "descripcion":"DERIVACIÓN VENTRICULAR CON VÁLVULA PROGRAMABLE IN SITU"
  },
  {
    "codigo":101631000119108,
    "descripcion":"NEUROMA TRAUMÁTICO DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":1089791000119107,
    "descripcion":"MENINGITIS DEBIDA A MONONUCLEOSIS INFECCIOSA"
  },
  {
    "codigo":10633471000119107,
    "descripcion":"CELULITIS DE MUÑECA DERECHA"
  },
  {
    "codigo":129791000119108,
    "descripcion":"NEOPLASIA POSTERIOR A TRASPLANTE DE HÍGADO"
  },
  {
    "codigo":16636671000119108,
    "descripcion":"LESIÓN BILATERAL DE NERVIOS MEDIANOS"
  },
  {
    "codigo":10682111000119106,
    "descripcion":"TUMORACIÓN DE LA PIEL DE EXTREMIDAD SUPERIOR IZQUIERDA"
  },
  {
    "codigo":1351944006,
    "descripcion":"ENFERMEDAD POR DEPÓSITO DE HIDROXIAPATITA DE MANO"
  },
  {
    "codigo":29951000119107,
    "descripcion":"HEMIPARESIA ATÁXICA"
  },
  {
    "codigo":1074431000119108,
    "descripcion":"ARTROSIS DE ARTICULACIÓN ACROMIOCLAVICULAR IZQUIERDA"
  },
  {
    "codigo":12205311000119109,
    "descripcion":"INFECCIÓN DE FÉMUR DERECHO ASOCIADA CON DISPOSITIVO DE FIJACIÓN INTERNA"
  },
  {
    "codigo":235997006,
    "descripcion":"ABSCESO NO TUBERCULOSO DE MÚSCULO PSOAS ILÍACO"
  },
  {
    "codigo":170461002,
    "descripcion":"REQUIERE UNA DOSIS DE GAMMAGLOBULINA"
  },
  {
    "codigo":205064009,
    "descripcion":"LUXACIÓN CONGÉNITA DE RODILLA, GRADO I"
  },
  {
    "codigo":203229009,
    "descripcion":"INFECCIÓN DE FALANGE DE DEDO DE LA MANO O PULGAR"
  },
  {
    "codigo":168626004,
    "descripcion":"RADIOGRAFÍA SIMPLE DE RADIO: NORMAL"
  },
  {
    "codigo":365234004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA MANEJAR PRÓTESIS"
  },
  {
    "codigo":823986007,
    "descripcion":"NERVIO TRIGÉMINO INTACTO"
  },
  {
    "codigo":299698007,
    "descripcion":"ALIMENTACIÓN ESCASA"
  },
  {
    "codigo":1348274009,
    "descripcion":"ENFERMEDAD POR DEPÓSITO DE HIDROXIAPATITA"
  },
  {
    "codigo":166791001,
    "descripcion":"PROTEÍNAS EN PLASMA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":35719004,
    "descripcion":"MIOCARDIOPATÍA DILATADA DEBIDA A ESCLEROSIS SISTÉMICA"
  },
  {
    "codigo":723847006,
    "descripcion":"CONDROSARCOMA PRIMARIO DE CARTÍLAGO ARTICULAR DE COSTILLA"
  },
  {
    "codigo":363399006,
    "descripcion":"NEOPLASIA MALIGNA DE HIPOFARINGE"
  },
  {
    "codigo":1116000,
    "descripcion":"HEPATITIS VIRAL TIPO B CRÓNICA AGRESIVA"
  },
  {
    "codigo":263260001,
    "descripcion":"SECCIÓN TRAUMÁTICA DE CARTÍLAGO COSTAL"
  },
  {
    "codigo":2951009,
    "descripcion":"CATARATA ATÓPICA"
  },
  {
    "codigo":296028002,
    "descripcion":"SOBREDOSIS DE METIPRILÓN"
  },
  {
    "codigo":164956004,
    "descripcion":"ELECTROCARDIOGRAMA: INTERVALO Q-T ANORMAL"
  },
  {
    "codigo":230492006,
    "descripcion":"SOMNOLENCIA DIURNA EXCESIVA CON PARÁLISIS DEL SUEÑO"
  },
  {
    "codigo":195889001,
    "descripcion":"NEUMONÍA DE LOS LEGIONARIOS"
  },
  {
    "codigo":425265006,
    "descripcion":"HERIDA POR CUCHILLO"
  },
  {
    "codigo":128518001,
    "descripcion":"PRESENCIA DE CUERPO EXTRAÑO EN LAS VÍAS RESPIRATORIAS SUPERIORES"
  },
  {
    "codigo":1144326001,
    "descripcion":"ATROFIA DIFUSA DE PIEL"
  },
  {
    "codigo":292358001,
    "descripcion":"REACCIÓN ADVERSA AL PRAZEPAM"
  },
  {
    "codigo":95750004,
    "descripcion":"BLEFARITIS AGUDA"
  },
  {
    "codigo":423430005,
    "descripcion":"CURVATURA ESPINAL CON CONVEXIDAD HACIA LA IZQUIERDA"
  },
  {
    "codigo":718342006,
    "descripcion":"DESGARRO DE TENDÓN DISTAL DE BÍCEPS BRAQUIAL"
  },
  {
    "codigo":224987000,
    "descripcion":"REGRESIÓN A TRAVÉS DE LA ACTUACIÓN"
  },
  {
    "codigo":1306331001,
    "descripcion":"GLAUCOMA DE ÁNGULO CERRADO SECUNDARIO DE OJO DERECHO"
  },
  {
    "codigo":126683002,
    "descripcion":"NEOPLASIA DE LA PARED LATERAL DE LA NASOFARINGE"
  },
  {
    "codigo":333551000119104,
    "descripcion":"DRUSAS DE PAPILA ÓPTICA DERECHA"
  },
  {
    "codigo":716507003,
    "descripcion":"NO UTILIZA PALABRAS MULTISILÁBICAS"
  },
  {
    "codigo":257755002,
    "descripcion":"ANGULACIÓN EN VALGO"
  },
  {
    "codigo":93915004,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL MIOMETRIO"
  },
  {
    "codigo":26544005,
    "descripcion":"DEBILIDAD MUSCULAR"
  },
  {
    "codigo":92080005,
    "descripcion":"NEOPLASIA BENIGNA DE DUODENO"
  },
  {
    "codigo":419760006,
    "descripcion":"VAGINOSIS BACTERIANA"
  },
  {
    "codigo":254085009,
    "descripcion":"ANADISPLASIA METAFISARIA"
  },
  {
    "codigo":285018002,
    "descripcion":"NO MANEJA UN ARTEFACTO MIENTRAS SE VISTE Y DESVISTE"
  },
  {
    "codigo":10956681000119103,
    "descripcion":"HERIDA ABIERTA DE DEDO DE MANO DERECHA"
  },
  {
    "codigo":874842006,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE CARA"
  },
  {
    "codigo":283183001,
    "descripcion":"CUERPO EXTRAÑO METÁLICO EN EL PIE"
  },
  {
    "codigo":414255006,
    "descripcion":"HALLAZGO RELACIONADO CON LA MEDICIÓN DE PARAPROTEÍNAS"
  },
  {
    "codigo":707332000,
    "descripcion":"GLOMERULONEFRITIS PROLIFERATIVA RECURRENTE"
  },
  {
    "codigo":314116003,
    "descripcion":"ANGINA POSINFARTO"
  },
  {
    "codigo":1264388005,
    "descripcion":"LACERACIÓN DE TENDÓN DE ESPALDA"
  },
  {
    "codigo":248580006,
    "descripcion":"SILBIDO NASAL"
  },
  {
    "codigo":443353000,
    "descripcion":"COMPRESIÓN DE NERVIO GENITOCRURAL"
  },
  {
    "codigo":445188009,
    "descripcion":"INESTABILIDAD DE ARTICULACIÓN DE MANO"
  },
  {
    "codigo":17369002,
    "descripcion":"ABORTO ESPONTÁNEO"
  },
  {
    "codigo":15708041000119108,
    "descripcion":"DISECCIÓN DE ARTERIA CARÓTIDA DERECHA"
  },
  {
    "codigo":408750000,
    "descripcion":"SÍNDROME DE DOLOR REGIONAL COMPLEJO, TIPO II, MIEMBRO SUPERIOR"
  },
  {
    "codigo":212142000,
    "descripcion":"LESIÓN DE LA CORTEZA VISUAL"
  },
  {
    "codigo":277678003,
    "descripcion":"ABSCESO DE FONDO DE SACO VESICORRECTAL"
  },
  {
    "codigo":1258883002,
    "descripcion":"TROMBOEMBOLISMO VENOSO POSQUIRÚRGICO"
  },
  {
    "codigo":110168002,
    "descripcion":"ABRASIÓN DE MENTÓN"
  },
  {
    "codigo":208472004,
    "descripcion":"FRACTURA EXPUESTA DE FALANGE DISTAL DE PULGAR"
  },
  {
    "codigo":306776007,
    "descripcion":"DEGLUTE ALIMENTOS BLANDOS"
  },
  {
    "codigo":370477004,
    "descripcion":"RUPTURA AURICULAR"
  },
  {
    "codigo":336061000119102,
    "descripcion":"HEMORRAGIA DE COROIDES DE OJO DERECHO"
  },
  {
    "codigo":403245009,
    "descripcion":"CABELLO ROJO NATURAL"
  },
  {
    "codigo":73730005,
    "descripcion":"FIEBRE HEMORRÁGICA ARENAVIRÓSICA"
  },
  {
    "codigo":237570007,
    "descripcion":"BOCIO MULTINODULAR"
  },
  {
    "codigo":301271000,
    "descripcion":"MATIDEZ DIAFRAGMÁTICA A LA PERCUSIÓN, NORMAL"
  },
  {
    "codigo":39127005,
    "descripcion":"NEUROPATÍA SIMÉTRICA MOTORA PROXIMAL DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":202967007,
    "descripcion":"RUPTURA DE LA CABEZA LARGA DEL MÚSCULO BÍCEPS"
  },
  {
    "codigo":1216940001,
    "descripcion":"SÍNDROME DE PIERRE ROBIN, CONTRACTURAS ARTICULARES Y RETRASO DEL DESARROLLO"
  },
  {
    "codigo":235735009,
    "descripcion":"FÍSTULA INTERNA DEL INTESTINO DELGADO"
  },
  {
    "codigo":233900001,
    "descripcion":"TAQUICARDIA SUPRAVENTRICULAR CON BLOQUEO FUNCIONAL DE RAMA"
  },
  {
    "codigo":364972005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA REALIZAR FUNCIONES CON LAS MANOS"
  },
  {
    "codigo":1056501000112102,
    "descripcion":"CÁLCULO RENAL RECURRENTE"
  },
  {
    "codigo":309591000119100,
    "descripcion":"NECROSIS AVASCULAR DE CÚBITO IZQUIERDO"
  },
  {
    "codigo":201132008,
    "descripcion":"ALOPECIA FRONTAL FEMENINA"
  },
  {
    "codigo":363137000,
    "descripcion":"TRASTORNO HEREDITARIO POR SISTEMA ORGÁNICO"
  },
  {
    "codigo":232065000,
    "descripcion":"SÍNDROME DE GOLDMANN-FAVRE"
  },
  {
    "codigo":789121002,
    "descripcion":"SÍFILIS TARDÍA DE MEMBRANA MUCOSA"
  },
  {
    "codigo":725420009,
    "descripcion":"DISTROFIA MUSCULAR CONGÉNITA TIPO PARADAS"
  },
  {
    "codigo":2689001,
    "descripcion":"EPIDERMÓLISIS BULLOSA DISTRÓFICA DOMINANTE CON AUSENCIA DE PIEL"
  },
  {
    "codigo":199297006,
    "descripcion":"ENFERMEDADES DEL SISTEMA NERVIOSO CENTRAL QUE COMPLICAN EL EMBARAZO, EL PARTO Y EL PUERPERIO"
  },
  {
    "codigo":68225006,
    "descripcion":"ALOPECIA CIRCUNSCRIPTA"
  },
  {
    "codigo":295766000,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE FLUDARABINA"
  },
  {
    "codigo":1073341000119108,
    "descripcion":"ARTRITIS DE TOBILLO DERECHO CAUSADA POR BACTERIAS"
  },
  {
    "codigo":230230002,
    "descripcion":"ATAXIA CEREBELOSA DE INICIO TEMPRANO CON RETINITIS PIGMENTARIA Y ATROFIA ÓPTICA"
  },
  {
    "codigo":228395002,
    "descripcion":"COMPARTE EL EQUIPO PARA INYECTAR DROGA"
  },
  {
    "codigo":128256001,
    "descripcion":"HALLAZGO RESPIRATORIO DURANTE LA PALPACIÓN DE LA PARED TORÁCICA"
  },
  {
    "codigo":718080002,
    "descripcion":"EXCESO DE ENCÍA"
  },
  {
    "codigo":95488001,
    "descripcion":"DISTROFIA CORNEAL MACULAR CONGÉNITA"
  },
  {
    "codigo":423168004,
    "descripcion":"PARO CARDÍACO POR TRASTORNO RESPIRATORIO"
  },
  {
    "codigo":783616005,
    "descripcion":"LIPODISTROFIA PARCIAL FAMILIAR RELACIONADA CON PERILIPINA 1"
  },
  {
    "codigo":292096006,
    "descripcion":"REACCIÓN ADVERSA DE MEDIOS DE CONTRASTE RADIOGRÁFICO"
  },
  {
    "codigo":191957001,
    "descripcion":"BOSTEZO PSICÓGENO"
  },
  {
    "codigo":880085002,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO Y TENDÓN DE PIERNA"
  },
  {
    "codigo":716245003,
    "descripcion":"SÍNDROME CRANEOFACIAL CON SORDERA"
  },
  {
    "codigo":93653006,
    "descripcion":"MELANOMA MALIGNO DE LA PIEL DE LAS EXTREMIDADES SUPERIORES"
  },
  {
    "codigo":288426001,
    "descripcion":"CORTA CON TIJERA"
  },
  {
    "codigo":419498005,
    "descripcion":"LEIOMIOMA INTRAOCULAR"
  },
  {
    "codigo":11997681000119103,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DE MUSLO DERECHO"
  },
  {
    "codigo":59050008,
    "descripcion":"INSOMNIO DE CONCILIACIÓN"
  },
  {
    "codigo":188287005,
    "descripcion":"NEOPLASIA MALIGNA DEL TÁLAMO"
  },
  {
    "codigo":417663005,
    "descripcion":"ASIMETRÍA DE CARILLA VERTEBRAL"
  },
  {
    "codigo":253823009,
    "descripcion":"QUISTE EMBRIONARIO DE OVARIO"
  },
  {
    "codigo":284756003,
    "descripcion":"GOLPEARSE INTENCIONALMENTE"
  },
  {
    "codigo":251988007,
    "descripcion":"LLENADO LENTO DE VEJIGA URINARIA"
  },
  {
    "codigo":250153001,
    "descripcion":"SUELA DEL CALZADO MUY FLEXIBLE"
  },
  {
    "codigo":282921005,
    "descripcion":"SE SIENTA DESDE EL DECÚBITO DORSAL"
  },
  {
    "codigo":1264126002,
    "descripcion":"ABSCESO POSOPERATORIO DE PELVIS FEMENINA"
  },
  {
    "codigo":444926003,
    "descripcion":"GASTRITIS EROSIVA AGUDA"
  },
  {
    "codigo":215550005,
    "descripcion":"LESIÓN PRODUCIDA POR ACCIDENTE DE EMBARCACIÓN CON COLISIÓN"
  },
  {
    "codigo":248318007,
    "descripcion":"PÉRDIDA DE GRASA CORPORAL, DISTRIBUIDA EN FORMA PAREJA"
  },
  {
    "codigo":1231358009,
    "descripcion":"HUEVO DE CLONORCHIS SINENSIS O HUEVO DE ESPECIE HETEROPHYES O HUEVO DE MATAGONIMUS YOKOGAWAI O HUEVO DE ESPECIE OPISTHORCHIS"
  },
  {
    "codigo":338571000119104,
    "descripcion":"CICATRIZ CORIORRETINIANA POSINFLAMATORIA DE OJO IZQUIERDO"
  },
  {
    "codigo":836307007,
    "descripcion":"AGUDEZA VISUAL DE OJO DERECHO 6\/24"
  },
  {
    "codigo":441256000,
    "descripcion":"BOCAVIRUS HUMANO PRESENTE"
  },
  {
    "codigo":373885002,
    "descripcion":"CÉLULAS ENDOMETRIALES EN MUJER DE 40 AÑOS O MÁS, NEGATIVAS PARA LESIÓN INTRAEPITELIAL ESCAMOSA"
  },
  {
    "codigo":78973009,
    "descripcion":"LINFANGITIS CRÓNICA"
  },
  {
    "codigo":1254951000,
    "descripcion":"EDEMA DEBIDO A OBSTRUCCIÓN DE RETORNO VENOSO"
  },
  {
    "codigo":77138008,
    "descripcion":"PLEURITIS FIBRINOSA"
  },
  {
    "codigo":402983005,
    "descripcion":"INFECCIÓN CUTÁNEA POR MYCOBACTERIUM MALMOENSE"
  },
  {
    "codigo":40700009,
    "descripcion":"RETRASO MENTAL SEVERO"
  },
  {
    "codigo":301009006,
    "descripcion":"PANCREATITIS CRÓNICA CALCIFICANTE"
  },
  {
    "codigo":169937006,
    "descripcion":"PROBLEMAS DE VÍNCULO"
  },
  {
    "codigo":432081008,
    "descripcion":"MASA DEL MÚSCULO PSOAS"
  },
  {
    "codigo":366545009,
    "descripcion":"HALLAZGO RELACIONADO CON EL TAMAÑO DE LA MANO"
  },
  {
    "codigo":4262001,
    "descripcion":"FLEBITIS DE SENO SAGITAL SUPERIOR"
  },
  {
    "codigo":299174001,
    "descripcion":"AMPLITUD DE ADUCCIÓN ACTIVA DEL PULGAR NORMAL"
  },
  {
    "codigo":233638004,
    "descripcion":"PLEURESÍA SIN DERRAME"
  },
  {
    "codigo":11836351000119103,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN DE PIE IZQUIERDO"
  },
  {
    "codigo":102566006,
    "descripcion":"EDEMA DE DEDO PULGAR"
  },
  {
    "codigo":69798007,
    "descripcion":"OBSTRUCCIÓN DE ARTERIA CARÓTIDA"
  },
  {
    "codigo":35195001,
    "descripcion":"CONGELAMIENTO DEL PIE"
  },
  {
    "codigo":231803006,
    "descripcion":"DERMATITIS VIRAL DE PÁRPADO"
  },
  {
    "codigo":264571006,
    "descripcion":"TRABÉCULAS SEPTOPARIETALES"
  },
  {
    "codigo":295504002,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE ETOMIDATO"
  },
  {
    "codigo":262736005,
    "descripcion":"CONTUSIÓN DE LA RAÍZ DE NERVIO LUMBAR"
  },
  {
    "codigo":721488006,
    "descripcion":"SÍNDROME DE BROWN-SEQUARD AL NIVEL DEL SÉPTIMO SEGMENTO DORSAL"
  },
  {
    "codigo":197200005,
    "descripcion":"ADHERENCIAS PÉLVICAS MASCULINAS"
  },
  {
    "codigo":129829001,
    "descripcion":"MANEJO INEFICAZ DEL RÉGIMEN TERAPÉUTICO DE UNA COMUNIDAD"
  },
  {
    "codigo":293669002,
    "descripcion":"ALERGIA A CAOLÍN"
  },
  {
    "codigo":228133003,
    "descripcion":"ACCESO AL NIÑO, REVOCADO"
  },
  {
    "codigo":16669631000119108,
    "descripcion":"FRACTURA NO EXPUESTA DE APÓFISIS CONDÍLEA IZQUIERDA DE MANDÍBULA"
  },
  {
    "codigo":816122000,
    "descripcion":"COLOR DE PIE NORMAL"
  },
  {
    "codigo":717818001,
    "descripcion":"MASTITIS NO PURULENTA ASOCIADA CON DIFICULTAD EN EL APEGO EN EL NACIMIENTO"
  },
  {
    "codigo":95226002,
    "descripcion":"RETICULOSARCOMA DE LOS GANGLIOS LINFÁTICOS INTRATORÁCICOS"
  },
  {
    "codigo":1078266003,
    "descripcion":"AGENESIA DE EPÍFISIS DE FALANGE PROXIMAL DE SEGUNDO DEDO DE PIE"
  },
  {
    "codigo":15742041000119103,
    "descripcion":"DEFORMIDAD EN VARO ADQUIRIDA DE AMBOS TOBILLOS"
  },
  {
    "codigo":1078361000119103,
    "descripcion":"RODILLA VARA CONGÉNITA IZQUIERDA"
  },
  {
    "codigo":62458008,
    "descripcion":"TIENE CREENCIA RELIGIOSA"
  },
  {
    "codigo":715983001,
    "descripcion":"SÍNDROME DE CROMOSOMA 8 EN ANILLO"
  },
  {
    "codigo":93391003,
    "descripcion":"PROTRUSIÓN CONGÉNITA DE LA LENGUA"
  },
  {
    "codigo":289999003,
    "descripcion":"VESÍCULA BILIAR HIPOFUNCIONAL"
  },
  {
    "codigo":124324001,
    "descripcion":"DEFICIENCIA DE COLINA CINASA"
  },
  {
    "codigo":1172900005,
    "descripcion":"SÍNDROME DE MICROCEFALIA PROGRESIVA, CRISIS CONVULSIVAS, CEGUERA CORTICAL Y RETRASO DEL DESARROLLO"
  },
  {
    "codigo":714148005,
    "descripcion":"ENFERMEDAD GINGIVAL ALÉRGICA CAUSADA POR CONTACTO CON NÍQUEL"
  },
  {
    "codigo":1269369001,
    "descripcion":"CRISIS EPILÉPTICA MIOCLÓNICA CON CONCIENCIA PRESERVADA DE INICIO FOCAL"
  },
  {
    "codigo":251726002,
    "descripcion":"ÁNGULO CERRADO"
  },
  {
    "codigo":22350004,
    "descripcion":"HIPERTIROIDISMO T>3<"
  },
  {
    "codigo":284494004,
    "descripcion":"CONDUCTA IGNORADA"
  },
  {
    "codigo":249891000,
    "descripcion":"FUNCIONES DEL COMPLEJO NEUROMUSCULAR"
  },
  {
    "codigo":282659000,
    "descripcion":"INCAPAZ DE GOLPEAR"
  },
  {
    "codigo":1003555002,
    "descripcion":"AGENESIA DE TRÁQUEA"
  },
  {
    "codigo":315427001,
    "descripcion":"NACIDO EN FRANCIA"
  },
  {
    "codigo":248056001,
    "descripcion":"DESCUIDO DE LA HIGIENE PERSONAL"
  },
  {
    "codigo":51448009,
    "descripcion":"TRASTORNO DE LA SECRECIÓN PLAQUETARIA"
  },
  {
    "codigo":410061008,
    "descripcion":"INTOXICACIÓN INTENCIONAL"
  },
  {
    "codigo":735906001,
    "descripcion":"EFECTOS DE LA PRESIÓN DE AGUA"
  },
  {
    "codigo":1260194003,
    "descripcion":"SÍNDROME NEFRÓTICO IDIOPÁTICO CORTICORRESISTENTE"
  },
  {
    "codigo":703138006,
    "descripcion":"DIABETES MELLITUS TIPO II EN REMISIÓN"
  },
  {
    "codigo":209783002,
    "descripcion":"RUPTURA DE TENDÓN PLANTAR"
  },
  {
    "codigo":111479008,
    "descripcion":"TRASTORNO MENTAL ORGÁNICO"
  },
  {
    "codigo":373623009,
    "descripcion":"OSTEOARTROSIS DE ARTICULACIÓN GLENOHUMERAL"
  },
  {
    "codigo":42273000,
    "descripcion":"PIEL GRASOSA"
  },
  {
    "codigo":240716009,
    "descripcion":"CANDIDIASIS MUCOCUTÁNEA CRÓNICA FAMILIAR - TIPO RECESIVO"
  },
  {
    "codigo":9505000,
    "descripcion":"INFESTACIÓN CAUSADA POR PNEUMONYSSUS SIMICOLA"
  },
  {
    "codigo":402721001,
    "descripcion":"MUCINOSIS QUE AFECTA LA PIEL"
  },
  {
    "codigo":109644008,
    "descripcion":"SUPRAOCLUSIÓN DENTAL"
  },
  {
    "codigo":238881001,
    "descripcion":"PANICULITIS LIPOATRÓFICA"
  },
  {
    "codigo":1156385007,
    "descripcion":"MANCHAS DE WISCHNEWSKI"
  },
  {
    "codigo":237046000,
    "descripcion":"ABSCESO TUBOVÁRICO GONOCÓCICO"
  },
  {
    "codigo":11838861000119108,
    "descripcion":"DISTENSIÓN DE MÚSCULO INTRÍNSECO DEL PULGAR IZQUIERDO"
  },
  {
    "codigo":1254689008,
    "descripcion":"METÁSTASIS DE CARCINOMA ADENOIDE QUÍSTICO EN CUELLO DE ÚTERO"
  },
  {
    "codigo":1285622004,
    "descripcion":"HEMATOMA DE SEGUNDO DEDO DE PIE"
  },
  {
    "codigo":105974005,
    "descripcion":"TRASTORNO DE SENO ETMOIDAL"
  },
  {
    "codigo":300747000,
    "descripcion":"NO USA INSTALACIONES RECREATIVAS PÚBLICAS"
  },
  {
    "codigo":38603001,
    "descripcion":"VOCALIZACIÓN INVOLUNTARIA"
  },
  {
    "codigo":16947009,
    "descripcion":"ENVENENAMIENTO CAUSADO POR ORUGA DE PELUCHE"
  },
  {
    "codigo":366283009,
    "descripcion":"HALLAZGO RELACIONADO CON EL TAMAÑO DEL ESCROTO"
  },
  {
    "codigo":167840003,
    "descripcion":"VÓMITO: OLOR NORMAL"
  },
  {
    "codigo":200608005,
    "descripcion":"FORÚNCULO DEL DORSO"
  },
  {
    "codigo":724896006,
    "descripcion":"LACERACIÓN DE MÚSCULO ABDOMINAL"
  },
  {
    "codigo":397216005,
    "descripcion":"GLÁNDULAS BENIGNAS EN EL MARGEN DE RESECCIÓN QUIRÚRGICA"
  },
  {
    "codigo":297077000,
    "descripcion":"SOBREDOSIS INTENCIONAL DE DIAZÓXIDO"
  },
  {
    "codigo":1080871000119107,
    "descripcion":"HISTIOCITOMA FIBROSO MALIGNO PRIMARIO DE PARTES BLANDAS DE HOMBRO DERECHO"
  },
  {
    "codigo":231541007,
    "descripcion":"TRASTORNO DE LA CONDUCTA - NO SOCIALIZADO"
  },
  {
    "codigo":317121000119102,
    "descripcion":"REUMATISMO PALINDRÓMICO DE ARTICULACIÓN DE HOMBRO DERECHO"
  },
  {
    "codigo":229706001,
    "descripcion":"APRAXIA CLÁSICA"
  },
  {
    "codigo":10966721000119102,
    "descripcion":"HERIDA ABIERTA DE PIERNA DERECHA DEBIDA A MORDEDURA HUMANA"
  },
  {
    "codigo":12113601000119103,
    "descripcion":"QUEMADURA QUÍMICA DE PARED TORÁCICA"
  },
  {
    "codigo":721226005,
    "descripcion":"SÍNDROME DE HUGHES STOVIN"
  },
  {
    "codigo":330007,
    "descripcion":"CEFALEA OCCIPITAL"
  },
  {
    "codigo":195103000,
    "descripcion":"PULSO BIGEMINAL"
  },
  {
    "codigo":295242007,
    "descripcion":"SOBREDOSIS DE FENOPROFENO"
  },
  {
    "codigo":129567005,
    "descripcion":"PARESIA FARÍNGEA"
  },
  {
    "codigo":719391005,
    "descripcion":"CAPAZ DE COMPRENDER INSTRUCCIONES DE TRES PALABRAS"
  },
  {
    "codigo":1145375007,
    "descripcion":"HIPOPLASIA CONGÉNITA DE MÚSCULO DE BRAZO"
  },
  {
    "codigo":162335008,
    "descripcion":"SÍNTOMAS NEUROLÓGICOS TRANSITORIOS"
  },
  {
    "codigo":64031009,
    "descripcion":"CONDUCTA MASOQUISTA"
  },
  {
    "codigo":293407009,
    "descripcion":"REACCIÓN ADVERSA AL POLIESTIRENO SULFONATO CÁLCICO"
  },
  {
    "codigo":160500004,
    "descripcion":"TIENE MADRASTRA"
  },
  {
    "codigo":783092005,
    "descripcion":"INSUFICIENCIA SUPRARRENAL Y TRASTORNO DEL DESARROLLO SEXUAL 46,XY DEBIDO A DEFICIENCIA DEL MIEMBRO 1 SUBFAMILIA A FAMILIA 11 DE CITOCROMO P450"
  },
  {
    "codigo":291572008,
    "descripcion":"INTOXICACIÓN POR CEFRADINA"
  },
  {
    "codigo":11785921000119107,
    "descripcion":"HERIDA DE MUÑECA DERECHA DEBIDA A PICADURA DE INSECTO NO VENENOSO"
  },
  {
    "codigo":93129004,
    "descripcion":"INFLAMACIÓN DE CANALÍCULO LAGRIMAL"
  },
  {
    "codigo":224201005,
    "descripcion":"MANEJA SUS PROPIOS ASUNTOS FINANCIEROS"
  },
  {
    "codigo":715721005,
    "descripcion":"BRAQUIDACTILIA TIPO A4"
  },
  {
    "codigo":289737006,
    "descripcion":"HALLAZGO RELACIONADO CON MEDICIONES DE LAS CONTRACCIONES UTERINAS"
  },
  {
    "codigo":1010633008,
    "descripcion":"ADENOCARCINOMA PAPILAR PRIMARIO DE NASOFARINGE"
  },
  {
    "codigo":713886006,
    "descripcion":"NEFROPATÍA CAUSADA POR POLIOMAVIRUS BK"
  },
  {
    "codigo":1172638007,
    "descripcion":"MASTITIS NEONATAL POR STAPHYLOCOCCUS AUREUS"
  },
  {
    "codigo":124062006,
    "descripcion":"CISTINA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":56691005,
    "descripcion":"INFECCIÓN CAUSADA POR APOPHALLUS"
  },
  {
    "codigo":89459006,
    "descripcion":"PERSISTENCIA HEREDITARIA DE HEMOGLOBINA FETAL VINCULADA AL GRUPO DE GENES DE GLOBULINA BETA"
  },
  {
    "codigo":286067005,
    "descripcion":"INCAPAZ DE DOBLAR LA ROPA LAVADA"
  },
  {
    "codigo":253299006,
    "descripcion":"DOBLE TRACTO DE SALIDA DE VENTRÍCULO DERECHO CON DEFECTO VENTRICULAR SEPTAL NO RELACIONADO"
  },
  {
    "codigo":449907009,
    "descripcion":"PAPILA INCISIVA"
  },
  {
    "codigo":251464004,
    "descripcion":"COMPLEJOS PERIÓDICOS CONTINUOS"
  },
  {
    "codigo":11814901000119100,
    "descripcion":"RUPTURA TRAUMÁTICA DE PLACA PALMAR DE ARTICULACIÓN DE DEDO MEDIO DE MANO IZQUIERDA"
  },
  {
    "codigo":218696007,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR MIORRELAJANTES DE ACCIÓN CENTRAL"
  },
  {
    "codigo":448072007,
    "descripcion":"TRACTO DE ENTRADA VENTRICULAR ÚNICO CON CONEXIÓN AURICULOVENTRICULAR AUSENTE"
  },
  {
    "codigo":185928009,
    "descripcion":"MONITOREO DE LOS EPISODIOS RELACIONADOS CON LA PRESCRIPCIÓN ENVIADO"
  },
  {
    "codigo":216861001,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR CLOROACETOFENONA"
  },
  {
    "codigo":249629008,
    "descripcion":"MARGEN ANAL - HALLAZGO"
  },
  {
    "codigo":82119001,
    "descripcion":"TIROIDITIS"
  },
  {
    "codigo":311495006,
    "descripcion":"AMILOIDOSIS URETRAL"
  },
  {
    "codigo":1163463008,
    "descripcion":"INFECCIÓN DE HÍGADO CAUSADA POR FUNGI"
  },
  {
    "codigo":47516005,
    "descripcion":"ESFEROCITOSIS HEREDITARIA POR DEFICIENCIA COMBINADA DE ESPECTRINA Y ANQUIRINA"
  },
  {
    "codigo":14748007,
    "descripcion":"ECTASIA CORNEAL"
  },
  {
    "codigo":735644008,
    "descripcion":"DOLOR NOCICEPTIVO CRÓNICO"
  },
  {
    "codigo":1290865001,
    "descripcion":"SARCOMA INTIMAL"
  },
  {
    "codigo":1083381000119107,
    "descripcion":"OTITIS EXTERNA CRÓNICA DE AMBOS CONDUCTOS AUDITIVOS EXTERNOS"
  },
  {
    "codigo":209521000,
    "descripcion":"DESGARRO PARCIAL DE RODILLA, LIGAMENTO CRUZADO POSTERIOR"
  },
  {
    "codigo":897649003,
    "descripcion":"MELANOSIS ADQUIRIDA PRIMARIA DE CÓRNEA DE OJO DERECHO"
  },
  {
    "codigo":307825005,
    "descripcion":"ESTADO DE DATOS DE REGISTRO DEL PACIENTE"
  },
  {
    "codigo":10831861000119108,
    "descripcion":"FRACTURA ABIERTA DE BASE DE CUARTO HUESO METACARPIANO DE MANO IZQUIERDA"
  },
  {
    "codigo":10641551000119102,
    "descripcion":"ÚLCERA CRÓNICA DE PANTORRILLA DERECHA"
  },
  {
    "codigo":319631000119102,
    "descripcion":"ARTRITIS REACTIVA DE ARTICULACIÓN GLENOHUMERAL DERECHA"
  },
  {
    "codigo":406129009,
    "descripcion":"INFESTACIÓN AMBIENTAL POR ROEDORES"
  },
  {
    "codigo":109382005,
    "descripcion":"NEOPLASIA BENIGNA DEL TEJIDO MESOTELIAL DEL PERICARDIO"
  },
  {
    "codigo":402459005,
    "descripcion":"AMILOIDOSIS SISTÉMICA HEREDOFAMILIAR QUE AFECTA LA PIEL"
  },
  {
    "codigo":271387005,
    "descripcion":"RIÑÓN CONGÉNITO AGRANDADO"
  },
  {
    "codigo":762907005,
    "descripcion":"AGENESIA DE RIÑÓN IZQUIERDO"
  },
  {
    "codigo":238619006,
    "descripcion":"PITIRIASIS ROSADA ATÍPICA DEL ADULTO"
  },
  {
    "codigo":369691009,
    "descripcion":"MARGEN DISTAL DE RESECCIÓN QUIRÚRGICA DE INTESTINO GRUESO, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":302320003,
    "descripcion":"DIETA LIBRE DE LECHE"
  },
  {
    "codigo":236784006,
    "descripcion":"EDEMA ESCROTAL IDIOPÁTICO"
  },
  {
    "codigo":234949000,
    "descripcion":"TRASTORNO DE LA ERUPCIÓN DENTARIA"
  },
  {
    "codigo":1187056009,
    "descripcion":"COBRE SÉRICO POR DEBAJO DE RANGO DE REFERENCIA"
  },
  {
    "codigo":366021002,
    "descripcion":"REACCIÓN PUPILAR - HALLAZGO"
  },
  {
    "codigo":38341003,
    "descripcion":"HIPERTENSIÓN ARTERIAL"
  },
  {
    "codigo":300485001,
    "descripcion":"TESTÍCULOS BLANDOS"
  },
  {
    "codigo":3738000,
    "descripcion":"HEPATITIS VIRAL"
  },
  {
    "codigo":202181008,
    "descripcion":"LUXACIÓN PATOLÓGICA DE LA ARTICULACIÓN RADIOCUBITAL INFERIOR"
  },
  {
    "codigo":429722003,
    "descripcion":"DISTENSIÓN DE MÚSCULO FLEXOR DE LA CADERA"
  },
  {
    "codigo":298650005,
    "descripcion":"SIN AMPLITUD DE MOVIMIENTO ACTIVO DE ROTACIÓN HACIA LA DERECHA DE LA COLUMNA LUMBAR"
  },
  {
    "codigo":36506006,
    "descripcion":"ESPESOR NORMAL"
  },
  {
    "codigo":42231000009109,
    "descripcion":"NEFRITIS BACTERIANA"
  },
  {
    "codigo":1903004,
    "descripcion":"INFESTACIÓN CAUSADA POR PSORERGATES OVIS"
  },
  {
    "codigo":427887006,
    "descripcion":"OSTEONECROSIS DE CUERPO VERTEBRAL"
  },
  {
    "codigo":165743006,
    "descripcion":"GRUPO SANGUÍNEO AB"
  },
  {
    "codigo":131140002,
    "descripcion":"NIVEL DE SEROTONINA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1085891000119100,
    "descripcion":"HEMORRAGIA RECTAL DEBIDA A ENFERMEDAD DE CROHN DE INTESTINO DELGADO"
  },
  {
    "codigo":294980007,
    "descripcion":"ALERGIA A MEXILETINA"
  },
  {
    "codigo":720964009,
    "descripcion":"QUISTE Y TROFOZOÍTO DE IODAMOEBA BÜTSCHLII"
  },
  {
    "codigo":94702005,
    "descripcion":"DEFECTOS CARDÍACOS CONGÉNITOS MÚLTIPLES"
  },
  {
    "codigo":60099002,
    "descripcion":"DEPRESIÓN MAYOR GRAVE CON SÍNTOMAS PSICÓTICOS, INCONGRUENTE CON EL ESTADO DE ÁNIMO"
  },
  {
    "codigo":125635006,
    "descripcion":"LESIÓN TRAUMÁTICA DEL RECTO"
  },
  {
    "codigo":289475007,
    "descripcion":"TUMEFACCIÓN DE LA VULVA"
  },
  {
    "codigo":189336000,
    "descripcion":"CARCINOMA IN SITU DE MAMA"
  },
  {
    "codigo":92867006,
    "descripcion":"FUSIÓN ANORMAL CONGÉNITA DEL METACARPO"
  },
  {
    "codigo":27331008,
    "descripcion":"INTOXICACIÓN POR FENOTIAZINA"
  },
  {
    "codigo":322141000119100,
    "descripcion":"SUBLUXACIÓN COMPLEJA DE VÉRTEBRA LUMBAR"
  },
  {
    "codigo":254872007,
    "descripcion":"CARCINOMA EMBRIONARIO DE OVARIO"
  },
  {
    "codigo":713624009,
    "descripcion":"MENINGITIS CAUSADA POR HISTOPLASMA CAPSULATUM"
  },
  {
    "codigo":1336216009,
    "descripcion":"HIPERTENSIÓN OCULAR DEBIDA A NEOPLASIA INTRAOCULAR DE OJO IZQUIERDO"
  },
  {
    "codigo":416877003,
    "descripcion":"CORIORRETINITIS CRIPTOCÓCICA"
  },
  {
    "codigo":123800009,
    "descripcion":"HIPERTENSIÓN DE GOLDBLATT"
  },
  {
    "codigo":23661008,
    "descripcion":"FORMACIÓN ÓSEA ENDÓSTICA ANORMAL"
  },
  {
    "codigo":283970001,
    "descripcion":"LACERACIÓN DEL PERINEO FEMENINO"
  },
  {
    "codigo":447810006,
    "descripcion":"ESTENOSIS CONGÉNITA DE TRÁQUEA DEBIDA A ANILLOS COMPLETOS"
  },
  {
    "codigo":1332546006,
    "descripcion":"ARTRITIS GOTOSA DE ARTICULACIÓN RADIOCARPIANA"
  },
  {
    "codigo":54594006,
    "descripcion":"INTOXICACIÓN CAUSADA POR CICLOGUANIL"
  },
  {
    "codigo":413207001,
    "descripcion":"PAPILA DUODENAL INACCESIBLE"
  },
  {
    "codigo":249367001,
    "descripcion":"SANGRADO DE RINOFARINGE"
  },
  {
    "codigo":314903002,
    "descripcion":"ARTROPATÍA DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":216599003,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ADRENÉRGICOS"
  },
  {
    "codigo":708119004,
    "descripcion":"VIRUS INFLUENZA A SUBTIPO H7 PRESENTE"
  },
  {
    "codigo":15968861000119105,
    "descripcion":"TROMBOFLEBITIS DE VENA ILÍACA IZQUIERDA"
  },
  {
    "codigo":18156008,
    "descripcion":"HIPERESTESIA ABDOMINAL"
  },
  {
    "codigo":704449003,
    "descripcion":"PERFUSIÓN DE TEJIDO PERIFÉRICO, ALTERADA"
  },
  {
    "codigo":737217005,
    "descripcion":"AUSENCIA CONGÉNITA DE ANTEBRAZO Y MANO"
  },
  {
    "codigo":278465006,
    "descripcion":"NISTAGMO ESPONTÁNEO"
  },
  {
    "codigo":49089006,
    "descripcion":"CUERPO EXTRAÑO MAGNÉTICO RETENIDO EN LA CÁMARA ANTERIOR DEL OJO"
  },
  {
    "codigo":702614000,
    "descripcion":"APLASIA DE GLÁNDULA PARATIROIDES"
  },
  {
    "codigo":276630006,
    "descripcion":"HIPOTIROTROFINEMIA TRANSITORIA"
  },
  {
    "codigo":243862009,
    "descripcion":"SITUACIÓN DEL MONITOREO DE LA OBESIDAD"
  },
  {
    "codigo":242027005,
    "descripcion":"PARÁLISIS CONSECUTIVA AL CHOQUE ELÉCTRICO"
  },
  {
    "codigo":78187008,
    "descripcion":"QUISTE DE CARTÍLAGO SEMILUNAR"
  },
  {
    "codigo":209259009,
    "descripcion":"FRACTURA-SUBLUXACIÓN NO EXPUESTA DE ARTICULACIÓN RADIOCUBITAL PROXIMAL"
  },
  {
    "codigo":305728001,
    "descripcion":"ATENDIDO POR CIRUJANO DE TRAUMA"
  },
  {
    "codigo":830016005,
    "descripcion":"QUISTE DERMOIDE DE CRÁNEO"
  },
  {
    "codigo":10816007,
    "descripcion":"OCLUSIÓN LINGUAL POSTERIOR DE LOS DIENTES MANDIBULARES"
  },
  {
    "codigo":404032008,
    "descripcion":"NEUROFIBROMA EPITELIOIDE"
  },
  {
    "codigo":402197001,
    "descripcion":"DERMATITIS ATÓPICA DEL ADULTO"
  },
  {
    "codigo":332721351000132106,
    "descripcion":"CON MODERADO RIESGO DE CAÍDA"
  },
  {
    "codigo":10754961000119101,
    "descripcion":"HIPERTIROIDISMO POSPARTO"
  },
  {
    "codigo":16024311000119107,
    "descripcion":"TROMBOFLEBITIS DE VENA SUBCLAVIA IZQUIERDA"
  },
  {
    "codigo":271125007,
    "descripcion":"AMPOLLA TRAUMÁTICA DE LA REGIÓN INGUINAL"
  },
  {
    "codigo":236522005,
    "descripcion":"NEFROTOXICIDAD CRÓNICA POR CICLOSPORINA A"
  },
  {
    "codigo":1088401000119103,
    "descripcion":"OTITIS MEDIA SUPURATIVA CRÓNICA ATICOANTRAL IZQUIERDA"
  },
  {
    "codigo":302058008,
    "descripcion":"NO IMITA LOS MOVIMIENTOS DE LA LENGUA"
  },
  {
    "codigo":726207003,
    "descripcion":"LACERACIÓN DE TENDÓN DE MÚSCULO INTRÍNSECO DE DEDO DE LA MANO"
  },
  {
    "codigo":38079004,
    "descripcion":"NECROSIS ASÉPTICA DEL PÁNCREAS"
  },
  {
    "codigo":300223008,
    "descripcion":"AUDICIÓN DE LA VOZ EN LA CONVERSACIÓN, ALTERADA"
  },
  {
    "codigo":365759009,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD DE CONCENTRACIÓN"
  },
  {
    "codigo":298388004,
    "descripcion":"CUELLO PEQUEÑO"
  },
  {
    "codigo":34409000,
    "descripcion":"HEMORRAGIA INTRALUMINAL DE VEJIGA URINARIA"
  },
  {
    "codigo":722537008,
    "descripcion":"ÚLCERA DE INTESTINO DELGADO CAUSADA POR RADIACIÓN"
  },
  {
    "codigo":296553009,
    "descripcion":"SOBREDOSIS DE PIRIMETAMINA"
  },
  {
    "codigo":196414004,
    "descripcion":"PREMOLARES IMPACTADOS"
  },
  {
    "codigo":32574007,
    "descripcion":"INFARTO DE MIOCARDIO ANTIGUO, DIAGNOSTICADO POR ELECTROCARDIOGRAMA Y\/U OTRO MÉTODO COMPLEMENTARIO, PERO ACTUALMENTE ASINTOMÁTICO"
  },
  {
    "codigo":129043005,
    "descripcion":"DEPENDENCIA PARA EL BAÑO"
  },
  {
    "codigo":40511000087102,
    "descripcion":"CUERPO EXTRAÑO EN EXTREMIDAD INFERIOR DERECHA"
  },
  {
    "codigo":48191000087101,
    "descripcion":"FRACTURA DE CUARTO HUESO METATARSIANO DE PIE DERECHO"
  },
  {
    "codigo":422120000,
    "descripcion":"MACROPSIA"
  },
  {
    "codigo":292883009,
    "descripcion":"REACCIÓN ADVERSA AL GLUTARALDEHÍDO"
  },
  {
    "codigo":192744002,
    "descripcion":"ABSCESO INTRACRANEAL SUBDURAL"
  },
  {
    "codigo":1144851009,
    "descripcion":"ESCASO CRECIMIENTO DE VELLO AXILAR"
  },
  {
    "codigo":35391000087108,
    "descripcion":"CABESTRILLO SUBURETRAL IN SITU"
  },
  {
    "codigo":37951000087109,
    "descripcion":"ACINESIA DE MIOCARDIO DE REGIÓN ANTEROSEPTAL DE VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":43071000087107,
    "descripcion":"HEMATOMA DE DEDO ANULAR IZQUIERDO"
  },
  {
    "codigo":16764101000119100,
    "descripcion":"MELANOMA IN SITU DE PIEL DE MEJILLA"
  },
  {
    "codigo":291048008,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR TRIAZOLAM"
  },
  {
    "codigo":127208009,
    "descripcion":"LINFADENOPATÍA POPLÍTEA SUPERFICIAL"
  },
  {
    "codigo":94440009,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE HUESO ESCAFOIDES"
  },
  {
    "codigo":92605003,
    "descripcion":"CARCINOMA IN SITU DE LA ENCÍA"
  },
  {
    "codigo":715197005,
    "descripcion":"SÍNDROME FETAL POR PARVOVIRUS"
  },
  {
    "codigo":289213005,
    "descripcion":"DURACIÓN NORMAL DE LA PRIMERA ETAPA DEL TRABAJO DE PARTO"
  },
  {
    "codigo":418450005,
    "descripcion":"REFLEJO DE DEFECACIÓN - DIARREA FALSA"
  },
  {
    "codigo":1335954005,
    "descripcion":"EPISODIO DE USO NOCIVO DE HIPNÓTICO"
  },
  {
    "codigo":285543000,
    "descripcion":"INCAPAZ DE MOVER EL PALADAR BLANDO"
  },
  {
    "codigo":187239003,
    "descripcion":"PSOROSPERMIASIS"
  },
  {
    "codigo":449383004,
    "descripcion":"ANOMALÍA CONGÉNITA DE MÚSCULO PAPILAR DE VÁLVULA AURICULOVENTRICULAR EN DEFECTO DEL TABIQUE AURICULOVENTRICULAR"
  },
  {
    "codigo":1137511009,
    "descripcion":"DEBILIDAD PROGRESIVA DE MÚSCULO"
  },
  {
    "codigo":283708002,
    "descripcion":"MORDEDURA HUMANA EN DEDO DE LA MANO"
  },
  {
    "codigo":414780005,
    "descripcion":"LINFOMA DE ÓRBITA DE TEJIDO LINFOIDE ASOCIADO A MUCOSA"
  },
  {
    "codigo":269960002,
    "descripcion":"EXTENDIDO CERVICAL - DISCARIOSIS GRAVE"
  },
  {
    "codigo":609553000,
    "descripcion":"SÍNDROME PARALÍTICO DE AMBAS EXTREMIDADES INFERIORES"
  },
  {
    "codigo":773393001,
    "descripcion":"ENFERMEDAD DE CHARCOT-MARIE-TOOTH TIPO 2Q AUTOSÓMICA DOMINANTE"
  },
  {
    "codigo":249105002,
    "descripcion":"PRESENTACIÓN DORSOPOSTERIOR DE HOMBRO"
  },
  {
    "codigo":52497002,
    "descripcion":"CUERPO EXTRAÑO EN EL SACO CONJUNTIVAL"
  },
  {
    "codigo":1363217001,
    "descripcion":"CICATRIZACIÓN DE PÁRPADO INFERIOR"
  },
  {
    "codigo":19729005,
    "descripcion":"PROLAPSO DE LABIO ANTERIOR DE CUELLO UTERINO QUE OBSTRUYE EL TRABAJO DE PARTO"
  },
  {
    "codigo":50662000,
    "descripcion":"RECHAZO CELULAR LEVE DE INJERTO"
  },
  {
    "codigo":1230310007,
    "descripcion":"SOBRECARGA DE HIERRO ASOCIADA A CADENA PESADA DE FERRITINA 1"
  },
  {
    "codigo":738790007,
    "descripcion":"METABOLIZADOR ULTRARRÁPIDO DE LA FAMILIA 2 SUBFAMILIA C MIEMBRO 19 DEL CITOCROMO P450"
  },
  {
    "codigo":247270009,
    "descripcion":"HALLAZGO RELACIONADO CON LOS HUESECILLOS DEL OÍDO"
  },
  {
    "codigo":704187002,
    "descripcion":"FRACTURA EXPUESTA DE FALANGE DISTAL DE DEDO ÍNDICE"
  },
  {
    "codigo":10675551000119104,
    "descripcion":"EXACERBACIÓN SEVERA AGUDA DE ASMA SEVERA PERSISTENTE CONCOMITANTE CON RINITIS ALÉRGICA"
  },
  {
    "codigo":16059006,
    "descripcion":"ANISEICONIA"
  },
  {
    "codigo":353631000119105,
    "descripcion":"CARCINOMA IN SITU DE MAMA DERECHA"
  },
  {
    "codigo":1259408008,
    "descripcion":"ADENOCARCINOMA EPITELIAL PIGMENTARIO PRIMARIO DE RETINA"
  },
  {
    "codigo":472976009,
    "descripcion":"PATRÓN DE COMPORTAMIENTO DE TIPO B"
  },
  {
    "codigo":766053003,
    "descripcion":"SÍNDROME DE TRISOMÍA DISTAL 1P36"
  },
  {
    "codigo":274533004,
    "descripcion":"HALLAZGOS ANORMALES EN IMÁGENES DIAGNÓSTICAS DE PULMÓN"
  },
  {
    "codigo":438373005,
    "descripcion":"ENFERMEDAD POR DEFICIENCIA HEREDITARIA SEVERA DE FACTOR VIII CON INHIBIDORES"
  },
  {
    "codigo":733285006,
    "descripcion":"LACERACIÓN DE MÚSCULO CUÁDRICEPS"
  },
  {
    "codigo":208997008,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA PANASTRAGALINA"
  },
  {
    "codigo":698682001,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: TAYIKO"
  },
  {
    "codigo":305466002,
    "descripcion":"BAJO ATENCIÓN DE ESPECIALISTA EN CUIDADOS INTENSIVOS DE ADULTOS"
  },
  {
    "codigo":16000351000119109,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DEBIDO A OCLUSIÓN DE ARTERIA CEREBRAL POSTERIOR IZQUIERDA"
  },
  {
    "codigo":1255738005,
    "descripcion":"LINFOMA DE HODGKIN DE GANGLIOS LINFÁTICOS DE CUELLO, PREDOMINIO LINFOCÍTICO-HISTIOCÍTICO"
  },
  {
    "codigo":76090006,
    "descripcion":"NEUMONÍA DE PITTSBURGH"
  },
  {
    "codigo":762383000,
    "descripcion":"DERMATITIS ALÉRGICA POR CONTACTO CAUSADA POR LUBRICANTE DE CORTE"
  },
  {
    "codigo":403770008,
    "descripcion":"SÍNDROME CARDIO-FACIO-CUTÁNEO"
  },
  {
    "codigo":238095002,
    "descripcion":"DEFICIENCIA DE APOLIPOPROTEÍNA A-I"
  },
  {
    "codigo":860687003,
    "descripcion":"EMBOLIA GRASA DEBIDA A EMBARAZO ECTÓPICO Y POSTERIOR A ÉL"
  },
  {
    "codigo":400100000,
    "descripcion":"NEVO EPIDÉRMICO EPIDERMOLÍTICO LOCALIZADO"
  },
  {
    "codigo":39652006,
    "descripcion":"INTOXICACIÓN POR ENULA GRAVEOLENS"
  },
  {
    "codigo":5049001,
    "descripcion":"ÁNGULO ANORMAL DE ERECCIÓN"
  },
  {
    "codigo":431033003,
    "descripcion":"RUPTURA DE TENDÓN PROXIMAL DEL CUÁDRICEPS"
  },
  {
    "codigo":365497005,
    "descripcion":"APOYO ASISTENCIAL VECINAL - HALLAZGO"
  },
  {
    "codigo":429198000,
    "descripcion":"HIPERTENSIÓN DE ESFUERZO"
  },
  {
    "codigo":299961008,
    "descripcion":"PRUEBA DE PHALEN POSITIVA"
  },
  {
    "codigo":234425008,
    "descripcion":"NEUTROPENIA AUTOINMUNITARIA"
  },
  {
    "codigo":3214003,
    "descripcion":"ASPERGILOSIS PULMONAR INVASIVA"
  },
  {
    "codigo":68750005,
    "descripcion":"MUCOCOLPOS"
  },
  {
    "codigo":134286006,
    "descripcion":"LEE ÁRABE"
  },
  {
    "codigo":298126007,
    "descripcion":"LESIÓN DE NERVIO DIGITAL"
  },
  {
    "codigo":230755007,
    "descripcion":"HERNIA ASCENDENTE DEL CEREBELO"
  },
  {
    "codigo":294456002,
    "descripcion":"ALERGIA A DIETILCARBAMAZINA"
  },
  {
    "codigo":196152007,
    "descripcion":"INSUFICIENCIA PULMONAR LUEGO DE UNA CIRUGÍA"
  },
  {
    "codigo":451991000124106,
    "descripcion":"ENFERMEDAD INFECCIOSA RECURRENTE"
  },
  {
    "codigo":30477007,
    "descripcion":"HERNIA INTRABDOMINAL"
  },
  {
    "codigo":126946000,
    "descripcion":"EXCESO DE CERUMEN EN EL CONDUCTO AUDITIVO"
  },
  {
    "codigo":718605009,
    "descripcion":"HIPOPLASIA PONTOCEREBELOSA CONGÉNITA TIPO 7"
  },
  {
    "codigo":290786003,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR LEVODOPA"
  },
  {
    "codigo":92343006,
    "descripcion":"NEOPLASIA BENIGNA DE COLON SIGMOIDE"
  },
  {
    "codigo":287116000,
    "descripcion":"ASTILLA CLAVADA EN MANO"
  },
  {
    "codigo":123276005,
    "descripcion":"ANOMALÍA CONGÉNITA DE LA ARTERIA UMBILICAL"
  },
  {
    "codigo":88673001,
    "descripcion":"PENE GRANDE"
  },
  {
    "codigo":447286000,
    "descripcion":"DESEQUILIBRIO VENTRICULAR CON VENTRÍCULO DERECHO DOMINANTE Y VENTRÍCULO IZQUIERDO HIPOPLÁSICO"
  },
  {
    "codigo":711265009,
    "descripcion":"MIOPATÍA DISTAL RELACIONADA CON CAVEOLINA 3"
  },
  {
    "codigo":86838005,
    "descripcion":"INFESTACIÓN CAUSADA POR SOLENOPOTES"
  },
  {
    "codigo":840502005,
    "descripcion":"HIDROCISTOMA ECRINO DE PÁRPADO"
  },
  {
    "codigo":283446008,
    "descripcion":"HERIDA PUNZANTE EN LA CABEZA Y EL CUELLO"
  },
  {
    "codigo":707595001,
    "descripcion":"CISTOADENOCARCINOMA MUCINOSO PRIMARIO DE PULMÓN"
  },
  {
    "codigo":281611002,
    "descripcion":"HIPERBILIRRUBINEMIA NO CONJUGADA NEONATAL"
  },
  {
    "codigo":248843009,
    "descripcion":"HIMEN VAGINAL - HALLAZGO"
  },
  {
    "codigo":1197280002,
    "descripcion":"TUMOR DE SACO VITELINO DE SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":247008005,
    "descripcion":"ACEITE EN CÁMARA ANTERIOR"
  },
  {
    "codigo":15704161000119100,
    "descripcion":"CONTRACTURA DE MÚSCULO DE AMBAS REGIONES DE HOMBROS"
  },
  {
    "codigo":441781003,
    "descripcion":"TÍTULO DE ANTICUERPOS POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":703925004,
    "descripcion":"ALERGIA A LEGUMINOSA"
  },
  {
    "codigo":736693005,
    "descripcion":"ANTICUERPO ANTI-ANTÍGENO CORE DE VIRUS DE HEPATITIS B NO DETECTADO"
  },
  {
    "codigo":1162677006,
    "descripcion":"ARTRITIS REUMATOIDE CON ENFERMEDAD PULMONAR REUMATOIDEA"
  },
  {
    "codigo":210570002,
    "descripcion":"SECCIÓN PARCIAL DEL TENDÓN DEL FLEXOR DE LA MANO"
  },
  {
    "codigo":243338005,
    "descripcion":"SÍNDROME DE COMPRESIÓN DE LA RAÍZ NERVIOSA"
  },
  {
    "codigo":276106008,
    "descripcion":"POSEE UNA AMANTE"
  },
  {
    "codigo":1290079005,
    "descripcion":"ESTENOSIS DE VÁLVULA TRICUSPÍDEA DEBIDA A TUMOR NEUROENDOCRINO"
  },
  {
    "codigo":77663007,
    "descripcion":"ANEMIA HEMOLÍTICA DEBIDA A PALUDISMO"
  },
  {
    "codigo":403508004,
    "descripcion":"TELANGIECTASIA DE PLIEGUE UNGUEAL ASOCIADA CON LUPUS ERITEMATOSO"
  },
  {
    "codigo":1157172005,
    "descripcion":"FUNCIÓN DEL SISTEMA MUSCULOESQUELÉTICO NORMAL"
  },
  {
    "codigo":1222708006,
    "descripcion":"SÍNDROME DE DEFECTOS CARDÍACOS CONGÉNITOS, DISMORFIA FACIAL Y RETRASO DEL DESARROLLO ASOCIADO AL GEN DE LA PROTEÍNA TRANSMEMBRANA 94"
  },
  {
    "codigo":205065005,
    "descripcion":"LUXACIÓN CONGÉNITA DE RODILLA, GRADO II"
  },
  {
    "codigo":237833006,
    "descripcion":"CRISIS CARCINOIDE"
  },
  {
    "codigo":1351945007,
    "descripcion":"ENFERMEDAD POR DEPÓSITO DE HIDROXIAPATITA DE HOMBRO"
  },
  {
    "codigo":303369006,
    "descripcion":"INCAPAZ DE TIRAR"
  },
  {
    "codigo":301534001,
    "descripcion":"CAPAZ DE SALIR DE LA BAÑERA"
  },
  {
    "codigo":203230004,
    "descripcion":"INFECCIÓN DE LA PELVIS"
  },
  {
    "codigo":39390005,
    "descripcion":"ENFERMEDAD DE NIEMANN - PICK, TIPO B"
  },
  {
    "codigo":70323002,
    "descripcion":"FATIGA OCULAR"
  },
  {
    "codigo":365235003,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA PONERSE PRÓTESIS"
  },
  {
    "codigo":299699004,
    "descripcion":"CONJUNTIVITIS INFECCIOSA"
  },
  {
    "codigo":695449561000119100,
    "descripcion":"ENDOMETRIOMA DE OVARIO IZQUIERDO"
  },
  {
    "codigo":15677401000119101,
    "descripcion":"MIOSITIS DE AMBOS PIES"
  },
  {
    "codigo":317401000119101,
    "descripcion":"DETENCIÓN PARCIAL DE CRECIMIENTO EPIFISARIO DE TIBIA DISTAL IZQUIERDA"
  },
  {
    "codigo":15741401000119101,
    "descripcion":"CONTRACTURA CONGÉNITA DE ARTICULACIÓN DE DEDO DE PIE DERECHO"
  },
  {
    "codigo":16606681000119101,
    "descripcion":"ARTRITIS REUMATOIDEA SERONEGATIVA EN REMISIÓN"
  },
  {
    "codigo":15718361000119106,
    "descripcion":"PROTRUSIÓN INTRAPÉLVICA DE ACETÁBULO IZQUIERDO"
  },
  {
    "codigo":1077721000119106,
    "descripcion":"OSTEOMIELITIS DE MANO IZQUIERDA"
  },
  {
    "codigo":11791321000119108,
    "descripcion":"LESIÓN TRAUMÁTICA DE MANO IZQUIERDA"
  },
  {
    "codigo":232328005,
    "descripcion":"PÉRDIDA DE LA AUDICIÓN NEUROSENSORIAL, FORMA DOMINANTE"
  },
  {
    "codigo":368601000119102,
    "descripcion":"COMA HIPEROSMOLAR DEBIDO A DIABETES MELLITUS SECUNDARIA"
  },
  {
    "codigo":12001241000119108,
    "descripcion":"HEMATOMA DEBIDO A ARTROPLASTIA DE CADERA DERECHA Y POSTERIOR A ELLA"
  },
  {
    "codigo":309721000119105,
    "descripcion":"GOTA PRIMARIA CRÓNICA DE CADERA, SIN TOFO"
  },
  {
    "codigo":678361000119106,
    "descripcion":"IRIS BOMBÉ DE OJO DERECHO"
  },
  {
    "codigo":15715801000119105,
    "descripcion":"ENOSTOSIS DE HÚMERO DERECHO"
  },
  {
    "codigo":299481000119106,
    "descripcion":"NÓDULO REUMATOIDEO DE MUÑECA"
  },
  {
    "codigo":48601000119107,
    "descripcion":"HEMIPLEJÍA Y\/O HEMIPARESIA DESPUÉS DE ACCIDENTE CEREBROVASCULAR"
  },
  {
    "codigo":1085401000119108,
    "descripcion":"COMPLICACIÓN DEBIDA A PÓLIPOS INFLAMATORIOS COLÓNICOS"
  },
  {
    "codigo":660441000119109,
    "descripcion":"INMUNIDAD CONTRA LA ENFERMEDAD DE LYME DETERMINADA POR SEROLOGÍA"
  },
  {
    "codigo":722013004,
    "descripcion":"MAYOR NECESIDAD DE REPOSO"
  },
  {
    "codigo":230493001,
    "descripcion":"APNEA MIXTA DEL SUEÑO"
  },
  {
    "codigo":359730001,
    "descripcion":"AFIBRINOGENEMIA ADQUIRIDA"
  },
  {
    "codigo":296029005,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE METIPRILÓN"
  },
  {
    "codigo":425266007,
    "descripcion":"USO DE PRESTADOR DE SALUD PARA CONTACTO SOCIAL"
  },
  {
    "codigo":95751000,
    "descripcion":"BLEFARITIS CRÓNICA"
  },
  {
    "codigo":62983000,
    "descripcion":"QUISTES SEBÁCEOS DEL ESCROTO"
  },
  {
    "codigo":1144327005,
    "descripcion":"ATROFIA DE DUODENO"
  },
  {
    "codigo":290524000,
    "descripcion":"INTOXICACIÓN POR DESFLURANO"
  },
  {
    "codigo":128519009,
    "descripcion":"NEOPLASIA DE LA REGIÓN DE LA CADERA"
  },
  {
    "codigo":423431009,
    "descripcion":"INDUCCIÓN DE ENZIMA DE CITOCROMO P450 CYP2E1 POR SUSTANCIA"
  },
  {
    "codigo":257756001,
    "descripcion":"ANGULACIÓN EN VARO"
  },
  {
    "codigo":93916003,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE HUESO DE LA NARIZ"
  },
  {
    "codigo":292359009,
    "descripcion":"REACCIÓN ADVERSA AL MIDAZOLAM"
  },
  {
    "codigo":224988005,
    "descripcion":"PENSAMIENTOS REPRIMIDOS"
  },
  {
    "codigo":126684008,
    "descripcion":"NEOPLASIA DE LA PARED ANTERIOR DE LA NASOFARINGE"
  },
  {
    "codigo":716508008,
    "descripcion":"NO UTILIZA LA PRAGMÁTICA EN LA COMUNICACIÓN"
  },
  {
    "codigo":1306332008,
    "descripcion":"GLAUCOMA DE ÁNGULO CERRADO SECUNDARIO DE OJO IZQUIERDO"
  },
  {
    "codigo":288689001,
    "descripcion":"CAPAZ DE ADAPTAR LA CONVERSACIÓN A UN CONTEXTO"
  },
  {
    "codigo":10627631000119102,
    "descripcion":"FORÚNCULO DE MANO DERECHA"
  },
  {
    "codigo":88411000,
    "descripcion":"AMPOLLA DEL ANO, CON INFECCIÓN"
  },
  {
    "codigo":712838009,
    "descripcion":"ALERGIA A CASTAÑA DE CAJÚ"
  },
  {
    "codigo":53808001,
    "descripcion":"CEGUERA NOCTURNA ADQUIRIDA"
  },
  {
    "codigo":16034351000119106,
    "descripcion":"HIPERTROFIA DE HUESO DE AMBAS MANOS"
  },
  {
    "codigo":414256007,
    "descripcion":"PNEUMOCYSTIS JIROVECI PRESENTE"
  },
  {
    "codigo":283184007,
    "descripcion":"CUERPO EXTRAÑO METÁLICO EN DEDO DEL PIE"
  },
  {
    "codigo":248581005,
    "descripcion":"RESPIRACIÓN SUPERFICIAL RÁPIDA"
  },
  {
    "codigo":1197018005,
    "descripcion":"OSTEOGÉNESIS IMPERFECTA TIPO IIC"
  },
  {
    "codigo":408751001,
    "descripcion":"SÍNDROME DE DOLOR REGIONAL COMPLEJO, TIPO II"
  },
  {
    "codigo":310447007,
    "descripcion":"SITUACIÓN DE SOLICITUD DE REGISTRO DE DISCAPACITADO"
  },
  {
    "codigo":441519008,
    "descripcion":"CONTUSIÓN DE NERVIO INFRAORBITARIO"
  },
  {
    "codigo":48303008,
    "descripcion":"LACERACIÓN ESTRELLADA DE HÍGADO SIN HERIDA ABIERTA HACIA CAVIDAD ABDOMINAL"
  },
  {
    "codigo":210308007,
    "descripcion":"HERIDA ABIERTA DE HUESECILLO DEL OÍDO"
  },
  {
    "codigo":1258884008,
    "descripcion":"TROMBO TUMORAL DE VENA CAVA INFERIOR"
  },
  {
    "codigo":306777003,
    "descripcion":"NO DEGLUTE ALIMENTOS BLANDOS"
  },
  {
    "codigo":110169005,
    "descripcion":"ABRASIÓN DE PIEL DE REGIÓN PREAURICULAR DE CARA"
  },
  {
    "codigo":208473009,
    "descripcion":"FRACTURA EXPUESTA DE LA FALANGE DISTAL DEL PULGAR, BASE"
  },
  {
    "codigo":16909001000119109,
    "descripcion":"DERMATOFIBROMA DE PIEL DE PÁRPADO INFERIOR IZQUIERDO"
  },
  {
    "codigo":403246005,
    "descripcion":"PELO PÁLIDO BLANCO-RUBIO"
  },
  {
    "codigo":237571006,
    "descripcion":"BOCIO ENDÉMICO MULTINODULAR RELACIONADO CON DEFICIENCIA DE YODO"
  },
  {
    "codigo":7011000119105,
    "descripcion":"NEFRITIS EXUDATIVA"
  },
  {
    "codigo":202968002,
    "descripcion":"SUBLUXACIÓN DE LA CABEZA LARGA DEL MÚSCULO BÍCEPS"
  },
  {
    "codigo":235736005,
    "descripcion":"FÍSTULA YEYUNOENTÉRICA"
  },
  {
    "codigo":301272007,
    "descripcion":"HALLAZGO RELACIONADO CON LA AUSCULTACIÓN TORÁCICA"
  },
  {
    "codigo":364973000,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA OPONER EL PULGAR"
  },
  {
    "codigo":399576007,
    "descripcion":"TUMOR QUE INVADE ESCLERÓTICA"
  },
  {
    "codigo":397741002,
    "descripcion":"ERUPCIÓN PAPULAR DE MENTÓN"
  },
  {
    "codigo":1216941002,
    "descripcion":"CETOACIDOSIS DEBIDA A DEFICIENCIA DE TRANSPORTADOR DE MONOCARBOXILATO 1"
  },
  {
    "codigo":233901002,
    "descripcion":"TAQUICARDIA DEL HAZ DE HIS"
  },
  {
    "codigo":201133003,
    "descripcion":"ALOPECIA PREMATURA"
  },
  {
    "codigo":102829006,
    "descripcion":"ISOSTENURIA"
  },
  {
    "codigo":736959331000119108,
    "descripcion":"PORTADOR DE CANDIDA AURIS"
  },
  {
    "codigo":428674000,
    "descripcion":"SEGMENTACIÓN DE VASO SANGUÍNEO RETINIANO"
  },
  {
    "codigo":232066004,
    "descripcion":"INCARCERACIÓN RETINIANA"
  },
  {
    "codigo":363138005,
    "descripcion":"TRASTORNO HEREDITARIO DEL SISTEMA INMUNITARIO"
  },
  {
    "codigo":15954941000119103,
    "descripcion":"MAMAS PÉNDULAS BILATERALES"
  },
  {
    "codigo":68226007,
    "descripcion":"CISTITIS AGUDA"
  },
  {
    "codigo":230231003,
    "descripcion":"ATAXIA CEREBELOSA DE INICIO TEMPRANO CON TEMBLOR ESENCIAL"
  },
  {
    "codigo":426839005,
    "descripcion":"DISPOSICIÓN PARA MEJORAR LA ESPERANZA"
  },
  {
    "codigo":721751007,
    "descripcion":"INFECCIÓN CAUSADA POR ACTINOMYCETALES"
  },
  {
    "codigo":262999009,
    "descripcion":"LESIÓN DE CÁPSULA ARTICULAR"
  },
  {
    "codigo":31788005,
    "descripcion":"EPÍFORA POR LAGRIMEO EXCESIVO"
  },
  {
    "codigo":457772007,
    "descripcion":"CALCIFICACIÓN DE VÁLVULA AURICULOVENTRICULAR IZQUIERDA (MORFOLÓGICAMENTE NO MITRAL)"
  },
  {
    "codigo":783617001,
    "descripcion":"INMUNODEFICIENCIA COMBINADA SEVERA DEBIDA A DEFICIENCIA DE PROTEÍNA TIROSINA CINASA ESPECÍFICA DE LINFOCITOS"
  },
  {
    "codigo":292097002,
    "descripcion":"REACCIÓN ADVERSA A MEDIOS DE CONTRASTE PARA RESONANCIA MAGNÉTICA"
  },
  {
    "codigo":11832471000119101,
    "descripcion":"LACERACIÓN DE VASO SANGUÍNEO DE ANULAR IZQUIERDO"
  },
  {
    "codigo":93654000,
    "descripcion":"MELANOMA MALIGNO DE LA PIEL DE LA MUÑECA"
  },
  {
    "codigo":95489009,
    "descripcion":"QUISTE CONJUNTIVAL CONGÉNITO"
  },
  {
    "codigo":880086001,
    "descripcion":"SÍNDROME DE DELECIÓN 12Q24.31-Q24.32"
  },
  {
    "codigo":1083451000119106,
    "descripcion":"OTOESCLEROSIS COCLEAR BILATERAL"
  },
  {
    "codigo":714411005,
    "descripcion":"CAPAZ DE ACORDAR CON EL PLAN DE ATENCIÓN"
  },
  {
    "codigo":1304235005,
    "descripcion":"TUMORACIÓN DE REGIÓN SUBAREOLAR DE MAMA"
  },
  {
    "codigo":288427005,
    "descripcion":"NO CORTA CON TIJERA"
  },
  {
    "codigo":1337003008,
    "descripcion":"SÍNDROME COMPARTIMENTAL TIBIAL ANTERIOR"
  },
  {
    "codigo":124587009,
    "descripcion":"DEFICIENCIA DE CISTEÍNA PROTEINASA"
  },
  {
    "codigo":59051007,
    "descripcion":"CISTICERCOSIS"
  },
  {
    "codigo":55381001,
    "descripcion":"INTOXICACIÓN CAUSADA POR HIERRO Y\/O COMPUESTO DE HIERRO"
  },
  {
    "codigo":251989004,
    "descripcion":"VELOCIDAD MEDIA DE LLENADO DE VEJIGA URINARIA"
  },
  {
    "codigo":284757007,
    "descripcion":"DARSE PUÑETAZOS"
  },
  {
    "codigo":16665751000119108,
    "descripcion":"FRACTURA EXPUESTA POR ESTALLIDO DEL PISO ORBITARIO IZQUIERDO"
  },
  {
    "codigo":282922003,
    "descripcion":"NO SE INCORPORA"
  },
  {
    "codigo":413994008,
    "descripcion":"MIOCARDIOPATÍA DILATADA CON TRASTORNO DEL TEJIDO CONJUNTIVO"
  },
  {
    "codigo":84479000,
    "descripcion":"DERMATITIS ALÉRGICA POR MEDICAMENTO INHALATORIO"
  },
  {
    "codigo":248319004,
    "descripcion":"PÉRDIDA DE GRASA CORPORAL, DISTRIBUIDA EN FORMA DESPAREJA"
  },
  {
    "codigo":215551009,
    "descripcion":"LESIÓN PRODUCIDA POR ACCIDENTE DE EMBARCACIÓN CON COLISIÓN, OCUPANTE DE EMBARCACIÓN PEQUEÑA NO MOTORIZADA LESIONADO"
  },
  {
    "codigo":443092002,
    "descripcion":"CALLO DE HUESO"
  },
  {
    "codigo":836308002,
    "descripcion":"AGUDEZA VISUAL DE OJO IZQUIERDO 6\/15"
  },
  {
    "codigo":337201000119106,
    "descripcion":"LAGOFTALMOS DE PÁRPADO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":703401001,
    "descripcion":"FIJACIÓN SUPRACRESTAL INSUFICIENTE"
  },
  {
    "codigo":768937006,
    "descripcion":"TERATOMA EXTRAGONADAL"
  },
  {
    "codigo":277417007,
    "descripcion":"OSTEOMA DE CONDUCTO AUDITIVO EXTERNO"
  },
  {
    "codigo":13438001,
    "descripcion":"TRASTORNO DE ANSIEDAD EXCESIVA EN LA NIÑEZ"
  },
  {
    "codigo":78974003,
    "descripcion":"DILATACIÓN DEL ESÓFAGO"
  },
  {
    "codigo":1074481000119109,
    "descripcion":"ARTROSIS DE PRIMERA ARTICULACIÓN METATARSOFALÁNGICA DE PIE DERECHO"
  },
  {
    "codigo":46206005,
    "descripcion":"TRASTORNO DEL ESTADO DE ÁNIMO"
  },
  {
    "codigo":11603001,
    "descripcion":"RETINOPATÍA DREPANOCÍTICA"
  },
  {
    "codigo":44371002,
    "descripcion":"CRIOINMUNOGLOBULINEMIA POLICLONAL MIXTA"
  },
  {
    "codigo":109907005,
    "descripcion":"ANOMALÍA AUDITIVA ADQUIRIDA"
  },
  {
    "codigo":9768003,
    "descripcion":"TUBERCULOSIS CUTÁNEA LIQUENOIDE"
  },
  {
    "codigo":402984004,
    "descripcion":"INFECCIÓN CUTÁNEA POR MYCOBACTEROIDES ABSCESSUS"
  },
  {
    "codigo":206376005,
    "descripcion":"SEPSIS NEONATAL"
  },
  {
    "codigo":1156648006,
    "descripcion":"DEFORMIDAD DE ESTIRAMIENTO EN POLO INFERIOR DE MAMA DEBIDA A AUMENTO QUIRÚRGICO DE MAMA CON INSERCIÓN DE PRÓTESIS Y POSTERIOR A ÉL"
  },
  {
    "codigo":239144007,
    "descripcion":"HAMARTOMA CONGÉNITO DE LOS MÚSCULOS ERECTORES DE LOS PELOS"
  },
  {
    "codigo":697896007,
    "descripcion":"HIPERTENSIÓN PULMONAR PRECAPILAR"
  },
  {
    "codigo":237309005,
    "descripcion":"NUDO DE CORDÓN UMBILICAL"
  },
  {
    "codigo":827133006,
    "descripcion":"PULSO EN ARTERIA PEDIA IZQUIERDA AUSENTE"
  },
  {
    "codigo":302845006,
    "descripcion":"LINFOMA MALIGNO NODULAR, LINFOCÍTICO - BIEN DIFERENCIADO"
  },
  {
    "codigo":6098001,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA VENA HEMIÁCIGOS"
  },
  {
    "codigo":301010001,
    "descripcion":"INFECCIÓN DE VÍAS URINARIAS POR BACTERIAS COLIFORMES"
  },
  {
    "codigo":399314004,
    "descripcion":"MICOSIS SISTÉMICA"
  },
  {
    "codigo":299175000,
    "descripcion":"AMPLITUD DE ADUCCIÓN ACTIVA DEL PULGAR AUMENTADA"
  },
  {
    "codigo":102567002,
    "descripcion":"PÉRDIDA DE CONTROL AL CAMINAR"
  },
  {
    "codigo":233639007,
    "descripcion":"DERRAME PLEURAL BENIGNO POR AMIANTO"
  },
  {
    "codigo":231804000,
    "descripcion":"DERMATITIS FÚNGICA DE PÁRPADO"
  },
  {
    "codigo":37031009,
    "descripcion":"CINETOSIS"
  },
  {
    "codigo":67964002,
    "descripcion":"ÚLCERA GÁSTRICA AGUDA SIN HEMORRAGIA Y SIN PERFORACIÓN"
  },
  {
    "codigo":788860005,
    "descripcion":"CARDITIS VIRAL AGUDA"
  },
  {
    "codigo":262737001,
    "descripcion":"CONTUSIÓN DE LA RAÍZ DE NERVIO SACRO"
  },
  {
    "codigo":295505001,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE ETOMIDATO"
  },
  {
    "codigo":721489003,
    "descripcion":"SÍNDROME DE BROWN-SEQUARD AL NIVEL DEL OCTAVO SEGMENTO DORSAL"
  },
  {
    "codigo":33361006,
    "descripcion":"IMPACTACIÓN DEL CIEGO"
  },
  {
    "codigo":15986431000119102,
    "descripcion":"DEGENERACIÓN CORIORRETINIANA CONGÉNITA DE OJO IZQUIERDO"
  },
  {
    "codigo":197201009,
    "descripcion":"ADHERENCIAS PERITONEALES PÉLVICAS LUEGO DE PROCEDIMIENTO"
  },
  {
    "codigo":424742005,
    "descripcion":"CONDUCTA INAPROPIADA PARA LA EDAD"
  },
  {
    "codigo":129830006,
    "descripcion":"MANEJO EFICAZ DEL RÉGIMEN TERAPÉUTICO"
  },
  {
    "codigo":160763002,
    "descripcion":"CONCURRE LA OBSTÉTRICA"
  },
  {
    "codigo":816123005,
    "descripcion":"COLOR DE PIE IZQUIERDO NORMAL"
  },
  {
    "codigo":1078267007,
    "descripcion":"AGENESIA DE EPÍFISIS DE FALANGE PROXIMAL DE TERCER DEDO DE PIE"
  },
  {
    "codigo":717819009,
    "descripcion":"RETRACCIÓN DE PEZÓN ASOCIADA CON EL PARTO CON DIFICULTAD EN LA PRENDIDA AL PECHO"
  },
  {
    "codigo":224464002,
    "descripcion":"TRANSFERIDO EN EL TRABAJO"
  },
  {
    "codigo":93392005,
    "descripcion":"TRONCO BRAQUIOCEFÁLICO CORTO CONGÉNITO"
  },
  {
    "codigo":191696005,
    "descripcion":"PSICOSIS ATÍPICAS DE LA INFANCIA"
  },
  {
    "codigo":715984007,
    "descripcion":"SÍNDROME DE ATAXIA CEREBELOSA CON HIPOGONADISMO Y DISTROFIA COROIDEA"
  },
  {
    "codigo":27856008,
    "descripcion":"REFLEJO PUPILAR DISMINUIDO"
  },
  {
    "codigo":124325000,
    "descripcion":"DEFICIENCIA DE PANTETEÍNA CINASA"
  },
  {
    "codigo":1076991000119107,
    "descripcion":"QUISTE ÓSEO DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":714149002,
    "descripcion":"ENFERMEDAD GINGIVAL ALÉRGICA CAUSADA POR CONTACTO CON MERCURIO"
  },
  {
    "codigo":419237004,
    "descripcion":"ECTOPIA DE CRISTALINO Y PUPILA"
  },
  {
    "codigo":11863961000119101,
    "descripcion":"AMPUTACIÓN PARCIAL TRAUMÁTICA DE EXTREMIDAD INFERIOR IZQUIERDA A NIVEL ENTRE RODILLA Y TOBILLO"
  },
  {
    "codigo":339711000119108,
    "descripcion":"LAGOFTALMOS PARALÍTICO DE PÁRPADO INFERIOR IZQUIERDO"
  },
  {
    "codigo":1269370000,
    "descripcion":"CRISIS EPILÉPTICA MIOCLÓNICA CON ALTERACIÓN DE CONCIENCIA DE INICIO FOCAL"
  },
  {
    "codigo":1172901009,
    "descripcion":"TRASTORNO DE LA COAGULACIÓN ASOCIADO CON UNA DEFICIENCIA DE FOSFOLIPASA A2 ALFA CITOSÓLICA"
  },
  {
    "codigo":253562005,
    "descripcion":"DEFECTO DEL TABIQUE INTERVENTRICULAR CON AUSENCIA DE TABIQUE DE SALIDA Y CABALGAMIENTO DE VÁLVULA TRONCAL"
  },
  {
    "codigo":218959000,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR PECTINA"
  },
  {
    "codigo":286330009,
    "descripcion":"DIFICULTAD PARA EMITIR VOZ"
  },
  {
    "codigo":89722009,
    "descripcion":"ÉPULIS GIGANTOCELULAR"
  },
  {
    "codigo":284495003,
    "descripcion":"CONDUCTA REFORZADA POSITIVAMENTE"
  },
  {
    "codigo":1234767007,
    "descripcion":"DUODENITIS CAUSADA POR ETANOL"
  },
  {
    "codigo":1003556001,
    "descripcion":"AGENESIA DE ESTÓMAGO"
  },
  {
    "codigo":282660005,
    "descripcion":"GOLPEA"
  },
  {
    "codigo":315428006,
    "descripcion":"NACIDO EN GABÓN"
  },
  {
    "codigo":249892007,
    "descripcion":"PARÁLISIS SEUDOBULBAR PROGRESIVA"
  },
  {
    "codigo":53284008,
    "descripcion":"INFESTACIÓN CAUSADA POR HYPODERMA LINEATUM"
  },
  {
    "codigo":15714201000119107,
    "descripcion":"DEDO DEL PIE EN GARRA ADQUIRIDO BILATERAL"
  },
  {
    "codigo":248057005,
    "descripcion":"DESCUIDO DE LA SALUD FÍSICA"
  },
  {
    "codigo":410062001,
    "descripcion":"LACERACIÓN DE VAGINA"
  },
  {
    "codigo":16846004,
    "descripcion":"ENFISEMA OBSTRUCTIVO"
  },
  {
    "codigo":1260195002,
    "descripcion":"RETRASO DE DESARROLLO, DISCAPACIDAD INTELECTUAL Y TRASTORNO DEL ESPECTRO AUTISTA ASOCIADOS A GEN GRIN2B"
  },
  {
    "codigo":80547003,
    "descripcion":"CONFIGURACIÓN DEL SOPLO CARDÍACO, CRECIENTE - DECRECIENTE"
  },
  {
    "codigo":735907005,
    "descripcion":"GOLPE DE CALOR POR EJERCICIO"
  },
  {
    "codigo":277155005,
    "descripcion":"NEOPLASIA DE OÍDO EXTERNO"
  },
  {
    "codigo":78712000,
    "descripcion":"COLITIS ULCEROSA CRÓNICA MODERADA"
  },
  {
    "codigo":275320004,
    "descripcion":"LESIÓN DE UÑA"
  },
  {
    "codigo":111480006,
    "descripcion":"DEMENCIA ORGÁNICA INDUCIDA POR SUSTANCIA PSICOACTIVA"
  },
  {
    "codigo":76877000,
    "descripcion":"LESIÓN TRAUMÁTICA DE DIAFRAGMA CON HERIDA ABIERTA HACIA CAVIDAD"
  },
  {
    "codigo":439160009,
    "descripcion":"SEUDOANEURISMA DE FÍSTULA ARTERIOVENOSA QUIRÚRGICA"
  },
  {
    "codigo":240717000,
    "descripcion":"CANDIDIASIS MUCOCUTÁNEA CRÓNICA FAMILIAR - INICIO TARDÍO"
  },
  {
    "codigo":209784008,
    "descripcion":"RUPTURA DE TENDÓN FLEXOR DEL PIE"
  },
  {
    "codigo":207949005,
    "descripcion":"FRACTURA EXPUESTA DE VÉRTEBRA DORSAL"
  },
  {
    "codigo":109645009,
    "descripcion":"SUPERERUPCIÓN DE DIENTE SIN OPOSICIÓN"
  },
  {
    "codigo":238882008,
    "descripcion":"PANICULITIS LIPOFÁGICA"
  },
  {
    "codigo":402722008,
    "descripcion":"MUCINOSIS FOCAL PRIMARIA DE LA PIEL"
  },
  {
    "codigo":342221000119104,
    "descripcion":"GLAUCOMA DE ÁNGULO AGUDO DE OJO IZQUIERDO"
  },
  {
    "codigo":105975006,
    "descripcion":"TRASTORNO DE SENO ESFENOIDAL"
  },
  {
    "codigo":7671008,
    "descripcion":"ASPERGILOSIS DISEMINADA"
  },
  {
    "codigo":202444001,
    "descripcion":"TUMOR TENOSINOVIAL DE CÉLULAS GIGANTES DIFUSO DE ARTICULACIÓN SACROILÍACA"
  },
  {
    "codigo":726732002,
    "descripcion":"DISCAPACIDAD INTELECTUAL LIGADA AL CROMOSOMA X TIPO NASCIMENTO"
  },
  {
    "codigo":237047009,
    "descripcion":"MASA TUBOVÁRICA"
  },
  {
    "codigo":366284003,
    "descripcion":"HALLAZGO RELACIONADO CON LA POSICIÓN DE TESTÍCULO"
  },
  {
    "codigo":5836005,
    "descripcion":"PERICARDITIS CONSTRICTIVA CON DERRAME SUBAGUDA"
  },
  {
    "codigo":267980005,
    "descripcion":"ESTENOSIS DE CONDUCTO RAQUÍDEO, EXCLUIDA LA REGIÓN CERVICAL"
  },
  {
    "codigo":300748005,
    "descripcion":"DIFICULTAD PARA USAR INSTALACIONES RECREATIVAS PÚBLICAS"
  },
  {
    "codigo":724897002,
    "descripcion":"LACERACIÓN DE FASCIA DEL ABDOMEN"
  },
  {
    "codigo":167841004,
    "descripcion":"OLOR DEL VÓMITO, REPULSIVO"
  },
  {
    "codigo":231542000,
    "descripcion":"TRASTORNO DE LA CONDUCTA POR DEPRESIÓN"
  },
  {
    "codigo":10637671000119102,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN EN GLÚTEO DERECHO NO ESTADIFICABLE"
  },
  {
    "codigo":428150004,
    "descripcion":"SUBLUXACIÓN NO EXPUESTA DE CABEZA DE RADIO"
  },
  {
    "codigo":460918005,
    "descripcion":"ANOMALÍA INTRATORÁCICA DEBIDA A COARTACIÓN DE LA AORTA"
  },
  {
    "codigo":34934005,
    "descripcion":"ARTRITIS PIÓGENA DE LOCALIZACIONES MÚLTIPLES"
  },
  {
    "codigo":721227001,
    "descripcion":"SÍNDROME DE CRANEOSINOSTOSIS DE HUNTER MCALPINE"
  },
  {
    "codigo":295243002,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE FENOPROFENO"
  },
  {
    "codigo":229707005,
    "descripcion":"DISPRAXIA VELOFARÍNGEA"
  },
  {
    "codigo":129568000,
    "descripcion":"PARESIA LARÍNGEA"
  },
  {
    "codigo":719392003,
    "descripcion":"CAPAZ DE COMPRENDER INSTRUCCIONES DE MÁS DE DOS PARTES"
  },
  {
    "codigo":293408004,
    "descripcion":"REACCIÓN ADVERSA AL POLIESTIRENO+SULFONATO SÓDICO"
  },
  {
    "codigo":1145376008,
    "descripcion":"HIPOPLASIA CONGÉNITA DE MÚSCULO TRÍCEPS BRAQUIAL"
  },
  {
    "codigo":160501000,
    "descripcion":"TIENE PADRASTRO"
  },
  {
    "codigo":291573003,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR CEFRADINA"
  },
  {
    "codigo":289738001,
    "descripcion":"CONTRACCIONES UTERINAS NORMALES"
  },
  {
    "codigo":1010634002,
    "descripcion":"NEUMONÍA POR ACINETOBACTER"
  },
  {
    "codigo":715722003,
    "descripcion":"BRAQUIDACTILIA TIPO A6"
  },
  {
    "codigo":224202003,
    "descripcion":"MANTIENE SU PROPIO DINERO PARA GASTAR"
  },
  {
    "codigo":124063001,
    "descripcion":"HISTIDINA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":713887002,
    "descripcion":"GLOMERULOSCLEROSIS SEGMENTARIA FOCAL CONCOMITANTE CON INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":386207004,
    "descripcion":"SÍNDROME DE DISFUNCIÓN DOLOROSA DE LA ARTICULACIÓN TEMPOROMANDIBULAR"
  },
  {
    "codigo":1172639004,
    "descripcion":"MASTITIS NEONATAL POR STAPHYLOCOCCUS EPIDERMIDIS"
  },
  {
    "codigo":286068000,
    "descripcion":"DOBLA LA ROPA LAVADA"
  },
  {
    "codigo":23924001,
    "descripcion":"SENSACIÓN DE OPRESIÓN EN EL PECHO"
  },
  {
    "codigo":417140001,
    "descripcion":"LIPOGRANULOMA ESCLEROSANTE"
  },
  {
    "codigo":56692003,
    "descripcion":"SÍNDROME DE CONDRODISPLASIA PUNTEADA RIZOMÉLICA"
  },
  {
    "codigo":449908004,
    "descripcion":"PERIODONTITIS AGRESIVA"
  },
  {
    "codigo":253300003,
    "descripcion":"DOBLE TRACTO DE SALIDA DEL VENTRÍCULO DERECHO CON DEFECTO INTERVENTRICULAR YUXTAARTERIAL DOBLE RELACIONADO"
  },
  {
    "codigo":448073002,
    "descripcion":"ANOMALÍA CONGÉNITA DE MÚSCULO PAPILAR DE VÁLVULA TRICÚSPIDE"
  },
  {
    "codigo":251465003,
    "descripcion":"COMPLEJOS PERIÓDICOS INTERMITENTES"
  },
  {
    "codigo":218697003,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR CLORFENESINA"
  },
  {
    "codigo":249630003,
    "descripcion":"MARGEN ANAL ENGROSADO"
  },
  {
    "codigo":344731000119103,
    "descripcion":"ESCOTOMA PARACENTRAL BILATERAL"
  },
  {
    "codigo":216862008,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ETILYODOACETATO"
  },
  {
    "codigo":1263603002,
    "descripcion":"TRASTORNO FETAL DEBIDO A PROCEDIMIENTO DESTRUCTIVO PARA FACILITAR EL PARTO"
  },
  {
    "codigo":247795009,
    "descripcion":"TEDIO VITAL"
  },
  {
    "codigo":1163464002,
    "descripcion":"ESQUISTOSOMIASIS HEPATOESPLÉNICA POR SCHISTOSOMA JAPONICUM"
  },
  {
    "codigo":311496007,
    "descripcion":"EXTRAVASACIÓN DE ORINA DESDE EL RIÑÓN"
  },
  {
    "codigo":213192008,
    "descripcion":"FALLA DE INJERTO DE PIEL"
  },
  {
    "codigo":1360072009,
    "descripcion":"ÁNGULO CERRADO DE AMBOS OJOS"
  },
  {
    "codigo":735645009,
    "descripcion":"CONTUSIÓN DE CRÁNEO"
  },
  {
    "codigo":897650003,
    "descripcion":"MELANOSIS ADQUIRIDA PRIMARIA DE CÓRNEA"
  },
  {
    "codigo":406130004,
    "descripcion":"INFESTACIÓN AMBIENTAL POR INSECTOS"
  },
  {
    "codigo":209522007,
    "descripcion":"ESGUINCE DE LIGAMENTO TIBIOPERONEO SUPERIOR"
  },
  {
    "codigo":109383000,
    "descripcion":"MESOTELIOMA MALIGNO DEL PERICARDIO"
  },
  {
    "codigo":15964981000119104,
    "descripcion":"ANOMALÍA CONGÉNITA DE CÁMARA CARDÍACA"
  },
  {
    "codigo":207687004,
    "descripcion":"FRACTURA NO EXPUESTA DE CALOTA CRANEAL CON LESIÓN TRAUMÁTICA INTRACRANEAL"
  },
  {
    "codigo":699207005,
    "descripcion":"ARTRITIS DE PELVIS"
  },
  {
    "codigo":402460000,
    "descripcion":"POLINEUROPATÍA AMILOIDE FAMILIAR CON AMILOIDOSIS CUTÁNEA"
  },
  {
    "codigo":238620000,
    "descripcion":"PITIRIASIS ROSADA CLÁSICA JUVENIL"
  },
  {
    "codigo":369692002,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA RADIAL PROFUNDA DE INTESTINO GRUESO, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":762908000,
    "descripcion":"AGENESIA DE RIÑÓN DERECHO"
  },
  {
    "codigo":165468981000119105,
    "descripcion":"MIOCARDIOPATÍA TÓXICA DILATADA"
  },
  {
    "codigo":240455009,
    "descripcion":"VERRUGA PERUANA"
  },
  {
    "codigo":42012007,
    "descripcion":"LIPOFUSCINOSIS CEROIDE NEURONAL"
  },
  {
    "codigo":171249001,
    "descripcion":"CRIBADO URINARIO - PENDIENTE"
  },
  {
    "codigo":72945002,
    "descripcion":"DEFICIENCIA DE CINURENINASA"
  },
  {
    "codigo":7409003,
    "descripcion":"PARÁLISIS PERIÓDICA SECUNDARIA"
  },
  {
    "codigo":105713003,
    "descripcion":"ENFERMEDAD CAUSADA POR ACANTHOCEPHALA"
  },
  {
    "codigo":1287196009,
    "descripcion":"TUMOR NEUROENDOCRINO BIEN DIFERENCIADO DE APÉNDICE"
  },
  {
    "codigo":236785007,
    "descripcion":"ESTENOSIS DE CONDUCTO DEFERENTE LUEGO DE REVERSIÓN DE VASECTOMÍA"
  },
  {
    "codigo":267718000,
    "descripcion":"DEGENERACIÓN MACULAR RELACIONADA CON LA EDAD"
  },
  {
    "codigo":202182001,
    "descripcion":"LUXACIÓN PATOLÓGICA DE ARTICULACIÓN DE LA MUÑECA"
  },
  {
    "codigo":300486000,
    "descripcion":"TESTÍCULOS DUROS"
  },
  {
    "codigo":366022009,
    "descripcion":"TOLERANCIA A LOS CAMBIOS DE LA TEMPERATURA AMBIENTE - HALLAZGO"
  },
  {
    "codigo":71110009,
    "descripcion":"HIDROCALICOSIS"
  },
  {
    "codigo":724635009,
    "descripcion":"DERMATITIS POR CONTACTO DE OÍDO EXTERNO"
  },
  {
    "codigo":427888001,
    "descripcion":"HIPERPLASIA DE HUESO CIGOMÁTICO"
  },
  {
    "codigo":65605001,
    "descripcion":"EDEMA DE LA MÉDULA ESPINAL"
  },
  {
    "codigo":1148784009,
    "descripcion":"SE SIENTE CÓMODO"
  },
  {
    "codigo":131141003,
    "descripcion":"HEMOGLOBINA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1084521000119101,
    "descripcion":"HERNIA INGUINAL IRREDUCTIBLE BILATERAL RECURRENTE OBSTRUIDA"
  },
  {
    "codigo":720965005,
    "descripcion":"ESPECIE DE LEIFSONIA AQUATICA O MICROBACTERIUM"
  },
  {
    "codigo":294981006,
    "descripcion":"ALERGIA A MORACIZINA"
  },
  {
    "codigo":360517009,
    "descripcion":"ENFERMEDAD DEL TORNEO"
  },
  {
    "codigo":31002004,
    "descripcion":"DIETA CONTROLADA EN POTASIO, SODIO Y PROTEÍNAS"
  },
  {
    "codigo":293146004,
    "descripcion":"REACCIÓN ADVERSA A LA PREDNISONA"
  },
  {
    "codigo":194842008,
    "descripcion":"ENFERMEDAD DE VASO CORONARIO ÚNICO"
  },
  {
    "codigo":94703000,
    "descripcion":"DERIVACIONES INTRACARDÍACAS MÚLTIPLES"
  },
  {
    "codigo":422383007,
    "descripcion":"TEMBLOR DE PALADAR"
  },
  {
    "codigo":92868001,
    "descripcion":"FUSIÓN ANORMAL CONGÉNITA DEL METATARSO"
  },
  {
    "codigo":191172001,
    "descripcion":"FAVISMO"
  },
  {
    "codigo":60100005,
    "descripcion":"QUISTE FARÍNGEO"
  },
  {
    "codigo":715460006,
    "descripcion":"ESCASO APEGO A CUIDADOR PRIMARIO"
  },
  {
    "codigo":125636007,
    "descripcion":"LESIÓN TRAUMÁTICA DEL INTESTINO GRUESO"
  },
  {
    "codigo":289476008,
    "descripcion":"TUMEFACCIÓN DE LABIOS DE LA VULVA"
  },
  {
    "codigo":1336217000,
    "descripcion":"HIPERTENSIÓN OCULAR DEBIDA A NEOPLASIA INTRAOCULAR DE OJO DERECHO"
  },
  {
    "codigo":254873002,
    "descripcion":"TUMOR OVÁRICO BENIGNO DE CÉLULAS GERMINALES"
  },
  {
    "codigo":347241000119107,
    "descripcion":"AMBLIOPÍA DE AMBOS OJOS"
  },
  {
    "codigo":713625005,
    "descripcion":"MENINGITIS CAUSADA POR HISTOPLASMA DUBOISII"
  },
  {
    "codigo":58265007,
    "descripcion":"GIARDIASIS"
  },
  {
    "codigo":123801008,
    "descripcion":"ESTENOSIS E INSUFICIENCIA DE UNA VÁLVULA CARDÍACA"
  },
  {
    "codigo":350091000221106,
    "descripcion":"DIARREA CAUSADA POR ESCHERICHIA COLI"
  },
  {
    "codigo":253038006,
    "descripcion":"NEVO DE CÉLULAS FUSIFORMES"
  },
  {
    "codigo":285806007,
    "descripcion":"LESIÓN TRAUMÁTICA DE CAVIDAD BUCAL, DIENTES Y GLÁNDULAS SALIVALES"
  },
  {
    "codigo":416878008,
    "descripcion":"CONJUNTIVITIS PAPILAR"
  },
  {
    "codigo":21827002,
    "descripcion":"PÓLIPO UMBILICAL"
  },
  {
    "codigo":1332547002,
    "descripcion":"ARTRITIS IDIOPÁTICA JUVENIL DE INICIO SISTÉMICO DE PIE"
  },
  {
    "codigo":283971002,
    "descripcion":"QUEMADURA DEL PERINEO FEMENINO"
  },
  {
    "codigo":447811005,
    "descripcion":"ESTENOSIS CONGÉNITA DE TRÁQUEA DEBIDA A MEMBRANA TRAQUEAL"
  },
  {
    "codigo":10970371000119105,
    "descripcion":"HERIDA ABIERTA DE PIERNA DERECHA DEBIDA A MORDEDURA DE PERRO"
  },
  {
    "codigo":87363009,
    "descripcion":"INTOXICACIÓN POR PROMAZINA"
  },
  {
    "codigo":216600000,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ADRENALINA"
  },
  {
    "codigo":708120005,
    "descripcion":"VIRUS INFLUENZA A SUBTIPO H9 PRESENTE"
  },
  {
    "codigo":413208006,
    "descripcion":"DEFORMIDAD CONSECUTIVA A ÚLCERA DE ESTRUCTURA DEL APARATO DIGESTIVO"
  },
  {
    "codigo":52760008,
    "descripcion":"HIPERCALCEMIA SECUNDARIA A ENFERMEDAD GRANULOMATOSA"
  },
  {
    "codigo":442306006,
    "descripcion":"PUPILA NO DILATADA"
  },
  {
    "codigo":212930009,
    "descripcion":"CONGELAMIENTO CON NECROSIS TISULAR DE LA MUÑECA Y MANO"
  },
  {
    "codigo":243863004,
    "descripcion":"SITUACIÓN DEL MONITOREO DE LA DEFICIENCIA DE B12"
  },
  {
    "codigo":276631005,
    "descripcion":"TETANIA HIPOCALCÉMICA NEONATAL TEMPRANA"
  },
  {
    "codigo":47255005,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DE GENITALES MASCULINOS"
  },
  {
    "codigo":440471007,
    "descripcion":"DILATACIÓN QUÍSTICA DE COLÉDOCO"
  },
  {
    "codigo":1259671005,
    "descripcion":"FÍSTULA ILEOVESICAL"
  },
  {
    "codigo":702615004,
    "descripcion":"APLASIA DE GLÁNDULA SUPRARRENAL"
  },
  {
    "codigo":793197981000119106,
    "descripcion":"NEOPLASIA CARCINOIDE MALIGNA DE PULMÓN DERECHO"
  },
  {
    "codigo":405868006,
    "descripcion":"FENOTIPO LU(A-B+)"
  },
  {
    "codigo":830017001,
    "descripcion":"QUISTE DERMOIDE DE PIEL DE DORSO"
  },
  {
    "codigo":404033003,
    "descripcion":"NEUROFIBROMA DE CORPÚSCULOS DE PACINI"
  },
  {
    "codigo":305729009,
    "descripcion":"VISTO POR UN URÓLOGO"
  },
  {
    "codigo":402198006,
    "descripcion":"DERMATITIS ATÓPICA DEL ADULTO PERSISTENTE DESDE LA INFANCIA"
  },
  {
    "codigo":236523000,
    "descripcion":"NEFRITIS TÓXICA INTERSTICIAL CRÓNICA"
  },
  {
    "codigo":271126008,
    "descripcion":"AMPOLLA TRAUMÁTICA PERINEAL"
  },
  {
    "codigo":302059000,
    "descripcion":"DIFICULTAD PARA IMITAR LOS MOVIMIENTOS DE LA LENGUA"
  },
  {
    "codigo":300224002,
    "descripcion":"AUDICIÓN DE LA VOZ FUERTE, NORMAL"
  },
  {
    "codigo":365760004,
    "descripcion":"NIVEL DE POTASIO - HALLAZGO"
  },
  {
    "codigo":15724241000119100,
    "descripcion":"TRASTORNO DE ENTESIS DE DEDO DE PIE DERECHO"
  },
  {
    "codigo":69013005,
    "descripcion":"DRASQUIASIS CUTÁNEA"
  },
  {
    "codigo":298389007,
    "descripcion":"DESGASTE DE CUELLO"
  },
  {
    "codigo":1345130001,
    "descripcion":"ALIMENTO ASPIRADO EN TRACTO RESPIRATORIO"
  },
  {
    "codigo":427626002,
    "descripcion":"EL TUMOR INVADE LA FASCIA"
  },
  {
    "codigo":722538003,
    "descripcion":"ÚLCERA TRAUMÁTICA DE INTESTINO DELGADO"
  },
  {
    "codigo":296554003,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE PIRIMETAMINA"
  },
  {
    "codigo":253704005,
    "descripcion":"ORIGEN ANÓMALO DE LA ARTERIA CORONARIA DESCENDENTE ANTERIOR IZQUIERDA EN LA ARTERIA CORONARIA DERECHA"
  },
  {
    "codigo":1148522008,
    "descripcion":"INTOXICACIÓN POR BILIS Y\/O DERIVADO BILIAR"
  },
  {
    "codigo":1179455003,
    "descripcion":"COMA MIXEDEMATOSO IATROGÉNICO"
  },
  {
    "codigo":1144852002,
    "descripcion":"ESCASO CRECIMIENTO DE VELLO CORPORAL"
  },
  {
    "codigo":192745001,
    "descripcion":"ABSCESO INTRACRANEAL TUBERCULOSO"
  },
  {
    "codigo":127209001,
    "descripcion":"LINFADENOPATÍA TIBIAL"
  },
  {
    "codigo":94441008,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL CUELLO"
  },
  {
    "codigo":92606002,
    "descripcion":"CARCINOMA IN SITU DEL PALADAR DURO"
  },
  {
    "codigo":289214004,
    "descripcion":"PRIMERA ETAPA DEL TRABAJO DE PARTO, NORMAL"
  },
  {
    "codigo":25235000,
    "descripcion":"MANOSEO"
  },
  {
    "codigo":31001000087104,
    "descripcion":"MICROBIOTA NORMAL DE LA PIEL"
  },
  {
    "codigo":254611009,
    "descripcion":"NEOPLASIA MALIGNA DE PÁNCREAS ENDOCRINO"
  },
  {
    "codigo":88936002,
    "descripcion":"DIAFRAGMA ELEVADO"
  },
  {
    "codigo":46361000087107,
    "descripcion":"DERMATITIS DE CONTACTO DE MANO DERECHA"
  },
  {
    "codigo":1137512002,
    "descripcion":"DEBILIDAD PROGRESIVA DE MÚSCULO PROXIMAL"
  },
  {
    "codigo":449384005,
    "descripcion":"DEFICIENCIA DE CADENA LIVIANA LAMBDA"
  },
  {
    "codigo":285544006,
    "descripcion":"MUEVE EL PALADAR BLANDO"
  },
  {
    "codigo":41241000087106,
    "descripcion":"HEMATOMA DE REGIÓN DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":43801000087108,
    "descripcion":"RUPTURA DE MÚSCULO GEMELO IZQUIERDO"
  },
  {
    "codigo":21565000,
    "descripcion":"LIGAMENTO ANCHO ACCESORIO"
  },
  {
    "codigo":250941001,
    "descripcion":"ESTENOSIS FIBROMUSCULAR INFUNDIBULAR DEL VENTRÍCULO DERECHO"
  },
  {
    "codigo":283709005,
    "descripcion":"MORDEDURA HUMANA EN EL PULGAR"
  },
  {
    "codigo":19730000,
    "descripcion":"CONSISTENCIA ANORMALMENTE DURA"
  },
  {
    "codigo":249106001,
    "descripcion":"PRESENTACIÓN DE HOMBRO ANTERIOR"
  },
  {
    "codigo":314642004,
    "descripcion":"DOLOR INTERMITENTE"
  },
  {
    "codigo":10838021000119103,
    "descripcion":"FRACTURA SUBCAPITAL EXPUESTA DE FÉMUR IZQUIERDO"
  },
  {
    "codigo":609554006,
    "descripcion":"SÍNDROME PARALÍTICO DE LOS CUATRO MIEMBROS"
  },
  {
    "codigo":773394007,
    "descripcion":"PAQUIGIRIA FRONTOTEMPORAL AUTOSÓMICA RECESIVA"
  },
  {
    "codigo":1363218006,
    "descripcion":"CICATRIZACIÓN DE PÁRPADO IZQUIERDO"
  },
  {
    "codigo":443879001,
    "descripcion":"RESPIRADOR CERVICAL PARCIAL LUEGO DE LARINGECTOMÍA"
  },
  {
    "codigo":707858008,
    "descripcion":"CON ALTO RIESGO DE ENFERMEDAD POR VIRUS ÉBOLA"
  },
  {
    "codigo":50663005,
    "descripcion":"ÚLCERA GASTROYEYUNAL CON HEMORRAGIA PERO SIN OBSTRUCCIÓN"
  },
  {
    "codigo":738791006,
    "descripcion":"ÚLCERA DE CUSHING DE ESTÓMAGO"
  },
  {
    "codigo":247271008,
    "descripcion":"HALLAZGO RELACIONADO CON EL YUNQUE"
  },
  {
    "codigo":16060001,
    "descripcion":"COMA HEPÁTICO DEBIDO A HEPATITIS POR VIRUS A"
  },
  {
    "codigo":214503008,
    "descripcion":"ACCIDENTE DE TRÁNSITO VEHICULAR DE TIPO NO COLISIÓN CON INTOXICACIÓN ACCIDENTAL POR GASES DE ESCAPE GENERADOS POR EL VEHÍCULO EN MOVIMIENTO"
  },
  {
    "codigo":704188007,
    "descripcion":"FRACTURA EXPUESTA DE FALANGE DISTAL DE DEDO MEDIO DE LA MANO"
  },
  {
    "codigo":1259409000,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS PRIMARIO DE BRONQUIO EN LÓBULO INFERIOR IZQUIERDO"
  },
  {
    "codigo":702353001,
    "descripcion":"ALTERACIÓN ESPECÍFICA DEL HABLA"
  },
  {
    "codigo":210833003,
    "descripcion":"LESIÓN TRAUMÁTICA CERRADA, ARTERIA HUMERAL"
  },
  {
    "codigo":276369006,
    "descripcion":"MOVIMIENTOS FETALES DISMINUIDOS"
  },
  {
    "codigo":208998003,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN SUBASTRAGALINA"
  },
  {
    "codigo":733286007,
    "descripcion":"LACERACIÓN DE TENDÓN DEL CUÁDRICEPS"
  },
  {
    "codigo":766054009,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR ADRENOCROMO"
  },
  {
    "codigo":1255739002,
    "descripcion":"ENFERMEDAD DE HODGKIN DE GANGLIOS LINFÁTICOS DE CABEZA Y CUELLO, PREDOMINIO LINFOCÍTICO-HISTIOCÍTICO"
  },
  {
    "codigo":239931003,
    "descripcion":"SÍNDROME DE SUPERPOSICIÓN DE POLIANGEÍTIS"
  },
  {
    "codigo":698683006,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: TSONGA"
  },
  {
    "codigo":205328000,
    "descripcion":"HÚMERO VARO CONGÉNITO"
  },
  {
    "codigo":238096001,
    "descripcion":"TRASTORNO DE LA VARIANTE DE APOLIPOPROTEÍNA A-I"
  },
  {
    "codigo":860688008,
    "descripcion":"EMBOLIA GASEOSA DEBIDA A EMBARAZO MOLAR Y POSTERIOR A ÉL"
  },
  {
    "codigo":74256009,
    "descripcion":"REPLICACIÓN DEL ADN"
  },
  {
    "codigo":16054431000119107,
    "descripcion":"HIPOPLASIA CONGÉNITA DE NERVIO ÓPTICO IZQUIERDO"
  },
  {
    "codigo":6885006,
    "descripcion":"CISTATIONINA GAMMA - LIASA, DEFICIENCIA"
  },
  {
    "codigo":301797007,
    "descripcion":"POLIPOSIS DUODENAL"
  },
  {
    "codigo":365498000,
    "descripcion":"HALLAZGO RELACIONADO CON APOYO PARA CUIDADOR INFORMAL"
  },
  {
    "codigo":299962001,
    "descripcion":"PRUEBA DE PHALEN NEGATIVA"
  },
  {
    "codigo":5050001,
    "descripcion":"ANGIOMA SENIL"
  },
  {
    "codigo":431034009,
    "descripcion":"DISTONÍA DE TORSIÓN"
  },
  {
    "codigo":234426009,
    "descripcion":"NEUTROFILIA INDUCIDA POR CORTICOSTEROIDES"
  },
  {
    "codigo":298127003,
    "descripcion":"DIVERTÍCULO CALICIAL ADQUIRIDO"
  },
  {
    "codigo":1380006,
    "descripcion":"AGORAFOBIA SIN ANTECEDENTES DE TRASTORNO DE PÁNICO, CON ATAQUES SINTOMÁTICOS LIMITADOS"
  },
  {
    "codigo":230756008,
    "descripcion":"HERNIA TRANSTENTORIAL"
  },
  {
    "codigo":197988009,
    "descripcion":"ORQUITIS ASOCIADA CON OTRO TRASTORNO"
  },
  {
    "codigo":196153002,
    "descripcion":"INSUFICIENCIA PULMONAR LUEGO DE UN TRAUMATISMO"
  },
  {
    "codigo":63246000,
    "descripcion":"ENFERMEDAD POR ALMACENAMIENTO DE COLESTANOL"
  },
  {
    "codigo":194318000,
    "descripcion":"PERFORACIÓN DE MEMBRANA TIMPÁNICA - MENOS DEL 50%"
  },
  {
    "codigo":292622004,
    "descripcion":"REACCIÓN ADVERSA A CREMAS CON UREA"
  },
  {
    "codigo":718606005,
    "descripcion":"HIPOPLASIA PONTOCEREBELOSA CONGÉNITA TIPO 6"
  },
  {
    "codigo":716771000,
    "descripcion":"HIPO CRÓNICO"
  },
  {
    "codigo":61411003,
    "descripcion":"INTOXICACIÓN POR CEFALOGLICINA"
  },
  {
    "codigo":94179005,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE COLON ASCENDENTE"
  },
  {
    "codigo":420024000,
    "descripcion":"OPACIFICACIÓN DE LENTE INTRAOCULAR"
  },
  {
    "codigo":126947009,
    "descripcion":"TUMOR DEL ÁNGULO PONTOCEREBELOSO"
  },
  {
    "codigo":92344000,
    "descripcion":"NEOPLASIA BENIGNA DE LA PIEL DEL ABDOMEN"
  },
  {
    "codigo":288952002,
    "descripcion":"CAPAZ DE TRAGAR LÍQUIDOS ESPESOS"
  },
  {
    "codigo":711281000124100,
    "descripcion":"SINOVITIS CRÓNICA DE RODILLA DERECHA DEBIDA A HEMARTROSIS"
  },
  {
    "codigo":26808007,
    "descripcion":"DEGENERACIÓN SINUSAL POLIPOIDE"
  },
  {
    "codigo":125112009,
    "descripcion":"MORFOLOGÍA DENTRO DE LOS LÍMITES NORMALES"
  },
  {
    "codigo":27091000119107,
    "descripcion":"TRASTORNO DE LA VÍA LAGRIMAL"
  },
  {
    "codigo":15919571000119107,
    "descripcion":"ANAFILAXIA CAUSADA POR AGENTE ANTIBACTERIANO"
  },
  {
    "codigo":682451000119107,
    "descripcion":"ASTROCITOMA PRIMARIO DE LÓBULO FRONTAL"
  },
  {
    "codigo":328301000119102,
    "descripcion":"PANCITOPENIA DEBIDA A QUIMIOTERAPIA ANTINEOPLÁSICA"
  },
  {
    "codigo":88674007,
    "descripcion":"INTOXICACIÓN CAUSADA POR VASOPRESINA"
  },
  {
    "codigo":840503000,
    "descripcion":"DUODENITIS CAUSADA POR ANCYLOSTOMA"
  },
  {
    "codigo":283447004,
    "descripcion":"HERIDA PUNZANTE EN LA CABEZA"
  },
  {
    "codigo":707596000,
    "descripcion":"CARCINOSARCOMA PRIMARIO DE PULMÓN"
  },
  {
    "codigo":447287009,
    "descripcion":"INTOXICACIÓN POR SILICONA"
  },
  {
    "codigo":248844003,
    "descripcion":"ORIFICIO DEL HIMEN"
  },
  {
    "codigo":52236005,
    "descripcion":"CARFOLOGÍA"
  },
  {
    "codigo":16466541000119106,
    "descripcion":"MELORREOSTOSIS DE COSTILLA DERECHA"
  },
  {
    "codigo":17633000,
    "descripcion":"FRACTURA NO EXPUESTA DE CINCO COSTILLAS"
  },
  {
    "codigo":314380009,
    "descripcion":"ENFERMERA CHAPERONA"
  },
  {
    "codigo":281612009,
    "descripcion":"HIPERBILIRRUBINEMIA CONJUGADA NEONATAL"
  },
  {
    "codigo":247009002,
    "descripcion":"GAS EN LA CÁMARA ANTERIOR"
  },
  {
    "codigo":1197281003,
    "descripcion":"NEOPLASIA QUÍSTICA MUCINOSA DE VÍA BILIAR EXTRAHEPÁTICA CON NEOPLASIA INTRAEPITELIAL DE BAJO GRADO"
  },
  {
    "codigo":443617006,
    "descripcion":"PROGENITOR BRINDA CUIDADO A TIEMPO PARCIAL"
  },
  {
    "codigo":703926003,
    "descripcion":"ALERGIA A FIBRA VEGETAL"
  },
  {
    "codigo":441782005,
    "descripcion":"CANTIDAD DE MOCO EN MATERIA FECAL, ANORMAL"
  },
  {
    "codigo":277942005,
    "descripcion":"TRICOBLASTOMA"
  },
  {
    "codigo":16030471000119103,
    "descripcion":"OSTEOMIELITIS SUBAGUDA DE AMBOS TOBILLOS"
  },
  {
    "codigo":210571003,
    "descripcion":"LESIÓN POR DESOLLAMIENTO DE MANO"
  },
  {
    "codigo":276107004,
    "descripcion":"ADULTERIO DE LA ESPOSA"
  },
  {
    "codigo":79499004,
    "descripcion":"DESPERSONALIZACIÓN"
  },
  {
    "codigo":308875009,
    "descripcion":"DISPLASIA DEL RECTO"
  },
  {
    "codigo":896864006,
    "descripcion":"FORMA ANCHA ANORMAL CONGÉNITA DE FALANGE MEDIA DE QUINTO DEDO DE PIE"
  },
  {
    "codigo":1290080008,
    "descripcion":"NEOPLASIA NEUROENDOCRINA DE PÁNCREAS"
  },
  {
    "codigo":1157173000,
    "descripcion":"VEJIGA URINARIA PRESENTE"
  },
  {
    "codigo":1222709003,
    "descripcion":"DIARREA SÓDICA CONGÉNITA SINDRÓMICA"
  },
  {
    "codigo":237834000,
    "descripcion":"TRASTORNO DE LA ESTATURA"
  },
  {
    "codigo":12235681000119102,
    "descripcion":"PTOSIS CONGÉNITA DE PÁRPADO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":205066006,
    "descripcion":"LUXACIÓN CONGÉNITA DE RODILLA, GRADO III"
  },
  {
    "codigo":303370007,
    "descripcion":"TIRA"
  },
  {
    "codigo":203231000,
    "descripcion":"INFECCIÓN DE FÉMUR"
  },
  {
    "codigo":1351946008,
    "descripcion":"INMUNODEFICIENCIA COMBINADA AUTOSÓMICA RECESIVA DEBIDA A MUTACIÓN DE MAN2B2"
  },
  {
    "codigo":41226008,
    "descripcion":"DOLOR AGUDÍSIMO"
  },
  {
    "codigo":301535000,
    "descripcion":"INCAPAZ DE SALIR DE LA BAÑERA"
  },
  {
    "codigo":235999009,
    "descripcion":"HEMATOMA INTRABDOMINAL"
  },
  {
    "codigo":135860001,
    "descripcion":"EXACERBACIÓN DE DORSALGIA"
  },
  {
    "codigo":168628003,
    "descripcion":"RADIOGRAFÍA SIMPLE DE CÚBITO: NORMAL"
  },
  {
    "codigo":234164004,
    "descripcion":"SÍNDROME VASOVAGAL MALIGNO"
  },
  {
    "codigo":4788002,
    "descripcion":"FRACTURA NO EXPUESTA DE HUESO CIGOMÁTICO"
  },
  {
    "codigo":365236002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA SACARSE PRÓTESIS"
  },
  {
    "codigo":68489000,
    "descripcion":"NÓDULOS VOCALES EN LOS NIÑOS"
  },
  {
    "codigo":428937001,
    "descripcion":"DEPENDENCIA DE DIÁLISIS PERITONEAL DEBIDA A ENFERMEDAD RENAL EN ETAPA TERMINAL"
  },
  {
    "codigo":232329002,
    "descripcion":"PÉRDIDA DE LA AUDICIÓN NEUROSENSORIAL ASOCIADA AL CROMOSOMA X"
  },
  {
    "codigo":37556009,
    "descripcion":"MICOSIS VERRUGOSA"
  },
  {
    "codigo":363401000,
    "descripcion":"NEOPLASIA MALIGNA DE FOSA PIRIFORME"
  },
  {
    "codigo":296030000,
    "descripcion":"SOBREDOSIS INTENCIONAL DE METIPRILÓN"
  },
  {
    "codigo":723849009,
    "descripcion":"OSTEOSARCOMA PRIMARIO DE CARTÍLAGO ARTICULAR DE MANDÍBULA"
  },
  {
    "codigo":429448005,
    "descripcion":"ANOMALÍA CONGÉNITA DE SEGMENTO ANTERIOR DEL OJO"
  },
  {
    "codigo":230494007,
    "descripcion":"APNEA ALVEOLAR DURANTE EL SUEÑO"
  },
  {
    "codigo":263262009,
    "descripcion":"SÍNDROME COMPARTIMENTAL DE MÚSCULO RECTO ABDOMINAL DEBIDO A LESIÓN TRAUMÁTICA"
  },
  {
    "codigo":425267003,
    "descripcion":"DERMATITIS PERIOCULAR"
  },
  {
    "codigo":16218291000119100,
    "descripcion":"ISQUEMIA CEREBRAL AGUDA"
  },
  {
    "codigo":16077491000119101,
    "descripcion":"CONJUNTIVITIS HEMORRÁGICA AGUDA DE OJO IZQUIERDO CAUSADA POR ENTEROVIRUS"
  },
  {
    "codigo":11817651000119101,
    "descripcion":"ESGUINCE DE LIGAMENTO DE DEDO DE MANO DERECHA"
  },
  {
    "codigo":16891571000119103,
    "descripcion":"QUISTE DE MENISCO INTERNO DE RODILLA IZQUIERDA"
  },
  {
    "codigo":16067251000119104,
    "descripcion":"ALERGIA A VEGETALES"
  },
  {
    "codigo":295091000119100,
    "descripcion":"CIERRE TARDÍO DE FONTANELA ANTERIOR"
  },
  {
    "codigo":330931000119106,
    "descripcion":"VITILIGO DE PIEL DE PÁRPADO IZQUIERDO Y REGIÓN PERIOCULAR"
  },
  {
    "codigo":307891000119107,
    "descripcion":"FÍSTULA DE ARTICULACIÓN DE PIE DERECHO"
  },
  {
    "codigo":292531000119101,
    "descripcion":"NEURALGIA DE NERVIO DE MIEMBRO INFERIOR IZQUIERDO"
  },
  {
    "codigo":123571000119104,
    "descripcion":"ERITEMA MULTIFORME MENOR"
  },
  {
    "codigo":16709811000119106,
    "descripcion":"HEMORRAGIA ESPONTÁNEA DE ESPACIO SUBARACNOIDEO DESDE ARTERIA COMUNICANTE ANTERIOR"
  },
  {
    "codigo":333491000119105,
    "descripcion":"QUISTE DE ÓRBITA DERECHA"
  },
  {
    "codigo":383350451000119103,
    "descripcion":"TOS SUBAGUDA"
  },
  {
    "codigo":305331000119107,
    "descripcion":"CONTRACTURA DE MÚSCULO DE MUSLO IZQUIERDO"
  },
  {
    "codigo":716509000,
    "descripcion":"NO UTILIZA APOYO RESPIRATORIO PARA LA VOZ"
  },
  {
    "codigo":15632051000119106,
    "descripcion":"FIBROMATOSIS DE LA FASCIA PLANTAR DEL PIE DERECHO"
  },
  {
    "codigo":1088691000119107,
    "descripcion":"LESIÓN DE OÍDO IZQUIERDO"
  },
  {
    "codigo":348851000119109,
    "descripcion":"BLEFAROFIMOSIS ADQUIRIDA DE HENDIDURA PALPEBRAL IZQUIERDA"
  },
  {
    "codigo":421597001,
    "descripcion":"POLINEUROPATÍA ASOCIADA CON SIDA"
  },
  {
    "codigo":93917007,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA CAVIDAD NASAL"
  },
  {
    "codigo":15951061000119102,
    "descripcion":"MELANOMA MALIGNO DE PIEL DE AMBAS EXTREMIDADES SUPERIORES"
  },
  {
    "codigo":126685009,
    "descripcion":"NEOPLASIA DE LA FARINGE"
  },
  {
    "codigo":290525004,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR DESFLURANO"
  },
  {
    "codigo":224989002,
    "descripcion":"RECUERDOS DOLOROSOS REPRIMIDOS"
  },
  {
    "codigo":1306333003,
    "descripcion":"GLAUCOMA DE ÁNGULO CERRADO SECUNDARIO BILATERAL"
  },
  {
    "codigo":288690005,
    "descripcion":"INCAPAZ DE ADAPTAR LA CONVERSACIÓN A UN CONTEXTO"
  },
  {
    "codigo":712839001,
    "descripcion":"ALERGIA A ALMENDRA"
  },
  {
    "codigo":1204359001,
    "descripcion":"EQUIPAMIENTO ADECUADO PARA ALMACENAMIENTO SEGURO DE ALIMENTO EN LA VIVIENDA"
  },
  {
    "codigo":188551004,
    "descripcion":"SARCOMA DE HODGKIN DE GANGLIOS LINFÁTICOS DE MÚLTIPLES LOCALIZACIONES"
  },
  {
    "codigo":1237127006,
    "descripcion":"TAQUICARDIA VENTRICULAR MONOMORFA SOSTENIDA"
  },
  {
    "codigo":416092001,
    "descripcion":"TENSIÓN LIGAMENTARIA EQUILIBRADA"
  },
  {
    "codigo":285020004,
    "descripcion":"DIFICULTAD PARA MANEJAR UN ARTEFACTO MIENTRAS SE VISTE Y DESVISTE"
  },
  {
    "codigo":16006511000119100,
    "descripcion":"ARTRITIS VIRAL DE ARTICULACIÓN DE MANO DERECHA"
  },
  {
    "codigo":874844007,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE REGIÓN INTERESCAPULAR"
  },
  {
    "codigo":88412007,
    "descripcion":"ARRITMIA DEL NÓDULO AURICULOVENTRICULAR"
  },
  {
    "codigo":1004081001,
    "descripcion":"TRASTORNO NEONATAL DEBIDO A ENFERMEDAD MATERNA"
  },
  {
    "codigo":55644006,
    "descripcion":"SUCCIÓN DEL PULGAR"
  },
  {
    "codigo":414257003,
    "descripcion":"HALLAZGO RELACIONADO CON LA RAÍZ SENSITIVA DEL SÉPTIMO NERVIO CRANEAL"
  },
  {
    "codigo":283185008,
    "descripcion":"CUERPO EXTRAÑO METÁLICO EN EL DEDO GORDO DEL PIE"
  },
  {
    "codigo":19206003,
    "descripcion":"NEURITIS ACÚSTICA SIFILÍTICA"
  },
  {
    "codigo":13241000202103,
    "descripcion":"CAPAZ DE EQUILIBRAR ACTIVIDAD Y DESCANSO"
  },
  {
    "codigo":281350007,
    "descripcion":"ARTRITIS SECUNDARIA A NEOPLASIA MALIGNA HEMATOLÓGICA"
  },
  {
    "codigo":246747007,
    "descripcion":"ESOTROPÍA INCOMITANTE"
  },
  {
    "codigo":441520002,
    "descripcion":"PORTADOR DE MUTACIÓN DE GEN DE FIBROSIS QUÍSTICA"
  },
  {
    "codigo":48304002,
    "descripcion":"MARCHA DEL GLÚTEO MAYOR"
  },
  {
    "codigo":736432009,
    "descripcion":"TRASTORNO DEGENERATIVO DEL OÍDO"
  },
  {
    "codigo":210309004,
    "descripcion":"HERIDA ABIERTA DE TROMPA DE EUSTAQUIO"
  },
  {
    "codigo":208474003,
    "descripcion":"FRACTURA EXPUESTA DE LA FALANGE DISTAL DEL PULGAR, DIÁFISIS"
  },
  {
    "codigo":77402005,
    "descripcion":"TRASTORNO DEL METABOLISMO DE LA LISINA Y\/O HIDROXILISINA"
  },
  {
    "codigo":110170006,
    "descripcion":"QUEMADURA DE LA REGIÓN PERIORBITARIA"
  },
  {
    "codigo":306778008,
    "descripcion":"DIFICULTAD PARA DEGLUTIR ALIMENTOS BLANDOS"
  },
  {
    "codigo":403247001,
    "descripcion":"PELO RUBIO CENIZA GRISÁCEO"
  },
  {
    "codigo":11310601000119104,
    "descripcion":"FRACTURA NO EXPUESTA DE TERCERA VÉRTEBRA DORSAL"
  },
  {
    "codigo":40964007,
    "descripcion":"VALVULITIS CRÓNICA"
  },
  {
    "codigo":235737001,
    "descripcion":"FÍSTULA YEYUNOCÓLICA"
  },
  {
    "codigo":301273002,
    "descripcion":"SONIDOS RESPIRATORIOS ANORMALES"
  },
  {
    "codigo":71897006,
    "descripcion":"ESTASIS VENOSO"
  },
  {
    "codigo":102830001,
    "descripcion":"DOLOR A LA PALPACIÓN EN EL ÁNGULO RENAL"
  },
  {
    "codigo":4526003,
    "descripcion":"INTOXICACIÓN POR PROBENECID"
  },
  {
    "codigo":364974006,
    "descripcion":"PATRÓN DE CONDUCCIÓN NERVIOSA - HALLAZGO"
  },
  {
    "codigo":201134009,
    "descripcion":"ALOPECIA DEL EMBARAZO"
  },
  {
    "codigo":1216942009,
    "descripcion":"VENTRICULOMEGALIA CEREBRAL CON ENFERMEDAD QUÍSTICA RENAL"
  },
  {
    "codigo":233902009,
    "descripcion":"TAQUICARDIA CONGÉNITA DEL HAZ DE HIS"
  },
  {
    "codigo":721752000,
    "descripcion":"MENINGITIS CAUSADA POR ACTINOMYCETALES"
  },
  {
    "codigo":197464001,
    "descripcion":"QUISTE Y SEUDOQUISTE PANCREÁTICO"
  },
  {
    "codigo":232067008,
    "descripcion":"DESPRENDIMIENTO DEL EPITELIO PIGMENTARIO DE LA RETINA"
  },
  {
    "codigo":295768004,
    "descripcion":"SOBREDOSIS DE AMINOGLUTETIMIDA"
  },
  {
    "codigo":230232005,
    "descripcion":"ATAXIA CEREBELOSA DE INICIO TARDÍO"
  },
  {
    "codigo":263000005,
    "descripcion":"ESGUINCE DE CÁPSULA ARTICULAR"
  },
  {
    "codigo":66392007,
    "descripcion":"BOCIO INTRATORÁCICO"
  },
  {
    "codigo":64557000,
    "descripcion":"TRASTORNO DE ÓRGANO GENITAL MASCULINO"
  },
  {
    "codigo":33624008,
    "descripcion":"HIPERIRRITABILIDAD"
  },
  {
    "codigo":228397005,
    "descripcion":"COMPARTE EL EQUIPO PARA CONSUMIR DROGA"
  },
  {
    "codigo":128258000,
    "descripcion":"HALLAZGO EN LA VENTILACIÓN"
  },
  {
    "codigo":293933008,
    "descripcion":"ALERGIA A TIETILPERAZINA"
  },
  {
    "codigo":95490000,
    "descripcion":"ANOMALÍA CONGÉNITA DE LA MEMBRANA COROIDES"
  },
  {
    "codigo":1099581000119102,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE SACO LAGRIMAL DERECHO"
  },
  {
    "codigo":689981000119103,
    "descripcion":"ÚLCERA DE PIEL CAUSADA POR CITOMEGALOVIRUS"
  },
  {
    "codigo":783618006,
    "descripcion":"SÍNDROME DE LA MOTONEURONA INFERIOR DE COMIENZO TARDÍO EN LA VIDA ADULTA"
  },
  {
    "codigo":28119000,
    "descripcion":"HIPERTENSIÓN ARTERIAL NEFRÓGENA"
  },
  {
    "codigo":423170008,
    "descripcion":"TEMOR AL ABUSO"
  },
  {
    "codigo":93655004,
    "descripcion":"MELANOMA MALIGNO DE PIEL"
  },
  {
    "codigo":880087005,
    "descripcion":"DISTENSIÓN DE MÚSCULO DE PIERNA"
  },
  {
    "codigo":290263006,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR INDOMETACINA"
  },
  {
    "codigo":26284000,
    "descripcion":"ÚLCERA DE LA BOCA"
  },
  {
    "codigo":60887008,
    "descripcion":"EMPANTANAMIENTO DE LOS TEJIDOS PERIRRECTALES"
  },
  {
    "codigo":288428000,
    "descripcion":"DIFICULTAD PARA CORTAR CON TIJERA"
  },
  {
    "codigo":714412003,
    "descripcion":"CAPAZ DE LIMPIAR AGUJAS"
  },
  {
    "codigo":15927101000119106,
    "descripcion":"LESIÓN DEL PÁRPADO INFERIOR IZQUIERDO"
  },
  {
    "codigo":253825002,
    "descripcion":"HIDROSALPINX CONGÉNITA"
  },
  {
    "codigo":89985004,
    "descripcion":"SOPLO PROTOSISTÓLICO"
  },
  {
    "codigo":188289008,
    "descripcion":"NEOPLASIA MALIGNA DEL HIPOCAMPO"
  },
  {
    "codigo":284758002,
    "descripcion":"ABOFETEARSE"
  },
  {
    "codigo":55382008,
    "descripcion":"ATEROSCLEROSIS CEREBRAL"
  },
  {
    "codigo":251990008,
    "descripcion":"LLENADO VESICAL RÁPIDO"
  },
  {
    "codigo":53547005,
    "descripcion":"ATROFIA CONCÉNTRICA"
  },
  {
    "codigo":250155008,
    "descripcion":"PUNTERA POCO PROFUNDA"
  },
  {
    "codigo":413995009,
    "descripcion":"MIOCARDIOPATÍA DILATADA POR DEFICIENCIA DE TAURINA"
  },
  {
    "codigo":84480002,
    "descripcion":"ARCADAS SECAS"
  },
  {
    "codigo":1296896002,
    "descripcion":"ARTROFITO EN ARTICULACIÓN DE DEDO DE LA MANO"
  },
  {
    "codigo":215552002,
    "descripcion":"LESIÓN PRODUCIDA POR ACCIDENTE DE EMBARCACIÓN CON COLISIÓN, OCUPANTE DE EMBARCACIÓN PEQUEÑA MOTORIZADA LESIONADO"
  },
  {
    "codigo":248320005,
    "descripcion":"PÉRDIDA DE GRASA EN LA PARTE SUPERIOR DEL CUERPO"
  },
  {
    "codigo":282923008,
    "descripcion":"DIFICULTAD PARA INCORPORARSE"
  },
  {
    "codigo":1073111000119106,
    "descripcion":"ARTRITIS ESTREPTOCÓCICA DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":1264128001,
    "descripcion":"AMPOLLA TRAUMÁTICA DE DEDO GORDO DE PIE"
  },
  {
    "codigo":335831000119107,
    "descripcion":"CATARATA POLAR SUBCAPSULAR POSTERIOR CONGÉNITA DE OJO DERECHO"
  },
  {
    "codigo":309361000119101,
    "descripcion":"NECROSIS AVASCULAR DE RADIO DERECHO"
  },
  {
    "codigo":836309005,
    "descripcion":"AGUDEZA VISUAL DE OJO DERECHO 6\/15"
  },
  {
    "codigo":443093007,
    "descripcion":"OSTEOCONDROMA"
  },
  {
    "codigo":840480881000119102,
    "descripcion":"CUERPO EXTRAÑO MAGNÉTICO RETENIDO EN CRISTALINO DE AMBOS OJOS"
  },
  {
    "codigo":15710321000119103,
    "descripcion":"ATEROSCLEROSIS DE INJERTO-PUENTE BIOLÓGICO NO AUTÓLOGO DE AMBAS EXTREMIDADES INFERIORES"
  },
  {
    "codigo":11778161000119103,
    "descripcion":"RUPTURA TRAUMÁTICA DE TENDÓN DE MÚSCULO SUBESCAPULAR DE HOMBRO DERECHO"
  },
  {
    "codigo":78975002,
    "descripcion":"HIPERTENSIÓN ARTERIAL ESENCIAL MALIGNA"
  },
  {
    "codigo":373887005,
    "descripcion":"NEGATIVO PARA LESIÓN INTRAEPITELIAL O CÁNCER"
  },
  {
    "codigo":109908000,
    "descripcion":"ANOMALÍA ADQUIRIDA DEL OÍDO EXTERNO"
  },
  {
    "codigo":11604007,
    "descripcion":"ENFERMEDAD POR LYMPHOCYSTIS"
  },
  {
    "codigo":697897003,
    "descripcion":"HIPERTENSIÓN HEREDITARIA DE ARTERIA PULMONAR"
  },
  {
    "codigo":402985003,
    "descripcion":"ACTINOMICETOMA CAUSADO POR NOCARDIA BRASILIENSIS"
  },
  {
    "codigo":42537006,
    "descripcion":"DESGARRO PERINEAL SECUNDARIO EN EL PUERPERIO"
  },
  {
    "codigo":237310000,
    "descripcion":"LESIÓN TRAUMÁTICA DE CORDÓN UMBILICAL"
  },
  {
    "codigo":239145008,
    "descripcion":"HAMARTOMA DIFUSO DEL MÚSCULO LISO"
  },
  {
    "codigo":302846007,
    "descripcion":"RABDOMIOMA"
  },
  {
    "codigo":38867000,
    "descripcion":"MUECAS NASAL Y FACIAL ASOCIADAS CON EL HABLA"
  },
  {
    "codigo":366547001,
    "descripcion":"REFLEJO AQUÍLEO - HALLAZGO"
  },
  {
    "codigo":202707000,
    "descripcion":"DISCO INTERVERTEBRAL DORSAL PROLAPSADO SIN MIELOPATÍA"
  },
  {
    "codigo":301011002,
    "descripcion":"INFECCIÓN DE VÍA URINARIA CAUSADA POR ESCHERICHIA COLI"
  },
  {
    "codigo":69800000,
    "descripcion":"HEPATITIS NEONATAL"
  },
  {
    "codigo":268243008,
    "descripcion":"HIPEREXTENSIÓN DE LA RODILLA Y ARQUEAMIENTO DE HUESO LARGO DE LA PIERNA"
  },
  {
    "codigo":4264000,
    "descripcion":"PERICORONITIS CRÓNICA"
  },
  {
    "codigo":299176004,
    "descripcion":"AMPLITUD DE ADUCCIÓN ACTIVA DEL PULGAR DISMINUIDA"
  },
  {
    "codigo":102568007,
    "descripcion":"PARESIA DE LA EXTREMIDAD INFERIOR"
  },
  {
    "codigo":233640009,
    "descripcion":"DERRAME PLEURAL FARMACÓGENO"
  },
  {
    "codigo":231805004,
    "descripcion":"ENTROPIÓN POR CICATRIZ FOCAL DE LA CONJUNTIVA"
  },
  {
    "codigo":426578000,
    "descripcion":"TRASTORNO DISFÓRICO PREMENSTRUAL EN REMISIÓN"
  },
  {
    "codigo":788861009,
    "descripcion":"AGRESIÓN DEBIDA A DEMENCIA"
  },
  {
    "codigo":338341000119103,
    "descripcion":"IRIDOCICLITIS RECURRENTE DE OJO IZQUIERDO"
  },
  {
    "codigo":66130006,
    "descripcion":"CORTOCIRCUITO DE IZQUIERDA A DERECHA"
  },
  {
    "codigo":262738006,
    "descripcion":"LESIÓN POR TRACCIÓN DE LA RAÍZ DE NERVIO ESPINAL"
  },
  {
    "codigo":721490007,
    "descripcion":"SÍNDROME DE BROWN-SEQUARD AL NIVEL DEL NOVENO SEGMENTO DORSAL"
  },
  {
    "codigo":293671002,
    "descripcion":"ALERGIA A CISAPRIDA"
  },
  {
    "codigo":129831005,
    "descripcion":"INCUMPLIMIENTO DE LOS EXÁMENES DIAGNÓSTICOS"
  },
  {
    "codigo":228135005,
    "descripcion":"EXCLUIDO DE LA ESCUELA"
  },
  {
    "codigo":1078268002,
    "descripcion":"AGENESIA DE EPÍFISIS DE FALANGE PROXIMAL DE CUARTO DEDO DE PIE"
  },
  {
    "codigo":717820003,
    "descripcion":"PEZÓN AGRIETADO ASOCIADO CON DIFICULTAD EN EL APEGO EN EL NACIMIENTO"
  },
  {
    "codigo":816124004,
    "descripcion":"EXAGERACIÓN DE REFLEJO ROTULIANO"
  },
  {
    "codigo":29692004,
    "descripcion":"DEFICIENCIA DE ENZIMA MOLIBDOFLAVOPROTEÍNA COMBINADA"
  },
  {
    "codigo":10633791000119100,
    "descripcion":"CELULITIS DE MANO IZQUIERDA"
  },
  {
    "codigo":191697001,
    "descripcion":"PSICOSIS LIMÍTROFES DE LA INFANCIA"
  },
  {
    "codigo":224465001,
    "descripcion":"CAMBIÓ LA DESCRIPCIÓN LABORAL"
  },
  {
    "codigo":715985008,
    "descripcion":"SÍNDROME DE DISPLASIA MAXILONASAL"
  },
  {
    "codigo":124326004,
    "descripcion":"DEFICIENCIA DE PIRIDOXAL CINASA"
  },
  {
    "codigo":320934008,
    "descripcion":"LESIÓN TRAUMÁTICA DEL ESÓFAGO"
  },
  {
    "codigo":1269371001,
    "descripcion":"CRISIS EPILÉPTICA HIPERQUINÉTICA DE INICIO FOCAL"
  },
  {
    "codigo":253563000,
    "descripcion":"DEFECTO DE LA PORCIÓN MUSCULAR DEL TABIQUE INTERVENTRICULAR, EN EL CONO DE ENTRADA"
  },
  {
    "codigo":24187003,
    "descripcion":"COLLAR DE STOKES"
  },
  {
    "codigo":89723004,
    "descripcion":"TIMPANITIS CRÓNICA"
  },
  {
    "codigo":251728001,
    "descripcion":"PIGMENTACIÓN DE MALLA TRABECULAR DE ÁNGULO"
  },
  {
    "codigo":1234768002,
    "descripcion":"CONDUCTA PSICÓTICA CAUSADA POR ETANOL"
  },
  {
    "codigo":284496002,
    "descripcion":"CONDUCTA REFORZADA NEGATIVAMENTE"
  },
  {
    "codigo":87888006,
    "descripcion":"CONTUSIÓN DE LA CORTEZA CEREBRAL CON HERIDA INTRACRANEAL ABIERTA"
  },
  {
    "codigo":22352007,
    "descripcion":"NEFRITIS TUBULOINTERSTICIAL AGUDA BACTERIANA"
  },
  {
    "codigo":315429003,
    "descripcion":"NACIDO EN GAMBIA"
  },
  {
    "codigo":1003557005,
    "descripcion":"AGENESIA DE ISQUION"
  },
  {
    "codigo":20517006,
    "descripcion":"CONDENSACIÓN MENTAL"
  },
  {
    "codigo":248058000,
    "descripcion":"DESCUIDO DEL CUIDADO DENTAL"
  },
  {
    "codigo":282661009,
    "descripcion":"NO GOLPEA"
  },
  {
    "codigo":18682003,
    "descripcion":"ÚLCERA DE LA TÚNICA VAGINAL"
  },
  {
    "codigo":278991002,
    "descripcion":"ENFERMEDAD POR DEPÓSITO DE ÁCIDO SIÁLICO"
  },
  {
    "codigo":410063006,
    "descripcion":"TRASTORNO CARACTERIZADO POR EXOSTOSIS MÚLTIPLES"
  },
  {
    "codigo":735908000,
    "descripcion":"HIPOTENSIÓN POSTURAL POSTERIOR A EJERCICIO"
  },
  {
    "codigo":49615009,
    "descripcion":"QUEMADURA DE PRIMER GRADO DE LA PARED ABDOMINAL"
  },
  {
    "codigo":277156006,
    "descripcion":"NEOPLASIA MALIGNA DE OÍDO EXTERNO"
  },
  {
    "codigo":15012007,
    "descripcion":"ANOMALÍA DEL GRANULOCITO POR DEFECTO INMUNOLÓGICO"
  },
  {
    "codigo":275321000,
    "descripcion":"VULVA DOLOROSA"
  },
  {
    "codigo":439161008,
    "descripcion":"HALLAZGO RELACIONADO CON EL SISTEMA VESTIBULAR"
  },
  {
    "codigo":13177009,
    "descripcion":"CELULITIS NASOFARÍNGEA"
  },
  {
    "codigo":44110002,
    "descripcion":"FIEBRE DE UGANDA S"
  },
  {
    "codigo":209785009,
    "descripcion":"RUPTURA DEL TENDÓN EXTENSOR DEL PIE"
  },
  {
    "codigo":240718005,
    "descripcion":"CANDIDIASIS MUCOCUTÁNEA LOCALIZADA CRÓNICA"
  },
  {
    "codigo":109646005,
    "descripcion":"SUPERERUPCIÓN DENTAL ASOCIADA CON OCLUSIÓN DEFECTUOSA"
  },
  {
    "codigo":207950005,
    "descripcion":"FRACTURA EXPUESTA DE VÉRTEBRA DORSAL, ESTALLIDO"
  },
  {
    "codigo":1254691000,
    "descripcion":"METÁSTASIS DE CARCINOMA ADENOIDE QUÍSTICO EN GLÁNDULA LAGRIMAL IZQUIERDA"
  },
  {
    "codigo":402723003,
    "descripcion":"MUCINOSIS CATABÓLICA SECUNDARIA DE LA PIEL"
  },
  {
    "codigo":1156387004,
    "descripcion":"QUISTE DE TÚNICA VAGINAL"
  },
  {
    "codigo":271651005,
    "descripcion":"TENSIÓN ARTERIAL ESTABLE"
  },
  {
    "codigo":238883003,
    "descripcion":"PANICULITIS HISTIOCÍTICA CITOFÁGICA"
  },
  {
    "codigo":269816001,
    "descripcion":"ERITROCITOS - NORMOBLASTOS"
  },
  {
    "codigo":237048004,
    "descripcion":"ACTINOMICOSIS DE LAS TROMPAS DE FALOPIO"
  },
  {
    "codigo":73208008,
    "descripcion":"INFESTACIÓN CAUSADA POR IXODES"
  },
  {
    "codigo":366285002,
    "descripcion":"HALLAZGO RELACIONADO CON EL TAMAÑO DEL PENE"
  },
  {
    "codigo":399053004,
    "descripcion":"HEMOCROMATOSIS IDIOPÁTICA"
  },
  {
    "codigo":726733007,
    "descripcion":"SÍNDROME DE MICRODELECIÓN DE CROMOSOMA XP22.3"
  },
  {
    "codigo":267981009,
    "descripcion":"DOLOR EN LA COLUMNA DORSAL"
  },
  {
    "codigo":298914001,
    "descripcion":"AMPLITUD DE PRONACIÓN ACTIVA DE CODO NORMAL"
  },
  {
    "codigo":167842006,
    "descripcion":"OLOR DEL VÓMITO, FÉTIDO"
  },
  {
    "codigo":724898007,
    "descripcion":"LACERACIÓN DE TENDÓN ABDOMINAL"
  },
  {
    "codigo":428151000,
    "descripcion":"FRACTURA NO EXPUESTA DE HUESO DE ARTICULACIÓN DE LA RODILLA"
  },
  {
    "codigo":297079002,
    "descripcion":"SOBREDOSIS DE HIDRALAZINA"
  },
  {
    "codigo":2167004,
    "descripcion":"HEMANGIOBLASTOMATOSIS RETINIANA"
  },
  {
    "codigo":231543005,
    "descripcion":"TRASTORNO DEL HABLA Y EL LENGUAJE"
  },
  {
    "codigo":229708000,
    "descripcion":"DISPRAXIA PALATINA"
  },
  {
    "codigo":33100004,
    "descripcion":"ENVENENAMIENTO POR BETA VULGARIS"
  },
  {
    "codigo":721228006,
    "descripcion":"ENFERMEDAD SIMILAR A HUNTINGTON TIPO 2"
  },
  {
    "codigo":295244008,
    "descripcion":"SOBREDOSIS INTENCIONAL DE FENOPROFENO"
  },
  {
    "codigo":1145377004,
    "descripcion":"HIPOPLASIA CONGÉNITA DE MÚSCULO DE EXTREMIDAD"
  },
  {
    "codigo":293409007,
    "descripcion":"REACCIÓN ADVERSA AL POTASIO"
  },
  {
    "codigo":31265008,
    "descripcion":"SIGNO DEL PULGAR DE STEINBERG"
  },
  {
    "codigo":424481009,
    "descripcion":"DESARROLLO DEL LENGUAJE - BALBUCEA SONIDOS REDUPLICADOS"
  },
  {
    "codigo":94966002,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA NARIZ"
  },
  {
    "codigo":719393008,
    "descripcion":"UTILIZA FOTOGRAFÍAS PARA LA COMUNICACIÓN"
  },
  {
    "codigo":195105007,
    "descripcion":"ARRITMIA VENTRICULAR POR REENTRADA"
  },
  {
    "codigo":62198004,
    "descripcion":"SÍNDROME DE ESTASIS DEL INTESTINO DELGADO"
  },
  {
    "codigo":783094006,
    "descripcion":"PARAPLEJÍA ESPÁSTICA AUTOSÓMICA RECESIVA TIPO 14"
  },
  {
    "codigo":160502007,
    "descripcion":"ES HIJASTRO"
  },
  {
    "codigo":1010635001,
    "descripcion":"NEOPLASIA DE CORDÓN UMBILICAL"
  },
  {
    "codigo":291574009,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR CEFRADINA"
  },
  {
    "codigo":11838631000119104,
    "descripcion":"LACERACIÓN DE MÚSCULO INTRÍNSECO DE PULGAR DERECHO"
  },
  {
    "codigo":420811004,
    "descripcion":"INFECCIÓN CAUSADA POR MANSONELLA PERSTANS"
  },
  {
    "codigo":715723008,
    "descripcion":"SINDACTILIA TIPO 1"
  },
  {
    "codigo":289739009,
    "descripcion":"PROBLEMA DE LAS CONTRACCIONES UTERINAS"
  },
  {
    "codigo":91296001,
    "descripcion":"FRACTURA EXPUESTA DEL ANTEBRAZO"
  },
  {
    "codigo":93131008,
    "descripcion":"LEPTOCEFALIA"
  },
  {
    "codigo":1172640002,
    "descripcion":"DIVERTICULITIS DE COLON DESCENDENTE"
  },
  {
    "codigo":255136005,
    "descripcion":"CARCINOMA IN SITU DE LA MUCOSA LABIAL SUPERIOR"
  },
  {
    "codigo":124064007,
    "descripcion":"HISTIDINA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":89461002,
    "descripcion":"MIOCARDIOPATÍA PRIMARIA"
  },
  {
    "codigo":1080641000119101,
    "descripcion":"LIPOMA DE MIEMBRO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":253301004,
    "descripcion":"DOBLE TRACTO DE SALIDA A PARTIR DE UN VENTRÍCULO DE MORFOLOGÍA INDETERMINADA"
  },
  {
    "codigo":449909007,
    "descripcion":"FLACIDEZ DE MÚSCULO DE MIEMBRO INFERIOR"
  },
  {
    "codigo":15681000119102,
    "descripcion":"DESGARRO DE RETINA SIN DESPRENDIMIENTO"
  },
  {
    "codigo":286069008,
    "descripcion":"NO DOBLA LA ROPA LAVADA"
  },
  {
    "codigo":251466002,
    "descripcion":"ONDAS TRIFÁSICAS"
  },
  {
    "codigo":22090007,
    "descripcion":"MARCHA EN TIJERAS"
  },
  {
    "codigo":218698008,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR MEFENESINA"
  },
  {
    "codigo":1003295001,
    "descripcion":"CLINODACTILIA CONGÉNITA DE DEDO ÍNDICE"
  },
  {
    "codigo":448074008,
    "descripcion":"ANOMALÍA DE EBSTEIN CON ESTENOSIS TRICUSPÍDEA FUNCIONAL"
  },
  {
    "codigo":249631004,
    "descripcion":"DEFECTO DEL MARGEN ANAL"
  },
  {
    "codigo":83956003,
    "descripcion":"JUEGO SEXUAL CON UN COMPAÑERO"
  },
  {
    "codigo":247796005,
    "descripcion":"PÉRDIDA DE LA CAPACIDAD PARA EL DISFRUTE"
  },
  {
    "codigo":1263604008,
    "descripcion":"TRASTORNO NEONATAL PRECOZ DEBIDO A PROCEDIMIENTO DESTRUCTIVO PARA FACILITAR PARTO"
  },
  {
    "codigo":1163465001,
    "descripcion":"DACRIOADENITIS POR HERPES ZÓSTER"
  },
  {
    "codigo":213193003,
    "descripcion":"FALLA DE COLGAJO"
  },
  {
    "codigo":311497003,
    "descripcion":"TESTÍCULO AUSENTE ADQUIRIDO"
  },
  {
    "codigo":16585004,
    "descripcion":"MANO EN PALA CONGÉNITA"
  },
  {
    "codigo":16235841000119109,
    "descripcion":"ENTROPIÓN CICATRIZAL DE PÁRPADOS DE AMBOS OJOS"
  },
  {
    "codigo":735646005,
    "descripcion":"LESIÓN TRAUMÁTICA DE AMBOS NERVIOS ÓPTICOS"
  },
  {
    "codigo":47518006,
    "descripcion":"ESCOLIOSIS CAUSADA POR RADIACIÓN"
  },
  {
    "codigo":211358006,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO, EN LA CADERA"
  },
  {
    "codigo":406131000,
    "descripcion":"ELIMINACIÓN DE RESIDUOS INADECUADA"
  },
  {
    "codigo":307827002,
    "descripcion":"ESTADO DE REGISTRO"
  },
  {
    "codigo":699208000,
    "descripcion":"TROMBOCITOPENIA CAUSADA POR ALCOHOL"
  },
  {
    "codigo":76616003,
    "descripcion":"TRASTORNO DE GANGLIO LINFÁTICO"
  },
  {
    "codigo":830280003,
    "descripcion":"SOBREDOSIS DE INHIBIDOR DE ALDEHÍDO DESHIDROGENASA"
  },
  {
    "codigo":240456005,
    "descripcion":"BARTONELOSIS MILIAR"
  },
  {
    "codigo":109384006,
    "descripcion":"NEOPLASIA MALIGNA SUPERPUESTA DE CORAZÓN, MEDIASTINO Y PLEURA"
  },
  {
    "codigo":1287197000,
    "descripcion":"TUMOR NEUROENDOCRINO BIEN DIFERENCIADO PRIMARIO DE TIMO"
  },
  {
    "codigo":238621001,
    "descripcion":"PITIRIASIS ROSADA JUVENIL LOCALIZADA"
  },
  {
    "codigo":74781006,
    "descripcion":"CERTIFICADO DE INGRESO HOSPITALARIO APROBADO"
  },
  {
    "codigo":369693007,
    "descripcion":"MARGEN LATERAL DE RESECCIÓN QUIRÚRGICA DE RECTO, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":9245008,
    "descripcion":"QUISTE DENTÍGERO"
  },
  {
    "codigo":171250001,
    "descripcion":"CRIBADO EN ORINA: NORMAL"
  },
  {
    "codigo":762909008,
    "descripcion":"AGENESIA DE RIÑÓN IZQUIERDO CONCOMITANTE CON HIPOPLASIA DE RIÑÓN DERECHO"
  },
  {
    "codigo":302322006,
    "descripcion":"DIETA SIN HUEVO"
  },
  {
    "codigo":38343000,
    "descripcion":"DOLOR EN LA VAGINA"
  },
  {
    "codigo":105714009,
    "descripcion":"ENFERMEDAD CAUSADA POR ANNELIDA"
  },
  {
    "codigo":40178009,
    "descripcion":"URTICARIA ALÉRGICA"
  },
  {
    "codigo":234951001,
    "descripcion":"AUSENCIA DE DESARROLLO DE DIENTE"
  },
  {
    "codigo":366023004,
    "descripcion":"REACCIÓN DE LA PUPILA A LA LUZ - HALLAZGO"
  },
  {
    "codigo":236786008,
    "descripcion":"INFECCIÓN DEL CORDÓN ESPERMÁTICO"
  },
  {
    "codigo":202183006,
    "descripcion":"LUXACIÓN PATOLÓGICA DE LA PRIMERA ARTICULACIÓN CARPOMETACARPIANA"
  },
  {
    "codigo":71111008,
    "descripcion":"GLAUCOMA DE LA NIÑEZ"
  },
  {
    "codigo":300487009,
    "descripcion":"TESTÍCULO SITUADO EN FORMA TRANSVERSAL"
  },
  {
    "codigo":429724002,
    "descripcion":"COMPLICACIÓN IATROGÉNICA DE CIRUGÍA VASCULAR"
  },
  {
    "codigo":298652002,
    "descripcion":"AMPLITUD DE ROTACIÓN PASIVA HACIA LA DERECHA DE LA COLUMNA LUMBAR NORMAL"
  },
  {
    "codigo":724636005,
    "descripcion":"PÉRDIDA DE LA AUDICIÓN IDIOPÁTICA SÚBITA"
  },
  {
    "codigo":15992591000119101,
    "descripcion":"QUERATITIS INTERSTICIAL DE OJO IZQUIERDO CAUSADA POR VIRUS HERPES SIMPLE"
  },
  {
    "codigo":1148785005,
    "descripcion":"BUEN VÍNCULO NIÑO-CUIDADOR"
  },
  {
    "codigo":427889009,
    "descripcion":"HIPERTENSIÓN ASOCIADA CON TRASPLANTE"
  },
  {
    "codigo":294982004,
    "descripcion":"ALERGIA A PROCAINAMIDA"
  },
  {
    "codigo":32838008,
    "descripcion":"ASTERIXIS"
  },
  {
    "codigo":194843003,
    "descripcion":"ENFERMEDAD DE DOS VASOS CORONARIOS"
  },
  {
    "codigo":293147008,
    "descripcion":"REACCIÓN ADVERSA A LA FLUOROMETOLONA"
  },
  {
    "codigo":94704006,
    "descripcion":"MIELOMA MÚLTIPLE EN REMISIÓN"
  },
  {
    "codigo":1208816008,
    "descripcion":"OBSTRUCCIÓN ARTERIAL DEBIDA A EMBOLIA TROMBÓTICA DE ANEURISMA DE ARTERIA POPLÍTEA"
  },
  {
    "codigo":125637003,
    "descripcion":"LESIÓN TRAUMÁTICA DEL ÚTERO"
  },
  {
    "codigo":289477004,
    "descripcion":"MASA EN LA VULVA"
  },
  {
    "codigo":11788201000119101,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE DEDO DE MANO DERECHA"
  },
  {
    "codigo":15720361000119101,
    "descripcion":"TRASTORNO DE CARTÍLAGO ARTICULAR DE MANO IZQUIERDA"
  },
  {
    "codigo":420549007,
    "descripcion":"ENFERMEDAD DE GLÁNDULA SALIVAL CON SIDA"
  },
  {
    "codigo":92869009,
    "descripcion":"FUSIÓN ANORMAL CONGÉNITA DE HUESO NASAL"
  },
  {
    "codigo":1336218005,
    "descripcion":"HIPERTENSIÓN OCULAR DEBIDA A NEOPLASIA INTRAOCULAR DE AMBOS OJOS"
  },
  {
    "codigo":713626006,
    "descripcion":"MENINGITIS CAUSADA POR HISTOPLASMOSIS"
  },
  {
    "codigo":416879000,
    "descripcion":"ESCLERITIS DEBIDA A GRANULOMATOSIS DE WEGENER CON POLIANGEÍTIS"
  },
  {
    "codigo":254874008,
    "descripcion":"DISGERMINOMA MALIGNO DE OVARIO"
  },
  {
    "codigo":285807003,
    "descripcion":"LESIÓN TRAUMÁTICA DE CONDUCTO ANAL"
  },
  {
    "codigo":89199004,
    "descripcion":"MEMBRANA DE ESÓFAGO CONGÉNITA"
  },
  {
    "codigo":447812003,
    "descripcion":"VENA CAVA SUPERIOR IZQUIERDA PERSISTENTE CON DESEMBOCADURA EN AURÍCULA DERECHA Y AURÍCULA IZQUIERDA"
  },
  {
    "codigo":1332548007,
    "descripcion":"ARTRITIS IDIOPÁTICA JUVENIL DE INICIO SISTÉMICO DE MANO"
  },
  {
    "codigo":283972009,
    "descripcion":"QUEMADURA DEL PERINEO MASCULINO"
  },
  {
    "codigo":216601001,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR NOREPINEFRINA"
  },
  {
    "codigo":249369003,
    "descripcion":"CATARRO SINUSAL"
  },
  {
    "codigo":708121009,
    "descripcion":"ENFERMEDAD DE VÁLVULA MITRAL DE ETIOLOGÍA NO REUMÁTICA"
  },
  {
    "codigo":12115881000119109,
    "descripcion":"QUEMADURA QUÍMICA DE CUERO CABELLUDO"
  },
  {
    "codigo":278467003,
    "descripcion":"NISTAGMO POR POSICIÓN DEL CUELLO"
  },
  {
    "codigo":704451004,
    "descripcion":"FRACTURA NO EXPUESTA TRANSVERSAL DE ACETÁBULO"
  },
  {
    "codigo":212931008,
    "descripcion":"CONGELAMIENTO CON NECROSIS TISULAR DE LA CADERA Y EL MUSLO"
  },
  {
    "codigo":14488001,
    "descripcion":"VAGINITIS DEBIDA A RADIOTERAPIA Y POSTERIOR A ELLA"
  },
  {
    "codigo":737219008,
    "descripcion":"APLASIA DE RÓTULA"
  },
  {
    "codigo":276632003,
    "descripcion":"TETANIA HIPOMAGNESÉMICA EN EL RECIÉN NACIDO"
  },
  {
    "codigo":1259672003,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE PRÓSTATA"
  },
  {
    "codigo":243864005,
    "descripcion":"SITUACIÓN DEL MONITOREO DE TRASTORNO HEMATOLÓGICO"
  },
  {
    "codigo":47256006,
    "descripcion":"INFECCIÓN CAUSADA POR STREPTOCOCCUS SUIS"
  },
  {
    "codigo":702616003,
    "descripcion":"APLASIA DE CORDÓN ESPERMÁTICO"
  },
  {
    "codigo":209261000,
    "descripcion":"FRACTURA-SUBLUXACIÓN EXPUESTA DE ARTICULACIÓN DE CODO"
  },
  {
    "codigo":292931000119107,
    "descripcion":"GRANULOMA SUBDURAL INTRAESPINAL"
  },
  {
    "codigo":405869003,
    "descripcion":"FENOTIPO LU(A+B+)"
  },
  {
    "codigo":45421006,
    "descripcion":"INTOXICACIÓN POR ANFETAMINA"
  },
  {
    "codigo":242029008,
    "descripcion":"EFECTOS DE LA FUERZA CENTRÍFUGA"
  },
  {
    "codigo":240194000,
    "descripcion":"TRASTORNO DE CONTINUIDAD DE HUESO"
  },
  {
    "codigo":12653009,
    "descripcion":"ESTERILIDAD DISPERMATOGÉNICA"
  },
  {
    "codigo":305730004,
    "descripcion":"VISTO POR UN CIRUJANO VASCULAR"
  },
  {
    "codigo":698946008,
    "descripcion":"CICLOTIMIA EN REMISIÓN"
  },
  {
    "codigo":762647001,
    "descripcion":"COLOR DE LENGUA NORMAL"
  },
  {
    "codigo":404034009,
    "descripcion":"MIXOMA DÉRMICO DE LA VAINA NERVIOSA"
  },
  {
    "codigo":402199003,
    "descripcion":"DERMATITIS ATÓPICA DEL ADULTO RECURRENTE EN LA VIDA ADULTA"
  },
  {
    "codigo":10818008,
    "descripcion":"POSICIÓN ANÓMALA CONGÉNITA DEL CORAZÓN"
  },
  {
    "codigo":271127004,
    "descripcion":"AMPOLLA TRAUMÁTICA DEL PENE"
  },
  {
    "codigo":860951008,
    "descripcion":"ANOMALÍA CONGÉNITA DE COLA DE CABALLO"
  },
  {
    "codigo":1170355009,
    "descripcion":"EXFOLIACIÓN DENTAL PRECOZ GENERALIZADA DEBIDA A ENFERMEDAD SISTÉMICA"
  },
  {
    "codigo":302060005,
    "descripcion":"GANGLIO LINFÁTICO Y VASOS LINFÁTICOS - HALLAZGO"
  },
  {
    "codigo":236524006,
    "descripcion":"NEFRITIS AGUDA POR RADIACIÓN"
  },
  {
    "codigo":1186796006,
    "descripcion":"NEUROPATÍA ÓPTICA DEBIDA A DEFICIENCIA DE MICRONUTRIENTES"
  },
  {
    "codigo":365761000,
    "descripcion":"NIVEL DE SODIO - HALLAZGO"
  },
  {
    "codigo":300225001,
    "descripcion":"AUDICIÓN DE LA VOZ FUERTE, ALTERADA"
  },
  {
    "codigo":70849001,
    "descripcion":"CONFLICTO CON UN NIÑO ADOPTADO O CON PADRE SUSTITUTO"
  },
  {
    "codigo":722119031000119100,
    "descripcion":"CARCINOMA PRIMARIO DE CÉLULAS ESCAMOSAS DE PIEL DE PIE IZQUIERDO"
  },
  {
    "codigo":15749341000119107,
    "descripcion":"DOLOR EN AMBOS BRAZOS"
  },
  {
    "codigo":5313005,
    "descripcion":"ALTERACIÓN DE CUERNO POSTERIOR DE MENISCO INTERNO"
  },
  {
    "codigo":201921009,
    "descripcion":"ENFERMEDAD DE KASHIN-BECK DE REGIÓN DE HOMBRO"
  },
  {
    "codigo":265622002,
    "descripcion":"TRASTORNO DEL EQUILIBRIO, NERVIO VESTIBULAR"
  },
  {
    "codigo":298390003,
    "descripcion":"DEFORMIDAD DEL CUELLO"
  },
  {
    "codigo":167318003,
    "descripcion":"PRUEBA DE BACTERIAS EN ORINA: NEGATIVA"
  },
  {
    "codigo":234689009,
    "descripcion":"PANCREATITIS RECIDIVANTE"
  },
  {
    "codigo":36246001,
    "descripcion":"ÚLCERA GÁSTRICA CRÓNICA PERFORADA PERO SIN OBSTRUCCIÓN"
  },
  {
    "codigo":198251001,
    "descripcion":"ENDOMETRIOSIS DE PERITONEO PÉLVICO"
  },
  {
    "codigo":1345131002,
    "descripcion":"ABSORCIOMETRÍA DUAL POR RAYOS X DE HUESO DE VÉRTEBRA LUMBAR NORMAL"
  },
  {
    "codigo":296555002,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE PIRIMETAMINA"
  },
  {
    "codigo":427627006,
    "descripcion":"VIRILIZACIÓN MATERNA POR DEFICIENCIA DE AROMATASA PLACENTARIA"
  },
  {
    "codigo":722539006,
    "descripcion":"ENTERITIS DE INTESTINO DELGADO DEBIDA A TRAUMATISMO"
  },
  {
    "codigo":10643831000119105,
    "descripcion":"ÚLCERA VARICOSA DE TALÓN IZQUIERDO"
  },
  {
    "codigo":1179456002,
    "descripcion":"ESOFAGITIS POR VIRUS DE LA VARICELA ZÓSTER"
  },
  {
    "codigo":196416002,
    "descripcion":"MOLARES IMPACTADOS"
  },
  {
    "codigo":294720004,
    "descripcion":"ALERGIA A INSULINA ISÓFANA"
  },
  {
    "codigo":550376571000132101,
    "descripcion":"ESTRECHEZ DE YEYUNO"
  },
  {
    "codigo":292885002,
    "descripcion":"REACCIÓN ADVERSA A LA NOXITIOLINA"
  },
  {
    "codigo":129045003,
    "descripcion":"ASISTENCIA PARA LA HIGIENE"
  },
  {
    "codigo":1144853007,
    "descripcion":"ESCASO CRECIMIENTO DE VELLO FACIAL"
  },
  {
    "codigo":291050000,
    "descripcion":"INTOXICACIÓN POR ALPRAZOLAM"
  },
  {
    "codigo":94442001,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL SISTEMA NERVIOSO"
  },
  {
    "codigo":225514004,
    "descripcion":"PAREJA SEXUAL DE OTRA GENERACIÓN"
  },
  {
    "codigo":127210006,
    "descripcion":"LINFADENOPATÍA TIBIAL POSTERIOR"
  },
  {
    "codigo":422122008,
    "descripcion":"PÉRDIDA CUTÁNEA QUE EXPONE MÚSCULO O HUESO"
  },
  {
    "codigo":289215003,
    "descripcion":"PROBLEMA EN LA PRIMERA ETAPA DEL TRABAJO DE PARTO"
  },
  {
    "codigo":92607006,
    "descripcion":"CARCINOMA IN SITU DE LA CABEZA DEL PÁNCREAS"
  },
  {
    "codigo":254612002,
    "descripcion":"CARCINOMA DEL PÁNCREAS ENDOCRINO"
  },
  {
    "codigo":1303188004,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO DE REGIÓN INGUINAL"
  },
  {
    "codigo":131601000119106,
    "descripcion":"STENT RECUBIERTO CON MEDICACIÓN EN RAMA DESCENDENTE ANTERIOR DE ARTERIA CORONARIA IZQUIERDA"
  },
  {
    "codigo":56169002,
    "descripcion":"SANGRADO INTERCURRENTE"
  },
  {
    "codigo":449385006,
    "descripcion":"DEFECTO CONFLUENTE DE LA PORCIÓN MUSCULAR DEL TABIQUE INTERVENTRICULAR"
  },
  {
    "codigo":1137513007,
    "descripcion":"DEBILIDAD DE MÚSCULO ESCAPULOPERONEO"
  },
  {
    "codigo":283710000,
    "descripcion":"MORDEDURA HUMANA EN EL TRONCO"
  },
  {
    "codigo":285545007,
    "descripcion":"NO MUEVE EL PALADAR BLANDO"
  },
  {
    "codigo":250942008,
    "descripcion":"ESTENOSIS MUSCULAR INFUNDIBULAR DEL VENTRÍCULO DERECHO"
  },
  {
    "codigo":1363219003,
    "descripcion":"CICATRIZACIÓN DE PÁRPADO DERECHO"
  },
  {
    "codigo":11819691000119104,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA ANTERIOR DE ARTICULACIÓN ESCAPULOHUMERAL IZQUIERDA"
  },
  {
    "codigo":249107005,
    "descripcion":"POSICIÓN DERECHA ANTERIOR DE HOMBRO"
  },
  {
    "codigo":609555007,
    "descripcion":"INSUFICIENCIA CARDÍACA DIASTÓLICA, ESTADIO A"
  },
  {
    "codigo":773395008,
    "descripcion":"ENCEFALITIS LÍMBICA CON ANTICUERPOS DIPEPTIDIL-PEPTIDASA 6"
  },
  {
    "codigo":314643009,
    "descripcion":"PERÍMETRO CEFÁLICO DEL NIÑO: : < PERCENTILO 0,4"
  },
  {
    "codigo":247272001,
    "descripcion":"YUNQUE AUSENTE"
  },
  {
    "codigo":47091000087104,
    "descripcion":"FRACTURA CONMINUTA DE RÓTULA DERECHA"
  },
  {
    "codigo":738792004,
    "descripcion":"ÚLCERA DE CUSHING DE ESÓFAGO"
  },
  {
    "codigo":41971000087109,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE DEDO ÍNDICE IZQUIERDO"
  },
  {
    "codigo":214504002,
    "descripcion":"ACCIDENTE DE TRÁNSITO VEHICULAR DE TIPO NO COLISIÓN CON INTOXICACIÓN ACCIDENTAL POR GASES DE ESCAPE GENERADOS POR EL VEHÍCULO EN MOVIMIENTO, CONDUCTOR DEL VEHÍCULO HERIDO"
  },
  {
    "codigo":16061002,
    "descripcion":"ENDOFLEBITIS DE SENO VENOSO LATERAL"
  },
  {
    "codigo":704189004,
    "descripcion":"FRACTURA EXPUESTA DE FALANGE DISTAL DE DEDO ANULAR"
  },
  {
    "codigo":472978005,
    "descripcion":"FÍSTULA OROCUTÁNEA"
  },
  {
    "codigo":1259410005,
    "descripcion":"CARCINOMA ESCAMOSO BRONQUIAL PRIMARIO EN LÓBULO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":702354007,
    "descripcion":"SÍNDROME DE CHRISTIANSON"
  },
  {
    "codigo":210834009,
    "descripcion":"LESIÓN TRAUMÁTICA ABIERTA, ARTERIA HUMERAL"
  },
  {
    "codigo":733287003,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA A LA ALTURA DE LA CADERA DERECHA"
  },
  {
    "codigo":274535006,
    "descripcion":"HALLAZGOS ANORMALES EN IMÁGENES DIAGNÓSTICAS DE CABEZA Y CRÁNEO"
  },
  {
    "codigo":698684000,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: TSWANA"
  },
  {
    "codigo":403772000,
    "descripcion":"SÍNDROME DE FISURA PALATINA CON SINEQUIAS LATERALES"
  },
  {
    "codigo":305468001,
    "descripcion":"BAJO ATENCIÓN DE ESPECIALISTA EN CUIDADOS INTENSIVOS PEDIÁTRICOS"
  },
  {
    "codigo":76092003,
    "descripcion":"PENFIGOIDE BENIGNO DE MEMBRANA MUCOSA CON COMPROMISO OCULAR"
  },
  {
    "codigo":239932005,
    "descripcion":"GLOMERULONEFRITIS PAUCINMUNITARIA PRIMARIA NECROSANTE Y SEMILUNAR"
  },
  {
    "codigo":371004008,
    "descripcion":"RUPTURA DE NEOPLASIA"
  },
  {
    "codigo":74257000,
    "descripcion":"RETRASO DEL DESARROLLO POR A DESNUTRICIÓN PROTEICO - CALÓRICA"
  },
  {
    "codigo":860689000,
    "descripcion":"EMBOLIA GASEOSA DEBIDA A EMBARAZO ECTÓPICO Y POSTERIOR A ÉL"
  },
  {
    "codigo":1110101000000106,
    "descripcion":"HIPERTENSIÓN OCULAR SECUNDARIA DEBIDA A SÍNDROME DE DISPERSIÓN PIGMENTARIA"
  },
  {
    "codigo":238097005,
    "descripcion":"VARIANTE APO A-I MILANO"
  },
  {
    "codigo":205329008,
    "descripcion":"SINOSTOSIS HUMERORRADIAL"
  },
  {
    "codigo":16026591000119103,
    "descripcion":"SÍNDROME AURICULOTEMPORAL DE NERVIO AURICULOTEMPORAL DERECHO"
  },
  {
    "codigo":234427000,
    "descripcion":"TRASTORNO MONOCITOIDE"
  },
  {
    "codigo":400102008,
    "descripcion":"LIPOBLASTOMA"
  },
  {
    "codigo":5051002,
    "descripcion":"ANOMALÍA DEL PAR DE CROMOSOMAS 9"
  },
  {
    "codigo":37819008,
    "descripcion":"HOMOLOGÍA DE SECUENCIA GENÉTICA"
  },
  {
    "codigo":365499008,
    "descripcion":"HALLAZGO RELACIONADO CON MEDIO DE TRANSPORTE DE CUIDADOR"
  },
  {
    "codigo":35984006,
    "descripcion":"TUBERCULOSIS DE LA COLUMNA VERTEBRAL"
  },
  {
    "codigo":134288007,
    "descripcion":"VÍA VENOSA CENTRAL BLOQUEADA"
  },
  {
    "codigo":298128008,
    "descripcion":"VERRUGA PERINEAL"
  },
  {
    "codigo":429200006,
    "descripcion":"HERNIA INGUINAL CONGÉNITA"
  },
  {
    "codigo":230757004,
    "descripcion":"HERNIA TRANSTENTORIAL DESCENDENTE"
  },
  {
    "codigo":427365005,
    "descripcion":"DOLOR IRRADIADO AL CENTRO DEL PECHO"
  },
  {
    "codigo":65082000,
    "descripcion":"CÁLCULO DE CONDUCTO CÍSTICO"
  },
  {
    "codigo":294458001,
    "descripcion":"ALERGIA A MEBENDAZOL"
  },
  {
    "codigo":718607001,
    "descripcion":"HIPOPLASIA PONTOCEREBELOSA CONGÉNITA TIPO 5"
  },
  {
    "codigo":1090681000119105,
    "descripcion":"OTITIS MEDIA MUCOIDE AGUDA DE OÍDO DERECHO"
  },
  {
    "codigo":63247009,
    "descripcion":"SÍNDROME DE WILLIAMS"
  },
  {
    "codigo":292623009,
    "descripcion":"REACCIÓN ADVERSA A ADITIVOS EMOLIENTES PARA EL BAÑO"
  },
  {
    "codigo":126948004,
    "descripcion":"MENINGIOMA DEL ÁNGULO PONTOCEREBELOSO"
  },
  {
    "codigo":716772007,
    "descripcion":"LIPOMATOSIS MESOSOMATOSA DE ROCH-LERI"
  },
  {
    "codigo":94180008,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA AXILA"
  },
  {
    "codigo":420025004,
    "descripcion":"LESIÓN TRAUMÁTICA NO ACCIDENTAL"
  },
  {
    "codigo":92345004,
    "descripcion":"NEOPLASIA BENIGNA DE PIEL DE TOBILLO"
  },
  {
    "codigo":125113004,
    "descripcion":"HISTOMORFOLOGÍA NORMAL SEGÚN EL EXAMEN MACROSCÓPICO"
  },
  {
    "codigo":288953007,
    "descripcion":"INCAPAZ DE DEGLUTIR LÍQUIDOS ESPESOS"
  },
  {
    "codigo":287118004,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN PIERNA"
  },
  {
    "codigo":24974008,
    "descripcion":"MIELOCATEXIS"
  },
  {
    "codigo":55907008,
    "descripcion":"ANEMIA APLÁSICA ADQUIRIDA"
  },
  {
    "codigo":449123008,
    "descripcion":"APERTURA EXCÉNTRICA DE VÁLVULA AÓRTICA TRICÚSPIDE"
  },
  {
    "codigo":447288004,
    "descripcion":"INTOXICACIÓN POR MANGANESO"
  },
  {
    "codigo":1332024006,
    "descripcion":"OSTEÓLISIS DE PIE"
  },
  {
    "codigo":840504006,
    "descripcion":"DUODENITIS CAUSADA POR CYTOMEGALOVIRUS"
  },
  {
    "codigo":54072008,
    "descripcion":"ENDOCARDIOSIS VERRUGOSA ABACTERIANA"
  },
  {
    "codigo":283448009,
    "descripcion":"HERIDA PUNZANTE EN EL CUERO CABELLUDO"
  },
  {
    "codigo":248845002,
    "descripcion":"HIMEN TABICADO"
  },
  {
    "codigo":445453003,
    "descripcion":"OBSTRUCCIÓN DEL TRACTO DE SALIDA DEL VENTRÍCULO IZQUIERDO POR ANEURISMA DEL TABIQUE MEMBRANOSO"
  },
  {
    "codigo":160648009,
    "descripcion":"NIVEL 2 DE ACTIVIDAD SEGÚN EL PRINCIPIO FITT; 5-11 OCASIONES DE ACTIVIDAD MODERADA\/ENÉRGICA EN 4 SEMANAS"
  },
  {
    "codigo":331000124109,
    "descripcion":"HALLAZGO RELACIONADO CON HEMODIÁLISIS"
  },
  {
    "codigo":85005007,
    "descripcion":"DEPENDENCIA DE CANNABIS"
  },
  {
    "codigo":314381008,
    "descripcion":"PADRE SUSTITUTO APROBADO"
  },
  {
    "codigo":707597009,
    "descripcion":"DOLOR ABDOMINAL CONTINUO DE CUADRANTE INFERIOR IZQUIERDO"
  },
  {
    "codigo":83170004,
    "descripcion":"INTOXICACIÓN CAUSADA POR 1,3-INDANODIONA"
  },
  {
    "codigo":1197282005,
    "descripcion":"NEOPLASIA QUÍSTICA MUCINOSA DE PÁNCREAS CON NEOPLASIA INTRAEPITELIAL DE BAJO GRADO"
  },
  {
    "codigo":247010007,
    "descripcion":"HALLAZGO RELACIONADO CON LAS PUPILAS"
  },
  {
    "codigo":13964001,
    "descripcion":"FÓRMULA PARA LACTANTES ENRIQUECIDA CON HIERRO"
  },
  {
    "codigo":210572005,
    "descripcion":"LESIÓN POR DESOLLAMIENTO DE MANO, REGIÓN PALMAR"
  },
  {
    "codigo":308876005,
    "descripcion":"DISPLASIA LEVE DEL RECTO"
  },
  {
    "codigo":44897000,
    "descripcion":"LINFADENITIS MESENTÉRICA"
  },
  {
    "codigo":1259148009,
    "descripcion":"METAPLASIA DE PULPA DE DIENTE POSTERIOR A TRAUMATISMO DENTAL"
  },
  {
    "codigo":276108009,
    "descripcion":"ADULTERIO DEL MARIDO"
  },
  {
    "codigo":1290081007,
    "descripcion":"NEOPLASIA NEUROENDOCRINA DE HÍGADO"
  },
  {
    "codigo":10294000,
    "descripcion":"MASTOCITOSIS REACTIVA"
  },
  {
    "codigo":438113009,
    "descripcion":"SÍNCOPE CONVULSIVO"
  },
  {
    "codigo":403510002,
    "descripcion":"VASCULITIS URTICARIANA ASOCIADA CON LUPUS ERITEMATOSO"
  },
  {
    "codigo":700257009,
    "descripcion":"MEGADUODENO CONGÉNITO"
  },
  {
    "codigo":1157174006,
    "descripcion":"CEREBELO PRESENTE"
  },
  {
    "codigo":1222710008,
    "descripcion":"SÍNDROME DE TRASTORNO DEL NEURODESARROLLO, DISMORFIA CRANEOFACIAL, DEFECTO CARDÍACO Y ANOMALÍAS ESQUELÉTICAS"
  },
  {
    "codigo":205067002,
    "descripcion":"LUXACIÓN CONGÉNITA DE LA RÓTULA"
  },
  {
    "codigo":10677831000119104,
    "descripcion":"TUMORACIÓN DE LA PIEL DEL ABDOMEN"
  },
  {
    "codigo":237835004,
    "descripcion":"ESTATURA ALTA CONSTITUCIONAL"
  },
  {
    "codigo":8459005,
    "descripcion":"FRACTURA NO EXPUESTA A NIVEL DE C1 - C4 CON LESIÓN MEDULAR INCOMPLETA"
  },
  {
    "codigo":303371006,
    "descripcion":"NO TIRA"
  },
  {
    "codigo":73995006,
    "descripcion":"PARACOCCIDIOIDOMICOSIS PULMONAR"
  },
  {
    "codigo":39392002,
    "descripcion":"COMPRESIÓN DE ESÓFAGO"
  },
  {
    "codigo":301536004,
    "descripcion":"SALE DE LA BAÑERA"
  },
  {
    "codigo":6624005,
    "descripcion":"TAQUIARRITMIA VENTRICULAR"
  },
  {
    "codigo":236000006,
    "descripcion":"HEMATOMA INTRAPERITONEAL"
  },
  {
    "codigo":203232007,
    "descripcion":"INFECCIÓN DE RÓTULA"
  },
  {
    "codigo":234165003,
    "descripcion":"SÍNDROME VASOVAGAL DEL ANCIANO"
  },
  {
    "codigo":168629006,
    "descripcion":"RADIOGRAFÍA SIMPLE DE CÚBITO: ANORMAL"
  },
  {
    "codigo":365237006,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA UTILIZAR DISPOSITIVOS PARA EL DAÑO SENSITIVO"
  },
  {
    "codigo":35722002,
    "descripcion":"TRASTORNO BIPOLAR II GRAVE, EPISODIO MÁS RECIENTE DE CARACTERÍSTICAS DEPRESIVAS PROFUNDAS, EN REMISIÓN"
  },
  {
    "codigo":232330007,
    "descripcion":"PÉRDIDA DE LA AUDICIÓN NEUROSENSORIAL, FORMA RECESIVA"
  },
  {
    "codigo":363402007,
    "descripcion":"NEOPLASIA MALIGNA DE ESÓFAGO"
  },
  {
    "codigo":723850009,
    "descripcion":"OSTEOSARCOMA PRIMARIO DE HUESO DE EXTREMIDAD"
  },
  {
    "codigo":263263004,
    "descripcion":"SÍNDROME COMPARTIMENTAL DE CUELLO DEBIDO A LESIÓN TRAUMÁTICA"
  },
  {
    "codigo":427103005,
    "descripcion":"CONTRACTURA CONGÉNITA DE LOS MÚSCULOS GEMELOS"
  },
  {
    "codigo":230495008,
    "descripcion":"TRASTORNO TRANSITORIO DEL CICLO SUEÑO-VIGILIA"
  },
  {
    "codigo":292361000,
    "descripcion":"REACCIÓN ADVERSA AL LORAZEPAM"
  },
  {
    "codigo":359732009,
    "descripcion":"ENFERMEDAD DE VON WILLEBRAND HEREDITARIA TIPO 2N"
  },
  {
    "codigo":194057002,
    "descripcion":"TRASTORNO DEL QUIASMA ÓPTICO POR TRASTORNO HIPOFISARIO"
  },
  {
    "codigo":95753002,
    "descripcion":"ENTROPIÓN DE PÁRPADO SUPERIOR"
  },
  {
    "codigo":15648481000119107,
    "descripcion":"ANEURISMA DE ARTERIA CARÓTIDA COMÚN IZQUIERDA"
  },
  {
    "codigo":62985007,
    "descripcion":"INSENSIBILIDAD HEREDITARIA AL DOLOR CON ANHIDROSIS"
  },
  {
    "codigo":718345008,
    "descripcion":"TORSIÓN DE FÉMUR"
  },
  {
    "codigo":1144329008,
    "descripcion":"ATROFIA DE FONDO DE OJO"
  },
  {
    "codigo":93918002,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL CORNETE ETMOIDAL DE LA NARIZ"
  },
  {
    "codigo":290526003,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR DESFLURANO"
  },
  {
    "codigo":716510005,
    "descripcion":"NO UTILIZA LA SEMÁNTICA EN LA COMUNICACIÓN"
  },
  {
    "codigo":126686005,
    "descripcion":"NEOPLASIA DE LA HIPOFARINGE"
  },
  {
    "codigo":224990006,
    "descripcion":"REPRESIÓN A TRAVÉS DE LA NEGACIÓN"
  },
  {
    "codigo":16206221000119100,
    "descripcion":"SÍNDROME DE LA ABERTURA DE SALIDA TORÁCICA BILATERAL"
  },
  {
    "codigo":16697741000119101,
    "descripcion":"INFECCIÓN DE STENT URETERAL"
  },
  {
    "codigo":10686861000119100,
    "descripcion":"MELANOMA MALIGNO DE LECHO UNGUEAL DE DEDO DE MANO IZQUIERDA"
  },
  {
    "codigo":15929741000119101,
    "descripcion":"DISFUNCIÓN DE LA MANO DERECHA"
  },
  {
    "codigo":11777421000119104,
    "descripcion":"HEMATOMA DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":308621000119105,
    "descripcion":"GANGLIÓN DE MANO IZQUIERDA"
  },
  {
    "codigo":15960461000119105,
    "descripcion":"ANGINA INESTABLE DEBIDA A ARTERIOESCLEROSIS DE INJERTO-PUENTE ARTERIAL AUTÓLOGO DE ARTERIA CORONARIA"
  },
  {
    "codigo":15937421000119107,
    "descripcion":"QUISTE EPIDERMOIDE DE DEDO DE MANO DERECHA"
  },
  {
    "codigo":11828621000119104,
    "descripcion":"AMPOLLA DE CADERA DERECHA, CON INFECCIÓN"
  },
  {
    "codigo":96141000119105,
    "descripcion":"ANGIOFIBROMA DE NASOFARINGE"
  },
  {
    "codigo":11874701000119105,
    "descripcion":"ECTROPIÓN DE AMBOS PÁRPADOS"
  },
  {
    "codigo":467442061000119103,
    "descripcion":"FIBROMATOSIS AGRESIVA DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":12202381000119105,
    "descripcion":"POSICIÓN ANÓMALA DE SUTURA PERMANENTE"
  },
  {
    "codigo":687501000119106,
    "descripcion":"NEVO EPIDÉRMICO PILOSO PIGMENTADO DE OREJA"
  },
  {
    "codigo":98701000119108,
    "descripcion":"SÍNDROME COMPARTIMENTAL NO TRAUMÁTICO DE MIEMBRO INFERIOR"
  },
  {
    "codigo":306061000119109,
    "descripcion":"TRASTORNO DE LIGAMENTO DE ARTICULACIÓN DE CODO DERECHO"
  },
  {
    "codigo":1204360006,
    "descripcion":"EQUIPAMIENTO ADECUADO PARA PREPARACIÓN DE ALIMENTO EN LA VIVIENDA"
  },
  {
    "codigo":16270221000119108,
    "descripcion":"ACATISIA AGUDA CAUSADA POR FÁRMACO"
  },
  {
    "codigo":254088006,
    "descripcion":"BRAQUIOLMIA"
  },
  {
    "codigo":416093006,
    "descripcion":"REACCIÓN ALÉRGICA CAUSADA POR FÁRMACO"
  },
  {
    "codigo":88413002,
    "descripcion":"TIPO CELULAR NO DETERMINADO"
  },
  {
    "codigo":53810004,
    "descripcion":"LESIÓN TRAUMÁTICA A NIVEL DE T1 - T6 CON LESIÓN DE LA MÉDULA ESPINAL Y SIN LESIÓN ÓSEA"
  },
  {
    "codigo":1004082008,
    "descripcion":"TRASTORNO FETAL DEBIDO A ENFERMEDAD PERIODONTAL MATERNA"
  },
  {
    "codigo":838407001,
    "descripcion":"CAPAZ DE VER MOVIMIENTO DE LA MANO A TRAVÉS DE AGUJERO ESTENOPEICO CON EL OJO IZQUIERDO"
  },
  {
    "codigo":283186009,
    "descripcion":"CUERPO EXTRAÑO METÁLICO EN DORSO DEL PIE"
  },
  {
    "codigo":281351006,
    "descripcion":"ARTRITIS SECUNDARIA A TRASTORNOS DE LA COAGULACIÓN"
  },
  {
    "codigo":248583008,
    "descripcion":"PARA DE RESPIRAR"
  },
  {
    "codigo":82908000,
    "descripcion":"SÍNDROME DE DUDLEY-KLINGENSTEIN"
  },
  {
    "codigo":246748002,
    "descripcion":"EXOTROPÍA INCOMITANTE"
  },
  {
    "codigo":212145003,
    "descripcion":"LESIÓN DEL NERVIO MOTOR OCULAR COMÚN"
  },
  {
    "codigo":77403000,
    "descripcion":"GRANULOMA DEL TEJIDO CELULAR SUBCUTÁNEO POR CUERPO EXTRAÑO"
  },
  {
    "codigo":11867000,
    "descripcion":"EVALUACIÓN DE DISCAPACIDAD: 9%"
  },
  {
    "codigo":210310009,
    "descripcion":"HERIDA ABIERTA DE LA CÓCLEA"
  },
  {
    "codigo":208475002,
    "descripcion":"FRACTURA EXPUESTA DE FALANGE DISTAL DEL PULGAR, CON PENACHO"
  },
  {
    "codigo":110171005,
    "descripcion":"QUEMADURA EPIDÉRMICA DE REGIÓN PERIORBITARIA"
  },
  {
    "codigo":44635007,
    "descripcion":"IMPACTACIÓN FECAL"
  },
  {
    "codigo":370480003,
    "descripcion":"DISPLASIA MICROVASCULAR HEPATOPORTAL"
  },
  {
    "codigo":403248006,
    "descripcion":"PELO RUBIO DORADO INTENSO"
  },
  {
    "codigo":42800007,
    "descripcion":"TEMBLOR FINO"
  },
  {
    "codigo":75568008,
    "descripcion":"FORÚNCULO DE DEDO DE LA MANO"
  },
  {
    "codigo":1255216009,
    "descripcion":"POSICIÓN ANÓMALA DE LENTE INTRAOCULAR"
  },
  {
    "codigo":305481000119100,
    "descripcion":"CONTRACTURA DE ARTICULACIÓN DE RODILLA IZQUIERDA"
  },
  {
    "codigo":204805004,
    "descripcion":"ANOMALÍAS DEL PÁNCREAS"
  },
  {
    "codigo":237573009,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA GLÁNDULA TIROIDES"
  },
  {
    "codigo":235738006,
    "descripcion":"FÍSTULA EXTERNA DEL INTESTINO DELGADO"
  },
  {
    "codigo":399578008,
    "descripcion":"INVASIÓN DEL PARÉNQUIMA PULMONAR POR TUMOR INDETERMINADO"
  },
  {
    "codigo":102831002,
    "descripcion":"DOLOR EN EL ÁNGULO RENAL"
  },
  {
    "codigo":1216943004,
    "descripcion":"DISOSTOSIS MANDIBULOFACIAL CON ALOPECIA"
  },
  {
    "codigo":201135005,
    "descripcion":"ALOPECIA SENIL"
  },
  {
    "codigo":233903004,
    "descripcion":"TAQUICARDIA POSQUIRÚRGICA DEL HAZ DE HIS"
  },
  {
    "codigo":364975007,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA DAR PUÑETAZOS"
  },
  {
    "codigo":363140000,
    "descripcion":"HIPOLIPOPROTEINEMIA"
  },
  {
    "codigo":37295009,
    "descripcion":"HIPERESTROGENISMO"
  },
  {
    "codigo":397743004,
    "descripcion":"BLOQUEO DE CONDUCCIÓN NERVIOSA MOTRIZ-PARCIAL"
  },
  {
    "codigo":428676003,
    "descripcion":"UVEÍTIS CAUSADA POR RANIBIZUMAB"
  },
  {
    "codigo":232068003,
    "descripcion":"DESPRENDIMIENTO DEL EPITELIO PIGMENTARIO RETINIANO CON VASCULARIZACIÓN"
  },
  {
    "codigo":230233000,
    "descripcion":"ATAXIA CEREBELOSA PROGRESIVA"
  },
  {
    "codigo":66393002,
    "descripcion":"CONTUSIÓN DEL TRONCO ENCEFÁLICO CON HERIDA INTRACRANEAL ABIERTA Y PÉRDIDA DE LA CONSCIENCIA"
  },
  {
    "codigo":857002,
    "descripcion":"ERITEMA SIMPLE"
  },
  {
    "codigo":721753005,
    "descripcion":"MENINGITIS CAUSADA POR NOCARDIA"
  },
  {
    "codigo":295769007,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE AMINOGLUTETIMIDA"
  },
  {
    "codigo":228398000,
    "descripcion":"CARGA FRONTAL DE JERINGA"
  },
  {
    "codigo":263001009,
    "descripcion":"RUPTURA DE CÁPSULA ARTICULAR"
  },
  {
    "codigo":293934002,
    "descripcion":"ALERGIA A FLUFENAZINA"
  },
  {
    "codigo":95491001,
    "descripcion":"HIPOPLASIA CONGÉNITA DE LA MEMBRANA COROIDES"
  },
  {
    "codigo":783619003,
    "descripcion":"SÍNDROME DE DISCAPACIDAD RELACIONADO CON DYRK1A DEBIDO A MICRODELECIÓN DE 21Q22.13Q22.2"
  },
  {
    "codigo":292099004,
    "descripcion":"REACCIÓN ADVERSA A UN COLORANTE DE USO DIAGNÓSTICO"
  },
  {
    "codigo":193795008,
    "descripcion":"OPACIDADES Y CICATRICES CORNEALES"
  },
  {
    "codigo":716248001,
    "descripcion":"SÍNDROME DE FISURA DE LABIO Y PALADAR CON DISPLASIA ECTODÉRMICA"
  },
  {
    "codigo":880088000,
    "descripcion":"DISTENSIÓN DE TENDÓN DE PIERNA"
  },
  {
    "codigo":124589007,
    "descripcion":"DEFICIENCIA DE PROTEINASA ASPÁRTICA"
  },
  {
    "codigo":714413008,
    "descripcion":"DIFICULTAD PARA ABSTENERSE DE BEBER"
  },
  {
    "codigo":253826001,
    "descripcion":"QUISTE EMBRIONARIO DE LIGAMENTO ANCHO"
  },
  {
    "codigo":417666002,
    "descripcion":"CORMACK-LEHANE GRADO 2"
  },
  {
    "codigo":57218003,
    "descripcion":"ENFERMEDAD POR ALMACENAMIENTO DE ÉSTERES DEL COLESTEROL"
  },
  {
    "codigo":188290004,
    "descripcion":"NEOPLASIA MALIGNA DEL UNCUS"
  },
  {
    "codigo":712578006,
    "descripcion":"ANEURISMA DE CAYADO AÓRTICO"
  },
  {
    "codigo":448599000,
    "descripcion":"ANOMALÍA TOTAL DEL RETORNO VENOSO PULMONAR DE TIPO INFRACARDÍACO"
  },
  {
    "codigo":55383003,
    "descripcion":"CUERPO NO IDENTIFICADO PERO CON IDENTIDAD SOSPECHADA"
  },
  {
    "codigo":284759005,
    "descripcion":"APUÑALARSE"
  },
  {
    "codigo":88151007,
    "descripcion":"QUERATOCONJUNTIVITIS"
  },
  {
    "codigo":307991000119100,
    "descripcion":"HIPERLAXITUD ARTICULAR DE CADERA IZQUIERDA"
  },
  {
    "codigo":741676008,
    "descripcion":"HERNIA CRURAL DERECHA RECURRENTE"
  },
  {
    "codigo":250156009,
    "descripcion":"PUNTERA MUY PROFUNDA"
  },
  {
    "codigo":16036631000119101,
    "descripcion":"DETENCIÓN TOTAL DE CRECIMIENTO EPIFISARIO DE TIBIAS PROXIMALES BILATERALES"
  },
  {
    "codigo":1296897006,
    "descripcion":"RESISTENCIA HEREDITARIA AUTOSÓMICA A VASOPRESINA"
  },
  {
    "codigo":836310000,
    "descripcion":"AGUDEZA VISUAL DE OJO IZQUIERDO 6\/48"
  },
  {
    "codigo":248321009,
    "descripcion":"PÉRDIDA ADIPOSA CORPORAL PROGRESIVA DESCENDENTE"
  },
  {
    "codigo":443094001,
    "descripcion":"HEMICRÁNEA PAROXÍSTICA"
  },
  {
    "codigo":49878003,
    "descripcion":"GRADO DE GLEASON: 2"
  },
  {
    "codigo":17110002,
    "descripcion":"INFECCIÓN POR FASCIOLA GIGANTICA"
  },
  {
    "codigo":770774004,
    "descripcion":"BLEFAROCONJUNTIVITIS DE OJO IZQUIERDO"
  },
  {
    "codigo":1264129009,
    "descripcion":"AMPOLLA TRAUMÁTICA DE SEGUNDO A QUINTO DEDO DE PIE"
  },
  {
    "codigo":703403003,
    "descripcion":"SÍNDROME OFTALMO-ACROMÉLICO"
  },
  {
    "codigo":1293227003,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE TENDÓN EXTENSOR DE REGIÓN DE MUÑECA"
  },
  {
    "codigo":277419005,
    "descripcion":"LUXACIÓN DE PRÓTESIS OSICULAR"
  },
  {
    "codigo":48043005,
    "descripcion":"PELVIS JUSTO MENOR"
  },
  {
    "codigo":373888000,
    "descripcion":"ADENOCARCINOMA EXTRAUTERINO"
  },
  {
    "codigo":768939009,
    "descripcion":"SÍNDROME DE DISRAFISMO ESPINAL OCULTO PRIMARIO"
  },
  {
    "codigo":109909008,
    "descripcion":"MASTOIDITIS SUPURATIVA AGUDA"
  },
  {
    "codigo":370218001,
    "descripcion":"ASMA LEVE"
  },
  {
    "codigo":402986002,
    "descripcion":"ACTINOMICETOMA CAUSADO POR NOCARDIA ASTEROIDES"
  },
  {
    "codigo":206378006,
    "descripcion":"SEPSIS NEONATAL POR STAPHYLOCOCCUS AUREUS"
  },
  {
    "codigo":697898008,
    "descripcion":"HIPERTENSIÓN DE ARTERIA PULMONAR IDIOPÁTICA"
  },
  {
    "codigo":239146009,
    "descripcion":"HAMARTOMA MESENQUIMÁTICO RABDOMIOMATOSO"
  },
  {
    "codigo":73471000,
    "descripcion":"TRASTORNO BIPOLAR I, EPISODIO MÁS RECIENTE MIXTO CON SÍNTOMAS CATATÓNICOS"
  },
  {
    "codigo":302847003,
    "descripcion":"RABDOMIOSARCOMA"
  },
  {
    "codigo":202708005,
    "descripcion":"PROLAPSO DE DISCO INTERVERTEBRAL LUMBAR"
  },
  {
    "codigo":366548006,
    "descripcion":"PRUEBA DE FINKELSTEIN - HALLAZGO"
  },
  {
    "codigo":301012009,
    "descripcion":"INFECCIÓN DE VÍAS URINARIAS POR PROTEUS"
  },
  {
    "codigo":102569004,
    "descripcion":"AMPLITUD DEL MOVIMIENTO DE LA CADERA DISMINUIDA"
  },
  {
    "codigo":299177008,
    "descripcion":"SIN AMPLITUD ACTIVA DE ADUCCIÓN DE PULGAR"
  },
  {
    "codigo":788862002,
    "descripcion":"AGITACIÓN DEBIDA A DEMENCIA"
  },
  {
    "codigo":231806003,
    "descripcion":"ECTROPIÓN POR CICATRIZ FOCAL DE LA CONJUNTIVA"
  },
  {
    "codigo":10822731000119104,
    "descripcion":"FRACTURA EXPUESTA DE PRIMER HUESO METACARPIANO DE MANO DERECHA"
  },
  {
    "codigo":66131005,
    "descripcion":"ABORTO ESPONTÁNEO CON EMBOLIA GRASA"
  },
  {
    "codigo":361043006,
    "descripcion":"DEFICIENCIA DE QUIMOTRIPSINA A Y B"
  },
  {
    "codigo":721491006,
    "descripcion":"SÍNDROME DE BROWN-SEQUARD AL NIVEL DEL DÉCIMO SEGMENTO DORSAL"
  },
  {
    "codigo":11805771000119105,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA PROXIMAL DE DEDO ÍNDICE DERECHO"
  },
  {
    "codigo":295507009,
    "descripcion":"SOBREDOSIS DE KETAMINA"
  },
  {
    "codigo":129832003,
    "descripcion":"INCUMPLIMIENTO DEL RÉGIMEN NUTRICIONAL"
  },
  {
    "codigo":16065611000119106,
    "descripcion":"GANGRENA DE EXTREMIDAD INFERIOR DERECHA DEBIDA A ATEROSCLEROSIS DE INJERTO-PUENTE AUTÓLOGO"
  },
  {
    "codigo":228136006,
    "descripcion":"EXCLUIDO DE LA ESCUELA TRANSITORIAMENTE"
  },
  {
    "codigo":816125003,
    "descripcion":"EXAGERACIÓN DE REFLEJO TRICIPITAL"
  },
  {
    "codigo":310501000119101,
    "descripcion":"INFECCIÓN PIÓGENA DE DISCO INTERVERTEBRAL CERVICOTORÁCICO"
  },
  {
    "codigo":717821004,
    "descripcion":"ENFERMEDAD POR ALMACENAMIENTO DE GLUCÓGENO CON MIOCARDIOPATÍA SEVERA DEBIDA A DEFICIENCIA DE GLUCOGENINA"
  },
  {
    "codigo":1078269005,
    "descripcion":"AGENESIA DE EPÍFISIS DE FALANGE PROXIMAL DE QUINTO DEDO DE PIE"
  },
  {
    "codigo":224466000,
    "descripcion":"REUBICADO LABORALMENTE"
  },
  {
    "codigo":91211000119109,
    "descripcion":"CARCINOMA NEUROENDOCRINO MICROCÍTICO CON METÁSTASIS A PLEURA"
  },
  {
    "codigo":93394006,
    "descripcion":"TRONCO CORTO CONGÉNITO"
  },
  {
    "codigo":290002008,
    "descripcion":"DIABETES MELLITUS TIPO 1 LÁBIL"
  },
  {
    "codigo":715986009,
    "descripcion":"SÍNDROME DE CAMPTODACTILIA CON CONTRACTURA ARTICULAR Y DEFECTO ESQUELÉTICO FACIAL"
  },
  {
    "codigo":27858009,
    "descripcion":"GASTROENTERITIS CLOSTRIDIAL"
  },
  {
    "codigo":124327008,
    "descripcion":"DEFICIENCIA DE MEVALONATO CINASA"
  },
  {
    "codigo":286332001,
    "descripcion":"CAPAZ DE PRODUCIR UN TONO ADECUADO"
  },
  {
    "codigo":253564006,
    "descripcion":"DEFECTO DEL TABIQUE INTERVENTRICULAR MUSCULAR EN LA PORCIÓN TRABECULAR CENTRAL"
  },
  {
    "codigo":1269372008,
    "descripcion":"CRISIS EPILÉPTICA HIPERQUINÉTICA CON CONCIENCIA PRESERVADA DE INICIO FOCAL"
  },
  {
    "codigo":186193001,
    "descripcion":"TUBERCULOSIS PULMONAR, CON CONFIRMACIÓN POR MICROSCOPIA DEL ESPUTO, CON O SIN CULTIVO"
  },
  {
    "codigo":15957221000119107,
    "descripcion":"CARCINOMA ESCAMOCELULAR METASTÁSICO DE PULMÓN IZQUIERDO"
  },
  {
    "codigo":284497006,
    "descripcion":"REFUERZO PRIMARIO DE LA CONDUCTA"
  },
  {
    "codigo":1003558000,
    "descripcion":"AGENESIA DE MAXILAR SUPERIOR"
  },
  {
    "codigo":218961009,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR EMÉTICO"
  },
  {
    "codigo":282662002,
    "descripcion":"DIFICULTAD PARA GOLPEAR"
  },
  {
    "codigo":251729009,
    "descripcion":"MALFORMACIÓN CONGÉNITA DEL ÁNGULO DE LA CÁMARA ANTERIOR DEL OJO"
  },
  {
    "codigo":53286005,
    "descripcion":"EPICONDILITIS MEDIAL"
  },
  {
    "codigo":249894008,
    "descripcion":"DIFICULTAD GENERAL PARA MOVERSE"
  },
  {
    "codigo":315430008,
    "descripcion":"NACIDO EN GEORGIA"
  },
  {
    "codigo":444667006,
    "descripcion":"DEFORMIDAD CONGÉNITA DE FARINGE"
  },
  {
    "codigo":248059008,
    "descripcion":"DESCUIDO DE ENFERMEDADES FÍSICAS"
  },
  {
    "codigo":11834751000119106,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA DE PULGAR DERECHO"
  },
  {
    "codigo":703141002,
    "descripcion":"PREPARACIÓN EFECTIVA DE INTESTINO PARA PROCEDIMIENTO"
  },
  {
    "codigo":15013002,
    "descripcion":"MOSCAS VOLANTES"
  },
  {
    "codigo":277157002,
    "descripcion":"NEOPLASIA BENIGNA DE OÍDO EXTERNO"
  },
  {
    "codigo":1260197005,
    "descripcion":"NEFROPATÍA FULL HOUSE NO LÚPICA IDIOPÁTICA"
  },
  {
    "codigo":16012671000119108,
    "descripcion":"EMBOLIA DE ARTERIA POPLÍTEA DERECHA"
  },
  {
    "codigo":735909008,
    "descripcion":"DESHIDRATACIÓN POSTERIOR A EJERCICIO"
  },
  {
    "codigo":439162001,
    "descripcion":"EMBOLIA DE TROMBOSIS VENOSA DE EXTREMIDAD INFERIOR DISTAL"
  },
  {
    "codigo":111482003,
    "descripcion":"ESQUIZOFRENIA SUBCRÓNICA CON EXACERBACIONES AGUDAS"
  },
  {
    "codigo":275322007,
    "descripcion":"CICATRIZ"
  },
  {
    "codigo":109647001,
    "descripcion":"TRAUMATISMO OCLUSAL"
  },
  {
    "codigo":240719002,
    "descripcion":"CANDIDIASIS MUCOCUTÁNEA DIFUSA CRÓNICA"
  },
  {
    "codigo":207951009,
    "descripcion":"FRACTURA EXPUESTA DE VÉRTEBRA DORSAL, EN CUÑA"
  },
  {
    "codigo":271652003,
    "descripcion":"VENA VARICOSA - HALLAZGO"
  },
  {
    "codigo":238884009,
    "descripcion":"PANICULITIS FICTICIA"
  },
  {
    "codigo":402724009,
    "descripcion":"XANTOMA POR ANORMALIDAD DEL METABOLISMO LIPÍDICO"
  },
  {
    "codigo":237049007,
    "descripcion":"FIBROSIS TUBÁRICA"
  },
  {
    "codigo":726734001,
    "descripcion":"SÍNDROME DE BAJA ESTATURA Y BLOQUEO DE DEDOS DE LAS MANOS"
  },
  {
    "codigo":267982002,
    "descripcion":"DOLOR EN COLUMNA LUMBAR"
  },
  {
    "codigo":366286001,
    "descripcion":"OJO DESPLAZÁNDOSE EN DIRECCIÓN AL SONIDO - HALLAZGO"
  },
  {
    "codigo":202446004,
    "descripcion":"TUMOR TENOSINOVIAL DE CÉLULAS GIGANTES DIFUSO DE ARTICULACIÓN TIBIOPERONEA"
  },
  {
    "codigo":300750002,
    "descripcion":"CAPAZ DE REALIZAR ACTIVIDADES DE JARDINERÍA"
  },
  {
    "codigo":5838006,
    "descripcion":"PULSO DICRÓTICO"
  },
  {
    "codigo":399054005,
    "descripcion":"EXOTROPÍA"
  },
  {
    "codigo":298915000,
    "descripcion":"AMPLITUD DE PRONACIÓN ACTIVA DE CODO AUMENTADA"
  },
  {
    "codigo":38606009,
    "descripcion":"AMILOIDOSIS CUTÁNEA AMPOLLAR"
  },
  {
    "codigo":339481000119109,
    "descripcion":"OPACIDAD MENOR DE CÓRNEA IZQUIERDA"
  },
  {
    "codigo":4003003,
    "descripcion":"ENFERMEDAD CAUSADA POR ALPHAVIRUS"
  },
  {
    "codigo":724899004,
    "descripcion":"LACERACIÓN DE MÚSCULO DE LA REGIÓN DORSAL INFERIOR"
  },
  {
    "codigo":266147005,
    "descripcion":"LESIONES EN FRAMBESIA DE ARTICULACIÓN Y HUESO"
  },
  {
    "codigo":200611006,
    "descripcion":"FORÚNCULO DE CODO"
  },
  {
    "codigo":297080004,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE HIDRALAZINA"
  },
  {
    "codigo":34936007,
    "descripcion":"DERMATITIS CRÓNICA"
  },
  {
    "codigo":428152007,
    "descripcion":"HERIDA PENETRANTE DE CUELLO"
  },
  {
    "codigo":264312008,
    "descripcion":"LÍQUIDO"
  },
  {
    "codigo":360781002,
    "descripcion":"DEFICIENCIA DE FOSFOMONOESTERASA ALCALINA"
  },
  {
    "codigo":721229003,
    "descripcion":"SÍNDROME DE HIDROCEFALIA, DISPLASIA COSTOVERTEBRAL Y ANOMALÍA DE SPRENGEL"
  },
  {
    "codigo":229709008,
    "descripcion":"DISPRAXIA DE LA PUNTA DE LA LENGUA"
  },
  {
    "codigo":64034001,
    "descripcion":"EMISIÓN DE SEMEN"
  },
  {
    "codigo":293410002,
    "descripcion":"REACCIÓN ADVERSA AL POTASIO POR VÍA ORAL"
  },
  {
    "codigo":719394002,
    "descripcion":"SÍNDROME DE MICROCEFALIA Y FISURA DE PALADAR"
  },
  {
    "codigo":424482002,
    "descripcion":"EXHIBE CONTROL ADECUADO DEL DOLOR SIN ANALGÉSICOS ORALES"
  },
  {
    "codigo":162338005,
    "descripcion":"SÍNTOMAS AUDITIVOS"
  },
  {
    "codigo":368461000119103,
    "descripcion":"ENFERMEDAD RENAL CRÓNICA ESTADIO 5 DEBIDA A DIABETES MELLITUS MEDICAMENTOSA"
  },
  {
    "codigo":1145378009,
    "descripcion":"APLASIA DE MÚSCULO DE EXTREMIDAD"
  },
  {
    "codigo":129570009,
    "descripcion":"SÍNDROME DEL FUMADOR PASIVO"
  },
  {
    "codigo":94967006,
    "descripcion":"NEOPLASIA DE HUESO TEMPORAL DE COMPORTAMIENTO INCIERTO"
  },
  {
    "codigo":62199007,
    "descripcion":"TRIGONITIS AGUDA"
  },
  {
    "codigo":1010636000,
    "descripcion":"SÍNDROME DE WAARDENBURG TIPO 2"
  },
  {
    "codigo":93132001,
    "descripcion":"SÍNDROME LETAL SIMILAR AL DE KNIEST"
  },
  {
    "codigo":715724002,
    "descripcion":"SINDACTILIA TIPO 2"
  },
  {
    "codigo":224204002,
    "descripcion":"MANTIENE EL DINERO EN SU PROPIA CUENTA"
  },
  {
    "codigo":27596001,
    "descripcion":"HIPOSENSIBILIDAD"
  },
  {
    "codigo":15933261000119106,
    "descripcion":"QUISTE EMBRIONARIO DE TROMPA DE FALOPIO DERECHA"
  },
  {
    "codigo":289740006,
    "descripcion":"HALLAZGO RELACIONADO CON EL ESTADO DE CONTRACCIÓN DEL ÚTERO"
  },
  {
    "codigo":341991000119100,
    "descripcion":"AFAQUIA DE OJO IZQUIERDO"
  },
  {
    "codigo":783095007,
    "descripcion":"APLASIA DE CUELLO UTERINO"
  },
  {
    "codigo":255137001,
    "descripcion":"CARCINOMA IN SITU DE LA MUCOSA LABIAL INFERIOR"
  },
  {
    "codigo":1172641003,
    "descripcion":"GONADOTROFINA HIPOFISARIA DENTRO DE RANGO DE REFERENCIA"
  },
  {
    "codigo":713889004,
    "descripcion":"ODONTALGIA ATÍPICA"
  },
  {
    "codigo":91297005,
    "descripcion":"PRESIÓN VENOSA CENTRAL NORMAL"
  },
  {
    "codigo":15988711000119101,
    "descripcion":"CONJUNTIVITIS ALÉRGICA PERENNE DE OJO IZQUIERDO"
  },
  {
    "codigo":124065008,
    "descripcion":"TIROSINA POR ENCIMA DE RANGO DE REFERENCIA"
  },
  {
    "codigo":449910002,
    "descripcion":"FLACIDEZ DE MÚSCULO DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":253302006,
    "descripcion":"COMUNICACIÓN VENTRICULOARTERIAL DE SALIDA ÚNICA"
  },
  {
    "codigo":286070009,
    "descripcion":"DIFICULTAD PARA DOBLAR LA ROPA LAVADA"
  },
  {
    "codigo":251467006,
    "descripcion":"REGISTRO TIPO ALFA DE COMA"
  },
  {
    "codigo":1003296000,
    "descripcion":"CLINODACTILIA CONGÉNITA DE DEDO MEDIO"
  },
  {
    "codigo":53024001,
    "descripcion":"AUMENTO DE PESO INSUFICIENTE EN EL EMBARAZO"
  },
  {
    "codigo":448075009,
    "descripcion":"CONEXIÓN UNIAURICULAR BIVENTRICULAR CON CONEXIÓN AURICULOVENTRICULAR DEL LADO DERECHO AUSENTE CON CABALGAMIENTO DE VÁLVULA"
  },
  {
    "codigo":249632006,
    "descripcion":"MUCOSA ANAL - HALLAZGO"
  },
  {
    "codigo":772085001,
    "descripcion":"BAJA ESTATURA PROPORCIONADA"
  },
  {
    "codigo":1163466000,
    "descripcion":"INFECCIÓN DE PÁRPADO CAUSADA POR TREPONEMA PALLIDUM PERTENUE"
  },
  {
    "codigo":1263605009,
    "descripcion":"TRASTORNO FETAL DEBIDO A INDUCCIÓN DE TRABAJO DE PARTO"
  },
  {
    "codigo":409802002,
    "descripcion":"INFECCIÓN CAUSADA POR BACTERIAS PRODUCTORAS DE BETALACTAMASA DE AMPLIO ESPECTRO"
  },
  {
    "codigo":1360074005,
    "descripcion":"ÁNGULO ESTRECHO DE AMBOS OJOS"
  },
  {
    "codigo":211359003,
    "descripcion":"PICADURA DE INSECTO, NO VENENOSO, EN MUSLO"
  },
  {
    "codigo":438900002,
    "descripcion":"ASA VENOSA CONSTRUIDA QUIRÚRGICAMENTE"
  },
  {
    "codigo":1290868004,
    "descripcion":"OSTEOSARCOMA PAROSTEAL"
  },
  {
    "codigo":406132007,
    "descripcion":"VIVE TRANSITORIAMENTE CON PARIENTES"
  },
  {
    "codigo":240457001,
    "descripcion":"BARTONELOSIS NODULAR"
  },
  {
    "codigo":11784321000119107,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE DEDO DE MANO IZQUIERDA"
  },
  {
    "codigo":830281004,
    "descripcion":"REACCIÓN ADVERSA A INHIBIDOR DE ALDEHÍDO DESHIDROGENASA"
  },
  {
    "codigo":109385007,
    "descripcion":"SARCOMA DE KAPOSI (CLÍNICO)"
  },
  {
    "codigo":699209008,
    "descripcion":"LESIÓN DE HIPOFARINGE"
  },
  {
    "codigo":369694001,
    "descripcion":"MARGEN DESCONOCIDO DE RESECCIÓN QUIRÚRGICA DE RECTO, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":762910003,
    "descripcion":"AGENESIA DE RIÑÓN DERECHO CONCOMITANTE CON HIPOPLASIA DE RIÑÓN IZQUIERDO"
  },
  {
    "codigo":1287198005,
    "descripcion":"MELANOMA IN SITU DE PIEL DE PIE"
  },
  {
    "codigo":238622008,
    "descripcion":"PITIRIASIS ROSADA JUVENIL ATÍPICA"
  },
  {
    "codigo":302323001,
    "descripcion":"TEJIDO DE GRANULACIÓN EN UNA TRAQUEOSTOMÍA"
  },
  {
    "codigo":171251002,
    "descripcion":"CRIBADO DE ORINA: ANORMAL"
  },
  {
    "codigo":236787004,
    "descripcion":"GRANULOMA ESPERMATOGÉNICO DE CORDÓN ESPERMÁTICO"
  },
  {
    "codigo":105715005,
    "descripcion":"ENFERMEDAD INFECCIOSA CAUSADA POR PLANTAS"
  },
  {
    "codigo":71112001,
    "descripcion":"PULSO CUBITAL NORMAL"
  },
  {
    "codigo":300488004,
    "descripcion":"HALLAZGO RELACIONADO CON LA SENSIBILIDAD DE LOS TESTÍCULOS"
  },
  {
    "codigo":366024005,
    "descripcion":"PROMEDIO DE LA REACCIÓN PUPILAR A LA LUZ - HALLAZGO"
  },
  {
    "codigo":344501000119100,
    "descripcion":"FOTOQUERATITIS DE AMBOS OJOS"
  },
  {
    "codigo":5576007,
    "descripcion":"EFECTO TÓXICO DEL ÁCIDO NÍTRICO"
  },
  {
    "codigo":398792007,
    "descripcion":"SENSACIÓN A LA PUNTURA DEL PIE CON ALFILER - NORMAL"
  },
  {
    "codigo":724637001,
    "descripcion":"TROMBOCITOPENIA AISLADA"
  },
  {
    "codigo":234952008,
    "descripcion":"DIENTE CÓNICO SUPERNUMERARIO"
  },
  {
    "codigo":298653007,
    "descripcion":"AMPLITUD DE ROTACIÓN PASIVA HACIA LA DERECHA DE LA COLUMNA LUMBAR AUMENTADA"
  },
  {
    "codigo":427890000,
    "descripcion":"OBSTRUCCIÓN PARCIAL DE LA VÍA AÉREA CAUSADA POR CUERPO EXTRAÑO"
  },
  {
    "codigo":165746003,
    "descripcion":"RHD NEGATIVO"
  },
  {
    "codigo":1148786006,
    "descripcion":"GASTO CARDÍACO NORMAL"
  },
  {
    "codigo":426055002,
    "descripcion":"ARACNOIDITIS ESPINAL"
  },
  {
    "codigo":1179719005,
    "descripcion":"LINFANGIOMATOSIS PULMONAR DIFUSA"
  },
  {
    "codigo":1081781000119105,
    "descripcion":"SEMINOMA PRIMARIO DE TESTÍCULO IZQUIERDO"
  },
  {
    "codigo":294983009,
    "descripcion":"ALERGIA A PROPAFENONA"
  },
  {
    "codigo":293148003,
    "descripcion":"REACCIÓN ADVERSA A LA FLUNISOLIDA"
  },
  {
    "codigo":72271000119100,
    "descripcion":"HIPERTIROIDISMO EN EL EMBARAZO"
  },
  {
    "codigo":422385000,
    "descripcion":"SALTO DE IMAGEN BIFOCAL"
  },
  {
    "codigo":162076009,
    "descripcion":"GAS EN EXCESO EN TRACTO GASTROINTESTINAL SUPERIOR"
  },
  {
    "codigo":16046671000119102,
    "descripcion":"ENFERMEDAD POR DEPÓSITO DE HIDROXIAPATITA DE CODO DERECHO"
  },
  {
    "codigo":61937009,
    "descripcion":"BRONQUITIS CRÓNICA SIMPLE"
  },
  {
    "codigo":291313009,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR CLONIDINA"
  },
  {
    "codigo":715462003,
    "descripcion":"MICROCEFALIA CONCOMITANTE CON ANOMALÍA DE FUSIÓN DE LA COLUMNA VERTEBRAL CERVICAL"
  },
  {
    "codigo":92870005,
    "descripcion":"FUSIÓN ANORMAL CONGÉNITA DE HUESO PALATINO"
  },
  {
    "codigo":125638008,
    "descripcion":"LESIÓN TRAUMÁTICA DE TROMPA DE FALOPIO"
  },
  {
    "codigo":254875009,
    "descripcion":"TERATOMA SÓLIDO MADURO DE OVARIO"
  },
  {
    "codigo":449648005,
    "descripcion":"NEOPLASIA DE PIEL DE PIERNA"
  },
  {
    "codigo":285808008,
    "descripcion":"LESIÓN DEL PERITONEO"
  },
  {
    "codigo":251205003,
    "descripcion":"ONDA P PROLONGADA"
  },
  {
    "codigo":21829004,
    "descripcion":"HALLAZGO EN VASO SANGUÍNEO"
  },
  {
    "codigo":54597004,
    "descripcion":"COLITIS CRÓNICA"
  },
  {
    "codigo":283973004,
    "descripcion":"CONTUSIÓN DEL PERINEO MASCULINO"
  },
  {
    "codigo":447813008,
    "descripcion":"CONFLUENCIA VENOSA PULMONAR CON ORIENTACIÓN HORIZONTAL"
  },
  {
    "codigo":1363482001,
    "descripcion":"AGRANDAMIENTO DE CUARTO VENTRÍCULO"
  },
  {
    "codigo":249370002,
    "descripcion":"SENO MAXILAR - HALLAZGO"
  },
  {
    "codigo":708122002,
    "descripcion":"HIPERGLUCEMIA INDUCIDA POR ESTEROIDES"
  },
  {
    "codigo":413210008,
    "descripcion":"DUODENOPATÍA CONGESTIVA"
  },
  {
    "codigo":15692521000119104,
    "descripcion":"QUERATITIS DE OJO IZQUIERDO CAUSADA POR ADENOVIRUS"
  },
  {
    "codigo":444143004,
    "descripcion":"PORTA TRATAMIENTO DE EMERGENCIA"
  },
  {
    "codigo":50927007,
    "descripcion":"TRASTORNO DE CARTÍLAGO"
  },
  {
    "codigo":247535008,
    "descripcion":"PATRÓN BIOLÓGICO DEL PELO"
  },
  {
    "codigo":212932001,
    "descripcion":"CONGELAMIENTO CON NECROSIS TISULAR DE RODILLA Y PIERNA"
  },
  {
    "codigo":737220002,
    "descripcion":"ANEMIA DEBIDA A TRASTORNO METABÓLICO"
  },
  {
    "codigo":704452006,
    "descripcion":"FRACTURA METAFISARIA EXPUESTA DE METATARSIANO"
  },
  {
    "codigo":278468008,
    "descripcion":"NISTAGMO INDUCIDO POR PRESIÓN"
  },
  {
    "codigo":243865006,
    "descripcion":"SITUACIÓN DEL MONITOREO DE TRASTORNO ALÉRGICO"
  },
  {
    "codigo":702617007,
    "descripcion":"PUSTULOSIS EXANTEMÁTICA GENERALIZADA AGUDA"
  },
  {
    "codigo":276633008,
    "descripcion":"TRASTORNO HIPOTÓNICO"
  },
  {
    "codigo":1259673008,
    "descripcion":"DEMENCIA DEBIDA A ENFERMEDAD DE CUERPOS DE INCLUSIÓN DE NEUROFILAMENTOS"
  },
  {
    "codigo":735385007,
    "descripcion":"TUMOR MALIGNO SÓLIDO CON ELEVADA INESTABILIDAD DE MICROSATÉLITE"
  },
  {
    "codigo":242030003,
    "descripcion":"SÍNCOPE POR FUERZA CENTRÍFUGA DURANTE EL VUELO"
  },
  {
    "codigo":405870002,
    "descripcion":"FENOTIPO LU(A+B-)"
  },
  {
    "codigo":209262007,
    "descripcion":"FRACTURA-SUBLUXACIÓN EXPUESTA DE LA ARTICULACIÓN RADIOCUBITAL SUPERIOR"
  },
  {
    "codigo":305731000,
    "descripcion":"ATENDIDO POR ENFERMERA"
  },
  {
    "codigo":830019003,
    "descripcion":"CORISTOMA DE GLOBO OCULAR DERECHO"
  },
  {
    "codigo":698947004,
    "descripcion":"TRASTORNO DE CONDUCTA EN REMISIÓN"
  },
  {
    "codigo":404035005,
    "descripcion":"TUMOR DE CÉLULAS GRANULARES"
  },
  {
    "codigo":402200000,
    "descripcion":"DERMATITIS ATÓPICA DEL ADULTO DE COMIENZO EN LA VIDA ADULTA"
  },
  {
    "codigo":762648006,
    "descripcion":"ESTENOSIS DE ARTERIA CEREBELOSA DERECHA"
  },
  {
    "codigo":205592008,
    "descripcion":"ALOPECIA LOCALIZADA CONGÉNITA"
  },
  {
    "codigo":271128009,
    "descripcion":"AMPOLLA TRAUMÁTICA DE LA VULVA"
  },
  {
    "codigo":1186797002,
    "descripcion":"HIPOPARATIROIDISMO DEBIDO A ENFERMEDAD DE WILSON"
  },
  {
    "codigo":236525007,
    "descripcion":"NEFRITIS CRÓNICA POR RADIACIÓN"
  },
  {
    "codigo":300226000,
    "descripcion":"CAPACIDAD NORMAL PARA OIR LA VOZ"
  },
  {
    "codigo":302061009,
    "descripcion":"LINFADENOPATÍA BRAQUIAL"
  },
  {
    "codigo":398530003,
    "descripcion":"BOTULISMO POR HERIDA"
  },
  {
    "codigo":365762007,
    "descripcion":"NIVEL DE CLORURO - HALLAZGO"
  },
  {
    "codigo":1119426009,
    "descripcion":"ENFERMEDAD INFECCIOSA TRANSMITIDA A TRAVÉS DE UNA TRANSFUSIÓN"
  },
  {
    "codigo":69015003,
    "descripcion":"URETRA DOBLE"
  },
  {
    "codigo":298391004,
    "descripcion":"DEFORMIDAD DE LA COLUMNA VERTEBRAL CERVICAL"
  },
  {
    "codigo":294071000119100,
    "descripcion":"HEMIPLEJÍA FLÁCCIDA DE LADO DERECHO NO DOMINANTE"
  },
  {
    "codigo":294721000,
    "descripcion":"ALERGIA A INSULINA CINC PROTAMINA"
  },
  {
    "codigo":722540008,
    "descripcion":"VÓLVULO DE INTESTINO GRUESO"
  },
  {
    "codigo":425793006,
    "descripcion":"AZOOSPERMIA POR ENFERMEDAD SISTÉMICA"
  },
  {
    "codigo":196417006,
    "descripcion":"TERCER MOLAR IMPACTADO"
  },
  {
    "codigo":67123006,
    "descripcion":"TRASTORNO DE LA IDENTIDAD SEXUAL DEL ADULTO, SEXUALMENTE ATRAÍDO POR AMBOS SEXOS"
  },
  {
    "codigo":1144854001,
    "descripcion":"PÉRDIDA PREMATURA DE PELO DE CUERO CABELLUDO"
  },
  {
    "codigo":129046002,
    "descripcion":"CONTINENCIA (ACTIVIDAD COTIDIANA)"
  },
  {
    "codigo":292886001,
    "descripcion":"REACCIÓN ADVERSA AL FORMALDEHÍDO"
  },
  {
    "codigo":63510008,
    "descripcion":"GLOMERULOESCLEROSIS NODULAR DE RIÑÓN DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":291051001,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ALPRAZOLAM"
  },
  {
    "codigo":30742008,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE NARIZ SIN INFECCIÓN"
  },
  {
    "codigo":225515003,
    "descripcion":"PAREJA SEXUAL DE LA MISMA GENERACIÓN"
  },
  {
    "codigo":699499004,
    "descripcion":"CURVA DE SPEE SUPERFICIAL"
  },
  {
    "codigo":5521000175101,
    "descripcion":"INCAPAZ DE COSTEAR MONITOR DE PRESIÓN ARTERIAL"
  },
  {
    "codigo":127211005,
    "descripcion":"LINFADENOPATÍA TIBIAL ANTERIOR"
  },
  {
    "codigo":1306859008,
    "descripcion":"INVERSIÓN DEL INTRÓN 1"
  },
  {
    "codigo":92608001,
    "descripcion":"CARCINOMA IN SITU DEL ÁNGULO HEPÁTICO DEL COLON"
  },
  {
    "codigo":289216002,
    "descripcion":"HALLAZGO RELACIONADO CON LA SEGUNDA ETAPA DEL TRABAJO DE PARTO"
  },
  {
    "codigo":1137514001,
    "descripcion":"DEBILIDAD DE MÚSCULO OBLICUO SUPERIOR"
  },
  {
    "codigo":56170001,
    "descripcion":"FOTOPSIA"
  },
  {
    "codigo":285546008,
    "descripcion":"DIFICULTAD PARA MOVER EL PALADAR BLANDO"
  },
  {
    "codigo":283711001,
    "descripcion":"MORDEDURA HUMANA EN LA ESPALDA"
  },
  {
    "codigo":23402009,
    "descripcion":"ESTRECHEZ CONGÉNITA DE ORIFICIO URETEROVESICAL"
  },
  {
    "codigo":677201000119104,
    "descripcion":"SÍNDROME DE HISTOPLASMOSIS DE AMBOS OJOS"
  },
  {
    "codigo":414783007,
    "descripcion":"COROIDITIS MULTIFOCAL"
  },
  {
    "codigo":249108000,
    "descripcion":"POSICIÓN IZQUIERDA ANTERIOR DE HOMBRO"
  },
  {
    "codigo":185407009,
    "descripcion":"PERSONA QUE ARREGLA UNA CITA"
  },
  {
    "codigo":314644003,
    "descripcion":"PERÍMETRO CEFÁLICO DEL NIÑO: PERCENTILO 0,4"
  },
  {
    "codigo":52500008,
    "descripcion":"BRONQUIECTASIA SACULAR"
  },
  {
    "codigo":773396009,
    "descripcion":"ARTROGRIPOSIS DISTAL TIPO 5D"
  },
  {
    "codigo":1363220009,
    "descripcion":"CICATRIZACIÓN DE PÁRPADO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":609556008,
    "descripcion":"INSUFICIENCIA CARDÍACA SISTÓLICA, ESTADIO A"
  },
  {
    "codigo":214505001,
    "descripcion":"ACCIDENTE DE TRÁNSITO VEHICULAR DE TIPO NO COLISIÓN CON INTOXICACIÓN ACCIDENTAL POR GASES DE ESCAPE GENERADOS POR EL VEHÍCULO EN MOVIMIENTO, PASAJERO DEL VEHÍCULO HERIDO"
  },
  {
    "codigo":81598001,
    "descripcion":"VULVOVAGINITIS TRICOMONIÁSICA"
  },
  {
    "codigo":704190008,
    "descripcion":"EDEMA MASIVO DE OVARIO"
  },
  {
    "codigo":472979002,
    "descripcion":"PROTRUSIÓN DE DISCO INTERVERTEBRAL DE BASE AMPLIA"
  },
  {
    "codigo":210835005,
    "descripcion":"LESIÓN DE VASO SANGUÍNEO RADIAL"
  },
  {
    "codigo":276371006,
    "descripcion":"MOVIMIENTOS FETALES INTENSOS"
  },
  {
    "codigo":79763005,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE EXTREMO DISTAL DE TIBIA"
  },
  {
    "codigo":702355008,
    "descripcion":"MIOTONÍA AGRAVADA POR POTASIO"
  },
  {
    "codigo":46995009,
    "descripcion":"FRACTURA NO EXPUESTA A NIVEL DE C5 - C7 CON LESIÓN TRAUMÁTICA DE LA MÉDULA ESPINAL"
  },
  {
    "codigo":1259411009,
    "descripcion":"CARCINOMA ESCAMOSO BRONQUIAL PRIMARIO EN LÓBULO INFERIOR DERECHO"
  },
  {
    "codigo":1290344003,
    "descripcion":"RESTAURACIÓN DENTAL MALEABLE COLOREADA EN DIENTE"
  },
  {
    "codigo":40141000087106,
    "descripcion":"LUXACIÓN DE ARTICULACIÓN DE DEDO MEÑIQUE DE MANO DERECHA"
  },
  {
    "codigo":42701000087108,
    "descripcion":"PROLAPSO DE DISCO INTERVERTEBRAL T1-T2"
  },
  {
    "codigo":47821000087108,
    "descripcion":"FRACTURA DE SEGUNDA COSTILLA DERECHA"
  },
  {
    "codigo":274536007,
    "descripcion":"HALLAZGOS ANORMALES EN IMÁGENES DIAGNÓSTICAS DE ÓRGANOS URINARIOS"
  },
  {
    "codigo":209000008,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE PIE"
  },
  {
    "codigo":733288008,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA A LA ALTURA DE LA CADERA IZQUIERDA"
  },
  {
    "codigo":43325004,
    "descripcion":"RUPTURA ESPLÉNICA NO TRAUMÁTICA"
  },
  {
    "codigo":698685004,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: TWI"
  },
  {
    "codigo":403773005,
    "descripcion":"SÍNDROME DE MILIA FACIAL, LENGUA LOBULADA, FRENILLO LINGUAL Y LABIAL"
  },
  {
    "codigo":238098000,
    "descripcion":"VARIANTE APO A-I MARBURG"
  },
  {
    "codigo":305469009,
    "descripcion":"BAJO ATENCIÓN DE ESPECIALISTA EN EL MANEJO DEL DOLOR"
  },
  {
    "codigo":205330003,
    "descripcion":"SINOSTOSIS HUMEROCUBITAL"
  },
  {
    "codigo":8722008,
    "descripcion":"VALVULOPATÍA AÓRTICA"
  },
  {
    "codigo":762386008,
    "descripcion":"DERMATITIS ALÉRGICA POR CONTACTO CAUSADA POR COMPUESTO DE CAUCHO"
  },
  {
    "codigo":170727003,
    "descripcion":"REGISTRADO COMO CIEGO"
  },
  {
    "codigo":6887003,
    "descripcion":"VULVOVAGINITIS CRÓNICA"
  },
  {
    "codigo":301799005,
    "descripcion":"ESTENOSIS DE COLOSTOMÍA"
  },
  {
    "codigo":365500004,
    "descripcion":"HALLAZGO RELACIONADO CON LA VIVIENDA, EL AMBIENTE LOCAL Y EL TRANSPORTE"
  },
  {
    "codigo":234428005,
    "descripcion":"TRASTORNO LINFOCITOIDE"
  },
  {
    "codigo":298129000,
    "descripcion":"VERRUGA PERINEAL FEMENINA"
  },
  {
    "codigo":1074991000000106,
    "descripcion":"INCAPAZ DE ACOSTARSE EN LA CAMA SIN ASISTENCIA"
  },
  {
    "codigo":3217005,
    "descripcion":"LUXACIÓN EXPUESTA DE LA SEXTA VÉRTEBRA CERVICAL"
  },
  {
    "codigo":679711000119102,
    "descripcion":"NEURITIS ÓPTICA RETROBULBAR DE OJO DERECHO"
  },
  {
    "codigo":66918004,
    "descripcion":"CELULITIS DEL FLANCO"
  },
  {
    "codigo":722278006,
    "descripcion":"LESIÓN RENAL AGUDA DEBIDA A SEPSIS"
  },
  {
    "codigo":165222009,
    "descripcion":"DEPENDIENTE PARA LA ALIMENTACIÓN"
  },
  {
    "codigo":230758009,
    "descripcion":"HERNIA TRANSTENTORIAL ASCENDENTE"
  },
  {
    "codigo":281267002,
    "descripcion":"ESPÉCIMEN INCORRECTO RECIBIDO"
  },
  {
    "codigo":294459009,
    "descripcion":"ALERGIA A ALBENDAZOL"
  },
  {
    "codigo":292624003,
    "descripcion":"REACCIÓN ADVERSA A POLVOS FACIALES"
  },
  {
    "codigo":718608006,
    "descripcion":"HIPOPLASIA PONTOCEREBELOSA CONGÉNITA TIPO 4"
  },
  {
    "codigo":716773002,
    "descripcion":"DILATACIÓN IDIOPÁTICA DE AURÍCULA DERECHA FAMILIAR"
  },
  {
    "codigo":11794361000119101,
    "descripcion":"RUPTURA TRAUMÁTICA DE TENDÓN DE MÚSCULO PECTORAL MAYOR DERECHO"
  },
  {
    "codigo":352031000119107,
    "descripcion":"MELANOMA MALIGNO DE PIEL DE CADERA IZQUIERDA"
  },
  {
    "codigo":290789005,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR AMANTADINA"
  },
  {
    "codigo":94181007,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LOS GANGLIOS LINFÁTICOS AXILARES"
  },
  {
    "codigo":782309008,
    "descripcion":"NEUROPATÍA INMUNOMEDIADA"
  },
  {
    "codigo":126949007,
    "descripcion":"NEUROMA ACÚSTICO"
  },
  {
    "codigo":288954001,
    "descripcion":"TRAGA SEMISÓLIDOS"
  },
  {
    "codigo":125114005,
    "descripcion":"HISTOMORFOLOGÍA MICROSCÓPICA NORMAL"
  },
  {
    "codigo":24975009,
    "descripcion":"ESFEROCITOSIS HEREDITARIA LEVE POR DEFICIENCIA COMBINADA DE ESPECTRINA Y ANQUIRINA"
  },
  {
    "codigo":449124002,
    "descripcion":"APERTURA EXCÉNTRICA DE VÁLVULA PULMONAR TRICÚSPIDE"
  },
  {
    "codigo":283449001,
    "descripcion":"HERIDA PUNZANTE EN LA CARA"
  },
  {
    "codigo":54073003,
    "descripcion":"VÁLVULA CARDÍACA MONOCÚSPIDE"
  },
  {
    "codigo":840505007,
    "descripcion":"SÍNDROME DE DOWN CONCOMITANTE CON PUSTULOSIS NEONATAL TRANSITORIA ASOCIADA CON REACCIÓN LEUCEMOIDE"
  },
  {
    "codigo":447289007,
    "descripcion":"DISCORDANCIA AURICULOVENTRICULAR CON ROTACIÓN HACIA LA IZQUIERDA"
  },
  {
    "codigo":248846001,
    "descripcion":"ORIFICIO DEL HIMEN, DILATADO"
  },
  {
    "codigo":414521009,
    "descripcion":"ORZUELO INTERNO"
  },
  {
    "codigo":1197283000,
    "descripcion":"CARCINOMA MIXTO ACINAR ENDOCRINO DUCTAL PRIMARIO DE PÁNCREAS"
  },
  {
    "codigo":445454009,
    "descripcion":"OBSTRUCCIÓN DEL TRACTO DE SALIDA DEL VENTRÍCULO IZQUIERDO POR VÁLVULA AURICULOVENTRICULAR"
  },
  {
    "codigo":247011006,
    "descripcion":"TAMAÑO Y FORMA DE LA PUPILA, NORMALES"
  },
  {
    "codigo":771299009,
    "descripcion":"PREMATUREZ DEL LACTANTE"
  },
  {
    "codigo":736696002,
    "descripcion":"HELICOBACTER PYLORI DETECTADO EN MATERIA FECAL"
  },
  {
    "codigo":105992002,
    "descripcion":"ANOMALÍA CONGÉNITA DE LA LENGUA, LA GLÁNDULA SALIVAL Y\/O LA FARINGE"
  },
  {
    "codigo":441784006,
    "descripcion":"GANGRENA CUTÁNEA PROGRESIVA"
  },
  {
    "codigo":210573000,
    "descripcion":"LESIÓN POR DESOLLAMIENTO DE MANO, REGIÓN DORSAL"
  },
  {
    "codigo":1290082000,
    "descripcion":"NEOPLASIA NEUROENDOCRINA DE BRONQUIO"
  },
  {
    "codigo":682221000119103,
    "descripcion":"ASTROCITOMA ANAPLÁSICO PRIMARIO DE CEREBRO"
  },
  {
    "codigo":43063000,
    "descripcion":"ATRESIA DEL MEATO ÓSEO DEL OÍDO MEDIO"
  },
  {
    "codigo":403511003,
    "descripcion":"VASCULITIS NECROSANTE ASOCIADA CON LUPUS ERITEMATOSO"
  },
  {
    "codigo":10295004,
    "descripcion":"HEPATITIS VIRAL CRÓNICA"
  },
  {
    "codigo":75831003,
    "descripcion":"TRASTORNO DE REFRACCIÓN Y\/O ACOMODACIÓN INDUCIDO POR DROGAS"
  },
  {
    "codigo":237836003,
    "descripcion":"TRASTORNO CON BAJA ESTATURA"
  },
  {
    "codigo":303372004,
    "descripcion":"DIFICULTAD PARA TIRAR"
  },
  {
    "codigo":205068007,
    "descripcion":"ENCORVAMIENTO CONGÉNITO DEL PERONÉ"
  },
  {
    "codigo":72161001,
    "descripcion":"INTOXICACIÓN POR AGROSTEMMA GITHAGO"
  },
  {
    "codigo":203233002,
    "descripcion":"INFECCIÓN DE TIBIA"
  },
  {
    "codigo":236001005,
    "descripcion":"HEMATOMA EPIPLOICO"
  },
  {
    "codigo":168630001,
    "descripcion":"RADIOGRAFÍA SIMPLE DE MUÑECA: NORMAL"
  },
  {
    "codigo":234166002,
    "descripcion":"SÍNCOPE VASOVAGAL POR INMERSIÓN"
  },
  {
    "codigo":365238001,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD DE UTILIZAR ANTEOJOS"
  },
  {
    "codigo":266934004,
    "descripcion":"PROBLEMA DE TRANSPORTE"
  },
  {
    "codigo":37558005,
    "descripcion":"CONDUCCIÓN SALTATORIA ANORMAL"
  },
  {
    "codigo":2955000,
    "descripcion":"PULPITIS ULCERATIVA CRÓNICA"
  },
  {
    "codigo":823990009,
    "descripcion":"NERVIO VAGO INTACTO"
  },
  {
    "codigo":363403002,
    "descripcion":"NEOPLASIA MALIGNA DE DUODENO"
  },
  {
    "codigo":12206471000119104,
    "descripcion":"INFECCIÓN ASOCIADA CON PRÓTESIS ARTICULAR DE HOMBRO DERECHO"
  },
  {
    "codigo":723851008,
    "descripcion":"OSTEOSARCOMA PRIMARIO DE CARTÍLAGO ARTICULAR DE MIEMBRO"
  },
  {
    "codigo":391000119105,
    "descripcion":"DEGENERACIÓN DE MÁCULA DEBIDA A QUISTE O AGUJERO"
  },
  {
    "codigo":263264005,
    "descripcion":"SÍNDROME COMPARTIMENTAL DE EXTREMIDAD SUPERIOR DEBIDO A LESIÓN TRAUMÁTICA"
  },
  {
    "codigo":296032008,
    "descripcion":"SOBREDOSIS DE PARALDEHÍDO"
  },
  {
    "codigo":230496009,
    "descripcion":"SUEÑO-VIGILIA QUE NO SE AJUSTA AL CICLO DE 24 HORAS"
  },
  {
    "codigo":15702561000119101,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE TENDÓN FLEXOR DE AMBAS MUÑECAS"
  },
  {
    "codigo":359733004,
    "descripcion":"LAXITUD ANORMALMENTE AUMENTADA"
  },
  {
    "codigo":1144330003,
    "descripcion":"HEMIATROFIA DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":194058007,
    "descripcion":"TRASTORNO DEL QUIASMA ÓPTICO POR NEOPLASIA NO HIPOFISARIA"
  },
  {
    "codigo":95754008,
    "descripcion":"ENTROPIÓN DEL PÁRPADO INFERIOR"
  },
  {
    "codigo":126687001,
    "descripcion":"NEOPLASIA DE LA REGIÓN POSCRICOIDEA"
  },
  {
    "codigo":718346009,
    "descripcion":"METAPLASIA INTESTINAL DE MEMBRANA MUCOSA DE CARDIAS GÁSTRICO"
  },
  {
    "codigo":292362007,
    "descripcion":"REACCIÓN ADVERSA AL TEMAZEPAM"
  },
  {
    "codigo":224991005,
    "descripcion":"REPRESIÓN A TRAVÉS DEL OLVIDO"
  },
  {
    "codigo":716511009,
    "descripcion":"UTILIZA SONIDOS COMBINADOS EN EL HABLA"
  },
  {
    "codigo":92084001,
    "descripcion":"NEOPLASIA BENIGNA DEL ENDOCÉRVIX"
  },
  {
    "codigo":288692002,
    "descripcion":"NO ADAPTA LA CONVERSACIÓN A UN CONTEXTO"
  },
  {
    "codigo":712841000,
    "descripcion":"ALERGIA A CEBADA"
  },
  {
    "codigo":24713001,
    "descripcion":"INTOXICACIÓN POR SWAINSONA"
  },
  {
    "codigo":450697004,
    "descripcion":"HIPERPLASIA LOBULILLAR ATÍPICA DE MAMA"
  },
  {
    "codigo":286857004,
    "descripcion":"EX - BEBEDOR PROBLEMA"
  },
  {
    "codigo":1204361005,
    "descripcion":"REFRIGERACIÓN ADECUADA EN LA VIVIENDA"
  },
  {
    "codigo":1237129009,
    "descripcion":"ATEROSCLEROSIS DE ARTERIA DE EXTREMIDAD INFERIOR IZQUIERDA"
  },
  {
    "codigo":22878006,
    "descripcion":"CONTUSIÓN DE LA RODILLA"
  },
  {
    "codigo":285022007,
    "descripcion":"CAPAZ DE MANEJAR UN ARTEFACTO MIENTRAS SE VISTE"
  },
  {
    "codigo":88414008,
    "descripcion":"TIC DE PENSÉE"
  },
  {
    "codigo":283187000,
    "descripcion":"CUERPO EXTRAÑO METÁLICO EN LA PLANTA DEL PIE"
  },
  {
    "codigo":55646008,
    "descripcion":"INTOXICACIÓN POR KALLSTROEMIA HIRSUTISSIMA"
  },
  {
    "codigo":1004083003,
    "descripcion":"TRASTORNO NEONATAL DEBIDO A ENFERMEDAD PERIODONTAL MATERNA"
  },
  {
    "codigo":10626151000119100,
    "descripcion":"CARBUNCO DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":10628711000119101,
    "descripcion":"DERMATITIS ALÉRGICA POR CONTACTO CAUSADA POR VEGETAL"
  },
  {
    "codigo":16754791000119101,
    "descripcion":"SANGRADO UTERINO ANORMAL DEBIDO A FIBROMA UTERINO INTRAMURAL"
  },
  {
    "codigo":10674791000119101,
    "descripcion":"EXACERBACIÓN AGUDA DE ASMA ALÉRGICO INTERMITENTE"
  },
  {
    "codigo":16004711000119104,
    "descripcion":"VARIANZA CUBITAL POSITIVA CONGÉNITA DE MUÑECA DERECHA"
  },
  {
    "codigo":16314471000119102,
    "descripcion":"INFECCIÓN POR TIÑA DE PIE MODIFICADA POR ESTEROIDES"
  },
  {
    "codigo":16027751000119103,
    "descripcion":"EXOSTOSIS DE FÉMUR IZQUIERDO"
  },
  {
    "codigo":15999591000119107,
    "descripcion":"CUERPO EXTRAÑO RETENIDO EN CÁMARA ANTERIOR DE OJO IZQUIERDO"
  },
  {
    "codigo":10679911000119107,
    "descripcion":"TUMORACIÓN DEL TEJIDO CELULAR SUBCUTÁNEO DE LA MANO IZQUIERDA"
  },
  {
    "codigo":10948711000119104,
    "descripcion":"HERIDA ABIERTA DE MANO DERECHA DEBIDA A MORDEDURA DE ANIMAL"
  },
  {
    "codigo":299111000119106,
    "descripcion":"HEMARTROSIS DE TOBILLO DERECHO"
  },
  {
    "codigo":340071000119109,
    "descripcion":"EVERSIÓN DE PUNTO LAGRIMAL DE PÁRPADO IZQUIERDO"
  },
  {
    "codigo":690791000119107,
    "descripcion":"ÚLCERA PENETRANTE DE AORTA"
  },
  {
    "codigo":286311000119104,
    "descripcion":"GANGRENA DEBIDA A FENÓMENO DE RAYNAUD SECUNDARIO"
  },
  {
    "codigo":15989351000119108,
    "descripcion":"CONJUNTIVITIS DE OJO IZQUIERDO CAUSADA POR VIRUS HERPES ZÓSTER"
  },
  {
    "codigo":68711000119109,
    "descripcion":"NEUROPATÍA GENITOFEMORAL"
  },
  {
    "codigo":838408006,
    "descripcion":"CAPAZ DE VER MOVIMIENTO DE LA MANO A TRAVÉS DE AGUJERO ESTENOPEICO CON EL OJO DERECHO"
  },
  {
    "codigo":10631271000119109,
    "descripcion":"ABSCESO DE PIEL DE RODILLA IZQUIERDA"
  },
  {
    "codigo":12238951000119109,
    "descripcion":"ALTERACIÓN DE ALINEACIÓN DE RODILLA DERECHA"
  },
  {
    "codigo":84821000119100,
    "descripcion":"SARCOMA FOLICULAR PRIMARIO DE CÉLULAS DENDRÍTICAS DE BAZO"
  },
  {
    "codigo":1231624007,
    "descripcion":"DEBILIDAD DE TERCER PAR CRANEAL SIN COMPROMISO DE PUPILA"
  },
  {
    "codigo":246749005,
    "descripcion":"HIPERTROPÍA INCOMITANTE"
  },
  {
    "codigo":736434005,
    "descripcion":"RUPTURA TRAUMÁTICA DE HÍGADO"
  },
  {
    "codigo":13703002,
    "descripcion":"SIN AUMENTO DE ANTICUERPOS ANTIBACTERIANOS, ESPECÍMENES PAREADOS"
  },
  {
    "codigo":208476001,
    "descripcion":"FRACTURA EXPUESTA DE LA FALANGE DISTAL DEL PULGAR, MARTILLO"
  },
  {
    "codigo":306780002,
    "descripcion":"CAPAZ DE TOSER VOLUNTARIAMENTE"
  },
  {
    "codigo":110172003,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DE REGIÓN PERIORBITARIA"
  },
  {
    "codigo":11868005,
    "descripcion":"QUEMADURA DE SITIOS MÚLTIPLES DEL TRONCO"
  },
  {
    "codigo":44636008,
    "descripcion":"PANCREATITIS INTERSTICIAL"
  },
  {
    "codigo":1156913001,
    "descripcion":"INMUNE A MENINGOCOCO"
  },
  {
    "codigo":1255217000,
    "descripcion":"RUPTURA TRAUMÁTICA DE TENDÓN DE MÚSCULO INFRAESPINOSO"
  },
  {
    "codigo":403249003,
    "descripcion":"CABELLO CASTAÑO CLARO"
  },
  {
    "codigo":370481004,
    "descripcion":"VÉRTEBRA DE TRANSICIÓN"
  },
  {
    "codigo":698161008,
    "descripcion":"AEROMONAS O PLESIOMONAS PRESENTES"
  },
  {
    "codigo":204806003,
    "descripcion":"AGENESIA DE PÁNCREAS"
  },
  {
    "codigo":235739003,
    "descripcion":"FÍSTULA YEYUNOCUTÁNEA"
  },
  {
    "codigo":39131004,
    "descripcion":"LESIÓN TRAUMÁTICA DE CORAZÓN SIN HERIDA ABIERTA HACIA EL TÓRAX"
  },
  {
    "codigo":16032751000119104,
    "descripcion":"NECROSIS AVASCULAR DE HUESO DE REGIÓN DE CODO DERECHO"
  },
  {
    "codigo":202971005,
    "descripcion":"RUPTURA DE TENDÓN DEL MÚSCULO FLEXOR LARGO DEL PULGAR"
  },
  {
    "codigo":10626031000119105,
    "descripcion":"ÁNTRAX DE AXILA DERECHA"
  },
  {
    "codigo":233904005,
    "descripcion":"TAQUICARDIA RECIPROCANTE PERMANENTE DE LA UNIÓN"
  },
  {
    "codigo":201136006,
    "descripcion":"ALOPECIA FEBRIL"
  },
  {
    "codigo":364976008,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD DE PRENSIÓN"
  },
  {
    "codigo":102832009,
    "descripcion":"VEJIGA URINARIA NEUROGÉNICA NO INHIBIDA"
  },
  {
    "codigo":232069006,
    "descripcion":"DESPRENDIMIENTO DEL EPITELIO PIGMENTARIO RETINIANO CON DESGARRO DEL EPITELIO PIGMENTARIO DE LA RETINA"
  },
  {
    "codigo":263002002,
    "descripcion":"SECCIÓN TRAUMÁTICA DE CÁPSULA ARTICULAR"
  },
  {
    "codigo":721754004,
    "descripcion":"MENINGITIS CAUSADA POR TROPHERYMA WHIPPLEI"
  },
  {
    "codigo":230234006,
    "descripcion":"ATAXIA PERIÓDICA"
  },
  {
    "codigo":295770008,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE AMINOGLUTETIMIDA"
  },
  {
    "codigo":293935001,
    "descripcion":"ALERGIA A CLORPROMAZINA"
  },
  {
    "codigo":64559002,
    "descripcion":"HIPERVITAMINOSIS A"
  },
  {
    "codigo":162863004,
    "descripcion":"ÍNDICE DE MASA CORPORAL 25-29, SOBREPESO"
  },
  {
    "codigo":425007008,
    "descripcion":"MIGRAÑA SIN AURA, NO REFRACTARIA"
  },
  {
    "codigo":29956001,
    "descripcion":"MIELATELIA"
  },
  {
    "codigo":228399008,
    "descripcion":"COMPARTE JERINGAS"
  },
  {
    "codigo":95492008,
    "descripcion":"HIPOPIGMENTACIÓN CONGÉNITA DE LA MEMBRANA COROIDES"
  },
  {
    "codigo":783620009,
    "descripcion":"HIPOFOSFATEMIA DOMINANTE CON NEFROLITIASIS Y\/U OSTEOPOROSIS"
  },
  {
    "codigo":290265004,
    "descripcion":"INTOXICACIÓN POR KETOPROFENO"
  },
  {
    "codigo":93657007,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL NERVIO MOTOR OCULAR EXTERNO"
  },
  {
    "codigo":880089008,
    "descripcion":"DISTENSIÓN DE MÚSCULO Y TENDÓN DE PIERNA"
  },
  {
    "codigo":716249009,
    "descripcion":"SÍNDROME DE TETRA-AMELIA CON MÚLTIPLES MALFORMACIONES"
  },
  {
    "codigo":714414002,
    "descripcion":"DIFICULTAD PARA ALCANZAR UNA FRECUENCIA CARDÍACA OBJETIVO"
  },
  {
    "codigo":288430003,
    "descripcion":"CAPAZ DE UTILIZAR PINZAS"
  },
  {
    "codigo":10927241000119109,
    "descripcion":"FRACTURA NO EXPUESTA DE CUELLO DE PRIMER METACARPIANO DE MANO IZQUIERDA"
  },
  {
    "codigo":1236867000,
    "descripcion":"DOLOR DEBIDO A TRAUMATISMO DENTAL"
  },
  {
    "codigo":712579003,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE HUESO MAXILOFACIAL"
  },
  {
    "codigo":253827005,
    "descripcion":"MALFORMACIÓN CONGÉNITA DE ÚTERO Y CUELLO UTERINO"
  },
  {
    "codigo":57219006,
    "descripcion":"SÍNDROME DE CRANEOSINOSTOSIS"
  },
  {
    "codigo":89987007,
    "descripcion":"PAPILOMATOSIS CONFLUENTE Y RETICULADA"
  },
  {
    "codigo":284760000,
    "descripcion":"ARRANCARSE LA PIEL"
  },
  {
    "codigo":448600002,
    "descripcion":"VENTRÍCULO DERECHO A LA DERECHA DEL VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":282925001,
    "descripcion":"CAPAZ DE RECOSTARSE"
  },
  {
    "codigo":741677004,
    "descripcion":"HERNIA CRURAL IZQUIERDA RECURRENTE"
  },
  {
    "codigo":444930000,
    "descripcion":"ANTICUERPO ANTI-CITOMEGALOVIRUS NO DETECTADO EN SUERO"
  },
  {
    "codigo":1296898001,
    "descripcion":"RESISTENCIA HEREDITARIA A ARGININA VASOPRESINA"
  },
  {
    "codigo":248322002,
    "descripcion":"PÉRDIDA LOCALIZADA DE GRASA CORPORAL"
  },
  {
    "codigo":1264130004,
    "descripcion":"TÉTANOS POSTERIOR A EMBARAZO ECTÓPICO"
  },
  {
    "codigo":14914851000119109,
    "descripcion":"CARCINOMA METASTÁSICO DE CÉLULAS DE MERKEL DE PIEL"
  },
  {
    "codigo":443095000,
    "descripcion":"HEMICRANIA CONTINUA"
  },
  {
    "codigo":836311001,
    "descripcion":"AGUDEZA VISUAL DE OJO DERECHO 6\/48"
  },
  {
    "codigo":17111003,
    "descripcion":"NEURALGIA POSTINFECCIOSA"
  },
  {
    "codigo":770775003,
    "descripcion":"BLEFAROCONJUNTIVITIS DE OJO DERECHO"
  },
  {
    "codigo":11857341000119104,
    "descripcion":"LACERACIÓN DEL TENDÓN DE AQUILES DERECHO"
  },
  {
    "codigo":15276008,
    "descripcion":"ANEMIA CAUSADA POR DEFICIENCIA ENZIMÁTICA INDUCIDA POR DROGAS"
  },
  {
    "codigo":1293228008,
    "descripcion":"ARTRITIS DE ARTICULACIÓN DE REGIÓN DE MUÑECA CAUSADA POR STREPTOCOCCUS"
  },
  {
    "codigo":78977005,
    "descripcion":"VÉRTIGO OCULAR"
  },
  {
    "codigo":275585008,
    "descripcion":"PACIENTE QUE AGUARDA REALIZACIÓN DE PROCEDIMIENTO"
  },
  {
    "codigo":109910003,
    "descripcion":"MASTOIDITIS SUPURATIVA CRÓNICA"
  },
  {
    "codigo":697899000,
    "descripcion":"HIPERTENSIÓN DE ARTERIA PULMONAR HEREDITARIA DEBIDA A MUTACIÓN DE BMPR2"
  },
  {
    "codigo":239147000,
    "descripcion":"MASTOCITOMA CUTÁNEO"
  },
  {
    "codigo":206379003,
    "descripcion":"SEPSIS NEONATAL POR ESCHERICHIA COLI"
  },
  {
    "codigo":75307004,
    "descripcion":"HIPERPLASIA EPITELIAL DE LA PIEL"
  },
  {
    "codigo":402987006,
    "descripcion":"ACTINOMICETOMA CAUSADO POR NOCARDIA OTITIDIS CAVIARUM"
  },
  {
    "codigo":9771006,
    "descripcion":"ALTERACIÓN DE CUERNO ANTERIOR DE MENISCO INTERNO"
  },
  {
    "codigo":370219009,
    "descripcion":"ASMA MODERADA"
  },
  {
    "codigo":204544004,
    "descripcion":"ATRESIA DE LARINGE Y TRÁQUEA"
  },
  {
    "codigo":302848008,
    "descripcion":"LINFOMA MALIGNO NODULAR, LINFOCÍTICO - DIFERENCIACIÓN INTERMEDIA"
  },
  {
    "codigo":268245001,
    "descripcion":"FETO ARLEQUÍN"
  },
  {
    "codigo":335601000119101,
    "descripcion":"ESTAFILOMA CORNEAL DE OJO DERECHO"
  },
  {
    "codigo":399317006,
    "descripcion":"BRADICINESIA"
  },
  {
    "codigo":233642001,
    "descripcion":"NEUMOTÓRAX PREMENSTRUAL"
  },
  {
    "codigo":102570003,
    "descripcion":"DOLOR INGUINAL"
  },
  {
    "codigo":69802008,
    "descripcion":"SUTURA DE CERCLAJE CERVICAL PRESENTE"
  },
  {
    "codigo":264575002,
    "descripcion":"INFECCIÓN ANAERÓBICA SOBREAGREGADA"
  },
  {
    "codigo":428415003,
    "descripcion":"TRANSITORIAMENTE CONFINADO EN EL DOMICILIO"
  },
  {
    "codigo":788863007,
    "descripcion":"TRASTORNO AMNÉSICO CAUSADO POR SUSTANCIA PSICOACTIVA"
  },
  {
    "codigo":231807007,
    "descripcion":"BLEFAROFIMOSIS SENIL"
  },
  {
    "codigo":262740001,
    "descripcion":"LESIÓN POR TRACCIÓN DE LA RAÍZ DE NERVIO CERVICAL"
  },
  {
    "codigo":67967009,
    "descripcion":"FACIES CUSHINGOIDE"
  },
  {
    "codigo":596004,
    "descripcion":"TRASTORNO DISFÓRICO PREMENSTRUAL"
  },
  {
    "codigo":721492004,
    "descripcion":"SÍNDROME DE BROWN-SEQUARD AL NIVEL DEL DECIMOPRIMER SEGMENTO DORSAL"
  },
  {
    "codigo":295508004,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE KETAMINA"
  },
  {
    "codigo":719657001,
    "descripcion":"SÍNDROME DE MICRODELECIÓN 2Q23.1"
  },
  {
    "codigo":31529002,
    "descripcion":"TROMBOSIS ARTERIAL DEL MIEMBRO SUPERIOR"
  },
  {
    "codigo":228137002,
    "descripcion":"EXCLUIDO DE LA ESCUELA EN FORMA PERMANENTE"
  },
  {
    "codigo":293673004,
    "descripcion":"ALERGIA A NABILONA"
  },
  {
    "codigo":129833008,
    "descripcion":"INCUMPLIMIENTO DE RÉGIMEN DE VOLUMEN DE LÍQUIDOS"
  },
  {
    "codigo":816126002,
    "descripcion":"EXAGERACIÓN DE REFLEJO BRAQUIORRADIAL"
  },
  {
    "codigo":95230004,
    "descripcion":"RETICULOSARCOMA DE LOS GANGLIOS LINFÁTICOS DE LOCALIZACIONES MÚLTIPLES"
  },
  {
    "codigo":291838005,
    "descripcion":"INTOXICACIÓN POR ANDRÓGENOS"
  },
  {
    "codigo":717822006,
    "descripcion":"SÍNDROME DE MEGACOLON DE GOLDBERG SHPRINTZEN"
  },
  {
    "codigo":1078270006,
    "descripcion":"AGENESIA DE EPÍFISIS DE FALANGE PROXIMAL DE DEDO GORDO"
  },
  {
    "codigo":715987000,
    "descripcion":"SÍNDROME DE DEFECTO CARDÍACO CONGÉNITO CON CARA REDONDA Y RETRASO DEL DESARROLLO"
  },
  {
    "codigo":422910009,
    "descripcion":"SECRECIÓN UROGENITAL ANORMAL"
  },
  {
    "codigo":421075007,
    "descripcion":"COMA CETOACIDÓSICO DEBIDO A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":60627008,
    "descripcion":"HERNIA OBTURATRIZ"
  },
  {
    "codigo":93395007,
    "descripcion":"ANO PEQUEÑO CONGÉNITO"
  },
  {
    "codigo":632240011000119105,
    "descripcion":"CREPITACIÓN DE ARTICULACIÓN DE AMBOS TOBILLOS"
  },
  {
    "codigo":224467009,
    "descripcion":"DEGRADADO EN EL TRABAJO"
  },
  {
    "codigo":419240004,
    "descripcion":"CARCINOMA ESCAMOCELULAR DE LA MEMBRANA MUCOSA DE LABIO SUPERIOR"
  },
  {
    "codigo":714152005,
    "descripcion":"ENFERMEDAD RENAL CRÓNICA, ESTADIO 5, EN DIÁLISIS"
  },
  {
    "codigo":188029000,
    "descripcion":"SARCOMA DE KAPOSI DE PARTES BLANDAS"
  },
  {
    "codigo":384637002,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA PROXIMAL NO AFECTADO POR CARCINOMA IN SITU\/ADENOMA"
  },
  {
    "codigo":1269373003,
    "descripcion":"CRISIS EPILÉPTICA HIPERQUINÉTICA CON ALTERACIÓN DE CONCIENCIA DE INICIO FOCAL"
  },
  {
    "codigo":417405005,
    "descripcion":"CORIORRETINITIS CON COCCIDIOIDOMICOSIS"
  },
  {
    "codigo":286333006,
    "descripcion":"INCAPAZ DE PRODUCIR UN TONO ADECUADO"
  },
  {
    "codigo":253565007,
    "descripcion":"DEFECTO DEL TABIQUE INTERVENTRICULAR MUSCULAR EN LA PORCIÓN TRABECULAR APICAL"
  },
  {
    "codigo":284498001,
    "descripcion":"REFUERZO SECUNDARIO DE LA CONDUCTA"
  },
  {
    "codigo":251730004,
    "descripcion":"GONIODISGENESIS"
  },
  {
    "codigo":186194007,
    "descripcion":"TUBERCULOSIS PULMONAR, CONFIRMADA ÚNICAMENTE POR CULTIVO"
  },
  {
    "codigo":315431007,
    "descripcion":"NACIDO EN ALEMANIA"
  },
  {
    "codigo":1003559008,
    "descripcion":"AGENESIA DE OMÓPLATO"
  },
  {
    "codigo":249895009,
    "descripcion":"PÉRDIDA DE AGILIDAD"
  },
  {
    "codigo":444668001,
    "descripcion":"RETRACCIÓN PALPEBRAL CONGÉNITA"
  },
  {
    "codigo":248060003,
    "descripcion":"DESCUIDO FRENTE A PELIGROS COMUNES"
  },
  {
    "codigo":410065004,
    "descripcion":"ANOMALÍA CONGÉNITA DEL CAYADO AÓRTICO Y\/O DE LA AORTA DESCENDIENTE"
  },
  {
    "codigo":82385007,
    "descripcion":"SÍNDROME DE BUDD - CHIARI"
  },
  {
    "codigo":1260198000,
    "descripcion":"SÍNDROME NEFRÓTICO IDIOPÁTICO SENSIBLE A ESTEROIDES CON RESISTENCIA SECUNDARIA A ESTEROIDES"
  },
  {
    "codigo":735910003,
    "descripcion":"ISQUEMIA DE MÚSCULO DEBIDA A LESIÓN TRAUMÁTICA"
  },
  {
    "codigo":277158007,
    "descripcion":"HIPERPLASIA ENDOMETRIAL ATÍPICA"
  },
  {
    "codigo":1075391000119104,
    "descripcion":"RUPTURA CRÓNICA DE LIGAMENTO LATERAL EXTERNO DE RODILLA DERECHA"
  },
  {
    "codigo":78715003,
    "descripcion":"BURSITIS SUBDELTOIDEA"
  },
  {
    "codigo":111483008,
    "descripcion":"ESQUIZOFRENIA CATATÓNICA EN REMISIÓN"
  },
  {
    "codigo":207952002,
    "descripcion":"FRACTURA EXPUESTA DE VÉRTEBRA DORSAL, ESPONDILÓLISIS"
  },
  {
    "codigo":76880004,
    "descripcion":"SÍNDROME DE ANGELMAN"
  },
  {
    "codigo":11780441000119100,
    "descripcion":"LESIÓN TRAUMÁTICA DE CARTÍLAGO ARTICULAR DE RODILLA IZQUIERDA"
  },
  {
    "codigo":109648006,
    "descripcion":"TRAUMATISMO OCLUSAL PRIMARIO"
  },
  {
    "codigo":240720008,
    "descripcion":"CANDIDIASIS DEL SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":1254693002,
    "descripcion":"RUPTURA TRAUMÁTICA DE LIGAMENTO COLATERAL DE ARTICULACIÓN DE DEDO MEÑIQUE"
  },
  {
    "codigo":42277004,
    "descripcion":"PRODUCCIÓN DISMINUIDA TRANSITORIA DE T>3<"
  },
  {
    "codigo":402725005,
    "descripcion":"HIPERLIPEMIA CON DEPÓSITOS DE LÍPIDOS EN PIEL"
  },
  {
    "codigo":271653008,
    "descripcion":"INGURGITACIÓN VENOSA YUGULAR"
  },
  {
    "codigo":7674000,
    "descripcion":"SÍNDROME DE DOLOR DEL TROCÁNTER MAYOR"
  },
  {
    "codigo":1285626001,
    "descripcion":"HEMATOMA DE TERCER DEDO DE PIE"
  },
  {
    "codigo":269818000,
    "descripcion":"MIELOCITOS, PRESENTES"
  },
  {
    "codigo":40442005,
    "descripcion":"RECHAZO CELULAR AGUDO DE INJERTO"
  },
  {
    "codigo":237050007,
    "descripcion":"FIMOSIS TUBARIA"
  },
  {
    "codigo":71375000,
    "descripcion":"TUBERCULOSIS DE LA APÓFISIS MASTOIDES"
  },
  {
    "codigo":726735000,
    "descripcion":"AMELIA AUTOSÓMICA RECESIVA"
  },
  {
    "codigo":300751003,
    "descripcion":"INCAPAZ DE REALIZAR ACTIVIDADES DE JARDINERÍA"
  },
  {
    "codigo":366287005,
    "descripcion":"HALLAZGO RELACIONADO CON LA FORMA DEL PENE"
  },
  {
    "codigo":298916004,
    "descripcion":"AMPLITUD DE PRONACIÓN ACTIVA DEL CODO DISMINUIDA"
  },
  {
    "codigo":297081000,
    "descripcion":"SOBREDOSIS INTENCIONAL DE HIDRALAZINA"
  },
  {
    "codigo":724900009,
    "descripcion":"LACERACIÓN DE FASCIA DE REGIÓN INFERIOR DEL DORSO"
  },
  {
    "codigo":2169001,
    "descripcion":"RADICULITIS DE NERVIO TORÁCICO"
  },
  {
    "codigo":723065009,
    "descripcion":"HERNIA PARAESTOMAL CON GANGRENA"
  },
  {
    "codigo":295246005,
    "descripcion":"SOBREDOSIS DE FLURBIPROFENO"
  },
  {
    "codigo":65870008,
    "descripcion":"HÁLITO DE HÍGADO"
  },
  {
    "codigo":719395001,
    "descripcion":"SÍNDROME DE HADZISELIMOVIC"
  },
  {
    "codigo":162339002,
    "descripcion":"EVALUACIÓN AUDITIVA NORMAL"
  },
  {
    "codigo":196942009,
    "descripcion":"HERNIA CIÁTICA CON GANGRENA"
  },
  {
    "codigo":293411003,
    "descripcion":"REACCIÓN ADVERSA AL POTASIO POR VÍA PARENTERAL"
  },
  {
    "codigo":1145379001,
    "descripcion":"APLASIA DE MÚSCULO DE BRAZO"
  },
  {
    "codigo":285171000119104,
    "descripcion":"OCLUSIÓN DE ARTERIA CARÓTIDA DERECHA"
  },
  {
    "codigo":129571008,
    "descripcion":"SÍNDROME DE ASPIRACIÓN EN EL ADULTO"
  },
  {
    "codigo":94968001,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL LÓBULO OCCIPITAL"
  },
  {
    "codigo":291576006,
    "descripcion":"INTOXICACIÓN POR LATAMOXEF"
  },
  {
    "codigo":783096008,
    "descripcion":"SÍNDROME DE ESTENOSIS SUBAÓRTICA Y BAJA ESTATURA"
  },
  {
    "codigo":715725001,
    "descripcion":"SINDACTILIA TIPO 3"
  },
  {
    "codigo":224205001,
    "descripcion":"TIENE CAJA DE AHORROS PROPIA"
  },
  {
    "codigo":160504008,
    "descripcion":"ESTADO CIVIL DESCONOCIDO"
  },
  {
    "codigo":12081651000119107,
    "descripcion":"QUEMADURA DE SACO CONJUNTIVAL DE OJO IZQUIERDO"
  },
  {
    "codigo":289741005,
    "descripcion":"ÚTERO CONTRAÍDO"
  },
  {
    "codigo":27597005,
    "descripcion":"QUEMADURA PROFUNDA DE TERCER GRADO DE LOS ÓRGANOS GENITALES FEMENINOS"
  },
  {
    "codigo":11809421000119102,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE PIERNA DERECHA"
  },
  {
    "codigo":1010637009,
    "descripcion":"OBSTRUCCIÓN DE TROMPA DE EUSTAQUIO POR INFLAMACIÓN"
  },
  {
    "codigo":1172642005,
    "descripcion":"GONADOTROFINA CORIÓNICA HUMANA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":255138006,
    "descripcion":"CARCINOMA IN SITU DE GARGANTA, NARIZ Y OÍDO"
  },
  {
    "codigo":713890008,
    "descripcion":"HIPOXEMIA DURANTE PROCEDIMIENTO QUIRÚRGICO"
  },
  {
    "codigo":253303001,
    "descripcion":"TRONCO AÓRTICO SOLITARIO CON ATRESIA PULMONAR"
  },
  {
    "codigo":25762009,
    "descripcion":"AGNOSIA VISUAL"
  },
  {
    "codigo":449911003,
    "descripcion":"HERIDA DE GUERRA POR EXPLOSIÓN AÉREA"
  },
  {
    "codigo":124066009,
    "descripcion":"TIROSINA POR DEBAJO DE RANGO DE REFERENCIA"
  },
  {
    "codigo":251468001,
    "descripcion":"REGISTRO TIPO BETA DE COMA"
  },
  {
    "codigo":87628006,
    "descripcion":"ENFERMEDAD INFECCIOSA BACTERIANA"
  },
  {
    "codigo":85793001,
    "descripcion":"PROLAPSO DE OVARIO"
  },
  {
    "codigo":249633001,
    "descripcion":"PÓLIPO CENTINELA"
  },
  {
    "codigo":446241005,
    "descripcion":"QUERATOACANTOMA DE PIEL DE LA MUÑECA"
  },
  {
    "codigo":216865005,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR CLORO"
  },
  {
    "codigo":772086000,
    "descripcion":"ESTATURA BAJA DESPROPORCIONADA"
  },
  {
    "codigo":1003297009,
    "descripcion":"CLINODACTILIA CONGÉNITA DE DEDO ANULAR"
  },
  {
    "codigo":1263606005,
    "descripcion":"TRASTORNO FETAL DEBIDO A INDUCCIÓN MÉDICA DE TRABAJO DE PARTO"
  },
  {
    "codigo":10963751000119104,
    "descripcion":"LACERACIÓN DE MUSLO DERECHO"
  },
  {
    "codigo":213195005,
    "descripcion":"FALLA DE INJERTO DE HUESO"
  },
  {
    "codigo":1360075006,
    "descripcion":"SÍNDROME DE HAO FOUNTAIN"
  },
  {
    "codigo":409803007,
    "descripcion":"INFECCIÓN CAUSADA POR ESCHERICHIA COLI PRODUCTORA DE BETALACTAMASA DE AMPLIO ESPECTRO"
  },
  {
    "codigo":1163467009,
    "descripcion":"INFECCIÓN GASTROINTESTINAL POR HERPES SIMPLE"
  },
  {
    "codigo":735648006,
    "descripcion":"LESIÓN TRAUMÁTICA DE AMBAS VÍAS ÓPTICAS"
  },
  {
    "codigo":211360008,
    "descripcion":"PICADURA DE INSECTO, NO VENENOSO, EN LA RODILLA"
  },
  {
    "codigo":406133002,
    "descripcion":"TASA ELEVADA DE DELINCUENCIA EN UNA COMUNIDAD"
  },
  {
    "codigo":1290869007,
    "descripcion":"OSTEOSARCOMA DE SUPERFICIE DE ALTO GRADO"
  },
  {
    "codigo":16098241000119102,
    "descripcion":"ARTROFIBROSIS DE ARTICULACIÓN DE DEDO DE MANO IZQUIERDA"
  },
  {
    "codigo":10937281000119102,
    "descripcion":"FRACTURA NO EXPUESTA DE HUESO SEMILUNAR DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":76618002,
    "descripcion":"ESTRECHEZ URETRAL"
  },
  {
    "codigo":699210003,
    "descripcion":"LESIÓN DE NASOFARINGE"
  },
  {
    "codigo":830282006,
    "descripcion":"INTOXICACIÓN CAUSADA POR INHIBIDOR DE ALDEHÍDO DESHIDROGENASA"
  },
  {
    "codigo":240458006,
    "descripcion":"NEUROBARTONELOSIS"
  },
  {
    "codigo":109386008,
    "descripcion":"SARCOMA DE KAPOSI CUTÁNEO"
  },
  {
    "codigo":11082009,
    "descripcion":"EMBARAZO ANORMAL"
  },
  {
    "codigo":369695000,
    "descripcion":"MARGEN LATERAL SUPERIOR DE RESECCIÓN QUIRÚRGICA DE RECTO, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":402463003,
    "descripcion":"AMILOIDOSIS CUTÁNEA FAMILIAR LOCALIZADA"
  },
  {
    "codigo":1287199002,
    "descripcion":"NEVO MELANOCÍTICO DE PÁRPADO INFERIOR"
  },
  {
    "codigo":762911004,
    "descripcion":"AGENESIA DE RIÑÓN DERECHO CONCOMITANTE CON DISPLASIA CONGÉNITA DE RIÑÓN IZQUIERDO"
  },
  {
    "codigo":72948000,
    "descripcion":"ANOMALÍA CONGÉNITA DE EPIGLOTIS"
  },
  {
    "codigo":74783009,
    "descripcion":"ESTENOSIS DEL ORIFICIO LAGRIMAL"
  },
  {
    "codigo":105716006,
    "descripcion":"INFECCIÓN CAUSADA POR CORDADOS"
  },
  {
    "codigo":1187060007,
    "descripcion":"ÍNDICE METABÓLICO BASAL POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":236788009,
    "descripcion":"INFERTILIDAD MASCULINA PRIMARIA"
  },
  {
    "codigo":234953003,
    "descripcion":"DIENTE TUBERCULADO SUPERNUMERARIO"
  },
  {
    "codigo":202185004,
    "descripcion":"LUXACIÓN PATOLÓGICA DE ARTICULACIÓN METACARPOFALÁNGICA"
  },
  {
    "codigo":366025006,
    "descripcion":"REACCIÓN PUPILAR AFERENTE A LA LUZ - HALLAZGO"
  },
  {
    "codigo":300489007,
    "descripcion":"DOLOR A LA PALPACIÓN DE AMBOS TESTÍCULOS"
  },
  {
    "codigo":298654001,
    "descripcion":"AMPLITUD DE ROTACIÓN PASIVA HACIA LA DERECHA DE LA COLUMNA LUMBAR DISMINUIDA"
  },
  {
    "codigo":1052318003,
    "descripcion":"LENTIGINOSIS AGMINADA"
  },
  {
    "codigo":11838401000119109,
    "descripcion":"LACERACIÓN DE MÚSCULO INTRÍNSECO DE PULGAR IZQUIERDO"
  },
  {
    "codigo":69278003,
    "descripcion":"ANIRIDIA CONGÉNITA"
  },
  {
    "codigo":167582007,
    "descripcion":"MICROALBÚMINA EN ORINA DETECTADA"
  },
  {
    "codigo":165747007,
    "descripcion":"RHD POSITIVO"
  },
  {
    "codigo":294984003,
    "descripcion":"ALERGIA A TOCAINIDA"
  },
  {
    "codigo":1145117000,
    "descripcion":"APENDICITIS GANGRENOSA"
  },
  {
    "codigo":162077000,
    "descripcion":"ERUCTOS EN CANTIDAD EXCESIVA"
  },
  {
    "codigo":31005002,
    "descripcion":"SÍNDROME HEPATORRENAL COMO CONSECUENCIA DE PROCEDIMIENTO"
  },
  {
    "codigo":316661000119101,
    "descripcion":"OSTEOFITO DE MANO DERECHA"
  },
  {
    "codigo":194845005,
    "descripcion":"FÍSTULA CARDÍACA AURICULOVENTRICULAR ADQUIRIDA"
  },
  {
    "codigo":293149006,
    "descripcion":"REACCIÓN ADVERSA A LA DESONIDA"
  },
  {
    "codigo":291314003,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR CLONIDINA"
  },
  {
    "codigo":193010006,
    "descripcion":"EPILEPSIA REFLEJA VISUAL"
  },
  {
    "codigo":125639000,
    "descripcion":"LESIÓN TRAUMÁTICA DEL OVARIO"
  },
  {
    "codigo":289479001,
    "descripcion":"INFLAMACIÓN DE LA VULVA"
  },
  {
    "codigo":94706008,
    "descripcion":"DEFECTO DEL TABIQUE VENTRICULAR MUSCULAR"
  },
  {
    "codigo":1208818009,
    "descripcion":"OBSTRUCCIÓN ARTERIAL DEBIDA A EMBOLIA TROMBÓTICA DE ANEURISMA DE AORTA TORÁCICA"
  },
  {
    "codigo":27335004,
    "descripcion":"INFECCIÓN CAUSADA POR SARCOCYSTIS LINDEMANNI"
  },
  {
    "codigo":60103007,
    "descripcion":"ORGASMO FEMENINO INHIBIDO"
  },
  {
    "codigo":1303452000,
    "descripcion":"TRASTORNO DE VASO SANGUÍNEO OCULAR"
  },
  {
    "codigo":92871009,
    "descripcion":"FUSIÓN ANORMAL CONGÉNITA DE HUESO PARIETAL"
  },
  {
    "codigo":715463008,
    "descripcion":"HIPOPLASIA PONTOCEREBELOSA CONGÉNITA TIPO 2"
  },
  {
    "codigo":418716000,
    "descripcion":"EXPRESA VERBALMENTE LAS CARACTERÍSTICAS ESENCIALES DE LA MEDICACIÓN"
  },
  {
    "codigo":1172380000,
    "descripcion":"COMPLEJO DE SÍNTOMAS DEL GLUTAMATO MONOSÓDICO"
  },
  {
    "codigo":254876005,
    "descripcion":"TUMOR DE SENO ENDODÉRMICO DE OVARIO"
  },
  {
    "codigo":91036007,
    "descripcion":"ATELECTASIA COMPLETA"
  },
  {
    "codigo":1336220008,
    "descripcion":"NEOPLASIA DE OJO IZQUIERDO PROPIAMENTE DICHO"
  },
  {
    "codigo":449649002,
    "descripcion":"NEOPLASIA DE PIEL DE BRAZO"
  },
  {
    "codigo":416881003,
    "descripcion":"DESINTEGRACIÓN DE STENT"
  },
  {
    "codigo":251206002,
    "descripcion":"ONDA P ACORTADA"
  },
  {
    "codigo":447814002,
    "descripcion":"CONFLUENCIA VENOSA PULMONAR CON ORIENTACIÓN VERTICAL"
  },
  {
    "codigo":1332550004,
    "descripcion":"ARTRITIS IDIOPÁTICA JUVENIL DE INICIO SISTÉMICO DE ARTICULACIÓN DE REGIÓN DE HOMBRO"
  },
  {
    "codigo":283974005,
    "descripcion":"HEMATOMA DEL PERINEO MASCULINO"
  },
  {
    "codigo":249371003,
    "descripcion":"SENO MAXILAR EXTENDIDO"
  },
  {
    "codigo":216603003,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ANTIADRENÉRGICOS"
  },
  {
    "codigo":19995004,
    "descripcion":"RUPTURA ESPONTÁNEA DEL ESÓFAGO"
  },
  {
    "codigo":413211007,
    "descripcion":"DUODENOPATÍA EROSIVA"
  },
  {
    "codigo":126351000119105,
    "descripcion":"LESIÓN ESCAMOSA INTRAEPITELIAL DE BAJO GRADO EN EXTENDIDO DE PAPANICOLAOU VAGINAL"
  },
  {
    "codigo":16018831000119106,
    "descripcion":"ATEROSCLEROSIS DE AMBAS ARTERIAS ILÍACAS"
  },
  {
    "codigo":278469000,
    "descripcion":"NISTAGMO INDUCIDO POR INTENSIDAD DEL SONIDO"
  },
  {
    "codigo":247536009,
    "descripcion":"DISTRIBUCIÓN DEL VELLO CORPORAL EN EL HOMBRE"
  },
  {
    "codigo":704453001,
    "descripcion":"FRACTURA METAFISARIA EXPUESTA DE CUARTO METATARSIANO"
  },
  {
    "codigo":737221003,
    "descripcion":"TROMBOCITOPENIA CONGÉNITA"
  },
  {
    "codigo":212933006,
    "descripcion":"CONGELAMIENTO CON NECROSIS TISULAR DE TOBILLO Y PIE"
  },
  {
    "codigo":276634002,
    "descripcion":"HIPERFOSFATEMIA IDIOPÁTICA"
  },
  {
    "codigo":1259674002,
    "descripcion":"CARCINOMA ENDOMETRIOIDE PRIMARIO DE PRÓSTATA"
  },
  {
    "codigo":345641000119103,
    "descripcion":"IRIDOSQUISIS BILATERAL"
  },
  {
    "codigo":243866007,
    "descripcion":"SITUACIÓN DEL MONITOREO DE TRASTORNO REUMATOLÓGICO"
  },
  {
    "codigo":735386008,
    "descripcion":"INSUFICIENCIA RESPIRATORIA AGUDA HIPOXÉMICA E HIPERCÁPNICA"
  },
  {
    "codigo":405871003,
    "descripcion":"FENOTIPO LU(A-)"
  },
  {
    "codigo":1290607009,
    "descripcion":"LESIÓN TRAUMÁTICA DE ARTICULACIÓN CIGOAPOFISARIA"
  },
  {
    "codigo":404036006,
    "descripcion":"PERINEUROMA"
  },
  {
    "codigo":305732007,
    "descripcion":"ATENDIDO POR ENFERMERA CONTRATADA"
  },
  {
    "codigo":698948009,
    "descripcion":"DEMENCIA VASCULAR EN REMISIÓN"
  },
  {
    "codigo":271129001,
    "descripcion":"AMPOLLA TRAUMÁTICA DE VAGINA"
  },
  {
    "codigo":762649003,
    "descripcion":"ESTENOSIS DE ARTERIA CEREBELOSA IZQUIERDA"
  },
  {
    "codigo":830020009,
    "descripcion":"CORISTOMA DE GLOBO OCULAR IZQUIERDO"
  },
  {
    "codigo":15638211000119101,
    "descripcion":"INESTABILIDAD DE AMBAS ARTICULACIONES DEL HOMBRO"
  },
  {
    "codigo":402201001,
    "descripcion":"DERMATITIS ATÓPICA IMPETIGINIZADA"
  },
  {
    "codigo":15746601000119107,
    "descripcion":"PUPILA DE OJO DERECHO ATÓNICA"
  },
  {
    "codigo":536601000221108,
    "descripcion":"OCLUSIÓN DE ARTERIA TIBIAL ANTERIOR IZQUIERDA"
  },
  {
    "codigo":1186798007,
    "descripcion":"PARKINSONISMO CAUSADO POR PLAGUICIDA"
  },
  {
    "codigo":365763002,
    "descripcion":"HALLAZGO RELACIONADO CON EL NIVEL DE CLORURO EN LÍQUIDO CEFALORRAQUÍDEO"
  },
  {
    "codigo":5315003,
    "descripcion":"ANEMIA HEMOLÍTICA NO ESFEROCÍTICA HEREDITARIA DEBIDA A AUMENTO DE LA ACTIVIDAD DE ADENOSINA DESAMINASA"
  },
  {
    "codigo":300227009,
    "descripcion":"AUDICIÓN PARA LA VOZ, ALTERADA"
  },
  {
    "codigo":3480002,
    "descripcion":"QUEMADURA DE MUÑECA"
  },
  {
    "codigo":69016002,
    "descripcion":"RASGO DE LA PERSONALIDAD TÍPICO DEL FUNCIONAMIENTO A LARGO PLAZO"
  },
  {
    "codigo":298392006,
    "descripcion":"ESCOLIOSIS CERVICAL"
  },
  {
    "codigo":296557005,
    "descripcion":"SOBREDOSIS DE CLOROQUINA"
  },
  {
    "codigo":165485006,
    "descripcion":"COLORACIÓN\/TINCIÓN ERITROCÍTICA: NORMAL"
  },
  {
    "codigo":722541007,
    "descripcion":"MEGACOLON TÓXICO DEBIDO A COLITIS INFECCIOSA"
  },
  {
    "codigo":720706000,
    "descripcion":"EVIDENCIA HISTOLÓGICA INSUFICIENTE DE BIOPSIA RENAL PARA DIAGNÓSTICO"
  },
  {
    "codigo":34413007,
    "descripcion":"ALEXITIMIA"
  },
  {
    "codigo":1179458001,
    "descripcion":"GLUCEMIA DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1144855000,
    "descripcion":"CAÍDA DE CABELLO DE REGIÓN FRONTAL DE CUERO CABELLUDO"
  },
  {
    "codigo":161815000,
    "descripcion":"HIMEN INTACTO"
  },
  {
    "codigo":784407005,
    "descripcion":"HEMATOMA SUBAPONEURÓTICO EPICRANEAL MASIVO DEBIDO A TRAUMATISMO DE PARTO"
  },
  {
    "codigo":225516002,
    "descripcion":"CONTACTOS SEXUALES MÚLTIPLES"
  },
  {
    "codigo":127212003,
    "descripcion":"LINFADENOPATÍA PERONEA"
  },
  {
    "codigo":1306860003,
    "descripcion":"INVERSIÓN DEL INTRÓN 22"
  },
  {
    "codigo":291052008,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR ALPRAZOLAM"
  },
  {
    "codigo":715201005,
    "descripcion":"SÍNDROME DE INTESTINO CORTO CONGÉNITO"
  },
  {
    "codigo":289217006,
    "descripcion":"SEGUNDA ETAPA DEL TRABAJO DE PARTO ESTABLECIDA"
  },
  {
    "codigo":190913009,
    "descripcion":"PORFIRIA CONGÉNITA"
  },
  {
    "codigo":254614001,
    "descripcion":"NEOPLASIA BENIGNA DE PÁNCREAS ENDOCRINO"
  },
  {
    "codigo":90774003,
    "descripcion":"VÍCTIMA DE ATAQUE FÍSICO"
  },
  {
    "codigo":320150004,
    "descripcion":"EOSINOFILIA IDIOPÁTICA"
  },
  {
    "codigo":92609009,
    "descripcion":"CARCINOMA IN SITU DEL HILIO PULMONAR"
  },
  {
    "codigo":348151000119103,
    "descripcion":"EXCAVACIÓN CONGÉNITA DE PAPILA ÓPTICA DERECHA"
  },
  {
    "codigo":1137515000,
    "descripcion":"DEBILIDAD DE MÚSCULO RECTO SUPERIOR DE OJO"
  },
  {
    "codigo":711531007,
    "descripcion":"GLOMERULONEFRITIS PROLIFERATIVA MESANGIAL FOCAL"
  },
  {
    "codigo":88939009,
    "descripcion":"TRASTORNO GRAVE DEL ESTADO DE ÁNIMO, SIN SÍNTOMAS PSICÓTICOS"
  },
  {
    "codigo":414784001,
    "descripcion":"SÍNDROME DE COROIDITIS MULTIFOCAL Y PANUVEÍTIS"
  },
  {
    "codigo":185408004,
    "descripcion":"CITA SOLICITADA POR EL PACIENTE"
  },
  {
    "codigo":29291000175109,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN DE GLÚTEO IZQUIERDO GRADO 2"
  },
  {
    "codigo":54336006,
    "descripcion":"ICTIOSIS LINEAL CIRCUNFLEJA"
  },
  {
    "codigo":283712008,
    "descripcion":"MORDEDURA HUMANA EN EL TÓRAX"
  },
  {
    "codigo":773397000,
    "descripcion":"GASTROPATÍA HIPERTRÓFICA NO HIPOPROTEINÉMICA"
  },
  {
    "codigo":314645002,
    "descripcion":"PERÍMETRO CEFÁLICO DEL NIÑO: PERCENTILO 0,5-1,9"
  },
  {
    "codigo":609557004,
    "descripcion":"SÍNDROME PARALÍTICO EN UN LADO DEL CUERPO"
  },
  {
    "codigo":249109008,
    "descripcion":"PRESENTACIÓN POSTERIOR DE HOMBROS"
  },
  {
    "codigo":1363221008,
    "descripcion":"CICATRIZACIÓN DE PÁRPADO SUPERIOR DERECHO"
  },
  {
    "codigo":247274000,
    "descripcion":"APÓFISIS LARGA TRUNCADA DE YUNQUE"
  },
  {
    "codigo":1230314003,
    "descripcion":"INCONTINENCIA FECAL POSTERIOR A CREACIÓN DE RESERVORIO ILEOANAL"
  },
  {
    "codigo":16063004,
    "descripcion":"ENFERMEDAD REUMÁTICA DE VÁLVULA CARDÍACA"
  },
  {
    "codigo":1259412002,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS PRIMARIO DE BRONQUIO DE LÓBULO MEDIO DE PULMÓN DERECHO"
  },
  {
    "codigo":276372004,
    "descripcion":"MOVIMIENTOS FETALES DÉBILES"
  },
  {
    "codigo":46996005,
    "descripcion":"DILATACIÓN DEL CIEGO"
  },
  {
    "codigo":210836006,
    "descripcion":"CONTUSIÓN, ARTERIA RADIAL"
  },
  {
    "codigo":472980004,
    "descripcion":"PROTRUSIÓN FOCAL DE DISCO INTERVERTEBRAL"
  },
  {
    "codigo":733289000,
    "descripcion":"LESIONES TRAUMÁTICAS MÚLTIPLES DE CADERA"
  },
  {
    "codigo":702356009,
    "descripcion":"RETRASO MENTAL SINDRÓMICO LIGADO AL CROMOSOMA X, 13"
  },
  {
    "codigo":241769004,
    "descripcion":"EFECTO TÓXICO CAUSADO POR SOLVENTES ORGÁNICOS"
  },
  {
    "codigo":15722641000119108,
    "descripcion":"ENFERMEDAD DE KASHIN-BECK DE ARTICULACIONES DE AMBAS REGIONES DE MUÑECAS"
  },
  {
    "codigo":698686003,
    "descripcion":"FRACTURA DE IMPLANTE DENTAL"
  },
  {
    "codigo":403774004,
    "descripcion":"POIQUILODERMIA ESCLEROSANTE HEREDITARIA DE WEARY"
  },
  {
    "codigo":43431000087103,
    "descripcion":"DISCO INTERVERTEBRAL TORÁCICO PROLAPSADO, T12-L1"
  },
  {
    "codigo":860691008,
    "descripcion":"UTILIZA IMPLANTE ANTICONCEPTIVO LIBERADOR DE MEDICACIÓN"
  },
  {
    "codigo":72424001,
    "descripcion":"AUSENCIA CONGÉNITA DEL DIAFRAGMA"
  },
  {
    "codigo":38311000087105,
    "descripcion":"HIPOCINESIA DE MIOCARDIO DE REGIÓN INFERIOR DE VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":238099008,
    "descripcion":"VARIANTE 1 APO A-I MUNSTER"
  },
  {
    "codigo":40871000087106,
    "descripcion":"QUEMADURA DE DEDO GORDO DE PIE DERECHO"
  },
  {
    "codigo":6888008,
    "descripcion":"DERMATITIS DE CONTACTO CAUSADA POR COLORANTE"
  },
  {
    "codigo":170728008,
    "descripcion":"AGUDEZA VISUAL DISMINUIDA"
  },
  {
    "codigo":431037002,
    "descripcion":"MUCOCELE DE LABIO INFERIOR"
  },
  {
    "codigo":267197003,
    "descripcion":"HEMORRAGIA PREPARTO, DESPRENDIMIENTO PREMATURO DE PLACENTA Y PLACENTA PREVIA"
  },
  {
    "codigo":37821003,
    "descripcion":"SÍNDROME DE HISTIOCITOSIS AZUL MARINO"
  },
  {
    "codigo":299965004,
    "descripcion":"COMPRESIÓN DE RAÍZ DE NERVIO DORSAL"
  },
  {
    "codigo":5053004,
    "descripcion":"INSUFICIENCIA CARDÍACA DEBIDA A PRÓTESIS"
  },
  {
    "codigo":234429002,
    "descripcion":"TRASTORNO QUIMIOTÁCTICO"
  },
  {
    "codigo":3218000,
    "descripcion":"MICOSIS"
  },
  {
    "codigo":396434001,
    "descripcion":"REMISIÓN TUMORAL AUSENTE"
  },
  {
    "codigo":301800009,
    "descripcion":"FONTANELA ANTERIOR PLANA"
  },
  {
    "codigo":298130005,
    "descripcion":"LESIÓN DEL NERVIO OBTURADOR"
  },
  {
    "codigo":134290008,
    "descripcion":"DISFUNCIÓN DE LA CUERDA VOCAL"
  },
  {
    "codigo":230759001,
    "descripcion":"EDEMA CEREBRAL VASOGÉNICO"
  },
  {
    "codigo":165223004,
    "descripcion":"REQUIERE AYUDA PARA LA ALIMENTACIÓN"
  },
  {
    "codigo":1383008,
    "descripcion":"TRASTORNO DEL ESTADO DE ÁNIMO POR ALUCINÓGENOS"
  },
  {
    "codigo":294460004,
    "descripcion":"ALERGIA A TIABENDAZOL"
  },
  {
    "codigo":65084004,
    "descripcion":"EMBOLIA DE ARTERIA VERTEBRAL"
  },
  {
    "codigo":423697000,
    "descripcion":"SEMINOMA DE TESTÍCULO, ESTADIO 4"
  },
  {
    "codigo":678341000119107,
    "descripcion":"IRIS BOMBÉ BILATERAL"
  },
  {
    "codigo":718609003,
    "descripcion":"HIPOPLASIA PONTOCEREBELOSA CONGÉNITA TIPO 3"
  },
  {
    "codigo":1111561000000108,
    "descripcion":"CIERRE ANGULAR PRIMARIO"
  },
  {
    "codigo":63249007,
    "descripcion":"TRASTORNO BIPOLAR I MANÍACO EN REMISIÓN PARCIAL"
  },
  {
    "codigo":1087941000119108,
    "descripcion":"ESTENOSIS ADQUIRIDA DE CONDUCTO AUDITIVO EXTERNO IZQUIERDO"
  },
  {
    "codigo":11792991000119103,
    "descripcion":"SUBLUXACIÓN DE ARTICULACIÓN DE DEDO MEDIO DE MANO IZQUIERDA"
  },
  {
    "codigo":126950007,
    "descripcion":"NEOPLASIA DEL SISTEMA NERVIOSO"
  },
  {
    "codigo":716774008,
    "descripcion":"QUERATOACANTOMA HEREDITARIO"
  },
  {
    "codigo":1306598009,
    "descripcion":"NEUMONITIS AGUDA POR ASPIRACIÓN"
  },
  {
    "codigo":288955000,
    "descripcion":"NO DEGLUTE LÍQUIDOS ESPESOS"
  },
  {
    "codigo":125115006,
    "descripcion":"ERITEMA AGUDO"
  },
  {
    "codigo":92347007,
    "descripcion":"NEOPLASIA BENIGNA DE LA PIEL DE LA AXILA"
  },
  {
    "codigo":385424001,
    "descripcion":"LESIÓN TRAUMÁTICA DE TEJIDO CONJUNTIVO"
  },
  {
    "codigo":57744004,
    "descripcion":"INFECCIÓN CAUSADA POR CYATHOSTOMUM"
  },
  {
    "codigo":24976005,
    "descripcion":"PROLAPSO UTERINO"
  },
  {
    "codigo":90512009,
    "descripcion":"HIPERVITAMINOSIS E"
  },
  {
    "codigo":449125001,
    "descripcion":"ESTENOSIS CONGÉNITA DE ARTERIA PULMONAR"
  },
  {
    "codigo":416357003,
    "descripcion":"REQUERIMIENTO DE TRATAMIENTO DE ENFERMEDAD CRÓNICA A LARGO PLAZO: NECESIDADES COMPLEJAS"
  },
  {
    "codigo":23141003,
    "descripcion":"JADEO"
  },
  {
    "codigo":283450001,
    "descripcion":"HERIDA PUNZANTE EN LA FRENTE"
  },
  {
    "codigo":86842008,
    "descripcion":"TRASTORNO HIPOFISARIO IATROGÉNICO"
  },
  {
    "codigo":840506008,
    "descripcion":"CANDIDOSIS DUODENAL"
  },
  {
    "codigo":15698681000119104,
    "descripcion":"ABSCESO DE VAINA TENDINOSA DE AMBOS HOMBROS"
  },
  {
    "codigo":85007004,
    "descripcion":"MERALGIA PARESTÉSICA"
  },
  {
    "codigo":248847005,
    "descripcion":"HIMEN ANULAR"
  },
  {
    "codigo":19471005,
    "descripcion":"LINFADENITIS"
  },
  {
    "codigo":738532000,
    "descripcion":"METABOLIZADOR LENTO DE LA FAMILIA 2 SUBFAMILIA D MIEMBRO 6 DEL CITOCROMO P450"
  },
  {
    "codigo":771300001,
    "descripcion":"HISTIOCITOSIS MUCINOSA PROGRESIVA HEREDITARIA"
  },
  {
    "codigo":115940004,
    "descripcion":"FENOTIPO DE GRUPO SANGUÍNEO"
  },
  {
    "codigo":247012004,
    "descripcion":"PUPILA EN OJO DE CERRADURA"
  },
  {
    "codigo":1090451000119100,
    "descripcion":"PANADIZO HERPÉTICO RECIDIVANTE"
  },
  {
    "codigo":1197284006,
    "descripcion":"NEOPLASIA QUÍSTICA MUCINOSA DE HÍGADO CON NEOPLASIA INTRAEPITELIAL DE ALTO GRADO"
  },
  {
    "codigo":1230052008,
    "descripcion":"CAPACIDAD ALTERADA PARA MANEJAR RÉGIMEN DE MEDICACIÓN"
  },
  {
    "codigo":50404009,
    "descripcion":"ESTADO POSTPARTO, 9 SEMANAS"
  },
  {
    "codigo":83172007,
    "descripcion":"INFECCIÓN POR PASTEURELLA"
  },
  {
    "codigo":736697006,
    "descripcion":"PRUEBA DE HELICOBACTER PYLORI EN MATERIA FECAL EQUÍVOCA"
  },
  {
    "codigo":210574006,
    "descripcion":"DAÑO MULTITISULAR SEVERO DE LA MANO"
  },
  {
    "codigo":276110006,
    "descripcion":"PELEA CON LA ESPOSA"
  },
  {
    "codigo":308878006,
    "descripcion":"DISPLASIA MODERADA DEL RECTO"
  },
  {
    "codigo":1290083005,
    "descripcion":"NEOPLASIA NEUROENDOCRINA DE ÍLEON"
  },
  {
    "codigo":700259007,
    "descripcion":"ENTROPIÓN CICATRIZAL DE PÁRPADO INFERIOR"
  },
  {
    "codigo":403512005,
    "descripcion":"POIQUILODERMIA DEBIDA A LUPUS ERITEMATOSO"
  },
  {
    "codigo":43064006,
    "descripcion":"HIDRONEFROSIS"
  },
  {
    "codigo":8461001,
    "descripcion":"MARCHA TALÓN-PUNTA"
  },
  {
    "codigo":237837007,
    "descripcion":"ENANISMO PRIMORDIAL"
  },
  {
    "codigo":107411000119108,
    "descripcion":"MUTILACIÓN GENITAL FEMENINA TIPO 4"
  },
  {
    "codigo":303373009,
    "descripcion":"CAPAZ DE ADOPTAR UNA POSICIÓN"
  },
  {
    "codigo":236002003,
    "descripcion":"HEMATOMA RETROPERITONEAL"
  },
  {
    "codigo":1153506004,
    "descripcion":"SOBREDOSIS DE ENZIMAS"
  },
  {
    "codigo":301538003,
    "descripcion":"CAPAZ DE SENTARSE Y LEVANTARSE DEL INODORO"
  },
  {
    "codigo":203234008,
    "descripcion":"INFECCIÓN DEL PERONÉ"
  },
  {
    "codigo":299703001,
    "descripcion":"MASA EN EL CUELLO"
  },
  {
    "codigo":168631002,
    "descripcion":"RADIOGRAFÍA SIMPLE DE MUÑECA: ANORMAL"
  },
  {
    "codigo":15973421000119104,
    "descripcion":"MALFORMACIÓN CONGÉNITA DEL CALCÁNEO IZQUIERDO"
  },
  {
    "codigo":1348279004,
    "descripcion":"DISMINUCIÓN DE TAMAÑO DE LESIÓN DE MAMA DESDE MAMOGRAFÍA ANTERIOR"
  },
  {
    "codigo":266935003,
    "descripcion":"CARENCIA DE VIVIENDA"
  },
  {
    "codigo":234167006,
    "descripcion":"SÍNCOPE SITUACIONAL"
  },
  {
    "codigo":823991008,
    "descripcion":"NERVIO TROCLEAR INTACTO"
  },
  {
    "codigo":1217207008,
    "descripcion":"PARÁLISIS CONGÉNITA DE NERVIO OCULOMOTOR"
  },
  {
    "codigo":723852001,
    "descripcion":"OSTEOSARCOMA PRIMARIO DE CARTÍLAGO ARTICULAR DE PELVIS"
  },
  {
    "codigo":365239009,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA USAR LENTES DE CONTACTO"
  },
  {
    "codigo":232332004,
    "descripcion":"PÉRDIDA DE LA AUDICIÓN NEUROSENSORIAL POSNATAL ADQUIRIDA"
  },
  {
    "codigo":230497000,
    "descripcion":"GOLPE EN LA CABEZA RELACIONADO CON EL SUEÑO"
  },
  {
    "codigo":363404008,
    "descripcion":"NEOPLASIA MALIGNA DE YEYUNO"
  },
  {
    "codigo":296033003,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE PARALDEHÍDO"
  },
  {
    "codigo":263265006,
    "descripcion":"SÍNDROME COMPARTIMENTAL DE TRÍCEPS SURAL DEBIDO A LESIÓN TRAUMÁTICA"
  },
  {
    "codigo":66657009,
    "descripcion":"TAQUICARDIA VENTRICULAR PAROXÍSTICA"
  },
  {
    "codigo":458038006,
    "descripcion":"ABSCESO DE VÁLVULA TRONCAL"
  },
  {
    "codigo":423435000,
    "descripcion":"NEUROMA DEL MIEMBRO SUPERIOR"
  },
  {
    "codigo":292363002,
    "descripcion":"REACCIÓN ADVERSA A CARBAMATO SEDANTE"
  },
  {
    "codigo":1144331004,
    "descripcion":"ATROFIA DE NEURONA MOTORA"
  },
  {
    "codigo":194059004,
    "descripcion":"TRASTORNO DEL QUIASMA ÓPTICO POR VASCULOPATÍA"
  },
  {
    "codigo":95755009,
    "descripcion":"ENTROPIÓN DEL CANTO NASAL"
  },
  {
    "codigo":716512002,
    "descripcion":"UTILIZA LA COMBINACIÓN CONSONANTE-VOCAL-CONSONANTE-VOCAL"
  },
  {
    "codigo":61152003,
    "descripcion":"RETRASO MENTAL MODERADO"
  },
  {
    "codigo":290528002,
    "descripcion":"INTOXICACIÓN POR BUPIVACAÍNA"
  },
  {
    "codigo":28384005,
    "descripcion":"QUEMADURA QUÍMICA DE ÓRGANOS INTERNOS"
  },
  {
    "codigo":126688006,
    "descripcion":"NEOPLASIA DEL SENO PIRIFORME"
  },
  {
    "codigo":93920004,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE HUESO NAVICULAR DE PIE"
  },
  {
    "codigo":92085000,
    "descripcion":"NEOPLASIA BENIGNA DE GLÁNDULA ENDOCRINA"
  },
  {
    "codigo":288693007,
    "descripcion":"DIFICULTAD PARA ADAPTAR LA CONVERSACIÓN A UN CONTEXTO"
  },
  {
    "codigo":417930000,
    "descripcion":"ALERGIA A ADHESIVO"
  },
  {
    "codigo":190389009,
    "descripcion":"DIABETES MELLITUS TIPO 2 CON ÚLCERA"
  },
  {
    "codigo":1204362003,
    "descripcion":"SISTEMA DE CALEFACCIÓN ADECUADO EN LA VIVIENDA"
  },
  {
    "codigo":1237130004,
    "descripcion":"ATEROSCLEROSIS DE ARTERIA DE EXTREMIDAD INFERIOR DERECHA"
  },
  {
    "codigo":254090007,
    "descripcion":"ACROMICRIA"
  },
  {
    "codigo":712842007,
    "descripcion":"ALERGIA A MOLUSCO"
  },
  {
    "codigo":448863000,
    "descripcion":"NEOPLASIA EPITELIAL MALIGNA DE GLÁNDULA PINEAL"
  },
  {
    "codigo":285023002,
    "descripcion":"INCAPAZ DE MANEJAR UN ARTEFACTO MIENTRAS SE VISTE"
  },
  {
    "codigo":22879003,
    "descripcion":"EMBARAZOS PREVIOS: 2"
  },
  {
    "codigo":55647004,
    "descripcion":"SORDERA DE TONO"
  },
  {
    "codigo":15920481000119105,
    "descripcion":"REACCIÓN ALÉRGICA CAUSADA POR MARISCOS"
  },
  {
    "codigo":88415009,
    "descripcion":"MICOBACTERIOSIS"
  },
  {
    "codigo":414260005,
    "descripcion":"FECHA DE PRIMERA CITA DE PACIENTE AMBULATORIO"
  },
  {
    "codigo":283188005,
    "descripcion":"CUERPO EXTRAÑO METÁLICO EN EL TALÓN"
  },
  {
    "codigo":248585001,
    "descripcion":"RESPIRACIÓN IRREGULAR"
  },
  {
    "codigo":217652009,
    "descripcion":"ENVENENAMIENTO POR MORDEDURA DE SERPIENTE CABEZA DE COBRE"
  },
  {
    "codigo":707337006,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE SENO PARANASAL"
  },
  {
    "codigo":11824481000119108,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE BRAZO IZQUIERDO"
  },
  {
    "codigo":1231625008,
    "descripcion":"DESPRENDIMIENTO DE RETINA TRACCIONAL DEBIDO A RETINOPATÍA DIABÉTICA PROLIFERATIVA"
  },
  {
    "codigo":281353009,
    "descripcion":"QUISTE SINOVIAL FILTRANTE DE CODO"
  },
  {
    "codigo":1531000119102,
    "descripcion":"DERMOPATÍA DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":246750005,
    "descripcion":"HIPOTROPÍA INCOMITANTE"
  },
  {
    "codigo":81075000,
    "descripcion":"DERRAME PARANEUMÓNICO"
  },
  {
    "codigo":333121000119100,
    "descripcion":"FOTOQUERATITIS DE OJO DERECHO"
  },
  {
    "codigo":11791681000119101,
    "descripcion":"LESIÓN TRAUMÁTICA DE REGIÓN DE MUÑECA DERECHA"
  },
  {
    "codigo":16097601000119102,
    "descripcion":"ARTROFIBROSIS DE CODO IZQUIERDO"
  },
  {
    "codigo":11837761000119103,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO INTRÍNSECO DE DEDO ÍNDICE DE MANO DERECHA"
  },
  {
    "codigo":1088321000119102,
    "descripcion":"TRASTORNO AUTOINMUNITARIO DE OÍDO INTERNO IZQUIERDO"
  },
  {
    "codigo":10754881000119104,
    "descripcion":"DIABETES MELLITUS EN LA MADRE QUE COMPLICA EL NACIMIENTO"
  },
  {
    "codigo":11778881000119104,
    "descripcion":"DISTENSIÓN DE MANGUITO ROTADOR DE HOMBRO DERECHO"
  },
  {
    "codigo":10760001000119100,
    "descripcion":"ENFERMEDAD TIROIDEA EN LA MADRE QUE COMPLICA EL NACIMIENTO"
  },
  {
    "codigo":683841000119102,
    "descripcion":"NEVO EPIDÉRMICO DE CARA"
  },
  {
    "codigo":15539009,
    "descripcion":"HIDROPESÍA FETAL POR ISOINMUNIZACIÓN"
  },
  {
    "codigo":115521000119107,
    "descripcion":"REGISTRO DE VACUNACIÓN NO DISPONIBLE"
  },
  {
    "codigo":343361000119107,
    "descripcion":"PIGMENTACIÓN CORNEAL ESTROMAL DE AMBOS OJOS"
  },
  {
    "codigo":11996481000119103,
    "descripcion":"NEUROMA DE MUÑÓN DE AMPUTACIÓN DE MIEMBRO INFERIOR DERECHO"
  },
  {
    "codigo":138561000119104,
    "descripcion":"MASA DE VESÍCULA BILIAR"
  },
  {
    "codigo":368961000119107,
    "descripcion":"RESISTENCIA PARCIAL A VASOPRESINA"
  },
  {
    "codigo":351041000119109,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE EXTREMIDAD SUPERIOR IZQUIERDA"
  },
  {
    "codigo":1258888006,
    "descripcion":"ANTÍGENO LINFOCITARIO CD56 DETECTADO"
  },
  {
    "codigo":15713601000119108,
    "descripcion":"COXA VARA ADQUIRIDA DE AMBAS CADERAS"
  },
  {
    "codigo":1078081000119109,
    "descripcion":"OSTEOCONDROSIS JUVENIL DE SEGUNDO METATARSIANO IZQUIERDO"
  },
  {
    "codigo":306781003,
    "descripcion":"INCAPAZ DE TOSER VOLUNTARIAMENTE"
  },
  {
    "codigo":208477005,
    "descripcion":"FRACTURA EXPUESTA DE FALANGE PROXIMAL DE DEDO DE LA MANO"
  },
  {
    "codigo":110173008,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO DE REGIÓN PERIORBITARIA"
  },
  {
    "codigo":403250003,
    "descripcion":"CABELLO CASTAÑO OSCURO"
  },
  {
    "codigo":75570004,
    "descripcion":"NEUMONÍA VIRAL"
  },
  {
    "codigo":1156914007,
    "descripcion":"NO INMUNE A MENINGOCOCO"
  },
  {
    "codigo":237575002,
    "descripcion":"ANOMALÍA DE LA SECRECIÓN DEL PÉPTIDO INTESTINAL VASOACTIVO"
  },
  {
    "codigo":8199003,
    "descripcion":"SÍNDROME DE NEFRITIS EMBÓLICA FOCAL"
  },
  {
    "codigo":6364000,
    "descripcion":"DEFICIENCIA ADQUIRIDA DE FACTOR XIII"
  },
  {
    "codigo":399580002,
    "descripcion":"SITIO DE IMPLANTACIÓN PRESENTE EN ESPÉCIMEN"
  },
  {
    "codigo":266673001,
    "descripcion":"TEJIDO NEURONAL ECTÓPICO"
  },
  {
    "codigo":70065001,
    "descripcion":"SÍNDROME FETAL POR HIDANTOÍNA"
  },
  {
    "codigo":201137002,
    "descripcion":"ALOPECIA LOCAL"
  },
  {
    "codigo":364977004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA USAR LA PRENSIÓN PALMAR"
  },
  {
    "codigo":4529005,
    "descripcion":"ESPERMATOGÉNESIS ANORMAL"
  },
  {
    "codigo":233905006,
    "descripcion":"TAQUICARDIA VENTRICULAR CON CORAZÓN NORMAL"
  },
  {
    "codigo":2694001,
    "descripcion":"ANEMIA MIELOPTÍSICA"
  },
  {
    "codigo":363142008,
    "descripcion":"COMPLICACIÓN INMUNOLÓGICA DE PROCEDIMIENTO"
  },
  {
    "codigo":33627001,
    "descripcion":"PRIMER ESTADIO DEL TRABAJO DE PARTO PROLONGADO"
  },
  {
    "codigo":721755003,
    "descripcion":"SINUSITIS CAUSADA POR HAEMOPHILUS INFLUENZAE"
  },
  {
    "codigo":230235007,
    "descripcion":"ATROFIA OLIVOPONTOCEREBELOSA CON MOVIMIENTO OCULAR LENTO"
  },
  {
    "codigo":293936000,
    "descripcion":"ALERGIA A PIPOTIAZINA"
  },
  {
    "codigo":228400001,
    "descripcion":"COMPARTE AGUJAS"
  },
  {
    "codigo":162864005,
    "descripcion":"ÍNDICE DE MASA CORPORAL 30+, OBESIDAD"
  },
  {
    "codigo":331721000119100,
    "descripcion":"ENTROPIÓN SENIL DE PÁRPADO SUPERIOR DERECHO"
  },
  {
    "codigo":10762031000119106,
    "descripcion":"DERMATITIS POR CONTACTO DE PÁRPADOS SUPERIOR E INFERIOR IZQUIERDOS"
  },
  {
    "codigo":95493003,
    "descripcion":"RETINOSQUISIS CONGÉNITA"
  },
  {
    "codigo":718085007,
    "descripcion":"INCAPAZ DE INTUBAR E INCAPAZ VENTILAR AL PACIENTE"
  },
  {
    "codigo":783621008,
    "descripcion":"INMUNODEFICIENCIA CON ANOMALÍA DE FACTOR I"
  },
  {
    "codigo":191962000,
    "descripcion":"ASTENIA NEUROCIRCULATORIA"
  },
  {
    "codigo":93658002,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL NERVIO ESPINAL"
  },
  {
    "codigo":28122003,
    "descripcion":"GRANULOMA EOSINÓFILO DE PULMÓN"
  },
  {
    "codigo":685871000119108,
    "descripcion":"LIPOSARCOMA PRIMARIO DE PARTES BLANDAS DE CARA"
  },
  {
    "codigo":714415001,
    "descripcion":"DIFICULTAD DE ADAPTACIÓN DESPUÉS DE UNA CRISIS PERSONAL"
  },
  {
    "codigo":124591004,
    "descripcion":"DEFICIENCIA DE METALOPROTEINASA"
  },
  {
    "codigo":288431004,
    "descripcion":"INCAPAZ DE UTILIZAR PINZAS"
  },
  {
    "codigo":26287007,
    "descripcion":"ÚTERO INCUDIFORME"
  },
  {
    "codigo":253828000,
    "descripcion":"APLASIA MULLERIANA"
  },
  {
    "codigo":712580000,
    "descripcion":"ESCOLIOSIS IDIOPÁTICA DE COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":57220000,
    "descripcion":"COMPLICACIÓN OBSTÉTRICA POR LA ANESTESIA LOCAL"
  },
  {
    "codigo":89988002,
    "descripcion":"QUISTE RADICULAR"
  },
  {
    "codigo":419503008,
    "descripcion":"HIPERHOMOCISTEINEMIA"
  },
  {
    "codigo":188292007,
    "descripcion":"NEOPLASIA MALIGNA DE PLEXO COROIDEO"
  },
  {
    "codigo":284761001,
    "descripcion":"FROTARSE LA PIEL"
  },
  {
    "codigo":448601003,
    "descripcion":"BAZO EN EL LADO IZQUIERDO"
  },
  {
    "codigo":88153005,
    "descripcion":"ESCORBUTO INFANTIL"
  },
  {
    "codigo":86318000,
    "descripcion":"VOLUMEN MINUTO DISMINUIDO"
  },
  {
    "codigo":282926000,
    "descripcion":"INCAPAZ DE RECOSTARSE"
  },
  {
    "codigo":250158005,
    "descripcion":"LA PLANTILLA DEL CALZADO NO SE AJUSTA CORRECTAMENTE"
  },
  {
    "codigo":1264131000,
    "descripcion":"TÉTANOS POSTERIOR A EMBARAZO MOLAR"
  },
  {
    "codigo":215555000,
    "descripcion":"LESIÓN PRODUCIDA POR ACCIDENTE DE EMBARCACIÓN CON COLISIÓN, ESQUIADOR ACUÁTICO LESIONADO"
  },
  {
    "codigo":281091000,
    "descripcion":"DISFUNCIÓN MIOCÁRDICA ISQUÉMICA"
  },
  {
    "codigo":84483000,
    "descripcion":"INTOXICACIÓN POR CLORDIAZEPÓXIDO"
  },
  {
    "codigo":444931001,
    "descripcion":"TROPONINA I POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":82648006,
    "descripcion":"DEFENSA ABDOMINAL INVOLUNTARIA"
  },
  {
    "codigo":277421000,
    "descripcion":"REABSORCIÓN DE LA APÓFISIS LARGA DEL YUNQUE"
  },
  {
    "codigo":49880009,
    "descripcion":"EFECTO TARDÍO DE UNA LESIÓN TRAUMÁTICA POR APLASTAMIENTO"
  },
  {
    "codigo":836312008,
    "descripcion":"AGUDEZA VISUAL CORREGIDA DE OJO DERECHO 5\/60"
  },
  {
    "codigo":15277004,
    "descripcion":"TRASTORNO DE ANSIEDAD INDUCIDO POR ALUCINÓGENOS"
  },
  {
    "codigo":80813006,
    "descripcion":"ARTROPATÍA HEMOFÍLICA"
  },
  {
    "codigo":11774051000119108,
    "descripcion":"CONTUSIÓN DE DEDO MEDIO DERECHO"
  },
  {
    "codigo":439426005,
    "descripcion":"FRACTURA EXPUESTA DE EPITRÓCLEA"
  },
  {
    "codigo":46210008,
    "descripcion":"QUISTE EN EL PÁRPADO"
  },
  {
    "codigo":109911004,
    "descripcion":"NEOPLASIA SUPERPUESTA MALIGNA DEL CEREBRO Y OTRAS PARTES DEL SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":208215006,
    "descripcion":"FRACTURAS MÚLTIPLES DE LA COLUMNA DORSAL"
  },
  {
    "codigo":206380000,
    "descripcion":"SEPSIS NEONATAL POR ANAEROBIOS"
  },
  {
    "codigo":370220003,
    "descripcion":"ASMA OCASIONAL"
  },
  {
    "codigo":688381000119106,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE PIEL DEL ALA DE LA NARIZ"
  },
  {
    "codigo":15980951000119100,
    "descripcion":"TRASTORNO DE PIEL DE PÁRPADOS DE AMBOS OJOS"
  },
  {
    "codigo":697900005,
    "descripcion":"HIPERTENSIÓN DE ARTERIA PULMONAR HEREDITARIA DEBIDA A MUTACIÓN DE ALK1 O ENDOGLINA"
  },
  {
    "codigo":302849000,
    "descripcion":"NEFROBLASTOMA"
  },
  {
    "codigo":75308009,
    "descripcion":"FRACTURA NO EXPUESTA DE HUESO NAVICULAR DE PIE"
  },
  {
    "codigo":237313003,
    "descripcion":"PARTO VAGINAL DESPUÉS DE OPERACIÓN CESÁREA ANTERIOR"
  },
  {
    "codigo":71638002,
    "descripcion":"TRASTORNO DEL METABOLISMO DEL CALCIO"
  },
  {
    "codigo":301014005,
    "descripcion":"INTERTRIGO DE PLIEGUE CUTÁNEO ABDOMINAL"
  },
  {
    "codigo":725163002,
    "descripcion":"SÍNDROME DE ESPASTICIDAD LIGADA AL CROMOSOMA X, DISCAPACIDAD INTELECTUAL Y EPILEPSIA"
  },
  {
    "codigo":299179006,
    "descripcion":"AMPLITUD DE ADUCCIÓN PASIVA DEL PULGAR NORMAL"
  },
  {
    "codigo":334231000119105,
    "descripcion":"LAGOFTALMOS CICATRIZAL INFERIOR DERECHO"
  },
  {
    "codigo":788864001,
    "descripcion":"TRASTORNO AMNÉSICO CAUSADO POR SOLVENTE VOLÁTIL"
  },
  {
    "codigo":168107008,
    "descripcion":"ALFA-FETOPROTEÍNA EN LÍQUIDO AMNIÓTICO DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":231808002,
    "descripcion":"BLEFAROFIMOSIS ESPÁSTICA"
  },
  {
    "codigo":67968004,
    "descripcion":"HIPERTROFIA DE CONDUCTO CÍSTICO"
  },
  {
    "codigo":2432006,
    "descripcion":"TRASTORNO EN LA CIRCULACIÓN DE LÍQUIDO CEFALORRAQUÍDEO"
  },
  {
    "codigo":262741002,
    "descripcion":"LESIÓN POR TRACCIÓN DE LA RAÍZ DE NERVIO DORSAL"
  },
  {
    "codigo":295509007,
    "descripcion":"OBESIDAD HIPERTRÓFICA"
  },
  {
    "codigo":787029008,
    "descripcion":"CUERPO EXTRAÑO RETENIDO EN REGIÓN DE TOBILLO"
  },
  {
    "codigo":721493009,
    "descripcion":"SÍNDROME DE BROWN-SEQUARD AL NIVEL DEL DECIMOSEGUNDO SEGMENTO DORSAL"
  },
  {
    "codigo":129834002,
    "descripcion":"INCUMPLIMIENTO DE LA FARMACOTERAPIA"
  },
  {
    "codigo":293674005,
    "descripcion":"ALERGIA A DOMPERIDONA"
  },
  {
    "codigo":64298006,
    "descripcion":"DEDO DE LA MANO EN MARTILLO"
  },
  {
    "codigo":228138007,
    "descripcion":"FRACASO PARA ALCANZAR EL NIVEL ACADÉMICO ESPERADO"
  },
  {
    "codigo":424746008,
    "descripcion":"INCAPAZ DE COMUNICAR SU PREOCUPACIÓN AL PROVEEDOR DE SERVICIOS COMUNITARIOS"
  },
  {
    "codigo":719658006,
    "descripcion":"SÍNDROME DE MICRODELECIÓN 2Q24"
  },
  {
    "codigo":717823001,
    "descripcion":"SÍNDROME DE CONDRODISPLASIA, DENTINOGÉNESIS IMPERFECTA, LAXITUD ARTICULAR"
  },
  {
    "codigo":291839002,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR TESTOSTERONA"
  },
  {
    "codigo":29695002,
    "descripcion":"DOLOR PULSÁTIL"
  },
  {
    "codigo":817962007,
    "descripcion":"DEPENDENCIA DE CLORDIAZEPÓXIDO"
  },
  {
    "codigo":816127006,
    "descripcion":"EXAGERACIÓN DE REFLEJO AQUÍLEO"
  },
  {
    "codigo":95231000,
    "descripcion":"RETICULOSARCOMA DEL BAZO"
  },
  {
    "codigo":60628003,
    "descripcion":"MACROTROMBOCITOPENIA MEDITERRÁNEA"
  },
  {
    "codigo":224468004,
    "descripcion":"PROMOCIONADO EN EL TRABAJO"
  },
  {
    "codigo":715988005,
    "descripcion":"SÍNDROME DE CATARATAS CON FRENILLO BUCAL ABERRANTE Y RETRASO DEL DESARROLLO"
  },
  {
    "codigo":714153000,
    "descripcion":"ENFERMEDAD RENAL CRÓNICA, ESTADIO 5, CON TRASPLANTE"
  },
  {
    "codigo":93396008,
    "descripcion":"ESTENOSIS CONGÉNITA DE LA ARTERIA CARÓTIDA"
  },
  {
    "codigo":124329006,
    "descripcion":"DEFICIENCIA DE DESFOSFOFOSFORILASA CINASA"
  },
  {
    "codigo":286334000,
    "descripcion":"PRODUCE UN TONO ADECUADO"
  },
  {
    "codigo":26025008,
    "descripcion":"ESQUIZOFRENIA RESIDUAL"
  },
  {
    "codigo":307761000119109,
    "descripcion":"DISPLASIA FIBROSA MONOSTÓTICA DE HUESO DE CINTURA ESCAPULAR DERECHA"
  },
  {
    "codigo":188030005,
    "descripcion":"MELANOMA MALIGNO DE LABIO"
  },
  {
    "codigo":384638007,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA PROXIMAL AFECTADO POR CARCINOMA IN SITU\/ADENOMA"
  },
  {
    "codigo":251731000,
    "descripcion":"MEMBRANA DE BARKAN"
  },
  {
    "codigo":1269374009,
    "descripcion":"CRISIS EPILÉPTICA CON AUTOMATISMOS CON ALTERACIÓN DE CONCIENCIA DE INICIO FOCAL"
  },
  {
    "codigo":253566008,
    "descripcion":"DEFECTO DE LA PORCIÓN MUSCULAR DEL TABIQUE INTERVENTRICULAR, EN EL SECTOR MARGINAL"
  },
  {
    "codigo":186195008,
    "descripcion":"TUBERCULOSIS PULMONAR, CON CONFIRMACIÓN HISTOLÓGICA"
  },
  {
    "codigo":282664001,
    "descripcion":"ESTENOSIS DE LA ARTERIA RENAL DE CAUSA DESCONOCIDA"
  },
  {
    "codigo":284499009,
    "descripcion":"CONDUCTA DESADAPTADA"
  },
  {
    "codigo":315432000,
    "descripcion":"NACIDO EN GHANA"
  },
  {
    "codigo":249896005,
    "descripcion":"NO PUEDE DESPLAZARSE"
  },
  {
    "codigo":18685001,
    "descripcion":"EFECTO TARDÍO DE UNA LESIÓN TRAUMÁTICA INTERNA A LOS ÓRGANOS INTRABDOMINALES"
  },
  {
    "codigo":35531000119107,
    "descripcion":"DISTROFIA DE RETINA SENSORIAL"
  },
  {
    "codigo":410066003,
    "descripcion":"ANOMALÍA CONGÉNITA EN LA CANTIDAD DE DIENTES"
  },
  {
    "codigo":1074021000119103,
    "descripcion":"ARTRITIS GOTOSA DE PIE IZQUIERDO"
  },
  {
    "codigo":735911004,
    "descripcion":"EMBOLIA GASEOSA DEBIDA A TRANSFUSIÓN Y POSTERIOR A ELLA"
  },
  {
    "codigo":1260199008,
    "descripcion":"SORDERA GENÉTICA NO SINDRÓMICA"
  },
  {
    "codigo":373628000,
    "descripcion":"HALLAZGO RELACIONADO CON LA CONCENTRACIÓN DE OXÍGENO EN SANGRE ARTERIAL"
  },
  {
    "codigo":111484002,
    "descripcion":"ESQUIZOFRENIA INDIFERENCIADA"
  },
  {
    "codigo":13180005,
    "descripcion":"MENSTRUACIÓN RETRÓGRADA"
  },
  {
    "codigo":44113000,
    "descripcion":"OSTEOCONDROSIS JUVENIL DE LA CABEZA RADIAL"
  },
  {
    "codigo":275324008,
    "descripcion":"ARTROSIS DE ARTICULACIÓN METACARPOFALÁNGICA"
  },
  {
    "codigo":109649003,
    "descripcion":"TRAUMATISMO OCLUSAL SECUNDARIO"
  },
  {
    "codigo":240721007,
    "descripcion":"CANDIDIASIS DE VÍAS URINARIAS"
  },
  {
    "codigo":207953007,
    "descripcion":"FRACTURA EXPUESTA DE VÉRTEBRA DORSAL, APÓFISIS ESPINOSA"
  },
  {
    "codigo":271654002,
    "descripcion":"VENAS DE LA PARED TORÁCICA DILATADAS"
  },
  {
    "codigo":1156390005,
    "descripcion":"FRACTURA DEL CUERNO SUPERIOR IZQUIERDO DEL CARTÍLAGO TIROIDES"
  },
  {
    "codigo":75046006,
    "descripcion":"SÍNDROME PIRAMIDAL - EXTRAPIRAMIDAL COMBINADO"
  },
  {
    "codigo":238886006,
    "descripcion":"PANICULITIS POR PRESIÓN"
  },
  {
    "codigo":402726006,
    "descripcion":"QUILOMICRONEMIA PRIMARIA"
  },
  {
    "codigo":237051006,
    "descripcion":"ADHERENCIA DE TEJIDO PARAOVÁRICO"
  },
  {
    "codigo":366288000,
    "descripcion":"HALLAZGO RELACIONADO CON TAMAÑO DE GLANDE DE PENE"
  },
  {
    "codigo":73211009,
    "descripcion":"DIABETES MELLITUS"
  },
  {
    "codigo":202448003,
    "descripcion":"TUMOR TENOSINOVIAL DE CÉLULAS GIGANTES DIFUSO DE ARTICULACIÓN SUBASTRAGALINA"
  },
  {
    "codigo":300752005,
    "descripcion":"REALIZA ACTIVIDADES DE JARDINERÍA"
  },
  {
    "codigo":850531481000119100,
    "descripcion":"TENDINOSIS DE MUÑECA DERECHA"
  },
  {
    "codigo":399056007,
    "descripcion":"RESPUESTA TERAPÉUTICA COMPLETA"
  },
  {
    "codigo":310271000119108,
    "descripcion":"ARTRITIS GOTOSA DE CODO DERECHO"
  },
  {
    "codigo":167845008,
    "descripcion":"PH DE VÓMITO DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":298917008,
    "descripcion":"SIN AMPLITUD ACTIVA DE PRONACIÓN DE CODO"
  },
  {
    "codigo":724901008,
    "descripcion":"LACERACIÓN DE TENDÓN DE LA REGIÓN INFERIOR DEL DORSO"
  },
  {
    "codigo":2170000,
    "descripcion":"RITMO DE GALOPE"
  },
  {
    "codigo":10632191000119109,
    "descripcion":"ABSCESO DE DEDO DE PIE DERECHO"
  },
  {
    "codigo":723066005,
    "descripcion":"RESULTADO NORMAL DE BIOPSIA RENAL"
  },
  {
    "codigo":34938008,
    "descripcion":"TRASTORNO DE ANSIEDAD CAUSADO POR ALCOHOL"
  },
  {
    "codigo":295247001,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE FLURBIPROFENO"
  },
  {
    "codigo":335002,
    "descripcion":"PILOROESPASMO"
  },
  {
    "codigo":229711004,
    "descripcion":"AFECCIÓN SEMÁNTICA-PRAGMÁTICA"
  },
  {
    "codigo":196943004,
    "descripcion":"HERNIA CIÁTICA IRREDUCTIBLE"
  },
  {
    "codigo":721231007,
    "descripcion":"SÍNDROME DE HIDROCEFALIA CON OBESIDAD E HIPOGONADISMO"
  },
  {
    "codigo":162340000,
    "descripcion":"DIFICULTAD AUDITIVA"
  },
  {
    "codigo":129572001,
    "descripcion":"OBSTRUCCIÓN ESOFÁGICA CON BOLO DE COMIDA"
  },
  {
    "codigo":1145380003,
    "descripcion":"APLASIA DE MÚSCULO DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":64036004,
    "descripcion":"COLAGENOSIS PERFORANTE REACTIVA"
  },
  {
    "codigo":293412005,
    "descripcion":"REACCIÓN ADVERSA A ANIÓN ELECTROLÍTICO"
  },
  {
    "codigo":31268005,
    "descripcion":"TROMBOFLEBITIS MIGRATORIA"
  },
  {
    "codigo":291577002,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR LATAMOXEF"
  },
  {
    "codigo":783097004,
    "descripcion":"SÍNDROME DE STICKLER TIPO NO OCULAR"
  },
  {
    "codigo":15684761000119108,
    "descripcion":"PERIOSTITIS DE ANTEBRAZOS BILATERALES"
  },
  {
    "codigo":224206000,
    "descripcion":"RECIBE SU PROPIO ESTADO DE CUENTAS"
  },
  {
    "codigo":62201009,
    "descripcion":"ENFERMEDAD DE GAUCHER, CRÓNICA NO NEUROPÁTICA"
  },
  {
    "codigo":715726000,
    "descripcion":"ATAXIA ESPINOCEREBELOSA TIPO 7"
  },
  {
    "codigo":94969009,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL NERVIO OCULOMOTOR"
  },
  {
    "codigo":289742003,
    "descripcion":"ÚTERO RELAJADO"
  },
  {
    "codigo":339251000119103,
    "descripcion":"EPIESCLERITIS NODULAR DE OJO IZQUIERDO"
  },
  {
    "codigo":60366008,
    "descripcion":"LESIÓN DE LA VENA PULMONAR"
  },
  {
    "codigo":124067000,
    "descripcion":"PORFIRINA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":255139003,
    "descripcion":"CARCINOMA IN SITU DE OÍDO MEDIO Y MASTOIDES"
  },
  {
    "codigo":1821000146108,
    "descripcion":"ENFERMEDAD METABÓLICA HEREDITARIA"
  },
  {
    "codigo":386211005,
    "descripcion":"TRASTORNO DE LA FUNCIÓN DEL ESTÓMAGO"
  },
  {
    "codigo":713891007,
    "descripcion":"HEMORRAGIA INTRAOPERATORIA CON REQUERIMIENTO DE TRANSFUSIÓN"
  },
  {
    "codigo":286072001,
    "descripcion":"CAPAZ DE AIREAR LA ROPA LAVADA"
  },
  {
    "codigo":449912005,
    "descripcion":"LONGITUD VERTICAL LARGA DE LABIO SUPERIOR"
  },
  {
    "codigo":417144005,
    "descripcion":"PACIENTE EN DOSIS MÁXIMA TOLERADA DE ANTAGONISTA DEL RECEPTOR DE ANGIOTENSINA II"
  },
  {
    "codigo":253304007,
    "descripcion":"TRONCO PULMONAR SOLITARIO CON ATRESIA AÓRTICA"
  },
  {
    "codigo":20258000,
    "descripcion":"POLIARTERITIS"
  },
  {
    "codigo":251469009,
    "descripcion":"SUPRESIÓN DE LAS SALVAS"
  },
  {
    "codigo":446242003,
    "descripcion":"ÚLCERA DE PIEL DE LA CARA"
  },
  {
    "codigo":216866006,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR GAS DE ÁCIDO CIANHÍDRICO"
  },
  {
    "codigo":1263607001,
    "descripcion":"SÍNDROME DE POSMADUREZ"
  },
  {
    "codigo":444407002,
    "descripcion":"DISPUESTO A SER DONANTE DE PULMÓN"
  },
  {
    "codigo":247799003,
    "descripcion":"PESIMISTA"
  },
  {
    "codigo":409804001,
    "descripcion":"INFECCIÓN CAUSADA POR KLEBSIELLA PNEUMONIAE PRODUCTORA DE BETALACTAMASA DE AMPLIO ESPECTRO"
  },
  {
    "codigo":1163468004,
    "descripcion":"MENINGITIS POR VIRUS LASSA"
  },
  {
    "codigo":49356004,
    "descripcion":"INFECCIÓN CAUSADA POR KHAWIA"
  },
  {
    "codigo":213196006,
    "descripcion":"DEHISCENCIA DE REPARACIÓN DE TENDÓN"
  },
  {
    "codigo":1360076007,
    "descripcion":"ÁNGULO ABIERTO DE AMBOS OJOS"
  },
  {
    "codigo":735649003,
    "descripcion":"LESIÓN DE AMBAS CINTILLAS ÓPTICAS"
  },
  {
    "codigo":80289005,
    "descripcion":"APLASIA DEL CEMENTO"
  },
  {
    "codigo":211361007,
    "descripcion":"PICADURA DE INSECTO, NO VENENOSO, EN LA PIERNA"
  },
  {
    "codigo":111222003,
    "descripcion":"ALTERACIÓN DE MENISCO INTERNO"
  },
  {
    "codigo":406134008,
    "descripcion":"DISCAPACIDAD MÚLTIPLE"
  },
  {
    "codigo":830283001,
    "descripcion":"SOLO CAPAZ DE CONTAR DEDOS CON EL OJO DERECHO"
  },
  {
    "codigo":1290870008,
    "descripcion":"OSTEOSARCOMA PERIOSTEAL"
  },
  {
    "codigo":240459003,
    "descripcion":"POLIOMIELITIS ABORTIVA"
  },
  {
    "codigo":699211004,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN EN TOBILLO"
  },
  {
    "codigo":369696004,
    "descripcion":"MARGEN LATERAL IZQUIERDO DE RESECCIÓN QUIRÚRGICA DE RECTO, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":1287200004,
    "descripcion":"NEVO MELANOCÍTICO DE PÁRPADO SUPERIOR"
  },
  {
    "codigo":762912006,
    "descripcion":"AGENESIA DE RIÑÓN IZQUIERDO CONCOMITANTE CON DISPLASIA CONGÉNITA DE RIÑÓN DERECHO"
  },
  {
    "codigo":271392007,
    "descripcion":"TIENE UN HIJO ADOPTIVO O HIJOS ADOPTIVOS"
  },
  {
    "codigo":16670311000119106,
    "descripcion":"FRACTURA NO EXPUESTA DE RAMA DE MANDÍBULA DERECHA"
  },
  {
    "codigo":402464009,
    "descripcion":"AMILOIDOSIS CUTÁNEA SECUNDARIA LOCALIZADA"
  },
  {
    "codigo":236789001,
    "descripcion":"INFERTILIDAD MASCULINA SECUNDARIA"
  },
  {
    "codigo":204021005,
    "descripcion":"ENCEFALOMIELOCELE"
  },
  {
    "codigo":202186003,
    "descripcion":"LUXACIÓN PATOLÓGICA DE LA ARTICULACIÓN INTERFALÁNGICA PROXIMAL"
  },
  {
    "codigo":366026007,
    "descripcion":"REACCIÓN PUPILAR MOTRIZ A LA LUZ - HALLAZGO"
  },
  {
    "codigo":298655000,
    "descripcion":"SIN AMPLITUD PASIVA DE ROTACIÓN HACIA LA DERECHA DE LA COLUMNA LUMBAR"
  },
  {
    "codigo":167583002,
    "descripcion":"MICROALBÚMINA EN ORINA NEGATIVA"
  },
  {
    "codigo":396959002,
    "descripcion":"TAMAÑO DE BASE DE TUMOR POR TRANSILUMINACIÓN, NO PUEDE SER DETERMINADO"
  },
  {
    "codigo":724639003,
    "descripcion":"ASPLENIA POSTERIOR A PROCEDIMIENTO QUIRÚRGICO"
  },
  {
    "codigo":1052319006,
    "descripcion":"SÍFILIS SECUNDARIA DE SISTEMA NERVIOSO"
  },
  {
    "codigo":15742721000119106,
    "descripcion":"TUMEFACCIÓN DE DEDO DE LA MANO IZQUIERDA"
  },
  {
    "codigo":788340006,
    "descripcion":"QUISTE Y TROFOZOÍTO DE ENTAMOEBA HISTOLYTICA"
  },
  {
    "codigo":402824003,
    "descripcion":"MILARIA INFANTIL"
  },
  {
    "codigo":131145007,
    "descripcion":"ALTERACIÓN INMUNOLÓGICA"
  },
  {
    "codigo":1079041000119108,
    "descripcion":"ANGIOSARCOMA PRIMARIO DE REGIÓN DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":63774006,
    "descripcion":"MASTITIS MICOPLASMÁTICA"
  },
  {
    "codigo":293150006,
    "descripcion":"REACCIÓN ADVERSA A LA DESOXIMETASONA"
  },
  {
    "codigo":1208819001,
    "descripcion":"OBSTRUCCIÓN ARTERIAL DEBIDA A EMBOLIA PARADÓJICA"
  },
  {
    "codigo":29171003,
    "descripcion":"PLACENTA ATRAPADA"
  },
  {
    "codigo":94707004,
    "descripcion":"MICOSIS FUNGOIDE DE GANGLIOS LINFÁTICOS INTRABDOMINALES"
  },
  {
    "codigo":92872002,
    "descripcion":"FUSIÓN ANORMAL CONGÉNITA DEL PREMAXILAR"
  },
  {
    "codigo":715464002,
    "descripcion":"SÍNDROME DE MICROCEFALIA Y MICROCÓRNEA TIPO SEEMANOVA"
  },
  {
    "codigo":125640003,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA PRÓSTATA"
  },
  {
    "codigo":289480003,
    "descripcion":"DEPOSICIÓN POR VULVA"
  },
  {
    "codigo":254877001,
    "descripcion":"SARCOMA DE ÚTERO"
  },
  {
    "codigo":25501002,
    "descripcion":"FOBIA SOCIAL"
  },
  {
    "codigo":91037003,
    "descripcion":"FRACTURA NO EXPUESTA DE PELVIS"
  },
  {
    "codigo":1336221007,
    "descripcion":"NEOPLASIA DE OJO DERECHO PROPIAMENTE DICHO"
  },
  {
    "codigo":449650002,
    "descripcion":"VENA VARICOSA RECURRENTE DE PIERNA"
  },
  {
    "codigo":1332551000,
    "descripcion":"ARTRITIS IDIOPÁTICA JUVENIL DE INICIO SISTÉMICO DE CADERA"
  },
  {
    "codigo":253042009,
    "descripcion":"DERMATOFIBROSARCOMA PROTUBERANTE MIXOIDE"
  },
  {
    "codigo":283975006,
    "descripcion":"LACERACIÓN DE PERINEO MASCULINO"
  },
  {
    "codigo":413212000,
    "descripcion":"DUODENOPATÍA HEMORRÁGICA"
  },
  {
    "codigo":708124001,
    "descripcion":"TAQUICARDIA VENTRICULAR RECURRENTE"
  },
  {
    "codigo":773660001,
    "descripcion":"HERNIA UMBILICAL RECIDIVANTE"
  },
  {
    "codigo":85532005,
    "descripcion":"ENFERMEDAD INFECCIOSA ENANTEMATOSA"
  },
  {
    "codigo":249372005,
    "descripcion":"AUSENCIA DE MANDÍBULA"
  },
  {
    "codigo":247537000,
    "descripcion":"DISTRIBUCIÓN MASCULINA DEL VELLO PUBIANO"
  },
  {
    "codigo":216604009,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR FENOXIBENZAMINA"
  },
  {
    "codigo":212934000,
    "descripcion":"CONGELAMIENTO CON NECROSIS TISULAR QUE COMPROMETE A MÚLTIPLES REGIONES CORPORALES"
  },
  {
    "codigo":737222005,
    "descripcion":"REACCIÓN ANORMAL A TUBERCULINA"
  },
  {
    "codigo":704454007,
    "descripcion":"FRACTURA EXPUESTA DE QUINTO METATARSIANO"
  },
  {
    "codigo":276635001,
    "descripcion":"ESTENOSIS SUBGLÓTICA ADQUIRIDA DEL RECIÉN NACIDO"
  },
  {
    "codigo":1259675001,
    "descripcion":"DEMENCIA DEBIDA A HIDROCEFALIA OBSTRUCTIVA"
  },
  {
    "codigo":243867003,
    "descripcion":"SITUACIÓN DEL MONITOREO DE TRASTORNO CUTÁNEO"
  },
  {
    "codigo":735387004,
    "descripcion":"REABSORCIÓN POR REEMPLAZO DE SUPERFICIE DE RAÍZ DENTAL POSTERIOR A TRAUMATISMO"
  },
  {
    "codigo":473243005,
    "descripcion":"QUEMADURA DE REGIÓN OCULAR CON QUEMADURA DE CARA"
  },
  {
    "codigo":405872005,
    "descripcion":"FENOTIPO LU(A+)"
  },
  {
    "codigo":209264008,
    "descripcion":"FRACTURA-LUXACIÓN NO EXPUESTA DE MUÑECA"
  },
  {
    "codigo":698949001,
    "descripcion":"DEMENCIA EN REMISIÓN"
  },
  {
    "codigo":404037002,
    "descripcion":"TUMOR MALIGNO DE VAINA DE NERVIO PERIFÉRICO"
  },
  {
    "codigo":344271000119107,
    "descripcion":"ATROFIA ÓPTICA PRIMARIA BILATERAL"
  },
  {
    "codigo":305733002,
    "descripcion":"ATENDIDO POR ESPECIALISTA EN ENFERMERÍA CLÍNICA"
  },
  {
    "codigo":240197007,
    "descripcion":"FRACTURA POR SOBRECARGA"
  },
  {
    "codigo":830021008,
    "descripcion":"CORISTOMA DE GLOBO OCULAR"
  },
  {
    "codigo":11786601000119102,
    "descripcion":"AMPOLLA DE DEDO ANULAR DE MANO DERECHA, CON INFECCIÓN"
  },
  {
    "codigo":8986002,
    "descripcion":"TRANSPOSICIÓN DE COLON"
  },
  {
    "codigo":74522004,
    "descripcion":"DILATACIÓN CERVICAL, 7CM"
  },
  {
    "codigo":402202008,
    "descripcion":"DERMATITIS SEBORREICA AGUDA"
  },
  {
    "codigo":334831000,
    "descripcion":"QUISTE MUCOSO POR EXTRAVASACIÓN DE GLÁNDULA SALIVAL"
  },
  {
    "codigo":1186799004,
    "descripcion":"HIPERPROLACTINEMIA DEBIDA A HIPOTIROIDISMO"
  },
  {
    "codigo":236527004,
    "descripcion":"ENFERMEDAD RENAL SÍMIL UÑA-RÓTULA"
  },
  {
    "codigo":269295009,
    "descripcion":"FALLA EN EL ÓRGANO TRASPLANTADO"
  },
  {
    "codigo":201924001,
    "descripcion":"ENFERMEDAD DE KASHIN-BECK DE MANO"
  },
  {
    "codigo":267460002,
    "descripcion":"HIPOGAMMAGLOBULINEMIA CONGÉNITA"
  },
  {
    "codigo":300228004,
    "descripcion":"PROBLEMA AUDITIVO"
  },
  {
    "codigo":365764008,
    "descripcion":"NIVELES DE ELECTRÓLITO EN ORINA - HALLAZGO"
  },
  {
    "codigo":298393001,
    "descripcion":"CIFOSIS CERVICAL"
  },
  {
    "codigo":15718761000119107,
    "descripcion":"ENTESOPATÍA DE MANO DERECHA"
  },
  {
    "codigo":12114281000119107,
    "descripcion":"QUEMADURA QUÍMICA DE PIERNA IZQUIERDA"
  },
  {
    "codigo":396697000,
    "descripcion":"NIVEL DE LACTATO DESHIDROGENASA SÉRICA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":69017006,
    "descripcion":"VÉRTIGO CORTICAL"
  },
  {
    "codigo":296558000,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE CLOROQUINA"
  },
  {
    "codigo":722542000,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE CONDUCTO ANAL"
  },
  {
    "codigo":2291000221109,
    "descripcion":"FIEBRE AMARILLA SOSPECHA DE EPIZOOTIA"
  },
  {
    "codigo":165486007,
    "descripcion":"ERITROCITOS HIPOCRÓMICOS"
  },
  {
    "codigo":294723002,
    "descripcion":"ALERGIA A INSULINA HUMANA"
  },
  {
    "codigo":784408000,
    "descripcion":"HEMATOMA RETROBULBAR"
  },
  {
    "codigo":129048001,
    "descripcion":"INDEPENDENCIA PARA HABLAR POR TELÉFONO"
  },
  {
    "codigo":292888000,
    "descripcion":"REACCIÓN ADVERSA A ISETIONATO DE PROPAMIDINA"
  },
  {
    "codigo":196419009,
    "descripcion":"DIENTES RETENIDOS"
  },
  {
    "codigo":161816004,
    "descripcion":"IRRITACIÓN VAGINAL"
  },
  {
    "codigo":1179459009,
    "descripcion":"MAGNESIO EN SANGRE POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":30744009,
    "descripcion":"PLATIPNEA"
  },
  {
    "codigo":94445004,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA NARIZ"
  },
  {
    "codigo":1306861004,
    "descripcion":"SUSTITUCIÓN SINÓNIMA DE NUCLEÓTIDO ÚNICO"
  },
  {
    "codigo":1084061000119102,
    "descripcion":"TRASTORNO DE AMBOS OÍDOS MEDIOS"
  },
  {
    "codigo":289218001,
    "descripcion":"SEGUNDA ETAPA DEL TRABAJO DE PARTO NO ESTABLECIDA"
  },
  {
    "codigo":127213008,
    "descripcion":"HIPERPLASIA ANGIOFOLICULAR DE GANGLIOS LINFÁTICOS, TIPO HIALINA - VASCULAR"
  },
  {
    "codigo":715202003,
    "descripcion":"BAÑO EN EL PISO DE ARRIBA"
  },
  {
    "codigo":92610004,
    "descripcion":"CARCINOMA IN SITU DE LA CARA HIPOFARÍNGEA DEL PLIEGUE ARITENOEPIGLÓTICO"
  },
  {
    "codigo":418455000,
    "descripcion":"ENCEFALITIS CAUSADA POR PROTOZOARIO"
  },
  {
    "codigo":254615000,
    "descripcion":"ADENOMA PANCREÁTICO ENDOCRINO"
  },
  {
    "codigo":377096861000119104,
    "descripcion":"IRITIS DE OJO DERECHO DEBIDA A PROCEDIMIENTO QUIRÚRGICO EN REGIÓN DE OJO DERECHO Y POSTERIOR A ÉL"
  },
  {
    "codigo":58007009,
    "descripcion":"FRACTURAS MÚLTIPLES NO EXPUESTAS DE EXTREMIDAD SUPERIOR Y COSTILLAS"
  },
  {
    "codigo":416620002,
    "descripcion":"DISFUNCIÓN COSTAL EN POSICIÓN DE INHALACIÓN"
  },
  {
    "codigo":318316003,
    "descripcion":"CONJUNTIVITIS PRIMAVERAL"
  },
  {
    "codigo":1137516004,
    "descripcion":"DEBILIDAD DE MÚSCULO TENAR"
  },
  {
    "codigo":88940006,
    "descripcion":"DISFUNCIÓN DIFUSA DEL MÚSCULO LISO DEL TRACTO GASTROINTESTINAL"
  },
  {
    "codigo":449388008,
    "descripcion":"ANOMALÍA DE VALVA DE VÁLVULA AURICULOVENTRICULAR EN DEFECTO DEL TABIQUE AURICULOVENTRICULAR"
  },
  {
    "codigo":285548009,
    "descripcion":"CAPAZ DE ELEVAR EL PALADAR BLANDO"
  },
  {
    "codigo":346781000119107,
    "descripcion":"CANALICULITIS LAGRIMAL CRÓNICA DE AMBOS OJOS"
  },
  {
    "codigo":283713003,
    "descripcion":"MORDEDURA HUMANA EN LA MAMA"
  },
  {
    "codigo":658081000005100,
    "descripcion":"PLACENTA UBICADA EN PARED LATERAL IZQUIERDA DE ÚTERO"
  },
  {
    "codigo":414785000,
    "descripcion":"PLASMOCITOMAS SOLITARIOS MÚLTIPLES"
  },
  {
    "codigo":185409007,
    "descripcion":"CITA SOLICITADA POR EL HIJO"
  },
  {
    "codigo":320311000119102,
    "descripcion":"ARTROSIS SECUNDARIA DE CODO"
  },
  {
    "codigo":314646001,
    "descripcion":"PERÍMETRO CEFÁLICO DEL NIÑO: PERCENTILO 2"
  },
  {
    "codigo":1363222001,
    "descripcion":"CICATRIZACIÓN DE PÁRPADO INFERIOR IZQUIERDO"
  },
  {
    "codigo":249110003,
    "descripcion":"PRESENTACIÓN EN EMBARAZO MÚLTIPLE"
  },
  {
    "codigo":773398005,
    "descripcion":"SÍNDROME DE CATARATA CONGÉNITA, HIPOTONÍA MUSCULAR PROGRESIVA, HIPOACUSIA Y RETRASO DEL DESARROLLO"
  },
  {
    "codigo":445718006,
    "descripcion":"LINFADENOPATÍA REACTIVA"
  },
  {
    "codigo":871702008,
    "descripcion":"REACCIÓN ADVERSA A HIDANTOÍNA Y\/O DERIVADO DE HIDANTOÍNA"
  },
  {
    "codigo":609558009,
    "descripcion":"TEMBLOR ESENCIAL"
  },
  {
    "codigo":73480000,
    "descripcion":"TRASTORNO DE LA TOLERANCIA A LA GLUCOSA ASOCIADA CON ETIOLOGÍA HORMONAL"
  },
  {
    "codigo":10642231000119104,
    "descripcion":"NECROSIS DE HUESO DE NALGA CONCOMITANTE CON ÚLCERA CRÓNICA DE NALGA Y DEBIDA A ELLA"
  },
  {
    "codigo":247275004,
    "descripcion":"APÓFISIS FIBROSA LARGA DEL YUNQUE"
  },
  {
    "codigo":214507009,
    "descripcion":"ACCIDENTE DE TRÁNSITO VEHICULAR DE TIPO NO COLISIÓN CON INTOXICACIÓN ACCIDENTAL POR GASES DE ESCAPE GENERADOS POR EL VEHÍCULO EN MOVIMIENTO, MOTOCICLISTA HERIDO"
  },
  {
    "codigo":442048005,
    "descripcion":"TENOSINOVITIS DE MUÑECA"
  },
  {
    "codigo":702357000,
    "descripcion":"SÍNDROME DE DELECIÓN CROMOSÓMICA 2Q37"
  },
  {
    "codigo":472981000,
    "descripcion":"TRASVESTISMO FETICHISTA"
  },
  {
    "codigo":210837002,
    "descripcion":"LESIÓN EXPUESTA, ARTERIA RADIAL"
  },
  {
    "codigo":1259413007,
    "descripcion":"CARCINOMA ESCAMOSO BRONQUIAL PRIMARIO EN LÓBULO SUPERIOR DERECHO"
  },
  {
    "codigo":276373009,
    "descripcion":"RUIDOS CARDÍACOS FETALES INTENSOS"
  },
  {
    "codigo":241770003,
    "descripcion":"EFECTO TÓXICO CAUSADO POR COMPUESTO DE ARSÉNICO TRIVALENTE"
  },
  {
    "codigo":274538008,
    "descripcion":"ECOENCEFALOGRAMA ANORMAL"
  },
  {
    "codigo":371007001,
    "descripcion":"PRUEBA DE PROVOCACIÓN, TOLERADA"
  },
  {
    "codigo":12394009,
    "descripcion":"ABORTO ESPONTÁNEO CON ANOXIA CEREBRAL"
  },
  {
    "codigo":403775003,
    "descripcion":"ANGIOMATOSIS NEUROCUTÁNEA HEREDITARIA"
  },
  {
    "codigo":733290009,
    "descripcion":"MÚLTIPLES LESIONES TRAUMÁTICAS DE MUSLO"
  },
  {
    "codigo":1255743003,
    "descripcion":"SARCOMA DE HODGKIN DE GANGLIOS LINFÁTICOS DE CABEZA"
  },
  {
    "codigo":698687007,
    "descripcion":"DEMENCIA POSTRAUMÁTICA CON CAMBIO DE CONDUCTA"
  },
  {
    "codigo":239935007,
    "descripcion":"GRANULOMATOSIS LIMITADA CON POLIANGEÍTIS"
  },
  {
    "codigo":238100000,
    "descripcion":"VARIANTE 2 APO A-I MUNSTER"
  },
  {
    "codigo":305471009,
    "descripcion":"BAJO ATENCIÓN DE ALERGISTA CLÍNICO"
  },
  {
    "codigo":72425000,
    "descripcion":"SÍNDROME DE POLISPLENIA"
  },
  {
    "codigo":762388009,
    "descripcion":"DERMATITIS IRRITATIVA POR CONTACTO CAUSADA POR SUSTANCIA EMOLIENTE"
  },
  {
    "codigo":11818091000119101,
    "descripcion":"ESGUINCE DE LIGAMENTO DE ARTICULACIÓN METACARPOFALÁNGICA DE DEDO DE MANO DERECHA"
  },
  {
    "codigo":400105005,
    "descripcion":"ERISIPELOIDE"
  },
  {
    "codigo":301801008,
    "descripcion":"HALLAZGO RELACIONADO CON LA LOCALIZACIÓN DEL EMBARAZO"
  },
  {
    "codigo":299966003,
    "descripcion":"COMPRESIÓN DE RAÍZ DE NERVIO LUMBAR"
  },
  {
    "codigo":1184702004,
    "descripcion":"INSEGURIDAD FINANCIERA"
  },
  {
    "codigo":431038007,
    "descripcion":"ESTATURA BAJA POR RADIOTERAPIA"
  },
  {
    "codigo":365502007,
    "descripcion":"DETALLES RELACIONADOS CON EL TELÉFONO EN EL HOGAR - HALLAZGO"
  },
  {
    "codigo":44161000087100,
    "descripcion":"CORTE EN MUÑECA IZQUIERDA"
  },
  {
    "codigo":46721000087101,
    "descripcion":"DESGARRO COMPLETO DE LIGAMENTO SEMILUNOPIRAMIDAL DERECHO"
  },
  {
    "codigo":39041000087102,
    "descripcion":"HEMATOMA DE PÁRPADO INFERIOR IZQUIERDO"
  },
  {
    "codigo":722280000,
    "descripcion":"SÍNDROME DE ACKERMAN"
  },
  {
    "codigo":3219008,
    "descripcion":"TIPO Y\/O CATEGORÍA DE ENFERMEDAD DESCONOCIDA"
  },
  {
    "codigo":1384002,
    "descripcion":"COLESTEATOSIS DIFUSA DEL OÍDO MEDIO"
  },
  {
    "codigo":41601000087105,
    "descripcion":"HERIDA PUNZANTE DE MAMA DERECHA"
  },
  {
    "codigo":165224005,
    "descripcion":"INDEPENDIENTE PARA LA ALIMENTACIÓN"
  },
  {
    "codigo":230760006,
    "descripcion":"EDEMA CEREBRAL CITOTÓXICO"
  },
  {
    "codigo":427368007,
    "descripcion":"SOFOCONES CLIMATÉRICOS"
  },
  {
    "codigo":1086571000119106,
    "descripcion":"HEMORRAGIA DE ÍLEON CONCOMITANTE CON DIVERTICULOSIS Y DEBIDA A ELLA"
  },
  {
    "codigo":292626001,
    "descripcion":"REACCIÓN ADVERSA A LA CALAMINA"
  },
  {
    "codigo":718610008,
    "descripcion":"HIPOPLASIA PONTOCEREBELOSA CONGÉNITA TIPO 1"
  },
  {
    "codigo":390930009,
    "descripcion":"EXTENDIDO CERVICAL ATRASADO"
  },
  {
    "codigo":290791002,
    "descripcion":"INTOXICACIÓN POR LISURIDA"
  },
  {
    "codigo":94183005,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA ESPALDA"
  },
  {
    "codigo":126951006,
    "descripcion":"NEOPLASIA DEL SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":716775009,
    "descripcion":"NANOFTALMÍA"
  },
  {
    "codigo":92348002,
    "descripcion":"NEOPLASIA BENIGNA DE LA PIEL DE LA ESPALDA"
  },
  {
    "codigo":288956004,
    "descripcion":"DIFICULTAD PARA DEGLUTIR LÍQUIDOS ESPESOS"
  },
  {
    "codigo":125116007,
    "descripcion":"ERITEMA CRÓNICO"
  },
  {
    "codigo":287121002,
    "descripcion":"ASTILLA CLAVADA EN EL PIE"
  },
  {
    "codigo":285286004,
    "descripcion":"COMPULSIÓN A ACTUAR ANTE LOS PENSAMIENTOS"
  },
  {
    "codigo":23142005,
    "descripcion":"INTOXICACIÓN CAUSADA POR PROSTAGLANDINA"
  },
  {
    "codigo":283451002,
    "descripcion":"HERIDA PUNZANTE EN LA REGIÓN OCULAR"
  },
  {
    "codigo":840507004,
    "descripcion":"DOBLE TRACTO DE SALIDA DE VENTRÍCULO DERECHO CON DEFECTO DE TABIQUE VENTRICULAR SUBAÓRTICO SIN ESTENOSIS PULMONAR"
  },
  {
    "codigo":54075005,
    "descripcion":"FRACTURA EXPUESTA DE PRIMER HUESO CUNEIFORME"
  },
  {
    "codigo":248848000,
    "descripcion":"HIMEN CON FORMA DE HERRADURA"
  },
  {
    "codigo":19472003,
    "descripcion":"HIPERPERMEABILIDAD CAPILAR"
  },
  {
    "codigo":445456006,
    "descripcion":"MASA DE REGIÓN SUBMANDIBULAR"
  },
  {
    "codigo":771301002,
    "descripcion":"DISPLASIA ESPONDILOMETAFISARIA AXIAL"
  },
  {
    "codigo":738533005,
    "descripcion":"METABOLIZADOR INTERMEDIO DE LA FAMILIA 2 SUBFAMILIA D MIEMBRO 6 DEL CITOCROMO P450"
  },
  {
    "codigo":1197285007,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS METASTÁSICO DE GANGLIO LINFÁTICO TORÁCICO"
  },
  {
    "codigo":15670841000119102,
    "descripcion":"LUXACIÓN CONGÉNITA DE RODILLA DERECHA"
  },
  {
    "codigo":247013009,
    "descripcion":"CONTRACCIÓN FIJA DE PUPILA"
  },
  {
    "codigo":736698001,
    "descripcion":"ANTÍGENO LEUCOCÍTICO HUMANO B27 NO DETECTADO"
  },
  {
    "codigo":703930000,
    "descripcion":"ALERGIA A CARNE VACUNA"
  },
  {
    "codigo":15802004,
    "descripcion":"DISTONÍA"
  },
  {
    "codigo":308879003,
    "descripcion":"DISPLASIA GRAVE DEL RECTO"
  },
  {
    "codigo":276111005,
    "descripcion":"CÓNYUGE INDIFERENTE"
  },
  {
    "codigo":210575007,
    "descripcion":"DAÑO MULTITISULAR MASIVO DE LA MANO"
  },
  {
    "codigo":733028000,
    "descripcion":"SÍNDROME DE ESCLEROSIS MÚLTIPLES, ICTIOSIS Y DEFICIENCIA DE FACTOR VIII"
  },
  {
    "codigo":767631007,
    "descripcion":"TRASTORNO BIPOLAR, EPISODIO MÁS RECIENTE DEPRESIVO"
  },
  {
    "codigo":700260002,
    "descripcion":"QUISTE DE GLÁNDULA DE MEIBOMIO DE PÁRPADO INFERIOR"
  },
  {
    "codigo":77668003,
    "descripcion":"TUBERCULOSIS TRAQUEAL AISLADA"
  },
  {
    "codigo":1290084004,
    "descripcion":"NEOPLASIA NEUROENDOCRINA DE YEYUNO"
  },
  {
    "codigo":403513000,
    "descripcion":"DISTROFIA UNGUEAL ASOCIADA CON LUPUS ERITEMATOSO"
  },
  {
    "codigo":237838002,
    "descripcion":"AUSENCIA DEL RECEPTOR DE LA HORMONA DEL CRECIMIENTO"
  },
  {
    "codigo":303374003,
    "descripcion":"INCAPAZ DE TOMAR UNA POSICIÓN"
  },
  {
    "codigo":73998008,
    "descripcion":"PROLAPSO DE LOS ÓRGANOS GENITALES FEMENINOS"
  },
  {
    "codigo":72163003,
    "descripcion":"FIEBRE POR METAL"
  },
  {
    "codigo":6627003,
    "descripcion":"INFECCIÓN CAUSADA POR STILESIA"
  },
  {
    "codigo":301539006,
    "descripcion":"INCAPAZ DE SENTARSE Y LEVANTARSE DEL INODORO"
  },
  {
    "codigo":236003008,
    "descripcion":"ASCITIS DE CAUSA CARDÍACA"
  },
  {
    "codigo":823992001,
    "descripcion":"NERVIO MOTOR OCULAR EXTERNO INTACTO"
  },
  {
    "codigo":203235009,
    "descripcion":"INFECCIÓN DEL CALCÁNEO"
  },
  {
    "codigo":234168001,
    "descripcion":"SÍNCOPE DE MICCIÓN"
  },
  {
    "codigo":1217208003,
    "descripcion":"DEFICIENCIA DE L-FERRITINA"
  },
  {
    "codigo":1348280001,
    "descripcion":"AUMENTO DE TAMAÑO DE LESIÓN MAMARIA DESDE LA ÚLTIMA MAMOGRAFÍA"
  },
  {
    "codigo":70328006,
    "descripcion":"DELIRIO POR INTOXICACIÓN CON COCAÍNA"
  },
  {
    "codigo":299704007,
    "descripcion":"TUMORACIÓN DE LA CARA"
  },
  {
    "codigo":37560007,
    "descripcion":"ÁNTRAX DEL BRAZO"
  },
  {
    "codigo":365240006,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA UTILIZAR AUDÍFONO"
  },
  {
    "codigo":445401000124106,
    "descripcion":"CON MAYOR RIESGO DE DIFICULTAD PARA AMAMANTAR"
  },
  {
    "codigo":266936002,
    "descripcion":"CASA EN MAL ESTADO"
  },
  {
    "codigo":2521000124109,
    "descripcion":"INCISIVO LATERAL INFERIOR DERECHO PERMANENTE SUPERNUMERARIO"
  },
  {
    "codigo":723853006,
    "descripcion":"SARCOMA DE EWING PRIMARIO DE HUESO DE EXTREMIDAD"
  },
  {
    "codigo":363405009,
    "descripcion":"NEOPLASIA MALIGNA DE ÍLEON"
  },
  {
    "codigo":232333009,
    "descripcion":"PÉRDIDA DE LA AUDICIÓN ASOCIADA A SÍNDROME"
  },
  {
    "codigo":230498005,
    "descripcion":"ERECCIONES DOLOROSAS RELACIONADAS CON EL SUEÑO"
  },
  {
    "codigo":263266007,
    "descripcion":"SÍNDROME DE COMPARTIMIENTO EXTENSOR DE ANTEBRAZO DEBIDO A LESIÓN TRAUMÁTICA"
  },
  {
    "codigo":33890007,
    "descripcion":"CUERPO EXTRAÑO EN LAS NARINAS"
  },
  {
    "codigo":296034009,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE PARALDEHÍDO"
  },
  {
    "codigo":458039003,
    "descripcion":"ORIGEN ANÓMALO DE ARTERIA CORONARIA CIRCUNFLEJA IZQUIERDA EN ARTERIA PULMONAR"
  },
  {
    "codigo":95756005,
    "descripcion":"COMBINACIÓN DE ENTROPIÓN - ECTROPIÓN"
  },
  {
    "codigo":1144332006,
    "descripcion":"ATROFIA DE AXÓN DE ESTRUCTURA DE NERVIO PERIFÉRICO"
  },
  {
    "codigo":128524007,
    "descripcion":"TRASTORNO DEL COLON"
  },
  {
    "codigo":292364008,
    "descripcion":"REACCIÓN ADVERSA AL MEPROBAMATO"
  },
  {
    "codigo":62988009,
    "descripcion":"SIGNO DE GREY TURNER"
  },
  {
    "codigo":194060009,
    "descripcion":"TRASTORNO INFLAMATORIO DEL QUIASMA ÓPTICO"
  },
  {
    "codigo":290529005,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR BUPIVACAÍNA"
  },
  {
    "codigo":716513007,
    "descripcion":"UTILIZA PALABRAS MULTISILÁBICAS"
  },
  {
    "codigo":224993008,
    "descripcion":"HALLAZGO PSICODINÁMICO"
  },
  {
    "codigo":10676231000119102,
    "descripcion":"ASMA PERSISTENTE LEVE NO CONTROLADA CONCOMITANTE CON RINITIS ALÉRGICA"
  },
  {
    "codigo":11849581000119108,
    "descripcion":"ABRASIÓN DE PIEL DE REGIÓN CLAVICULAR IZQUIERDA"
  },
  {
    "codigo":92086004,
    "descripcion":"NEOPLASIA BENIGNA DEL ENDOMETRIO"
  },
  {
    "codigo":1237131000,
    "descripcion":"VENA VARICOSA DE PIERNA IZQUIERDA"
  },
  {
    "codigo":712843002,
    "descripcion":"ALERGIA A APIO"
  },
  {
    "codigo":681991000119104,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE TRÍGONO VESICAL"
  },
  {
    "codigo":254091006,
    "descripcion":"DISPLASIA TRICORRINOFALÁNGICA TIPO I"
  },
  {
    "codigo":448864006,
    "descripcion":"NEOPLASIA EPITELIAL MALIGNA DE URÉTER"
  },
  {
    "codigo":285024008,
    "descripcion":"MANEJA DISPOSITIVOS MIENTRAS SE VISTE"
  },
  {
    "codigo":283189002,
    "descripcion":"CUERPO EXTRAÑO - ANZUELO"
  },
  {
    "codigo":250421003,
    "descripcion":"PRUEBA DE EMBARAZO - HALLAZGO"
  },
  {
    "codigo":53813002,
    "descripcion":"PRESIÓN ARTERIAL DIASTÓLICA NORMAL"
  },
  {
    "codigo":217653004,
    "descripcion":"ENVENENAMIENTO POR VENENO DE SERPIENTE DE CORAL"
  },
  {
    "codigo":248586000,
    "descripcion":"ESPIRACIÓN PROLONGADA"
  },
  {
    "codigo":19210000,
    "descripcion":"LACERACIÓN DEL TRONCO ENCEFÁLICO CON HERIDA INTRACRANEAL ABIERTA Y SIN PÉRDIDA DE CONSCIENCIA"
  },
  {
    "codigo":281354003,
    "descripcion":"QUISTE SINOVIAL FILTRANTE DE RODILLA"
  },
  {
    "codigo":838410008,
    "descripcion":"DOLOR A LA PALPACIÓN EN REGIÓN EPIGÁSTRICA"
  },
  {
    "codigo":51978008,
    "descripcion":"RETRASO CEFÁLICO EN RECIÉN NACIDO"
  },
  {
    "codigo":1231626009,
    "descripcion":"NANOFTALMOS SINDRÓMICO DEBIDO A SÍNDROME DE KENNY-CAFFEY"
  },
  {
    "codigo":11796641000119104,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN DE DEDO ANULAR DERECHO"
  },
  {
    "codigo":50143004,
    "descripcion":"KERNICTERUS DEL RECIÉN NACIDO"
  },
  {
    "codigo":212148001,
    "descripcion":"LESIÓN CERRADA DE NERVIO ESPINAL"
  },
  {
    "codigo":310452002,
    "descripcion":"ESTADO DE INFORME DE CONDUCTOR DISCAPACITADO"
  },
  {
    "codigo":246751009,
    "descripcion":"ESOFORIA INCOMITANTE"
  },
  {
    "codigo":769204005,
    "descripcion":"ANOMALÍA DE MIOTOMA"
  },
  {
    "codigo":208478000,
    "descripcion":"FRACTURA EXPUESTA DE FALANGE PROXIMAL DE DEDO DE LA MANO, BASE"
  },
  {
    "codigo":110174002,
    "descripcion":"QUEMADURA DE LA REGIÓN PREAURICULAR DE LA CARA"
  },
  {
    "codigo":306782005,
    "descripcion":"DIFICULTAD PARA TOSER VOLUNTARIAMENTE"
  },
  {
    "codigo":370483001,
    "descripcion":"MANCHA DE MITTENDORF"
  },
  {
    "codigo":1255219002,
    "descripcion":"RUPTURA TRAUMÁTICA DE TENDÓN DE MÚSCULO SUPRAESPINOSO"
  },
  {
    "codigo":308251000119100,
    "descripcion":"DEFORMIDAD EN FLEXIÓN DE ARTICULACIÓN DE CADERA DERECHA"
  },
  {
    "codigo":344091000119101,
    "descripcion":"PTERIGIÓN RECIDIVANTE DE AMBOS OJOS"
  },
  {
    "codigo":108571000119102,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE MANDÍBULA"
  },
  {
    "codigo":11777051000119103,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO BÍCEPS BRAQUIAL IZQUIERDO"
  },
  {
    "codigo":11853851000119104,
    "descripcion":"LESIÓN TRAUMÁTICA DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":10947611000119105,
    "descripcion":"HERIDA ABIERTA DE DEDO MEDIO DE MANO DERECHA DEBIDA A MORDEDURA DE PERRO"
  },
  {
    "codigo":338971000119106,
    "descripcion":"LAGOFTALMÍA PARALÍTICA DE PÁRPADO IZQUIERDO"
  },
  {
    "codigo":321051000119107,
    "descripcion":"ENTESOPATÍA ESPINAL DE REGIÓN TORÁCICA"
  },
  {
    "codigo":1086491000119108,
    "descripcion":"PERFORACIÓN DE INTESTINO DELGADO DEBIDA A DIVERTICULITIS"
  },
  {
    "codigo":10970651000119109,
    "descripcion":"HERIDA ABIERTA DE PIERNA IZQUIERDA DEBIDA A MORDEDURA DE GATO"
  },
  {
    "codigo":290331000119107,
    "descripcion":"MONOPLEJÍA DE MIEMBRO INFERIOR DERECHO DOMINANTE"
  },
  {
    "codigo":354331000119104,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE EXTREMIDAD INFERIOR IZQUIERDA"
  },
  {
    "codigo":687131000119107,
    "descripcion":"NEUROFIBROMA DE CUELLO"
  },
  {
    "codigo":16410651000119105,
    "descripcion":"ESPASMO DE MÚSCULO DE REGIÓN LUMBAR"
  },
  {
    "codigo":235741002,
    "descripcion":"PERFORACIÓN DEL INTESTINO DELGADO"
  },
  {
    "codigo":15634971000119107,
    "descripcion":"DEBILIDAD DE AMBAS EXTREMIDADES SUPERIORES"
  },
  {
    "codigo":301277001,
    "descripcion":"FRÉMITO VOCAL AUMENTADO"
  },
  {
    "codigo":399581003,
    "descripcion":"COMPROMISO TUMORAL A ESTRUCTURAS NO ADYACENTES, AUSENTE"
  },
  {
    "codigo":71901000,
    "descripcion":"PELVIS CONTRAÍDA CONGÉNITA"
  },
  {
    "codigo":6365004,
    "descripcion":"ACTINOMICOSIS CUTÁNEA"
  },
  {
    "codigo":70066000,
    "descripcion":"MUTISMO POR CONVERSIÓN"
  },
  {
    "codigo":4530000,
    "descripcion":"DEFORMIDAD DE MADELUNG"
  },
  {
    "codigo":202973008,
    "descripcion":"RUPTURA DE MÚSCULO PERONEO LATERAL LARGO"
  },
  {
    "codigo":102834005,
    "descripcion":"MICCIÓN NORMAL"
  },
  {
    "codigo":37298006,
    "descripcion":"ONICOFAGIA"
  },
  {
    "codigo":233906007,
    "descripcion":"TAQUICARDIA VENTRICULAR FAMILIAR"
  },
  {
    "codigo":201138007,
    "descripcion":"ALOPECIA DIFUSA"
  },
  {
    "codigo":364978009,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA UTILIZAR LA PINZA"
  },
  {
    "codigo":232071006,
    "descripcion":"NEOVASCULARIZACIÓN MACULAR OCULTA"
  },
  {
    "codigo":295772000,
    "descripcion":"SOBREDOSIS DE FÁRMACO ANTAGONISTA DEL ESTRÓGENO"
  },
  {
    "codigo":721756002,
    "descripcion":"INFECCIÓN CAUSADA POR KLEBSIELLA"
  },
  {
    "codigo":230236008,
    "descripcion":"ATROFIA OLIVOPONTOCEREBELOSA CON CEGUERA"
  },
  {
    "codigo":457777001,
    "descripcion":"RUPTURA DE CUERDAS TENDINOSAS DE VÁLVULA AURICULOVENTRICULAR IZQUIERDA (MORFOLÓGICAMENTE NO MITRAL)"
  },
  {
    "codigo":29958000,
    "descripcion":"HIDROLIZADO PROTEICO"
  },
  {
    "codigo":293937009,
    "descripcion":"ALERGIA A PROMAZINA"
  },
  {
    "codigo":783622001,
    "descripcion":"PARAPLEJÍA ESPÁSTICA AUTOSÓMICA DOMINANTE TIPO 38"
  },
  {
    "codigo":292102004,
    "descripcion":"REACCIÓN ADVERSA AL QUELATO DE BISMUTO"
  },
  {
    "codigo":423174004,
    "descripcion":"NO BUSCA ATENCIÓN DE LA SALUD DE MANERA CONSTANTE"
  },
  {
    "codigo":10760661000119109,
    "descripcion":"TRILLIZOS, ALGUNOS NACIDOS VIVOS"
  },
  {
    "codigo":95494009,
    "descripcion":"DISPLASIA RETINIANA"
  },
  {
    "codigo":60891003,
    "descripcion":"ANOMALÍA DEL PAR DE CROMOSOMAS 11"
  },
  {
    "codigo":957319791000119104,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DEBIDO A TROMBOSIS DE ARTERIA CEREBELOSA IZQUIERDA"
  },
  {
    "codigo":93659005,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE SENO PARANASAL"
  },
  {
    "codigo":290267007,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR KETOPROFENO"
  },
  {
    "codigo":714416000,
    "descripcion":"DIFICULTAD PARA RESPETAR REGLAS Y LÍMITES"
  },
  {
    "codigo":16058991000119105,
    "descripcion":"DEFECTO DE CAMPO VISUAL PERIFÉRICO DE OJO DERECHO"
  },
  {
    "codigo":1304240002,
    "descripcion":"GLAUCOMA BILATERAL"
  },
  {
    "codigo":124592006,
    "descripcion":"DEFICIENCIA DE LIASA"
  },
  {
    "codigo":288432006,
    "descripcion":"UTILIZA PINZAS"
  },
  {
    "codigo":712581001,
    "descripcion":"ESCOLIOSIS IDIOPÁTICA DE COLUMNA VERTEBRAL LUMBAR"
  },
  {
    "codigo":188293002,
    "descripcion":"NEOPLASIA MALIGNA DEL PISO DE UN VENTRÍCULO CEREBRAL"
  },
  {
    "codigo":89989005,
    "descripcion":"DIAGNÓSTICO APLAZADO EN EL EJE V"
  },
  {
    "codigo":253829008,
    "descripcion":"ÚTERO RUDIMENTARIO SÓLIDO"
  },
  {
    "codigo":88154004,
    "descripcion":"SÍNDROME DEL CROMOSOMA 18 EN ANILLO"
  },
  {
    "codigo":448602005,
    "descripcion":"BAZO EN EL LADO DERECHO"
  },
  {
    "codigo":210824000,
    "descripcion":"LESIÓN DE VASO SANGUÍNEO AXILAR"
  },
  {
    "codigo":86319008,
    "descripcion":"DISTENSIÓN DEL MÚSCULO SUBESCAPULAR"
  },
  {
    "codigo":248324001,
    "descripcion":"BIEN NUTRIDO"
  },
  {
    "codigo":1259400001,
    "descripcion":"CARCINOMA PRIMARIO DE VEJIGA URINARIA"
  },
  {
    "codigo":282927009,
    "descripcion":"SE ACUESTA"
  },
  {
    "codigo":215556004,
    "descripcion":"LESIÓN TRAUMÁTICA PROVOCADA POR ACCIDENTE EN DEPORTES ACUÁTICOS CON COLISIÓN, NADADOR LESIONADO"
  },
  {
    "codigo":84484006,
    "descripcion":"LALACIÓN"
  },
  {
    "codigo":1264132007,
    "descripcion":"SALPINGITIS POSTERIOR A EMBARAZO MOLAR"
  },
  {
    "codigo":444932008,
    "descripcion":"DEPENDENCIA DE DISPOSITIVO DE VENTILACIÓN"
  },
  {
    "codigo":281092007,
    "descripcion":"MIOCARDIO ATURDIDO"
  },
  {
    "codigo":10953481000119107,
    "descripcion":"HERIDA ABIERTA DE DEDO MEÑIQUE DERECHO DEBIDA A MORDEDURA DE GATO"
  },
  {
    "codigo":836313003,
    "descripcion":"AGUDEZA VISUAL CORREGIDA DE OJO IZQUIERDO 5\/60"
  },
  {
    "codigo":82649003,
    "descripcion":"ASTIGMATISMO"
  },
  {
    "codigo":703406006,
    "descripcion":"SÍNDROME TRICOHEPATOENTÉRICO"
  },
  {
    "codigo":210051003,
    "descripcion":"LESIÓN CARDÍACA Y PULMONAR"
  },
  {
    "codigo":109912006,
    "descripcion":"NEOPLASIA SUPERPUESTA MALIGNA DEL ENCÉFALO"
  },
  {
    "codigo":44376007,
    "descripcion":"TRASTORNO DISOCIATIVO"
  },
  {
    "codigo":1254957001,
    "descripcion":"NEOPLASIA MALIGNA DE VASO SANGUÍNEO"
  },
  {
    "codigo":239149002,
    "descripcion":"QUISTE CILIADO PREESTERNAL"
  },
  {
    "codigo":370221004,
    "descripcion":"ASMA GRAVE"
  },
  {
    "codigo":42541005,
    "descripcion":"GASTRITIS IRRITATIVA"
  },
  {
    "codigo":697901009,
    "descripcion":"HIPERTENSIÓN PULMONAR INDUCIDA POR TOXINA"
  },
  {
    "codigo":402989009,
    "descripcion":"NOCARDIOSIS CUTÁNEA PRIMARIA"
  },
  {
    "codigo":366551004,
    "descripcion":"HALLAZGO RELACIONADO CON LA COLORACIÓN DE ARTICULACIÓN DE PULGAR"
  },
  {
    "codigo":71639005,
    "descripcion":"GALACTORREA ASOCIADA CON EL PARTO"
  },
  {
    "codigo":397484000,
    "descripcion":"TUMOR ENDOCRINO PANCREÁTICO NO SECRETOR"
  },
  {
    "codigo":169943008,
    "descripcion":"MADRE MENOR DE 20 AÑOS"
  },
  {
    "codigo":168108003,
    "descripcion":"ALFA-FETOPROTEÍNA EN LÍQUIDO AMNIÓTICO, RESULTADO DUDOSO"
  },
  {
    "codigo":102572006,
    "descripcion":"EDEMA DE LA EXTREMIDAD INFERIOR"
  },
  {
    "codigo":266412007,
    "descripcion":"TRASTORNO DENTAL, DE LA CAVIDAD BUCAL Y LAS GLÁNDULAS SALIVALES"
  },
  {
    "codigo":725164008,
    "descripcion":"OMODISPLASIA"
  },
  {
    "codigo":788865000,
    "descripcion":"ANEMIA DEBIDA A ENFERMEDAD INFECCIOSA CRÓNICA"
  },
  {
    "codigo":299180009,
    "descripcion":"AMPLITUD DE ADUCCIÓN PASIVA DEL PULGAR AUMENTADA"
  },
  {
    "codigo":12102871000119101,
    "descripcion":"QUEMADURA DE PULGAR DERECHO"
  },
  {
    "codigo":231809005,
    "descripcion":"BLEFAROFIMOSIS CICATRIZAL"
  },
  {
    "codigo":428417006,
    "descripcion":"REPOLARIZACIÓN TEMPRANA"
  },
  {
    "codigo":295510002,
    "descripcion":"SOBREDOSIS INTENCIONAL DE KETAMINA"
  },
  {
    "codigo":787030003,
    "descripcion":"CUERPO EXTRAÑO RETENIDO EN PIE"
  },
  {
    "codigo":721494003,
    "descripcion":"FRACTURA DE PRIMERA VÉRTEBRA LUMBAR"
  },
  {
    "codigo":332861000119109,
    "descripcion":"CONJUNTIVITIS PSEUDOMEMBRANOSA DE OJO DERECHO"
  },
  {
    "codigo":129835001,
    "descripcion":"INCUMPLIMIENTO DE LAS MEDIDAS DE SEGURIDAD"
  },
  {
    "codigo":262742009,
    "descripcion":"LESIÓN POR TRACCIÓN DE LA RAÍZ DE NERVIO LUMBAR"
  },
  {
    "codigo":719659003,
    "descripcion":"SÍNDROME DE MICRODELECIÓN 2Q32Q33"
  },
  {
    "codigo":424747004,
    "descripcion":"NO REPONE LAS MEDICACIONES ADECUADAMENTE"
  },
  {
    "codigo":228139004,
    "descripcion":"FRACASO PARA ALCANZAR LOS OBJETIVOS DEL PROGRAMA DE ESTUDIOS NACIONAL"
  },
  {
    "codigo":293675006,
    "descripcion":"ALERGIA A METOCLOPRAMIDA"
  },
  {
    "codigo":291840000,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR TESTOSTERONA"
  },
  {
    "codigo":816128001,
    "descripcion":"EXAGERACIÓN DE REFLEJO MASETERINO"
  },
  {
    "codigo":1078272003,
    "descripcion":"AGENESIA DE FALANGE DISTAL DE SEGUNDO DEDO DE PIE"
  },
  {
    "codigo":717824007,
    "descripcion":"SÍNDROME DE ENFERMEDAD OCLUSIVA ARTERIAL PROGRESIVA, HIPERTENSIÓN, DEFECTO CARDÍACO, FRAGILIDAD ÓSEA, BRAQUISINDACTILIA"
  },
  {
    "codigo":715989002,
    "descripcion":"SÍNDROME DE CATARATA CONGÉNITA CON DISCAPACIDAD INTELECTUAL, ATRESIA ANAL Y DEFECTO URINARIO"
  },
  {
    "codigo":93397004,
    "descripcion":"ENGROSAMIENTO CONGÉNITO DE CLAVÍCULA"
  },
  {
    "codigo":421077004,
    "descripcion":"CANDIDIASIS DISEMINADA CON SIDA (SÍNDROME DE INMUNODEFICIENCIA ADQUIRIDA)"
  },
  {
    "codigo":1303978001,
    "descripcion":"DESPLAZAMIENTO DE PLACA DE OJO IZQUIERDO DEBIDO A CIRUGÍA DE DRENAJE DE GLAUCOMA Y POSTERIOR A ELLA"
  },
  {
    "codigo":124330001,
    "descripcion":"DEFICIENCIA DE HOMOSERINA CINASA"
  },
  {
    "codigo":60631000119109,
    "descripcion":"DEPENDENCIA DE RESPIRADOR DOMICILIARIO"
  },
  {
    "codigo":286335004,
    "descripcion":"NO PRODUCE UN TONO ADECUADO"
  },
  {
    "codigo":1269375005,
    "descripcion":"LESIÓN ANTERIOR DE MÉDULA ESPINAL DORSAL DEBIDA A LUXACIÓN NO EXPUESTA DE ARTICULACIÓN DE COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":384639004,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA DISTAL AFECTADO POR CARCINOMA IN SITU\/ADENOMA"
  },
  {
    "codigo":253567004,
    "descripcion":"DEFECTO DE LA PORCIÓN MUSCULAR DEL TABIQUE INTERVENTRICULAR, EN EL CONO DE SALIDA"
  },
  {
    "codigo":284500000,
    "descripcion":"CONDUCTA EXCESIVA"
  },
  {
    "codigo":1234772003,
    "descripcion":"TRASTORNO NEUROLÓGICO ASOCIADO A ALCOHOL"
  },
  {
    "codigo":251732007,
    "descripcion":"NEOVASCULARIZACIÓN DE ÁNGULO IRIDOCORNEAL"
  },
  {
    "codigo":282665000,
    "descripcion":"CAPAZ DE LANZAR"
  },
  {
    "codigo":249897001,
    "descripcion":"SUFRE DEBILIDAD QUE CAUSA INMOVILIDAD"
  },
  {
    "codigo":335371000119101,
    "descripcion":"CORIORRETINITIS DISEMINADA DE OJO DERECHO"
  },
  {
    "codigo":315433005,
    "descripcion":"NACIDO EN GRECIA"
  },
  {
    "codigo":16909681000119109,
    "descripcion":"DISFUNCIÓN DE GLÁNDULA DE MEIBOMIO DE PÁRPADO INFERIOR DERECHO"
  },
  {
    "codigo":84222005,
    "descripcion":"DETERMINACIÓN DEL RESULTADO: COMPLICACIÓN EVITABLE DERIVADA DE UN ERROR EN EL DIAGNÓSTICO"
  },
  {
    "codigo":248062006,
    "descripcion":"CONDUCTA AUTOLESIVA"
  },
  {
    "codigo":16851005,
    "descripcion":"MIOPATÍA MITOCONDRIAL"
  },
  {
    "codigo":278995006,
    "descripcion":"DOLOR A LA PALPACIÓN DE ROSTRO"
  },
  {
    "codigo":11804171000119105,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA DISTAL DE DEDO ÍNDICE DERECHO"
  },
  {
    "codigo":15016005,
    "descripcion":"PERICARDITIS PIÓGENA"
  },
  {
    "codigo":735912006,
    "descripcion":"LESIÓN TRAUMÁTICA DEBIDA A PROCEDIMIENTO"
  },
  {
    "codigo":111485001,
    "descripcion":"TRASTORNO BIPOLAR I MIXTO EN REMISIÓN TOTAL"
  },
  {
    "codigo":240722000,
    "descripcion":"CANDIDIASIS DISEMINADA AGUDA"
  },
  {
    "codigo":275325009,
    "descripcion":"ARTROPATÍA SECUNDARIA A HEMOGLOBINOPATÍA"
  },
  {
    "codigo":207954001,
    "descripcion":"FRACTURA EXPUESTA DE VÉRTEBRA DORSAL, APÓFISIS TRANSVERSA"
  },
  {
    "codigo":109650003,
    "descripcion":"TRAUMATISMO OCLUSAL SECUNDARIO LOCALIZADO"
  },
  {
    "codigo":699474000,
    "descripcion":"CURVA DE WILSON INVERSA"
  },
  {
    "codigo":42279001,
    "descripcion":"PARA 4"
  },
  {
    "codigo":75047002,
    "descripcion":"TRASTORNO DE MÚSCULO ESQUELÉTICO"
  },
  {
    "codigo":238887002,
    "descripcion":"PANICULITIS EOSINOFÍLICA"
  },
  {
    "codigo":402727002,
    "descripcion":"HIPERLIPEMIA SECUNDARIA"
  },
  {
    "codigo":15955621000119104,
    "descripcion":"NEOPLASIA BENIGNA DE AMBOS TESTÍCULOS"
  },
  {
    "codigo":308901000119105,
    "descripcion":"GOTA DE MÚLTIPLES LOCALIZACIONES DEBIDA A DISFUNCIÓN RENAL"
  },
  {
    "codigo":1156391009,
    "descripcion":"FRACTURA DEL CUERNO SUPERIOR DERECHO DEL CARTÍLAGO TIROIDES"
  },
  {
    "codigo":105980002,
    "descripcion":"ENFERMEDAD QUE AFECTA A TODO EL APARATO CARDIOVASCULAR"
  },
  {
    "codigo":237052004,
    "descripcion":"AUSENCIA ADQUIRIDA DE TROMPA DE FALOPIO"
  },
  {
    "codigo":40444006,
    "descripcion":"ABORTO ESPONTÁNEO CON ATROFIA AMARILLA AGUDA DE HÍGADO"
  },
  {
    "codigo":300753000,
    "descripcion":"NO REALIZA ACTIVIDADES DE JARDINERÍA"
  },
  {
    "codigo":202449006,
    "descripcion":"TUMOR TENOSINOVIAL DE CÉLULAS GIGANTES DIFUSO DE ARTICULACIÓN ASTRAGALONAVICULAR"
  },
  {
    "codigo":366289008,
    "descripcion":"HALLAZGO RELACIONADO CON LA RETRACCIÓN DEL PREPUCIO"
  },
  {
    "codigo":397222001,
    "descripcion":"PRESENCIA DE MUSCULAR PROPIA EN ESPÉCIMEN NO DETERMINADO"
  },
  {
    "codigo":724902001,
    "descripcion":"LACERACIÓN DE MÚSCULO DE LA PELVIS"
  },
  {
    "codigo":4006006,
    "descripcion":"TAQUICARDIA FETAL QUE AFECTA EL MANEJO DE LA SITUACIÓN MATERNA"
  },
  {
    "codigo":167846009,
    "descripcion":"PH DE VÓMITO MÁS ÁCIDO QUE RANGO DE REFERENCIA"
  },
  {
    "codigo":297083002,
    "descripcion":"SOBREDOSIS DE DIPIRIDAMOL"
  },
  {
    "codigo":460923005,
    "descripcion":"ORIGEN ANÓMALO DE ARTERIA CORONARIA DERECHA EN SENO AÓRTICO DE ARTERIA CORONARIA IZQUIERDA"
  },
  {
    "codigo":65872000,
    "descripcion":"PRONÓSTICO REGULAR"
  },
  {
    "codigo":721232000,
    "descripcion":"SÍNDROME HIDROLETALUS"
  },
  {
    "codigo":229712006,
    "descripcion":"TRASTORNOS DE LA ATENCIÓN Y EL CONTROL MOTOR"
  },
  {
    "codigo":295248006,
    "descripcion":"SOBREDOSIS INTENCIONAL DE FLURBIPROFENO"
  },
  {
    "codigo":293413000,
    "descripcion":"REACCIÓN ADVERSA AL CINC"
  },
  {
    "codigo":1145381004,
    "descripcion":"APLASIA DE BÍCEPS BRAQUIAL"
  },
  {
    "codigo":129573006,
    "descripcion":"ENFERMEDAD ATEROSCLERÓTICA OCLUSIVA"
  },
  {
    "codigo":337881000119102,
    "descripcion":"ECTASIA DE ESCLERÓTICA IZQUIERDA"
  },
  {
    "codigo":719397009,
    "descripcion":"DISPLASIA MESOMÉLICA TIPO KANTAPUTRA"
  },
  {
    "codigo":16011071000119109,
    "descripcion":"ARTROPATÍA DE AMBOS PIES"
  },
  {
    "codigo":94970005,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL NERVIO OLFATORIO"
  },
  {
    "codigo":11833151000119109,
    "descripcion":"ESGUINCE DE LIGAMENTO DE ARTICULACIÓN METATARSOFALÁNGICA DE DEDO GORDO DE PIE IZQUIERDO"
  },
  {
    "codigo":291578007,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR LATAMOXEF"
  },
  {
    "codigo":422650009,
    "descripcion":"AISLAMIENTO SOCIAL"
  },
  {
    "codigo":783098009,
    "descripcion":"BAJA ESTATURA DEBIDA A DEFICIENCIA PARCIAL DE RECEPTOR DE HORMONA DE CRECIMIENTO"
  },
  {
    "codigo":677381000119103,
    "descripcion":"AMBOS GLOBOS OCULARES CONTRAÍDOS"
  },
  {
    "codigo":1010639007,
    "descripcion":"ANOMALÍA DE VENA UMBILICAL GRUPO I"
  },
  {
    "codigo":289743008,
    "descripcion":"HALLAZGO RELACIONADO CON LA RETRACCIÓN DEL SEGMENTO SUPERIOR"
  },
  {
    "codigo":224207009,
    "descripcion":"POSEE SU PROPIA CHEQUERA"
  },
  {
    "codigo":255140001,
    "descripcion":"CARCINOMA IN SITU DE CAVIDAD NASAL Y NASOFARINGE"
  },
  {
    "codigo":58532003,
    "descripcion":"EMBARAZO NO DESEADO"
  },
  {
    "codigo":715727009,
    "descripcion":"SÍNDROME DE INTERRUPCIÓN DEL TALLO HIPOFISARIO"
  },
  {
    "codigo":25764005,
    "descripcion":"ABSCESO AGUDO DE SENO FRONTAL"
  },
  {
    "codigo":124068005,
    "descripcion":"PORFIRINA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":449913000,
    "descripcion":"LONGITUD VERTICAL CORTA DE LABIO SUPERIOR"
  },
  {
    "codigo":417145006,
    "descripcion":"RETINOPATÍA SARAMPIONOSA"
  },
  {
    "codigo":1075161000119108,
    "descripcion":"DEFORMIDAD EN VALGO ADQUIRIDA DE RODILLA IZQUIERDA"
  },
  {
    "codigo":253305008,
    "descripcion":"TRONCO ARTERIAL ÚNICO"
  },
  {
    "codigo":56697009,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DEL CUERO CABELLUDO"
  },
  {
    "codigo":187769009,
    "descripcion":"CARCINOMA PRIMARIO DEL HÍGADO"
  },
  {
    "codigo":286073006,
    "descripcion":"INCAPAZ DE AIREAR LA ROPA LAVADA"
  },
  {
    "codigo":251470005,
    "descripcion":"PÉRDIDA DE REACTIVIDAD"
  },
  {
    "codigo":448078006,
    "descripcion":"ANILLO VASCULAR CON CAYADO AÓRTICO DERECHO Y LIGAMENTO ARTERIAL DERECHO CON ARTERIA PULMONAR IZQUIERDA AUSENTE"
  },
  {
    "codigo":112631000146107,
    "descripcion":"DISTENSIÓN DE MÚSCULO PECTORAL"
  },
  {
    "codigo":1003299007,
    "descripcion":"CLINODACTILIA CONGÉNITA DE FALANGE DISTAL DE DEDO MEÑIQUE"
  },
  {
    "codigo":20259008,
    "descripcion":"HALLAZGO RELACIONADO CON EL PELOTEO FETAL"
  },
  {
    "codigo":446243008,
    "descripcion":"PULSO PEDIO TRIFÁSICO"
  },
  {
    "codigo":413475007,
    "descripcion":"CUESTIONARIO SOBRE ALCOHOL COMPLETADO"
  },
  {
    "codigo":249635008,
    "descripcion":"ANO PERMEABLE"
  },
  {
    "codigo":247800004,
    "descripcion":"VARIACIÓN DIURNA DEL HUMOR"
  },
  {
    "codigo":1263608006,
    "descripcion":"TRASTORNO FETAL DEBIDO A TRABAJO DE PARTO PROLONGADO"
  },
  {
    "codigo":444408007,
    "descripcion":"ADENOMA TUBULAR"
  },
  {
    "codigo":213197002,
    "descripcion":"RUPTURA DE REPARACIÓN NERVIOSA"
  },
  {
    "codigo":1163469007,
    "descripcion":"MENINGITIS POR VIRUS MACHUPO"
  },
  {
    "codigo":211362000,
    "descripcion":"PICADURA DE INSECTO, NO VENENOSO, EN EL TOBILLO"
  },
  {
    "codigo":735650003,
    "descripcion":"LESIÓN TRAUMÁTICA CERRADA DE AMBOS GLOBOS OCULARES"
  },
  {
    "codigo":78455002,
    "descripcion":"ALTERACIÓN VISUAL SUBJETIVA"
  },
  {
    "codigo":1290871007,
    "descripcion":"OSTEOSARCOMA CONVENCIONAL"
  },
  {
    "codigo":406135009,
    "descripcion":"DISCAPACIDAD SENSORIAL"
  },
  {
    "codigo":699212006,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN EN MAMA"
  },
  {
    "codigo":830284007,
    "descripcion":"SOLO CAPAZ DE CONTAR DEDOS CON EL OJO IZQUIERDO"
  },
  {
    "codigo":240460008,
    "descripcion":"POLIOMIELITIS PARALÍTICA AGUDA"
  },
  {
    "codigo":109388009,
    "descripcion":"SARCOMA DE KAPOSI DEL PALADAR"
  },
  {
    "codigo":762913001,
    "descripcion":"HIPOPLASIA DE RIÑÓN IZQUIERDO"
  },
  {
    "codigo":284941000119107,
    "descripcion":"BLOQUEO AURICULOVENTRICULAR DE SEGUNDO GRADO DE ALTO GRADO"
  },
  {
    "codigo":238625005,
    "descripcion":"QUERATOSIS FOLICULAR"
  },
  {
    "codigo":402465005,
    "descripcion":"MIXEDEMA PRETIBIAL TUBEROSO Y NODULAR CIRCUNSCRIPTO"
  },
  {
    "codigo":369697008,
    "descripcion":"MARGEN LATERAL INFERIOR DE RESECCIÓN QUIRÚRGICA DE RECTO, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":1187062004,
    "descripcion":"CAPACIDAD TOTAL DE FIJACIÓN DE HIERRO POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":236790005,
    "descripcion":"INFERTILIDAD CONGÉNITA EN EL VARÓN"
  },
  {
    "codigo":72950008,
    "descripcion":"GASTRITIS INDUCIDA POR BILIS"
  },
  {
    "codigo":5579000,
    "descripcion":"HIPERCALIEMIA AGUDA"
  },
  {
    "codigo":366027003,
    "descripcion":"REACCIÓN PUPILAR CERCANA - HALLAZGO"
  },
  {
    "codigo":15987111000119104,
    "descripcion":"ANOMALÍA CONGÉNITA DE AMBAS PUPILAS"
  },
  {
    "codigo":234955005,
    "descripcion":"EVAGINACIÓN DENTAL"
  },
  {
    "codigo":202187007,
    "descripcion":"LUXACIÓN PATOLÓGICA DE ARTICULACIÓN INTERFALÁNGICA DISTAL"
  },
  {
    "codigo":726475009,
    "descripcion":"ONICÓLISIS CAUSADA POR SUSTANCIA QUÍMICA"
  },
  {
    "codigo":3744001,
    "descripcion":"HIPERLIPOPROTEINEMIA"
  },
  {
    "codigo":429728004,
    "descripcion":"URETRITIS BACTERIANA"
  },
  {
    "codigo":67445002,
    "descripcion":"DERMATITIS DE CONTACTO CAUSADA POR ALIMENTO EN CONTACTO CON LA PIEL"
  },
  {
    "codigo":1148789004,
    "descripcion":"FUNCIÓN DEL SISTEMA ENDOCRINO NORMAL"
  },
  {
    "codigo":196682000,
    "descripcion":"ÚLCERA PÉPTICA AGUDA"
  },
  {
    "codigo":294986001,
    "descripcion":"ALERGIA A BRETILIO"
  },
  {
    "codigo":11782721000119103,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN DE RODILLA IZQUIERDA"
  },
  {
    "codigo":360522009,
    "descripcion":"ÉPULIS CONGÉNITO DEL RECIÉN NACIDO"
  },
  {
    "codigo":293151005,
    "descripcion":"REACCIÓN ADVERSA A LA FLUOCINONIDA"
  },
  {
    "codigo":11864641000119105,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DE PIERNA DERECHA"
  },
  {
    "codigo":313921000119106,
    "descripcion":"ATROFIA DE MÚSCULO DE MUSLO DERECHO"
  },
  {
    "codigo":1208820007,
    "descripcion":"AVULSIÓN TRAUMÁTICA DE CANTO MEDIAL DE OJO"
  },
  {
    "codigo":715465001,
    "descripcion":"DEGENERACIÓN ESPINOCEREBELOSA CONCOMITANTE CON DISTROFIA MACULAR DE DE CÓRNEA"
  },
  {
    "codigo":94708009,
    "descripcion":"MICOSIS FUNGOIDE DE GANGLIOS LINFÁTICOS INTRAPÉLVICOS"
  },
  {
    "codigo":125641004,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA VESÍCULA SEMINAL"
  },
  {
    "codigo":289481004,
    "descripcion":"DEPÓSITOS BLANQUECINOS EN LA VULVA"
  },
  {
    "codigo":92873007,
    "descripcion":"FUSIÓN ANORMAL CONGÉNITA DE HUESO PREESFENOIDAL"
  },
  {
    "codigo":191177007,
    "descripcion":"ANEMIA HEMOLÍTICA POR DEFICIENCIA DE HEXOCINASA"
  },
  {
    "codigo":1336222000,
    "descripcion":"NEOPLASIA BILATERAL DE GLOBOS OCULARES"
  },
  {
    "codigo":27337007,
    "descripcion":"EXTRASÍSTOLES VENTRICULARES UNIFOCALES"
  },
  {
    "codigo":123806003,
    "descripcion":"BISALBUMINEMIA"
  },
  {
    "codigo":1303454004,
    "descripcion":"GLAUCOMA DE ÁNGULO ABIERTO DE OJO DERECHO DEBIDO A TRASTORNO VASCULAR OCULAR"
  },
  {
    "codigo":254878006,
    "descripcion":"CARCINOMA ENDOMETRIAL"
  },
  {
    "codigo":91038008,
    "descripcion":"SINUSITIS FRONTAL AGUDA"
  },
  {
    "codigo":25502009,
    "descripcion":"LINFOCITOPENIA EPISÓDICA"
  },
  {
    "codigo":449651003,
    "descripcion":"VENA VARICOSA RECURRENTE DE MIEMBRO INFERIOR"
  },
  {
    "codigo":23667007,
    "descripcion":"EMBARAZO A TÉRMINO - NACIDO"
  },
  {
    "codigo":56435009,
    "descripcion":"POBREZA DEL CONTENIDO DEL PENSAMIENTO"
  },
  {
    "codigo":283976007,
    "descripcion":"LESIÓN TRAUMÁTICA VULVAR"
  },
  {
    "codigo":249373000,
    "descripcion":"SENO FRONTOETMOIDAL - HALLAZGO"
  },
  {
    "codigo":185672009,
    "descripcion":"CRIBADO PARA DETECCIÓN DE ALTERACIONES DE LA TENSIÓN ARTERIAL - NUEVA CONVOCATORIA ANULADA"
  },
  {
    "codigo":773661002,
    "descripcion":"HERNIA FEMORAL RECIDIVANTE"
  },
  {
    "codigo":1332552007,
    "descripcion":"ARTRITIS ESTAFILOCÓCICA DE CADERA IZQUIERDA"
  },
  {
    "codigo":413213005,
    "descripcion":"DUODENO DEFORMADO ULCEROGÉNICO"
  },
  {
    "codigo":50930000,
    "descripcion":"PERIDACRIOCISTITIS AGUDA"
  },
  {
    "codigo":247538005,
    "descripcion":"HALLAZGO DE FOLÍCULO PILOSO"
  },
  {
    "codigo":737223000,
    "descripcion":"NEOPLASIA DE CÉLULAS DENDRÍTICAS"
  },
  {
    "codigo":16327006,
    "descripcion":"INTOXICACIÓN POR FAGUS SYLVATICA"
  },
  {
    "codigo":276636000,
    "descripcion":"ESTENOSIS SUBGLÓTICA POSTERIOR A INTUBACIÓN"
  },
  {
    "codigo":1259676000,
    "descripcion":"MELANOMA NODULAR DE MEMBRANA MUCOSA PRIMARIO"
  },
  {
    "codigo":704455008,
    "descripcion":"FRACTURA METAFISARIA EXPUESTA DE PRIMER METATARSIANO"
  },
  {
    "codigo":473244004,
    "descripcion":"QUEMADURA DE REGIÓN OCULAR CON QUEMADURA EPIDÉRMICA DE CARA"
  },
  {
    "codigo":243868008,
    "descripcion":"ESTADO DE CONTROL DE TRASTORNO GINECOLÓGICO"
  },
  {
    "codigo":405873000,
    "descripcion":"FENOTIPO LU(B+)"
  },
  {
    "codigo":830022001,
    "descripcion":"QUISTE DERMOIDE DE PÁNCREAS"
  },
  {
    "codigo":240198002,
    "descripcion":"APLASTAMIENTO OSTEOPORÓTICO DE VÉRTEBRA"
  },
  {
    "codigo":209265009,
    "descripcion":"FRACTURA-LUXACIÓN NO EXPUESTA DE LA ARTICULACIÓN RADIOCUBITAL DISTAL"
  },
  {
    "codigo":404038007,
    "descripcion":"TUMOR EPITELIOIDE MALIGNO DE VAINA DE NERVIO PERIFÉRICO"
  },
  {
    "codigo":305734008,
    "descripcion":"VISTA POR ENFERMERA ESPECIALIZADA EN CUIDADOS MAMARIOS"
  },
  {
    "codigo":402203003,
    "descripcion":"DERMATITIS SEBORREICA AGUDA GENERALIZADA"
  },
  {
    "codigo":762651004,
    "descripcion":"OCLUSIÓN DE ARTERIA CEREBRAL POSTERIOR DERECHA POR ÉMBOLO"
  },
  {
    "codigo":271131005,
    "descripcion":"AMPOLLA TRAUMÁTICA DE TRONCO, INFECTADA"
  },
  {
    "codigo":1186800000,
    "descripcion":"TRASTORNO NEUROLÓGICO DEBIDO A OBESIDAD"
  },
  {
    "codigo":269296005,
    "descripcion":"COMPLICACIÓN DE MANO REIMPLANTADA"
  },
  {
    "codigo":208041000119100,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE ENDOCÉRVIX"
  },
  {
    "codigo":201925000,
    "descripcion":"ENFERMEDAD DE KASHIN-BECK DE REGIÓN PÉLVICA Y MUSLO"
  },
  {
    "codigo":236528009,
    "descripcion":"ESCLEROSIS MESANGIAL DIFUSA CON ANOMALÍAS OCULARES"
  },
  {
    "codigo":429466000,
    "descripcion":"ESPINA BÍFIDA ABIERTA DE COLUMNA VERTEBRAL LUMBAR"
  },
  {
    "codigo":69018001,
    "descripcion":"POSICIÓN MENTOILÍACA DERECHA TRANSVERSA"
  },
  {
    "codigo":365765009,
    "descripcion":"NIVELES DE ELECTRÓLITOS SÉRICOS - HALLAZGO"
  },
  {
    "codigo":3482005,
    "descripcion":"ESOFAGITIS POSTOPERATORIA"
  },
  {
    "codigo":298394007,
    "descripcion":"CIFOESCOLIOSIS CERVICAL"
  },
  {
    "codigo":427631000,
    "descripcion":"CON MAYOR RIESGO DE TROMBOEMBOLIA VENOSA"
  },
  {
    "codigo":126121000119104,
    "descripcion":"NIVEL DE FERRITINA SÉRICA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":722543005,
    "descripcion":"MELANOMA MALIGNO PRIMARIO DE CONDUCTO ANAL"
  },
  {
    "codigo":1647007,
    "descripcion":"INTOXICACIÓN POR PRIMAQUINA"
  },
  {
    "codigo":296559008,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE CLOROQUINA"
  },
  {
    "codigo":15690921000119105,
    "descripcion":"ARTRITIS ENTEROPÁTICA DE AMBAS ARTICULACIONES RADIOCARPIANAS"
  },
  {
    "codigo":32580004,
    "descripcion":"ENTERITIS POR ENTEROVIRUS"
  },
  {
    "codigo":1179460004,
    "descripcion":"MAGNESIO EN SANGRE POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":391193001,
    "descripcion":"CON REGISTRO DE ENFERMEDAD MENTAL GRAVE"
  },
  {
    "codigo":423961006,
    "descripcion":"ALMACENAMIENTO DE OBJETOS PELIGROSOS EN CONDICIONES NO SEGURAS"
  },
  {
    "codigo":784409008,
    "descripcion":"HEMATOMA DE OVARIO"
  },
  {
    "codigo":1144857008,
    "descripcion":"MEJORÍA EN EL EQUILIBRIO ÁCIDO-BASE"
  },
  {
    "codigo":127214002,
    "descripcion":"HIPERPLASIA ANGIOFOLICULAR DE GANGLIOS LINFÁTICOS, PLASMOCÍTICA"
  },
  {
    "codigo":292889008,
    "descripcion":"REACCIÓN ADVERSA A ISETIONATO DE DIBROMPROPAMIDINA"
  },
  {
    "codigo":94446003,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LOS GANGLIOS LINFÁTICOS DEL OBTURADOR"
  },
  {
    "codigo":225518001,
    "descripcion":"SEXO SÓLO EN EL MARCO DE UNA RELACIÓN"
  },
  {
    "codigo":422126006,
    "descripcion":"COMA HIPEROSMOLAR DEBIDO A DIABETES MELLITUS"
  },
  {
    "codigo":92611000,
    "descripcion":"CARCINOMA IN SITU DE LA CARA HIPOFARÍNGEA DEL PLIEGUE INTERARITENOIDEO"
  },
  {
    "codigo":291054009,
    "descripcion":"INTOXICACIÓN POR BROMAZEPAM"
  },
  {
    "codigo":190915002,
    "descripcion":"COPROPORFIRIA"
  },
  {
    "codigo":345411000119104,
    "descripcion":"ESTENOSIS DE AMBOS SACOS LAGRIMALES"
  },
  {
    "codigo":27075004,
    "descripcion":"ENFERMEDAD VENÉREA EN LA MADRE QUE COMPLICA EL EMBARAZO, EL PARTO Y\/O EL PUERPERIO"
  },
  {
    "codigo":715203008,
    "descripcion":"BAÑO EN EL PISO DE ABAJO"
  },
  {
    "codigo":289219009,
    "descripcion":"SEGUNDA ETAPA DEL TRABAJO DE PARTO, RÁPIDA"
  },
  {
    "codigo":58008004,
    "descripcion":"PELIOSIS HEPÁTICA"
  },
  {
    "codigo":189080005,
    "descripcion":"NEOPLASIA BENIGNA DE LA PIEL DEL BRAZO"
  },
  {
    "codigo":1303192006,
    "descripcion":"INFECCIÓN DE PERONÉ ASOCIADA CON DISPOSITIVO DE FIJACIÓN INTERNA"
  },
  {
    "codigo":285549001,
    "descripcion":"INCAPAZ DE ELEVAR EL PALADAR BLANDO"
  },
  {
    "codigo":99651000119107,
    "descripcion":"PREPUCIO HIPERTRÓFICO MASCULINO"
  },
  {
    "codigo":56173004,
    "descripcion":"POIQUILOTERMIA"
  },
  {
    "codigo":711533005,
    "descripcion":"ESPÉCIMEN RECHAZADO DEBIDO A IDENTIFICADORES ILEGIBLES EN EL ESPÉCIMEN"
  },
  {
    "codigo":1137517008,
    "descripcion":"DEBILIDAD DE MÚSCULO RESPIRATORIO"
  },
  {
    "codigo":185410002,
    "descripcion":"CITA SOLICITADA POR LA HIJA"
  },
  {
    "codigo":414786004,
    "descripcion":"SOPLO"
  },
  {
    "codigo":15965661000119103,
    "descripcion":"ENDOMETRIOSIS EN LIGAMENTO ANCHO IZQUIERDO"
  },
  {
    "codigo":609559001,
    "descripcion":"TEMBLOR ESENCIAL HEREDITARIO"
  },
  {
    "codigo":773399002,
    "descripcion":"ALERGIA A ACETILCOLINA"
  },
  {
    "codigo":283714009,
    "descripcion":"MORDEDURA HUMANA EN EL ABDOMEN"
  },
  {
    "codigo":314647005,
    "descripcion":"PERÍMETRO CEFÁLICO DEL NIÑO: PERCENTILO 3-8"
  },
  {
    "codigo":19735005,
    "descripcion":"SÍNDROME DE COMPRESIÓN PREQUIASMÁTICA INCIPIENTE DEL NERVIO ÓPTICO"
  },
  {
    "codigo":1363223006,
    "descripcion":"CICATRIZACIÓN DE PÁRPADO INFERIOR DERECHO"
  },
  {
    "codigo":247276003,
    "descripcion":"AUSENCIA DE MARTILLO Y YUNQUE"
  },
  {
    "codigo":214508004,
    "descripcion":"ACCIDENTE DE TRÁNSITO VEHICULAR DE TIPO NO COLISIÓN CON INTOXICACIÓN ACCIDENTAL POR GASES DE ESCAPE GENERADOS POR VEHÍCULO EN MOVIMIENTO, ACOMPAÑANTE DEL MOTOCICLISTA HERIDO"
  },
  {
    "codigo":83436008,
    "descripcion":"YERSINIOSIS"
  },
  {
    "codigo":16065006,
    "descripcion":"ANQUILOSIS DE LA ARTICULACIÓN SACROILÍACA"
  },
  {
    "codigo":1259414001,
    "descripcion":"CISTOADENOCARCINOMA PRIMARIO DE OVARIO"
  },
  {
    "codigo":276374003,
    "descripcion":"RUIDOS CARDÍACOS FETALES AMORTIGUADOS"
  },
  {
    "codigo":14230004,
    "descripcion":"DEFICIENCIA ADQUIRIDA DE FACTOR VIII"
  },
  {
    "codigo":702358005,
    "descripcion":"SÍNDROME DE CONDUCTO DE MÜLLER PERSISTENTE"
  },
  {
    "codigo":210838007,
    "descripcion":"LESIÓN DE LA ARTERIA RADIAL A NIVEL DE LA MUÑECA Y LA MANO"
  },
  {
    "codigo":274539000,
    "descripcion":"ECOGRAFÍA DE CABEZA: ANORMAL"
  },
  {
    "codigo":45163000,
    "descripcion":"HIPOPLASIA PONTOCEREBELOSA CONGÉNITA"
  },
  {
    "codigo":241771004,
    "descripcion":"EFECTO TÓXICO CAUSADO POR COMPUESTO DE ARSÉNICO PENTAVALENTE"
  },
  {
    "codigo":209003005,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN MEDIOTARSIANA"
  },
  {
    "codigo":733291008,
    "descripcion":"LACERACIÓN DE PIERNA CON CUERPO EXTRAÑO"
  },
  {
    "codigo":698688002,
    "descripcion":"TRASTORNO DE LA COMUNICACIÓN NO ORGÁNICO EN REMISIÓN"
  },
  {
    "codigo":403776002,
    "descripcion":"SÍNDROME CUTANEOVASCULAR HEREDITARIO"
  },
  {
    "codigo":305472002,
    "descripcion":"BAJO ATENCIÓN DE CARDIÓLOGO"
  },
  {
    "codigo":239936008,
    "descripcion":"GRANULOMATOSIS DE WEGENER CON POLIANGEÍTIS CON COMPROMISO MULTISISTÉMICO"
  },
  {
    "codigo":762389001,
    "descripcion":"ECCEMA DE PIERNA"
  },
  {
    "codigo":238101001,
    "descripcion":"VARIANTE 3 APO A-I MUNSTER"
  },
  {
    "codigo":16021111000119107,
    "descripcion":"BURSITIS GOTOSA BILATERAL DE RODILLAS"
  },
  {
    "codigo":1255744009,
    "descripcion":"SARCOMA DE HODGKIN DE GANGLIOS LINFÁTICOS DE CUELLO"
  },
  {
    "codigo":10211000132109,
    "descripcion":"DEPRESIÓN PERINATAL"
  },
  {
    "codigo":8725005,
    "descripcion":"ABSCESO DE PRÓSTATA"
  },
  {
    "codigo":367338000,
    "descripcion":"DERMATITIS INFECCIOSA"
  },
  {
    "codigo":301802001,
    "descripcion":"ABSCESO DE REGIÓN LUMBAR"
  },
  {
    "codigo":102161000119102,
    "descripcion":"PROBLEMAS DE RELACIÓN CON MIEMBROS DE LA FAMILIA DEBIDOS A AFECCIÓN MENTAL"
  },
  {
    "codigo":400106006,
    "descripcion":"TRASTORNO DE PIEL DE TRONCO"
  },
  {
    "codigo":267199000,
    "descripcion":"HEMORRAGIA EN EL PREPARTO CON DEFECTO DE COAGULACIÓN"
  },
  {
    "codigo":365503002,
    "descripcion":"AMBIENTE LOCAL Y DETALLES DEL ENTORNO VECINAL - HALLAZGO"
  },
  {
    "codigo":431039004,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE PÁRPADO"
  },
  {
    "codigo":70591005,
    "descripcion":"TRASTORNO FETAL"
  },
  {
    "codigo":201663006,
    "descripcion":"ARTRITIS GOTOSA DE REGIÓN DE HOMBRO"
  },
  {
    "codigo":299967007,
    "descripcion":"COMPRESIÓN DE RAÍZ DE NERVIO SACRO"
  },
  {
    "codigo":363668000,
    "descripcion":"COLESTEATOMA"
  },
  {
    "codigo":398271008,
    "descripcion":"DEFECTO PREDOMINANTEMENTE DE CÉLULAS T"
  },
  {
    "codigo":234431006,
    "descripcion":"DEFICIENCIA ESPECÍFICA GRANULAR"
  },
  {
    "codigo":1184703009,
    "descripcion":"PERIODONTITIS DEBIDA A AGRANULOCITOSIS GENÉTICA INFANTIL"
  },
  {
    "codigo":722281001,
    "descripcion":"SÍNDROME DE AGAMMAGLOBULINEMIA, MICROCEFALIA, CRANEOSINOSTOSIS Y DERMATITIS SEVERA"
  },
  {
    "codigo":230761005,
    "descripcion":"EDEMA PERIVENTRICULAR DE LÍQUIDO CEFALORRAQUÍDEO"
  },
  {
    "codigo":425534001,
    "descripcion":"CASCO UTILIZADO"
  },
  {
    "codigo":720446005,
    "descripcion":"MACRÓFAGO ALVEOLAR NO OBSERVADO"
  },
  {
    "codigo":321451000119103,
    "descripcion":"RUPTURA ESPONTÁNEA DE TENDÓN EXTENSOR DE MANO DERECHA"
  },
  {
    "codigo":294462007,
    "descripcion":"ALERGIA A AMINOGLUCÓSIDO"
  },
  {
    "codigo":30483005,
    "descripcion":"AMBLIOPÍA POR TABACO"
  },
  {
    "codigo":63251006,
    "descripcion":"MIOSIS PERSISTENTE"
  },
  {
    "codigo":718611007,
    "descripcion":"HIPOPLASIA PONTOCEREBELOSA CONGÉNITA TIPO 8"
  },
  {
    "codigo":390931008,
    "descripcion":"SENSIBILIDAD AL MONOFILAMENTO DE 10 G, PRESENTE"
  },
  {
    "codigo":55131000087105,
    "descripcion":"CON MAYOR RIESGO DE DESORIENTACIÓN"
  },
  {
    "codigo":292627005,
    "descripcion":"REACCIÓN ADVERSA AL ALQUITRÁN MINERAL"
  },
  {
    "codigo":1306600003,
    "descripcion":"NEUMONITIS POR ASPIRACIÓN POSTERIOR A PROCEDIMIENTO"
  },
  {
    "codigo":39771000087108,
    "descripcion":"LUXACIÓN DE ARTICULACIÓN DE PULGAR DERECHO"
  },
  {
    "codigo":126952004,
    "descripcion":"NEOPLASIA DE ENCÉFALO"
  },
  {
    "codigo":34651000087109,
    "descripcion":"ACTINOBACILLUS EQUULI O ACTINOBACILLUS SUIS"
  },
  {
    "codigo":94184004,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA BASE DE LA LENGUA"
  },
  {
    "codigo":61416008,
    "descripcion":"EVALUACIÓN DE DISCAPACIDAD: 90%"
  },
  {
    "codigo":421864009,
    "descripcion":"HALLAZGO RELACIONADO CON LA FORMA CORNEAL"
  },
  {
    "codigo":290792009,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR LISURIDA"
  },
  {
    "codigo":125117003,
    "descripcion":"ERITEMA IDIOPÁTICO"
  },
  {
    "codigo":10971051000119107,
    "descripcion":"LACERACIÓN DE MANO DERECHA"
  },
  {
    "codigo":92349005,
    "descripcion":"NEOPLASIA BENIGNA DE PIEL DE MAMA"
  },
  {
    "codigo":271368004,
    "descripcion":"NACIDO EN PARTO CON FÓRCEPS BAJO"
  },
  {
    "codigo":449127009,
    "descripcion":"SEPARACIÓN NORMAL DE COMISURAS DE VÁLVULA AÓRTICA"
  },
  {
    "codigo":447292006,
    "descripcion":"ENCEFALOMIOPATÍA MITOCONDRIAL"
  },
  {
    "codigo":283452009,
    "descripcion":"HERIDA PUNZANTE EN LA REGIÓN AURICULAR"
  },
  {
    "codigo":445457002,
    "descripcion":"HIPERPLASIA DE HUESO MAXILAR"
  },
  {
    "codigo":840508009,
    "descripcion":"AUSENCIA CONGÉNITA DE VESÍCULAS SEMINALES"
  },
  {
    "codigo":86844009,
    "descripcion":"FRACTURA EXPUESTA DE EXTREMO SUPERIOR DE HÚMERO"
  },
  {
    "codigo":248849008,
    "descripcion":"HIMEN TIRANTE"
  },
  {
    "codigo":738534004,
    "descripcion":"METABOLIZADOR NORMAL DE LA FAMILIA 2 SUBFAMILIA D MIEMBRO 6 DEL CITOCROMO P450"
  },
  {
    "codigo":83174008,
    "descripcion":"INTOXICACIÓN POR PORTULACA"
  },
  {
    "codigo":771302009,
    "descripcion":"ENFERMEDAD DE LA NEURONA MOTORA INFERIOR AUTOSÓMICA RECESIVA DE INICIO EN LA NIÑEZ"
  },
  {
    "codigo":703931001,
    "descripcion":"ALERGIA A CARNE"
  },
  {
    "codigo":15997151000119104,
    "descripcion":"PLIEGUE COROIDEO CONGÉNITO DE OJO DERECHO"
  },
  {
    "codigo":441787004,
    "descripcion":"HIPERTROFIA DE ENCÍAS"
  },
  {
    "codigo":1197286008,
    "descripcion":"CARCINOMA MIXTO ACINAR DUCTAL PRIMARIO DE PÁNCREAS"
  },
  {
    "codigo":81339006,
    "descripcion":"SÍFILIS SECUNDARIA DE LA AMÍGDALA"
  },
  {
    "codigo":767632000,
    "descripcion":"TRASTORNO BIPOLAR, EPISODIO MÁS RECIENTE MANÍACO"
  },
  {
    "codigo":15803009,
    "descripcion":"DOLOR DE VEJIGA URINARIA"
  },
  {
    "codigo":736699009,
    "descripcion":"REQUIERE REFUERZO DE VACUNA CONTRA HEPATITIS B"
  },
  {
    "codigo":276112003,
    "descripcion":"CÓNYUGE DESATENTO"
  },
  {
    "codigo":307045001,
    "descripcion":"OLOR DE GANGRENA GASEOSA"
  },
  {
    "codigo":700261003,
    "descripcion":"DERMATITIS ECCEMATOSA DE PÁRPADO INFERIOR"
  },
  {
    "codigo":1290085003,
    "descripcion":"NEOPLASIA NEUROENDOCRINA DE COLON TRANSVERSO"
  },
  {
    "codigo":733029008,
    "descripcion":"PARAPLEJÍA ESPÁSTICA AUTOSÓMICA DOMINANTE TIPO 29"
  },
  {
    "codigo":10298002,
    "descripcion":"VÍCTIMA, MOTOCICLISTA EN ACCIDENTE VEHICULAR Y\/O DE TRÁNSITO"
  },
  {
    "codigo":403514006,
    "descripcion":"CALCINOSIS ASOCIADA CON ESCLERODERMIA"
  },
  {
    "codigo":75834006,
    "descripcion":"SÍNDROME DE STRACHAN"
  },
  {
    "codigo":73999000,
    "descripcion":"INFARTO DE MIOCARDIO POSTERIOR EN EL ELECTROCARDIOGRAMA"
  },
  {
    "codigo":1157178009,
    "descripcion":"COMPRESIÓN DE PARÉNQUIMA RENAL"
  },
  {
    "codigo":303375002,
    "descripcion":"TOMA UNA POSICIÓN"
  },
  {
    "codigo":15724921000119104,
    "descripcion":"TRASTORNO DE ENTESIS DE AMBAS REGIONES DE HOMBROS"
  },
  {
    "codigo":1351951002,
    "descripcion":"SATURACIÓN DE OXÍGENO POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":237839005,
    "descripcion":"ANOMALÍA DEL RECEPTOR DE LA HORMONA DEL CRECIMIENTO"
  },
  {
    "codigo":270607006,
    "descripcion":"EN ESPERA DEL INFORME POSTMORTEM DEL CIRUJANO POLICIAL"
  },
  {
    "codigo":236004002,
    "descripcion":"ASCITIS CONCOMITANTE CON TRASTORNO HEPÁTICO Y DEBIDA A ÉL"
  },
  {
    "codigo":1153508003,
    "descripcion":"SOBREDOSIS DE CLORAL Y\/O DERIVADO DE CLORAL"
  },
  {
    "codigo":203236005,
    "descripcion":"INFECCIÓN DEL ASTRÁGALO"
  },
  {
    "codigo":6628008,
    "descripcion":"FRACTURA EXPUESTA DE DIÁFISIS DE FÉMUR"
  },
  {
    "codigo":301540008,
    "descripcion":"SE SIENTA Y SE LEVANTA DEL INODORO"
  },
  {
    "codigo":1348281002,
    "descripcion":"ARTRITIS Y PERIARTRITIS POR PIROFOSFATO DE CALCIO"
  },
  {
    "codigo":365241005,
    "descripcion":"ETAPA DEL PROCESO DE DUELO - HALLAZGO"
  },
  {
    "codigo":823993006,
    "descripcion":"CIANOSIS DE PIEL SOBRE LESIÓN"
  },
  {
    "codigo":37561006,
    "descripcion":"MECANISMO DEFECTUOSO DE REGULACIÓN DE LA SED"
  },
  {
    "codigo":723854000,
    "descripcion":"SARCOMA DE EWING PRIMARIO DE CARTÍLAGO ARTICULAR DE EXTREMIDAD"
  },
  {
    "codigo":234169009,
    "descripcion":"SÍNCOPE DE DEFECACIÓN"
  },
  {
    "codigo":68494000,
    "descripcion":"SOPLO MESOSISTÓLICO"
  },
  {
    "codigo":1217209006,
    "descripcion":"CRISIS EPILÉPTICA TÓNICO-CLÓNICA DE INICIO GENERALIZADO"
  },
  {
    "codigo":35726004,
    "descripcion":"ESGUINCE DE LIGAMENTO LATERAL EXTERNO DE RODILLA"
  },
  {
    "codigo":363406005,
    "descripcion":"NEOPLASIA MALIGNA DE COLON"
  },
  {
    "codigo":722019000,
    "descripcion":"SÍNDROME OCULOOTORRADIAL"
  },
  {
    "codigo":230499002,
    "descripcion":"INSUFICIENCIA RESPIRATORIA RELACIONADA CON EL SUEÑO"
  },
  {
    "codigo":263267003,
    "descripcion":"SÍNDROME COMPARTIMENTAL TIBIAL POSTERIOR DEBIDO A LESIÓN TRAUMÁTICA"
  },
  {
    "codigo":66659007,
    "descripcion":"VARIACIÓN NORMAL EN POSICIÓN"
  },
  {
    "codigo":458040001,
    "descripcion":"TORACÓPAGO CON CORAZONES Y SACOS PERICÁRDICOS SEPARADOS"
  },
  {
    "codigo":294200004,
    "descripcion":"ALERGIA A CROTAMITÓN"
  },
  {
    "codigo":195896004,
    "descripcion":"NEUMONÍA CAUSADA POR ORGANISMO TIPO PLEURONEUMONÍA"
  },
  {
    "codigo":359736007,
    "descripcion":"PERIONIXIS POR CANDIDA"
  },
  {
    "codigo":441011000124104,
    "descripcion":"INGESTA EXCESIVA DE MOLIBDENO"
  },
  {
    "codigo":1144333001,
    "descripcion":"ATROFIA DE NERVIO SAFENO EXTERNO"
  },
  {
    "codigo":95757001,
    "descripcion":"ECTROPIÓN DE PÁRPADO SUPERIOR"
  },
  {
    "codigo":680621000119102,
    "descripcion":"MEIBOMIANITIS DE PÁRPADO INFERIOR DERECHO"
  },
  {
    "codigo":716514001,
    "descripcion":"UTILIZA LA PRAGMÁTICA EN LA COMUNICACIÓN"
  },
  {
    "codigo":128525008,
    "descripcion":"TRASTORNO DEL CIEGO"
  },
  {
    "codigo":290530000,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR BUPIVACAÍNA"
  },
  {
    "codigo":224994002,
    "descripcion":"AUMENTO DE PESO EXCESIVO"
  },
  {
    "codigo":352941000119102,
    "descripcion":"IRIDOCICLITIS DEBIDA A SARCOIDOSIS"
  },
  {
    "codigo":28386007,
    "descripcion":"PERICARDITIS SECUNDARIA A NEOPLASIA"
  },
  {
    "codigo":126690007,
    "descripcion":"NEOPLASIA DE LA CARA HIPOFARÍNGEA DEL PLIEGUE INTERARITENOIDEO"
  },
  {
    "codigo":93922007,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL CUELLO"
  },
  {
    "codigo":288695000,
    "descripcion":"CAPAZ DE COMUNICARSE CON DIFERENTES PERSONAS"
  },
  {
    "codigo":92087008,
    "descripcion":"NEOPLASIA BENIGNA DEL EPICARDIO"
  },
  {
    "codigo":254092004,
    "descripcion":"DISPLASIA RENAL, DISTROFIA RETINIANA PIGMENTARIA, ATAXIA CEREBELOSA Y DISPLASIA ESQUELÉTICA"
  },
  {
    "codigo":1237132007,
    "descripcion":"VENA VARICOSA DE PIERNA DERECHA"
  },
  {
    "codigo":712844008,
    "descripcion":"ALERGIA A NUEZ DE MACADAMIA"
  },
  {
    "codigo":57484009,
    "descripcion":"SÍNDROME DE BEHCET, COMPLETO"
  },
  {
    "codigo":448865007,
    "descripcion":"LINFOMA NO HODGKIN FOLICULAR DE PIEL"
  },
  {
    "codigo":16546631000119102,
    "descripcion":"DISTENSIÓN DE TENDÓN ROTULIANO DERECHO"
  },
  {
    "codigo":285025009,
    "descripcion":"NO MANEJA UN ARTEFACTO MIENTRAS SE VISTE"
  },
  {
    "codigo":217654005,
    "descripcion":"ENVENENAMIENTO POR VENENO DE EQUIS OCCIDENTAL"
  },
  {
    "codigo":283190006,
    "descripcion":"ANZUELO EN CABEZA Y CUELLO"
  },
  {
    "codigo":1231627000,
    "descripcion":"DEBILIDAD DE TERCER PAR CRANEAL CON COMPROMISO DE PUPILA"
  },
  {
    "codigo":838411007,
    "descripcion":"DOLOR A LA PALPACIÓN EN REGIÓN ABDOMINAL"
  },
  {
    "codigo":248587009,
    "descripcion":"PROFUNDIDAD DE LA RESPIRACIÓN VARIABLE"
  },
  {
    "codigo":707339009,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE SENO MAXILAR"
  },
  {
    "codigo":246752002,
    "descripcion":"EXOFORIA INCOMITANTE"
  },
  {
    "codigo":408757002,
    "descripcion":"MIOPÍA AXIAL"
  },
  {
    "codigo":769205006,
    "descripcion":"NUEVA SUSTANCIA PSICOACTIVA POSITIVA EN ORINA"
  },
  {
    "codigo":310453007,
    "descripcion":"INFORME DE CONDUCTOR DISCAPACITADO SOLICITADO"
  },
  {
    "codigo":81077008,
    "descripcion":"ARTRITIS REUMÁTICA AGUDA"
  },
  {
    "codigo":212149009,
    "descripcion":"LESIÓN ABIERTA DE NERVIO ESPINAL"
  },
  {
    "codigo":275850001,
    "descripcion":"SÍNDROME DE HIPOSMOLALIDAD"
  },
  {
    "codigo":48309007,
    "descripcion":"PEDOFILIA, TIPO NO EXCLUSIVO"
  },
  {
    "codigo":13706005,
    "descripcion":"CONCRECIÓN CONJUNTIVAL"
  },
  {
    "codigo":110175001,
    "descripcion":"QUEMADURA EPIDÉRMICA DE REGIÓN PREAURICULAR DE LA CARA"
  },
  {
    "codigo":1287988000,
    "descripcion":"LUXACIÓN DE PRÓTESIS DE ARTICULACIÓN DE CADERA POSTERIOR A REEMPLAZO TOTAL DE CADERA"
  },
  {
    "codigo":208479008,
    "descripcion":"FRACTURA EXPUESTA DE FALANGE PROXIMAL DE DEDO DE LA MANO, DIÁFISIS"
  },
  {
    "codigo":403252006,
    "descripcion":"PIGMENTACIÓN BUCAL POR ENFERMEDAD DE ADDISON"
  },
  {
    "codigo":370484007,
    "descripcion":"EXPOSICIÓN DE LA PULPA DENTAL"
  },
  {
    "codigo":75572007,
    "descripcion":"POLIRRADICULOPATÍA"
  },
  {
    "codigo":683131000119100,
    "descripcion":"CONDROSARCOMA PRIMARIO DE COLUMNA VERTEBRAL"
  },
  {
    "codigo":40969002,
    "descripcion":"PULSO PERIFÉRICO NORMAL"
  },
  {
    "codigo":1255220008,
    "descripcion":"PERFORACIÓN DE APÉNDICE"
  },
  {
    "codigo":237577005,
    "descripcion":"SECRECIÓN ANORMAL DE SOMATOSTATINA"
  },
  {
    "codigo":202974002,
    "descripcion":"SUBLUXACIÓN DE TENDÓN PERONEO"
  },
  {
    "codigo":301278006,
    "descripcion":"FRÉMITO VOCAL DISMINUIDO"
  },
  {
    "codigo":39134007,
    "descripcion":"HEMATOMIELIA"
  },
  {
    "codigo":235742009,
    "descripcion":"RUPTURA DE INTESTINO DELGADO"
  },
  {
    "codigo":364979001,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA UTILIZAR EL TRÍPODE"
  },
  {
    "codigo":233907003,
    "descripcion":"TAQUICARDIA VENTRICULAR INDUCIDA"
  },
  {
    "codigo":201139004,
    "descripcion":"ALOPECIA CAQUÉCTICA"
  },
  {
    "codigo":10851061000119101,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR METANFETAMINA"
  },
  {
    "codigo":319221000119102,
    "descripcion":"LUXACIÓN RECURRENTE DE ARTICULACIÓN DE CODO IZQUIERDO"
  },
  {
    "codigo":1079541000119102,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE RIÑÓN DERECHO"
  },
  {
    "codigo":15935221000119102,
    "descripcion":"DEFORMIDAD EN FLEXIÓN DE DEDO DE LA MANO DERECHA"
  },
  {
    "codigo":11857141000119102,
    "descripcion":"HEMATOMA SUBUNGUEAL DE DEDO DE PIE IZQUIERDO"
  },
  {
    "codigo":102835006,
    "descripcion":"DIFICULTAD EN LA MICCIÓN"
  },
  {
    "codigo":142581000119107,
    "descripcion":"FRAGMENTO DE CUERPO EXTRAÑO METÁLICO MAGNÉTICO RETENIDO"
  },
  {
    "codigo":16467701000119102,
    "descripcion":"MELORREOSTOSIS DE HÚMERO DERECHO"
  },
  {
    "codigo":288501000119105,
    "descripcion":"DESAVENENCIA ENTRE PADRE E HIJO"
  },
  {
    "codigo":329461000119102,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DEBIDO A OCLUSIÓN DE ARTERIA CEREBELOSA IZQUIERDA POR ÉMBOLO"
  },
  {
    "codigo":12236021000119104,
    "descripcion":"DEFORMIDAD CONGÉNITA DE MIEMBRO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":428680008,
    "descripcion":"ANOMALÍA UROGENITAL FEMENINA CONGÉNITA"
  },
  {
    "codigo":29941000119105,
    "descripcion":"ATAXIA COMO SECUELA DE ENFERMEDAD CEREBROVASCULAR"
  },
  {
    "codigo":101621000119105,
    "descripcion":"NEUROMA POSQUIRÚRGICO DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":33629003,
    "descripcion":"DRUSAS DE PAPILA ÓPTICA"
  },
  {
    "codigo":230237004,
    "descripcion":"ATAXIA ESPINOCEREBELOSA PROGRESIVA CON REFLEJOS TENDINOSOS DISMINUIDOS"
  },
  {
    "codigo":1089781000119109,
    "descripcion":"MENINGITIS DEBIDA A ENFERMEDAD DE CHAGAS"
  },
  {
    "codigo":66397001,
    "descripcion":"APRAXIA SENSORIAL"
  },
  {
    "codigo":426845002,
    "descripcion":"BURSITIS DE DEDO DE LA MANO"
  },
  {
    "codigo":295773005,
    "descripcion":"SOBREDOSIS DE TRILOSTANO"
  },
  {
    "codigo":721757006,
    "descripcion":"INFECCIÓN CAUSADA POR ORIENTIA"
  },
  {
    "codigo":293938004,
    "descripcion":"ALERGIA A TIORIDAZINA"
  },
  {
    "codigo":228402009,
    "descripcion":"LIMPIA EL EQUIPO PARA INYECTAR DROGA"
  },
  {
    "codigo":423175003,
    "descripcion":"ARRITMIA SINUSAL NORMAL"
  },
  {
    "codigo":95495005,
    "descripcion":"DISPLASIA RETINIANA MULTIFOCAL"
  },
  {
    "codigo":93660000,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE NERVIO VESTIBULOCOCLEAR"
  },
  {
    "codigo":292103009,
    "descripcion":"REACCIÓN ADVERSA AL SUCRALFATO"
  },
  {
    "codigo":62727008,
    "descripcion":"ANGIOQUERATOMA DE MIBELLI"
  },
  {
    "codigo":124593001,
    "descripcion":"DEFICIENCIA DE PIRUVATO DESCARBOXILASA"
  },
  {
    "codigo":288433001,
    "descripcion":"NO UTILIZA PINZAS"
  },
  {
    "codigo":26289005,
    "descripcion":"FÍSTULA GASTROINTESTINAL EXTERNA DE BAJA PRODUCCIÓN"
  },
  {
    "codigo":1337009007,
    "descripcion":"FRACTURA EXPUESTA CONMINUTA DE RÓTULA"
  },
  {
    "codigo":714417009,
    "descripcion":"DIFICULTAD PARA ADMINISTRARSE MEDICACIÓN NO PARENTERAL"
  },
  {
    "codigo":712582008,
    "descripcion":"PSEUDOANEURISMA DE ARTERIA DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":284763003,
    "descripcion":"PELLIZCARSE"
  },
  {
    "codigo":251995003,
    "descripcion":"PRUEBA DE VEJIGA URINARIA - HALLAZGO"
  },
  {
    "codigo":699656000,
    "descripcion":"ALTERACIÓN DE GUSTO INDUCIDA POR RADIACIÓN"
  },
  {
    "codigo":282928004,
    "descripcion":"NO SE RECUESTA"
  },
  {
    "codigo":20784007,
    "descripcion":"LESIÓN TRAUMÁTICA DE ÓRGANOS ABDOMINALES CON HERIDA ABIERTA HACIA CAVIDAD"
  },
  {
    "codigo":248325000,
    "descripcion":"DESNUTRIDO"
  },
  {
    "codigo":250160007,
    "descripcion":"AJUSTE DEL CALZADO INADECUADO"
  },
  {
    "codigo":1264133002,
    "descripcion":"SALPINGITIS POSTERIOR A EMBARAZO ECTÓPICO"
  },
  {
    "codigo":281093002,
    "descripcion":"MIOCARDIO HIBERNANTE"
  },
  {
    "codigo":215557008,
    "descripcion":"LESIÓN TRAUMÁTICA PROVOCADA POR ACCIDENTE EN DEPORTES ACUÁTICOS CON COLISIÓN, TRABAJADOR PORTUARIO O ESTIBADOR LESIONADO"
  },
  {
    "codigo":49882001,
    "descripcion":"EXANTEMA VIRAL"
  },
  {
    "codigo":685641000119102,
    "descripcion":"LEIOMIOSARCOMA PRIMARIO DE REGIÓN INGUINAL"
  },
  {
    "codigo":836314009,
    "descripcion":"AGUDEZA VISUAL CORREGIDA DE OJO DERECHO 1\/60"
  },
  {
    "codigo":1260463008,
    "descripcion":"QUERATODERMIA PALMOPLANTAR NO EPIDERMOLÍTICA FOCAL AISLADA"
  },
  {
    "codigo":210052005,
    "descripcion":"LESIÓN CARDÍACA, NO EXPUESTA"
  },
  {
    "codigo":78980006,
    "descripcion":"FRACTURA EXPUESTA DEL EXTREMO INFERIOR DEL ANTEBRAZO"
  },
  {
    "codigo":109913001,
    "descripcion":"NEOPLASIA MENÍNGEA BENIGNA"
  },
  {
    "codigo":44377003,
    "descripcion":"INTOXICACIÓN POR OENANTHE"
  },
  {
    "codigo":402990000,
    "descripcion":"NOCARDIOSIS SISTÉMICA CON COMPROMISO CUTÁNEO"
  },
  {
    "codigo":697902002,
    "descripcion":"HIPERTENSIÓN DE ARTERIA PULMONAR ASOCIADA"
  },
  {
    "codigo":1254958006,
    "descripcion":"TEMBLOR DEBIDO A ABSTINENCIA DE SUSTANCIA"
  },
  {
    "codigo":302851001,
    "descripcion":"SARCOMA SINOVIAL"
  },
  {
    "codigo":827139005,
    "descripcion":"ÁNGULO KAPPA POSITIVO"
  },
  {
    "codigo":237315005,
    "descripcion":"MOLESTIA VAGINAL POSNATAL"
  },
  {
    "codigo":169944002,
    "descripcion":"LA MADRE TIENE UN TRABAJADOR SOCIAL"
  },
  {
    "codigo":331491000119106,
    "descripcion":"BLEFARITIS ULCEROSA DE PÁRPADO SUPERIOR DERECHO"
  },
  {
    "codigo":366552006,
    "descripcion":"HALLAZGO RELACIONADO CON EL TAMAÑO DE DEDO DE LA MANO"
  },
  {
    "codigo":102573001,
    "descripcion":"EDEMA DE MUSLO"
  },
  {
    "codigo":200877003,
    "descripcion":"DERMATITIS DE CONTACTO CAUSADA POR CONSERVANTES"
  },
  {
    "codigo":364717003,
    "descripcion":"PERFIL FACIAL - HALLAZGO"
  },
  {
    "codigo":397485004,
    "descripcion":"TUMOR ENDOCRINO PANCREÁTICO FUNCIONAL"
  },
  {
    "codigo":4269005,
    "descripcion":"ÚLCERA GASTROYEYUNAL CRÓNICA SIN HEMORRAGIA Y SIN PERFORACIÓN"
  },
  {
    "codigo":168109006,
    "descripcion":"ALFA-FETOPROTEÍNA EN LÍQUIDO AMNIÓTICO FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":233645004,
    "descripcion":"NEUMOTÓRAX A TENSIÓN"
  },
  {
    "codigo":725165009,
    "descripcion":"OMODISPLASIA AUTOSÓMICA DOMINANTE"
  },
  {
    "codigo":428418001,
    "descripcion":"ONDAS T ALTERNANTES EN EL ELECTROCARDIOGRAMA"
  },
  {
    "codigo":299181008,
    "descripcion":"AMPLITUD DE ADUCCIÓN PASIVA DEL PULGAR DISMINUIDA"
  },
  {
    "codigo":788866004,
    "descripcion":"ANSIEDAD DEBIDA A DEMENCIA"
  },
  {
    "codigo":15951741000119103,
    "descripcion":"NEOPLASIA BENIGNA DE PIEL DE AMBAS EXTREMIDADES INFERIORES"
  },
  {
    "codigo":10735331000119108,
    "descripcion":"DISPLASIA MAMARIA BENIGNA DE MAMA DERECHA"
  },
  {
    "codigo":231810000,
    "descripcion":"PTOSIS APONEURÓTICO"
  },
  {
    "codigo":721495002,
    "descripcion":"FRACTURA DE SEGUNDA VÉRTEBRA LUMBAR"
  },
  {
    "codigo":262743004,
    "descripcion":"LESIÓN POR TRACCIÓN DE LA RAÍZ DE NERVIO SACRO"
  },
  {
    "codigo":787031004,
    "descripcion":"CUERPO EXTRAÑO RETENIDO EN REGIÓN DEL HOMBRO"
  },
  {
    "codigo":599006,
    "descripcion":"NEUMOTÓRAX CRÓNICO"
  },
  {
    "codigo":129836000,
    "descripcion":"INCUMPLIMIENTO DEL RÉGIMEN TERAPÉUTICO"
  },
  {
    "codigo":228140002,
    "descripcion":"FRACASO PARA MANTENER EL NIVEL ACADÉMICO PREVIO"
  },
  {
    "codigo":10682391000119100,
    "descripcion":"TUMORACIÓN DEL TEJIDO CELULAR SUBCUTÁNEO DEL PIE IZQUIERDO"
  },
  {
    "codigo":293676007,
    "descripcion":"ALERGIA A ANTAGONISTA DE RECEPTOR DE 5-HIDROXITRIPTAMINA-3"
  },
  {
    "codigo":64300006,
    "descripcion":"DIETA RESTRINGIDA EN OXALATO"
  },
  {
    "codigo":16007191000119100,
    "descripcion":"GANGRENA DE DEDO DE AMBAS MANOS"
  },
  {
    "codigo":62465000,
    "descripcion":"ÚLCERA DE ESÓFAGO DEBIDA A INGESTIÓN DE SUSTANCIA QUÍMICA"
  },
  {
    "codigo":95233002,
    "descripcion":"URÉTER RETROCAVO"
  },
  {
    "codigo":719660008,
    "descripcion":"SÍNDROME DE MICRODELECIÓN 4Q21"
  },
  {
    "codigo":422913006,
    "descripcion":"FUNCIÓN PARENTAL NEGLIGENTE"
  },
  {
    "codigo":1078273008,
    "descripcion":"AGENESIA DE FALANGE DISTAL DE TERCER DEDO DE PIE"
  },
  {
    "codigo":816129009,
    "descripcion":"COLOR DE MUESTRA DE SANGRE NORMAL"
  },
  {
    "codigo":717825008,
    "descripcion":"NEUROPATÍA HEREDITARIA SENSITIVA Y AUTONÓMICA TIPO 1B"
  },
  {
    "codigo":715990006,
    "descripcion":"SÍNDROME DE AGENESIA DE CEREBELO E HIDROCEFALIA"
  },
  {
    "codigo":58795000,
    "descripcion":"DISTROFIA MUSCULAR DISTAL"
  },
  {
    "codigo":93398009,
    "descripcion":"ENGROSAMIENTO CONGÉNITO DE FÉMUR"
  },
  {
    "codigo":124331002,
    "descripcion":"DEFICIENCIA DE PIRUVATO CINASA"
  },
  {
    "codigo":224470008,
    "descripcion":"TIENE PERSPECTIVAS DE PROMOCIÓN"
  },
  {
    "codigo":114711000119105,
    "descripcion":"INFECCIÓN DEBIDA A DIÁLISIS PERITONEAL Y POSTERIOR A ELLA"
  },
  {
    "codigo":1303979009,
    "descripcion":"DESPLAZAMIENTO DE PLACA DE OJO DERECHO DEBIDO A CIRUGÍA DE DRENAJE DE GLAUCOMA Y POSTERIOR A ELLA"
  },
  {
    "codigo":384640002,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA DISTAL NO AFECTADO POR CARCINOMA IN SITU\/ADENOMA"
  },
  {
    "codigo":286336003,
    "descripcion":"DIFICULTAD PARA PRODUCIR UN TONO ADECUADO"
  },
  {
    "codigo":1269376006,
    "descripcion":"LESIÓN ANTERIOR DE MÉDULA ESPINAL DORSAL DEBIDA A SUBLUXACIÓN NO EXPUESTA DE ARTICULACIÓN DE COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":284501001,
    "descripcion":"CONDUCTA DEFICITARIA"
  },
  {
    "codigo":251733002,
    "descripcion":"ANOMALÍA LOCAL DEL ÁNGULO"
  },
  {
    "codigo":253568009,
    "descripcion":"DEFECTO SEPTAL CON COMPROMISO DOBLE SUBARTERIAL VENTRICULAR"
  },
  {
    "codigo":1234773008,
    "descripcion":"AGRESIÓN CAUSADA POR ETANOL"
  },
  {
    "codigo":282666004,
    "descripcion":"INCAPAZ DE LANZAR"
  },
  {
    "codigo":315434004,
    "descripcion":"NACIDO EN GRANADA"
  },
  {
    "codigo":249898006,
    "descripcion":"ENLENTECIMIENTO DE LAS PIERNAS"
  },
  {
    "codigo":86058007,
    "descripcion":"TRASTORNO BIPOLAR I GRAVE, UN SOLO EPISODIO MANÍACO CON SÍNTOMAS PSICÓTICOS, INCONGRUENTE CON EL ESTADO DE ÁNIMO"
  },
  {
    "codigo":280831005,
    "descripcion":"REMANENTE EMBRIOLÓGICO ARTERIAL"
  },
  {
    "codigo":293043009,
    "descripcion":"REACCIÓN ADVERSA A LA MAFENIDA"
  },
  {
    "codigo":18687009,
    "descripcion":"CARDIOPATÍA REUMÁTICA DE VÁLVULA PULMONAR"
  },
  {
    "codigo":735913001,
    "descripcion":"DESTRUCCIÓN DE ARTICULACIÓN CAUSADA POR HEMIARTROPLASTIA"
  },
  {
    "codigo":15734961000119107,
    "descripcion":"PSEUDOQUISTE DE RETINA DE AMBOS OJOS"
  },
  {
    "codigo":441001005,
    "descripcion":"ELEVACIÓN HEREDITARIA DE FACTOR IX"
  },
  {
    "codigo":334001000119108,
    "descripcion":"COROIDITIS FOCAL MACULAR DERECHA"
  },
  {
    "codigo":275326005,
    "descripcion":"DESGARRO EN ASA DE BALDE DE MENISCO EXTERNO DE LA RODILLA"
  },
  {
    "codigo":207955000,
    "descripcion":"FRACTURA EXPUESTA DE VÉRTEBRA DORSAL, ARCO POSTERIOR"
  },
  {
    "codigo":734078009,
    "descripcion":"ADENOMA DE OÍDO MEDIO"
  },
  {
    "codigo":699475004,
    "descripcion":"CURVA DE WILSON APLANADA"
  },
  {
    "codigo":240723005,
    "descripcion":"CANDIDIASIS DISEMINADA CRÓNICA"
  },
  {
    "codigo":273491005,
    "descripcion":"ENFERMEDAD POR DEFICIENCIA DE PROTEÍNAS"
  },
  {
    "codigo":44115007,
    "descripcion":"MACULOPATÍA TÓXICA"
  },
  {
    "codigo":271656000,
    "descripcion":"HALLAZGO RELACIONADO CON UN FRÉMITO CARDÍACO"
  },
  {
    "codigo":1156392002,
    "descripcion":"FRACTURA DE CUERNO SUPERIOR DEL CARTÍLAGO TIROIDES"
  },
  {
    "codigo":16910821000119100,
    "descripcion":"NEVO MELANOCÍTICO CONGÉNITO DE PIEL DE PÁRPADO INFERIOR DERECHO"
  },
  {
    "codigo":238888007,
    "descripcion":"NECROSIS GRASA"
  },
  {
    "codigo":402728007,
    "descripcion":"CAMBIOS CUTÁNEOS POR DESNUTRICIÓN"
  },
  {
    "codigo":105981003,
    "descripcion":"TRASTORNO DE LA FUNCIÓN CARDÍACA"
  },
  {
    "codigo":204285005,
    "descripcion":"AUSENCIA CONGÉNITA DE MENTÓN"
  },
  {
    "codigo":40445007,
    "descripcion":"INSUFICIENCIA DE VÁLVULA CARDÍACA"
  },
  {
    "codigo":366290004,
    "descripcion":"HALLAZGO RELACIONADO CON LA HABILIDAD PARA CONSEGUIR UNA ERECCIÓN"
  },
  {
    "codigo":12104011000119109,
    "descripcion":"QUEMADURA DE REGIÓN DE RODILLA DERECHA"
  },
  {
    "codigo":300754006,
    "descripcion":"DIFICULTAD PARA REALIZAR ACTIVIDADES DE JARDINERÍA"
  },
  {
    "codigo":167847000,
    "descripcion":"PH DE VÓMITO MÁS ALCALINO QUE RANGO DE REFERENCIA"
  },
  {
    "codigo":5842009,
    "descripcion":"DISPLASIA DE LA MÉDULA ESPINAL"
  },
  {
    "codigo":724903006,
    "descripcion":"LACERACIÓN DE FASCIA PÉLVICA"
  },
  {
    "codigo":298919006,
    "descripcion":"AMPLITUD DE PRONACIÓN PASIVA DE CODO NORMAL"
  },
  {
    "codigo":36775008,
    "descripcion":"ORIFICIO URETERAL DESPLAZADO"
  },
  {
    "codigo":67708007,
    "descripcion":"NECROSPERMIA"
  },
  {
    "codigo":297084008,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE DIPIRIDAMOL"
  },
  {
    "codigo":164177002,
    "descripcion":"EVALUACIÓN OTORRINOLARINGOLÓGICA - NO SE DETECTARON ANOMALÍAS"
  },
  {
    "codigo":1073791000119101,
    "descripcion":"ARTRITIS REUMATOIDE DE MANO DERECHA"
  },
  {
    "codigo":721233005,
    "descripcion":"SÍNDROME DE HIPOGONADISMO HIPERGONADOTRÓFICO CON CATARATAS"
  },
  {
    "codigo":129574000,
    "descripcion":"INFARTO DE MIOCARDIO POSQUIRÚRGICO"
  },
  {
    "codigo":719398004,
    "descripcion":"SÍNDROME DE HIPERTERMIA MALIGNA CON ARTROGRIPOSIS Y TORTÍCOLIS"
  },
  {
    "codigo":424486004,
    "descripcion":"CARCINOMA DE OVARIO, ESTADIO 2"
  },
  {
    "codigo":293414006,
    "descripcion":"REACCIÓN ADVERSA AL FLÚOR"
  },
  {
    "codigo":1145382006,
    "descripcion":"APLASIA DE EXTREMIDAD"
  },
  {
    "codigo":783099001,
    "descripcion":"SÍNDROME DE RADIOSENSIBILIDAD, INMUNODEFICIENCIA, CARACTERÍSTICAS DISMÓRFICAS Y DIFICULTADES DEL APRENDIZAJE"
  },
  {
    "codigo":160507001,
    "descripcion":"NIÑO ABANDONADO"
  },
  {
    "codigo":422651008,
    "descripcion":"ACCESO LIMITADO A SERVICIOS DE APOYO COMUNITARIO"
  },
  {
    "codigo":94971009,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL NERVIO ÓPTICO"
  },
  {
    "codigo":289744002,
    "descripcion":"RETRACCIÓN LEVE DEL SEGMENTO SUPERIOR"
  },
  {
    "codigo":224208004,
    "descripcion":"ASUNTOS ECONÓMICOS MANEJADOS POR UN TERCERO"
  },
  {
    "codigo":15983231000119107,
    "descripcion":"MALFORMACIÓN CONGÉNITA DE AMBOS OÍDOS EXTERNOS"
  },
  {
    "codigo":25765006,
    "descripcion":"IMINOGLICINURIA NEONATAL"
  },
  {
    "codigo":286074000,
    "descripcion":"AIREA LA ROPA LAVADA"
  },
  {
    "codigo":90751000119109,
    "descripcion":"ESTADIO 4 DE ENFERMEDAD RENAL CRÓNICA DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":253306009,
    "descripcion":"ANOMALÍA DE LA VENA CAVA SUPERIOR"
  },
  {
    "codigo":22095002,
    "descripcion":"LESIÓN TRAUMÁTICA DE GLÁNDULA SUPRARRENAL SIN HERIDA ABIERTA HACIA CAVIDAD ABDOMINAL"
  },
  {
    "codigo":448079003,
    "descripcion":"ANILLO VASCULAR CON CAYADO AÓRTICO DERECHO Y CONDUCTO ARTERIOSO DERECHO PERMEABLE CON ARTERIA PULMONAR IZQUIERDA AUSENTE"
  },
  {
    "codigo":251471009,
    "descripcion":"TRAZADO ELECTROENCEFALOGRÁFICO DE BAJA AMPLITUD"
  },
  {
    "codigo":1003300004,
    "descripcion":"CLINODACTILIA CONGÉNITA DE DEDO GORDO"
  },
  {
    "codigo":247801000,
    "descripcion":"DEPRESIÓN QUE EMPEORA DURANTE LA MAÑANA"
  },
  {
    "codigo":870393001,
    "descripcion":"DISTENSIÓN DE TENDÓN DE PIE"
  },
  {
    "codigo":1263609003,
    "descripcion":"TRASTORNO NEONATAL PRECOZ DEBIDO A TRABAJO DE PARTO PROLONGADO"
  },
  {
    "codigo":18425006,
    "descripcion":"DEPOSICIÓN DE HECES EN AGUA DE ARROZ"
  },
  {
    "codigo":82126001,
    "descripcion":"PERIOSTITIS TRAUMÁTICA OSIFICANTE"
  },
  {
    "codigo":11778841000119109,
    "descripcion":"RUPTURA TRAUMÁTICA DE TENDÓN DE LA CABEZA LARGA DE BÍCEPS BRAQUIAL IZQUIERDO"
  },
  {
    "codigo":213198007,
    "descripcion":"RUPTURA DE REPARACIÓN DE VASO SANGUÍNEO"
  },
  {
    "codigo":98001000146104,
    "descripcion":"PORTADOR DE PSEUDOMONAS AERUGINOSA RESISTENTE A MÚLTIPLES FÁRMACOS"
  },
  {
    "codigo":26321000146104,
    "descripcion":"CAPAZ DE MOSTRAR EMPATÍA"
  },
  {
    "codigo":1163470008,
    "descripcion":"MENINGITIS POR ARENAVIRUS"
  },
  {
    "codigo":1360078008,
    "descripcion":"ÁNGULO ABIERTO AMPLIO BILATERAL"
  },
  {
    "codigo":735651004,
    "descripcion":"AVULSIÓN TRAUMÁTICA DE AMBOS OJOS"
  },
  {
    "codigo":47523006,
    "descripcion":"ENCEFALITIS EQUINA OCCIDENTAL"
  },
  {
    "codigo":1290872000,
    "descripcion":"OSTEOSARCOMA CENTRAL DE BAJO GRADO"
  },
  {
    "codigo":14755009,
    "descripcion":"QUERATINIZACIÓN NORMAL"
  },
  {
    "codigo":111224002,
    "descripcion":"ALTERACIÓN DE MENISCO DE ARTICULACIÓN DE LA RODILLA"
  },
  {
    "codigo":78456001,
    "descripcion":"CICLO MENSTRUAL NORMAL"
  },
  {
    "codigo":12920002,
    "descripcion":"DERMATITIS PERIVASCULAR SUPERFICIAL"
  },
  {
    "codigo":1076301000119100,
    "descripcion":"BURSITIS DE ILIOPSOAS EN LA CADERA DERECHA"
  },
  {
    "codigo":733816007,
    "descripcion":"CONDUCTA INTROVERTIDA DISMINUIDA"
  },
  {
    "codigo":76621000,
    "descripcion":"MASTOCITOSIS CUTÁNEA, FORMA INFANTIL"
  },
  {
    "codigo":897656009,
    "descripcion":"RINOSINUSITIS"
  },
  {
    "codigo":699213001,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN DE DORSO DE PIE"
  },
  {
    "codigo":109389001,
    "descripcion":"SARCOMA DE KAPOSI DEL TRACTO GASTROINTESTINAL"
  },
  {
    "codigo":45688009,
    "descripcion":"PARS PLANITIS"
  },
  {
    "codigo":240461007,
    "descripcion":"RABIA EN INCUBACIÓN"
  },
  {
    "codigo":830285008,
    "descripcion":"FLUCTUACIÓN DEL NIVEL DE CONCIENCIA"
  },
  {
    "codigo":9250002,
    "descripcion":"SÍNDROME DE COMPRESIÓN DE LA ARTERIA CELÍACA"
  },
  {
    "codigo":369698003,
    "descripcion":"MARGEN LATERAL DERECHO DE RESECCIÓN QUIRÚRGICA DE RECTO, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":339021000119103,
    "descripcion":"PERIOSTITIS ORBITARIA IZQUIERDA"
  },
  {
    "codigo":402466006,
    "descripcion":"MIXEDEMA PRETIBIAL DIFUSO"
  },
  {
    "codigo":238626006,
    "descripcion":"QUERATOSIS PILAR DECALVANS"
  },
  {
    "codigo":762914007,
    "descripcion":"HIPOPLASIA DE RIÑÓN DERECHO"
  },
  {
    "codigo":7415003,
    "descripcion":"ABSCESO DE OVARIO"
  },
  {
    "codigo":105719004,
    "descripcion":"DISCAPACIDAD FÍSICA Y\/O ESTADO DE INSUFICIENCIA"
  },
  {
    "codigo":72951007,
    "descripcion":"GASTROSQUISIS"
  },
  {
    "codigo":1187063009,
    "descripcion":"CALCIO EN ORINA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":236791009,
    "descripcion":"INFERTILIDAD MASCULINA DE ORIGEN CROMOSÓMICO"
  },
  {
    "codigo":398796005,
    "descripcion":"HIPERLIPOPROTEINEMIA FAMILIAR DE TIPO 3"
  },
  {
    "codigo":726476005,
    "descripcion":"LIQUEN PLANO CONCOMITANTE CON ONICÓLISIS"
  },
  {
    "codigo":300492006,
    "descripcion":"LESIÓN DE TESTÍCULO"
  },
  {
    "codigo":366028008,
    "descripcion":"HALLAZGO RELACIONADO CON MOVIMIENTO DE LA PUPILA"
  },
  {
    "codigo":1052321001,
    "descripcion":"SÍFILIS SECUNDARIA DEL APARATO DIGESTIVO"
  },
  {
    "codigo":16041191000119100,
    "descripcion":"ARTRITIS IDIOPÁTICA JUVENIL DE INICIO SISTÉMICO DE ARTICULACIÓN DE AMBAS REGIONES DE HOMBRO"
  },
  {
    "codigo":42691000087108,
    "descripcion":"DISCO INTERVERTEBRAL CERVICAL PROLAPSADO, C7-T1"
  },
  {
    "codigo":69281008,
    "descripcion":"HEMOSIDEROSIS TRANSFUSIONAL"
  },
  {
    "codigo":216243000,
    "descripcion":"INTOXICACIÓN POR MONÓXIDO DE CARBONO DE AERONAVE EN TRÁNSITO, SIN ACCIDENTE DE AERONAVE, PERSONAL DE TIERRA O EMPLEADO DE AEROLÍNEA LESIONADO"
  },
  {
    "codigo":788342003,
    "descripcion":"HUEVO DE HETEROPHYES HETEROPHYES O HUEVO DE METAGONIMUS YOKOGAWAI"
  },
  {
    "codigo":1148790008,
    "descripcion":"FUNCIÓN DEL APARATO DIGESTIVO NORMAL"
  },
  {
    "codigo":424224001,
    "descripcion":"DEFICIENCIA DE ENZIMA DEL CITOCROMO P450"
  },
  {
    "codigo":293152003,
    "descripcion":"REACCIÓN ADVERSA A LA FLUORCOTOLONA"
  },
  {
    "codigo":719136005,
    "descripcion":"SÍNDROME DE DISCAPACIDAD INTELECTUAL LIGADA AL CROMOSOMA X CON HIPOPLASIA CEREBELOSA"
  },
  {
    "codigo":15687041000119100,
    "descripcion":"SINOVITIS ARTICULAR DE RODILLA BILATERAL"
  },
  {
    "codigo":94709001,
    "descripcion":"MICOSIS FUNGOIDE DE GANGLIOS LINFÁTICOS INTRATORÁCICOS"
  },
  {
    "codigo":291317005,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR ADRENALINA"
  },
  {
    "codigo":1208821006,
    "descripcion":"FRACTURA DE CABLE DE SENO CORONARIO DE DESFIBRILADOR CARDIOVERSOR IMPLANTABLE"
  },
  {
    "codigo":92874001,
    "descripcion":"FUSIÓN ANORMAL CONGÉNITA DEL RADIO"
  },
  {
    "codigo":420554003,
    "descripcion":"LEUCOENCEFALOPATÍA MULTIFOCAL PROGRESIVA ASOCIADA CON SIDA"
  },
  {
    "codigo":60106004,
    "descripcion":"TRONCO ARTERIAL COMÚN Y ORIGEN SEPARADO DE ARTERIAS PULMONARES"
  },
  {
    "codigo":289482006,
    "descripcion":"ERUPCIÓN DE VULVA"
  },
  {
    "codigo":125642006,
    "descripcion":"LESIÓN TRAUMÁTICA DE CONDUCTO DEFERENTE"
  },
  {
    "codigo":91039000,
    "descripcion":"GRANULOMA CUTÁNEO POR BERILIO"
  },
  {
    "codigo":58271001,
    "descripcion":"QUISTE ODONTÓGENO GINGIVAL"
  },
  {
    "codigo":254879003,
    "descripcion":"SEUDOFIBROMA DE LIGAMENTO ANCHO"
  },
  {
    "codigo":25503004,
    "descripcion":"NEUMOPIOPERICARDIO"
  },
  {
    "codigo":1336223005,
    "descripcion":"TRASTORNO DEBIDO A RADIOTERAPIA"
  },
  {
    "codigo":1303455003,
    "descripcion":"GLAUCOMA DE ÁNGULO ABIERTO DE OJO IZQUIERDO DEBIDO A TRASTORNO VASCULAR OCULAR"
  },
  {
    "codigo":123807007,
    "descripcion":"TRASTORNO DEL SODIO"
  },
  {
    "codigo":1332553002,
    "descripcion":"ARTRITIS ESTAFILOCÓCICA DE CADERA DERECHA"
  },
  {
    "codigo":11892251000119102,
    "descripcion":"QUERATITIS ULCERATIVA PERIFÉRICA BILATERAL"
  },
  {
    "codigo":447817009,
    "descripcion":"OBSTRUCCIÓN DEL CAYADO AÓRTICO"
  },
  {
    "codigo":19998002,
    "descripcion":"DETENCIÓN DE LA MADURACIÓN MEGACARIOCÍTICA"
  },
  {
    "codigo":251209009,
    "descripcion":"SEGMENTO ST ACORTADO"
  },
  {
    "codigo":708126004,
    "descripcion":"CANDIDIASIS RECURRENTE DE VAGINA"
  },
  {
    "codigo":413214004,
    "descripcion":"NEOPLASIA DE SUBMUCOSA DE INTESTINO"
  },
  {
    "codigo":249374006,
    "descripcion":"SENO FRONTAL EXTENDIDO"
  },
  {
    "codigo":773662009,
    "descripcion":"ENFERMEDAD INFLAMATORIA NEONATAL INTESTINAL Y CUTÁNEA"
  },
  {
    "codigo":247539002,
    "descripcion":"TAPÓN FOLICULAR"
  },
  {
    "codigo":83699005,
    "descripcion":"REACCIÓN DE HIPERSENSIBILIDAD MEDIADA POR COMPLEJO INMUNE"
  },
  {
    "codigo":16328001,
    "descripcion":"DIFERENCIAS VENTILATORIAS REGIONALES POR ESTRÉS DESIGUAL"
  },
  {
    "codigo":737224006,
    "descripcion":"NEOPLASIA HISTIOCÍTICA"
  },
  {
    "codigo":243869000,
    "descripcion":"SITUACIÓN DEL MONITOREO DE TRASTORNO URINARIO"
  },
  {
    "codigo":735389001,
    "descripcion":"RESORCIÓN DE VÉRTICE DE RAÍZ DE DIENTE POSTERIOR A LESIÓN TRAUMÁTICA"
  },
  {
    "codigo":49096008,
    "descripcion":"SÍNDROME DE DUHAMEL"
  },
  {
    "codigo":14493003,
    "descripcion":"SÍNDROME MEDULAR ANTERIOR DEBIDO A FRACTURA NO EXPUESTA A NIVEL DE T1-T6"
  },
  {
    "codigo":473245003,
    "descripcion":"QUEMADURA DE REGIÓN OCULAR CON QUEMADURA DE SEGUNDO GRADO DE CARA"
  },
  {
    "codigo":704456009,
    "descripcion":"FRACTURA METAFISARIA EXPUESTA DE SEGUNDO METATARSIANO"
  },
  {
    "codigo":373106001,
    "descripcion":"PACIENTE CON MARCAPASOS"
  },
  {
    "codigo":276637009,
    "descripcion":"EDEMA PULMONAR HEMORRÁGICO"
  },
  {
    "codigo":1259677009,
    "descripcion":"DEMENCIA DEBIDA A ATROFIA SISTÉMICA MÚLTIPLE"
  },
  {
    "codigo":13851000119109,
    "descripcion":"ASIMETRÍA FACIAL CONGÉNITA"
  },
  {
    "codigo":315061000119103,
    "descripcion":"OSTEÍTIS DEFORMANTE DE HÚMERO IZQUIERDO"
  },
  {
    "codigo":209266005,
    "descripcion":"FRACTURA-LUXACIÓN NO EXPUESTA DE ARTICULACIÓN RADIOCARPIANA"
  },
  {
    "codigo":405874006,
    "descripcion":"FENOTIPO LU(B-)"
  },
  {
    "codigo":698951002,
    "descripcion":"TRASTORNO DELIRANTE EN REMISIÓN"
  },
  {
    "codigo":43591003,
    "descripcion":"ENFERMEDAD INFECCIOSA EXANTEMATOSA"
  },
  {
    "codigo":764487004,
    "descripcion":"GINGIVITIS DESCAMATIVA CRÓNICA"
  },
  {
    "codigo":404039004,
    "descripcion":"TUMOR MELANÓTICO MALIGNO DE VAINA DE NERVIO PERIFÉRICO"
  },
  {
    "codigo":830023006,
    "descripcion":"QUISTE DERMOIDE DE CÓRNEA"
  },
  {
    "codigo":305735009,
    "descripcion":"ATENDIDO POR ENFERMERA DE REHABILITACIÓN CARDÍACA"
  },
  {
    "codigo":860956003,
    "descripcion":"ALERGIA A LEVADURA"
  },
  {
    "codigo":271132003,
    "descripcion":"AMPOLLA TRAUMÁTICA DE LA REGIÓN INTERESCAPULAR, INFECTADA"
  },
  {
    "codigo":74524003,
    "descripcion":"INTOXICACIÓN CAUSADA POR QUININA"
  },
  {
    "codigo":762652006,
    "descripcion":"OCLUSIÓN DE ARTERIA CEREBRAL POSTERIOR IZQUIERDA POR ÉMBOLO"
  },
  {
    "codigo":16836431000119100,
    "descripcion":"EMBARAZO TUBARIO ROTO DE TROMPA DE FALOPIO DERECHA"
  },
  {
    "codigo":302065000,
    "descripcion":"GLÁNDULA TIROIDES - HALLAZGO"
  },
  {
    "codigo":236529001,
    "descripcion":"SÍNDROME DE VIENTRE EN CIRUELA PASA CON ESTENOSIS PULMONAR, DISCAPACIDAD INTELECTUAL Y SORDERA"
  },
  {
    "codigo":402204009,
    "descripcion":"ECCEMA SEBORREICO CRÓNICO"
  },
  {
    "codigo":726214001,
    "descripcion":"LESIÓN TRAUMÁTICA DE BOLSA SEROSA DE CADERA"
  },
  {
    "codigo":5318001,
    "descripcion":"CATARATA SENIL POLAR SUBCAPSULAR POSTERIOR"
  },
  {
    "codigo":38086007,
    "descripcion":"LARINGOMALACIA"
  },
  {
    "codigo":3483000,
    "descripcion":"ÚLCERA PÉPTICA CRÓNICA CON PERFORACIÓN"
  },
  {
    "codigo":167323003,
    "descripcion":"UROBILINÓGENO EN ORINA NEGATIVO"
  },
  {
    "codigo":1648002,
    "descripcion":"SEUDOTUMOR LINFOCÍTICO PULMONAR"
  },
  {
    "codigo":722544004,
    "descripcion":"PANCREATITIS DEBIDA A OBSTRUCCIÓN DE CONDUCTO PANCREÁTICO"
  },
  {
    "codigo":165488008,
    "descripcion":"ERITROCITOS - MEGALOBLASTOS"
  },
  {
    "codigo":11839311000119108,
    "descripcion":"DISTENSIÓN DE TENDÓN DE LA MANO DERECHA"
  },
  {
    "codigo":784410003,
    "descripcion":"HEMORRAGIA DE CUERDAS VOCALES"
  },
  {
    "codigo":63514004,
    "descripcion":"REINERVACIÓN"
  },
  {
    "codigo":292890004,
    "descripcion":"REACCIÓN ADVERSA A DESINFECTANTE A BASE DE BIGUANIDA"
  },
  {
    "codigo":30746006,
    "descripcion":"LINFADENOPATÍA"
  },
  {
    "codigo":1144858003,
    "descripcion":"HIPOPLASIA CONGÉNITA DE PIEL"
  },
  {
    "codigo":161818003,
    "descripcion":"IRRITACIÓN VULVAR"
  },
  {
    "codigo":127215001,
    "descripcion":"CENTROS GERMINALES DE TRANSFORMACIÓN PROGRESIVA"
  },
  {
    "codigo":422127002,
    "descripcion":"HERPES ZÓSTER ASOCIADO CON SIDA"
  },
  {
    "codigo":28911003,
    "descripcion":"PLACENTA ADHESIVA"
  },
  {
    "codigo":782575000,
    "descripcion":"ALERGIA A SEMILLA DE LUPÍN"
  },
  {
    "codigo":291055005,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR BROMAZEPAM"
  },
  {
    "codigo":129050009,
    "descripcion":"CAPACIDAD PARA LEVANTARSE DE LA CAMA SIN AYUDA"
  },
  {
    "codigo":94447007,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE HUESO OCCIPITAL"
  },
  {
    "codigo":225519009,
    "descripcion":"DISFRUTA DEL SEXO"
  },
  {
    "codigo":289220003,
    "descripcion":"BUEN PROGRESO EN LA SEGUNDA ETAPA DEL TRABAJO DE PARTO"
  },
  {
    "codigo":92612007,
    "descripcion":"CARCINOMA IN SITU DE LA HIPOFARINGE"
  },
  {
    "codigo":1303193001,
    "descripcion":"INFECCIÓN DE HUESO DE PIE ASOCIADA CON DISPOSITIVO DE FIJACIÓN INTERNA"
  },
  {
    "codigo":15636611000119102,
    "descripcion":"DISFUNCIÓN SOMÁTICA DE AMBAS ARTICULACIONES SACROILÍACAS"
  },
  {
    "codigo":285550001,
    "descripcion":"ELEVA EL PALADAR BLANDO"
  },
  {
    "codigo":1137518003,
    "descripcion":"DEBILIDAD DE MÚSCULO ORBICULAR DE OJO"
  },
  {
    "codigo":88942003,
    "descripcion":"GRUPO SANGUÍNEO A>2<B"
  },
  {
    "codigo":416622005,
    "descripcion":"COMPRESIÓN PÚBICA"
  },
  {
    "codigo":23406007,
    "descripcion":"FRACTURA DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":185411003,
    "descripcion":"CITA SOLICITADA POR LA MADRE"
  },
  {
    "codigo":283715005,
    "descripcion":"MORDEDURA HUMANA EN LA REGIÓN PÉLVICA"
  },
  {
    "codigo":21571006,
    "descripcion":"GLAUCOMA SECUNDARIO DE CIERRE DE ÁNGULO"
  },
  {
    "codigo":447555007,
    "descripcion":"VIVE CON ESPOSA"
  },
  {
    "codigo":314648000,
    "descripcion":"PERÍMETRO CEFÁLICO DEL NIÑO: PERCENTILO 9"
  },
  {
    "codigo":1363224000,
    "descripcion":"CICATRIZACIÓN DE AMBOS PÁRPADOS INFERIORES"
  },
  {
    "codigo":249112006,
    "descripcion":"CABEZA ENCAJADA"
  },
  {
    "codigo":127261000119100,
    "descripcion":"CHOQUE SÉPTICO CONCOMITANTE CON DISFUNCIÓN ORGÁNICA AGUDA CAUSADO POR PNEUMOCOCCUS"
  },
  {
    "codigo":609560006,
    "descripcion":"PERCEPCIÓN A DISTANCIA DE SENSACIÓN TÁCTIL"
  },
  {
    "codigo":773400009,
    "descripcion":"SÍNDROME DE DIFICULTADES ALIMENTARIAS SEVERAS, FALTA DE PROGRESO Y MICROCEFALIA POR DEFICIENCIA DE ASXL3"
  },
  {
    "codigo":17901006,
    "descripcion":"HIPEROXALURIA PRIMARIA"
  },
  {
    "codigo":247277007,
    "descripcion":"ESTRIBO - HALLAZGO"
  },
  {
    "codigo":214509007,
    "descripcion":"ACCIDENTE DE TRÁNSITO VEHICULAR DE TIPO NO COLISIÓN CON INTOXICACIÓN ACCIDENTAL POR GASES DE ESCAPE GENERADOS POR EL VEHÍCULO EN MOVIMIENTO, PASAJERO DE TRANSPORTE PÚBLICO HERIDO"
  },
  {
    "codigo":442050002,
    "descripcion":"EXCESO DE GRASA SUBCUTÁNEA DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":212674008,
    "descripcion":"INTOXICACIÓN CON LOBELINA"
  },
  {
    "codigo":1259415000,
    "descripcion":"CARCINOMA PRIMARIO DE CABEZA DE PÁNCREAS"
  },
  {
    "codigo":702359002,
    "descripcion":"DISTROFIA CONGÉNITA DEL ESTROMA CORNEAL"
  },
  {
    "codigo":276375002,
    "descripcion":"LOQUIOS MALOLIENTES"
  },
  {
    "codigo":210839004,
    "descripcion":"LESIÓN DE VASO SANGUÍNEO DEL CÚBITO"
  },
  {
    "codigo":46999003,
    "descripcion":"TIÑA DE LA BARBA POR TRICHOPHYTON"
  },
  {
    "codigo":733292001,
    "descripcion":"HERIDA PUNZANTE DE PIERNA CON CUERPO EXTRAÑO"
  },
  {
    "codigo":274540003,
    "descripcion":"DIFICULTADES Y MAL MANEJO PARA LA ALIMENTACIÓN"
  },
  {
    "codigo":209004004,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN TARSOMETATARSIANA"
  },
  {
    "codigo":239937004,
    "descripcion":"AORTITIS IDIOPÁTICA"
  },
  {
    "codigo":698689005,
    "descripcion":"TRASTORNO DE HIPERACTIVIDAD CON DÉFICIT DE ATENCIÓN, CON PREDOMINIO DE DÉFICIT DE ATENCIÓN, EN REMISIÓN"
  },
  {
    "codigo":43329005,
    "descripcion":"INFESTACIÓN CAUSADA POR KNEMIDOKOPTES PILAE"
  },
  {
    "codigo":403777006,
    "descripcion":"ICTIOSIS LAMINAR (TIPO LIMITADA)"
  },
  {
    "codigo":305473007,
    "descripcion":"BAJO ATENCIÓN DE NEUMONÓLOGO"
  },
  {
    "codigo":76097009,
    "descripcion":"ERITEMA NUDOSO MIGRATORIO"
  },
  {
    "codigo":1255745005,
    "descripcion":"SARCOMA DE HODGKIN DE GANGLIOS LINFÁTICOS DE CABEZA Y CUELLO"
  },
  {
    "codigo":15937821000119109,
    "descripcion":"DERMATOFIBROMA DE PIEL DE AMBAS OREJAS"
  },
  {
    "codigo":762390005,
    "descripcion":"CAÍDA DE PELO TELÓGENO CAUSADA POR FÁRMACO"
  },
  {
    "codigo":238102008,
    "descripcion":"VARIANTE APO A-I GIESSEN"
  },
  {
    "codigo":255112006,
    "descripcion":"NEOPLASIA MALIGNA DE HIPÓFISIS E HIPOTÁLAMO"
  },
  {
    "codigo":39659002,
    "descripcion":"ANHIDROSIS"
  },
  {
    "codigo":203499004,
    "descripcion":"SEUDOARTROSIS HIPERTRÓFICA DE FRACTURA"
  },
  {
    "codigo":301803006,
    "descripcion":"HALLAZGO RELACIONADO CON EL LATIDO DE LA PUNTA"
  },
  {
    "codigo":8441000175102,
    "descripcion":"VÍCTIMA DE ACTIVIDAD SEXUAL FORZADA"
  },
  {
    "codigo":6891008,
    "descripcion":"INCOORDINACIÓN UTERINA, SEGUNDO GRADO"
  },
  {
    "codigo":1184704003,
    "descripcion":"PERIODONTITIS EXACERBADA POR HIPOFOSFATASIA"
  },
  {
    "codigo":37824006,
    "descripcion":"DIETA HOSPITALARIA BÁSICA"
  },
  {
    "codigo":365504008,
    "descripcion":"RELACIÓN CON LOS VECINOS - HALLAZGO"
  },
  {
    "codigo":298133007,
    "descripcion":"LESIÓN DEL NERVIO PLANTAR INTERNO"
  },
  {
    "codigo":1386000,
    "descripcion":"HEMORRAGIA INTRACRANEAL"
  },
  {
    "codigo":197994001,
    "descripcion":"EPIDIDIMITIS ASOCIADA CON OTRO TRASTORNO"
  },
  {
    "codigo":230762003,
    "descripcion":"EDEMA CEREBRAL POR LA ALTURA"
  },
  {
    "codigo":722282008,
    "descripcion":"SÍNDROME DE AGENESIA DE CUERPO CALLOSO, DISCAPACIDAD INTELECTUAL, COLOBOMA Y MICROGNATIA"
  },
  {
    "codigo":294463002,
    "descripcion":"ALERGIA A AMIKACINA"
  },
  {
    "codigo":65087006,
    "descripcion":"ANTÍGENO DE GRUPO SANGUÍNEO M>2<"
  },
  {
    "codigo":292628000,
    "descripcion":"REACCIÓN ADVERSA A PREPARADOS DE ALQUITRÁN MINERAL PARA EL CUERO CABELLUDO"
  },
  {
    "codigo":423700001,
    "descripcion":"CARCINOMA ESCAMOCELULAR DEL PABELLÓN AURICULAR"
  },
  {
    "codigo":390932001,
    "descripcion":"SENSIBILIDAD AL MONOFILAMENTO DE 10 G, AUSENTE"
  },
  {
    "codigo":94185003,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LAS VÍAS BILIARES"
  },
  {
    "codigo":1306601004,
    "descripcion":"NEUMONITIS POR ASPIRACIÓN CAUSADA POR REGURGITACIÓN DE ALIMENTO"
  },
  {
    "codigo":290793004,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR LISURIDA"
  },
  {
    "codigo":420030000,
    "descripcion":"DESPRENDIMIENTO MACULAR SEROSO"
  },
  {
    "codigo":126953009,
    "descripcion":"NEOPLASIA DEL CEREBRO"
  },
  {
    "codigo":288958003,
    "descripcion":"CAPAZ DE TRAGAR SALIVA"
  },
  {
    "codigo":92350005,
    "descripcion":"NEOPLASIA BENIGNA DE LA PIEL DE LOS GLÚTEOS"
  },
  {
    "codigo":43061000087103,
    "descripcion":"HEMATOMA DE DEDO MEDIO DE MANO IZQUIERDA"
  },
  {
    "codigo":385427008,
    "descripcion":"OSTEOCONDROMA DE CODO"
  },
  {
    "codigo":1268328001,
    "descripcion":"FRACTURA DE HUESO ADYACENTE A PRÓTESIS DE ARTICULACIÓN DE HOMBRO"
  },
  {
    "codigo":40501000087104,
    "descripcion":"CUERPO EXTRAÑO EN PIERNA DERECHA"
  },
  {
    "codigo":37941000087106,
    "descripcion":"ACINESIA DE MIOCARDIO DE REGIÓN ANTEROLATERAL DE VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":449128004,
    "descripcion":"SEPARACIÓN NORMAL DE COMISURAS DE VÁLVULA PULMONAR"
  },
  {
    "codigo":48181000087103,
    "descripcion":"FRACTURA DE CUARTO HUESO METATARSIANO DE PIE IZQUIERDO"
  },
  {
    "codigo":23144006,
    "descripcion":"SECRECIÓN SALIVAL CONTINUA"
  },
  {
    "codigo":1332029001,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE TENDÓN EXTENSOR DE PIE"
  },
  {
    "codigo":55912009,
    "descripcion":"GLUCOGENOSIS, TIPO V"
  },
  {
    "codigo":840509001,
    "descripcion":"HIPERPLASIA SUPRARRENAL CONGÉNITA DEBIDA A DEFICIENCIA DE 21-HIDROXILASA, FORMA NO CLÁSICA"
  },
  {
    "codigo":283453004,
    "descripcion":"HERIDA PUNZANTE EN LA NARIZ"
  },
  {
    "codigo":250685002,
    "descripcion":"ALFA-1-ANTITRIPSINA, FENOTIPO PIMM"
  },
  {
    "codigo":19474002,
    "descripcion":"LESIÓN TRAUMÁTICA DE ARTERIA CARÓTIDA PRIMITIVA"
  },
  {
    "codigo":10861291000119109,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO CIÁTICO IZQUIERDO"
  },
  {
    "codigo":445458007,
    "descripcion":"ATAXIA SENSITIVA"
  },
  {
    "codigo":248850008,
    "descripcion":"INTEGRIDAD DEL HIMEN"
  },
  {
    "codigo":738535003,
    "descripcion":"METABOLIZADOR ULTRARRÁPIDO DE LA FAMILIA 2 SUBFAMILIA D MIEMBRO 6 DEL CITOCROMO P450"
  },
  {
    "codigo":771303004,
    "descripcion":"ENCEFALOPATÍA SEVERA DE COMIENZO NEONATAL CON MICROCEFALIA"
  },
  {
    "codigo":703932008,
    "descripcion":"ALERGIA A CARNE DE POLLO"
  },
  {
    "codigo":349061000119107,
    "descripcion":"OPACIDAD DEL VÍTREO DE AMBOS OJOS"
  },
  {
    "codigo":439953004,
    "descripcion":"RELACIÓN COLESTEROL\/LIPOPROTEÍNA DE ALTA DENSIDAD POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":767633005,
    "descripcion":"TRASTORNO AFECTIVO BIPOLAR, EPISODIO MÁS RECIENTE MIXTO"
  },
  {
    "codigo":46737006,
    "descripcion":"ANEMIA NORMOCÍTICA NORMOCRÓMICA"
  },
  {
    "codigo":13969006,
    "descripcion":"GEOTRICOSIS"
  },
  {
    "codigo":1290086002,
    "descripcion":"NEOPLASIA NEUROENDOCRINA DE COLON SIGMOIDE"
  },
  {
    "codigo":733030003,
    "descripcion":"SÍNDROME DE HIPOPLASIA CONGÉNITA DE CÚBITO Y PIE HENDIDO"
  },
  {
    "codigo":44902004,
    "descripcion":"TROMBOSIS DE PENE"
  },
  {
    "codigo":403515007,
    "descripcion":"HIPERMELANOSIS ASOCIADA CON ESCLERODERMIA"
  },
  {
    "codigo":270608001,
    "descripcion":"INFORME POSTMORTEM DEL CIRUJANO POLICIAL SOLICITADO"
  },
  {
    "codigo":303376001,
    "descripcion":"NO TOMA UNA POSICIÓN"
  },
  {
    "codigo":41232003,
    "descripcion":"AMPOLLA DEL ESCROTO, CON INFECCIÓN"
  },
  {
    "codigo":237840007,
    "descripcion":"TRASTORNO ELECTROLÍTICO"
  },
  {
    "codigo":236005001,
    "descripcion":"ASCITIS MALIGNA"
  },
  {
    "codigo":1351952009,
    "descripcion":"SATURACIÓN DE OXÍGENO EN SANGRE ARTERIAL POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":301541007,
    "descripcion":"NO SE SIENTA NI SE LEVANTA DEL INODORO"
  },
  {
    "codigo":39397008,
    "descripcion":"CONTUSIÓN DE UÑA DEL DEDO PULGAR"
  },
  {
    "codigo":1217210001,
    "descripcion":"HIPEROSTOSIS CRANEAL INTERNA"
  },
  {
    "codigo":823994000,
    "descripcion":"CUERPO EXTRAÑO DE VIDRIO EN LA PIEL"
  },
  {
    "codigo":365242003,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA LLEVAR A CABO ACTIVIDADES DOMÉSTICAS"
  },
  {
    "codigo":266938001,
    "descripcion":"PACIENTE INTERNADO"
  },
  {
    "codigo":234170005,
    "descripcion":"SÍNCOPE DE DEGLUCIÓN"
  },
  {
    "codigo":10863801000119103,
    "descripcion":"HERIDA ABIERTA DE REGIÓN DE CADERA DERECHA"
  },
  {
    "codigo":70330008,
    "descripcion":"INTOXICACIÓN POR LORAZEPAM"
  },
  {
    "codigo":363407001,
    "descripcion":"NEOPLASIA MALIGNA DE ÁNGULO HEPÁTICO DE COLON"
  },
  {
    "codigo":232335002,
    "descripcion":"SÍNDROME DE FOSITA PREAURICULAR"
  },
  {
    "codigo":723855004,
    "descripcion":"SARCOMA DE EWING PRIMARIO DE CARTÍLAGO ARTICULAR DE PELVIS"
  },
  {
    "codigo":35727008,
    "descripcion":"PROTEINURIA CARDÍACA"
  },
  {
    "codigo":1124005,
    "descripcion":"PUERPERIO, 6 DÍAS"
  },
  {
    "codigo":722020006,
    "descripcion":"ARTERITIS TEMPORAL JUVENIL"
  },
  {
    "codigo":230500006,
    "descripcion":"DISTONÍA RELACIONADA CON EL SUEÑO"
  },
  {
    "codigo":296036006,
    "descripcion":"SOBREDOSIS DE BARBITÚRICO"
  },
  {
    "codigo":263268008,
    "descripcion":"SÍNDROME COMPARTIMENTAL DE PERONEO LATERAL DEBIDO A LESIÓN TRAUMÁTICA"
  },
  {
    "codigo":458041002,
    "descripcion":"TORACÓPAGOS CON CORAZONES SEPARADOS Y SACO PERICÁRDICO COMÚN"
  },
  {
    "codigo":132281000119108,
    "descripcion":"TROMBOSIS AGUDA DE VENA PROFUNDA"
  },
  {
    "codigo":292366005,
    "descripcion":"REACCIÓN ADVERSA A HIDRATO DE CLORAL"
  },
  {
    "codigo":95758006,
    "descripcion":"ECTROPIÓN DEL PÁRPADO INFERIOR"
  },
  {
    "codigo":1144334007,
    "descripcion":"ATROFIA DE TÚBULO RENAL"
  },
  {
    "codigo":716515000,
    "descripcion":"SÍNDROME DE MICRODELECIÓN 1Q41Q42"
  },
  {
    "codigo":128526009,
    "descripcion":"ESPASMO DEL MÚSCULO LISO"
  },
  {
    "codigo":93923002,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL SISTEMA NERVIOSO"
  },
  {
    "codigo":126691006,
    "descripcion":"NEOPLASIA DE LA PARED POSTERIOR DE LA HIPOFARINGE"
  },
  {
    "codigo":92088003,
    "descripcion":"NEOPLASIA BENIGNA DE EPIDÍDIMO"
  },
  {
    "codigo":288696004,
    "descripcion":"INCAPAZ DE COMUNICARSE CON DIFERENTES PERSONAS"
  },
  {
    "codigo":11820371000119106,
    "descripcion":"SUBLUXACIÓN DE ARTICULACIÓN GLENOHUMERAL DERECHA"
  },
  {
    "codigo":90253000,
    "descripcion":"GLIOSIS SUBCORTICAL PROGRESIVA"
  },
  {
    "codigo":188557000,
    "descripcion":"PUPILA GRANDE"
  },
  {
    "codigo":1237133002,
    "descripcion":"VENA VARICOSA DE PIERNA"
  },
  {
    "codigo":11793901000119101,
    "descripcion":"AMPOLLA TRAUMÁTICA DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":679251000119107,
    "descripcion":"DEGENERACIÓN MARGINAL DE TERRIEN DE CÓRNEA PERIFÉRICA DE OJO DERECHO"
  },
  {
    "codigo":254093009,
    "descripcion":"DISPLASIA CRANEOECTODÉRMICA"
  },
  {
    "codigo":416098002,
    "descripcion":"ALERGIA MEDICAMENTOSA"
  },
  {
    "codigo":285026005,
    "descripcion":"DIFICULTAD PARA MANEJAR UN ARTEFACTO MIENTRAS SE VISTE"
  },
  {
    "codigo":250423000,
    "descripcion":"PRUEBA DE EMBARAZO POSITIVA"
  },
  {
    "codigo":217655006,
    "descripcion":"ENVENENAMIENTO DEBIDO A MORDEDURA DE MONSTRUO DE GILA"
  },
  {
    "codigo":1264396000,
    "descripcion":"HEMORRAGIA EXCESIVA DEBIDA A ABORTO Y POSTERIOR A ÉL"
  },
  {
    "codigo":838412000,
    "descripcion":"DOLOR A LA PALPACIÓN EN REGIÓN LUMBAR"
  },
  {
    "codigo":1297164003,
    "descripcion":"HERIDA PUNZANTE DE PÁRPADO INFERIOR"
  },
  {
    "codigo":248588004,
    "descripcion":"PROFUNDIDAD DE LA RESPIRACIÓN IRREGULAR"
  },
  {
    "codigo":1231628005,
    "descripcion":"DESVIACIÓN SOSTENIDA DE LA MIRADA HACIA ARRIBA"
  },
  {
    "codigo":19212008,
    "descripcion":"EXTENSIÓN ANORMAL"
  },
  {
    "codigo":82913001,
    "descripcion":"INTOXICACIÓN POR BETA"
  },
  {
    "codigo":246753007,
    "descripcion":"HIPERFORIA INCOMITANTE"
  },
  {
    "codigo":310454001,
    "descripcion":"INFORME DE APTITUD PARA CONDUCIR SOLICITADO"
  },
  {
    "codigo":48310002,
    "descripcion":"INTOXICACIÓN POR SUSTITUTO SANGUÍNEO MACROMOLECULAR"
  },
  {
    "codigo":769206007,
    "descripcion":"NUEVA SUSTANCIA PSICOACTIVA NEGATIVA EN ORINA"
  },
  {
    "codigo":110176000,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DE REGIÓN PREAURICULAR DE LA CARA"
  },
  {
    "codigo":44640004,
    "descripcion":"INTENTO FALLIDO DE ABORTO CON PARAMETRITIS"
  },
  {
    "codigo":208480006,
    "descripcion":"FRACTURA EXPUESTA DE FALANGE PROXIMAL DE DEDO DE LA MANO, CUELLO"
  },
  {
    "codigo":1156917000,
    "descripcion":"INMUNE A TOS FERINA"
  },
  {
    "codigo":77408009,
    "descripcion":"FÍSTULA DEL ÚTERO"
  },
  {
    "codigo":403253001,
    "descripcion":"HIPERMELANOSIS POR SÍNDROME DE CUSHING"
  },
  {
    "codigo":354081000119101,
    "descripcion":"ADENOCARCINOMA METASTÁSICO"
  },
  {
    "codigo":370485008,
    "descripcion":"FÍSTULA ORONASAL"
  },
  {
    "codigo":40970001,
    "descripcion":"OSTEOMIELITIS CRÓNICA"
  },
  {
    "codigo":237578000,
    "descripcion":"HIPERSECRECIÓN DE SOMATOSTATINA"
  },
  {
    "codigo":11822881000119103,
    "descripcion":"ABRASIÓN DE PIEL DE AXILA IZQUIERDA"
  },
  {
    "codigo":792799000,
    "descripcion":"LIPOMA DE NERVIO"
  },
  {
    "codigo":202975001,
    "descripcion":"SUBLUXACIÓN DE TENDÓN DE MUÑECA O MANO"
  },
  {
    "codigo":301279003,
    "descripcion":"FRÉMITO VOCAL NORMAL"
  },
  {
    "codigo":235743004,
    "descripcion":"LEUCOPLASIA ANAL"
  },
  {
    "codigo":201140002,
    "descripcion":"ALOPECIA FOLICULAR"
  },
  {
    "codigo":364980003,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA UTILIZAR LA PRENSIÓN EN TIJERAS"
  },
  {
    "codigo":70068004,
    "descripcion":"POSICIÓN OCCIPITOPOSTERIOR PERSISTENTE"
  },
  {
    "codigo":102836007,
    "descripcion":"ESPASMO URETRAL"
  },
  {
    "codigo":397748008,
    "descripcion":"HIPERTENSIÓN CON ALBUMINURIA"
  },
  {
    "codigo":233908008,
    "descripcion":"TAQUICARDIA VENTRICULAR INFANTIL INCESANTE"
  },
  {
    "codigo":199305006,
    "descripcion":"COMPLICACIONES ESPECÍFICAS DE LA GESTACIÓN MÚLTIPLE"
  },
  {
    "codigo":232073009,
    "descripcion":"ANGIOMATOSIS DE RETINA"
  },
  {
    "codigo":862001,
    "descripcion":"ANEMIA CAUSADA POR CLORATO"
  },
  {
    "codigo":721758001,
    "descripcion":"INFECCIÓN CAUSADA POR COXIELLA"
  },
  {
    "codigo":230238009,
    "descripcion":"ATAXIA ESPINOCEREBELOSA PROGRESIVA CON REFLEJOS TENDINOSOS CONSERVADOS"
  },
  {
    "codigo":425011002,
    "descripcion":"SINUSITIS ALÉRGICA POR HONGOS"
  },
  {
    "codigo":1090511000119100,
    "descripcion":"TRASTORNO DE NERVIO AUDITIVO DERECHO"
  },
  {
    "codigo":16302031000119101,
    "descripcion":"LESIÓN DE HUESO DE MUSLO IZQUIERDO"
  },
  {
    "codigo":291791000119100,
    "descripcion":"SÍNDROME DE DOLOR REGIONAL COMPLEJO TIPO II DE MIEMBRO INFERIOR DERECHO"
  },
  {
    "codigo":317391000119103,
    "descripcion":"DETENCIÓN PARCIAL DE CRECIMIENTO EPIFISARIO DE RADIO DISTAL IZQUIERDO"
  },
  {
    "codigo":680911000119104,
    "descripcion":"HIPOTRICOSIS DE PÁRPADO DERECHO"
  },
  {
    "codigo":1077711000119104,
    "descripcion":"OSTEOMIELITIS DE MANO DERECHA"
  },
  {
    "codigo":10644431000119106,
    "descripcion":"ÚLCERA VARICOSA DE MUSLO IZQUIERDO"
  },
  {
    "codigo":186831000119104,
    "descripcion":"APRAXIA DEBIDA A ACCIDENTE CEREBROVASCULAR Y POSTERIOR A ÉL"
  },
  {
    "codigo":15999951000119108,
    "descripcion":"TRASTORNO DE ESCLERÓTICA DE OJO DERECHO"
  },
  {
    "codigo":335311000119109,
    "descripcion":"ENOFTALMÍA DE OJO DERECHO"
  },
  {
    "codigo":10667471000119108,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN DE PIERNA DERECHA ESTADIO II"
  },
  {
    "codigo":1087951000119105,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE LÓBULO DE LA OREJA IZQUIERDA PERFORADO"
  },
  {
    "codigo":15997391000119106,
    "descripcion":"PLIEGUE IDIOPÁTICO DE COROIDES DE OJO IZQUIERDO"
  },
  {
    "codigo":10631631000119108,
    "descripcion":"ONIQUIA DE DEDO DEL PIE IZQUIERDO"
  },
  {
    "codigo":678351000119109,
    "descripcion":"IRIS BOMBÉ DE OJO IZQUIERDO"
  },
  {
    "codigo":1085391000119106,
    "descripcion":"ABSCESO DE INTESTINO CONCOMITANTE CON PÓLIPOS INFLAMATORIOS COLÓNICOS Y DEBIDO A ELLOS"
  },
  {
    "codigo":292104003,
    "descripcion":"REACCIÓN ADVERSA AL OROZUZ"
  },
  {
    "codigo":368591000119109,
    "descripcion":"SÍNDROME DE LA MANO DIABÉTICA DEBIDO A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":60893000,
    "descripcion":"PROSTATITIS GONOCÓCICA CRÓNICA"
  },
  {
    "codigo":880093002,
    "descripcion":"SÍNDROME DE DELECIÓN 17Q11"
  },
  {
    "codigo":191965003,
    "descripcion":"SÍNTOMAS CUTÁNEOS PSICÓGENOS"
  },
  {
    "codigo":93661001,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL ACROMION"
  },
  {
    "codigo":290269005,
    "descripcion":"INTOXICACIÓN POR KETOROLACO"
  },
  {
    "codigo":1337010002,
    "descripcion":"FRACTURA EXPUESTA ESTRELLADA DE RÓTULA"
  },
  {
    "codigo":386738004,
    "descripcion":"MÚLTIPLES SÍNTOMAS SOMÁTICOS"
  },
  {
    "codigo":714418004,
    "descripcion":"DIFICULTAD PARA ADMINISTRARSE MEDICACIÓN PARENTERAL"
  },
  {
    "codigo":124594007,
    "descripcion":"DEFICIENCIA DE MALONIL - COA DESCARBOXILASA"
  },
  {
    "codigo":288434007,
    "descripcion":"DIFICULTAD PARA UTILIZAR PINZAS"
  },
  {
    "codigo":712583003,
    "descripcion":"INFECCIÓN INTESTINAL CAUSADA POR PLESIOMONAS SHIGELLOIDES"
  },
  {
    "codigo":137301000119105,
    "descripcion":"LESIÓN TRAUMÁTICA DEBIDA A ACTIVIDAD CICLÍSTICA"
  },
  {
    "codigo":188295009,
    "descripcion":"NEOPLASIA MALIGNA DE PEDÚNCULO CEREBRAL"
  },
  {
    "codigo":22620000,
    "descripcion":"ÚLCERA PREPILÓRICA"
  },
  {
    "codigo":415836006,
    "descripcion":"ABERRACIÓN DEL FRENTE DE ONDAS"
  },
  {
    "codigo":448604006,
    "descripcion":"ANOMALÍA CONGÉNITA DE CÚSPIDE DE VÁLVULA PULMONAR"
  },
  {
    "codigo":284764009,
    "descripcion":"SE PELLIZCA"
  },
  {
    "codigo":86321003,
    "descripcion":"INTOXICACIÓN POR LEVODOPA"
  },
  {
    "codigo":1264134008,
    "descripcion":"ENDOMETRITIS POSTERIOR A EMBARAZO MOLAR"
  },
  {
    "codigo":836315005,
    "descripcion":"AGUDEZA VISUAL CORREGIDA DE OJO IZQUIERDO 1\/60"
  },
  {
    "codigo":49883006,
    "descripcion":"CANDIDIASIS DE PIEL"
  },
  {
    "codigo":770779009,
    "descripcion":"QUEMADURA EPIDÉRMICA DE LA PIEL DE LOS LABIOS SUPERIOR E INFERIOR"
  },
  {
    "codigo":15280003,
    "descripcion":"RUIDOS INTESTINALES DISMINUIDOS"
  },
  {
    "codigo":15731081000119100,
    "descripcion":"PARÁLISIS TOTAL DE NERVIOS OCULOMOTORES BILATERALES"
  },
  {
    "codigo":277424008,
    "descripcion":"PÉRDIDA DE LA AUDICIÓN NEUROSENSORIAL PROFUNDA, POSQUIRÚRGICA"
  },
  {
    "codigo":13445001,
    "descripcion":"ENFERMEDAD DE MÉNIÈRE"
  },
  {
    "codigo":10678511000119108,
    "descripcion":"TUMEFACCIÓN LOCALIZADA DE AMBOS PIES"
  },
  {
    "codigo":84361000119102,
    "descripcion":"HIPOGLUCEMIA REACTIVA POR INSULINA DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":372058001,
    "descripcion":"LESIÓN NO ACCIDENTAL A UN ADULTO"
  },
  {
    "codigo":109914007,
    "descripcion":"NEOPLASIA MENÍNGEA DE COMPORTAMIENTO INCIERTO"
  },
  {
    "codigo":75311005,
    "descripcion":"AUSENCIA CONGÉNITA DE LOS HUESECILLOS DEL OÍDO"
  },
  {
    "codigo":304687006,
    "descripcion":"CAPAZ DE TOMAR DECISIONES ELABORADAS"
  },
  {
    "codigo":697903007,
    "descripcion":"HIPERTENSIÓN DE ARTERIA PULMONAR ASOCIADA CON ENFERMEDAD DE TEJIDO CONJUNTIVO"
  },
  {
    "codigo":42543008,
    "descripcion":"TOLERANCIA AL ESTRÉS DISMINUIDA"
  },
  {
    "codigo":827140007,
    "descripcion":"PULSO VISIBLE EN AORTA ABDOMINAL"
  },
  {
    "codigo":366553001,
    "descripcion":"HALLAZGO EN EL REFLEJO PLANTAR"
  },
  {
    "codigo":299182001,
    "descripcion":"SIN AMPLITUD PASIVA DE ADUCCIÓN DE PULGAR"
  },
  {
    "codigo":233646003,
    "descripcion":"QUILOTÓRAX CONGÉNITO"
  },
  {
    "codigo":725166005,
    "descripcion":"OMODISPLASIA AUTOSÓMICA RECESIVA"
  },
  {
    "codigo":364718008,
    "descripcion":"HALLAZGO EN LA PRUEBA ÍNDICE-NARIZ"
  },
  {
    "codigo":788867008,
    "descripcion":"COMPORTAMIENTO APÁTICO DEBIDO A DEMENCIA"
  },
  {
    "codigo":721496001,
    "descripcion":"FRACTURA DE TERCERA VÉRTEBRA LUMBAR"
  },
  {
    "codigo":10871331000119105,
    "descripcion":"FIBROMA DE OVARIO IZQUIERDO"
  },
  {
    "codigo":2435008,
    "descripcion":"ASCARIASIS"
  },
  {
    "codigo":262744005,
    "descripcion":"AVULSIÓN DE LA RAÍZ DE NERVIO ESPINAL"
  },
  {
    "codigo":787032006,
    "descripcion":"CUERPO EXTRAÑO RETENIDO EN REGIÓN DE LA RODILLA"
  },
  {
    "codigo":295512005,
    "descripcion":"SOBREDOSIS DE PROPOFOL"
  },
  {
    "codigo":600009,
    "descripcion":"PIROMANÍA"
  },
  {
    "codigo":424749001,
    "descripcion":"INHIBICIÓN FARMACOLÓGICA DE ENZIMA CYP2D6 DEL CITOCROMO P450"
  },
  {
    "codigo":897544003,
    "descripcion":"TRISOMÍA DISTAL 1Q"
  },
  {
    "codigo":719661007,
    "descripcion":"SÍNDROME DE MICRODELECIÓN 5Q14.3"
  },
  {
    "codigo":129837009,
    "descripcion":"PROTECCIÓN INEFICAZ"
  },
  {
    "codigo":1078274002,
    "descripcion":"AGENESIA DE FALANGE MEDIA DE TERCER DEDO DE PIE"
  },
  {
    "codigo":160770002,
    "descripcion":"ASISTENTE SOCIAL INVOLUCRADO"
  },
  {
    "codigo":816130004,
    "descripcion":"MUESTRA DE SANGRE DE COLOR PÁLIDO"
  },
  {
    "codigo":95234008,
    "descripcion":"CAYADO AÓRTICO RETROESOFÁGICO"
  },
  {
    "codigo":717826009,
    "descripcion":"NEUROPATÍA HEREDITARIA SENSITIVA Y AUTONÓMICA CON SORDERA Y RETRASO GLOBAL"
  },
  {
    "codigo":93399001,
    "descripcion":"ENGROSAMIENTO CONGÉNITO DE PERONÉ"
  },
  {
    "codigo":291842008,
    "descripcion":"INTOXICACIÓN POR ESTEROIDES ANABÓLICOS"
  },
  {
    "codigo":715991005,
    "descripcion":"SÍNDROME DE CRANE HEISE"
  },
  {
    "codigo":224471007,
    "descripcion":"SIN PERSPECTIVAS DE PROMOCIÓN"
  },
  {
    "codigo":27863008,
    "descripcion":"NO SE OBSERVAN ORGANISMOS"
  },
  {
    "codigo":1303980007,
    "descripcion":"DESPLAZAMIENTO DE PLACA DE AMBOS OJOS DEBIDO A CIRUGÍA DE DRENAJE DE GLAUCOMA Y POSTERIOR A ELLA"
  },
  {
    "codigo":89729000,
    "descripcion":"TRASTORNO POR INHIBIDOR DEL FACTOR IX"
  },
  {
    "codigo":124332009,
    "descripcion":"DEFICIENCIA DE GLUCOSA - 1 - FOSFATO FOSFODISMUTASA"
  },
  {
    "codigo":1269377002,
    "descripcion":"LESIÓN CENTRAL DE MÉDULA ESPINAL DORSAL DEBIDA A LUXACIÓN NO EXPUESTA DE ARTICULACIÓN DE COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":253569001,
    "descripcion":"DEFECTO INTERVENTRICULAR SUBARTERIAL DOBLE RELACIONADO CON EXTENSIÓN HACIA TABIQUE MEMBRANOSO"
  },
  {
    "codigo":188033007,
    "descripcion":"MELANOMA MALIGNO DE PABELLÓN AURICULAR"
  },
  {
    "codigo":1234774002,
    "descripcion":"ALTERACIÓN COGNITIVA CAUSADA POR ETANOL"
  },
  {
    "codigo":55126004,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN DEL TARSO"
  },
  {
    "codigo":415574006,
    "descripcion":"RUPTURA ESPONTÁNEA DE TENDONES EXTENSORES"
  },
  {
    "codigo":284502008,
    "descripcion":"CONDUCTA CAPRICHOSA"
  },
  {
    "codigo":1003563001,
    "descripcion":"AGENESIA DE VÉRTEBRA"
  },
  {
    "codigo":251734008,
    "descripcion":"TUMOR DE ÁNGULO"
  },
  {
    "codigo":249899003,
    "descripcion":"HALLAZGO RELACIONADO CON LA MOTRICIDAD GRUESA DE UNA EXTREMIDAD"
  },
  {
    "codigo":15979351000119104,
    "descripcion":"COLESTEATOSIS DIFUSA DE OÍDO MEDIO IZQUIERDO"
  },
  {
    "codigo":315435003,
    "descripcion":"NACIDO EN GUATEMALA"
  },
  {
    "codigo":282667008,
    "descripcion":"LANZA"
  },
  {
    "codigo":84224006,
    "descripcion":"OSTEOMIELITIS SUPURATIVA DE LA MANDÍBULA"
  },
  {
    "codigo":248064007,
    "descripcion":"AUTOMUTILACIÓN DE LAS MANOS"
  },
  {
    "codigo":278997003,
    "descripcion":"DOLOR A LA PALPACIÓN DE HUESO"
  },
  {
    "codigo":10736471000119108,
    "descripcion":"FIBROESCLEROSIS DE MAMA IZQUIERDA"
  },
  {
    "codigo":49621008,
    "descripcion":"ORINA GOTOSA"
  },
  {
    "codigo":1260202003,
    "descripcion":"SÍNDROME DE ACTIVACIÓN MASTOCITARIA MONOCLONAL"
  },
  {
    "codigo":211626006,
    "descripcion":"CUERPO EXTRAÑO EN FARINGE Y LARINGE"
  },
  {
    "codigo":735914007,
    "descripcion":"DESGASTE DE CARTÍLAGO ARTICULAR CAUSADO POR HEMIARTROPLASTIA"
  },
  {
    "codigo":275327001,
    "descripcion":"DESGARRO EN ASA DE BALDE - LESIÓN ACTUAL"
  },
  {
    "codigo":60401000119104,
    "descripcion":"PSICOSIS PUERPERAL EN REMISIÓN"
  },
  {
    "codigo":111487009,
    "descripcion":"CRISIS DE ANSIEDAD DEL SUEÑO"
  },
  {
    "codigo":240724004,
    "descripcion":"CRIPTOCOCOSIS CUTÁNEA"
  },
  {
    "codigo":207956004,
    "descripcion":"FRACTURA EXPUESTA DE VÉRTEBRA DORSAL, TRICOLUMNAR"
  },
  {
    "codigo":15926411000119101,
    "descripcion":"HERNIA PARAESOFÁGICA CON REFLUJO GASTROESOFÁGICO"
  },
  {
    "codigo":75049004,
    "descripcion":"DISTROFIA TORÁCICA DE JEUNE"
  },
  {
    "codigo":238889004,
    "descripcion":"LIPODISTROFIA MEMBRANOSA"
  },
  {
    "codigo":402729004,
    "descripcion":"CAMBIOS EN EL PELO POR DESNUTRICIÓN"
  },
  {
    "codigo":10955761000119108,
    "descripcion":"HERIDA PUNZANTE DE DEDO MEDIO DE MANO IZQUIERDA"
  },
  {
    "codigo":16745611000119102,
    "descripcion":"RETINOPATÍA NO PROLIFERATIVA LEVE DE OJO DERECHO DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":271657009,
    "descripcion":"FRÉMITO SISTÓLICO"
  },
  {
    "codigo":7678002,
    "descripcion":"NEUMONÍA POR CITOMEGALOVIRUS"
  },
  {
    "codigo":1285630003,
    "descripcion":"HEMATOMA DE PIE"
  },
  {
    "codigo":238387007,
    "descripcion":"ABSCESO DE LA PALMA DE LA MANO"
  },
  {
    "codigo":366291000,
    "descripcion":"HALLAZGO RELACIONADO CON FUNCIÓN VASCULAR DE PENE"
  },
  {
    "codigo":202451005,
    "descripcion":"TUMOR TENOSINOVIAL DE CÉLULAS GIGANTES DIFUSO DE PRIMERA ARTICULACIÓN METATARSOFALÁNGICA"
  },
  {
    "codigo":724904000,
    "descripcion":"LACERACIÓN DE TENDÓN PÉLVICO"
  },
  {
    "codigo":266152000,
    "descripcion":"MICETOMA DERMATOFÍTICO"
  },
  {
    "codigo":298920000,
    "descripcion":"AMPLITUD DE PRONACIÓN PASIVA DE CODO AUMENTADA"
  },
  {
    "codigo":297085009,
    "descripcion":"SOBREDOSIS INTENCIONAL DE DIPIRIDAMOL"
  },
  {
    "codigo":295250003,
    "descripcion":"SOBREDOSIS DE IBUPROFENO"
  },
  {
    "codigo":721234004,
    "descripcion":"HIPERINSULINISMO DEBIDO A DEFICIENCIA DE FACTOR NUCLEAR 1-ALFA DEL HEPATOCITO"
  },
  {
    "codigo":164178007,
    "descripcion":"EXAMEN DE OÍDO NORMAL"
  },
  {
    "codigo":1145383001,
    "descripcion":"APLASIA DE FÉMUR"
  },
  {
    "codigo":31271002,
    "descripcion":"MIMETISMO"
  },
  {
    "codigo":129575004,
    "descripcion":"SÍNDROME DE ROTACIÓN DEL MARCAPASOS CARDÍACO"
  },
  {
    "codigo":195111005,
    "descripcion":"INSUFICIENCIA CARDÍACA DESCOMPENSADA"
  },
  {
    "codigo":719399007,
    "descripcion":"BLOQUEO DEL HABLA"
  },
  {
    "codigo":293415007,
    "descripcion":"REACCIÓN ADVERSA AL FLUORURO DE SODIO"
  },
  {
    "codigo":335141000119105,
    "descripcion":"RETRACCIÓN ANORMAL DE PÁRPADO DERECHO"
  },
  {
    "codigo":94972002,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE ÓRBITA OCULAR"
  },
  {
    "codigo":291580001,
    "descripcion":"INTOXICACIÓN POR CEFALOSPORINA DE SEGUNDA GENERACIÓN"
  },
  {
    "codigo":424487008,
    "descripcion":"MELANOMA MALIGNO DE LA PIEL DE LABIO SUPERIOR"
  },
  {
    "codigo":62204001,
    "descripcion":"INTOXICACIÓN POR CROTALARIA GLOBIFERA"
  },
  {
    "codigo":160508006,
    "descripcion":"LUGAR DE ORDEN FAMILIAR: HERMANO MENOR DE SEXO FEMENINO O MASCULINO"
  },
  {
    "codigo":89381000119107,
    "descripcion":"RETARDO MODERADO DEL LENGUAJE RECEPTIVO"
  },
  {
    "codigo":27601005,
    "descripcion":"INFECCIÓN CAUSADA POR CESTODOS Y\/O TREMATODOS Y\/O NEMATODOS"
  },
  {
    "codigo":1010641008,
    "descripcion":"ANOMALÍA DE VENA UMBILICAL GRUPO II"
  },
  {
    "codigo":124070001,
    "descripcion":"UROPORFIRINA POR ENCIMA DE RANGO DE REFERENCIA"
  },
  {
    "codigo":16037311000119103,
    "descripcion":"DETENCIÓN DE CRECIMIENTO EPIFISARIO DE ANTEBRAZO DERECHO"
  },
  {
    "codigo":25766007,
    "descripcion":"TRASTORNO MIXTO DEL LENGUAJE RECEPTIVO - EXPRESIVO"
  },
  {
    "codigo":91302008,
    "descripcion":"SEPSIS"
  },
  {
    "codigo":255142009,
    "descripcion":"CARCINOMA IN SITU DE ÓRGANO RESPIRATORIO E INTRATORÁCICO"
  },
  {
    "codigo":253307000,
    "descripcion":"VENA CAVA SUPERIOR DERECHA ATRÉSICA"
  },
  {
    "codigo":89467003,
    "descripcion":"FALTA DE HEMORRAGIA DE PRIVACIÓN"
  },
  {
    "codigo":10630591000119104,
    "descripcion":"LINFANGITIS AGUDA DE DEDO DE MANO IZQUIERDA"
  },
  {
    "codigo":286075004,
    "descripcion":"NO AIREA LA ROPA LAVADA"
  },
  {
    "codigo":449915007,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN PIERNA, SIN INFECCIÓN"
  },
  {
    "codigo":16774591000119105,
    "descripcion":"CARCINOMA BASOCELULAR PRIMARIO DE PIEL DE MANO DERECHA"
  },
  {
    "codigo":448080000,
    "descripcion":"TRACTO DE SALIDA VENTRICULAR ÚNICO POR ENCIMA DE VENTRÍCULO DE MORFOLOGÍA INDETERMINADA"
  },
  {
    "codigo":251472002,
    "descripcion":"REGISTRO ISOELÉCTRICO"
  },
  {
    "codigo":1003301000,
    "descripcion":"CLINODACTILIA CONGÉNITA DE SEGUNDO DEDO DE PIE"
  },
  {
    "codigo":249637000,
    "descripcion":"ORIFICIO ANAL IRREGULARMENTE DILATADO"
  },
  {
    "codigo":218704008,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR ÓXIDO NITROSO"
  },
  {
    "codigo":51194002,
    "descripcion":"INTOXICACIÓN POR ECHIUM"
  },
  {
    "codigo":870394007,
    "descripcion":"DISTENSIÓN DE TENDÓN DE TOBILLO"
  },
  {
    "codigo":1360079000,
    "descripcion":"SÍNDROME DE PERSISTENCIA HEREDITARIA DE HEMOGLOBINA FETAL, DISCAPACIDAD INTELECTUAL"
  },
  {
    "codigo":247802007,
    "descripcion":"DEPRESIÓN QUE EMPEORA AL FINAL DEL DÍA"
  },
  {
    "codigo":82127005,
    "descripcion":"ABSCESO PERIANAL"
  },
  {
    "codigo":49359006,
    "descripcion":"JUEGO SEXUAL ENTRE HERMANO Y HERMANO"
  },
  {
    "codigo":1163471007,
    "descripcion":"MENINGITIS POR VIRUS JUNÍN"
  },
  {
    "codigo":721748000,
    "descripcion":"MENINGITIS CAUSADA POR ENTEROCOCCUS"
  },
  {
    "codigo":211364004,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN MIEMBRO INFERIOR, INFECTADA"
  },
  {
    "codigo":14756005,
    "descripcion":"PAROTITIS"
  },
  {
    "codigo":15683161000119106,
    "descripcion":"BURSITIS DE AMBAS MANOS"
  },
  {
    "codigo":735652006,
    "descripcion":"LACERACIÓN DE AMBOS OJOS CONCOMITANTE CON PROLAPSO DE TEJIDO INTRAOCULAR"
  },
  {
    "codigo":897657000,
    "descripcion":"RINOSINUSITIS CRÓNICA"
  },
  {
    "codigo":406137001,
    "descripcion":"ADULTO VÍCTIMA DE MALTRATO"
  },
  {
    "codigo":733817003,
    "descripcion":"AISLAMIENTO SOCIAL DISMINUIDO"
  },
  {
    "codigo":373369003,
    "descripcion":"DIFERENCIACIÓN Y\/O CONDUCTA DE ESTADIFICACIÓN HISTOLÓGICA - HALLAZGO"
  },
  {
    "codigo":209529003,
    "descripcion":"ESGUINCE DE TOBILLO Y PIE"
  },
  {
    "codigo":1074931000119101,
    "descripcion":"ARTRITIS DE ARTICULACIÓN MEDIOTARSIANA DERECHA"
  },
  {
    "codigo":1290873005,
    "descripcion":"OSTEOSARCOMA TELANGIECTÁSICO"
  },
  {
    "codigo":240462000,
    "descripcion":"PRÓDROMO DE RABIA"
  },
  {
    "codigo":43854003,
    "descripcion":"RETRACCIÓN ANORMAL DE PÁRPADO"
  },
  {
    "codigo":109390005,
    "descripcion":"SARCOMA DE KAPOSI PULMONAR"
  },
  {
    "codigo":699214007,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN EN CADERA"
  },
  {
    "codigo":11086007,
    "descripcion":"INTOXICACIÓN POR MICROCYSTIS"
  },
  {
    "codigo":830286009,
    "descripcion":"BACTERIAS OBSERVADAS EN EL EXAMEN MICROSCÓPICO CON TINCIÓN"
  },
  {
    "codigo":238627002,
    "descripcion":"ICTIOSIS FOLICULAR"
  },
  {
    "codigo":402467002,
    "descripcion":"MIXEDEMA PRETIBIAL ELEFANTIÁSICO"
  },
  {
    "codigo":42019003,
    "descripcion":"CONTUSIÓN DE PULMÓN CON HERIDA ABIERTA HACIA TÓRAX"
  },
  {
    "codigo":369699006,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA PROFUNDA DE RECTO, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":762915008,
    "descripcion":"TUMEFACCIÓN DE PIE DERECHO"
  },
  {
    "codigo":236792002,
    "descripcion":"INFERTILIDAD DE ORIGEN GENÉTICO EN EL VARÓN"
  },
  {
    "codigo":1187064003,
    "descripcion":"CALCIO EN ORINA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":105720005,
    "descripcion":"HALLAZGO RELACIONADO CON LA FUNCIÓN CORPORAL GENERAL"
  },
  {
    "codigo":10823411000119106,
    "descripcion":"FRACTURA EXPUESTA DE FALANGE MEDIA DE DEDO ANULAR IZQUIERDO"
  },
  {
    "codigo":366029000,
    "descripcion":"HALLAZGO RELACIONADO CON LA POSICIÓN DEL IRIS"
  },
  {
    "codigo":300493001,
    "descripcion":"TESTÍCULO NORMAL"
  },
  {
    "codigo":337651000119108,
    "descripcion":"RETINOPATÍA SOLAR DE OJO IZQUIERDO"
  },
  {
    "codigo":69282001,
    "descripcion":"TORSIÓN DE EPIDÍDIMO"
  },
  {
    "codigo":298658003,
    "descripcion":"AMPLITUD DE ROTACIÓN ACTIVA HACIA LA IZQUIERDA DE LA COLUMNA LUMBAR NORMAL"
  },
  {
    "codigo":1052322008,
    "descripcion":"SÍFILIS SECUNDARIA DE OJO"
  },
  {
    "codigo":724642009,
    "descripcion":"NEOPLASIA MIELOIDE ASOCIADA CON REORDENAMIENTO DEL GEN DEL RECEPTOR DE FACTOR DE CRECIMIENTO DERIVADO DE LAS PLAQUETAS TIPO BETA"
  },
  {
    "codigo":67447005,
    "descripcion":"LESIÓN TRAUMÁTICA DE CUERPO DE PÁNCREAS SIN HERIDA ABIERTA HACIA CAVIDAD ABDOMINAL"
  },
  {
    "codigo":427895005,
    "descripcion":"DERRAME PLEURAL TABICADO"
  },
  {
    "codigo":1148791007,
    "descripcion":"FUNCIÓN DEL SISTEMA GASTROINTESTINAL NORMAL"
  },
  {
    "codigo":294988000,
    "descripcion":"ALERGIA A AMIODARONA"
  },
  {
    "codigo":165751009,
    "descripcion":"GRUPO SANGUÍNEO DUFFY"
  },
  {
    "codigo":1179724008,
    "descripcion":"REACCIÓN ADVERSA AL TOCILIZUMAB"
  },
  {
    "codigo":131148009,
    "descripcion":"HEMORRAGIA"
  },
  {
    "codigo":162081000,
    "descripcion":"NO CONSTIPADO"
  },
  {
    "codigo":194849004,
    "descripcion":"MIOCARDIOPATÍA ISQUÉMICA GENERALIZADA"
  },
  {
    "codigo":293153008,
    "descripcion":"REACCIÓN ADVERSA A LA FLURANDRENOLONA"
  },
  {
    "codigo":422390002,
    "descripcion":"LESIÓN CAUSADA POR ARMA TIPO TASER"
  },
  {
    "codigo":1208822004,
    "descripcion":"OBSTRUCCIÓN ARTERIAL DEBIDA A EMBOLIA TROMBÓTICA DE ANEURISMA DE AORTA ABDOMINAL"
  },
  {
    "codigo":92875000,
    "descripcion":"FUSIÓN ANORMAL CONGÉNITA DE CARTÍLAGO COSTAL"
  },
  {
    "codigo":289483001,
    "descripcion":"DESCAMACIÓN DE VULVA"
  },
  {
    "codigo":125643001,
    "descripcion":"HERIDA ABIERTA"
  },
  {
    "codigo":1338059001,
    "descripcion":"HIPOESPERMATOGÉNESIS DEBIDA A RADIOTERAPIA Y POSTERIOR A ELLA"
  },
  {
    "codigo":24712006,
    "descripcion":"EPIDIDIMITIS SIN ABSCESO"
  },
  {
    "codigo":387787005,
    "descripcion":"URTICARIA POR PRESIÓN"
  },
  {
    "codigo":191179005,
    "descripcion":"ANEMIA HEMOLÍTICA POR DEFICIENCIA DE TRIOSA FOSFATO ISOMERASA"
  },
  {
    "codigo":27339005,
    "descripcion":"COROIDITIS DISEMINADA"
  },
  {
    "codigo":254880000,
    "descripcion":"PÓLIPO LEIOMIOMATOSO DEL ÚTERO"
  },
  {
    "codigo":123808002,
    "descripcion":"HIPERCUPRURIA"
  },
  {
    "codigo":1303456002,
    "descripcion":"GLAUCOMA DE ÁNGULO ABIERTO BILATERAL DEBIDO A TRASTORNO VASCULAR OCULAR"
  },
  {
    "codigo":11835431000119106,
    "descripcion":"SUBLUXACIÓN DE ARTICULACIÓN INTERFALÁNGICA DE SEGUNDO A QUINTO DEDOS DE PIE DERECHO"
  },
  {
    "codigo":23669005,
    "descripcion":"RUIDO DE EYECCIÓN PULMONAR"
  },
  {
    "codigo":120871000119108,
    "descripcion":"INSUFICIENCIA CARDÍACA SISTÓLICA, ESTADIO B"
  },
  {
    "codigo":285813007,
    "descripcion":"CAPAZ DE ABIR Y CERRAR CANILLAS"
  },
  {
    "codigo":447818004,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE FLANCO"
  },
  {
    "codigo":54602006,
    "descripcion":"APNEA POR SUCCINILCOLINA"
  },
  {
    "codigo":283978008,
    "descripcion":"QUEMADURA DE LA VULVA"
  },
  {
    "codigo":340161000119104,
    "descripcion":"QUERATOCONO ESTABLE DE OJO IZQUIERDO"
  },
  {
    "codigo":773663004,
    "descripcion":"SÍNDROME DE OBESIDAD INFANTIL DE INICIO TEMPRANO, DISFUNCIÓN HIPOTALÁMICA, HIPOVENTILACIÓN Y DESREGULACIÓN AUTÓNOMA"
  },
  {
    "codigo":52767006,
    "descripcion":"HIPOGLUCEMIA NEONATAL"
  },
  {
    "codigo":249375007,
    "descripcion":"DEFECTO EN PARED DE SENO FRONTAL"
  },
  {
    "codigo":247540000,
    "descripcion":"MUDA DE PELO"
  },
  {
    "codigo":708127008,
    "descripcion":"GLOMERULOPATÍA COLAGENOFIBRÓTICA"
  },
  {
    "codigo":704457000,
    "descripcion":"FRACTURA METAFISARIA EXPUESTA DE TERCER METATARSIANO"
  },
  {
    "codigo":737225007,
    "descripcion":"SÍNDROME PSICÓTICO SECUNDARIO CON ALUCINACIONES E IDEAS DELIRANTES"
  },
  {
    "codigo":473246002,
    "descripcion":"QUEMADURA DE REGIÓN OCULAR CON QUEMADURA DE TERCER GRADO DE CARA"
  },
  {
    "codigo":276638004,
    "descripcion":"HIPOXIA FETAL"
  },
  {
    "codigo":735390005,
    "descripcion":"RESORCIÓN DE SUPERFICIE DE DIENTE"
  },
  {
    "codigo":243870004,
    "descripcion":"SITUACIÓN DEL MONITOREO DE TRASTORNO OTORRINOLARINGOLÓGICO"
  },
  {
    "codigo":15632731000119103,
    "descripcion":"EXOTROPÍA DE OJO DERECHO"
  },
  {
    "codigo":309406008,
    "descripcion":"SITUACIÓN DE CRIBADO PARA DETECCIÓN DE VIRUS"
  },
  {
    "codigo":209267001,
    "descripcion":"FRACTURA-LUXACIÓN NO EXPUESTA DE ARTICULACIÓN MEDIOCARPIANA"
  },
  {
    "codigo":373107005,
    "descripcion":"PACIENTE LUEGO DE UNA ANGIOGRAFÍA"
  },
  {
    "codigo":45427005,
    "descripcion":"VIGOR DE UN HÍBRIDO"
  },
  {
    "codigo":405875007,
    "descripcion":"FENOTIPO M+"
  },
  {
    "codigo":830024000,
    "descripcion":"QUISTE DERMOIDE DE CONJUNTIVA DE LIMBO OCULAR"
  },
  {
    "codigo":404040002,
    "descripcion":"TUMOR MALIGNO TIPO TRITÓN"
  },
  {
    "codigo":305736005,
    "descripcion":"ATENDIDO POR ENFERMERA A CARGO DEL RASTREO DE CONTACTOS"
  },
  {
    "codigo":698952009,
    "descripcion":"TRASTORNO DISOCIATIVO EN REMISIÓN"
  },
  {
    "codigo":205597002,
    "descripcion":"PELO DE TAENZER"
  },
  {
    "codigo":402205005,
    "descripcion":"DERMATITIS SEBORREICA ERITRODÉRMICA"
  },
  {
    "codigo":271133008,
    "descripcion":"AMPOLLA TRAUMÁTICA DE LA PARED TORÁCICA, INFECTADA"
  },
  {
    "codigo":302066004,
    "descripcion":"HALLAZGO RELACIONADO CON EL ASPECTO DE LA GLÁNDULA TIROIDES"
  },
  {
    "codigo":236530006,
    "descripcion":"ESTENOSIS PULMONAR Y NEFROSIS CONGÉNITA"
  },
  {
    "codigo":726215000,
    "descripcion":"LESIÓN TRAUMÁTICA DE BOLSA SEROSA DE MUSLO"
  },
  {
    "codigo":1186802008,
    "descripcion":"NEUROPATÍA DEBIDA A OBESIDAD"
  },
  {
    "codigo":365767001,
    "descripcion":"NIVEL DE ENZIMA - HALLAZGO"
  },
  {
    "codigo":201927008,
    "descripcion":"ENFERMEDAD DE KASHIN-BECK DE TOBILLO Y\/O PIE"
  },
  {
    "codigo":5319009,
    "descripcion":"INTOXICACIÓN CAUSADA POR TEOBROMINA"
  },
  {
    "codigo":396700001,
    "descripcion":"SUBUNIDAD BETA DE GONADOTROFINA CORIÓNICA HUMANA SÉRICA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":69020003,
    "descripcion":"SUEÑO DE MOVIMIENTOS OCULARES RÁPIDOS ANORMAL"
  },
  {
    "codigo":165489000,
    "descripcion":"ERITROCITOS POLICROMÁTICOS"
  },
  {
    "codigo":298396009,
    "descripcion":"DEFORMIDAD DE VÉRTEBRA CERVICAL"
  },
  {
    "codigo":167324009,
    "descripcion":"UROBILINÓGENO EN ORINA: TRAZAS"
  },
  {
    "codigo":296561004,
    "descripcion":"SOBREDOSIS DE PRIMAQUINA"
  },
  {
    "codigo":34417008,
    "descripcion":"COAGULACIÓN INTRAVASCULAR DISEMINADA EN EL RECIÉN NACIDO"
  },
  {
    "codigo":32582007,
    "descripcion":"OOFORITIS CRÓNICA"
  },
  {
    "codigo":292891000,
    "descripcion":"REACCIÓN ADVERSA A LA CLORHEXIDINA"
  },
  {
    "codigo":1179462007,
    "descripcion":"UREA EN SANGRE POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1144859006,
    "descripcion":"APLASIA DE HUESO DE ESQUELETO AXIAL"
  },
  {
    "codigo":129051008,
    "descripcion":"NECESITA ASISTENCIA PARA REALIZAR TAREAS DOMÉSTICAS"
  },
  {
    "codigo":94448002,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL LÓBULO OCCIPITAL"
  },
  {
    "codigo":225520003,
    "descripcion":"MONÓGAMO"
  },
  {
    "codigo":1079951000119106,
    "descripcion":"NEVO EPIDÉRMICO DE MIEMBRO SUPERIOR DERECHO"
  },
  {
    "codigo":291056006,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR BROMAZEPAM"
  },
  {
    "codigo":92613002,
    "descripcion":"CARCINOMA IN SITU DE ÍLEON"
  },
  {
    "codigo":289221004,
    "descripcion":"DURACIÓN NORMAL DE LA SEGUNDA ETAPA DEL TRABAJO DE PARTO"
  },
  {
    "codigo":58010002,
    "descripcion":"AUSENCIA CONGÉNITA DE TIBIA Y PERONÉ"
  },
  {
    "codigo":254618003,
    "descripcion":"TUMOR DE VÍAS RESPIRATORIAS INFERIORES"
  },
  {
    "codigo":713370005,
    "descripcion":"HEPATOPATÍA ALCOHÓLICA CRÓNICA REAGUDIZADA"
  },
  {
    "codigo":1303194007,
    "descripcion":"INFECCIÓN DE HUESO DE MANO ASOCIADA CON DISPOSITIVO DE FIJACIÓN INTERNA"
  },
  {
    "codigo":285551002,
    "descripcion":"NO ELEVA EL PALADAR BLANDO"
  },
  {
    "codigo":23407003,
    "descripcion":"PIE PLANO CONGÉNITO"
  },
  {
    "codigo":711535003,
    "descripcion":"ESCHERICHIA COLI PRODUCTORA DE BETA LACTAMASA DE ESPECTRO EXTENDIDO AISLADA EN ESPUTO POR CULTIVO"
  },
  {
    "codigo":1137519006,
    "descripcion":"CALCIFICACIÓN PUNTEADA DE EPÍFISIS DE FALANGE DE DEDO GORDO"
  },
  {
    "codigo":88943008,
    "descripcion":"SÍFILIS DE LOS MÚSCULOS"
  },
  {
    "codigo":185412005,
    "descripcion":"CITA SOLICITADA POR EL PADRE"
  },
  {
    "codigo":87108006,
    "descripcion":"CALAMBRE POR CALOR"
  },
  {
    "codigo":250948007,
    "descripcion":"SANGRE ESTANCADA ECOGÉNICA EN EL VENTRÍCULO DERECHO"
  },
  {
    "codigo":283716006,
    "descripcion":"MORDEDURA HUMANA EN EL PERINEO"
  },
  {
    "codigo":249113001,
    "descripcion":"CABEZA PARCIALMENTE ENCAJADA"
  },
  {
    "codigo":10965801000119106,
    "descripcion":"HERIDA PUNZANTE DE DEDOS SEGUNDO A QUINTO DE PIE IZQUIERDO"
  },
  {
    "codigo":1363225004,
    "descripcion":"CICATRIZACIÓN DE AMBOS PÁRPADOS SUPERIORES"
  },
  {
    "codigo":609561005,
    "descripcion":"DIABETES MELLITUS SEMEJANTE A LA DE COMIENZO EN LA MADUREZ EN PERSONA JOVEN"
  },
  {
    "codigo":85273005,
    "descripcion":"ALTERACIÓN EN EL TRANSPORTE INTESTINAL DE GRASAS A TRAVÉS DE LAS CÉLULAS EPITELIALES"
  },
  {
    "codigo":314649008,
    "descripcion":"PERÍMETRO CEFÁLICO DEL NIÑO: PERCENTILO 10-24"
  },
  {
    "codigo":1230318000,
    "descripcion":"CARCINOMA SEROSO DE CUERPO DE ÚTERO"
  },
  {
    "codigo":247278002,
    "descripcion":"CABEZA DEL ESTRIBO AISLADA"
  },
  {
    "codigo":214510002,
    "descripcion":"ACCIDENTE DE TRÁNSITO DE VEHÍCULO CON MOTOR SIN COLISIÓN, CON INTOXICACIÓN ACCIDENTAL PRODUCIDA POR GASES DE ESCAPE GENERADOS POR EL VEHÍCULO CON MOTOR EN MOVIMIENTO, JINETE U OCUPANTE DE VEHÍCULO CON TRACCIÓN A SANGRE LESIONADO"
  },
  {
    "codigo":350081000221108,
    "descripcion":"ENVENENAMIENTO CAUSADO POR VENENO DE LEPIDÓPTERO"
  },
  {
    "codigo":17902004,
    "descripcion":"DIETA PARA HIPERLIPOPROTEINEMIA, TIPO IIB Y III"
  },
  {
    "codigo":442051003,
    "descripcion":"TRASTORNO ADQUIRIDO DEL PROCESAMIENTO AUDITIVO"
  },
  {
    "codigo":47000000,
    "descripcion":"MIELITIS TRANSVERSA AGUDA"
  },
  {
    "codigo":735128000,
    "descripcion":"EX-FUMADOR DURANTE MENOS DE 1 AÑO"
  },
  {
    "codigo":210840002,
    "descripcion":"CONTUSIÓN, ARTERIA CUBITAL"
  },
  {
    "codigo":1259416004,
    "descripcion":"ADENOCARCINOMA SEBÁCEO PRIMARIO"
  },
  {
    "codigo":702360007,
    "descripcion":"SORDERA CONGÉNITA CON APLASIA LABERÍNTICA, MICROTIA Y MICRODONCIA"
  },
  {
    "codigo":14232007,
    "descripcion":"MENINGITIS POR CRIPTOCOCOS"
  },
  {
    "codigo":307309005,
    "descripcion":"INSUFICIENCIA RENAL AGUDA TRANSITORIA"
  },
  {
    "codigo":733293006,
    "descripcion":"MORDEDURA ABIERTA DE PIERNA"
  },
  {
    "codigo":698690001,
    "descripcion":"TRASTORNO DE LA PERSONALIDAD DE EVITACIÓN EN REMISIÓN"
  },
  {
    "codigo":305474001,
    "descripcion":"BAJO ATENCIÓN DE MÉDICO ESPECIALISTA EN TÓRAX"
  },
  {
    "codigo":76098004,
    "descripcion":"DISPLASIA FIBROSA DE LA MANDÍBULA"
  },
  {
    "codigo":1255746006,
    "descripcion":"HISTIOCITOSIS MALIGNA DE GANGLIOS LINFÁTICOS DE CABEZA"
  },
  {
    "codigo":41495000,
    "descripcion":"POROQUERATOSIS ACTÍNICA SUPERFICIAL DISEMINADA"
  },
  {
    "codigo":239938009,
    "descripcion":"ARTERITIS DE CÉLULAS GIGANTES CON POLIMIALGIA REUMÁTICA"
  },
  {
    "codigo":10562009,
    "descripcion":"HIPERTENSIÓN MALIGNA QUE COMPLICA EL PARTO Y\/O CONSTITUYE UN MOTIVO DE ATENCIÓN DURANTE ESTE PROCEDIMIENTO"
  },
  {
    "codigo":238103003,
    "descripcion":"SÍNDROME TIPO EXOFTÁLMICO, VARIANTE DE PROTEÍNA APO AI"
  },
  {
    "codigo":860695004,
    "descripcion":"ALERGIA A COMPONENTE DE VACUNA QUE CONTIENE ANTÍGENO DE NEISSERIA MENINIGITIDIS"
  },
  {
    "codigo":345181000119104,
    "descripcion":"ÚLCERA MARGINAL BILATERAL DE CÓRNEA"
  },
  {
    "codigo":762391009,
    "descripcion":"EFLUVIO ANÁGENO CAUSADO POR FÁRMACO"
  },
  {
    "codigo":400108007,
    "descripcion":"LIQUEN PLANO DE PLIEGUES"
  },
  {
    "codigo":203500008,
    "descripcion":"SEUDOARTROSIS ATRÓFICA DE FRACTURA"
  },
  {
    "codigo":39660007,
    "descripcion":"INFECCIÓN CAUSADA POR PLATYNOSOMUM CONCINNUM"
  },
  {
    "codigo":431041003,
    "descripcion":"MASA DE ARTICULACIÓN DE MUÑECA"
  },
  {
    "codigo":299969005,
    "descripcion":"DISPEPSIA CAUSADA POR MEDICAMENTOS"
  },
  {
    "codigo":234433009,
    "descripcion":"DEFICIENCIA DE MIELOPEROXIDASA"
  },
  {
    "codigo":1217473009,
    "descripcion":"ALTA CARGA MUTACIONAL DE TUMOR"
  },
  {
    "codigo":568111000005107,
    "descripcion":"ANTICUERPO DE GRUPO SANGUÍNEO IRREGULAR NO DETECTADO"
  },
  {
    "codigo":365505009,
    "descripcion":"DETALLES RELACIONADOS CON LAS INSTALACIONES Y COMODIDADES LOCALES - HALLAZGO"
  },
  {
    "codigo":10640631000119103,
    "descripcion":"ÚLCERA NEUROPÁTICA DE PIERNA DERECHA"
  },
  {
    "codigo":722283003,
    "descripcion":"SÍNDROME DE AGNATIA, HOLOPROSENCEFALIA Y SITUS INVERSUS"
  },
  {
    "codigo":66923004,
    "descripcion":"FLEGMASIA ALBA DOLENS"
  },
  {
    "codigo":230763008,
    "descripcion":"EDEMA CEREBRAL TRAUMÁTICO"
  },
  {
    "codigo":1387009,
    "descripcion":"INTOXICACIÓN POR SOLANUM NIGRUM"
  },
  {
    "codigo":720448006,
    "descripcion":"ALETEO AURICULAR TÍPICO"
  },
  {
    "codigo":294464008,
    "descripcion":"ALERGIA A KANAMICINA"
  },
  {
    "codigo":15637751000119107,
    "descripcion":"HIPERPLASIA ATÍPICA DE CONDUCTOS GALACTÓFOROS DE AMBAS MAMAS"
  },
  {
    "codigo":292629008,
    "descripcion":"REACCIÓN ADVERSA A PREPARADOS DE ALQUITRÁN MINERAL PARA EL BAÑO"
  },
  {
    "codigo":63253009,
    "descripcion":"FÍSTULA RECTOVESTIBULAR CONGÉNITA"
  },
  {
    "codigo":94186002,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE VEJIGA"
  },
  {
    "codigo":126954003,
    "descripcion":"NEOPLASIA DEL LÓBULO FRONTAL"
  },
  {
    "codigo":15693201000119102,
    "descripcion":"QUERATITIS DE AMBOS OJOS CAUSADA POR ACANTHAMOEBA"
  },
  {
    "codigo":421866006,
    "descripcion":"TRASTORNO DE LA EPIESCLERÓTICA"
  },
  {
    "codigo":389098007,
    "descripcion":"ENCEFALOPATÍA ANÓXICA"
  },
  {
    "codigo":1306602006,
    "descripcion":"NEUMONITIS POR ASPIRACIÓN DEBIDA A PREAHOGAMIENTO"
  },
  {
    "codigo":288959006,
    "descripcion":"INCAPAZ DE TRAGAR SALIVA"
  },
  {
    "codigo":57748001,
    "descripcion":"ÚLCERA SANGRANTE DE ESÓFAGO"
  },
  {
    "codigo":92351009,
    "descripcion":"NEOPLASIA BENIGNA DE LA PIEL DE LA MEJILLA"
  },
  {
    "codigo":385428003,
    "descripcion":"OSTEOCONDROMA DE FÉMUR"
  },
  {
    "codigo":1335700004,
    "descripcion":"NECROSIS AVASCULAR DE CÚBITO"
  },
  {
    "codigo":90516007,
    "descripcion":"QUISTE NASOLABIAL"
  },
  {
    "codigo":449129007,
    "descripcion":"FIEBRE PARANEOPLÁSICA"
  },
  {
    "codigo":292241000119108,
    "descripcion":"NEUROMA DE MORTON EN PIE DERECHO"
  },
  {
    "codigo":1268329009,
    "descripcion":"FRACTURA DE HUESO ADYACENTE A PRÓTESIS DE ARTICULACIÓN DE TOBILLO"
  },
  {
    "codigo":250686001,
    "descripcion":"ALFA-1-ANTITRIPSINA, FENOTIPO PIZZ"
  },
  {
    "codigo":283454005,
    "descripcion":"HERIDA PUNZANTE EN LA MEJILLA"
  },
  {
    "codigo":840510006,
    "descripcion":"AUSENCIA CONGÉNITA DE EPIGLOTIS"
  },
  {
    "codigo":1332030006,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE TENDÓN FLEXOR DE PIE"
  },
  {
    "codigo":41231000087100,
    "descripcion":"HEMATOMA DE REGIÓN DE CODO IZQUIERDO"
  },
  {
    "codigo":445459004,
    "descripcion":"ANTICUERPO ANTI-CITOMEGALOVIRUS DETECTADO EN SUERO"
  },
  {
    "codigo":773139006,
    "descripcion":"ANOMALÍA CONGÉNITA DE VENTRÍCULO CARDÍACO"
  },
  {
    "codigo":30991000087103,
    "descripcion":"MICROBIOTA NORMAL DE LA OROFARINGE"
  },
  {
    "codigo":248851007,
    "descripcion":"HIMEN ROTO"
  },
  {
    "codigo":738536002,
    "descripcion":"METABOLIZADOR LENTO DE MIEMBRO A1 DE LA FAMILIA 1 DE URIDINA DIFOSFATO GLUCURONOSILTRANSFERASA"
  },
  {
    "codigo":46351000087109,
    "descripcion":"DERMATITIS DE CONTACTO DE MANO IZQUIERDA"
  },
  {
    "codigo":43791000087109,
    "descripcion":"TRASTORNO DE TENDÓN DE REGIÓN DE MUÑECA DERECHA"
  },
  {
    "codigo":83176005,
    "descripcion":"DISTIMIA PRIMARIA"
  },
  {
    "codigo":771304005,
    "descripcion":"HEMIPLEJÍA ALTERNANTE NOCTURNA BENIGNA DE LA INFANCIA"
  },
  {
    "codigo":277949001,
    "descripcion":"MALFORMACIÓN COMBINADA DEL SISTEMA NERVIOSO CENTRAL Y MÚSCULO"
  },
  {
    "codigo":15805002,
    "descripcion":"SINUSITIS AGUDA"
  },
  {
    "codigo":1084971000119107,
    "descripcion":"COLECISTITIS CRÓNICA DEBIDA A CÁLCULO DE VESÍCULA CON OBSTRUCCIÓN"
  },
  {
    "codigo":703933003,
    "descripcion":"ALERGIA A PROTEÍNA DE DERMATOPHAGOIDES PTERONYSSINUS"
  },
  {
    "codigo":1197288009,
    "descripcion":"NEOPLASIA ESCAMOSA INTRAEPITELIAL DE ESÓFAGO DE ALTO GRADO"
  },
  {
    "codigo":48573006,
    "descripcion":"LINFADENOPATÍA SUPURATIVA"
  },
  {
    "codigo":675371000119109,
    "descripcion":"IRIDOCICLITIS SUBAGUDA DE OJO IZQUIERDO"
  },
  {
    "codigo":439954005,
    "descripcion":"ALERGIA A TIAZOLIDINADIONA"
  },
  {
    "codigo":308882008,
    "descripcion":"ÚLCERA SANGRANTE DE ESTÓMAGO POR ESTRÉS"
  },
  {
    "codigo":700263000,
    "descripcion":"ELEFANTIASIS DE PÁRPADO INFERIOR"
  },
  {
    "codigo":733031004,
    "descripcion":"SÍNDROME DE EPILEPSIA, MICROCEFALIA Y DISPLASIA ESQUELÉTICA"
  },
  {
    "codigo":1290087006,
    "descripcion":"NEOPLASIA NEUROENDOCRINA DE COLON ASCENDENTE"
  },
  {
    "codigo":274279008,
    "descripcion":"DOLOR RENAL"
  },
  {
    "codigo":403516008,
    "descripcion":"TELANGIECTASIA ASOCIADA CON ESCLERODERMIA"
  },
  {
    "codigo":205073001,
    "descripcion":"DEFORMIDAD CONGÉNITA COMPLEJA DE PIE EQUINOVARO"
  },
  {
    "codigo":8465005,
    "descripcion":"HEMORRAGIA DE LA VESÍCULA SEMINAL"
  },
  {
    "codigo":303377005,
    "descripcion":"DIFICULTAD PARA TOMAR UNA POSICIÓN"
  },
  {
    "codigo":237841006,
    "descripcion":"HIPEROSMOLALIDAD CON HIPERNATREMIA"
  },
  {
    "codigo":236006000,
    "descripcion":"ASCITIS DE CAUSA METABÓLICA"
  },
  {
    "codigo":270609009,
    "descripcion":"INFORME POSTMORTEM DEL CIRUJANO POLICIAL RECIBIDO"
  },
  {
    "codigo":301542000,
    "descripcion":"DIFICULTAD PARA SENTARSE Y LEVANTARSE DEL INODORO"
  },
  {
    "codigo":203238006,
    "descripcion":"INFECCIÓN DE METATARSIANO"
  },
  {
    "codigo":185294007,
    "descripcion":"ATENDIDO POR MÉDICO ESPECIALISTA EN FORMACIÓN"
  },
  {
    "codigo":1217211002,
    "descripcion":"SÍNDROME DE TAQUICARDIA ORTOSTÁTICA POSTURAL DEBIDO A DEFICIENCIA DE TRANSPORTADOR DE NORADRENALINA"
  },
  {
    "codigo":823995004,
    "descripcion":"PIEL BRILLANTE SOBRE LESIÓN"
  },
  {
    "codigo":168635006,
    "descripcion":"RADIOGRAFÍA SIMPLE DE HÚMERO NORMAL"
  },
  {
    "codigo":365243008,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD DE REALIZAR TAREAS RELACIONADAS CON LA ALIMENTACIÓN"
  },
  {
    "codigo":234171009,
    "descripcion":"HIPOTENSIÓN INDUCIDA POR FÁRMACOS"
  },
  {
    "codigo":266939009,
    "descripcion":"RESIDE EN UNA HOSTERÍA"
  },
  {
    "codigo":35728003,
    "descripcion":"MIOCARDIOPATÍA FAMILIAR"
  },
  {
    "codigo":723856003,
    "descripcion":"SARCOMA DE EWING PRIMARIO DE CARTÍLAGO ARTICULAR DE COSTILLA"
  },
  {
    "codigo":68496003,
    "descripcion":"PÓLIPO DE COLON"
  },
  {
    "codigo":363408006,
    "descripcion":"NEOPLASIA MALIGNA DE COLON TRANSVERSO"
  },
  {
    "codigo":263269000,
    "descripcion":"SÍNDROME COMPARTIMENTAL DE PIERNA DEBIDO A LESIÓN TRAUMÁTICA"
  },
  {
    "codigo":296037002,
    "descripcion":"SOBREDOSIS DE AMILOBARBITAL"
  },
  {
    "codigo":1125006,
    "descripcion":"SEPSIS DURANTE EL TRABAJO DE PARTO"
  },
  {
    "codigo":164965006,
    "descripcion":"PRUEBA DE SUSCEPTIBILIDAD CUTÁNEA NORMAL"
  },
  {
    "codigo":11845471000119108,
    "descripcion":"LESIÓN TRAUMÁTICA DE VENA YUGULAR EXTERNA IZQUIERDA"
  },
  {
    "codigo":1344613009,
    "descripcion":"EVENTRACIÓN RECURRENTE"
  },
  {
    "codigo":33893009,
    "descripcion":"TUBERCULOSIS CUTIS VERRUGOSA"
  },
  {
    "codigo":785722006,
    "descripcion":"OBESIDAD DEBIDA A DEFICIENCIA DEL GEN DEL RECEPTOR DE LEPTINA"
  },
  {
    "codigo":128527000,
    "descripcion":"TRASTORNO DE MÚSCULO LISO"
  },
  {
    "codigo":64826008,
    "descripcion":"VOLUMEN SANGUÍNEO NORMAL"
  },
  {
    "codigo":425274008,
    "descripcion":"RESPUESTA ANORMAL AL SONIDO"
  },
  {
    "codigo":292367001,
    "descripcion":"REACCIÓN ADVERSA A LA DICLORALFENAZONA"
  },
  {
    "codigo":414600000,
    "descripcion":"UVEÍTIS ANTERIOR LEPROMATOSA"
  },
  {
    "codigo":30223005,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE LA PARED TORÁCICA, CON INFECCIÓN"
  },
  {
    "codigo":423439006,
    "descripcion":"PATRÓN DE SUEÑO QUE ALTERA LA VIDA FAMILIAR"
  },
  {
    "codigo":194063006,
    "descripcion":"TRASTORNO DE VÍA ÓPTICA POR NEOPLASIA"
  },
  {
    "codigo":1144335008,
    "descripcion":"HALLAZGO RELACIONADO CON LA FRENTE"
  },
  {
    "codigo":224996000,
    "descripcion":"CRECIMIENTO APROPIADO"
  },
  {
    "codigo":458042009,
    "descripcion":"TORACÓPAGOS CON AURÍCULAS UNIDAS"
  },
  {
    "codigo":126692004,
    "descripcion":"NEOPLASIA DE LA LARINGE"
  },
  {
    "codigo":716516004,
    "descripcion":"UTILIZA APOYO RESPIRATORIO PARA LA VOZ"
  },
  {
    "codigo":515027091000119100,
    "descripcion":"VÁRICES DE RECTO"
  },
  {
    "codigo":28388008,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DEL TRONCO, SIN INFECCIÓN"
  },
  {
    "codigo":290532008,
    "descripcion":"INTOXICACIÓN POR CINCOCAÍNA"
  },
  {
    "codigo":92089006,
    "descripcion":"NEOPLASIA BENIGNA DE LA EPIGLOTIS"
  },
  {
    "codigo":677881000119108,
    "descripcion":"PSEUDOAGUJERO MACULAR BILATERAL"
  },
  {
    "codigo":288697008,
    "descripcion":"SE COMUNICA CON DIFERENTES PERSONAS"
  },
  {
    "codigo":254094003,
    "descripcion":"DISPLASIA CON COMPROMISO SIGNIFICATIVO DE LA MEMBRANA ÓSEA"
  },
  {
    "codigo":1237134008,
    "descripcion":"VENA VARICOSA DE PIERNA CONCOMITANTE CON ECCEMA Y ÚLCERA VARICOSOS"
  },
  {
    "codigo":417934009,
    "descripcion":"MOVIMIENTO ABDOMINAL REDUCIDO"
  },
  {
    "codigo":22883003,
    "descripcion":"FÍSTULA ENTÉRICA - ARTERIAL"
  },
  {
    "codigo":448867004,
    "descripcion":"LINFOMA NO HODGKIN DIFUSO DE PULMÓN"
  },
  {
    "codigo":416099005,
    "descripcion":"NO SE REQUIERE EXTENDIDO CERVICAL - AUSENCIA DE ÚTERO"
  },
  {
    "codigo":447032001,
    "descripcion":"XANTOGRANULOMATOSIS SUBCUTÁNEA"
  },
  {
    "codigo":283192003,
    "descripcion":"ANZUELO EN LA CABEZA"
  },
  {
    "codigo":250424006,
    "descripcion":"PRUEBA DE EMBARAZO DÉBILMENTE POSITIVA"
  },
  {
    "codigo":711271000124103,
    "descripcion":"SINOVITIS CRÓNICA DE RODILLA IZQUIERDA DEBIDA A HEMARTROSIS"
  },
  {
    "codigo":217656007,
    "descripcion":"ENVENENAMIENTO CAUSADO POR VENENO DE BÚNGARO"
  },
  {
    "codigo":1002253002,
    "descripcion":"SERIE DE VACUNACIÓN INCOMPLETA"
  },
  {
    "codigo":19213003,
    "descripcion":"ENFERMEDAD DIARREICA INFECCIOSA"
  },
  {
    "codigo":281357005,
    "descripcion":"POLIMIOSITIS IDIOPÁTICA"
  },
  {
    "codigo":707341005,
    "descripcion":"HEPATITIS VIRAL, TIPO D"
  },
  {
    "codigo":248589007,
    "descripcion":"ACLARAMIENTO DE GARGANTA - CARRASPEO"
  },
  {
    "codigo":445197008,
    "descripcion":"ALTERACIÓN DE LA COLORACIÓN CUTÁNEA, BLANCA"
  },
  {
    "codigo":838413005,
    "descripcion":"AGUDEZA VISUAL CON AGUJERO ESTENOPEICO DE OJO IZQUIERDO 6\/18"
  },
  {
    "codigo":246754001,
    "descripcion":"HIPOFORIA INCOMITANTE"
  },
  {
    "codigo":310455000,
    "descripcion":"INFORME MÉDICO SOLICITADO"
  },
  {
    "codigo":441527004,
    "descripcion":"PATRÓN DE USO NOCIVO DE ESTIMULANTE"
  },
  {
    "codigo":79244005,
    "descripcion":"PREESPONDILOLISTESIS LUMBOSACRA"
  },
  {
    "codigo":44641000,
    "descripcion":"ANEMIA HEMOLÍTICA NO ESFEROCÍTICA HEREDITARIA POR DEFICIENCIA DE TRIOSAFOSFATO ISOMERASA"
  },
  {
    "codigo":208481005,
    "descripcion":"FRACTURA EXPUESTA DE FALANGE PROXIMAL DE DEDO DE LA MANO, CABEZA"
  },
  {
    "codigo":306785007,
    "descripcion":"ESTOMATITIS NECROSANTE AGUDA"
  },
  {
    "codigo":1255222000,
    "descripcion":"APENDICITIS CRÓNICA PERFORADA"
  },
  {
    "codigo":110177009,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO DE REGIÓN PREAURICULAR DE LA CARA"
  },
  {
    "codigo":1156918005,
    "descripcion":"NO INMUNE A TOS FERINA"
  },
  {
    "codigo":403254007,
    "descripcion":"HIPERMELANOSIS POR ACROMEGALIA"
  },
  {
    "codigo":370486009,
    "descripcion":"COMPRESIÓN INTESTINAL"
  },
  {
    "codigo":352711000119104,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE ÓRBITA DERECHA"
  },
  {
    "codigo":73739006,
    "descripcion":"GOLPETEO CON LOS PIES"
  },
  {
    "codigo":301280000,
    "descripcion":"SIGNO RESPIRATORIO TORÁCICO CON NOMBRE PROPIO"
  },
  {
    "codigo":268512000,
    "descripcion":"ADMINISTRACIÓN DE OXÍGENO EN EL DOMICILIO"
  },
  {
    "codigo":792800001,
    "descripcion":"PULSO EN ARTERIA TIBIAL POSTERIOR DERECHA PRESENTE"
  },
  {
    "codigo":202976000,
    "descripcion":"LUXACIÓN DE TENDÓN DE MUÑECA O MANO"
  },
  {
    "codigo":237579008,
    "descripcion":"ANOMALÍA DE LA SECRECIÓN PANCREÁTICA DE POLIPÉPTIDOS"
  },
  {
    "codigo":432352001,
    "descripcion":"NIVEL DE CREATINA QUINASA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":399584006,
    "descripcion":"FIMBRIAS DE TROMPA DE FALOPIO IZQUIERDA CERRADAS"
  },
  {
    "codigo":397749000,
    "descripcion":"ASPECTO DE BUEN CUIDADO"
  },
  {
    "codigo":299445000,
    "descripcion":"ARTICULACIÓN DE TOBILLO ESTABLE"
  },
  {
    "codigo":233909000,
    "descripcion":"TAQUICARDIA VENTRICULAR DEL TRACTO DE SALIDA DEL VENTRÍCULO DERECHO"
  },
  {
    "codigo":102837003,
    "descripcion":"CILINDRO URINARIO, CÉREO"
  },
  {
    "codigo":364981004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD DE REALIZAR LA PRENSIÓN CON PRONACIÓN DE MUÑECA"
  },
  {
    "codigo":201141003,
    "descripcion":"ALOPECIA NEURÓTICA"
  },
  {
    "codigo":232074003,
    "descripcion":"HIPERTROFIA CONGÉNITA DEL EPITELIO PIGMENTARIO RETINIANO"
  },
  {
    "codigo":15999431000119109,
    "descripcion":"QUERATOPATÍA DE OJO IZQUIERDO MEDICAMENTOSA"
  },
  {
    "codigo":123656005,
    "descripcion":"ATRESIA DE VÁLVULA CARDÍACA"
  },
  {
    "codigo":199306007,
    "descripcion":"CONTINUACIÓN DEL EMBARAZO LUEGO DEL ABORTO ESPONTÁNEO DE UNO O MÁS FETOS"
  },
  {
    "codigo":230239001,
    "descripcion":"ATAXIA CEREBELOSA PROGRESIVA CON MIOCLONÍA PALATINA"
  },
  {
    "codigo":295775003,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE TRILOSTANO"
  },
  {
    "codigo":33631007,
    "descripcion":"PIONEUMOTÓRAX"
  },
  {
    "codigo":15727201000119105,
    "descripcion":"HIPERLAXITUD ARTICULAR DE AMBAS RODILLAS"
  },
  {
    "codigo":721759009,
    "descripcion":"INFECCIÓN CAUSADA POR BIFIDOBACTERIUM"
  },
  {
    "codigo":718089001,
    "descripcion":"INSUFICIENCIA RESPIRATORIA AGUDA QUE REQUIERE REINTUBACIÓN DESPUÉS DE LA EXTUBACIÓN"
  },
  {
    "codigo":292105002,
    "descripcion":"REACCIÓN ADVERSA AL MISOPROSTOL"
  },
  {
    "codigo":293940009,
    "descripcion":"ALERGIA A PROCLORPERAZINA"
  },
  {
    "codigo":16218721000119107,
    "descripcion":"HIPERPARATIROIDISMO DEBIDO A ENFERMEDAD RENAL EN ESTADIO TERMINAL EN DIÁLISIS"
  },
  {
    "codigo":95497002,
    "descripcion":"DISPLASIA RETINIANA DIFUSA"
  },
  {
    "codigo":128265008,
    "descripcion":"TRASTORNO DE LOS GANGLIOS LINFÁTICOS DE LA CABEZA"
  },
  {
    "codigo":191966002,
    "descripcion":"PRURITO PSICÓGENO"
  },
  {
    "codigo":290270006,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR KETOROLACO"
  },
  {
    "codigo":93662008,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE ADENOIDES"
  },
  {
    "codigo":880094008,
    "descripcion":"TRASTORNO DEL DESARROLLO SEXUAL 46,XY"
  },
  {
    "codigo":1337011003,
    "descripcion":"FRACTURA CONMINUTA NO EXPUESTA DE RÓTULA"
  },
  {
    "codigo":310441000119100,
    "descripcion":"ESCOLIOSIS IDIOPÁTICA INFANTIL DE COLUMNA LUMBAR"
  },
  {
    "codigo":16917161000119101,
    "descripcion":"TRASTORNO DE NERVIO MOTOR OCULAR EXTERNO DERECHO"
  },
  {
    "codigo":653850281000119101,
    "descripcion":"VACUNACIÓN PARCIAL CONTRA COVID-19"
  },
  {
    "codigo":714419007,
    "descripcion":"DIFICULTAD PARA ADOPTAR EL PAPEL DE ENFERMO"
  },
  {
    "codigo":15721641000119100,
    "descripcion":"CONTRACTURA DE ARTICULACIONES DE AMBAS RODILLAS"
  },
  {
    "codigo":15680681000119101,
    "descripcion":"INFECCIÓN DE CONJUNTIVA DE OJO DERECHO"
  },
  {
    "codigo":320681000119102,
    "descripcion":"NEFROPATÍA TUBULOINTERSTICIAL DEBIDA A SÍNDROME DE SJÖGREN"
  },
  {
    "codigo":16097961000119107,
    "descripcion":"ARTROFIBROSIS DE PIE IZQUIERDO"
  },
  {
    "codigo":1075881000119107,
    "descripcion":"TENOSINOVITIS DE MANO IZQUIERDA"
  },
  {
    "codigo":15639721000119105,
    "descripcion":"DOLOR BILATERAL DE ARTICULACIONES TEMPOROMANDIBULARES"
  },
  {
    "codigo":15744681000119109,
    "descripcion":"MASA BILATERAL DE ARTICULACIONES DE MANOS"
  },
  {
    "codigo":417672002,
    "descripcion":"TRASTORNO GRANULOCITOPÉNICO"
  },
  {
    "codigo":113321000119104,
    "descripcion":"ENOSTOSIS DE CÚBITO"
  },
  {
    "codigo":15711401000119105,
    "descripcion":"TROMBOSIS AGUDA DE VENA PROFUNDA DE MIEMBRO INFERIOR IZQUIERDA POSTERIOR A PROCEDIMIENTO"
  },
  {
    "codigo":348841000119107,
    "descripcion":"COLOBOMA ADQUIRIDO DE DISCO ÓPTICO DE OJO IZQUIERDO"
  },
  {
    "codigo":305321000119109,
    "descripcion":"CONTRACTURA DE MÚSCULO DE REGIÓN DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":333481000119107,
    "descripcion":"DEFORMIDAD ORBITARIA DERECHA DEBIDA A ENFERMEDAD ÓSEA"
  },
  {
    "codigo":51881000119109,
    "descripcion":"DOLOR CRÓNICO DE TOBILLO"
  },
  {
    "codigo":712584009,
    "descripcion":"INFERTILIDAD FEMENINA DEBIDA A ENDOMETRIOSIS"
  },
  {
    "codigo":88157006,
    "descripcion":"SALPINGITIS"
  },
  {
    "codigo":186461000,
    "descripcion":"INFECCIÓN CAUSADA POR KLEBSIELLA AEROGENES"
  },
  {
    "codigo":282930002,
    "descripcion":"CAPAZ DE MOVERSE DE POSICIÓN ACOSTADA A SENTADA"
  },
  {
    "codigo":250162004,
    "descripcion":"CALZADO MUY PESADO"
  },
  {
    "codigo":248327008,
    "descripcion":"HALLAZGO GENERAL RELACIONADO CON LA TALLA"
  },
  {
    "codigo":1264135009,
    "descripcion":"ENDOMETRITIS POSTERIOR A EMBARAZO ECTÓPICO"
  },
  {
    "codigo":281095009,
    "descripcion":"ESTRECHEZ CONGÉNITA DEL COLÉDOCO"
  },
  {
    "codigo":836316006,
    "descripcion":"AGUDEZA VISUAL CORREGIDA DE OJO IZQUIERDO 2\/60"
  },
  {
    "codigo":770780007,
    "descripcion":"QUEMADURA DE TERCER GRADO DE PIEL Y TEJIDO CELULAR SUBCUTÁNEO DE LOS LABIOS SUPERIOR E INFERIOR"
  },
  {
    "codigo":328751000119102,
    "descripcion":"EXPOSICIÓN DE IMPLANTE DE MALLA VAGINAL EN VAGINA"
  },
  {
    "codigo":13446000,
    "descripcion":"COPROLALIA"
  },
  {
    "codigo":439430008,
    "descripcion":"CON BAJO RIESGO DE CAÍDAS"
  },
  {
    "codigo":77147000,
    "descripcion":"MALABSORCIÓN EN LOS ANCIANOS"
  },
  {
    "codigo":765275003,
    "descripcion":"INFERTILIDAD MASCULINA CON AZOOSPERMIA DEBIDA A MUTACIÓN DE UN SOLO GEN"
  },
  {
    "codigo":109915008,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LAS MENINGES"
  },
  {
    "codigo":304688001,
    "descripcion":"INCAPAZ DE TOMAR DECISIONES ELABORADAS"
  },
  {
    "codigo":697904001,
    "descripcion":"HIPERTENSIÓN PULMONAR ASOCIADA CON INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":239152005,
    "descripcion":"AUSENCIA CONGÉNITA DE PIEL DEL CUERO CABELLUDO"
  },
  {
    "codigo":1254960008,
    "descripcion":"CONVULSIÓN CONCOMITANTE CON ABSTINENCIA DE SUSTANCIA Y DEBIDA A ELLA"
  },
  {
    "codigo":73477001,
    "descripcion":"HEMONEUMOTÓRAX TRAUMÁTICO CON HERIDA ABIERTA HACIA TÓRAX"
  },
  {
    "codigo":402992008,
    "descripcion":"ACTINOMICOSIS SISTÉMICA CON COMPROMISO CUTÁNEO"
  },
  {
    "codigo":7941002,
    "descripcion":"HERNIA CECAL"
  },
  {
    "codigo":71642004,
    "descripcion":"FRACTURA DE CRÁNEO"
  },
  {
    "codigo":10624201000119103,
    "descripcion":"DERMATITIS ECCEMATOSA DE PÁRPADOS SUPERIOR E INFERIOR IZQUIERDOS"
  },
  {
    "codigo":399322006,
    "descripcion":"SED DE AIRE"
  },
  {
    "codigo":364719000,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA EMPEZAR A CAMINAR"
  },
  {
    "codigo":725167001,
    "descripcion":"NEOPLASIA NEUROENDOCRINA DE APÉNDICE ILEOCECAL"
  },
  {
    "codigo":397487007,
    "descripcion":"ESTADO FUNCIONAL DE TUMOR DEL PÁNCREAS ENDOCRINO, DESCONOCIDO"
  },
  {
    "codigo":102575008,
    "descripcion":"EDEMA DE RODILLA"
  },
  {
    "codigo":35204001,
    "descripcion":"PARAGRAMATISMO"
  },
  {
    "codigo":233647007,
    "descripcion":"QUILOTÓRAX MALIGNO"
  },
  {
    "codigo":788868003,
    "descripcion":"MALFORMACIÓN ARTERIOVENOSA UTERINA"
  },
  {
    "codigo":67972000,
    "descripcion":"VIVIR EN UNA CASA"
  },
  {
    "codigo":723332005,
    "descripcion":"SÍNDROME CON CROMOSOMA 15 ISODICÉNTRICO"
  },
  {
    "codigo":264580006,
    "descripcion":"DISFUNCIÓN TIROIDEA"
  },
  {
    "codigo":231812008,
    "descripcion":"SÍNDROME DE HIPERLAXITUD PALPEBRAL"
  },
  {
    "codigo":787033001,
    "descripcion":"CUERPO EXTRAÑO RETENIDO EN REGIÓN DE LA MUÑECA"
  },
  {
    "codigo":295513000,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE PROPOFOL"
  },
  {
    "codigo":721497005,
    "descripcion":"FRACTURA DE CUARTA VÉRTEBRA LUMBAR"
  },
  {
    "codigo":262745006,
    "descripcion":"AVULSIÓN DE RAÍZ DE NERVIO CERVICAL"
  },
  {
    "codigo":361049005,
    "descripcion":"CONSUMIDOR HABITUAL DE DROGA"
  },
  {
    "codigo":33369008,
    "descripcion":"INFESTACIÓN CAUSADA POR RHIPICEPHALUS"
  },
  {
    "codigo":424750001,
    "descripcion":"CÉLULAS EN ANILLO DE SELLO PRESENTES QUE REPRESENTAN MENOS DEL 50 PORCIENTO DE LAS CÉLULAS MALIGNAS"
  },
  {
    "codigo":719662000,
    "descripcion":"SÍNDROME DE MICRODELECIÓN 6P22"
  },
  {
    "codigo":195374003,
    "descripcion":"INSUFICIENCIA ARTERIAL"
  },
  {
    "codigo":129838004,
    "descripcion":"CON MAYOR RIESGO DE BAJA AUTOESTIMA SITUACIONAL"
  },
  {
    "codigo":391982004,
    "descripcion":"TÓRAX EN EMBUDO CONGÉNITO"
  },
  {
    "codigo":817966005,
    "descripcion":"SÍNDROME DE OBSTRUCCIÓN INTESTINAL DISTAL DEBIDO A FIBROSIS QUÍSTICA"
  },
  {
    "codigo":293678008,
    "descripcion":"ALERGIA A BISACODILO"
  },
  {
    "codigo":1078275001,
    "descripcion":"AGENESIA DE FALANGE PROXIMAL DE TERCER DEDO DE PIE"
  },
  {
    "codigo":816131000,
    "descripcion":"COLOR AMARILLO INTENSO DE MUESTRA DE SANGRE"
  },
  {
    "codigo":291843003,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR NANDROLONA"
  },
  {
    "codigo":717827000,
    "descripcion":"NEUROPATÍA HEREDITARIA SENSITIVA Y AUTONÓMICA CON PARAPLEJÍA ESPÁSTICA"
  },
  {
    "codigo":224472000,
    "descripcion":"ABANDONO DE TRABAJO"
  },
  {
    "codigo":95235009,
    "descripcion":"ARTERIA CARÓTIDA RETROESOFÁGICA"
  },
  {
    "codigo":331261000119100,
    "descripcion":"CUERPO EXTRAÑO RETENIDO EN PÁRPADO INFERIOR IZQUIERDO"
  },
  {
    "codigo":26029002,
    "descripcion":"ENFERMEDAD POR DEFICIENCIA HEREDITARIA LEVE DE FACTOR VIII"
  },
  {
    "codigo":124333004,
    "descripcion":"DEFICIENCIA DE ACETATO CINASA"
  },
  {
    "codigo":1303981006,
    "descripcion":"BLEBITIS CONJUNTIVAL DE OJO IZQUIERDO POSTERIOR A CIRUGÍA DE GLAUCOMA"
  },
  {
    "codigo":58797008,
    "descripcion":"COMPLICACIÓN DE RIÑÓN TRASPLANTADO"
  },
  {
    "codigo":188034001,
    "descripcion":"MELANOMA MALIGNO DE MEATO AUDITIVO EXTERNO"
  },
  {
    "codigo":286338002,
    "descripcion":"CAPAZ DE EMITIR UN VOLUMEN DE VOZ ADECUADO"
  },
  {
    "codigo":24194000,
    "descripcion":"PALADAR HENDIDO BILATERAL COMPLETO"
  },
  {
    "codigo":189869009,
    "descripcion":"HEMANGIOMA EPITELIOIDE"
  },
  {
    "codigo":253570000,
    "descripcion":"DEFECTO INTERVENTRICULAR SUBARTERIAL DOBLE RELACIONADO CON BORDE MUSCULAR POSTEROINFERIOR"
  },
  {
    "codigo":1269378007,
    "descripcion":"SÍNDROME MEDULAR POSTERIOR DE MÉDULA TORÁCICA DEBIDA A LUXACIÓN VERTEBRAL NO EXPUESTA DE COLUMNA TORÁCICA"
  },
  {
    "codigo":186199002,
    "descripcion":"TUBERCULOSIS DE LARINGE, TRÁQUEA Y BRONQUIOS, CON CONFIRMACIÓN BACTERIOLÓGICA E HISTOLÓGICA"
  },
  {
    "codigo":284503003,
    "descripcion":"CONDUCTA EXIGENTE"
  },
  {
    "codigo":415575007,
    "descripcion":"RUPTURA ESPONTÁNEA DE TENDONES FLEXORES"
  },
  {
    "codigo":251735009,
    "descripcion":"CUERPO EXTRAÑO EN ÁNGULO"
  },
  {
    "codigo":315436002,
    "descripcion":"NACIDO EN GUINEA BISSAU"
  },
  {
    "codigo":282668003,
    "descripcion":"NO LANZA"
  },
  {
    "codigo":1003564007,
    "descripcion":"AGENESIA DE CLÍTORIS"
  },
  {
    "codigo":249900008,
    "descripcion":"NO MUEVE NINGUNA DE LAS CUATRO EXTREMIDADES"
  },
  {
    "codigo":18689007,
    "descripcion":"DELIRIO POR INTOXICACIÓN POR INHALANTES"
  },
  {
    "codigo":444673007,
    "descripcion":"HIPEREMESIS"
  },
  {
    "codigo":248065008,
    "descripcion":"AUTOMUTILACIÓN DEL PENE"
  },
  {
    "codigo":410070006,
    "descripcion":"HERNIA VESICAL"
  },
  {
    "codigo":278998008,
    "descripcion":"DOLOR A LA PALPACIÓN EN CICATRIZ"
  },
  {
    "codigo":735915008,
    "descripcion":"TRASTORNO DEBIDO A AMPUTACIÓN DE MIEMBRO Y POSTERIOR A ELLA"
  },
  {
    "codigo":1260203008,
    "descripcion":"SÍNDROME DE DISPLASIA DE EPÍFISIS, VÉRTEBRAS, OÍDOS Y NARIZ MÁS HALLAZGOS ASOCIADOS"
  },
  {
    "codigo":13184001,
    "descripcion":"SEPARADO"
  },
  {
    "codigo":111488004,
    "descripcion":"SÍNDROME DE KLEINE - LEVIN"
  },
  {
    "codigo":699477007,
    "descripcion":"EMPUJE DE LENGUA ANTERIOR"
  },
  {
    "codigo":732245008,
    "descripcion":"MIOPATÍA MITOCONDRIAL PURA"
  },
  {
    "codigo":207957008,
    "descripcion":"FRACTURA NO EXPUESTA DE VÉRTEBRA LUMBAR"
  },
  {
    "codigo":271658004,
    "descripcion":"FRÉMITO DIASTÓLICO"
  },
  {
    "codigo":15679281000119103,
    "descripcion":"IRITIS BILATERAL POR HERPES SIMPLE"
  },
  {
    "codigo":105983000,
    "descripcion":"ENFERMEDAD LINFÁTICA NO INFECCIOSA"
  },
  {
    "codigo":238890008,
    "descripcion":"NECROSIS GRASA NODULAR"
  },
  {
    "codigo":402730009,
    "descripcion":"CALCINOSIS ASOCIADA CON LESIÓN TISULAR DIFUSA"
  },
  {
    "codigo":237055002,
    "descripcion":"SÍNDROME DE POLIQUISTOSIS OVÁRICA"
  },
  {
    "codigo":1285631004,
    "descripcion":"HEMATOMA DE CUARTO DEDO DE PIE"
  },
  {
    "codigo":32561000119105,
    "descripcion":"HIDROCELE EN ADULTO"
  },
  {
    "codigo":202452003,
    "descripcion":"TUMOR TENOSINOVIAL DE CÉLULAS GIGANTES DIFUSO DE ARTICULACIÓN METATARSOFALÁNGICA SEGUNDA A QUINTA"
  },
  {
    "codigo":366292007,
    "descripcion":"HALLAZGO RELACIONADO CON EL TAMAÑO DE LA PRÓSTATA"
  },
  {
    "codigo":300756008,
    "descripcion":"CAPAZ DE ENTRETENERSE CON UN PASATIEMPO"
  },
  {
    "codigo":298921001,
    "descripcion":"AMPLITUD DE PRONACIÓN PASIVA DE CODO DISMINUIDA"
  },
  {
    "codigo":687921000119107,
    "descripcion":"RABDOMIOSARCOMA PRIMARIO DE TRONCO"
  },
  {
    "codigo":724905004,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO A LA ALTURA DEL HOMBRO"
  },
  {
    "codigo":4009004,
    "descripcion":"ENFERMEDAD INFECCIOSA DE LAS VÍAS URINARIAS INFERIORES"
  },
  {
    "codigo":299400004,
    "descripcion":"PRUEBA DE COMPRESIÓN ROTULIANA NEGATIVA"
  },
  {
    "codigo":1149054002,
    "descripcion":"FUNCIÓN DEL SISTEMA REPRODUCTIVO NORMAL"
  },
  {
    "codigo":723070002,
    "descripcion":"VARIACIÓN DE DOLOR"
  },
  {
    "codigo":67710009,
    "descripcion":"RUPTURA DE CONDUCTO TORÁCICO"
  },
  {
    "codigo":65875003,
    "descripcion":"OSTEOMIELITIS ORBITARIA"
  },
  {
    "codigo":164179004,
    "descripcion":"EXAMEN NASAL NORMAL"
  },
  {
    "codigo":721235003,
    "descripcion":"HIPERINSULINISMO DEBIDO A DEFICIENCIA DE RECEPTOR DE INSULINA"
  },
  {
    "codigo":295251004,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE IBUPROFENO"
  },
  {
    "codigo":719400000,
    "descripcion":"DISPLASIA FACIOCARDIOMÉLICA LETAL"
  },
  {
    "codigo":229715008,
    "descripcion":"DÉFICITS EN LA ATENCIÓN, CONTROL MOTOR Y PERCEPCIÓN"
  },
  {
    "codigo":129576003,
    "descripcion":"SÍNDROME DEL GUANTE PÚRPURA"
  },
  {
    "codigo":195112003,
    "descripcion":"INSUFICIENCIA CARDÍACA COMPENSADA"
  },
  {
    "codigo":1145384007,
    "descripcion":"HIPOPLASIA CONGÉNITA DE EXTREMIDAD"
  },
  {
    "codigo":162344009,
    "descripcion":"SORDERA BILATERAL"
  },
  {
    "codigo":31272009,
    "descripcion":"INTOXICACIÓN POR CYNODON"
  },
  {
    "codigo":291581002,
    "descripcion":"INTOXICACIÓN POR CEFACLOR"
  },
  {
    "codigo":94973007,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA OROFARINGE"
  },
  {
    "codigo":1010642001,
    "descripcion":"NECROSIS ESTRIATAL BILATERAL INFANTIL ESPORÁDICA"
  },
  {
    "codigo":10901451000119109,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO TRIGÉMINO IZQUIERDO"
  },
  {
    "codigo":420818005,
    "descripcion":"MICOBACTERIOSIS ASOCIADA CON SIDA"
  },
  {
    "codigo":58535001,
    "descripcion":"ESTADO DE AGOTAMIENTO FÍSICO Y EMOCIONAL"
  },
  {
    "codigo":124071002,
    "descripcion":"UROPORFIRINA POR DEBAJO DE RANGO DE REFERENCIA"
  },
  {
    "codigo":713895003,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO OBTURADOR DURANTE PROCEDIMIENTO QUIRÚRGICO"
  },
  {
    "codigo":1172647004,
    "descripcion":"ADRENALINA EN ORINA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1303719005,
    "descripcion":"NEOPLASIA DE PULMÓN DERECHO"
  },
  {
    "codigo":255143004,
    "descripcion":"NEOPLASIA INTRAEPITELIAL ANAL"
  },
  {
    "codigo":15954021000119105,
    "descripcion":"HIPERPLASIA LOBAR ATÍPICA DE AMBAS MAMAS"
  },
  {
    "codigo":286076003,
    "descripcion":"DIFICULTAD PARA AIREAR LA ROPA LAVADA"
  },
  {
    "codigo":253308005,
    "descripcion":"VENA CAVA SUPERIOR DERECHA AUSENTE"
  },
  {
    "codigo":449916008,
    "descripcion":"PARÁLISIS PERIFÉRICA DE NERVIO FACIAL"
  },
  {
    "codigo":448081001,
    "descripcion":"VENA HEPÁTICA A SENO CORONARIO"
  },
  {
    "codigo":307301000119107,
    "descripcion":"TUBEROSIDAD MANDIBULAR EXCESIVA"
  },
  {
    "codigo":251473007,
    "descripcion":"ANOMALÍA ELECTROENCEFALOGRÁFICA EPISÓDICA GENERALIZADA"
  },
  {
    "codigo":54865008,
    "descripcion":"FOLICULITIS PERFORANTE DE LA NARIZ"
  },
  {
    "codigo":11858021000119108,
    "descripcion":"DISTENSIÓN DE MÚSCULO DE LA PIERNA IZQUIERDA"
  },
  {
    "codigo":218705009,
    "descripcion":"REACCIÓN CAUSADA POR CICLOPROPANO"
  },
  {
    "codigo":12241151000119103,
    "descripcion":"TENDINITIS DE ANTEBRAZO IZQUIERDO"
  },
  {
    "codigo":20262006,
    "descripcion":"ATAXIA"
  },
  {
    "codigo":1003302007,
    "descripcion":"CLINODACTILIA CONGÉNITA DE TERCER DEDO DE PIE"
  },
  {
    "codigo":249638005,
    "descripcion":"ANO PERMEABLE - ASPECTO"
  },
  {
    "codigo":51195001,
    "descripcion":"PÓLIPO PLACENTARIO"
  },
  {
    "codigo":247803002,
    "descripcion":"TRASTORNO AFECTIVO ESTACIONAL"
  },
  {
    "codigo":1263611007,
    "descripcion":"TRASTORNO FETAL DEBIDO A INERCIA UTERINA"
  },
  {
    "codigo":1163472000,
    "descripcion":"INFECCIÓN INVASIVA DE OJO CAUSADA POR ASPERGILLUS"
  },
  {
    "codigo":213200001,
    "descripcion":"INFECCIÓN ASOCIADA CON LA INSEMINACIÓN ARTIFICIAL"
  },
  {
    "codigo":1360080002,
    "descripcion":"INFECCIÓN INVASIVA CAUSADA POR SCOPULARIOPSIS"
  },
  {
    "codigo":82128000,
    "descripcion":"INFECCIÓN POR HERPESVIRUS SAIMIRI"
  },
  {
    "codigo":735653001,
    "descripcion":"RUPTURA DE AMBOS OJOS CONCOMITANTE CON PROLAPSO DE TEJIDO INTRAOCULAR"
  },
  {
    "codigo":16592009,
    "descripcion":"HERPES SIMPLE VISCERAL"
  },
  {
    "codigo":211365003,
    "descripcion":"PICADURA DE INSECTO, NO VENENOSO, EN LA RODILLA, INFECTADA"
  },
  {
    "codigo":47525004,
    "descripcion":"RALES GRUESOS"
  },
  {
    "codigo":1073561000119101,
    "descripcion":"ARTRITIS REACTIVA DE ARTICULACIÓN DE PIE DERECHO"
  },
  {
    "codigo":16664831000119108,
    "descripcion":"FRACTURA EXPUESTA DE ARCO CIGOMÁTICO IZQUIERDO"
  },
  {
    "codigo":78458000,
    "descripcion":"LESIÓN TRAUMÁTICA DEL NERVIO HIPOGLOSO"
  },
  {
    "codigo":373370002,
    "descripcion":"FORMACIÓN DE TÚBULOS MAMARIOS - HALLAZGO"
  },
  {
    "codigo":830287000,
    "descripcion":"PARÁSITO OBSERVADO EN EL EXAMEN MICROSCÓPICO CON TINCIÓN"
  },
  {
    "codigo":733818008,
    "descripcion":"DISMINUCIÓN DE LA DESESPERACIÓN"
  },
  {
    "codigo":76623002,
    "descripcion":"FIEBRE PARATIFOIDEA TIPO A"
  },
  {
    "codigo":240463005,
    "descripcion":"RABIA NEUROLÓGICA AGUDA"
  },
  {
    "codigo":74788000,
    "descripcion":"AGLOSIA"
  },
  {
    "codigo":109391009,
    "descripcion":"SARCOMA DE KAPOSI DE LOS GANGLIOS LINFÁTICOS"
  },
  {
    "codigo":15737241000119105,
    "descripcion":"OPACIFICACIÓN DE CÁPSULA POSTERIOR IZQUIERDA QUE NO OBSTACULIZA LA VISIÓN"
  },
  {
    "codigo":9252005,
    "descripcion":"ENCORVAMIENTO CONGÉNITO DE TIBIA Y\/O PERONÉ"
  },
  {
    "codigo":238628007,
    "descripcion":"QUERATOSIS CIRCUNSCRIPTA"
  },
  {
    "codigo":402468007,
    "descripcion":"ESCLEROMIXEDEMA"
  },
  {
    "codigo":762916009,
    "descripcion":"TUMEFACCIÓN DE PIE IZQUIERDO"
  },
  {
    "codigo":1187065002,
    "descripcion":"URATO EN ORINA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":171257003,
    "descripcion":"SIN CONSENTIMIENTO - VACUNA ANTITETÁNICA\/ANTIDIFTÉRICA DE BAJA DOSIS"
  },
  {
    "codigo":369700007,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA PROFUNDA DE RECTO, CON COMPROMISO TUMORAL FOCAL"
  },
  {
    "codigo":236793007,
    "descripcion":"AZOOSPERMIA CON CONDUCTOS AUSENTES EN ASOCIACIÓN CON RASGO DE FIBROSIS QUÍSTICA"
  },
  {
    "codigo":105721009,
    "descripcion":"PROBLEMA Y\/O ENFERMEDAD GENERAL"
  },
  {
    "codigo":202190001,
    "descripcion":"LUXACIÓN PATOLÓGICA DE LA ARTICULACIÓN ROTULIANA"
  },
  {
    "codigo":5582005,
    "descripcion":"SÍNDROME DE COMPRESIÓN DE LA FOSA POSTERIOR"
  },
  {
    "codigo":366030005,
    "descripcion":"PIGMENTACIÓN DEL IRIS - HALLAZGO"
  },
  {
    "codigo":234958007,
    "descripcion":"ANGULACIÓN VESTIBULAR DE LA RAÍZ DENTARIA"
  },
  {
    "codigo":300494007,
    "descripcion":"EPIDÍDIMO PRESENTE"
  },
  {
    "codigo":153221000146105,
    "descripcion":"PROFESIONAL DE LA SALUD NO DISPONIBLE PARA ADMINISTRAR MEDICACIÓN"
  },
  {
    "codigo":429731003,
    "descripcion":"INFARTO DE MIOCARDIO ANTERIOR EN ELECTROCARDIOGRAMA"
  },
  {
    "codigo":724643004,
    "descripcion":"MIELOPOYESIS ANORMAL TRANSITORIA CONCOMITANTE CON SÍNDROME DE DOWN"
  },
  {
    "codigo":15628851000119104,
    "descripcion":"MANCHA DE FORSTER-FUCHS BILATERAL"
  },
  {
    "codigo":298659006,
    "descripcion":"AMPLITUD DE ROTACIÓN ACTIVA HACIA LA IZQUIERDA DE LA COLUMNA LUMBAR AUMENTADA"
  },
  {
    "codigo":1052323003,
    "descripcion":"SÍFILIS SECUNDARIA DE SISTEMA MUSCULOESQUELÉTICO"
  },
  {
    "codigo":3747008,
    "descripcion":"CLIC DE EYECCIÓN"
  },
  {
    "codigo":34680005,
    "descripcion":"TRASTORNO PRIMARIO DEL SENTIDO DEL GUSTO DE LOS SABORES DULCES"
  },
  {
    "codigo":427896006,
    "descripcion":"INSUFICIENCIA RESPIRATORIA CRÓNICA"
  },
  {
    "codigo":131149001,
    "descripcion":"GRUPO SANGUÍNEO A>1<"
  },
  {
    "codigo":360525006,
    "descripcion":"TUMOR GRANULOMATOSO GINGIVAL CONGÉNITO"
  },
  {
    "codigo":1179725009,
    "descripcion":"REACCIÓN ADVERSA AL SOTROVIMAB"
  },
  {
    "codigo":293154002,
    "descripcion":"REACCIÓN ADVERSA A LA HALCINONIDA"
  },
  {
    "codigo":719138006,
    "descripcion":"SÍNDROME DE DISCAPACIDAD INTELECTUAL LIGADA AL CROMOSOMA X CON CÚBITO VALGO Y DISMORFISMO"
  },
  {
    "codigo":63778009,
    "descripcion":"TRASTORNO DEPRESIVO MAYOR, UN SOLO EPISODIO CON SÍNTOMAS MELANCÓLICOS"
  },
  {
    "codigo":387788000,
    "descripcion":"URTICARIA TARDÍA POR PRESIÓN"
  },
  {
    "codigo":1208823009,
    "descripcion":"ROTURA DE AISLAMIENTO DE CABLE DE SENO CORONARIO DE DESFIBRILADOR CARDIOVERSOR IMPLANTABLE"
  },
  {
    "codigo":420556001,
    "descripcion":"LÍNEAS EPITELIALES CORNEALES CON CONFIGURACIÓN EN MAPA"
  },
  {
    "codigo":92876004,
    "descripcion":"FUSIÓN ANORMAL CONGÉNITA DE HUESO ESCAMOSO"
  },
  {
    "codigo":1338060006,
    "descripcion":"HIPOFUNCIÓN TESTICULAR CAUSADA POR RADIACIÓN IONIZANTE"
  },
  {
    "codigo":125644007,
    "descripcion":"HERIDA ABIERTA DEL CUELLO"
  },
  {
    "codigo":191180008,
    "descripcion":"ANEMIA POR TRASTORNOS DEL METABOLISMO DE LOS NUCLEÓTIDOS"
  },
  {
    "codigo":289484007,
    "descripcion":"LIQUENIFICACIÓN DE LA VULVA"
  },
  {
    "codigo":254881001,
    "descripcion":"LEIOMIOBLASTOMA UTERINO"
  },
  {
    "codigo":123809005,
    "descripcion":"TRASTORNO EN EL METABOLISMO DEL AZUFRE"
  },
  {
    "codigo":1303457006,
    "descripcion":"DISPLASIA BRONCOPULMONAR LEVE DEL RECIÉN NACIDO"
  },
  {
    "codigo":285814001,
    "descripcion":"INCAPAZ DE ABIR Y CERRAR CANILLAS"
  },
  {
    "codigo":23670006,
    "descripcion":"PRESIÓN INTRAOCULAR DISMINUIDA"
  },
  {
    "codigo":416886008,
    "descripcion":"HERIDA CERRADA"
  },
  {
    "codigo":251211000,
    "descripcion":"ONDA T PROLONGADA"
  },
  {
    "codigo":283979000,
    "descripcion":"LESIÓN POR APLASTAMIENTO DEL HÍGADO"
  },
  {
    "codigo":415051003,
    "descripcion":"ABDOMEN PÉNDULO"
  },
  {
    "codigo":21835004,
    "descripcion":"TRASTORNO DEBIDO A QUEMADURA Y POSTERIOR A ELLA"
  },
  {
    "codigo":447819007,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE REGIÓN INTERESCAPULAR"
  },
  {
    "codigo":338791000119105,
    "descripcion":"RETINITIS PERIFÉRICA FOCAL DE OJO IZQUIERDO"
  },
  {
    "codigo":413216002,
    "descripcion":"GASTROPATÍA EROSIVA"
  },
  {
    "codigo":773664005,
    "descripcion":"SÍNDROME DE DEFICIENCIA FUNCIONAL DE LA HIPÓFISIS ANTERIOR E INMUNODEFICIENCIA VARIABLE"
  },
  {
    "codigo":282144007,
    "descripcion":"CAPAZ DE CAMINAR"
  },
  {
    "codigo":18165001,
    "descripcion":"ICTERICIA"
  },
  {
    "codigo":247541001,
    "descripcion":"PÉRDIDA PARCIAL DE PELO"
  },
  {
    "codigo":50933003,
    "descripcion":"TRASTORNO DELUSORIO POR ALUCINÓGENOS"
  },
  {
    "codigo":11863041000119101,
    "descripcion":"ABRASIÓN DE PIEL DE PIE IZQUIERDO"
  },
  {
    "codigo":15713281000119102,
    "descripcion":"DEFORMIDAD EN VARO ADQUIRIDA DE AMBOS CODOS"
  },
  {
    "codigo":442314000,
    "descripcion":"AUTISMO ACTIVO PERO ATÍPICO"
  },
  {
    "codigo":704458005,
    "descripcion":"CONSENTIMIENTO PARA EXAMEN DEL SISTEMA GASTROINTESTINAL REHUSADO"
  },
  {
    "codigo":737226008,
    "descripcion":"TRASTORNO CAUSADO POR CANABIS"
  },
  {
    "codigo":243871000,
    "descripcion":"SITUACIÓN DEL MONITOREO DE LA OSTOMÍA"
  },
  {
    "codigo":702623002,
    "descripcion":"APLASIA DE TIMO"
  },
  {
    "codigo":211103003,
    "descripcion":"PICADURA DE INSECTO, NO VENENOSO, EN LA REGIÓN INTERESCAPULAR"
  },
  {
    "codigo":14495005,
    "descripcion":"TRASTORNO BIPOLAR I GRAVE, UN SOLO EPISODIO MANÍACO SIN SÍNTOMAS PSICÓTICOS"
  },
  {
    "codigo":276639007,
    "descripcion":"HIPOXIA FETAL EN EL PREPARTO"
  },
  {
    "codigo":1259679007,
    "descripcion":"DEMENCIA DEBIDA A NEURODEGENERACIÓN ATÍPICA ASOCIADA A PANTOTENATO CINASA"
  },
  {
    "codigo":735391009,
    "descripcion":"RESORCIÓN INFLAMATORIA EXTERNA DE RAÍZ DE DIENTE"
  },
  {
    "codigo":1290612005,
    "descripcion":"RADIOGRAFÍA DE MIEMBRO INFERIOR NORMAL"
  },
  {
    "codigo":209268006,
    "descripcion":"FRACTURA-LUXACIÓN NO EXPUESTA DE ARTICULACIÓN CARPOMETACARPIANA"
  },
  {
    "codigo":78196008,
    "descripcion":"VÁLVULA MITRAL DOBLE"
  },
  {
    "codigo":10825001,
    "descripcion":"PERFORACIÓN DEL RECTO"
  },
  {
    "codigo":11781121000119107,
    "descripcion":"AMPOLLA TRAUMÁTICA DE ANTEBRAZO IZQUIERDO"
  },
  {
    "codigo":404041003,
    "descripcion":"TUMOR MALIGNO DE CÉLULAS DE LA GRANULOSA"
  },
  {
    "codigo":698953004,
    "descripcion":"AMINOACIDURIA HEREDITARIA"
  },
  {
    "codigo":830025004,
    "descripcion":"QUISTE DERMOIDE DE CONJUNTIVA"
  },
  {
    "codigo":405876008,
    "descripcion":"FENOTIPO M-"
  },
  {
    "codigo":305737001,
    "descripcion":"ATENDIDO POR ENFERMERA ESPECIALIZADA EN CONTINENCIA"
  },
  {
    "codigo":285851000119102,
    "descripcion":"ENFERMEDAD RENAL CRÓNICA POR HIPERTENSIÓN MALIGNA, ESTADIO 1"
  },
  {
    "codigo":271134002,
    "descripcion":"AMPOLLA TRAUMÁTICA DE MAMA, INFECTADA"
  },
  {
    "codigo":402206006,
    "descripcion":"DERMATITIS SEBORREICA PITIRIASIFORME"
  },
  {
    "codigo":1186803003,
    "descripcion":"NEUROTOXICIDAD CAUSADA POR VENENO DE REPTIL"
  },
  {
    "codigo":236531005,
    "descripcion":"DISPLASIA RENAL Y APLASIA RETINIANA"
  },
  {
    "codigo":302067008,
    "descripcion":"HALLAZGO RELACIONADO CON EL TAMAÑO DE LA GLÁNDULA TIROIDES"
  },
  {
    "codigo":726216004,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO DE LA CADERA"
  },
  {
    "codigo":365768006,
    "descripcion":"NIVELES DE ENZIMA CARDÍACA - HALLAZGO"
  },
  {
    "codigo":298397000,
    "descripcion":"LESIÓN DE CUELLO"
  },
  {
    "codigo":396701002,
    "descripcion":"NIVEL SÉRICO DE MARCADOR TUMORAL-HALLAZGO"
  },
  {
    "codigo":69021004,
    "descripcion":"MARCHA CEREBELOSA"
  },
  {
    "codigo":167325005,
    "descripcion":"UROBILINÓGENO EN ORINA: +"
  },
  {
    "codigo":296562006,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE PRIMAQUINA"
  },
  {
    "codigo":1179463002,
    "descripcion":"UREA EN SANGRE POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":161820000,
    "descripcion":"PESADEZ - PISO PÉLVICO"
  },
  {
    "codigo":1144860001,
    "descripcion":"HIPOPLASIA CONGÉNITA DE ARTERIA VERTEBRAL"
  },
  {
    "codigo":225521004,
    "descripcion":"NECESITA CAMBIO DE ROPA"
  },
  {
    "codigo":94449005,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LOS GANGLIOS LINFÁTICOS OCCIPITALES"
  },
  {
    "codigo":11810101000119108,
    "descripcion":"ABRASIÓN DE PIEL DE MUSLO IZQUIERDO"
  },
  {
    "codigo":717041008,
    "descripcion":"ICTIOSIS SINDRÓMICA RECESIVA LIGADA AL CROMOSOMA X"
  },
  {
    "codigo":127217009,
    "descripcion":"LINFADENITIS HISTIOCÍTICA NECROSANTE"
  },
  {
    "codigo":289222006,
    "descripcion":"PROBLEMA EN LA SEGUNDA ETAPA DEL TRABAJO DE PARTO"
  },
  {
    "codigo":92614008,
    "descripcion":"CARCINOMA IN SITU DE LA CARA INTERNA DE LABIO"
  },
  {
    "codigo":254619006,
    "descripcion":"CARCINOMA ADENOQUÍSTICO DE LA TRÁQUEA"
  },
  {
    "codigo":1303195008,
    "descripcion":"INFECCIÓN DE HÚMERO ASOCIADA CON DISPOSITIVO DE FIJACIÓN INTERNA"
  },
  {
    "codigo":1137520000,
    "descripcion":"CALCIFICACIÓN PUNTEADA DE EPÍFISIS DE FALANGE DE TERCER DEDO DE PIE"
  },
  {
    "codigo":711536002,
    "descripcion":"ALTO RIESGO DE SANGRADO"
  },
  {
    "codigo":285552009,
    "descripcion":"DIFICULTAD PARA ELEVAR EL PALADAR BLANDO"
  },
  {
    "codigo":283717002,
    "descripcion":"MORDEDURA HUMANA EN LOS GENITALES"
  },
  {
    "codigo":52506002,
    "descripcion":"RECTOSIGMOIDITIS ULCEROSA CRÓNICA"
  },
  {
    "codigo":609562003,
    "descripcion":"DIABETES DEL ADULTO DE INICIO JUVENIL, TIPO 1"
  },
  {
    "codigo":1363226003,
    "descripcion":"CICATRIZACIÓN DE PÁRPADOS SUPERIORES E INFERIORES, BILATERAL"
  },
  {
    "codigo":16426601000119103,
    "descripcion":"ARTRITIS DE ARTICULACIÓN CIGOAPOFISARIA DE COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":249114007,
    "descripcion":"CABEZA PROFUNDAMENTE ENCAJADA"
  },
  {
    "codigo":314650008,
    "descripcion":"PERÍMETRO CEFÁLICO DEL NIÑO: PERCENTILO 25"
  },
  {
    "codigo":214511003,
    "descripcion":"ACCIDENTE DE TRÁNSITO VEHICULAR DE TIPO NO COLISIÓN CON INTOXICACIÓN ACCIDENTAL POR GASES DE ESCAPE GENERADOS POR EL VEHÍCULO EN MOVIMIENTO, CICLISTA HERIDO"
  },
  {
    "codigo":247279005,
    "descripcion":"HENDIDURA DEL OÍDO MEDIO - HALLAZGO"
  },
  {
    "codigo":81604003,
    "descripcion":"SÍNDROME DE PERHEENTUPA"
  },
  {
    "codigo":442052005,
    "descripcion":"ANAFILAXIA CAUSADA POR MARISCOS"
  },
  {
    "codigo":210841003,
    "descripcion":"LESIÓN EXPUESTA, ARTERIA CUBITAL"
  },
  {
    "codigo":702361006,
    "descripcion":"SÍNDROME DE CROUZON CON ACANTOSIS NIGRICANS"
  },
  {
    "codigo":1357721006,
    "descripcion":"DISMINUCIÓN DE USO DE SERVICIO ENERGÉTICO DEBIDA A RECURSOS ECONÓMICOS LIMITADOS"
  },
  {
    "codigo":735129008,
    "descripcion":"GRANULOMA FISURADO DE MEMBRANAS MUCOSAS"
  },
  {
    "codigo":733294000,
    "descripcion":"AVULSIÓN DE INSERCIÓN DE LIGAMENTO CRUZADO"
  },
  {
    "codigo":307310000,
    "descripcion":"ABSCESO POSQUIRÚRGICO EN HERIDA DE PARED ABDOMINAL"
  },
  {
    "codigo":209006002,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE UNA SOLA ARTICULACIÓN METATARSOFALÁNGICA"
  },
  {
    "codigo":1259417008,
    "descripcion":"CARCINOMA PRIMARIO DE HUESO DE MIEMBRO INFERIOR"
  },
  {
    "codigo":343811000119102,
    "descripcion":"TELANGIECTASIA BILATERAL DE RETINA"
  },
  {
    "codigo":241774007,
    "descripcion":"EFECTO TÓXICO CAUSADO POR CIGUATOXINA"
  },
  {
    "codigo":43331001,
    "descripcion":"ANEURISMA ARTERIAL VARICOSO"
  },
  {
    "codigo":698691002,
    "descripcion":"TRASTORNO COGNITIVO EN REMISIÓN"
  },
  {
    "codigo":1255747002,
    "descripcion":"HISTIOCITOSIS MALIGNA DE GANGLIOS LINFÁTICOS DE CUELLO"
  },
  {
    "codigo":239939001,
    "descripcion":"ARTERITIS DE CÉLULAS GIGANTES SIN POLIMIALGIA REUMÁTICA"
  },
  {
    "codigo":371011007,
    "descripcion":"DILATACIÓN DE CÁLIZ RENAL"
  },
  {
    "codigo":403779009,
    "descripcion":"ICTIOSIS, DEGENERACIÓN CEREBELOSA Y HEPATOESPLENOMEGALIA"
  },
  {
    "codigo":762392002,
    "descripcion":"ANOMALÍA DE LA SUPERFICIE UNGUEAL"
  },
  {
    "codigo":74264003,
    "descripcion":"INTOXICACIÓN POR ALCALOIDE OPIÁCEO"
  },
  {
    "codigo":1081091000119106,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE MÚSCULO DE EXTREMIDAD INFERIOR IZQUIERDA"
  },
  {
    "codigo":238104009,
    "descripcion":"SITOESTEROLEMIA"
  },
  {
    "codigo":6893006,
    "descripcion":"PERÍODO DILATANTE"
  },
  {
    "codigo":170733007,
    "descripcion":"ARTICULACIONES AFECTADAS POR GOTA"
  },
  {
    "codigo":398274000,
    "descripcion":"TROMBOSIS DE ARTERIA CORONARIA"
  },
  {
    "codigo":1217474003,
    "descripcion":"BAJA CARGA MUTACIONAL DE TUMOR"
  },
  {
    "codigo":201666003,
    "descripcion":"ARTRITIS GOTOSA DE MANO"
  },
  {
    "codigo":365506005,
    "descripcion":"ESTADO DE LOS SERVICIOS Y PRESTACIONES PÚBLICAS - HALLAZGO"
  },
  {
    "codigo":299970006,
    "descripcion":"PICADURA ANIMAL"
  },
  {
    "codigo":298135000,
    "descripcion":"PROLAPSO DE ESTOMA DE UROSTOMÍA"
  },
  {
    "codigo":429207009,
    "descripcion":"HALLADO EN AUTOMÓVIL"
  },
  {
    "codigo":35991009,
    "descripcion":"AVERSIÓN"
  },
  {
    "codigo":1017196003,
    "descripcion":"FIBROSIS PULMONAR INTERSTICIAL POR INHALACIÓN DE SUSTANCIA"
  },
  {
    "codigo":296300004,
    "descripcion":"SOBREDOSIS DE FÁRMACO ALUCINÓGENO"
  },
  {
    "codigo":66924005,
    "descripcion":"CALCINOSIS UNIVERSAL"
  },
  {
    "codigo":1388004,
    "descripcion":"ALCALOSIS METABÓLICA"
  },
  {
    "codigo":1344876007,
    "descripcion":"MIOSITIS OSIFICANTE DE MÚSCULO DE AMBAS MANOS DEBIDA A QUEMADURA"
  },
  {
    "codigo":427372006,
    "descripcion":"MIOCARDITIS EOSINOFÍLICA"
  },
  {
    "codigo":722284009,
    "descripcion":"SÍNDROME DE HIPOPLASIA Y COLOBOMA DE CARTÍLAGO ALAR CON TELECANTO"
  },
  {
    "codigo":71581000119108,
    "descripcion":"ARTRITIS VIRAL POLIARTICULAR"
  },
  {
    "codigo":294465009,
    "descripcion":"ALERGIA A NETILMICINA"
  },
  {
    "codigo":292630003,
    "descripcion":"REACCIÓN ADVERSA AL BUFEXAMACO"
  },
  {
    "codigo":718614004,
    "descripcion":"SÍNDROME DE TELANGIECTASIA, ERITROCITOSIS, GAMMOPATÍA MONOCLONAL, COLECCIONES DE LÍQUIDO PERINÉFRICO Y CORTOCIRCUITO INTRAPULMONAR"
  },
  {
    "codigo":1306603001,
    "descripcion":"NEUMONITIS DEBIDA A CUERPO EXTRAÑO"
  },
  {
    "codigo":126955002,
    "descripcion":"NEOPLASIA DEL LÓBULO TEMPORAL"
  },
  {
    "codigo":28651003,
    "descripcion":"HIPOTENSIÓN ARTERIAL ORTOSTÁTICA"
  },
  {
    "codigo":94187006,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE VASO SANGUÍNEO ABDOMINAL"
  },
  {
    "codigo":290795006,
    "descripcion":"INTOXICACIÓN POR BROMOCRIPTINA"
  },
  {
    "codigo":288960001,
    "descripcion":"TRAGA SALIVA"
  },
  {
    "codigo":92352002,
    "descripcion":"NEOPLASIA BENIGNA DE LA PIEL DEL TÓRAX"
  },
  {
    "codigo":190656001,
    "descripcion":"DEFICIENCIA ALIMENTARIA DE CALCIO"
  },
  {
    "codigo":12401000132107,
    "descripcion":"INTOXICACIÓN CAUSADA POR ANILINA"
  },
  {
    "codigo":287125006,
    "descripcion":"AMPOLLA EN LA CÓRNEA"
  },
  {
    "codigo":16019511000119108,
    "descripcion":"ATEROSCLEROSIS DE ARTERIA ILÍACA DERECHA"
  },
  {
    "codigo":385429006,
    "descripcion":"OSTEOCONDROMA DE PIE"
  },
  {
    "codigo":1268330004,
    "descripcion":"FRACTURA DE HUESO ADYACENTE A PRÓTESIS DE ARTICULACIÓN DE RODILLA"
  },
  {
    "codigo":55914005,
    "descripcion":"INFESTACIÓN CAUSADA POR OTODECTES"
  },
  {
    "codigo":54079004,
    "descripcion":"CLONO DE APERTURA ANÓDICO"
  },
  {
    "codigo":840511005,
    "descripcion":"COMPRESIÓN DE MÉDULA ESPINAL DEBIDA A ABSCESO INTRAESPINAL"
  },
  {
    "codigo":283455006,
    "descripcion":"HERIDA PUNZANTE EN LA BOCA"
  },
  {
    "codigo":250687005,
    "descripcion":"ALFA-1-ANTITRIPSINA, FENOTIPO PISS"
  },
  {
    "codigo":15665361000119106,
    "descripcion":"COLOBOMA CORIORRETINIANO CONGÉNITO DE OJO IZQUIERDO"
  },
  {
    "codigo":773140008,
    "descripcion":"CUERPO EXTRAÑO EN LAS VÍAS URINARIAS INFERIORES"
  },
  {
    "codigo":445460009,
    "descripcion":"ANTICUERPO ANTI-VIRUS DE EPSTEIN BARR DETECTADO EN SUERO"
  },
  {
    "codigo":247017005,
    "descripcion":"DEFECTO PUPILAR MOTOR"
  },
  {
    "codigo":771305006,
    "descripcion":"POLINEUROPATÍA PROGRESIVA CON NECROSIS ESTRIATAL BILATERAL"
  },
  {
    "codigo":738537006,
    "descripcion":"METABOLIZADOR INTERMEDIO DE MIEMBRO A1 DE LA FAMILIA 1 DE URIDINA DIFOSFATO GLUCURONOSILTRANSFERASA"
  },
  {
    "codigo":277950001,
    "descripcion":"ENFERMEDAD MÚSCULO-OJO-CEREBRO"
  },
  {
    "codigo":346321000119109,
    "descripcion":"DESCEMETOCELES DE AMBOS OJOS"
  },
  {
    "codigo":703934009,
    "descripcion":"ALERGIA A HONGO"
  },
  {
    "codigo":767635003,
    "descripcion":"TRASTORNO BIPOLAR I, EPISODIO MÁS RECIENTE MANÍACO"
  },
  {
    "codigo":47081000087101,
    "descripcion":"FRACTURA CONMINUTA DE RÓTULA IZQUIERDA"
  },
  {
    "codigo":439955006,
    "descripcion":"ESOFAGITIS ULCEROSA"
  },
  {
    "codigo":1290088001,
    "descripcion":"NEOPLASIA NEUROENDOCRINA DE INTESTINO GRUESO"
  },
  {
    "codigo":12136001,
    "descripcion":"FASE PSICOSEXUAL ANAL"
  },
  {
    "codigo":307048004,
    "descripcion":"SENSACIÓN DE AISLAMIENTO"
  },
  {
    "codigo":39401000087109,
    "descripcion":"DISTENSIÓN DE TENDÓN DE EXTREMIDAD INFERIOR DERECHA"
  },
  {
    "codigo":274280006,
    "descripcion":"DOLOR URETERAL"
  },
  {
    "codigo":733032006,
    "descripcion":"SÍNDROME DE EPILEPSIA-TELANGIECTASIAS"
  },
  {
    "codigo":110440006,
    "descripcion":"PRESENCIA DE CORPÚSCULO DE BARR, SEXO NUCLEAR FEMENINO"
  },
  {
    "codigo":700264006,
    "descripcion":"RETRACCIÓN ANORMAL DE PÁRPADO INFERIOR"
  },
  {
    "codigo":10301003,
    "descripcion":"FIEBRE RECIDIVANTE TRANSMITIDA POR GARRAPATAS"
  },
  {
    "codigo":403517004,
    "descripcion":"TELANGIECTASIA DEL PLIEGUE UNGUEAL ASOCIADO CON ESCLERODERMIA"
  },
  {
    "codigo":75837004,
    "descripcion":"TRASTORNO DEL ESTADO DE ÁNIMO, CON SÍNTOMAS DEPRESIVOS POR UNA ENFERMEDAD MÉDICA GENERAL"
  },
  {
    "codigo":303378000,
    "descripcion":"CAPAZ DE MOVERSE DESDE UNA POSICIÓN"
  },
  {
    "codigo":237842004,
    "descripcion":"HIPONATREMIA CON DISMINUCIÓN DE LA OSMOLALIDAD SÉRICA"
  },
  {
    "codigo":8466006,
    "descripcion":"VACIAMIENTO GÁSTRICO RÁPIDO"
  },
  {
    "codigo":203239003,
    "descripcion":"INFECCIÓN DE FALANGE DE DEDO DEL PIE"
  },
  {
    "codigo":432615008,
    "descripcion":"DOLOR FACIAL CRÓNICO"
  },
  {
    "codigo":6631009,
    "descripcion":"TROMBOCITOSIS"
  },
  {
    "codigo":236007009,
    "descripcion":"ESTEATONECROSIS RETROPERITONEAL"
  },
  {
    "codigo":823996003,
    "descripcion":"AMPOLLA DE PIEL"
  },
  {
    "codigo":365244002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD DE PREPARAR UN BANQUETE PARA UNO MISMO"
  },
  {
    "codigo":234172002,
    "descripcion":"AESP - ACTIVIDAD ELÉCTRICA SIN PULSO"
  },
  {
    "codigo":266940006,
    "descripcion":"OCUPA ILEGALMENTE UNA VIVIENDA"
  },
  {
    "codigo":168636007,
    "descripcion":"RADIOGRAFÍA SIMPLE DE HÚMERO ANORMAL"
  },
  {
    "codigo":1110091000000103,
    "descripcion":"HIPERTENSIÓN OCULAR SECUNDARIA DEBIDA A PSEUDOEXFOLIACIÓN"
  },
  {
    "codigo":1217212009,
    "descripcion":"DEFICIENCIA DE TRANSPORTADOR MITOCONDRIAL DE PIRUVATO"
  },
  {
    "codigo":363409003,
    "descripcion":"NEOPLASIA MALIGNA DE COLON DESCENDENTE"
  },
  {
    "codigo":723857007,
    "descripcion":"MICROHEMORRAGIA CEREBRAL ASINTOMÁTICA"
  },
  {
    "codigo":230502003,
    "descripcion":"ANOSMIA CONGÉNITA"
  },
  {
    "codigo":164966007,
    "descripcion":"PRUEBA DE SUSCEPTIBILIDAD CUTÁNEA ANORMAL"
  },
  {
    "codigo":1126007,
    "descripcion":"RODILLA BLOQUEADA"
  },
  {
    "codigo":785723001,
    "descripcion":"DOLOR FACIAL IDIOPÁTICO PERSISTENTE"
  },
  {
    "codigo":294203002,
    "descripcion":"ALERGIA A PERÓXIDO DE BENZOILO"
  },
  {
    "codigo":296038007,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE AMILOBARBITAL"
  },
  {
    "codigo":15995551000119104,
    "descripcion":"GLAUCOMA BILATERAL POR IRIS PLANO"
  },
  {
    "codigo":458043004,
    "descripcion":"TORACÓPAGOS CON AURÍCULAS Y VENTRÍCULOS UNIDOS"
  },
  {
    "codigo":194064000,
    "descripcion":"TRASTORNO DE VÍA ÓPTICA POR VASCULOPATÍA"
  },
  {
    "codigo":425275009,
    "descripcion":"FUNCIÓN PARENTAL ABUSIVA"
  },
  {
    "codigo":292368006,
    "descripcion":"REACCIÓN ADVERSA AL TRICLOFÓS SÓDICO"
  },
  {
    "codigo":28389000,
    "descripcion":"INTOXICACIÓN POR FUROSEMIDA"
  },
  {
    "codigo":290533003,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR CINCOCAÍNA"
  },
  {
    "codigo":11791161000119101,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DE MANO IZQUIERDA"
  },
  {
    "codigo":421605005,
    "descripcion":"EDEMA CON FÓVEA 2+"
  },
  {
    "codigo":716517008,
    "descripcion":"UTILIZA LA SEMÁNTICA EN LA COMUNICACIÓN"
  },
  {
    "codigo":61157009,
    "descripcion":"FATIGA DE COMBATE"
  },
  {
    "codigo":224997009,
    "descripcion":"ALTURA AUMENTADA"
  },
  {
    "codigo":15723321000119102,
    "descripcion":"GANGLIÓN BILATERAL DE CADERAS"
  },
  {
    "codigo":92090002,
    "descripcion":"NEOPLASIA BENIGNA DE LOS GANGLIOS LINFÁTICOS EPITROCLEARES"
  },
  {
    "codigo":126693009,
    "descripcion":"NEOPLASIA DE LA GLOTIS"
  },
  {
    "codigo":288698003,
    "descripcion":"NO SE COMUNICA CON DIFERENTES PERSONAS"
  },
  {
    "codigo":26554009,
    "descripcion":"PARÁLISIS NUCLEAR DE NERVIO FACIAL"
  },
  {
    "codigo":1237135009,
    "descripcion":"VENA VARICOSA DE EXTREMIDAD INFERIOR CONCOMITANTE CON ECCEMA Y ÚLCERA VARICOSOS"
  },
  {
    "codigo":285028006,
    "descripcion":"CAPAZ DE MANEJAR UN ARTEFACTO MIENTRAS SE DESVISTE"
  },
  {
    "codigo":448868009,
    "descripcion":"NEOPLASIA MALIGNA DE PARED LATERAL DE OROFARINGE"
  },
  {
    "codigo":55652009,
    "descripcion":"GLOMERULONEFRITIS AGUDA IDIOPÁTICA CON SEMILUNAS, TIPO III"
  },
  {
    "codigo":217657003,
    "descripcion":"ENVENENAMIENTO POR VENENO DE MAMBA"
  },
  {
    "codigo":250425007,
    "descripcion":"PRUEBA DE EMBARAZO NEGATIVA"
  },
  {
    "codigo":283193008,
    "descripcion":"ANZUELO EN EL CUELLO"
  },
  {
    "codigo":281358000,
    "descripcion":"DERMATOMIOSITIS IDIOPÁTICA"
  },
  {
    "codigo":21049007,
    "descripcion":"TRICOSTASIS ESPINOSA"
  },
  {
    "codigo":248590003,
    "descripcion":"INCAPAZ DE TOSER"
  },
  {
    "codigo":838414004,
    "descripcion":"AGUDEZA VISUAL CON AGUJERO ESTENOPEICO DE OJO DERECHO 6\/12"
  },
  {
    "codigo":51982005,
    "descripcion":"EMULSIFICACIÓN"
  },
  {
    "codigo":707342003,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE SENO ETMOIDAL"
  },
  {
    "codigo":1231630007,
    "descripcion":"DESVIACIÓN SOSTENIDA DE LA MIRADA CONJUGADA HORIZONTAL DE TIPO CONTRALATERAL"
  },
  {
    "codigo":246755000,
    "descripcion":"DIRECCIÓN DEL ESTRABISMO"
  },
  {
    "codigo":17379000,
    "descripcion":"FORÚNCULO DE FLANCO"
  },
  {
    "codigo":445198003,
    "descripcion":"MENINGITIS CAUSADA POR HAEMOPHILUS INFLUENZAE TIPO B"
  },
  {
    "codigo":15544002,
    "descripcion":"MIOCARDIOPATÍA RESTRICTIVA SECUNDARIA A INFILTRACIÓN"
  },
  {
    "codigo":310456004,
    "descripcion":"INFORME SOLICITADO POR ORGANIZACIÓN DE SUBSIDIOS"
  },
  {
    "codigo":46477004,
    "descripcion":"INFECCIÓN CAUSADA POR THELAZIA"
  },
  {
    "codigo":700002003,
    "descripcion":"SECCIÓN PARCIAL DE TENDÓN DE CABEZA CORTA DE TENDÓN DE BÍCEPS BRAQUIAL"
  },
  {
    "codigo":110178004,
    "descripcion":"QUEMADURA DE LA REGIÓN PERIORAL"
  },
  {
    "codigo":208482003,
    "descripcion":"FRACTURA EXPUESTA DE FALANGE PROXIMAL DE MÚLTIPLES DEDOS DE MANO"
  },
  {
    "codigo":77410006,
    "descripcion":"ÚLCERA DUODENAL CON PERFORACIÓN Y OBSTRUCCIÓN"
  },
  {
    "codigo":42807005,
    "descripcion":"PULSO ALTERNANTE"
  },
  {
    "codigo":761868000,
    "descripcion":"TRASTORNO EPIGENÉTICO"
  },
  {
    "codigo":1088621000119105,
    "descripcion":"OTITIS EXTERNA DIFUSA IZQUIERDA"
  },
  {
    "codigo":403255008,
    "descripcion":"HIPERMELANOSIS POR HIPERTIROIDISMO"
  },
  {
    "codigo":237580006,
    "descripcion":"SECRECIÓN EXCESIVA PANCREÁTICA DE POLIPÉPTIDOS"
  },
  {
    "codigo":792801002,
    "descripcion":"PULSO EN ARTERIA TIBIAL ANTERIOR DERECHA PRESENTE"
  },
  {
    "codigo":679021000119107,
    "descripcion":"PLIEGUE BILATERAL DE MEMBRANA DE BOWMAN DE AMBOS OJOS"
  },
  {
    "codigo":268513005,
    "descripcion":"EN TRATAMIENTO CON FENOTIAZINA INYECTABLE"
  },
  {
    "codigo":235745006,
    "descripcion":"COLITIS GRANULOMATOSA NO CROHN"
  },
  {
    "codigo":432353006,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR AGONISTA OPIÁCEO"
  },
  {
    "codigo":202977009,
    "descripcion":"ESTRANGULACIÓN DE TENDÓN DE MUÑECA O MANO"
  },
  {
    "codigo":299446004,
    "descripcion":"ARTICULACIÓN DE TOBILLO DOLOROSA A LA PALPACIÓN"
  },
  {
    "codigo":201142005,
    "descripcion":"ALOPECIA PERONEA"
  },
  {
    "codigo":364982006,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD DE REALIZAR LA PRENSIÓN CON SUPINACIÓN DE MUÑECA"
  },
  {
    "codigo":233910005,
    "descripcion":"FIBRILACIÓN AURICULAR AISLADA"
  },
  {
    "codigo":70070008,
    "descripcion":"TORTÍCOLIS"
  },
  {
    "codigo":68235000,
    "descripcion":"CONGESTIÓN NASAL"
  },
  {
    "codigo":102838008,
    "descripcion":"CILINDRO URINARIO, LEUCOCÍTICO"
  },
  {
    "codigo":199307003,
    "descripcion":"CONTINUACIÓN DEL EMBARAZO LUEGO DE LA MUERTE INTRAUTERINA DE UNO O MÁS FETOS"
  },
  {
    "codigo":232075002,
    "descripcion":"LINFOMA DE RETINA"
  },
  {
    "codigo":12203271000119105,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":295776002,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE TRILOSTANO"
  },
  {
    "codigo":263008003,
    "descripcion":"LUXACIÓN RECURRENTE DE ARTICULACIÓN TEMPOROMANDIBULAR"
  },
  {
    "codigo":230240004,
    "descripcion":"ATAXIA CEREBELOSA PROGRESIVA CON HIPOGONADISMO"
  },
  {
    "codigo":721760004,
    "descripcion":"INFECCIÓN CAUSADA POR TROPHERYMA"
  },
  {
    "codigo":228405006,
    "descripcion":"CONSIGUE AGUJAS LIMPIAS"
  },
  {
    "codigo":242951000119108,
    "descripcion":"CARCINOMA PRIMARIO ESCAMOCELULAR DE BORDE BERMELLÓN DE LABIO"
  },
  {
    "codigo":293941008,
    "descripcion":"ALERGIA A TRIFLUOPERAZINA"
  },
  {
    "codigo":292106001,
    "descripcion":"REACCIÓN ADVERSA AL ANTAGONISTA DEL RECEPTOR H2"
  },
  {
    "codigo":161034004,
    "descripcion":"NO DISPUESTO A SER DONANTE"
  },
  {
    "codigo":29962006,
    "descripcion":"INCAPACIDAD"
  },
  {
    "codigo":93663003,
    "descripcion":"NEOPLASIA MALIGNA DE PIEL CON DIFERENCIACIÓN ANEXIAL"
  },
  {
    "codigo":290271005,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR KETOROLACO"
  },
  {
    "codigo":28127009,
    "descripcion":"BEBEDOR SOCIAL"
  },
  {
    "codigo":880095009,
    "descripcion":"DERMATITIS POR INFESTACIÓN DE ORNITHONYSSUS SYLVIARUM"
  },
  {
    "codigo":1337012005,
    "descripcion":"FRACTURA ESTRELLADA NO EXPUESTA DE RÓTULA"
  },
  {
    "codigo":24457001,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DEL OÍDO, CON INFECCIÓN"
  },
  {
    "codigo":253833001,
    "descripcion":"QUISTE EMBRIONARIO DE CUELLO UTERINO"
  },
  {
    "codigo":124596009,
    "descripcion":"DEFICIENCIA DE GLUTAMATO DESCARBOXILASA"
  },
  {
    "codigo":89993004,
    "descripcion":"HEMATOMA DE CONDUCTO DEFERENTE"
  },
  {
    "codigo":712585005,
    "descripcion":"INFERTILIDAD FEMENINA DEBIDA A ADHERENCIA PERITONEAL PÉLVICA"
  },
  {
    "codigo":188297001,
    "descripcion":"NEOPLASIA MALIGNA DEL MESENCÉFALO"
  },
  {
    "codigo":288436009,
    "descripcion":"CAPAZ DE REALIZAR ACTIVIDADES DE DIBUJO"
  },
  {
    "codigo":251998001,
    "descripcion":"CUELLO VESICAL DESCENDIDO EN REPOSO"
  },
  {
    "codigo":353851000119103,
    "descripcion":"CARCINOMA IN SITU DE PIEL DE MIEMBRO INFERIOR DERECHO"
  },
  {
    "codigo":446771003,
    "descripcion":"VERRUGA VULGAR DE PIEL DE CUERO CABELLUDO"
  },
  {
    "codigo":1086851000119100,
    "descripcion":"MUCOSA DE CRESTA ALVEOLAR RESIDUAL EXCESIVAMENTE QUERATINIZADA"
  },
  {
    "codigo":334211000119100,
    "descripcion":"ECTROPIÓN DE PÁRPADO INFERIOR DERECHO"
  },
  {
    "codigo":347011000119102,
    "descripcion":"OCLUSIÓN DE AMBAS ARTERIAS CENTRALES DE LA RETINA"
  },
  {
    "codigo":323971000119103,
    "descripcion":"MASA DE ARTICULACIÓN DE TOBILLO"
  },
  {
    "codigo":331651000119104,
    "descripcion":"DERMATOCALASIA DE PÁRPADO SUPERIOR DERECHO"
  },
  {
    "codigo":308611000119103,
    "descripcion":"GANGLIÓN DE CODO IZQUIERDO"
  },
  {
    "codigo":339331000119102,
    "descripcion":"ÚLCERA DE CÓRNEA MICÓTICA DE OJO IZQUIERDO"
  },
  {
    "codigo":248328003,
    "descripcion":"ALTA ESTATURA"
  },
  {
    "codigo":11769731000119107,
    "descripcion":"DISTENSIÓN DE MÚSCULO DE BRAZO IZQUIERDO"
  },
  {
    "codigo":51720005,
    "descripcion":"SÍNDROME DE LA PLAQUETA GRIS"
  },
  {
    "codigo":306051000119107,
    "descripcion":"TRASTORNO DE LIGAMENTO DE ARTICULACIÓN DE TOBILLO DERECHO"
  },
  {
    "codigo":1264136005,
    "descripcion":"PARAMETRITIS POSTERIOR A EMBARAZO MOLAR"
  },
  {
    "codigo":10947971000119108,
    "descripcion":"HERIDA ABIERTA DE DEDO ÍNDICE DERECHO DEBIDA A MORDEDURA DE ANIMAL"
  },
  {
    "codigo":354691000119107,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE OMÓPLATO DERECHO"
  },
  {
    "codigo":106371000119109,
    "descripcion":"OSTEOPATÍA CONCOMITANTE CON POLIOMIELITIS NO ACTIVA DE PIERNA Y DEBIDA A ELLA"
  },
  {
    "codigo":836317002,
    "descripcion":"AGUDEZA VISUAL CORREGIDA DE OJO DERECHO 2\/60"
  },
  {
    "codigo":49885004,
    "descripcion":"HIPERPLASIA DE AMÍGDALAS"
  },
  {
    "codigo":1081731000119109,
    "descripcion":"SARCOMA PRIMARIO DE PARTES BLANDAS DE EXTREMIDAD SUPERIOR DERECHA"
  },
  {
    "codigo":282236291000119109,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN DE TEJIDO PROFUNDO DE GLÚTEO DERECHO"
  },
  {
    "codigo":770781006,
    "descripcion":"QUEMADURA PROFUNDA DE ESPESOR PARCIAL DE PIEL DE LABIOS SUPERIOR E INFERIOR"
  },
  {
    "codigo":768946000,
    "descripcion":"SÍNDROME DE STEVENS-JOHNSON, ESPECTRO DE NECRÓLISIS EPIDÉRMICA TÓXICA"
  },
  {
    "codigo":80818002,
    "descripcion":"CIRUGÍA PREVIA DEL PERINEO Y\/O DE LA VULVA QUE AFECTA EL EMBARAZO"
  },
  {
    "codigo":277426005,
    "descripcion":"SENSACIÓN DE MOVIMIENTO"
  },
  {
    "codigo":242823008,
    "descripcion":"SOBREDOSIS INTENCIONAL DE ANALGÉSICOS NO OPIÁCEOS"
  },
  {
    "codigo":373895009,
    "descripcion":"DISTRÉS RESPIRATORIO AGUDO"
  },
  {
    "codigo":898183009,
    "descripcion":"NEUROESTIMULADOR GÁSTRICO IN SITU"
  },
  {
    "codigo":11612004,
    "descripcion":"CORIOAMNIONITIS"
  },
  {
    "codigo":239153000,
    "descripcion":"APLASIA CUTIS TIPO 3"
  },
  {
    "codigo":42545001,
    "descripcion":"ARTRITIS SUBAGUDA"
  },
  {
    "codigo":697905000,
    "descripcion":"HIPERTENSIÓN DE ARTERIA PULMONAR ASOCIADA CON CARDIOPATÍA CONGÉNITA"
  },
  {
    "codigo":402993003,
    "descripcion":"ACTINOMICETOMA CAUSADO POR ACTINOMADURA MADURAE"
  },
  {
    "codigo":370225008,
    "descripcion":"CUMPLIMIENTO DEL TRATAMIENTO ANTIASMÁTICO, NO SATISFACTORIO"
  },
  {
    "codigo":304689009,
    "descripcion":"DIFICULTAD PARA TOMAR DECISIONES ELABORADAS"
  },
  {
    "codigo":401158006,
    "descripcion":"QUISTE PILOSO DE CUERO CABELLUDO"
  },
  {
    "codigo":399323001,
    "descripcion":"CEGUERA DIURNA"
  },
  {
    "codigo":432091002,
    "descripcion":"SÍNDROME DEL SABIO"
  },
  {
    "codigo":204550009,
    "descripcion":"ESTENOSIS CONGÉNITA DE LARINGE, TRÁQUEA Y BRONQUIO"
  },
  {
    "codigo":268251006,
    "descripcion":"SINDACTILIA SIMPLE"
  },
  {
    "codigo":169947009,
    "descripcion":"DIFICULTAD PARA ESTABLECER LA LACTANCIA"
  },
  {
    "codigo":233648002,
    "descripcion":"QUILOTÓRAX TRAUMÁTICO"
  },
  {
    "codigo":364720006,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA DEJAR DE CAMINAR"
  },
  {
    "codigo":725168006,
    "descripcion":"ENFERMEDAD OCULAR DE LAS ISLAS ALAND"
  },
  {
    "codigo":2437000,
    "descripcion":"PLACENTA CIRCUNVALADA"
  },
  {
    "codigo":723333000,
    "descripcion":"SÍNDROME FACIOCARDIORRENAL"
  },
  {
    "codigo":102576009,
    "descripcion":"EDEMA DE PIE"
  },
  {
    "codigo":231813003,
    "descripcion":"LESIÓN TRAUMÁTICA PALPEBRAL"
  },
  {
    "codigo":37040008,
    "descripcion":"POSICIÓN OCCIPITOILÍACA DERECHA TRANSVERSA"
  },
  {
    "codigo":788869006,
    "descripcion":"ATRESIA DE ESÓFAGO CONCOMITANTE CON FÍSTULA ESOFAGOBRONQUIAL"
  },
  {
    "codigo":721498000,
    "descripcion":"FRACTURA DE QUINTA VÉRTEBRA LUMBAR"
  },
  {
    "codigo":197210001,
    "descripcion":"PÓLIPO ANAL Y RECTAL"
  },
  {
    "codigo":295514006,
    "descripcion":"SOBREDOSIS INTENCIONAL DE PROPOFOL"
  },
  {
    "codigo":787034007,
    "descripcion":"ASTILLA EN PÁRPADO"
  },
  {
    "codigo":293679000,
    "descripcion":"ALERGIA A DANTRÓN"
  },
  {
    "codigo":262746007,
    "descripcion":"AVULSIÓN DE RAÍZ DE NERVIO DORSAL"
  },
  {
    "codigo":33370009,
    "descripcion":"HIPEREMESIS GRAVÍDICA ANTES DEL FIN DE LA SEMANA 22 DE GESTACIÓN CON LA DESEQUILIBRIO ELECTROLÍTICO"
  },
  {
    "codigo":162607003,
    "descripcion":"ENFERMEDAD TERMINAL - ESTADIO INICIAL"
  },
  {
    "codigo":719663005,
    "descripcion":"SÍNDROME DE MICRODELECIÓN 6Q25"
  },
  {
    "codigo":129839007,
    "descripcion":"CON MAYOR RIESGO DE CAÍDAS"
  },
  {
    "codigo":1078276000,
    "descripcion":"AGENESIA DE EPÍFISIS DE FALANGE DE DEDO DE PIE"
  },
  {
    "codigo":15675401000119105,
    "descripcion":"TENDINITIS BILATERAL DE PIE"
  },
  {
    "codigo":422916003,
    "descripcion":"LESIÓN TRAUMÁTICA CONTUSA DEL TÓRAX"
  },
  {
    "codigo":95236005,
    "descripcion":"ARTERIA PULMONAR RETROESOFÁGICA"
  },
  {
    "codigo":816132007,
    "descripcion":"GLÓBULOS DE GRASA EN MUESTRA DE SANGRE"
  },
  {
    "codigo":291844009,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR NANDROLONA"
  },
  {
    "codigo":224473005,
    "descripcion":"A PUNTO DE JUBILARSE"
  },
  {
    "codigo":30600004,
    "descripcion":"METAPLASIA ESCAMOSA DE CUELLO UTERINO"
  },
  {
    "codigo":58798003,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM CHELONEI"
  },
  {
    "codigo":124334005,
    "descripcion":"DEFICIENCIA DE CARBAMATO CINASA"
  },
  {
    "codigo":253571001,
    "descripcion":"DEFECTO GIGANTE DEL TABIQUE INTERVENTRICULAR"
  },
  {
    "codigo":1269379004,
    "descripcion":"LESIÓN COMPLETA DE MÉDULA ESPINAL DORSAL DEBIDA A SUBLUXACIÓN NO EXPUESTA DE ARTICULACIÓN DE COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":286339005,
    "descripcion":"INCAPAZ DE EMITIR UN VOLUMEN DE VOZ ADECUADO"
  },
  {
    "codigo":1234776000,
    "descripcion":"TRASTORNO DE SUEÑO CAUSADO POR ETANOL"
  },
  {
    "codigo":218968003,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR CLORMERODRINA"
  },
  {
    "codigo":186200004,
    "descripcion":"PLEURESÍA TUBERCULOSA, CON CONFIRMACIÓN BACTERIOLÓGICA E HISTOLÓGICA"
  },
  {
    "codigo":329891000119106,
    "descripcion":"ESCOLIOSIS NEUROMUSCULAR DE COLUMNA DORSAL Y LUMBAR DEBIDA A POLIOMIELITIS Y POSTERIOR A ELLA"
  },
  {
    "codigo":284504009,
    "descripcion":"CONDUCTA DIFÍCIL DE CONTROLAR"
  },
  {
    "codigo":708653004,
    "descripcion":"ENFERMEDAD GINGIVAL CAUSADA POR FÁRMACO"
  },
  {
    "codigo":282669006,
    "descripcion":"DIFICULTAD PARA LANZAR"
  },
  {
    "codigo":315437006,
    "descripcion":"NACIDO EN LA REPÚBLICA DE GUINEA"
  },
  {
    "codigo":18690003,
    "descripcion":"NEUMOPATÍA POR HIPERSENSIBILIDAD AL HENO MOHOSO"
  },
  {
    "codigo":278999000,
    "descripcion":"DOLOR A LA PALPACIÓN EN PIEL"
  },
  {
    "codigo":16855001,
    "descripcion":"FALLO DE VÁLVULA TRICÚSPIDE REUMÁTICA"
  },
  {
    "codigo":248066009,
    "descripcion":"AUTOMUTILACIÓN DE LOS OJOS"
  },
  {
    "codigo":15950141000119105,
    "descripcion":"CARCINOMA BASOCELULAR PRIMARIO DE PIEL DE MAMA IZQUIERDA"
  },
  {
    "codigo":344013271000119100,
    "descripcion":"CARCINOMA PAPILAR IN SITU DE MAMA IZQUIERDA"
  },
  {
    "codigo":735916009,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA NEUROEPITELIAL DE RETINA"
  },
  {
    "codigo":275329003,
    "descripcion":"LUXACIÓN DEL EXTREMO DISTAL DEL RADIO"
  },
  {
    "codigo":111489007,
    "descripcion":"TRASTORNO DEL SUEÑO RELACIONADO CON LA RESPIRACIÓN"
  },
  {
    "codigo":11827671000119102,
    "descripcion":"SUBLUXACIÓN DE ARTICULACIÓN DE RODILLA DERECHA"
  },
  {
    "codigo":11350001,
    "descripcion":"NECROSIS HEPÁTICA DIFUSA"
  },
  {
    "codigo":209793009,
    "descripcion":"ESGUINCE DE LA REGIÓN TIROIDEA"
  },
  {
    "codigo":207958003,
    "descripcion":"FRACTURA NO EXPUESTA DE VÉRTEBRA LUMBAR, POR ESTALLIDO"
  },
  {
    "codigo":45953007,
    "descripcion":"IRIDODIÁLISIS"
  },
  {
    "codigo":76886005,
    "descripcion":"POLINEURITIS"
  },
  {
    "codigo":31191000119102,
    "descripcion":"DESPRENDIMIENTO DE RETINA RECIENTE"
  },
  {
    "codigo":732246009,
    "descripcion":"SÍNDROME DE DISCAPACIDAD INTELECTUAL LIGADA AL CROMOSOMA X, ESPASTICIDAD DE EXTREMIDADES, DISTROFIA DE RETINA Y DEFICIENCIA DE ARGININA VASOPRESINA"
  },
  {
    "codigo":42283001,
    "descripcion":"ÚTERO COCLEADO"
  },
  {
    "codigo":253341008,
    "descripcion":"VÁLVULA DE EUSTAQUIO OBSTRUCTIVA"
  },
  {
    "codigo":238891007,
    "descripcion":"NECROSIS GRASA TRAUMÁTICA"
  },
  {
    "codigo":402731008,
    "descripcion":"CALCIFICACIÓN METASTÁSICA DE PIEL"
  },
  {
    "codigo":271659007,
    "descripcion":"FRÉMITO CARDÍACO CONTINUO"
  },
  {
    "codigo":12237271000119105,
    "descripcion":"ANEURISMA DE ARTERIA RENAL IZQUIERDA"
  },
  {
    "codigo":7680008,
    "descripcion":"LESIÓN TRAUMÁTICA DEL NERVIO MUSCULOCUTÁNEO"
  },
  {
    "codigo":366293002,
    "descripcion":"CONSISTENCIA PROSTÁTICA - HALLAZGO"
  },
  {
    "codigo":300757004,
    "descripcion":"INCAPAZ DE ENTRETENERSE CON UN PASATIEMPO"
  },
  {
    "codigo":202453008,
    "descripcion":"TUMOR TENOSINOVIAL DE CÉLULAS GIGANTES DIFUSO DE ARTICULACIÓN INTERFALÁNGICA DE DEDO DE PIE"
  },
  {
    "codigo":200618000,
    "descripcion":"FORÚNCULO DE PIERNA"
  },
  {
    "codigo":167850002,
    "descripcion":"SANGRE OCULTA DETECTADA EN VÓMITO"
  },
  {
    "codigo":724906003,
    "descripcion":"LESIÓN TRAUMÁTICA DE FASCIA A LA ALTURA DEL HOMBRO"
  },
  {
    "codigo":266154004,
    "descripcion":"CANDIDIASIS DE BOCA Y ESÓFAGO"
  },
  {
    "codigo":36778005,
    "descripcion":"FRACTURA DE FALANGE DISTAL DE DEDO DE LA MANO"
  },
  {
    "codigo":298922008,
    "descripcion":"SIN AMPLITUD PASIVA DE PRONACIÓN DE CODO"
  },
  {
    "codigo":723071003,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN DE TEJIDO PROFUNDO"
  },
  {
    "codigo":67711008,
    "descripcion":"DISTIMIA PRIMARIA DE INICIO TARDÍO"
  },
  {
    "codigo":164180001,
    "descripcion":"EXAMEN DE FAUCES NORMAL"
  },
  {
    "codigo":721236002,
    "descripcion":"HIPERINSULINISMO DEBIDO A DEFICIENCIA DE 3-HIDROXIACIL-COENZIMA A DESHIDROGENASA DE CADENA CORTA"
  },
  {
    "codigo":295252006,
    "descripcion":"SOBREDOSIS INTENCIONAL DE IBUPROFENO"
  },
  {
    "codigo":719401001,
    "descripcion":"HABLA INTELIGIBLE"
  },
  {
    "codigo":293417004,
    "descripcion":"REACCIÓN ADVERSA A FÁRMACO HIPOLIPEMIANTE"
  },
  {
    "codigo":31273004,
    "descripcion":"SÍNDROME URETRAL"
  },
  {
    "codigo":64041007,
    "descripcion":"MIOCARDIOPATÍA RESTRICTIVA IDIOPÁTICA PRIMARIA"
  },
  {
    "codigo":129577007,
    "descripcion":"CHOQUE NEURÓGENO"
  },
  {
    "codigo":94974001,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL OVARIO"
  },
  {
    "codigo":62206004,
    "descripcion":"ABSCESO DE HIPÓFISIS"
  },
  {
    "codigo":291582009,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR CEFACLOR"
  },
  {
    "codigo":224211003,
    "descripcion":"NO TIENE SU CASA PROPIA"
  },
  {
    "codigo":1010643006,
    "descripcion":"ESPINA BÍFIDA ABIERTA DE COLUMNA VERTEBRAL TORACOLUMBOSACRA"
  },
  {
    "codigo":289747009,
    "descripcion":"HALLAZGO RELACIONADO CON MEDICIONES DEL ÚTERO GRÁVIDO"
  },
  {
    "codigo":222376002,
    "descripcion":"SOBRECARGA CALÓRICA"
  },
  {
    "codigo":1303720004,
    "descripcion":"NEOPLASIA DE PULMÓN IZQUIERDO"
  },
  {
    "codigo":255144005,
    "descripcion":"CARCINOMA IN SITU DE OÍDO"
  },
  {
    "codigo":417149000,
    "descripcion":"HALLAZGO RELACIONADO CON LA ESCALA DE CORMACK-LEHANE"
  },
  {
    "codigo":1172648009,
    "descripcion":"17 - ESTEROIDES CETOGÉNICOS EN ORINA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":253309002,
    "descripcion":"DILATACIÓN SACULAR DE VENA CAVA SUPERIOR DERECHA"
  },
  {
    "codigo":91304009,
    "descripcion":"FRAGILIDAD CAPILAR ANORMAL"
  },
  {
    "codigo":449917004,
    "descripcion":"CALAMBRE EN MIEMBRO INFERIOR"
  },
  {
    "codigo":89469000,
    "descripcion":"ÚLCERA DUODENAL CRÓNICA CON HEMORRAGIA"
  },
  {
    "codigo":187773007,
    "descripcion":"NEOPLASIA MALIGNA DE LOS CONDUCTOS BILIARES INTERLOBULILLARES"
  },
  {
    "codigo":22098000,
    "descripcion":"ANEMIA HEMOLÍTICA AUTOINMUNITARIA IDIOPÁTICA CRÓNICA"
  },
  {
    "codigo":251474001,
    "descripcion":"DESCARGAS GENERALIZADAS EPILEPTIFORMES"
  },
  {
    "codigo":448082008,
    "descripcion":"OBSTRUCCIÓN AL TRACTO DE SALIDA DE VENTRÍCULO DERECHO DEBIDA A PROLAPSO DE VÁLVULA DE EUSTAQUIO"
  },
  {
    "codigo":249639002,
    "descripcion":"HALLAZGO RELACIONADO CON EL ESFÍNTER ANAL"
  },
  {
    "codigo":772948901000119104,
    "descripcion":"TENDINOSIS DE AMBAS MUÑECAS"
  },
  {
    "codigo":1003303002,
    "descripcion":"CLINODACTILIA CONGÉNITA DE CUARTO DEDO DE PIE"
  },
  {
    "codigo":1263612000,
    "descripcion":"TRASTORNO FETAL DEBIDO A DISTOCIA UTERINA"
  },
  {
    "codigo":444412001,
    "descripcion":"DISPUESTO A SER DONANTE DE HÍGADO"
  },
  {
    "codigo":247804008,
    "descripcion":"PRÓDROMO ESQUIZOFRÉNICO"
  },
  {
    "codigo":313340009,
    "descripcion":"ATENDIDO EN CONSULTORIO ESPECIALIZADO DE OJO DIABÉTICO"
  },
  {
    "codigo":213201002,
    "descripcion":"HIPERESTIMULACIÓN OVÁRICA"
  },
  {
    "codigo":1360081003,
    "descripcion":"INFLAMACIÓN DE HIPÓFISIS DEBIDA A INMUNOTERAPIA Y POSTERIOR A ELLA"
  },
  {
    "codigo":1163473005,
    "descripcion":"QUERATOCONJUNTIVITIS POR ACANTHAMEBA"
  },
  {
    "codigo":47526003,
    "descripcion":"ANEMIA HEMOLÍTICA NO ESFEROCÍTICA HEREDITARIA POR DEFICIENCIA DE NADH-DIAFORASA"
  },
  {
    "codigo":735654007,
    "descripcion":"LACERACIÓN DE AMBOS OJOS CONCOMITANTE CON PÉRDIDA DE TEJIDO INTRAOCULAR"
  },
  {
    "codigo":733819000,
    "descripcion":"MEJORÍA EN EL ESTADO DE ÁNIMO"
  },
  {
    "codigo":1290875003,
    "descripcion":"ARTRITIS IDIOPÁTICA JUVENIL DE INICIO SISTÉMICO DE RODILLA"
  },
  {
    "codigo":129075008,
    "descripcion":"ASISTENCIA PARA HABLAR POR TELÉFONO"
  },
  {
    "codigo":373371003,
    "descripcion":"PLEOMORFISMO NUCLEAR - HALLAZGO"
  },
  {
    "codigo":78459008,
    "descripcion":"INCONTINENCIA TOTAL"
  },
  {
    "codigo":111227009,
    "descripcion":"ANQUILOSIS DE ARTICULACIÓN"
  },
  {
    "codigo":109392002,
    "descripcion":"SARCOMA DE KAPOSI DE MÚLTIPLES ÓRGANOS"
  },
  {
    "codigo":15981631000119105,
    "descripcion":"PTOSIS DE PÁRPADO IZQUIERDO POSTERIOR A CIRUGÍA"
  },
  {
    "codigo":240464004,
    "descripcion":"COMA POR RABIA"
  },
  {
    "codigo":10958041000119100,
    "descripcion":"HERIDA ABIERTA DE DEDO DEL PIE DERECHO"
  },
  {
    "codigo":762917000,
    "descripcion":"TUMEFACCIÓN DE AMBOS PIES"
  },
  {
    "codigo":699216009,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN EN REGIÓN COCCÍGEA DE ESPALDA"
  },
  {
    "codigo":402469004,
    "descripcion":"TOFO GOTOSO"
  },
  {
    "codigo":238629004,
    "descripcion":"FRINODERMIA"
  },
  {
    "codigo":369701006,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA PROFUNDA DE RECTO, CON COMPROMISO TUMORAL MULTIFOCAL"
  },
  {
    "codigo":42021008,
    "descripcion":"POLIURIA RELACIONADA CON ARGININA VASOPRESINA FAMILIAR"
  },
  {
    "codigo":236794001,
    "descripcion":"ESTERILIDAD RELACIONADA CON EL CRECIMIENTO EN EL VARÓN"
  },
  {
    "codigo":105722002,
    "descripcion":"PROBLEMA RELACIONADO CON EL PESO Y\/O EL CRECIMIENTO CORPORAL"
  },
  {
    "codigo":74789008,
    "descripcion":"ANEMIA HEMOLÍTICA COOMBS POSITIVA"
  },
  {
    "codigo":1187066001,
    "descripcion":"URATO EN ORINA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":171258008,
    "descripcion":"AL DÍA CON LAS INMUNIZACIONES"
  },
  {
    "codigo":202191002,
    "descripcion":"LUXACIÓN PATOLÓGICA DE LA ARTICULACIÓN FEMORORROTULIANA"
  },
  {
    "codigo":71119005,
    "descripcion":"PÉRDIDA DE SANGRE FETAL POR EL EXTREMO DEL CORDÓN UMBILICAL DE GEMELOS UNIDOS"
  },
  {
    "codigo":300495008,
    "descripcion":"EPIDÍDIMO AUSENTE"
  },
  {
    "codigo":366031009,
    "descripcion":"HALLAZGO RELACIONADO CON EL COLOR DEL IRIS"
  },
  {
    "codigo":298660001,
    "descripcion":"AMPLITUD DE ROTACIÓN ACTIVA HACIA LA IZQUIERDA DE LA COLUMNA LUMBAR DISMINUIDA"
  },
  {
    "codigo":724644005,
    "descripcion":"LEUCEMIA MIELOIDE ASOCIADA A SÍNDROME DE DOWN"
  },
  {
    "codigo":1052324009,
    "descripcion":"INFECCIÓN GENITAL FEMENINA POR TRICHOMONAS VAGINALIS"
  },
  {
    "codigo":427897002,
    "descripcion":"RINITIS CAUSADA POR AGENTE BLOQUEANTE ALFA-ADRENÉRGICO"
  },
  {
    "codigo":15709401000119107,
    "descripcion":"HIPOPIGMENTACIÓN DE PÁRPADO INFERIOR DERECHO Y DE ÁREA PERIOCULAR DERECHA"
  },
  {
    "codigo":131150001,
    "descripcion":"GRUPO SANGUÍNEO A>2<"
  },
  {
    "codigo":360526007,
    "descripcion":"AUSENCIA CONGÉNITA DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":293155001,
    "descripcion":"REACCIÓN ADVERSA A LA ALCLOMETASONA"
  },
  {
    "codigo":719139003,
    "descripcion":"SÍNDROME DE MALFORMACIÓN DE DANDY-WALKER LIGADO AL CROMOSOMA X CON DISCAPACIDAD INTELECTUAL, ENFERMEDAD DE GANGLIOS BASALES Y CONVULSIONES"
  },
  {
    "codigo":291320002,
    "descripcion":"INTOXICACIÓN INTENCIONAL CON NORADRENALINA"
  },
  {
    "codigo":1208824003,
    "descripcion":"FRACTURA DEL AISLAMIENTO DE DERIVACIÓN VENTRICULAR DE MARCAPASOS"
  },
  {
    "codigo":9741000119101,
    "descripcion":"APNEA DEL SUEÑO CENTRAL PRIMARIA"
  },
  {
    "codigo":289485008,
    "descripcion":"ERITEMA DE VULVA"
  },
  {
    "codigo":92877008,
    "descripcion":"FUSIÓN ANORMAL CONGÉNITA DE HUESO SUPRAOCCIPITAL"
  },
  {
    "codigo":125645008,
    "descripcion":"HERIDA ABIERTA DE REGIÓN DE HOMBRO"
  },
  {
    "codigo":123810000,
    "descripcion":"SULFATEMIA"
  },
  {
    "codigo":1303458001,
    "descripcion":"DISPLASIA BRONCOPULMONAR MODERADA DEL RECIÉN NACIDO"
  },
  {
    "codigo":25506007,
    "descripcion":"RETINOPATÍA EXUDATIVA"
  },
  {
    "codigo":285815000,
    "descripcion":"ABRE Y CIERRA CANILLAS"
  },
  {
    "codigo":254882008,
    "descripcion":"LEIOMIOMA EPITELIOIDE UTERINO"
  },
  {
    "codigo":1074701000119105,
    "descripcion":"ARTRITIS DE CODO DERECHO"
  },
  {
    "codigo":447820001,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE PENE"
  },
  {
    "codigo":283980002,
    "descripcion":"LESIÓN POR APLASTAMIENTO DEL PÁNCREAS"
  },
  {
    "codigo":21836003,
    "descripcion":"INTOXICACIÓN POR PROCAÍNA"
  },
  {
    "codigo":251212007,
    "descripcion":"ONDA T ACORTADA"
  },
  {
    "codigo":185676007,
    "descripcion":"TENSIÓN ARTERIAL ANORMAL - ANULADO"
  },
  {
    "codigo":249377004,
    "descripcion":"CALLOS POR SUCCIÓN EN LA BOCA"
  },
  {
    "codigo":216609004,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ANTIBIÓTICO"
  },
  {
    "codigo":773665006,
    "descripcion":"SÍNDROME DE HIPOGONADISMO HIPOGONADOTRÓFICO, MICROCEFALIA SEVERA, PÉRDIDA AUDITIVA NEUROSENSORIAL Y DISMORFIA"
  },
  {
    "codigo":20001006,
    "descripcion":"SÍNDROME DE LA LESIÓN DEL TRIÁNGULO FEMORAL POR IMPACTO DE MANUBRIO"
  },
  {
    "codigo":282145008,
    "descripcion":"INCAPAZ DE CAMINAR"
  },
  {
    "codigo":18166000,
    "descripcion":"SENO ACCESORIO"
  },
  {
    "codigo":444150000,
    "descripcion":"SÍFILIS LATENTE"
  },
  {
    "codigo":413217006,
    "descripcion":"GASTROPATÍA ERITEMATOSA"
  },
  {
    "codigo":16639501000119109,
    "descripcion":"COMPRESIÓN DE NERVIO PERIFÉRICO DE AMBAS EXTREMIDADES INFERIORES"
  },
  {
    "codigo":90675007,
    "descripcion":"DESPRENDIMIENTO ANULAR DE CUELLO DE ÚTERO"
  },
  {
    "codigo":16331000,
    "descripcion":"PIROSIS"
  },
  {
    "codigo":739062009,
    "descripcion":"METABOLIZADOR LENTO DE LA FAMILIA 3 SUBFAMILIA A MIEMBRO 5 DEL CITOCROMO P450"
  },
  {
    "codigo":49099001,
    "descripcion":"NIVEL DE ÁCIDO ÚRICO POR ENCIMA DE RANGO DE REFERENCIA"
  },
  {
    "codigo":737227004,
    "descripcion":"PARAPLEJÍA ESPÁSTICA AUTOSÓMICA DOMINANTE"
  },
  {
    "codigo":473248001,
    "descripcion":"QUEMADURA DE REGIÓN OCULAR CON QUEMADURA EPIDÉRMICA DE CABEZA Y\/O CUELLO"
  },
  {
    "codigo":735392002,
    "descripcion":"LINFEDEMA POSTURAL DEBIDO A ALTERACIÓN DE LA MOVILIDAD"
  },
  {
    "codigo":1259680005,
    "descripcion":"CARCINOMA PRIMARIO DE GLÁNDULA DE MEIBOMIO"
  },
  {
    "codigo":147111000119106,
    "descripcion":"OLIGODENDROGLIOMA DE SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":243872007,
    "descripcion":"SITUACIÓN DEL MONITOREO DE DROGA DE ALTO RIESGO"
  },
  {
    "codigo":1290613000,
    "descripcion":"RADIOGRAFÍA DE MIEMBRO INFERIOR ANORMAL"
  },
  {
    "codigo":276640009,
    "descripcion":"HIPOXIA FETAL INTRAPARTO"
  },
  {
    "codigo":211104009,
    "descripcion":"PICADURA DE INSECTO, NO VENENOSO, DE LA PARED TORÁCICA"
  },
  {
    "codigo":702624008,
    "descripcion":"APLASIA DE BAZO"
  },
  {
    "codigo":209269003,
    "descripcion":"FRACTURA-LUXACIÓN NO EXPUESTA DE HUESO SEMILUNAR (PALMAR)"
  },
  {
    "codigo":405877004,
    "descripcion":"FENOTIPO LE(A+B+)"
  },
  {
    "codigo":373109008,
    "descripcion":"POST VENTRICULOGRAFÍA"
  },
  {
    "codigo":240202000,
    "descripcion":"RUPTURA DE LA BOLSA SEROSA POPLÍTEA"
  },
  {
    "codigo":15685441000119102,
    "descripcion":"RETINITIS DE AMBOS OJOS CAUSADA POR TREPONEMA PALLIDUM"
  },
  {
    "codigo":830026003,
    "descripcion":"QUISTE DERMOIDE DE CONJUNTIVA DE OJO IZQUIERDO"
  },
  {
    "codigo":76362004,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE LA ENCÍA, CON INFECCIÓN"
  },
  {
    "codigo":698954005,
    "descripcion":"DEMENCIA DEGENERATIVA PRIMARIA DE TIPO ALZHEIMER, COMIENZO SENIL, EN REMISIÓN"
  },
  {
    "codigo":404042005,
    "descripcion":"TUMOR NEUROECTODÉRMICO PIGMENTADO INFANTIL"
  },
  {
    "codigo":307573009,
    "descripcion":"CONDROMA ÓSEO"
  },
  {
    "codigo":1256010001,
    "descripcion":"CONVIVENCIA EN VIVIENDA COMPARTIDA"
  },
  {
    "codigo":271135001,
    "descripcion":"AMPOLLA TRAUMÁTICA DE PARED ABDOMINAL, INFECTADA"
  },
  {
    "codigo":402207002,
    "descripcion":"OTITIS EXTERNA SEBORREICA AGUDA"
  },
  {
    "codigo":305738006,
    "descripcion":"ATENDIDO POR ENFERMERA DE ENLACE DE DIABETES"
  },
  {
    "codigo":238367006,
    "descripcion":"INFECCIÓN CUTÁNEA POR VIRUS POX"
  },
  {
    "codigo":236532003,
    "descripcion":"ACIDOSIS TUBULAR RENAL CON SORDERA NERVIOSA PROGRESIVA"
  },
  {
    "codigo":302068003,
    "descripcion":"GLÁNDULA TIROIDES PEQUEÑA"
  },
  {
    "codigo":11999041000119106,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO DEL DORSO DE MANO DERECHA"
  },
  {
    "codigo":300233000,
    "descripcion":"HALLAZGO RELACIONADO CON LA DENTICIÓN"
  },
  {
    "codigo":38089000,
    "descripcion":"ROTACIÓN DE DIENTE"
  },
  {
    "codigo":11808731000119101,
    "descripcion":"PERFORACIÓN TRAUMÁTICA DE COLON DESCENDENTE"
  },
  {
    "codigo":5321004,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE LA RODILLA"
  },
  {
    "codigo":70857003,
    "descripcion":"EFECTO TÓXICO DEL PARATIÓN"
  },
  {
    "codigo":201929006,
    "descripcion":"ENFERMEDAD DE KASHIN-BECK DE MÚLTIPLES LOCALIZACIONES"
  },
  {
    "codigo":365769003,
    "descripcion":"NIVELES DE ENZIMAS HEPÁTICAS - HALLAZGO"
  },
  {
    "codigo":726217008,
    "descripcion":"LESIÓN TRAUMÁTICA DE FASCIA DE MÚSCULO DE LA CADERA"
  },
  {
    "codigo":339931000119101,
    "descripcion":"VASCULARIZACIÓN LOCALIZADA DE CÓRNEA IZQUIERDA"
  },
  {
    "codigo":36254004,
    "descripcion":"FORÚNCULO DE ANTEBRAZO"
  },
  {
    "codigo":298398005,
    "descripcion":"COLUMNA CERVICAL TUMEFACTA"
  },
  {
    "codigo":167326006,
    "descripcion":"UROBILINÓGENO EN ORINA: ++"
  },
  {
    "codigo":296563001,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE PRIMAQUINA"
  },
  {
    "codigo":722547006,
    "descripcion":"MENINGITIS CAUSADA POR ENTEROVIRUS HUMANO 71"
  },
  {
    "codigo":16068571000119105,
    "descripcion":"ARTRITIS GOTOSA DE AMBAS MUÑECAS"
  },
  {
    "codigo":294728006,
    "descripcion":"ALERGIA A SULFONILUREA"
  },
  {
    "codigo":292893002,
    "descripcion":"REACCIÓN ADVERSA AL BORATO"
  },
  {
    "codigo":1144861002,
    "descripcion":"APLASIA DE COLUMNA DE SUSTANCIA BLANCA DE MÉDULA ESPINAL"
  },
  {
    "codigo":717042001,
    "descripcion":"ENFERMEDAD SIMILAR A LA ENFERMEDAD DE PELIZAEUS MERZBACHER"
  },
  {
    "codigo":127218004,
    "descripcion":"HIPERPLASIA FOLICULAR REACTIVA EN LOS ANCIANOS"
  },
  {
    "codigo":94450005,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL NERVIO OCULOMOTOR"
  },
  {
    "codigo":225522006,
    "descripcion":"SIENTE QUE LOS SUEÑOS SON REALES"
  },
  {
    "codigo":28914006,
    "descripcion":"ECTROPIÓN CICATRIZAL"
  },
  {
    "codigo":289223001,
    "descripcion":"SEGUNDA ETAPA DEL TRABAJO DE PARTO, NORMAL"
  },
  {
    "codigo":59847006,
    "descripcion":"PRODUCCIÓN NORMAL DE MONOCITOS"
  },
  {
    "codigo":190919008,
    "descripcion":"XANTINURIA"
  },
  {
    "codigo":254620000,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS DE LA TRÁQUEA"
  },
  {
    "codigo":189084001,
    "descripcion":"NEOPLASIA BENIGNA DE LA PIEL DE LA PIERNA"
  },
  {
    "codigo":1303196009,
    "descripcion":"INFECCIÓN DE RÓTULA ASOCIADA CON DISPOSITIVO DE FIJACIÓN INTERNA"
  },
  {
    "codigo":1137521001,
    "descripcion":"CALCIFICACIÓN PUNTEADA DE EPÍFISIS DE FALANGE DE CUARTO DEDO DE PIE"
  },
  {
    "codigo":711537006,
    "descripcion":"SOBRECRECIMIENTO DE HONGOS EN ESPÉCIMEN"
  },
  {
    "codigo":16015631000119102,
    "descripcion":"OSTEOPATÍA DE PIE IZQUIERDO POSTERIOR A POLIOMIELITIS"
  },
  {
    "codigo":250950004,
    "descripcion":"ACINESIA DE LA PARED DEL VENTRÍCULO DERECHO"
  },
  {
    "codigo":185414006,
    "descripcion":"CITA SOLICITADA POR COMPAÑERO DE TRABAJO"
  },
  {
    "codigo":283718007,
    "descripcion":"MORDEDURA HUMANA EN LA INGLE"
  },
  {
    "codigo":314651007,
    "descripcion":"PERÍMETRO CEFÁLICO DEL NIÑO: PERCENTILO 26-49"
  },
  {
    "codigo":249115008,
    "descripcion":"ENCAJE DE PRESENTACIÓN DE NALGAS"
  },
  {
    "codigo":609563008,
    "descripcion":"DIABETES MELLITUS PREEXISTENTE EN EL EMBARAZO"
  },
  {
    "codigo":17904003,
    "descripcion":"LARINGITIS HIPERTRÓFICA"
  },
  {
    "codigo":214512005,
    "descripcion":"ACCIDENTE DE TRÁNSITO VEHICULAR DE TIPO NO COLISIÓN CON INTOXICACIÓN ACCIDENTAL POR GASES DE ESCAPE GENERADOS POR EL VEHÍCULO EN MOVIMIENTO, PEATÓN HERIDO"
  },
  {
    "codigo":16316841000119100,
    "descripcion":"MASTITIS PURULENTA DURANTE EMBARAZO"
  },
  {
    "codigo":1079721000119100,
    "descripcion":"NEVO MELANOCÍTICO PIGMENTADO CONGÉNITO DE PIEL DE MIEMBRO INFERIOR DERECHO"
  },
  {
    "codigo":247280008,
    "descripcion":"SIGNO DE FÍSTULA EN LA HENDIDURA DEL OÍDO MEDIO"
  },
  {
    "codigo":704197006,
    "descripcion":"ADMITE CONSUMO DE ALCOHOL"
  },
  {
    "codigo":407450002,
    "descripcion":"INFECCIÓN POR VIRUS DEL HERPES SIMPLE, TIPO 2"
  },
  {
    "codigo":735130003,
    "descripcion":"GRANULOMA FISURADO CUTÁNEO"
  },
  {
    "codigo":702362004,
    "descripcion":"SÍNDROME CRANEOFACIAL-SORDERA-MANO"
  },
  {
    "codigo":1259418003,
    "descripcion":"CARCINOMA PRIMARIO DE MAMA - CUADRANTE SUPEROINTERNO"
  },
  {
    "codigo":368911000119109,
    "descripcion":"SÍNDROME NEFRÓTICO CONCOMITANTE CON GLOMERULONEFRITIS MEMBRANOPROLIFERATIVA TIPO III Y DEBIDO A ELLA"
  },
  {
    "codigo":1357722004,
    "descripcion":"POBREZA ENERGÉTICA DOMÉSTICA DEBIDA A DESCONEXIÓN DE SERVICIO DE PROVISIÓN DE ENERGÍA"
  },
  {
    "codigo":472986005,
    "descripcion":"ACTIVIDAD SEXUAL CON HOMBRES"
  },
  {
    "codigo":307311001,
    "descripcion":"ASCITIS INFECTADA"
  },
  {
    "codigo":733295004,
    "descripcion":"AVULSIÓN DE TUBEROSIDAD DE LA TIBIA"
  },
  {
    "codigo":209007006,
    "descripcion":"LUXACIÓN TRAUMÁTICA ABIERTA DE ARTICULACIÓN INTERFALÁNGICA ÚNICA DE DEDO DE PIE"
  },
  {
    "codigo":371012000,
    "descripcion":"LEUCEMIA LINFOBLÁSTICA AGUDA TRANSICIONAL DE CÉLULAS PRE-B"
  },
  {
    "codigo":239940004,
    "descripcion":"GRANULOMATOSIS LINFOMATOIDEA"
  },
  {
    "codigo":342441000119106,
    "descripcion":"FILARIASIS LINFÁTICA DE PÁRPADO INFERIOR IZQUIERDO"
  },
  {
    "codigo":10564005,
    "descripcion":"ESFEROCITOSIS HEREDITARIA SEVERA POR DEFICIENCIA COMBINADA DE ESPECTRINA Y ANQUIRINA"
  },
  {
    "codigo":403780007,
    "descripcion":"SÍNDROME AUTOSÓMICO RECESIVO DE QUERATITIS-ICTIOSIS-SORDERA"
  },
  {
    "codigo":1255748007,
    "descripcion":"HISTIOCITOSIS MALIGNA DE GANGLIOS LINFÁTICOS DE CABEZA Y CUELLO"
  },
  {
    "codigo":698692009,
    "descripcion":"TRASTORNO DE HIPERACTIVIDAD CON DÉFICIT DE ATENCIÓN, CON PREDOMINIO DE HIPERACTIVIDAD-IMPULSIVIDAD, EN REMISIÓN"
  },
  {
    "codigo":305476004,
    "descripcion":"BAJO ATENCIÓN DE ESPECIALISTA EN VÍAS RESPIRATORIAS"
  },
  {
    "codigo":8729004,
    "descripcion":"RECHAZO CRÓNICO DE INJERTO"
  },
  {
    "codigo":238105005,
    "descripcion":"DISTROFIA POR DESNUTRICIÓN"
  },
  {
    "codigo":41497008,
    "descripcion":"CONVULSIÓN FEBRIL"
  },
  {
    "codigo":72430001,
    "descripcion":"FARINGITIS GANGRENOSA"
  },
  {
    "codigo":170734001,
    "descripcion":"NIVEL DE ÁCIDO ÚRICO ANTES DEL TRATAMIENTO"
  },
  {
    "codigo":203502000,
    "descripcion":"CONSOLIDACIÓN DEFECTUOSA ANGULAR DE FRACTURA"
  },
  {
    "codigo":39662004,
    "descripcion":"DISTROFIA CORNEAL CRISTALINA"
  },
  {
    "codigo":431043000,
    "descripcion":"TRASTORNO DE NERVIO PERIFÉRICO ASOCIADO CON REPARACIÓN DE HERNIA"
  },
  {
    "codigo":365507001,
    "descripcion":"AUTOCONTROL - HALLAZGO"
  },
  {
    "codigo":234435002,
    "descripcion":"HIPERSEGMENTACIÓN HEREDITARIA"
  },
  {
    "codigo":15635011000119104,
    "descripcion":"TUMORACIÓN DE LA GLÁNDULA PARÓTIDA DERECHA"
  },
  {
    "codigo":299971005,
    "descripcion":"PICADURA DE INSECTO"
  },
  {
    "codigo":201667007,
    "descripcion":"ARTRITIS GOTOSA DE REGIÓN PÉLVICA Y MUSLO"
  },
  {
    "codigo":298136004,
    "descripcion":"HERNIA PARAESTOMAL DE UROSTOMÍA"
  },
  {
    "codigo":396440008,
    "descripcion":"REMISIÓN QUE INVOLUCRA EL 75 % O MÁS DEL TUMOR, PRESENTE"
  },
  {
    "codigo":296301000,
    "descripcion":"SOBREDOSIS DE CANABIS"
  },
  {
    "codigo":1344877003,
    "descripcion":"APEGO ANSIOSO RESISTENTE"
  },
  {
    "codigo":722285005,
    "descripcion":"SÍNDROME DE ALBINISMO CON SORDERA"
  },
  {
    "codigo":1017197007,
    "descripcion":"FIBROSIS PULMONAR INTERSTICIAL POR INHALACIÓN DE FÁRMACO"
  },
  {
    "codigo":294466005,
    "descripcion":"ALERGIA A ESTREPTOMICINA"
  },
  {
    "codigo":718615003,
    "descripcion":"SÍNDROME DE MICRODELECIÓN 8Q21.11"
  },
  {
    "codigo":292631004,
    "descripcion":"REACCIÓN ADVERSA AL DITRANOL"
  },
  {
    "codigo":126956001,
    "descripcion":"NEOPLASIA DEL LÓBULO PARIETAL"
  },
  {
    "codigo":28652005,
    "descripcion":"EVALUACIÓN DE DISCAPACIDAD: 85%"
  },
  {
    "codigo":389100007,
    "descripcion":"ENCEFALOPATÍA ISQUÉMICA"
  },
  {
    "codigo":1306604007,
    "descripcion":"NEUMONITIS INTERSTICIAL"
  },
  {
    "codigo":290796007,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR BROMOCRIPTINA"
  },
  {
    "codigo":125661000119107,
    "descripcion":"CÓLICO BILIAR CON OBSTRUCCIÓN"
  },
  {
    "codigo":288961002,
    "descripcion":"NO TRAGA SALIVA"
  },
  {
    "codigo":190657005,
    "descripcion":"DEFICIENCIA ALIMENTARIA DE YODO"
  },
  {
    "codigo":92353007,
    "descripcion":"NEOPLASIA BENIGNA DE LA PIEL DEL MENTÓN"
  },
  {
    "codigo":385430001,
    "descripcion":"OSTEOCONDROMA DE OMÓPLATO"
  },
  {
    "codigo":287126007,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN LA CÓRNEA"
  },
  {
    "codigo":24982008,
    "descripcion":"DIPLOPÍA"
  },
  {
    "codigo":250688000,
    "descripcion":"ALFA-1-ANTITRIPSINA, FENOTIPO PISZ"
  },
  {
    "codigo":840512003,
    "descripcion":"AUSENCIA CONGÉNITA DE DEDOS DE AMBOS PIES"
  },
  {
    "codigo":283456007,
    "descripcion":"HERIDA PUNZANTE EN EL LABIO"
  },
  {
    "codigo":21312008,
    "descripcion":"ESTIMULACIÓN ORAL DE PENE"
  },
  {
    "codigo":344951000119107,
    "descripcion":"SIDEROSIS DE AMBOS OJOS"
  },
  {
    "codigo":248853005,
    "descripcion":"BORDE DEL HIMEN"
  },
  {
    "codigo":738538001,
    "descripcion":"METABOLIZADOR NORMAL DE MIEMBRO A1 DE LA FAMILIA 1 DE URIDINA DIFOSFATO GLUCURONOSILTRANSFERASA"
  },
  {
    "codigo":15991671000119109,
    "descripcion":"IRIDOCICLITIS DE AMBOS OJOS CAUSADA POR MYCOBACTERIUM TUBERCULOSIS"
  },
  {
    "codigo":1082231000119109,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE LÓBULO INFERIOR DE PULMÓN DERECHO"
  },
  {
    "codigo":83178006,
    "descripcion":"VÍCTIMA DE CONTIENDA DE GUERRILLA"
  },
  {
    "codigo":771306007,
    "descripcion":"SÍNDROME DE POIQUILODERMIA FIBROSANTE, CONTRACTURAS EN LOS TENDONES, MIOPATÍA Y FIBROSIS PULMONAR"
  },
  {
    "codigo":50410009,
    "descripcion":"TRASTORNO DEL TUBO DIGESTIVO SUPERIOR"
  },
  {
    "codigo":736703007,
    "descripcion":"PORTADOR DE MUTACIÓN DE GEN HFE DE LA HEMOCROMATOSIS"
  },
  {
    "codigo":11787281000119105,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE DEDO ÍNDICE IZQUIERDO CON INFECCIÓN"
  },
  {
    "codigo":441791009,
    "descripcion":"VOLUMEN DE ERITROCITOS FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":767636002,
    "descripcion":"TRASTORNO BIPOLAR I, EPISODIO MÁS RECIENTE DEPRESIVO"
  },
  {
    "codigo":13972004,
    "descripcion":"INTOXICACIÓN POR CUPRESSUS"
  },
  {
    "codigo":733033001,
    "descripcion":"SÍNDROME DE ATAXIA ESPINOCEREBELOSA Y DISMORFISMO"
  },
  {
    "codigo":110441005,
    "descripcion":"AUSENCIA DE CORPÚSCULO DE BARR, SEXO NUCLEAR MASCULINO"
  },
  {
    "codigo":700265007,
    "descripcion":"ENTROPIÓN SENIL DE PÁRPADO INFERIOR"
  },
  {
    "codigo":307049007,
    "descripcion":"SENSACIÓN DE ALIENACIÓN"
  },
  {
    "codigo":10859691000119103,
    "descripcion":"ALIMENTO ASPIRADO EN BRONQUIO"
  },
  {
    "codigo":41235001,
    "descripcion":"FORMA SECA DE LEISHMANIASIS CUTÁNEA"
  },
  {
    "codigo":403518009,
    "descripcion":"VASCULITIS NECROSANTE ASOCIADA CON ESCLERODERMIA"
  },
  {
    "codigo":74003001,
    "descripcion":"HIPONATREMIA CON VOLUMEN DE LÍQUIDO EXTRACELULAR NORMAL"
  },
  {
    "codigo":40131000087100,
    "descripcion":"LUXACIÓN DE ARTICULACIÓN DE DEDO ÍNDICE DE MANO DERECHA"
  },
  {
    "codigo":47811000087100,
    "descripcion":"FRACTURA DE NOVENA COSTILLA DERECHA"
  },
  {
    "codigo":203240001,
    "descripcion":"INFECCIÓN DE MÚLTIPLES HUESOS"
  },
  {
    "codigo":237843009,
    "descripcion":"PSEUDOHIPONATREMIA"
  },
  {
    "codigo":39400004,
    "descripcion":"LESIÓN TRAUMÁTICA DEL HÍGADO"
  },
  {
    "codigo":236008004,
    "descripcion":"ESTEATONECROSIS MESENTÉRICA"
  },
  {
    "codigo":771507004,
    "descripcion":"PREMATUREZ DEL LACTANTE - MODERADA A TARDÍA"
  },
  {
    "codigo":72168007,
    "descripcion":"ÁNTRAX DORSAL, SIN COMPROMISO DE LAS NALGAS"
  },
  {
    "codigo":135869000,
    "descripcion":"FRENILLO DE PENE DESGARRADO"
  },
  {
    "codigo":365245001,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD DE PREPARAR UN BANQUETE PARA OTROS"
  },
  {
    "codigo":299709002,
    "descripcion":"ABSCESO DENTAL"
  },
  {
    "codigo":37565002,
    "descripcion":"CICLITIS SUBAGUDA"
  },
  {
    "codigo":1217213004,
    "descripcion":"ACROOSTEÓLISIS FALÁNGICA IDIOPÁTICA"
  },
  {
    "codigo":432616009,
    "descripcion":"INFECCIÓN DE DERIVACIÓN VENTRICULOPERITONEAL"
  },
  {
    "codigo":823997007,
    "descripcion":"REGULARIDAD DE PUPILA NORMAL"
  },
  {
    "codigo":232338000,
    "descripcion":"NEOPLASIA DE OÍDO MEDIO Y MASTOIDES"
  },
  {
    "codigo":234173007,
    "descripcion":"CHOQUE SÉPTICO HIPERDINÁMICO"
  },
  {
    "codigo":723858002,
    "descripcion":"ANEURISMA VENTRICULAR DEBIDO A INFARTO AGUDO DE MIOCARDIO Y POSTERIOR A ÉL"
  },
  {
    "codigo":1084741000119103,
    "descripcion":"MENINGOENCEFALITIS DEBIDA A BLASTOMYCES DERMATITIDIS"
  },
  {
    "codigo":789394007,
    "descripcion":"TENDINITIS DE REGIÓN DEL HOMBRO"
  },
  {
    "codigo":427111000,
    "descripcion":"MIOCLONÍA NO EPILÉPTICA"
  },
  {
    "codigo":166802008,
    "descripcion":"ELECTROFORESIS DE PROTEÍNAS DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":33895002,
    "descripcion":"REQUERIMIENTO METABÓLICO DISMINUIDO"
  },
  {
    "codigo":363410008,
    "descripcion":"NEOPLASIA MALIGNA DE COLON SIGMOIDE"
  },
  {
    "codigo":296039004,
    "descripcion":"SOBREDOSIS INTENCIONAL DE AMOBARBITAL"
  },
  {
    "codigo":263271000,
    "descripcion":"FRACTURA SIN COMPLICACIONES DE CORONA DENTAL"
  },
  {
    "codigo":230503008,
    "descripcion":"ANOSMIA MUCOSA"
  },
  {
    "codigo":195900001,
    "descripcion":"NEUMONÍA DEBIDA A SARAMPIÓN"
  },
  {
    "codigo":458044005,
    "descripcion":"RAQUIPAGOS"
  },
  {
    "codigo":785724007,
    "descripcion":"SÍNDROME DE PIODERMIA GANGRENOSA, ACNÉ E HIDRADENITIS SUPURATIVA"
  },
  {
    "codigo":1144337000,
    "descripcion":"HIPOPLASIA CONGÉNITA DE HEMISFERIO CEREBRAL"
  },
  {
    "codigo":163132008,
    "descripcion":"EVALUACIÓN DEL TRACTO GASTROINTESTINAL - NO SE DETECTARON ANOMALÍAS"
  },
  {
    "codigo":128529002,
    "descripcion":"ENFERMEDAD MAMARIA CRÓNICA"
  },
  {
    "codigo":64828009,
    "descripcion":"MITRIDATISMO"
  },
  {
    "codigo":194065004,
    "descripcion":"TRASTORNO INFLAMATORIO DE CINTILLA ÓPTICA"
  },
  {
    "codigo":294204008,
    "descripcion":"ALERGIA A NITRATO DE PLATA"
  },
  {
    "codigo":292369003,
    "descripcion":"REACCIÓN ADVERSA A LA BUSPIRONA"
  },
  {
    "codigo":423441007,
    "descripcion":"LESIÓN TRAUMÁTICA DE SISTEMA RESPIRATORIO DEBIDA A INHALACIÓN DE PARTÍCULAS"
  },
  {
    "codigo":347461000119107,
    "descripcion":"CATARATA SENIL HIPERMADURA DE OJO DERECHO"
  },
  {
    "codigo":126694003,
    "descripcion":"NEOPLASIA DE LA COMISURA DE LA LARINGE"
  },
  {
    "codigo":224998004,
    "descripcion":"LENTO PARA APRENDER"
  },
  {
    "codigo":93926005,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA NARIZ"
  },
  {
    "codigo":290534009,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR CINCOCAÍNA"
  },
  {
    "codigo":92091003,
    "descripcion":"NEOPLASIA BENIGNA DEL ESÓFAGO"
  },
  {
    "codigo":288699006,
    "descripcion":"DIFICULTAD PARA COMUNICARSE CON DIFERENTES PERSONAS"
  },
  {
    "codigo":254096001,
    "descripcion":"DISPLASIA CIFOMÉLICA"
  },
  {
    "codigo":90256008,
    "descripcion":"TASA DE RENOVACIÓN ÓSEA AUMENTADA"
  },
  {
    "codigo":416101003,
    "descripcion":"RESONANCIA MAGNÉTICA ABDOMINAL, NORMAL"
  },
  {
    "codigo":285029003,
    "descripcion":"INCAPAZ DE MANEJAR UN ARTEFACTO MIENTRAS SE DESVISTE"
  },
  {
    "codigo":283194002,
    "descripcion":"ANZUELO EN EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":250426008,
    "descripcion":"RESULTADO DUDOSO DE PRUEBA DE EMBARAZO"
  },
  {
    "codigo":1004090008,
    "descripcion":"COMPRESIÓN DE NERVIO CUBITAL IZQUIERDO A LA ALTURA DEL CODO"
  },
  {
    "codigo":51983000,
    "descripcion":"ESOTROPÍA ALTERNANTE CON PATRÓN X Y\/O Y"
  },
  {
    "codigo":248591004,
    "descripcion":"INCAPAZ DE RESOPLAR"
  },
  {
    "codigo":1297167005,
    "descripcion":"HERIDA PUNZANTE DE REGIÓN DE RODILLA CON CUERPO EXTRAÑO"
  },
  {
    "codigo":1231631006,
    "descripcion":"DESVIACIÓN SOSTENIDA DE LA MIRADA CONJUGADA HORIZONTAL DE TIPO IPSILATERAL"
  },
  {
    "codigo":281359008,
    "descripcion":"SINOVITIS TRAUMÁTICA"
  },
  {
    "codigo":707343008,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE SENO FRONTAL"
  },
  {
    "codigo":17380002,
    "descripcion":"INTENTO FALLIDO DE ABORTO CON INSUFICIENCIA RENAL AGUDA"
  },
  {
    "codigo":246756004,
    "descripcion":"DESVIACIÓN TORSIONAL DEL OJO"
  },
  {
    "codigo":11818771000119100,
    "descripcion":"ESGUINCE DE LIGAMENTO DE ARTICULACIÓN INTERFALÁNGICA DE DEDO MEDIO DERECHO"
  },
  {
    "codigo":738276008,
    "descripcion":"TRASTORNO DE SISTEMA NERVIOSO CENTRAL CONCOMITANTE CON INFECCIÓN POR VIRUS DE LA GRIPE Y DEBIDO A ELLA"
  },
  {
    "codigo":441529001,
    "descripcion":"DISFASIA COMO EFECTO TARDÍO DE ENFERMEDAD CEREBROVASCULAR"
  },
  {
    "codigo":15545001,
    "descripcion":"DUPLICACIÓN CONGÉNITA DEL ÚTERO"
  },
  {
    "codigo":82916009,
    "descripcion":"SÍNDROME DE OBSTRUCCIÓN DEL CUELLO VESICAL FEMENINO"
  },
  {
    "codigo":310457008,
    "descripcion":"ESTADO DEL INFORME DE REGISTRO DE DISCAPACIDAD"
  },
  {
    "codigo":677651000119102,
    "descripcion":"NEOVASCULARIZACIÓN DE COROIDES DE OJO IZQUIERDO"
  },
  {
    "codigo":13710008,
    "descripcion":"HERPES SIMPLE DISEMINADO"
  },
  {
    "codigo":110179007,
    "descripcion":"QUEMADURA EPIDÉRMICA DE LA REGIÓN PERIORAL"
  },
  {
    "codigo":42808000,
    "descripcion":"DEFICIENCIA LONGITUDINAL DE TIBIA"
  },
  {
    "codigo":208483008,
    "descripcion":"FRACTURA EXPUESTA DE FALANGE MEDIA DE DEDO DE LA MANO"
  },
  {
    "codigo":370488005,
    "descripcion":"SEUDOQUISTE PERIRRENAL"
  },
  {
    "codigo":323501000119100,
    "descripcion":"DEFORMIDAD EN VARO ADQUIRIDA DE RODILLA IZQUIERDA"
  },
  {
    "codigo":551451000124102,
    "descripcion":"VÍCTIMA DE MALTRATO EMOCIONAL POR PARTE DE PAREJA ÍNTIMA"
  },
  {
    "codigo":1156920008,
    "descripcion":"INMUNIDAD CONTRA TOS CONVULSA DETERMINADA SEROLOGÍA"
  },
  {
    "codigo":433691000124104,
    "descripcion":"HIPOTENSIÓN INTRACRANEANA"
  },
  {
    "codigo":403256009,
    "descripcion":"HIPERMELANOSIS DE PÁRPADOS POR HIPERTIROIDISMO"
  },
  {
    "codigo":237581005,
    "descripcion":"SECRECIÓN ANORMAL DE SECRETINA"
  },
  {
    "codigo":432354000,
    "descripcion":"CONVULSIÓN FEBRIL SIMPLE"
  },
  {
    "codigo":268514004,
    "descripcion":"EN TRATAMIENTO CON LITIO"
  },
  {
    "codigo":71906005,
    "descripcion":"PARONIQUIA"
  },
  {
    "codigo":235746007,
    "descripcion":"COLITIS INDETERMINADA"
  },
  {
    "codigo":301282008,
    "descripcion":"HALLAZGO EN LA RESPIRACIÓN"
  },
  {
    "codigo":792802009,
    "descripcion":"PULSO EN ARTERIA TIBIAL ANTERIOR IZQUIERDA PRESENTE"
  },
  {
    "codigo":397751001,
    "descripcion":"LESIÓN DE NERVIO MEDIANO"
  },
  {
    "codigo":201143000,
    "descripcion":"ALOPECIA SEBORREICA"
  },
  {
    "codigo":364983001,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD DE REALIZAR LA PRENSIÓN CON OPOSICIÓN DEL PULGAR"
  },
  {
    "codigo":725431001,
    "descripcion":"SUSCEPTIBILIDAD MENDELIANA AUTOSÓMICA RECESIVA A ENFERMEDAD POR MICOBACTERIAS DEBIDA A DEFICIENCIA PARCIAL DE RECEPTOR 1 DE INTERFERÓN GAMMA"
  },
  {
    "codigo":399586008,
    "descripcion":"NO SE PUEDE VALORAR INVASIÓN TUMORAL VENOSA(GRANDES VASOS)\/LINFÁTICA(PEQUEÑOS VASOS)"
  },
  {
    "codigo":37303008,
    "descripcion":"SENSIBILIDAD AL OLOR DE UN INDIVIDUO"
  },
  {
    "codigo":232076001,
    "descripcion":"AMILOIDE DEL CUERPO VÍTREO"
  },
  {
    "codigo":299447008,
    "descripcion":"ARTICULACIÓN DE TOBILLO DOLOROSA AL MOVIMIENTO"
  },
  {
    "codigo":233911009,
    "descripcion":"FIBRILACIÓN AURICULAR NO REUMÁTICA"
  },
  {
    "codigo":199308008,
    "descripcion":"SUBLUXACIÓN DE LA SÍNFISIS PÚBICA EN EL EMBARAZO, EL PARTO Y EL PUERPERIO"
  },
  {
    "codigo":230241000,
    "descripcion":"DEGENERACIÓN CEREBELOSA SECUNDARIA"
  },
  {
    "codigo":721761000,
    "descripcion":"INFECCIÓN CAUSADA POR VIRUS LINFOTRÓPICO DE CÉLULAS T HUMANO"
  },
  {
    "codigo":865004,
    "descripcion":"FÓRMULA DE HIPERALIMENTACIÓN PARA EL TRATAMIENTO DEL ÍLEO"
  },
  {
    "codigo":263009006,
    "descripcion":"LUXACIÓN DE ARTICULACIÓN ESTERNOCLAVICULAR"
  },
  {
    "codigo":293942001,
    "descripcion":"ALERGIA A TIOXANTENO"
  },
  {
    "codigo":228406007,
    "descripcion":"INTERCAMBIA AGUJAS"
  },
  {
    "codigo":457782008,
    "descripcion":"RUPTURA DE MÚSCULO PAPILAR DE VÁLVULA AURICULOVENTRICULAR IZQUIERDA (MORFOLÓGICAMENTE NO MITRAL)"
  },
  {
    "codigo":62731002,
    "descripcion":"INCREMENTO DE LA TOS"
  },
  {
    "codigo":161035003,
    "descripcion":"SIN DIETA ESPECIAL"
  },
  {
    "codigo":95499004,
    "descripcion":"HIPOPLASIA DEL NERVIO ÓPTICO"
  },
  {
    "codigo":292107005,
    "descripcion":"REACCIÓN ADVERSA A LA CIMETIDINA"
  },
  {
    "codigo":716256003,
    "descripcion":"CANDIDA INCONSPICUA O CANDIDA KRUSEI"
  },
  {
    "codigo":28128004,
    "descripcion":"ROTACIÓN FETAL EXTERNA"
  },
  {
    "codigo":880096005,
    "descripcion":"DERMATITIS POR INFESTACIÓN DE LIPONYSSOIDES SANGUINEUS"
  },
  {
    "codigo":124597000,
    "descripcion":"DEFICIENCIA DE FOSFORRIBOSILAMINOIMIDAZOL CARBOXILASA"
  },
  {
    "codigo":288437000,
    "descripcion":"INCAPAZ DE REALIZAR ACTIVIDADES DE DIBUJO"
  },
  {
    "codigo":714421002,
    "descripcion":"DIFICULTAD PARA ACORDAR CON EL PLAN DE ATENCIÓN"
  },
  {
    "codigo":60896008,
    "descripcion":"ATIPIA DE CUELLO UTERINO"
  },
  {
    "codigo":286602003,
    "descripcion":"CUERPO EXTRAÑO EN EL INTESTINO GRUESO"
  },
  {
    "codigo":24458006,
    "descripcion":"FALLA PRIMARIA DE INJERTO"
  },
  {
    "codigo":188298006,
    "descripcion":"NEOPLASIA MALIGNA DE LA PROTUBERANCIA"
  },
  {
    "codigo":253834007,
    "descripcion":"AGENESIA DE VAGINA INFERIOR"
  },
  {
    "codigo":186463002,
    "descripcion":"INFECCIÓN POR MIMA POLYMORPHA"
  },
  {
    "codigo":448607004,
    "descripcion":"LINFOMA NO HODGKIN DIFUSO DE CUELLO UTERINO"
  },
  {
    "codigo":251999009,
    "descripcion":"CUELLO VESICAL DESCENDIDO EN CONDICIONES DE ESTRÉS"
  },
  {
    "codigo":53556002,
    "descripcion":"NEFROPATÍA POR CISPLATINO"
  },
  {
    "codigo":250164003,
    "descripcion":"CALZADO CON ASPECTO DE MALA CALIDAD"
  },
  {
    "codigo":282932005,
    "descripcion":"SE INCORPORA DEL DECÚBITO PARA SENTARSE"
  },
  {
    "codigo":1264137001,
    "descripcion":"PARAMETRITIS POSTERIOR A EMBARAZO ECTÓPICO"
  },
  {
    "codigo":18953001,
    "descripcion":"OTITIS EXTERNA AGUDA POR CONTACTO"
  },
  {
    "codigo":442163005,
    "descripcion":"ATENDIDO EN DEPARTAMENTO DE MICROBIOLOGÍA"
  },
  {
    "codigo":49886003,
    "descripcion":"TROMBOCITOPENIA POR PÉRDIDA DE SANGRE"
  },
  {
    "codigo":770782004,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL SUPERFICIAL DE LA PIEL DE LOS LABIOS SUPERIOR E INFERIOR"
  },
  {
    "codigo":836318007,
    "descripcion":"AGUDEZA VISUAL CORREGIDA DE OJO IZQUIERDO 4\/60"
  },
  {
    "codigo":15648861000119100,
    "descripcion":"ANEURISMA DE ARTERIA SUBCLAVIA DERECHA"
  },
  {
    "codigo":15935581000119100,
    "descripcion":"DEFORMIDAD EN FLEXIÓN DE AMBOS PIES"
  },
  {
    "codigo":11816541000119102,
    "descripcion":"LESIÓN TRAUMÁTICA DE VENA BRAQUIAL DERECHA"
  },
  {
    "codigo":317021000119103,
    "descripcion":"REUMATISMO PALINDRÓMICO DE ARTICULACIÓN DE MANO IZQUIERDA"
  },
  {
    "codigo":10751581000119104,
    "descripcion":"TRABAJO DE PARTO OBSTRUIDO DEBIDO A DESPROPORCIÓN ENTRE EL FETO Y LA PELVIS"
  },
  {
    "codigo":12400221000119100,
    "descripcion":"DOLOR CRÓNICO POSTERIOR A ARTROPLASTIA TOTAL DE CADERA IZQUIERDA"
  },
  {
    "codigo":1085021000119106,
    "descripcion":"ASCITIS DE ETIOLOGÍA HEPÁTICA DEBIDA A HEPATITIS ALCOHÓLICA CRÓNICA"
  },
  {
    "codigo":125021000119107,
    "descripcion":"ASMA INTERMITENTE CONCOMITANTE CON RINITIS ALÉRGICA"
  },
  {
    "codigo":288861000119108,
    "descripcion":"TRASTORNO DEL ESTADO DE ÁNIMO INDUCIDO POR OPIOIDES DEBIDO A DEPENDENCIA DE OPIOIDES"
  },
  {
    "codigo":334941000119106,
    "descripcion":"ATROFIA DE DISCO ÓPTICO DE OJO DERECHO DEBIDA A GLAUCOMA"
  },
  {
    "codigo":135261000119106,
    "descripcion":"ESQUISTOSOMIASIS DE LA VÍA GENITOURINARIA"
  },
  {
    "codigo":299101000119108,
    "descripcion":"HEMARTROSIS DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":1260467009,
    "descripcion":"NEVO MELANOCÍTICO PIGMENTADO CONGÉNITO DE GRAN TAMAÑO"
  },
  {
    "codigo":11995741000119106,
    "descripcion":"EDEMA DE MUÑÓN DE AMPUTACIÓN DE MIEMBRO SUPERIOR DERECHO"
  },
  {
    "codigo":37981000119106,
    "descripcion":"DEHISCENCIA SUPERFICIAL DE HERIDA"
  },
  {
    "codigo":301661000119109,
    "descripcion":"ABSCESO DE VAINA TENDINOSA DE HOMBRO DERECHO"
  },
  {
    "codigo":119901000119109,
    "descripcion":"HEMORRAGIA CONCOMITANTE CON PLACENTA PREVIA PARCIAL Y DEBIDA A ELLA"
  },
  {
    "codigo":111752005,
    "descripcion":"FÍSTULA POSTOPERATORIA PERSISTENTE"
  },
  {
    "codigo":373896005,
    "descripcion":"ABORTO ESPONTÁNEO COMPLICADO POR INFECCIÓN GENITOPÉLVICA"
  },
  {
    "codigo":109917000,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LOS NERVIOS PERIFÉRICOS Y DEL SISTEMA NERVIOSO AUTÓNOMO"
  },
  {
    "codigo":697906004,
    "descripcion":"HIPERTENSIÓN DE ARTERIA PULMONAR ASOCIADA CON CORTOCIRCUITO SISTÉMICO-PULMONAR CONGÉNITO"
  },
  {
    "codigo":370226009,
    "descripcion":"CUMPLIMIENTO DEL TRATAMIENTO ANTIASMÁTICO, SATISFACTORIO"
  },
  {
    "codigo":402994009,
    "descripcion":"ACTINOMICETOMA CAUSADO POR ACTINOMADURA PELLETIERI"
  },
  {
    "codigo":73479003,
    "descripcion":"ADENOMIOMA DE VESÍCULA BILIAR"
  },
  {
    "codigo":237319004,
    "descripcion":"FALTA DE PROGRESIÓN DEL TRABAJO DE PARTO"
  },
  {
    "codigo":302855005,
    "descripcion":"LEUCEMIA SUBAGUDA"
  },
  {
    "codigo":204551008,
    "descripcion":"ESTENOSIS BRONQUIAL CONGÉNITA"
  },
  {
    "codigo":169948004,
    "descripcion":"LACTANTE DE ALTO RIESGO"
  },
  {
    "codigo":399324007,
    "descripcion":"FOLICULITIS BACTERIANA"
  },
  {
    "codigo":102577000,
    "descripcion":"TREPOPNEA"
  },
  {
    "codigo":366556009,
    "descripcion":"HALLAZGO RELACIONADO CON COLORACIÓN DE DEDO DE MANO"
  },
  {
    "codigo":266417001,
    "descripcion":"ENFERMEDAD DE PULPA Y TEJIDO PERIAPICAL"
  },
  {
    "codigo":430257003,
    "descripcion":"HALLAZGO DEL TRACTO GASTROINTESTINAL ASOCIADO CON EL EMBARAZO"
  },
  {
    "codigo":200881003,
    "descripcion":"DERMATITIS DE CONTACTO CAUSADA POR MATERIAL PARA CONSTRUCCIÓN DE YESOS ORTOPÉDICOS"
  },
  {
    "codigo":364721005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA EMPEZAR Y DEJAR DE CAMINAR ESPONTÁNEAMENTE"
  },
  {
    "codigo":299185004,
    "descripcion":"AMPLITUD DE OPOSICIÓN ACTIVA DEL PULGAR NORMAL"
  },
  {
    "codigo":233649005,
    "descripcion":"QUILOTÓRAX TUBERCULOSO"
  },
  {
    "codigo":4273008,
    "descripcion":"LUXACIÓN CERRADA POSTERIOR DE CODO"
  },
  {
    "codigo":67974004,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN LA NARIZ, CON INFECCIÓN"
  },
  {
    "codigo":2438005,
    "descripcion":"INIENCEFALIA"
  },
  {
    "codigo":723334006,
    "descripcion":"INMUNODEFICIENCIA RELACIONADA CON FADD"
  },
  {
    "codigo":788870007,
    "descripcion":"ENFERMEDAD ATÍPICA CAUSADA POR VIRUS ÉBOLA"
  },
  {
    "codigo":428422006,
    "descripcion":"HALLADO COLGADO"
  },
  {
    "codigo":231814009,
    "descripcion":"CONTUSIÓN PALPEBRAL"
  },
  {
    "codigo":11987631000119103,
    "descripcion":"QUEMADURA EPIDÉRMICA DE RODILLA DERECHA"
  },
  {
    "codigo":262747003,
    "descripcion":"AVULSIÓN DE LA RAÍZ DE NERVIO LUMBAR"
  },
  {
    "codigo":66139007,
    "descripcion":"PSEUDOPTERIGIÓN"
  },
  {
    "codigo":33371008,
    "descripcion":"AUSENCIA DE SENSIBILIDAD A LAS COSQUILLAS"
  },
  {
    "codigo":721499008,
    "descripcion":"LESIÓN COMPLETA DE MÉDULA ESPINAL LUMBAR"
  },
  {
    "codigo":293680002,
    "descripcion":"ALERGIA A PICOSULFATO DE SODIO"
  },
  {
    "codigo":361051009,
    "descripcion":"DEFICIENCIA DE QUIMIOTRIPSINA"
  },
  {
    "codigo":719664004,
    "descripcion":"SÍNDROME DE MICRODELECIÓN 8Q22.1"
  },
  {
    "codigo":228144006,
    "descripcion":"ALTERACIÓN EN LA EMISIÓN DE LA VOZ"
  },
  {
    "codigo":162608008,
    "descripcion":"ENFERMEDAD TERMINAL - ESTADIO FINAL"
  },
  {
    "codigo":95237001,
    "descripcion":"ARTERIA SUBCLAVIA RETROESOFÁGICA"
  },
  {
    "codigo":816133002,
    "descripcion":"SENSACIÓN DE DOLOR DISMINUIDA"
  },
  {
    "codigo":62469006,
    "descripcion":"ÚLCERA ARTERIAL"
  },
  {
    "codigo":226309007,
    "descripcion":"GLUCOSURIA RENAL FAMILIAR"
  },
  {
    "codigo":93402000,
    "descripcion":"ENGROSAMIENTO CONGÉNITO DE HÚMERO"
  },
  {
    "codigo":1078277009,
    "descripcion":"AGENESIA DE EPÍFISIS PROXIMAL DE RADIO"
  },
  {
    "codigo":257242002,
    "descripcion":"HIPERALDOSTERONISMO DEBIDO A NEOPLASIA DE LA CORTEZA SUPRARRENAL"
  },
  {
    "codigo":224474004,
    "descripcion":"DESPIDO LABORAL INJUSTO"
  },
  {
    "codigo":60634005,
    "descripcion":"TRASTORNO DE LA TOLERANCIA A LA GLUCOSA MEDICAMENTOSO"
  },
  {
    "codigo":124335006,
    "descripcion":"DEFICIENCIA DE FOSFOGLICERATO CINASA"
  },
  {
    "codigo":1269380001,
    "descripcion":"LESIÓN ANTERIOR DE MÉDULA ESPINAL DORSAL DEBIDA A LUXACIÓN EXPUESTA DE ARTICULACIÓN DE COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":1303983009,
    "descripcion":"BLEBITIS CONJUNTIVAL DE OJO DERECHO POSTERIOR A CIRUGÍA DE GLAUCOMA"
  },
  {
    "codigo":286340007,
    "descripcion":"EMITE UN VOLUMEN DE VOZ ADECUADO"
  },
  {
    "codigo":284505005,
    "descripcion":"CONDUCTA CONTROLABLE"
  },
  {
    "codigo":218969006,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR MERCAPTOMERINA"
  },
  {
    "codigo":22361007,
    "descripcion":"DEGENERACIÓN DE LA PULPA"
  },
  {
    "codigo":249902000,
    "descripcion":"DIFICULTAD PARA PARARSE"
  },
  {
    "codigo":1234777009,
    "descripcion":"DESINHIBICIÓN CAUSADA POR ETANOL"
  },
  {
    "codigo":15729481000119108,
    "descripcion":"ARTROPATÍA DE HOMBRO IZQUIERDO DEBIDA A SÍNDROME DE BEHCET"
  },
  {
    "codigo":315438001,
    "descripcion":"NACIDO EN GUYANA"
  },
  {
    "codigo":708654005,
    "descripcion":"RAÍCES DENTALES CONVERGENTES"
  },
  {
    "codigo":248067000,
    "descripcion":"AUTOMUTILACIÓN DE LAS OREJAS"
  },
  {
    "codigo":1003566009,
    "descripcion":"AGENESIA DE MANDÍBULA"
  },
  {
    "codigo":403763008,
    "descripcion":"APLASIA CUTÁNEA EN EL SÍNDROME DE JOHANSON-BLIZZARD"
  },
  {
    "codigo":16856000,
    "descripcion":"DEFICIENCIA LONGITUDINAL DE HÚMERO"
  },
  {
    "codigo":735917000,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE ANEXOS OCULARES"
  },
  {
    "codigo":12235901000119101,
    "descripcion":"PIE CAVO CONGÉNITO DE PIE DERECHO"
  },
  {
    "codigo":277165004,
    "descripcion":"SANGRE FRESCA EN CONDUCTO AUDITIVO EXTERNO"
  },
  {
    "codigo":111490003,
    "descripcion":"TRASTORNO DE PÁNICO CON AGORAFOBIA, EVITACIÓN AGORAFÓBICA EN REMISIÓN PARCIAL Y ATAQUES DE PÁNICO GRAVES"
  },
  {
    "codigo":732247000,
    "descripcion":"SÍNDROME DE FISURA DE LABIO Y RETINOPATÍA"
  },
  {
    "codigo":76887001,
    "descripcion":"HEMIBLOQUEO ANTERIOR, HEMIBLOQUEO POSTERIOR IZQUIERDO Y BLOQUEO INCOMPLETO DE RAMA DERECHA"
  },
  {
    "codigo":207959006,
    "descripcion":"FRACTURA NO EXPUESTA DE VÉRTEBRA LUMBAR, EN CUÑA"
  },
  {
    "codigo":240727006,
    "descripcion":"COCCIDIOIDOMICOSIS CUTÁNEA"
  },
  {
    "codigo":238892000,
    "descripcion":"GRANULOMA OLEOSO"
  },
  {
    "codigo":402732001,
    "descripcion":"TIC HABITUAL"
  },
  {
    "codigo":10761341000119105,
    "descripcion":"TRABAJO DE PARTO PRETÉRMINO SIN PARTO"
  },
  {
    "codigo":16905341000119105,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE PIEL DE PÁRPADO INFERIOR DERECHO"
  },
  {
    "codigo":40449001,
    "descripcion":"DEPÓSITOS CUTÁNEOS"
  },
  {
    "codigo":237057005,
    "descripcion":"TUMOR EPITELIAL DE OVARIO"
  },
  {
    "codigo":105985007,
    "descripcion":"SÍNDROME DE OSTEOCONDRODISPLASIA"
  },
  {
    "codigo":169686005,
    "descripcion":"PRUEBA DE AFP DESEADA"
  },
  {
    "codigo":366294008,
    "descripcion":"HALLAZGO RELACIONADO CON EL OLOR DEL ESMEGMA"
  },
  {
    "codigo":300758009,
    "descripcion":"PARTICIPA EN UN PASATIEMPO"
  },
  {
    "codigo":36779002,
    "descripcion":"INFECCIÓN CAUSADA POR ORIENTOBILHARZIA"
  },
  {
    "codigo":167851003,
    "descripcion":"SANGRE OCULTA NO DETECTADA EN VÓMITO"
  },
  {
    "codigo":331031000119104,
    "descripcion":"ALTERACIÓN DE VASO DE PÁRPADO DERECHO"
  },
  {
    "codigo":69547003,
    "descripcion":"MORDIDA AGRESIVA"
  },
  {
    "codigo":397227007,
    "descripcion":"GRASA PERIVESICAL COMPROMETIDA POR EXTENSIÓN DIRECTA DE NEOPLASIA MALIGNA"
  },
  {
    "codigo":724907007,
    "descripcion":"LESIÓN TRAUMÁTICA DE TENDÓN A LA ALTURA DEL HOMBRO"
  },
  {
    "codigo":67712001,
    "descripcion":"AFELPAMIENTO Y\/O ENMARAÑAMIENTO DEL PELO"
  },
  {
    "codigo":2176006,
    "descripcion":"ACNÉ CAUSADA POR HALÓGENOS"
  },
  {
    "codigo":297088006,
    "descripcion":"SOBREDOSIS DE NITROGLICERINA"
  },
  {
    "codigo":721237006,
    "descripcion":"SECUELA DE INFECCIÓN CAUSADA POR MYCOBACTERIUM"
  },
  {
    "codigo":64042000,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA VENA UTERINA"
  },
  {
    "codigo":15705521000119102,
    "descripcion":"CONCRECIÓN EN CONJUNTIVA DE PÁRPADO INFERIOR DERECHO"
  },
  {
    "codigo":129578002,
    "descripcion":"FLUJO VASCULAR EN UNA DERIVACIÓN PORTOCAVA"
  },
  {
    "codigo":195114002,
    "descripcion":"INSUFICIENCIA AGUDA DEL VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":341009,
    "descripcion":"REACCIÓN DE INCOMPATIBILIDAD ABO"
  },
  {
    "codigo":162346006,
    "descripcion":"SENSACIÓN DE CHASQUIDO EN EL OÍDO"
  },
  {
    "codigo":719402008,
    "descripcion":"ANEMIA HEMOLÍTICA LETAL Y ANOMALÍA GENITAL"
  },
  {
    "codigo":1145386009,
    "descripcion":"HIPOPLASIA CONGÉNITA DE MÚSCULO DE MUSLO"
  },
  {
    "codigo":94975000,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL PALADAR"
  },
  {
    "codigo":293418009,
    "descripcion":"REACCIÓN ADVERSA A LA DEXTROTIROXINA SÓDICA"
  },
  {
    "codigo":291583004,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR CEFACLOR"
  },
  {
    "codigo":1010644000,
    "descripcion":"ESPINA BÍFIDA ABIERTA DE COLUMNA VERTEBRAL TORÁCICA SUPERIOR"
  },
  {
    "codigo":62207008,
    "descripcion":"ENFERMEDAD CORONARIA OSTIAL SIFILÍTICA"
  },
  {
    "codigo":289748004,
    "descripcion":"ÚTERO GRÁVIDO NORMAL"
  },
  {
    "codigo":224212005,
    "descripcion":"HOGAR PERTENECIENTE A MIEMBRO DE LA FAMILIA"
  },
  {
    "codigo":365363004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA HACER UN PRESUPUESTO"
  },
  {
    "codigo":1303721000,
    "descripcion":"NECROSIS AVASCULAR DE HUESO DE PIE"
  },
  {
    "codigo":1172649001,
    "descripcion":"17 - ESTEROIDES CETOGÉNICOS EN ORINA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":124073004,
    "descripcion":"COPROPORFIRINA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":255145006,
    "descripcion":"CARCINOMA IN SITU DE EPITELIO DE SUPERFICIE"
  },
  {
    "codigo":713897006,
    "descripcion":"LINFOMA DE BURKITT CONCOMITANTE CON INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":417150000,
    "descripcion":"SITIO PLACENTARIO EXAGERADO"
  },
  {
    "codigo":286078002,
    "descripcion":"CAPAZ DE GUARDAR LA ROPA LAVADA"
  },
  {
    "codigo":89470004,
    "descripcion":"FIBRINÓLISIS AUMENTADA"
  },
  {
    "codigo":253310007,
    "descripcion":"INSERCIÓN ANÓMALA DE VENA CAVA SUPERIOR DERECHA EN AURÍCULA IZQUIERDA"
  },
  {
    "codigo":251475000,
    "descripcion":"ONDAS EN ESPIGA, GENERALIZADAS - 3 POR SEGUNDO"
  },
  {
    "codigo":449918009,
    "descripcion":"CALAMBRE EN PIERNA"
  },
  {
    "codigo":54867000,
    "descripcion":"ALVEOLITIS FIBROSANTE REUMATOIDEA"
  },
  {
    "codigo":448083003,
    "descripcion":"OBSTRUCCIÓN AL TRACTO DE SALIDA DE VENTRÍCULO DERECHO DEBIDA A PROLAPSO DE VÁLVULA ARTERIAL"
  },
  {
    "codigo":185939007,
    "descripcion":"PACIENTE EN ESTUDIO LOCAL"
  },
  {
    "codigo":22099008,
    "descripcion":"DEFORMIDAD CONGÉNITA EN VALGO DEL PIE"
  },
  {
    "codigo":870397000,
    "descripcion":"ECTASIA DE ESCLERÓTICA"
  },
  {
    "codigo":282408009,
    "descripcion":"SUBLUXACIÓN RECIDIVANTE DE ARTICULACIÓN DE HOMBRO"
  },
  {
    "codigo":1003304008,
    "descripcion":"CLINODACTILIA CONGÉNITA DE QUINTO DEDO DE PIE"
  },
  {
    "codigo":1263613005,
    "descripcion":"TRASTORNO NEONATAL PRECOZ DEBIDO A DISTOCIA UTERINA"
  },
  {
    "codigo":305757002,
    "descripcion":"ATENDIDO POR ENFERMERA PRACTICANTE"
  },
  {
    "codigo":313341008,
    "descripcion":"RAZÓN INTERNACIONAL NORMALIZADA POR ENCIMA DE RANGO DE REFERENCIA"
  },
  {
    "codigo":51197009,
    "descripcion":"CÓLICOS ABDOMINALES"
  },
  {
    "codigo":247805009,
    "descripcion":"ANSIEDAD Y MIEDO"
  },
  {
    "codigo":1163474004,
    "descripcion":"INFECCIÓN CARDÍACA INVASIVA CAUSADA POR ASPERGILLUS"
  },
  {
    "codigo":1360082005,
    "descripcion":"ESTENOSIS SUBGLÓTICA IDIOPÁTICA"
  },
  {
    "codigo":16594005,
    "descripcion":"PERIOSTITIS DE SITIOS MÚLTIPLES"
  },
  {
    "codigo":213202009,
    "descripcion":"COMPLICACIONES EN EL INTENTO DE IMPLANTE DEL HUEVO FERTILIZADO IN VITRO"
  },
  {
    "codigo":442578009,
    "descripcion":"SUSTANCIAS REDUCTORAS EN MATERIA FECAL DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":49362009,
    "descripcion":"EDEMA DE CÓRNEA CAUSADO POR USO DE LENTES DE CONTACTO"
  },
  {
    "codigo":735655008,
    "descripcion":"RUPTURA DE AMBOS OJOS CONCOMITANTE CON PÉRDIDA DE TEJIDO INTRAOCULAR"
  },
  {
    "codigo":1290876002,
    "descripcion":"NÓDULO REUMATOIDEO DE TEJIDO CELULAR SUBCUTÁNEO DE TOBILLO DERECHO"
  },
  {
    "codigo":373372005,
    "descripcion":"GRADO HISTOLÓGICO - HALLAZGO"
  },
  {
    "codigo":733820006,
    "descripcion":"MEJORÍA EN LA IMAGEN DE SÍ MISMO"
  },
  {
    "codigo":699217000,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN EN SURCO INTERGLÚTEO"
  },
  {
    "codigo":830289002,
    "descripcion":"HONGO OBSERVADO EN EL EXAMEN MICROSCÓPICO CON TINCIÓN"
  },
  {
    "codigo":240465003,
    "descripcion":"RABIA - FASE DE RECUPERACIÓN"
  },
  {
    "codigo":109393007,
    "descripcion":"DISOSTOSIS OTOMANDIBULAR"
  },
  {
    "codigo":402470003,
    "descripcion":"GOTA TOFÁCEA CRÓNICA DE DÍGITO"
  },
  {
    "codigo":369702004,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA DE LINFOMA GASTROINTESTINAL, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":271398006,
    "descripcion":"PESO ESTABLE"
  },
  {
    "codigo":171259000,
    "descripcion":"INMUNIZACIONES DESACTUALIZADAS"
  },
  {
    "codigo":1285371003,
    "descripcion":"ESGUINCE DE LIGAMENTO RADIAL COLATERAL DE ARTICULACIÓN DE CODO"
  },
  {
    "codigo":105723007,
    "descripcion":"HALLAZGO RELACIONADO CON LA TEMPERATURA CORPORAL"
  },
  {
    "codigo":366032002,
    "descripcion":"HALLAZGO RELACIONADO CON LA POSICIÓN DEL CUERPO CILIAR"
  },
  {
    "codigo":71120004,
    "descripcion":"INFECCIÓN BACTERIANA CAUSADA POR SERRATIA"
  },
  {
    "codigo":429733000,
    "descripcion":"INCAPAZ DE ALCANZAR LA FRECUENCIA CARDÍACA OBJETIVO"
  },
  {
    "codigo":202192009,
    "descripcion":"LUXACIÓN PATOLÓGICA DE ARTICULACIÓN DE TOBILLO"
  },
  {
    "codigo":16035711000119107,
    "descripcion":"OSTEÓLISIS DE RADIO DERECHO"
  },
  {
    "codigo":298661002,
    "descripcion":"SIN AMPLITUD DE MOVIMIENTO ACTIVO DE ROTACIÓN HACIA LA IZQUIERDA DE LA COLUMNA LUMBAR"
  },
  {
    "codigo":300496009,
    "descripcion":"HALLAZGO RELACIONADO CON EL ASPECTO DE EPIDÍDIMO"
  },
  {
    "codigo":1052325005,
    "descripcion":"PSORIASIS EXACERBADA POR VIH"
  },
  {
    "codigo":724645006,
    "descripcion":"LINFOMA DE GRANDES LINFOCITOS B RICO EN LINFOCITOS T E HISTIOCITOS"
  },
  {
    "codigo":36517007,
    "descripcion":"DISPLASIA FIBROSA POLIOSTÓSICA DE HUESO"
  },
  {
    "codigo":722810000,
    "descripcion":"PRÓTESIS IN SITU"
  },
  {
    "codigo":296826002,
    "descripcion":"SOBREDOSIS DE GLUCAGÓN"
  },
  {
    "codigo":1148794004,
    "descripcion":"HEMORRAGIA POSPARTO CON PLACENTA RETENIDA"
  },
  {
    "codigo":427898007,
    "descripcion":"INFECCIÓN DENTAL"
  },
  {
    "codigo":1179727001,
    "descripcion":"REACCIÓN ADVERSA AL SARILUMAB"
  },
  {
    "codigo":131151002,
    "descripcion":"GRUPO SANGUÍNEO A>3<"
  },
  {
    "codigo":360527003,
    "descripcion":"DIPLOMIELIA"
  },
  {
    "codigo":196687006,
    "descripcion":"ÚLCERA PÉPTICA AGUDA CON OBSTRUCCIÓN"
  },
  {
    "codigo":720975008,
    "descripcion":"EVENTO BREVE INEXPLICABLE RESUELTO"
  },
  {
    "codigo":719140001,
    "descripcion":"SÍNDROME DE DISCAPACIDAD INTELECTUAL LIGADA AL CROMOSOMA X CON DISMORFISMO Y ATROFIA CEREBRAL"
  },
  {
    "codigo":293156000,
    "descripcion":"REACCIÓN ADVERSA A LA BECLOMETASONA"
  },
  {
    "codigo":424228003,
    "descripcion":"ESTADO DE CONTROL DE INFECCIONES"
  },
  {
    "codigo":1208825002,
    "descripcion":"DESPLAZAMIENTO DE CABLE DE SENO CORONARIO DE DESFIBRILADOR CARDIOVERSOR IMPLANTABLE"
  },
  {
    "codigo":12214451000119101,
    "descripcion":"INFECCIÓN DE HUESO DE MANO IZQUIERDA ASOCIADA CON DISPOSITIVO DE FIJACIÓN INTERNA"
  },
  {
    "codigo":29177004,
    "descripcion":"ANEMIA POR DEFECTO EN LA VÍA DE LAS PENTOSAS FOSFATOS"
  },
  {
    "codigo":92878003,
    "descripcion":"FUSIÓN ANORMAL CONGÉNITA DEL ASTRÁGALO"
  },
  {
    "codigo":27342004,
    "descripcion":"ANEMIA DEL EMBARAZO"
  },
  {
    "codigo":16064691000119103,
    "descripcion":"TRASTORNO DEBIDO A POLINEUROPATÍA TÓXICA Y POSTERIOR A ELLA"
  },
  {
    "codigo":715470008,
    "descripcion":"ENANISMO CON BRAQUIDACTILIA, TIPO MSELENI"
  },
  {
    "codigo":123811001,
    "descripcion":"SULFATIDURIA"
  },
  {
    "codigo":289486009,
    "descripcion":"HIPERQUERATOSIS DE LA VULVA"
  },
  {
    "codigo":31801000146106,
    "descripcion":"ENFERMEDAD MATERNA PREEXISTENTE QUE COMPLICA EL EMBARAZO"
  },
  {
    "codigo":25507003,
    "descripcion":"EROSIÓN DENTAL IDIOPÁTICA"
  },
  {
    "codigo":418723004,
    "descripcion":"EFECTOS DE LA DESCARGA DIRECTA DE UN RAYO"
  },
  {
    "codigo":254883003,
    "descripcion":"LEIOMIOMATOSIS INTRAVENOSA"
  },
  {
    "codigo":1172387002,
    "descripcion":"AGRANDAMIENTO GINGIVAL EXACERBADO POR ANTICONCEPTIVO ORAL"
  },
  {
    "codigo":58275005,
    "descripcion":"PORFIRIA VARIEGATA"
  },
  {
    "codigo":125646009,
    "descripcion":"HERIDA ABIERTA DE LA REGIÓN ESCAPULAR"
  },
  {
    "codigo":1303459009,
    "descripcion":"DISPLASIA BRONCOPULMONAR SEVERA DEL RECIÉN NACIDO"
  },
  {
    "codigo":336051000119104,
    "descripcion":"RUPTURA DE COROIDES DE OJO DERECHO"
  },
  {
    "codigo":285816004,
    "descripcion":"NO ABRE Y CIERRA CANILLAS"
  },
  {
    "codigo":56440001,
    "descripcion":"ESTENOSIS SEGMENTARIA DE LA TRÁQUEA"
  },
  {
    "codigo":447821002,
    "descripcion":"HERNIA DIAFRAGMÁTICA POSTEROLATERAL CONGÉNITA"
  },
  {
    "codigo":283981003,
    "descripcion":"LESIÓN POR APLASTAMIENTO DEL BAZO"
  },
  {
    "codigo":413218001,
    "descripcion":"GASTROPATÍA HEMORRÁGICA"
  },
  {
    "codigo":314914004,
    "descripcion":"DETERIORO DE LA AUDICIÓN"
  },
  {
    "codigo":773666007,
    "descripcion":"HIPOGLUCEMIA HIPOINSULINÉMICA Y HEMIHIPERTROFIA CORPORAL"
  },
  {
    "codigo":249378009,
    "descripcion":"LENGUA - HALLAZGO"
  },
  {
    "codigo":282146009,
    "descripcion":"CAMINA"
  },
  {
    "codigo":216610009,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ANTI-INFECCIOSOS"
  },
  {
    "codigo":739063004,
    "descripcion":"METABOLIZADOR INTERMEDIO DE LA FAMILIA 3 SUBFAMILIA A MIEMBRO 5 DEL CITOCROMO P450"
  },
  {
    "codigo":50935005,
    "descripcion":"ORINA LECHOSA"
  },
  {
    "codigo":442316003,
    "descripcion":"ATRAPAMIENTO DE INTESTINO EN DEFECTO PERITONEAL"
  },
  {
    "codigo":16332007,
    "descripcion":"INTOXICACIÓN POR ETIONAMIDA"
  },
  {
    "codigo":737228009,
    "descripcion":"ATROFIA CORTICAL FOCAL PROGRESIVA"
  },
  {
    "codigo":243873002,
    "descripcion":"SITUACIÓN DEL MONITOREO DE LA WARFARINA"
  },
  {
    "codigo":211105005,
    "descripcion":"PICADURA DE INSECTO, EN LA MAMA"
  },
  {
    "codigo":276641008,
    "descripcion":"ASFIXIA INTRAUTERINA"
  },
  {
    "codigo":473249009,
    "descripcion":"QUEMADURA DE REGIÓN OCULAR CON QUEMADURA DE SEGUNDO GRADO DE CABEZA Y\/O CUELLO"
  },
  {
    "codigo":209270002,
    "descripcion":"FRACTURA-LUXACIÓN PERISEMILUNAR (DORSAL) NO EXPUESTA"
  },
  {
    "codigo":1259681009,
    "descripcion":"CARCINOMA ANEXIAL PRIMARIO DE VULVA"
  },
  {
    "codigo":438646004,
    "descripcion":"TROMBOFLEBITIS DE VENA AXILAR"
  },
  {
    "codigo":16011751000119102,
    "descripcion":"TROMBOFLEBITIS DE VENA SAFENA IZQUIERDA"
  },
  {
    "codigo":404043000,
    "descripcion":"LEIOMIOMA CUTÁNEO MÚLTIPLE FAMILIAR"
  },
  {
    "codigo":78198009,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DE TESTÍCULO"
  },
  {
    "codigo":405878009,
    "descripcion":"FENOTIPO N+"
  },
  {
    "codigo":305739003,
    "descripcion":"ATENDIDO POR ENFERMERA ESPECIALISTA EN VÍAS GENITOURINARIAS"
  },
  {
    "codigo":698955006,
    "descripcion":"DEMENCIA DEGENERATIVA PRIMARIA DE TIPO ALZHEIMER, COMIENZO PRESENIL, EN REMISIÓN"
  },
  {
    "codigo":830027007,
    "descripcion":"QUISTE DERMOIDE DE CONJUNTIVA DE OJO DERECHO"
  },
  {
    "codigo":271136000,
    "descripcion":"AMPOLLA TRAUMÁTICA DE ESPALDA, INFECTADA"
  },
  {
    "codigo":43595007,
    "descripcion":"DEFICIENCIA DE CROMO"
  },
  {
    "codigo":238368001,
    "descripcion":"ECCEMA VACUNAL"
  },
  {
    "codigo":402208007,
    "descripcion":"OTITIS EXTERNA SEBORREICA CRÓNICA"
  },
  {
    "codigo":762656009,
    "descripcion":"RECUENTO DE CÉLULAS SANGUÍNEAS FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":39925003,
    "descripcion":"MIOPATÍA JUVENIL, ENCEFALOPATÍA, ACIDOSIS LÁCTICA Y ACCIDENTE CEREBROVASCULAR"
  },
  {
    "codigo":1186805005,
    "descripcion":"NEOPLASIA NEUROENDOCRINA DE INTESTINO DELGADO"
  },
  {
    "codigo":302069006,
    "descripcion":"HALLAZGO RELACIONADO CON LA MOVILIDAD DE LA GLÁNDULA TIROIDES"
  },
  {
    "codigo":1075841000119102,
    "descripcion":"TENDINITIS CALCIFICANTE DEL TENDÓN DE AQUILES IZQUIERDO"
  },
  {
    "codigo":236533008,
    "descripcion":"SÍNDROME DE OCHOA"
  },
  {
    "codigo":365770002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA DECIR LA HORA"
  },
  {
    "codigo":726218003,
    "descripcion":"LESIÓN TRAUMÁTICA DE TENDÓN DE MÚSCULO DE LA CADERA"
  },
  {
    "codigo":300234006,
    "descripcion":"HALLAZGO RELACIONADO CON LA SENSIBILIDAD DENTAL"
  },
  {
    "codigo":724383002,
    "descripcion":"SÍNDROME DE HEMIDISTONÍA HEMIATROFIA"
  },
  {
    "codigo":298399002,
    "descripcion":"TUMEFACCIÓN ÓSEA DE COLUMNA CERVICAL"
  },
  {
    "codigo":167327002,
    "descripcion":"UROBILINÓGENO EN ORINA: +++"
  },
  {
    "codigo":3487004,
    "descripcion":"CANDIDIASIS PULMONAR"
  },
  {
    "codigo":34420000,
    "descripcion":"TESAURISMOSIS"
  },
  {
    "codigo":722548001,
    "descripcion":"MENINGITIS CAUSADA POR ENTEROVIRUS HUMANO 70"
  },
  {
    "codigo":338561000119105,
    "descripcion":"CICATRIZ CORIORRETINIANA DE OJO IZQUIERDO POSTERIOR A CIRUGÍA"
  },
  {
    "codigo":394868004,
    "descripcion":"ESPECIE DE SHIGELLA, NO AISLADA"
  },
  {
    "codigo":15739521000119106,
    "descripcion":"GLAUCOMA TRAUMÁTICO BILATERAL"
  },
  {
    "codigo":294729003,
    "descripcion":"ALERGIA A ACETOHEXAMIDA"
  },
  {
    "codigo":129054000,
    "descripcion":"INDEPENDENCIA PARA LA ADMINISTRACIÓN DEL DINERO"
  },
  {
    "codigo":61683000,
    "descripcion":"ATAQUE DE CAÍDA"
  },
  {
    "codigo":292894008,
    "descripcion":"REACCIÓN ADVERSA AL ÁCIDO BÓRICO"
  },
  {
    "codigo":1144862009,
    "descripcion":"HIPOPLASIA CONGÉNITA DE ESTRUCTURA VULVAR"
  },
  {
    "codigo":291059004,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR CLORDIAZEPÓXIDO"
  },
  {
    "codigo":717043006,
    "descripcion":"CALCIFILAXIA CUTÁNEA"
  },
  {
    "codigo":782579006,
    "descripcion":"REACCIÓN ADVERSA A AZO-DERIVADO DE ACRIDINA"
  },
  {
    "codigo":59848001,
    "descripcion":"HIPERBILIRRUBINEMIA OBSTRUCTIVA"
  },
  {
    "codigo":190920002,
    "descripcion":"HIPERURICEMIA SIN SIGNOS DE ARTRITIS INFLAMATORIA O ENFERMEDAD TOFÁCEA"
  },
  {
    "codigo":94451009,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL NERVIO OLFATORIO"
  },
  {
    "codigo":289224007,
    "descripcion":"PUJOS EN EL TRABAJO DE PARTO - HALLAZGO"
  },
  {
    "codigo":1303197000,
    "descripcion":"INFECCIÓN DE TIBIA ASOCIADA CON DISPOSITIVO DE FIJACIÓN INTERNA"
  },
  {
    "codigo":254621001,
    "descripcion":"PAPILOMATOSIS LARINGOTRAQUEAL"
  },
  {
    "codigo":27080008,
    "descripcion":"TALASEMIA BETA CERO TIPO DELECIÓN"
  },
  {
    "codigo":367541000119102,
    "descripcion":"GLOMERULONEFRITIS MEMBRANOSA DIFUSA HEREDITARIA"
  },
  {
    "codigo":711538001,
    "descripcion":"SOBREDOSIS INTENCIONAL DE FÁRMACO EN COMPRIMIDO"
  },
  {
    "codigo":285554005,
    "descripcion":"CAPAZ DE MANTENER LA ELEVACIÓN DEL PALADAR BLANDO"
  },
  {
    "codigo":250951000,
    "descripcion":"PARED DE VENTRÍCULO DERECHO HIPOCINÉTICA"
  },
  {
    "codigo":1137522008,
    "descripcion":"CALCIFICACIÓN PUNTEADA DE EPÍFISIS DE FALANGE DE QUINTO DEDO DE PIE"
  },
  {
    "codigo":416626008,
    "descripcion":"PÉRDIDA DE CAMPO VISUAL FUNCIONAL"
  },
  {
    "codigo":283719004,
    "descripcion":"MORDEDURA HUMANA EN EXTREMIDAD INFERIOR"
  },
  {
    "codigo":185415007,
    "descripcion":"CITA SOLICITADA POR COHABITANTE"
  },
  {
    "codigo":314652000,
    "descripcion":"PERÍMETRO CEFÁLICO DEL NIÑO: PERCENTILO 50"
  },
  {
    "codigo":773404000,
    "descripcion":"SÍNDROME DE ROIFMAN"
  },
  {
    "codigo":52508001,
    "descripcion":"ÁNTRAX DE DEDO DEL PIE"
  },
  {
    "codigo":445724000,
    "descripcion":"LACERACIÓN SUPERFICIAL DE ANTEBRAZO"
  },
  {
    "codigo":609564002,
    "descripcion":"DIABETES MELLITUS TIPO 1 PREEXISTENTE EN EL EMBARAZO"
  },
  {
    "codigo":341071000119100,
    "descripcion":"AMBLIOPÍA POR DEPRIVACIÓN DE OJO IZQUIERDO"
  },
  {
    "codigo":249116009,
    "descripcion":"NALGAS ENCAJADAS"
  },
  {
    "codigo":247281007,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAVIDAD MASTOIDEA"
  },
  {
    "codigo":704198001,
    "descripcion":"NIEGA CONSUMO DE ALCOHOL"
  },
  {
    "codigo":16070004,
    "descripcion":"CIRROSIS SIFILÍTICA"
  },
  {
    "codigo":210843000,
    "descripcion":"LESIÓN DE LA ARTERIA CUBITAL A NIVEL DE LA MUÑECA Y LA MANO"
  },
  {
    "codigo":440219001,
    "descripcion":"BACTERIEMIA CAUSADA POR SALMONELLA"
  },
  {
    "codigo":472987001,
    "descripcion":"ACTIVIDAD SEXUAL CON MUJERES"
  },
  {
    "codigo":407451003,
    "descripcion":"INFECCIÓN POR VIRUS DEL HERPES SIMPLE, TIPO 1"
  },
  {
    "codigo":735131004,
    "descripcion":"OCLUSIÓN DE ARTERIA CEREBELOSA IZQUIERDA"
  },
  {
    "codigo":1259419006,
    "descripcion":"CARCINOMA PRIMARIO DE MAMA - CUADRANTE INFEROINTERNO"
  },
  {
    "codigo":209008001,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN METATARSOFALÁNGICA, MÚLTIPLE"
  },
  {
    "codigo":702363009,
    "descripcion":"SÍNDROME DE SUDORACIÓN INDUCIDA POR FRÍO"
  },
  {
    "codigo":733296003,
    "descripcion":"AVULSIÓN DE CABEZA DE PERONÉ"
  },
  {
    "codigo":1357723009,
    "descripcion":"POBREZA ENERGÉTICA DOMÉSTICA DEBIDA A NOTIFICACIÓN DE DESCONEXIÓN DE SERVICIO DE PROVISIÓN DE ENERGÍA"
  },
  {
    "codigo":307312008,
    "descripcion":"PERFORACIÓN DE ARTERIA"
  },
  {
    "codigo":43333003,
    "descripcion":"INFESTACIÓN CAUSADA POR CULICIDAE"
  },
  {
    "codigo":698693004,
    "descripcion":"TRASTORNO DE ADAPTACIÓN CON ESTADO DE ÁNIMO ANSIOSO EN REMISIÓN"
  },
  {
    "codigo":1255749004,
    "descripcion":"LINFOMA DE BURKITT DE GANGLIOS LINFÁTICOS DE CABEZA"
  },
  {
    "codigo":403781006,
    "descripcion":"SÍNDROME DE FOTOSENSIBILIDAD CON ICTIOSIS, CABELLO QUEBRADIZO, ALTERACIÓN INTELECTUAL, DISMINUCIÓN DE LA FERTILIDAD Y BAJA ESTATURA"
  },
  {
    "codigo":305477008,
    "descripcion":"BAJO ATENCIÓN DE INMUNÓLOGO CLÍNICO"
  },
  {
    "codigo":74266001,
    "descripcion":"TRASTORNO DEL ESTADO DE ÁNIMO, EN REMISIÓN PARCIAL"
  },
  {
    "codigo":762394001,
    "descripcion":"RESULTADO INSATISFACTORIO DEBIDO A CIRUGÍA COSMÉTICA Y POSTERIOR A ELLA"
  },
  {
    "codigo":72431002,
    "descripcion":"INTOXICACIÓN ACCIDENTAL"
  },
  {
    "codigo":203503005,
    "descripcion":"CONSOLIDACIÓN DEFECTUOSA ROTACIONAL DE FRACTURA"
  },
  {
    "codigo":400111008,
    "descripcion":"HAMARTOMA LIPOMATOSO"
  },
  {
    "codigo":1217476001,
    "descripcion":"ANAFILAXIA CAUSADA POR COMPONENTE DE VACUNA"
  },
  {
    "codigo":234436001,
    "descripcion":"SÍNDROME ERITROFAGOCÍTICO HEMOLÍTICO"
  },
  {
    "codigo":299972003,
    "descripcion":"PICADURA DE LA PIEL"
  },
  {
    "codigo":398276003,
    "descripcion":"INSUFICIENCIA PLACENTARIA QUE AFECTA EL MANEJO DE LA MADRE"
  },
  {
    "codigo":16207081000119105,
    "descripcion":"DOLOR EN MUÑÓN DE AMPUTACIÓN DE AMBAS EXTREMIDADES INFERIORES"
  },
  {
    "codigo":267204006,
    "descripcion":"INFECCIÓN DE LAS VÍAS GENITOURINARIAS EN EL EMBARAZO"
  },
  {
    "codigo":431044006,
    "descripcion":"ABRASIÓN DE PIEL DE REGIÓN ESTERNAL"
  },
  {
    "codigo":365508006,
    "descripcion":"CIRCUNSTANCIAS DE ALOJAMIENTO Y VIVIENDA - HALLAZGO"
  },
  {
    "codigo":68761002,
    "descripcion":"VÉRTIGO EPILÉPTICO"
  },
  {
    "codigo":536591000221103,
    "descripcion":"OCLUSIÓN DE ARTERIA TIBIAL ANTERIOR DERECHA"
  },
  {
    "codigo":298137008,
    "descripcion":"NEUROPATÍA TORACOABDOMINAL"
  },
  {
    "codigo":789657008,
    "descripcion":"LIPOFUCSINOSIS CEROIDE NEURONAL JUVENIL RELACIONADA CON ATPASA TRANSPORTADORA DE CATIONES 13A2"
  },
  {
    "codigo":1017198002,
    "descripcion":"CON MAYOR RIESGO DE MATRIMONIO FORZADO"
  },
  {
    "codigo":230766000,
    "descripcion":"ENCEFALOMALACIA MULTIQUÍSTICA"
  },
  {
    "codigo":11783401000119109,
    "descripcion":"HERIDA INFECTADA DE CADERA DERECHA DEBIDA A PICADURA DE INSECTO NO VENENOSO"
  },
  {
    "codigo":165230005,
    "descripcion":"INTESTINO: ACCIDENTE OCASIONAL"
  },
  {
    "codigo":427374007,
    "descripcion":"NEOPLASIA INMUNOPROLIFERATIVA EN REMISIÓN"
  },
  {
    "codigo":66926007,
    "descripcion":"FRACTURA NO EXPUESTA DE CÓNDILO FEMORAL"
  },
  {
    "codigo":294467001,
    "descripcion":"ALERGIA A FRAMICETINA"
  },
  {
    "codigo":296302007,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE CANABIS"
  },
  {
    "codigo":720451004,
    "descripcion":"DEPRESIÓN MAYOR MÍNIMA RECURRENTE"
  },
  {
    "codigo":390936003,
    "descripcion":"ARTERIOPATÍA CEREBRAL AUTOSÓMICA DOMINANTE CON INFARTOS SUBCORTICALES Y LEUCOENCEFALOPATÍA"
  },
  {
    "codigo":292632006,
    "descripcion":"REACCIÓN ADVERSA A POMADA CON DITRANOL"
  },
  {
    "codigo":28653000,
    "descripcion":"LINFANGITIS AGUDA DE MUÑECA"
  },
  {
    "codigo":1080861000119101,
    "descripcion":"HISTIOCITOMA FIBROSO MALIGNO PRIMARIO DE PARTES BLANDAS DE EXTREMIDAD INFERIOR DERECHA"
  },
  {
    "codigo":421869004,
    "descripcion":"BRADIARRITMIA"
  },
  {
    "codigo":126957005,
    "descripcion":"NEOPLASIA DEL LÓBULO OCCIPITAL"
  },
  {
    "codigo":389101006,
    "descripcion":"ENCEFALOPATÍA ANÓXICA - ISQUÉMICA"
  },
  {
    "codigo":290797003,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR BROMOCRIPTINA"
  },
  {
    "codigo":1306605008,
    "descripcion":"NEUMONITIS POR ASPIRACIÓN NEONATAL"
  },
  {
    "codigo":92354001,
    "descripcion":"NEOPLASIA BENIGNA DE LA PIEL DE LA OREJA"
  },
  {
    "codigo":94189009,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE VASO SANGUÍNEO AXILAR"
  },
  {
    "codigo":59586001,
    "descripcion":"HIPOCALIEMIA, PÉRDIDAS GASTROINTESTINALES"
  },
  {
    "codigo":288962009,
    "descripcion":"DIFICULTAD PARA TRAGAR SALIVA"
  },
  {
    "codigo":385431002,
    "descripcion":"OSTEOCONDROMA DE TIBIA"
  },
  {
    "codigo":287127003,
    "descripcion":"ASTILLA CLAVADA EN LA CÓRNEA"
  },
  {
    "codigo":23148009,
    "descripcion":"TRASTORNO POR DÉFICIT DE ATENCIÓN INDIFERENCIADO"
  },
  {
    "codigo":283457003,
    "descripcion":"HERIDA PUNZANTE EN EL CUELLO"
  },
  {
    "codigo":86849004,
    "descripcion":"ENVENENAMIENTO SUICIDA"
  },
  {
    "codigo":414529006,
    "descripcion":"INFECCIÓN INTESTINAL CAUSADA POR BACTERIAS ANAERÓBICAS"
  },
  {
    "codigo":250689008,
    "descripcion":"ALFA-1-ANTITRIPSINA, FENOTIPO PIMZ"
  },
  {
    "codigo":840513008,
    "descripcion":"NEOPLASIA MALIGNA COMPLEJA MIXTA Y DEL ESTROMA DE MIOMETRIO DE CUERPO UTERINO"
  },
  {
    "codigo":609302002,
    "descripcion":"QUISTE PERICÁRDICO"
  },
  {
    "codigo":707606004,
    "descripcion":"ENFERMEDAD GINGIVAL NO INDUCIDA POR PLACA"
  },
  {
    "codigo":248854004,
    "descripcion":"BORDE CICATRIZAL DEL HIMEN"
  },
  {
    "codigo":771307003,
    "descripcion":"ENFERMEDAD DE CHARCOT-MARIE-TOOTH TIPO 2B5"
  },
  {
    "codigo":1230059004,
    "descripcion":"POSICIÓN ANÓMALA DE IMPLANTE DENTAL"
  },
  {
    "codigo":8801000175101,
    "descripcion":"DIFICULTAD PARA TRAGAR PÍLDORAS"
  },
  {
    "codigo":738539009,
    "descripcion":"METABOLIZADOR LENTO DE TIOPURINA S-METILTRANSFERASA"
  },
  {
    "codigo":29281000175106,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN EN GLÚTEO IZQUIERDO ESTADIO I"
  },
  {
    "codigo":47201000175109,
    "descripcion":"VELOCIDAD DE FILTRACIÓN GLOMERULAR POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":16045751000119107,
    "descripcion":"ALTERACIÓN DE AMBAS ARTICULACIONES RADIOCARPIANAS"
  },
  {
    "codigo":12138000,
    "descripcion":"CABEZA GRANDE"
  },
  {
    "codigo":79509009,
    "descripcion":"CÁLCULO DE LA VÍA URINARIA INFERIOR"
  },
  {
    "codigo":44906001,
    "descripcion":"SÍNDROME DE CAPGRAS"
  },
  {
    "codigo":110442003,
    "descripcion":"CORPÚSCULO DE BARR, MÁS DE UNO POR CÉLULA"
  },
  {
    "codigo":77674003,
    "descripcion":"HEMIANOPSIA"
  },
  {
    "codigo":13973009,
    "descripcion":"ESTADO DE EPILEPSIA CON CONVULSIONES TÓNICO-CLÓNICAS"
  },
  {
    "codigo":307050007,
    "descripcion":"EXPERIENCIA EXTRACORPORAL"
  },
  {
    "codigo":700266008,
    "descripcion":"QUISTE DE GLÁNDULA DE MEIBOMIO DE PÁRPADO SUPERIOR"
  },
  {
    "codigo":733034007,
    "descripcion":"SÍNDROME DE CHARLIE M"
  },
  {
    "codigo":403519001,
    "descripcion":"POIQUILODERMIA DEBIDA A ESCLERODERMIA"
  },
  {
    "codigo":41236000,
    "descripcion":"SIGNOS VITALES ANORMALES"
  },
  {
    "codigo":237844003,
    "descripcion":"HIPONATREMIA FARMACÓGENA"
  },
  {
    "codigo":1260339004,
    "descripcion":"DISTONÍA DEBIDA A LESIÓN CEREBRAL FOCAL"
  },
  {
    "codigo":303380006,
    "descripcion":"FIJACIÓN OCULAR ALTERNANTE"
  },
  {
    "codigo":39401000,
    "descripcion":"ENANISMO DOLICOCEFÁLICO"
  },
  {
    "codigo":432617000,
    "descripcion":"INFECCIÓN DE PRÓTESIS COMPLETA DE ARTICULACIÓN DE TOBILLO"
  },
  {
    "codigo":203241002,
    "descripcion":"OSTEOMIELITIS VERTEBRAL"
  },
  {
    "codigo":301545003,
    "descripcion":"INCAPAZ DE LLEGAR HASTA EL INODORO"
  },
  {
    "codigo":236009007,
    "descripcion":"ESTEATONECROSIS EPIPLOICA"
  },
  {
    "codigo":365246000,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA PROGRAMAR LAS COMIDAS"
  },
  {
    "codigo":234174001,
    "descripcion":"CHOQUE SÉPTICO HIPODINÁMICO"
  },
  {
    "codigo":823998002,
    "descripcion":"REACCIÓN PUPILAR DESIGUAL BILATERAL"
  },
  {
    "codigo":266942003,
    "descripcion":"CONCURRE TRABAJADOR VOLUNTARIO"
  },
  {
    "codigo":166803003,
    "descripcion":"ELECTROFORESIS DE PROTEÍNAS FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":43421000087100,
    "descripcion":"PROLAPSO DE DISCO INTERVERTEBRAL T11-T12"
  },
  {
    "codigo":723859005,
    "descripcion":"EMBOLIA PULMONAR DEBIDA A INFARTO AGUDO DE MIOCARDIO Y POSTERIOR A ÉL"
  },
  {
    "codigo":40861000087102,
    "descripcion":"QUEMADURA DE DEDO GORDO DE PIE IZQUIERDO"
  },
  {
    "codigo":363411007,
    "descripcion":"NEOPLASIA MALIGNA DE APÉNDICE ILEOCECAL"
  },
  {
    "codigo":232339008,
    "descripcion":"TRASTORNO DE NARIZ Y NASOFARINGE"
  },
  {
    "codigo":230504002,
    "descripcion":"PAPILA ÓPTICA OBLICUA"
  },
  {
    "codigo":38301000087108,
    "descripcion":"HIPOCINESIA GLOBAL DE VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":319621000119100,
    "descripcion":"ARTRITIS REACTIVA DE ARTICULACIÓN DE RODILLA DERECHA"
  },
  {
    "codigo":263272007,
    "descripcion":"FRACTURA NO COMPLICADA DE CORONA Y RAÍZ DENTAL"
  },
  {
    "codigo":163133003,
    "descripcion":"EXAMEN DE ABDOMEN - NO SE DETECTARON ANOMALÍAS"
  },
  {
    "codigo":346091000119108,
    "descripcion":"QUISTE EXUDATIVO DE IRIS DE AMBOS OJOS"
  },
  {
    "codigo":785725008,
    "descripcion":"SÍNDROME DE QUERATODERMIA PALMOPLANTAR Y PARÁLISIS ESPÁSTICA"
  },
  {
    "codigo":62994001,
    "descripcion":"TRAQUEÍTIS"
  },
  {
    "codigo":292370002,
    "descripcion":"REACCIÓN ADVERSA AL CLORMETIAZOL"
  },
  {
    "codigo":15966341000119102,
    "descripcion":"ESTENOSIS CONGÉNITA DE ARTERIA RENAL DERECHA"
  },
  {
    "codigo":1144338005,
    "descripcion":"HIPOPLASIA CONGÉNITA DE MÚSCULO CRURAL POSTERIOR"
  },
  {
    "codigo":93927001,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE HUESO OCCIPITAL"
  },
  {
    "codigo":126695002,
    "descripcion":"NEOPLASIA DE LAS CUERDAS VOCALES"
  },
  {
    "codigo":716519006,
    "descripcion":"USO INADECUADO DEL IDIOMA EN LA COMUNICACIÓN"
  },
  {
    "codigo":224999007,
    "descripcion":"NO COMPRENDE SUS PROPIAS EMOCIONES"
  },
  {
    "codigo":28391008,
    "descripcion":"EDEMA DE RETINA LOCALIZADO"
  },
  {
    "codigo":92092005,
    "descripcion":"NEOPLASIA BENIGNA DE HUESO ETMOIDES"
  },
  {
    "codigo":1111551000000105,
    "descripcion":"CIERRE DE ÁNGULO DEBIDO A NEOVASCULARIZACIÓN"
  },
  {
    "codigo":90257004,
    "descripcion":"ÚLCERA GASTROYEYUNAL CRÓNICA CON HEMORRAGIA Y OBSTRUCCIÓN"
  },
  {
    "codigo":1070591000000109,
    "descripcion":"DIFICULTAD PARA MOVER OBJETOS EN EL HOGAR"
  },
  {
    "codigo":254097005,
    "descripcion":"DISPLASIA DE STÜEVE-WIEDEMANN"
  },
  {
    "codigo":1204369007,
    "descripcion":"TOS CRÓNICA INEXPLICABLE"
  },
  {
    "codigo":22886006,
    "descripcion":"ACIDURIA GLUTÁRICA, TIPO 2"
  },
  {
    "codigo":285030008,
    "descripcion":"MANEJA DISPOSITIVOS MIENTRAS SE DESVISTE"
  },
  {
    "codigo":283195001,
    "descripcion":"ANZUELO EN EL HOMBRO"
  },
  {
    "codigo":217659000,
    "descripcion":"ENVENENAMIENTO CAUSADO POR VENENO DE SERPIENTE DE CASCABEL"
  },
  {
    "codigo":86587003,
    "descripcion":"PLATIBASIA"
  },
  {
    "codigo":53819003,
    "descripcion":"INTOXICACIÓN POR DIEFFENBACHIA"
  },
  {
    "codigo":1297168000,
    "descripcion":"HERIDA PUNZANTE DE EXTREMIDAD SUPERIOR CON CUERPO EXTRAÑO"
  },
  {
    "codigo":838416002,
    "descripcion":"AGUDEZA VISUAL CON AGUJERO ESTENOPEICO DE OJO DERECHO 6\/18"
  },
  {
    "codigo":84752003,
    "descripcion":"DIENTES MOTEADOS CONGÉNITOS"
  },
  {
    "codigo":1231632004,
    "descripcion":"DESVIACIÓN SOSTENIDA DE LA MIRADA CONJUGADA HORIZONTAL"
  },
  {
    "codigo":11843871000119106,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA PARCIAL DE OÍDO EXTERNO DERECHO"
  },
  {
    "codigo":51984006,
    "descripcion":"SIALIDOSIS DISMÓRFICA, FORMA INFANTIL"
  },
  {
    "codigo":19216006,
    "descripcion":"MEMBRANA ESOFÁGICA"
  },
  {
    "codigo":707344002,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE SENO ESFENOIDAL"
  },
  {
    "codigo":1295333008,
    "descripcion":"SÍNDROME DE BILIS ESPESA"
  },
  {
    "codigo":310458003,
    "descripcion":"INFORME DE REGISTRO DE DISCAPACIDAD SOLICITADO"
  },
  {
    "codigo":1085881000119103,
    "descripcion":"OBSTRUCCIÓN INTESTINAL DEBIDA A ENFERMEDAD DE CROHN DE INTESTINO DELGADO"
  },
  {
    "codigo":736442006,
    "descripcion":"INFECCIÓN DEL TORRENTE SANGUÍNEO RELACIONADA CON CATÉTER"
  },
  {
    "codigo":441530006,
    "descripcion":"INSUFICIENCIA CARDÍACA DIASTÓLICA CRÓNICA"
  },
  {
    "codigo":289032006,
    "descripcion":"UTILIZA LA MANO IZQUIERDA PARA ALIMENTARSE"
  },
  {
    "codigo":1258895002,
    "descripcion":"CIRCULAR Y COMPRESIÓN DE CORDÓN UMBILICAL"
  },
  {
    "codigo":208484002,
    "descripcion":"FRACTURA EXPUESTA DE FALANGE MEDIA DE DEDO DE LA MANO, BASE"
  },
  {
    "codigo":77412003,
    "descripcion":"INFECCIÓN POR HYMENOLEPIS NANA"
  },
  {
    "codigo":110180005,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DE LA REGIÓN PERIBUCAL"
  },
  {
    "codigo":403257000,
    "descripcion":"HIPERMELANOSIS POR TUMOR SECRETOR DE ACTH\/MSH"
  },
  {
    "codigo":10041001,
    "descripcion":"ESTENOSIS TRAQUEAL SECUNDARIA A TRAQUEOSTOMÍA"
  },
  {
    "codigo":370489002,
    "descripcion":"COLANGIOHEPATITIS"
  },
  {
    "codigo":1156921007,
    "descripcion":"INMUNE A POLIOVIRUS"
  },
  {
    "codigo":237582003,
    "descripcion":"SECRECIÓN EXCESIVA DE SECRETINA"
  },
  {
    "codigo":348601000119109,
    "descripcion":"EXCAVACIÓN CONGÉNITA DE PAPILA ÓPTICA IZQUIERDA"
  },
  {
    "codigo":1351694005,
    "descripcion":"POLISEROSITIS AGUDA"
  },
  {
    "codigo":39139002,
    "descripcion":"CEGUERA CENTRAL"
  },
  {
    "codigo":301283003,
    "descripcion":"HALLAZGO RELACIONADO CON FRECUENCIA RESPIRATORIA"
  },
  {
    "codigo":792803004,
    "descripcion":"PULSO EN ARTERIA TIBIAL POSTERIOR IZQUIERDA PRESENTE"
  },
  {
    "codigo":432355004,
    "descripcion":"FUNCIONAMIENTO DEFECTUOSO DE MARCAPASOS CARDÍACO"
  },
  {
    "codigo":399587004,
    "descripcion":"TUMOR QUE INVADE LA MEMBRANA DE BRUCH"
  },
  {
    "codigo":1251555003,
    "descripcion":"ACTITUD QUE DIFICULTA CAMBIO DE CONDUCTA ALIMENTARIA Y\/O NUTRICIONAL"
  },
  {
    "codigo":235747003,
    "descripcion":"COLITIS AMEBIANA"
  },
  {
    "codigo":299448003,
    "descripcion":"CREPITACIÓN EN EL TOBILLO"
  },
  {
    "codigo":102840003,
    "descripcion":"CILINDRO URINARIO, ERITROCÍTICO"
  },
  {
    "codigo":201144006,
    "descripcion":"ALOPECIA HEREDITARIA"
  },
  {
    "codigo":364984007,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA LIBERAR LA PRENSIÓN"
  },
  {
    "codigo":397752008,
    "descripcion":"RUPTURA DE HERIDA PERINEAL OBSTÉTRICA"
  },
  {
    "codigo":725432008,
    "descripcion":"SUSCEPTIBILIDAD MENDELIANA AUTOSÓMICA RECESIVA A ENFERMEDAD POR MICOBACTERIAS DEBIDA A DEFICIENCIA PARCIAL DE RECEPTOR 2 DE INTERFERÓN GAMMA"
  },
  {
    "codigo":232077005,
    "descripcion":"VÍTREO VACÍO"
  },
  {
    "codigo":68237008,
    "descripcion":"CONEXIÓN VENOSA PULMONAR ANÓMALA PARCIAL"
  },
  {
    "codigo":263010001,
    "descripcion":"LUXACIÓN DE ARTICULACIÓN COSTOVERTEBRAL"
  },
  {
    "codigo":295778001,
    "descripcion":"SOBREDOSIS DE TAMOXIFENO"
  },
  {
    "codigo":721762007,
    "descripcion":"LEUCEMIA\/LINFOMA CUTÁNEO DE LINFOCITOS T DEL ADULTO"
  },
  {
    "codigo":230242007,
    "descripcion":"ATAXIA CEREBELOSA MEDICAMENTOSA"
  },
  {
    "codigo":426850008,
    "descripcion":"COMPLICACIÓN DE LA PREMATUREZ"
  },
  {
    "codigo":228407003,
    "descripcion":"CONSIGUE JERINGAS LIMPIAS"
  },
  {
    "codigo":293943006,
    "descripcion":"ALERGIA A CLORPROTIXENO"
  },
  {
    "codigo":292108000,
    "descripcion":"REACCIÓN ADVERSA A LA FAMOTIDINA"
  },
  {
    "codigo":161036002,
    "descripcion":"VIVIENDA ADECUADA"
  },
  {
    "codigo":128268005,
    "descripcion":"ARTROPATÍA DE LA PELVIS"
  },
  {
    "codigo":1088391000119100,
    "descripcion":"OTITIS MEDIA IZQUIERDA CRÓNICA ALÉRGICA"
  },
  {
    "codigo":95500008,
    "descripcion":"MEMBRANAS PUPILARES PERSISTENTES"
  },
  {
    "codigo":62732009,
    "descripcion":"FENÓMENO DEL MIEMBRO AJENO"
  },
  {
    "codigo":880097001,
    "descripcion":"DERMATITIS POR INFESTACIÓN DE ORNITHONYSSUS BACOTI"
  },
  {
    "codigo":60897004,
    "descripcion":"CONTUSIÓN DE LA NARIZ"
  },
  {
    "codigo":93665005,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE GLÁNDULA SUPRARRENAL"
  },
  {
    "codigo":290273008,
    "descripcion":"INTOXICACIÓN POR ÁCIDO MEFENÁMICO"
  },
  {
    "codigo":124598005,
    "descripcion":"DEFICIENCIA DE HISTIDINA DESCARBOXILASA"
  },
  {
    "codigo":288438005,
    "descripcion":"REALIZA ACTIVIDADES DE DIBUJO"
  },
  {
    "codigo":59062007,
    "descripcion":"ESTENOSIS CORONARIA"
  },
  {
    "codigo":417675000,
    "descripcion":"FRACTURA-LUXACIÓN NO EXPUESTA DE MÚLTIPLES DEDOS DE LA MANO"
  },
  {
    "codigo":714422009,
    "descripcion":"DIFICULTAD PARA LIMPIAR AGUJAS"
  },
  {
    "codigo":286603008,
    "descripcion":"CUERPO EXTRAÑO EN PARED Y CAVIDAD CORPORAL"
  },
  {
    "codigo":253835008,
    "descripcion":"ATRESIA DE VAGINA INFERIOR"
  },
  {
    "codigo":186464008,
    "descripcion":"INFECCIÓN POR MICOPLASMA"
  },
  {
    "codigo":282933000,
    "descripcion":"NO SE MUEVE DE POSICIÓN ACOSTADA A SENTADA"
  },
  {
    "codigo":250165002,
    "descripcion":"MATERIAL USADO EN LA CONFECCIÓN DEL CALZADO INADECUADO"
  },
  {
    "codigo":20789002,
    "descripcion":"INTOXICACIÓN POR EQUISETUM"
  },
  {
    "codigo":86325007,
    "descripcion":"ANEMIA NO MEGALOBLÁSTICA POR ALCOHOLISMO"
  },
  {
    "codigo":248330001,
    "descripcion":"OBSERVACIÓN SOBRE EL CRECIMIENTO EN GENERAL"
  },
  {
    "codigo":84490005,
    "descripcion":"LINFANGITIS AGUDA DEL TRONCO"
  },
  {
    "codigo":1264138006,
    "descripcion":"ANOXIA CEREBRAL POSTERIOR A EMBARAZO MOLAR"
  },
  {
    "codigo":836319004,
    "descripcion":"AGUDEZA VISUAL CORREGIDA DE OJO DERECHO 4\/60"
  },
  {
    "codigo":11218009,
    "descripcion":"INFECCIÓN CAUSADA POR PSEUDOMONAS AERUGINOSA"
  },
  {
    "codigo":80820004,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA CARÓTIDA INTERNA"
  },
  {
    "codigo":15284007,
    "descripcion":"TUBERCULOSIS DEL ESÓFAGO"
  },
  {
    "codigo":111753000,
    "descripcion":"COMPLICACIÓN DE LA TERAPIA POR INHALACIÓN"
  },
  {
    "codigo":408500009,
    "descripcion":"EXAMEN PEDIÁTRICO A LOS 7 MESES ANORMAL: DERIVADO"
  },
  {
    "codigo":898185002,
    "descripcion":"DEPENDENCIA DE TERAPIA DE REEMPLAZO RENAL INTERMITENTE PROLONGADA POR INSUFICIENCIA RENAL"
  },
  {
    "codigo":242825001,
    "descripcion":"SOBREDOSIS INTENCIONAL DE ASPIRINA"
  },
  {
    "codigo":13449007,
    "descripcion":"SÍNDROME DE MELNICK-NEEDLES"
  },
  {
    "codigo":11614003,
    "descripcion":"ESTENOSIS CONGÉNITA DE LAS VENAS PULMONARES"
  },
  {
    "codigo":109918005,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LOS NERVIOS PERIFÉRICOS Y DEL SISTEMA NERVIOSO AUTÓNOMO"
  },
  {
    "codigo":372062007,
    "descripcion":"NEOPLASIA MALIGNA DE SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":75315001,
    "descripcion":"UVEÍTIS SIMPÁTICA"
  },
  {
    "codigo":322871000119100,
    "descripcion":"LESIÓN TRAUMÁTICA DE REGIONES DORSAL Y LUMBAR DE COLUMNA VERTEBRAL"
  },
  {
    "codigo":311000119101,
    "descripcion":"RINITIS DE ETIOLOGÍA NO ALÉRGICA"
  },
  {
    "codigo":16028471000119102,
    "descripcion":"EXOSTOSIS DE AMBOS CALCÁNEOS"
  },
  {
    "codigo":10626871000119102,
    "descripcion":"FORÚNCULO DE CADERA IZQUIERDA"
  },
  {
    "codigo":16302391000119104,
    "descripcion":"LESIÓN DE HUESO DE RADIO Y\/O CÚBITO IZQUIERDOS"
  },
  {
    "codigo":368951000119105,
    "descripcion":"INSUFICIENCIA RENAL AGUDA CAUSADA POR AGENTE DE CONTRASTE"
  },
  {
    "codigo":16033591000119106,
    "descripcion":"HIPERTROFIA DE RADIO DERECHO"
  },
  {
    "codigo":827144003,
    "descripcion":"TUMORACIÓN QUÍSTICA DE MAMA"
  },
  {
    "codigo":41271000119108,
    "descripcion":"ARTRITIS VIRAL CONCOMITANTE CON HEPATITIS"
  },
  {
    "codigo":15997751000119100,
    "descripcion":"DEFECTO DE CAPA DE FIBRAS NERVIOSAS DE AMBAS RETINAS"
  },
  {
    "codigo":302856006,
    "descripcion":"LEUCEMIA ALEUCÉMICA"
  },
  {
    "codigo":10631991000119104,
    "descripcion":"ABSCESO DE PULPEJO DE DEDO DE LA MANO IZQUIERDA"
  },
  {
    "codigo":16002871000119105,
    "descripcion":"DOLOR CRÓNICO DE PIE DERECHO"
  },
  {
    "codigo":315191000119106,
    "descripcion":"OSTEOCONDRITIS DISECANTE DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":10678071000119108,
    "descripcion":"NECROSIS DE COLUMNA VERTEBRAL CONCOMITANTE CON ÚLCERA CRÓNICA DE DORSO Y DEBIDA A ELLA"
  },
  {
    "codigo":15984951000119108,
    "descripcion":"HEMORRAGIA CEREBELOSA ESPONTÁNEA NEONATAL"
  },
  {
    "codigo":66871000119108,
    "descripcion":"PORTADOR DE TRASTORNO METABÓLICO"
  },
  {
    "codigo":16891191000119108,
    "descripcion":"ENFERMEDAD CORONARIA DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":366557000,
    "descripcion":"HALLAZGO RELACIONADO CON EL TAMAÑO DE LA PIERNA"
  },
  {
    "codigo":40712008,
    "descripcion":"DERMATITIS DE CONTACTO ALÉRGICA CAUSADA POR ÁRNICA"
  },
  {
    "codigo":37042000,
    "descripcion":"PSORIASIS EN GOTAS"
  },
  {
    "codigo":38877003,
    "descripcion":"AORTITIS REUMATOIDEA"
  },
  {
    "codigo":301021005,
    "descripcion":"ÚLCERA DE DEDO DEL PIE"
  },
  {
    "codigo":364722003,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA CAMINAR EN UNA LÍNEA ANGOSTA"
  },
  {
    "codigo":299186003,
    "descripcion":"AMPLITUD DE OPOSICIÓN ACTIVA DEL PULGAR AUMENTADA"
  },
  {
    "codigo":102578005,
    "descripcion":"BRONCOESPASMO PARADÓJICO"
  },
  {
    "codigo":233650005,
    "descripcion":"DERRAME SEUDOQUILOSO INTRALIPÍDICO"
  },
  {
    "codigo":69810009,
    "descripcion":"COLITIS HEMORRÁGICA AGUDA CAUSADA POR ESCHERICHIA COLI"
  },
  {
    "codigo":2439002,
    "descripcion":"ENDOCARDITIS PURULENTA"
  },
  {
    "codigo":67975003,
    "descripcion":"EMBOLIA FIBROCARTILAGINOSA DE LA MÉDULA ESPINAL"
  },
  {
    "codigo":199047001,
    "descripcion":"FALSO TRABAJO DE PARTO"
  },
  {
    "codigo":231815005,
    "descripcion":"ABRASIÓN PALPEBRAL"
  },
  {
    "codigo":788871006,
    "descripcion":"ENFERMEDAD ATÍPICA CAUSADA POR HANTAVIRUS"
  },
  {
    "codigo":35207008,
    "descripcion":"INTOXICACIÓN POR PANICUM COLORATUM"
  },
  {
    "codigo":721500004,
    "descripcion":"LESIÓN COMPLETA DE MÉDULA ESPINAL AL NIVEL DEL PRIMER SEGMENTO LUMBAR"
  },
  {
    "codigo":262748008,
    "descripcion":"AVULSIÓN DE LA RAÍZ DE NERVIO SACRO"
  },
  {
    "codigo":293681003,
    "descripcion":"ALERGIA A LACTULOSA"
  },
  {
    "codigo":719665003,
    "descripcion":"SÍNDROME DE MICRODUPLICACIÓN 5Q35"
  },
  {
    "codigo":31537005,
    "descripcion":"TRASTORNO DEL CICLO DE SUEÑO - VIGILIA, DE FASE AVANZADA"
  },
  {
    "codigo":228145007,
    "descripcion":"ALTERACIÓN DE LAS FORMAS DEL HABLA"
  },
  {
    "codigo":16819541000119108,
    "descripcion":"RUPTURA ESPONTÁNEA DE FASCIA PLANTAR DE PIE IZQUIERDO"
  },
  {
    "codigo":29702001,
    "descripcion":"SÍNDROME DE AFASIA - LÓBULO PARIETAL IZQUIERDO"
  },
  {
    "codigo":1078278004,
    "descripcion":"AUSENCIA CONGÉNITA DE VÉRTEBRA COCCÍGEA"
  },
  {
    "codigo":291846006,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR OXIMETOLONA"
  },
  {
    "codigo":10301000202103,
    "descripcion":"INTERACCIÓN ADECUADA CON OTROS"
  },
  {
    "codigo":95238006,
    "descripcion":"MORDIDA EN CRUZ POSTERIOR INVERSA"
  },
  {
    "codigo":160774006,
    "descripcion":"PRESTACIÓN DE AYUDA DOMICILIARIA"
  },
  {
    "codigo":715995001,
    "descripcion":"ACCESO A LA RESIDENCIA POR ESCALONES"
  },
  {
    "codigo":93403005,
    "descripcion":"ENGROSAMIENTO CONGÉNITO DE ILION"
  },
  {
    "codigo":1303984003,
    "descripcion":"BLEBITIS CONJUNTIVAL BILATERAL POSTERIOR A CIRUGÍA DE GLAUCOMA"
  },
  {
    "codigo":81391000119106,
    "descripcion":"ARTROPATÍA DE CHARCOT DEBIDA A SIRINGOMIELIA"
  },
  {
    "codigo":124336007,
    "descripcion":"DEFICIENCIA DE ASPARTATO CINASA"
  },
  {
    "codigo":1269381002,
    "descripcion":"LESIÓN CENTRAL DE MÉDULA ESPINAL DORSAL DEBIDA A LUXACIÓN EXPUESTA DE ARTICULACIÓN DE COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":253573003,
    "descripcion":"INFUNDÍBULO SUBPULMONAR"
  },
  {
    "codigo":286341006,
    "descripcion":"NO EMITE UN VOLUMEN DE VOZ ADECUADO"
  },
  {
    "codigo":87898000,
    "descripcion":"HIPOMAGNESEMIA NEONATAL"
  },
  {
    "codigo":55130001,
    "descripcion":"LARINGOTRAQUEÍTIS"
  },
  {
    "codigo":1234778004,
    "descripcion":"ESTEATOHEPATITIS ALCOHÓLICA"
  },
  {
    "codigo":251738006,
    "descripcion":"HALLAZGO ORTÓPTICO"
  },
  {
    "codigo":218970007,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR MERCUROFILINA"
  },
  {
    "codigo":284506006,
    "descripcion":"GRAN DIFICULTAD PARA CONTROLAR LA CONDUCTA"
  },
  {
    "codigo":186202007,
    "descripcion":"TUBERCULOSIS RESPIRATORIA, SIN CONFIRMACIÓN BACTERIOLÓGICA O HISTOLÓGICA"
  },
  {
    "codigo":53295002,
    "descripcion":"OTITIS EXTERNA CRÓNICA"
  },
  {
    "codigo":1003567000,
    "descripcion":"AGENESIA DE VÍA BILIAR"
  },
  {
    "codigo":249903005,
    "descripcion":"DIFICULTAD PARA PONERSE DE PIE"
  },
  {
    "codigo":708655006,
    "descripcion":"NECROSIS POSTERIOR A INYECCIÓN DE ANESTÉSICO LOCAL"
  },
  {
    "codigo":446511007,
    "descripcion":"FÍSTULA CUTÁNEA DE REGIÓN INGUINAL"
  },
  {
    "codigo":282671006,
    "descripcion":"CAPAZ DE ATRAPAR"
  },
  {
    "codigo":315439009,
    "descripcion":"NACIDO EN HAITÍ"
  },
  {
    "codigo":248068005,
    "descripcion":"PROBLEMAS DE LA PIEL AUTOINFLIGIDOS"
  },
  {
    "codigo":300681000119106,
    "descripcion":"TRASTORNO DE TENDÓN DE PIERNA DERECHA"
  },
  {
    "codigo":15701641000119107,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE TENDÓN DE AMBAS PIERNAS"
  },
  {
    "codigo":279001004,
    "descripcion":"HALLAZGO RELACIONADO CON DOLOR EN UN SITIO ANATÓMICO"
  },
  {
    "codigo":82393007,
    "descripcion":"ESÓFAGO GIGANTE"
  },
  {
    "codigo":410073008,
    "descripcion":"ATROFIA DE ESTRUCTURA ORBITARIA"
  },
  {
    "codigo":441006000,
    "descripcion":"ENFERMEDAD MODERADA POR DEFICIENCIA HEREDITARIA DE FACTOR VIII SIN INHIBIDORES"
  },
  {
    "codigo":277166003,
    "descripcion":"SANGRE SECA EN EL CONDUCTO AUDITIVO EXTERNO"
  },
  {
    "codigo":735918005,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE CARÚNCULA LAGRIMAL"
  },
  {
    "codigo":1292974007,
    "descripcion":"FRACTURA DE RAMA DE PUBIS"
  },
  {
    "codigo":78723001,
    "descripcion":"CANABINOSIS"
  },
  {
    "codigo":111491004,
    "descripcion":"TRASTORNO DE PÁNICO CON AGORAFOBIA, EVITACIÓN AGORAFÓBICA EN REMISIÓN TOTAL Y ATAQUES DE PÁNICO EN REMISIÓN PARCIAL"
  },
  {
    "codigo":275331007,
    "descripcion":"LUXACIÓN DE EXTREMO DISTAL DE TIBIA"
  },
  {
    "codigo":13187008,
    "descripcion":"INTOXICACIÓN POR HEROÍNA"
  },
  {
    "codigo":207960001,
    "descripcion":"FRACTURA NO EXPUESTA DE VÉRTEBRA LUMBAR, ESPONDILÓLISIS"
  },
  {
    "codigo":240728001,
    "descripcion":"COCCIDIOIDOMICOSIS SUBCUTÁNEA"
  },
  {
    "codigo":732248005,
    "descripcion":"SÍNDROME COXOAURICULAR"
  },
  {
    "codigo":11352009,
    "descripcion":"CRIOGLOBULINEMIA PRIMARIA"
  },
  {
    "codigo":75053002,
    "descripcion":"ENFERMEDAD DE KAWASAKI"
  },
  {
    "codigo":271661003,
    "descripcion":"RUIDOS CARDÍACOS AUMENTADOS DE INTENSIDAD"
  },
  {
    "codigo":238893005,
    "descripcion":"HIPERTROFIA GRASA"
  },
  {
    "codigo":402733006,
    "descripcion":"TIC HABITUAL QUE AFECTA LA PIEL"
  },
  {
    "codigo":237058000,
    "descripcion":"TUMOR DE CORDÓN GERMINAL DE OVARIO"
  },
  {
    "codigo":40450001,
    "descripcion":"EMBOLIA DEL SENO SAGITAL SUPERIOR"
  },
  {
    "codigo":1156397008,
    "descripcion":"FRACTURA DE CUERNO MAYOR IZQUIERDO DE HUESO HIOIDES"
  },
  {
    "codigo":105986008,
    "descripcion":"DISPLASIA ESQUELÉTICA"
  },
  {
    "codigo":300759001,
    "descripcion":"NO SE ENTRETIENE CON UN PASATIEMPO"
  },
  {
    "codigo":366295009,
    "descripcion":"HALLAZGO RELACIONADO CON LA CANTIDAD DE ESMEGMA"
  },
  {
    "codigo":724908002,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO A LA ALTURA DEL BRAZO"
  },
  {
    "codigo":525574231000119100,
    "descripcion":"ATRAPAMIENTO DE MÚSCULO RECTO EXTERNO DE OJO DERECHO"
  },
  {
    "codigo":298924009,
    "descripcion":"ARTICULACIÓN DE CODO INESTABLE"
  },
  {
    "codigo":2177002,
    "descripcion":"NEURALGIA POSHERPÉTICA"
  },
  {
    "codigo":112941000112107,
    "descripcion":"NEISSERIA MUCOSA O NEISSERIA SICCA"
  },
  {
    "codigo":297089003,
    "descripcion":"SOBREDOSIS DE DINITRITO DE ISOSORBIDA"
  },
  {
    "codigo":196950000,
    "descripcion":"HERNIA RETROPERITONEAL - IRREDUCTIBLE"
  },
  {
    "codigo":721238001,
    "descripcion":"ANOMALÍA ADQUIRIDA DE ARTERIA PULMONAR"
  },
  {
    "codigo":65878001,
    "descripcion":"BRONQUITIS SÉPTICA"
  },
  {
    "codigo":229718005,
    "descripcion":"DEMORA FONOLÓGICA"
  },
  {
    "codigo":295254007,
    "descripcion":"SOBREDOSIS DE INDOMETACINA"
  },
  {
    "codigo":293419001,
    "descripcion":"REACCIÓN ADVERSA A GEMFIBROZILO"
  },
  {
    "codigo":719403003,
    "descripcion":"LEUCOENCEFALOPATÍA CONCOMITANTE CON QUISTES DE LÓBULO PARIETAL ANTERIOR BILATERALES"
  },
  {
    "codigo":129579005,
    "descripcion":"FLUJO VASCULAR EN UNA DERIVACIÓN PORTOESPLÉNICA"
  },
  {
    "codigo":64043005,
    "descripcion":"MIOCARDITIS BACTERIANA"
  },
  {
    "codigo":29440002,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE INGLE, CON INFECCIÓN"
  },
  {
    "codigo":62208003,
    "descripcion":"ENVENENAMIENTO POR MEDUSA"
  },
  {
    "codigo":94976004,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE HUESO PALATINO"
  },
  {
    "codigo":10625111000119106,
    "descripcion":"BRONCONEUMONÍA CAUSADA POR ESCHERICHIA COLI"
  },
  {
    "codigo":715733000,
    "descripcion":"HIPERPLASIA SUPRARRENAL CONGÉNITA DEBIDA A DEFICIENCIA DE CITOCROMO P450 OXIDORREDUCTASA"
  },
  {
    "codigo":224213000,
    "descripcion":"VIVE EN UN HOSPEDAJE ALQUILADO"
  },
  {
    "codigo":1010645004,
    "descripcion":"ARTERIA UMBILICAL ÚNICA TIPO III"
  },
  {
    "codigo":289749007,
    "descripcion":"PROBLEMA DEL ÚTERO GRÁVIDO"
  },
  {
    "codigo":16906481000119103,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE PÁRPADO SUPERIOR DERECHO"
  },
  {
    "codigo":124074005,
    "descripcion":"COPROPORFIRINA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1303722007,
    "descripcion":"DEFORMIDAD EN VALGO DE PRIMER DEDO DE AMBOS PIES"
  },
  {
    "codigo":449919001,
    "descripcion":"CONGELAMIENTO SUPERFICIAL DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":23935006,
    "descripcion":"DÉFICIT EN LAS ACTIVIDADES RECREATIVAS"
  },
  {
    "codigo":253311006,
    "descripcion":"VENA CAVA SUPERIOR BILATERAL"
  },
  {
    "codigo":251476004,
    "descripcion":"PUNTA ONDA LENTA GENERALIZADA (MENOS DE TRES POR SEGUNDO)"
  },
  {
    "codigo":249641001,
    "descripcion":"ESFÍNTER ANAL INTACTO"
  },
  {
    "codigo":185940009,
    "descripcion":"PACIENTE EN ESTUDIO DE ASMA"
  },
  {
    "codigo":448084009,
    "descripcion":"TRONCO PULMONAR AUSENTE"
  },
  {
    "codigo":686321000119108,
    "descripcion":"HISTIOCITOMA FIBROSO MALIGNO PRIMARIO DE PARTES BLANDAS DE CADERA"
  },
  {
    "codigo":1263614004,
    "descripcion":"TRASTORNO NEONATAL PRECOZ DEBIDO A INERCIA UTERINA"
  },
  {
    "codigo":18430005,
    "descripcion":"GRADO DE GLEASON: 4"
  },
  {
    "codigo":83966006,
    "descripcion":"HIPOTERMIA CAUSADA POR PERMANENCIA EN UN AMBIENTE FRÍO"
  },
  {
    "codigo":247806005,
    "descripcion":"INCÓMODO"
  },
  {
    "codigo":1360083000,
    "descripcion":"SÍNDROME DE CITOPENIA, AUTOINFLAMACIÓN, ERUPCIÓN, EPISODIOS DE LINFOHISTIOCITOSIS HEMOFAGOCÍTICA DE INICIO NEONATAL"
  },
  {
    "codigo":1163475003,
    "descripcion":"INFECCIÓN INVASIVA DE PIEL CAUSADA POR ASPERGILLUS"
  },
  {
    "codigo":373373000,
    "descripcion":"GRADO HISTOLÓGICO ESCASAMENTE DIFERENCIADO - HALLAZGO"
  },
  {
    "codigo":14760008,
    "descripcion":"ESTREÑIMIENTO"
  },
  {
    "codigo":1290877006,
    "descripcion":"NÓDULO REUMATOIDEO DE TEJIDO CELULAR SUBCUTÁNEO DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":43858000,
    "descripcion":"ANEMIA APLÁSICA SECUNDARIA"
  },
  {
    "codigo":109394001,
    "descripcion":"DISOSTOSIS INTERMANDIBULAR"
  },
  {
    "codigo":74791000,
    "descripcion":"PEDOFILIA, LIMITADA AL INCESTO"
  },
  {
    "codigo":1354578009,
    "descripcion":"PROSTATITIS BACTERIANA CRÓNICA"
  },
  {
    "codigo":402471004,
    "descripcion":"XANTOMA ERUPTIVO TUBEROSO"
  },
  {
    "codigo":238631008,
    "descripcion":"POROQUERATOSIS LINEAL"
  },
  {
    "codigo":369703009,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA DE GLÁNDULA TIROIDES, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":236796004,
    "descripcion":"HIPOGONADISMO CON SÍNDROME DEL ABDOMEN EN CIRUELA PASA"
  },
  {
    "codigo":171260005,
    "descripcion":"NO VACUNADO CONTRA LA TOS FERINA"
  },
  {
    "codigo":300497000,
    "descripcion":"EPIDÍDIMO AGRANDADO"
  },
  {
    "codigo":38353004,
    "descripcion":"PORENCEFALIA CONGÉNITA"
  },
  {
    "codigo":202193004,
    "descripcion":"LUXACIÓN PATOLÓGICA DE LA ARTICULACIÓN SUBASTRAGALINA"
  },
  {
    "codigo":366033007,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA DORMIR"
  },
  {
    "codigo":234961008,
    "descripcion":"AMELOGÉNESIS IMPERFECTA HIPOPLÁSICA, AUTOSÓMICA DOMINANTE, LOCAL"
  },
  {
    "codigo":3750006,
    "descripcion":"ESPASMO ARTERIAL"
  },
  {
    "codigo":1052326006,
    "descripcion":"RAQUISQUISIS PARCIAL"
  },
  {
    "codigo":165755000,
    "descripcion":"ANTICUERPOS DE LEWIS DETECTADOS"
  },
  {
    "codigo":296827006,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE GLUCAGÓN"
  },
  {
    "codigo":1179728006,
    "descripcion":"REACCIÓN ADVERSA AL REMDESIVIR"
  },
  {
    "codigo":294992007,
    "descripcion":"ALERGIA A BENDROFLUAZIDA"
  },
  {
    "codigo":31013001,
    "descripcion":"PRESIÓN ARTERIAL MEDIA DISMINUIDA"
  },
  {
    "codigo":719141002,
    "descripcion":"CAPAZ DE RECONOCER SEÑALES SOCIALES"
  },
  {
    "codigo":15735641000119101,
    "descripcion":"QUERATOPATÍA EN VÓRTICE DE OJO DERECHO"
  },
  {
    "codigo":720976009,
    "descripcion":"TRASTORNO CONGÉNITO DE GLICOSILACIÓN 3 VINCULADO A ASPARAGINA"
  },
  {
    "codigo":131152009,
    "descripcion":"GRUPO SANGUÍNEO A>X<"
  },
  {
    "codigo":424229006,
    "descripcion":"CARCINOMA DUCTAL INFILTRANTE DE MAMA, ESTADIO 4"
  },
  {
    "codigo":16007871000119108,
    "descripcion":"TROMBOSIS DE ARTERIA DE EXTREMIDAD SUPERIOR IZQUIERDA"
  },
  {
    "codigo":293157009,
    "descripcion":"REACCIÓN ADVERSA AL CLOBETASOL"
  },
  {
    "codigo":1208826001,
    "descripcion":"DESPLAZAMIENTO DE ELECTRODO DE MARCAPASOS CARDÍACO VENTRICULAR"
  },
  {
    "codigo":94714002,
    "descripcion":"MICOSIS FUNGOIDE DE BAZO"
  },
  {
    "codigo":289487000,
    "descripcion":"PÚRPURA DE VULVA"
  },
  {
    "codigo":125647000,
    "descripcion":"HERIDA ABIERTA DE LA REGIÓN AXILAR"
  },
  {
    "codigo":11311961000119104,
    "descripcion":"FRACTURA EXPUESTA DE TERCERA VÉRTEBRA LUMBAR"
  },
  {
    "codigo":92879006,
    "descripcion":"FUSIÓN ANORMAL CONGÉNITA DEL TARSO"
  },
  {
    "codigo":715471007,
    "descripcion":"SÍNDROME DE DISPLASIA MESOMÉLICA CON FISURA DE PALADAR Y CAMPTODACTILIA"
  },
  {
    "codigo":1336228001,
    "descripcion":"TRASTORNO POR USO DE SEDANTES"
  },
  {
    "codigo":27343009,
    "descripcion":"CONDUCTA DE ACERCAMIENTO - EVITACIÓN"
  },
  {
    "codigo":123812008,
    "descripcion":"EXCESO DE CINC"
  },
  {
    "codigo":56441002,
    "descripcion":"ACOSO SEXUAL"
  },
  {
    "codigo":308211000119101,
    "descripcion":"DEFORMIDAD EN FLEXIÓN DE ARTICULACIÓN DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":285817008,
    "descripcion":"DIFICULTAD PARA MANEJAR LAS CANILLAS DE AGUA"
  },
  {
    "codigo":282147000,
    "descripcion":"NO CAMINA"
  },
  {
    "codigo":85539001,
    "descripcion":"HEMORRAGIA DEL RECIÉN NACIDO"
  },
  {
    "codigo":251214008,
    "descripcion":"INTERVALO TU PROLONGADO"
  },
  {
    "codigo":773667003,
    "descripcion":"SÍNDROME DE HIPERTELORISMO, FÍSTULA PREAURICULAR, OBSTRUCCIÓN DEL CONDUCTO LAGRIMAL Y SORDERA"
  },
  {
    "codigo":447822009,
    "descripcion":"PROLAPSO CONGÉNITO DE VÁLVULA AÓRTICA"
  },
  {
    "codigo":413219009,
    "descripcion":"GASTROPATÍA HIPERTRÓFICA"
  },
  {
    "codigo":18168004,
    "descripcion":"DIARREA ASOCIADA A LA LECHE DE VACA CRUDA"
  },
  {
    "codigo":739064005,
    "descripcion":"METABOLIZADOR NORMAL DE LA FAMILIA 3 SUBFAMILIA A MIEMBRO 5 DEL CITOCROMO P450"
  },
  {
    "codigo":50936006,
    "descripcion":"AMPOLLA DEL ANO, SIN INFECCIÓN"
  },
  {
    "codigo":737229001,
    "descripcion":"TRASTORNO DE LA SUSTANCIA BLANCA DEBIDO A ANOMALÍA VASCULAR"
  },
  {
    "codigo":16333002,
    "descripcion":"QUEMADURA EPIDÉRMICA DE GENITALES MASCULINOS"
  },
  {
    "codigo":50030121000188108,
    "descripcion":"CON MAYOR RIESGO DE TROMBOEMBOLIA ARTERIAL"
  },
  {
    "codigo":81869008,
    "descripcion":"PRODUCCIÓN ANORMAL DE ERITROCITOS"
  },
  {
    "codigo":276642001,
    "descripcion":"ASFIXIA FETAL EN EL PREPARTO"
  },
  {
    "codigo":1259682002,
    "descripcion":"CARCINOMA DUCTAL INFILTRANTE PRIMARIO DE PÁNCREAS"
  },
  {
    "codigo":80034003,
    "descripcion":"GINGIVITIS MARGINAL SIMPLE"
  },
  {
    "codigo":211106006,
    "descripcion":"PICADURA DE INSECTO, NO VENENOSO, EN LA PARED ABDOMINAL"
  },
  {
    "codigo":243874008,
    "descripcion":"ESTADO DE CONTROL DE REPETICIÓN DE LA PRESCRIPCIÓN"
  },
  {
    "codigo":473250009,
    "descripcion":"QUEMADURA DE REGIÓN OCULAR CON QUEMADURA DE TERCER GRADO DE CABEZA Y\/O CUELLO"
  },
  {
    "codigo":405879001,
    "descripcion":"FENOTIPO N-"
  },
  {
    "codigo":15928461000119104,
    "descripcion":"INFECCIÓN DE PEZÓN DURANTE LA LACTANCIA"
  },
  {
    "codigo":45431004,
    "descripcion":"PERICONDRITIS CRÓNICA DEL PABELLÓN DE LA OREJA"
  },
  {
    "codigo":209271003,
    "descripcion":"FRACTURA-LUXACIÓN NO EXPUESTA TRANSESCAFOIDEA DE ARTICULACIÓN PERISEMILUNAR"
  },
  {
    "codigo":78199001,
    "descripcion":"TUMOR EPITELIAL DE OVARIO, ESTADIO IIC DE LA FIGO"
  },
  {
    "codigo":438647008,
    "descripcion":"TROMBOSIS DE VENA SUBCLAVIA"
  },
  {
    "codigo":830028002,
    "descripcion":"QUISTE DERMOIDE DE ÓRBITA PROPIAMENTE DICHA"
  },
  {
    "codigo":240204004,
    "descripcion":"NEOPLASIA DE TIPO SINOVIAL"
  },
  {
    "codigo":404044006,
    "descripcion":"LEIOMIOMA GENITAL"
  },
  {
    "codigo":402209004,
    "descripcion":"DERMATITIS SEBORREICA PERIANAL"
  },
  {
    "codigo":271137009,
    "descripcion":"MALA CIRCULACIÓN - ALTERACIÓN VASOMOTORA"
  },
  {
    "codigo":39926002,
    "descripcion":"VISIÓN EN AUREOLA"
  },
  {
    "codigo":16747661000119109,
    "descripcion":"RETINOPATÍA DIABÉTICA NO PROLIFERATIVA BILATERAL POR DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":1186806006,
    "descripcion":"NEUROTOXICIDAD CAUSADA POR VENENO DE INSECTO"
  },
  {
    "codigo":302070007,
    "descripcion":"LA GLÁNDULA TIROIDES SE MUEVE AL TRAGAR"
  },
  {
    "codigo":431307001,
    "descripcion":"INTOXICACIÓN INTENCIONAL CAUSADA POR FÁRMACO"
  },
  {
    "codigo":365771003,
    "descripcion":"NIVEL DE FOSFATASA ALCALINA - HALLAZGO"
  },
  {
    "codigo":726219006,
    "descripcion":"DISTENSIÓN DE MÚSCULO DE LA CADERA"
  },
  {
    "codigo":1074471000119106,
    "descripcion":"OSTEOARTROSIS DE ARTICULACIÓN MEDIOTARSIANA DE PIE DERECHO"
  },
  {
    "codigo":167328007,
    "descripcion":"UROBILINÓGENO EN ORINA: ++++"
  },
  {
    "codigo":724384008,
    "descripcion":"DEGENERACIÓN CORIORRETINIANA PERIPAPILAR HELICOIDAL"
  },
  {
    "codigo":298400009,
    "descripcion":"TUMEFACCIÓN DE PARTES BLANDAS DE COLUMNA VERTEBRAL CERVICAL"
  },
  {
    "codigo":1148533006,
    "descripcion":"SOBREDOSIS INTENCIONAL DE ÁCIDO BILIAR Y\/O DERIVADO DE ÁCIDO BILIAR"
  },
  {
    "codigo":394869007,
    "descripcion":"ESPECIE DE CAMPYLOBACTER, NO AISLADA"
  },
  {
    "codigo":310721000119102,
    "descripcion":"MIOSITIS INFECCIOSA DE ANTEBRAZO DERECHO"
  },
  {
    "codigo":425802001,
    "descripcion":"DERRAME PLEURAL BILATERAL"
  },
  {
    "codigo":296565008,
    "descripcion":"SOBREDOSIS DE QUININA"
  },
  {
    "codigo":722549009,
    "descripcion":"INFECCIÓN CAUSADA POR TOXOPLASMA"
  },
  {
    "codigo":65354004,
    "descripcion":"FRACTURAS DE HUESOS DEL TRONCO"
  },
  {
    "codigo":15983911000119109,
    "descripcion":"MÚSCULO OCULAR SUPERNUMERARIO DE AMBOS OJOS"
  },
  {
    "codigo":294730008,
    "descripcion":"ALERGIA A CLORPROPAMIDA"
  },
  {
    "codigo":10960321000119104,
    "descripcion":"LACERACIÓN DE ANTEBRAZO IZQUIERDO"
  },
  {
    "codigo":1144863004,
    "descripcion":"HIPOPLASIA CONGÉNITA DE GENITALES EXTERNOS MASCULINOS"
  },
  {
    "codigo":129055004,
    "descripcion":"BAÑO (ACTIVIDAD COTIDIANA)"
  },
  {
    "codigo":717044000,
    "descripcion":"HIPOGLUCEMIA HIPERINSULINÉMICA PERSISTENTE SIN INSULINOMA, DE COMIENZO EN LA VIDA ADULTA"
  },
  {
    "codigo":292895009,
    "descripcion":"REACCIÓN ADVERSA A SURFACTANTE CATIÓNICO"
  },
  {
    "codigo":127220001,
    "descripcion":"LINFOMA MALIGNO DE LOS GANGLIOS LINFÁTICOS"
  },
  {
    "codigo":94452002,
    "descripcion":"NEOPLASIA MALIGNA SECUNDARIA DEL NERVIO ÓPTICO"
  },
  {
    "codigo":11861441000119105,
    "descripcion":"SUBLUXACIÓN DE ARTICULACIÓN DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":1306868005,
    "descripcion":"GLAUCOMA POR RECESIÓN DE ÁNGULO DE OJO IZQUIERDO"
  },
  {
    "codigo":11779521000119105,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE REGIÓN DE CODO IZQUIERDO"
  },
  {
    "codigo":225524007,
    "descripcion":"ALIMENTACIÓN CAÓTICA"
  },
  {
    "codigo":782580009,
    "descripcion":"ALERGIA A AZO-DERIVADO DE ACRIDINA"
  },
  {
    "codigo":92617001,
    "descripcion":"CARCINOMA IN SITU DEL INTESTINO"
  },
  {
    "codigo":90782003,
    "descripcion":"SÍNDROME POSTCOLECISTECTOMÍA"
  },
  {
    "codigo":1303198005,
    "descripcion":"INFECCIÓN DE CLAVÍCULA ASOCIADA CON DISPOSITIVO DE FIJACIÓN INTERNA"
  },
  {
    "codigo":254622008,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS DE BRONQUIO"
  },
  {
    "codigo":187251001,
    "descripcion":"SECUELA DE TUBERCULOSIS"
  },
  {
    "codigo":1137523003,
    "descripcion":"CALCIFICACIÓN PUNTEADA DE EPÍFISIS DE FALANGE DISTAL DE DEDO GORDO"
  },
  {
    "codigo":416627004,
    "descripcion":"HIPOPLASIA GRANULOCÍTICA DE MÉDULA ÓSEA"
  },
  {
    "codigo":285555006,
    "descripcion":"INCAPAZ DE MANTENER LA ELEVACIÓN DEL PALADAR BLANDO"
  },
  {
    "codigo":711539009,
    "descripcion":"SOBREDOSIS INTENCIONAL DE SUSTANCIA INYECTABLE"
  },
  {
    "codigo":283720005,
    "descripcion":"MORDEDURA HUMANA EN EL GLÚTEO"
  },
  {
    "codigo":250952007,
    "descripcion":"PARED VENTRICULAR DERECHA HIPERCINÉTICA"
  },
  {
    "codigo":249117000,
    "descripcion":"PRESENTACIÓN DE NALGAS NO ENCAJADA"
  },
  {
    "codigo":185416008,
    "descripcion":"CITA SOLICITADA POR EL EMPLEADOR"
  },
  {
    "codigo":609565001,
    "descripcion":"DIABETES MELLITUS NEONATAL PERMANENTE"
  },
  {
    "codigo":773405004,
    "descripcion":"SÍNDROME DE DISCAPACIDAD INTELECTUAL CON ESTRABISMO"
  },
  {
    "codigo":314653005,
    "descripcion":"PERÍMETRO CEFÁLICO DEL NIÑO: PERCENTILO 51-74"
  },
  {
    "codigo":1363229005,
    "descripcion":"CICATRIZACIÓN DE PÁRPADOS IZQUIERDOS SUPERIOR E INFERIOR"
  },
  {
    "codigo":247282000,
    "descripcion":"CAVIDAD MASTOIDEA SECA"
  },
  {
    "codigo":443890006,
    "descripcion":"PATRÓN DE ANTICUERPOS ANTICENTRÓMEROS"
  },
  {
    "codigo":83442007,
    "descripcion":"REACCIÓN SISTÉMICA DESFAVORABLE A LA PRUEBA CUTÁNEA"
  },
  {
    "codigo":16071000,
    "descripcion":"CONTRACTURAS EN FLEXIÓN GENERALIZADAS CONGÉNITAS DE LAS ARTICULACIONES DE LOS MIEMBROS INFERIORES"
  },
  {
    "codigo":48839007,
    "descripcion":"RESISTENCIA AL GLUCAGÓN"
  },
  {
    "codigo":339701000119105,
    "descripcion":"ECTROPIÓN ESPÁSTICO DE PÁRPADO INFERIOR IZQUIERDO"
  },
  {
    "codigo":1259420000,
    "descripcion":"CARCINOMA PRIMARIO DE CUADRANTE SUPEROEXTERNO DE MAMA"
  },
  {
    "codigo":1357724003,
    "descripcion":"DEPENDENCIA DE EQUIPO Y\/O DISPOSITIVO MÉDICO QUE DEMANDA ENERGÍA"
  },
  {
    "codigo":702364003,
    "descripcion":"ENFERMEDAD POR RETENCIÓN DE QUILOMICRONES"
  },
  {
    "codigo":407452005,
    "descripcion":"INFECCIÓN COMBINADA POR VIRUS DEL HERPES SIMPLE 1 Y 2"
  },
  {
    "codigo":735132006,
    "descripcion":"OCLUSIÓN DE ARTERIA CEREBELOSA DERECHA"
  },
  {
    "codigo":440220007,
    "descripcion":"DOLOR A LA PALPACIÓN ABDOMINAL GENERALIZADO"
  },
  {
    "codigo":276380006,
    "descripcion":"INESTABILIDAD DE CADERA"
  },
  {
    "codigo":210844006,
    "descripcion":"LESIÓN TRAUMÁTICA NO EXPUESTA DE ARTERIA PALMAR"
  },
  {
    "codigo":241777000,
    "descripcion":"INTOXICACIÓN POR AMANITA PHALLOIDES"
  },
  {
    "codigo":307313003,
    "descripcion":"PERFORACIÓN DE ARTERIA ILÍACA"
  },
  {
    "codigo":472988006,
    "descripcion":"ACTIVIDAD SEXUAL CON PERSONA TRANSEXUAL"
  },
  {
    "codigo":733297007,
    "descripcion":"FRACTURA DE TOBILLO COMPLICADA"
  },
  {
    "codigo":305478003,
    "descripcion":"BAJO ATENCIÓN DE NEUROFISIÓLOGO CLÍNICO"
  },
  {
    "codigo":1076981000119109,
    "descripcion":"QUISTE ÓSEO DE HOMBRO DERECHO"
  },
  {
    "codigo":698694005,
    "descripcion":"LUPUS ERITEMATOSO SISTÉMICO EN REMISIÓN"
  },
  {
    "codigo":403782004,
    "descripcion":"ICTIOSIS FOLICULAR CON ALOPECIA Y FOTOFOBIA"
  },
  {
    "codigo":10566007,
    "descripcion":"OTOESCLEROSIS QUE COMPROMETE A LA VENTANA REDONDA"
  },
  {
    "codigo":762395000,
    "descripcion":"LESIÓN TRAUMÁTICA DE MANO CAUSADA POR BAJA TEMPERATURA POSTERIOR A INMERSIÓN EN AGUA"
  },
  {
    "codigo":1255750004,
    "descripcion":"LINFOMA DE BURKITT DE GANGLIOS LINFÁTICOS DE CUELLO"
  },
  {
    "codigo":238107002,
    "descripcion":"DEFICIENCIA DE MACRONUTRIENTES"
  },
  {
    "codigo":76102007,
    "descripcion":"HOMOSEXUALIDAD MASCULINA"
  },
  {
    "codigo":860699005,
    "descripcion":"TROMBOSIS DE VENA PROFUNDA DE EXTREMIDAD INFERIOR DEBIDA A USO DE DROGAS INTRAVENOSAS"
  },
  {
    "codigo":74267005,
    "descripcion":"ENCEFALITIS TÓXICA CAUSADA POR TETRACLORURO DE CARBONO"
  },
  {
    "codigo":11837481000119100,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE PIERNA DERECHA CON INFECCIÓN"
  },
  {
    "codigo":365509003,
    "descripcion":"HALLAZGO RELACIONADO CON PROPIEDAD Y POSESIÓN DE VIVIENDA"
  },
  {
    "codigo":234437005,
    "descripcion":"LINFOHISTIOCITOSIS HEMOFAGOCÍTICA"
  },
  {
    "codigo":201669005,
    "descripcion":"ARTRITIS GOTOSA DE TOBILLO Y PIE"
  },
  {
    "codigo":16041871000119108,
    "descripcion":"ARTRITIS IDIOPÁTICA JUVENIL DE AMBOS TOBILLOS"
  },
  {
    "codigo":363674000,
    "descripcion":"ASPECTO GENERAL DEL PACIENTE"
  },
  {
    "codigo":299973008,
    "descripcion":"PUNTURA DE PLANTA"
  },
  {
    "codigo":398277007,
    "descripcion":"BLOQUEO DE LA CONDUCCIÓN NERVIOSA SENSORIAL - COMPLETO"
  },
  {
    "codigo":298138003,
    "descripcion":"RONCHA MICROPAPULAR"
  },
  {
    "codigo":16097321000119103,
    "descripcion":"ARTROFIBROSIS DE ARTICULACIÓN DE AMBAS REGIONES DE TOBILLO"
  },
  {
    "codigo":296303002,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE CANABIS"
  },
  {
    "codigo":1017199005,
    "descripcion":"CON MAYOR RIESGO DE SUFRIR ABUSO ECONÓMICO"
  },
  {
    "codigo":294468006,
    "descripcion":"ALERGIA A NEOMICINA"
  },
  {
    "codigo":720452006,
    "descripcion":"DEPRESIÓN MAYOR MODERADAMENTE SEVERA RECURRENTE"
  },
  {
    "codigo":425540008,
    "descripcion":"DESCOMPENSACIÓN CORNEAL"
  },
  {
    "codigo":292633001,
    "descripcion":"REACCIÓN ADVERSA A CREMA CON DITRANOL"
  },
  {
    "codigo":126958000,
    "descripcion":"NEOPLASIA DE VENTRÍCULO ENCEFÁLICO"
  },
  {
    "codigo":94190000,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE VASO SANGUÍNEO DE GLÚTEO"
  },
  {
    "codigo":30489009,
    "descripcion":"FRACTURA INTRACAPSULAR EXPUESTA DE FÉMUR"
  },
  {
    "codigo":92355000,
    "descripcion":"NEOPLASIA BENIGNA DE PIEL DE CODO"
  },
  {
    "codigo":1306606009,
    "descripcion":"NEUMONITIS POR ASPIRACIÓN POSTERIOR A PROCEDIMIENTO QUIRÚRGICO"
  },
  {
    "codigo":125123008,
    "descripcion":"HALLAZGO DE PESO DE ÓRGANO"
  },
  {
    "codigo":90520006,
    "descripcion":"ESTENOSIS DE ARTERIA VERTEBRAL"
  },
  {
    "codigo":449133000,
    "descripcion":"AUSENCIA DE CÚSPIDE DE VÁLVULA PULMONAR"
  },
  {
    "codigo":23149001,
    "descripcion":"CREPITACIÓN ÓSEA"
  },
  {
    "codigo":414530001,
    "descripcion":"ENFERMEDAD INFECCIOSA INTESTINAL CAUSADA POR BACTERIAS GRAMNEGATIVAS"
  },
  {
    "codigo":840514002,
    "descripcion":"NEVO COMPUESTO DE PÁRPADO"
  },
  {
    "codigo":250690004,
    "descripcion":"ALFA-1-ANTITRIPSINA, FENOTIPO PIMS"
  },
  {
    "codigo":86850004,
    "descripcion":"OTITIS MEDIA CRÓNICA SEROSANGUINOLENTA"
  },
  {
    "codigo":283458008,
    "descripcion":"HERIDA PUNZANTE EN LA GARGANTA"
  },
  {
    "codigo":54082009,
    "descripcion":"CRECIMIENTO BACTERIANO EN CULTIVO CELULAR"
  },
  {
    "codigo":248855003,
    "descripcion":"HIMEN MELLADO"
  },
  {
    "codigo":707607008,
    "descripcion":"SÍNDROME DE AMELOGÉNESIS IMPERFECTA E HIPERPLASIA GINGIVAL"
  },
  {
    "codigo":281623008,
    "descripcion":"TUBERCULOSIS GENITAL"
  },
  {
    "codigo":1197292002,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS METASTÁSICO DE GANGLIO LINFÁTICO PÉLVICO"
  },
  {
    "codigo":738540006,
    "descripcion":"METABOLIZADOR INTERMEDIO DE TIOPURINA S-METILTRANSFERASA"
  },
  {
    "codigo":771308008,
    "descripcion":"SÍNDROME DE DEFICIENCIA DE HORMONA HIPOFISARIA COMBINADA NO ADQUIRIDA, PÉRDIDA AUDITIVA NEUROSENSORIAL Y ANOMALÍAS DE LA COLUMNA VERTEBRAL"
  },
  {
    "codigo":703937002,
    "descripcion":"RINITIS ALÉRGICA CAUSADA POR DERMATOPHAGOIDES PTERONYSSINUS"
  },
  {
    "codigo":81345003,
    "descripcion":"ESTENOSIS DEL CANALÍCULO LAGRIMAL"
  },
  {
    "codigo":441793007,
    "descripcion":"NIVEL DE HEMOGLOBINA FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":658071000005103,
    "descripcion":"PLACENTA UBICADA EN PARED POSTERIOR DERECHA DE ÚTERO"
  },
  {
    "codigo":15809008,
    "descripcion":"ABORTO ESPONTÁNEO CON PERFORACIÓN DE ÚTERO"
  },
  {
    "codigo":46742003,
    "descripcion":"ÚLCERA DE LA PIEL"
  },
  {
    "codigo":79510004,
    "descripcion":"DESPLAZAMIENTO CONGÉNITO DE ESÓFAGO"
  },
  {
    "codigo":11839991000119103,
    "descripcion":"HEMATOMA TRAUMÁTICO DE MAMA IZQUIERDA"
  },
  {
    "codigo":308886006,
    "descripcion":"HALLAZGO DE ALTA PRODUCCIÓN DE DRENAJE TRANSGÁSTRICO"
  },
  {
    "codigo":16755191000119103,
    "descripcion":"SANGRADO UTERINO ANORMAL DEBIDO A PÓLIPO ENDOMETRIAL"
  },
  {
    "codigo":210582006,
    "descripcion":"SECCIÓN TOTAL DEL TENDÓN DEL FLEXOR SUPERFICIAL DE LOS DEDOS DE LA MANO"
  },
  {
    "codigo":77675002,
    "descripcion":"ANOREXIA NERVIOSA, TIPO RESTRICTIVO"
  },
  {
    "codigo":700267004,
    "descripcion":"LAGOFTALMOS CICATRIZAL DE PÁRPADO SUPERIOR"
  },
  {
    "codigo":307051006,
    "descripcion":"INSERCIÓN DE OBJETOS EN HERIDA"
  },
  {
    "codigo":30011000175104,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN DE DORSO DE PIE IZQUIERDO"
  },
  {
    "codigo":18630001000004100,
    "descripcion":"INFECCIÓN ASOCIADA CON PRÓTESIS ARTICULAR DE CADERA DERECHA"
  },
  {
    "codigo":18310001000004100,
    "descripcion":"FRACTURA DE EXTREMO DISTAL DE RADIO DERECHO"
  },
  {
    "codigo":403520007,
    "descripcion":"DISTROFIA UNGUEAL ASOCIADA CON ESCLERODERMIA"
  },
  {
    "codigo":43072008,
    "descripcion":"INADAPTACIÓN AL AMBIENTE FAMILIAR"
  },
  {
    "codigo":1351957003,
    "descripcion":"NEOPLASIA MALIGNA DE CIEGO Y\/O COLON Y\/O RECTO DETECTADA MEDIANTE PRUEBA DE CRIBADO PARA ARN EN HECES"
  },
  {
    "codigo":344721000119101,
    "descripcion":"PTOSIS PARALÍTICA DE AMBOS PÁRPADOS SUPERIORES"
  },
  {
    "codigo":236010002,
    "descripcion":"CUERPO EXTRAÑO PERITONEAL"
  },
  {
    "codigo":301546002,
    "descripcion":"LLEGA AL INODORO"
  },
  {
    "codigo":432618005,
    "descripcion":"HERIDA PENETRANTE DE MIEMBRO INFERIOR"
  },
  {
    "codigo":39402007,
    "descripcion":"SÍNDROME DE CONGESTIÓN PÉLVICA"
  },
  {
    "codigo":168639000,
    "descripcion":"RADIOGRAFÍA SIMPLE DE MANO NORMAL"
  },
  {
    "codigo":398015002,
    "descripcion":"EQUIPO AUSENTE"
  },
  {
    "codigo":37567005,
    "descripcion":"ACENESTESIA"
  },
  {
    "codigo":723860000,
    "descripcion":"ARRITMIA DEBIDA A INFARTO AGUDO DE MIOCARDIO Y POSTERIOR A ÉL"
  },
  {
    "codigo":15745681000119105,
    "descripcion":"INESTABILIDAD DE ARTICULACIÓN DE AMBAS REGIONES DE MUÑECA"
  },
  {
    "codigo":365247009,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA OBTENER ALIMENTOS"
  },
  {
    "codigo":363412000,
    "descripcion":"NEOPLASIA MALIGNA DE COLON ASCENDENTE"
  },
  {
    "codigo":232340005,
    "descripcion":"TRASTORNO DE LA CAVIDAD NASAL"
  },
  {
    "codigo":428948008,
    "descripcion":"DISCAPACIDAD BILATERAL DE MIEMBROS INFERIORES"
  },
  {
    "codigo":1082001000119107,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS INTRAEPIDÉRMICO DE MIEMBRO INFERIOR IZQUIERDO"
  },
  {
    "codigo":296041003,
    "descripcion":"SOBREDOSIS DE BUTABARBITAL"
  },
  {
    "codigo":427113002,
    "descripcion":"ESOTROPÍA POR EXCESO DE CONVERGENCIA"
  },
  {
    "codigo":263273002,
    "descripcion":"FRACTURA DE CORONA Y RAÍZ DENTAL COMPLICADA"
  },
  {
    "codigo":15663761000119108,
    "descripcion":"HEMARTROSIS DE AMBAS CADERAS"
  },
  {
    "codigo":294206005,
    "descripcion":"ALERGIA A ÁCIDO GAMOLÉNICO"
  },
  {
    "codigo":359742006,
    "descripcion":"HIPOPARATIROIDISMO TRANSITORIO"
  },
  {
    "codigo":785726009,
    "descripcion":"SÍNDROME DE HIPEREXPLEXIA-EPILEPSIA"
  },
  {
    "codigo":195902009,
    "descripcion":"NEUMONÍA POR CARBUNCO"
  },
  {
    "codigo":292371003,
    "descripcion":"REACCIÓN ADVERSA A FÁRMACO NEUROLÉPTICO"
  },
  {
    "codigo":1144339002,
    "descripcion":"HIPOPLASIA CONGÉNITA DE PORCIÓN BASAL DE PROTUBERANCIA"
  },
  {
    "codigo":30227006,
    "descripcion":"ASPIRACIÓN DEL CONTENIDO GÁSTRICO"
  },
  {
    "codigo":44151000087103,
    "descripcion":"CORTE EN PIE DERECHO"
  },
  {
    "codigo":41591000087102,
    "descripcion":"HERIDA PUNZANTE DE MAMA IZQUIERDA"
  },
  {
    "codigo":126696001,
    "descripcion":"NEOPLASIA DE LA SUBGLOTIS"
  },
  {
    "codigo":39031000087108,
    "descripcion":"HERIDA ABIERTA DE EXTREMIDAD SUPERIOR DERECHA"
  },
  {
    "codigo":46711000087109,
    "descripcion":"DESGARRO COMPLETO DE LIGAMENTO SEMILUNOPIRAMIDAL IZQUIERDO"
  },
  {
    "codigo":93928006,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL LÓBULO OCCIPITAL"
  },
  {
    "codigo":421608007,
    "descripcion":"HALLAZGO DEL PULSO RECONOCIDO POR PALPACIÓN"
  },
  {
    "codigo":388840007,
    "descripcion":"QUERATOGLOBO"
  },
  {
    "codigo":92093000,
    "descripcion":"NEOPLASIA BENIGNA DE SENO ETMOIDAL"
  },
  {
    "codigo":290536006,
    "descripcion":"INTOXICACIÓN POR PRILOCAÍNA"
  },
  {
    "codigo":288701006,
    "descripcion":"CAPAZ DE COMUNICARSE EN DIFERENTES LUGARES"
  },
  {
    "codigo":254098000,
    "descripcion":"LUXACIONES MÚLTIPLES CON DISPLASIA"
  },
  {
    "codigo":286866000,
    "descripcion":"BOCA CERRADA"
  },
  {
    "codigo":712850003,
    "descripcion":"TRASTORNO PSICÓTICO POLIMÓRFICO AGUDO CON SÍNTOMAS DE ESQUIZOFRENIA"
  },
  {
    "codigo":188562004,
    "descripcion":"ENFERMEDAD DE HODGKIN, PREDOMINIO LINFOCÍTICO-HISTIOCÍTICO DE GANGLIOS LINFÁTICOS DE MÚLTIPLES LOCALIZACIONES"
  },
  {
    "codigo":417938007,
    "descripcion":"EXPRESA VERBALMENTE EL PLAN DE ACTIVIDAD PRESCRITO"
  },
  {
    "codigo":1204370008,
    "descripcion":"MASA EN DEDO GORDO"
  },
  {
    "codigo":448871001,
    "descripcion":"ESTENOSIS SUBAÓRTICA DEBIDA A DEFECTO RESTRICTIVO DE TABIQUE INTERVENTRICULAR EN CORAZÓN FUNCIONALMENTE UNIVENTRICULAR"
  },
  {
    "codigo":285031007,
    "descripcion":"NO MANEJA UN ARTEFACTO MIENTRAS SE DESVISTE"
  },
  {
    "codigo":1004092000,
    "descripcion":"COMPRESIÓN DE NERVIO CUBITAL DERECHO A LA ALTURA DEL CODO"
  },
  {
    "codigo":283196000,
    "descripcion":"ANZUELO EN LA AXILA"
  },
  {
    "codigo":217660005,
    "descripcion":"ENVENENAMIENTO POR VENENO DE SERPIENTE DE MAR"
  },
  {
    "codigo":248593001,
    "descripcion":"TOSE AL TRAGAR"
  },
  {
    "codigo":1264401001,
    "descripcion":"MIOPATÍA DEBIDA A ESCLEROSIS SISTÉMICA"
  },
  {
    "codigo":707345001,
    "descripcion":"CARCINOMA PRIMARIO DE SENO PARANASAL"
  },
  {
    "codigo":838417006,
    "descripcion":"AGUDEZA VISUAL CON AGUJERO ESTENOPEICO DE OJO IZQUIERDO 6\/12"
  },
  {
    "codigo":84753008,
    "descripcion":"NEUMONÍA EN LA MICOSIS SISTÉMICA"
  },
  {
    "codigo":1231633009,
    "descripcion":"IMPLANTE SUBRETINAL IN SITU"
  },
  {
    "codigo":445201008,
    "descripcion":"ANTÍGENO CARCINOEMBRIONARIO POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":246758003,
    "descripcion":"NISTAGMO MIXTO"
  },
  {
    "codigo":17382005,
    "descripcion":"INSUFICIENCIA CERVICOUTERINA"
  },
  {
    "codigo":310459006,
    "descripcion":"EL PACIENTE SUELE BUSCAR VARIAS OPINIONES MÉDICAS"
  },
  {
    "codigo":13712000,
    "descripcion":"ESTADO PRENATAL DEL FETO, 3ER TRIMESTRE"
  },
  {
    "codigo":15547009,
    "descripcion":"PRODUCCIÓN DE GRANULOCITOS DISMINUIDA"
  },
  {
    "codigo":769211009,
    "descripcion":"SIN FUERZA PARA TOSER"
  },
  {
    "codigo":1258896001,
    "descripcion":"EMBOLIA PULMONAR DE LÍQUIDO AMNIÓTICO"
  },
  {
    "codigo":79248008,
    "descripcion":"GRUPO SANGUÍNEO A>1<B"
  },
  {
    "codigo":208485001,
    "descripcion":"FRACTURA EXPUESTA DE FALANGE MEDIA DE DEDO DE LA MANO, DIÁFISIS"
  },
  {
    "codigo":52503801000119101,
    "descripcion":"FRACTURA ABIERTA DE PARED SUPERIOR DE ÓRBITA IZQUIERDA"
  },
  {
    "codigo":437390431000119108,
    "descripcion":"TELANGIECTASIA DE MÁCULA LÚTEA DE AMBOS OJOS"
  },
  {
    "codigo":1156922000,
    "descripcion":"NO INMUNE A POLIOVIRUS"
  },
  {
    "codigo":110181009,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO DE LA REGIÓN PERIORAL"
  },
  {
    "codigo":77413008,
    "descripcion":"ESFEROCITOSIS HEREDITARIA SEVERA POR DEFICIENCIA DE ESPECTRINA"
  },
  {
    "codigo":42810003,
    "descripcion":"DEPRESIÓN MAYOR EN REMISIÓN"
  },
  {
    "codigo":403258005,
    "descripcion":"HIPERMELANOSIS POR TUMOR MALIGNO SECRETOR DE ACTH\/MSH"
  },
  {
    "codigo":370490006,
    "descripcion":"COLANGIOHEPATITIS AGUDA"
  },
  {
    "codigo":8207002,
    "descripcion":"CUERPO EXTRAÑO NO MAGNÉTICO RETENIDO EN SITIOS MÚLTIPLES"
  },
  {
    "codigo":1351695006,
    "descripcion":"POLISEROSITIS CRÓNICA"
  },
  {
    "codigo":237583008,
    "descripcion":"SECRECIÓN ANORMAL DE COLECISTOQUININA-PANCREOZIMINA"
  },
  {
    "codigo":1251556002,
    "descripcion":"CREENCIA QUE DIFICULTA CAMBIO DE CONDUCTA ALIMENTARIA Y\/O NUTRICIONAL"
  },
  {
    "codigo":71908006,
    "descripcion":"FIBRILACIÓN VENTRICULAR"
  },
  {
    "codigo":235748008,
    "descripcion":"COLITIS AMÉBICA FULMINANTE"
  },
  {
    "codigo":301284009,
    "descripcion":"INTENSIDAD NORMAL DE LA RESPIRACIÓN"
  },
  {
    "codigo":725433003,
    "descripcion":"ATAXIA CEREBELOSA AUTOSÓMICA RECESIVA TIPO BEAUCE"
  },
  {
    "codigo":102841004,
    "descripcion":"CILINDRO URINARIO, GRASO"
  },
  {
    "codigo":70073005,
    "descripcion":"CRISIS APNEICA PERINATAL"
  },
  {
    "codigo":299449006,
    "descripcion":"CREPITACIÓN PALPABLE EN EL TOBILLO"
  },
  {
    "codigo":233913007,
    "descripcion":"SÍNDROME DE DISFUNCIÓN SINUSAL FAMILIAR"
  },
  {
    "codigo":232078000,
    "descripcion":"CUERPO EXTRAÑO INTRAOCULAR EN EL CUERPO VÍTREO"
  },
  {
    "codigo":364985008,
    "descripcion":"PATRÓN DE CONDUCCIÓN NERVIOSA SENSITIVA - HALLAZGO"
  },
  {
    "codigo":11789561000119109,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO DE DEDO DE MANO DERECHA"
  },
  {
    "codigo":263011002,
    "descripcion":"LUXACIÓN DE ARTICULACIÓN ESTERNOCOSTAL"
  },
  {
    "codigo":721763002,
    "descripcion":"INFECCIÓN CAUSADA POR NOROVIRUS"
  },
  {
    "codigo":66403007,
    "descripcion":"ANILLO VASCULAR DE LA AORTA"
  },
  {
    "codigo":295779009,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE TAMOXIFENO"
  },
  {
    "codigo":2511000124101,
    "descripcion":"INCISIVO CENTRAL INFERIOR DERECHO PERMANENTE SUPERNUMERARIO"
  },
  {
    "codigo":460751000124103,
    "descripcion":"TIENE ACCESO A OPIOIDE"
  },
  {
    "codigo":447951000124108,
    "descripcion":"PACIENTE INSATISFECHO CON EL RÉGIMEN NUTRICIONAL"
  },
  {
    "codigo":445391000124109,
    "descripcion":"CON MAYOR RIESGO DE INTERACCIÓN FARMACOLÓGICA CON ALIMENTO"
  },
  {
    "codigo":783629005,
    "descripcion":"ANEURISMA CONGÉNITO DE ARTERIA CEREBRAL"
  },
  {
    "codigo":95501007,
    "descripcion":"MALFORMACIÓN ARTERIOVENOSA RETINIANA"
  },
  {
    "codigo":292109008,
    "descripcion":"REACCIÓN ADVERSA A LA NIZATIDINA"
  },
  {
    "codigo":161037006,
    "descripcion":"NO NECESITA SERVICIO DOMICILIARIO"
  },
  {
    "codigo":716258002,
    "descripcion":"CANDIDA FIRMETARIA O CANDIDA INCONSPICUA"
  },
  {
    "codigo":290274002,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ÁCIDO MEFENÁMICO"
  },
  {
    "codigo":421346005,
    "descripcion":"EDEMA CON FÓVEA 3+"
  },
  {
    "codigo":191970005,
    "descripcion":"VÓMITO CÍCLICO PSICÓGENO"
  },
  {
    "codigo":880098006,
    "descripcion":"DERMATITIS POR INFESTACIÓN DE DERMANYSSUS GALLINAE"
  },
  {
    "codigo":1142242007,
    "descripcion":"FÍSTULA URETROVAGINAL CIRCUNFERENCIAL"
  },
  {
    "codigo":124599002,
    "descripcion":"DEFICIENCIA DE TIROSINA DESCARBOXILASA"
  },
  {
    "codigo":419511003,
    "descripcion":"PROPENSIÓN A PRESENTAR REACCIONES MEDICAMENTOSAS ADVERSAS"
  },
  {
    "codigo":714423004,
    "descripcion":"SE ABSTIENE DE BEBER"
  },
  {
    "codigo":288439002,
    "descripcion":"NO REALIZA ACTIVIDADES DE DIBUJO"
  },
  {
    "codigo":59063002,
    "descripcion":"INFARTO AGUDO DE MIOCARDIO DE PARED APICOLATERAL"
  },
  {
    "codigo":448609001,
    "descripcion":"LINFOMA NO HODGKIN DIFUSO DE OVARIO"
  },
  {
    "codigo":253836009,
    "descripcion":"HIPOPLASIA DE VAGINA"
  },
  {
    "codigo":252001004,
    "descripcion":"INCOMPETENCIA DE CUELLO DE VEJIGA URINARIA EN REPOSO"
  },
  {
    "codigo":22625005,
    "descripcion":"HEMATOMEDIASTINO"
  },
  {
    "codigo":20790006,
    "descripcion":"INFECCIÓN HEPÁTICA POR ECHINOCOCCUS GRANULOSUS"
  },
  {
    "codigo":282934006,
    "descripcion":"DIFICULTAD PARA MOVERSE DE POSICIÓN ACOSTADA A SENTADA"
  },
  {
    "codigo":248331002,
    "descripcion":"HA CRECIDO EN ALTURA"
  },
  {
    "codigo":1264139003,
    "descripcion":"ANOXIA CEREBRAL POSTERIOR A EMBARAZO ECTÓPICO"
  },
  {
    "codigo":51723007,
    "descripcion":"SÍNCOPE DEL SENO CAROTÍDEO"
  },
  {
    "codigo":770784003,
    "descripcion":"DISFUNCIÓN DEL NÓDULO SINUSAL Y SORDERA"
  },
  {
    "codigo":836320005,
    "descripcion":"AGUDEZA VISUAL CORREGIDA DE OJO DERECHO 6\/3"
  },
  {
    "codigo":211893005,
    "descripcion":"QUEMADURA SUPERFICIAL DE UN SOLO DEDO DE LA MANO"
  },
  {
    "codigo":16051911000119108,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE TENDÓN DE MÚSCULO PLANTAR DE AMBAS EXTREMIDADES INFERIORES"
  },
  {
    "codigo":15285008,
    "descripcion":"DEFICIENCIA DE ADENILOSUCCINATO LIASA"
  },
  {
    "codigo":46218001,
    "descripcion":"TONICIDAD GÁSTRICA DISMINUIDA"
  },
  {
    "codigo":372063002,
    "descripcion":"NEOPLASIA MALIGNA DE SISTEMA NERVIOSO"
  },
  {
    "codigo":109919002,
    "descripcion":"NEOPLASIA SUPERPUESTA MALIGNA DE LOS NERVIOS PERIFÉRICOS Y DEL SISTEMA NERVIOSO AUTÓNOMO"
  },
  {
    "codigo":75316000,
    "descripcion":"HIPOPARATIROIDISMO AUTOINMUNITARIO"
  },
  {
    "codigo":697908003,
    "descripcion":"HIPERTENSIÓN DE ARTERIA PULMONAR ASOCIADA CON ANEMIA HEMOLÍTICA CRÓNICA"
  },
  {
    "codigo":9780006,
    "descripcion":"PRESENTACIÓN DE BRAZO PROLAPSADO DEL FETO"
  },
  {
    "codigo":402996006,
    "descripcion":"CANDIDIASIS ORAL SEUDOMEMBRANOSA CRÓNICA"
  },
  {
    "codigo":73481001,
    "descripcion":"ÚLCERA GÁSTRICA SIN HEMORRAGIA Y SIN PERFORACIÓN"
  },
  {
    "codigo":302857002,
    "descripcion":"ANGIOFIBROMA"
  },
  {
    "codigo":204553006,
    "descripcion":"ESTENOSIS SUPRAGLÓTICA CONGÉNITA"
  },
  {
    "codigo":401161007,
    "descripcion":"INICIO RETRASADO DEL SUEÑO"
  },
  {
    "codigo":237321009,
    "descripcion":"PARTO DEMORADO DE TRILLIZOS"
  },
  {
    "codigo":301022003,
    "descripcion":"ÚLCERA DEL TALÓN"
  },
  {
    "codigo":169950007,
    "descripcion":"UNO DE LOS TRILLIZOS"
  },
  {
    "codigo":4275001,
    "descripcion":"ESPASMO DE LA MIRADA CONJUGADA"
  },
  {
    "codigo":399326009,
    "descripcion":"TUMOR MALIGNO DE VEJIGA URINARIA"
  },
  {
    "codigo":15673361000119100,
    "descripcion":"NÓDULO REUMATOIDE DE TEJIDO SUBCUTÁNEO DE AMBOS CODOS"
  },
  {
    "codigo":1041000119100,
    "descripcion":"PROBLEMA DE RELACIÓN CON LA PAREJA"
  },
  {
    "codigo":11313681000119102,
    "descripcion":"FRACTURA EXPUESTA DE HUESO TEMPORAL"
  },
  {
    "codigo":295441000119103,
    "descripcion":"TENDINITIS CALCIFICANTE DE PIERNA"
  },
  {
    "codigo":364723008,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA CAMINAR APOYANDO PRIMERO EL TALÓN Y LUEGO LOS DEDOS"
  },
  {
    "codigo":321041000119105,
    "descripcion":"ENTESOPATÍA ESPINAL DE REGIÓN SACROCOCCÍGEA"
  },
  {
    "codigo":303121000119106,
    "descripcion":"BURSITIS DE MANO DERECHA"
  },
  {
    "codigo":126481000119106,
    "descripcion":"EXTENDIDO DE PAPANICOLAOU VAGINAL INSATISFACTORIO PARA LA EVALUACIÓN"
  },
  {
    "codigo":788872004,
    "descripcion":"ENFERMEDAD ATÍPICA CAUSADA POR VIRUS MARBURG"
  },
  {
    "codigo":1076241000119109,
    "descripcion":"BURSITIS DE RODILLA IZQUIERDA"
  },
  {
    "codigo":290321000119109,
    "descripcion":"MONOPLEJÍA DE MIEMBRO INFERIOR IZQUIERDO NO DOMINANTE"
  },
  {
    "codigo":1091601000119107,
    "descripcion":"FÍSTULA DE LA ESTRUCTURA DEL LABERINTO DERECHO"
  },
  {
    "codigo":15678481000119108,
    "descripcion":"ENDOFTALMITIS CRÓNICA DE OJO DERECHO"
  },
  {
    "codigo":233651009,
    "descripcion":"ENDOMETRIOSIS PLEURAL"
  },
  {
    "codigo":723336008,
    "descripcion":"SÍNDROME DE COMPLEJO DE FALLOT CON DISCAPACIDAD INTELECTUAL Y RETRASO DEL CRECIMIENTO"
  },
  {
    "codigo":77841000119108,
    "descripcion":"RADICULOPATÍA DORSOLUMBAR"
  },
  {
    "codigo":11999761000119108,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO DE REGIÓN DORSAL INFERIOR"
  },
  {
    "codigo":721501000,
    "descripcion":"LESIÓN COMPLETA DE MÉDULA ESPINAL AL NIVEL DEL SEGUNDO SEGMENTO LUMBAR"
  },
  {
    "codigo":262749000,
    "descripcion":"HERIDA ABIERTA DE PÁRPADO"
  },
  {
    "codigo":231816006,
    "descripcion":"LACERACIÓN PALPEBRAL"
  },
  {
    "codigo":64306000,
    "descripcion":"FRACTURA DE APÓFISIS ESPINOSA VERTEBRAL"
  },
  {
    "codigo":129842001,
    "descripcion":"HALLAZGO EN LA AUTOPERCEPCIÓN DE LA SALUD"
  },
  {
    "codigo":391986001,
    "descripcion":"TÓRAX EN EMBUDO ADQUIRIDO"
  },
  {
    "codigo":15972501000119101,
    "descripcion":"TROMBOSIS DE ARTERIA ILÍACA DERECHA"
  },
  {
    "codigo":197213004,
    "descripcion":"PROLAPSO RECTAL COMPLETO"
  },
  {
    "codigo":293682005,
    "descripcion":"ALERGIA A SULFATO DE MAGNESIO"
  },
  {
    "codigo":679931000119109,
    "descripcion":"CATARATA CORTICAL CONGÉNITA DE OJO DERECHO"
  },
  {
    "codigo":719666002,
    "descripcion":"SÍNDROME DE DELECIÓN TERMINAL 6Q"
  },
  {
    "codigo":228146008,
    "descripcion":"DETERIORO DEL CUIDADO PERSONAL"
  },
  {
    "codigo":291847002,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR OXIMETOLONA"
  },
  {
    "codigo":95239003,
    "descripcion":"RINITIS MEDICAMENTOSA"
  },
  {
    "codigo":1078279007,
    "descripcion":"PERFORACIÓN DE PARED DE CONDUCTO RADICULAR DEBIDA A PROCEDIMIENTO ENDODÓNCICO"
  },
  {
    "codigo":160775007,
    "descripcion":"AYUDA DOMICILIARIA SOLICITADA"
  },
  {
    "codigo":816135009,
    "descripcion":"TRASTORNO CAUSADO POR VAPEO"
  },
  {
    "codigo":27868004,
    "descripcion":"ESTEATORREA CRÓNICA"
  },
  {
    "codigo":93404004,
    "descripcion":"ENGROSAMIENTO CONGÉNITO DE ISQUION"
  },
  {
    "codigo":16027951000119100,
    "descripcion":"EXOSTOSIS DE TIBIA DERECHA"
  },
  {
    "codigo":191708009,
    "descripcion":"ANSIEDAD CRÓNICA"
  },
  {
    "codigo":124337003,
    "descripcion":"DEFICIENCIA DE GUANIDINOACETATO CINASA"
  },
  {
    "codigo":417414000,
    "descripcion":"SACRO ANTERIOR"
  },
  {
    "codigo":26033009,
    "descripcion":"MICOTOXICOSIS"
  },
  {
    "codigo":188038003,
    "descripcion":"MELANOMA MALIGNO DEL MENTÓN"
  },
  {
    "codigo":286342004,
    "descripcion":"DIFICULTAD PARA EMITIR UN VOLUMEN DE VOZ ADECUADO"
  },
  {
    "codigo":11031000202102,
    "descripcion":"INSTALACIONES DE TRABAJO ADECUADAS"
  },
  {
    "codigo":1269382009,
    "descripcion":"SÍNDROME DE CORDÓN POSTERIOR DE MÉDULA ESPINAL DORSAL DEBIDO A LUXACIÓN EXPUESTA DE ARTICULACIÓN DE COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":186203002,
    "descripcion":"TUBERCULOSIS PULMONAR, CON RESULTADOS BACTERIOLÓGICOS Y HISTOLÓGICOS NEGATIVOS"
  },
  {
    "codigo":253574009,
    "descripcion":"INFUNDÍBULO SUBAÓRTICO"
  },
  {
    "codigo":1234779007,
    "descripcion":"TRASTORNO DEL ESTADO DE ÁNIMO INDUCIDO POR ALCOHOL"
  },
  {
    "codigo":446512000,
    "descripcion":"FÍSTULA CUTÁNEA DE CUELLO"
  },
  {
    "codigo":413744002,
    "descripcion":"SEGUIMIENTO DE CRIBADO PARA CÁNCER"
  },
  {
    "codigo":282672004,
    "descripcion":"INCAPAZ DE ATRAPAR"
  },
  {
    "codigo":1003568005,
    "descripcion":"AGENESIA DE DIAFRAGMA"
  },
  {
    "codigo":11823561000119100,
    "descripcion":"ABRASIÓN DE PIEL DE REGIÓN DE HOMBRO DERECHO"
  },
  {
    "codigo":315440006,
    "descripcion":"NACIDO EN HONDURAS"
  },
  {
    "codigo":20528005,
    "descripcion":"PROLAPSO RECTAL COMPLETO SIN DESPLAZAMIENTO DE ESFÍNTER ANAL"
  },
  {
    "codigo":84229001,
    "descripcion":"FATIGA"
  },
  {
    "codigo":248069002,
    "descripcion":"MORDERSE LA MANO"
  },
  {
    "codigo":410074002,
    "descripcion":"ATROFIA DE GRASA ORBITARIA"
  },
  {
    "codigo":279002006,
    "descripcion":"LIQUENIFICACIÓN DE LA PIEL"
  },
  {
    "codigo":735919002,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA NEUROEPITELIAL DE IRIS"
  },
  {
    "codigo":277167007,
    "descripcion":"DOLOR A LA PALPACIÓN EN EL CONDUCTO AUDITIVO"
  },
  {
    "codigo":275332000,
    "descripcion":"LUXACIÓN DEL EXTREMO DISTAL DEL PERONÉ"
  },
  {
    "codigo":682441000119105,
    "descripcion":"ASTROCITOMA PRIMARIO DE VENTRÍCULO CEREBRAL"
  },
  {
    "codigo":111492006,
    "descripcion":"TRASTORNO DE CONVERSIÓN, EPISODIO ÚNICO"
  },
  {
    "codigo":109657000,
    "descripcion":"DISCREPANCIA ENTRE EL TAMAÑO DENTAL Y LA EXTENSIÓN DEL ARCO DENTAL"
  },
  {
    "codigo":732249002,
    "descripcion":"DISPLASIA ÓSEA LETAL TIPO HOLMGREN"
  },
  {
    "codigo":76889003,
    "descripcion":"INTENTO FALLIDO DE ABORTO CON ANOXIA CEREBRAL"
  },
  {
    "codigo":207961002,
    "descripcion":"FRACTURA NO EXPUESTA DE VÉRTEBRA LUMBAR, APÓFISIS ESPINOSA"
  },
  {
    "codigo":402734000,
    "descripcion":"DISTROFIA UNGUEAL POR TIC HABITUAL"
  },
  {
    "codigo":240729009,
    "descripcion":"COCCIDIOMICOSIS HEPÁTICA"
  },
  {
    "codigo":1156398003,
    "descripcion":"FRACTURA DE CUERNO MAYOR DERECHO DE HUESO HIOIDES"
  },
  {
    "codigo":238894004,
    "descripcion":"LIPOHIPERTROFIA DEL SITIO DE APLICACIÓN DE LA INSULINA"
  },
  {
    "codigo":271662005,
    "descripcion":"RUIDOS CARDÍACOS DISMINUIDOS"
  },
  {
    "codigo":328291000119103,
    "descripcion":"INFECCIÓN CAUSADA POR ESCHERICHIA COLI PRODUCTORA DE TOXINA SHIGA"
  },
  {
    "codigo":237059008,
    "descripcion":"TUMOR OVÁRICO DE CÉLULAS GERMINALES"
  },
  {
    "codigo":1285635008,
    "descripcion":"HERIDA DE MAMA POR MORDEDURA"
  },
  {
    "codigo":235224000,
    "descripcion":"ENTERITIS HEMORRÁGICA"
  },
  {
    "codigo":366296005,
    "descripcion":"HALLAZGO RELACIONADO CON EL OLOR DE LA SECRECIÓN VAGINAL"
  },
  {
    "codigo":169688006,
    "descripcion":"AFP - SANGRE ENVIADA"
  },
  {
    "codigo":300760006,
    "descripcion":"DIFICULTAD PARA ENTRETENERSE CON UN PASATIEMPO"
  },
  {
    "codigo":724909005,
    "descripcion":"LESIÓN TRAUMÁTICA DE FASCIA A LA ALTURA DEL BRAZO"
  },
  {
    "codigo":266157006,
    "descripcion":"CANDIDIASIS PERIANAL"
  },
  {
    "codigo":397229005,
    "descripcion":"RECTO COMPROMETIDO POR EXTENSIÓN DIRECTA DE NEOPLASIA MALIGNA"
  },
  {
    "codigo":429997009,
    "descripcion":"SIGNO DE BALLANCE"
  },
  {
    "codigo":1149058004,
    "descripcion":"HIPOPLASIA CONGÉNITA DE ARTERIA CARÓTIDA INTERNA"
  },
  {
    "codigo":460930004,
    "descripcion":"ORIGEN ANÓMALO DE ARTERIA CORONARIA IZQUIERDA EN SENO AÓRTICO DE CORONARIA DERECHA"
  },
  {
    "codigo":723074006,
    "descripcion":"NECROSIS DE PAPILAS RENALES DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":297090007,
    "descripcion":"SOBREDOSIS DE MONONITRATO DE ISOSORBIDA"
  },
  {
    "codigo":229719002,
    "descripcion":"TRASTORNO FONOLÓGICO"
  },
  {
    "codigo":295255008,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE INDOMETACINA"
  },
  {
    "codigo":721239009,
    "descripcion":"INFECCIÓN DE BAZO"
  },
  {
    "codigo":64044004,
    "descripcion":"PERTURBACIÓN DE LA AUTOESTIMA"
  },
  {
    "codigo":1145388005,
    "descripcion":"APLASIA DE MÚSCULO DE MUSLO"
  },
  {
    "codigo":293420007,
    "descripcion":"REACCIÓN ADVERSA AL PROBUCOL"
  },
  {
    "codigo":719404009,
    "descripcion":"CONDRODISPLASIA RECESIVA LETAL"
  },
  {
    "codigo":10679191000119101,
    "descripcion":"TUMEFACCIÓN LOCALIZADA DEL ANTEBRAZO DERECHO"
  },
  {
    "codigo":160513005,
    "descripcion":"ORIGEN EUROPEO"
  },
  {
    "codigo":291585006,
    "descripcion":"INTOXICACIÓN POR CEFUROXIMA"
  },
  {
    "codigo":94977008,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE AMÍGDALAS"
  },
  {
    "codigo":1010646003,
    "descripcion":"ARTERIA UMBILICAL ÚNICA TIPO IV"
  },
  {
    "codigo":93142004,
    "descripcion":"LEUCEMIA EN REMISIÓN"
  },
  {
    "codigo":294451007,
    "descripcion":"ALERGIA A PIPERAZINA"
  },
  {
    "codigo":715734006,
    "descripcion":"AUSENCIA CONGÉNITA DE LA MITAD DE LA GLÁNDULA TIROIDES"
  },
  {
    "codigo":289750007,
    "descripcion":"HALLAZGO RELACIONADO CON LA INVOLUCIÓN UTERINA"
  },
  {
    "codigo":224214006,
    "descripcion":"VIVE EN UN HOSPEDAJE ALQUILADO AMUEBLADO"
  },
  {
    "codigo":1172651002,
    "descripcion":"CARBOXIHEMOGLOBINA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1303723002,
    "descripcion":"FIBROADENOMA DE MAMA DERECHA"
  },
  {
    "codigo":56704004,
    "descripcion":"VÓLVULO GÁSTRICO MIXTO"
  },
  {
    "codigo":11826071000119106,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO ADUCTOR Y TENDÓN DE MUSLO DERECHO"
  },
  {
    "codigo":187776004,
    "descripcion":"NEOPLASIA MALIGNA DE LOS CANALÍCULOS INTRAHEPÁTICOS"
  },
  {
    "codigo":23936007,
    "descripcion":"INFESTACIÓN CAUSADA POR TABANIDAE"
  },
  {
    "codigo":417152008,
    "descripcion":"HISTIOCITOSIS DE CÉLULAS DE LANGERHANS DE PULMÓN"
  },
  {
    "codigo":449920007,
    "descripcion":"CONGELAMIENTO SUPERFICIAL DE BRAZO"
  },
  {
    "codigo":284245002,
    "descripcion":"CAPAZ DE REALIZAR FUNCIONES CON LA MANO"
  },
  {
    "codigo":253312004,
    "descripcion":"AUSENCIA DE PUENTE VENOSO"
  },
  {
    "codigo":286080008,
    "descripcion":"INCAPAZ DE GUARDAR LA ROPA LAVADA"
  },
  {
    "codigo":448085005,
    "descripcion":"VÁLVULA AÓRTICA UNICÚSPIDE ACOMISURAL"
  },
  {
    "codigo":251477008,
    "descripcion":"PUNTA-ONDA ATÍPICA GENERALIZADA"
  },
  {
    "codigo":249642008,
    "descripcion":"ESFÍNTER ANAL DAÑADO"
  },
  {
    "codigo":247807001,
    "descripcion":"CONDUCTA DE EVITACIÓN DE SITUACIONES"
  },
  {
    "codigo":1263615003,
    "descripcion":"TRASTORNO FETAL DEBIDO A DISFUNCIÓN UTERINA HIPERTÓNICA"
  },
  {
    "codigo":1163476002,
    "descripcion":"INFECCIÓN INVASIVA DE OÍDO CAUSADA POR ASPERGILLUS"
  },
  {
    "codigo":49364005,
    "descripcion":"ABSCESO SUBAREOLAR ASOCIADO CON EL PARTO"
  },
  {
    "codigo":82132006,
    "descripcion":"AGUDEZA VISUAL NORMAL"
  },
  {
    "codigo":16596007,
    "descripcion":"ESOTROPÍA"
  },
  {
    "codigo":735657000,
    "descripcion":"LESIÓN TRAUMÁTICA PENETRANTE DE AMBOS GLOBOS OCULARES"
  },
  {
    "codigo":373374006,
    "descripcion":"GRADO HISTOLÓGICO NO DIFERENCIADO - HALLAZGO"
  },
  {
    "codigo":109395000,
    "descripcion":"DISOSTOSIS TEMPOROAUROMANDIBULAR"
  },
  {
    "codigo":1354579001,
    "descripcion":"INFLAMACIÓN AGUDA DE PRÓSTATA CAUSADA POR BACTERIAS"
  },
  {
    "codigo":76627001,
    "descripcion":"MUCORMICOSIS"
  },
  {
    "codigo":699219002,
    "descripcion":"TORUS PALATINO CON FORMA DE HUSO"
  },
  {
    "codigo":12926008,
    "descripcion":"INTOXICACIÓN POR MERCURIALIS ANNUA"
  },
  {
    "codigo":240467006,
    "descripcion":"MOLUSCO CONTAGIOSO GENITAL"
  },
  {
    "codigo":238632001,
    "descripcion":"POROQUERATOSIS GIGANTE"
  },
  {
    "codigo":369704003,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA DEL CORAZÓN, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":402472006,
    "descripcion":"XANTOMA CUTÁNEO"
  },
  {
    "codigo":105725000,
    "descripcion":"HALLAZGOS CRONOBIOLÓGICOS Y\/O BIORRÍTMICOS"
  },
  {
    "codigo":873135461000119101,
    "descripcion":"ENDOMETRIOSIS DE CIEGO"
  },
  {
    "codigo":72957006,
    "descripcion":"GEMELOS BIAMNIÓTICOS - MONOCORIÓNICOS"
  },
  {
    "codigo":304331000119108,
    "descripcion":"GOTA CRÓNICA, SIN TOFO, DEBIDA A DISFUNCIÓN RENAL"
  },
  {
    "codigo":366034001,
    "descripcion":"HALLAZGO RELACIONADO CON LA POSICIÓN DEL CRISTALINO"
  },
  {
    "codigo":234962001,
    "descripcion":"AMELOGÉNESIS IMPERFECTA - HIPOPLÁSICA AUTOSÓMICA DOMINANTE - LEVE"
  },
  {
    "codigo":38354005,
    "descripcion":"HERIDA ABIERTA DE LA CABEZA"
  },
  {
    "codigo":202194005,
    "descripcion":"LUXACIÓN PATOLÓGICA DE ARTICULACIÓN MEDIOTARSIANA"
  },
  {
    "codigo":300498005,
    "descripcion":"EPIDÍDIMO ANFRACTUOSO"
  },
  {
    "codigo":724647003,
    "descripcion":"LINFOMA DIFUSO DE GRANDES CÉLULAS B CONCOMITANTE CON INFLAMACIÓN CRÓNICA CAUSADA POR VIRUS DE EPSTEIN-BARR"
  },
  {
    "codigo":298663004,
    "descripcion":"AMPLITUD DE ROTACIÓN PASIVA HACIA LA IZQUIERDA DE LA COLUMNA LUMBAR NORMAL"
  },
  {
    "codigo":3751005,
    "descripcion":"CONTUSIÓN DE LABIO VAGINAL"
  },
  {
    "codigo":429735007,
    "descripcion":"DEFICIENCIA DE CITRINA"
  },
  {
    "codigo":395132000,
    "descripcion":"DERRAME DE QUILO"
  },
  {
    "codigo":34684001,
    "descripcion":"ÁNTRAX DEL CORDÓN ESPERMÁTICO"
  },
  {
    "codigo":722812008,
    "descripcion":"DISTENSIÓN DE MÚSCULO DE LA MUÑECA"
  },
  {
    "codigo":720977000,
    "descripcion":"TRASTORNO CONGÉNITO DE GLICOSILACIÓN 8 VINCULADO A ASPARAGINA"
  },
  {
    "codigo":294993002,
    "descripcion":"ALERGIA A CLOROTIAZIDA"
  },
  {
    "codigo":87551000119101,
    "descripcion":"ALTERACIÓN VISUAL COMO SECUELA DE ENFERMEDAD CEREBROVASCULAR"
  },
  {
    "codigo":65617004,
    "descripcion":"ENFERMEDAD VENOCLUSIVA DE HÍGADO"
  },
  {
    "codigo":131153004,
    "descripcion":"GRUPO SANGUÍNEO A>M<"
  },
  {
    "codigo":426065008,
    "descripcion":"TRASTORNO DE HIPERSENSIBILIDAD MEDIADO POR INMUNOCOMPLEJOS"
  },
  {
    "codigo":293158004,
    "descripcion":"REACCIÓN ADVERSA A LA CLOBETASONA"
  },
  {
    "codigo":225787000,
    "descripcion":"HALLAZGO RELACIONADO CON EL USO DEL DÍA"
  },
  {
    "codigo":719142009,
    "descripcion":"CAPAZ DE IDENTIFICAR CONDUCTAS RIESGOSAS"
  },
  {
    "codigo":291323000,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR HIOSCINA"
  },
  {
    "codigo":61947007,
    "descripcion":"SORDOMUDEZ"
  },
  {
    "codigo":715472000,
    "descripcion":"DISPLASIA MESOMÉLICAS TIPO CÚBITO Y PERONÉ HIPOPLÁSICOS"
  },
  {
    "codigo":333311000119105,
    "descripcion":"QUISTE DE RETINA DE OJO DERECHO CAUSADO POR PARÁSITO"
  },
  {
    "codigo":125648005,
    "descripcion":"HERIDA ABIERTA DEL BRAZO"
  },
  {
    "codigo":289488005,
    "descripcion":"LESIÓN DE LABIOS VULVARES"
  },
  {
    "codigo":92880009,
    "descripcion":"FUSIÓN ANORMAL CONGÉNITA DE TIBIA"
  },
  {
    "codigo":15980031000119107,
    "descripcion":"ALTERACIÓN DE LA ALINEACIÓN DE LA ARTICULACIÓN TEMPOROMANDIBULAR DERECHA"
  },
  {
    "codigo":123813003,
    "descripcion":"TRASTORNO EN EL METABOLISMO DEL ESTRONCIO"
  },
  {
    "codigo":1172389004,
    "descripcion":"TRASTORNO DEBIDO A DIABETES MELLITUS RELACIONADA CON DESNUTRICIÓN"
  },
  {
    "codigo":876808004,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE AXILA CON INFECCIÓN"
  },
  {
    "codigo":306841000119102,
    "descripcion":"DERRAME ARTICULAR DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":1336229009,
    "descripcion":"TRASTORNO POR USO DE HIPNÓTICO"
  },
  {
    "codigo":23674002,
    "descripcion":"REACCIÓN A TRANSFUSIÓN CAUSADA POR ANTICUERPOS ANTI B"
  },
  {
    "codigo":15707801000119103,
    "descripcion":"CATARATA CALCIFICADA DE OJO IZQUIERDO"
  },
  {
    "codigo":447823004,
    "descripcion":"ANOMALÍA CONGÉNITA DE VENA HEPÁTICA"
  },
  {
    "codigo":251215009,
    "descripcion":"INTERVALO UT ACORTADO"
  },
  {
    "codigo":52772002,
    "descripcion":"TIROIDITIS POSTPARTO"
  },
  {
    "codigo":314916002,
    "descripcion":"PULGAR TUMEFACTO"
  },
  {
    "codigo":249380003,
    "descripcion":"LENGUA PEQUEÑA"
  },
  {
    "codigo":413220003,
    "descripcion":"GASTROPATÍA PAPULOSA"
  },
  {
    "codigo":1099571000119100,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE SACO LAGRIMAL IZQUIERDA"
  },
  {
    "codigo":773668008,
    "descripcion":"ENCEFALOPATÍA INFANTIL DEBIDA A DEFICIENCIA DE TIAMINA PIROFOSFOCINASA"
  },
  {
    "codigo":247545005,
    "descripcion":"PELO SUAVE"
  },
  {
    "codigo":18169007,
    "descripcion":"ÚLCERA DUODENAL SIN HEMORRAGIA Y SIN PERFORACIÓN PERO CON OBSTRUCCIÓN"
  },
  {
    "codigo":49102001,
    "descripcion":"CARDIOPATÍA Y NEFROPATÍA HIPERTENSIVAS EN EL CONTEXTO OBSTÉTRICO"
  },
  {
    "codigo":737230006,
    "descripcion":"TRASTORNO DE LA SUSTANCIA BLANCA DEBIDO A ISQUEMIA"
  },
  {
    "codigo":702627001,
    "descripcion":"APLASIA DE TESTÍCULO"
  },
  {
    "codigo":211107002,
    "descripcion":"PICADURA DE INSECTO, EN LA ESPALDA"
  },
  {
    "codigo":276643006,
    "descripcion":"ASFIXIA NEONATAL LEVE"
  },
  {
    "codigo":243875009,
    "descripcion":"SITUACIÓN DEL MONITOREO DE LA MENOPAUSIA"
  },
  {
    "codigo":307576001,
    "descripcion":"OSTEOSARCOMA ÓSEO"
  },
  {
    "codigo":78200003,
    "descripcion":"HIPERPARATIROIDISMO TERCIARIO"
  },
  {
    "codigo":405880003,
    "descripcion":"FENOTIPO M-N-"
  },
  {
    "codigo":1290616008,
    "descripcion":"VACUNA VENCIDA"
  },
  {
    "codigo":305741002,
    "descripcion":"ATENDIDO POR ENFERMERA DEL ÁREA DE ONCOLOGÍA (MARIE CURIE)"
  },
  {
    "codigo":240205003,
    "descripcion":"QUISTE SINOVIAL"
  },
  {
    "codigo":698957003,
    "descripcion":"TRASTORNO DEPRESIVO EN REMISIÓN"
  },
  {
    "codigo":830029005,
    "descripcion":"QUISTE DERMOIDE DE ÓRBITA IZQUIERDA PROPIAMENTE DICHA"
  },
  {
    "codigo":404045007,
    "descripcion":"LEIOMIOSARCOMA EPITELIOIDE DE PIEL"
  },
  {
    "codigo":74530003,
    "descripcion":"DÉFICIT SENSITIVO NO COMPENSADO"
  },
  {
    "codigo":271138004,
    "descripcion":"AMPOLLA TRAUMÁTICA DE GLÚTEO, INFECTADA"
  },
  {
    "codigo":238370005,
    "descripcion":"EXANTEMA POR MONONUCLEOSIS INFECCIOSA"
  },
  {
    "codigo":236535001,
    "descripcion":"GLOMERULOPATÍA CON DEPÓSITOS FIBRILARES GIGANTES"
  },
  {
    "codigo":1186807002,
    "descripcion":"DEFICIENCIA HEREDITARIA DE HORMONA DE CRECIMIENTO"
  },
  {
    "codigo":7159003,
    "descripcion":"NECROSIS PULMONAR"
  },
  {
    "codigo":217651002,
    "descripcion":"ENVENENAMIENTO POR VENENO DE COBRA"
  },
  {
    "codigo":302071006,
    "descripcion":"HALLAZGO RELACIONADO CON LA SENSIBILIDAD DE LA GLÁNDULA TIROIDES"
  },
  {
    "codigo":39927006,
    "descripcion":"FIBROSIS DE PENE"
  },
  {
    "codigo":269303008,
    "descripcion":"LESIÓN PERIOPERATORIA"
  },
  {
    "codigo":726220000,
    "descripcion":"DISTENSIÓN DE FASCIA DE MÚSCULO DE LA CADERA"
  },
  {
    "codigo":365772005,
    "descripcion":"NIVEL DE FOSFATASA ALCALINA SÉRICA - HALLAZGO"
  },
  {
    "codigo":431308006,
    "descripcion":"INFECCIÓN AGUDA DEL TRACTO URINARIO SUPERIOR"
  },
  {
    "codigo":201932009,
    "descripcion":"ARTROPATÍA TRAUMÁTICA DE REGIÓN DE HOMBRO"
  },
  {
    "codigo":1073101000119108,
    "descripcion":"ARTRITIS ESTREPTOCÓCICA DE MUÑECA DERECHA"
  },
  {
    "codigo":298401008,
    "descripcion":"COLUMNA VERTEBRAL CERVICAL INFLAMADA"
  },
  {
    "codigo":724385009,
    "descripcion":"RETRASO DEL CRECIMIENTO DEBIDO A DEFICIENCIA DE FACTOR DE CRECIMIENTO SIMILAR A LA INSULINA TIPO 1"
  },
  {
    "codigo":69025008,
    "descripcion":"QUEMADURA EPIDÉRMICA DE DEDO PULGAR"
  },
  {
    "codigo":1148534000,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE ÁCIDO BILIAR Y\/O DERIVADO DE ÁCIDO BILIAR"
  },
  {
    "codigo":165494000,
    "descripcion":"ERITROCITOS NO AGREGADOS"
  },
  {
    "codigo":309351000119103,
    "descripcion":"NECROSIS AVASCULAR DE HÚMERO DERECHO"
  },
  {
    "codigo":10877031000119103,
    "descripcion":"HERIDA ABIERTA DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":1654001,
    "descripcion":"GLAUCOMA DE ÁNGULO ABIERTO CAUSADO POR CORTICOSTEROIDES"
  },
  {
    "codigo":394870008,
    "descripcion":"ESPECIE DE ESCHERICHIA COLI, NO AISLADA"
  },
  {
    "codigo":722550009,
    "descripcion":"SECUELA DE INFECCIÓN CAUSADA POR BACTERIA"
  },
  {
    "codigo":32587001,
    "descripcion":"RUPTURA DE TROMPA DE FALOPIO"
  },
  {
    "codigo":296566009,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE QUININA"
  },
  {
    "codigo":196427000,
    "descripcion":"OCLUSIÓN DENTAL DEFECTUOSA POR HÁBITO LABIAL"
  },
  {
    "codigo":294731007,
    "descripcion":"ALERGIA A GLIBENCLAMIDA"
  },
  {
    "codigo":718880003,
    "descripcion":"SÍNDROME SIMILAR AL SÍNDROME DE ZELLWEGER SIN ANOMALÍA DE LOS PEROXISOMAS"
  },
  {
    "codigo":292896005,
    "descripcion":"REACCIÓN ADVERSA A SURFACTANTE DE AMONIO CUATERNARIO"
  },
  {
    "codigo":145511000119106,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE ÓRGANO GENITAL"
  },
  {
    "codigo":1144864005,
    "descripcion":"DISMINUCIÓN DEL NIVEL DE DESORIENTACIÓN"
  },
  {
    "codigo":15683841000119100,
    "descripcion":"BURSITIS SUBACROMIAL BILATERAL"
  },
  {
    "codigo":1306869002,
    "descripcion":"GLAUCOMA POR RECESIÓN DE ÁNGULO BILATERAL"
  },
  {
    "codigo":717045004,
    "descripcion":"HIPERINSULINISMO AUTOSÓMICO DOMINANTE DEBIDO A DEFICIENCIA DE KIR6.2"
  },
  {
    "codigo":94453007,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA ÓRBITA OCULAR"
  },
  {
    "codigo":225525008,
    "descripcion":"HALLAZGO RELACIONADO CON EL HÁBITO DE COMER"
  },
  {
    "codigo":291061008,
    "descripcion":"INTOXICACIÓN POR CLOBAZAM"
  },
  {
    "codigo":92618006,
    "descripcion":"CARCINOMA IN SITU DE LAS VÍAS BILIARES INTRAHEPÁTICAS"
  },
  {
    "codigo":125386007,
    "descripcion":"HALLAZGOS ANORMALES POR MICROSCOPIA ELECTRÓNICA"
  },
  {
    "codigo":289226009,
    "descripcion":"PUJA EFICAZMENTE DURANTE EL TRABAJO DE PARTO"
  },
  {
    "codigo":1303199002,
    "descripcion":"INFECCIÓN DE FÉMUR ASOCIADA CON DISPOSITIVO DE FIJACIÓN INTERNA"
  },
  {
    "codigo":254623003,
    "descripcion":"PAPILOMA DE BRONQUIO"
  },
  {
    "codigo":58015007,
    "descripcion":"ENFERMEDAD EPIDÉMICA"
  },
  {
    "codigo":23412002,
    "descripcion":"HEMOPERICARDIO"
  },
  {
    "codigo":285556007,
    "descripcion":"MANTIENE LA ELEVACIÓN DEL PALADAR BLANDO"
  },
  {
    "codigo":187252008,
    "descripcion":"EFECTO TARDÍO DE TUBERCULOSIS RESPIRATORIA"
  },
  {
    "codigo":1137524009,
    "descripcion":"CALCIFICACIÓN PUNTEADA DE EPÍFISIS DE FALANGE DISTAL DE SEGUNDO DEDO DE PIE"
  },
  {
    "codigo":250953002,
    "descripcion":"PARED VENTRICULAR DERECHA PARADÓJICA"
  },
  {
    "codigo":1332297002,
    "descripcion":"GLAUCOMA DE OJO IZQUIERDO DEBIDO A LESIÓN PERFORANTE DE GLOBO OCULAR IZQUIERDO Y POSTERIOR A ELLA"
  },
  {
    "codigo":54345007,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE CUELLO SIN INFECCIÓN"
  },
  {
    "codigo":609566000,
    "descripcion":"EMBARAZO Y DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":283721009,
    "descripcion":"MORDEDURA HUMANA EN LA CADERA"
  },
  {
    "codigo":1363230000,
    "descripcion":"CICATRIZACIÓN DE PÁRPADOS INFERIOR Y SUPERIOR DERECHOS"
  },
  {
    "codigo":773406003,
    "descripcion":"SÍNDROME PROGEROIDE DE HIPOPLASIA MANDIBULAR Y SORDERA"
  },
  {
    "codigo":314654004,
    "descripcion":"PERÍMETRO CEFÁLICO DEL NIÑO: PERCENTILO 75"
  },
  {
    "codigo":19742005,
    "descripcion":"NECROSIS PANCREÁTICA RECIDIVANTE"
  },
  {
    "codigo":249118005,
    "descripcion":"NO SE ENCUENTRA LA PRESENTACIÓN EN EL ESTRECHO INFERIOR DE LA PELVIS"
  },
  {
    "codigo":85278001,
    "descripcion":"INTOXICACIÓN POR PHALARIS TUBEROSA"
  },
  {
    "codigo":50675000,
    "descripcion":"ABSCESO ESCLERAL"
  },
  {
    "codigo":1230323000,
    "descripcion":"SEPSIS NEONATAL PREMATURA"
  },
  {
    "codigo":247283005,
    "descripcion":"DIPLACUSIA BIAURAL"
  },
  {
    "codigo":81608000,
    "descripcion":"INSOMNIO RELACIONADO CON FACTORES ORGÁNICOS CONOCIDOS"
  },
  {
    "codigo":312819009,
    "descripcion":"TUMOR TENOSINOVIAL DE CÉLULAS GIGANTES DIFUSO DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":10824091000119105,
    "descripcion":"FRACTURA EXPUESTA DE FALANGE DISTAL DE PULGAR IZQUIERDO"
  },
  {
    "codigo":704200007,
    "descripcion":"HIPOTONÍA ADQUIRIDA"
  },
  {
    "codigo":1259421001,
    "descripcion":"CARCINOMA PRIMARIO DE MAMA - CUADRANTE INFEROEXTERNO"
  },
  {
    "codigo":702365002,
    "descripcion":"ACIDURIA MALÓNICA Y METILMALÓNICA COMBINADA"
  },
  {
    "codigo":472989003,
    "descripcion":"TRAVESTISMO DE DOBLE ROL"
  },
  {
    "codigo":1357725002,
    "descripcion":"SIN POBREZA ENERGÉTICA EN EL HOGAR"
  },
  {
    "codigo":276381005,
    "descripcion":"SIN RUIDOS HIDROAÉREOS"
  },
  {
    "codigo":210845007,
    "descripcion":"LESIÓN EXPUESTA, ARTERIA PALMAR"
  },
  {
    "codigo":45170000,
    "descripcion":"ENCEFALITIS"
  },
  {
    "codigo":733298002,
    "descripcion":"LUXACIÓN TRAUMÁTICA DE ARTICULACIÓN DE RÓTULA"
  },
  {
    "codigo":209010004,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA PANASTRAGALINA"
  },
  {
    "codigo":241778005,
    "descripcion":"EFECTO TÓXICO DE HONGO MATAMOSCAS"
  },
  {
    "codigo":1255751000,
    "descripcion":"LINFOMA DE BURKITT DE GANGLIOS LINFÁTICOS DE CABEZA Y CUELLO"
  },
  {
    "codigo":307314009,
    "descripcion":"RUPTURA DE ARTERIA ILÍACA"
  },
  {
    "codigo":239943002,
    "descripcion":"VASCULITIS REUMATOIDE NECROSANTE"
  },
  {
    "codigo":76103002,
    "descripcion":"FRACTURAS MÚLTIPLES EXPUESTAS DE LA EXTREMIDAD SUPERIOR CON EL ESTERNÓN Y LAS COSTILLAS"
  },
  {
    "codigo":10567003,
    "descripcion":"SÍNDROME DE TETRASOMÍA X"
  },
  {
    "codigo":371015003,
    "descripcion":"AUSENCIA CONGÉNITA DE AMBOS TESTÍCULOS"
  },
  {
    "codigo":698695006,
    "descripcion":"ANOREXIA NERVIOSA EN REMISIÓN"
  },
  {
    "codigo":305479006,
    "descripcion":"BAJO ATENCIÓN DE FARMACÓLOGO CLÍNICO"
  },
  {
    "codigo":403783009,
    "descripcion":"ENFERMEDAD DE DARIER DE LOS PLIEGUES"
  },
  {
    "codigo":762396004,
    "descripcion":"LIPOMA SUBCUTÁNEO"
  },
  {
    "codigo":238108007,
    "descripcion":"CAQUEXIA"
  },
  {
    "codigo":1284849005,
    "descripcion":"TUMOR DE OVARIO PRIMARIO MALIGNO DE CÉLULAS DE SERTOLI-LEYDIG"
  },
  {
    "codigo":400113006,
    "descripcion":"QUEMADURA DE PIEL POR ÁCIDO"
  },
  {
    "codigo":6897007,
    "descripcion":"INFECCIÓN CAUSADA POR DIPLOGONOPORUS GRANDIS"
  },
  {
    "codigo":725958000,
    "descripcion":"INSUFICIENCIA VENOSA CEREBROESPINAL CRÓNICA"
  },
  {
    "codigo":170737008,
    "descripcion":"PROBLEMA ASOCIADO CON GOTA"
  },
  {
    "codigo":299974002,
    "descripcion":"IRRITACIÓN POR CONTACTO CON ORTIGA"
  },
  {
    "codigo":398278002,
    "descripcion":"BLOQUEO DE LA CONDUCCIÓN NERVIOSA SENSORIAL - NINGUNO"
  },
  {
    "codigo":37830006,
    "descripcion":"PERIMETRITIS CRÓNICA"
  },
  {
    "codigo":201670006,
    "descripcion":"ARTRITIS GOTOSA DE MÚLTIPLES LOCALIZACIONES"
  },
  {
    "codigo":365510008,
    "descripcion":"ARREGLOS PARA ALBERGUE TEMPORARIO - HALLAZGO"
  },
  {
    "codigo":396443005,
    "descripcion":"REMISIÓN QUE INVOLUCRA MENOS DEL 75% DEL TUMOR, PRESENTE"
  },
  {
    "codigo":298139006,
    "descripcion":"RONCHA BULLOSA"
  },
  {
    "codigo":165232002,
    "descripcion":"INCONTINENCIA VESICAL"
  },
  {
    "codigo":722288007,
    "descripcion":"SÍNDROME DE ENTEROPATÍA AUTOINMUNITARIA Y ENDOCRINOPATÍA CON SUSCEPTIBILIDAD A INFECCIÓN CRÓNICA"
  },
  {
    "codigo":1017200008,
    "descripcion":"CON MAYOR RIESGO DE ABUSO INSTITUCIONAL"
  },
  {
    "codigo":720453001,
    "descripcion":"EPISODIO ÚNICO DE DEPRESIÓN MAYOR MODERADAMENTE SEVERA"
  },
  {
    "codigo":65093003,
    "descripcion":"ENFERMEDAD CAUSADA POR ORTHOMYXOVIRIDAE"
  },
  {
    "codigo":294469003,
    "descripcion":"ALERGIA A GENTAMICINA"
  },
  {
    "codigo":15741801000119103,
    "descripcion":"PIE EQUINOVARO ADQUIRIDO BILATERAL"
  },
  {
    "codigo":292634007,
    "descripcion":"REACCIÓN ADVERSA A PASTA CON DITRANOL"
  },
  {
    "codigo":1306607000,
    "descripcion":"GLAUCOMA POR RECESIÓN DE ÁNGULO DE OJO DERECHO"
  },
  {
    "codigo":94191001,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE VASO SANGUÍNEO DE LA CARA"
  },
  {
    "codigo":290799000,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR PROFENAMINA"
  },
  {
    "codigo":421871004,
    "descripcion":"TRASTORNO ALÉRGICO ATÓPICO MEDIADO POR IGE"
  },
  {
    "codigo":126959008,
    "descripcion":"NEOPLASIA DE LAS MENINGES CEREBRALES"
  },
  {
    "codigo":340841000119105,
    "descripcion":"ESTAFILOMA ECUATORIAL IZQUIERDO"
  },
  {
    "codigo":125124002,
    "descripcion":"PESO DE ÓRGANO, NORMAL"
  },
  {
    "codigo":190660003,
    "descripcion":"DEFICIENCIA ALIMENTARIA DE SELENIO"
  },
  {
    "codigo":26820004,
    "descripcion":"INTOXICACIÓN POR TTRIFOLIUM SUBTERRANEUM"
  },
  {
    "codigo":288964005,
    "descripcion":"CAPAZ DE INICIAR EL REFLEJO DE DEGLUCIÓN"
  },
  {
    "codigo":23150001,
    "descripcion":"SÍNDROME DE PROTEUS"
  },
  {
    "codigo":285294006,
    "descripcion":"FANTASÍA PLACENTERA"
  },
  {
    "codigo":283459000,
    "descripcion":"HERIDA PUNZANTE EN EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":250691000,
    "descripcion":"ALFA-1-ANTITRIPSINA, FENOTIPO NULO"
  },
  {
    "codigo":840515001,
    "descripcion":"NEOPLASIA MALIGNA MIXTA COMPLEJA Y DEL ESTROMA DE ISTMO UTERINO"
  },
  {
    "codigo":248856002,
    "descripcion":"HIMEN CON FIMBRIAS"
  },
  {
    "codigo":707608003,
    "descripcion":"AMELOGÉNESIS IMPERFECTA CON DISTROFIA DE CONOS Y BASTONES CONCOMITANTE"
  },
  {
    "codigo":19480005,
    "descripcion":"DIAGNÓSTICO EN EL EJE V"
  },
  {
    "codigo":771309000,
    "descripcion":"ENFERMEDAD LINFOPROLIFERATIVA AUTOSÓMICA RECESIVA"
  },
  {
    "codigo":247021003,
    "descripcion":"PUPILA HEMIANÓPSICA DE WERNICKE"
  },
  {
    "codigo":738541005,
    "descripcion":"METABOLIZADOR NORMAL DE TIOPURINA S-METILTRANSFERASA"
  },
  {
    "codigo":1197293007,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS METASTÁSICO DE GANGLIOS LINFÁTICOS DE CABEZA Y CUELLO"
  },
  {
    "codigo":1230061008,
    "descripcion":"ENVEJECIMIENTO PREMATURO DE PLACENTA"
  },
  {
    "codigo":441794001,
    "descripcion":"CUADRIPLEJÍA INCOMPLETA DEBIDA A LESIÓN DE MÉDULA ESPINAL ENTRE QUINTA Y SÉPTIMA VÉRTEBRAS CERVICALES"
  },
  {
    "codigo":736706004,
    "descripcion":"FUNCIÓN DENTOFACIAL NORMAL"
  },
  {
    "codigo":703938007,
    "descripcion":"DERMATOSIS INFLAMATORIA"
  },
  {
    "codigo":210583001,
    "descripcion":"SECCIÓN TOTAL DEL TENDÓN DEL FLEXOR PROFUNDO DE LOS DEDOS DE LA MANO"
  },
  {
    "codigo":13975002,
    "descripcion":"LUXACIÓN EXPUESTA DE ARTICULACIÓN GLENOHUMERAL"
  },
  {
    "codigo":734871004,
    "descripcion":"EVALUACIÓN DE CARIOTIPO NORMAL"
  },
  {
    "codigo":77676001,
    "descripcion":"PROLAPSO DEL IRIS"
  },
  {
    "codigo":307052004,
    "descripcion":"CONSUMO DE DROGAS ILÍCITAS"
  },
  {
    "codigo":208748005,
    "descripcion":"LUXACIÓN EXPUESTA DE MANDÍBULA"
  },
  {
    "codigo":700268009,
    "descripcion":"BLEFAROCALASIA DE PÁRPADO INFERIOR"
  },
  {
    "codigo":403521006,
    "descripcion":"MORFEA EN GOTAS"
  },
  {
    "codigo":1157185008,
    "descripcion":"INFECCIÓN CAUSADA POR OOMYCOTA"
  },
  {
    "codigo":237846001,
    "descripcion":"ALCALOSIS HIPERPOTASÉMICA"
  },
  {
    "codigo":41238004,
    "descripcion":"INTOXICACIÓN POR ORO"
  },
  {
    "codigo":74006009,
    "descripcion":"AMUSIA INSTRUMENTAL"
  },
  {
    "codigo":236011003,
    "descripcion":"QUISTE RETROPERITONEAL"
  },
  {
    "codigo":35861000175101,
    "descripcion":"ÚLCERA POR PRESIÓN EN TALÓN, ESTADIO IV"
  },
  {
    "codigo":301547006,
    "descripcion":"NO LLEGA HACIA EL INODORO"
  },
  {
    "codigo":1080631000119105,
    "descripcion":"LEIOMIOSARCOMA PRIMARIO DE HOMBRO DERECHO"
  },
  {
    "codigo":4800001,
    "descripcion":"PIURIA"
  },
  {
    "codigo":70336002,
    "descripcion":"INTOXICACIÓN POR METOMIL"
  },
  {
    "codigo":168640003,
    "descripcion":"RADIOGRAFÍA SIMPLE DE MANO ANORMAL"
  },
  {
    "codigo":234176004,
    "descripcion":"RETENCIÓN DE LÍQUIDOS IDIOPÁTICA"
  },
  {
    "codigo":48661000175109,
    "descripcion":"VÍCTIMA DE ACOSO"
  },
  {
    "codigo":365248004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA MANEJAR RECIPIENTE DE ALIMENTOS"
  },
  {
    "codigo":12761000132100,
    "descripcion":"HALLAZGO RELACIONADO CON EL NIVEL DE CETONEMIA"
  },
  {
    "codigo":343351000119105,
    "descripcion":"GLAUKOMFLECKEN BILATERAL"
  },
  {
    "codigo":266944002,
    "descripcion":"TIENE ANTECEDENTES PENALES"
  },
  {
    "codigo":363413005,
    "descripcion":"NEOPLASIA MALIGNA DE ÁNGULO ESPLÉNICO DE COLON"
  },
  {
    "codigo":2965006,
    "descripcion":"ALOPECIA CONGÉNITA"
  },
  {
    "codigo":230506000,
    "descripcion":"FIBRAS NERVIOSAS MIELINIZADAS DE LA PAPILA ÓPTICA"
  },
  {
    "codigo":296042005,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE BUTABARBITAL"
  },
  {
    "codigo":785727000,
    "descripcion":"DIARREA INFANTIL CRÓNICA DEBIDA A HIPERACTIVIDAD DE GUANILATO CICLASA 2C"
  },
  {
    "codigo":294207001,
    "descripcion":"ALERGIA A RETINOIDE"
  },
  {
    "codigo":359743001,
    "descripcion":"HIPOPARATIROIDISMO POSABLATIVO"
  },
  {
    "codigo":263274008,
    "descripcion":"LESIÓN TRAUMÁTICA DEL TEJIDO PERIODONTAL"
  },
  {
    "codigo":11785681000119104,
    "descripcion":"ABRASIÓN DE PIEL DE DEDO MEDIO IZQUIERDO"
  },
  {
    "codigo":64831005,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE HOMBRO CON INFECCIÓN"
  },
  {
    "codigo":15635921000119105,
    "descripcion":"BURSITIS DE PATA DE GANSO DE AMBAS RODILLAS"
  },
  {
    "codigo":10966481000119105,
    "descripcion":"HERIDA POR ARMA BLANCA DE PIE IZQUIERDO"
  },
  {
    "codigo":194068002,
    "descripcion":"TRASTORNO DE CORTEZA VISUAL POR NEOPLASIA"
  },
  {
    "codigo":1144340000,
    "descripcion":"HIPOPLASIA CONGÉNITA DE NEUROHIPÓFISIS"
  },
  {
    "codigo":292372005,
    "descripcion":"REACCIÓN ADVERSA A LA SULPIRIDA"
  },
  {
    "codigo":716521001,
    "descripcion":"PRUEBA DE LAS REGLAS DE OTTAWA PARA TOBILLO NEGATIVA"
  },
  {
    "codigo":290537002,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR PRILOCAÍNA"
  },
  {
    "codigo":93929003,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL NERVIO OCULOMOTOR"
  },
  {
    "codigo":126697005,
    "descripcion":"NEOPLASIA DE SUPRAGLOTIS"
  },
  {
    "codigo":225001006,
    "descripcion":"PREOCUPADO CON PROBLEMAS EMOCIONALES"
  },
  {
    "codigo":419774004,
    "descripcion":"ASTIGMATISMO INDUCIDO QUIRÚRGICAMENTE"
  },
  {
    "codigo":288702004,
    "descripcion":"INCAPAZ DE COMUNICARSE EN DIFERENTES LUGARES"
  },
  {
    "codigo":92094006,
    "descripcion":"NEOPLASIA BENIGNA DE TROMPA DE EUSTAQUIO"
  },
  {
    "codigo":26558007,
    "descripcion":"PAROTITIS TÓXICA"
  },
  {
    "codigo":417939004,
    "descripcion":"DEGENERACIÓN AMILOIDE DE LA CÓRNEA"
  },
  {
    "codigo":1204371007,
    "descripcion":"QUISTE DE COLÉDOCO"
  },
  {
    "codigo":254099008,
    "descripcion":"SÍNDROME DE DESBUQUOIS"
  },
  {
    "codigo":39761000087104,
    "descripcion":"LUXACIÓN DE ARTICULACIÓN DE DEDO ANULAR DE MANO DERECHA"
  },
  {
    "codigo":34641000087106,
    "descripcion":"PRUEBA DE HEMATOLOGÍA POR FUERA DE RANGO DE REFERENCIA"
  },
  {
    "codigo":285032000,
    "descripcion":"DIFICULTAD DE MANEJAR UN ARTEFACTO MIENTRAS SE DESVISTE"
  },
  {
    "codigo":42321000087103,
    "descripcion":"CONTUSIÓN DE COSTILLA IZQUIERDA"
  },
  {
    "codigo":290411000119106,
    "descripcion":"PARAPLEJÍA INCOMPLETA"
  },
  {
    "codigo":22888007,
    "descripcion":"LUPUS ERITEMATOSO MEDICAMENTOSO CAUSADO POR PROCAINAMIDA"
  },
  {
    "codigo":448872008,
    "descripcion":"VENA COLATERAL VENOVENOSA SISTÉMICA"
  },
  {
    "codigo":250429001,
    "descripcion":"OBSERVACIÓN MACROSCÓPICA DEL ESPÉCIMEN"
  },
  {
    "codigo":16674411000119107,
    "descripcion":"FRACTURA PATOLÓGICA DE MITAD DERECHA DE MANDÍBULA"
  },
  {
    "codigo":53821008,
    "descripcion":"INFERTILIDAD CAUSADA POR RADIACIÓN"
  },
  {
    "codigo":283197009,
    "descripcion":"ANZUELO EN BRAZO"
  },
  {
    "codigo":707346000,
    "descripcion":"CARCINOMA PRIMARIO DE SENO ETMOIDAL"
  },
  {
    "codigo":1231634003,
    "descripcion":"ATROFIA ÓPTICA LIGADA A CROMOSOMA X"
  },
  {
    "codigo":217661009,
    "descripcion":"ENVENENAMIENTO CAUSADO POR VENENO DE VÍBORA"
  },
  {
    "codigo":345861000119103,
    "descripcion":"ATROFIA DE DISCO ÓPTICO DE AMBOS OJOS DEBIDA A GLAUCOMA"
  },
  {
    "codigo":281362006,
    "descripcion":"TOFO GOTOSO DE BOLSA SEROSA"
  },
  {
    "codigo":248594007,
    "descripcion":"TOS A TRAVÉS DE FÍSTULA TRAQUEOESOFÁGICA"
  },
  {
    "codigo":17383000,
    "descripcion":"EFECTO TÓXICO DEL MONÓXIDO DE CARBONO"
  },
  {
    "codigo":51986008,
    "descripcion":"INTOXICACIÓN POR TRIGLOCHIN"
  },
  {
    "codigo":1264402008,
    "descripcion":"HIPOTIROIDISMO DEBIDO A ESCLEROSIS SISTÉMICA"
  },
  {
    "codigo":82919002,
    "descripcion":"INFECCIÓN CAUSADA POR STRONGYLOIDES PAPILLOSUS"
  },
  {
    "codigo":246759006,
    "descripcion":"NISTAGMO IRREGULAR"
  },
  {
    "codigo":1162428009,
    "descripcion":"DOLOR EN CINTURA ESCAPULAR"
  },
  {
    "codigo":46481004,
    "descripcion":"HIPERTENSIÓN ARTERIAL ESENCIAL CON BAJO NIVEL DE RENINA"
  },
  {
    "codigo":308625005,
    "descripcion":"SITUACIÓN DE SOLICITUD"
  },
  {
    "codigo":1258897005,
    "descripcion":"DESPROPORCIÓN FETAL DEBIDA A FETO GRANDE"
  },
  {
    "codigo":700006000,
    "descripcion":"HALLAZGO RELACIONADO CON ÓRGANO PÉLVICO"
  },
  {
    "codigo":102451006,
    "descripcion":"CONJUNTIVITIS MEMBRANOSA"
  },
  {
    "codigo":77414002,
    "descripcion":"QUEILOGNATOSQUISIS"
  },
  {
    "codigo":110182002,
    "descripcion":"QUEMADURA DE LA FRENTE"
  },
  {
    "codigo":208486000,
    "descripcion":"FRACTURA EXPUESTA DE FALANGE MEDIA DE DEDO DE LA MANO, CUELLO"
  },
  {
    "codigo":403259002,
    "descripcion":"HIPERMELANOSIS POR FEOCROMOCITOMA"
  },
  {
    "codigo":370491005,
    "descripcion":"ACIDOSIS METABÓLICA POR INGESTIÓN EXCESIVA DE CEREALES"
  },
  {
    "codigo":237584002,
    "descripcion":"SECRECIÓN EXCESIVA DE COLECISTOQUININA-PANCREOZIMINA"
  },
  {
    "codigo":73744004,
    "descripcion":"ESTADO DE HIPERSEXUALIDAD"
  },
  {
    "codigo":40976007,
    "descripcion":"DESEQUILIBRIO DE ENLACE GENÉTICO"
  },
  {
    "codigo":235749000,
    "descripcion":"COLITIS POR CITOMEGALOVIRUS"
  },
  {
    "codigo":301285005,
    "descripcion":"HALLAZGO RELACIONADO CON EL SONIDO DE LA RESPIRACIÓN"
  },
  {
    "codigo":268517006,
    "descripcion":"CONTROL DE DIABETES - SITIOS DE INYECCIÓN"
  },
  {
    "codigo":233914001,
    "descripcion":"DISFUNCIÓN DEL NÓDULO SINUSAL POSTERIOR A PROCEDIMIENTO QUIRÚRGICO"
  },
  {
    "codigo":299450006,
    "descripcion":"CREPITACIÓN AUDIBLE EN EL TOBILLO"
  },
  {
    "codigo":168378007,
    "descripcion":"HELICOBACTER DETECTADO POR PRUEBA DE ALIENTO"
  },
  {
    "codigo":201146008,
    "descripcion":"ALOPECIA ANDRÓGENA MEDICAMENTOSA"
  },
  {
    "codigo":364986009,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA EJECUTAR FUNCIONES DEL HABLA"
  },
  {
    "codigo":725434009,
    "descripcion":"SÍNDROME FACIODIGITOGENITAL AUTOSÓMICO RECESIVO"
  },
  {
    "codigo":397754009,
    "descripcion":"MORBILIDAD DE ANESTESIA REGIONAL"
  },
  {
    "codigo":428687006,
    "descripcion":"PESADILLAS ASOCIADAS CON TRASTORNO CRÓNICO DE ESTRÉS POSTRAUMÁTICO"
  },
  {
    "codigo":197476001,
    "descripcion":"MALABSORCIÓN INTESTINAL"
  },
  {
    "codigo":295780007,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE TAMOXIFENO"
  },
  {
    "codigo":721764008,
    "descripcion":"INFECCIÓN CAUSADA POR POLIOVIRUS HUMANO"
  },
  {
    "codigo":263012009,
    "descripcion":"DIASTASIS DE LA SÍNFISIS PÚBICA"
  },
  {
    "codigo":425017003,
    "descripcion":"DISPOSITIVO DE SEGURIDAD RESIDENCIAL INADECUADO"
  },
  {
    "codigo":95502000,
    "descripcion":"ANOMALÍA CONGÉNITA DEL NERVIO ÓPTICO"
  },
  {
    "codigo":128270001,
    "descripcion":"INFECCIÓN FETAL"
  },
  {
    "codigo":783630000,
    "descripcion":"ANEURISMA CONGÉNITO DE ARTERIA PRECEREBRAL"
  },
  {
    "codigo":292110003,
    "descripcion":"REACCIÓN ADVERSA A LA RANITIDINA"
  },
  {
    "codigo":64569008,
    "descripcion":"FRACTURAS NO EXPUESTAS DE MÚLTIPLES HUESOS DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":60899001,
    "descripcion":"CARDIOPATÍA HIPERTENSIVA SIN INSUFICIENCIA CARDÍACA CONGESTIVA"
  },
  {
    "codigo":29966009,
    "descripcion":"HIPERTRICOSIS"
  },
  {
    "codigo":93667002,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE MUCOSA DE CRESTA ALVEOLAR"
  },
  {
    "codigo":880099003,
    "descripcion":"DERMATITIS POR INFESTACIÓN DE CHEYLETIELLA YASGURI"
  },
  {
    "codigo":716259005,
    "descripcion":"STAPHYLOCOCCUS CHROMOGENES O STAPHYLOCOCCUS HYICUS"
  },
  {
    "codigo":290275001,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR ÁCIDO MEFENÁMICO"
  },
  {
    "codigo":288440000,
    "descripcion":"DIFICULTAD PARA REALIZAR ACTIVIDADES DE DIBUJO"
  },
  {
    "codigo":124600004,
    "descripcion":"DEFICIENCIA DE L - AMINOÁCIDO - AROMÁTICO DESCARBOXILASA"
  },
  {
    "codigo":714424005,
    "descripcion":"SE ASIMILA CULTURALMENTE"
  },
  {
    "codigo":441001000124102,
    "descripcion":"INGESTA EXCESIVA DE CROMO"
  },
  {
    "codigo":1337016008,
    "descripcion":"SÍNDROME COMPARTIMENTAL TIBIAL ANTERIOR DE PIERNA IZQUIERDA DEBIDO A LESIÓN TRAUMÁTICA"
  },
  {
    "codigo":253837000,
    "descripcion":"FÍSTULA URETROVAGINAL CONGÉNITA"
  },
  {
    "codigo":671401000124108,
    "descripcion":"INCAPAZ DE REFRIGERAR LA VIVIENDA DEBIDO A RECURSOS FINANCIEROS LIMITADOS"
  },
  {
    "codigo":188301005,
    "descripcion":"NEOPLASIA MALIGNA DEL CUERPO CALLOSO"
  },
  {
    "codigo":1085651000119109,
    "descripcion":"FISURA ANAL CONGÉNITA"
  },
  {
    "codigo":448610006,
    "descripcion":"HEMANGIOMA DE CARA"
  },
  {
    "codigo":252002006,
    "descripcion":"INCOMPETENCIA DE CUELLO DE VEJIGA URINARIA EN CONDICIONES DE ESTRÉS"
  },
  {
    "codigo":250167005,
    "descripcion":"PACIENTE QUE NO ES OBEDIENTE CON RESPECTO AL USO DEL CALZADO"
  },
  {
    "codigo":1264140001,
    "descripcion":"AFIBRINOGENEMIA POSTERIOR A EMBARAZO MOLAR"
  },
  {
    "codigo":1296908006,
    "descripcion":"RESISTENCIA HEREDITARIA AUTOSÓMICA DOMINANTE A VASOPRESINA"
  },
  {
    "codigo":248332009,
    "descripcion":"FLUCTUACIÓN DEL PESO"
  },
  {
    "codigo":770785002,
    "descripcion":"INMUNODEFICIENCIA DE LINFOCITOS T DEBIDA A DEFICIENCIA DE MIEMBRO H DE HOMÓLOGO DE LA FAMILIA RAS"
  },
  {
    "codigo":18956009,
    "descripcion":"INFECCIÓN CAUSADA POR STRONGYLOIDES RANSOMI"
  },
  {
    "codigo":17121006,
    "descripcion":"NEFRITIS POR VIRUS DE LA PAROTIDITIS URLIANA"
  },
  {
    "codigo":16024071000119102,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DEBIDO A OCLUSIÓN DE ARTERIA COROIDEA ANTERIOR DERECHA"
  },
  {
    "codigo":408502001,
    "descripcion":"EXAMEN PEDIÁTRICO DE LOS 7 MESES ANORMAL: PARA OBSERVACIÓN"
  },
  {
    "codigo":836321009,
    "descripcion":"AGUDEZA VISUAL CORREGIDA DE OJO IZQUIERDO 6\/3"
  },
  {
    "codigo":211894004,
    "descripcion":"QUEMADURA SUPERFICIAL DE MÁS DE UN DEDO DE LA MANO"
  },
  {
    "codigo":734347001,
    "descripcion":"TIENE SUMINISTRO DE MEDICACIÓN DE RESCATE"
  },
  {
    "codigo":373899003,
    "descripcion":"SÍNTOMAS ASMÁTICOS DIURNOS"
  },
  {
    "codigo":131591000119104,
    "descripcion":"STENT METÁLICO SIN CUBIERTA EN RAMA CIRCUNFLEJA DE ARTERIA CORONARIA IZQUIERDA"
  },
  {
    "codigo":111755007,
    "descripcion":"INTOXICACIÓN POR CORTICOSTEROIDE FLUORADO"
  },
  {
    "codigo":177291008,
    "descripcion":"PERICARDITIS AGUDA CON DERRAME"
  },
  {
    "codigo":273760003,
    "descripcion":"ENFERMEDAD FÍSICA, COMPONENTE PSICOLÓGICO MODERADO"
  },
  {
    "codigo":402997002,
    "descripcion":"CANDIDIASIS ORAL CRÓNICA EN PLACAS"
  },
  {
    "codigo":239157004,
    "descripcion":"NECROSIS DE BORDE DE HERIDA"
  },
  {
    "codigo":105121000119102,
    "descripcion":"CARCINOMA ESCAMOCELULAR DE VAGINA"
  },
  {
    "codigo":350881000119102,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE CORTEZA SUPRARRENAL DERECHA"
  },
  {
    "codigo":302858007,
    "descripcion":"OSTEOMA"
  },
  {
    "codigo":38879000,
    "descripcion":"TRASTORNO POR INHIBIDOR DEL FACTOR XI"
  },
  {
    "codigo":40714009,
    "descripcion":"CATARATA PUNTEADA"
  },
  {
    "codigo":152148641000119104,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DEBIDO A EMBOLIA DE AMBAS ARTERIAS CARÓTIDAS"
  },
  {
    "codigo":6111009,
    "descripcion":"LIQUEN PLANO AMPOLLAR"
  },
  {
    "codigo":364724002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA CAMINAR LLEVANDO UN JUGUETE GRANDE"
  },
  {
    "codigo":299188002,
    "descripcion":"SIN AMPLITUD ACTIVA DE OPOSICIÓN DE PULGAR"
  },
  {
    "codigo":102580004,
    "descripcion":"SUPRESIÓN DE LA TOS"
  },
  {
    "codigo":168116007,
    "descripcion":"ESTUDIO DE CÉLULAS FETALES EN LÍQUIDO AMNIÓTICO, NO SE DETECTARON ANOMALÍAS"
  },
  {
    "codigo":266420009,
    "descripcion":"ANOMALÍA DE LA MANDÍBULA A NIVEL DE LA BASE DE CRÁNEO"
  },
  {
    "codigo":231817002,
    "descripcion":"LACERACIÓN PALPEBRAL DE ESPESOR TOTAL"
  },
  {
    "codigo":35209006,
    "descripcion":"SENSIBILIDAD"
  },
  {
    "codigo":428425008,
    "descripcion":"HALLADO SOBRE INODORO"
  },
  {
    "codigo":788873009,
    "descripcion":"SINAPTOPATÍA AUDITIVA"
  },
  {
    "codigo":262750000,
    "descripcion":"HERIDA ABIERTA PERIOCULAR"
  },
  {
    "codigo":721502007,
    "descripcion":"LESIÓN COMPLETA DE MÉDULA ESPINAL AL NIVEL DEL TERCER SEGMENTO LUMBAR"
  },
  {
    "codigo":16076011000119100,
    "descripcion":"GOTA TOFÁCEA CRÓNICA DE AMBOS PIES"
  },
  {
    "codigo":332011000119101,
    "descripcion":"ENTROPIÓN ESPÁSTICO DE PÁRPADO DERECHO"
  },
  {
    "codigo":391987005,
    "descripcion":"TÓRAX EN EMBUDO"
  },
  {
    "codigo":1074411000119103,
    "descripcion":"ARTROSIS DE AMBAS ARTICULACIONES ESTERNOCLAVICULARES"
  },
  {
    "codigo":60651000119103,
    "descripcion":"DEPENDENCIA DE OXÍGENO SUPLEMENTARIO CONTINUO"
  },
  {
    "codigo":101611000119103,
    "descripcion":"NEUROMA TRAUMÁTICO DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":1079531000119106,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE RIÑÓN IZQUIERDO"
  },
  {
    "codigo":329451000119104,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DEBIDO A OCLUSIÓN DE ARTERIA CEREBELOSA DERECHA POR ÉMBOLO"
  },
  {
    "codigo":334571000119106,
    "descripcion":"QUERATOCONO DE LA CÓRNEA DERECHA"
  },
  {
    "codigo":15630571000119109,
    "descripcion":"TENDINITIS DE REGIÓN DE MUÑECA DERECHA"
  },
  {
    "codigo":129843006,
    "descripcion":"HALLAZGO RELACIONADO CON EL CUIDADO DE LA SALUD"
  },
  {
    "codigo":16068331000119102,
    "descripcion":"ACIDEMIA METABÓLICA NEONATAL"
  },
  {
    "codigo":129771000119107,
    "descripcion":"NEOPLASIA POSTERIOR A TRASPLANTE DE MÉDULA ÓSEA"
  },
  {
    "codigo":62472004,
    "descripcion":"DILATACIÓN CERVICAL COMPLETA"
  },
  {
    "codigo":717832004,
    "descripcion":"TRASTORNO DE PIGMENTACIÓN DE LABIO"
  },
  {
    "codigo":1771000119109,
    "descripcion":"ARTRITIS DE MUÑECA"
  },
  {
    "codigo":142571000119109,
    "descripcion":"FRAGMENTO DE CUERPO EXTRAÑO METÁLICO RETENIDO"
  },
  {
    "codigo":50411000119108,
    "descripcion":"NEFRITIS TUBULOINTERSTICIAL SECUNDARIA"
  },
  {
    "codigo":60637003,
    "descripcion":"ANOMALÍA CONGÉNITA DE GLÁNDULA SUPRARRENAL"
  },
  {
    "codigo":93405003,
    "descripcion":"ENGROSAMIENTO CONGÉNITO DEL PUBIS"
  },
  {
    "codigo":191709001,
    "descripcion":"ANSIEDAD RECURRENTE"
  },
  {
    "codigo":224477006,
    "descripcion":"RECIBE AYUDA DE CUIDADOR NO PROFESIONAL"
  },
  {
    "codigo":91570002,
    "descripcion":"LÍNEA FISIOLÓGICA DE PIGMENTACIÓN FÉRRICA ENTRE LOS DOS TERCIOS SUPERIORES Y EL TERCIO INFERIOR DE LA CÓRNEA"
  },
  {
    "codigo":124338008,
    "descripcion":"DEFICIENCIA DE CREATINA CINASA"
  },
  {
    "codigo":1269383004,
    "descripcion":"LESIÓN COMPLETA DE MÉDULA ESPINAL DORSAL DEBIDA A SUBLUXACIÓN EXPUESTA DE ARTICULACIÓN DE COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":24199005,
    "descripcion":"AGITACIÓN"
  },
  {
    "codigo":253575005,
    "descripcion":"INFUNDÍBULOS MUSCULARES BILATERALES"
  },
  {
    "codigo":87900003,
    "descripcion":"LESIÓN TRAUMÁTICA DE LAS RAÍCES NERVIOSAS SACRAS"
  },
  {
    "codigo":218972004,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR DIURÉTICO DERIVADO DE PURINA"
  },
  {
    "codigo":11848661000119106,
    "descripcion":"CONTUSIÓN DE PÁRPADO IZQUIERDO"
  },
  {
    "codigo":1234780005,
    "descripcion":"TRASTORNO DEL ESTADO DE ÁNIMO CON SÍNTOMAS MANÍACOS Y DEPRESIVOS MIXTOS INDUCIDO POR ALCOHOL"
  },
  {
    "codigo":284508007,
    "descripcion":"CONDUCTA PREDECIBLE"
  },
  {
    "codigo":186204008,
    "descripcion":"TUBERCULOSIS PULMONAR, SIN REALIZACIÓN DE EXÁMENES BACTERIOLÓGICOS O HISTOLÓGICOS"
  },
  {
    "codigo":20529002,
    "descripcion":"MIOCARDIOPATÍA DILATADA SECUNDARIA"
  },
  {
    "codigo":249905003,
    "descripcion":"DIFICULTAD PARA ACOSTARSE"
  },
  {
    "codigo":1003569002,
    "descripcion":"AGENESIA DE ESÓFAGO"
  },
  {
    "codigo":446513005,
    "descripcion":"FÍSTULA DE GLÚTEO"
  },
  {
    "codigo":53297005,
    "descripcion":"SÍNDROME DE FREGOLI"
  },
  {
    "codigo":315441005,
    "descripcion":"NACIDO EN HONG KONG"
  },
  {
    "codigo":353391000119102,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE OJO DERECHO"
  },
  {
    "codigo":1296646001,
    "descripcion":"EXACERBACIÓN DE PSORIASIS"
  },
  {
    "codigo":282673009,
    "descripcion":"ATRAPA"
  },
  {
    "codigo":248070001,
    "descripcion":"GOLPE DE CABEZA"
  },
  {
    "codigo":681071000119104,
    "descripcion":"BLEFARITIS ANGULAR DE PÁRPADO IZQUIERDO"
  },
  {
    "codigo":25711000119105,
    "descripcion":"OBSTRUCCIÓN PROXIMAL DE TROMPA DE FALOPIO"
  },
  {
    "codigo":16000111000119105,
    "descripcion":"SÍNDROME DE IRIS EN MESETA DE AMBOS OJOS"
  },
  {
    "codigo":277168002,
    "descripcion":"DOLOR A LA PALPACIÓN EN EL CONDUCTO AUDITIVO AL TRACCIONAR EL PABELLÓN AURICULAR"
  },
  {
    "codigo":735920008,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA NEUROEPITELIAL DE CUERPO CILIAR"
  },
  {
    "codigo":373637000,
    "descripcion":"REFLUJO VESICOURETERORRENAL CONGÉNITO"
  },
  {
    "codigo":275333005,
    "descripcion":"LUXACIÓN DEL ASTRÁGALO"
  },
  {
    "codigo":177029008,
    "descripcion":"CHOQUE DE LA PUNTA PALPABLE"
  },
  {
    "codigo":732250002,
    "descripcion":"SÍNDROME DE CRANEOSINOSTOSIS Y APLASIA DE PERONÉ"
  },
  {
    "codigo":240730004,
    "descripcion":"HISTOPLASMOSIS CLÁSICA DISEMINADA AGUDA"
  },
  {
    "codigo":109658005,
    "descripcion":"EXTENSIÓN EXCESIVA DEL ARCO DENTAL"
  },
  {
    "codigo":11354005,
    "descripcion":"TUBERCULOSIS CUTÁNEA INDURATIVA"
  },
  {
    "codigo":76890007,
    "descripcion":"LACERACIÓN DE PULMÓN SIN HERIDA ABIERTA HACIA TÓRAX"
  },
  {
    "codigo":271663000,
    "descripcion":"DESDOBLAMIENTO DEL PRIMER RUIDO CARDÍACO"
  },
  {
    "codigo":207962009,
    "descripcion":"FRACTURA NO EXPUESTA DE VÉRTEBRA LUMBAR, APÓFISIS TRANSVERSA"
  },
  {
    "codigo":238895003,
    "descripcion":"LIPOATROFIA Y LIPODISTROFIA"
  },
  {
    "codigo":402735004,
    "descripcion":"TIC HABITUAL QUE AFECTA EL CABELLO"
  },
  {
    "codigo":1287471003,
    "descripcion":"ERUPCIÓN CUTÁNEA CAUSADA POR SALMONELLA PARATYPHI"
  },
  {
    "codigo":1156399006,
    "descripcion":"FRACTURA DE CUERNO MAYOR DE HUESO HIOIDES"
  },
  {
    "codigo":7684004,
    "descripcion":"DEREÍSMO"
  },
  {
    "codigo":1285636009,
    "descripcion":"HERIDA DE OÍDO EXTERNO POR MORDEDURA"
  },
  {
    "codigo":366297001,
    "descripcion":"REFLEJO DE CONGELAMIENTO - HALLAZGO"
  },
  {
    "codigo":38617005,
    "descripcion":"FOBIA DENTAL"
  },
  {
    "codigo":397230000,
    "descripcion":"ÚTERO Y ANEXOS COMPROMETIDOS POR EXTENSIÓN DIRECTA DE NEOPLASIA MALIGNA"
  },
  {
    "codigo":266158001,
    "descripcion":"INTERTRIGO CANDIDIÁSICO"
  },
  {
    "codigo":202457009,
    "descripcion":"REUMATISMO PALINDRÓMICO DE REGIÓN DE HOMBRO"
  },
  {
    "codigo":724910000,
    "descripcion":"LESIÓN TRAUMÁTICA DE TENDÓN A LA ALTURA DEL BRAZO"
  },
  {
    "codigo":429998004,
    "descripcion":"DEMENCIA VASCULAR"
  },
  {
    "codigo":69550000,
    "descripcion":"INFECCIÓN CAUSADA POR FASCIOLOIDES"
  },
  {
    "codigo":298926006,
    "descripcion":"ARTICULACIÓN DE CODO ESTABLE"
  },
  {
    "codigo":428163005,
    "descripcion":"HIPERTROFIA VENTRICULAR IZQUIERDA POR HIPERTENSIÓN"
  },
  {
    "codigo":360792001,
    "descripcion":"DEFICIENCIA DE FOSFATASA ALCALINA"
  },
  {
    "codigo":110141000119100,
    "descripcion":"ÚLCERA DE MIEMBRO INFERIOR DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":65880007,
    "descripcion":"AGAMMAGLOBULINEMIA LIGADA A CROMOSOMA X"
  },
  {
    "codigo":229720008,
    "descripcion":"DÉFICIT DE PROGRAMACIÓN FONOLÓGICA"
  },
  {
    "codigo":295256009,
    "descripcion":"SOBREDOSIS INTENCIONAL DE INDOMETACINA"
  },
  {
    "codigo":721240006,
    "descripcion":"MENINGITIS CAUSADA POR COCO AERÓBICO GRAMNEGATIVO"
  },
  {
    "codigo":162349004,
    "descripcion":"RUIDOS EN OÍDO"
  },
  {
    "codigo":719405005,
    "descripcion":"SÍNDROME DE LEUCOENCEFALOPATÍA CON CONDRODISPLASIA METAFISARIA"
  },
  {
    "codigo":293421006,
    "descripcion":"REACCIÓN ADVERSA AL ACIPIMOX"
  },
  {
    "codigo":62210001,
    "descripcion":"INTOXICACIÓN POR ARSÉNICO INORGÁNICO"
  },
  {
    "codigo":422658002,
    "descripcion":"CONJUNTIVA BLANCA Y NO INFLAMADA"
  },
  {
    "codigo":94978003,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE PÁNCREAS"
  },
  {
    "codigo":160514004,
    "descripcion":"ORIGEN AFRICANO"
  },
  {
    "codigo":28221000119103,
    "descripcion":"DOLOR DE MÚSCULO ABDOMINAL"
  },
  {
    "codigo":291586007,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR CEFUROXIMA"
  },
  {
    "codigo":289751006,
    "descripcion":"ÚTERO EN INVOLUCIÓN"
  },
  {
    "codigo":1010647007,
    "descripcion":"SÍNDROME VESTIBULAR AGUDO POR TRASTORNO VESTIBULAR EPISÓDICO"
  },
  {
    "codigo":191447007,
    "descripcion":"TRASTORNO PSICÓTICO DE ORIGEN ORGÁNICO"
  },
  {
    "codigo":93143009,
    "descripcion":"LEUCEMIA"
  },
  {
    "codigo":715735007,
    "descripcion":"DISOMÍA UNIPARENTAL MATERNA DE CROMOSOMA 20"
  },
  {
    "codigo":224215007,
    "descripcion":"VIVE EN UN HOSPEDAJE ALQUILADO NO AMUEBLADO"
  },
  {
    "codigo":25772007,
    "descripcion":"DEMENCIA MULTINFARTO CON IDEAS DELIRANTES"
  },
  {
    "codigo":255148008,
    "descripcion":"NEOPLASIA INTRAEPITELIAL DE PENE"
  },
  {
    "codigo":58540009,
    "descripcion":"ÁNTRAX DE DEDO PULGAR"
  },
  {
    "codigo":1172652009,
    "descripcion":"LIPOPROTEÍNA DENTRO DE RANGO DE REFERENCIA"
  },
  {
    "codigo":124076007,
    "descripcion":"PROTOPORFIRINA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1303724008,
    "descripcion":"FIBROADENOMA DE MAMA IZQUIERDA"
  },
  {
    "codigo":1269121005,
    "descripcion":"RABDOMIOSARCOMA METASTÁSICO"
  },
  {
    "codigo":286081007,
    "descripcion":"GUARDA LA ROPA LAVADA"
  },
  {
    "codigo":710230000,
    "descripcion":"SÍNDROME DEL OS PERONEUM DOLOROSO"
  },
  {
    "codigo":284246001,
    "descripcion":"INCAPAZ DE REALIZAR FUNCIONES CON LA MANO"
  },
  {
    "codigo":187777008,
    "descripcion":"NEOPLASIA MALIGNA DE CONDUCTO BILIAR INTRAHEPÁTICO"
  },
  {
    "codigo":251478003,
    "descripcion":"ESPIGAS MULTIFOCALES GENERALIZADAS"
  },
  {
    "codigo":253313009,
    "descripcion":"INTERRUPCIÓN DE LA VENA CAVA INFERIOR CON LA CONTINUACIÓN DE LA HEMIÁCIGOS IZQUIERDA"
  },
  {
    "codigo":448086006,
    "descripcion":"ATRESIA DE TRONCO PULMONAR CON ARTERIA PULMONAR IZQUIERDA AUSENTE"
  },
  {
    "codigo":249643003,
    "descripcion":"DESGARRO CICATRIZADO DEL ESFÍNTER ANAL"
  },
  {
    "codigo":446251006,
    "descripcion":"RATÓN PERITONEAL"
  },
  {
    "codigo":313344000,
    "descripcion":"DISPAREUNIA DE LA SUPERFICIE VULVAR"
  },
  {
    "codigo":329431000119105,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DEBIDO A OCLUSIÓN DE ARTERIA CEREBRAL POSTERIOR IZQUIERDA POR ÉMBOLO"
  },
  {
    "codigo":1263616002,
    "descripcion":"TRASTORNO FETAL DEBIDO A ESPASMO DEL ANILLO DE BANDL MATERNO"
  },
  {
    "codigo":247808006,
    "descripcion":"ANSIEDAD RELACIONADA CON LA FUNCIÓN O SALUD CORPORAL"
  },
  {
    "codigo":1163477006,
    "descripcion":"INFECCIÓN INTESTINAL POR CHLAMYDIA TRACHOMATIS"
  },
  {
    "codigo":737493007,
    "descripcion":"ALERGIA A DENOSUMAB"
  },
  {
    "codigo":735658005,
    "descripcion":"LESIÓN TRAUMÁTICA PERFORANTE DE AMBOS GLOBOS OCULARES"
  },
  {
    "codigo":78463001,
    "descripcion":"NECROSIS MASIVA DEL INTESTINO"
  },
  {
    "codigo":209535003,
    "descripcion":"DESGARRO PARCIAL DE LIGAMENTO INTERNO DE TOBILLO"
  },
  {
    "codigo":307839005,
    "descripcion":"VISTO POR UNA PERSONA"
  },
  {
    "codigo":373375007,
    "descripcion":"GRADO HISTOLÓGICO BIEN DIFERENCIADO - HALLAZGO"
  },
  {
    "codigo":240468001,
    "descripcion":"VARICELA NEUROLÓGICA"
  },
  {
    "codigo":11092001,
    "descripcion":"TAQUICARDIA SINUSAL"
  },
  {
    "codigo":15703921000119106,
    "descripcion":"CONTRACTURA DE MÚSCULO DE AMBOS BRAZOS"
  },
  {
    "codigo":76628006,
    "descripcion":"COREA POSTHEMIPLÉJICA"
  },
  {
    "codigo":699220008,
    "descripcion":"SABOR FANTASMA"
  },
  {
    "codigo":402473001,
    "descripcion":"HIPERTRIGLICERIDEMIA ESPORÁDICA PRIMARIA"
  },
  {
    "codigo":369705002,
    "descripcion":"BORDE DE TUMOR INVASOR"
  },
  {
    "codigo":11853681000119107,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA PARCIAL DE PIE IZQUIERDO"
  },
  {
    "codigo":238633006,
    "descripcion":"POROQUERATOSIS SUPERFICIAL DISEMINADA"
  },
  {
    "codigo":105726004,
    "descripcion":"HALLAZGO RELACIONADO CON LA EDAD Y\/O CON EL CRECIMIENTO"
  },
  {
    "codigo":300499002,
    "descripcion":"MASA DE EPIDÍDIMO"
  },
  {
    "codigo":5587004,
    "descripcion":"DISTROFIA CORNEAL"
  },
  {
    "codigo":890323004,
    "descripcion":"COLAGENOMA ERUPTIVO"
  },
  {
    "codigo":202195006,
    "descripcion":"LUXACIÓN PATOLÓGICA DE ARTICULACIÓN TARSOMETATARSIANA"
  },
  {
    "codigo":234963006,
    "descripcion":"AMELOGÉNESIS IMPERFECTA, VARIANTE HIPOPLÁSICA AUTOSÓMICA DOMINANTE CON SUPERFICIE DENTAL RUGOSA"
  },
  {
    "codigo":69288002,
    "descripcion":"FACIES DE DUENDE"
  },
  {
    "codigo":3752003,
    "descripcion":"TRICHURIASIS"
  },
  {
    "codigo":36520004,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO DE OÍDO"
  },
  {
    "codigo":822952005,
    "descripcion":"CON RIESGO AUMENTADO DE ADMISIÓN HOSPITALARIA DE URGENCIA"
  },
  {
    "codigo":298664005,
    "descripcion":"AMPLITUD DE ROTACIÓN PASIVA HACIA LA IZQUIERDA DE LA COLUMNA LUMBAR AUMENTADA"
  },
  {
    "codigo":724648008,
    "descripcion":"LINFOMA PLASMABLÁSTICO"
  },
  {
    "codigo":722813003,
    "descripcion":"DISTENSIÓN DE TENDÓN DE MUÑECA"
  },
  {
    "codigo":360530005,
    "descripcion":"MIELOSQUISIS"
  },
  {
    "codigo":720978005,
    "descripcion":"TRASTORNO CONGÉNITO DE GLICOSILACIÓN 9 VINCULADO A ASPARAGINA"
  },
  {
    "codigo":131154005,
    "descripcion":"GRUPO SANGUÍNEO A>Y<"
  },
  {
    "codigo":294994008,
    "descripcion":"ALERGIA A CICLOPENTIAZIDA"
  },
  {
    "codigo":63783001,
    "descripcion":"BRAQUIGNATISMO"
  },
  {
    "codigo":1179730008,
    "descripcion":"REACCIÓN ADVERSA A CASIRIVIMAB"
  },
  {
    "codigo":719143004,
    "descripcion":"CAPAZ DE SENTIRSE ESPERANZADO POR EL FUTURO"
  },
  {
    "codigo":293159007,
    "descripcion":"REACCIÓN ADVERSA A LA CORTISONA"
  },
  {
    "codigo":94716000,
    "descripcion":"LEUCEMIA MIELOIDE EN REMISIÓN"
  },
  {
    "codigo":1208828000,
    "descripcion":"AVULSIÓN TRAUMÁTICA DE CANTO LATERAL DE OJO"
  },
  {
    "codigo":31015008,
    "descripcion":"SÍFILIS ANAL PRIMARIA"
  },
  {
    "codigo":225788005,
    "descripcion":"RUTINA DIARIA REGULAR"
  },
  {
    "codigo":141631000119100,
    "descripcion":"SOFOCO EN EL HOMBRE"
  },
  {
    "codigo":1338065001,
    "descripcion":"IRITIS RECURRENTE"
  },
  {
    "codigo":125649002,
    "descripcion":"HERIDA ABIERTA DEL ANTEBRAZO"
  },
  {
    "codigo":289489002,
    "descripcion":"HALLAZGO RELACIONADO CON SECRECIÓN DE LA VULVA"
  },
  {
    "codigo":60113004,
    "descripcion":"TRASTORNO DE PÁRPADO"
  },
  {
    "codigo":92881008,
    "descripcion":"FUSIÓN ANORMAL CONGÉNITA DEL ANILLO TIMPÁNICO"
  },
  {
    "codigo":713638002,
    "descripcion":"ÚLCERA GÁSTRICA CAUSADA POR FÁRMACO"
  },
  {
    "codigo":1336230004,
    "descripcion":"TRASTORNO POR USO DE ANSIOLÍTICO"
  },
  {
    "codigo":254886006,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS DE CUELLO UTERINO"
  },
  {
    "codigo":1303462007,
    "descripcion":"GLAUCOMA DE ÁNGULO ABIERTO BILATERAL DEBIDO A TRASTORNO VASCULAR"
  },
  {
    "codigo":1172390008,
    "descripcion":"TESTOSTERONA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":123814009,
    "descripcion":"INSUFICIENCIA DE ESTRONCIO"
  },
  {
    "codigo":89211009,
    "descripcion":"DIETA ESTRICTA"
  },
  {
    "codigo":87376003,
    "descripcion":"FRACTURA NO EXPUESTA DE DIÁFISIS DE CLAVÍCULA"
  },
  {
    "codigo":447824005,
    "descripcion":"ANOMALÍA CONGÉNITA DE AURÍCULA IZQUIERDA"
  },
  {
    "codigo":20005002,
    "descripcion":"CARDIOPATÍA REUMÁTICA RECURRENTE"
  },
  {
    "codigo":282149002,
    "descripcion":"CAPAZ DE CAMINAR SOBRE UNA SUPERFICIE PLANA"
  },
  {
    "codigo":249381004,
    "descripcion":"HALLAZGO RELACIONADO CON LA SIMETRÍA DE LA LENGUA"
  },
  {
    "codigo":413221004,
    "descripcion":"MUCOSA GÁSTRICA ECTÓPICA - MÚLTIPLES LOCALIZACIONES"
  },
  {
    "codigo":247546006,
    "descripcion":"PELO FINO"
  },
  {
    "codigo":15679961000119104,
    "descripcion":"CONJUNTIVITIS PRIMAVERAL DE OJO DERECHO"
  },
  {
    "codigo":737231005,
    "descripcion":"HEMORRAGIA TRAUMÁTICA DE TÁLAMO"
  },
  {
    "codigo":1163215007,
    "descripcion":"LESIÓN POR PRESIÓN"
  },
  {
    "codigo":276644000,
    "descripcion":"SOBREHIDRATACIÓN NEONATAL"
  },
  {
    "codigo":473252001,
    "descripcion":"QUEMADURA DE MÚLTIPLES SITIOS DE LA CARA SIN COMPROMISO DEL OJO PROPIAMENTE DICHO"
  },
  {
    "codigo":1259684001,
    "descripcion":"CARCINOMA PRIMARIO DE CÉLULAS RENALES QUÍSTICAS DE RIÑÓN"
  },
  {
    "codigo":243876005,
    "descripcion":"SITUACIÓN DE CRIBADO"
  },
  {
    "codigo":702628006,
    "descripcion":"ANOMALÍA CONGÉNITA DE CEREBRO"
  },
  {
    "codigo":211108007,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN GLÚTEO"
  },
  {
    "codigo":209273000,
    "descripcion":"FRACTURA-LUXACIÓN EXPUESTA DE LA MUÑECA"
  },
  {
    "codigo":405881004,
    "descripcion":"FENOTIPO M+N-"
  },
  {
    "codigo":307577005,
    "descripcion":"HALLAZGO RELACIONADO CON LA PRUEBA DE HEAF"
  },
  {
    "codigo":688601000119108,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS INTRAEPIDÉRMICO DE CUELLO"
  },
  {
    "codigo":830030000,
    "descripcion":"QUISTE DERMOIDE DE ÓRBITA DERECHA PROPIAMENTE DICHA"
  },
  {
    "codigo":76366001,
    "descripcion":"ANEMIA HEMOLÍTICA CAUSADA POR BARTONELLA"
  },
  {
    "codigo":240206002,
    "descripcion":"HIPERTROFIA SINOVIAL"
  },
  {
    "codigo":698958008,
    "descripcion":"DELIRIO EN REMISIÓN"
  },
  {
    "codigo":404046008,
    "descripcion":"LEIOMIOSARCOMA MIXOIDE DE PIEL"
  },
  {
    "codigo":762659002,
    "descripcion":"RUPTURA DE AISLAMIENTO DE DERIVACIÓN DE DESFIBRILADOR CARDÍACO IMPLANTABLE"
  },
  {
    "codigo":97991000146107,
    "descripcion":"PORTADOR DE STREPTOCOCCUS PNEUMONIAE RESISTENTE A MÚLTIPLES FÁRMACOS"
  },
  {
    "codigo":305742009,
    "descripcion":"ATENDIDO POR ENFERMERA DE CUIDADOS DE LINFEDEMA"
  },
  {
    "codigo":8995005,
    "descripcion":"INTOXICACIÓN POR CLORPROPAMIDA"
  },
  {
    "codigo":271139007,
    "descripcion":"AMPOLLA TRAUMÁTICA DEL ANO, INFECTADA"
  },
  {
    "codigo":269304002,
    "descripcion":"PERFORACIÓN ACCIDENTAL DE ÓRGANO DURANTE PROCEDIMIENTO"
  },
  {
    "codigo":433144002,
    "descripcion":"ENFERMEDAD RENAL CRÓNICA, ESTADIO 3"
  },
  {
    "codigo":302072004,
    "descripcion":"DOLOR EN LA GLÁNDULA TIROIDES"
  },
  {
    "codigo":11803251000119106,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN METACARPOFALÁNGICA DE DEDO MEÑIQUE DERECHO"
  },
  {
    "codigo":10738291000119106,
    "descripcion":"HIPERPLASIA ENDOMETRIAL COMPLEJA SIN ATIPIA"
  },
  {
    "codigo":726221001,
    "descripcion":"DISTENSIÓN DE TENDÓN DE MÚSCULO DE LA CADERA"
  },
  {
    "codigo":50080221000188107,
    "descripcion":"OPIÁCEO DETECTADO POR SCREENING"
  },
  {
    "codigo":431309003,
    "descripcion":"INFECCIÓN AGUDA DEL TRACTO URINARIO"
  },
  {
    "codigo":300237004,
    "descripcion":"PROBLEMA DENTAL"
  },
  {
    "codigo":298402001,
    "descripcion":"HALLAZGO RELACIONADO CON EL MOVIMIENTO DEL CUELLO"
  },
  {
    "codigo":724386005,
    "descripcion":"LESIÓN DE GENITALES"
  },
  {
    "codigo":296567000,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE QUININA"
  },
  {
    "codigo":427639003,
    "descripcion":"INTOXICACIÓN POR AZASPIRÁCIDO"
  },
  {
    "codigo":165495004,
    "descripcion":"AUTOAGLUTINACIÓN DE ERITROCITOS"
  },
  {
    "codigo":394871007,
    "descripcion":"PIENSA DEJAR DE FUMAR"
  },
  {
    "codigo":294732000,
    "descripcion":"ALERGIA A GLIBORNURIDA"
  },
  {
    "codigo":722551008,
    "descripcion":"SECUELA DE INFECCIÓN CAUSADA POR CORYNEBACTERIUM"
  },
  {
    "codigo":62221000119105,
    "descripcion":"RETARDO SEVERO DEL LENGUAJE EXPRESIVO"
  },
  {
    "codigo":292897001,
    "descripcion":"REACCIÓN ADVERSA A LA CETRIMIDA"
  },
  {
    "codigo":30753002,
    "descripcion":"HIDROCEFALIA NORMOTENSA"
  },
  {
    "codigo":16665511000119101,
    "descripcion":"FRACTURA EXPUESTA POR ESTALLIDO DEL PISO ORBITARIO DERECHO"
  },
  {
    "codigo":718881004,
    "descripcion":"SÍNDROME DE DUPLICACIÓN CROMOSÓMICA XQ27.3Q28"
  },
  {
    "codigo":161825005,
    "descripcion":"APETITO NORMAL"
  },
  {
    "codigo":1144865006,
    "descripcion":"HIPOPLASIA CONGÉNITA DE LABIO GENITAL"
  },
  {
    "codigo":129057007,
    "descripcion":"ASISTENCIA PARA LA PREPARACIÓN DE LAS COMIDAS"
  },
  {
    "codigo":423969008,
    "descripcion":"INFECCIÓN DISEMINADA POR MYCOBACTERIUM GORDONAE"
  },
  {
    "codigo":94454001,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA OROFARINGE"
  },
  {
    "codigo":1306870001,
    "descripcion":"SOSPECHA DE GLAUCOMA DE OJO DERECHO"
  },
  {
    "codigo":717046003,
    "descripcion":"HIPERINSULINISMO AUTOSÓMICO DOMINANTE DEBIDO A DEFICIENCIA DE SUR1"
  },
  {
    "codigo":291062001,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR CLOBAZAM"
  },
  {
    "codigo":11832231000119103,
    "descripcion":"LESIÓN TRAUMÁTICA DE VASO SANGUÍNEO DE DEDO MEDIO DE MANO IZQUIERDA"
  },
  {
    "codigo":190923000,
    "descripcion":"AMILOIDOSIS ESPORÁDICA PRIMARIA"
  },
  {
    "codigo":225526009,
    "descripcion":"SE ALIMENTA DE MANERA IRREGULAR"
  },
  {
    "codigo":289227000,
    "descripcion":"NO PUJA EFICAZMENTE DURANTE EL TRABAJO DE PARTO"
  },
  {
    "codigo":92619003,
    "descripcion":"CARCINOMA IN SITU DE LOS ISLOTES DE LANGERHANS"
  },
  {
    "codigo":416629001,
    "descripcion":"PACIENTE INCAPAZ DE COMUNICARSE CON EL MÉDICO FUERA DEL HORARIO DE ATENCIÓN"
  },
  {
    "codigo":254624009,
    "descripcion":"NEOPLASIA DE PARÉNQUIMA PULMONAR"
  },
  {
    "codigo":336961000119101,
    "descripcion":"PROLAPSO DE VÍTREO DE OJO IZQUIERDO"
  },
  {
    "codigo":187253003,
    "descripcion":"EFECTOS TARDÍOS POR TUBERCULOSIS EN EL SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":711541005,
    "descripcion":"EMPALAMIENTO DE CUERPO EXTRAÑO EN EL DORSO"
  },
  {
    "codigo":1137525005,
    "descripcion":"CALCIFICACIÓN PUNTEADA DE EPÍFISIS DE FALANGE DISTAL DE TERCER DEDO DE PIE"
  },
  {
    "codigo":285557003,
    "descripcion":"NO MANTIENE LA ELEVACIÓN DEL PALADAR BLANDO"
  },
  {
    "codigo":16010151000119108,
    "descripcion":"ARTRITIS REACTIVA DE AMBAS ARTICULACIONES DE CADERA"
  },
  {
    "codigo":23413007,
    "descripcion":"ACOSO SEXUAL POR PARTE DE UNA MUJER"
  },
  {
    "codigo":283722002,
    "descripcion":"MORDEDURA HUMANA EN EL MUSLO"
  },
  {
    "codigo":1332298007,
    "descripcion":"GLAUCOMA DE OJO DERECHO DEBIDO A LESIÓN PERFORANTE DE GLOBO OCULAR DERECHO Y POSTERIOR A ELLA"
  },
  {
    "codigo":185418009,
    "descripcion":"MÉTODO PARA CITA ESTABLECIDO"
  },
  {
    "codigo":1363231001,
    "descripcion":"CICATRIZACIÓN DE PÁRPADOS SUPERIOR E INFERIOR"
  },
  {
    "codigo":314655003,
    "descripcion":"PERÍMETRO CEFÁLICO DEL NIÑO: PERCENTILO 76-90"
  },
  {
    "codigo":609567009,
    "descripcion":"DIABETES MELLITUS TIPO 2 PREEXISTENTE EN EL EMBARAZO"
  },
  {
    "codigo":312820003,
    "descripcion":"TUMOR TENOSINOVIAL DE CÉLULAS GIGANTES DIFUSO DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":247284004,
    "descripcion":"AUDICIÓN SENSITIVA"
  },
  {
    "codigo":443892003,
    "descripcion":"NEUROMA"
  },
  {
    "codigo":442057004,
    "descripcion":"TRASTORNO CRÓNICO DE PERSONALIDAD DEPRESIVA"
  },
  {
    "codigo":702366001,
    "descripcion":"ESPECTRO DE MIOCEREBROHEPATOPATÍA INFANTIL"
  },
  {
    "codigo":276382003,
    "descripcion":"RUIDOS HIDROAÉREOS AUMENTADOS"
  },
  {
    "codigo":472990007,
    "descripcion":"DESARROLLO NORMAL DE LA SEXUALIDAD"
  },
  {
    "codigo":210846008,
    "descripcion":"LESIÓN DEL ARCO PALMAR SUPERFICIAL"
  },
  {
    "codigo":209011000,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE LA ARTICULACIÓN SUBASTRAGALINA"
  },
  {
    "codigo":1259422008,
    "descripcion":"CARCINOMA PRIMARIO DE MAMA - PROLONGACIÓN AXILAR"
  },
  {
    "codigo":241779002,
    "descripcion":"INTOXICACIÓN POR AMANITA PANTHERINA"
  },
  {
    "codigo":77939001,
    "descripcion":"RETINOCOROIDITIS DISEMINADA SIFILÍTICA"
  },
  {
    "codigo":307315005,
    "descripcion":"RUPTURA DE ARTERIA FEMORAL"
  },
  {
    "codigo":733299005,
    "descripcion":"LUXACIÓN TRAUMÁTICA ANTERIOR DE ARTICULACIÓN TIBIOFEMORAL"
  },
  {
    "codigo":12403008,
    "descripcion":"HIPERNATREMIA CRÓNICA"
  },
  {
    "codigo":403784003,
    "descripcion":"ENFERMEDAD DE DARIER HIPERTRÓFICA"
  },
  {
    "codigo":698696007,
    "descripcion":"TRASTORNO DE ADAPTACIÓN CON ESTADO DE ÁNIMO DEPRIMIDO EN REMISIÓN"
  },
  {
    "codigo":239944008,
    "descripcion":"VASCULITIS POR LUPUS"
  },
  {
    "codigo":305480009,
    "descripcion":"BAJO ATENCIÓN DE FISIÓLOGO CLÍNICO"
  },
  {
    "codigo":1255752007,
    "descripcion":"MICOSIS FUNGOIDE DE GANGLIOS LINFÁTICOS DE CABEZA"
  },
  {
    "codigo":41501003,
    "descripcion":"AMENAZA DE SUICIDIO"
  },
  {
    "codigo":238109004,
    "descripcion":"KWASHIORKOR MARÁSMICO"
  },
  {
    "codigo":10568008,
    "descripcion":"FRACTURA EXPUESTA DE OCHO COSTILLAS O MÁS"
  },
  {
    "codigo":8733006,
    "descripcion":"PERITONITIS SUPURATIVA AGUDA"
  },
  {
    "codigo":762397008,
    "descripcion":"SENSACIÓN DE ARDOR EN LA PIEL"
  },
  {
    "codigo":39666001,
    "descripcion":"SECRECIÓN ANORMAL DEL INTESTINO DELGADO"
  },
  {
    "codigo":203506002,
    "descripcion":"CUERPO EXTRAÑO RESIDUAL EN HUESO"
  },
  {
    "codigo":170738003,
    "descripcion":"EFECTO COLATERAL DE FÁRMACO ANTIGOTOSO"
  },
  {
    "codigo":1284850005,
    "descripcion":"ENFERMEDAD PULMONAR INTERSTICIAL DEBIDA A RADIOTERAPIA Y POSTERIOR A ELLA"
  },
  {
    "codigo":267207004,
    "descripcion":"TRASTORNOS CARDIOVASCULARES CONGÉNITOS DURANTE EL EMBARAZO, EL NACIMIENTO Y EL PUERPERIO"
  },
  {
    "codigo":37831005,
    "descripcion":"FÍSTULA GASTROINTESTINAL"
  },
  {
    "codigo":365511007,
    "descripcion":"APTO PARA RECIBIR ALOJAMIENTO - HALLAZGO"
  },
  {
    "codigo":15930741000119105,
    "descripcion":"NEOPLASIA BENIGNA DE AMBOS OVARIOS"
  },
  {
    "codigo":789660001,
    "descripcion":"SÍNDROME URÉMICO HEMOLÍTICO ATÍPICO"
  },
  {
    "codigo":38261000119106,
    "descripcion":"INFECCIÓN DEL TRACTO GENITAL DEBIDA A INTERRUPCIÓN INDUCIDA DEL EMBARAZO INCOMPLETA"
  },
  {
    "codigo":68764005,
    "descripcion":"TABOPARÁLISIS JUVENIL"
  },
  {
    "codigo":298140008,
    "descripcion":"UÑA, AUSENTE"
  },
  {
    "codigo":66929000,
    "descripcion":"ESTRECHEZ BILIAR POSTOPERATORIA"
  },
  {
    "codigo":1393001,
    "descripcion":"SÍNDROME DE HIPEROSTOSIS DE LENZ - MAJEWSKI"
  },
  {
    "codigo":3228009,
    "descripcion":"FRACTURA NO EXPUESTA DE DIÁFISIS DE RADIO"
  },
  {
    "codigo":165233007,
    "descripcion":"VEJIGA: ACCIDENTE OCASIONAL"
  },
  {
    "codigo":230769007,
    "descripcion":"LEUCOMALACIA PERIVENTRICULAR"
  },
  {
    "codigo":294470002,
    "descripcion":"ALERGIA A TOBRAMICINA"
  },
  {
    "codigo":10743311000119103,
    "descripcion":"CUTIS LAXO DE AMBOS PÁRPADOS SUPERIORES"
  },
  {
    "codigo":720454007,
    "descripcion":"EPISODIO ÚNICO DE DEPRESIÓN MAYOR MÍNIMA"
  },
  {
    "codigo":65094009,
    "descripcion":"SÍNDROME DE MALFORMACIONES MÚLTIPLES CON ANOMALÍAS FACIALES COMO CARACTERÍSTICA PRINCIPAL"
  },
  {
    "codigo":30491001,
    "descripcion":"TRASTORNO DELUSORIO POR COCAÍNA"
  },
  {
    "codigo":292635008,
    "descripcion":"REACCIÓN ADVERSA AL ICTAMOL"
  },
  {
    "codigo":192496000,
    "descripcion":"CAMBIO DE LA PERSONALIDAD DURADERO NO ORGÁNICO"
  },
  {
    "codigo":290800001,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR PROFENAMINA"
  },
  {
    "codigo":126960003,
    "descripcion":"NEOPLASIA DEL CEREBELO"
  },
  {
    "codigo":61424003,
    "descripcion":"ENFERMEDAD DE CROHN DEL PÍLORO"
  },
  {
    "codigo":1306608005,
    "descripcion":"NEUMONITIS POR ASPIRACIÓN RECURRENTE"
  },
  {
    "codigo":28656008,
    "descripcion":"INSUFICIENCIA CONGÉNITA DE VÁLVULA AÓRTICA"
  },
  {
    "codigo":125125001,
    "descripcion":"PESO DE ÓRGANO, ANORMAL"
  },
  {
    "codigo":94192008,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE VASO SANGUÍNEO DE DEDO DE LA MANO"
  },
  {
    "codigo":190661004,
    "descripcion":"DEFICIENCIA ALIMENTARIA DE CINC"
  },
  {
    "codigo":288965006,
    "descripcion":"INICIA EL REFLEJO DE DEGLUCIÓN"
  },
  {
    "codigo":878789008,
    "descripcion":"INGESTA ENERGÉTICA INADECUADA"
  },
  {
    "codigo":92357008,
    "descripcion":"NEOPLASIA BENIGNA DE LA PIEL DE LAS CEJAS"
  },
  {
    "codigo":88687001,
    "descripcion":"NEUMONITIS POR MANGANESO"
  },
  {
    "codigo":124595008,
    "descripcion":"DEFICIENCIA DE ASPARTATO 4 - DESCARBOXILASA"
  },
  {
    "codigo":285295007,
    "descripcion":"FANTASÍA PORNOGRÁFICA"
  },
  {
    "codigo":840516000,
    "descripcion":"NEOPLASIA MALIGNA MIXTA COMPLEJA Y DEL ESTROMA DE ENDOMETRIO DE CUERPO UTERINO"
  },
  {
    "codigo":449135007,
    "descripcion":"ESTENOSIS CONGÉNITA DE APARATO SUBVALVULAR MITRAL"
  },
  {
    "codigo":11781801000119106,
    "descripcion":"LESIÓN TRAUMÁTICA DE VASO SANGUÍNEO DE MUSLO DERECHO"
  },
  {
    "codigo":54084005,
    "descripcion":"LINFADENITIS TUBERCULOSA CERVICAL"
  },
  {
    "codigo":283460005,
    "descripcion":"HERIDA PUNZANTE EN EL HOMBRO"
  },
  {
    "codigo":21316006,
    "descripcion":"LESIÓN TRAUMÁTICA DE TOBILLO EN SUPINACIÓN-EVERSIÓN, GRADO 1"
  },
  {
    "codigo":707609006,
    "descripcion":"SÍNDROME DE INCISIVO CENTRAL MAXILAR MEDIO ÚNICO"
  },
  {
    "codigo":248857006,
    "descripcion":"SECCIÓN DE HIMEN"
  },
  {
    "codigo":50414000,
    "descripcion":"LEISHMANIASIS CUTÁNEA TARDÍA"
  },
  {
    "codigo":1197294001,
    "descripcion":"MELANOMA MALIGNO ORIGINADO EN NEVO MELANOCÍTICO"
  },
  {
    "codigo":1230062001,
    "descripcion":"ATRESIA CONGÉNITA DE VENA CAVA INFERIOR SIN CONTINUACIÓN POR VENA ÁCIGOS"
  },
  {
    "codigo":738542003,
    "descripcion":"METABOLIZADOR LENTO DE DIHIDROPIRIMIDINA DESHIDROGENASA"
  },
  {
    "codigo":441795000,
    "descripcion":"SEROMA INFECTADO DESPUÉS DE PROCEDIMIENTO QUIRÚRGICO"
  },
  {
    "codigo":439960005,
    "descripcion":"TRASTORNO ALIMENTARIO POR ATRACÓN"
  },
  {
    "codigo":1079261000119100,
    "descripcion":"NEOPLASIA BENIGNA DE OMÓPLATO IZQUIERDO"
  },
  {
    "codigo":308888007,
    "descripcion":"FILTRACIÓN DE BILIS POSREMOCIÓN DE SONDA EN T"
  },
  {
    "codigo":733037000,
    "descripcion":"SÍNDROME DE GERMAN"
  },
  {
    "codigo":700269001,
    "descripcion":"LUPUS ERITEMATOSO DISCOIDE DE PÁRPADO INFERIOR"
  },
  {
    "codigo":208749002,
    "descripcion":"SUBLUXACIÓN NO EXPUESTA DE MANDÍBULA"
  },
  {
    "codigo":1290093003,
    "descripcion":"SÍNDROME VEXAS"
  },
  {
    "codigo":405357004,
    "descripcion":"MEZCLA DE GASES HIPÓXICOS"
  },
  {
    "codigo":12141009,
    "descripcion":"DETERMINACIÓN DEL RESULTADO: MUERTE EVITABLE"
  },
  {
    "codigo":403522004,
    "descripcion":"MORFEA SUBCUTÁNEA"
  },
  {
    "codigo":341981000119103,
    "descripcion":"DEFECTO ARQUEADO DE CAMPO VISUAL DE OJO IZQUIERDO"
  },
  {
    "codigo":74007000,
    "descripcion":"TRASTORNO DE LA EXCITACIÓN SEXUAL"
  },
  {
    "codigo":237847005,
    "descripcion":"ACIDOSIS HIPERPOTASÉMICA"
  },
  {
    "codigo":303383008,
    "descripcion":"CAPAZ DE CAMBIAR DE POSICIÓN"
  },
  {
    "codigo":301548001,
    "descripcion":"DIFICULTAD PARA LLEGAR HASTA EL INODORO"
  },
  {
    "codigo":6636004,
    "descripcion":"TRASTORNO CARDIOVASCULAR CONGÉNITO EN LA MADRE QUE COMPLICA EL EMBARAZO, EL PARTO Y\/O EL PUERPERIO"
  },
  {
    "codigo":236012005,
    "descripcion":"PSEUDOQUISTE PERITONEAL"
  },
  {
    "codigo":266945001,
    "descripcion":"ROMPIÓ CON SU PAREJA"
  },
  {
    "codigo":135873002,
    "descripcion":"PARESTESIA TRANSITORIA"
  },
  {
    "codigo":598091000005102,
    "descripcion":"CONSUMIDORA DE NICOTINA ANTES DE CONFIRMACIÓN DE EMBARAZO"
  },
  {
    "codigo":365249007,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA PREPARAR ALIMENTOS PARA COMER"
  },
  {
    "codigo":234177008,
    "descripcion":"AUMENTO DE PESO EXCESIVO ENTRE DIÁLISIS"
  },
  {
    "codigo":363414004,
    "descripcion":"NEOPLASIA MALIGNA DE UNIÓN RECTOSIGMOIDEA"
  },
  {
    "codigo":723862008,
    "descripcion":"ATEROSCLEROSIS DE INJERTO-PUENTE NO AUTÓLOGO DE ARTERIA CORONARIA"
  },
  {
    "codigo":296043000,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE BUTABARBITAL"
  },
  {
    "codigo":197739000,
    "descripcion":"TRASTORNOS GLOMERULARES EN LAS HEMOPATÍAS Y EN LOS TRASTORNOS QUE COMPROMETEN AL MECANISMO INMUNOLÓGICO"
  },
  {
    "codigo":1131009,
    "descripcion":"INSUFICIENCIA VALVULAR CONGÉNITA"
  },
  {
    "codigo":263275009,
    "descripcion":"CONCUSIÓN DE LIGAMENTO PERIODONTAL"
  },
  {
    "codigo":722027009,
    "descripcion":"SÍNDROME DE KALLMAN CON CARDIOPATÍA"
  },
  {
    "codigo":32064003,
    "descripcion":"AMPOLLA DEL FLANCO, SIN INFECCIÓN"
  },
  {
    "codigo":785728005,
    "descripcion":"BRONQUITIS CONCOMITANTE CON SIBILANCIAS"
  },
  {
    "codigo":195904005,
    "descripcion":"NEUMONÍA CON COCCIDIOIDOMICOSIS"
  },
  {
    "codigo":230507009,
    "descripcion":"NEURITIS RETROBULBAR"
  },
  {
    "codigo":292373000,
    "descripcion":"REACCIÓN ADVERSA A LA LOXAPINA"
  },
  {
    "codigo":294208006,
    "descripcion":"ALERGIA A ETRETINATO"
  },
  {
    "codigo":1144341001,
    "descripcion":"HIPOPLASIA DE DIENTE"
  },
  {
    "codigo":423445003,
    "descripcion":"DIFICULTAD PARA CUMPLIR UNA DIETA PRENATAL"
  },
  {
    "codigo":64832003,
    "descripcion":"VASCULITIS NEUTRÓFILA DE LA PIEL"
  },
  {
    "codigo":194069005,
    "descripcion":"TRASTORNO DE CORTEZA VISUAL POR VASCULOPATÍA"
  },
  {
    "codigo":16371831000119108,
    "descripcion":"RASGO DE DELTA BETA TALASEMIA"
  },
  {
    "codigo":28394000,
    "descripcion":"ENCEFALOPATÍA TÓXICA"
  },
  {
    "codigo":126698000,
    "descripcion":"NEOPLASIA DE CUERDA VOCAL FALSA"
  },
  {
    "codigo":128533009,
    "descripcion":"MICROPAPILA"
  },
  {
    "codigo":30229009,
    "descripcion":"HIPOTIROIDISMO SECUNDARIO A ENFERMEDAD INFILTRATIVA"
  },
  {
    "codigo":15690001000119102,
    "descripcion":"ARTRITIS DE ARTICULACIONES DE AMBAS MANOS CAUSADA POR STAPHYLOCOCCUS"
  },
  {
    "codigo":290538007,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR PRILOCAÍNA"
  },
  {
    "codigo":716522008,
    "descripcion":"PRUEBA DE LAS REGLAS DE OTTAWA PARA TOBILLO POSITIVA"
  },
  {
    "codigo":93930008,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL NERVIO OLFATORIO"
  },
  {
    "codigo":92095007,
    "descripcion":"NEOPLASIA BENIGNA DEL HOCICO DE TENCA"
  },
  {
    "codigo":288703009,
    "descripcion":"SE COMUNICA EN DIFERENTES LUGARES"
  },
  {
    "codigo":186729003,
    "descripcion":"INFECCIÓN CLAMIDIAL DE LAS VÍAS GENITOURINARIAS INFERIORES"
  },
  {
    "codigo":88425004,
    "descripcion":"ANOMALÍA CONGÉNITA DEL SISTEMA NERVIOSO"
  },
  {
    "codigo":217662002,
    "descripcion":"ENVENENAMIENTO CAUSADO POR VENENO DE SERPIENTE MOCASÍN DE AGUA"
  },
  {
    "codigo":283198004,
    "descripcion":"ANZUELO EN EL CODO"
  },
  {
    "codigo":184894007,
    "descripcion":"INFORME DE APTITUD PARA CONDUCIR ENVIADO"
  },
  {
    "codigo":281363001,
    "descripcion":"TOFO GOTOSO DE TENDÓN"
  },
  {
    "codigo":1231635002,
    "descripcion":"DESVIACIÓN SOSTENIDA DE MIRADA DESCENDENTE"
  },
  {
    "codigo":37931000087100,
    "descripcion":"ACINESIA DE MIOCARDIO DE REGIÓN ANTERIOR DE VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":43051000087101,
    "descripcion":"HEMATOMA DE DEDO MEÑIQUE IZQUIERDO"
  },
  {
    "codigo":48171000087100,
    "descripcion":"FRACTURA DE PRIMER HUESO METATARSIANO DE PIE DERECHO"
  },
  {
    "codigo":51987004,
    "descripcion":"DESPRENDIMIENTO RETINIANO SIN DEFECTO DE LA RETINA"
  },
  {
    "codigo":248595008,
    "descripcion":"HALLAZGO RELACIONADO CON EL ESPUTO"
  },
  {
    "codigo":707347009,
    "descripcion":"CARCINOMA PRIMARIO DE SENO MAXILAR"
  },
  {
    "codigo":40491000087107,
    "descripcion":"CUERPO EXTRAÑO EN ANTEBRAZO DERECHO"
  },
  {
    "codigo":35371000087109,
    "descripcion":"FUMADOR OCASIONAL DE CIGARRILLO ELECTRÓNICO"
  },
  {
    "codigo":17384006,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN DEDO DEL PIE, CON INFECCIÓN"
  },
  {
    "codigo":1197032007,
    "descripcion":"GRANULOMA GINGIVAL PIÓGENO DISEMINADO"
  },
  {
    "codigo":344491000119107,
    "descripcion":"GLAUCOMA PIGMENTARIO BILATERAL"
  },
  {
    "codigo":1081771000119107,
    "descripcion":"SEMINOMA PRIMARIO DE TESTÍCULO IZQUIERDO DESCENDIDO"
  },
  {
    "codigo":408765004,
    "descripcion":"AMPOLLA FILTRANTE PERMEABLE"
  },
  {
    "codigo":1258898000,
    "descripcion":"TRASTORNO MENTAL DURANTE EL PUERPERIO"
  },
  {
    "codigo":439698008,
    "descripcion":"TROMBOFILIA HEREDITARIA"
  },
  {
    "codigo":44647001,
    "descripcion":"ARTERIA HIALOIDE PERSISTENTE"
  },
  {
    "codigo":110183007,
    "descripcion":"QUEMADURA EPIDÉRMICA DE FRENTE"
  },
  {
    "codigo":75580000,
    "descripcion":"LUXACIÓN EXPUESTA DE EXTREMO DISTAL DE LA TIBIA"
  },
  {
    "codigo":208487009,
    "descripcion":"FRACTURA EXPUESTA DE FALANGE MEDIA DE DEDO DE LA MANO, CABEZA"
  },
  {
    "codigo":370492003,
    "descripcion":"HEPATITIS ASOCIADA A ALMACENAMIENTO DE COBRE"
  },
  {
    "codigo":1156924004,
    "descripcion":"INMUNE AL TÉTANOS"
  },
  {
    "codigo":403260007,
    "descripcion":"HIPERMELANOSIS DE ETIOLOGÍA NO DETERMINADA"
  },
  {
    "codigo":237585001,
    "descripcion":"ANOMALÍA DE LA SECRECIÓN DEL PÉPTIDO INHIBIDOR GÁSTRICO"
  },
  {
    "codigo":8209004,
    "descripcion":"MIOCARDIOPATÍA DILATADA DEBIDA A HEMOCROMATOSIS"
  },
  {
    "codigo":1220625008,
    "descripcion":"INTERRUPCIÓN INDUCIDA DEL EMBARAZO INCOMPLETA COMPLICADA POR TRASTORNO METABÓLICO"
  },
  {
    "codigo":1251558001,
    "descripcion":"PREOCUPACIÓN SOBRE ALIMENTACIÓN Y\/O NUTRICIÓN"
  },
  {
    "codigo":235750000,
    "descripcion":"COLITIS INDUCIDA POR MEDICAMENTOS"
  },
  {
    "codigo":6374002,
    "descripcion":"BLOQUEO DE RAMA"
  },
  {
    "codigo":399590005,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS DE PRÓSTATA"
  },
  {
    "codigo":364987000,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA REALIZAR FUNCIONES MECÁNICAS DEL HABLA"
  },
  {
    "codigo":102843001,
    "descripcion":"CILINDRO URINARIO, GRANULOSO"
  },
  {
    "codigo":233915000,
    "descripcion":"FIBRILACIÓN VENTRICULAR FAMILIAR PAROXÍSTICA"
  },
  {
    "codigo":168379004,
    "descripcion":"HELICOBACTER NO DETECTADO POR PRUEBA DE ALIENTO"
  },
  {
    "codigo":2704003,
    "descripcion":"ENFERMEDAD AGUDA"
  },
  {
    "codigo":35472004,
    "descripcion":"ÁNGULO ABIERTO CON PRESIÓN INTRAOCULAR MARGINAL"
  },
  {
    "codigo":232080006,
    "descripcion":"IRIS PLANO"
  },
  {
    "codigo":263013004,
    "descripcion":"LUXACIÓN DE ARTICULACIÓN DE LA COLUMNA VERTEBRAL"
  },
  {
    "codigo":426853005,
    "descripcion":"NEUMOCONIOSIS CAUSADA POR SILICATO"
  },
  {
    "codigo":721765009,
    "descripcion":"MENINGITIS CAUSADA POR POLIOVIRUS HUMANO"
  },
  {
    "codigo":293946003,
    "descripcion":"ALERGIA A ZUCLOPENTIXOL"
  },
  {
    "codigo":228410005,
    "descripcion":"INTERCAMBIA AGUJAS Y JERINGAS"
  },
  {
    "codigo":718095000,
    "descripcion":"ASOCIACIÓN ESQUISIS"
  },
  {
    "codigo":128271002,
    "descripcion":"ENFERMEDAD INFECCIOSA NEONATAL"
  },
  {
    "codigo":292111004,
    "descripcion":"REACCIÓN ADVERSA A INHIBIDOR DE BOMBA DE PROTONES"
  },
  {
    "codigo":95503005,
    "descripcion":"FISURA MACROPALPEBRAL"
  },
  {
    "codigo":716260000,
    "descripcion":"NEISSERIA ANIMALORIS O NEISSERIA ZOODEGMATIS"
  },
  {
    "codigo":161039009,
    "descripcion":"NO RECIBIÓ SUBSIDIOS"
  },
  {
    "codigo":191972002,
    "descripcion":"DISPEPSIA PSICÓGENA"
  },
  {
    "codigo":28132005,
    "descripcion":"ESPASMO DEL ESFÍNTER DE ODDI"
  },
  {
    "codigo":421348006,
    "descripcion":"TAQUICARDIA - FRECUENCIA CARDÍACA FETAL BASAL"
  },
  {
    "codigo":880100006,
    "descripcion":"DERMATITIS POR INFESTACIÓN DE CHEYLETIELLA PARASITIVORAX"
  },
  {
    "codigo":124601000,
    "descripcion":"DEFICIENCIA DE SULFINOALANINA DESCARBOXILASA"
  },
  {
    "codigo":1337017004,
    "descripcion":"SÍNDROME COMPARTIMENTAL TIBIAL ANTERIOR DE PIERNA DERECHA DEBIDO A LESIÓN TRAUMÁTICA"
  },
  {
    "codigo":714425006,
    "descripcion":"ALCANZA LA FRECUENCIA CARDÍACA OBJETIVO"
  },
  {
    "codigo":188302003,
    "descripcion":"NEOPLASIA MALIGNA DEL TAPETUM"
  },
  {
    "codigo":253838005,
    "descripcion":"AUSENCIA CONGÉNITA DE LABIO MENOR"
  },
  {
    "codigo":415843000,
    "descripcion":"SÍNDROME DEL PUNTO BLANCO"
  },
  {
    "codigo":448611005,
    "descripcion":"ANILLO VASCULAR CON CAYADO AÓRTICO IZQUIERDO Y CONDUCTO ARTERIAL RETROTRAQUEAL DERECHO PERMEABLE"
  },
  {
    "codigo":10970131000119105,
    "descripcion":"HERIDA ABIERTA DE PIE DERECHO DEBIDA A MORDEDURA DE PERRO"
  },
  {
    "codigo":18957000,
    "descripcion":"ABSCESO DE CORDÓN ESPERMÁTICO"
  },
  {
    "codigo":282936008,
    "descripcion":"CAPAZ DE INCLINARSE"
  },
  {
    "codigo":1264141002,
    "descripcion":"AFIBRINOGENEMIA POSTERIOR A EMBARAZO ECTÓPICO"
  },
  {
    "codigo":707085002,
    "descripcion":"CON ALTO RIESGO DE INFECCIÓN TUBERCULOSA"
  },
  {
    "codigo":1296909003,
    "descripcion":"RESISTENCIA HEREDITARIA AUTOSÓMICA RECESIVA A ARGININA VASOPRESINA"
  },
  {
    "codigo":281101005,
    "descripcion":"EXTENDIDO - NO SE DETECTARON ANOMALÍAS: AUSENCIA DE CÉLULAS ENDOCERVICALES"
  },
  {
    "codigo":84493007,
    "descripcion":"QUEMADURA DE LA AXILA"
  },
  {
    "codigo":770786001,
    "descripcion":"MIOPATÍA HEREDITARIA CON CUERPOS DE INCLUSIÓN TIPO 4"
  },
  {
    "codigo":836322002,
    "descripcion":"AGUDEZA VISUAL CON AGUJERO ESTENOPEICO DE OJO IZQUIERDO 6\/6"
  },
  {
    "codigo":17122004,
    "descripcion":"SÍNDROME DE MONOSOMÍA PARCIAL 4P"
  },
  {
    "codigo":211895003,
    "descripcion":"QUEMADURA SUPERFICIAL DEL PULGAR Y LOS DEDOS DE LA MANO"
  },
  {
    "codigo":408503006,
    "descripcion":"EXAMEN PEDIÁTRICO A LOS 7 MESES: NORMAL"
  },
  {
    "codigo":277431007,
    "descripcion":"DIPLACUSIA MONOAURAL"
  },
  {
    "codigo":767116002,
    "descripcion":"ALERGIA A SUSTANCIA CON ESTRUCTURA DE ÉTER"
  },
  {
    "codigo":46220003,
    "descripcion":"EMBRIOCARDIA"
  },
  {
    "codigo":294061000119106,
    "descripcion":"HEMIPLEJÍA FLÁCCIDA DE LADO DOMINANTE DERECHO"
  },
  {
    "codigo":210060006,
    "descripcion":"LESIÓN CARDÍACA, EXPUESTA"
  },
  {
    "codigo":1086791000119100,
    "descripcion":"GASTRITIS EROSIVA"
  },
  {
    "codigo":111756008,
    "descripcion":"INTOXICACIÓN POR HORMONA HIPOFISARIA POSTERIOR"
  },
  {
    "codigo":208225001,
    "descripcion":"FRACTURA NO EXPUESTA DE APÓFISIS CORACOIDES DEL OMÓPLATO"
  },
  {
    "codigo":109921007,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE NERVIO PERIFÉRICO DE CABEZA, CARA Y\/O CUELLO"
  },
  {
    "codigo":372065009,
    "descripcion":"NEOPLASIA MALIGNA DE BRONQUIO FUENTE"
  },
  {
    "codigo":697910001,
    "descripcion":"HIPERTENSIÓN PULMONAR DEBIDA A ENFERMEDAD PULMONAR Y\/O HIPOXIA"
  },
  {
    "codigo":1156662004,
    "descripcion":"PTERIGIÓN UNGUEAL DORSAL"
  },
  {
    "codigo":402998007,
    "descripcion":"CANDIDIASIS ORAL NODULAR CRÓNICA"
  },
  {
    "codigo":206390008,
    "descripcion":"HEMORRAGIA FETAL"
  },
  {
    "codigo":302859004,
    "descripcion":"OSTEOMA OSTEOIDE"
  },
  {
    "codigo":38880002,
    "descripcion":"ESCALOFRÍO"
  },
  {
    "codigo":301024002,
    "descripcion":"ÚLCERA DE RODILLA"
  },
  {
    "codigo":169952004,
    "descripcion":"HALLAZGO PLACENTARIO"
  },
  {
    "codigo":366560007,
    "descripcion":"HALLAZGO RELACIONADO CON AMPLITUD DE MOVIMIENTO DE ARTICULACIÓN DE CADERA"
  },
  {
    "codigo":102581000,
    "descripcion":"SECRECIÓN BRONQUIAL EXCESIVA"
  },
  {
    "codigo":364725001,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA CAMINAR HACIA ATRÁS ARRASTRANDO UN JUGUETE GRANDE"
  },
  {
    "codigo":168117003,
    "descripcion":"CÉLULAS FETALES ANORMALES EN EL LÍQUIDO AMNIÓTICO"
  },
  {
    "codigo":233653007,
    "descripcion":"FIBROSIS PLEURAL INDUCIDA POR AMIANTO"
  },
  {
    "codigo":266421008,
    "descripcion":"ANOMALÍA DE RELACIÓN DE ARCO DENTAL"
  },
  {
    "codigo":1149322001,
    "descripcion":"INTOXICACIÓN"
  },
  {
    "codigo":199050003,
    "descripcion":"FALSO TRABAJO DE PARTO A LAS 37 SEMANAS DE GESTACIÓN COMPLETAS O DESPUÉS"
  },
  {
    "codigo":788874003,
    "descripcion":"LEUCEMIA PROLINFOCÍTICA DE CÉLULAS B EN REMISIÓN"
  },
  {
    "codigo":231818007,
    "descripcion":"LACERACIÓN DE ESPESOR TOTAL DE PÁRPADO CON LESIÓN DE CONDUCTO LAGRIMAL"
  },
  {
    "codigo":361055000,
    "descripcion":"USO INAPROPIADO DE SUSTANCIAS"
  },
  {
    "codigo":262751001,
    "descripcion":"LESIÓN TRAUMÁTICA DE CONDUCTO LAGRIMAL"
  },
  {
    "codigo":721503002,
    "descripcion":"LESIÓN COMPLETA DE MÉDULA ESPINAL AL NIVEL DEL CUARTO SEGMENTO LUMBAR"
  },
  {
    "codigo":229983003,
    "descripcion":"POSICIÓN DE PARTE DEL CUERPO"
  },
  {
    "codigo":607007,
    "descripcion":"CAPACIDAD VITAL DISMINUIDA"
  },
  {
    "codigo":129844000,
    "descripcion":"ALTERACIÓN NUTRICIONAL"
  },
  {
    "codigo":422921000,
    "descripcion":"ALERGIA A VENENO DE ESCORPIÓN"
  },
  {
    "codigo":228148009,
    "descripcion":"DEFICIENCIA DE LA MOTRICIDAD FINA"
  },
  {
    "codigo":95241002,
    "descripcion":"RINOCEFALIA"
  },
  {
    "codigo":291849004,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR METANDRIOL"
  },
  {
    "codigo":160777004,
    "descripcion":"AYUDA DOMICILIARIA REQUERIDA"
  },
  {
    "codigo":717833009,
    "descripcion":"DIENTES CÓNICOS"
  },
  {
    "codigo":93406002,
    "descripcion":"ENGROSAMIENTO CONGÉNITO DE RADIO"
  },
  {
    "codigo":62473009,
    "descripcion":"GASTROPATÍA ASOCIADA A AINE"
  },
  {
    "codigo":224478001,
    "descripcion":"RECIBE AYUDA DE ORGANIZACIÓN VOLUNTARIA"
  },
  {
    "codigo":124339000,
    "descripcion":"DEFICIENCIA DE FOSFOMEVALONATO CINASA"
  },
  {
    "codigo":16916421000119100,
    "descripcion":"HIGROMA SUBDURAL POSTRAUMÁTICO"
  },
  {
    "codigo":340421000119101,
    "descripcion":"HIPOPIÓN DE OJO IZQUIERDO"
  },
  {
    "codigo":1077701000119102,
    "descripcion":"OSTEOMIELITIS DE CÚBITO IZQUIERDO"
  },
  {
    "codigo":12095941000119103,
    "descripcion":"PIE DE INMERSIÓN IZQUIERDO"
  },
  {
    "codigo":112581000119104,
    "descripcion":"DOLOR AGUDO DE ARTICULACIÓN DE LA RODILLA"
  },
  {
    "codigo":680901000119102,
    "descripcion":"HIPOTRICOSIS DE PÁRPADO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":11839941000119106,
    "descripcion":"HEMATOMA TRAUMÁTICO DE MAMA DERECHA"
  },
  {
    "codigo":286344003,
    "descripcion":"CAPAZ DE PRODUCIR CALIDAD DE VOZ APROPIADA"
  },
  {
    "codigo":1082821000119107,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE AMBOS PABELLONES AURICULARES"
  },
  {
    "codigo":368581000119106,
    "descripcion":"NEUROPATÍA DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":89736004,
    "descripcion":"ENDOCARDITIS VALVULAR"
  },
  {
    "codigo":291781000119103,
    "descripcion":"SÍNDROME DE DOLOR REGIONAL COMPLEJO TIPO II DE MIEMBRO INFERIOR IZQUIERDO"
  },
  {
    "codigo":319941000119103,
    "descripcion":"NÓDULO REUMATOIDE SUBCUTÁNEO DE CODO DERECHO"
  },
  {
    "codigo":332741000119104,
    "descripcion":"EROSIÓN RECIDIVANTE DE LA CÓRNEA DEL OJO DERECHO"
  },
  {
    "codigo":16755141000119106,
    "descripcion":"SANGRADO UTERINO ANORMAL DEBIDO A TRASTORNO ENDOMETRIAL"
  },
  {
    "codigo":107461000119106,
    "descripcion":"SÍNDROME COMPARTIMENTAL DEBIDO A LESIÓN TRAUMÁTICA"
  },
  {
    "codigo":284509004,
    "descripcion":"CONDUCTA IMPREDECIBLE"
  },
  {
    "codigo":1085381000119108,
    "descripcion":"VIREMIA POR CITOMEGALOVIRUS"
  },
  {
    "codigo":56968009,
    "descripcion":"ASMA POR ASERRÍN"
  },
  {
    "codigo":55133004,
    "descripcion":"MIOPATÍA CONGÉNITA MULTIFOCAL"
  },
  {
    "codigo":53298000,
    "descripcion":"SÍNDROME DE HEMATURIA"
  },
  {
    "codigo":218973009,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR TEOBROMINA"
  },
  {
    "codigo":249906002,
    "descripcion":"DIFICULTAD PARA FLEXIONARSE"
  },
  {
    "codigo":282674003,
    "descripcion":"NO ATRAPA"
  },
  {
    "codigo":1234781009,
    "descripcion":"TRASTORNO DEL ESTADO DE ÁNIMO CON SÍNTOMAS MANÍACOS INDUCIDO POR ALCOHOL"
  },
  {
    "codigo":413746000,
    "descripcion":"ENDOFTALMITIS CANDIDIÁSICA"
  },
  {
    "codigo":315442003,
    "descripcion":"NACIDO EN HUNGRÍA"
  },
  {
    "codigo":248071002,
    "descripcion":"SE RASCA"
  },
  {
    "codigo":279004007,
    "descripcion":"INCOORDINACIÓN NEUROMUSCULAR URETERAL"
  },
  {
    "codigo":735921007,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA NEUROEPITELIAL DE ÓRBITA"
  },
  {
    "codigo":275334004,
    "descripcion":"DISTENSIÓN DE HOMBRO"
  },
  {
    "codigo":240731000,
    "descripcion":"HISTOPLASMOSIS CLÁSICA DISEMINADA SUBAGUDA"
  },
  {
    "codigo":732251003,
    "descripcion":"SÍNDROME DE CEGUERA CORTICAL, DISCAPACIDAD INTELECTUAL Y POLIDACTILIA"
  },
  {
    "codigo":371803003,
    "descripcion":"ENFERMEDAD DE MÚLTIPLES ARTERIAS CORONARIAS"
  },
  {
    "codigo":699483005,
    "descripcion":"ARCADA MAXILAR ASIMÉTRICA"
  },
  {
    "codigo":207963004,
    "descripcion":"FRACTURA NO EXPUESTA DE VÉRTEBRA LUMBAR, ARCO POSTERIOR"
  },
  {
    "codigo":238896002,
    "descripcion":"LIPOATROFIA LOCALIZADA"
  },
  {
    "codigo":402736003,
    "descripcion":"ENFERMEDAD CUTÁNEA FACTICIA"
  },
  {
    "codigo":42288005,
    "descripcion":"AUSENCIA DE EYACULACIÓN"
  },
  {
    "codigo":9520006,
    "descripcion":"NISTAGMO DISOCIADO"
  },
  {
    "codigo":1285637000,
    "descripcion":"HERIDA DE EXTREMIDAD INFERIOR POR MORDEDURA"
  },
  {
    "codigo":73221001,
    "descripcion":"PAPILITIS ÓPTICA"
  },
  {
    "codigo":105989001,
    "descripcion":"SECUENCIA DE ANOMALÍA CONGÉNITA"
  },
  {
    "codigo":299081000119101,
    "descripcion":"HEMARTROSIS DE RODILLA IZQUIERDA"
  },
  {
    "codigo":237061004,
    "descripcion":"SÍNDROME DE REMANENTE OVÁRICO"
  },
  {
    "codigo":40453004,
    "descripcion":"HIPERPLASIA DE AMÍGDALAS Y ADENOIDES"
  },
  {
    "codigo":5850000,
    "descripcion":"SE SUGIERE REPETIR EL EXTENDIDO CELULAR"
  },
  {
    "codigo":71386003,
    "descripcion":"TRASTORNO DE LA VOZ POR FACTOR IATROGÉNICO"
  },
  {
    "codigo":300762003,
    "descripcion":"CAPAZ DE REALIZAR ACTIVIDAD CREATIVA"
  },
  {
    "codigo":366298006,
    "descripcion":"HALLAZGO RELACIONADO CON EL COLOR DE LOS LOQUIOS"
  },
  {
    "codigo":397231001,
    "descripcion":"PARED LATERAL DE LA PELVIS AFECTADA POR PROPAGACIÓN DIRECTA DE NEOPLASIA MALIGNA"
  },
  {
    "codigo":298927002,
    "descripcion":"BLOQUEO DE CODO"
  },
  {
    "codigo":724911001,
    "descripcion":"LESIÓN TRAUMÁTICA DE BOLSA SEROSA A NIVEL DEL HOMBRO"
  },
  {
    "codigo":428164004,
    "descripcion":"TRASTORNO DE VÁLVULA MITRAL DURANTE EL EMBARAZO"
  },
  {
    "codigo":297092004,
    "descripcion":"SOBREDOSIS DE FÁRMACO ANTIVARICOSO"
  },
  {
    "codigo":723076008,
    "descripcion":"MIXOFIBROSARCOMA PRIMARIO"
  },
  {
    "codigo":721241005,
    "descripcion":"MENINGITIS CAUSADA POR BACILO AERÓBICO GRAMNEGATIVO"
  },
  {
    "codigo":229721007,
    "descripcion":"DEMORA EN EL HABLA"
  },
  {
    "codigo":129582000,
    "descripcion":"FÍSTULA CONGÉNITA DE LA ARTERIA CORONARIA A LA ARTERIA PULMONAR"
  },
  {
    "codigo":293422004,
    "descripcion":"REACCIÓN ADVERSA A RESINAS DE INTERCAMBIO ANIÓNICO"
  },
  {
    "codigo":1145390006,
    "descripcion":"APLASIA DE MÚSCULO CUÁDRICEPS FEMORAL"
  },
  {
    "codigo":62211002,
    "descripcion":"URTICARIA POR CALOR"
  },
  {
    "codigo":291587003,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR CEFUROXIMA"
  },
  {
    "codigo":160515003,
    "descripcion":"ORIGEN ASIÁTICO"
  },
  {
    "codigo":94979006,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE CONDUCTO PANCREÁTICO"
  },
  {
    "codigo":1010648002,
    "descripcion":"SÍNDROME VESTIBULAR AGUDO POR ENFERMEDAD CEREBROVASCULAR"
  },
  {
    "codigo":93144003,
    "descripcion":"RETICULOENDOTELIOSIS LEUCÉMICA DE GANGLIOS LINFÁTICOS INTRABDOMINALES"
  },
  {
    "codigo":289752004,
    "descripcion":"ÚTERO INVOLUCIONADO"
  },
  {
    "codigo":715736008,
    "descripcion":"DISOMÍA UNIPARENTAL PATERNA DEL CROMOSOMA 20"
  },
  {
    "codigo":255149000,
    "descripcion":"CARCINOMA IN SITU DE LOS CONDUCTOS PROSTÁTICOS"
  },
  {
    "codigo":224216008,
    "descripcion":"SE ALOJA EN LA CASA DE UNA PROPIETARIA"
  },
  {
    "codigo":124077003,
    "descripcion":"PROTOPORFIRINA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1172653004,
    "descripcion":"LIPOPROTEÍNA DE ALTA DENSIDAD DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":286082000,
    "descripcion":"NO GUARDA LA ROPA LAVADA"
  },
  {
    "codigo":1303725009,
    "descripcion":"FIBROADENOMA DE AMBAS MAMAS"
  },
  {
    "codigo":1269122003,
    "descripcion":"METÁSTASIS DE CARCINOMA EN NASOFARINGE"
  },
  {
    "codigo":253314003,
    "descripcion":"INTERRUPCIÓN DE LA VENA CAVA INFERIOR CON LA CONTINUACIÓN DE LA HEMIÁCIGOS DERECHA"
  },
  {
    "codigo":89474008,
    "descripcion":"RESULTADO NEGATIVO PARA PRESENCIA DE TUMOR METASTÁSICO"
  },
  {
    "codigo":710231001,
    "descripcion":"FÍSTULA CON DRENAJE CONCOMITANTE CON OSTEOMIELITIS CRÓNICA DE TOBILLO Y\/O PIE Y DEBIDA A ELLA"
  },
  {
    "codigo":448087002,
    "descripcion":"ATRESIA DE TRONCO PULMONAR CON ARTERIA PULMONAR DERECHA AUSENTE"
  },
  {
    "codigo":284247005,
    "descripcion":"REALIZA FUNCIONES MANUALES"
  },
  {
    "codigo":251479006,
    "descripcion":"DESCARGAS EPILEPTIFORMES PERIÓDICAS BILATERALES"
  },
  {
    "codigo":16030231000119100,
    "descripcion":"OSTEOMIELITIS SUBAGUDA DE HUESO TIBIAL DERECHO"
  },
  {
    "codigo":301591000119101,
    "descripcion":"ABSCESO DE VAINA TENDINOSA DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":83969004,
    "descripcion":"FRACTURA DE HUESO TEMPORAL"
  },
  {
    "codigo":247809003,
    "descripcion":"MIEDO A PERDER EL CONTROL DE ESFÍNTER INTESTINAL"
  },
  {
    "codigo":1263617006,
    "descripcion":"TRASTORNO FETAL DEBIDO A DISFUNCIÓN UTERINA HIPOTÓNICA"
  },
  {
    "codigo":1163478001,
    "descripcion":"QUISTE INFECCIOSO INTRACRANEAL"
  },
  {
    "codigo":735659002,
    "descripcion":"CUERPO EXTRAÑO MAGNÉTICO RETENIDO EN AMBOS OJOS DEBIDO A LESIÓN TRAUMÁTICA OCULAR Y POSTERIOR A ELLA"
  },
  {
    "codigo":14763005,
    "descripcion":"TOFO GOTOSO DE PABELLÓN AURICULAR"
  },
  {
    "codigo":209536002,
    "descripcion":"DESGARRO PARCIAL DE TOBILLO, LIGAMENTO EXTERNO"
  },
  {
    "codigo":45696004,
    "descripcion":"LUXACIÓN EXPUESTA DE LA ARTICULACIÓN METACARPOFALÁNGICA DEL PULGAR"
  },
  {
    "codigo":111232005,
    "descripcion":"ESPONDILOPATÍA TRAUMÁTICA"
  },
  {
    "codigo":373376008,
    "descripcion":"RESPUESTA LINFOCÍTICA PERITUMORAL - HALLAZGO"
  },
  {
    "codigo":699221007,
    "descripcion":"QUERATOSIS ACRA"
  },
  {
    "codigo":238634000,
    "descripcion":"ACANTOSIS NIGRICANS BENIGNA"
  },
  {
    "codigo":240469009,
    "descripcion":"VARICELA PERINATAL"
  },
  {
    "codigo":109397008,
    "descripcion":"DISOSTOSIS TEMPOROAURICULAR"
  },
  {
    "codigo":369706001,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA RADIAL PROFUNDA DE INTESTINO GRUESO, SIN COMPROMISO TUMORAL"
  },
  {
    "codigo":402474007,
    "descripcion":"HIPERLIPIDEMIA POLIGÉNICA PRIMARIA COMBINADA IIB"
  },
  {
    "codigo":236799006,
    "descripcion":"AFECCIÓN ESPERMATOGÉNICA CONGÉNITA"
  },
  {
    "codigo":171263007,
    "descripcion":"PLENO CONSENTIMIENTO PARA INMUNIZACIÓN"
  },
  {
    "codigo":234964000,
    "descripcion":"AMELOGÉNESIS IMPERFECTA - RECESIVA - RÍGIDA"
  },
  {
    "codigo":72959009,
    "descripcion":"INACTIVACIÓN MOLECULAR"
  },
  {
    "codigo":1187071008,
    "descripcion":"COLITIS LINFOCÍTICA"
  },
  {
    "codigo":366036004,
    "descripcion":"MADUREZ DE UNA CATARATA - HALLAZGO"
  },
  {
    "codigo":300500006,
    "descripcion":"HALLAZGO RELACIONADO CON LA SENSIBILIDAD DE EPIDÍDIMO"
  },
  {
    "codigo":202196007,
    "descripcion":"LUXACIÓN PATOLÓGICA DE PRIMERA ARTICULACIÓN METATARSOFALÁNGICA"
  },
  {
    "codigo":36521000,
    "descripcion":"PERÍODO MENSTRUAL AUSENTE"
  },
  {
    "codigo":724649000,
    "descripcion":"SARCOMA DE CÉLULAS DE LANGERHANS"
  },
  {
    "codigo":298665006,
    "descripcion":"AMPLITUD DE ROTACIÓN PASIVA HACIA LA IZQUIERDA DE LA COLUMNA LUMBAR DISMINUIDA"
  },
  {
    "codigo":296830004,
    "descripcion":"SOBREDOSIS DE AGENTE ANTITIROIDEO"
  },
  {
    "codigo":722814009,
    "descripcion":"DISPOSITIVO ORTÉSICO IN SITU"
  },
  {
    "codigo":720979002,
    "descripcion":"SÍNDROME DE ALOPECIA, CONTRACTURA, ENANISMO Y DISCAPACIDAD INTELECTUAL"
  },
  {
    "codigo":65619001,
    "descripcion":"FÍSTULA RECTOVAGINAL"
  },
  {
    "codigo":131155006,
    "descripcion":"GRUPO SANGUÍNEO A>END<"
  },
  {
    "codigo":1179731007,
    "descripcion":"REACCIÓN ADVERSA AL IMDEVIMAB"
  },
  {
    "codigo":294995009,
    "descripcion":"ALERGIA A HIDROCLOROTIAZIDA"
  },
  {
    "codigo":293160002,
    "descripcion":"REACCIÓN ADVERSA A LA DIFLUCORTOLONA"
  },
  {
    "codigo":194856005,
    "descripcion":"INFARTO DE MIOCARDIO SUBSECUENTE"
  },
  {
    "codigo":10898251000119106,
    "descripcion":"HERIDA ABIERTA DE MEJILLA DERECHA DEBIDA A MORDEDURA DE PERRO"
  },
  {
    "codigo":193021002,
    "descripcion":"EPILEPSIA CURSIVA"
  },
  {
    "codigo":225789002,
    "descripcion":"RUTINA DIARIA: POBRE"
  },
  {
    "codigo":1208829008,
    "descripcion":"RETINITIS AUTOINMUNITARIA"
  },
  {
    "codigo":92882001,
    "descripcion":"FUSIÓN ANORMAL CONGÉNITA DEL CÚBITO"
  },
  {
    "codigo":125650002,
    "descripcion":"HERIDA ABIERTA DE CODO"
  },
  {
    "codigo":27346001,
    "descripcion":"QUEMADURA EPIDÉRMICA DE TOBILLO"
  },
  {
    "codigo":715474004,
    "descripcion":"APLASIA DE PERONÉ CONCOMITANTE CON BRAQUIDACTILIA COMPLEJA"
  },
  {
    "codigo":1336231000,
    "descripcion":"TRASTORNO POR CONSUMO DE COCAÍNA"
  },
  {
    "codigo":254887002,
    "descripcion":"ADENOCARCINOMA DE CUELLO UTERINO"
  },
  {
    "codigo":418727003,
    "descripcion":"HALLAZGO RELACIONADO CON EL SEGMENTO ANTERIOR"
  },
  {
    "codigo":1303463002,
    "descripcion":"GLAUCOMA DE ÁNGULO ABIERTO DE OJO IZQUIERDO DEBIDO A TRASTORNO VASCULAR"
  },
  {
    "codigo":123815005,
    "descripcion":"EXCESO DE ESTRONCIO"
  },
  {
    "codigo":285820000,
    "descripcion":"CAPAZ DE ABRIR LAS CANILLAS DE AGUA"
  },
  {
    "codigo":416892002,
    "descripcion":"RESONANCIA MAGNÉTICA DE COLUMNA VERTEBRAL DORSAL, NORMAL"
  },
  {
    "codigo":251217001,
    "descripcion":"ONDA U PROLONGADA"
  },
  {
    "codigo":54609002,
    "descripcion":"ÚLCERA DEL RECTO"
  },
  {
    "codigo":447825006,
    "descripcion":"ANOMALÍA CONGÉNITA DE VENA CARDÍACA MEDIA"
  },
  {
    "codigo":87377007,
    "descripcion":"CAPACIDAD RESPIRATORIA MÁXIMA NORMAL"
  },
  {
    "codigo":283985007,
    "descripcion":"LESIÓN TRAUMÁTICA LINFORRETICULAR"
  },
  {
    "codigo":282150002,
    "descripcion":"INCAPAZ DE CAMINAR EN TERRENO PLANO"
  },
  {
    "codigo":773670004,
    "descripcion":"SÍNDROME DE MICRODUPLICACIÓN XQ28 DISTAL"
  },
  {
    "codigo":85542007,
    "descripcion":"LACERACIÓN PERINEAL QUE COMPROMETE LA PIEL"
  },
  {
    "codigo":247547002,
    "descripcion":"CABELLO ENSORTIJADO"
  },
  {
    "codigo":18171007,
    "descripcion":"FRACTURA DE FALANGE DE DEDO DE LA MANO"
  },
  {
    "codigo":12237951000119105,
    "descripcion":"AMAUROSIS FUGAZ DE OJO DERECHO"
  },
  {
    "codigo":83707009,
    "descripcion":"OSTEOMIELITIS NEONATAL DE MANDÍBULA"
  },
  {
    "codigo":409552002,
    "descripcion":"FIEBRE Q CRÓNICA"
  },
  {
    "codigo":737232003,
    "descripcion":"HEMORRAGIA TRAUMÁTICA DE GANGLIOS BASALES"
  },
  {
    "codigo":278480000,
    "descripcion":"ENDOCARDITIS SIFILÍTICA DE VÁLVULA AÓRTICA"
  },
  {
    "codigo":1259685000,
    "descripcion":"COREA DEBIDA A SÍNDROME SIMILAR A ENFERMEDAD DE HUNTINGTON TIPO 3"
  },
  {
    "codigo":243877001,
    "descripcion":"SITUACIÓN DE CRIBADO PARA CÁNCER DE CUELLO UTERINO"
  },
  {
    "codigo":702629003,
    "descripcion":"OBSTRUCCIÓN AL FLUJO MENSTRUAL"
  },
  {
    "codigo":211109004,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO, EN EL ANO"
  },
  {
    "codigo":47269005,
    "descripcion":"QUISTE PRIMARIO EN LA PORCIÓN PLANA"
  },
  {
    "codigo":473253006,
    "descripcion":"QUEMADURA EPIDÉRMICA DE MÚLTIPLES SITIOS DE LA CARA SIN COMPROMISO DEL OJO PROPIAMENTE DICHO"
  },
  {
    "codigo":276645004,
    "descripcion":"HIPERCALCEMIA INFANTIL"
  },
  {
    "codigo":333081000119102,
    "descripcion":"PINGUECULITIS DE OJO DERECHO"
  },
  {
    "codigo":307578000,
    "descripcion":"CORTARSE LAS MUÑECAS"
  },
  {
    "codigo":78202006,
    "descripcion":"QUEMADURA EPIDÉRMICA DE LABIO"
  },
  {
    "codigo":373114007,
    "descripcion":"COMPROMISO TUMORAL EN MARGEN DE RESECCIÓN QUIRÚRGICA, AUSENTE (MAMA)"
  },
  {
    "codigo":209274006,
    "descripcion":"FRACTURA-LUXACIÓN EXPUESTA DE ARTICULACIÓN RADIOCUBITAL DISTAL"
  },
  {
    "codigo":1290618009,
    "descripcion":"VACUNA RETIRADA POR FABRICANTE"
  },
  {
    "codigo":830031001,
    "descripcion":"QUISTE DERMOIDE DE PÁRPADO"
  },
  {
    "codigo":43599001,
    "descripcion":"PORFIRIA INDUCIDA POR DROGAS"
  },
  {
    "codigo":404047004,
    "descripcion":"LEIOMIOSARCOMA CUTÁNEO CON CAMBIOS EN LAS CÉLULAS DE LA GRANULOSA"
  },
  {
    "codigo":405882006,
    "descripcion":"FENOTIPO M+N+"
  },
  {
    "codigo":240207006,
    "descripcion":"CONDROMATOSIS SINOVIAL"
  },
  {
    "codigo":305743004,
    "descripcion":"ATENDIDO POR ENFERMERA ESPECIALISTA EN TERAPIA CONDUCTISTA"
  },
  {
    "codigo":238372002,
    "descripcion":"TRASTORNO DERMATOLÓGICO POR CHLAMYDIA"
  },
  {
    "codigo":41764006,
    "descripcion":"MONOPLEJÍA DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":762660007,
    "descripcion":"FISURA DE PALADAR CON LABIO LEPORINO BILATERAL Y FISURA ALVEOLAR BILATERAL"
  },
  {
    "codigo":433145001,
    "descripcion":"FETO POSTÉRMINO"
  },
  {
    "codigo":271140009,
    "descripcion":"AMPOLLA TRAUMÁTICA DEL FLANCO, INFECTADA"
  },
  {
    "codigo":1186809004,
    "descripcion":"GLUCOGENOSIS DEBIDA A DEFICIENCIA DE LACTATO DESHIDROGENASA"
  },
  {
    "codigo":1119438000,
    "descripcion":"ATROFIA DE MÚSCULO DE HOMBRO"
  },
  {
    "codigo":302073009,
    "descripcion":"DOLOR A LA PALPACIÓN EN LA GLÁNDULA TIROIDES"
  },
  {
    "codigo":39929009,
    "descripcion":"TRASTORNO DEL METABOLISMO DE LOS ÁCIDOS GRASOS"
  },
  {
    "codigo":365774006,
    "descripcion":"NIVEL DE HORMONA - HALLAZGO"
  },
  {
    "codigo":726222008,
    "descripcion":"LACERACIÓN DE MÚSCULO DE LA CADERA"
  },
  {
    "codigo":300238009,
    "descripcion":"HALLAZGO RELACIONADO CON MEDICIONES DE LA DENTICIÓN"
  },
  {
    "codigo":394872000,
    "descripcion":"PREPARADO PARA DEJAR DE FUMAR"
  },
  {
    "codigo":427640001,
    "descripcion":"TRASTORNO NO ALÉRGICO DE HIPERSENSIBILIDAD MEDICAMENTOSA"
  },
  {
    "codigo":722552001,
    "descripcion":"SECUELA DE INFECCIÓN CAUSADA POR CHLAMYDIA"
  },
  {
    "codigo":1148536003,
    "descripcion":"SOBREDOSIS DE ÁCIDO BILIAR Y\/O DERIVADO DE ÁCIDO BILIAR"
  },
  {
    "codigo":36259009,
    "descripcion":"DERMATITIS ECCEMATOSA DE PÁRPADO"
  },
  {
    "codigo":165496003,
    "descripcion":"EN PILA DE MONEDAS"
  },
  {
    "codigo":34424009,
    "descripcion":"DUPLICACIÓN CONGÉNITA DE LA VAGINA"
  },
  {
    "codigo":425805004,
    "descripcion":"RETRASO DEL DESARROLLO COGNITIVO"
  },
  {
    "codigo":294733005,
    "descripcion":"ALERGIA A GLICLAZIDA"
  },
  {
    "codigo":718882006,
    "descripcion":"NEUTROPENIA CONGÉNITA SEVERA LIGADA AL CROMOSOMA X"
  },
  {
    "codigo":292898006,
    "descripcion":"REACCIÓN ADVERSA AL BENZALCONIO"
  },
  {
    "codigo":94455000,
    "descripcion":"NEOPLASIA MALIGNA SECUNDARIA DE OVARIO"
  },
  {
    "codigo":225527000,
    "descripcion":"SE ALIMENTA CON FRECUENCIA"
  },
  {
    "codigo":1306871002,
    "descripcion":"SOSPECHA DE GLAUCOMA DE OJO IZQUIERDO"
  },
  {
    "codigo":1144866007,
    "descripcion":"HIPOPLASIA CONGÉNITA DE URÉTER"
  },
  {
    "codigo":61687004,
    "descripcion":"ENDOFLEBITIS DEL SENO SAGITAL INFERIOR"
  },
  {
    "codigo":291063006,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR CLOBAZAM"
  },
  {
    "codigo":717047007,
    "descripcion":"DEFICIENCIA DE ÁCIDO BILIAR COA LIGASA Y AMIDACIÓN DEFECTUOSA"
  },
  {
    "codigo":192759008,
    "descripcion":"TROMBOSIS DE SENO VENOSO CEREBRAL"
  },
  {
    "codigo":420300004,
    "descripcion":"CLASIFICACIÓN DE LA ASOCIACIÓN CARDIOLÓGICA DE NUEVA YORK - CLASE I"
  },
  {
    "codigo":715212005,
    "descripcion":"LESIÓN TRAUMÁTICA DE VESÍCULA BILIAR DURANTE INTERVENCIÓN QUIRÚRGICA"
  },
  {
    "codigo":289228005,
    "descripcion":"NECESIDAD DE PUJAR EN EL TRABAJO DE PARTO"
  },
  {
    "codigo":92620009,
    "descripcion":"CARCINOMA IN SITU DEL ISTMO UTERINO"
  },
  {
    "codigo":254625005,
    "descripcion":"NEOPLASIA MALIGNA DE PARÉNQUIMA PULMONAR"
  },
  {
    "codigo":23414001,
    "descripcion":"NEUROPATÍA DESMIELINIZANTE"
  },
  {
    "codigo":449398002,
    "descripcion":"TÚNEL AORTOVENTRICULAR IZQUIERDO CON ANEURISMA INTRACARDÍACO DE LA PORCIÓN SEPTAL"
  },
  {
    "codigo":416630006,
    "descripcion":"PRESCRIPCIÓN RECOGIDA POR VECINO"
  },
  {
    "codigo":88950007,
    "descripcion":"AUSENCIA DE SECRECIÓN EXOCRINA"
  },
  {
    "codigo":1137526006,
    "descripcion":"CALCIFICACIÓN PUNTEADA DE EPÍFISIS DE FALANGE DISTAL DE CUARTO DEDO DE PIE"
  },
  {
    "codigo":187254009,
    "descripcion":"SECUELAS TARDÍAS DE LA TUBERCULOSIS DE VÍAS GENITOURINARIAS"
  },
  {
    "codigo":185419001,
    "descripcion":"CITA REALIZADA EN LA RECEPCIÓN"
  },
  {
    "codigo":15982311000119104,
    "descripcion":"DEBILIDAD DE MÚSCULO FACIAL IZQUIERDO DEBIDO A ENFERMEDAD CEREBROVASCULAR Y POSTERIOR A ELLA"
  },
  {
    "codigo":285558008,
    "descripcion":"DIFICULTAD PARA MANTENER LA ELEVACIÓN DEL PALADAR BLANDO"
  },
  {
    "codigo":1332299004,
    "descripcion":"GLAUCOMA DE AMBOS OJOS DEBIDO A LESIÓN PERFORANTE DE AMBOS GLOBOS OCULARES Y POSTERIOR A ELLA"
  },
  {
    "codigo":283723007,
    "descripcion":"MORDEDURA HUMANA EN LA RODILLA"
  },
  {
    "codigo":414795007,
    "descripcion":"ISQUEMIA MIOCÁRDICA"
  },
  {
    "codigo":314656002,
    "descripcion":"PERÍMETRO CEFÁLICO DEL NIÑO: PERCENTILO 91"
  },
  {
    "codigo":609568004,
    "descripcion":"DIABETES MELLITUS DEBIDA A DEFECTO GENÉTICO EN LA FUNCIÓN DE LAS CÉLULAS BETA"
  },
  {
    "codigo":85280007,
    "descripcion":"DEDO DEL PIE EN MARTILLO CONGÉNITO"
  },
  {
    "codigo":247285003,
    "descripcion":"RUIDOS MUY FUERTES"
  },
  {
    "codigo":1259423003,
    "descripcion":"CARCINOMA UROTELIAL PRIMARIO DE URÉTER"
  },
  {
    "codigo":210847004,
    "descripcion":"LESIÓN DEL ARCO PALMAR PROFUNDO"
  },
  {
    "codigo":702367005,
    "descripcion":"SÍNDROME GENITORROTULIANO"
  },
  {
    "codigo":472991006,
    "descripcion":"DESARROLLO ANORMAL DE LA SEXUALIDAD"
  },
  {
    "codigo":11777921000119105,
    "descripcion":"RUPTURA TRAUMÁTICA DE TENDÓN DE BÍCEPS BRAQUIAL DERECHO"
  },
  {
    "codigo":276383008,
    "descripcion":"RUIDOS HIDROAÉREOS INTERMITENTES"
  },
  {
    "codigo":766068002,
    "descripcion":"PROBLEMA DE RELACIÓN SEXUAL"
  },
  {
    "codigo":733300002,
    "descripcion":"DELECIÓN DE PARTE DEL BRAZO LARGO DEL CROMOSOMA 17"
  },
  {
    "codigo":241780004,
    "descripcion":"EFECTO TÓXICO CAUSADO POR HONGO PSILOSYBE SEMILANCEATA"
  },
  {
    "codigo":307316006,
    "descripcion":"RUPTURA DE ARTERIA POPLÍTEA"
  },
  {
    "codigo":43337002,
    "descripcion":"FRACTURA EXPUESTA DEL BORDE ALVEOLAR DEL CUERPO DE LA MANDÍBULA"
  },
  {
    "codigo":698697003,
    "descripcion":"TRASTORNO DE ADAPTACIÓN CON ALTERACIÓN MIXTA DE LAS EMOCIONES Y DE LA CONDUCTA EN REMISIÓN"
  },
  {
    "codigo":403785002,
    "descripcion":"ENFERMEDAD DE DARIER, LINEAL\/NEVOIDE\/ZOSTERIFORME"
  },
  {
    "codigo":1255753002,
    "descripcion":"MICOSIS FUNGOIDE DE GANGLIOS LINFÁTICOS DE CUELLO"
  },
  {
    "codigo":10958721000119108,
    "descripcion":"HERIDA ABIERTA DE MANO IZQUIERDA"
  },
  {
    "codigo":305481008,
    "descripcion":"BAJO ATENCIÓN DE DERMATÓLOGO"
  },
  {
    "codigo":239945009,
    "descripcion":"VASCULITIS URTICARIANA HIPOCOMPLEMENTÉMICA"
  },
  {
    "codigo":76105009,
    "descripcion":"CICLOTIMIA"
  },
  {
    "codigo":762398003,
    "descripcion":"MÚLTIPLES HERIDAS ABIERTAS DE MÚLTIPLES REGIONES CORPORALES"
  },
  {
    "codigo":205342008,
    "descripcion":"MACRODACTILIA DE DEDOS DE LOS PIES - SIMPLE"
  },
  {
    "codigo":74270009,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DE MUSLO"
  },
  {
    "codigo":1156915008,
    "descripcion":"INMUNIDAD CONTRA MENINGOCOCCUS DETERMINADA POR SEROLOGÍA"
  },
  {
    "codigo":400115004,
    "descripcion":"HIPERQUERATOSIS ACRAL FOCAL"
  },
  {
    "codigo":72435006,
    "descripcion":"FRACTURA EXPUESTA DEL EXTREMO ACROMIAL DE LA CLAVÍCULA"
  },
  {
    "codigo":299976000,
    "descripcion":"SENSACIÓN MAMARIA CONFORTABLE"
  },
  {
    "codigo":1284851009,
    "descripcion":"SÍNDROME DE BAJA ESTATURA, DISPLASIA ESQUELÉTICA, DEGENERACIÓN RETINIANA, DISCAPACIDAD INTELECTUAL E HIPOACUSIA NEUROSENSITIVA"
  },
  {
    "codigo":365512000,
    "descripcion":"HALLAZGO RELACIONADO CON CARACTERÍSTICAS DEL AMBIENTE DOMÉSTICO"
  },
  {
    "codigo":37832003,
    "descripcion":"INFECCIÓN CAUSADA POR METAGONIMUS YOKOGAWAI"
  },
  {
    "codigo":234440005,
    "descripcion":"DEFICIENCIA DE FACTOR VIII"
  },
  {
    "codigo":3229001,
    "descripcion":"ÚLCERA DE LA TRÁQUEA"
  },
  {
    "codigo":396445003,
    "descripcion":"HALLAZGO RELACIONADO CON LA REMISIÓN TUMORAL"
  },
  {
    "codigo":68765006,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN REGIÓN DE TOBILLO SIN INFECCIÓN"
  },
  {
    "codigo":363677007,
    "descripcion":"XEROFTALMÍA"
  },
  {
    "codigo":1017202000,
    "descripcion":"CON MAYOR RIESGO DE TRÁFICO HUMANO"
  },
  {
    "codigo":298141007,
    "descripcion":"CURVATURA LONGITUDINAL DE LA UÑA PRONUNCIADA"
  },
  {
    "codigo":338101000119103,
    "descripcion":"HEMORRAGIA DE RETINA IZQUIERDA"
  },
  {
    "codigo":1344882005,
    "descripcion":"APEGO CAÓTICO Y CONTROLADOR"
  },
  {
    "codigo":722290008,
    "descripcion":"SÍNDROME LINFOPROLIFERATIVO AUTOINMUNITARIO CON INFECCIÓN VIRAL RECURRENTE"
  },
  {
    "codigo":198002008,
    "descripcion":"ORQUIEPIDIDIMITIS ASOCIADA CON OTRO TRASTORNO"
  },
  {
    "codigo":294471003,
    "descripcion":"ALERGIA A CLARITROMICINA"
  },
  {
    "codigo":65095005,
    "descripcion":"ABSCESO PULMONAR AMEBIANO"
  },
  {
    "codigo":720455008,
    "descripcion":"DEPRESIÓN MAYOR MÍNIMA"
  },
  {
    "codigo":390940007,
    "descripcion":"CONTROL DE ASMA: PENDIENTE"
  },
  {
    "codigo":423708008,
    "descripcion":"CARCINOMA MUCOEPIDERMOIDE DE GLÁNDULA SALIVAL"
  },
  {
    "codigo":292636009,
    "descripcion":"REACCIÓN ADVERSA AL CALCIPOTRIOL"
  },
  {
    "codigo":94193003,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE VASO SANGUÍNEO DEL PIE"
  },
  {
    "codigo":126961004,
    "descripcion":"NEOPLASIA DEL TRONCO ENCEFÁLICO"
  },
  {
    "codigo":125126000,
    "descripcion":"PESO DE ÓRGANO ANORMALMENTE AUMENTADO"
  },
  {
    "codigo":10633551000119102,
    "descripcion":"CELULITIS DE HOMBRO DERECHO"
  },
  {
    "codigo":92358003,
    "descripcion":"NEOPLASIA BENIGNA DE LA PIEL DE LOS PÁRPADOS"
  },
  {
    "codigo":878790004,
    "descripcion":"INGESTA EXCESIVA DE ENERGÍA"
  },
  {
    "codigo":288966007,
    "descripcion":"NO COMIENZA EL REFLEJO DE DEGLUCIÓN"
  },
  {
    "codigo":420038007,
    "descripcion":"SE SIENTE INFELIZ"
  },
  {
    "codigo":449136008,
    "descripcion":"FENESTRACIÓN DE VALVA DE VÁLVULA MITRAL"
  },
  {
    "codigo":250693002,
    "descripcion":"APOLIPOPROTEÍNA E, FENOTIPO E2:2"
  },
  {
    "codigo":248858001,
    "descripcion":"HALLAZGO DE LA VULVA"
  },
  {
    "codigo":19482002,
    "descripcion":"SECUENCIA DE REGULACIÓN"
  },
  {
    "codigo":283461009,
    "descripcion":"HERIDA PUNZANTE EN LA AXILA"
  },
  {
    "codigo":840517009,
    "descripcion":"DEFECTO DEL TABIQUE AURICULOVENTRICULAR CON COMPONENTES AURICULAR Y VENTRICULAR CON VÁLVULA AURICULOVENTRICULAR COMÚN DESEQUILIBRADA HACIA EL VENTRÍCULO DERECHO"
  },
  {
    "codigo":367081000119103,
    "descripcion":"HIPERMOVILIDAD URETRAL Y DEFICIENCIA ESFINTERIANA INTRÍNSECA COMBINADAS"
  },
  {
    "codigo":247023000,
    "descripcion":"MOVIMIENTO PUPILAR VERMIFORME"
  },
  {
    "codigo":17647001,
    "descripcion":"INFECCIÓN CAUSADA POR SAPROLEGNIA"
  },
  {
    "codigo":1197295000,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS METASTÁSICO DE GANGLIOS LINFÁTICOS DE SITIOS MÚLTIPLES"
  },
  {
    "codigo":50415004,
    "descripcion":"DOLOR MODERADO"
  },
  {
    "codigo":738543008,
    "descripcion":"METABOLIZADOR INTERMEDIO DE DIHIDROPIRIMIDINA DESHIDROGENASA"
  },
  {
    "codigo":285161000119105,
    "descripcion":"OCLUSIÓN DE ARTERIA CARÓTIDA IZQUIERDA"
  },
  {
    "codigo":441796004,
    "descripcion":"EDEMA ORBITARIO"
  },
  {
    "codigo":48580008,
    "descripcion":"ANEMIA POR INANICIÓN"
  },
  {
    "codigo":46745001,
    "descripcion":"SÍNDROME HIPERQUINÉTICO CON RETRASO DEL DESARROLLO"
  },
  {
    "codigo":69939005,
    "descripcion":"OSTEOCONDROSIS JUVENIL DEL CENTRO ROTULIANO PRIMARIO"
  },
  {
    "codigo":308889004,
    "descripcion":"FILTRACIÓN DE LINFA DESDE EL CONDUCTO TORÁCICO"
  },
  {
    "codigo":767641005,
    "descripcion":"QUISTE EMBRIONARIO DE ESTRUCTURA GENITAL MASCULINA"
  },
  {
    "codigo":700270000,
    "descripcion":"BLEFARITIS ULCEROSA DE PÁRPADO SUPERIOR"
  },
  {
    "codigo":210585008,
    "descripcion":"SECCIÓN TOTAL TRAUMÁTICA DE TENDÓN DE EXTENSOR DE DEDOS DE MANO"
  },
  {
    "codigo":208750002,
    "descripcion":"SUBLUXACIÓN EXPUESTA DE MANDÍBULA"
  },
  {
    "codigo":44910003,
    "descripcion":"ANEMIA MEGALOBLÁSTICA POR APORTE INSUFICIENTE DE VITAMINA B12"
  },
  {
    "codigo":15686121000119109,
    "descripcion":"ARTROSIS DE ARTICULACIÓN TEMPOROMANDIBULAR IZQUIERDA"
  },
  {
    "codigo":733038005,
    "descripcion":"SÍNDROME DE DISMORFISMO, PECTUS CARINATUM E HIPERLAXITUD ARTICULAR"
  },
  {
    "codigo":401271000221109,
    "descripcion":"MANCHA BLANCA EN SUPERFICIE DENTARIA"
  },
  {
    "codigo":896878007,
    "descripcion":"FORMA ANCHA ANORMAL CONGÉNITA DE FALANGE DISTAL DE PIE"
  },
  {
    "codigo":350071000221105,
    "descripcion":"BRUCELOSIS DURANTE EL EMBARAZO"
  },
  {
    "codigo":405358009,
    "descripcion":"ERROR DURANTE LA UTILIZACIÓN DE EQUIPAMIENTO"
  },
  {
    "codigo":75843002,
    "descripcion":"DENSIDAD DE UNA COLONIA BACTERIANA, OPACA"
  },
  {
    "codigo":237848000,
    "descripcion":"HIPERCALEMIA CON EQUILIBRIO ACIDOBASE NORMAL"
  },
  {
    "codigo":403523009,
    "descripcion":"MORFEA INFANTIL PANESCLERÓTICA DISCAPACITANTE"
  },
  {
    "codigo":303384002,
    "descripcion":"INCAPAZ DE CAMBIAR DE POSICIÓN"
  },
  {
    "codigo":1351960005,
    "descripcion":"INMUNODEFICIENCIA VARIABLE COMÚN AUTOSÓMICA RECESIVA DEBIDA A MUTACIÓN DE CD20"
  },
  {
    "codigo":74008005,
    "descripcion":"TRISOMÍA PARCIAL 5P"
  },
  {
    "codigo":236013000,
    "descripcion":"SEUDOQUISTE MESENTÉRICO"
  },
  {
    "codigo":94851000119107,
    "descripcion":"ENDOCARDITIS VALVULAR SIFILÍTICA"
  },
  {
    "codigo":203245006,
    "descripcion":"PERIOSTITIS SIN OSTEOMIELITIS"
  },
  {
    "codigo":398018000,
    "descripcion":"EVALUACIÓN ANESTÉSICA INADECUADA"
  },
  {
    "codigo":266946000,
    "descripcion":"CUIDA A FAMILIAR CRÓNICAMENTE ENFERMO"
  },
  {
    "codigo":168642006,
    "descripcion":"RADIOGRAFÍA SIMPLE DE CARPO NORMAL"
  },
  {
    "codigo":365250007,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA LIMPIAR ALIMENTOS"
  },
  {
    "codigo":135874008,
    "descripcion":"MORDIDA DE LA PROPIA LENGUA"
  },
  {
    "codigo":789399002,
    "descripcion":"TRASTORNO DE AJUSTE PERSISTENTE"
  },
  {
    "codigo":723863003,
    "descripcion":"MIOPERICARDITIS"
  },
  {
    "codigo":363415003,
    "descripcion":"NEOPLASIA MALIGNA DE VÍA BILIAR"
  },
  {
    "codigo":2967003,
    "descripcion":"ESTRABISMO NO CONCOMITANTE"
  },
  {
    "codigo":232343007,
    "descripcion":"RINITIS IRRITATIVA AGUDA"
  },
  {
    "codigo":396183009,
    "descripcion":"REACCIÓN EN EL SITIO QUIRÚRGICO"
  },
  {
    "codigo":230508004,
    "descripcion":"NEUROPATÍA ÓPTICA ISQUÉMICA ARTERÍTICA"
  },
  {
    "codigo":294209003,
    "descripcion":"ALERGIA A ACITRETINA"
  },
  {
    "codigo":423446002,
    "descripcion":"INVERSIÓN DE ROLES INVOLUNTARIA"
  },
  {
    "codigo":95766002,
    "descripcion":"TRASTORNO DE LA GLÁNDULA LAGRIMAL"
  },
  {
    "codigo":128534003,
    "descripcion":"ANOMALÍA CONGÉNITA DEL SEGMENTO POSTERIOR DEL OJO"
  },
  {
    "codigo":568101000005109,
    "descripcion":"VARIANTE DE HEMOGLOBINA NO DETECTADA"
  },
  {
    "codigo":194070006,
    "descripcion":"TRASTORNO INFLAMATORIO DE LA CORTEZA VISUAL"
  },
  {
    "codigo":292374006,
    "descripcion":"REACCIÓN ADVERSA A LA CLOZAPINA"
  },
  {
    "codigo":61163000,
    "descripcion":"INTOXICACIÓN POR MELILOTUS"
  },
  {
    "codigo":1144342008,
    "descripcion":"HIPOPLASIA CONGÉNITA DE ADENOHIPÓFISIS"
  },
  {
    "codigo":123831000119104,
    "descripcion":"PORTADOR DE STAPHYLOCOCCUS EPIDERMIDIS"
  },
  {
    "codigo":28395004,
    "descripcion":"ESTOMATOMENIA"
  },
  {
    "codigo":93931007,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL NERVIO ÓPTICO"
  },
  {
    "codigo":126699008,
    "descripcion":"NEOPLASIA DE LA EPIGLOTIS"
  },
  {
    "codigo":225003009,
    "descripcion":"AJUSTE EMOCIONAL INMADURO"
  },
  {
    "codigo":288704003,
    "descripcion":"NO SE COMUNICA EN DIFERENTES LUGARES"
  },
  {
    "codigo":530558861000132104,
    "descripcion":"DIABETES MELLITUS ATÍPICA"
  },
  {
    "codigo":254101001,
    "descripcion":"ENANISMO PRIMORDIAL OSTEODISPLÁSICO"
  },
  {
    "codigo":41911000119107,
    "descripcion":"GLAUCOMA DEBIDO A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":417941003,
    "descripcion":"HEMORRAGIA DE VÍAS GENITOURINARIAS"
  },
  {
    "codigo":15744081000119101,
    "descripcion":"ESPASMO DE AMBOS MÚSCULOS PIRAMIDALES"
  },
  {
    "codigo":57493005,
    "descripcion":"ENDOMETRIOSIS DE LA VAGINA"
  },
  {
    "codigo":92096008,
    "descripcion":"NEOPLASIA BENIGNA DE LAS VÍAS BILIARES EXTRAHEPÁTICAS"
  },
  {
    "codigo":285034004,
    "descripcion":"CAPAZ DE MANEJAR LA MEDICACIÓN"
  },
  {
    "codigo":416106008,
    "descripcion":"TRASTORNO DE MEMORIA: ORDEN DE LOS EVENTOS"
  },
  {
    "codigo":343121000119104,
    "descripcion":"MOLESTIA VISUAL DE AMBOS OJOS"
  },
  {
    "codigo":414271006,
    "descripcion":"LÍQUIDOS, ELECTRÓLITOS Y EQUILIBRIO ÁCIDO-BASE IGUALES O MEJORADOS CON RESPECTO A LOS NIVELES BASALES PREQUIRÚRGICOS"
  },
  {
    "codigo":283199007,
    "descripcion":"ANZUELO EN EL ANTEBRAZO"
  },
  {
    "codigo":1231636001,
    "descripcion":"SÍNDROME DE OFTALMOPLEJÍA INTERNUCLEAR BILATERAL CON ESTRABISMO CONVERGENTE"
  },
  {
    "codigo":707348004,
    "descripcion":"CARCINOMA PRIMARIO DE SENO ESFENOIDAL"
  },
  {
    "codigo":19220005,
    "descripcion":"COMPLICACIÓN DE UN IMPLANTE"
  },
  {
    "codigo":281364007,
    "descripcion":"TOFO GOTOSO DE BOLSA SEROSA DE OLÉCRANON"
  },
  {
    "codigo":248596009,
    "descripcion":"ESPUTO - SÍNTOMA"
  },
  {
    "codigo":1197033002,
    "descripcion":"TELANGIECTASIA GINGIVAL HEMORRÁGICA HEREDITARIA"
  },
  {
    "codigo":246761002,
    "descripcion":"NISTAGMO UNIOCULAR"
  },
  {
    "codigo":1264404009,
    "descripcion":"MIOCARDIOPATÍA DILATADA DEBIDA A ESCLERODERMIA"
  },
  {
    "codigo":443369007,
    "descripcion":"CONCRECIÓN EN CONJUNTIVA DE PÁRPADO"
  },
  {
    "codigo":181225007,
    "descripcion":"SÍNDROME DE ADENOPATÍA HILIAR BILATERAL"
  },
  {
    "codigo":17385007,
    "descripcion":"FIBROSIS PULMONAR POR GRAFITO"
  },
  {
    "codigo":81086003,
    "descripcion":"INFECCIÓN CAUSADA POR HETEROBILHARZIA AMERICANUM"
  },
  {
    "codigo":316651000119103,
    "descripcion":"OSTEOFITO DE PIE DERECHO"
  },
  {
    "codigo":439699000,
    "descripcion":"DEFICIENCIA HEREDITARIA DE ANTITROMBINA III"
  },
  {
    "codigo":210323002,
    "descripcion":"HERIDA ABIERTA EN EL CUERO CABELLUDO"
  },
  {
    "codigo":30981000087100,
    "descripcion":"MICROBIOTA NORMAL DE INTESTINO"
  },
  {
    "codigo":41221000087102,
    "descripcion":"HEMATOMA DE NALGA IZQUIERDA"
  },
  {
    "codigo":77416000,
    "descripcion":"CELOS"
  },
  {
    "codigo":110184001,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DE LA FRENTE"
  },
  {
    "codigo":46341000087106,
    "descripcion":"FRACTURA DE ASTRÁGALO DERECHO"
  },
  {
    "codigo":43781000087107,
    "descripcion":"TRASTORNO DE TENDÓN DE EXTREMIDAD SUPERIOR DERECHA"
  },
  {
    "codigo":75581001,
    "descripcion":"ATROFIA VELLOSA DE INTESTINO"
  },
  {
    "codigo":1156925003,
    "descripcion":"NO INMUNE AL TÉTANOS"
  },
  {
    "codigo":403261006,
    "descripcion":"PIGMENTACIÓN CUTÁNEA POR HEMOSIDEROSIS"
  },
  {
    "codigo":370493008,
    "descripcion":"LAVADO MEDULAR RENAL"
  },
  {
    "codigo":237586000,
    "descripcion":"SECRECIÓN EXCESIVA DEL PÉPTIDO INHIBIDOR GÁSTRICO"
  },
  {
    "codigo":1220626009,
    "descripcion":"INTERRUPCIÓN INDUCIDA DEL EMBARAZO INCOMPLETA COMPLICADA POR INFECCIÓN GENITOPÉLVICA"
  },
  {
    "codigo":301287002,
    "descripcion":"ESTRIDOR ESPIRATORIO"
  },
  {
    "codigo":235751001,
    "descripcion":"COLITIS INDUCIDA POR FÁRMACOS ANTIINFLAMATORIOS NO ESTEROIDES"
  },
  {
    "codigo":268519009,
    "descripcion":"DIABÉTICO MAL CONTROLADO"
  },
  {
    "codigo":70076002,
    "descripcion":"RINITIS"
  },
  {
    "codigo":299452003,
    "descripcion":"ARTICULACIÓN DE TOBILLO - ROJA"
  },
  {
    "codigo":1251559009,
    "descripcion":"DERMATITIS ALÉRGICA DE CONTACTO DE CUELLO"
  },
  {
    "codigo":364988005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD DE HACER GESTOS PARA HABLAR"
  },
  {
    "codigo":290181000119106,
    "descripcion":"LESIÓN DE NERVIO RADIAL IZQUIERDO"
  },
  {
    "codigo":102844007,
    "descripcion":"CILINDRO URINARIO, ANCHO"
  },
  {
    "codigo":233916004,
    "descripcion":"BLOQUEO CARDÍACO"
  },
  {
    "codigo":397756006,
    "descripcion":"VIVE EN CONDICIONES DE HUMEDAD"
  },
  {
    "codigo":232081005,
    "descripcion":"GLAUCOMA IATROGÉNICO"
  },
  {
    "codigo":68241007,
    "descripcion":"GLAUCOMA DEBIDO A LESIÓN TRAUMÁTICA DE GLOBO OCULAR Y POSTERIOR A ELLA"
  },
  {
    "codigo":295782004,
    "descripcion":"SOBREDOSIS DE FORMESTANO"
  },
  {
    "codigo":263014005,
    "descripcion":"LUXACIÓN DE ARTICULACIÓN ATLANTO-OCCIPITAL"
  },
  {
    "codigo":230246005,
    "descripcion":"PARÁLISIS BULBAR PROGRESIVA DE LA INFANCIA"
  },
  {
    "codigo":721766005,
    "descripcion":"ENCEFALITIS CAUSADA POR ALPHAVIRUS"
  },
  {
    "codigo":15992351000119104,
    "descripcion":"QUERATITIS DE AMBOS OJOS CAUSADA POR HERPESVIRUS HUMANO 3"
  },
  {
    "codigo":31803008,
    "descripcion":"FIEBRE POR VAPORES DE POLÍMERO"
  },
  {
    "codigo":718096004,
    "descripcion":"ESCLEROSIS HEPATOPORTAL"
  },
  {
    "codigo":29968005,
    "descripcion":"PROBLEMA, PRUEBA ANORMAL"
  },
  {
    "codigo":292112006,
    "descripcion":"REACCIÓN ADVERSA AL OMEPRAZOL"
  },
  {
    "codigo":95504004,
    "descripcion":"CILIOS ECTÓPICOS DE PÁRPADO"
  },
  {
    "codigo":161040006,
    "descripcion":"HABILITADO A RECIBIR SUBSIDIO"
  },
  {
    "codigo":128272009,
    "descripcion":"TRASTORNO DE VÍAS RESPIRATORIAS INFERIORES"
  },
  {
    "codigo":716261001,
    "descripcion":"ENTEROCOCCUS CASSELIFLAVUS O ENTEROCOCCUS MUNDTII"
  },
  {
    "codigo":1082911000119106,
    "descripcion":"INFLAMACIÓN AGUDA DE AMBAS TROMPAS FARINGOTIMPÁNICAS"
  },
  {
    "codigo":93669004,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE CONDUCTO ANAL"
  },
  {
    "codigo":60901005,
    "descripcion":"INTOXICACIÓN CAUSADA POR INHALANTE"
  },
  {
    "codigo":880101005,
    "descripcion":"DERMATITIS POR INFESTACIÓN DE CHEYLETIELLA BLAKEI"
  },
  {
    "codigo":191973007,
    "descripcion":"ESTREÑIMIENTO PSICÓGENO"
  },
  {
    "codigo":290277009,
    "descripcion":"INTOXICACIÓN POR NABUMETONA"
  },
  {
    "codigo":15883961000119103,
    "descripcion":"DOLOR A LA PALPACIÓN DE AMBAS ARTICULACIONES TEMPOROMANDIBULARES"
  },
  {
    "codigo":124602007,
    "descripcion":"DEFICIENCIA DE PANTOTENOILCISTEÍNA DESCARBOXILASA"
  },
  {
    "codigo":26298008,
    "descripcion":"COMA CETOACIDÓTICO DEBIDO A DIABETES MELLITUS"
  },
  {
    "codigo":288442008,
    "descripcion":"CAPAZ DE REALIZAR ACTIVIDADES DE ESCRITURA"
  },
  {
    "codigo":253839002,
    "descripcion":"AUSENCIA CONGÉNITA DE LABIO MAYOR"
  },
  {
    "codigo":24463005,
    "descripcion":"ASTENOSPERMIA"
  },
  {
    "codigo":57231008,
    "descripcion":"DERRAME PERICÁRDICO AGUDO"
  },
  {
    "codigo":448612003,
    "descripcion":"TRACTO DE SALIDA VENTRICULAR ÚNICO POR ENCIMA DE AMBOS VENTRÍCULOS"
  },
  {
    "codigo":88164008,
    "descripcion":"AGOTAMIENTO POR EXPOSICIÓN"
  },
  {
    "codigo":282937004,
    "descripcion":"INCAPAZ DE INCLINARSE"
  },
  {
    "codigo":708921005,
    "descripcion":"CARCINOMA DE PORCIÓN CENTRAL DE MAMA"
  },
  {
    "codigo":20793008,
    "descripcion":"OMALGIA"
  },
  {
    "codigo":84494001,
    "descripcion":"GLAUCOMA DE ÁNGULO ABIERTO"
  },
  {
    "codigo":250169008,
    "descripcion":"EL CALZADO MUESTRA SIGNOS DE ANORMALIDAD LOCOMOTRIZ"
  },
  {
    "codigo":11787961000119109,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DE DEDO MEDIO DERECHO"
  },
  {
    "codigo":1296910008,
    "descripcion":"RESISTENCIA HEREDITARIA A ARGININA VASOPRESINA LIGADA AL CROMOSOMA X"
  },
  {
    "codigo":1264142009,
    "descripcion":"DAÑO DE INTESTINO GRUESO POSTERIOR A EMBARAZO MOLAR"
  },
  {
    "codigo":49891002,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE CÓCCIX"
  },
  {
    "codigo":770787005,
    "descripcion":"MIOPATÍA CONGÉNITA BENIGNA DEL SAMARITANO"
  },
  {
    "codigo":836323007,
    "descripcion":"AGUDEZA VISUAL CON AGUJERO ESTENOPEICO DE OJO DERECHO 6\/6"
  },
  {
    "codigo":277432000,
    "descripcion":"PARACUSIA DE WILLIS"
  },
  {
    "codigo":711261000124105,
    "descripcion":"SINOVITIS CRÓNICA CODO DERECHO DEBIDA A HEMARTROSIS"
  },
  {
    "codigo":734349003,
    "descripcion":"SÍNDROME DE DISCAPACIDAD INTELECTUAL POR TALASEMIA ALFA LIGADO AL CROMOSOMA 16"
  },
  {
    "codigo":429661000124108,
    "descripcion":"HIPOSPADIAS EN LA MITAD DEL PENE"
  },
  {
    "codigo":439437006,
    "descripcion":"ATENDIDO EN CONSULTORIO ESPECIALIZADO EN TRASTORNOS ALIMENTARIOS"
  },
  {
    "codigo":242829007,
    "descripcion":"SOBREDOSIS INTENCIONAL DE DIAMORFINA"
  },
  {
    "codigo":11618000,
    "descripcion":"INFECCIÓN FETAL INTRAAMNIÓTICA"
  },
  {
    "codigo":109922000,
    "descripcion":"NEOPLASIA BENIGNA DE LOS NERVIOS PERIFÉRICOS DE LA CABEZA"
  },
  {
    "codigo":208226000,
    "descripcion":"FRACTURA NO EXPUESTA DE LA CAVIDAD GLENOIDEA DEL OMÓPLATO"
  },
  {
    "codigo":13453009,
    "descripcion":"BANDAS MUSCULARES ANÓMALAS DEL VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":765282004,
    "descripcion":"INFERTILIDAD MASCULINA CON OLIGOZOOSPERMIA DEBIDA A MUTACIÓN DE UN SOLO GEN"
  },
  {
    "codigo":10833901000119103,
    "descripcion":"FRACTURA EXPUESTA DE TERCER HUESO METATARSIANO DE PIE DERECHO"
  },
  {
    "codigo":239159001,
    "descripcion":"SEROMA DE HERIDA"
  },
  {
    "codigo":697911002,
    "descripcion":"HIPERTENSIÓN PULMONAR DEBIDA A ENFERMEDAD PULMONAR OBSTRUCTIVA CRÓNICA"
  },
  {
    "codigo":1085421000119104,
    "descripcion":"OBSTRUCCIÓN INTESTINAL DEBIDA A PÓLIPOS INFLAMATORIOS COLÓNICOS"
  },
  {
    "codigo":402999004,
    "descripcion":"CANDIDIASIS NODULAR DE LA ZONA DEL PAÑAL"
  },
  {
    "codigo":237324001,
    "descripcion":"DISTOCIA CERVICAL"
  },
  {
    "codigo":401164004,
    "descripcion":"USA ARNÉS DE PAVLIK"
  },
  {
    "codigo":301025001,
    "descripcion":"ÚLCERA DE MALÉOLO"
  },
  {
    "codigo":399329002,
    "descripcion":"TIÑA DE BARBA"
  },
  {
    "codigo":366561006,
    "descripcion":"HALLAZGO RELACIONADO CON LA AMPLITUD DE LA FLEXIÓN DE LA CADERA"
  },
  {
    "codigo":364726000,
    "descripcion":"DISTANCIA DE LA MARCHA-HALLAZGO"
  },
  {
    "codigo":299190001,
    "descripcion":"AMPLITUD DE OPOSICIÓN PASIVA DEL PULGAR NORMAL"
  },
  {
    "codigo":168118008,
    "descripcion":"TRISOMÍA 21 EN CÉLULA FETAL OBTENIDA DE LÍQUIDO AMNIÓTICO"
  },
  {
    "codigo":788875002,
    "descripcion":"FISURA BILATERAL DE LABIO Y FISURA BILATERAL DE PROCESO ALVEOLAR DE MAXILAR SUPERIOR"
  },
  {
    "codigo":2443003,
    "descripcion":"INTOXICACIÓN POR ÁCIDO SULFHÍDRICO"
  },
  {
    "codigo":231819004,
    "descripcion":"LESIÓN TÉRMICA DE PÁRPADO"
  },
  {
    "codigo":321671000119105,
    "descripcion":"ARTRITIS ESTAFILOCÓCICA DE MANO IZQUIERDA"
  },
  {
    "codigo":426592006,
    "descripcion":"BALISMO"
  },
  {
    "codigo":197216007,
    "descripcion":"ESTENOSIS DE RECTO Y ANO"
  },
  {
    "codigo":721504008,
    "descripcion":"LESIÓN COMPLETA DE MÉDULA ESPINAL AL NIVEL DEL QUINTO SEGMENTO LUMBAR"
  },
  {
    "codigo":228149001,
    "descripcion":"ALTERACIÓN DE LA FUNCIÓN MANUAL"
  },
  {
    "codigo":262752008,
    "descripcion":"LACERACIÓN DE CONDUCTO LAGRIMAL"
  },
  {
    "codigo":424757003,
    "descripcion":"RETINITIS ESCLOPETARIA"
  },
  {
    "codigo":129845004,
    "descripcion":"CON MAYOR RIESGO DE DESEQUILIBRIO NUTRICIONAL, INFERIOR A LAS NECESIDADES FÍSICAS"
  },
  {
    "codigo":195381005,
    "descripcion":"NEVO NO NEOPLÁSICO"
  },
  {
    "codigo":359842081000119101,
    "descripcion":"MELANOMA IN SITU DE PIEL DE PIE DERECHO"
  },
  {
    "codigo":64309007,
    "descripcion":"TRASTORNO DEL NERVIO TRIGÉMINO"
  },
  {
    "codigo":293685007,
    "descripcion":"ALERGIA A LA CÁSCARA SAGRADA"
  },
  {
    "codigo":31541009,
    "descripcion":"SARCOIDOSIS"
  },
  {
    "codigo":324618004,
    "descripcion":"HEMORRAGIA FARÍNGEA"
  },
  {
    "codigo":291850004,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR METANDRIOL"
  },
  {
    "codigo":95242009,
    "descripcion":"TRONCO ARTERIAL PULMONAR DERECHO"
  },
  {
    "codigo":160778009,
    "descripcion":"SERVICIO DE COMIDAS A DOMICILIO PARA PERSONAS INCAPACITADAS"
  },
  {
    "codigo":93407006,
    "descripcion":"ENGROSAMIENTO CONGÉNITO DE COSTILLA"
  },
  {
    "codigo":27871007,
    "descripcion":"DESPRENDIMIENTO COROIDEO"
  },
  {
    "codigo":224479009,
    "descripcion":"RECIBE AYUDA DE AMIGO"
  },
  {
    "codigo":124340003,
    "descripcion":"DEFICIENCIA DE ADENILATO CINASA"
  },
  {
    "codigo":286345002,
    "descripcion":"INCAPAZ DE PRODUCIR CALIDAD DE VOZ APROPIADA"
  },
  {
    "codigo":253577002,
    "descripcion":"ANEURISMA DEL TABIQUE VENTRICULAR"
  },
  {
    "codigo":1269385006,
    "descripcion":"LESIÓN DE MÉDULA ESPINAL TORÁCICA DEBIDA A SUBLUXACIÓN DE ARTICULACIÓN DE COLUMNA VERTEBRAL TORÁCICA"
  },
  {
    "codigo":417417007,
    "descripcion":"TERATOMA MALIGNO DE TESTÍCULO NO DESCENDIDO"
  },
  {
    "codigo":1234782002,
    "descripcion":"TRASTORNO DEL ESTADO DE ÁNIMO CON SÍNTOMAS DEPRESIVOS INDUCIDO POR ALCOHOL"
  },
  {
    "codigo":678331000119103,
    "descripcion":"SINEQUIAS ANTERIORES DE IRIS DE OJO DERECHO"
  },
  {
    "codigo":87902006,
    "descripcion":"TROMBOCITOPENIA POR DESTRUCCIÓN NO INMUNOLÓGICA"
  },
  {
    "codigo":284510009,
    "descripcion":"CONDUCTA EXPLOSIVA"
  },
  {
    "codigo":282675002,
    "descripcion":"DIFICULTAD PARA ATRAPAR"
  },
  {
    "codigo":1087931000119104,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE PABELLÓN AURICULAR IZQUIERDO"
  },
  {
    "codigo":673951000119100,
    "descripcion":"BURSITIS GOTOSA DE HOMBRO"
  },
  {
    "codigo":16031000119101,
    "descripcion":"DEFICIENCIA INTRÍNSECA DE ESFÍNTER URETRAL"
  },
  {
    "codigo":16026271000119102,
    "descripcion":"MALFORMACIÓN ARTERIOVENOSA CONGÉNITA DE AMBAS ARTERIAS RENALES Y AMBAS VENAS RENALES"
  },
  {
    "codigo":348831000119103,
    "descripcion":"ENDOFTALMITIS AGUDA DE OJO IZQUIERDO"
  },
  {
    "codigo":305311000119102,
    "descripcion":"CONTRACTURA DE MÚSCULO DE PIERNA IZQUIERDA"
  },
  {
    "codigo":1086111000119105,
    "descripcion":"ABSCESO DEL CIEGO CONCOMITANTE CON DIVERTICULITIS Y DEBIDO A ELLA"
  },
  {
    "codigo":1088671000119106,
    "descripcion":"TRASTORNO DE OÍDO IZQUIERDO"
  },
  {
    "codigo":16033951000119107,
    "descripcion":"HIPERTROFIA DE HUESO DE FÉMUR IZQUIERDO"
  },
  {
    "codigo":100511000119108,
    "descripcion":"MIELOPATÍA CONCOMITANTE CON ESTENOSIS ESPINAL DE REGIÓN DORSAL Y DEBIDA A ELLA"
  },
  {
    "codigo":10878111000119106,
    "descripcion":"HERIDA POR DISPARO DE ARMA DE FUEGO DE PARED ABDOMINAL"
  },
  {
    "codigo":310431000119109,
    "descripcion":"ESCOLIOSIS IDIOPÁTICA INFANTIL DE COLUMNA CERVICOTORÁCICA"
  },
  {
    "codigo":292511000119106,
    "descripcion":"TRASTORNO DE NERVIO PERIFÉRICO DE MIEMBRO INFERIOR IZQUIERDO"
  },
  {
    "codigo":16021151000119108,
    "descripcion":"BURSITIS DE PIE DERECHO"
  },
  {
    "codigo":133791000119107,
    "descripcion":"DEFECTO DEL METABOLISMO MITOCONDRIAL"
  },
  {
    "codigo":1075871000119109,
    "descripcion":"TENOSINOVITIS DE MANO DERECHA"
  },
  {
    "codigo":10750111000119108,
    "descripcion":"TUMORACIÓN DE MAMA EN EL EMBARAZO"
  },
  {
    "codigo":123551000119108,
    "descripcion":"SEROMA DEBIDO A TRAUMATISMO"
  },
  {
    "codigo":333471000119109,
    "descripcion":"EDEMA DE ÓRBITA DERECHA"
  },
  {
    "codigo":248072009,
    "descripcion":"MORDERSE"
  },
  {
    "codigo":735922000,
    "descripcion":"AGUJERO MACULAR DEBIDO A LESIÓN TRAUMÁTICA"
  },
  {
    "codigo":211634000,
    "descripcion":"CUERPO EXTRAÑO EN EL DUODENO"
  },
  {
    "codigo":15026003,
    "descripcion":"INTOXICACIÓN POR TESTOSTERONA"
  },
  {
    "codigo":12202581000119103,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DE OÍDO IZQUIERDO"
  },
  {
    "codigo":277170006,
    "descripcion":"EDEMA DE CONDUCTO AUDITIVO"
  },
  {
    "codigo":373639002,
    "descripcion":"COLITIS DISTAL"
  },
  {
    "codigo":275335003,
    "descripcion":"RUPTURA TRAUMÁTICA DEL TENDÓN DE AQUILES"
  },
  {
    "codigo":44124003,
    "descripcion":"TRASTORNO REACTIVO DE LA VINCULACIÓN EN LA NIÑEZ TEMPRANA"
  },
  {
    "codigo":699484004,
    "descripcion":"EMPUJE DE LENGUA LATERAL"
  },
  {
    "codigo":732252005,
    "descripcion":"SÍNDROME DE GLICOPROTEÍNAS CON DEFICIENCIA DE CARBOHIDRATOS TIPO 2K"
  },
  {
    "codigo":207964005,
    "descripcion":"FRACTURA NO EXPUESTA DE VÉRTEBRA LUMBAR, TRICOLUMNAR"
  },
  {
    "codigo":240732007,
    "descripcion":"HISTOPLASMOSIS CLÁSICA DISEMINADA CRÓNICA"
  },
  {
    "codigo":109660007,
    "descripcion":"DESPLAZAMIENTO DEL DISCO DE LA ARTICULACIÓN TEMPOROMANDIBULAR"
  },
  {
    "codigo":11356007,
    "descripcion":"CUERPO EXTRAÑO EN LOS BRONQUIOS PRINCIPALES"
  },
  {
    "codigo":42289002,
    "descripcion":"DIETA PARA MANDÍBULA INMOVILIZADA CON CABLES"
  },
  {
    "codigo":16026351000119101,
    "descripcion":"MALFORMACIÓN ARTERIOVENOSA CONGÉNITA DE EXTREMIDAD SUPERIOR DERECHA"
  },
  {
    "codigo":371804009,
    "descripcion":"ENFERMEDAD DE ARTERIA CORONARIA IZQUIERDA PRINCIPAL"
  },
  {
    "codigo":238897006,
    "descripcion":"LIPOATROFIA IDIOPÁTICA LOCALIZADA"
  },
  {
    "codigo":402737007,
    "descripcion":"ENFERMEDAD CUTÁNEA ARTEFACTA"
  },
  {
    "codigo":271665007,
    "descripcion":"DESDOBLAMIENTO DEL SEGUNDO RUIDO CARDÍACO"
  },
  {
    "codigo":237062006,
    "descripcion":"TRASTORNO DEL LIGAMENTO ANCHO"
  },
  {
    "codigo":366299003,
    "descripcion":"HALLAZGO RELACIONADO CON LA CANTIDAD DE LOQUIOS"
  },
  {
    "codigo":300763008,
    "descripcion":"INCAPAZ DE REALIZAR ACTIVIDAD CREATIVA"
  },
  {
    "codigo":4016003,
    "descripcion":"EMPIEMA DE APÓFISIS MASTOIDES"
  },
  {
    "codigo":266160004,
    "descripcion":"INFECCIÓN POR TENIA SOLIUM, FORMA INTESTINAL"
  },
  {
    "codigo":298928007,
    "descripcion":"ARTICULACIÓN DE CODO DOLOROSA A LA PALPACIÓN"
  },
  {
    "codigo":724912008,
    "descripcion":"LESIÓN TRAUMÁTICA DE BOLSA SEROSA A NIVEL DEL BRAZO"
  },
  {
    "codigo":36784008,
    "descripcion":"INTOXICACIÓN POR FLURAZEPAM"
  },
  {
    "codigo":428165003,
    "descripcion":"HIPOTIROIDISMO DURANTE EL EMBARAZO"
  },
  {
    "codigo":788613004,
    "descripcion":"ENFERMEDAD DE ANTICUERPOS ANTI-MEMBRANA BASAL GLOMERULAR"
  },
  {
    "codigo":723077004,
    "descripcion":"MIOSARCOMA PRIMARIO DE ÚTERO"
  },
  {
    "codigo":229722000,
    "descripcion":"SISTEMA SONORO INMADURO"
  },
  {
    "codigo":1090441000119102,
    "descripcion":"INFLAMACIÓN RECIDIVANTE DE VULVA POR VIRUS DEL HERPES SIMPLE"
  },
  {
    "codigo":721242003,
    "descripcion":"MENINGITIS CAUSADA POR SPIROCHAETES"
  },
  {
    "codigo":295258005,
    "descripcion":"SOBREDOSIS DE KETOPROFENO"
  },
  {
    "codigo":162351000,
    "descripcion":"ZUMBIDO EN OÍDO"
  },
  {
    "codigo":15672201000119104,
    "descripcion":"MACRODACTILIA DE DEDO DERECHO"
  },
  {
    "codigo":129583005,
    "descripcion":"PARÁLISIS DEL PALADAR"
  },
  {
    "codigo":1145391005,
    "descripcion":"HIPOPLASIA CONGÉNITA DE MÚSCULO CUÁDRICEPS FEMORAL"
  },
  {
    "codigo":293423009,
    "descripcion":"REACCIÓN ADVERSA AL COLESTIPOL"
  },
  {
    "codigo":160516002,
    "descripcion":"ORIGEN NORTEAMERICANO"
  },
  {
    "codigo":94980009,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL CUERPO PARAÓRTICO"
  },
  {
    "codigo":93145002,
    "descripcion":"RETICULOENDOTELIOSIS LEUCÉMICA DE GANGLIOS LINFÁTICOS INTRAPÉLVICOS"
  },
  {
    "codigo":420825003,
    "descripcion":"GANGRENA DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":715737004,
    "descripcion":"PARKINSONISMO CONCOMITANTE CON DEMENCIA DE GUADALUPE"
  },
  {
    "codigo":1010649005,
    "descripcion":"SÍNDROME VESTIBULAR AGUDO POR ANSIEDAD Y MIEDO"
  },
  {
    "codigo":191449005,
    "descripcion":"DEMENCIA SENIL NO COMPLICADA"
  },
  {
    "codigo":284552004,
    "descripcion":"LACERACIÓN DE DEDO DEL PIE"
  },
  {
    "codigo":255150000,
    "descripcion":"CARCINOMA IN SITU DEL TRACTO URINARIO PROPIAMENTE DICHO"
  },
  {
    "codigo":289753009,
    "descripcion":"SIN INVOLUCIÓN ADICIONAL DEL ÚTERO"
  },
  {
    "codigo":224217004,
    "descripcion":"VIVE EN VIVIENDA FACILITADA POR EL EMPLEADOR"
  },
  {
    "codigo":680841000119109,
    "descripcion":"ÉMBOLO DE COLESTEROL DE ARTERIA DE LA RETINA DE AMBOS OJOS"
  },
  {
    "codigo":1303726005,
    "descripcion":"DISECCIÓN DE AORTA INFRARRENAL"
  },
  {
    "codigo":1172654005,
    "descripcion":"LIPOPROTEÍNA DE ALTA DENSIDAD POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":23939000,
    "descripcion":"FUSIÓN IMPERFECTA DEL CRÁNEO"
  },
  {
    "codigo":124078008,
    "descripcion":"NIVEL DE BILIRRUBINA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":253315002,
    "descripcion":"INTERRUPCIÓN DE LA VENA CAVA INFERIOR CON LA CONTINUACIÓN DE LA VENA ÁCIGOS BILATERAL"
  },
  {
    "codigo":286083005,
    "descripcion":"DIFICULTAD PARA GUARDAR LA ROPA LAVADA"
  },
  {
    "codigo":284248000,
    "descripcion":"NO REALIZA FUNCIONES CON LA MANO"
  },
  {
    "codigo":1269123008,
    "descripcion":"METÁSTASIS DE CARCINOMA ESCAMOSO EN RECTO"
  },
  {
    "codigo":710232008,
    "descripcion":"NARIZ EN SILLA DE MONTAR CONGÉNITA"
  },
  {
    "codigo":251480009,
    "descripcion":"ACTIVIDAD THETA GENERALIZADA INTERMITENTE"
  },
  {
    "codigo":20269002,
    "descripcion":"HIPOCALIEMIA, DESPLAZAMIENTOS DE LÍQUIDO EXTRACELULAR A LÍQUIDO INTRACELULAR"
  },
  {
    "codigo":16301091000119107,
    "descripcion":"MELANOSIS ADQUIRIDA PRIMARIA DE CONJUNTIVA DE OJO IZQUIERDO"
  },
  {
    "codigo":249645005,
    "descripcion":"ESFÍNTER ANAL CON HIPERTONO"
  },
  {
    "codigo":184109007,
    "descripcion":"DATOS DE REGISTRO DEL PACIENTE - DESCONOCIDOS"
  },
  {
    "codigo":1263618001,
    "descripcion":"TRASTORNO NEONATAL PRECOZ DEBIDO A DISFUNCIÓN UTERINA HIPOTÓNICA"
  },
  {
    "codigo":313346003,
    "descripcion":"VÁRICES DE LAS PIERNAS DISTRIBUIDAS EN EL TERRITORIO DE LA VENA SAFENA INTERNA, CON ECCEMA"
  },
  {
    "codigo":247810008,
    "descripcion":"MIEDO A ORINARSE"
  },
  {
    "codigo":213207003,
    "descripcion":"COMPLICACIONES EN EL SISTEMA NERVIOSO CENTRAL DERIVADAS DE LA ATENCIÓN"
  },
  {
    "codigo":1163479009,
    "descripcion":"RETINITIS HERPÉTICA"
  },
  {
    "codigo":735660007,
    "descripcion":"CUERPO EXTRAÑO NO MAGNÉTICO RETENIDO EN AMBOS OJOS DEBIDO A LESIÓN TRAUMÁTICA OCULAR Y POSTERIOR A ELLA"
  },
  {
    "codigo":80300008,
    "descripcion":"INTOXICACIÓN POR ESTREPTOMICINA"
  },
  {
    "codigo":12929001,
    "descripcion":"PRESIÓN ARTERIAL SISTÓLICA NORMAL"
  },
  {
    "codigo":373377004,
    "descripcion":"GRADO HISTOLÓGICO MODERADAMENTE DIFERENCIADO - HALLAZGO"
  },
  {
    "codigo":699222000,
    "descripcion":"DISCREPANCIA EN EL TAMAÑO DE LOS DIENTES"
  },
  {
    "codigo":830294002,
    "descripcion":"PAPILA ÓPTICA APLANADA"
  },
  {
    "codigo":109398003,
    "descripcion":"DISOSTOSIS DEL MAXILAR"
  },
  {
    "codigo":240470005,
    "descripcion":"INFECCIÓN TORÁCICA POR HERPES ZÓSTER"
  },
  {
    "codigo":76630008,
    "descripcion":"PLEURESÍA FIBRINOPURULENTA"
  },
  {
    "codigo":238635004,
    "descripcion":"ACANTOSIS NIGRICANS MEDICAMENTOSA"
  },
  {
    "codigo":369707005,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA PROXIMAL DE INTESTINO GRUESO, SIN COMPROMISO TUMORAL"
  },
  {
    "codigo":402475008,
    "descripcion":"QUILOMICRONEMIA PRIMARIA ADQUIRIDA"
  },
  {
    "codigo":105728003,
    "descripcion":"OBSERVACIÓN Y\/O DIAGNÓSTICO DE ENFERMERÍA"
  },
  {
    "codigo":72960004,
    "descripcion":"RABDOMIÓLISIS DEL EJERCICIO"
  },
  {
    "codigo":1092951000119106,
    "descripcion":"NEUMONÍA CAUSADA POR BORDETELLA PARAPERTUSSIS"
  },
  {
    "codigo":236800005,
    "descripcion":"INSUFICIENCIA ESPERMATOGÉNICA PRIMARIA"
  },
  {
    "codigo":40192003,
    "descripcion":"MARCHA DEL GLÚTEO MEDIO"
  },
  {
    "codigo":202197003,
    "descripcion":"LUXACIÓN PATOLÓGICA DE ARTICULACIÓN METATARSOFALÁNGICA DE SEGUNDO A QUINTO DEDOS"
  },
  {
    "codigo":234965004,
    "descripcion":"AMELOGÉNESIS IMPERFECTA - HIPOMADURACIÓN- PIGMENTACIÓN RECESIVA"
  },
  {
    "codigo":300501005,
    "descripcion":"DOLOR A LA PALPACIÓN DE EPIDÍDIMO"
  },
  {
    "codigo":366037008,
    "descripcion":"CLARIDAD DE LA CÁPSULA DEL CRISTALINO EN LA SEUDOFAQUIA - HALLAZGO"
  },
  {
    "codigo":398805009,
    "descripcion":"PÉRDIDA DE LA SENSIBILIDAD PROTECTORA DE LA PIEL"
  },
  {
    "codigo":724650000,
    "descripcion":"SARCOMA FOLICULAR PRIMARIO DE CÉLULAS DENDRÍTICAS"
  },
  {
    "codigo":69290001,
    "descripcion":"PASAJERO EN ASIENTO TRASERO EN ACCIDENTE VEHICULAR Y\/O DE TRÁNSITO"
  },
  {
    "codigo":3754002,
    "descripcion":"DISPLASIA DE LA VAGINA"
  },
  {
    "codigo":15648241000119103,
    "descripcion":"ANEURISMA DE PORCIÓN INTRACRANEAL DE ARTERIA CARÓTIDA INTERNA IZQUIERDA"
  },
  {
    "codigo":298666007,
    "descripcion":"SIN AMPLITUD PASIVA DE ROTACIÓN HACIA LA IZQUIERDA DE COLUMNA LUMBAR"
  },
  {
    "codigo":296831000,
    "descripcion":"SOBREDOSIS DE TIOUREA"
  },
  {
    "codigo":67455003,
    "descripcion":"HIPERNATREMIA ESENCIAL"
  },
  {
    "codigo":427903006,
    "descripcion":"ANAFILAXIA CAUSADA POR PEZ"
  },
  {
    "codigo":1179732000,
    "descripcion":"REACCIÓN ADVERSA A CASIRIVIMAB Y\/O IMDEVIMAB"
  },
  {
    "codigo":1279871009,
    "descripcion":"SÍNDROME DE CORDÓN CENTRAL DE MÉDULA LUMBAR DEBIDO A LESIÓN TRAUMÁTICA"
  },
  {
    "codigo":34687008,
    "descripcion":"HIPERTROFIA DE CONDUCTO DEFERENTE"
  },
  {
    "codigo":720980004,
    "descripcion":"SÍNDROME DE ALOPECIA, EPILEPSIA PSICOMOTRIZ, PIORREA PERIODONTAL Y DISCAPACIDAD INTELECTUAL"
  },
  {
    "codigo":294996005,
    "descripcion":"ALERGIA A HIDROFLUMETIAZIDA"
  },
  {
    "codigo":426068005,
    "descripcion":"DOLOR PROVOCADO POR UN ALTERCADO"
  },
  {
    "codigo":131156007,
    "descripcion":"GRUPO SANGUÍNEO A>EL<"
  },
  {
    "codigo":194857001,
    "descripcion":"INFARTO DE MIOCARDIO SUBSIGUIENTE DE PARED ANTERIOR"
  },
  {
    "codigo":162089003,
    "descripcion":"MATERIA FECAL NORMAL"
  },
  {
    "codigo":293161003,
    "descripcion":"REACCIÓN ADVERSA A LA FLUCLOROLONA"
  },
  {
    "codigo":63785008,
    "descripcion":"AMPOLLA POR FRICCIÓN SIN INFECCIÓN"
  },
  {
    "codigo":1208830003,
    "descripcion":"QUERATITIS INTERSTICIAL AUTOINMUNITARIA"
  },
  {
    "codigo":94718004,
    "descripcion":"SARCOMA MIELOIDE EN REMISIÓN"
  },
  {
    "codigo":225790006,
    "descripcion":"HALLAZGO RELACIONADO CON LA AUTONOMÍA Y EL FORTALECIMIENTO"
  },
  {
    "codigo":291326008,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR ATROPINA"
  },
  {
    "codigo":125651003,
    "descripcion":"HERIDA ABIERTA DE MUÑECA"
  },
  {
    "codigo":289491005,
    "descripcion":"HALLAZGO RELACIONADO CON LA SENSACIÓN VULVAR"
  },
  {
    "codigo":92883006,
    "descripcion":"FUSIÓN ANORMAL CONGÉNITA DEL VÓMER"
  },
  {
    "codigo":191187006,
    "descripcion":"TALASEMIA DE RASGO ALFA"
  },
  {
    "codigo":123816006,
    "descripcion":"ESTRONCIURESIS"
  },
  {
    "codigo":1336232007,
    "descripcion":"TRASTORNO POR USO DE CATINONA SINTÉTICA"
  },
  {
    "codigo":1303464008,
    "descripcion":"GLAUCOMA DE ÁNGULO ABIERTO DE OJO DERECHO DEBIDO A TRASTORNO VASCULAR"
  },
  {
    "codigo":285821001,
    "descripcion":"INCAPAZ DE ABRIR LAS CANILLAS DE AGUA"
  },
  {
    "codigo":254888007,
    "descripcion":"CARCINOMA ADENOESCAMOSO DE CUELLO UTERINO"
  },
  {
    "codigo":416893007,
    "descripcion":"ÁNTRAX"
  },
  {
    "codigo":685861000119102,
    "descripcion":"LIPOSARCOMA PRIMARIO DE PARTES BLANDAS DE GLÚTEO"
  },
  {
    "codigo":138891000119109,
    "descripcion":"RETINOPATÍA NO PROLIFERATIVA MODERADA DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":251218006,
    "descripcion":"ONDA U ACORTADA"
  },
  {
    "codigo":249383001,
    "descripcion":"HALLAZGO RELACIONADO CON LA SUPERFICIE DE LA LENGUA"
  },
  {
    "codigo":282151003,
    "descripcion":"CAMINA SOBRE TERRENO PLANO"
  },
  {
    "codigo":247548007,
    "descripcion":"PELOS EN SIGNO DE EXCLAMACIÓN"
  },
  {
    "codigo":278481001,
    "descripcion":"SÍFILIS CUATERNARIA"
  },
  {
    "codigo":1359825002,
    "descripcion":"BAJO ESTRÉS PERCIBIDO"
  },
  {
    "codigo":1163217004,
    "descripcion":"LESIÓN POR PRESIÓN GRADO 1"
  },
  {
    "codigo":81873006,
    "descripcion":"DEFECTO DE YODURO PEROXIDASA"
  },
  {
    "codigo":409553007,
    "descripcion":"FIEBRE Q AGUDA"
  },
  {
    "codigo":737233008,
    "descripcion":"CONMOCIÓN DE MÉDULA ESPINAL CERVICAL"
  },
  {
    "codigo":11826981000119108,
    "descripcion":"LESIÓN TRAUMÁTICA DE ARTERIA FEMORAL IZQUIERDA"
  },
  {
    "codigo":473254000,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO DE MÚLTIPLES SITIOS DE LA CARA SIN COMPROMISO DEL OJO PROPIAMENTE DICHO"
  },
  {
    "codigo":276646003,
    "descripcion":"HIPERCALCEMIA IDIOPÁTICA DEL LACTANTE - FORMA LEVE"
  },
  {
    "codigo":1259686004,
    "descripcion":"CARCINOMA NO MICROCÍTICO PRIMARIO DE PULMÓN CON FUSIÓN DEL GEN DE LA NEURREGULINA 1"
  },
  {
    "codigo":16906021000119109,
    "descripcion":"CARCINOMA DE CÉLULAS DE MERKEL PRIMARIO DE PIEL DE PÁRPADO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":243878006,
    "descripcion":"SITUACIÓN DE CRIBADO PARA NEOPLASIA DE MAMA"
  },
  {
    "codigo":47270006,
    "descripcion":"HIPERCORTISOLISMO"
  },
  {
    "codigo":1290619001,
    "descripcion":"SIN RESERVA DE VACUNA"
  },
  {
    "codigo":211110009,
    "descripcion":"PICADURA DE INSECTO, NO VENENOSO, EN FLANCO"
  },
  {
    "codigo":405883001,
    "descripcion":"FENOTIPO M-N+"
  },
  {
    "codigo":274811005,
    "descripcion":"PARÁLISIS, AUSENTE"
  },
  {
    "codigo":307579008,
    "descripcion":"HEMATOMA ESCROTAL TRAUMÁTICO"
  },
  {
    "codigo":15978431000119106,
    "descripcion":"TROMBOSIS DE ARTERIA VERTEBRAL DERECHA"
  },
  {
    "codigo":305744005,
    "descripcion":"ATENDIDO POR ENFERMERA PSICOTERAPEUTA"
  },
  {
    "codigo":830032008,
    "descripcion":"QUISTE DERMOIDE DE LÓBULO OCCIPITAL"
  },
  {
    "codigo":404048009,
    "descripcion":"RABDOMIOMA DEL ADULTO"
  },
  {
    "codigo":331711000119107,
    "descripcion":"BLEFARITIS DE PÁRPADO SUPERIOR DERECHO"
  },
  {
    "codigo":613093311000119107,
    "descripcion":"INTOXICACIÓN CAUSADA POR ÁCIDO VALPROICO"
  },
  {
    "codigo":15650751000119107,
    "descripcion":"SARCOMA PRIMARIO DE PÁNCREAS"
  },
  {
    "codigo":369445005,
    "descripcion":"PROCTOCOLITIS CRÓNICA"
  },
  {
    "codigo":762661006,
    "descripcion":"DISFUNCIÓN DE DERIVACIÓN DE DESFIBRILADOR CARDÍACO IMPLANTABLE"
  },
  {
    "codigo":402213006,
    "descripcion":"ECCEMA DISCOIDE SECO"
  },
  {
    "codigo":433146000,
    "descripcion":"ENFERMEDAD RENAL CRÓNICA, ESTADIO 5"
  },
  {
    "codigo":271141008,
    "descripcion":"AMPOLLA TRAUMÁTICA DE LA INGLE, INFECTADA"
  },
  {
    "codigo":302074003,
    "descripcion":"HALLAZGO RELACIONADO CON LA FUNCIÓN TIROIDEA"
  },
  {
    "codigo":236538004,
    "descripcion":"COMPLICACIONES AGUDAS DE LA HEMODIÁLISIS"
  },
  {
    "codigo":5327000,
    "descripcion":"ENDOMETRIOSIS DEL LIGAMENTO REDONDO"
  },
  {
    "codigo":1186810009,
    "descripcion":"PROTOPORFIRIA ERITROPOYÉTICA DEBIDA A GANANCIA DE FUNCIÓN EN EL GEN AMINOLEVULÍNICO ÁCIDO SINTETASA 2"
  },
  {
    "codigo":726223003,
    "descripcion":"LACERACIÓN DE FASCIA DE MÚSCULO DE LA CADERA"
  },
  {
    "codigo":201935006,
    "descripcion":"ARTROPATÍA TRAUMÁTICA DE LA MANO"
  },
  {
    "codigo":103631007,
    "descripcion":"CANTIDAD NORMAL DE CÉLULAS"
  },
  {
    "codigo":365775007,
    "descripcion":"NIVEL DE CATECOLAMINA - HALLAZGO"
  },
  {
    "codigo":167332001,
    "descripcion":"MICROSCOPIA URINARIA - NO SE DETECTARON ANOMALÍAS"
  },
  {
    "codigo":1119439008,
    "descripcion":"ATROFIA DE MÚSCULO DE PIERNA Y ANTEBRAZO"
  },
  {
    "codigo":296569002,
    "descripcion":"SOBREDOSIS DE MEFLOQUINA"
  },
  {
    "codigo":394873005,
    "descripcion":"NO INTERESADO EN DEJAR DE FUMAR"
  },
  {
    "codigo":722553006,
    "descripcion":"SECUELA DE TRACOMA"
  },
  {
    "codigo":1657008,
    "descripcion":"INTOXICACIÓN POR MEVINFOS"
  },
  {
    "codigo":65358001,
    "descripcion":"DEFORMIDAD EN VALGO ADQUIRIDA DEL DEDO GORDO"
  },
  {
    "codigo":263801008,
    "descripcion":"LEÑOSO"
  },
  {
    "codigo":11993331000119102,
    "descripcion":"CONGELAMIENTO DE PIE IZQUIERDO"
  },
  {
    "codigo":153211000146100,
    "descripcion":"OLVIDO EN ADMINISTRACIÓN DE MEDICACIÓN POR PROFESIONAL DE SALUD"
  },
  {
    "codigo":294734004,
    "descripcion":"ALERGIA A GLIPIZIDA"
  },
  {
    "codigo":32590007,
    "descripcion":"AMENORREA PREMENOPÁUSICA"
  },
  {
    "codigo":292899003,
    "descripcion":"REACCIÓN ADVERSA AL DOMIFENO"
  },
  {
    "codigo":1144867003,
    "descripcion":"HIPOPLASIA CONGÉNITA DE CLÍTORIS"
  },
  {
    "codigo":717048002,
    "descripcion":"HIPERINSULINISMO DEBIDO A DEFICIENCIA DE FACTOR NUCLEAR 4-ALFA"
  },
  {
    "codigo":422136003,
    "descripcion":"NEURALGIA CON SÍNDROME DE INMUNODEFICIENCIA ADQUIRIDA"
  },
  {
    "codigo":94456004,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL PALADAR"
  },
  {
    "codigo":225528005,
    "descripcion":"ESCLAVITUD"
  },
  {
    "codigo":61688009,
    "descripcion":"SOBREHIDRATACIÓN"
  },
  {
    "codigo":289229002,
    "descripcion":"REACIA A PUJAR EN EL TRABAJO DE PARTO"
  },
  {
    "codigo":1306872009,
    "descripcion":"SOSPECHA DE GLAUCOMA BILATERAL"
  },
  {
    "codigo":90786000,
    "descripcion":"AUSENCIA DE REFLEJO PALATINO"
  },
  {
    "codigo":92621008,
    "descripcion":"CARCINOMA IN SITU DE YEYUNO"
  },
  {
    "codigo":92083007,
    "descripcion":"NEOPLASIA BENIGNA DEL ENDOCARDIO"
  },
  {
    "codigo":254626006,
    "descripcion":"ADENOCARCINOMA DEL PULMÓN"
  },
  {
    "codigo":1268599000,
    "descripcion":"INFECCIÓN DE HERIDA DEBIDA A MORDEDURA DE PERRO"
  },
  {
    "codigo":23415000,
    "descripcion":"ESGUINCE DE LA MANDÍBULA"
  },
  {
    "codigo":1137527002,
    "descripcion":"CALCIFICACIÓN PUNTEADA DE EPÍFISIS DE FALANGE DISTAL DE QUINTO DEDO DE PIE"
  },
  {
    "codigo":187255005,
    "descripcion":"SECUELAS TARDÍAS DE LA TUBERCULOSIS DE HUESOS Y ARTICULACIONES"
  },
  {
    "codigo":88951006,
    "descripcion":"INTOXICACIÓN POR CYNOGLOSSUM OFFICINALE"
  },
  {
    "codigo":711543008,
    "descripcion":"DISOSTOSIS MANDIBULOFACIAL CON MICROCEFALIA"
  },
  {
    "codigo":283724001,
    "descripcion":"MORDEDURA HUMANA EN LA PIERNA"
  },
  {
    "codigo":21580006,
    "descripcion":"HEMATOMA Y CONTUSIÓN DE HÍGADO CON HERIDA ABIERTA HACIA CAVIDAD ABDOMINAL"
  },
  {
    "codigo":185420007,
    "descripcion":"CITA REALIZADA POR TELÉFONO"
  },
  {
    "codigo":334221000119107,
    "descripcion":"DERMATOCALASIA DE PÁRPADO INFERIOR DERECHO"
  },
  {
    "codigo":314657006,
    "descripcion":"PERÍMETRO CEFÁLICO DEL NIÑO: PERCENTILO 92-97"
  },
  {
    "codigo":609569007,
    "descripcion":"DIABETES MELLITUS DEBIDA A DEFECTO GENÉTICO EN LA ACCIÓN DE LA INSULINA"
  },
  {
    "codigo":712840004,
    "descripcion":"ALERGIA A AVELLANA"
  },
  {
    "codigo":247286002,
    "descripcion":"HALLAZGO RELACIONADO CON LA RESPUESTA AL SONIDO"
  },
  {
    "codigo":443894002,
    "descripcion":"ACIDURIA ALFA CETOADÍPICA"
  },
  {
    "codigo":312822006,
    "descripcion":"ISQUEMIA CRÍTICA DEL PIE"
  },
  {
    "codigo":442059001,
    "descripcion":"TRASTORNO MIXTO DEL DESARROLLO"
  },
  {
    "codigo":702368000,
    "descripcion":"CARCINOSARCOMA DE OVARIO"
  },
  {
    "codigo":835275009,
    "descripcion":"PALADAR BLANDO, FAUCES Y ÚVULA PALATINA VISIBLES"
  },
  {
    "codigo":14240001,
    "descripcion":"POLIOSIS"
  },
  {
    "codigo":276384002,
    "descripcion":"RUIDOS HIDROAÉREOS CONTINUOS"
  },
  {
    "codigo":472992004,
    "descripcion":"DESARROLLO NORMAL DE CARACTERES SEXUALES SECUNDARIOS"
  },
  {
    "codigo":704203009,
    "descripcion":"NEFROPATÍA CAUSADA POR CICLOSPORINA"
  },
  {
    "codigo":241781000,
    "descripcion":"EFECTO TÓXICO CAUSADO POR ACEITE DE ARGEMONE"
  },
  {
    "codigo":1259424009,
    "descripcion":"LENTIGO MALIGNO MELANOMA PRIMARIO"
  },
  {
    "codigo":307317002,
    "descripcion":"RUPTURA DE ARTERIA TIBIAL ANTERIOR"
  },
  {
    "codigo":733301003,
    "descripcion":"INFLAMACIÓN DIFUSA DE ÓRBITA"
  },
  {
    "codigo":16583361000119101,
    "descripcion":"ARTROSIS DE ARTICULACIÓN DE TOBILLO DERECHO"
  },
  {
    "codigo":209013002,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA NO EXPUESTA DE PIE"
  },
  {
    "codigo":403786001,
    "descripcion":"ENFERMEDAD DE DARIER CON AFECTACIÓN ACRA"
  },
  {
    "codigo":305482001,
    "descripcion":"BAJO ATENCIÓN DE ENDOCRINÓLOGO"
  },
  {
    "codigo":239946005,
    "descripcion":"VASCULITIS POR INMUNOGLOBULINA A POSTINFECCIOSA"
  },
  {
    "codigo":895306005,
    "descripcion":"CURVATURA ANORMAL DE FALANGE DISTAL DE DEDO MAYOR"
  },
  {
    "codigo":698698008,
    "descripcion":"BULIMIA NERVIOSA EN REMISIÓN"
  },
  {
    "codigo":1255754008,
    "descripcion":"MICOSIS FUNGOIDE DE GANGLIOS LINFÁTICOS DE CABEZA Y CUELLO"
  },
  {
    "codigo":205343003,
    "descripcion":"MACRODACTILIA DE DEDOS DEL PIE - TUMOR GRASO EN NERVIO"
  },
  {
    "codigo":762399006,
    "descripcion":"LESIÓN TRAUMÁTICA DEBIDA A INFUSIÓN Y POSTERIOR A ELLA"
  },
  {
    "codigo":238111008,
    "descripcion":"DEFICIENCIA DE MICRONUTRIENTES"
  },
  {
    "codigo":203508001,
    "descripcion":"DOLOR PÉLVICO ÓSEO"
  },
  {
    "codigo":6900000,
    "descripcion":"INTOXICACIÓN POR FENFORMINA"
  },
  {
    "codigo":72436007,
    "descripcion":"BORRAMIENTO DE LOS MÁRGENES DEL DISCO ÓPTICO"
  },
  {
    "codigo":431049001,
    "descripcion":"AMPLITUD DE EXTENSIÓN DE LA COLUMNA CERVICAL DISMINUIDA"
  },
  {
    "codigo":365513005,
    "descripcion":"HALLAZGO RELACIONADO CON EL ESTADO DE REPARACIÓN DE LA CASA"
  },
  {
    "codigo":398281007,
    "descripcion":"CONCENTRACIÓN ESPIRATORIA"
  },
  {
    "codigo":298142000,
    "descripcion":"CURVATURA TRANSVERSAL DE LA UÑA PRONUNCIADA"
  },
  {
    "codigo":234441009,
    "descripcion":"PORTADOR DE ENFERMEDAD POR DEFICIENCIA HEREDITARIA DE FACTOR VIII"
  },
  {
    "codigo":396446002,
    "descripcion":"MENOS DE UNA FIGURA MITÓTICA POR MM2"
  },
  {
    "codigo":1344883000,
    "descripcion":"HABILIDADES DIGITALES INADECUADAS"
  },
  {
    "codigo":1395008,
    "descripcion":"COMPLICACIÓN DE LA TERAPIA POR ULTRASONIDO"
  },
  {
    "codigo":196168001,
    "descripcion":"AHOGAMIENTO POR OBSTRUCCIÓN DE LAS VÍAS AÉREAS"
  },
  {
    "codigo":66931009,
    "descripcion":"HIPERCALCEMIA"
  },
  {
    "codigo":1074011000119105,
    "descripcion":"ARTRITIS GOTOSA DE DEDO GORDO DERECHO"
  },
  {
    "codigo":294472005,
    "descripcion":"ALERGIA A AZITROMICINA"
  },
  {
    "codigo":65096006,
    "descripcion":"DEMENCIA DEGENERATIVA PRIMARIA TIPO ALZHEIMER, DE INICIO EN LA EDAD PRESENIL, CON DELIRIO"
  },
  {
    "codigo":292637000,
    "descripcion":"REACCIÓN ADVERSA AL AZUFRE"
  },
  {
    "codigo":720456009,
    "descripcion":"SÍNDROME DE APARIENCIA FACIAL ACROMEGALOIDE"
  },
  {
    "codigo":423709000,
    "descripcion":"TUBERCULOSIS RESISTENTE A LOS MEDICAMENTOS"
  },
  {
    "codigo":30493003,
    "descripcion":"INFECCIÓN INTESTINAL CAUSADA POR PROTEUS MIRABILIS"
  },
  {
    "codigo":390941006,
    "descripcion":"CONTROL DE ENFERMEDAD PULMONAR OBSTRUCTIVA CRÓNICA: PENDIENTE"
  },
  {
    "codigo":16694261000119102,
    "descripcion":"FRACTURA NO EXPUESTA DE MITAD DERECHA DE HUESO OCCIPITAL"
  },
  {
    "codigo":310261000119102,
    "descripcion":"ARTRITIS GOTOSA DE TOBILLO DERECHO"
  },
  {
    "codigo":192498004,
    "descripcion":"CAMBIO DE LA PERSONALIDAD DURADERO LUEGO DE ENFERMEDAD PSIQUIÁTRICA"
  },
  {
    "codigo":126962006,
    "descripcion":"NEOPLASIA DE LA MÉDULA ESPINAL"
  },
  {
    "codigo":421874007,
    "descripcion":"TRASTORNO RESPIRATORIO CON SIDA (SÍNDROME DE INMUNODEFICIENCIA ADQUIRIDA)"
  },
  {
    "codigo":290802009,
    "descripcion":"INTOXICACIÓN POR LITIO"
  },
  {
    "codigo":26823002,
    "descripcion":"FACIES DE PARKINSON"
  },
  {
    "codigo":288967003,
    "descripcion":"DIFICULTAD PARA INICIAR EL REFLEJO DE DEGLUCIÓN"
  },
  {
    "codigo":94194009,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE VASO SANGUÍNEO DEL ANTEBRAZO"
  },
  {
    "codigo":92359006,
    "descripcion":"NEOPLASIA BENIGNA DE LA PIEL DE LA CARA"
  },
  {
    "codigo":125127009,
    "descripcion":"PESO DE ÓRGANO ANORMALMENTE DISMINUIDO"
  },
  {
    "codigo":287132002,
    "descripcion":"QUEMADURA EPIDÉRMICA DE PÁRPADO"
  },
  {
    "codigo":57756003,
    "descripcion":"TELESCOPADO"
  },
  {
    "codigo":1237404009,
    "descripcion":"UTILIZA HORMONAS COMO MÉTODO ANTICONCEPTIVO"
  },
  {
    "codigo":283462002,
    "descripcion":"HERIDA DE ARMA BLANCA EN BRAZO"
  },
  {
    "codigo":840518004,
    "descripcion":"NEOPLASIA MALIGNA MIXTA COMPLEJA Y DEL ESTROMA DE CUERPO UTERINO"
  },
  {
    "codigo":86854008,
    "descripcion":"HIPERREFLEXIA"
  },
  {
    "codigo":250694008,
    "descripcion":"APOLIPOPROTEÍNA E, FENOTIPO E3:3"
  },
  {
    "codigo":11834511000119104,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA DE PULGAR DERECHO"
  },
  {
    "codigo":19483007,
    "descripcion":"ANQUILOSIS DE LOS HUESECILLOS DEL OÍDO, EXCEPTO EL MARTILLO"
  },
  {
    "codigo":248859009,
    "descripcion":"HALLAZGO RELACIONADO CON EL TAMAÑO DE LA ESTRUCTURA VULVAR"
  },
  {
    "codigo":738544002,
    "descripcion":"METABOLIZADOR NORMAL DE DIHIDROPIRIMIDINA DESHIDROGENASA"
  },
  {
    "codigo":1197296004,
    "descripcion":"NEOPLASIA DE CÉLULAS GERMINALES MALIGNA PRIMARIA DE PLEURA"
  },
  {
    "codigo":247024006,
    "descripcion":"PARÁLISIS PUPILAR LOCALIZADA"
  },
  {
    "codigo":1076521000119100,
    "descripcion":"BURSITIS SUBDELTOIDEA DE HOMBRO DERECHO"
  },
  {
    "codigo":703941003,
    "descripcion":"TOLERANCIA AL EJERCICIO MEJORADA"
  },
  {
    "codigo":673911951000119108,
    "descripcion":"ATRAPAMIENTO DE MÚSCULO OBLICUO SUPERIOR DE OJO IZQUIERDO"
  },
  {
    "codigo":13978000,
    "descripcion":"ENDOFTALMITIS CRÓNICA"
  },
  {
    "codigo":212421009,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚLTIPLES MÚSCULOS Y TENDONES A NIVEL DE HOMBRO Y BRAZO"
  },
  {
    "codigo":409029008,
    "descripcion":"HALLAZGO RELACIONADO CON EL PROCESO DE MUERTE"
  },
  {
    "codigo":767642003,
    "descripcion":"ALERGIA A BENZODIACEPINA"
  },
  {
    "codigo":441797008,
    "descripcion":"HIPERTROFIA DE PENE"
  },
  {
    "codigo":10825001000119103,
    "descripcion":"FRACTURA EXPUESTA DE DIÁFISIS DE CUARTO HUESO METACARPIANO DE MANO DERECHA"
  },
  {
    "codigo":308890008,
    "descripcion":"CUERPO EXTRAÑO INTRABDOMINAL"
  },
  {
    "codigo":405359001,
    "descripcion":"DILUCIÓN INADECUADA DE AGENTE ANESTÉSICO INHALADO"
  },
  {
    "codigo":210586009,
    "descripcion":"DEDO MARTILLO CON LESIÓN TENDINOSA EXPUESTA"
  },
  {
    "codigo":700271001,
    "descripcion":"HIPERTRICOSIS DE PÁRPADO INFERIOR"
  },
  {
    "codigo":403524003,
    "descripcion":"ESCLEROSIS CUTÁNEA SECUNDARIA TIPO ESCLERODERMIA"
  },
  {
    "codigo":1157188005,
    "descripcion":"ESTÓMAGO PRESENTE EN EL CUADRANTE SUPERIOR IZQUIERDO DEL ABDOMEN"
  },
  {
    "codigo":1255492008,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO DE DEDO GORDO DE PIE"
  },
  {
    "codigo":303385001,
    "descripcion":"CAMBIA DE POSICIÓN"
  },
  {
    "codigo":237849008,
    "descripcion":"HIPERCALIEMIA MEDICAMENTOSA"
  },
  {
    "codigo":1351961009,
    "descripcion":"INMUNODEFICIENCIA VARIABLE COMÚN AUTOSÓMICA RECESIVA DEBIDA A MUTACIÓN DE CD21"
  },
  {
    "codigo":236014006,
    "descripcion":"SEUDOQUISTE EPIPLOICO"
  },
  {
    "codigo":168643001,
    "descripcion":"RADIOGRAFÍA SIMPLE DE CARPO ANORMAL"
  },
  {
    "codigo":301550009,
    "descripcion":"CAPAZ DE LEVANTARSE DEL INODORO"
  },
  {
    "codigo":365251006,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA CORTAR ALIMENTOS"
  },
  {
    "codigo":398019008,
    "descripcion":"LACERACIÓN PERINEAL DURANTE EL PARTO"
  },
  {
    "codigo":232344001,
    "descripcion":"RINITIS CASEOSA"
  },
  {
    "codigo":363416002,
    "descripcion":"NEOPLASIA MALIGNA DE COLÉDOCO EXTRAHEPÁTICO"
  },
  {
    "codigo":396184003,
    "descripcion":"AMBLIOPÍA ISOMETRÓPICA"
  },
  {
    "codigo":68504005,
    "descripcion":"SÍNDROME DE ATAXIA-TELANGIECTASIA"
  },
  {
    "codigo":723864009,
    "descripcion":"INFECCIÓN QUE OCASIONA ENDOCARDITIS SUBAGUDA"
  },
  {
    "codigo":789400009,
    "descripcion":"ENFERMEDAD CAUSADA POR VIRUS DEL RÍO ROSS"
  },
  {
    "codigo":1344621003,
    "descripcion":"TIENE SERVICIO DE INTERNET"
  },
  {
    "codigo":230509007,
    "descripcion":"NEUROPATÍA ÓPTICA ISQUÉMICA NO ARTERÍTICA"
  },
  {
    "codigo":286301000119102,
    "descripcion":"GANGRENA DEBIDA A ENFERMEDAD DE RAYNAUD"
  },
  {
    "codigo":296045007,
    "descripcion":"SOBREDOSIS DE CICLOBARBITAL"
  },
  {
    "codigo":64834002,
    "descripcion":"PERFORACIÓN TRAUMÁTICA DEL INTESTINO DELGADO"
  },
  {
    "codigo":294210008,
    "descripcion":"ALERGIA A TRETINOÍNA"
  },
  {
    "codigo":425282008,
    "descripcion":"INDUCCIÓN FARMACOLÓGICA DE ENZIMA CYP2C9 DEL CITOCROMO P450"
  },
  {
    "codigo":359746009,
    "descripcion":"PACIENTE ESTABLE"
  },
  {
    "codigo":128535002,
    "descripcion":"TRASTORNO DEL SEGMENTO ANTERIOR DEL OJO"
  },
  {
    "codigo":1144343003,
    "descripcion":"HIPOPLASIA CONGÉNITA DE SUSTANCIA BLANCA CEREBRAL"
  },
  {
    "codigo":62999006,
    "descripcion":"DISTROFIA ADIPOSOGENITAL"
  },
  {
    "codigo":292375007,
    "descripcion":"REACCIÓN ADVERSA A LA RISPERIDONA"
  },
  {
    "codigo":93932000,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE ÓRBITA"
  },
  {
    "codigo":95767006,
    "descripcion":"TRASTORNO DE CONDUCTO NASOLAGRIMAL"
  },
  {
    "codigo":423447006,
    "descripcion":"MELANOMA MALIGNO DE LA PIEL DEL PÁRPADO INFERIOR"
  },
  {
    "codigo":61164006,
    "descripcion":"COPROPORFIRIA ERITROPOYÉTICA"
  },
  {
    "codigo":716524009,
    "descripcion":"UTILIZA AUMENTATIVOS Y COMUNICACIÓN ALTERNATIVA"
  },
  {
    "codigo":126700009,
    "descripcion":"NEOPLASIA DE LA CARA LARÍNGEA DE LA EPIGLOTIS"
  },
  {
    "codigo":288705002,
    "descripcion":"DIFICULTAD PARA COMUNICARSE EN DIFERENTES LUGARES"
  },
  {
    "codigo":92097004,
    "descripcion":"NEOPLASIA BENIGNA DEL OJO"
  },
  {
    "codigo":59329007,
    "descripcion":"PANCREATITIS METABÓLICA"
  },
  {
    "codigo":188566001,
    "descripcion":"ENFERMEDAD DE HODGKIN, ESCLEROSIS NODULAR DE GANGLIOS LINFÁTICOS INTRATORÁCICOS"
  },
  {
    "codigo":90262003,
    "descripcion":"MORFOLOGÍA INTRACELULAR NORMAL"
  },
  {
    "codigo":57494004,
    "descripcion":"AGOTAMIENTO SENIL"
  },
  {
    "codigo":15988471000119103,
    "descripcion":"CONJUNTIVITIS DE OJO DERECHO CAUSADA POR MYCOBACTERIUM TUBERCULOSIS"
  },
  {
    "codigo":55659000,
    "descripcion":"MATIDEZ CARDÍACA DISMINUIDA"
  },
  {
    "codigo":254102008,
    "descripcion":"ENANISMO PRIMORDIAL OSTEODISPLÁSICO, TIPO 1"
  },
  {
    "codigo":285035003,
    "descripcion":"INCAPAZ DE MANEJAR LA MEDICACIÓN"
  },
  {
    "codigo":1079031000119104,
    "descripcion":"ANGIOSARCOMA PRIMARIO DE EXTREMIDAD INFERIOR IZQUIERDA"
  },
  {
    "codigo":186731007,
    "descripcion":"INFECCIÓN CLAMIDIAL DEL RECTO Y EL ANO"
  },
  {
    "codigo":283200005,
    "descripcion":"ANZUELO EN MUÑECA"
  },
  {
    "codigo":15716241000119100,
    "descripcion":"ENOSTOSIS PÉLVICA BILATERAL"
  },
  {
    "codigo":12391000132109,
    "descripcion":"INFECCIÓN FÚNGICA INVASIVA"
  },
  {
    "codigo":1231637005,
    "descripcion":"QUISTE DE EPITELIO RESPIRATORIO DE ÓRBITA"
  },
  {
    "codigo":707349007,
    "descripcion":"CARCINOMA PRIMARIO DE SENO FRONTAL"
  },
  {
    "codigo":281365008,
    "descripcion":"TOFO GOTOSO DE BOLSA SEROSA PRERROTULIANA"
  },
  {
    "codigo":84757009,
    "descripcion":"EPILEPSIA"
  },
  {
    "codigo":736447000,
    "descripcion":"ARTRALGIA EPISÓDICA INFRECUENTE DE ARTICULACIÓN TEMPOROMANDIBULAR"
  },
  {
    "codigo":246762009,
    "descripcion":"NISTAGMO PARÉTICO"
  },
  {
    "codigo":441535001,
    "descripcion":"ADENOCARCINOMA DE CABEZA Y\/O CUELLO"
  },
  {
    "codigo":151441000119105,
    "descripcion":"NACIMIENTO GEMELAR DE NIÑOS VIVOS EN HOSPITAL POR PARTO VAGINAL"
  },
  {
    "codigo":110185000,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO DE LA FRENTE"
  },
  {
    "codigo":92552003,
    "descripcion":"CARCINOMA IN SITU DE BRONQUIO DEL LÓBULO INFERIOR IZQUIERDO DEL PULMÓN"
  },
  {
    "codigo":44649003,
    "descripcion":"ESTADIO L0"
  },
  {
    "codigo":208489007,
    "descripcion":"FRACTURA EXPUESTA DE FALANGE DISTAL DE DEDO DE LA MANO, BASE"
  },
  {
    "codigo":700009007,
    "descripcion":"LESIÓN TRAUMÁTICA DE CINTURA PÉLVICA"
  },
  {
    "codigo":11784081000119108,
    "descripcion":"HERIDA INFECTADA DE MUÑECA IZQUIERDA DEBIDA A PICADURA DE INSECTO NO VENENOSO"
  },
  {
    "codigo":370494002,
    "descripcion":"NEFROPATÍA CON PÉRDIDA DE PROTEÍNAS"
  },
  {
    "codigo":403262004,
    "descripcion":"PIGMENTACIÓN CUTÁNEA CON HEMOSIDERINA POR INSUFICIENCIA VENOSA"
  },
  {
    "codigo":42814007,
    "descripcion":"PUERPERIO MEDIATO"
  },
  {
    "codigo":40979000,
    "descripcion":"FALTA DE EJERCICIO"
  },
  {
    "codigo":47071000087103,
    "descripcion":"FRACTURA DE FALANGE PROXIMAL DE DEDO PULGAR DERECHO"
  },
  {
    "codigo":71912000,
    "descripcion":"COLANGITIS CRÓNICA"
  },
  {
    "codigo":8211008,
    "descripcion":"CONJUNTIVITIS CRÓNICA SIMPLE"
  },
  {
    "codigo":39391000087106,
    "descripcion":"DISTENSIÓN DE MÚSCULO POSTERIOR DE MUSLO DERECHO"
  },
  {
    "codigo":237587009,
    "descripcion":"ANOMALÍA DE LA SECRECIÓN DE GLICENTINA"
  },
  {
    "codigo":44511000087105,
    "descripcion":"DOLOR OROFACIAL CRÓNICO DEBIDO A ENFERMEDAD INFECCIOSA"
  },
  {
    "codigo":41951000087103,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE CUARTO DEDO DE PIE DERECHO"
  },
  {
    "codigo":301288007,
    "descripcion":"RESPIRACIÓN SILENCIOSA"
  },
  {
    "codigo":792808008,
    "descripcion":"INGESTA INADECUADA DE FOLATO Y\/O DERIVADO DE FOLATO"
  },
  {
    "codigo":364989002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA USAR APOYO RESPIRATORIO PARA HABLAR"
  },
  {
    "codigo":344261000119101,
    "descripcion":"OFTALMOPLEJÍA EXTERNA PROGRESIVA BILATERAL"
  },
  {
    "codigo":725437002,
    "descripcion":"VARIANTE DE MUTACIÓN GENÉTICA DE LEUCEMIA LINFOCÍTICA CRÓNICA"
  },
  {
    "codigo":299453008,
    "descripcion":"ARTICULACIÓN DE TOBILLO - AZUL"
  },
  {
    "codigo":199314001,
    "descripcion":"PARTO NORMAL CON PRESENCIA DE ENFERMEDADES PRENATALES O POSNATALES"
  },
  {
    "codigo":233917008,
    "descripcion":"BLOQUEO AURICULOVENTRICULAR"
  },
  {
    "codigo":232082003,
    "descripcion":"GLAUCOMA IATROGÉNICO DE ÁNGULO AGUDO"
  },
  {
    "codigo":102845008,
    "descripcion":"CILINDRO URINARIO, CÉREO ANCHO"
  },
  {
    "codigo":721767001,
    "descripcion":"INFECCIÓN DE PIEL Y\/O MEMBRANA MUCOSA CAUSADA POR VIRUS HERPES SIMPLE"
  },
  {
    "codigo":230247001,
    "descripcion":"ATROFIA MUSCULAR ESPINAL DISTAL"
  },
  {
    "codigo":871005,
    "descripcion":"PELVIS CONTRAÍDA"
  },
  {
    "codigo":263015006,
    "descripcion":"LUXACIÓN DE LA ARTICULACIÓN ATLOAXOIDEA"
  },
  {
    "codigo":64572001,
    "descripcion":"ENFERMEDAD"
  },
  {
    "codigo":293948002,
    "descripcion":"ALERGIA A FLUPENTIXOL"
  },
  {
    "codigo":295783009,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE FORMESTANO"
  },
  {
    "codigo":1110081000000100,
    "descripcion":"HIPERTENSIÓN OCULAR PRIMARIA"
  },
  {
    "codigo":31804002,
    "descripcion":"DESMAYO PARCIAL"
  },
  {
    "codigo":292113001,
    "descripcion":"REACCIÓN ADVERSA AL LANSOPRAZOL"
  },
  {
    "codigo":95505003,
    "descripcion":"PUNTO LAGRIMAL PEQUEÑO CONGÉNITO"
  },
  {
    "codigo":128273004,
    "descripcion":"ÁNTRAX DE LA REGIÓN DE LA CABEZA"
  },
  {
    "codigo":62737003,
    "descripcion":"INFECCIÓN CAUSADA POR CRATEROSTOMUM"
  },
  {
    "codigo":161041005,
    "descripcion":"TIENE DISTINTIVO ANARANJADO DE CONDUCTOR DISCAPACITADO"
  },
  {
    "codigo":718097008,
    "descripcion":"HIPERPLASIA LINFOIDE NODULAR DE PULMÓN"
  },
  {
    "codigo":880102003,
    "descripcion":"INGESTA EXCESIVA DE NIACINA"
  },
  {
    "codigo":290278004,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR NABUMETONA"
  },
  {
    "codigo":1142246005,
    "descripcion":"HIPERTROFIA DE MÚSCULO DE PANTORRILLA"
  },
  {
    "codigo":16046431000119103,
    "descripcion":"ENFERMEDAD POR DEPÓSITO DE HIDROXIAPATITA DE AMBOS TOBILLOS"
  },
  {
    "codigo":153951000119103,
    "descripcion":"INSUFICIENCIA CARDÍACA SISTÓLICA Y DIASTÓLICA COMBINADA CRÓNICA REAGUDIZADA"
  },
  {
    "codigo":716262008,
    "descripcion":"CORYNEBACTERIUM GLUCURONOLYTICUM O CORYNEBACTERIUM RIEGELII"
  },
  {
    "codigo":26299000,
    "descripcion":"NECROSIS DEL TABIQUE NASAL"
  },
  {
    "codigo":93670003,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA CARA ANTERIOR DE LA EPIGLOTIS"
  },
  {
    "codigo":288443003,
    "descripcion":"INCAPAZ DE REALIZAR ACTIVIDADES DE ESCRITURA"
  },
  {
    "codigo":419515007,
    "descripcion":"REACCIÓN ALÉRGICA CAUSADA POR DETERGENTE"
  },
  {
    "codigo":253840000,
    "descripcion":"DUPLICACIÓN DE GENITALES EXTERNOS"
  },
  {
    "codigo":286608004,
    "descripcion":"AVULSIÓN TRAUMÁTICA DE NERVIO PERIFÉRICO"
  },
  {
    "codigo":252005008,
    "descripcion":"CISTOCELE FEMENINO"
  },
  {
    "codigo":88165009,
    "descripcion":"INTOXICACIÓN POR TETRACAÍNA"
  },
  {
    "codigo":282938009,
    "descripcion":"SE INCLINA HACIA ABAJO"
  },
  {
    "codigo":1264143004,
    "descripcion":"DAÑO DE INTESTINO GRUESO POSTERIOR A EMBARAZO ECTÓPICO"
  },
  {
    "codigo":707087005,
    "descripcion":"CON MAYOR RIESGO DE VIOLENCIA DOMÉSTICA"
  },
  {
    "codigo":1296911007,
    "descripcion":"POLIURIA HEREDITARIA RELACIONADA CON ARGININA-VASOPRESINA"
  },
  {
    "codigo":770788000,
    "descripcion":"SÍNDROME DE ESTATURA ALTA, ESCOLIOSIS Y MACRODACTILIA DEL DEDO GORDO"
  },
  {
    "codigo":836324001,
    "descripcion":"AGUDEZA VISUAL CON AGUJERO ESTENOPEICO DE OJO DERECHO 6\/5"
  },
  {
    "codigo":277433005,
    "descripcion":"DIFICULTAD PARA ESCUCHAR EN AMBIENTE RUIDOSO"
  },
  {
    "codigo":80825009,
    "descripcion":"HIPOPLASIA CONGÉNITA DEL PULMÓN"
  },
  {
    "codigo":242830002,
    "descripcion":"SOBREDOSIS INTENCIONAL DE DIHIDROCODEÍNA"
  },
  {
    "codigo":78990003,
    "descripcion":"CONDUCTA COMPULSIVA SIN UN PROPÓSITO ESPECÍFICO"
  },
  {
    "codigo":275598004,
    "descripcion":"HIPERLIPOPROTEINEMIA, TIPO I"
  },
  {
    "codigo":111758009,
    "descripcion":"INTOXICACIÓN CAUSADA POR ENZIMAS"
  },
  {
    "codigo":1084051000119104,
    "descripcion":"PÉRDIDA DE LA AUDICIÓN CONDUCTIVA DE AMBOS OÍDOS MEDIOS"
  },
  {
    "codigo":109923005,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LOS NERVIOS PERIFÉRICOS DE LA CABEZA"
  },
  {
    "codigo":11619008,
    "descripcion":"SÍNDROME DE TORSIÓN - VÓLVULO - DILATACIÓN GÁSTRICA"
  },
  {
    "codigo":208227009,
    "descripcion":"FRACTURA NO EXPUESTA DEL CUERPO DEL OMÓPLATO"
  },
  {
    "codigo":403000003,
    "descripcion":"CANDIDIASIS SISTÉMICA NEONATAL"
  },
  {
    "codigo":239160006,
    "descripcion":"HEMATOMA DE HERIDA"
  },
  {
    "codigo":237325000,
    "descripcion":"ATRAPAMIENTO CEFÁLICO DURANTE EL PARTO DE NALGAS"
  },
  {
    "codigo":697912009,
    "descripcion":"HIPERTENSIÓN PULMONAR DEBIDA A ENFERMEDAD PULMONAR INTERSTICIAL"
  },
  {
    "codigo":204557007,
    "descripcion":"FISURA CONGÉNITA DE LA EPIGLOTIS"
  },
  {
    "codigo":302861008,
    "descripcion":"CONDROMATOSIS"
  },
  {
    "codigo":301026000,
    "descripcion":"PÉRDIDA DE CONFIANZA"
  },
  {
    "codigo":366562004,
    "descripcion":"AMPLITUD DE MOVIMIENTO ACTIVO DE FLEXIÓN DE CADERA - HALLAZGO"
  },
  {
    "codigo":233655000,
    "descripcion":"ENGROSAMIENTO PLEURAL DIFUSO BILATERAL, INDUCIDO POR AMIANTO"
  },
  {
    "codigo":299191002,
    "descripcion":"AMPLITUD DE OPOSICIÓN PASIVA DEL PULGAR AUMENTADA"
  },
  {
    "codigo":69815004,
    "descripcion":"INFECCIÓN CAUSADA POR MOLINEUS"
  },
  {
    "codigo":364727009,
    "descripcion":"ADAPTACIÓN GENERAL AL CALZADO - HALLAZGO"
  },
  {
    "codigo":788876001,
    "descripcion":"CAQUEXIA DEBIDA A ENFERMEDAD NEOPLÁSICA MALIGNA"
  },
  {
    "codigo":295521006,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE METOHEXITONA"
  },
  {
    "codigo":721505009,
    "descripcion":"SÍNDROME DEL CORDÓN CENTRAL DE MÉDULA ESPINAL LUMBAR"
  },
  {
    "codigo":228150001,
    "descripcion":"ALTERACIÓN DE LA SALUD MENTAL"
  },
  {
    "codigo":129846003,
    "descripcion":"POLIFARMACIA"
  },
  {
    "codigo":195382003,
    "descripcion":"NEVO TELANGIECTÁSICO"
  },
  {
    "codigo":293686008,
    "descripcion":"ALERGIA A SEN"
  },
  {
    "codigo":424758008,
    "descripcion":"HEPATITIS POR VIRUS A SIN COMA HEPÁTICO, SIN HEPATITIS D"
  },
  {
    "codigo":422923002,
    "descripcion":"RECURSOS COMUNITARIOS INADECUADOS"
  },
  {
    "codigo":717835002,
    "descripcion":"ATRESIA DE ESÓFAGO SIN FÍSTULA TRAQUEOESOFÁGICA"
  },
  {
    "codigo":95243004,
    "descripcion":"SÍNDROME DE ROLLAND - DEBUGOIS"
  },
  {
    "codigo":160779001,
    "descripcion":"QUIROPODIA DOMICILIARIA"
  },
  {
    "codigo":293831000119105,
    "descripcion":"INFARTO CEREBRAL DEBIDO A ESTENOSIS DE ARTERIA PRECEREBRAL"
  },
  {
    "codigo":93408001,
    "descripcion":"ENGROSAMIENTO CONGÉNITO DE OMÓPLATO"
  },
  {
    "codigo":1086561000119100,
    "descripcion":"HEMORRAGIA DE DUODENO CONCOMITANTE CON DIVERTICULOSIS Y DEBIDA A ELLA"
  },
  {
    "codigo":224480007,
    "descripcion":"RECIBE AYUDA DE FAMILIAR"
  },
  {
    "codigo":716000009,
    "descripcion":"CAPAZ DE REALIZAR TRABAJO PAGO"
  },
  {
    "codigo":419253001,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR CLOPIDOGREL"
  },
  {
    "codigo":124341004,
    "descripcion":"DEFICIENCIA DE NUCLEÓSIDO - FOSFATO CINASA"
  },
  {
    "codigo":26037005,
    "descripcion":"MIELOPATÍA CAUSADA POR RADIACIÓN"
  },
  {
    "codigo":286346001,
    "descripcion":"PRODUCE UNA CALIDAD DE VOZ ADECUADA"
  },
  {
    "codigo":89738003,
    "descripcion":"INTOXICACIÓN POR ARSÉNICO ORGÁNICO"
  },
  {
    "codigo":253578007,
    "descripcion":"ANOMALÍA CONGÉNITA DE VÁLVULAS ARTERIALES"
  },
  {
    "codigo":1234783007,
    "descripcion":"TRASTORNO MENTAL ORGÁNICO CAUSADO POR ETANOL"
  },
  {
    "codigo":284511008,
    "descripcion":"DIFICULTAD PARA INICIAR EL MOVIMIENTO"
  },
  {
    "codigo":249908001,
    "descripcion":"DIFICULTAD PARA ARRODILLARSE"
  },
  {
    "codigo":315444002,
    "descripcion":"NACIDO EN INDIA"
  },
  {
    "codigo":53300000,
    "descripcion":"INTOXICACIÓN POR SULFATO FERROSO"
  },
  {
    "codigo":248073004,
    "descripcion":"CORTARSE"
  },
  {
    "codigo":15668321000119108,
    "descripcion":"PIE PLANO VALGO CONGÉNITO DE AMBOS PIES"
  },
  {
    "codigo":84233008,
    "descripcion":"ABSCESO PERIVESICULAR"
  },
  {
    "codigo":49630000,
    "descripcion":"FACIES HIPOCRÁTICA"
  },
  {
    "codigo":349281000119109,
    "descripcion":"CATARATA ZONULAR CONGÉNITA DE AMBOS OJOS"
  },
  {
    "codigo":11308921000119100,
    "descripcion":"MÚLTIPLES FRACTURAS POR COMPRESIÓN ANTEROPOSTERIOR DE PELVIS CON ANILLO PÉLVICO ESTABLE"
  },
  {
    "codigo":331641000119101,
    "descripcion":"ECTROPIÓN DE PÁRPADO SUPERIOR DERECHO"
  },
  {
    "codigo":3961000119101,
    "descripcion":"MACROCEFALIA RELATIVA"
  },
  {
    "codigo":15630201000119101,
    "descripcion":"ESPASMO HEMIFACIAL DEL NERVIO FACIAL DERECHO"
  },
  {
    "codigo":303481000119104,
    "descripcion":"DEPÓSITO DE CALCIO EN BOLSA SEROSA DE RODILLA IZQUIERDA"
  },
  {
    "codigo":16469881000119105,
    "descripcion":"FATIGA DEBIDA A ACCIDENTE CEREBROVASCULAR EMBÓLICO Y POSTERIOR A ÉL"
  },
  {
    "codigo":15919481000119106,
    "descripcion":"ANAFILAXIA CAUSADA POR ANALGÉSICO"
  },
  {
    "codigo":67961000119106,
    "descripcion":"CONSUMIDOR DE CAFEÍNA"
  },
  {
    "codigo":11864441000119108,
    "descripcion":"CUERPO EXTRAÑO SUPERFICIAL EN PIE IZQUIERDO CON INFECCIÓN"
  },
  {
    "codigo":15709561000119109,
    "descripcion":"HIPOPIGMENTACIÓN DE PÁRPADO IZQUIERDO Y DE ÁREA PERIOCULAR IZQUIERDA"
  },
  {
    "codigo":32121000119107,
    "descripcion":"FRACTURA DE HUESO DEBIDA A CAÍDA ACCIDENTAL"
  },
  {
    "codigo":15911801000119104,
    "descripcion":"REACCIÓN ALÉRGICA CAUSADA POR PENICILINA"
  },
  {
    "codigo":306041000119105,
    "descripcion":"TRASTORNO DE LIGAMENTO DE ARTICULACIÓN DE LA MUÑECA IZQUIERDA"
  },
  {
    "codigo":11997561000119106,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DE SUPERFICIE POSTERIOR DEL TÓRAX"
  },
  {
    "codigo":65401000119107,
    "descripcion":"PRESENCIA DE TAPONES LAGRIMALES"
  },
  {
    "codigo":15668601000119109,
    "descripcion":"PIE VALGO DERECHO"
  },
  {
    "codigo":111496009,
    "descripcion":"SIRINGOMIELIA"
  },
  {
    "codigo":240733002,
    "descripcion":"ULCERACIÓN DE LA MUCOSA POR HISTOPLASMOSIS CLÁSICA"
  },
  {
    "codigo":371805005,
    "descripcion":"ENFERMEDAD SIGNIFICATIVA DE INJERTO-PUENTE CORONARIO"
  },
  {
    "codigo":207965006,
    "descripcion":"FRACTURA EXPUESTA DE VÉRTEBRA LUMBAR"
  },
  {
    "codigo":109661006,
    "descripcion":"DESPLAZAMIENTO DEL DISCO DE LA ARTICULACIÓN TEMPOROMANDIBULAR, SIN REDUCCIÓN"
  },
  {
    "codigo":238898001,
    "descripcion":"LIPOATROFIA SEMICIRCULAR"
  },
  {
    "codigo":402738002,
    "descripcion":"CONDUCTA ADICTIVA CON DAÑO POTENCIAL DE PIEL"
  },
  {
    "codigo":699485003,
    "descripcion":"CURVA DE WILSON EXCESIVA"
  },
  {
    "codigo":42290006,
    "descripcion":"PERITONITIS QUÍMICA DEBIDA A PROCEDIMIENTO Y POSTERIOR A ÉL"
  },
  {
    "codigo":763186006,
    "descripcion":"SÍNDROME DE GRUBBEN, DE COCK Y BORGHGRAEF"
  },
  {
    "codigo":237063001,
    "descripcion":"FIBROMA PRIMARIO DEL LIGAMENTO ANCHO"
  },
  {
    "codigo":1285639002,
    "descripcion":"SÍNDROME DE ABSTINENCIA A ANTIDEPRESIVOS PROLONGADO"
  },
  {
    "codigo":7687006,
    "descripcion":"FRACTURA DE HUESO ILÍACO"
  },
  {
    "codigo":202460002,
    "descripcion":"REUMATISMO PALINDRÓMICO DE ARTICULACIÓN DE MANO"
  },
  {
    "codigo":399068003,
    "descripcion":"NEOPLASIA MALIGNA DE PRÓSTATA"
  },
  {
    "codigo":300764002,
    "descripcion":"REALIZA ACTIVIDAD CREATIVA"
  },
  {
    "codigo":366300006,
    "descripcion":"TONO MUSCULAR PÉLVICO ALREDEDOR DE LA VAGINA - HALLAZGO"
  },
  {
    "codigo":5852008,
    "descripcion":"POSICIÓN ACROMIOILÍACA DERECHA ANTERIOR"
  },
  {
    "codigo":724913003,
    "descripcion":"LESIÓN TRAUMÁTICA DE CABEZA LARGA DEL BÍCEPS"
  },
  {
    "codigo":298929004,
    "descripcion":"ARTICULACIÓN DE CODO DOLOROSA CON EL MOVIMIENTO"
  },
  {
    "codigo":4017007,
    "descripcion":"ADHESIVIDAD DEL ESTRATO CÓRNEO AUMENTADA"
  },
  {
    "codigo":36785009,
    "descripcion":"SÍNDROME DE AFASIA - CIRCUNVOLUCIÓN ANGULAR"
  },
  {
    "codigo":1149062005,
    "descripcion":"ESTENOSIS VELOFARÍNGEA"
  },
  {
    "codigo":723078009,
    "descripcion":"NEOPLASIA FIBROHISTIOCÍTICA BENIGNA DE RETROPERITONEO"
  },
  {
    "codigo":295259002,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE KETOPROFENO"
  },
  {
    "codigo":229723005,
    "descripcion":"SISTEMA RESTRINGIDO DE SONIDOS"
  },
  {
    "codigo":196955005,
    "descripcion":"HERNIA DE SPIEGEL CON GANGRENA"
  },
  {
    "codigo":393563007,
    "descripcion":"GLIOBLASTOMA MULTIFORME"
  },
  {
    "codigo":721243008,
    "descripcion":"MENINGITIS CAUSADA POR PARAMYXOVIRUS"
  },
  {
    "codigo":65883009,
    "descripcion":"INFECCIÓN CAUSADA POR MICROSPORA"
  },
  {
    "codigo":24111000119105,
    "descripcion":"CARCINOMA PRIMARIO DE CÉLULAS ESCAMOSAS DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":1145392003,
    "descripcion":"APLASIA DE TRÍCEPS BRAQUIAL"
  },
  {
    "codigo":129584004,
    "descripcion":"PARESIA PALATINA"
  },
  {
    "codigo":293424003,
    "descripcion":"REACCIÓN ADVERSA A LA COLESTIRAMINA"
  },
  {
    "codigo":162352007,
    "descripcion":"CAMPANILLEO EN EL OÍDO"
  },
  {
    "codigo":719408007,
    "descripcion":"SÍNDROME DE ONFALOCELE LETAL CON FISURA DE PALADAR"
  },
  {
    "codigo":291589000,
    "descripcion":"INTOXICACIÓN POR CEFAMANDOL"
  },
  {
    "codigo":160517006,
    "descripcion":"ORIGEN SUDAMERICANO"
  },
  {
    "codigo":93146001,
    "descripcion":"RETICULOENDOTELIOSIS LEUCÉMICA DE GANGLIOS LINFÁTICOS INTRATORÁCICOS"
  },
  {
    "codigo":1089071000119109,
    "descripcion":"INFLAMACIÓN DE MASTOIDES IZQUIERDA"
  },
  {
    "codigo":1010650005,
    "descripcion":"NEUMONITIS LIPOIDEA ENDÓGENA AGUDA"
  },
  {
    "codigo":224218009,
    "descripcion":"VIVE EN HOTEL"
  },
  {
    "codigo":1172655006,
    "descripcion":"COLESTEROL DE LIPOPROTEÍNA DE BAJA DENSIDAD POR DEBAJO DE RANGO DE REFERENCIA"
  },
  {
    "codigo":253316001,
    "descripcion":"DESEMBOCADURA ANORMAL DE LA VENA CAVA INFERIOR"
  },
  {
    "codigo":89476005,
    "descripcion":"CAQUEXIA HIPOFISARIA"
  },
  {
    "codigo":448089004,
    "descripcion":"DOSIS DE MEDICACIÓN DEMASIADO ELEVADA"
  },
  {
    "codigo":54873004,
    "descripcion":"ANOMALÍA ESTRUCTURAL CONGÉNITA DE ÓRBITA PROPIAMENTE DICHA"
  },
  {
    "codigo":251481008,
    "descripcion":"ACTIVIDAD DELTA GENERALIZADA INTERMITENTE"
  },
  {
    "codigo":284249008,
    "descripcion":"DIFICULTAD PARA REALIZAR FUNCIONES CON LA MANO"
  },
  {
    "codigo":184110002,
    "descripcion":"NOMBRE DEL PACIENTE - DESCONOCIDO"
  },
  {
    "codigo":135011000119102,
    "descripcion":"TROMBOSIS VENOSA PROFUNDA CRÓNICA DE VENA YUGULAR INTERNA"
  },
  {
    "codigo":11767651000119102,
    "descripcion":"RUPTURA TRAUMÁTICA DE TENDÓN DE BÍCEPS BRAQUIAL IZQUIERDO"
  },
  {
    "codigo":249646006,
    "descripcion":"TONO DEL ESFÍNTER ANAL AUSENTE"
  },
  {
    "codigo":313347007,
    "descripcion":"VÁRICES DE LAS PIERNAS DISTRIBUIDAS EN EL TERRITORIO DE LA VENA SAFENA EXTERNA, CON ECCEMA"
  },
  {
    "codigo":247811007,
    "descripcion":"MIEDO A VOMITAR EN PÚBLICO"
  },
  {
    "codigo":851365731000119106,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DEBIDO A TROMBOSIS DE ARTERIA CEREBRAL POSTERIOR IZQUIERDA"
  },
  {
    "codigo":442584007,
    "descripcion":"PRIAPISMO INTERMITENTE"
  },
  {
    "codigo":213208008,
    "descripcion":"COMPLICACIÓN POR DAÑO CEREBRAL POR ANOXIA"
  },
  {
    "codigo":1163480007,
    "descripcion":"DUODENITIS POR HERPES SIMPLE"
  },
  {
    "codigo":47533003,
    "descripcion":"LESIÓN TRAUMÁTICA DE COLA DE PÁNCREAS SIN HERIDA ABIERTA HACIA CAVIDAD ABDOMINAL"
  },
  {
    "codigo":735661006,
    "descripcion":"HEMORRAGIA TRAUMÁTICA DE RETINA"
  },
  {
    "codigo":80301007,
    "descripcion":"FLATULENCIA EXCESIVA"
  },
  {
    "codigo":733826000,
    "descripcion":"DOLOR DEBIDO A FRACTURA"
  },
  {
    "codigo":111234006,
    "descripcion":"SÍNDROME CERVICAL"
  },
  {
    "codigo":406146007,
    "descripcion":"ASIMETRÍA DEL TONO MUSCULAR"
  },
  {
    "codigo":373378009,
    "descripcion":"ESCALA COMBINADA DE NOTTINGHAM - HALLAZGO"
  },
  {
    "codigo":830295001,
    "descripcion":"PIGMENTACIÓN DE PAPILA ÓPTICA"
  },
  {
    "codigo":109399006,
    "descripcion":"DISOSTOSIS MAXILOCIGOMÁTICA"
  },
  {
    "codigo":369708000,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA DISTAL DE INTESTINO GRUESO, SIN COMPROMISO TUMORAL"
  },
  {
    "codigo":240471009,
    "descripcion":"INFECCIÓN LUMBAR POR HERPES ZÓSTER"
  },
  {
    "codigo":238636003,
    "descripcion":"ACANTOSIS NIGRICANS MALIGNA"
  },
  {
    "codigo":74796005,
    "descripcion":"SUFRIMIENTO FETAL INTRAUTERINO DETECTADO ANTES DEL TRABAJO DE PARTO EN NIÑO NACIDO VIVO"
  },
  {
    "codigo":354301000119106,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA COROIDES DEL OJO IZQUIERDO"
  },
  {
    "codigo":171265000,
    "descripcion":"SIN CONSENTIMIENTO PARA INMUNIZACIÓN CONTRA LA TOS FERINA"
  },
  {
    "codigo":402476009,
    "descripcion":"XANTOMA SECUNDARIO A LINFEDEMA"
  },
  {
    "codigo":12206231000119101,
    "descripcion":"FRACTURA ÓSEA ADYACENTE A PRÓTESIS DE CODO DERECHO"
  },
  {
    "codigo":105729006,
    "descripcion":"PATRÓN DE PERCEPCIÓN Y DE MANEJO DE LA SALUD"
  },
  {
    "codigo":7425008,
    "descripcion":"COPROPORFIRIA HEREDITARIA"
  },
  {
    "codigo":366038003,
    "descripcion":"HALLAZGO RELACIONADO CON LA POSICIÓN DEL CRISTALINO ARTIFICIAL"
  },
  {
    "codigo":234966003,
    "descripcion":"AMELOGÉNESIS IMPERFECTA - HIPOMADURACIÓN - DIENTES CON CORONA NÍVEA"
  },
  {
    "codigo":202198008,
    "descripcion":"LUXACIÓN PATOLÓGICA DE ARTICULACIÓN INTERFALÁNGICA DE DEDO DEL PIE"
  },
  {
    "codigo":724651001,
    "descripcion":"TRASTORNO DEL DESARROLLO DE LA FLUIDEZ DEL HABLA"
  },
  {
    "codigo":3755001,
    "descripcion":"PITIRIASIS RUBRA PILARIS"
  },
  {
    "codigo":298667003,
    "descripcion":"HALLAZGO RELACIONADO CON LA ESTABILIDAD DE LA COLUMNA LUMBAR"
  },
  {
    "codigo":36523002,
    "descripcion":"LESIÓN TRAUMÁTICA DE ARTERIA TIBIAL POSTERIOR"
  },
  {
    "codigo":16302231000119105,
    "descripcion":"LESIÓN DE HUESO DE MANO IZQUIERDA"
  },
  {
    "codigo":427904000,
    "descripcion":"FRACTURA NO EXPUESTA NO DESPLAZADA DE HUESO NASAL"
  },
  {
    "codigo":1279872002,
    "descripcion":"SÍNDROME DE CORDÓN CENTRAL DE MÉDULA LUMBAR DEBIDO A LUXACIÓN VERTEBRAL NO EXPUESTA"
  },
  {
    "codigo":1162803009,
    "descripcion":"SOBREDOSIS DE VALPROATO"
  },
  {
    "codigo":296832007,
    "descripcion":"SOBREDOSIS DE CARBIMAZOL"
  },
  {
    "codigo":720981000,
    "descripcion":"SÍNDROME DE ALOPECIA Y DISCAPACIDAD INTELECTUAL CON HIPOGONADISMO HIPERGONADOTRÓFICO"
  },
  {
    "codigo":294997001,
    "descripcion":"ALERGIA A METICLOTIAZIDA"
  },
  {
    "codigo":426069002,
    "descripcion":"NEUMOTÓRAX EX VACUO"
  },
  {
    "codigo":131157003,
    "descripcion":"VARIANTE DEL GRUPO SANGUÍNEO A"
  },
  {
    "codigo":15702321000119102,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE TENDÓN DE BRAZO IZQUIERDO"
  },
  {
    "codigo":1145130004,
    "descripcion":"EXOFTALMÍA DEBIDA A CONGESTIÓN ORBITARIA"
  },
  {
    "codigo":293162005,
    "descripcion":"REACCIÓN ADVERSA A LA FLUDROCORTISONA"
  },
  {
    "codigo":194858006,
    "descripcion":"INFARTO DE MIOCARDIO SUBSIGUIENTE DE PARED INFERIOR"
  },
  {
    "codigo":422399001,
    "descripcion":"CARCINOMA DUCTAL INFILTRANTE DE MAMA, ESTADIO 1"
  },
  {
    "codigo":225791005,
    "descripcion":"HABILITADO"
  },
  {
    "codigo":94719007,
    "descripcion":"SARCOMA MIELOIDE"
  },
  {
    "codigo":92884000,
    "descripcion":"FUSIÓN ANORMAL CONGÉNITA DE HUESO CIGOMÁTICO"
  },
  {
    "codigo":61951009,
    "descripcion":"INTENTO FALLIDO DE ABORTO CON LACERACIÓN DE TEJIDO PERIURETRAL"
  },
  {
    "codigo":289492003,
    "descripcion":"DOLOR A LA PALPACIÓN EN VULVA"
  },
  {
    "codigo":125652005,
    "descripcion":"HERIDA ABIERTA DE LA MANO"
  },
  {
    "codigo":1336233002,
    "descripcion":"EPISODIO DE USO NOCIVO DE CAFEÍNA"
  },
  {
    "codigo":123817002,
    "descripcion":"TRICOFITOSIS"
  },
  {
    "codigo":23678004,
    "descripcion":"MEMBRANA ANTRAL PILÓRICA CONGÉNITA"
  },
  {
    "codigo":56446007,
    "descripcion":"ABDOMEN ESCAFOIDEO"
  },
  {
    "codigo":285822008,
    "descripcion":"ABRE LAS CANILLAS"
  },
  {
    "codigo":447827003,
    "descripcion":"CONEXIÓN VENOSA PULMONAR ANÓMALA PARCIAL DE TODO EL PULMÓN DERECHO"
  },
  {
    "codigo":52776004,
    "descripcion":"INESTABILIDAD MUSCULOESQUELÉTICA"
  },
  {
    "codigo":282152005,
    "descripcion":"NO CAMINA EN TERRENO PLANO"
  },
  {
    "codigo":773672007,
    "descripcion":"SÍNDROME LETAL DE ENCEFALOCELE OCCIPITAL Y DISPLASIA ESQUELÉTICA"
  },
  {
    "codigo":249384007,
    "descripcion":"GRANDES PAPILAS FUNGIFORMES"
  },
  {
    "codigo":85544008,
    "descripcion":"FÓRMULA DE HIPERALIMENTACIÓN PARA EL TRATAMIENTO DEL DESARROLLO DEFECTUOSO DEL APARATO DIGESTIVO"
  },
  {
    "codigo":413224007,
    "descripcion":"DUODENOPATÍA ERITEMATOSA"
  },
  {
    "codigo":50941003,
    "descripcion":"IMPACTACIÓN DE PELO GINGIVAL"
  },
  {
    "codigo":247549004,
    "descripcion":"PELOS QUEBRADOS A NIVEL DE LA PIEL"
  },
  {
    "codigo":83709007,
    "descripcion":"INTOXICACIÓN POR CHEILANTHES SINNATA"
  },
  {
    "codigo":409554001,
    "descripcion":"HEPATITIS POR FIEBRE Q"
  },
  {
    "codigo":737234002,
    "descripcion":"EDEMA TRAUMÁTICO DE MÉDULA ESPINAL CERVICAL"
  },
  {
    "codigo":278482008,
    "descripcion":"TAQUICARDIA AURICULOVENTRICULAR"
  },
  {
    "codigo":243879003,
    "descripcion":"ESTADO DE DETECCIÓN SELECTIVA URINARIA"
  },
  {
    "codigo":473255004,
    "descripcion":"QUEMADURA DE TERCER GRADO DE MÚLTIPLES SITIOS DE LA CARA SIN COMPROMISO DEL OJO PROPIAMENTE DICHO"
  },
  {
    "codigo":276647007,
    "descripcion":"HEMORRAGIA INTRACRANEAL PERINATAL"
  },
  {
    "codigo":1259687008,
    "descripcion":"COREA DEBIDA A HIPERGLUCEMIA"
  },
  {
    "codigo":211111008,
    "descripcion":"PICADURA DE INSECTO, NO VENENOSO EN LA INGLE"
  },
  {
    "codigo":274812003,
    "descripcion":"REFLEJO CORNEAL IZQUIERDO AUSENTE"
  },
  {
    "codigo":1290620007,
    "descripcion":"CONSERVACIÓN INADECUADA DE VACUNA"
  },
  {
    "codigo":209276008,
    "descripcion":"FRACTURA-LUXACIÓN EXPUESTA DE LA ARTICULACIÓN RADIOCARPIANA"
  },
  {
    "codigo":404049001,
    "descripcion":"RABDOMIOMA FETAL"
  },
  {
    "codigo":373116009,
    "descripcion":"INSUFICIENCIA MITRAL AGUDA"
  },
  {
    "codigo":830033003,
    "descripcion":"QUISTE DERMOIDE DE ENCÉFALO"
  },
  {
    "codigo":405884007,
    "descripcion":"FENOTIPO S-"
  },
  {
    "codigo":305745006,
    "descripcion":"ATENDIDO POR ENFERMERA DE MANEJO DEL DOLOR"
  },
  {
    "codigo":76369008,
    "descripcion":"RASGO DE PERSONALIDAD INADAPTADA"
  },
  {
    "codigo":271142001,
    "descripcion":"AMPOLLA TRAUMÁTICA DEL PERINEO, INFECTADA"
  },
  {
    "codigo":238374001,
    "descripcion":"IMPÉTIGO NO BULLOSO"
  },
  {
    "codigo":402214000,
    "descripcion":"ECCEMA DISCOIDE EXUDATIVO"
  },
  {
    "codigo":762662004,
    "descripcion":"HIPOPLASIA DE CONDUCTO AUDITIVO"
  },
  {
    "codigo":140031000119103,
    "descripcion":"LESIÓN NO TRAUMÁTICA AGUDA DE RIÑÓN"
  },
  {
    "codigo":39931000,
    "descripcion":"AMENORREA SECUNDARIA A PÍLDORAS ANTICONCEPTIVAS"
  },
  {
    "codigo":41766008,
    "descripcion":"SINFISIÓLISIS DE LA SÍNFISIS DEL PUBIS"
  },
  {
    "codigo":302075002,
    "descripcion":"HALLAZGO RELACIONADO CON EL PATRÓN DE INGESTA DE LÍQUIDOS"
  },
  {
    "codigo":1286950009,
    "descripcion":"CARCINOMA ESCAMOCELULAR IN SITU DE PIEL DE PÁRPADO SUPERIOR"
  },
  {
    "codigo":7163005,
    "descripcion":"UROPATÍA OBSTRUCTIVA"
  },
  {
    "codigo":236539007,
    "descripcion":"SÍNDROME DEL PRIMER USO EN DIÁLISIS"
  },
  {
    "codigo":1186811008,
    "descripcion":"NEOPLASIA NEUROENDOCRINA RECTAL"
  },
  {
    "codigo":433147009,
    "descripcion":"ALTERACIÓN VISUAL Y AUDITIVA COMBINADA"
  },
  {
    "codigo":38096003,
    "descripcion":"ASPLENIA FUNCIONAL"
  },
  {
    "codigo":1119440005,
    "descripcion":"ATROFIA DE MÚSCULO DE PIERNA"
  },
  {
    "codigo":16032511000119106,
    "descripcion":"NECROSIS AVASCULAR DE AMBAS TIBIAS"
  },
  {
    "codigo":201936007,
    "descripcion":"ARTROPATÍA TRAUMÁTICA DE LA REGIÓN PÉLVICA Y EL MUSLO"
  },
  {
    "codigo":36261000,
    "descripcion":"MALABSORCIÓN CAUSADA POR FÁRMACO"
  },
  {
    "codigo":726224009,
    "descripcion":"LACERACIÓN DE TENDÓN DE MÚSCULO DE LA CADERA"
  },
  {
    "codigo":69029002,
    "descripcion":"FRACTURA EXPUESTA DE SIETE COSTILLAS"
  },
  {
    "codigo":724389003,
    "descripcion":"AMPOLLA DE CUELLO UTERINO"
  },
  {
    "codigo":429477006,
    "descripcion":"ISQUEMIA MIOCÁRDICA AUMENTADA EN COMPARACIÓN CON ESTUDIO PREVIO"
  },
  {
    "codigo":167333006,
    "descripcion":"MICROSCOPIA DE ORINA: ANOMALÍAS"
  },
  {
    "codigo":722554000,
    "descripcion":"SECUELA DE INFECCIÓN CAUSADA POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":296570001,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE MEFLOQUINA"
  },
  {
    "codigo":1148538002,
    "descripcion":"SOBREDOSIS DE ANTAGONISTA DE RECEPTOR DE HISTAMINA"
  },
  {
    "codigo":1658003,
    "descripcion":"FRACTURA NO EXPUESTA DE EXTREMO ACROMIAL DE CLAVÍCULA"
  },
  {
    "codigo":10927001000119102,
    "descripcion":"FRACTURA NO EXPUESTA DE DIÁFISIS DE TERCER HUESO METACARPIANO DE MANO IZQUIERDA"
  },
  {
    "codigo":16907161000119103,
    "descripcion":"MELANOMA IN SITU DE PÁRPADO INFERIOR IZQUIERDO"
  },
  {
    "codigo":427642009,
    "descripcion":"LEUCEMIA LINFOBLÁSTICA DE CÉLULAS T EN REMISIÓN"
  },
  {
    "codigo":294735003,
    "descripcion":"ALERGIA A GLIQUIDONA"
  },
  {
    "codigo":292900008,
    "descripcion":"REACCIÓN ADVERSA A SURFACTANTE DE PIRIDINIO CUATERNARIO"
  },
  {
    "codigo":1144868008,
    "descripcion":"APLASIA DE CLÍTORIS"
  },
  {
    "codigo":225529002,
    "descripcion":"PRÁCTICA HOMOSEXUAL EN LUGARES PÚBLICOS"
  },
  {
    "codigo":87091000119101,
    "descripcion":"GLIOMA MALIGNO DE TELENCÉFALO"
  },
  {
    "codigo":192761004,
    "descripcion":"TROMBOSIS DE SENO TRANSVERSO"
  },
  {
    "codigo":1306873004,
    "descripcion":"GLAUCOMA DE OJO IZQUIERDO CON HEMORRAGIA INTRAOCULAR"
  },
  {
    "codigo":127225006,
    "descripcion":"LEUCEMIA MIELOMONOCÍTICA CRÓNICA"
  },
  {
    "codigo":422137007,
    "descripcion":"INFESTACIÓN CAUSADA POR HYPODERMATINAE"
  },
  {
    "codigo":94457008,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE HUESO PALATINO"
  },
  {
    "codigo":717049005,
    "descripcion":"TRISOMÍA 17P"
  },
  {
    "codigo":92622001,
    "descripcion":"CARCINOMA IN SITU DE LA REGIÓN DE UNIÓN DE LA EPIGLOTIS"
  },
  {
    "codigo":289230007,
    "descripcion":"PUJA VOLUNTARIAMENTE EN EL TRABAJO DE PARTO"
  },
  {
    "codigo":420302007,
    "descripcion":"RETICULOSARCOMA ASOCIADO CON SIDA (SÍNDROME DE INMUNODEFICIENCIA ADQUIRIDA)"
  },
  {
    "codigo":254627002,
    "descripcion":"TUMOR CARCINOIDE DE PULMÓN"
  },
  {
    "codigo":25251008,
    "descripcion":"ANEMIA HEMOLÍTICA NO ESFEROCÍTICA HEREDITARIA POR DEFICIENCIA DE GAMMA GLUTAMIL CISTEÍNA SINTETASA"
  },
  {
    "codigo":285560005,
    "descripcion":"CAPAZ DE DESCENDER EL PALADAR BLANDO"
  },
  {
    "codigo":1137528007,
    "descripcion":"CALCIFICACIÓN PUNTEADA DE EPÍFISIS DE FALANGE MEDIA DE SEGUNDO DEDO DE PIE"
  },
  {
    "codigo":283725000,
    "descripcion":"MORDEDURA HUMANA EN LA ESPINILLA"
  },
  {
    "codigo":87117006,
    "descripcion":"INFECCIÓN POR VIH CON LINFADENITIS AGUDA"
  },
  {
    "codigo":1332301006,
    "descripcion":"PATRÓN DE USO NOCIVO CONTINUO DE SUSTANCIA"
  },
  {
    "codigo":249122000,
    "descripcion":"BEBÉ POSTÉRMINO"
  },
  {
    "codigo":314658001,
    "descripcion":"PERÍMETRO CEFÁLICO DEL NIÑO: PERCENTILO 98"
  },
  {
    "codigo":185421006,
    "descripcion":"CITA REALIZADA POR CARTA"
  },
  {
    "codigo":306381000119102,
    "descripcion":"GOTA CRÓNICA DE MÚLTIPLES SITIOS, SIN TOFO, CAUSADA POR FÁRMACO"
  },
  {
    "codigo":11801651000119108,
    "descripcion":"LESIÓN TRAUMÁTICA DE URÉTER DERECHO"
  },
  {
    "codigo":609570008,
    "descripcion":"DIABETES DEL ADULTO DE INICIO JUVENIL, TIPO 3"
  },
  {
    "codigo":1363234009,
    "descripcion":"QUISTE DE CEREBRO"
  },
  {
    "codigo":312823001,
    "descripcion":"ADENOMA VELLOSO DEL RECTO"
  },
  {
    "codigo":11857101000119104,
    "descripcion":"HEMATOMA SUBUNGUEAL DE SEGUNDO A QUINTO DEDOS DE PIE DERECHO"
  },
  {
    "codigo":704204003,
    "descripcion":"NEFROPATÍA CAUSADA POR PLOMO"
  },
  {
    "codigo":835276005,
    "descripcion":"SÓLO PALADAR DURO VISIBLE"
  },
  {
    "codigo":16008551000119100,
    "descripcion":"ARTRITIS DE DEDO DE LA MANO IZQUIERDA DEBIDA A TRAUMATISMO"
  },
  {
    "codigo":442060006,
    "descripcion":"INCONTINENCIA DE ESFUERZO CONSECUTIVA A PROSTATECTOMÍA"
  },
  {
    "codigo":210849001,
    "descripcion":"CONTUSIÓN, ARTERIA DIGITAL"
  },
  {
    "codigo":276385001,
    "descripcion":"PRÓSTATA BLANDA"
  },
  {
    "codigo":1099111000119101,
    "descripcion":"MEIBOMIANITIS DE PÁRPADOS SUPERIORES E INFERIORES DE AMBOS OJOS"
  },
  {
    "codigo":407457004,
    "descripcion":"ENFERMEDAD CAUSADA POR POLYOMAVIRIDAE"
  },
  {
    "codigo":1259425005,
    "descripcion":"NEUROBLASTOMA PRIMARIO DE CEREBRO"
  },
  {
    "codigo":702369008,
    "descripcion":"CARCINOSARCOMA DE ÚTERO"
  },
  {
    "codigo":472993009,
    "descripcion":"DESARROLLO ANORMAL DE CARACTERES SEXUALES SECUNDARIOS"
  },
  {
    "codigo":733302005,
    "descripcion":"QUISTE DE ÓRBITA CONGÉNITO"
  },
  {
    "codigo":241782007,
    "descripcion":"EFECTO TÓXICO CAUSADO POR ISOCIANATO"
  },
  {
    "codigo":698699000,
    "descripcion":"TRASTORNO DE LA PERSONALIDAD ANTISOCIAL EN REMISIÓN"
  },
  {
    "codigo":239947001,
    "descripcion":"CRIOGLOBULINEMIA ESENCIAL MIXTA"
  },
  {
    "codigo":76107001,
    "descripcion":"ESTENOSIS DE CONDUCTO RAQUÍDEO"
  },
  {
    "codigo":307318007,
    "descripcion":"RUPTURA DE ARTERIA TIBIAL POSTERIOR"
  },
  {
    "codigo":895307001,
    "descripcion":"FORMA DE BALA ANORMAL CONGÉNITA DE FALANGE DISTAL DE DEDO ÍNDICE"
  },
  {
    "codigo":403787005,
    "descripcion":"PUNTILLADO PALMAR DEBIDO A ENFERMEDAD DE DARIER"
  },
  {
    "codigo":10571000,
    "descripcion":"INTOXICACIÓN POR COTYLEDON"
  },
  {
    "codigo":43339004,
    "descripcion":"HIPOCALIEMIA"
  },
  {
    "codigo":305483006,
    "descripcion":"BAJO ATENCIÓN DE GASTROENTERÓLOGO"
  },
  {
    "codigo":371019009,
    "descripcion":"AZOEMIA DEBIDA A ENFERMEDAD INTRARRENAL"
  },
  {
    "codigo":238112001,
    "descripcion":"DEFICIENCIA NUTRICIONAL DE CARNITINA"
  },
  {
    "codigo":762400004,
    "descripcion":"LESIÓN TRAUMÁTICA DEBIDA A TRANSFUSIÓN Y POSTERIOR A ELLA"
  },
  {
    "codigo":400117007,
    "descripcion":"TRASTORNO EXFOLIATIVO DE PIEL DE CUERO CABELLUDO"
  },
  {
    "codigo":203509009,
    "descripcion":"DOLOR CLAVICULAR"
  },
  {
    "codigo":70602002,
    "descripcion":"PSEUDOCOARTACIÓN DE AORTA"
  },
  {
    "codigo":234442002,
    "descripcion":"ENFERMEDAD POR DEFICIENCIA HEREDITARIA DE FACTOR VIII CON INHIBIDOR"
  },
  {
    "codigo":365514004,
    "descripcion":"HALLAZGO RELACIONADO CON LA SUFICIENCIA DEL ESPACIO DE VIVIENDA"
  },
  {
    "codigo":298143005,
    "descripcion":"UÑA PARTIDA EN FORMA TRANSVERSAL"
  },
  {
    "codigo":35999006,
    "descripcion":"ÓVULO FERTILIZADO NO DESARROLLADO"
  },
  {
    "codigo":396447006,
    "descripcion":"UNA O MÁS FIGURAS MITÓTICAS POR MM2"
  },
  {
    "codigo":722292000,
    "descripcion":"AMILOIDOSIS BETA 2-MICROGLOBULÍNICA AUTOSÓMICA DOMINANTE"
  },
  {
    "codigo":427380004,
    "descripcion":"SÍNDROME DE CONDUCTO BILIAR EVANESCENTE"
  },
  {
    "codigo":1344884006,
    "descripcion":"HABILIDADES DIGITALES INADECUADAS QUE AFECTAN LA ATENCIÓN DE LA SALUD"
  },
  {
    "codigo":720457000,
    "descripcion":"DISPLASIA ACROPECTOROVERTEBRAL"
  },
  {
    "codigo":15736321000119107,
    "descripcion":"TRASTORNO DE CÓRNEA DE OJO DERECHO"
  },
  {
    "codigo":335361000119107,
    "descripcion":"COROIDITIS DISEMINADA DERECHA"
  },
  {
    "codigo":292638005,
    "descripcion":"REACCIÓN ADVERSA AL ÁCIDO AZELAICO"
  },
  {
    "codigo":126963001,
    "descripcion":"NEOPLASIA DE LA COLA DE CABALLO"
  },
  {
    "codigo":716787002,
    "descripcion":"NEUROCITOMA EXTRAVENTRICULAR"
  },
  {
    "codigo":290803004,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR LITIO"
  },
  {
    "codigo":94195005,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE VASO SANGUÍNEO DE LA MANO"
  },
  {
    "codigo":92360001,
    "descripcion":"NEOPLASIA BENIGNA DE LA PIEL DE LOS DEDOS DE LA MANO"
  },
  {
    "codigo":125128004,
    "descripcion":"DENSIDAD RADIOLÓGICA ANORMAL, DIFUSA"
  },
  {
    "codigo":26824008,
    "descripcion":"INTOXICACIÓN POR MIMOSA PUDICA"
  },
  {
    "codigo":287133007,
    "descripcion":"QUEMADURA DE PÁRPADO - AMPOLLA"
  },
  {
    "codigo":23154005,
    "descripcion":"PRESIÓN ARTERIAL DIASTÓLICA AUMENTADA"
  },
  {
    "codigo":449138009,
    "descripcion":"OBSTRUCCIÓN AL TRACTO DE SALIDA DE VENTRÍCULO DERECHO DEBIDA A HIPERTROFIA DE TABIQUE"
  },
  {
    "codigo":283463007,
    "descripcion":"HERIDA PUNZANTE EN EL CODO"
  },
  {
    "codigo":86855009,
    "descripcion":"ÁNTRAX DE MUÑECA"
  },
  {
    "codigo":85020001,
    "descripcion":"CISTINURIA"
  },
  {
    "codigo":445468002,
    "descripcion":"MENINGOCELE OCCIPITAL"
  },
  {
    "codigo":250695009,
    "descripcion":"APOLIPOPROTEÍNA E, FENOTIPO E4:4"
  },
  {
    "codigo":248860004,
    "descripcion":"VULVA PEQUEÑA"
  },
  {
    "codigo":337871000119100,
    "descripcion":"ESCLERITIS DE OJO IZQUIERDO"
  },
  {
    "codigo":738545001,
    "descripcion":"METABOLIZADOR LENTO DE LA FAMILIA 2 SUBFAMILIA C MIEMBRO 9 DEL CITOCROMO P450"
  },
  {
    "codigo":50417007,
    "descripcion":"INFECCIÓN DE VÍAS RESPIRATORIAS INFERIORES"
  },
  {
    "codigo":247025007,
    "descripcion":"HALLAZGO DEL IRIS"
  },
  {
    "codigo":443633009,
    "descripcion":"CONCEBIDO POR FERTILIZACIÓN IN VITRO"
  },
  {
    "codigo":1197297008,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS METASTÁSICO DE GANGLIO LINFÁTICO DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":409030003,
    "descripcion":"AFRONTAMIENTO FAMILIAR INEFECTIVO"
  },
  {
    "codigo":441798003,
    "descripcion":"HIPERPLASIA DE ENCÍAS"
  },
  {
    "codigo":210587000,
    "descripcion":"SECCIÓN TOTAL, TENDÓN DEL FLEXOR LARGO DEL PULGAR"
  },
  {
    "codigo":81350009,
    "descripcion":"ANSIEDAD FLOTANTE"
  },
  {
    "codigo":308891007,
    "descripcion":"CUERPO EXTRAÑO INTRABDOMINAL DEJADO EN EL MOMENTO DE LA OPERACIÓN"
  },
  {
    "codigo":896880001,
    "descripcion":"FORMA ANCHA ANORMAL CONGÉNITA DE FALANGE DISTAL DE DEDO GORDO"
  },
  {
    "codigo":1075151000119106,
    "descripcion":"DEFORMIDAD EN VALGO ADQUIRIDA DE RODILLA DERECHA"
  },
  {
    "codigo":405360006,
    "descripcion":"SUEÑO\/PESADILLA DURANTE LA ANESTESIA GENERAL"
  },
  {
    "codigo":44912006,
    "descripcion":"ERECCIÓN DEL CLÍTORIS"
  },
  {
    "codigo":700272008,
    "descripcion":"TUBERCULOSIS DEL APARATO RESPIRATORIO"
  },
  {
    "codigo":43077002,
    "descripcion":"QUISTE DE EPIDÍDIMO"
  },
  {
    "codigo":403525002,
    "descripcion":"HIPERMELANOSIS LUEGO DE FOTOTERAPIA PARA TRATAMIENTO DE ICTERICIA NEONATAL"
  },
  {
    "codigo":1255493003,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO DE DEDO GORDO DE PIE DERECHO"
  },
  {
    "codigo":303386000,
    "descripcion":"NO CAMBIA DE POSICIÓN"
  },
  {
    "codigo":1351962002,
    "descripcion":"HIPOMAGNESEMIA PRIMARIA RELACIONADA CON FACTOR DE CRECIMIENTO EPIDÉRMICO CON DISCAPACIDAD INTELECTUAL"
  },
  {
    "codigo":11780201000119103,
    "descripcion":"CONTUSIÓN DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":74010007,
    "descripcion":"TRASTORNO DE PÁNICO CON AGORAFOBIA, EVITACIÓN AGORAFÓBICA GRAVE Y ATAQUES DE PÁNICO EN REMISIÓN PARCIAL"
  },
  {
    "codigo":205082007,
    "descripcion":"ASTRÁGALO VERTICAL CONGÉNITO"
  },
  {
    "codigo":11862121000119104,
    "descripcion":"AMPOLLA TRAUMÁTICA DE TOBILLO IZQUIERDO CON INFECCIÓN"
  },
  {
    "codigo":236015007,
    "descripcion":"FIBROSIS RETROPERITONEAL FARMACÓGENA"
  },
  {
    "codigo":301551008,
    "descripcion":"INCAPAZ DE LEVANTARSE DEL INODORO"
  },
  {
    "codigo":365252004,
    "descripcion":"PROCESO DEL PENSAMIENTO - HALLAZGO"
  },
  {
    "codigo":135876005,
    "descripcion":"MASTALGIA PUBERAL"
  },
  {
    "codigo":70340006,
    "descripcion":"PATRÓN DE USO NOCIVO DE INHALANTE VOLÁTIL"
  },
  {
    "codigo":168644007,
    "descripcion":"RADIOGRAFÍA SIMPLE DE ESCAFOIDES NORMAL"
  },
  {
    "codigo":232345000,
    "descripcion":"RINITIS NO INFECCIOSA, NO ALÉRGICA"
  },
  {
    "codigo":234180009,
    "descripcion":"PÉRDIDA POR DISPOSITIVO CARDÍACO"
  },
  {
    "codigo":266948004,
    "descripcion":"TIENE PRONTUARIO"
  },
  {
    "codigo":35737003,
    "descripcion":"SIGNO DE LA HOMBRERA"
  },
  {
    "codigo":723865005,
    "descripcion":"INFECCIÓN QUE OCASIONA MIOENDOCARDITIS"
  },
  {
    "codigo":363417006,
    "descripcion":"NEOPLASIA MALIGNA DE AMPOLLA DE VATER"
  },
  {
    "codigo":1134001,
    "descripcion":"LÍNEAS DE MUEHRCKE"
  },
  {
    "codigo":811000221107,
    "descripcion":"ENCEFALOPATÍA ESPONGIFORME TRANSMISIBLE EN HUMANOS"
  },
  {
    "codigo":1344622005,
    "descripcion":"TIENE DISPOSITIVO DIGITAL CON CONEXIÓN A INTERNET"
  },
  {
    "codigo":33902006,
    "descripcion":"ENFERMEDAD DEL AIRE"
  },
  {
    "codigo":296046008,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE CICLOBARBITAL"
  },
  {
    "codigo":359747000,
    "descripcion":"ERLIQUIOSIS HUMANA CAUSADA POR EHRLICHIA CHAFFEENSIS"
  },
  {
    "codigo":32067005,
    "descripcion":"COLECISTITIS ENFISEMATOSA AGUDA"
  },
  {
    "codigo":294211007,
    "descripcion":"ALERGIA A ISOTRETINOÍNA"
  },
  {
    "codigo":128536001,
    "descripcion":"TRASTORNO DEL SEGMENTO POSTERIOR DEL OJO"
  },
  {
    "codigo":95768001,
    "descripcion":"DESPLAZAMIENTO ADQUIRIDO DEL PUNTO LAGRIMAL"
  },
  {
    "codigo":718360006,
    "descripcion":"FUNCIONALMENTE INDEPENDIENTE"
  },
  {
    "codigo":63000007,
    "descripcion":"TOS ESPASMÓDICA"
  },
  {
    "codigo":292376008,
    "descripcion":"REACCIÓN ADVERSA A LA TETRABENAZINA"
  },
  {
    "codigo":1144344009,
    "descripcion":"HIPOPLASIA CONGÉNITA DE LÓBULO FRONTAL"
  },
  {
    "codigo":640080131000119107,
    "descripcion":"FRACTURA NO EXPUESTA DE PARED EXTERNA DE ÓRBITA IZQUIERDA"
  },
  {
    "codigo":290541003,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR LIDOCAÍNA"
  },
  {
    "codigo":225005002,
    "descripcion":"INCAPAZ DE CONTROLAR LA IRA"
  },
  {
    "codigo":93933005,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA OROFARINGE"
  },
  {
    "codigo":126701008,
    "descripcion":"NEOPLASIA DE LA CARA LARÍNGEA DEL PLIEGUE ARITENOEPIGLÓTICO"
  },
  {
    "codigo":12081411000119109,
    "descripcion":"QUEMADURA QUÍMICA DE CÓRNEA IZQUIERDA"
  },
  {
    "codigo":92098009,
    "descripcion":"NEOPLASIA BENIGNA DE LA CARA"
  },
  {
    "codigo":188567005,
    "descripcion":"ENFERMEDAD DE HODGKIN, ESCLEROSIS NODULAR DE GANGLIOS LINFÁTICOS INTRABDOMINALES"
  },
  {
    "codigo":285036002,
    "descripcion":"MANEJA LA MEDICACIÓN"
  },
  {
    "codigo":448876006,
    "descripcion":"DEFECTO DEL TABIQUE INTERVENTRICULAR SUBARTERIAL"
  },
  {
    "codigo":217665000,
    "descripcion":"ENVENENAMIENTO DEBIDO A PICADURA DE ARAÑA VENENOSA"
  },
  {
    "codigo":1231638000,
    "descripcion":"CUERPO EXTRAÑO RETENIDO EN PÁRPADO INFERIOR"
  },
  {
    "codigo":283201009,
    "descripcion":"ANZUELO EN LA MANO"
  },
  {
    "codigo":707350007,
    "descripcion":"MELANOMA MALIGNO DE SENO PARANASAL"
  },
  {
    "codigo":281366009,
    "descripcion":"OSTEOCONDROMATOSIS SINOVIAL PRIMARIA"
  },
  {
    "codigo":313911000119104,
    "descripcion":"ATROFIA DE MÚSCULO DE HOMBRO DERECHO"
  },
  {
    "codigo":443371007,
    "descripcion":"NIVEL DE CONCIENCIA DISMINUIDO"
  },
  {
    "codigo":441536000,
    "descripcion":"NEUMOTÓRAX IATROGÉNICO"
  },
  {
    "codigo":10635831000119105,
    "descripcion":"ÚLCERA CRÓNICA DE TALÓN IZQUIERDO"
  },
  {
    "codigo":5501000175107,
    "descripcion":"FALTA DE TELÉFONO EN EL DOMICILIO"
  },
  {
    "codigo":15552004,
    "descripcion":"OSTEOGÉNESIS IMPERFECTA, PERINATAL MORTAL RECESIVA, CON MICROCEFALIA Y CATARATAS"
  },
  {
    "codigo":68151000119106,
    "descripcion":"PARÁLISIS FACIAL GRADO V DE HOUSE-BRACKMANN"
  },
  {
    "codigo":241732151000119106,
    "descripcion":"LACERACIÓN DE VASO SANGUÍNEO DE DEDO ÍNDICE"
  },
  {
    "codigo":455201601000132100,
    "descripcion":"CON ALTO RIESGO DE CAÍDA"
  },
  {
    "codigo":439701000,
    "descripcion":"DEFICIENCIA HEREDITARIA DE COFACTOR II DE HEPARINA"
  },
  {
    "codigo":210325009,
    "descripcion":"HERIDA ABIERTA DE LA NARIZ"
  },
  {
    "codigo":700010002,
    "descripcion":"LESIÓN TRAUMÁTICA DE MIEMBRO INFERIOR LIBRE"
  },
  {
    "codigo":208490003,
    "descripcion":"FRACTURA EXPUESTA DE FALANGE DISTAL DE DEDO DE LA MANO, DIÁFISIS"
  },
  {
    "codigo":110186004,
    "descripcion":"QUEMADURA DE LA MEJILLA"
  },
  {
    "codigo":11838161000119103,
    "descripcion":"LESIÓN TRAUMÁTICA DE TENDÓN DE LA MANO IZQUIERDA"
  },
  {
    "codigo":11882005,
    "descripcion":"MASTURBACIÓN JUVENIL"
  },
  {
    "codigo":1255231000,
    "descripcion":"POSICIÓN ANÓMALA DE IMPLANTE DE MAMA"
  },
  {
    "codigo":213171008,
    "descripcion":"FALLA PARCIAL DE REIMPLANTE DEL PULGAR"
  },
  {
    "codigo":1156927006,
    "descripcion":"INMUNE CONTRA HAEMOPHILUS INFLUENZAE TIPO B"
  },
  {
    "codigo":40980002,
    "descripcion":"PARÁLISIS ESPÁSTICA POR TRAUMATISMO DEL NACIMIENTO"
  },
  {
    "codigo":792809000,
    "descripcion":"INGESTA EXCESIVA DE FOLATO Y\/O DERIVADO DE FOLATO"
  },
  {
    "codigo":235753003,
    "descripcion":"COLITIS MICROSCÓPICA"
  },
  {
    "codigo":301289004,
    "descripcion":"ESPUTO CON TAPONES DE MOCO"
  },
  {
    "codigo":71913005,
    "descripcion":"ENTERITIS GRANULOMATOSA, NO ENFERMEDAD DE CROHN"
  },
  {
    "codigo":399593007,
    "descripcion":"NO SE PUEDE VALORAR METÁSTASIS A DISTANCIA"
  },
  {
    "codigo":299454002,
    "descripcion":"HALLAZGO RELACIONADO CON LA TEMPERATURA DE ARTICULACIÓN DE TOBILLO"
  },
  {
    "codigo":233918003,
    "descripcion":"BLOQUEO CARDÍACO COMPLETO POSQUIRÚRGICO"
  },
  {
    "codigo":364990006,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD DE UTILIZAR FLUJO DE AIRE PULMONAR PARA HABLAR"
  },
  {
    "codigo":397758007,
    "descripcion":"OSTEONECROSIS"
  },
  {
    "codigo":102846009,
    "descripcion":"SEDIMENTO URINARIO"
  },
  {
    "codigo":168382009,
    "descripcion":"HELICOBACTER DETECTADO EN SANGRE"
  },
  {
    "codigo":2707005,
    "descripcion":"INFLAMACIÓN NECROSANTE FETAL Y\/O NEONATAL DE INTESTINO DELGADO Y COLON"
  },
  {
    "codigo":40121000087102,
    "descripcion":"LUXACIÓN DE ARTICULACIÓN DE DEDO MEDIO DE MANO IZQUIERDA"
  },
  {
    "codigo":47801000087102,
    "descripcion":"FRACTURA DE CUARTA COSTILLA DERECHA"
  },
  {
    "codigo":232083008,
    "descripcion":"GLAUCOMA Y ANOMALÍA CORNEAL"
  },
  {
    "codigo":426856002,
    "descripcion":"MIOCARDIOPATÍA ISQUÉMICA CONGESTIVA"
  },
  {
    "codigo":295784003,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE FORMESTANO"
  },
  {
    "codigo":42681000087106,
    "descripcion":"DISCO INTERVERTEBRAL CERVICAL PROLAPSADO, C6-C7"
  },
  {
    "codigo":197480006,
    "descripcion":"TRASTORNO DE ANSIEDAD"
  },
  {
    "codigo":230248006,
    "descripcion":"ATROFIA MUSCULAR ESPINAL ESCAPULOPERONEA"
  },
  {
    "codigo":721768006,
    "descripcion":"INFECCIÓN DE SISTEMA NERVIOSO CENTRAL CAUSADA POR VIRUS HERPES SIMPLE"
  },
  {
    "codigo":31805001,
    "descripcion":"DESPROPORCIÓN FETAL"
  },
  {
    "codigo":293949005,
    "descripcion":"ALERGIA A LA OXIPERTINA"
  },
  {
    "codigo":95506002,
    "descripcion":"DESPLAZAMIENTO CONGÉNITO DEL PUNTO LAGRIMAL"
  },
  {
    "codigo":718098003,
    "descripcion":"EXCESO GINGIVAL DEBIDO A EXPOSICIÓN EXCESIVA DE TEJIDO GINGIVAL"
  },
  {
    "codigo":161042003,
    "descripcion":"MIEMBRO DE LA COMUNIDAD MÉDICA"
  },
  {
    "codigo":128274005,
    "descripcion":"ANOMALÍA CONGÉNITA DE LA NARIZ"
  },
  {
    "codigo":292114007,
    "descripcion":"REACCIÓN ADVERSA A LA CARBENOXOLONA"
  },
  {
    "codigo":62738008,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DE BRAZO"
  },
  {
    "codigo":1142247001,
    "descripcion":"PSEUDOHIPERTROFIA DE MÚSCULO CRURAL POSTERIOR"
  },
  {
    "codigo":93671004,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL MEDIASTINO ANTERIOR"
  },
  {
    "codigo":290279007,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR NABUMETONA"
  },
  {
    "codigo":880103008,
    "descripcion":"INGESTA INADECUADA DE NIACINA"
  },
  {
    "codigo":59068006,
    "descripcion":"LUXACIÓN CONGÉNITA DE LA RODILLA"
  },
  {
    "codigo":124604008,
    "descripcion":"DEFICIENCIA DE DIFOSFOMEVALONATO DESCARBOXILASA"
  },
  {
    "codigo":288444009,
    "descripcion":"REALIZA ACTIVIDADES DE ESCRITURA"
  },
  {
    "codigo":286609007,
    "descripcion":"FECALITO APENDICULAR"
  },
  {
    "codigo":417681008,
    "descripcion":"PACIENTE DIABÉTICO NO APTO PARA RETINOGRAFÍA DIGITAL"
  },
  {
    "codigo":448614002,
    "descripcion":"VENA CAVA INFERIOR ANTERIOR Y DEL MISMO LADO QUE LA AORTA DESCENDENTE"
  },
  {
    "codigo":710758007,
    "descripcion":"DESVIACIÓN DE LA ÚVULA HACIA LA DERECHA"
  },
  {
    "codigo":284774007,
    "descripcion":"CAPAZ DE REALIZAR ACTIVIDAD DE CUIDADO PERSONAL"
  },
  {
    "codigo":252006009,
    "descripcion":"HALLAZGO RELACIONADO CON SENSIBILIDAD VESICAL"
  },
  {
    "codigo":446779001,
    "descripcion":"LACERACIÓN SUPERFICIAL DE UÑA DE DEDO DE MANO"
  },
  {
    "codigo":282939001,
    "descripcion":"NO SE INCLINA"
  },
  {
    "codigo":1264144005,
    "descripcion":"DAÑO DE VAGINA POSTERIOR A EMBARAZO MOLAR"
  },
  {
    "codigo":444944006,
    "descripcion":"DEFICIENCIA DE 2-4 DIENOIL-COA REDUCTASA"
  },
  {
    "codigo":18960007,
    "descripcion":"FRACTURA NO EXPUESTA A NIVEL DE D7 - D12 CON LESIÓN INCOMPLETA DE LA MÉDULA ESPINAL"
  },
  {
    "codigo":836325000,
    "descripcion":"AGUDEZA VISUAL CON AGUJERO ESTENOPEICO DE OJO IZQUIERDO 6\/5"
  },
  {
    "codigo":16018591000119107,
    "descripcion":"DEDO EN GATILLO CONGÉNITO DE MANO DERECHA"
  },
  {
    "codigo":82661006,
    "descripcion":"EMBARAZO ABDOMINAL"
  },
  {
    "codigo":15290006,
    "descripcion":"AMPOLLA DE DEDO DE PIE, CON INFECCIÓN"
  },
  {
    "codigo":242831003,
    "descripcion":"SOBREDOSIS INTENCIONAL DE METADONA"
  },
  {
    "codigo":15664441000119104,
    "descripcion":"NEOPLASIA BENIGNA DE AMBOS OJOS"
  },
  {
    "codigo":109924004,
    "descripcion":"NEOPLASIA BENIGNA DE LOS NERVIOS PERIFÉRICOS DE LA CARA"
  },
  {
    "codigo":208228004,
    "descripcion":"FRACTURA NO EXPUESTA DE ESPINA DE OMÓPLATO"
  },
  {
    "codigo":318931000119100,
    "descripcion":"ARTRITIS REUMATOIDE SEROPOSITIVA DE MANO DERECHA"
  },
  {
    "codigo":699748007,
    "descripcion":"PARO CARDIORRESPIRATORIO CON REANIMACIÓN EXITOSA"
  },
  {
    "codigo":9785001,
    "descripcion":"SÍNDROME DEL ESTÓMAGO PEQUEÑO"
  },
  {
    "codigo":15637971000119101,
    "descripcion":"LINFEDEMA DE AMBOS MIEMBROS INFERIORES"
  },
  {
    "codigo":403001004,
    "descripcion":"CANDIDIASIS MUCOCUTÁNEA CRÓNICA ADQUIRIDA"
  },
  {
    "codigo":239161005,
    "descripcion":"HEMORRAGIA DE HERIDA"
  },
  {
    "codigo":697913004,
    "descripcion":"HIPERTENSIÓN PULMONAR DEBIDA A ENFERMEDAD PULMONAR CON PATRÓN MIXTO RESTRICTIVO Y OBSTRUCTIVO"
  },
  {
    "codigo":302862001,
    "descripcion":"OSTEOFIBROMA"
  },
  {
    "codigo":204558002,
    "descripcion":"HENDIDURA CONGÉNITA DEL CARTÍLAGO CRICOIDES POSTERIOR"
  },
  {
    "codigo":42553009,
    "descripcion":"TRASTORNO FUNCIONAL DE LA BARRERA PLACENTARIA"
  },
  {
    "codigo":202723000,
    "descripcion":"SÍNDROME POSLAMINECTOMÍA CERVICAL"
  },
  {
    "codigo":301027009,
    "descripcion":"ENFERMEDAD DE PAGET DE LA CADERA"
  },
  {
    "codigo":366563009,
    "descripcion":"MASA TESTICULAR INFLAMATORIA"
  },
  {
    "codigo":233656004,
    "descripcion":"FIBROSIS PLEURAL POSINFECCIOSA"
  },
  {
    "codigo":364728004,
    "descripcion":"HALLAZGO RELACIONADO CON EL TACO DEL CALZADO"
  },
  {
    "codigo":454161000124103,
    "descripcion":"INCUMPLIMIENTO DE RÉGIMEN DE MEDICACIÓN DEBIDO A ALTERACIÓN COGNITIVA"
  },
  {
    "codigo":102584008,
    "descripcion":"PRESIÓN ARTERIAL DESIGUAL EN AMBOS BRAZOS"
  },
  {
    "codigo":299192009,
    "descripcion":"AMPLITUD DE OPOSICIÓN PASIVA DEL PULGAR DISMINUIDA"
  },
  {
    "codigo":441361000124104,
    "descripcion":"AUMENTO DE PESO NO INTENCIONAL"
  },
  {
    "codigo":551441000124104,
    "descripcion":"VÍCTIMA DE MALTRATO FÍSICO POR PARTE DE PAREJA ÍNTIMA"
  },
  {
    "codigo":788877005,
    "descripcion":"SÍNCOPE CARDÍACO"
  },
  {
    "codigo":610000,
    "descripcion":"AFONÍA ESPÁSTICA"
  },
  {
    "codigo":231821009,
    "descripcion":"AVULSIÓN DE PÁRPADO"
  },
  {
    "codigo":361058003,
    "descripcion":"DEFICIENCIA DE ALFA Y BETA TRIPSINA"
  },
  {
    "codigo":295522004,
    "descripcion":"SOBREDOSIS INTENCIONAL DE METOHEXITAL"
  },
  {
    "codigo":721506005,
    "descripcion":"SÍNDROME DEL CORDÓN CENTRAL DE MÉDULA ESPINAL AL NIVEL DEL PRIMER SEGMENTO LUMBAR"
  },
  {
    "codigo":424759000,
    "descripcion":"FUNCIÓN DE CUIDADOR, NEGLIGENTE"
  },
  {
    "codigo":262754009,
    "descripcion":"LESIÓN TRAUMÁTICA ORBITARIA"
  },
  {
    "codigo":228151002,
    "descripcion":"DISCAPACIDAD PARA EL CUIDADO PERSONAL"
  },
  {
    "codigo":293687004,
    "descripcion":"ALERGIA A DOCUSATO"
  },
  {
    "codigo":129847007,
    "descripcion":"INCONTINENCIA URINARIA FUNCIONAL"
  },
  {
    "codigo":195383008,
    "descripcion":"NEVO SENIL"
  },
  {
    "codigo":62476001,
    "descripcion":"DESORIENTADO"
  },
  {
    "codigo":160780003,
    "descripcion":"TERAPIA OCUPACIONAL DOMICILIARIA"
  },
  {
    "codigo":95244005,
    "descripcion":"QUERATITIS ROSÁCEA"
  },
  {
    "codigo":10669831000119100,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN DE PIERNA IZQUIERDA ESTADIO III"
  },
  {
    "codigo":291852007,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR LIOTIRONINA"
  },
  {
    "codigo":193548006,
    "descripcion":"GLAUCOMA POR ESTEROIDES, ESTADIO GLAUCOMATOSO"
  },
  {
    "codigo":27873005,
    "descripcion":"DEGENERACIÓN ESPINOPONTINA"
  },
  {
    "codigo":224481006,
    "descripcion":"RECIBE AYUDA DE VECINO"
  },
  {
    "codigo":191713008,
    "descripcion":"TEMBLOR DISOCIATIVO"
  },
  {
    "codigo":93409009,
    "descripcion":"ENGROSAMIENTO CONGÉNITO DE ASTRÁGALO"
  },
  {
    "codigo":189878003,
    "descripcion":"OSTEOSARCOMA"
  },
  {
    "codigo":124342006,
    "descripcion":"DEFICIENCIA DE NUCLEÓSIDO - DIFOSFATO CINASA"
  },
  {
    "codigo":253579004,
    "descripcion":"ANOMALÍA DE VÁLVULA TRONCAL"
  },
  {
    "codigo":286347005,
    "descripcion":"NO PRODUCE CALIDAD DE VOZ APROPIADA"
  },
  {
    "codigo":24203005,
    "descripcion":"RESISTENCIA EXTREMA A LA INSULINA CON ACANTOSIS NIGRICANS, HIRSUTISMO Y RECEPTORES DE INSULINA ANORMALES"
  },
  {
    "codigo":284512001,
    "descripcion":"CONDUCTA HIPOMANÍACA"
  },
  {
    "codigo":321441000119100,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE TENDÓN EXTENSOR DE ANTEBRAZO DERECHO"
  },
  {
    "codigo":11790241000119100,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE PIEL DE PULGAR DERECHO"
  },
  {
    "codigo":415584007,
    "descripcion":"ENDOFTALMITIS ESTÉRIL"
  },
  {
    "codigo":315445001,
    "descripcion":"NACIDO EN INDONESIA"
  },
  {
    "codigo":1003573004,
    "descripcion":"AGENESIA DE ESTERNEBRA"
  },
  {
    "codigo":282677005,
    "descripcion":"CAPAZ DE ALCANZAR"
  },
  {
    "codigo":86069005,
    "descripcion":"ESTADIO DE BRESLOW, PROFUNDIDAD MENOR DE 0,76 MM"
  },
  {
    "codigo":249909009,
    "descripcion":"DIFICULTAD PARA GIRAR"
  },
  {
    "codigo":20533009,
    "descripcion":"CURVATURA DE POTT"
  },
  {
    "codigo":248074005,
    "descripcion":"DEGLUCIÓN DE OBJETOS"
  },
  {
    "codigo":49631001,
    "descripcion":"ADENITIS MESENTÉRICA AGUDA"
  },
  {
    "codigo":82399006,
    "descripcion":"INSPIRACIÓN AUDIBLE"
  },
  {
    "codigo":15028002,
    "descripcion":"PRESENTACIÓN FETAL ANORMAL"
  },
  {
    "codigo":211636003,
    "descripcion":"CUERPO EXTRAÑO EN EL ÍLEON"
  },
  {
    "codigo":735924004,
    "descripcion":"FRAGMENTOS DE LENTE PARA CATARATA EN CÁMARA ANTERIOR DE OJO DEBIDOS A CIRUGÍA DE CATARATAS Y DESPUÉS DE ELLA"
  },
  {
    "codigo":1292980004,
    "descripcion":"FRACTURA NO EXPUESTA DE RAMA DE PUBIS"
  },
  {
    "codigo":703156006,
    "descripcion":"HEMORRAGIA CEREBRAL HEMISFÉRICA PROFUNDA"
  },
  {
    "codigo":277172003,
    "descripcion":"CONDUCTO AUDITIVO ERITEMATOSO"
  },
  {
    "codigo":111497000,
    "descripcion":"TROMBOSIS ARTERIAL DE LA MÉDULA ESPINAL"
  },
  {
    "codigo":209801006,
    "descripcion":"ESGUINCE DE ARTICULACIÓN CONDROCOSTAL"
  },
  {
    "codigo":275337006,
    "descripcion":"FRACTURA EXPUESTA DE HOMBRO"
  },
  {
    "codigo":699486002,
    "descripcion":"EMPUJE DE LENGUA POSTERIOR"
  },
  {
    "codigo":109662004,
    "descripcion":"DESPLAZAMIENTO DEL DISCO DE LA ARTICULACIÓN TEMPOROMANDIBULAR, CON REDUCCIÓN"
  },
  {
    "codigo":753248161000119109,
    "descripcion":"SÍNDROME DE DEHISCENCIA DE CONDUCTO SEMICIRCULAR SUPERIOR BILATERAL"
  },
  {
    "codigo":371806006,
    "descripcion":"ANGINA DE PECHO PROGRESIVA"
  },
  {
    "codigo":207966007,
    "descripcion":"FRACTURA EXPUESTA DE VÉRTEBRA LUMBAR, ESTALLIDO"
  },
  {
    "codigo":240734008,
    "descripcion":"ULCERACIÓN BUCAL POR HISTOPLASMOSIS CLÁSICA"
  },
  {
    "codigo":1156403002,
    "descripcion":"LINFOMA HODGKIN Y NO-HODGKIN COMPUESTO"
  },
  {
    "codigo":125011000119100,
    "descripcion":"ASMA PERSISTENTE LEVE CONCOMITANTE CON RINITIS ALÉRGICA"
  },
  {
    "codigo":340051000119100,
    "descripcion":"ESTENOSIS DE SACO LAGRIMAL IZQUIERDO"
  },
  {
    "codigo":11821651000119102,
    "descripcion":"SUBLUXACIÓN DE ARTICULACIÓN ESTERNOCLAVICULAR DERECHA"
  },
  {
    "codigo":680531000119103,
    "descripcion":"CATARATAS DE AMBOS OJOS CAUSADAS POR FÁRMACO"
  },
  {
    "codigo":334931000119102,
    "descripcion":"ATROFIA DE OJO DERECHO"
  },
  {
    "codigo":7688001,
    "descripcion":"APNEA POR ÉTER"
  },
  {
    "codigo":119891000119105,
    "descripcion":"HEMORRAGIA POSPARTO DEBIDA A PLACENTA PREVIA COMPLETA"
  },
  {
    "codigo":16580691000119107,
    "descripcion":"DOLOR CRÓNICO DE VEJIGA"
  },
  {
    "codigo":288851000119106,
    "descripcion":"TRASTORNO DEL ESTADO DE ÁNIMO INDUCIDO POR OPIOIDES DEBIDO A ABUSO DE OPIOIDES"
  },
  {
    "codigo":11839571000119106,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO INTRÍNSECO DE PULGAR IZQUIERDO"
  },
  {
    "codigo":293971000119103,
    "descripcion":"SÍNDROME DE DOLOR REGIONAL COMPLEJO TIPO I DE MIEMBRO SUPERIOR DERECHO"
  },
  {
    "codigo":690771000119106,
    "descripcion":"NEOPLASIA MUCINOSA PAPILAR INTRADUCTAL DE PÁNCREAS"
  },
  {
    "codigo":299091000119103,
    "descripcion":"HEMARTROSIS DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":301651000119107,
    "descripcion":"ABSCESO DE VAINA TENDINOSA DE PIERNA DERECHA"
  },
  {
    "codigo":14931000119109,
    "descripcion":"HISTIOCITOSIS CRÓNICA"
  },
  {
    "codigo":202461003,
    "descripcion":"REUMATISMO PALINDRÓMICO DE REGIÓN PÉLVICA Y MUSLO"
  },
  {
    "codigo":11842131000119107,
    "descripcion":"LACERACIÓN DE TENDÓN DE DEDO DE PIE DERECHO"
  },
  {
    "codigo":366301005,
    "descripcion":"HALLAZGO RELACIONADO CON EL TAMAÑO DEL ÚTERO"
  },
  {
    "codigo":309331000119109,
    "descripcion":"NECROSIS AVASCULAR DE HUESO DE PIE DERECHO"
  },
  {
    "codigo":300765001,
    "descripcion":"NO REALIZA ACTIVIDAD CREATIVA"
  },
  {
    "codigo":104661000119102,
    "descripcion":"ARTRITIS REACTIVA DE ARTICULACIÓN DE MANO"
  },
  {
    "codigo":266162007,
    "descripcion":"ENTEROBIASIS"
  },
  {
    "codigo":724914009,
    "descripcion":"LESIÓN TRAUMÁTICA DE FASCIA DE CABEZA LARGA DE BÍCEPS"
  },
  {
    "codigo":298930009,
    "descripcion":"CREPITACIÓN DE ARTICULACIÓN DE CODO"
  },
  {
    "codigo":723079001,
    "descripcion":"NEOPLASIA FIBROHISTIOCÍTICA BENIGNA DE PERITONEO"
  },
  {
    "codigo":297095002,
    "descripcion":"SOBREDOSIS DE ESTREPTOQUINASA"
  },
  {
    "codigo":34951003,
    "descripcion":"ESTADO NARCOTIZADO"
  },
  {
    "codigo":393564001,
    "descripcion":"GLIOMA"
  },
  {
    "codigo":721244002,
    "descripcion":"MIELITIS CAUSADA POR INFECCIÓN"
  },
  {
    "codigo":33116002,
    "descripcion":"HIDROXIQUINURENINURIA"
  },
  {
    "codigo":229724004,
    "descripcion":"SISTEMA LIMITADO DE SONIDOS"
  },
  {
    "codigo":196956006,
    "descripcion":"HERNIA DE SPIEGEL OBSTRUIDA"
  },
  {
    "codigo":295260007,
    "descripcion":"SOBREDOSIS INTENCIONAL DE KETOPROFENO"
  },
  {
    "codigo":162353002,
    "descripcion":"SISEO EN EL OÍDO"
  },
  {
    "codigo":678101000119107,
    "descripcion":"HEMORRAGIA SUBRETINIANA DE OJO DERECHO"
  },
  {
    "codigo":719409004,
    "descripcion":"SÍNDROME SIMILAR AL SÍNDROME DE LARSEN LETAL"
  },
  {
    "codigo":424497004,
    "descripcion":"EDEMA DE PAPILA ÓPTICA POR HIPOTONÍA"
  },
  {
    "codigo":129585003,
    "descripcion":"ESTREÑIMIENTO SUBJETIVO"
  },
  {
    "codigo":94982001,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL PARAMETRIO"
  },
  {
    "codigo":160518001,
    "descripcion":"ORIGEN AUSTRALIANO"
  },
  {
    "codigo":1340166003,
    "descripcion":"POSICIÓN EN CUCLILLAS DURANTE EL PARTO"
  },
  {
    "codigo":16052591000119103,
    "descripcion":"TENDINOSIS DE BÍCEPS BRAQUIAL IZQUIERDO"
  },
  {
    "codigo":291590009,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR CEFAMANDOL"
  },
  {
    "codigo":289755002,
    "descripcion":"CUELLO UTERINO, PRESENTE"
  },
  {
    "codigo":224219001,
    "descripcion":"VIVE EN UN HOGAR INDEPENDIENTE DEL GRUPO"
  },
  {
    "codigo":58544000,
    "descripcion":"VIRUELA CAUSADA POR VIRUS TANA"
  },
  {
    "codigo":1010651009,
    "descripcion":"COLESTEATOMA ADQUIRIDO DE OÍDO MEDIO"
  },
  {
    "codigo":124080002,
    "descripcion":"BILIVERDINA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":191451009,
    "descripcion":"DEMENCIA PRESENIL NO COMPLICADA"
  },
  {
    "codigo":11792751000119105,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN DE DEDO MEÑIQUE IZQUIERDO"
  },
  {
    "codigo":1172656007,
    "descripcion":"COLESTEROL DE LIPOPROTEÍNA DE BAJA DENSIDAD DENTRO DE RANGO DE REFERENCIA"
  },
  {
    "codigo":1269125001,
    "descripcion":"METÁSTASIS DE CARCINOMA ESCAMOSO EN INTESTINO DELGADO"
  },
  {
    "codigo":449925002,
    "descripcion":"TUBERCULOSIS DE HUESO DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":253317005,
    "descripcion":"VENA CAVA INFERIOR QUE DESEMBOCA EN AURÍCULA IZQUIERDA MORFOLÓGICA"
  },
  {
    "codigo":251482001,
    "descripcion":"RESPUESTA DE HIPERVENTILACIÓN EXCESIVA"
  },
  {
    "codigo":56709009,
    "descripcion":"CÉLULA BLANCO DE LA REACCIÓN INMUNOLÓGICA"
  },
  {
    "codigo":448090008,
    "descripcion":"INTERACCIÓN FARMACOLÓGICA ADVERSA CON ALIMENTO"
  },
  {
    "codigo":710234009,
    "descripcion":"NARIZ EN SILLA DE MONTAR"
  },
  {
    "codigo":249647002,
    "descripcion":"ESFÍNTER ANAL DÉBIL"
  },
  {
    "codigo":184111003,
    "descripcion":"APELLIDO DEL PACIENTE - DESCONOCIDO"
  },
  {
    "codigo":413487000,
    "descripcion":"AMENORREA ASOCIADA CON OBESIDAD"
  },
  {
    "codigo":870404000,
    "descripcion":"INGESTA EXCESIVA DE CARBOHIDRATOS"
  },
  {
    "codigo":247812000,
    "descripcion":"MIEDO A TENER UN ATAQUE"
  },
  {
    "codigo":313348002,
    "descripcion":"VÁRICES DE LAS PIERNAS DISTRIBUIDAS EN EL TERRITORIO DE LA VENA SAFENA INTERNA, CON ÚLCERA"
  },
  {
    "codigo":38365000,
    "descripcion":"ÚLCERA PÉPTICA SIN HEMORRAGIA, SIN PERFORACIÓN Y SIN OBSTRUCCIÓN"
  },
  {
    "codigo":213209000,
    "descripcion":"COMPLICACIÓN POR ANOXIA CEREBRAL"
  },
  {
    "codigo":49369000,
    "descripcion":"QUEMADURA PROFUNDA DE TERCER GRADO DEL BRAZO"
  },
  {
    "codigo":16601003,
    "descripcion":"CONSISTENCIA DE UNA COLONIA BACTERIANA, VISCOSA"
  },
  {
    "codigo":1163481006,
    "descripcion":"DACRIOADENITIS POR HISTOPLASMA"
  },
  {
    "codigo":735662004,
    "descripcion":"PÉRDIDA INCOMPLETA DE LA CONSCIENCIA SIN AMNESIA"
  },
  {
    "codigo":373379001,
    "descripcion":"INVASIÓN TUMORAL - HALLAZGO"
  },
  {
    "codigo":111235007,
    "descripcion":"TRASTORNO MUSCULOESQUELÉTICO DEL CUELLO"
  },
  {
    "codigo":830296000,
    "descripcion":"AUSENCIA DE BORDE DE PAPILA ÓPTICA"
  },
  {
    "codigo":240472002,
    "descripcion":"INFECCIÓN MAXILAR POR HERPES ZÓSTER"
  },
  {
    "codigo":11096003,
    "descripcion":"CUERPO EXTRAÑO NO MAGNÉTICO RETENIDO EN LA CÁMARA ANTERIOR DEL OJO"
  },
  {
    "codigo":109400004,
    "descripcion":"DISOSTOSIS NASOMAXILAR"
  },
  {
    "codigo":1354584007,
    "descripcion":"ENFERMEDAD INFECCIOSA MENINGOCÓCICA CAUSADA POR NEISSERIA MENINGITIDIS SEROGRUPO B"
  },
  {
    "codigo":238637007,
    "descripcion":"ACANTOSIS PALMAR"
  },
  {
    "codigo":369709008,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA DE GLÁNDULA SUPRARRENAL, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":40194002,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE LABIO, SIN INFECCIÓN"
  },
  {
    "codigo":171266004,
    "descripcion":"SIN CONSENTIMIENTO PARA VACUNACIÓN ANTIDIFTÉRICA"
  },
  {
    "codigo":7426009,
    "descripcion":"ÚLCERA CORNEAL CENTRAL"
  },
  {
    "codigo":366039006,
    "descripcion":"HALLAZGO RELACIONADO CON EL COLOR DE LA ESCLERÓTICA"
  },
  {
    "codigo":3756000,
    "descripcion":"ATAXIA ESTÁTICA"
  },
  {
    "codigo":167596001,
    "descripcion":"EXAMEN DE HECES: NORMAL"
  },
  {
    "codigo":200364001,
    "descripcion":"INFECCIÓN OBSTÉTRICA DE MAMA"
  },
  {
    "codigo":300503008,
    "descripcion":"EPIDÍDIMO NORMAL"
  },
  {
    "codigo":5591009,
    "descripcion":"HEMIANOPSIA HOMÓNIMA DERECHA"
  },
  {
    "codigo":15973181000119106,
    "descripcion":"ANOMALÍA CONGÉNITA DE VASO SANGUÍNEO DE EXTREMIDAD INFERIOR IZQUIERDA"
  },
  {
    "codigo":724652008,
    "descripcion":"TRASTORNO DE MOVIMIENTOS ESTEREOTIPADOS SIN COMPORTAMIENTO AUTOLESIVO"
  },
  {
    "codigo":36524008,
    "descripcion":"DISTROFIA HIALINA DE LA MEMBRANA DE BRUCH"
  },
  {
    "codigo":298668008,
    "descripcion":"COLUMNA LUMBAR INESTABLE"
  },
  {
    "codigo":296833002,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE CARBIMAZOL"
  },
  {
    "codigo":1279873007,
    "descripcion":"SÍNDROME DE CORDÓN CENTRAL DE MÉDULA LUMBAR DEBIDO A SUBLUXACIÓN VERTEBRAL NO EXPUESTA"
  },
  {
    "codigo":16028631000119102,
    "descripcion":"EXOSTOSIS DE HÚMERO DERECHO"
  },
  {
    "codigo":294998006,
    "descripcion":"ALERGIA A POLITIAZIDA"
  },
  {
    "codigo":720982007,
    "descripcion":"SÍNDROME DE ALPORT, DISCAPACIDAD INTELECTUAL, HIPOPLASIA MEDIOFACIAL Y ELIPTOCITOSIS"
  },
  {
    "codigo":293163000,
    "descripcion":"REACCIÓN ADVERSA A LA FLUOCINOLONA"
  },
  {
    "codigo":196694009,
    "descripcion":"ÚLCERA PÉPTICA CRÓNICA CON OBSTRUCCIÓN"
  },
  {
    "codigo":1145131000,
    "descripcion":"EXOFTALMÍA DEBIDA A EDEMA ORBITARIO"
  },
  {
    "codigo":299991000119104,
    "descripcion":"ARTRITIS ESTAFILOCÓCICA DE PIE"
  },
  {
    "codigo":131158008,
    "descripcion":"SUBGRUPO B"
  },
  {
    "codigo":94720001,
    "descripcion":"TRANSFORMACIÓN MIXOIDE DE VÁLVULA TRICÚSPIDE"
  },
  {
    "codigo":225792003,
    "descripcion":"CONOCE SUS DERECHOS"
  },
  {
    "codigo":1208832006,
    "descripcion":"TAQUICARDIA MEDIADA POR MARCAPASOS"
  },
  {
    "codigo":422400008,
    "descripcion":"VÓMITOS"
  },
  {
    "codigo":125653000,
    "descripcion":"HERIDA ABIERTA DE DEDO DE LA MANO"
  },
  {
    "codigo":15920241000119101,
    "descripcion":"REACCIÓN ALÉRGICA CAUSADA POR FRUTA"
  },
  {
    "codigo":92885004,
    "descripcion":"VÍA BILIAR ELONGADA CONGÉNITA"
  },
  {
    "codigo":191189009,
    "descripcion":"BETATALASEMIA INTERMEDIA"
  },
  {
    "codigo":683121000119103,
    "descripcion":"CONDROSARCOMA PRIMARIO DE MANDÍBULA"
  },
  {
    "codigo":59571007,
    "descripcion":"ALTERACIÓN DE LA COLORACIÓN DEL PELO"
  },
  {
    "codigo":123818007,
    "descripcion":"REFLEJO TUSÍGENO ALTERADO"
  },
  {
    "codigo":1336234008,
    "descripcion":"TRASTORNO POR USO DE CAFEÍNA"
  },
  {
    "codigo":58282009,
    "descripcion":"HEPATITIS VIRAL RECURRENTE"
  },
  {
    "codigo":89215000,
    "descripcion":"GLAUCOMA DE CIERRE DE ÁNGULO POSTOPERATORIO"
  },
  {
    "codigo":11824241000119104,
    "descripcion":"CONTUSIÓN DE BRAZO IZQUIERDO"
  },
  {
    "codigo":427784006,
    "descripcion":"DESHIDRATACIÓN HIPERNATRÉMICA"
  },
  {
    "codigo":254890008,
    "descripcion":"ADENOCARCINOMA IN SITU DE CUELLO UTERINO"
  },
  {
    "codigo":15674481000119103,
    "descripcion":"MIOSITIS INTERSTICIAL DE AMBOS ANTEBRAZOS"
  },
  {
    "codigo":285823003,
    "descripcion":"NO ABRE LAS CANILLAS DE AGUA"
  },
  {
    "codigo":282153000,
    "descripcion":"DIFICULTAD PARA CAMINAR EN TERRENO PLANO"
  },
  {
    "codigo":87380008,
    "descripcion":"AUSENCIA CONGÉNITA DE LA VAGINA"
  },
  {
    "codigo":773673002,
    "descripcion":"SÍNDROME DE HIPOPLASIA DE PÁNCREAS, ATRESIA INTESTINAL E HIPOPLASIA DE VESÍCULA BILIAR"
  },
  {
    "codigo":249385008,
    "descripcion":"GRANDES PAPILAS CALICIFORMES"
  },
  {
    "codigo":413225008,
    "descripcion":"ESOFAGITIS GRADO I"
  },
  {
    "codigo":52777008,
    "descripcion":"RIÑÓN PEQUEÑO BILATERAL"
  },
  {
    "codigo":247550004,
    "descripcion":"PELO EN BANDAS"
  },
  {
    "codigo":444158007,
    "descripcion":"LESIÓN TRAUMÁTICA DE LIGAMENTO CRUZADO DE RODILLA"
  },
  {
    "codigo":409555000,
    "descripcion":"MENINGITIS CAUSADA POR COXIELLA BURNETII"
  },
  {
    "codigo":737235001,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DE LA TRÁQUEA"
  },
  {
    "codigo":49107007,
    "descripcion":"TUBERCULOSIS DEL OJO"
  },
  {
    "codigo":243880000,
    "descripcion":"ESTADO DE CONSENTIMIENTO PARA INMUNIZACIONES"
  },
  {
    "codigo":211112001,
    "descripcion":"PICADURA DE INSECTO, NO VENENOSO, EN PERINEO"
  },
  {
    "codigo":276648002,
    "descripcion":"HEMORRAGIA INTRAVENTRICULAR EN EL PREMATURO"
  },
  {
    "codigo":473256003,
    "descripcion":"QUEMADURA DE MÚLTIPLES SITIOS DE LA CABEZA SIN COMPROMISO DEL OJO PROPIAMENTE DICHO"
  },
  {
    "codigo":735400004,
    "descripcion":"INFECCIÓN LOCALIZADA DE TEJIDO SUBCUTÁNEO"
  },
  {
    "codigo":1259688003,
    "descripcion":"CARCINOMA ADENOIDE QUÍSTICO PRIMARIO DE GLÁNDULA LAGRIMAL DERECHA"
  },
  {
    "codigo":302501000119100,
    "descripcion":"ANQUILOSIS DE ARTICULACIÓN DE PIE IZQUIERDO"
  },
  {
    "codigo":373117000,
    "descripcion":"EXAMEN ANATOMOPATOLÓGICO - HALLAZGOS INDETERMINADOS"
  },
  {
    "codigo":209277004,
    "descripcion":"FRACTURA-LUXACIÓN EXPUESTA DE LA ARTICULACIÓN MEDIOCARPIANA"
  },
  {
    "codigo":1290621006,
    "descripcion":"PÉRDIDA DE CADENA DE FRÍO DE VACUNA"
  },
  {
    "codigo":78205008,
    "descripcion":"PENSAMIENTOS IRRACIONALES"
  },
  {
    "codigo":274813008,
    "descripcion":"REFLEJO CORNEAL DERECHO AUSENTE"
  },
  {
    "codigo":698962002,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚLTIPLES LUGARES DEL COLON"
  },
  {
    "codigo":404050001,
    "descripcion":"RABDOMIOMA GENITAL"
  },
  {
    "codigo":405885008,
    "descripcion":"FENOTIPO S+"
  },
  {
    "codigo":305746007,
    "descripcion":"ATENDIDO POR ENFERMERA PEDIÁTRICA"
  },
  {
    "codigo":238375000,
    "descripcion":"IMPÉTIGO ESTREPTOCÓCICO"
  },
  {
    "codigo":402215004,
    "descripcion":"ECCEMA DISCOIDE INFECTADO"
  },
  {
    "codigo":271143006,
    "descripcion":"AMPOLLA TRAUMÁTICA DEL PENE, INFECTADA"
  },
  {
    "codigo":1286951008,
    "descripcion":"CARCINOMA DE CÉLULAS DE MERKEL PRIMARIO DE PIEL DE OREJA"
  },
  {
    "codigo":1186812001,
    "descripcion":"HIPOALDOSTERONISMO HIPERRENINÉMICO FAMILIAR TIPO 2"
  },
  {
    "codigo":762663009,
    "descripcion":"DISOCIACIÓN MESENCEFÁLICA DE LUZ-PROXIMIDAD"
  },
  {
    "codigo":72700005,
    "descripcion":"INTOXICACIÓN POR TRIPELENAMINA"
  },
  {
    "codigo":236540009,
    "descripcion":"REACCIÓN DE HIPERSENSIBILIDAD NO ALÉRGICA DURANTE DIÁLISIS"
  },
  {
    "codigo":365777004,
    "descripcion":"NIVEL DE HORMONA FETOPLACENTARIA - HALLAZGO"
  },
  {
    "codigo":726225005,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO ADUCTOR DE MUSLO"
  },
  {
    "codigo":1119441009,
    "descripcion":"ATROFIA DE MÚSCULO DE ANTEBRAZO"
  },
  {
    "codigo":298406003,
    "descripcion":"AMPLITUD DE FLEXIÓN ACTIVA DE LA COLUMNA CERVICAL NORMAL"
  },
  {
    "codigo":16004671000119103,
    "descripcion":"VARIANZA CUBITAL POSITIVA CONGÉNITA BILATERAL DE MUÑECAS"
  },
  {
    "codigo":724390007,
    "descripcion":"PÓLIPO DEL MARGEN ANAL"
  },
  {
    "codigo":36262007,
    "descripcion":"PIGMALIONISMO"
  },
  {
    "codigo":34427002,
    "descripcion":"ARTROPATÍA POR CRISTALES DE REGIÓN DE HOMBRO"
  },
  {
    "codigo":11826751000119104,
    "descripcion":"DISTENSIÓN DE MÚSCULO DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":296571002,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE MEFLOQUINA"
  },
  {
    "codigo":165499005,
    "descripcion":"ENZIMAS ERITROCÍTICAS: NORMALES"
  },
  {
    "codigo":1148539005,
    "descripcion":"SOBREDOSIS DE HORMONA TIROIDEA"
  },
  {
    "codigo":67195008,
    "descripcion":"TRASTORNO POR ESTRÉS AGUDO"
  },
  {
    "codigo":294736002,
    "descripcion":"ALERGIA A GLIMIDINA"
  },
  {
    "codigo":423973006,
    "descripcion":"CARCINOMA DE CUELLO UTERINO, INVASIVO"
  },
  {
    "codigo":292901007,
    "descripcion":"REACCIÓN ADVERSA AL CETILPIRIDINIO"
  },
  {
    "codigo":94458003,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE AMÍGDALAS"
  },
  {
    "codigo":10679871000119109,
    "descripcion":"TUMORACIÓN DEL TEJIDO CELULAR SUBCUTÁNEO DEL ANTEBRAZO IZQUIERDO"
  },
  {
    "codigo":717050005,
    "descripcion":"ANEMIA SIDEROBLÁSTICA AUTOSÓMICA RECESIVA"
  },
  {
    "codigo":1306874005,
    "descripcion":"GLAUCOMA DE OJO DERECHO CON HEMORRAGIA INTRAOCULAR"
  },
  {
    "codigo":127226007,
    "descripcion":"NEOPLASIA DEL ANILLO DE WALDEYER"
  },
  {
    "codigo":225530007,
    "descripcion":"SALIR A BUSCAR SEXO OCASIONAL CON UNA PAREJA HOMOSEXUAL"
  },
  {
    "codigo":289231006,
    "descripcion":"PUJO INVOLUNTARIO EN EL TRABAJO DE PARTO"
  },
  {
    "codigo":92623006,
    "descripcion":"CARCINOMA IN SITU DE LA ZONA DE UNIÓN DE LA LENGUA"
  },
  {
    "codigo":715215007,
    "descripcion":"SÍNDROME DE DELECIÓN CROMOSÓMICA 11P13"
  },
  {
    "codigo":711545001,
    "descripcion":"MIGRAÑA CAUSADA POR ANTICONCEPTIVO CON ESTRÓGENOS"
  },
  {
    "codigo":1137529004,
    "descripcion":"CALCIFICACIÓN PUNTEADA DE EPÍFISIS DE FALANGE MEDIA DE TERCER DEDO DE PIE"
  },
  {
    "codigo":331481000119108,
    "descripcion":"XANTOMA DE PÁRPADO SUPERIOR DERECHO"
  },
  {
    "codigo":87118001,
    "descripcion":"SÍNDROME VERTIGINOSO"
  },
  {
    "codigo":285561009,
    "descripcion":"INCAPAZ DE DESCENDER EL PALADAR BLANDO"
  },
  {
    "codigo":185422004,
    "descripcion":"CITA REALIZADA POR MEDIO DE UNA NOTA"
  },
  {
    "codigo":15732441000119109,
    "descripcion":"ENTROPIÓN CON ECTROPIÓN DE AMBOS PÁRPADOS INFERIORES"
  },
  {
    "codigo":283726004,
    "descripcion":"MORDEDURA HUMANA EN LA PANTORRILLA"
  },
  {
    "codigo":1363235005,
    "descripcion":"QUISTE DE ENCÉFALO"
  },
  {
    "codigo":609571007,
    "descripcion":"DIABETES DEL ADULTO DE INICIO JUVENIL, TIPO 4"
  },
  {
    "codigo":10872691000119105,
    "descripcion":"LACERACIÓN DE TABIQUE NASAL"
  },
  {
    "codigo":314659009,
    "descripcion":"PERÍMETRO CEFÁLICO DEL NIÑO: PERCENTILO 98,1-99,6"
  },
  {
    "codigo":52515009,
    "descripcion":"HERNIA DE CAVIDAD ABDOMINAL"
  },
  {
    "codigo":83448006,
    "descripcion":"PAPILOMA PLANTAR EN LA FRAMBESIA"
  },
  {
    "codigo":835277001,
    "descripcion":"PALADAR BLANDO, FAUCES, ÚVULA PALATINA, ARCO GLOSOPALATINO Y ARCO FARINGOPALATINO VISIBLES"
  },
  {
    "codigo":704205002,
    "descripcion":"NEFROPATÍA CAUSADA POR TACROLIMÚS"
  },
  {
    "codigo":442061005,
    "descripcion":"IMPLANTE RADIACTIVO IN SITU"
  },
  {
    "codigo":276386000,
    "descripcion":"PRÓSTATA FIRME"
  },
  {
    "codigo":210850001,
    "descripcion":"LESIÓN EXPUESTA, ARTERIA DIGITAL"
  },
  {
    "codigo":472994003,
    "descripcion":"FASE FREUDIANA DE DESARROLLO PSICOSEXUAL"
  },
  {
    "codigo":1259426006,
    "descripcion":"NEUROBLASTOMA PRIMARIO DE GLÁNDULA SUPRARRENAL"
  },
  {
    "codigo":733303000,
    "descripcion":"DEFORMIDAD DE ÓRBITA ÓSEA"
  },
  {
    "codigo":702370009,
    "descripcion":"PACIENTE INADECUADO PARA PROCEDIMIENTO"
  },
  {
    "codigo":407458009,
    "descripcion":"ENFERMEDAD CAUSADA POR PAPILLOMAVIRIDAE"
  },
  {
    "codigo":47010009,
    "descripcion":"ASPIRACIÓN DE COMPUESTO ANIMAL"
  },
  {
    "codigo":307319004,
    "descripcion":"RUPTURA DE ARTERIA SUBCLAVIA"
  },
  {
    "codigo":77943002,
    "descripcion":"DIETA CON 20 GRAMOS DE PROTEÍNAS SELECCIONADAS"
  },
  {
    "codigo":688141000119104,
    "descripcion":"NEURILEMOMA DE NERVIO DE LA MANO"
  },
  {
    "codigo":403788000,
    "descripcion":"DISTROFIA UNGUEAL POR ENFERMEDAD DE DARIER"
  },
  {
    "codigo":305484000,
    "descripcion":"BAJO ATENCIÓN DE MÉDICO GENERAL"
  },
  {
    "codigo":371020003,
    "descripcion":"HEMATURIA RENAL"
  },
  {
    "codigo":698700004,
    "descripcion":"TRASTORNO DE PERSONALIDAD LIMÍTROFE EN REMISIÓN"
  },
  {
    "codigo":10846221000119106,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO PLANTAR EXTERNO DERECHO"
  },
  {
    "codigo":239948006,
    "descripcion":"AORTITIS SECUNDARIA"
  },
  {
    "codigo":895308006,
    "descripcion":"FORMA DE BALA ANORMAL CONGÉNITA DE FALANGE DISTAL DE DEDO ANULAR"
  },
  {
    "codigo":762401000,
    "descripcion":"LESIÓN TRAUMÁTICA DEBIDA A INYECCIÓN TERAPÉUTICA Y POSTERIOR A ELLA"
  },
  {
    "codigo":10572007,
    "descripcion":"SÍNDROME DE TRISOMÍA PARCIAL 13Q"
  },
  {
    "codigo":333991000119100,
    "descripcion":"RETINITIS FOCAL DE MÁCULA DE OJO DERECHO"
  },
  {
    "codigo":238113006,
    "descripcion":"DEFICIENCIA DE COLINA"
  },
  {
    "codigo":41505007,
    "descripcion":"SÍNDROME DE DÉBRÉ - SÉMÉLAIGNE"
  },
  {
    "codigo":270881008,
    "descripcion":"METAMORFOSIS GRASA DE LAS VÍSCERAS"
  },
  {
    "codigo":400118002,
    "descripcion":"PAPULOSIS BOWENOIDE DE PENE CON NEOPLASIA INTRAEPITELIAL DE GRADO III"
  },
  {
    "codigo":72438008,
    "descripcion":"HERNIA INGUINAL PREPERITONEAL"
  },
  {
    "codigo":301814009,
    "descripcion":"INSUFICIENCIA RENAL POSRENAL"
  },
  {
    "codigo":15980711000119104,
    "descripcion":"ARTRITIS DE ARTICULACIÓN TEMPOROMANDIBULAR IZQUIERDA"
  },
  {
    "codigo":365515003,
    "descripcion":"PERSONALIZACIÓN DEL HOGAR - HALLAZGO"
  },
  {
    "codigo":70603007,
    "descripcion":"RUPTURA DE CORDÓN"
  },
  {
    "codigo":298144004,
    "descripcion":"ARTICULACIÓN PRESENTE"
  },
  {
    "codigo":34165000,
    "descripcion":"PROTEINURIA GESTACIONAL"
  },
  {
    "codigo":296309003,
    "descripcion":"SOBREDOSIS DE PSILOCIBINA"
  },
  {
    "codigo":722293005,
    "descripcion":"SÍNDROME DE ATAXIA CEREBELOSA AUTOSÓMICA DOMINANTE, SORDERA Y NARCOLEPSIA"
  },
  {
    "codigo":230773005,
    "descripcion":"PARÁLISIS CEREBRAL ESPÁSTICA"
  },
  {
    "codigo":1344885007,
    "descripcion":"HABILIDADES DIGITALES INADECUADAS QUE AFECTAN EL EMPLEO"
  },
  {
    "codigo":720458005,
    "descripcion":"SÍNDROME ACRORRENAL"
  },
  {
    "codigo":294474006,
    "descripcion":"ALERGIA A ESPECTINOMICINA"
  },
  {
    "codigo":194335001,
    "descripcion":"PÉRDIDA PARCIAL \/ NECROSIS DE HUESECILLOS DEL OÍDO"
  },
  {
    "codigo":390943009,
    "descripcion":"FERRITINA SÉRICA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":290804005,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR LITIO"
  },
  {
    "codigo":94196006,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE VASO SANGUÍNEO DE LA CABEZA"
  },
  {
    "codigo":126964007,
    "descripcion":"NEOPLASIA DE LAS MENINGES ESPINALES"
  },
  {
    "codigo":288969000,
    "descripcion":"CAPAZ DE ESCUPIR"
  },
  {
    "codigo":10957121000119106,
    "descripcion":"HERIDA ABIERTA DE DEDO DE LA MANO DERECHA DEBIDA A MORDEDURA HUMANA"
  },
  {
    "codigo":92361002,
    "descripcion":"NEOPLASIA BENIGNA DE LA PIEL DEL PIE"
  },
  {
    "codigo":716788007,
    "descripcion":"LINFOMA DIFUSO DE GRANDES LINFOCITOS B POSITIVO PARA VIRUS DE EPSTEIN-BARR DEL ANCIANO"
  },
  {
    "codigo":125129007,
    "descripcion":"DENSIDAD RADIOLÓGICA ANORMAL, IRREGULAR"
  },
  {
    "codigo":26825009,
    "descripcion":"PIEL MARMÓREA"
  },
  {
    "codigo":287134001,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO DE PÁRPADO"
  },
  {
    "codigo":449139001,
    "descripcion":"FUSIÓN DE COMISURA DE VÁLVULA TRONCAL"
  },
  {
    "codigo":55923008,
    "descripcion":"DIETA PARA LACTANTES"
  },
  {
    "codigo":283464001,
    "descripcion":"HERIDA PUNZANTE EN EL ANTEBRAZO"
  },
  {
    "codigo":117211000119105,
    "descripcion":"LINFOMA PERIFÉRICO DE LINFOCITOS T DE GANGLIOS LINFÁTICOS DE MÚLTIPLES LOCALIZACIONES"
  },
  {
    "codigo":86856005,
    "descripcion":"DISFUNCIÓN DEL MÚSCULO PAPILAR"
  },
  {
    "codigo":250696005,
    "descripcion":"APOLIPOPROTEÍNA E, FENOTIPO E2:3"
  },
  {
    "codigo":248861000,
    "descripcion":"VULVA ATRÓFICA"
  },
  {
    "codigo":738546000,
    "descripcion":"METABOLIZADOR INTERMEDIO DE LA FAMILIA 2 SUBFAMILIA C MIEMBRO 9 DEL CITOCROMO P450"
  },
  {
    "codigo":1197298003,
    "descripcion":"NEOPLASIA DE CÉLULAS GERMINALES MALIGNA PRIMARIA DE GLÁNDULA PINEAL"
  },
  {
    "codigo":1230066003,
    "descripcion":"MICROESFEROFAQUIA AISLADA"
  },
  {
    "codigo":1073781000119104,
    "descripcion":"ARTRITIS REUMATOIDE DE PIE DERECHO"
  },
  {
    "codigo":409031004,
    "descripcion":"CON MAYOR RIESGO DE LESIÓN PERIOPERATORIA"
  },
  {
    "codigo":336501000119105,
    "descripcion":"LEUCOMA ADHERENTE DE OJO DERECHO"
  },
  {
    "codigo":210588005,
    "descripcion":"SECCIÓN TOTAL, TENDÓN DEL EXTENSOR LARGO DEL PULGAR"
  },
  {
    "codigo":13980006,
    "descripcion":"ARACNOIDITIS ADHESIVA"
  },
  {
    "codigo":733041001,
    "descripcion":"HERIDA ACCIDENTAL DURANTE PROCEDIMIENTO"
  },
  {
    "codigo":44913001,
    "descripcion":"ATETOSIS"
  },
  {
    "codigo":700273003,
    "descripcion":"TUBERCULOSIS TRAQUEOBRONQUIAL AISLADA"
  },
  {
    "codigo":90741000119107,
    "descripcion":"ESTADIO 3 DE ENFERMEDAD RENAL CRÓNICA DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":405361005,
    "descripcion":"DIFUSIÓN EXCESIVA DE ANESTÉSICO LOCAL"
  },
  {
    "codigo":77681005,
    "descripcion":"ADHERENCIAS PERITUBÁRICAS"
  },
  {
    "codigo":403526001,
    "descripcion":"SÍNDROME DE ERITRODERMIA DEL LACTANTE, FALTA DE PROGRESO Y DIARREA"
  },
  {
    "codigo":10310006,
    "descripcion":"FRACTURA EXPUESTA A NIVEL DE C1 - C4 CON LESIÓN INCOMPLETA DE LA MÉDULA ESPINAL"
  },
  {
    "codigo":1255494009,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO DE DEDO GORDO DE PIE IZQUIERDO"
  },
  {
    "codigo":205083002,
    "descripcion":"PIE CAVO CONGÉNITO - VALGO"
  },
  {
    "codigo":312584000,
    "descripcion":"TROMBOSIS DE VENA DEL TRONCO"
  },
  {
    "codigo":237851007,
    "descripcion":"ACIDOSIS HIPOCALIÉMICA"
  },
  {
    "codigo":303387009,
    "descripcion":"DIFICULTAD PARA CAMBIAR DE POSICIÓN"
  },
  {
    "codigo":301552001,
    "descripcion":"SE LEVANTA DEL INODORO"
  },
  {
    "codigo":12106511000119106,
    "descripcion":"QUEMADURA DE ANTEBRAZO DERECHO"
  },
  {
    "codigo":39408006,
    "descripcion":"FRACTURA NO EXPUESTA DE HUESO ILÍACO"
  },
  {
    "codigo":236016008,
    "descripcion":"ENTEROCOLITIS HEMORRÁGICA AGUDA"
  },
  {
    "codigo":398021003,
    "descripcion":"SÍNDROME DE SUPERPOSICIÓN DE ENFERMEDADES DEL TEJIDO CONJUNTIVO"
  },
  {
    "codigo":70341005,
    "descripcion":"LARINGITIS TUBERCULOSA"
  },
  {
    "codigo":37573006,
    "descripcion":"DIETA BLANDA, ESTADIO 2"
  },
  {
    "codigo":1348293006,
    "descripcion":"SE MOVILIZA DURANTE EL TRABAJO DE PARTO"
  },
  {
    "codigo":266949007,
    "descripcion":"PROBLEMAS DOMÉSTICOS"
  },
  {
    "codigo":234181008,
    "descripcion":"DEHISCENCIA DE PRÓTESIS DE VÁLVULA CARDÍACA"
  },
  {
    "codigo":363418001,
    "descripcion":"NEOPLASIA MALIGNA DE PÁNCREAS"
  },
  {
    "codigo":4805006,
    "descripcion":"AFASIA FUNCIONAL"
  },
  {
    "codigo":365253009,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA CORTAR ALIMENTOS EN RODAJAS"
  },
  {
    "codigo":199578005,
    "descripcion":"HEMORRAGIA MATERNOFETAL CON PROBLEMA PRENATAL"
  },
  {
    "codigo":723866006,
    "descripcion":"FIBRILACIÓN VENTRICULAR IDIOPÁTICA, NO DEL TIPO BRUGADA"
  },
  {
    "codigo":1344623000,
    "descripcion":"TRASTORNO DE CIRCULACIÓN PERIFÉRICA DEBIDO A DIABETES MELLITUS RELACIONADA CON DESNUTRICIÓN"
  },
  {
    "codigo":1135000,
    "descripcion":"RETINOPATÍA SOLAR"
  },
  {
    "codigo":722031003,
    "descripcion":"SÍNDROME DE KAPUR TORIELLO"
  },
  {
    "codigo":230511003,
    "descripcion":"ATROFIA ÓPTICA SECUNDARIA A PAPILEDEMA"
  },
  {
    "codigo":296047004,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE CICLOBARBITAL"
  },
  {
    "codigo":359748005,
    "descripcion":"EL ESTADO DEL PACIENTE NO HA VARIADO"
  },
  {
    "codigo":15684521000119106,
    "descripcion":"PERIOSTITIS DE PIE IZQUIERDO"
  },
  {
    "codigo":195908008,
    "descripcion":"NEUMONÍA ACTINOMICÓTICA"
  },
  {
    "codigo":30233002,
    "descripcion":"DOLOR AL TRAGAR"
  },
  {
    "codigo":1076291000119101,
    "descripcion":"BURSITIS ISQUIOGLÚTEA DE CADERA DERECHA"
  },
  {
    "codigo":292377004,
    "descripcion":"REACCIÓN ADVERSA A LA BUTIROFENONA"
  },
  {
    "codigo":536581000221101,
    "descripcion":"OCLUSIÓN DE ARTERIA PEDIA IZQUIERDA"
  },
  {
    "codigo":16067651000119101,
    "descripcion":"NEOPLASIA NEUROENDOCRINA BIEN DIFERENCIADA METASTÁSICA EN PERITONEO"
  },
  {
    "codigo":126702001,
    "descripcion":"NEOPLASIA DE LA CARA LARÍNGEA DEL PLIEGUE INTERARITENOIDEO"
  },
  {
    "codigo":28398002,
    "descripcion":"EMBOLIA GRASA COMO COMPLICACIÓN TEMPRANA DE UN TRAUMATISMO"
  },
  {
    "codigo":225006001,
    "descripcion":"SE ENOJA CON FACILIDAD"
  },
  {
    "codigo":93934004,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE OVARIO"
  },
  {
    "codigo":11998121000119109,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DE REGIÓN PALMAR DE MANO DERECHA"
  },
  {
    "codigo":92099001,
    "descripcion":"NEOPLASIA BENIGNA DEL NERVIO FACIAL"
  },
  {
    "codigo":11807811000119104,
    "descripcion":"RUPTURA TRAUMÁTICA DE LIGAMENTO SEMILUNOPIRAMIDAL DERECHO"
  },
  {
    "codigo":288707005,
    "descripcion":"CAPAZ DE COMUNICARSE EN DIFERENTES OCASIONES"
  },
  {
    "codigo":339011000119105,
    "descripcion":"PANOFTALMITIS DE OJO IZQUIERDO"
  },
  {
    "codigo":254104009,
    "descripcion":"DISPLASIA CON DENSIDAD ÓSEA DISMINUIDA"
  },
  {
    "codigo":285037006,
    "descripcion":"NO MANEJA LA MEDICACIÓN"
  },
  {
    "codigo":449459006,
    "descripcion":"DEFECTO DEL TABIQUE AURICULOVENTRICULAR CON INSUFICIENCIA DE VÁLVULA AURICULOVENTRICULAR A TRAVÉS DE COMISURA MURAL LATERAL DE VALVA EN PUENTE INFERIOR"
  },
  {
    "codigo":283202002,
    "descripcion":"ANZUELO EN EL DORSO DE LA MANO"
  },
  {
    "codigo":217666004,
    "descripcion":"ENVENENAMIENTO DEBIDO A PICADURA DE ARAÑA VIUDA NEGRA"
  },
  {
    "codigo":281367000,
    "descripcion":"OSTEOCONDROMATOSIS SINOVIAL SECUNDARIA"
  },
  {
    "codigo":248599002,
    "descripcion":"ESPUTO ABUNDANTE"
  },
  {
    "codigo":707351006,
    "descripcion":"INFECCIÓN RESPIRATORIA INSTITUCIONAL"
  },
  {
    "codigo":84759007,
    "descripcion":"TRASTORNO DEL NERVIO ACCESORIO"
  },
  {
    "codigo":1231639008,
    "descripcion":"GRANULOMA PIÓGENO DE CONJUNTIVA"
  },
  {
    "codigo":246764005,
    "descripcion":"NISTAGMO POSTURAL"
  },
  {
    "codigo":16014711000119101,
    "descripcion":"OCLUSIÓN DE ARTERIA POPLÍTEA DERECHA"
  },
  {
    "codigo":16260471000119101,
    "descripcion":"PARÁLISIS DE NERVIO RADIAL DERECHO"
  },
  {
    "codigo":81089005,
    "descripcion":"CALCIFICACIÓN DE LA TRÁQUEA"
  },
  {
    "codigo":367991000119101,
    "descripcion":"HIPERGLUCEMIA DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":15959261000119108,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE AMBOS RIÑONES"
  },
  {
    "codigo":769217008,
    "descripcion":"EDEMA MACULAR DEL OJO DERECHO DEBIDO A DIABETES MELLITUS"
  },
  {
    "codigo":439702007,
    "descripcion":"DEFICIENCIA HEREDITARIA DE PROTEÍNA S"
  },
  {
    "codigo":79254009,
    "descripcion":"CODO INESTABLE"
  },
  {
    "codigo":700011003,
    "descripcion":"TRASTORNO DE LA CINTURA PÉLVICA"
  },
  {
    "codigo":208491004,
    "descripcion":"FRACTURA EXPUESTA DE FALANGE DISTAL DE DEDO DE LA MANO, CONMINUTA"
  },
  {
    "codigo":110187008,
    "descripcion":"QUEMADURA EPIDÉRMICA DE MEJILLA"
  },
  {
    "codigo":1156928001,
    "descripcion":"NO INMUNE CONTRA HAEMOPHILUS INFLUENZAE B"
  },
  {
    "codigo":370496000,
    "descripcion":"UROVAGINA"
  },
  {
    "codigo":403264003,
    "descripcion":"PIGMENTACIÓN CAUSADA POR BISMUTO"
  },
  {
    "codigo":16561681000119100,
    "descripcion":"LUXACIÓN CERRADA DE AMBAS ARTICULACIONES TEMPOROMANDIBULARES"
  },
  {
    "codigo":1255232007,
    "descripcion":"FRACTURA EXPUESTA DE MÚLTIPLES HUESOS METACARPIANOS"
  },
  {
    "codigo":1288000009,
    "descripcion":"SOBREDOSIS DE INHIBIDOR DE LA RECAPTACIÓN DE NORADRENALINA"
  },
  {
    "codigo":1220629002,
    "descripcion":"RESPUESTA ALTERADA A PROCEDIMIENTO DE MOVILIZACIÓN DE CÉLULAS MADRE"
  },
  {
    "codigo":11836791000119107,
    "descripcion":"SUBLUXACIÓN DE ARTICULACIÓN INTERTARSIANA DE PIE IZQUIERDO"
  },
  {
    "codigo":40981003,
    "descripcion":"HERPES SIMPLE PRIMARIO"
  },
  {
    "codigo":237589007,
    "descripcion":"SECRECIÓN EXCESIVA DE GLICENTINA"
  },
  {
    "codigo":73749009,
    "descripcion":"ICTERICIA NEONATAL ASOCIADA CON PARTO PRETÉRMINO"
  },
  {
    "codigo":204821009,
    "descripcion":"ANOMALÍA CONGÉNITA DE ÓRGANOS GENITALES"
  },
  {
    "codigo":202986004,
    "descripcion":"TENDÓN CORTO"
  },
  {
    "codigo":6378004,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚLTIPLES VASOS SANGUÍNEOS DE LA CABEZA Y\/O DEL CUELLO"
  },
  {
    "codigo":15742481000119103,
    "descripcion":"APOFISITIS DE EPITRÓCLEA DE CODO DERECHO DEBIDA A USO EXCESIVO"
  },
  {
    "codigo":102847000,
    "descripcion":"SEDIMENTO URINARIO AMORFO"
  },
  {
    "codigo":301290008,
    "descripcion":"SANGRE FRANCA EN ESPUTO"
  },
  {
    "codigo":299455001,
    "descripcion":"ARTICULACIÓN DE TOBILLO CALIENTE AL TACTO"
  },
  {
    "codigo":235754009,
    "descripcion":"COLITIS FLEMONOSA"
  },
  {
    "codigo":168383004,
    "descripcion":"HELICOBACTER NO DETECTADO EN SANGRE"
  },
  {
    "codigo":364991005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD DE UTILIZAR FLUJO DE AIRE GLÓTICO PARA HABLAR"
  },
  {
    "codigo":233919006,
    "descripcion":"BLOQUEO COMPLETO AISLADO FAMILIAR DE RAMA DERECHA DEL HAZ DE HIS"
  },
  {
    "codigo":1078801000119105,
    "descripcion":"CATARATA POLAR SUBCAPSULAR POSTERIOR SENIL DE OJO DERECHO"
  },
  {
    "codigo":70079009,
    "descripcion":"EFECTOS TARDÍOS DEL RAQUITISMO (UN AÑO O MÁS)"
  },
  {
    "codigo":315051000119100,
    "descripcion":"ENFERMEDAD DE PAGET DE FÉMUR IZQUIERDO"
  },
  {
    "codigo":341521000119107,
    "descripcion":"ECTROPIÓN CICATRIZAL DE PÁRPADO IZQUIERDO"
  },
  {
    "codigo":263017003,
    "descripcion":"LUXACIÓN DE ARTICULACIÓN DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":230249003,
    "descripcion":"ATROFIA MUSCULAR ESPINAL FACIOESCAPULOHUMERAL"
  },
  {
    "codigo":13841000119107,
    "descripcion":"DERRAME PLEURAL EXUDATIVO"
  },
  {
    "codigo":721769003,
    "descripcion":"MENINGITIS CAUSADA POR VIRUS DE EPSTEIN-BARR"
  },
  {
    "codigo":425022003,
    "descripcion":"APOYO SOCIAL INADECUADO"
  },
  {
    "codigo":293950005,
    "descripcion":"ALERGIA A REMOXIPRIDA"
  },
  {
    "codigo":40851000087100,
    "descripcion":"QUEMADURA DE CUARTO DEDO DE PIE DERECHO"
  },
  {
    "codigo":718099006,
    "descripcion":"AGUJEROS PARIETALES AUMENTADOS DE TAMAÑO"
  },
  {
    "codigo":128275006,
    "descripcion":"ANOMALÍA CONGÉNITA DE LOS SENOS NASALES"
  },
  {
    "codigo":161043008,
    "descripcion":"DISCAPACIDAD - LEVE"
  },
  {
    "codigo":95507006,
    "descripcion":"DIVERTÍCULO CONGÉNITO DEL CANALÍCULO LAGRIMAL"
  },
  {
    "codigo":880104002,
    "descripcion":"INGESTA EXCESIVA DE RIBOFLAVINA"
  },
  {
    "codigo":292115008,
    "descripcion":"REACCIÓN ADVERSA A LA PIRENZEPINA"
  },
  {
    "codigo":43411000087108,
    "descripcion":"PROLAPSO DE DISCO INTERVERTEBRAL L5-S1"
  },
  {
    "codigo":38291000087109,
    "descripcion":"HIPOCINESIA DE SEGMENTO INFEROSEPTAL BASAL DE VENTRÍCULO CARDÍACO IZQUIERDO"
  },
  {
    "codigo":421352006,
    "descripcion":"MOVIMIENTO PUPILAR RÁPIDO"
  },
  {
    "codigo":1142248006,
    "descripcion":"HIPERTROFIA DE MÚSCULO DE ANTEBRAZO"
  },
  {
    "codigo":93672006,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA PORCIÓN ANTERIOR DEL PISO DE LA BOCA"
  },
  {
    "codigo":288445005,
    "descripcion":"NO REALIZA ACTIVIDADES DE ESCRITURA"
  },
  {
    "codigo":288581000119102,
    "descripcion":"HIPOXEMIA RELACIONADA CON EL SUEÑO"
  },
  {
    "codigo":124605009,
    "descripcion":"DEFICIENCIA DE CETOTETROSA - FOSFATO ALDOLASA"
  },
  {
    "codigo":90002005,
    "descripcion":"RUIDO DE DISPARO DE PISTOLA"
  },
  {
    "codigo":1236882005,
    "descripcion":"RUPTURA TRAUMÁTICA DE VESÍCULA SEMINAL"
  },
  {
    "codigo":450450008,
    "descripcion":"DISINCRONÍA ENTRE EL PACIENTE Y EL RESPIRADOR"
  },
  {
    "codigo":253842008,
    "descripcion":"MALFORMACIÓN CONGÉNITA DEL CLÍTORIS"
  },
  {
    "codigo":15935301000119104,
    "descripcion":"DEFORMIDAD EN FLEXIÓN DE ARTICULACIÓN DE TOBILLO DERECHO"
  },
  {
    "codigo":710759004,
    "descripcion":"DESVIACIÓN DE LA ÚVULA HACIA LA IZQUIERDA"
  },
  {
    "codigo":22631008,
    "descripcion":"INESTABLE DURANTE LA MARCHA"
  },
  {
    "codigo":55399009,
    "descripcion":"ABSCESO DE DÍGITO"
  },
  {
    "codigo":284775008,
    "descripcion":"INCAPAZ DE REALIZAR ACTIVIDAD DE CUIDADO PERSONAL"
  },
  {
    "codigo":282940004,
    "descripcion":"DIFICULTAD PARA INCLINARSE"
  },
  {
    "codigo":10692421000119106,
    "descripcion":"TUMEFACCIÓN DEL TEJIDO CELULAR SUBCUTÁNEO DEL PULGAR DERECHO"
  },
  {
    "codigo":1081311000119100,
    "descripcion":"OSTEOSARCOMA PRIMARIO DE OMÓPLATO IZQUIERDO"
  },
  {
    "codigo":1290741000000106,
    "descripcion":"CON MAYOR RIESGO DE EXPOSICIÓN A VIRUS DE VIRUELA DE MONO"
  },
  {
    "codigo":1111541000000107,
    "descripcion":"CIERRE DE ÁNGULO DEBIDO A UVEÍTIS"
  },
  {
    "codigo":1264145006,
    "descripcion":"DAÑO DE VAGINA POSTERIOR A EMBARAZO ECTÓPICO"
  },
  {
    "codigo":1231377006,
    "descripcion":"INFLAMACIÓN DE INTESTINO DELGADO CAUSADA POR ESCHERICHIA COLI"
  },
  {
    "codigo":84497008,
    "descripcion":"EVALUACIÓN DE DISCAPACIDAD: 40%"
  },
  {
    "codigo":707089008,
    "descripcion":"INFECCIÓN DEL TRACTO GENITAL EN EL PUERPERIO"
  },
  {
    "codigo":17126001,
    "descripcion":"FACIES ANTONINA"
  },
  {
    "codigo":770790004,
    "descripcion":"RETRASO DEL DESARROLLO CON TRASTORNO DEL ESPECTRO AUTISTA E INESTABILIDAD EN LA MARCHA"
  },
  {
    "codigo":49894005,
    "descripcion":"TRICOMICOSIS AXILAR"
  },
  {
    "codigo":836326004,
    "descripcion":"AGUDEZA VISUAL CON AGUJERO ESTENOPEICO DE OJO IZQUIERDO 6\/9"
  },
  {
    "codigo":443110007,
    "descripcion":"EDEMA DEL BRAZO"
  },
  {
    "codigo":80827001,
    "descripcion":"QUEMADURA DEL ANTEBRAZO"
  },
  {
    "codigo":408507007,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: AMHÁRICO"
  },
  {
    "codigo":235784001,
    "descripcion":"FÍSTULA RECTOURINARIA"
  },
  {
    "codigo":13456001,
    "descripcion":"FRACTURA NO EXPUESTA A NIVEL DE D1 - D6 CON LESIÓN INCOMPLETA DE LA MÉDULA ESPINAL"
  },
  {
    "codigo":210064002,
    "descripcion":"LACERACIÓN DE CORAZÓN CON HERIDA ABIERTA HACIA TÓRAX Y PENETRACIÓN DE CÁMARAS CARDÍACAS"
  },
  {
    "codigo":242832005,
    "descripcion":"SOBREDOSIS INTENCIONAL DE BENZODIAZEPINA"
  },
  {
    "codigo":111760006,
    "descripcion":"INTOXICACIÓN CAUSADA POR VITAMINA"
  },
  {
    "codigo":765285002,
    "descripcion":"ATRACCIÓN SEXUAL POR EL SEXO MASCULINO"
  },
  {
    "codigo":109925003,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LOS NERVIOS PERIFÉRICOS DE LA CARA"
  },
  {
    "codigo":699749004,
    "descripcion":"ARCADA MANDIBULAR ESTRECHA"
  },
  {
    "codigo":77157004,
    "descripcion":"TRASTORNO DEL NERVIO ÓPTICO"
  },
  {
    "codigo":208229007,
    "descripcion":"FRACTURA NO EXPUESTA DE CUELLO DE OMÓPLATO"
  },
  {
    "codigo":239162003,
    "descripcion":"CELULITIS DE HERIDA"
  },
  {
    "codigo":697914005,
    "descripcion":"HIPERTENSIÓN PULMONAR DEBIDA A ALTERACIÓN DE LA RESPIRACIÓN DURANTE EL SUEÑO"
  },
  {
    "codigo":403002006,
    "descripcion":"TIÑA DEL CUERO CABELLUDO POR MICROSPORUM CANIS VARIEDAD CANIS"
  },
  {
    "codigo":7951001,
    "descripcion":"JUANETE DE SASTRE"
  },
  {
    "codigo":40719004,
    "descripcion":"ESOFAGITIS EROSIVA"
  },
  {
    "codigo":15718521000119105,
    "descripcion":"FALTA DE FUSÍÓN DE ACROMION DE OMÓPLATO IZQUIERDO"
  },
  {
    "codigo":366564003,
    "descripcion":"AMPLITUD DE MOVIMIENTO PASIVO DE FLEXIÓN DE LA CADERA - HALLAZGO"
  },
  {
    "codigo":202724006,
    "descripcion":"SÍNDROME POSLAMINECTOMÍA DORSAL"
  },
  {
    "codigo":299193004,
    "descripcion":"SIN AMPLITUD PASIVA DE OPOSICIÓN DE PULGAR"
  },
  {
    "codigo":364729007,
    "descripcion":"MOTRICIDAD GRUESA CORPORAL Y DE LAS EXTREMIDADES"
  },
  {
    "codigo":788878000,
    "descripcion":"MIOCARDIOPATÍA DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":127251000119102,
    "descripcion":"CHOQUE SÉPTICO CONCOMITANTE CON DISFUNCIÓN ORGÁNICA AGUDA CAUSADO POR STREPTOCOCCUS"
  },
  {
    "codigo":231822002,
    "descripcion":"QUISTE DE ZEISS"
  },
  {
    "codigo":233657008,
    "descripcion":"FIBROSIS PLEURAL POSTUBERCULOSA"
  },
  {
    "codigo":1149326003,
    "descripcion":"INTOXICACIÓN POR POTASIO"
  },
  {
    "codigo":291091000119102,
    "descripcion":"MONOPLEJÍA DE MIEMBRO SUPERIOR IZQUIERDO NO DOMINANTE DEBIDA A ACCIDENTE CEREBROVASCULAR Y POSTERIOR A ÉL"
  },
  {
    "codigo":11786361000119108,
    "descripcion":"AMPOLLA DE DEDO MEDIO DE MANO IZQUIERDA, CON INFECCIÓN"
  },
  {
    "codigo":395662007,
    "descripcion":"CAPAZ DE COMPRENDER EL CONCEPTO DE PELIGRO"
  },
  {
    "codigo":69817007,
    "descripcion":"OCLUSIÓN CONGÉNITA DEL ANO"
  },
  {
    "codigo":721507001,
    "descripcion":"SÍNDROME DEL CORDÓN CENTRAL DE MÉDULA ESPINAL AL NIVEL DEL SEGUNDO SEGMENTO LUMBAR"
  },
  {
    "codigo":262755005,
    "descripcion":"LESIÓN DEL CRISTALINO"
  },
  {
    "codigo":228152009,
    "descripcion":"DISCAPACIDAD PARA BAÑARSE"
  },
  {
    "codigo":291853002,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR LIOTIRONINA"
  },
  {
    "codigo":1083821000119101,
    "descripcion":"HIPERACUSIA DE AMBOS OÍDOS"
  },
  {
    "codigo":11815341000119101,
    "descripcion":"RUPTURA TRAUMÁTICA DE LIGAMENTO LATERAL DE ARTICULACIÓN DE DEDO ANULAR DERECHO"
  },
  {
    "codigo":62477005,
    "descripcion":"ÚLCERA GASTROYEYUNAL CRÓNICA CON PERFORACIÓN PERO SIN OBSTRUCCIÓN"
  },
  {
    "codigo":95245006,
    "descripcion":"HEMIVÉRTEBRA SACRA"
  },
  {
    "codigo":160781004,
    "descripcion":"INTERRUPCIÓN DE LA PRESTACIÓN DE ENFERMERA DEL DISTRITO"
  },
  {
    "codigo":27874004,
    "descripcion":"EVALUACIÓN DE DISCAPACIDAD: 25%"
  },
  {
    "codigo":93410004,
    "descripcion":"ENGROSAMIENTO CONGÉNITO DEL TARSO"
  },
  {
    "codigo":224482004,
    "descripcion":"SIN AYUDA DISPONIBLE DE CUIDADOR NO PROFESIONAL"
  },
  {
    "codigo":1172919000,
    "descripcion":"HEMOGLOBINA A1C DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":124343001,
    "descripcion":"DEFICIENCIA DE RIBOSA-FOSFATO PIROFOSFOCINASA"
  },
  {
    "codigo":286348000,
    "descripcion":"DIFICULTAD PARA PRODUCIR CALIDAD DE VOZ APROPIADA"
  },
  {
    "codigo":26039008,
    "descripcion":"NEUROSÍFILIS"
  },
  {
    "codigo":448353003,
    "descripcion":"ODONTOMA DE MAXILAR INFERIOR"
  },
  {
    "codigo":284513006,
    "descripcion":"CONDUCTA MANÍACA"
  },
  {
    "codigo":282678000,
    "descripcion":"INCAPAZ DE ALCANZAR"
  },
  {
    "codigo":87905008,
    "descripcion":"FRACTURA DE GOSSELIN"
  },
  {
    "codigo":315446000,
    "descripcion":"NACIDO EN IRÁN"
  },
  {
    "codigo":249910004,
    "descripcion":"DIFICULTAD PARA GIRAR LA CABEZA"
  },
  {
    "codigo":1003574005,
    "descripcion":"AGENESIA DE MANO IZQUIERDA"
  },
  {
    "codigo":86070006,
    "descripcion":"PERIMETRITIS"
  },
  {
    "codigo":248075006,
    "descripcion":"INCONCIENCIA SOBRE PELIGROS COMUNES"
  },
  {
    "codigo":51467008,
    "descripcion":"HEMÓLISIS EXTRAVASCULAR"
  },
  {
    "codigo":82400004,
    "descripcion":"SIGNO DE LA MONEDA"
  },
  {
    "codigo":1292981000,
    "descripcion":"FRACTURA EXPUESTA DE RAMA DE PUBIS"
  },
  {
    "codigo":703157002,
    "descripcion":"FALLA DE PRÓTESIS DE VÁLVULA MITRAL"
  },
  {
    "codigo":735925003,
    "descripcion":"CICATRICES CORIORRETINIANAS POSTERIORES A CIRUGÍA POR DESPRENDIMIENTO DE RETINA"
  },
  {
    "codigo":211637007,
    "descripcion":"CUERPO EXTRAÑO EN EL APÉNDICE ILEOCECAL"
  },
  {
    "codigo":277173008,
    "descripcion":"OBSTRUCCIÓN DE TUBO DE VENTILACIÓN TIMPÁNICA"
  },
  {
    "codigo":275338001,
    "descripcion":"FRACTURA SUBCAPITAL NO EXPUESTA DE FÉMUR"
  },
  {
    "codigo":13194006,
    "descripcion":"SÍNDROME MEDULAR ANTERIOR DEBIDO A FRACTURA NO EXPUESTA A NIVEL DE T7-T12"
  },
  {
    "codigo":371807002,
    "descripcion":"ANGINA DE PECHO ATÍPICA"
  },
  {
    "codigo":207967003,
    "descripcion":"FRACTURA EXPUESTA DE VÉRTEBRA LUMBAR, EN CUÑA"
  },
  {
    "codigo":240735009,
    "descripcion":"ULCERACIÓN NASAL POR HISTOPLASMOSIS CLÁSICA"
  },
  {
    "codigo":109663009,
    "descripcion":"ARTRITIS DE LA ARTICULACIÓN TEMPOROMANDIBULAR EN LA POLIARTRITIS"
  },
  {
    "codigo":238900004,
    "descripcion":"LIPOATROFIA POSINFLAMATORIA"
  },
  {
    "codigo":402740007,
    "descripcion":"DERMATOSIS SECUNDARIA A TRASTORNO DE NERVIO PERIFÉRICO"
  },
  {
    "codigo":1156404008,
    "descripcion":"POLIEMBRIOMA"
  },
  {
    "codigo":271668009,
    "descripcion":"PIORREA"
  },
  {
    "codigo":1285641001,
    "descripcion":"ORQUIEPIDIDIMITIS AGUDA"
  },
  {
    "codigo":73225005,
    "descripcion":"HERNIA ISQUIÁTICA CON OBSTRUCCIÓN"
  },
  {
    "codigo":269833008,
    "descripcion":"MONONUCLEOSIS INFECCIOSA DETECTADA"
  },
  {
    "codigo":7689009,
    "descripcion":"CONVULSIÓN ORIGINADA POR LA LECTURA"
  },
  {
    "codigo":237065008,
    "descripcion":"FIBROIDE DEL LIGAMENTO OVÁRICO"
  },
  {
    "codigo":169694003,
    "descripcion":"CRIBADO PARA RUBÉOLA DESEADO"
  },
  {
    "codigo":300766000,
    "descripcion":"DIFICULTAD PARA REALIZAR ACTIVIDAD CREATIVA"
  },
  {
    "codigo":1086331000119103,
    "descripcion":"DIVERTICULITIS DEL YEYUNO CON PERFORACIÓN"
  },
  {
    "codigo":366302003,
    "descripcion":"HALLAZGO RELACIONADO CON LA POSICIÓN DEL ÚTERO"
  },
  {
    "codigo":36787001,
    "descripcion":"CONTUSIÓN DEL TRONCO"
  },
  {
    "codigo":1078061000119100,
    "descripcion":"OSTEOCONDROSIS JUVENIL DE SEGUNDO METATARSIANO DERECHO"
  },
  {
    "codigo":724915005,
    "descripcion":"LESIÓN TRAUMÁTICA DE TENDÓN DE CABEZA LARGA DEL BÍCEPS"
  },
  {
    "codigo":105261000119101,
    "descripcion":"ADENOSIS ESCLEROSANTE DE MAMA"
  },
  {
    "codigo":292141000119100,
    "descripcion":"TRASTORNO DE NERVIO CIÁTICO POPLÍTEO EXTERNO DERECHO A LA ALTURA DE RAMA POPLÍTEA LATERAL"
  },
  {
    "codigo":301000119104,
    "descripcion":"ESPASMO DE MÚSCULO DEL CUELLO"
  },
  {
    "codigo":564989741000119102,
    "descripcion":"TRASTORNO DEBIDO A TRASPLANTE DE CÓRNEA DE OJO DERECHO Y POSTERIOR A ÉL"
  },
  {
    "codigo":322861000119106,
    "descripcion":"LESIÓN TRAUMÁTICA DE REGIÓN DE COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":11830061000119100,
    "descripcion":"HEMATOMA DE REGIÓN DE RODILLA DERECHA"
  },
  {
    "codigo":133421000119101,
    "descripcion":"TROMBOSIS AGUDA DE VENA MESENTÉRICA"
  },
  {
    "codigo":298931008,
    "descripcion":"CREPITACIÓN PALPABLE DE ARTICULACIÓN DE CODO"
  },
  {
    "codigo":12265261000119102,
    "descripcion":"HIGROMA EXTRAAXIAL BENIGNO"
  },
  {
    "codigo":317741000119107,
    "descripcion":"TENDINITIS PERONEA DE MIEMBRO INFERIOR IZQUIERDO"
  },
  {
    "codigo":310061000119109,
    "descripcion":"GOTA PRIMARIA CRÓNICA DE HOMBRO, SIN TOFO"
  },
  {
    "codigo":721245001,
    "descripcion":"MIELITIS CAUSADA POR BACTERIA"
  },
  {
    "codigo":315181000119108,
    "descripcion":"OSTEOCONDRITIS DISECANTE DE RODILLA IZQUIERDA"
  },
  {
    "codigo":23341000119109,
    "descripcion":"INSUFICIENCIA CARDÍACA CONGESTIVA CON INSUFICIENCIA DERECHA"
  },
  {
    "codigo":229725003,
    "descripcion":"SISTEMA SONORO NO CONTRASTANTE"
  },
  {
    "codigo":143661000119109,
    "descripcion":"SOFOCO NO MENOPÁUSICO"
  },
  {
    "codigo":349006,
    "descripcion":"REFLEJO TENDINOSO AUSENTE"
  },
  {
    "codigo":196957002,
    "descripcion":"HERNIA DE SPIEGEL IRREDUCTIBLE"
  },
  {
    "codigo":65885002,
    "descripcion":"OBSTRUCCIÓN PARCIAL DE VÍA URINARIA"
  },
  {
    "codigo":293426001,
    "descripcion":"REACCIÓN ADVERSA AL BEZAFIBRATO"
  },
  {
    "codigo":129586002,
    "descripcion":"SÍNDROME DE LA PELVIS RÍGIDA"
  },
  {
    "codigo":162354008,
    "descripcion":"RONQUIDO EN EL OÍDO"
  },
  {
    "codigo":422663003,
    "descripcion":"ANIMAL PELIGROSO EN EL AMBIENTE"
  },
  {
    "codigo":94983006,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA GLÁNDULA PARATIROIDES"
  },
  {
    "codigo":291591008,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR CEFAMANDOL"
  },
  {
    "codigo":60380001,
    "descripcion":"NARCOLEPSIA"
  },
  {
    "codigo":191452002,
    "descripcion":"DEMENCIA PRESENIL CON DELIRIO"
  },
  {
    "codigo":160519009,
    "descripcion":"ORIGEN INDIO"
  },
  {
    "codigo":289756001,
    "descripcion":"CUELLO UTERINO, NO VISUALIZADO"
  },
  {
    "codigo":1010652002,
    "descripcion":"ARTERIA UMBILICAL ÚNICA TIPO II"
  },
  {
    "codigo":224220007,
    "descripcion":"VIVE EN VIVIENDA SUBSIDIADA"
  },
  {
    "codigo":1172657003,
    "descripcion":"RELACIÓN COLESTEROL\/LIPOPROTEÍNA DE ALTA DENSIDAD DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1303729003,
    "descripcion":"DISECCIÓN DE RAMA DESCENDENTE ANTERIOR DE ARTERIA CORONARIA IZQUIERDA"
  },
  {
    "codigo":255153003,
    "descripcion":"NEOPLASIA BENIGNA DE MUCOSA DE LABIO INFERIOR"
  },
  {
    "codigo":91313006,
    "descripcion":"APENDICITIS PÉLVICA"
  },
  {
    "codigo":1269126000,
    "descripcion":"METÁSTASIS DE CARCINOMA ESCAMOSO EN ESTÓMAGO"
  },
  {
    "codigo":449926001,
    "descripcion":"TROMBOFLEBITIS DE VENA SUPERFICIAL DE PIERNA"
  },
  {
    "codigo":286086002,
    "descripcion":"CAPAZ DE LAVAR LA VAJILLA"
  },
  {
    "codigo":253318000,
    "descripcion":"VENA CAVA INFERIOR QUE DESEMBOCA EN EL SENO CORONARIO"
  },
  {
    "codigo":56710004,
    "descripcion":"QUEMADURA EPIDÉRMICA DE MUÑECA"
  },
  {
    "codigo":89478006,
    "descripcion":"MELANODERMIA PARASITARIA"
  },
  {
    "codigo":710235005,
    "descripcion":"BEBÉ PREMATURO, 28-32 SEMANAS"
  },
  {
    "codigo":251483006,
    "descripcion":"RESPUESTA DE HIPERVENTILACIÓN PROLONGADA"
  },
  {
    "codigo":448091007,
    "descripcion":"INTERACCIÓN FARMACOLÓGICA ADVERSA CON ALCOHOL"
  },
  {
    "codigo":284251007,
    "descripcion":"CAPAZ DE FLEXIONAR LA MANO EN PUÑO"
  },
  {
    "codigo":184112005,
    "descripcion":"DOMICILIO DEL PACIENTE - DESCONOCIDO"
  },
  {
    "codigo":249648007,
    "descripcion":"ESPASMO DEL ESFÍNTER ANAL"
  },
  {
    "codigo":20272009,
    "descripcion":"RECIÉN NACIDOS MÚLTIPLES PREMATUROS"
  },
  {
    "codigo":870405004,
    "descripcion":"INGESTA INADECUADA DE CARBOHIDRATOS"
  },
  {
    "codigo":247813005,
    "descripcion":"MIEDO A SOFOCARSE"
  },
  {
    "codigo":1163482004,
    "descripcion":"INFARTO CEREBRAL HEMORRÁGICO POR ASPERGILLUS"
  },
  {
    "codigo":213210005,
    "descripcion":"PÉRDIDA DE LÍQUIDO CEFALORRAQUÍDEO EN EL POSOPERATORIO"
  },
  {
    "codigo":105801000119103,
    "descripcion":"INMUNIDAD CONTRA HEPATITIS A DETERMINADA POR SEROLOGÍA"
  },
  {
    "codigo":47535005,
    "descripcion":"SÍNDROME DE COLOBOMA, MALFORMACIÓN CARDÍACA, ATRESIA DE COANAS, RETRASO DE CRECIMIENTO Y DESARROLLO, TRASTORNOS GENITOURINARIOS Y MALFORMACIONES AURICULARES"
  },
  {
    "codigo":12932003,
    "descripcion":"CÁLCULO DEL COLÉDOCO CON COLECISTITIS CRÓNICA CON OBSTRUCCIÓN"
  },
  {
    "codigo":209540006,
    "descripcion":"ESGUINCE DE ARTICULACIÓN METATARSOFALÁNGICA"
  },
  {
    "codigo":111236008,
    "descripcion":"COMPRESIÓN DE RAÍZ DE NERVIO RAQUÍDEO"
  },
  {
    "codigo":207705002,
    "descripcion":"LESIÓN TRAUMÁTICA INTRACRANEAL CONCOMITANTE CON FRACTURA EXPUESTA DE LA BÓVEDA CRANEAL Y DEBIDA A ELLA"
  },
  {
    "codigo":240473007,
    "descripcion":"INFECCIÓN MANDIBULAR POR HERPES ZÓSTER"
  },
  {
    "codigo":42030000,
    "descripcion":"TRASTORNO DEL APARATO GENITOURINARIO"
  },
  {
    "codigo":238638002,
    "descripcion":"HIPERQUERATOSIS DIGITIFORMES MÚLTIPLES DIMINUTAS DE GOLDSTEIN"
  },
  {
    "codigo":369710003,
    "descripcion":"INVASIÓN TUMORAL DEL MARGEN DE RESECCIÓN QUIRÚRGICA, NO DETERMINADA"
  },
  {
    "codigo":402478005,
    "descripcion":"INFILTRACIÓN XANTOMATOSA SECUNDARIA DE PIEL"
  },
  {
    "codigo":236803007,
    "descripcion":"INFERTILIDAD OLIGOSINÁPTICA"
  },
  {
    "codigo":171267008,
    "descripcion":"SIN CONSENTIMIENTO PARA INMUNIZACIÓN CONTRA EL TÉTANOS"
  },
  {
    "codigo":234968002,
    "descripcion":"DENTINOGÉNESIS IMPERFECTA - TIPO I DE SHIELD"
  },
  {
    "codigo":300504002,
    "descripcion":"HALLAZGO RELACIONADO CON EL CONDUCTO DEFERENTE"
  },
  {
    "codigo":366040008,
    "descripcion":"VASCULARIDAD DE LA ESCLERÓTICA - HALLAZGO"
  },
  {
    "codigo":298669000,
    "descripcion":"COLUMNA LUMBAR ESTABLE"
  },
  {
    "codigo":69293004,
    "descripcion":"HERIDA ABIERTA DE LOS ÓRGANOS GENITALES EXTERNOS"
  },
  {
    "codigo":1279874001,
    "descripcion":"SÍNDROME DE CORDÓN CENTRAL DE MÉDULA LUMBAR DEBIDO A LUXACIÓN VERTEBRAL EXPUESTA"
  },
  {
    "codigo":296834008,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE CARBIMAZOL"
  },
  {
    "codigo":1922008,
    "descripcion":"AUSENCIA CONGÉNITA DE LA URETRA"
  },
  {
    "codigo":426071002,
    "descripcion":"ENFERMEDAD DE HODGKIN EN REMISIÓN"
  },
  {
    "codigo":720983002,
    "descripcion":"SÍNDROME DE AMAUROSIS E HIPERTRICOSIS"
  },
  {
    "codigo":131159000,
    "descripcion":"GRUPO SANGUÍNEO B>3<"
  },
  {
    "codigo":32855007,
    "descripcion":"PERSISTENCIA HEREDITARIA DE HEMOGLOBINA FETAL NO VINCULADA AL GRUPO DE GENES DE GLOBULINA BETA"
  },
  {
    "codigo":65623009,
    "descripcion":"NEUTROPENIA INMUNITARIA"
  },
  {
    "codigo":10675991000119100,
    "descripcion":"EXACERBACIÓN SEVERA AGUDA DE ASMA ALÉRGICA LEVE PERSISTENTE CONCOMITANTE CON RINITIS ALÉRGICA"
  },
  {
    "codigo":16000791000119100,
    "descripcion":"ESCLERITIS DE OJO IZQUIERDO POR HERPES ZOSTER"
  },
  {
    "codigo":293164006,
    "descripcion":"REACCIÓN ADVERSA A LA FLUTICASONA"
  },
  {
    "codigo":1208833001,
    "descripcion":"POLIMIOCLONÍA GENERALIZADA AUTOINMUNITARIA"
  },
  {
    "codigo":94721002,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL ESÓFAGO ABDOMINAL"
  },
  {
    "codigo":291329001,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR HOMATROPINA"
  },
  {
    "codigo":225793008,
    "descripcion":"NO FORTALECIDO"
  },
  {
    "codigo":92886003,
    "descripcion":"FORMA ANORMAL CONGÉNITA DE GLÁNDULA SUPRARRENAL"
  },
  {
    "codigo":1091351000119103,
    "descripcion":"TRASTORNO DE TROMPA DE EUSTAQUIO DERECHA"
  },
  {
    "codigo":125654006,
    "descripcion":"HERIDA ABIERTA DE DEDO PULGAR"
  },
  {
    "codigo":11986711000119103,
    "descripcion":"QUEMADURA EPIDÉRMICA DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":60118008,
    "descripcion":"ALCALOSIS RESPIRATORIA AGUDA"
  },
  {
    "codigo":91051003,
    "descripcion":"ESPOROTRICOSIS DISEMINADA"
  },
  {
    "codigo":123819004,
    "descripcion":"AUSENCIA DE REFLEJO TUSÍGENO"
  },
  {
    "codigo":58283004,
    "descripcion":"PULSO PEQUEÑO"
  },
  {
    "codigo":354071000119104,
    "descripcion":"NEOPLASIA BENIGNA DE RETINA IZQUIERDA"
  },
  {
    "codigo":254891007,
    "descripcion":"FIBROMA CERVICAL"
  },
  {
    "codigo":1336235009,
    "descripcion":"TRASTORNO POR USO DE ALUCINÓGENOS"
  },
  {
    "codigo":23680005,
    "descripcion":"ENTESOPATÍA"
  },
  {
    "codigo":681751000119106,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE CONDUCTO BILIAR INTRAHEPÁTICO"
  },
  {
    "codigo":447829000,
    "descripcion":"ANOMALÍA CONGÉNITA DE CUERDAS TENDINOSAS DE VÁLVULA TRICÚSPIDE"
  },
  {
    "codigo":283989001,
    "descripcion":"RECUERDOS INTRUSIVOS"
  },
  {
    "codigo":21845002,
    "descripcion":"CONSISTENCIA GRANULOSA"
  },
  {
    "codigo":285824009,
    "descripcion":"DIFICULTAD PARA ABRIR LAS CANILLAS DE AGUA"
  },
  {
    "codigo":251221008,
    "descripcion":"ONDA P INVERTIDA"
  },
  {
    "codigo":20010003,
    "descripcion":"TRASTORNO LIMÍTROFE DE LA PERSONALIDAD"
  },
  {
    "codigo":4915001,
    "descripcion":"INFECCIÓN CAUSADA POR ENTAMOEBA COLI"
  },
  {
    "codigo":50943000,
    "descripcion":"ANOMALÍA CONGÉNITA DE BRONQUIOS"
  },
  {
    "codigo":249386009,
    "descripcion":"LENGUA AFRAMBUESADA"
  },
  {
    "codigo":247551000,
    "descripcion":"BURBUJAS EN EL TALLO DEL PELO"
  },
  {
    "codigo":739071000,
    "descripcion":"ANTÍGENO LEUCOCÍTICO HUMANO B*58:01 NEGATIVO"
  },
  {
    "codigo":444159004,
    "descripcion":"LESIÓN TRAUMÁTICA DE LIGAMENTO LATERAL DE RODILLA"
  },
  {
    "codigo":413226009,
    "descripcion":"ESOFAGITIS GRADO II"
  },
  {
    "codigo":737236000,
    "descripcion":"CONMOCIÓN DE MÉDULA ESPINAL DORSAL"
  },
  {
    "codigo":409556004,
    "descripcion":"ENCEFALITIS POR FIEBRE Q"
  },
  {
    "codigo":1163220007,
    "descripcion":"LESIÓN POR PRESIÓN GRADO 2"
  },
  {
    "codigo":243881001,
    "descripcion":"SITUACIÓN DE EVALUACIÓN ESPECIAL"
  },
  {
    "codigo":278484009,
    "descripcion":"HIPEREOSINOFILIA FILARIÁSICA"
  },
  {
    "codigo":276649005,
    "descripcion":"HEMORRAGIA PERIVENTRICULAR PERINATAL"
  },
  {
    "codigo":1259689006,
    "descripcion":"COREA DEBIDA A SÍNDROME SIMILAR A ENFERMEDAD DE HUNTINGTON TIPO 2"
  },
  {
    "codigo":473257007,
    "descripcion":"QUEMADURA EPIDÉRMICA DE MÚLTIPLES SITIOS DE LA CABEZA SIN COMPROMISO DEL OJO PROPIAMENTE DICHO"
  },
  {
    "codigo":211113006,
    "descripcion":"PICADURA DE INSECTO, NO VENENOSO, EN EL PENE"
  },
  {
    "codigo":373118005,
    "descripcion":"MICROCALCIFICACIONES PRESENTES EN EL ESPÉCIMEN MAMARIO"
  },
  {
    "codigo":240211000,
    "descripcion":"CALCIFICACIÓN DE DISCO INTERVERTEBRAL"
  },
  {
    "codigo":209278009,
    "descripcion":"FRACTURA-LUXACIÓN EXPUESTA DE ARTICULACIÓN CARPOMETACARPIANA"
  },
  {
    "codigo":404051002,
    "descripcion":"RABDOMIOSARCOMA EMBRIONARIO"
  },
  {
    "codigo":405886009,
    "descripcion":"FENOTIPO S -"
  },
  {
    "codigo":305747003,
    "descripcion":"ATENDIDO POR ENFERMERA PSIQUIÁTRICA"
  },
  {
    "codigo":10835007,
    "descripcion":"PULSO POLICRÓTICO"
  },
  {
    "codigo":271144000,
    "descripcion":"AMPOLLA TRAUMÁTICA DE LA VULVA, INFECTADA"
  },
  {
    "codigo":76371008,
    "descripcion":"HERIDA PENETRANTE DE ÓRBITA CON PRESENCIA DE CUERPO EXTRAÑO"
  },
  {
    "codigo":698963007,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚLTIPLES LUGARES DEL RECTO"
  },
  {
    "codigo":762664003,
    "descripcion":"PIGMENTACIÓN DE LA PIEL CAUSADA POR LUZ ULTRAVIOLETA ARTIFICIAL"
  },
  {
    "codigo":238376004,
    "descripcion":"IMPÉTIGO ESTAFILOCÓCICO NO BULLOSO"
  },
  {
    "codigo":402216003,
    "descripcion":"ECCEMA VESICULAR AGUDO DE MANOS"
  },
  {
    "codigo":369448007,
    "descripcion":"TUMOR MALIGNO QUE COMPROMETE EL RECTO POR PROPAGACIÓN DIRECTA DEL ENDOMETRIO"
  },
  {
    "codigo":860968007,
    "descripcion":"GLÁNDULA SALIVAL NORMAL"
  },
  {
    "codigo":1186813006,
    "descripcion":"ENCEFALOPATÍA POR DEFICIENCIA DE MÚLTIPLES NUTRIENTES"
  },
  {
    "codigo":236541008,
    "descripcion":"ACIDOSIS HIPERCLORÉMICA ASOCIADA CON DIÁLISIS"
  },
  {
    "codigo":1119442002,
    "descripcion":"ATROFIA DE MÚSCULO DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":856856651000119109,
    "descripcion":"TROMBOSIS VENOSA PROFUNDA CRÓNICA DE VENA PERONEA IZQUIERDA"
  },
  {
    "codigo":726226006,
    "descripcion":"LESIÓN TRAUMÁTICA DE FASCIA DE MÚSCULO ADUCTOR DEL MUSLO"
  },
  {
    "codigo":201938008,
    "descripcion":"ARTROPATÍA TRAUMÁTICA DE TOBILLO Y PIE"
  },
  {
    "codigo":365778009,
    "descripcion":"NIVEL DE HORMONA GASTROINTESTINAL - HALLAZGO"
  },
  {
    "codigo":298407007,
    "descripcion":"AMPLITUD DE FLEXIÓN ACTIVA DE LA COLUMNA CERVICAL AUMENTADA"
  },
  {
    "codigo":165500001,
    "descripcion":"ENZIMAS ERITROCÍTICAS: ANORMALES"
  },
  {
    "codigo":198268002,
    "descripcion":"PROLAPSO UTEROVAGINAL INCOMPLETO"
  },
  {
    "codigo":722556003,
    "descripcion":"PARKINSONISMO CONCOMITANTE CON INFECCIÓN AGUDA Y DEBIDO A ELLA"
  },
  {
    "codigo":427644005,
    "descripcion":"PÉRDIDA DE LA AUDICIÓN CENTRAL, BILATERAL"
  },
  {
    "codigo":1148540007,
    "descripcion":"SOBREDOSIS DE AGONISTA DE RECEPTOR DE DOPAMINA"
  },
  {
    "codigo":294737006,
    "descripcion":"ALERGIA A TOLAZAMIDA"
  },
  {
    "codigo":292902000,
    "descripcion":"REACCIÓN ADVERSA A SURFACTANTE DE QUINOLINIO CUATERNARIO"
  },
  {
    "codigo":1144870004,
    "descripcion":"APLASIA DE TROMPA DE FALOPIO"
  },
  {
    "codigo":16058751000119103,
    "descripcion":"FRACASO DE TRASPLANTE DE CÓRNEA DE AMBOS OJOS"
  },
  {
    "codigo":129062008,
    "descripcion":"INDEPENDENCIA PARA LA HIGIENE"
  },
  {
    "codigo":63526009,
    "descripcion":"DIETA CARDÍACA SEMIBLANDA CON 2 GRAMOS DE SODIO"
  },
  {
    "codigo":127227003,
    "descripcion":"NEOPLASIA DE AMÍGDALA PALATINA"
  },
  {
    "codigo":94459006,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE PÁNCREAS"
  },
  {
    "codigo":782587007,
    "descripcion":"ALERGIA A COMPUESTO QUE CONTIENE FÓSFORO ORGÁNICO"
  },
  {
    "codigo":92624000,
    "descripcion":"CARCINOMA IN SITU DE RIÑÓN"
  },
  {
    "codigo":61691009,
    "descripcion":"ADIADOCOCINESIA"
  },
  {
    "codigo":1306875006,
    "descripcion":"GLAUCOMA BILATERAL CON HEMORRAGIA INTRAOCULAR"
  },
  {
    "codigo":225531006,
    "descripcion":"CONDUCTA HOMOSEXUAL"
  },
  {
    "codigo":289232004,
    "descripcion":"HALLAZGO RELACIONADO CON LA TERCERA ETAPA DEL TRABAJO DE PARTO"
  },
  {
    "codigo":715216008,
    "descripcion":"ARTROGRIPOSIS DISTAL TIPO 2B"
  },
  {
    "codigo":254629004,
    "descripcion":"CARCINOMA DE CÉLULAS GRANDES DE PULMÓN"
  },
  {
    "codigo":123557007,
    "descripcion":"ANOMALÍA CONGÉNITA DEL OMÓPLATO"
  },
  {
    "codigo":711546000,
    "descripcion":"CONEXIÓN VENTRICULOARTERIAL CONCORDANTE CON GRANDES ARTERIAS PARALELAS"
  },
  {
    "codigo":285562002,
    "descripcion":"BAJA EL PALADAR BLANDO"
  },
  {
    "codigo":252794008,
    "descripcion":"PARÁLISIS DEL NERVIO OBTURADOR"
  },
  {
    "codigo":1137530009,
    "descripcion":"CALCIFICACIÓN PUNTEADA DE EPÍFISIS DE FALANGE MEDIA DE CUARTO DEDO DE PIE"
  },
  {
    "codigo":609572000,
    "descripcion":"DIABETES DEL ADULTO DE INICIO JUVENIL, TIPO 5"
  },
  {
    "codigo":87119009,
    "descripcion":"PULMÓN QUÍSTICO CONGÉNITO"
  },
  {
    "codigo":283727008,
    "descripcion":"MORDEDURA HUMANA EN EL TOBILLO"
  },
  {
    "codigo":85284003,
    "descripcion":"ANGINA DE PECHO, CLASE III"
  },
  {
    "codigo":314660004,
    "descripcion":"PERÍMETRO CEFÁLICO DEL NIÑO: > PERCENTILO 99,6"
  },
  {
    "codigo":183588003,
    "descripcion":"DERIVADO AL ODONTÓLOGO"
  },
  {
    "codigo":1363236006,
    "descripcion":"QUISTE HIDATÍDICO DE ENCÉFALO"
  },
  {
    "codigo":312825008,
    "descripcion":"OCLUSIÓN DE ARTERIA ILÍACA COMÚN"
  },
  {
    "codigo":247289009,
    "descripcion":"RESPUESTA A LA VOZ FAMILIAR"
  },
  {
    "codigo":704206001,
    "descripcion":"NEFROPATÍA CAUSADA POR AMINOGLUCÓSIDO"
  },
  {
    "codigo":835278006,
    "descripcion":"TEMBLOR DE LENGUA"
  },
  {
    "codigo":210851002,
    "descripcion":"LESIÓN TRAUMÁTICA NO EXPUESTA DE VENA DIGITAL"
  },
  {
    "codigo":1259427002,
    "descripcion":"NEUROBLASTOMA PRIMARIO DE TÓRAX"
  },
  {
    "codigo":472995002,
    "descripcion":"FASE PSICOSEXUAL FÁLICA"
  },
  {
    "codigo":309155007,
    "descripcion":"RESPIRACIÓN DE CHEYNE-STOKES"
  },
  {
    "codigo":702371008,
    "descripcion":"PACIENTE NO APTO PARA PROCEDIMIENTO DEBIDO A AFECCIÓN CLÍNICA"
  },
  {
    "codigo":276387009,
    "descripcion":"PRÓSTATA DURA"
  },
  {
    "codigo":307320005,
    "descripcion":"RUPTURA DE ARTERIA AXILAR"
  },
  {
    "codigo":209016005,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN MEDIOTARSIANA"
  },
  {
    "codigo":698701000,
    "descripcion":"TRASTORNO DE AJUSTE EN REMISIÓN"
  },
  {
    "codigo":10573002,
    "descripcion":"AMNIONITIS"
  },
  {
    "codigo":239949003,
    "descripcion":"POLIALGIA"
  },
  {
    "codigo":371021004,
    "descripcion":"RITIDOSIS FACIAL"
  },
  {
    "codigo":895309003,
    "descripcion":"FORMA DE BALA ANORMAL CONGÉNITA DE FALANGE DISTAL DE DEDO MEÑIQUE"
  },
  {
    "codigo":305485004,
    "descripcion":"BAJO ATENCIÓN DE GENETISTA"
  },
  {
    "codigo":403789008,
    "descripcion":"DISTROFIA UNGUEAL POR PÉNFIGO FAMILIAR BENIGNO"
  },
  {
    "codigo":238114000,
    "descripcion":"DEFICIENCIA DE ÁCIDOS GRASOS ESENCIALES"
  },
  {
    "codigo":205346006,
    "descripcion":"BRAQUIDACTILIA DE DEDOS DE LOS PIES"
  },
  {
    "codigo":762402007,
    "descripcion":"ANOMALÍA CONGÉNITA DE ZÓNULA"
  },
  {
    "codigo":1284855000,
    "descripcion":"DEFICIENCIA DE VÍA DE BIOSÍNTESIS DE SERINA, FORMA INFANTIL\/JUVENIL"
  },
  {
    "codigo":234444001,
    "descripcion":"VARIANTE DE DEFICIENCIA CONGÉNITA DEL FACTOR IX"
  },
  {
    "codigo":365516002,
    "descripcion":"HALLAZGO RELACIONADO CON LA LIMPIEZA DEL HOGAR"
  },
  {
    "codigo":267212003,
    "descripcion":"ANOMALÍA CONGÉNITA DEL ÚTERO EN EL EMBARAZO, EL NACIMIENTO Y EL PUERPERIO"
  },
  {
    "codigo":398284004,
    "descripcion":"PACIENTE EN HABITACIÓN"
  },
  {
    "codigo":265377002,
    "descripcion":"PARKINSONISMO SINTOMÁTICO"
  },
  {
    "codigo":298145003,
    "descripcion":"ARTICULACIÓN AUSENTE"
  },
  {
    "codigo":363681007,
    "descripcion":"EMBARAZO CON ABORTO COMO DESENLACE"
  },
  {
    "codigo":36001007,
    "descripcion":"INFECCIÓN POR CAPILLARIA HEPATICA"
  },
  {
    "codigo":722294004,
    "descripcion":"ENFERMEDAD DE CHARCOT-MARIE-TOOTH AUTOSÓMICA DOMINANTE TIPO E"
  },
  {
    "codigo":198006006,
    "descripcion":"PREPUCIO TIRANTE"
  },
  {
    "codigo":1344886008,
    "descripcion":"HABILIDADES DIGITALES INADECUADAS QUE AFECTAN LA EDUCACIÓN"
  },
  {
    "codigo":296310008,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE PSILOCIBINA"
  },
  {
    "codigo":720459002,
    "descripcion":"HIPERCORTISOLISMO DEBIDO A HIPERPLASIA SUPRARRENAL MACRONODULAR"
  },
  {
    "codigo":65099004,
    "descripcion":"ENDOMETRIOSIS DE VEJIGA URINARIA"
  },
  {
    "codigo":294475007,
    "descripcion":"ALERGIA A VANCOMICINA"
  },
  {
    "codigo":292640000,
    "descripcion":"EFECTO ADVERSO DE RESINA DE PODOFILINA"
  },
  {
    "codigo":32331008,
    "descripcion":"CUERPO EXTRAÑO EN EL PABELLÓN AURICULAR"
  },
  {
    "codigo":306151000119106,
    "descripcion":"GOTA TOFÁCEA CRÓNICA DE CODO CAUSADA POR FÁRMACO"
  },
  {
    "codigo":30496006,
    "descripcion":"MIOCARDIOPATÍA DILATADA DEBIDA A MIOCARDITIS VIRAL"
  },
  {
    "codigo":33921000119100,
    "descripcion":"MASA EN MÚSCULO DE EXTREMIDAD"
  },
  {
    "codigo":10628071000119107,
    "descripcion":"CARBUNCO DE PIE IZQUIERDO"
  },
  {
    "codigo":94197002,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE VASO SANGUÍNEO DE LA CADERA"
  },
  {
    "codigo":126965008,
    "descripcion":"NEOPLASIA DE LAS MENINGES"
  },
  {
    "codigo":125130002,
    "descripcion":"DENSIDAD RADIOLÓGICA ANORMAL, ÁREA AMPLIA"
  },
  {
    "codigo":288970004,
    "descripcion":"INCAPAZ DE ESCUPIR"
  },
  {
    "codigo":26826005,
    "descripcion":"APENDICITIS AMEBIANA"
  },
  {
    "codigo":92362009,
    "descripcion":"NEOPLASIA BENIGNA DE LA PIEL DEL ANTEBRAZO"
  },
  {
    "codigo":1237407002,
    "descripcion":"UTILIZA PRESERVATIVO FEMENINO COMO MÉTODO DE PROTECCIÓN EN LAS RELACIONES SEXUALES"
  },
  {
    "codigo":57759005,
    "descripcion":"LACERACIÓN PERINEAL DE PRIMER GRADO"
  },
  {
    "codigo":416372004,
    "descripcion":"INFECCIÓN CAUSADA POR NANOPHYETUS SALMINCOLA"
  },
  {
    "codigo":449140004,
    "descripcion":"ORIENTACIÓN DE VÁLVULA PULMONAR BICÚSPIDE DE DERECHA A IZQUIERDA"
  },
  {
    "codigo":16637211000119100,
    "descripcion":"TRASTORNO DE AMBOS NERVIOS ILIOINGUINALES"
  },
  {
    "codigo":23156007,
    "descripcion":"ENFERMEDAD DE LA ORINA EN JARABE DE ARCE LEVE"
  },
  {
    "codigo":283465000,
    "descripcion":"HERIDA POR ARMA BLANCA DE MUÑECA"
  },
  {
    "codigo":250697001,
    "descripcion":"APOLIPOPROTEÍNA E, FENOTIPO E2:4"
  },
  {
    "codigo":840521002,
    "descripcion":"EDEMA PULMONAR AGUDO CAUSADO POR PARTÍCULAS SÓLIDAS CALIENTES TRANSITORIAMENTE SUSPENDIDAS EN EL AIRE"
  },
  {
    "codigo":335131000119101,
    "descripcion":"QUERATITIS FILAMENTOSA DE OJO DERECHO"
  },
  {
    "codigo":689281000119108,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE ÁREA RETROMOLAR"
  },
  {
    "codigo":21321009,
    "descripcion":"GENITALES AMBIGUOS"
  },
  {
    "codigo":445470006,
    "descripcion":"ABSCESO DE PÁRPADO SUPERIOR"
  },
  {
    "codigo":248862007,
    "descripcion":"VULVA GRANDE"
  },
  {
    "codigo":52254009,
    "descripcion":"SÍNDROME NEFRÓTICO"
  },
  {
    "codigo":247027004,
    "descripcion":"DESPLAZAMIENTO DEL IRIS"
  },
  {
    "codigo":1197299006,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS METASTÁSICO DE GANGLIO LINFÁTICO DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":738547009,
    "descripcion":"METABOLIZADOR NORMAL DE LA FAMILIA 2 SUBFAMILIA C MIEMBRO 9 DEL CITOCROMO P450"
  },
  {
    "codigo":409032006,
    "descripcion":"LESIÓN PERIOPERATORIA CAUSADA POR LA POSICIÓN"
  },
  {
    "codigo":439965000,
    "descripcion":"REACCIÓN INFLAMATORIA DE OJO CAUSADA POR IMPLANTE DE LENTE INTRAOCULAR"
  },
  {
    "codigo":276125006,
    "descripcion":"SEPARADO DEL COHABITANTE"
  },
  {
    "codigo":11803931000119108,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA DISTAL DE DEDO DE LA MANO IZQUIERDA"
  },
  {
    "codigo":405362003,
    "descripcion":"PROBLEMA ENCONTRADO DURANTE LA ADMINISTRACIÓN DE ANESTÉSICO LOCAL"
  },
  {
    "codigo":12146004,
    "descripcion":"PULSO NORMAL"
  },
  {
    "codigo":403527005,
    "descripcion":"EXACERBACIÓN DE DERMATOSIS EN EL PERÍODO PREMENSTRUAL"
  },
  {
    "codigo":1255495005,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO DE DEDO MEDIO DE MANO"
  },
  {
    "codigo":237852000,
    "descripcion":"HIPOCALIEMIA CON EQUILIBRIO ACIDOBASE NORMAL"
  },
  {
    "codigo":74012004,
    "descripcion":"ANOMALÍA CONGÉNITA DE LA HIPÓFISIS"
  },
  {
    "codigo":15955381000119106,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE AMBOS TESTÍCULOS NO DESCENDIDOS"
  },
  {
    "codigo":203249000,
    "descripcion":"PERIOSTITIS DE ANTEBRAZO SIN OSTEOMIELITIS"
  },
  {
    "codigo":11832911000119101,
    "descripcion":"ESGUINCE DE LIGAMENTO DE ARTICULACIÓN DE DEDO GORDO DE PIE IZQUIERDO"
  },
  {
    "codigo":236017004,
    "descripcion":"FIBROSIS RETROPERITONEAL MALIGNA"
  },
  {
    "codigo":301553006,
    "descripcion":"NO SE LEVANTA DEL INODORO"
  },
  {
    "codigo":299718000,
    "descripcion":"HALLAZGO EN EL CEREBRO"
  },
  {
    "codigo":1348294000,
    "descripcion":"PARTO CON ANESTESIA GENERAL"
  },
  {
    "codigo":234182001,
    "descripcion":"EMBOLIA DE COMPONENTE PROTÉSICO DE VÁLVULA CARDÍACA"
  },
  {
    "codigo":70342003,
    "descripcion":"COLELITIASIS SIN OBSTRUCCIÓN"
  },
  {
    "codigo":365254003,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA DESPARRAMAR ALIMENTOS"
  },
  {
    "codigo":398022005,
    "descripcion":"PROLAPSO DE PARED VAGINAL"
  },
  {
    "codigo":4806007,
    "descripcion":"ESCOTOMA DE BJERRUM"
  },
  {
    "codigo":168646009,
    "descripcion":"RADIOGRAFÍA SIMPLE DE ESCAFOIDES ANORMAL"
  },
  {
    "codigo":723867002,
    "descripcion":"COARTACIÓN DE CAYADO AÓRTICO"
  },
  {
    "codigo":363419009,
    "descripcion":"NEOPLASIA MALIGNA DE CABEZA DE PÁNCREAS"
  },
  {
    "codigo":722032005,
    "descripcion":"SÍNDROME DE KARSCH NEUGEBAUER"
  },
  {
    "codigo":1344624006,
    "descripcion":"HERIDA ABIERTA DE FLANCO"
  },
  {
    "codigo":195909000,
    "descripcion":"NEUMONÍA POR NOCARDIAS"
  },
  {
    "codigo":359749002,
    "descripcion":"IMPÉTIGO CIRCINADO"
  },
  {
    "codigo":16010831000119108,
    "descripcion":"GANGRENA DE DEDO DE AMBOS PIES"
  },
  {
    "codigo":718362003,
    "descripcion":"TRASTORNO FUNCIONAL DEL MOVIMIENTO"
  },
  {
    "codigo":95770005,
    "descripcion":"INFLAMACIÓN ORBITARIA"
  },
  {
    "codigo":1144346006,
    "descripcion":"HIPOPLASIA CONGÉNITA DE UNIDAD UNGUEAL DE MEÑIQUE"
  },
  {
    "codigo":292378009,
    "descripcion":"REACCIÓN ADVERSA AL BENPERIDOL"
  },
  {
    "codigo":1074921000119104,
    "descripcion":"ARTRITIS DE PIE DERECHO"
  },
  {
    "codigo":28399005,
    "descripcion":"TUBERCULOSIS DEL BAZO"
  },
  {
    "codigo":126703006,
    "descripcion":"NEOPLASIA DE LA TRÁQUEA"
  },
  {
    "codigo":288708000,
    "descripcion":"INCAPAZ DE COMUNICARSE EN DIFERENTES OCASIONES"
  },
  {
    "codigo":124868006,
    "descripcion":"TRASTORNO DEL SITIO RECEPTOR"
  },
  {
    "codigo":712857000,
    "descripcion":"NEURALGIA SEGMENTARIA COMO EFECTO TARDÍO DE LESIÓN TRAUMÁTICA"
  },
  {
    "codigo":92100009,
    "descripcion":"NEOPLASIA BENIGNA DE TROMPA DE FALOPIO"
  },
  {
    "codigo":15738601000119107,
    "descripcion":"INFECCIÓN DE AMBOS OJOS"
  },
  {
    "codigo":1306504003,
    "descripcion":"CARCINOMA DUCTAL INFILTRANTE PRIMARIO DE CUADRANTE INFERIOR EXTERNO DE MAMA"
  },
  {
    "codigo":57497006,
    "descripcion":"ANOMALÍA CONGÉNITA DEL BAZO"
  },
  {
    "codigo":285038001,
    "descripcion":"DIFICULTAD PARA MANEJAR LA MEDICACIÓN"
  },
  {
    "codigo":55662002,
    "descripcion":"PROTEINURIA ENTEROGÉNICA"
  },
  {
    "codigo":250435001,
    "descripcion":"PRESENCIA DE CÉLULAS"
  },
  {
    "codigo":895205251000119104,
    "descripcion":"ANEURISMA ROTO DE ARCO AÓRTICO"
  },
  {
    "codigo":86595004,
    "descripcion":"HERNIA MESOCÓLICA CONGÉNITA"
  },
  {
    "codigo":53827007,
    "descripcion":"SIALORREA"
  },
  {
    "codigo":283203007,
    "descripcion":"ANZUELO EN LA PALMA DE LA MANO"
  },
  {
    "codigo":447043009,
    "descripcion":"CÁLCULO DE TERCIO INFERIOR DE URÉTER"
  },
  {
    "codigo":445208002,
    "descripcion":"HIPOPLASIA CONGÉNITA DE ARTERIA PULMONAR DERECHA"
  },
  {
    "codigo":84760002,
    "descripcion":"TRASTORNO ESQUIZOAFECTIVO, TIPO DEPRESIVO"
  },
  {
    "codigo":707352004,
    "descripcion":"GASTROENTERITIS INSTITUCIONAL"
  },
  {
    "codigo":281368005,
    "descripcion":"CUERPO EXTRAÑO INTRARTICULAR"
  },
  {
    "codigo":1231640005,
    "descripcion":"UVEÍTIS ANTERIOR AGUDA RECURRENTE"
  },
  {
    "codigo":248600004,
    "descripcion":"ESPUTO, CANTIDAD MODERADA"
  },
  {
    "codigo":15931421000119101,
    "descripcion":"RUPTURA DE QUISTE DE OVARIO DERECHO"
  },
  {
    "codigo":120861000119102,
    "descripcion":"INSUFICIENCIA CARDÍACA SISTÓLICA, ESTADIO C"
  },
  {
    "codigo":736450002,
    "descripcion":"RUPTURA TRAUMÁTICA PARCIAL DE UNIÓN URETEROPÉLVICA"
  },
  {
    "codigo":769218003,
    "descripcion":"EDEMA MACULAR DEL OJO IZQUIERDO DEBIDO A DIABETES MELLITUS"
  },
  {
    "codigo":210327001,
    "descripcion":"HERIDA ABIERTA DE TABIQUE NASAL"
  },
  {
    "codigo":79255005,
    "descripcion":"PRESENTACIÓN DE MENTÓN DE FETO"
  },
  {
    "codigo":77420001,
    "descripcion":"HABLA ESCANDIDA"
  },
  {
    "codigo":110188003,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DE MEJILLA"
  },
  {
    "codigo":700012005,
    "descripcion":"TRASTORNO DE MIEMBRO INFERIOR LIBRE"
  },
  {
    "codigo":208492006,
    "descripcion":"FRACTURA EXPUESTA DE FALANGE DISTAL DE DEDO DE LA MANO, MARTILLO"
  },
  {
    "codigo":42817000,
    "descripcion":"RESISTENCIA HORMONAL"
  },
  {
    "codigo":763713000,
    "descripcion":"LINFOCITOPENIA CD4 IDIOPÁTICA"
  },
  {
    "codigo":403265002,
    "descripcion":"OCRONOSIS CAUSADA POR HIDROQUINONA"
  },
  {
    "codigo":340151000119101,
    "descripcion":"QUERATOCONO INESTABLE DE OJO IZQUIERDO"
  },
  {
    "codigo":43821000087102,
    "descripcion":"HERIDA CORTANTE DE PIEL DE ANTEBRAZO IZQUIERDO"
  },
  {
    "codigo":75585005,
    "descripcion":"ENDOMETRITIS DE CADUCA"
  },
  {
    "codigo":1255233002,
    "descripcion":"FRACTURA EXPUESTA CONMINUTA DE HUESO METACARPIANO"
  },
  {
    "codigo":8214000,
    "descripcion":"TELANGIECTASIA MACULOSA ERUPTIVA PERSISTENTE"
  },
  {
    "codigo":1156929009,
    "descripcion":"INMUNIDAD CONTRA HAEMOPHILUS INFLUENZAE B DETERMINADA POR SEROLOGÍA"
  },
  {
    "codigo":1288001008,
    "descripcion":"REACCIÓN ADVERSA A INHIBIDOR DE LA RECAPTACIÓN DE NORADRENALINA"
  },
  {
    "codigo":237590003,
    "descripcion":"SECRECIÓN ANORMAL DE MOTILINA"
  },
  {
    "codigo":658061000005108,
    "descripcion":"PLACENTA UBICADA EN PARED POSTERIOR IZQUIERDA DE ÚTERO"
  },
  {
    "codigo":1220630007,
    "descripcion":"INTERRUPCIÓN INDUCIDA DEL EMBARAZO INCOMPLETA COMPLICADA POR EMBOLISMO"
  },
  {
    "codigo":399595000,
    "descripcion":"FIMBRIAS DE TROMPA DE FALOPIO IZQUIERDA, PERMEABLES"
  },
  {
    "codigo":235755005,
    "descripcion":"COLITIS NEUTROPÉNICA"
  },
  {
    "codigo":30001000175102,
    "descripcion":"ÚLCERA POR PRESIÓN EN DORSO DE PIE DERECHO, ESTADIO IV"
  },
  {
    "codigo":301291007,
    "descripcion":"ESPUTO ACUOSO"
  },
  {
    "codigo":299456000,
    "descripcion":"ARTICULACIÓN DE TOBILLO TIBIA AL TACTO"
  },
  {
    "codigo":202987008,
    "descripcion":"ABSCESO DE TENDÓN DE BRAZO"
  },
  {
    "codigo":364992003,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA UTILIZAR EL FLUJO DE AIRE PALATINO PARA HABLAR"
  },
  {
    "codigo":102848005,
    "descripcion":"CUERPOS GRASOS OVALADOS DE LA ORINA"
  },
  {
    "codigo":66410001,
    "descripcion":"FÍSTULA LABERÍNTICA DE SITIOS COMBINADOS"
  },
  {
    "codigo":874002,
    "descripcion":"DIURESIS TERAPÉUTICA"
  },
  {
    "codigo":230250003,
    "descripcion":"ATROFIA FASCIOESCAPULOHUMERAL MUSCULAR ESPINAL CON PÉRDIDA SENSORIAL"
  },
  {
    "codigo":295786001,
    "descripcion":"SOBREDOSIS DE ALCALOIDE DE LA VINCA"
  },
  {
    "codigo":721770002,
    "descripcion":"MENINGITIS CAUSADA POR CITOMEGALOVIRUS 5 HUMANO"
  },
  {
    "codigo":195647007,
    "descripcion":"INFECCIÓN RESPIRATORIA AGUDA"
  },
  {
    "codigo":95508001,
    "descripcion":"OBSTRUCCIÓN CONGÉNITA DE CONDUCTO LAGRIMAL"
  },
  {
    "codigo":161044002,
    "descripcion":"DISCAPACIDAD - MODERADA"
  },
  {
    "codigo":128276007,
    "descripcion":"CELULITIS DEL PIE"
  },
  {
    "codigo":880105001,
    "descripcion":"INGESTA INADECUADA DE RIBOFLAVINA"
  },
  {
    "codigo":1142249003,
    "descripcion":"HIPERTROFIA GENERALIZADA DE MÚSCULO ESQUELÉTICO"
  },
  {
    "codigo":191977008,
    "descripcion":"DISMENORREA PSICÓGENA"
  },
  {
    "codigo":59070002,
    "descripcion":"AFALANGIA PARCIAL DE LA EXTREMIDAD INFERIOR"
  },
  {
    "codigo":124606005,
    "descripcion":"DEFICIENCIA DE TREONINA ALDOLASA"
  },
  {
    "codigo":288446006,
    "descripcion":"DIFICULTAD PARA REALIZAR ACTIVIDADES DE ESCRITURA"
  },
  {
    "codigo":419518009,
    "descripcion":"HALLAZGO RELACIONADO CON EL TOBILLO O EL PIE"
  },
  {
    "codigo":286611003,
    "descripcion":"EXOSTOSIS DE FÉMUR"
  },
  {
    "codigo":253843003,
    "descripcion":"CLÍTORIS CON CAPUCHÓN"
  },
  {
    "codigo":44141000087101,
    "descripcion":"CORTE EN PIE IZQUIERDO"
  },
  {
    "codigo":417683006,
    "descripcion":"DREPANOCITOSIS-ENFERMEDAD DE LA HEMOGLOBINA C SIN CRISIS HEMOLÍTICA"
  },
  {
    "codigo":450451007,
    "descripcion":"SOBREPESO EN LA INFANCIA"
  },
  {
    "codigo":41581000087104,
    "descripcion":"HERIDA PUNZANTE DE OÍDO DERECHO"
  },
  {
    "codigo":188307009,
    "descripcion":"NEOPLASIA MALIGNA DE NERVIO CRANEAL"
  },
  {
    "codigo":39021000087106,
    "descripcion":"HERIDA ABIERTA DE EXTREMIDAD SUPERIOR IZQUIERDA"
  },
  {
    "codigo":46701000087107,
    "descripcion":"FRACTURA DE FALANGE DISTAL DE ANULAR DERECHO"
  },
  {
    "codigo":12247531000119106,
    "descripcion":"DOLOR EN AMBAS PIERNAS"
  },
  {
    "codigo":284776009,
    "descripcion":"REALIZA ACTIVIDAD DE CUIDADO PERSONAL"
  },
  {
    "codigo":446781004,
    "descripcion":"VALVA DE VÁLVULA TRICÚSPIDE FRÁGIL"
  },
  {
    "codigo":86333008,
    "descripcion":"FICOMICOSIS SUBCUTÁNEA POR BASIDIOBOLUS"
  },
  {
    "codigo":1231378001,
    "descripcion":"INFLAMACIÓN INTESTINAL CAUSADA POR ESCHERICHIA COLI"
  },
  {
    "codigo":1296914004,
    "descripcion":"DEFICIENCIA HEREDITARIA AUTOSÓMICA DOMINANTE DE VASOPRESINA"
  },
  {
    "codigo":707090004,
    "descripcion":"ESPONDILOARTROPATÍA DEBIDA A AMILOIDOSIS ASOCIADA A HEMODIÁLISIS"
  },
  {
    "codigo":1264146007,
    "descripcion":"DAÑO DE ÚTERO POSTERIOR A EMBARAZO MOLAR"
  },
  {
    "codigo":770791000,
    "descripcion":"VITREORRETINOPATÍA NEOVASCULAR INFLAMATORIA AUTOSÓMICA DOMINANTE"
  },
  {
    "codigo":443111006,
    "descripcion":"EDEMA DE PANTORRILLA"
  },
  {
    "codigo":836327008,
    "descripcion":"AGUDEZA VISUAL CON AGUJERO ESTENOPEICO DE OJO DERECHO 6\/9"
  },
  {
    "codigo":82663009,
    "descripcion":"OSTEOPATÍA ESTRIADA"
  },
  {
    "codigo":408508002,
    "descripcion":"NO HA PRESENTADO EFECTOS COLATERALES DE LA MEDICACIÓN"
  },
  {
    "codigo":277436002,
    "descripcion":"TELANGIECTASIA DE CUERDA VOCAL POSTERIOR A RADIOTERAPIA"
  },
  {
    "codigo":1293244004,
    "descripcion":"CONDROMA PERIOSTAL"
  },
  {
    "codigo":242833000,
    "descripcion":"SOBREDOSIS INTENCIONAL DE DIAZEPAM"
  },
  {
    "codigo":866511000000105,
    "descripcion":"PROTUBERANCIA CARPOMETACARPIANA"
  },
  {
    "codigo":373905003,
    "descripcion":"SÍNDROME DE JERVELL Y LANGE-NIELSEN"
  },
  {
    "codigo":13457005,
    "descripcion":"CUERPO EXTRAÑO EN EL ANO"
  },
  {
    "codigo":765286001,
    "descripcion":"ATRACCIÓN SEXUAL POR EL SEXO FEMENINO"
  },
  {
    "codigo":372070002,
    "descripcion":"TRASTORNO GANGRENOSO"
  },
  {
    "codigo":109926002,
    "descripcion":"NEOPLASIA BENIGNA DE LOS NERVIOS PERIFÉRICOS DEL CUELLO"
  },
  {
    "codigo":10638111000119103,
    "descripcion":"ÚLCERA CRÓNICA DE TOBILLO DERECHO"
  },
  {
    "codigo":403003001,
    "descripcion":"TIÑA DE CUERO CABELLUDO CAUSADA POR MICROSPORUM CANIS VARIANTE DISTORTUM"
  },
  {
    "codigo":304699004,
    "descripcion":"NO MUEVE LOS LABIOS"
  },
  {
    "codigo":697915006,
    "descripcion":"HIPERTENSIÓN PULMONAR DEBIDA A TRASTORNO DE HIPOVENTILACIÓN ALVEOLAR"
  },
  {
    "codigo":239163008,
    "descripcion":"ERITEMA EN HERIDA"
  },
  {
    "codigo":401168001,
    "descripcion":"AÚN SIN HABLAR"
  },
  {
    "codigo":9787009,
    "descripcion":"LUXACIÓN NO EXPUESTA LATERAL DE EXTREMO PROXIMAL DE TIBIA"
  },
  {
    "codigo":366565002,
    "descripcion":"RESPUESTA FLEXORA PLANTAR - HALLAZGO"
  },
  {
    "codigo":202725007,
    "descripcion":"SÍNDROME POSLAMINECTOMÍA LUMBAR"
  },
  {
    "codigo":301029007,
    "descripcion":"FALTA DE ARMONÍA CON LA PAREJA"
  },
  {
    "codigo":399333009,
    "descripcion":"NO SE PALAPA LATIDO APEXIANO"
  },
  {
    "codigo":364730002,
    "descripcion":"PROFUNDIDAD DE LA PUNTERA DEL CALZADO - HALLAZGO"
  },
  {
    "codigo":233658003,
    "descripcion":"PLACA PLEURAL"
  },
  {
    "codigo":102586005,
    "descripcion":"AUSENCIA DEL SEGUNDO RUIDO CARDÍACO, R>2<"
  },
  {
    "codigo":395663002,
    "descripcion":"INCAPAZ DE COMPRENDER EL CONCEPTO DE PELIGRO"
  },
  {
    "codigo":428431006,
    "descripcion":"HALLADO ATRAVESADO SOBRE EL ASIENTO DEL AUTOMÓVIL"
  },
  {
    "codigo":231823007,
    "descripcion":"MILIA DE PÁRPADO"
  },
  {
    "codigo":1149327007,
    "descripcion":"INTOXICACIÓN POR TOXINA BOTULÍNICA"
  },
  {
    "codigo":788879008,
    "descripcion":"CATATONÍA CAUSADA POR SUSTANCIA PSICOACTIVA"
  },
  {
    "codigo":295524003,
    "descripcion":"SOBREDOSIS DE ANESTÉSICO INHALATORIO"
  },
  {
    "codigo":262756006,
    "descripcion":"LESIÓN RETINIANA"
  },
  {
    "codigo":721508006,
    "descripcion":"SÍNDROME DEL CORDÓN CENTRAL DE MÉDULA ESPINAL AL NIVEL DEL TERCER SEGMENTO LUMBAR"
  },
  {
    "codigo":64313000,
    "descripcion":"ALTERACIÓN EN LOS PROCESOS FAMILIARES"
  },
  {
    "codigo":787044009,
    "descripcion":"ESTENOSIS BILATERAL DE ARTERIAS CARÓTIDAS"
  },
  {
    "codigo":33380008,
    "descripcion":"TRASTORNO BIPOLAR I MANÍACO GRAVE CON SÍNTOMAS PSICÓTICOS, INCONGRUENTE CON EL ESTADO DE ÁNIMO"
  },
  {
    "codigo":228153004,
    "descripcion":"DISCAPACIDAD PARA LA HIGIENE PERSONAL"
  },
  {
    "codigo":129849005,
    "descripcion":"CON MAYOR RIESGO DE VOLUMEN EXCESIVO DE LÍQUIDOS"
  },
  {
    "codigo":345171000119102,
    "descripcion":"PTOSIS MECÁNICA DE AMBOS PÁRPADOS SUPERIORES"
  },
  {
    "codigo":424761009,
    "descripcion":"ENCEFALOMIELITIS PARANEOPLÁSICA"
  },
  {
    "codigo":1082451000119102,
    "descripcion":"ENCEFALITIS CAUSADA POR ACTINOMYCES"
  },
  {
    "codigo":95246007,
    "descripcion":"CARIES POR DISFUNCIÓN SALIVAL SECUNDARIA A ENVEJECIMIENTO"
  },
  {
    "codigo":93411000,
    "descripcion":"ENGROSAMIENTO CONGÉNITO DE TIBIA"
  },
  {
    "codigo":224483009,
    "descripcion":"FAMILIARES INCAPACES DE CUIDAR AL PACIENTE"
  },
  {
    "codigo":58808003,
    "descripcion":"ACIDOSIS RESPIRATORIA COMPENSADA"
  },
  {
    "codigo":1172920006,
    "descripcion":"PROTEÍNA PLASMÁTICA POR ENCIMA DE RANGO DE REFERENCIA"
  },
  {
    "codigo":124344007,
    "descripcion":"DEFICIENCIA DE TIAMINA PIROFOSFOCINASA"
  },
  {
    "codigo":1269389000,
    "descripcion":"LESIÓN ANTERIOR DE MÉDULA ESPINAL DORSAL DEBIDA A SUBLUXACIÓN EXPUESTA DE ARTICULACIÓN DE COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":91576008,
    "descripcion":"HERPES SIMPLE CONGÉNITO"
  },
  {
    "codigo":445381000124106,
    "descripcion":"NUTRICIÓN ALTERADA DEBIDO A DESEQUILIBRIO DE NUTRIENTES"
  },
  {
    "codigo":188045003,
    "descripcion":"MELANOMA MALIGNO DE CUERO CABELLUDO"
  },
  {
    "codigo":253581002,
    "descripcion":"ESTENOSIS DE VÁLVULA TRONCAL"
  },
  {
    "codigo":430021000124103,
    "descripcion":"ESPECIE DE VIBRIO NO AISLADA"
  },
  {
    "codigo":2501000124104,
    "descripcion":"CANINO INFERIOR DERECHO PERMANENTE SUPERNUMERARIO"
  },
  {
    "codigo":284514000,
    "descripcion":"SE MUEVE CONTINUAMENTE EN EL ASIENTO"
  },
  {
    "codigo":249911000,
    "descripcion":"DIFICULTAD PARA GIRAR EL CUERPO"
  },
  {
    "codigo":448354009,
    "descripcion":"LINFOMA NO HODGKIN DE INTESTINO"
  },
  {
    "codigo":1003575006,
    "descripcion":"AGENESIA DE EPIDÍDIMO"
  },
  {
    "codigo":282679008,
    "descripcion":"ALCANZA"
  },
  {
    "codigo":15965421000119105,
    "descripcion":"VULVOVAGINITIS CAUSADA POR AMOEBA"
  },
  {
    "codigo":315447009,
    "descripcion":"NACIDO EN IRAQ"
  },
  {
    "codigo":248076007,
    "descripcion":"NO CONOCE EL PELIGRO DE LOS OBJETOS CALIENTES"
  },
  {
    "codigo":82401000,
    "descripcion":"CRISIS EPILÉPTICA DE INICIO MOTOR CON CONCIENCIA PRESERVADA DE INICIO FOCAL"
  },
  {
    "codigo":128391000119101,
    "descripcion":"RUPTURA FAMILIAR DEBIDA A SEPARACIÓN LEGAL"
  },
  {
    "codigo":16865007,
    "descripcion":"DERMATITIS VESICULAR ESPONGIÓTICA"
  },
  {
    "codigo":211638002,
    "descripcion":"CUERPO EXTRAÑO EN EL CIEGO"
  },
  {
    "codigo":703158007,
    "descripcion":"EMBOLIA DE ARTERIA AUDITIVA INTERNA"
  },
  {
    "codigo":111499002,
    "descripcion":"ENFERMEDAD DE DÉJÉRINE - SOTTAS"
  },
  {
    "codigo":373643003,
    "descripcion":"LABIO LEPORINO Y FISURA ALVEOLAR"
  },
  {
    "codigo":45963004,
    "descripcion":"DEFICIENCIA DE FACTOR XI, TIPO III"
  },
  {
    "codigo":292231000119104,
    "descripcion":"COMPRESIÓN DE NERVIO PLANTAR IZQUIERDO"
  },
  {
    "codigo":78731006,
    "descripcion":"INTOXICACIÓN CAUSADA POR VITAMINA K"
  },
  {
    "codigo":76896001,
    "descripcion":"SIDEROSIS SUBPIAL"
  },
  {
    "codigo":275339009,
    "descripcion":"FRACTURA SUBCAPITAL EXPUESTA DE FÉMUR"
  },
  {
    "codigo":109664003,
    "descripcion":"ARTRITIS DE ARTICULACIÓN TEMPOROMANDIBULAR CAUSADA POR PRÓTESIS ARTICULAR INTERNA"
  },
  {
    "codigo":240736005,
    "descripcion":"ULCERACIÓN INTESTINAL POR HISTOPLASMOSIS CLÁSICA"
  },
  {
    "codigo":347681000119100,
    "descripcion":"ABSCESO DE PÁRPADO INFERIOR IZQUIERDO"
  },
  {
    "codigo":371808007,
    "descripcion":"ESTADO DE ANGINA DE PECHO RECURRENTE, LUEGO DE ANGIOPLASTIA CORONARIA TRANSLUMINAL PERCUTÁNEA"
  },
  {
    "codigo":238901000,
    "descripcion":"LIPOATROFIA POR INSULINA"
  },
  {
    "codigo":271669001,
    "descripcion":"LENGUA SECA"
  },
  {
    "codigo":207968008,
    "descripcion":"FRACTURA EXPUESTA DE VÉRTEBRA LUMBAR, ESPONDILÓLISIS"
  },
  {
    "codigo":1287477004,
    "descripcion":"NEVO MELANOCÍTICO DE REGIÓN DE CARA"
  },
  {
    "codigo":42293008,
    "descripcion":"VÍCTIMA DE ACCIONES BÉLICAS INTERNACIONALES"
  },
  {
    "codigo":7690000,
    "descripcion":"SÍNDROME GRIS POR ADMINISTRACIÓN DE CLORANFENICOL EN EL RECIÉN NACIDO"
  },
  {
    "codigo":269834002,
    "descripcion":"MONONUCLEOSIS INFECCIOSA NO DETECTADA"
  },
  {
    "codigo":675361000119103,
    "descripcion":"IRIDOCICLITIS SUBAGUDA DE AMBOS OJOS"
  },
  {
    "codigo":40458008,
    "descripcion":"ABSCESO DE LA PARED TORÁCICA"
  },
  {
    "codigo":237066009,
    "descripcion":"FIBROSIS PARAMETRIAL"
  },
  {
    "codigo":202463000,
    "descripcion":"REUMATISMO PALINDRÓMICO DE TOBILLO Y\/O PIE"
  },
  {
    "codigo":169695002,
    "descripcion":"CRIBADO PARA RUBÉOLA - SANGRE ENVIADA"
  },
  {
    "codigo":5855005,
    "descripcion":"TRASTORNO MOTOR DEL NERVIO TRIGÉMINO"
  },
  {
    "codigo":366303008,
    "descripcion":"HALLAZGO RELACIONADO CON LA VERSIÓN DEL ÚTERO"
  },
  {
    "codigo":298932001,
    "descripcion":"CREPITACIÓN AUDIBLE DE ARTICULACIÓN DE CODO"
  },
  {
    "codigo":724916006,
    "descripcion":"DISTENSIÓN DE CABEZA LARGA DE MÚSCULO BÍCEPS BRAQUIAL"
  },
  {
    "codigo":200628009,
    "descripcion":"CELULITIS Y ABSCESO DE DEDO DE LA MANO Y DEL PIE"
  },
  {
    "codigo":460937001,
    "descripcion":"ORIGEN ANÓMALO DE ARTERIA CORONARIA ÚNICA EN SENO AÓRTICO DE ARTERIA CORONARIA DERECHA"
  },
  {
    "codigo":297097005,
    "descripcion":"SOBREDOSIS INTENCIONAL DE ESTREPTOQUINASA"
  },
  {
    "codigo":15666721000119108,
    "descripcion":"HUESO ACCESORIO DEL CARPO DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":721246000,
    "descripcion":"MIELITIS CAUSADA POR HONGO"
  },
  {
    "codigo":428169009,
    "descripcion":"ARTROPATÍA EN SÍNDROME DE BEHCET DE TOBILLO"
  },
  {
    "codigo":229726002,
    "descripcion":"CIERRE INCOMPLETO DE APARATO VELOFARÍNGEO DEBIDO A ANOMALÍA ANATÓMICA"
  },
  {
    "codigo":33118001,
    "descripcion":"FRACTURA NO EXPUESTA DE ACETÁBULO"
  },
  {
    "codigo":295262004,
    "descripcion":"SOBREDOSIS DE KETOROLACO"
  },
  {
    "codigo":31283000,
    "descripcion":"DISFONÍA ESPÁSTICA DE TIPO ABDUCTOR"
  },
  {
    "codigo":292871000119100,
    "descripcion":"PSEUDOPORENCEFALIA ADQUIRIDA"
  },
  {
    "codigo":10637831000119101,
    "descripcion":"ÚLCERA CRÓNICA NO CAUSADA POR PRESIÓN DE TOBILLO QUE SE EXTIENDE HASTA EL TEJIDO ADIPOSO"
  },
  {
    "codigo":321031000119101,
    "descripcion":"TRASTORNO DE ENTESIS DE REGIONES ATLANTOAXIAL Y ATLANTOOCCIPITAL"
  },
  {
    "codigo":10942471000119103,
    "descripcion":"PERFORACIÓN TRAUMÁTICA DE MEMBRANA TIMPÁNICA IZQUIERDA"
  },
  {
    "codigo":129587006,
    "descripcion":"SÍNDROME DEL MUÑÓN DE CONDUCTO CÍSTICO"
  },
  {
    "codigo":293427005,
    "descripcion":"REACCIÓN ADVERSA AL CLOFIBRATO"
  },
  {
    "codigo":1081351000119104,
    "descripcion":"OSTEOSARCOMA PRIMARIO DE HUESO DE EXTREMIDAD INFERIOR DERECHA"
  },
  {
    "codigo":10630151000119100,
    "descripcion":"LINFANGITIS AGUDA DE REGIÓN DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":308231000119106,
    "descripcion":"DEFORMIDAD EN FLEXIÓN DE ARTICULACIÓN DE CODO DERECHO"
  },
  {
    "codigo":290311000119102,
    "descripcion":"MONOPLEJÍA DE MIEMBRO INFERIOR IZQUIERDO DOMINANTE"
  },
  {
    "codigo":331271000119106,
    "descripcion":"CUERPO EXTRAÑO RETENIDO EN PÁRPADO IZQUIERDO"
  },
  {
    "codigo":313351000119102,
    "descripcion":"ARTROFITO EN ARTICULACIÓN DE DEDO DE LA MANO IZQUIERDA"
  },
  {
    "codigo":231431000119104,
    "descripcion":"VÍCTIMA ADULTA DE NEGLIGENCIA NUTRICIONAL"
  },
  {
    "codigo":1073671000119106,
    "descripcion":"NÓDULO REUMATOIDEO DE TEJIDO CELULAR SUBCUTÁNEO DE PIE IZQUIERDO"
  },
  {
    "codigo":98311000119105,
    "descripcion":"PORTADOR DE ENFERMEDAD DE CANAVAN"
  },
  {
    "codigo":62216007,
    "descripcion":"ARTROGRIFOSIS FAMILIAR - SÍNDROME HEPATORRENAL COLESTÁTICO"
  },
  {
    "codigo":1031000119109,
    "descripcion":"ATENCIÓN PRENATAL INSUFICIENTE"
  },
  {
    "codigo":12237831000119108,
    "descripcion":"TROMBOSIS AGUDA DE VENA SUPERFICIAL DE MIEMBRO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":354311000119109,
    "descripcion":"CARCINOMA IN SITU DE OJO DERECHO"
  },
  {
    "codigo":1010653007,
    "descripcion":"NEUROFIBROMATOSIS SEGMENTARIA TIPO 1"
  },
  {
    "codigo":29448009,
    "descripcion":"AUSENCIA DE LA SENSACIÓN POSTURAL"
  },
  {
    "codigo":420829009,
    "descripcion":"EDEMA CON FÓVEA 1+"
  },
  {
    "codigo":224221006,
    "descripcion":"VIVE EN ALOJAMIENTO CUSTODIADO POR VIGILANCIA"
  },
  {
    "codigo":124082005,
    "descripcion":"NIVEL DE UROBILINÓGENO POR DEBAJO DE RANGO DE REFERENCIA"
  },
  {
    "codigo":25778006,
    "descripcion":"CONSISTENCIA DE LA COLONIA BACTERIANA, MANTECOSA"
  },
  {
    "codigo":1303730008,
    "descripcion":"CICATRIZ DE OJO IZQUIERDO DEBIDA A CIRUGÍA FILTRANTE DE GLAUCOMA Y POSTERIOR A ELLA"
  },
  {
    "codigo":255154009,
    "descripcion":"NEOPLASIA BENIGNA DE GLÁNDULA SALIVAL"
  },
  {
    "codigo":1172658008,
    "descripcion":"RELACIÓN COLESTEROL\/LIPOPROTEÍNA DE ALTA DENSIDAD POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":286087006,
    "descripcion":"INCAPAZ DE LAVAR LA VAJILLA"
  },
  {
    "codigo":284252000,
    "descripcion":"INCAPAZ DE DOBLAR LA MANO EN PUÑO"
  },
  {
    "codigo":448092000,
    "descripcion":"ANILLO VASCULAR DEBIDO A ARTERIA SUBCLAVIA ABERRANTE Y CONDUCTOS ARTERIALES BILATERALES"
  },
  {
    "codigo":253319008,
    "descripcion":"VENA CAVA INFERIOR A LA IZQUIERDA DE LA COLUMNA VERTEBRAL"
  },
  {
    "codigo":710236006,
    "descripcion":"NO REALIZA ACTIVIDADES DE ACICALAMIENTO PERSONAL"
  },
  {
    "codigo":184113000,
    "descripcion":"TÍTULO DEL PACIENTE - DESCONOCIDO"
  },
  {
    "codigo":249649004,
    "descripcion":"DILATACIÓN REFLEJA DEL ANO"
  },
  {
    "codigo":313350005,
    "descripcion":"VÁRICES DE LAS PIERNAS DISTRIBUIDAS EN EL TERRITORIO DE LA VENA SAFENA EXTERNA, CON ÚLCERA"
  },
  {
    "codigo":16603000,
    "descripcion":"TALIPÓMANO"
  },
  {
    "codigo":10754031000119105,
    "descripcion":"GONORREA EN LA MADRE QUE COMPLICA EL NACIMIENTO"
  },
  {
    "codigo":1163483009,
    "descripcion":"INFECCIÓN PALPEBRAL POR HERPES ZÓSTER"
  },
  {
    "codigo":677871000119105,
    "descripcion":"AGUJERO MACULAR DE ESPESOR PARCIAL DE AMBOS OJOS"
  },
  {
    "codigo":735664003,
    "descripcion":"LESIÓN TRAUMÁTICA DE BOLSA SEROSA DE HOMBRO"
  },
  {
    "codigo":80304004,
    "descripcion":"SÍNDROME DE BOCIO Y CALCIFICACIONES INTRATIROIDEAS"
  },
  {
    "codigo":309680006,
    "descripcion":"TIENE PADRE ANCIANO"
  },
  {
    "codigo":78469002,
    "descripcion":"RESPUESTA TERAPÉUTICA, BUENA"
  },
  {
    "codigo":307845002,
    "descripcion":"ESTADO DE LA SUPERVISIÓN INFANTIL"
  },
  {
    "codigo":111237004,
    "descripcion":"SÍNDROME DE PUTTI"
  },
  {
    "codigo":1290885002,
    "descripcion":"LUXACIÓN DE HUESO SEMILUNAR"
  },
  {
    "codigo":104431000119107,
    "descripcion":"LIPOMIELOMENINGOCELE"
  },
  {
    "codigo":45701006,
    "descripcion":"QUERATOCONJUNTIVITIS INDUCIDA POR DROGAS"
  },
  {
    "codigo":386085001000119102,
    "descripcion":"TUMOR NEUROENDOCRINO BIEN DIFERENCIADO CON METÁSTASIS A PULMÓN IZQUIERDO"
  },
  {
    "codigo":240474001,
    "descripcion":"INFECCIÓN MULTIDERMATÓMICA POR HERPES ZÓSTER"
  },
  {
    "codigo":109402007,
    "descripcion":"FACIOSINOSTOSIS PERIMAXILAR ANTERIOR"
  },
  {
    "codigo":42031001,
    "descripcion":"RETINOCOROIDITIS Y RETINITIS FOCAL PARAMACULAR"
  },
  {
    "codigo":402479002,
    "descripcion":"PORFIRIA CUTÁNEA TARDÍA ESPORÁDICA"
  },
  {
    "codigo":369711004,
    "descripcion":"INVASIÓN TUMORAL DE LOS MÁRGENES CERVICALES, NO DETERMINADA"
  },
  {
    "codigo":238639005,
    "descripcion":"PITIRIASIS ROTUNDA"
  },
  {
    "codigo":40196000,
    "descripcion":"DOLOR LEVE"
  },
  {
    "codigo":171268003,
    "descripcion":"SIN CONSENTIMIENTO PARA INMUNIZACIÓN ANTIPOLIOMIELÍTICA"
  },
  {
    "codigo":204036008,
    "descripcion":"LISENCEFALIA"
  },
  {
    "codigo":72964008,
    "descripcion":"SORDERA TRAUMÁTICA, NO OCUPACIONAL"
  },
  {
    "codigo":300505001,
    "descripcion":"CONDUCTO DEFERENTE PRESENTE"
  },
  {
    "codigo":234969005,
    "descripcion":"DENTINOGÉNESIS IMPERFECTA - TIPO II DE SHIELD"
  },
  {
    "codigo":366041007,
    "descripcion":"MORFOLOGÍA DEL HUMOR VÍTREO - HALLAZGO"
  },
  {
    "codigo":396974000,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA DE NERVIO ÓPTICO CON COMPROMISO TUMORAL"
  },
  {
    "codigo":298670004,
    "descripcion":"MOVIMIENTO PARADÓJICO DE LA COLUMNA LUMBAR"
  },
  {
    "codigo":429742007,
    "descripcion":"APARICIÓN DEL DOLOR DURANTE EL EJERCICIO MODERADO"
  },
  {
    "codigo":1279875000,
    "descripcion":"SÍNDROME DE CORDÓN CENTRAL DE MÉDULA LUMBAR DEBIDO A SUBLUXACIÓN VERTEBRAL EXPUESTA"
  },
  {
    "codigo":724654009,
    "descripcion":"TRASTORNO DE ANSIEDAD CAUSADO POR OPIOIDE"
  },
  {
    "codigo":722819004,
    "descripcion":"HALLAZGO RELACIONADO CON LA ESCALA DE PREPARACIÓN INTESTINAL DE BOSTON"
  },
  {
    "codigo":427907007,
    "descripcion":"ATROFIA DE CUERDA VOCAL"
  },
  {
    "codigo":295000003,
    "descripcion":"ALERGIA A FUROSEMIDA"
  },
  {
    "codigo":131160005,
    "descripcion":"GRUPO SANGUÍNEO B>M<"
  },
  {
    "codigo":32856008,
    "descripcion":"ESCALA DEL COMA DE GLASGOW, 8"
  },
  {
    "codigo":720984008,
    "descripcion":"DISPLASIA FALANGOEPIFISARIA CON FORMA DE ÁNGEL"
  },
  {
    "codigo":31021007,
    "descripcion":"QUISTE ORBITARIO"
  },
  {
    "codigo":293165007,
    "descripcion":"REACCIÓN ADVERSA A LA MOMETASONA"
  },
  {
    "codigo":352701000119102,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE CUELLO DE PÁNCREAS"
  },
  {
    "codigo":10946851000119109,
    "descripcion":"AVULSIÓN DE UNIDAD UNGUEAL DE DEDO ANULAR DERECHO"
  },
  {
    "codigo":1208834007,
    "descripcion":"ALOPECIA AREATA DE PESTAÑA"
  },
  {
    "codigo":60119000,
    "descripcion":"AGOTAMIENTO"
  },
  {
    "codigo":289495001,
    "descripcion":"ENTUMECIMIENTO VULVAR"
  },
  {
    "codigo":94722009,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL NERVIO ABDUCTOR"
  },
  {
    "codigo":125655007,
    "descripcion":"HERIDA ABIERTA DE LA UÑA DE DEDO DE LA MANO"
  },
  {
    "codigo":254892000,
    "descripcion":"FIBROMA POLIPOIDE DE CUELLO UTERINO"
  },
  {
    "codigo":92887007,
    "descripcion":"FORMA ANORMAL CONGÉNITA DE HUESO ALIESFENOIDAL"
  },
  {
    "codigo":27351007,
    "descripcion":"ÁNTRAX DE PENE"
  },
  {
    "codigo":1336236005,
    "descripcion":"TRASTORNO POR USO DE NICOTINA"
  },
  {
    "codigo":1303468006,
    "descripcion":"ATROFIA PAPILAR CENTRAL DE LENGUA"
  },
  {
    "codigo":285825005,
    "descripcion":"CAPAZ DE CERRAR LAS CANILLAS DE AGUA"
  },
  {
    "codigo":89217008,
    "descripcion":"HOMOSEXUALIDAD FEMENINA"
  },
  {
    "codigo":21846001,
    "descripcion":"ACTINOMICOSIS PULMONAR"
  },
  {
    "codigo":251222001,
    "descripcion":"ONDA P APLANADA"
  },
  {
    "codigo":54614003,
    "descripcion":"AMPOLLA DE DEDO DE PIE, SIN INFECCIÓN"
  },
  {
    "codigo":283990005,
    "descripcion":"RECUERDOS AGRADABLES"
  },
  {
    "codigo":447830005,
    "descripcion":"ANOMALÍA CONGÉNITA DE VALVA DE VÁLVULA TRICÚSPIDE"
  },
  {
    "codigo":249387000,
    "descripcion":"HALLAZGO RELACIONADO CON EL FRENILLO DE LA LENGUA"
  },
  {
    "codigo":413227000,
    "descripcion":"ESOFAGITIS GRADO III"
  },
  {
    "codigo":282155007,
    "descripcion":"CAPAZ DE CAMINAR PENDIENTE ARRIBA"
  },
  {
    "codigo":11850481000119100,
    "descripcion":"CONTUSIÓN DE MAMA DERECHA"
  },
  {
    "codigo":247552007,
    "descripcion":"PELOS CIRCULARES"
  },
  {
    "codigo":739072007,
    "descripcion":"ANTÍGENO LEUCOCÍTICO HUMANO B*58:01 DETECTADO"
  },
  {
    "codigo":16341002,
    "descripcion":"PARAPSORIASIS LIQUENOIDE"
  },
  {
    "codigo":12204631000119107,
    "descripcion":"DISLOCACIÓN DE ARTICULACIÓN PROTÉSICA DE CODO DERECHO"
  },
  {
    "codigo":16054871000119107,
    "descripcion":"ASTIGMATISMO IRREGULAR DE OJO IZQUIERDO POSTQUIRÚRGICO"
  },
  {
    "codigo":409557008,
    "descripcion":"OSTEOMIELITIS POR FIEBRE Q"
  },
  {
    "codigo":737237009,
    "descripcion":"EDEMA TRAUMÁTICO DE MÉDULA ESPINAL DORSAL"
  },
  {
    "codigo":473258002,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO DE MÚLTIPLES SITIOS DE LA CABEZA SIN COMPROMISO DEL OJO PROPIAMENTE DICHO"
  },
  {
    "codigo":1259690002,
    "descripcion":"CARCINOMA ADENOIDE QUÍSTICO PRIMARIO DE GLÁNDULA LAGRIMAL IZQUIERDA"
  },
  {
    "codigo":702634004,
    "descripcion":"DIÁLISIS PERITONEAL INADECUADA"
  },
  {
    "codigo":276650005,
    "descripcion":"HEMORRAGIA SUBEPENDIMARIA PERINATAL"
  },
  {
    "codigo":243882008,
    "descripcion":"SITUACIÓN DE CRIBADO DE UN PACIENTE NUEVO"
  },
  {
    "codigo":274815001,
    "descripcion":"SENSACIÓN DE LA POSICIÓN ARTICULAR, AUSENTE"
  },
  {
    "codigo":373119002,
    "descripcion":"MICROCALCIFICACIONES AUSENTES EN EL ESPÉCIMEN MAMARIO"
  },
  {
    "codigo":209279001,
    "descripcion":"FRACTURA-LUXACIÓN EXPUESTA DE HUESO SEMILUNAR (PALMAR)"
  },
  {
    "codigo":405887000,
    "descripcion":"FENOTIPO S+"
  },
  {
    "codigo":698964001,
    "descripcion":"MÚLTIPLES HERIDAS ABIERTAS DE HOMBRO"
  },
  {
    "codigo":764500002,
    "descripcion":"SÍNDROME DE TRISOMÍA 20Q DISTAL"
  },
  {
    "codigo":830036006,
    "descripcion":"QUISTE DERMOIDE DE GLOBO OCULAR"
  },
  {
    "codigo":240212007,
    "descripcion":"DESGARRO DEL ANILLO FIBROSO DE DISCO INTERVERTEBRAL"
  },
  {
    "codigo":305748008,
    "descripcion":"ATENDIDO POR ENFERMERA ONCOLÓGICA"
  },
  {
    "codigo":404052009,
    "descripcion":"RABDOMIOSARCOMA BOTRIOIDE"
  },
  {
    "codigo":15864561000119107,
    "descripcion":"DEFORMIDAD CONGÉNITA DE DEDO DEL PIE DERECHO"
  },
  {
    "codigo":762665002,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA NEUROENDOCRINA DE CONDUCTO BILIAR PERIHILIAR"
  },
  {
    "codigo":860969004,
    "descripcion":"SISTEMA VENOSO NORMAL"
  },
  {
    "codigo":271145004,
    "descripcion":"AMPOLLA TRAUMÁTICA DE LA VAGINA, INFECTADA"
  },
  {
    "codigo":369449004,
    "descripcion":"TUMOR MALIGNO QUE COMPROMETE EL RECTO POR PROPAGACIÓN DIRECTA DESDE TROMPA DE FALOPIO"
  },
  {
    "codigo":302078000,
    "descripcion":"VELLOSIDADES CORIÓNICAS INMADURAS"
  },
  {
    "codigo":236542001,
    "descripcion":"TRASTORNO PROLONGADO DE LA DIÁLISIS"
  },
  {
    "codigo":238377008,
    "descripcion":"IMPETIGINIZACIÓN SECUNDARIA"
  },
  {
    "codigo":1186814000,
    "descripcion":"NEOPLASIA NEUROENDOCRINA DUODENAL"
  },
  {
    "codigo":365779001,
    "descripcion":"HALLAZGO RELACIONADO CON EL NIVEL DE GONADOTROFINA"
  },
  {
    "codigo":300243002,
    "descripcion":"HALLAZGO RELACIONADO CON LA APARIENCIA DE LA LENGUA"
  },
  {
    "codigo":726227002,
    "descripcion":"LESIÓN TRAUMÁTICA DE TENDÓN DE MÚSCULO ADUCTOR DE MUSLO"
  },
  {
    "codigo":38099005,
    "descripcion":"INTENTO FALLIDO DE ABORTO CON ENDOMETRITIS"
  },
  {
    "codigo":1119443007,
    "descripcion":"ATROFIA DE MÚSCULO DE BRAZO Y CADERA Y\/O MUSLO"
  },
  {
    "codigo":298408002,
    "descripcion":"AMPLITUD DE FLEXIÓN ACTIVA DE LA COLUMNA CERVICAL DISMINUIDA"
  },
  {
    "codigo":167336003,
    "descripcion":"MICROSCOPIA URINARIA: AUSENCIA DE CILINDROS"
  },
  {
    "codigo":67197000,
    "descripcion":"ALTERACIÓN EN EL ESTILO DE VIDA, ASOCIADA CON EL TRABAJO"
  },
  {
    "codigo":296573004,
    "descripcion":"SOBREDOSIS DE PROGUANIL"
  },
  {
    "codigo":427645006,
    "descripcion":"ORIENTADO EN ASPECTOS PERSONALES"
  },
  {
    "codigo":722557007,
    "descripcion":"PARKINSONISMO DEBIDO A INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":425810000,
    "descripcion":"MASA DE PÁNCREAS"
  },
  {
    "codigo":294738001,
    "descripcion":"ALERGIA A TOLBUTAMIDA"
  },
  {
    "codigo":11797541000119102,
    "descripcion":"AMPOLLA TRAUMÁTICA DE REGIÓN LUMBAR"
  },
  {
    "codigo":1148541006,
    "descripcion":"PALADAR HENDIDO INCOMPLETO BILATERAL Y LABIO LEPORINO INCOMPLETO BILATERAL"
  },
  {
    "codigo":65362007,
    "descripcion":"PIE CAVO VARO ADQUIRIDO"
  },
  {
    "codigo":1144871000,
    "descripcion":"APLASIA DE VAGINA"
  },
  {
    "codigo":129063003,
    "descripcion":"ACTIVIDAD DIARIA INSTRUMENTAL"
  },
  {
    "codigo":292903005,
    "descripcion":"REACCIÓN ADVERSA AL DECUALINIO"
  },
  {
    "codigo":94460001,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE CONDUCTO PANCREÁTICO"
  },
  {
    "codigo":717052002,
    "descripcion":"SÍNDROME DE LEIGH HEREDADO DE LA MADRE"
  },
  {
    "codigo":782588002,
    "descripcion":"ALERGIA A PARAFINA BLANCA"
  },
  {
    "codigo":225532004,
    "descripcion":"CONDUCTA SEXUAL INHIBIDA"
  },
  {
    "codigo":192764007,
    "descripcion":"FLEBITIS DE SENO CAVERNOSO"
  },
  {
    "codigo":127228008,
    "descripcion":"NEOPLASIA DE ADENOIDES"
  },
  {
    "codigo":1306876007,
    "descripcion":"GLAUCOMA DE ÁNGULO ABIERTO DE AMBOS OJOS"
  },
  {
    "codigo":715217004,
    "descripcion":"ARTROGRIPOSIS DISTAL TIPO 5"
  },
  {
    "codigo":92625004,
    "descripcion":"CARCINOMA IN SITU DE LABIOS MAYORES VULVARES"
  },
  {
    "codigo":59857007,
    "descripcion":"QUISTE DE LA HENDIDURA BRANQUIAL"
  },
  {
    "codigo":289233009,
    "descripcion":"DURACIÓN NORMAL DE LA TERCERA ETAPA DEL TRABAJO DE PARTO"
  },
  {
    "codigo":123558002,
    "descripcion":"ANOMALÍA CONGÉNITA DE HÚMERO"
  },
  {
    "codigo":90790003,
    "descripcion":"TRASTORNO DE EVITACIÓN EN LA ADOLESCENCIA"
  },
  {
    "codigo":418470004,
    "descripcion":"PORFIRIA"
  },
  {
    "codigo":1303206005,
    "descripcion":"LESIÓN POR CONGELAMIENTO DE PIERNA"
  },
  {
    "codigo":16030911000119103,
    "descripcion":"OSTEOMIELITIS SUBAGUDA DE AMBAS MANOS"
  },
  {
    "codigo":1335974003,
    "descripcion":"GLAUCOMA DEBIDO A QUISTE DE IRIS"
  },
  {
    "codigo":187259004,
    "descripcion":"SECUELAS DE LEPRA"
  },
  {
    "codigo":285563007,
    "descripcion":"NO DESCIENDE EL PALADAR BLANDO"
  },
  {
    "codigo":1137531008,
    "descripcion":"CALCIFICACIÓN PUNTEADA DE EPÍFISIS DE FALANGE MEDIA DE QUINTO DEDO DE PIE"
  },
  {
    "codigo":21584002,
    "descripcion":"SÍNDROME DEL INFANTE DE MADRE DIABÉTICA"
  },
  {
    "codigo":283728003,
    "descripcion":"MORDEDURA HUMANA EN EL PIE"
  },
  {
    "codigo":250960008,
    "descripcion":"MASA VENTRICULAR DERECHA"
  },
  {
    "codigo":314661000,
    "descripcion":"LESIÓN TRAUMÁTICA CRANEOENCEFÁLICA MODERADA"
  },
  {
    "codigo":1363237002,
    "descripcion":"QUISTE ENCEFÁLICO CONGÉNITO"
  },
  {
    "codigo":30041000119101,
    "descripcion":"SÍNTOMAS DEL TRACTO URINARIO INFERIOR DEBIDOS A HIPERTROFIA PROSTÁTICA BENIGNA"
  },
  {
    "codigo":249125003,
    "descripcion":"MEMBRANAS INTACTAS"
  },
  {
    "codigo":609573005,
    "descripcion":"DIABETES DEL ADULTO DE INICIO JUVENIL, TIPO 6"
  },
  {
    "codigo":445733003,
    "descripcion":"FRACTURA EXPUESTA CONMINUTA SUPRACONDÍLEA DE FÉMUR"
  },
  {
    "codigo":247290000,
    "descripcion":"TRANQUILO CON VOZ FAMILIAR"
  },
  {
    "codigo":83450003,
    "descripcion":"MANO DE SIMIO ADQUIRIDA"
  },
  {
    "codigo":443898004,
    "descripcion":"VIRILIZACIÓN DE MUJER POR DUPLICACIÓN DEL GEN SOX9"
  },
  {
    "codigo":12236121000119103,
    "descripcion":"CONJUNTIVITIS BILATERAL"
  },
  {
    "codigo":312826009,
    "descripcion":"OCLUSIÓN DE ARTERIA ILÍACA EXTERNA"
  },
  {
    "codigo":835279003,
    "descripcion":"REFLEJO DISMINUIDO"
  },
  {
    "codigo":440228000,
    "descripcion":"FILTRACIÓN DE LÍQUIDO PARA DIÁLISIS PERITONEAL EN EL TEJIDO SUBCUTÁNEO DE LA PARED ABDOMINAL"
  },
  {
    "codigo":472996001,
    "descripcion":"FASE PSICOSEXUAL: LATENCIA"
  },
  {
    "codigo":276388004,
    "descripcion":"PRÓSTATA DURO-PÉTREA"
  },
  {
    "codigo":1259428007,
    "descripcion":"NEUROBLASTOMA PÉLVICO PRIMARIO"
  },
  {
    "codigo":210852009,
    "descripcion":"LESIÓN EXPUESTA, VENA DIGITAL"
  },
  {
    "codigo":45177002,
    "descripcion":"TUMEFACCIÓN DE ESTRUCTURA DEL OJO"
  },
  {
    "codigo":209017001,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN TARSOMETATARSIANA"
  },
  {
    "codigo":405625008,
    "descripcion":"QUIRÓFANO NO DISPONIBLE"
  },
  {
    "codigo":307321009,
    "descripcion":"RUPTURA DE ARTERIA HUMERAL"
  },
  {
    "codigo":331251000119102,
    "descripcion":"CUERPO EXTRAÑO RETENIDO EN PÁRPADO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":239950003,
    "descripcion":"CALCIFICACIÓN DE LIGAMENTO"
  },
  {
    "codigo":403790004,
    "descripcion":"SÍNDROME DE HIPERQUERATOSIS-HIPERPIGMENTACIÓN PALMOPLANTAR DE CANTU"
  },
  {
    "codigo":77945009,
    "descripcion":"QUISTE RENAL SIMPLE"
  },
  {
    "codigo":371022006,
    "descripcion":"CONVULSIONES POR TRASTORNO METABÓLICO"
  },
  {
    "codigo":698702007,
    "descripcion":"DETENCIÓN TRANSVERSAL PROFUNDA CON POSICIÓN OCCIPITOPOSTERIOR PERSISTENTE"
  },
  {
    "codigo":305486003,
    "descripcion":"BAJO ATENCIÓN DE GENETISTA CLÍNICO"
  },
  {
    "codigo":205347002,
    "descripcion":"DEDOS DEL PIE SUPERPUESTOS CONGÉNITOS"
  },
  {
    "codigo":762403002,
    "descripcion":"FISURA DE PALADAR DURO CON FISURA LABIAL IZQUIERDA"
  },
  {
    "codigo":238115004,
    "descripcion":"DEFICIENCIA DE SODIO"
  },
  {
    "codigo":39672001,
    "descripcion":"ALUCINACIONES OLFATIVAS"
  },
  {
    "codigo":72440003,
    "descripcion":"DESORIENTACIÓN ESPACIAL"
  },
  {
    "codigo":400120004,
    "descripcion":"HAMARTOMA DE APARATO PILOSEBÁCEO"
  },
  {
    "codigo":15650291000119106,
    "descripcion":"CREPITACIÓN DE AMBAS RODILLAS"
  },
  {
    "codigo":234445000,
    "descripcion":"DEFICIENCIA CONGÉNITA DEL FACTOR IX CON INHIBIDOR"
  },
  {
    "codigo":398285003,
    "descripcion":"POSICIÓN DEL PACIENTE SEMIACOSTADO"
  },
  {
    "codigo":365517006,
    "descripcion":"HALLAZGO RELACIONADO CON LA PROLIJIDAD DEL HOGAR"
  },
  {
    "codigo":789666007,
    "descripcion":"FLEBITIS POSTERIOR A PERFUSIÓN"
  },
  {
    "codigo":1344887004,
    "descripcion":"HABILIDADES DIGITALES ADECUADAS"
  },
  {
    "codigo":296311007,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE PSILOCIBINA"
  },
  {
    "codigo":425548001,
    "descripcion":"ABSCESO CARDÍACO"
  },
  {
    "codigo":687911000119100,
    "descripcion":"RABDOMIOSARCOMA PRIMARIO DE TÓRAX"
  },
  {
    "codigo":720460007,
    "descripcion":"DESPIGMENTACIÓN AGUDA BILATERAL DE IRIS"
  },
  {
    "codigo":294476008,
    "descripcion":"ALERGIA A TEICOPLANINA"
  },
  {
    "codigo":292641001,
    "descripcion":"REACCIÓN ADVERSA A LA PODOFILOTOXINA"
  },
  {
    "codigo":94198007,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE VASO SANGUÍNEO DE LA REGIÓN INGUINAL"
  },
  {
    "codigo":288971000,
    "descripcion":"ESCUPE"
  },
  {
    "codigo":126966009,
    "descripcion":"NEOPLASIA DE NERVIO CRANEAL"
  },
  {
    "codigo":125131003,
    "descripcion":"DENSIDAD RADIOLÓGICA ANORMAL, LOCALIZADA"
  },
  {
    "codigo":92363004,
    "descripcion":"NEOPLASIA BENIGNA DE LA PIEL DE LA FRENTE"
  },
  {
    "codigo":878795009,
    "descripcion":"SORDERA TRANSITORIA"
  },
  {
    "codigo":1237408007,
    "descripcion":"UTILIZA PRESERVATIVO FEMENINO COMO MÉTODO ANTICONCEPTIVO"
  },
  {
    "codigo":449141000,
    "descripcion":"NEOPLASIA BENIGNA DE PARTES BLANDAS DEL PIE"
  },
  {
    "codigo":55925001,
    "descripcion":"MIOSITIS INTERSTICIAL"
  },
  {
    "codigo":1268341002,
    "descripcion":"RESORCIÓN INTERNA TRANSITORIA DE DIENTE DEBIDA A TRAUMATISMO DENTAL Y POSTERIOR A ÉL"
  },
  {
    "codigo":10682151000119107,
    "descripcion":"TUMORACIÓN DE LA PIEL DE DEDO DE LA MANO IZQUIERDA"
  },
  {
    "codigo":711285008,
    "descripcion":"PÉRDIDA DE DIMENSIÓN DE OCLUSIÓN VERTICAL DEBIDA A PRÓTESIS DENTAL COMPLETA DESGASTADA"
  },
  {
    "codigo":283466004,
    "descripcion":"HERIDA PUNZANTE EN LA MANO"
  },
  {
    "codigo":10737601000119103,
    "descripcion":"CISTOADENOCARCINOMA PAPILAR SEROSO PRIMARIO DE OVARIO DERECHO"
  },
  {
    "codigo":250698006,
    "descripcion":"APOLIPOPROTEÍNA E, FENOTIPO E3:4"
  },
  {
    "codigo":840522009,
    "descripcion":"EDEMA PULMONAR AGUDO CAUSADO POR VAPOR"
  },
  {
    "codigo":248863002,
    "descripcion":"LABIOS MAYORES VULVARES FLOJOS Y PÉNDULOS"
  },
  {
    "codigo":11311041000119104,
    "descripcion":"FRACTURA EXPUESTA DE PRIMERA VÉRTEBRA DORSAL"
  },
  {
    "codigo":85023004,
    "descripcion":"REGURGITACIÓN NASAL"
  },
  {
    "codigo":445471005,
    "descripcion":"EDEMA DE EXTREMIDAD CON EXTENSIÓN AL TRONCO"
  },
  {
    "codigo":1230068002,
    "descripcion":"BLEFAROCALASIA AISLADA"
  },
  {
    "codigo":50420004,
    "descripcion":"INFESTACIÓN CAUSADA POR ESCARABAJOS"
  },
  {
    "codigo":409033001,
    "descripcion":"CRECIMIENTO Y DESARROLLO ALTERADOS"
  },
  {
    "codigo":48585003,
    "descripcion":"ESPECTADOR EN ACCIDENTE DE EMBARCACIÓN"
  },
  {
    "codigo":441801009,
    "descripcion":"METAL PESADO EN ESPÉCIMEN DE SANGRE POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":308894004,
    "descripcion":"NECROSIS SUPRARRENAL"
  },
  {
    "codigo":734878005,
    "descripcion":"PATRÓN HORMONAL CELULAR NORMAL"
  },
  {
    "codigo":210590006,
    "descripcion":"PULGAR EN MARTILLO CON LESIÓN TENDINOSA EXPUESTA"
  },
  {
    "codigo":276126007,
    "descripcion":"EL ESPOSO ABANDONÓ EL HOGAR"
  },
  {
    "codigo":405363008,
    "descripcion":"BLOQUEO TOTAL DE NERVIO ESPINAL CONSECUTIVO A INYECCIÓN DE ANESTÉSICO LOCAL"
  },
  {
    "codigo":403528000,
    "descripcion":"EXACERBACIÓN GESTACIONAL DE DERMATOSIS"
  },
  {
    "codigo":43080001,
    "descripcion":"FÍSTULA INTESTINOUTERINA"
  },
  {
    "codigo":11776091000119105,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE ANTEBRAZO DERECHO CON INFECCIÓN"
  },
  {
    "codigo":1255496006,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO DE DEDO ANULAR DE MANO"
  },
  {
    "codigo":237853005,
    "descripcion":"HIPOCALIEMIA FARMACÓGENA"
  },
  {
    "codigo":203250000,
    "descripcion":"PERIOSTITIS DE MANO SIN OSTEOMIELITIS"
  },
  {
    "codigo":74013009,
    "descripcion":"GRADO DE GLEASON: 5"
  },
  {
    "codigo":16746741000119102,
    "descripcion":"RETINOPATÍA DIABÉTICA NO PROLIFERATIVA DE OJO DERECHO DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":399858007,
    "descripcion":"RETINA-HALLAZGO"
  },
  {
    "codigo":236018009,
    "descripcion":"EPIPLÓN MAYOR ESTRANGULADO"
  },
  {
    "codigo":365255002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA MEZCLAR INGREDIENTES DE COMIDA"
  },
  {
    "codigo":1348295004,
    "descripcion":"PARTO CON ANESTESIA EPIDURAL"
  },
  {
    "codigo":234183006,
    "descripcion":"INSUFICIENCIA DE PRÓTESIS DE VÁLVULA CARDÍACA"
  },
  {
    "codigo":266951006,
    "descripcion":"PRISIONERO DE GUERRA"
  },
  {
    "codigo":299719008,
    "descripcion":"HALLAZGO RELACIONADO CON LA DOMINANCIA CEREBRAL"
  },
  {
    "codigo":363420003,
    "descripcion":"TUMOR RETROPERITONEAL MALIGNO"
  },
  {
    "codigo":723868007,
    "descripcion":"OCLUSIÓN AGUDA DE ARTERIA"
  },
  {
    "codigo":230513000,
    "descripcion":"AVULSIÓN DE NERVIO ÓPTICO"
  },
  {
    "codigo":722033000,
    "descripcion":"SÍNDROME DE MACROCEFALIA, BAJA ESTATURA Y PARAPLEJÍA"
  },
  {
    "codigo":296049001,
    "descripcion":"SOBREDOSIS DE SECOBARBITAL"
  },
  {
    "codigo":66673003,
    "descripcion":"ÚLCERA GASTROYEYUNAL AGUDA CON HEMORRAGIA Y CON PERFORACIÓN PERO SIN OBSTRUCCIÓN"
  },
  {
    "codigo":1344625007,
    "descripcion":"FRACTURA EXPUESTA DE HUESO DE TÓRAX"
  },
  {
    "codigo":33905008,
    "descripcion":"ESFEROCITOSIS HEREDITARIA POR DEFICIENCIA DE PROTEÍNA 4, 2"
  },
  {
    "codigo":427121008,
    "descripcion":"AZOOSPERMIA POR OBSTRUCCIÓN"
  },
  {
    "codigo":294214004,
    "descripcion":"ALERGIA A ALCALOIDE DEL CÓLQUICO"
  },
  {
    "codigo":342651000119105,
    "descripcion":"FIBROSIS SUBRETINIANA DIFUSA"
  },
  {
    "codigo":32070009,
    "descripcion":"DEPURACIÓN RENAL ELEVADA"
  },
  {
    "codigo":1144347002,
    "descripcion":"HIPOPLASIA CONGÉNITA DE UNIDAD UNGUEAL DE QUINTO DEDO DE PIE"
  },
  {
    "codigo":292379001,
    "descripcion":"REACCIÓN ADVERSA AL TRIFLUPERIDOL"
  },
  {
    "codigo":423451008,
    "descripcion":"INFECCIÓN CAUSADA POR BACTERIAS ANAEROBIAS"
  },
  {
    "codigo":95771009,
    "descripcion":"MIOSITIS MASTICATORIA"
  },
  {
    "codigo":126704000,
    "descripcion":"NEOPLASIA DE LA CARINA DE LA TRÁQUEA"
  },
  {
    "codigo":808558991000119105,
    "descripcion":"MELANOMA MALIGNO DE PIEL DE ANTEBRAZO IZQUIERDO"
  },
  {
    "codigo":93936002,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE HUESO PALATINO"
  },
  {
    "codigo":290544006,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR COCAÍNA"
  },
  {
    "codigo":124869003,
    "descripcion":"AUMENTO DE LOS SITIOS RECEPTORES"
  },
  {
    "codigo":10959401000119101,
    "descripcion":"LACERACIÓN DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":92101008,
    "descripcion":"NEOPLASIA BENIGNA DE CUERDA VOCAL FALSA"
  },
  {
    "codigo":450714000,
    "descripcion":"DEPRESIÓN MAYOR SEVERA"
  },
  {
    "codigo":288709008,
    "descripcion":"SE COMUNICA EN DIFERENTES OCASIONES"
  },
  {
    "codigo":15982991000119109,
    "descripcion":"OTITIS EXTERNA DE CONDUCTO AUDITIVO EXTERNO DERECHO CAUSADO POR VIRUS DEL HERPES SIMPLE HUMANO"
  },
  {
    "codigo":712858005,
    "descripcion":"NEOPLASIA DE NERVIO ESPINAL DORSAL"
  },
  {
    "codigo":24730004,
    "descripcion":"ESGUINCE DE LIGAMENTO CALCANEOPERONEO"
  },
  {
    "codigo":188570009,
    "descripcion":"ENFERMEDAD DE HODGKIN, ESCLEROSIS NODULAR DE GANGLIOS LINFÁTICOS INTRAPÉLVICOS"
  },
  {
    "codigo":250436000,
    "descripcion":"CÉLULAS HUMANAS"
  },
  {
    "codigo":283204001,
    "descripcion":"ANZUELO EN DEDO DE LA MANO"
  },
  {
    "codigo":447044003,
    "descripcion":"ABSCESO DE LECHO UNGUEAL"
  },
  {
    "codigo":21060003,
    "descripcion":"EPIGLOTITIS BACTERIANA AGUDA"
  },
  {
    "codigo":217668003,
    "descripcion":"ENVENENAMIENTO DEBIDO A PICADURA DE TARÁNTULA"
  },
  {
    "codigo":184900007,
    "descripcion":"EXAMEN MÉDICO DE CORREDOR DE CARRERA: EFECTUADO"
  },
  {
    "codigo":248601000,
    "descripcion":"ESPUTO, VOLUMEN ESCASO"
  },
  {
    "codigo":709188009,
    "descripcion":"INFECCIÓN CAUSADA POR CATÉTER DE TENCKHOFF"
  },
  {
    "codigo":281369002,
    "descripcion":"DERRAME ESPONTÁNEO DE LA ARTICULACIÓN"
  },
  {
    "codigo":445209005,
    "descripcion":"HIPOPLASIA CONGÉNITA DE ARTERIA PULMONAR IZQUIERDA"
  },
  {
    "codigo":314137006,
    "descripcion":"NITRITO EN ORINA DETECTADO"
  },
  {
    "codigo":1231641009,
    "descripcion":"PSEUDOPARÁLISIS DEL ABDUCENS"
  },
  {
    "codigo":707353009,
    "descripcion":"CARCINOMA PRIMARIO DE CÉLULAS ESCAMOSAS DE SENO PARANASAL"
  },
  {
    "codigo":15555002,
    "descripcion":"PERICARDITIS AGUDA"
  },
  {
    "codigo":265458371000119104,
    "descripcion":"ADAMANTINOMA MALIGNO PRIMARIO DE HUESO LARGO DE MIEMBRO INFERIOR DERECHO"
  },
  {
    "codigo":736451003,
    "descripcion":"RUPTURA PARCIAL DE UNIÓN URETEROPÉLVICA"
  },
  {
    "codigo":408771005,
    "descripcion":"ECOGRAFÍA DE CABEZA FETAL, ANORMAL"
  },
  {
    "codigo":769219006,
    "descripcion":"EDEMA MACULAR DEBIDO A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":13720003,
    "descripcion":"GAMMAPATÍA TRICLONAL"
  },
  {
    "codigo":210328006,
    "descripcion":"HERIDA ABIERTA DE LA CAVIDAD NASAL"
  },
  {
    "codigo":1258904007,
    "descripcion":"RUPTURA TRAUMÁTICA DE COMPLEJO FIBROCARTILAGINOSO TRIANGULAR DE REGIÓN DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":79256006,
    "descripcion":"ACROPARESTESIA"
  },
  {
    "codigo":44653001,
    "descripcion":"ERISIPELA"
  },
  {
    "codigo":110189006,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO DE MEJILLA"
  },
  {
    "codigo":1288002001,
    "descripcion":"ARTRITIS DE TOBILLO CAUSADA POR STREPTOCOCCUS PNEUMONIAE"
  },
  {
    "codigo":403266001,
    "descripcion":"PIGMENTACIÓN POR PIGMENTO EXÓGENO"
  },
  {
    "codigo":10050004,
    "descripcion":"CONTUSIÓN DEL TÓRAX"
  },
  {
    "codigo":42818005,
    "descripcion":"FRACTURA NO EXPUESTA DE HUESO ESCAFOIDES DE MUÑECA"
  },
  {
    "codigo":763714006,
    "descripcion":"NEVOS FLÁMEOS MÚLTIPLES, TIPO FAMILIAR"
  },
  {
    "codigo":370498004,
    "descripcion":"MUCOMETRA"
  },
  {
    "codigo":16477021000119103,
    "descripcion":"CATARATA SENIL POLAR SUBCAPSULAR ANTERIOR DE AMBOS OJOS"
  },
  {
    "codigo":237591004,
    "descripcion":"SECRECIÓN EXCESIVA DE MOTILINA"
  },
  {
    "codigo":1220631006,
    "descripcion":"INTERRUPCIÓN INDUCIDA DEL EMBARAZO INCOMPLETA COMPLICADA POR HEMORRAGIA RETRASADA O EXCESIVA"
  },
  {
    "codigo":73751008,
    "descripcion":"LÍNEAS DE MEE"
  },
  {
    "codigo":301292000,
    "descripcion":"ESPUTO ACUOSO ABUNDANTE"
  },
  {
    "codigo":202988003,
    "descripcion":"ABSCESO DE TENDÓN EN ANTEBRAZO"
  },
  {
    "codigo":399596004,
    "descripcion":"COMPROMISO TUMORAL DEL MARGEN QUIRÚRGICO PANCREÁTICO NO SE PUEDE VALORAR"
  },
  {
    "codigo":6380005,
    "descripcion":"PELVIS INVERTIDA"
  },
  {
    "codigo":235756006,
    "descripcion":"COLITIS AGUDA POR RADIACIÓN"
  },
  {
    "codigo":1251564008,
    "descripcion":"ENFERMEDAD NEOPLÁSICA MALIGNA RECIDIVANTE"
  },
  {
    "codigo":102849002,
    "descripcion":"LIPIDURIA"
  },
  {
    "codigo":66551000119101,
    "descripcion":"PORTADOR DE TALASEMIA BETA"
  },
  {
    "codigo":338781000119107,
    "descripcion":"PTERIGIÓN PERIFÉRICO PROGRESIVO DE OJO IZQUIERDO"
  },
  {
    "codigo":16040951000119101,
    "descripcion":"ARTRITIS IDIOPÁTICA JUVENIL DE INICIO SISTÉMICO DE CADERA DERECHA"
  },
  {
    "codigo":168385006,
    "descripcion":"HELICOBACTER PYLORI DETECTADO POR PRUEBA RÁPIDA DE UREASA"
  },
  {
    "codigo":364993008,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA COORDINAR EL FLUJO AÉREO Y LA EMISIÓN DE LA VOZ"
  },
  {
    "codigo":299457009,
    "descripcion":"ARTICULACIÓN DE TOBILLO FRÍA AL TACTO"
  },
  {
    "codigo":232086000,
    "descripcion":"GLAUCOMA NEOVASCULAR DE ÁNGULO CERRADO"
  },
  {
    "codigo":263019000,
    "descripcion":"LUXACIÓN DE ARTICULACIÓN ACROMIOCLAVICULAR"
  },
  {
    "codigo":875001,
    "descripcion":"CALCOSIS OCULAR"
  },
  {
    "codigo":721771003,
    "descripcion":"INFECCIÓN DE INTESTINO CAUSADA POR CITOMEGALOVIRUS 5 HUMANO"
  },
  {
    "codigo":230251004,
    "descripcion":"ATROFIA MUSCULAR ESPINAL ESCAPULOHUMERAL"
  },
  {
    "codigo":295787005,
    "descripcion":"SOBREDOSIS DE VINBLASTINA"
  },
  {
    "codigo":35851000175103,
    "descripcion":"ÚLCERA POR PRESIÓN EN TALÓN, ESTADIO III"
  },
  {
    "codigo":197483008,
    "descripcion":"HIPOGLUCEMIA POSCIRUGÍA DEL TRACTO GASTROINTESTINAL"
  },
  {
    "codigo":293952002,
    "descripcion":"ALERGIA A SELEGILINA"
  },
  {
    "codigo":64576003,
    "descripcion":"ABSCESO GLÚTEO"
  },
  {
    "codigo":48651000175107,
    "descripcion":"VÍCTIMA DE CIBERACOSO"
  },
  {
    "codigo":161045001,
    "descripcion":"DISCAPACIDAD - GRAVE"
  },
  {
    "codigo":128277003,
    "descripcion":"CELULITIS DE LA CABEZA"
  },
  {
    "codigo":880106000,
    "descripcion":"INGESTA EXCESIVA DE TIAMINA"
  },
  {
    "codigo":95509009,
    "descripcion":"ESTRABISMO CONGÉNITO"
  },
  {
    "codigo":423189008,
    "descripcion":"ADENOCARCINOMA QUÍSTICO DE GLÁNDULA SUBMAXILAR"
  },
  {
    "codigo":1142250003,
    "descripcion":"HIPERTROFIA DE MÚSCULO DE EXTREMIDAD INFERIOR IZQUIERDA"
  },
  {
    "codigo":191978003,
    "descripcion":"DISURIA PSICÓGENA"
  },
  {
    "codigo":290282002,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR NAPROXENO"
  },
  {
    "codigo":93674007,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA PARED ANTERIOR DE LA NASOFARINGE"
  },
  {
    "codigo":419519001,
    "descripcion":"REACCIÓN ALÉRGICA CAUSADA POR POLEN DE HIERBAS"
  },
  {
    "codigo":124607001,
    "descripcion":"DEFICIENCIA DE FOSFOCETOLASA"
  },
  {
    "codigo":285841000119104,
    "descripcion":"ENFERMEDAD RENAL TERMINAL POR HIPERTENSIÓN MALIGNA"
  },
  {
    "codigo":367761000119105,
    "descripcion":"OLIGOZOOSPERMIA DEBIDA A TRATAMIENTO FARMACOLÓGICO"
  },
  {
    "codigo":188308004,
    "descripcion":"NEOPLASIA MALIGNA DEL BULBO OLFATIVO"
  },
  {
    "codigo":284777000,
    "descripcion":"NO REALIZA ACTIVIDAD DE CUIDADO PERSONAL"
  },
  {
    "codigo":253844009,
    "descripcion":"DUPLICACIÓN DE CLÍTORIS"
  },
  {
    "codigo":88169003,
    "descripcion":"ÚLCERA PÉPTICA CON PERFORACIÓN"
  },
  {
    "codigo":414014001,
    "descripcion":"ENFERMEDAD CAUSADA POR FLAVIVIRIDAE"
  },
  {
    "codigo":53566005,
    "descripcion":"SIGNO DE MURPHY"
  },
  {
    "codigo":282942007,
    "descripcion":"CAPAZ DE INCLINARSE PARA LEVANTAR UN OBJETO SIN CAERSE"
  },
  {
    "codigo":1264147003,
    "descripcion":"DAÑO DE ÚTERO POSTERIOR A EMBARAZO ECTÓPICO"
  },
  {
    "codigo":1296915003,
    "descripcion":"DEFICIENCIA HEREDITARIA AUTOSÓMICA RECESIVA DE VASOPRESINA"
  },
  {
    "codigo":39751000087102,
    "descripcion":"LUXACIÓN DE ARTICULACIÓN DE PULGAR IZQUIERDO"
  },
  {
    "codigo":17128000,
    "descripcion":"EVENTRACIÓN CONGÉNITA DEL DIAFRAGMA"
  },
  {
    "codigo":281107009,
    "descripcion":"INTOXICACIÓN POR ALIMENTOS INFECTADOS"
  },
  {
    "codigo":18963009,
    "descripcion":"LABILIDAD ANÍMICA"
  },
  {
    "codigo":82664003,
    "descripcion":"PLACENTA ACCESORIA"
  },
  {
    "codigo":42311000087106,
    "descripcion":"CONTUSIÓN DE REGIÓN DE CLAVÍCULA DERECHA"
  },
  {
    "codigo":836328003,
    "descripcion":"AGUDEZA VISUAL CON AGUJERO ESTENOPEICO DE OJO IZQUIERDO 6\/36"
  },
  {
    "codigo":1231379009,
    "descripcion":"INFLAMACIÓN DE INTESTINO DELGADO CAUSADA POR SHIGELLA"
  },
  {
    "codigo":770792007,
    "descripcion":"MIOPATÍA DISTAL DEL ADULTO POR MUTACIÓN DE PROTEÍNA QUE CONTIENE VALOSINA"
  },
  {
    "codigo":211901000,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO SUPERFICIAL DE PULGAR"
  },
  {
    "codigo":48061001,
    "descripcion":"CÁLCULO CONGÉNITO DE RIÑÓN"
  },
  {
    "codigo":10745131000119107,
    "descripcion":"ABSCESO DE MAMA ASOCIADO CON LA LACTANCIA"
  },
  {
    "codigo":80829003,
    "descripcion":"HEMORROIDES EXTERNAS ESTRANGULADAS"
  },
  {
    "codigo":47431000087107,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE PIEL DE TALÓN DERECHO"
  },
  {
    "codigo":408509005,
    "descripcion":"DERIVADO PARA EVALUACIÓN DE LA SILLA DE RUEDAS"
  },
  {
    "codigo":111762003,
    "descripcion":"INTOXICACIÓN CAUSADA POR ANTIRREUMÁTICO"
  },
  {
    "codigo":439442003,
    "descripcion":"SANGRADO ESOFÁGICO POR ESOFAGITIS ULCEROSA"
  },
  {
    "codigo":242834006,
    "descripcion":"SOBREDOSIS INTENCIONAL DE CLORDIAZEPÓXIDO"
  },
  {
    "codigo":699751000,
    "descripcion":"ARCADA MAXILAR ESTRECHA"
  },
  {
    "codigo":11623000,
    "descripcion":"HEMORRAGIA COROIDEA EXPULSIVA"
  },
  {
    "codigo":765287005,
    "descripcion":"ATRACCIÓN SEXUAL POR LOS SEXOS MASCULINO Y FEMENINO"
  },
  {
    "codigo":109927006,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LOS NERVIOS PERIFÉRICOS DEL CUELLO"
  },
  {
    "codigo":16125381000119105,
    "descripcion":"DERRAME INTERMITENTE DE ARTICULACIÓN DE AMBOS CODOS"
  },
  {
    "codigo":239164002,
    "descripcion":"SECRECIÓN DE HERIDA"
  },
  {
    "codigo":403004007,
    "descripcion":"TIÑA DE CUERO CABELLUDO CAUSADA POR MICROSPORUM GALLINAE"
  },
  {
    "codigo":697916007,
    "descripcion":"HIPERTENSIÓN PULMONAR DEBIDA A ANOMALÍA DEL DESARROLLO DEL PULMÓN"
  },
  {
    "codigo":302865004,
    "descripcion":"TRASTORNO NO DIABÉTICO DEL PÁNCREAS"
  },
  {
    "codigo":401169009,
    "descripcion":"AÚN SIN CAMINAR"
  },
  {
    "codigo":301030002,
    "descripcion":"TUMORACIÓN EN EL MEDIASTINO ANTERIOR"
  },
  {
    "codigo":366566001,
    "descripcion":"AMPLITUD DE LA EXTENSIÓN DE LA CADERA - HALLAZGO"
  },
  {
    "codigo":6118003,
    "descripcion":"ENFERMEDAD DESMIELINIZANTE DEL SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":71654004,
    "descripcion":"DACRIOPS"
  },
  {
    "codigo":235494005,
    "descripcion":"PANCREATITIS CRÓNICA"
  },
  {
    "codigo":268262006,
    "descripcion":"ACROCEFALOSINDACTILIA"
  },
  {
    "codigo":102587001,
    "descripcion":"DOLOR DE PECHO AGUDO"
  },
  {
    "codigo":364731003,
    "descripcion":"HALLAZGO RELACIONADO CON LA ADAPTACIÓN GENERAL A LA PLANTILLA DEL CALZADO"
  },
  {
    "codigo":299195006,
    "descripcion":"ARTICULACIÓN DEL PULGAR INESTABLE"
  },
  {
    "codigo":233659006,
    "descripcion":"PLACA PLEURAL INDUCIDA POR AMIANTO"
  },
  {
    "codigo":37051008,
    "descripcion":"EVALUACIÓN DE DISCAPACIDAD: 45%"
  },
  {
    "codigo":231824001,
    "descripcion":"NEOPLASIA BENIGNA PALPEBRAL"
  },
  {
    "codigo":1149328002,
    "descripcion":"TOXICIDAD POR CANNABIS"
  },
  {
    "codigo":4283007,
    "descripcion":"SÍNDROME DE MIRIZZI"
  },
  {
    "codigo":428432004,
    "descripcion":"DOLOR ESPONTÁNEO"
  },
  {
    "codigo":788880006,
    "descripcion":"ACCIDENTE CEREBROVASCULAR ISQUÉMICO DEBIDO A DISECCIÓN DE ARTERIA"
  },
  {
    "codigo":343801000119100,
    "descripcion":"VASCULITIS RETINIANA DE AMBOS OJOS"
  },
  {
    "codigo":395664008,
    "descripcion":"DIFICULTAD PARA COMPRENDER EL CONCEPTO DE PELIGRO"
  },
  {
    "codigo":295525002,
    "descripcion":"SOBREDOSIS DE ENFLURANO"
  },
  {
    "codigo":613003,
    "descripcion":"SÍNDROME DEL CROMOSOMA X FRÁGIL"
  },
  {
    "codigo":721509003,
    "descripcion":"SÍNDROME DEL CORDÓN CENTRAL DE MÉDULA ESPINAL AL NIVEL DEL CUARTO SEGMENTO LUMBAR"
  },
  {
    "codigo":66149005,
    "descripcion":"HIPERPLASIA DE LAS CÉLULAS BETA DE LOS ISLOTES PANCREÁTICOS"
  },
  {
    "codigo":293690005,
    "descripcion":"ALERGIA A ACEITE DE MENTA"
  },
  {
    "codigo":64314006,
    "descripcion":"RISA SARDÓNICA"
  },
  {
    "codigo":129850005,
    "descripcion":"CON MAYOR RIESGO DE RESPUESTA ADVERSA A FÁRMACO"
  },
  {
    "codigo":301747008,
    "descripcion":"DIFICULTAD PARA REALIZAR ACTIVIDADES DE TECNOLOGÍA INFORMÁTICA"
  },
  {
    "codigo":95247003,
    "descripcion":"CARIES POR DISFUNCIÓN SALIVAL CAUSADA POR MEDICACIÓN"
  },
  {
    "codigo":62479008,
    "descripcion":"SIDA"
  },
  {
    "codigo":291855009,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR TIROXINA"
  },
  {
    "codigo":1078287008,
    "descripcion":"FIEBRE RECURRENTE"
  },
  {
    "codigo":421092003,
    "descripcion":"TRASTORNO ALÉRGICO DEL APARATO RESPIRATORIO"
  },
  {
    "codigo":224484003,
    "descripcion":"LOS PROPIOS PACIENTES PROVEEN LA ATENCIÓN"
  },
  {
    "codigo":60644007,
    "descripcion":"SÍNDROME DE PELLEGRINI - STIEDA"
  },
  {
    "codigo":93412007,
    "descripcion":"ENGROSAMIENTO CONGÉNITO DE CÚBITO"
  },
  {
    "codigo":15744761000119108,
    "descripcion":"MASA DE ARTICULACIÓN DE RODILLA DERECHA"
  },
  {
    "codigo":89742000,
    "descripcion":"TRASTORNO AUTÓNOMO DEL NERVIO VAGO"
  },
  {
    "codigo":26041009,
    "descripcion":"DIETA RESTRINGIDA EN POTASIO"
  },
  {
    "codigo":188046002,
    "descripcion":"MELANOMA MALIGNO DE CUELLO"
  },
  {
    "codigo":124345008,
    "descripcion":"DEFICIENCIA DE NICOTINAMIDA - NUCLEÓTIDO ADENILILTRANSFERASA"
  },
  {
    "codigo":286350008,
    "descripcion":"CAPAZ DE IMITAR LA VOCALIZACIÓN"
  },
  {
    "codigo":253582009,
    "descripcion":"INSUFICIENCIA DE VÁLVULA TRONCAL"
  },
  {
    "codigo":1269390009,
    "descripcion":"LESIÓN CENTRAL DE MÉDULA ESPINAL DORSAL DEBIDA A SUBLUXACIÓN EXPUESTA DE ARTICULACIÓN DE COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":284515004,
    "descripcion":"MOVIMIENTOS DE ALETEO REPETITIVOS"
  },
  {
    "codigo":448355005,
    "descripcion":"FRACTURA EN TALLO VERDE DE RADIO DISTAL"
  },
  {
    "codigo":315448004,
    "descripcion":"NACIDO EN IRLANDA"
  },
  {
    "codigo":282680006,
    "descripcion":"NO ALCANZA"
  },
  {
    "codigo":1003576007,
    "descripcion":"AGENESIA DE HUESO HIOIDES"
  },
  {
    "codigo":249912007,
    "descripcion":"TOBILLO RÍGIDO"
  },
  {
    "codigo":440991000124103,
    "descripcion":"INGESTA EXCESIVA DE MANGANESO"
  },
  {
    "codigo":671391000124106,
    "descripcion":"INCAPAZ DE OBTENER ELECTRICIDAD EN DOMICILIO DEBIDO A RECURSOS ECONÓMICOS LIMITADOS"
  },
  {
    "codigo":248077003,
    "descripcion":"NO CONOCE EL PELIGRO DE LAS HORNALLAS CALIENTES"
  },
  {
    "codigo":232534061000119102,
    "descripcion":"DELIRIO DEBIDO A ENCEFALOPATÍA HEPÁTICA"
  },
  {
    "codigo":277175001,
    "descripcion":"ERITEMA PERIUMBILICAL"
  },
  {
    "codigo":703159004,
    "descripcion":"FALLA DE PRÓTESIS DE VÁLVULA MITRAL QUE REQUIERE REEMPLAZO"
  },
  {
    "codigo":211639005,
    "descripcion":"CUERPO EXTRAÑO EN EL COLON ASCENDENTE"
  },
  {
    "codigo":80567007,
    "descripcion":"SIALODOCOLITIASIS"
  },
  {
    "codigo":275340006,
    "descripcion":"FRACTURA NO EXPUESTA DE TROCÁNTER MAYOR DE FÉMUR"
  },
  {
    "codigo":13196008,
    "descripcion":"POLIURIA ASOCIADA A VASOPRESINA ARGININA SECUNDARIA"
  },
  {
    "codigo":240737001,
    "descripcion":"ULCERACIÓN DE PENE POR HISTOPLASMOSIS CLÁSICA"
  },
  {
    "codigo":109665002,
    "descripcion":"FERULIZACIÓN PARA PROTECCIÓN DE LOS MÚSCULOS MASTICATORIOS"
  },
  {
    "codigo":207969000,
    "descripcion":"FRACTURA EXPUESTA DE VÉRTEBRA LUMBAR, APÓFISIS ESPINOSA"
  },
  {
    "codigo":371809004,
    "descripcion":"ANGINA DE PECHO RECURRENTE DESPUÉS DE COLOCACIÓN DE STENT EN ARTERIA CORONARIA"
  },
  {
    "codigo":9526000,
    "descripcion":"DISFUNCIÓN DE LA GLÁNDULA PINEAL"
  },
  {
    "codigo":699489009,
    "descripcion":"CARIES DENTAL CLASE I"
  },
  {
    "codigo":1083591000119102,
    "descripcion":"BOLSILLO DE RETRACCIÓN DE AMBAS MEMBRANAS TIMPÁNICAS"
  },
  {
    "codigo":346311000119102,
    "descripcion":"PLIEGUE DE MEMBRANA DE DESCEMET DE AMBOS OJOS"
  },
  {
    "codigo":402742004,
    "descripcion":"LESIÓN DE PIEL POR TRASTORNO NERVIOSO ADQUIRIDO"
  },
  {
    "codigo":1156406005,
    "descripcion":"OLIGODENDROGLIOMA ANAPLÁSICO DEL SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":238902007,
    "descripcion":"LIPOMATOSIS SIMÉTRICA MÚLTIPLE"
  },
  {
    "codigo":105995000,
    "descripcion":"TRASTORNO DE LOS DIENTES Y\/O ESTRUCTURAS DE SOSTÉN"
  },
  {
    "codigo":237067000,
    "descripcion":"DOLOR CRÓNICO EN PELVIS FEMENINA"
  },
  {
    "codigo":1287478009,
    "descripcion":"NEVO MELANOCÍTICO DE PIEL DE CARA"
  },
  {
    "codigo":1285643003,
    "descripcion":"GLAUCOMA NEOVASCULAR DEBIDO A OCLUSIÓN DE VENA CENTRAL DE RETINA"
  },
  {
    "codigo":15911111000119105,
    "descripcion":"RETINOPATÍA DE OJO DERECHO CAUSADA POR TAMOXIFENO"
  },
  {
    "codigo":169696001,
    "descripcion":"ESTADO DE RUBÉOLA NO CONOCIDO"
  },
  {
    "codigo":204299009,
    "descripcion":"DEXTROTRANSPOSICIÓN DE LA AORTA"
  },
  {
    "codigo":366304002,
    "descripcion":"HALLAZGO RELACIONADO CON LA FLEXIÓN DEL ÚTERO"
  },
  {
    "codigo":300768004,
    "descripcion":"CAPAZ DE REALIZAR ACTIVIDADES RECREATIVAS Y DEPORTIVAS"
  },
  {
    "codigo":399072004,
    "descripcion":"OBSTRUCCIÓN DE CUELLO DE VEJIGA URINARIA"
  },
  {
    "codigo":71392009,
    "descripcion":"CELULITIS DE MUÑECA"
  },
  {
    "codigo":724917002,
    "descripcion":"DISTENSIÓN DE FASCIA DE CABEZA LARGA DE BÍCEPS BRAQUIAL"
  },
  {
    "codigo":36789003,
    "descripcion":"GASTROENTERITIS INFECCIOSA AGUDA"
  },
  {
    "codigo":723082006,
    "descripcion":"INFARTO CEREBRAL SILENCIOSO"
  },
  {
    "codigo":67722007,
    "descripcion":"CON MAYOR RIESGO DE CONTRACTURA ARTICULAR"
  },
  {
    "codigo":1149066008,
    "descripcion":"PANCARDITIS CRÓNICA DEBIDA A CARDIOPATÍA REUMÁTICA"
  },
  {
    "codigo":2186007,
    "descripcion":"ALCALOSIS METABÓLICA COMPENSADA"
  },
  {
    "codigo":229727006,
    "descripcion":"CIERRE INCOMPLETO DE APARATO VELOFARÍNGEO"
  },
  {
    "codigo":293428000,
    "descripcion":"REACCIÓN ADVERSA AL FENOFIBRATO"
  },
  {
    "codigo":129588001,
    "descripcion":"SÍNDROME DE FALTA DE PROGRESO EN EL ADULTO"
  },
  {
    "codigo":1145396000,
    "descripcion":"APLASIA DE CABEZA DE FÉMUR"
  },
  {
    "codigo":721247009,
    "descripcion":"MIELITIS CAUSADA POR INFECCIÓN PARASITARIA"
  },
  {
    "codigo":453720571000119100,
    "descripcion":"RECTOSIGMOIDITIS ULCEROSA AGUDA"
  },
  {
    "codigo":94985004,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE HUESO PARIETAL"
  },
  {
    "codigo":160521004,
    "descripcion":"ORIGEN: LEJANO ORIENTE"
  },
  {
    "codigo":291593006,
    "descripcion":"INTOXICACIÓN POR CEFALOSPORINA DE TERCERA GENERACIÓN"
  },
  {
    "codigo":15720801000119108,
    "descripcion":"SUBLUXACIÓN CONGÉNITA DE CABEZA DE RADIO DERECHO"
  },
  {
    "codigo":289758000,
    "descripcion":"CUELLO UTERINO DE FORMA IRREGULAR"
  },
  {
    "codigo":191454001,
    "descripcion":"DEMENCIA PRESENIL CON PARANOIA"
  },
  {
    "codigo":224222004,
    "descripcion":"VIVE EN ALOJAMIENTO CON VIGILANCIA QUE RESIDE EN EL LUGAR"
  },
  {
    "codigo":27614006,
    "descripcion":"ABSCESO INTRACRANEAL"
  },
  {
    "codigo":93150008,
    "descripcion":"RETICULOENDOTELIOSIS LEUCÉMICA DE GANGLIOS LINFÁTICOS DE LOCALIZACIONES MÚLTIPLES"
  },
  {
    "codigo":296161000119100,
    "descripcion":"QUISTE DE MENISCO DE RODILLA DERECHA"
  },
  {
    "codigo":417437921000119101,
    "descripcion":"CARCINOMA ASOCIADO A PROTEÍNA NUCLEAR EN TESTÍCULO CON METÁSTASIS EN HÍGADO"
  },
  {
    "codigo":15684321000119102,
    "descripcion":"PERIOSTITIS DE MANO DERECHA"
  },
  {
    "codigo":132321000119103,
    "descripcion":"TROMBOSIS VENOSA PROFUNDA AGUDA DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":15668961000119104,
    "descripcion":"DEFORMIDAD CONGÉNITA DE ARTICULACIÓN DE RODILLA IZQUIERDA"
  },
  {
    "codigo":101601000119101,
    "descripcion":"NEUROMA POSQUIRÚRGICO DE MIEMBRO INFERIOR"
  },
  {
    "codigo":308961000119106,
    "descripcion":"TENDINITIS CALCIFICANTE DE CADERA IZQUIERDA"
  },
  {
    "codigo":15725281000119106,
    "descripcion":"DERRAME DE BOLSA SEROSA DE OLÉCRANON DE AMBOS CODOS"
  },
  {
    "codigo":969688801000119108,
    "descripcion":"COLITIS ULCEROSA IZQUIERDA CRÓNICA"
  },
  {
    "codigo":11864801000119109,
    "descripcion":"LESIÓN TRAUMÁTICA DE PIERNA DERECHA"
  },
  {
    "codigo":352481000119103,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE PIEL DE EXTREMIDAD INFERIOR IZQUIERDA"
  },
  {
    "codigo":561258721000119104,
    "descripcion":"DISTROFIA MACULAR CORNEAL BILATERAL"
  },
  {
    "codigo":6881000119109,
    "descripcion":"NISTAGMO SENSORIAL"
  },
  {
    "codigo":1092321000119104,
    "descripcion":"TRASTORNO DE NERVIO VESTIBULAR DERECHO"
  },
  {
    "codigo":298721000119105,
    "descripcion":"OSTEONECROSIS DE DEDO DE PIE DEBIDA A TRAUMATISMO"
  },
  {
    "codigo":11995361000119109,
    "descripcion":"CONTRACTURA DE MUÑÓN DE AMPUTACIÓN DE EXTREMIDAD INFERIOR IZQUIERDA"
  },
  {
    "codigo":251485004,
    "descripcion":"ANOMALÍA ELECTROENCEFALOGRÁFICA FOCAL CONTINUA"
  },
  {
    "codigo":284253005,
    "descripcion":"EMPUÑA"
  },
  {
    "codigo":15709921000119109,
    "descripcion":"HEMANGIOMA COROIDAL BILATERAL"
  },
  {
    "codigo":417160009,
    "descripcion":"INFECCIÓN NO NEUROINVASIVA POR VIRUS DE LA ENCEFALITIS DE POWASSAN"
  },
  {
    "codigo":249650004,
    "descripcion":"SIGNO DEL NEUMÁTICO"
  },
  {
    "codigo":20274005,
    "descripcion":"FRACTURA DE UNA COSTILLA"
  },
  {
    "codigo":53042006,
    "descripcion":"IRREGULARIDADES EN EL DESGASTE DEL DIENTE"
  },
  {
    "codigo":184114006,
    "descripcion":"FECHA DE NACIMIENTO DEL PACIENTE - DESCONOCIDA"
  },
  {
    "codigo":247815003,
    "descripcion":"MIEDO A DEGLUTIR"
  },
  {
    "codigo":83975008,
    "descripcion":"ERRORES DE DENOMINACIÓN"
  },
  {
    "codigo":313351009,
    "descripcion":"ENFERMEDAD DE BOWEN DE LA VULVA"
  },
  {
    "codigo":1163484003,
    "descripcion":"TRASTORNO DE LOS GLOMÉRULOS DEBIDO A INFECCIÓN POR STRONGYLOIDES"
  },
  {
    "codigo":735665002,
    "descripcion":"LESIÓN TRAUMÁTICA DE BOLSA SEROSA DE CODO"
  },
  {
    "codigo":47537002,
    "descripcion":"ABORTO ESPONTÁNEO CON CHOQUE POSOPERATORIO"
  },
  {
    "codigo":309681005,
    "descripcion":"VIVE EN DEPARTAMENTO ALQUILADO AMUEBLADO"
  },
  {
    "codigo":1290886001,
    "descripcion":"SARCOMA EPITELIOIDE PROXIMAL"
  },
  {
    "codigo":209542003,
    "descripcion":"ESGUINCE DE ARTICULACIÓN MEDIOTARSIANA"
  },
  {
    "codigo":373382006,
    "descripcion":"TRASTORNO DEL APARATO OCULOMOTOR"
  },
  {
    "codigo":240475000,
    "descripcion":"INFECCIÓN CUTÁNEA CAUSADA POR EL VIRUS DEL HERPES SIMPLE"
  },
  {
    "codigo":897670009,
    "descripcion":"NEUROESTIMULADOR DE NERVIO PERIFÉRICO IN SITU"
  },
  {
    "codigo":109403002,
    "descripcion":"FACIOSINOSTOSIS PERIMAXILAR COMPLETA"
  },
  {
    "codigo":207707005,
    "descripcion":"FRACTURA EXPUESTA DE LA CALOTA CRANEAL CON LESIÓN INTRACRANEAL, SIN PÉRDIDA DE CONSCIENCIA"
  },
  {
    "codigo":9264002,
    "descripcion":"LACERACIÓN DE RIÑÓN CON HERIDA ABIERTA HACIA CAVIDAD ABDOMINAL"
  },
  {
    "codigo":402480004,
    "descripcion":"QUEMADURA FOTOTÓXICA INDUCIDA POR PORFIRIA"
  },
  {
    "codigo":74800004,
    "descripcion":"FIEBRE DE LOS FUNDIDORES DE LATÓN"
  },
  {
    "codigo":369712006,
    "descripcion":"MÁRGENES NO EVALUABLES"
  },
  {
    "codigo":238640007,
    "descripcion":"ACROQUERATOSIS PARANEOPLÁSICA DE BAZEX"
  },
  {
    "codigo":236805000,
    "descripcion":"ALTERACIÓN CONGÉNITA DE MOTILIDAD DE ESPERMATOZOIDES"
  },
  {
    "codigo":42032008,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN LA REGIÓN DE LA PARED ABDOMINAL, CON INFECCIÓN"
  },
  {
    "codigo":224947005,
    "descripcion":"DISPARARSE A UNO MISMO"
  },
  {
    "codigo":171269006,
    "descripcion":"SIN CONSENTIMIENTO PARA INMUNIZACIÓN CONTRA SARAMPIÓN"
  },
  {
    "codigo":366042000,
    "descripcion":"HALLAZGO RELACIONADO CON LA APARIENCIA GENERAL DE LA RETINA"
  },
  {
    "codigo":5594001,
    "descripcion":"MOVIMIENTO BIFÁSICO DE LAS COSTILLAS INFERIORES"
  },
  {
    "codigo":40197009,
    "descripcion":"ENFERMEDAD GRANULOMATOSA CRÓNICA, TIPO IA"
  },
  {
    "codigo":38362002,
    "descripcion":"DENGUE"
  },
  {
    "codigo":300506000,
    "descripcion":"CONDUCTO DEFERENTE AUSENTE"
  },
  {
    "codigo":72965009,
    "descripcion":"COLITIS QUÍMICA"
  },
  {
    "codigo":234970006,
    "descripcion":"DENTINOGÉNESIS IMPERFECTA - TIPO III DE SHIELD"
  },
  {
    "codigo":298671000,
    "descripcion":"HALLAZGO RELACIONADO CON LA SENSIBILIDAD DE LA COLUMNA LUMBAR"
  },
  {
    "codigo":726490008,
    "descripcion":"ESTENOSIS DE ARTERIA"
  },
  {
    "codigo":429743002,
    "descripcion":"HEMATOMA EXTRADURAL OCCIPITAL"
  },
  {
    "codigo":724655005,
    "descripcion":"TRASTORNO PSICÓTICO CAUSADO POR OPIOIDE"
  },
  {
    "codigo":3759007,
    "descripcion":"LESIÓN TRAUMÁTICA DE CORAZÓN CON HERIDA ABIERTA HACIA TÓRAX"
  },
  {
    "codigo":427908002,
    "descripcion":"ENFERMEDAD PULMONAR RESTRICTIVA POR CIFOESCOLIOSIS"
  },
  {
    "codigo":1279876004,
    "descripcion":"SÍNDROME DE CORDÓN CENTRAL DE MÉDULA LUMBAR DEBIDO A FRACTURA VERTEBRAL EXPUESTA"
  },
  {
    "codigo":15696841000119106,
    "descripcion":"OSTEOMIELITIS DE AMBOS TOBILLOS"
  },
  {
    "codigo":296836005,
    "descripcion":"SOBREDOSIS DE TIOURACILO"
  },
  {
    "codigo":295001004,
    "descripcion":"ALERGIA A BUMETANIDA"
  },
  {
    "codigo":194862000,
    "descripcion":"HEMOPERICARDIO DEBIDO A INFARTO AGUDO DE MIOCARDIO Y POSTERIOR A ÉL"
  },
  {
    "codigo":31022000,
    "descripcion":"EXOTROPÍA MONOCULAR CON PATRÓN X Y\/O Y"
  },
  {
    "codigo":131161009,
    "descripcion":"GRUPO SANGUÍNEO B>EL<"
  },
  {
    "codigo":1088611000119103,
    "descripcion":"DIVISIÓN CONGÉNITA DE LÓBULO DE LA OREJA IZQUIERDA"
  },
  {
    "codigo":293166008,
    "descripcion":"REACCIÓN ADVERSA A LA DEXAMETASONA"
  },
  {
    "codigo":225795001,
    "descripcion":"ESTÁ INFORMADO"
  },
  {
    "codigo":29187000,
    "descripcion":"INFECCIÓN CAUSADA POR LAGOCHILASCARIS"
  },
  {
    "codigo":94723004,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL NERVIO ACCESORIO"
  },
  {
    "codigo":291331005,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ACETILCISTEÍNA"
  },
  {
    "codigo":289496000,
    "descripcion":"ARDOR DE VULVA"
  },
  {
    "codigo":92888002,
    "descripcion":"FORMA ANORMAL CONGÉNITA DE VÁLVULA AÓRTICA"
  },
  {
    "codigo":387800004,
    "descripcion":"ESPONDILOSIS CERVICAL"
  },
  {
    "codigo":125656008,
    "descripcion":"HERIDA ABIERTA DE LA UÑA DE DEDO PULGAR"
  },
  {
    "codigo":1336237001,
    "descripcion":"EPISODIO DE USO NOCIVO DE NICOTINA"
  },
  {
    "codigo":1303469003,
    "descripcion":"ASA VASCULAR PREPAPILAR ADQUIRIDA"
  },
  {
    "codigo":254893005,
    "descripcion":"CARCINOMA DE VAGINA"
  },
  {
    "codigo":123821009,
    "descripcion":"PRESIÓN ANORMAL DEL OXÍGENO EN SANGRE"
  },
  {
    "codigo":23682002,
    "descripcion":"AMOR"
  },
  {
    "codigo":285826006,
    "descripcion":"INCAPAZ DE CERRAR LAS CANILLAS DE AGUA"
  },
  {
    "codigo":54615002,
    "descripcion":"ENFERMEDAD DE MARTIN DU PAN - RUTISHAUER"
  },
  {
    "codigo":87383005,
    "descripcion":"ANGUSTIA MATERNA"
  },
  {
    "codigo":251223006,
    "descripcion":"ONDA P ELEVADA"
  },
  {
    "codigo":249388005,
    "descripcion":"FRENILLO LINGUAL CORTO"
  },
  {
    "codigo":413228005,
    "descripcion":"ESOFAGITIS GRADO IV"
  },
  {
    "codigo":11793661000119106,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO DE DEDO DE PIE IZQUIERDO (SEGUNDO A QUINTO)"
  },
  {
    "codigo":282156008,
    "descripcion":"INCAPAZ DE CAMINAR PENDIENTE ARRIBA"
  },
  {
    "codigo":247553002,
    "descripcion":"PELOS EN CLAVA"
  },
  {
    "codigo":1163222004,
    "descripcion":"LESIÓN POR PRESIÓN GRADO 3"
  },
  {
    "codigo":442326005,
    "descripcion":"EFLUENTE DE DIÁLISIS PERITONEAL TURBIO"
  },
  {
    "codigo":278486006,
    "descripcion":"ABSCESO ENTRE ASAS INTESTINALES"
  },
  {
    "codigo":737238004,
    "descripcion":"CONMOCIÓN DE MÉDULA ESPINAL LUMBAR"
  },
  {
    "codigo":702635003,
    "descripcion":"HEMODIÁLISIS INADECUADA"
  },
  {
    "codigo":243883003,
    "descripcion":"ESTADO DE APTITUD PARA CONDUCIR"
  },
  {
    "codigo":211115004,
    "descripcion":"PICADURA DE INSECTO, NO VENENOSO, EN LA VULVA"
  },
  {
    "codigo":1259691003,
    "descripcion":"COREA DEBIDA A ATAXIA HEREDITARIA"
  },
  {
    "codigo":473259005,
    "descripcion":"QUEMADURA DE TERCER GRADO DE MÚLTIPLES SITIOS DE LA CABEZA SIN COMPROMISO DEL OJO PROPIAMENTE DICHO"
  },
  {
    "codigo":276651009,
    "descripcion":"HEMORRAGIA SUBEPENDIMARIA PERINATAL CON EXTENSIÓN INTRAVENTRICULAR"
  },
  {
    "codigo":209280003,
    "descripcion":"FRACTURA-LUXACIÓN EXPUESTA PERISEMILUNAR (DORSAL)"
  },
  {
    "codigo":78208005,
    "descripcion":"CIRROSIS PIGMENTARIA"
  },
  {
    "codigo":405888005,
    "descripcion":"FENOTIPO S+S+"
  },
  {
    "codigo":305749000,
    "descripcion":"ATENDIDO POR ENFERMERA ESPECIALISTA EN REUMATOLOGÍA"
  },
  {
    "codigo":240213002,
    "descripcion":"PROLAPSO DE DISCO INTERVERTEBRAL SIN MIELOPATÍA"
  },
  {
    "codigo":404053004,
    "descripcion":"RABDOMIOSARCOMA ALVEOLAR"
  },
  {
    "codigo":76373006,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DEL PIE, SIN INFECCIÓN"
  },
  {
    "codigo":762666001,
    "descripcion":"PSEUDOMIOTONÍA"
  },
  {
    "codigo":402218002,
    "descripcion":"ECCEMA VESICULAR CRÓNICO DE MANOS"
  },
  {
    "codigo":860970003,
    "descripcion":"GLOBO OCULAR PROPIAMENTE DICHO NORMAL"
  },
  {
    "codigo":238378003,
    "descripcion":"FOLICULITIS DEL CUERO CABELLUDO"
  },
  {
    "codigo":369450004,
    "descripcion":"TUMOR MALIGNO QUE COMPROMETE EL RECTO POR PROPAGACIÓN DIRECTA DEL OVARIO"
  },
  {
    "codigo":1186815004,
    "descripcion":"ENCEFALOPATÍA POR DEFICIENCIA DE VITAMINA B12"
  },
  {
    "codigo":236543006,
    "descripcion":"ARTRITIS DEBIDA A AMILOIDOSIS ASOCIADA A HEMODIÁLISIS"
  },
  {
    "codigo":302079008,
    "descripcion":"HALLAZGO RELACIONADO CON EL ESTADO EN EL MOMENTO DEL NACIMIENTO"
  },
  {
    "codigo":1119444001,
    "descripcion":"ATROFIA DE MÚSCULO DE BRAZO"
  },
  {
    "codigo":365780003,
    "descripcion":"NIVEL DE HORMONA SEXUAL EN ORINA - HALLAZGO"
  },
  {
    "codigo":5332004,
    "descripcion":"CRISIS OCULÓGIRA"
  },
  {
    "codigo":201940003,
    "descripcion":"ARTROPATÍA TRAUMÁTICA DE MÚLTIPLES LOCALIZACIONES"
  },
  {
    "codigo":726228007,
    "descripcion":"DISTENSIÓN DE MÚSCULO ADUCTOR DE MUSLO"
  },
  {
    "codigo":300244008,
    "descripcion":"LENGUA SIMÉTRICA"
  },
  {
    "codigo":11822641000119107,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN AXILA IZQUIERDA CON INFECCIÓN"
  },
  {
    "codigo":298409005,
    "descripcion":"SIN FLEXIÓN ACTIVA DE LA COLUMNA CERVICAL"
  },
  {
    "codigo":167337007,
    "descripcion":"MICROSCOPIA URINARIA: CILINDROS EPITELIALES"
  },
  {
    "codigo":722558002,
    "descripcion":"PARKINSONISMO POSTERIOR A INFECCIÓN"
  },
  {
    "codigo":1091121000119109,
    "descripcion":"OTITIS EXTERNA CRÓNICA DE CONDUCTO AUDITIVO EXTERNO DERECHO"
  },
  {
    "codigo":67198005,
    "descripcion":"TAQUICARDIA SUPRAVENTRICULAR PAROXÍSTICA"
  },
  {
    "codigo":296574005,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE PROGUANIL"
  },
  {
    "codigo":1148542004,
    "descripcion":"SOBREDOSIS INTENCIONAL DE ÁCIDO NICOTÍNICO"
  },
  {
    "codigo":1279614008,
    "descripcion":"HERIDA CORTANTE DE PIEL DE DEDO ÍNDICE"
  },
  {
    "codigo":34430009,
    "descripcion":"RUPTURA DEL ÚTERO"
  },
  {
    "codigo":65363002,
    "descripcion":"OTITIS MEDIA"
  },
  {
    "codigo":32595002,
    "descripcion":"MONONEURITIS"
  },
  {
    "codigo":294739009,
    "descripcion":"ALERGIA A BIGUANIDA"
  },
  {
    "codigo":292904004,
    "descripcion":"REACCIÓN ADVERSA A TINTURA DESINFECTANTE"
  },
  {
    "codigo":1144872007,
    "descripcion":"APLASIA DE TERCIO SUPERIOR DE VAGINA"
  },
  {
    "codigo":127229000,
    "descripcion":"NEOPLASIA DE LA AMÍGDALA LINGUAL"
  },
  {
    "codigo":30760008,
    "descripcion":"DEDOS DE LA MANO HIPOCRÁTICOS"
  },
  {
    "codigo":94461002,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL CUERPO PARAÓRTICO"
  },
  {
    "codigo":1306877003,
    "descripcion":"GLAUCOMA DE ÁNGULO ABIERTO DE OJO DERECHO DEBIDO A CIRUGÍA OCULAR"
  },
  {
    "codigo":782589005,
    "descripcion":"ALERGIA A PARAFINA AMARILLA"
  },
  {
    "codigo":291069005,
    "descripcion":"INTOXICACIÓN POR KETAZOLAM"
  },
  {
    "codigo":717053007,
    "descripcion":"SÍNDROME DE TUBULOPATÍA RENAL CON ENCEFALOPATÍA E INSUFICIENCIA HEPÁTICA"
  },
  {
    "codigo":225533009,
    "descripcion":"CONDUCTA SEXUAL DESINHIBIDA"
  },
  {
    "codigo":289234003,
    "descripcion":"TERCERA ETAPA DEL TRABAJO DE PARTO PROLONGADA"
  },
  {
    "codigo":92626003,
    "descripcion":"CARCINOMA IN SITU DE LABIOS VULVARES MENORES"
  },
  {
    "codigo":10976971000119109,
    "descripcion":"SOBREDOSIS DE METANFETAMINA"
  },
  {
    "codigo":418471000,
    "descripcion":"PROPENSIÓN A PRESENTAR REACCIONES ADVERSAS A LOS ALIMENTOS"
  },
  {
    "codigo":1303207001,
    "descripcion":"FRACTURA ÓSEA ADYACENTE A PRÓTESIS DE CODO"
  },
  {
    "codigo":715218009,
    "descripcion":"HIPERPARATIROIDISMO NEONATAL PRIMARIO SEVERO"
  },
  {
    "codigo":1335975002,
    "descripcion":"GLAUCOMA DEBIDO A QUISTE DE CUERPO CILIAR"
  },
  {
    "codigo":90791004,
    "descripcion":"ATAXIA POSTHEMIPLÉJICA"
  },
  {
    "codigo":123559005,
    "descripcion":"ANOMALÍA CONGÉNITA DEL RADIO"
  },
  {
    "codigo":254631008,
    "descripcion":"CARCINOMA GIGANTOCELULAR DE PULMÓN"
  },
  {
    "codigo":1137532001,
    "descripcion":"CALCIFICACIÓN PUNTEADA DE EPÍFISIS DE FALANGE PROXIMAL DE DEDO GORDO"
  },
  {
    "codigo":187260009,
    "descripcion":"SECUELAS DE HEPATITIS VIRAL"
  },
  {
    "codigo":87121004,
    "descripcion":"SÍNDROME DE LA LARVA MIGRATORIA VISCERAL"
  },
  {
    "codigo":283729006,
    "descripcion":"MORDEDURA HUMANA EN DEDO DEL PIE"
  },
  {
    "codigo":486168421000119108,
    "descripcion":"MELANOMA IN SITU DE PIEL DE HOMBRO DERECHO"
  },
  {
    "codigo":19750001,
    "descripcion":"SEUDOLINFOMA"
  },
  {
    "codigo":609574004,
    "descripcion":"DIABETES DEL ADULTO DE INICIO JUVENIL, TIPO 7"
  },
  {
    "codigo":10678271000119103,
    "descripcion":"TUMEFACCIÓN LOCALIZADA DE DEDO DE PIE IZQUIERDO"
  },
  {
    "codigo":314662007,
    "descripcion":"LESIÓN TRAUMÁTICA CRANEOENCEFÁLICA GRAVE"
  },
  {
    "codigo":312827000,
    "descripcion":"OCLUSIÓN DE LA PORCIÓN DISTAL DE LA ARTERIA FEMORAL"
  },
  {
    "codigo":773414009,
    "descripcion":"ENFERMEDAD DE CHARCOT-MARIE-TOOTH INTERMEDIA AUTOSÓMICA RECESIVA TIPO C"
  },
  {
    "codigo":1363238007,
    "descripcion":"QUISTE CEREBRAL CONGÉNITO"
  },
  {
    "codigo":445734009,
    "descripcion":"FRACTURA DE CUERPO DE VÉRTEBRA"
  },
  {
    "codigo":443899007,
    "descripcion":"INFLAMACIÓN AUTOINMUNITARIA DE MÚSCULO ESQUELÉTICO"
  },
  {
    "codigo":835280000,
    "descripcion":"AGUDEZA VISUAL DE OJO DERECHO 6\/9"
  },
  {
    "codigo":704208000,
    "descripcion":"FRACTURA NO EXPUESTA DE EPÍFISIS PROXIMAL DE RADIO"
  },
  {
    "codigo":735141001,
    "descripcion":"EN TRATAMIENTO FARMACOLÓGICO CONTRA LA DEMENCIA"
  },
  {
    "codigo":1259429004,
    "descripcion":"NEUROBLASTOMA PARAESPINAL PRIMARIO"
  },
  {
    "codigo":472997005,
    "descripcion":"INTERÉS ERÓTICO DISMINUIDO"
  },
  {
    "codigo":702373006,
    "descripcion":"MIOPATÍA HEREDITARIA CON INSUFICIENCIA RESPIRATORIA TEMPRANA"
  },
  {
    "codigo":276389007,
    "descripcion":"MATERIA FECAL PEQUEÑA"
  },
  {
    "codigo":15648921000119102,
    "descripcion":"ANEURISMA DE ARTERIA SUBCLAVIA IZQUIERDA"
  },
  {
    "codigo":307322002,
    "descripcion":"RUPTURA DE ARTERIA RADIAL"
  },
  {
    "codigo":241786005,
    "descripcion":"EFECTO TÓXICO CAUSADO POR FUNGICIDA"
  },
  {
    "codigo":209018006,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN METATARSOFALÁNGICA, ÚNICA"
  },
  {
    "codigo":733306008,
    "descripcion":"DEFORMIDAD DE PARTES BLANDAS DE ÓRBITA"
  },
  {
    "codigo":895311007,
    "descripcion":"FORMA DE BALA ANORMAL CONGÉNITA DE FALANGE MEDIA DE DEDO MEDIO"
  },
  {
    "codigo":305487007,
    "descripcion":"BAJO ATENCIÓN DE CITOGENETISTA CLÍNICO"
  },
  {
    "codigo":10575009,
    "descripcion":"FRACTURA EXPUESTA DE LA COLUMNA VERTEBRAL CON LESIÓN TRAUMÁTICA DE LA MÉDULA ESPINAL"
  },
  {
    "codigo":238116003,
    "descripcion":"DEFICIENCIA DE CLORO"
  },
  {
    "codigo":205348007,
    "descripcion":"TORSIÓN CONGÉNITA DE LOS DEDOS DE LOS PIES"
  },
  {
    "codigo":762404008,
    "descripcion":"FISURA DE PALADAR DURO CON FISURA LABIAL DERECHA"
  },
  {
    "codigo":170745003,
    "descripcion":"DIABÉTICO TRATADO SOLAMENTE CON DIETA"
  },
  {
    "codigo":365518001,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA RECONOCER OBJETOS"
  },
  {
    "codigo":398286002,
    "descripcion":"REGULACIÓN - NO SE DETECTÓ ASPIRACIÓN"
  },
  {
    "codigo":168910002,
    "descripcion":"ARTROGRAFÍA DE RODILLA NORMAL"
  },
  {
    "codigo":11307161000119109,
    "descripcion":"FRACTURA TRANSVERSAL NO EXPUESTA Y DE PARED POSTERIOR DE ACETÁBULO DERECHO"
  },
  {
    "codigo":68771000,
    "descripcion":"INFECCIÓN CAUSADA POR THEILERIA"
  },
  {
    "codigo":97981000146105,
    "descripcion":"PORTADOR DE STENOTROPHOMONAS MALTOPHILIA RESISTENTE A MÚLTIPLES FÁRMACOS"
  },
  {
    "codigo":789667003,
    "descripcion":"FLEBITIS POSTERIOR A TRANSFUSIÓN"
  },
  {
    "codigo":298147006,
    "descripcion":"DEFORMIDAD ARTICULAR MÚLTIPLE"
  },
  {
    "codigo":722296002,
    "descripcion":"SÍNDROME DE BOOK"
  },
  {
    "codigo":34168003,
    "descripcion":"EVENTRACIÓN DEL DIAFRAGMA"
  },
  {
    "codigo":66936004,
    "descripcion":"TRASTORNO DE LA IDENTIDAD"
  },
  {
    "codigo":31181000119100,
    "descripcion":"DESPRENDIMIENTO DE RETINA ANTIGUO"
  },
  {
    "codigo":294477004,
    "descripcion":"ALERGIA A TRIMETOPRIMA"
  },
  {
    "codigo":720461006,
    "descripcion":"INSUFICIENCIA HEPÁTICA INFANTIL AGUDA DEBIDA A DEFECTO DE LA SÍNTESIS DE PROTEÍNA CODIFICADA POR ÁCIDO DESOXIRRIBONUCLEICO MITOCONDRIAL"
  },
  {
    "codigo":292642008,
    "descripcion":"REACCIÓN ADVERSA A PANTALLAS SOLARES"
  },
  {
    "codigo":126967000,
    "descripcion":"NEOPLASIA DEL NERVIO OLFATORIO"
  },
  {
    "codigo":28663008,
    "descripcion":"TRASTORNO BIPOLAR I MANÍACO GRAVE CON SÍNTOMAS PSICÓTICOS"
  },
  {
    "codigo":125132005,
    "descripcion":"DENSIDAD RADIOLÓGICA ANORMAL, NODULAR"
  },
  {
    "codigo":878796005,
    "descripcion":"SORDERA PARCIAL TRANSITORIA"
  },
  {
    "codigo":288972007,
    "descripcion":"NO ESCUPE"
  },
  {
    "codigo":418209000,
    "descripcion":"DISFOTOPSIA"
  },
  {
    "codigo":92364005,
    "descripcion":"NEOPLASIA BENIGNA DE PIEL DE INGLE"
  },
  {
    "codigo":26828006,
    "descripcion":"RECTOCELE QUE AFECTA AL EMBARAZO"
  },
  {
    "codigo":1237409004,
    "descripcion":"UTILIZA PRESERVATIVO COMO MÉTODO DE PROTECCIÓN EN LAS RELACIONES SEXUALES"
  },
  {
    "codigo":287137008,
    "descripcion":"QUEMADURA DE CÓRNEA - AMPOLLA"
  },
  {
    "codigo":285302001,
    "descripcion":"QUISTE CUTÁNEO"
  },
  {
    "codigo":15979111000119103,
    "descripcion":"MALFORMACIÓN CONGÉNITA DE HUESECILLOS DE OÍDO IZQUIERDO"
  },
  {
    "codigo":1268342009,
    "descripcion":"RESORCIÓN INTERNA PROGRESIVA DE DIENTE CAUSADA POR BACTERIAS"
  },
  {
    "codigo":711286009,
    "descripcion":"DERRAME ARTICULAR INTERMITENTE"
  },
  {
    "codigo":86859003,
    "descripcion":"ANEMIA POR DEFICIENCIA DE VARIANTE ENZIMÁTICA DE GLUCOSA-6-FOSFATO DESHIDROGENASA"
  },
  {
    "codigo":21323007,
    "descripcion":"CALCINOSIS CUTÁNEA"
  },
  {
    "codigo":283467008,
    "descripcion":"HERIDA PUNZANTE EN EL DORSO DE LA MANO"
  },
  {
    "codigo":445472003,
    "descripcion":"EDEMA LINFOVENOSO"
  },
  {
    "codigo":17653001,
    "descripcion":"TUBERCULOSIS DE HUESOS Y\/O ARTICULACIONES"
  },
  {
    "codigo":332391000119108,
    "descripcion":"RETINOPATÍA POR PREMATUREZ DEL OJO DERECHO ETAPA 1 - LÍNEA DE DEMARCACIÓN"
  },
  {
    "codigo":109747007,
    "descripcion":"DIENTE PARTIDO"
  },
  {
    "codigo":409034007,
    "descripcion":"ALTERACIÓN DE LA CONDUCTA DEL RECIÉN NACIDO"
  },
  {
    "codigo":703946008,
    "descripcion":"IRRITACIÓN DE CLÍTORIS"
  },
  {
    "codigo":734879002,
    "descripcion":"ANEURISMA ROTO DE ARTERIA COMUNICANTE POSTERIOR DERECHA"
  },
  {
    "codigo":308895003,
    "descripcion":"HEMORRAGIA REACTIVA LUEGO DE PROCEDIMIENTO"
  },
  {
    "codigo":276127003,
    "descripcion":"LA ESPOSA ABANDONÓ EL HOGAR"
  },
  {
    "codigo":210591005,
    "descripcion":"SECCIÓN PARCIAL, TENDÓN DEL FLEXOR SUPERFICIAL DE LOS DEDOS DE LA MANO"
  },
  {
    "codigo":865951006,
    "descripcion":"COLANGIOCARCINOMA DE CONDUCTO BILIAR PERIHILIAR"
  },
  {
    "codigo":405364002,
    "descripcion":"BLOQUEO CON ANESTESIA LOCAL INADECUADO"
  },
  {
    "codigo":765812004,
    "descripcion":"AUSENCIA CONGÉNITA DE VENA BRAQUIOCEFÁLICA"
  },
  {
    "codigo":896884005,
    "descripcion":"FORMA ANCHA ANORMAL CONGÉNITA DE FALANGE DISTAL DE SEGUNDO DEDO DE PIE"
  },
  {
    "codigo":700276006,
    "descripcion":"ECTROPIÓN ESPÁSTICO DE PÁRPADO INFERIOR"
  },
  {
    "codigo":733044009,
    "descripcion":"DERMATOLEUCODISTROFIA"
  },
  {
    "codigo":44916009,
    "descripcion":"FRACTURA DE LE FORT, TIPO II"
  },
  {
    "codigo":1255497002,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO DE DEDO ANULAR DE MANO IZQUIERDA"
  },
  {
    "codigo":403529008,
    "descripcion":"ENVEJECIMIENTO INTRÍNSECO DE LA PIEL"
  },
  {
    "codigo":237854004,
    "descripcion":"BRECHA ANIÓNICA AUMENTADA"
  },
  {
    "codigo":236019001,
    "descripcion":"NEOPLASIA DE PERITONEO Y RETROPERITONEO"
  },
  {
    "codigo":170483003,
    "descripcion":"PORTADOR DEL CÓLERA"
  },
  {
    "codigo":301555004,
    "descripcion":"DIFICULTAD PARA LEVANTARSE DEL INODORO"
  },
  {
    "codigo":135880000,
    "descripcion":"EN EL REGISTRO NACIONAL DE SISTEMA DE SALUD MENTAL"
  },
  {
    "codigo":234184000,
    "descripcion":"FILTRACIÓN PARAVALVULAR DE PRÓTESIS CARDÍACA"
  },
  {
    "codigo":299720002,
    "descripcion":"PREFERENCIA DE MANO IZQUIERDA"
  },
  {
    "codigo":1348296003,
    "descripcion":"PARTO CON ANESTESIA RAQUÍDEA"
  },
  {
    "codigo":266952004,
    "descripcion":"COMENZÓ UNA AVENTURA AMOROSA"
  },
  {
    "codigo":365256001,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA PREPARAR COMIDA"
  },
  {
    "codigo":68509000,
    "descripcion":"MORTINATO INMADURO DE SEXO FEMENINO (500 - 999 GRAMOS)"
  },
  {
    "codigo":723869004,
    "descripcion":"OCLUSIÓN AGUDA DE ARTERIA AORTOILÍACA CONCOMITANTE CON TROMBOEMBOLIA Y DEBIDA A ELLA"
  },
  {
    "codigo":363421004,
    "descripcion":"NEOPLASIA MALIGNA DEL EPIPLÓN MAYOR"
  },
  {
    "codigo":232349006,
    "descripcion":"ALERGIA A POLVO DOMÉSTICO"
  },
  {
    "codigo":296050001,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE SECOBARBITAL"
  },
  {
    "codigo":722034006,
    "descripcion":"NÓDULO DE LABIO SUPERIOR, LÍNEA MEDIA"
  },
  {
    "codigo":1344626008,
    "descripcion":"OSTEOMIELITIS DE CODO"
  },
  {
    "codigo":33906009,
    "descripcion":"ENTERITIS ISQUÉMICA AGUDA"
  },
  {
    "codigo":294215003,
    "descripcion":"ALERGIA A COLCHICINA"
  },
  {
    "codigo":359751003,
    "descripcion":"IMPÉTIGO CAUSADO POR STAPHYLOCOCCUS AUREUS"
  },
  {
    "codigo":195911009,
    "descripcion":"NEUMONÍA CAUSADA POR EL VIRUS DE LA VARICELA"
  },
  {
    "codigo":95772002,
    "descripcion":"DRENAJE ORBITARIO POSENUCLEACIÓN"
  },
  {
    "codigo":292380003,
    "descripcion":"REACCIÓN ADVERSA AL DECANOATO DE HALOPERIDOL"
  },
  {
    "codigo":128540005,
    "descripcion":"TRASTORNO DE LA AUDICIÓN"
  },
  {
    "codigo":1144348007,
    "descripcion":"HIPOPLASIA CONGÉNITA DE PUENTE NASAL"
  },
  {
    "codigo":61169001,
    "descripcion":"OBSTRUCCIÓN DE LA LARINGE"
  },
  {
    "codigo":28401004,
    "descripcion":"HIPERTROFIA DE LA GLÁNDULA SUBMAXILAR"
  },
  {
    "codigo":126705004,
    "descripcion":"NEOPLASIA DE BRONQUIO"
  },
  {
    "codigo":225009008,
    "descripcion":"SE SIENTE PERDIDO"
  },
  {
    "codigo":10630351000119102,
    "descripcion":"LINFANGITIS AGUDA DE AXILA IZQUIERDA"
  },
  {
    "codigo":124870002,
    "descripcion":"DISMINUCIÓN DE LOS SITIOS RECEPTORES"
  },
  {
    "codigo":190406000,
    "descripcion":"CETOACIDOSIS DEBIDA A DIABETES MELLITUS RELACIONADA CON DESNUTRICIÓN"
  },
  {
    "codigo":334901000119109,
    "descripcion":"DESPRENDIMIENTO HEMORRÁGICO DE COROIDES DERECHA"
  },
  {
    "codigo":288710003,
    "descripcion":"NO SE COMUNICA EN DIFERENTES OCASIONES"
  },
  {
    "codigo":712859002,
    "descripcion":"PERICARDITIS CAUSADA POR TOXINA"
  },
  {
    "codigo":450715004,
    "descripcion":"GRIPE CAUSADA POR VIRUS INFLUENZA A SUBTIPO H7"
  },
  {
    "codigo":308431000119105,
    "descripcion":"GRANULOMA POR CUERPO EXTRAÑO DE PARTES BLANDAS DE TOBILLO DERECHO"
  },
  {
    "codigo":55664001,
    "descripcion":"OTOESCLEROSIS OBLITERANTE QUE COMPROMETE A LA VENTANA OVAL"
  },
  {
    "codigo":283205000,
    "descripcion":"ANZUELO EN EL PULGAR"
  },
  {
    "codigo":447045002,
    "descripcion":"ABSCESO DE REGIÓN PARAUMBILICAL"
  },
  {
    "codigo":21061004,
    "descripcion":"BABESIOSIS"
  },
  {
    "codigo":86597007,
    "descripcion":"PENSAMIENTO ILÓGICO"
  },
  {
    "codigo":16037071000119108,
    "descripcion":"DETENCIÓN PARCIAL DE CRECIMIENTO EPIFISARIO DE AMBAS TIBIAS DISTALES"
  },
  {
    "codigo":281370001,
    "descripcion":"HEMARTROSIS ESPONTÁNEA"
  },
  {
    "codigo":314138001,
    "descripcion":"NITRITO URINARIO NEGATIVO"
  },
  {
    "codigo":707354003,
    "descripcion":"CARCINOMA PRIMARIO DE CÉLULAS ESCAMOSAS DE SENO MAXILAR"
  },
  {
    "codigo":1231642002,
    "descripcion":"ILUSIÓN DE PULFRICH"
  },
  {
    "codigo":11996521000119103,
    "descripcion":"DOLOR EN MUÑÓN DE AMPUTACIÓN DE EXTREMIDAD SUPERIOR IZQUIERDA"
  },
  {
    "codigo":248602007,
    "descripcion":"AUSENCIA DE ESPUTO"
  },
  {
    "codigo":838426009,
    "descripcion":"REACCIÓN ADVERSA CUTÁNEA A ACEITE VOLÁTIL"
  },
  {
    "codigo":246767003,
    "descripcion":"MOVIMIENTO SACÁDICO ANORMAL DEL OJO"
  },
  {
    "codigo":50159004,
    "descripcion":"RESISTENCIA CAPILAR DISMINUIDA"
  },
  {
    "codigo":769220000,
    "descripcion":"EDEMA MACULAR DEBIDO A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":408772003,
    "descripcion":"ECOGRAFÍA DE CABEZA FETAL, NORMAL"
  },
  {
    "codigo":210329003,
    "descripcion":"HERIDA ABIERTA DE SENO NASAL"
  },
  {
    "codigo":110190002,
    "descripcion":"QUEMADURA DE MUCOSA YUGAL"
  },
  {
    "codigo":10051000,
    "descripcion":"FACIES MITRAL"
  },
  {
    "codigo":77422009,
    "descripcion":"RESONANCIA NORMAL"
  },
  {
    "codigo":403267005,
    "descripcion":"VITILIGO LOCALIZADO"
  },
  {
    "codigo":1288003006,
    "descripcion":"CARCINOMA MEDULAR TIROIDEO PRIMARIO"
  },
  {
    "codigo":763715007,
    "descripcion":"HIPERPROLACTINEMIA FAMILIAR"
  },
  {
    "codigo":1074691000119105,
    "descripcion":"ARTRITIS DE CODO IZQUIERDO"
  },
  {
    "codigo":1255235009,
    "descripcion":"POSICIÓN ANÓMALA DE PRÓTESIS DE ARTICULACIÓN DE CADERA"
  },
  {
    "codigo":370499007,
    "descripcion":"HIDROMETRA"
  },
  {
    "codigo":1220632004,
    "descripcion":"INTERRUPCIÓN INDUCIDA DEL EMBARAZO INCOMPLETA COMPLICADA POR DAÑO A ÓRGANOS O TEJIDOS PÉLVICOS"
  },
  {
    "codigo":237592006,
    "descripcion":"SECRECIÓN ANORMAL DE BOMBESINA"
  },
  {
    "codigo":235757002,
    "descripcion":"COLITIS CRÓNICA POR RADIACIÓN"
  },
  {
    "codigo":301293005,
    "descripcion":"HALLAZGO RELACIONADO CON EL OLOR DEL ESPUTO"
  },
  {
    "codigo":202989006,
    "descripcion":"ABSCESO DE TENDÓN DE MANO"
  },
  {
    "codigo":1251565009,
    "descripcion":"ENFERMEDAD NEOPLÁSICA MALIGNA REFRACTARIA"
  },
  {
    "codigo":364994002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA UTILIZAR LOS PROCESOS FONOLÓGICOS"
  },
  {
    "codigo":299458004,
    "descripcion":"ARTICULACIÓN DE TOBILLO - FRÍA"
  },
  {
    "codigo":168386007,
    "descripcion":"HELICOBACTER PYLORI NO DETECTADO POR PRUEBA RÁPIDA DE UREASA"
  },
  {
    "codigo":233922008,
    "descripcion":"VÍA ACCESORIA ESCONDIDA"
  },
  {
    "codigo":363159003,
    "descripcion":"INFECCIÓN DE AXILA"
  },
  {
    "codigo":15957661000119104,
    "descripcion":"NEOPLASIA BENIGNA DE AMBOS RIÑONES"
  },
  {
    "codigo":295788000,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE VINBLASTINA"
  },
  {
    "codigo":232087009,
    "descripcion":"GLAUCOMA CON HEMORRAGIA INTRAOCULAR"
  },
  {
    "codigo":197484002,
    "descripcion":"DESNUTRICIÓN POSCIRUGÍA DEL TRACTO GASTROINTESTINAL"
  },
  {
    "codigo":33644002,
    "descripcion":"SÍNDROME POSVALVULOTOMÍA"
  },
  {
    "codigo":721772005,
    "descripcion":"INFECCIÓN CAUSADA POR ROSEOLOVIRUS"
  },
  {
    "codigo":263020006,
    "descripcion":"LUXACIÓN DE ARTICULACIÓN ESCAPULODORSAL"
  },
  {
    "codigo":230252006,
    "descripcion":"ATROFIA MUSCULAR ESPINAL OCULOFARÍNGEA"
  },
  {
    "codigo":310941000119106,
    "descripcion":"DERRAME INTERMITENTE DE ARTICULACIÓN DE REGIÓN DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":164716009,
    "descripcion":"PROCEDIMIENTO DE DIAGNÓSTICO NEUROLÓGICO - NORMAL"
  },
  {
    "codigo":598081000005100,
    "descripcion":"DEJÓ DE FUMAR DESPUÉS DEL PRIMER TRIMESTRE"
  },
  {
    "codigo":147101000119108,
    "descripcion":"ASTROCITOMA MALIGNO PRIMARIO DE SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":161046000,
    "descripcion":"DISCAPACIDAD FÍSICA CRÓNICA"
  },
  {
    "codigo":228417008,
    "descripcion":"PRIORIDAD INDEBIDA OTORGADA A LAS ACTIVIDADES RELACIONADAS CON EL CONSUMO DE DROGAS"
  },
  {
    "codigo":292118005,
    "descripcion":"REACCIÓN ADVERSA AL ÁCIDO 5-AMINOSALICÍLICO"
  },
  {
    "codigo":62742006,
    "descripcion":"COSTRA LÁCTEA"
  },
  {
    "codigo":16013111000119103,
    "descripcion":"TROMBOSIS DE ARTERIA FEMORAL COMÚN DERECHA"
  },
  {
    "codigo":128278008,
    "descripcion":"LINFANGITIS AGUDA DE LA ESPALDA"
  },
  {
    "codigo":11835191000119103,
    "descripcion":"SUBLUXACIÓN DE PULGAR IZQUIERDO"
  },
  {
    "codigo":1142251004,
    "descripcion":"HIPERTROFIA DE MÚSCULO DE EXTREMIDAD INFERIOR DERECHA"
  },
  {
    "codigo":93675008,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA PARED ANTERIOR DE LA VEJIGA"
  },
  {
    "codigo":880107009,
    "descripcion":"INGESTA INADECUADA DE TIAMINA"
  },
  {
    "codigo":124608006,
    "descripcion":"DEFICIENCIA DE FRUCTOSA - BIFOSFATO ALDOLASA"
  },
  {
    "codigo":288448007,
    "descripcion":"CAPAZ DE REALIZAR ACTIVIDADES DE COPIADO"
  },
  {
    "codigo":286613000,
    "descripcion":"CICATRIZ POSTERIOR A HERIDA"
  },
  {
    "codigo":417685004,
    "descripcion":"DESPLAZAMIENTO POSTERIOR DEL SACRO"
  },
  {
    "codigo":122773008,
    "descripcion":"FRACTURA EXPUESTA DE EPÍFISIS DISTAL DE HÚMERO"
  },
  {
    "codigo":448618004,
    "descripcion":"ANOMALÍA DE ANILLO DE VÁLVULA MITRAL"
  },
  {
    "codigo":284778005,
    "descripcion":"DIFICULTAD PARA REALIZAR ACTIVIDAD DE CUIDADO PERSONAL"
  },
  {
    "codigo":414015000,
    "descripcion":"ENFERMEDAD CAUSADA POR ORTHOPOXVIRUS"
  },
  {
    "codigo":446783001,
    "descripcion":"USA LENTES MULTIFOCALES"
  },
  {
    "codigo":282943002,
    "descripcion":"INCAPAZ DE INCLINARSE PARA LEVANTAR UN OBJETO SIN CAERSE"
  },
  {
    "codigo":339921000119104,
    "descripcion":"GLAUCOMA DE BAJA TENSIÓN DEL OJO IZQUIERDO"
  },
  {
    "codigo":1231380007,
    "descripcion":"INFLAMACIÓN INTESTINAL CAUSADA POR SHIGELLA"
  },
  {
    "codigo":1264148008,
    "descripcion":"DAÑO DE CUELLO UTERINO POSTERIOR A EMBARAZO MOLAR"
  },
  {
    "codigo":770793002,
    "descripcion":"SÍNDROME DE MICRODUPLICACIÓN 5P13"
  },
  {
    "codigo":49897003,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL CON INFECCIÓN"
  },
  {
    "codigo":836329006,
    "descripcion":"AGUDEZA VISUAL CON AGUJERO ESTENOPEICO DE OJO IZQUIERDO 6\/24"
  },
  {
    "codigo":408510000,
    "descripcion":"PACIENTE EN ESPERA DE EQUIPAMIENTO"
  },
  {
    "codigo":441278007,
    "descripcion":"CEPA NO TIPIFICADA DE VIRUS SINCITIAL RESPIRATORIO PRESENTE"
  },
  {
    "codigo":35361000087100,
    "descripcion":"EX FUMADOR DE CIGARRILLO ELECTRÓNICO"
  },
  {
    "codigo":242835007,
    "descripcion":"SOBREDOSIS INTENCIONAL DE TEMAZEPAM"
  },
  {
    "codigo":43041000087104,
    "descripcion":"HEMATOMA DE DEDO ÍNDICE IZQUIERDO"
  },
  {
    "codigo":210067009,
    "descripcion":"LESIÓN PULMONAR NO EXPUESTA"
  },
  {
    "codigo":40481000087105,
    "descripcion":"CUERPO EXTRAÑO EN OÍDO EXTERNO DERECHO"
  },
  {
    "codigo":765288000,
    "descripcion":"SIN ATRACCIÓN SEXUAL POR LOS SEXOS MASCULINO O FEMENINO"
  },
  {
    "codigo":208232005,
    "descripcion":"FRACTURA EXPUESTA DE APÓFISIS CORACOIDES DE OMÓPLATO"
  },
  {
    "codigo":48161000087109,
    "descripcion":"FRACTURA DE PRIMER HUESO METATARSIANO DE PIE IZQUIERDO"
  },
  {
    "codigo":239165001,
    "descripcion":"GRANULOMA DE HERIDA"
  },
  {
    "codigo":15632491000119107,
    "descripcion":"SÍNDROME DE DISFUNCIÓN DOLOROSA DE LA ARTICULACIÓN TEMPOROMANDIBULAR IZQUIERDA"
  },
  {
    "codigo":697917003,
    "descripcion":"HIPERTENSIÓN PULMONAR DEBIDA A TRASTORNO HEMATOLÓGICO"
  },
  {
    "codigo":1254973007,
    "descripcion":"DEPENDENCIA DE SUSTANCIAS EN REMISIÓN"
  },
  {
    "codigo":9789007,
    "descripcion":"ESTERILIDAD NATURAL"
  },
  {
    "codigo":237330001,
    "descripcion":"LESIÓN TRAUMÁTICA OBSTÉTRICA DE VEJIGA URINARIA"
  },
  {
    "codigo":403005008,
    "descripcion":"TIÑA DE CUERO CABELLUDO CAUSADA POR TRICHOPHYTON GOURVILII"
  },
  {
    "codigo":302866003,
    "descripcion":"HIPOGLUCEMIA"
  },
  {
    "codigo":1187602003,
    "descripcion":"HALLAZGO RELACIONADO CON EL SERVICIO MILITAR"
  },
  {
    "codigo":401170005,
    "descripcion":"AÚN SIN SENTARSE"
  },
  {
    "codigo":366567005,
    "descripcion":"AMPLITUD DE MOVIMIENTO ACTIVO DE EXTENSIÓN DE LA CADERA - HALLAZGO"
  },
  {
    "codigo":233660001,
    "descripcion":"DEFECTO DE DEPURACIÓN MUCOCILIAR"
  },
  {
    "codigo":200892002,
    "descripcion":"ERUPCIÓN CUTÁNEA GENERALIZADA CAUSADA POR FÁRMACO O MEDICAMENTO"
  },
  {
    "codigo":168124002,
    "descripcion":"NO SE DETECTARON ANOMALÍAS EN EXAMEN DE ESPÉCIMEN"
  },
  {
    "codigo":69820004,
    "descripcion":"LESIÓN TRAUMÁTICA DEL QUIASMA ÓPTICO"
  },
  {
    "codigo":364732005,
    "descripcion":"HALLAZGO RELACIONADO CON EL PESO DEL CALZADO"
  },
  {
    "codigo":102588006,
    "descripcion":"DOLOR DE LA PARED TORÁCICA"
  },
  {
    "codigo":299196007,
    "descripcion":"ARTICULACIÓN DEL PULGAR ESTABLE"
  },
  {
    "codigo":231825000,
    "descripcion":"PAPILOMA DE CÉLULAS ESCAMOSAS DEL PÁRPADO"
  },
  {
    "codigo":67985002,
    "descripcion":"ANOMALÍA CONGÉNITA DEL LABERINTO MEMBRANOSO"
  },
  {
    "codigo":1075331000000107,
    "descripcion":"INCAPAZ DE MANEJAR RIESGOS EN EL HOGAR"
  },
  {
    "codigo":10664351000119101,
    "descripcion":"ÚLCERA ISQUÉMICA ATEROSCLERÓTICA DE PIERNA DERECHA"
  },
  {
    "codigo":788881005,
    "descripcion":"ACCIDENTE CEREBROVASCULAR ISQUÉMICO DEBIDO A EMBOLIA DE CAYADO AÓRTICO"
  },
  {
    "codigo":1149329005,
    "descripcion":"INTOXICACIÓN POR CITRATO"
  },
  {
    "codigo":35217003,
    "descripcion":"ENFERMEDAD DE GROSS"
  },
  {
    "codigo":33382000,
    "descripcion":"PANOFTALMITIS"
  },
  {
    "codigo":342431000119102,
    "descripcion":"FILARIASIS LINFÁTICA DE PÁRPADO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":295526001,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE ENFLURANO"
  },
  {
    "codigo":426598005,
    "descripcion":"NEFROPATÍA POR AMILOIDE DE CADENA LIVIANA"
  },
  {
    "codigo":788986271000119103,
    "descripcion":"SUMINISTRO DE AGUA POTABLE INADECUADO"
  },
  {
    "codigo":262758007,
    "descripcion":"LESIÓN TRAUMÁTICA DE CONDUCTO AUDITIVO EXTERNO"
  },
  {
    "codigo":721510008,
    "descripcion":"SÍNDROME DEL CORDÓN CENTRAL DE MÉDULA ESPINAL AL NIVEL DEL QUINTO SEGMENTO LUMBAR"
  },
  {
    "codigo":228155006,
    "descripcion":"DISCAPACIDAD PARA ALIMENTARSE"
  },
  {
    "codigo":64315007,
    "descripcion":"SÍNDROME DE DEFICIENCIA DE FACTOR MÚLTIPLE FAMILIAR, TIPO III"
  },
  {
    "codigo":129851009,
    "descripcion":"TRASTORNO EN LA EVACUACIÓN INTESTINAL"
  },
  {
    "codigo":293691009,
    "descripcion":"ALERGIA A ALVERINA"
  },
  {
    "codigo":717840005,
    "descripcion":"ESTADIO B DE INSUFICIENCIA CARDÍACA CONGESTIVA"
  },
  {
    "codigo":422928006,
    "descripcion":"SECRECIÓN CONJUNTIVAL MUCOSA"
  },
  {
    "codigo":291856005,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR TIROXINA"
  },
  {
    "codigo":95248008,
    "descripcion":"CARIES POR DISFUNCIÓN SALIVAL POSTERIOR A RADIOTERAPIA"
  },
  {
    "codigo":193552006,
    "descripcion":"GLAUCOMA DEBIDO A MALFORMACIÓN CONGÉNITA DE ÁNGULO DE CÁMARA ANTERIOR DEL OJO"
  },
  {
    "codigo":93413002,
    "descripcion":"TORACOCELOSQUISIS"
  },
  {
    "codigo":224485002,
    "descripcion":"CUIDA A UN AMIGO"
  },
  {
    "codigo":716005004,
    "descripcion":"SÍNDROME DE DIETILESTILBESTROL FETAL"
  },
  {
    "codigo":11784761000119101,
    "descripcion":"AMPOLLA TRAUMÁTICA DE SEGUNDO A QUINTO DEDO DE PIE DERECHO"
  },
  {
    "codigo":1172922003,
    "descripcion":"PROTEÍNAS SÉRICAS TOTALES POR ENCIMA DE RANGO DE REFERENCIA"
  },
  {
    "codigo":124346009,
    "descripcion":"DEFICIENCIA DE FMN ADENILILTRANSFERASA"
  },
  {
    "codigo":253583004,
    "descripcion":"PROLAPSO DE VÁLVULA TRONCAL"
  },
  {
    "codigo":56975005,
    "descripcion":"NEVO ANGIOMATOSO CUTÁNEO"
  },
  {
    "codigo":89743005,
    "descripcion":"LEUCOARAIOSIS"
  },
  {
    "codigo":286351007,
    "descripcion":"INCAPAZ DE IMITAR LA VOCALIZACIÓN"
  },
  {
    "codigo":1269391008,
    "descripcion":"SÍNDROME DE CORDÓN POSTERIOR DE MÉDULA ESPINAL DORSAL DEBIDA A SUBLUXACIÓN EXPUESTA DE ARTICULACIÓN DE COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":10965561000119105,
    "descripcion":"HERIDA POR ARMA BLANCA DE REGIÓN DE CADERA DERECHA"
  },
  {
    "codigo":284516003,
    "descripcion":"MOVIMIENTOS GIRATORIOS REPETITIVOS"
  },
  {
    "codigo":448356006,
    "descripcion":"DRENAJE DE SENO CORONARIO POR ENCIMA DE VENA CAVA SUPERIOR DERECHA"
  },
  {
    "codigo":249913002,
    "descripcion":"RODILLA RÍGIDA"
  },
  {
    "codigo":602893011000119101,
    "descripcion":"NASOFARINGITIS AGUDA CAUSADA POR VIRUS SINCICIAL RESPIRATORIO"
  },
  {
    "codigo":1003577003,
    "descripcion":"AGENESIA DE HUESO NASAL"
  },
  {
    "codigo":282681005,
    "descripcion":"DIFICULTAD PARA ALCANZAR"
  },
  {
    "codigo":315449007,
    "descripcion":"NACIDO EN ISRAEL"
  },
  {
    "codigo":86073008,
    "descripcion":"GIGANTISMO HIPERSOMATOTRÓFICO"
  },
  {
    "codigo":51470007,
    "descripcion":"PERCEPCIÓN EXTRASENSORIAL"
  },
  {
    "codigo":248078008,
    "descripcion":"NO CONOCE EL PELIGRO DEL AGUA CALIENTE"
  },
  {
    "codigo":82403002,
    "descripcion":"COLANGITIS"
  },
  {
    "codigo":311779007,
    "descripcion":"NEOPLASIA MALIGNA DE LA PIEL DE LA REGIÓN ESCAPULAR"
  },
  {
    "codigo":277176000,
    "descripcion":"MEMBRANA TIMPÁNICA TRANSLÚCIDA"
  },
  {
    "codigo":735928001,
    "descripcion":"AUSENCIA ADQUIRIDA DE MIEMBRO COMPLETO"
  },
  {
    "codigo":211640007,
    "descripcion":"CUERPO EXTRAÑO EN EL COLON TRANSVERSO"
  },
  {
    "codigo":15032008,
    "descripcion":"INFESTACIÓN CAUSADA POR DERMACENTOR"
  },
  {
    "codigo":1292984008,
    "descripcion":"TUMOR FIBROBLÁSTICO EWSR1-SMAD3 POSITIVO"
  },
  {
    "codigo":703160009,
    "descripcion":"FALLA DE PRÓTESIS DE VÁLVULA MITRAL QUE REQUIERE REVISIÓN"
  },
  {
    "codigo":13197004,
    "descripcion":"UTILIZA ANTICONCEPTIVO"
  },
  {
    "codigo":111501005,
    "descripcion":"DISTROFIA MUSCULAR HEREDITARIA CONGÉNITA"
  },
  {
    "codigo":275341005,
    "descripcion":"FRACTURA NO EXPUESTA DE TROCÁNTER MENOR DE FÉMUR"
  },
  {
    "codigo":699490000,
    "descripcion":"CARIES DENTAL CLASE II"
  },
  {
    "codigo":109666001,
    "descripcion":"ARTRITIS INFECCIOSA DE LA ARTICULACIÓN TEMPOROMANDIBULAR"
  },
  {
    "codigo":207970004,
    "descripcion":"FRACTURA EXPUESTA DE VÉRTEBRA LUMBAR, APÓFISIS TRANSVERSA"
  },
  {
    "codigo":240738006,
    "descripcion":"GRANULOMA MEDIASTÍNICO POR HISTOPLASMOSIS CLÁSICA"
  },
  {
    "codigo":371810009,
    "descripcion":"ANGINA DE PECHO RECURRENTE, LUEGO DE INJERTO-PUENTE CORONARIO"
  },
  {
    "codigo":238903002,
    "descripcion":"LIPOMATOSIS CIRCUNSCRIPTA"
  },
  {
    "codigo":42295001,
    "descripcion":"POLINEUROPATÍA AMILOIDE FAMILIAR"
  },
  {
    "codigo":1156407001,
    "descripcion":"EPENDIMOMA MIXOPAPILAR DE MÉDULA ESPINAL"
  },
  {
    "codigo":1254711005,
    "descripcion":"REQUIERE INTERVENCIÓN EN LENGUAJE CLARO PARA APOYAR EL CONOCIMIENTO SOBRE LA SALUD"
  },
  {
    "codigo":75063005,
    "descripcion":"HEMOGLOBINOPATÍA CON ERITROCITOSIS"
  },
  {
    "codigo":344941000119105,
    "descripcion":"OFTALMÍA NODOSA DE AMBOS OJOS"
  },
  {
    "codigo":402743009,
    "descripcion":"DEFECTO DE MÉDULA ESPINAL QUE AFECTA PIEL"
  },
  {
    "codigo":9527009,
    "descripcion":"SÍNDROME DE TETRASOMÍA 12P"
  },
  {
    "codigo":71816001,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE NALGA SIN INFECCIÓN"
  },
  {
    "codigo":204300001,
    "descripcion":"TRANSPOSICIÓN PARCIAL DE LOS GRANDES VASOS"
  },
  {
    "codigo":15637511000119100,
    "descripcion":"RUPTURA DEGENERATIVA DE MENISCO INTERNO DE RODILLA DERECHA"
  },
  {
    "codigo":16047111000119100,
    "descripcion":"ENFERMEDAD POR DEPÓSITO DE HIDROXIAPATITA DE AMBOS CODOS"
  },
  {
    "codigo":366305001,
    "descripcion":"HALLAZGO RELACIONADO CON LA MOVILIDAD UTERINA"
  },
  {
    "codigo":10830701000119107,
    "descripcion":"FRACTURA EXPUESTA DE LA FALANGE PROXIMAL DEL DEDO ANULAR DE LA MANO DERECHA"
  },
  {
    "codigo":71393004,
    "descripcion":"DOLORIMIENTO"
  },
  {
    "codigo":202465007,
    "descripcion":"REUMATISMO PALINDRÓMICO DE MÚLTIPLES LOCALIZACIONES"
  },
  {
    "codigo":298934000,
    "descripcion":"ARTICULACIÓN DE CODO ERITEMATOSA"
  },
  {
    "codigo":300769007,
    "descripcion":"INCAPAZ DE REALIZAR ACTIVIDADES RECREATIVAS Y DEPORTIVAS"
  },
  {
    "codigo":167862003,
    "descripcion":"EXAMEN DE LÍQUIDO SINOVIAL, NORMAL"
  },
  {
    "codigo":16237421000119109,
    "descripcion":"DISFUNCIÓN DE GLÁNDULAS DE MEIBOMIO DE AMBOS OJOS"
  },
  {
    "codigo":266166005,
    "descripcion":"PEDICULOSIS E INFECCIONES POR PTHIRIUS"
  },
  {
    "codigo":200630006,
    "descripcion":"CELULITIS Y ABSCESO DE DEDO DE LA MANO"
  },
  {
    "codigo":724918007,
    "descripcion":"LACERACIÓN DE CABEZA LARGA DE BÍCEPS BRAQUIAL"
  },
  {
    "codigo":4022007,
    "descripcion":"VULVITIS CIRCUNSCRIPTA PLASMOCELULAR"
  },
  {
    "codigo":723083001,
    "descripcion":"EFECTOS TARDÍOS DE ACCIDENTE CEREBROVASCULAR ISQUÉMICO"
  },
  {
    "codigo":67723002,
    "descripcion":"HIPOTIROIDISMO CAUSADO POR MATERIAL DE CONTRASTE RADIACTIVO"
  },
  {
    "codigo":297099008,
    "descripcion":"SOBREDOSIS DE UROCINASA"
  },
  {
    "codigo":428171009,
    "descripcion":"ENFERMEDAD VASCULAR PERIFÉRICA CON DOLOR EN REPOSO"
  },
  {
    "codigo":229728001,
    "descripcion":"TRASTORNO DE APRENDIZAJE VELOFARÍNGEO"
  },
  {
    "codigo":295264003,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE KETOROLACO"
  },
  {
    "codigo":721248004,
    "descripcion":"MIELITIS CAUSADA POR VIRUS"
  },
  {
    "codigo":426336007,
    "descripcion":"MIELOMA ÓSEO SOLITARIO"
  },
  {
    "codigo":360800009,
    "descripcion":"DEFICIENCIA DE LIPOFOSFODIESTERASA II"
  },
  {
    "codigo":293429008,
    "descripcion":"REACCIÓN ADVERSA AL CIPROFIBRATO"
  },
  {
    "codigo":1145397009,
    "descripcion":"APLASIA DE CUELLO DE FÉMUR"
  },
  {
    "codigo":129589009,
    "descripcion":"HIPERLIPEMIA ENDÓGENA"
  },
  {
    "codigo":94986003,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL LÓBULO PARIETAL"
  },
  {
    "codigo":291594000,
    "descripcion":"INTOXICACIÓN POR CEFOTAXIMA"
  },
  {
    "codigo":1340170006,
    "descripcion":"CONTUSIÓN DE CÓNDILO INTERNO DE FÉMUR"
  },
  {
    "codigo":422666006,
    "descripcion":"EPITELIOPATÍA CORNEAL POR HERPES ZÓSTER"
  },
  {
    "codigo":62218008,
    "descripcion":"POLIDACTILIA DE LOS DEDOS DEL PIE"
  },
  {
    "codigo":191455000,
    "descripcion":"DEMENCIA PRESENIL CON DEPRESIÓN"
  },
  {
    "codigo":160522006,
    "descripcion":"ORIGEN ANTILLANO"
  },
  {
    "codigo":1010655000,
    "descripcion":"ARTERIA UMBILICAL ÚNICA TIPO I"
  },
  {
    "codigo":93151007,
    "descripcion":"RETICULOENDOTELIOSIS LEUCÉMICA DEL BAZO"
  },
  {
    "codigo":1303732000,
    "descripcion":"CICATRIZ DE OJO DERECHO DEBIDA A CIRUGÍA FILTRANTE DE GLAUCOMA Y POSTERIOR A ELLA"
  },
  {
    "codigo":289759008,
    "descripcion":"ORIFICIO CERVICAL EXTERNO ABIERTO"
  },
  {
    "codigo":224223009,
    "descripcion":"VIVE EN ALOJAMIENTO, CON VISITAS DE TUTOR"
  },
  {
    "codigo":91316003,
    "descripcion":"CÁLCULO DE VÍA BILIAR CON COLECISTITIS CRÓNICA"
  },
  {
    "codigo":255156006,
    "descripcion":"NEOPLASIA BENIGNA DE GARGANTA, NARIZ Y OÍDO"
  },
  {
    "codigo":418996007,
    "descripcion":"RUPTURA DE LA CÁPSULA POSTERIOR"
  },
  {
    "codigo":56713002,
    "descripcion":"DISFUNCIÓN DE TROMPA DE EUSTAQUIO"
  },
  {
    "codigo":253321003,
    "descripcion":"FINALIZACIÓN ANÓMALA DE LA VENA PULMONAR DERECHA"
  },
  {
    "codigo":417161008,
    "descripcion":"CANALÍCULO SUPERNUMERARIO"
  },
  {
    "codigo":218718001,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR ANESTÉSICO SUPERFICIAL Y PARA INFILTRACIÓN"
  },
  {
    "codigo":208691006,
    "descripcion":"FRACTURA NO EXPUESTA DE MÚLTIPLES HUESOS DE METATARSO"
  },
  {
    "codigo":251486003,
    "descripcion":"ACTIVIDAD THETA FOCAL CONTINUA"
  },
  {
    "codigo":448094004,
    "descripcion":"ACCESO VENOSO PERMEABLE"
  },
  {
    "codigo":284254004,
    "descripcion":"NO DOBLA LA MANO EN PUÑO"
  },
  {
    "codigo":286089009,
    "descripcion":"NO LAVA LA VAJILLA"
  },
  {
    "codigo":249651000,
    "descripcion":"SIGNO O"
  },
  {
    "codigo":53043001,
    "descripcion":"MIOCARDIOPATÍA DILATADA IDIOPÁTICA PRIMARIA"
  },
  {
    "codigo":1082811000119100,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE AMBAS OREJAS"
  },
  {
    "codigo":680891000119101,
    "descripcion":"HIPOTRICOSIS DE PÁRPADO INFERIOR IZQUIERDO"
  },
  {
    "codigo":16227771000119102,
    "descripcion":"PRURITO DE OJO IZQUIERDO"
  },
  {
    "codigo":353211000119103,
    "descripcion":"PLASMOCITOMA EXTRAMEDULAR EN REMISIÓN"
  },
  {
    "codigo":10838971000119103,
    "descripcion":"INMUNODEFICIENCIA CAUSADA POR USO TERAPÉUTICO PROLONGADO DE FÁRMACO"
  },
  {
    "codigo":542440891000119103,
    "descripcion":"PANCOLITIS ULCERATIVA EN REMISIÓN"
  },
  {
    "codigo":184115007,
    "descripcion":"SEXO DEL PACIENTE - DESCONOCIDO"
  },
  {
    "codigo":1077691000119102,
    "descripcion":"OSTEOMIELITIS DE CÚBITO DERECHO"
  },
  {
    "codigo":11855291000119107,
    "descripcion":"AMPOLLA DE LENGUA CON INFECCIÓN"
  },
  {
    "codigo":102331000119107,
    "descripcion":"CISTOURETROCELE FEMENINO"
  },
  {
    "codigo":122811000119101,
    "descripcion":"SÍNDROME DE INSENSIBILIDAD PARCIAL A ANDRÓGENOS"
  },
  {
    "codigo":15628731000119103,
    "descripcion":"DISTROFIA PSEUDOINFLAMATORIA DE SORSBY DE FONDO DE OJO BILATERAL"
  },
  {
    "codigo":143291000119104,
    "descripcion":"LINFOMA NO-HODGKIN EN REMISIÓN"
  },
  {
    "codigo":517253051000119105,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DEBIDO A EMBOLIA DE ARTERIA VERTEBRAL IZQUIERDA"
  },
  {
    "codigo":302011000119105,
    "descripcion":"ESCOLIOSIS IDIOPÁTICA DEL ADOLESCENTE, COLUMNA LUMBAR"
  },
  {
    "codigo":145851000119109,
    "descripcion":"DISECCIÓN DE AORTA TORÁCICA DEBIDA A TRAUMATISMO"
  },
  {
    "codigo":83976009,
    "descripcion":"GRANULOMA DE INTESTINO"
  },
  {
    "codigo":340411000119108,
    "descripcion":"QUISTE IDIOPÁTICO DE CUERPO CILIAR DE OJO IZQUIERDO"
  },
  {
    "codigo":82141001,
    "descripcion":"DIABETES MELLITUS PREGESTACIONAL Y\/O TRASTORNO DE LA TOLERANCIA A LA GLUCOSA, CLASE A DE WHITE MODIFICADA"
  },
  {
    "codigo":170059221000119102,
    "descripcion":"NEUMONITIS LIPOIDEA DEBIDA A VAPEO"
  },
  {
    "codigo":735666001,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE AMBOS MIEMBROS SUPERIORES ENTRE EL CODO Y LA MUÑECA"
  },
  {
    "codigo":80306002,
    "descripcion":"PERISTALTISMO AUMENTADO"
  },
  {
    "codigo":406151001,
    "descripcion":"SEGUIMIENTO POSTERIOR AL ALTA"
  },
  {
    "codigo":111239001,
    "descripcion":"ENTESOPATÍA PERIFÉRICA"
  },
  {
    "codigo":78471002,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE PENE CON INFECCIÓN"
  },
  {
    "codigo":45703009,
    "descripcion":"MOLIMEN DEL CLIMATERIO VIRIL"
  },
  {
    "codigo":76636002,
    "descripcion":"INTOXICACIÓN POR PECTINA"
  },
  {
    "codigo":240476004,
    "descripcion":"INFECCIÓN MUCOCUTÁNEA CRÓNICA POR HERPES SIMPLE"
  },
  {
    "codigo":402481000,
    "descripcion":"ESCLERODERMIA INDUCIDA POR PORFIRIA"
  },
  {
    "codigo":109404008,
    "descripcion":"FACIOSINOSTOSIS PERIMAXILAR POSTERIOR"
  },
  {
    "codigo":369713001,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA DISTAL, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":238641006,
    "descripcion":"QUERATOSIS FOLICULAR ADQUIRIDA"
  },
  {
    "codigo":269574000,
    "descripcion":"INFECCIÓN CAUSADA POR LEGIONELLA PNEUMOPHILA"
  },
  {
    "codigo":40198004,
    "descripcion":"TROMBOFLEBITIS DE LAS VENAS PROFUNDAS DE LA EXTREMIDAD INFERIOR"
  },
  {
    "codigo":236806004,
    "descripcion":"INFERTILIDAD ASOCIADA CON ESPERMATOZOIDES CON VARIAS COLAS Y EXCESO DE ADN"
  },
  {
    "codigo":171270007,
    "descripcion":"SIN CONSENTIMIENTO PARA INMUNIZACIÓN ANTIRRUBEÓLICA"
  },
  {
    "codigo":285960000,
    "descripcion":"INCAPAZ DE REMOVER EL TAPÓN DE LA PILETA"
  },
  {
    "codigo":366043005,
    "descripcion":"ASPECTO DE LA ARTERIA RETINIANA - HALLAZGO"
  },
  {
    "codigo":890331009,
    "descripcion":"DERMATITIS ALÉRGICA POR CONTACTO CON JABÓN"
  },
  {
    "codigo":300507009,
    "descripcion":"DOLOR A LA PALPACIÓN EN CONDUCTO DEFERENTE"
  },
  {
    "codigo":3760002,
    "descripcion":"SÍNDROME DE DEFICIENCIA DE FACTOR MÚLTIPLE FAMILIAR, TIPO V"
  },
  {
    "codigo":11845231000119106,
    "descripcion":"LESIÓN TRAUMÁTICA DE VENA YUGULAR INTERNA IZQUIERDA"
  },
  {
    "codigo":822960006,
    "descripcion":"PIEL TIBIA SOBRE LESIÓN"
  },
  {
    "codigo":167600006,
    "descripcion":"OLOR DE LA MATERIA FECAL: NORMAL"
  },
  {
    "codigo":429744008,
    "descripcion":"CORTE EN GENITALES FEMENINOS"
  },
  {
    "codigo":724656006,
    "descripcion":"DEPENDENCIA DE HIPNÓTICO"
  },
  {
    "codigo":296837001,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE TIOURACILO"
  },
  {
    "codigo":1148805003,
    "descripcion":"FUNCIÓN VASCULAR PERIFÉRICA NORMAL"
  },
  {
    "codigo":22281000119101,
    "descripcion":"EMBARAZO POSTÉRMINO DE 40 A 42 SEMANAS"
  },
  {
    "codigo":427909005,
    "descripcion":"SINUSITIS CRÓNICA RECURRENTE"
  },
  {
    "codigo":1279877008,
    "descripcion":"SÍNDROME DE CORDÓN CENTRAL DE MÉDULA LUMBAR DEBIDO A FRACTURA VERTEBRAL NO EXPUESTA"
  },
  {
    "codigo":65626001,
    "descripcion":"HERNIA INGUINAL INDIRECTA"
  },
  {
    "codigo":131162002,
    "descripcion":"GRUPO SANGUÍNEO B>W<"
  },
  {
    "codigo":720986005,
    "descripcion":"SÍNDROME DE DISPLASIA ECTODÉRMICA ANHIDRÓTICA, INMUNODEFICIENCIA, OSTEOPETROSIS Y LINFEDEMA"
  },
  {
    "codigo":295002006,
    "descripcion":"ALERGIA A ÁCIDO ETACRÍNICO"
  },
  {
    "codigo":32858009,
    "descripcion":"ENFERMEDAD HEMOLÍTICA DEL FETO O DEL RECIÉN NACIDO POR INMUNIZACIÓN ABO"
  },
  {
    "codigo":293167004,
    "descripcion":"REACCIÓN ADVERSA A LA DEXAMETASONA TÓPICA"
  },
  {
    "codigo":63791005,
    "descripcion":"PULSO ANADICRÓTICO"
  },
  {
    "codigo":194863005,
    "descripcion":"DEFECTO DEL TABIQUE AURICULAR DEBIDO A INFARTO AGUDO DE MIOCARDIO Y CONSECUTIVO A ÉL"
  },
  {
    "codigo":31023005,
    "descripcion":"INFECCIÓN CAUSADA POR TRYPANOSOMA EVANSI"
  },
  {
    "codigo":225796000,
    "descripcion":"SABE CÓMO REALIZAR UN RECLAMO"
  },
  {
    "codigo":291332003,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR ACETILCISTEÍNA"
  },
  {
    "codigo":29188005,
    "descripcion":"PARÁLISIS BILATERAL COMPLETA"
  },
  {
    "codigo":94724005,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE SENO PARANASAL"
  },
  {
    "codigo":193028008,
    "descripcion":"CEFALEA MIGRAÑOSA"
  },
  {
    "codigo":387801000,
    "descripcion":"ARTRITIS CERVICAL"
  },
  {
    "codigo":1208836009,
    "descripcion":"AFAQUIA DEBIDA A TRAUMATISMO"
  },
  {
    "codigo":420569002,
    "descripcion":"LÍNEAS EPITELIALES CORNEALES"
  },
  {
    "codigo":125657004,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE DÍGITO DE LA MANO"
  },
  {
    "codigo":60121005,
    "descripcion":"QUERATITIS XERÓTICA"
  },
  {
    "codigo":289497009,
    "descripcion":"HALLAZGO RELACIONADO CON EL COLOR DE LA VULVA"
  },
  {
    "codigo":123822002,
    "descripcion":"PRESIÓN DE OXÍGENO EN SANGRE AUMENTADA"
  },
  {
    "codigo":713646001,
    "descripcion":"TUMOR MALIGNO DE CÉLULAS GERMINALES DE TESTÍCULO"
  },
  {
    "codigo":254894004,
    "descripcion":"NEOPLASIA INTRAEPITELIAL VAGINAL"
  },
  {
    "codigo":1336238006,
    "descripcion":"EPISODIO DE USO NOCIVO DE METILENDIOXIMETANFETAMINA"
  },
  {
    "codigo":56451001,
    "descripcion":"INTENTO FALLIDO DE ABORTO CON PERFORACIÓN DE LIGAMENTO ANCHO"
  },
  {
    "codigo":285827002,
    "descripcion":"CIERRA LAS CANILLAS"
  },
  {
    "codigo":21848000,
    "descripcion":"ANGIOQUERATOMA CIRCUNSCRIPTO"
  },
  {
    "codigo":54616001,
    "descripcion":"HIPERTROFIA CONGÉNITA DEL PÍLORO"
  },
  {
    "codigo":447832002,
    "descripcion":"ANOMALÍA TOTAL DEL RETORNO VENOSO PULMONAR DE TIPO SUPRACARDÍACO"
  },
  {
    "codigo":249389002,
    "descripcion":"CUARTEADURA DEL FRENILLO DE LA LENGUA"
  },
  {
    "codigo":282157004,
    "descripcion":"CAMINA PENDIENTE ARRIBA"
  },
  {
    "codigo":52781008,
    "descripcion":"DISPLASIA CONGÉNITA DE CADERA"
  },
  {
    "codigo":83714006,
    "descripcion":"MICROGASTRIA CONGÉNITA"
  },
  {
    "codigo":247554008,
    "descripcion":"PELOS ENSORTIJADOS"
  },
  {
    "codigo":49111001,
    "descripcion":"HEMORRAGIA SUPRARRENAL"
  },
  {
    "codigo":278487002,
    "descripcion":"PICADURA DE INSECTO EN EL PÁRPADO"
  },
  {
    "codigo":81879005,
    "descripcion":"MENTE EN BLANCO"
  },
  {
    "codigo":737239007,
    "descripcion":"EDEMA TRAUMÁTICO DE MÉDULA ESPINAL LUMBAR"
  },
  {
    "codigo":47276000,
    "descripcion":"AUSENCIA CONGÉNITA DE FÉMUR"
  },
  {
    "codigo":473260000,
    "descripcion":"QUEMADURA DE MÚLTIPLES SITIOS DEL CUELLO"
  },
  {
    "codigo":276652002,
    "descripcion":"HEMORRAGIA SUBEPENDIMARIA PERINATAL CON EXTENSIÓN INTRAVENTRICULAR E INTRACEREBRAL"
  },
  {
    "codigo":211116003,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN LA VAGINA"
  },
  {
    "codigo":1259692005,
    "descripcion":"GLIOSARCOMA CEREBRAL PRIMARIO"
  },
  {
    "codigo":78209002,
    "descripcion":"SÍNDROME URÉMICO HEMOLÍTICO DEL ADULTO"
  },
  {
    "codigo":352471000119101,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE PIEL DE HOMBRO DERECHO"
  },
  {
    "codigo":209281004,
    "descripcion":"FRACTURA-LUXACIÓN EXPUESTA TRANSESCAFOIDEA DE HUESO PERISEMILUNAR"
  },
  {
    "codigo":405889002,
    "descripcion":"FENOTIPO S-S+"
  },
  {
    "codigo":16900311000119102,
    "descripcion":"TOMOGRAFÍA COMPUTADA DE TÓRAX ANORMAL"
  },
  {
    "codigo":274817009,
    "descripcion":"REFLEJO ROTULIANO, AUSENTE"
  },
  {
    "codigo":305750000,
    "descripcion":"ATENDIDO POR ENFERMERA ESPECIALISTA EN ESTOMAS"
  },
  {
    "codigo":404054005,
    "descripcion":"RABDOMIOSARCOMA PLEOMÓRFICO"
  },
  {
    "codigo":369451000,
    "descripcion":"TUMOR MALIGNO QUE COMPROMETE EL RECTO POR PROPAGACIÓN DIRECTA PROVENIENTE DE LA PRÓSTATA"
  },
  {
    "codigo":43606009,
    "descripcion":"RUPTURA ANTIGUA DEL CARTÍLAGO Y\/O DEL MENISCO DE LA RODILLA"
  },
  {
    "codigo":860971004,
    "descripcion":"COLUMNA VERTEBRAL NORMAL"
  },
  {
    "codigo":762667005,
    "descripcion":"ESTIMULACIÓN DE BOLSILLO MUSCULAR DEBIDA A IMPLANTE DE DESFIBRILADOR CARDÍACO AUTOMÁTICO Y POSTERIOR A ÉL"
  },
  {
    "codigo":402219005,
    "descripcion":"ECCEMA VESICULAR CRÓNICO REAGUDIZADO DE PIES"
  },
  {
    "codigo":238379006,
    "descripcion":"FOLICULITIS ESTAFILOCÓCICA DEL CUERO CABELLUDO"
  },
  {
    "codigo":302080006,
    "descripcion":"HALLAZGO RELACIONADO CON LA EVOLUCIÓN DEL NACIMIENTO"
  },
  {
    "codigo":1119445000,
    "descripcion":"ATROFIA DE MÚSCULO ESTERNOCLEIDOMASTOIDEO"
  },
  {
    "codigo":38101003,
    "descripcion":"HIPERMETROPÍA"
  },
  {
    "codigo":365781004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD DE ESCRIBIR"
  },
  {
    "codigo":726229004,
    "descripcion":"DISTENSIÓN DE FASCIA DE MÚSCULO ADUCTOR DE MUSLO"
  },
  {
    "codigo":201941004,
    "descripcion":"ARTROPATÍA TRAUMÁTICA DE HOMBRO"
  },
  {
    "codigo":300245009,
    "descripcion":"LENGUA ASIMÉTRICA"
  },
  {
    "codigo":167338002,
    "descripcion":"MICROSCOPIA URINARIA: CILINDROS HIALINOS"
  },
  {
    "codigo":1663004,
    "descripcion":"ESTADIO G2"
  },
  {
    "codigo":296575006,
    "descripcion":"SOBREDOSIS INTENCIONAL DE PROGUANIL"
  },
  {
    "codigo":1148543009,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE ÁCIDO NICOTÍNICO"
  },
  {
    "codigo":1279615009,
    "descripcion":"HERIDA CORTANTE DE PIEL DE DEDO MEDIO"
  },
  {
    "codigo":720724003,
    "descripcion":"TIENE TARJETA DE IDENTIFICACIÓN DE DIABETES"
  },
  {
    "codigo":294740006,
    "descripcion":"ALERGIA A METFORMINA"
  },
  {
    "codigo":1144873002,
    "descripcion":"APLASIA DE GLÁNDULA SUDORÍPARA"
  },
  {
    "codigo":129065005,
    "descripcion":"DEPENDENCIA PARA VESTIRSE"
  },
  {
    "codigo":161833006,
    "descripcion":"AUMENTO ANORMAL DE PESO"
  },
  {
    "codigo":28926001,
    "descripcion":"ERUPCIÓN CAUSADA POR FÁRMACO"
  },
  {
    "codigo":717054001,
    "descripcion":"DISTONÍA MITOCONDRIAL HEREDADA DE LA MADRE"
  },
  {
    "codigo":782590001,
    "descripcion":"ALERGIA A FOSFOLÍPIDO"
  },
  {
    "codigo":225534003,
    "descripcion":"CONDUCTA SEXUALMENTE PROVOCATIVA"
  },
  {
    "codigo":127230005,
    "descripcion":"NEOPLASIA DEL BAZO"
  },
  {
    "codigo":291070006,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR KETAZOLAM"
  },
  {
    "codigo":1306878008,
    "descripcion":"GLAUCOMA DE ÁNGULO ABIERTO DE OJO IZQUIERDO DEBIDO A CIRUGÍA OCULAR"
  },
  {
    "codigo":715219001,
    "descripcion":"NEUMOTÓRAX ESPONTÁNEO FAMILIAR"
  },
  {
    "codigo":94462009,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE PARAGANGLIO"
  },
  {
    "codigo":289235002,
    "descripcion":"EXPULSIÓN RÁPIDA DE LA PLACENTA"
  },
  {
    "codigo":123560000,
    "descripcion":"ANOMALÍA CONGÉNITA DEL CÚBITO"
  },
  {
    "codigo":1335976001,
    "descripcion":"QUISTE DE CUERPO CILIAR DE OJO IZQUIERDO"
  },
  {
    "codigo":254632001,
    "descripcion":"CARCINOMA DE CÉLULAS PEQUEÑAS DE PULMÓN"
  },
  {
    "codigo":1303208006,
    "descripcion":"DISLOCACIÓN DE ARTICULACIÓN PROTÉSICA DE CODO"
  },
  {
    "codigo":418472007,
    "descripcion":"NISTAGMO SINCRÓNICO ROTATORIO"
  },
  {
    "codigo":285565000,
    "descripcion":"DIFICULTAD PARA DESCENDER EL PALADAR BLANDO"
  },
  {
    "codigo":1137533006,
    "descripcion":"CALCIFICACIÓN PUNTEADA DE EPÍFISIS DE FALANGE PROXIMAL DE SEGUNDO DEDO DE PIE"
  },
  {
    "codigo":21586000,
    "descripcion":"SÍNDROME DE MÜNCHHAUSEN"
  },
  {
    "codigo":416637009,
    "descripcion":"LIPOGRANULOMA ESCLEROSANTE DE PENE DEBIDO A INYECCIÓN DE SUSTANCIA"
  },
  {
    "codigo":283730001,
    "descripcion":"MORDEDURA HUMANA EN DEDO GORDO"
  },
  {
    "codigo":609575003,
    "descripcion":"DIABETES DEL ADULTO DE INICIO JUVENIL, TIPO 8"
  },
  {
    "codigo":1363239004,
    "descripcion":"QUISTE HIDATÍDICO DE CEREBRO"
  },
  {
    "codigo":773415005,
    "descripcion":"SÍNDROME DE DELECIÓN CONTIGUA ABCD1 DXS1357E"
  },
  {
    "codigo":249127006,
    "descripcion":"MEMBRANAS INTACTAS QUE PROTRUYEN A TRAVÉS DEL CUELLO UTERINO"
  },
  {
    "codigo":15919781000119104,
    "descripcion":"REACCIÓN ALÉRGICA CAUSADA POR AGENTE ANTIBACTERIANO"
  },
  {
    "codigo":312828005,
    "descripcion":"OCLUSIÓN DE LA PORCIÓN PROXIMAL DE LA ARTERIA FEMORAL"
  },
  {
    "codigo":835281001,
    "descripcion":"AGUDEZA VISUAL DE OJO IZQUIERDO 6\/9"
  },
  {
    "codigo":702374000,
    "descripcion":"TROMBOSIS NO INFECCIOSA NEONATAL DE SENO VENOSO CEREBRAL"
  },
  {
    "codigo":704209008,
    "descripcion":"FRACTURA NO EXPUESTA DE EPÍFISIS DE PERONÉ PROXIMAL"
  },
  {
    "codigo":47014000,
    "descripcion":"FIBROMA DE PRÓSTATA"
  },
  {
    "codigo":440230003,
    "descripcion":"SIGNO DEL CINTURÓN DE SEGURIDAD"
  },
  {
    "codigo":276390003,
    "descripcion":"MATERIA FECAL COMO LA DE LOS CONEJOS"
  },
  {
    "codigo":831000119103,
    "descripcion":"CIRROSIS HEPÁTICA DEBIDA A HEPATITIS C CRÓNICA"
  },
  {
    "codigo":472998000,
    "descripcion":"HALLAZGO RELACIONADO CON LA CANTIDAD DE PAREJAS SEXUALES PREVIAS"
  },
  {
    "codigo":14246007,
    "descripcion":"EMBOLIA DE SENO VENOSO INTRACRANEAL"
  },
  {
    "codigo":405627000,
    "descripcion":"AUTOCONSENTIMIENTO"
  },
  {
    "codigo":77947001,
    "descripcion":"INFECCIÓN CAUSADA POR WUCHERERIA BANCROFTI"
  },
  {
    "codigo":241787001,
    "descripcion":"EFECTO TÓXICO CAUSADO POR BAÑO PARA OVEJAS"
  },
  {
    "codigo":12411003,
    "descripcion":"CICATRIZ CORIORRETINIANA POSINFLAMATORIA"
  },
  {
    "codigo":733307004,
    "descripcion":"DEFORMIDAD COMBINADA DE HUESO Y PARTES BLANDAS DE ÓRBITA"
  },
  {
    "codigo":1259430009,
    "descripcion":"NEUROBLASTOMA PRIMARIO ABDOMINOTORÁCICO"
  },
  {
    "codigo":209019003,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA DE DEDO DE PIE, ÚNICA"
  },
  {
    "codigo":307323007,
    "descripcion":"RUPTURA DE ARTERIA CUBITAL"
  },
  {
    "codigo":895312000,
    "descripcion":"FORMA DE BALA ANORMAL CONGÉNITA DE FALANGE MEDIA DE DEDO ANULAR"
  },
  {
    "codigo":305488002,
    "descripcion":"BAJO ATENCIÓN DE GENETISTA MOLECULAR CLÍNICO"
  },
  {
    "codigo":403792007,
    "descripcion":"QUERATODERMIA POR EPIDERMÓLISIS AMPOLLAR SIMPLE TIPO DOWLING-MEARA"
  },
  {
    "codigo":371024007,
    "descripcion":"DEMENCIA SENIL CON IDEACIÓN DELIRANTE"
  },
  {
    "codigo":205349004,
    "descripcion":"BRAQUIFALANGIA DEL QUINTO DEDO DEL PIE"
  },
  {
    "codigo":238117007,
    "descripcion":"DEFICIENCIA DE CALCIO"
  },
  {
    "codigo":39674000,
    "descripcion":"SÍNDROME DE DEFICIENCIA FAMILIAR DEL INHIBIDOR DE C3B"
  },
  {
    "codigo":762405009,
    "descripcion":"FISURA DE PALADAR BLANDO CON FISURA LABIAL IZQUIERDA"
  },
  {
    "codigo":170746002,
    "descripcion":"DIABÉTICO EN TRATAMIENTO POR VÍA ORAL"
  },
  {
    "codigo":72442006,
    "descripcion":"TRASTORNO DE LA HIPÓFISIS POSTERIOR"
  },
  {
    "codigo":400122007,
    "descripcion":"LINFOMA CUTÁNEO PRIMARIO DE CÉLULAS T"
  },
  {
    "codigo":203514008,
    "descripcion":"HIPERTROFIA ÓSEA"
  },
  {
    "codigo":168911003,
    "descripcion":"ARTROGRAFÍA DE RODILLA ANORMAL"
  },
  {
    "codigo":209160007,
    "descripcion":"SUBLUXACIÓN EXPUESTA ENTRE LA SÉPTIMA VÉRTEBRA CERVICAL Y LA PRIMERA VÉRTEBRA DORSAL"
  },
  {
    "codigo":5071006,
    "descripcion":"INFECCIÓN CAUSADA POR CAMALLANUS"
  },
  {
    "codigo":70607008,
    "descripcion":"TROMBOSIS DE SENO SAGITAL SUPERIOR"
  },
  {
    "codigo":298148001,
    "descripcion":"FORMA ARTICULAR NORMAL"
  },
  {
    "codigo":365519009,
    "descripcion":"HALLAZGO RELACIONADO CON LA DECORACIÓN DEL HOGAR"
  },
  {
    "codigo":789668008,
    "descripcion":"FLEBITIS DEBIDA A PROCEDIMIENTO"
  },
  {
    "codigo":296313005,
    "descripcion":"SOBREDOSIS DE MESCALINA"
  },
  {
    "codigo":230777006,
    "descripcion":"PARÁLISIS CEREBRAL MONOPLÉJICA QUE AFECTA A LA EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":165241007,
    "descripcion":"INDEPENDENCIA PARA HACER SUS NECESIDADES"
  },
  {
    "codigo":66937008,
    "descripcion":"ENFERMEDAD POR DEPÓSITO DE GLUCÓGENO DE TIPO III"
  },
  {
    "codigo":302041000119109,
    "descripcion":"ESCOLIOSIS IDIOPÁTICA DEL ADOLESCENTE, COLUMNA VERTEBRAL DORSOLUMBAR"
  },
  {
    "codigo":720462004,
    "descripcion":"UTILIZA DISPOSITIVO DE REGISTRO PERSONAL DE AUDIO PARA REGISTRAR INFORMACIÓN"
  },
  {
    "codigo":65102004,
    "descripcion":"ADIASPIROMICOSIS POR EMMONSIA PARVA"
  },
  {
    "codigo":423715000,
    "descripcion":"DESARROLLO DEL LENGUAJE - INTENTA COMUNICARSE CON GESTOS"
  },
  {
    "codigo":294478009,
    "descripcion":"ALERGIA A NITROFURANTOÍNA"
  },
  {
    "codigo":194339007,
    "descripcion":"COLESTEATOMA DEL OÍDO MEDIO Y MASTOIDES"
  },
  {
    "codigo":94200001,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE VASO SANGUÍNEO DEL MIEMBRO INFERIOR"
  },
  {
    "codigo":28664002,
    "descripcion":"HERPES IRIS"
  },
  {
    "codigo":61432006,
    "descripcion":"FUNCIÓN MAMARIA NORMAL"
  },
  {
    "codigo":125133000,
    "descripcion":"DENSIDAD RADIOLÓGICA ANORMAL, CIRCULAR"
  },
  {
    "codigo":878797001,
    "descripcion":"SORDERA TOTAL TRANSITORIA"
  },
  {
    "codigo":190669002,
    "descripcion":"DEFICIENCIA DE MÚLTIPLES NUTRIENTES"
  },
  {
    "codigo":290808008,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR AMITRIPTILINA"
  },
  {
    "codigo":92365006,
    "descripcion":"NEOPLASIA BENIGNA DE LA PIEL DE LA MANO"
  },
  {
    "codigo":331021000119102,
    "descripcion":"ALTERACIÓN VASCULAR DE PÁRPADO INFERIOR DERECHO"
  },
  {
    "codigo":287138003,
    "descripcion":"QUEMADURA DE CÓRNEA - TERCER GRADO"
  },
  {
    "codigo":385442006,
    "descripcion":"TRASTORNO VASCULAR DE LA PELVIS"
  },
  {
    "codigo":711287000,
    "descripcion":"FORMA ANORMAL DE FOSA DE ARTICULACIÓN TEMPOROMANDIBULAR"
  },
  {
    "codigo":1268343004,
    "descripcion":"INTOXICACIÓN CAUSADA POR OPIO"
  },
  {
    "codigo":285303006,
    "descripcion":"PENSAMIENTOS RÁPIDOS"
  },
  {
    "codigo":283468003,
    "descripcion":"HERIDA PUNZANTE EN LA PALMA DE LA MANO"
  },
  {
    "codigo":620930471000119101,
    "descripcion":"DISTENSIÓN DE MÚSCULO INTRÍNSECO DE DEDO MEDIO"
  },
  {
    "codigo":445473008,
    "descripcion":"INFLAMACIÓN DE SÍNFISIS DE PUBIS"
  },
  {
    "codigo":248865009,
    "descripcion":"ORIFICIO DE CONDUCTO DE BARTOLINO NO OBSERVADO"
  },
  {
    "codigo":83190008,
    "descripcion":"AUSENCIA CONGÉNITA DE GLÁNDULA SUPRARRENAL"
  },
  {
    "codigo":10626471000119104,
    "descripcion":"CARBUNCO DE DEDO DE MANO DERECHA"
  },
  {
    "codigo":170760000,
    "descripcion":"EFECTOS COLATERALES DE FÁRMACO PARA LA DIABETES"
  },
  {
    "codigo":703947004,
    "descripcion":"FRACTURA NO EXPUESTA DE TUBEROSIDAD MENOR DE HÚMERO"
  },
  {
    "codigo":409035008,
    "descripcion":"ALTERACIÓN DE LA CONDUCTA DEL LACTANTE"
  },
  {
    "codigo":308896002,
    "descripcion":"HEMORRAGIA SECUNDARIA LUEGO DE PROCEDIMIENTO"
  },
  {
    "codigo":210592003,
    "descripcion":"SECCIÓN PARCIAL, TENDÓN DEL FLEXOR PROFUNDO DE LOS DEDOS DE LA MANO"
  },
  {
    "codigo":46752004,
    "descripcion":"TORUS PALATINUS"
  },
  {
    "codigo":734880004,
    "descripcion":"ANEURISMA ROTO DE ARTERIA COMUNICANTE POSTERIOR IZQUIERDA"
  },
  {
    "codigo":44917000,
    "descripcion":"HIMENOLEPIASIS"
  },
  {
    "codigo":405365001,
    "descripcion":"PROCEDIMIENTO QUIRÚRGICO INCORRECTO REALIZADO"
  },
  {
    "codigo":79520009,
    "descripcion":"MONOPARESIA"
  },
  {
    "codigo":276128008,
    "descripcion":"EL COHABITANTE ABANDONÓ EL HOGAR"
  },
  {
    "codigo":733045005,
    "descripcion":"CAMPTOBRAQUIDACTILIA"
  },
  {
    "codigo":10314002,
    "descripcion":"SÍNDROME DE HIPONASALIDAD"
  },
  {
    "codigo":403530003,
    "descripcion":"DERMATOSIS PUSTULOSA EROSIVA"
  },
  {
    "codigo":1255498007,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO DE DEDO ANULAR DE MANO DERECHA"
  },
  {
    "codigo":74015002,
    "descripcion":"NEUMOPATÍA POR INHALACIÓN DE POLVO"
  },
  {
    "codigo":237855003,
    "descripcion":"BRECHA ANIÓNICA REDUCIDA"
  },
  {
    "codigo":72180004,
    "descripcion":"ANILLO DE VOSSIUS"
  },
  {
    "codigo":430793000,
    "descripcion":"VIVE CON COMPAÑERO DE HABITACIÓN"
  },
  {
    "codigo":1217225001,
    "descripcion":"SÍNDROME DE ANOMALÍA DE KLIPPEL-FEIL, MIOPATÍA Y DISMORFIA FACIAL"
  },
  {
    "codigo":170484009,
    "descripcion":"PORTADOR DE FIEBRE TIFOIDEA"
  },
  {
    "codigo":299721003,
    "descripcion":"PREFERENCIA DE MANO DERECHA"
  },
  {
    "codigo":234185004,
    "descripcion":"TROMBOSIS DE PRÓTESIS DE VÁLVULA CARDÍACA"
  },
  {
    "codigo":365257005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA PREPARAR ALIMENTOS"
  },
  {
    "codigo":398025007,
    "descripcion":"EMERGENCIA CAUSADA POR LA ANESTESIA"
  },
  {
    "codigo":166814000,
    "descripcion":"LÍPIDOS SÉRICOS DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":266953009,
    "descripcion":"ESCAPÓ"
  },
  {
    "codigo":723870003,
    "descripcion":"OCLUSIÓN AGUDA DE ARTERIA DE MIEMBRO INFERIOR CONCOMITANTE CON TROMBOEMBOLIA Y DEBIDA A ELLA"
  },
  {
    "codigo":35742006,
    "descripcion":"SÍFILIS CONGÉNITA"
  },
  {
    "codigo":232350006,
    "descripcion":"ALERGIA A PROTEÍNA DE ÁCAROS DEL POLVO"
  },
  {
    "codigo":363422006,
    "descripcion":"NEOPLASIA MALIGNA DE CAVIDAD NASAL"
  },
  {
    "codigo":296051002,
    "descripcion":"SOBREDOSIS INTENCIONAL DE SECOBARBITAL"
  },
  {
    "codigo":1344627004,
    "descripcion":"OSTEOMIELITIS DE REGIÓN DE CADERA"
  },
  {
    "codigo":427123006,
    "descripcion":"ENFERMEDAD DEL INTERSTICIO PULMONAR POR ENFERMEDAD COLAGENOVASCULAR"
  },
  {
    "codigo":722035007,
    "descripcion":"SÍNDROME DE DISCAPACIDAD INTELECTUAL, ENTEROPATÍA, SORDERA, NEUROPATÍA PERIFÉRICA, ICTIOSIS Y QUERATODERMIA"
  },
  {
    "codigo":1139006,
    "descripcion":"PRUEBA DE CONFRONTACIÓN (VISUAL)"
  },
  {
    "codigo":785736001,
    "descripcion":"BRONQUITIS CRÓNICA CONCOMITANTE CON SIBILANCIAS"
  },
  {
    "codigo":359752005,
    "descripcion":"HALLAZGO EN LA ENERGÍA"
  },
  {
    "codigo":292381004,
    "descripcion":"REACCIÓN ADVERSA AL DROPERIDOL"
  },
  {
    "codigo":95773007,
    "descripcion":"ENOFTALMOS POR ATROFIA DEL MÚSCULO TEMPORAL"
  },
  {
    "codigo":61170000,
    "descripcion":"ESTOMATITIS"
  },
  {
    "codigo":61301000119102,
    "descripcion":"TRASTORNO DEL SISTEMA NERVIOSO CENTRAL CONCOMITANTE CON LEUCEMIA LINFOIDE AGUDA Y DEBIDO A ELLA"
  },
  {
    "codigo":225010003,
    "descripcion":"SE SIENTE FRACASADO"
  },
  {
    "codigo":126706003,
    "descripcion":"NEOPLASIA DE BRONQUIO PRINCIPAL"
  },
  {
    "codigo":290546008,
    "descripcion":"INTOXICACIÓN POR BENZOCAÍNA"
  },
  {
    "codigo":124871003,
    "descripcion":"AUSENCIA DE SITIOS RECEPTORES"
  },
  {
    "codigo":288711004,
    "descripcion":"DIFICULTAD PARA COMUNICARSE EN DIFERENTES OCASIONES"
  },
  {
    "codigo":92103006,
    "descripcion":"NEOPLASIA BENIGNA DE LOS ÓRGANOS GENITALES FEMENINOS"
  },
  {
    "codigo":59335007,
    "descripcion":"INTOXICACIÓN POR KALMIA"
  },
  {
    "codigo":188572001,
    "descripcion":"ENFERMEDAD DE HODGKIN, ESCLEROSIS NODULAR DE GANGLIOS LINFÁTICOS DE MÚLTIPLES LOCALIZACIONES"
  },
  {
    "codigo":450716003,
    "descripcion":"GRIPE CAUSADA POR VIRUS INFLUENZA A SUBTIPO H9"
  },
  {
    "codigo":307061000119106,
    "descripcion":"ARTRITIS ENTEROPÁTICA DE CADERA"
  },
  {
    "codigo":712860007,
    "descripcion":"NEUROMA DE ÓRGANO INTRATORÁCICO"
  },
  {
    "codigo":285041005,
    "descripcion":"CAPAZ DE USAR ANTEOJOS"
  },
  {
    "codigo":22897006,
    "descripcion":"NEUMOTÓRAX TRAUMÁTICO CON HERIDA ABIERTA HACIA TÓRAX"
  },
  {
    "codigo":416113008,
    "descripcion":"TRASTORNO FEBRIL"
  },
  {
    "codigo":447046001,
    "descripcion":"CICATRIZ HIPERTRÓFICA DE BRAZO"
  },
  {
    "codigo":283206004,
    "descripcion":"ANZUELO EN EL TRONCO"
  },
  {
    "codigo":998010741000119109,
    "descripcion":"SENSACIÓN DE CUERPO EXTRAÑO EN AMBOS OJOS"
  },
  {
    "codigo":217670007,
    "descripcion":"ENVENENAMIENTO DEBIDO A PICADURA DE ESCORPIÓN"
  },
  {
    "codigo":51995000,
    "descripcion":"RUBEOSIS DEL IRIS"
  },
  {
    "codigo":445211001,
    "descripcion":"BLOQUEO FASCICULAR IZQUIERDO POSTERIOR EN EL ELECTROCARDIOGRAMA"
  },
  {
    "codigo":707355002,
    "descripcion":"CARCINOMA PRIMARIO DE CÉLULAS ESCAMOSAS DE SENO ESFENOIDAL"
  },
  {
    "codigo":10684431000119104,
    "descripcion":"NÓDULO DEL TEJIDO CELULAR SUBCUTÁNEO DEL PIE DERECHO"
  },
  {
    "codigo":1231643007,
    "descripcion":"CORIORRETINOPATÍA POSTRAUMÁTICA"
  },
  {
    "codigo":738288005,
    "descripcion":"ANTÍGENO LEUCOCÍTICO HUMANO B*57:01 DETECTADO"
  },
  {
    "codigo":246768008,
    "descripcion":"MOVIMIENTOS SACÁDICOS HIPOMÉTRICOS"
  },
  {
    "codigo":769221001,
    "descripcion":"EDEMA DE MÁCULA CLÍNICAMENTE SIGNIFICATIVO DE OJO DERECHO DEBIDO A DIABETES MELLITUS"
  },
  {
    "codigo":48325002,
    "descripcion":"FÓRMULA DE HIPERALIMENTACIÓN PARA EL TRATAMIENTO DE PERITONITIS"
  },
  {
    "codigo":336041000119101,
    "descripcion":"COROIDITIS DE OJO DERECHO"
  },
  {
    "codigo":15557005,
    "descripcion":"SÍNDROME DEL PRIMER ARCO"
  },
  {
    "codigo":408773008,
    "descripcion":"MOTIVOS PARA EL TRATAMIENTO"
  },
  {
    "codigo":308634000,
    "descripcion":"DESMIELINIZACIÓN DE MÉDULA ESPINAL"
  },
  {
    "codigo":1073321000119102,
    "descripcion":"ARTRITIS DE RODILLA DERECHA CAUSADA POR BACTERIAS"
  },
  {
    "codigo":441541008,
    "descripcion":"MIOCARDIOPATÍA DE TAKOTSUBO"
  },
  {
    "codigo":210330008,
    "descripcion":"HERIDAS MÚLTIPLES DE LA NARIZ"
  },
  {
    "codigo":437871001,
    "descripcion":"CONVULSIÓN DESPUÉS DE TRAUMATISMO DE CRÁNEO"
  },
  {
    "codigo":110191003,
    "descripcion":"QUEMADURA DE PRIMER GRADO DE MUCOSA YUGAL"
  },
  {
    "codigo":77423004,
    "descripcion":"INTOXICACIÓN POR AMSINCKIA INTERMEDIA"
  },
  {
    "codigo":44655008,
    "descripcion":"RUPTURA DE QUISTE FOLICULAR DEL OVARIO"
  },
  {
    "codigo":403268000,
    "descripcion":"VITILIGO SEGMENTARIO"
  },
  {
    "codigo":370500003,
    "descripcion":"RUPTURA DEL CUELLO UTERINO"
  },
  {
    "codigo":763716008,
    "descripcion":"REFLUJO VESICOURETERAL FAMILIAR"
  },
  {
    "codigo":237593001,
    "descripcion":"SECRECIÓN EXCESIVA DE BOMBESINA"
  },
  {
    "codigo":309571000119101,
    "descripcion":"NECROSIS AVASCULAR DE TIBIA IZQUIERDA"
  },
  {
    "codigo":401261000221100,
    "descripcion":"RESTOS RADICULARES"
  },
  {
    "codigo":350061000221101,
    "descripcion":"MICOSIS POR LEVADURAS NO CÁNDIDA Y CRYPTOCOCCUS"
  },
  {
    "codigo":15628611000119101,
    "descripcion":"FUNDUS FLAVIMACULATUS BILATERAL"
  },
  {
    "codigo":8217007,
    "descripcion":"ARACNOIDITIS"
  },
  {
    "codigo":792814001,
    "descripcion":"PULSO EN ARTERIA POPLÍTEA DERECHA PRESENTE"
  },
  {
    "codigo":6382002,
    "descripcion":"ENFERMEDAD INFLAMATORIA CRÓNICA DEL INTESTINO DELGADO"
  },
  {
    "codigo":202990002,
    "descripcion":"ABSCESO DE TENDÓN DE MUSLO"
  },
  {
    "codigo":301294004,
    "descripcion":"ESPUTO DE OLOR DULZÓN"
  },
  {
    "codigo":1251566005,
    "descripcion":"EMBOLISMO CARDÍACO"
  },
  {
    "codigo":39150004,
    "descripcion":"ANOMALÍA CONGÉNITA DE LAS MENINGES ESPINALES"
  },
  {
    "codigo":235758007,
    "descripcion":"COLITIS DE BEHCET"
  },
  {
    "codigo":364995001,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA USAR LOS TONOS VOCALES Y LAS UNIDADES FONÉTICAS"
  },
  {
    "codigo":102851003,
    "descripcion":"CRISTAL URINARIO, URATO DE AMONIO"
  },
  {
    "codigo":4547004,
    "descripcion":"DETERMINACIÓN DEL RESULTADO: SATISFACTORIO PARA EL MÉDICO"
  },
  {
    "codigo":233923003,
    "descripcion":"VÍA ACCESORIA RETRÓGRADA UNIDIRECCIONAL"
  },
  {
    "codigo":397763006,
    "descripcion":"ENCEFALOPATÍA POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":299459007,
    "descripcion":"HALLAZGO RELACIONADO CON EL TAMAÑO DEL PIE"
  },
  {
    "codigo":232088004,
    "descripcion":"GLAUCOMA DE CÉLULAS FANTASMA"
  },
  {
    "codigo":164717000,
    "descripcion":"ELECTROENCEFALOGRAMA NORMAL"
  },
  {
    "codigo":363160008,
    "descripcion":"ENFERMEDAD INFECCIOSA DE CARTÍLAGO"
  },
  {
    "codigo":230253001,
    "descripcion":"NEUROPATÍA BULBOESPINAL"
  },
  {
    "codigo":66413004,
    "descripcion":"INTOXICACIÓN POR PENICILINA"
  },
  {
    "codigo":263021005,
    "descripcion":"LUXACIÓN ANTERIOR DE ARTICULACIÓN DE HOMBRO"
  },
  {
    "codigo":425026000,
    "descripcion":"TONO MUSCULAR DISMINUIDO - LADO DERECHO MÁS ACENTUADO QUE EL IZQUIERDO"
  },
  {
    "codigo":293954001,
    "descripcion":"ALERGIA A PEMOLINA"
  },
  {
    "codigo":31810002,
    "descripcion":"PLEURESÍA CON DERRAME"
  },
  {
    "codigo":295789008,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE VINBLASTINA"
  },
  {
    "codigo":228418003,
    "descripcion":"EL CONSUMO DE DROGAS TIENE PRIORIDAD SOBRE LAS OBLIGACIONES SOCIALES"
  },
  {
    "codigo":423191000,
    "descripcion":"PARO CARDÍACO POR CARDIOPATÍA"
  },
  {
    "codigo":718103001,
    "descripcion":"GENIOESPASMO HEREDITARIO"
  },
  {
    "codigo":161047009,
    "descripcion":"MALA ADAPTACIÓN A LA DISCAPACIDAD"
  },
  {
    "codigo":290284001,
    "descripcion":"INTOXICACIÓN POR NEFOPAM"
  },
  {
    "codigo":880108004,
    "descripcion":"INGESTA EXCESIVA DE ÁCIDO ASCÓRBICO"
  },
  {
    "codigo":1142252006,
    "descripcion":"HIPERTROFIA DE MÚSCULO DE EXTREMIDAD SUPERIOR IZQUIERDA"
  },
  {
    "codigo":59073000,
    "descripcion":"HIPOESTESIA TÁCTIL"
  },
  {
    "codigo":191980009,
    "descripcion":"DISFUNCIÓN ENDOCRINA PSICÓGENA"
  },
  {
    "codigo":93676009,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL ANO"
  },
  {
    "codigo":91841003,
    "descripcion":"COMUNICACIÓN ANORMAL ENTRE EL SACO PERICÁRDICO Y LA CAVIDAD PERITONEAL"
  },
  {
    "codigo":124609003,
    "descripcion":"DEFICIENCIA DE ISOCITRATO LIASA"
  },
  {
    "codigo":568091000005100,
    "descripcion":"VARIANTE DE HEMOGLOBINA DETECTADA"
  },
  {
    "codigo":288449004,
    "descripcion":"INCAPAZ DE REALIZAR ACTIVIDADES DE COPIADO"
  },
  {
    "codigo":421356009,
    "descripcion":"PUPILA REDONDA"
  },
  {
    "codigo":90006008,
    "descripcion":"LISTA DE INTERCAMBIO DE CARNE CON ALTO CONTENIDO DE GRASA"
  },
  {
    "codigo":415851002,
    "descripcion":"PERFUSIÓN DE HERIDA\/TISULAR IGUAL O MEJORADA CON RESPECTO AL ESTADO PREOPERATORIO BASAL"
  },
  {
    "codigo":710763006,
    "descripcion":"INDEPENDIENTE AL COCINAR"
  },
  {
    "codigo":448619007,
    "descripcion":"DESVIACIÓN ANTERIOR DE TABIQUE INFUNDIBULAR TIPO FALLOT"
  },
  {
    "codigo":414016004,
    "descripcion":"ENFERMEDAD CAUSADA POR ORTHOREOVIRUS"
  },
  {
    "codigo":11862801000119100,
    "descripcion":"ABRASIÓN DE PIEL DE REGIÓN DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":1264149000,
    "descripcion":"DAÑO DE CUELLO UTERINO POSTERIOR A EMBARAZO ECTÓPICO"
  },
  {
    "codigo":282944008,
    "descripcion":"SE INCLINA PARA LEVANTAR UN OBJETO SIN CAERSE"
  },
  {
    "codigo":1231381006,
    "descripcion":"CARCINOMA UROTELIAL DE CÉLULAS CLARAS DE SISTEMA URINARIO"
  },
  {
    "codigo":281109007,
    "descripcion":"VESTIGIO DE REMANENTE GASTROINTESTINAL"
  },
  {
    "codigo":338551000119108,
    "descripcion":"QUISTE PRIMARIO DE ANILLO CILIAR DE OJO IZQUIERDO"
  },
  {
    "codigo":836330001,
    "descripcion":"AGUDEZA VISUAL CON AGUJERO ESTENOPEICO DE OJO DERECHO 6\/24"
  },
  {
    "codigo":10906231000119109,
    "descripcion":"LACERACIÓN DE REGIÓN DE MANDÍBULA"
  },
  {
    "codigo":15713041000119103,
    "descripcion":"INFARTO AGUDO DE PARED POSTERIOR DE MIOCARDIO CON ELEVACIÓN DE SEGMENTO ST"
  },
  {
    "codigo":49898008,
    "descripcion":"HEMORRAGIA SECUNDARIA Y\/O RECURRENTE COMO COMPLICACIÓN TEMPRANA DE UN TRAUMATISMO"
  },
  {
    "codigo":15295001,
    "descripcion":"RETROVERSIÓN DEL ÚTERO"
  },
  {
    "codigo":408511001,
    "descripcion":"SUSTITUTO DE COMIDA UTILIZADO"
  },
  {
    "codigo":770794008,
    "descripcion":"SÍNDROME DE MICRODUPLICACIÓN 11P15.4"
  },
  {
    "codigo":211903002,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL SUPERFICIAL DE DÍGITO DE LA MANO"
  },
  {
    "codigo":441279004,
    "descripcion":"CAPAZ DE LEER LOS LABIOS"
  },
  {
    "codigo":80831007,
    "descripcion":"INFECCIÓN CAUSADA POR MICROSOMACANTHUS"
  },
  {
    "codigo":208233000,
    "descripcion":"FRACTURA EXPUESTA DE CAVIDAD GLENOIDEA DE OMÓPLATO"
  },
  {
    "codigo":78996009,
    "descripcion":"PERIOSTITIS ALVEOLAR SUPURATIVA AGUDA"
  },
  {
    "codigo":11780881000119107,
    "descripcion":"LESIÓN TRAUMÁTICA DE HOMBRO DERECHO"
  },
  {
    "codigo":44393007,
    "descripcion":"DESTRUCCIÓN DE GRANULOCITOS AUMENTADA"
  },
  {
    "codigo":11625007,
    "descripcion":"TORUS MANDIBULAR"
  },
  {
    "codigo":239166000,
    "descripcion":"DOLOR PERSISTENTE DE HERIDA"
  },
  {
    "codigo":765289008,
    "descripcion":"PROBLEMA EN LA RELACIÓN SEXUAL DEBIDO A CONFUSIÓN CON LA IDENTIDAD DE GÉNERO"
  },
  {
    "codigo":206398001,
    "descripcion":"HEMORRAGIA INTRAVENTRICULAR POR TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":1254974001,
    "descripcion":"DEPENDENCIA DE SUSTANCIAS, EPISÓDICA"
  },
  {
    "codigo":697918008,
    "descripcion":"HIPERTENSIÓN PULMONAR DEBIDA A TRASTORNO MIELOPROLIFERATIVO"
  },
  {
    "codigo":403006009,
    "descripcion":"TIÑA DEL CUERO CABELLUDO POR MICROSPORUM EQUINUM"
  },
  {
    "codigo":237331002,
    "descripcion":"HEMATOMA PERINEAL"
  },
  {
    "codigo":46331000087100,
    "descripcion":"FRACTURA DE CARPO DERECHO"
  },
  {
    "codigo":30971000087102,
    "descripcion":"MICROBIOTA NORMAL DE LA CONJUNTIVA"
  },
  {
    "codigo":40723007,
    "descripcion":"PERFORACIÓN CENTRAL DE LA MEMBRANA TIMPÁNICA"
  },
  {
    "codigo":366568000,
    "descripcion":"HALLAZGO RELACIONADO CON LA AMPLITUD DE LA ABDUCCIÓN DE LA CADERA"
  },
  {
    "codigo":401171009,
    "descripcion":"AÚN SIN PARARSE"
  },
  {
    "codigo":41211000087105,
    "descripcion":"HEMATOMA DE EXTREMIDAD SUPERIOR IZQUIERDA"
  },
  {
    "codigo":169960003,
    "descripcion":"DETALLES DEL TRABAJO DE PARTO"
  },
  {
    "codigo":43771000087105,
    "descripcion":"TRASTORNO DE TENDÓN DE EXTREMIDAD INFERIOR DERECHA"
  },
  {
    "codigo":399336001,
    "descripcion":"CATARATA JUVENIL"
  },
  {
    "codigo":301032005,
    "descripcion":"FRACTURA DE LA RAMA SUPERIOR DEL PUBIS"
  },
  {
    "codigo":268264007,
    "descripcion":"ANILLO DE CONSTRICCIÓN DE EXTREMIDAD SUPERIOR CON LINFEDEMA"
  },
  {
    "codigo":364733000,
    "descripcion":"HALLAZGO RELACIONADO CON EL AJUSTE DEL CALZADO"
  },
  {
    "codigo":168125001,
    "descripcion":"EXAMEN DE ESPÉCIMEN, ANORMAL"
  },
  {
    "codigo":233661002,
    "descripcion":"DEFECTO DE DEPURACIÓN MUCOCILIAR HEREDADO"
  },
  {
    "codigo":102589003,
    "descripcion":"DOLOR DE PECHO ATÍPICO"
  },
  {
    "codigo":299197003,
    "descripcion":"BLOQUEO DE ARTICULACIÓN DE PULGAR"
  },
  {
    "codigo":266429005,
    "descripcion":"QUEILITIS ANGULAR"
  },
  {
    "codigo":202728009,
    "descripcion":"PROLAPSO DE DISCO INTERVERTEBRAL CON MIELOPATÍA"
  },
  {
    "codigo":200893007,
    "descripcion":"ERUPCIÓN CUTÁNEA LOCALIZADA CAUSADA POR FÁRMACO Y MEDICAMENTO"
  },
  {
    "codigo":1149330000,
    "descripcion":"INTOXICACIÓN CRÓNICA POR MONÓXIDO DE CARBONO"
  },
  {
    "codigo":428434003,
    "descripcion":"LESIÓN TRAUMÁTICA DEBIDA A MAQUINARIA"
  },
  {
    "codigo":788882003,
    "descripcion":"ACCIDENTE CEREBROVASCULAR ISQUÉMICO DEBIDO A HIPOPERFUSIÓN GENERALIZADA CON INFARTO DE ZONA DIVISORIA"
  },
  {
    "codigo":231826004,
    "descripcion":"QUERATOSIS SEBORREICA DE PÁRPADO"
  },
  {
    "codigo":35218008,
    "descripcion":"ESQUIZOFRENIA DESORGANIZADA CRÓNICA CON EXACERBACIÓN AGUDA"
  },
  {
    "codigo":426599002,
    "descripcion":"MIELITIS CAUSADA POR VIRUS HERPES SIMPLE HUMANO"
  },
  {
    "codigo":361063004,
    "descripcion":"FALTA DE EDUCACIÓN"
  },
  {
    "codigo":615005,
    "descripcion":"OBSTRUCCIÓN POR CUERPO EXTRAÑO DEJADO ACCIDENTALMENTE EN HERIDA OPERATORIA Y\/O EN CAVIDAD CORPORAL DURANTE PROCEDIMIENTO"
  },
  {
    "codigo":295527005,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE ENFLURANO"
  },
  {
    "codigo":721511007,
    "descripcion":"SÍNDROME DEL CORDÓN ANTERIOR DE MÉDULA ESPINAL LUMBAR"
  },
  {
    "codigo":33383005,
    "descripcion":"REACCIÓN EXPLOSIVA AISLADA"
  },
  {
    "codigo":66151009,
    "descripcion":"COLAPSO PULMONAR PERINATAL"
  },
  {
    "codigo":293692002,
    "descripcion":"ALERGIA A MEBEVERINA"
  },
  {
    "codigo":11809861000119105,
    "descripcion":"HERIDA DE REGIÓN DE RODILLA IZQUIERDA DEBIDA A PICADURA DE INSECTO NO VENENOSO"
  },
  {
    "codigo":228156007,
    "descripcion":"DISCAPACIDAD EN EL FUNCIONAMIENTO INTELECTUAL"
  },
  {
    "codigo":64316008,
    "descripcion":"INTOXICACIÓN POR BAILEYA MULTIRADIATA"
  },
  {
    "codigo":95249000,
    "descripcion":"CARIES DENTAL POR DISFUNCIÓN SALIVAL"
  },
  {
    "codigo":193553001,
    "descripcion":"GLAUCOMA DEBIDO A ANOMALÍA DEL IRIS"
  },
  {
    "codigo":314591000119101,
    "descripcion":"BURSITIS DE OLÉCRANON DE CODO IZQUIERDO"
  },
  {
    "codigo":1078289006,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":27878001,
    "descripcion":"AMIGDALITIS FOLICULAR"
  },
  {
    "codigo":224486001,
    "descripcion":"CUIDA A UN VECINO"
  },
  {
    "codigo":716006003,
    "descripcion":"FÉMUR BÍFIDO CONCOMITANTE CON ECTRODACTILIA-MONODACTILIA"
  },
  {
    "codigo":93414008,
    "descripcion":"TORACOESTENOSIS CONGÉNITA"
  },
  {
    "codigo":124347000,
    "descripcion":"DEFICIENCIA DE PANTETEÍNA - FOSFATO ADENILILTRANSFERASA"
  },
  {
    "codigo":286352000,
    "descripcion":"IMITA VOCALIZACIÓN"
  },
  {
    "codigo":1269392001,
    "descripcion":"LESIÓN CENTRAL DE MÉDULA ESPINAL DORSAL DEBIDA A SUBLUXACIÓN NO EXPUESTA DE ARTICULACIÓN DE COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":24208001,
    "descripcion":"INTOXICACIÓN POR LOBELIA"
  },
  {
    "codigo":1172923008,
    "descripcion":"PROTEÍNAS SÉRICAS TOTALES POR DEBAJO DE RANGO DE REFERENCIA"
  },
  {
    "codigo":89744004,
    "descripcion":"SECUENCIA ANORMAL DE CARBOHIDRATOS"
  },
  {
    "codigo":253584005,
    "descripcion":"TEJIDO ACCESORIO SOBRE VALVA DE VÁLVULA TRONCAL"
  },
  {
    "codigo":1202021001,
    "descripcion":"SENSACIÓN DE ARDOR EN BOCA"
  },
  {
    "codigo":415589002,
    "descripcion":"ESTOMATITIS CAUSADA POR VIRUS DE LA ESTOMATITIS PAPULAR BOVINA"
  },
  {
    "codigo":735923005,
    "descripcion":"FRAGMENTOS DE LENTE PARA CATARATA EN HUMOR VÍTREO DE OJO DEBIDOS A CIRUGÍA DE CATARATAS Y DESPUÉS DE ELLA"
  },
  {
    "codigo":87909002,
    "descripcion":"NEUMOCONIOSIS POR METALES PESADOS"
  },
  {
    "codigo":448357002,
    "descripcion":"VÉRTICE DEL CORAZÓN EN LA LÍNEA MEDIA ANTERIOR"
  },
  {
    "codigo":284517007,
    "descripcion":"MOVIMIENTOS REPETITIVOS DE PARPADEO"
  },
  {
    "codigo":315450007,
    "descripcion":"NACIDO EN ITALIA"
  },
  {
    "codigo":249914008,
    "descripcion":"CADERA RÍGIDA"
  },
  {
    "codigo":248079000,
    "descripcion":"NO CONOCE EL PELIGRO DEL FUEGO"
  },
  {
    "codigo":1003578008,
    "descripcion":"AGENESIA DE HUESO PREMAXILAR"
  },
  {
    "codigo":704996001,
    "descripcion":"ONDA T ANTERIOR BIFÁSICA INVERTIDA"
  },
  {
    "codigo":15033003,
    "descripcion":"ABSCESO PERIAMIGDALINO"
  },
  {
    "codigo":1260217004,
    "descripcion":"NEOPLASIA MIELODISPLÁSICA CON ESCASOS BLASTOS Y MUTACIÓN DE GEN SF3B1"
  },
  {
    "codigo":211641006,
    "descripcion":"CUERPO EXTRAÑO EN EL COLON DESCENDENTE"
  },
  {
    "codigo":703161008,
    "descripcion":"OCLUSIÓN DE ARTERIA AUDITIVA INTERNA"
  },
  {
    "codigo":735929009,
    "descripcion":"AUSENCIA ADQUIRIDA DE ÓRGANO GENITAL"
  },
  {
    "codigo":209806001,
    "descripcion":"ESGUINCE ESTERNOCLAVICULAR"
  },
  {
    "codigo":1292985009,
    "descripcion":"ANGIOMIOFIBROBLASTOMA"
  },
  {
    "codigo":275342003,
    "descripcion":"FRACTURA EXPUESTA DE TROCÁNTER MENOR DE FÉMUR"
  },
  {
    "codigo":1080851000119103,
    "descripcion":"HISTIOCITOMA FIBROSO MALIGNO PRIMARIO DE PARTES BLANDAS DE CADERA DERECHA"
  },
  {
    "codigo":111502003,
    "descripcion":"DISTROFIA MUSCULAR CONGÉNITA DE FUKUYAMA"
  },
  {
    "codigo":207971000,
    "descripcion":"FRACTURA EXPUESTA DE VÉRTEBRA LUMBAR, ARCO POSTERIOR"
  },
  {
    "codigo":699491001,
    "descripcion":"CARIES DENTAL CLASE III"
  },
  {
    "codigo":732259001,
    "descripcion":"MONOSOMÍA DISTAL 17Q"
  },
  {
    "codigo":240739003,
    "descripcion":"FIBROSIS MEDIASTÍNICA POR HISTOPLASMOSIS CLÁSICA"
  },
  {
    "codigo":109667005,
    "descripcion":"ARTRITIS INFECCIOSA DE ARTICULACIÓN TEMPOROMANDIBULAR CAUSADA POR PRÓTESIS INTERNA"
  },
  {
    "codigo":371811008,
    "descripcion":"ESTADO DE ANGINA DE PECHO RECURRENTE, LUEGO DE ATERECTOMÍA ROTATORIA"
  },
  {
    "codigo":402744003,
    "descripcion":"NECRÓLISIS TÓXICA EPIDÉRMICA CAUSADA POR FÁRMACO"
  },
  {
    "codigo":1254712003,
    "descripcion":"REQUIERE SERVICIO DE TRADUCCIÓN DE DOCUMENTOS PARA APOYAR EL CONOCIMIENTO SOBRE LA SALUD"
  },
  {
    "codigo":238904008,
    "descripcion":"LIPOMATOSIS DIFUSA CONGÉNITA"
  },
  {
    "codigo":271672008,
    "descripcion":"OMBLIGO APLANADO"
  },
  {
    "codigo":237069002,
    "descripcion":"ENDOMETRITIS GONOCÓCICA"
  },
  {
    "codigo":429651000124106,
    "descripcion":"HIPOSPADIAS DEL CUERPO DEL PENE"
  },
  {
    "codigo":711251000124108,
    "descripcion":"SINOVITIS CRÓNICA DE CODO IZQUIERDO DEBIDA A HEMARTROSIS"
  },
  {
    "codigo":1187341006,
    "descripcion":"TUMOR DE CÉLULAS DE LA GRANULOSA TESTICULAR DE COMPORTAMIENTO INCIERTO"
  },
  {
    "codigo":105997008,
    "descripcion":"TRASTORNO DEL TRACTO BILIAR"
  },
  {
    "codigo":366306000,
    "descripcion":"HALLAZGO RELACIONADO CON EL TAMAÑO DEL CUELLO UTERINO"
  },
  {
    "codigo":268002004,
    "descripcion":"RUPTURA ESPONTÁNEA DE TENDÓN"
  },
  {
    "codigo":300770008,
    "descripcion":"REALIZA ACTIVIDADES RECREATIVAS Y DEPORTIVAS"
  },
  {
    "codigo":298935004,
    "descripcion":"HALLAZGO RELACIONADO CON LA TEMPERATURA DE ARTICULACIÓN DE CODO"
  },
  {
    "codigo":724919004,
    "descripcion":"LACERACIÓN DE FASCIA DE CABEZA LARGA DE BÍCEPS BRAQUIAL"
  },
  {
    "codigo":69559004,
    "descripcion":"MASA DE ESTRUCTURA RETROPERITONEAL"
  },
  {
    "codigo":167863008,
    "descripcion":"EXAMEN DE LÍQUIDO SINOVIAL, ANORMAL"
  },
  {
    "codigo":297100000,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE UROCINASA"
  },
  {
    "codigo":428172002,
    "descripcion":"FOLICULITIS POR MALASSEZIA"
  },
  {
    "codigo":723084007,
    "descripcion":"SECUELA DE HEMORRAGIA INTRACEREBRAL NO TRAUMÁTICA"
  },
  {
    "codigo":67724008,
    "descripcion":"TRASTORNO SECUNDARIO DEL SENTIDO DEL GUSTO DE LOS SABORES SALADOS"
  },
  {
    "codigo":34956008,
    "descripcion":"INFECCIÓN CAUSADA POR HEPATOZOON CANIS"
  },
  {
    "codigo":295265002,
    "descripcion":"SOBREDOSIS INTENCIONAL DE KETOROLACO"
  },
  {
    "codigo":33121004,
    "descripcion":"PRODUCCIÓN ANORMAL DE GRANULOCITOS"
  },
  {
    "codigo":721249007,
    "descripcion":"ENCEFALOMIELITIS CAUSADA POR INFECCIÓN"
  },
  {
    "codigo":129590000,
    "descripcion":"HIPERLIPEMIA EXÓGENA"
  },
  {
    "codigo":293430003,
    "descripcion":"REACCIÓN ADVERSA A LOS ACEITES DE PESCADO"
  },
  {
    "codigo":290631000119103,
    "descripcion":"DISARTRIA DEBIDA A ACCIDENTE CEREBROVASCULAR Y POSTERIOR A ÉL"
  },
  {
    "codigo":195126007,
    "descripcion":"HIPERTROFIA AURICULAR"
  },
  {
    "codigo":29451002,
    "descripcion":"GANGRENA INTESTINAL"
  },
  {
    "codigo":444979008,
    "descripcion":"TENDINITIS DE FLEXOR CUBITAL DEL CARPO"
  },
  {
    "codigo":291595004,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR CEFOTAXIMA"
  },
  {
    "codigo":1340171005,
    "descripcion":"CONTUSIÓN DE MALÉOLO EXTERNO DE PERONÉ"
  },
  {
    "codigo":94987007,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL PERITONEO PARIETAL"
  },
  {
    "codigo":289760003,
    "descripcion":"ORIFICIO INTERNO ABIERTO"
  },
  {
    "codigo":1010656004,
    "descripcion":"CARCINOMA ESCAMOCELULAR ADENOIDE DE NASOFARINGE"
  },
  {
    "codigo":224224003,
    "descripcion":"VIVE EN VIVIENDA CON PERSONAL"
  },
  {
    "codigo":15747041000119100,
    "descripcion":"PRESIÓN INTRAOCULAR ELEVADA EN AMBOS OJOS"
  },
  {
    "codigo":27616008,
    "descripcion":"INTOXICACIÓN POR METOXICLORO"
  },
  {
    "codigo":255157002,
    "descripcion":"NEOPLASIA BENIGNA DE OÍDO MEDIO Y MASTOIDES"
  },
  {
    "codigo":124085007,
    "descripcion":"UROBILINA POR ENCIMA DE RANGO DE REFERENCIA"
  },
  {
    "codigo":286090000,
    "descripcion":"DIFICULTAD PARA LAVAR LA VAJILLA"
  },
  {
    "codigo":187786003,
    "descripcion":"NEOPLASIA MALIGNA DEL ESFÍNTER DE ODDI"
  },
  {
    "codigo":253322005,
    "descripcion":"CONEXIÓN VENOSA PULMONAR OBSTRUIDA"
  },
  {
    "codigo":1083361000119103,
    "descripcion":"OTITIS NO INFECCIOSA CRÓNICA EXTERNA DE AMBOS CONDUCTOS AUDITIVOS EXTERNOS"
  },
  {
    "codigo":54879000,
    "descripcion":"NEFROPATÍA HIPOCALIÉMICA"
  },
  {
    "codigo":284255003,
    "descripcion":"DIFICULTAD PARA DOBLAR LA MANO EN PUÑO"
  },
  {
    "codigo":448095003,
    "descripcion":"TÚNEL AÓRTICO EN VENTRÍCULO IZQUIERDO CON ORIGEN DE ARTERIA CORONARIA DERECHA EN EL TÚNEL"
  },
  {
    "codigo":251487007,
    "descripcion":"ACTIVIDAD DELTA FOCAL CONTINUA"
  },
  {
    "codigo":346081000119105,
    "descripcion":"QUISTE EXUDATIVO DE PARS PLANA DE CUERPO CILIAR DE AMBOS OJOS"
  },
  {
    "codigo":446260003,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN ADQUIRIDA EN CENTRO DE CUIDADOS PALIATIVOS"
  },
  {
    "codigo":249652007,
    "descripcion":"ANO ESPASMÓDICO"
  },
  {
    "codigo":184116008,
    "descripcion":"ESTADO CIVIL DEL PACIENTE - DESCONOCIDO"
  },
  {
    "codigo":870409005,
    "descripcion":"SOBREDOSIS DE FÁRMACO VASOPRESOR"
  },
  {
    "codigo":51209006,
    "descripcion":"AMIGDALITIS VIRAL"
  },
  {
    "codigo":313353007,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS DE BRONQUIO, EN EL LÓBULO INFERIOR IZQUIERDO"
  },
  {
    "codigo":247817006,
    "descripcion":"TEMOR A DESVANECERSE"
  },
  {
    "codigo":1163486001,
    "descripcion":"DACRIOADENITIS POR VIRUS DE EPSTEIN-BARR"
  },
  {
    "codigo":307861000119100,
    "descripcion":"FÍSTULA DE ARTICULACIÓN DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":16466581000119101,
    "descripcion":"MELORREOSTOSIS DE PIERNA DERECHA"
  },
  {
    "codigo":28821000119102,
    "descripcion":"ENFERMEDAD DE DEPÓSITO LISOSOMAL"
  },
  {
    "codigo":333461000119103,
    "descripcion":"AGRANDAMIENTO DE ÓRBITA DERECHA"
  },
  {
    "codigo":1075861000119103,
    "descripcion":"TENOSINOVITIS DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":1083541000119105,
    "descripcion":"TRASTORNO DE AMBOS OÍDOS"
  },
  {
    "codigo":82581000119105,
    "descripcion":"RUBEOSIS DE IRIS DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":11848341000119103,
    "descripcion":"HERIDA DE PÁRPADO DERECHO DEBIDA A PICADURA DE INSECTO NO VENENOSO"
  },
  {
    "codigo":292501000119108,
    "descripcion":"TRASTORNO DE NERVIO PERIFÉRICO DE MIEMBRO INFERIOR DERECHO"
  },
  {
    "codigo":77461000119109,
    "descripcion":"MIASTENIA GRAVE CON EXACERBACIÓN"
  },
  {
    "codigo":348821000119101,
    "descripcion":"FASE HIDRÓPICA AGUDA DE QUERATOCONO DE OJO IZQUIERDO"
  },
  {
    "codigo":15649941000119102,
    "descripcion":"GANGRENA DE AMBOS MIEMBROS INFERIORES CONCOMITANTE CON ATEROSCLEROSIS Y DEBIDA A ELLA"
  },
  {
    "codigo":515623061000119105,
    "descripcion":"ENFERMEDAD DE CROHN DE COLON EN REMISIÓN"
  },
  {
    "codigo":123541000119106,
    "descripcion":"HEMATOMA NO TRAUMÁTICO DE PARTES BLANDAS"
  },
  {
    "codigo":302741000119107,
    "descripcion":"SÍNDROME COMPARTIMENTAL TIBIAL ANTERIOR DE PIERNA DERECHA"
  },
  {
    "codigo":45704003,
    "descripcion":"CON MAYOR RIESGO DE INCUMPLIMIENTO"
  },
  {
    "codigo":103061000119109,
    "descripcion":"FRACTURA NO EXPUESTA DE PORCIÓN NASO-ORBITARIA DE ETMOIDES"
  },
  {
    "codigo":373384007,
    "descripcion":"CUERPO DESCOMPUESTO POR INMERSIÓN"
  },
  {
    "codigo":319611000119107,
    "descripcion":"ARTRITIS REACTIVA DE ARTICULACIÓN DE CADERA DERECHA"
  },
  {
    "codigo":240477008,
    "descripcion":"INFECCIÓN ESOFÁGICA POR HERPES SIMPLE"
  },
  {
    "codigo":238642004,
    "descripcion":"DERMATOSIS ACANTOLÍTICA PERSISTENTE DE FAWCETT Y MILLER"
  },
  {
    "codigo":402482007,
    "descripcion":"DERMATOSIS ASOCIADA A DEFICIENCIA DE BIOTINA"
  },
  {
    "codigo":369714007,
    "descripcion":"MEDICIÓN DE BRESLOW - INVASIÓN DE 0,76 A 1,5 MM DESDE EL BORDE PROFUNDO DE LA CAPA GRANULAR"
  },
  {
    "codigo":171271006,
    "descripcion":"SIN CONSENTIMIENTO PARA VACUNACIÓN CON BACILO CALMETTE-GUERIN"
  },
  {
    "codigo":40199007,
    "descripcion":"POSICIÓN CORPORAL SUPINA"
  },
  {
    "codigo":236807008,
    "descripcion":"AZOOSPERMIA OBSTRUCTIVA CONGÉNITA"
  },
  {
    "codigo":38364001,
    "descripcion":"ROSARIO ESCORBÚTICO"
  },
  {
    "codigo":234972003,
    "descripcion":"TRASTORNO DE LA ERUPCIÓN O CAÍDA DENTARIA"
  },
  {
    "codigo":366044004,
    "descripcion":"HALLAZGO RELACIONADO CON EL LUGAR DE LA MUERTE"
  },
  {
    "codigo":5596004,
    "descripcion":"APENDICITIS ATÍPICA"
  },
  {
    "codigo":298673002,
    "descripcion":"DOLOR A LA PALPACIÓN EN REGIÓN DE COLUMNA LUMBAR"
  },
  {
    "codigo":1085871000119101,
    "descripcion":"FÍSTULA DE INTESTINO DELGADO DEBIDA A ENFERMEDAD DE CROHN"
  },
  {
    "codigo":36529003,
    "descripcion":"INFECCIÓN INTESTINAL CAUSADA POR MORGANELLA MORGANII"
  },
  {
    "codigo":167601005,
    "descripcion":"OLOR DE MATERIA FECAL: HÚMEDA"
  },
  {
    "codigo":822961005,
    "descripcion":"TEMPERATURA NORMAL DE PIEL SOBRE LESIÓN"
  },
  {
    "codigo":396977007,
    "descripcion":"INVASIÓN TUMORAL DEL NERVIO ÓPTICO, AUSENTE"
  },
  {
    "codigo":427910000,
    "descripcion":"DIVERTICULITIS DE COLON SIGMOIDE"
  },
  {
    "codigo":1148806002,
    "descripcion":"FUNCIÓN DEL SISTEMA INMUNOLÓGICO NORMAL"
  },
  {
    "codigo":1926006,
    "descripcion":"OSTEOPETROSIS"
  },
  {
    "codigo":34694006,
    "descripcion":"HIPERTENSIÓN PREEXISTENTE QUE COMPLICA EL PARTO Y\/O CONSTITUYE UN MOTIVO DE ATENCIÓN DURANTE ESTE PROCEDIMIENTO"
  },
  {
    "codigo":296838006,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE TIOURACILO"
  },
  {
    "codigo":720987001,
    "descripcion":"SÍNDROME DE ANIRIDIA, PTOSIS, DISCAPACIDAD INTELECTUAL Y OBESIDAD FAMILIAR"
  },
  {
    "codigo":295003001,
    "descripcion":"ALERGIA A PIRETANIDA"
  },
  {
    "codigo":102831000119104,
    "descripcion":"SÍNDROME PARALÍTICO DE AMBOS MIEMBROS INFERIORES COMO SECUELA DE ACCIDENTE CEREBROVASCULAR"
  },
  {
    "codigo":131163007,
    "descripcion":"GRUPO SANGUÍNEO B>X<"
  },
  {
    "codigo":1208837000,
    "descripcion":"INDICADOR DE REEMPLAZO ELECTIVO DE BATERÍA DE MARCAPASOS CARDÍACO"
  },
  {
    "codigo":15723081000119101,
    "descripcion":"ARTROSIS SECUNDARIA DE AMBAS MANOS"
  },
  {
    "codigo":94725006,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE NERVIO VESTIBULOCOCLEAR"
  },
  {
    "codigo":92890001,
    "descripcion":"FORMA ANORMAL CONGÉNITA DE ARCO DE VÉRTEBRA CERVICAL"
  },
  {
    "codigo":225797009,
    "descripcion":"CONOCE EL PROCEDIMIENTO DE RECLAMO"
  },
  {
    "codigo":715482004,
    "descripcion":"ENANISMO MICROCEFÁLICO PRIMORDIAL TIPO TORIELLO"
  },
  {
    "codigo":289498004,
    "descripcion":"HIPERPIGMENTACIÓN VULVAR"
  },
  {
    "codigo":387802007,
    "descripcion":"ESPONDILOSIS DORSAL"
  },
  {
    "codigo":125658009,
    "descripcion":"HERIDA ABIERTA DE LA REGIÓN DE LA CADERA"
  },
  {
    "codigo":254895003,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS DE LA VULVA"
  },
  {
    "codigo":1336239003,
    "descripcion":"PATRÓN DE USO NOCIVO DE METILENDIOXIMETANFETAMINA"
  },
  {
    "codigo":123823007,
    "descripcion":"PRESIÓN DE OXÍGENO EN SANGRE DISMINUIDA"
  },
  {
    "codigo":285828007,
    "descripcion":"NO CIERRA LAS CANILLAS DE AGUA"
  },
  {
    "codigo":56452008,
    "descripcion":"CONDUCTA DISOCIAL EN EL ADULTO"
  },
  {
    "codigo":709977002,
    "descripcion":"PARCHE MUCOSO DE MUCOSA ORAL"
  },
  {
    "codigo":251225004,
    "descripcion":"ALTURA DE LA ONDA Q AUMENTADA"
  },
  {
    "codigo":85550003,
    "descripcion":"ALUCINACIÓN CENESTÉSICA"
  },
  {
    "codigo":249390006,
    "descripcion":"PALADAR - HALLAZGO"
  },
  {
    "codigo":282158009,
    "descripcion":"NO CAMINA PENDIENTE ARRIBA"
  },
  {
    "codigo":295651000119104,
    "descripcion":"DEPÓSITO DE CALCIO EN BOLSA SEROSA DE CODO"
  },
  {
    "codigo":444163006,
    "descripcion":"LIPODISTROFIA DE CARA"
  },
  {
    "codigo":247555009,
    "descripcion":"PELOS DE POHL-PINKUS"
  },
  {
    "codigo":1163224003,
    "descripcion":"LESIÓN POR PRESIÓN GRADO 4"
  },
  {
    "codigo":278488007,
    "descripcion":"SECCIÓN TRAUMÁTICA DEL ESÓFAGO"
  },
  {
    "codigo":1259693000,
    "descripcion":"GLIOSARCOMA PRIMARIO DE MÉDULA ESPINAL"
  },
  {
    "codigo":737240009,
    "descripcion":"NEUROPATÍA AUTONÓMICA DEBIDA A ENFERMEDAD ENDOCRINA"
  },
  {
    "codigo":473261001,
    "descripcion":"QUEMADURA EPIDÉRMICA DE MÚLTIPLES SITIOS DEL CUELLO"
  },
  {
    "codigo":276653007,
    "descripcion":"ARTRITIS POR PARVOVIRUS"
  },
  {
    "codigo":373122000,
    "descripcion":"MOVIMIENTO NORMAL DE LA PARED VENTRICULAR"
  },
  {
    "codigo":47277009,
    "descripcion":"FIEBRE IZUMI"
  },
  {
    "codigo":274818004,
    "descripcion":"REFLEJO AQUÍLEO, AUSENTE"
  },
  {
    "codigo":1088381000119103,
    "descripcion":"CONDRODERMATITIS NODULAR HELICOIDAL DE LA OREJA IZQUIERDA"
  },
  {
    "codigo":12674005,
    "descripcion":"SÍNDROME DE MALFORMACIÓN MÚLTIPLE, CON APARIENCIA TIPO SENIL"
  },
  {
    "codigo":405890006,
    "descripcion":"FENOTIPO S-S-"
  },
  {
    "codigo":305751001,
    "descripcion":"ATENDIDO POR ENFERMERA EXTRAHOSPITALARIA"
  },
  {
    "codigo":404055006,
    "descripcion":"RABDOMIOSARCOMA FUSOCELULAR"
  },
  {
    "codigo":762668000,
    "descripcion":"ESTIMULACIÓN DE BOLSILLO MUSCULAR DEBIDA A IMPLANTE DE MARCAPASOS CARDÍACO Y POSTERIOR A ÉL"
  },
  {
    "codigo":240215009,
    "descripcion":"PROLAPSO DE DISCO INTERVERTEBRAL CERVICAL"
  },
  {
    "codigo":271148002,
    "descripcion":"AMPOLLA TRAUMÁTICA DE HOMBRO"
  },
  {
    "codigo":402220004,
    "descripcion":"ECCEMA VESICULAR CRÓNICO REAGUDIZADO DE MANOS Y PIES"
  },
  {
    "codigo":860972006,
    "descripcion":"AMBOS MIEMBROS SUPERIORES Y AMBOS MIEMBROS INFERIORES NORMALES"
  },
  {
    "codigo":369452007,
    "descripcion":"TUMOR MALIGNO QUE COMPROMETE EL RECTO POR PROPAGACIÓN DIRECTA DEL CUELLO UTERINO"
  },
  {
    "codigo":41772008,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE TOBILLO SIN INFECCIÓN"
  },
  {
    "codigo":238380009,
    "descripcion":"FOLICULITIS POR GRAMNEGATIVOS"
  },
  {
    "codigo":11793431000119101,
    "descripcion":"AMPOLLA DE PIE DERECHO, CON INFECCIÓN"
  },
  {
    "codigo":7169009,
    "descripcion":"ESTENOSIS AÓRTICA SUPRAVALVULAR CONGÉNITA"
  },
  {
    "codigo":1119446004,
    "descripcion":"ATROFIA DE MÚSCULO FLEXOR LARGO DE DEDOS DE PIE"
  },
  {
    "codigo":300246005,
    "descripcion":"LESIÓN DE LENGUA"
  },
  {
    "codigo":201942006,
    "descripcion":"ARTROPATÍA TRAUMÁTICA DE LA ARTICULACIÓN ESTERNOCLAVICULAR"
  },
  {
    "codigo":12203031000119103,
    "descripcion":"FILTRACIÓN POR CONDUCTO BILIAR POSTERIOR A PROCEDIMIENTO"
  },
  {
    "codigo":365782006,
    "descripcion":"NIVEL SÉRICO DE HORMONAS SEXUALES FEMENINAS - HALLAZGO"
  },
  {
    "codigo":298411001,
    "descripcion":"AMPLITUD DE FLEXIÓN PASIVA DE LA COLUMNA CERVICAL NORMAL"
  },
  {
    "codigo":726230009,
    "descripcion":"DISTENSIÓN DE TENDÓN DE MÚSCULO ADUCTOR DE MUSLO"
  },
  {
    "codigo":263808002,
    "descripcion":"MICROPROTEINURIA"
  },
  {
    "codigo":1148544003,
    "descripcion":"SOBREDOSIS DE ÁCIDO NICOTÍNICO"
  },
  {
    "codigo":1345152005,
    "descripcion":"SUSTANCIA ASPIRADA EN TRACTO RESPIRATORIO INFERIOR"
  },
  {
    "codigo":1279616005,
    "descripcion":"CORTE EN PIEL DE DEDO ANULAR DE MANO"
  },
  {
    "codigo":196437005,
    "descripcion":"ASINERGIA VENTRICULAR"
  },
  {
    "codigo":294741005,
    "descripcion":"ALERGIA A GOMA GUAR"
  },
  {
    "codigo":292906002,
    "descripcion":"REACCIÓN ADVERSA A DESINFECTANTE AZOICO A BASE DE TRIFENILMETANO"
  },
  {
    "codigo":129066006,
    "descripcion":"DEPENDENCIA PARA LA ADMINISTRACIÓN DEL DINERO"
  },
  {
    "codigo":717055000,
    "descripcion":"ALOPECIA FIBROSANTE FRONTAL"
  },
  {
    "codigo":1144874008,
    "descripcion":"APLASIA DE GLÁNDULA ECRINA"
  },
  {
    "codigo":782591002,
    "descripcion":"ALERGIA A PIRETROIDE"
  },
  {
    "codigo":192904000,
    "descripcion":"MIELOPATÍA POR OTRO TRASTORNO"
  },
  {
    "codigo":94463004,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LOS GANGLIOS LINFÁTICOS PARAMAMARIOS"
  },
  {
    "codigo":1306879000,
    "descripcion":"GLAUCOMA DE ÁNGULO ABIERTO BILATERAL DEBIDO A CIRUGÍA OFTALMOLÓGICA"
  },
  {
    "codigo":291071005,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR KETAZOLAM"
  },
  {
    "codigo":15699121000119104,
    "descripcion":"ATROFIA ÓPTICA DERECHA HEREDITARIA"
  },
  {
    "codigo":225535002,
    "descripcion":"CONDUCTA ERÓTICA"
  },
  {
    "codigo":127231009,
    "descripcion":"NEOPLASIA DEL TIMO"
  },
  {
    "codigo":289236001,
    "descripcion":"EXPULSIÓN RETARDADA DE LA PLACENTA"
  },
  {
    "codigo":190932003,
    "descripcion":"TRASTORNOS DE LA EXCRECIÓN DE BILIRRUBINA"
  },
  {
    "codigo":92628002,
    "descripcion":"CARCINOMA IN SITU DE LA GLÁNDULA LAGRIMAL"
  },
  {
    "codigo":420308006,
    "descripcion":"CAMBIOS VASCULARES RETINIANOS ASOCIADOS CON SIDA (SÍNDROME DE INMUNODEFICIENCIA ADQUIRIDA)"
  },
  {
    "codigo":353611000119100,
    "descripcion":"CARCINOMA IN SITU DE OJO IZQUIERDO"
  },
  {
    "codigo":123561001,
    "descripcion":"ANOMALÍA CONGÉNITA DE FÉMUR"
  },
  {
    "codigo":58025002,
    "descripcion":"INTOXICACIÓN POR NANDROLONA"
  },
  {
    "codigo":1303209003,
    "descripcion":"TRANSECCIÓN COMPLETA DE ARTERIA CARÓTIDA"
  },
  {
    "codigo":1335977005,
    "descripcion":"QUISTE DE CUERPO CILIAR DE OJO DERECHO"
  },
  {
    "codigo":156329007,
    "descripcion":"DERMATITIS SEBORREICA DE CUERO CABELLUDO"
  },
  {
    "codigo":1137534000,
    "descripcion":"CALCIFICACIÓN PUNTEADA DE EPÍFISIS DE FALANGE PROXIMAL DE TERCER DEDO DE PIE"
  },
  {
    "codigo":416638004,
    "descripcion":"DREPANOCITOSIS-ENFERMEDAD DE LA HEMOGLOBINA E SIN CRISIS HEMOLÍTICA"
  },
  {
    "codigo":283731002,
    "descripcion":"MORDEDURA HUMANA EN EL DORSO DEL PIE"
  },
  {
    "codigo":447571007,
    "descripcion":"RETORNO VENOSO PULMONAR OBSTRUIDO POR COMPRESIÓN EXTRÍNSECA ENTRE ARTERIA PULMONAR IZQUIERDA Y BRONQUIO"
  },
  {
    "codigo":249128001,
    "descripcion":"MEMBRANAS EN RELOJ DE ARENA"
  },
  {
    "codigo":609576002,
    "descripcion":"DIABETES DEL ADULTO DE INICIO JUVENIL, TIPO 9"
  },
  {
    "codigo":773416006,
    "descripcion":"SÍNDROME DE DISCAPACIDAD INTELECTUAL, DISMORFIA FACIAL, ANOMALÍAS DE LA MANO"
  },
  {
    "codigo":445736006,
    "descripcion":"TUMOR DE ESTROMA GASTROINTESTINAL DEL ESTÓMAGO"
  },
  {
    "codigo":314664008,
    "descripcion":"LUXACIÓN DE ARTICULACIÓN DE LA MANO"
  },
  {
    "codigo":312829002,
    "descripcion":"ESTENOSIS DE LA PORCIÓN PROXIMAL DE LA ARTERIA FEMORAL"
  },
  {
    "codigo":1090891000119107,
    "descripcion":"COLESTEATOMA DEL ÁTICO EPITIMPÁNICO DEL OÍDO MEDIO DERECHO"
  },
  {
    "codigo":704210003,
    "descripcion":"FRACTURA NO EXPUESTA DE HOMBRO"
  },
  {
    "codigo":835282008,
    "descripcion":"AGUDEZA VISUAL DE OJO IZQUIERDO 6\/36"
  },
  {
    "codigo":736978009,
    "descripcion":"TROMBO MURAL DE VENTRÍCULO DERECHO POSTERIOR A INFARTO AGUDO DE MIOCARDIO"
  },
  {
    "codigo":276391004,
    "descripcion":"ALIMENTO EN MATERIA FECAL"
  },
  {
    "codigo":702375004,
    "descripcion":"ADENOMA HIPOFISARIO FAMILIAR AISLADO"
  },
  {
    "codigo":210855006,
    "descripcion":"LESIÓN DE VASOS SANGUÍNEOS A NIVEL DEL ANTEBRAZO"
  },
  {
    "codigo":1259431008,
    "descripcion":"CARCINOMA PRIMARIO DE CANAL ANAL"
  },
  {
    "codigo":307324001,
    "descripcion":"PIE ESPÁSTICO"
  },
  {
    "codigo":472999008,
    "descripcion":"MÚLTIPLES PAREJAS SEXUALES ANTERIORES"
  },
  {
    "codigo":405628005,
    "descripcion":"CONSENTIMIENTO MÉDICO OBTENIDO"
  },
  {
    "codigo":241788006,
    "descripcion":"EFECTO TÓXICO CAUSADO POR HERBICIDA DERIVADO DE FENOXIÁCIDO"
  },
  {
    "codigo":239953001,
    "descripcion":"LESIÓN DE PARTES BLANDAS"
  },
  {
    "codigo":403793002,
    "descripcion":"CALLOSIDADES DOLOROSAS FAMILIARES"
  },
  {
    "codigo":733308009,
    "descripcion":"HEMORRAGIA TRAUMÁTICA DE ÓRBITA"
  },
  {
    "codigo":209020009,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA NO EXPUESTA DE MÚLTIPLES ARTICULACIONES METATARSOFALÁNGICAS"
  },
  {
    "codigo":895313005,
    "descripcion":"FORMA DE BALA ANORMAL CONGÉNITA DE FALANGE MEDIA DE DEDO MEÑIQUE"
  },
  {
    "codigo":305489005,
    "descripcion":"BAJO ATENCIÓN DE ESPECIALISTA EN VÍAS GENITOURINARIAS"
  },
  {
    "codigo":15973861000119107,
    "descripcion":"NEOPLASIA ÓSEA BENIGNA BILATERAL DE PIE"
  },
  {
    "codigo":238118002,
    "descripcion":"DEFICIENCIA DE MAGNESIO"
  },
  {
    "codigo":10868351000119103,
    "descripcion":"SOBREDOSIS DE COAGULANTE"
  },
  {
    "codigo":41510006,
    "descripcion":"CONVULSIÓN ANÓXICA"
  },
  {
    "codigo":762406005,
    "descripcion":"FISURA DE PALADAR BLANDO CON FISURA LABIAL DERECHA"
  },
  {
    "codigo":400123002,
    "descripcion":"QUERATODERMIA PALMOPLANTAR DIFUSA HEREDITARIA"
  },
  {
    "codigo":6907002,
    "descripcion":"FACTOR DE HEMOLISINA"
  },
  {
    "codigo":619779711000119104,
    "descripcion":"MELANOMA IN SITU DE PIEL DE PIE IZQUIERDO"
  },
  {
    "codigo":170747006,
    "descripcion":"DIABÉTICO QUE UTILIZA INSULINA"
  },
  {
    "codigo":203515009,
    "descripcion":"HIPERTROFIA ÓSEA COMPENSADORA"
  },
  {
    "codigo":365520003,
    "descripcion":"POSIBILIDAD DE PRIVACIDAD EN EL ALOJAMIENTO - HALLAZGO"
  },
  {
    "codigo":789669000,
    "descripcion":"FLEBITIS DURANTE PROCEDIMIENTO"
  },
  {
    "codigo":300671000119108,
    "descripcion":"TRASTORNO DE TENDÓN DE MANO DERECHA"
  },
  {
    "codigo":10759961000119102,
    "descripcion":"ENFERMEDAD VIRAL EN LA MADRE QUE COMPLICA EL NACIMIENTO"
  },
  {
    "codigo":230778001,
    "descripcion":"PARÁLISIS CEREBRAL MONOPLÉJICA QUE AFECTA A LA EXTREMIDAD INFERIOR"
  },
  {
    "codigo":298149009,
    "descripcion":"LESIÓN ARTICULAR"
  },
  {
    "codigo":722298001,
    "descripcion":"SÍNDROME DE BALLARD"
  },
  {
    "codigo":1402001,
    "descripcion":"MIEDO"
  },
  {
    "codigo":296314004,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE MESCALINA"
  },
  {
    "codigo":10923801000119102,
    "descripcion":"FRACTURA NO EXPUESTA DE BASE DE TERCER HUESO METACARPIANO DE MANO DERECHA"
  },
  {
    "codigo":34170007,
    "descripcion":"DIETA PARA DIABETES DEL ADULTO"
  },
  {
    "codigo":15675161000119104,
    "descripcion":"TENOSINOVITIS DE AMBOS PIES"
  },
  {
    "codigo":683801000119104,
    "descripcion":"EPENDIMOMA PRIMARIO DE LÓBULO TEMPORAL"
  },
  {
    "codigo":65103009,
    "descripcion":"SIGNO DE GALEAZZI"
  },
  {
    "codigo":720463009,
    "descripcion":"SÍNDROME DE PULGARES EN ADUCCIÓN Y ARTROGRIPOSIS TIPO CHRISTIAN"
  },
  {
    "codigo":423716004,
    "descripcion":"PETEQUIAS CUTÁNEAS"
  },
  {
    "codigo":292644009,
    "descripcion":"REACCIÓN ADVERSA AL ÁCIDO BENZOICO"
  },
  {
    "codigo":126969002,
    "descripcion":"NEOPLASIA DEL NERVIO OCULOMOTOR"
  },
  {
    "codigo":94201002,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE VASO SANGUÍNEO DEL CUELLO"
  },
  {
    "codigo":329651000119102,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DEBIDO A TROMBO DE ARTERIA CARÓTIDA DERECHA"
  },
  {
    "codigo":125134006,
    "descripcion":"DENSIDAD RADIOLÓGICA ANORMAL, ÁREA REDUCIDA"
  },
  {
    "codigo":878798006,
    "descripcion":"MELANOMA IN SITU DE PIEL DEL ESCROTO"
  },
  {
    "codigo":92366007,
    "descripcion":"NEOPLASIA BENIGNA DE LA PIEL DE LA CADERA"
  },
  {
    "codigo":288974008,
    "descripcion":"DIFICULTAD PARA ESCUPIR"
  },
  {
    "codigo":90531003,
    "descripcion":"DIVERTÍCULO URETRAL"
  },
  {
    "codigo":287139006,
    "descripcion":"QUEMADURA EPIDÉRMICA DE LA CABEZA"
  },
  {
    "codigo":285304000,
    "descripcion":"CON RIESGO DE LESIÓN TRAUMÁTICA POR PRESIÓN"
  },
  {
    "codigo":418211009,
    "descripcion":"REACCIÓN ADVERSA A TOXINA BOTULÍNICA"
  },
  {
    "codigo":23160005,
    "descripcion":"PERIOSTITIS DE FÉMUR"
  },
  {
    "codigo":1268344005,
    "descripcion":"ANAFILAXIA POSOPERATORIA"
  },
  {
    "codigo":414541004,
    "descripcion":"NÓDULO DE KOEPPE EN IRIS"
  },
  {
    "codigo":283469006,
    "descripcion":"HERIDA PUNZANTE EN DEDO DE LA MANO"
  },
  {
    "codigo":445474002,
    "descripcion":"ÚLCERA CUTÁNEA CON BORDES EN SACABOCADOS"
  },
  {
    "codigo":248866005,
    "descripcion":"ADHERENCIAS DE LABIOS VULVARES"
  },
  {
    "codigo":1230071005,
    "descripcion":"PATRÓN DE USO EPISÓDICO PERJUDICIAL DE ANFETAMINA Y\/O DERIVADO DE ANFETAMINA"
  },
  {
    "codigo":247031005,
    "descripcion":"MANCHAS CLARAS EN EL IRIS PERIFÉRICO"
  },
  {
    "codigo":303181000119105,
    "descripcion":"TENDINITIS CALCIFICANTE DE PIERNA IZQUIERDA"
  },
  {
    "codigo":441804001,
    "descripcion":"TUMEFACCIÓN SUPERFICIAL"
  },
  {
    "codigo":291379003,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR TRATAMIENTO CAPILAR"
  },
  {
    "codigo":276129000,
    "descripcion":"EL CÓNYUGE ABANDONÓ EL HOGAR"
  },
  {
    "codigo":409036009,
    "descripcion":"ALTERACIÓN DE LA CONDUCTA DEL NIÑO"
  },
  {
    "codigo":686311000119101,
    "descripcion":"HISTIOCITOMA FIBROSO MALIGNO PRIMARIO DE PARTES BLANDAS DE CABEZA"
  },
  {
    "codigo":308897006,
    "descripcion":"HEMORRAGIA INTRABDOMINAL LUEGO DE PROCEDIMIENTO"
  },
  {
    "codigo":1259169006,
    "descripcion":"DETENCIÓN PARCIAL DE CRECIMIENTO DE RAÍZ DENTAL DEBIDA A TRAUMATISMO DENTAL Y POSTERIOR A ÉL"
  },
  {
    "codigo":405366000,
    "descripcion":"CAMA EN SALA DE RECUPERACIÓN NO DISPONIBLE"
  },
  {
    "codigo":10680551000119102,
    "descripcion":"NÓDULO DE PIEL DE DEDO DE AMBOS PIES"
  },
  {
    "codigo":11827431000119103,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN DE DEDO DE PIE IZQUIERDO"
  },
  {
    "codigo":733046006,
    "descripcion":"SÍNDROME DE ESTRABISMO E HIPERPLASIA HEMIFACIAL"
  },
  {
    "codigo":700278007,
    "descripcion":"ANOMALÍA VASCULAR CONGÉNITA DE PÁRPADO"
  },
  {
    "codigo":307062006,
    "descripcion":"BAJO ATENCIÓN DE HEMATÓLOGO CLÍNICO"
  },
  {
    "codigo":1157195001,
    "descripcion":"REACCIÓN ADVERSA A VACUNA VIRUS ENTERO INACTIVADO CONTRA COVID-19"
  },
  {
    "codigo":112871000119104,
    "descripcion":"CONTRACTURA CONGÉNITA DE ARTICULACIÓN DE DEDO DE PIE"
  },
  {
    "codigo":75851004,
    "descripcion":"DOLOR A LA PALPACIÓN EN CUERO CABELLUDO"
  },
  {
    "codigo":403531004,
    "descripcion":"DERMATOSIS PUSTULOSA EROSIVA DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":1255499004,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO DE DEDO MEÑIQUE"
  },
  {
    "codigo":237856002,
    "descripcion":"BRECHA ANIÓNICA INVERTIDA"
  },
  {
    "codigo":8480004,
    "descripcion":"AGNOSIA OLFATIVA"
  },
  {
    "codigo":170485005,
    "descripcion":"PORTADOR DE SALMONELLA"
  },
  {
    "codigo":236021006,
    "descripcion":"HERNIA INGUINAL DERECHA"
  },
  {
    "codigo":301557007,
    "descripcion":"CAPAZ DE MOVILIZARSE APOYÁNDOSE EN LOS MUEBLES"
  },
  {
    "codigo":70346000,
    "descripcion":"EDEMA GINGIVAL"
  },
  {
    "codigo":399861008,
    "descripcion":"ENGROSAMIENTO DE RETINA"
  },
  {
    "codigo":365258000,
    "descripcion":"PARÁLISIS DE NERVIO TIBIAL"
  },
  {
    "codigo":234186003,
    "descripcion":"OBSTRUCCIÓN DE PRÓTESIS DE VÁLVULA CARDÍACA"
  },
  {
    "codigo":15733121000119102,
    "descripcion":"RETINOSQUISIS BULLOSA DE OJO DERECHO"
  },
  {
    "codigo":299722005,
    "descripcion":"PREFERENCIA DE PIE IZQUIERDO"
  },
  {
    "codigo":430794006,
    "descripcion":"CON MAYOR RIESGO DE DELIRIO"
  },
  {
    "codigo":1217226000,
    "descripcion":"MIOPATÍA ESCAPULOHUMEROPERONEAL DISTAL PROGRESIVA"
  },
  {
    "codigo":135882008,
    "descripcion":"RESFRÍO FEBRIL"
  },
  {
    "codigo":35743001,
    "descripcion":"NISTAGMO PENDULAR"
  },
  {
    "codigo":398026008,
    "descripcion":"HIPOESTESIA CUTÁNEA"
  },
  {
    "codigo":363423001,
    "descripcion":"NEOPLASIA MALIGNA DE TABIQUE NASAL"
  },
  {
    "codigo":86401000119104,
    "descripcion":"DEPENDENCIA DE INHALANTE VOLÁTIL, EPISÓDICA"
  },
  {
    "codigo":723871004,
    "descripcion":"OCLUSIÓN AGUDA DE ARTERIA AORTOILÍACA DEBIDA A TROMBOSIS"
  },
  {
    "codigo":427124000,
    "descripcion":"BOLSA DE AIRE DESPLEGADA"
  },
  {
    "codigo":164980000,
    "descripcion":"MANTOUX: REACCIÓN TARDÍA"
  },
  {
    "codigo":33908005,
    "descripcion":"LESIÓN TRAUMÁTICA DE PERITONEO SIN HERIDA ABIERTA HACIA CAVIDAD ABDOMINAL"
  },
  {
    "codigo":1140008,
    "descripcion":"HIPOESTESIA TÉRMICA"
  },
  {
    "codigo":1344628009,
    "descripcion":"OSTEOMIELITIS DE RODILLA"
  },
  {
    "codigo":722036008,
    "descripcion":"SÍNDROME DE MEGALENCEFALIA, POLIMICROGIRIA, POLIDACTILIA POSTAXIAL E HIDROCEFALIA"
  },
  {
    "codigo":785737005,
    "descripcion":"BRONQUITIS CONCOMITANTE CON SIBILANCIAS CRÓNICAS"
  },
  {
    "codigo":294217006,
    "descripcion":"ALERGIA A PROBENECID"
  },
  {
    "codigo":95774001,
    "descripcion":"ATROFIA DE PAPILA ÓPTICA"
  },
  {
    "codigo":1177118004,
    "descripcion":"LAMINOPATÍA CON ENVEJECIMIENTO PREMATURO"
  },
  {
    "codigo":194078004,
    "descripcion":"ESOTROPÍA MONOCULAR CON PATRÓN X"
  },
  {
    "codigo":30238006,
    "descripcion":"INFERTILIDAD FEMENINA SECUNDARIA"
  },
  {
    "codigo":292382006,
    "descripcion":"REACCIÓN ADVERSA AL HALOPERIDOL"
  },
  {
    "codigo":305691000119104,
    "descripcion":"QUISTE DE ASTA ANTERIOR DE MENISCO INTERNO DE RODILLA DERECHA"
  },
  {
    "codigo":225011004,
    "descripcion":"SE SIENTE SUCIO"
  },
  {
    "codigo":290547004,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR BENZOCAÍNA"
  },
  {
    "codigo":126707007,
    "descripcion":"NEOPLASIA DEL HILIO PULMONAR"
  },
  {
    "codigo":92104000,
    "descripcion":"NEOPLASIA BENIGNA DE GANGLIOS LINFÁTICOS FEMORALES"
  },
  {
    "codigo":93939009,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE CONDUCTO PANCREÁTICO"
  },
  {
    "codigo":26568002,
    "descripcion":"HIPERTRICOSIS SACRA Y DIASTEMATOMIELIA"
  },
  {
    "codigo":223176004,
    "descripcion":"TRASTORNO CEREBELOSO"
  },
  {
    "codigo":124872005,
    "descripcion":"REDISTRIBUCIÓN DE LOS RECEPTORES DE SUPERFICIE"
  },
  {
    "codigo":712861006,
    "descripcion":"OSTEOMIELITIS DE SACRO"
  },
  {
    "codigo":22898001,
    "descripcion":"FLUJO VASCULAR DE TIPO TURBULENTO"
  },
  {
    "codigo":186738001,
    "descripcion":"VÉRTIGO EPIDÉMICO"
  },
  {
    "codigo":285042003,
    "descripcion":"INCAPAZ DE USAR ANTEOJOS"
  },
  {
    "codigo":11774491000119109,
    "descripcion":"AMPOLLA DE DEDO PULGAR IZQUIERDO, CON INFECCIÓN"
  },
  {
    "codigo":12403381000119103,
    "descripcion":"INESTABILIDAD DE PRÓTESIS DE ARTICULACIÓN DE RODILLA DERECHA"
  },
  {
    "codigo":448882009,
    "descripcion":"NEOPLASIA MALIGNA DE ÓRGANO INTRABDOMINAL"
  },
  {
    "codigo":250439007,
    "descripcion":"PIOCITOS PRESENTES"
  },
  {
    "codigo":283207008,
    "descripcion":"ANZUELO EN ESPALDA"
  },
  {
    "codigo":1231644001,
    "descripcion":"CATARATA DEBIDA A DESNUTRICIÓN"
  },
  {
    "codigo":707356001,
    "descripcion":"CARCINOMA PRIMARIO DE CÉLULAS ESCAMOSAS DE SENO FRONTAL"
  },
  {
    "codigo":19228003,
    "descripcion":"INTENTO FALLIDO DE ABORTO CON PERFORACIÓN DE VEJIGA"
  },
  {
    "codigo":10738511000119100,
    "descripcion":"HIPERPLASIA ATÍPICA DE CONDUCTO GALACTÓFORO DE MAMA DERECHA"
  },
  {
    "codigo":248604008,
    "descripcion":"ESPUTO CLARO"
  },
  {
    "codigo":246769000,
    "descripcion":"MOVIMIENTOS SACÁDICOS HIPERMÉTRICOS"
  },
  {
    "codigo":738289002,
    "descripcion":"ANTÍGENO LEUCOCÍTICO HUMANO B*57:01 NO DETECTADO"
  },
  {
    "codigo":281372009,
    "descripcion":"PRIMERA VÉRTEBRA SACRA LUMBARIZADA"
  },
  {
    "codigo":17393007,
    "descripcion":"SÍNDROME DE HIPERABDUCCIÓN"
  },
  {
    "codigo":408774002,
    "descripcion":"CONSENTIMIENTO PARA EXAMEN POSTMORTEM, OTORGADO"
  },
  {
    "codigo":81094005,
    "descripcion":"QUEMADURA EPIDÉRMICA DE MUSLO"
  },
  {
    "codigo":769222008,
    "descripcion":"EDEMA DE MÁCULA CLÍNICAMENTE SIGNIFICATIVO DE OJO IZQUIERDO DEBIDO A DIABETES MELLITUS"
  },
  {
    "codigo":308635004,
    "descripcion":"TRASTORNOS OCASIONADOS POR PRÓTESIS E IMPLANTES"
  },
  {
    "codigo":110192005,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO DE MUCOSA YUGAL"
  },
  {
    "codigo":11888009,
    "descripcion":"SÍNDROME DE HIPERVISCOSIDAD"
  },
  {
    "codigo":763717004,
    "descripcion":"SECUENCIA DISRUPTIVA ESPORÁDICA DEL CEREBRO FETAL"
  },
  {
    "codigo":75589004,
    "descripcion":"DIFTERIA NASOFARÍNGEA"
  },
  {
    "codigo":370501004,
    "descripcion":"TELITIS"
  },
  {
    "codigo":403269008,
    "descripcion":"VITILIGO GENERALIZADO"
  },
  {
    "codigo":8218002,
    "descripcion":"HIPERTENSIÓN CRÓNICA QUE COMPLICA EL PARTO Y\/O CONSTITUYE UN MOTIVO DE ATENCIÓN DURANTE ESTE PROCEDIMIENTO"
  },
  {
    "codigo":204826004,
    "descripcion":"ANOMALÍAS DEL LIGAMENTO ANCHO Y TROMPA DE FALOPIO"
  },
  {
    "codigo":237594007,
    "descripcion":"ANOMALÍA DE LA SECRECIÓN DE SEROTONINA"
  },
  {
    "codigo":792815000,
    "descripcion":"PULSO EN ARTERIA POPLÍTEA IZQUIERDA PRESENTE"
  },
  {
    "codigo":434202008,
    "descripcion":"RECHAZO HIPERAGUDO DE TRASPLANTE DE PÁNCREAS"
  },
  {
    "codigo":1251567001,
    "descripcion":"ÉMBOLO DE AURÍCULA DE CORAZÓN"
  },
  {
    "codigo":301295003,
    "descripcion":"HALLAZGO RELACIONADO CON UN DISPOSITIVO RESPIRATORIO"
  },
  {
    "codigo":202991003,
    "descripcion":"ABSCESO DE TENDÓN DE PIERNA"
  },
  {
    "codigo":40986008,
    "descripcion":"QUEMADURA EPIDÉRMICA DE PIE"
  },
  {
    "codigo":399599006,
    "descripcion":"CONDILOMA ACUMINADO DE VAGINA"
  },
  {
    "codigo":6383007,
    "descripcion":"TRABAJO DE PARTO PREMATURO"
  },
  {
    "codigo":235759004,
    "descripcion":"PROCTITIS PRODUCIDA POR SUSTANCIAS QUÍMICAS"
  },
  {
    "codigo":364996000,
    "descripcion":"PATRÓN DE CONDUCCIÓN NERVIOSA MOTORA - HALLAZGO"
  },
  {
    "codigo":299460002,
    "descripcion":"PIE AGRANDADO"
  },
  {
    "codigo":102852005,
    "descripcion":"CRISTAL URINARIO, BILIRRUBINA"
  },
  {
    "codigo":117891000119100,
    "descripcion":"CONVULSIÓN PARCIAL SIMPLE"
  },
  {
    "codigo":2713001,
    "descripcion":"NEUMOTÓRAX CERRADO"
  },
  {
    "codigo":428697002,
    "descripcion":"TUBERCULOSIS PULMONAR INACTIVA"
  },
  {
    "codigo":35481005,
    "descripcion":"TRASTORNO BIPOLAR I MIXTO EN REMISIÓN"
  },
  {
    "codigo":363161007,
    "descripcion":"ENFERMEDAD INFECCIOSA DEL SISTEMA INMUNITARIO"
  },
  {
    "codigo":263022003,
    "descripcion":"LUXACIÓN POSTERIOR DE HOMBRO"
  },
  {
    "codigo":371271000221108,
    "descripcion":"HEMORRAGIA DURANTE EL PRIMER TRIMESTRE DEL EMBARAZO"
  },
  {
    "codigo":164718005,
    "descripcion":"PROCEDIMIENTO DE DIAGNÓSTICO NEUROLÓGICO - ANORMAL"
  },
  {
    "codigo":721774006,
    "descripcion":"INFECCIÓN CAUSADA POR ERYTHROPARVOVIRUS"
  },
  {
    "codigo":230254007,
    "descripcion":"ENFERMEDAD DE LA NEURONA MOTORA DEL PACÍFICO OCCIDENTAL"
  },
  {
    "codigo":293955000,
    "descripcion":"ALERGIA A METILFENIDATO"
  },
  {
    "codigo":426862007,
    "descripcion":"ESTRABISMO RESTRICTIVO POR FIBROSIS ORBITARIA"
  },
  {
    "codigo":64579005,
    "descripcion":"EFECTO CARCINÓGENO EN LA DESCENDENCIA"
  },
  {
    "codigo":228419006,
    "descripcion":"EL CONSUMO DE DROGAS TIENE PRIORIDAD SOBRE LAS OBLIGACIONES FAMILIARES"
  },
  {
    "codigo":128280002,
    "descripcion":"LINFANGITIS AGUDA DE PIE"
  },
  {
    "codigo":161048004,
    "descripcion":"REGISTRADO COMO DISCAPACITADO"
  },
  {
    "codigo":1074461000119100,
    "descripcion":"ARTROSIS DE PIE DERECHO"
  },
  {
    "codigo":423192007,
    "descripcion":"CON MAYOR RIESGO DE CONFUSIÓN AGUDA"
  },
  {
    "codigo":93677000,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL CUERPO AÓRTICO"
  },
  {
    "codigo":1142253001,
    "descripcion":"HIPERTROFIA DE MÚSCULO DE EXTREMIDAD SUPERIOR DERECHA"
  },
  {
    "codigo":62744007,
    "descripcion":"ORTOPNEA"
  },
  {
    "codigo":290285000,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR NEFOPAM"
  },
  {
    "codigo":292120008,
    "descripcion":"REACCIÓN ADVERSA A LA OLSALAZINA"
  },
  {
    "codigo":718104007,
    "descripcion":"SÍNDROME DE TORSIÓN DE LA PUNTA CON INTERVALO DE ACOPLAMIENTO CORTO"
  },
  {
    "codigo":29976007,
    "descripcion":"TRACOMA, ESTADIO INICIAL"
  },
  {
    "codigo":880109007,
    "descripcion":"INGESTA INADECUADA DE ÁCIDO ASCÓRBICO"
  },
  {
    "codigo":191981008,
    "descripcion":"SÍNTOMA DE ÓRGANO SENSITIVO ESPECIAL, DE ORIGEN PSICÓGENO"
  },
  {
    "codigo":1010611006,
    "descripcion":"TORACOONFALÓPAGO"
  },
  {
    "codigo":288450004,
    "descripcion":"REALIZA ACTIVIDADES DE COPIADO"
  },
  {
    "codigo":91842005,
    "descripcion":"SEGMENTACIÓN PULMONAR ANORMAL"
  },
  {
    "codigo":124610008,
    "descripcion":"DEFICIENCIA DE N - ACETILNEURAMINATO LIASA"
  },
  {
    "codigo":337181000119105,
    "descripcion":"ECTROPIÓN MECÁNICO DE PÁRPADO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":448620001,
    "descripcion":"CONTINUACIÓN DE VENA CAVA INFERIOR EN LA VENA ÁCIGOS HACIA VENA CAVA SUPERIOR DERECHA"
  },
  {
    "codigo":22636003,
    "descripcion":"ESTADO PREMENOPÁUSICO"
  },
  {
    "codigo":284780004,
    "descripcion":"CAPAZ DE REALIZAR ACTIVIDAD DE HIGIENE PERSONAL"
  },
  {
    "codigo":88172005,
    "descripcion":"PAPILOMATOSIS ORAL"
  },
  {
    "codigo":186476008,
    "descripcion":"POLIOMIELITIS PARALÍTICA AGUDA NO BULBAR"
  },
  {
    "codigo":1003841002,
    "descripcion":"RESTOS DE VENA VITELINA"
  },
  {
    "codigo":20801005,
    "descripcion":"TRASTORNO SECUNDARIO DEL SENTIDO DEL GUSTO DE LOS SABORES ÁCIDOS"
  },
  {
    "codigo":1264150000,
    "descripcion":"DAÑO DE VEJIGA URINARIA POSTERIOR A EMBARAZO MOLAR"
  },
  {
    "codigo":414017008,
    "descripcion":"ENFERMEDAD CAUSADA POR PARAPOXVIRUS"
  },
  {
    "codigo":281110002,
    "descripcion":"AGNOSIA SOMATOSENSORIAL"
  },
  {
    "codigo":18966001,
    "descripcion":"ALUCINACIÓN AUTOSCÓPICA"
  },
  {
    "codigo":248342006,
    "descripcion":"BAJO PESO CORPORAL"
  },
  {
    "codigo":443115002,
    "descripcion":"EDEMA DE PARED TORÁCICA FETAL"
  },
  {
    "codigo":836331002,
    "descripcion":"AGUDEZA VISUAL CON AGUJERO ESTENOPEICO DE OJO DERECHO 6\/36"
  },
  {
    "codigo":15296000,
    "descripcion":"ESTERILIDAD"
  },
  {
    "codigo":16039351000119105,
    "descripcion":"CONDROMALACIA DE ARTICULACIÓN DE AMBAS MANOS"
  },
  {
    "codigo":15685201000119100,
    "descripcion":"QUERATITIS INTERSTICIAL DE OJO IZQUIERDO CAUSADA POR VIRUS HERPES ZÓSTER"
  },
  {
    "codigo":408512008,
    "descripcion":"ÍNDICE DE MASA CORPORAL, 40+ - OBESIDAD GRAVE"
  },
  {
    "codigo":898197001,
    "descripcion":"LEUCEMIA\/LINFOMA DE LINFOCITOS T EN EL ADULTO EN REMISIÓN"
  },
  {
    "codigo":46229002,
    "descripcion":"TRASTORNO BIPOLAR I MIXTO GRAVE SIN SÍNTOMAS PSICÓTICOS"
  },
  {
    "codigo":12381000132107,
    "descripcion":"SÍNDROME DE NEUMONITIS IDIOPÁTICA"
  },
  {
    "codigo":120401000119101,
    "descripcion":"CONDROCALCINOSIS DE MANO DEBIDA A TRASTORNO DEL METABOLISMO DEL CALCIO"
  },
  {
    "codigo":111765001,
    "descripcion":"INTOXICACIÓN CAUSADA POR PROCLORPERAZINA"
  },
  {
    "codigo":242837004,
    "descripcion":"AUTOINTOXICACIÓN POR PARAQUAT"
  },
  {
    "codigo":78997000,
    "descripcion":"ANEMIA MEGALOBLÁSTICA ASOCIADA A VEGETARIANISMO"
  },
  {
    "codigo":211904008,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO SUPERFICIAL DE PALMA DE LA MANO"
  },
  {
    "codigo":373909009,
    "descripcion":"SENSACIÓN DE SOFOCACIÓN"
  },
  {
    "codigo":109930004,
    "descripcion":"NEOPLASIA BENIGNA DE LOS NERVIOS PERIFÉRICOS DEL MIEMBRO SUPERIOR"
  },
  {
    "codigo":208234006,
    "descripcion":"FRACTURA EXPUESTA DEL CUERPO DEL OMÓPLATO"
  },
  {
    "codigo":1254975000,
    "descripcion":"DEPENDENCIA DE SUSTANCIA, CONTINUA"
  },
  {
    "codigo":699754008,
    "descripcion":"SÍNDROME OCULODENTAL"
  },
  {
    "codigo":403007000,
    "descripcion":"TIÑA DE CUERO CABELLUDO CAUSADA POR MICROSPORUM FERRUGINEUM"
  },
  {
    "codigo":697919000,
    "descripcion":"HIPERTENSIÓN PULMONAR DEBIDA A TRASTORNO HEMATOLÓGICO POSESPLENECTOMÍA"
  },
  {
    "codigo":337471007,
    "descripcion":"FISURA DE LABIO SUPERIOR, MAXILAR SUPERIOR Y PALADAR"
  },
  {
    "codigo":763455008,
    "descripcion":"ENFERMEDAD DE CHARCOT-MARIE-TOOTH LIGADA AL CROMOSOMA X TIPO 1"
  },
  {
    "codigo":206399009,
    "descripcion":"HEMORRAGIA SUBARACNOIDEA INTRACRANEAL POR TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":370239008,
    "descripcion":"LACERACIÓN SUPERFICIAL DE DEDO DEL PIE"
  },
  {
    "codigo":1187604002,
    "descripcion":"ACTIVO EN EL SERVICIO MILITAR"
  },
  {
    "codigo":73492000,
    "descripcion":"INFECCIÓN CAUSADA POR SPARGANUM PROLIFERUM"
  },
  {
    "codigo":7956006,
    "descripcion":"VÉRTIGO PSICÓGENO"
  },
  {
    "codigo":301033000,
    "descripcion":"FRACTURA DE LA RAMA INFERIOR DEL PUBIS"
  },
  {
    "codigo":6121001,
    "descripcion":"HIPERPLASIA EPITELIAL FOCAL DE LA BOCA"
  },
  {
    "codigo":202729001,
    "descripcion":"PROLAPSO DE DISCO INTERVERTEBRAL CERVICAL CON MIELOPATÍA"
  },
  {
    "codigo":237332009,
    "descripcion":"DESGARRO DE VULVA"
  },
  {
    "codigo":11998801000119108,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO DE PIERNA DERECHA"
  },
  {
    "codigo":268265008,
    "descripcion":"ANOMALÍA CONGÉNITA DE CODO Y BRAZO"
  },
  {
    "codigo":266430000,
    "descripcion":"MELANOPLAQUIA BUCAL"
  },
  {
    "codigo":366569008,
    "descripcion":"AMPLITUD DE MOVIMIENTO ACTIVO DE ABDUCCIÓN DE LA CADERA - HALLAZGO"
  },
  {
    "codigo":37054000,
    "descripcion":"ATRESIA DE COLON"
  },
  {
    "codigo":364734006,
    "descripcion":"HALLAZGO RELACIONADO CON LA CALIDAD DE FABRICACIÓN DEL CALZADO"
  },
  {
    "codigo":102590007,
    "descripcion":"PALPITACIONES INTERMITENTES"
  },
  {
    "codigo":299198008,
    "descripcion":"ARTICULACIÓN DE PULGAR DOLOROSA A LA PALPACIÓN"
  },
  {
    "codigo":1149331001,
    "descripcion":"INTOXICACIÓN POR ALUMINIO Y\/O COMPUESTO DE ALUMINIO"
  },
  {
    "codigo":233662009,
    "descripcion":"SÍNDROME DE OBSTRUCCIÓN INTESTINAL DISTAL"
  },
  {
    "codigo":67987005,
    "descripcion":"INTOXICACIÓN POR INGESTA DE PESCADO"
  },
  {
    "codigo":41941000087101,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE CUARTO DEDO DE PIE IZQUIERDO"
  },
  {
    "codigo":788883008,
    "descripcion":"ACCIDENTE CEREBROVASCULAR ISQUÉMICO DEBIDO A ESTADO HIPERCOAGULABLE"
  },
  {
    "codigo":721512000,
    "descripcion":"SÍNDROME DEL CORDÓN ANTERIOR DE MÉDULA ESPINAL AL NIVEL DEL PRIMER SEGMENTO LUMBAR"
  },
  {
    "codigo":231827008,
    "descripcion":"NEVO PALPEBRAL"
  },
  {
    "codigo":339691000119105,
    "descripcion":"ENTROPIÓN ESPÁSTICO DE PÁRPADO INFERIOR IZQUIERDO"
  },
  {
    "codigo":12011000119105,
    "descripcion":"PIE PLANO VALGO CONGÉNITO"
  },
  {
    "codigo":39381000087109,
    "descripcion":"DISTENSIÓN DE TENDÓN DE EXTREMIDAD INFERIOR IZQUIERDA"
  },
  {
    "codigo":616006,
    "descripcion":"TRASTORNO PALPEBRAL SENSITIVOMOTOR"
  },
  {
    "codigo":47061000087107,
    "descripcion":"FRACTURA DE FALANGE PROXIMAL DE DEDO ANULAR DERECHO"
  },
  {
    "codigo":262760009,
    "descripcion":"LUXACIÓN TRAUMÁTICA DE PRÓTESIS OSICULAR"
  },
  {
    "codigo":228157003,
    "descripcion":"DISCAPACIDAD EN LA MOTRICIDAD GRUESA"
  },
  {
    "codigo":129853007,
    "descripcion":"INCONTINENCIA URINARIA TOTAL"
  },
  {
    "codigo":293693007,
    "descripcion":"ALERGIA A DICICLOMINA"
  },
  {
    "codigo":95250000,
    "descripcion":"GLAUCOMA SECUNDARIO POR MECANISMOS COMBINADOS"
  },
  {
    "codigo":717842002,
    "descripcion":"MEGAESÓFAGO IDIOPÁTICO"
  },
  {
    "codigo":422930008,
    "descripcion":"CREENCIAS ESPIRITUALES CONFLICTIVAS CON RESPECTO AL PLAN DE ATENCIÓN DE LA SALUD"
  },
  {
    "codigo":716007007,
    "descripcion":"SÍNDROME DE FISURA DE LABIO Y PALADAR CON SORDERA Y LIPOMA SACRO"
  },
  {
    "codigo":93415009,
    "descripcion":"TRANSPOSICIÓN CONGÉNITA DE LA VENA ÁCIGOS"
  },
  {
    "codigo":91580003,
    "descripcion":"OBSTRUCCIÓN CAUSADA POR ENGROSAMIENTO DE LAS PAREDES DEL INTESTINO"
  },
  {
    "codigo":124348005,
    "descripcion":"DEFICIENCIA DE SULFATO ADENILILTRANSFERASA (ADP)"
  },
  {
    "codigo":419260007,
    "descripcion":"REFLEJO AQUÍLEO ASIMÉTRICO"
  },
  {
    "codigo":56977002,
    "descripcion":"EDEMA IDIOPÁTICO"
  },
  {
    "codigo":286353005,
    "descripcion":"NO IMITA LA VOCALIZACIÓN"
  },
  {
    "codigo":1269393006,
    "descripcion":"SÍNDROME MEDULAR POSTERIOR DE MÉDULA TORÁCICA DEBIDO A SUBLUXACIÓN VERTEBRAL NO EXPUESTA DE COLUMNA TORÁCICA"
  },
  {
    "codigo":253585006,
    "descripcion":"HIPOPLASIA DE VALVA DE VÁLVULA PULMONAR"
  },
  {
    "codigo":24209009,
    "descripcion":"RASGO DE PERSONALIDAD MASOQUISTA"
  },
  {
    "codigo":284518002,
    "descripcion":"MOVIMIENTOS DE GOLPETEO REPETITIVOS"
  },
  {
    "codigo":188049009,
    "descripcion":"MELANOMA MALIGNO DE AXILA"
  },
  {
    "codigo":417425009,
    "descripcion":"ENFERMEDAD POR HEMOGLOBINA SS CON CRISIS HEMOLÍTICA"
  },
  {
    "codigo":415590006,
    "descripcion":"ESTRABISMO POR FRACTURA CONMINUTA DE ÓRBITA"
  },
  {
    "codigo":448358007,
    "descripcion":"DISPOSICIÓN AURICULAR NORMAL"
  },
  {
    "codigo":774203000,
    "descripcion":"SÍNDROME DE DISCAPACIDAD INTELECTUAL, RETRASO SEVERO DEL HABLA Y DISMORFIA LEVE"
  },
  {
    "codigo":86075001,
    "descripcion":"DÉFICIT DE LOS FACTORES DE LA COAGULACIÓN"
  },
  {
    "codigo":1003579000,
    "descripcion":"AGENESIA DE MANO DERECHA"
  },
  {
    "codigo":315451006,
    "descripcion":"NACIDO EN COSTA DE MARFIL"
  },
  {
    "codigo":708667008,
    "descripcion":"ÁNGULO GONÍACO AUMENTADO"
  },
  {
    "codigo":249915009,
    "descripcion":"ARTICULACIÓN DE MANO RÍGIDA"
  },
  {
    "codigo":248080002,
    "descripcion":"NO CONOCE EL PELIGRO DE UNA LÁMPARA CALIENTE"
  },
  {
    "codigo":16015391000119105,
    "descripcion":"OSTEOARTROSIS DE ARTICULACIONES MEDIOTARSIANAS DE AMBOS PIES"
  },
  {
    "codigo":870672007,
    "descripcion":"SECCIÓN EXPUESTA DE LIGAMENTO DE PUBIS"
  },
  {
    "codigo":96441000119101,
    "descripcion":"ENFERMEDAD RENAL CRÓNICA DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":704997005,
    "descripcion":"DEPRESIÓN INFERIOR DE SEGMENTO ST"
  },
  {
    "codigo":703162001,
    "descripcion":"PARO CARDÍACO BRADICÁRDICO"
  },
  {
    "codigo":735930004,
    "descripcion":"ALFABETIZACIÓN DE BAJO NIVEL"
  },
  {
    "codigo":1292986005,
    "descripcion":"FIBROMIXOMA ACRAL"
  },
  {
    "codigo":211642004,
    "descripcion":"CUERPO EXTRAÑO EN COLON SIGMOIDE"
  },
  {
    "codigo":277178004,
    "descripcion":"MEMBRANA TIMPÁNICA MÓVIL"
  },
  {
    "codigo":1260218009,
    "descripcion":"TIENE CONTACTO CON PERSONA INMUNOCOMPROMETIDA"
  },
  {
    "codigo":15034009,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN LA REGIÓN DE LA MAMA, CON INFECCIÓN"
  },
  {
    "codigo":109668000,
    "descripcion":"ARTROSIS DE ARTICULACIÓN TEMPOROMANDIBULAR"
  },
  {
    "codigo":371812001,
    "descripcion":"ESTADO DE ANGINA RECURRENTE CONSECUTIVO A ATERECTOMÍA CORONARIA DIRECCIONAL"
  },
  {
    "codigo":111503008,
    "descripcion":"DISTROFIA MUSCULAR CONGÉNITA POR DEFICIENCIA DE MEROSINA"
  },
  {
    "codigo":275343008,
    "descripcion":"FRACTURA EXPUESTA DE TROCÁNTER MAYOR DE FÉMUR"
  },
  {
    "codigo":904002,
    "descripcion":"SIGNO DE PINARD"
  },
  {
    "codigo":207972007,
    "descripcion":"FRACTURA EXPUESTA DE VÉRTEBRA LUMBAR, TRICOLUMNAR"
  },
  {
    "codigo":699492008,
    "descripcion":"CARIES DENTAL CLASE IV"
  },
  {
    "codigo":402745002,
    "descripcion":"ERITEMA ANULAR CAUSADO POR FÁRMACO"
  },
  {
    "codigo":1156409003,
    "descripcion":"EPENDIMOMA ANAPLÁSICO DE SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":75065003,
    "descripcion":"CRETINISMO ENDÉMICO"
  },
  {
    "codigo":271673003,
    "descripcion":"PARED ABDOMINAL LAXA"
  },
  {
    "codigo":9529007,
    "descripcion":"SARCOIDOSIS, TIPO ERITRODÉRMICA"
  },
  {
    "codigo":1254713008,
    "descripcion":"REQUIERE SERVICIO DE INTERPRETACIÓN LINGÜÍSTICA PARA APOYAR EL CONOCIMIENTO SOBRE LA SALUD"
  },
  {
    "codigo":238905009,
    "descripcion":"LIPOMATOSIS ENCEFALOCRANEOCUTÁNEA"
  },
  {
    "codigo":237070001,
    "descripcion":"CANDIDIASIS UTERINA"
  },
  {
    "codigo":342201000119108,
    "descripcion":"CONJUNTIVITIS AGUDA DE OJO IZQUIERDO CAUSADA POR SUSTANCIA QUÍMICA"
  },
  {
    "codigo":73230009,
    "descripcion":"SENSIBILIDAD NORMAL DE LA PIEL"
  },
  {
    "codigo":5859004,
    "descripcion":"INTOXICACIÓN POR GÉNERO GASTROLOBIUM"
  },
  {
    "codigo":300771007,
    "descripcion":"NO REALIZA ACTIVIDADES RECREATIVAS Y DEPORTIVAS"
  },
  {
    "codigo":253448001,
    "descripcion":"ANOMALÍA EN ARCADA DE CUERDAS TENDINOSAS DE VÁLVULA AURICULOVENTRICULAR COMÚN"
  },
  {
    "codigo":366307009,
    "descripcion":"PERMEABILIDAD DEL ORIFICIO CERVICAL DEL ÚTERO - HALLAZGO"
  },
  {
    "codigo":298936003,
    "descripcion":"ARTICULACIÓN DE CODO CALIENTE AL TACTO"
  },
  {
    "codigo":724920005,
    "descripcion":"LACERACIÓN DE TENDÓN DE CABEZA LARGA DE BÍCEPS BRAQUIAL"
  },
  {
    "codigo":1149069001,
    "descripcion":"SÍNDROME DE POLIPOSIS JUVENIL CON TELANGIECTASIA HEMORRÁGICA HEREDITARIA"
  },
  {
    "codigo":297101001,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE UROCINASA"
  },
  {
    "codigo":428173007,
    "descripcion":"INSUFICIENCIA RESPIRATORIA CRÓNICA HIPOXÉMICA"
  },
  {
    "codigo":723085008,
    "descripcion":"SECUELA DE HEMORRAGIA SUBARACNOIDEA INTRACRANEAL NO TRAUMÁTICA"
  },
  {
    "codigo":67725009,
    "descripcion":"BLOQUEO NEUROMUSCULAR INDUCIDO POR ANTIBIÓTICOS"
  },
  {
    "codigo":33122006,
    "descripcion":"ENFERMEDAD CAUSADA POR PENTASTOMA"
  },
  {
    "codigo":721250007,
    "descripcion":"ABSCESO DE MÉDULA ESPINAL CAUSADO POR BACTERIA"
  },
  {
    "codigo":129591001,
    "descripcion":"HIPERCOLESTEROLEMIA E HIPERTRIGLICERIDEMIA MIXTA"
  },
  {
    "codigo":162359003,
    "descripcion":"OTALGIA BILATERAL"
  },
  {
    "codigo":293431004,
    "descripcion":"REACCIÓN ADVERSA A LOS TRIGLICÉRIDOS MARINOS OMEGA-3"
  },
  {
    "codigo":1145399007,
    "descripcion":"APLASIA DE EPICÓNDILO"
  },
  {
    "codigo":94988002,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA PLEURA PARIETAL"
  },
  {
    "codigo":1340172003,
    "descripcion":"SÍNDROME DE NEUROPATÍA PERIFÉRICA Y NEURODEGENERACIÓN PROGRESIVA DE INICIO EN INFANCIA ASOCIADO AL GEN CLCN6"
  },
  {
    "codigo":291596003,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR CEFOTAXIMA"
  },
  {
    "codigo":224225002,
    "descripcion":"VIVE EN UN HOSPITAL"
  },
  {
    "codigo":289761004,
    "descripcion":"HALLAZGO RELACIONADO CON LA DILATACIÓN CERVICAL"
  },
  {
    "codigo":1010657008,
    "descripcion":"HIPOPLASIA SECUNDARIA BILATERAL DE PULMÓN"
  },
  {
    "codigo":191457008,
    "descripcion":"DEMENCIA SENIL CON CARACTERÍSTICAS PARANOIDES O DEPRESIVAS"
  },
  {
    "codigo":1303734004,
    "descripcion":"CICATRIZ DE AMBOS OJOS DEBIDA A CIRUGÍA FILTRANTE DE GLAUCOMA Y POSTERIOR A ELLA"
  },
  {
    "codigo":255158007,
    "descripcion":"NEOPLASIA BENIGNA DE LA CAVIDAD NASAL Y NASOFARINGE"
  },
  {
    "codigo":713910008,
    "descripcion":"APLASIA ERITROCÍTICA PURA MEDIADA POR ANTICUERPOS ADQUIRIDA CAUSADA POR AGENTE ESTIMULANTE DE LA ERITROPOYESIS"
  },
  {
    "codigo":253323000,
    "descripcion":"ANOMALÍA DEL SENO CORONARIO"
  },
  {
    "codigo":124086008,
    "descripcion":"UROBILINA POR DEBAJO DE RANGO DE REFERENCIA"
  },
  {
    "codigo":418998008,
    "descripcion":"QUERATITIS QUÍMICA"
  },
  {
    "codigo":417163006,
    "descripcion":"LESIÓN TRAUMÁTICA O NO TRAUMÁTICA"
  },
  {
    "codigo":185952002,
    "descripcion":"POSEE SEGURO DE SALUD PRIVADO"
  },
  {
    "codigo":251488002,
    "descripcion":"ONDAS PICUDAS FOCALES"
  },
  {
    "codigo":448096002,
    "descripcion":"ORIGEN ABERRANTE DE ARTERIA SUBCLAVIA IZQUIERDA"
  },
  {
    "codigo":1201760007,
    "descripcion":"SEPSIS CAUSADA POR BACTEROIDES"
  },
  {
    "codigo":249653002,
    "descripcion":"CONDUCTO ANAL - HALLAZGO"
  },
  {
    "codigo":446261004,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN ADQUIRIDA EN HOSPITAL"
  },
  {
    "codigo":184117004,
    "descripcion":"CÓDIGO POSTAL DEL PACIENTE - DESCONOCIDO"
  },
  {
    "codigo":15991431000119108,
    "descripcion":"CORIORRETINITIS DE AMBOS OJOS CAUSADA POR MYCOBACTERIUM TUBERCULOSIS"
  },
  {
    "codigo":18442000,
    "descripcion":"TETANIA HIPOCALCÉMICA NEONATAL"
  },
  {
    "codigo":313354001,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS DE BRONQUIO, EN EL LÓBULO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":247818001,
    "descripcion":"MIEDO A SUFRIR UN ATAQUE CARDÍACO"
  },
  {
    "codigo":83978005,
    "descripcion":"MIOCARDIOPATÍA HIPERTRÓFICA FAMILIAR PRIMARIA"
  },
  {
    "codigo":82143003,
    "descripcion":"PERFORACIÓN POSTINFLAMATORIA DEL TÍMPANO"
  },
  {
    "codigo":16607004,
    "descripcion":"ABORTO INADVERTIDO"
  },
  {
    "codigo":1163487005,
    "descripcion":"COLITIS POR MICOBACTERIAS"
  },
  {
    "codigo":735668000,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE AMBAS PIERNAS A TRAVÉS DE LAS CADERAS"
  },
  {
    "codigo":111241000,
    "descripcion":"SÍNDROME ESCAPULOCOSTAL"
  },
  {
    "codigo":291771000119101,
    "descripcion":"SÍNDROME DE DOLOR REGIONAL COMPLEJO TIPO II DE MIEMBRO SUPERIOR DERECHO"
  },
  {
    "codigo":78473004,
    "descripcion":"REORDENAMIENTO GENÉTICO, CADENA BETA, RECEPTOR ANTIGÉNICO DE LINFOCITOS T"
  },
  {
    "codigo":1290889008,
    "descripcion":"SARCOMA SINOVIAL DE CÉLULAS FUSIFORMES"
  },
  {
    "codigo":240478003,
    "descripcion":"ÚLCERA HERPÉTICA ANOGENITAL PRIMARIA"
  },
  {
    "codigo":11787041000119109,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE DEDO DE MANO IZQUIERDA"
  },
  {
    "codigo":11102005,
    "descripcion":"FÍSTULA CONGÉNITA DE LABIO"
  },
  {
    "codigo":109406005,
    "descripcion":"FACIOSINOSTOSIS VÓMERO - PREMAXILAR"
  },
  {
    "codigo":74803002,
    "descripcion":"TAIJIN KYOFUSHO"
  },
  {
    "codigo":11842491000119104,
    "descripcion":"RUPTURA TRAUMÁTICA DE TENDÓN DE PIE DERECHO"
  },
  {
    "codigo":10835311000119100,
    "descripcion":"EPÍFISIS CAPITAL SUPERIOR DE FÉMUR IZQUIERDO DESPLAZADA"
  },
  {
    "codigo":336751000119101,
    "descripcion":"PERFORACIÓN DE LENTE INTRAOCULAR"
  },
  {
    "codigo":303471000119102,
    "descripcion":"DEPÓSITO DE CALCIO EN BOLSA SEROSA DE CADERA IZQUIERDA"
  },
  {
    "codigo":1076591000119103,
    "descripcion":"TENDINITIS DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":10681711000119101,
    "descripcion":"MASA DE PIEL DE AMBAS EXTREMIDADES INFERIORES"
  },
  {
    "codigo":15986031000119105,
    "descripcion":"MALFORMACIÓN CONGÉNITA DE VASO SANGUÍNEO DE ÓRBITA IZQUIERDA PROPIAMENTE DICHA"
  },
  {
    "codigo":16009071000119106,
    "descripcion":"DISPLASIA CONGÉNITA DE EXTREMIDAD SUPERIOR DERECHA"
  },
  {
    "codigo":16026991000119107,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DEBIDO A ESTENOSIS DE ARTERIA CARÓTIDA IZQUIERDA"
  },
  {
    "codigo":339311000119107,
    "descripcion":"MIOPATÍA DE MÚSCULO EXTRAOCULAR DE OJO IZQUIERDO"
  },
  {
    "codigo":10630511000119108,
    "descripcion":"LINFANGITIS AGUDA DE DEDO DE LA MANO"
  },
  {
    "codigo":331631000119105,
    "descripcion":"ENTROPIÓN DE PÁRPADO SUPERIOR DERECHO"
  },
  {
    "codigo":171272004,
    "descripcion":"SIN CONSENTIMIENTO PARA INMUNIZACIÓN CONTRA LA GRIPE"
  },
  {
    "codigo":238643009,
    "descripcion":"TRASTORNO DE EXFOLIACIÓN CUTÁNEA"
  },
  {
    "codigo":10635631000119106,
    "descripcion":"ÚLCERA CRÓNICA DE PIE IZQUIERDO"
  },
  {
    "codigo":16024431000119108,
    "descripcion":"ARTRITIS IDIOPÁTICA AGUDA JUVENIL POLIARTICULAR AGUDA"
  },
  {
    "codigo":15637871000119106,
    "descripcion":"LINFEDEMA DE MIEMBRO INFERIOR DERECHO"
  },
  {
    "codigo":21871000119107,
    "descripcion":"GASTRITIS SUPURATIVA"
  },
  {
    "codigo":308591000119108,
    "descripcion":"ANQUILOSIS DE ARTICULACIÓN SACROCOCCÍGEA DE LA COLUMNA VERTEBRAL"
  },
  {
    "codigo":366045003,
    "descripcion":"ASPECTO DE LA VENA DE LA RETINA - HALLAZGO"
  },
  {
    "codigo":300509007,
    "descripcion":"CORDÓN ESPERMÁTICO - HALLAZGO"
  },
  {
    "codigo":234973008,
    "descripcion":"DIENTE SUMERGIDO"
  },
  {
    "codigo":101461000119102,
    "descripcion":"PARÁLISIS DE NERVIO MUSCULOCUTÁNEO"
  },
  {
    "codigo":396978002,
    "descripcion":"TUMOR QUE INVADE NERVIO ÓPTICO ANTERIOR A LA LÁMINA CRIBOSA"
  },
  {
    "codigo":822962003,
    "descripcion":"ENROJECIMIENTO CUTÁNEO SOBRE LESIÓN"
  },
  {
    "codigo":167602003,
    "descripcion":"OLOR DESAGRADABLE DE MATERIA FECAL"
  },
  {
    "codigo":11816021000119102,
    "descripcion":"LESIÓN TRAUMÁTICA DE ARTERIA BRAQUIAL IZQUIERDA"
  },
  {
    "codigo":3762005,
    "descripcion":"HERNIA FEMORAL BILATERAL RECURRENTE CON GANGRENA"
  },
  {
    "codigo":10832981000119103,
    "descripcion":"FRACTURA EXPUESTA DE TERCER HUESO METACARPIANO DE MANO DERECHA"
  },
  {
    "codigo":298674008,
    "descripcion":"DOLOR AL MOVIMIENTO DE COLUMNA LUMBAR"
  },
  {
    "codigo":36530008,
    "descripcion":"DERMATITIS DE CONTACTO CAUSADA POR PESCADO"
  },
  {
    "codigo":131164001,
    "descripcion":"GRUPO SANGUÍNEO A>M<^H^"
  },
  {
    "codigo":720988006,
    "descripcion":"CON MAYOR RIESGO DE SHOCK"
  },
  {
    "codigo":295004007,
    "descripcion":"ALERGIA A TORASEMIDA"
  },
  {
    "codigo":293169001,
    "descripcion":"REACCIÓN ADVERSA A LA METILPREDNISOLONA"
  },
  {
    "codigo":194865003,
    "descripcion":"RUPTURA DE PARED CARDÍACA SIN HEMOPERICARDIO COMO COMPLICACIÓN ACTUAL LUEGO DE INFARTO AGUDO DE MIOCARDIO"
  },
  {
    "codigo":424241004,
    "descripcion":"CONDUCTA HOMICIDA"
  },
  {
    "codigo":127494000,
    "descripcion":"AUSENCIA DE INVASIÓN TUMORAL EN EL SISTEMA VASCULAR"
  },
  {
    "codigo":61958003,
    "descripcion":"ENFERMEDAD RESPIRATORIA ADENOVIRAL"
  },
  {
    "codigo":225798004,
    "descripcion":"DESINFORMADO"
  },
  {
    "codigo":193030005,
    "descripcion":"VARIEDADES DE MIGRAÑA"
  },
  {
    "codigo":1208838005,
    "descripcion":"UVEITIS ANTERIOR AGUDA IDIOPÁTICA"
  },
  {
    "codigo":94726007,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL ACROMION"
  },
  {
    "codigo":125659001,
    "descripcion":"HERIDA ABIERTA DE MUSLO"
  },
  {
    "codigo":92891002,
    "descripcion":"FORMA ANORMAL CONGÉNITA DEL ARCO DE LA VÉRTEBRA LUMBAR"
  },
  {
    "codigo":16501000202106,
    "descripcion":"COMPRENSIÓN ALTERADA ACERCA DEL PROPIO CUERPO"
  },
  {
    "codigo":27355003,
    "descripcion":"DOLOR DE DIENTES"
  },
  {
    "codigo":420571002,
    "descripcion":"RECHAZO DE ALOINJERTO SUBEPITELIAL CORNEAL"
  },
  {
    "codigo":289499007,
    "descripcion":"VULVA NORMAL"
  },
  {
    "codigo":60123008,
    "descripcion":"TRASTORNO DELIRANTE, TIPO MIXTO"
  },
  {
    "codigo":1336240001,
    "descripcion":"TRASTORNO POR USO DE METILENDIOXIMETANFETAMINA"
  },
  {
    "codigo":715483009,
    "descripcion":"ATROFIA OLIVOPONTOCEREBELOSA CONCOMITANTE CON HIPOACUSIA NEUROSENSORIAL"
  },
  {
    "codigo":123824001,
    "descripcion":"RUIDOS CARDÍACOS ANORMALES"
  },
  {
    "codigo":254896002,
    "descripcion":"MELANOMA MALIGNO DE VULVA"
  },
  {
    "codigo":23685000,
    "descripcion":"CARDIOPATÍA REUMÁTICA"
  },
  {
    "codigo":91056008,
    "descripcion":"INFECCIÓN CAUSADA POR THYSANOSOMA"
  },
  {
    "codigo":416901002,
    "descripcion":"MEDULOEPITELIOMA MALIGNO DE CUERPO CILIAR"
  },
  {
    "codigo":56453003,
    "descripcion":"ANGIOPATÍA AMILOIDE CEREBRAL HEREDITARIA, TIPO HOLANDESA"
  },
  {
    "codigo":285829004,
    "descripcion":"DIFICULTAD PARA CERRAR LAS CANILLAS DE AGUA"
  },
  {
    "codigo":449669007,
    "descripcion":"AUSENCIA DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":87386002,
    "descripcion":"ASPECTO DE PIEL DE NARANJA DE LA MAMA"
  },
  {
    "codigo":251226003,
    "descripcion":"ALTURA DE LA ONDA Q DISMINUIDA"
  },
  {
    "codigo":709978007,
    "descripcion":"RIÑÓN CONTRAÍDO"
  },
  {
    "codigo":21850008,
    "descripcion":"PLAGIOCEFALIA"
  },
  {
    "codigo":282159001,
    "descripcion":"DIFICULTAD PARA CAMINAR PENDIENTE ARRIBA"
  },
  {
    "codigo":85551004,
    "descripcion":"SÍNDROME DE HIPERMOVILIDAD"
  },
  {
    "codigo":249391005,
    "descripcion":"REPARACIÓN PREVIA DE HENDIDURA PALATINA"
  },
  {
    "codigo":413231006,
    "descripcion":"PATRÓN VASCULAR DISMINUIDO"
  },
  {
    "codigo":83716008,
    "descripcion":"COMPRESIÓN TRAUMÁTICA DE LA MÉDULA ESPINAL"
  },
  {
    "codigo":278489004,
    "descripcion":"PERFORACIÓN ARTERIAL TRAUMÁTICA"
  },
  {
    "codigo":212953005,
    "descripcion":"ENFERMEDAD POR DESCOMPRESIÓN TIPO I"
  },
  {
    "codigo":16345006,
    "descripcion":"ANTÍGENO DE GRUPO SANGUÍNEO G^U^"
  },
  {
    "codigo":737241008,
    "descripcion":"NEUROPATÍA AUTONÓMICA DEBIDA DEBIDA A ENFERMEDAD METABÓLICA"
  },
  {
    "codigo":276654001,
    "descripcion":"MALFORMACIÓN CONGÉNITA"
  },
  {
    "codigo":1259694006,
    "descripcion":"COREA DEBIDA A SÍNDROME SIMILAR A ENFERMEDAD DE HUNTINGTON TIPO 1"
  },
  {
    "codigo":473262008,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO DE MÚLTIPLES SITIOS DEL CUELLO"
  },
  {
    "codigo":209283001,
    "descripcion":"FRACTURA-SUBLUXACIÓN NO EXPUESTA DE MUÑECA"
  },
  {
    "codigo":373123005,
    "descripcion":"HIPERCINESIA DE LA REGIÓN DE LA PARED CARDÍACA"
  },
  {
    "codigo":78211006,
    "descripcion":"FRACTURA EXPUESTA DE LA COLUMNA DORSAL CON LESIÓN TRAUMÁTICA DE LA MÉDULA ESPINAL"
  },
  {
    "codigo":274819007,
    "descripcion":"REFLEJO TRICIPITAL, AUSENTE"
  },
  {
    "codigo":110979008,
    "descripcion":"DERMATITIS IRRITATIVA POR CONTACTO"
  },
  {
    "codigo":405891005,
    "descripcion":"FENOTIPO S+S-"
  },
  {
    "codigo":76376003,
    "descripcion":"ENDOMETRIOSIS DEL ÚTERO"
  },
  {
    "codigo":240216005,
    "descripcion":"PROLAPSO DE DISCO INTERVERTEBRAL TORÁCICO"
  },
  {
    "codigo":404056007,
    "descripcion":"SARCOMA ALVEOLAR DE PARTES BLANDAS"
  },
  {
    "codigo":402221000,
    "descripcion":"ECCEMA VESICULAR CRÓNICO REAGUDIZADO DE MANOS"
  },
  {
    "codigo":305752008,
    "descripcion":"ATENDIDO POR ENFERMERA DE ATENCIÓN PSIQUIÁTRICA AMBULATORIA"
  },
  {
    "codigo":11818531000119107,
    "descripcion":"ESGUINCE DE LIGAMENTO DE ARTICULACIÓN INTERFALÁNGICA DE DEDO MEÑIQUE IZQUIERDO"
  },
  {
    "codigo":369453002,
    "descripcion":"TUMOR MALIGNO QUE COMPROMETE EL RECTO POR PROPAGACIÓN DIRECTA DEL ÚTERO"
  },
  {
    "codigo":271149005,
    "descripcion":"AMPOLLA TRAUMÁTICA DE LA REGIÓN ESCAPULAR"
  },
  {
    "codigo":1087011000119108,
    "descripcion":"INFECCIÓN DE TRACTO GENITOURINARIO INFERIOR CONCOMITANTE CON ABSCESO DE GLÁNDULA PERIURETRAL CAUSADA POR GONOCOCCUS"
  },
  {
    "codigo":762669008,
    "descripcion":"ESTIMULACIÓN DE NERVIO FRÉNICO DEBIDA A IMPLANTE DE DESFIBRILADOR CARDÍACO AUTOMÁTICO Y POSTERIOR A ÉL"
  },
  {
    "codigo":1285122000,
    "descripcion":"DOLOR AGRAVADO POR DEAMBULACIÓN"
  },
  {
    "codigo":238381008,
    "descripcion":"GRANULOMA ESTAFILOCÓCICO"
  },
  {
    "codigo":302082003,
    "descripcion":"HALLAZGO RELACIONADO CON LA TALLA AL NACER"
  },
  {
    "codigo":1286957007,
    "descripcion":"CARCINOMA ESCAMOCELULAR IN SITU DE PIEL DE PIE"
  },
  {
    "codigo":300247001,
    "descripcion":"HALLAZGO RELACIONADO CON LA HUMEDAD DE LA LENGUA"
  },
  {
    "codigo":5335002,
    "descripcion":"DEFICIENCIA DE FOSFOENOLPIRUVATO CARBOXICINASA"
  },
  {
    "codigo":201943001,
    "descripcion":"ARTROPATÍA TRAUMÁTICA DE LA ARTICULACIÓN ACROMIOCLAVICULAR"
  },
  {
    "codigo":365783001,
    "descripcion":"NIVELES DE HORMONA SUPRARRENAL\/HIPOFISARIA - HALLAZGO"
  },
  {
    "codigo":1119447008,
    "descripcion":"ATROFIA DE MÚSCULO DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":726231008,
    "descripcion":"LACERACIÓN DE MÚSCULO ADUCTOR DE MUSLO"
  },
  {
    "codigo":10972861000119106,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO DIGITAL DE DEDO DE LA MANO DERECHA"
  },
  {
    "codigo":427649000,
    "descripcion":"CÁLCULO RENAL DE CALCIO"
  },
  {
    "codigo":298412008,
    "descripcion":"AMPLITUD DE FLEXIÓN PASIVA DE LA COLUMNA CERVICAL AUMENTADA"
  },
  {
    "codigo":1279617001,
    "descripcion":"HERIDA CORTANTE DE PIEL DE DEDO MEÑIQUE"
  },
  {
    "codigo":296577003,
    "descripcion":"SOBREDOSIS DE FÁRMACO ANTIHELMÍNTICO"
  },
  {
    "codigo":429192004,
    "descripcion":"ARTRITIS REUMATOIDE DEL PIE"
  },
  {
    "codigo":198273008,
    "descripcion":"ENTEROCELE VAGINAL CONGÉNITO"
  },
  {
    "codigo":60979006,
    "descripcion":"INFECCIÓN POR SCHISTOSOMA HAEMATOBIUM"
  },
  {
    "codigo":294742003,
    "descripcion":"ALERGIA A ACARBOSA"
  },
  {
    "codigo":65366005,
    "descripcion":"TROMBOSIS DE PEQUEÑOS VASOS DE LA PIEL"
  },
  {
    "codigo":292907006,
    "descripcion":"REACCIÓN ADVERSA AL CRISTAL VIOLETA"
  },
  {
    "codigo":1144875009,
    "descripcion":"APLASIA DE GLÁNDULA PARÓTIDA"
  },
  {
    "codigo":127232002,
    "descripcion":"NEOPLASIA DE GANGLIOS LINFÁTICOS"
  },
  {
    "codigo":225536001,
    "descripcion":"JUEGO SEXUAL PREVIO"
  },
  {
    "codigo":94464005,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LOS GANGLIOS LINFÁTICOS PARAMETRIALES"
  },
  {
    "codigo":782592009,
    "descripcion":"ALERGIA A ALCALOIDE DE LA RAUWOLFIA"
  },
  {
    "codigo":289237005,
    "descripcion":"VELOCIDAD NORMAL DE EXPULSIÓN DE LA PLACENTA"
  },
  {
    "codigo":92629005,
    "descripcion":"CARCINOMA IN SITU DEL INTESTINO GRUESO"
  },
  {
    "codigo":1335978000,
    "descripcion":"QUISTE DE CUERPO CILIAR DE AMBOS OJOS"
  },
  {
    "codigo":254634000,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS DE PULMÓN"
  },
  {
    "codigo":90794007,
    "descripcion":"INTOXICACIÓN POR BIFENILO POLICLORADO"
  },
  {
    "codigo":123562008,
    "descripcion":"ANOMALÍA CONGÉNITA DEL PERONÉ"
  },
  {
    "codigo":15671281000119104,
    "descripcion":"BRAQUIDACTILIA DE DEDOS DE PIE IZQUIERDO"
  },
  {
    "codigo":1137535004,
    "descripcion":"CALCIFICACIÓN PUNTEADA DE EPÍFISIS DE FALANGE PROXIMAL DE CUARTO DEDO DE PIE"
  },
  {
    "codigo":416639007,
    "descripcion":"BANCO DE NIEVE EN EL CUERPO VÍTREO"
  },
  {
    "codigo":283732009,
    "descripcion":"MORDEDURA HUMANA EN LA PLANTA DEL PIE"
  },
  {
    "codigo":773417002,
    "descripcion":"ALERGIA A ETINODIOL"
  },
  {
    "codigo":445737002,
    "descripcion":"TUMOR DEL ESTROMA GASTROINTESTINAL DE INTESTINO DELGADO"
  },
  {
    "codigo":1363241003,
    "descripcion":"QUISTE CONGÉNITO ÚNICO DE ENCÉFALO"
  },
  {
    "codigo":609577006,
    "descripcion":"DIABETES DEL ADULTO DE INICIO JUVENIL, TIPO 10"
  },
  {
    "codigo":85289008,
    "descripcion":"ERITROPSIA"
  },
  {
    "codigo":314665009,
    "descripcion":"SECCIÓN TRAUMÁTICA DE TENDÓN DE MÚSCULO EXTENSOR DE LA MANO"
  },
  {
    "codigo":736979001,
    "descripcion":"INFECCIÓN CUTÁNEA RECURRENTE"
  },
  {
    "codigo":835283003,
    "descripcion":"AGUDEZA VISUAL DE OJO DERECHO 6\/36"
  },
  {
    "codigo":704211004,
    "descripcion":"FRACTURA NO EXPUESTA DE FALANGE PROXIMAL DE DEDO GRANDE DEL PIE"
  },
  {
    "codigo":212691007,
    "descripcion":"INTOXICACIÓN CON ESTROFANTINA"
  },
  {
    "codigo":48851009,
    "descripcion":"ALTERACIÓN DE LA INTEGRIDAD DE LOS TEJIDOS"
  },
  {
    "codigo":1259432001,
    "descripcion":"CARCINOMA PRIMARIO DE COLON SIGMOIDES"
  },
  {
    "codigo":702376003,
    "descripcion":"SÍNDROME SIMILAR A LA ENFERMEDAD DE HUNTINGTON"
  },
  {
    "codigo":47016003,
    "descripcion":"FÓRMULA DE HIPERALIMENTACIÓN PARA EL TRATAMIENTO DE LA PANCREATITIS"
  },
  {
    "codigo":276392006,
    "descripcion":"HEMORROIDE FÁCILMENTE REDUCTIBLE"
  },
  {
    "codigo":210856007,
    "descripcion":"LESIÓN VENOSA A NIVEL DEL ANTEBRAZO"
  },
  {
    "codigo":14248008,
    "descripcion":"VAGINITIS CRÓNICA"
  },
  {
    "codigo":473000009,
    "descripcion":"ÚNICA PAREJA SEXUAL ANTERIOR"
  },
  {
    "codigo":405629002,
    "descripcion":"HIPOTIROIDISMO INFANTIL"
  },
  {
    "codigo":77949003,
    "descripcion":"TRASTORNO DEL NERVIO ACÚSTICO"
  },
  {
    "codigo":45181002,
    "descripcion":"NÓDULOS DE SCHMORL"
  },
  {
    "codigo":241789003,
    "descripcion":"EFECTO TÓXICO CAUSADO POR ÁCIDO 2,4,5-TRICLOROFENOXIACÉTICO"
  },
  {
    "codigo":209021008,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA NO EXPUESTA DE MÚLTIPLES ARTICULACIONES INTERFALÁNGICAS DE DEDO DE PIE"
  },
  {
    "codigo":305490001,
    "descripcion":"BAJO ATENCIÓN DE GERIATRA"
  },
  {
    "codigo":76114004,
    "descripcion":"FUNCIÓN RENAL DISMINUIDA"
  },
  {
    "codigo":895314004,
    "descripcion":"FORMA DE BALA ANORMAL CONGÉNITA DE FALANGE DE DEDO ÍNDICE"
  },
  {
    "codigo":239954007,
    "descripcion":"LESIÓN DE PARTES BLANDAS DE REGIÓN DE HOMBRO"
  },
  {
    "codigo":403794008,
    "descripcion":"PELO LANOSO DE HERENCIA AUTOSÓMICA DOMINANTE FAMILIAR"
  },
  {
    "codigo":371026009,
    "descripcion":"DEMENCIA SENIL CON PSICOSIS"
  },
  {
    "codigo":205351000,
    "descripcion":"PERODACTILIA DEL DEDO GORDO"
  },
  {
    "codigo":43346008,
    "descripcion":"DEFICIENCIA DE LA ACTIVIDAD PROCOAGULANTE DE LA PLAQUETAS"
  },
  {
    "codigo":762407001,
    "descripcion":"FISURA DE PALADAR BLANDO Y DURO CON FISURA IZQUIERDA DE LABIO"
  },
  {
    "codigo":41511005,
    "descripcion":"FRACTURA EXPUESTA DE LA FALANGE DISTAL DE DEDO DE LA MANO"
  },
  {
    "codigo":238119005,
    "descripcion":"DEFICIENCIA DE FOSFATO"
  },
  {
    "codigo":270887007,
    "descripcion":"RUPTURA DE QUISTE SINOVIAL DE RODILLA"
  },
  {
    "codigo":367356000,
    "descripcion":"OSTEOCONDRITIS DE HUESO SEMILUNAR DEL CARPO"
  },
  {
    "codigo":170748001,
    "descripcion":"ÚLTIMA CRISIS HIPOGLUCÉMICA"
  },
  {
    "codigo":203516005,
    "descripcion":"HIPERTROFIA ÓSEA IDIOPÁTICA"
  },
  {
    "codigo":301820005,
    "descripcion":"HALLAZGO RELACIONADO CON EL ESFUERZO RESPIRATORIO"
  },
  {
    "codigo":6908007,
    "descripcion":"MENOLIPSIS"
  },
  {
    "codigo":11850021000119106,
    "descripcion":"AMPOLLA DE MAMA DERECHA, CON INFECCIÓN"
  },
  {
    "codigo":365521004,
    "descripcion":"PRESENCIA DE ÁREAS PÚBLICAS EN EL ALOJAMIENTO - HALLAZGO"
  },
  {
    "codigo":1217489007,
    "descripcion":"NEUROFIBROMA DE ENCÍA"
  },
  {
    "codigo":3238004,
    "descripcion":"PERICARDITIS"
  },
  {
    "codigo":298150009,
    "descripcion":"DERRAME DE ARTICULACIÓN TEMPOROMANDIBULAR"
  },
  {
    "codigo":296315003,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE MESCALINA"
  },
  {
    "codigo":1092031000119104,
    "descripcion":"TROMPA DE EUSTAQUIO DERECHA PERMEABLE"
  },
  {
    "codigo":165243005,
    "descripcion":"INDEPENDIENTE EN EL MANEJO DE LA SILLA DE RUEDAS"
  },
  {
    "codigo":230779009,
    "descripcion":"PIE ESPÁSTICO CONGÉNITO"
  },
  {
    "codigo":720464003,
    "descripcion":"SÍNDROME ACRO-DERMATO-UNGUEAL-LAGRIMAL-DENTAL"
  },
  {
    "codigo":294480003,
    "descripcion":"ALERGIA A MUPIROCINA"
  },
  {
    "codigo":32336003,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE LA REGIÓN ESCAPULAR, CON INFECCIÓN"
  },
  {
    "codigo":126970001,
    "descripcion":"NEOPLASIA DEL NERVIO TROCLEAR"
  },
  {
    "codigo":290810005,
    "descripcion":"INTOXICACIÓN POR AMOXAPINA"
  },
  {
    "codigo":94202009,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE VASO SANGUÍNEO PÉLVICO"
  },
  {
    "codigo":190671002,
    "descripcion":"DESEQUILIBRIO EN LOS COMPONENTES DE LA INGESTA ALIMENTARIA"
  },
  {
    "codigo":878799003,
    "descripcion":"MELANOMA IN SITU DE BORDE BERMELLÓN DE LABIO"
  },
  {
    "codigo":92367003,
    "descripcion":"NEOPLASIA BENIGNA DE LA PIEL DE LA RODILLA"
  },
  {
    "codigo":15729241000119104,
    "descripcion":"LUXACIÓN DE ARTICULACIÓN DE PIE IZQUIERDO DEBIDA A DISPLASIA CONGÉNITA"
  },
  {
    "codigo":125135007,
    "descripcion":"DENSIDAD RADIOLÓGICA ANORMAL, DESIGUAL"
  },
  {
    "codigo":26831007,
    "descripcion":"OSTEÍTIS DE LA PIERNA"
  },
  {
    "codigo":1237412001,
    "descripcion":"DISPLASIA ESPONDILOMETAFISARIA REGRESIVA"
  },
  {
    "codigo":90532005,
    "descripcion":"LACERACIÓN CENTRAL DURANTE EL PARTO"
  },
  {
    "codigo":287140008,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DE CABEZA"
  },
  {
    "codigo":711289002,
    "descripcion":"FORMA ANORMAL DE DISCO ARTICULAR DE ARTICULACIÓN TEMPOROMANDIBULAR"
  },
  {
    "codigo":416377005,
    "descripcion":"ANGIOMA PLANO"
  },
  {
    "codigo":55929007,
    "descripcion":"SENTIMIENTO DE IRRITABILIDAD"
  },
  {
    "codigo":283470007,
    "descripcion":"HERIDA PUNZANTE EN EL PULGAR"
  },
  {
    "codigo":445475001,
    "descripcion":"NEUROPATÍA SENSITIVOMOTRIZ PARANEOPLÁSICA"
  },
  {
    "codigo":248867001,
    "descripcion":"HALLAZGO RELACIONADO CON EL CLÍTORIS"
  },
  {
    "codigo":19491003,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA NARIZ"
  },
  {
    "codigo":146251000146109,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÉDULA ESPINAL"
  },
  {
    "codigo":214264003,
    "descripcion":"LETARGO"
  },
  {
    "codigo":1230072003,
    "descripcion":"ABUSO DE ANFETAMINA Y\/O DERIVADO DE ANFETAMINA, CONTINUO"
  },
  {
    "codigo":247032003,
    "descripcion":"HIPOPIGMENTACIÓN DEL IRIS"
  },
  {
    "codigo":409037000,
    "descripcion":"ALTERACIÓN DE LA CONDUCTA DEL ADOLESCENTE"
  },
  {
    "codigo":703949001,
    "descripcion":"ESPECIE DE CEDECEA 3 O ESPECIE DE CEDECEA 5"
  },
  {
    "codigo":308898001,
    "descripcion":"HEMORRAGIA EXTRAPERITONEAL LUEGO DE PROCEDIMIENTO"
  },
  {
    "codigo":48589009,
    "descripcion":"TRASTORNO DEPRESIVO MENOR"
  },
  {
    "codigo":210594002,
    "descripcion":"SECCIÓN PARCIAL, TENDÓN DEL EXTENSOR DE LOS DEDOS DE LA MANO"
  },
  {
    "codigo":865954003,
    "descripcion":"ADENOCARCINOMA DE MAMA"
  },
  {
    "codigo":276130005,
    "descripcion":"SUBESTIMULADO"
  },
  {
    "codigo":1193634005,
    "descripcion":"NACIDO EN CABO VERDE"
  },
  {
    "codigo":208759001,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN ACROMIOCLAVICULAR"
  },
  {
    "codigo":700279004,
    "descripcion":"ANOMALÍA VASCULAR CONGÉNITA DE PÁRPADO SUPERIOR"
  },
  {
    "codigo":10761101000119105,
    "descripcion":"PARTO VAGINAL ASISTIDO CON EXTRACTOR DE VACÍO"
  },
  {
    "codigo":405367009,
    "descripcion":"EVALUACIÓN PREOPERATORIA INADECUADA"
  },
  {
    "codigo":43084005,
    "descripcion":"MADRE SOLTERA ADOLESCENTE"
  },
  {
    "codigo":75852006,
    "descripcion":"SIGNO DEL CINE"
  },
  {
    "codigo":403532006,
    "descripcion":"HIPERTRICOSIS CON MACROENCÍAS CONGÉNITAS"
  },
  {
    "codigo":8481000,
    "descripcion":"INTOXICACIÓN POR UREA"
  },
  {
    "codigo":1255500008,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO DE DEDO MEÑIQUE DE MANO IZQUIERDA"
  },
  {
    "codigo":29602701000119108,
    "descripcion":"MASA DE AMBAS REGIONES AXILARES"
  },
  {
    "codigo":399862001,
    "descripcion":"RETINOPATÍA PROLIFERATIVA DE ALTO RIESGO SIN EDEMA DE MÁCULA DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":301558002,
    "descripcion":"INCAPAZ DE DESPLAZARSE APOYÁNDOSE EN LOS MUEBLES"
  },
  {
    "codigo":236022004,
    "descripcion":"HERNIA INGUINAL IZQUIERDA"
  },
  {
    "codigo":684941000119109,
    "descripcion":"GLIOBLASTOMA MULTIFORME PRIMARIO DE LÓBULO TEMPORAL"
  },
  {
    "codigo":170486006,
    "descripcion":"PORTADOR DE MENINGOCOCO"
  },
  {
    "codigo":72182007,
    "descripcion":"INTOXICACIÓN POR NISTATINA"
  },
  {
    "codigo":299723000,
    "descripcion":"PREFERENCIA DE PIE DERECHO"
  },
  {
    "codigo":135883003,
    "descripcion":"TOS CON FIEBRE"
  },
  {
    "codigo":234187007,
    "descripcion":"VEGETACIÓN DE PRÓTESIS DE VÁLVULA CARDÍACA"
  },
  {
    "codigo":365259008,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA PREPARAR BEBIDA"
  },
  {
    "codigo":1217227009,
    "descripcion":"ESCEDOSPORIOSIS"
  },
  {
    "codigo":166816003,
    "descripcion":"LÍPIDOS SÉRICOS POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":723872006,
    "descripcion":"OCLUSIÓN AGUDA DE ARTERIA DE MIEMBRO INFERIOR DEBIDA A TROMBOSIS"
  },
  {
    "codigo":363424007,
    "descripcion":"NEOPLASIA MALIGNA DE CELDILLAS AÉREAS MASTOIDEAS"
  },
  {
    "codigo":1344629001,
    "descripcion":"OSTEOMIELITIS DE HUESO CARPIANO"
  },
  {
    "codigo":428960009,
    "descripcion":"GLIOMA DE BAJO GRADO DE TRONCO ENCEFÁLICO"
  },
  {
    "codigo":230517004,
    "descripcion":"COMPRESIÓN DEL QUIASMA ÓPTICO"
  },
  {
    "codigo":722037004,
    "descripcion":"SÍNDROME DE RETARDO MENTAL, CONVULSIONES EPILÉPTICAS, HIPOGONADISMO E HIPOGENITALISMO, MICROCEFALIA Y OBESIDAD"
  },
  {
    "codigo":296053004,
    "descripcion":"SOBREDOSIS DE BENZODIAZEPINA"
  },
  {
    "codigo":1141007,
    "descripcion":"PARESTESIA PERIORAL"
  },
  {
    "codigo":330791000119108,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DEBIDO A TROMBO DE ARTERIA CARÓTIDA IZQUIERDA"
  },
  {
    "codigo":294218001,
    "descripcion":"ALERGIA A SULFINPIRAZONA"
  },
  {
    "codigo":10953921000119102,
    "descripcion":"HERIDA ABIERTA DE MANO DERECHA DEBIDA A MORDEDURA DE GATO"
  },
  {
    "codigo":1144351000,
    "descripcion":"CICATRIZ CUTÁNEA POSTHERPÉTICA"
  },
  {
    "codigo":292383001,
    "descripcion":"REACCIÓN ADVERSA A LA DIFENILBUTILPIPERIDINA"
  },
  {
    "codigo":95775000,
    "descripcion":"ATROFIA RETROBULBAR DEL NERVIO ÓPTICO"
  },
  {
    "codigo":30239003,
    "descripcion":"ABSCESO AGUDO DE SENO ESFENOIDAL"
  },
  {
    "codigo":128543007,
    "descripcion":"TRASTORNO DE LOS CUERPOS CAVERNOSOS DEL PENE"
  },
  {
    "codigo":304321000119105,
    "descripcion":"GOTA TOFÁCEA CRÓNICA DEBIDA A DISFUNCIÓN RENAL"
  },
  {
    "codigo":194079007,
    "descripcion":"ESOTROPÍA MONOCULAR CON PATRÓN Y"
  },
  {
    "codigo":126708002,
    "descripcion":"NEOPLASIA DE BRONQUIO DEL LÓBULO SUPERIOR DERECHO DEL PULMÓN"
  },
  {
    "codigo":225012006,
    "descripcion":"SE SIENTE AVERGONZADO"
  },
  {
    "codigo":93940006,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL CUERPO PARAÓRTICO"
  },
  {
    "codigo":124873000,
    "descripcion":"ALTERACIÓN ANTIGÉNICA DE LA MEMBRANA PLASMÁTICA"
  },
  {
    "codigo":290548009,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR BENZOCAÍNA"
  },
  {
    "codigo":61172008,
    "descripcion":"FUCOSIDOSIS INFANTIL"
  },
  {
    "codigo":288713001,
    "descripcion":"CAPAZ DE UTILIZAR LA CONVERSACIÓN CON FINES RECREATIVOS"
  },
  {
    "codigo":92105004,
    "descripcion":"NEOPLASIA BENIGNA DE FÉMUR"
  },
  {
    "codigo":254110009,
    "descripcion":"OSTEOGÉNESIS IMPERFECTA TIPO II A"
  },
  {
    "codigo":285043008,
    "descripcion":"USA LENTES"
  },
  {
    "codigo":283208003,
    "descripcion":"ANZUELO EN EL TÓRAX"
  },
  {
    "codigo":1231645000,
    "descripcion":"CATARATA DEBIDA A DESHIDRATACIÓN"
  },
  {
    "codigo":250440009,
    "descripcion":"CÉLULAS CLUE PRESENTES"
  },
  {
    "codigo":445213003,
    "descripcion":"CATARATA SENIL INCIPIENTE"
  },
  {
    "codigo":281373004,
    "descripcion":"SACRALIZACIÓN DE QUINTA VÉRTEBRA LUMBAR"
  },
  {
    "codigo":707357005,
    "descripcion":"CARCINOMA PRIMARIO DE CÉLULAS ESCAMOSAS DE CARTÍLAGO LARÍNGEO"
  },
  {
    "codigo":248605009,
    "descripcion":"ESPUTO SUCIO"
  },
  {
    "codigo":443378001,
    "descripcion":"SÍNDROME DE LADY WINDERMERE"
  },
  {
    "codigo":17394001,
    "descripcion":"ANOMALÍA DE EBSTEIN CON DEFECTO DEL TABIQUE AURICULAR"
  },
  {
    "codigo":246770004,
    "descripcion":"MOVIMIENTO OCULAR DE SEGUIMIENTO"
  },
  {
    "codigo":82930004,
    "descripcion":"INFECCIÓN INTESTINAL CAUSADA POR PSEUDOMONAS"
  },
  {
    "codigo":408775001,
    "descripcion":"CONSENTIMIENTO PARA EXAMEN POSTMORTEM REHUSADO"
  },
  {
    "codigo":61448007,
    "descripcion":"ATELECTASIA FOCAL"
  },
  {
    "codigo":1162439007,
    "descripcion":"LESIÓN TRAUMÁTICA CAUSADA POR PRESIÓN DE AIRE"
  },
  {
    "codigo":10628751000119100,
    "descripcion":"DERMATITIS ALÉRGICA POR CONTACTO CAUSADA POR POLEN"
  },
  {
    "codigo":13724007,
    "descripcion":"CRECIMIENTO AUMENTADO DEL PELO"
  },
  {
    "codigo":110193000,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO DE MUCOSA YUGAL"
  },
  {
    "codigo":333301000119107,
    "descripcion":"CICLOPLEJÍA DE OJO DERECHO"
  },
  {
    "codigo":698182002,
    "descripcion":"PAPILOMA DE CÉLULAS ESCAMOSAS DE LA CAVIDAD BUCAL"
  },
  {
    "codigo":1288006003,
    "descripcion":"ARTRITIS REACTIVA DE ARTICULACIÓN DE PIE"
  },
  {
    "codigo":370502006,
    "descripcion":"MIELOENCEFALOPATÍA"
  },
  {
    "codigo":1156934008,
    "descripcion":"CAPACIDAD DE PROTECCIÓN EFECTIVA"
  },
  {
    "codigo":403270009,
    "descripcion":"VITILIGO TRICRÓMICO"
  },
  {
    "codigo":763718009,
    "descripcion":"MIOPATÍA FINLANDESA DE MIEMBRO SUPERIOR DE COMIENZO DISTAL"
  },
  {
    "codigo":40987004,
    "descripcion":"TRASTORNO EXPLOSIVO INTERMITENTE"
  },
  {
    "codigo":237595008,
    "descripcion":"ANORMALIDAD DE LA SECRECIÓN DE LA NEUROTENSINA"
  },
  {
    "codigo":301296002,
    "descripcion":"HALLAZGO RELACIONADO CON EL MEDIASTINO"
  },
  {
    "codigo":306831000119106,
    "descripcion":"GOTA DE MUÑECA CAUSADA POR FÁRMACO"
  },
  {
    "codigo":202992005,
    "descripcion":"ABSCESO DE TENDÓN DE PIE"
  },
  {
    "codigo":268528005,
    "descripcion":"ATENCIÓN COMPLETA POR ESPECIALISTA"
  },
  {
    "codigo":102853000,
    "descripcion":"CRISTAL URINARIO, CARBONATO DE CALCIO"
  },
  {
    "codigo":399600009,
    "descripcion":"LINFOMA-HALLAZGO"
  },
  {
    "codigo":235760009,
    "descripcion":"PROCTITIS POR RADIACIÓN"
  },
  {
    "codigo":299461003,
    "descripcion":"PIE PEQUEÑO"
  },
  {
    "codigo":363162000,
    "descripcion":"ENFERMEDAD INFECCIOSA DE ARTICULACIÓN"
  },
  {
    "codigo":364997009,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA HACER SONIDOS DEL HABLA"
  },
  {
    "codigo":199322008,
    "descripcion":"EMBARAZO DE TRILLIZOS CON PROBLEMA PRENATAL"
  },
  {
    "codigo":723610009,
    "descripcion":"SÍNDROME DE DISOSTOSIS ESPONDILOCOSTAL CON ATRESIA ANAL Y MALFORMACIONES GENITOURINARIAS"
  },
  {
    "codigo":295791000,
    "descripcion":"SOBREDOSIS DE VINCRISTINA"
  },
  {
    "codigo":263023008,
    "descripcion":"LUXACIÓN DE LA CABEZA RADIAL"
  },
  {
    "codigo":230255008,
    "descripcion":"ENFERMEDAD NEURONAL MOTORA DE TIPO MADRÁS"
  },
  {
    "codigo":33647009,
    "descripcion":"GLAUCOMA CRÓNICO DE ÁNGULO CERRADO"
  },
  {
    "codigo":228420000,
    "descripcion":"EL CONSUMO DE DROGAS TIENE PRIORIDAD SOBRE LAS OBLIGACIONES FINANCIERAS"
  },
  {
    "codigo":293956004,
    "descripcion":"ALERGIA A PROLINTANO"
  },
  {
    "codigo":326724004,
    "descripcion":"MUTACIÓN DEL SUPRESOR"
  },
  {
    "codigo":128281003,
    "descripcion":"LINFANGITIS AGUDA DE LA CABEZA"
  },
  {
    "codigo":292121007,
    "descripcion":"REACCIÓN ADVERSA A LA SULFASALAZINA"
  },
  {
    "codigo":718105008,
    "descripcion":"LIQUEN AMILOIDE"
  },
  {
    "codigo":62745008,
    "descripcion":"LESIÓN TRAUMÁTICA DEL NERVIO CUBITAL"
  },
  {
    "codigo":880110002,
    "descripcion":"INGESTA INADECUADA DE GRASA Y ACEITE"
  },
  {
    "codigo":335811000119102,
    "descripcion":"QUISTE CONJUNTIVAL DEL OJO DERECHO"
  },
  {
    "codigo":290286004,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR NEFOPAM"
  },
  {
    "codigo":801000221109,
    "descripcion":"RABIA ANIMAL"
  },
  {
    "codigo":1073091000119103,
    "descripcion":"ARTRITIS DE ARTICULACIÓN DE CODO IZQUIERDO CAUSADA POR STREPTOCOCCUS"
  },
  {
    "codigo":288451000,
    "descripcion":"NO REALIZA ACTIVIDADES DE COPIADO"
  },
  {
    "codigo":91843000,
    "descripcion":"ABRASIÓN DENTAL DEBIDA A PRÁCTICAS ORALES DELETÉREAS"
  },
  {
    "codigo":11804611000119105,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA DISTAL DE DEDO MEÑIQUE DERECHO"
  },
  {
    "codigo":1204120002,
    "descripcion":"EMBOLIA DEBIDA A NEOPLASIA MALIGNA"
  },
  {
    "codigo":417688002,
    "descripcion":"NEUMONÍA PROGRESIVA CRÓNICA POR COCCIDIOS"
  },
  {
    "codigo":188312005,
    "descripcion":"NEOPLASIA MALIGNA DE LA DURAMADRE CEREBRAL"
  },
  {
    "codigo":309341000119100,
    "descripcion":"NECROSIS AVASCULAR DE HUESO DE MANO DERECHA"
  },
  {
    "codigo":284781000,
    "descripcion":"INCAPAZ DE REALIZAR ACTIVIDAD DE HIGIENE PERSONAL"
  },
  {
    "codigo":448621002,
    "descripcion":"TUBO DE TRAQUEOSTOMÍA PERMEABLE"
  },
  {
    "codigo":20802003,
    "descripcion":"PH AUMENTADO DE LA PIEL"
  },
  {
    "codigo":282946005,
    "descripcion":"DIFICULTAD PARA INCLINARSE PARA LEVANTAR UN OBJETO SIN CAERSE"
  },
  {
    "codigo":1264151001,
    "descripcion":"DAÑO DE VEJIGA URINARIA POSTERIOR A EMBARAZO ECTÓPICO"
  },
  {
    "codigo":444951002,
    "descripcion":"LACTANTE IRRITABLE"
  },
  {
    "codigo":281111003,
    "descripcion":"TRASTORNO ORGÁNICO DEL ESQUEMA CORPORAL"
  },
  {
    "codigo":446786009,
    "descripcion":"FENESTRACIÓN DE VALVA DE VÁLVULA TRICÚSPIDE"
  },
  {
    "codigo":1003842009,
    "descripcion":"DISGENESIA TUBULAR RENAL CAUSADA POR FÁRMACOS"
  },
  {
    "codigo":82668000,
    "descripcion":"SIGNO DE ELEVACIÓN DE LA PIERNA CRUZADA"
  },
  {
    "codigo":836332009,
    "descripcion":"AGUDEZA VISUAL DE OJO DERECHO 6\/12"
  },
  {
    "codigo":16584951000119101,
    "descripcion":"ASMA DEPENDIENTE DE ESTEROIDES ORALES"
  },
  {
    "codigo":408513003,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: BRAWA"
  },
  {
    "codigo":768961004,
    "descripcion":"NECRÓLISIS EPIDÉRMICA TÓXICA DEBIDA A INFECCIÓN"
  },
  {
    "codigo":145501000119108,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE MAMA"
  },
  {
    "codigo":111766000,
    "descripcion":"INTOXICACIÓN CAUSADA POR TRANQUILIZANTE"
  },
  {
    "codigo":308374001,
    "descripcion":"TRASTORNO RELACIONADO CON LA CAFEÍNA"
  },
  {
    "codigo":211905009,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO SUPERFICIAL DE DORSO DE LA MANO"
  },
  {
    "codigo":11860061000119109,
    "descripcion":"ESGUINCE DE LIGAMENTO CRUZADO POSTERIOR DE RODILLA IZQUIERDA"
  },
  {
    "codigo":898198006,
    "descripcion":"LEUCEMIA PROLINFOCÍTICA DE CÉLULAS T EN REMISIÓN"
  },
  {
    "codigo":46230007,
    "descripcion":"EDAD GESTACIONAL, 40 SEMANAS"
  },
  {
    "codigo":44395000,
    "descripcion":"TETRAPLEJÍA ESPÁSTICA CON SÍNDROME DE RIGIDEZ"
  },
  {
    "codigo":242838009,
    "descripcion":"AUTOINTOXICACIÓN POR PLANTAS O PARTES DE PLANTAS"
  },
  {
    "codigo":109931000,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LOS NERVIOS PERIFÉRICOS DEL MIEMBRO SUPERIOR"
  },
  {
    "codigo":208235007,
    "descripcion":"FRACTURA EXPUESTA DE ESPINA DE OMÓPLATO"
  },
  {
    "codigo":11833591000119105,
    "descripcion":"ESGUINCE DE TOBILLO DERECHO"
  },
  {
    "codigo":699755009,
    "descripcion":"COROIDITIS FOCAL PERIFÉRICA"
  },
  {
    "codigo":5491000175103,
    "descripcion":"FALTA DE AGUA CORRIENTE EN LA CASA"
  },
  {
    "codigo":403008005,
    "descripcion":"TIÑA DE CUERO CABELLUDO CAUSADA POR NANNIZZIA FULVA"
  },
  {
    "codigo":1075601000119100,
    "descripcion":"INESTABILIDAD DE ARTICULACIÓN DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":370240005,
    "descripcion":"LACERACIÓN SUPERFICIAL DE PIE"
  },
  {
    "codigo":40725000,
    "descripcion":"ESTEATOSIS MUSCULAR"
  },
  {
    "codigo":697920006,
    "descripcion":"HIPERTENSIÓN PULMONAR EN TRASTORNO SISTÉMICO"
  },
  {
    "codigo":237333004,
    "descripcion":"DESGARRO DE HIMEN"
  },
  {
    "codigo":302869005,
    "descripcion":"RETRASO DE CRECIMIENTO DE CAUSA NUTRICIONAL"
  },
  {
    "codigo":202730006,
    "descripcion":"PROLAPSO DE DISCO INTERVERTEBRAL DORSAL CON MIELOPATÍA"
  },
  {
    "codigo":301034006,
    "descripcion":"FRACTURA DE TROCÁNTER MAYOR"
  },
  {
    "codigo":299199000,
    "descripcion":"ARTICULACIÓN DEL PULGAR DOLOROSA AL MOVIMIENTO"
  },
  {
    "codigo":366570009,
    "descripcion":"AMPLITUD DE MOVIMIENTO PASIVO DE ABDUCCIÓN DE LA CADERA - HALLAZGO"
  },
  {
    "codigo":200895000,
    "descripcion":"DERMATITIS CAUSADA POR ALIMENTO INGERIDO"
  },
  {
    "codigo":233663004,
    "descripcion":"DISCINESIA CILIAR PRIMARIA POR TRANSPOSICIÓN DE MICROTÚBULOS CILIARES"
  },
  {
    "codigo":102591006,
    "descripcion":"DOLOR A LA PALPACIÓN DE PARED TORÁCICA"
  },
  {
    "codigo":364735007,
    "descripcion":"HALLAZGO RELACIONADO CON EL DESGASTE DEL CALZADO"
  },
  {
    "codigo":4287008,
    "descripcion":"CURVATURA ANORMAL DE PENE"
  },
  {
    "codigo":67988000,
    "descripcion":"DESARROLLO ANORMAL DE CARTÍLAGO"
  },
  {
    "codigo":788884002,
    "descripcion":"ACCIDENTE CEREBROVASCULAR ISQUÉMICO DEBIDO A HEMORRAGIA SUBARACNOIDEA"
  },
  {
    "codigo":231828003,
    "descripcion":"HEMANGIOMA CAPILAR PALPEBRAL"
  },
  {
    "codigo":636201361000119105,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE ESCLERÓTICA DE OJO IZQUIERDO"
  },
  {
    "codigo":397503006,
    "descripcion":"INFECCIÓN POR SALMONELLA ENTERICA ARIZONAE"
  },
  {
    "codigo":2452007,
    "descripcion":"ROTACIÓN FETAL"
  },
  {
    "codigo":721513005,
    "descripcion":"SÍNDROME DEL CORDÓN ANTERIOR DE MÉDULA ESPINAL AL NIVEL DEL SEGUNDO SEGMENTO LUMBAR"
  },
  {
    "codigo":262761008,
    "descripcion":"DERRAME DE OÍDO MEDIO POR RADIACIÓN"
  },
  {
    "codigo":293694001,
    "descripcion":"ALERGIA A MEPENZOLATO"
  },
  {
    "codigo":719678003,
    "descripcion":"ATEROSCLEROSIS NO OBSTRUCTIVA DE ARTERIA CORONARIA"
  },
  {
    "codigo":31550006,
    "descripcion":"CUERPO EXTRAÑO NO MAGNÉTICO RETENIDO EN EL OJO"
  },
  {
    "codigo":228158008,
    "descripcion":"DISCAPACIDAD PARA CAMINAR"
  },
  {
    "codigo":95251001,
    "descripcion":"QUISTE SECUNDARIO EN LA PORCIÓN PLANA"
  },
  {
    "codigo":160787000,
    "descripcion":"MATRIMONIO, EVENTO DEL CICLO VITAL"
  },
  {
    "codigo":29715005,
    "descripcion":"TUBÉRCULO DE DARWIN"
  },
  {
    "codigo":47791000087101,
    "descripcion":"FRACTURA DE PRIMERA COSTILLA DERECHA"
  },
  {
    "codigo":717843007,
    "descripcion":"FÍSTULA ADQUIRIDA DE ESÓFAGO"
  },
  {
    "codigo":421096000,
    "descripcion":"CAMPOS VISUALES POR CONFRONTACIÓN COMPLETOS"
  },
  {
    "codigo":40111000087105,
    "descripcion":"LUXACIÓN DE ARTICULACIÓN DE DEDO MEÑIQUE DE MANO IZQUIERDA"
  },
  {
    "codigo":716008002,
    "descripcion":"SÍNDROME DE FIBROMATOSIS GINGIVAL E HIPERTRICOSIS"
  },
  {
    "codigo":193555008,
    "descripcion":"GLAUCOMA DEBIDO A SÍNDROME SISTÉMICO"
  },
  {
    "codigo":42671000087109,
    "descripcion":"PROLAPSO DE DISCO INTERVERTEBRAL C5-C6"
  },
  {
    "codigo":26045000,
    "descripcion":"CONJUNTIVITIS ALÉRGICA CRÓNICA"
  },
  {
    "codigo":124349002,
    "descripcion":"DEFICIENCIA DE ARN POLIMERASA, DIRIGIDA POR ADN"
  },
  {
    "codigo":419261006,
    "descripcion":"DESNUTRICIÓN POR MALTRATO INFANTIL"
  },
  {
    "codigo":15630891000119108,
    "descripcion":"PARONIQUIA DE DEDO DE AMBOS PIES"
  },
  {
    "codigo":10853061000119102,
    "descripcion":"SOBREDOSIS DE INHIBIDOR DE LA RECAPTACIÓN DE NORADRENALINA E INHIBIDOR DE LA RECAPTACIÓN DE SEROTONINA"
  },
  {
    "codigo":286354004,
    "descripcion":"DIFICULTAD PARA IMITAR LA VOCALIZACIÓN"
  },
  {
    "codigo":417426005,
    "descripcion":"CUATRO VASOS EN EL CORDÓN UMBILICAL"
  },
  {
    "codigo":24210004,
    "descripcion":"DEGENERACIÓN CORIORRETINIANA CONGÉNITA"
  },
  {
    "codigo":253586007,
    "descripcion":"HIPOPLASIA DE ANILLO DE VÁLVULA PULMONAR"
  },
  {
    "codigo":56978007,
    "descripcion":"VACCINA GENERALIZADA"
  },
  {
    "codigo":188050009,
    "descripcion":"MELANOMA MALIGNO DE MAMA"
  },
  {
    "codigo":1202023003,
    "descripcion":"MIOPATÍA CONGÉNITA POR DESPROPORCIÓN DE TIPO DE FIBRA DEBIDA A MUTACIÓN DE GEN SELENON"
  },
  {
    "codigo":448359004,
    "descripcion":"VENTRÍCULO DERECHO POR ENCIMA DE VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":415591005,
    "descripcion":"ESTRABISMO POSTERIOR A CIRUGÍA DE CATARATA"
  },
  {
    "codigo":285381000119104,
    "descripcion":"TROMBOSIS AGUDA PROFUNDA DE AMBAS VENAS FEMORALES"
  },
  {
    "codigo":284519005,
    "descripcion":"GOLPETEO REPETITIVO DE LOS DEDOS DE LA MANO"
  },
  {
    "codigo":15932101000119105,
    "descripcion":"ENDOMETRIOSIS DE OVARIO IZQUIERDO"
  },
  {
    "codigo":282684002,
    "descripcion":"CAPAZ DE EMPUJAR Y ARRASTRAR UN OBJETO GRANDE POR EL PISO"
  },
  {
    "codigo":708668003,
    "descripcion":"ÁNGULO GONÍACO DISMINUIDO"
  },
  {
    "codigo":315452004,
    "descripcion":"NACIDO EN JAMAICA"
  },
  {
    "codigo":249916005,
    "descripcion":"MUÑECA RÍGIDA"
  },
  {
    "codigo":774204006,
    "descripcion":"SÍNDROME DE RETRASO DEL CRECIMIENTO, RETRASO LEVE DEL DESARROLLO Y HEPATITIS CRÓNICA"
  },
  {
    "codigo":248081003,
    "descripcion":"NO CONOCE EL PELIGRO DE LOS OBJETOS PUNZANTES"
  },
  {
    "codigo":1296657006,
    "descripcion":"DESPERTARES NOCTURNOS FRECUENTES EN PRIMERA INFANCIA"
  },
  {
    "codigo":84241008,
    "descripcion":"DERMATOARTRITIS LIPOIDEA"
  },
  {
    "codigo":704998000,
    "descripcion":"DEPRESIÓN DIFUSA DE SEGMENTO ST"
  },
  {
    "codigo":311782002,
    "descripcion":"ENFERMEDAD AVANZADA DE RETINA DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":279014003,
    "descripcion":"ANOMALÍA CONGÉNITA DEL PEZÓN"
  },
  {
    "codigo":1260219001,
    "descripcion":"CICATRIZ DE PISO DE BOCA"
  },
  {
    "codigo":47803004,
    "descripcion":"FÍSTULA DEL APARATO GENITAL - DIGESTIVO FEMENINO"
  },
  {
    "codigo":703163006,
    "descripcion":"ENFERMEDAD CEREBROVASCULAR SECUNDARIA"
  },
  {
    "codigo":277179007,
    "descripcion":"MEMBRANA TIMPÁNICA INMÓVIL"
  },
  {
    "codigo":209808000,
    "descripcion":"ESGUINCE DEL APÉNDICE XIFOIDES"
  },
  {
    "codigo":275344002,
    "descripcion":"DEFORMIDADES EN VALGO DE AMBOS PIES"
  },
  {
    "codigo":13200003,
    "descripcion":"ÚLCERA PÉPTICA"
  },
  {
    "codigo":111504002,
    "descripcion":"DISTROFIA MUSCULAR CONGÉNITA DE WALKER - WARBURG"
  },
  {
    "codigo":240741002,
    "descripcion":"HISTOPLASMOSIS PULMONAR AGUDA DEL ÁFRICA"
  },
  {
    "codigo":15987551000119107,
    "descripcion":"ANOMALÍA ESTRUCTURAL CONGÉNITA DE AMBAS CÓRNEAS"
  },
  {
    "codigo":1354853004,
    "descripcion":"POBREZA ENERGÉTICA DOMÉSTICA"
  },
  {
    "codigo":732261005,
    "descripcion":"SÍNDROME NEUROMUSCULOESQUELÉTICO FACIAL DE CHIPRE"
  },
  {
    "codigo":371813006,
    "descripcion":"INSUFICIENCIA MITRAL AGUDA POR RUPTURA DE CUERDA TENDINOSA"
  },
  {
    "codigo":314361000119102,
    "descripcion":"ESCOLIOSIS NEUROMUSCULAR LUMBAR"
  },
  {
    "codigo":109669008,
    "descripcion":"ARTRITIS TRAUMÁTICA DE LA ARTICULACIÓN TEMPOROMANDIBULAR"
  },
  {
    "codigo":1254714002,
    "descripcion":"REQUIERE SERVICIO CON CAPACIDAD DE RESPUESTA CULTURAL PARA INCREMENTAR EL ALFABETISMO SANITARIO"
  },
  {
    "codigo":75066002,
    "descripcion":"SÍNDROME DE ICTERICIA COLESTÁSICA CRÓNICA"
  },
  {
    "codigo":402746001,
    "descripcion":"CAPILARITIS CAUSADA POR FÁRMACO"
  },
  {
    "codigo":1156410008,
    "descripcion":"OLIGOASTROCITOMA ANAPLÁSICO DEL SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":271674009,
    "descripcion":"ESTRÍAS DEL EMBARAZO"
  },
  {
    "codigo":237071002,
    "descripcion":"PÓLIPO CÓRNEO UTERINO"
  },
  {
    "codigo":105999006,
    "descripcion":"NEFROPATÍA QUÍSTICA ADQUIRIDA"
  },
  {
    "codigo":300772000,
    "descripcion":"DIFICULTAD PARA REALIZAR ACTIVIDADES RECREATIVAS Y DEPORTIVAS"
  },
  {
    "codigo":399076001,
    "descripcion":"NEUROPATÍA TIBIAL"
  },
  {
    "codigo":366308004,
    "descripcion":"HALLAZGO RELACIONADO CON EL REFLEJO DE GALANT"
  },
  {
    "codigo":5860009,
    "descripcion":"OFIASIS"
  },
  {
    "codigo":38628009,
    "descripcion":"HOMOSEXUAL"
  },
  {
    "codigo":266169003,
    "descripcion":"INFECCIÓN POR AMEBAS DE VIDA LIBRE"
  },
  {
    "codigo":298937007,
    "descripcion":"ARTICULACIÓN DE CODO TIBIA AL TACTO"
  },
  {
    "codigo":15715321000119108,
    "descripcion":"TORSIÓN INTERNA CONGÉNITA DE AMBAS TIBIAS"
  },
  {
    "codigo":724921009,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO BÍCEPS BRAQUIAL"
  },
  {
    "codigo":428174001,
    "descripcion":"INFECCIÓN CAUSADA POR BRUCELLA CANIS"
  },
  {
    "codigo":355001,
    "descripcion":"CHOQUE HEMORRÁGICO"
  },
  {
    "codigo":34958009,
    "descripcion":"INTOXICACIÓN POR DIPIRIDAMOL"
  },
  {
    "codigo":723086009,
    "descripcion":"TEMOR A ENFERMEDAD CARDÍACA"
  },
  {
    "codigo":295267005,
    "descripcion":"SOBREDOSIS DE ÁCIDO MEFENÁMICO"
  },
  {
    "codigo":1145400000,
    "descripcion":"APLASIA DE ARTERIA RADIAL"
  },
  {
    "codigo":293432006,
    "descripcion":"REACCIÓN ADVERSA A INHIBIDOR DE HMG-COA REDUCTASA"
  },
  {
    "codigo":162360008,
    "descripcion":"IRRITACIÓN ÓTICA"
  },
  {
    "codigo":94989005,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA GLÁNDULA PARÓTIDA"
  },
  {
    "codigo":1340173008,
    "descripcion":"SÍNDROME DORSOVENTRAL RELACIONADO CON EL GEN EN1"
  },
  {
    "codigo":224226001,
    "descripcion":"SIN DOMICILIO FIJO"
  },
  {
    "codigo":191458003,
    "descripcion":"DEMENCIA SENIL CON PARANOIA"
  },
  {
    "codigo":93154004,
    "descripcion":"MORDIDA EN CRUZ LINGUAL"
  },
  {
    "codigo":289762006,
    "descripcion":"CUELLO DEL ÚTERO DILATADO"
  },
  {
    "codigo":47011000087105,
    "descripcion":"FRACTURA DE FALANGE PROXIMAL DE MEÑIQUE IZQUIERDO"
  },
  {
    "codigo":27618009,
    "descripcion":"PALUDISMO CUARTANO"
  },
  {
    "codigo":255159004,
    "descripcion":"NEOPLASIA BENIGNA DE PARED NASAL EXTERNA"
  },
  {
    "codigo":713911007,
    "descripcion":"ESPONDILOSIS LUMBOSACRA CONCOMITANTE CON COMPRESIÓN DE RAÍZ"
  },
  {
    "codigo":417164000,
    "descripcion":"BACTERIAS ENTEROPATÓGENAS AISLADAS"
  },
  {
    "codigo":56716005,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO DEL CUERO CABELLUDO"
  },
  {
    "codigo":253324006,
    "descripcion":"DEFECTO DEL SENO CORONARIO EN LA AURÍCULA IZQUIERDA"
  },
  {
    "codigo":286092008,
    "descripcion":"CAPAZ DE DESECHAR LOS RESIDUOS DOMICILIARIOS"
  },
  {
    "codigo":1080621000119107,
    "descripcion":"LEIOMIOSARCOMA PRIMARIO DE EXTREMIDAD INFERIOR DERECHA"
  },
  {
    "codigo":251489005,
    "descripcion":"ESPIGAS FOCALES"
  },
  {
    "codigo":284257006,
    "descripcion":"CAPAZ DE AGARRAR"
  },
  {
    "codigo":87649007,
    "descripcion":"CONDUCTA INADAPTADA RELACIONADA CON ENFERMEDAD FÍSICA"
  },
  {
    "codigo":448097006,
    "descripcion":"TRAYECTO ANORMAL DE CAYADO AÓRTICO"
  },
  {
    "codigo":343341000119108,
    "descripcion":"HEMORRAGIA SUBCONJUNTIVAL DE AMBOS OJOS"
  },
  {
    "codigo":446262006,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN ADQUIRIDA EN CENTRO DE CUIDADOS DE PACIENTES CRÓNICOS CON ATENCIÓN DE ENFERMERÍA"
  },
  {
    "codigo":313355000,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS DE BRONQUIO, EN EL LÓBULO INFERIOR DERECHO"
  },
  {
    "codigo":870411001,
    "descripcion":"REACCIÓN ADVERSA A FÁRMACO VASOPRESOR"
  },
  {
    "codigo":51211002,
    "descripcion":"PETROSITIS AGUDA"
  },
  {
    "codigo":1263627000,
    "descripcion":"TRASTORNO FETAL DEBIDO A PRESENTACIÓN OBLICUA ANTES DE TRABAJO DE PARTO"
  },
  {
    "codigo":249654008,
    "descripcion":"ANO EN EMBUDO"
  },
  {
    "codigo":184118009,
    "descripcion":"NÚMERO TELEFÓNICO DEL PACIENTE - DESCONOCIDO"
  },
  {
    "codigo":772107008,
    "descripcion":"METABOLIZADOR NORMAL DE NUDT15"
  },
  {
    "codigo":1163488000,
    "descripcion":"COLITIS FÚNGICA"
  },
  {
    "codigo":247819009,
    "descripcion":"MIEDO A TEMBLAR"
  },
  {
    "codigo":309685001,
    "descripcion":"ENCÍAS INFLAMADAS"
  },
  {
    "codigo":82144009,
    "descripcion":"SEPARACIÓN HORIZONTAL DE CAPAS DE UNGUEALES"
  },
  {
    "codigo":32570691000036108,
    "descripcion":"INTERSEXO"
  },
  {
    "codigo":735669008,
    "descripcion":"FRACTURA DE METÁFISIS PROXIMAL DE TIBIA"
  },
  {
    "codigo":45706001,
    "descripcion":"INTOXICACIÓN POR CYNODON DACTYLON"
  },
  {
    "codigo":71111000119109,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA RECURRENTE DE VULVA"
  },
  {
    "codigo":1290890004,
    "descripcion":"SARCOMA SINOVIAL BIFÁSICO"
  },
  {
    "codigo":733834006,
    "descripcion":"CARCINOMA INVASIVO DE CUELLO UTERINO CONCOMITANTE CON INFECCIÓN POR VIRUS DE INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":111242007,
    "descripcion":"PERIARTRITIS DE MUÑECA"
  },
  {
    "codigo":109407001,
    "descripcion":"DISOSTOSIS INTERNASAL"
  },
  {
    "codigo":371551001,
    "descripcion":"OSTEOMIELITIS DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":240479006,
    "descripcion":"HERPES ANOGENITAL RECURRENTE"
  },
  {
    "codigo":238644003,
    "descripcion":"EXFOLIACIÓN PALMAR FOCAL RECURRENTE"
  },
  {
    "codigo":15691361000119106,
    "descripcion":"ARTRITIS REUMATOIDEA SERONEGATIVA DE AMBAS ARTICULACIONES DE CADERA"
  },
  {
    "codigo":345851000119100,
    "descripcion":"ATROFIA DE AMBOS OJOS PROPIAMENTE DICHOS"
  },
  {
    "codigo":402484008,
    "descripcion":"DEFICIENCIA DE CINC NUTRICIONAL ENDÉMICA"
  },
  {
    "codigo":369716009,
    "descripcion":"G1: BIEN DIFERENCIADO (MÁS DE 95 POR CIENTO DE FORMACIÓN GLANDULAR)"
  },
  {
    "codigo":236809006,
    "descripcion":"INFERTILIDAD MASCULINA ADQUIRIDA"
  },
  {
    "codigo":290401000119108,
    "descripcion":"PARAPLEJÍA COMPLETA"
  },
  {
    "codigo":366046002,
    "descripcion":"HALLAZGO RELACIONADO CON LA EXCAVACIÓN DE LA PAPILA ÓPTICA"
  },
  {
    "codigo":234974002,
    "descripcion":"CAÍDA DENTARIA PREMATURA"
  },
  {
    "codigo":300510002,
    "descripcion":"CORDÓN ESPERMÁTICO PALPABLE"
  },
  {
    "codigo":431582005,
    "descripcion":"CICATRIZ DE LA PIEL DE LA MANO"
  },
  {
    "codigo":69299000,
    "descripcion":"ERITROPLASIA DE LA BOCA"
  },
  {
    "codigo":3763000,
    "descripcion":"DUELO ESPERABLE"
  },
  {
    "codigo":11314761000119100,
    "descripcion":"FRACTURA POR ESTRÉS DE FALANGE DE PIE DERECHO"
  },
  {
    "codigo":396979005,
    "descripcion":"TUMOR QUE INVADE NERVIO ÓPTICO A NIVEL DE LA LÁMINA CRIBOSA"
  },
  {
    "codigo":16644681000119102,
    "descripcion":"ACCIDENTE CEREBROVASCULAR ISQUÉMICO DEBIDO A OCLUSIÓN BILATERAL DE ARTERIAS PROTUBERANCIALES"
  },
  {
    "codigo":15743561000119103,
    "descripcion":"DOLOR CRÓNICO DE MIEMBRO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":11998281000119101,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO DE REGIÓN INGUINAL"
  },
  {
    "codigo":15707721000119101,
    "descripcion":"CATARATA CALCIFICADA DE OJO DERECHO"
  },
  {
    "codigo":125001000119103,
    "descripcion":"ASMA PERSISTENTE MODERADA CONCOMITANTE CON RINITIS ALÉRGICA"
  },
  {
    "codigo":16631881000119104,
    "descripcion":"HERNIA PARAESTOMAL POSTERIOR A GASTROSTOMÍA"
  },
  {
    "codigo":680521000119101,
    "descripcion":"HIFEMA DE OJO DERECHO"
  },
  {
    "codigo":16637001000119108,
    "descripcion":"LESIÓN BILATERAL DE NERVIOS PLANTARES"
  },
  {
    "codigo":12236361000119106,
    "descripcion":"BURSITIS DE DEDO DE MANO DERECHA"
  },
  {
    "codigo":340041000119102,
    "descripcion":"LAGOFTALMÍA DEL PÁRPADO IZQUIERDO"
  },
  {
    "codigo":15741001000119107,
    "descripcion":"GANGLIÓN DE AMBOS TOBILLOS"
  },
  {
    "codigo":11790921000119104,
    "descripcion":"LESIÓN TRAUMÁTICA DE MUSLO IZQUIERDO"
  },
  {
    "codigo":314441000119108,
    "descripcion":"SÍNDROME COMPARTIMENTAL NO TRAUMÁTICO DE EXTREMIDAD SUPERIOR IZQUIERDA"
  },
  {
    "codigo":10692681000119108,
    "descripcion":"ENFERMEDAD RESPIRATORIA EXACERBADA POR ASPIRINA"
  },
  {
    "codigo":293961000119109,
    "descripcion":"SÍNDROME DE DOLOR REGIONAL COMPLEJO TIPO I DE MIEMBRO INFERIOR DERECHO"
  },
  {
    "codigo":32861005,
    "descripcion":"ERITEMA NUDOSO"
  },
  {
    "codigo":319561000119109,
    "descripcion":"ARTRITIS REACTIVA DE ARTICULACIÓN GLENOHUMERAL IZQUIERDA"
  },
  {
    "codigo":720989003,
    "descripcion":"ENDOCARDITIS CAUSADA POR ERYSIPELOTHRIX RHUSIOPATHIAE"
  },
  {
    "codigo":293170000,
    "descripcion":"REACCIÓN ADVERSA A LA PREDNISOLONA"
  },
  {
    "codigo":15966101000119102,
    "descripcion":"DISPLASIA FIBROMUSCULAR DE PARED DE ARTERIA RENAL DERECHA"
  },
  {
    "codigo":31026002,
    "descripcion":"COMPLICACIÓN OBSTÉTRICA POR LA SEDACIÓN"
  },
  {
    "codigo":194866002,
    "descripcion":"RUPTURA DE CUERDAS TENDINOSAS COMO COMPLICACIÓN ACTUAL LUEGO DE INFARTO AGUDO DE MIOCARDIO"
  },
  {
    "codigo":237461000119103,
    "descripcion":"NIÑO VÍCTIMA DE MALTRATO FÍSICO"
  },
  {
    "codigo":291335001,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR NIQUETAMIDA"
  },
  {
    "codigo":1208839002,
    "descripcion":"HIPERTENSIÓN ARTERIAL SECUNDARIA A ENFERMEDAD TUBULAR RENAL"
  },
  {
    "codigo":94727003,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE ADENOIDES"
  },
  {
    "codigo":127495004,
    "descripcion":"INVASIÓN TUMORAL INDETERMINADA EN EL SISTEMA VASCULAR"
  },
  {
    "codigo":29191005,
    "descripcion":"RUPTURA ATRAUMÁTICA DE MÚSCULO"
  },
  {
    "codigo":61959006,
    "descripcion":"TRONCO ARTERIAL COMÚN (TRONCO ARTERIOSO)"
  },
  {
    "codigo":225799007,
    "descripcion":"HALLAZGO RELACIONADO CON LA INSTITUCIONALIZACIÓN"
  },
  {
    "codigo":1208968000,
    "descripcion":"CRISIS EPILÉPTICA ATÓNICA DE INICIO GENERALIZADO"
  },
  {
    "codigo":193031009,
    "descripcion":"CEFALEA EN SALVAS"
  },
  {
    "codigo":27356002,
    "descripcion":"RINITIS GRANULOMATOSA"
  },
  {
    "codigo":715484003,
    "descripcion":"DISPLASIA OFTALMOMANDIBULOMÉLICA"
  },
  {
    "codigo":289500003,
    "descripcion":"PROBLEMA VULVAR"
  },
  {
    "codigo":125660006,
    "descripcion":"HERIDA ABIERTA DE LA RODILLA"
  },
  {
    "codigo":58289000,
    "descripcion":"ESTADIO PRODRÓMICO DE TRABAJO DE PARTO"
  },
  {
    "codigo":92892009,
    "descripcion":"FORMA ANORMAL CONGÉNITA DE ARCO DE VÉRTEBRA SACRA"
  },
  {
    "codigo":189361002,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LOS APARATOS DIGESTIVO Y RESPIRATORIO"
  },
  {
    "codigo":319381000119107,
    "descripcion":"LUXACIÓN RECURRENTE DE ARTICULACIÓN DE RODILLA DERECHA"
  },
  {
    "codigo":1172401003,
    "descripcion":"HORMONAS SEXUALES FEMENINAS SÉRICAS DENTRO DE RANGO DE REFERENCIA"
  },
  {
    "codigo":254897006,
    "descripcion":"SARCOMA DE VULVA"
  },
  {
    "codigo":292911000119102,
    "descripcion":"GRANULOMA EPIDURAL INTRACRANEAL"
  },
  {
    "codigo":23686004,
    "descripcion":"SÍNDROME DEL CROMOSOMA 20 EN ANILLO"
  },
  {
    "codigo":449670008,
    "descripcion":"AUSENCIA DE BRAZO"
  },
  {
    "codigo":285830009,
    "descripcion":"LESIÓN DEL PERICARDIO"
  },
  {
    "codigo":416902009,
    "descripcion":"TROMBOCITOPENIA URÉMICA"
  },
  {
    "codigo":89222008,
    "descripcion":"PERICARDITIS ASOCIADA CON DEFECTO DEL TABIQUE INTERAURICULAR"
  },
  {
    "codigo":56454009,
    "descripcion":"PITIRIASIS VERSICOLOR"
  },
  {
    "codigo":283995000,
    "descripcion":"MEMORIA VERBAL PARA LOS EVENTOS"
  },
  {
    "codigo":52784000,
    "descripcion":"FRACTURA DE EXTREMO ACROMIAL DE CLAVÍCULA"
  },
  {
    "codigo":249392003,
    "descripcion":"AMÍGDALA - HALLAZGO"
  },
  {
    "codigo":413232004,
    "descripcion":"ANASTOMOSIS ESOFÁGICA"
  },
  {
    "codigo":20016009,
    "descripcion":"MENARCA"
  },
  {
    "codigo":247557001,
    "descripcion":"PELO EN LANA DE VIDRIO"
  },
  {
    "codigo":737242001,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE PLACA UNGUEAL"
  },
  {
    "codigo":1163226001,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN INCLASIFICABLE"
  },
  {
    "codigo":11843631000119109,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE OREJA DERECHA"
  },
  {
    "codigo":212954004,
    "descripcion":"ENFERMEDAD POR DESCOMPRESIÓN TIPO II"
  },
  {
    "codigo":348361000119103,
    "descripcion":"GLAUCOMA SECUNDARIO DEBIDO A AFAQUIA DE OJO DERECHO"
  },
  {
    "codigo":276655000,
    "descripcion":"DEFORMIDAD CONGÉNITA"
  },
  {
    "codigo":409562009,
    "descripcion":"BOTULISMO INHALATORIO"
  },
  {
    "codigo":473263003,
    "descripcion":"QUEMADURA DE TERCER GRADO DE MÚLTIPLES SITIOS DEL CUELLO"
  },
  {
    "codigo":1259695007,
    "descripcion":"CARCINOMA PRIMARIO DE EPIDÍDIMO Y DE CORDÓN ESPERMÁTICO"
  },
  {
    "codigo":274820001,
    "descripcion":"REFLEJO BICIPITAL, AUSENTE"
  },
  {
    "codigo":405892003,
    "descripcion":"FENOTIPO K+"
  },
  {
    "codigo":373124004,
    "descripcion":"CÁMARA CARDÍACA DE TAMAÑO NORMAL"
  },
  {
    "codigo":15667401000119106,
    "descripcion":"METATARSO ADUCTO DERECHO"
  },
  {
    "codigo":110980006,
    "descripcion":"HISTIOCITOMA ERUPTIVO GENERALIZADO"
  },
  {
    "codigo":12676007,
    "descripcion":"FRACTURA DE RADIO"
  },
  {
    "codigo":209284007,
    "descripcion":"FRACTURA-SUBLUXACIÓN NO EXPUESTA DE ARTICULACIÓN RADIOCUBITAL DISTAL"
  },
  {
    "codigo":404057003,
    "descripcion":"ANGIOLIPOMA"
  },
  {
    "codigo":305753003,
    "descripcion":"ATENDIDO POR ENFERMERA LABORAL"
  },
  {
    "codigo":238382001,
    "descripcion":"ABSCESO DE HERIDA"
  },
  {
    "codigo":271150005,
    "descripcion":"AMPOLLA TRAUMÁTICA DE LA AXILA"
  },
  {
    "codigo":402222007,
    "descripcion":"ECCEMA VESICULAR DE MANO"
  },
  {
    "codigo":369454008,
    "descripcion":"TUMOR MALIGNO QUE COMPROMETE EL RECTO POR PROPAGACIÓN DIRECTA DE LA VAGINA"
  },
  {
    "codigo":762670009,
    "descripcion":"ESTIMULACIÓN DE NERVIO FRÉNICO DEBIDA A IMPLANTE DE MARCAPASOS CARDÍACO Y POSTERIOR A ÉL"
  },
  {
    "codigo":1186819005,
    "descripcion":"LEUCENCEFALOPATÍA DEBIDA A DEFICIENCIA DE COBRE"
  },
  {
    "codigo":236547007,
    "descripcion":"OSTEOPATÍA POR ALUMINIO"
  },
  {
    "codigo":302083008,
    "descripcion":"HALLAZGO RELACIONADO CON EL PUNTAJE DE APGAR"
  },
  {
    "codigo":726232001,
    "descripcion":"LACERACIÓN DE FASCIA DE MÚSCULO ADUCTOR DE MUSLO"
  },
  {
    "codigo":297267009,
    "descripcion":"GLÁNDULA TIROIDEA RETROESTERNAL"
  },
  {
    "codigo":300248006,
    "descripcion":"LENGUA HÚMEDA"
  },
  {
    "codigo":201944007,
    "descripcion":"ARTROPATÍA TRAUMÁTICA DE CODO"
  },
  {
    "codigo":365784007,
    "descripcion":"NIVEL SÉRICO DE HORMONAS SEXUALES MASCULINAS - HALLAZGO"
  },
  {
    "codigo":36269003,
    "descripcion":"QUEILODINIA"
  },
  {
    "codigo":298413003,
    "descripcion":"AMPLITUD DE FLEXIÓN PASIVA DE LA COLUMNA CERVICAL DISMINUIDA"
  },
  {
    "codigo":167341006,
    "descripcion":"MICROSCOPIA DE ORINA: AUSENCIA DE CRISTALES"
  },
  {
    "codigo":10971491000119108,
    "descripcion":"HERIDA ABIERTA DE REGIÓN DE CODO IZQUIERDO DEBIDA A MORDEDURA DE ANIMAL"
  },
  {
    "codigo":131581000119102,
    "descripcion":"STENT RECUBIERTO CON MEDICACIÓN EN RAMA CIRCUNFLEJA DE ARTERIA CORONARIA IZQUIERDA"
  },
  {
    "codigo":67202007,
    "descripcion":"SÍNDROME DE EHLERS-DANLOS LIGADO A X"
  },
  {
    "codigo":296578008,
    "descripcion":"SOBREDOSIS DE PIPERACINA"
  },
  {
    "codigo":65367001,
    "descripcion":"CLASE DE VÍCTIMA"
  },
  {
    "codigo":32599008,
    "descripcion":"AMILOIDOSIS ASOCIADA CON HEMODIÁLISIS"
  },
  {
    "codigo":196439008,
    "descripcion":"PÉRDIDA DENTAL POR ACCIDENTE"
  },
  {
    "codigo":292908001,
    "descripcion":"REACCIÓN ADVERSA AL VERDE BRILLANTE"
  },
  {
    "codigo":161836003,
    "descripcion":"SÍNTOMA RELACIONADO CON UN PROBLEMA ALIMENTARIO"
  },
  {
    "codigo":63532004,
    "descripcion":"DIVERTÍCULOS DE INTESTINO"
  },
  {
    "codigo":1144876005,
    "descripcion":"HIPOPLASIA DE MÉDULA SUPRARRENAL"
  },
  {
    "codigo":129068007,
    "descripcion":"DEPENDENCIA PARA LA PREPARACIÓN DE LAS COMIDAS"
  },
  {
    "codigo":192769002,
    "descripcion":"TROMBOFLEBITIS DE LOS SENOS VENOSOS DEL SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":782593004,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR ALCALOIDE DE LA RAUWOLFIA"
  },
  {
    "codigo":225537005,
    "descripcion":"AUTOMASTURBACIÓN"
  },
  {
    "codigo":94465006,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL PARAMETRIO"
  },
  {
    "codigo":127233007,
    "descripcion":"NEOPLASIA DE LOS GANGLIOS LINFÁTICOS DE LA CABEZA"
  },
  {
    "codigo":92630000,
    "descripcion":"CARCINOMA IN SITU DE LA CARA LARÍNGEA DEL PLIEGUE ARITENOEPIGLÓTICO"
  },
  {
    "codigo":289238000,
    "descripcion":"HALLAZGO RELACIONADO CON EL PATRÓN DEL TRABAJO DE PARTO"
  },
  {
    "codigo":15997591000119103,
    "descripcion":"COROIDOPATÍA SEROSA CENTRAL DE OJO DERECHO"
  },
  {
    "codigo":189099001,
    "descripcion":"XANTOGRANULOMA"
  },
  {
    "codigo":27094009,
    "descripcion":"FRACTURA DE SKILLERN"
  },
  {
    "codigo":123563003,
    "descripcion":"ANOMALÍA CONGÉNITA DE TIBIA"
  },
  {
    "codigo":254635004,
    "descripcion":"HEMANGIOENDOTELIOMA EPITELIOIDE DE PULMÓN"
  },
  {
    "codigo":418475009,
    "descripcion":"TRASTORNO DEL SUEÑO DE CAUSA MEDICAMENTOSA"
  },
  {
    "codigo":1137536003,
    "descripcion":"CALCIFICACIÓN PUNTEADA DE EPÍFISIS DE FALANGE PROXIMAL DE QUINTO DEDO DE PIE"
  },
  {
    "codigo":449408005,
    "descripcion":"TRASTORNO RENAL DEBIDO A ENFERMEDAD DE CADENA LIVIANA KAPPA"
  },
  {
    "codigo":6323005,
    "descripcion":"INFECCIÓN CAUSADA POR CYATHOSTOMA"
  },
  {
    "codigo":283733004,
    "descripcion":"MORDEDURA HUMANA EN EL TALÓN"
  },
  {
    "codigo":52522001,
    "descripcion":"TRASTORNO CEREBRAL DEGENERATIVO"
  },
  {
    "codigo":609578001,
    "descripcion":"DIABETES DEL ADULTO DE INICIO JUVENIL, TIPO 11"
  },
  {
    "codigo":105111000119109,
    "descripcion":"CARCINOMA PRIMARIO ESCAMOCELULAR DE TIMO"
  },
  {
    "codigo":281898005,
    "descripcion":"LINFADENOPATÍA POR TOXOPLASMOSIS CONGÉNITA"
  },
  {
    "codigo":19754005,
    "descripcion":"ALOPECIA TOTAL"
  },
  {
    "codigo":445738007,
    "descripcion":"ENFERMEDAD MIELODISPLÁSICA\/MIELOPROLIFERATIVA"
  },
  {
    "codigo":773418007,
    "descripcion":"TRASTORNO CONGÉNITO DE LA GLUCOSILACIÓN POR XILOSILTRANSFERASA 1"
  },
  {
    "codigo":443903000,
    "descripcion":"LINFORREA CUTÁNEA"
  },
  {
    "codigo":17919002,
    "descripcion":"GRANULOMA CUTÁNEO POR SÍLICE"
  },
  {
    "codigo":314666005,
    "descripcion":"SECCIÓN TRAUMÁTICA DE TENDÓN DE MÚSCULO FLEXOR DE LA MANO"
  },
  {
    "codigo":1363242005,
    "descripcion":"QUISTE CONGÉNITO ÚNICO DE CEREBRO"
  },
  {
    "codigo":15725361000119106,
    "descripcion":"DERRAME BILATERAL DE ARTICULACIONES RADIOCARPIANAS"
  },
  {
    "codigo":704212006,
    "descripcion":"FRACTURA NO EXPUESTA DE EPÍFISIS DISTAL DE RADIO"
  },
  {
    "codigo":835284009,
    "descripcion":"AGUDEZA VISUAL DE OJO DERECHO 6\/7,5"
  },
  {
    "codigo":276393001,
    "descripcion":"HEMORROIDES REDUCTIBLES CON DIFICULTAD"
  },
  {
    "codigo":1259433006,
    "descripcion":"CARCINOMA PRIMARIO DE CUELLO UTERINO"
  },
  {
    "codigo":47017007,
    "descripcion":"SÍNDROME DE CROMOSOMA EN ANILLO 1"
  },
  {
    "codigo":702377007,
    "descripcion":"HIPERMAGNESEMIA CON DISTONÍA, POLICITEMIA Y CIRROSIS"
  },
  {
    "codigo":473001008,
    "descripcion":"ESTADO DE MADURACIÓN SEXUAL PUBERAL"
  },
  {
    "codigo":209022001,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA NO EXPUESTA PANASTRAGALINA"
  },
  {
    "codigo":733310006,
    "descripcion":"BLEBITIS CONJUNTIVAL POSTERIOR A CIRUGÍA DE GLAUCOMA"
  },
  {
    "codigo":405630007,
    "descripcion":"HIPOTIROIDISMO INFANTIL HASTA LOS 24 MESES"
  },
  {
    "codigo":241790007,
    "descripcion":"HERBICIDA DE BIPIRIDINIO QUE CAUSA EFECTOS TÓXICOS"
  },
  {
    "codigo":698707001,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR VASODILATADOR CORONARIO"
  },
  {
    "codigo":305491002,
    "descripcion":"BAJO ATENCIÓN DE INFECTÓLOGO"
  },
  {
    "codigo":10579003,
    "descripcion":"HALLAZGO RELACIONADO CON EL OLOR DE LA ORINA"
  },
  {
    "codigo":895315003,
    "descripcion":"FORMA DE BALA ANORMAL CONGÉNITA DE FALANGE MEDIA DE DEDO ÍNDICE"
  },
  {
    "codigo":403795009,
    "descripcion":"PELO LANOSO DE HERENCIA AUTOSÓMICA RECESIVA FAMILIAR"
  },
  {
    "codigo":8744003,
    "descripcion":"APENDICITIS CATARRAL"
  },
  {
    "codigo":762408006,
    "descripcion":"FISURA DE PALADAR BLANDO Y DURO CON FISURA DE LABIO EN EL LADO DERECHO"
  },
  {
    "codigo":205352007,
    "descripcion":"PERODACTILIA DE SEGUNDO A QUINTO DEDOS DEL PIE"
  },
  {
    "codigo":203517001,
    "descripcion":"DETENCIÓN TOTAL DEL CRECIMIENTO EPIFISARIO"
  },
  {
    "codigo":1090661000119101,
    "descripcion":"INFLAMACIÓN AGUDA DE MASTOIDES DERECHA"
  },
  {
    "codigo":398290000,
    "descripcion":"PREMEDICACIÓN OMITIDA DELIBERADAMENTE"
  },
  {
    "codigo":301821009,
    "descripcion":"APNEA MEDICAMENTOSA"
  },
  {
    "codigo":72445008,
    "descripcion":"HEPATITIS SUBAGUDA NO INFECCIOSA"
  },
  {
    "codigo":1217490003,
    "descripcion":"SARCOMA DE KAPOSI GINGIVAL"
  },
  {
    "codigo":365522006,
    "descripcion":"LISTA DE ESPERA PARA UN ALOJAMIENTO - HALLAZGO"
  },
  {
    "codigo":789671000,
    "descripcion":"TROMBOFLEBITIS DURANTE PROCEDIMIENTO"
  },
  {
    "codigo":3239007,
    "descripcion":"TRASTORNO LINFOCITARIO"
  },
  {
    "codigo":681061000119105,
    "descripcion":"BLEFARITIS ANGULAR DE PÁRPADO DERECHO"
  },
  {
    "codigo":165244004,
    "descripcion":"REQUIERE AYUDA MÍNIMA EN EL MANEJO DE LA SILLA DE RUEDAS"
  },
  {
    "codigo":230780007,
    "descripcion":"PARÁLISIS CEREBRAL DISCINÉSICA"
  },
  {
    "codigo":720465002,
    "descripcion":"ANEMIA SIDEROBLÁSTICA AUTOSÓMICA RECESIVA DE COMIENZO EN LA VIDA ADULTA"
  },
  {
    "codigo":294481004,
    "descripcion":"ALERGIA A NITROFURAL"
  },
  {
    "codigo":1179217006,
    "descripcion":"ICTERICIA COLESTÁTICA MEDICAMENTOSA"
  },
  {
    "codigo":32337007,
    "descripcion":"MICRODONCIA"
  },
  {
    "codigo":194342001,
    "descripcion":"CUERPO EXTRAÑO ANTIGUO EN EL OÍDO MEDIO"
  },
  {
    "codigo":423718003,
    "descripcion":"ENDOCARDITIS INFECCIOSA DEL LADO IZQUIERDO"
  },
  {
    "codigo":390950008,
    "descripcion":"REMOVIDO DEL REGISTRO DE ENFERMEDAD MENTAL SEVERA"
  },
  {
    "codigo":126971002,
    "descripcion":"NEOPLASIA DEL NERVIO TRIGÉMINO"
  },
  {
    "codigo":421883002,
    "descripcion":"ESTRONGILOIDIASIS ASOCIADA CON SÍNDROME DE INMUNODEFICIENCIA ADQUIRIDA"
  },
  {
    "codigo":94203004,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE VASO SANGUÍNEO PERINEAL"
  },
  {
    "codigo":59600000,
    "descripcion":"ARTERIA ONFALOMESENTÉRICA PERSISTENTE"
  },
  {
    "codigo":290811009,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR AMOXAPINA"
  },
  {
    "codigo":288976005,
    "descripcion":"CAPAZ DE CHUPAR"
  },
  {
    "codigo":125136008,
    "descripcion":"DENSIDAD RADIOLÓGICA ANORMAL, UNIFORME"
  },
  {
    "codigo":1237413006,
    "descripcion":"SÍNDROME PROGRESIVO DE ATAXIA CEREBELOSA Y SORDERA NEUROSENSORIAL AUTOSÓMICO RECESIVO"
  },
  {
    "codigo":287141007,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO DE LA CABEZA"
  },
  {
    "codigo":55930002,
    "descripcion":"CAMBIOS DEL SEGMENTO ST EN EL ECG"
  },
  {
    "codigo":285306003,
    "descripcion":"CLOROPSIA"
  },
  {
    "codigo":414543001,
    "descripcion":"HERNIA IRREDUCTIBLE DE PARED ABDOMINAL ANTERIOR"
  },
  {
    "codigo":283471006,
    "descripcion":"HERIDA PUNZANTE EN EL TRONCO"
  },
  {
    "codigo":445476000,
    "descripcion":"TUMOR TENOSINOVIAL DE CÉLULAS GIGANTES DIFUSO DE ARTICULACIÓN DE TOBILLO"
  },
  {
    "codigo":248868006,
    "descripcion":"CLÍTORIS QUE SE PARECE A UN PENE"
  },
  {
    "codigo":17657000,
    "descripcion":"CICLITIS"
  },
  {
    "codigo":247033008,
    "descripcion":"IRIS HETEROCRÓMICO"
  },
  {
    "codigo":441806004,
    "descripcion":"ABSCESO DE CEREBRO"
  },
  {
    "codigo":409038005,
    "descripcion":"ALTERACIÓN DE LA CONDUCTA DEL ADULTO"
  },
  {
    "codigo":210595001,
    "descripcion":"SECCIÓN PARCIAL, TENDÓN DEL EXTENSOR LARGO DEL PULGAR"
  },
  {
    "codigo":700280001,
    "descripcion":"CÁMARA ANTERIOR DEL OJO APLANADA CON HIPOTONÍA"
  },
  {
    "codigo":308899009,
    "descripcion":"CONDICIONES DE VIDA INSATISFACTORIAS"
  },
  {
    "codigo":405368004,
    "descripcion":"BLOQUEO REGIONAL - PROPAGACIÓN CEFÁLICA EXCESIVA DE ANESTESIA LOCAL"
  },
  {
    "codigo":75853001,
    "descripcion":"ALTERACIÓN DEL SISTEMA NERVIOSO CENTRAL EN LA REGULACIÓN DEL AGUA"
  },
  {
    "codigo":403533001,
    "descripcion":"ALOPECIA VERTICAL"
  },
  {
    "codigo":1255501007,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO DE DEDO MEÑIQUE DE MANO DERECHA"
  },
  {
    "codigo":10317009,
    "descripcion":"ENTESOPATÍA VERTEBRAL"
  },
  {
    "codigo":237858001,
    "descripcion":"TRASTORNOS MIXTOS DEL EQUILIBRIO ÁCIDO-BASE - TRASTORNO PRIMARIO NO COMPENSADO"
  },
  {
    "codigo":41250005,
    "descripcion":"ESCLEROSIS COROIDEA DIFUSA"
  },
  {
    "codigo":170487002,
    "descripcion":"PORTADOR DE ESTAFILOCOCO"
  },
  {
    "codigo":301559005,
    "descripcion":"SE MOVILIZA APOYÁNDOSE EN LOS MUEBLES"
  },
  {
    "codigo":399863006,
    "descripcion":"RETINOPATÍA NO PROLIFERATIVA MUY SEVERA SIN EDEMA DE MÁCULA DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":266956001,
    "descripcion":"PÉRDIDA DEL EMPLEO"
  },
  {
    "codigo":234188002,
    "descripcion":"CALCIFICACIÓN DE PRÓTESIS DE VÁLVULA CARDÍACA"
  },
  {
    "codigo":365260003,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA SEGUIR UNA RECETA"
  },
  {
    "codigo":70348004,
    "descripcion":"SÍNDROME DE PENDRED"
  },
  {
    "codigo":1217228004,
    "descripcion":"SÍNDROME DE DISCAPACIDAD INTELECTUAL LIGADA A CROMOSOMA X, HIPOPLASIA CEREBELOSA Y DISPLASIA ESPONDILOEPIFISARIA"
  },
  {
    "codigo":299724006,
    "descripcion":"OJO IZQUIERDO DOMINANTE"
  },
  {
    "codigo":398028009,
    "descripcion":"NEVO HALO"
  },
  {
    "codigo":396193002,
    "descripcion":"GRADO NUCLEAR DE FUHRMAN-HALLAZGO"
  },
  {
    "codigo":135884009,
    "descripcion":"NEOPLASIA BENIGNA DE LA PROTUBERANCIA"
  },
  {
    "codigo":723873001,
    "descripcion":"OBSTRUCCIÓN ARTERIAL DEBIDA A EMBOLIA TROMBÓTICA POR TROMBO MURAL DEL CORAZÓN"
  },
  {
    "codigo":35745008,
    "descripcion":"SECRECIÓN UMBILICAL"
  },
  {
    "codigo":363425008,
    "descripcion":"NEOPLASIA MALIGNA DE SENO MAXILAR"
  },
  {
    "codigo":232353008,
    "descripcion":"RINITIS ALÉRGICA PERENNE CON VARIACIÓN ESTACIONAL"
  },
  {
    "codigo":296054005,
    "descripcion":"SOBREDOSIS DE FLUNITRAZEPAM"
  },
  {
    "codigo":33910007,
    "descripcion":"INFECCIÓN POSTOPERATORIA"
  },
  {
    "codigo":230518009,
    "descripcion":"INFARTO DE CINTILLA ÓPTICA"
  },
  {
    "codigo":425291007,
    "descripcion":"HALLAZGO RELACIONADO CON LA ACTIVIDAD ENZIMÁTICA DE P450"
  },
  {
    "codigo":1177120001,
    "descripcion":"SÍNDROME DE BRONQUIOLITIS OBLITERANTE POSTERIOR A TRASPLANTE ALOGÉNICO DE CÉLULAS MADRE"
  },
  {
    "codigo":128544001,
    "descripcion":"ANOMALÍA CONGÉNITA DEL ASTRÁGALO"
  },
  {
    "codigo":294219009,
    "descripcion":"ALERGIA A INHIBIDOR DE XANTINA OXIDASA"
  },
  {
    "codigo":95776004,
    "descripcion":"TRASTORNO DE LA CINTILLA ÓPTICA"
  },
  {
    "codigo":30240001,
    "descripcion":"MASTURBACIÓN INCOMPLETA"
  },
  {
    "codigo":1144352007,
    "descripcion":"CICATRIZ CORNEAL POSTHERPÉTICA"
  },
  {
    "codigo":292384007,
    "descripcion":"REACCIÓN ADVERSA A LA PIMOZIDA"
  },
  {
    "codigo":225013001,
    "descripcion":"SE SIENTE MAL"
  },
  {
    "codigo":1306357003,
    "descripcion":"TIENE PADRES MAYORES"
  },
  {
    "codigo":93941005,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA PARAGANGLIONAR"
  },
  {
    "codigo":126709005,
    "descripcion":"NEOPLASIA DE BRONQUIO DEL LÓBULO SUPERIOR IZQUIERDO DEL PULMÓN"
  },
  {
    "codigo":419786001,
    "descripcion":"PRESERVACIÓN DE LA ARTERIA CILIORRETINIANA"
  },
  {
    "codigo":92106003,
    "descripcion":"NEOPLASIA BENIGNA DEL PERONÉ"
  },
  {
    "codigo":10624871000119109,
    "descripcion":"CONTRACTURA CUTÁNEA CONGÉNITA"
  },
  {
    "codigo":124874006,
    "descripcion":"PRODUCCIÓN DE ANTÍGENOS FETALES"
  },
  {
    "codigo":288714007,
    "descripcion":"INCAPAZ DE UTILIZAR LA CONVERSACIÓN CON FINES RECREATIVOS"
  },
  {
    "codigo":90271007,
    "descripcion":"INFECCIÓN INTESTINAL CAUSADA POR GRUPO ARIZONA"
  },
  {
    "codigo":254111008,
    "descripcion":"OSTEOGÉNESIS IMPERFECTA, TIPO IIB"
  },
  {
    "codigo":285044002,
    "descripcion":"NO USA ANTEOJOS"
  },
  {
    "codigo":55668003,
    "descripcion":"TRASTORNO DE ADAPTACIÓN, CON SÍNTOMAS EMOCIONALES MIXTOS"
  },
  {
    "codigo":283209006,
    "descripcion":"ANZUELO EN LA MAMA"
  },
  {
    "codigo":250441008,
    "descripcion":"CÉLULAS EPITELIALES PRESENTES"
  },
  {
    "codigo":707358000,
    "descripcion":"CARCINOMA PRIMARIO DE CÉLULAS ESCAMOSAS DE LARINGE"
  },
  {
    "codigo":1231646004,
    "descripcion":"ENDOFTALMITIS BACTERIANA POSTRAUMÁTICA"
  },
  {
    "codigo":246771000,
    "descripcion":"MOVIMIENTOS OCULARES EN RUEDA DENTADA"
  },
  {
    "codigo":738291005,
    "descripcion":"ONICOFOSIS"
  },
  {
    "codigo":408776000,
    "descripcion":"CONSENTIMIENTO PARA EXAMEN POSTMORTEM COMPLETO, OTORGADO"
  },
  {
    "codigo":443379009,
    "descripcion":"VENTRÍCULO ÚNICO FUNCIONAL"
  },
  {
    "codigo":81096007,
    "descripcion":"ABSCESO DE LIGAMENTO ANCHO"
  },
  {
    "codigo":1162440009,
    "descripcion":"DELECIÓN DE PARTE DEL BRAZO CORTO DEL CROMOSOMA 12"
  },
  {
    "codigo":79261008,
    "descripcion":"SÍNDROME DE VAN DER WOUDE"
  },
  {
    "codigo":110194006,
    "descripcion":"QUEMADURA DE LA MUCOSA LABIAL"
  },
  {
    "codigo":763719001,
    "descripcion":"LINFOMA SEMEJANTE A HIDROA VACCINIFORME"
  },
  {
    "codigo":700018009,
    "descripcion":"HEMARTROSIS DE ARTICULACIÓN GLENOHUMERAL"
  },
  {
    "codigo":75591007,
    "descripcion":"FRACTURA DE PERONÉ"
  },
  {
    "codigo":403271008,
    "descripcion":"VITILIGO POR FENÓMENO DE KÖBNER"
  },
  {
    "codigo":8220004,
    "descripcion":"PÓLIPO ENDOCERVICAL"
  },
  {
    "codigo":202993000,
    "descripcion":"INFECCIÓN PIÓGENA DE VAINA TENDINOSA"
  },
  {
    "codigo":40988009,
    "descripcion":"RINITIS OBSTRUCTIVA"
  },
  {
    "codigo":268529002,
    "descripcion":"ATENCIÓN COMPARTIDA - CONSULTOR Y MÉDICO GENERAL"
  },
  {
    "codigo":688591000119101,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS INTRAEPIDÉRMICO DE LABIO"
  },
  {
    "codigo":399601008,
    "descripcion":"EQUIPO DE VISUALIZACIÓN ESTÉREO, NO DISPONIBLE"
  },
  {
    "codigo":235761008,
    "descripcion":"PROCTITIS AGUDA POR RADIACIÓN"
  },
  {
    "codigo":4550001,
    "descripcion":"FÓRMULA ESPECIAL PARA LACTANTES"
  },
  {
    "codigo":364998004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA ARTICULAR EL HABLA"
  },
  {
    "codigo":299462005,
    "descripcion":"PIE LARGO"
  },
  {
    "codigo":102854006,
    "descripcion":"CRISTAL URINARIO, OXALATO DE CALCIO"
  },
  {
    "codigo":201158008,
    "descripcion":"HIPERTRICOSIS ADQUIRIDA CIRCUNSCRIPTA"
  },
  {
    "codigo":363163005,
    "descripcion":"ENFERMEDAD INFECCIOSA DE MÚSCULO"
  },
  {
    "codigo":723611008,
    "descripcion":"SÍNDROME DE MANOS Y PIES HENDIDOS CON HIPOACUSIA NEUROSENSITIVA"
  },
  {
    "codigo":263024002,
    "descripcion":"LUXACIÓN DE ARTICULACIÓN RADIOCARPIANA"
  },
  {
    "codigo":70781000052101,
    "descripcion":"DOLOR DE CINTURA PÉLVICA DURANTE EMBARAZO"
  },
  {
    "codigo":334441000119100,
    "descripcion":"LAGOFTALMÍA DEL PÁRPADO DERECHO"
  },
  {
    "codigo":11829711000119106,
    "descripcion":"LACERACIÓN DE MÚSCULO DE MANO DERECHA"
  },
  {
    "codigo":16007631000119106,
    "descripcion":"ANOMALÍA CONGÉNITA DE VASO SANGUÍNEO DE EXTREMIDAD SUPERIOR DERECHA"
  },
  {
    "codigo":230256009,
    "descripcion":"AMIOTROFIA MONOMÉLICA BENIGNA"
  },
  {
    "codigo":10682831000119107,
    "descripcion":"TUMORACIÓN DE LA PIEL DE DEDO DEL PIE DERECHO"
  },
  {
    "codigo":15735401000119100,
    "descripcion":"RETINOPATÍA DE OJO IZQUIERDO CAUSADA POR HIDROXICLOROQUINA"
  },
  {
    "codigo":295792007,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE VINCRISTINA"
  },
  {
    "codigo":66416007,
    "descripcion":"INTOXICACIÓN POR DRYOPTERIS"
  },
  {
    "codigo":721776008,
    "descripcion":"ENCEFALITIS CAUSADA POR VIRUS POLYOMA"
  },
  {
    "codigo":64581007,
    "descripcion":"NÁUSEAS POSOPERATORIAS"
  },
  {
    "codigo":292122000,
    "descripcion":"REACCIÓN ADVERSA A UN ANTIÁCIDO"
  },
  {
    "codigo":293957008,
    "descripcion":"ALERGIA A ANFETAMINA Y\/O DERIVADO DE ANFETAMINA"
  },
  {
    "codigo":128282005,
    "descripcion":"LINFANGITIS AGUDA DE DEDO DEL PIE"
  },
  {
    "codigo":161050007,
    "descripcion":"CON MAYOR RIESGO DE ACCIDENTE EN HOGAR"
  },
  {
    "codigo":95514008,
    "descripcion":"DISPLASIA DEL DESARROLLO DEL OÍDO INTERNO"
  },
  {
    "codigo":718106009,
    "descripcion":"SÍNDROME DE HIPERINSULINISMO E HIPERAMONEMIA"
  },
  {
    "codigo":28143002,
    "descripcion":"CÓRNEA TÍSICA"
  },
  {
    "codigo":93679002,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE APÉNDICE"
  },
  {
    "codigo":191983006,
    "descripcion":"BRUXISMO"
  },
  {
    "codigo":124612000,
    "descripcion":"DEFICIENCIA DE HIDROXIMETILGLUTARILO - COA SINTASA"
  },
  {
    "codigo":1304260005,
    "descripcion":"SÍNDROME UVEÍTIS GLAUCOMA HIPEMA DE OJO DERECHO"
  },
  {
    "codigo":91844006,
    "descripcion":"VESÍCULA BILIAR SUPERNUMERARIA"
  },
  {
    "codigo":288452007,
    "descripcion":"DIFICULTAD PARA REALIZAR ACTIVIDADES DE COPIADO"
  },
  {
    "codigo":188313000,
    "descripcion":"NEOPLASIA MALIGNA DE LA MEMBRANA ARACNOIDES CEREBRAL"
  },
  {
    "codigo":90009001,
    "descripcion":"CORDÓN UMBILICAL ANORMAL"
  },
  {
    "codigo":1204121003,
    "descripcion":"EMBOLIA DEBIDA A VEGETACIONES DE VÁLVULA CARDÍACA NO INFECCIOSAS"
  },
  {
    "codigo":307971000119101,
    "descripcion":"HIPERLAXITUD ARTICULAR DE CODO IZQUIERDO"
  },
  {
    "codigo":253849004,
    "descripcion":"PENE OCULTO CONGÉNITO"
  },
  {
    "codigo":24473007,
    "descripcion":"ESTADO VEGETATIVO PERSISTENTE"
  },
  {
    "codigo":536571000221104,
    "descripcion":"OCLUSIÓN DE ARTERIA PEDIA DERECHA"
  },
  {
    "codigo":252014003,
    "descripcion":"PRUEBA URETRAL - HALLAZGO"
  },
  {
    "codigo":62211000119103,
    "descripcion":"RETARDO MODERADO DEL LENGUAJE EXPRESIVO"
  },
  {
    "codigo":88174006,
    "descripcion":"TROMBOSIS DE ARTERIA BASILAR"
  },
  {
    "codigo":284782007,
    "descripcion":"REALIZA ACTIVIDAD DE HIGIENE PERSONAL"
  },
  {
    "codigo":55406008,
    "descripcion":"HIPERALGESIA"
  },
  {
    "codigo":186478009,
    "descripcion":"POLIOMIELITIS PARALÍTICA AGUDA, ASOCIADA A LA VACUNA"
  },
  {
    "codigo":448622009,
    "descripcion":"OBSTRUCCIÓN COMPLETA DE CORTOCIRCUITO SISTÉMICO-PULMONAR"
  },
  {
    "codigo":1296920003,
    "descripcion":"DEFICIENCIA SECUNDARIA DE ARGININA VASOPRESINA"
  },
  {
    "codigo":11776771000119106,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DE ANTEBRAZO DERECHO"
  },
  {
    "codigo":1264152008,
    "descripcion":"PERITONITIS PÉLVICA POSTERIOR A EMBARAZO MOLAR"
  },
  {
    "codigo":444952009,
    "descripcion":"MÉDICAMENTE APTO PARA CONCURRIR A CITA HOSPITALARIA"
  },
  {
    "codigo":17133001,
    "descripcion":"ABSCESO DE LA REGIÓN SUBMANDIBULAR"
  },
  {
    "codigo":836333004,
    "descripcion":"AGUDEZA VISUAL DE OJO IZQUIERDO 6\/12"
  },
  {
    "codigo":211906005,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO SUPERFICIAL DE MUÑECA"
  },
  {
    "codigo":768962006,
    "descripcion":"SÍNDROME DE LYELL"
  },
  {
    "codigo":767127000,
    "descripcion":"TELANGIECTASIA NEVOIDE UNILATERAL"
  },
  {
    "codigo":408514009,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: IGBO"
  },
  {
    "codigo":78999002,
    "descripcion":"MICOSIS OPORTUNISTA"
  },
  {
    "codigo":242839001,
    "descripcion":"AUTOINTOXICACIÓN POR GAS"
  },
  {
    "codigo":441282009,
    "descripcion":"NO RECONOCE NÚMEROS"
  },
  {
    "codigo":13463001,
    "descripcion":"LUXACIÓN EXPUESTA DE LA QUINTA VÉRTEBRA CERVICAL"
  },
  {
    "codigo":16419741000119105,
    "descripcion":"PENACHO VITREORRETINIANO DE OJO DERECHO"
  },
  {
    "codigo":699756005,
    "descripcion":"DISPLASIA ODONTOMAXILAR SEGMENTARIA"
  },
  {
    "codigo":109932007,
    "descripcion":"NEOPLASIA BENIGNA DE NERVIOS PERIFÉRICOS DE HOMBRO"
  },
  {
    "codigo":763457000,
    "descripcion":"ENFERMEDAD DE CHARCOT-MARIE-TOOTH LIGADA AL CROMOSOMA X TIPO 2"
  },
  {
    "codigo":208236008,
    "descripcion":"FRACTURA EXPUESTA DE OMÓPLATO, CUELLO"
  },
  {
    "codigo":10849181000119107,
    "descripcion":"CUERPO EXTRAÑO EN CÓRNEA IZQUIERDA"
  },
  {
    "codigo":403009002,
    "descripcion":"TIÑA DE CUERO CABELLUDO CAUSADA POR TRICHOPHYTON MEGNINII"
  },
  {
    "codigo":42561004,
    "descripcion":"NEURALGIA REMINISCENTE"
  },
  {
    "codigo":697921005,
    "descripcion":"HIPERTENSIÓN PULMONAR EN SARCOIDOSIS"
  },
  {
    "codigo":370241009,
    "descripcion":"LACERACIÓN SUPERFICIAL DE LA ESPALDA"
  },
  {
    "codigo":10904631000119103,
    "descripcion":"HERIDA PUNZANTE DE GLÚTEO IZQUIERDO"
  },
  {
    "codigo":302870006,
    "descripcion":"HIPERTRIGLICERIDEMIA"
  },
  {
    "codigo":268267000,
    "descripcion":"DISOSTOSIS OCULOMANDIBULAR"
  },
  {
    "codigo":169963001,
    "descripcion":"DETALLES DEL PARTO DESCONOCIDOS"
  },
  {
    "codigo":29261000175100,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN EN GLÚTEO IZQUIERDO"
  },
  {
    "codigo":202731005,
    "descripcion":"PROLAPSO DE DISCO INTERVERTEBRAL LUMBAR CON MIELOPATÍA"
  },
  {
    "codigo":40621000087106,
    "descripcion":"ABRASIÓN DE PIEL DE TERCER DEDO DE PIE DERECHO"
  },
  {
    "codigo":366571008,
    "descripcion":"HALLAZGO RELACIONADO CON LA AMPLITUD DE LA ADUCCIÓN DE LA CADERA"
  },
  {
    "codigo":71659009,
    "descripcion":"ECTROPIÓN SENIL"
  },
  {
    "codigo":299200002,
    "descripcion":"CREPITACIÓN DE ARTICULACIÓN DE PULGAR"
  },
  {
    "codigo":168128004,
    "descripcion":"NADA OBSERVADO EN LA MICROSCOPIA"
  },
  {
    "codigo":233664005,
    "descripcion":"SÍNDROME DE LAS CILIAS INMÓVILES POR DEFECTO DE LAS PROYECCIONES RADIALES"
  },
  {
    "codigo":364736008,
    "descripcion":"DISTENSIBILIDAD DEL CALZADO - HALLAZGO"
  },
  {
    "codigo":788885001,
    "descripcion":"ATEROEMBOLIA DE COLESTEROL DE LA VASCULATURA CUTÁNEA"
  },
  {
    "codigo":1149333003,
    "descripcion":"INTOXICACIÓN AGUDA POR ALCOHOL"
  },
  {
    "codigo":35221005,
    "descripcion":"CUATRO SIGNOS CARDINALES DE KANAVEL"
  },
  {
    "codigo":428437005,
    "descripcion":"ARTRITIS INFECCIOSA DE REGIÓN DE HOMBRO"
  },
  {
    "codigo":231829006,
    "descripcion":"NEOPLASIA MALIGNA DE PÁRPADO"
  },
  {
    "codigo":91191000119108,
    "descripcion":"ADENOCARCINOMA METASTÁSICO DE PLEURA"
  },
  {
    "codigo":262762001,
    "descripcion":"LESIÓN TRAUMÁTICA DEL OÍDO INTERNO"
  },
  {
    "codigo":721514004,
    "descripcion":"SÍNDROME DEL CORDÓN ANTERIOR DE MÉDULA ESPINAL AL NIVEL DEL TERCER SEGMENTO LUMBAR"
  },
  {
    "codigo":361066007,
    "descripcion":"DEFICIENCIA DE TRIPSINA"
  },
  {
    "codigo":129855000,
    "descripcion":"TRASTORNO DE LA ACTIVIDAD"
  },
  {
    "codigo":228159000,
    "descripcion":"DISCAPACIDAD EN LA MOTRICIDAD FINA"
  },
  {
    "codigo":293695000,
    "descripcion":"ALERGIA A PIPENZOLATO"
  },
  {
    "codigo":310481000119105,
    "descripcion":"ESCOLIOSIS IDIOPÁTICA INFANTIL DE COLUMNA TORACOLUMBAR"
  },
  {
    "codigo":62484002,
    "descripcion":"FIBROSIS HEPÁTICA"
  },
  {
    "codigo":160788005,
    "descripcion":"SEPARACIÓN MATRIMONIAL"
  },
  {
    "codigo":11779281000119106,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE ANTEBRAZO IZQUIERDO"
  },
  {
    "codigo":95252008,
    "descripcion":"CARIES DENTAL SECUNDARIA ASOCIADA CON FALLA O DEFECTO EN LA RESTAURACIÓN DENTAL"
  },
  {
    "codigo":816148008,
    "descripcion":"DESPROPORCIÓN ENTRE EL FETO Y LA PELVIS DEBIDA A MELLIZOS SIAMESES"
  },
  {
    "codigo":93417001,
    "descripcion":"CONJUNTIVITIS CAUSADA POR BORDETELLA PERTUSSIS"
  },
  {
    "codigo":193556009,
    "descripcion":"GLAUCOMA EN ENDOCRINOPATÍAS, ENFERMEDADES METABÓLICAS Y TRASTORNOS ALIMENTARIOS"
  },
  {
    "codigo":224489008,
    "descripcion":"CUIDADOR RENUENTE A BRINDAR ATENCIÓN"
  },
  {
    "codigo":124350002,
    "descripcion":"DEFICIENCIA DE ADN POLIMERASA, DIRIGIDA POR ADN"
  },
  {
    "codigo":417427001,
    "descripcion":"CON MAYOR RIESGO DE ABUSO DISCRIMINATORIO"
  },
  {
    "codigo":253587003,
    "descripcion":"FUSIÓN COMISURAL DE VÁLVULA PULMONAR"
  },
  {
    "codigo":1269395004,
    "descripcion":"HIPERSENSIBILIDAD A HIDROCORTISONA"
  },
  {
    "codigo":40841000087103,
    "descripcion":"QUEMADURA DE CUARTO DEDO DE PIE IZQUIERDO"
  },
  {
    "codigo":188051008,
    "descripcion":"MELANOMA MALIGNO DE GLÚTEO"
  },
  {
    "codigo":43401000087106,
    "descripcion":"DISCO INTERVERTEBRAL LUMBAR PROLAPSADO, L4-L5"
  },
  {
    "codigo":415592003,
    "descripcion":"ESTRABISMO POSTERIOR A CIRUGÍA OCULAR"
  },
  {
    "codigo":87912004,
    "descripcion":"INTOXICACIÓN POR NAFTALENO CLORADO"
  },
  {
    "codigo":284520004,
    "descripcion":"CREPITACIONES BASALES"
  },
  {
    "codigo":38281000087107,
    "descripcion":"HIPOCINESIA DE SEGMENTO INFEROLATERAL BASAL DE VENTRÍCULO CARDÍACO IZQUIERDO"
  },
  {
    "codigo":339461000119100,
    "descripcion":"ESOTROPÍA MONOCULAR DE OJO IZQUIERDO"
  },
  {
    "codigo":251752008,
    "descripcion":"VISIÓN BINOCULAR AISLADA MONOFOVEAL"
  },
  {
    "codigo":1202024009,
    "descripcion":"MIOPATÍA CONGÉNITA AUTOSÓMICA DOMINANTE POR DESPROPORCIÓN DEL TIPO DE FIBRA DEBIDA A MUTACIÓN DE SELENOPROTEÍNA N"
  },
  {
    "codigo":249917001,
    "descripcion":"CODO RÍGIDO"
  },
  {
    "codigo":282685001,
    "descripcion":"INCAPAZ DE EMPUJAR Y ARRASTRAR UN OBJETO GRANDE POR EL PISO"
  },
  {
    "codigo":1003581003,
    "descripcion":"AGENESIA DE HUESO CARPIANO"
  },
  {
    "codigo":413757005,
    "descripcion":"ESTADO CARDÍACO IGUAL O MEJORADO CON RESPECTO AL ESTADO PREQUIRÚRGICO"
  },
  {
    "codigo":708669006,
    "descripcion":"CÓNDILO MANDIBULAR BÍFIDO"
  },
  {
    "codigo":774205007,
    "descripcion":"SÍNDROME DE RETRASO DEL CRECIMIENTO Y DEL DESARROLLO, HIPOTONÍA, ALTERACIONES VISUALES, ACIDOSIS LÁCTICA"
  },
  {
    "codigo":444690001,
    "descripcion":"UROLITIASIS DE ESTRUVITA"
  },
  {
    "codigo":315453009,
    "descripcion":"NACIDO EN JAPÓN"
  },
  {
    "codigo":51474003,
    "descripcion":"ALTERACIÓN EN LA VELOCIDAD DE LAS ASOCIACIONES"
  },
  {
    "codigo":1296658001,
    "descripcion":"MENSTRUACIÓN IRREGULAR EN ADOLESCENCIA"
  },
  {
    "codigo":248082005,
    "descripcion":"NO CONOCE EL PELIGRO DE CAERSE DE LAS ALTURAS"
  },
  {
    "codigo":870674008,
    "descripcion":"REACCIÓN ADVERSA A INDANODIONA"
  },
  {
    "codigo":704999008,
    "descripcion":"INVERSIÓN ANTERIOR DE ONDA T"
  },
  {
    "codigo":703164000,
    "descripcion":"INFARTO AGUDO DE PARED ANTERIOR DE MIOCARDIO CON ELEVACIÓN DEL SEGMENTO ST"
  },
  {
    "codigo":211644003,
    "descripcion":"CUERPO EXTRAÑO EN EL ANO Y RECTO"
  },
  {
    "codigo":277180005,
    "descripcion":"PARÁLISIS DEL SUEÑO"
  },
  {
    "codigo":1292988006,
    "descripcion":"TUMOR FIBROMIXOIDE OSIFICANTE MALIGNO"
  },
  {
    "codigo":1260220007,
    "descripcion":"PIERCING EN TABIQUE NASAL"
  },
  {
    "codigo":1111531000000103,
    "descripcion":"CIERRE DE ÁNGULO SECUNDARIO"
  },
  {
    "codigo":111505001,
    "descripcion":"ENFERMEDAD DE MÚSCULOS - OJOS - CEREBRO, DISTROFIA MUSCULAR CONGÉNITA"
  },
  {
    "codigo":275345001,
    "descripcion":"DEFORMIDADES EN VARO DE LOS PIES"
  },
  {
    "codigo":78737005,
    "descripcion":"SINUSITIS FRONTAL"
  },
  {
    "codigo":371814000,
    "descripcion":"INSUFICIENCIA MITRAL AGUDA POR DISFUNCIÓN DE CUERDA TENDINOSA"
  },
  {
    "codigo":732262003,
    "descripcion":"SÍNDROME MARFANOIDE TIPO DE SILVA"
  },
  {
    "codigo":11366004,
    "descripcion":"NÓDULOS VOCALES"
  },
  {
    "codigo":1354854005,
    "descripcion":"POBREZA ENERGÉTICA DOMÉSTICA DEBIDA A RECURSOS FINANCIEROS LIMITADOS"
  },
  {
    "codigo":76902006,
    "descripcion":"TÉTANOS"
  },
  {
    "codigo":207974008,
    "descripcion":"FRACTURA NO EXPUESTA DEL SACRO"
  },
  {
    "codigo":1254715001,
    "descripcion":"REQUIERE ASISTENCIA TECNOLÓGICA PARA APOYAR EL CONOCIMIENTO SOBRE LA SALUD"
  },
  {
    "codigo":238907001,
    "descripcion":"ENFERMEDAD LOCALIZADA DE LA PIEL"
  },
  {
    "codigo":240742009,
    "descripcion":"HISTOPLASMOSIS PULMONAR CRÓNICA DEL ÁFRICA"
  },
  {
    "codigo":699494009,
    "descripcion":"CARIES DENTAL CLASE V"
  },
  {
    "codigo":402747005,
    "descripcion":"ENFERMEDAD DE SWEET MEDICAMENTOSA"
  },
  {
    "codigo":1156411007,
    "descripcion":"EQUIMOSIS PERIORBITARIA"
  },
  {
    "codigo":10634911000119105,
    "descripcion":"ÚLCERA CRÓNICA DE DEDO DE PIE DERECHO"
  },
  {
    "codigo":1187344003,
    "descripcion":"TUMOR TESTICULAR DE CÉLULAS DE LEYDIG DE COMPORTAMIENTO INCIERTO"
  },
  {
    "codigo":10962591000119106,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO DIGITAL DE PULGAR DERECHO"
  },
  {
    "codigo":106000008,
    "descripcion":"NEFROPATÍA METABÓLICA"
  },
  {
    "codigo":237072009,
    "descripcion":"HIPERPLASIA ENDOMETRIAL"
  },
  {
    "codigo":268005002,
    "descripcion":"PLIEGUE SINOVIAL"
  },
  {
    "codigo":366309007,
    "descripcion":"HALLAZGO RELACIONADO CON EL BORRAMIENTO DEL CUELLO UTERINO"
  },
  {
    "codigo":368441000119102,
    "descripcion":"ENFERMEDAD RENAL CRÓNICA ESTADIO 3 DEBIDA A DIABETES MELLITUS MEDICAMENTOSA"
  },
  {
    "codigo":724922002,
    "descripcion":"LESIÓN TRAUMÁTICA DE FASCIA DE BÍCEPS BRAQUIAL"
  },
  {
    "codigo":298938002,
    "descripcion":"ARTICULACIÓN DE CODO FRÍA AL TACTO"
  },
  {
    "codigo":4026005,
    "descripcion":"MASTITIS INTERSTICIAL ASOCIADA CON EL PARTO"
  },
  {
    "codigo":428175000,
    "descripcion":"ENCEFALITIS AMEBIANA PRIMARIA CAUSADA POR NAEGLERIA FOWLERI"
  },
  {
    "codigo":723087000,
    "descripcion":"TEMOR A ENFERMEDAD CARDIOVASCULAR"
  },
  {
    "codigo":360804000,
    "descripcion":"DEFICIENCIA DE LECITINASA D"
  },
  {
    "codigo":295268000,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE ÁCIDO MEFENÁMICO"
  },
  {
    "codigo":721252004,
    "descripcion":"QUISTE SUBDURAL ESPINAL CAUSADO POR INFECCIÓN"
  },
  {
    "codigo":229732007,
    "descripcion":"TRASTORNO FONOLÓGICO SINTÁCTICO"
  },
  {
    "codigo":293433001,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR SIMVASTATINA"
  },
  {
    "codigo":129593003,
    "descripcion":"SÍNDROME DE COMPRESIÓN NEURAL POR AMILOIDE"
  },
  {
    "codigo":1079251000119102,
    "descripcion":"NEOPLASIA BENIGNA DE PULMÓN IZQUIERDO"
  },
  {
    "codigo":94990001,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA RÓTULA"
  },
  {
    "codigo":1340174002,
    "descripcion":"SÍNDROME DE RETRASO DEL DESARROLLO, INMUNODEFICIENCIA, LEUCOENCEFALOPATÍA E HIPOHOMOCISTEINEMIA"
  },
  {
    "codigo":62222003,
    "descripcion":"FLUJO VASCULAR NORMAL"
  },
  {
    "codigo":291598002,
    "descripcion":"INTOXICACIÓN POR CEFTAZIDIMA"
  },
  {
    "codigo":796522451000119103,
    "descripcion":"DEFICIENCIA DE CÉLULAS MADRE LIMBARES DE OJO IZQUIERDO"
  },
  {
    "codigo":289763001,
    "descripcion":"BORDE DE CUELLO UTERINO PALPABLE"
  },
  {
    "codigo":27619001,
    "descripcion":"ENFERMEDAD CAUSADA POR CORONAVIRIDAE"
  },
  {
    "codigo":93155003,
    "descripcion":"MIOSITIS LINGUAL"
  },
  {
    "codigo":1010659006,
    "descripcion":"HEMANGIOMA INFANTIL SEGMENTARIO"
  },
  {
    "codigo":191459006,
    "descripcion":"DEMENCIA SENIL CON DEPRESIÓN"
  },
  {
    "codigo":420835009,
    "descripcion":"NEOPLASIA INTRAEPITELIAL DE LA CÓRNEA"
  },
  {
    "codigo":25784009,
    "descripcion":"XERODERMIA PIGMENTOSA, GRUPO C"
  },
  {
    "codigo":56717001,
    "descripcion":"TUBERCULOSIS"
  },
  {
    "codigo":124088009,
    "descripcion":"ÁCIDO ADENÍLICO POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":286093003,
    "descripcion":"INCAPAZ DE DESECHAR LOS RESIDUOS DOMICILIARIOS"
  },
  {
    "codigo":89485005,
    "descripcion":"VÍCTIMA DE ACCIONES DE PAZ"
  },
  {
    "codigo":23949002,
    "descripcion":"INFECCIÓN POR CAPILLARIA PHILIPPINENSIS"
  },
  {
    "codigo":22114000,
    "descripcion":"PERISTALTISMO AUSENTE"
  },
  {
    "codigo":251490001,
    "descripcion":"HIPERQUERATOSIS LINFEDEMATOSA"
  },
  {
    "codigo":284258001,
    "descripcion":"INCAPAZ DE AGARRAR"
  },
  {
    "codigo":448098001,
    "descripcion":"ANEURISMA DE SENO DE VALSALVA AÓRTICO CON PROTRUSIÓN EN ARTERIA PULMONAR"
  },
  {
    "codigo":413495001,
    "descripcion":"SOCIEDAD ESTADOUNIDENSE DE ANESTESISTAS - ESTADO FÍSICO CLASE 1"
  },
  {
    "codigo":446263001,
    "descripcion":"SÍNDROME DE LOEYS-DIETZ"
  },
  {
    "codigo":184119001,
    "descripcion":"OCUPACIÓN DEL PACIENTE - DESCONOCIDA"
  },
  {
    "codigo":249655009,
    "descripcion":"EVERSIÓN DE CONDUCTO ANAL"
  },
  {
    "codigo":772108003,
    "descripcion":"METABOLIZADOR INTERMEDIO DE NUDT15"
  },
  {
    "codigo":83980004,
    "descripcion":"ALTERACIÓN DE LA FAGOCITOSIS"
  },
  {
    "codigo":1263628005,
    "descripcion":"TRASTORNO FETAL DEBIDO A POSICIÓN INESTABLE ANTES DE TRABAJO DE PARTO"
  },
  {
    "codigo":313356004,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS DE BRONQUIO DE LÓBULO MEDIO DE PULMÓN DERECHO"
  },
  {
    "codigo":247820003,
    "descripcion":"MIEDO A TRANSPIRAR"
  },
  {
    "codigo":870412008,
    "descripcion":"REACCIÓN ADVERSA A VITAMINA D Y\/O DERIVADO DE VITAMINA D"
  },
  {
    "codigo":51212009,
    "descripcion":"QUERATÓLISIS PUNTEADA"
  },
  {
    "codigo":213217008,
    "descripcion":"COMPLICACIÓN VASCULAR PERIFÉRICA DE LA ASISTENCIA"
  },
  {
    "codigo":1163489008,
    "descripcion":"BRONQUITIS POR METAPNEUMOVIRUS HUMANO"
  },
  {
    "codigo":1290891000,
    "descripcion":"SARCOMA SINOVIAL POBREMENTE DIFERENCIADO"
  },
  {
    "codigo":111243002,
    "descripcion":"BURSITIS DE RODILLA"
  },
  {
    "codigo":12939007,
    "descripcion":"ESQUIZOFRENIA DESORGANIZADA CRÓNICA"
  },
  {
    "codigo":125191000119105,
    "descripcion":"RUPTURA FAMILIAR DEBIDA A NIÑO EN CUSTODIA DE SERVICIO DE PROTECCIÓN INFANTIL"
  },
  {
    "codigo":209547009,
    "descripcion":"ESGUINCE DE LIGAMENTO PÉLVICO"
  },
  {
    "codigo":733835007,
    "descripcion":"TUBERCULOSIS EXTRAPULMONAR CONCOMITANTE CON INFECCIÓN POR VIRUS DE INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":16017671000119106,
    "descripcion":"ALTERACIÓN DE CUERNO ANTERIOR DE MENISCO LATERAL DE AMBAS RODILLAS"
  },
  {
    "codigo":109408006,
    "descripcion":"DISOSTOSIS FRONTAL"
  },
  {
    "codigo":11104006,
    "descripcion":"MIOCARDIOPATÍA DILATADA DEBIDA A ENFERMEDAD DE ALMACENAMIENTO DE ÁCIDO FITÁNICO"
  },
  {
    "codigo":369717000,
    "descripcion":"G2: MODERADAMENTE DIFERENCIADO (50-95 POR CIENTO DE FORMACIÓN GLANDULAR)"
  },
  {
    "codigo":238645002,
    "descripcion":"LIQUEN PLANO CONFLUENTE"
  },
  {
    "codigo":1081761000119101,
    "descripcion":"SARCOMA PRIMARIO DE PARTES BLANDAS DE HOMBRO DERECHO"
  },
  {
    "codigo":9269007,
    "descripcion":"QUEMADURA EPIDÉRMICA DE OÍDO EXTERNO"
  },
  {
    "codigo":236810001,
    "descripcion":"INFERTILIDAD MASCULINA ADQUIRIDA DE ORIGEN ENDOCRINO"
  },
  {
    "codigo":72970002,
    "descripcion":"SIGNOS VITALES NORMALES"
  },
  {
    "codigo":269578002,
    "descripcion":"MELANOMA MALIGNO DE CABEZA Y CUELLO"
  },
  {
    "codigo":171274003,
    "descripcion":"INVITACIÓN DE VACUNACIÓN - NO RESPONDIDA"
  },
  {
    "codigo":402485009,
    "descripcion":"DEFICIENCIA DE CINC SECUNDARIA ADQUIRIDA"
  },
  {
    "codigo":204042007,
    "descripcion":"MALFORMACIÓN CONGÉNITA DEL CUERPO CALLOSO"
  },
  {
    "codigo":234975001,
    "descripcion":"CARIES DE RAÍZ"
  },
  {
    "codigo":300511003,
    "descripcion":"CORDÓN ESPERMÁTICO NO PALPABLE"
  },
  {
    "codigo":366047006,
    "descripcion":"APOSICIÓN DEL ORIFICIO LAGRIMAL INFERIOR - HALLAZGO"
  },
  {
    "codigo":298676005,
    "descripcion":"CREPITACIÓN PALPABLE DE LA COLUMNA LUMBAR"
  },
  {
    "codigo":15663521000119106,
    "descripcion":"RETINOPATÍA DE PURTSCHER DE OJO IZQUIERDO"
  },
  {
    "codigo":396980008,
    "descripcion":"TUMOR QUE INVADE EL NERVIO ÓPTICO POSTERIOR A LA LÁMINA CRIBOSA PERO NO HASTA EL FINAL DEL NERVIO"
  },
  {
    "codigo":724660009,
    "descripcion":"ABSTINENCIA DE HIPNÓTICO"
  },
  {
    "codigo":165769000,
    "descripcion":"ANTICUERPO RHESUS DETECTADO"
  },
  {
    "codigo":296841002,
    "descripcion":"SOBREDOSIS DE PREDNISONA"
  },
  {
    "codigo":427913003,
    "descripcion":"TORSIÓN INTRAVAGINAL DEL CORDÓN ESPERMÁTICO"
  },
  {
    "codigo":1279881008,
    "descripcion":"FRACTURA CERRADA DE METÁFISIS DE RADIO DISTAL"
  },
  {
    "codigo":67465009,
    "descripcion":"ABORTO ESPONTÁNEO CON SEPSIS"
  },
  {
    "codigo":131166004,
    "descripcion":"GRUPO SANGUÍNEO O>M<^H^"
  },
  {
    "codigo":720990007,
    "descripcion":"MENINGITIS CAUSADA POR BACILLUS ANTHRACIS"
  },
  {
    "codigo":426078008,
    "descripcion":"TUMOR QUE INVADE CABEZA Y CUELLO"
  },
  {
    "codigo":295006009,
    "descripcion":"ALERGIA A TRIAMTERENO"
  },
  {
    "codigo":293171001,
    "descripcion":"REACCIÓN ADVERSA A LA PREDNISOLONA TÓPICA"
  },
  {
    "codigo":291000119100,
    "descripcion":"DERMATITIS POR CONTACTO CAUSADA POR SUSTANCIA QUÍMICA"
  },
  {
    "codigo":719155005,
    "descripcion":"SÍNDROME DE DISCAPACIDAD INTELECTUAL LIGADA AL CROMOSOMA X Y EPILEPSIA CON CONTRACTURA ARTICULAR PROGRESIVA Y DISMORFISMO FACIAL"
  },
  {
    "codigo":194867006,
    "descripcion":"RUPTURA DE MÚSCULO PAPILAR COMO COMPLICACIÓN ACTUAL LUEGO DE INFARTO AGUDO DE MIOCARDIO"
  },
  {
    "codigo":335651000119102,
    "descripcion":"EDEMA DE CÓRNEA DERECHA CAUSADO POR USO DE LENTE DE CONTACTO"
  },
  {
    "codigo":291336000,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR NIQUETAMIDA"
  },
  {
    "codigo":673571000119102,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE PARED ABDOMINAL"
  },
  {
    "codigo":141091000119105,
    "descripcion":"COMPRESIÓN DE CEREBRO CONCOMITANTE CON HEMORRAGIA SUBARACNOIDEA NO TRAUMÁTICA Y DEBIDA A ELLA"
  },
  {
    "codigo":333091000119104,
    "descripcion":"PINGUÉCULA DE OJO DERECHO"
  },
  {
    "codigo":16066851000119103,
    "descripcion":"DOLOR EN REPOSO DE AMBOS MIEMBROS SUPERIORES DEBIDO A ATEROESCLEROSIS"
  },
  {
    "codigo":353571000119109,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE GLÁNDULA SUPRARRENAL DERECHA"
  },
  {
    "codigo":61960001,
    "descripcion":"DEFORMIDAD EN LORDOSIS DE COLUMNA VERTEBRAL"
  },
  {
    "codigo":13091000119107,
    "descripcion":"ALTERACIÓN DE ARTICULACIÓN DE HOMBRO"
  },
  {
    "codigo":133411000119108,
    "descripcion":"TROMBOSIS CRÓNICA DE VENA MESENTÉRICA"
  },
  {
    "codigo":60125001,
    "descripcion":"ENFISEMA INTERSTICIAL PERINATAL"
  },
  {
    "codigo":225800006,
    "descripcion":"INSTITUCIONALIZADO"
  },
  {
    "codigo":94728008,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LOS ANEXOS EPIDÉRMICOS"
  },
  {
    "codigo":92893004,
    "descripcion":"FORMA ANORMAL CONGÉNITA DEL ARCO DE LA VÉRTEBRA DORSAL"
  },
  {
    "codigo":125661005,
    "descripcion":"HERIDA ABIERTA DE PIERNA"
  },
  {
    "codigo":27357006,
    "descripcion":"ESTRABISMO ACOMODATIVO"
  },
  {
    "codigo":1010397000,
    "descripcion":"DEFICIENCIA SEVERA DE GLUCOSA - 6 - FOSFATO DESHIDROGENASA"
  },
  {
    "codigo":289501004,
    "descripcion":"CLÍTORIS PRESENTE"
  },
  {
    "codigo":254898001,
    "descripcion":"ENFERMEDAD DE PAGET DE LA VULVA"
  },
  {
    "codigo":123826004,
    "descripcion":"APORTE ANORMAL DE OXÍGENO"
  },
  {
    "codigo":189362009,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE GLÁNDULA SALIVAL MAYOR"
  },
  {
    "codigo":416903004,
    "descripcion":"TUBERCULOMA DE MÉDULA ESPINAL"
  },
  {
    "codigo":449671007,
    "descripcion":"CELULITIS DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":23687008,
    "descripcion":"ESPASMO DE ARTERIA CORONARIA"
  },
  {
    "codigo":87388001,
    "descripcion":"ANHEDONIA SEXUAL"
  },
  {
    "codigo":54620002,
    "descripcion":"QUISTE PERITONEAL, CONGÉNITO"
  },
  {
    "codigo":251228002,
    "descripcion":"ALTURA DE LA ONDA R AUMENTADA"
  },
  {
    "codigo":185692002,
    "descripcion":"INMUNIZACIÓN DE ADULTO - NUEVO LLAMADO ANULADO"
  },
  {
    "codigo":282161005,
    "descripcion":"CAPAZ DE CAMINAR PENDIENTE ABAJO"
  },
  {
    "codigo":413233009,
    "descripcion":"BANDA GÁSTRICA ADHERIDA"
  },
  {
    "codigo":247558006,
    "descripcion":"PELO ESPIRALADO"
  },
  {
    "codigo":685691000119105,
    "descripcion":"LEIOMIOSARCOMA PRIMARIO DE PELVIS"
  },
  {
    "codigo":16347003,
    "descripcion":"DETERMINACIÓN DEL ESTADO DEL PACIENTE, MODERADO AGRAVAMIENTO"
  },
  {
    "codigo":409563004,
    "descripcion":"BOTULISMO INTESTINAL"
  },
  {
    "codigo":737243006,
    "descripcion":"PÚRPURA CUTÁNEA CONCOMITANTE CON FRAGILIDAD VASCULAR Y DEBIDA A ELLA"
  },
  {
    "codigo":442331007,
    "descripcion":"INTOXICACIÓN POR COMPUESTO FENÓLICO"
  },
  {
    "codigo":278491007,
    "descripcion":"SEMINOMA - TERATOMA MIXTO DE TESTÍCULO"
  },
  {
    "codigo":276656004,
    "descripcion":"DEFORMIDAD POSTURAL FETAL"
  },
  {
    "codigo":14512007,
    "descripcion":"PALINGRAFÍA"
  },
  {
    "codigo":1259696008,
    "descripcion":"COREA DEBIDA A TRASTORNO DE SISTEMA ENDOCRINO"
  },
  {
    "codigo":473264009,
    "descripcion":"QUEMADURA DE MÚLTIPLES SITIOS DE LA MANO"
  },
  {
    "codigo":242053002,
    "descripcion":"HERIDA ACCIDENTAL"
  },
  {
    "codigo":12677003,
    "descripcion":"TUBERCULOSIS DEL ENCÉFALO"
  },
  {
    "codigo":373125003,
    "descripcion":"CÁMARA CARDÍACA DE TAMAÑO ANORMALMENTE PEQUEÑO"
  },
  {
    "codigo":274821002,
    "descripcion":"REFLEJO MASETÉRICO, AUSENTE"
  },
  {
    "codigo":346991000119107,
    "descripcion":"ESCOTOMA CENTRAL DE AMBOS OJOS"
  },
  {
    "codigo":110981005,
    "descripcion":"MUCINOSIS FOCAL DE LA PIEL"
  },
  {
    "codigo":209285008,
    "descripcion":"FRACTURA-SUBLUXACIÓN NO EXPUESTA DE LA ARTICULACIÓN RADIOCARPIANA"
  },
  {
    "codigo":405893008,
    "descripcion":"FENOTIPO K-"
  },
  {
    "codigo":240218006,
    "descripcion":"ENFERMEDAD DE KÜMMELL"
  },
  {
    "codigo":43610007,
    "descripcion":"PUNTAJE DE APGAR 1"
  },
  {
    "codigo":404058008,
    "descripcion":"LIPOMA FUSOCELULAR"
  },
  {
    "codigo":205615000,
    "descripcion":"TRISOMÍA 21 - FALTA DE DISYUNCIÓN MEIÓTICA"
  },
  {
    "codigo":402223002,
    "descripcion":"ECCEMA DE DEDO DE LA MANO"
  },
  {
    "codigo":305754009,
    "descripcion":"ATENDIDO POR ENFERMERA DE UNIDAD MÓVIL"
  },
  {
    "codigo":74543003,
    "descripcion":"INFECCIÓN CAUSADA POR OOCHORISTICA"
  },
  {
    "codigo":41775005,
    "descripcion":"CON RIESGO AUMENTADO DE MANEJO DE MANTENIMIENTO DE HOGAR ALTERADO"
  },
  {
    "codigo":238383006,
    "descripcion":"ABSCESO DE PUNTO DE SUTURA"
  },
  {
    "codigo":762671008,
    "descripcion":"INTOXICACIÓN CAUSADA POR CATINONA SINTÉTICA"
  },
  {
    "codigo":271151009,
    "descripcion":"AMPOLLA TRAUMÁTICA DE BRAZO"
  },
  {
    "codigo":302084002,
    "descripcion":"HALLAZGO RELACIONADO CON EL ASPECTO DEL MUÑÓN DE CORDÓN UMBILICAL"
  },
  {
    "codigo":236548002,
    "descripcion":"OSTEOMALACIA RELACIONADA CON ALUMINIO"
  },
  {
    "codigo":860975008,
    "descripcion":"DENTICIÓN NORMAL"
  },
  {
    "codigo":15639561000119107,
    "descripcion":"DOLOR EN AMBAS ARTICULACIONES ACROMIOCLAVICULARES"
  },
  {
    "codigo":300249003,
    "descripcion":"LENGUA NORMAL"
  },
  {
    "codigo":130211000119101,
    "descripcion":"NEOPLASIA NEUROENDOCRINA BENIGNA DE BRONQUIO"
  },
  {
    "codigo":726233006,
    "descripcion":"LACERACIÓN DE TENDÓN DE MÚSCULO ADUCTOR DE MUSLO"
  },
  {
    "codigo":11789321000119108,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO DE DEDO MEDIO DE MANO IZQUIERDA"
  },
  {
    "codigo":365785008,
    "descripcion":"NIVEL DE PRODUCTOS INTERMEDIARIOS DEL METABOLISMO - HALLAZGO"
  },
  {
    "codigo":201945008,
    "descripcion":"ARTROPATÍA TRAUMÁTICA DE LA ARTICULACIÓN RADIOCUBITAL DISTAL"
  },
  {
    "codigo":167342004,
    "descripcion":"MICROSCOPIA DE ORINA: CRISTALES DE OXALATO DE CALCIO"
  },
  {
    "codigo":3502005,
    "descripcion":"LINFADENITIS CERVICAL"
  },
  {
    "codigo":296579000,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE PIPERACINA"
  },
  {
    "codigo":298414009,
    "descripcion":"SIN FLEXIÓN PASIVA DE LA COLUMNA CERVICAL"
  },
  {
    "codigo":1667003,
    "descripcion":"CIERRE TEMPRANO DE LA FONTANELA"
  },
  {
    "codigo":165507003,
    "descripcion":"RECUENTO DE LEUCOCITOS DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":32600006,
    "descripcion":"COMPLICACIÓN DE LA EXTREMIDAD INFERIOR REIMPLANTADA"
  },
  {
    "codigo":1144877001,
    "descripcion":"HIPOPLASIA CONGÉNITA DE GLÁNDULA APOCRINA DE AXILA"
  },
  {
    "codigo":161837007,
    "descripcion":"SE ALIMENTA NORMALMENTE"
  },
  {
    "codigo":225538000,
    "descripcion":"IMPULSO SEXUAL INCONTROLABLE"
  },
  {
    "codigo":192770001,
    "descripcion":"TROMBOFLEBITIS DE SENO CAVERNOSO"
  },
  {
    "codigo":127234001,
    "descripcion":"NEOPLASIA DE LOS GANGLIOS LINFÁTICOS DE LA CARA"
  },
  {
    "codigo":784429009,
    "descripcion":"RUPTURA DE HERNIA DE PARED ABDOMINAL"
  },
  {
    "codigo":292909009,
    "descripcion":"REACCIÓN ADVERSA AL PERÓXIDO DE HIDRÓGENO"
  },
  {
    "codigo":1086781000119103,
    "descripcion":"ESTENOSIS DE ESTOMA DE ENTEROSTOMÍA"
  },
  {
    "codigo":291074002,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR MEDAZEPAM"
  },
  {
    "codigo":782594005,
    "descripcion":"ALERGIA A PROTEÍNA DE SOJA"
  },
  {
    "codigo":94466007,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LOS GANGLIOS LINFÁTICOS PARARRECTALES"
  },
  {
    "codigo":92631001,
    "descripcion":"CARCINOMA IN SITU DE LA CARA LARÍNGEA DEL PLIEGUE INTERARITENOIDEO"
  },
  {
    "codigo":289239008,
    "descripcion":"HALLAZGO RELACIONADO CON LA DURACIÓN DEL TRABAJO DE PARTO"
  },
  {
    "codigo":715223009,
    "descripcion":"SÍNDROME DE VARICELA FETAL"
  },
  {
    "codigo":713388002,
    "descripcion":"TROMBOCITOPENIA CON DISERITROPOYESIS RELACIONADA CON LA PROTEÍNA DE UNIÓN GATA 1"
  },
  {
    "codigo":1335980006,
    "descripcion":"GLAUCOMA DEBIDO A QUISTE DE CUERPO CILIAR DE OJO DERECHO"
  },
  {
    "codigo":112921000112103,
    "descripcion":"NEISSERIA FLAVA O NEISSERIA PERFLAVA O NEISSERIA SUBFLAVA"
  },
  {
    "codigo":449409002,
    "descripcion":"TRASTORNO RENAL DEBIDO A ENFERMEDAD DE CADENA LIVIANA LAMBDA"
  },
  {
    "codigo":1137537007,
    "descripcion":"CALCIFICACIÓN PUNTEADA DE EPÍFISIS DE HUESO METACARPIANO"
  },
  {
    "codigo":711553009,
    "descripcion":"EFECTO ADVERSO DE EXPOSICIÓN A MATERIAL INDUSTRIAL PELIGROSO"
  },
  {
    "codigo":21590003,
    "descripcion":"CATARATA ZONULAR CONGÉNITA"
  },
  {
    "codigo":283734005,
    "descripcion":"HERIDA POR MORDEDURA DE PERRO"
  },
  {
    "codigo":249131000,
    "descripcion":"HALLAZGO RELACIONADO CON EL VOLUMEN DE LÍQUIDO AMNIÓTICO"
  },
  {
    "codigo":1363243000,
    "descripcion":"QUISTES CONGÉNITOS MÚLTIPLES DE ENCÉFALO"
  },
  {
    "codigo":281899002,
    "descripcion":"HIDROCEFALIA CONGÉNITA CAUSADA POR TOXOPLASMOSIS"
  },
  {
    "codigo":314667001,
    "descripcion":"FRACTURA POR ESTALLIDO DE VÉRTEBRA"
  },
  {
    "codigo":773419004,
    "descripcion":"SÍNDROME DE DISCAPACIDAD INTELECTUAL, BAJA ESTATURA, TRASTORNOS DE CONDUCTA Y DISMORFISMO FACIAL"
  },
  {
    "codigo":445739004,
    "descripcion":"QUEMADURA POR FRICCIÓN DE CARA"
  },
  {
    "codigo":116224001,
    "descripcion":"COMPLICACIÓN DE PROCEDIMIENTO"
  },
  {
    "codigo":609579009,
    "descripcion":"DIABETES MELLITUS TRANSITORIA NEONATAL DE TIPO 1"
  },
  {
    "codigo":11873751000119106,
    "descripcion":"PIE CAVO CONGÉNITO BILATERAL"
  },
  {
    "codigo":247296006,
    "descripcion":"ALTERADO POR RUIDO FUERTE"
  },
  {
    "codigo":443904006,
    "descripcion":"CORONA FLEBECTÁSICA"
  },
  {
    "codigo":17920008,
    "descripcion":"TROMBOSIS DE LA VENA PORTA"
  },
  {
    "codigo":704213001,
    "descripcion":"FRACTURA NO EXPUESTA DE FALANGE DE PULGAR"
  },
  {
    "codigo":835285005,
    "descripcion":"AGUDEZA VISUAL DE OJO IZQUIERDO 6\/7,5"
  },
  {
    "codigo":48853007,
    "descripcion":"INTOXICACIÓN POR BRASSICA"
  },
  {
    "codigo":1259434000,
    "descripcion":"CARCINOMA PRIMARIO DE LABIO"
  },
  {
    "codigo":473002001,
    "descripcion":"ESTADO DE MADURACIÓN SEXUAL PREPUBERAL"
  },
  {
    "codigo":702378002,
    "descripcion":"SÍNDROME DE HIPERPARATIROIDISMO-TUMOR MANDIBULAR"
  },
  {
    "codigo":309162003,
    "descripcion":"HALLAZGOS HISTOLÓGICOS NORMALES"
  },
  {
    "codigo":276394007,
    "descripcion":"HEMORROIDES PROLAPSADAS IRREDUCTIBLES"
  },
  {
    "codigo":132721000119104,
    "descripcion":"EMERGENCIA HIPERTENSIVA"
  },
  {
    "codigo":733311005,
    "descripcion":"TRASTORNO DEBIDO A INSERCIÓN DE DISPOSITIVO DE DRENAJE EN GLAUCOMA"
  },
  {
    "codigo":405631006,
    "descripcion":"INFECCIÓN PEDIÁTRICA POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":209023006,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA NO EXPUESTA DE LA ARTICULACIÓN SUBASTRAGALINA"
  },
  {
    "codigo":241791006,
    "descripcion":"EFECTO TÓXICO CAUSADO POR DIQUAT"
  },
  {
    "codigo":895316002,
    "descripcion":"FORMA DE BALA ANORMAL CONGÉNITA DE FALANGE DE DEDO MEDIO"
  },
  {
    "codigo":371028005,
    "descripcion":"PARESIA ESPÁSTICA"
  },
  {
    "codigo":698708006,
    "descripcion":"HEMORRAGIA PREPARTO DEBIDA A HEMORRAGIA TIPO I"
  },
  {
    "codigo":403796005,
    "descripcion":"SÍNDROME DE CABELLO QUEBRADIZO, ALTERACIÓN INTELECTUAL, DISMINUCIÓN DE LA FERTILIDAD Y BAJA ESTATURA"
  },
  {
    "codigo":238121000,
    "descripcion":"DEFICIENCIA DE YODO"
  },
  {
    "codigo":239956009,
    "descripcion":"TENDINITIS INFRAESPINOSA"
  },
  {
    "codigo":205353002,
    "descripcion":"PERODACTILIA DE VARIOS DEDOS DEL PIE"
  },
  {
    "codigo":762409003,
    "descripcion":"FISURA DE PALADAR CON FISURA LABIAL IZQUIERDA"
  },
  {
    "codigo":305492009,
    "descripcion":"BAJO ATENCIÓN DE OFTALMÓLOGO CLÍNICO"
  },
  {
    "codigo":679691000119100,
    "descripcion":"NEURITIS ÓPTICA RETROBULBAR DE AMBOS OJOS"
  },
  {
    "codigo":270889005,
    "descripcion":"DELECIÓN DEL BRAZO LARGO DEL CROMOSOMA 18"
  },
  {
    "codigo":296561000119108,
    "descripcion":"DISPLASIA FIBROSA MONOSTÓTICA DE HUESO DE ANTEBRAZO"
  },
  {
    "codigo":352011000119102,
    "descripcion":"MELANOMA MALIGNO DE PIEL DE HOMBRO DERECHO"
  },
  {
    "codigo":301822002,
    "descripcion":"SANGRADO VAGINAL ANORMAL"
  },
  {
    "codigo":367358004,
    "descripcion":"INTELIGENCIA SUPERIOR AL PROMEDIO"
  },
  {
    "codigo":400126005,
    "descripcion":"ULERITEMA OFRIÓGENES"
  },
  {
    "codigo":203518006,
    "descripcion":"DETENCIÓN PARCIAL DEL CRECIMIENTO EPIFISARIO"
  },
  {
    "codigo":365523001,
    "descripcion":"HALLAZGO EN LOS ANTECEDENTES LABORALES, FINANCIEROS, LEGALES Y\/O SOCIOECONÓMICOS"
  },
  {
    "codigo":5075002,
    "descripcion":"LINFANGITIS AGUDA DE HOMBRO"
  },
  {
    "codigo":70611002,
    "descripcion":"HEMORRAGIA INTRAVENTRICULAR PERINATAL"
  },
  {
    "codigo":72446009,
    "descripcion":"EFECTO TÓXICO DE COMPUESTO DE PLOMO INORGÁNICO"
  },
  {
    "codigo":234451005,
    "descripcion":"ENFERMEDAD DE VON WILLEBRAND ADQUIRIDA"
  },
  {
    "codigo":267219007,
    "descripcion":"NEOPLASIA DE CUERPO DE ÚTERO EN EL EMBARAZO, EL NACIMIENTO Y EL PUERPERIO"
  },
  {
    "codigo":168915007,
    "descripcion":"ARTROGRAFÍA NORMAL"
  },
  {
    "codigo":298152001,
    "descripcion":"DERRAME DE ARTICULACIÓN DE DEDO DE LA MANO"
  },
  {
    "codigo":11820811000119105,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN GLENOHUMERAL IZQUIERDA"
  },
  {
    "codigo":429224003,
    "descripcion":"INSUFICIENCIA RENAL AGUDA POR NECROSIS CORTICAL AGUDA"
  },
  {
    "codigo":134312002,
    "descripcion":"CARCINOMA ODONTÓGENO DE CÉLULAS FANTASMAS"
  },
  {
    "codigo":724136006,
    "descripcion":"MASTOPATÍA DIABÉTICA"
  },
  {
    "codigo":789672007,
    "descripcion":"TROMBOFLEBITIS DEBIDA A PROCEDIMIENTO"
  },
  {
    "codigo":165245003,
    "descripcion":"CAMINA DE MANERA INDEPENDIENTE"
  },
  {
    "codigo":296317006,
    "descripcion":"SOBREDOSIS DE PSICOESTIMULANTES"
  },
  {
    "codigo":1344893007,
    "descripcion":"LESIÓN POR PRESIÓN CICATRIZADA"
  },
  {
    "codigo":230781006,
    "descripcion":"PARÁLISIS CEREBRAL DISTÓNICA\/RÍGIDA"
  },
  {
    "codigo":720466001,
    "descripcion":"SÍNDROME DE DISTONÍA-PARKINSONISMO DE COMIENZO EN LA VIDA ADULTA"
  },
  {
    "codigo":34173009,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA ARTERIA RADIAL"
  },
  {
    "codigo":294482006,
    "descripcion":"ALERGIA A ÁCIDO FUSÍDICO"
  },
  {
    "codigo":292647002,
    "descripcion":"REACCIÓN ADVERSA A ADHESIVO TISULAR DE USO QUIRÚRGICO"
  },
  {
    "codigo":718631006,
    "descripcion":"ICTIOSIS EPIDERMOLÍTICA ANULAR"
  },
  {
    "codigo":390951007,
    "descripcion":"GLUCEMIA EN AYUNAS ALTERADA"
  },
  {
    "codigo":290812002,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR AMOXAPINA"
  },
  {
    "codigo":94204005,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE VASO SANGUÍNEO DEL HUECO POPLÍTEO"
  },
  {
    "codigo":782332007,
    "descripcion":"VARIANTE CUBITAL NEGATIVA DE MUÑECA, CONGÉNITA"
  },
  {
    "codigo":92369000,
    "descripcion":"NEOPLASIA BENIGNA DE LA PIEL DE LOS LABIOS"
  },
  {
    "codigo":126972009,
    "descripcion":"NEOPLASIA DEL NERVIO MOTOR OCULAR EXTERNO"
  },
  {
    "codigo":288977001,
    "descripcion":"INCAPAZ DE CHUPAR"
  },
  {
    "codigo":420049001,
    "descripcion":"ANOMALÍA CONGÉNITA DEL APARATO LAGRIMAL"
  },
  {
    "codigo":1237414000,
    "descripcion":"METÁSTASIS DE CISTOADENOCARCINOMA EN RIÑÓN"
  },
  {
    "codigo":188838004,
    "descripcion":"NEOPLASIA BENIGNA DE RECTO Y CONDUCTO ANAL"
  },
  {
    "codigo":10948671000119103,
    "descripcion":"HERIDA ABIERTA DE MANO IZQUIERDA DEBIDA A MORDEDURA DE ANIMAL"
  },
  {
    "codigo":299071000119104,
    "descripcion":"HEMARTROSIS DE CADERA IZQUIERDA"
  },
  {
    "codigo":16027711000119104,
    "descripcion":"EXOSTOSIS DE AMBOS HÚMEROS"
  },
  {
    "codigo":711291005,
    "descripcion":"AUMENTO DE LA LONGITUD DEL MENTÓN A LAS FAUCES"
  },
  {
    "codigo":285307007,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS DE LA PIEL DE LABIO SUPERIOR"
  },
  {
    "codigo":21328003,
    "descripcion":"SEDIMENTO CORNEAL ARGENTOSO"
  },
  {
    "codigo":283472004,
    "descripcion":"HERIDA PUNZANTE EN LA ESPALDA"
  },
  {
    "codigo":414544007,
    "descripcion":"EVENTRACIÓN IRREDUCTIBLE DE PARED ABDOMINAL ANTERIOR"
  },
  {
    "codigo":85029000,
    "descripcion":"ANOMALÍA CONGÉNITA DE LAS TROMPAS DE FALOPIO"
  },
  {
    "codigo":108761000119101,
    "descripcion":"TORSIÓN TIBIAL INTERNA CONGÉNITA"
  },
  {
    "codigo":11823321000119101,
    "descripcion":"HERIDA INFECTADA DE BRAZO DERECHO DEBIDA A PICADURA DE INSECTO NO VENENOSO"
  },
  {
    "codigo":248869003,
    "descripcion":"CLÍTORIS PEQUEÑO"
  },
  {
    "codigo":445477009,
    "descripcion":"ARTROPATÍA DE PELVIS POR CRISTALES"
  },
  {
    "codigo":247034002,
    "descripcion":"SINEQUIA ANTERIOR PERIFÉRICA"
  },
  {
    "codigo":1230074002,
    "descripcion":"PATRÓN DE USO EPISÓDICO NOCIVO SIN DEPENDENCIA DE HIPNÓTICO"
  },
  {
    "codigo":17658005,
    "descripcion":"INFECCIÓN CAUSADA POR THEILERIA PARVA"
  },
  {
    "codigo":1197306009,
    "descripcion":"EPENDIMOMA MIXOPAPILAR DE ENCÉFALO"
  },
  {
    "codigo":703951002,
    "descripcion":"CONJUNTIVITIS ALÉRGICA CAUSADA POR DERMATOPHAGOIDES FARINAE"
  },
  {
    "codigo":409039002,
    "descripcion":"ALTERACIÓN DE LA CONDUCTA DEL ADULTO MAYOR"
  },
  {
    "codigo":81359005,
    "descripcion":"TUBERCULOSIS DE URÉTER"
  },
  {
    "codigo":79524000,
    "descripcion":"ECOUTEURISMO"
  },
  {
    "codigo":210596000,
    "descripcion":"SECCIÓN PARCIAL, TENDÓN EXTENSOR LARGO DEL PULGAR"
  },
  {
    "codigo":308900004,
    "descripcion":"ÚLCERA DE DEDO DE LA MANO"
  },
  {
    "codigo":1259172004,
    "descripcion":"DESARROLLO SOSTENIDO DE RAÍZ DE DIENTE PERMANENTE INMADURO LUEGO DE TRAUMA DENTAL"
  },
  {
    "codigo":734884008,
    "descripcion":"DIARREA CONCOMITANTE CON SÍNDROME CARCINOIDE Y DEBIDA A ÉL"
  },
  {
    "codigo":700281002,
    "descripcion":"QUERATOCONO INESTABLE"
  },
  {
    "codigo":733049004,
    "descripcion":"SÍNDROME DE ENCEFALOPATÍA, CALCIFICACIONES INTRACEREBRALES Y DEGENERACIÓN DE LA RETINA"
  },
  {
    "codigo":44921007,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN LA REGIÓN DEL OÍDO, SIN INFECCIÓN"
  },
  {
    "codigo":12153008,
    "descripcion":"DEFICIENCIA ADQUIRIDA DE FACTOR IX"
  },
  {
    "codigo":1255502000,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO DE PULGAR"
  },
  {
    "codigo":307065008,
    "descripcion":"ATENDIDO POR HEMATÓLOGO CLÍNICO"
  },
  {
    "codigo":10318004,
    "descripcion":"PUNTAJE DE APGAR 6"
  },
  {
    "codigo":403534007,
    "descripcion":"ALOPECIA SOBRE SUTURA"
  },
  {
    "codigo":205091006,
    "descripcion":"PIE CAVO CONGÉNITO"
  },
  {
    "codigo":399864000,
    "descripcion":"EDEMA DE MÁCULA NO SIGNIFICATIVO CLÍNICAMENTE DEBIDO A DIABETES MELLITUS"
  },
  {
    "codigo":237859009,
    "descripcion":"ACIDOSIS METABÓLICA Y ALCALOSIS METABÓLICA"
  },
  {
    "codigo":39416002,
    "descripcion":"CONCLUSIÓN ERRÓNEA"
  },
  {
    "codigo":236024003,
    "descripcion":"HERNIA INGUINAL ESTRANGULADA"
  },
  {
    "codigo":1153528004,
    "descripcion":"INTOXICACIÓN CAUSADA POR SUSTANCIA CON ESTRUCTURA ÉTER"
  },
  {
    "codigo":50030101000188101,
    "descripcion":"DIETA SIN GALACTOSA"
  },
  {
    "codigo":203256006,
    "descripcion":"PERIOSTITIS DE COLUMNA VERTEBRAL CERVICAL SIN OSTEOMIELITIS"
  },
  {
    "codigo":170488007,
    "descripcion":"PORTADOR DE ESTREPTOCOCO"
  },
  {
    "codigo":82291000119105,
    "descripcion":"NEUROMA DE MANO"
  },
  {
    "codigo":301560000,
    "descripcion":"NO SE TRASLADA APOYÁNDOSE EN LOS MUEBLES"
  },
  {
    "codigo":398029001,
    "descripcion":"PARÁLISIS DE VEJIGA URINARIA"
  },
  {
    "codigo":365261004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA COCINAR ALIMENTOS"
  },
  {
    "codigo":234189005,
    "descripcion":"DESPLAZAMIENTO DE PRÓTESIS DE VÁLVULA CARDÍACA"
  },
  {
    "codigo":266957005,
    "descripcion":"PREOCUPACIÓN ACERCA DE LOS NEGOCIOS"
  },
  {
    "codigo":1217229007,
    "descripcion":"SÍNDROME DE DISPLASIA CRANEOFACIAL, ESTATURA BAJA, ANOMALÍAS ECTODÉRMICAS Y DISCAPACIDAD INTELECTUAL"
  },
  {
    "codigo":299725007,
    "descripcion":"OJO DERECHO DOMINANTE"
  },
  {
    "codigo":70349007,
    "descripcion":"SEUDONEUTROFILIA"
  },
  {
    "codigo":232354002,
    "descripcion":"EPISTAXIS ANTERIOR"
  },
  {
    "codigo":166818002,
    "descripcion":"LÍPIDOS FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":2978006,
    "descripcion":"ANEURISMA DE LA CONJUNTIVA"
  },
  {
    "codigo":723874007,
    "descripcion":"OBSTRUCCIÓN ARTERIAL DEBIDA A EMBOLIA CARDÍACA NO TROMBÓTICA"
  },
  {
    "codigo":230519001,
    "descripcion":"LESIÓN DE LA CINTILLA ÓPTICA"
  },
  {
    "codigo":35746009,
    "descripcion":"FIBROMA UTERINO QUE AFECTA AL EMBARAZO"
  },
  {
    "codigo":301581000119104,
    "descripcion":"ABSCESO DE VAINA TENDINOSA DE PIERNA IZQUIERDA"
  },
  {
    "codigo":363426009,
    "descripcion":"NEOPLASIA MALIGNA DE SENO ETMOIDAL"
  },
  {
    "codigo":11852301000119104,
    "descripcion":"AMPUTACIÓN PARCIAL TRAUMÁTICA DE DEDO GORDO DE PIE DERECHO"
  },
  {
    "codigo":296055006,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE FLUNITRAZEPAM"
  },
  {
    "codigo":294220003,
    "descripcion":"ALERGIA A ALOPURINOL"
  },
  {
    "codigo":15948301000119106,
    "descripcion":"ÚLCERA DE PANTORRILLA DERECHA DEBIDA A SÍNDROME POSTROMBÓTICO"
  },
  {
    "codigo":1144353002,
    "descripcion":"ESTOMATITIS IRRITATIVA POR CONTACTO CAUSADA POR PRÓTESIS DENTAL"
  },
  {
    "codigo":16003751000119101,
    "descripcion":"PINZAMIENTO SUBCORACOIDEO DE AMBAS REGIONES DE HOMBRO"
  },
  {
    "codigo":126710000,
    "descripcion":"NEOPLASIA DE BRONQUIO DE LÓBULO MEDIO DE PULMÓN DERECHO"
  },
  {
    "codigo":95777008,
    "descripcion":"NISTAGMO TEMPORAL"
  },
  {
    "codigo":292385008,
    "descripcion":"REACCIÓN ADVERSA AL FLUSPIRILENO"
  },
  {
    "codigo":93942003,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL PARAMETRIO"
  },
  {
    "codigo":290550001,
    "descripcion":"INTOXICACIÓN POR OXIBUPROCAÍNA"
  },
  {
    "codigo":10678951000119103,
    "descripcion":"TUMEFACCIÓN LOCALIZADA DE AMBAS MANOS"
  },
  {
    "codigo":225014007,
    "descripcion":"SE SIENTE VACÍO"
  },
  {
    "codigo":124875007,
    "descripcion":"ADQUISICIÓN DE NUEVOS ANTÍGENOS"
  },
  {
    "codigo":288715008,
    "descripcion":"UTILIZA LA CONVERSACIÓN CON FINES RECREATIVOS"
  },
  {
    "codigo":254112001,
    "descripcion":"OSTEOPOROSIS CON SEUDOGLIOMA"
  },
  {
    "codigo":188576003,
    "descripcion":"ENFERMEDAD DE HODGKIN, CELULARIDAD MIXTA DE GANGLIOS LINFÁTICOS INTRATORÁCICOS"
  },
  {
    "codigo":285045001,
    "descripcion":"DIFICULTAD PARA USAR ANTEOJOS"
  },
  {
    "codigo":283210001,
    "descripcion":"ANZUELO EN EL ABDOMEN"
  },
  {
    "codigo":248607001,
    "descripcion":"DESCENSO DE TRÁQUEA DURANTE INSPIRACIÓN"
  },
  {
    "codigo":445215005,
    "descripcion":"INFECCIÓN DE HUESO DE TIBIA Y\/O PERONÉ"
  },
  {
    "codigo":281375006,
    "descripcion":"CIFOESCOLIOSIS NEUROMUSCULAR"
  },
  {
    "codigo":707359008,
    "descripcion":"CARCINOMA PRIMARIO DE CÉLULAS ESCAMOSAS DE SENO ETMOIDAL"
  },
  {
    "codigo":1231647008,
    "descripcion":"APRAXIA OCULOMOTORA ADQUIRIDA TIPO PARIETAL"
  },
  {
    "codigo":246772007,
    "descripcion":"MIRADA"
  },
  {
    "codigo":212169004,
    "descripcion":"LESIÓN DE MÉDULA ESPINAL DORSAL SIN LESIÓN DE LA COLUMNA VERTEBRAL"
  },
  {
    "codigo":441545004,
    "descripcion":"PRIAPISMO NO ISQUÉMICO"
  },
  {
    "codigo":1162441008,
    "descripcion":"ENCONDROMA DE HUESO DE FALANGE DE PIE"
  },
  {
    "codigo":408777009,
    "descripcion":"CONSENTIMIENTO PARA EXAMEN POSTMORTEM PARCIAL, OTORGADO"
  },
  {
    "codigo":79262001,
    "descripcion":"INTOXICACIÓN POR LOLIUM RIGIDUM"
  },
  {
    "codigo":208499002,
    "descripcion":"FRACTURA NO EXPUESTA DE MÚLTIPLES HUESOS DE MANO"
  },
  {
    "codigo":77427003,
    "descripcion":"INTOLERANCIA A LA ACTIVIDAD"
  },
  {
    "codigo":110195007,
    "descripcion":"QUEMADURA DE PRIMER GRADO DE LA MUCOSA LABIAL"
  },
  {
    "codigo":403272001,
    "descripcion":"HIPOMELANOSIS POSINFECCIOSA"
  },
  {
    "codigo":1255240001,
    "descripcion":"FRACTURA EXPUESTA DE MÚLTIPLES HUESOS METATARSIANOS"
  },
  {
    "codigo":370504007,
    "descripcion":"TRASTORNO DE DIRECCIÓN DE FLUJO DE HUMOR ACUOSO"
  },
  {
    "codigo":763720007,
    "descripcion":"HIPERMETIONINEMIA DEBIDA A DEFICIENCIA DE GLICINA N-METILTRANSFERASA"
  },
  {
    "codigo":237597000,
    "descripcion":"TRASTORNO DE LA REGULACIÓN DE LA GLUCOSA"
  },
  {
    "codigo":40989001,
    "descripcion":"INTOXICACIÓN POR PROPOXUR"
  },
  {
    "codigo":11828341000119101,
    "descripcion":"RUPTURA TRAUMÁTICA DE TENDÓN DEL MÚSCULO CUÁDRICEPS IZQUIERDO"
  },
  {
    "codigo":73757007,
    "descripcion":"OCLUSIÓN VASCULAR RETINIANA"
  },
  {
    "codigo":235762001,
    "descripcion":"PROCTITIS CRÓNICA POR RADIACIÓN"
  },
  {
    "codigo":792818003,
    "descripcion":"PULSO EN ARTERIA PEDIA DERECHA PRESENTE"
  },
  {
    "codigo":71922006,
    "descripcion":"TRASTORNO INMUNOLÓGICO"
  },
  {
    "codigo":170226006,
    "descripcion":"NIÑO DERIVADO A MÉDICO GENERAL"
  },
  {
    "codigo":201159000,
    "descripcion":"HIRSUTISMO IDIOPÁTICO"
  },
  {
    "codigo":299463000,
    "descripcion":"PIE CORTO"
  },
  {
    "codigo":202994006,
    "descripcion":"INFECCIÓN TUBERCULOSA DE VAINA TENDINOSA"
  },
  {
    "codigo":233927002,
    "descripcion":"PARO CARDÍACO CON REANIMACIÓN EXITOSA"
  },
  {
    "codigo":430535006,
    "descripcion":"INSUFICIENCIA RENAL AGUDA CON OLIGURIA"
  },
  {
    "codigo":102855007,
    "descripcion":"CRISTAL URINARIO, FOSFATO DE CALCIO"
  },
  {
    "codigo":397767007,
    "descripcion":"INSUFICIENCIA RESPIRATORIA AGUDA QUE REQUIERE REINTUBACIÓN"
  },
  {
    "codigo":364999007,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA ACOMODAR LOS ÓRGANOS DE LA FONACIÓN AL MOMENTO DE ARTICULAR PALABRAS"
  },
  {
    "codigo":723612001,
    "descripcion":"SÍNDROME DE ATROFIA DE MÚSCULOS ESPINALES, MALFORMACIÓN DE DANDY-WALKER Y CATARATAS"
  },
  {
    "codigo":35484002,
    "descripcion":"APLASIA DE CUTIS CONGÉNITA"
  },
  {
    "codigo":363164004,
    "descripcion":"TRASTORNO INFECCIOSO DE TENDÓN"
  },
  {
    "codigo":428700003,
    "descripcion":"ESCLEROSIS MÚLTIPLE PROGRESIVA PRIMARIA"
  },
  {
    "codigo":333071000119100,
    "descripcion":"PIGMENTACIÓN DE SUPERFICIE POSTERIOR DE CÓRNEA DE OJO DERECHO"
  },
  {
    "codigo":230257000,
    "descripcion":"ENFERMEDAD PARANEOPLÁSICA DE LA NEURONA MOTORA"
  },
  {
    "codigo":263025001,
    "descripcion":"LUXACIÓN DE ARTICULACIÓN MEDIOCARPIANA"
  },
  {
    "codigo":846429301000119107,
    "descripcion":"ÚLCERA VENOSA DE MUSLO IZQUIERDO"
  },
  {
    "codigo":295793002,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE VINCRISTINA"
  },
  {
    "codigo":721777004,
    "descripcion":"INFECCIÓN CAUSADA POR VIRUS MACHUPO"
  },
  {
    "codigo":293958003,
    "descripcion":"ALERGIA A DEXANFETAMINA"
  },
  {
    "codigo":31814006,
    "descripcion":"REABSORCIÓN FACULTATIVA DE AGUA"
  },
  {
    "codigo":128283000,
    "descripcion":"NEUROPATÍA CRÓNICA"
  },
  {
    "codigo":718107000,
    "descripcion":"INMUNODEFICIENCIA COMBINADA SEVERA NEGATIVA PARA LINFOCITOS T, POSITIVA PARA LINFOCITOS B DEBIDA A DEFICIENCIA DE CINASA JANO-3"
  },
  {
    "codigo":29979000,
    "descripcion":"INFECCIÓN CAUSADA POR ENTEROMONAS HOMINIS"
  },
  {
    "codigo":292123005,
    "descripcion":"REACCIÓN ADVERSA AL TRISILICATO DE MAGNESIO"
  },
  {
    "codigo":161051006,
    "descripcion":"CON MAYOR RIESGO DE VIOLENCIA EN HOGAR"
  },
  {
    "codigo":423195009,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL SISTEMA DE DRENAJE LAGRIMAL"
  },
  {
    "codigo":95515009,
    "descripcion":"IMPLANTACIÓN BAJA DE LAS OREJAS"
  },
  {
    "codigo":290288003,
    "descripcion":"INTOXICACIÓN POR OXIFENBUTAZONA"
  },
  {
    "codigo":60912005,
    "descripcion":"FÍSTULA DE CONDUCTO TORÁCICO"
  },
  {
    "codigo":306601000119100,
    "descripcion":"GOTA CRÓNICA DE MUÑECA, SIN TOFO, CAUSADA POR FÁRMACO"
  },
  {
    "codigo":419525002,
    "descripcion":"MOVIMIENTO PARADÓJICO DEL ABDOMEN DURANTE LA INSPIRACIÓN"
  },
  {
    "codigo":124613005,
    "descripcion":"DEFICIENCIA DE CITRATO (SI) - SINTASA"
  },
  {
    "codigo":5391000119108,
    "descripcion":"ECCEMA NO ALÉRGICO"
  },
  {
    "codigo":15979791000119108,
    "descripcion":"DESPLAZAMIENTO DE MENISCO DE ARTICULACIÓN TEMPOROMANDIBULAR DERECHA"
  },
  {
    "codigo":1304261009,
    "descripcion":"SÍNDROME UVEÍTIS GLAUCOMA HIPEMA DE OJO IZQUIERDO"
  },
  {
    "codigo":91845007,
    "descripcion":"GÓNADA ACCESORIA"
  },
  {
    "codigo":253850004,
    "descripcion":"PENE ROTADO"
  },
  {
    "codigo":1204122005,
    "descripcion":"PERICARDITIS EFUSIVO-CONSTRICTIVA"
  },
  {
    "codigo":186479001,
    "descripcion":"POLIOMIELITIS PARALÍTICA AGUDA, VIRUS NATURAL, IMPORTADA"
  },
  {
    "codigo":284783002,
    "descripcion":"NO REALIZA ACTIVIDAD DE HIGIENE PERSONAL"
  },
  {
    "codigo":15707561000119104,
    "descripcion":"MIOSITIS OSIFICANTE TRAUMÁTICA DE MUSLOS BILATERALES"
  },
  {
    "codigo":282948006,
    "descripcion":"CAPAZ DE INCLINARSE PARA TOCARSE LOS PIES"
  },
  {
    "codigo":1231385002,
    "descripcion":"DEMUESTRA CONOCIMIENTO SOBRE TRATAMIENTO COMPLEMENTARIO"
  },
  {
    "codigo":1264153003,
    "descripcion":"PERITONITIS PÉLVICA POSTERIOR A EMBARAZO ECTÓPICO"
  },
  {
    "codigo":444953004,
    "descripcion":"MÉDICAMENTE APTO PARA TRASLADO A PRISIÓN"
  },
  {
    "codigo":1296921004,
    "descripcion":"RESISTENCIA SECUNDARIA A VASOPRESINA ARGININA"
  },
  {
    "codigo":16690601000119108,
    "descripcion":"QUISTE LÚTEO BILATERAL"
  },
  {
    "codigo":101451331000119102,
    "descripcion":"STENT RECUBIERTO CON MEDICACIÓN EN RAMA DE ARTERIA CORONARIA IZQUIERDA"
  },
  {
    "codigo":10956201000119108,
    "descripcion":"HERIDA ABIERTA DE DEDO MEDIO DE MANO DERECHA DEBIDA A MORDEDURA"
  },
  {
    "codigo":836334005,
    "descripcion":"AGUDEZA VISUAL DE OJO DERECHO 6\/6"
  },
  {
    "codigo":408515005,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: ETÍOPE"
  },
  {
    "codigo":242840004,
    "descripcion":"AUTOINTOXICACIÓN POR MONÓXIDO DE CARBONO"
  },
  {
    "codigo":77165001,
    "descripcion":"LESIÓN TRAUMÁTICA DE VEJIGA URINARIA"
  },
  {
    "codigo":109933002,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE NERVIOS PERIFÉRICOS DE HOMBRO"
  },
  {
    "codigo":699757001,
    "descripcion":"RETINITIS FOCAL DE LA MÁCULA"
  },
  {
    "codigo":370242002,
    "descripcion":"LACERACIÓN SUPERFICIAL DE LA PARED TORÁCICA"
  },
  {
    "codigo":697922003,
    "descripcion":"HIPERTENSIÓN PULMONAR EN HISTIOCITOSIS DE CÉLULAS DE LANGERHANS"
  },
  {
    "codigo":206402005,
    "descripcion":"DESLIZAMIENTO NEONATAL DE LA LIGADURA UMBILICAL"
  },
  {
    "codigo":763458005,
    "descripcion":"ENFERMEDAD DE CHARCOT-MARIE-TOOTH LIGADA AL CROMOSOMA X TIPO 3"
  },
  {
    "codigo":9794007,
    "descripcion":"HIDROPESÍA ENDOLINFÁTICA"
  },
  {
    "codigo":401175000,
    "descripcion":"HALLAZGO RELACIONADO CON EL PATRÓN DEL SUEÑO"
  },
  {
    "codigo":239170008,
    "descripcion":"CICATRIZ MADURA"
  },
  {
    "codigo":403010007,
    "descripcion":"TIÑA DE CUERO CABELLUDO CAUSADA POR MICROSPORUM GYPSEUM"
  },
  {
    "codigo":73495003,
    "descripcion":"DISINERGIA CEREBELOSA MIOCLÓNICA"
  },
  {
    "codigo":16637661000119104,
    "descripcion":"TRASTORNO DE AMBOS NERVIOS CIÁTICOS POPLÍTEOS EXTERNOS EN RAMA POPLÍTEA LATERAL"
  },
  {
    "codigo":270103006,
    "descripcion":"INFORME FORENSE - SOLICITADO"
  },
  {
    "codigo":366572001,
    "descripcion":"AMPLITUD DE MOVIMIENTO ACTIVO DE ADUCCIÓN DE LA CADERA - HALLAZGO"
  },
  {
    "codigo":202732003,
    "descripcion":"PROLAPSO DE DISCO INTERVERTEBRAL CON RADICULOPATÍA"
  },
  {
    "codigo":399340005,
    "descripcion":"NEFRITIS HEREDITARIA"
  },
  {
    "codigo":6124009,
    "descripcion":"LINFANGIECTASIA INTESTINAL PRIMARIA"
  },
  {
    "codigo":299201003,
    "descripcion":"CREPITACIÓN PALPABLE DE ARTICULACIÓN DE PULGAR"
  },
  {
    "codigo":364737004,
    "descripcion":"ESTADO DE SALUD GENERAL DEL RECIÉN NACIDO - HALLAZGO"
  },
  {
    "codigo":266433003,
    "descripcion":"ENFERMEDAD POR REFLUJO GASTROESOFÁGICO CON ESOFAGITIS"
  },
  {
    "codigo":233665006,
    "descripcion":"SÍNDROME DE INMOVILIDAD CILIAR POR CILIOS EXCESIVAMENTE LARGOS"
  },
  {
    "codigo":168129007,
    "descripcion":"LEUCOCITOS VISTOS POR MICROSCOPIA"
  },
  {
    "codigo":788886000,
    "descripcion":"EXCORIACIÓN CRÓNICA DE PIEL"
  },
  {
    "codigo":428438000,
    "descripcion":"LESIÓN TRAUMÁTICA INHALATORIA POR QUÍMICOS"
  },
  {
    "codigo":658051000005106,
    "descripcion":"PLACENTA UBICADA EN PARED ANTERIOR DERECHA DE ÚTERO"
  },
  {
    "codigo":35222003,
    "descripcion":"ÚLCERA NEURÓGENA CRÓNICA DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":10631031000119102,
    "descripcion":"LINFANGITIS AGUDA DE RODILLA IZQUIERDA"
  },
  {
    "codigo":69825009,
    "descripcion":"MUCOCELE DE LA GLÁNDULA SALIVAL"
  },
  {
    "codigo":231830001,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS IN SITU DE PÁRPADO"
  },
  {
    "codigo":787051000,
    "descripcion":"GLAUCOMA DE ÁNGULO ABIERTO DE OJO IZQUIERDO"
  },
  {
    "codigo":1149334009,
    "descripcion":"INTOXICACIÓN AGUDA"
  },
  {
    "codigo":721515003,
    "descripcion":"SÍNDROME DEL CORDÓN ANTERIOR DE MÉDULA ESPINAL AL NIVEL DEL CUARTO SEGMENTO LUMBAR"
  },
  {
    "codigo":29991000175101,
    "descripcion":"ÚLCERA POR PRESIÓN EN DORSO DE PIE DERECHO, ESTADIO III"
  },
  {
    "codigo":293696004,
    "descripcion":"ALERGIA A POLDINA"
  },
  {
    "codigo":228160005,
    "descripcion":"DISCAPACIDAD DE LA FUNCIÓN MANUAL"
  },
  {
    "codigo":64320007,
    "descripcion":"CURVATURA ANORMAL DE PENE CONGÉNITA"
  },
  {
    "codigo":717845000,
    "descripcion":"TRASTORNO DEL PERISTALTISMO ESOFÁGICO"
  },
  {
    "codigo":719680009,
    "descripcion":"GOTA TOFÁCEA CRÓNICA DE DEDO DE PIE"
  },
  {
    "codigo":29717002,
    "descripcion":"LATIDOS PREMATUROS"
  },
  {
    "codigo":95253003,
    "descripcion":"CARIES DENTAL SECUNDARIA ASOCIADA CON FACTORES LOCALES O SISTÉMICOS"
  },
  {
    "codigo":291861007,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR TIROGLOBULINA"
  },
  {
    "codigo":60650002,
    "descripcion":"SÍNDROME DEL CROMOSOMA 9 EN ANILLO"
  },
  {
    "codigo":421098004,
    "descripcion":"LIPOBLASTOMA\/LIPOBLASTOMATOSIS"
  },
  {
    "codigo":224490004,
    "descripcion":"CUIDADOR REACIO A ASISTIR"
  },
  {
    "codigo":93418006,
    "descripcion":"DERMATITIS DE CONTACTO CAUSADA POR CROMO"
  },
  {
    "codigo":191722009,
    "descripcion":"AGORAFOBIA CON CRISIS DE ANGUSTIA"
  },
  {
    "codigo":124351003,
    "descripcion":"DEFICIENCIA DE POLIRRIBONUCLEÓTIDO NUCLEOTIDILTRANSFERASA"
  },
  {
    "codigo":89748001,
    "descripcion":"ÚLCERA GÁSTRICA AGUDA CON HEMORRAGIA"
  },
  {
    "codigo":188052001,
    "descripcion":"MELANOMA MALIGNO DE INGLE"
  },
  {
    "codigo":1269396003,
    "descripcion":"HIPERSENSIBILIDAD A ATENOLOL"
  },
  {
    "codigo":419263009,
    "descripcion":"ALERGIA A POLEN DE ÁRBOL"
  },
  {
    "codigo":417428006,
    "descripcion":"PRUEBA DE HEAF GRADO 3"
  },
  {
    "codigo":24212007,
    "descripcion":"FRACTURA NO EXPUESTA DE SEGUNDO HUESO CUNEIFORME DE TARSO"
  },
  {
    "codigo":284521000,
    "descripcion":"EDEMA CON FÓVEA"
  },
  {
    "codigo":253588008,
    "descripcion":"DISPLASIA DE VÁLVULA PULMONAR"
  },
  {
    "codigo":251753003,
    "descripcion":"VISIÓN BIFOVEAL"
  },
  {
    "codigo":1202025005,
    "descripcion":"MIOPATÍA CONGÉNITA AUTOSÓMICA RECESIVA POR DESPROPORCIÓN DEL TIPO DE FIBRA DEBIDA A MUTACIÓN DE SELENOPROTEÍNA N"
  },
  {
    "codigo":186217006,
    "descripcion":"ABSCESO CEREBRAL TUBERCULOSO"
  },
  {
    "codigo":282686000,
    "descripcion":"EMPUJA Y TIRA DE UN OBJETO GRANDE POR EL PISO"
  },
  {
    "codigo":415593008,
    "descripcion":"ESTRABISMO POSTERIOR A CIRUGÍA DE RETINA"
  },
  {
    "codigo":413758000,
    "descripcion":"ACCIDENTE CEREBROVASCULAR CARDIOEMBÓLICO"
  },
  {
    "codigo":315454003,
    "descripcion":"NACIDO EN JORDANIA"
  },
  {
    "codigo":55145008,
    "descripcion":"DOLOR EN PUÑALADA"
  },
  {
    "codigo":1003582005,
    "descripcion":"AGENESIA DE HUESO DEL TARSO"
  },
  {
    "codigo":249918006,
    "descripcion":"HOMBRO RÍGIDO"
  },
  {
    "codigo":708670007,
    "descripcion":"ANTEVERSIÓN DE FOSA NASAL"
  },
  {
    "codigo":248083000,
    "descripcion":"NO CONOCE EL PELIGRO DEL TRÁNSITO"
  },
  {
    "codigo":774206008,
    "descripcion":"TRASTORNO NEURODEGENERATIVO POSTVIRAL FATAL"
  },
  {
    "codigo":444691002,
    "descripcion":"NECROSIS DE CORTEZA RENAL"
  },
  {
    "codigo":41571000087101,
    "descripcion":"HERIDA PUNZANTE DE PARED POSTERIOR DE TÓRAX"
  },
  {
    "codigo":39011000087103,
    "descripcion":"LUXACIÓN DE ARTICULACIÓN PERISEMILUNAR DE MUÑECA DERECHA"
  },
  {
    "codigo":279016001,
    "descripcion":"CEFALEA CERVICÓGENA"
  },
  {
    "codigo":870675009,
    "descripcion":"REACCIÓN ADVERSA A BISMUTO Y\/O COMPUESTO DE BISMUTO"
  },
  {
    "codigo":1296659009,
    "descripcion":"EXACERBACIÓN AGUDA DE INSUFICIENCIA CARDÍACA CRÓNICA"
  },
  {
    "codigo":787037000,
    "descripcion":"DISTROFIA MUSCULAR CONGÉNITA TIPO 1A"
  },
  {
    "codigo":46691000087107,
    "descripcion":"FRACTURA DE FALANGE DISTAL DE MEÑIQUE DERECHO"
  },
  {
    "codigo":82408006,
    "descripcion":"REFLEJO ÓPTICO DE PARPADEO"
  },
  {
    "codigo":44131000087107,
    "descripcion":"CORTE EN PIEL DE BRAZO DERECHO"
  },
  {
    "codigo":705000008,
    "descripcion":"AUTOCONTROL BAJO"
  },
  {
    "codigo":16872008,
    "descripcion":"ENFERMEDAD POR DEFICIENCIA HEREDITARIA SEVERA DE FACTOR VIII"
  },
  {
    "codigo":15037002,
    "descripcion":"HORMIGUEO"
  },
  {
    "codigo":703165004,
    "descripcion":"INFARTO AGUDO DE PARED ANTERIOR DE MIOCARDIO CON ELEVACIÓN DEL SEGMENTO ST, CON COMPROMISO DE VENTRÍCULO DERECHO"
  },
  {
    "codigo":1260221006,
    "descripcion":"PIERCING EN FOSA NASAL IZQUIERDA"
  },
  {
    "codigo":338091000119108,
    "descripcion":"DEGENERACIÓN EN ENCAJE DE RETINA IZQUIERDA"
  },
  {
    "codigo":275346000,
    "descripcion":"AUSENCIA DE TIBIA"
  },
  {
    "codigo":277181009,
    "descripcion":"SOBRESALTOS DURANTE EL SUEÑO"
  },
  {
    "codigo":111506000,
    "descripcion":"DISTROFIA MUSCULAR DISTAL, TIPO MIYOSHI"
  },
  {
    "codigo":373650004,
    "descripcion":"HIPOPLASIA DE LA PAPILA ÓPTICA"
  },
  {
    "codigo":371815004,
    "descripcion":"INSUFICIENCIA MITRAL AGUDA POR DISFUNCIÓN DEL MÚSCULO PAPILAR"
  },
  {
    "codigo":699495005,
    "descripcion":"CARIES DENTAL CLASE VI"
  },
  {
    "codigo":240743004,
    "descripcion":"HISTOPLASMOSIS DISEMINADA AFRICANA"
  },
  {
    "codigo":402748000,
    "descripcion":"ERUPCIÓN PSEUDOLINFOMATOSA CAUSADA POR FÁRMACO"
  },
  {
    "codigo":75068001,
    "descripcion":"ATROFIA LAGRIMAL SECUNDARIA"
  },
  {
    "codigo":109671008,
    "descripcion":"AVULSIÓN DENTAL COMPLETA"
  },
  {
    "codigo":1156412000,
    "descripcion":"GLIOMA ANGIOCÉNTRICO DEL SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":207975009,
    "descripcion":"FRACTURA POR COMPRESIÓN DE SACRO NO EXPUESTA"
  },
  {
    "codigo":732263008,
    "descripcion":"SÍNDROME DE MELHEM FAHL"
  },
  {
    "codigo":238908006,
    "descripcion":"TRASTORNO DE LA PIEL Y DE LA MEMBRANA MUCOSA DE LA BOCA, LABIOS Y LENGUA"
  },
  {
    "codigo":271676006,
    "descripcion":"HALLAZGO RELACIONADO CON EL ASPECTO DEL ABDOMEN"
  },
  {
    "codigo":1187345002,
    "descripcion":"TUMOR DE CORDÓN GERMINAL DE OVARIO DE COMPORTAMIENTO INCIERTO"
  },
  {
    "codigo":237073004,
    "descripcion":"ANTEFLEXIÓN AGUDA DEL ÚTERO"
  },
  {
    "codigo":268006001,
    "descripcion":"TRASTORNOS MUSCULARES, LIGAMENTARIOS Y APONEURÓTICOS"
  },
  {
    "codigo":366310002,
    "descripcion":"HALLAZGO RELACIONADO CON LA PARIDAD DEL ORIFICIO CERVICAL"
  },
  {
    "codigo":300774004,
    "descripcion":"CAPAZ DE JUGAR"
  },
  {
    "codigo":200635001,
    "descripcion":"INFECCIÓN DE ESPACIO INTERDIGITAL DE LA MANO"
  },
  {
    "codigo":298939005,
    "descripcion":"ARTICULACIÓN DE CODO HELADA AL TACTO"
  },
  {
    "codigo":724923007,
    "descripcion":"LESIÓN TRAUMÁTICA DE TENDÓN DE BÍCEPS BRAQUIAL"
  },
  {
    "codigo":428176004,
    "descripcion":"AMPOLLAS EN MÚLTIPLES SITIOS"
  },
  {
    "codigo":723088005,
    "descripcion":"PERIENDOCARDITIS DEBIDA A INFECCIÓN"
  },
  {
    "codigo":11835871000119106,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN METATARSOFALÁNGICA DE DEDO GORDO DERECHO"
  },
  {
    "codigo":460944005,
    "descripcion":"ORIGEN ANÓMALO DE ARTERIA CORONARIA DERECHA EN SENO AÓRTICO DE ARTERIA CORONARIA IZQUIERDA Y ORIGEN ANÓMALO DE ARTERIA CORONARIA IZQUIERDA EN SENO AÓRTICO DE ARTERIA CORONARIA DERECHA"
  },
  {
    "codigo":229733002,
    "descripcion":"TRASTORNO DEL LENGUAJE EXPRESIVO"
  },
  {
    "codigo":16914911000119107,
    "descripcion":"HIPOCLOREMIA TRANSITORIA NEONATAL"
  },
  {
    "codigo":285151000119108,
    "descripcion":"ARTERIOSCLEROSIS DE INJERTO-PUENTE AUTÓLOGO DE ARTERIA CORONARIA"
  },
  {
    "codigo":162362000,
    "descripcion":"SÍNTOMAS DE SECRECIÓN POR EL OÍDO"
  },
  {
    "codigo":393573009,
    "descripcion":"SÍNDROME HIPEREOSINOFÍLICO"
  },
  {
    "codigo":721253009,
    "descripcion":"QUISTE EPIDURAL ESPINAL CAUSADO POR INFECCIÓN"
  },
  {
    "codigo":357009,
    "descripcion":"FRACTURA NO EXPUESTA DE HUESO TRAPEZOIDE DEL CARPO"
  },
  {
    "codigo":295269008,
    "descripcion":"SOBREDOSIS INTENCIONAL DE ÁCIDO MEFENÁMICO"
  },
  {
    "codigo":195130005,
    "descripcion":"TRASTORNO FUNCIONAL POSTCIRUGÍA CARDÍACA"
  },
  {
    "codigo":31290005,
    "descripcion":"HIDROURÉTER CONGÉNITO"
  },
  {
    "codigo":293434007,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR FLUVASTATINA"
  },
  {
    "codigo":1145402008,
    "descripcion":"MACROCEFALIA CONGÉNITA"
  },
  {
    "codigo":1340175001,
    "descripcion":"SÍNDROME SIMILAR A PRADER-WILLI ASOCIADO A CARBOXIPEPTIDASA E"
  },
  {
    "codigo":94991002,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE HUESO ILÍACO"
  },
  {
    "codigo":15741561000119104,
    "descripcion":"MANO EN GARRA ADQUIRIDA BILATERAL"
  },
  {
    "codigo":291599005,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR CEFTAZIDIMA"
  },
  {
    "codigo":224228000,
    "descripcion":"VIVIR SIN COMODIDADES"
  },
  {
    "codigo":1010660001,
    "descripcion":"HEMANGIOMA SUBGLÓTICO INFANTIL"
  },
  {
    "codigo":93156002,
    "descripcion":"LIPOMA DE GLÚTEO"
  },
  {
    "codigo":715748006,
    "descripcion":"ATAXIA ESPINOCEREBELOSA TIPO 1"
  },
  {
    "codigo":289764007,
    "descripcion":"CUELLO UTERINO, NO DILATADO"
  },
  {
    "codigo":27620007,
    "descripcion":"DERMATITIS PSORIASIFORME ESPONGIÓTICA"
  },
  {
    "codigo":124089001,
    "descripcion":"ÁCIDO ADENÍLICO POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":23950002,
    "descripcion":"POLIARTRITIS INFECCIOSA AGUDA"
  },
  {
    "codigo":417166003,
    "descripcion":"HALLAZGO RELACIONADO CON UNA ESTRUCTURA ILÍACA"
  },
  {
    "codigo":56718006,
    "descripcion":"DIETA PARA HIPERLIPOPROTEINEMIA"
  },
  {
    "codigo":710243000,
    "descripcion":"ÁNGULO DE PLANO MANDIBULAR APLANADO"
  },
  {
    "codigo":54883000,
    "descripcion":"SÍNDROME DEL ASA CIEGA POSTOPERATORIA"
  },
  {
    "codigo":251491002,
    "descripcion":"ESPIGAS ROLÁNDICAS FOCALES"
  },
  {
    "codigo":253326008,
    "descripcion":"ATRESIA DE ORIFICIO DE SENO CORONARIO"
  },
  {
    "codigo":185955000,
    "descripcion":"EN LISTA DE NECESIDAD DE VIVIENDA URGENTE"
  },
  {
    "codigo":413496000,
    "descripcion":"SOCIEDAD ESTADOUNIDENSE DE ANESTESISTAS - ESTADO FÍSICO CLASE 2"
  },
  {
    "codigo":448099009,
    "descripcion":"ANEURISMA DE SENO DE VALSALVA AÓRTICO CON PROTRUSIÓN EN AURÍCULA DERECHA"
  },
  {
    "codigo":249656005,
    "descripcion":"VASOS ANORRECTALES - HALLAZGO"
  },
  {
    "codigo":446264007,
    "descripcion":"HERIDA ABIERTA DE MÚSCULO DE ANTEBRAZO"
  },
  {
    "codigo":1263629002,
    "descripcion":"TRASTORNO FETAL DEBIDO A POSICIÓN TRANSVERSA ANTES DE TRABAJO DE PARTO"
  },
  {
    "codigo":870413003,
    "descripcion":"REACCIÓN ADVERSA A VITAMINA K Y\/O DERIVADO DE VITAMINA K"
  },
  {
    "codigo":2491000124107,
    "descripcion":"PRIMER MOLAR INFERIOR DERECHO PERMANENTE SUPERNUMERARIO"
  },
  {
    "codigo":772109006,
    "descripcion":"POSIBLE METABOLIZADOR INTERMEDIO DE NUDT15"
  },
  {
    "codigo":313357008,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS DE BRONQUIO, EN EL LÓBULO SUPERIOR DERECHO"
  },
  {
    "codigo":1163490004,
    "descripcion":"ABSCESO DE ESPACIO EPIDURAL ESPINAL CAUSADO POR ORGANISMO DEL REINO FUNGI"
  },
  {
    "codigo":82146006,
    "descripcion":"ESTAFILOMA ECUATORIAL"
  },
  {
    "codigo":735671008,
    "descripcion":"FRACTURA DE CÓNDILO EXTERNO DE TIBIA"
  },
  {
    "codigo":209548004,
    "descripcion":"ESGUINCE DE LIGAMENTO DE ARTICULACIÓN LUMBOSACRA"
  },
  {
    "codigo":406156006,
    "descripcion":"CON EMPLEO REMUNERADO"
  },
  {
    "codigo":1290892007,
    "descripcion":"SÍNDROME DE MANCHAS ANÉMICAS DE BIER, CIANOSIS Y ERUPCIÓN DE TIPO URTICARIA"
  },
  {
    "codigo":109409003,
    "descripcion":"CRANEOSINOSTOSIS INTERFRONTAL"
  },
  {
    "codigo":76641005,
    "descripcion":"PROLAPSO DE INTESTINO"
  },
  {
    "codigo":240481008,
    "descripcion":"HERPES SIMPLE CRÓNICO"
  },
  {
    "codigo":238646001,
    "descripcion":"LIQUEN PLANO MICROPAPULAR"
  },
  {
    "codigo":369718005,
    "descripcion":"G3: ESCASAMENTE DIFERENCIADO (5-49 POR CIENTO DE FORMACIÓN GLANDULAR)"
  },
  {
    "codigo":402486005,
    "descripcion":"SÍNDROME DE DEPLECIÓN DE CINC"
  },
  {
    "codigo":204043002,
    "descripcion":"HIPOPLASIA DEL CUERPO CALLOSO"
  },
  {
    "codigo":236811002,
    "descripcion":"INSUFICIENCIA TESTICULAR ADQUIRIDA"
  },
  {
    "codigo":171275002,
    "descripcion":"CONVOCATORIA PARA VACUNACIÓN - NO ALCANZADA"
  },
  {
    "codigo":269579005,
    "descripcion":"MELANOMA MALIGNO DEL TRONCO"
  },
  {
    "codigo":234976000,
    "descripcion":"CARIES DENTAL AGRESIVA MÚLTIPLE"
  },
  {
    "codigo":15989831000119105,
    "descripcion":"COROIDEREMIA DE AMBOS OJOS"
  },
  {
    "codigo":366048001,
    "descripcion":"APERTURA DE PUNTO LAGRIMAL INFERIOR - HALLAZGO"
  },
  {
    "codigo":38368003,
    "descripcion":"TRASTORNO ESQUIZOAFECTIVO, TIPO BIPOLAR"
  },
  {
    "codigo":300512005,
    "descripcion":"HALLAZGO RELACIONADO CON EL ASPECTO DEL PENE"
  },
  {
    "codigo":316641000119100,
    "descripcion":"OSTEOFITO DE CODO DERECHO"
  },
  {
    "codigo":167605001,
    "descripcion":"COLOR DE MATERIA FECAL NORMAL"
  },
  {
    "codigo":298677001,
    "descripcion":"CREPITACIÓN AUDIBLE DE LA COLUMNA LUMBAR"
  },
  {
    "codigo":10966241000119101,
    "descripcion":"HERIDA PUNZANTE DE MUSLO DERECHO"
  },
  {
    "codigo":69301007,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA AXILA"
  },
  {
    "codigo":724661008,
    "descripcion":"ABSTINENCIA DE ANSIOLÍTICO"
  },
  {
    "codigo":396981007,
    "descripcion":"TUMOR QUE INVADE NERVIO ÓPTICO A NIVEL DE LUGAR DE SECCIÓN"
  },
  {
    "codigo":1279882001,
    "descripcion":"RHABDOMIOSARCOMA EMBRIONARIO METASTÁSICO"
  },
  {
    "codigo":295007000,
    "descripcion":"ALERGIA A ANTAGONISTA DE RECEPTOR DE ALDOSTERONA"
  },
  {
    "codigo":427914009,
    "descripcion":"LESIÓN TRAUMÁTICA DE HUESO DEL METACARPO"
  },
  {
    "codigo":296842009,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE PREDNISONA"
  },
  {
    "codigo":131167008,
    "descripcion":"GRUPO SANGUÍNEO O>HM<"
  },
  {
    "codigo":194868001,
    "descripcion":"TROMBOSIS AURICULAR, VENTRICULAR Y DE APÉNDICE AURICULAR COMO COMPLICACIÓN ACTUAL LUEGO DE INFARTO AGUDO DE MIOCARDIO"
  },
  {
    "codigo":719156006,
    "descripcion":"SÍNDROME DE DISCAPACIDAD INTELECTUAL LIGADA AL CROMOSOMA X CON HIPOGAMMAGLOBULINEMIA Y DETERIORO NEUROLÓGICO PROGRESIVO"
  },
  {
    "codigo":293172008,
    "descripcion":"REACCIÓN ADVERSA A LAS GOTAS DE PREDNISOLONA"
  },
  {
    "codigo":1208841001,
    "descripcion":"ENFERMEDAD DE MOYAMOYA SECUNDARIA"
  },
  {
    "codigo":61961002,
    "descripcion":"TRASTORNO DEL METABOLISMO DE LA BETA ALANINA, CARNOSINA Y\/O HOMOCARNOSINA"
  },
  {
    "codigo":94729000,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA CORTEZA SUPRARRENAL"
  },
  {
    "codigo":11785441000119107,
    "descripcion":"ABRASIÓN DE PIEL DE DEDO MEÑIQUE DERECHO"
  },
  {
    "codigo":225801005,
    "descripcion":"DOMINADO POR OTROS"
  },
  {
    "codigo":27358001,
    "descripcion":"SÍNDROME DEL ACUEDUCTO DE SILVIO"
  },
  {
    "codigo":125662003,
    "descripcion":"HERIDA ABIERTA DE TOBILLO"
  },
  {
    "codigo":92894005,
    "descripcion":"FORMA ANORMAL CONGÉNITA DE LOS HUESECILLOS DEL OÍDO"
  },
  {
    "codigo":289502006,
    "descripcion":"CLÍTORIS AUSENTE"
  },
  {
    "codigo":1172403000,
    "descripcion":"HORMONAS SEXUALES FEMENINAS SÉRICAS POR DEBAJO DE RANGO DE REFERENCIA"
  },
  {
    "codigo":1073661000119100,
    "descripcion":"NÓDULO REUMATOIDEO DE TEJIDO CELULAR SUBCUTÁNEO DE PIE DERECHO"
  },
  {
    "codigo":1086461000119101,
    "descripcion":"HEMORRAGIA DE INTESTINO DELGADO DEBIDA A DIVERTICULITIS"
  },
  {
    "codigo":303101000119102,
    "descripcion":"BURSITIS DE MANO IZQUIERDA"
  },
  {
    "codigo":15960061000119102,
    "descripcion":"ANGINA INESTABLE CONCOMITANTE CON ARTERIOESCLEROSIS CORONARIA Y DEBIDA A ELLA"
  },
  {
    "codigo":338941000119104,
    "descripcion":"ENDOFTALMITIS DE OJO IZQUIERDO CAUSADA POR PARÁSITO"
  },
  {
    "codigo":254899009,
    "descripcion":"MUERMO CUTÁNEO"
  },
  {
    "codigo":10852861000119104,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO DIGITAL DE DEDO ANULAR IZQUIERDO"
  },
  {
    "codigo":328701000119101,
    "descripcion":"COMPLICACIÓN DE PROCEDIMIENTO DE COLOCACIÓN DE BANDA GÁSTRICA"
  },
  {
    "codigo":1091581000119103,
    "descripcion":"QUERATOSIS OBTURATRIZ DE CONDUCTO AUDITIVO EXTERNO DERECHO"
  },
  {
    "codigo":11797501000119104,
    "descripcion":"AMPOLLA SACRA, CON INFECCIÓN"
  },
  {
    "codigo":1021000119106,
    "descripcion":"CATÉTER VENOSO CENTRAL INSERTADO PERIFÉRICAMENTE IN SITU"
  },
  {
    "codigo":292861000119106,
    "descripcion":"HEMIPARESIA ATÁXICA LACUNAR DE LADO IZQUIERDO DOMINANTE"
  },
  {
    "codigo":118781000119108,
    "descripcion":"ENFERMEDAD RENAL CRÓNICA HIPERTENSIVA MATERNA PREEXISTENTE QUE COMPLICA EL EMBARAZO"
  },
  {
    "codigo":1089021000119108,
    "descripcion":"OTITIS EXTERNA MALIGNA DE CONDUCTO AUDITIVO EXTERNO IZQUIERDO"
  },
  {
    "codigo":1268872008,
    "descripcion":"HEMATOMA TRAUMÁTICO DE VAGINA"
  },
  {
    "codigo":323581000119108,
    "descripcion":"TUMOR TENOSINOVIAL DE CÉLULAS GIGANTES DIFUSO DE ARTICULACIÓN DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":15970301000119109,
    "descripcion":"HEMORROIDE INTERNA SANGRANTE GRADO II"
  },
  {
    "codigo":251229005,
    "descripcion":"ALTURA DE LA ONDA R DISMINUIDA"
  },
  {
    "codigo":336381000119109,
    "descripcion":"AFAQUIA DE OJO DERECHO"
  },
  {
    "codigo":283997008,
    "descripcion":"RECUERDOS FALSOS"
  },
  {
    "codigo":249394002,
    "descripcion":"HALLAZGO RELACIONADO CON EL TAMAÑO DE LAS AMÍGDALAS"
  },
  {
    "codigo":413234003,
    "descripcion":"BANDA GÁSTRICA LIBRE"
  },
  {
    "codigo":282162003,
    "descripcion":"INCAPAZ DE CAMINAR PENDIENTE ABAJO"
  },
  {
    "codigo":20018005,
    "descripcion":"OBSTRUCCIÓN URETERAL"
  },
  {
    "codigo":11814421000119103,
    "descripcion":"RUPTURA TRAUMÁTICA DE LIGAMENTO COLATERAL DE ARTICULACIÓN DE DEDO ÍNDICE IZQUIERDO"
  },
  {
    "codigo":247559003,
    "descripcion":"PELO QUEBRADIZO"
  },
  {
    "codigo":737244000,
    "descripcion":"CONTUSIÓN CUTÁNEA DEBIDA A FRAGILIDAD VASCULAR"
  },
  {
    "codigo":81884004,
    "descripcion":"LESIÓN TRAUMÁTICA DEL NERVIO TIBIAL"
  },
  {
    "codigo":409564005,
    "descripcion":"BOTULISMO TRANSMITIDO POR LOS ALIMENTOS, TIPO A"
  },
  {
    "codigo":1259697004,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE DIVERTÍCULO DE MECKEL"
  },
  {
    "codigo":473265005,
    "descripcion":"QUEMADURA EPIDÉRMICA DE MÚLTIPLES SITIOS DE LA MANO"
  },
  {
    "codigo":276657008,
    "descripcion":"SÍNDROME DE SUPERPOSICIÓN"
  },
  {
    "codigo":73391000119102,
    "descripcion":"QUISTE DE TERCERA HENDIDURA BRANQUIAL"
  },
  {
    "codigo":373126002,
    "descripcion":"CÁMARA CARDÍACA LEVEMENTE AGRANDADA"
  },
  {
    "codigo":110982003,
    "descripcion":"ANETODERMIA DE JADASSOHN - PELLIZZARI"
  },
  {
    "codigo":405894002,
    "descripcion":"FENOTIPO K-"
  },
  {
    "codigo":319151000119103,
    "descripcion":"ARTRITIS REUMATOIDEA SERONEGATIVA DE ARTICULACIÓN DE REGIÓN DE MUÑECA DERECHA"
  },
  {
    "codigo":345621000119109,
    "descripcion":"ASTIGMATISMO IRREGULAR DE AMBOS OJOS"
  },
  {
    "codigo":404059000,
    "descripcion":"LIPOMA PLEOMÓRFICO"
  },
  {
    "codigo":209286009,
    "descripcion":"FRACTURA-SUBLUXACIÓN NO EXPUESTA DE ARTICULACIÓN MEDIOCARPIANA"
  },
  {
    "codigo":371291002,
    "descripcion":"SIGNO DEL TÉMPANO EN LA RODILLA"
  },
  {
    "codigo":305755005,
    "descripcion":"ATENDIDO POR ENFERMERA ESCOLAR"
  },
  {
    "codigo":698971006,
    "descripcion":"DIVERTÍCULO SUBAÓRTICO CONGÉNITO"
  },
  {
    "codigo":762672001,
    "descripcion":"ABSTINENCIA DE CATINONA SINTÉTICA"
  },
  {
    "codigo":205616004,
    "descripcion":"TRISOMÍA 21 - MOSAICISMO CON FALTA DE DISYUNCIÓN MITÓTICA"
  },
  {
    "codigo":16840521000119100,
    "descripcion":"OBSTRUCCIÓN PARCIAL DE INTESTINO POSTERIOR A PROCEDIMIENTO"
  },
  {
    "codigo":1186821000,
    "descripcion":"TRASTORNO DEL DESARROLLO ACADÉMICO DEBIDO A DEFICIENCIA DE MICRONUTRIENTES"
  },
  {
    "codigo":302085001,
    "descripcion":"HALLAZGO RELACIONADO CON LA HUMEDAD DEL MUÑÓN UMBILICAL"
  },
  {
    "codigo":402224008,
    "descripcion":"ECCEMA DE PULPEJO DE DEDO DE LA MANO"
  },
  {
    "codigo":1285125003,
    "descripcion":"ERROR DE IDENTIFICACIÓN DE PACIENTE"
  },
  {
    "codigo":292681000119101,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DEBIDO A OCLUSIÓN DE ARTERIA VERTEBRAL DERECHA"
  },
  {
    "codigo":105477005,
    "descripcion":"EXÁMENES DESAPROBADOS"
  },
  {
    "codigo":236549005,
    "descripcion":"OSTEODISTROFIA FRACTURANTE RELACIONADA CON EL ALUMINIO"
  },
  {
    "codigo":860976009,
    "descripcion":"TRANSMISIÓN DE LUZ VISIBLE A TRAVÉS DE TUMEFACCIÓN DE ESCROTO"
  },
  {
    "codigo":15693641000119102,
    "descripcion":"QUERATITIS DE AMBOS OJOS CAUSADA POR BACTERIA"
  },
  {
    "codigo":300250003,
    "descripcion":"HALLAZGO RELACIONADO CON EL ASPECTO DE LAS ENCÍAS"
  },
  {
    "codigo":38106008,
    "descripcion":"ENFERMEDAD DE CROHN DEL ÍLEON"
  },
  {
    "codigo":201946009,
    "descripcion":"ARTROPATÍA TRAUMÁTICA DE LA MUÑECA"
  },
  {
    "codigo":365786009,
    "descripcion":"NIVEL DE BILIRRUBINA - HALLAZGO"
  },
  {
    "codigo":398554008,
    "descripcion":"TULAREMIA TIFOIDEA"
  },
  {
    "codigo":429487005,
    "descripcion":"DEPENDENCIA DE VENTILACIÓN CON PRESIÓN POSITIVA CONTINUA EN LA VÍA AÉREA"
  },
  {
    "codigo":167343009,
    "descripcion":"MICROSCOPIA DE ORINA: CRISTALES DE ÁCIDO ÚRICO"
  },
  {
    "codigo":296580002,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE PIPERACINA"
  },
  {
    "codigo":34436003,
    "descripcion":"HEMATURIA"
  },
  {
    "codigo":1345156008,
    "descripcion":"PATRÓN DE USO NOCIVO DE TABACO"
  },
  {
    "codigo":294745001,
    "descripcion":"ALERGIA A PROGESTÁGENO"
  },
  {
    "codigo":261977004,
    "descripcion":"FLEXIÓN DEL CUELLO"
  },
  {
    "codigo":229209009,
    "descripcion":"CAMBIO EN LA CONSISTENCIA DE LA MATERIA FECAL"
  },
  {
    "codigo":161838002,
    "descripcion":"LACTANTE CON PROBLEMA ALIMENTARIO"
  },
  {
    "codigo":292910004,
    "descripcion":"REACCIÓN ADVERSA A LOS ANTIHELMÍNTICOS"
  },
  {
    "codigo":1144878006,
    "descripcion":"HIPOPLASIA CONGÉNITA DE CARTÍLAGO AURICULAR"
  },
  {
    "codigo":127235000,
    "descripcion":"NEOPLASIA DE LOS GANGLIOS LINFÁTICOS DEL CUELLO"
  },
  {
    "codigo":94467003,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA GLÁNDULA PARATIROIDES"
  },
  {
    "codigo":28931004,
    "descripcion":"RUPTURA DE ARTERIA CORONARIA"
  },
  {
    "codigo":782595006,
    "descripcion":"ALERGIA A TIOURACILO"
  },
  {
    "codigo":289240005,
    "descripcion":"DURACIÓN PROLONGADA DEL TRABAJO DE PARTO"
  },
  {
    "codigo":92632008,
    "descripcion":"CARCINOMA IN SITU DE LA COMISURA DE LA LARINGE"
  },
  {
    "codigo":90797000,
    "descripcion":"EDAD GESTACIONAL, 28 SEMANAS"
  },
  {
    "codigo":254637007,
    "descripcion":"CÁNCER PULMONAR DE CÉLULAS NO MICROCÍTICAS"
  },
  {
    "codigo":56194001,
    "descripcion":"TRASTORNO DEL SUEÑO INDUCIDO POR CAFEÍNA"
  },
  {
    "codigo":1137538002,
    "descripcion":"CALCIFICACIÓN PUNTEADA DE EPÍFISIS DE PRIMER HUESO METACARPIANO"
  },
  {
    "codigo":88962006,
    "descripcion":"CLARIDAD MENTAL INCOMPLETA"
  },
  {
    "codigo":449410007,
    "descripcion":"ADENOMA TUBULOVELLOSO DE UNIÓN ANORRECTAL"
  },
  {
    "codigo":54359000,
    "descripcion":"OPACIDAD CORNEAL CONGÉNITA QUE NO INTERFIERE CON LA VISIÓN"
  },
  {
    "codigo":447575003,
    "descripcion":"LESIÓN TRAUMÁTICA COMPLETA DE MÉDULA ESPINAL A NIVEL DE D1 A D6"
  },
  {
    "codigo":1332311004,
    "descripcion":"OSTEOPATÍA DE FÉMUR POSTERIOR A POLIOMIELITIS"
  },
  {
    "codigo":21591004,
    "descripcion":"EROSIÓN ARTERIAL"
  },
  {
    "codigo":283735006,
    "descripcion":"MORDEDURA DE PERRO EN LA CABEZA Y EL CUELLO"
  },
  {
    "codigo":321661000119104,
    "descripcion":"ARTRITIS DE CODO IZQUIERDO CAUSADA POR STAPHYLOCOCCUS"
  },
  {
    "codigo":773420005,
    "descripcion":"ALERGIA A BAMETÁN"
  },
  {
    "codigo":1363244006,
    "descripcion":"QUISTES CONGÉNITOS MÚLTIPLES DE CEREBRO"
  },
  {
    "codigo":281900007,
    "descripcion":"NO SE DETECTARON ANOMALÍAS"
  },
  {
    "codigo":116225000,
    "descripcion":"COMPLICACIÓN DE LESIÓN TRAUMÁTICA"
  },
  {
    "codigo":609580007,
    "descripcion":"DIABETES MELLITUS TRANSITORIA NEONATAL DE TIPO 2"
  },
  {
    "codigo":249132007,
    "descripcion":"CAMBIO EN CANTIDAD DE LÍQUIDO AMNIÓTICO"
  },
  {
    "codigo":314668006,
    "descripcion":"FRACTURA EN CUÑA DE VÉRTEBRA"
  },
  {
    "codigo":83457000,
    "descripcion":"BRONQUIECTASIA CILÍNDRICA"
  },
  {
    "codigo":443905007,
    "descripcion":"LUXACIÓN CONGÉNITA DE TOBILLO Y\/O PIE"
  },
  {
    "codigo":987840791000119102,
    "descripcion":"DEFICIENCIA DE DESAMINASA DE ADENOSINA 2"
  },
  {
    "codigo":1162966002,
    "descripcion":"HEMATOMA INTRACRANEAL EPIDURAL ESPONTÁNEO"
  },
  {
    "codigo":212694004,
    "descripcion":"INTOXICACIÓN POR BLOQUEANTE GANGLIONAR"
  },
  {
    "codigo":835286006,
    "descripcion":"AGUDEZA VISUAL DE OJO DERECHO 6\/5"
  },
  {
    "codigo":704214007,
    "descripcion":"FRACTURA EXPUESTA DE BASE DE TERCER METACARPIANO"
  },
  {
    "codigo":210859000,
    "descripcion":"LESIÓN DE MÚLTIPLES VASOS SANGUÍNEOS DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":1259435004,
    "descripcion":"CARCINOMA PRIMARIO DE LENGUA"
  },
  {
    "codigo":702379005,
    "descripcion":"HIPOMIELINIZACIÓN Y CATARATA CONGÉNITA"
  },
  {
    "codigo":473003006,
    "descripcion":"TONO DE VOZ VIRILIZADO"
  },
  {
    "codigo":79787007,
    "descripcion":"TRASTORNO DEL TRACTO GASTROINTESTINAL INFERIOR"
  },
  {
    "codigo":276395008,
    "descripcion":"CAPAZ DE SACAR LA LENGUA"
  },
  {
    "codigo":209024000,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA EXPUESTA DE PIE"
  },
  {
    "codigo":733312003,
    "descripcion":"QUERATITIS CAUSADA POR INFECCIÓN"
  },
  {
    "codigo":241792004,
    "descripcion":"EFECTO TÓXICO CAUSADO POR HERBICIDA CON UREA"
  },
  {
    "codigo":405632004,
    "descripcion":"INFECCIÓN ESTREPTOCÓCICA INFANTIL"
  },
  {
    "codigo":371029002,
    "descripcion":"TRASTORNO ISQUÉMICO DE MÉDULA ESPINAL"
  },
  {
    "codigo":698709003,
    "descripcion":"HEMORRAGIA PREPARTO DEBIDA A PLACENTA PREVIA, TIPO II"
  },
  {
    "codigo":16023831000119107,
    "descripcion":"OCLUSIÓN DE ARTERIA COROIDEA ANTERIOR DERECHA"
  },
  {
    "codigo":678321000119101,
    "descripcion":"SINEQUIAS ANTERIORES DE IRIS DE OJO IZQUIERDO"
  },
  {
    "codigo":895317006,
    "descripcion":"FORMA DE BALA ANORMAL CONGÉNITA DE FALANGE DISTAL DE DEDO MEDIO"
  },
  {
    "codigo":305493004,
    "descripcion":"BAJO ATENCIÓN DE NEFRÓLOGO"
  },
  {
    "codigo":1087921000119102,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE OREJA IZQUIERDA"
  },
  {
    "codigo":270890001,
    "descripcion":"DELECIÓN DEL BRAZO CORTO DEL CROMOSOMA 18"
  },
  {
    "codigo":41514002,
    "descripcion":"ESTENOSIS MITRAL SUPRAVALVULAR CONGÉNITA"
  },
  {
    "codigo":238122007,
    "descripcion":"DEFICIENCIA DE MOLIBDENO"
  },
  {
    "codigo":205354008,
    "descripcion":"DEDO GORDO TRIFALÁNGICO"
  },
  {
    "codigo":400127001,
    "descripcion":"GRANULOMA SARCOIDAL DE PIEL"
  },
  {
    "codigo":762410008,
    "descripcion":"PALADAR HENDIDO CON FISURA DE LABIO DE LADO DERECHO"
  },
  {
    "codigo":1284863004,
    "descripcion":"ARTERIOESCLEROSIS DE AORTA"
  },
  {
    "codigo":39679005,
    "descripcion":"INTOXICACIÓN POR CUMAFURILO"
  },
  {
    "codigo":301823007,
    "descripcion":"ARDOR DE OÍDO"
  },
  {
    "codigo":234452003,
    "descripcion":"DEFICIENCIA DE FACTOR DE CONTACTO"
  },
  {
    "codigo":15669681000119106,
    "descripcion":"BRAQUIDACTILIA DE DEDO DE AMBAS MANOS"
  },
  {
    "codigo":365524007,
    "descripcion":"APTITUD PARA TRABAJAR - HALLAZGO"
  },
  {
    "codigo":168916008,
    "descripcion":"ARTROGRAFÍA ANORMAL"
  },
  {
    "codigo":70612009,
    "descripcion":"HIPERTERMIA EN EL RECIÉN NACIDO"
  },
  {
    "codigo":724137002,
    "descripcion":"SÍNDROME DE MACROCEFALIA, OBESIDAD, DISCAPACIDAD MENTAL Y ANOMALÍAS OCULARES"
  },
  {
    "codigo":68777001,
    "descripcion":"GRADO DE AFECTACIÓN DE AMBOS OJOS"
  },
  {
    "codigo":298153006,
    "descripcion":"DERRAME DE ARTICULACIÓN DEL PULGAR"
  },
  {
    "codigo":198014000,
    "descripcion":"AZOOSPERMIA OBSTRUCTIVA ADQUIRIDA"
  },
  {
    "codigo":1344894001,
    "descripcion":"TRASTORNO DE PARTES BLANDAS DE PELVIS"
  },
  {
    "codigo":230782004,
    "descripcion":"SÍNDROME DE DESEQUILIBRIO"
  },
  {
    "codigo":1017214008,
    "descripcion":"VIREMIA POR SARS-COV-2"
  },
  {
    "codigo":722302009,
    "descripcion":"ENFERMEDAD POR ALMACENAMIENTO DE GLUCÓGENO DEBIDA A DEFICIENCIA DE MALTASA DE COMIENZO INFANTIL"
  },
  {
    "codigo":720467005,
    "descripcion":"SÍNDROME DE ANIRIDIA Y RÓTULA AUSENTE"
  },
  {
    "codigo":32339005,
    "descripcion":"DEFICIENCIA LONGITUDINAL DE HUESO METACARPIANO"
  },
  {
    "codigo":390952000,
    "descripcion":"ALERGIA A POLVO"
  },
  {
    "codigo":718632004,
    "descripcion":"ICTIOSIS LAMINAR AUTOCICATRIZANTE"
  },
  {
    "codigo":292648007,
    "descripcion":"REACCIÓN ADVERSA AL ENBUCRILATO"
  },
  {
    "codigo":782333002,
    "descripcion":"INTOLERANCIA A LA LACTOSA POR DEFICIENCIA DE LACTASA ADQUIRIDA"
  },
  {
    "codigo":78411000119107,
    "descripcion":"SARCOMA DE EWING DE HUESO DE LA PELVIS"
  },
  {
    "codigo":126973004,
    "descripcion":"NEOPLASIA DEL NERVIO FACIAL"
  },
  {
    "codigo":94205006,
    "descripcion":"NEOPLASIA MALIGNA SECUNDARIA DE VASO SANGUÍNEO DE HOMBRO"
  },
  {
    "codigo":28669007,
    "descripcion":"ANHEDONIA"
  },
  {
    "codigo":92370004,
    "descripcion":"NEOPLASIA BENIGNA DE LA PIEL DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":288978006,
    "descripcion":"SUCCIONA"
  },
  {
    "codigo":59602008,
    "descripcion":"SENSACIÓN DE IMPOTENCIA, SEVERA"
  },
  {
    "codigo":11848421000119104,
    "descripcion":"HERIDA DE PÁRPADO IZQUIERDO DEBIDA A PICADURA DE INSECTO NO VENENOSO"
  },
  {
    "codigo":1237415004,
    "descripcion":"METÁSTASIS DE CISTOADENOCARCINOMA EN OVARIO"
  },
  {
    "codigo":90535007,
    "descripcion":"PROLAPSO DUODENAL"
  },
  {
    "codigo":285308002,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS DE LA PIEL DE LABIO INFERIOR"
  },
  {
    "codigo":711292003,
    "descripcion":"DISMINUCIÓN DE LA LONGITUD DEL MENTÓN A LAS FAUCES"
  },
  {
    "codigo":680831000119100,
    "descripcion":"NEVO DE IRIS DERECHO"
  },
  {
    "codigo":1268348008,
    "descripcion":"CARCINOMA MICROCÍTICO PRIMARIO DE PULMÓN"
  },
  {
    "codigo":88700009,
    "descripcion":"ÚLCERA MICÓTICA DEL ESÓFAGO"
  },
  {
    "codigo":709457002,
    "descripcion":"UTILIZA ANTICONCEPCIÓN CON PROGESTÁGENO DE DEPÓSITO SOLAMENTE"
  },
  {
    "codigo":54097007,
    "descripcion":"TRASTORNO LEUCOCÍTICO"
  },
  {
    "codigo":414545008,
    "descripcion":"CARDIOPATÍA ISQUÉMICA"
  },
  {
    "codigo":283473009,
    "descripcion":"HERIDA PUNZANTE EN EL TÓRAX"
  },
  {
    "codigo":248870002,
    "descripcion":"HALLAZGO RELACIONADO CON LA VAGINA"
  },
  {
    "codigo":445478004,
    "descripcion":"ARTROSIS DE PELVIS"
  },
  {
    "codigo":85030005,
    "descripcion":"CORTE Y EMPALME DE ÁCIDO RIBONUCLEICO"
  },
  {
    "codigo":1197307000,
    "descripcion":"CARCINOMA NEUROENDOCRINO PRIMARIO DE VESÍCULA BILIAR"
  },
  {
    "codigo":50427001,
    "descripcion":"RELLENO CAPILAR AUMENTADO"
  },
  {
    "codigo":1230075001,
    "descripcion":"PATRÓN DE USO EPISÓDICO NOCIVO SIN DEPENDENCIA DE ANSIOLÍTICO"
  },
  {
    "codigo":247035001,
    "descripcion":"RETROFLEXIÓN DEL IRIS"
  },
  {
    "codigo":443643007,
    "descripcion":"EPENDIMOMA"
  },
  {
    "codigo":115963009,
    "descripcion":"ANEMIA REGENERATIVA"
  },
  {
    "codigo":1090431000119106,
    "descripcion":"DERMATITIS VESICULAR RECIDIVANTE POR VIRUS DEL HERPES SIMPLE"
  },
  {
    "codigo":308901000,
    "descripcion":"ÚLCERA DE MALÉOLO EXTERNO"
  },
  {
    "codigo":703952009,
    "descripcion":"CONJUNTIVITIS ALÉRGICA CAUSADA POR DERMATOPHAGOIDES PTERONYSSINUS"
  },
  {
    "codigo":79525004,
    "descripcion":"CONDUCCIÓN CARDÍACA NORMAL"
  },
  {
    "codigo":44922000,
    "descripcion":"PULSO DE CORRIGAN"
  },
  {
    "codigo":1290106001,
    "descripcion":"TENDINOSIS DE MUÑECA"
  },
  {
    "codigo":1259173009,
    "descripcion":"DETENCIÓN DE CRECIMIENTO DE RAÍZ DENTAL DEBIDA A TRAUMATISMO DENTAL Y POSTERIOR A ÉL"
  },
  {
    "codigo":77690003,
    "descripcion":"ENFISEMA PULMONAR INTERSTICIAL"
  },
  {
    "codigo":733050004,
    "descripcion":"SÍNDROME DE DISMORFISMO, BAJA ESTATURA, SORDERA Y TRASTORNO DEL DESARROLLO SEXUAL"
  },
  {
    "codigo":210597009,
    "descripcion":"LESIÓN POR DESOLLAMIENTO DE DEDO DE LA MANO"
  },
  {
    "codigo":1255503005,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO DE PULGAR IZQUIERDO"
  },
  {
    "codigo":403535008,
    "descripcion":"ALOPECIA TRIANGULAR"
  },
  {
    "codigo":15727641000119105,
    "descripcion":"ARTROFITO EN ARTICULACIÓN DE AMBAS REGIONES DE HOMBROS"
  },
  {
    "codigo":74020002,
    "descripcion":"PENETRACIÓN PERCUTÁNEA AUMENTADA"
  },
  {
    "codigo":205092004,
    "descripcion":"PIE EN GARRA CONGÉNITO"
  },
  {
    "codigo":237860004,
    "descripcion":"ALCALOSIS RESPIRATORIA Y ACIDOSIS METABÓLICA"
  },
  {
    "codigo":11769011000119100,
    "descripcion":"RUPTURA TRAUMÁTICA DE TENDÓN DE ANTEBRAZO IZQUIERDO"
  },
  {
    "codigo":301561001,
    "descripcion":"DIFICULTAD PARA MOVILIZARSE APOYÁNDOSE EN LOS MUEBLES"
  },
  {
    "codigo":203257002,
    "descripcion":"PERIOSTITIS DE COLUMNA VERTEBRAL DORSAL SIN OSTEOMIELITIS"
  },
  {
    "codigo":236025002,
    "descripcion":"HERNIA INGUINAL DE RICHTER"
  },
  {
    "codigo":170489004,
    "descripcion":"PORTADOR DE HEPATITIS VIRAL"
  },
  {
    "codigo":399865004,
    "descripcion":"RETINOPATÍA PROLIFERATIVA MUY SEVERA DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":1153529007,
    "descripcion":"INTOXICACIÓN ACCIDENTAL CAUSADA POR SUSTANCIA CON ESTRUCTURA DE ÉTER"
  },
  {
    "codigo":266958000,
    "descripcion":"PROBLEMAS MÉDICOS EN EL TRABAJO"
  },
  {
    "codigo":234190001,
    "descripcion":"TRASTORNO EN EL INJERTO VASCULAR"
  },
  {
    "codigo":1217230002,
    "descripcion":"ATAXIA CEREBELOSA CON APRAXIA OCULOMOTORA TIPO 4"
  },
  {
    "codigo":1348302005,
    "descripcion":"HIPERPLASIA DIFUSA IDIOPÁTICA DE CÉLULAS NEUROENDOCRINAS DE PULMÓN"
  },
  {
    "codigo":365262006,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA LLEVAR COMIDA PREPARADA"
  },
  {
    "codigo":70350007,
    "descripcion":"MIELOPATÍA DEGENERATIVA"
  },
  {
    "codigo":299726008,
    "descripcion":"DESCUIDO DE LA PARTE IZQUIERDA DEL CUERPO"
  },
  {
    "codigo":232355001,
    "descripcion":"EPISTAXIS POSTERIOR"
  },
  {
    "codigo":363427000,
    "descripcion":"NEOPLASIA MALIGNA DE SENO FRONTAL"
  },
  {
    "codigo":723875008,
    "descripcion":"OBSTRUCCIÓN ARTERIAL DEBIDA A EMBOLIA TROMBÓTICA POR ANEURISMA DE ARTERIA"
  },
  {
    "codigo":427128002,
    "descripcion":"COMIENZO GRADUAL DEL DOLOR"
  },
  {
    "codigo":1344632003,
    "descripcion":"TRASTORNO DEBIDO A PROCEDIMIENTO DE INJERTO"
  },
  {
    "codigo":33912004,
    "descripcion":"DEFORMIDAD ORBITARIA POR ENFERMEDAD ÓSEA"
  },
  {
    "codigo":230520007,
    "descripcion":"COMPRESIÓN DE CINTILLA ÓPTICA"
  },
  {
    "codigo":296056007,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE FLUNITRAZEPAM"
  },
  {
    "codigo":359757004,
    "descripcion":"CANDIDIASIS ATRÓFICA CRÓNICA"
  },
  {
    "codigo":95778003,
    "descripcion":"NISTAGMO PERMANENTE"
  },
  {
    "codigo":1144354008,
    "descripcion":"INFLAMACIÓN DE MEMBRANA MUCOSA ORAL DEBIDA A TRAUMATISMO POR PRÓTESIS DENTAL"
  },
  {
    "codigo":126711001,
    "descripcion":"NEOPLASIA DE BRONQUIO DEL LÓBULO INFERIOR DERECHO DEL PULMÓN"
  },
  {
    "codigo":1177122009,
    "descripcion":"DISTROFIA MIOTÓNICA"
  },
  {
    "codigo":292386009,
    "descripcion":"REACCIÓN ADVERSA A LA FENOTIAZINA"
  },
  {
    "codigo":290551002,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR OXIBUPROCAÍNA"
  },
  {
    "codigo":30242009,
    "descripcion":"ESCARLATINA"
  },
  {
    "codigo":225015008,
    "descripcion":"SE SIENTE ABANDONADO"
  },
  {
    "codigo":419788000,
    "descripcion":"ALERGIA A NÍQUEL"
  },
  {
    "codigo":92108002,
    "descripcion":"NEOPLASIA BENIGNA DEL FLANCO"
  },
  {
    "codigo":26572003,
    "descripcion":"DISFUNCIÓN POLIGLANDULAR Y\/O TRASTORNOS RELACIONADOS"
  },
  {
    "codigo":93943008,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA GLÁNDULA PARATIROIDES"
  },
  {
    "codigo":124876008,
    "descripcion":"PÉRDIDA DE ANTÍGENOS NORMALES"
  },
  {
    "codigo":288716009,
    "descripcion":"NO UTILIZA LA CONVERSACIÓN CON FINES RECREATIVOS"
  },
  {
    "codigo":16057831000119101,
    "descripcion":"PARÁLISIS FACIAL IZQUIERDA GRADO IV DE HOUSE-BRACKMANN"
  },
  {
    "codigo":254113006,
    "descripcion":"SÍNDROME DE BRUCK"
  },
  {
    "codigo":188577007,
    "descripcion":"ENFERMEDAD DE HODGKIN, CELULARIDAD MIXTA DE GANGLIOS LINFÁTICOS INTRABDOMINALES"
  },
  {
    "codigo":283211002,
    "descripcion":"ANZUELO EN EL PERINEO"
  },
  {
    "codigo":447051007,
    "descripcion":"VIVE CON CÓNYUGE"
  },
  {
    "codigo":1264416003,
    "descripcion":"SÍNDROME MIELODISPLÁSICO NO CLASIFICADO"
  },
  {
    "codigo":707360003,
    "descripcion":"CARCINOMA LINFOEPITELIAL PRIMARIO DE LARINGE"
  },
  {
    "codigo":281376007,
    "descripcion":"CIFOESCOLIOSIS TORACOGÉNICA"
  },
  {
    "codigo":246773002,
    "descripcion":"PARÁLISIS DE LA MIRADA VERTICAL"
  },
  {
    "codigo":1511000119107,
    "descripcion":"NEUROPATÍA PERIFÉRICA DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":50165004,
    "descripcion":"DESPRENDIMIENTO HEMORRÁGICO DEL EPITELIO PIGMENTARIO RETINIANO"
  },
  {
    "codigo":302721000119101,
    "descripcion":"SÍNDROME COMPARTIMENTAL TIBIAL ANTERIOR DE PIERNA IZQUIERDA"
  },
  {
    "codigo":441546003,
    "descripcion":"FRACTURA DE HUESO ADYACENTE A PRÓTESIS"
  },
  {
    "codigo":15703681000119103,
    "descripcion":"TRASTORNO DE TENDÓN DE REGIÓN DE HOMBRO DERECHO"
  },
  {
    "codigo":244938009,
    "descripcion":"TRASTORNO DE LOS ÓRGANOS GENITALES FEMENINOS"
  },
  {
    "codigo":46495001,
    "descripcion":"ÚLCERA ESTERCORÁCEA DE RECTO"
  },
  {
    "codigo":138881000119106,
    "descripcion":"RETINOPATÍA NO PROLIFERATIVA LEVE DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":208500006,
    "descripcion":"FRACTURAS MÚLTIPLES EXPUESTAS DE HUESOS DE LA MANO"
  },
  {
    "codigo":110196008,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO DE LA MUCOSA LABIAL"
  },
  {
    "codigo":10057001,
    "descripcion":"PITIRIASIS LIQUENOIDE CRÓNICA"
  },
  {
    "codigo":698185000,
    "descripcion":"MORDIDA CRUZADA ANTERIOR QUE INVOLUCRA A VARIOS DIENTES"
  },
  {
    "codigo":1255241002,
    "descripcion":"FRACTURA EXPUESTA CONMINUTA DE HUESO METATARSIANO"
  },
  {
    "codigo":403273006,
    "descripcion":"CICATRIZ HIPOPIGMENTADA"
  },
  {
    "codigo":763721006,
    "descripcion":"ENCEFALOPATÍA HIPERMETIONINÉMICA DEBIDA A DEFICIENCIA DE ADENOSINA CINASA"
  },
  {
    "codigo":370505008,
    "descripcion":"CARILLA CORNEAL"
  },
  {
    "codigo":237598005,
    "descripcion":"TRASTORNO HIPERGLUCÉMICO"
  },
  {
    "codigo":170227002,
    "descripcion":"NIÑO DERIVADO AL MÉDICO ESPECIALISTA"
  },
  {
    "codigo":685851000119104,
    "descripcion":"LIPOSARCOMA PRIMARIO DE PARTES BLANDAS DE AXILA"
  },
  {
    "codigo":235763006,
    "descripcion":"PROCTITIS TRAUMÁTICA"
  },
  {
    "codigo":202995007,
    "descripcion":"ABSCESO DE BOLSA SEROSA DE HOMBRO"
  },
  {
    "codigo":792819006,
    "descripcion":"PULSO EN ARTERIA PEDIA IZQUIERDA PRESENTE"
  },
  {
    "codigo":397768002,
    "descripcion":"PANICULITIS POR FRÍO"
  },
  {
    "codigo":201160005,
    "descripcion":"HIPERTRICOSIS LANUGINOSA ADQUIRIDA"
  },
  {
    "codigo":299464006,
    "descripcion":"PIE ANGOSTO"
  },
  {
    "codigo":37320007,
    "descripcion":"PÉRDIDA DE DIENTES"
  },
  {
    "codigo":365000007,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA ARTICULAR CORRECTAMENTE PARA HABLAR"
  },
  {
    "codigo":233928007,
    "descripcion":"DISFUNCIÓN MIOCÁRDICA"
  },
  {
    "codigo":102856008,
    "descripcion":"CRISTAL URINARIO, SULFATO DE CALCIO"
  },
  {
    "codigo":363165003,
    "descripcion":"SECUELAS INFECCIOSAS DE TRASTORNOS"
  },
  {
    "codigo":232093001,
    "descripcion":"ESOTROPÍA INFANTIL"
  },
  {
    "codigo":263026000,
    "descripcion":"LUXACIÓN PERISEMILUNAR"
  },
  {
    "codigo":164722000,
    "descripcion":"ELECTROMIOGRAMA NORMAL"
  },
  {
    "codigo":197490003,
    "descripcion":"MALABSORCIÓN INTESTINAL DE PROTEÍNAS"
  },
  {
    "codigo":1237000005,
    "descripcion":"INFLAMACIÓN SEBORREICA DE BORDE ANTERIOR DE PÁRPADO INFERIOR DERECHO"
  },
  {
    "codigo":230258005,
    "descripcion":"ESCLEROSIS LATERAL AMIOTRÓFICA CON DEMENCIA"
  },
  {
    "codigo":195655000,
    "descripcion":"FARINGITIS GANGRENOSA AGUDA"
  },
  {
    "codigo":721778009,
    "descripcion":"INFECCIÓN CAUSADA POR VIRUS JUNÍN"
  },
  {
    "codigo":64583005,
    "descripcion":"LESIÓN TRAUMÁTICA DE VENA"
  },
  {
    "codigo":29980002,
    "descripcion":"ROTACIÓN ANÓMALA CONGÉNITA DE INTESTINO"
  },
  {
    "codigo":161052004,
    "descripcion":"CON MAYOR RIESGO DE HIPOTERMIA"
  },
  {
    "codigo":95516005,
    "descripcion":"IRRITACIÓN GASTROINTESTINAL"
  },
  {
    "codigo":128284006,
    "descripcion":"TRASTORNO CRÓNICO DEL APARATO DIGESTIVO"
  },
  {
    "codigo":292124004,
    "descripcion":"REACCIÓN ADVERSA AL HIDRÓXIDO DE ALUMINIO"
  },
  {
    "codigo":290289006,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR OXIFENBUTAZONA"
  },
  {
    "codigo":124614004,
    "descripcion":"DEFICIENCIA DE 4 - HIDROXI - 2 - OXOGLUTARATO ALDOLASA"
  },
  {
    "codigo":10627151000119103,
    "descripcion":"FORÚNCULO DE TOBILLO DERECHO"
  },
  {
    "codigo":331701000119109,
    "descripcion":"BLEFAROCALASIA DE PÁRPADO SUPERIOR DERECHO"
  },
  {
    "codigo":91846008,
    "descripcion":"HUESO METACARPIANO SUPERNUMERARIO"
  },
  {
    "codigo":1204123000,
    "descripcion":"EMBOLIA DEBIDA A MIXOMA CARDÍACO"
  },
  {
    "codigo":417691002,
    "descripcion":"ALTA DE LA ATENCIÓN DE ENFERMERA ESPECIALIZADA EN TRATAMIENTO DE LA DISPEPSIA"
  },
  {
    "codigo":253851000,
    "descripcion":"DIFALO"
  },
  {
    "codigo":188315007,
    "descripcion":"NEOPLASIA MALIGNA DE LA PIAMADRE CEREBRAL"
  },
  {
    "codigo":57243009,
    "descripcion":"FÍSTULA URINARIA"
  },
  {
    "codigo":186480003,
    "descripcion":"POLIOMIELITIS PARALÍTICA AGUDA, VIRUS NATURAL, INDÍGENA"
  },
  {
    "codigo":448624005,
    "descripcion":"CONEXIÓN BIVENTRICULAR UNIAURICULAR CON CONEXIÓN AURICULOVENTRICULAR DEL LADO IZQUIERDO AUSENTE Y CABALGAMIENTO DE VÁLVULA"
  },
  {
    "codigo":284784008,
    "descripcion":"DIFICULTAD PARA REALIZAR ACTIVIDAD DE HIGIENE PERSONAL"
  },
  {
    "codigo":55408009,
    "descripcion":"ENTROPIÓN SENIL"
  },
  {
    "codigo":414021001,
    "descripcion":"TRASTORNO CAUSADO POR VIRUS DE LA ESTOMATITIS PAPULAR BOVINA"
  },
  {
    "codigo":282949003,
    "descripcion":"INCAPAZ DE INCLINARSE PARA TOCARSE LOS PIES"
  },
  {
    "codigo":16033871000119108,
    "descripcion":"HIPERTROFIA DE HUESO DE PERONÉ DERECHO"
  },
  {
    "codigo":86341008,
    "descripcion":"INSUFICIENCIA VASCULAR"
  },
  {
    "codigo":1231386001,
    "descripcion":"CONOCIMIENTO INSUFICIENTE SOBRE TRATAMIENTO COMPLEMENTARIO"
  },
  {
    "codigo":16908521000119102,
    "descripcion":"CARCINOMA SEBÁCEO DE PIEL DE PÁRPADO INFERIOR IZQUIERDO"
  },
  {
    "codigo":444954005,
    "descripcion":"RIÑÓN IZQUIERDO PRESENTE"
  },
  {
    "codigo":1264154009,
    "descripcion":"TRASTORNO METABÓLICO POSTERIOR A EMBARAZO MOLAR"
  },
  {
    "codigo":408516006,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: SUECO"
  },
  {
    "codigo":703428006,
    "descripcion":"AUMENTO DE ERITROCITOS FANTASMA EN SANGRE"
  },
  {
    "codigo":242841000,
    "descripcion":"AUTOINTOXICACIÓN POR GAS DE CARBÓN"
  },
  {
    "codigo":79001001,
    "descripcion":"INTOXICACIÓN POR MARSILEA DRUMMONDII"
  },
  {
    "codigo":210073005,
    "descripcion":"LESIÓN PULMONAR EXPUESTA"
  },
  {
    "codigo":13465008,
    "descripcion":"ELEVACIÓN DE UNA COLONIA BACTERIANA, CON FORMA DE CÚPULA"
  },
  {
    "codigo":44398003,
    "descripcion":"EDAD GESTACIONAL, 4 SEMANAS"
  },
  {
    "codigo":699758006,
    "descripcion":"RETINITIS FOCAL PARAMACULAR"
  },
  {
    "codigo":206403000,
    "descripcion":"HEMORRAGIA UMBILICAL MASIVA DEL RECIÉN NACIDO"
  },
  {
    "codigo":11803011000119104,
    "descripcion":"ESGUINCE DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":271939006,
    "descripcion":"SECRECIÓN VAGINAL"
  },
  {
    "codigo":239171007,
    "descripcion":"CICATRIZ A TENSIÓN"
  },
  {
    "codigo":270104000,
    "descripcion":"INFORME FORENSE - ENVIADO"
  },
  {
    "codigo":75331009,
    "descripcion":"SÍNDROME DE EVANS"
  },
  {
    "codigo":697923008,
    "descripcion":"HIPERTENSIÓN PULMONAR EN LINFANGIOLEIOMIOMATOSIS"
  },
  {
    "codigo":302872003,
    "descripcion":"TRASTORNO POR HIPERALIMENTACIÓN"
  },
  {
    "codigo":827160004,
    "descripcion":"ERUPCIÓN ERITEMATOSA"
  },
  {
    "codigo":73496002,
    "descripcion":"INTOXICACIÓN POR LUPINUS"
  },
  {
    "codigo":401176004,
    "descripcion":"PRESCRIPCIÓN REPETIDA CONTROLADA POR FARMACÉUTICO"
  },
  {
    "codigo":237336007,
    "descripcion":"FIBRINÓLISIS - POSPARTO"
  },
  {
    "codigo":370243007,
    "descripcion":"LACERACIÓN SUPERFICIAL DE DEDO DE LA MANO"
  },
  {
    "codigo":366573006,
    "descripcion":"AMPLITUD DE MOVIMIENTO PASIVO DE ADUCCIÓN DE LA CADERA - HALLAZGO"
  },
  {
    "codigo":202733008,
    "descripcion":"PROLAPSO DE DISCO CERVICAL CON RADICULOPATÍA"
  },
  {
    "codigo":168130002,
    "descripcion":"ERITROCITOS VISTOS POR MICROSCOPIA"
  },
  {
    "codigo":397506003,
    "descripcion":"AUSENCIA DE IMPLANTES EN EPIPLÓN DE TUMOR DE OVARIO NO INVASIVO (EPITELIAL)"
  },
  {
    "codigo":102594003,
    "descripcion":"HALLAZGO ANORMAL EN EL ELECTROCARDIOGRAMA"
  },
  {
    "codigo":299202005,
    "descripcion":"CREPITACIÓN AUDIBLE DE ARTICULACIÓN DE PULGAR"
  },
  {
    "codigo":233666007,
    "descripcion":"SÍNDROME DE YOUNG"
  },
  {
    "codigo":266434009,
    "descripcion":"DISMOTILIDAD ESOFÁGICA"
  },
  {
    "codigo":231831002,
    "descripcion":"CARCINOMA PALPEBRAL DE CÉLULAS ESCAMOSAS"
  },
  {
    "codigo":262764000,
    "descripcion":"CAMBIO PERMANENTE DEL UMBRAL AUDITIVO INDUCIDO POR RUIDO"
  },
  {
    "codigo":788887009,
    "descripcion":"CARDITIS VIRAL CRÓNICA"
  },
  {
    "codigo":721516002,
    "descripcion":"SÍNDROME DEL CORDÓN ANTERIOR DE MÉDULA ESPINAL AL NIVEL DEL QUINTO SEGMENTO LUMBAR"
  },
  {
    "codigo":35223008,
    "descripcion":"GASTRITIS NO EROSIVA NO ESPECÍFICA SUPERFICIAL"
  },
  {
    "codigo":787052007,
    "descripcion":"GLAUCOMA DE ÁNGULO ABIERTO DE OJO DERECHO"
  },
  {
    "codigo":293697008,
    "descripcion":"ALERGIA A PROPANTELINA"
  },
  {
    "codigo":10685111000119102,
    "descripcion":"INFECCIÓN DE TRACTO RESPIRATORIO SUPERIOR CAUSADA POR VIRUS INFLUENZA"
  },
  {
    "codigo":129857008,
    "descripcion":"DISMINUCIÓN DE LA MOVILIDAD EN LA SILLA DE RUEDAS"
  },
  {
    "codigo":228161009,
    "descripcion":"DEFICIENCIA EN EL CUIDADO PERSONAL"
  },
  {
    "codigo":717846004,
    "descripcion":"ENFERMEDAD POR REFLUJO GASTROESOFÁGICO NO EROSIVA"
  },
  {
    "codigo":11831991000119102,
    "descripcion":"LACERACIÓN DE VASO SANGUÍNEO DE ÍNDICE DERECHO"
  },
  {
    "codigo":291862000,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR TIROGLOBULINA"
  },
  {
    "codigo":224491000,
    "descripcion":"CUIDADOR QUE EXPRESA SU DESEO DE ASISTIR"
  },
  {
    "codigo":95254009,
    "descripcion":"CARIES DENTAL SECUNDARIA"
  },
  {
    "codigo":93419003,
    "descripcion":"DERMATITIS DE CONTACTO CAUSADA POR NÍQUEL"
  },
  {
    "codigo":35841000175100,
    "descripcion":"ÚLCERA POR PRESIÓN EN TALÓN, ESTADIO II"
  },
  {
    "codigo":714176002,
    "descripcion":"NECROSIS DE COLGAJO"
  },
  {
    "codigo":124352005,
    "descripcion":"DEFICIENCIA DE UTP-GLUCOSA-1-FOSFATO URIDILILTRANSFERASA"
  },
  {
    "codigo":91584007,
    "descripcion":"DIETA RESTRINGIDA EN LACTOSA"
  },
  {
    "codigo":1269397007,
    "descripcion":"ATAXIA ADQUIRIDA DEBIDA A DEFICIENCIA DE VITAMINA"
  },
  {
    "codigo":415594002,
    "descripcion":"HERNIA ESTRANGULADA DE PARED ABDOMINAL ANTERIOR"
  },
  {
    "codigo":15737681000119103,
    "descripcion":"CATARATA POLAR SUBCAPSULAR ANTERIOR DE AMBOS OJOS"
  },
  {
    "codigo":284522007,
    "descripcion":"SIGUE SIEMPRE EL MISMO CAMINO - RUTINA ESTEREOTIPADA"
  },
  {
    "codigo":1003583000,
    "descripcion":"AGENESIA DE AMBOS TESTÍCULOS"
  },
  {
    "codigo":251754009,
    "descripcion":"SUPRESIÓN CENTRAL"
  },
  {
    "codigo":55146009,
    "descripcion":"INFLAMACIÓN DE ARTICULACIÓN SACROILÍACA"
  },
  {
    "codigo":315455002,
    "descripcion":"NACIDO EN KAZAKHSTAN"
  },
  {
    "codigo":774207004,
    "descripcion":"INSUFICIENCIA HEPÁTICA INFANTIL AGUDA CON SÍNDROME DE COMPROMISO MULTISISTÉMICO"
  },
  {
    "codigo":708671006,
    "descripcion":"DESPLIEGUE DENTAL DISMINUIDO AL SONREÍR"
  },
  {
    "codigo":413759008,
    "descripcion":"CUIDADOR DE PERSONA QUE ABUSA DEL ALCOHOL"
  },
  {
    "codigo":51476001,
    "descripcion":"RINOFARINGITIS"
  },
  {
    "codigo":282687009,
    "descripcion":"NO EMPUJAR NI ARRASTRA UN OBJETO GRANDE POR EL PISO"
  },
  {
    "codigo":53311008,
    "descripcion":"VARIACIÓN NORMAL EN EL TAMAÑO"
  },
  {
    "codigo":870676005,
    "descripcion":"REACCIÓN ADVERSA A PLOMO Y\/O COMPUESTO DE PLOMO"
  },
  {
    "codigo":248084006,
    "descripcion":"NO CONOCE EL PELIGRO DE LOS EXTRAÑOS"
  },
  {
    "codigo":18708008,
    "descripcion":"NEUROPATÍA INTERSTICIAL HIPERTRÓFICA"
  },
  {
    "codigo":1074001000119107,
    "descripcion":"ARTRITIS GOTOSA DE PIE DERECHO"
  },
  {
    "codigo":16873003,
    "descripcion":"CONVULSIÓN MUSICOGÉNICA"
  },
  {
    "codigo":705001007,
    "descripcion":"VÓMITO AUTOINDUCIDO PARA PERDER PESO"
  },
  {
    "codigo":80574002,
    "descripcion":"ENFERMEDAD DE MARIE - LERI"
  },
  {
    "codigo":703166003,
    "descripcion":"FÍSTULA ARTERIOVENOSA DURAL"
  },
  {
    "codigo":1260222004,
    "descripcion":"PIERCING EN FOSA NASAL DERECHA"
  },
  {
    "codigo":15038007,
    "descripcion":"INFESTACIÓN CAUSADA POR MYOCOPTES MUSCULINUS"
  },
  {
    "codigo":373651000,
    "descripcion":"HIDRONEFROSIS IDIOPÁTICA"
  },
  {
    "codigo":1292990007,
    "descripcion":"TUMOR FIBROSO SOLITARIO MALIGNO"
  },
  {
    "codigo":39741000087100,
    "descripcion":"LUXACIÓN DE ARTICULACIÓN DE DEDO ANULAR DE MANO IZQUIERDA"
  },
  {
    "codigo":734099007,
    "descripcion":"NEUROBLASTOMA DEL SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":275347009,
    "descripcion":"AUSENCIA DE PERONÉ"
  },
  {
    "codigo":109672001,
    "descripcion":"DIENTE AVULSIONADO REIMPLANTADO"
  },
  {
    "codigo":11368003,
    "descripcion":"ESTADO PRENATAL DEL FETO, 1ER TRIMESTRE"
  },
  {
    "codigo":371816003,
    "descripcion":"INSUFICIENCIA MITRAL AGUDA POR RUPTURA DE MÚSCULO PAPILAR"
  },
  {
    "codigo":732264002,
    "descripcion":"NEURODEGENERACIÓN ASOCIADA A LA PROTEÍNA COENZIMA A SINTASA"
  },
  {
    "codigo":240744005,
    "descripcion":"HISTOPLASMOSIS CUTÁNEA"
  },
  {
    "codigo":42301000087109,
    "descripcion":"CONTUSIÓN DE REGIÓN CLAVICULAR IZQUIERDA"
  },
  {
    "codigo":207976005,
    "descripcion":"FRACTURA NO EXPUESTA VERTICAL DEL SACRO"
  },
  {
    "codigo":47421000087105,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE PIEL DE TALÓN IZQUIERDO"
  },
  {
    "codigo":271677002,
    "descripcion":"CONTORNO ABDOMINAL IRREGULAR"
  },
  {
    "codigo":238909003,
    "descripcion":"TRASTORNO DE LA PIEL DE LA MAMA"
  },
  {
    "codigo":1156413005,
    "descripcion":"GLIOMATOSIS CEREBRAL"
  },
  {
    "codigo":106002000,
    "descripcion":"TRASTORNOS ASOCIADOS CON LA MENSTRUACIÓN Y\/O LA MENOPAUSIA"
  },
  {
    "codigo":237074005,
    "descripcion":"TORSIÓN UTERINA"
  },
  {
    "codigo":15930501000119103,
    "descripcion":"NEOPLASIA OVÁRICA BILATERAL DE COMPORTAMIENTO INCIERTO"
  },
  {
    "codigo":204306007,
    "descripcion":"PENTALOGÍA DE FALLOT"
  },
  {
    "codigo":300775003,
    "descripcion":"INCAPAZ DE JUGAR"
  },
  {
    "codigo":366311003,
    "descripcion":"HALLAZGO RELACIONADO CON LA POSICIÓN DEL CUELLO UTERINO"
  },
  {
    "codigo":200636000,
    "descripcion":"INFECCIÓN DE LA REGIÓN DE PULPEJO DE DEDO DE LA MANO\/PULGAR"
  },
  {
    "codigo":724924001,
    "descripcion":"DISTENSIÓN DE MÚSCULO BÍCEPS BRAQUIAL"
  },
  {
    "codigo":298940007,
    "descripcion":"HALLAZGO RELACIONADO CON ARTICULACIÓN DEL CARPO"
  },
  {
    "codigo":788625001,
    "descripcion":"SUPERPOSICIÓN ADQUIRIDA DE DEDO DE PIE"
  },
  {
    "codigo":723089002,
    "descripcion":"DEFECTO ADQUIRIDO DE TABIQUE INTERAURICULAR"
  },
  {
    "codigo":1149073003,
    "descripcion":"DEFICIENCIA DE TAURINA"
  },
  {
    "codigo":297105005,
    "descripcion":"TROMPA DE FALOPIO NORMAL"
  },
  {
    "codigo":721254003,
    "descripcion":"INFECCIÓN DE NERVIO CRANEANO"
  },
  {
    "codigo":229734008,
    "descripcion":"RETARDO DEL LENGUAJE EXPRESIVO"
  },
  {
    "codigo":1145403003,
    "descripcion":"MACROCEFALIA"
  },
  {
    "codigo":16641311000119104,
    "descripcion":"INFLAMACIÓN DE NERVIOS SAFENOS BILATERALES"
  },
  {
    "codigo":129595005,
    "descripcion":"SÍNDROME DE LA URETRA RÍGIDA"
  },
  {
    "codigo":1340176000,
    "descripcion":"SÍNDROME DE RETRASO DEL DESARROLLO, SOBREPESO, DISMORFIA FACIAL Y ANOMALÍAS DE COMPORTAMIENTO"
  },
  {
    "codigo":31291009,
    "descripcion":"SÍNDROME DE DISPLASIA ECTODÉRMICA - MALFORMACIÓN OCULAR"
  },
  {
    "codigo":62224002,
    "descripcion":"ABSCESO DE APÉNDICE ILEOCECAL"
  },
  {
    "codigo":293435008,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR PRAVASTATINA"
  },
  {
    "codigo":248499004,
    "descripcion":"EDEMA POSTURAL"
  },
  {
    "codigo":422672006,
    "descripcion":"VISIÓN A DISTANCIA 20\/60"
  },
  {
    "codigo":60389000,
    "descripcion":"PARAPLEJÍA"
  },
  {
    "codigo":94992009,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL PERITONEO PÉLVICO"
  },
  {
    "codigo":191461002,
    "descripcion":"DEMENCIA SENIL CON DELIRIO"
  },
  {
    "codigo":291600008,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR CEFTAZIDIMA"
  },
  {
    "codigo":11863481000119101,
    "descripcion":"CONTUSIÓN DE SEGUNDO A QUINTO DEDO DEL PIE DERECHO"
  },
  {
    "codigo":93157006,
    "descripcion":"LIPOMA DE ÓRGANOS INTRABDOMINALES"
  },
  {
    "codigo":289765008,
    "descripcion":"CUELLO UTERINO MADURO"
  },
  {
    "codigo":58554001,
    "descripcion":"EMPIEMA DE LA PLEURA"
  },
  {
    "codigo":1303738001,
    "descripcion":"NEOPLASIA COLORRECTAL"
  },
  {
    "codigo":224229008,
    "descripcion":"DUERME AFUERA"
  },
  {
    "codigo":15985951000119109,
    "descripcion":"MALFORMACIÓN CONGÉNITA DE VASO SANGUÍNEO DE AMBAS ÓRBITAS PROPIAMENTE DICHAS"
  },
  {
    "codigo":713914004,
    "descripcion":"CONSUMIDOR DE TABACO SIN HUMO"
  },
  {
    "codigo":25786006,
    "descripcion":"CONDUCTA ANORMAL"
  },
  {
    "codigo":187791002,
    "descripcion":"NEOPLASIA MALIGNA DE CUERPO DE PÁNCREAS"
  },
  {
    "codigo":23951003,
    "descripcion":"QUISTE DE LA GLÁNDULA DE MOLL"
  },
  {
    "codigo":253327004,
    "descripcion":"ESTENOSIS CONGÉNITA DE SENO CORONARIO"
  },
  {
    "codigo":89487002,
    "descripcion":"LINFOMA ESTADIO IE"
  },
  {
    "codigo":286095005,
    "descripcion":"TIRA LA BASURA DOMICILIARIA"
  },
  {
    "codigo":11781561000119105,
    "descripcion":"LESIÓN TRAUMÁTICA DE VENA FEMORAL DERECHA"
  },
  {
    "codigo":448100001,
    "descripcion":"ANEURISMA DE SENO DE VALSALVA AÓRTICO CON PROTRUSIÓN EN VENTRÍCULO DERECHO"
  },
  {
    "codigo":284260004,
    "descripcion":"TIENE PRENSIÓN"
  },
  {
    "codigo":185956004,
    "descripcion":"EN LISTA PARA VIVIENDA"
  },
  {
    "codigo":218724007,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR TETRACAÍNA"
  },
  {
    "codigo":251492009,
    "descripcion":"DESCARGAS EPILEPTIFORMES LATERALIZADAS PERIÓDICAS"
  },
  {
    "codigo":249657001,
    "descripcion":"DILATACIÓN VENOSA PERIANAL"
  },
  {
    "codigo":53049002,
    "descripcion":"TRASTORNO BIPOLAR GRAVE SIN SÍNTOMAS PSICÓTICOS"
  },
  {
    "codigo":184121006,
    "descripcion":"DISTANCIA DEL PACIENTE CON EL CONSULTORIO: DESCONOCIDA"
  },
  {
    "codigo":413497009,
    "descripcion":"SOCIEDAD ESTADOUNIDENSE DE ANESTESISTAS - ESTADO FÍSICO CLASE 3"
  },
  {
    "codigo":772110001,
    "descripcion":"METABOLIZADOR LENTO DE NUDT15"
  },
  {
    "codigo":313358003,
    "descripcion":"EXOSTOSIS DE OMÓPLATO"
  },
  {
    "codigo":247822006,
    "descripcion":"MIEDO DE VOLVERSE LOCO"
  },
  {
    "codigo":83982007,
    "descripcion":"MIELOPATÍA NECRÓTICA SUBAGUDA"
  },
  {
    "codigo":1263630007,
    "descripcion":"TRASTORNO FETAL DEBIDO A POSICIÓN TRANSVERSA DURANTE TRABAJO DE PARTO"
  },
  {
    "codigo":1163491000,
    "descripcion":"TRASTORNO DE LOS GLOMÉRULOS DEBIDO A INFECCIÓN POR SCHISTOSOMA"
  },
  {
    "codigo":870414009,
    "descripcion":"REACCIÓN ADVERSA A VITAMINA B Y\/O DERIVADO DE VITAMINA B"
  },
  {
    "codigo":49379003,
    "descripcion":"TRASTORNO DEL METABOLISMO DEL CROMO"
  },
  {
    "codigo":211384000,
    "descripcion":"MÚLTIPLES LESIONES TRAUMÁTICAS SUPERFICIALES DE PIERNA"
  },
  {
    "codigo":735672001,
    "descripcion":"FRACTURA DE CÓNDILO INTERNO DE TIBIA"
  },
  {
    "codigo":440981000124101,
    "descripcion":"INGESTA EXCESIVA DE SELENIO"
  },
  {
    "codigo":47544006,
    "descripcion":"EXALTACIÓN"
  },
  {
    "codigo":451221000124101,
    "descripcion":"HEMATOMA SUBUNGUEAL DE PULGAR IZQUIERDO"
  },
  {
    "codigo":406157002,
    "descripcion":"PROBABLEMENTE MANTENGA CONTACTO ADECUADO CON LOS SERVICIOS"
  },
  {
    "codigo":1290893002,
    "descripcion":"OSTEOSARCOMA MICROCÍTICO"
  },
  {
    "codigo":671381000124108,
    "descripcion":"INCAPAZ DE CONSEGUIR ATENCIÓN DE SALUD DEBIDO A RECURSOS FINANCIEROS LIMITADOS"
  },
  {
    "codigo":661000124108,
    "descripcion":"ERROR EN PRESCRIPCIÓN"
  },
  {
    "codigo":209549007,
    "descripcion":"ESGUINCE DE LIGAMENTO SACROILÍACO ANTERIOR"
  },
  {
    "codigo":1079021000119102,
    "descripcion":"ANGIOSARCOMA PRIMARIO DE CADERA IZQUIERDA"
  },
  {
    "codigo":111245009,
    "descripcion":"SÍNDROME COMPARTIMENTAL"
  },
  {
    "codigo":1354594002,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA INCOMPLETA DE DÍGITO DE MANO"
  },
  {
    "codigo":76642003,
    "descripcion":"DEFICIENCIA DE FACTOR X"
  },
  {
    "codigo":240482001,
    "descripcion":"EXANTEMA ENTEROVIRAL"
  },
  {
    "codigo":109410008,
    "descripcion":"DISOSTOSIS FRONTOFRONTAL"
  },
  {
    "codigo":402487001,
    "descripcion":"CALCINOSIS POSTRAUMÁTICA"
  },
  {
    "codigo":369719002,
    "descripcion":"G4: INDIFERENCIADO (MENOS DE 5 POR CIENTO DE FORMACIÓN GLANDULAR)"
  },
  {
    "codigo":42039004,
    "descripcion":"CONTUSIÓN DEL PERINEO"
  },
  {
    "codigo":238647005,
    "descripcion":"LIQUEN PLANO EN GOTAS"
  },
  {
    "codigo":7436001,
    "descripcion":"NEUMOPATÍA ALVEOLAR"
  },
  {
    "codigo":72972005,
    "descripcion":"MIOCARDIOPATÍA DILATADA CAUSADA POR FÁRMACO"
  },
  {
    "codigo":204044008,
    "descripcion":"APLASIA DEL CUERPO CALLOSO"
  },
  {
    "codigo":236812009,
    "descripcion":"DEFICIENCIA ESPERMATOGÉNICA ADQUIRIDA"
  },
  {
    "codigo":269580008,
    "descripcion":"MELANOMA MALIGNO DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":300513000,
    "descripcion":"LESIÓN DE PENE"
  },
  {
    "codigo":38369006,
    "descripcion":"CON MAYOR RIESGO DE DETERIORO COGNITIVO"
  },
  {
    "codigo":5601008,
    "descripcion":"SÍNDROME DE KLIPPEL - FEIL"
  },
  {
    "codigo":396982000,
    "descripcion":"HALLAZGO QUE ENCARA LA INVASIÓN TUMORAL DEL NERVIO ÓPTICO"
  },
  {
    "codigo":69302000,
    "descripcion":"PETICIÓN DE ABORTO"
  },
  {
    "codigo":429750003,
    "descripcion":"ANOMALÍA DE LA MOTILIDAD PARIETAL DEL VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":234977009,
    "descripcion":"PÉRDIDA DE SUPERFICIE DENTAL"
  },
  {
    "codigo":15634311000119103,
    "descripcion":"HALLAZGO MAMOGRÁFICO DE MASA DE MAMA IZQUIERDA"
  },
  {
    "codigo":298678006,
    "descripcion":"HALLAZGO RELACIONADO CON LA TEMPERATURA DE LA COLUMNA LUMBAR"
  },
  {
    "codigo":366049009,
    "descripcion":"APERTURA DE PUNTO LAGRIMAL SUPERIOR - HALLAZGO"
  },
  {
    "codigo":315271000119104,
    "descripcion":"OSTEOCONDRODISPLASIA CONCOMITANTE CON DEFECTOS DE CRECIMIENTO DE HUESOS TUBULARES Y COLUMNA VERTEBRAL"
  },
  {
    "codigo":296843004,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE PREDNISONA"
  },
  {
    "codigo":427915005,
    "descripcion":"HIPERPLASIA DE CONDUCTO GALACTÓFORO"
  },
  {
    "codigo":1279883006,
    "descripcion":"DISTROFIA MUSCULAR DE CINTURAS R23 ASOCIADA A SUBUNIDAD ALFA 2 DE LAMININA"
  },
  {
    "codigo":722827008,
    "descripcion":"SARCOMA SINOVIAL PRIMARIO DE ÓRGANO RESPIRATORIO"
  },
  {
    "codigo":131168003,
    "descripcion":"GRUPO SANGUÍNEO O>HM<^A^"
  },
  {
    "codigo":295008005,
    "descripcion":"ALERGIA A CANRENOATO DE POTASIO"
  },
  {
    "codigo":719157002,
    "descripcion":"SÍNDROME DE DISCAPACIDAD INTELECTUAL LIGADA AL CROMOSOMA X E HIPOTONÍA CON DISMORFISMO FACIAL Y CONDUCTA AGRESIVA"
  },
  {
    "codigo":293173003,
    "descripcion":"REACCIÓN ADVERSA A LOS PREPARADOS DE PREDNISOLONA RECTAL"
  },
  {
    "codigo":225802003,
    "descripcion":"DOMINADO POR CUIDADOR"
  },
  {
    "codigo":422410004,
    "descripcion":"FENÓMENO MIOTÓNICO DURANTE EL CALENTAMIENTO"
  },
  {
    "codigo":94730005,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE GLÁNDULA SUPRARRENAL"
  },
  {
    "codigo":1208842008,
    "descripcion":"TROMBOEMBOLISMO VENOSO POR TROMBOSIS DE VENA DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":289503001,
    "descripcion":"HALLAZGO RELACIONADO CON EL TAMAÑO DEL CLÍTORIS"
  },
  {
    "codigo":715487005,
    "descripcion":"SÍNDROME DE OSTEÓLISIS DISTAL AUTOSÓMICO RECESIVO"
  },
  {
    "codigo":92895006,
    "descripcion":"FORMA ANORMAL CONGÉNITA DE HUESO BASIOCCIPITAL"
  },
  {
    "codigo":125663008,
    "descripcion":"HERIDA ABIERTA DEL PIE"
  },
  {
    "codigo":123828003,
    "descripcion":"ORGANISMOS FÚNGICOS CON MORFOLOGÍA INDICATIVA DE ESPECIE DE CANDIDA"
  },
  {
    "codigo":254900004,
    "descripcion":"CARCINOMA DE PRÓSTATA"
  },
  {
    "codigo":91060006,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN LA REGIÓN DE LA MUÑECA, CON INFECCIÓN"
  },
  {
    "codigo":1172404006,
    "descripcion":"HORMONAS SEXUALES FEMENINAS SÉRICAS POR ENCIMA DE RANGO DE REFERENCIA"
  },
  {
    "codigo":89225005,
    "descripcion":"ERITROFOBIA"
  },
  {
    "codigo":283998003,
    "descripcion":"LESIÓN DE GANGLIO LINFÁTICO"
  },
  {
    "codigo":447838003,
    "descripcion":"ATRESIA PULMONAR Y DEFECTO DEL TABIQUE INTERVENTRICULAR CON SALIDA DE AORTA DESDE EL VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":54622005,
    "descripcion":"PROVISIÓN NORMAL DE OXÍGENO"
  },
  {
    "codigo":344251000119103,
    "descripcion":"GLAUCOMA BILATERAL POR PSEUDOEXFOLIACIÓN"
  },
  {
    "codigo":249395001,
    "descripcion":"AMÍGDALAS GRANDES"
  },
  {
    "codigo":413235002,
    "descripcion":"TUBO DE GASTROSTOMÍA PERCUTÁNEA ENDOSCÓPICA REMOVIBLE EXTERNAMENTE"
  },
  {
    "codigo":1751000119100,
    "descripcion":"EXACERBACIÓN AGUDA DE ENFERMEDAD PULMONAR OBSTRUCTIVA CRÓNICA CON ASMA"
  },
  {
    "codigo":687831000119101,
    "descripcion":"RABDOMIOSARCOMA PRIMARIO DE CADERA"
  },
  {
    "codigo":296151000119102,
    "descripcion":"QUISTE DE MENISCO DE RODILLA IZQUIERDA"
  },
  {
    "codigo":1074391000119103,
    "descripcion":"ARTROSIS DE ARTICULACIÓN ESTERNOCLAVICULAR DERECHA"
  },
  {
    "codigo":159139031000119104,
    "descripcion":"VULVOVAGINITIS CANDIDIÁSICA DURANTE EL EMBARAZO"
  },
  {
    "codigo":10904791000119105,
    "descripcion":"HERIDA ABIERTA DE GLÚTEO IZQUIERDO"
  },
  {
    "codigo":15978711000119106,
    "descripcion":"TRASTORNO DE RAÍZ DE NERVIO CERVICAL IZQUIERDO"
  },
  {
    "codigo":99031000119107,
    "descripcion":"EXACERBACIÓN AGUDA DE ASMA CONCOMITANTE CON RINITIS ALÉRGICA"
  },
  {
    "codigo":1092311000119106,
    "descripcion":"NEURONITIS VESTIBULAR DERECHA"
  },
  {
    "codigo":367831000119109,
    "descripcion":"ESTRECHEZ POSINFECCIOSA DE URETRA ANTERIOR"
  },
  {
    "codigo":308951000119109,
    "descripcion":"TENDINITIS CALCIFICANTE DE CODO IZQUIERDO"
  },
  {
    "codigo":10899671000119109,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO OCULOMOTOR DERECHO"
  },
  {
    "codigo":16434391000119107,
    "descripcion":"PUBALGIA ATLÉTICA DE REGIÓN INGUINAL IZQUIERDA"
  },
  {
    "codigo":10682071000119104,
    "descripcion":"NÓDULO DE TEJIDO CELULAR SUBCUTÁNEO DE DEDO DE AMBOS PIES"
  },
  {
    "codigo":16907991000119108,
    "descripcion":"NEVO EPIDÉRMICO PILOSO PIGMENTADO DE PÁRPADO SUPERIOR DERECHO"
  },
  {
    "codigo":319191000119108,
    "descripcion":"RADICULOPATÍA SACROCOCCÍGEA"
  },
  {
    "codigo":737245004,
    "descripcion":"DERMATOSIS DE ANO"
  },
  {
    "codigo":10633431000119109,
    "descripcion":"CELULITIS DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":12205271000119109,
    "descripcion":"INFECCIÓN DE CLAVÍCULA DERECHA ASOCIADA CON DISPOSITIVO DE FIJACIÓN INTERNA"
  },
  {
    "codigo":50952009,
    "descripcion":"LUXACIÓN RECURRENTE DE TOBILLO Y\/O PIE"
  },
  {
    "codigo":247560008,
    "descripcion":"PELOS AHUSADOS"
  },
  {
    "codigo":317781000119102,
    "descripcion":"ARTRITIS DE TOBILLO IZQUIERDO CAUSADA POR STREPTOCOCCUS PNEUMONIAE"
  },
  {
    "codigo":409565006,
    "descripcion":"BOTULISMO TRANSMITIDO POR LOS ALIMENTOS, TIPO B"
  },
  {
    "codigo":702642003,
    "descripcion":"ALOSENSIBILIZACIÓN"
  },
  {
    "codigo":276658003,
    "descripcion":"INMADUREZ EXTREMA"
  },
  {
    "codigo":473266006,
    "descripcion":"QUEMADURA DE TERCER GRADO DE MÚLTIPLES SITIOS DE LA MANO"
  },
  {
    "codigo":309426007,
    "descripcion":"GLOMERULOPATÍA DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":14514008,
    "descripcion":"ANEMIA POR ALTERACIÓN EN LA SÍNTESIS DE HEMOGLOBINA"
  },
  {
    "codigo":1259698009,
    "descripcion":"ADENOCARCINOMA DE CÉLULAS CLARAS PRIMARIO DE PERITONEO"
  },
  {
    "codigo":209287000,
    "descripcion":"FRACTURA-SUBLUXACIÓN NO EXPUESTA DE ARTICULACIÓN CARPOMETACARPIANA"
  },
  {
    "codigo":15964501000119104,
    "descripcion":"PARADA CARDIORRESPIRATORIA DURANTE CIRUGÍA CARDÍACA"
  },
  {
    "codigo":307591004,
    "descripcion":"MASTOCITOSIS MALIGNA"
  },
  {
    "codigo":405895001,
    "descripcion":"FENOTIPO K+"
  },
  {
    "codigo":373127006,
    "descripcion":"CÁMARA CARDÍACA MODERADAMENTE AGRANDADA"
  },
  {
    "codigo":110983008,
    "descripcion":"ANETODERMIA DE SCHWENINGER - BUZZI"
  },
  {
    "codigo":404060005,
    "descripcion":"LIPOMA FRONTAL ASOCIADO"
  },
  {
    "codigo":305756006,
    "descripcion":"ATENDIDO POR ENFERMERA DE ENLACE"
  },
  {
    "codigo":76380008,
    "descripcion":"PLACENTA MEMBRANOSA"
  },
  {
    "codigo":240220009,
    "descripcion":"INESTABILIDAD DE LA COLUMNA VERTEBRAL"
  },
  {
    "codigo":9009001,
    "descripcion":"VEJIGA URINARIA CON POCA DISTENSIBILIDAD"
  },
  {
    "codigo":860977000,
    "descripcion":"ÚLCERA DE PIE DERECHO DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":271153007,
    "descripcion":"AMPOLLA TRAUMÁTICA DE HOMBRO Y BRAZO, INFECTADA"
  },
  {
    "codigo":302086000,
    "descripcion":"ESTADIO 4 DEL TANNER DE VELLO AXILAR"
  },
  {
    "codigo":105478000,
    "descripcion":"PELEAS EN LA ESCUELA"
  },
  {
    "codigo":236550005,
    "descripcion":"SÍNDROME DE POLISEROSITIS EN DIÁLISIS"
  },
  {
    "codigo":201947000,
    "descripcion":"ARTROPATÍA TRAUMÁTICA DE ARTICULACIÓN METACARPOFALÁNGICA"
  },
  {
    "codigo":11741000202105,
    "descripcion":"BUENA CALIDAD DE SUEÑO"
  },
  {
    "codigo":365787000,
    "descripcion":"NIVEL SÉRICO DE BILIRRUBINA - HALLAZGO"
  },
  {
    "codigo":38107004,
    "descripcion":"PUNTAJE DE APGAR 4"
  },
  {
    "codigo":300251004,
    "descripcion":"LESIÓN DE ENCÍAS"
  },
  {
    "codigo":167344003,
    "descripcion":"MICROSCOPIA DE ORINA: CRISTALES DE FOSFATOS"
  },
  {
    "codigo":165509000,
    "descripcion":"RECUENTO DE LEUCOCITOS FUERA DE RANGO DE REFERENCIA"
  },
  {
    "codigo":427653003,
    "descripcion":"DOLOR IRRADIADO A LA PIERNA DERECHA"
  },
  {
    "codigo":1345157004,
    "descripcion":"DEPENDENCIA FISIOLÓGICA DE SUSTANCIA EN EL USO TERAPÉUTICO"
  },
  {
    "codigo":294746000,
    "descripcion":"ALERGIA A ALILESTRENOL"
  },
  {
    "codigo":1279621008,
    "descripcion":"HERIDA CORTANTE DE PIEL DE OÍDO"
  },
  {
    "codigo":65370002,
    "descripcion":"LACERACIÓN ANTIGUA DEL CUELLO UTERINO"
  },
  {
    "codigo":720730003,
    "descripcion":"QUISTE Y TROFOZOÍTO DE ENTAMOEBA COLI"
  },
  {
    "codigo":346761000119103,
    "descripcion":"MUCOCELE CRÓNICO DE SACO LAGRIMAL DE AMBOS OJOS"
  },
  {
    "codigo":425818007,
    "descripcion":"DISPOSICIÓN PARA MEJORAR EL CONFORT"
  },
  {
    "codigo":292911000,
    "descripcion":"REACCIÓN ADVERSA A LA PIPERAZINA"
  },
  {
    "codigo":63535002,
    "descripcion":"INTOXICACIÓN POR MATRICARIA NIGELLIFOLIA"
  },
  {
    "codigo":1144879003,
    "descripcion":"HIPOPLASIA CONGÉNITA DE GLÁNDULA ECRINA"
  },
  {
    "codigo":129071004,
    "descripcion":"DEPENDENCIA PARA HABLAR POR TELÉFONO"
  },
  {
    "codigo":161839005,
    "descripcion":"PROBLEMA ALIMENTARIO EN EL ANCIANO"
  },
  {
    "codigo":30767006,
    "descripcion":"APRAXIA DE LA MARCHA"
  },
  {
    "codigo":15665801000119104,
    "descripcion":"CATARATA CAPSULAR CONGÉNITA DE AMBOS OJOS"
  },
  {
    "codigo":291076000,
    "descripcion":"INTOXICACIÓN POR OXAZEPAM"
  },
  {
    "codigo":127236004,
    "descripcion":"NEOPLASIA DE LOS GANGLIOS LINFÁTICOS OCCIPITALES"
  },
  {
    "codigo":225540005,
    "descripcion":"INFLAMACIÓN DE HERIDA"
  },
  {
    "codigo":1306884006,
    "descripcion":"GLAUCOMA PRIMARIO DE ÁNGULO ABIERTO CON PRESIÓN NORMAL DE OJO IZQUIERDO"
  },
  {
    "codigo":782596007,
    "descripcion":"ALERGIA A TIOUREA"
  },
  {
    "codigo":61700007,
    "descripcion":"INFLUENZA CON MANIFESTACIONES NO RESPIRATORIAS"
  },
  {
    "codigo":192772009,
    "descripcion":"TROMBOFLEBITIS DE SENO LATERAL"
  },
  {
    "codigo":27097002,
    "descripcion":"MIOCARDIOPATÍA AMILOIDE FAMILIAR TIPO DANESA"
  },
  {
    "codigo":92633003,
    "descripcion":"CARCINOMA IN SITU DE LA CARA LARÍNGEA DE LA EPIGLOTIS"
  },
  {
    "codigo":94468008,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LAS GLÁNDULAS PARAURETRALES"
  },
  {
    "codigo":289241009,
    "descripcion":"TRABAJO DE PARTO BREVE"
  },
  {
    "codigo":254638002,
    "descripcion":"TUMOR DEL VÉRTICE PULMONAR"
  },
  {
    "codigo":1335982003,
    "descripcion":"GLAUCOMA DEBIDO A QUISTE DE CUERPO CILIAR DE OJO IZQUIERDO"
  },
  {
    "codigo":123566006,
    "descripcion":"ANOMALÍA CONGÉNITA DE HUESO CALCÁNEO"
  },
  {
    "codigo":1137539005,
    "descripcion":"CALCIFICACIÓN PUNTEADA DE EPÍFISIS DISTAL DE CÚBITO"
  },
  {
    "codigo":87128005,
    "descripcion":"MALESTAR SENSITIVO"
  },
  {
    "codigo":54360005,
    "descripcion":"CLONO ROTULIANO"
  },
  {
    "codigo":1332312006,
    "descripcion":"OSTEOPATÍA DE TIBIA POSTERIOR A POLIOMIELITIS"
  },
  {
    "codigo":283736007,
    "descripcion":"MORDEDURA DE PERRO EN LA CABEZA"
  },
  {
    "codigo":314669003,
    "descripcion":"PESO DEL NIÑO: < PERCENTILO 0,4"
  },
  {
    "codigo":609581006,
    "descripcion":"DIABETES MELLITUS TRANSITORIA NEONATAL, TIPO 3"
  },
  {
    "codigo":773421009,
    "descripcion":"EPILEPSIA DEL LÓBULO TEMPORAL MESIAL DE INICIO EN LA LACTANCIA, CON REGRESIÓN COGNITIVA SEVERA"
  },
  {
    "codigo":83458005,
    "descripcion":"DEPRESIÓN AGITADA"
  },
  {
    "codigo":835287002,
    "descripcion":"AGUDEZA VISUAL DE OJO IZQUIERDO 6\/5"
  },
  {
    "codigo":473004000,
    "descripcion":"FEMINIZACIÓN"
  },
  {
    "codigo":704215008,
    "descripcion":"FRACTURA EXPUESTA DE CUERPO DEL OMÓPLATO"
  },
  {
    "codigo":79788002,
    "descripcion":"ATRESIA DEL MEATO URINARIO"
  },
  {
    "codigo":1259436003,
    "descripcion":"CARCINOMA PRIMARIO DE COLON"
  },
  {
    "codigo":210860005,
    "descripcion":"LESIÓN DE MÚLTIPLES VASOS SANGUÍNEOS A NIVEL DEL ANTEBRAZO"
  },
  {
    "codigo":10671191000119100,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN EN TOBILLO DERECHO NO ESTADIFICABLE"
  },
  {
    "codigo":702380008,
    "descripcion":"MIOPATÍA INFLAMATORIA IDIOPÁTICA"
  },
  {
    "codigo":276396009,
    "descripcion":"DESVIACIÓN DE LA MANDÍBULA EN LA APERTURA"
  },
  {
    "codigo":45185006,
    "descripcion":"TOXICIDAD POR COMPUESTO DE FENILUREA"
  },
  {
    "codigo":1086551000119102,
    "descripcion":"HEMORRAGIA DE CIEGO DEBIDA A DIVERTICULOSIS"
  },
  {
    "codigo":895318001,
    "descripcion":"FORMA DE BALA ANORMAL CONGÉNITA DE FALANGE DE DEDO ANULAR"
  },
  {
    "codigo":733313008,
    "descripcion":"QUERATITIS DEBIDA A TRAUMATISMO"
  },
  {
    "codigo":241793009,
    "descripcion":"EFECTO TÓXICO CAUSADO POR HERBICIDA ORGANOFOSFORADO"
  },
  {
    "codigo":76118001,
    "descripcion":"ILEÍTIS DIETÉTICA"
  },
  {
    "codigo":305494005,
    "descripcion":"BAJO ATENCIÓN DE NEURÓLOGO"
  },
  {
    "codigo":403798006,
    "descripcion":"ATRIQUIA CONGÉNITA"
  },
  {
    "codigo":371030007,
    "descripcion":"DOLOR TORÁCICO OPRESIVO"
  },
  {
    "codigo":698710008,
    "descripcion":"HEMORRAGIA PREPARTO DEBIDA A PLACENTA PREVIA, TIPO III"
  },
  {
    "codigo":405633009,
    "descripcion":"INFECCIÓN POR STREPTOCOCCUS DEL GRUPO B EN EL LACTANTE"
  },
  {
    "codigo":238123002,
    "descripcion":"DEFICIENCIA DE VANADIO"
  },
  {
    "codigo":762411007,
    "descripcion":"ERROR DE IMPRONTA"
  },
  {
    "codigo":301824001,
    "descripcion":"LARINGOTRAQUEÍTIS VIRAL AGUDA"
  },
  {
    "codigo":170752001,
    "descripcion":"HA CONSULTADO AL NUTRICIONISTA - DIABETES"
  },
  {
    "codigo":1284864005,
    "descripcion":"CRISIS EPILÉPTICA SENSORIAL CON ALTERACIÓN DE CONCIENCIA DE INICIO FOCAL"
  },
  {
    "codigo":400128006,
    "descripcion":"DERMOPATÍA RESTRICTIVA LETAL"
  },
  {
    "codigo":398293003,
    "descripcion":"DEFECTO DE LA INMUNIDAD CELULAR"
  },
  {
    "codigo":299989006,
    "descripcion":"INFECCIÓN DE DEDO DEL PIE"
  },
  {
    "codigo":234453008,
    "descripcion":"DEFICIENCIA DEL FACTOR DE PASSOVOY"
  },
  {
    "codigo":298154000,
    "descripcion":"DERRAME DE ARTICULACIÓN DEL PIE"
  },
  {
    "codigo":365525008,
    "descripcion":"HALLAZGO RELACIONADO CON EL ESTADO LABORAL"
  },
  {
    "codigo":36010004,
    "descripcion":"MENINGOCELE CEREBRAL CONGÉNITO"
  },
  {
    "codigo":724138007,
    "descripcion":"SÍNDROME DE MIOPATÍA MITOCONDRIAL CON ANEMIA SIDEROBLÁSTICA"
  },
  {
    "codigo":789674008,
    "descripcion":"PARAPLEJÍA ESPÁSTICA, ATROFIA ÓPTICA Y NEUROPATÍA Y TRASTORNO RELACIONADO CON PARAPLEJÍA ESPÁSTICA, ATROFIA ÓPTICA Y NEUROPATÍA"
  },
  {
    "codigo":165247006,
    "descripcion":"INCAPAZ DE SUBIR ESCALERAS"
  },
  {
    "codigo":720468000,
    "descripcion":"SÍNDROME DE ANIRIDIA Y DISCAPACIDAD INTELECTUAL"
  },
  {
    "codigo":230783009,
    "descripcion":"APRAXIA CONGÉNITA"
  },
  {
    "codigo":65108000,
    "descripcion":"CON MAYOR RIESGO DE VIOLENCIA"
  },
  {
    "codigo":425556003,
    "descripcion":"CALCIFICACIÓN DE ÚTERO"
  },
  {
    "codigo":322801000119105,
    "descripcion":"TRASTORNO TRAUMÁTICO DE COLUMNA CERVICAL"
  },
  {
    "codigo":294484007,
    "descripcion":"ALERGIA A ROSOXACINO"
  },
  {
    "codigo":292649004,
    "descripcion":"REACCIÓN ADVERSA AL COLODIÓN"
  },
  {
    "codigo":718633009,
    "descripcion":"ICTIOSIS LAMINAR AUTOCICATRIZANTE ACRA"
  },
  {
    "codigo":290814001,
    "descripcion":"INTOXICACIÓN POR BUTRIPTILINA"
  },
  {
    "codigo":61438005,
    "descripcion":"INTOXICACIÓN POR AGENTE PSICOTRÓPICO"
  },
  {
    "codigo":94206007,
    "descripcion":"NEOPLASIA MALIGNA SECUNDARIA DE VASO SANGUÍNEO DE MUSLO"
  },
  {
    "codigo":28670008,
    "descripcion":"VÁRICES ESOFÁGICAS"
  },
  {
    "codigo":782334008,
    "descripcion":"INTOLERANCIA A LA LACTOSA POR DEFICIENCIA DE LACTASA CONGÉNITA"
  },
  {
    "codigo":92371000,
    "descripcion":"NEOPLASIA BENIGNA DE LA PIEL DEL CUELLO"
  },
  {
    "codigo":288979003,
    "descripcion":"NO CHUPA"
  },
  {
    "codigo":190675006,
    "descripcion":"SECUELAS DE LA DESNUTRICIÓN CALORICOPROTEICA"
  },
  {
    "codigo":1237416003,
    "descripcion":"METÁSTASIS DE CISTOADENOCARCINOMA EN PÁNCREAS"
  },
  {
    "codigo":156072005,
    "descripcion":"ABORTO ESPONTÁNEO INCOMPLETO"
  },
  {
    "codigo":1268349000,
    "descripcion":"CARCINOMA ENDOMETRIOIDE PRIMARIO DE OVARIO"
  },
  {
    "codigo":449149003,
    "descripcion":"DEFICIENCIA DE CÚSPIDE DE VÁLVULA AÓRTICA"
  },
  {
    "codigo":416381005,
    "descripcion":"PRESCRIPCIÓN RECOGIDA"
  },
  {
    "codigo":285309005,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS DE LA PIEL DE LA MEJILLA"
  },
  {
    "codigo":10864011000119108,
    "descripcion":"HERIDA POR DISPARO DE ARMA DE FUEGO DE PIE DERECHO"
  },
  {
    "codigo":351781000119102,
    "descripcion":"CARCINOMA DE CÉLULAS DE MERKEL PRIMARIO DE PIEL DE OREJA DERECHA"
  },
  {
    "codigo":711293008,
    "descripcion":"CON RIESGO MODERADO DE TROMBOEMBOLIA VENOSA"
  },
  {
    "codigo":283474003,
    "descripcion":"HERIDA PUNZANTE EN LA MAMA"
  },
  {
    "codigo":1089061000119103,
    "descripcion":"TRASTORNO DE MASTOIDES IZQUIERDA"
  },
  {
    "codigo":281639001,
    "descripcion":"IRRITACIÓN PERINEAL"
  },
  {
    "codigo":414546009,
    "descripcion":"TUBERCULOSIS RESISTENTE A LA ISONIAZIDA"
  },
  {
    "codigo":16899621000119104,
    "descripcion":"PERFORACIÓN TRAUMÁTICA DE RECTO"
  },
  {
    "codigo":248871003,
    "descripcion":"VAGINA AUSENTE"
  },
  {
    "codigo":314407005,
    "descripcion":"DISTROFIA RETINIANA"
  },
  {
    "codigo":106021000119105,
    "descripcion":"DEMENCIA MULTINFARTO DEBIDA A ATEROSCLEROSIS"
  },
  {
    "codigo":707623008,
    "descripcion":"DISPLASIA DE CEMENTO"
  },
  {
    "codigo":247036000,
    "descripcion":"LESIÓN FOCAL EN EL IRIS"
  },
  {
    "codigo":1230076000,
    "descripcion":"PATRÓN DE USO NOCIVO CONTINUO DE ANSIOLÍTICO SIN DEPENDENCIA"
  },
  {
    "codigo":1197308005,
    "descripcion":"NEOPLASIA QUÍSTICA MUCINOSA DE VESÍCULA BILIAR CON NEOPLASIA INTRAEPITELIAL DE BAJO GRADO"
  },
  {
    "codigo":703953004,
    "descripcion":"ASMA ALÉRGICA CAUSADA POR DERMATOPHAGOIDES PTERONYSSINUS"
  },
  {
    "codigo":308902007,
    "descripcion":"ÚLCERA DE MALÉOLO INTERNO"
  },
  {
    "codigo":733051000,
    "descripcion":"NEUMONÍA CAUSADA POR BACTERIAS GRAMPOSITIVAS"
  },
  {
    "codigo":210568006,
    "descripcion":"SECCIÓN TOTAL DEL TENDÓN DEL FLEXOR DE LA MANO"
  },
  {
    "codigo":700283004,
    "descripcion":"ACALASIA CONGÉNITA DE ESÓFAGO"
  },
  {
    "codigo":1255504004,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO DE PULGAR DERECHO"
  },
  {
    "codigo":12203711000119106,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DE PULGAR IZQUIERDO"
  },
  {
    "codigo":135001000119100,
    "descripcion":"TROMBOSIS VENOSA PROFUNDA AGUDA DE VENA YUGULAR INTERNA"
  },
  {
    "codigo":237861000,
    "descripcion":"ALCALOSIS RESPIRATORIA Y ALCALOSIS METABÓLICA"
  },
  {
    "codigo":403536009,
    "descripcion":"MÁCULA MELANÓTICA"
  },
  {
    "codigo":74021003,
    "descripcion":"BLOQUEO BIFASCICULAR"
  },
  {
    "codigo":16053951000119108,
    "descripcion":"POLINEUROPATÍA CAUSADA POR RADIACIÓN IONIZANTE"
  },
  {
    "codigo":236026001,
    "descripcion":"PROCESO VAGINAL PERMEABLE"
  },
  {
    "codigo":205093009,
    "descripcion":"ACORTAMIENTO CONGÉNITO DE TENDÓN DE AQUILES"
  },
  {
    "codigo":399866003,
    "descripcion":"VENAS DE LA RETINA EN CUENTAS DE ROSARIO DEBIDAS A DIABETES MELLITUS"
  },
  {
    "codigo":1153530002,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR SUSTANCIA CON ESTRUCTURA ÉTER"
  },
  {
    "codigo":203258007,
    "descripcion":"PERIOSTITIS DE COLUMNA VERTEBRAL LUMBAR SIN OSTEOMIELITIS"
  },
  {
    "codigo":1348303000,
    "descripcion":"SÍNDROME AUTOINFLAMATORIO POR FRÍO ASOCIADO AL FACTOR DE COAGULACIÓN XII"
  },
  {
    "codigo":170490008,
    "descripcion":"PORTADOR DE GONORREA"
  },
  {
    "codigo":234191002,
    "descripcion":"OCLUSIÓN DE INJERTO VASCULAR"
  },
  {
    "codigo":365263001,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA MANTENER LA TEMPERATURA CORRECTA DE LA COMIDA"
  },
  {
    "codigo":299727004,
    "descripcion":"DESCUIDO DE LA PARTE DERECHA DEL CUERPO"
  },
  {
    "codigo":232356000,
    "descripcion":"EPISTAXIS TRAUMÁTICA"
  },
  {
    "codigo":428964000,
    "descripcion":"GLIOMA DE CEREBRO DE BAJO GRADO"
  },
  {
    "codigo":266959008,
    "descripcion":"PROBLEMAS EN EL TRABAJO"
  },
  {
    "codigo":68516004,
    "descripcion":"INVERSIÓN DE NEGOCIOS EQUIVOCADA"
  },
  {
    "codigo":363428005,
    "descripcion":"NEOPLASIA MALIGNA DE SENO ESFENOIDAL"
  },
  {
    "codigo":681971000119100,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE COLA DE PÁNCREAS"
  },
  {
    "codigo":197753000,
    "descripcion":"NEFROPATÍA CAUSADA POR METALES PESADOS"
  },
  {
    "codigo":723876009,
    "descripcion":"EMBOLIA DE PLAQUETAS"
  },
  {
    "codigo":1145003,
    "descripcion":"TRASTORNO DEL DESARROLLO DEL HABLA"
  },
  {
    "codigo":230521006,
    "descripcion":"TRASTORNO DE RADIACIÓN ÓPTICA"
  },
  {
    "codigo":1344633008,
    "descripcion":"TRASTORNO POSTERIOR A PROCEDIMIENTO DE INJERTO"
  },
  {
    "codigo":292387000,
    "descripcion":"REACCIÓN ADVERSA A LA LEVOMEPROMAZINA"
  },
  {
    "codigo":97971000146108,
    "descripcion":"PORTADOR DE ACINETOBACTER RESISTENTE A MÚLTIPLES FÁRMACOS"
  },
  {
    "codigo":423459005,
    "descripcion":"ADELGAZAMIENTO CORNEAL"
  },
  {
    "codigo":26291000146108,
    "descripcion":"CAPAZ DE HACER AMIGOS"
  },
  {
    "codigo":95779006,
    "descripcion":"NISTAGMO UNIDIRECCIONAL"
  },
  {
    "codigo":194083007,
    "descripcion":"ESOTROPÍA ALTERNANTE CON PATRÓN X"
  },
  {
    "codigo":1144355009,
    "descripcion":"ESTOMATITIS ALÉRGICA POR CONTACTO CAUSADA POR PRÓTESIS DENTAL"
  },
  {
    "codigo":93944002,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LAS GLÁNDULAS PARAURETRALES"
  },
  {
    "codigo":1306360005,
    "descripcion":"NEOPLASIA BENIGNA DE PROLONGACIÓN AXILAR DE MAMA"
  },
  {
    "codigo":61176006,
    "descripcion":"ARTRITIS MICOPLASMÁTICA"
  },
  {
    "codigo":126712008,
    "descripcion":"NEOPLASIA DE BRONQUIO DEL LÓBULO INFERIOR IZQUIERDO DEL PULMÓN"
  },
  {
    "codigo":290552009,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR OXIBUPROCAÍNA"
  },
  {
    "codigo":288717000,
    "descripcion":"DIFICULTAD PARA UTILIZAR LA CONVERSACIÓN CON FINES RECREATIVOS"
  },
  {
    "codigo":124877004,
    "descripcion":"PÉRDIDA DE ISOANTÍGENOS"
  },
  {
    "codigo":92109005,
    "descripcion":"NEOPLASIA BENIGNA DEL PISO DE LA BOCA"
  },
  {
    "codigo":254114000,
    "descripcion":"SÍNDROME DE SIGLEON-MERTEN"
  },
  {
    "codigo":712866001,
    "descripcion":"ISQUEMIA EN REPOSO CONCOMITANTE CON CARDIOPATÍA ISQUÉMICA Y DEBIDA A ELLA"
  },
  {
    "codigo":24738006,
    "descripcion":"OSTEOMIELITIS DEL PEÑASCO"
  },
  {
    "codigo":333781000119100,
    "descripcion":"ÚLCERA DE MOOREN DE CÓRNEA DERECHA"
  },
  {
    "codigo":448887003,
    "descripcion":"TRONCO ARTERIAL COMÚN CON ARTERIA PULMONAR AISLADA"
  },
  {
    "codigo":184908000,
    "descripcion":"EXAMEN DE CONDUCTOR DISCAPACITADO A SEGURIDAD SOCIAL"
  },
  {
    "codigo":285047009,
    "descripcion":"CAPAZ DE USAR LENTES DE CONTACTO"
  },
  {
    "codigo":53836006,
    "descripcion":"HEMOCROMATOSIS SECUNDARIA"
  },
  {
    "codigo":283212009,
    "descripcion":"ANZUELO EN GENITALES"
  },
  {
    "codigo":84769001,
    "descripcion":"VÉRTIGO CERVICAL"
  },
  {
    "codigo":281377003,
    "descripcion":"LORDOSIS-HALLAZGO"
  },
  {
    "codigo":445217002,
    "descripcion":"PARÁLISIS DE NERVIO VESTIBULOCOCLEAR"
  },
  {
    "codigo":19233004,
    "descripcion":"CONTUSIÓN CEREBELOSA CON HERIDA INTRACRANEAL ABIERTA Y PÉRDIDA DE LA CONSCIENCIA"
  },
  {
    "codigo":707361004,
    "descripcion":"MELANOMA MALIGNO DE SENO FRONTAL"
  },
  {
    "codigo":1264417007,
    "descripcion":"ESTENOSIS POSOPERATORIA DE CUELLO UTERINO"
  },
  {
    "codigo":1297185003,
    "descripcion":"QUEMADURA DE PÁRPADO INFERIOR"
  },
  {
    "codigo":16029991000119101,
    "descripcion":"OSTEOMIELITIS SUBAGUDA DE AMBOS HUESOS TIBIALES"
  },
  {
    "codigo":82934008,
    "descripcion":"ESTREÑIMIENTO IDIOPÁTICO CRÓNICO"
  },
  {
    "codigo":246774008,
    "descripcion":"PARÁLISIS HORIZONTAL DISOCIADA DE LA MIRADA"
  },
  {
    "codigo":212171004,
    "descripcion":"LESIÓN TOTAL DE LA MÉDULA ESPINAL DORSAL, SIN LESIÓN ÓSEA, PRIMERA A SEXTA VÉRTEBRAS DORSALES"
  },
  {
    "codigo":1162443006,
    "descripcion":"BEZOAR EN ESTÓMAGO"
  },
  {
    "codigo":110197004,
    "descripcion":"QUEMADURA DE TERCER GRADO DE LA MUCOSA LABIAL"
  },
  {
    "codigo":403274000,
    "descripcion":"HIPOMELANOSIS ALREDEDOR DE MELANOMA MALIGNO"
  },
  {
    "codigo":763722004,
    "descripcion":"SÍNDROME DE HIPOTONÍA, ALTERACIÓN DEL HABLA Y RETRASO COGNITIVO SEVERO"
  },
  {
    "codigo":698186004,
    "descripcion":"MORDIDA CRUZADA ANTERIOR QUE INVOLUCRA A UN SOLO DIENTE"
  },
  {
    "codigo":10058006,
    "descripcion":"ABORTO ESPONTÁNEO CON EMBOLIA DE LÍQUIDO AMNIÓTICO"
  },
  {
    "codigo":370506009,
    "descripcion":"QUERATOUVEÍTIS"
  },
  {
    "codigo":237599002,
    "descripcion":"DIABETES MELLITUS TIPO 2 TRATADA CON INSULINA"
  },
  {
    "codigo":1255242009,
    "descripcion":"FRACTURA CONMINUTA NO EXPUESTA DE HUESO METATARSIANO"
  },
  {
    "codigo":792820000,
    "descripcion":"PULSO EN ARTERIA FEMORAL IZQUIERDA PRESENTE"
  },
  {
    "codigo":15675841000119105,
    "descripcion":"TENDINITIS CALCIFICANTE BILATERAL DE PIERNAS"
  },
  {
    "codigo":235764000,
    "descripcion":"PROCTITIS INFECCIOSA"
  },
  {
    "codigo":792925006,
    "descripcion":"RIÑÓN DE ARMANNI-EBSTEIN"
  },
  {
    "codigo":202996008,
    "descripcion":"ABSCESO DE BOLSA SEROSA DE CODO"
  },
  {
    "codigo":102857004,
    "descripcion":"CRISTAL URINARIO, COLESTEROL"
  },
  {
    "codigo":233929004,
    "descripcion":"TROMBO MURAL POSINFARTO"
  },
  {
    "codigo":168393006,
    "descripcion":"PATOLOGÍA GENERAL"
  },
  {
    "codigo":365001006,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA USAR LA ARTICULACIÓN SECUNDARIA"
  },
  {
    "codigo":35486000,
    "descripcion":"HEMORRAGIA SUBDURAL INTRACRANEAL"
  },
  {
    "codigo":201161009,
    "descripcion":"HIPERTRICOSIS NEVOIDE"
  },
  {
    "codigo":363166002,
    "descripcion":"TRASTORNO INFECCIOSO DE LA CABEZA"
  },
  {
    "codigo":299465007,
    "descripcion":"HIPERLIPIDEMIA MÚLTIPLE FAMILIAR TIPO LIPOPROTEINEMIA"
  },
  {
    "codigo":199326006,
    "descripcion":"EMBARAZO DE CUATRILLIZOS CON PROBLEMA PRENATAL"
  },
  {
    "codigo":428702006,
    "descripcion":"FÍSTULA DE ARTICULACIÓN DE REGIÓN DE MUÑECA"
  },
  {
    "codigo":166558007,
    "descripcion":"ALFA - FETOPROTEÍNA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":426867001,
    "descripcion":"TRASTORNO ANORRECTAL"
  },
  {
    "codigo":721779001,
    "descripcion":"INFECCIÓN CAUSADA POR VIRUS LASSA"
  },
  {
    "codigo":232094007,
    "descripcion":"ESOTROPÍA CON DESVIACIÓN VERTICAL DISOCIADA"
  },
  {
    "codigo":197491004,
    "descripcion":"MALABSORCIÓN INTESTINAL DE CARBOHIDRATOS"
  },
  {
    "codigo":330331000119105,
    "descripcion":"TRASTORNO DE NERVIO RADIAL DERECHO"
  },
  {
    "codigo":293960001,
    "descripcion":"ALERGIA A DISULFIRAM"
  },
  {
    "codigo":263027009,
    "descripcion":"LUXACIÓN DE LA ARTICULACIÓN RADIOCUBITAL DISTAL"
  },
  {
    "codigo":295795009,
    "descripcion":"SOBREDOSIS DE VINDESINA"
  },
  {
    "codigo":195656004,
    "descripcion":"FARINGITIS FLEMONOSA AGUDA"
  },
  {
    "codigo":719944006,
    "descripcion":"SÍNDROME DE TRICOMEGALIA CON DEGENERACIÓN DEL EPITELIO PIGMENTARIO DE LA RETINA Y ENANISMO"
  },
  {
    "codigo":95517001,
    "descripcion":"ALTERACIÓN DE LA COLORACIÓN DE LA MUCOSA DEL TRACTO GASTROINTESTINAL"
  },
  {
    "codigo":423197001,
    "descripcion":"ANOMALÍA ARTERIOVENOSA DE ÓRBITA"
  },
  {
    "codigo":292125003,
    "descripcion":"REACCIÓN ADVERSA A FÁRMACO ANTIDIARREICO"
  },
  {
    "codigo":193821003,
    "descripcion":"PLIEGUE DE LA MEMBRANA DE DESCEMET"
  },
  {
    "codigo":128285007,
    "descripcion":"ENFERMEDAD CRÓNICA DE LOS DIENTES Y\/O DE LAS ESTRUCTURAS DE SOPORTE"
  },
  {
    "codigo":290290002,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR OXIFENBUTAZONA"
  },
  {
    "codigo":60914006,
    "descripcion":"OSTEODISTROFIA POR INACTIVIDAD"
  },
  {
    "codigo":93682007,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL BRAZO"
  },
  {
    "codigo":716274007,
    "descripcion":"CARCINOMA BASOCELULAR NODULAR DE PIEL"
  },
  {
    "codigo":59079001,
    "descripcion":"DIABETES MELLITUS ASOCIADA CON UNA ETIOLOGÍA HORMONAL"
  },
  {
    "codigo":124615003,
    "descripcion":"DEFICIENCIA DE CARBONATO DEHIDRATASA"
  },
  {
    "codigo":91847004,
    "descripcion":"SITIO DE OSIFICACIÓN ACCESORIA DE LA VÉRTEBRA ESTERNAL"
  },
  {
    "codigo":303861000119106,
    "descripcion":"CONDROMALACIA DE RÓTULA IZQUIERDA"
  },
  {
    "codigo":1204124006,
    "descripcion":"ARRITMIA CARDÍACA DEBIDA A ESPASMO DE ARTERIA CORONARIA"
  },
  {
    "codigo":253852007,
    "descripcion":"PENE MEMBRANOSO"
  },
  {
    "codigo":286620007,
    "descripcion":"LACERACIÓN DEL PALADAR"
  },
  {
    "codigo":448625006,
    "descripcion":"CONEXIÓN AURICULOVENTRICULAR UNIVENTRICULAR CON CONEXIÓN AURICULOVENTRICULAR DEL LADO IZQUIERDO AUSENTE"
  },
  {
    "codigo":282950003,
    "descripcion":"SE INCLINA PARA TOCARSE LOS PIES"
  },
  {
    "codigo":16006031000119103,
    "descripcion":"TROMBOFLEBITIS DE VENA DE MIEMBRO SUPERIOR DERECHO"
  },
  {
    "codigo":414022008,
    "descripcion":"TRASTORNO DE COMPONENTE CELULAR SANGUÍNEO"
  },
  {
    "codigo":1264155005,
    "descripcion":"TRASTORNO METABÓLICO POSTERIOR A EMBARAZO ECTÓPICO"
  },
  {
    "codigo":444955006,
    "descripcion":"RIÑÓN DERECHO PRESENTE"
  },
  {
    "codigo":443120002,
    "descripcion":"INFLAMACIÓN DE LIGAMENTO"
  },
  {
    "codigo":686991000119106,
    "descripcion":"MICOSIS FUNGOIDE DE GANGLIO LINFÁTICO DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":836336007,
    "descripcion":"AGUDEZA VISUAL DE OJO IZQUIERDO 6\/6"
  },
  {
    "codigo":17136009,
    "descripcion":"TUBERCULOSIS DE LA RODILLA"
  },
  {
    "codigo":408517002,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: TAGALOG"
  },
  {
    "codigo":703429003,
    "descripcion":"GLIOMA ÓPTICO MALIGNO DE LA VIDA ADULTA"
  },
  {
    "codigo":48069004,
    "descripcion":"ACROCEFALIA"
  },
  {
    "codigo":211909003,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO PROFUNDA DE PULGAR"
  },
  {
    "codigo":441285006,
    "descripcion":"DILATACIÓN QUÍSTICA ADQUIRIDA DE COLÉDOCO"
  },
  {
    "codigo":13466009,
    "descripcion":"ÍLEO DINÁMICO"
  },
  {
    "codigo":699759003,
    "descripcion":"RETINITIS PERIFÉRICA FOCAL"
  },
  {
    "codigo":239172000,
    "descripcion":"CICATRIZ ATRÓFICA"
  },
  {
    "codigo":332841000119105,
    "descripcion":"PSEUDOPTERIGIÓN DE OJO DERECHO"
  },
  {
    "codigo":370244001,
    "descripcion":"LACERACIÓN SUPERFICIAL DE MANO"
  },
  {
    "codigo":697924002,
    "descripcion":"HIPERTENSIÓN PULMONAR EN NEUROFIBROMATOSIS"
  },
  {
    "codigo":403012004,
    "descripcion":"TIÑA DE CUERO CABELLUDO CAUSADA POR MICROSPORUM NANUM"
  },
  {
    "codigo":763460007,
    "descripcion":"ENFERMEDAD DE CHARCOT-MARIE-TOOTH LIGADA AL CROMOSOMA X TIPO 5"
  },
  {
    "codigo":1254980009,
    "descripcion":"INTOXICACIÓN AUTOINFLIGIDA CON HERBICIDA"
  },
  {
    "codigo":237337003,
    "descripcion":"AFRIBINOGENEMIA - POSPARTO"
  },
  {
    "codigo":270105004,
    "descripcion":"INFORME FORENSE - PAGADO"
  },
  {
    "codigo":302873008,
    "descripcion":"PÚRPURA TROMBOCITOPÉNICA"
  },
  {
    "codigo":366574000,
    "descripcion":"AMPLITUD DE LA ROTACIÓN INTERNA DE LA CADERA - HALLAZGO"
  },
  {
    "codigo":202734002,
    "descripcion":"DISCO DORSAL PROLAPSADO CON COMPRESIÓN RADICULAR"
  },
  {
    "codigo":364739001,
    "descripcion":"TIEMPO DE GESTACIÓN AL MOMENTO DEL PARTO - HALLAZGO"
  },
  {
    "codigo":69827001,
    "descripcion":"DERMATITIS DE CONTACTO CAUSADA POR RAYOS X"
  },
  {
    "codigo":102595002,
    "descripcion":"OLOR DESAGRADABLE DE LA AXILA"
  },
  {
    "codigo":233667003,
    "descripcion":"SÍNDROME DE DESORIENTACIÓN CILIAR, DE RUTLAND"
  },
  {
    "codigo":266435005,
    "descripcion":"ENFERMEDAD POR REFLUJO GASTROESOFÁGICO SIN ESOFAGITIS"
  },
  {
    "codigo":397507007,
    "descripcion":"IMPLANTES DE TUMOR NO INVASIVO (EPITELIAL) DE OVARIO EN EPIPLÓN, PRESENTES"
  },
  {
    "codigo":35224002,
    "descripcion":"INTOXICACIÓN CAUSADA POR SULFAFURAZOL"
  },
  {
    "codigo":788888004,
    "descripcion":"INFLAMACIÓN CRÓNICA DE GANGLIO LINFÁTICO AXILAR"
  },
  {
    "codigo":67992007,
    "descripcion":"OBSTRUCCIÓN MÚLTIPLE Y BILATERAL DE LA ARTERIA CEREBRAL ANTERIOR"
  },
  {
    "codigo":295533001,
    "descripcion":"SOBREDOSIS DE HALOTANO"
  },
  {
    "codigo":231832009,
    "descripcion":"CARCINOMA BASOCELULAR DE PÁRPADO"
  },
  {
    "codigo":262765004,
    "descripcion":"FÍSTULA PERILINFÁTICA TRAUMÁTICA"
  },
  {
    "codigo":721517006,
    "descripcion":"SÍNDROME DEL CORDÓN POSTERIOR DE MÉDULA ESPINAL LUMBAR"
  },
  {
    "codigo":228162002,
    "descripcion":"ESTADO DE LA SOLICITUD PARA SUBSIDIO"
  },
  {
    "codigo":689501000119103,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE VESTÍBULO DE LA BOCA"
  },
  {
    "codigo":422935003,
    "descripcion":"PELIGROS BIOLÓGICOS EN EL AMBIENTE"
  },
  {
    "codigo":160791005,
    "descripcion":"TRÁMITES DE DIVORCIO PENDIENTES"
  },
  {
    "codigo":95255005,
    "descripcion":"HIPOTONÍA SECUNDARIA DEL OJO"
  },
  {
    "codigo":717847008,
    "descripcion":"ENFERMEDAD POR REFLUJO GASTROESOFÁGICO EROSIVA"
  },
  {
    "codigo":60652005,
    "descripcion":"QUISTE CONGÉNITO DEL MEDIASTINO"
  },
  {
    "codigo":12240221000119106,
    "descripcion":"MASA DE MAMA DERECHA"
  },
  {
    "codigo":191724005,
    "descripcion":"FOBIA SOCIAL, MIEDO A COMER EN PÚBLICO"
  },
  {
    "codigo":224492007,
    "descripcion":"CUIDADOR COMPROMETIDO A ASISTIR"
  },
  {
    "codigo":93420009,
    "descripcion":"GINGIVITIS EN ROLLOS DE ALGODÓN"
  },
  {
    "codigo":598071000005103,
    "descripcion":"DEJÓ DE FUMAR EN EL PRIMER TRIMESTRE"
  },
  {
    "codigo":188054000,
    "descripcion":"MELANOMA MALIGNO DE PERINEO"
  },
  {
    "codigo":1269398002,
    "descripcion":"HIPERSENSIBILIDAD A MINOCICLINA"
  },
  {
    "codigo":15975701000119100,
    "descripcion":"MASA DE TEJIDO SUBCUTÁNEO DE AMBOS PULGARES"
  },
  {
    "codigo":417430008,
    "descripcion":"ADULTO VULNERABLE"
  },
  {
    "codigo":415595001,
    "descripcion":"EVENTRACIÓN ESTRANGULADA DE PARED ABDOMINAL ANTERIOR"
  },
  {
    "codigo":284523002,
    "descripcion":"TOS PERSISTENTE"
  },
  {
    "codigo":87915002,
    "descripcion":"CASADO"
  },
  {
    "codigo":253590009,
    "descripcion":"ATRESIA PULMONAR CON TABIQUE VENTRICULAR INTACTO"
  },
  {
    "codigo":251755005,
    "descripcion":"DIPLOPÍA HOMÓNIMA"
  },
  {
    "codigo":335351000119105,
    "descripcion":"PTERIGIÓN DOBLE DE OJO DERECHO"
  },
  {
    "codigo":53312001,
    "descripcion":"VASCULITIS DE LA PIEL"
  },
  {
    "codigo":315456001,
    "descripcion":"NACIDO EN KENIA"
  },
  {
    "codigo":413760003,
    "descripcion":"CUIDADOR DE PERSONA CON ENFERMEDAD CRÓNICA"
  },
  {
    "codigo":282688004,
    "descripcion":"DIFICULTAD PARA EMPUJAR Y ARRASTRAR UN OBJETO GRANDE POR EL PISO"
  },
  {
    "codigo":708672004,
    "descripcion":"ODONTOHIPOFOSFATASIA"
  },
  {
    "codigo":18890001000004102,
    "descripcion":"FRACTURA FACIAL DEBIDA A CAÍDA"
  },
  {
    "codigo":14090001000004102,
    "descripcion":"DOLOR NEUROPÁTICO CAUSADO POR RADIACIÓN"
  },
  {
    "codigo":1003584006,
    "descripcion":"LACERACIÓN DEL ROMBENCÉFALO CON HERIDA INTRACRANEAL ABIERTA Y PÉRDIDA DE LA CONSCIENCIA"
  },
  {
    "codigo":774208009,
    "descripcion":"SÍNDROME DE NEVO SEBÁCEO, MALFORMACIONES DEL SISTEMA NERVIOSO CENTRAL, APLASIA CUTÁNEA CONGÉNITA, QUISTE DERMOIDE DEL LIMBO ESCLERO-CORNEAL Y NEVO PIGMENTARIO"
  },
  {
    "codigo":870677001,
    "descripcion":"REACCIÓN ADVERSA A BENZODIAZEPINA"
  },
  {
    "codigo":444693004,
    "descripcion":"DEFORMIDAD TORÁCICA"
  },
  {
    "codigo":28490001000004108,
    "descripcion":"FRACTURA POR COMPRESIÓN DE SEGUNDA VÉRTEBRA LUMBAR"
  },
  {
    "codigo":84245004,
    "descripcion":"INFERTILIDAD SECUNDARIA A CAUSA EXTRATESTICULAR"
  },
  {
    "codigo":248085007,
    "descripcion":"FALTA DE SENTIDO COMÚN ACERCA DEL PELIGRO"
  },
  {
    "codigo":11777681000119102,
    "descripcion":"RUPTURA TRAUMÁTICA DE TENDÓN DE MÚSCULO INFRAESPINOSO DERECHO"
  },
  {
    "codigo":51477005,
    "descripcion":"SEDUCCIÓN"
  },
  {
    "codigo":442858008,
    "descripcion":"INFECCIÓN DE SITIO DE GASTROSTOMÍA"
  },
  {
    "codigo":47807003,
    "descripcion":"HABRONEMIASIS CUTÁNEA"
  },
  {
    "codigo":703167007,
    "descripcion":"ESTENOSIS DE PRÓTESIS DE VÁLVULA MITRAL"
  },
  {
    "codigo":1260223009,
    "descripcion":"TATUAJE DE COLOR VERDE DE TEJIDO BLANDO BUCAL"
  },
  {
    "codigo":735935009,
    "descripcion":"DOLOR CRÓNICO DEBIDO A ENFERMEDAD NEOPLÁSICA MALIGNA"
  },
  {
    "codigo":111508004,
    "descripcion":"DISTROFIA MUSCULAR DE EMERY - DREIFUSS"
  },
  {
    "codigo":275348004,
    "descripcion":"ADACTILIA"
  },
  {
    "codigo":209812006,
    "descripcion":"ESGUINCE, SÍNFISIS DEL PUBIS"
  },
  {
    "codigo":78740005,
    "descripcion":"MONOSOMÍA 21 COMPLETA"
  },
  {
    "codigo":44137000,
    "descripcion":"INTOXICACIÓN POR DAPHNE"
  },
  {
    "codigo":207977001,
    "descripcion":"FRACTURA EXPUESTA DEL SACRO"
  },
  {
    "codigo":15709841000119107,
    "descripcion":"HEMANGIOMA DE COROIDES IZQUIERDA"
  },
  {
    "codigo":240745006,
    "descripcion":"HISTOPLASMOSIS CUTÁNEA PRIMARIA"
  },
  {
    "codigo":371817007,
    "descripcion":"RUPTURA AGUDA DEL TABIQUE INTERVENTRICULAR"
  },
  {
    "codigo":1156414004,
    "descripcion":"GLIOBLASTOMA DE CÉLULAS GIGANTES DE CEREBRO"
  },
  {
    "codigo":75070005,
    "descripcion":"INFECCIÓN CAUSADA POR OPHRYOSCOLEX"
  },
  {
    "codigo":271678007,
    "descripcion":"MOVIMIENTO INTRA-ABDOMINAL"
  },
  {
    "codigo":402750008,
    "descripcion":"DERMATOSIS AMPOLLAR PRECIPITADA POR TRATAMIENTO FARMACOLÓGICO"
  },
  {
    "codigo":238910008,
    "descripcion":"ENFERMEDAD DE LA PIEL DEL OMBLIGO"
  },
  {
    "codigo":1285651000,
    "descripcion":"HERIDA DE REGIÓN DE RODILLA POR MORDEDURA"
  },
  {
    "codigo":73235004,
    "descripcion":"ENTERITIS ISQUÉMICA CRÓNICA"
  },
  {
    "codigo":7699004,
    "descripcion":"INFLAMACIÓN ADHESIVA DEL OÍDO MEDIO"
  },
  {
    "codigo":237075006,
    "descripcion":"INCARCERACIÓN UTERINA"
  },
  {
    "codigo":40467008,
    "descripcion":"MANCHA MONGOLOIDE"
  },
  {
    "codigo":43031000087105,
    "descripcion":"HEMATOMA DE ANTEBRAZO DERECHO"
  },
  {
    "codigo":48151000087106,
    "descripcion":"FRACTURA DE QUINTO HUESO METATARSIANO DE PIE DERECHO"
  },
  {
    "codigo":38632003,
    "descripcion":"TEJIDO HIPOFISARIO FARÍNGEO"
  },
  {
    "codigo":40471000087108,
    "descripcion":"CUERPO EXTRAÑO EN PABELLÓN AURICULAR DERECHO"
  },
  {
    "codigo":300776002,
    "descripcion":"JUEGA"
  },
  {
    "codigo":366312005,
    "descripcion":"HALLAZGO RELACIONADO CON LA POSICIÓN DEL CUELLO DE ÚTERO GRÁVIDO"
  },
  {
    "codigo":724925000,
    "descripcion":"DISTENSIÓN DE FASCIA DE BÍCEPS BRAQUIAL"
  },
  {
    "codigo":202472008,
    "descripcion":"DOLOR DE ARTICULACIÓN DE MANO"
  },
  {
    "codigo":298941006,
    "descripcion":"TUMEFACCIÓN DE ARTICULACIÓN DE MUÑECA"
  },
  {
    "codigo":297106006,
    "descripcion":"INFERTILIDAD PRIMARIA"
  },
  {
    "codigo":723090006,
    "descripcion":"INFECCIÓN DE VAGINA CAUSADA POR VIRUS HERPES SIMPLE HUMANO"
  },
  {
    "codigo":67730008,
    "descripcion":"FRACTURA DE BENNETT NO EXPUESTA"
  },
  {
    "codigo":721255002,
    "descripcion":"ENFERMEDAD POR PRIONES ADQUIRIDA"
  },
  {
    "codigo":359007,
    "descripcion":"KERNICTERUS POR ISOINMUNIZACIÓN"
  },
  {
    "codigo":64060000,
    "descripcion":"TRASTORNO DE PÁNICO CON AGORAFOBIA, EVITACIÓN AGORAFÓBICA MODERADA Y ATAQUES DE PÁNICO EN REMISIÓN TOTAL"
  },
  {
    "codigo":295271008,
    "descripcion":"SOBREDOSIS DE NABUMETONA"
  },
  {
    "codigo":337861000119106,
    "descripcion":"ESCLEROPERIQUERATITIS IZQUIERDA"
  },
  {
    "codigo":293436009,
    "descripcion":"REACCIÓN ADVERSA A FÁRMACO ANTIARRÍTMICO"
  },
  {
    "codigo":94993004,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA PELVIS"
  },
  {
    "codigo":93158001,
    "descripcion":"LIPOMA DE ÓRGANOS INTRATORÁCICOS"
  },
  {
    "codigo":1075141000119109,
    "descripcion":"HALLUX LIMITUS ADQUIRIDO IZQUIERDO"
  },
  {
    "codigo":419003001,
    "descripcion":"HALLAZGO RELACIONADO CON EL MUSLO"
  },
  {
    "codigo":289766009,
    "descripcion":"HALLAZGO RELACIONADO CON EL ESPESOR DEL CUELLO UTERINO"
  },
  {
    "codigo":1010662009,
    "descripcion":"INFECCIÓN PULMONAR POR MYCOBACTERIUM KANSASII"
  },
  {
    "codigo":255163006,
    "descripcion":"PAPILOMA BENIGNO DE LARINGE"
  },
  {
    "codigo":286096006,
    "descripcion":"NO TIRA LA BASURA DOMICILIARIA"
  },
  {
    "codigo":89488007,
    "descripcion":"TRASTORNO NASAL"
  },
  {
    "codigo":284261000,
    "descripcion":"NO AGARRA"
  },
  {
    "codigo":253328009,
    "descripcion":"SENO CORONARIO HACIA FÍSTULA DE VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":187792009,
    "descripcion":"NEOPLASIA MALIGNA DE COLA DE PÁNCREAS"
  },
  {
    "codigo":251493004,
    "descripcion":"REDUCCIÓN FOCAL DE LA ACTIVIDAD DEL ELECTROENCEFALOGRAMA"
  },
  {
    "codigo":185957008,
    "descripcion":"A LA ESPERA DE MEJORA EN VIVIENDA"
  },
  {
    "codigo":53050002,
    "descripcion":"TRASTORNOS MENTALES ORGÁNICOS INDUCIDOS POR ALUCINÓGENOS"
  },
  {
    "codigo":413498004,
    "descripcion":"SOCIEDAD ESTADOUNIDENSE DE ANESTESISTAS - ESTADO FÍSICO CLASE 4"
  },
  {
    "codigo":184122004,
    "descripcion":"NÚMERO DEL PACIENTE EN EL HOSPITAL - DESCONOCIDO"
  },
  {
    "codigo":249658006,
    "descripcion":"HEMORROIDE GANGRENOSA"
  },
  {
    "codigo":1003322006,
    "descripcion":"DELECIÓN DISTAL DEL BRAZO CORTO DEL CROMOSOMA 3"
  },
  {
    "codigo":247823001,
    "descripcion":"MIEDO A PERDER EL CONTROL DE LAS EMOCIONES"
  },
  {
    "codigo":1263631006,
    "descripcion":"TRASTORNO FETAL DEBIDO A POSICIÓN TRANSVERSA"
  },
  {
    "codigo":313359006,
    "descripcion":"HERNIA PARAUMBILICAL ESTRANGULADA"
  },
  {
    "codigo":213220000,
    "descripcion":"TROMBOSIS VENOSA PROFUNDA EN EL POSOPERATORIO"
  },
  {
    "codigo":1163492007,
    "descripcion":"GASTRITIS POR MYCOBACTERIUM AVIUM-INTRACELLULARE"
  },
  {
    "codigo":80313002,
    "descripcion":"PALPITACIONES"
  },
  {
    "codigo":211385004,
    "descripcion":"LESIONES SUPERFICIALES MÚLTIPLES EN TOBILLO Y PIE"
  },
  {
    "codigo":735673006,
    "descripcion":"LESIÓN TRAUMÁTICA DE BOLSA SEROSA DE RODILLA"
  },
  {
    "codigo":15685881000119109,
    "descripcion":"RETINITIS DE AMBOS OJOS"
  },
  {
    "codigo":111246005,
    "descripcion":"ARTROGRIPOSIS"
  },
  {
    "codigo":209550007,
    "descripcion":"ESGUINCE DE LIGAMENTO SACROILÍACO POSTERIOR"
  },
  {
    "codigo":78478008,
    "descripcion":"FRAMBESIOMA"
  },
  {
    "codigo":240483006,
    "descripcion":"SARAMPIÓN ATÍPICO"
  },
  {
    "codigo":109411007,
    "descripcion":"DISOSTOSIS FRONTONASOETMOIDAL"
  },
  {
    "codigo":9272000,
    "descripcion":"VACÍA EL INTESTINO COMPLETAMENTE"
  },
  {
    "codigo":699235009,
    "descripcion":"PERITONITIS ASOCIADA CON DIÁLISIS PERITONEAL CONTINUA AMBULATORIA"
  },
  {
    "codigo":238648000,
    "descripcion":"LIQUEN PLANO ZOSTERIFORME"
  },
  {
    "codigo":402488006,
    "descripcion":"CALCINOSIS DENTRO DE UN HEMATOMA"
  },
  {
    "codigo":74808006,
    "descripcion":"DESVIACIÓN ADQUIRIDA DEL TABIQUE NASAL"
  },
  {
    "codigo":369720008,
    "descripcion":"G1: NÚCLEOS REDONDOS, UNIFORMES, DE 10 Μ APROXIMADAMENTE; NUCLÉOLOS POCO VISIBLES O AUSENTES"
  },
  {
    "codigo":236813004,
    "descripcion":"HIPOFUNCIÓN TESTICULAR POSQUIMIOTERAPIA"
  },
  {
    "codigo":269581007,
    "descripcion":"MELANOMA MALIGNO DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":313901000119102,
    "descripcion":"ATROFIA DE MÚSCULO DE PIERNA DERECHA"
  },
  {
    "codigo":5602001,
    "descripcion":"PATRÓN DE USO NOCIVO DE OPIOIDE"
  },
  {
    "codigo":234978004,
    "descripcion":"ALTERACIÓN DE LA COLORACIÓN DENTAL"
  },
  {
    "codigo":300514006,
    "descripcion":"FÍSTULA DE PENE"
  },
  {
    "codigo":202210006,
    "descripcion":"LUXACIÓN ANTERIOR RECURRENTE DE HOMBRO"
  },
  {
    "codigo":366050009,
    "descripcion":"ACCESO AL FONDO DE SACO LAGRIMAL - HALLAZGO"
  },
  {
    "codigo":298679003,
    "descripcion":"COLUMNA LUMBAR CALIENTE AL TACTO"
  },
  {
    "codigo":429751004,
    "descripcion":"ANAFILAXIA CAUSADA POR FRUTA"
  },
  {
    "codigo":396983005,
    "descripcion":"CARACTERÍSTICAS HISTOLÓGICAS TUMORALES NO PUEDEN SER DETERMINADAS"
  },
  {
    "codigo":36535003,
    "descripcion":"RETINOCOROIDITIS Y RETINITIS FOCAL PERIFÉRICA"
  },
  {
    "codigo":16206381000119105,
    "descripcion":"COMPRESIÓN DE AMBOS NERVIOS CUBITALES"
  },
  {
    "codigo":167607009,
    "descripcion":"HECES AMARILLAS"
  },
  {
    "codigo":1279884000,
    "descripcion":"DISTROFIA MUSCULAR DE CINTURAS R24 ASOCIADA AL GEN POMGNT2"
  },
  {
    "codigo":722828003,
    "descripcion":"SARCOMA SINOVIAL PRIMARIO DE ÓRGANO INTRATORÁCICO"
  },
  {
    "codigo":427916006,
    "descripcion":"ABSCESO EN ESPACIO EPIDURAL DORSAL"
  },
  {
    "codigo":165772007,
    "descripcion":"PRUEBA DE COOMBS DIRECTA NEGATIVA"
  },
  {
    "codigo":32865001,
    "descripcion":"ADHERENCIAS POSTOPERATORIAS DE LA VAGINA"
  },
  {
    "codigo":295009002,
    "descripcion":"ALERGIA A ESPIRONOLACTONA"
  },
  {
    "codigo":262241003,
    "descripcion":"NO EMPARENTADO"
  },
  {
    "codigo":131169006,
    "descripcion":"GRUPO SANGUÍNEO O>HM<^B^"
  },
  {
    "codigo":1343585008,
    "descripcion":"PATRÓN DE USO NOCIVO DE TABACO EN LA MADRE"
  },
  {
    "codigo":719158007,
    "descripcion":"SINDACTILIA TIPO 4"
  },
  {
    "codigo":422411000,
    "descripcion":"CICATRIZ QUIRÚRGICA"
  },
  {
    "codigo":293174009,
    "descripcion":"REACCIÓN ADVERSA A LA TRIAMCINOLONA"
  },
  {
    "codigo":1208843003,
    "descripcion":"INSUFICIENCIA VENTRICULAR DERECHA POR VALVULOPATÍA CARDÍACA"
  },
  {
    "codigo":291339007,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR CLORFENAMINA"
  },
  {
    "codigo":225803008,
    "descripcion":"DOMINADO POR PROFESIONALES"
  },
  {
    "codigo":94731009,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA MÉDULA SUPRARRENAL"
  },
  {
    "codigo":125664002,
    "descripcion":"HERIDA ABIERTA DE DEDO DE PIE"
  },
  {
    "codigo":92896007,
    "descripcion":"FORMA ANORMAL CONGÉNITA DE HUESO BASIESFENOIDAL"
  },
  {
    "codigo":254901000,
    "descripcion":"NEOPLASIA INTRAEPITELIAL PROSTÁTICA"
  },
  {
    "codigo":1010400009,
    "descripcion":"SUSCEPTIBILIDAD GENÉTICA A HIPERTERMIA MALIGNA DEBIDA A MUTACIÓN DE GEN DE RECEPTOR 1 DE RIANODINA"
  },
  {
    "codigo":189365006,
    "descripcion":"NEOPLASIA DE GLÁNDULA SUBMAXILAR, DE COMPORTAMIENTO INCIERTO"
  },
  {
    "codigo":271112004,
    "descripcion":"AMPOLLA TRAUMÁTICA DE LA CARA, INFECTADA"
  },
  {
    "codigo":285834000,
    "descripcion":"LESIÓN TRAUMÁTICA DEL LIGAMENTO ANCHO"
  },
  {
    "codigo":1172405007,
    "descripcion":"HORMONAS SEXUALES MASCULINAS SÉRICAS DENTRO DE RANGO DE REFERENCIA"
  },
  {
    "codigo":56458007,
    "descripcion":"RUPTURA ANTIGUA DE LIGAMENTO DE LA RODILLA, EXCEPTO DE LOS LIGAMENTOS COLATERALES Y\/O CRUZADOS"
  },
  {
    "codigo":185695000,
    "descripcion":"CRIBADO EN ADULTO MAYOR - ATENDIDO"
  },
  {
    "codigo":251231001,
    "descripcion":"ALTURA DE LA ONDA S AUMENTADA"
  },
  {
    "codigo":283999006,
    "descripcion":"LESIÓN TRAUMÁTICA DE ÓRGANO SENSITIVO"
  },
  {
    "codigo":447839006,
    "descripcion":"ATRESIA PULMONAR Y DEFECTO DEL TABIQUE INTERVENTRICULAR CON SALIDA DE AORTA DESDE EL VENTRÍCULO DERECHO"
  },
  {
    "codigo":249396000,
    "descripcion":"AMÍGDALAS QUE SE ENCUENTRAN EN LA LÍNEA MEDIA"
  },
  {
    "codigo":413236001,
    "descripcion":"TUBO DE GASTROSTOMÍA PERCUTÁNEA ENDOSCÓPICA REMOVIBLE INTERNAMENTE"
  },
  {
    "codigo":282164002,
    "descripcion":"NO CAMINA PENDIENTE ABAJO"
  },
  {
    "codigo":83721006,
    "descripcion":"SÍNDROME DE TRISOMÍA PARCIAL 6P"
  },
  {
    "codigo":247561007,
    "descripcion":"PELO DESGASTADO"
  },
  {
    "codigo":16350000,
    "descripcion":"MÁCULA CORNEAL QUE INTERFIERE CON LA VISIÓN CENTRAL"
  },
  {
    "codigo":409566007,
    "descripcion":"BOTULISMO TRANSMITIDO POR LOS ALIMENTOS, TIPO E"
  },
  {
    "codigo":473267002,
    "descripcion":"QUEMADURA DE MÚLTIPLES SITIOS DE LA MUÑECA"
  },
  {
    "codigo":12113841000119100,
    "descripcion":"QUEMADURA QUÍMICA DE CABEZA"
  },
  {
    "codigo":1077681000119100,
    "descripcion":"OSTEOMIELITIS DE RADIO IZQUIERDO"
  },
  {
    "codigo":312241000119102,
    "descripcion":"ENFERMEDAD DE KASHIN-BECK DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":15743921000119103,
    "descripcion":"MASA DE ARTICULACIÓN DE CADERA IZQUIERDA"
  },
  {
    "codigo":1085361000119104,
    "descripcion":"MENINGITIS DEBIDA A MONONUCLEOSIS POR CITOMEGALOVIRUS"
  },
  {
    "codigo":680881000119104,
    "descripcion":"HIPOTRICOSIS DE PÁRPADO IZQUIERDO"
  },
  {
    "codigo":340401000119105,
    "descripcion":"EDEMA CORNEAL IDIOPÁTICO DE OJO IZQUIERDO"
  },
  {
    "codigo":15685041000119107,
    "descripcion":"PERIOSTITIS DE FÉMUR DERECHO"
  },
  {
    "codigo":16650161000119108,
    "descripcion":"LESIÓN DE RAÍZ DE NERVIO VERTEBRAL CERVICAL DERECHO"
  },
  {
    "codigo":274824005,
    "descripcion":"PTOSIS AUSENTE"
  },
  {
    "codigo":335281000119107,
    "descripcion":"EPÍFORA DE OJO DERECHO"
  },
  {
    "codigo":117681000119102,
    "descripcion":"ENFERMEDAD RENAL CRÓNICA EN ESTADIO 1 DEBIDA A HIPERTENSIÓN"
  },
  {
    "codigo":11791281000119103,
    "descripcion":"LESIÓN TRAUMÁTICA DE MANO DERECHA"
  },
  {
    "codigo":309681000119104,
    "descripcion":"GOTA PRIMARIA CRÓNICA DE CODO, SIN TOFO"
  },
  {
    "codigo":373128001,
    "descripcion":"CÁMARA CARDÍACA NOTABLEMENTE AGRANDADA"
  },
  {
    "codigo":16583601000119107,
    "descripcion":"QUISTE SINOVIAL DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":11996081000119108,
    "descripcion":"INFECCIÓN DE MUÑÓN DE AMPUTACIÓN DE EXTREMIDAD INFERIOR IZQUIERDA"
  },
  {
    "codigo":348081000119109,
    "descripcion":"SÍNDROME DE DISPERSIÓN PIGMENTARIA DE OJO DERECHO"
  },
  {
    "codigo":66481000119109,
    "descripcion":"PORTADOR DE HIPERCOLESTEROLEMIA FAMILIAR"
  },
  {
    "codigo":307592006,
    "descripcion":"LEUCEMIA BASÓFILA"
  },
  {
    "codigo":240221008,
    "descripcion":"ESPONDILÓLISIS"
  },
  {
    "codigo":762674000,
    "descripcion":"DESPLAZAMIENTO DE DISCO DE ARTICULACIÓN TEMPOROMANDIBULAR SIN REDUCCIÓN CON APERTURA LIMITADA"
  },
  {
    "codigo":271154001,
    "descripcion":"AMPOLLA TRAUMÁTICA DE HOMBRO, INFECTADA"
  },
  {
    "codigo":238386003,
    "descripcion":"ABSCESO DE DORSO DE MANO"
  },
  {
    "codigo":10939541000119102,
    "descripcion":"HERIDA ABIERTA DE REGIÓN DE HOMBRO DERECHO"
  },
  {
    "codigo":402226005,
    "descripcion":"ECCEMA DE MANO VESICULOESCAMOSO CRÓNICO RECURRENTE"
  },
  {
    "codigo":860978005,
    "descripcion":"ÚLCERA DE PIE IZQUIERDO DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":404061009,
    "descripcion":"LIPOMA ORAL"
  },
  {
    "codigo":15936661000119103,
    "descripcion":"ERISIPELA DE AMBAS EXTREMIDADES INFERIORES"
  },
  {
    "codigo":1186823002,
    "descripcion":"TRASTORNO DEL DESARROLLO ACADÉMICO DE CAUSA NUTRICIONAL"
  },
  {
    "codigo":433159008,
    "descripcion":"DOLOR AGUDO EN PELVIS FEMENINA"
  },
  {
    "codigo":302087009,
    "descripcion":"ESTADIO 5 DEL TANNER DE VELLO AXILAR"
  },
  {
    "codigo":236551009,
    "descripcion":"DIÁLISIS INSUFICIENTE"
  },
  {
    "codigo":105479008,
    "descripcion":"AUSENTISMO ESCOLAR INJUSTIFICADO"
  },
  {
    "codigo":201948005,
    "descripcion":"ARTROPATÍA TRAUMÁTICA DE ARTICULACIÓN INTERFALÁNGICA PROXIMAL DE DEDO DE LA MANO"
  },
  {
    "codigo":167345002,
    "descripcion":"MICROSCOPIA DE ORINA: CRISTALES DE CISTEÍNA"
  },
  {
    "codigo":99631000119101,
    "descripcion":"INFECCIÓN DE LA VÍA URINARIA FEBRIL"
  },
  {
    "codigo":298417002,
    "descripcion":"AMPLITUD DE EXTENSIÓN ACTIVA DE LA COLUMNA CERVICAL NORMAL"
  },
  {
    "codigo":1670004,
    "descripcion":"HEMIPARESIA CEREBRAL"
  },
  {
    "codigo":296582005,
    "descripcion":"SOBREDOSIS DE TIABENDAZOL"
  },
  {
    "codigo":345391000119104,
    "descripcion":"FRAGMENTO DE LENTE PARA CATARATAS EN VÍTREO DE AMBOS OJOS DEBIDO A CIRUGÍA DE CATARATAS Y POSTERIOR A ELLA"
  },
  {
    "codigo":720731004,
    "descripcion":"QUISTE Y TROFOZOÍTO DE ENTAMOEBA HARTMANNI"
  },
  {
    "codigo":718896000,
    "descripcion":"SÍNDROME RECESIVO DE DISCAPACIDAD INTELECTUAL Y MACROCEFALIA CON DISFUNCIÓN CILIAR LIGADO AL CROMOSOMA X"
  },
  {
    "codigo":294747009,
    "descripcion":"ALERGIA A DIDROGESTERONA"
  },
  {
    "codigo":1144880000,
    "descripcion":"HIPOPLASIA CONGÉNITA DE GLÁNDULA SUDORÍPARA"
  },
  {
    "codigo":17711000119106,
    "descripcion":"VEJIGA URINARIA NO DISTENSIBLE"
  },
  {
    "codigo":129072006,
    "descripcion":"INDEPENDENCIA PARA REALIZAR LAS TAREAS DOMÉSTICAS"
  },
  {
    "codigo":161840007,
    "descripcion":"PROBLEMA ALIMENTARIO POR ENFERMEDAD"
  },
  {
    "codigo":292912007,
    "descripcion":"REACCIÓN ADVERSA AL PIRANTEL"
  },
  {
    "codigo":94469000,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LOS GANGLIOS LINFÁTICOS PARAVAGINALES"
  },
  {
    "codigo":717061002,
    "descripcion":"LIQUEN PLANO PIGMENTOSO"
  },
  {
    "codigo":782597003,
    "descripcion":"ALERGIA A HORMONA TIROIDEA"
  },
  {
    "codigo":61701006,
    "descripcion":"INSUFICIENCIA HIPOFISARIA LINFOCÍTICA"
  },
  {
    "codigo":1306885007,
    "descripcion":"GLAUCOMA PRIMARIO DE ÁNGULO ABIERTO CON PRESIÓN NORMAL DE OJO DERECHO"
  },
  {
    "codigo":127237008,
    "descripcion":"NEOPLASIA DE LOS GANGLIOS LINFÁTICOS PAROTÍDEOS"
  },
  {
    "codigo":225541009,
    "descripcion":"GRANULACIÓN DE TEJIDO"
  },
  {
    "codigo":289242002,
    "descripcion":"PÉRDIDA DE SANGRE EN EL TRABAJO DE PARTO - HALLAZGO"
  },
  {
    "codigo":291077009,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR OXAZEPAM"
  },
  {
    "codigo":318921000119103,
    "descripcion":"ARTRITIS REUMATOIDEA SEROPOSITIVA DE ARTICULACIÓN DE CODO DERECHO"
  },
  {
    "codigo":92634009,
    "descripcion":"CARCINOMA IN SITU DE LA LARINGE"
  },
  {
    "codigo":90799002,
    "descripcion":"FRACTURAS MÚLTIPLES DE LA EXTREMIDAD INFERIOR CON COSTILLAS Y ESTERNÓN"
  },
  {
    "codigo":58031004,
    "descripcion":"FARINGITIS SUPURATIVA"
  },
  {
    "codigo":254639005,
    "descripcion":"CARCINOMA IN SITU DE PARÉNQUIMA PULMONAR"
  },
  {
    "codigo":1137540007,
    "descripcion":"CALCIFICACIÓN PUNTEADA DE EPÍFISIS DE HÚMERO"
  },
  {
    "codigo":1332313001,
    "descripcion":"OSTEOPATÍA DE PERONÉ POSTERIOR A POLIOMIELITIS"
  },
  {
    "codigo":283737003,
    "descripcion":"MORDEDURA DE PERRO EN EL CUERO CABELLUDO"
  },
  {
    "codigo":314670002,
    "descripcion":"PESO DEL NIÑO: PERCENTILO 0,4"
  },
  {
    "codigo":52526003,
    "descripcion":"SUDORACIÓN ANORMAL"
  },
  {
    "codigo":773422002,
    "descripcion":"COAGULOPATÍA DEL ESTE DE TEXAS"
  },
  {
    "codigo":609582004,
    "descripcion":"PATEA A OTRA PERSONA"
  },
  {
    "codigo":249134008,
    "descripcion":"LÍQUIDO AMNIÓTICO CON SANGRE"
  },
  {
    "codigo":81624004,
    "descripcion":"PARÁLISIS DE LA FARINGE"
  },
  {
    "codigo":736984007,
    "descripcion":"INFECCIÓN DE TORRENTE SANGUÍNEO ASOCIADA A CATÉTER PARA HEMODIÁLISIS TEMPORARIO IN SITU"
  },
  {
    "codigo":835288007,
    "descripcion":"AGUDEZA VISUAL DE OJO IZQUIERDO 6\/4"
  },
  {
    "codigo":276397000,
    "descripcion":"PASÓ MECONIO"
  },
  {
    "codigo":704216009,
    "descripcion":"FRACTURA EXPUESTA DE QUINTO METACARPIANO"
  },
  {
    "codigo":369587005,
    "descripcion":"TUMOR MALIGNO QUE COMPROMETE LA VULVA POR PROPAGACIÓN DIRECTA DE LA VAGINA"
  },
  {
    "codigo":473005004,
    "descripcion":"ORIGEN ANÓMALO DE LIGAMENTO ARTERIOSO EN DIVERTÍCULO AÓRTICO RETROESOFÁGICO"
  },
  {
    "codigo":702381007,
    "descripcion":"PARÁLISIS HORIZONTAL DE LA MIRADA CON ESCOLIOSIS PROGRESIVA"
  },
  {
    "codigo":1259437007,
    "descripcion":"CARCINOMA PRIMARIO DE UNIÓN RECTOSIGMOIDEA"
  },
  {
    "codigo":733314002,
    "descripcion":"ÚLCERA DE CÓRNEA DEBIDA A DEFICIENCIA DE VITAMINA A"
  },
  {
    "codigo":274562003,
    "descripcion":"AUSENCIA DE CONTRACCIÓN ARTICULAR"
  },
  {
    "codigo":405634003,
    "descripcion":"INFECCIÓN POR STREPTOCOCCUS DEL GRUPO B EN EL LACTANTE - MENOR DE 30 DÍAS"
  },
  {
    "codigo":45186007,
    "descripcion":"PULSO TIBIAL ANORMAL"
  },
  {
    "codigo":239959002,
    "descripcion":"CONTRACTURA DE TENDÓN DE REGIÓN DE HOMBRO"
  },
  {
    "codigo":403799003,
    "descripcion":"HIPERTRICOSIS LANUGINOSA CONGÉNITA"
  },
  {
    "codigo":305495006,
    "descripcion":"BAJO ATENCIÓN DE MÉDICO ESPECIALISTA EN MEDICINA NUCLEAR"
  },
  {
    "codigo":698711007,
    "descripcion":"HEMORRAGIA PREPARTO DEBIDA A PLACENTA PREVIA TIPO IV"
  },
  {
    "codigo":762412000,
    "descripcion":"ERROR DE IMPRONTA MATERNO"
  },
  {
    "codigo":895319009,
    "descripcion":"FORMA DE BALA ANORMAL CONGÉNITA DE FALANGE DE DEDO MEÑIQUE"
  },
  {
    "codigo":8748000,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE CADERA CON INFECCIÓN"
  },
  {
    "codigo":371031006,
    "descripcion":"VENTRICULITIS POR STAPHYLOCOCCUS EPIDERMIDIS"
  },
  {
    "codigo":238124008,
    "descripcion":"DEFICIENCIA DE CINC"
  },
  {
    "codigo":270892009,
    "descripcion":"BACTERIA DETECTADA EN ESPÉCIMEN POR MICROSCOPIA DIRECTA"
  },
  {
    "codigo":6913006,
    "descripcion":"SECRECIÓN DE GLÁNDULA EXOCRINA DISMINUIDA"
  },
  {
    "codigo":170753006,
    "descripcion":"COMPRENDE LA DIETA - DIABETES"
  },
  {
    "codigo":203521008,
    "descripcion":"SEUDOARTROSIS LUEGO DE FUSIÓN O ARTRODESIS"
  },
  {
    "codigo":5078000,
    "descripcion":"SÍNDROME DE SCRIVER - GOLDBLOOM - ROY"
  },
  {
    "codigo":299990002,
    "descripcion":"INFECCIÓN DEL PIE"
  },
  {
    "codigo":234454002,
    "descripcion":"DEFICIENCIA DEL COMPLEJO PROTROMBINA"
  },
  {
    "codigo":269057007,
    "descripcion":"FRACTURA EXPUESTA DE HUESOS MALAR O MAXILAR"
  },
  {
    "codigo":1284865006,
    "descripcion":"CRISIS EPILÉPTICA COGNITIVA DE INICIO FOCAL CON ALTERACIÓN DE MEMORIA"
  },
  {
    "codigo":365526009,
    "descripcion":"DETALLES LABORALES - HALLAZGO"
  },
  {
    "codigo":68779003,
    "descripcion":"NEFROPATÍA PRIMARIA POR IGA"
  },
  {
    "codigo":724139004,
    "descripcion":"SÍNDROME DE MICROTIA, COLOBOMA OCULAR Y CONDUCTO NASOLAGRIMAL IMPERFORADO"
  },
  {
    "codigo":298155004,
    "descripcion":"DERRAME DE ARTICULACIÓN METATARSOFALÁNGICA"
  },
  {
    "codigo":789675009,
    "descripcion":"ACROMATOPSIA COMPLETA"
  },
  {
    "codigo":165248001,
    "descripcion":"NECESITA AYUDA EN LAS ESCALERAS"
  },
  {
    "codigo":230784003,
    "descripcion":"PARÁLISIS SEUDOBULBAR CONGÉNITA"
  },
  {
    "codigo":66944004,
    "descripcion":"TIROIDITIS AUTOINMUNITARIA"
  },
  {
    "codigo":1344896004,
    "descripcion":"OTITIS MEDIA SUPURATIVA DE OÍDO IZQUIERDO"
  },
  {
    "codigo":16050071000119108,
    "descripcion":"ARTRITIS REUMATOIDEA SEROPOSITIVA BILATERAL DE PIE"
  },
  {
    "codigo":720469008,
    "descripcion":"AZOOSPERMIA CAUSADA POR QUIMIOTERAPIA"
  },
  {
    "codigo":294485008,
    "descripcion":"ALERGIA A CINOXACINO"
  },
  {
    "codigo":30506002,
    "descripcion":"LACTANCIA SUPRIMIDA"
  },
  {
    "codigo":718634003,
    "descripcion":"VASCULOPATÍA COLAGENOSA CUTÁNEA"
  },
  {
    "codigo":423722008,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA ELIMINAR LAS AGUAS SERVIDAS DOMÉSTICAS"
  },
  {
    "codigo":290815000,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR BUTRIPTILINA"
  },
  {
    "codigo":94207003,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE VASO SANGUÍNEO DEL TÓRAX"
  },
  {
    "codigo":126975006,
    "descripcion":"NEOPLASIA DEL NERVIO GLOSOFARÍNGEO"
  },
  {
    "codigo":28671007,
    "descripcion":"INFECCIÓN CAUSADA POR ATHESMIA FOXI"
  },
  {
    "codigo":288980000,
    "descripcion":"DIFICULTAD PARA CHUPAR"
  },
  {
    "codigo":190676007,
    "descripcion":"SECUELAS DE LA HIPOVITAMINOSIS A"
  },
  {
    "codigo":156073000,
    "descripcion":"ABORTO ESPONTÁNEO COMPLETO"
  },
  {
    "codigo":92372007,
    "descripcion":"NEOPLASIA BENIGNA DE LA PIEL DE LA NARIZ"
  },
  {
    "codigo":294961000119107,
    "descripcion":"ABSCESO DE HUESO DE SENO PARANASAL"
  },
  {
    "codigo":57769004,
    "descripcion":"DISNEA POSTPRANDIAL"
  },
  {
    "codigo":1237417007,
    "descripcion":"TRASTORNO CONGÉNITO DE GLICOSILACIÓN RELACIONADO CON CARBAMOIL FOSFATO SINTETASA 2, ASPARTATO TRANSCARBAMILASA Y DIHIDROOROTASA"
  },
  {
    "codigo":285310000,
    "descripcion":"CARCINOMA DE CONDUCTO ANAL"
  },
  {
    "codigo":1268350000,
    "descripcion":"CARCINOMA PRIMARIO DE VAGINA"
  },
  {
    "codigo":23166004,
    "descripcion":"CELULITIS DE LA FARINGE"
  },
  {
    "codigo":446856005,
    "descripcion":"QUEMADURA DE SACO CONJUNTIVAL"
  },
  {
    "codigo":283475002,
    "descripcion":"HERIDA POR ARMA BLANCA DE ABDOMEN"
  },
  {
    "codigo":54099005,
    "descripcion":"DIPLEJÍA DE MIEMBROS SUPERIORES"
  },
  {
    "codigo":11819211000119105,
    "descripcion":"ESGUINCE DE LIGAMENTO DE ARTICULACIÓN DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":314408000,
    "descripcion":"INFILTRADO LEUCÉMICO DE LA MEMBRANA COROIDES"
  },
  {
    "codigo":707624002,
    "descripcion":"SIALOFAGIA"
  },
  {
    "codigo":16079051000119106,
    "descripcion":"ÁCIDO DESOXIRRIBONUCLEICO DE PAPILOMAVIRUS HUMANO DE BAJO RIESGO DETECTADO EN ESPÉCIMEN DE ANO"
  },
  {
    "codigo":19496008,
    "descripcion":"CUERPO EXTRAÑO EN LA LARINGE"
  },
  {
    "codigo":1197309002,
    "descripcion":"QUERATOACANTOMAS MÚLTIPLES EN PIEL"
  },
  {
    "codigo":50429003,
    "descripcion":"ESTENOSIS CONGÉNITA DEL ACUEDUCTO DE SILVIO"
  },
  {
    "codigo":1230077009,
    "descripcion":"PATRÓN DE USO NOCIVO CONTINUO DE HIPNÓTICO SIN DEPENDENCIA"
  },
  {
    "codigo":736722003,
    "descripcion":"PRÓTESIS DENTAL COMPLETA CON AUMENTO DE LA DIMENSIÓN DE OCLUSIÓN VERTICAL"
  },
  {
    "codigo":703954005,
    "descripcion":"ASMA ALÉRGICA CAUSADA POR DERMATOPHAGOIDES FARINAE"
  },
  {
    "codigo":1259175002,
    "descripcion":"ADENOCARCINOMA DE CUELLO"
  },
  {
    "codigo":210599007,
    "descripcion":"LESIÓN POR DESOLLAMIENTO DE MÚLTIPLES DEDOS DE MANO"
  },
  {
    "codigo":46759008,
    "descripcion":"INTOXICACIÓN POR SULFAMETOXAZOL"
  },
  {
    "codigo":307068005,
    "descripcion":"CAPAZ DE SOSTENER BEBIDAS"
  },
  {
    "codigo":77692006,
    "descripcion":"HIPERSOMNIA"
  },
  {
    "codigo":700284005,
    "descripcion":"TOXOPLASMOSIS DISEMINADA CONGÉNITA"
  },
  {
    "codigo":75857000,
    "descripcion":"FRACTURA DE RADIO Y CÚBITO"
  },
  {
    "codigo":10321002,
    "descripcion":"ABSCESO DE LA APÓFISIS MASTOIDEA"
  },
  {
    "codigo":237862007,
    "descripcion":"ACIDOSIS RESPIRATORIA Y ACIDOSIS METABÓLICA"
  },
  {
    "codigo":301563003,
    "descripcion":"CAPAZ DE MOVILIZARSE EN LUGARES ABIERTOS"
  },
  {
    "codigo":203259004,
    "descripcion":"PERIOSTITIS DE VÉRTEBRA SACRA SIN OSTEOMIELITIS"
  },
  {
    "codigo":1153531003,
    "descripcion":"FOSFATO INORGÁNICO SÉRICO POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":39419009,
    "descripcion":"CHOQUE HIPOVOLÉMICO"
  },
  {
    "codigo":398032003,
    "descripcion":"HECES DISGREGADAS"
  },
  {
    "codigo":266960003,
    "descripcion":"MAL REGISTRO LABORAL"
  },
  {
    "codigo":37584004,
    "descripcion":"INFECCIÓN CAUSADA POR CYSTICERCUS TENUICOLLIS"
  },
  {
    "codigo":1348304006,
    "descripcion":"SÍNDROME DE FIBROSIS, NEURODEGENERACIÓN Y ANGIOMATOSIS CEREBRAL"
  },
  {
    "codigo":365264007,
    "descripcion":"HALLAZGO RELACIONADO CON EL FLUJO DE PENSAMIENTO"
  },
  {
    "codigo":723877000,
    "descripcion":"OBSTRUCCIÓN DE VENA VISCERAL"
  },
  {
    "codigo":299728009,
    "descripcion":"DESPLAZAMIENTO DE LA LÍNEA MEDIA DEL CEREBRO"
  },
  {
    "codigo":2981001,
    "descripcion":"MASA ABDOMINAL PULSÁTIL"
  },
  {
    "codigo":234192009,
    "descripcion":"ESTENOSIS DE INJERTO VASCULAR"
  },
  {
    "codigo":428965004,
    "descripcion":"GLIOMA DE TÁLAMO DE BAJO GRADO"
  },
  {
    "codigo":363429002,
    "descripcion":"NEOPLASIA MALIGNA DE LARINGE"
  },
  {
    "codigo":68517008,
    "descripcion":"INFECCIÓN CAUSADA POR INERMICAPSIFER"
  },
  {
    "codigo":232357009,
    "descripcion":"EPISTAXIS POSQUIRÚRGICA"
  },
  {
    "codigo":230522004,
    "descripcion":"TRASTORNO INFLAMATORIO DE LA RADIACIÓN ÓPTICA"
  },
  {
    "codigo":11821721000119103,
    "descripcion":"SUBLUXACIÓN ANTERIOR DE ARTICULACIÓN ESTERNOCLAVICULAR DERECHA"
  },
  {
    "codigo":164986006,
    "descripcion":"PRUEBA DE KVEIM NEGATIVA"
  },
  {
    "codigo":296058008,
    "descripcion":"SOBREDOSIS DE FLURAZEPAM"
  },
  {
    "codigo":194084001,
    "descripcion":"ESOTROPÍA ALTERNANTE CON PATRÓN Y"
  },
  {
    "codigo":292388005,
    "descripcion":"REACCIÓN ADVERSA A LA PERICIAZINA"
  },
  {
    "codigo":680601000119106,
    "descripcion":"MEIBOMIANITIS DE PÁRPADO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":225017000,
    "descripcion":"SE SIENTE NO DESEADO"
  },
  {
    "codigo":95780009,
    "descripcion":"NISTAGMO MULTIDIRECCIONAL"
  },
  {
    "codigo":93945001,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE HUESO PARIETAL"
  },
  {
    "codigo":126713003,
    "descripcion":"NEOPLASIA DE PULMÓN"
  },
  {
    "codigo":716537007,
    "descripcion":"UTILIZA AMPLIFICADOR DE LA VOZ PARA APOYAR LA COMUNICACIÓN"
  },
  {
    "codigo":92110000,
    "descripcion":"NEOPLASIA BENIGNA DEL PIE"
  },
  {
    "codigo":352921000119108,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE NERVIO ÓPTICO DERECHO"
  },
  {
    "codigo":1306361009,
    "descripcion":"NEOPLASIA BENIGNA DE PORCIÓN CENTRAL DE MAMA"
  },
  {
    "codigo":59342007,
    "descripcion":"ACROSTEÓLISIS LABORAL"
  },
  {
    "codigo":57507002,
    "descripcion":"TRASTORNO DEL METABOLISMO DE LAS PENTOSAS"
  },
  {
    "codigo":90275003,
    "descripcion":"HÁBITO"
  },
  {
    "codigo":712867005,
    "descripcion":"OSTEOMIELITIS CRÓNICA DE HUESO FACIAL"
  },
  {
    "codigo":285048004,
    "descripcion":"INCAPAZ DE USAR LENTES DE CONTACTO"
  },
  {
    "codigo":317816007,
    "descripcion":"SÍNDROME DE ESTOCOLMO"
  },
  {
    "codigo":414285001,
    "descripcion":"ALERGIA ALIMENTARIA"
  },
  {
    "codigo":283213004,
    "descripcion":"ANZUELO EN EXTREMIDAD INFERIOR"
  },
  {
    "codigo":250445004,
    "descripcion":"CILINDROS CELULARES"
  },
  {
    "codigo":217677005,
    "descripcion":"ENVENENAMIENTO DEBIDO A PICADURA DE CIEMPIÉS"
  },
  {
    "codigo":1297186002,
    "descripcion":"QUEMADURA DE DEDO GORDO DE PIE"
  },
  {
    "codigo":19234005,
    "descripcion":"EFECTO TARDÍO DE LA PRESENCIA DE CUERPO EXTRAÑO EN ORIFICIO DEL CUERPO"
  },
  {
    "codigo":1231650006,
    "descripcion":"DESPRENDIMIENTO DE RETINA REGMATÓGENO Y TRACCIONAL COMBINADO DEBIDO A RETINOPATÍA DIABÉTICA PROLIFERATIVA"
  },
  {
    "codigo":11768781000119103,
    "descripcion":"HEMATOMA SUBUNGUEAL DE DEDO ANULAR DE MANO IZQUIERDA"
  },
  {
    "codigo":52002008,
    "descripcion":"DESPRENDIMIENTO SEROSO DEL EPITELIO PIGMENTARIO RETINIANO"
  },
  {
    "codigo":707362006,
    "descripcion":"MELANOMA MALIGNO DE SENO ESFENOIDAL"
  },
  {
    "codigo":50167007,
    "descripcion":"HEPATITIS VIRAL TIPO B CRÓNICA ACTIVA"
  },
  {
    "codigo":1162444000,
    "descripcion":"FIBROMA DE CUERO CABELLUDO"
  },
  {
    "codigo":246775009,
    "descripcion":"ESPASMO HORIZONTAL DE LA MIRADA"
  },
  {
    "codigo":82935009,
    "descripcion":"ESTADO DE MADUREZ SEXUAL MASCULINA"
  },
  {
    "codigo":212172006,
    "descripcion":"LESIÓN DE LA MÉDULA DORSAL ANTERIOR, SIN LESIÓN ÓSEA, D1-6"
  },
  {
    "codigo":769228007,
    "descripcion":"TRASTORNO DEBIDO A QUEMADURA DE MUÑECA Y POSTERIOR A ELLA"
  },
  {
    "codigo":308641006,
    "descripcion":"SITUACIÓN DE CANCELACIÓN DE REGISTRO DEL PACIENTE"
  },
  {
    "codigo":46497009,
    "descripcion":"RETINOCOROIDITIS Y RETINITIS FOCAL YUXTAPAPILAR"
  },
  {
    "codigo":110198009,
    "descripcion":"QUEMADURA DEL VESTÍBULO MAXILAR"
  },
  {
    "codigo":10759271000119104,
    "descripcion":"BLEFARITIS DE AMBOS PÁRPADOS SUPERIORES"
  },
  {
    "codigo":403275004,
    "descripcion":"SÍNDROME DE ALEZZANDRINI"
  },
  {
    "codigo":1255243004,
    "descripcion":"FRACTURA EXPUESTA DE MÚLTIPLES HUESOS TARSIANOS"
  },
  {
    "codigo":42827006,
    "descripcion":"PROTEINURIA GLOBULAR"
  },
  {
    "codigo":698187008,
    "descripcion":"VÁRICES DE OVARIO"
  },
  {
    "codigo":237600004,
    "descripcion":"DIABETES MELLITUS RELACIONADA CON DESNUTRICIÓN - FIBROCALCULOSA"
  },
  {
    "codigo":1251573000,
    "descripcion":"FIBROSIS DE PIEL POSTERIOR A CIRUGÍA COSMÉTICA"
  },
  {
    "codigo":39157001,
    "descripcion":"PARÁLISIS FLÁCCIDA"
  },
  {
    "codigo":792821001,
    "descripcion":"PULSO EN ARTERIA FEMORAL DERECHA PRESENTE"
  },
  {
    "codigo":202997004,
    "descripcion":"ABSCESO DE BOLSA SEROSA DE MUÑECA"
  },
  {
    "codigo":399605004,
    "descripcion":"HALLAZGO EN ESTADIO DE LA FIGO PARA TUMOR DE TROMPA DE FALOPIO"
  },
  {
    "codigo":6389006,
    "descripcion":"ALTERACIÓN EN LA CONDUCTA FÍSICA"
  },
  {
    "codigo":235765004,
    "descripcion":"SIGMOIDITIS"
  },
  {
    "codigo":201162002,
    "descripcion":"HIPERTRICOSIS PARCIAL"
  },
  {
    "codigo":365002004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA ARTICULAR PALABRAS"
  },
  {
    "codigo":15729921000119103,
    "descripcion":"NÓDULOS DE HEBERDEN DE LAS ARTICULACIONES INTERFALÁNGICAS DISTALES DE LA MANO IZQUIERDA"
  },
  {
    "codigo":70090004,
    "descripcion":"VIRUELA BOVINA"
  },
  {
    "codigo":4554005,
    "descripcion":"BLOQUEO INTRAVENTRICULAR"
  },
  {
    "codigo":299466008,
    "descripcion":"DEFORMIDAD DE PIE EN CALCANEOVALGO"
  },
  {
    "codigo":428703001,
    "descripcion":"TRASTORNO MENTAL TRANSITORIO DE CAUSA ORGÁNICA"
  },
  {
    "codigo":102858009,
    "descripcion":"CRISTAL URINARIO, CISTINA"
  },
  {
    "codigo":233930009,
    "descripcion":"TROMBOSIS INTRACARDÍACA EN GASTO CARDÍACO BAJO"
  },
  {
    "codigo":166559004,
    "descripcion":"ALFA - FETOPROTEÍNA - HALLAZGO DUDOSO"
  },
  {
    "codigo":232095008,
    "descripcion":"ESOTROPÍA CON NISTAGMO"
  },
  {
    "codigo":35487009,
    "descripcion":"HIPERCAROTINEMIA"
  },
  {
    "codigo":721780003,
    "descripcion":"INFECCIÓN CAUSADA POR VIRUS GUANARITO"
  },
  {
    "codigo":263028004,
    "descripcion":"LUXACIÓN DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":33652004,
    "descripcion":"HERNIA LUMBAR CON OBSTRUCCIÓN"
  },
  {
    "codigo":295796005,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE VINDESINA"
  },
  {
    "codigo":230260007,
    "descripcion":"PARAPLEJÍA ESPÁSTICA HEREDITARIA PURA"
  },
  {
    "codigo":719945007,
    "descripcion":"SÍNDROME DE TAURODONCIA CON AUSENCIA DE DIENTES Y CABELLO RALO"
  },
  {
    "codigo":195657008,
    "descripcion":"FARINGITIS ULCEROSA AGUDA"
  },
  {
    "codigo":83201000119108,
    "descripcion":"DEFICIENCIA SECUNDARIA DE CARNITINA"
  },
  {
    "codigo":292126002,
    "descripcion":"REACCIÓN ADVERSA A LA LOPERAMIDA"
  },
  {
    "codigo":95518006,
    "descripcion":"MUCOSITIS GASTROINTESTINAL"
  },
  {
    "codigo":128286008,
    "descripcion":"ÚLCERA DUODENAL CRÓNICA"
  },
  {
    "codigo":28147001,
    "descripcion":"ANEMIA HEMOLÍTICA CAUSADA POR CLOSTRIDIUM WELCHII"
  },
  {
    "codigo":1142259002,
    "descripcion":"HIPERTROFIA SEVERA DE MÚSCULO ESQUELÉTICO"
  },
  {
    "codigo":93683002,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE COLON ASCENDENTE"
  },
  {
    "codigo":91848009,
    "descripcion":"ACEFALIA"
  },
  {
    "codigo":302491000119107,
    "descripcion":"ANQUILOSIS DE ARTICULACIÓN DE CODO IZQUIERDO"
  },
  {
    "codigo":417693004,
    "descripcion":"DISFUNCIÓN SOMÁTICA DE ANTEBRAZO"
  },
  {
    "codigo":1171357005,
    "descripcion":"ANEMIA POR DEFICIENCIA DE VITAMINA B12 POSGASTRECTOMÍA"
  },
  {
    "codigo":188317004,
    "descripcion":"NEOPLASIA MALIGNA DE LA DURAMADRE RAQUÍDEA"
  },
  {
    "codigo":1204125007,
    "descripcion":"HEMORRAGIA SUBARACNOIDEA CEREBRAL IDIOPÁTICA ESPONTÁNEA"
  },
  {
    "codigo":11771291000119108,
    "descripcion":"SUBLUXACIÓN DE CODO DERECHO"
  },
  {
    "codigo":284786005,
    "descripcion":"CAPAZ DE LAVARSE"
  },
  {
    "codigo":186482006,
    "descripcion":"INFECCIÓN VIRAL LENTA DEL SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":55410006,
    "descripcion":"INTOXICACIÓN POR HOMATROPINA"
  },
  {
    "codigo":448626007,
    "descripcion":"VALVA DE VÁLVULA AURICULOVENTRICULAR GELATINOSA EN DEFECTO DEL TABIQUE INTERVENTRICULAR"
  },
  {
    "codigo":88178009,
    "descripcion":"PERITONITIS PUERPERAL"
  },
  {
    "codigo":414023003,
    "descripcion":"TRASTORNO EN COMPONENTE CELULAR SANGUÍNEO EN EL RECIÉN NACIDO"
  },
  {
    "codigo":282951004,
    "descripcion":"NO SE INCLINA PARA TOCARSE LOS PIES"
  },
  {
    "codigo":1003847003,
    "descripcion":"DEFICIENCIA DE PIRUVATO DESHIDROGENASA FOSFATASA"
  },
  {
    "codigo":1264156006,
    "descripcion":"DESEQUILIBRIO ELECTROLÍTICO POSTERIOR A EMBARAZO MOLAR"
  },
  {
    "codigo":444956007,
    "descripcion":"EDEMA DE TODOS LOS DEDOS DE LOS PIES"
  },
  {
    "codigo":443121003,
    "descripcion":"HALLAZGO RELACIONADO CON EVALUACIÓN DE LÍQUIDO ASCÍTICO"
  },
  {
    "codigo":836337003,
    "descripcion":"AGUDEZA VISUAL CON AGUJERO ESTENOPEICO DE OJO IZQUIERDO 6\/60"
  },
  {
    "codigo":12400181000119108,
    "descripcion":"DOLOR CRÓNICO POSTERIOR A ARTROPLASTIA TOTAL DE AMBAS RODILLAS"
  },
  {
    "codigo":685621000119108,
    "descripcion":"LEIOMIOSARCOMA PRIMARIO DE CABEZA"
  },
  {
    "codigo":85711000119103,
    "descripcion":"TAMBALEO DEBIDO A FALTA DE COORDINACIÓN"
  },
  {
    "codigo":408518007,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: SINHALA"
  },
  {
    "codigo":46235002,
    "descripcion":"SÍFILIS CONGÉNITA TEMPRANA, LATENTE, SEROLOGÍA POSITIVA, LÍQUIDO CEFALORRAQUÍDEO NEGATIVO"
  },
  {
    "codigo":331471000119105,
    "descripcion":"GLAUCOMA UVEÍTICO DE OJO DERECHO"
  },
  {
    "codigo":11718351000119105,
    "descripcion":"XANTOMA DE AMBOS PÁRPADOS SUPERIORES"
  },
  {
    "codigo":11632003,
    "descripcion":"INTOXICACIÓN POR MEDICAGO SATIVA"
  },
  {
    "codigo":44400004,
    "descripcion":"EFECTO TÓXICO DE UN VENENO"
  },
  {
    "codigo":109936005,
    "descripcion":"NEOPLASIA BENIGNA DE LOS NERVIOS PERIFÉRICOS DEL MIEMBRO INFERIOR"
  },
  {
    "codigo":208240004,
    "descripcion":"FRACTURA NO EXPUESTA DE HÚMERO PROXIMAL, CUELLO"
  },
  {
    "codigo":370245000,
    "descripcion":"LACERACIÓN SUPERFICIAL DEL PULGAR"
  },
  {
    "codigo":697925001,
    "descripcion":"HIPERTENSIÓN PULMONAR DEBIDA A DISFUNCIÓN VENTRICULAR SISTÓLICA SISTÉMICA"
  },
  {
    "codigo":239173005,
    "descripcion":"CICATRIZ IMPREGNADA DE SUCIEDAD"
  },
  {
    "codigo":271941007,
    "descripcion":"SECRECIÓN MAMARIA"
  },
  {
    "codigo":1254981008,
    "descripcion":"DEPENDENCIA DE SUSTANCIAS DURANTE EMBARAZO, PARTO Y\/O PUERPERIO"
  },
  {
    "codigo":403013009,
    "descripcion":"TIÑA DE CUERO CABELLUDO CAUSADA POR TRICHOPHYTON MENTAGROPHYTES VARIEDAD ERINACEI"
  },
  {
    "codigo":302874002,
    "descripcion":"DISFUNCIÓN DE CÉLULA FAGOCÍTICA"
  },
  {
    "codigo":75333007,
    "descripcion":"INFECCIÓN CAUSADA POR CRYPTOSPORIDIUM MURIS"
  },
  {
    "codigo":827162007,
    "descripcion":"TERATOMA MALIGNO INMADURO DE OVARIO"
  },
  {
    "codigo":237338008,
    "descripcion":"DISCRASIA SANGUÍNEA PUERPERAL"
  },
  {
    "codigo":202735001,
    "descripcion":"PROLAPSO DE DISCO LUMBAR CON RADICULOPATÍA"
  },
  {
    "codigo":169967000,
    "descripcion":"ALIMENTADO ARTIFICIALMENTE A LOS 10 DÍAS"
  },
  {
    "codigo":71663002,
    "descripcion":"PROLAPSO RECTAL INCOMPLETO"
  },
  {
    "codigo":366575004,
    "descripcion":"HALLAZGO EN LA RESPUESTA DEL MÚSCULO EXTENSOR PLANTAR"
  },
  {
    "codigo":102596001,
    "descripcion":"OLOR DESAGRADABLE DE LOS GENITALES"
  },
  {
    "codigo":397508002,
    "descripcion":"AUSENCIA DE IMPLANTES EN EPIPLÓN DE TUMOR DE OVARIO NO INVASIVO (DESMOPLÁSICO)"
  },
  {
    "codigo":364740004,
    "descripcion":"HALLAZGO RELACIONADO CON LA FUNCIÓN MOTORA DE LA LENGUA"
  },
  {
    "codigo":299204006,
    "descripcion":"ARTICULACIÓN DEL PULGAR ERITEMATOSA"
  },
  {
    "codigo":233668008,
    "descripcion":"DEFECTO DE ACLARAMIENTO MUCOCILIAR ADQUIRIDO"
  },
  {
    "codigo":16662531000119101,
    "descripcion":"DISECCIÓN DE AMBAS ARTERIAS POPLÍTEAS"
  },
  {
    "codigo":231833004,
    "descripcion":"ADENOCARCINOMA SEBÁCEO DE PÁRPADO"
  },
  {
    "codigo":788889007,
    "descripcion":"INFLAMACIÓN CRÓNICA DE GANGLIO LINFÁTICO CERVICAL"
  },
  {
    "codigo":350051000221103,
    "descripcion":"MICOSIS SISTÉMICA CAUSADA POR HONGOS MICELIALES"
  },
  {
    "codigo":721518001,
    "descripcion":"SÍNDROME DEL CORDÓN POSTERIOR DE MÉDULA ESPINAL AL NIVEL DEL PRIMER SEGMENTO LUMBAR"
  },
  {
    "codigo":197230002,
    "descripcion":"SEUDODIVERTÍCULO RECTAL"
  },
  {
    "codigo":262766003,
    "descripcion":"HEMATOMA DE GLÁNDULA SALIVAL"
  },
  {
    "codigo":66158003,
    "descripcion":"FRACTURA NO EXPUESTA A NIVEL DE C5 - C7 CON LESIÓN INCOMPLETA DE LA MÉDULA ESPINAL"
  },
  {
    "codigo":295534007,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE HALOTANO"
  },
  {
    "codigo":129859006,
    "descripcion":"DISMINUCIÓN DE LA MOVILIDAD EN LA CAMA"
  },
  {
    "codigo":293699006,
    "descripcion":"ALERGIA A ÁCIDO QUENODEOXICÓLICO"
  },
  {
    "codigo":424771006,
    "descripcion":"MEDIOS INSUFICIENTES PARA LA SALIDA DEL LUGAR DE RESIDENCIA"
  },
  {
    "codigo":64323009,
    "descripcion":"RUPTURA COMPLETA DE PARÉNQUIMA RENAL SIN HERIDA ABIERTA HACIA CAVIDAD"
  },
  {
    "codigo":27885002,
    "descripcion":"BLOQUEO AURICULOVENTRICULAR COMPLETO"
  },
  {
    "codigo":224493002,
    "descripcion":"CUIDADOR DISPUESTO A COMPARTIR LA ASISTENCIA CON PROFESIONALES"
  },
  {
    "codigo":191725006,
    "descripcion":"FOBIA SOCIAL, MIEDO A HABLAR EN PÚBLICO"
  },
  {
    "codigo":688131000119108,
    "descripcion":"NEURILEMOMA DE NERVIO DE LA CARA"
  },
  {
    "codigo":93421008,
    "descripcion":"DISTANCIA ANOGENITAL DISMINUIDA"
  },
  {
    "codigo":419266001,
    "descripcion":"CONDILOMA ACUMINADO DEL CUELLO UTERINO"
  },
  {
    "codigo":333981000119103,
    "descripcion":"QUERATITIS MACULAR DE OJO DERECHO"
  },
  {
    "codigo":124354006,
    "descripcion":"DEFICIENCIA DE UDP-GLUCOSA-HEXOSA-1-FOSFATO URIDILILTRANSFERASA"
  },
  {
    "codigo":91586009,
    "descripcion":"ELEFANTIASIS DE BANCROFT"
  },
  {
    "codigo":188055004,
    "descripcion":"MELANOMA MALIGNO DE OMBLIGO"
  },
  {
    "codigo":1269399005,
    "descripcion":"ALERGIA A PROTEÍNA DE CONEJO SALVAJE"
  },
  {
    "codigo":89751008,
    "descripcion":"TRASTORNO SEXUAL DOLOROSO"
  },
  {
    "codigo":87916001,
    "descripcion":"CONSISTENCIA DE UNA COLONIA BACTERIANA, FRIABLE"
  },
  {
    "codigo":253591008,
    "descripcion":"ATRESIA PULMONAR CON DEFECTO DEL TABIQUE INTERVENTRICULAR"
  },
  {
    "codigo":10737821000119106,
    "descripcion":"CARCINOMA ENDOMETRIOIDE PRIMARIO DE OVARIO IZQUIERDO"
  },
  {
    "codigo":251756006,
    "descripcion":"DIPLOPÍA HETERÓNIMA"
  },
  {
    "codigo":774209001,
    "descripcion":"DIDIMOSIS APLASTICOSEBÁCEA"
  },
  {
    "codigo":413761004,
    "descripcion":"CUIDADOR DE PERSONA CON DISCAPACIDAD PARA EL APRENDIZAJE"
  },
  {
    "codigo":315457005,
    "descripcion":"NACIDO EN KIRIBATI"
  },
  {
    "codigo":53313006,
    "descripcion":"CONTRACCIÓN EN RELOJ DE ARENA DEL ESTÓMAGO"
  },
  {
    "codigo":249921008,
    "descripcion":"ESPALDA RÍGIDA"
  },
  {
    "codigo":86081009,
    "descripcion":"DERMATITIS HERPETIFORME DEL EMBARAZO"
  },
  {
    "codigo":708673009,
    "descripcion":"PAROSMIA"
  },
  {
    "codigo":870678006,
    "descripcion":"REACCIÓN ADVERSA A ANTIMONIO Y\/O COMPUESTO DE ANTIMONIO"
  },
  {
    "codigo":279019008,
    "descripcion":"DOLOR TORÁCICO CENTRAL OPRESIVO"
  },
  {
    "codigo":211648000,
    "descripcion":"CUERPO EXTRAÑO EN VEJIGA URINARIA Y URETRA"
  },
  {
    "codigo":703168002,
    "descripcion":"ESTENOSIS E INSUFICIENCIA DE PRÓTESIS DE VÁLVULA MITRAL"
  },
  {
    "codigo":1260224003,
    "descripcion":"MIOSITIS OSIFICANTE CIRCUNSCRITA NO TRAUMÁTICA"
  },
  {
    "codigo":441024003,
    "descripcion":"LESIÓN DE TRIFURCACIÓN DE ARTERIA CORONARIA"
  },
  {
    "codigo":735936005,
    "descripcion":"DOLOR NEUROPÁTICO CRÓNICO"
  },
  {
    "codigo":209813001,
    "descripcion":"DESGARRO COMPLETO, LIGAMENTO DE LA SÍNFISIS DEL PUBIS"
  },
  {
    "codigo":45973002,
    "descripcion":"PECTUS CARINATUM ADQUIRIDO"
  },
  {
    "codigo":275349007,
    "descripcion":"AUSENCIA DE HUESO DEL CRÁNEO"
  },
  {
    "codigo":109674000,
    "descripcion":"AUSENCIA ADQUIRIDA DE UN DIENTE"
  },
  {
    "codigo":10629431000119108,
    "descripcion":"RINITIS ALÉRGICA CAUSADA POR INSECTOS"
  },
  {
    "codigo":371818002,
    "descripcion":"PACIENTE CON ASISTENCIA DE BALÓN DE CONTRAPULSACIÓN INTRAÓRTICO"
  },
  {
    "codigo":11995601000119103,
    "descripcion":"DEHISCENCIA DE HERIDA DE MUÑÓN DE AMPUTACIÓN DE EXTREMIDAD INFERIOR DERECHA"
  },
  {
    "codigo":207978006,
    "descripcion":"FRACTURA EXPUESTA POR COMPRESIÓN DEL SACRO"
  },
  {
    "codigo":240746007,
    "descripcion":"HISTOPLASMOSIS CUTÁNEA DISEMINADA"
  },
  {
    "codigo":1354858008,
    "descripcion":"SÍNDROME DE MICROCEFALIA PROGRESIVA, CONVULSIONES, CEGUERA CORTICAL, RETRASO DEL DESARROLLO CON INMUNODEFICIENCIA COMBINADA DEBIDA A DEFICIENCIA DE DIAPH1"
  },
  {
    "codigo":1156415003,
    "descripcion":"ASTROCITOMA PROTOPLASMÁTICO"
  },
  {
    "codigo":238911007,
    "descripcion":"SÍNDROME DE OMBLIGO AUSENTE"
  },
  {
    "codigo":40468003,
    "descripcion":"HEPATITIS VIRAL, TIPO A"
  },
  {
    "codigo":106004004,
    "descripcion":"COMPLICACIÓN HEMORRÁGICA DEL EMBARAZO"
  },
  {
    "codigo":11831761000119106,
    "descripcion":"LESIÓN TRAUMÁTICA DE VASO SANGUÍNEO DE DEDO DE MANO DERECHA"
  },
  {
    "codigo":237076007,
    "descripcion":"SACULACIÓN UTERINA"
  },
  {
    "codigo":366313000,
    "descripcion":"HALLAZGO RELACIONADO CON MOVILIDAD DE ESPERMATOZOIDES EN MOCO CERVICAL POSTCOITAL"
  },
  {
    "codigo":399081005,
    "descripcion":"NEUROPATÍA DEL PERONEO COMÚN"
  },
  {
    "codigo":300777006,
    "descripcion":"NO JUEGA"
  },
  {
    "codigo":36798000,
    "descripcion":"BORRAMIENTO CERVICAL, 10%"
  },
  {
    "codigo":298942004,
    "descripcion":"TUMEFACCIÓN ÓSEA DE MUÑECA"
  },
  {
    "codigo":724926004,
    "descripcion":"DISTENSIÓN DE TENDÓN DE BÍCEPS BRAQUIAL"
  },
  {
    "codigo":200638004,
    "descripcion":"CELULITIS Y ABSCESO DE DEDO DEL PIE"
  },
  {
    "codigo":90731000119103,
    "descripcion":"ESTADIO 2 DE ENFERMEDAD RENAL CRÓNICA DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":4030008,
    "descripcion":"ENFERMEDAD POR EL VIRUS LE DANTEC"
  },
  {
    "codigo":336491000119103,
    "descripcion":"ATROFIA SENIL DE COROIDES DERECHA"
  },
  {
    "codigo":10930641000119109,
    "descripcion":"FRACTURA NO EXPUESTA DE HUESO METATARSIANO DEL PIE IZQUIERDO"
  },
  {
    "codigo":16228971000119104,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE PARTES BLANDAS DE CADERA IZQUIERDA"
  },
  {
    "codigo":723091005,
    "descripcion":"FÍSTULA DE VAGINA Y\/O RECTO Y\/O VEJIGA DEBIDA A COMPLICACIÓN DURANTE EL TRABAJO DE PARTO Y\/O PARTO"
  },
  {
    "codigo":43761000087101,
    "descripcion":"TRASTORNO DE TENDÓN DE PIE DERECHO"
  },
  {
    "codigo":46321000087102,
    "descripcion":"FRACTURA DE EXTREMO PROXIMAL DE CÚBITO DERECHO"
  },
  {
    "codigo":293256007,
    "descripcion":"REACCIÓN ADVERSA AL ESTRIOL"
  },
  {
    "codigo":721256001,
    "descripcion":"INFECCIÓN DE GLÁNDULA LAGRIMAL"
  },
  {
    "codigo":360002,
    "descripcion":"ENFERMEDAD AGUDA POR RADIACIÓN"
  },
  {
    "codigo":295272001,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE NABUMETONA"
  },
  {
    "codigo":41201000087108,
    "descripcion":"HERIDA PUNZANTE DE OÍDO DERECHO CON CUERPO EXTRAÑO"
  },
  {
    "codigo":229736005,
    "descripcion":"RETARDO DEL LENGUAJE RECEPTIVO"
  },
  {
    "codigo":65896005,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DE TOBILLO"
  },
  {
    "codigo":51441000087107,
    "descripcion":"USUARIO DE CIGARRO ELECTRÓNICO CON CANNABIS"
  },
  {
    "codigo":293437000,
    "descripcion":"REACCIÓN ADVERSA A LA ADENOSINA"
  },
  {
    "codigo":129597002,
    "descripcion":"HIPEREMESIS GRAVÍDICA MODERADA"
  },
  {
    "codigo":162365003,
    "descripcion":"SECRECIÓN HEMÁTICA DEL OÍDO"
  },
  {
    "codigo":424509006,
    "descripcion":"VÍCTIMA DE DISCIPLINA EXCESIVA"
  },
  {
    "codigo":291602000,
    "descripcion":"INTOXICACIÓN POR CEFTIZOXIMA"
  },
  {
    "codigo":94994005,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE PENE"
  },
  {
    "codigo":1010663004,
    "descripcion":"HETEROTOPÍA NODULAR SUBCORTICAL"
  },
  {
    "codigo":715751004,
    "descripcion":"ATAXIA ESPINOCEREBELOSA TIPO 2"
  },
  {
    "codigo":191463004,
    "descripcion":"DEMENCIA ARTERIOSCLERÓTICA NO COMPLICADA"
  },
  {
    "codigo":224231004,
    "descripcion":"DUERME EN REFUGIO NOCTURNO"
  },
  {
    "codigo":93159009,
    "descripcion":"LIPOMA DE PIEL Y TEJIDO CELULAR SUBCUTÁNEO DE LA CARA"
  },
  {
    "codigo":15956741000119106,
    "descripcion":"CARCINOMA MICROCÍTICO METASTÁSICO DE AMBOS PULMONES"
  },
  {
    "codigo":253329001,
    "descripcion":"ANOMALÍA DE CONDUCTO VENOSO"
  },
  {
    "codigo":286097002,
    "descripcion":"DIFICULTAD PARA TIRAR LA BASURA DOMÉSTICA"
  },
  {
    "codigo":89489004,
    "descripcion":"ESTOMATITIS HEMORRÁGICA"
  },
  {
    "codigo":187793004,
    "descripcion":"NEOPLASIA MALIGNA DE CONDUCTO PANCREÁTICO"
  },
  {
    "codigo":284262007,
    "descripcion":"DIFICULTAD PARA AGARRAR"
  },
  {
    "codigo":218726009,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR ANESTÉSICO BLOQUEANTE DE PLEXO Y NERVIO PERIFÉRICO"
  },
  {
    "codigo":448102009,
    "descripcion":"VÁLVULA TRONCAL CUADRICÚSPIDE"
  },
  {
    "codigo":16012191000119104,
    "descripcion":"TROMBOFLEBITIS DE AMBAS VENAS FEMORALES PROFUNDAS"
  },
  {
    "codigo":413499007,
    "descripcion":"SOCIEDAD ESTADOUNIDENSE DE ANESTESISTAS - ESTADO FÍSICO CLASE 5"
  },
  {
    "codigo":313360001,
    "descripcion":"EXOSTOSIS DE CODO"
  },
  {
    "codigo":1263632004,
    "descripcion":"TRASTORNO FETAL DEBIDO A MALPOSICIÓN OCCIPITO-POSTERIOR PERSISTENTE DURANTE TRABAJO DE PARTO"
  },
  {
    "codigo":247824007,
    "descripcion":"MIEDO DE VOLVERSE GORDO"
  },
  {
    "codigo":49381001,
    "descripcion":"ANOMALÍA CONGÉNITA DE LA RETINA"
  },
  {
    "codigo":1163493002,
    "descripcion":"DUODENITIS FÚNGICA"
  },
  {
    "codigo":735674000,
    "descripcion":"LESIÓN TRAUMÁTICA DE UÑA DE DEDO DE PIE"
  },
  {
    "codigo":11834271000119109,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN RADIOCARPIANA DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":47546008,
    "descripcion":"SOBREDOSIS DE WARFARINA"
  },
  {
    "codigo":111247001,
    "descripcion":"CONTRACTURA DE VOLKMANN"
  },
  {
    "codigo":733839001,
    "descripcion":"INSUFICIENCIA RENAL AGUDA POSPARTO"
  },
  {
    "codigo":1076281000119104,
    "descripcion":"BURSITIS SUBROTULIANA DE RODILLA IZQUIERDA"
  },
  {
    "codigo":240484000,
    "descripcion":"SARAMPIÓN MODIFICADO"
  },
  {
    "codigo":1354596000,
    "descripcion":"INMUNODEFICIENCIA VARIABLE COMÚN AUTOSÓMICA RECESIVA DEBIDA A MUTACIÓN DE POU2AF1"
  },
  {
    "codigo":1290895009,
    "descripcion":"LIPOSARCOMA EPITELIOIDE"
  },
  {
    "codigo":699236005,
    "descripcion":"CONSENTIMIENTO OTORGADO PARA EVALUACIÓN DEL RIESGO CARDIOVASCULAR"
  },
  {
    "codigo":43876007,
    "descripcion":"SITUS INVERSUS VISCERAL"
  },
  {
    "codigo":339001000119107,
    "descripcion":"PANUVEÍTIS DEL OJO IZQUIERDO"
  },
  {
    "codigo":9273005,
    "descripcion":"SÍNDROME DE POLIPOSIS JUVENIL"
  },
  {
    "codigo":369721007,
    "descripcion":"G2: NÚCLEOS LEVEMENTE IRREGULARES, DE 15 Μ APROXIMADAMENTE; NUCLÉOLOS VISIBLES"
  },
  {
    "codigo":171278000,
    "descripcion":"ESTADO DE INMUNIZACIÓN - DESCONOCIDO"
  },
  {
    "codigo":7438000,
    "descripcion":"ATRESIA DE AORTA"
  },
  {
    "codigo":238649008,
    "descripcion":"HIPERPIGMENTACIÓN POSINFLAMATORIA EN LIQUEN PLANO"
  },
  {
    "codigo":254856004,
    "descripcion":"CARCINOMA INDIFERENCIADO DE OVARIO"
  },
  {
    "codigo":236814005,
    "descripcion":"HIPOESPERMATOGÉNESIS CITOTÓXICA INDUCIDA POR FÁRMACOS"
  },
  {
    "codigo":204046005,
    "descripcion":"ANOMALÍAS HIPOTALÁMICAS"
  },
  {
    "codigo":202211005,
    "descripcion":"LUXACIÓN POSTERIOR RECURRENTE DE ARTICULACIÓN DE HOMBRO"
  },
  {
    "codigo":38371006,
    "descripcion":"ANOMALÍA DE POLAND"
  },
  {
    "codigo":300515007,
    "descripcion":"MASA DE PENE"
  },
  {
    "codigo":366051008,
    "descripcion":"SECRECIÓN DE LÁGRIMAS Y DRENAJE LAGRIMAL - HALLAZGO"
  },
  {
    "codigo":298680000,
    "descripcion":"COLUMNA LUMBAR TIBIA AL TACTO"
  },
  {
    "codigo":234979007,
    "descripcion":"COLORACIÓN EXTRÍNSECA DE DIENTE"
  },
  {
    "codigo":5603006,
    "descripcion":"ANEMIA HEMOLÍTICA AUTOINMUNITARIA CAUSADA POR INMUNOGLOBULINA G"
  },
  {
    "codigo":167608004,
    "descripcion":"COLOR DE LAS HECES: MECONIAL"
  },
  {
    "codigo":2121000124101,
    "descripcion":"DETERMINACIÓN DEL ESTADO DE LA ENFERMEDAD: ESCASAMENTE CONTROLADA"
  },
  {
    "codigo":69304004,
    "descripcion":"INTOXICACIÓN POR TRIFOLIUM"
  },
  {
    "codigo":71139009,
    "descripcion":"FRACTURA NO EXPUESTA DE EXTREMO PROXIMAL DE RADIO"
  },
  {
    "codigo":427917002,
    "descripcion":"ABSCESOS MÚLTIPLES"
  },
  {
    "codigo":165773002,
    "descripcion":"PRUEBA DE COOMBS DIRECTA POSITIVA"
  },
  {
    "codigo":1279885004,
    "descripcion":"SÍNDROME DE CORDÓN CENTRAL DE MÉDULA ESPINAL DORSAL DEBIDO A LESIÓN TRAUMÁTICA"
  },
  {
    "codigo":15932781000119101,
    "descripcion":"OBSTRUCCIÓN COMPLETA DE EXTREMO DISTAL DE TROMPA UTERINA IZQUIERDA"
  },
  {
    "codigo":296845006,
    "descripcion":"SOBREDOSIS DE DEXAMETASONA"
  },
  {
    "codigo":722829006,
    "descripcion":"DOLOR AGUDO DE ESCROTO"
  },
  {
    "codigo":429641000124109,
    "descripcion":"HIPOSPADIAS CORONAL"
  },
  {
    "codigo":360546002,
    "descripcion":"CHOQUE HIPOGLUCÉMICO"
  },
  {
    "codigo":295010007,
    "descripcion":"ALERGIA A AMILORIDA"
  },
  {
    "codigo":719159004,
    "descripcion":"SINDACTILIA TIPO 5"
  },
  {
    "codigo":293175005,
    "descripcion":"REACCIÓN ADVERSA A LA BUDESONIDA"
  },
  {
    "codigo":225804002,
    "descripcion":"PRESIONADO POR OTROS"
  },
  {
    "codigo":94732002,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE MUCOSA DE CRESTA ALVEOLAR"
  },
  {
    "codigo":15988231000119100,
    "descripcion":"ANOMALÍA CONGÉNITA DE SISTEMA DE DRENAJE LAGRIMAL IZQUIERDO"
  },
  {
    "codigo":341511000119100,
    "descripcion":"ENTROPIÓN CICATRIZAL DE PÁRPADO IZQUIERDO"
  },
  {
    "codigo":125665001,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO"
  },
  {
    "codigo":191201002,
    "descripcion":"PERSISTENCIA HEREDITARIA DE HEMOGLOBINA FETAL"
  },
  {
    "codigo":291340009,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR CLORFENAMINA"
  },
  {
    "codigo":92897003,
    "descripcion":"FORMA ANORMAL CONGÉNITA DEL CALCÁNEO"
  },
  {
    "codigo":1208844009,
    "descripcion":"OBSTRUCCIÓN ARTERIAL DEBIDA A EMBOLIA TROMBÓTICA DE ANEURISMA DE VENTRÍCULO"
  },
  {
    "codigo":418742000,
    "descripcion":"HALLAZGO RELACIONADO CON EL REFLEJO DE DEFECACIÓN"
  },
  {
    "codigo":123830001,
    "descripcion":"BACTERIAS CON MORFOLOGÍA INDICATIVA DE ESPECIES DE ACTINOMYCES"
  },
  {
    "codigo":289505008,
    "descripcion":"CLÍTORIS DE TAMAÑO NORMAL"
  },
  {
    "codigo":713654004,
    "descripcion":"COLANGITIS AUTOINMUNITARIA"
  },
  {
    "codigo":254902007,
    "descripcion":"HIPERPLASIA PROSTÁTICA BENIGNA SIN OBSTRUCCIÓN DEL FLUJO DE SALIDA"
  },
  {
    "codigo":1172406008,
    "descripcion":"HORMONAS SEXUALES MASCULINAS SÉRICAS POR ENCIMA DE RANGO DE REFERENCIA"
  },
  {
    "codigo":185696004,
    "descripcion":"CRIBADO EN ADULTO MAYOR - SIN RESPUESTA"
  },
  {
    "codigo":284000008,
    "descripcion":"LESIÓN ENDOCRINA"
  },
  {
    "codigo":447840008,
    "descripcion":"ESTENOSIS DE ARTERIA PULMONAR DERECHA"
  },
  {
    "codigo":282165001,
    "descripcion":"DIFICULTAD PARA CAMINAR PENDIENTE ABAJO"
  },
  {
    "codigo":251232008,
    "descripcion":"ALTURA DE LA ONDA S DISMINUIDA"
  },
  {
    "codigo":85557000,
    "descripcion":"PERSISTENCIA HEREDITARIA DE HEMOGLOBINA FETAL TIPO DELECIÓN"
  },
  {
    "codigo":413237005,
    "descripcion":"UNIÓN PANCREATOBILIAR ANORMAL"
  },
  {
    "codigo":1363509005,
    "descripcion":"ENFERMEDAD MITOCONDRIAL RELACIONADA CON LA SUBUNIDAD 6 DE ATP SINTASA CODIFICADA MITOCONDRIALMENTE"
  },
  {
    "codigo":20021007,
    "descripcion":"DESPLAZAMIENTO DE DISCO INTERVERTEBRAL LUMBAR, SIN MIELOPATÍA"
  },
  {
    "codigo":247562000,
    "descripcion":"TIPO DE PELO RACIAL"
  },
  {
    "codigo":249397009,
    "descripcion":"AMÍGDALAS REMANENTES"
  },
  {
    "codigo":315041000119102,
    "descripcion":"ENFERMEDAD DE PAGET DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":18186001,
    "descripcion":"FETICHISMO COMPULSIVO VERDADERO"
  },
  {
    "codigo":83722004,
    "descripcion":"FILTRACIÓN DE DISPOSITIVO CARDÍACO"
  },
  {
    "codigo":1078791000119109,
    "descripcion":"CATARATA POLAR SUBCAPSULAR POSTERIOR SENIL DE OJO IZQUIERDO"
  },
  {
    "codigo":444170006,
    "descripcion":"INVASIÓN DE MÚSCULO ESQUELÉTICO POR CARCINOMA"
  },
  {
    "codigo":409567003,
    "descripcion":"BOTULISMO TRANSMITIDO POR LOS ALIMENTOS, TIPO F"
  },
  {
    "codigo":737247007,
    "descripcion":"DERMATOSIS DE PERINEO"
  },
  {
    "codigo":1259700000,
    "descripcion":"NEOPLASIA QUÍSTICA MUCINOSA PRIMARIA CON CARCINOMA INVASIVO DE PÁNCREAS"
  },
  {
    "codigo":276660001,
    "descripcion":"ENFERMEDAD VIRAL CONGÉNITA"
  },
  {
    "codigo":702644002,
    "descripcion":"ESTENOSIS CONGÉNITA DE APERTURA PIRIFORME NASAL"
  },
  {
    "codigo":15634081000119106,
    "descripcion":"TOMOGRAFÍA COMPUTARIZADA DE VÍA BILIAR ANORMAL"
  },
  {
    "codigo":473268007,
    "descripcion":"QUEMADURA EPIDÉRMICA DE MÚLTIPLES SITIOS DE LA MUÑECA"
  },
  {
    "codigo":307593001,
    "descripcion":"CARCINOMATOSIS"
  },
  {
    "codigo":110985001,
    "descripcion":"FIBROFOLICULOMAS MÚLTIPLES"
  },
  {
    "codigo":209289002,
    "descripcion":"FRACTURA-SUBLUXACIÓN NO EXPUESTA PERISEMILUNAR (DORSAL)"
  },
  {
    "codigo":274825006,
    "descripcion":"PTOSIS PRESENTE"
  },
  {
    "codigo":373129009,
    "descripcion":"CONTRACTILIDAD CARDÍACA GENERAL NORMAL"
  },
  {
    "codigo":404062002,
    "descripcion":"LIPOMAS MÚLTIPLES"
  },
  {
    "codigo":43614003,
    "descripcion":"TRASTORNO AUTISTA DE INICIO EN LA NIÑEZ"
  },
  {
    "codigo":240222001,
    "descripcion":"ESPONDILOPTOSIS"
  },
  {
    "codigo":405897009,
    "descripcion":"FENOTIPO K+K-"
  },
  {
    "codigo":305758007,
    "descripcion":"ATENDIDO POR ENFERMERA DE ESTUDIO EXPERIMENTAL"
  },
  {
    "codigo":271155000,
    "descripcion":"AMPOLLA TRAUMÁTICA DE LA REGIÓN ESCAPULAR, INFECTADA"
  },
  {
    "codigo":402227001,
    "descripcion":"ECCEMA EXÓGENO DE MANO"
  },
  {
    "codigo":860979002,
    "descripcion":"ÚLCERA CRÓNICA DE PIE DERECHO DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":333451000119100,
    "descripcion":"EXOSTOSIS DE ÓRBITA DERECHA"
  },
  {
    "codigo":292491000119101,
    "descripcion":"NEURALGIA DE NERVIO PUDENDO IZQUIERDO"
  },
  {
    "codigo":1075851000119100,
    "descripcion":"TENOSINOVITIS DE MUÑECA DERECHA"
  },
  {
    "codigo":100491000119103,
    "descripcion":"MIELOPATÍA CONCOMITANTE CON ESTENOSIS ESPINAL DE REGIÓN LUMBAR Y DEBIDA A ELLA"
  },
  {
    "codigo":128651000119103,
    "descripcion":"ENFERMEDAD DE INJERTO VERSUS HUÉSPED POSTERIOR A TRASPLANTE DE RIÑÓN"
  },
  {
    "codigo":12065931000119105,
    "descripcion":"MALPOSICIÓN DE FÍSTULA ARTERIOVENOSA QUIRÚRGICA"
  },
  {
    "codigo":341131000119102,
    "descripcion":"DACRIOADENITIS DE OJO IZQUIERDO"
  },
  {
    "codigo":15629451000119107,
    "descripcion":"SUBEPENDIMOMA DE MÉDULA ESPINAL"
  },
  {
    "codigo":651000119108,
    "descripcion":"TROMBOSIS AGUDA DE VENA PROFUNDA DE MIEMBRO INFERIOR"
  },
  {
    "codigo":36491000119101,
    "descripcion":"OBSTRUCCIÓN LARÍNGEA DEBIDA A SUPRAGLOTITIS"
  },
  {
    "codigo":305291000119101,
    "descripcion":"CONTRACTURA DE MÚSCULO DE ANTEBRAZO IZQUIERDO"
  },
  {
    "codigo":72331000119105,
    "descripcion":"TALASEMIA MATERNA QUE COMPLICA EL EMBARAZO"
  },
  {
    "codigo":236552002,
    "descripcion":"ENFERMEDAD ADINÁMICA DE HUESO"
  },
  {
    "codigo":898816651000119105,
    "descripcion":"ILEÍTIS TERMINAL EN REMISIÓN"
  },
  {
    "codigo":5771000119106,
    "descripcion":"SÍNDROME DE MIEMBRO FANTASMA CON DOLOR"
  },
  {
    "codigo":302088004,
    "descripcion":"HALLAZGO RELACIONADO CON LOS PARÁMETROS DE DESARROLLO DEL LACTANTE"
  },
  {
    "codigo":141451000119109,
    "descripcion":"TARTAMUDEZ DE COMIENZO EN LA VIDA ADULTA"
  },
  {
    "codigo":16064651000119108,
    "descripcion":"TRASTORNO DEBIDO A SÍNDROME DE GUILLAIN BARRÉ Y POSTERIOR A ÉL"
  },
  {
    "codigo":201949002,
    "descripcion":"ARTROPATÍA TRAUMÁTICA DE ARTICULACIÓN INTERFALÁNGICA DISTAL DE DEDO DE LA MANO"
  },
  {
    "codigo":365789002,
    "descripcion":"COMPOSICIÓN QUÍMICA DEL CÁLCULO - HALLAZGO"
  },
  {
    "codigo":398557001,
    "descripcion":"INFECCIÓN CAUSADA POR VIBRIÓN NO COLÉRICO"
  },
  {
    "codigo":167346001,
    "descripcion":"MICROSCOPIA DE ORINA: CRISTALES DE LEUCINA"
  },
  {
    "codigo":429490004,
    "descripcion":"TRASTORNO QUE AFECTA ESTRUCTURA TRASPLANTADA"
  },
  {
    "codigo":298418007,
    "descripcion":"AMPLITUD DE EXTENSIÓN ACTIVA DE LA COLUMNA CERVICAL AUMENTADA"
  },
  {
    "codigo":1671000,
    "descripcion":"BAZO SAGÚ"
  },
  {
    "codigo":3506008,
    "descripcion":"ESTENOSIS DE LA ARTERIA RETINIANA"
  },
  {
    "codigo":296583000,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE TIABENDAZOL"
  },
  {
    "codigo":396722008,
    "descripcion":"NIVEL SÉRICO DE MARCADOR TUMORAL DESCONOCIDO"
  },
  {
    "codigo":34439005,
    "descripcion":"HIPERPLASIA DEL ESTROMA OVÁRICO"
  },
  {
    "codigo":427655005,
    "descripcion":"HOLLÍN ALREDEDOR DE LA BOCA"
  },
  {
    "codigo":263815005,
    "descripcion":"MUCOPURULENTO"
  },
  {
    "codigo":198279007,
    "descripcion":"INTROITO VAGINAL LAXO"
  },
  {
    "codigo":1148551007,
    "descripcion":"CARCINOMA DUCTAL INFILTRANTE DE PÁNCREAS"
  },
  {
    "codigo":294748004,
    "descripcion":"ALERGIA A PROGESTERONA"
  },
  {
    "codigo":65372005,
    "descripcion":"TRASTORNO DE LA RESORCIÓN DE CARTÍLAGO"
  },
  {
    "codigo":720732006,
    "descripcion":"QUISTE Y TROFOZOÍTO DE ENTAMOEBA POLECKI"
  },
  {
    "codigo":129073001,
    "descripcion":"NECESITA ASISTENCIA PARA HACER COMPRAS"
  },
  {
    "codigo":1144881001,
    "descripcion":"HIPOPLASIA CONGÉNITA DE GLÁNDULA SEBÁCEA"
  },
  {
    "codigo":292913002,
    "descripcion":"REACCIÓN ADVERSA A LA NICLOSAMIDA"
  },
  {
    "codigo":63537005,
    "descripcion":"RELACIÓN SEXUAL PROTEGIDA"
  },
  {
    "codigo":718897009,
    "descripcion":"DISCAPACIDAD INTELECTUAL LIGADA AL CROMOSOMA X TIPO SEEMANOVA"
  },
  {
    "codigo":225542002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CICATRIZACIÓN CUTÁNEA"
  },
  {
    "codigo":127238003,
    "descripcion":"NEOPLASIA DE LOS GANGLIOS LINFÁTICOS PREAURICULARES"
  },
  {
    "codigo":94470004,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE HUESO PARIETAL"
  },
  {
    "codigo":291078004,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR OXAZEPAM"
  },
  {
    "codigo":28934007,
    "descripcion":"HIRSUTISMO INDEPENDIENTE DE ANDRÓGENOS"
  },
  {
    "codigo":782598008,
    "descripcion":"ALERGIA A TRIISOCIANATO DE TRIFENILMETANO"
  },
  {
    "codigo":717062009,
    "descripcion":"LESIÓN NO CARIADA EN MARGEN CERVICAL DE DIENTE"
  },
  {
    "codigo":59867002,
    "descripcion":"OSTEOMIELITIS AGUDA DE LOCALIZACIONES MÚLTIPLES"
  },
  {
    "codigo":71791000119104,
    "descripcion":"NEUROPATÍA PERIFÉRICA DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":422150008,
    "descripcion":"CÁPSULA ANTERIOR QUE RECUBRE LA LENTE INTRAOCULAR EN LOS 360 GRADOS"
  },
  {
    "codigo":1306886008,
    "descripcion":"GLAUCOMA PRIMARIO DE ÁNGULO ABIERTO CON PRESIÓN NORMAL DE AMBOS OJOS"
  },
  {
    "codigo":289243007,
    "descripcion":"PÉRDIDA MÍNIMA DE SANGRE MATERNA"
  },
  {
    "codigo":418480000,
    "descripcion":"MENINGOENCEFALITIS EOSINOFÍLICA CAUSADA POR ANGIOSTRONGYLUS CANTONENSIS"
  },
  {
    "codigo":1303216002,
    "descripcion":"RUPTURA DE LIGAMENTO DE DEDO DE MANO"
  },
  {
    "codigo":123568007,
    "descripcion":"ANOMALÍA CONGÉNITA DE HUESO DEL TARSO"
  },
  {
    "codigo":254640007,
    "descripcion":"NEOPLASIA BENIGNA DE PARÉNQUIMA PULMONAR"
  },
  {
    "codigo":416645004,
    "descripcion":"FRACTURA-LUXACIÓN EXPUESTA DE ARTICULACIÓN DE LA CINTURA ESCAPULAR"
  },
  {
    "codigo":711557005,
    "descripcion":"CONTRACCIÓN DE CAVIDAD ORBITARIA"
  },
  {
    "codigo":1137541006,
    "descripcion":"CALCIFICACIÓN PUNTEADA DE EPÍFISIS DE FALANGE DE DEDO DE MANO"
  },
  {
    "codigo":449413009,
    "descripcion":"DECLINACIÓN DEL PUNTAJE DE LA ESCALA DE DEPRESIÓN POSNATAL DE EDIMBURGO A LOS 8 MESES"
  },
  {
    "codigo":250970005,
    "descripcion":"ECOGENICIDAD DE LA PARED DEL VENTRÍCULO DERECHO"
  },
  {
    "codigo":1332314007,
    "descripcion":"TRASTORNO ÓSEO DE ARTICULACIÓN DE TOBILLO POSTERIOR A POLIOMIELITIS"
  },
  {
    "codigo":283738008,
    "descripcion":"MORDEDURA DE PERRO EN LA CARA"
  },
  {
    "codigo":314671003,
    "descripcion":"PESO DEL NIÑO: PERCENTILO 0,5-1,9"
  },
  {
    "codigo":127241000119104,
    "descripcion":"CHOQUE SÉPTICO CONCOMITANTE CON DISFUNCIÓN ORGÁNICA AGUDA DEBIDO A STAPHYLOCOCCUS"
  },
  {
    "codigo":15692041000119104,
    "descripcion":"ARTRITIS REUMATOIDEA SEROPOSITIVA DE ARTICULACIÓN DE AMBAS REGIONES DE MUÑECA"
  },
  {
    "codigo":773423007,
    "descripcion":"ACIDOSIS LÁCTICA NEONATAL SEVERA DEBIDA A DEFICIENCIA DE COMPLEJO NFS1-ISD11"
  },
  {
    "codigo":312836001,
    "descripcion":"ENTESOPATÍA DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":609583009,
    "descripcion":"INTERROGATORIO REPETITIVO"
  },
  {
    "codigo":83460007,
    "descripcion":"MADURACIÓN MEGACARIOCÍTICA NORMAL"
  },
  {
    "codigo":247300007,
    "descripcion":"CAPACIDAD PARA ESCUCHAR LA VOZ - HALLAZGO"
  },
  {
    "codigo":704217000,
    "descripcion":"FRACTURA EXPUESTA DE CUARTO METACARPIANO"
  },
  {
    "codigo":835289004,
    "descripcion":"AGUDEZA VISUAL DE OJO DERECHO 6\/4"
  },
  {
    "codigo":442073005,
    "descripcion":"INFECCIÓN CAUSADA POR STAPHYLOCOCCUS AUREUS SENSIBLE A LA METICILINA"
  },
  {
    "codigo":702382000,
    "descripcion":"MIOPATÍA POR CUERPOS DE INCLUSIÓN TIPO 2"
  },
  {
    "codigo":1162969009,
    "descripcion":"DOLOR AL MOVIMIENTO OCULAR"
  },
  {
    "codigo":210862002,
    "descripcion":"LESIÓN DE VASO SANGUÍNEO DE PULGAR"
  },
  {
    "codigo":346531000119102,
    "descripcion":"TRASTORNO DE AMBAS CÓRNEAS CAUSADO POR LENTES DE CONTACTO"
  },
  {
    "codigo":473006003,
    "descripcion":"BRADICARDIA AUTONÓMICA VAGAL DE LA PREMATUREZ"
  },
  {
    "codigo":276398005,
    "descripcion":"MUCOSA BUCAL HÚMEDA"
  },
  {
    "codigo":1259438002,
    "descripcion":"CARCINOMA PRIMARIO DE BASE DE LENGUA"
  },
  {
    "codigo":407470008,
    "descripcion":"ENFERMEDAD CAUSADA POR ORTHOBUNYAVIRUS"
  },
  {
    "codigo":733315001,
    "descripcion":"INFECCIÓN DE CÁMARA ANTERIOR DEL OJO CAUSADA POR PARÁSITO"
  },
  {
    "codigo":405635002,
    "descripcion":"SÍFILIS TARDÍA CON MANIFESTACIONES CLÍNICAS DIFERENTES A LA NEUROSÍFILIS"
  },
  {
    "codigo":209027007,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN MEDIOTARSIANA"
  },
  {
    "codigo":698712000,
    "descripcion":"HEMORRAGIA PREPARTO DEBIDA A PÓLIPO CERVICAL"
  },
  {
    "codigo":274563008,
    "descripcion":"CONTRACTURA MUSCULAR AUSENTE"
  },
  {
    "codigo":895320003,
    "descripcion":"FORMA DE BALA ANORMAL CONGÉNITA DE FALANGE PROXIMAL DE DEDO ÍNDICE"
  },
  {
    "codigo":403800004,
    "descripcion":"UÑAS EN RAQUETA HEREDITARIAS"
  },
  {
    "codigo":239960007,
    "descripcion":"SÍNDROME DE PELLIZCAMIENTO DE HOMBRO"
  },
  {
    "codigo":305496007,
    "descripcion":"BAJO ATENCIÓN DE ESPECIALISTA EN CUIDADOS PALIATIVOS"
  },
  {
    "codigo":74285003,
    "descripcion":"MASA PÉLVICA"
  },
  {
    "codigo":762413005,
    "descripcion":"ERROR DE IMPRONTA PATERNO"
  },
  {
    "codigo":41517009,
    "descripcion":"HIPERTROFIA CONGÉNITA DE HUESO ESFENOIDES"
  },
  {
    "codigo":203522001,
    "descripcion":"OSTEÓLISIS"
  },
  {
    "codigo":301826004,
    "descripcion":"ESTRIDOR INTERMITENTE"
  },
  {
    "codigo":400130008,
    "descripcion":"ARTERITIS TEMPORAL"
  },
  {
    "codigo":234455001,
    "descripcion":"ANOMALÍA DEL FIBRINÓGENO"
  },
  {
    "codigo":365527000,
    "descripcion":"HALLAZGO RELACIONADO CON LA REGULARIDAD DEL TRABAJO"
  },
  {
    "codigo":299991003,
    "descripcion":"INFECCIÓN DE DEDO DE LA MANO"
  },
  {
    "codigo":70615006,
    "descripcion":"QUERATITIS ESTRELLADA"
  },
  {
    "codigo":396460000,
    "descripcion":"DISPLASIA HEPATOCELULAR"
  },
  {
    "codigo":724140002,
    "descripcion":"SÍNDROME DE MICROESFEROFAQUIA CON DISPLASIA METAFISARIA"
  },
  {
    "codigo":298156003,
    "descripcion":"DERRAME DE ARTICULACIÓN VERTEBRAL"
  },
  {
    "codigo":789676005,
    "descripcion":"MONOCROMATISMO DE CONOS AZULES"
  },
  {
    "codigo":641000112101,
    "descripcion":"STREPTOCOCCUS DEL GRUPO C O STREPTOCOCCUS DEL GRUPO G DE LANCEFIELD"
  },
  {
    "codigo":230785002,
    "descripcion":"DISARTRIA CONGÉNITA"
  },
  {
    "codigo":296321004,
    "descripcion":"SOBREDOSIS DE COCAÍNA"
  },
  {
    "codigo":34177005,
    "descripcion":"REACCIÓN EXPLOSIVA INTERMITENTE"
  },
  {
    "codigo":1344897008,
    "descripcion":"OTITIS MEDIA SUPURATIVA DE OÍDO DERECHO"
  },
  {
    "codigo":427393009,
    "descripcion":"ELECTROCARDIOGRAMA: ARRITMIA SINUSAL"
  },
  {
    "codigo":425558002,
    "descripcion":"TRASTORNO DE AZOOSPERMIA"
  },
  {
    "codigo":65110003,
    "descripcion":"PIOMIOSITIS TROPICAL"
  },
  {
    "codigo":165249009,
    "descripcion":"SIN AYUDA EN LAS ESCALERAS"
  },
  {
    "codigo":292651000,
    "descripcion":"REACCIÓN ADVERSA A AGENTES EMOLIENTES"
  },
  {
    "codigo":294486009,
    "descripcion":"ALERGIA A ÁCIDO NALIDÍXICO"
  },
  {
    "codigo":63275006,
    "descripcion":"HIPOCALCEMIA POR LECHE DE VACA DEL RECIÉN NACIDO"
  },
  {
    "codigo":290816004,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR BUTRIPTILINA"
  },
  {
    "codigo":782336005,
    "descripcion":"INTOLERANCIA A LA LACTOSA POR DEFICIENCIA DE LACTASA EN OTRAS ENFERMEDADES QUE NO AFECTAN AL INTESTINO DELGADO"
  },
  {
    "codigo":126976007,
    "descripcion":"NEOPLASIA DEL NERVIO VAGO"
  },
  {
    "codigo":94208008,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE VASO SANGUÍNEO DE DEDO DE PIE"
  },
  {
    "codigo":92373002,
    "descripcion":"NEOPLASIA BENIGNA DE LA PIEL DEL PERINEO"
  },
  {
    "codigo":190677003,
    "descripcion":"SECUELAS DE LA HIPOVITAMINOSIS C"
  },
  {
    "codigo":11844311000119108,
    "descripcion":"LESIÓN TRAUMÁTICA DE OÍDO IZQUIERDO"
  },
  {
    "codigo":878805009,
    "descripcion":"CARCINOMA GRANULOCÍTICO RENAL"
  },
  {
    "codigo":1237418002,
    "descripcion":"SÍNDROME DE TETRAPLEJÍA ESPÁSTICA, CUERPO CALLOSO DELGADO Y MICROCEFALIA PROGRESIVA POSTNATAL"
  },
  {
    "codigo":15750001000119103,
    "descripcion":"BEBÉ PREMATURO, 28 SEMANAS"
  },
  {
    "codigo":285311001,
    "descripcion":"AMELOBLASTOMA MANDIBULAR"
  },
  {
    "codigo":1268351001,
    "descripcion":"CARCINOMA PRIMARIO DE CÉLULAS CLARAS DE RIÑÓN"
  },
  {
    "codigo":416383008,
    "descripcion":"ALTERACIÓN DEL AFECTO"
  },
  {
    "codigo":283476001,
    "descripcion":"HERIDA PUNZANTE EN LA REGIÓN PÉLVICA"
  },
  {
    "codigo":248873000,
    "descripcion":"HALLAZGO RELACIONADO CON EL TAMAÑO DE LA VAGINA"
  },
  {
    "codigo":707625001,
    "descripcion":"NEOPLASIA NEUROENDOCRINA DE LARINGE"
  },
  {
    "codigo":115966001,
    "descripcion":"ENFERMEDAD OCUPACIONAL"
  },
  {
    "codigo":445481009,
    "descripcion":"BLOQUEO BIFASCICULAR EN ELECTROCARDIOGRAMA"
  },
  {
    "codigo":1230078004,
    "descripcion":"PATRÓN DE USO NOCIVO DE ANSIOLÍTICO SIN DEPENDENCIA, EN REMISIÓN"
  },
  {
    "codigo":247038004,
    "descripcion":"VASOS SANGUÍNEOS EN IRIS"
  },
  {
    "codigo":1197310007,
    "descripcion":"ADENOCARCINOMA METASTÁSICO DE GANGLIO LINFÁTICO DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":441811002,
    "descripcion":"METAL PESADO EN ESPÉCIMEN DE ORINA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":81363003,
    "descripcion":"NEFROESCLEROSIS ARTERIOLAR MALIGNA"
  },
  {
    "codigo":736723008,
    "descripcion":"PRÓTESIS DENTAL PARCIAL CON AUMENTO DE LA DIMENSIÓN DE OCLUSIÓN VERTICAL"
  },
  {
    "codigo":1259176001,
    "descripcion":"ADENOCARCINOMA DE CABEZA"
  },
  {
    "codigo":46760003,
    "descripcion":"ANEMIA DE ESTREN - DAMESHEK"
  },
  {
    "codigo":210600005,
    "descripcion":"LESIÓN POR AVULSIÓN ANULAR, CLASE 1"
  },
  {
    "codigo":308904008,
    "descripcion":"HEMATEMESIS DE CAUSA DESCONOCIDA"
  },
  {
    "codigo":307069002,
    "descripcion":"SOSTIENE BEBIDAS"
  },
  {
    "codigo":700285006,
    "descripcion":"DISFUNCIÓN VELOFARÍNGEA CONGÉNITA"
  },
  {
    "codigo":1157202002,
    "descripcion":"NIVEL DE TRISTEZA PERSISTENTE DISMINUIDO"
  },
  {
    "codigo":403538005,
    "descripcion":"LENTIGINOSIS NEVOIDE"
  },
  {
    "codigo":237863002,
    "descripcion":"ACIDOSIS RESPIRATORIA Y ALCALOSIS METABÓLICA"
  },
  {
    "codigo":132261000119104,
    "descripcion":"TROMBOSIS VENOSA PROFUNDA AGUDA DE VENA TIBIAL"
  },
  {
    "codigo":236028000,
    "descripcion":"HIDROCELE INFANTIL"
  },
  {
    "codigo":399868002,
    "descripcion":"ANOMALÍA MICROVASCULAR INTRARRETINIANA DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":1153532005,
    "descripcion":"FOSFATO INORGÁNICO SÉRICO POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":299729001,
    "descripcion":"HALLAZGO RELACIONADO CON LAS MENINGES"
  },
  {
    "codigo":203260009,
    "descripcion":"PERIOSTITIS DE CÓCCIX SIN OSTEOMIELITIS"
  },
  {
    "codigo":301564009,
    "descripcion":"INCAPAZ DE MOVILIZARSE EN LUGARES ABIERTOS"
  },
  {
    "codigo":234193004,
    "descripcion":"ESTENOSIS ANASTOMÓTICA DE INJERTO VALVULAR"
  },
  {
    "codigo":679231000119101,
    "descripcion":"DEGENERACIÓN MARGINAL DE TERRIEN DE CÓRNEA PERIFÉRICA DE OJO IZQUIERDO"
  },
  {
    "codigo":266961004,
    "descripcion":"TRABAJADOR DE TURNO"
  },
  {
    "codigo":365265008,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA PREPARAR COMIDA EN FORMA HIGIÉNICA"
  },
  {
    "codigo":4817008,
    "descripcion":"DEMENCIA DEGENERATIVA PRIMARIA TIPO ALZHEIMER, DE INICIO EN LA EDAD SENIL, CON DELIRIO"
  },
  {
    "codigo":723878005,
    "descripcion":"OBSTRUCCIÓN DE VENA PERIFÉRICA"
  },
  {
    "codigo":363430007,
    "descripcion":"NEOPLASIA MALIGNA DE SUBGLOTIS"
  },
  {
    "codigo":296059000,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE FLURAZEPAM"
  },
  {
    "codigo":1344635001,
    "descripcion":"INFARTO CEREBRAL ISQUÉMICO IATROGÉNICO"
  },
  {
    "codigo":164987002,
    "descripcion":"PRUEBA DE KVEIM POSITIVA"
  },
  {
    "codigo":105791000119104,
    "descripcion":"INMUNIDAD CONTRA RUBÉOLA DETERMINADA POR SEROLOGÍA"
  },
  {
    "codigo":66683004,
    "descripcion":"MASTITIS ESTREPTOCÓCICA"
  },
  {
    "codigo":427131001,
    "descripcion":"SOBREDOSIS ACCIDENTAL CON CLORPROTIXENO"
  },
  {
    "codigo":785744001,
    "descripcion":"BRONQUITIS CONCOMITANTE CON SIBILANCIAS AGUDAS"
  },
  {
    "codigo":425296002,
    "descripcion":"INSATISFACCIÓN CON LOS SERVICIOS DE RECURSOS COMUNITARIOS"
  },
  {
    "codigo":230523009,
    "descripcion":"INFARTO DE LA RADIACIÓN ÓPTICA"
  },
  {
    "codigo":23871000119106,
    "descripcion":"SONAMBULISMO CONCOMITANTE CON TRASTORNO DE TERROR NOCTURNO"
  },
  {
    "codigo":294224007,
    "descripcion":"ALERGIA A SUXAMETONIO"
  },
  {
    "codigo":1088831000119107,
    "descripcion":"COLESTEATOMA DEL OÍDO EXTERNO IZQUIERDO"
  },
  {
    "codigo":292389002,
    "descripcion":"REACCIÓN ADVERSA AL DECANOATO DE FLUFENAZINA"
  },
  {
    "codigo":718373005,
    "descripcion":"PSEUDOLINFOMA CUTÁNEO DE LINFOCITOS B CAUSADO POR BORRELIA"
  },
  {
    "codigo":95781008,
    "descripcion":"NISTAGMO CONJUGADO"
  },
  {
    "codigo":93946000,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL LÓBULO PARIETAL"
  },
  {
    "codigo":243161000119102,
    "descripcion":"ECTROPIÓN ANAL"
  },
  {
    "codigo":1306362002,
    "descripcion":"NEOPLASIA BENIGNA DE CUADRANTE INFERIOR INTERNO DE MAMA"
  },
  {
    "codigo":225018005,
    "descripcion":"SE SIENTE NO QUERIDO"
  },
  {
    "codigo":126714009,
    "descripcion":"NEOPLASIA DEL LÓBULO SUPERIOR DERECHO DEL PULMÓN"
  },
  {
    "codigo":92111001,
    "descripcion":"NEOPLASIA BENIGNA DEL ANTEBRAZO"
  },
  {
    "codigo":12367321000119104,
    "descripcion":"TROMBO MURAL DE AURÍCULA DERECHA"
  },
  {
    "codigo":288719002,
    "descripcion":"CAPAZ DE HABLAR MIENTRAS JUEGA"
  },
  {
    "codigo":254116003,
    "descripcion":"GERODERMIA OSTEODISPLÁSICA"
  },
  {
    "codigo":450724008,
    "descripcion":"LESIÓN TRAUMÁTICA DE REGIÓN CERVICAL DORSAL"
  },
  {
    "codigo":188580008,
    "descripcion":"ENFERMEDAD DE HODGKIN, CELULARIDAD MIXTA DE GANGLIOS LINFÁTICOS INTRAPÉLVICOS"
  },
  {
    "codigo":285049007,
    "descripcion":"USA LENTILLAS"
  },
  {
    "codigo":414286000,
    "descripcion":"INTOXICACIÓN ALIMENTARIA CAUSADA POR VIBRIO VULNIFICUS"
  },
  {
    "codigo":217678000,
    "descripcion":"ENVENENAMIENTO DEBIDO A PICADURA DE MILPIÉS"
  },
  {
    "codigo":21070001,
    "descripcion":"PALUDISMO MIXTO"
  },
  {
    "codigo":22905009,
    "descripcion":"INFECCIÓN CAUSADA POR HETEROPHYES HETEROPHYES"
  },
  {
    "codigo":447054004,
    "descripcion":"SÍNDROME DE CHASQUIDO ROTULIANO"
  },
  {
    "codigo":283214005,
    "descripcion":"ANZUELO EN GLÚTEO"
  },
  {
    "codigo":707363001,
    "descripcion":"PEQUEÑO TUMOR BENIGNO DE PULMÓN"
  },
  {
    "codigo":1297187006,
    "descripcion":"QUEMADURA DE SEGUNDO DEDO DE PIE"
  },
  {
    "codigo":248611007,
    "descripcion":"MATIDEZ EN EL ESPACIO DE TRAUBE"
  },
  {
    "codigo":212173001,
    "descripcion":"LESIÓN MEDULAR DORSAL CENTRAL SIN LESIÓN OSTEOVERTEBRAL, T1-T6"
  },
  {
    "codigo":1162445004,
    "descripcion":"GASTRITIS CRÓNICA POR HELICOBACTER HEILMANNII"
  },
  {
    "codigo":408781009,
    "descripcion":"LÍQUIDO AMNIÓTICO COLOR PAJA"
  },
  {
    "codigo":1258914003,
    "descripcion":"HIPOMINERALIZACIÓN DENTAL"
  },
  {
    "codigo":108301000119103,
    "descripcion":"SODIO URINARIO POR ENCIMA DE RANGO DE REFERENCIA"
  },
  {
    "codigo":110199001,
    "descripcion":"QUEMADURA DE PRIMER GRADO DEL VESTÍBULO MAXILAR"
  },
  {
    "codigo":354061000119105,
    "descripcion":"NEOPLASIA BENIGNA DE URÉTER IZQUIERDO"
  },
  {
    "codigo":403276003,
    "descripcion":"HIPOMELANOSIS ADQUIRIDA DE ETIOLOGÍA INCIERTA"
  },
  {
    "codigo":698188003,
    "descripcion":"MASCA QUID DE BETEL"
  },
  {
    "codigo":370508005,
    "descripcion":"DEPLECIÓN LINFOCÍTICA"
  },
  {
    "codigo":1255244005,
    "descripcion":"FRACTURA NO EXPUESTA DE MÚLTIPLES HUESOS METACARPIANOS"
  },
  {
    "codigo":270369000,
    "descripcion":"HIPERPLASIA DE CÉLULAS DEL ESTROMA EN EL SÍNDROME DE INSENSIBILIDAD A ANDRÓGENOS"
  },
  {
    "codigo":237601000,
    "descripcion":"DIABETES MELLITUS ENDOCRINA SECUNDARIA"
  },
  {
    "codigo":40993007,
    "descripcion":"QUEMADURA DE TOBILLO"
  },
  {
    "codigo":6390002,
    "descripcion":"DISPERSIÓN FINA"
  },
  {
    "codigo":399606003,
    "descripcion":"TAMAÑO DEL ESPÉCIMEN, NO PUEDE SER DETERMINADO"
  },
  {
    "codigo":235766003,
    "descripcion":"ULCERACIÓN DEL INTESTINO GRUESO"
  },
  {
    "codigo":238131007,
    "descripcion":"SOBREPESO"
  },
  {
    "codigo":16711591000119103,
    "descripcion":"NEOVASCULARIZACIÓN DE RETINA DEBIDA A OCLUSIÓN DE RAMA DE VENA RETINIANA DE OJO DERECHO"
  },
  {
    "codigo":202998009,
    "descripcion":"ABSCESO DE BOLSA SEROSA DE LA CADERA"
  },
  {
    "codigo":102859001,
    "descripcion":"CRISTAL URINARIO, HIPURATO"
  },
  {
    "codigo":12205991000119104,
    "descripcion":"POSICIÓN ANÓMALA DE IMPLANTE DE MAMA DERECHA"
  },
  {
    "codigo":299467004,
    "descripcion":"HALLAZGO RELACIONADO CON LA PROPORCIÓN DEL PIE"
  },
  {
    "codigo":201163007,
    "descripcion":"HIPERTRICOSIS UNIVERSAL"
  },
  {
    "codigo":233931008,
    "descripcion":"CORAZÓN DE ATLETA"
  },
  {
    "codigo":363168001,
    "descripcion":"INFLAMACIÓN DE LA PIEL Y\/O DEL TEJIDO CELULAR SUBCUTÁNEO"
  },
  {
    "codigo":37323009,
    "descripcion":"HERPES SIMPLE RECURRENTE"
  },
  {
    "codigo":365003009,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD DE UTILIZAR CLICS AL HABLAR"
  },
  {
    "codigo":1286707009,
    "descripcion":"HIPERTENSIÓN OCULAR CAUSADA POR FÁRMACO"
  },
  {
    "codigo":68256003,
    "descripcion":"NIVEL DE GLUCOSA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":428704007,
    "descripcion":"EFECTO TARDÍO DE DISTENSIÓN MUSCULAR"
  },
  {
    "codigo":295797001,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE VINDESINA"
  },
  {
    "codigo":197493001,
    "descripcion":"MALABSORCIÓN DEBIDA A INTOLERANCIA A PROTEÍNA DE SOJA"
  },
  {
    "codigo":15702081000119101,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE TENDÓN DE HOMBRO DERECHO"
  },
  {
    "codigo":721781004,
    "descripcion":"INFECCIÓN CAUSADA POR VIRUS DE LA CORIOMENINGITIS LINFOCÍTICA"
  },
  {
    "codigo":232096009,
    "descripcion":"ESOTROPÍA CON NISTAGMO EN BLOQUE"
  },
  {
    "codigo":230261006,
    "descripcion":"PARAPLEJÍA ESPÁSTICA HEREDITARIA COMPLICADA"
  },
  {
    "codigo":263029007,
    "descripcion":"LUXACIÓN DE ARTICULACIÓN FEMORORROTULIANA"
  },
  {
    "codigo":11851841000119102,
    "descripcion":"CONTUSIÓN DE MITAD DERECHA DE PARED TORÁCICA POSTERIOR"
  },
  {
    "codigo":33653009,
    "descripcion":"AUSENCIA DE SENSACIÓN"
  },
  {
    "codigo":64586002,
    "descripcion":"ESTENOSIS CAROTÍDEA"
  },
  {
    "codigo":195658003,
    "descripcion":"FARINGITIS BACTERIANA AGUDA"
  },
  {
    "codigo":719946008,
    "descripcion":"SÍNDROME DE CAMPTODACTILIA DE TEL HASHOMER"
  },
  {
    "codigo":293962009,
    "descripcion":"ALERGIA A ANTAGONISTA DE RECEPTOR BETA ADRENÉRGICO"
  },
  {
    "codigo":95519003,
    "descripcion":"NECROSIS MUCOSA GASTROINTESTINAL"
  },
  {
    "codigo":62856000,
    "descripcion":"OTOESCLEROSIS NO OBLITERANTE QUE COMPROMETE A LA VENTANA OVAL"
  },
  {
    "codigo":128287004,
    "descripcion":"ÚLCERA PÉPTICA CRÓNICA"
  },
  {
    "codigo":292127006,
    "descripcion":"REACCIÓN ADVERSA AL CAOLÍN"
  },
  {
    "codigo":60916008,
    "descripcion":"ESQUISTOSOMIASIS CARDIOPULMONAR"
  },
  {
    "codigo":91849001,
    "descripcion":"ACEFALOSTOMÍA"
  },
  {
    "codigo":716276009,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE RODILLA"
  },
  {
    "codigo":93684008,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA AXILA"
  },
  {
    "codigo":124617006,
    "descripcion":"DEFICIENCIA DE ACONITATO HIDRATASA"
  },
  {
    "codigo":1171358000,
    "descripcion":"GASTRITIS CRÓNICA POR HELICOBACTER PYLORI"
  },
  {
    "codigo":57246001,
    "descripcion":"ÚLCERA GÁSTRICA CRÓNICA CON HEMORRAGIA"
  },
  {
    "codigo":286622004,
    "descripcion":"LACERACIÓN DE ENCÍAS"
  },
  {
    "codigo":1204126008,
    "descripcion":"ATEROEMBOLIA DE COLESTEROL DE ARTERIA DIGITAL"
  },
  {
    "codigo":188318009,
    "descripcion":"NEOPLASIA MALIGNA DE LA MEMBRANA ARACNOIDES RAQUÍDEA"
  },
  {
    "codigo":284787001,
    "descripcion":"INCAPAZ DE LAVARSE"
  },
  {
    "codigo":315400000,
    "descripcion":"NACIDO EN LA REPÚBLICA CENTRAL AFRICANA"
  },
  {
    "codigo":448627003,
    "descripcion":"ANILLO VASCULAR CON CAYADO AÓRTICO IZQUIERDO Y CONDUCTO ARTERIAL DERECHO ORIGINADO EN ARTERIA BRAQUIOCEFÁLICA RETROESOFÁGICA ABERRANTE"
  },
  {
    "codigo":253854008,
    "descripcion":"FIMOSIS CONGÉNITA"
  },
  {
    "codigo":282952006,
    "descripcion":"DIFICULTAD PARA INCLINARSE Y TOCARSE LOS PIES"
  },
  {
    "codigo":1003848008,
    "descripcion":"RECOARTACIÓN AÓRTICA LUEGO DE PROCEDIMIENTO"
  },
  {
    "codigo":414024009,
    "descripcion":"TRASTORNO DE ARTERIA CORONARIA"
  },
  {
    "codigo":1264157002,
    "descripcion":"DESEQUILIBRIO ELECTROLÍTICO POSTERIOR A EMBARAZO ECTÓPICO"
  },
  {
    "codigo":330101000119101,
    "descripcion":"RUPTURA DE ANEURISMA CONGÉNITO DE ARTERIA CEREBRAL"
  },
  {
    "codigo":444957003,
    "descripcion":"MENINGOMIELITIS BACTERIANA"
  },
  {
    "codigo":18973006,
    "descripcion":"PROLAPSO UTEROVAGINAL"
  },
  {
    "codigo":82674000,
    "descripcion":"INTOXICACIÓN POR PENICILINASA"
  },
  {
    "codigo":836338008,
    "descripcion":"AGUDEZA VISUAL CON AGUJERO ESTENOPEICO DE OJO DERECHO 6\/60"
  },
  {
    "codigo":15649141000119104,
    "descripcion":"ANEURISMA DE ARTERIA ILÍACA INTERNA IZQUIERDA"
  },
  {
    "codigo":1293255004,
    "descripcion":"INFILTRADO DE CÓRNEA POSTERIOR A QUERATOMILEUSIS IN SITU ASISTIDA CON LÁSER"
  },
  {
    "codigo":408519004,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: TAILANDÉS"
  },
  {
    "codigo":211911007,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL PROFUNDA DE DÍGITO DE LA MANO"
  },
  {
    "codigo":210076002,
    "descripcion":"LACERACIÓN PULMONAR CON HERIDA ABIERTA HACIA EL TÓRAX"
  },
  {
    "codigo":13468005,
    "descripcion":"DENTINA SENSIBLE"
  },
  {
    "codigo":208241000,
    "descripcion":"FRACTURA NO EXPUESTA DE HÚMERO PROXIMAL, CUELLO ANATÓMICO"
  },
  {
    "codigo":109937001,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LOS NERVIOS PERIFÉRICOS DEL MIEMBRO INFERIOR"
  },
  {
    "codigo":699761007,
    "descripcion":"RETINOCOROIDITIS FOCAL PARAMACULAR"
  },
  {
    "codigo":697926000,
    "descripcion":"HIPERTENSIÓN PULMONAR DEBIDA A DISFUNCIÓN VENTRICULAR SISTÉMICA DIASTÓLICA"
  },
  {
    "codigo":403014003,
    "descripcion":"TIÑA DE CUERO CABELLUDO CAUSADA POR TRICHOPHYTON MENTAGROPHYTES"
  },
  {
    "codigo":763462004,
    "descripcion":"SÍNDROME DE PTERIGIÓN MÚLTIPLE LETAL LIGADO AL CROMOSOMA X"
  },
  {
    "codigo":239174004,
    "descripcion":"CICATRIZ PIGMENTADA"
  },
  {
    "codigo":370246004,
    "descripcion":"LACERACIÓN SUPERFICIAL DEL MIEMBRO SUPERIOR"
  },
  {
    "codigo":10625551000119103,
    "descripcion":"BRONCONEUMONÍA CAUSADA POR VIRUS SINCICIAL RESPIRATORIO"
  },
  {
    "codigo":237339000,
    "descripcion":"INFECCIÓN - HERIDA PERINEAL"
  },
  {
    "codigo":206406008,
    "descripcion":"HEMATEMESIS PERINATAL"
  },
  {
    "codigo":827163002,
    "descripcion":"PERICARDITIS POSTERIOR A INFARTO DE MIOCARDIO TEMPRANA"
  },
  {
    "codigo":302875001,
    "descripcion":"HÁBITO DE CHUPARSE EL DEDO"
  },
  {
    "codigo":1187611003,
    "descripcion":"SALIDA DEL SERVICIO MILITAR"
  },
  {
    "codigo":202736000,
    "descripcion":"PROLAPSO DE DISCO INTERVERTEBRAL LUMBAR CON COMPRESIÓN DE LA COLA DE CABALLO"
  },
  {
    "codigo":366576003,
    "descripcion":"AMPLITUD DE MOVIMIENTO ACTIVO DE ROTACIÓN INTERNA DE LA CADERA - HALLAZGO"
  },
  {
    "codigo":169968005,
    "descripcion":"AMAMANTADO A LOS 10 DÍAS"
  },
  {
    "codigo":10926761000119100,
    "descripcion":"FRACTURA NO EXPUESTA DE DIÁFISIS DE PRIMER METACARPIANO DE MANO IZQUIERDA"
  },
  {
    "codigo":6128007,
    "descripcion":"INFESTACIÓN CAUSADA POR CERATOPHYLLUS"
  },
  {
    "codigo":364741000,
    "descripcion":"PUNTAJE DE APGAR AL MINUTO - HALLAZGO"
  },
  {
    "codigo":37061001,
    "descripcion":"NEFROPATÍA GRANULOMATOSA SARCOIDE"
  },
  {
    "codigo":233669000,
    "descripcion":"DISCINESIA CILIAR SECUNDARIA"
  },
  {
    "codigo":69829003,
    "descripcion":"RUIDO DE EYECCIÓN AÓRTICA"
  },
  {
    "codigo":15678121000119101,
    "descripcion":"COROIDITIS BILATERAL POR TOXOPLASMA"
  },
  {
    "codigo":397509005,
    "descripcion":"IMPLANTES DE TUMOR NO INVASIVO (DESMOPLÁSTICO) DE OVARIO EN EPIPLÓN, PRESENTES"
  },
  {
    "codigo":299205007,
    "descripcion":"HALLAZGO RELACIONADO CON TEMPERATURA DE ARTICULACIÓN DE PULGAR"
  },
  {
    "codigo":788890003,
    "descripcion":"INFLAMACIÓN CRÓNICA DE GANGLIO LINFÁTICO INGUINAL"
  },
  {
    "codigo":231834005,
    "descripcion":"MELANOMA MALIGNO PALPEBRAL"
  },
  {
    "codigo":262767007,
    "descripcion":"CONTUSIÓN DE GLÁNDULA SALIVAL"
  },
  {
    "codigo":295535008,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE HALOTANO"
  },
  {
    "codigo":129860001,
    "descripcion":"TRASTORNO CINESTÉSICO"
  },
  {
    "codigo":721519009,
    "descripcion":"SÍNDROME DEL CORDÓN POSTERIOR DE MÉDULA ESPINAL AL NIVEL DEL SEGUNDO SEGMENTO LUMBAR"
  },
  {
    "codigo":64324003,
    "descripcion":"DACRIOCISTITIS FLEMONOSA"
  },
  {
    "codigo":787055009,
    "descripcion":"EXCAVACIÓN DE PAPILA ÓPTICA IZQUIERDA"
  },
  {
    "codigo":719684000,
    "descripcion":"SÍNDROME DE MICRODUPLICACIÓN 8Q12"
  },
  {
    "codigo":293700007,
    "descripcion":"ALERGIA A ÁCIDO DEHIDROCÓLICO"
  },
  {
    "codigo":195396009,
    "descripcion":"TROMBOFLEBITIS SUPERFICIAL DE VENA SAFENA INTERNA"
  },
  {
    "codigo":291865003,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR CORTICOTROPINA"
  },
  {
    "codigo":193561006,
    "descripcion":"GLAUCOMA DE ÁNGULO CERRADO SECUNDARIO CON BLOQUEO PUPILAR"
  },
  {
    "codigo":259097007,
    "descripcion":"DERMATITIS FOTOALÉRGICA RETARDADA"
  },
  {
    "codigo":160793008,
    "descripcion":"RUPTURA MARITAL"
  },
  {
    "codigo":93422001,
    "descripcion":"SENSIBILIDAD DE LA RAÍZ DENTAL"
  },
  {
    "codigo":781550002,
    "descripcion":"INTOXICACIÓN POR SAPINDACEAE"
  },
  {
    "codigo":425021000221107,
    "descripcion":"TROMBOCITOPENIA TROMBÓTICA INDUCIDA POR VACUNA"
  },
  {
    "codigo":27886001,
    "descripcion":"QUERATITIS ESCLEROSANTE"
  },
  {
    "codigo":16906921000119108,
    "descripcion":"NEOPLASIA BENIGNA DE PIEL DE PÁRPADO INFERIOR IZQUIERDO"
  },
  {
    "codigo":421102007,
    "descripcion":"ANEMIA APLÁSICA CON SIDA (SÍNDROME DE INMUNODEFICIENCIA ADQUIRIDA)"
  },
  {
    "codigo":191726007,
    "descripcion":"FOBIA SOCIAL, MIEDO A LAVARSE EN PÚBLICO"
  },
  {
    "codigo":26051005,
    "descripcion":"OSTEÍTIS DE MUSLO"
  },
  {
    "codigo":124355007,
    "descripcion":"DEFICIENCIA DE ETANOLAMINA - FOSFATO CITIDILILTRANSFERASA"
  },
  {
    "codigo":253592001,
    "descripcion":"ATRESIA DE VÁLVULA PULMONAR SIN TRACTO DE SALIDA VENTRICULAR"
  },
  {
    "codigo":1269400003,
    "descripcion":"HIPERSENSIBILIDAD A ÁCIDO NALIDÍXICO"
  },
  {
    "codigo":251757002,
    "descripcion":"DIPLOPÍA PARADÓJICA"
  },
  {
    "codigo":53314000,
    "descripcion":"ACATAMATESIA"
  },
  {
    "codigo":284525009,
    "descripcion":"TOQUE COMPULSIVO"
  },
  {
    "codigo":315458000,
    "descripcion":"NACIDO EN KOSOVO"
  },
  {
    "codigo":708674003,
    "descripcion":"DISPLASIA HEMIMAXILOFACIAL"
  },
  {
    "codigo":282690003,
    "descripcion":"CAPAZ DE EMPUJAR Y ARRASTRAR HACIA ADELANTE UN JUGUETE GRANDE CON RUEDAS"
  },
  {
    "codigo":413762006,
    "descripcion":"CUIDADOR DE PERSONA CON PROBLEMA DE SALUD MENTAL"
  },
  {
    "codigo":774210006,
    "descripcion":"NEVO DE PELO DE ANGORA"
  },
  {
    "codigo":1003586008,
    "descripcion":"SINOSTOSIS CONGÉNITA DE SUTURA CORONAL DE CRÁNEO"
  },
  {
    "codigo":1296663002,
    "descripcion":"BEETURIA"
  },
  {
    "codigo":870679003,
    "descripcion":"REACCIÓN ADVERSA A PIRETROIDE"
  },
  {
    "codigo":248087004,
    "descripcion":"COMPORTAMIENTO ABIERTAMENTE SEXUALIZADO EN LA INFANCIA"
  },
  {
    "codigo":279020002,
    "descripcion":"DOLOR EN LOS ÓRGANOS GENITALES MASCULINOS"
  },
  {
    "codigo":16876006,
    "descripcion":"PERICARDITIS SECUNDARIA A TUMOR PRIMARIO"
  },
  {
    "codigo":277185000,
    "descripcion":"SCHWANNOMA DEL TRIGÉMINO"
  },
  {
    "codigo":735937001,
    "descripcion":"DOLOR AGUDO DE CARA"
  },
  {
    "codigo":703169005,
    "descripcion":"INSUFICIENCIA AGUDA DE VÁLVULA AÓRTICA PROTÉSICA"
  },
  {
    "codigo":211649008,
    "descripcion":"CUERPO EXTRAÑO EN VEJIGA URINARIA"
  },
  {
    "codigo":80577009,
    "descripcion":"ALEXIA CORTICAL"
  },
  {
    "codigo":111510002,
    "descripcion":"PTISIS BULBI"
  },
  {
    "codigo":766870005,
    "descripcion":"SÍNDROME DE DISPLASIA EPIFISARIA, PÉRDIDA DE LA AUDICIÓN Y DISMORFISMO"
  },
  {
    "codigo":275350007,
    "descripcion":"DEFORMIDAD FIJA EN FLEXIÓN DE DEDO PULGAR"
  },
  {
    "codigo":209814007,
    "descripcion":"DESGARRO COMPLETO, LIGAMENTO SACROTUBEROSO"
  },
  {
    "codigo":45974008,
    "descripcion":"AMPOLLA GINGIVAL SIN INFECCIÓN"
  },
  {
    "codigo":13206009,
    "descripcion":"DESPLAZAMIENTO TRAQUEAL"
  },
  {
    "codigo":240747003,
    "descripcion":"BLASTOMICOSIS PULMONAR CRÓNICA"
  },
  {
    "codigo":109675004,
    "descripcion":"FÍSTULA OROANTRAL"
  },
  {
    "codigo":371819005,
    "descripcion":"PACIENTE CON ASISTENCIA CIRCULATORIA"
  },
  {
    "codigo":11371006,
    "descripcion":"PIGMENTACIÓN DE LA PIEL POR MERCURIO"
  },
  {
    "codigo":30351000175101,
    "descripcion":"ÚLCERA POR PRESIÓN EN CABEZA, ESTADIO IV"
  },
  {
    "codigo":402752000,
    "descripcion":"DERMATOSIS DEBIDA A TRATAMIENTO CITOTÓXICO"
  },
  {
    "codigo":271680001,
    "descripcion":"BORDE HEPÁTICO PALPABLE"
  },
  {
    "codigo":75072002,
    "descripcion":"MIOPATÍA NEMALÍNICA"
  },
  {
    "codigo":207979003,
    "descripcion":"FRACTURA EXPUESTA VERTICAL DEL SACRO"
  },
  {
    "codigo":1156416002,
    "descripcion":"ASTROCITOMA GEMISTOCÍTICO DE CEREBRO"
  },
  {
    "codigo":689271000119105,
    "descripcion":"CARCINOMA PRIMARIO DE CÉLULAS ESCAMOSAS DE PREPUCIO"
  },
  {
    "codigo":413875004,
    "descripcion":"FRACTURA NO EXPUESTA DE CABEZA DE HÚMERO"
  },
  {
    "codigo":106005003,
    "descripcion":"HIPERTENSIÓN Y\/O VÓMITOS QUE COMPLICAN EL NACIMIENTO Y\/O EL PUERPERIO"
  },
  {
    "codigo":237077003,
    "descripcion":"OCLUSIÓN DE CUERNO UTERINO"
  },
  {
    "codigo":73237007,
    "descripcion":"SINUSITIS ETMOIDAL CRÓNICA"
  },
  {
    "codigo":300778001,
    "descripcion":"DIFICULTAD PARA JUGAR"
  },
  {
    "codigo":89361000119103,
    "descripcion":"TRASTORNO DEL DESARROLLO DE LA ARTICULACIÓN LEVE"
  },
  {
    "codigo":366314006,
    "descripcion":"EXCITACIÓN CERVICAL - HALLAZGO"
  },
  {
    "codigo":724927008,
    "descripcion":"LACERACIÓN DE BÍCEPS BRAQUIAL"
  },
  {
    "codigo":298943009,
    "descripcion":"TUMEFACCIÓN DE PARTES BLANDAS DE ARTICULACIÓN DE MUÑECA"
  },
  {
    "codigo":36799008,
    "descripcion":"DEFICIENCIA DE GLUTAMATO - CISTEÍNA LIGASA"
  },
  {
    "codigo":34964002,
    "descripcion":"PERITONITIS SIFILÍTICA"
  },
  {
    "codigo":723092003,
    "descripcion":"TEMOR A ENFERMEDAD RESPIRATORIA"
  },
  {
    "codigo":33129002,
    "descripcion":"SÍNDROME DE LINFOEDEMA POSMASTECTOMÍA"
  },
  {
    "codigo":721257005,
    "descripcion":"INFECCIÓN DE GLÁNDULA LAGRIMAL CAUSADA POR VIRUS"
  },
  {
    "codigo":295273006,
    "descripcion":"SOBREDOSIS INTENCIONAL DE NABUMETONA"
  },
  {
    "codigo":308651000119102,
    "descripcion":"GANGLIÓN DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":293438005,
    "descripcion":"REACCIÓN ADVERSA A LOS ANTIARRÍTMICOS DE CLASE I"
  },
  {
    "codigo":129598007,
    "descripcion":"HIPEREMESIS GRAVÍDICA GRAVE"
  },
  {
    "codigo":291603005,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR CEFTIZOXIMA"
  },
  {
    "codigo":94995006,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL TEJIDO PERISUPRARRENAL"
  },
  {
    "codigo":238600001,
    "descripcion":"PSORIASIS DE LOS PLIEGUES"
  },
  {
    "codigo":27624003,
    "descripcion":"ENFERMEDAD CRÓNICA"
  },
  {
    "codigo":93160004,
    "descripcion":"LIPOMA DE PIEL Y TEJIDO CELULAR SUBCUTÁNEO DEL CUELLO"
  },
  {
    "codigo":41931000087107,
    "descripcion":"TENDINITIS DE BÍCEPS BRAQUIAL DERECHO"
  },
  {
    "codigo":1010664005,
    "descripcion":"SÍNDROME DE STICKLER TIPO 2"
  },
  {
    "codigo":715752006,
    "descripcion":"ATAXIA ESPINOCEREBELOSA TIPO 6"
  },
  {
    "codigo":39371000087107,
    "descripcion":"ESGUINCE DE LIGAMENTO DE ARTICULACIÓN RADIOCUBITAL DISTAL IZQUIERDA"
  },
  {
    "codigo":191464005,
    "descripcion":"DEMENCIA ARTERIOSCLERÓTICA CON DELIRIO"
  },
  {
    "codigo":47051000087109,
    "descripcion":"FRACTURA DE FALANGE PROXIMAL DE DEDO MEÑIQUE DERECHO"
  },
  {
    "codigo":289768005,
    "descripcion":"CUELLO UTERINO GRUESO"
  },
  {
    "codigo":224232006,
    "descripcion":"DUERME EN CASA DE AMIGOS"
  },
  {
    "codigo":1303741005,
    "descripcion":"DESPLAZAMIENTO DE TUBO DE OJO DERECHO DEBIDO A CIRUGÍA DE GLAUCOMA Y POSTERIOR A ELLA"
  },
  {
    "codigo":58557008,
    "descripcion":"ESPINA BÍFIDA ABIERTA"
  },
  {
    "codigo":419005008,
    "descripcion":"PRESIÓN OCULAR POSTERIOR"
  },
  {
    "codigo":56722001,
    "descripcion":"INFECCIÓN CAUSADA POR BALANTIDIUM COLI"
  },
  {
    "codigo":187794005,
    "descripcion":"NEOPLASIA MALIGNA DE ISLOTES DE LANGERHANS"
  },
  {
    "codigo":253330006,
    "descripcion":"CONDUCTO VENOSO PERMEABLE"
  },
  {
    "codigo":23954006,
    "descripcion":"PRESENTACIÓN DE HOMBROS"
  },
  {
    "codigo":218727000,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR ANESTÉSICO RAQUÍDEO"
  },
  {
    "codigo":448103004,
    "descripcion":"VENTRÍCULO DERECHO POR DEBAJO DE VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":251495006,
    "descripcion":"ANOMALÍA ELECTROENCEFALOGRÁFICA FOCAL EPISÓDICA"
  },
  {
    "codigo":413500003,
    "descripcion":"SOCIEDAD ESTADOUNIDENSE DE ANESTESISTAS - ESTADO FÍSICO CLASE 6"
  },
  {
    "codigo":184124003,
    "descripcion":"REGISTRO DEL PACIENTE - INVESTIGACIÓN DE DATOS"
  },
  {
    "codigo":1003324007,
    "descripcion":"SINOSTOSIS TIBIOPERONEA CONGÉNITA BILATERAL"
  },
  {
    "codigo":313361002,
    "descripcion":"EXOSTOSIS DE PIE"
  },
  {
    "codigo":337631000119102,
    "descripcion":"ENTROPIÓN ESPÁSTICO DE PÁRPADO IZQUIERDO"
  },
  {
    "codigo":1263633009,
    "descripcion":"TRASTORNO FETAL DEBIDO A MALPOSICIÓN DURANTE TRABAJO DE PARTO"
  },
  {
    "codigo":247825008,
    "descripcion":"ANSIEDAD ACERCA DE LA CONDUCTA O EL DESEMPEÑO"
  },
  {
    "codigo":213222008,
    "descripcion":"COMPLICACIONES RESPIRATORIAS DE LA ASISTENCIA"
  },
  {
    "codigo":1163494008,
    "descripcion":"GASTRITIS POR MYCOBACTERIUM NO TUBERCULOSIS"
  },
  {
    "codigo":735675004,
    "descripcion":"LESIÓN TRAUMÁTICA DEBIDA A IMPLANTE DE DISPOSITIVO Y POSTERIOR A ÉL"
  },
  {
    "codigo":14779006,
    "descripcion":"HIPOTIROIDISMO CONSECUTIVO A RADIOTERAPIA EXTERNA"
  },
  {
    "codigo":209552004,
    "descripcion":"ESGUINCE DE LIGAMENTO SACROTUBEROSO"
  },
  {
    "codigo":1290896005,
    "descripcion":"CONDROSARCOMA DE CÉLULAS CLARAS"
  },
  {
    "codigo":111248006,
    "descripcion":"DIÁSTASIS DE MÚSCULO"
  },
  {
    "codigo":11109001,
    "descripcion":"ABORTO ESPONTÁNEO CON UREMIA"
  },
  {
    "codigo":699237001,
    "descripcion":"CONSENTIMIENTO OTORGADO PARA COMUNICACIÓN MEDIANTE SERVICIO DE MENSAJES DE TEXTO"
  },
  {
    "codigo":406160009,
    "descripcion":"FUNCIÓN PARENTAL ALTERADA"
  },
  {
    "codigo":240485004,
    "descripcion":"RUBÉOLA HEMORRÁGICA"
  },
  {
    "codigo":109413005,
    "descripcion":"FACIOSINOSTOSIS FRONTOMALAR"
  },
  {
    "codigo":369722000,
    "descripcion":"G3: NÚCLEOS MUY IRREGULARES, DE 20 Μ APROXIMADAMENTE; NUCLÉOLOS GRANDES Y PROMINENTES"
  },
  {
    "codigo":311161000119102,
    "descripcion":"MIOSITIS INTERSTICIAL DE HOMBRO DERECHO"
  },
  {
    "codigo":1354597009,
    "descripcion":"DEFECTO AUTOSÓMICO RECESIVO DE REPARACIÓN DE ADN DEBIDO A DEFICIENCIA DE POLE2"
  },
  {
    "codigo":11861881000119103,
    "descripcion":"RUPTURA TRAUMÁTICA DE LIGAMENTO LATERAL EXTERNO DE ARTICULACIÓN DE RODILLA IZQUIERDA"
  },
  {
    "codigo":402490007,
    "descripcion":"CALCINOSIS LUEGO DE ESTEATONECROSIS LOCALIZADA"
  },
  {
    "codigo":74810008,
    "descripcion":"SÍNDROME DE CORTEZA PREMOTORA"
  },
  {
    "codigo":204047001,
    "descripcion":"ANOMALÍAS CEREBELOSAS"
  },
  {
    "codigo":236815006,
    "descripcion":"HIPOESPERMATOGÉNESIS POR DROGADEPENDENCIA"
  },
  {
    "codigo":5604000,
    "descripcion":"HIPERTIROIDISMO NEONATAL TRANSITORIO"
  },
  {
    "codigo":366052001,
    "descripcion":"PERMEABILIDAD LAGRIMAL - HALLAZGO"
  },
  {
    "codigo":171279008,
    "descripcion":"INMUNIZACIÓN PENDIENTE"
  },
  {
    "codigo":202212003,
    "descripcion":"SUBLUXACIÓN ANTERIOR RECIDIVANTE DE HOMBRO"
  },
  {
    "codigo":38372004,
    "descripcion":"LESIÓN TRAUMÁTICA DE CEJA"
  },
  {
    "codigo":234980005,
    "descripcion":"MANCHADO DENTARIO EXTRÍNSECO - NEGRO"
  },
  {
    "codigo":12245011000119100,
    "descripcion":"MAL FUNCIONAMIENTO DE DESFIBRILADOR CARDIOVERSOR IMPLANTABLE AUTOMÁTICO"
  },
  {
    "codigo":300516008,
    "descripcion":"GLANDE DEL PENE GRANDE"
  },
  {
    "codigo":298681001,
    "descripcion":"COLUMNA LUMBAR FRÍA AL TACTO"
  },
  {
    "codigo":429753001,
    "descripcion":"MIOPATÍA CONGÉNITA NO PROGRESIVA CON SECUENCIAS DE MOEBIUS Y ROBIN"
  },
  {
    "codigo":724665004,
    "descripcion":"ALTERACIONES PERCEPTIVAS CONCOMITANTES CON ABSTINENCIA DE SEDANTE Y DEBIDAS A ELLA"
  },
  {
    "codigo":167609007,
    "descripcion":"COLOR DE LA MATERIA FECAL: VERDE"
  },
  {
    "codigo":822969007,
    "descripcion":"CISTOADENOCARCINOMA DE CÉLULAS ACINARES DE PULMÓN"
  },
  {
    "codigo":722830001,
    "descripcion":"ENFERMEDAD INFLAMATORIA AGUDA DE PELVIS FEMENINA DESPUÉS DE PROCEDIMIENTO"
  },
  {
    "codigo":1279886003,
    "descripcion":"DISTROFIA MUSCULAR DE CINTURAS D4 ASOCIADA A CALPAÍNA 3"
  },
  {
    "codigo":12107641000119109,
    "descripcion":"INFECCIÓN ASOCIADA CON PRÓTESIS ARTICULAR DE CODO IZQUIERDO"
  },
  {
    "codigo":296846007,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE DEXAMETASONA"
  },
  {
    "codigo":34702008,
    "descripcion":"MOVIMIENTO PARADÓJICO DE LAS COSTILLAS INFERIORES"
  },
  {
    "codigo":196707000,
    "descripcion":"ÚLCERA GASTROYEYUNAL AGUDA"
  },
  {
    "codigo":426083000,
    "descripcion":"MARCAPASOS CARDÍACO ACTIVO EN EL ELECTROCARDIOGRAMA"
  },
  {
    "codigo":165774008,
    "descripcion":"PRUEBA DE COOMBS INDIRECTA NEGATIVA"
  },
  {
    "codigo":120851000119104,
    "descripcion":"INSUFICIENCIA CARDÍACA SISTÓLICA, ESTADIO D"
  },
  {
    "codigo":1343587000,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE TENDÓN DE PIERNA"
  },
  {
    "codigo":131171006,
    "descripcion":"METAHEMOGLOBINA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":293176006,
    "descripcion":"REACCIÓN ADVERSA A LA BUDESONIDA TÓPICA"
  },
  {
    "codigo":719160009,
    "descripcion":"DISCAPACIDAD INTELECTUAL SINDRÓMICA LIGADA AL CROMOSOMA X TIPO 7"
  },
  {
    "codigo":225805001,
    "descripcion":"PRESIONADO POR LOS PADRES"
  },
  {
    "codigo":1208845005,
    "descripcion":"HIPERTENSIÓN ARTERIAL SECUNDARIA A TRASTORNO CARDÍACO CONGÉNITO"
  },
  {
    "codigo":94733007,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA AMPOLLA DE VATER"
  },
  {
    "codigo":125666000,
    "descripcion":"QUEMADURA"
  },
  {
    "codigo":29197009,
    "descripcion":"MENINGOENCEFALOMIELITIS"
  },
  {
    "codigo":60130002,
    "descripcion":"SINUSITIS FRONTAL CRÓNICA"
  },
  {
    "codigo":340141000119103,
    "descripcion":"QUERATOMALACIA DE OJO IZQUIERDO"
  },
  {
    "codigo":27362007,
    "descripcion":"DISLOGIA"
  },
  {
    "codigo":92898008,
    "descripcion":"FORMA ANORMAL CONGÉNITA DEL CARPO"
  },
  {
    "codigo":191202009,
    "descripcion":"ENFERMEDAD POR HEMOGLOBINA ZURICH"
  },
  {
    "codigo":123831002,
    "descripcion":"SATISFACTORIO PARA EVALUACIÓN, PERO LIMITADO POR PRESENCIA DE SANGRE QUE ENMASCARA PARCIALMENTE EL RESULTADO"
  },
  {
    "codigo":713655003,
    "descripcion":"DEPENDENCIA DE VENTILACIÓN NO INVASIVA"
  },
  {
    "codigo":1172407004,
    "descripcion":"HORMONAS SEXUALES MASCULINAS SÉRICAS POR DEBAJO DE RANGO DE REFERENCIA"
  },
  {
    "codigo":289506009,
    "descripcion":"LESIÓN DE CLÍTORIS"
  },
  {
    "codigo":285836003,
    "descripcion":"NEOPLASIA INTRAEPITELIAL CERVICAL GRADO 1"
  },
  {
    "codigo":56460009,
    "descripcion":"INFECCIÓN CAUSADA POR BIPOLARIS HAWAIIENSIS"
  },
  {
    "codigo":313671000119101,
    "descripcion":"MONOARTRITIS DE CODO DERECHO"
  },
  {
    "codigo":10963271000119101,
    "descripcion":"LACERACIÓN DE REGIÓN DE CADERA IZQUIERDA"
  },
  {
    "codigo":415073005,
    "descripcion":"TRASTORNO PERINATAL"
  },
  {
    "codigo":21857006,
    "descripcion":"TULAREMIA GLANDULAR"
  },
  {
    "codigo":284001007,
    "descripcion":"LESIÓN DEL APARATO SALIVAL"
  },
  {
    "codigo":20022000,
    "descripcion":"HEMIPARESIA"
  },
  {
    "codigo":447841007,
    "descripcion":"SEPSIS CAUSADA POR CANDIDA"
  },
  {
    "codigo":413238000,
    "descripcion":"REFLUJO DE MEDIO DE CONTRASTE"
  },
  {
    "codigo":11808941000119108,
    "descripcion":"ABRASIÓN DE PIEL DE REGIÓN DE CADERA IZQUIERDA"
  },
  {
    "codigo":249398004,
    "descripcion":"SECRECIÓN POSNASAL EN PARED POSTERIOR DE FARINGE"
  },
  {
    "codigo":50955006,
    "descripcion":"DEFORMIDAD DE ÓRBITA DEBIDA A TRAUMATISMO"
  },
  {
    "codigo":1359840000,
    "descripcion":"NEOPLASIA BENIGNA DE UNIÓN FARINGOESOFÁGICA"
  },
  {
    "codigo":737248002,
    "descripcion":"CONGELAMIENTO DE MÚLTIPLES REGIONES CORPORALES"
  },
  {
    "codigo":49120005,
    "descripcion":"FIBROSIS RETROPERITONEAL"
  },
  {
    "codigo":1259701001,
    "descripcion":"COREA DEBIDA A ANOXIA CEREBRAL"
  },
  {
    "codigo":276661002,
    "descripcion":"OSTEOPOROSIS PRIMARIA"
  },
  {
    "codigo":702645001,
    "descripcion":"FALLA DE COHESIÓN DE RESTAURACIÓN DENTAL"
  },
  {
    "codigo":473269004,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO DE MÚLTIPLES SITIOS DE LA MUÑECA"
  },
  {
    "codigo":440501006,
    "descripcion":"ADENOCARCINOMA DE LA UNIÓN ESOFAGOGÁSTRICA, SIEWERT TIPO II"
  },
  {
    "codigo":110986000,
    "descripcion":"FIBROQUERATOMA DIGITAL ADQUIRIDO"
  },
  {
    "codigo":405898004,
    "descripcion":"FENOTIPO K-K-"
  },
  {
    "codigo":15688161000119103,
    "descripcion":"CAPSULITIS DE ARTICULACIÓN DE AMBOS TOBILLOS"
  },
  {
    "codigo":209290006,
    "descripcion":"FRACTURA-SUBLUXACIÓN NO EXPUESTA PERISEMILUNAR TRANSESCAFOIDEA"
  },
  {
    "codigo":698975002,
    "descripcion":"EDEMA DE EXTREMIDAD DE COMIENZO SÚBITO"
  },
  {
    "codigo":830047004,
    "descripcion":"OVARIO IZQUIERDO POLIQUÍSTICO"
  },
  {
    "codigo":305759004,
    "descripcion":"ATENDIDO POR OBSTÉTRICA EXTRAHOSPITALARIA"
  },
  {
    "codigo":404063007,
    "descripcion":"LIPOMAS FAMILIARES MÚLTIPLES"
  },
  {
    "codigo":205620000,
    "descripcion":"TRISOMÍA 13 - MOSAICISMO CON FALTA DE DISYUNCIÓN MITÓTICA"
  },
  {
    "codigo":11837921000119105,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO INTRÍNSECO DE DEDO MEDIO DE MANO IZQUIERDA"
  },
  {
    "codigo":238388002,
    "descripcion":"PARONIQUIA POR PSEUDOMONAS AERUGINOSA"
  },
  {
    "codigo":9012003,
    "descripcion":"PESTE SEPTICÉMICA"
  },
  {
    "codigo":271156004,
    "descripcion":"AMPOLLA TRAUMÁTICA DE LA AXILA CON INFECCIÓN"
  },
  {
    "codigo":860980004,
    "descripcion":"ÚLCERA CRÓNICA DE PIE IZQUIERDO DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":402228006,
    "descripcion":"ECCEMA EXÓGENO DE PIE"
  },
  {
    "codigo":105481005,
    "descripcion":"RECHAZO DEL PACIENTE HACIA LOS ALIMENTOS"
  },
  {
    "codigo":302089007,
    "descripcion":"ULCERACIÓN DE GANGLIO LINFÁTICO CERVICAL"
  },
  {
    "codigo":1186825009,
    "descripcion":"SÍNDROME HIPOFISARIO DE SECRECIÓN INADECUADA DE VASOPRESINA"
  },
  {
    "codigo":201950002,
    "descripcion":"ARTROPATÍA TRAUMÁTICA DE LA CADERA"
  },
  {
    "codigo":16097761000119109,
    "descripcion":"ARTROFIBROSIS DE ARTICULACIÓN DE DEDO DE MANO DERECHA"
  },
  {
    "codigo":365790006,
    "descripcion":"HALLAZGO QUÍMICO DE BILIS EN ORINA"
  },
  {
    "codigo":300254007,
    "descripcion":"HALLAZGO LUEGO DE PROCEDIMIENTO EN LA CAVIDAD BUCAL"
  },
  {
    "codigo":429491000,
    "descripcion":"OBSTRUCCIÓN DE VÍA AÉREA CAUSADA POR CUERPO EXTRAÑO"
  },
  {
    "codigo":354661000119100,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE OMÓPLATO IZQUIERDO"
  },
  {
    "codigo":1076581000119101,
    "descripcion":"TENDINITIS DE HOMBRO DERECHO"
  },
  {
    "codigo":3507004,
    "descripcion":"ABSCESO DE MUSLO"
  },
  {
    "codigo":16697701000119103,
    "descripcion":"INFECCIÓN ASOCIADA CON STENT EN VÍA URINARIA"
  },
  {
    "codigo":11828581000119104,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO DE MUSLO IZQUIERDO"
  },
  {
    "codigo":535696741000119105,
    "descripcion":"PSEUDOQUISTE DE OREJA IZQUIERDA"
  },
  {
    "codigo":16265061000119105,
    "descripcion":"TRASTORNO DEPRESIVO MAYOR RECURRENTE CONCOMITANTE CON ANSIEDAD EN REMISIÓN PARCIAL"
  },
  {
    "codigo":167347005,
    "descripcion":"MICROSCOPIA DE ORINA: CRISTALES DE TIROSINA"
  },
  {
    "codigo":991898981000119108,
    "descripcion":"HEMATOMA SUBDURAL INTRACRANEAL NO TRAUMÁTICO CRÓNICO"
  },
  {
    "codigo":303461000119108,
    "descripcion":"DEPÓSITO DE CALCIO EN BOLSA SEROSA DE MANO IZQUIERDA"
  },
  {
    "codigo":677221000119108,
    "descripcion":"SÍNDROME DE HISTOPLASMOSIS DE OJO DERECHO"
  },
  {
    "codigo":11874661000119103,
    "descripcion":"ENTROPIÓN BILATERAL"
  },
  {
    "codigo":10686821000119105,
    "descripcion":"MELANOMA MALIGNO DE LECHO UNGUEAL DE DEDO DE MANO DERECHA"
  },
  {
    "codigo":686117221000119105,
    "descripcion":"CREPITACIÓN DE ARTICULACIÓN DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":10761061000119107,
    "descripcion":"ABUSO SEXUAL QUE COMPLICA EL EMBARAZO"
  },
  {
    "codigo":16741000119108,
    "descripcion":"LESIÓN TRAUMÁTICA DE RETROPERITONEO"
  },
  {
    "codigo":1086821000119108,
    "descripcion":"INFECCIÓN DE ESOFAGOSTOMÍA"
  },
  {
    "codigo":32605001,
    "descripcion":"COAGULOPATÍA NEONATAL TRANSITORIA"
  },
  {
    "codigo":720733001,
    "descripcion":"QUISTE Y TROFOZOÍTO DE ENTEROMONAS HOMINIS"
  },
  {
    "codigo":294749007,
    "descripcion":"ALERGIA A GESTONORONA"
  },
  {
    "codigo":423986002,
    "descripcion":"NO SIGUE EL ESQUEMA DE ADMINISTRACIÓN DE MEDICACIÓN RECOMENDADO"
  },
  {
    "codigo":129074007,
    "descripcion":"DEPENDENCIA PARA VIAJAR"
  },
  {
    "codigo":94471000,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL LÓBULO PARIETAL"
  },
  {
    "codigo":292914008,
    "descripcion":"REACCIÓN ADVERSA AL BEFENIO"
  },
  {
    "codigo":1144882008,
    "descripcion":"HIPOPLASIA CONGÉNITA DE GLÁNDULA LAGRIMAL"
  },
  {
    "codigo":127239006,
    "descripcion":"NEOPLASIA DE LOS GANGLIOS LINFÁTICOS SUBMANDIBULARES"
  },
  {
    "codigo":225543007,
    "descripcion":"ASPECTO CUTÁNEO ANORMAL"
  },
  {
    "codigo":192775006,
    "descripcion":"EFECTOS TARDÍOS DE ABSCESO INTRACRANEAL O INFECCIÓN PIÓGENA"
  },
  {
    "codigo":289244001,
    "descripcion":"PÉRDIDA DE SANGRE MATERNA, DENTRO DE LOS LÍMITES NORMALES"
  },
  {
    "codigo":92636006,
    "descripcion":"CARCINOMA IN SITU DE LA PARED LATERAL DE LA NASOFARINGE"
  },
  {
    "codigo":1335985001,
    "descripcion":"GLAUCOMA BILATERAL DEBIDO A QUISTE DE CUERPO CILIAR"
  },
  {
    "codigo":123569004,
    "descripcion":"ANOMALÍA CONGÉNITA DE HUESO METATARSIANO"
  },
  {
    "codigo":1303217006,
    "descripcion":"RUPTURA DE LIGAMENTO DE DEDO MEÑIQUE"
  },
  {
    "codigo":254641006,
    "descripcion":"HISTIOCITOMA PULMONAR"
  },
  {
    "codigo":449414003,
    "descripcion":"ALERGIA A RAPACURONIO"
  },
  {
    "codigo":1137542004,
    "descripcion":"CALCIFICACIÓN PUNTEADA DE EPÍFISIS DE FALANGE DE PULGAR"
  },
  {
    "codigo":283739000,
    "descripcion":"MORDEDURA DE PERRO EN LA FRENTE"
  },
  {
    "codigo":773424001,
    "descripcion":"ALERGIA AL ÁCIDO CÍTRICO"
  },
  {
    "codigo":609584003,
    "descripcion":"RESISTENCIA AL CUIDADO FÍSICO"
  },
  {
    "codigo":314672005,
    "descripcion":"PESO DEL NIÑO: PERCENTILO 2"
  },
  {
    "codigo":249136005,
    "descripcion":"LÍQUIDO AMNIÓTICO CON MECONIO FRESCO"
  },
  {
    "codigo":312837005,
    "descripcion":"LUXACIÓN VERTEBRAL CON LESIÓN MEDULAR A NIVEL CERVICAL"
  },
  {
    "codigo":247301006,
    "descripcion":"CAPACIDAD PARA ESCUCHAR SUSURROS - HALLAZGO"
  },
  {
    "codigo":81626002,
    "descripcion":"HIPERTENSIÓN MALIGNA EN EL CONTEXTO OBSTÉTRICO"
  },
  {
    "codigo":704218005,
    "descripcion":"FRACTURA EXPUESTA DE SEGUNDO METACARPIANO"
  },
  {
    "codigo":276399002,
    "descripcion":"AMÍGDALAS PEQUEÑAS"
  },
  {
    "codigo":1082441000119104,
    "descripcion":"DISFUNCIÓN VELOFARÍNGEA ADQUIRIDA"
  },
  {
    "codigo":702383005,
    "descripcion":"MIOPATÍA DISTAL TIPO 2"
  },
  {
    "codigo":1259439005,
    "descripcion":"CARCINOMA PRIMARIO DE PALADAR"
  },
  {
    "codigo":473007007,
    "descripcion":"DOLOR CERVICAL DISCOGÉNICO"
  },
  {
    "codigo":298675009,
    "descripcion":"CREPITACIÓN DE LA COLUMNA LUMBAR"
  },
  {
    "codigo":733316000,
    "descripcion":"TRASTORNO DEL TRACTO UVEAL ANTERIOR"
  },
  {
    "codigo":241796001,
    "descripcion":"EFECTO TÓXICO CAUSADO POR 4,6-DINITRO-O-CRESOL"
  },
  {
    "codigo":407471007,
    "descripcion":"ENFERMEDAD CAUSADA POR VIRUS LONE STAR"
  },
  {
    "codigo":209028002,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN TARSOMETATARSIANA"
  },
  {
    "codigo":403801000,
    "descripcion":"PAQUIONIQUIA CONGÉNITA TIPO II DE JACKSON-LAWLER"
  },
  {
    "codigo":77956009,
    "descripcion":"SÍNDROME DE DISTROFIA MIOTÓNICA DE STEINERT"
  },
  {
    "codigo":45188008,
    "descripcion":"GLUCOPROLINURIA"
  },
  {
    "codigo":305497003,
    "descripcion":"BAJO ATENCIÓN DE RADIÓLOGO"
  },
  {
    "codigo":43353004,
    "descripcion":"ANOMALÍA CONGÉNITA DE OÍDO INTERNO"
  },
  {
    "codigo":698713005,
    "descripcion":"HEMORRAGIA PREPARTO DEBIDA A EROSIÓN CERVICAL"
  },
  {
    "codigo":239961006,
    "descripcion":"BURSITIS DE HOMBRO"
  },
  {
    "codigo":895321004,
    "descripcion":"FORMA DE BALA ANORMAL CONGÉNITA DE FALANGE PROXIMAL DE DEDO MEDIO"
  },
  {
    "codigo":345161000119108,
    "descripcion":"OPACIDAD CORNEAL MENOR BILATERAL"
  },
  {
    "codigo":371033009,
    "descripcion":"EQUIMOSIS POR ESTEROIDES"
  },
  {
    "codigo":762414004,
    "descripcion":"CAVIDAD ORBITARIA MICROFTÁLMICA"
  },
  {
    "codigo":238126005,
    "descripcion":"BERIBERI INFANTIL"
  },
  {
    "codigo":205358006,
    "descripcion":"PIE HENDIDO"
  },
  {
    "codigo":367363000,
    "descripcion":"INSUFICIENCIA DEL VENTRÍCULO DERECHO"
  },
  {
    "codigo":170755004,
    "descripcion":"TABLA DE AZÚCAR URINARIO"
  },
  {
    "codigo":39683005,
    "descripcion":"REGULACIÓN DE LA SECRECIÓN GÁSTRICA NORMAL"
  },
  {
    "codigo":400131007,
    "descripcion":"HEMANGIOMA EPITELIOIDE DE PIEL"
  },
  {
    "codigo":234456000,
    "descripcion":"ANOMALÍA CONGÉNITA DEL FIBRINÓGENO"
  },
  {
    "codigo":301827008,
    "descripcion":"LESIÓN DE BRONQUIO"
  },
  {
    "codigo":365528005,
    "descripcion":"DETALLES RELACIONADOS CON EL LUGAR DE TRABAJO Y EL EMPLEADOR - HALLAZGO"
  },
  {
    "codigo":396461001,
    "descripcion":"DISPLASIA DE CONDUCTO HEPÁTICO"
  },
  {
    "codigo":724141003,
    "descripcion":"ENANISMO MICROCEFÁLICO PRIMORDIAL DEBIDO A DEFICIENCIA DE PROTEÍNA DEDO DE CINC 335"
  },
  {
    "codigo":298157007,
    "descripcion":"DERRAME EN CARILLA ARTICULAR CERVICAL"
  },
  {
    "codigo":292221000119102,
    "descripcion":"COMPRESIÓN DE NERVIO PLANTAR DERECHO"
  },
  {
    "codigo":230786001,
    "descripcion":"DISFASIA CONGÉNITA"
  },
  {
    "codigo":1344898003,
    "descripcion":"ARTRITIS TRAUMÁTICA"
  },
  {
    "codigo":296322006,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE COCAÍNA"
  },
  {
    "codigo":294487000,
    "descripcion":"ALERGIA A CIPROFLOXACINO"
  },
  {
    "codigo":128381000119104,
    "descripcion":"CHOQUE SÉPTICO CONCOMITANTE CON DISFUNCIÓN ORGÁNICA AGUDA CAUSADO POR STAPHYLOCOCCUS AUREUS RESISTENTE A LA METICILINA"
  },
  {
    "codigo":718636001,
    "descripcion":"DEPRESIÓN MÍNIMA"
  },
  {
    "codigo":194348002,
    "descripcion":"ENFERMEDAD DE MÉNIÈRE COCLEOVESTIBULAR ACTIVA"
  },
  {
    "codigo":675351000119100,
    "descripcion":"LEUCOMA CORNEAL DE OJO DERECHO"
  },
  {
    "codigo":94209000,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE VASO SANGUÍNEO DEL TRONCO"
  },
  {
    "codigo":782337001,
    "descripcion":"INTOLERANCIA A LA LACTOSA POR FALTA DE PERSISTENCIA DE LACTASA INTESTINAL"
  },
  {
    "codigo":7731005,
    "descripcion":"SÍNDROME DE DISPLASIA ECTODÉRMICA HIPOHIDRÓTICA AUTOSÓMICA DOMINANTE"
  },
  {
    "codigo":126977003,
    "descripcion":"NEOPLASIA DEL NERVIO ACCESORIO"
  },
  {
    "codigo":26838001,
    "descripcion":"ENTERITIS FIBRINOSA"
  },
  {
    "codigo":420054005,
    "descripcion":"CIRROSIS ALCOHÓLICA"
  },
  {
    "codigo":59606006,
    "descripcion":"PROTRUSIÓN INTRAPÉLVICA DE ACETÁBULO"
  },
  {
    "codigo":347671000119103,
    "descripcion":"ABSCESO DE PÁRPADO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":288982008,
    "descripcion":"CAPAZ DE SUCCIONAR"
  },
  {
    "codigo":90539001,
    "descripcion":"ANEURISMA VENTRICULAR"
  },
  {
    "codigo":878806005,
    "descripcion":"SEGUNDO CÁNCER PRIMARIO"
  },
  {
    "codigo":10669591000119104,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN DE REGIÓN COCCÍGEA DE ESPALDA ESTADIO IV"
  },
  {
    "codigo":57771004,
    "descripcion":"LESIÓN TRAUMÁTICA DE INTESTINO SIN HERIDA ABIERTA HACIA CAVIDAD ABDOMINAL"
  },
  {
    "codigo":92374008,
    "descripcion":"NEOPLASIA BENIGNA DE LA PIEL DEL HUECO POPLÍTEO"
  },
  {
    "codigo":25003006,
    "descripcion":"ACROCIANOSIS"
  },
  {
    "codigo":10751511000119105,
    "descripcion":"TRABAJO DE PARTO OBSTRUIDO DEBIDO A ROTACIÓN INCOMPLETA DE LA CABEZA FETAL"
  },
  {
    "codigo":23168003,
    "descripcion":"TRASTORNO DEL HABLA"
  },
  {
    "codigo":285312008,
    "descripcion":"CARCINOMA DE COLON SIGMOIDE"
  },
  {
    "codigo":1268352008,
    "descripcion":"CARCINOMA PRIMARIO DE HIPÓFISIS"
  },
  {
    "codigo":260275005,
    "descripcion":"VISIÓN A DISTANCIA 6\/18"
  },
  {
    "codigo":21333004,
    "descripcion":"ALTERACIÓN DE MENISCO EXTERNO"
  },
  {
    "codigo":283477005,
    "descripcion":"HERIDA PUNZANTE EN EL PERINEO"
  },
  {
    "codigo":85034001,
    "descripcion":"MIOTONÍA ADQUIRIDA"
  },
  {
    "codigo":248874006,
    "descripcion":"VAGINA PEQUEÑA"
  },
  {
    "codigo":1197311006,
    "descripcion":"ADENOCARCINOMA METASTÁSICO DE GANGLIO LINFÁTICO DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":1230079007,
    "descripcion":"PATRÓN DE USO PERJUDICIAL DE HIPNÓTICO SIN DEPENDENCIA, EN REMISIÓN"
  },
  {
    "codigo":247039007,
    "descripcion":"PENACHO VASCULAR DEL MARGEN PUPILAR"
  },
  {
    "codigo":736724002,
    "descripcion":"ERITEMA DE MEMBRANA MUCOSA DE LA CAVIDAD BUCAL DEBIDO A LESIÓN TRAUMÁTICA Y POSTERIOR A ELLA"
  },
  {
    "codigo":13993001,
    "descripcion":"TRASTORNO POR INHIBIDOR DEL FACTOR XIII"
  },
  {
    "codigo":11790001000119107,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE DEDO ÍNDICE DERECHO"
  },
  {
    "codigo":865961004,
    "descripcion":"DISFUNCIÓN DE SISTEMA VESTIBULAR DESPUÉS DE LESIÓN TRAUMÁTICA"
  },
  {
    "codigo":767657005,
    "descripcion":"ANEMIA DEBIDA A QUIMIOTERAPIA Y POSTERIOR A ELLA"
  },
  {
    "codigo":208766000,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN DE HOMBRO, ANTERIOR (SUBCORACOIDEA)"
  },
  {
    "codigo":210601009,
    "descripcion":"LESIÓN POR AVULSIÓN ANULAR, CLASE 2"
  },
  {
    "codigo":307070001,
    "descripcion":"NO SOSTIENE BEBIDAS"
  },
  {
    "codigo":700286007,
    "descripcion":"ORZUELO EXTERNO DE PÁRPADO SUPERIOR"
  },
  {
    "codigo":733054008,
    "descripcion":"LESIÓN PULMONAR AGUDA DURANTE Y DESPUÉS DE LA ADMINISTRACIÓN DE HEMODERIVADO"
  },
  {
    "codigo":403539002,
    "descripcion":"LENTIGINOSIS ZOSTERIFORME"
  },
  {
    "codigo":41256004,
    "descripcion":"PRESBICIA"
  },
  {
    "codigo":8488006,
    "descripcion":"SINESTESIA"
  },
  {
    "codigo":72189003,
    "descripcion":"RINORREA HEMORRÁGICA"
  },
  {
    "codigo":170493005,
    "descripcion":"PORTADOR DE LEGIONELLA"
  },
  {
    "codigo":301565005,
    "descripcion":"SE MOVILIZA EN EL EXTERIOR"
  },
  {
    "codigo":399869005,
    "descripcion":"RETINOPATÍA PROLIFERATIVA DE ALTO RIESGO NO TRATABLE CON FOTOCOAGULACIÓN DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":398034002,
    "descripcion":"MÉDICO CLÍNICO NO DISPONIBLE"
  },
  {
    "codigo":234194005,
    "descripcion":"TROMBOSIS DE INJERTO VASCULAR"
  },
  {
    "codigo":266962006,
    "descripcion":"RETORNÓ AL TRABAJO"
  },
  {
    "codigo":135890008,
    "descripcion":"NIÑO QUE YA NO REQUIERE ASISTENCIA"
  },
  {
    "codigo":365266009,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA ALMACENAR COMIDA EN FORMA HIGIÉNICA"
  },
  {
    "codigo":1348306008,
    "descripcion":"DISTROFIA MUSCULAR INTERMEDIA RELACIONADA CON COLÁGENO VI"
  },
  {
    "codigo":723879002,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE LESIÓN SUPERPUESTA DE ÓRGANO URINARIO"
  },
  {
    "codigo":677861000119104,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO DEL AGUJERO MACULAR DE AMBOS OJOS"
  },
  {
    "codigo":68519006,
    "descripcion":"CLICS SISTÓLICOS MÚLTIPLES NO EYECTIVOS"
  },
  {
    "codigo":363431006,
    "descripcion":"NEOPLASIA MALIGNA DE CARTÍLAGO LARÍNGEO"
  },
  {
    "codigo":230524003,
    "descripcion":"LESIÓN DE LA RADIACIÓN ÓPTICA"
  },
  {
    "codigo":296060005,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE FLURAZEPAM"
  },
  {
    "codigo":785745000,
    "descripcion":"BRONQUITIS AGUDA CONCOMITANTE CON SIBILANCIAS"
  },
  {
    "codigo":16052351000119101,
    "descripcion":"TENDINOSIS BILATERAL DE RODILLA"
  },
  {
    "codigo":359761005,
    "descripcion":"ENFERMEDAD CAUSADA POR HANTAVIRUS"
  },
  {
    "codigo":294225008,
    "descripcion":"ALERGIA A MIORRELAJANTE NO DESPOLARIZANTE"
  },
  {
    "codigo":95782001,
    "descripcion":"NISTAGMO EN SUBE Y BAJA"
  },
  {
    "codigo":718374004,
    "descripcion":"ARTICULACIÓN TEMPOROMANDIBULAR NORMAL"
  },
  {
    "codigo":11792511000119103,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN DE DEDO ÍNDICE DERECHO"
  },
  {
    "codigo":292390006,
    "descripcion":"REACCIÓN ADVERSA AL ENANTATO DE FLUFENAZINA"
  },
  {
    "codigo":423462008,
    "descripcion":"FÍSTULA DURAL CAVERNOSO-CAROTÍDEA"
  },
  {
    "codigo":225019002,
    "descripcion":"SE SIENTE EMOCIONALMENTE HERIDO"
  },
  {
    "codigo":61179004,
    "descripcion":"BERIBERI CARDÍACO"
  },
  {
    "codigo":716539005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA UTILIZAR LA COMBINACIÓN DE CONSONANTE-VOCAL-CONSONANTE-VOCAL"
  },
  {
    "codigo":126715005,
    "descripcion":"NEOPLASIA DE LÓBULO MEDIO DE PULMÓN DERECHO"
  },
  {
    "codigo":290555006,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR PROCAÍNA"
  },
  {
    "codigo":26576000,
    "descripcion":"REACCIÓN POSITIVA A LA PRUEBA CUTÁNEA"
  },
  {
    "codigo":93947009,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL PERITONEO PARIETAL"
  },
  {
    "codigo":10645631000119105,
    "descripcion":"ÚLCERA VARICOSA DE TALÓN DERECHO"
  },
  {
    "codigo":1306363007,
    "descripcion":"NEOPLASIA BENIGNA DE CUADRANTE INFERIOR EXTERNO DE MAMA"
  },
  {
    "codigo":92112008,
    "descripcion":"NEOPLASIA BENIGNA DEL PREPUCIO"
  },
  {
    "codigo":288720008,
    "descripcion":"INCAPAZ DE HABLAR MIENTRAS JUEGA"
  },
  {
    "codigo":254117007,
    "descripcion":"DISPLASIA CON MINERALIZACIÓN DEFECTUOSA"
  },
  {
    "codigo":285050007,
    "descripcion":"NO USA LENTES DE CONTACTO"
  },
  {
    "codigo":21071002,
    "descripcion":"INFERTILIDAD DEBIDA A APLASIA DE CÉLULAS GERMINALES"
  },
  {
    "codigo":53839004,
    "descripcion":"HEMORRAGIA DE CONDUCTO DEFERENTE"
  },
  {
    "codigo":283215006,
    "descripcion":"ANZUELO EN LA CADERA"
  },
  {
    "codigo":838436001,
    "descripcion":"DEFORMIDAD DE TÓRAX DEBIDA A ESPONDILITIS ANQUILOSANTE"
  },
  {
    "codigo":1297188001,
    "descripcion":"QUEMADURA DE TERCER DEDO DE PIE"
  },
  {
    "codigo":1231652003,
    "descripcion":"DEFORMIDAD POSQUIRÚRGICA COMBINADA DE HUESO Y PARTES BLANDAS DE ÓRBITA"
  },
  {
    "codigo":707364007,
    "descripcion":"XANTOMA DE PULMÓN"
  },
  {
    "codigo":19236007,
    "descripcion":"PLACENTA ANORMAL INMADURA"
  },
  {
    "codigo":408782002,
    "descripcion":"LÍQUIDO AMNIÓTICO PURULENTO"
  },
  {
    "codigo":15698201000119109,
    "descripcion":"OSTEÍTIS DE FÉMUR DERECHO"
  },
  {
    "codigo":48334007,
    "descripcion":"LUXACIÓN CONGÉNITA DE LA CADERA"
  },
  {
    "codigo":212174007,
    "descripcion":"SÍNDROME MEDULAR POSTERIOR DEBIDO A LESIÓN A NIVEL DE T1 - T6, SIN LESIÓN ÓSEA"
  },
  {
    "codigo":769230009,
    "descripcion":"TRASTORNO DEBIDO A QUEMADURA DE MANO Y POSTERIOR A ELLA"
  },
  {
    "codigo":1258915002,
    "descripcion":"HIPOMINERALIZACIÓN DE ESMALTE DENTAL"
  },
  {
    "codigo":15566009,
    "descripcion":"INFECCIÓN CAUSADA POR TRYPANOSOMA EQUIPERDUM"
  },
  {
    "codigo":79267007,
    "descripcion":"MIGRAÑA RETINIANA"
  },
  {
    "codigo":46499007,
    "descripcion":"CONCIENCIA DE LA PRESENCIA DE UN BOLO"
  },
  {
    "codigo":308643009,
    "descripcion":"SITUACIÓN DE LA SOLICITUD"
  },
  {
    "codigo":210339009,
    "descripcion":"HERIDA ABIERTA EN LA CARA"
  },
  {
    "codigo":110200003,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO DEL VESTÍBULO MAXILAR"
  },
  {
    "codigo":108365000,
    "descripcion":"INFECCIÓN DE LA PIEL"
  },
  {
    "codigo":370509002,
    "descripcion":"NEUROAPRAXIA"
  },
  {
    "codigo":698189006,
    "descripcion":"HIPOTAURODONTISMO"
  },
  {
    "codigo":1255245006,
    "descripcion":"FRACTURA NO EXPUESTA DE FALANGE MEDIA DE MÚLTIPLES DEDOS DE MANO"
  },
  {
    "codigo":42829009,
    "descripcion":"FOLÍCULO MULTIPILOSO"
  },
  {
    "codigo":303138003,
    "descripcion":"ANOMALÍA DE CONDUCTO TIROGLOSO"
  },
  {
    "codigo":11821491000119109,
    "descripcion":"LUXACIÓN TRAUMÁTICA POSTERIOR NO EXPUESTA DE ARTICULACIÓN ESTERNOCLAVICULAR DERECHA"
  },
  {
    "codigo":237602007,
    "descripcion":"SÍNDROME METABÓLICO X"
  },
  {
    "codigo":73762008,
    "descripcion":"CONJUNTIVITIS CRÓNICA"
  },
  {
    "codigo":202999001,
    "descripcion":"ABSCESO DE BOLSA SEROSA DE LA RODILLA"
  },
  {
    "codigo":6391003,
    "descripcion":"EVALUACIÓN DE DISCAPACIDAD: 75%"
  },
  {
    "codigo":235767007,
    "descripcion":"ÚLCERA ESTERCORÁCEA DEL INTESTINO GRUESO"
  },
  {
    "codigo":170231008,
    "descripcion":"NIÑO DERIVADO AL ORTOPTISTA"
  },
  {
    "codigo":365004003,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA IMITAR SONIDOS DEL HABLA"
  },
  {
    "codigo":102860006,
    "descripcion":"CRISTAL URINARIO, LEUCINA"
  },
  {
    "codigo":70092007,
    "descripcion":"CONTUSIÓN DE RIÑÓN"
  },
  {
    "codigo":4556007,
    "descripcion":"GASTRITIS"
  },
  {
    "codigo":299468009,
    "descripcion":"HALLAZGO RELACIONADO CON LA COLORACIÓN DEL PIE"
  },
  {
    "codigo":232097000,
    "descripcion":"ESOTROPÍA PRIMARIA"
  },
  {
    "codigo":199329004,
    "descripcion":"PARTO MÚLTIPLE, TODOS NACIDOS DE MANERA ESPONTÁNEA"
  },
  {
    "codigo":35489007,
    "descripcion":"TRASTORNO DEPRESIVO"
  },
  {
    "codigo":428705008,
    "descripcion":"DESGARRO DEGENERATIVO DEL COMPLEJO FIBROCARTILAGINOSO TRIANGULAR DE LA MUÑECA"
  },
  {
    "codigo":363169009,
    "descripcion":"INFLAMACIÓN DE ÓRGANOS (CORPORALES) ESPECÍFICOS"
  },
  {
    "codigo":263030002,
    "descripcion":"LUXACIÓN DE ARTICULACIÓN DE DEDO DEL PIE"
  },
  {
    "codigo":166561008,
    "descripcion":"ALFA - FETOPROTEÍNA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":230262004,
    "descripcion":"AMIOTROFIA CAUSADA POR HERPES ZÓSTER"
  },
  {
    "codigo":721782006,
    "descripcion":"INFECCIÓN CAUSADA POR VIRUS SABIA"
  },
  {
    "codigo":197494007,
    "descripcion":"MALABSORCIÓN INTESTINAL DE GRASAS"
  },
  {
    "codigo":31819001,
    "descripcion":"INFECCIÓN CAUSADA POR MUCOR"
  },
  {
    "codigo":228427002,
    "descripcion":"SIGUE UNA RUTINA DE ACTIVIDADES RELACIONADAS CON EL CONSUMO DE DROGA"
  },
  {
    "codigo":261195002,
    "descripcion":"PARO CIRCULATORIO"
  },
  {
    "codigo":719947004,
    "descripcion":"SÍNDROME DE DISMORFISMO CRANEOFACIAL CON COLOBOMA OCULAR Y AGENESIA DE CUERPO CALLOSO"
  },
  {
    "codigo":293963004,
    "descripcion":"ALERGIA A ANTAGONISTA DE RECEPTOR ADRENÉRGICO BETA-1"
  },
  {
    "codigo":195659006,
    "descripcion":"FARINGITIS NEUMOCÓCICA AGUDA"
  },
  {
    "codigo":16028391000119105,
    "descripcion":"EXOSTOSIS DE FÉMUR DERECHO"
  },
  {
    "codigo":292128001,
    "descripcion":"REACCIÓN ADVERSA A FÁRMACO ESTIMULANTE DE LA MOTILIDAD"
  },
  {
    "codigo":62752005,
    "descripcion":"INFESTACIÓN CAUSADA POR SARCOPTES"
  },
  {
    "codigo":716277000,
    "descripcion":"DIARREA CRÓNICA DEBIDA A DEFICIENCIA DE GLUCOAMILASA"
  },
  {
    "codigo":95520009,
    "descripcion":"ESTENOSIS GASTROINTESTINAL"
  },
  {
    "codigo":128288009,
    "descripcion":"ÚLCERA GASTROYEYUNAL CRÓNICA"
  },
  {
    "codigo":421365002,
    "descripcion":"TRASTORNO CIRCULATORIO PERIFÉRICO DEBIDO A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":290293000,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR FENILBUTAZONA"
  },
  {
    "codigo":1142261006,
    "descripcion":"HIPERTROFIA DE MÚSCULO DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":109441000119102,
    "descripcion":"ALOPECIA CICATRIZAL CENTRÍFUGA CENTRAL"
  },
  {
    "codigo":91850001,
    "descripcion":"ALTERACIÓN ADQUIRIDA DE LA COLORACIÓN DEL ESMALTE DENTAL ASOCIADA CON EL ENVEJECIMIENTO"
  },
  {
    "codigo":124618001,
    "descripcion":"DEFICIENCIA DE ENOLASA"
  },
  {
    "codigo":1304266004,
    "descripcion":"GLAUCOMA DE ÁNGULO CERRADO SECUNDARIO DE OJO DERECHO DEBIDO A SÍNDROME ENDOTELIAL IRIDOCORNEAL"
  },
  {
    "codigo":386762009,
    "descripcion":"QUISTE DEL CUERPO LÚTEO"
  },
  {
    "codigo":188319001,
    "descripcion":"NEOPLASIA MALIGNA DE LA PIAMADRE RAQUÍDEA"
  },
  {
    "codigo":1204127004,
    "descripcion":"DISECCIÓN CORONARIA CRÓNICA"
  },
  {
    "codigo":1171359008,
    "descripcion":"OBSTRUCCIÓN INTESTINAL POR ADHERENCIA DE INTESTINO DELGADO"
  },
  {
    "codigo":253855009,
    "descripcion":"FRENILLO PREPUCIAL CORTO"
  },
  {
    "codigo":286623009,
    "descripcion":"LACERACIÓN DE LENGUA"
  },
  {
    "codigo":88180003,
    "descripcion":"CUERPO EXTRAÑO MAGNÉTICO RETENIDO EN SITIOS MÚLTIPLES"
  },
  {
    "codigo":252020002,
    "descripcion":"HIPERACTIVIDAD URETRAL"
  },
  {
    "codigo":284788006,
    "descripcion":"SE LAVA"
  },
  {
    "codigo":448628008,
    "descripcion":"ANILLO VASCULAR CON CAYADO AÓRTICO IZQUIERDO Y CONDUCTO ARTERIAL DERECHO ORIGINADO EN DIVERTÍCULO AÓRTICO RETROESOFÁGICO Y ARTERIA SUBCLAVIA DERECHA ABERRANTE"
  },
  {
    "codigo":1003849000,
    "descripcion":"DEFICIENCIA DE SUBUNIDAD E2 DEL COMPLEJO PIRUVATO DESHIDROGENASA"
  },
  {
    "codigo":86345004,
    "descripcion":"SÍNDROME DE BERTOLOTTI"
  },
  {
    "codigo":414025005,
    "descripcion":"TRASTORNO FETAL Y\/O NEONATAL"
  },
  {
    "codigo":1092481000119108,
    "descripcion":"CHOQUE SÉPTICO CONCOMITANTE CON DISFUNCIÓN ORGÁNICA AGUDA DEBIDO A STAPHYLOCOCCUS COAGULASA-NEGATIVO"
  },
  {
    "codigo":1051000119103,
    "descripcion":"ADHERENCIA DE PENE ADQUIRIDA"
  },
  {
    "codigo":51742006,
    "descripcion":"TRASTORNO DE LA ADENOHIPÓFISIS"
  },
  {
    "codigo":1264158007,
    "descripcion":"TRASTORNO POSTERIOR A EMBARAZO ECTÓPICO"
  },
  {
    "codigo":836339000,
    "descripcion":"MOVIMIENTO DE ARTICULACIÓN CON LA GRAVEDAD"
  },
  {
    "codigo":211912000,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO PROFUNDA DE PALMA DE LA MANO"
  },
  {
    "codigo":408520005,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: FLAMENCO"
  },
  {
    "codigo":139566261000119101,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN DE TEJIDO PROFUNDO DE TALÓN IZQUIERDO"
  },
  {
    "codigo":302261000119101,
    "descripcion":"QUISTE ÓSEO ANEURISMÁTICO DE MANO DERECHA"
  },
  {
    "codigo":699762000,
    "descripcion":"LABIO DOBLE CONGÉNITO"
  },
  {
    "codigo":767133009,
    "descripcion":"HIPERCOLESTEROLEMIA FAMILIAR HETEROCIGOTA COMPUESTA"
  },
  {
    "codigo":109938006,
    "descripcion":"NEOPLASIA BENIGNA DE LOS NERVIOS PERIFÉRICOS DE LA CADERA"
  },
  {
    "codigo":44402007,
    "descripcion":"PÉRDIDA DE DIENTES POR EXTRACCIÓN"
  },
  {
    "codigo":208242007,
    "descripcion":"FRACTURA NO EXPUESTA DE HÚMERO PROXIMAL, TUBEROSIDAD MAYOR"
  },
  {
    "codigo":9799002,
    "descripcion":"DIETA HIPERCALÓRICA, HIPERPROTEICA PARA EL PACIENTE QUEMADO"
  },
  {
    "codigo":239175003,
    "descripcion":"SÍNDROME DE DOLOR POSTORACOTOMÍA"
  },
  {
    "codigo":206407004,
    "descripcion":"MELENA PERINATAL"
  },
  {
    "codigo":271943005,
    "descripcion":"CARCINOMA DE LA BASE DE LA LENGUA"
  },
  {
    "codigo":403015002,
    "descripcion":"TIÑA DE CUERO CABELLUDO CAUSADA POR TRICHOPHYTON RUBRUM"
  },
  {
    "codigo":7964000,
    "descripcion":"LISTERIOSIS CONGÉNITA"
  },
  {
    "codigo":370247008,
    "descripcion":"LACERACIÓN FACIAL"
  },
  {
    "codigo":270108002,
    "descripcion":"INFORME FORENSE POSTMORTEM - ESPERADO"
  },
  {
    "codigo":697927009,
    "descripcion":"HIPERTENSIÓN PULMONAR DEBIDA A CARDIOPATÍA VALVULAR DE LADO IZQUIERDO"
  },
  {
    "codigo":827164008,
    "descripcion":"PERICARDITIS TARDÍA POSTERIOR A INFARTO DE MIOCARDIO"
  },
  {
    "codigo":401180009,
    "descripcion":"ANORMALMENTE DELGADO"
  },
  {
    "codigo":169969002,
    "descripcion":"AMAMANTADO Y ALIMENTADO CON SUPLEMENTOS A LOS 10 DÍAS"
  },
  {
    "codigo":366577007,
    "descripcion":"AMPLITUD DE MOVIMIENTO PASIVO DE ROTACIÓN INTERNA DE LA CADERA - HALLAZGO"
  },
  {
    "codigo":102598000,
    "descripcion":"VISCOSIDAD DE LA PIEL"
  },
  {
    "codigo":233670004,
    "descripcion":"DEFECTO DE ACLARAMIENTO MUCOCILIAR TRANSITORIO"
  },
  {
    "codigo":4294006,
    "descripcion":"PUBERTAD PRECOZ ISOSEXUAL"
  },
  {
    "codigo":364742007,
    "descripcion":"PUNTAJE DE APGAR A LOS 5 MINUTOS - HALLAZGO"
  },
  {
    "codigo":299206008,
    "descripcion":"ARTICULACIÓN DEL PULGAR CALIENTE AL TACTO"
  },
  {
    "codigo":69830008,
    "descripcion":"FRACTURAS MÚLTIPLES NO EXPUESTAS DE EXTREMO DISTAL DE FÉMUR"
  },
  {
    "codigo":266438007,
    "descripcion":"ESTENOSIS PILÓRICA HIPERTRÓFICA DEL ADULTO"
  },
  {
    "codigo":680047951000119104,
    "descripcion":"RETINOPATÍA PROLIFERATIVA DE AMBOS OJOS DEBIDA A ANEMIA DREPANOCÍTICA"
  },
  {
    "codigo":788891004,
    "descripcion":"DOLOR CRÓNICO DESPUÉS DE TRATAMIENTO ANTINEOPLÁSICO"
  },
  {
    "codigo":231835006,
    "descripcion":"SARCOMA DE KAPOSI PALPEBRAL"
  },
  {
    "codigo":1193651003,
    "descripcion":"INFLAMACIÓN INTESTINAL POR BLASTOMYCES DERMATITIDIS"
  },
  {
    "codigo":262768002,
    "descripcion":"FRAGMENTACIÓN DE GLÁNDULA SALIVAL"
  },
  {
    "codigo":721520003,
    "descripcion":"SÍNDROME DEL CORDÓN POSTERIOR DE MÉDULA ESPINAL AL NIVEL DEL TERCER SEGMENTO LUMBAR"
  },
  {
    "codigo":66160001,
    "descripcion":"GASTROENTERITIS POR CRIPTOSPORIDIOS"
  },
  {
    "codigo":197232005,
    "descripcion":"DOLOR ANORRECTAL"
  },
  {
    "codigo":787056005,
    "descripcion":"EXCAVACIÓN DE PAPILA ÓPTICA DERECHA"
  },
  {
    "codigo":11826511000119106,
    "descripcion":"DISTENSIÓN DE TENDÓN DE MÚSCULO FLEXOR DE CADERA IZQUIERDA"
  },
  {
    "codigo":195397000,
    "descripcion":"TROMBOFLEBITIS SUPERFICIAL DE VENA SAFENA EXTERNA"
  },
  {
    "codigo":129861002,
    "descripcion":"HALLAZGO EN LA ACTIVIDAD FÍSICA"
  },
  {
    "codigo":719685004,
    "descripcion":"SÍNDROME DE AUSENCIA DE PULGAR CON BAJA ESTATURA E INMUNODEFICIENCIA"
  },
  {
    "codigo":293701006,
    "descripcion":"ALERGIA A ÁCIDO URSODEOXICÓLICO"
  },
  {
    "codigo":424773009,
    "descripcion":"NO RECONOCE LAS ETAPAS DEL DUELO"
  },
  {
    "codigo":291866002,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR CORTICOTROFINA"
  },
  {
    "codigo":193562004,
    "descripcion":"GLAUCOMA DE ÁNGULO ABIERTO DEBIDO A TRASTORNO VASCULAR OCULAR"
  },
  {
    "codigo":717850006,
    "descripcion":"BRAQUIMELIA DE MIEMBRO INFERIOR"
  },
  {
    "codigo":191727003,
    "descripcion":"NEUMONÍA POSARAMPIONOSA"
  },
  {
    "codigo":331241000119104,
    "descripcion":"CUERPO EXTRAÑO RETENIDO EN PÁRPADO DERECHO"
  },
  {
    "codigo":93423006,
    "descripcion":"DERMATITIS PALPEBRAL"
  },
  {
    "codigo":419268000,
    "descripcion":"VISIÓN A DISTANCIA 6\/3"
  },
  {
    "codigo":224495009,
    "descripcion":"CUIDADOR FÁCILMENTE DISPONIBLE"
  },
  {
    "codigo":3561000119106,
    "descripcion":"PÉRDIDA DE LA AUDICIÓN SEVERA"
  },
  {
    "codigo":714180007,
    "descripcion":"ORIFICIO ANORMAL DE ARTERIA CORONARIA"
  },
  {
    "codigo":124356008,
    "descripcion":"DEFICIENCIA DE COLINA - FOSFATO CITIDILILTRANSFERASA"
  },
  {
    "codigo":791000221108,
    "descripcion":"INTOXICACIÓN POR HIDROCARBUROS AROMÁTICOS VOLÁTILES"
  },
  {
    "codigo":284526005,
    "descripcion":"SUCCIÓN DE LA LENGUA"
  },
  {
    "codigo":251758007,
    "descripcion":"DIPLOPÍA INCONGRUENTE"
  },
  {
    "codigo":413763001,
    "descripcion":"CUIDADOR DE PERSONA CON DISCAPACIDAD FÍSICA"
  },
  {
    "codigo":282691004,
    "descripcion":"INCAPAZ DE EMPUJAR Y ARRASTRAR HACIA ADELANTE UN JUGUETE GRANDE CON RUEDAS"
  },
  {
    "codigo":774211005,
    "descripcion":"SÍNDROME DE DERMATITIS SEVERA, ALERGIAS MÚLTIPLES Y CONSUNCIÓN METABÓLICA"
  },
  {
    "codigo":249923006,
    "descripcion":"BLOQUEO ARTICULAR"
  },
  {
    "codigo":315459008,
    "descripcion":"NACIDO EN KUWAIT"
  },
  {
    "codigo":248088009,
    "descripcion":"ELECCIÓN DE OBJETO SEXUAL NO ORTODOXO"
  },
  {
    "codigo":279021003,
    "descripcion":"DOLOR DE EPIDÍDIMO"
  },
  {
    "codigo":11829021000119101,
    "descripcion":"AMPOLLA TRAUMÁTICA DE MUSLO DERECHO"
  },
  {
    "codigo":311789006,
    "descripcion":"CATARATA CORTICAL INMADURA"
  },
  {
    "codigo":277186004,
    "descripcion":"LESIÓN DE NERVIO PERIFÉRICO CAUSADA POR UN RAYO"
  },
  {
    "codigo":687901000119103,
    "descripcion":"RABDOMIOSARCOMA PRIMARIO DE REGIÓN DE HOMBRO"
  },
  {
    "codigo":735938006,
    "descripcion":"CEFALEA AGUDA"
  },
  {
    "codigo":703170006,
    "descripcion":"ESTENOSIS DE PRÓTESIS DE VÁLVULA AÓRTICA"
  },
  {
    "codigo":211650008,
    "descripcion":"CUERPO EXTRAÑO EN LA URETRA"
  },
  {
    "codigo":15042005,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM VACCAE"
  },
  {
    "codigo":111511003,
    "descripcion":"QUISTE DE IMPLANTACIÓN EN EL CUERPO CILIAR"
  },
  {
    "codigo":308119005,
    "descripcion":"GASTROENTERITIS VIRAL INFANTIL"
  },
  {
    "codigo":275351006,
    "descripcion":"MUÑECA EN VALGO"
  },
  {
    "codigo":209815008,
    "descripcion":"DESGARRO COMPLETO, LIGAMENTO SACROESPINOSO"
  },
  {
    "codigo":766871009,
    "descripcion":"DISPLASIA DE LA UNIÓN ENTRE DIENCÉFALO Y MESENCÉFALO"
  },
  {
    "codigo":109676003,
    "descripcion":"MIGRACIÓN DENTAL CON FRACTURA"
  },
  {
    "codigo":371820004,
    "descripcion":"PACIENTE EN VENTILACIÓN MECÁNICA"
  },
  {
    "codigo":76908005,
    "descripcion":"FACTOR DE LACTOSA"
  },
  {
    "codigo":240748008,
    "descripcion":"BLASTOMICOSIS CUTÁNEA DISEMINADA"
  },
  {
    "codigo":271681002,
    "descripcion":"DOLOR DE ESTÓMAGO"
  },
  {
    "codigo":15980471000119101,
    "descripcion":"TRASTORNO DEL DISCO ARTICULAR DE AMBAS ARTICULACIONES TEMPOROMANDIBULARES"
  },
  {
    "codigo":9537004,
    "descripcion":"GANGLIOSIDOSIS GM 2 JUVENIL"
  },
  {
    "codigo":402753005,
    "descripcion":"ENFERMEDAD CUTÁNEA ATRIBUIBLE A TRATAMIENTO CON CORTICOSTEROIDES"
  },
  {
    "codigo":238913005,
    "descripcion":"CORISTIA PERIUMBILICAL"
  },
  {
    "codigo":75073007,
    "descripcion":"MALACOPLASIA DE VEJIGA URINARIA"
  },
  {
    "codigo":1156417006,
    "descripcion":"ASTROCITOMA FIBRILAR DE CEREBRO"
  },
  {
    "codigo":73238002,
    "descripcion":"ENCOGIMIENTO"
  },
  {
    "codigo":269846003,
    "descripcion":"PRUEBAS DE HORMONAS TIROIDEAS DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":237078008,
    "descripcion":"SÍNDROME DE DISTENSIÓN UTERINA"
  },
  {
    "codigo":366315007,
    "descripcion":"HALLAZGO RELACIONADO CON EL TAMAÑO DEL OVARIO"
  },
  {
    "codigo":10655671000119105,
    "descripcion":"ÚLCERA ISQUÉMICA ATEROSCLERÓTICA DE PIE DERECHO"
  },
  {
    "codigo":298944003,
    "descripcion":"ARTICULACIÓN DE LA MUÑECA - TUMEFACCIÓN SINOVIAL"
  },
  {
    "codigo":724928003,
    "descripcion":"LACERACIÓN DE FASCIA DE BÍCEPS BRAQUIAL"
  },
  {
    "codigo":67733005,
    "descripcion":"GLAUKOMFLECKEN"
  },
  {
    "codigo":721258000,
    "descripcion":"INFECCIÓN DE GLÁNDULA LAGRIMAL CAUSADA POR BACTERIA"
  },
  {
    "codigo":723093008,
    "descripcion":"TEMOR A CÁNCER DEL SISTEMA RESPIRATORIO"
  },
  {
    "codigo":229738006,
    "descripcion":"DIFICULTAD EN EL HALLAZGO DEL LENGUAJE"
  },
  {
    "codigo":31295000,
    "descripcion":"FLEBITIS DE LA VENA ILÍACA"
  },
  {
    "codigo":15708241000119104,
    "descripcion":"TROMBOSIS VENOSA PROFUNDA AGUDA DE EXTREMIDAD INFERIOR DERECHA COMO EFECTO TARDÍO DE INJERTO PUENTE DE ARTERIA CORONARIA"
  },
  {
    "codigo":129599004,
    "descripcion":"RECIÉN NACIDO MACROSÓMICO DE MADRE DIABÉTICA"
  },
  {
    "codigo":16527441000119105,
    "descripcion":"CARCINOMA NO MICROCÍTICO PRIMARIO DE LÓBULO INFERIOR DE PULMÓN IZQUIERDO"
  },
  {
    "codigo":291604004,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR CEFTIZOXIMA"
  },
  {
    "codigo":193300006,
    "descripcion":"MÚLTIPLES CUERPOS EXTRAÑOS INTRAOCULARES, MAGNÉTICOS, ANTIGUOS"
  },
  {
    "codigo":94996007,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA PIEL PERIANAL"
  },
  {
    "codigo":93161000,
    "descripcion":"LIPOMA DE PIEL Y TEJIDO CELULAR SUBCUTÁNEO DEL CUERO CABELLUDO"
  },
  {
    "codigo":422676009,
    "descripcion":"CARCINOMA ESCAMOCELULAR DEL ALA DE LA NARIZ"
  },
  {
    "codigo":715753001,
    "descripcion":"ATAXIA ESPINOCEREBELOSA TIPO 8"
  },
  {
    "codigo":224233001,
    "descripcion":"DURMIENDO EN AUTOMÓVIL"
  },
  {
    "codigo":1010665006,
    "descripcion":"ÚLCERA HELICOIDAL DE CORDÓN UMBILICAL"
  },
  {
    "codigo":307281000119108,
    "descripcion":"DISTANCIA INTEROCLUSAL EXCESIVA DE DIENTES COMPLETAMENTE ERUPCIONADOS"
  },
  {
    "codigo":143441000119108,
    "descripcion":"ARTRITIS REUMATOIDE EN REMISIÓN"
  },
  {
    "codigo":60393006,
    "descripcion":"HOMOEROTISMO JUVENIL"
  },
  {
    "codigo":191465006,
    "descripcion":"DEMENCIA ARTERIOSCLERÓTICA CON PARANOIA"
  },
  {
    "codigo":255166003,
    "descripcion":"NEOPLASIA BENIGNA DEL APARATO RESPIRATORIO"
  },
  {
    "codigo":1303742003,
    "descripcion":"DESPLAZAMIENTO DE TUBO DE OJO IZQUIERDO DEBIDO A CIRUGÍA DE GLAUCOMA Y POSTERIOR A ELLA"
  },
  {
    "codigo":58558003,
    "descripcion":"HIPERLISINEMIA"
  },
  {
    "codigo":286099004,
    "descripcion":"CAPAZ DE LIMPIAR UNA HABITACIÓN"
  },
  {
    "codigo":253331005,
    "descripcion":"CONDUCTO VENOSO CERRADO"
  },
  {
    "codigo":42661000087100,
    "descripcion":"PROLAPSO DE DISCO INTERVERTEBRAL C4-C5"
  },
  {
    "codigo":47781000087103,
    "descripcion":"FRACTURA DE QUINTA COSTILLA DERECHA"
  },
  {
    "codigo":185960001,
    "descripcion":"PROBLEMA DE VIVIENDA RESUELTO"
  },
  {
    "codigo":40101000087108,
    "descripcion":"LUXACIÓN DE ARTICULACIÓN DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":218728005,
    "descripcion":"CAYADO AÓRTICO INTERRUMPIDO"
  },
  {
    "codigo":448104005,
    "descripcion":"ESTENOSIS AÓRTICA SUPRAVALVULAR LOCALIZADA EN LA UNIÓN SENOTUBULAR"
  },
  {
    "codigo":251496007,
    "descripcion":"ACTIVIDAD THETA FOCAL EPISÓDICA"
  },
  {
    "codigo":282429000,
    "descripcion":"AVULSIÓN DE HÍGADO"
  },
  {
    "codigo":54888009,
    "descripcion":"ESGUINCE DE RODILLA"
  },
  {
    "codigo":184125002,
    "descripcion":"ES CUESTIONABLE SI EL PRIMER NOMBRE DEL PACIENTE ES CORRECTO"
  },
  {
    "codigo":284264008,
    "descripcion":"CAPAZ DE UTILIZAR PRENSIÓN PALMAR"
  },
  {
    "codigo":85821003,
    "descripcion":"SÍNDROME CEREBRAL AGUDO NO PSICÓTICO"
  },
  {
    "codigo":249661007,
    "descripcion":"SECRECIÓN DEL ANO"
  },
  {
    "codigo":16091371000119108,
    "descripcion":"ANGIOSARCOMA PRIMARIO DE PIEL DE REGIÓN TEMPORAL"
  },
  {
    "codigo":1263634003,
    "descripcion":"TRASTORNO FETAL DEBIDO A MALPOSICIÓN DURANTE PARTO"
  },
  {
    "codigo":83986005,
    "descripcion":"HIPOTIROIDISMO GRAVE"
  },
  {
    "codigo":247826009,
    "descripcion":"MIEDO A PARECER RIDÍCULO"
  },
  {
    "codigo":1163495009,
    "descripcion":"DACRIOADENITIS POR NEISSERIA GONORRHOEAE"
  },
  {
    "codigo":735676003,
    "descripcion":"NARCOLEPSIA TIPO 1"
  },
  {
    "codigo":299271000000100,
    "descripcion":"NECESIDAD IMPERIOSA DE ORINAR NUEVAMENTE POCO DESPUÉS DE FINALIZAR MICCIÓN"
  },
  {
    "codigo":1290897001,
    "descripcion":"CONDROSARCOMA DESDIFERENCIADO"
  },
  {
    "codigo":1069831000000107,
    "descripcion":"DIFICULTAD PARA ASISTIR CON LA PREPARACIÓN DE COMIDAS"
  },
  {
    "codigo":1064711000000108,
    "descripcion":"INDECISO SOBRE LA ORIENTACIÓN SEXUAL"
  },
  {
    "codigo":406161008,
    "descripcion":"ALTERACIÓN DE LA FUNCIÓN PARENTAL"
  },
  {
    "codigo":209553009,
    "descripcion":"ESGUINCE DE LIGAMENTO ILIOLUMBAR"
  },
  {
    "codigo":240486003,
    "descripcion":"CRISIS APLÁSICA PARVOVIRAL"
  },
  {
    "codigo":109414004,
    "descripcion":"DISOSTOSIS ESFENOIDAL"
  },
  {
    "codigo":11110006,
    "descripcion":"REACCIÓN AUTOINMUNITARIA MEDIADA POR ANTICUERPOS ANTI - TEJIDO, SIN PARTICIPACIÓN DE COMPLEMENTO"
  },
  {
    "codigo":699238006,
    "descripcion":"SORDERA PRELINGUAL CONGÉNITA"
  },
  {
    "codigo":43878008,
    "descripcion":"FARINGITIS ESTREPTOCÓCICA"
  },
  {
    "codigo":1287227000,
    "descripcion":"FRACTURA PATOLÓGICA DE MÚLTIPLES HUESOS"
  },
  {
    "codigo":9275003,
    "descripcion":"FRACTURA DE SITIOS MÚLTIPLES DEL METACARPO"
  },
  {
    "codigo":369723005,
    "descripcion":"G4: NÚCLEOS ANÓMALOS Y MULTILOBULADOS, DE 20 Μ O MÁS; NUCLÉOLOS PROMINENTES, CROMATINA GRUMOSA"
  },
  {
    "codigo":402491006,
    "descripcion":"CALCINOSIS LUEGO DE INFARTO VENOSO\/ARTERIAL"
  },
  {
    "codigo":238651007,
    "descripcion":"ESTRÍAS DE WICKHAM EN EL LIQUEN PLANO"
  },
  {
    "codigo":10631711000119105,
    "descripcion":"ONIQUIA DE DEDO DE MANO IZQUIERDA"
  },
  {
    "codigo":171280006,
    "descripcion":"SIN CONSENTIMIENTO PARA VACUNACIÓN MMR"
  },
  {
    "codigo":236816007,
    "descripcion":"INFERTILIDAD ASOCIADA CON ANTICUERPOS ANTIESPERMATOZOIDES"
  },
  {
    "codigo":300517004,
    "descripcion":"GLANDE DEL PENE PEQUEÑO"
  },
  {
    "codigo":366053006,
    "descripcion":"HALLAZGO RELACIONADO CON EL DRENAJE LAGRIMAL"
  },
  {
    "codigo":169445007,
    "descripcion":"ANTICONCEPCIÓN NO NECESARIA"
  },
  {
    "codigo":202213008,
    "descripcion":"SUBLUXACIÓN POSTERIOR RECURRENTE DE ARTICULACIÓN DE HOMBRO"
  },
  {
    "codigo":234981009,
    "descripcion":"MANCHADO DENTARIO EXTRÍNSECO - MARRÓN"
  },
  {
    "codigo":396986002,
    "descripcion":"LOCALIZACIÓN TUMORAL LUEGO DE SU SECCIÓN, NO PUEDE SER DETERMINADA"
  },
  {
    "codigo":724666003,
    "descripcion":"ALTERACIONES PERCEPTIVAS CONCOMITANTES CON ABSTINENCIA DE HIPNÓTICO Y DEBIDAS A ELLA"
  },
  {
    "codigo":298682008,
    "descripcion":"COLUMNA LUMBAR HELADA AL TACTO"
  },
  {
    "codigo":822970008,
    "descripcion":"CISTOADENOCARCINOMA DE CÉLULAS ACINARES DE PRÓSTATA"
  },
  {
    "codigo":722831002,
    "descripcion":"INFECCIÓN DE SISTEMA GENITAL FEMENINO DESPUÉS DE PROCEDIMIENTO DE REPRODUCCIÓN ASISTIDA MÉDICAMENTE"
  },
  {
    "codigo":296847003,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE DEXAMETASONA"
  },
  {
    "codigo":427919004,
    "descripcion":"ARTERIOSCLEROSIS CORONARIA CAUSADA POR RADIACIÓN"
  },
  {
    "codigo":11997881000119104,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DE ANTEBRAZO DERECHO"
  },
  {
    "codigo":1279887007,
    "descripcion":"SÍNDROME DE HIPERACTIVACIÓN DE COMPLEMENTO, TROMBOSIS ANGIOPÁTICA Y ENTEROPATÍA PERDEDORA DE PROTEÍNAS"
  },
  {
    "codigo":165775009,
    "descripcion":"PRUEBA DE COOMBS INDIRECTA POSITIVA"
  },
  {
    "codigo":131172004,
    "descripcion":"NIVEL DE METAHEMOGLOBINA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1343588005,
    "descripcion":"ÚLCERA NEUROPÁTICA DE PIE"
  },
  {
    "codigo":426084006,
    "descripcion":"INFECCIÓN BACTERIANA RESISTENTE A BETALACTÁMICOS"
  },
  {
    "codigo":65636009,
    "descripcion":"QUERATOCONO"
  },
  {
    "codigo":293177002,
    "descripcion":"REACCIÓN ADVERSA A LA INSULINA"
  },
  {
    "codigo":31033002,
    "descripcion":"SÍNDROME MEDULAR POSTERIOR DEBIDO A FRACTURA NO EXPUESTA A NIVEL DE T1 - T6"
  },
  {
    "codigo":15684281000119107,
    "descripcion":"PERIOSTITIS DE MANOS BILATERALES"
  },
  {
    "codigo":719161008,
    "descripcion":"DISCAPACIDAD INTELECTUAL SINDRÓMICA LIGADA AL CROMOSOMA X DEBIDA A MUTACIÓN DE DOMINIO INTERACTIVO JUMONJI AT-RICH 1C"
  },
  {
    "codigo":94734001,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE CONDUCTO ANAL"
  },
  {
    "codigo":291342001,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR DIFENHIDRAMINA"
  },
  {
    "codigo":225806000,
    "descripcion":"PRESIONADO POR LA PAREJA"
  },
  {
    "codigo":1076051000119103,
    "descripcion":"QUISTE MUCOSO DIGITAL DE MANO DERECHA"
  },
  {
    "codigo":966011731000119103,
    "descripcion":"PANCOLITIS ULCEROSA AGUDA"
  },
  {
    "codigo":1208846006,
    "descripcion":"INSUFICIENCIA VENTRICULAR DERECHA POR TRASTORNO PULMONAR"
  },
  {
    "codigo":715491000,
    "descripcion":"PARAPLEJÍA ESPÁSTICA TIPO 11 AUTOSÓMICA RECESIVA"
  },
  {
    "codigo":60131003,
    "descripcion":"CICATRIZ ADHERENTE"
  },
  {
    "codigo":125667009,
    "descripcion":"CONTUSIÓN"
  },
  {
    "codigo":446461000124103,
    "descripcion":"FRACTURA DE RADIO DERECHO"
  },
  {
    "codigo":416909000,
    "descripcion":"DESEMPEÑO PSICOMOTOR ALTERADO"
  },
  {
    "codigo":123832009,
    "descripcion":"SATISFACTORIO PARA EVALUACIÓN, PERO LIMITADO POR PRESENCIA DE INFLAMACIÓN QUE ENMASCARA PARCIALMENTE EL RESULTADO"
  },
  {
    "codigo":459261000124106,
    "descripcion":"LESIÓN TRAUMÁTICA DE RODILLA IZQUIERDA"
  },
  {
    "codigo":1172408009,
    "descripcion":"11-DESOXICORTICOSTERONA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":23693000,
    "descripcion":"ÚLCERA DUODENAL AGUDA SIN HEMORRAGIA, SIN PERFORACIÓN Y SIN OBSTRUCCIÓN"
  },
  {
    "codigo":254904008,
    "descripcion":"CARCINOMA DEL GLANDE DEL PENE"
  },
  {
    "codigo":284002000,
    "descripcion":"LESIÓN TRAUMÁTICA DE ESTRUCTURAS DENTALES"
  },
  {
    "codigo":56461008,
    "descripcion":"ÚLCERA PÉPTICA CRÓNICA CON HEMORRAGIA Y OBSTRUCCIÓN"
  },
  {
    "codigo":415074004,
    "descripcion":"HERNIA PERINEAL"
  },
  {
    "codigo":709986007,
    "descripcion":"ESQUEMA OCLUSAL DENTADO MODERADAMENTE COMPROMETIDO"
  },
  {
    "codigo":251234009,
    "descripcion":"ALTURA DEL COMPLEJO QRS AUMENTADA"
  },
  {
    "codigo":314935002,
    "descripcion":"NISTAGMO ADQUIRIDO"
  },
  {
    "codigo":85559002,
    "descripcion":"ANOMALÍA DE PELGER - HUËT"
  },
  {
    "codigo":1363511001,
    "descripcion":"ENZIMA CARDÍACA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":87394009,
    "descripcion":"HIPERTENSIÓN PULMONAR EPISÓDICA"
  },
  {
    "codigo":52791002,
    "descripcion":"ESTADO DE MADUREZ SEXUAL FEMENINA"
  },
  {
    "codigo":249399007,
    "descripcion":"FOLÍCULOS LINFOIDES EN PARED POSTERIOR DE FARINGE"
  },
  {
    "codigo":413239008,
    "descripcion":"COMPLICACIÓN DE PROCEDIMIENTO NO QUIRÚRGICO PREVIO EN LA VÍA BILIAR"
  },
  {
    "codigo":282167009,
    "descripcion":"CAPAZ DE SUBIR UNA COLINA"
  },
  {
    "codigo":444172003,
    "descripcion":"ATAQUE ISQUÉMICO CEREBRAL TRANSITORIO RECURRENTE"
  },
  {
    "codigo":247564004,
    "descripcion":"MECHÓN CANOSO"
  },
  {
    "codigo":50956007,
    "descripcion":"PEZÓN ACCESORIO"
  },
  {
    "codigo":1359841001,
    "descripcion":"NEOPLASIA MALIGNA DE UNIÓN FARINGOESOFÁGICA"
  },
  {
    "codigo":737249005,
    "descripcion":"FOTODERMATITIS CONCOMITANTE CON ENFERMEDAD AUTOINMUNITARIA Y DEBIDA A ELLA"
  },
  {
    "codigo":702646000,
    "descripcion":"LESIÓN CAVITADA EXTENSA CON DENTINA EXPUESTA"
  },
  {
    "codigo":473270003,
    "descripcion":"QUEMADURA DE TERCER GRADO DE MÚLTIPLES SITIOS DE LA MUÑECA"
  },
  {
    "codigo":47286004,
    "descripcion":"AGREGACIÓN"
  },
  {
    "codigo":16014471000119103,
    "descripcion":"TROMBOFLEBITIS DE MIEMBRO INFERIOR DERECHO"
  },
  {
    "codigo":1259702008,
    "descripcion":"CARCINOMA ESCAMOSO ADENOIDE PRIMARIO DE NASOFARINGE"
  },
  {
    "codigo":373131000,
    "descripcion":"DEFECTO NO RESTRICTIVO DEL TABIQUE INTERVENTRICULAR"
  },
  {
    "codigo":405899007,
    "descripcion":"FENOTIPO K-K+"
  },
  {
    "codigo":11836551000119105,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN TARSOMETATARSIANA DE PIE DERECHO"
  },
  {
    "codigo":110987009,
    "descripcion":"PTERIGIÓN DE UÑA"
  },
  {
    "codigo":404064001,
    "descripcion":"HIBERNOMA"
  },
  {
    "codigo":764512003,
    "descripcion":"SÍNDROME DE TRISOMÍA DISTAL 22Q"
  },
  {
    "codigo":830048009,
    "descripcion":"OVARIO DERECHO POLIQUÍSTICO"
  },
  {
    "codigo":32570681000036106,
    "descripcion":"SEXO INDETERMINADO"
  },
  {
    "codigo":402229003,
    "descripcion":"DERMATITIS ATÓPICA AGUDA DE MANO"
  },
  {
    "codigo":74549004,
    "descripcion":"INFESTACIÓN CAUSADA POR OEDEMAGENA"
  },
  {
    "codigo":238389005,
    "descripcion":"FORÚNCULOS DE MÚLTIPLES LOCALIZACIONES"
  },
  {
    "codigo":305760009,
    "descripcion":"VISTA POR OBSTÉTRICA HOSPITALARIA"
  },
  {
    "codigo":271157008,
    "descripcion":"AMPOLLA TRAUMÁTICA DEL BRAZO, INFECTADA"
  },
  {
    "codigo":236554001,
    "descripcion":"DOLOR DURANTE EL INGRESO DE LA SOLUCIÓN DE DIÁLISIS"
  },
  {
    "codigo":105482003,
    "descripcion":"PROBLEMA AMBIENTAL OCUPACIONAL"
  },
  {
    "codigo":302090003,
    "descripcion":"ULCERACIÓN DE GANGLIO LINFÁTICO AXILAR"
  },
  {
    "codigo":1186826005,
    "descripcion":"TRASTORNO DEL DESARROLLO ACADÉMICO DEBIDO A DEFICIENCIA DE HIERRO"
  },
  {
    "codigo":433162006,
    "descripcion":"LESIÓN TRAUMÁTICA DE LIGAMENTO CRUZADO POSTERIOR"
  },
  {
    "codigo":39946007,
    "descripcion":"MITMACHEN"
  },
  {
    "codigo":201951003,
    "descripcion":"ARTROPATÍA TRAUMÁTICA DE LA ARTICULACIÓN SACROILÍACA"
  },
  {
    "codigo":365791005,
    "descripcion":"NIVEL DE LÍQUIDO - HALLAZGO"
  },
  {
    "codigo":300255008,
    "descripcion":"PROBLEMA EN LA CAVIDAD BUCAL"
  },
  {
    "codigo":298420005,
    "descripcion":"SIN EXTENSIÓN ACTIVA DE LA COLUMNA CERVICAL"
  },
  {
    "codigo":429492007,
    "descripcion":"ALIVIO DEL DOLOR AL SENTARSE"
  },
  {
    "codigo":36276008,
    "descripcion":"NEURITIS RETROBULBAR SIFILÍTICA"
  },
  {
    "codigo":34441006,
    "descripcion":"AMPOLLA DE LA MANO, CON INFECCIÓN"
  },
  {
    "codigo":165513007,
    "descripcion":"RECUENTO DIFERENCIAL DE LEUCOCITOS FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":294750007,
    "descripcion":"ALERGIA A HIDROXIPROGESTERONA"
  },
  {
    "codigo":1144883003,
    "descripcion":"MEJORÍA EN EL NIVEL DE AUTOCONTROL"
  },
  {
    "codigo":127551000119100,
    "descripcion":"HIPOPLASIA CONGÉNITA DE CEREBRO"
  },
  {
    "codigo":15984191000119101,
    "descripcion":"TUBERCULOSIS DE OÍDO DERECHO"
  },
  {
    "codigo":137791000119100,
    "descripcion":"CONDROCALCINOSIS DE CODO DEBIDA A TRASTORNO DEL METABOLISMO DEL CALCIO"
  },
  {
    "codigo":301631000119101,
    "descripcion":"ABSCESO DE VAINA TENDINOSA DE ANTEBRAZO DERECHO"
  },
  {
    "codigo":10669631000119104,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN DE REGIÓN COCCÍGEA DE ESPALDA ESTADIO III"
  },
  {
    "codigo":161843009,
    "descripcion":"INGESTA NORMAL DE LÍQUIDOS"
  },
  {
    "codigo":16002111000119106,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DEBIDO A TROMBO DE ARTERIA CEREBRAL MEDIA IZQUIERDA"
  },
  {
    "codigo":688191000119107,
    "descripcion":"NEURILEMOMA DE NERVIO DEL TRONCO"
  },
  {
    "codigo":16703551000119107,
    "descripcion":"DÉFICIT DE MEMORIA DEBIDO A ENFERMEDAD CEREBROVASCULAR Y POSTERIOR A ELLA"
  },
  {
    "codigo":12238911000119108,
    "descripcion":"ALTERACIÓN DE ALINEACIÓN DE RODILLA IZQUIERDA"
  },
  {
    "codigo":15989311000119107,
    "descripcion":"CONJUNTIVITIS DE AMBOS OJOS CAUSADA POR VIRUS HERPES ZÓSTER"
  },
  {
    "codigo":16058431000119104,
    "descripcion":"ENFERMEDAD DE LA SUSTANCIA BLANCA"
  },
  {
    "codigo":2111000119106,
    "descripcion":"DISPLASIA GLENOIDEA CONGÉNITA"
  },
  {
    "codigo":61704003,
    "descripcion":"MANCHADO POSERUPTIVO DE DIENTE CAUSADO POR TETRACICLINA"
  },
  {
    "codigo":11844671000119105,
    "descripcion":"RUPTURA TRAUMÁTICA DE ARTERIA AORTA TORÁCICA"
  },
  {
    "codigo":334911000119107,
    "descripcion":"HEMORRAGIA EN VAINA DE NERVIO ÓPTICO DERECHO"
  },
  {
    "codigo":127240008,
    "descripcion":"NEOPLASIA DE LOS GANGLIOS LINFÁTICOS SUBMENTONIANOS"
  },
  {
    "codigo":92637002,
    "descripcion":"CARCINOMA IN SITU DE LA PARED LATERAL DE LA OROFARINGE"
  },
  {
    "codigo":94472007,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL PERITONEO PARIETAL"
  },
  {
    "codigo":289245000,
    "descripcion":"PÉRDIDA MODERADA DE SANGRE MATERNA"
  },
  {
    "codigo":1303218001,
    "descripcion":"ADENOMIOSIS DE TROMPA DE FALOPIO"
  },
  {
    "codigo":123570003,
    "descripcion":"ANOMALÍA CONGÉNITA DE HUESO DEL CARPO"
  },
  {
    "codigo":254642004,
    "descripcion":"ADENOMA DE PULMÓN"
  },
  {
    "codigo":25266006,
    "descripcion":"ESFEROCITOSIS HEREDITARIA POR DEFICIENCIA DE ESPECTRINA"
  },
  {
    "codigo":58034007,
    "descripcion":"HIPERGAMMAGLOBULINEMIA CONGÉNITA"
  },
  {
    "codigo":1137543009,
    "descripcion":"CALCIFICACIÓN PUNTEADA DE EPÍFISIS DE FALANGE DISTAL DE MANO"
  },
  {
    "codigo":283740003,
    "descripcion":"MORDEDURA DE PERRO EN LA REGIÓN OCULAR"
  },
  {
    "codigo":87132004,
    "descripcion":"ABSTINENCIA DE OPIÁCEOS"
  },
  {
    "codigo":314673000,
    "descripcion":"PESO DEL NIÑO: PERCENTILO 3-8"
  },
  {
    "codigo":249137001,
    "descripcion":"LÍQUIDO AMNIÓTICO CON MECONIO ANTIGUO"
  },
  {
    "codigo":609585002,
    "descripcion":"SÍNDROME DEL ATARDECER"
  },
  {
    "codigo":343791000119101,
    "descripcion":"RETINOPATÍA BILATERAL POR PREMATUREZ"
  },
  {
    "codigo":773425000,
    "descripcion":"PARAPLEJÍA ESPÁSTICA AUTOSÓMICA RECESIVA TIPO 59"
  },
  {
    "codigo":1230342001,
    "descripcion":"REINFECCIÓN POR VIRUS HEPATITIS B POSTERIOR A TRASPLANTE DE HÍGADO"
  },
  {
    "codigo":50694005,
    "descripcion":"EMPIEMA CON FÍSTULA MEDIASTÍNICA"
  },
  {
    "codigo":443910006,
    "descripcion":"INFECCIÓN DE PRÓTESIS TOTAL DE ARTICULACIÓN DE CADERA"
  },
  {
    "codigo":1155720006,
    "descripcion":"ZINC SÉRICO POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":704219002,
    "descripcion":"FRACTURA EXPUESTA DE TERCER METACARPIANO"
  },
  {
    "codigo":278235004,
    "descripcion":"ENLENTECIMIENTO FOCAL DE LA CONDUCCIÓN NERVIOSA SENSITIVA"
  },
  {
    "codigo":1081071000119105,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE MÚSCULO DE EXTREMIDAD SUPERIOR IZQUIERDA"
  },
  {
    "codigo":210864001,
    "descripcion":"LESIÓN TRAUMÁTICA DE VASOS SANGUÍNEOS DE MIEMBRO INFERIOR"
  },
  {
    "codigo":473008002,
    "descripcion":"DOLOR EN MEJILLA"
  },
  {
    "codigo":16111000119105,
    "descripcion":"ABORTO ESPONTÁNEO INCOMPLETO DEBIDO A HEMORRAGIA"
  },
  {
    "codigo":702384004,
    "descripcion":"SÍNDROME DE RESTRICCIÓN DEL CRECIMIENTO INTRAUTERINO, DISPLASIA METAFISARIA, HIPOPLASIA SUPRARRENAL CONGÉNITA Y ANOMALÍA GENITAL"
  },
  {
    "codigo":15990511000119106,
    "descripcion":"TRASTORNO DEGENERATIVO DE AMBOS OJOS"
  },
  {
    "codigo":11786121000119100,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE MANO DERECHA CON INFECCIÓN"
  },
  {
    "codigo":407472000,
    "descripcion":"ENCEFALITIS POR NAIROVIRUS"
  },
  {
    "codigo":438405000,
    "descripcion":"LLANTO AGUDO"
  },
  {
    "codigo":276400009,
    "descripcion":"AMÍGDALAS SALUDABLES"
  },
  {
    "codigo":47024008,
    "descripcion":"ENFERMEDAD DE CÉLULAS FALCIFORMES - HEMOGLOBINA E"
  },
  {
    "codigo":1259440007,
    "descripcion":"CARCINOMA PRIMARIO DE AMÍGDALA"
  },
  {
    "codigo":307333004,
    "descripcion":"ISOINMUNIZACIÓN RHESUS POR INMUNOGLOBULINA ANTI - D"
  },
  {
    "codigo":209029005,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN METATARSOFALÁNGICA ÚNICA"
  },
  {
    "codigo":77957000,
    "descripcion":"FIEBRE INTERMITENTE"
  },
  {
    "codigo":241797005,
    "descripcion":"EFECTO TÓXICO CAUSADO POR HERBICIDA CON TRIACINA O TRIAZOL"
  },
  {
    "codigo":733317009,
    "descripcion":"UVEÍTIS ANTERIOR PRIMARIA"
  },
  {
    "codigo":371034003,
    "descripcion":"INCOORDINACIÓN SUCCIÓN-DEGLUCIÓN"
  },
  {
    "codigo":239962004,
    "descripcion":"LESIÓN DE LIGAMENTOS DE REGIÓN DE HOMBRO"
  },
  {
    "codigo":76122006,
    "descripcion":"HIPERQUERATOSIS PROVOCADA POR PINTA"
  },
  {
    "codigo":10586006,
    "descripcion":"TRASTORNO POR ESTRÉS RELACIONADO CON LA OCUPACIÓN"
  },
  {
    "codigo":403802007,
    "descripcion":"PAQUIONIQUIA CONGÉNITA TIPO III DE SCHAFER-BRUNAUER"
  },
  {
    "codigo":895322006,
    "descripcion":"FORMA DE BALA ANORMAL CONGÉNITA DE FALANGE PROXIMAL DE DEDO ANULAR"
  },
  {
    "codigo":305498008,
    "descripcion":"BAJO ATENCIÓN DE ESPECIALISTA EN REHABILITACIÓN"
  },
  {
    "codigo":762415003,
    "descripcion":"TRASTORNO DE ÁNGULO IRIDOCORNEAL"
  },
  {
    "codigo":400132000,
    "descripcion":"NEOPLASIA VASCULAR DE PIEL"
  },
  {
    "codigo":1286703008,
    "descripcion":"FRACTURA POR AVULSIÓN DE FALANGE DE DEDO PULGAR"
  },
  {
    "codigo":301828003,
    "descripcion":"NECROSIS DE BRONQUIO"
  },
  {
    "codigo":170756003,
    "descripcion":"TABLAS DE AZÚCAR EN SANGRE"
  },
  {
    "codigo":72452005,
    "descripcion":"HIPERNATREMIA CEREBRAL"
  },
  {
    "codigo":365529002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA RECONOCER OBJETOS POR MEDIO DEL TACTO"
  },
  {
    "codigo":37849005,
    "descripcion":"ANOMALÍA UTERINA CONGÉNITA"
  },
  {
    "codigo":234457009,
    "descripcion":"HIPOFIBRINOGENEMIA"
  },
  {
    "codigo":298158002,
    "descripcion":"DERRAME EN CARILLA ARTICULAR DORSAL"
  },
  {
    "codigo":724142005,
    "descripcion":"SÍNDROME DE GLICOPROTEÍNAS DEFICIENTES EN CARBOHIDRATOS TIPO 2A"
  },
  {
    "codigo":296323001,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE COCAÍNA"
  },
  {
    "codigo":230787005,
    "descripcion":"DISFASIA EXPRESIVA CONGÉNITA"
  },
  {
    "codigo":66947006,
    "descripcion":"INFESTACIÓN CAUSADA POR HIRUDO MEDICINALIS"
  },
  {
    "codigo":294488005,
    "descripcion":"ALERGIA A ENOXACINO"
  },
  {
    "codigo":346301000119100,
    "descripcion":"RUPTURA DE MEMBRANA DE DESCEMET DE AMBOS OJOS"
  },
  {
    "codigo":292653002,
    "descripcion":"REACCIÓN ADVERSA A SURFACTANTE ANIÓNICO"
  },
  {
    "codigo":11815101000119101,
    "descripcion":"RUPTURA TRAUMÁTICA DE LIGAMENTO DE ARTICULACIÓN DE DEDO MEDIO DE MANO DERECHA"
  },
  {
    "codigo":194349005,
    "descripcion":"ENFERMEDAD DE MÉNIÈRE COCLEAR ACTIVA"
  },
  {
    "codigo":481462461000119102,
    "descripcion":"PORTADOR DE ATROFIA MUSCULAR ESPINAL"
  },
  {
    "codigo":30509009,
    "descripcion":"TRASTORNO DE LA IDENTIDAD SEXUAL EN LA ADOLESCENCIA, PREVIAMENTE HOMOSEXUAL"
  },
  {
    "codigo":290818003,
    "descripcion":"INTOXICACIÓN POR CLOMIPRAMINA"
  },
  {
    "codigo":94210005,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE VASO SANGUÍNEO DEL MIEMBRO SUPERIOR"
  },
  {
    "codigo":782338006,
    "descripcion":"INTOLERANCIA AL GLUTAMATO MONOSÓDICO"
  },
  {
    "codigo":126978008,
    "descripcion":"NEOPLASIA DEL NERVIO HIPOGLOSO"
  },
  {
    "codigo":878807001,
    "descripcion":"CARCINOMA GÁSTRICO POSITIVO PARA HER2"
  },
  {
    "codigo":288983003,
    "descripcion":"INCAPAZ DE SUCCIONAR"
  },
  {
    "codigo":25004000,
    "descripcion":"HEMORRAGIA SUBDURAL POR ANOXIA Y\/O HIPOXIA INTRAPARTO"
  },
  {
    "codigo":92375009,
    "descripcion":"NEOPLASIA BENIGNA DE LA PIEL DEL CUERO CABELLUDO"
  },
  {
    "codigo":188844000,
    "descripcion":"NEOPLASIA BENIGNA DE CONDUCTO HEPÁTICO"
  },
  {
    "codigo":1237420004,
    "descripcion":"SÍNDROME DE DISCAPACIDAD INTELECTUAL, RETRASO GLOBAL DEL DESARROLLO, DISMORFIA FACIAL, REMANENTE CAUDAL DEL SACRO LIGADO AL CROMOSOMA X"
  },
  {
    "codigo":57772006,
    "descripcion":"FRACTURA EXPUESTA DEL TERCER HUESO METATARSIANO"
  },
  {
    "codigo":449153001,
    "descripcion":"ADENOCARCINOMA DE ESÓFAGO INFERIOR"
  },
  {
    "codigo":1268353003,
    "descripcion":"ADENOCARCINOMA DE CÉLULAS CLARAS DE OVARIO METASTÁSICO"
  },
  {
    "codigo":283478000,
    "descripcion":"HERIDA PUNZANTE EN LOS GENITALES"
  },
  {
    "codigo":414550002,
    "descripcion":"LESIÓN DE JANEWAY"
  },
  {
    "codigo":54102005,
    "descripcion":"ESTADIO G1"
  },
  {
    "codigo":21334005,
    "descripcion":"INTENTO FALLIDO DE ABORTO CON OLIGURIA"
  },
  {
    "codigo":447318008,
    "descripcion":"RETORNO VENOSO PULMONAR OBSTRUIDO A NIVEL DE COMUNICACIÓN INTERAURICULAR"
  },
  {
    "codigo":248875007,
    "descripcion":"VAGINA ESTRECHA"
  },
  {
    "codigo":10641751000119105,
    "descripcion":"ÚLCERA CRÓNICA DE PIERNA DERECHA"
  },
  {
    "codigo":412715009,
    "descripcion":"CÉLULAS DE LA ZONA DE TRANSFORMACIÓN PRESENTES EN EL EXTENDIDO CERVICAL"
  },
  {
    "codigo":707627009,
    "descripcion":"CARCINOMA PRIMARIO DE HIPOFARINGE, TIPO GLÁNDULA SALIVAL"
  },
  {
    "codigo":443648003,
    "descripcion":"NEOPLASIA MALIGNA DE OÍDO"
  },
  {
    "codigo":1197312004,
    "descripcion":"ADENOCARCINOMA METASTÁSICO DE GANGLIO LINFÁTICO ABDOMINAL"
  },
  {
    "codigo":1230080005,
    "descripcion":"PATRÓN DE USO NOCIVO DE ANSIOLÍTICO SIN DEPENDENCIA"
  },
  {
    "codigo":247040009,
    "descripcion":"HALLAZGO DEL MARGEN PUPILAR"
  },
  {
    "codigo":767658000,
    "descripcion":"NEUTROPENIA DEBIDA A QUIMIOTERAPIA Y POSTERIOR A ELLA"
  },
  {
    "codigo":210602002,
    "descripcion":"LESIÓN POR AVULSIÓN ANULAR, CLASE 3"
  },
  {
    "codigo":308906005,
    "descripcion":"NEUMONÍA BACTERIANA SECUNDARIA"
  },
  {
    "codigo":46762006,
    "descripcion":"TRASTORNO DEL DESEO SEXUAL"
  },
  {
    "codigo":472746006,
    "descripcion":"TRASTORNO CEREBROVASCULAR DEBIDO A EMBOLIA PARADÓJICA"
  },
  {
    "codigo":734890007,
    "descripcion":"SEPARACIÓN ANTERIOR DE DIENTES INFERIORES"
  },
  {
    "codigo":307071002,
    "descripcion":"DIFICULTAD PARA SOSTENER BEBIDAS"
  },
  {
    "codigo":700287003,
    "descripcion":"ECTROPIÓN SENIL DE PÁRPADO SUPERIOR"
  },
  {
    "codigo":10861041000119105,
    "descripcion":"HEMATOMA DE ÓRBITA IZQUIERDA"
  },
  {
    "codigo":403540000,
    "descripcion":"NEVO PIGMENTADO CONGÉNITO CON PROLIFERACIÓN MELANOCÍTICA ATÍPICA"
  },
  {
    "codigo":75860007,
    "descripcion":"TRASTORNO DE LA FARINGE"
  },
  {
    "codigo":205097005,
    "descripcion":"TALIPES EQUINO CONGÉNITO"
  },
  {
    "codigo":74025007,
    "descripcion":"TROPÍA INTERMITENTE"
  },
  {
    "codigo":205619006,
    "descripcion":"TRISOMÍA 13 - SIN DISYUNCIÓN MEIÓTICA"
  },
  {
    "codigo":6654000,
    "descripcion":"RIGIDEZ DEL DEDO GORDO ADQUIRIDA"
  },
  {
    "codigo":11817611000119102,
    "descripcion":"ESGUINCE DE LIGAMENTO DE DEDO ANULAR IZQUIERDO"
  },
  {
    "codigo":236030003,
    "descripcion":"HERNIA CRURAL ESTRANGULADA"
  },
  {
    "codigo":170494004,
    "descripcion":"PORTADOR DE PROTOZOARIO AMEBIANO"
  },
  {
    "codigo":39422006,
    "descripcion":"DERMATITIS DE LA UNIÓN DERMOEPIDÉRMICA, TIPO LIQUENOIDE"
  },
  {
    "codigo":301566006,
    "descripcion":"NO SE MOVILIZA EN LUGARES ABIERTOS"
  },
  {
    "codigo":365267000,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA USAR EQUIPO DOMÉSTICO"
  },
  {
    "codigo":1153534006,
    "descripcion":"SEPSIS CAUSADA POR ENTEROCOCCUS RESISTENTE A LA VANCOMICINA"
  },
  {
    "codigo":399870006,
    "descripcion":"RETINOPATÍA DIABÉTICA PROLIFERATIVA SIN ALTO RIESGO Y SIN EDEMA DE MÁCULA DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":266963001,
    "descripcion":"EXENTO DEL SERVICIO MILITAR"
  },
  {
    "codigo":1348307004,
    "descripcion":"ENFERMEDAD ADRENOCORTICAL NODULAR PIGMENTADA PRIMARIA AISLADA"
  },
  {
    "codigo":234195006,
    "descripcion":"INFECCIÓN DE INJERTO VASCULAR"
  },
  {
    "codigo":135891007,
    "descripcion":"NIÑO NECESITADO"
  },
  {
    "codigo":396200000,
    "descripcion":"TUMOR RENAL MACROSCÓPICAMENTE CIRCUNSCRIPTO AL RIÑÓN"
  },
  {
    "codigo":4819006,
    "descripcion":"DERRAME DE ARTICULACIÓN DE TOBILLO Y\/O PIE"
  },
  {
    "codigo":428968002,
    "descripcion":"PULSOS FEMORALES DESIGUALES"
  },
  {
    "codigo":232360002,
    "descripcion":"NEUMATIZACIÓN DE CORNETE MEDIO"
  },
  {
    "codigo":723880004,
    "descripcion":"ABSCESO DE TRACTO RESPIRATORIO SUPERIOR"
  },
  {
    "codigo":16077451000119106,
    "descripcion":"CONJUNTIVITIS HEMORRÁGICA AGUDA DE OJO DERECHO CAUSADA POR ENTEROVIRUS"
  },
  {
    "codigo":363432004,
    "descripcion":"NEOPLASIA MALIGNA DE TRÁQUEA"
  },
  {
    "codigo":230525002,
    "descripcion":"COMPRESIÓN DE LA RADIACIÓN ÓPTICA"
  },
  {
    "codigo":197757004,
    "descripcion":"SÍFILIS RENAL TARDÍA"
  },
  {
    "codigo":348811000119108,
    "descripcion":"GLAUCOMA SECUNDARIO DEBIDO A AFAQUIA DE OJO IZQUIERDO"
  },
  {
    "codigo":32082000,
    "descripcion":"COMPETENCIA"
  },
  {
    "codigo":294226009,
    "descripcion":"ALERGIA A MIVACURIO"
  },
  {
    "codigo":423463003,
    "descripcion":"CARCINOMA BASOCELULAR DE LA ESPALDA"
  },
  {
    "codigo":718375003,
    "descripcion":"DIENTE PERMANENTE NORMAL"
  },
  {
    "codigo":128551005,
    "descripcion":"FÍSTULA AÓRTICA"
  },
  {
    "codigo":95783006,
    "descripcion":"NISTAGMO ROTACIONAL"
  },
  {
    "codigo":292391005,
    "descripcion":"REACCIÓN ADVERSA A LA TIETILPERAZINA"
  },
  {
    "codigo":61180001,
    "descripcion":"TRASTORNO DE LA IDENTIDAD SEXUAL DEL ADULTO, NO ATRAÍDO SEXUALMENTE POR NINGUNO DE LOS DOS SEXOS"
  },
  {
    "codigo":1306364001,
    "descripcion":"NEOPLASIA BENIGNA DE CUADRANTE SUPERIOR INTERNO DE MAMA"
  },
  {
    "codigo":28412004,
    "descripcion":"SÍNDROME DE POLIPOSIS MÚLTIPLE NO FAMILIAR"
  },
  {
    "codigo":93948004,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA PLEURA PARIETAL"
  },
  {
    "codigo":126716006,
    "descripcion":"NEOPLASIA DEL LÓBULO INFERIOR DERECHO DEL PULMÓN"
  },
  {
    "codigo":225020008,
    "descripcion":"DUELO ANTES DE LA MUERTE"
  },
  {
    "codigo":92113003,
    "descripcion":"NEOPLASIA BENIGNA DE HUESO FRONTAL"
  },
  {
    "codigo":288721007,
    "descripcion":"HABLA MIENTRAS JUEGA"
  },
  {
    "codigo":188582000,
    "descripcion":"ENFERMEDAD DE HODGKIN, CELULARIDAD MIXTA DE GANGLIOS LINFÁTICOS DE MÚLTIPLES LOCALIZACIONES"
  },
  {
    "codigo":252283005,
    "descripcion":"PERIODONTITIS MARGINAL"
  },
  {
    "codigo":285051006,
    "descripcion":"DIFICULTAD PARA USAR LENTES DE CONTACTO"
  },
  {
    "codigo":186747009,
    "descripcion":"INFECCIÓN POR CORONAVIRUS"
  },
  {
    "codigo":282888002,
    "descripcion":"CAPAZ DE PONERSE DE PIE DESDE LA POSICIÓN SENTADA"
  },
  {
    "codigo":283216007,
    "descripcion":"ANZUELO EN LA INGLE"
  },
  {
    "codigo":709200009,
    "descripcion":"ARTRITIS BACTERIANA DE ARTICULACIÓN COSTOTRANSVERSA"
  },
  {
    "codigo":84773003,
    "descripcion":"ANOMALÍA CONGÉNITA DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":1088601000119101,
    "descripcion":"OTOESCLEROSIS COCLEAR DE OÍDO IZQUIERDO"
  },
  {
    "codigo":248613005,
    "descripcion":"MATIDEZ DIAFRAGMÁTICA DESPLAZADA HACIA ARRIBA"
  },
  {
    "codigo":1231653008,
    "descripcion":"DEFORMIDAD ÓSEA Y DE PARTES BLANDAS COMBINADA POSQUIRÚRGICA DE ÓRBITA"
  },
  {
    "codigo":707365008,
    "descripcion":"HEMANGIOMA ESCLEROSANTE DE PULMÓN"
  },
  {
    "codigo":1297189009,
    "descripcion":"QUEMADURA DE CUARTO DEDO DE PIE"
  },
  {
    "codigo":679001000119103,
    "descripcion":"QUERATOPATÍA BULLOSA AFÁQUICA DE OJO DERECHO"
  },
  {
    "codigo":50170006,
    "descripcion":"ENFERMEDAD CAUSADA POR BETAHERPESVIRINAE"
  },
  {
    "codigo":17402007,
    "descripcion":"PAVOR DIURNO"
  },
  {
    "codigo":81103005,
    "descripcion":"ATRESIA DE VENA"
  },
  {
    "codigo":408783007,
    "descripcion":"ESTADO DE PROFILAXIS ANTI-D PRENATAL"
  },
  {
    "codigo":441551009,
    "descripcion":"INFLAMACIÓN DE LARINGE CAUSADA POR VIRUS"
  },
  {
    "codigo":79268002,
    "descripcion":"SÍNDROME POEMS"
  },
  {
    "codigo":308644003,
    "descripcion":"SITUACIÓN DE LA SOLICITUD DE PASAPORTE"
  },
  {
    "codigo":46500003,
    "descripcion":"SEQUEDAD DE LA VULVA"
  },
  {
    "codigo":15670361000119106,
    "descripcion":"CONTRACTURA CONGÉNITA DE AMBOS MÚSCULOS GEMELOS"
  },
  {
    "codigo":110201004,
    "descripcion":"QUEMADURA DE TERCER GRADO DEL VESTÍBULO MAXILAR"
  },
  {
    "codigo":75598001,
    "descripcion":"TRASTORNO DEL CLORO"
  },
  {
    "codigo":698190002,
    "descripcion":"VARICOCELE PALPABLE SIN MANIOBRA DE VALSALVA"
  },
  {
    "codigo":370510007,
    "descripcion":"CUERPO EXTRAÑO LINEAL DEL TRACTO GASTROINTESTINAL"
  },
  {
    "codigo":77851000146104,
    "descripcion":"VIRUS PAPILOMA HUMANO DE ALTO RIESGO NO DETECTADO"
  },
  {
    "codigo":1288014009,
    "descripcion":"ARTROSIS SECUNDARIA DE MUÑECA"
  },
  {
    "codigo":237603002,
    "descripcion":"DIABETES MELLITUS TRANSITORIA DEL RECIÉN NACIDO"
  },
  {
    "codigo":1255246007,
    "descripcion":"FRACTURA CONMINUTA NO EXPUESTA DE FALANGE MEDIA DE DEDO DE MANO"
  },
  {
    "codigo":1220643007,
    "descripcion":"TAQUICARDIA CON COMPLEJO QRS DE ANCHURA REGULAR"
  },
  {
    "codigo":203000000,
    "descripcion":"ABSCESO DE BOLSA SEROSA DE TOBILLO"
  },
  {
    "codigo":235768002,
    "descripcion":"ÚLCERA TRAUMÁTICA DE INTESTINO GRUESO"
  },
  {
    "codigo":299469001,
    "descripcion":"PIE ERITEMATOSO"
  },
  {
    "codigo":792824009,
    "descripcion":"TODOS LOS PULSOS PRESENTES EN EL PIE DERECHO"
  },
  {
    "codigo":4557003,
    "descripcion":"SÍNDROME PREINFARTO"
  },
  {
    "codigo":365005002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA ARTICULAR CLARAMENTE LA PALABRA"
  },
  {
    "codigo":102861005,
    "descripcion":"CRISTAL URINARIO, PIROFOSFATO"
  },
  {
    "codigo":233933006,
    "descripcion":"RECHAZO DEL TRASPLANTE CARDÍACO"
  },
  {
    "codigo":37325002,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA VENA SAFENA"
  },
  {
    "codigo":166562001,
    "descripcion":"ALFA - FETOPROTEÍNA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":68258002,
    "descripcion":"INTOXICACIÓN POR KOCHIA SCOPARIA"
  },
  {
    "codigo":35490003,
    "descripcion":"FORÚNCULO DE HOMBRO"
  },
  {
    "codigo":363170005,
    "descripcion":"INFLAMACIÓN DE ESTRUCTURAS O TEJIDOS CORPORALES ESPECÍFICOS"
  },
  {
    "codigo":721783001,
    "descripcion":"INFECCIÓN CAUSADA POR VIRUS CHAPARE"
  },
  {
    "codigo":33655002,
    "descripcion":"CISTITIS CRÓNICA"
  },
  {
    "codigo":426871003,
    "descripcion":"TRASTORNO CITOTÓXICO MEDIADO POR CÉLULAS"
  },
  {
    "codigo":263031003,
    "descripcion":"SUBLUXACIÓN ARTICULAR"
  },
  {
    "codigo":295799003,
    "descripcion":"SOBREDOSIS DE FÁRMACO INMUNODEPRESOR"
  },
  {
    "codigo":164727006,
    "descripcion":"PRUEBA VISUAL NORMAL"
  },
  {
    "codigo":199330009,
    "descripcion":"EMBARAZO MÚLTIPLE, TODOS NACIDOS POR FÓRCEPS Y VENTOSA"
  },
  {
    "codigo":197495008,
    "descripcion":"MALABSORCIÓN - HIERRO"
  },
  {
    "codigo":195660001,
    "descripcion":"FARINGITIS ESTAFILOCÓCICA AGUDA"
  },
  {
    "codigo":230263009,
    "descripcion":"PARAPLEJÍA ESPÁSTICA AUTOSÓMICA DOMINANTE TIPO 17"
  },
  {
    "codigo":293964005,
    "descripcion":"ALERGIA A ACEBUTOLOL"
  },
  {
    "codigo":11986471000119100,
    "descripcion":"QUEMADURA EPIDÉRMICA DE ANTEBRAZO IZQUIERDO"
  },
  {
    "codigo":31820007,
    "descripcion":"ANEMIA ASOCIADA CON TRASTORNO ENDOCRINO"
  },
  {
    "codigo":228428007,
    "descripcion":"SIGUE LA MISMA RUTINA RELACIONADA CON EL CONSUMO DE DROGA TODOS LOS DÍAS"
  },
  {
    "codigo":128289001,
    "descripcion":"METABOLOPATÍA CRÓNICA"
  },
  {
    "codigo":719948009,
    "descripcion":"SÍNDROME DE TRIGONOCEFALIA CON NARIZ BÍFIDA Y ANOMALÍA DE PARTES ACRAS"
  },
  {
    "codigo":11849101000119106,
    "descripcion":"ABRASIÓN DE PIEL DE MAMA IZQUIERDA"
  },
  {
    "codigo":161057005,
    "descripcion":"CARENCIA DE ESTIMULACIÓN"
  },
  {
    "codigo":95521008,
    "descripcion":"MOVIMIENTO ANORMAL DE LA MANDÍBULA"
  },
  {
    "codigo":191990001,
    "descripcion":"TIC TRANSITORIO DE LA NIÑEZ"
  },
  {
    "codigo":292129009,
    "descripcion":"REACCIÓN ADVERSA A LA CISAPRIDA"
  },
  {
    "codigo":1142262004,
    "descripcion":"HIPERTROFIA DE MÚSCULO DE CUELLO"
  },
  {
    "codigo":93686005,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA ESPALDA"
  },
  {
    "codigo":716278005,
    "descripcion":"EPILEPSIA CON MIOCLONÍA DE PÁRPADO"
  },
  {
    "codigo":91851002,
    "descripcion":"ALTERACIÓN ADQUIRIDA DE LA COLORACIÓN DEL ESMALTE DENTAL"
  },
  {
    "codigo":57248000,
    "descripcion":"ACTITUD FETAL EN FLEXIÓN"
  },
  {
    "codigo":124619009,
    "descripcion":"DEFICIENCIA DE L-SERINA AMONÍACO LIASA"
  },
  {
    "codigo":1304267008,
    "descripcion":"GLAUCOMA DE ÁNGULO CERRADO SECUNDARIO DE OJO IZQUIERDO DEBIDO A SÍNDROME ENDOTELIAL IRIDOCORNEAL"
  },
  {
    "codigo":26315009,
    "descripcion":"OBSTRUCCIÓN CONGÉNITA DEL INTESTINO DELGADO"
  },
  {
    "codigo":253856005,
    "descripcion":"QUISTE PARAMEATAL CONGÉNITO"
  },
  {
    "codigo":448629000,
    "descripcion":"ANILLO VASCULAR CON CAYADO AÓRTICO IZQUIERDO Y LIGAMENTO ARTERIAL DERECHO"
  },
  {
    "codigo":1204128009,
    "descripcion":"ATEROEMBOLIA DE COLESTEROL CEREBRAL"
  },
  {
    "codigo":24480009,
    "descripcion":"CONDUCCIÓN NERVIOSA ANORMAL"
  },
  {
    "codigo":284789003,
    "descripcion":"NO SE LAVA"
  },
  {
    "codigo":252021003,
    "descripcion":"HIPOACTIVIDAD URETRAL"
  },
  {
    "codigo":55413008,
    "descripcion":"OSTEÍTIS CONDENSANTE"
  },
  {
    "codigo":1003850000,
    "descripcion":"DEFICIENCIA DE SUBUNIDAD E1 ALFA DEL COMPLEJO PIRUVATO DESHIDROGENASA"
  },
  {
    "codigo":414026006,
    "descripcion":"TRASTORNO DE PROLIFERACIÓN DE CÉLULA HEMATOPOYÉTICA"
  },
  {
    "codigo":282954007,
    "descripcion":"CAPAZ DE ENDEREZARSE"
  },
  {
    "codigo":1264159004,
    "descripcion":"TRASTORNO POSTERIOR A EMBARAZO MOLAR"
  },
  {
    "codigo":17140000,
    "descripcion":"ICTERICIA NEONATAL DEBIDA A CONJUGACIÓN RETARDADA"
  },
  {
    "codigo":49908003,
    "descripcion":"EPIGLOTITIS AGUDA SIN OBSTRUCCIÓN"
  },
  {
    "codigo":211913005,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO PROFUNDA DE DORSO DE LA MANO"
  },
  {
    "codigo":1293257007,
    "descripcion":"CON MAYOR RIESGO DE ENFERMEDAD NEOPLÁSICA"
  },
  {
    "codigo":15728321000119108,
    "descripcion":"FÍSTULA DE ARTICULACIÓN DE REGIÓN DE AMBOS HOMBROS"
  },
  {
    "codigo":210078001,
    "descripcion":"LESIÓN CARDÍACA CON HEMOPERICARDIO"
  },
  {
    "codigo":408521009,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: CREOL"
  },
  {
    "codigo":13470001,
    "descripcion":"ILEOCOLITIS ULCEROSA CRÓNICA"
  },
  {
    "codigo":767134003,
    "descripcion":"MUTACIÓN DE LA PROTEÍNA ADAPTADORA DEL RECEPTOR DE LIPOPROTEÍNAS DE BAJA DENSIDAD TIPO 1"
  },
  {
    "codigo":11796161000119109,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN METACARPOFALÁNGICA DE DEDO MEDIO DE MANO IZQUIERDA"
  },
  {
    "codigo":11635001,
    "descripcion":"CONDUCTA ANTISOCIAL DEL ADULTO"
  },
  {
    "codigo":109939003,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LOS NERVIOS PERIFÉRICOS DE LA CADERA"
  },
  {
    "codigo":699763005,
    "descripcion":"COROIDITIS FOCAL DE POLO POSTERIOR DEL OJO"
  },
  {
    "codigo":403016001,
    "descripcion":"TIÑA DE CUERO CABELLUDO POR TRICHOPHYTON SOUDANENSE"
  },
  {
    "codigo":239176002,
    "descripcion":"DOLOR POSMASTECTOMÍA"
  },
  {
    "codigo":697928004,
    "descripcion":"HIPERTENSIÓN DE ARTERIA PULMONAR DEBIDA A ESTENOSIS CONGÉNITA DE VENA PULMONAR"
  },
  {
    "codigo":75336004,
    "descripcion":"ENFERMEDAD POR EL VIRUS MARITUBA"
  },
  {
    "codigo":73501001,
    "descripcion":"PÁPULAS POR PRESIÓN PIGMENTADAS DOLOROSAS"
  },
  {
    "codigo":206408009,
    "descripcion":"HEMORRAGIA RECTAL PERINATAL"
  },
  {
    "codigo":40733004,
    "descripcion":"ENFERMEDAD INFECCIOSA"
  },
  {
    "codigo":270109005,
    "descripcion":"INFORME FORENSE POSTMORTEM SOLICITADO"
  },
  {
    "codigo":827165009,
    "descripcion":"PULSO LENTO LIMÍTROFE"
  },
  {
    "codigo":366578002,
    "descripcion":"AMPLITUD DE LA ROTACIÓN EXTERNA DE LA CADERA - HALLAZGO"
  },
  {
    "codigo":38898003,
    "descripcion":"PIELONEFRITIS XANTOGRANULOMATOSA"
  },
  {
    "codigo":302877009,
    "descripcion":"MENINGITIS POR PROTEUS"
  },
  {
    "codigo":268274005,
    "descripcion":"ENCONDROMATOSIS"
  },
  {
    "codigo":399346004,
    "descripcion":"DESGARRO DE SUPRAESPINOSO"
  },
  {
    "codigo":364743002,
    "descripcion":"PUNTAJE DE APGAR A LOS 10 MINUTOS - HALLAZGO"
  },
  {
    "codigo":299207004,
    "descripcion":"ARTICULACIÓN DEL PULGAR TIBIA AL TACTO"
  },
  {
    "codigo":266439004,
    "descripcion":"APENDICITIS AGUDA CON ABSCESO APENDICULAR"
  },
  {
    "codigo":102599008,
    "descripcion":"PIEL TIBIA"
  },
  {
    "codigo":428444001,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA UTILIZAR UNA ASPIRADORA"
  },
  {
    "codigo":788892006,
    "descripcion":"FRACTURA COMPLEJA DE EXTREMO INFERIOR DE FÉMUR SIN EXTENSIÓN HACIA LA ARTICULACIÓN"
  },
  {
    "codigo":197233000,
    "descripcion":"INFECCIÓN PERIANAL"
  },
  {
    "codigo":295537000,
    "descripcion":"SOBREDOSIS DE ISOFLURANO"
  },
  {
    "codigo":721521004,
    "descripcion":"SÍNDROME DEL CORDÓN POSTERIOR DE MÉDULA ESPINAL AL NIVEL DEL CUARTO SEGMENTO LUMBAR"
  },
  {
    "codigo":262769005,
    "descripcion":"LACERACIÓN DE GLÁNDULA SALIVAL"
  },
  {
    "codigo":424774003,
    "descripcion":"CONVEXIDAD DE LA CURVATURA ESPINAL HACIA LA DERECHA"
  },
  {
    "codigo":10760181000119109,
    "descripcion":"PARO CARDÍACO DEBIDO A ABORTO ESPONTÁNEO"
  },
  {
    "codigo":719686003,
    "descripcion":"MONOSOMÍA DISTAL 10P"
  },
  {
    "codigo":129862009,
    "descripcion":"CONOCIMIENTOS ESCASOS ACERCA DE LA EVALUACIÓN DIAGNÓSTICA"
  },
  {
    "codigo":62491004,
    "descripcion":"FROTEURISMO"
  },
  {
    "codigo":816155005,
    "descripcion":"HIPOVOLEMIA ABSOLUTA"
  },
  {
    "codigo":29723007,
    "descripcion":"FORÚNCULO DE PARED DEL TÓRAX"
  },
  {
    "codigo":93424000,
    "descripcion":"SÍNDROME DIROFILARIÁSICO DE LA VENA CAVA"
  },
  {
    "codigo":329871000119105,
    "descripcion":"ESCOLIOSIS NEUROMUSCULAR CERVICOTORÁCICA DEBIDA A POLIOMIELITIS Y POSTERIOR A ELLA"
  },
  {
    "codigo":1254664002,
    "descripcion":"ESTENOSIS DE RAMA DIAGONAL DE RAMA DESCENDENTE ANTERIOR DE ARTERIA CORONARIA IZQUIERDA"
  },
  {
    "codigo":224496005,
    "descripcion":"CUIDADOR NO FÁCILMENTE DISPONIBLE"
  },
  {
    "codigo":191728008,
    "descripcion":"TEMOR A LAS MULTITUDES"
  },
  {
    "codigo":124357004,
    "descripcion":"DEFICIENCIA DE ADN NUCLEOTIDILEXOTRANSFERASA"
  },
  {
    "codigo":714181006,
    "descripcion":"ORIFICIO ANORMAL DE SENO CORONARIO"
  },
  {
    "codigo":26053008,
    "descripcion":"INFECCIÓN CAUSADA POR ASCOMYCETES"
  },
  {
    "codigo":15704361000119102,
    "descripcion":"ATROFIA DE MÚSCULO DE AMBAS PIERNAS"
  },
  {
    "codigo":253594000,
    "descripcion":"ATRESIA MUSCULAR DE VÁLVULA PULMONAR"
  },
  {
    "codigo":286362007,
    "descripcion":"CAPAZ DE UTILIZAR EL LENGUAJE"
  },
  {
    "codigo":284527001,
    "descripcion":"SE MUERDE LA LENGUA"
  },
  {
    "codigo":251759004,
    "descripcion":"CORRESPONDENCIA RETINIANA"
  },
  {
    "codigo":22383006,
    "descripcion":"FRACTURA NO EXPUESTA DE LA BÓVEDA CRANEAL CON LACERACIÓN Y\/O CONTUSIÓN CEREBRAL"
  },
  {
    "codigo":249924000,
    "descripcion":"TRABA TRANSITORIA DE ARTICULACIÓN"
  },
  {
    "codigo":774212003,
    "descripcion":"SÍNDROME DE MICROCÓRNEA, ATROFIA CORIORRETINIANA MIÓPICA Y TELECANTO"
  },
  {
    "codigo":53316003,
    "descripcion":"OTOMICOSIS"
  },
  {
    "codigo":315460003,
    "descripcion":"NACIDO EN KYRGYZSTAN"
  },
  {
    "codigo":282692006,
    "descripcion":"EMPUJA Y TIRA HACIA ADELANTE UN JUGUETE GRANDE CON RUEDAS"
  },
  {
    "codigo":413764007,
    "descripcion":"CUIDADOR DE PERSONA CON ALTERACIÓN DEL SENSORIO"
  },
  {
    "codigo":705006002,
    "descripcion":"ELEVACIÓN LATERAL DE SEGMENTO ST"
  },
  {
    "codigo":279022005,
    "descripcion":"DOLOR POSVASECTOMÍA"
  },
  {
    "codigo":770542008,
    "descripcion":"ISOCROMÍA YQ"
  },
  {
    "codigo":735939003,
    "descripcion":"INGESTA INSUFICIENTE DE ALIMENTOS Y AGUA CONCOMITANTE CON DESCUIDO DE SÍ MISMO Y DEBIDO A ÉL"
  },
  {
    "codigo":703171005,
    "descripcion":"FALLA DE PRÓTESIS DE VÁLVULA AÓRTICA"
  },
  {
    "codigo":277187008,
    "descripcion":"NEUROPATÍA PROXIMAL DEL NERVIO MEDIANO"
  },
  {
    "codigo":766872002,
    "descripcion":"PARKINSONISMO CAUSADO POR CIANURO"
  },
  {
    "codigo":111512005,
    "descripcion":"SINEQUIAS POSTERIORES DEL IRIS"
  },
  {
    "codigo":209816009,
    "descripcion":"DESGARRO COMPLETO, LIGAMENTO SACROILÍACO"
  },
  {
    "codigo":109677007,
    "descripcion":"LUXACIÓN DENTAL LATERAL"
  },
  {
    "codigo":10818141000119102,
    "descripcion":"FRACTURA EXPUESTA DE FALANGE DISTAL DE DEDO MEDIO DERECHO"
  },
  {
    "codigo":1354861009,
    "descripcion":"SÍNDROME DE ENFERMEDAD PULMONAR, INMUNODEFICIENCIA Y RUPTURA CROMOSÓMICA"
  },
  {
    "codigo":1156418001,
    "descripcion":"TUMOR RABDOIDE MALIGNO"
  },
  {
    "codigo":402754004,
    "descripcion":"DERMATOSIS POR TRATAMIENTO ANTICOAGULANTE"
  },
  {
    "codigo":238914004,
    "descripcion":"ONFALITO"
  },
  {
    "codigo":42306005,
    "descripcion":"FRACTURA NO EXPUESTA DE HUESO CUNEIFORME DE PIE"
  },
  {
    "codigo":237079000,
    "descripcion":"TRASTORNO ASOCIADO CON DISPOSITIVO ANTICONCEPTIVO INTRAUTERINO RETENIDO"
  },
  {
    "codigo":7703001,
    "descripcion":"DEFECTO TUBULAR RENAL"
  },
  {
    "codigo":332381000119105,
    "descripcion":"RETINOPATÍA POR PREMATUREZ DEL OJO DERECHO ETAPA 2 - CRESTA INTRARRETINIANA"
  },
  {
    "codigo":204311009,
    "descripcion":"COMPLEJO DE EISENMENGER"
  },
  {
    "codigo":1285655009,
    "descripcion":"ENFERMEDAD LEVE POR DEFICIENCIA HEREDITARIA DE FACTOR VIII CON INHIBIDOR DE ALTA RESPUESTA"
  },
  {
    "codigo":71404003,
    "descripcion":"LIPOMATOSIS DOLOROSA"
  },
  {
    "codigo":300780007,
    "descripcion":"CAPAZ DE PARTICIPAR EN JUEGOS POR DIVERSIÓN"
  },
  {
    "codigo":366316008,
    "descripcion":"HALLAZGO RELACIONADO CON LA HABILIDAD PARA TENER RELACIONES SEXUALES"
  },
  {
    "codigo":298945002,
    "descripcion":"DEFORMIDAD DE ARTICULACIÓN DE MUÑECA"
  },
  {
    "codigo":11856631000119101,
    "descripcion":"LESIÓN TRAUMÁTICA DE MANGUITO DE LOS ROTADORES IZQUIERDO"
  },
  {
    "codigo":724929006,
    "descripcion":"LACERACIÓN DE TENDÓN DE BÍCEPS BRAQUIAL"
  },
  {
    "codigo":200641008,
    "descripcion":"INFECCIÓN DE LA REGIÓN DEL PULPEJO DE DEDO DEL PIE"
  },
  {
    "codigo":723094002,
    "descripcion":"QUISTE DE CARA"
  },
  {
    "codigo":10627831000119103,
    "descripcion":"ÁNTRAX DE MUSLO DERECHO"
  },
  {
    "codigo":305911000119103,
    "descripcion":"DESVIACIÓN DE LA MANDÍBULA DURANTE MOVIMIENTOS DE APERTURA Y CIERRE"
  },
  {
    "codigo":198806007,
    "descripcion":"INTENTO FALLIDO DE ABORTO CON INFECCIÓN PÉLVICA O DEL TRACTO GENITAL"
  },
  {
    "codigo":16034551000119104,
    "descripcion":"HIPERTROFIA ÓSEA DE HÚMERO DERECHO"
  },
  {
    "codigo":295275004,
    "descripcion":"SOBREDOSIS DE NAPROXENO"
  },
  {
    "codigo":29251000175102,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN DE GLÚTEO DERECHO GRADO 4"
  },
  {
    "codigo":8771000175103,
    "descripcion":"UTILIZA FUENTE DOMICILIARIA DE VENTILACIÓN DE PRESIÓN POSITIVA CONTINUA EN LA VÍA AÉREA"
  },
  {
    "codigo":721259008,
    "descripcion":"INFECCIÓN DE GLÁNDULA LAGRIMAL CAUSADA POR HONGO"
  },
  {
    "codigo":293440000,
    "descripcion":"REACCIÓN ADVERSA A LA DISOPIRAMIDA"
  },
  {
    "codigo":195136004,
    "descripcion":"MIOCARDITIS REUMATOIDEA"
  },
  {
    "codigo":167688002,
    "descripcion":"XILOSA DETECTADA EN ESPÉCIMEN DE MATERIA FECAL EXAMINADO CON CROMATOGRAFÍA"
  },
  {
    "codigo":422677000,
    "descripcion":"RESPUESTA A ESTÍMULOS VISUALES AUSENTE"
  },
  {
    "codigo":94997003,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL PERICARDIO"
  },
  {
    "codigo":289770001,
    "descripcion":"CUELLO UTERINO DELGADO"
  },
  {
    "codigo":1010666007,
    "descripcion":"SÍNDROME DE STICKLER TIPO 4"
  },
  {
    "codigo":419007000,
    "descripcion":"REACCIÓN ADVERSA A ANTIBIÓTICO SULFONAMIDA"
  },
  {
    "codigo":91327001,
    "descripcion":"CUADRIPARESIA"
  },
  {
    "codigo":715754007,
    "descripcion":"ATAXIA ESPINOCEREBELOSA TIPO 10"
  },
  {
    "codigo":93162007,
    "descripcion":"LIPOMA DEL CORDÓN ESPERMÁTICO"
  },
  {
    "codigo":191466007,
    "descripcion":"DEMENCIA ARTERIOSCLERÓTICA CON DEPRESIÓN"
  },
  {
    "codigo":16909201000119104,
    "descripcion":"BLEFARITIS ULCEROSA DE PÁRPADOS SUPERIOR E INFERIOR DERECHOS"
  },
  {
    "codigo":224234007,
    "descripcion":"HOGAR RECUPERADO"
  },
  {
    "codigo":255167007,
    "descripcion":"NEOPLASIA BENIGNA DE ÓRGANO DIGESTIVO"
  },
  {
    "codigo":89492000,
    "descripcion":"ADIPSIA"
  },
  {
    "codigo":713919009,
    "descripcion":"HIPOESPERMATOGÉNESIS"
  },
  {
    "codigo":1303743008,
    "descripcion":"DESPLAZAMIENTO DE TUBO DE DRENAJE DE AMBOS OJOS DEBIDO A CIRUGÍA DE GLAUCOMA Y POSTERIOR A ELLA"
  },
  {
    "codigo":417172003,
    "descripcion":"PACIENTE EN TRATAMIENTO CON DOSIS MÁXIMA TOLERADA DE BETABLOQUEANTE"
  },
  {
    "codigo":286100007,
    "descripcion":"INCAPAZ DE LIMPIAR UNA HABITACIÓN"
  },
  {
    "codigo":22121000,
    "descripcion":"TRASTORNO BIPOLAR I DEPRESIVO EN REMISIÓN TOTAL"
  },
  {
    "codigo":15680401000119107,
    "descripcion":"CONJUNTIVITIS FOLICULAR AGUDA POR ADENOVIRUS DE OJO DERECHO"
  },
  {
    "codigo":251497003,
    "descripcion":"ACTIVIDAD DELTA FOCAL EPISÓDICA"
  },
  {
    "codigo":185961002,
    "descripcion":"CASA FUMIGADA"
  },
  {
    "codigo":448105006,
    "descripcion":"ORIGEN ANÓMALO DE ARTERIA PULMONAR EN CONDUCTO ARTERIAL PERMEABLE"
  },
  {
    "codigo":184126001,
    "descripcion":"ES CUESTIONABLE SI EL APELLIDO DEL PACIENTE ES CORRECTO"
  },
  {
    "codigo":284265009,
    "descripcion":"INCAPAZ DE EMPLEAR AGARRE PALMAR"
  },
  {
    "codigo":51219000,
    "descripcion":"PULGAR BÍFIDO"
  },
  {
    "codigo":247827000,
    "descripcion":"MIEDO A DECIR ALGO INCORRECTO"
  },
  {
    "codigo":1263635002,
    "descripcion":"TRASTORNO FETAL DEBIDO A PELVIS MATERNA CONTRACTURADA DURANTE TRABAJO DE PARTO"
  },
  {
    "codigo":11803691000119104,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA PROXIMAL DE DEDO ANULAR IZQUIERDO"
  },
  {
    "codigo":334891000119105,
    "descripcion":"DESPRENDIMIENTO HEMORRÁGICO DE EPITELIO PIGMENTARIO DE LA RETINA"
  },
  {
    "codigo":38271000087105,
    "descripcion":"HIPOCINESIA DE SEGMENTO BASAL INFERIOR DE VENTRÍCULO CARDÍACO IZQUIERDO"
  },
  {
    "codigo":43391000087108,
    "descripcion":"LACERACIÓN SIMPLE DE PABELLÓN AURICULAR DERECHO"
  },
  {
    "codigo":1163496005,
    "descripcion":"GASTRITIS POR MUCORMICOSIS"
  },
  {
    "codigo":40831000087109,
    "descripcion":"QUEMADURA DE QUINTO DEDO DE PIE DERECHO"
  },
  {
    "codigo":49384009,
    "descripcion":"LESIÓN TRAUMÁTICA DEL NERVIO GLOSOFARÍNGEO"
  },
  {
    "codigo":735677007,
    "descripcion":"HEMORRAGIA NEONATAL DE HÍGADO"
  },
  {
    "codigo":78482005,
    "descripcion":"ENFERMEDAD DE BOUCHARD"
  },
  {
    "codigo":1290898006,
    "descripcion":"CONDROSARCOMA MESENQUIMATOSO"
  },
  {
    "codigo":109415003,
    "descripcion":"DISOSTOSIS ESFENOFRONTAL"
  },
  {
    "codigo":15955141000119104,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE GLÁNDULA DE BARTOLINO IZQUIERDA"
  },
  {
    "codigo":240487007,
    "descripcion":"INFECCIÓN PARVOVIRAL CONGÉNITA"
  },
  {
    "codigo":238652000,
    "descripcion":"LIQUEN PLANO CON LUPUS ERITEMATOSO SUPERPUESTO"
  },
  {
    "codigo":1354599007,
    "descripcion":"FRACTURA DE FALANGE DISTAL DE DEDO MEÑIQUE"
  },
  {
    "codigo":402492004,
    "descripcion":"CALCINOSIS LUEGO DE INFLAMACIÓN LOCALIZADA"
  },
  {
    "codigo":369724004,
    "descripcion":"G1: 5 POR CIENTO O MENOS DE CRECIMIENTO SÓLIDO NO ESCAMOSO"
  },
  {
    "codigo":1111521000000100,
    "descripcion":"CIERRE DE ÁNGULO AGUDO DEBIDO A NEOVASCULARIZACIÓN"
  },
  {
    "codigo":1287228005,
    "descripcion":"FRACTURA PATOLÓGICA DE MÚLTIPLES SITIOS DE UN SOLO HUESO"
  },
  {
    "codigo":236817003,
    "descripcion":"TERATOZOOSPERMIA"
  },
  {
    "codigo":204049003,
    "descripcion":"APLASIA DEL CEREBELO"
  },
  {
    "codigo":366054000,
    "descripcion":"HALLAZGO RELACIONADO CON EL DRENAJE LAGRIMAL MARCADO CON FLUORESCEÍNA"
  },
  {
    "codigo":202214002,
    "descripcion":"LUXACIÓN INFERIOR RECURRENTE DE ARTICULACIÓN DE HOMBRO"
  },
  {
    "codigo":234982002,
    "descripcion":"MANCHADO DENTARIO EXTRÍNSECO - FLORA DE PLACA CROMOGÉNICA"
  },
  {
    "codigo":169446008,
    "descripcion":"HIMEN INTACTO - ANTICONCEPCIÓN INNECESARIA"
  },
  {
    "codigo":300518009,
    "descripcion":"PREPUCIO PRESENTE"
  },
  {
    "codigo":298683003,
    "descripcion":"SIGNO CON NOMBRE PROPIO DE LA COLUMNA LUMBAR"
  },
  {
    "codigo":724667007,
    "descripcion":"ALTERACIONES PERCEPTIVAS CONCOMITANTES CON ABSTINENCIA DE ANSIOLÍTICO Y DEBIDAS A ELLA"
  },
  {
    "codigo":36539009,
    "descripcion":"TRASTORNO DEBIDO A LESIÓN TRAUMÁTICA DE NERVIO CRANEAL Y POSTERIOR A ELLA"
  },
  {
    "codigo":722832009,
    "descripcion":"CARCINOMA PAPILAR SÓLIDO PRIMARIO CON INVASIÓN DE MAMA"
  },
  {
    "codigo":1343589002,
    "descripcion":"ÚLCERA NEUROPÁTICA DE PIERNA"
  },
  {
    "codigo":34704009,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA VENA PORTA"
  },
  {
    "codigo":719162001,
    "descripcion":"SÍNDROME DE SINOSTOSIS RADIOCUBITAL CON MICROCEFALIA Y ESCOLIOSIS"
  },
  {
    "codigo":131173009,
    "descripcion":"SULFAHEMOGLOBINA POR ENCIMA DE RANGO DE REFERENCIA"
  },
  {
    "codigo":360549009,
    "descripcion":"DESNUTRICIÓN CALORICOPROTEICA SEVERA (GÓMEZ: MENOS DEL 60% DEL PESO ESTÁNDAR)"
  },
  {
    "codigo":16010591000119109,
    "descripcion":"OSTEONECROSIS DE HUESO METATARSIANO DE PIE DERECHO"
  },
  {
    "codigo":162106006,
    "descripcion":"DIARREA ESPURIA - REBOSAMIENTO"
  },
  {
    "codigo":94735000,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA CARA ANTERIOR DE LA EPIGLOTIS"
  },
  {
    "codigo":1208847002,
    "descripcion":"TROMBOEMBOLISMO VENOSO POR TROMBOSIS DE VENA DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":193039006,
    "descripcion":"MIGRAÑA COMPLICADA"
  },
  {
    "codigo":29199007,
    "descripcion":"FORÚNCULO DEL OMBLIGO"
  },
  {
    "codigo":291343006,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR DIFENHIDRAMINA"
  },
  {
    "codigo":225807009,
    "descripcion":"PRESIONADO POR SUS PARES"
  },
  {
    "codigo":422415009,
    "descripcion":"MARGEN QUIRÚRGICO PROXIMAL AFECTADO POR ADENOMA CON DISPLASIA DE BAJO GRADO DE MALIGNIDAD"
  },
  {
    "codigo":125668004,
    "descripcion":"CONTUSIÓN DE LA CARA"
  },
  {
    "codigo":92900005,
    "descripcion":"FORMA ANORMAL CONGÉNITA DE CENTRO DE VÉRTEBRA CERVICAL"
  },
  {
    "codigo":289508005,
    "descripcion":"TUMEFACCIÓN DEL CLÍTORIS"
  },
  {
    "codigo":337401000119107,
    "descripcion":"CATARATA DE OJO IZQUIERDO DEBIDA A TRAUMATISMO Y POSTERIOR A ÉL"
  },
  {
    "codigo":123833004,
    "descripcion":"SATISFACTORIO PARA EVALUACIÓN, PERO SUBÓPTIMO POR PRESENCIA DE ÁREAS DENSAS QUE DIFICULTAN LA EVALUACIÓN"
  },
  {
    "codigo":25529004,
    "descripcion":"FRACTURA EXPUESTA DEL EXTREMO DISTAL DEL RADIO"
  },
  {
    "codigo":310931000119102,
    "descripcion":"HIDRARTROSIS INTERMITENTE DE RODILLA IZQUIERDA"
  },
  {
    "codigo":56462001,
    "descripcion":"INTENTO FALLIDO DE ABORTO CON EMBOLIA POR JABÓN"
  },
  {
    "codigo":285838002,
    "descripcion":"NEOPLASIA INTRAEPITELIAL CERVICAL GRADO 2"
  },
  {
    "codigo":416910005,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE DEDO DE LA MANO"
  },
  {
    "codigo":709987003,
    "descripcion":"ESQUEMA OCLUSAL MODERADAMENTE COMPROMETIDO"
  },
  {
    "codigo":54627004,
    "descripcion":"XANTINURIA HEREDITARIA"
  },
  {
    "codigo":251235005,
    "descripcion":"ALTURA DEL COMPLEJO QRS DISMINUIDA"
  },
  {
    "codigo":284003005,
    "descripcion":"LESIÓN TRAUMÁTICA ÓSEA"
  },
  {
    "codigo":447843005,
    "descripcion":"SEPSIS CAUSADA POR BACTERIAS ANAERÓBICAS"
  },
  {
    "codigo":249400000,
    "descripcion":"MUCOSA ORAL - HALLAZGO"
  },
  {
    "codigo":314936001,
    "descripcion":"SIN CONSENTIMIENTO PARA INMUNIZACIÓN CONTRA MENINGITIS C"
  },
  {
    "codigo":282168004,
    "descripcion":"INCAPAZ DE SUBIR UNA COLINA"
  },
  {
    "codigo":773688007,
    "descripcion":"INFLAMACIÓN LINFOCÍTICA CRÓNICA CON REFUERZO PERIVASCULAR DE LA PROTUBERANCIA Y RESPUESTA A ESTEROIDES"
  },
  {
    "codigo":1363512008,
    "descripcion":"TROPONINA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":247565003,
    "descripcion":"PELO CON ILUMINACIÓN"
  },
  {
    "codigo":444173008,
    "descripcion":"SUBVIRILIZACIÓN MASCULINA POR DEFICIENCIA AGUDA DE PROTEÍNA REGULADORA ESTEROIDOGÉNICA"
  },
  {
    "codigo":704482000,
    "descripcion":"FRACTURA NO EXPUESTA DE METÁFISIS DE CUARTO METATARSIANO"
  },
  {
    "codigo":737250005,
    "descripcion":"REACCIÓN FOTOTÓXICA CUTÁNEA CAUSADA POR PERFUME"
  },
  {
    "codigo":1359842008,
    "descripcion":"DOLOR EN CARA INFERIOR DE PALADAR"
  },
  {
    "codigo":1259703003,
    "descripcion":"COREA DEBIDA A DEGENERACIÓN HEPATOCEREBRAL CRÓNICA"
  },
  {
    "codigo":276663004,
    "descripcion":"INFECCIÓN CONGÉNITA POR PARVOVIRUS HUMANO"
  },
  {
    "codigo":298882861000119105,
    "descripcion":"TENDINOSIS DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":405900002,
    "descripcion":"P1 + FENOTIPO"
  },
  {
    "codigo":209292003,
    "descripcion":"FRACTURA-SUBLUXACIÓN EXPUESTA DE MUÑECA"
  },
  {
    "codigo":110988004,
    "descripcion":"MELANODERMIA CAQUÉCTICA"
  },
  {
    "codigo":373132007,
    "descripcion":"RAÍZ AÓRTICA NORMAL"
  },
  {
    "codigo":242060008,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR ANTIPIRÉTICO"
  },
  {
    "codigo":307596009,
    "descripcion":"ADENOMA APOCRINO"
  },
  {
    "codigo":404065000,
    "descripcion":"LIPOMA CONDROIDE"
  },
  {
    "codigo":830049001,
    "descripcion":"OVARIOS POLIQUÍSTICOS BILATERALES"
  },
  {
    "codigo":15931181000119108,
    "descripcion":"HEMORRAGIA DE QUISTE DE CUERPO LÚTEO DERECHO"
  },
  {
    "codigo":369462000,
    "descripcion":"HIPERPLASIA MAMARIA ATÍPICA"
  },
  {
    "codigo":305761008,
    "descripcion":"VISTO POR PSICOTERAPEUTA"
  },
  {
    "codigo":9014002,
    "descripcion":"PSORIASIS"
  },
  {
    "codigo":860982007,
    "descripcion":"NEOPLASIA MALIGNA MIXTA COMPLEJA Y DEL ESTROMA DE FONDO UTERINO"
  },
  {
    "codigo":236555000,
    "descripcion":"DOLOR DURANTE LA SALIDA DE LA SOLUCIÓN DE DIÁLISIS"
  },
  {
    "codigo":402230008,
    "descripcion":"DERMATITIS ATÓPICA CRÓNICA DE MANO"
  },
  {
    "codigo":1186827001,
    "descripcion":"POLINEUROPATÍA DEBIDA A TRASTORNO DE PARATIROIDES"
  },
  {
    "codigo":302091004,
    "descripcion":"ULCERACIÓN DE GANGLIO LINFÁTICO INGUINAL"
  },
  {
    "codigo":105483008,
    "descripcion":"PADRE SOBREPROTECTOR"
  },
  {
    "codigo":365792003,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA LEER"
  },
  {
    "codigo":339911000119106,
    "descripcion":"BAJA VISIÓN EN OJO DERECHO, VISIÓN NORMAL EN OJO IZQUIERDO"
  },
  {
    "codigo":201952005,
    "descripcion":"ARTROPATÍA TRAUMÁTICA DE LA RODILLA"
  },
  {
    "codigo":11864161000119100,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE TOBILLO DERECHO"
  },
  {
    "codigo":726240007,
    "descripcion":"LACERACIÓN DE MÚSCULO POSTERIOR DE MUSLO"
  },
  {
    "codigo":70880006,
    "descripcion":"ENTERITIS ADENOVIRAL"
  },
  {
    "codigo":11782241000119102,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA ANTERIOR DE RODILLA IZQUIERDA"
  },
  {
    "codigo":427658007,
    "descripcion":"LEUCEMIA MIELOMONOCÍTICA AGUDA, FAB M4, EN REMISIÓN"
  },
  {
    "codigo":1674008,
    "descripcion":"DISTROFIA CORNEAL EPITELIAL JUVENIL"
  },
  {
    "codigo":294751006,
    "descripcion":"ALERGIA A MEGESTROL"
  },
  {
    "codigo":65375007,
    "descripcion":"ESTADO POSTPARTO, 6 SEMANAS"
  },
  {
    "codigo":718900002,
    "descripcion":"DISCAPACIDAD INTELECTUAL SINDRÓMICA LIGADA AL CROMOSOMA X TIPO 11"
  },
  {
    "codigo":161844003,
    "descripcion":"INGESTA DE LÍQUIDOS DISMINUIDA"
  },
  {
    "codigo":63540005,
    "descripcion":"LUXACIÓN EXPUESTA ANTERIOR DE EXTREMO DISTAL DE FÉMUR"
  },
  {
    "codigo":313441000119106,
    "descripcion":"ARTROFITO EN ARTICULACIÓN DE REGIÓN DE HOMBRO DERECHO"
  },
  {
    "codigo":1144884009,
    "descripcion":"MEJORÍA EN EL NIVEL DE INTEGRIDAD CUTÁNEA"
  },
  {
    "codigo":94473002,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA PLEURA PARIETAL"
  },
  {
    "codigo":127241007,
    "descripcion":"NEOPLASIA DE LOS GANGLIOS LINFÁTICOS SUPRACLAVICULARES"
  },
  {
    "codigo":291081009,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR PRAZEPAM"
  },
  {
    "codigo":289246004,
    "descripcion":"PÉRDIDA PROFUSA DE SANGRE MATERNA"
  },
  {
    "codigo":67681000119109,
    "descripcion":"ASTIGMATISMO ALTO"
  },
  {
    "codigo":92638007,
    "descripcion":"CARCINOMA IN SITU DE LA PARED LATERAL DE LA VEJIGA"
  },
  {
    "codigo":90803001,
    "descripcion":"QUEMADURA DEL INTESTINO DELGADO"
  },
  {
    "codigo":340761000119100,
    "descripcion":"PTOSIS DE PÁRPADO SUPERIOR DERECHO"
  },
  {
    "codigo":317721000119101,
    "descripcion":"PERIARTRITIS DE MUÑECA DERECHA"
  },
  {
    "codigo":15687961000119100,
    "descripcion":"CAPSULITIS DE TARSO IZQUIERDO"
  },
  {
    "codigo":15667481000119103,
    "descripcion":"METATARSO ADUCTO IZQUIERDO"
  },
  {
    "codigo":353561000119103,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE PULMÓN DERECHO"
  },
  {
    "codigo":11863321000119105,
    "descripcion":"AMPOLLA DE SEGUNDO A QUINTO DEDO DE PIE DERECHO, CON INFECCIÓN"
  },
  {
    "codigo":130841000119103,
    "descripcion":"QUERATITIS INTERSTICIAL DEBIDA A SÍFILIS CONGÉNITA"
  },
  {
    "codigo":1137544003,
    "descripcion":"CALCIFICACIÓN PUNTEADA DE EPÍFISIS DE FALANGE MEDIA DE DEDO DE MANO"
  },
  {
    "codigo":95001000119103,
    "descripcion":"HERNIA INGUINAL RECURRENTE OBSTRUIDA"
  },
  {
    "codigo":1078041000119104,
    "descripcion":"OSTEOCONDROSIS JUVENIL DE HUESO NAVICULAR DEL TARSO IZQUIERDO"
  },
  {
    "codigo":15700761000119107,
    "descripcion":"DISFUNCIÓN DE MÚSCULO OBLICUO SUPERIOR DE OJO IZQUIERDO"
  },
  {
    "codigo":15682841000119106,
    "descripcion":"OSTEOCONDROSIS JUVENIL DE AMBOS TARSOS"
  },
  {
    "codigo":281000119103,
    "descripcion":"DEPRESIÓN MAYOR SEVERA RECURRENTE"
  },
  {
    "codigo":254643009,
    "descripcion":"TERATOMA INTRAPULMONAR"
  },
  {
    "codigo":12398361000119105,
    "descripcion":"TRASTORNO MENTAL CAUSADO POR METANFETAMINA"
  },
  {
    "codigo":711560003,
    "descripcion":"EL PACIENTE NO CUENTA CON UN PROFESIONAL QUE LO DERIVE"
  },
  {
    "codigo":25881000119108,
    "descripcion":"TRASTORNO DE SISTEMA URINARIO DEBIDO A CIRUGÍA Y POSTERIOR A ELLA"
  },
  {
    "codigo":11996441000119108,
    "descripcion":"NEUROMA DE MUÑÓN DE AMPUTACIÓN DE MIEMBRO SUPERIOR DERECHO"
  },
  {
    "codigo":13081000119109,
    "descripcion":"COMPLICACIÓN DE AMPOLLA FILTRANTE"
  },
  {
    "codigo":283741004,
    "descripcion":"MORDEDURA DE PERRO EN LA REGIÓN AURICULAR"
  },
  {
    "codigo":250973007,
    "descripcion":"ESTENOSIS AÓRTICA CON DEFORMIDAD EN CÚPULA"
  },
  {
    "codigo":87133009,
    "descripcion":"REQUERIMIENTO METABÓLICO ANORMAL"
  },
  {
    "codigo":609586001,
    "descripcion":"COMBATIVIDAD"
  },
  {
    "codigo":773426004,
    "descripcion":"SÍNDROME DE PROGERIA CARDIOCUTÁNEA RELACIONADO CON EL GEN LMNA"
  },
  {
    "codigo":314674006,
    "descripcion":"PESO DEL NIÑO: PERCENTILO 9"
  },
  {
    "codigo":1230343006,
    "descripcion":"NEUROPATÍA MOTORA DISTAL HEREDITARIA TIPO 2"
  },
  {
    "codigo":312839008,
    "descripcion":"LUXACIÓN VERTEBRAL CON LESIÓN MEDULAR A NIVEL LUMBAR"
  },
  {
    "codigo":247303009,
    "descripcion":"CAPACIDAD PARA ESCUCHAR VOCES FUERTES - HALLAZGO"
  },
  {
    "codigo":442076002,
    "descripcion":"SACIEDAD PRECOZ"
  },
  {
    "codigo":278236003,
    "descripcion":"ANOMALÍA DIFUSA DE LA CONDUCCIÓN NERVIOSA SENSITIVA"
  },
  {
    "codigo":835292000,
    "descripcion":"AGUDEZA VISUAL DE OJO DERECHO 6\/18"
  },
  {
    "codigo":212700005,
    "descripcion":"INTOXICACIÓN POR CICLANDELATO"
  },
  {
    "codigo":210865000,
    "descripcion":"CONTUSIÓN, ARTERIA FEMORAL COMÚN"
  },
  {
    "codigo":704220008,
    "descripcion":"FRACTURA EXPUESTA DE CUELLO DE QUINTO METACARPIANO"
  },
  {
    "codigo":702385003,
    "descripcion":"EMBOLIA DE NITRÓGENO"
  },
  {
    "codigo":473009005,
    "descripcion":"DOLOR EN PALADAR"
  },
  {
    "codigo":1259441006,
    "descripcion":"CARCINOMA ODONTÓGENO DE CÉLULAS FANTASMAS PRIMARIO"
  },
  {
    "codigo":276401008,
    "descripcion":"MUÑÓN UMBILICAL SECO"
  },
  {
    "codigo":209030000,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA ÚNICA DE DEDO DE PIE"
  },
  {
    "codigo":241798000,
    "descripcion":"EFECTO TÓXICO CAUSADO POR HERBICIDA CON NITRILO"
  },
  {
    "codigo":733318004,
    "descripcion":"DEGENERACIÓN DE IRIS"
  },
  {
    "codigo":307334005,
    "descripcion":"ISOINMUNIZACIÓN RHESUS POR INMUNOGLOBULINA ANTI - C"
  },
  {
    "codigo":1079701000119109,
    "descripcion":"NEVO MELANOCÍTICO PIGMENTADO CONGÉNITO DE PIEL DE OREJA DERECHA"
  },
  {
    "codigo":305499000,
    "descripcion":"BAJO ATENCIÓN DE REUMATÓLOGO"
  },
  {
    "codigo":895323001,
    "descripcion":"FORMA DE BALA ANORMAL CONGÉNITA DE FALANGE PROXIMAL DE DEDO MEÑIQUE"
  },
  {
    "codigo":371035002,
    "descripcion":"OBSTRUCCIÓN DE LA VÍA AÉREA SUPRAGLÓTICA"
  },
  {
    "codigo":315951000119104,
    "descripcion":"OSTEONECROSIS DE HUESO DE PELVIS CAUSADA POR FÁRMACO"
  },
  {
    "codigo":403803002,
    "descripcion":"HIPERMELANOSIS NEVOIDE LINEAL Y EN REMOLINOS"
  },
  {
    "codigo":43355006,
    "descripcion":"EOSINOPENIA"
  },
  {
    "codigo":239963009,
    "descripcion":"LAXITUD LIGAMENTOSA DE REGIÓN DE HOMBRO"
  },
  {
    "codigo":762416002,
    "descripcion":"ADHERENCIA DE CUERPO CILIAR"
  },
  {
    "codigo":238128006,
    "descripcion":"DEFICIENCIA DE ÁCIDO PANTOTÉNICO"
  },
  {
    "codigo":301829006,
    "descripcion":"FÍSTULA ENTEROANAL"
  },
  {
    "codigo":5082003,
    "descripcion":"INFECCIÓN CAUSADA POR GIGANTOBILHARZIA"
  },
  {
    "codigo":234458004,
    "descripcion":"HIPODISFIBRINOGENEMIA"
  },
  {
    "codigo":365530007,
    "descripcion":"INSTALACIONES EN EL ÁMBITO LABORAL - HALLAZGO"
  },
  {
    "codigo":298159005,
    "descripcion":"DERRAME EN CARILLA ARTICULAR LUMBAR"
  },
  {
    "codigo":230788000,
    "descripcion":"DISFASIA RECEPTIVA CONGÉNITA"
  },
  {
    "codigo":165252001,
    "descripcion":"SIN AYUDA PARA CAMINAR"
  },
  {
    "codigo":66948001,
    "descripcion":"PALADAR HENDIDO CON LABIO LEPORINO"
  },
  {
    "codigo":1412008,
    "descripcion":"CATARATA POLAR SUBCAPSULAR ANTERIOR"
  },
  {
    "codigo":425561001,
    "descripcion":"VEJIGA URINARIA NEUROGÉNICA POSTERIOR A POLIOMIELITIS"
  },
  {
    "codigo":294489002,
    "descripcion":"ALERGIA A OFLOXACINO"
  },
  {
    "codigo":65113001,
    "descripcion":"REPARACIÓN DEL ADN"
  },
  {
    "codigo":720473006,
    "descripcion":"DISFUNCIÓN SOMÁTICA DE REGIÓN SACROILÍACA"
  },
  {
    "codigo":194350005,
    "descripcion":"ENFERMEDAD DE MÉNIÈRE VESTIBULAR ACTIVA"
  },
  {
    "codigo":423726006,
    "descripcion":"INFECCIÓN DISEMINADA POR MYCOBACTERIUM CHELONEI"
  },
  {
    "codigo":292654008,
    "descripcion":"REACCIÓN ADVERSA A JABÓN ALCALINO"
  },
  {
    "codigo":126979000,
    "descripcion":"NEOPLASIA DEL NERVIO AUTÓNOMO"
  },
  {
    "codigo":782339003,
    "descripcion":"INTOLERANCIA A LA SACAROSA POR DEFICIENCIA DE SACARASA-ISOMALTASA"
  },
  {
    "codigo":1082211000119104,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE PIEL DE CADERA DERECHA"
  },
  {
    "codigo":421891006,
    "descripcion":"HALLAZGO DEL PULSO HALLADO POR AUSCULTACIÓN"
  },
  {
    "codigo":290819006,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR CLOMIPRAMINA"
  },
  {
    "codigo":94211009,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE VASO SANGUÍNEO"
  },
  {
    "codigo":190680002,
    "descripcion":"TRASTORNOS DEL TRANSPORTE Y EL METABOLISMO DE LOS AMINOÁCIDOS"
  },
  {
    "codigo":92376005,
    "descripcion":"NEOPLASIA BENIGNA DE PIEL DE HOMBRO"
  },
  {
    "codigo":878808006,
    "descripcion":"TUMOR DE CÉLULAS GERMINALES NO GERMINOMATOSO DEL SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":1237421000,
    "descripcion":"MICROCEFALIA ASOCIADA A GEN PYCR2 Y LEUCOENCEFALOPATÍA PROGRESIVA"
  },
  {
    "codigo":288984009,
    "descripcion":"MAMA"
  },
  {
    "codigo":57773001,
    "descripcion":"PROLAPSO RECTAL"
  },
  {
    "codigo":188845004,
    "descripcion":"NEOPLASIA BENIGNA DE VÍA BILIAR"
  },
  {
    "codigo":416386000,
    "descripcion":"CUERDAS VOCALES VISIBLES"
  },
  {
    "codigo":88706003,
    "descripcion":"INFECCIÓN CAUSADA POR SPIRURA"
  },
  {
    "codigo":449154007,
    "descripcion":"HEMANGIOMA CAVERNOSO DE CUERO CABELLUDO"
  },
  {
    "codigo":447319000,
    "descripcion":"INTOXICACIÓN CAUSADA POR COMPUESTO CON BERILIO"
  },
  {
    "codigo":55938009,
    "descripcion":"TEMBLOR DE LA VOZ"
  },
  {
    "codigo":1268354009,
    "descripcion":"ADENOCARCINOMA DE CÉLULAS CLARAS DE PERITONEO METASTÁSICO"
  },
  {
    "codigo":185175005,
    "descripcion":"ATENDIDO EN CENTRO DE ATENCIÓN PRIMARIA"
  },
  {
    "codigo":283479008,
    "descripcion":"HERIDA PUNZANTE EN LA INGLE"
  },
  {
    "codigo":707628004,
    "descripcion":"CARCINOMA SUPERPUESTO DE CÉLULAS ESCAMOSAS DE HIPOFARINGE"
  },
  {
    "codigo":248876008,
    "descripcion":"VAGINA GRANDE"
  },
  {
    "codigo":247041008,
    "descripcion":"SINEQUIA POSTERIOR INCOMPLETA"
  },
  {
    "codigo":1197313009,
    "descripcion":"ADENOCARCINOMA METASTÁSICO DE GANGLIO LINFÁTICO DE CABEZA Y\/O CUELLO"
  },
  {
    "codigo":1230081009,
    "descripcion":"PATRÓN DE USO NOCIVO DE HIPNÓTICO SIN DEPENDENCIA"
  },
  {
    "codigo":441814005,
    "descripcion":"PRUEBA CUTÁNEA DE HIPERSENSIBILIDAD TARDÍA PARA HISTOPLASMINA POSITIVA"
  },
  {
    "codigo":212438008,
    "descripcion":"ABSCESO AGUDO DE LA CARA"
  },
  {
    "codigo":472747002,
    "descripcion":"DRENAJE DE SENO CORONARIO A AURÍCULA VENOSA PULMONAR CONSTRUIDO QUIRÚRGICAMENTE"
  },
  {
    "codigo":734891006,
    "descripcion":"SEPARACIÓN ANTERIOR DE DIENTES SUPERIORES"
  },
  {
    "codigo":210603007,
    "descripcion":"LESIÓN POR AVULSIÓN ANULAR, CLASE 4"
  },
  {
    "codigo":767659008,
    "descripcion":"NEUROPATÍA PERIFÉRICA DEBIDA A TERAPIA ANTINEOPLÁSICA Y POSTERIOR A ELLA"
  },
  {
    "codigo":208768004,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN DE HOMBRO, INFERIOR (INFRAGLENOIDEA)"
  },
  {
    "codigo":15666481000119100,
    "descripcion":"ESCAFOIDES ACCESORIO DEL TARSO IZQUIERDO"
  },
  {
    "codigo":700288008,
    "descripcion":"ABSCESO DE PÁRPADO INFERIOR"
  },
  {
    "codigo":403541001,
    "descripcion":"NEVO ACRÓMICO"
  },
  {
    "codigo":77696009,
    "descripcion":"VÁLVULA AÓRTICA DOBLE"
  },
  {
    "codigo":10325006,
    "descripcion":"AFASIA ANÓMICA"
  },
  {
    "codigo":8490007,
    "descripcion":"INFECCIÓN CAUSADA POR ENCEPHALITOZOON CUNICULI"
  },
  {
    "codigo":74026008,
    "descripcion":"URTICARIA TRAUMÁTICA"
  },
  {
    "codigo":39423001,
    "descripcion":"TARTAMUDEZ"
  },
  {
    "codigo":170495003,
    "descripcion":"PORTADOR DE DIFTERIA"
  },
  {
    "codigo":6655004,
    "descripcion":"LARINGITIS AGUDA"
  },
  {
    "codigo":399871005,
    "descripcion":"RETINOPATÍA QUE PONE EN PELIGRO LA VISIÓN DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":203263006,
    "descripcion":"TUBERCULOSIS DE LA COLUMNA VERTEBRAL CERVICAL"
  },
  {
    "codigo":236031004,
    "descripcion":"HERNIA CRURAL DE RICHTER"
  },
  {
    "codigo":398036000,
    "descripcion":"HIPERCOLESTEROLEMIA FAMILIAR"
  },
  {
    "codigo":299732003,
    "descripcion":"HALLAZGO RELACIONADO CON LA PRESIÓN INTRACRANEAL"
  },
  {
    "codigo":365268005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA USAR EL LAVAPLATOS"
  },
  {
    "codigo":234196007,
    "descripcion":"TORSIÓN DE INJERTO VASCULAR"
  },
  {
    "codigo":723881000,
    "descripcion":"RONQUIDO HABITUAL"
  },
  {
    "codigo":1348308009,
    "descripcion":"ENFERMEDAD CORTICOSUPRARRENAL NODULAR PIGMENTADA PRIMARIA ASOCIADA AL COMPLEJO DE CARNEY"
  },
  {
    "codigo":396201001,
    "descripcion":"MARGEN QUIRÚRGICO DE LA CÁPSULA RENAL COMPROMETIDO POR NEOPLASIA MALIGNA"
  },
  {
    "codigo":232361003,
    "descripcion":"ADHERENCIAS DE LA CAVIDAD NASAL"
  },
  {
    "codigo":230526001,
    "descripcion":"COMPRESIÓN DE LA CORTEZA VISUAL"
  },
  {
    "codigo":363433009,
    "descripcion":"NEOPLASIA MALIGNA DE PLEURA"
  },
  {
    "codigo":296062002,
    "descripcion":"SOBREDOSIS DE LOPRAZOLAM"
  },
  {
    "codigo":1344638004,
    "descripcion":"TRASTORNO POSTERIOR A PROCEDIMIENTO DE INJERTO DE PIEL"
  },
  {
    "codigo":294227000,
    "descripcion":"ALERGIA A ALCURONIO"
  },
  {
    "codigo":427134009,
    "descripcion":"ENFERMEDAD DE PEQUEÑOS VASOS DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":1150009,
    "descripcion":"MICROQUEILIA CONGÉNITA"
  },
  {
    "codigo":195923003,
    "descripcion":"GRIPE CON LARINGITIS"
  },
  {
    "codigo":95784000,
    "descripcion":"NISTAGMO DE CONVERGENCIA"
  },
  {
    "codigo":359763008,
    "descripcion":"ENFERMEDAD CAUSADA POR VIRUS HANTAN"
  },
  {
    "codigo":292392003,
    "descripcion":"REACCIÓN ADVERSA A LA FLUFENAZINA"
  },
  {
    "codigo":1306365000,
    "descripcion":"NEOPLASIA BENIGNA DE CUADRANTE SUPERIOR EXTERNO DE MAMA"
  },
  {
    "codigo":423464009,
    "descripcion":"CARCINOMA ESCAMOCELULAR DE OROFARINGE"
  },
  {
    "codigo":126717002,
    "descripcion":"NEOPLASIA DEL LÓBULO SUPERIOR IZQUIERDO DEL PULMÓN"
  },
  {
    "codigo":290557003,
    "descripcion":"INTOXICACIÓN POR PROXIMETACAÍNA"
  },
  {
    "codigo":30248008,
    "descripcion":"PIGOMORFO"
  },
  {
    "codigo":225021007,
    "descripcion":"REACCIÓN DE DUELO ANORMAL ANTE EVENTO DEL CICLO VITAL"
  },
  {
    "codigo":288722000,
    "descripcion":"NO HABLA MIENTRAS JUEGA"
  },
  {
    "codigo":92114009,
    "descripcion":"NEOPLASIA BENIGNA DEL LÓBULO FRONTAL"
  },
  {
    "codigo":24743004,
    "descripcion":"ENFERMEDAD DE DEFICIENCIA DEL SISTEMA DEL COMPLEMENTO"
  },
  {
    "codigo":254119005,
    "descripcion":"HIPERPARATIROIDISMO NEONATAL"
  },
  {
    "codigo":286887005,
    "descripcion":"CARCINOMA DE HÍGADO Y\/O SISTEMA BILIAR"
  },
  {
    "codigo":186748004,
    "descripcion":"INFECCIÓN POR PARVOVIRUS"
  },
  {
    "codigo":283217003,
    "descripcion":"ANZUELO EN EL MUSLO"
  },
  {
    "codigo":217681005,
    "descripcion":"ENVENENAMIENTO DEBIDO A PICADURA DE HORMIGA"
  },
  {
    "codigo":1297190000,
    "descripcion":"QUEMADURA DE QUINTO DEDO DE PIE"
  },
  {
    "codigo":1231654002,
    "descripcion":"QUISTE DE VAINA DE NERVIO ÓPTIMO"
  },
  {
    "codigo":445222002,
    "descripcion":"PUNCIÓN ACCIDENTAL DE ARTERIA DURANTE LA INSERCIÓN DE CATÉTER"
  },
  {
    "codigo":248614004,
    "descripcion":"RUIDOS TORÁCICOS"
  },
  {
    "codigo":707366009,
    "descripcion":"HEMANGIOMA ESCLEROSANTE DE PULMÓN, ÚNICO"
  },
  {
    "codigo":246779003,
    "descripcion":"RESPUESTA VESTIBULOOCULAR DURANTE LA ROTACIÓN CORPORAL"
  },
  {
    "codigo":403507009,
    "descripcion":"HIPERMELANOSIS ASOCIADA CON LUPUS ERITEMATOSO"
  },
  {
    "codigo":736464002,
    "descripcion":"SÍNDROME DE DOLOR CRÓNICO IDIOPÁTICO"
  },
  {
    "codigo":81104004,
    "descripcion":"REACCIÓN GRUPAL DELICTIVA EN LA NIÑEZ"
  },
  {
    "codigo":48336009,
    "descripcion":"ÚLCERA PÉPTICA CON PERFORACIÓN Y OBSTRUCCIÓN"
  },
  {
    "codigo":1258917005,
    "descripcion":"FISURA DE PEZÓN EN PUERPERIO"
  },
  {
    "codigo":210341005,
    "descripcion":"HERIDA ABIERTA EN LA MEJILLA"
  },
  {
    "codigo":677631000119108,
    "descripcion":"NEOVASCULARIZACIÓN POLIPOIDE COROIDEA DE AMBOS OJOS"
  },
  {
    "codigo":77434001,
    "descripcion":"ENFERMEDAD AUTOINDUCIDA"
  },
  {
    "codigo":306810001,
    "descripcion":"VISTO EN EL SERVICIO DE ACCIDENTE CEREBROVASCULAR"
  },
  {
    "codigo":44666001,
    "descripcion":"ANEMIA MICROCÍTICA HIPOCRÓMICA"
  },
  {
    "codigo":13733009,
    "descripcion":"DISTROFIA UNGULAR MEDIANA CANALIFORME"
  },
  {
    "codigo":110202006,
    "descripcion":"QUEMADURA DEL VESTÍBULO MANDIBULAR"
  },
  {
    "codigo":437882009,
    "descripcion":"LATERALIDAD CRUZADA"
  },
  {
    "codigo":698191003,
    "descripcion":"VARICOCELE PALPABLE CON MANIOBRA DE VALSALVA SOLAMENTE"
  },
  {
    "codigo":10973081000119104,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO DIGITAL DE DEDO MEDIO IZQUIERDO"
  },
  {
    "codigo":403279005,
    "descripcion":"LESIÓN PIGMENTADA DE PIEL DE NATURALEZA INCIERTA"
  },
  {
    "codigo":370511006,
    "descripcion":"FIBROSARCOMA INDUCIDO POR VACUNA"
  },
  {
    "codigo":15724441000119104,
    "descripcion":"ENTESOPATÍA DE AMBOS PIES"
  },
  {
    "codigo":108367008,
    "descripcion":"LUXACIÓN ARTICULAR"
  },
  {
    "codigo":763727005,
    "descripcion":"LABIO LEPORINO IZQUIERDO COMPLETO Y FISURA ALVEOLAR IZQUIERDA COMPLETA"
  },
  {
    "codigo":8228006,
    "descripcion":"RUPTURA FAMILIAR CON SEPARACIÓN"
  },
  {
    "codigo":237604008,
    "descripcion":"DIABETES DEL ADULTO DE INICIO EN LA JUVENTUD, TIPO 2"
  },
  {
    "codigo":203001001,
    "descripcion":"ABSCESO DE BOLSA SEROSA DEL PIE"
  },
  {
    "codigo":792825005,
    "descripcion":"TODOS LOS PULSOS PRESENTES EN EL PIE IZQUIERDO"
  },
  {
    "codigo":301305006,
    "descripcion":"HALLAZGO RELACIONADO CON LA OBSERVACIÓN GENERAL DE LA APARIENCIA"
  },
  {
    "codigo":235769005,
    "descripcion":"APENDICITIS FOCAL AGUDA"
  },
  {
    "codigo":233934000,
    "descripcion":"FALLA DEL TRASPLANTE CARDÍACO"
  },
  {
    "codigo":365006001,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA USAR SONIDOS DEL HABLA PARTICULARES"
  },
  {
    "codigo":397774002,
    "descripcion":"DOLOR DURANTE EL TRABAJO DE PARTO Y PARTO"
  },
  {
    "codigo":299470000,
    "descripcion":"HALLAZGO RELACIONADO CON EL MOVIMIENTO DEL PIE"
  },
  {
    "codigo":102862003,
    "descripcion":"CRISTAL URINARIO, SULFONAMIDA"
  },
  {
    "codigo":399609005,
    "descripcion":"COMPROMISO TUMORAL DE MARGEN DE RESECCIÓN QUIRÚRGICA PROXIMAL, NO PUEDE SER EVALUADO"
  },
  {
    "codigo":428707000,
    "descripcion":"DEFICIENCIA NUTRICIONAL DURANTE EL EMBARAZO"
  },
  {
    "codigo":264867001,
    "descripcion":"PROTEINURIA NEFRÓTICA"
  },
  {
    "codigo":232099002,
    "descripcion":"ESOTROPÍA CONSECUTIVA"
  },
  {
    "codigo":35491004,
    "descripcion":"INADAPTACIÓN AL MATRIMONIO"
  },
  {
    "codigo":133171000119105,
    "descripcion":"FARINGOLARINGITIS CRÓNICA"
  },
  {
    "codigo":363171009,
    "descripcion":"INFLAMACIÓN DE SISTEMAS CORPORALES ESPECÍFICOS"
  },
  {
    "codigo":164728001,
    "descripcion":"PRUEBA VISUAL ANORMAL"
  },
  {
    "codigo":230264003,
    "descripcion":"SÍNDROME DE TROYER"
  },
  {
    "codigo":295800004,
    "descripcion":"SOBREDOSIS DE CICLOSPORINA"
  },
  {
    "codigo":199331008,
    "descripcion":"PARTO MÚLTIPLE, TODOS NACIDOS POR CESÁREA"
  },
  {
    "codigo":721784007,
    "descripcion":"INFECCIÓN CAUSADA POR VIRUS LUJO"
  },
  {
    "codigo":719949001,
    "descripcion":"SÍNDROME DE TRIGONOCEFALIA CON PULGAR ANCHO"
  },
  {
    "codigo":10946611000119107,
    "descripcion":"AVULSIÓN DE UNIDAD UNGUEAL DE DEDO MEDIO IZQUIERDO"
  },
  {
    "codigo":425037004,
    "descripcion":"LINFOMA DE BAJO GRADO, ESTADIO 1"
  },
  {
    "codigo":31821006,
    "descripcion":"CICATRIZ UTERINA DE CIRUGÍA PREVIA QUE AFECTA AL EMBARAZO"
  },
  {
    "codigo":293965006,
    "descripcion":"ALERGIA A ATENOLOL"
  },
  {
    "codigo":95522001,
    "descripcion":"LIMITACIÓN DE AMPLITUD DE MOVIMIENTO DE ARTICULACIÓN TEMPOROMANDIBULAR"
  },
  {
    "codigo":292130004,
    "descripcion":"REACCIÓN ADVERSA A FÁRMACO ANTIEMÉTICO"
  },
  {
    "codigo":128290005,
    "descripcion":"ENFERMEDAD CRÓNICA DEL APARATO GENITOURINARIO"
  },
  {
    "codigo":93687001,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA BASE DE LA LENGUA"
  },
  {
    "codigo":716279002,
    "descripcion":"DUPLICACIÓN CONGÉNITA DE LA NARIZ"
  },
  {
    "codigo":290295007,
    "descripcion":"INTOXICACIÓN POR PIROXICAM"
  },
  {
    "codigo":733320001,
    "descripcion":"PUPILA PARASIMPATICOPARÉTICA"
  },
  {
    "codigo":1142263009,
    "descripcion":"HIPERTROFIA DE MÚSCULO ERECTOR ESPINAL"
  },
  {
    "codigo":10756301000119105,
    "descripcion":"MALTRATO FÍSICO QUE COMPLICA EL EMBARAZO"
  },
  {
    "codigo":124620003,
    "descripcion":"DEFICIENCIA DE TREONINA DESHIDRATASA"
  },
  {
    "codigo":1304268003,
    "descripcion":"GLAUCOMA DE ÁNGULO CERRADO SECUNDARIO BILATERAL DEBIDO A SÍNDROME ENDOTELIAL IRIDOCORNEAL"
  },
  {
    "codigo":386764005,
    "descripcion":"QUISTE FOLICULAR LUTEINIZADO"
  },
  {
    "codigo":419532006,
    "descripcion":"PARACOCCIDIOIDOMICOSIS DISEMINADA"
  },
  {
    "codigo":26316005,
    "descripcion":"PROLAPSO RECTAL COMPLETO INTERNO CON INVAGINACIÓN RECTOSIGMOIDEA"
  },
  {
    "codigo":1204129001,
    "descripcion":"TAQUICARDIA VENTRICULAR POLIMÓRFICA CATECOLAMINÉRGICA DEBIDA A MUTACIÓN RYR2"
  },
  {
    "codigo":352461000119107,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE PIEL DE EXTREMIDAD INFERIOR DERECHA"
  },
  {
    "codigo":253857001,
    "descripcion":"SEUDOHERMAFRODITA"
  },
  {
    "codigo":417697003,
    "descripcion":"DESEO VEHEMENTE IRRESISTIBLE DE CONSUMIR DROGAS"
  },
  {
    "codigo":188321006,
    "descripcion":"NEOPLASIA MALIGNA DEL SISTEMA NERVIOSO PERIFÉRICO Y AUTÓNOMO"
  },
  {
    "codigo":365107007,
    "descripcion":"HALLAZGO RELACIONADO CON EL NIVEL DE ÁNIMO"
  },
  {
    "codigo":448630005,
    "descripcion":"ANILLO VASCULAR CON CAYADO AÓRTICO IZQUIERDO Y CONDUCTO ARTERIOSO DERECHO PERMEABLE"
  },
  {
    "codigo":284790007,
    "descripcion":"DIFICULTAD PARA LAVARSE"
  },
  {
    "codigo":1003851001,
    "descripcion":"DEFICIENCIA DE SUBUNIDAD E1 BETA DEL COMPLEJO PIRUVATO DESHIDROGENASA"
  },
  {
    "codigo":414027002,
    "descripcion":"TRASTORNO DE ESTRUCTURA HEMATOPOYÉTICA"
  },
  {
    "codigo":12204391000119104,
    "descripcion":"INFECCIÓN ASOCIADA CON PRÓTESIS ARTICULAR DE TOBILLO DERECHO"
  },
  {
    "codigo":86347007,
    "descripcion":"ESTENOSIS URETRAL TRAUMÁTICA"
  },
  {
    "codigo":80231000119105,
    "descripcion":"DEFICIENCIA DE ENZIMA CIRCULANTE"
  },
  {
    "codigo":282955008,
    "descripcion":"INCAPAZ DE ENDEREZARSE"
  },
  {
    "codigo":16054631000119105,
    "descripcion":"ESTRABISMO PARALÍTICO DE OJO IZQUIERDO"
  },
  {
    "codigo":135681000119100,
    "descripcion":"ANAFILAXIA CAUSADA POR AGENTE ANTIINFLAMATORIO NO ESTEROIDE"
  },
  {
    "codigo":51744007,
    "descripcion":"TAURODONTISMO"
  },
  {
    "codigo":17141001,
    "descripcion":"CALCIFICACIÓN SUBCUTÁNEA"
  },
  {
    "codigo":1264160009,
    "descripcion":"SALPINGOOFORITIS POSTERIOR A EMBARAZO MOLAR"
  },
  {
    "codigo":836341004,
    "descripcion":"HALLAZGO DE CITOLOGÍA URINARIA NEGATIVO PARA CARCINOMA UROTELIAL DE ALTO GRADO"
  },
  {
    "codigo":408522002,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: GAÉLICO"
  },
  {
    "codigo":211914004,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO PROFUNDA DE MUÑECA"
  },
  {
    "codigo":439455002,
    "descripcion":"DEFICIENCIA HEREDITARIA DE SUBUNIDAD A DE FACTOR XIII"
  },
  {
    "codigo":13471002,
    "descripcion":"INFECCIÓN CAUSADA POR TRICHURIS OVIS"
  },
  {
    "codigo":11636000,
    "descripcion":"PRESIÓN DE ENCLAVAMIENTO VENOSA DISMINUIDA"
  },
  {
    "codigo":109940001,
    "descripcion":"NEOPLASIA BENIGNA DE LOS NERVIOS PERIFÉRICOS DEL TÓRAX"
  },
  {
    "codigo":208244008,
    "descripcion":"FRACTURA NO EXPUESTA DE HÚMERO, EPÍFISIS SUPERIOR"
  },
  {
    "codigo":206409001,
    "descripcion":"HEMORRAGIA VAGINAL NEONATAL"
  },
  {
    "codigo":271945003,
    "descripcion":"QUISTE MUCINOSO DE LA CAVIDAD MASTOIDEA"
  },
  {
    "codigo":403017005,
    "descripcion":"TIÑA DE CUERO CABELLUDO CAUSADO POR TRICHOPHYTON VERRUCOSUM"
  },
  {
    "codigo":239177006,
    "descripcion":"DOLOR POSEPISIOTOMÍA"
  },
  {
    "codigo":697929007,
    "descripcion":"HIPERTENSIÓN INTERMITENTE"
  },
  {
    "codigo":270110000,
    "descripcion":"INFORME FORENSE POSTMORTEM - RECIBIDO"
  },
  {
    "codigo":1092251000119102,
    "descripcion":"ABSCESO SUBPERIÓSTICO DE LA APÓFISIS MASTOIDEA DERECHA"
  },
  {
    "codigo":302878004,
    "descripcion":"TROMBOFLEBITIS SÉPTICA INTRACRANEAL"
  },
  {
    "codigo":827166005,
    "descripcion":"PULSO RÁPIDO LIMÍTROFE"
  },
  {
    "codigo":237342006,
    "descripcion":"EMBOLIA GRASA - OBSTÉTRICA"
  },
  {
    "codigo":11850241000119109,
    "descripcion":"CUERPO EXTRAÑO SUPERFICIAL DE MAMA DERECHA CON INFECCIÓN"
  },
  {
    "codigo":1187614006,
    "descripcion":"MACROTROMBOCITOPENIA AUTOSÓMICA RECESIVA SEVERA"
  },
  {
    "codigo":366579005,
    "descripcion":"AMPLITUD DE MOVIMIENTO ACTIVO DE ROTACIÓN EXTERNA DE LA CADERA - HALLAZGO"
  },
  {
    "codigo":233672007,
    "descripcion":"BISINOSIS, GRADO 3"
  },
  {
    "codigo":364744008,
    "descripcion":"HALLAZGO RELACIONADO CON EL TAMAÑO FETAL"
  },
  {
    "codigo":37064009,
    "descripcion":"HIPERPROTEINEMIA"
  },
  {
    "codigo":788893001,
    "descripcion":"CONTUSIÓN DE VASO SANGUÍNEO DE DEDO DE LA MANO"
  },
  {
    "codigo":231837003,
    "descripcion":"ATROFIA SENIL DE LA GLÁNDULA LAGRIMAL"
  },
  {
    "codigo":299208009,
    "descripcion":"ARTICULACIÓN DEL PULGAR FRÍA AL TACTO"
  },
  {
    "codigo":428445000,
    "descripcion":"PRUEBA DE LA RESPIRACIÓN PARA LA DETECCIÓN DE HELICOBACTER, DUDOSA"
  },
  {
    "codigo":626004,
    "descripcion":"HIPERCORTISOLISMO DEBIDO A TUMOR NO HIPOFISARIO"
  },
  {
    "codigo":295538005,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE ISOFLURANO"
  },
  {
    "codigo":721522006,
    "descripcion":"SÍNDROME DEL CORDÓN POSTERIOR DE MÉDULA ESPINAL AL NIVEL DEL QUINTO SEGMENTO LUMBAR"
  },
  {
    "codigo":262770006,
    "descripcion":"LESIÓN DE PAPILA DE GLÁNDULA SALIVAL"
  },
  {
    "codigo":15975221000119104,
    "descripcion":"QUISTE DE ASTA ANTERIOR DE MENISCO INTERNO DE AMBAS RODILLAS"
  },
  {
    "codigo":129863004,
    "descripcion":"CONOCIMIENTOS ESCASOS ACERCA DEL RÉGIMEN ALIMENTARIO"
  },
  {
    "codigo":719687007,
    "descripcion":"FIBROMATOSIS GINGIVAL CON SÍNDROME DE DISMORFISMO FACIAL"
  },
  {
    "codigo":291868001,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR GONADOTROFINA"
  },
  {
    "codigo":302031000119100,
    "descripcion":"ESCOLIOSIS IDIOPÁTICA DEL ADOLESCENTE, COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":816156006,
    "descripcion":"HIPOVOLEMIA RELATIVA"
  },
  {
    "codigo":16030671000119100,
    "descripcion":"OSTEOMIELITIS SUBAGUDA DE TOBILLO DERECHO"
  },
  {
    "codigo":93425004,
    "descripcion":"ALTERACIÓN DE LA COLORACIÓN DE RIÑÓN"
  },
  {
    "codigo":124358009,
    "descripcion":"DEFICIENCIA DE ETANOLAMINAFOSFOTRANSFERASA"
  },
  {
    "codigo":286363002,
    "descripcion":"INCAPAZ DE UTILIZAR EL LENGUAJE"
  },
  {
    "codigo":253595004,
    "descripcion":"PROLAPSO DE VÁLVULA PULMONAR"
  },
  {
    "codigo":282693001,
    "descripcion":"NO EMPUJA NI ARRASTRA HACIA ADELANTE UN JUGUETE GRANDE CON RUEDAS"
  },
  {
    "codigo":249925004,
    "descripcion":"BLOQUEO ARTICULAR COMPLETO"
  },
  {
    "codigo":708677005,
    "descripcion":"MALFORMACIÓN CONGÉNITA DE CAVIDAD GLENOIDEA MANDIBULAR"
  },
  {
    "codigo":315461004,
    "descripcion":"NACIDO EN LAOS"
  },
  {
    "codigo":413765008,
    "descripcion":"CUIDADOR DE PERSONA QUE ABUSA DE SUSTANCIAS"
  },
  {
    "codigo":248090005,
    "descripcion":"PREOCUPACIÓN ACERCA DE LA ORIENTACIÓN SEXUAL"
  },
  {
    "codigo":1296666005,
    "descripcion":"ESTREÑIMIENTO AGUDO EN INFANCIA"
  },
  {
    "codigo":870682008,
    "descripcion":"INCAPAZ DE UTILIZAR COMUNICACIÓN CON AUMENTATIVOS Y DIMINUTIVOS"
  },
  {
    "codigo":770543003,
    "descripcion":"HIPOPLASIA CONGÉNITA DE PARTE DE LA EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":82415003,
    "descripcion":"AGORAFOBIA SIN ANTECEDENTE DE TRASTORNO DE PÁNICO, SIN ATAQUES SINTOMÁTICOS LIMITADOS"
  },
  {
    "codigo":61151000087106,
    "descripcion":"INFECCIÓN CAUSADA POR STREPTOCOCCUS INIAE"
  },
  {
    "codigo":705007006,
    "descripcion":"ELEVACIÓN INFERIOR DE SEGMENTO ST"
  },
  {
    "codigo":211652000,
    "descripcion":"CUERPO EXTRAÑO EN VULVA Y VAGINA"
  },
  {
    "codigo":735940001,
    "descripcion":"DOLOR EN ESPACIO INTERCOSTAL"
  },
  {
    "codigo":47812002,
    "descripcion":"DIARREA FUNCIONAL"
  },
  {
    "codigo":703172003,
    "descripcion":"FALLA DE PRÓTESIS DE VÁLVULA AÓRTICA QUE REQUIERE REVISIÓN"
  },
  {
    "codigo":277188003,
    "descripcion":"COMPRESIÓN DE NERVIO CUBITAL"
  },
  {
    "codigo":209817000,
    "descripcion":"DESGARRO COMPLETO, LIGAMENTO ILIOLUMBAR"
  },
  {
    "codigo":111513000,
    "descripcion":"GLAUCOMA AVANZADO DE ÁNGULO ABIERTO"
  },
  {
    "codigo":15676521000119107,
    "descripcion":"TENDINITIS DE TENDÓN EXTENSOR DE MANO DERECHA"
  },
  {
    "codigo":308121000,
    "descripcion":"LINFOMA FOLICULAR"
  },
  {
    "codigo":240750000,
    "descripcion":"NÓDULO LOBOMICÓTICO PRIMARIO"
  },
  {
    "codigo":275353009,
    "descripcion":"DEFORMIDAD DE PIE EN SUPINACIÓN"
  },
  {
    "codigo":109678002,
    "descripcion":"LUXACIÓN DENTAL EXTRUSIVA"
  },
  {
    "codigo":371822007,
    "descripcion":"PACIENTE LUEGO DE ANGIOPLASTIA CORONARIA TRANSLUMINAL PERCUTÁNEA"
  },
  {
    "codigo":271683004,
    "descripcion":"VESÍCULA BILIAR PALPABLE"
  },
  {
    "codigo":1254723004,
    "descripcion":"METÁSTASIS DE CARCINOMA ADENOIDE QUÍSTICO EN GLÁNDULA LAGRIMAL DERECHA"
  },
  {
    "codigo":106008001,
    "descripcion":"ENFERMEDAD MATERNA Y\/O DEL ALUMBRAMIENTO QUE AFECTA EL MANEJO"
  },
  {
    "codigo":237080002,
    "descripcion":"EXPULSIÓN DEL DISPOSITIVO ANTICONCEPTIVO INTRAUTERINO"
  },
  {
    "codigo":763203009,
    "descripcion":"DEFECTO COMBINADO DE LA FOSFORILACIÓN OXIDATIVA TIPO 15"
  },
  {
    "codigo":204312002,
    "descripcion":"DEFECTO DEL TABIQUE VENTRICULAR ENTRE VENTRÍCULO IZQUIERDO Y AURÍCULA DERECHA"
  },
  {
    "codigo":1156419009,
    "descripcion":"ADENOMA HEPATOCELULAR"
  },
  {
    "codigo":1285656005,
    "descripcion":"ENFERMEDAD LEVE POR DEFICIENCIA HEREDITARIA DE FACTOR VIII CON INHIBIDOR DE BAJA RESPUESTA"
  },
  {
    "codigo":71405002,
    "descripcion":"PULSATILIDAD HEPÁTICA"
  },
  {
    "codigo":10734851000119107,
    "descripcion":"CAMBIO FIBROQUÍSTICO DE MAMA IZQUIERDA"
  },
  {
    "codigo":366317004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CALIDAD DEL ORGASMO"
  },
  {
    "codigo":300781006,
    "descripcion":"INCAPAZ DE PARTICIPAR EN JUEGOS POR DIVERSIÓN"
  },
  {
    "codigo":724930001,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO TRÍCEPS BRAQUIAL"
  },
  {
    "codigo":723095001,
    "descripcion":"QUISTE DE CUELLO"
  },
  {
    "codigo":460951001,
    "descripcion":"DILATACIÓN QUÍSTICA DE CONDUCTO DE GLÁNDULA BULBOURETRAL"
  },
  {
    "codigo":788631003,
    "descripcion":"MÁCULA MELANÓTICA DE LABIO"
  },
  {
    "codigo":198807003,
    "descripcion":"INTENTO FALLIDO DE ABORTO CON HEMORRAGIA TARDÍA O EXCESIVA"
  },
  {
    "codigo":428183006,
    "descripcion":"ESCLERÓTICA PÁLIDA"
  },
  {
    "codigo":229740001,
    "descripcion":"RETARDO DEL DESARROLLO PRE-VERBAL"
  },
  {
    "codigo":721260003,
    "descripcion":"INFECCIÓN PARASITARIA DE GLÁNDULA LAGRIMAL"
  },
  {
    "codigo":33132004,
    "descripcion":"RUPTURA DE DISCO INTERVERTEBRAL"
  },
  {
    "codigo":295276003,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE NAPROXENO"
  },
  {
    "codigo":364006,
    "descripcion":"INSUFICIENCIA VENTRICULAR IZQUIERDA AGUDA"
  },
  {
    "codigo":360812008,
    "descripcion":"DEFICIENCIA DE FOSFOLIPASA D"
  },
  {
    "codigo":293441001,
    "descripcion":"REACCIÓN ADVERSA A LA QUINIDINA"
  },
  {
    "codigo":129601002,
    "descripcion":"SÍNDROME DEL ÍLEO NEURÓGENO CONGÉNITO"
  },
  {
    "codigo":400375351000119102,
    "descripcion":"MELANOMA MALIGNO DE PIEL DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":719425009,
    "descripcion":"MUERTE SÚBITA INEXPLICABLE EN EPILEPSIA"
  },
  {
    "codigo":195137008,
    "descripcion":"DEFECTO ADQUIRIDO DE TABIQUE CARDÍACO"
  },
  {
    "codigo":291606002,
    "descripcion":"INTOXICACIÓN POR CEFIXIMA"
  },
  {
    "codigo":15951261000119109,
    "descripcion":"NEOPLASIA BENIGNA DE PIEL DE MAMA IZQUIERDA"
  },
  {
    "codigo":658041000005109,
    "descripcion":"PLACENTA UBICADA EN PARED ANTERIOR IZQUIERDA DE ÚTERO"
  },
  {
    "codigo":94998008,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL TEJIDO PERIRRENAL"
  },
  {
    "codigo":93163002,
    "descripcion":"LIPOMA"
  },
  {
    "codigo":1010667003,
    "descripcion":"ESTERNÓPAGO"
  },
  {
    "codigo":25792000,
    "descripcion":"SÍNDROME DE KEARNS-SAYRE"
  },
  {
    "codigo":29981000175104,
    "descripcion":"ÚLCERA POR PRESIÓN EN DORSO DE PIE DERECHO, ESTADIO II"
  },
  {
    "codigo":715755008,
    "descripcion":"ATAXIA ESPINOCEREBELOSA TIPO 4"
  },
  {
    "codigo":255168002,
    "descripcion":"NEOPLASIA BENIGNA DE ESÓFAGO, ESTÓMAGO Y\/O DUODENO"
  },
  {
    "codigo":23957004,
    "descripcion":"AMPOLLAS CUTÁNEAS POR FRICCIÓN"
  },
  {
    "codigo":89493005,
    "descripcion":"CIERRE EPIFISARIO PREMATURO"
  },
  {
    "codigo":286101006,
    "descripcion":"LIMPIA UNA HABITACIÓN"
  },
  {
    "codigo":744853008,
    "descripcion":"ASPIRACIÓN DE CUERPO EXTRAÑO HACIA PULMÓN"
  },
  {
    "codigo":253333008,
    "descripcion":"DESEMBOCADURA ANORMAL DE LA VENA HEPÁTICA EN AURÍCULA"
  },
  {
    "codigo":284266005,
    "descripcion":"UTILIZA PRENSIÓN PALMAR"
  },
  {
    "codigo":54890005,
    "descripcion":"INFECCIÓN CAUSADA POR ANDRYA"
  },
  {
    "codigo":249663005,
    "descripcion":"ESTADO DEL PERINEO ALREDEDOR DEL ANO"
  },
  {
    "codigo":184127005,
    "descripcion":"ES CUESTIONABLE SI LA DIRECCIÓN DEL PACIENTE ES CORRECTA"
  },
  {
    "codigo":773951007,
    "descripcion":"OTITIS EXTERNA NECROSANTE DE CONDUCTO AUDITIVO EXTERNO DERECHO"
  },
  {
    "codigo":282431009,
    "descripcion":"SECCIÓN DE VESÍCULA BILIAR"
  },
  {
    "codigo":1263636001,
    "descripcion":"TRASTORNO FETAL DEBIDO A ANOMALÍA ÓSEA PÉLVICA MATERNA DURANTE TRABAJO DE PARTO"
  },
  {
    "codigo":870420005,
    "descripcion":"RETINOPATÍA NO PROLIFERATIVA SEVERA CON VENAS DE LA RETINA EN CUENTAS DE ROSARIO DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":247828005,
    "descripcion":"MIEDO A SALIR"
  },
  {
    "codigo":1163497001,
    "descripcion":"DACRIOADENITIS POR MYCOBACTERIUM LEPRAE"
  },
  {
    "codigo":82153002,
    "descripcion":"ABORTO ESPONTÁNEO CON EMBOLIA PULMONAR"
  },
  {
    "codigo":16617009,
    "descripcion":"DISFONÍA"
  },
  {
    "codigo":735678002,
    "descripcion":"CONDROSARCOMA PRIMARIO DE CARTÍLAGO ARTICULAR"
  },
  {
    "codigo":10737361000119109,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE TROMPA DE FALOPIO DERECHA"
  },
  {
    "codigo":61291000119103,
    "descripcion":"TRASTORNO DEL SISTEMA NERVIOSO CENTRAL CONCOMITANTE CON LEUCEMIA LINFOIDE AGUDA EN REMISIÓN Y DEBIDO A ELLA"
  },
  {
    "codigo":1290899003,
    "descripcion":"CONDROSARCOMA PERIOSTEAL"
  },
  {
    "codigo":39001000087100,
    "descripcion":"CONTUSIÓN DE DORSO DE MANO DERECHA"
  },
  {
    "codigo":45715008,
    "descripcion":"MEMBRANAS VÍTREAS"
  },
  {
    "codigo":699240001,
    "descripcion":"EMBARAZO INTRAUTERINO Y OVÁRICO COMBINADO"
  },
  {
    "codigo":109416002,
    "descripcion":"CRANEOSINOSTOSIS ESFENOFRONTOPARIETAL"
  },
  {
    "codigo":46681000087105,
    "descripcion":"FRACTURA DE FALANGE DISTAL DE ÍNDICE DERECHO"
  },
  {
    "codigo":44121000087105,
    "descripcion":"HERIDA CORTANTE DE PIEL DE BRAZO IZQUIERDO"
  },
  {
    "codigo":1354600005,
    "descripcion":"FRACTURA DE FALANGE DISTAL DE ANULAR"
  },
  {
    "codigo":41561000087105,
    "descripcion":"HERIDA PUNZANTE DE OÍDO IZQUIERDO"
  },
  {
    "codigo":369725003,
    "descripcion":"G2: 6-50 POR CIENTO DE CRECIMIENTO SÓLIDO NO ESCAMOSO"
  },
  {
    "codigo":238653005,
    "descripcion":"LIQUEN PLANO PENFIGOIDES"
  },
  {
    "codigo":42045007,
    "descripcion":"ACEPTACIÓN DE LA ENFERMEDAD"
  },
  {
    "codigo":12103531000119108,
    "descripcion":"QUEMADURA DE MUSLO IZQUIERDO"
  },
  {
    "codigo":40210001,
    "descripcion":"HÍGADO FLOTANTE"
  },
  {
    "codigo":402493009,
    "descripcion":"CALCINOSIS LUEGO DE ACNÉ"
  },
  {
    "codigo":171282003,
    "descripcion":"INMUNIZACIÓN ANTIGRIPAL ACONSEJADA EN EL HOGAR"
  },
  {
    "codigo":236818008,
    "descripcion":"GLOBOZOOSPERMIA"
  },
  {
    "codigo":202215001,
    "descripcion":"SUBLUXACIÓN INFERIOR RECIDIVANTE DE HOMBRO"
  },
  {
    "codigo":300519001,
    "descripcion":"PREPUCIO AUSENTE"
  },
  {
    "codigo":366055004,
    "descripcion":"HALLAZGO RELACIONADO CON EL DESARROLLO GENERAL"
  },
  {
    "codigo":169447004,
    "descripcion":"SIN PAREJA ACTUAL"
  },
  {
    "codigo":234983007,
    "descripcion":"DECOLORACIÓN DENTAL INTRÍNSECA"
  },
  {
    "codigo":724668002,
    "descripcion":"CONVULSIÓN CONCOMITANTE CON ABSTINENCIA DE SEDANTE Y DEBIDA A ELLA"
  },
  {
    "codigo":36540006,
    "descripcion":"CALCIFICACIÓN DE ARTICULACIÓN"
  },
  {
    "codigo":296849000,
    "descripcion":"SOBREDOSIS DE INSULINA"
  },
  {
    "codigo":298684009,
    "descripcion":"HALLAZGO RELACIONADO CON MEDICIONES DE LA COLUMNA LUMBAR"
  },
  {
    "codigo":722833004,
    "descripcion":"AVULSIÓN DE ELEVADOR DEL ANO DE SÍNFISIS DEL PUBIS FEMENINA"
  },
  {
    "codigo":1279889005,
    "descripcion":"SÍNDROME DE MICROCEFALIA, DISMORFIA FACIAL, ANOMALÍAS OCULARES, ANOMALÍAS CONGÉNITAS MÚLTIPLES"
  },
  {
    "codigo":249907006,
    "descripcion":"DIFICULTAD PARA ERGUIRSE"
  },
  {
    "codigo":427921009,
    "descripcion":"ÚLCERA CRÓNICA EN EL TOBILLO"
  },
  {
    "codigo":131174003,
    "descripcion":"SULFAHEMOGLOBINA POR DEBAJO DE RANGO DE REFERENCIA"
  },
  {
    "codigo":1343590006,
    "descripcion":"ÚLCERA NEUROPÁTICA DE PANTORRILLA"
  },
  {
    "codigo":719163006,
    "descripcion":"ORIFICIO NASAL ANTERIOR ACCESORIO"
  },
  {
    "codigo":336031000119105,
    "descripcion":"GLAUCOMA DE ÁNGULO ANATÓMICO CERRADO DEL OJO DERECHO"
  },
  {
    "codigo":225808004,
    "descripcion":"SOBREPROTEGIDO"
  },
  {
    "codigo":94736004,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL MEDIASTINO ANTERIOR"
  },
  {
    "codigo":11778361000119100,
    "descripcion":"DISTENSIÓN DE TENDÓN DE MÚSCULO TRAPECIO DERECHO"
  },
  {
    "codigo":1208848007,
    "descripcion":"INSUFICIENCIA VENTRICULAR DERECHA POR TRASTORNO CIRCULATORIO PULMONAR"
  },
  {
    "codigo":289509002,
    "descripcion":"EDEMA DEL CLÍTORIS"
  },
  {
    "codigo":1010405004,
    "descripcion":"FIBRILACIÓN AURICULAR PAROXÍSTICA CON RESPUESTA VENTRICULAR RÁPIDA"
  },
  {
    "codigo":92901009,
    "descripcion":"FORMA ANORMAL CONGÉNITA DEL CENTRO DE LA VÉRTEBRA LUMBAR"
  },
  {
    "codigo":1073311000119109,
    "descripcion":"ARTRITIS DE CADERA IZQUIERDA CAUSADA POR BACTERIAS"
  },
  {
    "codigo":254906005,
    "descripcion":"NEOPLASIA DE PIEL DE PENE"
  },
  {
    "codigo":123834005,
    "descripcion":"SATISFACTORIO PARA EVALUACIÓN, PERO LIMITADO POR FIJACIÓN ESCASA DE LA MUESTRA, QUE ENMASCARA PARCIALMENTE EL RESULTADO"
  },
  {
    "codigo":89231008,
    "descripcion":"HEPATITIS POR VIRUS DE LA PAROTIDITIS URLIANA"
  },
  {
    "codigo":21860004,
    "descripcion":"NEURITIS ACÚSTICA"
  },
  {
    "codigo":87396006,
    "descripcion":"INTOXICACIÓN POR CLORPROMAZINA"
  },
  {
    "codigo":709988008,
    "descripcion":"ESQUEMA OCLUSAL PARCIALMENTE DENTADO MODERADAMENTE COMPROMETIDO"
  },
  {
    "codigo":309561000119107,
    "descripcion":"NECROSIS AVASCULAR DE CLAVÍCULA IZQUIERDA"
  },
  {
    "codigo":20025003,
    "descripcion":"ABSCESO DE LA GLÁNDULA DE COWPER"
  },
  {
    "codigo":15710521000119107,
    "descripcion":"ARTERIOSCLEROSIS DE INJERTO-PUENTE AUTÓLOGO DE EXTREMIDAD INFERIOR IZQUIERDA"
  },
  {
    "codigo":10959161000119107,
    "descripcion":"LACERACIÓN DE BRAZO IZQUIERDO"
  },
  {
    "codigo":216633005,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR BEBIDA ALCOHÓLICA"
  },
  {
    "codigo":282169007,
    "descripcion":"SUBE UNA COLINA"
  },
  {
    "codigo":1363513003,
    "descripcion":"MIOGLOBINA EN SUERO POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":247566002,
    "descripcion":"CAMBIO DEL COLOR DE PELO"
  },
  {
    "codigo":81891001,
    "descripcion":"HIPERSECRECIÓN DE ANDRÓGENOS OVÁRICOS"
  },
  {
    "codigo":1359843003,
    "descripcion":"NEOPLASIA BENIGNA DE CARA INFERIOR DE PALADAR"
  },
  {
    "codigo":704483005,
    "descripcion":"FRACTURA EXPUESTA DE PARED ANTERIOR DE ACETÁBULO"
  },
  {
    "codigo":49123007,
    "descripcion":"GLOSITIS CAUSADA POR ACEITE DE CANELA"
  },
  {
    "codigo":737251009,
    "descripcion":"REACCIÓN FOTOTÓXICA CUTÁNEA CAUSADA POR COSMÉTICO"
  },
  {
    "codigo":445361000124101,
    "descripcion":"CAPAZ DE MANEJAR LA NUTRICIÓN"
  },
  {
    "codigo":276664005,
    "descripcion":"INFECCIÓN CONGÉNITA POR COXACKIE"
  },
  {
    "codigo":307597000,
    "descripcion":"HIDRADENOMA PAPILAR"
  },
  {
    "codigo":14520009,
    "descripcion":"RETRACCIÓN DE PÁRPADO"
  },
  {
    "codigo":373133002,
    "descripcion":"RAÍZ AÓRTICA AGRANDADA"
  },
  {
    "codigo":1259704009,
    "descripcion":"CARCINOMA ESCAMOSO BASALOIDE PRIMARIO DE NASOFARINGE"
  },
  {
    "codigo":405901003,
    "descripcion":"P1 - FENOTIPO"
  },
  {
    "codigo":2481000124109,
    "descripcion":"INCISIVO CENTRAL INFERIOR IZQUIERDO PERMANENTE SUPERNUMERARIO"
  },
  {
    "codigo":110989007,
    "descripcion":"ERITROSIS PERIBUCAL PIGMENTADA DE BROCQ"
  },
  {
    "codigo":209293008,
    "descripcion":"FRACTURA-SUBLUXACIÓN EXPUESTA DE ARTICULACIÓN RADIOCUBITAL DISTAL"
  },
  {
    "codigo":305762001,
    "descripcion":"VISTO POR PROFESIONAL RELACIONADO CON LA MEDICINA"
  },
  {
    "codigo":240226003,
    "descripcion":"DEFORMIDAD ESQUELÉTICA ADQUIRIDA"
  },
  {
    "codigo":404066004,
    "descripcion":"MIOLIPOMA"
  },
  {
    "codigo":238391002,
    "descripcion":"SICOSIS AGUDA DE LA BARBA"
  },
  {
    "codigo":205623003,
    "descripcion":"TRISOMÍA 18 - FALTA DE DISYUNCIÓN MEIÓTICA"
  },
  {
    "codigo":41783004,
    "descripcion":"ANOSMIA TRAUMÁTICA"
  },
  {
    "codigo":369463005,
    "descripcion":"TUMOR MALIGNO QUE COMPROMETE EL URÉTER POR PROPAGACIÓN DIRECTA DESDE LA VEJIGA"
  },
  {
    "codigo":105484002,
    "descripcion":"CRISIS DE LA MITAD DE LA VIDA, EVENTO DEL CICLO VITAL"
  },
  {
    "codigo":236556004,
    "descripcion":"LÍQUIDO SANGUINOLENTO EXTRAÍDO DE DIÁLISIS PERITONEAL"
  },
  {
    "codigo":1186828006,
    "descripcion":"NEUROPATÍA PERIFÉRICA DEBIDA A MÚLTIPLES DEFICIENCIAS DE MICRONUTRIENTES"
  },
  {
    "codigo":302092006,
    "descripcion":"ULCERACIÓN DE GANGLIO LINFÁTICO EPITROCLEAR"
  },
  {
    "codigo":300257000,
    "descripcion":"LESIÓN EN GLÁNDULA SALIVAL"
  },
  {
    "codigo":7180009,
    "descripcion":"MENINGITIS"
  },
  {
    "codigo":431329002,
    "descripcion":"ESPASMO DE CUELLO UTERINO"
  },
  {
    "codigo":201953000,
    "descripcion":"ARTROPATÍA TRAUMÁTICA DE LA ARTICULACIÓN TIBIOPERONEA"
  },
  {
    "codigo":1260083004,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS DE SENO PIRIFORME"
  },
  {
    "codigo":365793008,
    "descripcion":"HALLAZGO RELACIONADO CON EL NIVEL DE COLESTEROL"
  },
  {
    "codigo":10633991000119103,
    "descripcion":"EMPIEMA DE SENO PARANASAL"
  },
  {
    "codigo":394891000,
    "descripcion":"PRUEBA DE EMISIÓN OTOACÚSTICA, NORMAL"
  },
  {
    "codigo":429494008,
    "descripcion":"SEROMA POSQUIRÚRGICO"
  },
  {
    "codigo":211507008,
    "descripcion":"CONTUSIÓN DE LA MANO, EXCLUIDOS LOS DEDOS"
  },
  {
    "codigo":722571004,
    "descripcion":"FRACTURA LINEAL DE CRÁNEO DEBIDA A TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":296587004,
    "descripcion":"SOBREDOSIS DE FÁRMACO ANTIBACTERIANO"
  },
  {
    "codigo":1148555003,
    "descripcion":"EROSIÓN DE DUODENO CON HEMORRAGIA"
  },
  {
    "codigo":294752004,
    "descripcion":"ALERGIA A NORETISTERONA"
  },
  {
    "codigo":32608004,
    "descripcion":"FIBROSIS DEL CUERPO CAVERNOSO"
  },
  {
    "codigo":129077000,
    "descripcion":"DEPENDENCIA PARA MANTENER LA CONTINENCIA"
  },
  {
    "codigo":292917001,
    "descripcion":"REACCIÓN ADVERSA AL MEBENDAZOL"
  },
  {
    "codigo":161845002,
    "descripcion":"NO INGIERE LÍQUIDOS"
  },
  {
    "codigo":1144885005,
    "descripcion":"DEMUESTRA CONOCIMIENTO SOBRE EVALUACIÓN DIAGNÓSTICA"
  },
  {
    "codigo":127242000,
    "descripcion":"NEOPLASIA DE LOS GANGLIOS LINFÁTICOS RETROFARÍNGEOS"
  },
  {
    "codigo":291082002,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR PRAZEPAM"
  },
  {
    "codigo":94474008,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA GLÁNDULA PARÓTIDA"
  },
  {
    "codigo":92639004,
    "descripcion":"CARCINOMA IN SITU DEL LÓBULO INFERIOR IZQUIERDO DEL PULMÓN"
  },
  {
    "codigo":289247008,
    "descripcion":"HALLAZGO RELACIONADO CON MEDICIONES DEL TRABAJO DE PARTO"
  },
  {
    "codigo":254644003,
    "descripcion":"HAMARTOMA DE PULMÓN"
  },
  {
    "codigo":1335988004,
    "descripcion":"QUISTE DE IRIS IZQUIERDO"
  },
  {
    "codigo":123572006,
    "descripcion":"ANOMALÍA CONGÉNITA DE LAS COSTILLAS"
  },
  {
    "codigo":1137545002,
    "descripcion":"CALCIFICACIÓN PUNTEADA DE EPÍFISIS DE FALANGE PROXIMAL DE MANO"
  },
  {
    "codigo":88969002,
    "descripcion":"COMPLICACIÓN DE LA CIRCULACIÓN EXTRACORPÓREA"
  },
  {
    "codigo":711561004,
    "descripcion":"TIENE ACCESO A MEDIOS PARA SUICIDARSE PLANEADOS"
  },
  {
    "codigo":449417005,
    "descripcion":"NEOPLASIA EPITELIAL MALIGNA DE TABIQUE NASAL"
  },
  {
    "codigo":15686561000119107,
    "descripcion":"INFLAMACIÓN TRANSITORIA DE MEMBRANA SINOVIAL DE ARTICULACIÓN DE AMBAS RODILLAS"
  },
  {
    "codigo":367521000119108,
    "descripcion":"GLOMERULONEFRITIS PROLIFERATIVA DIFUSA HEREDITARIA"
  },
  {
    "codigo":250974001,
    "descripcion":"INSUFICIENCIA DE PRÓTESIS DE VÁLVULA AÓRTICA"
  },
  {
    "codigo":54366004,
    "descripcion":"HIDROPESÍA AGUDA DE LA VESÍCULA BILIAR"
  },
  {
    "codigo":283742006,
    "descripcion":"MORDEDURA DE PERRO EN LA NARIZ"
  },
  {
    "codigo":249139003,
    "descripcion":"MECONIO ESPESO QUE DRENA CON LÍQUIDO AMNIÓTICO"
  },
  {
    "codigo":11853811000119100,
    "descripcion":"LESIÓN TRAUMÁTICA DE TOBILLO DERECHO"
  },
  {
    "codigo":281907005,
    "descripcion":"FRACTURA LUXACIÓN DE ARTICULACIÓN TORACOLUMBAR"
  },
  {
    "codigo":328691000119101,
    "descripcion":"INFECCIÓN DEBIDA A PROCEDIMIENTO CON BANDA GÁSTRICA"
  },
  {
    "codigo":1089011000119101,
    "descripcion":"INFLAMACIÓN DE ESTRUCTURA DEL LABERINTO IZQUIERDO"
  },
  {
    "codigo":1011000119104,
    "descripcion":"PESARIO VAGINAL IN SITU"
  },
  {
    "codigo":17928001,
    "descripcion":"PROTEINURIA DE CADENAS LIVIANAS"
  },
  {
    "codigo":333811000119103,
    "descripcion":"EXOTROPÍA MONOCULAR CON PATRÓN A DE OJO DERECHO"
  },
  {
    "codigo":773427008,
    "descripcion":"ALERGIA A DANAPAROIDE"
  },
  {
    "codigo":346611000119108,
    "descripcion":"ANOMALÍA VASCULAR BILATERAL DE CONJUNTIVAS"
  },
  {
    "codigo":321011000119106,
    "descripcion":"ENTESOPATÍA ESPINAL DE REGIÓN LUMBOSACRA"
  },
  {
    "codigo":10970611000119108,
    "descripcion":"HERIDA ABIERTA DE PIERNA DERECHA DEBIDA A MORDEDURA DE GATO"
  },
  {
    "codigo":12245491000119103,
    "descripcion":"TROMBOSIS DE FÍSTULA ARTERIOVENOSA CREADA QUIRÚRGICAMENTE"
  },
  {
    "codigo":11777011000119104,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO BÍCEPS BRAQUIAL DERECHO"
  },
  {
    "codigo":470101491000119107,
    "descripcion":"ENFERMEDAD PULMONAR INTERSTICIAL DEBIDA A DABBING"
  },
  {
    "codigo":292851000119109,
    "descripcion":"HEMIPARESIA ATÁXICA LACUNAR DE LADO DERECHO DOMINANTE"
  },
  {
    "codigo":247304003,
    "descripcion":"PRUEBA DE LA VOZ INCONCLUSA"
  },
  {
    "codigo":303091000119107,
    "descripcion":"BURSITIS DE HOMBRO DERECHO"
  },
  {
    "codigo":835293005,
    "descripcion":"AGUDEZA VISUAL DE OJO IZQUIERDO 6\/18"
  },
  {
    "codigo":442077006,
    "descripcion":"HEMIPLEJÍA FLÁCCIDA DE LADO NO DOMINANTE"
  },
  {
    "codigo":278237007,
    "descripcion":"BLOQUEO DE LA CONDUCCIÓN NERVIOSA SENSITIVA"
  },
  {
    "codigo":473010000,
    "descripcion":"ESTADO DE HIPERSENSIBILIDAD"
  },
  {
    "codigo":276402001,
    "descripcion":"MUÑÓN UMBILICAL HÚMEDO"
  },
  {
    "codigo":81629009,
    "descripcion":"LUXACIÓN TRAUMÁTICA DE ARTICULACIÓN TEMPOROMANDIBULAR"
  },
  {
    "codigo":212701009,
    "descripcion":"INTOXICACIÓN CON PAPAVERINA"
  },
  {
    "codigo":210866004,
    "descripcion":"LESIÓN EXPUESTA, ARTERIA FEMORAL COMÚN"
  },
  {
    "codigo":1259442004,
    "descripcion":"CARCINOMA MUCINOSO PRIMARIO DE MAMA"
  },
  {
    "codigo":341051000119109,
    "descripcion":"DESCEMETOCELE DE OJO IZQUIERDO"
  },
  {
    "codigo":704221007,
    "descripcion":"FRACTURA EXPUESTA DE CUELLO DE CUARTO METACARPIANO"
  },
  {
    "codigo":209031001,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA EXPUESTA DE MÚLTIPLES ARTICULACIONES METATARSOFALÁNGICAS"
  },
  {
    "codigo":307335006,
    "descripcion":"ISOINMUNIZACIÓN RHESUS POR INMUNOGLOBULINA ANTI - E"
  },
  {
    "codigo":733319007,
    "descripcion":"REACCIÓN PUPILAR PARADÓJICA A LA LUZ Y LA OSCURIDAD"
  },
  {
    "codigo":405639008,
    "descripcion":"EXTUBACIÓN TRAQUEAL INADVERTIDA"
  },
  {
    "codigo":371036001,
    "descripcion":"MENOPAUSIA POSQUIRÚRGICA"
  },
  {
    "codigo":241799008,
    "descripcion":"EFECTO TÓXICO CAUSADO POR RODENTICIDA NO ANTICOAGULANTE"
  },
  {
    "codigo":239964003,
    "descripcion":"LESIÓN DE PARTES BLANDAS DE REGIÓN DE CODO"
  },
  {
    "codigo":698716002,
    "descripcion":"TRABAJO DE PARTO ESPONTÁNEO PRETÉRMINO CON PARTO PRETÉRMINO"
  },
  {
    "codigo":895324007,
    "descripcion":"CURVATURA ANORMAL DE FALANGE DISTAL DE DEDO ÍNDICE"
  },
  {
    "codigo":403804008,
    "descripcion":"HIPERMELANOSIS HEREDITARIA"
  },
  {
    "codigo":305500009,
    "descripcion":"BAJO ATENCIÓN DE PEDIATRA"
  },
  {
    "codigo":762417006,
    "descripcion":"RUPTURA DE IRIS"
  },
  {
    "codigo":205361007,
    "descripcion":"BARRA CUNEOESCAFOIDEA"
  },
  {
    "codigo":860721006,
    "descripcion":"TRASTORNO DE MÁCULA DE AMBOS OJOS DEBIDO A DIABETES MELLITUS"
  },
  {
    "codigo":301830001,
    "descripcion":"HALLAZGO RELACIONADO CON LA ORINA"
  },
  {
    "codigo":269062008,
    "descripcion":"FRACTURA NO EXPUESTA DE COLUMNA VERTEBRAL CERVICAL"
  },
  {
    "codigo":365531006,
    "descripcion":"INSTALACIONES SANITARIAS EN EL ÁMBITO LABORAL - HALLAZGO"
  },
  {
    "codigo":234459007,
    "descripcion":"DISFIBRINOGENEMIA POR DEFECTO DE LA CADENA ALFA"
  },
  {
    "codigo":298160000,
    "descripcion":"INFLAMACIÓN DE ARTICULACIÓN"
  },
  {
    "codigo":5083008,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DE DORSO"
  },
  {
    "codigo":429232006,
    "descripcion":"ISQUEMIA MIOCÁRDICA DISMINUIDA EN COMPARACIÓN CON ESTUDIO ANTERIOR"
  },
  {
    "codigo":363696006,
    "descripcion":"TRASTORNO CARDIOVASCULAR NEONATAL"
  },
  {
    "codigo":722309000,
    "descripcion":"NEURODISCAPACIDAD"
  },
  {
    "codigo":1080841000119100,
    "descripcion":"HISTIOCITOMA FIBROSO MALIGNO PRIMARIO DE PARTES BLANDAS DE MIEMBRO SUPERIOR DERECHO"
  },
  {
    "codigo":724144006,
    "descripcion":"EMBRIOFETOPATÍA CAUSADA POR METIMAZOL"
  },
  {
    "codigo":165253006,
    "descripcion":"BASTÓN SOLO PARA CAMINAR"
  },
  {
    "codigo":97801000119102,
    "descripcion":"GASTRITIS CON HEMORRAGIA GASTROINTESTINAL"
  },
  {
    "codigo":296325008,
    "descripcion":"SOBREDOSIS DE COCAÍNA CRACK"
  },
  {
    "codigo":294490006,
    "descripcion":"ALERGIA A NORFLOXACINO"
  },
  {
    "codigo":425562008,
    "descripcion":"CISTITIS BACTERIANA RECURRENTE"
  },
  {
    "codigo":290820000,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR CLOMIPRAMINA"
  },
  {
    "codigo":194351009,
    "descripcion":"ENFERMEDAD DE MÉNIÈRE INACTIVA"
  },
  {
    "codigo":782340001,
    "descripcion":"INTOLERANCIA ADQUIRIDA A LA FRUCTOSA"
  },
  {
    "codigo":126980002,
    "descripcion":"NEOPLASIA DE NERVIO PERIFÉRICO"
  },
  {
    "codigo":94212002,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL CUERPO DEL PÁNCREAS"
  },
  {
    "codigo":15744521000119106,
    "descripcion":"MASA DE ARTICULACIÓN DE AMBAS REGIONES DE MUÑECA"
  },
  {
    "codigo":28676002,
    "descripcion":"TRASTORNO DEL ESTADO DE ÁNIMO CON CARACTERÍSTICAS MANÍACAS DEBIDO A AFECCIÓN GENERAL"
  },
  {
    "codigo":390959009,
    "descripcion":"NACIDO VIVO QUE SOBREVIVE MÁS DE UN AÑO"
  },
  {
    "codigo":92377001,
    "descripcion":"NEOPLASIA BENIGNA DE LA PIEL DE LA REGIÓN TEMPORAL"
  },
  {
    "codigo":61444009,
    "descripcion":"DIPLOACUSIA DISARMÓNICA"
  },
  {
    "codigo":190681003,
    "descripcion":"CISTINOSIS"
  },
  {
    "codigo":420057003,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR MONÓXIDO DE CARBONO"
  },
  {
    "codigo":288985005,
    "descripcion":"NO SUCCIONA"
  },
  {
    "codigo":16783011000119102,
    "descripcion":"CARCINOMA DE CÉLULAS DE MERKEL PRIMARIO DE PIEL DE FRENTE"
  },
  {
    "codigo":188846003,
    "descripcion":"NEOPLASIA BENIGNA DEL ESFÍNTER DE ODDI"
  },
  {
    "codigo":1237422007,
    "descripcion":"METÁSTASIS DE CARCINOMA DE PRÓSTATA"
  },
  {
    "codigo":23171006,
    "descripcion":"HEMORRAGIA POSTPARTO RETARDADA Y\/O SECUNDARIA"
  },
  {
    "codigo":414552005,
    "descripcion":"XANTOGRANULOMA JUVENIL CUTÁNEO"
  },
  {
    "codigo":283480006,
    "descripcion":"HERIDA PUNZANTE EN EXTREMIDAD INFERIOR"
  },
  {
    "codigo":185176006,
    "descripcion":"ATENDIDO EN CONSULTORIO ESPECIALIZADO EN NUTRICIÓN"
  },
  {
    "codigo":445485000,
    "descripcion":"NO APTO DESDE EL PUNTO DE VISTA MÉDICO PARA SER EVALUADO EN ESCUELA"
  },
  {
    "codigo":609325001,
    "descripcion":"ATRAPAMIENTO DE MÚSCULO EXTRAOCULAR"
  },
  {
    "codigo":447320006,
    "descripcion":"OBSTRUCCIÓN DE INTESTINO POR BOLO ALIMENTARIO"
  },
  {
    "codigo":248877004,
    "descripcion":"TABIQUE VAGINAL"
  },
  {
    "codigo":936472381000119102,
    "descripcion":"TUMOR NEUROENDOCRINO BIEN DIFERENCIADO GRADO 1 DE PULMÓN IZQUIERDO"
  },
  {
    "codigo":1230082002,
    "descripcion":"PATRÓN DE USO NOCIVO DE PSICOESTIMULANTE SIN DEPENDENCIA, EN REMISIÓN"
  },
  {
    "codigo":250376006,
    "descripcion":"RH NEGATIVO DU POSITIVO"
  },
  {
    "codigo":441815006,
    "descripcion":"GLOMERULONEFRITIS PROLIFERATIVA"
  },
  {
    "codigo":210604001,
    "descripcion":"LESIÓN POR DESOLLAMIENTO DE PULGAR"
  },
  {
    "codigo":734892004,
    "descripcion":"SEPARACIÓN DE DIENTES POSTERIORES INFERIORES"
  },
  {
    "codigo":308908006,
    "descripcion":"ÚLCERA DE LA ESPINILLA"
  },
  {
    "codigo":472748007,
    "descripcion":"DRENAJE DE SENO CORONARIO A AURÍCULA VENOSA SISTÉMICA CONSTRUIDO QUIRÚRGICAMENTE"
  },
  {
    "codigo":700289000,
    "descripcion":"ENTROPIÓN SENIL DE PÁRPADO SUPERIOR"
  },
  {
    "codigo":1083351000119100,
    "descripcion":"INFLAMACIÓN CRÓNICA DE AMBAS MEMBRANAS TIMPÁNICAS"
  },
  {
    "codigo":46764007,
    "descripcion":"PREECLAMPSIA SEVERA"
  },
  {
    "codigo":307073004,
    "descripcion":"SE EXPRESA BURLONAMENTE"
  },
  {
    "codigo":208769007,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN ACROMIOCLAVICULAR"
  },
  {
    "codigo":43094000,
    "descripcion":"CONSONANTES DE PRESIÓN SUAVE"
  },
  {
    "codigo":403542008,
    "descripcion":"HAMARTOMA FIBROLIPOMATOSO DE NERVIO"
  },
  {
    "codigo":237867001,
    "descripcion":"AMILOIDOSIS CEREBROVASCULAR HEREDITARIA"
  },
  {
    "codigo":203264000,
    "descripcion":"TUBERCULOSIS DE LA COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":399872003,
    "descripcion":"RETINOPATÍA NO PROLIFERATIVA SEVERA CON EDEMA MACULAR CLÍNICAMENTE SIGNIFICATIVO DEBIDO A DIABETES MELLITUS"
  },
  {
    "codigo":236032006,
    "descripcion":"HERNIA UMBILICAL ESTRANGULADA"
  },
  {
    "codigo":301568007,
    "descripcion":"DIFICULTAD PARA MOVILIZARSE EN LUGARES ABIERTOS"
  },
  {
    "codigo":4821001,
    "descripcion":"CONTUSIÓN DE LA MEJILLA"
  },
  {
    "codigo":365269002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA USAR EL LAVARROPAS"
  },
  {
    "codigo":234197003,
    "descripcion":"POSICIÓN ANÓMALA DE INJERTO VASCULAR"
  },
  {
    "codigo":346071000119107,
    "descripcion":"RETINOPATÍA EXUDATIVA BILATERAL"
  },
  {
    "codigo":168661005,
    "descripcion":"RADIOGRAFÍA SIMPLE DE ARTICULACIÓN DE CADERA NORMAL"
  },
  {
    "codigo":15992791000119108,
    "descripcion":"EPISCLERITIS DE AMBOS OJOS CAUSADA POR MYCOBACTERIUM TUBERCULOSIS"
  },
  {
    "codigo":299733008,
    "descripcion":"HALLAZGO RELACIONADO CON LA MÉDULA ESPINAL"
  },
  {
    "codigo":37589009,
    "descripcion":"FORÚNCULO DE MUÑECA"
  },
  {
    "codigo":266965008,
    "descripcion":"PROBLEMAS POR RETIRO"
  },
  {
    "codigo":363434003,
    "descripcion":"NEOPLASIA MALIGNA DE TIMO"
  },
  {
    "codigo":232362005,
    "descripcion":"QUISTE DE LA CAVIDAD NASAL"
  },
  {
    "codigo":396202008,
    "descripcion":"MARGEN QUIRÚRGICO DE LA GRASA PERIRRENAL COMPROMETIDO POR NEOPLASIA MALIGNA"
  },
  {
    "codigo":296063007,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE LOPRAZOLAM"
  },
  {
    "codigo":1151008,
    "descripcion":"CONSTRICCIÓN DEL CAMPO VISUAL"
  },
  {
    "codigo":64852002,
    "descripcion":"DEFICIENCIA DE SARCOSINA DESHIDROGENASA"
  },
  {
    "codigo":32084004,
    "descripcion":"APENDICITIS RETROILEAL"
  },
  {
    "codigo":294228005,
    "descripcion":"ALERGIA A ATRACURIO"
  },
  {
    "codigo":63017000,
    "descripcion":"MOTILIDAD GÁSTRICA NORMAL"
  },
  {
    "codigo":195924009,
    "descripcion":"GRIPE CON FARINGITIS"
  },
  {
    "codigo":95785004,
    "descripcion":"NISTAGMO POSICIONAL"
  },
  {
    "codigo":292393008,
    "descripcion":"REACCIÓN ADVERSA A LA CLORPROMAZINA"
  },
  {
    "codigo":225022000,
    "descripcion":"ADAPTACIÓN A LA PÉRDIDA POSTERIOR AL DUELO"
  },
  {
    "codigo":28414003,
    "descripcion":"HIPOVITAMINOSIS A CON XERODERMIA"
  },
  {
    "codigo":16703601000119109,
    "descripcion":"DÉFICIT DE MEMORIA DEBIDO A HEMORRAGIA SUBARACNOIDEA ESPONTÁNEA Y POSTERIOR A ELLA"
  },
  {
    "codigo":319601000119109,
    "descripcion":"ARTRITIS REACTIVA DE MANO DERECHA"
  },
  {
    "codigo":126718007,
    "descripcion":"NEOPLASIA DEL LÓBULO INFERIOR IZQUIERDO DEL PULMÓN"
  },
  {
    "codigo":290558008,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR PROXIMETACAÍNA"
  },
  {
    "codigo":124883001,
    "descripcion":"TRASTORNO DEL CAROTENO"
  },
  {
    "codigo":93950007,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA RÓTULA"
  },
  {
    "codigo":92115005,
    "descripcion":"NEOPLASIA BENIGNA DE SENO FRONTAL"
  },
  {
    "codigo":254120004,
    "descripcion":"DISPLASIA CON DENSIDAD ÓSEA AUMENTADA"
  },
  {
    "codigo":348581000119100,
    "descripcion":"ATROFIA ÓPTICA PARCIAL DE OJO IZQUIERDO"
  },
  {
    "codigo":88445007,
    "descripcion":"BANDAS MUSCULARES ANÓMALAS DEL VENTRÍCULO DERECHO"
  },
  {
    "codigo":11817381000119102,
    "descripcion":"ESGUINCE DE LIGAMENTO DE ARTICULACIÓN CARPOMETACARPIANA DE MANO IZQUIERDA"
  },
  {
    "codigo":709202001,
    "descripcion":"NEOPLASIA DE ARTICULACIÓN SACROILÍACA"
  },
  {
    "codigo":285053009,
    "descripcion":"CAPAZ DE USAR AUDÍFONO"
  },
  {
    "codigo":217682003,
    "descripcion":"ENVENENAMIENTO DEBIDO A PICADURA DE ORUGA"
  },
  {
    "codigo":86610004,
    "descripcion":"SECUENCIA DE DISPLASIA FRONTONASAL"
  },
  {
    "codigo":53842005,
    "descripcion":"DEFORMIDAD EN VALGO CONGÉNITA DEL DEDO GORDO"
  },
  {
    "codigo":447058001,
    "descripcion":"NÓDULO NECRÓTICO SOLITARIO DE HÍGADO"
  },
  {
    "codigo":283218008,
    "descripcion":"ANZUELO EN LA RODILLA"
  },
  {
    "codigo":707367000,
    "descripcion":"HEMANGIOMA ESCLEROSANTE MÚLTIPLE DE PULMÓN"
  },
  {
    "codigo":248615003,
    "descripcion":"SONIDOS DE LA VÍA AÉREA PRINCIPAL"
  },
  {
    "codigo":84775005,
    "descripcion":"OSTEONECROSIS AGUDA"
  },
  {
    "codigo":838439008,
    "descripcion":"MOVIMIENTO DE ARTICULACIÓN CONTRA RESISTENCIA"
  },
  {
    "codigo":246780000,
    "descripcion":"MOVIMIENTOS OCULARES IRREGULARES"
  },
  {
    "codigo":212177000,
    "descripcion":"LESIÓN TOTAL DE LA MÉDULA DORSAL, SIN LESIÓN ÓSEA, D7-12"
  },
  {
    "codigo":1197052008,
    "descripcion":"SÍNDROME DE DEPLECIÓN DE ÁCIDO DESOXIRRIBONUCLEICO MITOCONDRIAL FORMA ENCEFALOMIOPÁTICA CON ACIDURIA METILMALÓNICA"
  },
  {
    "codigo":184741000119107,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE ANO"
  },
  {
    "codigo":16050751000119101,
    "descripcion":"TRASTORNO DE ARTICULACIÓN GLENOHUMERAL IZQUIERDA POSTERIOR A ADMINISTRACIÓN DE VACUNA"
  },
  {
    "codigo":48337000,
    "descripcion":"ESTRECHEZ CONGÉNITA DEL MEATO URINARIO"
  },
  {
    "codigo":1162449005,
    "descripcion":"ERITEMA TÓXICO NEONATAL"
  },
  {
    "codigo":210342003,
    "descripcion":"HERIDA ABIERTA EN LA FRENTE"
  },
  {
    "codigo":10644031000119103,
    "descripcion":"ÚLCERA VARICOSA DE PIERNA IZQUIERDA"
  },
  {
    "codigo":46502006,
    "descripcion":"HEMATOMA DE VAGINA DURANTE EL PARTO"
  },
  {
    "codigo":110203001,
    "descripcion":"QUEMADURA DE PRIMER GRADO DEL VESTÍBULO MANDIBULAR"
  },
  {
    "codigo":306811002,
    "descripcion":"VISTO POR SERVICIO PARA JÓVENES DISCAPACITADOS"
  },
  {
    "codigo":322111000119104,
    "descripcion":"SUBLUXACIÓN COMPLEJA DE VÉRTEBRA CERVICAL"
  },
  {
    "codigo":763728000,
    "descripcion":"LABIO LEPORINO DERECHO COMPLETO Y FISURA ALVEOLAR DERECHA COMPLETA"
  },
  {
    "codigo":370512004,
    "descripcion":"MIGRACIÓN DE IMPLANTE O DE DISPOSITIVO INTERNO"
  },
  {
    "codigo":698192005,
    "descripcion":"RESORCIÓN CERVICAL EXTERNA INVASIVA DE DIENTE"
  },
  {
    "codigo":1288016006,
    "descripcion":"ARTROSIS SECUNDARIA DE MANO"
  },
  {
    "codigo":403280008,
    "descripcion":"POLIONIQUIA"
  },
  {
    "codigo":1220645000,
    "descripcion":"SHOCK DEBIDO A INTERRUPCIÓN COMPLETA INDUCIDA DE EMBARAZO Y POSTERIOR A ELLA"
  },
  {
    "codigo":172069000,
    "descripcion":"MENINGOCELE CONGÉNITO"
  },
  {
    "codigo":8229003,
    "descripcion":"RINITIS VASOMOTORA"
  },
  {
    "codigo":73765005,
    "descripcion":"TRASTORNO DEL NERVIO NEUMOGÁSTRICO"
  },
  {
    "codigo":792826006,
    "descripcion":"TODOS LOS PULSOS PRESENTES EN EL MIEMBRO INFERIOR IZQUIERDO"
  },
  {
    "codigo":235770006,
    "descripcion":"APENDICITIS SUPURATIVA AGUDA"
  },
  {
    "codigo":4559000,
    "descripcion":"ENFERMEDAD INFECCIOSA MIXTA"
  },
  {
    "codigo":301306007,
    "descripcion":"VESTIDO - ASPECTO"
  },
  {
    "codigo":299471001,
    "descripcion":"DEBILIDAD DEL PIE"
  },
  {
    "codigo":397775001,
    "descripcion":"MIEDO A TRANSPORTE"
  },
  {
    "codigo":233935004,
    "descripcion":"TROMBOEMBOLIA PULMONAR"
  },
  {
    "codigo":365007005,
    "descripcion":"HALLAZGO DE PATRÓN MIXTO DE CONDUCCIÓN NERVIOSA"
  },
  {
    "codigo":102863008,
    "descripcion":"CRISTAL URINARIO, FOSFATO AMÓNICO MAGNÉSICO"
  },
  {
    "codigo":789156003,
    "descripcion":"DISPLASIA DÉRMICA FACIAL FOCAL"
  },
  {
    "codigo":723620004,
    "descripcion":"REQUIERE VACUNACIÓN"
  },
  {
    "codigo":428708005,
    "descripcion":"PARASOMNIA SECUNDARIA"
  },
  {
    "codigo":2724004,
    "descripcion":"RECLUTAMIENTO AUDITIVO"
  },
  {
    "codigo":11819891000119100,
    "descripcion":"SUBLUXACIÓN DE ARTICULACIÓN RADIOCUBITAL DISTAL DERECHA"
  },
  {
    "codigo":263033000,
    "descripcion":"SUBLUXACIÓN RECURRENTE DE ARTICULACIÓN TEMPOROMANDIBULAR"
  },
  {
    "codigo":295801000,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE CICLOSPORINA"
  },
  {
    "codigo":230265002,
    "descripcion":"MAL DE ALZHEIMER FAMILIAR DE INICIO TEMPRANO"
  },
  {
    "codigo":426873000,
    "descripcion":"DEPENDENCIA DE METANFETAMINA"
  },
  {
    "codigo":232100005,
    "descripcion":"ESOTROPÍA RESIDUAL"
  },
  {
    "codigo":721785008,
    "descripcion":"INFECCIÓN CAUSADA POR COLTAVIRUS"
  },
  {
    "codigo":719950001,
    "descripcion":"SÍNDROME DE PULGAR TRIFALÁNGICO Y POLISINDACTILIA"
  },
  {
    "codigo":31822004,
    "descripcion":"URETRITIS"
  },
  {
    "codigo":293966007,
    "descripcion":"ALERGIA A BETAXOLOL"
  },
  {
    "codigo":292131000,
    "descripcion":"REACCIÓN ADVERSA A LA NABILONA"
  },
  {
    "codigo":195662009,
    "descripcion":"FARINGITIS VIRAL AGUDA"
  },
  {
    "codigo":228430009,
    "descripcion":"SIGUE RITUALES RELACIONADOS CON EL CONSUMO DE DROGAS"
  },
  {
    "codigo":1142264003,
    "descripcion":"HIPERTROFIA DE MÚSCULO DE BRAZO"
  },
  {
    "codigo":716280004,
    "descripcion":"DUPLICACIÓN TUBULAR CONGÉNITA DE ESÓFAGO"
  },
  {
    "codigo":191992009,
    "descripcion":"RUTINAS REPETITIVAS"
  },
  {
    "codigo":419533001,
    "descripcion":"REFLEJO MASIVO AUSENTE"
  },
  {
    "codigo":124621004,
    "descripcion":"DEFICIENCIA DE ENOILO - COA HIDRATASA"
  },
  {
    "codigo":188322004,
    "descripcion":"NEOPLASIA MALIGNA DE NERVIOS PERIFÉRICOS DE CABEZA, CARA Y CUELLO"
  },
  {
    "codigo":1204130006,
    "descripcion":"DEFECTO DEL TABIQUE INTERVENTRICULAR PERIMEMBRANOSO BASAL CENTRAL"
  },
  {
    "codigo":417698008,
    "descripcion":"EXTENSIÓN ESFENOBASILAR"
  },
  {
    "codigo":448631009,
    "descripcion":"CONEXIÓN DE VENA CAVA INFERIOR DERECHA A AURÍCULA DEL LADO IZQUIERDO"
  },
  {
    "codigo":86348002,
    "descripcion":"ENDOCARDITIS MICÓTICA"
  },
  {
    "codigo":426120002,
    "descripcion":"DOLOR PROVOCADO POR REPOSO"
  },
  {
    "codigo":414028007,
    "descripcion":"TRASTORNO DEL SISTEMA HEMATOPOYÉTICO EN EL RECIÉN NACIDO"
  },
  {
    "codigo":282956009,
    "descripcion":"SE ENDEREZA"
  },
  {
    "codigo":1264161008,
    "descripcion":"SALPINGOOFORITIS POSTERIOR A EMBARAZO ECTÓPICO"
  },
  {
    "codigo":444961009,
    "descripcion":"DEFECTO DEL TABIQUE AURICULOVENTRICULAR CON ORIFICIO AURICULOVENTRICULAR COMÚN"
  },
  {
    "codigo":17142008,
    "descripcion":"AUSENCIA CONGÉNITA DE ÚTERO"
  },
  {
    "codigo":1293259005,
    "descripcion":"MELANOCITOMA PENETRANTE PROFUNDO"
  },
  {
    "codigo":408523007,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: HAKKA"
  },
  {
    "codigo":57907009,
    "descripcion":"EDAD GESTACIONAL, 36 SEMANAS"
  },
  {
    "codigo":111776002,
    "descripcion":"EFECTO TÓXICO DE HIDROCARBURO GASEOSO"
  },
  {
    "codigo":46240005,
    "descripcion":"DERMATITIS DE CONTACTO CAUSADA POR CAUCHO"
  },
  {
    "codigo":898208007,
    "descripcion":"INSUFICIENCA CARDÍACA POR TIROTOXICOSIS"
  },
  {
    "codigo":109941002,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LOS NERVIOS PERIFÉRICOS DEL TÓRAX"
  },
  {
    "codigo":77173005,
    "descripcion":"OSTEOCONDROSIS JUVENIL DEL ASTRÁGALO"
  },
  {
    "codigo":511452481000119102,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DEBIDO A TROMBOSIS DE ARTERIA VERTEBRAL DERECHA"
  },
  {
    "codigo":239178001,
    "descripcion":"NEUROMA CICATRIZAL"
  },
  {
    "codigo":42570001,
    "descripcion":"PRURITO SENIL"
  },
  {
    "codigo":271946002,
    "descripcion":"GRANULACIONES DE CAVIDAD MASTOIDEA"
  },
  {
    "codigo":10757441000119102,
    "descripcion":"CARDIOPATÍA HIPERTENSIVA PREEXISTENTE EN LA MADRE QUE COMPLICA EL NACIMIENTO"
  },
  {
    "codigo":697930002,
    "descripcion":"HIPERTENSIÓN LÁBIL POR ESTAR EN UN ENTORNO CLÍNICO"
  },
  {
    "codigo":208245009,
    "descripcion":"FRACTURA NO EXPUESTA DE HÚMERO PROXIMAL, TRES PARTES"
  },
  {
    "codigo":353601000119103,
    "descripcion":"CARCINOMA IN SITU DE BRONQUIO Y PULMÓN IZQUIERDOS"
  },
  {
    "codigo":102344001000119102,
    "descripcion":"SÍNDROME DE DEHISCENCIA DE CONDUCTO SEMICIRCULAR SUPERIOR DE OÍDO DERECHO"
  },
  {
    "codigo":237343001,
    "descripcion":"FLEBITIS EN PUERPERIO"
  },
  {
    "codigo":9802006,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE NALGA CON INFECCIÓN"
  },
  {
    "codigo":40735006,
    "descripcion":"QUERATINIZACIÓN ANORMAL DE LA MATRIZ UNGUEAL"
  },
  {
    "codigo":1187615007,
    "descripcion":"SÍNDROME DE TROMBOCITOPENIA, ANASARCA, FIEBRE, INSUFICIENCIA RENAL Y ORGANOMEGALIA"
  },
  {
    "codigo":310451009,
    "descripcion":"INFORME DE SEGURO DE VIDA SOLICITADO"
  },
  {
    "codigo":204575008,
    "descripcion":"AUSENCIA CONGÉNITA DE FISURAS PULMONARES"
  },
  {
    "codigo":302879007,
    "descripcion":"TROMBOFLEBITIS SÉPTICA DE SENO CAVERNOSO"
  },
  {
    "codigo":6132001,
    "descripcion":"QUEMADURA DE MUSLO"
  },
  {
    "codigo":268276007,
    "descripcion":"EXOSTOSIS CONGÉNITA"
  },
  {
    "codigo":366580008,
    "descripcion":"AMPLITUD DE MOVIMIENTO PASIVO DE ROTACIÓN EXTERNA DE LA CADERA - HALLAZGO"
  },
  {
    "codigo":299209001,
    "descripcion":"ARTICULACIÓN DEL PULGAR HELADA AL TACTO"
  },
  {
    "codigo":233673002,
    "descripcion":"BRONQUIOLITIS OBLITERANTE MEDICAMENTOSA"
  },
  {
    "codigo":169972009,
    "descripcion":"ALIMENTADO ARTIFICIALMENTE A LAS 6 SEMANAS"
  },
  {
    "codigo":397513003,
    "descripcion":"ORZUELO"
  },
  {
    "codigo":102601005,
    "descripcion":"ENTUMECIMIENTO PERIORAL"
  },
  {
    "codigo":11822401000119108,
    "descripcion":"DESGARRO ANTEROPOSTERIOR DE RODETE GLENOIDEO SUPERIOR DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":364745009,
    "descripcion":"RELACIÓN ENTRE EL TAMAÑO FETAL Y LA EDAD GESTACIONAL - HALLAZGO"
  },
  {
    "codigo":1090881000119109,
    "descripcion":"MEMBRANA TIMPÁNICA DERECHA ATRÓFICA NO FLÁCIDA"
  },
  {
    "codigo":67998006,
    "descripcion":"CONTRACCIÓN Y RELAJACIÓN PERISTÁLTICAS DEL INTESTINO DELGADO"
  },
  {
    "codigo":788894007,
    "descripcion":"CONTUSIÓN DE VASO SANGUÍNEO DE PULGAR"
  },
  {
    "codigo":231838008,
    "descripcion":"OBSTRUCCIÓN TOTAL DEL PUNTO LAGRIMAL"
  },
  {
    "codigo":721523001,
    "descripcion":"SÍNDROME DE BROWN-SEQUARD DE MÉDULA ESPINAL LUMBAR"
  },
  {
    "codigo":295539002,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE ISOFLURANO"
  },
  {
    "codigo":262771005,
    "descripcion":"DESGARRO DE CONDUCTO SALIVAL"
  },
  {
    "codigo":426611007,
    "descripcion":"INSUFICIENCIA CARDÍACA CONGESTIVA DEBIDA A ENFERMEDAD VALVULAR"
  },
  {
    "codigo":361075009,
    "descripcion":"DEFICIENCIA DE PROTEINASA NEUTRA RIBOSOMAL"
  },
  {
    "codigo":719688002,
    "descripcion":"DISPLASIA EPIFISARIA MÚLTIPLE TIPO AL-GAZALI"
  },
  {
    "codigo":129864005,
    "descripcion":"CONOCIMIENTOS ESCASOS ACERCA DE LOS PROCESOS PATOLÓGICOS"
  },
  {
    "codigo":816157002,
    "descripcion":"HEMATOMA SUBUNGUEAL DE SEGUNDO A QUINTO DEDOS DE PIE"
  },
  {
    "codigo":422941005,
    "descripcion":"ÁREA DE EJERCICIOS INSEGURA"
  },
  {
    "codigo":291869009,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR GONADOTROFINA"
  },
  {
    "codigo":93426003,
    "descripcion":"ALTERACIÓN DE LA COLORACIÓN DEL HÍGADO"
  },
  {
    "codigo":224498006,
    "descripcion":"VIVE CON CUIDADOR"
  },
  {
    "codigo":124359001,
    "descripcion":"DEFICIENCIA DE COLINAFOSFOTRANSFERASA"
  },
  {
    "codigo":60658009,
    "descripcion":"ESTENOSIS DEL RECTO"
  },
  {
    "codigo":288199005,
    "descripcion":"DIARREA Y VÓMITOS LUEGO DE CIRUGÍA DEL TRACTO GASTROINTESTINAL"
  },
  {
    "codigo":188060000,
    "descripcion":"MELANOMA MALIGNO DE HOMBRO"
  },
  {
    "codigo":384668003,
    "descripcion":"NO ES POSIBLE DETERMINAR EL GRADO COMBINADO DE NOTTINGHAM"
  },
  {
    "codigo":253596003,
    "descripcion":"SÍNDROME DE AUSENCIA DE VÁLVULA PULMONAR"
  },
  {
    "codigo":683791000119100,
    "descripcion":"EPENDIMOMA PRIMARIO DE LÓBULO PARIETAL"
  },
  {
    "codigo":286364008,
    "descripcion":"UTILIZA EL LENGUAJE"
  },
  {
    "codigo":284529003,
    "descripcion":"CAQUEXIA DE CAUSA CARDÍACA"
  },
  {
    "codigo":186225008,
    "descripcion":"TUBERCULOSIS DE INTESTINOS, PERITONEO Y GANGLIOS MESENTÉRICOS"
  },
  {
    "codigo":53318002,
    "descripcion":"ESPINA BÍFIDA CON HIDROCEFALIA"
  },
  {
    "codigo":249926003,
    "descripcion":"SEUDOBLOQUEO ARTICULAR"
  },
  {
    "codigo":315462006,
    "descripcion":"NACIDO EN LATVIA"
  },
  {
    "codigo":282694007,
    "descripcion":"DIFICULTAD PARA EMPUJAR Y ARRASTRAR HACIA ADELANTE UN JUGUETE GRANDE CON RUEDAS"
  },
  {
    "codigo":1296667001,
    "descripcion":"ESTREÑIMIENTO AGUDO EN PERÍODO DE LACTANCIA"
  },
  {
    "codigo":870683003,
    "descripcion":"DIFICULTAD PARA UTILIZAR COMUNICACIÓN CON AUMENTATIVOS Y COMUNICACIÓN ALTERNATIVA"
  },
  {
    "codigo":248091009,
    "descripcion":"DESEO DE CONVERTIRSE EN UN MIEMBRO DEL SEXO OPUESTO"
  },
  {
    "codigo":82416002,
    "descripcion":"AMPOLLA DE MEJILLA, SIN INFECCIÓN"
  },
  {
    "codigo":16880001,
    "descripcion":"INFECCIÓN CAUSADA POR ALARIA"
  },
  {
    "codigo":705008001,
    "descripcion":"ELEVACIÓN ANTERIOR DE SEGMENTO ST"
  },
  {
    "codigo":311792005,
    "descripcion":"INFARTO MIOCÁRDICO TRANSMURAL DE PARED ANTERIOR, POSQUIRÚRGICO"
  },
  {
    "codigo":770544009,
    "descripcion":"HIPOPLASIA CONGÉNITA DE TODA LA EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":16002831000119107,
    "descripcion":"DOLOR EN MIEMBRO INFERIOR IZQUIERDO CONCOMITANTE CON ISQUEMIA Y DEBIDO A ELLA"
  },
  {
    "codigo":277189006,
    "descripcion":"POLIRRADICULONEUROPATÍA DESMIELINIZANTE INFLAMATORIA SUBAGUDA"
  },
  {
    "codigo":703173008,
    "descripcion":"FALLA DE PRÓTESIS DE VÁLVULA AÓRTICA QUE REQUIERE REEMPLAZO"
  },
  {
    "codigo":1260229008,
    "descripcion":"CICATRIZ DE PIEL DE LABIO SUPERIOR"
  },
  {
    "codigo":766874001,
    "descripcion":"DISPLASIA CONO ESPONDILAR"
  },
  {
    "codigo":275354003,
    "descripcion":"DEFORMIDAD EN PRONACIÓN DEL PIE"
  },
  {
    "codigo":209818005,
    "descripcion":"DESGARRO COMPLETO, LIGAMENTO LUMBOSACRO"
  },
  {
    "codigo":373658006,
    "descripcion":"CONDUCTA OBSESIVA"
  },
  {
    "codigo":111514006,
    "descripcion":"GLAUCOMA POR PSEUDOEXFOLIACIÓN"
  },
  {
    "codigo":240751001,
    "descripcion":"LOBOMICOSIS CUTÁNEA COALESCENTE CRÓNICA"
  },
  {
    "codigo":11375002,
    "descripcion":"MICRONIQUIA"
  },
  {
    "codigo":207983003,
    "descripcion":"FRACTURA DE LA PRIMERA VÉRTEBRA CERVICAL"
  },
  {
    "codigo":329641000119104,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DEBIDO A TROMBO DE ARTERIA BASILAR"
  },
  {
    "codigo":371823002,
    "descripcion":"PACIENTE LUEGO DE ANGIOPLASTIA"
  },
  {
    "codigo":109679005,
    "descripcion":"LUXACIÓN DENTAL INTRUSIVA"
  },
  {
    "codigo":1354863007,
    "descripcion":"SÍNDROME DE DOLOR PÉLVICO PRIMARIO CRÓNICO MASCULINO"
  },
  {
    "codigo":76911006,
    "descripcion":"FRACTURA EXPUESTA DEL ISQUION"
  },
  {
    "codigo":15730601000119105,
    "descripcion":"ESOTROPÍA NO ACOMODATIVA DE OJO DERECHO"
  },
  {
    "codigo":402756002,
    "descripcion":"ANORMALIDAD DEL PELO INDUCIDA POR FÁRMACOS"
  },
  {
    "codigo":763204003,
    "descripcion":"DEFECTO COMBINADO DE LA FOSFORILACIÓN OXIDATIVA TIPO 7"
  },
  {
    "codigo":75076004,
    "descripcion":"AMIELENCÉFALO"
  },
  {
    "codigo":271684005,
    "descripcion":"RUIDOS HIDROAÉREOS TINTINEANTES"
  },
  {
    "codigo":1254724005,
    "descripcion":"METÁSTASIS DE CARCINOMA ADENOIDE QUÍSTICO EN OROFARINGE"
  },
  {
    "codigo":1156420003,
    "descripcion":"TUMOR DESMOPLÁSICO DE CÉLULAS REDONDAS PEQUEÑAS"
  },
  {
    "codigo":238916002,
    "descripcion":"PAPILOMA HIRSUTOIDE DEL PENE"
  },
  {
    "codigo":1285657001,
    "descripcion":"ENFERMEDAD POR DEFICIENCIA DE FACTOR VIII HEREDITARIA GRAVE CON INHIBIDOR DE ALTA RESPUESTA"
  },
  {
    "codigo":73241006,
    "descripcion":"HEMATOPOYESIS ANORMAL"
  },
  {
    "codigo":7705008,
    "descripcion":"ESPÉCIMEN INADECUADO PARA EVALUACIÓN HORMONAL"
  },
  {
    "codigo":106009009,
    "descripcion":"ENFERMEDAD FETAL QUE AFECTA EL CUIDADO OBSTÉTRICO DE LA MADRE"
  },
  {
    "codigo":38638004,
    "descripcion":"TRANSLUCIDEZ AUMENTADA"
  },
  {
    "codigo":11771971000119103,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA POSTERIOR DE ARTICULACIÓN DE CODO IZQUIERDO"
  },
  {
    "codigo":300782004,
    "descripcion":"PARTICIPA EN JUEGOS POR DIVERSIÓN"
  },
  {
    "codigo":202478007,
    "descripcion":"DOLOR DE ARTICULACIÓN ESTERNOCLAVICULAR"
  },
  {
    "codigo":366318009,
    "descripcion":"REACCIÓN DE ÁCIDO ACÉTICO - HALLAZGO"
  },
  {
    "codigo":724931002,
    "descripcion":"LESIÓN TRAUMÁTICA DE FASCIA DE TRÍCEPS BRAQUIAL"
  },
  {
    "codigo":723096000,
    "descripcion":"GASTRITIS CAUSADA POR BACTERIA"
  },
  {
    "codigo":1149080001,
    "descripcion":"ACTITUD POSITIVA HACIA EL CUIDADO"
  },
  {
    "codigo":67736002,
    "descripcion":"ESPÉCIMEN MAL FIJADO"
  },
  {
    "codigo":36803009,
    "descripcion":"EPILEPSIA GENERALIZADA IDIOPÁTICA"
  },
  {
    "codigo":788632005,
    "descripcion":"LÉNTIGO DE LABIO"
  },
  {
    "codigo":460952008,
    "descripcion":"ANOMALÍA DE LIGAMENTO ARTERIOSO"
  },
  {
    "codigo":198808008,
    "descripcion":"INTENTO FALLIDO DE ABORTO CON LESIÓN DE ÓRGANOS O TEJIDOS PÉLVICOS"
  },
  {
    "codigo":229741002,
    "descripcion":"DESARROLLO LIMITADO DEL LENGUAJE"
  },
  {
    "codigo":303171000119107,
    "descripcion":"TENDINITIS CALCIFICANTE DE MANO IZQUIERDA"
  },
  {
    "codigo":721261004,
    "descripcion":"INFLAMACIÓN DE NERVIO ÓPTICO CAUSADA POR INFECCIÓN"
  },
  {
    "codigo":295277007,
    "descripcion":"SOBREDOSIS INTENCIONAL DE NAPROXENO"
  },
  {
    "codigo":11853891000119109,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DE PIE DERECHO"
  },
  {
    "codigo":94999000,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE FALANGE DEL PIE"
  },
  {
    "codigo":129602009,
    "descripcion":"PSICOSIS SIMBIÓTICA DE LA INFANCIA"
  },
  {
    "codigo":293442008,
    "descripcion":"REACCIÓN ADVERSA A LA FLECAINIDA"
  },
  {
    "codigo":686301000119104,
    "descripcion":"HISTIOCITOMA FIBROSO MALIGNO PRIMARIO DE PARTES BLANDAS DE CARA"
  },
  {
    "codigo":422679002,
    "descripcion":"SEMINOMA DE TESTÍCULO, ESTADIO 3"
  },
  {
    "codigo":291607006,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR CEFIXIMA"
  },
  {
    "codigo":1010668008,
    "descripcion":"SÍNDROME DE STICKLER TIPO 1"
  },
  {
    "codigo":289772009,
    "descripcion":"HALLAZGO RELACIONADO CON LA CONSISTENCIA DEL CUELLO UTERINO"
  },
  {
    "codigo":58561002,
    "descripcion":"DISPLASIA DIASTRÓFICA"
  },
  {
    "codigo":86391000119101,
    "descripcion":"DEPENDENCIA DE INHALANTE VOLÁTIL, CONTINUA"
  },
  {
    "codigo":224236009,
    "descripcion":"NO APTO PARA RECIBIR ALOJAMIENTO"
  },
  {
    "codigo":255169005,
    "descripcion":"PÓLIPO ESOFÁGICO BENIGNO"
  },
  {
    "codigo":286102004,
    "descripcion":"NO LIMPIA UNA HABITACIÓN"
  },
  {
    "codigo":251499000,
    "descripcion":"ACTIVIDAD DELTA RÍTMICA INTERMITENTE FRONTAL"
  },
  {
    "codigo":187798008,
    "descripcion":"NEOPLASIA MALIGNA DE TEJIDO PANCREÁTICO ECTÓPICO"
  },
  {
    "codigo":284267001,
    "descripcion":"NO UTILIZA PRENSIÓN PALMAR"
  },
  {
    "codigo":23958009,
    "descripcion":"DISTROFIA PULMONAR PROGRESIVA"
  },
  {
    "codigo":10899831000119105,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO MOTOR OCULAR EXTERNO IZQUIERDO"
  },
  {
    "codigo":184128000,
    "descripcion":"ES CUESTIONABLE SI EL TÍTULO DEL PACIENTE ES CORRECTO"
  },
  {
    "codigo":35831000175106,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN EN TALÓN ESTADIO I"
  },
  {
    "codigo":315200003,
    "descripcion":"TOXOPLASMA DETECTADO MEDIANTE REACCIÓN EN CADENA DE LA POLIMERASA"
  },
  {
    "codigo":249664004,
    "descripcion":"DESCENSO PERINEAL"
  },
  {
    "codigo":282432002,
    "descripcion":"DESGARRO DE CONDUCTO BILIAR"
  },
  {
    "codigo":10171000132106,
    "descripcion":"SÍNTOMAS PSICOLÓGICOS Y DE COMPORTAMIENTO DE DEMENCIA"
  },
  {
    "codigo":247829002,
    "descripcion":"MIEDO A LAS CALLES VACÍAS"
  },
  {
    "codigo":51221005,
    "descripcion":"DERMATITIS DE CONTACTO CRÓNICA"
  },
  {
    "codigo":1263637005,
    "descripcion":"TRASTORNO FETAL DEBIDO A TAMAÑO Y DESPROPORCIÓN DE PELVIS DURANTE TRABAJO DE PARTO"
  },
  {
    "codigo":10735991000119108,
    "descripcion":"COMPLICACIÓN DE FERTILIZACIÓN ARTIFICIAL"
  },
  {
    "codigo":305681000119102,
    "descripcion":"QUISTE DE ASTA ANTERIOR DE MENISCO INTERNO DE RODILLA IZQUIERDA"
  },
  {
    "codigo":870421009,
    "descripcion":"EDEMA MACULAR CISTOIDE DEBIDO A DIABETES MELLITUS"
  },
  {
    "codigo":16618004,
    "descripcion":"GAMMAPATÍA POLICLONAL"
  },
  {
    "codigo":49386006,
    "descripcion":"DISCINESIA OROFACIAL"
  },
  {
    "codigo":1163498006,
    "descripcion":"GASTRITIS MICOBACTERIANA"
  },
  {
    "codigo":735679005,
    "descripcion":"CONDROSARCOMA PRIMARIO DE HUESO"
  },
  {
    "codigo":14783006,
    "descripcion":"HIPERBILIRRUBINEMIA"
  },
  {
    "codigo":111252006,
    "descripcion":"INFECCIÓN DE HUESO ASOCIADA CON OTRA ENFERMEDAD"
  },
  {
    "codigo":16745131000119100,
    "descripcion":"RETINOPATÍA DIABÉTICA NO PROLIFERATIVA DE OJO IZQUIERDO DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":699241002,
    "descripcion":"TRASTORNO DE ESTRÉS POSTRAUMÁTICO CRÓNICO DESPUÉS DE COMBATE MILITAR"
  },
  {
    "codigo":43881003,
    "descripcion":"INTOXICACIÓN POR EPN"
  },
  {
    "codigo":109417006,
    "descripcion":"CRANEOSINOSTOSIS PARIETOCCIPITAL"
  },
  {
    "codigo":76649007,
    "descripcion":"QUISTE SEBÁCEO DE PIEL DE MAMA"
  },
  {
    "codigo":371561008,
    "descripcion":"LESIÓN DE RAÍZ NERVIOSA DORSAL"
  },
  {
    "codigo":1354601009,
    "descripcion":"FRACTURA DE FALANGE DISTAL DE DEDO ÍNDICE"
  },
  {
    "codigo":369726002,
    "descripcion":"G3: MÁS DE 50 POR CIENTO DE CRECIMIENTO SÓLIDO NO ESCAMOSO"
  },
  {
    "codigo":402494003,
    "descripcion":"CARCINOMA BASOCELULAR DE PÁRPADO INFERIOR"
  },
  {
    "codigo":74814004,
    "descripcion":"CONTUSIÓN DEL PIE"
  },
  {
    "codigo":238654004,
    "descripcion":"LIQUEN PLANO DE LOCALIZACIÓN ESPECÍFICA"
  },
  {
    "codigo":236819000,
    "descripcion":"TRASTORNO DEL COITO"
  },
  {
    "codigo":72979001,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE MAMA, SIN INFECCIÓN"
  },
  {
    "codigo":47411000087102,
    "descripcion":"ABRASIÓN DE REGIÓN DE OJO DERECHO"
  },
  {
    "codigo":171283008,
    "descripcion":"SIN CONSENTIMIENTO PARA NINGUNA INMUNIZACIÓN PRIMARIA"
  },
  {
    "codigo":42291000087105,
    "descripcion":"BAROTRAUMA ÓTICO DE OÍDO DERECHO"
  },
  {
    "codigo":39731000087106,
    "descripcion":"LUXACIÓN DE ARTICULACIÓN DE DEDO ÍNDICE DE MANO IZQUIERDA"
  },
  {
    "codigo":366056003,
    "descripcion":"HALLAZGO RELACIONADO CON LA CALIDAD DE LA IMAGEN VISUAL"
  },
  {
    "codigo":234984001,
    "descripcion":"MANCHADO DENTARIO INTRÍNSECO - DIENTE NO VITAL"
  },
  {
    "codigo":44851000087107,
    "descripcion":"INFARTO AGUDO DE MIOCARDIO CON ELEVACIÓN DE SEGMENTO ST DEBIDO A OCLUSIÓN DE SEGMENTO PROXIMAL DE RAMA CIRCUNFLEJA DE ARTERIA CORONARIA IZQUIERDA"
  },
  {
    "codigo":300520007,
    "descripcion":"LESIÓN DE PREPUCIO"
  },
  {
    "codigo":429757000,
    "descripcion":"LUXACIÓN RECURRENTE DE PRÓTESIS DE CADERA"
  },
  {
    "codigo":688811000119107,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE CARA DORSAL DE LA LENGUA"
  },
  {
    "codigo":298685005,
    "descripcion":"SIGNO CON NOMBRE PROPIO DE LA COLUMNA"
  },
  {
    "codigo":724669005,
    "descripcion":"CONVULSIÓN CONCOMITANTE CON ABSTINENCIA DE HIPNÓTICO Y DEBIDA A ELLA"
  },
  {
    "codigo":296850000,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE INSULINA"
  },
  {
    "codigo":396989009,
    "descripcion":"TAMAÑO TUMORAL NO PUEDE SER DETERMINADO"
  },
  {
    "codigo":1279890001,
    "descripcion":"SÍNDROME DE DISFUNCIÓN MITOCONDRIAL MÚLTIPLE TIPO 5"
  },
  {
    "codigo":427922002,
    "descripcion":"ANQUILOSIS DE ARTICULACIÓN DE DEDO DE LA MANO"
  },
  {
    "codigo":722834005,
    "descripcion":"DISFUNCIÓN ANORRECTAL DEBIDA A PROLAPSO DE ÓRGANO PÉLVICO"
  },
  {
    "codigo":131175002,
    "descripcion":"CARBOXIHEMOGLOBINA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":334661000119104,
    "descripcion":"ASTIGMATISMO IRREGULAR DE OJO DERECHO"
  },
  {
    "codigo":426087004,
    "descripcion":"ENDOCARDITIS POR STAPHYLOCOCCUS AUREUS DEL LADO DERECHO"
  },
  {
    "codigo":1343591005,
    "descripcion":"ÚLCERA NEUROPÁTICA DE MUSLO"
  },
  {
    "codigo":719164000,
    "descripcion":"CALCIFICACIÓN TALÁMICA SIMÉTRICA"
  },
  {
    "codigo":16636741000119106,
    "descripcion":"LESIÓN BILATERAL DE NERVIOS RADIALES"
  },
  {
    "codigo":422417001,
    "descripcion":"VISIÓN A DISTANCIA 20\/200"
  },
  {
    "codigo":10630111000119101,
    "descripcion":"LINFANGITIS AGUDA DE REGIÓN DE TOBILLO DERECHO"
  },
  {
    "codigo":1208849004,
    "descripcion":"FENÓMENO DE RAYNAUD POR ENFERMEDAD AUTOINMUNITARIA"
  },
  {
    "codigo":291345004,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR DIFENILPIRALINA"
  },
  {
    "codigo":225809007,
    "descripcion":"SOBREPROTEGIDO POR LA MADRE"
  },
  {
    "codigo":308191000119102,
    "descripcion":"DEFORMIDAD EN FLEXIÓN DE ARTICULACIÓN DE RODILLA IZQUIERDA"
  },
  {
    "codigo":16036831000119102,
    "descripcion":"DETENCIÓN DE CRECIMIENTO EPIFISARIO DE FÉMUR DERECHO"
  },
  {
    "codigo":92902002,
    "descripcion":"FORMA ANORMAL CONGÉNITA DE CENTRO DE VÉRTEBRA SACRA"
  },
  {
    "codigo":717329009,
    "descripcion":"PSEUDOTUMOR INFLAMATORIO DE HÍGADO"
  },
  {
    "codigo":782865007,
    "descripcion":"EOSINOFILIA DE LÍQUIDO PERITONEAL"
  },
  {
    "codigo":387814004,
    "descripcion":"DEFICIENCIA DE PROTEINCINASA"
  },
  {
    "codigo":27366005,
    "descripcion":"ANEMIA MEGALOBLÁSTICA POR HEMODIÁLISIS"
  },
  {
    "codigo":94737008,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA PORCIÓN ANTERIOR DEL PISO DE LA BOCA"
  },
  {
    "codigo":125670008,
    "descripcion":"CUERPO EXTRAÑO EN ESTRUCTURA CORPORAL"
  },
  {
    "codigo":189371000,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LAS ENCÍAS"
  },
  {
    "codigo":289510007,
    "descripcion":"INFLAMACIÓN DEL CLÍTORIS"
  },
  {
    "codigo":123835006,
    "descripcion":"SATISFACTORIO PARA EVALUACIÓN, PERO LIMITADO POR PRESENCIA DE UNA SUSTANCIA CONTAMINANTE QUE ENMASCARA PARCIALMENTE EL RESULTADO"
  },
  {
    "codigo":285840007,
    "descripcion":"CON GRADO DE EDUCACIÓN GRAVEMENTE SUBNORMAL"
  },
  {
    "codigo":709989000,
    "descripcion":"ESQUEMA OCLUSAL DENTADO SEVERAMENTE COMPROMETIDO"
  },
  {
    "codigo":21861000,
    "descripcion":"CIRROSIS MICRONODULAR"
  },
  {
    "codigo":251237002,
    "descripcion":"ONDA T ELEVADA"
  },
  {
    "codigo":284005003,
    "descripcion":"LESIÓN TRAUMÁTICA DE CAVIDAD ABDOMINAL"
  },
  {
    "codigo":447845003,
    "descripcion":"VENTRÍCULO DERECHO POR DETRÁS DE VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":12104671000119108,
    "descripcion":"QUEMADURA QUÍMICA DE DORSO DE MANO IZQUIERDA"
  },
  {
    "codigo":314938000,
    "descripcion":"PATRÓN DE SUEÑO, DEFICITARIO"
  },
  {
    "codigo":11996281000119102,
    "descripcion":"NECROSIS DE MUÑÓN DE AMPUTACIÓN DE EXTREMIDAD SUPERIOR DERECHA"
  },
  {
    "codigo":20026002,
    "descripcion":"LUXACIÓN EXPUESTA DE EXTREMO PROXIMAL DE HUESO METACARPIANO"
  },
  {
    "codigo":282170008,
    "descripcion":"NO SUBE UNA COLINA"
  },
  {
    "codigo":773690008,
    "descripcion":"MICROCÓRNEA, MEGALOLENTICONUS POSTERIOR, PERSISTENCIA DE LA VASCULATURA FETAL Y COLOBOMA"
  },
  {
    "codigo":83727005,
    "descripcion":"INFARTO PULMONAR HEMORRÁGICO"
  },
  {
    "codigo":247567006,
    "descripcion":"FOLÍCULO DE LAS PESTAÑAS - HALLAZGO"
  },
  {
    "codigo":313103006,
    "descripcion":"ATENDIDO EN UN CONSULTORIO DE LACTANTES"
  },
  {
    "codigo":737252002,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO DEL ABDOMEN"
  },
  {
    "codigo":704484004,
    "descripcion":"FRACTURA EXPUESTA DE PARED POSTERIOR DE ACETÁBULO"
  },
  {
    "codigo":16356006,
    "descripcion":"EMBARAZO MÚLTIPLE"
  },
  {
    "codigo":1359844009,
    "descripcion":"NEOPLASIA MALIGNA DE CARA INFERIOR DE PALADAR"
  },
  {
    "codigo":1259705005,
    "descripcion":"CARCINOMA SARCOMATOIDE PRIMARIO DE UROTELIO DE VEJIGA URINARIA"
  },
  {
    "codigo":276665006,
    "descripcion":"SÍNDROME DE INMUNODEFICIENCIA ADQUIRIDA CONGÉNITO"
  },
  {
    "codigo":14521008,
    "descripcion":"CONVULSIÓN VISUAL"
  },
  {
    "codigo":209294002,
    "descripcion":"FRACTURA-SUBLUXACIÓN EXPUESTA DE LA ARTICULACIÓN RADIOCARPIANA"
  },
  {
    "codigo":110990003,
    "descripcion":"PIGMENTACIÓN ANORMAL DE LA PIEL, MEDICAMENTOSA"
  },
  {
    "codigo":78222005,
    "descripcion":"NEGACIÓN - MECANISMO DE DEFENSA PSICOLÓGICA"
  },
  {
    "codigo":307598005,
    "descripcion":"ADENOMA SEBÁCEO DE LA PIEL"
  },
  {
    "codigo":373134008,
    "descripcion":"ANEURISMA DE RAÍZ AÓRTICA"
  },
  {
    "codigo":305763006,
    "descripcion":"VISTO POR TERAPEUTA EN ARTES"
  },
  {
    "codigo":402232000,
    "descripcion":"ECCEMA AGUDO DE MANOS"
  },
  {
    "codigo":271160001,
    "descripcion":"AMPOLLA TRAUMÁTICA DE CODO"
  },
  {
    "codigo":404067008,
    "descripcion":"LIPOSARCOMA CON COMPONENTE ADIPOCÍTICO"
  },
  {
    "codigo":41784005,
    "descripcion":"ADICCIÓN FÍSICA"
  },
  {
    "codigo":762680008,
    "descripcion":"HIPOTERMIA PERIOPERATORIA NO PLANEADA"
  },
  {
    "codigo":105485001,
    "descripcion":"ESTRÉS FAMILIAR"
  },
  {
    "codigo":238392009,
    "descripcion":"SICOSIS CRURIS"
  },
  {
    "codigo":671371000124105,
    "descripcion":"INCAPAZ DE CALEFACCIONAR LA VIVIENDA DEBIDO A RECURSOS FINANCIEROS LIMITADOS"
  },
  {
    "codigo":1186829003,
    "descripcion":"NEUROPATÍA PERIFÉRICA DEBIDA A OBESIDAD"
  },
  {
    "codigo":302093001,
    "descripcion":"ULCERACIÓN DE GANGLIO LINFÁTICO POPLÍTEO"
  },
  {
    "codigo":440971000124104,
    "descripcion":"INGESTA EXCESIVA DE YODO"
  },
  {
    "codigo":205624009,
    "descripcion":"TRISOMÍA 18 - MOSAICISMO CON FALTA DE DISYUNCIÓN MITÓTICA"
  },
  {
    "codigo":700339006,
    "descripcion":"EDEMA DE PÁRPADO SUPERIOR"
  },
  {
    "codigo":236557008,
    "descripcion":"INFECCIÓN DEL SITIO DE SALIDA DEL CATÉTER PARA DIÁLISIS PERITONEAL"
  },
  {
    "codigo":15629741000119102,
    "descripcion":"INSUFICIENCIA CARDÍACA SISTÓLICA EN ESTADIO C DEBIDA A MIOCARDIOPATÍA ISQUÉMICA"
  },
  {
    "codigo":337171000119107,
    "descripcion":"ENTROPIÓN MECÁNICO DE PÁRPADO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":365794002,
    "descripcion":"NIVEL DE COLESTEROL - HALLAZGO"
  },
  {
    "codigo":300258005,
    "descripcion":"QUISTE DE GLÁNDULA SALIVAL"
  },
  {
    "codigo":201954006,
    "descripcion":"ARTROPATÍA TRAUMÁTICA DE TOBILLO"
  },
  {
    "codigo":3511005,
    "descripcion":"TIROIDITIS INFECCIOSA"
  },
  {
    "codigo":298423007,
    "descripcion":"AMPLITUD DE EXTENSIÓN PASIVA DE LA COLUMNA CERVICAL NORMAL"
  },
  {
    "codigo":69047008,
    "descripcion":"FOTOSENSIBILIDAD CAUSADA POR FÁRMACO"
  },
  {
    "codigo":165516004,
    "descripcion":"RECUENTO DE NEUTRÓFILOS DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":15957421000119106,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS PRIMARIO DE BRONQUIOS PRINCIPALES BILATERALES"
  },
  {
    "codigo":722572006,
    "descripcion":"LESIÓN TRAUMÁTICA DE HUESO FACIAL DEBIDA A TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":394892007,
    "descripcion":"PRUEBA DE EMISIÓN OTOACÚSTICA, ANORMAL"
  },
  {
    "codigo":65377004,
    "descripcion":"POLIGALACTIA"
  },
  {
    "codigo":63542002,
    "descripcion":"QUEMADURA DE LA CÓRNEA Y\/O DEL SACO CONJUNTIVAL POR SUSTANCIAS QUÍMICAS ÁCIDAS"
  },
  {
    "codigo":129078005,
    "descripcion":"DEPENDENCIA PARA LA HIGIENE"
  },
  {
    "codigo":1144886006,
    "descripcion":"DEMUESTRA CONOCIMIENTO SOBRE PROCEDIMIENTO"
  },
  {
    "codigo":292918006,
    "descripcion":"REACCIÓN ADVERSA AL ALBENDAZOL"
  },
  {
    "codigo":127243005,
    "descripcion":"NEOPLASIA DE LOS GANGLIOS LINFÁTICOS INFRACLAVICULARES"
  },
  {
    "codigo":225547008,
    "descripcion":"HALLAZGO RELACIONADO CON LA INTEGRIDAD DE LA PIEL"
  },
  {
    "codigo":190944000,
    "descripcion":"HEPATITIS POR DEFICIENCIA DE ALFA-1-ANTITRIPSINA"
  },
  {
    "codigo":92640002,
    "descripcion":"CARCINOMA IN SITU DEL LÓBULO SUPERIOR IZQUIERDO DEL PULMÓN"
  },
  {
    "codigo":94475009,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LOS GANGLIOS LINFÁTICOS PAROTÍDEOS"
  },
  {
    "codigo":58037000,
    "descripcion":"SÍNDROME DE COWDEN"
  },
  {
    "codigo":254645002,
    "descripcion":"MESOTELIOMA MALIGNO DE PLEURA"
  },
  {
    "codigo":1335989007,
    "descripcion":"QUISTE DE IRIS DERECHO"
  },
  {
    "codigo":449418000,
    "descripcion":"LINFOMA NO HODGKIN FOLICULAR DE TESTÍCULO"
  },
  {
    "codigo":1137546001,
    "descripcion":"CALCIFICACIÓN PUNTEADA DE EPÍFISIS DE FALANGE DISTAL DE PULGAR"
  },
  {
    "codigo":250975000,
    "descripcion":"INSUFICIENCIA PARAPROTÉSICA DE VÁLVULA AÓRTICA"
  },
  {
    "codigo":283743001,
    "descripcion":"MORDEDURA DE PERRO EN LA MEJILLA"
  },
  {
    "codigo":281908000,
    "descripcion":"FRACTURA-LUXACIÓN DE ARTICULACIÓN CERVICODORSAL"
  },
  {
    "codigo":773428003,
    "descripcion":"ALERGIA A ISOSORBIDA"
  },
  {
    "codigo":15740641000119106,
    "descripcion":"ASTIGMATISMO ALTO DE OJO DERECHO"
  },
  {
    "codigo":314676008,
    "descripcion":"PESO DEL NIÑO: PERCENTILO 25"
  },
  {
    "codigo":83465002,
    "descripcion":"DISTONÍA AGUDA INDUCIDA POR NEUROLÉPTICOS"
  },
  {
    "codigo":247305002,
    "descripcion":"PÉRDIDA DE LA DISCRIMINACIÓN EN LA PRUEBA DE VOZ"
  },
  {
    "codigo":10907361000119107,
    "descripcion":"HERIDA POR DISPARO DE ARMA DE FUEGO DE CARA"
  },
  {
    "codigo":704222000,
    "descripcion":"FRACTURA EXPUESTA DE SEGUNDA FALANGE DE DEDO MAYOR DE LA MANO"
  },
  {
    "codigo":442078001,
    "descripcion":"TROMBOFILIA DEBIDA A NEOPLASIA MALIGNA"
  },
  {
    "codigo":1162974001,
    "descripcion":"VASCULOPATÍA COROIDEA POLIPOIDE"
  },
  {
    "codigo":278238002,
    "descripcion":"ENLENTECIMIENTO FOCAL DE LA CONDUCCIÓN NERVIOSA MIXTA"
  },
  {
    "codigo":473011001,
    "descripcion":"CONDICIÓN ALÉRGICA"
  },
  {
    "codigo":47027001,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN LA REGIÓN DEL ESCROTO, CON INFECCIÓN"
  },
  {
    "codigo":16237261000119100,
    "descripcion":"TRASTORNO DE LA FLUIDEZ DEL HABLA DE COMIENZO EN LA VIDA ADULTA"
  },
  {
    "codigo":12207821000119101,
    "descripcion":"INFECCIÓN DE TIBIA DERECHA ASOCIADA CON DISPOSITIVO DE FIJACIÓN INTERNA"
  },
  {
    "codigo":1084621000119102,
    "descripcion":"ACÚFENO PULSÁTIL SUBJECTIVO BILATERAL"
  },
  {
    "codigo":1741000119102,
    "descripcion":"ASMA INTERMITENTE NO CONTROLADA"
  },
  {
    "codigo":672461000119104,
    "descripcion":"HEMIPLEJÍA DE LADO DOMINANTE DEBIDA A ACCIDENTE CEREBROVASCULAR ISQUÉMICO Y POSTERIOR A ÉL"
  },
  {
    "codigo":16219341000119105,
    "descripcion":"MIELOPATÍA DEBIDA A COMPRESIÓN DE LA MÉDULA ESPINAL"
  },
  {
    "codigo":331981000119104,
    "descripcion":"CATARATA DE OJO DERECHO CAUSADA POR CORTICOSTEROIDE"
  },
  {
    "codigo":682701000119104,
    "descripcion":"NEOPLASIA BENIGNA DE GLÁNDULA LAGRIMAL IZQUIERDA"
  },
  {
    "codigo":1092301000119108,
    "descripcion":"DISFUNCIÓN DEL SISTEMA VESTIBULAR DERECHO"
  },
  {
    "codigo":296141000119104,
    "descripcion":"QUISTE DE MENISCO INTERNO DE RODILLA DERECHA"
  },
  {
    "codigo":132301000119107,
    "descripcion":"TROMBOSIS PROFUNDA AGUDA DE VENA ILIOFEMORAL"
  },
  {
    "codigo":307336007,
    "descripcion":"ISOINMUNIZACIÓN RHESUS POR INMUNOGLOBULINA ANTI - CW"
  },
  {
    "codigo":638862541000119108,
    "descripcion":"MASTITIS GRANULOMATOSA DE MAMA DERECHA"
  },
  {
    "codigo":15930061000119106,
    "descripcion":"EDEMA POR ESTASIS VENOSA DE MIEMBRO INFERIOR IZQUIERDO"
  },
  {
    "codigo":10973901000119108,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO MOTOR OCULAR EXTERNO DERECHO"
  },
  {
    "codigo":329421000119107,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DEBIDO A OCLUSIÓN DE ARTERIA CEREBRAL POSTERIOR DERECHA POR ÉMBOLO"
  },
  {
    "codigo":16467661000119109,
    "descripcion":"MELORREOSTOSIS DE FÉMUR IZQUIERDO"
  },
  {
    "codigo":86221000119109,
    "descripcion":"QUISTE SUBURETRAL"
  },
  {
    "codigo":371037005,
    "descripcion":"DISFUNCIÓN SISTÓLICA"
  },
  {
    "codigo":10589004,
    "descripcion":"TRANSCRIPCIÓN GENÉTICA"
  },
  {
    "codigo":895325008,
    "descripcion":"CURVATURA ANORMAL DE FALANGE DISTAL DE DEDO ANULAR"
  },
  {
    "codigo":403805009,
    "descripcion":"SÍNDROME DE ALBINISMO Y SORDERA DE TIETZ"
  },
  {
    "codigo":762418001,
    "descripcion":"RUPTURA DE CUERPO CILIAR"
  },
  {
    "codigo":698717006,
    "descripcion":"TRABAJO DE PARTO ESPONTÁNEO PRETÉRMINO CON PARTO A TÉRMINO"
  },
  {
    "codigo":205362000,
    "descripcion":"COALICIÓN COMPLEJA DEL TARSO"
  },
  {
    "codigo":1286706000,
    "descripcion":"FRACTURA DE FALANGE PROXIMAL DE DEDO MEDIO"
  },
  {
    "codigo":305501008,
    "descripcion":"BAJO ATENCIÓN DE PEDIATRA COMUNITARIO"
  },
  {
    "codigo":238130008,
    "descripcion":"INCORPORACIÓN EXCESIVA DE MACRONUTRIENTES"
  },
  {
    "codigo":269063003,
    "descripcion":"FRACTURA NO EXPUESTA DEL ATLAS"
  },
  {
    "codigo":5084002,
    "descripcion":"INFERTILIDAD FEMENINA PRIMARIA"
  },
  {
    "codigo":234460002,
    "descripcion":"DISFIBRINOGENEMIA POR DEFECTO DE LA CADENA BETA"
  },
  {
    "codigo":365532004,
    "descripcion":"INSTALACIONES PARA EL LAVADO DE MANOS EN EL ÁMBITO LABORAL - HALLAZGO"
  },
  {
    "codigo":789681001,
    "descripcion":"TROMBOFLEBITIS POSTERIOR A PERFUSIÓN"
  },
  {
    "codigo":298161001,
    "descripcion":"ARTICULACIÓN TEMPOROMANDIBULAR INFLAMADA"
  },
  {
    "codigo":429233001,
    "descripcion":"DISFUNCIÓN NEUROGÉNICA NO NEURÓGENA DE VEJIGA URINARIA"
  },
  {
    "codigo":15933461000119107,
    "descripcion":"ENDOMETRIOSIS DE AMBAS TROMPAS DE FALOPIO"
  },
  {
    "codigo":724145007,
    "descripcion":"SÍNDROME DE DISPLASIA METAFISARIA, HIPOPLASIA MAXILAR Y BRAQUIDACTILIA"
  },
  {
    "codigo":165254000,
    "descripcion":"CAMINA CON TRÍPODE O BASTÓN DE 4 PATAS"
  },
  {
    "codigo":230790004,
    "descripcion":"QUISTE DE PLEXO COROIDEO"
  },
  {
    "codigo":296326009,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE CRACK"
  },
  {
    "codigo":294491005,
    "descripcion":"ALERGIA A TEMAFLOXACINO"
  },
  {
    "codigo":196187007,
    "descripcion":"TRASTORNOS RESPIRATORIOS LUEGO DE PROCEDIMIENTO"
  },
  {
    "codigo":423728007,
    "descripcion":"USO INCONSTANTE DE MÉTODOS ANTICONCEPTIVOS"
  },
  {
    "codigo":30512007,
    "descripcion":"CARIES CEMENTARIA"
  },
  {
    "codigo":1144624009,
    "descripcion":"AUSENCIA CONGÉNITA DE MIELINIZACIÓN EN NERVIO PERIFÉRICO"
  },
  {
    "codigo":126981003,
    "descripcion":"NEOPLASIA DE NERVIO PERIFÉRICO DE LA CABEZA Y\/O DEL CUELLO"
  },
  {
    "codigo":94213007,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL CUERPO DEL PENE"
  },
  {
    "codigo":421893009,
    "descripcion":"TRASTORNO RENAL DEBIDO A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":190682005,
    "descripcion":"CISTINEMIA"
  },
  {
    "codigo":288986006,
    "descripcion":"DIFICULTAD PARA SUCCIONAR"
  },
  {
    "codigo":11784521000119103,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE MANO DERECHA"
  },
  {
    "codigo":92378006,
    "descripcion":"NEOPLASIA BENIGNA DE PIEL DE MUSLO"
  },
  {
    "codigo":1237423002,
    "descripcion":"METÁSTASIS DE CARCINOMA DE GLANDE DE PENE"
  },
  {
    "codigo":414553000,
    "descripcion":"MIELOMA DE CADENAS LIVIANAS KAPPA"
  },
  {
    "codigo":449156009,
    "descripcion":"NEOPLASIA EPITELIAL MALIGNA DE PISO DE LA BOCA"
  },
  {
    "codigo":185177002,
    "descripcion":"ATENDIDO EN CONSULTORIO ESPECIALIZADO EN TRASTORNOS LIPÍDICOS"
  },
  {
    "codigo":283481005,
    "descripcion":"HERIDA PUNZANTE EN EL GLÚTEO"
  },
  {
    "codigo":445486004,
    "descripcion":"MALFORMACIÓN CONGÉNITA DE VASO SANGUÍNEO DE LA ÓRBITA PROPIAMENTE DICHA"
  },
  {
    "codigo":183342005,
    "descripcion":"INFECCIÓN CAUSADA POR CLADOSPORIUM WERNECKII"
  },
  {
    "codigo":52270006,
    "descripcion":"CETONURIA DE CADENA RAMIFICADA INTERMITENTE"
  },
  {
    "codigo":248878009,
    "descripcion":"HALLAZGO RELACIONADO CON LA PARED DE LA VAGINA"
  },
  {
    "codigo":1197315002,
    "descripcion":"NEVO MELANOCÍTICO DE CUERPO CILIAR"
  },
  {
    "codigo":247043006,
    "descripcion":"SINEQUIA POSTERIOR COMPLETA"
  },
  {
    "codigo":1230083007,
    "descripcion":"PATRÓN DE USO NOCIVO DE ANFETAMINA Y\/O DERIVADO DE ANFETAMINA SIN DEPENDENCIA, EN REMISIÓN"
  },
  {
    "codigo":736728004,
    "descripcion":"IDENTIDAD DEL PACIENTE VERIFICADA"
  },
  {
    "codigo":308909003,
    "descripcion":"TEMBLOR PARKINSONIANO"
  },
  {
    "codigo":472749004,
    "descripcion":"HIPERTENSIÓN DE SENO CORONARIO COMO COMPLICACIÓN DE PROCEDIMIENTO"
  },
  {
    "codigo":734893009,
    "descripcion":"SEPARACIÓN DE DIENTES POSTERIORES SUPERIORES"
  },
  {
    "codigo":307074005,
    "descripcion":"ÁNIMO EXCITADO"
  },
  {
    "codigo":77698005,
    "descripcion":"LISTA DE REEMPLAZO DE LAS PROTEÍNAS"
  },
  {
    "codigo":700290009,
    "descripcion":"ENTROPIÓN CICATRIZAL DE PÁRPADO SUPERIOR"
  },
  {
    "codigo":10327003,
    "descripcion":"TRASTORNO DEL ESTADO DE ÁNIMO INDUCIDO POR COCAÍNA"
  },
  {
    "codigo":403543003,
    "descripcion":"HAMARTOMA DE DENDROCITOS DÉRMICOS CON DEPÓSITO DE GRASA"
  },
  {
    "codigo":344701000119105,
    "descripcion":"ENDOFTALMITIS BILATERAL CAUSADA POR PARÁSITO"
  },
  {
    "codigo":237868006,
    "descripcion":"AMILOIDOSIS FAMILIAR NO NEUROPÁTICA"
  },
  {
    "codigo":236033001,
    "descripcion":"DEFECTO UMBILICAL CONGÉNITO"
  },
  {
    "codigo":1081981000119107,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS INTRAEPIDÉRMICO DE OÍDO IZQUIERDO"
  },
  {
    "codigo":72471000119101,
    "descripcion":"RUIDOS TORÁCICOS ANORMALES"
  },
  {
    "codigo":203265004,
    "descripcion":"TUBERCULOSIS DE LA COLUMNA VERTEBRAL LUMBAR"
  },
  {
    "codigo":399873008,
    "descripcion":"RETINOPATÍA NO PROLIFERATIVA SEVERA SIN EDEMA MACULAR DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":365270001,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD DE UTILIZAR UNA OLLA PARA COCINAR"
  },
  {
    "codigo":299734002,
    "descripcion":"HALLAZGO RELACIONADO CON LA PRAXIA"
  },
  {
    "codigo":168662003,
    "descripcion":"RADIOGRAFÍA SIMPLE DE ARTICULACIÓN DE CADERA ANORMAL"
  },
  {
    "codigo":16046871000119103,
    "descripcion":"ENFERMEDAD POR DEPÓSITO DE HIDROXIAPATITA DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":232363000,
    "descripcion":"ABSCESO DE LA CAVIDAD NASAL"
  },
  {
    "codigo":234198008,
    "descripcion":"ANEURISMA DE INJERTO VASCULAR"
  },
  {
    "codigo":199595002,
    "descripcion":"TRABAJO DE PARTO Y PARTO COMPLICADOS POR PRESENCIA DE MECONIO EN LÍQUIDO AMNIÓTICO"
  },
  {
    "codigo":363435002,
    "descripcion":"NEOPLASIA MALIGNA DE CORAZÓN"
  },
  {
    "codigo":723883002,
    "descripcion":"DUODENITIS CAUSADA POR RADIACIÓN IONIZANTE"
  },
  {
    "codigo":195720006,
    "descripcion":"BRONQUITIS ESTREPTOCÓCICA AGUDA"
  },
  {
    "codigo":396203003,
    "descripcion":"MARGEN QUIRÚRGICO DE VENA RENAL COMPROMETIDO POR NEOPLASIA MALIGNA"
  },
  {
    "codigo":15637271000119105,
    "descripcion":"SÍNDROME DE FRICCIÓN DE LA BANDELETA ILIOTIBIAL DE AMBAS RODILLAS"
  },
  {
    "codigo":1152001,
    "descripcion":"REACCIÓN NEGATIVA A LA PRUEBA CUTÁNEA"
  },
  {
    "codigo":296064001,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE LOPRAZOLAM"
  },
  {
    "codigo":66688008,
    "descripcion":"DEGENERACIÓN DEL NERVIO ACÚSTICO"
  },
  {
    "codigo":1344640009,
    "descripcion":"FIBROSIS PULMONAR CRÓNICA CAUSADA POR VAPOR"
  },
  {
    "codigo":425301002,
    "descripcion":"ADQUISICIÓN INADECUADA DE LOS PARÁMETROS DE DESARROLLO"
  },
  {
    "codigo":294229002,
    "descripcion":"ALERGIA A GALAMINA"
  },
  {
    "codigo":30250000,
    "descripcion":"OTITIS EXTERNA AGUDA"
  },
  {
    "codigo":292394002,
    "descripcion":"REACCIÓN ADVERSA A LA PIPOTIAZINA"
  },
  {
    "codigo":95786003,
    "descripcion":"NISTAGMO POSICIONAL FATIGABLE"
  },
  {
    "codigo":194090002,
    "descripcion":"EXOTROPÍA MONOCULAR CON PATRÓN X"
  },
  {
    "codigo":290559000,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR PROXIMETACAÍNA"
  },
  {
    "codigo":126719004,
    "descripcion":"NEOPLASIA DE LA PLEURA"
  },
  {
    "codigo":225023005,
    "descripcion":"ELABORACIÓN MEDIANTE EL DOLOR DEL DUELO"
  },
  {
    "codigo":421631007,
    "descripcion":"GANGRENA DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":288724004,
    "descripcion":"DIFICULTAD PARA HABLAR MIENTRAS JUEGA"
  },
  {
    "codigo":92116006,
    "descripcion":"NEOPLASIA BENIGNA DEL FONDO DEL ESTÓMAGO"
  },
  {
    "codigo":254121000,
    "descripcion":"OSTEOPETROSIS - TIPO INTERMEDIO"
  },
  {
    "codigo":291761000119107,
    "descripcion":"SÍNDROME DE DOLOR REGIONAL COMPLEJO TIPO II DE MIEMBRO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":90281006,
    "descripcion":"INFECCIÓN CAUSADA POR OPISTHORCHIS VIVERRINI"
  },
  {
    "codigo":286889008,
    "descripcion":"CARCINOMA DE HUESOS DE MIEMBRO SUPERIOR \/ OMÓPLATO"
  },
  {
    "codigo":285054003,
    "descripcion":"INCAPAZ DE USAR AUDÍFONO"
  },
  {
    "codigo":10859441000119109,
    "descripcion":"LACERACIÓN DE MITAD DERECHA DE PARED POSTERIOR DE TÓRAX"
  },
  {
    "codigo":1004115000,
    "descripcion":"DERRAME DE OÍDO MEDIO"
  },
  {
    "codigo":22910008,
    "descripcion":"TRASTORNO DE LA TOLERANCIA A LA GLUCOSA EN INDIVIDUOS OBESOS"
  },
  {
    "codigo":283219000,
    "descripcion":"ANZUELO EN PIERNA"
  },
  {
    "codigo":709203006,
    "descripcion":"NEOPLASIA BENIGNA DE PLEXO BRAQUIAL"
  },
  {
    "codigo":248616002,
    "descripcion":"RESONANCIA VOCAL AUMENTADA"
  },
  {
    "codigo":19240003,
    "descripcion":"CELULITIS DE DÍGITO"
  },
  {
    "codigo":838440005,
    "descripcion":"MOVIMIENTO DE ARTICULACIÓN CONTRA LA GRAVEDAD"
  },
  {
    "codigo":707368005,
    "descripcion":"LIPOMA DE PULMÓN"
  },
  {
    "codigo":52008007,
    "descripcion":"CALAMBRE ORGÁNICO DEL ESCRITOR"
  },
  {
    "codigo":1297192008,
    "descripcion":"DETENCIÓN DE CRECIMIENTO EPIFISARIO DE PIERNA"
  },
  {
    "codigo":246781001,
    "descripcion":"MIOQUIMIA DEL MÚSCULO OBLICUO SUPERIOR"
  },
  {
    "codigo":1197053003,
    "descripcion":"MELORREOSTOSIS CON OSTEOPOIQUILIA"
  },
  {
    "codigo":347211000119108,
    "descripcion":"PIGMENTACIÓN CORNEAL ANTERIOR DE AMBOS OJOS"
  },
  {
    "codigo":441554001,
    "descripcion":"EHRLICHIOSIS HUMANA CAUSADA POR EHRLICHIA EWINGII"
  },
  {
    "codigo":212178005,
    "descripcion":"LESIÓN DE LA MÉDULA DORSAL ANTERIOR, SIN LESIÓN ÓSEA, D7-12"
  },
  {
    "codigo":1162450005,
    "descripcion":"CISTOCELE FEMENINO Y PROLAPSO UTERINO"
  },
  {
    "codigo":46503001,
    "descripcion":"RESULTADO NEGATIVO PARA RECIDIVA TUMORAL"
  },
  {
    "codigo":13735002,
    "descripcion":"COMPLICACIÓN DE LA TERAPIA CON CHOQUE ELÉCTRICO"
  },
  {
    "codigo":308647005,
    "descripcion":"SITUACIÓN DE CERTIFICADO DE CREMACIÓN"
  },
  {
    "codigo":210343008,
    "descripcion":"HERIDA ABIERTA EN LA CEJA"
  },
  {
    "codigo":77436004,
    "descripcion":"DISCINESIA OCULAR PAROXÍSTICA"
  },
  {
    "codigo":110204007,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO DEL VESTÍBULO MANDIBULAR"
  },
  {
    "codigo":698193000,
    "descripcion":"REVESTIMIENTO DE MEMBRANA MUCOSA DE LA LENGUA"
  },
  {
    "codigo":1255249000,
    "descripcion":"NEOPLASIA MALIGNA LOCALMENTE AVANZADA"
  },
  {
    "codigo":1288017002,
    "descripcion":"CONDUCTA HETEROSEXUAL"
  },
  {
    "codigo":10065003,
    "descripcion":"ACNÉ EXCORIADA"
  },
  {
    "codigo":403281007,
    "descripcion":"ONICODISPLASIA CONGÉNITA DE DEDOS ÍNDICES"
  },
  {
    "codigo":370513009,
    "descripcion":"FIBROSIS EN LA REGIÓN DEL ELECTRODO DEL MARCAPASOS CARDÍACO"
  },
  {
    "codigo":237606005,
    "descripcion":"ACANTOSIS NIGRICANS BENIGNA HEREDITARIA CON RESISTENCIA A LA INSULINA"
  },
  {
    "codigo":399611001,
    "descripcion":"DIFERENCIACIÓN HISTOLÓGICA DE ALTO GRADO"
  },
  {
    "codigo":792827002,
    "descripcion":"TODOS LOS PULSOS PRESENTES EN EL MIEMBRO INFERIOR DERECHO"
  },
  {
    "codigo":301307003,
    "descripcion":"ABOTAGADO AZUL"
  },
  {
    "codigo":203003003,
    "descripcion":"DEGENERACIÓN DEL TENDÓN DE AQUILES"
  },
  {
    "codigo":235771005,
    "descripcion":"MASA DEL APÉNDICE"
  },
  {
    "codigo":6395007,
    "descripcion":"ÚLCERA DE HIPOPIÓN"
  },
  {
    "codigo":365008000,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA PRONUNCIAR SONIDOS AISLADOS"
  },
  {
    "codigo":397776000,
    "descripcion":"MARCHA FESTINANTE"
  },
  {
    "codigo":102864002,
    "descripcion":"CRISTAL URINARIO, TIROSINA"
  },
  {
    "codigo":233936003,
    "descripcion":"EMBOLIA PULMONAR MASIVA AGUDA"
  },
  {
    "codigo":723621000,
    "descripcion":"SÍNDROME DE TETRAPLEJÍA ESPÁSTICA, RETINITIS PIGMENTOSA Y DISCAPACIDAD INTELECTUAL"
  },
  {
    "codigo":299472008,
    "descripcion":"HALLAZGO RELACIONADO CON LA MOVILIDAD DEL PIE"
  },
  {
    "codigo":2725003,
    "descripcion":"TRASTORNO PREVIO DE LA TOLERANCIA A LA GLUCOSA"
  },
  {
    "codigo":789157007,
    "descripcion":"DISPLASIA DÉRMICA FACIAL FOCAL TIPO I"
  },
  {
    "codigo":363173007,
    "descripcion":"TRASTORNO INFLAMATORIO DE CARTÍLAGO"
  },
  {
    "codigo":66426000,
    "descripcion":"CRANEÓPAGO PARIETAL"
  },
  {
    "codigo":890002,
    "descripcion":"QUEMADURA PROFUNDA DE TERCER GRADO DE CODO"
  },
  {
    "codigo":15668761000119102,
    "descripcion":"DEFORMIDAD CONGÉNITA DE AMBAS MANOS"
  },
  {
    "codigo":164730004,
    "descripcion":"TONOMETRÍA NORMAL"
  },
  {
    "codigo":677401000119103,
    "descripcion":"GLOBO OCULAR DERECHO CONTRAÍDO"
  },
  {
    "codigo":263034006,
    "descripcion":"SUBLUXACIÓN DE ARTICULACIÓN COSTOVERTEBRAL"
  },
  {
    "codigo":426874006,
    "descripcion":"ADENOLINFANGITIS"
  },
  {
    "codigo":295802007,
    "descripcion":"SOBREDOSIS INTENCIONAL DE CICLOSPORINA"
  },
  {
    "codigo":721786009,
    "descripcion":"NO SE OBSERVAN CÉLULAS"
  },
  {
    "codigo":719951002,
    "descripcion":"SÍNDROME DE PULGAR TRIFALÁNGICO CON BRAQUIECTRODACTILIA"
  },
  {
    "codigo":293967003,
    "descripcion":"ALERGIA A BISOPROLOL"
  },
  {
    "codigo":195663004,
    "descripcion":"FARINGITIS ALÉRGICA"
  },
  {
    "codigo":95524000,
    "descripcion":"PARESTESIA ORAL"
  },
  {
    "codigo":1087001000119105,
    "descripcion":"INFECCIÓN DE ANO Y RECTO CAUSADA POR NEISSERIA GONORRHOEAE"
  },
  {
    "codigo":128292002,
    "descripcion":"ENFERMEDAD CRÓNICA DEL APARATO CARDIOVASCULAR"
  },
  {
    "codigo":161060003,
    "descripcion":"MIEMBRO DE FAMILIA NUMEROSA"
  },
  {
    "codigo":292132007,
    "descripcion":"REACCIÓN ADVERSA A LA DOMPERIDONA"
  },
  {
    "codigo":716281000,
    "descripcion":"AFASIA NO FLUENTE PROGRESIVA PRIMARIA"
  },
  {
    "codigo":93689003,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE VEJIGA URINARIA"
  },
  {
    "codigo":290297004,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR PIROXICAM"
  },
  {
    "codigo":421369008,
    "descripcion":"HIPERSENSIBILIDAD EMOCIONAL"
  },
  {
    "codigo":91854005,
    "descripcion":"LEUCEMIA AGUDA, EN REMISIÓN"
  },
  {
    "codigo":26318006,
    "descripcion":"ENROLLAR LA LENGUA"
  },
  {
    "codigo":1304270007,
    "descripcion":"EDEMA DE MUSLO IZQUIERDO"
  },
  {
    "codigo":386766007,
    "descripcion":"ENFERMEDAD DE MARCHIAFAVA - BIGNAMI"
  },
  {
    "codigo":124622006,
    "descripcion":"DEFICIENCIA DE METILGLUTACONILO - COA HIDRATASA"
  },
  {
    "codigo":253859003,
    "descripcion":"MALFORMACIÓN CONGÉNITA DEL SISTEMA URINARIO"
  },
  {
    "codigo":1204131005,
    "descripcion":"ROTURA EN AISLAMIENTO DE CABLE VENTRICULAR DE DEFIBRILADOR CARDIOVERSOR IMPLANTABLE"
  },
  {
    "codigo":188323009,
    "descripcion":"NEOPLASIA MALIGNA DE NERVIOS PERIFÉRICOS DE EXTREMIDAD SUPERIOR, INCLUIDO EL HOMBRO"
  },
  {
    "codigo":448632002,
    "descripcion":"VENA CAVA INFERIOR IZQUIERDA CONECTADA A AURÍCULAS IZQUIERDA Y DERECHA"
  },
  {
    "codigo":284792004,
    "descripcion":"CAPAZ DE DUCHARSE"
  },
  {
    "codigo":219256006,
    "descripcion":"LESIÓN TRAUMÁTICA POR INTERVENCIÓN LEGAL"
  },
  {
    "codigo":20813000,
    "descripcion":"SÍNDROME DEL ASA AFERENTE"
  },
  {
    "codigo":282957000,
    "descripcion":"NO SE ENDEREZA"
  },
  {
    "codigo":414029004,
    "descripcion":"TRASTORNO DE FUNCIÓN INMUNOLÓGICA"
  },
  {
    "codigo":444962002,
    "descripcion":"PÉRDIDA DE VOLUMEN FACIAL"
  },
  {
    "codigo":51746009,
    "descripcion":"CONDUCTA NORMAL"
  },
  {
    "codigo":836343001,
    "descripcion":"XANTINURIA HEREDITARIA TIPO 1"
  },
  {
    "codigo":408524001,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: HEBREO"
  },
  {
    "codigo":898209004,
    "descripcion":"NEUROESTIMULADOR SACRO IN SITU"
  },
  {
    "codigo":79009004,
    "descripcion":"INFARTO AGUDO DE MIOCARDIO, SEPTAL"
  },
  {
    "codigo":111777006,
    "descripcion":"INTOXICACIÓN POR COBALTO"
  },
  {
    "codigo":352231000119103,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE PARTES BLANDAS DE EXTREMIDAD SUPERIOR IZQUIERDA"
  },
  {
    "codigo":208246005,
    "descripcion":"FRACTURA NO EXPUESTA DE HÚMERO PROXIMAL, CUATRO PARTES"
  },
  {
    "codigo":15998951000119103,
    "descripcion":"INFECCIÓN OCULAR BILATERAL CAUSADA POR NEISSERIA GONORRHOEAE"
  },
  {
    "codigo":109942009,
    "descripcion":"NEOPLASIA BENIGNA DE LOS NERVIOS PERIFÉRICOS DEL ABDOMEN"
  },
  {
    "codigo":42571002,
    "descripcion":"INDUCCIÓN FALLIDA DEL TRABAJO DE PARTO"
  },
  {
    "codigo":697931003,
    "descripcion":"DIFERENCIA DE ALTURA DE CRESTAS MARGINALES"
  },
  {
    "codigo":679911000119104,
    "descripcion":"CATARATA CORTICAL CONGÉNITA DE OJO IZQUIERDO"
  },
  {
    "codigo":75339006,
    "descripcion":"LINFOMA ESTADIO III 2"
  },
  {
    "codigo":1254987007,
    "descripcion":"DEPENDENCIA DE SUSTANCIAS DURANTE PARTO"
  },
  {
    "codigo":403019008,
    "descripcion":"TIÑA DE CUERO CABELLUDO CAUSADA POR TRICHOPHYTON YAOUNDEI"
  },
  {
    "codigo":271947006,
    "descripcion":"FOBIA A LA ESCUELA"
  },
  {
    "codigo":302880005,
    "descripcion":"TROMBOFLEBITIS SÉPTICA DE SENO SAGITAL"
  },
  {
    "codigo":827168006,
    "descripcion":"ÁNGULO KAPPA NEGATIVO"
  },
  {
    "codigo":1187616008,
    "descripcion":"DEFICIENCIA DE GALACTOSA MUTAROTASA"
  },
  {
    "codigo":169973004,
    "descripcion":"AMAMANTADO A LAS 6 SEMANAS"
  },
  {
    "codigo":364746005,
    "descripcion":"HALLAZGO RELACIONADO CON LA SITUACIÓN FETAL"
  },
  {
    "codigo":299210006,
    "descripcion":"HALLAZGO RELACIONADO CON LA EXTREMIDAD SUPERIOR LUEGO DE UN PROCEDIMIENTO"
  },
  {
    "codigo":231839000,
    "descripcion":"OBSTRUCCIÓN COMPLETA DE CANALÍCULO LAGRIMAL"
  },
  {
    "codigo":233674008,
    "descripcion":"ENFISEMA PULMONAR EN LA DEFICIENCIA DE INHIBIDOR DE PROTEINASA ALFA-1 HUMANA"
  },
  {
    "codigo":723359002,
    "descripcion":"ENCEFALOPATÍA NECROSANTE AGUDA FAMILIAR"
  },
  {
    "codigo":2463005,
    "descripcion":"HETEROCROMÍA ADQUIRIDA DEL IRIS"
  },
  {
    "codigo":788895008,
    "descripcion":"CONTUSIÓN DE ARCO PALMAR PROFUNDO"
  },
  {
    "codigo":262772003,
    "descripcion":"SECCIÓN DE CONDUCTO SALIVAL"
  },
  {
    "codigo":721524007,
    "descripcion":"SÍNDROME DE BROWN-SEQUARD AL NIVEL DEL PRIMER SEGMENTO LUMBAR"
  },
  {
    "codigo":11794561000119107,
    "descripcion":"DISTENSIÓN DE MÚSCULO PECTORAL DERECHO"
  },
  {
    "codigo":31561003,
    "descripcion":"BRONCONEUMONÍA HIPOSTÁTICA"
  },
  {
    "codigo":719689005,
    "descripcion":"DISPLASIA EPIFISARIA MÚLTIPLE TIPO BEIGHTON"
  },
  {
    "codigo":129865006,
    "descripcion":"CONOCIMIENTOS ESCASOS: MANEJO DE LOS LÍQUIDOS"
  },
  {
    "codigo":15726721000119108,
    "descripcion":"ANQUILOSIS DE ARTICULACIÓN DE AMBOS TOBILLOS"
  },
  {
    "codigo":10948891000119103,
    "descripcion":"HERIDA ABIERTA DE BRAZO IZQUIERDO DEBIDA A MORDEDURA DE PERRO"
  },
  {
    "codigo":816158007,
    "descripcion":"HEMATOMA SUBUNGUEAL DE DEDO GORDO"
  },
  {
    "codigo":62494007,
    "descripcion":"TUBERCULOSIS MILIAR CRÓNICA"
  },
  {
    "codigo":224499003,
    "descripcion":"SE QUEDA CON CUIDADOR"
  },
  {
    "codigo":93427007,
    "descripcion":"ALTERACIÓN DE LA COLORACIÓN PULMONAR"
  },
  {
    "codigo":135451000119105,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR GLUTAMATO MONOSÓDICO"
  },
  {
    "codigo":15864091000119105,
    "descripcion":"MALFORMACIÓN CONGÉNITA DE AMBOS OÍDOS"
  },
  {
    "codigo":124360006,
    "descripcion":"DEFICIENCIA DE TIOSULFATO SULFUROTRANSFERASA"
  },
  {
    "codigo":56989000,
    "descripcion":"SÍNDROME DE EATON - LAMBERT"
  },
  {
    "codigo":188061001,
    "descripcion":"MELANOMA MALIGNO DEL BRAZO"
  },
  {
    "codigo":253597007,
    "descripcion":"TEJIDO ACCESORIO SOBRE VALVA DE VÁLVULA PULMONAR"
  },
  {
    "codigo":286365009,
    "descripcion":"NO UTILIZA EL LENGUAJE"
  },
  {
    "codigo":22386003,
    "descripcion":"ATROFIA ÓPTICA SIFILÍTICA"
  },
  {
    "codigo":448370006,
    "descripcion":"ATELECTASIS REDONDEADA"
  },
  {
    "codigo":284530008,
    "descripcion":"HALLAZGO RELACIONADO CON LA COMUNICACIÓN, EL HABLA Y EL LENGUAJE"
  },
  {
    "codigo":315463001,
    "descripcion":"NACIDO EN LÍBANO"
  },
  {
    "codigo":682421000119104,
    "descripcion":"ANGIOSARCOMA PRIMARIO DE TRONCO"
  },
  {
    "codigo":20551005,
    "descripcion":"INFLAMACIÓN ORBITARIA AGUDA"
  },
  {
    "codigo":311793000,
    "descripcion":"INFARTO MIOCÁRDICO TRANSMURAL DE PARED INFERIOR, POSQUIRÚRGICO"
  },
  {
    "codigo":49649001,
    "descripcion":"INFECCIÓN CAUSADA POR ACANTHAMOEBA"
  },
  {
    "codigo":770545005,
    "descripcion":"DERMATITIS POR CONTACTO ALÉRGICA CAUSADA POR YODO"
  },
  {
    "codigo":1292998000,
    "descripcion":"TUMOR FIBROBLÁSTICO SUPERFICIAL POSITIVO PARA CD34"
  },
  {
    "codigo":47814001,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DE LA MUÑECA"
  },
  {
    "codigo":703174002,
    "descripcion":"HEMORRAGIA SUBARACNOIDEA DE ANEURISMA DE ARTERIA VERTEBRAL"
  },
  {
    "codigo":1260230003,
    "descripcion":"PIERCING EN CEJA DE REGIÓN OCULAR IZQUIERDA"
  },
  {
    "codigo":277190002,
    "descripcion":"PARÁLISIS PELÁGICA"
  },
  {
    "codigo":705009009,
    "descripcion":"DEPRESIÓN POSTERIOR DE SEGMENTO ST"
  },
  {
    "codigo":275355002,
    "descripcion":"DESIGUALDAD DE LA LONGITUD DE LOS BRAZOS"
  },
  {
    "codigo":45979003,
    "descripcion":"DOLOR POR GASES"
  },
  {
    "codigo":308123002,
    "descripcion":"LIPOMA DE LA ESPALDA"
  },
  {
    "codigo":111515007,
    "descripcion":"CATARATA SENIL POLAR SUBCAPSULAR ANTERIOR"
  },
  {
    "codigo":11376001,
    "descripcion":"ACANTOCITOSIS HEREDITARIA"
  },
  {
    "codigo":240752008,
    "descripcion":"PÓLIPO RINOSPORIDIAL DE LA MUCOSA"
  },
  {
    "codigo":371824008,
    "descripcion":"ISQUEMIA MIOCÁRDICA MANIFIESTA EN PRUEBA DE ESTRÉS REALIZADA DESPUÉS DE INFARTO DE MIOCARDIO"
  },
  {
    "codigo":207984009,
    "descripcion":"FRACTURA DE LA SEGUNDA VÉRTEBRA CERVICAL"
  },
  {
    "codigo":109680008,
    "descripcion":"ATROFIA HORIZONTAL DE CRESTA ALVEOLAR DESDENTADA"
  },
  {
    "codigo":402757006,
    "descripcion":"AFECCIÓN ORAL INDUCIDA POR FÁRMACOS"
  },
  {
    "codigo":271685006,
    "descripcion":"SUCUSIÓN HIPOCRÁTICA DE ABDOMEN"
  },
  {
    "codigo":1254725006,
    "descripcion":"METÁSTASIS DE CARCINOMA ADENOIDE QUÍSTICO EN GLÁNDULA PARÓTIDA"
  },
  {
    "codigo":106010004,
    "descripcion":"DISTOCIA PÉLVICA Y\/O TRASTORNO UTERINO"
  },
  {
    "codigo":237082005,
    "descripcion":"CANDIDIASIS DEL CUELLO UTERINO"
  },
  {
    "codigo":1285658006,
    "descripcion":"ENFERMEDAD POR DEFICIENCIA DE FACTOR VIII HEREDITARIA GRAVE CON INHIBIDOR DE BAJA RESPUESTA"
  },
  {
    "codigo":366319001,
    "descripcion":"GRASA CORPORAL - HALLAZGO"
  },
  {
    "codigo":7706009,
    "descripcion":"INFECCIÓN CAUSADA POR ANOPLOCEPHALA MAGNA"
  },
  {
    "codigo":202479004,
    "descripcion":"DOLOR DE ARTICULACIÓN ACROMIOCLAVICULAR"
  },
  {
    "codigo":431855005,
    "descripcion":"ENFERMEDAD RENAL CRÓNICA, ESTADIO 1"
  },
  {
    "codigo":399087009,
    "descripcion":"ACIDEMIA PROPIÓNICA TIPO I"
  },
  {
    "codigo":300783009,
    "descripcion":"NO PARTICIPA EN JUEGOS POR DIVERSIÓN"
  },
  {
    "codigo":684931000119100,
    "descripcion":"GLIOBLASTOMA MULTIFORME PRIMARIO DE LÓBULO PARIETAL"
  },
  {
    "codigo":198809000,
    "descripcion":"INTENTO FALLIDO DE ABORTO CON INSUFICIENCIA RENAL"
  },
  {
    "codigo":724932009,
    "descripcion":"LESIÓN TRAUMÁTICA DE TENDÓN DE TRÍCEPS BRAQUIAL"
  },
  {
    "codigo":1149081002,
    "descripcion":"SE SIENTE ORGULLOSO"
  },
  {
    "codigo":460953003,
    "descripcion":"INSERCIÓN ANÓMALA DE LIGAMENTO ARTERIOSO"
  },
  {
    "codigo":723097009,
    "descripcion":"GASTRITIS CAUSADA POR HONGO"
  },
  {
    "codigo":33134003,
    "descripcion":"ABSCESO DE LA FRENTE"
  },
  {
    "codigo":721262006,
    "descripcion":"INFECCIÓN DE SISTEMA DE DRENAJE LAGRIMAL"
  },
  {
    "codigo":366008,
    "descripcion":"HIDROMEIOSIS"
  },
  {
    "codigo":719427001,
    "descripcion":"SÍNDROME DE MICRODUPLICACIÓN 15Q11Q13"
  },
  {
    "codigo":229742009,
    "descripcion":"DESARROLLO LIMITADO DEL LENGUAJE EXPRESIVO"
  },
  {
    "codigo":293443003,
    "descripcion":"REACCIÓN ADVERSA A LA MEXILETINA"
  },
  {
    "codigo":129603004,
    "descripcion":"SÍNDROME DE LA FAMILIA ALCOHÓLICA"
  },
  {
    "codigo":95000000,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE FALANGE DE LA MANO"
  },
  {
    "codigo":291608001,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR CEFIXIMA"
  },
  {
    "codigo":15649821000119100,
    "descripcion":"ANEURISMA DE ARTERIA DE MIEMBRO SUPERIOR DERECHO"
  },
  {
    "codigo":1010669000,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE PARED SUPERIOR DE NASOFARINGE"
  },
  {
    "codigo":224237000,
    "descripcion":"CALIFICADO PARA RECIBIR INDEMNIZACIÓN PARA ALOJAMIENTO"
  },
  {
    "codigo":111491000119107,
    "descripcion":"NEFRITIS MEDICAMENTOSA"
  },
  {
    "codigo":289773004,
    "descripcion":"CUELLO UTERINO BLANDO"
  },
  {
    "codigo":93165009,
    "descripcion":"MACRODONCIA LOCALIZADA"
  },
  {
    "codigo":253335001,
    "descripcion":"ISOMERISMO DE APÉNDICES AURICULARES"
  },
  {
    "codigo":56727007,
    "descripcion":"VITILIGO"
  },
  {
    "codigo":330781000119105,
    "descripcion":"TRASTORNO DE NERVIO RADIAL IZQUIERDO"
  },
  {
    "codigo":286103009,
    "descripcion":"DIFICULTAD PARA LIMPIAR UNA HABITACIÓN"
  },
  {
    "codigo":284268006,
    "descripcion":"DIFICULTAD PARA UTILIZAR LA PRENSIÓN PALMAR"
  },
  {
    "codigo":251500009,
    "descripcion":"ACTIVIDAD DELTA RÍTMICA INTERMITENTE OCCIPITAL"
  },
  {
    "codigo":10626231000119101,
    "descripcion":"CARBUNCO DE ANTEBRAZO IZQUIERDO"
  },
  {
    "codigo":53057004,
    "descripcion":"DOLOR DE LA MANO"
  },
  {
    "codigo":16032951000119101,
    "descripcion":"OSTEONECROSIS DE HUESO SEMILUNAR DERECHO"
  },
  {
    "codigo":1263638000,
    "descripcion":"TRASTORNO FETAL DEBIDO A TAMAÑO Y DESPROPORCIÓN DE PELVIS DURANTE PARTO"
  },
  {
    "codigo":184129008,
    "descripcion":"ES CUESTIONABLE SI LA FECHA DE NACIMIENTO DEL PACIENTE ES CORRECTA"
  },
  {
    "codigo":304311000119103,
    "descripcion":"GOTA CRÓNICA DE VÉRTEBRA, SIN TOFO, DEBIDA A DISFUNCIÓN RENAL"
  },
  {
    "codigo":247830007,
    "descripcion":"MIEDO A LOS ESPACIOS ABIERTOS"
  },
  {
    "codigo":213227002,
    "descripcion":"COMPLICACIONES GASTROINTESTINALES COMO CONSECUENCIA DE LA ATENCIÓN MÉDICA"
  },
  {
    "codigo":1163499003,
    "descripcion":"INFECCIÓN FÚNGICA DE NERVIO CRANEAL"
  },
  {
    "codigo":294664000,
    "descripcion":"ALERGIA A COMPONENTE DE VACUNA QUE CONTIENE ANTÍGENO DE HAEMOPHILUS INFLUENZAE TIPO B"
  },
  {
    "codigo":16619007,
    "descripcion":"OCLUSIÓN CONGÉNITA DE URÉTER"
  },
  {
    "codigo":3281000175104,
    "descripcion":"HABLA VARIOS IDIOMAS"
  },
  {
    "codigo":14784000,
    "descripcion":"TRASTORNO MENTAL ORGÁNICO INDUCIDO POR OPIÁCEO"
  },
  {
    "codigo":735680008,
    "descripcion":"OSTEOSARCOMA PRIMARIO"
  },
  {
    "codigo":111253001,
    "descripcion":"INFECCIÓN DEL HUESO"
  },
  {
    "codigo":209557005,
    "descripcion":"ESGUINCE DE CUELLO"
  },
  {
    "codigo":438933007,
    "descripcion":"CIRCULACIÓN HIPERDINÁMICA"
  },
  {
    "codigo":78485007,
    "descripcion":"CARDIOPATÍA CONGÉNITA ACIANÓTICA"
  },
  {
    "codigo":109418001,
    "descripcion":"CRANEOSINOSTOSIS SAGITAL"
  },
  {
    "codigo":11114002,
    "descripcion":"GINGIVALGIA"
  },
  {
    "codigo":371562001,
    "descripcion":"LESIÓN DE RAÍCES NERVIOSAS DORSALES"
  },
  {
    "codigo":1354602002,
    "descripcion":"FRACTURA DE FALANGE DISTAL DE DEDO MEDIO DE MANO"
  },
  {
    "codigo":1290901007,
    "descripcion":"LIPOSARCOMA INFLAMATORIO"
  },
  {
    "codigo":402495002,
    "descripcion":"CARCINOMA BASOCELULAR DE CANTO INTERNO"
  },
  {
    "codigo":238655003,
    "descripcion":"LIQUEN PLANO DE CUERO CABELLUDO"
  },
  {
    "codigo":369727006,
    "descripcion":"G3-4: ESCASAMENTE DIFERENCIADO\/INDIFERENCIADO"
  },
  {
    "codigo":271423008,
    "descripcion":"TUBERCULOSIS DE PIEL Y TEJIDO SUBCUTÁNEO"
  },
  {
    "codigo":9279009,
    "descripcion":"EMBARAZO EXTRAMNIÓTICO"
  },
  {
    "codigo":7444001,
    "descripcion":"TUBERCULOSIS DEL RECTO"
  },
  {
    "codigo":204052006,
    "descripcion":"CEBOCEFALIA"
  },
  {
    "codigo":236820006,
    "descripcion":"FALLA DEL COITO"
  },
  {
    "codigo":234985000,
    "descripcion":"MANCHADO DENTARIO INTRÍNSECO - ENFERMEDAD METABÓLICA"
  },
  {
    "codigo":169449001,
    "descripcion":"TRATAR DE CONCEBIR"
  },
  {
    "codigo":5609005,
    "descripcion":"PARO SINUSAL"
  },
  {
    "codigo":300521006,
    "descripcion":"ÚLCERA DE PREPUCIO"
  },
  {
    "codigo":366057007,
    "descripcion":"HALLAZGO RELACIONADO CON LA CLARIDAD DE LA IMAGEN VISUAL"
  },
  {
    "codigo":396990000,
    "descripcion":"EXTENSIÓN TUMORAL EXTRAESCLERAL, PRESENTE"
  },
  {
    "codigo":298686006,
    "descripcion":"ELEVACIÓN DE LA PIERNA EXTENDIDA, NORMAL"
  },
  {
    "codigo":167614006,
    "descripcion":"CONSISTENCIA DE LA MATERIA FECAL: NORMAL"
  },
  {
    "codigo":724670006,
    "descripcion":"CONVULSIÓN CONCOMITANTE CON ABSTINENCIA DE ANSIOLÍTICO Y DEBIDA A ELLA"
  },
  {
    "codigo":296851001,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE INSULINA"
  },
  {
    "codigo":1279891002,
    "descripcion":"SÍNDROME DE DISFUNCIÓN MITOCONDRIAL MÚLTIPLE TIPO 6"
  },
  {
    "codigo":1148819003,
    "descripcion":"LESIÓN TRAUMÁTICA DE PULMÓN DEBIDA A VAPEO"
  },
  {
    "codigo":1939005,
    "descripcion":"FLUJO VASCULAR ANORMAL"
  },
  {
    "codigo":722835006,
    "descripcion":"FETO PEQUEÑO PARA LA EDAD GESTACIONAL, ASIMÉTRICO"
  },
  {
    "codigo":427923007,
    "descripcion":"ESTENOSIS DE LA FOSA LATERAL DE LA COLUMNA VERTEBRAL LUMBAR"
  },
  {
    "codigo":40461000087104,
    "descripcion":"CUERPO EXTRAÑO EN CONDUCTO AUDITIVO DERECHO"
  },
  {
    "codigo":131176001,
    "descripcion":"CARBOXIHEMOGLOBINA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":35341000087101,
    "descripcion":"UTILIZA CIGARRILLO ELECTRÓNICO DIARIAMENTE"
  },
  {
    "codigo":1343592003,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE TENDÓN DE BRAZO"
  },
  {
    "codigo":196712004,
    "descripcion":"ÚLCERA GASTROYEYUNAL AGUDA CON OBSTRUCCIÓN"
  },
  {
    "codigo":43021000087108,
    "descripcion":"HEMATOMA DE ANTEBRAZO IZQUIERDO"
  },
  {
    "codigo":333291000119106,
    "descripcion":"SÍNDROME OCULOGLANDULAR DE PARINAUD DE OJO DERECHO"
  },
  {
    "codigo":48141000087108,
    "descripcion":"FRACTURA DE QUINTO HUESO METATARSIANO DE PIE IZQUIERDO"
  },
  {
    "codigo":719165004,
    "descripcion":"DISPLASIA ESPONDILOMETAFISARIA TIPO AGRECANO"
  },
  {
    "codigo":193042000,
    "descripcion":"CATAPLEXIA Y NARCOLEPSIA"
  },
  {
    "codigo":94738003,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LOS DOS TERCIOS ANTERIORES DE LA LENGUA"
  },
  {
    "codigo":1208850004,
    "descripcion":"INSUFICIENCIA VENTRICULAR DERECHA POR INFARTO VENTRICULAR DERECHO"
  },
  {
    "codigo":717330004,
    "descripcion":"DISPLASIA ESPONDILOEPIMETAFISARIA TIPO IRAPA"
  },
  {
    "codigo":291346003,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR DIFENILPIRALINA"
  },
  {
    "codigo":420583000,
    "descripcion":"PÉRDIDA CUTÁNEA DE ESPESOR PARCIAL"
  },
  {
    "codigo":782866008,
    "descripcion":"PERITONITIS EOSINOFÍLICA"
  },
  {
    "codigo":387815003,
    "descripcion":"DEFICIENCIA DE GLUCÓGENO SINTETASA A CINASA"
  },
  {
    "codigo":289511006,
    "descripcion":"VAGINA PRESENTE"
  },
  {
    "codigo":92903007,
    "descripcion":"FORMA ANORMAL CONGÉNITA DEL CENTRO DE LA VÉRTEBRA DORSAL"
  },
  {
    "codigo":1172412003,
    "descripcion":"11 - DESOXI, 17 - HIDROXICORTICOSTERONA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1052296002,
    "descripcion":"GASTRITIS POR SÍFILIS SECUNDARIA"
  },
  {
    "codigo":254908006,
    "descripcion":"NEOPLASIA MALIGNA DE PIEL DE PENE"
  },
  {
    "codigo":123836007,
    "descripcion":"INADECUADO PARA EVALUACIÓN POR PRESENCIA DE SANGRE, QUE ENMASCARA LA OBSERVACIÓN"
  },
  {
    "codigo":3720003,
    "descripcion":"PRESENCIA ANORMAL DE HEMOGLOBINA"
  },
  {
    "codigo":11011871000119101,
    "descripcion":"FÍSTULA ARTERIOVENOSA ADQUIRIDA"
  },
  {
    "codigo":23697004,
    "descripcion":"SÍNDROME DE APLASTAMIENTO"
  },
  {
    "codigo":11857541000119107,
    "descripcion":"DISTENSIÓN DE TENDÓN DE AQUILES IZQUIERDO"
  },
  {
    "codigo":285841006,
    "descripcion":"LESIÓN DE LA CAVIDAD PÉLVICA"
  },
  {
    "codigo":416913007,
    "descripcion":"NEURORRETINITIS TOXOPLÁSMICA"
  },
  {
    "codigo":15953541000119108,
    "descripcion":"OCLUSIÓN DE CONDUCTO GALACTÓFORO DE MAMA IZQUIERDA"
  },
  {
    "codigo":1268881002,
    "descripcion":"MELANOMA MALIGNO PRIMARIO DE PIEL"
  },
  {
    "codigo":284006002,
    "descripcion":"LESIÓN DE LA CAVIDAD TORÁCICA"
  },
  {
    "codigo":447846002,
    "descripcion":"OBSTRUCCIÓN DE AORTA ASCENDENTE"
  },
  {
    "codigo":251238007,
    "descripcion":"ONDA T PICUDA ELEVADA"
  },
  {
    "codigo":249403003,
    "descripcion":"PARCHES BLANQUECINOS EN LA MUCOSA ORAL"
  },
  {
    "codigo":216635003,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ALCOHOL DESNATURALIZADO"
  },
  {
    "codigo":773691007,
    "descripcion":"DERMATOSIS EROSIVA Y VESICULAR CONGÉNITA"
  },
  {
    "codigo":314939008,
    "descripcion":"PATRÓN DE SUEÑO, APROPIADO"
  },
  {
    "codigo":313104000,
    "descripcion":"ATENDIDO EN UN CENTRO DE REHABILITACIÓN DE DROGAS"
  },
  {
    "codigo":247568001,
    "descripcion":"FOLICULITIS PALPEBRAL"
  },
  {
    "codigo":282171007,
    "descripcion":"DIFICULTAD PARA SUBIR UNA COLINA"
  },
  {
    "codigo":83728000,
    "descripcion":"SÍNDROME AUTOINMUNITARIO POLIGLANDULAR, TIPO 2"
  },
  {
    "codigo":335801000119100,
    "descripcion":"DEPÓSITO EN CONJUNTIVA DE OJO DERECHO"
  },
  {
    "codigo":18192007,
    "descripcion":"ENDOCARDITIS REUMÁTICA AGUDA"
  },
  {
    "codigo":10684191000119107,
    "descripcion":"NÓDULO DE PIEL DE EXTREMIDAD SUPERIOR DERECHA"
  },
  {
    "codigo":1073081000119101,
    "descripcion":"ARTRITIS ESTREPTOCÓCICA DE CODO DERECHO"
  },
  {
    "codigo":1359845005,
    "descripcion":"CARCINOMA IN SITU DE CARA INFERIOR DE PALADAR"
  },
  {
    "codigo":737253007,
    "descripcion":"LESIÓN TRAUMÁTICA DE FASCIA ABDOMINAL"
  },
  {
    "codigo":1259706006,
    "descripcion":"COREA DEBIDA A SÍNDROME ANTIFOSFOLIPÍDICO"
  },
  {
    "codigo":276666007,
    "descripcion":"SEROPOSITIVIDAD PARA EL VIRUS DEL SÍNDROME DE INMUNODEFICIENCIA HUMANA CONGÉNITO"
  },
  {
    "codigo":78223000,
    "descripcion":"ERITEMA NUDOSO DEBIDO A COCCIDIOIDOMICOSIS"
  },
  {
    "codigo":405903000,
    "descripcion":"TUMOR QUE INVADE TEJIDO SUBCUTÁNEO"
  },
  {
    "codigo":307599002,
    "descripcion":"ADENOCARCINOMA SEBÁCEO"
  },
  {
    "codigo":209295001,
    "descripcion":"FRACTURA-SUBLUXACIÓN EXPUESTA DE LA ARTICULACIÓN MEDIOCARPIANA"
  },
  {
    "codigo":12687004,
    "descripcion":"MENOR ACTIVIDAD"
  },
  {
    "codigo":305764000,
    "descripcion":"VISTO POR TERAPEUTA EN ARTE"
  },
  {
    "codigo":373135009,
    "descripcion":"ABSCESO ANULAR DE RAÍZ AÓRTICA"
  },
  {
    "codigo":76388001,
    "descripcion":"SUPRADESNIVEL DEL ST"
  },
  {
    "codigo":45455009,
    "descripcion":"FRACTURAS EXPUESTAS MÚLTIPLES DE EXTREMO DISTAL DE FÉMUR"
  },
  {
    "codigo":404068003,
    "descripcion":"LIPOSARCOMA ESCLEROSANTE"
  },
  {
    "codigo":10852006,
    "descripcion":"INTOXICACIÓN CAUSADA POR INGESTIÓN DE ALIMENTO INFESTADO POR INSECTOS"
  },
  {
    "codigo":830052009,
    "descripcion":"SÍNDROME DE OVARIO POLIQUÍSTICO DE OVARIO DERECHO"
  },
  {
    "codigo":271161002,
    "descripcion":"AMPOLLA TRAUMÁTICA DEL ANTEBRAZO"
  },
  {
    "codigo":369465003,
    "descripcion":"TUMOR MALIGNO QUE COMPROMETE LA URETRA POR PROPAGACIÓN DIRECTA DE LA VEJIGA"
  },
  {
    "codigo":238393004,
    "descripcion":"SICOSIS LUPOIDE DE LA BARBA"
  },
  {
    "codigo":402233005,
    "descripcion":"ECCEMA CRÓNICO DE MANOS"
  },
  {
    "codigo":1569991000168108,
    "descripcion":"CARECE DE DESEO DE CUIDAR DE SÍ MISMO"
  },
  {
    "codigo":762681007,
    "descripcion":"RUPTURA DE AISLAMIENTO DE DERIVACIÓN DE MARCAPASOS CARDÍACO"
  },
  {
    "codigo":105486000,
    "descripcion":"DIFICULTAD CON LA PAREJA"
  },
  {
    "codigo":39950000,
    "descripcion":"DISNEA, CLASE III"
  },
  {
    "codigo":236558003,
    "descripcion":"INFECCIÓN DEL SITIO DE INSERCIÓN DEL CATÉTER DE DIÁLISIS PERITONEAL"
  },
  {
    "codigo":1186830008,
    "descripcion":"NEUROPATÍA PERIFÉRICA CAUSADA POR PLOMO"
  },
  {
    "codigo":38115001,
    "descripcion":"TUBERCULOSIS DE LAS MENINGES ESPINALES"
  },
  {
    "codigo":300259002,
    "descripcion":"QUISTE DE GLÁNDULA PARÓTIDA"
  },
  {
    "codigo":365795001,
    "descripcion":"NIVEL DE TRIGLICÉRIDO - HALLAZGO"
  },
  {
    "codigo":201955007,
    "descripcion":"ARTROPATÍA TRAUMÁTICA DE LA ARTICULACIÓN SUBASTRAGALINA"
  },
  {
    "codigo":298424001,
    "descripcion":"AMPLITUD DE EXTENSIÓN PASIVA DE LA COLUMNA CERVICAL AUMENTADA"
  },
  {
    "codigo":198285000,
    "descripcion":"FÍSTULA DE LA VAGINA AL INTESTINO DELGADO"
  },
  {
    "codigo":722573001,
    "descripcion":"FRACTURA DE MANDÍBULA DEBIDA A TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":394893002,
    "descripcion":"PRUEBA DE EMISIÓN OTOACÚSTICA, RESULTADO DUDOSO"
  },
  {
    "codigo":296589001,
    "descripcion":"SOBREDOSIS DE KANAMICINA"
  },
  {
    "codigo":165517008,
    "descripcion":"NEUTROPENIA"
  },
  {
    "codigo":294754003,
    "descripcion":"ALERGIA A LEVONORGESTREL"
  },
  {
    "codigo":30775000,
    "descripcion":"EVALUACIÓN DE DISCAPACIDAD: 1%"
  },
  {
    "codigo":292919003,
    "descripcion":"REACCIÓN ADVERSA AL TIABENDAZOL"
  },
  {
    "codigo":291084001,
    "descripcion":"INTOXICACIÓN POR MIDAZOLAM"
  },
  {
    "codigo":422156002,
    "descripcion":"BAJO ANESTESIA LOCAL"
  },
  {
    "codigo":127244004,
    "descripcion":"NEOPLASIA DE LOS GANGLIOS LINFÁTICOS ESCALENOS"
  },
  {
    "codigo":94476005,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA RÓTULA"
  },
  {
    "codigo":420321004,
    "descripcion":"MALABSORCIÓN INTESTINAL ASOCIADA CON SIDA"
  },
  {
    "codigo":15985031000119102,
    "descripcion":"HEMORRAGIA INTRAVENTRICULAR NEONATAL NO TRAUMÁTICA"
  },
  {
    "codigo":338311000119102,
    "descripcion":"AMBLIOPÍA REFRACTARIA DEL OJO IZQUIERDO"
  },
  {
    "codigo":713398008,
    "descripcion":"NIVEL DE CONOCIMIENTO SOBRE SALUD RELACIONADA CON VIAJE, DEFICIENTE"
  },
  {
    "codigo":90806009,
    "descripcion":"REACCIÓN AGUDA A SUSTANCIA EXTRAÑA DEJADA ACCIDENTALMENTE EN EL CUERPO DURANTE UN PROCEDIMIENTO"
  },
  {
    "codigo":711563001,
    "descripcion":"SIN EXPOSICIÓN CONOCIDA A HUMO DE TABACO"
  },
  {
    "codigo":16230791000119104,
    "descripcion":"AVERSIÓN SENSITIVA A DETERMINADOS ALIMENTOS"
  },
  {
    "codigo":1137547005,
    "descripcion":"CALCIFICACIÓN PUNTEADA DE EPÍFISIS DE FALANGE PROXIMAL DE PULGAR"
  },
  {
    "codigo":10631000119105,
    "descripcion":"INFECCIÓN DE TRACTO GENITAL FEMENINO DEBIDA A ABORTO ESPONTÁNEO COMPLETO"
  },
  {
    "codigo":449419008,
    "descripcion":"LINFOMA NO HODGKIN FOLICULAR DE INTESTINO"
  },
  {
    "codigo":250976004,
    "descripcion":"INSUFICIENCIA DE CÚSPIDE DE VÁLVULA AÓRTICA"
  },
  {
    "codigo":283744007,
    "descripcion":"MORDEDURA DE PERRO EN LA BOCA"
  },
  {
    "codigo":19765000,
    "descripcion":"COMPLICACIÓN DE LA DIÁLISIS"
  },
  {
    "codigo":249141002,
    "descripcion":"TRABAJO DE PARTO NO ESTABLECIDO"
  },
  {
    "codigo":52533003,
    "descripcion":"ENDOMETRIOSIS DEL TABIQUE RECTOVAGINAL"
  },
  {
    "codigo":314677004,
    "descripcion":"PESO DEL NIÑO: PERCENTILO 26-49"
  },
  {
    "codigo":1075591000119107,
    "descripcion":"INESTABILIDAD DE ARTICULACIÓN DE TOBILLO DERECHO"
  },
  {
    "codigo":11862561000119101,
    "descripcion":"HERIDA INFECTADA DE PIE IZQUIERDO DEBIDA A PICADURA DE INSECTO NO VENENOSO"
  },
  {
    "codigo":281909008,
    "descripcion":"FRACTURA LUXACIÓN DE ARTICULACIÓN LUMBOSACRA"
  },
  {
    "codigo":247306001,
    "descripcion":"RESULTADOS INCONSISTENTES CON LA PRUEBA DE VOZ"
  },
  {
    "codigo":15712801000119102,
    "descripcion":"VÁRICES EN RETINA DE OJO DERECHO"
  },
  {
    "codigo":11780641000119103,
    "descripcion":"CONTUSIÓN DE CODO DERECHO"
  },
  {
    "codigo":1162975000,
    "descripcion":"ENFERMEDAD DEL ADN MITOCONDRIAL HEREDADA POR VÍA MATERNA"
  },
  {
    "codigo":16095003,
    "descripcion":"HETERODÍDIMO"
  },
  {
    "codigo":278239005,
    "descripcion":"ANOMALÍA DIFUSA DE LA CONDUCCIÓN NERVIOSA MIXTA"
  },
  {
    "codigo":704223005,
    "descripcion":"FRACTURA EXPUESTA DE SEGUNDA FALANGE DE DEDO ANULAR"
  },
  {
    "codigo":407476002,
    "descripcion":"ENFERMEDAD POR FLEBOVIRUS TRANSMITIDA POR MOSQUITOS SIMÚLIDOS"
  },
  {
    "codigo":210868003,
    "descripcion":"LESIÓN EXPUESTA, ARTERIA FEMORAL SUPERFICIAL"
  },
  {
    "codigo":1259444003,
    "descripcion":"CARCINOMA INDIFERENCIADO PRIMARIO DE SENO NASAL"
  },
  {
    "codigo":47028006,
    "descripcion":"HERNIA HIATAL CONGÉNITA"
  },
  {
    "codigo":14260009,
    "descripcion":"BERIBERI DE SHOSHIN"
  },
  {
    "codigo":733321002,
    "descripcion":"TRASTORNO DE MÚSCULO DE ESFÍNTER PUPILAR"
  },
  {
    "codigo":307337003,
    "descripcion":"ISOINMUNIZACIÓN DEL RECIÉN NACIDO POR GRUPO SANGUÍNEO DUFFY"
  },
  {
    "codigo":209033003,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA EXPUESTA PANASTRAGALINA"
  },
  {
    "codigo":241801006,
    "descripcion":"EFECTO TÓXICO CAUSADO POR SULFURO DE CINC"
  },
  {
    "codigo":371038000,
    "descripcion":"OCLUSIÓN DE LA AORTA TERMINAL"
  },
  {
    "codigo":405641009,
    "descripcion":"TUBO ENDOBRONQUIAL COLOCADO EN FORMA INCORRECTA"
  },
  {
    "codigo":698718001,
    "descripcion":"VÍCTIMA DE MOVIMIENTOS CATACLÍSMICOS DE TIERRA CAUSADOS POR UN TERREMOTO"
  },
  {
    "codigo":305502001,
    "descripcion":"BAJO ATENCIÓN DE NEONATÓLOGO"
  },
  {
    "codigo":403806005,
    "descripcion":"SÍNDROME DE ZIPRKOWSKI-MARGOLIS"
  },
  {
    "codigo":43358008,
    "descripcion":"VOZ ANFÓRICA"
  },
  {
    "codigo":76126009,
    "descripcion":"ABSCESO DE PÁRPADO"
  },
  {
    "codigo":94631000119100,
    "descripcion":"TRASTORNO DEPRESIVO MATERNO QUE COMPLICA EL EMBARAZO"
  },
  {
    "codigo":10682791000119101,
    "descripcion":"TUMORACIÓN DE LA PIEL DE LA PIERNA DERECHA"
  },
  {
    "codigo":319911000119102,
    "descripcion":"NÓDULO REUMATOIDEO DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":16025511000119103,
    "descripcion":"TROMBOFLEBITIS DE AMBAS VENAS YUGULARES"
  },
  {
    "codigo":1085351000119101,
    "descripcion":"FISURA DE PALADAR BLANDO Y DE LABIO"
  },
  {
    "codigo":39688001,
    "descripcion":"VENTILACIÓN DESIGUAL"
  },
  {
    "codigo":12203431000119106,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DE REGIÓN INGUINAL"
  },
  {
    "codigo":16012711000119107,
    "descripcion":"ATEROEMBOLIA DE AMBOS MIEMBROS INFERIORES"
  },
  {
    "codigo":15999911000119107,
    "descripcion":"TRASTORNO DEL OJO IZQUIERDO POSTERIOR A CIRUGÍA DE CATARATAS"
  },
  {
    "codigo":10680231000119105,
    "descripcion":"TUMORACIÓN DE LA PIEL DE LA PIERNA IZQUIERDA"
  },
  {
    "codigo":10639271000119105,
    "descripcion":"ÚLCERA NEUROPÁTICA DE PANTORRILLA DERECHA"
  },
  {
    "codigo":881694631000119107,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DE BULBO RAQUÍDEO"
  },
  {
    "codigo":1077671000119103,
    "descripcion":"OSTEOMIELITIS DE RADIO DERECHO"
  },
  {
    "codigo":16028071000119106,
    "descripcion":"EXOSTOSIS DE HÚMERO IZQUIERDO"
  },
  {
    "codigo":16051111000119106,
    "descripcion":"ARTRITIS DE ARTICULACIÓN DE RODILLA IZQUIERDA DEBIDA A INMUNIZACIÓN Y POSTERIOR A ELLA"
  },
  {
    "codigo":404252071000119106,
    "descripcion":"ENDOMETRIOMA DE OVARIO DERECHO"
  },
  {
    "codigo":12001191000119108,
    "descripcion":"HEMATOMA DEBIDO A ARTROPLASTIA DE RODILLA IZQUIERDA Y POSTERIOR A ELLA"
  },
  {
    "codigo":340391000119108,
    "descripcion":"QUISTE IDIOPÁTICO DE IRIS IZQUIERDO"
  },
  {
    "codigo":501913511000119109,
    "descripcion":"RECTOSIGMOIDITIS ULCEROSA CRÓNICA EN REMISIÓN"
  },
  {
    "codigo":398301006,
    "descripcion":"MORBILIDAD DE LA VÍA AÉREA"
  },
  {
    "codigo":5085001,
    "descripcion":"GONOCOCCEMIA"
  },
  {
    "codigo":12081851000119108,
    "descripcion":"QUEMADURA DE PÁRPADO DERECHO"
  },
  {
    "codigo":234461003,
    "descripcion":"DISFIBRINOGENEMIA POR DEFECTO DE LA CADENA GAMMA"
  },
  {
    "codigo":1078101000119102,
    "descripcion":"OSTEOCONDRITIS DISECANTE DE PIE IZQUIERDO"
  },
  {
    "codigo":365533009,
    "descripcion":"INSTALACIONES PARA DUCHARSE EN EL ÁMBITO LABORAL - HALLAZGO"
  },
  {
    "codigo":724146008,
    "descripcion":"CONDROMATOSIS METAFISARIA CONCOMITANTE CON ACIDURIA HIDROXIGLUTÁRICA D-2"
  },
  {
    "codigo":298162008,
    "descripcion":"ARTICULACIÓN DE HOMBRO, INFLAMADA"
  },
  {
    "codigo":789682008,
    "descripcion":"TROMBOFLEBITIS POSTERIOR A TRANSFUSIÓN"
  },
  {
    "codigo":230791000,
    "descripcion":"HAMARTOMA NEURONAL HIPOTALÁMICO"
  },
  {
    "codigo":165255004,
    "descripcion":"USA ANDADOR"
  },
  {
    "codigo":1415005,
    "descripcion":"LINFANGITIS"
  },
  {
    "codigo":721711931000119105,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DEBIDO A TROMBOSIS DE ARTERIAS CEREBRALES ANTERIORES BILATERALES"
  },
  {
    "codigo":340821000119104,
    "descripcion":"QUERATOCONJUNTIVITIS DE OJO IZQUIERDO POR EXPOSICIÓN"
  },
  {
    "codigo":427399008,
    "descripcion":"TRASTORNO HEPÁTICO INDUCIDO POR FÁRMACOS"
  },
  {
    "codigo":296327000,
    "descripcion":"SOBREDOSIS INTENCIONAL DE CRACK"
  },
  {
    "codigo":196188002,
    "descripcion":"INSUFICIENCIA PULMONAR AGUDA LUEGO DE UNA CIRUGÍA TORÁCICA"
  },
  {
    "codigo":11809621000119104,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE MUSLO IZQUIERDO"
  },
  {
    "codigo":292657001,
    "descripcion":"REACCIÓN ADVERSA AL SELENIO TÓPICO"
  },
  {
    "codigo":10963951000119101,
    "descripcion":"LACERACIÓN DE RODILLA IZQUIERDA"
  },
  {
    "codigo":94214001,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL CUERPO DEL ESTÓMAGO"
  },
  {
    "codigo":126982005,
    "descripcion":"NEOPLASIA DE LOS NERVIOS PERIFÉRICOS DE LA CABEZA"
  },
  {
    "codigo":420059000,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR INHIBIDOR DE LA RESORCIÓN ÓSEA"
  },
  {
    "codigo":125147001,
    "descripcion":"DENSIDAD DENTRO DE RANGO DE REFERENCIA"
  },
  {
    "codigo":290822008,
    "descripcion":"INTOXICACIÓN POR DESIPRAMINA"
  },
  {
    "codigo":314351000119104,
    "descripcion":"ESCOLIOSIS NEUROMUSCULAR CERVICODORSAL"
  },
  {
    "codigo":92379003,
    "descripcion":"NEOPLASIA BENIGNA DE PIEL DE DEDO DE PIE"
  },
  {
    "codigo":26843008,
    "descripcion":"SÍNDROME ANTIFOSFOLIPÍDICO"
  },
  {
    "codigo":25008002,
    "descripcion":"HIPERTIROIDISMO POR ESTRUMA OVÁRICO"
  },
  {
    "codigo":188848002,
    "descripcion":"NEOPLASIA BENIGNA DEL PÁNCREAS, EXCLUIDOS LOS ISLOTES PANCREÁTICOS DE LANGERHANS"
  },
  {
    "codigo":55941000,
    "descripcion":"SARCOIDOSIS CUTÁNEA"
  },
  {
    "codigo":1237424008,
    "descripcion":"METÁSTASIS DE CARCINOMA DE PREPUCIO"
  },
  {
    "codigo":416389007,
    "descripcion":"TRASTORNO GASTROINTESTINAL CAUSADO POR ALERGIA ALIMENTARIA"
  },
  {
    "codigo":840538003,
    "descripcion":"QUEMADURA DE DÍGITO DE MANO"
  },
  {
    "codigo":447322003,
    "descripcion":"LACERACIÓN DE ARTERIA RADIAL"
  },
  {
    "codigo":283482003,
    "descripcion":"HERIDA PUNZANTE EN LA CADERA"
  },
  {
    "codigo":185178007,
    "descripcion":"ATENDIDO EN CONSULTORIO ESPECIALIZADO EN TRASTORNOS DEL COLESTEROL"
  },
  {
    "codigo":281647001,
    "descripcion":"REACCIÓN ADVERSA"
  },
  {
    "codigo":248879001,
    "descripcion":"PROLAPSO DE LA PARED VAGINAL ANTERIOR"
  },
  {
    "codigo":52271005,
    "descripcion":"FRACTURA DE ESFENOIDES"
  },
  {
    "codigo":85039006,
    "descripcion":"SÍNDROME DE AMENORREA-GALACTORREA POSPARTO"
  },
  {
    "codigo":445487008,
    "descripcion":"CICATRIZ CONTRAÍDA DE PIEL"
  },
  {
    "codigo":609327009,
    "descripcion":"SENSIBILIZACIÓN ALÉRGICA"
  },
  {
    "codigo":17668000,
    "descripcion":"PLEUROPERICARDITIS AGUDA"
  },
  {
    "codigo":247044000,
    "descripcion":"HALLAZGO DEL CUERPO CILIAR"
  },
  {
    "codigo":1230084001,
    "descripcion":"PATRÓN DE USO NOCIVO CONTINUO DE PSICOESTIMULANTE SIN DEPENDENCIA"
  },
  {
    "codigo":1080611000119100,
    "descripcion":"LEIOMIOSARCOMA PRIMARIO DE RIÑÓN DERECHO"
  },
  {
    "codigo":48601002,
    "descripcion":"TROMBOSIS DE LA ARTERIA CEREBRAL ANTERIOR"
  },
  {
    "codigo":472750004,
    "descripcion":"ESTENOSIS DE VENA CAVA SUPERIOR COMO COMPLICACIÓN DE PROCEDIMIENTO"
  },
  {
    "codigo":79534009,
    "descripcion":"ENFERMEDAD DE MULLER-WEISS"
  },
  {
    "codigo":343331000119104,
    "descripcion":"PÉRDIDA SÚBITA DE LA VISIÓN DE AMBOS OJOS"
  },
  {
    "codigo":307075006,
    "descripcion":"SENSACIÓN DE INSEGURIDAD"
  },
  {
    "codigo":700291008,
    "descripcion":"BLEFARITIS ULCEROSA DE PÁRPADO INFERIOR"
  },
  {
    "codigo":1290115008,
    "descripcion":"TUMOR DE PÁNCREAS SECRETOR DE FACTOR LIBERADOR DE HORMONA DE CRECIMIENTO"
  },
  {
    "codigo":75864003,
    "descripcion":"SÍNTOMA PSIQUIÁTRICO"
  },
  {
    "codigo":234941000119100,
    "descripcion":"GLIOMA MALIGNO DE OJO"
  },
  {
    "codigo":205101001,
    "descripcion":"PECTUS CARINATUM CONGÉNITO"
  },
  {
    "codigo":403544009,
    "descripcion":"HEMANGIOMA PLANO CON ANOMALÍAS ASOCIADAS"
  },
  {
    "codigo":237869003,
    "descripcion":"AMILOIDOSIS HEREDITARIA LOCALIZADA"
  },
  {
    "codigo":8493009,
    "descripcion":"GASTRITIS CRÓNICA"
  },
  {
    "codigo":399874002,
    "descripcion":"RETINOPATÍA PROLIFERATIVA DE ALTO RIESGO CON EDEMA DE MÁCULA CLÍNICAMENTE SIGNIFICATIVO DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":301570003,
    "descripcion":"CAPAZ DE MOVILIZARSE CON DISPOSITIVO ORTOPÉDICO"
  },
  {
    "codigo":97571000119109,
    "descripcion":"TROMBOCITOPENIA CONCOMITANTE CON ALCOHOLISMO Y DEBIDA A ÉL"
  },
  {
    "codigo":234199000,
    "descripcion":"CALCIFICACIÓN DE INJERTO VASCULAR"
  },
  {
    "codigo":299735001,
    "descripcion":"LESIÓN NEUROLÓGICA"
  },
  {
    "codigo":365271002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA USAR EL MICROONDAS"
  },
  {
    "codigo":39426009,
    "descripcion":"INFESTACIÓN CAUSADA POR SARCOPHAGIDAE"
  },
  {
    "codigo":199596001,
    "descripcion":"TRABAJO DE PARTO Y PARTO COMPLICADOS POR ANOMALÍA EN LA FRECUENCIA CARDÍACA FETAL Y PRESENCIA DE MECONIO EN LÍQUIDO AMNIÓTICO"
  },
  {
    "codigo":363436001,
    "descripcion":"NEOPLASIA MALIGNA DE ENDOCARDIO"
  },
  {
    "codigo":71101000119106,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA RECURRENTE DE VAGINA"
  },
  {
    "codigo":232364006,
    "descripcion":"PAPILOMA DEL VESTÍBULO NASAL"
  },
  {
    "codigo":166828006,
    "descripcion":"COLESTEROL SÉRICO DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":723884008,
    "descripcion":"ÚLCERA DUODENAL CAUSADA POR BACTERIA"
  },
  {
    "codigo":396204009,
    "descripcion":"MARGEN QUIRÚRGICO DE LA FASCIA DE GEROTA COMPROMETIDO POR NEOPLASIA MALIGNA"
  },
  {
    "codigo":197761005,
    "descripcion":"PIELONEFRITIS CRÓNICA CON NECROSIS MEDULAR"
  },
  {
    "codigo":230529008,
    "descripcion":"FALLA CONGÉNITA DE LA ELEVACIÓN OCULAR"
  },
  {
    "codigo":359766000,
    "descripcion":"CATARATA ESCLERÓTICA NUCLEAR"
  },
  {
    "codigo":294230007,
    "descripcion":"ALERGIA A PANCURONIO"
  },
  {
    "codigo":292395001,
    "descripcion":"REACCIÓN ADVERSA A LA PROMAZINA"
  },
  {
    "codigo":128555001,
    "descripcion":"FÍSTULA CONGÉNITA DE ARTERIA CORONARIA A AURÍCULA IZQUIERDA"
  },
  {
    "codigo":95787007,
    "descripcion":"NISTAGMO POSICIONAL NO FATIGABLE"
  },
  {
    "codigo":421632000,
    "descripcion":"CONJUNTIVITIS PAPILAR RELACIONADA CON EL USO DE LENTES DE CONTACTO"
  },
  {
    "codigo":16019031000119105,
    "descripcion":"ATEROSCLEROSIS DE INJERTO-PUENTE DE VENA AUTÓLOGA DE EXTREMIDAD SUPERIOR DERECHA"
  },
  {
    "codigo":1306368003,
    "descripcion":"SARCOMA DE PROLONGACIÓN AXILAR DE MAMA"
  },
  {
    "codigo":93952004,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL PERITONEO PÉLVICO"
  },
  {
    "codigo":126720005,
    "descripcion":"NEOPLASIA DE LA PLEURA PARIETAL"
  },
  {
    "codigo":290391000119106,
    "descripcion":"DEGENERACIÓN MULTISISTÉMICA DE SISTEMA NERVIOSO AUTÓNOMO"
  },
  {
    "codigo":225024004,
    "descripcion":"ETAPA DE CULPA EN EL PROCESO DE DUELO"
  },
  {
    "codigo":92117002,
    "descripcion":"NEOPLASIA BENIGNA DE LA VESÍCULA BILIAR"
  },
  {
    "codigo":59349003,
    "descripcion":"CARPOPTOSIA"
  },
  {
    "codigo":57514000,
    "descripcion":"DEFICIENCIA DE 3 - OXO - 5 - ALFA ESTEROIDE DELTA 4 - DESHIDROGENASA"
  },
  {
    "codigo":26581009,
    "descripcion":"FALSIFICACIÓN RETROSPECTIVA"
  },
  {
    "codigo":345841000119102,
    "descripcion":"HEMORRAGIA INTRAOCULAR BILATERAL"
  },
  {
    "codigo":188586002,
    "descripcion":"ENFERMEDAD DE HODGKIN, DEPLECIÓN LINFOCITARIA DE GANGLIOS LINFÁTICOS INTRATORÁCICOS"
  },
  {
    "codigo":286890004,
    "descripcion":"CARCINOMA DE HUESOS DE LA EXTREMIDAD INFERIOR"
  },
  {
    "codigo":254122007,
    "descripcion":"OSTEOPETROSIS CON ACIDOSIS TUBULAR RENAL"
  },
  {
    "codigo":1204394008,
    "descripcion":"DILATACIÓN DE URETRA"
  },
  {
    "codigo":285055002,
    "descripcion":"USA AUDÍFONO"
  },
  {
    "codigo":711039004,
    "descripcion":"ACROBRAQUICEFALIA"
  },
  {
    "codigo":22911007,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN DE REGIÓN DE HOMBRO"
  },
  {
    "codigo":55679008,
    "descripcion":"NEUMONÍA PERIBRONQUIAL"
  },
  {
    "codigo":709204000,
    "descripcion":"NEOPLASIA DE CÉLULAS GIGANTES DE CLAVÍCULA"
  },
  {
    "codigo":15664881000119106,
    "descripcion":"TUMOR TENOSINOVIAL DIFUSO DE CÉLULAS GIGANTES DE PIE DERECHO"
  },
  {
    "codigo":414292006,
    "descripcion":"FRACTURA DE PIERNA"
  },
  {
    "codigo":15638411000119100,
    "descripcion":"TENDINITIS PERONEA DE AMBAS PIERNAS"
  },
  {
    "codigo":283220006,
    "descripcion":"ANZUELO EN LA ESPINILLA"
  },
  {
    "codigo":237451000119100,
    "descripcion":"VÍCTIMA ADULTA DE MALTRATO FÍSICO"
  },
  {
    "codigo":84777002,
    "descripcion":"DESPLAZAMIENTO DE LA GLÁNDULA LAGRIMAL"
  },
  {
    "codigo":707369002,
    "descripcion":"GRANULOMA HIALINIZANTE DE PULMÓN ÚNICO"
  },
  {
    "codigo":1297193003,
    "descripcion":"DETENCIÓN DE CRECIMIENTO EPIFISARIO DE FÉMUR"
  },
  {
    "codigo":19241004,
    "descripcion":"LUXACIÓN EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA DE MANO"
  },
  {
    "codigo":248617006,
    "descripcion":"RESONANCIA VOCAL DISMINUIDA"
  },
  {
    "codigo":1231657009,
    "descripcion":"SARCOIDOSIS DE GLÁNDULA LAGRIMAL"
  },
  {
    "codigo":838441009,
    "descripcion":"SÍNDROME MASA"
  },
  {
    "codigo":17406005,
    "descripcion":"VENAS VARICOSAS DE PELVIS"
  },
  {
    "codigo":246782008,
    "descripcion":"PARÁLISIS MIOSTÁTICA"
  },
  {
    "codigo":212179002,
    "descripcion":"LESIÓN MEDULAR DORSAL CENTRAL SIN LESIÓN OSTEOVERTEBRAL, T7-T12"
  },
  {
    "codigo":81107006,
    "descripcion":"DIVERTÍCULO CONGÉNITO DE VEJIGA URINARIA"
  },
  {
    "codigo":1258920002,
    "descripcion":"TRICODINIA"
  },
  {
    "codigo":210344002,
    "descripcion":"HERIDA ABIERTA DE LABIO"
  },
  {
    "codigo":292901000119100,
    "descripcion":"GRANULOMA SUBDURAL INTRACRANEAL"
  },
  {
    "codigo":277939004,
    "descripcion":"MIOPATÍA CRÓNICA CON HIPOCALCEMIA E HIPOFOSFATEMIA"
  },
  {
    "codigo":77437008,
    "descripcion":"OBSTRUCCIÓN INTESTINAL COMO CONSECUENCIA DE PROCEDIMIENTO"
  },
  {
    "codigo":403282000,
    "descripcion":"ALINEAMIENTO ANÓMALO CONGÉNITO DE MÚLTIPLES UÑAS DE LOS PIES"
  },
  {
    "codigo":110205008,
    "descripcion":"QUEMADURA DE TERCER GRADO DEL VESTÍBULO MANDIBULAR"
  },
  {
    "codigo":370514003,
    "descripcion":"ENTEROTOXEMIA"
  },
  {
    "codigo":698194006,
    "descripcion":"RESORCIÓN DE RAÍZ DE DIENTE"
  },
  {
    "codigo":1288018007,
    "descripcion":"ARTROSIS SECUNDARIA DE PIE"
  },
  {
    "codigo":8231007,
    "descripcion":"DEPÓSITO AMILOIDE OCULAR"
  },
  {
    "codigo":1220647008,
    "descripcion":"HEMATOMA DE CÚPULA VAGINAL POSTERIOR A PROCEDIMIENTO QUIRÚRGICO"
  },
  {
    "codigo":71932004,
    "descripcion":"DILATACIÓN CARDÍACA"
  },
  {
    "codigo":348351000119100,
    "descripcion":"HIALOSIS ASTEROIDE DE OJO DERECHO"
  },
  {
    "codigo":792828007,
    "descripcion":"PULSO EN ARTERIA TIBIAL POSTERIOR DERECHA NORMAL"
  },
  {
    "codigo":301308008,
    "descripcion":"SOPLADOR ROSADO"
  },
  {
    "codigo":102865001,
    "descripcion":"CRISTALURIA POR ÁCIDO ÚRICO"
  },
  {
    "codigo":399612008,
    "descripcion":"COMPROMISO TUMORAL DE MARGEN DE RESECCIÓN QUIRÚRGICA LATERAL, NO PUEDE SER EVALUADO"
  },
  {
    "codigo":299473003,
    "descripcion":"PIE MÓVIL"
  },
  {
    "codigo":233937007,
    "descripcion":"EMBOLIA PULMONAR MASIVA SUBAGUDA"
  },
  {
    "codigo":365009008,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA USAR VOCALES SIMPLES"
  },
  {
    "codigo":35494007,
    "descripcion":"CLIC DE ORTOLANI"
  },
  {
    "codigo":723622007,
    "descripcion":"PARAPLEJÍA ESPÁSTICA LIGADA AL CROMOSOMA X TIPO 2"
  },
  {
    "codigo":164731000,
    "descripcion":"TONOMETRÍA ANORMAL"
  },
  {
    "codigo":721787000,
    "descripcion":"INFECCIÓN CAUSADA POR RUBULAVIRUS"
  },
  {
    "codigo":230267005,
    "descripcion":"MAL DE ALZHEIMER FAMILIAR DE INICIO TARDÍO"
  },
  {
    "codigo":263035007,
    "descripcion":"SUBLUXACIÓN DE ARTICULACIÓN COSTOCONDRAL"
  },
  {
    "codigo":33659008,
    "descripcion":"CICATRIZ QUELOIDE"
  },
  {
    "codigo":426875007,
    "descripcion":"DIABETES MELLITUS AUTOINMUNITARIA LATENTE EN EL ADULTO"
  },
  {
    "codigo":16623961000119100,
    "descripcion":"PANCITOPENIA CAUSADA POR AGENTE INMUNOSUPRESOR"
  },
  {
    "codigo":293968008,
    "descripcion":"ALERGIA A CELIPROLOL"
  },
  {
    "codigo":29989001,
    "descripcion":"ÁNTRAX DE LA PARED ABDOMINAL"
  },
  {
    "codigo":292133002,
    "descripcion":"REACCIÓN ADVERSA A LA METOCLOPRAMIDA"
  },
  {
    "codigo":95525004,
    "descripcion":"HIPOESTESIA ORAL"
  },
  {
    "codigo":128293007,
    "descripcion":"TRASTORNO MENTAL CRÓNICO"
  },
  {
    "codigo":1142266001,
    "descripcion":"HIPERTROFIA DE MÚSCULO DE ARTICULACIÓN DE HOMBRO"
  },
  {
    "codigo":60922004,
    "descripcion":"QUIMERA HETERÓLOGA"
  },
  {
    "codigo":28154007,
    "descripcion":"DISFUNCIÓN SEXUAL FEMENINA"
  },
  {
    "codigo":93690007,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE VASO SANGUÍNEO ABDOMINAL"
  },
  {
    "codigo":290298009,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR PIROXICAM"
  },
  {
    "codigo":91855006,
    "descripcion":"LEUCEMIA AGUDA"
  },
  {
    "codigo":1304271006,
    "descripcion":"EDEMA DE MUSLO DERECHO"
  },
  {
    "codigo":188324003,
    "descripcion":"NEOPLASIA MALIGNA DE NERVIOS PERIFÉRICOS DE EXTREMIDAD INFERIOR, INCLUIDA LA CADERA"
  },
  {
    "codigo":219257002,
    "descripcion":"LESIÓN POR INTERVENCIÓN LEGAL CON ARMA DE FUEGO"
  },
  {
    "codigo":252025007,
    "descripcion":"MECANISMO DE CIERRE URETRAL INCOMPETENTE"
  },
  {
    "codigo":22649008,
    "descripcion":"FOTODERMATITIS"
  },
  {
    "codigo":448633007,
    "descripcion":"OBSTRUCCIÓN AL TRACTO DE SALIDA DE VENTRÍCULO DERECHO DEBIDA A VÁLVULA AURICULOVENTRICULAR"
  },
  {
    "codigo":284793009,
    "descripcion":"INCAPAZ DE DUCHARSE"
  },
  {
    "codigo":414030009,
    "descripcion":"TRASTORNO DE ESTRUCTURA INMUNOLÓGICA"
  },
  {
    "codigo":84515001,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM XENOPI"
  },
  {
    "codigo":444963007,
    "descripcion":"PÉRDIDA DE VOLUMEN LABIAL"
  },
  {
    "codigo":10754701000119100,
    "descripcion":"HERPES SIMPLE GENITAL EN LA MADRE QUE COMPLICA EL NACIMIENTO"
  },
  {
    "codigo":836344007,
    "descripcion":"NEOPLASIA UROTELIAL DE BAJO GRADO HALLADA EN LA CITOLOGÍA URINARIA"
  },
  {
    "codigo":408525000,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: AKA"
  },
  {
    "codigo":17144009,
    "descripcion":"FIBROCONDROGÉNESIS"
  },
  {
    "codigo":439458000,
    "descripcion":"ENFERMEDAD POR DEFICIENCIA DE FACTOR I"
  },
  {
    "codigo":111778001,
    "descripcion":"INTOXICACIÓN POR IONÓFORO"
  },
  {
    "codigo":372087000,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA"
  },
  {
    "codigo":109943004,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LOS NERVIOS PERIFÉRICOS ABDOMINALES"
  },
  {
    "codigo":1254988002,
    "descripcion":"DEPENDENCIA DE SUSTANCIAS EN MADRE QUE COMPLICA EMBARAZO, PARTO Y\/O PUERPERIO"
  },
  {
    "codigo":350861000119106,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE GLÁNDULA SUPRARRENAL DERECHA"
  },
  {
    "codigo":75340008,
    "descripcion":"QUERATOCONO CONGÉNITO POSTERIOR CIRCUNSCRIPTO"
  },
  {
    "codigo":10836621000119107,
    "descripcion":"FRACTURA ABIERTA DE BASE DE SEGUNDO HUESO METACARPIANO DE MANO IZQUIERDA"
  },
  {
    "codigo":1187617004,
    "descripcion":"ENFERMEDAD DE CHARCOT-MARIE-TOOTH TIPO 2S"
  },
  {
    "codigo":366582000,
    "descripcion":"HALLAZGO RELACIONADO CON LA PRUEBA DE ORTOLANI"
  },
  {
    "codigo":302881009,
    "descripcion":"TROMBOFLEBITIS SÉPTICA DE SENO LATERAL"
  },
  {
    "codigo":71670002,
    "descripcion":"INFESTACIÓN CAUSADA POR MYOBIA"
  },
  {
    "codigo":169974005,
    "descripcion":"AMAMANTADO Y ALIMENTADO CON SUPLEMENTOS A LAS 6 SEMANAS"
  },
  {
    "codigo":399350006,
    "descripcion":"BAJO SEGUIMIENTO"
  },
  {
    "codigo":364747001,
    "descripcion":"HALLAZGO RELACIONADO CON LA PRESENTACIÓN FETAL"
  },
  {
    "codigo":200907003,
    "descripcion":"PÉNFIGO MEDICAMENTOSO"
  },
  {
    "codigo":299211005,
    "descripcion":"AMPUTADO A NIVEL DEL CUARTO DELANTERO"
  },
  {
    "codigo":397515005,
    "descripcion":"BLEFAROCONJUNTIVITIS POR MOLUSCO CONTAGIOSO"
  },
  {
    "codigo":102603008,
    "descripcion":"ENTUMECIMIENTO DE LA PIEL"
  },
  {
    "codigo":233675009,
    "descripcion":"ENFISEMA TÓXICO"
  },
  {
    "codigo":231840003,
    "descripcion":"INSUFICIENCIA DE SACO LAGRIMAL"
  },
  {
    "codigo":15698881000119100,
    "descripcion":"ÚLCERA DE CÓRNEA IZQUIERDA CAUSADA POR ACANTHAMOEBA"
  },
  {
    "codigo":723360007,
    "descripcion":"HIPERCOLANEMIA FAMILIAR"
  },
  {
    "codigo":788896009,
    "descripcion":"CONTUSIÓN DE ARCO PALMAR SUPERFICIAL"
  },
  {
    "codigo":295541001,
    "descripcion":"SOBREDOSIS DE TRICLOROETILENO"
  },
  {
    "codigo":262773008,
    "descripcion":"HEMATOMA DE GLÁNDULA TIROIDES"
  },
  {
    "codigo":293706001,
    "descripcion":"ALERGIA A ETOMIDATO"
  },
  {
    "codigo":721525008,
    "descripcion":"SÍNDROME DE BROWN-SEQUARD AL NIVEL DEL SEGUNDO SEGMENTO LUMBAR"
  },
  {
    "codigo":11793191000119109,
    "descripcion":"SUBLUXACIÓN DE ARTICULACIÓN DE DEDO MEDIO DE MANO DERECHA"
  },
  {
    "codigo":129866007,
    "descripcion":"CONOCIMIENTOS ESCASOS ACERCA DE LAS PAUTAS POSOLÓGICAS"
  },
  {
    "codigo":11828821000119100,
    "descripcion":"AMPOLLA DE MUSLO IZQUIERDO, CON INFECCIÓN"
  },
  {
    "codigo":95263006,
    "descripcion":"ENFERMEDAD DE SÉZARY DEL BAZO"
  },
  {
    "codigo":291871009,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR OXITOCINA"
  },
  {
    "codigo":93428002,
    "descripcion":"ALTERACIÓN DE LA COLORACIÓN DEL BAZO"
  },
  {
    "codigo":716020005,
    "descripcion":"EMBRIOPATÍA DIABÉTICA"
  },
  {
    "codigo":224500007,
    "descripcion":"CUIDADOR QUE VIVE EN LA CERCANÍA"
  },
  {
    "codigo":879860009,
    "descripcion":"AUSENCIA DE PULSO EN PIE DERECHO"
  },
  {
    "codigo":124361005,
    "descripcion":"DEFICIENCIA DE 3 - MERCAPTOPIRUVATO SULFUROTRANSFERASA"
  },
  {
    "codigo":419273006,
    "descripcion":"DESGARRO EN CAPSULOTOMÍA ANTERIOR"
  },
  {
    "codigo":253598002,
    "descripcion":"VÁLVULA PULMONAR UNICÚSPIDE"
  },
  {
    "codigo":286366005,
    "descripcion":"DIFICULTAD PARA UTILIZAR EL LENGUAJE"
  },
  {
    "codigo":384670007,
    "descripcion":"MICROCALCIFICACIONES NO IDENTIFICADAS EN EL ESPÉCIMEN"
  },
  {
    "codigo":188062008,
    "descripcion":"MELANOMA MALIGNO DE ANTEBRAZO"
  },
  {
    "codigo":448371005,
    "descripcion":"LINFOMA NO HODGKIN DE NASOFARINGE"
  },
  {
    "codigo":284531007,
    "descripcion":"HALLAZGO RELACIONADO CON EL PROCESO DE DUELO"
  },
  {
    "codigo":249928002,
    "descripcion":"NO PUEDE ENCOGERSE DE HOMBRO"
  },
  {
    "codigo":315464007,
    "descripcion":"NACIDO EN LESOTHO"
  },
  {
    "codigo":282696009,
    "descripcion":"CAPAZ DE EMPUJAR Y ARRASTRAR HACIA ATRÁS UN JUGUETE GRANDE CON RUEDAS"
  },
  {
    "codigo":51485001,
    "descripcion":"COLOBOMA CONGÉNITO DE IRIS"
  },
  {
    "codigo":15973621000119101,
    "descripcion":"DEFORMIDAD CONGÉNITA DE MIEMBRO INFERIOR IZQUIERDO"
  },
  {
    "codigo":870685005,
    "descripcion":"INCAPAZ DE MANEJAR ACTIVIDADES RELACIONADAS CON LA RESIDENCIA"
  },
  {
    "codigo":297778421000119102,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DEBIDO A TROMBOSIS DE AMBAS ARTERIAS CEREBRALES POSTERIORES"
  },
  {
    "codigo":49650001,
    "descripcion":"DISURIA"
  },
  {
    "codigo":705010004,
    "descripcion":"ELEVACIÓN POSTERIOR DE SEGMENTO ST"
  },
  {
    "codigo":703175001,
    "descripcion":"INSUFICIENCIA AGUDA DE VÁLVULA MITRAL PROTÉSICA"
  },
  {
    "codigo":1260231004,
    "descripcion":"TATUAJE DE LENGUA"
  },
  {
    "codigo":80583007,
    "descripcion":"ANSIEDAD SEVERA (PÁNICO)"
  },
  {
    "codigo":1292999008,
    "descripcion":"TUMOR FIBROLIPOMATOSO HEMOSIDERÓTICO"
  },
  {
    "codigo":275356001,
    "descripcion":"COMPLICACIÓN DE PULGAR REIMPLANTADO"
  },
  {
    "codigo":766876004,
    "descripcion":"DEFECTO COMBINADO DE LA FOSFORILACIÓN OXIDATIVA TIPO 4"
  },
  {
    "codigo":13212004,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DE MÚLTIPLES SITIOS"
  },
  {
    "codigo":406428006,
    "descripcion":"HIPERTROFIA DE LA TRABECULACIÓN SEPTOMARGINAL"
  },
  {
    "codigo":111516008,
    "descripcion":"IMAGEN VISUAL BORROSA"
  },
  {
    "codigo":240753003,
    "descripcion":"RINOSPORIDIOSIS CUTÁNEA"
  },
  {
    "codigo":207985005,
    "descripcion":"FRACTURAS MÚLTIPLES DE COLUMNA VERTEBRAL CERVICAL"
  },
  {
    "codigo":44145005,
    "descripcion":"EPILEPSIA AUTOLIMITADA CON ESPIGAS CENTROTEMPORALES"
  },
  {
    "codigo":109681007,
    "descripcion":"CRESTA ALVEOLAR DESDENTADA CORTANTE"
  },
  {
    "codigo":402758001,
    "descripcion":"PROBLEMA CON CICATRIZ QUIRÚRGICA"
  },
  {
    "codigo":371825009,
    "descripcion":"PACIENTE EN TRATAMIENTO CON OXÍGENO"
  },
  {
    "codigo":271686007,
    "descripcion":"VEJIGA URINARIA NO PALPABLE"
  },
  {
    "codigo":1254726007,
    "descripcion":"METÁSTASIS DE CARCINOMA ADENOIDE QUÍSTICO EN GLÁNDULA SALIVAL"
  },
  {
    "codigo":237083000,
    "descripcion":"CERVICITIS GONOCÓCICA"
  },
  {
    "codigo":204315000,
    "descripcion":"DEFECTO SEPTAL AURICULAR TIPO OSTIUM SECUNDUM"
  },
  {
    "codigo":7707000,
    "descripcion":"EDAD GESTACIONAL, 32 SEMANAS"
  },
  {
    "codigo":1285659003,
    "descripcion":"ENFERMEDAD MODERADA POR DEFICIENCIA HEREDITARIA DE FACTOR VIII CON INHIBIDOR DE ALTA RESPUESTA"
  },
  {
    "codigo":202480001,
    "descripcion":"DOLOR EN ARTICULACIÓN DE CODO"
  },
  {
    "codigo":300784003,
    "descripcion":"DIFICULTAD PARA PARTICIPAR EN JUEGOS POR DIVERSIÓN"
  },
  {
    "codigo":399088004,
    "descripcion":"PARÁLISIS DE NERVIO CIÁTICO POPLÍTEO EXTERNO"
  },
  {
    "codigo":431856006,
    "descripcion":"ENFERMEDAD RENAL CRÓNICA, ESTADIO 2"
  },
  {
    "codigo":366320007,
    "descripcion":"REFLEJO DE PRENSIÓN PALMAR - HALLAZGO"
  },
  {
    "codigo":724933004,
    "descripcion":"DISTENSIÓN DE FASCIA DE TRÍCEPS BRAQUIAL"
  },
  {
    "codigo":200645004,
    "descripcion":"CELULITIS Y ABSCESO DE LA CARA"
  },
  {
    "codigo":2202000,
    "descripcion":"LUXACIÓN EXPUESTA POSTERIOR DE EXTREMO DISTAL DE FÉMUR"
  },
  {
    "codigo":298949008,
    "descripcion":"AMPLITUD DE FLEXIÓN ACTIVA DE LA MUÑECA NORMAL"
  },
  {
    "codigo":723098004,
    "descripcion":"INFECCIÓN PARASITARIA QUE CAUSA GASTRITIS"
  },
  {
    "codigo":198810005,
    "descripcion":"INTENTO FALLIDO DE ABORTO CON TRASTORNO METABÓLICO"
  },
  {
    "codigo":460954009,
    "descripcion":"INSERCIÓN ANÓMALA DE LIGAMENTO ARTERIOSO EN ARTERIA PULMONAR IZQUIERDA DISTAL"
  },
  {
    "codigo":33135002,
    "descripcion":"DEPRESIÓN MAYOR RECURRENTE EN REMISIÓN PARCIAL"
  },
  {
    "codigo":426351003,
    "descripcion":"DOLOR PROVOCADO POR LEVANTAR PESOS"
  },
  {
    "codigo":229743004,
    "descripcion":"DESARROLLO LIMITADO DEL LENGUAJE RECEPTIVO"
  },
  {
    "codigo":1149082009,
    "descripcion":"SATISFECHO CON LA IMAGEN CORPORAL"
  },
  {
    "codigo":295279005,
    "descripcion":"SOBREDOSIS DE NEFOPAM"
  },
  {
    "codigo":129604005,
    "descripcion":"DELIRIO DE ENFERMEDAD CARDÍACA"
  },
  {
    "codigo":11824681000119106,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":95001001,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA FARINGE"
  },
  {
    "codigo":293444009,
    "descripcion":"REACCIÓN ADVERSA A LA MORACIZINA"
  },
  {
    "codigo":350041000221100,
    "descripcion":"MICOSIS OCULAR POR LEVADURAS"
  },
  {
    "codigo":1010670004,
    "descripcion":"NEUMONITIS LIPOIDE ENDÓGENA CRÓNICA"
  },
  {
    "codigo":93166005,
    "descripcion":"MICRODONCIA LOCALIZADA"
  },
  {
    "codigo":289774005,
    "descripcion":"CUELLO UTERINO FIRME"
  },
  {
    "codigo":715758005,
    "descripcion":"ACCESO A LA RESIDENCIA POR ESCALERAS"
  },
  {
    "codigo":1141742009,
    "descripcion":"INSUFICIENCIA DE VÁLVULA AURICULOVENTRICULAR DERECHA (MORFOLÓGICAMENTE NO TRICÚSPIDE)"
  },
  {
    "codigo":255171005,
    "descripcion":"PÓLIPO DE YEYUNO"
  },
  {
    "codigo":419011006,
    "descripcion":"EXPRESA VERBALMENTE EL CUMPLIMIENTO CON LA MEDICACIÓN"
  },
  {
    "codigo":253336000,
    "descripcion":"ISOMERISMO DE APÉNDICE AURICULAR DERECHO"
  },
  {
    "codigo":89496002,
    "descripcion":"SORDERA TRAUMÁTICA"
  },
  {
    "codigo":56728002,
    "descripcion":"CERVICITIS CRÓNICA"
  },
  {
    "codigo":1731000119106,
    "descripcion":"INFECCIÓN DE PULMÓN POR MICOBACTERIAS ATÍPICAS"
  },
  {
    "codigo":251501008,
    "descripcion":"ONDAS PICUDAS FOCALES EPISÓDICAS"
  },
  {
    "codigo":22125009,
    "descripcion":"PANICULITIS"
  },
  {
    "codigo":282434001,
    "descripcion":"AVULSIÓN DE VESÍCULA BILIAR"
  },
  {
    "codigo":184130003,
    "descripcion":"ES CUESTIONABLE SI EL SEXO DEL PACIENTE ES CORRECTO"
  },
  {
    "codigo":1003330007,
    "descripcion":"SINDACTILIA SIMPLE DE DEDOS DEL PIE DEL PRIMER ESPACIO INTERDIGITAL BILATERAL"
  },
  {
    "codigo":772119000,
    "descripcion":"REQUIERE COMPONENTE SANGUÍNEO NEGATIVO PARA EL VIRUS DE LA HEPATITIS E"
  },
  {
    "codigo":83991006,
    "descripcion":"LESIÓN INCOMPLETA DE LA MÉDULA ESPINAL A NIVEL DE C5 - C7 SIN LESIÓN TRAUMÁTICA ÓSEA"
  },
  {
    "codigo":247831006,
    "descripcion":"MIEDO A CRUZAR LAS CALLES"
  },
  {
    "codigo":1263639008,
    "descripcion":"METÁSTASIS DE CARCINOMA DE CÉLULAS TRANSICIONALES EN VEJIGA URINARIA"
  },
  {
    "codigo":1163500007,
    "descripcion":"INFECCIÓN PALPEBRAL POR MYCOBACTERIUM LEPRAE"
  },
  {
    "codigo":49388007,
    "descripcion":"ESGUINCE DE PIE"
  },
  {
    "codigo":211393004,
    "descripcion":"LESIÓN SUPERFICIAL EN EL MIEMBRO INFERIOR, INFECTADA"
  },
  {
    "codigo":14785004,
    "descripcion":"SÍNDROME DE MONOFIJACIÓN"
  },
  {
    "codigo":16005111000119102,
    "descripcion":"TRASTORNO DE NERVIO AXILAR IZQUIERDO"
  },
  {
    "codigo":1290902000,
    "descripcion":"SARCOMA FIBROBLÁSTICO MIXOINFLAMATORIO"
  },
  {
    "codigo":80321008,
    "descripcion":"GLOMERULONEFRITIS MESANGIOCAPILAR"
  },
  {
    "codigo":373398004,
    "descripcion":"PLEOMORFISMO NUCLEAR GRADO 1: NÚCLEOS MONÓTONOS, 1,5 - 2,0 DIÁMETROS ERITROCÍTICOS, CON CROMATINA FINAMENTE DISPERSA Y SÓLO NUCLÉOLOS OCASIONALES"
  },
  {
    "codigo":111254007,
    "descripcion":"OSTEÍTIS DEFORMANTE SIN TUMOR DE HUESO"
  },
  {
    "codigo":76651006,
    "descripcion":"FARINGITIS NEUMOCÓCICA"
  },
  {
    "codigo":1354603007,
    "descripcion":"FRACTURA DE FALANGE MEDIA DE DEDO ANULAR"
  },
  {
    "codigo":109419009,
    "descripcion":"DISOSTOSIS MANDIBULOACRAL"
  },
  {
    "codigo":369728001,
    "descripcion":"AUSENCIA DE INVASIÓN TUMORAL EN PEQUEÑOS VASOS"
  },
  {
    "codigo":238656002,
    "descripcion":"LIQUEN PLANO DE PALMAS Y PLANTAS"
  },
  {
    "codigo":402496001,
    "descripcion":"CARCINOMA BASOCELULAR DE CANTO EXTERNO"
  },
  {
    "codigo":171285001,
    "descripcion":"SIN CONSENTIMIENTO PARA VACUNACIÓN PREESCOLAR"
  },
  {
    "codigo":236821005,
    "descripcion":"FRACASO DE LA PENETRACIÓN"
  },
  {
    "codigo":1285397009,
    "descripcion":"RECTOCELE MASCULINO"
  },
  {
    "codigo":366058002,
    "descripcion":"COMPORTAMIENTO VISUAL - HALLAZGO"
  },
  {
    "codigo":890346002,
    "descripcion":"HOLOPROSENCEFALIA CONCOMITANTE CON ESTENOSIS CONGÉNITA DE APERTURA PIRIFORME NASAL"
  },
  {
    "codigo":234986004,
    "descripcion":"COLORACIÓN DENTAL INTRÍNSECA INDUCIDA POR DROGAS"
  },
  {
    "codigo":202218004,
    "descripcion":"LUXACIÓN RECURRENTE DE HOMBRO - MULTIDIRECCIONAL"
  },
  {
    "codigo":298687002,
    "descripcion":"ELEVACIÓN DE LA PIERNA EXTENDIDA, DISMINUIDA"
  },
  {
    "codigo":822975003,
    "descripcion":"MALFORMACIÓN ARTERIOVENOSA CONGÉNITA DE DUODENO"
  },
  {
    "codigo":429759002,
    "descripcion":"PÉRDIDA DE LÍQUIDO CEFALORRAQUÍDEO POR NARIZ Y BOCA"
  },
  {
    "codigo":724671005,
    "descripcion":"ALTERACIONES PERCEPTIVAS Y CONVULSIONES CONCOMITANTES CON ABSTINENCIA DE SEDANTE Y DEBIDAS A ELLA"
  },
  {
    "codigo":165780000,
    "descripcion":"TÍTULO PARA SÍFILIS NEGATIVO"
  },
  {
    "codigo":427924001,
    "descripcion":"EXTRAVASACIÓN DE MEDIO DE CONTRASTE INTRAVENOSO"
  },
  {
    "codigo":36543008,
    "descripcion":"DIPLOACUSIA ECOICA"
  },
  {
    "codigo":11774251000119100,
    "descripcion":"CONTUSIÓN DE DEDO MEÑIQUE IZQUIERDO"
  },
  {
    "codigo":1148820009,
    "descripcion":"SOBRECARGA DE FLUIDOS INTRAOPERATORIA"
  },
  {
    "codigo":131177005,
    "descripcion":"NIVEL DE FIBRINÓGENO POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":63806000,
    "descripcion":"INTOXICACIÓN POR HYMENOXYS ODERATA"
  },
  {
    "codigo":719166003,
    "descripcion":"DISPLASIA ESPONDILOMETAFISARIA TIPO MATRILINA 3"
  },
  {
    "codigo":31038006,
    "descripcion":"DESIGUALDAD EN LA RELACIÓN VENTILACIÓN - PERFUSIÓN"
  },
  {
    "codigo":717331000,
    "descripcion":"QUISTE DE CONDUCTO TIROGLOSO FAMILIAR"
  },
  {
    "codigo":1208851000,
    "descripcion":"PATRÓN ELECTROCARDIOGRÁFICO DE BRUGADA PROVOCADO"
  },
  {
    "codigo":225811003,
    "descripcion":"ABIERTO A LA EXPLOTACIÓN"
  },
  {
    "codigo":51431000087101,
    "descripcion":"PANSEXUAL"
  },
  {
    "codigo":94739006,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA PARED ANTERIOR DE LA NASOFARINGE"
  },
  {
    "codigo":25831000087102,
    "descripcion":"VIVE CON CUIDADOR PRIMARIO"
  },
  {
    "codigo":43751000087104,
    "descripcion":"TRASTORNO DE TENDÓN DE REGIÓN DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":92904001,
    "descripcion":"FORMA ANORMAL CONGÉNITA DEL CEREBELO"
  },
  {
    "codigo":41191000087106,
    "descripcion":"HERIDA PUNZANTE DE OÍDO IZQUIERDO CON CUERPO EXTRAÑO"
  },
  {
    "codigo":46311000087105,
    "descripcion":"FRACTURA DE EXTREMO PROXIMAL DE RADIO DERECHO"
  },
  {
    "codigo":289512004,
    "descripcion":"VAGINA NO OBSERVADA"
  },
  {
    "codigo":387816002,
    "descripcion":"DEFICIENCIA DE HIDROXIALQUILPROTEÍNA CINASA"
  },
  {
    "codigo":713661000,
    "descripcion":"CAPAZ DE COMPLETAR UNA ORACIÓN EN UNA RESPIRACIÓN"
  },
  {
    "codigo":60136008,
    "descripcion":"TUBERCULOSIS INTESTINAL"
  },
  {
    "codigo":123837003,
    "descripcion":"INADECUADO PARA EVALUACIÓN POR PRESENCIA DE INFLAMACIÓN, QUE ENMASCARA LA OBSERVACIÓN"
  },
  {
    "codigo":254909003,
    "descripcion":"CARCINOMA DE PREPUCIO"
  },
  {
    "codigo":25533006,
    "descripcion":"PRODUCCIÓN DE PLAQUETAS DISMINUIDA"
  },
  {
    "codigo":449682004,
    "descripcion":"AUSENCIA CONGÉNITA PARCIAL DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":285842004,
    "descripcion":"CAPACIDAD EMOCIONAL NORMAL"
  },
  {
    "codigo":23698009,
    "descripcion":"PLEURESÍA ESTAFILOCÓCICA CON DERRAME"
  },
  {
    "codigo":21863002,
    "descripcion":"HIPERPLASIA IRRITATIVA DE LA MUCOSA ORAL"
  },
  {
    "codigo":218471002,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR HORMONA FOLICULOESTIMULANTE"
  },
  {
    "codigo":447847006,
    "descripcion":"PROLAPSO DE CÚSPIDE CORONARIA DERECHA DE VÁLVULA AÓRTICA"
  },
  {
    "codigo":709991008,
    "descripcion":"ESQUEMA OCLUSAL SEVERAMENTE COMPROMETIDO"
  },
  {
    "codigo":773692000,
    "descripcion":"SÍNDROME DE EPIDERMÓLISIS BULLOSA DE LA UNIÓN LOCALIZADA Y DISCAPACIDAD INTELECTUAL DE INICIO TARDÍO"
  },
  {
    "codigo":12403141000119105,
    "descripcion":"FUGA DE AMPOLLA FILTRANTE POSTRABECULECTOMÍA IZQUIERDA"
  },
  {
    "codigo":85564003,
    "descripcion":"LESIÓN TRAUMÁTICA DE VASOS SANGUÍNEOS DE CABEZA Y\/O CUELLO"
  },
  {
    "codigo":216636002,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR BEBIDA ALCOHÓLICA METILADA"
  },
  {
    "codigo":1070921000000103,
    "descripcion":"DIFICULTAD PARA HACER COMPRAS EN LÍNEA"
  },
  {
    "codigo":249404009,
    "descripcion":"TRAZOS BLANQUECINOS EN MUCOSA BUCAL"
  },
  {
    "codigo":18193002,
    "descripcion":"HIPOCONDRIASIS"
  },
  {
    "codigo":10656351000119101,
    "descripcion":"ÚLCERA DE DEDO DE PIE DERECHO"
  },
  {
    "codigo":737254001,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO DE REGIÓN LUMBAR"
  },
  {
    "codigo":704486002,
    "descripcion":"DIFICULTAD PARA EL MANEJO DE CATÉTER URINARIO"
  },
  {
    "codigo":247569009,
    "descripcion":"ULCERACIÓN DE LOS FOLÍCULOS DE LAS PESTAÑAS"
  },
  {
    "codigo":212966005,
    "descripcion":"EFECTOS DEL HAMBRE"
  },
  {
    "codigo":1359846006,
    "descripcion":"NEOPLASIA MALIGNA DE LABIO SUPERIOR"
  },
  {
    "codigo":16358007,
    "descripcion":"ENFERMEDAD CRÓNICA DE LAS AMÍGDALAS Y\/O ADENOIDES"
  },
  {
    "codigo":1259707002,
    "descripcion":"CARCINOMA SARCOMATOIDE PRIMARIO DE UROTELIO DE URÉTER"
  },
  {
    "codigo":276667003,
    "descripcion":"EMBOLIA GASEOSA VENOSA"
  },
  {
    "codigo":14523006,
    "descripcion":"INFECCIÓN POR CYSTOISOSPORA BELLI"
  },
  {
    "codigo":209296000,
    "descripcion":"FRACTURA-SUBLUXACIÓN EXPUESTA DE ARTICULACIÓN CARPOMETACARPIANA"
  },
  {
    "codigo":735419009,
    "descripcion":"FALLA DE FÍSTULA ARTERIOVENOSA CONSTRUIDA QUIRÚRGICAMENTE"
  },
  {
    "codigo":373136005,
    "descripcion":"CALCIFICACIÓN DE VÁLVULA CARDÍACA"
  },
  {
    "codigo":45456005,
    "descripcion":"INFARTO RENAL"
  },
  {
    "codigo":110992006,
    "descripcion":"UÑA BÍFIDA"
  },
  {
    "codigo":405904006,
    "descripcion":"TUMOR QUE INVADE ESTRUCTURA SUBFASCIAL"
  },
  {
    "codigo":10853001,
    "descripcion":"COMPLICACIÓN OBSTÉTRICA POR LA ANESTESIA GENERAL"
  },
  {
    "codigo":830053004,
    "descripcion":"SÍNDROME DE OVARIO POLIQUÍSTICO DE OVARIO IZQUIERDO"
  },
  {
    "codigo":240229005,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE ARTICULACIÓN DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":404069006,
    "descripcion":"LIPOSARCOMA MIXOIDE"
  },
  {
    "codigo":305765004,
    "descripcion":"VISTO POR DANZATERAPEUTA"
  },
  {
    "codigo":762682000,
    "descripcion":"DISFUNCIÓN DE DERIVACIÓN DE MARCAPASOS CARDÍACO"
  },
  {
    "codigo":764517009,
    "descripcion":"FISURA CRANEOFACIAL"
  },
  {
    "codigo":369466002,
    "descripcion":"TUMOR MALIGNO QUE COMPROMETE LA URETRA POR PROPAGACIÓN DIRECTA DE LA PRÓSTATA"
  },
  {
    "codigo":402234004,
    "descripcion":"ECCEMA, PIE"
  },
  {
    "codigo":238394005,
    "descripcion":"FOLICULITIS CRÓNICA DE LAS PIERNAS"
  },
  {
    "codigo":41786007,
    "descripcion":"DEBILIDAD NEUROLÓGICA DEL MÚSCULO"
  },
  {
    "codigo":39951001,
    "descripcion":"TRASTORNO DE ANSIEDAD INDUCIDO POR CANNABIS"
  },
  {
    "codigo":271162009,
    "descripcion":"AMPOLLA TRAUMÁTICA DE MUÑECA"
  },
  {
    "codigo":236559006,
    "descripcion":"PÉRDIDA DE ULTRAFILTRACIÓN"
  },
  {
    "codigo":7183006,
    "descripcion":"ANOFTALMÍA"
  },
  {
    "codigo":365796000,
    "descripcion":"NIVELES DE TRIGLICÉRIDO SÉRICO - HALLAZGO"
  },
  {
    "codigo":105487009,
    "descripcion":"RECONCILIACIÓN MATRIMONIAL"
  },
  {
    "codigo":70884002,
    "descripcion":"ENCEFALITIS ALÉRGICA"
  },
  {
    "codigo":300260007,
    "descripcion":"CONDUCTO SALIVAL PERMEABLE"
  },
  {
    "codigo":201956008,
    "descripcion":"ARTROPATÍA TRAUMÁTICA DE LA ARTICULACIÓN ASTRAGALONAVICULAR"
  },
  {
    "codigo":298425000,
    "descripcion":"AMPLITUD DE EXTENSIÓN PASIVA DE LA COLUMNA CERVICAL DISMINUIDA"
  },
  {
    "codigo":36281004,
    "descripcion":"ABSCESO DE MUÑECA"
  },
  {
    "codigo":165518003,
    "descripcion":"NEUTROFILIA"
  },
  {
    "codigo":198286004,
    "descripcion":"FÍSTULA DE LA VAGINA AL INTESTINO GRUESO"
  },
  {
    "codigo":296590005,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE KANAMICINA"
  },
  {
    "codigo":722574007,
    "descripcion":"LESIÓN TRAUMÁTICA DE SISTEMA NERVIOSO DENTRAL DEBIDA A TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":294755002,
    "descripcion":"ALERGIA A MEDROXIPROGESTERONA"
  },
  {
    "codigo":336941000119100,
    "descripcion":"XANTOMA DE PÁRPADO IZQUIERDO"
  },
  {
    "codigo":460351000124104,
    "descripcion":"FRACTURA DE HUESO DE CINTURA ESCAPULAR IZQUIERDA"
  },
  {
    "codigo":94477001,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LOS GANGLIOS LINFÁTICOS AXILARES PECTORALES"
  },
  {
    "codigo":292920009,
    "descripcion":"REACCIÓN ADVERSA A FÁRMACO ANTIBACTERIANO"
  },
  {
    "codigo":192781003,
    "descripcion":"LEUCODISTROFIA"
  },
  {
    "codigo":127245003,
    "descripcion":"NEOPLASIA DE LOS GANGLIOS LINFÁTICOS INTRATORÁCICOS"
  },
  {
    "codigo":2111000124109,
    "descripcion":"TÉCNICA DE ADMINISTRACIÓN DE MEDICACIÓN INADECUADA"
  },
  {
    "codigo":225549006,
    "descripcion":"PIEL AMARILLA"
  },
  {
    "codigo":291085000,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR MIDAZOLAM"
  },
  {
    "codigo":429631000124104,
    "descripcion":"HIPOSPADIAS DE GLANDE"
  },
  {
    "codigo":92642005,
    "descripcion":"CARCINOMA IN SITU DE AMÍGDALA LINGUAL"
  },
  {
    "codigo":1335991004,
    "descripcion":"QUISTE DE AMBOS IRIS"
  },
  {
    "codigo":254647005,
    "descripcion":"TERATOMA MEDIASTÍNICO BENIGNO"
  },
  {
    "codigo":1137548000,
    "descripcion":"CALCIFICACIÓN PUNTEADA DE EPÍFISIS DE FALANGE DE DEDO ÍNDICE"
  },
  {
    "codigo":449420002,
    "descripcion":"NEOPLASIA MALIGNA DE CEREBELO"
  },
  {
    "codigo":23436003,
    "descripcion":"CUERPO EXTRAÑO EN EL PUNTO LAGRIMAL"
  },
  {
    "codigo":711564007,
    "descripcion":"COLECISTOLITIASIS CON OBSTRUCCIÓN"
  },
  {
    "codigo":283745008,
    "descripcion":"MORDEDURA DE PERRO EN EL CUELLO"
  },
  {
    "codigo":250977008,
    "descripcion":"ASPECTO DE VÁLVULA AÓRTICA"
  },
  {
    "codigo":85302003,
    "descripcion":"INTOXICACIÓN POR DIFENHIDRAMINA"
  },
  {
    "codigo":609590004,
    "descripcion":"COMPRESIÓN DE NERVIO RADIAL"
  },
  {
    "codigo":281910003,
    "descripcion":"FRACTURA DE APÓFISIS ODONTOIDES"
  },
  {
    "codigo":19766004,
    "descripcion":"TRASTORNO DE PÁNICO CON AGORAFOBIA, EVITACIÓN AGORAFÓBICA LEVE Y ATAQUES DE PÁNICO GRAVES"
  },
  {
    "codigo":314678009,
    "descripcion":"PESO DEL NIÑO: PERCENTILO 50"
  },
  {
    "codigo":249142009,
    "descripcion":"PROGRESO LENTO EN LA PRIMERA ETAPA DEL TRABAJO DE PARTO"
  },
  {
    "codigo":212704001,
    "descripcion":"INTOXICACIÓN POR RESERPINA"
  },
  {
    "codigo":736992003,
    "descripcion":"NEFROPATÍA POSTERIOR A PREECLAMPSIA"
  },
  {
    "codigo":1162976004,
    "descripcion":"ENFERMEDAD HEREDITARIA RECESIVA LIGADA AL CROMOSOMA X"
  },
  {
    "codigo":48864005,
    "descripcion":"FLEXIÓN FETAL COMPLETA"
  },
  {
    "codigo":704224004,
    "descripcion":"FRACTURA EXPUESTA DE SEGUNDA FALANGE DE DEDO MEÑIQUE"
  },
  {
    "codigo":278240007,
    "descripcion":"BLOQUEO DE LA CONDUCCIÓN NERVIOSA MIXTA"
  },
  {
    "codigo":310471000119107,
    "descripcion":"ESCOLIOSIS IDIOPÁTICA INFANTIL DE COLUMNA TORÁCICA"
  },
  {
    "codigo":473013003,
    "descripcion":"HALLAZGO RELACIONADO CON COMPORTAMIENTO SEXUAL"
  },
  {
    "codigo":866229004,
    "descripcion":"TRAUMATISMO DE URETRA Y VEJIGA URINARIA DURANTE EL PARTO"
  },
  {
    "codigo":1259445002,
    "descripcion":"CARCINOMA ESCAMOCELULAR QUERATINIZANTE PRIMARIO DE NASOFARINGE"
  },
  {
    "codigo":210869006,
    "descripcion":"CONTUSIÓN, VENA FEMORAL"
  },
  {
    "codigo":276405004,
    "descripcion":"TESTÍCULO EN EL CONDUCTO INGUINAL"
  },
  {
    "codigo":14261008,
    "descripcion":"QUEMADURA DE BRAZO"
  },
  {
    "codigo":45194000,
    "descripcion":"QUERATITIS MICÓTICA CAUSADA POR FUSARIUM"
  },
  {
    "codigo":241802004,
    "descripcion":"EFECTO TÓXICO CAUSADO POR MOLUSQUICIDA"
  },
  {
    "codigo":307338008,
    "descripcion":"ISOINMUNIZACIÓN DEL RECIÉN NACIDO POR GRUPO SANGUÍNEO KIDD"
  },
  {
    "codigo":403807001,
    "descripcion":"HIPOMELANOSIS FILOIDE"
  },
  {
    "codigo":733322009,
    "descripcion":"LESIÓN TRAUMÁTICA DE ESFÍNTER PUPILAR"
  },
  {
    "codigo":209034009,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA EXPUESTA DE LA ARTICULACIÓN SUBASTRAGALINA"
  },
  {
    "codigo":239967005,
    "descripcion":"CONTRACTURA DE TENDÓN DE REGIÓN DE CODO"
  },
  {
    "codigo":305503006,
    "descripcion":"BAJO ATENCIÓN DE NEURÓLOGO INFANTIL"
  },
  {
    "codigo":371039008,
    "descripcion":"TRASTORNO TROMBOEMBÓLICO"
  },
  {
    "codigo":698719009,
    "descripcion":"VÍCTIMA DE TSUNAMI"
  },
  {
    "codigo":238132000,
    "descripcion":"OBESIDAD ANDROIDE"
  },
  {
    "codigo":205364004,
    "descripcion":"FRACASO EN LA DIFERENCIACIÓN DE PARTES BLANDAS DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":15684961000119106,
    "descripcion":"PERIOSTITIS DE FÉMUR IZQUIERDO"
  },
  {
    "codigo":41524005,
    "descripcion":"FLAGELACIÓN"
  },
  {
    "codigo":11998561000119107,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO DE TOBILLO DERECHO"
  },
  {
    "codigo":11808251000119101,
    "descripcion":"PERFORACIÓN TRAUMÁTICA DE YEYUNO"
  },
  {
    "codigo":301833004,
    "descripcion":"MUESTRA DE ORINA OBTENIDA DE CATÉTER: SIN ANOMALÍAS"
  },
  {
    "codigo":269065005,
    "descripcion":"FRACTURA NO EXPUESTA DE LA TERCERA VÉRTEBRA CERVICAL"
  },
  {
    "codigo":70622003,
    "descripcion":"ENFERMEDAD DE CROHN DEL ANTRO PILÓRICO"
  },
  {
    "codigo":398302004,
    "descripcion":"ANOMALÍA CONGÉNITA DE LA CARA"
  },
  {
    "codigo":234462005,
    "descripcion":"ANOMALÍA ADQUIRIDA DEL FIBRINÓGENO"
  },
  {
    "codigo":365534003,
    "descripcion":"INSTALACIONES DE COMEDOR EN EL TRABAJO - HALLAZGO"
  },
  {
    "codigo":396467002,
    "descripcion":"HALLAZGO RELACIONADO CON EL MARGEN DE RESECCIÓN QUIRÚRGICA PARENQUIMATOSO"
  },
  {
    "codigo":298163003,
    "descripcion":"INFLAMACIÓN DE ARTICULACIÓN DE CODO"
  },
  {
    "codigo":128641000119100,
    "descripcion":"ENFERMEDAD DE INJERTO VERSUS HUÉSPED AGUDA POSTERIOR A TRASPLANTE DE RIÑÓN"
  },
  {
    "codigo":724147004,
    "descripcion":"SÍNDROME DE MICRODELECIÓN 8Q13"
  },
  {
    "codigo":333441000119102,
    "descripcion":"GRANULOMA DE ÓRBITA DERECHA"
  },
  {
    "codigo":336001000119103,
    "descripcion":"DACRIOCISTITIS CRÓNICA DE SACO LAGRIMAL DE OJO DERECHO"
  },
  {
    "codigo":15736961000119103,
    "descripcion":"DEPÓSITO DE PIGMENTO EN CÁPSULA DE CRISTALINO DE OJO IZQUIERDO POSTERIOR A TRAUMATISMO CONTUSO"
  },
  {
    "codigo":16415361000119105,
    "descripcion":"SÍNDROME RADIOLÓGICO AISLADO"
  },
  {
    "codigo":305281000119104,
    "descripcion":"CONTRACTURA DE MÚSCULO DE REGIÓN DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":15724161000119107,
    "descripcion":"ENTESOPATÍA DE RODILLA IZQUIERDA"
  },
  {
    "codigo":15742081000119108,
    "descripcion":"DEFORMIDAD EN VALGO ADQUIRIDA DE AMBOS TOBILLOS"
  },
  {
    "codigo":483082881000119106,
    "descripcion":"TRASTORNO DEBIDO A TRASPLANTE DE CÓRNEA Y POSTERIOR A ÉL"
  },
  {
    "codigo":292481000119104,
    "descripcion":"NEURALGIA DE NERVIO PUDENDO DERECHO"
  },
  {
    "codigo":1070721000119105,
    "descripcion":"RUPTURA PARCIAL NO TRAUMÁTICA DE MANGUITO ROTADOR"
  },
  {
    "codigo":15698561000119107,
    "descripcion":"ABSCESO DE VAINA TENDINOSA DE AMBOS ANTEBRAZOS"
  },
  {
    "codigo":12199041000119109,
    "descripcion":"LUXACIÓN DE PRÓTESIS DE ARTICULACIÓN DE RODILLA IZQUIERDA"
  },
  {
    "codigo":1080961000119108,
    "descripcion":"MELANOMA MALIGNO DE CONJUNTIVA DE OJO IZQUIERDO"
  },
  {
    "codigo":34184002,
    "descripcion":"SÍNDROME DEL CUERPO CALLOSO"
  },
  {
    "codigo":72321000119107,
    "descripcion":"RASGO DREPANOCÍTICO EN LA MADRE QUE COMPLICA EL EMBARAZO"
  },
  {
    "codigo":295041000119108,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE TOBILLO"
  },
  {
    "codigo":15716481000119109,
    "descripcion":"ENOSTOSIS DE PERONÉ IZQUIERDO"
  },
  {
    "codigo":230792007,
    "descripcion":"QUISTE EPENDIMARIO"
  },
  {
    "codigo":196189005,
    "descripcion":"INSUFICIENCIA PULMONAR AGUDA LUEGO DE UNA CIRUGÍA NO TORÁCICA"
  },
  {
    "codigo":294493008,
    "descripcion":"OBESIDAD QUE PERDURA TODA LA VIDA"
  },
  {
    "codigo":149141000119102,
    "descripcion":"VÍCTIMA ADULTA DE ABUSO SEXUAL"
  },
  {
    "codigo":1179229002,
    "descripcion":"AMBIENTE AFECTUOSO"
  },
  {
    "codigo":292658006,
    "descripcion":"REACCIÓN ADVERSA AL CROTAMITÓN"
  },
  {
    "codigo":30514008,
    "descripcion":"ÚLCERA GASTROYEYUNAL AGUDA SIN HEMORRAGIA Y SIN PERFORACIÓN"
  },
  {
    "codigo":126983000,
    "descripcion":"NEOPLASIA DE LOS NERVIOS PERIFÉRICOS DE LA CARA"
  },
  {
    "codigo":421895002,
    "descripcion":"TRASTORNO VASCULAR PERIFÉRICO DEBIDO A DIABETES MELLITUS"
  },
  {
    "codigo":94215000,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL CUERPO DEL ÚTERO"
  },
  {
    "codigo":290823003,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR DESIPRAMINA"
  },
  {
    "codigo":423730009,
    "descripcion":"INSTALACIONES DE LAVANDERÍA INADECUADAS"
  },
  {
    "codigo":716807006,
    "descripcion":"CAPAZ DE MANEJAR LA PROPIA AGRESIÓN"
  },
  {
    "codigo":92380000,
    "descripcion":"NEOPLASIA BENIGNA DE LA PIEL DEL TRONCO"
  },
  {
    "codigo":59612001,
    "descripcion":"ÚLCERA DE LA VESÍCULA BILIAR"
  },
  {
    "codigo":16696981000119105,
    "descripcion":"ANOMALÍA CONGÉNITA DE ARTERIAS RENALES BILATERALES"
  },
  {
    "codigo":125148006,
    "descripcion":"DENSIDAD POR FUERA DE RANGO DE REFERENCIA"
  },
  {
    "codigo":288988007,
    "descripcion":"CAPAZ DE PRENDERSE AL PECHO PARA MAMAR"
  },
  {
    "codigo":57777000,
    "descripcion":"BOCIO NODULAR TÓXICO"
  },
  {
    "codigo":287153006,
    "descripcion":"QUEMADURA CORPORAL: MÁS DEL 70%"
  },
  {
    "codigo":123313007,
    "descripcion":"ENFERMEDAD DE CADENA PESADA ALFA, FORMA ENTÉRICA"
  },
  {
    "codigo":1237425009,
    "descripcion":"METÁSTASIS DE CARCINOMA DE HIPÓFISIS"
  },
  {
    "codigo":449158005,
    "descripcion":"ANOMALÍA DE EBSTEIN DE VÁLVULA TRICÚSPIDE CON AURICULIZACIÓN DE CÁMARA VENTRICULAR DERECHA"
  },
  {
    "codigo":55942007,
    "descripcion":"INTOXICACIÓN POR SOLANUM KWEBENSE"
  },
  {
    "codigo":185179004,
    "descripcion":"ATENDIDO EN CONSULTORIO DE ORTODONCIA"
  },
  {
    "codigo":840539006,
    "descripcion":"COVID-19"
  },
  {
    "codigo":414555007,
    "descripcion":"QUERATODERMIA BLENORRÁGICA"
  },
  {
    "codigo":283483008,
    "descripcion":"HERIDA PUNZANTE EN EL MUSLO"
  },
  {
    "codigo":445488003,
    "descripcion":"UTILLIZA DISPOSITIVO DE TELECOMUNICACIONES PARA SORDOS"
  },
  {
    "codigo":609328004,
    "descripcion":"DISPOSICIÓN ALÉRGICA"
  },
  {
    "codigo":368431000119106,
    "descripcion":"ENFERMEDAD RENAL CRÓNICA ESTADIO 2 DEBIDA A DIABETES MELLITUS MEDICAMENTOSA"
  },
  {
    "codigo":248880003,
    "descripcion":"PROLAPSO DE LA PARED VAGINAL POSTERIOR"
  },
  {
    "codigo":1230085000,
    "descripcion":"PATRÓN DE USO NOCIVO CONTINUO DE ANFETAMINA Y\/O DERIVADO DE ANFETAMINA SIN DEPENDENCIA"
  },
  {
    "codigo":247045004,
    "descripcion":"ANOMALÍA OCULAR DE AXENFELD RIEGER"
  },
  {
    "codigo":771333006,
    "descripcion":"SÍNDROME DE DESREGULACIÓN INMUNITARIA, ENFERMEDAD INTESTINAL INFLAMATORIA, ARTRITIS E INFECCIONES RECURRENTES"
  },
  {
    "codigo":472751000,
    "descripcion":"OBSTRUCCIÓN DE VENA CAVA SUPERIOR COMO COMPLICACIÓN DE PROCEDIMIENTO"
  },
  {
    "codigo":1079241000119104,
    "descripcion":"NEOPLASIA BENIGNA DE HUESO DE MIEMBRO INFERIOR IZQUIERDO"
  },
  {
    "codigo":700292001,
    "descripcion":"ECTROPIÓN CICATRIZAL DE PÁRPADO INFERIOR"
  },
  {
    "codigo":44932007,
    "descripcion":"FRACTURA EXPUESTA DE UNA COSTILLA"
  },
  {
    "codigo":307076007,
    "descripcion":"LABILIDAD ANÍMICA CÍCLICA"
  },
  {
    "codigo":1290116009,
    "descripcion":"TUMOR PANCREÁTICO SECRETOR DE POLIPÉPTIDO INHIBIDOR GÁSTRICO"
  },
  {
    "codigo":341961000119107,
    "descripcion":"DEPÓSITO DE PLATA EN CÓRNEA DE OJO IZQUIERDO"
  },
  {
    "codigo":403545005,
    "descripcion":"HEMANGIOMA PLANO CON MELANOSIS OCULOCUTÁNEA"
  },
  {
    "codigo":237870002,
    "descripcion":"AMILOIDOSIS FAMILIAR POR LIQUEN"
  },
  {
    "codigo":39427000,
    "descripcion":"SÍNDROME DE PAQUIONIQUIA CONGÉNITA"
  },
  {
    "codigo":399875001,
    "descripcion":"RETINOPATÍA PROLIFERATIVA SIN ALTO RIESGO CON EDEMA DE MÁCULA CLÍNICAMENTE SIGNIFICATIVO DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":301571004,
    "descripcion":"INCAPAZ DE MOVILIZARSE CON DISPOSITIVO ORTOPÉDICO"
  },
  {
    "codigo":6659005,
    "descripcion":"ANEMIA MEGALOBLÁSTICA POR CELIAQUÍA"
  },
  {
    "codigo":203267007,
    "descripcion":"TUBERCULOSIS DE LOS HUESOS DE LAS EXTREMIDADES"
  },
  {
    "codigo":299736000,
    "descripcion":"LESIÓN EXPANSIVA INTRAESPINAL"
  },
  {
    "codigo":1055235007,
    "descripcion":"AUSENCIA DE REFLEJO ACÚSTICO"
  },
  {
    "codigo":234200002,
    "descripcion":"FÍSTULA ENTÉRICA DE INJERTO VASCULAR"
  },
  {
    "codigo":365272009,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA UTILIZAR LA PAVA"
  },
  {
    "codigo":398040009,
    "descripcion":"ENFERMEDAD DE CHARCOT-MARIE-TOOTH, TIPO I"
  },
  {
    "codigo":15935741000119101,
    "descripcion":"DEFORMIDAD CONGÉNITA DE AMBAS CLAVÍCULAS"
  },
  {
    "codigo":199597005,
    "descripcion":"TRABAJO DE PARTO Y PARTO COMPLICADOS, CON EVIDENCIA BIOQUÍMICA DE SUFRIMIENTO FETAL"
  },
  {
    "codigo":363437005,
    "descripcion":"NEOPLASIA MALIGNA DE MIOCARDIO"
  },
  {
    "codigo":232365007,
    "descripcion":"ESTENOSIS VESTIBULAR"
  },
  {
    "codigo":1344642001,
    "descripcion":"HERNIA DIAFRAGMÁTICA AGUDA TRAUMÁTICA"
  },
  {
    "codigo":197762003,
    "descripcion":"PIELITIS CRÓNICA"
  },
  {
    "codigo":230530003,
    "descripcion":"OFTALMOPLEJÍA NUCLEAR CONGÉNITA"
  },
  {
    "codigo":296066004,
    "descripcion":"SOBREDOSIS DE LORMETAZEPAM"
  },
  {
    "codigo":64855000,
    "descripcion":"ENFERMEDAD DE PELIZAEUS - MERZBACHER"
  },
  {
    "codigo":425303004,
    "descripcion":"CARCINOMATOSIS ESCAMOCELULAR"
  },
  {
    "codigo":294231006,
    "descripcion":"ALERGIA A TUBOCURARINA"
  },
  {
    "codigo":292396000,
    "descripcion":"REACCIÓN ADVERSA A LA TIORIDAZINA"
  },
  {
    "codigo":128556000,
    "descripcion":"FÍSTULA CONGÉNITA DE ARTERIA CORONARIA A VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":95788002,
    "descripcion":"NISTAGMO POSICIONAL, DIRECCIÓN VARIABLE DEL OJO"
  },
  {
    "codigo":194092005,
    "descripcion":"EXOTROPÍA MONOCULAR CON PATRÓN Y"
  },
  {
    "codigo":423468007,
    "descripcion":"CARCINOMA ESCAMOCELULAR DEL PULMÓN, TNM ESTADIO 2"
  },
  {
    "codigo":16754941000119107,
    "descripcion":"SANGRADO UTERINO ANORMAL DEBIDO A ADENOMIOSIS"
  },
  {
    "codigo":225025003,
    "descripcion":"ETAPA DE DESESPERACIÓN EN EL PROCESO DE DUELO"
  },
  {
    "codigo":28417005,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE LA CARA, SIN INFECCIÓN"
  },
  {
    "codigo":1306369006,
    "descripcion":"SARCOMA DE PORCIÓN CENTRAL DE MAMA"
  },
  {
    "codigo":126721009,
    "descripcion":"NEOPLASIA DE LA PLEURA VISCERAL"
  },
  {
    "codigo":93953009,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA PELVIS"
  },
  {
    "codigo":288726002,
    "descripcion":"CAPAZ DE EMPLEAR DIFERENTES FORMAS DE CONVERSACIÓN"
  },
  {
    "codigo":1081751000119103,
    "descripcion":"SARCOMA PRIMARIO DE MIEMBRO INFERIOR DERECHO"
  },
  {
    "codigo":92118007,
    "descripcion":"NEOPLASIA BENIGNA DEL TRACTO GASTROINTESTINAL"
  },
  {
    "codigo":286891000,
    "descripcion":"CARCINOMA DE PIEL DE CABEZA\/CUELLO"
  },
  {
    "codigo":254123002,
    "descripcion":"DISOSTEOSCLEROSIS"
  },
  {
    "codigo":712875004,
    "descripcion":"HALLAZGO ANORMAL EN PROCEDIMIENTO DE CRIBADO"
  },
  {
    "codigo":188587006,
    "descripcion":"ENFERMEDAD DE HODGKIN, DEPLECIÓN LINFOCITARIA DE GANGLIOS LINFÁTICOS INTRABDOMINALES"
  },
  {
    "codigo":417963007,
    "descripcion":"ANOMALÍA DE LA TEXTURA TISULAR"
  },
  {
    "codigo":285056001,
    "descripcion":"NO USA AUDÍFONO"
  },
  {
    "codigo":711040002,
    "descripcion":"INTERFERENCIA OCLUSAL LATERAL EN EL LADO DE BALANCE"
  },
  {
    "codigo":344471000119106,
    "descripcion":"PINGUÉCULA BILATERAL"
  },
  {
    "codigo":414293001,
    "descripcion":"FRACTURA DE TIBIA Y PERONÉ"
  },
  {
    "codigo":709205004,
    "descripcion":"NEOPLASIA DE CÉLULAS GIGANTES DE SACRO"
  },
  {
    "codigo":283221005,
    "descripcion":"ANZUELO EN LA PANTORRILLA"
  },
  {
    "codigo":707370001,
    "descripcion":"GRANULOMA HIALINIZANTE MÚLTIPLE DE PULMÓN"
  },
  {
    "codigo":248618001,
    "descripcion":"ESTERTORES HÚMEDOS"
  },
  {
    "codigo":1231658004,
    "descripcion":"SARCOIDOSIS DE ÓRBITA"
  },
  {
    "codigo":19242006,
    "descripcion":"EDEMA PULMONAR"
  },
  {
    "codigo":246783003,
    "descripcion":"PROFUNDIDAD OCULAR"
  },
  {
    "codigo":48340000,
    "descripcion":"INCONTINENCIA"
  },
  {
    "codigo":212180004,
    "descripcion":"SÍNDROME MEDULAR POSTERIOR DEBIDO A LESIÓN A NIVEL DE T7 - T12, SIN LESIÓN ÓSEA"
  },
  {
    "codigo":12114481000119106,
    "descripcion":"QUEMADURA QUÍMICA DE DEDO DE PIE IZQUIERDO"
  },
  {
    "codigo":210345001,
    "descripcion":"HERIDA ABIERTA EN LA MANDÍBULA"
  },
  {
    "codigo":208510002,
    "descripcion":"FRACTURAS MÚLTIPLES DE CLAVÍCULA, OMÓPLATO Y HÚMERO"
  },
  {
    "codigo":110206009,
    "descripcion":"QUEMADURA DE LA ENCÍA UNIDA AL MAXILAR SUPERIOR"
  },
  {
    "codigo":370515002,
    "descripcion":"ENDOTOXICOSIS"
  },
  {
    "codigo":1156947003,
    "descripcion":"INMUNE AL VIRUS DE LA RABIA"
  },
  {
    "codigo":1288019004,
    "descripcion":"ALERGIA A TROPOMIOSINA"
  },
  {
    "codigo":403283005,
    "descripcion":"PTERIGIÓN CONGÉNITO DE UÑA"
  },
  {
    "codigo":396948171000119104,
    "descripcion":"OSTEÍTIS DEFORMANTE DE AMBAS TIBIAS Y PERONÉS"
  },
  {
    "codigo":698195007,
    "descripcion":"INCOMPETENCIA DE LABIO"
  },
  {
    "codigo":1220648003,
    "descripcion":"INSUFICIENCIA RENAL DEBIDA A INTERRUPCIÓN COMPLETA INDUCIDA DE EMBARAZO Y POSTERIOR A ELLA"
  },
  {
    "codigo":237608006,
    "descripcion":"LIPODISTROFIA, PARCIAL, CON ANOMALÍA DE REIGER, BAJA ESTATURA, Y DIABETES MELLITUS INSULINOPÉNICA"
  },
  {
    "codigo":432381000,
    "descripcion":"INFECCIÓN DE CUERDA VOCAL POR VIRUS DEL PAPILOMA HUMANO"
  },
  {
    "codigo":301309000,
    "descripcion":"CONSTITUCIÓN FÍSICA NORMAL"
  },
  {
    "codigo":792829004,
    "descripcion":"PULSO EN ARTERIA TIBIAL POSTERIOR IZQUIERDA NORMAL"
  },
  {
    "codigo":291531000119108,
    "descripcion":"HEMORRAGIA ESPONTÁNEA DE HEMISFERIO CEREBRAL"
  },
  {
    "codigo":102866000,
    "descripcion":"ORINA ANORMAL"
  },
  {
    "codigo":235773008,
    "descripcion":"DIVERTÍCULO SOLITARIO DEL HEMICOLON IZQUIERDO"
  },
  {
    "codigo":233938002,
    "descripcion":"EMBOLIA GRASA PULMONAR"
  },
  {
    "codigo":365010003,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA USAR CONSONANTES SIMPLES"
  },
  {
    "codigo":70098006,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE DEDO DE LA MANO SIN INFECCIÓN"
  },
  {
    "codigo":168402006,
    "descripcion":"EXTENDIDO CERVICAL: ESPÉCIMEN INADECUADO"
  },
  {
    "codigo":363175000,
    "descripcion":"TRASTORNO INFLAMATORIO DE LAS EXTREMIDADES"
  },
  {
    "codigo":430546009,
    "descripcion":"RESPIRACIÓN AGÓNICA"
  },
  {
    "codigo":723623002,
    "descripcion":"OVALOCITOSIS DEL SUDESTE ASIÁTICO"
  },
  {
    "codigo":299474009,
    "descripcion":"PIE INMÓVIL"
  },
  {
    "codigo":789159005,
    "descripcion":"DISPLASIA DÉRMICA FACIAL FOCAL TIPO II"
  },
  {
    "codigo":232103007,
    "descripcion":"EXOTROPÍA PRIMARIA"
  },
  {
    "codigo":11815781000119105,
    "descripcion":"LESIÓN TRAUMÁTICA DE MANGUITO DE LOS ROTADORES DERECHO"
  },
  {
    "codigo":230268000,
    "descripcion":"ENFERMEDAD DE ALZHEIMER NO FAMILIAR DE INICIO TARDÍO"
  },
  {
    "codigo":10832741000119105,
    "descripcion":"FRACTURA EXPUESTA DE DIÁFISIS DE CUARTO HUESO METACARPIANO DE MANO IZQUIERDA"
  },
  {
    "codigo":721788005,
    "descripcion":"ENCEFALITIS CAUSADA POR RUBULAVIRUS"
  },
  {
    "codigo":263036008,
    "descripcion":"SUBLUXACIÓN DE ARTICULACIÓN ESTERNOCOSTAL"
  },
  {
    "codigo":295804008,
    "descripcion":"SOBREDOSIS DE AZATIOPRINA"
  },
  {
    "codigo":31825002,
    "descripcion":"TEJIDO DE GRANULACIÓN ANORMAL"
  },
  {
    "codigo":293969000,
    "descripcion":"ALERGIA A ESMOLOL"
  },
  {
    "codigo":228433006,
    "descripcion":"TOLERANCIA CONDUCTUAL A LAS DROGAS"
  },
  {
    "codigo":128294001,
    "descripcion":"TRASTORNO INFLAMATORIO CRÓNICO"
  },
  {
    "codigo":95526003,
    "descripcion":"NECROSIS DEL PALADAR DURO"
  },
  {
    "codigo":292134008,
    "descripcion":"REACCIÓN ADVERSA A ANTAGONISTA DE RECEPTOR DE 5-HIDROXITRIPTAMINA"
  },
  {
    "codigo":1142267005,
    "descripcion":"HIPERTROFIA DE MÚSCULO DE MUSLO"
  },
  {
    "codigo":28155008,
    "descripcion":"HEMORRAGIA EXTRADURAL TRAUMÁTICA CON HERIDA INTRACRANEAL ABIERTA Y CONCUSIÓN"
  },
  {
    "codigo":1304272004,
    "descripcion":"EDEMA DE AMBOS MUSLOS"
  },
  {
    "codigo":91856007,
    "descripcion":"LEUCEMIA LINFOIDE AGUDA EN REMISIÓN"
  },
  {
    "codigo":417701000,
    "descripcion":"CONJUNTIVITIS ASOCIADA CON DERMATITIS HERPETIFORME"
  },
  {
    "codigo":188325002,
    "descripcion":"NEOPLASIA MALIGNA DE NERVIO PERIFÉRICO DEL TÓRAX"
  },
  {
    "codigo":1204133008,
    "descripcion":"DESPLAZAMIENTO DE DERIVACIÓN VENTRICULAR DE DESFIBRILADOR CARDIOVERSOR IMPLANTABLE"
  },
  {
    "codigo":448634001,
    "descripcion":"CÚSPIDE DE VÁLVULA AÓRTICA AUSENTE"
  },
  {
    "codigo":284794003,
    "descripcion":"SE DUCHA"
  },
  {
    "codigo":219258007,
    "descripcion":"LESIÓN POR INTERVENCIÓN LEGAL CON AMETRALLADORA"
  },
  {
    "codigo":252026008,
    "descripcion":"INESTABILIDAD URETRAL"
  },
  {
    "codigo":282959002,
    "descripcion":"CAPAZ DE ACUCLILLARSE"
  },
  {
    "codigo":20815007,
    "descripcion":"SECUENCIA DE EXTROFIA DE CLOACA"
  },
  {
    "codigo":414031008,
    "descripcion":"TRASTORNO DEBIDO AL AUMENTO DE PRODUCCIÓN DE INMUNOGLOBULINAS"
  },
  {
    "codigo":444964001,
    "descripcion":"PULMONES CON DISPOSICIÓN EN ESPEJO"
  },
  {
    "codigo":294041000119107,
    "descripcion":"HEMIPLEJÍA FLÁCCIDA DE LADO IZQUIERDO DOMINANTE"
  },
  {
    "codigo":80846000,
    "descripcion":"ECTROPIÓN ESPÁSTICO"
  },
  {
    "codigo":277454003,
    "descripcion":"RUIDO AURICULAR"
  },
  {
    "codigo":408526004,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: LINGALA"
  },
  {
    "codigo":373923006,
    "descripcion":"PIGMENTACIÓN DE PIEL O MUCOSA"
  },
  {
    "codigo":439459008,
    "descripcion":"DEFICIENCIA HEREDITARIA DE SUBUNIDAD B DE FACTOR XIII"
  },
  {
    "codigo":210083009,
    "descripcion":"LESIÓN NO EXPUESTA DE DIAFRAGMA"
  },
  {
    "codigo":77176002,
    "descripcion":"FUMADOR"
  },
  {
    "codigo":767139008,
    "descripcion":"RECEPTOR DE LIPOPROTEÍNA DE BAJA DENSIDAD HETEROCIGOTA COMBINADO CONCOMITANTE CON MUTACIONES DE PROTEÍNA 1 DE ADAPTADOR DE RECEPTOR DE LIPOPROTEÍNA DE BAJA DENSIDAD"
  },
  {
    "codigo":109944005,
    "descripcion":"NEOPLASIA BENIGNA DE NERVIO PERIFÉRICO DE LA REGIÓN PÉLVICA"
  },
  {
    "codigo":403021003,
    "descripcion":"TIÑA DEL CUERO CABELLUDO POR MICROSPORUM AUDOUINII"
  },
  {
    "codigo":11818291000119108,
    "descripcion":"ESGUINCE DE LIGAMENTO DE ARTICULACIÓN METACARPOFALÁNGICA DE PULGAR DERECHO"
  },
  {
    "codigo":206413008,
    "descripcion":"HEMATOMA SUPERFICIAL PERINATAL"
  },
  {
    "codigo":302882002,
    "descripcion":"HIDROCEFALIA ASOCIADA CON ESTENOSIS CONGÉNITA DEL ACUEDUCTO DE SILVIO"
  },
  {
    "codigo":204578005,
    "descripcion":"FUSIÓN DE LÓBULOS PULMONARES"
  },
  {
    "codigo":1187618009,
    "descripcion":"ENFERMEDAD DE CHARCOT MARIE TOOTH AUTOSÓMICA DOMINANTE TIPO 2V"
  },
  {
    "codigo":432119003,
    "descripcion":"ANEURISMA"
  },
  {
    "codigo":366583005,
    "descripcion":"HALLAZGO DE LA PRUEBA DE THOMAS"
  },
  {
    "codigo":169975006,
    "descripcion":"INCORPORACIÓN DE SÓLIDOS A LAS 6 SEMANAS"
  },
  {
    "codigo":299212003,
    "descripcion":"AMPUTADO A NIVEL DE HOMBRO"
  },
  {
    "codigo":364748006,
    "descripcion":"HALLAZGO RELACIONADO CON LA POSICIÓN EN LA PRESENTACIÓN PÉLVICA"
  },
  {
    "codigo":788897000,
    "descripcion":"DELIRIO DE IDENTIFICACIÓN ERRÓNEA"
  },
  {
    "codigo":4300009,
    "descripcion":"QUEMADURA PROFUNDA DE TERCER GRADO DEL ANTEBRAZO"
  },
  {
    "codigo":231841004,
    "descripcion":"ESTENOSIS DE CONDUCTO NASOLAGRIMAL"
  },
  {
    "codigo":1149345007,
    "descripcion":"AUMENTO DE PESO EXCESIVO MEDIDO DURANTE LA GESTACIÓN"
  },
  {
    "codigo":262774002,
    "descripcion":"CONTUSIÓN DE GLÁNDULA TIROIDES"
  },
  {
    "codigo":31563000,
    "descripcion":"BACTERIURIA ASINTOMÁTICA EN EMBARAZO"
  },
  {
    "codigo":197238009,
    "descripcion":"DISFUNCIÓN DE UNA COLOSTOMÍA Y ENTEROSTOMÍA"
  },
  {
    "codigo":721526009,
    "descripcion":"SÍNDROME DE BROWN-SEQUARD AL NIVEL DEL TERCER SEGMENTO LUMBAR"
  },
  {
    "codigo":129867003,
    "descripcion":"CONOCIMIENTOS ESCASOS ACERCA DE LAS NORMAS DE SEGURIDAD"
  },
  {
    "codigo":184883008,
    "descripcion":"SOLICITUD DE REGISTRO DE DISCAPACIDAD - EXAMINADA"
  },
  {
    "codigo":293707005,
    "descripcion":"ALERGIA A KETAMINA"
  },
  {
    "codigo":295542008,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE TRICLOROETILENO"
  },
  {
    "codigo":424779008,
    "descripcion":"SARCOMA DE KAPOSI PRIMARIO DE LA CAVIDAD BUCAL"
  },
  {
    "codigo":291872002,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR OXITOCINA"
  },
  {
    "codigo":93429005,
    "descripcion":"COSTILLA DISCONTINUA"
  },
  {
    "codigo":224501006,
    "descripcion":"CUIDADOR QUE VIVE A DISTANCIA"
  },
  {
    "codigo":191733007,
    "descripcion":"MIEDO AL EMBARAZO"
  },
  {
    "codigo":879861008,
    "descripcion":"AUSENCIA DE PULSO EN PIE IZQUIERDO"
  },
  {
    "codigo":714186001,
    "descripcion":"PERSONA TRANSEXUAL DE GÉNERO MASCULINO A FEMENINO EN TRATAMIENTO HORMONAL"
  },
  {
    "codigo":124362003,
    "descripcion":"DEFICIENCIA DE ARILSULFOTRANSFERASA"
  },
  {
    "codigo":679681000119103,
    "descripcion":"ENDOFTALMITIS DE OJO DERECHO DEBIDA A CIRUGÍA Y POSTERIOR A ELLA"
  },
  {
    "codigo":188063003,
    "descripcion":"MELANOMA MALIGNO DE MANO"
  },
  {
    "codigo":253599005,
    "descripcion":"VÁLVULA PULMONAR BICÚSPIDE"
  },
  {
    "codigo":384671006,
    "descripcion":"MICROCALCIFICACIONES PRESENTES EN TEJIDO TUMORAL"
  },
  {
    "codigo":22388002,
    "descripcion":"QUEMADURA DEL ÚTERO"
  },
  {
    "codigo":448372003,
    "descripcion":"LINFOMA NO HODGKIN DE PULMÓN"
  },
  {
    "codigo":282697000,
    "descripcion":"INCAPAZ DE EMPUJAR Y ARRASTRAR HACIA ATRÁS UN JUGUETE GRANDE CON RUEDAS"
  },
  {
    "codigo":79771000119101,
    "descripcion":"CIFOESCOLIOSIS DEGENERATIVA"
  },
  {
    "codigo":249929005,
    "descripcion":"NO PUEDE TOCARSE LA CARA POSTERIOR DEL CUELLO"
  },
  {
    "codigo":86089006,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DE AXILA"
  },
  {
    "codigo":315465008,
    "descripcion":"NACIDO EN LIBERIA"
  },
  {
    "codigo":248094001,
    "descripcion":"INTERÉS ERÓTICO AUMENTADO"
  },
  {
    "codigo":18718003,
    "descripcion":"ENFERMEDAD GINGIVAL"
  },
  {
    "codigo":870686006,
    "descripcion":"CAPAZ DE MANEJAR ACTIVIDADES RELACIONADAS CON LA RESIDENCIA"
  },
  {
    "codigo":444702007,
    "descripcion":"HÁBITOS INTESTINALES IRREGULARES"
  },
  {
    "codigo":705011000,
    "descripcion":"DEPRESIÓN ANTERIOR DE SEGMENTO ST"
  },
  {
    "codigo":703176000,
    "descripcion":"ANEURISMA DE ARTERIA VERTEBRAL ROTO"
  },
  {
    "codigo":82419009,
    "descripcion":"FRACTURA EXPUESTA DE COLUMNA VERTEBRAL"
  },
  {
    "codigo":1260232006,
    "descripcion":"PIERCING EN CEJA DE REGIÓN OCULAR DERECHA"
  },
  {
    "codigo":275357005,
    "descripcion":"COMPLICACIÓN DE DEDO DEL PIE REIMPLANTADO"
  },
  {
    "codigo":373661007,
    "descripcion":"ANOMALÍA ESTRUCTURAL DE LA PAPILA ÓPTICA"
  },
  {
    "codigo":11378000,
    "descripcion":"SENO UROGENITAL PERSISTENTE"
  },
  {
    "codigo":13213009,
    "descripcion":"CARDIOPATÍA CONGÉNITA"
  },
  {
    "codigo":766877008,
    "descripcion":"LACTANTE QUE LLORA CONSTANTEMENTE"
  },
  {
    "codigo":109682000,
    "descripcion":"CRESTA ALVEOLAR DESDENTADA CON RESORCIÓN LABIAL"
  },
  {
    "codigo":1354866004,
    "descripcion":"MANTIENE RESIDENCIA INCÓMODAMENTE CALUROSA DEBIDO A ESCASEZ DE RECURSOS ECONÓMICOS"
  },
  {
    "codigo":207986006,
    "descripcion":"FRACTURA DE COLUMNA VERTEBRAL LUMBAR Y PELVIS"
  },
  {
    "codigo":240754009,
    "descripcion":"PAPILOMA RINOSPORIDIAL"
  },
  {
    "codigo":271687003,
    "descripcion":"TUMEFACCIÓN DEL ESCROTO"
  },
  {
    "codigo":1254727003,
    "descripcion":"METÁSTASIS DE CARCINOMA ADENOIDE QUÍSTICO EN GLÁNDULA SALIVAL SUBMAXILAR"
  },
  {
    "codigo":402759009,
    "descripcion":"COMPLICACIÓN DE CIRUGÍA LÁSER"
  },
  {
    "codigo":238919009,
    "descripcion":"SEUDOCONDILOMAS DE VULVA"
  },
  {
    "codigo":73244003,
    "descripcion":"FRACTURA NO EXPUESTA DE CUELLO QUIRÚRGICO DE HÚMERO"
  },
  {
    "codigo":237084006,
    "descripcion":"CERVICITIS POR CLAMIDIA"
  },
  {
    "codigo":16001231000119100,
    "descripcion":"BUFTALMOS DE OJO DERECHO"
  },
  {
    "codigo":268017000,
    "descripcion":"OSTEOMIELITIS AGUDA DE TOBILLO O PIE"
  },
  {
    "codigo":1285660008,
    "descripcion":"ENFERMEDAD MODERADA POR DEFICIENCIA HEREDITARIA DE FACTOR VIII CON INHIBIDOR DE BAJA RESPUESTA"
  },
  {
    "codigo":431857002,
    "descripcion":"ENFERMEDAD RENAL CRÓNICA, ESTADIO 4"
  },
  {
    "codigo":202481002,
    "descripcion":"DOLOR DE ARTICULACIÓN RADIOCUBITAL DISTAL"
  },
  {
    "codigo":366321006,
    "descripcion":"EMBARAZO - HALLAZGO"
  },
  {
    "codigo":38641008,
    "descripcion":"OBLICUIDAD PÉLVICA"
  },
  {
    "codigo":4038001,
    "descripcion":"MIROTECIOTOXICOSIS"
  },
  {
    "codigo":69574002,
    "descripcion":"ANEMIA POR DISFUNCIÓN PARATIROIDEA"
  },
  {
    "codigo":724934005,
    "descripcion":"DISTENSIÓN DE TENDÓN DE TRÍCEPS BRAQUIAL"
  },
  {
    "codigo":10676431000119103,
    "descripcion":"EXACERBACIÓN SEVERA AGUDA DE ASMA ALÉRGICA MODERADA PERSISTENTE"
  },
  {
    "codigo":298950008,
    "descripcion":"AMPLITUD DE FLEXIÓN ACTIVA DE LA MUÑECA AUMENTADA"
  },
  {
    "codigo":460955005,
    "descripcion":"INSERCIÓN ANÓMALA DE LIGAMENTO ARTERIOSO EN TRONCO PULMONAR"
  },
  {
    "codigo":428187007,
    "descripcion":"NÓDULO HEPÁTICO"
  },
  {
    "codigo":723099007,
    "descripcion":"ÚLCERA GÁSTRICA CAUSADA POR BACTERIA"
  },
  {
    "codigo":198811009,
    "descripcion":"INTENTO FALLIDO DE ABORTO CON CHOQUE"
  },
  {
    "codigo":196976000,
    "descripcion":"ENTERITIS REGIONAL DEL YEYUNO"
  },
  {
    "codigo":229744005,
    "descripcion":"DISFUNCIÓN DEL DESARROLLO SINTÁCTICO"
  },
  {
    "codigo":721264007,
    "descripcion":"QUISTE HIDATÍDICO DE ÓRBITA"
  },
  {
    "codigo":295280008,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE NEFOPAM"
  },
  {
    "codigo":368009,
    "descripcion":"VALVULOPATÍA"
  },
  {
    "codigo":1091791000119107,
    "descripcion":"OTITIS EXTERNA DE CONDUCTO AUDITIVO DERECHO CAUSADA POR HONGO"
  },
  {
    "codigo":719429003,
    "descripcion":"SÍNDROME DE DISPLASIA ECTODÉRMICA CON ACANTOSIS NIGRICANS"
  },
  {
    "codigo":31301004,
    "descripcion":"ÚLCERA GÁSTRICA CRÓNICA PERFORADA"
  },
  {
    "codigo":293445005,
    "descripcion":"REACCIÓN ADVERSA A LA PROCAINAMIDA"
  },
  {
    "codigo":195141007,
    "descripcion":"ATROFIA DE MÚSCULO PAPILAR"
  },
  {
    "codigo":291610004,
    "descripcion":"INTOXICACIÓN POR CEFODIZIMA"
  },
  {
    "codigo":361000119103,
    "descripcion":"SÍNDROME PARALÍTICO EN UN LADO DEL CUERPO COMO EFECTO TARDÍO DE ACCIDENTE CEREBROVASCULAR"
  },
  {
    "codigo":191471000,
    "descripcion":"PSICOSIS ALCOHÓLICA DE KORSAKOV CON NEURITIS PERIFÉRICA"
  },
  {
    "codigo":95002008,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA GLÁNDULA PINEAL"
  },
  {
    "codigo":93167001,
    "descripcion":"HEMIVÉRTEBRA LUMBAR"
  },
  {
    "codigo":224239002,
    "descripcion":"EN LISTA DE ESPERA PARA ALOJAMIENTO"
  },
  {
    "codigo":60399005,
    "descripcion":"DERMATOFIBROSIS LENTICULAR DISEMINADA"
  },
  {
    "codigo":289775006,
    "descripcion":"CUELLO UTERINO DURO"
  },
  {
    "codigo":255172003,
    "descripcion":"NEOPLASIA BENIGNA DE VÁLVULA ILEOCECAL"
  },
  {
    "codigo":187801002,
    "descripcion":"NEOPLASIA MALIGNA DE PERITONEO Y RETROPERITONEO"
  },
  {
    "codigo":286105002,
    "descripcion":"CAPAZ DE LUSTRAR"
  },
  {
    "codigo":23961005,
    "descripcion":"ARTROPATÍA ASOCIADA CON UN TRASTORNO HEMATOLÓGICO"
  },
  {
    "codigo":89497006,
    "descripcion":"COLA HUMANA PERSISTENTE"
  },
  {
    "codigo":251502001,
    "descripcion":"ESPIGAS FOCALES EPISÓDICAS"
  },
  {
    "codigo":1269145009,
    "descripcion":"COMPLICACIÓN POSTERIOR A TRASPLANTE DE CÓRNEA"
  },
  {
    "codigo":744857009,
    "descripcion":"BAJO ATENCIÓN DE SERVICIO DE USO DE INDEBIDO DE DROGAS"
  },
  {
    "codigo":284270002,
    "descripcion":"CAPAZ DE EMPLEAR AGARRE DE PINZA"
  },
  {
    "codigo":22126005,
    "descripcion":"EDEMA NEUROAXIAL HEREDITARIO"
  },
  {
    "codigo":253337009,
    "descripcion":"ISOMERISMO DE APÉNDICE AURICULAR IZQUIERDO"
  },
  {
    "codigo":87662006,
    "descripcion":"NACIMIENTO DE TÉRMINO DE GEMELOS DICIGÓTICOS, AMBOS VIVOS"
  },
  {
    "codigo":773955003,
    "descripcion":"OTITIS EXTERNA NECROSANTE DE CONDUCTO AUDITIVO EXTERNO IZQUIERDO"
  },
  {
    "codigo":184131004,
    "descripcion":"ES CUESTIONABLE SI EL ESTADO MARITAL DEL PACIENTE ES CORRECTO"
  },
  {
    "codigo":247832004,
    "descripcion":"MIEDO SOCIAL"
  },
  {
    "codigo":1263640005,
    "descripcion":"METÁSTASIS DE CARCINOMA DE CÉLULAS TRANSICIONALES EN CUERPO DE ÚTERO"
  },
  {
    "codigo":772120006,
    "descripcion":"REQUIERE COMPONENTE SANGUÍNEO IRRADIADO"
  },
  {
    "codigo":311533004,
    "descripcion":"MEMORIA VERBAL RETARDADA"
  },
  {
    "codigo":1163501006,
    "descripcion":"INFECCIÓN CAUSADA POR PROPIONIBACTERIUM"
  },
  {
    "codigo":735682000,
    "descripcion":"TAQUICARDIA AURICULAR POR MACRO-REENTRADA"
  },
  {
    "codigo":14786003,
    "descripcion":"PARÁLISIS DE LA NOCHE DEL SÁBADO"
  },
  {
    "codigo":78487004,
    "descripcion":"DERMATOFITOSIS GRANULOMATOSA"
  },
  {
    "codigo":1290903005,
    "descripcion":"SARCOMA INDIFERENCIADO"
  },
  {
    "codigo":373399007,
    "descripcion":"PLEOMORFISMO NUCLEAR, GRADO 2: NO CORRESPONDIENTE A GRADO NUCLEAR 1 NI A GRADO NUCLEAR 3"
  },
  {
    "codigo":111255008,
    "descripcion":"OSTEONECROSIS DE EPÍFISIS DE CABEZA FEMORAL"
  },
  {
    "codigo":209559008,
    "descripcion":"ESGUINCE DE LIGAMENTO LONGITUDINAL ANTERIOR CEL CUELLO"
  },
  {
    "codigo":1354604001,
    "descripcion":"FRACTURA DE FALANGE MEDIA DE DEDO MEÑIQUE"
  },
  {
    "codigo":109420003,
    "descripcion":"DISOSTOSIS"
  },
  {
    "codigo":76652004,
    "descripcion":"PSEUDOFRIGIDEZ"
  },
  {
    "codigo":10760861000119105,
    "descripcion":"SEXTILLIZOS, TODOS NACIDOS VIVOS"
  },
  {
    "codigo":271425001,
    "descripcion":"FIEBRE FLUVIAL DEL JAPÓN"
  },
  {
    "codigo":304193004,
    "descripcion":"AMPLITUD DE MOVIMIENTO ACTIVO DE FLEXIÓN HORIZONTAL DE HOMBRO"
  },
  {
    "codigo":402497005,
    "descripcion":"CARCINOMA BASOCELULAR DE LA RAÍZ DE LA NARIZ"
  },
  {
    "codigo":238657006,
    "descripcion":"LIQUEN PLANO ULCEROSO DE PALMAS Y PLANTAS"
  },
  {
    "codigo":171286000,
    "descripcion":"VACUNACIÓN AL FINALIZAR AÑO LECTIVO - SIN AUTORIZACIÓN"
  },
  {
    "codigo":369729009,
    "descripcion":"INVASIÓN TUMORAL DE PEQUEÑOS VASOS, NO DETERMINADA"
  },
  {
    "codigo":236822003,
    "descripcion":"DEFICIENCIA EN EL COITO"
  },
  {
    "codigo":40214005,
    "descripcion":"ÚLCERA DUODENAL CRÓNICA SIN HEMORRAGIA Y SIN PERFORACIÓN"
  },
  {
    "codigo":16059191000119103,
    "descripcion":"ESCOTOMA DE AMBOS OJOS"
  },
  {
    "codigo":890347006,
    "descripcion":"SINOSTOSIS HUMERORRADIAL BILATERAL"
  },
  {
    "codigo":30341000175103,
    "descripcion":"ÚLCERA POR PRESIÓN EN CABEZA, ESTADIO III"
  },
  {
    "codigo":202219007,
    "descripcion":"SUBLUXACIÓN RECIDIVANTE DE HOMBRO - MULTIDIRECCIONAL"
  },
  {
    "codigo":300523009,
    "descripcion":"MASA DEL PREPUCIO"
  },
  {
    "codigo":724672003,
    "descripcion":"ALTERACIONES PERCEPTIVAS Y CONVULSIONES CONCOMITANTES CON ABSTINENCIA DE HIPNÓTICO Y DEBIDAS A ELLA"
  },
  {
    "codigo":298688007,
    "descripcion":"ELEVACIÓN DE LA PIERNA EXTENDIDA, AUSENTE"
  },
  {
    "codigo":396992008,
    "descripcion":"SITIO DE BIOPSIA, NO APLICABLE"
  },
  {
    "codigo":165781001,
    "descripcion":"TÍTULO PARA SÍFILIS DETECTADO"
  },
  {
    "codigo":427925000,
    "descripcion":"ARTROPATÍA DE LA MUÑECA ASOCIADA CON TRASTORNO NEUROLÓGICO"
  },
  {
    "codigo":296853003,
    "descripcion":"SOBREDOSIS DE HIPOGLUCEMIANTE ORAL"
  },
  {
    "codigo":360554000,
    "descripcion":"EDEMA ALIMENTARIO"
  },
  {
    "codigo":131178000,
    "descripcion":"TIPO GERBICH"
  },
  {
    "codigo":1179754003,
    "descripcion":"CARBOHIDRATO DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":32874004,
    "descripcion":"CUERPO EXTRAÑO EN EL CONDUCTO AUDITIVO"
  },
  {
    "codigo":293183004,
    "descripcion":"REACCIÓN ADVERSA A LA INSULINA ISÓFANA"
  },
  {
    "codigo":10953681000119105,
    "descripcion":"HERIDA ABIERTA DE PULGAR IZQUIERDO DEBIDA A MORDEDURA DE GATO"
  },
  {
    "codigo":291348002,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR DEXTROMETORFANO"
  },
  {
    "codigo":225812005,
    "descripcion":"NIEGA LA POSIBILIDAD DE TOMAR DECISIONES BIEN FUNDADAS"
  },
  {
    "codigo":717332007,
    "descripcion":"ATAXIA CEREBELOSA TIPO CAYMAN"
  },
  {
    "codigo":92905000,
    "descripcion":"FORMA ANORMAL CONGÉNITA DEL CEREBRO"
  },
  {
    "codigo":422420009,
    "descripcion":"TUBO DE DRENAJE DE GLAUCOMA EN CONTACTO CON LA CÓRNEA"
  },
  {
    "codigo":1208852007,
    "descripcion":"TROMBOEMBOLISMO DESDE PRÓTESIS VALVULAR CARDÍACA"
  },
  {
    "codigo":27369003,
    "descripcion":"TEMBLOR MASIVO"
  },
  {
    "codigo":94740008,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA PARED ANTERIOR DE LA VEJIGA"
  },
  {
    "codigo":387817006,
    "descripcion":"DEFICIENCIA DE FOSFORILASA B CINASA"
  },
  {
    "codigo":420585007,
    "descripcion":"MENINGITIS CAUSADA POR KLEBSIELLA AEROGENES"
  },
  {
    "codigo":1172414002,
    "descripcion":"17- CETOESTEROIDES DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":123838008,
    "descripcion":"INADECUADO PARA EVALUACIÓN POR PRESENCIA DE ÁREAS DENSAS"
  },
  {
    "codigo":254910008,
    "descripcion":"NEOPLASIA DE CUERPO ESPONJOSO DE PENE"
  },
  {
    "codigo":44481000087102,
    "descripcion":"CEFALEA CRÓNICA DEBIDA A ENFERMEDAD INFECCIOSA"
  },
  {
    "codigo":39361000087103,
    "descripcion":"HERIDA PUNZANTE DE DEDO MEDIO DE MANO DERECHA CON CUERPO EXTRAÑO"
  },
  {
    "codigo":709992001,
    "descripcion":"ESQUEMA OCLUSAL PARCIALMENTE DENTADO SEVERAMENTE COMPROMETIDO"
  },
  {
    "codigo":284008001,
    "descripcion":"CUERPO EXTRAÑO EN HUESO"
  },
  {
    "codigo":449683009,
    "descripcion":"AUSENCIA CONGÉNITA PARCIAL DE BRAZO"
  },
  {
    "codigo":41921000087105,
    "descripcion":"TENDINITIS DE BÍCEPS BRAQUIAL IZQUIERDO"
  },
  {
    "codigo":447848001,
    "descripcion":"TRONCO PULMONAR PRESENTE"
  },
  {
    "codigo":251240002,
    "descripcion":"ONDA U INVERTIDA"
  },
  {
    "codigo":285843009,
    "descripcion":"CAPACIDAD PARA EL DISFRUTE MANTENIDA"
  },
  {
    "codigo":413245000,
    "descripcion":"SANGRADO DE ORIGEN DESCONOCIDO"
  },
  {
    "codigo":47041000087106,
    "descripcion":"FRACTURA DE FALANGE PROXIMAL DE DEDO ÍNDICE DERECHO"
  },
  {
    "codigo":249405005,
    "descripcion":"PIGMENTACIÓN DE MUCOSA ORAL"
  },
  {
    "codigo":773693005,
    "descripcion":"DISPLASIA ESPONDILOMEGAEPIFISARIA-METAFISARIA"
  },
  {
    "codigo":282173005,
    "descripcion":"CAPAZ DE CAMINAR BARRANCA ABAJO"
  },
  {
    "codigo":247570005,
    "descripcion":"COLLARETES DE FOLÍCULOS DE PESTAÑAS"
  },
  {
    "codigo":737255000,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO DE LA PELVIS"
  },
  {
    "codigo":1359847002,
    "descripcion":"NEOPLASIA BENIGNA DE BERMELLÓN DE LABIO"
  },
  {
    "codigo":278503003,
    "descripcion":"HIPOTIROIDISMO CONGÉNITO CON BOCIO DIFUSO"
  },
  {
    "codigo":80060002,
    "descripcion":"LENGUA CUBIERTA"
  },
  {
    "codigo":735420003,
    "descripcion":"FALLA DE INJERTO-PUENTE ARTERIOVENOSO"
  },
  {
    "codigo":47292005,
    "descripcion":"TUBERCULOSIS DEL MIOCARDIO"
  },
  {
    "codigo":333061000119106,
    "descripcion":"CICLITIS POSTERIOR DE OJO DERECHO"
  },
  {
    "codigo":1259708007,
    "descripcion":"COREA DEBIDA A SÍNDROME DE ATAXIA TELANGIECTASIA"
  },
  {
    "codigo":307601000,
    "descripcion":"SEUDOMIXOMA PERITONEAL"
  },
  {
    "codigo":373137001,
    "descripcion":"VÁLVULA CARDÍACA INMÓVIL"
  },
  {
    "codigo":110993001,
    "descripcion":"GRANULOMA DEL COLON POR CUERPO EXTRAÑO"
  },
  {
    "codigo":274833007,
    "descripcion":"HALLAZGO HISTOLÓGICO ANORMAL EN ESPÉCIMEN DE ÓRGANO GENITAL FEMENINO"
  },
  {
    "codigo":240230000,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE CODO FIJA EN FLEXIÓN"
  },
  {
    "codigo":405905007,
    "descripcion":"TUMOR QUE INVADE DERMIS"
  },
  {
    "codigo":209297009,
    "descripcion":"FRACTURA-SUBLUXACIÓN EXPUESTA DE HUESO SEMILUNAR (PALMAR)"
  },
  {
    "codigo":305766003,
    "descripcion":"VISTO POR DRAMATERAPEUTA"
  },
  {
    "codigo":764518004,
    "descripcion":"TRISOMÍA DISTAL 2P"
  },
  {
    "codigo":12103071000119103,
    "descripcion":"QUEMADURA DE DEDO DE PIE IZQUIERDO"
  },
  {
    "codigo":830054005,
    "descripcion":"SÍNDROME DE OVARIO POLIQUÍSTICO DE AMBOS OVARIOS"
  },
  {
    "codigo":10874271000119103,
    "descripcion":"LACERACIÓN DE MEJILLA DERECHA"
  },
  {
    "codigo":205627002,
    "descripcion":"MONOSOMÍA Y DELECIÓN DE AUTOSOMA"
  },
  {
    "codigo":402235003,
    "descripcion":"QUEILITIS ECCEMATOSA"
  },
  {
    "codigo":1186832000,
    "descripcion":"TRASTORNO DEL DESARROLLO ACADÉMICO DEBIDO A DEFICIENCIA DE YODO"
  },
  {
    "codigo":236560001,
    "descripcion":"DEPURACIÓN DE SOLUTOS"
  },
  {
    "codigo":7184000,
    "descripcion":"INTOXICACIÓN CAUSADA POR PLASMA SANGUÍNEO"
  },
  {
    "codigo":105488004,
    "descripcion":"DIFICULTAD CON LOS PADRES"
  },
  {
    "codigo":10628511000119107,
    "descripcion":"DERMATITIS IRRITATIVA POR CONTACTO CAUSADA POR DETERGENTE"
  },
  {
    "codigo":306591000119107,
    "descripcion":"GOTA TOFÁCEA CRÓNICA DE MUÑECA CAUSADA POR FÁRMACO"
  },
  {
    "codigo":398565003,
    "descripcion":"INFECCIÓN CAUSADA POR CLOSTRIDIUM BOTULINUM"
  },
  {
    "codigo":5349006,
    "descripcion":"PRUEBA DE WEBER, CENTRAL"
  },
  {
    "codigo":300261006,
    "descripcion":"CONDUCTO SALIVAL OCLUIDOS"
  },
  {
    "codigo":365797009,
    "descripcion":"NIVEL DE GRASAS EN MATERIA FECAL - HALLAZGO"
  },
  {
    "codigo":3514002,
    "descripcion":"FIBROSIS PULMONAR PERIBRONQUIAL"
  },
  {
    "codigo":298426004,
    "descripcion":"SIN EXTENSIÓN PASIVA DE LA COLUMNA CERVICAL"
  },
  {
    "codigo":165519006,
    "descripcion":"RECUENTO DE NEUTRÓFILOS FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":722575008,
    "descripcion":"HEMORRAGIA TRAUMÁTICA DE CEREBELO DEBIDA A TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":296591009,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE KANAMICINA"
  },
  {
    "codigo":196452003,
    "descripcion":"QUISTE MANDIBULAR DEL DESARROLLO NO ODONTOGÉNICO"
  },
  {
    "codigo":32612005,
    "descripcion":"TRASTORNO DEL METABOLISMO DE LAS PURINAS"
  },
  {
    "codigo":11830841000119107,
    "descripcion":"LESIÓN TRAUMÁTICA DE ARTERIA PEDIA IZQUIERDA"
  },
  {
    "codigo":718905007,
    "descripcion":"DISCAPACIDAD INTELECTUAL LIGADA AL CROMOSOMA X TIPO SHRIMPTON"
  },
  {
    "codigo":292921008,
    "descripcion":"REACCIÓN ADVERSA A LOS AMINOGLUCÓSIDOS"
  },
  {
    "codigo":16909881000119108,
    "descripcion":"LAGOFTALMÍA PARALÍTICA DE PÁRPADOS SUPERIOR E INFERIOR DERECHOS"
  },
  {
    "codigo":127246002,
    "descripcion":"NEOPLASIA DE LOS GANGLIOS LINFÁTICOS BRONCOPULMONARES"
  },
  {
    "codigo":291086004,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR MIDAZOLAM"
  },
  {
    "codigo":192782005,
    "descripcion":"DEFICIENCIA DE GALACTOSILCERAMIDA BETA-GALACTOSIDASA"
  },
  {
    "codigo":225550006,
    "descripcion":"SECRECIÓN PURULENTA DE HERIDA"
  },
  {
    "codigo":94478006,
    "descripcion":"NEOPLASIA METASTÁSICA MALIGNA DE HUESO COXAL"
  },
  {
    "codigo":92643000,
    "descripcion":"CARCINOMA IN SITU DE LABIO"
  },
  {
    "codigo":10821331000119106,
    "descripcion":"FRACTURA EXPUESTA DE QUINTO HUESO METACARPIANO DE MANO DERECHA"
  },
  {
    "codigo":90808005,
    "descripcion":"QUEMADURA DE CUALQUIER GRADO QUE COMPROMETE 90 PORCIENTO O MÁS DE LA SUPERFICIE DEL CUERPO"
  },
  {
    "codigo":335571000119107,
    "descripcion":"DEPÓSITOS CRISTALINOS EN VÍTREO DE OJO DERECHO"
  },
  {
    "codigo":11804371000119107,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA DISTAL DE DEDO ÍNDICE IZQUIERDO"
  },
  {
    "codigo":56205004,
    "descripcion":"PHHF, TIPO SIN DELECIÓN"
  },
  {
    "codigo":711565008,
    "descripcion":"ACTUACIÓN DE LOS SUEÑOS"
  },
  {
    "codigo":1137549008,
    "descripcion":"CALCIFICACIÓN PUNTEADA DE EPÍFISIS DE FALANGE DE DEDO MEDIO DE MANO"
  },
  {
    "codigo":250978003,
    "descripcion":"CALCIFICACIÓN DE VÁLVULA AÓRTICA"
  },
  {
    "codigo":609591000,
    "descripcion":"MONONEUROPATÍA DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":314679001,
    "descripcion":"PESO DEL NIÑO: PERCENTILO 51-74"
  },
  {
    "codigo":283746009,
    "descripcion":"MORDEDURA DE PERRO EN LA GARGANTA"
  },
  {
    "codigo":281911004,
    "descripcion":"FRACTURA EN LÁGRIMA DE VÉRTEBRA CERVICAL"
  },
  {
    "codigo":52535005,
    "descripcion":"PERICARDITIS CONSTRICTIVA CRÓNICA"
  },
  {
    "codigo":247308000,
    "descripcion":"HALLAZGO RELACIONADO CON LA CONDUCTIVIDAD DEL SONIDO"
  },
  {
    "codigo":312844001,
    "descripcion":"LUXACIÓN DE ARTICULACIÓN METACARPOFALÁNGICA"
  },
  {
    "codigo":704225003,
    "descripcion":"FRACTURA EXPUESTA DE SEGUNDA FALANGE DE DEDO ÍNDICE"
  },
  {
    "codigo":442081006,
    "descripcion":"LARVA MIGRATORIA CUTÁNEA CAUSADA POR UNCINARIA"
  },
  {
    "codigo":12105581000119108,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO DE REGIÓN PALMAR DE MANO DERECHA"
  },
  {
    "codigo":736993008,
    "descripcion":"NEFROPATÍA POSTERIOR A ECLAMPSIA"
  },
  {
    "codigo":1259446001,
    "descripcion":"CARCINOMA ESCAMOSO NO QUERATINIZANTE INDIFERENCIADO PRIMARIO DE NASOFARINGE"
  },
  {
    "codigo":276406003,
    "descripcion":"DEPÓSITO EN ORINA"
  },
  {
    "codigo":11859821000119109,
    "descripcion":"ESGUINCE DE LIGAMENTO LATERAL EXTERNO DE RODILLA IZQUIERDA"
  },
  {
    "codigo":210870007,
    "descripcion":"LESIÓN EXPUESTA, VENA FEMORAL"
  },
  {
    "codigo":16011271000119104,
    "descripcion":"GANGRENA DE PIE IZQUIERDO"
  },
  {
    "codigo":733323004,
    "descripcion":"DISOCIACIÓN DE LUZ-OSCURIDAD PREGENICULADA"
  },
  {
    "codigo":12427005,
    "descripcion":"ENFERMEDAD DE ADDISON CONGÉNITA"
  },
  {
    "codigo":274571007,
    "descripcion":"OJO IZQUIERDO CIEGO"
  },
  {
    "codigo":305504000,
    "descripcion":"BAJO ATENCIÓN DE ONCÓLOGO INFANTIL"
  },
  {
    "codigo":698720003,
    "descripcion":"VÍCTIMA DE LOS EFECTOS DE UN TERREMOTO"
  },
  {
    "codigo":371040005,
    "descripcion":"ACCIDENTE CEREBROVASCULAR TROMBÓTICO"
  },
  {
    "codigo":11315361000119100,
    "descripcion":"FRACTURA EXPUESTA DE DIENTE"
  },
  {
    "codigo":895328005,
    "descripcion":"CURVATURA ANORMAL DE FALANGE DISTAL DE DEDO MEÑIQUE"
  },
  {
    "codigo":118791000119106,
    "descripcion":"ANEMIA APLÁSICA CAUSADA POR AGENTE ANTINEOPLÁSICO"
  },
  {
    "codigo":403808006,
    "descripcion":"EPIDERMÓLISIS AMPOLLAR DISTRÓFICA RECESIVA GENERALIZADA NO MUTILANTE"
  },
  {
    "codigo":860725002,
    "descripcion":"FACTOR DE VON WILLEBRAND POR DEBAJO DE RANGO DE REFERENCIA"
  },
  {
    "codigo":205365003,
    "descripcion":"MÚSCULO ABERRANTE DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":762421004,
    "descripcion":"MIDRIASIS EPISÓDICA DE PUPILA IZQUIERDA"
  },
  {
    "codigo":238133005,
    "descripcion":"OBESIDAD GINECOIDE"
  },
  {
    "codigo":8757006,
    "descripcion":"SÍNDROME DE HECHT"
  },
  {
    "codigo":1332403005,
    "descripcion":"DELIRIO DE CONTROL DE PENSAMIENTOS"
  },
  {
    "codigo":400138001,
    "descripcion":"FASCITIS NODULAR"
  },
  {
    "codigo":270901009,
    "descripcion":"TRASTORNO ESQUIZOAFECTIVO, TIPO MIXTO"
  },
  {
    "codigo":301834005,
    "descripcion":"MUESTRA DE ORINA OBTENIDA DE CATÉTER: ANORMAL"
  },
  {
    "codigo":269066006,
    "descripcion":"FRACTURA NO EXPUESTA DE LA CUARTA VÉRTEBRA CERVICAL"
  },
  {
    "codigo":234463000,
    "descripcion":"DEFICIENCIA COMBINADA DE FACTOR DE COAGULACIÓN"
  },
  {
    "codigo":365535002,
    "descripcion":"INSTALACIONES DE MÁQUINAS EXPENDEDORAS EN EL ÁMBITO LABORAL - HALLAZGO"
  },
  {
    "codigo":5087009,
    "descripcion":"PELVIS BRAQUIPÉLICA"
  },
  {
    "codigo":15739041000119106,
    "descripcion":"GLAUCOMA DE AMBOS OJOS DEBIDO A ANOMALÍA CONGÉNITA DE AMBOS IRIS"
  },
  {
    "codigo":396468007,
    "descripcion":"MARGEN QUIRÚRGICO PARENQUIMATOSO NO COMPROMETIDO POR NEOPLASIA MALIGNA"
  },
  {
    "codigo":68788007,
    "descripcion":"INTOXICACIÓN POR CICUTA MACULATA"
  },
  {
    "codigo":789684009,
    "descripcion":"DISPOSITIVO ANTICONCEPTIVO INTRAUTERINO RETENIDO"
  },
  {
    "codigo":230793002,
    "descripcion":"QUISTE DE NEUROGLIA"
  },
  {
    "codigo":298164009,
    "descripcion":"INFLAMACIÓN DE ARTICULACIÓN DE MUÑECA"
  },
  {
    "codigo":296329002,
    "descripcion":"SOBREDOSIS DE CAFEÍNA"
  },
  {
    "codigo":196190001,
    "descripcion":"INSUFICIENCIA PULMONAR CRÓNICA LUEGO DE UNA CIRUGÍA"
  },
  {
    "codigo":294494002,
    "descripcion":"ALERGIA A PENICILINA BENETAMINA"
  },
  {
    "codigo":65118005,
    "descripcion":"PROBLEMA MARITAL"
  },
  {
    "codigo":1179230007,
    "descripcion":"AMBIENTE DE DESCUIDO"
  },
  {
    "codigo":235840008,
    "descripcion":"SÍNDROME DEL INTESTINO IRRITABLE, VARIANTE DE LA INFANCIA CON ESTREÑIMIENTO"
  },
  {
    "codigo":15630651000119104,
    "descripcion":"TENDINITIS DE MANO DERECHA"
  },
  {
    "codigo":321371000119100,
    "descripcion":"RUPTURA ESPONTÁNEA DE TENDÓN EXTENSOR DE MANO IZQUIERDA"
  },
  {
    "codigo":367451000119101,
    "descripcion":"DISFUNCIÓN ERÉCTIL POSTERIOR A PROSTATECTOMÍA RADICAL"
  },
  {
    "codigo":1081691000119102,
    "descripcion":"SARCOMA PRIMARIO DE PARTES BLANDAS DE EXTREMIDAD SUPERIOR IZQUIERDA"
  },
  {
    "codigo":677211000119101,
    "descripcion":"SÍNDROME DE HISTOPLASMOSIS DE OJO IZQUIERDO"
  },
  {
    "codigo":1076571000119104,
    "descripcion":"BURSITIS ESCAPULOTORÁCICA DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":11777371000119105,
    "descripcion":"HEMATOMA DE TOBILLO DERECHO"
  },
  {
    "codigo":303451000119106,
    "descripcion":"DEPÓSITO DE CALCIO EN BOLSA SEROSA DE CODO IZQUIERDO"
  },
  {
    "codigo":353043291000119101,
    "descripcion":"ÚLCERA VENOSA DE PIERNA IZQUIERDA"
  },
  {
    "codigo":11805531000119103,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA PROXIMAL DE DEDO DE MANO IZQUIERDA"
  },
  {
    "codigo":1099611000119109,
    "descripcion":"MUTACIÓN GENÉTICA PARA CÁNCER DE COLON NO RELACIONADO CON POLIPOSIS HEREDITARIA DETECTADA"
  },
  {
    "codigo":341851000119102,
    "descripcion":"QUERATOPATÍA BULLOSA DE OJO IZQUIERDO"
  },
  {
    "codigo":90971000119103,
    "descripcion":"GLOMERULONEFRITIS CONCOMITANTE CON VASCULITIS Y DEBIDA A ELLA"
  },
  {
    "codigo":24411000119104,
    "descripcion":"TUMEFACCIÓN DE TRIÁNGULO SUBMANDIBULAR"
  },
  {
    "codigo":126984006,
    "descripcion":"NEOPLASIA DE LOS NERVIOS PERIFÉRICOS DEL CUELLO"
  },
  {
    "codigo":716808001,
    "descripcion":"CORYNEBACTERIUM AMYCOLATUM O CORYNEBACTERIUM STRIATUM"
  },
  {
    "codigo":346971000119106,
    "descripcion":"ESCOTOMA CENTROCECAL BILATERAL"
  },
  {
    "codigo":288989004,
    "descripcion":"INCAPAZ DE PRENDERSE AL PECHO PARA MAMAR"
  },
  {
    "codigo":92381001,
    "descripcion":"NEOPLASIA BENIGNA DE LA PIEL DEL OMBLIGO"
  },
  {
    "codigo":290824009,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR DESIPRAMINA"
  },
  {
    "codigo":125149003,
    "descripcion":"DENSIDAD POR ENCIMA DE RANGO DE REFERENCIA"
  },
  {
    "codigo":25010000,
    "descripcion":"CISTINOSIS ADULTA BENIGNA"
  },
  {
    "codigo":420061009,
    "descripcion":"REFLEJO DE DEFECACIÓN NORMAL"
  },
  {
    "codigo":57778005,
    "descripcion":"LESIÓN TRAUMÁTICA DE TOBILLO EN SUPINACIÓN-ADUCCIÓN, GRADO 1"
  },
  {
    "codigo":1237426005,
    "descripcion":"METÁSTASIS DE CARCINOMA DE GLÁNDULA PARATIROIDES"
  },
  {
    "codigo":1335730007,
    "descripcion":"SÍNDROME POR RADIACIÓN POSTERIOR A RADIOTERAPIA"
  },
  {
    "codigo":788915008,
    "descripcion":"ENCEFALITIS CAUSADA POR HENIPAVIRUS"
  },
  {
    "codigo":185180001,
    "descripcion":"ATENDIDO EN CONSULTORIO ESPECIALIZADO EN TRASTORNOS GENITOURINARIOS"
  },
  {
    "codigo":283484002,
    "descripcion":"HERIDA PUNZANTE EN LA RODILLA"
  },
  {
    "codigo":285141000119106,
    "descripcion":"ARTERIOSCLEROSIS DE INJERTO-PUENTE ARTERIAL AUTÓLOGO DE ARTERIA CORONARIA"
  },
  {
    "codigo":840540008,
    "descripcion":"QUEMADURA DE DÍGITOS DE MANO"
  },
  {
    "codigo":367061000119107,
    "descripcion":"PRIAPISMO DEBIDO A DREPANOCITOSIS"
  },
  {
    "codigo":10662511000119101,
    "descripcion":"ÚLCERA DE REGIÓN MEDIA DEL PIE"
  },
  {
    "codigo":248881004,
    "descripcion":"PROLAPSO DE LA PARED VAGINAL EN EL INTROITO"
  },
  {
    "codigo":609329007,
    "descripcion":"SÍNDROME ANTIFOSFOLIPÍDICO CATASTRÓFICO"
  },
  {
    "codigo":771334000,
    "descripcion":"DISTROFIA MUSCULAR DE LAS CINTURAS DE LAS EXTREMIDADES TIPO 1H AUTOSÓMICA DOMINANTE"
  },
  {
    "codigo":50438001,
    "descripcion":"VÉRTIGO PERIFÉRICO"
  },
  {
    "codigo":1230086004,
    "descripcion":"PATRÓN DE USO EPISÓDICO NOCIVO SIN DEPENDENCIA DE PSICOESTIMULANTE"
  },
  {
    "codigo":16832981000119109,
    "descripcion":"NEVO MELANOCÍTICO DE NARIZ"
  },
  {
    "codigo":15931861000119109,
    "descripcion":"TORSIÓN CONGÉNITA DE OVARIO DERECHO"
  },
  {
    "codigo":472752007,
    "descripcion":"OCLUSIÓN DE VENA CAVA SUPERIOR DEBIDA A NEOPLASIA"
  },
  {
    "codigo":1290117000,
    "descripcion":"TUMOR DE PÁNCREAS SECRETOR DE PÉPTIDO RELACIONADO CON HORMONA PARATIROIDEA"
  },
  {
    "codigo":77701002,
    "descripcion":"SÍNDROME DE MALFORMACIÓN MÚLTIPLE, ESTATURA BAJA MODERADA, FACIAL, CON O SIN CARACTERÍSTICAS GENITALES"
  },
  {
    "codigo":44933002,
    "descripcion":"PERFORACIONES MÚLTIPLES DE LA MEMBRANA TIMPÁNICA"
  },
  {
    "codigo":307077003,
    "descripcion":"SENTIRSE DESESPERANZADO"
  },
  {
    "codigo":700293006,
    "descripcion":"ARTROSIS PRIMARIA DE TOBILLO"
  },
  {
    "codigo":43098002,
    "descripcion":"FIEBRE POR COBRE"
  },
  {
    "codigo":403546006,
    "descripcion":"LINFANGIOMATOSIS"
  },
  {
    "codigo":399876000,
    "descripcion":"RETINOPATÍA NO PROLIFERATIVA MUY SEVERA DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":72196001,
    "descripcion":"REFLUJO HEPATOYUGULAR"
  },
  {
    "codigo":1153540004,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR FLUOROQUINOLONA"
  },
  {
    "codigo":11864841000119106,
    "descripcion":"LESIÓN TRAUMÁTICA DE PIERNA IZQUIERDA"
  },
  {
    "codigo":301572006,
    "descripcion":"SE MOVILIZA CON DISPOSITIVOS ORTOPÉDICOS"
  },
  {
    "codigo":1055236008,
    "descripcion":"AUSENCIA DE REFLEJO DE MÚSCULO TENSOR DE TÍMPANO"
  },
  {
    "codigo":236036009,
    "descripcion":"HERNIA EPIGÁSTRICA ESTRANGULADA"
  },
  {
    "codigo":234201003,
    "descripcion":"HEMORRAGIA DE INJERTO VASCULAR"
  },
  {
    "codigo":365273004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA UTILIZAR UTENSILIOS DE COCINA"
  },
  {
    "codigo":363438000,
    "descripcion":"NEOPLASIA MALIGNA DE COLUMNA VERTEBRAL"
  },
  {
    "codigo":299737009,
    "descripcion":"LESIÓN DE NEURONA MOTORA INFERIOR"
  },
  {
    "codigo":15715081000119109,
    "descripcion":"OSTEOFITOS DE AMBOS PIES"
  },
  {
    "codigo":723886005,
    "descripcion":"INTOXICACIÓN CAUSADA POR MANDIOCA"
  },
  {
    "codigo":396206006,
    "descripcion":"MARGEN QUIRÚRGICO URETERAL COMPROMETIDO POR NEOPLASIA MALIGNA"
  },
  {
    "codigo":232366008,
    "descripcion":"COLAPSO ALAR"
  },
  {
    "codigo":35758009,
    "descripcion":"ALTERACIÓN EN LA ABSORCIÓN INTESTINAL DE CARBOHIDRATOS"
  },
  {
    "codigo":2990008,
    "descripcion":"REACCIÓN LEUCEMOIDE LINFOCÍTICA"
  },
  {
    "codigo":166830008,
    "descripcion":"COLESTEROL SÉRICO POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":722051004,
    "descripcion":"SÍNDROME DE OBESIDAD, COLITIS, HIPOTIROIDISMO, HIPERTROFIA CARDÍACA Y RETRASO DEL DESARROLLO"
  },
  {
    "codigo":427139004,
    "descripcion":"SANGRADO DEL TERCER TRIMESTRE"
  },
  {
    "codigo":1344643006,
    "descripcion":"HERNIA DIAFRAGMÁTICA CRÓNICA TRAUMÁTICA"
  },
  {
    "codigo":1155004,
    "descripcion":"HIPERTROFIA MIOCÁRDICA DETERMINADA MEDIANTE ELECTROCARDIOGRAMA"
  },
  {
    "codigo":66691008,
    "descripcion":"FRACTURA EXPUESTA DE HUESOS DEL TRONCO"
  },
  {
    "codigo":197763008,
    "descripcion":"PIONEFROSIS CRÓNICA"
  },
  {
    "codigo":296067008,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE LORMETAZEPAM"
  },
  {
    "codigo":294232004,
    "descripcion":"ALERGIA A VECURONIO"
  },
  {
    "codigo":95789005,
    "descripcion":"NISTAGMO PRODUCIDO POR LA ROTACIÓN DEL CUELLO"
  },
  {
    "codigo":11811901000119102,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE PULGAR DERECHO"
  },
  {
    "codigo":292397009,
    "descripcion":"REACCIÓN ADVERSA A LA PERFENAZINA"
  },
  {
    "codigo":126722002,
    "descripcion":"NEOPLASIA DEL TEJIDO MESOTELIAL DE LA PLEURA"
  },
  {
    "codigo":128557009,
    "descripcion":"FÍSTULA CONGÉNITA DE ARTERIA CORONARIA A AURÍCULA DERECHA"
  },
  {
    "codigo":16235581000119102,
    "descripcion":"ECTROPIÓN CICATRIZAL DE AMBOS PÁRPADOS INFERIORES"
  },
  {
    "codigo":225026002,
    "descripcion":"ETAPA DE IRA EN EL PROCESO DE DUELO"
  },
  {
    "codigo":1306370007,
    "descripcion":"SARCOMA DE CUADRANTE INFERIOR INTERNO DE MAMA"
  },
  {
    "codigo":92119004,
    "descripcion":"NEOPLASIA BENIGNA DE LA MUCOSA GINGIVAL"
  },
  {
    "codigo":288727006,
    "descripcion":"INCAPAZ DE EMPLEAR DIFERENTES FORMAS DE CONVERSACIÓN"
  },
  {
    "codigo":97341000119105,
    "descripcion":"RETINOPATÍA PROLIFERATIVA CON EDEMA DE RETINA DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":254124008,
    "descripcion":"OSTEOSCLEROSIS - TIPO STANESCU"
  },
  {
    "codigo":416129000,
    "descripcion":"ENFERMEDAD NO NEUROINVASIVA POR VIRUS DE LA ENCEFALITIS DE ST. LOUIS"
  },
  {
    "codigo":285057005,
    "descripcion":"DIFICULTAD PARA USAR AUDÍFONO"
  },
  {
    "codigo":343101000119108,
    "descripcion":"DEGENERACIÓN VÍTREA BILATERAL"
  },
  {
    "codigo":283222003,
    "descripcion":"ANZUELO EN EL TOBILLO"
  },
  {
    "codigo":707371002,
    "descripcion":"ESTENOSIS CONGÉNITA DE ARTERIA PULMONAR IZQUIERDA"
  },
  {
    "codigo":281387004,
    "descripcion":"OSTEOPOROSIS REGIONAL"
  },
  {
    "codigo":1231659007,
    "descripcion":"NEURITIS ÓPTICA RETROBULBAR DEBIDA A ESCLEROSIS MÚLTIPLE"
  },
  {
    "codigo":16045271000119105,
    "descripcion":"ALTERACIÓN DE ARTICULACIÓN DE HOMBRO DERECHO"
  },
  {
    "codigo":52011008,
    "descripcion":"LESIÓN TRAUMÁTICA DE DEDO DE LA MANO"
  },
  {
    "codigo":445227008,
    "descripcion":"LEUCEMIA MIELOMONOCÍTICA JUVENIL"
  },
  {
    "codigo":248619009,
    "descripcion":"RALES CREPITANTES DE BURBUJA"
  },
  {
    "codigo":771072001,
    "descripcion":"MONOSOMÍA 9P"
  },
  {
    "codigo":443392007,
    "descripcion":"UTILIZA SÓLO UNA MULETA PARA CAMINAR"
  },
  {
    "codigo":10857841000119101,
    "descripcion":"HERIDA ABIERTA DE MITAD IZQUIERDA DE PARED TORÁCICA POSTERIOR"
  },
  {
    "codigo":441557008,
    "descripcion":"EMBOLIA PULMONAR SÉPTICA"
  },
  {
    "codigo":316631000119109,
    "descripcion":"OSTEOFITO DE TOBILLO DERECHO"
  },
  {
    "codigo":15691121000119103,
    "descripcion":"ARTRITIS REUMATOIDEA SERONEGATIVA DE ARTICULACIÓN DE AMBOS CODOS"
  },
  {
    "codigo":110207000,
    "descripcion":"QUEMADURA DE PRIMER GRADO DE LA ENCÍA UNIDA AL MAXILAR SUPERIOR"
  },
  {
    "codigo":44671008,
    "descripcion":"HEMORRAGIA SUPRARRENAL PERINATAL"
  },
  {
    "codigo":10068001,
    "descripcion":"TRASTORNO CORTICAL SOMÁTICO SENSITIVO"
  },
  {
    "codigo":403284004,
    "descripcion":"ONICOATROFIA CONGÉNITA"
  },
  {
    "codigo":1288020005,
    "descripcion":"AMPUTACIÓN DE MANO COMPLETA"
  },
  {
    "codigo":1156948008,
    "descripcion":"NO INMUNE AL VIRUS DE LA RABIA"
  },
  {
    "codigo":1255252008,
    "descripcion":"REABSORCIÓN DE PROCESO ALVEOLAR DEBIDA A TRAUMA DENTAL"
  },
  {
    "codigo":235774002,
    "descripcion":"ABSCESO DE COLON CONCOMITANTE CON ENFERMEDAD DIVERTICULAR COLÓNICA Y DEBIDO A ELLA"
  },
  {
    "codigo":301310005,
    "descripcion":"HALLAZGO RELACIONADO CON EL ROSTRO"
  },
  {
    "codigo":6398009,
    "descripcion":"ENFERMEDAD CRÓNICA IDIOPÁTICA POR CRIOAGLUTININAS"
  },
  {
    "codigo":70099003,
    "descripcion":"ENFERMEDAD DE STARGARDT"
  },
  {
    "codigo":365011004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA USAR COMBINACIÓN ENTRE CONSONANTE Y VOCAL"
  },
  {
    "codigo":37331004,
    "descripcion":"TRASTORNO DEL ESTADO DE ÁNIMO ORGÁNICO CAUSADO POR SUSTANCIA PSICOACTIVA"
  },
  {
    "codigo":299475005,
    "descripcion":"HALLAZGO RELACIONADO CON LA TEMPERATURA DEL PIE"
  },
  {
    "codigo":233939005,
    "descripcion":"EMBOLIA GRASA PULMONAR SUBAGUDA"
  },
  {
    "codigo":789160000,
    "descripcion":"DISPLASIA DÉRMICA FACIAL FOCAL TIPO III"
  },
  {
    "codigo":102867009,
    "descripcion":"ALTERACIÓN DEL COLOR DE LA ORINA"
  },
  {
    "codigo":397779007,
    "descripcion":"POSICIÓN DEL PACIENTE PARA BLOQUEO REGIONAL"
  },
  {
    "codigo":363176004,
    "descripcion":"TRASTORNO INFLAMATORIO DE LA CABEZA"
  },
  {
    "codigo":73381000119100,
    "descripcion":"QUISTE DE SEGUNDA HENDIDURA BRANQUIAL"
  },
  {
    "codigo":319141000119100,
    "descripcion":"ARTRITIS REUMATOIDEA SERONEGATIVA DE ARTICULACIÓN DE REGIÓN DE HOMBRO DERECHO"
  },
  {
    "codigo":723624008,
    "descripcion":"TRASTORNO DE LA GLICOSILACIÓN POR ANOMALÍA DEL MIEMBRO A1 DE LA FAMILIA 35 DE TRANSPORTADORES DE SOLUTOS"
  },
  {
    "codigo":35496009,
    "descripcion":"NEURALGIA DE NERVIO FEMORAL"
  },
  {
    "codigo":721789002,
    "descripcion":"INFECCIÓN CAUSADA POR HENIPAVIRUS"
  },
  {
    "codigo":263037004,
    "descripcion":"SUBLUXACIÓN DE ARTICULACIÓN SACROILÍACA"
  },
  {
    "codigo":66429007,
    "descripcion":"NEUMONÍA LOBULAR NO RESUELTA"
  },
  {
    "codigo":228434000,
    "descripcion":"TOLERANCIA FÍSICA A LA DROGA"
  },
  {
    "codigo":31826001,
    "descripcion":"CAPACIDAD DE FIJACIÓN DEL AGUA DEL ESTRATO CÓRNEO DISMINUIDA"
  },
  {
    "codigo":230269008,
    "descripcion":"MAL DE ALZHEIMER FOCAL"
  },
  {
    "codigo":295805009,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE AZATIOPRINA"
  },
  {
    "codigo":293970004,
    "descripcion":"ALERGIA A METOPROLOL"
  },
  {
    "codigo":1082891000119109,
    "descripcion":"OTITIS EXTERNA AGUDA DE CONTACTO DE AMBOS CONDUCTOS AUDITIVOS EXTERNOS"
  },
  {
    "codigo":195666007,
    "descripcion":"AMIGDALITIS ERITEMATOSA AGUDA"
  },
  {
    "codigo":128295000,
    "descripcion":"TRASTORNO INFLAMATORIO DEL OJO"
  },
  {
    "codigo":284296000,
    "descripcion":"REALIZA LA PRENSIÓN CON SUPINACIÓN DE MUÑECA"
  },
  {
    "codigo":95527007,
    "descripcion":"PARESTESIA DE LA LENGUA"
  },
  {
    "codigo":1142268000,
    "descripcion":"HIPERTROFIA DE MÚSCULO DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":292135009,
    "descripcion":"REACCIÓN ADVERSA A UN LAXANTE"
  },
  {
    "codigo":93692004,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE VASO SANGUÍNEO AXILAR"
  },
  {
    "codigo":388604008,
    "descripcion":"INFLAMACIÓN DE VELLOSIDADES CORIÓNICAS"
  },
  {
    "codigo":290300009,
    "descripcion":"INTOXICACIÓN POR SULINDAC"
  },
  {
    "codigo":91857003,
    "descripcion":"LEUCEMIA LINFOIDE AGUDA"
  },
  {
    "codigo":124625008,
    "descripcion":"DEFICIENCIA DE HIALURONATO LIASA"
  },
  {
    "codigo":188326001,
    "descripcion":"NEOPLASIA MALIGNA DE NERVIO PERIFÉRICO DEL ABDOMEN"
  },
  {
    "codigo":1204134002,
    "descripcion":"FRACTURA DE DERIVACIÓN VENTRICULAR DE DESFIBRILADOR CARDIOVERSOR IMPLANTABLE"
  },
  {
    "codigo":253862000,
    "descripcion":"RIÑÓN TRÍFIDO"
  },
  {
    "codigo":417702007,
    "descripcion":"TRASTORNO CAUSADO POR VIRUS DE LA ENCEFALITIS EQUINA DE VENEZUELA"
  },
  {
    "codigo":448635000,
    "descripcion":"CONDUCTO VENOSO AUSENTE"
  },
  {
    "codigo":284795002,
    "descripcion":"NO SE DUCHA"
  },
  {
    "codigo":292671000119104,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DEBIDO A ESTENOSIS DE ARTERIA VERTEBRAL IZQUIERDA"
  },
  {
    "codigo":219259004,
    "descripcion":"LESIÓN POR INTERVENCIÓN LEGAL CON REVÓLVER"
  },
  {
    "codigo":55419007,
    "descripcion":"TUBERCULOSIS DE LA GLOTIS"
  },
  {
    "codigo":710779007,
    "descripcion":"REFLUJO DE ORINA"
  },
  {
    "codigo":414032001,
    "descripcion":"TRASTORNO DE LA PIGMENTACIÓN"
  },
  {
    "codigo":86352002,
    "descripcion":"ESCLEROSIS DE LA PIEL"
  },
  {
    "codigo":16021311000119105,
    "descripcion":"BURSITIS RETROCALCÁNEA DE AMBOS PIES"
  },
  {
    "codigo":282960007,
    "descripcion":"INCAPAZ DE ACUCLILLARSE"
  },
  {
    "codigo":48079002,
    "descripcion":"ALTERACIÓN DEL ÁNIMO"
  },
  {
    "codigo":168627008,
    "descripcion":"RADIOGRAFÍA SIMPLE DE RADIO: ANORMAL"
  },
  {
    "codigo":102361000119104,
    "descripcion":"NEUMONÍA CRÓNICA"
  },
  {
    "codigo":277455002,
    "descripcion":"TERCER RUIDO CARDÍACO"
  },
  {
    "codigo":15311007,
    "descripcion":"SIGNO DE ERICHSEN"
  },
  {
    "codigo":408527008,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: LUGANDA"
  },
  {
    "codigo":79012001,
    "descripcion":"ESPASMO VAGINAL"
  },
  {
    "codigo":898212001,
    "descripcion":"SINOSTOSIS CONGÉNITA DE FALANGE PROXIMAL DE DEDO GORDO CON PRIMER HUESO METATARSIANO"
  },
  {
    "codigo":210084003,
    "descripcion":"LESIÓN EXPUESTA DE DIAFRAGMA"
  },
  {
    "codigo":46244001,
    "descripcion":"DEPRESIÓN MAYOR RECURRENTE EN REMISIÓN COMPLETA"
  },
  {
    "codigo":348121000119106,
    "descripcion":"ABSCESO DE REGIÓN PERIORBITARIA DE OJO DERECHO"
  },
  {
    "codigo":439460003,
    "descripcion":"DEFICIENCIA HEREDITARIA DE SUBUNIDADES A Y B DE FACTOR XIII"
  },
  {
    "codigo":111780007,
    "descripcion":"TOXICIDAD DEL SULFATO DE AMONIO"
  },
  {
    "codigo":372089002,
    "descripcion":"INCAPAZ DE CUMPLIR EL TRATAMIENTO"
  },
  {
    "codigo":109945006,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LOS NERVIOS PERIFÉRICOS DE LA REGIÓN PÉLVICA"
  },
  {
    "codigo":11641008,
    "descripcion":"ASMA DE LOS MOLINEROS"
  },
  {
    "codigo":75342000,
    "descripcion":"ÚLCERA DUODENAL AGUDA SIN HEMORRAGIA Y SIN PERFORACIÓN PERO CON OBSTRUCCIÓN"
  },
  {
    "codigo":239182004,
    "descripcion":"HEMATOMA DE INJERTO DE PIEL"
  },
  {
    "codigo":403022005,
    "descripcion":"TIÑA CORPORAL CAUSADA POR EPIDERMOPHYTON FLOCCOSUM"
  },
  {
    "codigo":42574005,
    "descripcion":"ESCLERITIS CON COMPROMISO DE CÓRNEA PERIFÉRICA"
  },
  {
    "codigo":40739000,
    "descripcion":"DISFAGIA"
  },
  {
    "codigo":1187619001,
    "descripcion":"ENFERMEDAD DE CHARCOT MARIE TOOTH AXONAL AUTOSÓMICA RECESIVA DEBIDA A DEFECTO DEL METABOLISMO DEL COBRE"
  },
  {
    "codigo":73507002,
    "descripcion":"CIFOSIS POSTURAL DEL ADOLESCENTE"
  },
  {
    "codigo":270115005,
    "descripcion":"MUERTE NO ESPERADA - DICHO POR EL MÉDICO FORENSE"
  },
  {
    "codigo":302883007,
    "descripcion":"QUISTE MENÍNGEO"
  },
  {
    "codigo":202744000,
    "descripcion":"DISCITIS CERVICAL"
  },
  {
    "codigo":366584004,
    "descripcion":"GRAFESTESIA - HALLAZGO"
  },
  {
    "codigo":102605001,
    "descripcion":"MÁSCARA DE HUTCHINSON"
  },
  {
    "codigo":233677001,
    "descripcion":"ENFISEMA CICATRIZAL"
  },
  {
    "codigo":364749003,
    "descripcion":"HALLAZGO RELACIONADO CON EL ENCAJAMIENTO DE LA PRESENTACIÓN FETAL"
  },
  {
    "codigo":37069004,
    "descripcion":"INFECCIÓN CAUSADA POR MONIEZIA BENEDENI"
  },
  {
    "codigo":299213008,
    "descripcion":"AMPUTADO POR ARRIBA DE CODO"
  },
  {
    "codigo":4301008,
    "descripcion":"ESTADO AUTOINMUNITARIO"
  },
  {
    "codigo":723362004,
    "descripcion":"HIPOTRICOSIS SIMPLE HEREDITARIA"
  },
  {
    "codigo":788898005,
    "descripcion":"DEMENCIA CAUSADA POR INHALANTE VOLÁTIL"
  },
  {
    "codigo":231842006,
    "descripcion":"DACRIOCISTITIS CRÓNICA CON FORMACIÓN DE FÍSTULA"
  },
  {
    "codigo":721527000,
    "descripcion":"SÍNDROME DE BROWN-SEQUARD AL NIVEL DEL CUARTO SEGMENTO LUMBAR"
  },
  {
    "codigo":262775001,
    "descripcion":"FRAGMENTACIÓN DE GLÁNDULA TIROIDES"
  },
  {
    "codigo":631002,
    "descripcion":"REACCIÓN A UNA TRANSFUSIÓN, CAUSADA POR INCOMPATIBILIDAD MENOR"
  },
  {
    "codigo":295543003,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE TRICLOROETILENO"
  },
  {
    "codigo":293708000,
    "descripcion":"ALERGIA A PROPOFOL"
  },
  {
    "codigo":195404000,
    "descripcion":"FLEBITIS DE LA VENA FEMORAL"
  },
  {
    "codigo":129868008,
    "descripcion":"CONOCIMIENTOS ESCASOS ACERCA DE LAS PAUTAS TERAPÉUTICAS"
  },
  {
    "codigo":62497000,
    "descripcion":"SÍNDROME DE STEWART-TREVES"
  },
  {
    "codigo":15997351000119101,
    "descripcion":"PLIEGUE IDIOPÁTICO DE COROIDES DE OJO DERECHO"
  },
  {
    "codigo":95265004,
    "descripcion":"COSTILLA SUPERNUMERARIA CORTA"
  },
  {
    "codigo":93430000,
    "descripcion":"CABEZA EN CÚPULA"
  },
  {
    "codigo":879862001,
    "descripcion":"PERFORACIÓN DEL CUERPO"
  },
  {
    "codigo":716022002,
    "descripcion":"SÍNDROME DE DISPLASIA FRONTOFACIONASAL"
  },
  {
    "codigo":350631000119102,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE NERVIO AUDITIVO IZQUIERDO"
  },
  {
    "codigo":22951000119104,
    "descripcion":"CRUP ESPASMÓDICO"
  },
  {
    "codigo":288203005,
    "descripcion":"SITUACIÓN TRANSVERSA\/OBLICUA"
  },
  {
    "codigo":89760000,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE PELVIS"
  },
  {
    "codigo":124363008,
    "descripcion":"DEFICIENCIA DE ALCOHOL SULFOTRANSFERASA"
  },
  {
    "codigo":384672004,
    "descripcion":"MICROCALCIFICACIONES PRESENTES EN TEJIDO NO NEOPLÁSICO"
  },
  {
    "codigo":286368006,
    "descripcion":"CAPAZ DE HABLAR"
  },
  {
    "codigo":253600008,
    "descripcion":"VÁLVULA PULMONAR CUADRICÚSPIDE"
  },
  {
    "codigo":188064009,
    "descripcion":"MELANOMA MALIGNO DE DEDO DE LA MANO"
  },
  {
    "codigo":678311000119108,
    "descripcion":"SINEQUIAS ANTERIORES DE IRIS DE AMBOS OJOS"
  },
  {
    "codigo":249930000,
    "descripcion":"NO PUEDE TOCAR LA REGIÓN LUMBAR"
  },
  {
    "codigo":1003594001,
    "descripcion":"SINOSTOSIS CONGÉNITA DE SUTURA CORONAL IZQUIERDA DE CRÁNEO"
  },
  {
    "codigo":448373008,
    "descripcion":"NEOPLASIA DE PARED DEL ESTÓMAGO"
  },
  {
    "codigo":282698005,
    "descripcion":"EMPUJA Y TIRA HACIA ATRÁS UN JUGUETE GRANDE CON RUEDAS"
  },
  {
    "codigo":15725121000119103,
    "descripcion":"DERRAME ARTICULAR DE AMBOS TOBILLOS"
  },
  {
    "codigo":315466009,
    "descripcion":"NACIDO EN LIBIA"
  },
  {
    "codigo":870687002,
    "descripcion":"DIFICULTAD PARA MANEJAR ACTIVIDADES RELACIONADAS CON LA RESIDENCIA"
  },
  {
    "codigo":18719006,
    "descripcion":"REABSORCIÓN OBLIGATORIA DE AGUA"
  },
  {
    "codigo":442868003,
    "descripcion":"NEOPLASIA DEL SISTEMA ESQUELÉTICO"
  },
  {
    "codigo":16884005,
    "descripcion":"INTOXICACIÓN POR ANAGALLIS ARVENSIS"
  },
  {
    "codigo":705012007,
    "descripcion":"ELEVACIÓN ANTEROLATERAL DE SEGMENTO ST"
  },
  {
    "codigo":80585000,
    "descripcion":"INTOLERANCIA AL FRÍO"
  },
  {
    "codigo":279028009,
    "descripcion":"DOLOR OVÁRICO"
  },
  {
    "codigo":311796008,
    "descripcion":"INFARTO MIOCÁRDICO SUBENDOCÁRDICO, POSQUIRÚRGICO"
  },
  {
    "codigo":768713003,
    "descripcion":"SÍNDROME DE MICRODUPLICACIÓN 15Q13.3"
  },
  {
    "codigo":275358000,
    "descripcion":"COMPLICACIÓN DE PIE REIMPLANTADO"
  },
  {
    "codigo":1293001008,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE TENDÓN DE CUÁDRICEPS"
  },
  {
    "codigo":703177009,
    "descripcion":"ESTENOSIS CALCIFICADA DE PRÓTESIS DE VÁLVULA MITRAL"
  },
  {
    "codigo":766878003,
    "descripcion":"DIFICULTAD FAMILIAR CON LACTANTE QUE LLORA"
  },
  {
    "codigo":373662000,
    "descripcion":"INSUFICIENCIA CORTICOSUPRARRENAL PRIMARIA"
  },
  {
    "codigo":10947291000119103,
    "descripcion":"HERIDA ABIERTA DE DEDO DE LA MANO IZQUIERDA DEBIDA A MORDEDURA DE PERRO"
  },
  {
    "codigo":45982008,
    "descripcion":"QUEMADURA DEL ESÓFAGO"
  },
  {
    "codigo":371827001,
    "descripcion":"PACIENTE DADO DE ALTA CON VIDA"
  },
  {
    "codigo":109683005,
    "descripcion":"FRACTURA DE RAÍZ DENTAL"
  },
  {
    "codigo":240755005,
    "descripcion":"RINOSPORIDIOSIS CUTÁNEA POLIPOIDE"
  },
  {
    "codigo":1354867008,
    "descripcion":"MANTIENE RESIDENCIA INCÓMODAMENTE FRÍA DEBIDO A ESCASEZ DE RECURSOS ECONÓMICOS"
  },
  {
    "codigo":42312000,
    "descripcion":"RUPTURA DE LA MEMBRANA DE DESCEMET"
  },
  {
    "codigo":402760004,
    "descripcion":"TRASTORNO CUTÁNEO POR FOTOTERAPIA"
  },
  {
    "codigo":1254728008,
    "descripcion":"METÁSTASIS DE CARCINOMA ADENOIDE QUÍSTICO EN TRÁQUEA"
  },
  {
    "codigo":271688008,
    "descripcion":"ÚTERO EN ANTEROVERSIÓN"
  },
  {
    "codigo":237085007,
    "descripcion":"CERVICITIS ACTINOMICÓTICA"
  },
  {
    "codigo":204317008,
    "descripcion":"FORAMEN OVAL PERSISTENTE"
  },
  {
    "codigo":1285661007,
    "descripcion":"ENFERMEDAD POR DEFICIENCIA DE FACTOR IX HEREDITARIA GRAVE CON INHIBIDOR DE ALTA RESPUESTA"
  },
  {
    "codigo":5874002,
    "descripcion":"ANSIEDAD ANTICIPATORIA, SEVERA"
  },
  {
    "codigo":399090003,
    "descripcion":"VÉRTIGO SUBJETIVO"
  },
  {
    "codigo":300786001,
    "descripcion":"CAPAZ DE INICIAR JUEGO ESPONTÁNEO"
  },
  {
    "codigo":680821000119103,
    "descripcion":"NEVO DE IRIS IZQUIERDO"
  },
  {
    "codigo":202482009,
    "descripcion":"DOLOR DE ARTICULACIÓN DE MUÑECA"
  },
  {
    "codigo":724935006,
    "descripcion":"LACERACIÓN DE TRICEPS BRAQUIAL"
  },
  {
    "codigo":298951007,
    "descripcion":"AMPLITUD DE FLEXIÓN ACTIVA DE LA MUÑECA DISMINUIDA"
  },
  {
    "codigo":4039009,
    "descripcion":"HIPOVITAMINOSIS, MÚLTIPLES VITAMINAS"
  },
  {
    "codigo":198812002,
    "descripcion":"INTENTO FALLIDO DE ABORTO CON EMBOLIA"
  },
  {
    "codigo":2204004,
    "descripcion":"DEFORMIDAD ADQUIRIDA DEL PABELLÓN AURICULAR"
  },
  {
    "codigo":723100004,
    "descripcion":"ÚLCERA GÁSTRICA CAUSADA POR VIRUS"
  },
  {
    "codigo":460956006,
    "descripcion":"INSERCIÓN ANÓMALA DE LIGAMENTO ARTERIOSO EN ARTERIA PULMONAR DERECHA"
  },
  {
    "codigo":369001,
    "descripcion":"PRESIÓN VENOSA YUGULAR NORMAL"
  },
  {
    "codigo":229745006,
    "descripcion":"ALTERACIÓN DEL DESARROLLO SEMÁNTICO"
  },
  {
    "codigo":295281007,
    "descripcion":"SOBREDOSIS INTENCIONAL DE NEFOPAM"
  },
  {
    "codigo":721265008,
    "descripcion":"INFECCIÓN DE PIEL Y\/O MEMBRANA MUCOSA CAUSADA POR VIRUS HERPES"
  },
  {
    "codigo":195142000,
    "descripcion":"MÚSCULO PAPILAR - DEGENERACIÓN"
  },
  {
    "codigo":196977009,
    "descripcion":"ENFERMEDAD DE CROHN DEL ÍLEON TERMINAL"
  },
  {
    "codigo":31302006,
    "descripcion":"LINFANGITIS AGUDA DE ANTEBRAZO"
  },
  {
    "codigo":129606007,
    "descripcion":"SÍNDROME DEL LÓBULO FRONTAL"
  },
  {
    "codigo":719430008,
    "descripcion":"ENFERMEDAD DE LEBER \"PLUS\""
  },
  {
    "codigo":293446006,
    "descripcion":"REACCIÓN ADVERSA A LA PROPAFENONA"
  },
  {
    "codigo":291611000,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR CEFODIZIMA"
  },
  {
    "codigo":95003003,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE HUESO PISIFORME DE REGIÓN DE MUÑECA"
  },
  {
    "codigo":60400003,
    "descripcion":"ÚLCERA PÉPTICA CRÓNICA SIN HEMORRAGIA, SIN PERFORACIÓN Y SIN OBSTRUCCIÓN"
  },
  {
    "codigo":1010672007,
    "descripcion":"VÉRTIGO POSICIONAL PAROXÍSTICO BENIGNO DEL CANAL SEMICIRCULAR LATERAL"
  },
  {
    "codigo":289776007,
    "descripcion":"CUELLO UTERINO ESTRECHO"
  },
  {
    "codigo":58565006,
    "descripcion":"LESIÓN TRAUMÁTICA DE CABEZA DEL PÁNCREAS SIN HERIDA ABIERTA HACIA CAVIDAD"
  },
  {
    "codigo":25797006,
    "descripcion":"ASPIRACIÓN DE SANGRE"
  },
  {
    "codigo":15701161000119102,
    "descripcion":"TRASTORNO DE TENDÓN DE BÍCEPS BRAQUIAL DERECHO"
  },
  {
    "codigo":89498001,
    "descripcion":"AFASIA DEL LÓBULO TEMPORAL"
  },
  {
    "codigo":255173008,
    "descripcion":"PAPILOMA BENIGNO DE RECTO"
  },
  {
    "codigo":286106001,
    "descripcion":"INCAPAZ DE LUSTRAR"
  },
  {
    "codigo":253338004,
    "descripcion":"IMÁGENES AURICULARES EN ESPEJO"
  },
  {
    "codigo":284271003,
    "descripcion":"INCAPAZ DE UTILIZAR PRENSIÓN CON PINZA"
  },
  {
    "codigo":251503006,
    "descripcion":"PUNTA-ONDA FOCAL EPISÓDICA"
  },
  {
    "codigo":11850921000119105,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE HEMITÓRAX IZQUIERDO"
  },
  {
    "codigo":184132006,
    "descripcion":"ES CUESTIONABLE SI EL CÓDIGO POSTAL DEL PACIENTE ES CORRECTO"
  },
  {
    "codigo":85828009,
    "descripcion":"ENFERMEDAD AUTOINMUNITARIA"
  },
  {
    "codigo":781000221105,
    "descripcion":"CHAGAS AGUDO VECTORIAL"
  },
  {
    "codigo":1263641009,
    "descripcion":"METÁSTASIS DE CARCINOMA DE CÉLULAS TRANSICIONALES EN RIÑÓN"
  },
  {
    "codigo":247833009,
    "descripcion":"MIEDO A LAS ACTIVIDADES EN PÚBLICO"
  },
  {
    "codigo":1163502004,
    "descripcion":"INFECCIÓN DE CONDUCTO BILIAR CAUSADA POR HONGOS"
  },
  {
    "codigo":83993009,
    "descripcion":"INFECCIÓN CAUSADA POR GNATHOSTOMA NIPPONICUM"
  },
  {
    "codigo":735683005,
    "descripcion":"TAQUICARDIA DE MACROREENTRADA DEPENDIENTE DEL ISTMO CAVOTRICUSPÍDEO"
  },
  {
    "codigo":27971000119105,
    "descripcion":"INSOMNIO CONCOMITANTE CON AFECCIÓN CLÍNICA Y DEBIDO A ELLA"
  },
  {
    "codigo":373400000,
    "descripcion":"PLEOMORFISMO NUCLEAR, GRADO 3: NÚCLEOS CONSIDERABLEMENTE PLEOMÓRFICOS, GENERALMENTE DE MÁS DE 2,5 DIÁMETROS ERITROCÍTICOS, CON CROMATINA GRUESA Y MÚLTIPLES NUCLÉOLOS"
  },
  {
    "codigo":209560003,
    "descripcion":"ESGUINCE DE ARTICULACIÓN ATLOAXOIDEA"
  },
  {
    "codigo":12207581000119100,
    "descripcion":"INFECCIÓN DE HUESO DE MANO DERECHA ASOCIADA CON DISPOSITIVO DE FIJACIÓN INTERNA"
  },
  {
    "codigo":1354605000,
    "descripcion":"FRACTURA DE FALANGE MEDIA DE ÍNDICE"
  },
  {
    "codigo":240493004,
    "descripcion":"FIEBRE HEMORRÁGICA POR HAZARA"
  },
  {
    "codigo":271426000,
    "descripcion":"SÍFILIS ENDÉMICA NO VENÉREA"
  },
  {
    "codigo":238658001,
    "descripcion":"LIQUEN PLANO DE UÑA"
  },
  {
    "codigo":76653009,
    "descripcion":"EMPIEMA AGUDO DE SENO MAXILAR"
  },
  {
    "codigo":16467421000119102,
    "descripcion":"MELORREOSTOSIS DE FÉMUR DERECHO"
  },
  {
    "codigo":402498000,
    "descripcion":"CARCINOMA BASOCELULAR DEL DORSO DE LA NARIZ"
  },
  {
    "codigo":304194005,
    "descripcion":"AMPLITUD DE FLEXIÓN HORIZONTAL ACTIVA DE HOMBRO AUMENTADA"
  },
  {
    "codigo":72983001,
    "descripcion":"COMPRESIÓN DEL NERVIO ÓPTICO"
  },
  {
    "codigo":366060000,
    "descripcion":"MEDICIÓN DE LA REFRACCIÓN - HALLAZGO"
  },
  {
    "codigo":202220001,
    "descripcion":"LUXACIÓN HABITUAL DE ARTICULACIÓN DE HOMBRO"
  },
  {
    "codigo":890348001,
    "descripcion":"EPIBLÉFARON BILATERAL"
  },
  {
    "codigo":234988003,
    "descripcion":"QUISTE RADICULAR LATERAL"
  },
  {
    "codigo":267756004,
    "descripcion":"CONGESTIÓN - TROMPA DE EUSTAQUIO"
  },
  {
    "codigo":298689004,
    "descripcion":"PRUEBA DE ESTIRAMIENTO DEL NERVIO CIÁTICO POSITIVA"
  },
  {
    "codigo":724673008,
    "descripcion":"TRASTORNO PSICÓTICO CAUSADO POR SEDANTE"
  },
  {
    "codigo":427926004,
    "descripcion":"DISARTRIA LINGUAL"
  },
  {
    "codigo":1501000119109,
    "descripcion":"RETINOPATÍA PROLIFERATIVA DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":264086008,
    "descripcion":"TABIQUE DE SALIDA DESVIADO"
  },
  {
    "codigo":296854009,
    "descripcion":"SOBREDOSIS DE SULFONILUREA"
  },
  {
    "codigo":1217672006,
    "descripcion":"CONJUNTIVITIS FOLICULAR TÓXICA CRÓNICA"
  },
  {
    "codigo":32875003,
    "descripcion":"DEMENCIA PERSISTENTE INDUCIDA POR INHALANTES"
  },
  {
    "codigo":1179755002,
    "descripcion":"FRUCTOSA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":295019008,
    "descripcion":"ALERGIA A MANITOL"
  },
  {
    "codigo":131179008,
    "descripcion":"TIPO YUS"
  },
  {
    "codigo":63808004,
    "descripcion":"CHANCRO TUBERCULOSO"
  },
  {
    "codigo":293184005,
    "descripcion":"REACCIÓN ADVERSA A INSULINA CINC PROTAMINA"
  },
  {
    "codigo":12236561000119100,
    "descripcion":"ARTRITIS DE DEDO DE LA MANO IZQUIERDA"
  },
  {
    "codigo":225813000,
    "descripcion":"NO SE INVOLUCRA EN EL MANEJO DE LOS PROPIOS ASUNTOS"
  },
  {
    "codigo":1145152008,
    "descripcion":"INTOXICACIÓN ACCIDENTAL CAUSADA POR CARBROMAL"
  },
  {
    "codigo":717333002,
    "descripcion":"HIPOTIROIDISMO CONGÉNITO DEBIDO A PASAJE TRANSPLACENTARIO DE ANTICUERPOS MATERNOS INHIBIDORES DE HORMONA TIROESTIMULANTE"
  },
  {
    "codigo":1208853002,
    "descripcion":"TROMBOEMBOLISMO POR TROMBOSIS DE VENA ILÍACA"
  },
  {
    "codigo":291349005,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR DEXTROMETORFANO"
  },
  {
    "codigo":94741007,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL ANO"
  },
  {
    "codigo":15677201000119102,
    "descripcion":"MIOSITIS DE AMBOS MUSLOS"
  },
  {
    "codigo":289514003,
    "descripcion":"TUMORACIÓN DE LA VAGINA"
  },
  {
    "codigo":92906004,
    "descripcion":"FORMA ANORMAL CONGÉNITA DE LA CLAVÍCULA"
  },
  {
    "codigo":191210005,
    "descripcion":"ANEMIA HEMOLÍTICA PRIMARIA POR ANTICUERPOS FRÍOS"
  },
  {
    "codigo":123839000,
    "descripcion":"INADECUADO PARA EVALUACIÓN POR FIJACIÓN ESCASA DE LA MUESTRA"
  },
  {
    "codigo":60138009,
    "descripcion":"ANEMIA POR DÉFICIT HIPOFISARIO"
  },
  {
    "codigo":1172415001,
    "descripcion":"17 - CETOESTEROIDES DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":254911007,
    "descripcion":"TUMOR DE CUERPO CAVERNOSO"
  },
  {
    "codigo":285844003,
    "descripcion":"CAPAZ DE ENTENDER SUS PROPIAS EMOCIONES"
  },
  {
    "codigo":416916004,
    "descripcion":"NEUMONITIS LIPOIDEA"
  },
  {
    "codigo":251241003,
    "descripcion":"ONDA U APLANADA"
  },
  {
    "codigo":1354547005,
    "descripcion":"OCLUSIÓN DE VENA RETINIANA HEMISFÉRICA DE AMBOS OJOS"
  },
  {
    "codigo":709993006,
    "descripcion":"ESQUEMA OCLUSAL DENTADO SUSTANCIALMENTE COMPROMETIDO"
  },
  {
    "codigo":447849009,
    "descripcion":"DOBLE CAYADO AÓRTICO CON ARCO DERECHO DOMINANTE Y ATRESIA DE ARCO IZQUIERDO"
  },
  {
    "codigo":282174004,
    "descripcion":"INCAPAZ DE BAJAR DE UNA COLINA"
  },
  {
    "codigo":249406006,
    "descripcion":"REVESTIMIENTO DE LA MUCOSA ORAL"
  },
  {
    "codigo":10899371000119104,
    "descripcion":"HERIDA PUNZANTE DE LENGUA"
  },
  {
    "codigo":47771000087100,
    "descripcion":"FRACTURA DE OCTAVA COSTILLA DERECHA"
  },
  {
    "codigo":40091000087103,
    "descripcion":"HERIDA DE REGIÓN DE OJO DERECHO POR MORDEDURA"
  },
  {
    "codigo":42651000087103,
    "descripcion":"DISCO INTERVERTEBRAL CERVICAL PROLAPSADO, C3-C4"
  },
  {
    "codigo":704488001,
    "descripcion":"ALTERACIÓN DEL ESTADO PSICOLÓGICO"
  },
  {
    "codigo":442344002,
    "descripcion":"DEMENCIA DEBIDA A COREA DE HUNTINGTON"
  },
  {
    "codigo":49128003,
    "descripcion":"FRACTURAS MÚLTIPLES DE CRÁNEO"
  },
  {
    "codigo":737256004,
    "descripcion":"LESIÓN TRAUMÁTICA DE FASCIA DE PELVIS"
  },
  {
    "codigo":212968006,
    "descripcion":"EMACIACIÓN POR FALTA DE ALIMENTO"
  },
  {
    "codigo":81896006,
    "descripcion":"SIALIDOSIS DISMÓRFICA CON COMPROMISO RENAL"
  },
  {
    "codigo":276669000,
    "descripcion":"SEPSIS BACTERIANA NEONATAL"
  },
  {
    "codigo":278504009,
    "descripcion":"AFIBRINOGENEMIA"
  },
  {
    "codigo":1359848007,
    "descripcion":"CARCINOMA DE BERMELLÓN DE LABIO SUPERIOR"
  },
  {
    "codigo":16360009,
    "descripcion":"TALASEMIA BETA DELTA"
  },
  {
    "codigo":735421004,
    "descripcion":"SÍNDROME DE LEUCOENCEFALOPATÍA CON COMPROMISO DE TRONCO ENCEFÁLICO Y MÉDULA ESPINAL Y LACTATO ELEVADO"
  },
  {
    "codigo":1259709004,
    "descripcion":"CARCINOMA PRIMARIO MICROPAPILAR DE UROTELIO"
  },
  {
    "codigo":274834001,
    "descripcion":"HALLAZGOS HISTOLÓGICOS ANORMALES EN EL LÍQUIDO CEFALORRAQUÍDEO"
  },
  {
    "codigo":331691000119109,
    "descripcion":"QUISTE DE LA GLÁNDULA DE MEIBOMIO DEL PÁRPADO SUPERIOR DERECHO"
  },
  {
    "codigo":209298004,
    "descripcion":"FRACTURA-SUBLUXACIÓN EXPUESTA PERISEMILUNAR (DORSAL)"
  },
  {
    "codigo":373138006,
    "descripcion":"LESIÓN ULCEROSA DE ARTERIA CORONARIA"
  },
  {
    "codigo":110994007,
    "descripcion":"GRANULOMA DEL COLON POR INGESTIÓN DE BARIO"
  },
  {
    "codigo":405906008,
    "descripcion":"TUMOR QUE INVADE ESTRUCTURA RETROPERITONEAL"
  },
  {
    "codigo":240231001,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE MUÑECA Y\/O MANO"
  },
  {
    "codigo":12265541000119104,
    "descripcion":"INVERSIÓN BILATERAL DE PEZÓN"
  },
  {
    "codigo":404071006,
    "descripcion":"LIPOSARCOMA PLEOMÓRFICO"
  },
  {
    "codigo":764519007,
    "descripcion":"TRISOMÍA DISTAL 3P"
  },
  {
    "codigo":830055006,
    "descripcion":"CÁNCER DE PULMÓN NO MICROCÍTICO NEGATIVO PARA ONCOGÉN DE FUSIÓN CINASA DEL LINFOMA ANAPLÁSICO"
  },
  {
    "codigo":305767007,
    "descripcion":"VISTO POR MUSICOTERAPEUTA"
  },
  {
    "codigo":402236002,
    "descripcion":"ECCEMA VULVAR"
  },
  {
    "codigo":238396007,
    "descripcion":"CELULITIS DEL DORSO DE LA MANO"
  },
  {
    "codigo":41788008,
    "descripcion":"ENFERMEDAD POR DEFICIENCIA HEREDITARIA DE FACTOR IX"
  },
  {
    "codigo":236561002,
    "descripcion":"TRASTORNO CON EL CATÉTER DE DIÁLISIS PERITONEAL"
  },
  {
    "codigo":1095421000000107,
    "descripcion":"VIVE CON AMIGOS TEMPORARIAMENTE"
  },
  {
    "codigo":1186833005,
    "descripcion":"INSUFICIENCIA HIPOFISARIA CAUSADA POR TRASTORNO VASCULAR"
  },
  {
    "codigo":10954821000119108,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO AXILAR DERECHO"
  },
  {
    "codigo":105489007,
    "descripcion":"DIFICULTAD CON FAMILIARES POLÍTICOS"
  },
  {
    "codigo":890086003,
    "descripcion":"TRASTORNO DEL DESARROLLO SEXUAL 46,XX CAUSADO POR PROGESTÁGENO SINTÉTICO ADMINISTRADO POR VÍA ORAL"
  },
  {
    "codigo":365798004,
    "descripcion":"NIVELES DE LÍPIDO SÉRICO - HALLAZGO"
  },
  {
    "codigo":16007391000119103,
    "descripcion":"FUSIÓN ANORMAL CONGÉNITA DE HUESOS DE AMBOS CARPOS"
  },
  {
    "codigo":300262004,
    "descripcion":"TEXTURA ARENOSA DE CONDUCTO SALIVAL"
  },
  {
    "codigo":201958009,
    "descripcion":"ARTROPATÍA TRAUMÁTICA DE PRIMERA ARTICULACIÓN METATARSOFALÁNGICA"
  },
  {
    "codigo":198288003,
    "descripcion":"ESTADO DE ANSIEDAD"
  },
  {
    "codigo":394896005,
    "descripcion":"CAMBIO EN LESIÓN CUTÁNEA"
  },
  {
    "codigo":722576009,
    "descripcion":"LESIÓN TRAUMÁTICA DE TRONCO ENCEFÁLICO DEBIDA A TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":294757005,
    "descripcion":"ALERGIA A ESTEROIDE ANABÓLICO"
  },
  {
    "codigo":10682591000119108,
    "descripcion":"TUMORACIÓN DE LA PIEL DE DEDO DE LA MANO DERECHA"
  },
  {
    "codigo":292922001,
    "descripcion":"REACCIÓN ADVERSA A LA AMIKACINA"
  },
  {
    "codigo":334201000119103,
    "descripcion":"ENTROPIÓN DEL PÁRPADO INFERIOR DERECHO"
  },
  {
    "codigo":11311481000119104,
    "descripcion":"FRACTURA PATOLÓGICA DE VÉRTEBRA LUMBAR EN SITIO DE NEOPLASIA"
  },
  {
    "codigo":782607004,
    "descripcion":"ALERGIA A DERIVADO DE FENOTIAZINA"
  },
  {
    "codigo":225551005,
    "descripcion":"HALLAZGO RELACIONADO CON SECRECIÓN DE HERIDA"
  },
  {
    "codigo":61711004,
    "descripcion":"ABSCESO AGUDO DE SENO ETMOIDAL"
  },
  {
    "codigo":127247006,
    "descripcion":"NEOPLASIA DE LOS GANGLIOS LINFÁTICOS TRAQUEOBRONQUIALES"
  },
  {
    "codigo":94479003,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL PERITONEO PÉLVICO"
  },
  {
    "codigo":190948002,
    "descripcion":"DEFECTO DE ENZIMAS LISOSÓMICAS POSTERIOR A LA TRADUCCIÓN"
  },
  {
    "codigo":289252003,
    "descripcion":"PÉRDIDA ESTIMADA DE SANGRE MATERNA"
  },
  {
    "codigo":15735161000119106,
    "descripcion":"TRASTORNO DE RETINA DE OJO DERECHO"
  },
  {
    "codigo":92644006,
    "descripcion":"CARCINOMA IN SITU DE HÍGADO"
  },
  {
    "codigo":25273001,
    "descripcion":"AGRANDAMIENTO DE LA LENGUA"
  },
  {
    "codigo":307731000119101,
    "descripcion":"DISPLASIA FIBROSA MONOSTÓTICA DE HUESO DE ANTEBRAZO DERECHO"
  },
  {
    "codigo":713401006,
    "descripcion":"ACIDURIA D-2-HIDROXIGLUTÁRICA Y L-2-HIDROXIGLUTÁRICA COMBINADA"
  },
  {
    "codigo":254649008,
    "descripcion":"NEOPLASIA EPITELIAL DE PIEL"
  },
  {
    "codigo":16636281000119109,
    "descripcion":"LESIÓN BILATERAL DE NERVIOS CIÁTICOS"
  },
  {
    "codigo":283747000,
    "descripcion":"MORDEDURA DE PERRO EN EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":711566009,
    "descripcion":"CONCRECIÓN EN CONJUNTIVA DE PÁRPADO SUPERIOR"
  },
  {
    "codigo":1137550008,
    "descripcion":"CALCIFICACIÓN PUNTEADA DE EPÍFISIS DE FALANGE DE DEDO ANULAR"
  },
  {
    "codigo":250979006,
    "descripcion":"FIBROSIS DE VÁLVULA AÓRTICA"
  },
  {
    "codigo":414819007,
    "descripcion":"SÍNDROME DE ABSTINENCIA NEONATAL"
  },
  {
    "codigo":314680003,
    "descripcion":"PESO DEL NIÑO: PERCENTILO 75"
  },
  {
    "codigo":249144005,
    "descripcion":"PRIMERA FASE DEL TRABAJO DE PARTO RÁPIDA"
  },
  {
    "codigo":281912006,
    "descripcion":"FRACTURA EN CUÑA DE VÉRTEBRA CERVICAL"
  },
  {
    "codigo":609592007,
    "descripcion":"MONONEUROPATÍA DE MIEMBRO INFERIOR"
  },
  {
    "codigo":50701000,
    "descripcion":"HEPATOPTOSIS"
  },
  {
    "codigo":6131000124104,
    "descripcion":"MEDICAMENTO TOMADO A UNA DOSIS SUPERIOR A LA RECOMENDADA"
  },
  {
    "codigo":15927981000119100,
    "descripcion":"DISTORSIÓN VISUAL DEL OJO IZQUIERDO"
  },
  {
    "codigo":247309008,
    "descripcion":"SIN DIFERENCIAS EN LA CONDUCCIÓN AÉREA U ÓSEA"
  },
  {
    "codigo":83469008,
    "descripcion":"HIPERINSULINISMO"
  },
  {
    "codigo":442082004,
    "descripcion":"HALLAZGO RELACIONADO CON MEDICIÓN DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":212706004,
    "descripcion":"INTOXICACIÓN CAUSADA POR INHIBIDORES DE LA ENZIMA CONVERTIDORA DE ANGIOTENSINA"
  },
  {
    "codigo":81634008,
    "descripcion":"QUISTE PERINEURAL"
  },
  {
    "codigo":702391001,
    "descripcion":"CARCINOMA DE CÉLULAS RENALES"
  },
  {
    "codigo":1259447005,
    "descripcion":"ADENOCARCINOMA PRIMARIO EN PÓLIPO ADENOMATOSO"
  },
  {
    "codigo":210871006,
    "descripcion":"LESIÓN TRAUMÁTICA DE VENA SAFENA INTERNA"
  },
  {
    "codigo":276407007,
    "descripcion":"ARENILLA URINARIA"
  },
  {
    "codigo":12428000,
    "descripcion":"ASMA INTRÍNSECA SIN MAL ASMÁTICO"
  },
  {
    "codigo":274572000,
    "descripcion":"OJO DERECHO CIEGO"
  },
  {
    "codigo":307340003,
    "descripcion":"SÍNDROME DE MONOSOMÍA 7"
  },
  {
    "codigo":241804003,
    "descripcion":"ENVENENAMIENTO CAUSADO POR VENENO DE VÍBORA VERDADERA"
  },
  {
    "codigo":76129002,
    "descripcion":"SÍNDROME DE GANSER"
  },
  {
    "codigo":895329002,
    "descripcion":"CURVATURA ANORMAL DE FALANGE MEDIA DE DEDO ÍNDICE"
  },
  {
    "codigo":305505004,
    "descripcion":"BAJO ATENCIÓN DE PATÓLOGO"
  },
  {
    "codigo":10593005,
    "descripcion":"ESTADO POSTRANSFUSIÓN"
  },
  {
    "codigo":403809003,
    "descripcion":"EPIDERMÓLISIS BULLOSA DISTRÓFICA TIPO INVERSA"
  },
  {
    "codigo":239969008,
    "descripcion":"LESIÓN DE LIGAMENTOS DE REGIÓN DE CODO"
  },
  {
    "codigo":371041009,
    "descripcion":"ACCIDENTE CEREBROVASCULAR POR EMBOLIA"
  },
  {
    "codigo":205366002,
    "descripcion":"FALTA DE DIFERENCIACIÓN DE HUESOS DE LA EXTREMIDAD INFERIOR"
  },
  {
    "codigo":8758001,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE VÉRTEBRA DORSAL"
  },
  {
    "codigo":238134004,
    "descripcion":"OBESIDAD GENERALIZADA"
  },
  {
    "codigo":762422006,
    "descripcion":"MIDRIASIS EPISÓDICA DE PUPILA DERECHA"
  },
  {
    "codigo":41526007,
    "descripcion":"TRASTORNO REACTIVO DE LA VINCULACIÓN"
  },
  {
    "codigo":203531001,
    "descripcion":"PIE PLANO HIPERMÓVIL"
  },
  {
    "codigo":6923002,
    "descripcion":"LESIÓN TRAUMÁTICA DEL PERINEO"
  },
  {
    "codigo":170763003,
    "descripcion":"DIABETES - BUEN CONTROL"
  },
  {
    "codigo":1073991000119104,
    "descripcion":"BURSITIS GOTOSA DE RODILLA IZQUIERDA"
  },
  {
    "codigo":269067002,
    "descripcion":"FRACTURA NO EXPUESTA DE LA QUINTA VÉRTEBRA CERVICAL"
  },
  {
    "codigo":301835006,
    "descripcion":"MUESTRA DE ORINA OBTENIDA DE CATÉTER: SIN CRECIMIENTO DE MICROORGANISMOS"
  },
  {
    "codigo":74294009,
    "descripcion":"INFERTILIDAD FEMENINA SECUNDARIA A ANOMALÍA ESTRUCTURAL CONGÉNITA DEL CUELLO UTERINO"
  },
  {
    "codigo":168928000,
    "descripcion":"ANGIOGRAFÍA CAROTÍDEA A NORMAL"
  },
  {
    "codigo":365536001,
    "descripcion":"DISPONIBILIDAD DE AGUA POTABLE EN EL ÁMBITO LABORAL - HALLAZGO"
  },
  {
    "codigo":398304003,
    "descripcion":"MIEDO DE VIAJAR EN VEHÍCULOS"
  },
  {
    "codigo":5088004,
    "descripcion":"PROGRESIÓN FETAL ESPONTÁNEA, MÉTODO DE DOUGLAS"
  },
  {
    "codigo":15983431000119106,
    "descripcion":"PABELLÓN AURICULAR SUPERNUMERARIO DERECHO"
  },
  {
    "codigo":234464006,
    "descripcion":"SÍNDROME DE SANGRADO FIBRINOLÍTICO"
  },
  {
    "codigo":310241000119101,
    "descripcion":"ARTRITIS GOTOSA DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":298165005,
    "descripcion":"INFLAMACIÓN DE ARTICULACIÓN DE MANO"
  },
  {
    "codigo":789685005,
    "descripcion":"INFECCIÓN RECURRENTE CAUSADA POR CLOSTRIDIUM DIFFICILE"
  },
  {
    "codigo":3253007,
    "descripcion":"ALTERACIÓN DE LA COLORACIÓN CUTÁNEA"
  },
  {
    "codigo":1418007,
    "descripcion":"CONDRODISTROFIA HIPOPLÁSICA"
  },
  {
    "codigo":230794008,
    "descripcion":"CORISTOMA NEURONAL"
  },
  {
    "codigo":296330007,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE CAFEÍNA"
  },
  {
    "codigo":196191002,
    "descripcion":"ESTENOSIS SUBGLÓTICA LUEGO DE PROCEDIMIENTO"
  },
  {
    "codigo":11779041000119105,
    "descripcion":"LESIÓN TRAUMÁTICA DE TENDÓN DE CABEZA LARGA DE BÍCEPS BRAQUIAL IZQUIERDO"
  },
  {
    "codigo":11860961000119105,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXTERNA NO EXPUESTA DE RODILLA IZQUIERDA"
  },
  {
    "codigo":28681006,
    "descripcion":"CONDRODISPLASIA METAFISARIA"
  },
  {
    "codigo":59614000,
    "descripcion":"SANGRE OCULTA DETECTADA EN MATERIA FECAL"
  },
  {
    "codigo":714974000,
    "descripcion":"LESIÓN DE PIEL Y\/O MEMBRANA MUCOSA CUTÁNEA"
  },
  {
    "codigo":94217008,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE MÉDULA ÓSEA"
  },
  {
    "codigo":288990008,
    "descripcion":"SE PRENDE AL PECHO PARA MAMAR"
  },
  {
    "codigo":92382008,
    "descripcion":"NEOPLASIA BENIGNA DE PIEL DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":1237427001,
    "descripcion":"METÁSTASIS DE CARCINOMA DE CIEGO"
  },
  {
    "codigo":332341000119100,
    "descripcion":"RETINOSQUISIS DEL OJO DERECHO"
  },
  {
    "codigo":368181000119101,
    "descripcion":"ÚLCERA DE PIE DEBIDA A DIABETES MELLITUS MEDICAMENTOSA"
  },
  {
    "codigo":314421000119102,
    "descripcion":"SÍNDROME COMPARTIMENTAL NO TRAUMÁTICO DE EXTREMIDAD SUPERIOR DERECHA"
  },
  {
    "codigo":16206901000119103,
    "descripcion":"SÍNDROME DEL TÚNEL TARSIANO DE AMBOS NERVIOS TIBIALES"
  },
  {
    "codigo":11816501000119104,
    "descripcion":"LESIÓN TRAUMÁTICA DE VENA AXILAR IZQUIERDA"
  },
  {
    "codigo":15935541000119105,
    "descripcion":"DEFORMIDAD EN FLEXIÓN DE ARTICULACIÓN DE AMBOS TOBILLOS"
  },
  {
    "codigo":11857461000119105,
    "descripcion":"DISTENSIÓN DE MÚSCULO PERONEO IZQUIERDO"
  },
  {
    "codigo":293941000119105,
    "descripcion":"SÍNDROME DE DOLOR REGIONAL COMPLEJO TIPO I DE MIEMBRO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":337461000119108,
    "descripcion":"OFTALMOPLEJÍA TOTAL DE OJO IZQUIERDO"
  },
  {
    "codigo":11793461000119109,
    "descripcion":"AMPOLLA DE PIE IZQUIERDO, CON INFECCIÓN"
  },
  {
    "codigo":16754741000119109,
    "descripcion":"SANGRADO UTERINO ANORMAL POR LEIOMIOMA SUBSEROSO"
  },
  {
    "codigo":1090101000119109,
    "descripcion":"EDENTULISMO PARCIAL DEBIDO A ENFERMEDAD PERIODONTAL"
  },
  {
    "codigo":16291381000119103,
    "descripcion":"INFECCIÓN DE LA PIEL SUBUNGUEAL DE DEDOS DE AMBOS PIES DEBIDA A UÑA ENCARNADA"
  },
  {
    "codigo":340021000119108,
    "descripcion":"FRAGMENTOS DE LENTE PARA CATARATAS EN VÍTREO DE OJO IZQUIERDO DEBIDOS A CIRUGÍA DE CATARATAS Y POSTERIOR A ELLA"
  },
  {
    "codigo":299061000119105,
    "descripcion":"HEMARTROSIS DE MANO IZQUIERDA"
  },
  {
    "codigo":16859701000119109,
    "descripcion":"HEPATITIS B CRÓNICA DURANTE EMBARAZO"
  },
  {
    "codigo":63541000119109,
    "descripcion":"DEFECTO DEL EPITELIO CORNEAL POSTERIOR A QUERATOPLASTIA PENETRANTE"
  },
  {
    "codigo":449160007,
    "descripcion":"SÍNDROME DE LA CABEZA QUE ESTALLA"
  },
  {
    "codigo":447325001,
    "descripcion":"FILTRACIÓN DE BILIS POR COLEDOCOTOMÍA"
  },
  {
    "codigo":185181002,
    "descripcion":"ATENDIDO EN EL SERVICIO DE RADIOLOGÍA"
  },
  {
    "codigo":85042000,
    "descripcion":"EPÍFORA POR DRENAJE INSUFICIENTE"
  },
  {
    "codigo":283485001,
    "descripcion":"HERIDA POR ARMA BLANCA EN PIERNA"
  },
  {
    "codigo":52274002,
    "descripcion":"DISTONÍA LENTICULAR"
  },
  {
    "codigo":551906581000119101,
    "descripcion":"MELANOMA MALIGNO DE PIEL DE DEDO DE MANO DERECHA"
  },
  {
    "codigo":314418005,
    "descripcion":"INFILTRADO LEUCÉMICO DE LA RETINA"
  },
  {
    "codigo":248882006,
    "descripcion":"CICATRIZACIÓN DE PARED VAGINAL"
  },
  {
    "codigo":771335004,
    "descripcion":"SÍNDROME DE DISPLASIA ECTODÉRMICA-SINDACTILIA"
  },
  {
    "codigo":247047007,
    "descripcion":"DESPLAZAMIENTO DEL CUERPO CILIAR"
  },
  {
    "codigo":1162716000,
    "descripcion":"CAMPTODACTILIA DE DEDO DE LA MANO"
  },
  {
    "codigo":1230087008,
    "descripcion":"PATRÓN DE USO EPISÓDICO NOCIVO SIN DEPENDENCIA DE ANFETAMINA Y\/O DERIVADO DE ANFETAMINA"
  },
  {
    "codigo":15836005,
    "descripcion":"DISFUNCIÓN DE LA COLOSTOMÍA"
  },
  {
    "codigo":736732005,
    "descripcion":"USA CHUPETE"
  },
  {
    "codigo":1259185001,
    "descripcion":"HEMATOMA DEBIDO A ARTROPLASTIA DE CADERA Y POSTERIOR A ELLA"
  },
  {
    "codigo":472753002,
    "descripcion":"ESTENOSIS DE VENA CAVA INFERIOR COMO COMPLICACIÓN DE PROCEDIMIENTO"
  },
  {
    "codigo":1193649002,
    "descripcion":"ENTERITIS POR ASPERGILLUS"
  },
  {
    "codigo":733062000,
    "descripcion":"SÍNDROME DE HÁBITO MARFANOIDE CON DISCAPACIDAD INTELECTUAL AUTOSÓMICA RECESIVA"
  },
  {
    "codigo":767665008,
    "descripcion":"QUISTE DE INCLUSIÓN EPITELIAL DE PÁRPADO"
  },
  {
    "codigo":700294000,
    "descripcion":"ARTROSIS SECUNDARIA DE TOBILLO"
  },
  {
    "codigo":208774004,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN DE HOMBRO"
  },
  {
    "codigo":1290118005,
    "descripcion":"DIABETES MELLITUS TIPO 1 PRESINTOMÁTICA"
  },
  {
    "codigo":16041391000119103,
    "descripcion":"ARTRITIS IDIOPÁTICA JUVENIL DE INICIO SISTÉMICO DE AMBOS PIES"
  },
  {
    "codigo":1076501000119109,
    "descripcion":"BURSITIS SUBACROMIAL DE HOMBRO DERECHO"
  },
  {
    "codigo":44934008,
    "descripcion":"DIURESIS OSMÓTICA"
  },
  {
    "codigo":12166008,
    "descripcion":"MENINGITIS ESTAFILOCÓCICA"
  },
  {
    "codigo":403547002,
    "descripcion":"LINFANGIOMATOSIS SEGMENTARIA"
  },
  {
    "codigo":307078008,
    "descripcion":"COMENTARIO DEL PENSAMIENTO"
  },
  {
    "codigo":77702009,
    "descripcion":"DESNUTRICIÓN LEVE (SEGÚN LA CLASIFICACIÓN DE GÓMEZ: PESO ENTRE 75% Y MENOS DEL 90% DEL PESO ESTÁNDAR)"
  },
  {
    "codigo":75867005,
    "descripcion":"ROSÁCEA, TIPO PAPULOSA"
  },
  {
    "codigo":237872005,
    "descripcion":"AMILOIDE CUTÁNEO POIQUILODÉRMICO"
  },
  {
    "codigo":40521000119100,
    "descripcion":"HIPERTENSIÓN INDUCIDA POR EL EMBARAZO DESPUÉS DEL NACIMIENTO"
  },
  {
    "codigo":368201000119100,
    "descripcion":"TRASTORNO RENAL POR DIABETES MELLITUS MEDICAMENTOSA"
  },
  {
    "codigo":236037000,
    "descripcion":"EVENTRACIÓN"
  },
  {
    "codigo":301573001,
    "descripcion":"NO SE MOVILIZA CON DISPOSITIVO ORTOPÉDICO"
  },
  {
    "codigo":39429002,
    "descripcion":"CONJUNTIVITIS FOLICULAR CRÓNICA"
  },
  {
    "codigo":12246601000119101,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE AMBOS PULMONES"
  },
  {
    "codigo":1055237004,
    "descripcion":"REFLEJO DE TENDÓN DE AQUILES DISMINUIDO"
  },
  {
    "codigo":203269005,
    "descripcion":"TUBERCULOSIS DE HUESO DEL BRAZO"
  },
  {
    "codigo":1153541000,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR FLUOROQUINOLONA"
  },
  {
    "codigo":10634671000119108,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN EN TALÓN DERECHO NO ESTADIFICABLE"
  },
  {
    "codigo":11837001000119102,
    "descripcion":"HERIDA INFECTADA DE PIERNA DERECHA DEBIDA A PICADURA DE INSECTO NO VENENOSO"
  },
  {
    "codigo":399877009,
    "descripcion":"RETINOPATÍA NO PROLIFERATIVA MUY SEVERA CON EDEMA DE MÁCULA CLÍNICAMENTE SIGNIFICATIVO DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":299738004,
    "descripcion":"LESIÓN DE LA NEURONA MOTORA SUPERIOR"
  },
  {
    "codigo":234202005,
    "descripcion":"OCLUSIÓN DE FÍSTULA ARTERIOVENOSA"
  },
  {
    "codigo":365274005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA USAR EL SECARROPAS"
  },
  {
    "codigo":35759001,
    "descripcion":"SOBREACTIVIDAD DE LA RIBOSA FOSFATO PIROFOSFOQUINASA"
  },
  {
    "codigo":723887001,
    "descripcion":"SARCOMA DE EWING PRIMARIO DE COSTILLA"
  },
  {
    "codigo":232367004,
    "descripcion":"SÍFILIS NASAL"
  },
  {
    "codigo":363439008,
    "descripcion":"NEOPLASIA MALIGNA DE PARTES BLANDAS DE CABEZA"
  },
  {
    "codigo":197764002,
    "descripcion":"PIELONEFRITIS CRÓNICA NO OBSTRUCTIVA ASOCIADA A REFLUJO"
  },
  {
    "codigo":296068003,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE LORMETAZEPAM"
  },
  {
    "codigo":33924006,
    "descripcion":"ABSCESO DE LARINGE"
  },
  {
    "codigo":195929004,
    "descripcion":"GRIPE CON COMPROMISO DEL TRACTO GASTROINTESTINAL"
  },
  {
    "codigo":425305006,
    "descripcion":"DIFICULTAD PARA RECONOCER LAS CONSECUENCIAS DE LA CONDUCTA SEXUAL"
  },
  {
    "codigo":95790001,
    "descripcion":"NISTAGMO DE FIJACIÓN"
  },
  {
    "codigo":294233009,
    "descripcion":"ALERGIA A ROCURONIO"
  },
  {
    "codigo":292398004,
    "descripcion":"REACCIÓN ADVERSA A PROCLORPERAZINA"
  },
  {
    "codigo":128558004,
    "descripcion":"FÍSTULA CONGÉNITA DE ARTERIA CORONARIA A VENTRÍCULO DERECHO"
  },
  {
    "codigo":15687241000119109,
    "descripcion":"ARTRITIS INFECCIOSA DE AMBAS MANOS"
  },
  {
    "codigo":93955002,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL TEJIDO PERISUPRARRENAL"
  },
  {
    "codigo":1306371006,
    "descripcion":"SARCOMA DE CUADRANTE SUPERIOR EXTERNO DE MAMA"
  },
  {
    "codigo":225027006,
    "descripcion":"ETAPA DE REFLEXIÓN EN EL PROCESO DE DUELO"
  },
  {
    "codigo":288728001,
    "descripcion":"UTILIZA DISTINTAS FORMAS DE CONVERSACIÓN"
  },
  {
    "codigo":131165000,
    "descripcion":"GRUPO SANGUÍNEO B>M<^H^"
  },
  {
    "codigo":92120005,
    "descripcion":"NEOPLASIA BENIGNA DEL GLANDE DEL PENE"
  },
  {
    "codigo":59352006,
    "descripcion":"DEFICIENCIA LONGITUDINAL DE RADIO Y CÚBITO"
  },
  {
    "codigo":286893002,
    "descripcion":"CARCINOMA DE MAMA - CUADRANTE SUPEROINTERNO"
  },
  {
    "codigo":57517007,
    "descripcion":"DESDOBLAMIENTO INVERTIDO DEL SEGUNDO RUIDO CARDÍACO, R>2<"
  },
  {
    "codigo":285058000,
    "descripcion":"HALLAZGO RELACIONADO CON LA ACTIVIDAD SEXUAL"
  },
  {
    "codigo":254125009,
    "descripcion":"OSTEOMESOPICNOSIS"
  },
  {
    "codigo":448898002,
    "descripcion":"ANOMALÍA DEL TRACTO DE SALIDA EN VENTRÍCULO SOLITARIO INDETERMINADO"
  },
  {
    "codigo":1079011000119109,
    "descripcion":"ANGIOSARCOMA PRIMARIO DE EXTREMIDAD SUPERIOR IZQUIERDA"
  },
  {
    "codigo":283223008,
    "descripcion":"ANZUELO EN EL PIE"
  },
  {
    "codigo":52012001,
    "descripcion":"RODILLA VALGA ADQUIRIDA"
  },
  {
    "codigo":86615009,
    "descripcion":"DIARREA EPIDÉMICA"
  },
  {
    "codigo":315261000119105,
    "descripcion":"OSTEOCONDRITIS DISECANTE DE REGIÓN DE MUÑECA DERECHA"
  },
  {
    "codigo":1231660002,
    "descripcion":"DISCORDANCIA PULSO-RAMPA DEL MOVIMIENTO SACÁDICO"
  },
  {
    "codigo":707372009,
    "descripcion":"ESTENOSIS CONGÉNITA DE ARTERIA PULMONAR DERECHA"
  },
  {
    "codigo":1197057002,
    "descripcion":"SÍNDROME TIPO HALLERMAMM-STREIFF"
  },
  {
    "codigo":17409003,
    "descripcion":"HEMIPARESIA FACIAL"
  },
  {
    "codigo":281388009,
    "descripcion":"COLANGITIS ESCLEROSANTE RELACIONADA CON EL VIH"
  },
  {
    "codigo":771073006,
    "descripcion":"TRASTORNO LINFOPROLIFERATIVO CAUSADO POR METOTREXATO"
  },
  {
    "codigo":50177009,
    "descripcion":"TEMPERATURA CORPORAL POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":441558003,
    "descripcion":"FRACTURA POR SOBRECARGA DE HUESO DEL METATARSO"
  },
  {
    "codigo":15574005,
    "descripcion":"FRACTURA DE PIE"
  },
  {
    "codigo":1258923000,
    "descripcion":"INFECCIÓN CAUSADA POR NEISSERIA GONORRHOEAE DURANTE EL PUERPERIO"
  },
  {
    "codigo":268040001,
    "descripcion":"CIFOSIS POSTURAL"
  },
  {
    "codigo":210347009,
    "descripcion":"HERIDAS ABIERTAS MÚLTIPLES EN LA CARA"
  },
  {
    "codigo":16017431000119105,
    "descripcion":"ALTERACIÓN DE LA ALINEACIÓN DEL ASTA POSTERIOR DEL MENISCO EXTERNO DE LA RODILLA IZQUIERDA"
  },
  {
    "codigo":110208005,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO DE LA ENCÍA UNIDA AL MAXILAR SUPERIOR"
  },
  {
    "codigo":344241000119100,
    "descripcion":"CONJUNTIVITIS PSEUDOMEMBRANOSA DE AMBOS OJOS"
  },
  {
    "codigo":763733001,
    "descripcion":"FISURA DE LABIO COMPLETA DEL LADO IZQUIERDO"
  },
  {
    "codigo":75605002,
    "descripcion":"SANGUE DORMIDO"
  },
  {
    "codigo":1255253003,
    "descripcion":"HERIDA DE TEJIDO PERIODONTAL EN CICATRIZACIÓN POSTERIOR A TRAUMATISMO DENTAL"
  },
  {
    "codigo":403285003,
    "descripcion":"HEMORRAGIA TRAUMÁTICA EN ASTILLA"
  },
  {
    "codigo":8234004,
    "descripcion":"MUJERES XY"
  },
  {
    "codigo":1081521000119103,
    "descripcion":"NEVO EPIDÉRMICO PILOSO PIGMENTADO DE OREJA DERECHA"
  },
  {
    "codigo":1220650006,
    "descripcion":"DELIRIO DE EMISIÓN DE OLOR CORPORAL DESAGRADABLE"
  },
  {
    "codigo":237610008,
    "descripcion":"DEFECTO DEL CAMPO ACRORRENAL, DISPLASIA ECTODÉRMICA Y DIABETES LIPOATRÓFICA"
  },
  {
    "codigo":301311009,
    "descripcion":"HALLAZGO RELACIONADO CON LAS PROPORCIONES FACIALES"
  },
  {
    "codigo":102868004,
    "descripcion":"SANGRADO INTERMENSTRUAL EN GOTAS CAUSADO POR DISPOSITIVO INTRAUTERINO"
  },
  {
    "codigo":299476006,
    "descripcion":"HALLAZGO RELACIONADO CON LAS MEDIDAS DEL PIE"
  },
  {
    "codigo":233940007,
    "descripcion":"EMBOLIA PULMONAR TUMORAL"
  },
  {
    "codigo":365012006,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD DE USAR COMBINACIÓN DE CONSONANTE, VOCAL, CONSONANTE"
  },
  {
    "codigo":789161001,
    "descripcion":"DISPLASIA DÉRMICA FACIAL FOCAL TIPO IV"
  },
  {
    "codigo":232105000,
    "descripcion":"EXOTROPÍA CONSECUTIVA"
  },
  {
    "codigo":15636811000119101,
    "descripcion":"RIGIDEZ DE ARTICULACIÓN DEL HOMBRO BILATERAL"
  },
  {
    "codigo":363177008,
    "descripcion":"TRASTORNO INFLAMATORIO DEL SISTEMA INMUNITARIO"
  },
  {
    "codigo":295806005,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE AZATIOPRINA"
  },
  {
    "codigo":721790006,
    "descripcion":"ENCEFALITIS CAUSADA POR VIRUS HENDRA"
  },
  {
    "codigo":164734008,
    "descripcion":"FUNDOSCOPIA NORMAL"
  },
  {
    "codigo":230270009,
    "descripcion":"DEMENCIA FRONTOTEMPORAL"
  },
  {
    "codigo":263038009,
    "descripcion":"SUBLUXACIÓN DE LA SÍNFISIS PÚBICA"
  },
  {
    "codigo":195667003,
    "descripcion":"AMIGDALITIS FOLICULAR AGUDA"
  },
  {
    "codigo":228435004,
    "descripcion":"TOLERANCIA PSICOLÓGICA A LA DROGA"
  },
  {
    "codigo":64595005,
    "descripcion":"ÚLCERA DE ESÓFAGO DEBIDA A INGESTIÓN DE MEDICAMENTOS"
  },
  {
    "codigo":719955006,
    "descripcion":"ATRESIA DE VÁLVULA PULMONAR"
  },
  {
    "codigo":95528002,
    "descripcion":"ENTUMECIMIENTO DE LA LENGUA"
  },
  {
    "codigo":128296004,
    "descripcion":"ENFERMEDAD CRÓNICA DE LOS ANEXOS OCULARES"
  },
  {
    "codigo":292136005,
    "descripcion":"REACCIÓN ADVERSA AL BISACODILO"
  },
  {
    "codigo":16675301000119100,
    "descripcion":"DOLOR DE TESTÍCULO IZQUIERDO"
  },
  {
    "codigo":161064007,
    "descripcion":"VIOLENCIA ENTRE PADRE E HIJO"
  },
  {
    "codigo":28157000,
    "descripcion":"QUISTE RETINIANO PRIMARIO"
  },
  {
    "codigo":880125002,
    "descripcion":"TRASTORNO DEL DESARROLLO SEXUAL 46,XX INDUCIDO POR ANDRÓGENOS DEBIDO A HIPERPLASIA SUPRARRENAL MATERNA"
  },
  {
    "codigo":191997003,
    "descripcion":"INSOMNIO PERSISTENTE"
  },
  {
    "codigo":290301008,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR SULINDACO"
  },
  {
    "codigo":26322001,
    "descripcion":"OTORRAGIA"
  },
  {
    "codigo":93693009,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE VASO SANGUÍNEO DE GLÚTEO"
  },
  {
    "codigo":1304274003,
    "descripcion":"SÍNDROME COMPARTIMENTAL NEONATAL"
  },
  {
    "codigo":388605009,
    "descripcion":"TRASTORNO DE CORION"
  },
  {
    "codigo":91858008,
    "descripcion":"LEUCEMIA MONOCÍTICA AGUDA EN REMISIÓN"
  },
  {
    "codigo":124626009,
    "descripcion":"DEFICIENCIA DE HEPARINA LIASA"
  },
  {
    "codigo":1204135001,
    "descripcion":"DISFUNCIÓN DE GENERADOR DE DESFIBRILADOR CARDIOVERSOR IMPLANTABLE"
  },
  {
    "codigo":188327005,
    "descripcion":"NEOPLASIA MALIGNA DE NERVIO PERIFÉRICO DE LA PELVIS"
  },
  {
    "codigo":284796001,
    "descripcion":"DIFICULTAD PARA DUCHARSE"
  },
  {
    "codigo":448636004,
    "descripcion":"CIEGO EN EL LADO DERECHO"
  },
  {
    "codigo":710780005,
    "descripcion":"ALTURA FACIAL POSTERIOR AUMENTADA"
  },
  {
    "codigo":219260009,
    "descripcion":"LESIÓN POR INTERVENCIÓN LEGAL CON BALA DE RIFLE"
  },
  {
    "codigo":16265701000119107,
    "descripcion":"TRASTORNO DE ANSIEDAD POR ENFERMEDADES"
  },
  {
    "codigo":252028009,
    "descripcion":"OBSTRUCCIÓN DEL FLUJO URINARIO"
  },
  {
    "codigo":414033006,
    "descripcion":"TRASTORNO DEL MANGUITO ROTADOR"
  },
  {
    "codigo":282961006,
    "descripcion":"SE PONE EN CUCLILLAS"
  },
  {
    "codigo":86353007,
    "descripcion":"HIPOCALCIURIA"
  },
  {
    "codigo":491375231000119103,
    "descripcion":"ENDOMETRIOSIS PROFUNDA DE RECTO"
  },
  {
    "codigo":49915006,
    "descripcion":"ESTENOSIS DE VÁLVULA TRICÚSPIDE"
  },
  {
    "codigo":1084031000119105,
    "descripcion":"ENFERMEDAD DE MÉNIÈRE DE AMBOS OÍDOS INTERNOS EN REMISIÓN"
  },
  {
    "codigo":277456001,
    "descripcion":"TUMOR SUPRASELAR DE CÉLULAS GERMINALES"
  },
  {
    "codigo":15993471000119105,
    "descripcion":"IRITIS BILATERAL DEBIDA A SÍFILIS SECUNDARIA"
  },
  {
    "codigo":408528003,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: HOLANDÉS"
  },
  {
    "codigo":242853001,
    "descripcion":"LESIÓN AUTOINFLIGIDA POR QUEMADURA DE CIGARRILLO"
  },
  {
    "codigo":1293264009,
    "descripcion":"SÍNDROME HEMOLÍTICO URÉMICO ATÍPICO CON ANOMALÍA DE GEN DE COMPLEMENTO"
  },
  {
    "codigo":439461004,
    "descripcion":"HEMATOMA DE CUERO CABELLUDO"
  },
  {
    "codigo":373925004,
    "descripcion":"PIGMENTACIÓN DE LOS DEDOS DE LAS MANOS"
  },
  {
    "codigo":898213006,
    "descripcion":"FUSIÓN ANORMAL CONGÉNITA DE HUESO DE CARPO Y METACARPO"
  },
  {
    "codigo":11642001,
    "descripcion":"INTELIGENCIA POR ENCIMA DEL PROMEDIO (C.I.....)"
  },
  {
    "codigo":678011000119106,
    "descripcion":"CUERPO HIALINO DE RETINA DE OJO DERECHO"
  },
  {
    "codigo":208250003,
    "descripcion":"FRACTURA EXPUESTA DE HÚMERO PROXIMAL, CUELLO"
  },
  {
    "codigo":109946007,
    "descripcion":"NEOPLASIA BENIGNA DE LOS NERVIOS PERIFÉRICOS DEL TRONCO"
  },
  {
    "codigo":403023000,
    "descripcion":"TIÑA CORPORAL CAUSADA POR MICROSPORUM AUDOUINII"
  },
  {
    "codigo":1254991002,
    "descripcion":"DEPENDENCIA DE SUSTANCIA EN EMBARAZO"
  },
  {
    "codigo":10806041000119104,
    "descripcion":"INFECCIÓN DE PEZÓN ASOCIADA CON LA LACTANCIA"
  },
  {
    "codigo":271951008,
    "descripcion":"LLANTO ASOCIADO CON EL ESTADO DE ÁNIMO"
  },
  {
    "codigo":239183009,
    "descripcion":"SEROMA DE INJERTO DE PIEL"
  },
  {
    "codigo":401188002,
    "descripcion":"NO UTILIZA DISPOSITIVO ESPACIADOR"
  },
  {
    "codigo":302884001,
    "descripcion":"LESIONES MÚLTIPLES DE NERVIOS CRANEALES Y SÍNDROMES VINCULADOS"
  },
  {
    "codigo":237348005,
    "descripcion":"PIREXIA PUERPERAL"
  },
  {
    "codigo":827172005,
    "descripcion":"ATAXIA CEREBELOSA PROGRESIVA LIGADA AL CROMOSOMA X"
  },
  {
    "codigo":1187620007,
    "descripcion":"ENFERMEDAD DE CHARCOT MARIE TOOTH AUTOSÓMICA DOMINANTE TIPO 2DD"
  },
  {
    "codigo":293811000119100,
    "descripcion":"INFARTO CEREBRAL DEBIDO A ESTENOSIS DE ARTERIA VERTEBRAL"
  },
  {
    "codigo":15639321000119106,
    "descripcion":"PSEUDOEXFOLIACIÓN DE CÁPSULA DE CRISTALINO IZQUIERDO"
  },
  {
    "codigo":366585003,
    "descripcion":"PRUEBA DE BARLOW - HALLAZGO"
  },
  {
    "codigo":202745004,
    "descripcion":"DESGARRO ANULAR DE DISCO CERVICAL"
  },
  {
    "codigo":6137007,
    "descripcion":"HISTIOCITOSIS MUCINOSA DEL COLON"
  },
  {
    "codigo":102606000,
    "descripcion":"SIGNO DE LESER - TRÉLAT"
  },
  {
    "codigo":399353008,
    "descripcion":"FOSAS NASALES GRANDES"
  },
  {
    "codigo":299214002,
    "descripcion":"AMPUTADO A LA ALTURA DE CODO"
  },
  {
    "codigo":364750003,
    "descripcion":"HALLAZGO RELACIONADO CON EL ENCAJE DE LA CABEZA FETAL"
  },
  {
    "codigo":233678006,
    "descripcion":"ASMA INFANTIL"
  },
  {
    "codigo":397518007,
    "descripcion":"QUERATITIS LAMINAR DIFUSA"
  },
  {
    "codigo":231843001,
    "descripcion":"FÍSTULA LAGRIMAL ADQUIRIDA"
  },
  {
    "codigo":788899002,
    "descripcion":"DEMENCIA DEBIDA A PELAGRA"
  },
  {
    "codigo":262776000,
    "descripcion":"HEMATOMA DE GLÁNDULA PARATIROIDES"
  },
  {
    "codigo":723363009,
    "descripcion":"SÍNDROME DE HIPOTRICOSIS, LINFEDEMA, TELANGIECTASIAS Y DEFECTO RENAL"
  },
  {
    "codigo":230008005,
    "descripcion":"HALLAZGO RELACIONADO CON LA POSICIÓN DEL TRONCO"
  },
  {
    "codigo":721528005,
    "descripcion":"SÍNDROME DE BROWN-SEQUARD AL NIVEL DEL QUINTO SEGMENTO LUMBAR"
  },
  {
    "codigo":349261000119100,
    "descripcion":"INFILTRADO DE CÓRNEA BILATERAL POSTERIOR A QUERATOMILEUSIS IN SITU BILATERAL ASISTIDA CON LÁSER"
  },
  {
    "codigo":129869000,
    "descripcion":"ANSIEDAD ANTE LA MUERTE"
  },
  {
    "codigo":985355341000119101,
    "descripcion":"MELANOMA MALIGNO DE PIEL DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":195405004,
    "descripcion":"FLEBITIS DE VENA POPLÍTEA"
  },
  {
    "codigo":293709008,
    "descripcion":"ALERGIA A TIOPENTAL"
  },
  {
    "codigo":816162001,
    "descripcion":"PÉRDIDA DE VOLUMEN DE LÍQUIDO GASTROINTESTINAL"
  },
  {
    "codigo":366515006,
    "descripcion":"HALLAZGO RELACIONADO CON LA AMPLITUD DE SUPINACIÓN PASIVA DE CODO"
  },
  {
    "codigo":95266003,
    "descripcion":"NARINA ÚNICA"
  },
  {
    "codigo":160802003,
    "descripcion":"CÓNYUGE VIOLENTO"
  },
  {
    "codigo":10753101000119102,
    "descripcion":"CARDIOPATÍA EN LA MADRE QUE COMPLICA EL NACIMIENTO"
  },
  {
    "codigo":717858004,
    "descripcion":"FÍSTULA GÁSTRICA ADQUIRIDA"
  },
  {
    "codigo":193570009,
    "descripcion":"CATARATA"
  },
  {
    "codigo":1086541000119104,
    "descripcion":"PERFORACIÓN DE INTESTINO DEBIDA A DIVERTICULITIS DE TRACTO GASTROINTESTINAL"
  },
  {
    "codigo":716023007,
    "descripcion":"SÍNDROME DE GLABELA PROMINENTE CON MICROCEFALIA E HIPOGENITALISMO"
  },
  {
    "codigo":124364002,
    "descripcion":"DEFICIENCIA DE OXALATO COA - TRANSFERASA"
  },
  {
    "codigo":286369003,
    "descripcion":"INCAPAZ DE HABLAR"
  },
  {
    "codigo":24225004,
    "descripcion":"REACCIÓN PUPILAR TÓNICA"
  },
  {
    "codigo":188065005,
    "descripcion":"MELANOMA MALIGNO DE PULGAR"
  },
  {
    "codigo":417441005,
    "descripcion":"MIASIS PROGRESIVA"
  },
  {
    "codigo":384673009,
    "descripcion":"MICROCALCIFICACIONES PRESENTES EN TEJIDO TUMORAL Y NO NEOPLÁSICO"
  },
  {
    "codigo":448374002,
    "descripcion":"PRUEBA DE INHIBICIÓN DE LA AMPLIFICACIÓN DE ÁCIDO NUCLEICO PARA CHLAMYDIA TRACHOMATIS"
  },
  {
    "codigo":251766003,
    "descripcion":"PERCEPCIÓN SIMULTÁNEA"
  },
  {
    "codigo":10835021000119109,
    "descripcion":"FRACTURA ABIERTA DE TRAPECIO DE MUÑECA DERECHA"
  },
  {
    "codigo":1003595000,
    "descripcion":"SINOSTOSIS CONGÉNITA DE SUTURA CORONAL DERECHA DE CRÁNEO"
  },
  {
    "codigo":249931001,
    "descripcion":"DEBILIDAD DEL CUELLO"
  },
  {
    "codigo":282699002,
    "descripcion":"NO EMPUJA NI ARRASTRA HACIA ATRÁS UN JUGUETE GRANDE CON RUEDAS"
  },
  {
    "codigo":20555001,
    "descripcion":"IRITIS POR VIRUS DEL HERPES SIMPLE"
  },
  {
    "codigo":315467000,
    "descripcion":"NACIDO EN LIECHTENSTEIN"
  },
  {
    "codigo":10972391000119105,
    "descripcion":"INTOXICACIÓN POR HUMO"
  },
  {
    "codigo":248096004,
    "descripcion":"FALTA DE LIBIDO"
  },
  {
    "codigo":1296672005,
    "descripcion":"FARINGITIS ESTREPTOCÓCICA AGUDA"
  },
  {
    "codigo":15697281000119100,
    "descripcion":"NEURITIS CUBITAL IZQUIERDA"
  },
  {
    "codigo":279029001,
    "descripcion":"DOLOR EN LA COLUMNA CERVICAL"
  },
  {
    "codigo":705013002,
    "descripcion":"ELEVACIÓN INFERIOR Y LATERAL DEL SEGMENTO ST"
  },
  {
    "codigo":1293002001,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE TENDÓN DE REGIÓN DE HOMBRO"
  },
  {
    "codigo":703178004,
    "descripcion":"ESTENOSIS DE VÁLVULA PULMONAR CON INSUFICIENCIA DE ETIOLOGÍA NO REUMÁTICA"
  },
  {
    "codigo":277194006,
    "descripcion":"HALLAZGO DE CITOPATOLOGÍA"
  },
  {
    "codigo":45983003,
    "descripcion":"QUEMADURA DEL PULMÓN"
  },
  {
    "codigo":373663005,
    "descripcion":"PERÍODO PERINATAL"
  },
  {
    "codigo":766879006,
    "descripcion":"INMUNODEFICIENCIA COMBINADA DEBIDA A DEFICIENCIA DE OX40"
  },
  {
    "codigo":275359008,
    "descripcion":"HEMORRAGIA UMBILICAL"
  },
  {
    "codigo":871603009,
    "descripcion":"TRANSPOSICIÓN DE GRANDES ARTERIAS CON CONEXIONES AURICULOVENTRICULARES DISCORDANTES Y DEFECTO DEL TABIQUE VENTRICULAR"
  },
  {
    "codigo":76916001,
    "descripcion":"ESPINA BÍFIDA OCULTA"
  },
  {
    "codigo":109684004,
    "descripcion":"HIPOPLASIA ALVEOLAR MANDIBULAR"
  },
  {
    "codigo":1089051000119100,
    "descripcion":"COLESTEATOMA DE MASTOIDES IZQUIERDA"
  },
  {
    "codigo":371828006,
    "descripcion":"PACIENTE FALLECIDO DURANTE LA INTERNACIÓN (ESTADO AL ALTA = FALLECIDO)"
  },
  {
    "codigo":402761000,
    "descripcion":"TRASTORNO DE PIEL DEBIDO A RADIOTERAPIA"
  },
  {
    "codigo":11380006,
    "descripcion":"MUCOPOLISACARIDOSIS"
  },
  {
    "codigo":240756006,
    "descripcion":"RINOSPORIDIOSIS CUTÁNEA ULCERADA"
  },
  {
    "codigo":11820571000119100,
    "descripcion":"SUBLUXACIÓN POSTERIOR DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":238921004,
    "descripcion":"VULVITIS DE CÉLULAS PLASMÁTICAS"
  },
  {
    "codigo":271689000,
    "descripcion":"ÚTERO EN RETROVERSIÓN"
  },
  {
    "codigo":40478000,
    "descripcion":"QUISTE DE LA GLÁNDULA TÍMICA"
  },
  {
    "codigo":763209008,
    "descripcion":"DEFECTO COMBINADO DE LA FOSFORILACIÓN OXIDATIVA TIPO 9"
  },
  {
    "codigo":1187358001,
    "descripcion":"LORDOSIS CONGÉNITA DE COLUMNA"
  },
  {
    "codigo":1285662000,
    "descripcion":"ENFERMEDAD POR DEFICIENCIA DE FACTOR IX HEREDITARIA GRAVE CON INHIBIDOR DE BAJA RESPUESTA"
  },
  {
    "codigo":204318003,
    "descripcion":"OSTIUM SECUNDUM PERSISTENTE"
  },
  {
    "codigo":16080411000119103,
    "descripcion":"CALCIFICACIÓN MAMOGRÁFICA DE AMBAS MAMAS"
  },
  {
    "codigo":5875001,
    "descripcion":"BRONQUITIS AGUDA CON OBSTRUCCIÓN"
  },
  {
    "codigo":268019002,
    "descripcion":"OSTEOMIELITIS CRÓNICA DE TOBILLO Y\/O PIE"
  },
  {
    "codigo":202483004,
    "descripcion":"DOLOR EN ARTICULACIÓN METACARPOFALÁNGICA"
  },
  {
    "codigo":399091004,
    "descripcion":"DISTROFIA MUSCULAR FASCIOESCAPULOHUMERAL"
  },
  {
    "codigo":300787005,
    "descripcion":"INCAPAZ DE INICIAR JUEGO ESPONTÁNEO"
  },
  {
    "codigo":298952000,
    "descripcion":"SIN AMPLITUD ACTIVA DE FLEXIÓN DE MUÑECA"
  },
  {
    "codigo":366323009,
    "descripcion":"HALLAZGO RELACIONADO CON LA DURACIÓN DE LA GESTACIÓN"
  },
  {
    "codigo":200648002,
    "descripcion":"CELULITIS Y ABSCESO DE MENTÓN"
  },
  {
    "codigo":11794101000119100,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE SEGUNDO A QUINTO DEDOS DE PIE DERECHO"
  },
  {
    "codigo":724936007,
    "descripcion":"LACERACIÓN DE FASCIA DE TRÍCEPS BRAQUIAL"
  },
  {
    "codigo":723101000,
    "descripcion":"ÚLCERA GÁSTRICA CAUSADA POR HONGO"
  },
  {
    "codigo":4040006,
    "descripcion":"CUERPOS DE HASSALL - HENLE"
  },
  {
    "codigo":460957002,
    "descripcion":"ORIGEN ANÓMALO DE LIGAMENTO ARTERIOSO"
  },
  {
    "codigo":167880007,
    "descripcion":"LÍQUIDO SINOVIAL: LÍMPIDO"
  },
  {
    "codigo":67741005,
    "descripcion":"CONTRACTURA DE LA FASCIA PLANTAR"
  },
  {
    "codigo":1149085006,
    "descripcion":"SATISFECHO CON EL MANEJO DEL DOLOR"
  },
  {
    "codigo":428189005,
    "descripcion":"RUPTURA TRAUMÁTICA DE TENDÓN EXTENSOR DE DEDO DE LA MANO"
  },
  {
    "codigo":16709301000119102,
    "descripcion":"FRACTURA NO EXPUESTA DE PORCIÓN BASILAR IZQUIERDA DE HUESO OCCIPITAL"
  },
  {
    "codigo":229746007,
    "descripcion":"ALTERACIÓN ESPECÍFICA DEL LENGUAJE"
  },
  {
    "codigo":721266009,
    "descripcion":"INFECCIÓN DE PIEL Y MEMBRANA MUCOSA CAUSADA POR VIRUS DEL PAPILOMA HUMANO"
  },
  {
    "codigo":293447002,
    "descripcion":"REACCIÓN ADVERSA A LA TOCAINIDA"
  },
  {
    "codigo":129607003,
    "descripcion":"SÍNDROME DE SIMBIOSIS ENTRE MADRE E HIJA"
  },
  {
    "codigo":719431007,
    "descripcion":"DEGENERACIÓN DE LA RETINA DE COMIENZO TARDÍO AUTOSÓMICA DOMINANTE"
  },
  {
    "codigo":1340188003,
    "descripcion":"CERVICITIS INFECCIOSA"
  },
  {
    "codigo":95004009,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA GLÁNDULA HIPÓFISIS"
  },
  {
    "codigo":1010673002,
    "descripcion":"VÉRTIGO POSICIONAL PAROXÍSTICO BENIGNO DEL CANAL SEMICIRCULAR POSTERIOR"
  },
  {
    "codigo":93169003,
    "descripcion":"LEUCEMIA LINFOIDE EN REMISIÓN"
  },
  {
    "codigo":289777003,
    "descripcion":"CUELLO UTERINO NO ESTRECHO"
  },
  {
    "codigo":224241001,
    "descripcion":"NO SE ENCUENTRA EN LISTA DE ESPERA PARA ALOJAMIENTO"
  },
  {
    "codigo":255174002,
    "descripcion":"PÓLIPO BENIGNO DE VÍA BILIAR"
  },
  {
    "codigo":56731001,
    "descripcion":"HIPERTONO MUSCULAR"
  },
  {
    "codigo":187803004,
    "descripcion":"NEOPLASIA MALIGNA DE TEJIDO PERINÉFRICO"
  },
  {
    "codigo":286107005,
    "descripcion":"LUSTRA"
  },
  {
    "codigo":253339007,
    "descripcion":"ANOMALÍA AURICULAR DERECHA"
  },
  {
    "codigo":89499009,
    "descripcion":"ADHERENCIA DEL ESTÓMAGO"
  },
  {
    "codigo":415344002,
    "descripcion":"UVEÍTIS ANTERIOR PRODUCIDA POR RIFABUTINA"
  },
  {
    "codigo":1201776003,
    "descripcion":"AUSENCIA CONGÉNITA COMPLETA DE EXTREMIDAD INFERIOR DERECHA"
  },
  {
    "codigo":284272005,
    "descripcion":"UTILIZA LA PINZA (MOVIMIENTO DE LA MANO)"
  },
  {
    "codigo":11823081000119100,
    "descripcion":"AMPOLLA DE HOMBRO DERECHO, CON INFECCIÓN"
  },
  {
    "codigo":185968008,
    "descripcion":"PACIENTE QUE ESPERA ATENCIÓN DOMICILIARIA"
  },
  {
    "codigo":184133001,
    "descripcion":"ES CUESTIONABLE SI EL NÚMERO TELEFÓNICO DEL PACIENTE ES CORRECTO"
  },
  {
    "codigo":51226000,
    "descripcion":"AGUJERO RETINIANO REDONDO SIN DESPRENDIMIENTO"
  },
  {
    "codigo":1263642002,
    "descripcion":"METÁSTASIS DE CARCINOMA DE CÉLULAS TRANSICIONALES EN RIÑÓN IZQUIERDO"
  },
  {
    "codigo":247834003,
    "descripcion":"MIEDO A COMER EN PÚBLICO"
  },
  {
    "codigo":346138009,
    "descripcion":"SABOR DESAGRADABLE DE ORIGEN NEUROLÓGICO"
  },
  {
    "codigo":16623004,
    "descripcion":"NEUMOPATÍA DE LOS TRABAJADORES DEL CAFÉ"
  },
  {
    "codigo":311535006,
    "descripcion":"RIGIDEZ DEL PENSAMIENTO"
  },
  {
    "codigo":735684004,
    "descripcion":"TAQUICARDIA AURICULAR INDEPENDIENTE DEL ISTMO CAVOTRICUSPÍDEO"
  },
  {
    "codigo":373401001,
    "descripcion":"AUSENCIA DE INVASIÓN TUMORAL EN VASOS SANGUÍNEOS\/LINFÁTICOS (MAMA)"
  },
  {
    "codigo":209561004,
    "descripcion":"ESGUINCE DE ARTICULACIÓN ATLANTO-OCCIPITAL"
  },
  {
    "codigo":1354606004,
    "descripcion":"FRACTURA DE FALANGE MEDIA DE DEDO MEDIO DE MANO"
  },
  {
    "codigo":240494005,
    "descripcion":"FIEBRE HEMORRÁGICA TRANSMITIDA POR ROEDORES"
  },
  {
    "codigo":109422006,
    "descripcion":"HUESO CUBOIDES ACCESORIO"
  },
  {
    "codigo":369731000,
    "descripcion":"INVASIÓN TUMORAL PERINEURAL PRESENTE"
  },
  {
    "codigo":42051002,
    "descripcion":"HIPERTROFIA DEL CORDÓN ESPERMÁTICO"
  },
  {
    "codigo":304195006,
    "descripcion":"AMPLITUD DE FLEXIÓN HORIZONTAL ACTIVA DE HOMBRO DISMINUIDA"
  },
  {
    "codigo":402499008,
    "descripcion":"CARCINOMA BASOCELULAR DE LA PARED LATERAL EXTERNA DE LA NARIZ"
  },
  {
    "codigo":238659009,
    "descripcion":"PTERIGIÓN UNGUEAL EN LIQUEN PLANO"
  },
  {
    "codigo":9283009,
    "descripcion":"PROLAPSO UTERINO DE SEGUNDO GRADO"
  },
  {
    "codigo":7448003,
    "descripcion":"PIONEFROSIS AGUDA CON NECROSIS MEDULAR RENAL"
  },
  {
    "codigo":171288004,
    "descripcion":"SIN REGISTRO DE ANTECEDENTES DE INMUNIZACIONES"
  },
  {
    "codigo":289715004,
    "descripcion":"CONTRACCIONES UTERINAS LEVES"
  },
  {
    "codigo":16275741000119100,
    "descripcion":"APNEA OBSTRUCTIVA DEL SUEÑO SEVERA EN LA EDAD PEDIÁTRICA"
  },
  {
    "codigo":11852061000119100,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DE DEDO DEL PIE DERECHO"
  },
  {
    "codigo":366061001,
    "descripcion":"PODER DE REFRACCIÓN - HALLAZGO"
  },
  {
    "codigo":300525002,
    "descripcion":"CAPAZ DE CONSEGUIR UNA ERECCIÓN"
  },
  {
    "codigo":202221002,
    "descripcion":"SUBLUXACIÓN HABITUAL DE HOMBRO"
  },
  {
    "codigo":890349009,
    "descripcion":"EURIBLÉFARON BILATERAL"
  },
  {
    "codigo":724674002,
    "descripcion":"TRASTORNO PSICÓTICO CAUSADO POR HIPNÓTICO"
  },
  {
    "codigo":1052354004,
    "descripcion":"SÍNDROME DE ARTRITIS-DERMATOSIS ASOCIADO AL INTESTINO"
  },
  {
    "codigo":131000119109,
    "descripcion":"PERFIL DE LÍPIDOS EN AYUNAS POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":298690008,
    "descripcion":"PRUEBA DE ESTIRAMIENTO DEL NERVIO CIÁTICO NEGATIVA"
  },
  {
    "codigo":722839000,
    "descripcion":"NIÑO PREMATURO EN EL MOMENTO DEL PARTO, DE MENOS DE 23 SEMANAS"
  },
  {
    "codigo":296855005,
    "descripcion":"SOBREDOSIS DE ACETOHEXAMIDA"
  },
  {
    "codigo":788375006,
    "descripcion":"SENSACIÓN DE ANORMALIDAD"
  },
  {
    "codigo":427927008,
    "descripcion":"TRASTORNO RELACIONADO CON TRASPLANTE CARDÍACO"
  },
  {
    "codigo":34711008,
    "descripcion":"DESPRENDIMIENTO DE RETINA POR TRACCIÓN"
  },
  {
    "codigo":1943009,
    "descripcion":"DESORIENTACIÓN IZQUIERDA - DERECHA"
  },
  {
    "codigo":1179756001,
    "descripcion":"GALACTOSA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":131180006,
    "descripcion":"TIPO MELASIANO"
  },
  {
    "codigo":1145153003,
    "descripcion":"INTOXICACIÓN ACCIDENTAL CAUSADA POR AGONISTA DE RECEPTOR DE CANABINOIDE"
  },
  {
    "codigo":10678711000119102,
    "descripcion":"TUMEFACCIÓN LOCALIZADA DE LA PIERNA IZQUIERDA"
  },
  {
    "codigo":94742000,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL CUERPO AÓRTICO"
  },
  {
    "codigo":29206004,
    "descripcion":"HIPERFUNCIÓN TESTICULAR"
  },
  {
    "codigo":225814006,
    "descripcion":"ADOPTA EL PAPEL DE ENFERMO"
  },
  {
    "codigo":717334008,
    "descripcion":"HIPOTIROIDISMO CONGÉNITO IDIOPÁTICO"
  },
  {
    "codigo":61974008,
    "descripcion":"ABSCESO EPIDURAL"
  },
  {
    "codigo":1208854008,
    "descripcion":"TROMBOEMBOLISMO POR ENDOCARDITIS VEGETATIVA DE VÁLVULA CARDÍACA"
  },
  {
    "codigo":289515002,
    "descripcion":"PROTUBERANCIA DE LA PARED VAGINAL"
  },
  {
    "codigo":92907008,
    "descripcion":"FORMA ANORMAL CONGÉNITA DE LOS DEDOS"
  },
  {
    "codigo":29241000175104,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN DE GLÚTEO DERECHO GRADO 3"
  },
  {
    "codigo":1172416000,
    "descripcion":"HORMONA DE LA CORTEZA SUPRARRENAL DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":123840003,
    "descripcion":"ESPÉCIMEN CONTAMINADO"
  },
  {
    "codigo":191211009,
    "descripcion":"ANEMIA HEMOLÍTICA PRIMARIA POR ANTICUERPOS CALIENTES"
  },
  {
    "codigo":11825591000119106,
    "descripcion":"RUPTURA DE TRAUMÁTICA DE TENDÓN DE MANO DERECHA"
  },
  {
    "codigo":254912000,
    "descripcion":"REGRESIÓN DE TUMOR MALIGNO TESTICULAR"
  },
  {
    "codigo":285845002,
    "descripcion":"INCAPAZ DE ENTENDER SUS PROPIAS EMOCIONES"
  },
  {
    "codigo":11307601000119101,
    "descripcion":"FRACTURA NO EXPUESTA DE TECHO DE ACETÁBULO IZQUIERDO"
  },
  {
    "codigo":1268885006,
    "descripcion":"EPENDIMOBLASTOMA PRIMARIO"
  },
  {
    "codigo":709994000,
    "descripcion":"ESQUEMA OCLUSAL SUSTANCIALMENTE COMPROMETIDO"
  },
  {
    "codigo":15649361000119102,
    "descripcion":"ANEURISMA DE ARTERIA POPLÍTEA IZQUIERDA"
  },
  {
    "codigo":251242005,
    "descripcion":"ONDA U ELEVADA"
  },
  {
    "codigo":447850009,
    "descripcion":"DOBLE CAYADO AÓRTICO CON ARCO DERECHO DOMINANTE Y COARTACIÓN DE ARCO IZQUIERDO"
  },
  {
    "codigo":249407002,
    "descripcion":"DEPÓSITOS EN LA MUCOSA ORAL"
  },
  {
    "codigo":282175003,
    "descripcion":"BAJA UNA COLINA"
  },
  {
    "codigo":85567005,
    "descripcion":"JUGADOR EN ACCIDENTE DURANTE ACTIVIDAD DEPORTIVA"
  },
  {
    "codigo":10871531000119100,
    "descripcion":"CISTOADENOMA SEROSO DE OVARIO DERECHO"
  },
  {
    "codigo":330321000119107,
    "descripcion":"MONOPLEJÍA DE MIEMBRO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":1359849004,
    "descripcion":"CARCINOMA DE BERMELLÓN DE LABIO INFERIOR"
  },
  {
    "codigo":737257008,
    "descripcion":"LESIÓN TRAUMÁTICA DE FASCIA DE REGIÓN LUMBAR"
  },
  {
    "codigo":704489009,
    "descripcion":"FALTA DE APOYO FAMILIAR"
  },
  {
    "codigo":276670004,
    "descripcion":"INFECCIÓN CONGÉNITA NO BACTERIANA Y NO VIRAL"
  },
  {
    "codigo":735422006,
    "descripcion":"DEFICIENCIA DE SINTETASA DE ÁCIDO RIBONUCLEICO DE TRANSFERENCIA DE ASPARTILO MITOCRONDRIAL"
  },
  {
    "codigo":274835000,
    "descripcion":"HALLAZGO HISTOLÓGICO ANORMAL EN ESPÉCIMEN DE ÓRGANO GENITAL MASCULINO"
  },
  {
    "codigo":1259710009,
    "descripcion":"CARCINOMA NEUROENDOCRINO DE CÉLULAS PEQUEÑAS PRIMARIO DE PRÓSTATA"
  },
  {
    "codigo":307603002,
    "descripcion":"NEVO AZUL MALIGNO DE LA PIEL"
  },
  {
    "codigo":405907004,
    "descripcion":"TUMOR QUE INVADE ESTRUCTURA DE CAVIDAD ABDOMINAL"
  },
  {
    "codigo":38261000087101,
    "descripcion":"HIPOCINESIA DE SEGMENTO BASAL ANTEROSEPTAL DE VENTRÍCULO CARDÍACO IZQUIERDO"
  },
  {
    "codigo":209299007,
    "descripcion":"FRACTURA-SUBLUXACIÓN EXPUESTA PERISEMILUNAR TRANSESCAFOIDEA"
  },
  {
    "codigo":110995008,
    "descripcion":"CALCIFICACIÓN INTRAPARIETAL DE LA VESÍCULA BILIAR"
  },
  {
    "codigo":764520001,
    "descripcion":"TRISOMÍA DISTAL 9Q"
  },
  {
    "codigo":43381000087106,
    "descripcion":"DISCO INTERVERTEBRAL LUMBAR PROLAPSADO, L3-L4"
  },
  {
    "codigo":305768002,
    "descripcion":"VISTO POR LUDOTERAPEUTA"
  },
  {
    "codigo":404072004,
    "descripcion":"LIPOSARCOMA DESDIFERENCIADO"
  },
  {
    "codigo":40821000087107,
    "descripcion":"ABRASIÓN DE PIEL DE SEGUNDO DEDO DE PIE DERECHO"
  },
  {
    "codigo":240232008,
    "descripcion":"DEFORMIDAD ADQUIRIDA DEL PULGAR"
  },
  {
    "codigo":1286973001,
    "descripcion":"MELANOMA MALIGNO DE LECHO UNGUEAL"
  },
  {
    "codigo":41789000,
    "descripcion":"LINFANGITIS AGUDA DEL MENTÓN"
  },
  {
    "codigo":271165006,
    "descripcion":"AMPOLLA TRAUMÁTICA DE CODO, INFECTADA"
  },
  {
    "codigo":369469009,
    "descripcion":"TUMOR MALIGNO QUE COMPROMETE VEJIGA URINARIA POR PROPAGACIÓN DIRECTA DE ENDOMETRIO"
  },
  {
    "codigo":105490003,
    "descripcion":"TRABAJO EXCESIVO"
  },
  {
    "codigo":1186834004,
    "descripcion":"HIPOFISITIS RELACIONADA CON INMUNOGLOBULINA G4"
  },
  {
    "codigo":201959001,
    "descripcion":"ARTROPATÍA TRAUMÁTICA DE SEGUNDA A QUINTA ARTICULACIONES METATARSOFALÁNGICAS"
  },
  {
    "codigo":431335002,
    "descripcion":"HIPOXEMIA EN EL RECIÉN NACIDO"
  },
  {
    "codigo":236562009,
    "descripcion":"BLOQUEO DEL CATÉTER DE DIÁLISIS PERITONEAL"
  },
  {
    "codigo":38119007,
    "descripcion":"AMPOLLA DEL TRONCO, SIN INFECCIÓN"
  },
  {
    "codigo":365799007,
    "descripcion":"NIVEL PROTEICO - HALLAZGO"
  },
  {
    "codigo":890087007,
    "descripcion":"TRASTORNO DEL DESARROLLO SEXUAL 46,XX CAUSADO POR DIETILESTILBESTROL SINTÉTICO ADMINISTRADO POR VÍA ORAL"
  },
  {
    "codigo":300263009,
    "descripcion":"CONDUCTO SALIVAL LISO"
  },
  {
    "codigo":10900511000119100,
    "descripcion":"CONTUSIÓN DE GLOBO OCULAR DERECHO"
  },
  {
    "codigo":722577000,
    "descripcion":"LESIÓN TRAUMÁTICA DE HÍGADO DEBIDA A TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":1111511000000106,
    "descripcion":"CIERRE DE ÁNGULO FACOMÓRFICO SECUNDARIO AGUDO"
  },
  {
    "codigo":1279633003,
    "descripcion":"CORTE EN PIEL DE DEDO MEÑIQUE DE MANO DERECHA"
  },
  {
    "codigo":427665004,
    "descripcion":"ALETEO AURICULAR PAROXÍSTICO"
  },
  {
    "codigo":686981000119108,
    "descripcion":"MICOSIS FUNGOIDE DE GANGLIO LINFÁTICO INGUINAL"
  },
  {
    "codigo":294758000,
    "descripcion":"ALERGIA A TIBOLONA"
  },
  {
    "codigo":296593007,
    "descripcion":"SOBREDOSIS DE ESTREPTOMICINA"
  },
  {
    "codigo":32614006,
    "descripcion":"MICROGLOSIA"
  },
  {
    "codigo":65382006,
    "descripcion":"BROMHIDROSIS"
  },
  {
    "codigo":292923006,
    "descripcion":"REACCIÓN ADVERSA A LA KANAMICINA"
  },
  {
    "codigo":1144891007,
    "descripcion":"COLANGIOCARCINOMA PRIMARIO DE CONDUCTO BILIAR EXTRAHEPÁTICO"
  },
  {
    "codigo":94480000,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA PELVIS"
  },
  {
    "codigo":127248001,
    "descripcion":"NEOPLASIA DE GANGLIOS LINFÁTICOS MEDIASTÍNICOS"
  },
  {
    "codigo":225552003,
    "descripcion":"HALLAZGO RELACIONADO CON HERIDA"
  },
  {
    "codigo":15979551000119106,
    "descripcion":"HIPOPLASIA CONGÉNITA DE AMBOS HUESOS CIGOMÁTICOS"
  },
  {
    "codigo":61712006,
    "descripcion":"INTOLERANCIA TRANSITORIA AL GLUTEN"
  },
  {
    "codigo":59877000,
    "descripcion":"ANOMALÍA CONGÉNITA DE LA AORTA"
  },
  {
    "codigo":28944009,
    "descripcion":"INFECCIÓN POR CITOMEGALOVIRUS"
  },
  {
    "codigo":92645007,
    "descripcion":"CARCINOMA IN SITU DE LA ENCÍA INFERIOR"
  },
  {
    "codigo":289253008,
    "descripcion":"HALLAZGO DEL TRABAJO DE PARTO ASOCIADO CON UN DISPOSITIVO"
  },
  {
    "codigo":1335994007,
    "descripcion":"CARCINOMA DE CÉLULAS DE MERKEL PRIMARIO DE PIEL DE HOMBRO"
  },
  {
    "codigo":711567000,
    "descripcion":"CONCRECIÓN EN CONJUNTIVA DE PÁRPADO INFERIOR"
  },
  {
    "codigo":254650008,
    "descripcion":"NEOPLASIA EPITELIAL MALIGNA DE LA PIEL"
  },
  {
    "codigo":88975006,
    "descripcion":"TRASTORNO ESQUIZOFRENIFORME"
  },
  {
    "codigo":1137551007,
    "descripcion":"CALCIFICACIÓN PUNTEADA DE EPÍFISIS DE FALANGE DE DEDO MEÑIQUE"
  },
  {
    "codigo":414820001,
    "descripcion":"BOTULISMO NEONATAL"
  },
  {
    "codigo":283748005,
    "descripcion":"MORDEDURA DE PERRO EN EL HOMBRO"
  },
  {
    "codigo":10955961000119106,
    "descripcion":"HERIDA PUNZANTE DE DEDO MEDIO DE MANO DERECHA"
  },
  {
    "codigo":85305001,
    "descripcion":"CRECIMIENTO ANORMAL DEL PELO"
  },
  {
    "codigo":185444009,
    "descripcion":"INFORME DE ESTUDIO ECOGRÁFICO RECIBIDO"
  },
  {
    "codigo":609593002,
    "descripcion":"LESIÓN DE RAMA DE NERVIO MEDIANO"
  },
  {
    "codigo":314681004,
    "descripcion":"PESO DEL NIÑO: PERCENTILO 76-90"
  },
  {
    "codigo":281913001,
    "descripcion":"FRACTURA POR APLASTAMIENTO DE VÉRTEBRA CERVICAL"
  },
  {
    "codigo":249145006,
    "descripcion":"OBSERVACIÓN UTERINA DURANTE EL TRABAJO DE PARTO"
  },
  {
    "codigo":19769006,
    "descripcion":"HIPERTENSIÓN ARTERIAL ESENCIAL POR ALTO NIVEL DE RENINA"
  },
  {
    "codigo":17934008,
    "descripcion":"ENVENENAMIENTO DEBIDO A PICADURA DE ABEJA AFRICANA"
  },
  {
    "codigo":48867003,
    "descripcion":"BRADICARDIA"
  },
  {
    "codigo":47032000,
    "descripcion":"HIDROCEFALIA CONGÉNITA"
  },
  {
    "codigo":689491000119105,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE BORDE BERMELLÓN DE LABIO SUPERIOR"
  },
  {
    "codigo":276408002,
    "descripcion":"PIEDRA EN LA ORINA"
  },
  {
    "codigo":1259448000,
    "descripcion":"ADENOCARCINOMA MUCINOSO PRIMARIO DE TRACTO GASTROINTESTINAL"
  },
  {
    "codigo":210872004,
    "descripcion":"LESIÓN DE VENA SAFENA MENOR"
  },
  {
    "codigo":702392008,
    "descripcion":"CARCINOMA DE CÉLULAS RENALES METASTÁSICO"
  },
  {
    "codigo":209037002,
    "descripcion":"LUXACIÓN NO EXPUESTA DE COLUMNA CERVICAL"
  },
  {
    "codigo":877043181000119101,
    "descripcion":"INFECCIÓN CAUSADA POR BABESIA DUNCANI"
  },
  {
    "codigo":307341004,
    "descripcion":"TRICOLEUCEMIA ATÍPICA"
  },
  {
    "codigo":274573005,
    "descripcion":"HIPERNASALIDAD E HIPONASALIDAD"
  },
  {
    "codigo":733325006,
    "descripcion":"OCLUSIÓN COMBINADA POR TROMBO DE ARTERIA Y VENA DE LA RETINA"
  },
  {
    "codigo":241805002,
    "descripcion":"ENVENENAMIENTO POR VENENO DE VÍBORA EUROPEA"
  },
  {
    "codigo":371042002,
    "descripcion":"TIÑA CAUSADA POR TRICHOPHYTON RUBRUM"
  },
  {
    "codigo":305506003,
    "descripcion":"BAJO ATENCIÓN DE MÉDICO ESPECIALISTA EN TRANSFUSIONES DE SANGRE"
  },
  {
    "codigo":895330007,
    "descripcion":"CURVATURA ANORMAL DE FALANGE MEDIA DE DEDO MAYOR DE MANO"
  },
  {
    "codigo":403810008,
    "descripcion":"EPIDERMÓLISIS BULLOSA PRURIGINOSA"
  },
  {
    "codigo":239970009,
    "descripcion":"LAXITUD LIGAMENTOSA DE REGIÓN DE CODO"
  },
  {
    "codigo":762423001,
    "descripcion":"DESVIACIÓN DE LA MIRADA HACIA ABAJO"
  },
  {
    "codigo":238135003,
    "descripcion":"SÍNDROME DE LA ALMOHADILLA ADIPOSA"
  },
  {
    "codigo":41527003,
    "descripcion":"GLUCOGENOSIS TIPO VIII"
  },
  {
    "codigo":205367006,
    "descripcion":"SINOSTOSIS CONGÉNITA DE HUESO DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":270903007,
    "descripcion":"FALTA O PÉRDIDA DE DESEO SEXUAL"
  },
  {
    "codigo":432908002,
    "descripcion":"RECHAZO CRÓNICO DE TRASPLANTE HEPÁTICO"
  },
  {
    "codigo":400140006,
    "descripcion":"EPIDERMÓLISIS BULLOSA GRAVE DE LA ZONA DE UNIÓN DE HERLITZ"
  },
  {
    "codigo":269068007,
    "descripcion":"FRACTURA NO EXPUESTA DE LA SEXTA VÉRTEBRA CERVICAL"
  },
  {
    "codigo":203532008,
    "descripcion":"PIE PLANO RÍGIDO"
  },
  {
    "codigo":301836007,
    "descripcion":"TUBERCULOSIS DE COLON"
  },
  {
    "codigo":365537005,
    "descripcion":"INSTALACIONES DE ASISTENCIA SOCIAL LABORAL - HALLAZGO"
  },
  {
    "codigo":335341000119108,
    "descripcion":"SÍNDROME DE OJO SECO DERECHO"
  },
  {
    "codigo":168929008,
    "descripcion":"ANGIOGRAFÍA DE CARÓTIDA, ANORMAL"
  },
  {
    "codigo":5089007,
    "descripcion":"TRASTORNO DE LA VULVA"
  },
  {
    "codigo":234465007,
    "descripcion":"DEFICIENCIA DE ALFA-2 ANTIPLASMINA"
  },
  {
    "codigo":396470003,
    "descripcion":"MARGEN QUIRÚRGICO DE VÍAS BILIARES NO COMPROMETIDO POR NEOPLASIA MALIGNA"
  },
  {
    "codigo":10876551000119102,
    "descripcion":"INTOXICACIÓN CAUSADA POR ASPIRINA"
  },
  {
    "codigo":3254001,
    "descripcion":"INFECCIÓN CAUSADA POR STRONGYLOIDES WESTERI"
  },
  {
    "codigo":298166006,
    "descripcion":"INFLAMACIÓN DE ARTICULACIÓN METACARPOFALÁNGICA"
  },
  {
    "codigo":296331006,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE CAFEÍNA"
  },
  {
    "codigo":294496000,
    "descripcion":"ALERGIA A FENETICILINA"
  },
  {
    "codigo":230795009,
    "descripcion":"COMA HIPOFISARIO"
  },
  {
    "codigo":34187009,
    "descripcion":"MIOPÍA SEVERA"
  },
  {
    "codigo":10630791000119106,
    "descripcion":"LINFANGITIS AGUDA DE MANO IZQUIERDA"
  },
  {
    "codigo":292661007,
    "descripcion":"REACCIÓN ADVERSA AL PERÓXIDO DE BENZOILO"
  },
  {
    "codigo":94218003,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE HUESO DE LA CARA"
  },
  {
    "codigo":28682004,
    "descripcion":"DUPLICACIÓN CONGÉNITA DE COLON"
  },
  {
    "codigo":290826006,
    "descripcion":"INTOXICACIÓN POR DOTIEPINA"
  },
  {
    "codigo":126986008,
    "descripcion":"NEOPLASIA DE LOS NERVIOS PERIFÉRICOS DE LOS MIEMBROS SUPERIORES"
  },
  {
    "codigo":92383003,
    "descripcion":"NEOPLASIA BENIGNA DE LA PIEL DE LA MUÑECA"
  },
  {
    "codigo":190687004,
    "descripcion":"FENILCETONURIA"
  },
  {
    "codigo":714975004,
    "descripcion":"INADECUADO PARA PLANIFICACIÓN ANTICIPADA DE CUIDADOS"
  },
  {
    "codigo":288991007,
    "descripcion":"NO SE PRENDE AL PECHO PARA MAMAR"
  },
  {
    "codigo":254388002,
    "descripcion":"NEOPLASIA SUPERPUESTA DE LA CAVIDAD BUCAL Y LABIO Y GLÁNDULAS SALIVALES"
  },
  {
    "codigo":1075131000119100,
    "descripcion":"HALLUX LIMITUS ADQUIRIDO DERECHO"
  },
  {
    "codigo":1237428006,
    "descripcion":"METÁSTASIS DE CARCINOMA DE COLÉDOCO"
  },
  {
    "codigo":25012008,
    "descripcion":"CUERPO EXTRAÑO RETENIDO EN EL PÁRPADO"
  },
  {
    "codigo":23177005,
    "descripcion":"CREPITACIÓN UTERINA"
  },
  {
    "codigo":187017007,
    "descripcion":"PARONIQUIA POR CANDIDA"
  },
  {
    "codigo":283486000,
    "descripcion":"HERIDA PUNZANTE EN LA ESPINILLA"
  },
  {
    "codigo":185182009,
    "descripcion":"ATENDIDO EN EL DEPARTAMENTO DE ANATOMÍA PATOLÓGICA"
  },
  {
    "codigo":248883001,
    "descripcion":"PAPILOMA VAGINAL"
  },
  {
    "codigo":314419002,
    "descripcion":"PROLIFERACIÓN MELANOCÍTICA UVEAL DIFUSA BILATERAL"
  },
  {
    "codigo":348431000119100,
    "descripcion":"OPACIDAD DEL HUMOR VÍTREO DEL OJO IZQUIERDO"
  },
  {
    "codigo":16018191000119101,
    "descripcion":"OSTEOPATÍA DE TIBIA IZQUIERDA POSTERIOR A POLIOMIELITIS"
  },
  {
    "codigo":12237071000119100,
    "descripcion":"CLAUDICACIÓN INTERMITENTE DE MIEMBRO INFERIOR IZQUIERDO CONCOMITANTE CON ATEROSCLEROSIS Y DEBIDA A ELLA"
  },
  {
    "codigo":16036111000119103,
    "descripcion":"OSTEÓLISIS DE PIE DERECHO"
  },
  {
    "codigo":153871000119102,
    "descripcion":"DERMATITIS POR ESTASIS CONCOMITANTE CON ÚLCERA VENOSA DE MIEMBRO INFERIOR DEBIDA A HIPERTENSIÓN VENOSA PERIFÉRICA CRÓNICA"
  },
  {
    "codigo":16046351000119103,
    "descripcion":"ENFERMEDAD POR DEPÓSITO DE HIDROXIAPATITA DE MUÑECA DERECHA"
  },
  {
    "codigo":340751000119102,
    "descripcion":"RETRACCIÓN ANORMAL DE PÁRPADO IZQUIERDO"
  },
  {
    "codigo":10680591000119107,
    "descripcion":"NÓDULO DE PIEL DE EXTREMIDAD SUPERIOR IZQUIERDA"
  },
  {
    "codigo":71951000119107,
    "descripcion":"SUSCEPTIBILIDAD GENÉTICA A TRASTORNO GENÉTICO"
  },
  {
    "codigo":16041231000119109,
    "descripcion":"ARTRITIS IDIOPÁTICA JUVENIL DE INICIO SISTÉMICO DE TOBILLO DERECHO"
  },
  {
    "codigo":317711000119108,
    "descripcion":"PERIARTRITIS DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":16005391000119108,
    "descripcion":"OCLUSIÓN DE ARTERIA DISTAL DE MIEMBRO SUPERIOR DERECHO"
  },
  {
    "codigo":10867471000119104,
    "descripcion":"HERIDA ABIERTA DE REGIÓN LUMBAR DEBIDA MORDEDURA DE PERRO"
  },
  {
    "codigo":1078031000119108,
    "descripcion":"OSTEOCONDROSIS JUVENIL DE HUESO NAVICULAR DEL TARSO DERECHO"
  },
  {
    "codigo":691471000119109,
    "descripcion":"ISQUEMIA CONCOMITANTE CON AUMENTO DE LA DEMANDA DE OXÍGENO Y DEBIDA A ÉL"
  },
  {
    "codigo":10900751000119107,
    "descripcion":"CONTUSIÓN DE TEJIDO ORBITARIO DE OJO DERECHO"
  },
  {
    "codigo":771336003,
    "descripcion":"POLIMICROGIRIA CON HIPOPLASIA DEL NERVIO ÓPTICO"
  },
  {
    "codigo":16000271000119108,
    "descripcion":"SÍNDROME DEL IRIS FLÁCIDO INTRAOPERATORIO DE OJO IZQUIERDO"
  },
  {
    "codigo":10637071000119109,
    "descripcion":"ÚLCERA POR PRESIÓN EN NALGA ESTADIO II"
  },
  {
    "codigo":50440006,
    "descripcion":"ENFERMEDAD DE CROHN DEL COLON"
  },
  {
    "codigo":1193650002,
    "descripcion":"INFLAMACIÓN INTESTINAL POR ASPERGILLUS"
  },
  {
    "codigo":337851000119109,
    "descripcion":"ESCLEROQUERATITIS DE OJO IZQUIERDO"
  },
  {
    "codigo":472754008,
    "descripcion":"OBSTRUCCIÓN DE VENA CAVA INFERIOR COMO COMPLICACIÓN DE PROCEDIMIENTO"
  },
  {
    "codigo":14002008,
    "descripcion":"INTOXICACIÓN POR CAOLÍN"
  },
  {
    "codigo":767666009,
    "descripcion":"QUISTE DE INCLUSIÓN EPIDÉRMICA DE PÁRPADO"
  },
  {
    "codigo":208775003,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA NO EXPUESTA DE LA ARTICULACIÓN ACROMIOCLAVICULAR"
  },
  {
    "codigo":700295004,
    "descripcion":"ARTROSIS DE TOBILLO SECUNDARIA A TRAUMATISMO"
  },
  {
    "codigo":307079000,
    "descripcion":"OYE VOCES BURLONAS"
  },
  {
    "codigo":75868000,
    "descripcion":"TIÑA DEL CUERPO POR TRICHOPHYTON"
  },
  {
    "codigo":43100002,
    "descripcion":"ATROFIA CEREBELOSA CORTICAL TARDÍA"
  },
  {
    "codigo":15958101000119106,
    "descripcion":"SARCOMA PRIMARIO DE RIÑÓN DERECHO"
  },
  {
    "codigo":16668911000119100,
    "descripcion":"FRACTURA NO EXPUESTA DE PORCIÓN NASO-ORBITARIA DE HUESO ETMOIDES DERECHO"
  },
  {
    "codigo":403548007,
    "descripcion":"APLASIA CUTÁNEA CONGÉNITA POR MALFORMACIÓN SUBYACENTE (TIPO 4)"
  },
  {
    "codigo":237873000,
    "descripcion":"MIOPATÍA AMILOIDE FAMILIAR PRIMARIA"
  },
  {
    "codigo":12107861000119109,
    "descripcion":"QUEMADURA DE REGIÓN ESCAPULAR DERECHA"
  },
  {
    "codigo":203270006,
    "descripcion":"TUBERCULOSIS DE HUESO DEL ANTEBRAZO"
  },
  {
    "codigo":301574007,
    "descripcion":"DIFICULTAD PARA MOVILIZARSE CON DISPOSITIVO ORTOPÉDICO"
  },
  {
    "codigo":234203000,
    "descripcion":"ESTENOSIS DE FÍSTULA ARTERIOVENOSA"
  },
  {
    "codigo":1153542007,
    "descripcion":"INTOXICACIÓN POR FLUOROQUINOLONA"
  },
  {
    "codigo":365275006,
    "descripcion":"HALLAZGO RELACIONADO CON EL BIENESTAR GENERAL"
  },
  {
    "codigo":398043006,
    "descripcion":"PACIENTE EN POSICIÓN CABEZA ABAJO"
  },
  {
    "codigo":2992000,
    "descripcion":"DEGENERACIÓN PIGMENTARIA DEL GLOBO PÁLIDO"
  },
  {
    "codigo":168667009,
    "descripcion":"RADIOGRAFÍA SIMPLE DE RODILLA NORMAL"
  },
  {
    "codigo":299739007,
    "descripcion":"LESIÓN BILATERAL DE LA NEURONA MOTORA SUPERIOR"
  },
  {
    "codigo":363440005,
    "descripcion":"NEOPLASIA MALIGNA DE PARTES BLANDAS DE CARA"
  },
  {
    "codigo":723888006,
    "descripcion":"CLINODACTILIA DE DEDO DE PIE"
  },
  {
    "codigo":15741321000119100,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE REGIÓN DE PELVIS IZQUIERDA"
  },
  {
    "codigo":68528007,
    "descripcion":"HIPERFENILALANINEMIA"
  },
  {
    "codigo":232368009,
    "descripcion":"SARCOIDOSIS NASAL"
  },
  {
    "codigo":722053001,
    "descripcion":"OBESIDAD DEBIDA A DEFICIENCIA DE PROHORMONA CONVERTASA I"
  },
  {
    "codigo":427141003,
    "descripcion":"LINFOMA MALIGNO EN REMISIÓN"
  },
  {
    "codigo":340361000119101,
    "descripcion":"GLAUCOMA DE ÁNGULO CERRADO INTERMITENTE DE OJO IZQUIERDO"
  },
  {
    "codigo":396208007,
    "descripcion":"MARGEN QUIRÚRGICO DE PARÉNQUIMA RENAL COMPROMETIDO POR NEOPLASIA MALIGNA"
  },
  {
    "codigo":294234003,
    "descripcion":"ALERGIA A BACLOFENO"
  },
  {
    "codigo":11835631000119109,
    "descripcion":"SUBLUXACIÓN DE ARTICULACIÓN METATARSOFALÁNGICA DE DEDO (SEGUNDO A QUINTO) DE PIE IZQUIERDO"
  },
  {
    "codigo":95791002,
    "descripcion":"NISTAGMO AUMENTADO POR LA REMOCIÓN DE LA FIJACIÓN"
  },
  {
    "codigo":423471004,
    "descripcion":"POLIPOSIS ASOCIADA AL GEN MYH"
  },
  {
    "codigo":292399007,
    "descripcion":"REACCIÓN ADVERSA A LA TRIFLUOPERAZINA"
  },
  {
    "codigo":1077641000119105,
    "descripcion":"OSTEOMIELITIS CRÓNICA DE PIE IZQUIERDO"
  },
  {
    "codigo":126724001,
    "descripcion":"NEOPLASIA DE TEJIDO MESOTELIAL"
  },
  {
    "codigo":93956001,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA PIEL PERIANAL"
  },
  {
    "codigo":225028001,
    "descripcion":"ACEPTA LA PÉRDIDA"
  },
  {
    "codigo":1306372004,
    "descripcion":"SARCOMA DE CUADRANTE INFERIOR EXTERNO DE MAMA"
  },
  {
    "codigo":68131000119100,
    "descripcion":"PARÁLISIS FACIAL GRADO III DE HOUSE-BRACKMANN"
  },
  {
    "codigo":313891000119101,
    "descripcion":"ATROFIA DE MÚSCULO DE MANO DERECHA"
  },
  {
    "codigo":10963491000119101,
    "descripcion":"LACERACIÓN DE DEDO ANULAR IZQUIERDO"
  },
  {
    "codigo":24750000,
    "descripcion":"SÍNDROME DE TOWNES"
  },
  {
    "codigo":92121009,
    "descripcion":"NEOPLASIA BENIGNA DEL GLOMO YUGULAR"
  },
  {
    "codigo":288729009,
    "descripcion":"NO EMPLEA DIFERENTES FORMAS DE CONVERSACIÓN"
  },
  {
    "codigo":286894008,
    "descripcion":"CARCINOMA DE MAMA - CUADRANTE INFEROINTERNO"
  },
  {
    "codigo":88451002,
    "descripcion":"CONFLICTO DE INDEPENDENCIA - DEPENDENCIA NO RESUELTO"
  },
  {
    "codigo":186755002,
    "descripcion":"CARDITIS VIRAL"
  },
  {
    "codigo":448899005,
    "descripcion":"VENA CAVA SUPERIOR DERECHA CONECTADA A AURÍCULA DERECHA"
  },
  {
    "codigo":285059008,
    "descripcion":"LESIÓN TRAUMÁTICA DEL OÍDO EXTERNO"
  },
  {
    "codigo":283224002,
    "descripcion":"ANZUELO EN DEDO DEL PIE"
  },
  {
    "codigo":184920008,
    "descripcion":"EXAMEN DEL CINTURÓN DE SEGURIDAD - REALIZADO"
  },
  {
    "codigo":414296009,
    "descripcion":"FRECUENCIA DE USO INAPROPIADO DE SUSTANCIA"
  },
  {
    "codigo":84781002,
    "descripcion":"CRETINISMO ESPORÁDICO"
  },
  {
    "codigo":1231661003,
    "descripcion":"DEFICIENCIA RETINOTÓPICA DE MOVIMIENTOS DE PERSECUCIÓN SUAVE"
  },
  {
    "codigo":707373004,
    "descripcion":"GRANULOMA DE CÉLULAS PLASMÁTICAS DE PULMÓN"
  },
  {
    "codigo":248621004,
    "descripcion":"RUIDOS TRANSMITIDOS"
  },
  {
    "codigo":123581000119101,
    "descripcion":"DESPROPORCIÓN DE MAMA RECONSTRUIDA"
  },
  {
    "codigo":771074000,
    "descripcion":"SÍNDROME DE MICROCEFALIA, BAJA ESTATURA, DISCAPACIDAD INTELECTUAL Y DISMORFIA FACIAL"
  },
  {
    "codigo":50178004,
    "descripcion":"PULSO FEMORAL ANORMAL"
  },
  {
    "codigo":212183002,
    "descripcion":"LESIÓN DE LA MÉDULA ESPINAL LUMBAR, SIN LESIÓN ÓSEA"
  },
  {
    "codigo":441559006,
    "descripcion":"LINFOMA DE CÉLULAS DEL MANTO DEL BAZO"
  },
  {
    "codigo":13740005,
    "descripcion":"SENSACIÓN DE IMPOTENCIA, LEVE"
  },
  {
    "codigo":208513000,
    "descripcion":"FRACTURAS MÚLTIPLES DEL ANTEBRAZO"
  },
  {
    "codigo":110209002,
    "descripcion":"QUEMADURA DE TERCER GRADO DE LA ENCÍA UNIDA AL MAXILAR SUPERIOR"
  },
  {
    "codigo":1156950000,
    "descripcion":"INMUNIDAD CONTRA VIRUS DE LA RABIA DETERMINADA POR SEROLOGÍA"
  },
  {
    "codigo":370518000,
    "descripcion":"COCCIDIOSIS ENTÉRICA"
  },
  {
    "codigo":403286002,
    "descripcion":"ONICÓLISIS TRAUMÁTICA"
  },
  {
    "codigo":763734007,
    "descripcion":"FISURA DE LABIO COMPLETA DEL LADO DERECHO"
  },
  {
    "codigo":1220651005,
    "descripcion":"ABORTO COMPLETO INDUCIDO COMPLICADO POR ENFERMEDAD METABÓLICA"
  },
  {
    "codigo":237611007,
    "descripcion":"ATROFIA MUSCULAR, ATAXIA, RETINITIS PIGMENTOSA Y DIABETES MELLITUS"
  },
  {
    "codigo":183761751000119105,
    "descripcion":"ATRAPAMIENTO DE MÚSCULO RECTO SUPERIOR DE OJO DERECHO"
  },
  {
    "codigo":792832001,
    "descripcion":"TODOS LOS PULSOS PRESENTES EN AMBOS MIEMBROS INFERIORES"
  },
  {
    "codigo":301312002,
    "descripcion":"HALLAZGO RELACIONADO CON LA APARIENCIA DE LA CABEZA"
  },
  {
    "codigo":268544001,
    "descripcion":"SIN EXTENDIDO - HISTERECTOMÍA POR CAUSA BENIGNA"
  },
  {
    "codigo":235776000,
    "descripcion":"ENFERMEDAD DIVERTICULAR DEL COLON DERECHO"
  },
  {
    "codigo":15989591000119106,
    "descripcion":"FLICTÉNULA DE OJO IZQUIERDO"
  },
  {
    "codigo":4565000,
    "descripcion":"AFINIDAD POR EL OXÍGENO DISMINUIDA"
  },
  {
    "codigo":365013001,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA PRONUNCIAR SONIDOS COMBINADOS"
  },
  {
    "codigo":299477002,
    "descripcion":"PIE NORMAL"
  },
  {
    "codigo":233941006,
    "descripcion":"HIPERTENSIÓN PULMONAR AISLADA"
  },
  {
    "codigo":725461009,
    "descripcion":"ENANISMO PRIMORDIAL OSTEODISPLÁSICO MICROCEFÁLICO TIPOS I Y III"
  },
  {
    "codigo":232106004,
    "descripcion":"EXOTROPÍA RESIDUAL"
  },
  {
    "codigo":35498005,
    "descripcion":"DERMATITIS POR ESTASIS"
  },
  {
    "codigo":68266006,
    "descripcion":"LIQUEN PLANO HIPERTRÓFICO"
  },
  {
    "codigo":263039001,
    "descripcion":"SUBLUXACIÓN DE ARTICULACIÓN DE LA COLUMNA VERTEBRAL"
  },
  {
    "codigo":721791005,
    "descripcion":"ENCEFALITIS CAUSADA POR VIRUS NIPAH"
  },
  {
    "codigo":230271008,
    "descripcion":"ENFERMEDAD DE PICK CON CUERPOS DE PICK"
  },
  {
    "codigo":164735009,
    "descripcion":"FUNDOSCOPIA ANORMAL"
  },
  {
    "codigo":228436003,
    "descripcion":"TOLERANCIA INVERSA A LA DROGA"
  },
  {
    "codigo":64596006,
    "descripcion":"UÑA HIPOCRÁTICA CONGÉNITA"
  },
  {
    "codigo":293972007,
    "descripcion":"ALERGIA A NADOLOL"
  },
  {
    "codigo":195668008,
    "descripcion":"AMIGDALITIS ULCEROSA AGUDA"
  },
  {
    "codigo":292137001,
    "descripcion":"REACCIÓN ADVERSA A DANTRÓN"
  },
  {
    "codigo":16290801000119107,
    "descripcion":"VÍCTIMA DE TRÁFICO HUMANO INFANTIL"
  },
  {
    "codigo":15717361000119107,
    "descripcion":"OSTEOCONDRITIS DISECANTE BILATERAL DE PIE"
  },
  {
    "codigo":95529005,
    "descripcion":"ÚLCERA GÁSTRICA AGUDA"
  },
  {
    "codigo":10966001000119108,
    "descripcion":"HERIDA PUNZANTE DE DEDO DE REGIÓN DE TOBILLO DERECHO"
  },
  {
    "codigo":128297008,
    "descripcion":"ENFERMEDAD CRÓNICA DEL OÍDO"
  },
  {
    "codigo":60926001,
    "descripcion":"NEFRITIS TUBULOINTERSTICIAL CRÓNICA"
  },
  {
    "codigo":880126001,
    "descripcion":"TRASTORNO DEL AMNIOS"
  },
  {
    "codigo":93694003,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE VASO SANGUÍNEO DE LA CARA"
  },
  {
    "codigo":290302001,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR SULINDAC"
  },
  {
    "codigo":57256002,
    "descripcion":"INTOXICACIÓN POR ACACIA BERLANDIERI"
  },
  {
    "codigo":253864004,
    "descripcion":"RIÑÓN GLOMERULOQUÍSTICO FAMILIAR TIPO HIPOPLÁSICO"
  },
  {
    "codigo":417704008,
    "descripcion":"DISTENSIÓN DE MEMBRANA ARTICULAR"
  },
  {
    "codigo":252029001,
    "descripcion":"OBSTRUCCIÓN URINARIA MECÁNICA"
  },
  {
    "codigo":22653005,
    "descripcion":"MIOCARDITIS INFECCIOSA"
  },
  {
    "codigo":219261008,
    "descripcion":"LESIÓN POR INTERVENCIÓN LEGAL CON BALA DE GOMA"
  },
  {
    "codigo":414034000,
    "descripcion":"COMPLEJO DE ESTRABISMO DISOCIADO"
  },
  {
    "codigo":710781009,
    "descripcion":"SURCO MENTOLABIAL PROFUNDO"
  },
  {
    "codigo":448637008,
    "descripcion":"COARTACIÓN DE ARTERIA PULMONAR IZQUIERDA"
  },
  {
    "codigo":282962004,
    "descripcion":"NO SE ACUCLILLA"
  },
  {
    "codigo":1082661000119103,
    "descripcion":"ABSCESO ANAL"
  },
  {
    "codigo":1003858007,
    "descripcion":"CONDRODISPLASIA PUNTEADA RIZOMÉLICA TIPO 3"
  },
  {
    "codigo":20818009,
    "descripcion":"PÉRDIDA SENSITIVA DISOCIADA DEL NERVIO ESPINAL"
  },
  {
    "codigo":53586009,
    "descripcion":"UNIÓN MACROMOLECULAR"
  },
  {
    "codigo":99621000119104,
    "descripcion":"FÍSTULA URETROCUTÁNEA ADQUIRIDA"
  },
  {
    "codigo":281127005,
    "descripcion":"ORIFICIO CERVICAL ABIERTO"
  },
  {
    "codigo":11814181000119105,
    "descripcion":"RUPTURA DE LIGAMENTO DE DEDO DE MANO IZQUIERDA"
  },
  {
    "codigo":444967008,
    "descripcion":"HIPOPLASIA DE HUESO MAXILAR"
  },
  {
    "codigo":49916007,
    "descripcion":"ÚLCERA DUODENAL CRÓNICA CON PERFORACIÓN"
  },
  {
    "codigo":211921004,
    "descripcion":"QUEMADURA DE TERCER GRADO DE PULGAR Y DEDO(S) DE LA MANO"
  },
  {
    "codigo":408529006,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: MALAYALAM"
  },
  {
    "codigo":80849007,
    "descripcion":"GIGANTISMO"
  },
  {
    "codigo":898214000,
    "descripcion":"SINOSTOSIS CONGÉNITA DE HUESO METACARPIANO CON FALANGE PRÓXIMA DE MANO"
  },
  {
    "codigo":210086001,
    "descripcion":"LESIÓN NO EXPUESTA DE BRONQUIO"
  },
  {
    "codigo":734374000,
    "descripcion":"TROMBOSIS DE ARTERIA CARÓTIDA IZQUIERDA"
  },
  {
    "codigo":111782004,
    "descripcion":"INTOXICACIÓN POR METRIFONATO"
  },
  {
    "codigo":10640831000119104,
    "descripcion":"OSTEONECROSIS DE PERONÉ DEBIDA A ÚLCERA CRÓNICA DE PANTORRILLA"
  },
  {
    "codigo":109947003,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LOS NERVIOS PERIFÉRICOS DEL TRONCO"
  },
  {
    "codigo":208251004,
    "descripcion":"FRACTURA EXPUESTA DE HÚMERO PROXIMAL, CUELLO ANATÓMICO"
  },
  {
    "codigo":318911000119105,
    "descripcion":"ARTRITIS REUMATOIDEA SEROPOSITIVA DE ARTICULACIÓN DE TOBILLO DERECHO"
  },
  {
    "codigo":271952001,
    "descripcion":"REACCIÓN DE ADAPTACIÓN Y ESTRÉS"
  },
  {
    "codigo":699771009,
    "descripcion":"LÍNEA DE LABIO SUPERIOR ALTA"
  },
  {
    "codigo":239184003,
    "descripcion":"INJERTO DE PIEL COLOCADO CON LA CARA SUPERIOR HACIA ABAJO"
  },
  {
    "codigo":9808005,
    "descripcion":"FRACTURA NO EXPUESTA DE HUESO CUBOIDES DEL PIE"
  },
  {
    "codigo":403024006,
    "descripcion":"TIÑA CORPORAL CAUSADA POR MICROSPORUM CANIS VARIANTE CANIS"
  },
  {
    "codigo":302885000,
    "descripcion":"COMPRESIÓN DE NERVIO INTERÓSEO ANTERIOR"
  },
  {
    "codigo":237349002,
    "descripcion":"DEPRESIÓN POSPARTO LEVE"
  },
  {
    "codigo":15693401000119101,
    "descripcion":"QUERATITIS DE OJO DERECHO CAUSADA POR NEISSERIA GONORRHOEAE"
  },
  {
    "codigo":1187621006,
    "descripcion":"ENFERMEDAD DE CHARCOT-MARIE-TOOTH TIPO 2 ASOCIADA AL GEN DNAJB2"
  },
  {
    "codigo":7973008,
    "descripcion":"VISIÓN ANORMAL"
  },
  {
    "codigo":366586002,
    "descripcion":"AMPLITUD DE MOVIMIENTO DE ARTICULACIÓN DE RODILLA - HALLAZGO"
  },
  {
    "codigo":202746003,
    "descripcion":"RESORCIÓN DE DISCO CERVICAL"
  },
  {
    "codigo":268282005,
    "descripcion":"ERITRODERMIA ICTIOSIFORME"
  },
  {
    "codigo":169978008,
    "descripcion":"ALIMENTADO ARTIFICIALMENTE A LOS 3 MESES"
  },
  {
    "codigo":299215001,
    "descripcion":"AMPUTADO POR DEBAJO DE CODO"
  },
  {
    "codigo":168143002,
    "descripcion":"ORGANISMO AISLADO EN CULTIVO DE HISOPADO DE HERIDA"
  },
  {
    "codigo":233679003,
    "descripcion":"ASMA DE COMIENZO TARDÍO"
  },
  {
    "codigo":364751004,
    "descripcion":"HALLAZGO RELACIONADO CON LA PROTRUSIÓN DE LA LENGUA"
  },
  {
    "codigo":102607009,
    "descripcion":"DESEO VEHEMENTE DE CARBOHIDRATOS"
  },
  {
    "codigo":723364003,
    "descripcion":"SÍNDROME DE HIPOTRICOSIS CON DEGENERACIÓN MACULAR JUVENIL"
  },
  {
    "codigo":788900007,
    "descripcion":"DEPENDENCIA DE CORAZÓN ARTIFICIAL"
  },
  {
    "codigo":231844007,
    "descripcion":"QUEMADURA DEL PUNTO LAGRIMAL"
  },
  {
    "codigo":721529002,
    "descripcion":"LESIÓN COMPLETA DE MÉDULA ESPINAL SACRA"
  },
  {
    "codigo":230009002,
    "descripcion":"POSICIÓN DEL TRONCO: ENCORVADA"
  },
  {
    "codigo":295545005,
    "descripcion":"SOBREDOSIS DE DESFLURANO"
  },
  {
    "codigo":328313007,
    "descripcion":"MALABSORCIÓN DE PROTEÍNAS"
  },
  {
    "codigo":262777009,
    "descripcion":"CONTUSIÓN DE GLÁNDULA PARATIROIDES"
  },
  {
    "codigo":293710003,
    "descripcion":"ALERGIA A METOHEXITAL"
  },
  {
    "codigo":195406003,
    "descripcion":"FLEBITIS DE VENA TIBIAL ANTERIOR"
  },
  {
    "codigo":347891000119103,
    "descripcion":"HEPATITIS C CRÓNICA CON FIBROSIS EN ESTADIO 3"
  },
  {
    "codigo":129870004,
    "descripcion":"BAJA AUTOESTIMA CRÓNICA"
  },
  {
    "codigo":29731002,
    "descripcion":"NEUMOTÓRAX TUBERCULOSO"
  },
  {
    "codigo":816163006,
    "descripcion":"PÉRDIDA DE VOLUMEN DE LÍQUIDO EXTRARRENAL"
  },
  {
    "codigo":717859007,
    "descripcion":"SÍNDROME DE HIDROCEFALIA, MALFORMACIÓN CARDÍACA, HUESO DENSO"
  },
  {
    "codigo":421112000,
    "descripcion":"PULSO DE MIEMBRO INFERIOR PRESENTE"
  },
  {
    "codigo":422947009,
    "descripcion":"CICATRIZ CORNEAL SUBEPITELIAL"
  },
  {
    "codigo":716024001,
    "descripcion":"SÍNDROME DE GONIODISGENESIA CON DISCAPACIDAD INTELECTUAL Y BAJA ESTATURA"
  },
  {
    "codigo":224504003,
    "descripcion":"ACUERDOS PARA EL CUIDADO INFORMAL CONVENIENTES"
  },
  {
    "codigo":191736004,
    "descripcion":"TRASTORNO OBSESIVO-COMPULSIVO"
  },
  {
    "codigo":93432008,
    "descripcion":"ASMA MEDICAMENTOSA"
  },
  {
    "codigo":124365001,
    "descripcion":"DEFICIENCIA DE MALONATO COA - TRANSFERASA"
  },
  {
    "codigo":26061003,
    "descripcion":"AUSENCIA CONGÉNITA DE CONDUCTO AUDITIVO EXTERNO"
  },
  {
    "codigo":1085171000119108,
    "descripcion":"HEMORRAGIA RECTAL DEBIDA A PANCOLITIS ULCEROSA CRÓNICA"
  },
  {
    "codigo":714189008,
    "descripcion":"PERSONA TRANSEXUAL DE GÉNERO FEMENINO A MASCULINO EN TRATAMIENTO HORMONAL"
  },
  {
    "codigo":253602000,
    "descripcion":"FUSIÓN COMISURAL DE VÁLVULA AÓRTICA"
  },
  {
    "codigo":286370002,
    "descripcion":"HABLA"
  },
  {
    "codigo":284535003,
    "descripcion":"ENFERMEDAD DIVERTICULAR DE HEMICOLON IZQUIERDO"
  },
  {
    "codigo":251767007,
    "descripcion":"SUPERPOSICIÓN"
  },
  {
    "codigo":282700001,
    "descripcion":"DIFICULTAD PARA EMPUJAR Y ARRASTRAR HACIA ATRÁS UN JUGUETE GRANDE CON RUEDAS"
  },
  {
    "codigo":86092005,
    "descripcion":"FIBROSIS QUÍSTICA CON ÍLEO MECONIAL"
  },
  {
    "codigo":315468005,
    "descripcion":"NACIDO EN LITUANIA"
  },
  {
    "codigo":249932008,
    "descripcion":"DEBILIDAD FACIAL INFERIOR"
  },
  {
    "codigo":311859005,
    "descripcion":"FRACTURAS EXPUESTAS QUE COMPROMETEN REGIONES MÚLTIPLES DE EXTREMIDADES SUPERIORES E INFERIORES"
  },
  {
    "codigo":248097008,
    "descripcion":"SENTIMIENTO ERÓTICO"
  },
  {
    "codigo":279030006,
    "descripcion":"SÍNDROME DE DOLOR MIOFASCIAL DEL CUELLO"
  },
  {
    "codigo":311798009,
    "descripcion":"ANEURISMA ROTO DE LA ARTERIA POPLÍTEA"
  },
  {
    "codigo":703179007,
    "descripcion":"ENDOCARDITIS DE PRÓTESIS DE VÁLVULA MITRAL"
  },
  {
    "codigo":211659009,
    "descripcion":"QUEMADURA DE PÁRPADO POR SUSTANCIAS QUÍMICAS"
  },
  {
    "codigo":275360003,
    "descripcion":"ICTERICIA NEONATAL DEBIDA A DEFICIENCIA DEL SISTEMA ENZIMÁTICO DE CONJUGACIÓN DE BILIRRUBINA"
  },
  {
    "codigo":373664004,
    "descripcion":"EXIGENTE PARA COMER"
  },
  {
    "codigo":439200003,
    "descripcion":"SE DUDA SI LA INVITACIÓN PARA EL CRIBADO SE ENVIÓ A LA DIRECCIÓN CORRECTA"
  },
  {
    "codigo":678081000119100,
    "descripcion":"HEMORRAGIA SUBRETINIANA DE OJO IZQUIERDO"
  },
  {
    "codigo":111520007,
    "descripcion":"ÚLCERA CORNEAL EN ANILLO"
  },
  {
    "codigo":240757002,
    "descripcion":"RINOSPORIDIOSIS DISEMINADA"
  },
  {
    "codigo":109685003,
    "descripcion":"HIPOPLASIA ALVEOLAR MAXILAR"
  },
  {
    "codigo":765045003,
    "descripcion":"PARAPLEJÍA ESPÁSTICA AUTOSÓMICA RECESIVA TIPO 62"
  },
  {
    "codigo":11381005,
    "descripcion":"ACNÉ"
  },
  {
    "codigo":238922006,
    "descripcion":"TRASTORNO DEL CUERO CABELLUDO"
  },
  {
    "codigo":402762007,
    "descripcion":"LESIÓN CUTÁNEA ASOCIADA CON HEMODIÁLISIS"
  },
  {
    "codigo":271690009,
    "descripcion":"SANGRE EN EL ORIFICIO EXTERNO DEL CUELLO UTERINO"
  },
  {
    "codigo":237087004,
    "descripcion":"ÚLCERA TRÓFICA DE CUELLO UTERINO"
  },
  {
    "codigo":1285663005,
    "descripcion":"ENFERMEDAD MODERADA POR DEFICIENCIA HEREDITARIA DE FACTOR IX CON INHIBIDOR DE ALTA RESPUESTA"
  },
  {
    "codigo":204319006,
    "descripcion":"SÍNDROME DE LUTEMBACHER"
  },
  {
    "codigo":5876000,
    "descripcion":"PANCITOPENIA ADQUIRIDA"
  },
  {
    "codigo":106015009,
    "descripcion":"TRASTORNO MENTAL Y\/O SÍNDROME RELACIONADO CON EL MEDIO CULTURAL"
  },
  {
    "codigo":1187359009,
    "descripcion":"LORDOESCOLIOSIS CONGÉNITA DE COLUMNA"
  },
  {
    "codigo":300788000,
    "descripcion":"INICIA JUEGOS ESPONTÁNEAMENTE"
  },
  {
    "codigo":202484005,
    "descripcion":"DOLOR DE ARTICULACIÓN INTERFALÁNGICA PROXIMAL DE DEDO DE MANO"
  },
  {
    "codigo":10836161000119106,
    "descripcion":"HIPERPLASIA LOBAR ATÍPICA DE MAMA DERECHA"
  },
  {
    "codigo":726772006,
    "descripcion":"DEPRESIÓN MAYOR CON CARACTERÍSTICAS PSICÓTICAS"
  },
  {
    "codigo":724937003,
    "descripcion":"LACERACIÓN DE TENDÓN DE TRÍCEPS BRAQUIAL"
  },
  {
    "codigo":200649005,
    "descripcion":"CELULITIS Y ABSCESO DE LA REGIÓN SUBMANDIBULAR"
  },
  {
    "codigo":167881006,
    "descripcion":"LÍQUIDO SINOVIAL: AMARILLO"
  },
  {
    "codigo":4041005,
    "descripcion":"ANOMALÍA CONGÉNITA DE LA MÁCULA"
  },
  {
    "codigo":69577009,
    "descripcion":"CECEO"
  },
  {
    "codigo":428190001,
    "descripcion":"VEJIGA URINARIA NEUROGÉNICA DEBIDA A ESPINA BÍFIDA"
  },
  {
    "codigo":723102007,
    "descripcion":"ÚLCERA GÁSTRICA CAUSADA POR INFECCIÓN PARASITARIA"
  },
  {
    "codigo":721267000,
    "descripcion":"INFECCIÓN PIÓGENA DE PIEL Y TEJIDOS SUBCUTÁNEOS CAUSADA POR BACTERIA"
  },
  {
    "codigo":460958007,
    "descripcion":"ORIGEN ANÓMALO DE LIGAMENTO ARTERIOSO EN CAYADO AÓRTICO"
  },
  {
    "codigo":229747003,
    "descripcion":"DISFASIA DEL DESARROLLO"
  },
  {
    "codigo":295283005,
    "descripcion":"SOBREDOSIS DE OXIFENBUTAZONA"
  },
  {
    "codigo":719432000,
    "descripcion":"EPIDERMÓLISIS BULLOSA DE LA ZONA DE UNIÓN DE COMIENZO TARDÍO"
  },
  {
    "codigo":64072006,
    "descripcion":"PANCARDITIS REUMÁTICA AGUDA"
  },
  {
    "codigo":293448007,
    "descripcion":"REACCIÓN ADVERSA A LOS ANTIARRÍTMICOS DE CLASE II"
  },
  {
    "codigo":129608008,
    "descripcion":"DEGENERACIÓN PIRAMIDOPALIDAL PROGRESIVA"
  },
  {
    "codigo":226077000,
    "descripcion":"DIETA TERAPÉUTICA"
  },
  {
    "codigo":291613002,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR CEFODIZIMA"
  },
  {
    "codigo":95005005,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA PLACENTA"
  },
  {
    "codigo":420850000,
    "descripcion":"RECUENTO DE DEDOS COMPLETO EN EL CAMPO VISUAL POR CONFRONTACIÓN"
  },
  {
    "codigo":20915006,
    "descripcion":"DISPLASIA GÁSTRICA"
  },
  {
    "codigo":1010674008,
    "descripcion":"CARCINOMA ESCAMOSO BASALOIDE DE NASOFARINGE"
  },
  {
    "codigo":255175001,
    "descripcion":"PAPILOMA DE LA AMPOLLA DE VATER"
  },
  {
    "codigo":289778008,
    "descripcion":"CUELLO UTERINO RÍGIDO"
  },
  {
    "codigo":91335003,
    "descripcion":"TROMBO CARDÍACO PARIETAL"
  },
  {
    "codigo":1172679008,
    "descripcion":"METAHEMOGLOBINA DENTRO DE RANGO DE REFERENCIA"
  },
  {
    "codigo":286108000,
    "descripcion":"NO LUSTRA"
  },
  {
    "codigo":417180005,
    "descripcion":"ARTRITIS INFLAMATORIA INDIFERENCIADA"
  },
  {
    "codigo":187804005,
    "descripcion":"NEOPLASIA MALIGNA DE TEJIDO RETROCECAL"
  },
  {
    "codigo":185969000,
    "descripcion":"PACIENTE EN ESPERA DE TURNO PARA EL DEPARTAMENTO DE ATENCIÓN AMBULATORIA"
  },
  {
    "codigo":253340009,
    "descripcion":"VÁLVULA PROMINENTE DE VENA CAVA INFERIOR"
  },
  {
    "codigo":284273000,
    "descripcion":"NO UTILIZA PRENSIÓN CON PINZA"
  },
  {
    "codigo":352911000119101,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE NERVIO ÓPTICO IZQUIERDO"
  },
  {
    "codigo":251505004,
    "descripcion":"PUNTA-ONDA FOCAL EPISÓDICA CON GENERALIZACIÓN SECUNDARIA"
  },
  {
    "codigo":415345001,
    "descripcion":"TUBERCULOSIS RESISTENTE A LA RIFAMPICINA"
  },
  {
    "codigo":1201777007,
    "descripcion":"AUSENCIA CONGÉNITA COMPLETA DE MIEMBRO INFERIOR IZQUIERDO"
  },
  {
    "codigo":87665008,
    "descripcion":"OTITIS MEDIA CRÓNICA TUBOTIMPÁNICA SUPURATIVA"
  },
  {
    "codigo":448113007,
    "descripcion":"VENA CAVA SUPERIOR DERECHA CONECTADA A SENO CORONARIO"
  },
  {
    "codigo":16845301000119108,
    "descripcion":"GLIOBLASTOMA MULTIFORME PRIMARIO DE CEREBELO"
  },
  {
    "codigo":282438003,
    "descripcion":"AVULSIÓN DEL PÁNCREAS"
  },
  {
    "codigo":1090191000119103,
    "descripcion":"EDENTULISMO PARCIAL CLASE IV DEBIDO A TRAUMATISMO"
  },
  {
    "codigo":249670005,
    "descripcion":"TÓRAX CORTO"
  },
  {
    "codigo":184134007,
    "descripcion":"ES CUESTIONABLE SI LA OCUPACIÓN DEL PACIENTE ES CORRECTA"
  },
  {
    "codigo":247835002,
    "descripcion":"MIEDO A HABLAR EN PÚBLICO"
  },
  {
    "codigo":680591000119104,
    "descripcion":"MEIBOMIANITIS DE OJO IZQUIERDO"
  },
  {
    "codigo":1263643007,
    "descripcion":"METÁSTASIS DE CARCINOMA DE CÉLULAS TRANSICIONALES EN RIÑÓN DERECHO"
  },
  {
    "codigo":1163504003,
    "descripcion":"INFECCIÓN POR MYCOPLASMA GENITALIUM"
  },
  {
    "codigo":15999631000119107,
    "descripcion":"CUERPO EXTRAÑO RETENIDO EN CÁMARA ANTERIOR DE OJO DERECHO"
  },
  {
    "codigo":735685003,
    "descripcion":"TAQUICARDIA RECÍPROCA DE LA UNIÓN AURICULOVENTRICULAR"
  },
  {
    "codigo":80325004,
    "descripcion":"ORIFICIO UTERINO PUNTIFORME"
  },
  {
    "codigo":78490005,
    "descripcion":"FRACTURA EXPUESTA DEL EXTREMO PROXIMAL DEL CÚBITO"
  },
  {
    "codigo":373402008,
    "descripcion":"INVASIÓN TUMORAL DE VASOS SANGUÍNEOS\/LINFÁTICOS (MAMA)"
  },
  {
    "codigo":109423001,
    "descripcion":"HUESO NAVICULAR ACCESORIO"
  },
  {
    "codigo":43887004,
    "descripcion":"FÍSTULA POSTAURICULAR"
  },
  {
    "codigo":764783004,
    "descripcion":"TRASTORNO DE SUFRIMIENTO CORPORAL LEVE"
  },
  {
    "codigo":1354607008,
    "descripcion":"FRACTURA DE FALANGE PROXIMAL DE MEÑIQUE"
  },
  {
    "codigo":74820003,
    "descripcion":"COXA VARA CONGÉNITA"
  },
  {
    "codigo":238660004,
    "descripcion":"LIQUEN PLANO MUTILANTE DE DEDOS DE LA MANO Y DEL PIE"
  },
  {
    "codigo":271428004,
    "descripcion":"TRASTORNO ESQUIZOAFECTIVO, TIPO MANÍACO"
  },
  {
    "codigo":15727401000119106,
    "descripcion":"ARTROFITO BILATERAL DE TOBILLOS"
  },
  {
    "codigo":369732007,
    "descripcion":"INVASIÓN TUMORAL DE VENA DE GRAN CALIBRE PRESENTE"
  },
  {
    "codigo":304196007,
    "descripcion":"SIN AMPLITUD ACTIVA DE FLEXIÓN HORIZONTAL DE HOMBRO"
  },
  {
    "codigo":42052009,
    "descripcion":"ONFALITIS DEL RECIÉN NACIDO"
  },
  {
    "codigo":402500004,
    "descripcion":"CARCINOMA BASOCELULAR DEL ALA NASAL"
  },
  {
    "codigo":16438211000119101,
    "descripcion":"SÍNDROME DE DOLOR LOCALIZADO EN AMBOS TROCÁNTERES MAYORES"
  },
  {
    "codigo":7449006,
    "descripcion":"LESIÓN TRAUMÁTICA DEL NERVIO FEMORAL"
  },
  {
    "codigo":300526001,
    "descripcion":"HALLAZGO RELACIONADO CON LA EYACULACIÓN"
  },
  {
    "codigo":366062008,
    "descripcion":"REACCIÓN GENERAL A LA LUZ - HALLAZGO"
  },
  {
    "codigo":202222009,
    "descripcion":"LUXACIÓN RECURRENTE DE CODO"
  },
  {
    "codigo":890350009,
    "descripcion":"CATARATA CORALIFORME"
  },
  {
    "codigo":724675001,
    "descripcion":"TRASTORNO PSICÓTICO CAUSADO POR ANSIOLÍTICO"
  },
  {
    "codigo":36547009,
    "descripcion":"POSICIÓN OCCIPITOILÍACA DERECHA POSTERIOR"
  },
  {
    "codigo":427928003,
    "descripcion":"TRASTORNO RELACIONADO CON TRASPLANTE PULMONAR"
  },
  {
    "codigo":722840003,
    "descripcion":"NIÑO PREMATURO EN EL MOMENTO DEL PARTO, DE 23 SEMANAS COMPLETAS"
  },
  {
    "codigo":296856006,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE ACETOHEXAMIDA"
  },
  {
    "codigo":295021003,
    "descripcion":"ALERGIA A MERSALIL"
  },
  {
    "codigo":65645005,
    "descripcion":"PRURITO ESCROTAL"
  },
  {
    "codigo":109006,
    "descripcion":"TRASTORNO DE ANSIEDAD DE LA NIÑEZ O LA ADOLESCENCIA"
  },
  {
    "codigo":131181005,
    "descripcion":"TIPO LEACH"
  },
  {
    "codigo":1343597009,
    "descripcion":"BATOFOBIA"
  },
  {
    "codigo":63810002,
    "descripcion":"OSTEORRADIONECROSIS DE MANDÍBULA"
  },
  {
    "codigo":1145154009,
    "descripcion":"INTOXICACIÓN CAUSADA POR AGONISTA DE RECEPTOR DE CANABINOIDE"
  },
  {
    "codigo":94743005,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL VÉRTICE VESICAL"
  },
  {
    "codigo":422423006,
    "descripcion":"BARRERAS CULTURALES LIMITAN LA CAPACIDAD PARA UTILIZAR LOS RECURSOS COMUNITARIOS"
  },
  {
    "codigo":225815007,
    "descripcion":"NO INVOLUCRADO EN EL MANEJO DE SU PROPIO DINERO"
  },
  {
    "codigo":717335009,
    "descripcion":"SÍNDROME DE TRISOMÍA 8 EN MOSAICO"
  },
  {
    "codigo":191212002,
    "descripcion":"ANEMIA HEMOLÍTICA SECUNDARIA POR ANTICUERPOS FRÍOS"
  },
  {
    "codigo":92908003,
    "descripcion":"FORMA ANORMAL CONGÉNITA DE HUESO EXOCCIPITAL"
  },
  {
    "codigo":60140004,
    "descripcion":"POLIARTRITIS INFECCIOSA SUBAGUDA"
  },
  {
    "codigo":289516001,
    "descripcion":"HALLAZGO RELACIONADO CON LA POSICIÓN ANATÓMICA DE LA VAGINA"
  },
  {
    "codigo":16057591000119100,
    "descripcion":"PARÁLISIS FACIAL IZQUIERDA GRADO V DE HOUSE-BRACKMANN"
  },
  {
    "codigo":1208855009,
    "descripcion":"TROMBOEMBOLISMO POR TROMBO MURAL"
  },
  {
    "codigo":291351009,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR GUAIFENESINA"
  },
  {
    "codigo":123841004,
    "descripcion":"NEOPLASIA DEL CUELLO UTERINO"
  },
  {
    "codigo":254913005,
    "descripcion":"NEOPLASIA DEL TRACTO URINARIO PROPIAMENTE DICHO"
  },
  {
    "codigo":658031000005101,
    "descripcion":"PLACENTA DE UBICACIÓN BAJA EN PARED POSTERIOR DEL ÚTERO"
  },
  {
    "codigo":285846001,
    "descripcion":"EMOCIONALMENTE FRÍO"
  },
  {
    "codigo":89238002,
    "descripcion":"PROTEINURIA VERDADERA"
  },
  {
    "codigo":21867001,
    "descripcion":"FRACTURA DE EXTREMO SUPERIOR DE PERONÉ"
  },
  {
    "codigo":709995004,
    "descripcion":"ESQUEMA OCLUSAL PARCIALMENTE DENTADO SUSTANCIALMENTE COMPROMETIDO"
  },
  {
    "codigo":218475006,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR HORMONAS DE LA NEUROHIPÓFISIS"
  },
  {
    "codigo":29971000175102,
    "descripcion":"ÚLCERA POR PRESIÓN EN DORSO DE PIE DERECHO, ESTADIO I"
  },
  {
    "codigo":85568000,
    "descripcion":"BOCIO ESPORÁDICO"
  },
  {
    "codigo":235059009,
    "descripcion":"INFECCIÓN DE LA MUCOSA BUCAL POR HERPES ZÓSTER"
  },
  {
    "codigo":282176002,
    "descripcion":"NO BAJA UNA COLINA"
  },
  {
    "codigo":314944001,
    "descripcion":"VACIAMIENTO GÁSTRICO TARDÍO"
  },
  {
    "codigo":447851008,
    "descripcion":"FÍSTULA TRAQUEOESOFÁGICA CONGÉNITA CON ESTENOSIS ESOFÁGICA"
  },
  {
    "codigo":216640006,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ALCOHOL METÍLICO"
  },
  {
    "codigo":249408007,
    "descripcion":"DEPÓSITOS ALIMENTARIOS EN LA MUCOSA ORAL"
  },
  {
    "codigo":18197001,
    "descripcion":"SIBILANCIA ASMATOIDE"
  },
  {
    "codigo":313109005,
    "descripcion":"SOLICITUD DE LICENCIA DE CONDUCIR FIRMADA"
  },
  {
    "codigo":49130001,
    "descripcion":"TRASTORNO DEL OÍDO EXTERNO"
  },
  {
    "codigo":737258003,
    "descripcion":"LESIÓN TRAUMÁTICA DE TENDÓN DE ABDOMEN"
  },
  {
    "codigo":1359850004,
    "descripcion":"CARCINOMA IN SITU DE BERMELLÓN DE LABIO"
  },
  {
    "codigo":278506006,
    "descripcion":"ESTADO PARANOIDE INVOLUTIVO"
  },
  {
    "codigo":81898007,
    "descripcion":"RITMO DE ESCAPE VENTRICULAR"
  },
  {
    "codigo":276671000,
    "descripcion":"PALUDISMO CONGÉNITO POR PLASMODIUM FALCIPARUM"
  },
  {
    "codigo":735423001,
    "descripcion":"DEFICIENCIA DE ADENOSINTRIFOSFATASA CÁLCICA 1 DE RETÍCULO SARCOPLÁSMICO"
  },
  {
    "codigo":14527007,
    "descripcion":"EMPIEMA TUBERCULOSO"
  },
  {
    "codigo":47295007,
    "descripcion":"AGITACIÓN PSICOMOTRIZ"
  },
  {
    "codigo":1259711008,
    "descripcion":"CARCINOMA UROTELIAL PRIMARIO DE TRACTO URINARIO SUPERIOR"
  },
  {
    "codigo":15703441000119106,
    "descripcion":"DEDO DE LA MANO EN GATILLO ADQUIRIDO, AMBOS DEDOS MEÑIQUES"
  },
  {
    "codigo":10857000,
    "descripcion":"RUIDO CAROTÍDEO SUBJETIVO"
  },
  {
    "codigo":307604008,
    "descripcion":"NEFROMA MESOBLÁSTICO"
  },
  {
    "codigo":764521002,
    "descripcion":"DOBLE CAYADO AÓRTICO CIRCULAR"
  },
  {
    "codigo":76393003,
    "descripcion":"ÚLCERA SERPIGINOSA"
  },
  {
    "codigo":685611000119101,
    "descripcion":"LEIOMIOSARCOMA PRIMARIO DE CARA"
  },
  {
    "codigo":830057003,
    "descripcion":"LINFOMA DE HODGKIN CLÁSICO RECIDIVANTE"
  },
  {
    "codigo":305769005,
    "descripcion":"VISTO POR TÉCNICO DE AUDIOLOGÍA"
  },
  {
    "codigo":759291281000119108,
    "descripcion":"HEMATOMA SUBDURAL INTRACRANEAL NO TRAUMÁTICO AGUDO"
  },
  {
    "codigo":402238001,
    "descripcion":"LIQUENIFICACIÓN GUIJARROSA"
  },
  {
    "codigo":404073009,
    "descripcion":"LIPOSARCOMA FUSOCELULAR"
  },
  {
    "codigo":369470005,
    "descripcion":"TUMOR MALIGNO QUE COMPROMETE VEJIGA URINARIA POR PROPAGACIÓN DIRECTA DESDE TROMPA DE FALOPIO"
  },
  {
    "codigo":271166007,
    "descripcion":"AMPOLLA TRAUMÁTICA DEL ANTEBRAZO, INFECTADA"
  },
  {
    "codigo":238398008,
    "descripcion":"CELULITIS DE LA PALMA DE LA MANO"
  },
  {
    "codigo":205630009,
    "descripcion":"DELECIÓN DEL BRAZO LARGO DEL CROMOSOMA 13"
  },
  {
    "codigo":1186835003,
    "descripcion":"INSUFICIENCIA HIPOFISARIA DEBIDA A TRASTORNO CARACTERIZADO POR GRANULOMA"
  },
  {
    "codigo":105491004,
    "descripcion":"INSATISFACCIÓN LABORAL"
  },
  {
    "codigo":236563004,
    "descripcion":"MIGRACIÓN DEL CATÉTER DE DIÁLISIS PERITONEAL"
  },
  {
    "codigo":44111000087102,
    "descripcion":"HERIDA CORTANTE DE MIEMBRO INFERIOR DERECHO"
  },
  {
    "codigo":38991000087100,
    "descripcion":"ABRASIÓN DE PIEL DE MIEMBRO INFERIOR DERECHO"
  },
  {
    "codigo":726248000,
    "descripcion":"LESIÓN TRAUMÁTICA DE BOLSA SEROSA DE PIERNA"
  },
  {
    "codigo":33871000087104,
    "descripcion":"STREPTOCOCCUS DYSGALACTIAE DEL GRUPO C DE LANCEFIELD O STREPTOCOCCUS DYSGALACTIAE DEL GRUPO G DE LANCEFIELD"
  },
  {
    "codigo":890088002,
    "descripcion":"TRASTORNO DEL DESARROLLO SEXUAL 46,XX CAUSADO POR TESTOSTERONA Y\/O DERIVADO DE TESTOSTERONA"
  },
  {
    "codigo":300264003,
    "descripcion":"HALLAZGO RELACIONADO CON LA SALIVA"
  },
  {
    "codigo":41551000087107,
    "descripcion":"HERIDA PUNZANTE DE PARED ANTERIOR DE TÓRAX"
  },
  {
    "codigo":46671000087108,
    "descripcion":"FRACTURA DE FALANGE DISTAL DE DEDO ANULAR IZQUIERDO"
  },
  {
    "codigo":201960006,
    "descripcion":"ARTROPATÍA TRAUMÁTICA DE ARTICULACIÓN INTERFALÁNGICA DE DEDO DEL PIE"
  },
  {
    "codigo":365800006,
    "descripcion":"PERFIL ELECTROFORÉTICO DE PROTEÍNAS EN EL LÍQUIDO CEFALORRAQUÍDEO - HALLAZGO"
  },
  {
    "codigo":200125006,
    "descripcion":"INFECCIÓN DE HERIDA QUIRÚRGICA OBSTÉTRICA"
  },
  {
    "codigo":298429006,
    "descripcion":"AMPLITUD DE FLEXIÓN LATERAL ACTIVA HACIA LA DERECHA DE LA COLUMNA VERTEBRAL CERVICAL, NORMAL"
  },
  {
    "codigo":296594001,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE ESTREPTOMICINA"
  },
  {
    "codigo":722578005,
    "descripcion":"HEMORRAGIA DE GLÁNDULA SUPRARRENAL DEBIDA A TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":1682008,
    "descripcion":"TRASTORNO METABÓLICO TRANSITORIO DE AMINOÁCIDOS"
  },
  {
    "codigo":1179495001,
    "descripcion":"REACCIÓN ADVERSA A LA VACUNA QUE CONTIENE ANTÍGENO DE PARTÍCULAS PSEUDOVIRALES DEL VIRUS DE LA COVID-19"
  },
  {
    "codigo":425831002,
    "descripcion":"DOLOR CARACTERIZADO POR UN FACTOR ALIVIADOR"
  },
  {
    "codigo":165522008,
    "descripcion":"RECUENTO DE EOSINÓFILOS DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1279634009,
    "descripcion":"HERIDA CORTANTE DE PIEL DE DEDO MEÑIQUE IZQUIERDO"
  },
  {
    "codigo":32615007,
    "descripcion":"SOPLO DE AUSTIN FLINT"
  },
  {
    "codigo":292924000,
    "descripcion":"REACCIÓN ADVERSA A LA NETILMICINA"
  },
  {
    "codigo":1144892000,
    "descripcion":"ESCASEZ CONGÉNITA DE VÍAS BILIARES INTRAHEPÁTICAS"
  },
  {
    "codigo":718908009,
    "descripcion":"DISCAPACIDAD INTELECTUAL LIGADA AL CROMOSOMA X TIPO SIDERIUS"
  },
  {
    "codigo":94481001,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL PENE"
  },
  {
    "codigo":761521000000107,
    "descripcion":"CAPAZ DE USAR COMPUTADORA PERSONAL"
  },
  {
    "codigo":141151000119101,
    "descripcion":"HEMATOMA SUBDURAL NO TRAUMÁTICO CON COMPRESIÓN DE CEREBRO"
  },
  {
    "codigo":28945005,
    "descripcion":"ÚLCERA PÉPTICA AGUDA CON HEMORRAGIA, PERFORACIÓN Y OBSTRUCCIÓN"
  },
  {
    "codigo":291089006,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR DIAZEPAM"
  },
  {
    "codigo":225553008,
    "descripcion":"DEHISCENCIA DE HERIDA"
  },
  {
    "codigo":127249009,
    "descripcion":"NEOPLASIA DE LOS GANGLIOS LINFÁTICOS INTERCOSTALES"
  },
  {
    "codigo":289254002,
    "descripcion":"EXPULSIÓN DE DISPOSITIVO INTRAUTERINO DURANTE LA TERCERA ETAPA DEL TRABAJO DE PARTO"
  },
  {
    "codigo":59878005,
    "descripcion":"FACTOR SOCIAL RELACIONADO CON LA OCUPACIÓN"
  },
  {
    "codigo":715238005,
    "descripcion":"CON MAYOR RIESGO DE DESEQUILIBRIO ELECTROLÍTICO"
  },
  {
    "codigo":10626911000119104,
    "descripcion":"FORÚNCULO DE CADERA DERECHA"
  },
  {
    "codigo":254651007,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS DE LA PIEL"
  },
  {
    "codigo":1137552000,
    "descripcion":"CICATRIZ DE POLO POSTERIOR DE LA RETINA DEL OJO IZQUIERDO"
  },
  {
    "codigo":1335995008,
    "descripcion":"CARCINOMA DE CÉLULAS DE MERKEL PRIMARIO DE PIEL DE CADERA"
  },
  {
    "codigo":414821002,
    "descripcion":"CANDIDIASIS NEONATAL"
  },
  {
    "codigo":283749002,
    "descripcion":"MORDEDURA DE PERRO EN LA AXILA"
  },
  {
    "codigo":16908281000119101,
    "descripcion":"CARCINOMA ESCAMOCELULAR IN SITU DE PIEL DE PÁRPADO INFERIOR DERECHO"
  },
  {
    "codigo":185445005,
    "descripcion":"INFORME DE ESTUDIO RADIOISOTÓPICO RECIBIDO"
  },
  {
    "codigo":314682006,
    "descripcion":"PESO DEL NIÑO: PERCENTILO 91"
  },
  {
    "codigo":249146007,
    "descripcion":"SEGMENTOS DEL ÚTERO DISTINGUIBLES DURANTE EL PARTO"
  },
  {
    "codigo":609594008,
    "descripcion":"LESIÓN DE RAMA DE NERVIO CUBITAL"
  },
  {
    "codigo":281914007,
    "descripcion":"FRACTURA POR ESTALLIDO DE VÉRTEBRA CERVICAL"
  },
  {
    "codigo":15679481000119104,
    "descripcion":"IRITIS DE OJO DERECHO CAUSADA POR TREPONEMA PALLIDUM"
  },
  {
    "codigo":443919007,
    "descripcion":"TRASTORNO DE ESTRÉS POSTRAUMÁTICO COMPLEJO"
  },
  {
    "codigo":312847008,
    "descripcion":"LESIÓN MUSCULOTENDINOSA"
  },
  {
    "codigo":17935009,
    "descripcion":"MIOSITIS MAXILAR"
  },
  {
    "codigo":688121000119105,
    "descripcion":"NEURILEMOMA DE NERVIO DEL TÓRAX"
  },
  {
    "codigo":442084003,
    "descripcion":"VÍCTIMA DE VIOLENCIA FÍSICA"
  },
  {
    "codigo":48868008,
    "descripcion":"VENAS VARICOSAS DE VULVA"
  },
  {
    "codigo":79801002,
    "descripcion":"ANGIOMATOSIS LEPTOMENÍNGEA CONGÉNITA"
  },
  {
    "codigo":702393003,
    "descripcion":"DEMENCIA FRONTOTEMPORAL ASOCIADA CON MUTACIÓN GENÉTICA EN 3P11"
  },
  {
    "codigo":1357753002,
    "descripcion":"ENFERMEDAD TIROIDEA ASOCIADA A INMUNOGLOBULINA G4"
  },
  {
    "codigo":276409005,
    "descripcion":"MUCOSIDAD EN ORINA"
  },
  {
    "codigo":47033005,
    "descripcion":"FUNCIÓN RENAL AUMENTADA"
  },
  {
    "codigo":333971000119101,
    "descripcion":"MEMBRANA EPIRRETINIANA DE OJO DERECHO"
  },
  {
    "codigo":1259449008,
    "descripcion":"CARCINOSARCOMA PRIMARIO DE ÚTERO"
  },
  {
    "codigo":241806001,
    "descripcion":"ENVENENAMIENTO CAUSADO POR VENENO DE VÍBORA SOPLADORA"
  },
  {
    "codigo":12430003,
    "descripcion":"FORÚNCULO DE NALGA"
  },
  {
    "codigo":307342006,
    "descripcion":"TROMBOCITOPENIA POR TRANSFUSIÓN SANGUÍNEA MASIVA"
  },
  {
    "codigo":733326007,
    "descripcion":"TELANGIECTASIA DE MÁCULA LÚTEA"
  },
  {
    "codigo":895331006,
    "descripcion":"CURVATURA ANORMAL DE FALANGE MEDIA DE DEDO ANULAR"
  },
  {
    "codigo":371043007,
    "descripcion":"LESIÓN POR INHALACIÓN TÓXICA"
  },
  {
    "codigo":239971008,
    "descripcion":"QUISTE SINOVIAL DE CODO"
  },
  {
    "codigo":205368001,
    "descripcion":"DUPLICACIÓN DE HUESO DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":238136002,
    "descripcion":"OBESIDAD MÓRBIDA"
  },
  {
    "codigo":403811007,
    "descripcion":"SEUDOXANTOMA ELÁSTICO AUTOSÓMICO DOMINANTE"
  },
  {
    "codigo":43363007,
    "descripcion":"UVEÍTIS POSTERIOR"
  },
  {
    "codigo":10901651000119106,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO ACÚSTICO DERECHO"
  },
  {
    "codigo":16636051000119105,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE ESTROMA GASTROINTESTINAL, DE COLON"
  },
  {
    "codigo":305507007,
    "descripcion":"BAJO ATENCIÓN DE BIOQUÍMICO CLÍNICO"
  },
  {
    "codigo":303672007,
    "descripcion":"INFECCIÓN CAUSADA POR PHYSALOPTERA CAUCASICA"
  },
  {
    "codigo":1155640009,
    "descripcion":"HUESO SUPERNUMERARIO DE PIE"
  },
  {
    "codigo":2471000124106,
    "descripcion":"SEGUNDO PREMOLAR INFERIOR IZQUIERDO PERMANENTE SUPERNUMERARIO"
  },
  {
    "codigo":39693003,
    "descripcion":"MIOCARDIOPATÍA DILATADA DEBIDA A GRANULOMA"
  },
  {
    "codigo":367373003,
    "descripcion":"FOLICULITIS NODULAR"
  },
  {
    "codigo":170765005,
    "descripcion":"HIPERGLUCEMIA CRÓNICA"
  },
  {
    "codigo":203533003,
    "descripcion":"PIE PLANO ESPÁSTICO PERONEO"
  },
  {
    "codigo":269069004,
    "descripcion":"FRACTURA NO EXPUESTA DE LA SÉPTIMA VÉRTEBRA CERVICAL"
  },
  {
    "codigo":15954221000119102,
    "descripcion":"DISPLASIA MAMARIA BENIGNA DE AMBAS MAMAS"
  },
  {
    "codigo":365538000,
    "descripcion":"INSTALACIONES DE ÁREAS DE DESCANSO EN EL ÁMBITO LABORAL - HALLAZGO"
  },
  {
    "codigo":5090003,
    "descripcion":"MANIERISMO"
  },
  {
    "codigo":234466008,
    "descripcion":"TRASTORNO ADQUIRIDO DE LA COAGULACIÓN"
  },
  {
    "codigo":201698009,
    "descripcion":"HEXADACTILIA"
  },
  {
    "codigo":429239002,
    "descripcion":"ALERGIA A ANTIBIÓTICO SULFONAMÍDICO"
  },
  {
    "codigo":298167002,
    "descripcion":"INFLAMACIÓN DE ARTICULACIÓN DE DEDO DE MANO"
  },
  {
    "codigo":396471004,
    "descripcion":"MARGEN QUIRÚRGICO DE VÍAS BILIARES COMPROMETIDO POR NEOPLASIA MALIGNA"
  },
  {
    "codigo":296332004,
    "descripcion":"DEFICIENCIA ADQUIRIDA DE LA RESERVA DE PLAQUETAS"
  },
  {
    "codigo":230796005,
    "descripcion":"COMA HIPOGLUCÉMICO NO DIABÉTICO"
  },
  {
    "codigo":427404005,
    "descripcion":"DERMATITIS DE CONDUCTO AUDITIVO EXTERNO"
  },
  {
    "codigo":1344908008,
    "descripcion":"MELANOMA MALIGNO PRIMARIO DE MEMBRANA MUCOSA ORAL"
  },
  {
    "codigo":292662000,
    "descripcion":"REACCIÓN ADVERSA AL NITRATO DE PLATA"
  },
  {
    "codigo":294497009,
    "descripcion":"ALERGIA A FENOXIMETILPENICILINA"
  },
  {
    "codigo":61451000,
    "descripcion":"GALACTOSEMIA CLÁSICA, HOMOCIGOTA TIPO NEGRO"
  },
  {
    "codigo":290827002,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR DOSULEPINA"
  },
  {
    "codigo":16009671000119104,
    "descripcion":"TRASTORNO DE LIGAMENTOS DE ARTICULACIONES DE AMBAS MANOS"
  },
  {
    "codigo":126987004,
    "descripcion":"NEOPLASIA DE NERVIOS PERIFÉRICOS DE HOMBRO"
  },
  {
    "codigo":94219006,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE HUESO DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":288992000,
    "descripcion":"DIFICULTAD PARA PRENDERSE AL PECHO PARA MAMAR"
  },
  {
    "codigo":714976003,
    "descripcion":"INCLUIDO EN ESTUDIO CLÍNICO SOBRE DISPOSITIVO"
  },
  {
    "codigo":26848004,
    "descripcion":"SÍNDROME DE COREA - ACANTOCITOSIS"
  },
  {
    "codigo":125152006,
    "descripcion":"ESPÉCIMEN SATISFACTORIO PARA EVALUACIÓN"
  },
  {
    "codigo":57781000,
    "descripcion":"TRASTORNO DE CUERDAS VOCALES"
  },
  {
    "codigo":92384009,
    "descripcion":"NEOPLASIA BENIGNA DE PIEL"
  },
  {
    "codigo":336481000119101,
    "descripcion":"ECTROPIÓN SENIL DE PÁRPADO DERECHO"
  },
  {
    "codigo":90549003,
    "descripcion":"SÍNDROME DE VERBRYCKE"
  },
  {
    "codigo":90721000119101,
    "descripcion":"ESTADIO 1 DE ENFERMEDAD RENAL CRÓNICA DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":254389005,
    "descripcion":"CARCINOMA DE BORDE BERMELLÓN DE LABIO SUPERIOR"
  },
  {
    "codigo":449162004,
    "descripcion":"SÍNTOMAS SENSORIALES EXPERIENCIALES"
  },
  {
    "codigo":88714009,
    "descripcion":"HIPOGAMMAGLOBULINEMIA TRANSITORIA DE LA INFANCIA"
  },
  {
    "codigo":185183004,
    "descripcion":"ATENDIDO EN CONSULTORIO DE AUXOLOGÍA"
  },
  {
    "codigo":709471005,
    "descripcion":"PERIODONTITIS CONCOMITANTE CON LEUCEMIA"
  },
  {
    "codigo":52276000,
    "descripcion":"METALOSIS"
  },
  {
    "codigo":283487009,
    "descripcion":"HERIDA PUNZANTE EN LA PANTORRILLA"
  },
  {
    "codigo":445492005,
    "descripcion":"LINFANGIOMA DE PIEL"
  },
  {
    "codigo":248884007,
    "descripcion":"PÓLIPO DE PARED VAGINAL"
  },
  {
    "codigo":314420008,
    "descripcion":"TUMOR CORIORRETINIANO"
  },
  {
    "codigo":247049005,
    "descripcion":"HALLAZGO RELACIONADO CON EL CRISTALINO"
  },
  {
    "codigo":1230089006,
    "descripcion":"PATRÓN DE USO NOCIVO DE PSICOESTIMULANTE SIN DEPENDENCIA"
  },
  {
    "codigo":771337007,
    "descripcion":"SÍNDROME DE MICRODUPLICACIÓN 1Q21.1"
  },
  {
    "codigo":83209008,
    "descripcion":"LESIÓN TRAUMÁTICA DE COLON TRANSVERSO SIN HERIDA ABIERTA HACIA CAVIDAD ABDOMINAL"
  },
  {
    "codigo":703966004,
    "descripcion":"PANICULITIS AGUDA"
  },
  {
    "codigo":48606007,
    "descripcion":"RESISTENCIA A LA INSULINA DE CAUSA FARMACOLÓGICA"
  },
  {
    "codigo":409054008,
    "descripcion":"ALTERACIÓN DE LA PERFUSIÓN TISULAR"
  },
  {
    "codigo":865971002,
    "descripcion":"DOLOR A LA PERCUSIÓN DE DIENTE"
  },
  {
    "codigo":14003003,
    "descripcion":"MONOMANÍA"
  },
  {
    "codigo":1086441000119100,
    "descripcion":"PERFORACIÓN DE INTESTINO DELGADO Y GRUESO DEBIDA A DIVERTICULITIS"
  },
  {
    "codigo":210611002,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DEL PULGAR"
  },
  {
    "codigo":1001000119102,
    "descripcion":"EMBOLIA PULMONAR CON INFARTO PULMONAR"
  },
  {
    "codigo":370658281000119103,
    "descripcion":"SÍNDROME DE DISTRÉS RESPIRATORIO AGUDO DEBIDO A DABBING"
  },
  {
    "codigo":15704041000119103,
    "descripcion":"CONTRACTURA MUSCULAR DE AMBOS ANTEBRAZOS"
  },
  {
    "codigo":439987009,
    "descripcion":"FRACTURA EXPUESTA DE HUESO"
  },
  {
    "codigo":346601000119105,
    "descripcion":"XEROSIS CONJUNTIVAL DE AMBOS OJOS"
  },
  {
    "codigo":16098281000119107,
    "descripcion":"ARTROFIBROSIS DE RODILLA IZQUIERDA"
  },
  {
    "codigo":310761000119107,
    "descripcion":"MIOSITIS INFECCIOSA DE MUSLO DERECHO"
  },
  {
    "codigo":15724521000119109,
    "descripcion":"CADERA DERECHA EN RESORTE"
  },
  {
    "codigo":679401000119109,
    "descripcion":"CICATRIZ DE CONJUNTIVA DE OJO DERECHO"
  },
  {
    "codigo":292841000119107,
    "descripcion":"SÍNDROME DE NERVIO INTERÓSEO ANTERIOR DE EXTREMIDAD SUPERIOR IZQUIERDA"
  },
  {
    "codigo":338921000119105,
    "descripcion":"QUISTE DE RETINA DE OJO IZQUIERDO CAUSADO POR PARÁSITO"
  },
  {
    "codigo":15739881000119108,
    "descripcion":"EXCAVACIÓN DE PAPILA ÓPTICA DERECHA DEBIDA A GLAUCOMA DE ÁNGULO ABIERTO DE OJO DERECHO"
  },
  {
    "codigo":15721961000119107,
    "descripcion":"CONTRACTURA DE ARTICULACIONES DE AMBAS MUÑECAS"
  },
  {
    "codigo":15640041000119109,
    "descripcion":"DISTENSIÓN DE MÚSCULO ROMBOIDE IZQUIERDO"
  },
  {
    "codigo":1081321000119107,
    "descripcion":"OSTEOSARCOMA PRIMARIO DE HUESO DE EXTREMIDAD SUPERIOR DERECHA"
  },
  {
    "codigo":303081000119109,
    "descripcion":"DEFORMIDAD EN OJAL DE DEDO DE MANO DERECHA"
  },
  {
    "codigo":100841000119109,
    "descripcion":"CIRUGÍA BARIÁTRICA PREVIA QUE COMPLICA EL EMBARAZO"
  },
  {
    "codigo":698461004,
    "descripcion":"CRIBADO DE ANEURISMA AÓRTICO NORMAL"
  },
  {
    "codigo":12168009,
    "descripcion":"VARIACIÓN EN EL COLOR DE PELO"
  },
  {
    "codigo":403549004,
    "descripcion":"APLASIA CUTÁNEA CONGÉNITA ASOCIADA CON FETO PAPIRÁCEO (TIPO 5)"
  },
  {
    "codigo":237874006,
    "descripcion":"MIOPATÍA AMILOIDE ESPORÁDICA PRIMARIA"
  },
  {
    "codigo":1055239001,
    "descripcion":"AUSENCIA DE REFLEJO EN UN LADO DEL CUERPO"
  },
  {
    "codigo":1153543002,
    "descripcion":"OCLUSIÓN DE ARTERIA CEREBRAL ANTERIOR"
  },
  {
    "codigo":15930261000119104,
    "descripcion":"EDEMA DE ESTROMA DE AMBAS CÓRNEAS"
  },
  {
    "codigo":236039002,
    "descripcion":"EVENTRACIÓN ESTRANGULADA"
  },
  {
    "codigo":39431006,
    "descripcion":"DETERMINACIÓN DEL ESTADO DE ENFERMEDAD: LIGERAMENTE CONTROLADA"
  },
  {
    "codigo":201436003,
    "descripcion":"LUPUS ERITEMATOSO SISTÉMICO MEDICAMENTOSO"
  },
  {
    "codigo":168668004,
    "descripcion":"RADIOGRAFÍA SIMPLE DE RODILLA ANORMAL"
  },
  {
    "codigo":365276007,
    "descripcion":"HALLAZGO RELACIONADO CON LA VELOCIDAD DEL PENSAMIENTO"
  },
  {
    "codigo":232369001,
    "descripcion":"GRANULOMATOSIS DE WEGENER CON POLIANGEÍTIS DE NARIZ"
  },
  {
    "codigo":723889003,
    "descripcion":"LEUCEMIA LINFOBLÁSTICA B\/LINFOMA CON T(9:22) (Q34;Q11.2); BCR-ABL 1"
  },
  {
    "codigo":1076271000119102,
    "descripcion":"BURSITIS SUPRARROTULIANA DE RODILLA IZQUIERDA"
  },
  {
    "codigo":164998001,
    "descripcion":"PRUEBA CUTÁNEA DE HIPERSENSIBILIDAD: SIN REACCIÓN"
  },
  {
    "codigo":363441009,
    "descripcion":"NEOPLASIA MALIGNA DE PARTES BLANDAS DE CUELLO"
  },
  {
    "codigo":230534007,
    "descripcion":"COMPRESIÓN DEL NERVIO TRIGÉMINO"
  },
  {
    "codigo":722054007,
    "descripcion":"ALBINISMO OCULAR CON SORDERA NEUROSENSORIAL DE COMIENZO TARDÍO"
  },
  {
    "codigo":296070007,
    "descripcion":"SOBREDOSIS DE NITRAZEPAM"
  },
  {
    "codigo":294235002,
    "descripcion":"ALERGIA A CARISOPRODOL"
  },
  {
    "codigo":64859006,
    "descripcion":"OSTEOPOROSIS"
  },
  {
    "codigo":292400000,
    "descripcion":"REACCIÓN ADVERSA AL TIOXANTENO"
  },
  {
    "codigo":1144368001,
    "descripcion":"SOBREDOSIS INTENCIONAL DE WARFARINA"
  },
  {
    "codigo":63024004,
    "descripcion":"VÉRTIGO ALTERNOBÁRICO"
  },
  {
    "codigo":126725000,
    "descripcion":"NEOPLASIA DEL MEDIASTINO"
  },
  {
    "codigo":95792009,
    "descripcion":"NISTAGMO INVARIABLE POR LA REMOCIÓN DE LA FIJACIÓN"
  },
  {
    "codigo":338991000119107,
    "descripcion":"ESCOTOMA PARACECAL IZQUIERDO"
  },
  {
    "codigo":194096008,
    "descripcion":"EXOTROPÍA ALTERNANTE CON PATRÓN X"
  },
  {
    "codigo":93957005,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL PERICARDIO"
  },
  {
    "codigo":1306373009,
    "descripcion":"SARCOMA DE CUADRANTE SUPERIOR INTERNO DE MAMA"
  },
  {
    "codigo":92122002,
    "descripcion":"NEOPLASIA BENIGNA DEL NERVIO GLOSOFARÍNGEO"
  },
  {
    "codigo":225029009,
    "descripcion":"ETAPA DE ACEPTACIÓN EN EL PROCESO DE DUELO"
  },
  {
    "codigo":288730004,
    "descripcion":"DIFICULTAD PARA EMPLEAR DIFERENTES FORMAS DE CONVERSACIÓN"
  },
  {
    "codigo":188591001,
    "descripcion":"ENFERMEDAD DE HODGKIN, DEPLECIÓN LINFOCITARIA DE GANGLIOS LINFÁTICOS INTRAPÉLVICOS"
  },
  {
    "codigo":417967008,
    "descripcion":"TRASTORNO DE LOS EOSINÓFILOS"
  },
  {
    "codigo":11863241000119105,
    "descripcion":"AMPOLLA DE DEDO GORDO DE PIE DERECHO, CON INFECCIÓN"
  },
  {
    "codigo":416132002,
    "descripcion":"SÍNDROME DEL PSOAS"
  },
  {
    "codigo":286895009,
    "descripcion":"CARCINOMA DE CUADRANTE SUPERIOR EXTERNO DE MAMA"
  },
  {
    "codigo":414297000,
    "descripcion":"ANGEÍTIS DE LA RAMA CONGELADA"
  },
  {
    "codigo":53849001,
    "descripcion":"EMBRIÓN NODULAR"
  },
  {
    "codigo":283225001,
    "descripcion":"ANZUELO EN DEDO GORDO"
  },
  {
    "codigo":184921007,
    "descripcion":"EXENCIÓN DEL CINTURÓN DE SEGURIDAD FIRMADA"
  },
  {
    "codigo":367971000119102,
    "descripcion":"ESTRECHEZ DE URETRA MEMBRANOSA DE ORIGEN TRAUMÁTICO"
  },
  {
    "codigo":1231662005,
    "descripcion":"NEOVASCULARIZACIÓN RETINIANA DEBIDA A OCLUSIÓN DE RAMA DE VENA RETINIANA"
  },
  {
    "codigo":248622006,
    "descripcion":"SONIDO RESPIRATORIO EN CHASQUIDO"
  },
  {
    "codigo":707374005,
    "descripcion":"LEIOMIOMA DE PULMÓN"
  },
  {
    "codigo":652287331000119104,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DE TRONCO ENCEFÁLICO"
  },
  {
    "codigo":1197059004,
    "descripcion":"SÍNDROME DE ICTIOSIS CONGÉNITA, CUADRIPLEJÍA Y MICROCEFALIA"
  },
  {
    "codigo":771075004,
    "descripcion":"MACROTROMBOCITOPENIA CON INSUFICIENCIA DE VÁLVULA MITRAL"
  },
  {
    "codigo":443395009,
    "descripcion":"FRACTURA POR COMPRESIÓN"
  },
  {
    "codigo":408792005,
    "descripcion":"LÍQUIDO AMNIÓTICO CON MECONIO - GRADO I"
  },
  {
    "codigo":15576007,
    "descripcion":"ERITEMA NECROLÍTICO MIGRATORIO"
  },
  {
    "codigo":703704008,
    "descripcion":"TUMOR DE CÉLULAS GIGANTES DE MEMBRANA SINOVIAL Y\/O VAINA TENDINOSA"
  },
  {
    "codigo":439725008,
    "descripcion":"DEFICIENCIA DE DESINTEGRINA A Y METALOPROTEINASA CON TROMBOSPONDINA TIPO 1, MOTIVO 13"
  },
  {
    "codigo":341501000119103,
    "descripcion":"LAGOFTALMOS CICATRIZAL IZQUIERDO"
  },
  {
    "codigo":208514006,
    "descripcion":"FRACTURAS QUE COMPROMETEN MÚLTIPLES REGIONES DE AMBAS EXTREMIDADES SUPERIORES"
  },
  {
    "codigo":11906007,
    "descripcion":"VULVOVAGINITIS GONOCÓCICA CRÓNICA"
  },
  {
    "codigo":110210007,
    "descripcion":"QUEMADURA DE LA ENCÍA UNIDA A LA MANDÍBULA"
  },
  {
    "codigo":698199001,
    "descripcion":"ERITROLEUCOPLASIA DE PARTE INTERNA DE LA BOCA"
  },
  {
    "codigo":403287006,
    "descripcion":"LESIÓN UNGUEAL POR AGENTES QUÍMICOS"
  },
  {
    "codigo":1288023007,
    "descripcion":"TUMOR NEUROENDOCRINO BIEN DIFERENCIADO HEREDITARIO DE INTESTINO DELGADO"
  },
  {
    "codigo":237612000,
    "descripcion":"FOTOMIOCLONÍA, DIABETES MELLITUS, SORDERA, NEFROPATÍA Y DISFUNCIÓN CEREBRAL"
  },
  {
    "codigo":370519008,
    "descripcion":"PITIOSIS CUTÁNEA"
  },
  {
    "codigo":763735008,
    "descripcion":"LABIO LEPORINO COMPLETO BILATERAL Y FISURA ALVEOLAR COMPLETA BILATERAL"
  },
  {
    "codigo":1220652003,
    "descripcion":"ABORTO COMPLETO INDUCIDO COMPLICADO POR EMBOLIA"
  },
  {
    "codigo":11810301000119106,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DE CADERA Y MUSLO DERECHOS"
  },
  {
    "codigo":204844007,
    "descripcion":"AGENESIA DE ÚTERO"
  },
  {
    "codigo":399617002,
    "descripcion":"CARDITIS"
  },
  {
    "codigo":203009004,
    "descripcion":"MIOSITIS INFECCIOSA DE CUELLO"
  },
  {
    "codigo":792833006,
    "descripcion":"PULSO EN ARTERIA FEMORAL IZQUIERDA AUSENTE"
  },
  {
    "codigo":301313007,
    "descripcion":"CRÁNEO SIMÉTRICO"
  },
  {
    "codigo":235777009,
    "descripcion":"FÍSTULA DEL INTESTINO GRUESO"
  },
  {
    "codigo":725462002,
    "descripcion":"HIPOTIROIDISMO CONGÉNITO CENTRAL DEBIDO A DEFICIENCIA DE RECEPTOR DE HORMONA LIBERADORA DE TIROTROFINA"
  },
  {
    "codigo":201174003,
    "descripcion":"POLIOSIS EXCÉNTRICA"
  },
  {
    "codigo":233942004,
    "descripcion":"HIPERTENSIÓN PULMONAR DE PEQUEÑOS VASOS"
  },
  {
    "codigo":365014007,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA EMITIR LA VOZ"
  },
  {
    "codigo":299478007,
    "descripcion":"PROBLEMA DEL PIE"
  },
  {
    "codigo":168406009,
    "descripcion":"DISCARIOSIS SEVERA EN EL EXTENDIDO CERVICAL, NO ES POSIBLE DESCARTAR CARCINOMA INVASOR"
  },
  {
    "codigo":68267002,
    "descripcion":"HIPERTENSIÓN INTRACRANEAL BENIGNA"
  },
  {
    "codigo":166571005,
    "descripcion":"AMILASA SÉRICA (PANCREÁTICA) DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":363179006,
    "descripcion":"TRASTORNO INFLAMATORIO DEL APARATO MUSCULOESQUELÉTICO"
  },
  {
    "codigo":81459009,
    "descripcion":"INTOXICACIÓN POR PODOPHYLLUM PELTATUM"
  },
  {
    "codigo":230272001,
    "descripcion":"ENFERMEDAD DE PICK CON CÉLULAS PICK Y SIN CUERPOS DE PICK"
  },
  {
    "codigo":232107008,
    "descripcion":"HIPERTROPÍA ALTERNANTE"
  },
  {
    "codigo":721792003,
    "descripcion":"MENINGITIS CAUSADA POR MUCORALES"
  },
  {
    "codigo":263040004,
    "descripcion":"SUBLUXACIÓN DE ARTICULACIÓN DE LA COLUMNA VERTEBRAL CERVICAL"
  },
  {
    "codigo":315031000119106,
    "descripcion":"OSTEÍTIS DEFORMANTE DE TIBIA Y PERONÉ IZQUIERDOS"
  },
  {
    "codigo":195669000,
    "descripcion":"AMIGDALITIS EXUDATIVA AGUDA"
  },
  {
    "codigo":293973002,
    "descripcion":"ALERGIA A PINDOLOL"
  },
  {
    "codigo":95530000,
    "descripcion":"ÚLCERA GÁSTRICA CRÓNICA"
  },
  {
    "codigo":718122005,
    "descripcion":"PIEBALDISMO"
  },
  {
    "codigo":292138006,
    "descripcion":"REACCIÓN ADVERSA AL PICOSULFATO DE SODIO"
  },
  {
    "codigo":191999000,
    "descripcion":"HIPERSOMNIA PERSISTENTE"
  },
  {
    "codigo":423210009,
    "descripcion":"OSTEOMA OSTEOIDE DE LA COLUMNA VERTEBRAL"
  },
  {
    "codigo":93695002,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE VASO SANGUÍNEO DE DEDO DE LA MANO"
  },
  {
    "codigo":880127005,
    "descripcion":"TRASTORNO DEL DESARROLLO SEXUAL 46,XX INDUCIDO POR ANDRÓGENOS DE ORIGEN IATROGÉNICO DERIVADO DE TRASTORNO MATERNO"
  },
  {
    "codigo":1304276001,
    "descripcion":"SÍNDROME DE SOBRECRECIMIENTO CHD8"
  },
  {
    "codigo":91860005,
    "descripcion":"LEUCEMIA MIELOIDE AGUDA EN REMISIÓN"
  },
  {
    "codigo":124628005,
    "descripcion":"DEFICIENCIA DE HISTIDINA AMONÍACO - LIASA"
  },
  {
    "codigo":253865003,
    "descripcion":"ECTOPIA CRUZADA DE RIÑÓN, SIN FUSIÓN"
  },
  {
    "codigo":284798000,
    "descripcion":"CAPAZ DE REALIZAR ACTIVIDAD DE BAÑO"
  },
  {
    "codigo":1204137009,
    "descripcion":"DISFUNCIÓN DE COMPONENTE DE ALTO VOLTAJE DE DESFIBRILADOR CARDIOVERSOR IMPLANTABLE"
  },
  {
    "codigo":710782002,
    "descripcion":"MALA OCLUSIÓN, SUBDIVISIÓN DE LA CLASE II DE ANGLE"
  },
  {
    "codigo":252030006,
    "descripcion":"MICCIÓN DISFUNCIONAL"
  },
  {
    "codigo":1081291000119104,
    "descripcion":"OSTEOSARCOMA PRIMARIO DE HUESO DE MANO IZQUIERDA"
  },
  {
    "codigo":281128000,
    "descripcion":"ORIFICIO CERVICAL CERRADO"
  },
  {
    "codigo":282963009,
    "descripcion":"DIFICULTAD PARA ACUCLILLARSE"
  },
  {
    "codigo":408530001,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: NORUEGO"
  },
  {
    "codigo":48082007,
    "descripcion":"ANOMALÍA DEL PAR DE CROMOSOMAS 8"
  },
  {
    "codigo":898215004,
    "descripcion":"FUSIÓN ANORMAL CONGÉNITA DE HUESOS DE PIE"
  },
  {
    "codigo":210087005,
    "descripcion":"LESIÓN TRAUMÁTICA ESOFÁGICA CERRADA"
  },
  {
    "codigo":79015004,
    "descripcion":"PREOCUPADO"
  },
  {
    "codigo":44412000,
    "descripcion":"URETRITIS GONOCÓCICA CRÓNICA"
  },
  {
    "codigo":111783009,
    "descripcion":"OCRATOXICOSIS"
  },
  {
    "codigo":372092003,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA PROLONGACIÓN AXILAR DE LA MAMA"
  },
  {
    "codigo":109948008,
    "descripcion":"NEOPLASIA SUPERPUESTA MALIGNA DEL OJO Y LOS ANEXOS OCULARES, PRIMARIA"
  },
  {
    "codigo":239185002,
    "descripcion":"INJERTO DE PIEL DESPLAZADO"
  },
  {
    "codigo":271953006,
    "descripcion":"PENSAMIENTOS OBSESIVOS ACERCA DE CAUSARSE DAÑO"
  },
  {
    "codigo":403025007,
    "descripcion":"TIÑA CORPORAL CAUSADA POR TRICHOPHYTON EQUINUM VARIANTE EQUINUM"
  },
  {
    "codigo":16019711000119102,
    "descripcion":"SINOVITIS TRANSITORIA DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":401190001,
    "descripcion":"SIN NEBULIZACIONES DESDE LA ÚLTIMA CONSULTA"
  },
  {
    "codigo":237350002,
    "descripcion":"DEPRESIÓN POSPARTO AGUDA"
  },
  {
    "codigo":302886004,
    "descripcion":"COMPRESIÓN DE NERVIO INTERÓSEO POSTERIOR"
  },
  {
    "codigo":1187622004,
    "descripcion":"PROTEÍNA NUCLEAR EN CARCINOMA TESTICULAR"
  },
  {
    "codigo":827174006,
    "descripcion":"FIBROCONDROMA CERVICOFACIAL"
  },
  {
    "codigo":169979000,
    "descripcion":"AMAMANTADO A LOS 3 MESES"
  },
  {
    "codigo":38907003,
    "descripcion":"VARICELA"
  },
  {
    "codigo":366587006,
    "descripcion":"HALLAZGO RELACIONADO CON LA AMPLITUD DE LA FLEXIÓN DE LA RODILLA"
  },
  {
    "codigo":202747007,
    "descripcion":"CALCIFICACIÓN DE DISCO CERVICAL"
  },
  {
    "codigo":299216000,
    "descripcion":"MANO AMPUTADA"
  },
  {
    "codigo":102608004,
    "descripcion":"APETITO ALIMENTARIO EXCESIVO"
  },
  {
    "codigo":69840006,
    "descripcion":"LACTANCIA MATERNA NORMAL"
  },
  {
    "codigo":364752006,
    "descripcion":"COMPROMISO DE LA CABEZA FETAL POR SOBRE EL BORDE PÉLVICO - HALLAZGO"
  },
  {
    "codigo":168144008,
    "descripcion":"ORGANISMO NO AISLADO EN CULTIVO DE HISOPADO DE HERIDA"
  },
  {
    "codigo":346521000119100,
    "descripcion":"ECTASIA DE CÓRNEA DE AMBOS OJOS"
  },
  {
    "codigo":723365002,
    "descripcion":"SÍNDROME DE HIPOTRICOSIS Y DISCAPACIDAD INTELECTUAL TIPO LOPES"
  },
  {
    "codigo":15911321000119101,
    "descripcion":"RETINOPATÍA DE OJO IZQUIERDO CAUSADA POR TALCO"
  },
  {
    "codigo":127231000119108,
    "descripcion":"CHOQUE SÉPTICO CONCOMITANTE CON DISFUNCIÓN ORGÁNICA AGUDA CAUSADO POR SERRATIA"
  },
  {
    "codigo":231845008,
    "descripcion":"LACERACIÓN DE CANALÍCULO LAGRIMAL"
  },
  {
    "codigo":2469009,
    "descripcion":"ONICOMALACIA"
  },
  {
    "codigo":262778004,
    "descripcion":"FRAGMENTACIÓN DE GLÁNDULA PARATIROIDES"
  },
  {
    "codigo":295546006,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE DESFLURANO"
  },
  {
    "codigo":721530007,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO MEDIANO A NIVEL DE BRAZO"
  },
  {
    "codigo":361082008,
    "descripcion":"DEFICIENCIA DE CATEPSINA RIBOSÓMICA"
  },
  {
    "codigo":230010007,
    "descripcion":"POSICIÓN DEL TRONCO RELAJADA CON INCLINACIÓN HACIA ADELANTE"
  },
  {
    "codigo":129871000,
    "descripcion":"BAJA AUTOESTIMA SITUACIONAL"
  },
  {
    "codigo":424783008,
    "descripcion":"LESIÓN TRAUMÁTICA DEL TÓRAX POR DESACELERACIÓN"
  },
  {
    "codigo":95268002,
    "descripcion":"DEFECTO DE TABIQUE INTERAURICULAR TIPO SENO VENOSO"
  },
  {
    "codigo":62500006,
    "descripcion":"VEJIGA URINARIA ACCESORIA"
  },
  {
    "codigo":224505002,
    "descripcion":"ACUERDOS PARA EL CUIDADO INFORMAL RAZONABLES"
  },
  {
    "codigo":93433003,
    "descripcion":"DISCINESIA MEDICAMENTOSA, INICIO AGUDO"
  },
  {
    "codigo":124366000,
    "descripcion":"DEFICIENCIA DE 3 - OXOÁCIDO COA - TRANSFERASA"
  },
  {
    "codigo":384675002,
    "descripcion":"BLOQUEO PUPILAR"
  },
  {
    "codigo":286371003,
    "descripcion":"NO HABLA"
  },
  {
    "codigo":253603005,
    "descripcion":"ORIFICIO EXCÉNTRICO DE VÁLVULA AÓRTICA"
  },
  {
    "codigo":448376000,
    "descripcion":"LINFOMA NO HODGKIN DE OVARIO"
  },
  {
    "codigo":251768002,
    "descripcion":"IMAGEN RESIDUAL"
  },
  {
    "codigo":342971000119107,
    "descripcion":"MELASMA DE PÁRPADO DERECHO Y REGIÓN PERIOCULAR"
  },
  {
    "codigo":249933003,
    "descripcion":"DEBILIDAD FACIAL, NEURONA MOTORA INFERIOR"
  },
  {
    "codigo":315469002,
    "descripcion":"NACIDO EN LUXEMBURGO"
  },
  {
    "codigo":51490003,
    "descripcion":"ENFERMEDAD CAUSADA POR RUBIVIRUS"
  },
  {
    "codigo":248098003,
    "descripcion":"DISFRUTE SEXUAL INTENSO"
  },
  {
    "codigo":82423001,
    "descripcion":"DOLOR CRÓNICO"
  },
  {
    "codigo":279031005,
    "descripcion":"DISFUNCIÓN CERVICAL SEGMENTARIA"
  },
  {
    "codigo":1293004000,
    "descripcion":"NECROSIS TUBULAR AGUDA DEBIDA A ISQUEMIA"
  },
  {
    "codigo":703180005,
    "descripcion":"OCLUSIÓN ASINTOMÁTICA DE ARTERIA CARÓTIDA EXTRACRANEAL"
  },
  {
    "codigo":277196008,
    "descripcion":"ANEURISMA EN FRAMBUESA"
  },
  {
    "codigo":10670951000119101,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN EN PIERNA DERECHA NO ESTADIFICABLE"
  },
  {
    "codigo":275361004,
    "descripcion":"LACERACIÓN TENTORIAL"
  },
  {
    "codigo":13217005,
    "descripcion":"BRONQUIECTASIA FUSIFORME"
  },
  {
    "codigo":111521006,
    "descripcion":"DEGENERACIÓN CORNEAL"
  },
  {
    "codigo":766881008,
    "descripcion":"SÍNDROME DE COMPLEJO DE CARNEY, TRISMO Y PSEUDOCAMPTODACTILIA"
  },
  {
    "codigo":78753008,
    "descripcion":"QUISTE GLOBULOMAXILAR"
  },
  {
    "codigo":109686002,
    "descripcion":"ABSCESO MAXILAR"
  },
  {
    "codigo":765046002,
    "descripcion":"ENFERMEDAD DE CHARCOT-MARIE-TOOTH AUTOSÓMICA DOMINANTE TIPO 2U"
  },
  {
    "codigo":4659007,
    "descripcion":"ACNÉ FULMINANTE"
  },
  {
    "codigo":240758007,
    "descripcion":"NÓDULO ESPOROTRICOIDE CUTÁNEO PRIMARIO"
  },
  {
    "codigo":238923001,
    "descripcion":"ALOPECIA LIPEDEMATOSA"
  },
  {
    "codigo":402763002,
    "descripcion":"REACCIÓN ADVERSA CUTÁNEA A PROCEDIMIENTO DIAGNÓSTICO"
  },
  {
    "codigo":763211004,
    "descripcion":"DEFECTO COMBINADO DE LA FOSFORILACIÓN OXIDATIVA TIPO 21"
  },
  {
    "codigo":75083006,
    "descripcion":"FRAGILIDAD OSMÓTICA AUMENTADA"
  },
  {
    "codigo":271691008,
    "descripcion":"MAMAS ASIMÉTRICAS"
  },
  {
    "codigo":1285664004,
    "descripcion":"ENFERMEDAD MODERADA POR DEFICIENCIA HEREDITARIA DE FACTOR IX CON INHIBIDOR DE BAJA RESPUESTA"
  },
  {
    "codigo":366325002,
    "descripcion":"HALLAZGO RELACIONADO CON LA PROGRESIÓN DE LA PRIMERA ETAPA DEL TRABAJO DE PARTO"
  },
  {
    "codigo":38645004,
    "descripcion":"MEMBRANA TIMPÁNICA FLÁCCIDA ATRÓFICA"
  },
  {
    "codigo":202485006,
    "descripcion":"DOLOR DE DEDO DE LA MANO O DE ARTICULACIÓN INTERFALÁNGICA DISTAL"
  },
  {
    "codigo":300789008,
    "descripcion":"NO INICIA JUEGO ESPONTÁNEO"
  },
  {
    "codigo":5877009,
    "descripcion":"INTOXICACIÓN POR PIMELEA TRICHOSTACHYA"
  },
  {
    "codigo":167882004,
    "descripcion":"LÍQUIDO SINOVIAL: OPALESCENTE"
  },
  {
    "codigo":200650005,
    "descripcion":"CELULITIS Y ABSCESO DE LA FRENTE"
  },
  {
    "codigo":298954004,
    "descripcion":"AMPLITUD DE FLEXIÓN PASIVA DE LA MUÑECA NORMAL"
  },
  {
    "codigo":11791361000119103,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE MUÑECA DERECHA"
  },
  {
    "codigo":724938008,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE EXTREMIDAD SUPERIOR DERECHA ENTRE EL HOMBRO Y EL CODO"
  },
  {
    "codigo":723103002,
    "descripcion":"ÚLCERA GÁSTRICA CAUSADA POR ALCOHOL"
  },
  {
    "codigo":1149087003,
    "descripcion":"MICROENCEFALIA CONGÉNITA"
  },
  {
    "codigo":460959004,
    "descripcion":"ORIGEN ANÓMALO DE LIGAMENTO ARTERIOSO EN AORTA ASCENDENTE"
  },
  {
    "codigo":295284004,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE OXIFENBUTAZONA"
  },
  {
    "codigo":15723521000119106,
    "descripcion":"GANGLIÓN DE AMBOS PIES"
  },
  {
    "codigo":721268005,
    "descripcion":"FOLICULITIS SUPERFICIAL CAUSADA POR BACTERIA"
  },
  {
    "codigo":229748008,
    "descripcion":"FALTA DE PERCEPCIÓN AUDITIVA CONGÉNITA"
  },
  {
    "codigo":129609000,
    "descripcion":"ATAXIA ESPINOCEREBELOSA"
  },
  {
    "codigo":132251000119101,
    "descripcion":"TROMBOSIS VENOSA PROFUNDA AGUDA DE VENA POPLÍTEA"
  },
  {
    "codigo":293449004,
    "descripcion":"REACCIÓN ADVERSA AL BRETILIO"
  },
  {
    "codigo":322561000119109,
    "descripcion":"SINOVITIS TRANSITORIA DE ARTICULACIÓN GLENOHUMERAL IZQUIERDA"
  },
  {
    "codigo":226078005,
    "descripcion":"DIETA MODIFICADA EN CONTENIDO CALÓRICO"
  },
  {
    "codigo":95006006,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA PLEURA"
  },
  {
    "codigo":289779000,
    "descripcion":"CONSISTENCIA DEL CUELLO UTERINO, NORMAL"
  },
  {
    "codigo":224243003,
    "descripcion":"ÁREAS COMUNITARIAS EN UN ALOJAMIENTO"
  },
  {
    "codigo":27635008,
    "descripcion":"DOLOR SORDO Y PERSISTENTE"
  },
  {
    "codigo":191475009,
    "descripcion":"SÍNDROME CEREBRAL ALCOHÓLICO CRÓNICO"
  },
  {
    "codigo":1010675009,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS DE PARED POSTERIOR DE NASOFARINGE"
  },
  {
    "codigo":1172680006,
    "descripcion":"SULFAHEMOGLOBINA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":89501001,
    "descripcion":"RESISTENCIA HORMONAL AUMENTADA"
  },
  {
    "codigo":56733003,
    "descripcion":"INFESTACIÓN PARASITARIA DE ÓRBITA"
  },
  {
    "codigo":105781000119102,
    "descripcion":"INMUNIDAD CONTRA VARICELA DETERMINADA POR SEROLOGÍA"
  },
  {
    "codigo":762291006,
    "descripcion":"SÍNDROME DE HIJO DE MADRE CON DIABETES GESTACIONAL"
  },
  {
    "codigo":417181009,
    "descripcion":"NEOPLASIA MAMARIA MALIGNA POSITIVA PARA RECEPTORES HORMONALES"
  },
  {
    "codigo":251506003,
    "descripcion":"DESCARGA DE RECLUTAMIENTO FOCAL"
  },
  {
    "codigo":185970004,
    "descripcion":"PACIENTE QUE ESPERA ADMISIÓN MÉDICA"
  },
  {
    "codigo":54898003,
    "descripcion":"DEFICIENCIA DE SULFATASA MÚLTIPLE"
  },
  {
    "codigo":415346000,
    "descripcion":"INCLINACIÓN LATERAL DERECHA"
  },
  {
    "codigo":286109008,
    "descripcion":"DIFICULTAD PARA LUSTRAR"
  },
  {
    "codigo":284274006,
    "descripcion":"DIFICULTAD PARA EMPLEAR AGARRE DE PINZA"
  },
  {
    "codigo":87666009,
    "descripcion":"VITILIGO DE PÁRPADO"
  },
  {
    "codigo":315207000,
    "descripcion":"DIETA HIPOCOLESTEROLÉMICA PARA DIABÉTICOS"
  },
  {
    "codigo":679221000119104,
    "descripcion":"DEGENERACIÓN MARGINAL PELÚCIDA DE CÓRNEA DE OJO IZQUIERDO"
  },
  {
    "codigo":22130008,
    "descripcion":"INTOXICACIÓN POR MERCURIO ORGÁNICO"
  },
  {
    "codigo":20295000,
    "descripcion":"DIVORCIADO"
  },
  {
    "codigo":282439006,
    "descripcion":"DESGARRO DEL PÁNCREAS"
  },
  {
    "codigo":18460000,
    "descripcion":"FUNCIÓN NORMAL DEL SISTEMA NERVIOSO"
  },
  {
    "codigo":1263644001,
    "descripcion":"SUSTANCIA EN ORINA DETECTADA POR MÉTODO DE SCREENING"
  },
  {
    "codigo":249671009,
    "descripcion":"TÓRAX ANGOSTO"
  },
  {
    "codigo":870428003,
    "descripcion":"ENFERMEDAD HEPÁTICA DESPUÉS DE OPERACIÓN DE FONTAN"
  },
  {
    "codigo":51228004,
    "descripcion":"INTOXICACIÓN CAUSADA POR HORMONA HIPOFISARIA ANTERIOR"
  },
  {
    "codigo":118599009,
    "descripcion":"ENFERMEDAD DE HODGKIN"
  },
  {
    "codigo":247836001,
    "descripcion":"MIEDO A IR A LOS BAÑOS PÚBLICOS"
  },
  {
    "codigo":735686002,
    "descripcion":"MUERTE SÚBITA CARDÍACA DEBIDA A ARRITMIA CARDÍACA"
  },
  {
    "codigo":111259002,
    "descripcion":"DEFORMIDAD ADQUIRIDA DEL CALCÁNEO"
  },
  {
    "codigo":373403003,
    "descripcion":"INVASIÓN TUMORAL INDETERMINADA DE VASOS SANGUÍNEOS\/LINFÁTICOS (MAMA)"
  },
  {
    "codigo":45723005,
    "descripcion":"FUNCIÓN REPRODUCTIVA FEMENINA NORMAL"
  },
  {
    "codigo":371568002,
    "descripcion":"INFECCIÓN ANAL"
  },
  {
    "codigo":1354608003,
    "descripcion":"FRACTURA DE FALANGE PROXIMAL DE ÍNDICE"
  },
  {
    "codigo":764784005,
    "descripcion":"TRASTORNO DE SUFRIMIENTO CORPORAL MODERADO"
  },
  {
    "codigo":238661000,
    "descripcion":"ESTRÍAS BUCALES DE WICKHAM EN LIQUEN PLANO"
  },
  {
    "codigo":402501000,
    "descripcion":"CARCINOMA BASOCELULAR DE LA PUNTA DE LA NARIZ"
  },
  {
    "codigo":369733002,
    "descripcion":"INVASIÓN TUMORAL DE VASO VENOSO INTRAPARIETAL (DE GRAN CALIBRE) PRESENTE"
  },
  {
    "codigo":304197003,
    "descripcion":"AMPLITUD DE MOVIMIENTO PASIVO DE FLEXIÓN HORIZONTAL DE HOMBRO NORMAL"
  },
  {
    "codigo":271429007,
    "descripcion":"PTOSIS ADQUIRIDA DE PÁRPADO"
  },
  {
    "codigo":171290003,
    "descripcion":"CONSENTIMIENTO PARA VACUNACIÓN ANTIGRIPAL OTORGADO"
  },
  {
    "codigo":12203471000119109,
    "descripcion":"PIE DE INMERSIÓN DERECHO"
  },
  {
    "codigo":40218008,
    "descripcion":"NEUMOCONIOSIS DE LOS PRODUCTORES DE ELECTRODOS DE CARBÓN"
  },
  {
    "codigo":72986009,
    "descripcion":"LEUCOENCEFALITIS HEMORRÁGICA AGUDA"
  },
  {
    "codigo":202223004,
    "descripcion":"SUBLUXACIÓN RECURRENTE DE CODO"
  },
  {
    "codigo":300527005,
    "descripcion":"PENE NORMAL"
  },
  {
    "codigo":398831006,
    "descripcion":"ENFERMEDAD DE BOWEN DE PENE"
  },
  {
    "codigo":298692000,
    "descripcion":"PRUEBA DE LASÈGUE POSITIVA"
  },
  {
    "codigo":724676000,
    "descripcion":"TRASTORNO DEL ESTADO DE ÁNIMO CON SÍNTOMAS DEPRESIVOS CAUSADO POR SEDANTE"
  },
  {
    "codigo":331460002,
    "descripcion":"GANGLIO SEÑAL"
  },
  {
    "codigo":890351008,
    "descripcion":"SINFALANGISMO BILATERAL DE ARTICULACIONES INTERFALÁNGICAS DISTALES"
  },
  {
    "codigo":396996006,
    "descripcion":"SITIO DE ASPIRACIÓN NO APLICABLE"
  },
  {
    "codigo":296857002,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE ACETOHEXAMIDA"
  },
  {
    "codigo":722841004,
    "descripcion":"PERFORACIÓN DE INTESTINO CONCOMITANTE CON ÍLEO MECONIAL Y DEBIDA A ÉL"
  },
  {
    "codigo":34713006,
    "descripcion":"HIPOVITAMINOSIS D"
  },
  {
    "codigo":1179758000,
    "descripcion":"PSEUDOPROGRESIÓN TUMORAL"
  },
  {
    "codigo":131182003,
    "descripcion":"ALTERACIÓN VISUAL"
  },
  {
    "codigo":1343598004,
    "descripcion":"ENTOMOFOBIA"
  },
  {
    "codigo":63811003,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE LABIO SIN INFECCIÓN"
  },
  {
    "codigo":162115004,
    "descripcion":"FRECUENCIA MICCIONAL NORMAL"
  },
  {
    "codigo":719171005,
    "descripcion":"DISPLASIA ESPONDILOMETAFISARIA TIPO MISSOURI"
  },
  {
    "codigo":194883006,
    "descripcion":"ÉMBOLO PULMONAR POSQUIRÚRGICO"
  },
  {
    "codigo":325955007,
    "descripcion":"PROTEINURIA RECURRENTE"
  },
  {
    "codigo":1145155005,
    "descripcion":"INTOXICACIÓN POR PLOMO Y\/O DERIVADO DE PLOMO"
  },
  {
    "codigo":43528001,
    "descripcion":"DIENTE SUPERNUMERARIO DISTOMOLAR"
  },
  {
    "codigo":291352002,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR GUAIFENESINA"
  },
  {
    "codigo":94744004,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE APÉNDICE ILEOCECAL"
  },
  {
    "codigo":717336005,
    "descripcion":"ATROFIA ÓPTICA AUTOSÓMICA DOMINANTE, FORMA CLÁSICA"
  },
  {
    "codigo":1208856005,
    "descripcion":"EMBOLIA TROMBÓTICA DESDE AURÍCULA CARDÍACA"
  },
  {
    "codigo":225816008,
    "descripcion":"OBTIENE VENTAJAS DEL PAPEL DE ENFERMO"
  },
  {
    "codigo":27373000,
    "descripcion":"DEFICIENCIA DE FUMARILACETOACETASA, TIPO AGUDO"
  },
  {
    "codigo":289517005,
    "descripcion":"LESIÓN VAGINAL"
  },
  {
    "codigo":92909006,
    "descripcion":"FORMA ANORMAL CONGÉNITA DE FÉMUR"
  },
  {
    "codigo":354051000119108,
    "descripcion":"NEOPLASIA BENIGNA DE HUESO LARGO DE MIEMBRO INFERIOR IZQUIERDO"
  },
  {
    "codigo":191213007,
    "descripcion":"ANEMIA HEMOLÍTICA SECUNDARIA POR ANTICUERPOS CALIENTES"
  },
  {
    "codigo":91074004,
    "descripcion":"INTOXICACIÓN POR GONADOTROFINA"
  },
  {
    "codigo":1172418004,
    "descripcion":"ADRENOCORTICOTROFINA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":254914004,
    "descripcion":"NEOPLASIA DE PARÉNQUIMA RENAL"
  },
  {
    "codigo":1091331000119109,
    "descripcion":"BOLSILLO DE RETRACCIÓN DE MEMBRANA TIMPÁNICA DERECHA"
  },
  {
    "codigo":58306008,
    "descripcion":"FITOFOTODERMATITIS AGUDA"
  },
  {
    "codigo":123842006,
    "descripcion":"ADENOCARCINOMA ENDOCERVICAL"
  },
  {
    "codigo":285847005,
    "descripcion":"EMOCIONALMENTE DISTANTE"
  },
  {
    "codigo":447852001,
    "descripcion":"DEFECTO DEL TABIQUE INTERVENTRICULAR EN LA ENTRADA DEL LADO DERECHO DEL TABIQUE INTERVENTRICULAR"
  },
  {
    "codigo":251244006,
    "descripcion":"ELEVACIÓN DEL PR"
  },
  {
    "codigo":314945000,
    "descripcion":"ESTENOSIS DE ANASTOMOSIS HEPATOYEYUNAL"
  },
  {
    "codigo":249409004,
    "descripcion":"HIPERQUERATOSIS DE LA MUCOSA ORAL"
  },
  {
    "codigo":773697006,
    "descripcion":"ELASTOSIS FOCAL LINEAL"
  },
  {
    "codigo":282177006,
    "descripcion":"DIFICULTAD PARA BAJAR UNA COLINA"
  },
  {
    "codigo":296072004,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE NITRAZEPAM"
  },
  {
    "codigo":301111000119103,
    "descripcion":"CIFOSIS DE COLUMNA VERTEBRAL CERVICODORSAL"
  },
  {
    "codigo":1359851000,
    "descripcion":"NEOPLASIA BENIGNA DE BERMELLÓN DE LABIO INFERIOR"
  },
  {
    "codigo":212971003,
    "descripcion":"DEPRIVACIÓN DE AGUA"
  },
  {
    "codigo":737259006,
    "descripcion":"LESIÓN TRAUMÁTICA DE TENDÓN DE PELVIS"
  },
  {
    "codigo":442347009,
    "descripcion":"ESTRÉS EMOCIONAL"
  },
  {
    "codigo":1259712001,
    "descripcion":"CARCINOMA UROTELIAL PLASMOCITOIDE PRIMARIO DE VEJIGA URINARIA"
  },
  {
    "codigo":276672007,
    "descripcion":"CANDIDIASIS CONGÉNITA"
  },
  {
    "codigo":110997000,
    "descripcion":"SÍNDROME DE FAHR"
  },
  {
    "codigo":307605009,
    "descripcion":"OSTEOBLASTOMA ÓSEO"
  },
  {
    "codigo":404074003,
    "descripcion":"OSTEOMA CUTÁNEO"
  },
  {
    "codigo":305770006,
    "descripcion":"ATENDIDO POR PODÓLOGO EXTRAHOSPITALARIO"
  },
  {
    "codigo":238399000,
    "descripcion":"FASCITIS NECROSANTE DEL ESCROTO Y PERINEO"
  },
  {
    "codigo":240234009,
    "descripcion":"DEFORMIDAD ADQUIRIDA FIJA EN FLEXIÓN DE PULGAR"
  },
  {
    "codigo":764522009,
    "descripcion":"EPILEPSIA FOCAL FAMILIAR CON FOCOS VARIABLES"
  },
  {
    "codigo":74559003,
    "descripcion":"EVALUACIÓN DE DISCAPACIDAD: ALTERACIÓN CLASE 2"
  },
  {
    "codigo":271167003,
    "descripcion":"AMPOLLA TRAUMÁTICA DE LA MUÑECA, INFECTADA"
  },
  {
    "codigo":402239009,
    "descripcion":"LIQUENIFICACIÓN SECUNDARIA"
  },
  {
    "codigo":72724002,
    "descripcion":"MORFOLOGÍA"
  },
  {
    "codigo":1186836002,
    "descripcion":"PARKINSONISMO INDUCIDO POR TOXINA"
  },
  {
    "codigo":369471009,
    "descripcion":"TUMOR MALIGNO QUE COMPROMETE VEJIGA URINARIA POR PROPAGACIÓN DIRECTA DE OVARIO"
  },
  {
    "codigo":236564005,
    "descripcion":"ENVOLTORIO EPIPLOICO ALREDEDOR DEL CATÉTER DE DIÁLISIS PERITONEAL"
  },
  {
    "codigo":105492006,
    "descripcion":"CAMBIO DE EMPLEO"
  },
  {
    "codigo":300265002,
    "descripcion":"SALIVA NORMAL"
  },
  {
    "codigo":15675601000119107,
    "descripcion":"TENDINITIS CALCIFICANTE DE AMBAS MANOS"
  },
  {
    "codigo":365801005,
    "descripcion":"NIVEL DE ALBÚMINA - HALLAZGO"
  },
  {
    "codigo":890089005,
    "descripcion":"TRASTORNO DEL DESARROLLO SEXUAL 46,XX TESTICULAR"
  },
  {
    "codigo":298430001,
    "descripcion":"AMPLITUD DE FLEXIÓN LATERAL ACTIVA HACIA LA DERECHA DE LA COLUMNA VERTEBRAL CERVICAL, AUMENTADA"
  },
  {
    "codigo":296595000,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE ESTREPTOMICINA"
  },
  {
    "codigo":722579002,
    "descripcion":"HEMORRAGIA TRAUMÁTICA NEONATAL DE TRÁQUEA DESPUÉS DE PROCEDIMIENTO EN EL TRACTO RESPIRATORIO INFERIOR"
  },
  {
    "codigo":49961000087101,
    "descripcion":"EDAD MAYOR O IGUAL A 40 AÑOS"
  },
  {
    "codigo":47401000087104,
    "descripcion":"ABRASIÓN DE REGIÓN DE OJO IZQUIERDO"
  },
  {
    "codigo":294760003,
    "descripcion":"ALERGIA A OXIMETOLONA"
  },
  {
    "codigo":42281000087108,
    "descripcion":"BAROTRAUMA ÓTICO DE OÍDO IZQUIERDO"
  },
  {
    "codigo":39721000087109,
    "descripcion":"DOLOR OROFACIAL CRÓNICO DEBIDO A TRASTORNO DE ARTICULACIÓN TEMPOROMANDIBULAR"
  },
  {
    "codigo":44841000087109,
    "descripcion":"INFARTO AGUDO DE MIOCARDIO CON ELEVACIÓN DE SEGMENTO ST DEBIDO A OCLUSIÓN DE RAMA POSTERIOR LATERAL DE RAMA CIRCUNFLEJA DE ARTERIA CORONARIA IZQUIERDA"
  },
  {
    "codigo":65384007,
    "descripcion":"ALOPECIA PSICÓGENA"
  },
  {
    "codigo":718909001,
    "descripcion":"DISCAPACIDAD INTELECTUAL LIGADA AL CROMOSOMA X TIPO STEVENSON"
  },
  {
    "codigo":425832009,
    "descripcion":"INSOMNIO PSICOFISIOLÓGICO"
  },
  {
    "codigo":423997002,
    "descripcion":"TUBERCULOSIS EXTRAPULMONAR"
  },
  {
    "codigo":292925004,
    "descripcion":"REACCIÓN ADVERSA A LA ESTREPTOMICINA"
  },
  {
    "codigo":1144893005,
    "descripcion":"QUISTE EPIDERMOIDE DE GLÁNDULA HIPÓFISIS"
  },
  {
    "codigo":225554002,
    "descripcion":"HALLAZGO RELACIONADO CON EL ESTADO GENERAL DE LAS UÑAS"
  },
  {
    "codigo":28946006,
    "descripcion":"CUERPO EXTRAÑO MAGNÉTICO RETENIDO EN EL IRIS Y\/O EN EL CUERPO CILIAR"
  },
  {
    "codigo":61714007,
    "descripcion":"ALTERACIÓN METABÓLICA EN EL TRABAJO DE PARTO Y\/O PARTO"
  },
  {
    "codigo":94482008,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL TEJIDO PERISUPRARRENAL"
  },
  {
    "codigo":127250009,
    "descripcion":"NEOPLASIA DE LOS GANGLIOS LINFÁTICOS INTRABDOMINALES"
  },
  {
    "codigo":715239002,
    "descripcion":"HIPOACUSIA NEUROSENSORIAL SÚBITA"
  },
  {
    "codigo":254652000,
    "descripcion":"CARCINOMA ESCAMOSO DE CÉLULAS CLARAS DE LA PIEL"
  },
  {
    "codigo":418492000,
    "descripcion":"HALLAZGO RELACIONADO CON ARTICULACIÓN SACROILÍACA"
  },
  {
    "codigo":242571000000102,
    "descripcion":"PACIENTE NO MEDICADO"
  },
  {
    "codigo":1335996009,
    "descripcion":"CARCINOMA DE CÉLULAS DE MERKEL PRIMARIO DE PIEL DE PÁRPADO INFERIOR"
  },
  {
    "codigo":56209005,
    "descripcion":"CONDUCTA AGONISTA"
  },
  {
    "codigo":1137553005,
    "descripcion":"CICATRIZ DE POLO POSTERIOR DE LA RETINA DEL OJO DERECHO"
  },
  {
    "codigo":449425007,
    "descripcion":"CONEXIÓN VENOSA PULMONAR ANÓMALA DE LOCALIZACIÓN INTRACARDÍCA A SENO CORONARIO"
  },
  {
    "codigo":250982001,
    "descripcion":"FUSIÓN COMISURAL DE VALVA AÓRTICA"
  },
  {
    "codigo":1332326002,
    "descripcion":"LABIO LEPORINO AISLADO"
  },
  {
    "codigo":283750002,
    "descripcion":"MORDEDURA DE PERRO EN EL BRAZO"
  },
  {
    "codigo":87142002,
    "descripcion":"AUSENCIA CONGÉNITA DE APÉNDICE ILEOCECAL"
  },
  {
    "codigo":10680991000119103,
    "descripcion":"NÓDULO DE PIEL DE PIERNA DERECHA"
  },
  {
    "codigo":314683001,
    "descripcion":"PESO DEL NIÑO: PERCENTILO 92-97"
  },
  {
    "codigo":414822009,
    "descripcion":"HEMORRAGIA PULMONAR NEONATAL"
  },
  {
    "codigo":52539004,
    "descripcion":"VAINA RETINIANA VASCULAR"
  },
  {
    "codigo":281915008,
    "descripcion":"FRACTURA DE PEDÍCULO DE VÉRTEBRA CERVICAL"
  },
  {
    "codigo":609595009,
    "descripcion":"LESIÓN DE RAMA DE NERVIO RADIAL"
  },
  {
    "codigo":443920001,
    "descripcion":"LACERACIÓN SIMPLE"
  },
  {
    "codigo":16101002,
    "descripcion":"ÚLCERA DE CIEGO"
  },
  {
    "codigo":212709006,
    "descripcion":"INTOXICACIÓN POR MORRUATO DE SODIO"
  },
  {
    "codigo":14266003,
    "descripcion":"ATROFIA DE LA GLÁNDULA TÍMICA"
  },
  {
    "codigo":1259450008,
    "descripcion":"CARCINOMA UROTELIAL PRIMARIO DE URÉTER IZQUIERDO"
  },
  {
    "codigo":307343001,
    "descripcion":"ENFERMEDAD ADQUIRIDA DE HEMOGLOBINA H"
  },
  {
    "codigo":12431004,
    "descripcion":"PUNTAJE DE APGAR 8"
  },
  {
    "codigo":241807005,
    "descripcion":"ENVENENAMIENTO CAUSADO POR VENENO DE CROTÁLIDO"
  },
  {
    "codigo":403812000,
    "descripcion":"SEUDOXANTOMA ELÁSTICO AUTOSÓMICO RECESIVO"
  },
  {
    "codigo":371044001,
    "descripcion":"DISTRÉS RESPIRATORIO TRANSITORIO CON SEPSIS"
  },
  {
    "codigo":10596002,
    "descripcion":"COMPLICACIÓN VASCULAR PERIFÉRICA"
  },
  {
    "codigo":239972001,
    "descripcion":"LESIÓN DE PARTES BLANDAS DE MUÑECA Y MANO"
  },
  {
    "codigo":43364001,
    "descripcion":"MALESTAR ABDOMINAL"
  },
  {
    "codigo":895332004,
    "descripcion":"CURVATURA ANORMAL DE FALANGE MEDIA DE QUINTO DEDO DE MANO"
  },
  {
    "codigo":305508002,
    "descripcion":"BAJO ATENCIÓN DE PATÓLOGO GENERAL"
  },
  {
    "codigo":270905000,
    "descripcion":"TRASTORNO DE LA VINCULACIÓN DE LA INFANCIA DESINHIBIDO"
  },
  {
    "codigo":74297002,
    "descripcion":"LESIÓN TRAUMÁTICA DE LAS RAÍCES NERVIOSAS CERVICALES"
  },
  {
    "codigo":238137006,
    "descripcion":"SOBRECARGA PROTEICA"
  },
  {
    "codigo":205369009,
    "descripcion":"SOBRECRECIMIENTO CONGÉNITO DE MIEMBRO INFERIOR"
  },
  {
    "codigo":269070003,
    "descripcion":"FRACTURA EXPUESTA DE COLUMNA VERTEBRAL CERVICAL"
  },
  {
    "codigo":400142003,
    "descripcion":"NEVO EPIDÉRMICO EPIDERMOLÍTICO"
  },
  {
    "codigo":236302005,
    "descripcion":"NEUMONITIS INTERSTICIAL AGUDA"
  },
  {
    "codigo":170766006,
    "descripcion":"PÉRDIDA DE ADVERTENCIA DE REACCIÓN HIPOGLUCÉMICA DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":203534009,
    "descripcion":"PIE PLANO ADQUIRIDO"
  },
  {
    "codigo":234467004,
    "descripcion":"TROMBOFILIA"
  },
  {
    "codigo":429240000,
    "descripcion":"GESTACIÓN EN EL TERCER TRIMESTRE, ANTES DE LAS 36 SEMANAS"
  },
  {
    "codigo":365539008,
    "descripcion":"HALLAZGO RELACIONADO CON EL TIPO DE TRABAJO"
  },
  {
    "codigo":396472006,
    "descripcion":"HALLAZGO RELACIONADO CON EL MARGEN DE RESECCIÓN QUIRÚRGICA DE VÍAS BILIARES"
  },
  {
    "codigo":298168007,
    "descripcion":"INFLAMACIÓN DE ARTICULACIÓN DE PULGAR"
  },
  {
    "codigo":789688007,
    "descripcion":"PODOCITURIA"
  },
  {
    "codigo":230797001,
    "descripcion":"COMA POSANÓXICO"
  },
  {
    "codigo":671361000124103,
    "descripcion":"INCAPAZ DE OBTENER SERVICIO DE INTERNET EN DOMICILIO DEBIDO A RECURSOS ECONÓMICOS LIMITADOS"
  },
  {
    "codigo":724152009,
    "descripcion":"TENDINOSIS"
  },
  {
    "codigo":198029003,
    "descripcion":"TRASTORNO VASCULAR DEL PENE"
  },
  {
    "codigo":641000124109,
    "descripcion":"NO CUMPLE CON LA PRESCRIPCIÓN DE DIÁLISIS PERITONEAL"
  },
  {
    "codigo":440961000124106,
    "descripcion":"INGESTA EXCESIVA DE FLUORURO"
  },
  {
    "codigo":66957007,
    "descripcion":"HIPOFUNCIÓN TESTICULAR IATROGÉNICA"
  },
  {
    "codigo":390967001,
    "descripcion":"PROBLEMA DE AUDÍFONO"
  },
  {
    "codigo":63287004,
    "descripcion":"HIPERTENSIÓN ESENCIAL BENIGNA EN EL CONTEXTO OBSTÉTRICO"
  },
  {
    "codigo":94220000,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LOS HUESOS DEL CRÁNEO"
  },
  {
    "codigo":61452007,
    "descripcion":"INTENTO FALLIDO DE ABORTO CON LACERACIÓN DE ÚTERO"
  },
  {
    "codigo":716812007,
    "descripcion":"MYCOBACTERIUM MUCOGENICUM O MYCOBACTERIUM PHOCAICUM"
  },
  {
    "codigo":125153001,
    "descripcion":"ESPÉCIMEN SATISFACTORIO PARA LA EVALUACIÓN PERO LIMITADO"
  },
  {
    "codigo":290828007,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR DOTIEPINA"
  },
  {
    "codigo":92385005,
    "descripcion":"NEOPLASIA BENIGNA DEL INTESTINO DELGADO"
  },
  {
    "codigo":59617007,
    "descripcion":"TRASTORNO BIPOLAR I DEPRESIVO GRAVE CON SÍNTOMAS PSICÓTICOS"
  },
  {
    "codigo":254390001,
    "descripcion":"CARCINOMA DE BORDE BERMELLÓN DE LABIO INFERIOR"
  },
  {
    "codigo":713142003,
    "descripcion":"CON MAYOR RIESGO DE TABAQUISMO PASIVO"
  },
  {
    "codigo":1268363006,
    "descripcion":"LUXACIÓN TRAUMÁTICA ABIERTA DE ARTICULACIÓN DE DEDO MEDIO DE MANO"
  },
  {
    "codigo":449163009,
    "descripcion":"NEVO MELANOCÍTICO DE PIEL DE LA PUNTA DE LA NARIZ"
  },
  {
    "codigo":709472003,
    "descripcion":"PERIODONTITIS DEBIDA A SÍNDROME DE PAPILLON-LEFÈVRE"
  },
  {
    "codigo":283488004,
    "descripcion":"HERIDA PUNZANTE EN EL TOBILLO"
  },
  {
    "codigo":185184005,
    "descripcion":"ATENDIDO EN CONSULTORIO ESPECIALIZADO EN TRASTORNOS DEL HABLA Y DEL LENGUAJE"
  },
  {
    "codigo":335111000119106,
    "descripcion":"CORIORRETINITIS FOCAL DERECHA"
  },
  {
    "codigo":445493000,
    "descripcion":"FRACTURA NO EXPUESTA DE CALOTA CRANEANA"
  },
  {
    "codigo":248885008,
    "descripcion":"FÍSTULA VAGINAL - HALLAZGO"
  },
  {
    "codigo":771338002,
    "descripcion":"AGUJEROS PARIETALES CON HIPOPLASIA CLAVICULAR"
  },
  {
    "codigo":50442003,
    "descripcion":"REUMATISMO PALINDRÓMICO"
  },
  {
    "codigo":312586003,
    "descripcion":"TROMBOFLEBITIS INTRACRANEAL"
  },
  {
    "codigo":1197322005,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS METASTÁSICO DE GANGLIO LINFÁTICO ABDOMINAL"
  },
  {
    "codigo":308641000119104,
    "descripcion":"GANGLIÓN DE RODILLA IZQUIERDA"
  },
  {
    "codigo":48607003,
    "descripcion":"GLÁNDULA PARÓTIDA ACCESORIA"
  },
  {
    "codigo":1162719007,
    "descripcion":"GAMMAGLUTAMIL TRANSFERASA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":409055009,
    "descripcion":"PERFUSIÓN TISULAR INEFECTIVA"
  },
  {
    "codigo":1259188004,
    "descripcion":"HEMATOMA DEBIDO A ARTROPLASTIA DE RODILLA Y POSTERIOR A ELLA"
  },
  {
    "codigo":472756005,
    "descripcion":"ESTENOSIS DE ANASTOMOSIS ENTRE CONFLUENCIA VENOSA PULMONAR Y AURÍCULA IZQUIERDA DESPUÉS DE REPARACIÓN PREVIA DE CONEXIÓN VENOSA PULMONAR ANÓMALA"
  },
  {
    "codigo":1193652005,
    "descripcion":"ENTERITIS POR BLASTOMYCES DERMATITIDIS"
  },
  {
    "codigo":733065003,
    "descripcion":"SÍNDROME DE MIOCLONÍA, ATAXIA CEREBELOSA Y SORDERA"
  },
  {
    "codigo":403550004,
    "descripcion":"APLASIA CUTÁNEA CONGÉNITA ASOCIADA CON EPIDERMÓLISIS BULLOSA (TIPO 6)"
  },
  {
    "codigo":15709601000119109,
    "descripcion":"HIPERPIGMENTACIÓN DE PÁRPADO INFERIOR DERECHO Y DE ÁREA PERIOCULAR DERECHA"
  },
  {
    "codigo":698462006,
    "descripcion":"CRIBADO PARA ANEURISMA AÓRTICO, ANORMAL"
  },
  {
    "codigo":74035001,
    "descripcion":"ATROFIA MUSCULAR POR DESNERVACIÓN"
  },
  {
    "codigo":41267003,
    "descripcion":"FALLA DE INJERTO DEBIDA A ESTENOSIS"
  },
  {
    "codigo":127171000119100,
    "descripcion":"CHOQUE SÉPTICO CONCOMITANTE CON DISFUNCIÓN ORGÁNICA AGUDA CAUSADO POR HAEMOPHILUS INFLUENZAE"
  },
  {
    "codigo":16470211000119100,
    "descripcion":"INCONTINENCIA URINARIA DEBIDA A ACCIDENTE CEREBROVASCULAR EMBÓLICO Y POSTERIOR A ÉL"
  },
  {
    "codigo":10981571000119100,
    "descripcion":"CUERPO EXTRAÑO ASPIRADO EN BRONQUIO"
  },
  {
    "codigo":86211000119102,
    "descripcion":"TRASTORNO RENAL BILATERAL POR REFLUJO VESICOURETERAL"
  },
  {
    "codigo":306371000119100,
    "descripcion":"GOTA TOFÁCEA CRÓNICA DE MÚLTIPLES LOCALIZACIONES CAUSADA POR FÁRMACO"
  },
  {
    "codigo":11775171000119104,
    "descripcion":"LACERACIÓN DE MÚSCULO DE BRAZO DERECHO"
  },
  {
    "codigo":164353731000119106,
    "descripcion":"TROMBOSIS VENOSA PROFUNDA AGUDA DURANTE PERÍODO POSPARTO"
  },
  {
    "codigo":785716931000119106,
    "descripcion":"ESPONDILOARTRITIS AXIAL NO RADIOGRÁFICA DE REGIÓN DORSOLUMBAR"
  },
  {
    "codigo":16068291000119108,
    "descripcion":"CROMOSOMA DICÉNTRICO"
  },
  {
    "codigo":16715971000119108,
    "descripcion":"INFARTO AGUDO DE INTESTINO DELGADO"
  },
  {
    "codigo":12246211000119101,
    "descripcion":"INFECCIÓN DEBIDA A TRASPLANTE DE MÉDULA ÓSEA Y POSTERIOR A ÉL"
  },
  {
    "codigo":15863491000119102,
    "descripcion":"TUMOR NEUROENDOCRINO BIEN DIFERENCIADO DE INTESTINO POSTERIOR"
  },
  {
    "codigo":1074371000119104,
    "descripcion":"ARTROSIS DE ARTICULACIÓN ACROMIOCLAVICULAR DERECHA"
  },
  {
    "codigo":1082051000119106,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE PIEL DE EXTREMIDAD SUPERIOR IZQUIERDA"
  },
  {
    "codigo":203272003,
    "descripcion":"TUBERCULOSIS DE HUESO DE PIERNA"
  },
  {
    "codigo":1153544008,
    "descripcion":"OCLUSIÓN DE ARTERIA CEREBRAL ANTERIOR DERECHA"
  },
  {
    "codigo":365277003,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA USAR ARTEFACTOS DE CALOR"
  },
  {
    "codigo":12107971000119108,
    "descripcion":"QUEMADURA QUÍMICA DE ESÓFAGO"
  },
  {
    "codigo":399880005,
    "descripcion":"NEVO EPIDÉRMICO ACANTOLÍTICO, NEVO CORNICULADO"
  },
  {
    "codigo":234205007,
    "descripcion":"TROMBOSIS DE FÍSTULA ARTERIOVENOSA"
  },
  {
    "codigo":299741008,
    "descripcion":"REFLEJO DE MORO PRESENTE"
  },
  {
    "codigo":301576009,
    "descripcion":"CAPAZ DE MOVILIZARSE CON SILLA DE RUEDAS"
  },
  {
    "codigo":2994004,
    "descripcion":"CANSANCIO CEREBRAL"
  },
  {
    "codigo":66695004,
    "descripcion":"ACRODINIA POR INTOXICACIÓN MERCURIAL"
  },
  {
    "codigo":33927004,
    "descripcion":"HIPOGONADISMO HIPOGONADOTRÓFICO"
  },
  {
    "codigo":296071006,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE NITRAZEPAM"
  },
  {
    "codigo":722055008,
    "descripcion":"SÍNDROME OCULOPALATOCEREBRAL"
  },
  {
    "codigo":294236001,
    "descripcion":"ALERGIA A METOCARBAMOL"
  },
  {
    "codigo":164999009,
    "descripcion":"PIEL: REACCIÓN TIPO 3 TARDÍA"
  },
  {
    "codigo":230535008,
    "descripcion":"INFLAMACIÓN DEL NERVIO TRIGÉMINO"
  },
  {
    "codigo":32092008,
    "descripcion":"NEUTROPENIA TÓXICA"
  },
  {
    "codigo":423473001,
    "descripcion":"IMPLANTE TUMORAL PERITONEAL PRESENTE"
  },
  {
    "codigo":30257002,
    "descripcion":"FIBRINÓLISIS ANORMAL"
  },
  {
    "codigo":128561003,
    "descripcion":"TRASTORNO GRANULOMATOSO"
  },
  {
    "codigo":95793004,
    "descripcion":"NISTAGMO INHIBIDO POR LA REMOCIÓN DE LA FIJACIÓN"
  },
  {
    "codigo":292401001,
    "descripcion":"REACCIÓN ADVERSA AL CLORPROTIXENO"
  },
  {
    "codigo":194097004,
    "descripcion":"EXOTROPÍA ALTERNANTE CON PATRÓN Y"
  },
  {
    "codigo":1074901000119108,
    "descripcion":"ARTRITIS DE ARTICULACIÓN MEDIOTARSIANA IZQUIERDA"
  },
  {
    "codigo":93958000,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL TEJIDO PERIRRENAL"
  },
  {
    "codigo":1306374003,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE PROLONGACIÓN AXILAR DE MAMA"
  },
  {
    "codigo":126726004,
    "descripcion":"NEOPLASIA DEL MEDIASTINO ANTERIOR"
  },
  {
    "codigo":13008751000119103,
    "descripcion":"PROCTOCOLITIS ALÉRGICA CAUSADA POR PROTEÍNA ALIMENTARIA"
  },
  {
    "codigo":10633071000119103,
    "descripcion":"CELULITIS DE TOBILLO DERECHO"
  },
  {
    "codigo":225030004,
    "descripcion":"ETAPA DE NEGOCIACIÓN EN EL PROCESO DE DUELO"
  },
  {
    "codigo":92123007,
    "descripcion":"NEOPLASIA BENIGNA DE LA GLOTIS"
  },
  {
    "codigo":26587008,
    "descripcion":"FALTA DE DESARROLLO SEXUAL"
  },
  {
    "codigo":286896005,
    "descripcion":"CARCINOMA DE MAMA - CUADRANTE INFEROEXTERNO"
  },
  {
    "codigo":24752008,
    "descripcion":"HIPEROSTOSIS CORTICAL INFANTIL"
  },
  {
    "codigo":221360009,
    "descripcion":"ESPASTICIDAD"
  },
  {
    "codigo":188592008,
    "descripcion":"ENFERMEDAD DE HODGKIN, AGOTAMIENTO DE LINFOCITOS ESPLÉNICOS"
  },
  {
    "codigo":184922000,
    "descripcion":"CINTURÓN DE SEGURIDAD, NO EXENTO"
  },
  {
    "codigo":709210000,
    "descripcion":"NEOPLASIA DE CÉLULAS GIGANTES DE HUESO DE LA PELVIS"
  },
  {
    "codigo":283226000,
    "descripcion":"ANZUELO EN EL DORSO PIE"
  },
  {
    "codigo":11999241000119102,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":447066005,
    "descripcion":"GRANULOMA POR CUERPO EXTRAÑO DE PENE"
  },
  {
    "codigo":1231663000,
    "descripcion":"RETINITIS PIGMENTARIA DEBIDA A ENFERMEDAD SISTÉMICA"
  },
  {
    "codigo":248623001,
    "descripcion":"QUEJIDO RESPIRATORIO"
  },
  {
    "codigo":707375006,
    "descripcion":"LEIOMIOMA DE PULMÓN ÚNICO"
  },
  {
    "codigo":838447008,
    "descripcion":"VESTIMENTA DESALIÑADA"
  },
  {
    "codigo":771076003,
    "descripcion":"LEPTOMIELOLIPOMA"
  },
  {
    "codigo":50180005,
    "descripcion":"INTOXICACIÓN POR DINAMITA"
  },
  {
    "codigo":408793000,
    "descripcion":"LÍQUIDO AMNIÓTICO CON MECONIO - GRADO II"
  },
  {
    "codigo":212185009,
    "descripcion":"LESIÓN TOTAL DE LA MÉDULA LUMBAR SIN LESIÓN ÓSEA"
  },
  {
    "codigo":1258926008,
    "descripcion":"RUPTURA DE COMPLEJO FIBROCARTILAGINOSO TRIANGULAR DE REGIÓN DE MUÑECA DERECHA"
  },
  {
    "codigo":110211006,
    "descripcion":"QUEMADURA DE PRIMER GRADO DE LA ENCÍA UNIDA A LA MANDÍBULA"
  },
  {
    "codigo":304984001,
    "descripcion":"ERITEMA GINGIVAL LINEAL"
  },
  {
    "codigo":403288001,
    "descripcion":"LESIÓN UNGUEAL POR HERBICIDA"
  },
  {
    "codigo":1288024001,
    "descripcion":"TUMOR NEUROENDOCRINO BIEN DIFERENCIADO DE CUERPO DE ÚTERO"
  },
  {
    "codigo":698200003,
    "descripcion":"SARCOMA DE EWING DE CÉLULAS GRANDES DE HUESO"
  },
  {
    "codigo":1255256006,
    "descripcion":"ESTENOSIS DE PORCIÓN PROXIMAL DE RAMA CIRCUNFLEJA DE ARTERIA CORONARIA IZQUIERDA"
  },
  {
    "codigo":237613005,
    "descripcion":"HIPERPROINSULINEMIA"
  },
  {
    "codigo":792834000,
    "descripcion":"PULSO EN ARTERIA FEMORAL DERECHA AUSENTE"
  },
  {
    "codigo":301314001,
    "descripcion":"CALOTA DELGADA"
  },
  {
    "codigo":1220653008,
    "descripcion":"HEMORRAGIA EXCESIVA DEBIDA A INTERRUPCIÓN COMPLETA INDUCIDA DE EMBARAZO Y POSTERIOR A ELLA"
  },
  {
    "codigo":71938000,
    "descripcion":"HIPERCALCIURIA"
  },
  {
    "codigo":235778004,
    "descripcion":"FÍSTULA INTERNA DEL INTESTINO GRUESO"
  },
  {
    "codigo":39170005,
    "descripcion":"FÍSTULA COLECISTODUODENAL"
  },
  {
    "codigo":168407000,
    "descripcion":"NO ES POSIBLE DESCARTAR NEOPLASIA GLANDULAR EN EL EXTENDIDO CERVICAL"
  },
  {
    "codigo":203010009,
    "descripcion":"MIOSITIS INFECCIOSA DE ESPALDA"
  },
  {
    "codigo":201175002,
    "descripcion":"POLIOSIS - ADQUIRIDA"
  },
  {
    "codigo":299479004,
    "descripcion":"HALLAZGO EN ARTICULACIÓN DE PIE"
  },
  {
    "codigo":397783007,
    "descripcion":"DISTRIBUCIÓN DE VENTILACIÓN:PERFUSIÓN"
  },
  {
    "codigo":365015008,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA PRONUNCIAR EL TONO APROPIADO"
  },
  {
    "codigo":725463007,
    "descripcion":"ANEMIA HIPOCRÓMICA CONGÉNITA SEVERA CON SIDEROBLASTOS EN ANILLO"
  },
  {
    "codigo":16697661000119105,
    "descripcion":"INFECCIÓN ASOCIADA CON ESFÍNTER URINARIO ARTIFICIAL"
  },
  {
    "codigo":232108003,
    "descripcion":"DESVIACIÓN VERTICAL DISOCIATIVA"
  },
  {
    "codigo":166572003,
    "descripcion":"AMILASA SÉRICA (PANCREÁTICA) FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":233943009,
    "descripcion":"HIPERTENSIÓN PULMONAR PRIMARIA ESPORÁDICA"
  },
  {
    "codigo":263041000,
    "descripcion":"SUBLUXACIÓN DE LA ARTICULACIÓN ATLANTO-OCCIPITAL"
  },
  {
    "codigo":363180009,
    "descripcion":"TRASTORNO INFLAMATORIO DE VÍAS RESPIRATORIAS"
  },
  {
    "codigo":295809003,
    "descripcion":"SOBREDOSIS DE FÁRMACO ANOREXÍGENO DE ACCIÓN CENTRAL"
  },
  {
    "codigo":426881004,
    "descripcion":"RETRASO MADURATIVO PARA LA ALIMENTACIÓN"
  },
  {
    "codigo":230273006,
    "descripcion":"DEGENERACIÓN FRONTOTEMPORAL"
  },
  {
    "codigo":721793008,
    "descripcion":"INFECCIÓN CAUSADA POR MAGNUSIOMYCES CAPITATUS"
  },
  {
    "codigo":228438002,
    "descripcion":"SUPLICA POR DROGAS"
  },
  {
    "codigo":195670004,
    "descripcion":"AMIGDALITIS GANGRENOSA AGUDA"
  },
  {
    "codigo":293974008,
    "descripcion":"ALERGIA A CARVEDILOL"
  },
  {
    "codigo":95531001,
    "descripcion":"DUODENITIS HEMORRÁGICA"
  },
  {
    "codigo":395016000,
    "descripcion":"TRATAMIENTO EXCESIVO"
  },
  {
    "codigo":292139003,
    "descripcion":"REACCIÓN ADVERSA A LA LACTULOSA"
  },
  {
    "codigo":290304000,
    "descripcion":"INTOXICACIÓN POR TENOXICAM"
  },
  {
    "codigo":93696001,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE VASO SANGUÍNEO DEL PIE"
  },
  {
    "codigo":421376003,
    "descripcion":"ALTERACIÓN VISUAL SUBJETIVA DEL TAMAÑO DE LA IMAGEN"
  },
  {
    "codigo":124629002,
    "descripcion":"DEFICIENCIA DE FORMIMINOTETRAHIDROFOLATO CICLODEAMINASA"
  },
  {
    "codigo":1304277005,
    "descripcion":"SÍNDROME DE DISCAPACIDAD INTELECTUAL, DISMORFIA CRANEOFACIAL, MACROCEFALIA, HIPOTONÍA AUTOSÓMICO DOMINANTE POR MUTACIÓN EN EL GEN H1-4"
  },
  {
    "codigo":59093008,
    "descripcion":"CIRCULACIÓN COLATERAL VENOSA"
  },
  {
    "codigo":91861009,
    "descripcion":"LEUCEMIA MIELOIDE AGUDA"
  },
  {
    "codigo":253866002,
    "descripcion":"ECTOPIA CRUZADA DE RIÑÓN CON ANOMALÍA DE FUSIÓN"
  },
  {
    "codigo":1204138004,
    "descripcion":"RECAMBIO ELECTIVO DE BATERÍA DE DESFIBRILADOR CARDIOVERSOR IMPLANTABLE REQUERIDO"
  },
  {
    "codigo":1079921000119103,
    "descripcion":"NEVO EPIDÉRMICO DE PIEL DE OREJA IZQUIERDA"
  },
  {
    "codigo":219263006,
    "descripcion":"LESIÓN POR INTERVENCIÓN LEGAL CON EXPLOSIVO"
  },
  {
    "codigo":710783007,
    "descripcion":"PRÓTESIS DENTAL PARCIAL REMOVIBLE CON PÉRDIDA DE RELACIÓN OCLUSAL"
  },
  {
    "codigo":16317041000119105,
    "descripcion":"MASTITIS PURULENTA DE MAMA IZQUIERDA DURANTE LA LACTANCIA"
  },
  {
    "codigo":284799008,
    "descripcion":"INCAPAZ DE REALIZAR ACTIVIDAD DE BAÑO"
  },
  {
    "codigo":414036003,
    "descripcion":"DISTANCIA DE ADENOMA DESDE MARGEN ANAL, DESCONOCIDA"
  },
  {
    "codigo":86356004,
    "descripcion":"SITUACIÓN INESTABLE DEL FETO"
  },
  {
    "codigo":1003860009,
    "descripcion":"CONDRODISPLASIA PUNTEADA RIZOMÉLICA TIPO 2"
  },
  {
    "codigo":18985003,
    "descripcion":"PAPILOMATOSIS VESTIBULAR"
  },
  {
    "codigo":342641000119108,
    "descripcion":"LUPUS ERITEMATOSO DISCOIDE DE PIEL DE PÁRPADO IZQUIERDO"
  },
  {
    "codigo":281129008,
    "descripcion":"VARIABILIDAD DEL HUMOR"
  },
  {
    "codigo":82686002,
    "descripcion":"QUERATITIS MICÓTICA CAUSADA POR FUSARIUM SOLANI"
  },
  {
    "codigo":408531002,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: PASHTO"
  },
  {
    "codigo":210088000,
    "descripcion":"LESIÓN NO EXPUESTA DE PLEURA"
  },
  {
    "codigo":373928002,
    "descripcion":"SENSACIÓN DE DISTENSIÓN"
  },
  {
    "codigo":898216003,
    "descripcion":"FUSIÓN ANORMAL CONGÉNITA DE HUESOS DE MANO"
  },
  {
    "codigo":111784003,
    "descripcion":"INTOXICACIÓN POR ACER RUBRUM"
  },
  {
    "codigo":46248003,
    "descripcion":"RASGO DE HEMOGLOBINA E"
  },
  {
    "codigo":109949000,
    "descripcion":"EFECTOS DE SUPLEMENTACIÓN HORMONAL"
  },
  {
    "codigo":208253001,
    "descripcion":"FRACTURA EXPUESTA DE HÚMERO PROXIMAL, TUBEROSIDAD MAYOR"
  },
  {
    "codigo":820063141000119101,
    "descripcion":"IRITIS DE OJO IZQUIERDO DEBIDA A PROCEDIMIENTO QUIRÚRGICO EN REGIÓN DE OJO IZQUIERDO Y POSTERIOR A ÉL"
  },
  {
    "codigo":699773007,
    "descripcion":"FRACTURA VERTICAL DE DIENTE SIN COMPROMISO DE LA PULPA"
  },
  {
    "codigo":271954000,
    "descripcion":"INTENTO FALLIDO DE ABORTO REALIZADO CON MÉTODOS NO QUIRÚRGICOS"
  },
  {
    "codigo":239186001,
    "descripcion":"CONJUNTIVITIS EPIDÉMICA AGUDA"
  },
  {
    "codigo":372093008,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA PROLONGACIÓN AXILAR DE LA MAMA"
  },
  {
    "codigo":403026008,
    "descripcion":"TIÑA CORPORAL CAUSADA POR MICROSPORUM DISTORTUM"
  },
  {
    "codigo":237351003,
    "descripcion":"PSICOSIS POSPARTO LEVE"
  },
  {
    "codigo":1187623009,
    "descripcion":"TRASTORNO DE GLICOSILACIÓN CONGÉNITO RELACIONADO A FOSFOGLUCOMUTASA 3"
  },
  {
    "codigo":202748002,
    "descripcion":"DISCITIS DORSAL"
  },
  {
    "codigo":366588001,
    "descripcion":"AMPLITUD DE MOVIMIENTO ACTIVO DE FLEXIÓN DE LA RODILLA - HALLAZGO"
  },
  {
    "codigo":169980002,
    "descripcion":"AMAMANTADO Y ALIMENTADO CON SUPLEMENTOS A LOS 3 MESES"
  },
  {
    "codigo":268284006,
    "descripcion":"HAMARTOMAS VASCULARES"
  },
  {
    "codigo":6140007,
    "descripcion":"EMBOTAMIENTO DEL AFECTO"
  },
  {
    "codigo":71676008,
    "descripcion":"DEFICIENCIA ADQUIRIDA EN LA VISIÓN DEL COLOR"
  },
  {
    "codigo":364753001,
    "descripcion":"APLICACIÓN DEL CUELLO UTERINO A LA PRESENTACIÓN - HALLAZGO"
  },
  {
    "codigo":102609007,
    "descripcion":"PROBLEMAS DE ALIMENTACIÓN EN LOS NIÑOS"
  },
  {
    "codigo":10939301000119108,
    "descripcion":"HERIDA ABIERTA DE BRAZO DERECHO"
  },
  {
    "codigo":723366001,
    "descripcion":"SÍNDROME DE MACROSTOMÍA, APÉNDICE PREAURICULAR Y OFTALMOPLEJÍA EXTERNA"
  },
  {
    "codigo":299217009,
    "descripcion":"PULGAR AMPUTADO"
  },
  {
    "codigo":428454002,
    "descripcion":"VÍCTIMA DE INTIMIDACIÓN FUERA DE LA ESCUELA"
  },
  {
    "codigo":788902004,
    "descripcion":"ENFERMEDAD CAUSADA POR EBOLAVIRUS BUNDIBUGYO"
  },
  {
    "codigo":231846009,
    "descripcion":"QUISTE DE LOS CONDUCTOS LAGRIMALES"
  },
  {
    "codigo":295547002,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE DESFLURANO"
  },
  {
    "codigo":721531006,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO A NIVEL DE ANTEBRAZO"
  },
  {
    "codigo":262779007,
    "descripcion":"HEMATOMA DE TIMO"
  },
  {
    "codigo":230011006,
    "descripcion":"POSICIÓN CAÍDA DEL TRONCO"
  },
  {
    "codigo":424784002,
    "descripcion":"QUEMADURA CAUSADA POR OBJETO CALIENTE"
  },
  {
    "codigo":195408002,
    "descripcion":"FLEBITIS DE VENA TIBIAL POSTERIOR"
  },
  {
    "codigo":293712006,
    "descripcion":"ALERGIA A ENFLURANO"
  },
  {
    "codigo":129872007,
    "descripcion":"TRASTORNO EN LAS HABILIDADES DE SOCIALIZACIÓN"
  },
  {
    "codigo":64336009,
    "descripcion":"PENSAMIENTO INCOHERENTE"
  },
  {
    "codigo":31568009,
    "descripcion":"MENINGITIS POR LISTERIA"
  },
  {
    "codigo":717861003,
    "descripcion":"GASTRITIS METAPLÁSICA"
  },
  {
    "codigo":29733004,
    "descripcion":"TRASTORNO DEL ESTADO DE ÁNIMO INDUCIDO POR OPIOIDE"
  },
  {
    "codigo":95269005,
    "descripcion":"QUERATOSIS POR TABACO SIN HUMO"
  },
  {
    "codigo":62501005,
    "descripcion":"DISPLASIA CONDROECTODÉRMICA"
  },
  {
    "codigo":422949007,
    "descripcion":"ASIMETRÍA MUSCULOESQUELÉTICA"
  },
  {
    "codigo":1082431000119108,
    "descripcion":"DILATACIÓN ADQUIRIDA DE CONDUCTO BILIAR"
  },
  {
    "codigo":291877008,
    "descripcion":"INTOXICACIÓN POR TIROTROFINA"
  },
  {
    "codigo":224506001,
    "descripcion":"ACUERDOS PARA EL CUIDADO INFORMAL DEFICIENTES"
  },
  {
    "codigo":93434009,
    "descripcion":"HIPERPLASIA GINGIVAL MEDICAMENTOSA"
  },
  {
    "codigo":12115161000119105,
    "descripcion":"QUEMADURA QUÍMICA DE TOBILLO DERECHO"
  },
  {
    "codigo":124367009,
    "descripcion":"DEFICIENCIA DE 3 - OXOADIPATO COA - TRANSFERASA"
  },
  {
    "codigo":24228002,
    "descripcion":"TÓRAX EN TONEL"
  },
  {
    "codigo":253604004,
    "descripcion":"DISPLASIA DE VÁLVULA AÓRTICA"
  },
  {
    "codigo":318681000119106,
    "descripcion":"ARTROSIS DE ARTICULACIÓN DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":1269412004,
    "descripcion":"MEDULOEPITELIOMA PRIMARIO DEL SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":188068007,
    "descripcion":"MELANOMA MALIGNO DE CADERA"
  },
  {
    "codigo":89764009,
    "descripcion":"ARTRITIS URLIANA"
  },
  {
    "codigo":10968281000119107,
    "descripcion":"LACERACIÓN DE DEDO GORDO DE PIE DERECHO"
  },
  {
    "codigo":251769005,
    "descripcion":"SUPRESIÓN DE IMAGEN RESIDUAL"
  },
  {
    "codigo":284537006,
    "descripcion":"QUEMADURA DE PÁRPADO"
  },
  {
    "codigo":708686000,
    "descripcion":"ÁNGULO DE PLANO MANDIBULAR HIPERDIVERGENTE"
  },
  {
    "codigo":448377009,
    "descripcion":"SARCOMA DE SACRO"
  },
  {
    "codigo":315470001,
    "descripcion":"NACIDO EN MADAGASCAR"
  },
  {
    "codigo":11787481000119109,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE DEDO ÍNDICE DERECHO"
  },
  {
    "codigo":86094006,
    "descripcion":"RINITIS CRÓNICA"
  },
  {
    "codigo":249934009,
    "descripcion":"DEBILIDAD FACIAL, NEURONA MOTORA SUPERIOR"
  },
  {
    "codigo":282702009,
    "descripcion":"CAPAZ DE EMPUJAR Y TIRAR DE UN OBJETO AL CORRER"
  },
  {
    "codigo":444707001,
    "descripcion":"GLUCOGENOSIS DE TIPO IA"
  },
  {
    "codigo":51491004,
    "descripcion":"JUEGO DE ROLES"
  },
  {
    "codigo":248099006,
    "descripcion":"CONDUCTA SEXUAL INAPROPIADA"
  },
  {
    "codigo":870691007,
    "descripcion":"REACCIÓN ADVERSA A INSULINA CINC"
  },
  {
    "codigo":11842931000119105,
    "descripcion":"LESIÓN TRAUMÁTICA DE ARTERIA CARÓTIDA IZQUIERDA"
  },
  {
    "codigo":279032003,
    "descripcion":"DOLOR PÉLVICO CRÓNICO SIN PATOLOGÍA EVIDENTE"
  },
  {
    "codigo":705016005,
    "descripcion":"CRISIS DE SALUD AGUDA"
  },
  {
    "codigo":211661000,
    "descripcion":"QUEMADURA DE LA CÓRNEA Y EL SACO CONJUNTIVAL POR SUSTANCIAS QUÍMICAS ALCALINAS"
  },
  {
    "codigo":47821001,
    "descripcion":"HEMORRAGIA POSTPARTO"
  },
  {
    "codigo":675341000119102,
    "descripcion":"LEUCOMA CORNEAL DE OJO IZQUIERDO"
  },
  {
    "codigo":703181009,
    "descripcion":"INSUFICIENCIA DE VÁLVULA PULMONAR POSTERIOR A PROCEDIMIENTO"
  },
  {
    "codigo":78754002,
    "descripcion":"ANGIOCOLECISTITIS"
  },
  {
    "codigo":111522004,
    "descripcion":"ARCOS SENILES"
  },
  {
    "codigo":406434004,
    "descripcion":"REACCIÓN ADVERSA AL TIANFENICOL"
  },
  {
    "codigo":275362006,
    "descripcion":"LACERACIÓN DE LA HOZ"
  },
  {
    "codigo":11816461000119104,
    "descripcion":"LESIÓN TRAUMÁTICA DE VENA AXILAR DERECHA"
  },
  {
    "codigo":240759004,
    "descripcion":"ESPOROTRICOSIS CUTÁNEA DISEMINADA"
  },
  {
    "codigo":109687006,
    "descripcion":"ABSCESO MANDIBULAR"
  },
  {
    "codigo":765047006,
    "descripcion":"ENFERMEDAD DE CHARCOT-MARIE-TOOTH TIPO 4 RELACIONADA CON SURF1, FACTOR DE ENSAMBLAJE DE CITOCROMO C OXIDASA"
  },
  {
    "codigo":1354871006,
    "descripcion":"LESIÓN TRAUMÁTICA DE VASO SANGUÍNEO DIGITAL DE DEDO ÍNDICE"
  },
  {
    "codigo":75084000,
    "descripcion":"DEPRESIÓN MAYOR GRAVE SIN SÍNTOMAS PSICÓTICOS"
  },
  {
    "codigo":1254732002,
    "descripcion":"METÁSTASIS DE CARCINOMA DE CÉLULAS GRANDES EN PULMÓN"
  },
  {
    "codigo":763212006,
    "descripcion":"DEFICIENCIA COMBINADA DE LIPASA PANCREÁTICA Y COLIPASA"
  },
  {
    "codigo":238924007,
    "descripcion":"PITIRIASIS AMIANTÁCEA"
  },
  {
    "codigo":1187361000,
    "descripcion":"LORDOSIS DE COLUMNA DEBIDA A TRASTORNO DE CADERA"
  },
  {
    "codigo":1285665003,
    "descripcion":"ENFERMEDAD LEVE POR DEFICIENCIA HEREDITARIA DE FACTOR IX CON INHIBIDOR DE ALTA RESPUESTA"
  },
  {
    "codigo":268022000,
    "descripcion":"OSTEOCONDRITIS JUVENIL DE LA CADERA Y LA PELVIS"
  },
  {
    "codigo":431862001,
    "descripcion":"RECHAZO AGUDO DE TRASPLANTE DE MÉDULA ÓSEA"
  },
  {
    "codigo":7713009,
    "descripcion":"HEMORRAGIA PONTINA"
  },
  {
    "codigo":347661000119109,
    "descripcion":"ABSCESO DE PÁRPADO DERECHO"
  },
  {
    "codigo":300790004,
    "descripcion":"DIFICULTAD PARA INICIAR JUEGO ESPONTÁNEO"
  },
  {
    "codigo":399094007,
    "descripcion":"HEMATURIA FAMILIAR"
  },
  {
    "codigo":724939000,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE EXTREMIDAD SUPERIOR IZQUIERDA ENTRE EL HOMBRO Y EL CODO"
  },
  {
    "codigo":298955003,
    "descripcion":"AMPLITUD DE FLEXIÓN PASIVA DE LA MUÑECA AUMENTADA"
  },
  {
    "codigo":200651009,
    "descripcion":"CELULITIS Y ABSCESO DE LA REGIÓN TEMPORAL"
  },
  {
    "codigo":723104008,
    "descripcion":"ÚLCERA GÁSTRICA CAUSADA POR RADIACIÓN IONIZANTE"
  },
  {
    "codigo":428192009,
    "descripcion":"LESIÓN TRAUMÁTICA DE HÚMERO"
  },
  {
    "codigo":721269002,
    "descripcion":"ABSCESO PIÓGENO DE PIEL CAUSADO POR BACTERIA"
  },
  {
    "codigo":460960009,
    "descripcion":"ORIGEN ANÓMALO DE LIGAMENTO ARTERIOSO EN AORTA DESCENDENTE DISTAL"
  },
  {
    "codigo":229749000,
    "descripcion":"AGNOSIA AUDITIVA CONGÉNITA"
  },
  {
    "codigo":295285003,
    "descripcion":"SOBREDOSIS INTENCIONAL DE OXIFENBUTAZONA"
  },
  {
    "codigo":33141009,
    "descripcion":"FRACTURA EXPUESTA DEL EXTREMO SUPERIOR DEL ANTEBRAZO"
  },
  {
    "codigo":293450004,
    "descripcion":"REACCIÓN ADVERSA A LOS ANTIARRÍTMICOS DE CLASE III"
  },
  {
    "codigo":129610005,
    "descripcion":"CEFALEA POR ENFERMEDAD INTRACRANEAL"
  },
  {
    "codigo":226079002,
    "descripcion":"DIETA CON MUY BAJO VALOR ENERGÉTICO"
  },
  {
    "codigo":95007002,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA REGIÓN POSCRICOIDEA"
  },
  {
    "codigo":291615009,
    "descripcion":"INTOXICACIÓN POR CEFPODOXIMA"
  },
  {
    "codigo":289780002,
    "descripcion":"HALLAZGO RELACIONADO CON LA DISPOSICIÓN DEL CUELLO UTERINO"
  },
  {
    "codigo":191476005,
    "descripcion":"ALUCINOSIS POR ABSTINENCIA ALCOHÓLICA"
  },
  {
    "codigo":1010676005,
    "descripcion":"NEOPLASIA BENIGNA DE CÉLULAS CLARAS DE PULMÓN"
  },
  {
    "codigo":60404007,
    "descripcion":"ABSCESO CEREBRAL"
  },
  {
    "codigo":58569000,
    "descripcion":"FIBROMATOSIS GINGIVAL"
  },
  {
    "codigo":224244009,
    "descripcion":"SIN ÁREAS COMUNALES DE ALOJAMIENTO"
  },
  {
    "codigo":677851000119101,
    "descripcion":"AGUJERO MACULAR DE AMBOS OJOS"
  },
  {
    "codigo":1172681005,
    "descripcion":"METAHEMALBÚMINA DENTRO DE RANGO DE REFERENCIA"
  },
  {
    "codigo":91337006,
    "descripcion":"INFECCIÓN CAUSADA POR DIGRAMMA"
  },
  {
    "codigo":23966000,
    "descripcion":"PÓLIPO DE SENO ETMOIDAL"
  },
  {
    "codigo":255177009,
    "descripcion":"NEOPLASIA BENIGNA DE HUESO FACIAL"
  },
  {
    "codigo":253342001,
    "descripcion":"PROLAPSO DE VÁLVULA DE EUSTAQUIO"
  },
  {
    "codigo":185971000,
    "descripcion":"PACIENTE QUE ESPERA ADMISIÓN PARA CIRUGÍA"
  },
  {
    "codigo":448115000,
    "descripcion":"ANEURISMA DE SENO DE VALSALVA AÓRTICO CON PROTRUSIÓN EN AURÍCULA IZQUIERDA"
  },
  {
    "codigo":89502008,
    "descripcion":"INTOXICACIÓN POR AESCULUS"
  },
  {
    "codigo":1201779005,
    "descripcion":"ULCERACIÓN NO INFECCIOSA DE INTESTINO DELGADO DEBIDA A ENFERMEDAD AUTOINMUNITARIA"
  },
  {
    "codigo":415347009,
    "descripcion":"ENCEFALITIS VIRAL DEL RÍO BRAVO"
  },
  {
    "codigo":249672002,
    "descripcion":"TÓRAX ASIMÉTRICO"
  },
  {
    "codigo":85832003,
    "descripcion":"LARINGITIS CAUSADA POR EL VIRUS DE LA PARAINFLUENZA"
  },
  {
    "codigo":315208005,
    "descripcion":"DIETA HIPOCALÓRICA PARA DIABÉTICOS"
  },
  {
    "codigo":118600007,
    "descripcion":"LINFOMA MALIGNO"
  },
  {
    "codigo":772125001,
    "descripcion":"ANOMALÍA DE RIÑÓN FETAL"
  },
  {
    "codigo":313373002,
    "descripcion":"HISTORIA CLÍNICA ENVIADA AL SOLICITANTE"
  },
  {
    "codigo":247837005,
    "descripcion":"MIEDO A ESCRIBIR EN PÚBLICO"
  },
  {
    "codigo":1163506001,
    "descripcion":"INFECCIÓN CAUSADA POR ASTROVIRIDAE"
  },
  {
    "codigo":311538008,
    "descripcion":"CAPAZ DE PROCESAR INFORMACIÓN CON PRECISIÓN"
  },
  {
    "codigo":80327007,
    "descripcion":"OTITIS MEDIA SEROSA"
  },
  {
    "codigo":323701000119105,
    "descripcion":"TUMOR TENOSINOVIAL DE CÉLULAS GIGANTES DIFUSO DE ARTICULACIÓN GLENOHUMERAL DERECHA"
  },
  {
    "codigo":43889001,
    "descripcion":"CONFIGURACIÓN DEL SOPLO CARDÍACO, CRECIENTE"
  },
  {
    "codigo":240497003,
    "descripcion":"ENFERMEDAD DE OCKELBO"
  },
  {
    "codigo":764785006,
    "descripcion":"TRASTORNO DE SUFRIMIENTO CORPORAL SEVERO"
  },
  {
    "codigo":1354609006,
    "descripcion":"FRACTURA DE FALANGE PROXIMAL DE ANULAR"
  },
  {
    "codigo":109425008,
    "descripcion":"VENTRÍCULO DERECHO ÚNICO"
  },
  {
    "codigo":238662007,
    "descripcion":"LIQUEN PLANO ORAL EROSIVO"
  },
  {
    "codigo":304198008,
    "descripcion":"AMPLITUD DE MOVIMIENTO PASIVO DE FLEXIÓN HORIZONTAL DE HOMBRO AUMENTADA"
  },
  {
    "codigo":369734008,
    "descripcion":"INVASIÓN TUMORAL DE VASO VENOSO EXTRAPARIETAL (DE GRAN CALIBRE) PRESENTE"
  },
  {
    "codigo":402502007,
    "descripcion":"CARCINOMA BASOCELULAR DE PUNTA NASAL"
  },
  {
    "codigo":171291004,
    "descripcion":"SIN CONSENTIMIENTO PARA VACUNACIÓN CONTRA HAEMOPHILUS INFLUENZAE TIPO B"
  },
  {
    "codigo":300528000,
    "descripcion":"PROBLEMA DEL PENE"
  },
  {
    "codigo":890352001,
    "descripcion":"DEFORMIDAD CONGÉNITA EN VALGO BILATERAL DE PRIMER DEDO DEL PIE"
  },
  {
    "codigo":234992005,
    "descripcion":"GINGIVITIS DE CÉLULAS PLASMÁTICAS"
  },
  {
    "codigo":202224005,
    "descripcion":"LUXACIÓN RECURRENTE DE ARTICULACIÓN RADIOCUBITAL PROXIMAL"
  },
  {
    "codigo":352681000119100,
    "descripcion":"MELANOMA MALIGNO PRIMARIO DE NERVIO PERIFÉRICO DE CADERA IZQUIERDA"
  },
  {
    "codigo":366064009,
    "descripcion":"VISIÓN BINOCULAR - HALLAZGO"
  },
  {
    "codigo":429765002,
    "descripcion":"NEOPLASIA BENIGNA DE BULBO RAQUÍDEO"
  },
  {
    "codigo":298693005,
    "descripcion":"PRUEBA DE LASÈGUE NEGATIVA"
  },
  {
    "codigo":34714000,
    "descripcion":"ESPASMO LOCAL"
  },
  {
    "codigo":427930001,
    "descripcion":"LINFEDEMA DEL ESCROTO"
  },
  {
    "codigo":724677009,
    "descripcion":"TRASTORNO DEL ESTADO DE ÁNIMO CON SÍNTOMAS DEPRESIVOS CAUSADO POR HIPNÓTICO"
  },
  {
    "codigo":722842006,
    "descripcion":"TEMOR A PADECER UNA ENFERMEDAD DIGESTIVA"
  },
  {
    "codigo":1279898008,
    "descripcion":"SÍNDROME DE CORDÓN CENTRAL DE MÉDULA TORÁCICA DEBIDO A FRACTURA NO EXPUESTA A NIVEL T1-T6"
  },
  {
    "codigo":295023000,
    "descripcion":"ALERGIA A CLORTALIDONA"
  },
  {
    "codigo":426095000,
    "descripcion":"PATRÓN DE USO NOCIVO CONTINUO DE INHALANTE VOLÁTIL"
  },
  {
    "codigo":721007005,
    "descripcion":"SÍNDROME DE DEFECTO DEL PELO CON FOTOSENSIBILIDAD Y DISCAPACIDAD INTELECTUAL"
  },
  {
    "codigo":1179759008,
    "descripcion":"HIPERPROGRESIÓN TUMORAL"
  },
  {
    "codigo":196719008,
    "descripcion":"ÚLCERA GASTROYEYUNAL CRÓNICA CON OBSTRUCCIÓN"
  },
  {
    "codigo":719172003,
    "descripcion":"DISPLASIA ESPONDILOMETAFISARIA TIPO 3-PRIMA-FOSFOADENOSINA 5-PRIMA-FOSFOSULFATO SINTASA TIPO 2"
  },
  {
    "codigo":162116003,
    "descripcion":"FRECUENCIA DE MICCIÓN AUMENTADA"
  },
  {
    "codigo":424260006,
    "descripcion":"CARCINOMA ESCAMOCELULAR DEL PLIEGUE NASOLABIAL"
  },
  {
    "codigo":1145156006,
    "descripcion":"INTOXICACIÓN ACCIDENTAL CAUSADA POR PLOMO Y\/O DERIVADO DE PLOMO"
  },
  {
    "codigo":717337001,
    "descripcion":"HIPOPLASIA SINDRÓMICA DEL REBORDE ORBITARIO"
  },
  {
    "codigo":61977001,
    "descripcion":"HEPATITIS VIRAL TIPO B CRÓNICA"
  },
  {
    "codigo":1208857001,
    "descripcion":"REGURGITACIÓN AÓRTICA PERIPROTÉSICA"
  },
  {
    "codigo":225817004,
    "descripcion":"NO ADOPTA EL PAPEL DE ENFERMO"
  },
  {
    "codigo":782873003,
    "descripcion":"AGRANDAMIENTO DE LABIOS VULVARES"
  },
  {
    "codigo":15671721000119108,
    "descripcion":"MACRODACTILIA DE DEDO DE PIE IZQUIERDO"
  },
  {
    "codigo":92910001,
    "descripcion":"FORMA ANORMAL CONGÉNITA DEL PERONÉ"
  },
  {
    "codigo":123843001,
    "descripcion":"NEOPLASIA DE OVARIO"
  },
  {
    "codigo":254915003,
    "descripcion":"CARCINOMA DE CÉLULAS CLARAS DE RIÑÓN"
  },
  {
    "codigo":449688000,
    "descripcion":"AMPOLLA DE MIEMBRO INFERIOR, CON INFECCIÓN"
  },
  {
    "codigo":416920000,
    "descripcion":"OBSTRUCCIÓN DE CANALÍCULO LAGRIMAL"
  },
  {
    "codigo":285848000,
    "descripcion":"CAPAZ DE CONTROLAR LA IRA"
  },
  {
    "codigo":56472003,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA PLEURA"
  },
  {
    "codigo":1268888008,
    "descripcion":"TUMOR DE PARÉNQUIMA DE GLÁNDULA PINEAL DE DIFERENCIACIÓN INTERMEDIA PRIMARIO"
  },
  {
    "codigo":21869003,
    "descripcion":"FORÚNCULO DE INGLE"
  },
  {
    "codigo":709997007,
    "descripcion":"ÁNGULO DEL PLANO MANDIBULAR INCLINADO"
  },
  {
    "codigo":251245007,
    "descripcion":"DEPRESIÓN DEL PR"
  },
  {
    "codigo":773698001,
    "descripcion":"ELASTOSIS DÉRMICA FOCAL DE INICIO TARDÍO"
  },
  {
    "codigo":247575000,
    "descripcion":"INTELIGENCIA POR DEBAJO DEL PROMEDIO"
  },
  {
    "codigo":249410009,
    "descripcion":"HALLAZGO DE ENCÍAS"
  },
  {
    "codigo":85570009,
    "descripcion":"ANEMIA POR DEFICIENCIA DE VITAMINA A"
  },
  {
    "codigo":50967008,
    "descripcion":"GANGLIOSIDOSIS"
  },
  {
    "codigo":737260001,
    "descripcion":"LESIÓN TRAUMÁTICA DE REGIÓN LUMBAR"
  },
  {
    "codigo":442348004,
    "descripcion":"QUERATOSIS SEBORREICA INFLAMADA"
  },
  {
    "codigo":278508007,
    "descripcion":"DISMORFOFOBIA DELIRANTE"
  },
  {
    "codigo":1359852007,
    "descripcion":"NEOPLASIA MALIGNA DE BERMELLÓN DE LABIO SUPERIOR"
  },
  {
    "codigo":1163244009,
    "descripcion":"TROMBOEMBOLIA PULMONAR POSQUIRÚRGICA"
  },
  {
    "codigo":49132009,
    "descripcion":"INTOXICACIÓN POR VERATRUM CALIFORNICUM"
  },
  {
    "codigo":473281000,
    "descripcion":"OBSTRUCCIÓN DE COLÉDOCO"
  },
  {
    "codigo":1259713006,
    "descripcion":"CARCINOMA UROTELIAL RICO EN LÍPIDOS PRIMARIO DE APARATO URINARIO"
  },
  {
    "codigo":735425008,
    "descripcion":"ABSCESO DE SISTEMA DIGESTIVO"
  },
  {
    "codigo":598051000005106,
    "descripcion":"PIERCING DE PEZÓN"
  },
  {
    "codigo":110998005,
    "descripcion":"CATARATA AXIAL"
  },
  {
    "codigo":405910006,
    "descripcion":"AUSENCIA DE NECROSIS TUMORAL"
  },
  {
    "codigo":209302007,
    "descripcion":"FRACTURA-LUXACIÓN NO EXPUESTA DE DÍGITO"
  },
  {
    "codigo":307606005,
    "descripcion":"OSTEOCONDROMA DE HUESO"
  },
  {
    "codigo":10859002,
    "descripcion":"FRACTURA DE SENO ETMOIDAL"
  },
  {
    "codigo":404075002,
    "descripcion":"OSTEOMA DE LAS MUCOSAS"
  },
  {
    "codigo":1256043002,
    "descripcion":"TROMBOFLEBITIS SUPERFICIAL POSTERIOR A ADMINISTRACIÓN DE FÁRMACO POR VÍA INTRAVENOSA"
  },
  {
    "codigo":764523004,
    "descripcion":"TRICOMEGALIA FAMILIAR AISLADA"
  },
  {
    "codigo":240235005,
    "descripcion":"DEFORMIDAD FIJA EN EXTENSIÓN DE ARTICULACIÓN DEL PULGAR"
  },
  {
    "codigo":11987831000119104,
    "descripcion":"QUEMADURA EPIDÉRMICA DE MUSLO DERECHO"
  },
  {
    "codigo":1092471000119105,
    "descripcion":"CHOQUE SÉPTICO CONCOMITANTE CON DISFUNCIÓN ORGÁNICA AGUDA DEBIDO A CHROMOBACTERIUM"
  },
  {
    "codigo":698987009,
    "descripcion":"LINFEDEMA DEBIDO A ENFERMEDAD ENDOCRINA"
  },
  {
    "codigo":369472002,
    "descripcion":"TUMOR MALIGNO QUE COMPROMETE VEJIGA URINARIA POR PROPAGACIÓN DIRECTA DE PRÓSTATA"
  },
  {
    "codigo":305771005,
    "descripcion":"ATENDIDO POR PODÓLOGO HOSPITALARIO"
  },
  {
    "codigo":10759031000119106,
    "descripcion":"CARDIOPATÍA HIPERTENSIVA PREEXISTENTE EN LA MADRE QUE COMPLICA EL EMBARAZO"
  },
  {
    "codigo":402240006,
    "descripcion":"LIQUEN SIMPLE DE ESCROTO"
  },
  {
    "codigo":105493001,
    "descripcion":"RETIRO, EVENTO DEL CICLO VITAL"
  },
  {
    "codigo":236565006,
    "descripcion":"DRENAJE ESCASO DEL CATÉTER DE DIÁLISIS PERITONEAL"
  },
  {
    "codigo":1186837006,
    "descripcion":"INSUFICIENCIA HIPOFISARIA DEBIDA A TRASTORNO METABÓLICO"
  },
  {
    "codigo":890090001,
    "descripcion":"PRURITO DE MANO BILATERAL"
  },
  {
    "codigo":300266001,
    "descripcion":"HALLAZGO RELACIONADO CON MEDICIONES DE CONDUCTO SALIVAL"
  },
  {
    "codigo":365802003,
    "descripcion":"NIVEL DE ALFA-FETOPROTEÍNA"
  },
  {
    "codigo":5354002,
    "descripcion":"HIPERCALIEMIA, CAMBIOS TRANSCELULARES"
  },
  {
    "codigo":398570005,
    "descripcion":"DIARREA CAUSADA POR TOXINA ESTAFILOCÓCICA"
  },
  {
    "codigo":298431002,
    "descripcion":"AMPLITUD DE FLEXIÓN LATERAL ACTIVA HACIA LA DERECHA DE LA COLUMNA VERTEBRAL CERVICAL, DISMINUIDA"
  },
  {
    "codigo":3519007,
    "descripcion":"TRASTORNO DE MEMBRANA SINOVIAL"
  },
  {
    "codigo":1345172000,
    "descripcion":"LESIÓN SUBEPITELIAL DE TRACTO GASTROINTESTINAL"
  },
  {
    "codigo":427668002,
    "descripcion":"DOLOR IRRADIADO AL ABDOMEN MEDIO"
  },
  {
    "codigo":15729681000119106,
    "descripcion":"COXA MAGNA BILATERAL DE FÉMURES"
  },
  {
    "codigo":294761004,
    "descripcion":"ALERGIA A NANDROLONA"
  },
  {
    "codigo":30782001,
    "descripcion":"SOPLO DIASTÓLICO"
  },
  {
    "codigo":164881000119109,
    "descripcion":"ÚLCERA DE PIE DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":302251000119103,
    "descripcion":"QUISTE ÓSEO ANEURISMÁTICO DE RADIO DERECHO"
  },
  {
    "codigo":718910006,
    "descripcion":"DISCAPACIDAD INTELECTUAL LIGADA AL CROMOSOMA X TIPO STOCCO DOS SANTOS"
  },
  {
    "codigo":423998007,
    "descripcion":"COLOR DE LA SANGRE - HALLAZGO"
  },
  {
    "codigo":1144894004,
    "descripcion":"NEUROPATÍA AUTÓNOMA PERIFÉRICA DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":225555001,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN EN HOMBRO"
  },
  {
    "codigo":422163002,
    "descripcion":"PULSO DEL PIE AUSENTE"
  },
  {
    "codigo":94483003,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA PIEL PERIANAL"
  },
  {
    "codigo":43011000087100,
    "descripcion":"CUERPO EXTRAÑO DE MAMA DERECHA"
  },
  {
    "codigo":192787004,
    "descripcion":"DEFICIENCIA DE HEXOSAMINIDASA A, VARIANTE B"
  },
  {
    "codigo":40451000087102,
    "descripcion":"CUERPO EXTRAÑO EN EXTREMIDAD INFERIOR IZQUIERDA"
  },
  {
    "codigo":48131000087102,
    "descripcion":"FRACTURA DE APÓFISIS CORACOIDES DE OMÓPLATO DERECHO"
  },
  {
    "codigo":127251008,
    "descripcion":"NEOPLASIA DE LOS GANGLIOS LINFÁTICOS INTESTINALES"
  },
  {
    "codigo":289256000,
    "descripcion":"PARTURIENTA QUE DIO A LUZ"
  },
  {
    "codigo":715240000,
    "descripcion":"DISPLASIA DE RETINA LIGADA AL CROMOSOMA X"
  },
  {
    "codigo":61715008,
    "descripcion":"ENFERMEDAD CELÍACA CON ULCERACIÓN INTESTINAL DIFUSA"
  },
  {
    "codigo":50691000087106,
    "descripcion":"LUMEN Y PARED DE INTESTINO GRUESO NORMALES"
  },
  {
    "codigo":11771051000119106,
    "descripcion":"ESGUINCE DE LIGAMENTO DE ARTICULACIÓN DE CODO DERECHO"
  },
  {
    "codigo":25277000,
    "descripcion":"SIDEROSIS DEL OJO"
  },
  {
    "codigo":92648009,
    "descripcion":"CARCINOMA IN SITU DEL TERCIO INFERIOR DEL ESÓFAGO"
  },
  {
    "codigo":713405002,
    "descripcion":"CARDIOPATÍA ISQUÉMICA SUBAGUDA"
  },
  {
    "codigo":254653005,
    "descripcion":"CARCINOMA ESCAMOSO FUSOCELULAR DE LA PIEL"
  },
  {
    "codigo":418493005,
    "descripcion":"TAQUICARDIA AURICULAR POSTINCISIONAL"
  },
  {
    "codigo":16905541000119102,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE PIEL DE PÁRPADO INFERIOR IZQUIERDO"
  },
  {
    "codigo":416658003,
    "descripcion":"HIPERTROFIA PAPILAR DE LA CONJUNTIVA"
  },
  {
    "codigo":1137554004,
    "descripcion":"CICATRIZ DE POLO POSTERIOR DE LA RETINA DE AMBOS OJOS"
  },
  {
    "codigo":449426008,
    "descripcion":"CONTINUACIÓN DE VENA CAVA INFERIOR EN VENA ÁCIGOS IZQUIERDA HACIA VENA CAVA SUPERIOR IZQUIERDA"
  },
  {
    "codigo":283751003,
    "descripcion":"MORDEDURA DE PERRO EN EL CODO"
  },
  {
    "codigo":414823004,
    "descripcion":"NEOPLASIA QUE AFECTA ESTRUCTURA HEMATOPOYÉTICA"
  },
  {
    "codigo":250983006,
    "descripcion":"ABOMBAMIENTO DE VALVA DE AORTA BICÚSPIDE"
  },
  {
    "codigo":314684007,
    "descripcion":"PESO DEL NIÑO: PERCENTILO 98"
  },
  {
    "codigo":249148008,
    "descripcion":"SEGMENTO UTERINO INFERIOR HIPERTÓNICO DURANTE EL TRABAJO DE PARTO"
  },
  {
    "codigo":281916009,
    "descripcion":"FRACTURA DE APÓFISIS TRANSVERSA DE VÉRTEBRA CERVICAL"
  },
  {
    "codigo":50705009,
    "descripcion":"TRASTORNO FACTICIO"
  },
  {
    "codigo":212710001,
    "descripcion":"INTOXICACIÓN POR SAL DE CINC"
  },
  {
    "codigo":16102009,
    "descripcion":"COMPLICACIÓN POSTMASTOIDECTOMÍA"
  },
  {
    "codigo":276411001,
    "descripcion":"TESTÍCULO PEQUEÑO"
  },
  {
    "codigo":1259451007,
    "descripcion":"ADENOCARCINOMA OXIFÍLICO PRIMARIO"
  },
  {
    "codigo":77968000,
    "descripcion":"EFECTOS DE LA EXPOSICIÓN ACCIDENTAL A UN AGENTE EXTERNO"
  },
  {
    "codigo":241808000,
    "descripcion":"ENVENENAMIENTO CAUSADO POR VENENO DE SERPIENTE DE LA FAMILIA DE LA COBRA"
  },
  {
    "codigo":11718111000119106,
    "descripcion":"MASA DE PARTES BLANDAS DE MIEMBRO INFERIOR IZQUIERDO"
  },
  {
    "codigo":15977951000119106,
    "descripcion":"MUCOCELE DE SACO LAGRIMAL DE AMBOS OJOS"
  },
  {
    "codigo":371045000,
    "descripcion":"SÍNDROME DE DOWN POR TRANSLOCACIÓN"
  },
  {
    "codigo":733328008,
    "descripcion":"OFTALMOPATÍA RESTRICTIVA"
  },
  {
    "codigo":403813005,
    "descripcion":"CUTIS LAXA CONGÉNITA LOCALIZADA"
  },
  {
    "codigo":10597006,
    "descripcion":"TRASTORNO DE BOLSA SEROSA"
  },
  {
    "codigo":331231000119108,
    "descripcion":"CUERPO EXTRAÑO RETENIDO EN PÁRPADO INFERIOR DERECHO"
  },
  {
    "codigo":698725008,
    "descripcion":"DEMENCIA ASOCIADA CON NEUROSÍFILIS"
  },
  {
    "codigo":238138001,
    "descripcion":"INCORPORACIÓN EXCESIVA DE MICRONUTRIENTES"
  },
  {
    "codigo":895333009,
    "descripcion":"CURVATURA ANORMAL DE FALANGE DE DEDO ÍNDICE"
  },
  {
    "codigo":140921000119102,
    "descripcion":"ACCIDENTE CEREBROVASCULAR ISQUÉMICO SIN COMA"
  },
  {
    "codigo":270906004,
    "descripcion":"RUPTURA DE CUERDA MITRAL"
  },
  {
    "codigo":205370005,
    "descripcion":"CRECIMIENTO EXCESIVO CONGÉNITO DE EXTREMIDAD INFERIOR PROXIMAL"
  },
  {
    "codigo":305509005,
    "descripcion":"BAJO ATENCIÓN DE HEMATÓLOGO"
  },
  {
    "codigo":8762007,
    "descripcion":"HIPERTENSIÓN CRÓNICA EN EL CONTEXTO OBSTÉTRICO"
  },
  {
    "codigo":269071004,
    "descripcion":"FRACTURA EXPUESTA DEL ATLAS"
  },
  {
    "codigo":15705721000119105,
    "descripcion":"DEPÓSITO DE CALCIO EN BOLSA SEROSA DE AMBAS RODILLAS"
  },
  {
    "codigo":37860001,
    "descripcion":"MAZOPLASIA"
  },
  {
    "codigo":365540005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA RECONOCER OBJETOS VISUALMENTE"
  },
  {
    "codigo":234468009,
    "descripcion":"DEFICIENCIA DE COFACTOR II DE HEPARINA"
  },
  {
    "codigo":396473001,
    "descripcion":"MARGEN QUIRÚRGICO DE VÍAS BILIARES COMPROMETIDO POR CARCINOMA IN SITU"
  },
  {
    "codigo":36025004,
    "descripcion":"TUMOR FIBROSO DE PIEL DE ESCLEROSIS TUBEROSA"
  },
  {
    "codigo":789689004,
    "descripcion":"GRANULOMATOSIS LINFOMATOIDE MALIGNA"
  },
  {
    "codigo":298169004,
    "descripcion":"INFLAMACIÓN DE ARTICULACIÓN DE CADERA"
  },
  {
    "codigo":687891000119102,
    "descripcion":"RABDOMIOSARCOMA PRIMARIO DE PERINEO"
  },
  {
    "codigo":66958002,
    "descripcion":"ISOINMUNIZACIÓN POR INCOMPATIBILIDAD POR GRUPO DE SANGRE NO ABO, NO RH, QUE AFECTA EL EMBARAZO"
  },
  {
    "codigo":296334003,
    "descripcion":"SOBREDOSIS DE FÁRMACO QUE ACTÚA SOBRE EL SISTEMA NERVIOSO AUTÓNOMO"
  },
  {
    "codigo":230798006,
    "descripcion":"COMA HIPOTÉRMICO"
  },
  {
    "codigo":198030008,
    "descripcion":"PARÁLISIS PERIÓDICA"
  },
  {
    "codigo":1179235002,
    "descripcion":"TRASTORNO CAUSADO POR STENT URETERAL"
  },
  {
    "codigo":294499007,
    "descripcion":"ALERGIA A BENCILPENICILINA"
  },
  {
    "codigo":194360001,
    "descripcion":"NISTAGMO POSICIONAL CENTRAL"
  },
  {
    "codigo":292664004,
    "descripcion":"REACCIÓN ADVERSA AL ÁCIDO GAMOLÉNICO"
  },
  {
    "codigo":434011000124101,
    "descripcion":"DOLOR TORÁCICO CRÓNICO"
  },
  {
    "codigo":126989001,
    "descripcion":"NEOPLASIA DE LOS NERVIOS PERIFÉRICOS DE LOS MIEMBROS INFERIORES"
  },
  {
    "codigo":716813002,
    "descripcion":"MYCOBACTERIUM LACTICOLA O MYCOBACTERIUM NEOAURUM"
  },
  {
    "codigo":94221001,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE HUESO DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":30520009,
    "descripcion":"TRASTORNO BIPOLAR II GRAVE, EPISODIO MÁS RECIENTE DE CARACTERÍSTICAS DEPRESIVAS PROFUNDAS CON SÍNTOMAS PSICÓTICOS"
  },
  {
    "codigo":1306637009,
    "descripcion":"RADIOGRAFÍA DE PARTES BLANDAS DE CARA ANORMAL"
  },
  {
    "codigo":878818001,
    "descripcion":"FARINGOAMIGDALITIS"
  },
  {
    "codigo":288994004,
    "descripcion":"CAPAZ DE BEBER DE UNA BOTELLA"
  },
  {
    "codigo":420066004,
    "descripcion":"RETRASO EN EL TRANSPORTE"
  },
  {
    "codigo":92386006,
    "descripcion":"NEOPLASIA BENIGNA DEL VELO DEL PALADAR"
  },
  {
    "codigo":125154007,
    "descripcion":"ESPÉCIMEN INSATISFACTORIO PARA EVALUACIÓN"
  },
  {
    "codigo":1335735002,
    "descripcion":"NECROSIS AVASCULAR DE PELVIS"
  },
  {
    "codigo":1237431007,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ACEITE LUBRICANTE AUTOMOTRIZ"
  },
  {
    "codigo":333741000119105,
    "descripcion":"SÍNDROME DE MÚLTIPLES PUNTOS BLANCOS EVANESCENTES DE OJO DERECHO"
  },
  {
    "codigo":449164003,
    "descripcion":"LEIOMIOMA DE ÚTERO PEDUNCULADO"
  },
  {
    "codigo":10629191000119100,
    "descripcion":"BRONQUIOLITIS CAUSADA POR VIRUS INFLUENZA"
  },
  {
    "codigo":185185006,
    "descripcion":"ATENDIDO EN CONSULTORIO ESPECIALIZADO EN ATENCIÓN DE PACIENTE SANO"
  },
  {
    "codigo":283489007,
    "descripcion":"HERIDA PUNZANTE EN EL PIE"
  },
  {
    "codigo":314422000,
    "descripcion":"INTOXICACIÓN POR CARAMIFENO"
  },
  {
    "codigo":609334006,
    "descripcion":"LESIÓN SUPERFICIAL DE EXTREMIDAD INFERIOR SIN INFECCIÓN"
  },
  {
    "codigo":1197323000,
    "descripcion":"CARCINOMA METASTÁSICO DE GANGLIO LINFÁTICO DE TÓRAX"
  },
  {
    "codigo":871478009,
    "descripcion":"PRESENTACIÓN DE FETO NO ENCAJADA"
  },
  {
    "codigo":771339005,
    "descripcion":"HIPERCINCEMIA E HIPERCALPROTECTINEMIA"
  },
  {
    "codigo":307271000119105,
    "descripcion":"ARTRITIS ENTEROPÁTICA DE ARTICULACIÓN RADIOCARPIANA"
  },
  {
    "codigo":12103751000119105,
    "descripcion":"QUEMADURA DE PIE IZQUIERDO"
  },
  {
    "codigo":247051009,
    "descripcion":"CRISTALINO TRÉMULO"
  },
  {
    "codigo":472757001,
    "descripcion":"HIPERTENSIÓN VENOSA PULMONAR COMO COMPLICACIÓN DE PROCEDIMIENTO"
  },
  {
    "codigo":210613004,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE PULGAR A TRAVÉS DE METACARPIANO"
  },
  {
    "codigo":46773004,
    "descripcion":"FRACTURA DE QUERVAIN"
  },
  {
    "codigo":308917006,
    "descripcion":"HALLAZGOS SINTOMÁTICOS EN RELACIÓN CON EL TIEMPO"
  },
  {
    "codigo":14005005,
    "descripcion":"INFESTACIÓN CAUSADA POR DERMANYSSUS GALLINAE"
  },
  {
    "codigo":208778001,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN DE HOMBRO"
  },
  {
    "codigo":733066002,
    "descripcion":"SÍNDROME DE TRIGONOCEFALIA, BAJA ESTATURA Y RETRASO DEL DESARROLLO"
  },
  {
    "codigo":700298002,
    "descripcion":"XERODERMIA DE PÁRPADO INFERIOR"
  },
  {
    "codigo":896906006,
    "descripcion":"FORMA ANCHA ANORMAL CONGÉNITA DE FALANGE DISTAL DE TERCER DEDO DE PIE"
  },
  {
    "codigo":77706007,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO SENSITIVO CUTÁNEO DE MIEMBRO INFERIOR"
  },
  {
    "codigo":10335000,
    "descripcion":"INSUFICIENCIA VENTRICULAR DERECHA CRÓNICA"
  },
  {
    "codigo":698463001,
    "descripcion":"CON MAYOR RIESGO DE ENFERMEDAD RENAL CRÓNICA"
  },
  {
    "codigo":403551000,
    "descripcion":"APLASIA CUTÁNEA CONGÉNITA POR FÁRMACO TERATÓGENO (TIPO 7)"
  },
  {
    "codigo":15681761000119106,
    "descripcion":"ENOFTALMÍA DE OJO IZQUIERDO DEBIDA A SÍNDROME DEL SENO SILENCIOSO"
  },
  {
    "codigo":205108007,
    "descripcion":"CONTRACTURA EN FLEXIÓN CONGÉNITA DE LA CADERA"
  },
  {
    "codigo":237876008,
    "descripcion":"ARTRITIS SECUNDARIA A AMILOIDOSIS"
  },
  {
    "codigo":301577000,
    "descripcion":"INCAPAZ DE MOVILIZARSE CON SILLA DE RUEDAS"
  },
  {
    "codigo":299742001,
    "descripcion":"REFLEJO DE MORO AUSENTE"
  },
  {
    "codigo":1153545009,
    "descripcion":"OCLUSIÓN DE ARTERIA CEREBRAL ANTERIOR IZQUIERDA"
  },
  {
    "codigo":1348318004,
    "descripcion":"CANTIDAD MODERADA DE SANGRE HEMOLIZADA DETECTADA EN ORINA MEDIANTE TIRA REACTIVA"
  },
  {
    "codigo":234206008,
    "descripcion":"INFECCIÓN DE FÍSTULA ARTERIOVENOSA"
  },
  {
    "codigo":232371001,
    "descripcion":"HEMORRAGIA DESDE EL LECHO ADENOIDEO"
  },
  {
    "codigo":168670008,
    "descripcion":"RADIOGRAFÍA SIMPLE DE RÓTULA NORMAL"
  },
  {
    "codigo":48947008,
    "descripcion":"ATRICIÓN DENTAL ANORMAL"
  },
  {
    "codigo":15930781000119100,
    "descripcion":"NEOPLASIA CON BAJO POTENCIAL DE COMPORTAMIENTO MALIGNO DE OVARIO IZQUIERDO"
  },
  {
    "codigo":107421000119101,
    "descripcion":"ACIDOSIS NEONATAL"
  },
  {
    "codigo":365278008,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA UTILIZAR INSTALACIONES PARA EL LAVADO"
  },
  {
    "codigo":544102301000119103,
    "descripcion":"DISTROFIA ESTROMAL CORNEAL BILATERAL"
  },
  {
    "codigo":396211008,
    "descripcion":"ESPÉCIMEN SIN GLÁNDULA SUPRARRENAL"
  },
  {
    "codigo":99741000119100,
    "descripcion":"ADENOCARCINOMA IN SITU EN ADENOMA VELLOSO"
  },
  {
    "codigo":12208541000119106,
    "descripcion":"POSICIÓN ANÓMALA DE LENTE INTRAOCULAR DERECHO"
  },
  {
    "codigo":1075101000119107,
    "descripcion":"PRIMER DEDO EN MARTILLO DE PIE IZQUIERDO, ADQUIRIDO"
  },
  {
    "codigo":197768004,
    "descripcion":"PIELONEFRITIS AGUDA SIN NECROSIS MEDULAR"
  },
  {
    "codigo":89501000119108,
    "descripcion":"RETARDO LEVE DEL LENGUAJE RECEPTIVO"
  },
  {
    "codigo":1077661000119109,
    "descripcion":"OSTEOMIELITIS DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":660381000119107,
    "descripcion":"INMUNIDAD CONTRA HAEMOPHILUS INFLUENZAE DETERMINADA POR SEROLOGÍA"
  },
  {
    "codigo":299421000119107,
    "descripcion":"NÓDULO REUMATOIDEO DE TEJIDO CELULAR SUBCUTÁNEO DE PIE"
  },
  {
    "codigo":165000009,
    "descripcion":"REACCIÓN CUTÁNEA DE HIPERSENSIBILIDAD TIPO 1"
  },
  {
    "codigo":309661000119108,
    "descripcion":"GOTA CRÓNICA PRIMARIA SIN TOFO DE TOBILLO Y\/O PIE"
  },
  {
    "codigo":722056009,
    "descripcion":"SÍNDROME OCULOCEREBROFACIAL TIPO KAUFMAN"
  },
  {
    "codigo":230536009,
    "descripcion":"HERPES ZÓSTER TRIGEMINAL AGUDO"
  },
  {
    "codigo":294237005,
    "descripcion":"ALERGIA A DANTROLENO"
  },
  {
    "codigo":32093003,
    "descripcion":"NEFRITIS TUBULOINTERSTICIAL AGUDA MEDICAMENTOSA"
  },
  {
    "codigo":336251000119107,
    "descripcion":"CATARATA NEGRA DE OJO DERECHO"
  },
  {
    "codigo":95794005,
    "descripcion":"SÍNDROME DE TOLOSA - HUNT"
  },
  {
    "codigo":128562005,
    "descripcion":"CARDIOPATÍA INFECCIOSA DE ORIGEN BACTERIANO"
  },
  {
    "codigo":292402008,
    "descripcion":"REACCIÓN ADVERSA AL DECANOATO DE FLUPENTIXOL"
  },
  {
    "codigo":225031000,
    "descripcion":"ETAPA DE NEGACIÓN EN EL PROCESO DE DUELO"
  },
  {
    "codigo":1306375002,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE PORCIÓN CENTRAL DE MAMA"
  },
  {
    "codigo":388871003,
    "descripcion":"MENINGIOMA PRIMARIO DE LA VAINA DEL NERVIO ÓPTICO"
  },
  {
    "codigo":126727008,
    "descripcion":"NEOPLASIA DEL MEDIASTINO POSTERIOR"
  },
  {
    "codigo":92124001,
    "descripcion":"NEOPLASIA BENIGNA DE GRANDES VASOS"
  },
  {
    "codigo":93959008,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE FALANGE DEL PIE"
  },
  {
    "codigo":301491009,
    "descripcion":"CAPAZ DE SUBIR Y BAJAR EL CORDÓN DE LA ACERA"
  },
  {
    "codigo":288732007,
    "descripcion":"CAPAZ DE RESPONDER A LA COMUNICACIÓN ESTABLECIDA POR OTROS"
  },
  {
    "codigo":59356009,
    "descripcion":"ÚLCERA GASTROYEYUNAL CRÓNICA CON HEMORRAGIA PERO SIN PERFORACIÓN"
  },
  {
    "codigo":286897001,
    "descripcion":"CARCINOMA DE MAMA - PROLONGACIÓN AXILAR"
  },
  {
    "codigo":188593003,
    "descripcion":"ENFERMEDAD DE HODGKIN, DEPLECIÓN LINFOCITARIA DE GANGLIOS LINFÁTICOS DE MÚLTIPLES LOCALIZACIONES"
  },
  {
    "codigo":254129003,
    "descripcion":"OSTEOPATÍA ESTRIADA CON ESCLEROSIS CRANEAL"
  },
  {
    "codigo":11834031000119102,
    "descripcion":"SUBLUXACIÓN DE ARTICULACIÓN METACARPOFALÁNGICA DE PULGAR DERECHO"
  },
  {
    "codigo":416134001,
    "descripcion":"ELASTICIDAD TISULAR"
  },
  {
    "codigo":90289008,
    "descripcion":"LUXACIÓN CERRADA DEL OBTURADOR DE LA CADERA"
  },
  {
    "codigo":16667311000119103,
    "descripcion":"FRACTURA EXPUESTA DE MITAD IZQUIERDA DE LA MANDÍBULA"
  },
  {
    "codigo":709211001,
    "descripcion":"NEOPLASIA DE CÉLULAS GIGANTES DE MANDÍBULA"
  },
  {
    "codigo":230266001,
    "descripcion":"ENFERMEDAD DE ALZHEIMER NO FAMILIAR DE INICIO TEMPRANO"
  },
  {
    "codigo":840283003,
    "descripcion":"LESIÓN OBSTRUCTIVA DE CORAZÓN IZQUIERDO"
  },
  {
    "codigo":16011951000119104,
    "descripcion":"TROMBOFLEBITIS DE VENA POPLÍTEA DERECHA"
  },
  {
    "codigo":283227009,
    "descripcion":"ANZUELO EN LA PLANTA DEL PIE"
  },
  {
    "codigo":52016003,
    "descripcion":"ENFERMEDAD POR EL VIRUS SHUNI"
  },
  {
    "codigo":838448003,
    "descripcion":"ESTENOSIS DE VÁLVULA MITRAL LEVE"
  },
  {
    "codigo":1076041000119100,
    "descripcion":"HIPERTROFIA DE MEMBRANA SINOVIAL DE ARTICULACIÓN DE PIE IZQUIERDO"
  },
  {
    "codigo":1231664006,
    "descripcion":"IMPLANTE RETINIANO IN SITU"
  },
  {
    "codigo":248624007,
    "descripcion":"CHILLIDO RESPIRATORIO"
  },
  {
    "codigo":82949000,
    "descripcion":"AUSENCIA CONGÉNITA DEL PÁNCREAS"
  },
  {
    "codigo":707376007,
    "descripcion":"LEIOMIOMA MÚLTIPLE DE PULMÓN"
  },
  {
    "codigo":246789004,
    "descripcion":"MOVIMIENTOS CORPORALES ASOCIADOS CON LOS MOVIMIENTOS OCULARES"
  },
  {
    "codigo":17413005,
    "descripcion":"GALACTOCELE NO ASOCIADO CON EL NACIMIENTO"
  },
  {
    "codigo":771077007,
    "descripcion":"SÍNDROME DE DISCAPACIDAD INTELECTUAL, BAJA ESTATURA E HIPERTELORISMO"
  },
  {
    "codigo":1197061008,
    "descripcion":"TRASTORNO PERINATAL DEBIDO A PROLAPSO DE CORDÓN UMBILICAL"
  },
  {
    "codigo":50181009,
    "descripcion":"DETERMINACIÓN DEL RESULTADO: MUERTE EVITABLE, PEDIDO DE AUDITORÍA DE LA HISTORIA CLÍNICA"
  },
  {
    "codigo":212186005,
    "descripcion":"LESIÓN DE LA MÉDULA ESPINAL LUMBAR ANTERIOR, SIN LESIÓN ÓSEA"
  },
  {
    "codigo":408794006,
    "descripcion":"LÍQUIDO AMNIÓTICO CON MECONIO - GRADO III"
  },
  {
    "codigo":338761000119103,
    "descripcion":"GLAUCOMA FACOLÍTICO DE OJO IZQUIERDO"
  },
  {
    "codigo":275887009,
    "descripcion":"CUERO CABELLUDO ESCAMOSO"
  },
  {
    "codigo":110212004,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO DE LA ENCÍA UNIDA A LA MANDÍBULA"
  },
  {
    "codigo":1255257002,
    "descripcion":"ESTENOSIS DE SEGMENTO MEDIO DE RAMA CIRCUNFLEJA DE ARTERIA CORONARIA IZQUIERDA"
  },
  {
    "codigo":812493641000119108,
    "descripcion":"FRACTURA NO EXPUESTA DE PARED SUPERIOR DE ÓRBITA DERECHA"
  },
  {
    "codigo":403289009,
    "descripcion":"DAÑO UNGUEAL PRODUCIDO POR INSECTICIDA"
  },
  {
    "codigo":237614004,
    "descripcion":"ENANISMO DE CABEZA DE PÁJARO CON ATAXIA PROGRESIVA, DIABETES INSULINORRESISTENTE, BOCIO E INSUFICIENCIA GONADAL PRIMARIA"
  },
  {
    "codigo":73774007,
    "descripcion":"ENDOCARDITIS INFECCIOSA SUBAGUDA"
  },
  {
    "codigo":301315000,
    "descripcion":"CRÁNEO ALARGADO"
  },
  {
    "codigo":235779007,
    "descripcion":"FÍSTULA COLOCÓLICA"
  },
  {
    "codigo":203011008,
    "descripcion":"MIOSITIS INFECCIOSA DE HOMBRO"
  },
  {
    "codigo":725464001,
    "descripcion":"OFTALMOPLEJÍA EXTERNA PROGRESIVA CRÓNICA DE COMIENZO EN LA VIDA ADULTA CON MIOPATÍA MITOCONDRIAL"
  },
  {
    "codigo":299480001,
    "descripcion":"TUMEFACCIÓN DE ARTICULACIÓN DE PIE"
  },
  {
    "codigo":15631331000119105,
    "descripcion":"BLEFAROSPASMO DE AMBOS PÁRPADOS"
  },
  {
    "codigo":102872000,
    "descripcion":"EMBARAZO DURANTE TRATAMIENTO CON ANTICONCEPTIVOS ORALES"
  },
  {
    "codigo":4568003,
    "descripcion":"DOLOR RETROESTERNAL"
  },
  {
    "codigo":168408005,
    "descripcion":"EXTENDIDO CERVICAL - CAMBIOS ATRÓFICOS"
  },
  {
    "codigo":233944003,
    "descripcion":"HIPERTENSIÓN PULMONAR PRIMARIA FAMILIAR"
  },
  {
    "codigo":266712008,
    "descripcion":"COMIENZO DE NUEVA MEDICACIÓN"
  },
  {
    "codigo":365016009,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD DE PRODUCIR UN VOLUMEN DE VOZ APROPIADO"
  },
  {
    "codigo":2733002,
    "descripcion":"TALALGIA"
  },
  {
    "codigo":35501005,
    "descripcion":"QUEMADURA EPIDÉRMICA DE MAMA"
  },
  {
    "codigo":232109006,
    "descripcion":"PARÁLISIS DOBLE DEL MÚSCULO ELEVADOR"
  },
  {
    "codigo":230274000,
    "descripcion":"DEGENERACIÓN DEL LÓBULO FRONTAL CON ENFERMEDAD DE LA NEURONA MOTORA"
  },
  {
    "codigo":721794002,
    "descripcion":"INFECCIÓN CAUSADA POR MALASSEZIA"
  },
  {
    "codigo":426882006,
    "descripcion":"TORSIÓN DE LA PUNTA EN EL ELECTROCARDIOGRAMA"
  },
  {
    "codigo":263042007,
    "descripcion":"SUBLUXACIÓN DE LA ARTICULACIÓN ATLOAXOIDEA"
  },
  {
    "codigo":195671000,
    "descripcion":"AMIGDALITIS BACTERIANA AGUDA"
  },
  {
    "codigo":33666009,
    "descripcion":"PIEDRA NEGRA"
  },
  {
    "codigo":295810008,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE FÁRMACO ANOREXÍGENO DE ACCIÓN CENTRAL"
  },
  {
    "codigo":292140001,
    "descripcion":"REACCIÓN ADVERSA AL SULFATO DE MAGNESIO"
  },
  {
    "codigo":293975009,
    "descripcion":"ALERGIA A METIPRANOLOL"
  },
  {
    "codigo":128300003,
    "descripcion":"ENFERMEDAD CRÓNICA DE LOS VASOS LINFÁTICOS"
  },
  {
    "codigo":367741000119106,
    "descripcion":"BOCIO DIFUSO DE GLÁNDULA TIROIDES SIN TIROTOXICOSIS"
  },
  {
    "codigo":718124006,
    "descripcion":"DEFICIENCIA INFANTIL DE OXIDASA DE CITOCROMO C FATAL"
  },
  {
    "codigo":95532008,
    "descripcion":"OBSTRUCCIÓN DEL DUODENO"
  },
  {
    "codigo":290305004,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR TENOXICAM"
  },
  {
    "codigo":93697005,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE VASO SANGUÍNEO DEL ANTEBRAZO"
  },
  {
    "codigo":60929008,
    "descripcion":"DIETA MISCELÁNEA"
  },
  {
    "codigo":91862002,
    "descripcion":"ABSCESO PERIODONTAL AGUDO"
  },
  {
    "codigo":417707001,
    "descripcion":"ESTADO DE CERTIFICACIÓN DE MÉDICO GENERAL"
  },
  {
    "codigo":87816000,
    "descripcion":"INTOXICACIÓN POR SULFONA"
  },
  {
    "codigo":253867006,
    "descripcion":"RIÑÓN TORÁCICO"
  },
  {
    "codigo":450475007,
    "descripcion":"PARA REANIMACIÓN CARDIOPULMONAR"
  },
  {
    "codigo":1204139007,
    "descripcion":"HIPERTENSIÓN DEBIDA A HIPERPLASIA SUPRARRENAL CONGÉNITA"
  },
  {
    "codigo":219264000,
    "descripcion":"LESIÓN POR INTERVENCIÓN LEGAL CON DINAMITA"
  },
  {
    "codigo":341271000119105,
    "descripcion":"ECTASIA DE CÓRNEA DE OJO IZQUIERDO"
  },
  {
    "codigo":710784001,
    "descripcion":"PRÓTESIS PARCIAL REMOVIBLE CON PÉRDIDA DE RETENCIÓN"
  },
  {
    "codigo":284800007,
    "descripcion":"REALIZA ACTIVIDADES DE BAÑO"
  },
  {
    "codigo":352269591000119107,
    "descripcion":"SÍNDROME DE DISTRÉS RESPIRATORIO AGUDO DEBIDO A VAPEO"
  },
  {
    "codigo":282965002,
    "descripcion":"CAPAZ DE ESTAR SENTADO"
  },
  {
    "codigo":1296938000,
    "descripcion":"ARTROFITO EN ARTICULACIÓN DE DEDO DE PIE"
  },
  {
    "codigo":15715761000119102,
    "descripcion":"SECUESTRO DE HUESO CIGOMÁTICO IZQUIERDO"
  },
  {
    "codigo":1003861008,
    "descripcion":"DISGENESIA TUBULAR RENAL DEBIDA A SÍNDROME DE TRANSFUSIÓN GEMELO-GEMELO"
  },
  {
    "codigo":86357008,
    "descripcion":"FRACTURA EXPUESTA DE LA APÓFISIS CORONOIDES DEL CÚBITO"
  },
  {
    "codigo":15316002,
    "descripcion":"ENCEFALOMIELITIS SIMIESCA B"
  },
  {
    "codigo":11783601000119106,
    "descripcion":"AMPOLLA DE MANO IZQUIERDA, CON INFECCIÓN"
  },
  {
    "codigo":48084008,
    "descripcion":"CONDUCTOR EN ACCIDENTE VEHICULAR Y\/O DE TRÁNSITO"
  },
  {
    "codigo":408532009,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: GALÉS"
  },
  {
    "codigo":111785002,
    "descripcion":"INTOXICACIÓN POR ANEMONE"
  },
  {
    "codigo":15633841000119107,
    "descripcion":"RESONANCIA MAGNÉTICA DE PELVIS ANORMAL"
  },
  {
    "codigo":79017007,
    "descripcion":"PUPILA DEFORMADA"
  },
  {
    "codigo":210089008,
    "descripcion":"LESIÓN NO EXPUESTA DEL TIMO"
  },
  {
    "codigo":898217007,
    "descripcion":"FUSIÓN ANORMAL CONGÉNITA DE FALANGE DE PIE"
  },
  {
    "codigo":372094002,
    "descripcion":"NEOPLASIA MALIGNA DE LA PROLONGACIÓN AXILAR DE LA MAMA"
  },
  {
    "codigo":11646003,
    "descripcion":"INVERSIÓN CONGÉNITA DEL PEZÓN"
  },
  {
    "codigo":77182004,
    "descripcion":"GLOMERULONEFRITIS MEMBRANOSA"
  },
  {
    "codigo":699774001,
    "descripcion":"DESVIACIÓN DE LA LÍNEA MEDIA MAXILAR HACIA LA DERECHA"
  },
  {
    "codigo":208254007,
    "descripcion":"FRACTURA EXPUESTA DE HÚMERO PROXIMAL, CABEZA HUMERAL"
  },
  {
    "codigo":763475004,
    "descripcion":"PAPULOSIS FIBROSA BLANCA DEL CUELLO"
  },
  {
    "codigo":239187005,
    "descripcion":"INFECCIÓN DE INJERTO DE PIEL"
  },
  {
    "codigo":271955004,
    "descripcion":"RETRACCIÓN DE PEZÓN"
  },
  {
    "codigo":403027004,
    "descripcion":"TIÑA CORPORAL POR TRICHOPHYTON GALLINAE"
  },
  {
    "codigo":302888003,
    "descripcion":"AGUJERO REDONDO DE LA RETINA"
  },
  {
    "codigo":237352005,
    "descripcion":"PSICOSIS POSPARTO AGUDA"
  },
  {
    "codigo":11839051000119107,
    "descripcion":"DISTENSIÓN DE MÚSCULO DE LA MANO DERECHA"
  },
  {
    "codigo":169981003,
    "descripcion":"INCORPORACIÓN DE SÓLIDOS A LOS 3 MESES"
  },
  {
    "codigo":71677004,
    "descripcion":"LESIÓN TRAUMÁTICA POR EXPOSICIÓN A CAUSA EXTERNA"
  },
  {
    "codigo":202749005,
    "descripcion":"DESGARRO ANULAR DE DISCO DORSAL"
  },
  {
    "codigo":6141006,
    "descripcion":"EDEMA DE RETINA"
  },
  {
    "codigo":366589009,
    "descripcion":"AMPLITUD DE MOVIMIENTO PASIVO DE FLEXIÓN DE LA RODILLA - HALLAZGO"
  },
  {
    "codigo":102610002,
    "descripcion":"DIETA ALIMENTARIA INADECUADA"
  },
  {
    "codigo":4306003,
    "descripcion":"TRASTORNO DE LA PERSONALIDAD DEL GRUPO B"
  },
  {
    "codigo":399357009,
    "descripcion":"DEFICIENCIA DE TIAMINA"
  },
  {
    "codigo":364754007,
    "descripcion":"NIVEL DE LA PRESENTACIÓN EN RELACIÓN CON LAS ESPINAS CIÁTICAS"
  },
  {
    "codigo":231847000,
    "descripcion":"TROMBOFLEBITIS ORBITAL"
  },
  {
    "codigo":35239001,
    "descripcion":"ANEURISMA DE ARTERIA VISCERAL"
  },
  {
    "codigo":1081061000119104,
    "descripcion":"CARCINOMA DE CÉLULAS DE MERKEL PRIMARIO DE PIEL DE HOMBRO DERECHO"
  },
  {
    "codigo":723367005,
    "descripcion":"SÍNDROME DE MACROCEFALIA, ALOPECIA, CUTIS LAXO Y ESCOLIOSIS"
  },
  {
    "codigo":2471009,
    "descripcion":"ABSCESO INTRABDOMINAL POSTOPERATORIO"
  },
  {
    "codigo":788903009,
    "descripcion":"ENFERMEDAD CAUSADA POR VIRUS ÉBOLA SUDÁN"
  },
  {
    "codigo":230012004,
    "descripcion":"POSICIÓN DEL TRONCO EN ARCO"
  },
  {
    "codigo":262780005,
    "descripcion":"LACERACIÓN DE TIMO"
  },
  {
    "codigo":721532004,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO CUBITAL A NIVEL DE ANTEBRAZO"
  },
  {
    "codigo":129873002,
    "descripcion":"CONFLICTO DEL ROL PARENTAL"
  },
  {
    "codigo":62502003,
    "descripcion":"ASPIRACIÓN DE LÍQUIDO EN LA VÍA RESPIRATORIA INFERIOR"
  },
  {
    "codigo":291878003,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR TIROTROFINA"
  },
  {
    "codigo":717862005,
    "descripcion":"EROSIÓN DE ANASTOMOSIS GASTROINTESTINAL"
  },
  {
    "codigo":95270006,
    "descripcion":"ESTENOSIS DEL SISTEMA LAGRIMAL"
  },
  {
    "codigo":49416000,
    "descripcion":"INTENTO FALLIDO DE ABORTO"
  },
  {
    "codigo":16045951000119105,
    "descripcion":"ALTERACIÓN DE LA ALINEACIÓN DE TOBILLO DERECHO"
  },
  {
    "codigo":60667009,
    "descripcion":"FRACTURA NO EXPUESTA DE COSTILLA"
  },
  {
    "codigo":124368004,
    "descripcion":"DEFICIENCIA DE BUTIRATO - ACETOACETATO COA - TRANSFERASA"
  },
  {
    "codigo":188069004,
    "descripcion":"MELANOMA MALIGNO DE MUSLO"
  },
  {
    "codigo":89765005,
    "descripcion":"SÍNDROME DE DEPENDENCIA DE TABACO"
  },
  {
    "codigo":1269413009,
    "descripcion":"ASTROCITOMA PILOMIXOIDE PRIMARIO"
  },
  {
    "codigo":1202042004,
    "descripcion":"DEFORMIDAD DE REGIÓN PÉLVICA"
  },
  {
    "codigo":448378004,
    "descripcion":"SARCOMA DE HUESO DEL PIE"
  },
  {
    "codigo":251770006,
    "descripcion":"CORRESPONDENCIA DE IMAGEN RESIDUAL RETINIANA"
  },
  {
    "codigo":315471002,
    "descripcion":"NACIDO EN MALAWI"
  },
  {
    "codigo":282703004,
    "descripcion":"INCAPAZ DE EMPUJAR Y TIRAR DE UN OBJETO AL CORRER"
  },
  {
    "codigo":249935005,
    "descripcion":"CIERRE DÉBIL DE OJO"
  },
  {
    "codigo":1003599006,
    "descripcion":"SINOSTOSIS CONGÉNITA DE LADO DERECHO DE SUTURA LAMBDOIDEA DE CRÁNEO"
  },
  {
    "codigo":446543007,
    "descripcion":"ABSCESO TUBERCULOSO DE PULMÓN"
  },
  {
    "codigo":86095007,
    "descripcion":"METABOLOPATÍA CONGÉNITA"
  },
  {
    "codigo":84260001,
    "descripcion":"HEMOGLOBINOPATÍA CON CIANOSIS"
  },
  {
    "codigo":870692000,
    "descripcion":"RANGO DE FRECUENCIA CARDÍACA FETAL BASAL MENOR DE 40"
  },
  {
    "codigo":248100003,
    "descripcion":"COMPORTAMIENTO SEXUALIZADO"
  },
  {
    "codigo":127001000119106,
    "descripcion":"LESIÓN HIPERVASCULARIZADA DE VEJIGA"
  },
  {
    "codigo":51492006,
    "descripcion":"INFESTACIÓN CAUSADA POR HIPPOBOSCA"
  },
  {
    "codigo":705017001,
    "descripcion":"ALTERACIÓN DE LA ACEPTACIÓN DEL ESTADO DE SALUD"
  },
  {
    "codigo":1231140009,
    "descripcion":"SÍNDROME DE LEMIERRE"
  },
  {
    "codigo":346291000119101,
    "descripcion":"QUERATITIS INTERSTICIAL DIFUSA DE AMBOS OJOS"
  },
  {
    "codigo":18724009,
    "descripcion":"FRACTURA NO EXPUESTA DE SEGUNDO METATARSIANO"
  },
  {
    "codigo":279033008,
    "descripcion":"DOLOR POSRESECCIÓN ABDOMINOPERINEAL"
  },
  {
    "codigo":703182002,
    "descripcion":"CEFALEA DEBIDA A SÍNDROME DE VASOCONSTRICCIÓN CEREBRAL REVERSIBLE"
  },
  {
    "codigo":211662007,
    "descripcion":"QUEMADURA DE LA CÓRNEA Y EL SACO CONJUNTIVAL POR SUSTANCIAS QUÍMICAS ÁCIDAS"
  },
  {
    "codigo":275363001,
    "descripcion":"RUPTURA DE VENA CEREBRAL SUPERFICIAL"
  },
  {
    "codigo":78755001,
    "descripcion":"DERMATITIS DE CONTACTO CAUSADA POR COSMÉTICOS"
  },
  {
    "codigo":45987002,
    "descripcion":"ACORTAMIENTO CONGÉNITO DE TENDÓN"
  },
  {
    "codigo":277198009,
    "descripcion":"ANEURISMA ATEROSCLERÓTICO"
  },
  {
    "codigo":439203001,
    "descripcion":"ESTIMACIÓN DE LA DISTANCIA DESDE EL HOGAR DEL PACIENTE AL CENTRO DE ATENCIÓN, CUESTIONABLE"
  },
  {
    "codigo":766883006,
    "descripcion":"MIOCARDIOPATÍA DILATADA FAMILIAR CON DEFECTO DE CONDUCCIÓN DEBIDA A MUTACIÓN DE LÁMINA A\/C"
  },
  {
    "codigo":308131007,
    "descripcion":"DISPLASIA DE CUERDAS VOCALES"
  },
  {
    "codigo":209827006,
    "descripcion":"CONMOCIÓN CON PÉRDIDA DE CONCIENCIA INFERIOR A 1 HORA"
  },
  {
    "codigo":111523009,
    "descripcion":"FASE HIDRÓPICA DE QUERATOCONO"
  },
  {
    "codigo":109688001,
    "descripcion":"ABSCESO MAXILAR CRÓNICO"
  },
  {
    "codigo":373667006,
    "descripcion":"CORIORRETINITIS FOCAL DE POLO POSTERIOR DE OJO"
  },
  {
    "codigo":1354872004,
    "descripcion":"LESIÓN TRAUMÁTICA DE VASO SANGUÍNEO DIGITAL DE DEDO MEDIO"
  },
  {
    "codigo":763213001,
    "descripcion":"SÍNDROME DE SORDERA DE CONDUCCIÓN, PTOSIS Y ANOMALÍAS ESQUELÉTICAS"
  },
  {
    "codigo":240760009,
    "descripcion":"ESPOROTRICOSIS EXTRACUTÁNEA"
  },
  {
    "codigo":16703821000119101,
    "descripcion":"DÉFICIT DE MEMORIA DEBIDO A ACCIDENTE CEREBROVASCULAR HEMORRÁGICO Y POSTERIOR A ÉL"
  },
  {
    "codigo":271693006,
    "descripcion":"PELVIS ADECUADA PARA EL PARTO"
  },
  {
    "codigo":1254733007,
    "descripcion":"METÁSTASIS DE CARCINOMA DE CÉLULAS GRANDES EN PULMÓN DERECHO"
  },
  {
    "codigo":238925008,
    "descripcion":"NUCA QUELOIDAL"
  },
  {
    "codigo":402765009,
    "descripcion":"LESIÓN CUTÁNEA EN DROGADICTO"
  },
  {
    "codigo":1285666002,
    "descripcion":"ENFERMEDAD LEVE POR DEFICIENCIA HEREDITARIA DE FACTOR IX CON INHIBIDOR DE BAJA RESPUESTA"
  },
  {
    "codigo":237090005,
    "descripcion":"LACERACIÓN DE CUELLO UTERINO"
  },
  {
    "codigo":106018006,
    "descripcion":"ENFERMEDAD DEGENERATIVA HEREDITARIA DEL SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":1187362007,
    "descripcion":"LORDOSIS DE COLUMNA DEBIDA A DISPLASIA ESQUELÉTICA CONGÉNITA"
  },
  {
    "codigo":202487003,
    "descripcion":"DOLOR DE ARTICULACIÓN SACROILÍACA"
  },
  {
    "codigo":268023005,
    "descripcion":"OSTEOCONDRITIS DE PELVIS"
  },
  {
    "codigo":366327005,
    "descripcion":"PROGRESIÓN DE LA SEGUNDA ETAPA DEL TRABAJO DE PARTO - HALLAZGO"
  },
  {
    "codigo":15966541000119105,
    "descripcion":"DISECCIÓN DE AMBAS ARTERIAS RENALES"
  },
  {
    "codigo":200652002,
    "descripcion":"CELULITIS DE LA CARA"
  },
  {
    "codigo":724940003,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO A LA ALTURA DEL ANTEBRAZO"
  },
  {
    "codigo":167884003,
    "descripcion":"LÍQUIDO SINOVIAL: TURBIO"
  },
  {
    "codigo":298956002,
    "descripcion":"AMPLITUD DE FLEXIÓN PASIVA DE LA MUÑECA DISMINUIDA"
  },
  {
    "codigo":297121000,
    "descripcion":"INFERTILIDAD SECUNDARIA"
  },
  {
    "codigo":67745001,
    "descripcion":"OBSTRUCCIÓN INTESTINAL RECURRENTE"
  },
  {
    "codigo":428193004,
    "descripcion":"MUCOSITIS ULCEROSA DE CUELLO UTERINO"
  },
  {
    "codigo":34977006,
    "descripcion":"AFASIA INTELECTUAL"
  },
  {
    "codigo":229750000,
    "descripcion":"TRASTORNO SINTÁCTICO-LÉXICO"
  },
  {
    "codigo":721270001,
    "descripcion":"INFECCIÓN DE ZONA DEL PAÑAL"
  },
  {
    "codigo":360822002,
    "descripcion":"DEFICIENCIA DE SULFATASA"
  },
  {
    "codigo":460961008,
    "descripcion":"ORIGEN ANÓMALO DE LIGAMENTO ARTERIOSO EN ARTERIA BRAQUIOCEFÁLICA DERECHA"
  },
  {
    "codigo":723105009,
    "descripcion":"ÚLCERA GÁSTRICA CAUSADA POR SUSTANCIA QUÍMICA"
  },
  {
    "codigo":11844071000119103,
    "descripcion":"CONTUSIÓN DE OREJA IZQUIERDA"
  },
  {
    "codigo":293451000,
    "descripcion":"REACCIÓN ADVERSA A LA AMIODARONA"
  },
  {
    "codigo":195147006,
    "descripcion":"TROMBOSIS AURICULAR"
  },
  {
    "codigo":249248231000119105,
    "descripcion":"INMUNIDAD CONTRA HEPATITIS C DETERMINADA POR SEROLOGÍA"
  },
  {
    "codigo":129511000119105,
    "descripcion":"DOLOR CRÓNICO EN CÓCCIX DE MÁS DE TRES MESES DE DURACIÓN"
  },
  {
    "codigo":129611009,
    "descripcion":"NEUROPATÍA ISQUÉMICA PERIFÉRICA"
  },
  {
    "codigo":226080004,
    "descripcion":"PARÁLISIS GLÓTICA"
  },
  {
    "codigo":62240004,
    "descripcion":"NEFROESCLEROSIS ARTERIOLAR BENIGNA"
  },
  {
    "codigo":291616005,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR CEFPODOXIMA"
  },
  {
    "codigo":783136007,
    "descripcion":"QUERATODERMIA PALMOPLANTAR NO EPIDERMOLÍTICA FOCAL AUTOSÓMICA DOMINANTE CON AMPOLLAS PLANTARES"
  },
  {
    "codigo":1141749000,
    "descripcion":"SUSCEPTIBILIDAD GENÉTICA A HIPERTERMIA MALIGNA DEBIDA A MUTACIÓN DE GEN DE SUBUNIDAD ALFA 1 S DE CANAL DE CALCIO DEPENDIENTE DE VOLTAJE"
  },
  {
    "codigo":95008007,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA PARED POSTERIOR DE LA HIPOFARINGE"
  },
  {
    "codigo":1010677001,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE PARED ANTERIOR DE NASOFARINGE"
  },
  {
    "codigo":27637000,
    "descripcion":"DEXTROCARDIA"
  },
  {
    "codigo":10752641000119102,
    "descripcion":"ECLAMPSIA CON HIPERTENSIÓN PREEXISTENTE DURANTE EL PARTO"
  },
  {
    "codigo":255178004,
    "descripcion":"NEOPLASIA BENIGNA DE ESTRUCTURA ÓSEA DE LA COLUMNA VERTEBRAL"
  },
  {
    "codigo":286111004,
    "descripcion":"CAPAZ DE LIMPIAR EL POLVO"
  },
  {
    "codigo":253343006,
    "descripcion":"VÁLVULA ANÓMALA DE SENO CORONARIO"
  },
  {
    "codigo":417183007,
    "descripcion":"DISTROFIA CORNEAL PUNTEADA"
  },
  {
    "codigo":348801000119105,
    "descripcion":"HIALOSIS ASTEROIDE DE OJO IZQUIERDO"
  },
  {
    "codigo":251508002,
    "descripcion":"ELECTROENCEFALOGRAMA ASIMÉTRICO"
  },
  {
    "codigo":448116004,
    "descripcion":"ANEURISMA DE SENO DE VALSALVA AÓRTICO CON PROTRUSIÓN EN VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":15667841000119106,
    "descripcion":"DEFORMIDAD CONGÉNITA DE AMBAS CADERAS"
  },
  {
    "codigo":184137000,
    "descripcion":"ES CUESTIONABLE SI EL NÚMERO HOSPITALARIO DEL PACIENTE ES CORRECTO"
  },
  {
    "codigo":284276008,
    "descripcion":"CAPAZ DE EMPLEAR AGARRE CON TRES DEDOS"
  },
  {
    "codigo":15749761000119107,
    "descripcion":"UÑA ENCARNADA DE DEDO DEL PIE IZQUIERDO"
  },
  {
    "codigo":15887131000119101,
    "descripcion":"BEBÉ PREMATURO, 27 SEMANAS"
  },
  {
    "codigo":1201780008,
    "descripcion":"CONDROSARCOMA GINGIVAL"
  },
  {
    "codigo":1003337005,
    "descripcion":"ECTRODACTILIA BILATERAL DE PIE"
  },
  {
    "codigo":118601006,
    "descripcion":"LINFOMA NO-HODGKIN"
  },
  {
    "codigo":249673007,
    "descripcion":"TÓRAX EN FORMA DE ESCUDO"
  },
  {
    "codigo":772126000,
    "descripcion":"POIQUILODERMIA CON NEUTROPENIA"
  },
  {
    "codigo":85833008,
    "descripcion":"ABSCESO DE ESÓFAGO"
  },
  {
    "codigo":247838000,
    "descripcion":"MIEDO A LAS ACTIVIDADES SOCIALES GRUPALES"
  },
  {
    "codigo":1263646004,
    "descripcion":"PULGAR EN GATILLO EN EDAD PEDIÁTRICA"
  },
  {
    "codigo":311539000,
    "descripcion":"INCAPAZ DE PROCESAR INFORMACIÓN CON PRECISIÓN"
  },
  {
    "codigo":313374008,
    "descripcion":"INFORME DE LOS SOLICITANTES: PEDIDO"
  },
  {
    "codigo":213235004,
    "descripcion":"COMPLICACIONES URINARIAS DE CUIDADO"
  },
  {
    "codigo":1163507005,
    "descripcion":"INFECCIÓN POR CHLAMYDIA PNEUMONIAE"
  },
  {
    "codigo":735688001,
    "descripcion":"TEMOR A ENFERMEDAD DE LA VÍA URINARIA"
  },
  {
    "codigo":80328002,
    "descripcion":"DISTROFIA PROGRESIVA DE CONOS Y BASTONES"
  },
  {
    "codigo":211400007,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE PIE Y DEDO(S) DEL PIE"
  },
  {
    "codigo":295861000119101,
    "descripcion":"OSTEOMIELITIS CRÓNICA DE ANTEBRAZO CON FÍSTULA PRODUCTIVA"
  },
  {
    "codigo":373405005,
    "descripcion":"TRASTORNO INFLAMATORIO DEL APARATO RESPIRATORIO"
  },
  {
    "codigo":111261006,
    "descripcion":"DEFORMIDAD ADQUIRIDA DEL BRAZO"
  },
  {
    "codigo":209565008,
    "descripcion":"ESGUINCE LUMBAR"
  },
  {
    "codigo":12957008,
    "descripcion":"TRASTORNO DEL METABOLISMO DE LA FENILALANINA"
  },
  {
    "codigo":76658000,
    "descripcion":"LACERACIÓN PERINEAL QUE COMPROMETE LOS LABIOS VULVARES"
  },
  {
    "codigo":304199000,
    "descripcion":"AMPLITUD DE FLEXIÓN HORIZONTAL PASIVA DE HOMBRO DISMINUIDA"
  },
  {
    "codigo":109426009,
    "descripcion":"VENTRÍCULO IZQUIERDO ÚNICO"
  },
  {
    "codigo":238663002,
    "descripcion":"LIQUEN PLANO ORAL ATRÓFICO"
  },
  {
    "codigo":271431003,
    "descripcion":"ESTENOSIS CONGÉNITA DE CONDUCTO NASOLAGRIMAL"
  },
  {
    "codigo":402503002,
    "descripcion":"CARCINOMA BASOCELULAR DE LA COLUMELA"
  },
  {
    "codigo":768648001,
    "descripcion":"CARIES CORONAL INACTIVA EN ESTADIO MODERADO"
  },
  {
    "codigo":369735009,
    "descripcion":"INVASIÓN TUMORAL DE VASO NO VENOSO (DE GRANDE CALIBRE)"
  },
  {
    "codigo":171292006,
    "descripcion":"SIN CONSENTIMIENTO PARA INMUNIZACIÓN ANTINEUMOCÓCICA"
  },
  {
    "codigo":234993000,
    "descripcion":"GINGIVITIS DE HIPERSENSIBILIDAD"
  },
  {
    "codigo":38385001,
    "descripcion":"VENA CARDINAL POSTERIOR IZQUIERDA PERSISTENTE"
  },
  {
    "codigo":366065005,
    "descripcion":"VISIÓN BINOCULAR SIMPLE - HALLAZGO"
  },
  {
    "codigo":202225006,
    "descripcion":"SUBLUXACIÓN RECURRENTE DE LA ARTICULACIÓN RADIOCUBITAL PROXIMAL"
  },
  {
    "codigo":890353006,
    "descripcion":"ASTRÁGALO VERTICAL CONGÉNITO BILATERAL"
  },
  {
    "codigo":300529008,
    "descripcion":"PRÓSTATA PALPABLE"
  },
  {
    "codigo":429766001,
    "descripcion":"FRACTURA NO EXPUESTA DE CARTÍLAGO TRIRRADIADO Y EPÍFISIS ACETABULAR"
  },
  {
    "codigo":167622004,
    "descripcion":"CANTIDAD DE LA MATERIA FECAL: NORMAL"
  },
  {
    "codigo":298694004,
    "descripcion":"PRUEBA DE BRAGARD POSITIVA"
  },
  {
    "codigo":69318006,
    "descripcion":"INTERVALO ST ACORTADO"
  },
  {
    "codigo":678991000119103,
    "descripcion":"QUERATOPATÍA PSEUDOFÁQUICA AMPOLLAR DE OJO IZQUIERDO"
  },
  {
    "codigo":1279899000,
    "descripcion":"SÍNDROME DE CORDÓN CENTRAL DE MÉDULA TORÁCICA DEBIDO A LESIÓN TRAUMÁTICA DE MÉDULA ESPINAL A NIVEL T7-T12"
  },
  {
    "codigo":724678004,
    "descripcion":"TRASTORNO DEL ESTADO DE ÁNIMO CON SÍNTOMAS DEPRESIVOS CAUSADO POR ANSIOLÍTICO"
  },
  {
    "codigo":427931002,
    "descripcion":"ESPUTO BLANCO"
  },
  {
    "codigo":67483001,
    "descripcion":"TEJIDO DE GRANULACIÓN DE LA BÓVEDA VAGINAL"
  },
  {
    "codigo":34715004,
    "descripcion":"EVALUACIÓN DE DISCAPACIDAD: 10%"
  },
  {
    "codigo":296859004,
    "descripcion":"SOBREDOSIS DE CLORPROPAMIDA"
  },
  {
    "codigo":722843001,
    "descripcion":"TEMOR A PADECER CÁNCER DEL SISTEMA DIGESTIVO"
  },
  {
    "codigo":721008000,
    "descripcion":"SÍNDROME DE HALL RIGGS"
  },
  {
    "codigo":1179760003,
    "descripcion":"CARGA MUTACIONAL TUMORAL"
  },
  {
    "codigo":295024006,
    "descripcion":"ALERGIA A INDAPAMIDA"
  },
  {
    "codigo":32880007,
    "descripcion":"TRASTORNO DE ADAPTACIÓN, CON INHIBICIÓN LABORAL"
  },
  {
    "codigo":351311000119107,
    "descripcion":"NEOPLASIA BENIGNA DE RETINA DERECHA"
  },
  {
    "codigo":1088591000119108,
    "descripcion":"HIDROPESÍA COCLEAR DE OÍDO INTERNO IZQUIERDO"
  },
  {
    "codigo":391493008,
    "descripcion":"PRESENCIA DE XANTOCROMÍA"
  },
  {
    "codigo":29210001,
    "descripcion":"TENDINITIS TROCANTÉRICA"
  },
  {
    "codigo":291354001,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR HIDRATO DE TERPINA"
  },
  {
    "codigo":422426003,
    "descripcion":"NEUROPATÍA FACIAL"
  },
  {
    "codigo":717338006,
    "descripcion":"SÍNDROME DE KOOLEN DE VRIES"
  },
  {
    "codigo":1208858006,
    "descripcion":"EMBOLIA TROMBÓTICA DESDE VENTRÍCULO CARDÍACO"
  },
  {
    "codigo":225818009,
    "descripcion":"VÍCTIMA DE LA CONDUCTA DE OTRA PERSONA"
  },
  {
    "codigo":1010415005,
    "descripcion":"TRASTORNO FETAL DEBIDO A EDEMA GESTACIONAL Y PROTEINURIA SIN HIPERTENSIÓN MATERNOS"
  },
  {
    "codigo":289519008,
    "descripcion":"AMPOLLA VAGINAL"
  },
  {
    "codigo":1172420001,
    "descripcion":"ANDRÓGENO DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":254916002,
    "descripcion":"CISTOADENOCARCINOMA DE RIÑÓN"
  },
  {
    "codigo":713668006,
    "descripcion":"DEFECTO ADQUIRIDO DEL CRÁNEO"
  },
  {
    "codigo":25540007,
    "descripcion":"PÉRDIDA DE DIENTE"
  },
  {
    "codigo":123844007,
    "descripcion":"NEOPLASIA DE ENDOMETRIO"
  },
  {
    "codigo":416921001,
    "descripcion":"CARCINOMA IN SITU DE CONDUCTO NASOLAGRIMAL"
  },
  {
    "codigo":449689008,
    "descripcion":"AMPOLLA DE PIERNA, CON INFECCIÓN"
  },
  {
    "codigo":285849008,
    "descripcion":"DIFICULTAD PARA CONTROLAR LA IRA"
  },
  {
    "codigo":350031000221107,
    "descripcion":"MICOSIS OCULAR POR HONGOS MICELIALES"
  },
  {
    "codigo":185710003,
    "descripcion":"CRIBADO PARA CÁNCER DE MAMA ANORMAL - PACIENTE INFORMADO"
  },
  {
    "codigo":446019002,
    "descripcion":"LACERACIÓN DE PARÉNQUIMA DE BAZO"
  },
  {
    "codigo":249411008,
    "descripcion":"DEPÓSITO GINGIVAL"
  },
  {
    "codigo":85571008,
    "descripcion":"PÉRDIDA DE LA AUDICIÓN SENSITIVA"
  },
  {
    "codigo":18200000,
    "descripcion":"DEFICIENCIA AUTOSÓMICA RECESIVA AISLADA DE SOMATOTROFINA"
  },
  {
    "codigo":282179009,
    "descripcion":"CAPAZ DE SUBIR UN ESCALÓN"
  },
  {
    "codigo":1091101000119100,
    "descripcion":"OTITIS NO INFECCIOSA CRÓNICA EXTERNA DE CONDUCTO AUDITIVO EXTERNO DERECHO"
  },
  {
    "codigo":83736009,
    "descripcion":"INFECCIÓN CAUSADA POR MESOCESTOIDES CORTI"
  },
  {
    "codigo":737261002,
    "descripcion":"FRACTURA DE EXTREMO DISTAL DE RADIO CON INCLINACIÓN DORSAL"
  },
  {
    "codigo":1359853002,
    "descripcion":"NEOPLASIA MALIGNA DE BERMELLÓN DE LABIO INFERIOR"
  },
  {
    "codigo":278509004,
    "descripcion":"ATAXIA CONGÉNITA NO PROGRESIVA"
  },
  {
    "codigo":1259714000,
    "descripcion":"CARCINOMA UROTELIAL DE CÉLULAS CLARAS PRIMARIO DE SISTEMA URINARIO"
  },
  {
    "codigo":276674008,
    "descripcion":"MENINGITIS NEONATAL"
  },
  {
    "codigo":735426009,
    "descripcion":"FÍSTULA DE SISTEMA DIGESTIVO"
  },
  {
    "codigo":110999002,
    "descripcion":"CATARATA ESTACIONARIA"
  },
  {
    "codigo":108061000119104,
    "descripcion":"DEFECTO DE CONTINUIDAD DE LA MANDÍBULA"
  },
  {
    "codigo":373143004,
    "descripcion":"TROMBO SEVERO"
  },
  {
    "codigo":405911005,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA NO COMPROMETIDO POR SARCOMA"
  },
  {
    "codigo":16819741000119104,
    "descripcion":"RUPTURA TRAUMÁTICA DE FASCIA PLANTAR DE PIE IZQUIERDO"
  },
  {
    "codigo":307607001,
    "descripcion":"FIBROMA CONDROMIXOIDE DE HUESO"
  },
  {
    "codigo":109491008,
    "descripcion":"HIPOMINERALIZACIÓN GENERALIZADA DEL ESMALTE"
  },
  {
    "codigo":404076001,
    "descripcion":"TUMOR FIBROMIXOIDE OSIFICANTE"
  },
  {
    "codigo":305772003,
    "descripcion":"ATENDIDO POR DIETISTA EXTRAHOSPITALARIO"
  },
  {
    "codigo":698988004,
    "descripcion":"LINFEDEMA DEBIDO A INFECCIÓN"
  },
  {
    "codigo":764524005,
    "descripcion":"SÍNDROME DE MICRODUPLICACIÓN 22Q11.2 DISTAL"
  },
  {
    "codigo":240236006,
    "descripcion":"DEFORMIDAD ROTACIONAL DE PULGAR"
  },
  {
    "codigo":830060005,
    "descripcion":"CÁNCER DE PULMÓN NO MICROCÍTICO NEGATIVO PARA ROS-1"
  },
  {
    "codigo":1256044008,
    "descripcion":"VÍCTIMA DE MATRIMONIO FORZADO"
  },
  {
    "codigo":16711351000119101,
    "descripcion":"EDEMA DE MÁCULA RETINIANA DEBIDO A OCLUSIÓN DE RAMA DE VENA DE LA RETINA IZQUIERDA"
  },
  {
    "codigo":402241005,
    "descripcion":"LIQUEN SIMPLE DE PIEL PERIANAL"
  },
  {
    "codigo":238401006,
    "descripcion":"CELULITIS ANAERÓBICA"
  },
  {
    "codigo":74561007,
    "descripcion":"DIVERTÍCULO DE KOMMERELL"
  },
  {
    "codigo":369473007,
    "descripcion":"TUMOR MALIGNO QUE COMPROMETE VEJIGA URINARIA POR PROPAGACIÓN DIRECTA DE CUELLO UTERINO"
  },
  {
    "codigo":1186838001,
    "descripcion":"NEUROPATÍA PERIFÉRICA CAUSADA POR CIGUATOXINA"
  },
  {
    "codigo":236566007,
    "descripcion":"EXTRUSIÓN DE MANGUITO DE CATÉTER PARA DIÁLISIS PERITONEAL"
  },
  {
    "codigo":105494007,
    "descripcion":"RETIRO TEMPRANO - EVENTO DEL CICLO VITAL"
  },
  {
    "codigo":890091002,
    "descripcion":"EPISODIO HIPOTÓNICO-HIPORREACTIVO"
  },
  {
    "codigo":300267005,
    "descripcion":"HALLAZGO DE SALIVACIÓN"
  },
  {
    "codigo":365803008,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA EL SECUENCIAMIENTO LÓGICO"
  },
  {
    "codigo":69056000,
    "descripcion":"MACROTIA"
  },
  {
    "codigo":298432009,
    "descripcion":"SIN AMPLITUD DE FLEXIÓN LATERAL ACTIVA HACIA LA DERECHA DE LA COLUMNA VERTEBRAL CERVICAL"
  },
  {
    "codigo":1279637002,
    "descripcion":"CIERRE VELOFARÍNGEO INCOMPLETO ADQUIRIDO DEBIDO A ANOMALÍA ANATÓMICA"
  },
  {
    "codigo":1685005,
    "descripcion":"FIEBRE POR MORDEDURA DE RATA"
  },
  {
    "codigo":1345173005,
    "descripcion":"LESIÓN SUBEPITELIAL DE INTESTINO GRUESO"
  },
  {
    "codigo":460437005,
    "descripcion":"ORIGEN ANÓMALO DE ARTERIAS CORONARIAS DESCENDENTES ANTERIORES IZQUIERDAS DOBLES EN ARTERIA CORONARIA DERECHA Y ARTERIA CORONARIA IZQUIERDA"
  },
  {
    "codigo":16275281000119102,
    "descripcion":"ENTROPIÓN SENIL DE AMBOS PÁRPADOS SUPERIORES"
  },
  {
    "codigo":1148565009,
    "descripcion":"MUCOCELE DE SENO FRONTAL"
  },
  {
    "codigo":296597008,
    "descripcion":"SOBREDOSIS DE GENTAMICINA"
  },
  {
    "codigo":425834005,
    "descripcion":"DOLOR IRRADIADO AL FLANCO DERECHO"
  },
  {
    "codigo":720746006,
    "descripcion":"CONTRACTURA CON DISPLASIA ECTODÉRMICA Y SÍNDROME DE HENDIDURA OROFACIAL"
  },
  {
    "codigo":294762006,
    "descripcion":"ALERGIA A ESTANOZOLOL"
  },
  {
    "codigo":1144895003,
    "descripcion":"PSEUDOMENINGOCELE POSQUIRÚRGICO"
  },
  {
    "codigo":718911005,
    "descripcion":"DISCAPACIDAD INTELECTUAL LIGADA AL CROMOSOMA X TIPO STOLL"
  },
  {
    "codigo":292927007,
    "descripcion":"REACCIÓN ADVERSA A LA NEOMICINA"
  },
  {
    "codigo":225556000,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN DE OREJA"
  },
  {
    "codigo":127252001,
    "descripcion":"NEOPLASIA DE LOS GANGLIOS LINFÁTICOS MESENTÉRICOS"
  },
  {
    "codigo":291092005,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR LORAZEPAM"
  },
  {
    "codigo":92649001,
    "descripcion":"CARCINOMA IN SITU DE PULMÓN"
  },
  {
    "codigo":94484009,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL PERICARDIO"
  },
  {
    "codigo":192788009,
    "descripcion":"DISTROFIA RETINIANA EN LA LIPIDOSIS CEREBRORRETINIANA"
  },
  {
    "codigo":125417005,
    "descripcion":"AGREGADO MACROMOLECULAR CITOPLÁSMICO"
  },
  {
    "codigo":190953007,
    "descripcion":"DEFICIENCIA DE TRIPSINÓGENO"
  },
  {
    "codigo":713406001,
    "descripcion":"TRANSLOCACIÓN CROMOSÓMICA BALANCEADA"
  },
  {
    "codigo":289257009,
    "descripcion":"MADRE SIN PARIR"
  },
  {
    "codigo":254654004,
    "descripcion":"CARCINOMA ESCAMOSO ACANTOLÍTICO DE PIEL"
  },
  {
    "codigo":56211001,
    "descripcion":"CUERPO EXTRAÑO MAGNÉTICO RETENIDO EN EL CRISTALINO"
  },
  {
    "codigo":449427004,
    "descripcion":"DOBLE CAYADO AÓRTICO CON ARCO DERECHO DOMINANTE Y ARCO IZQUIERDO PERMEABLE"
  },
  {
    "codigo":43741000087102,
    "descripcion":"TRASTORNO DE TENDÓN DE EXTREMIDAD SUPERIOR IZQUIERDA"
  },
  {
    "codigo":416659006,
    "descripcion":"INFECCIÓN NEUROINVASORA POR VIRUS DE LA ENCEFALITIS EQUINA VENEZOLANA"
  },
  {
    "codigo":12398571000119105,
    "descripcion":"INTOXICACIÓN POR METANFETAMINA"
  },
  {
    "codigo":54376001,
    "descripcion":"PRUEBA DE RINNE NORMAL"
  },
  {
    "codigo":250984000,
    "descripcion":"VALVA AÓRTICA DESGARRADA"
  },
  {
    "codigo":87144001,
    "descripcion":"ACNÉ INDURADA"
  },
  {
    "codigo":46301000087108,
    "descripcion":"FRACTURA DE EXTREMO PROXIMAL DE HÚMERO DERECHO"
  },
  {
    "codigo":414824005,
    "descripcion":"NEOPLASIA DE MÉDULA ÓSEA"
  },
  {
    "codigo":41181000087109,
    "descripcion":"QUEMADURA DE CADERA DERECHA"
  },
  {
    "codigo":283752005,
    "descripcion":"MORDEDURA DE PERRO EN EL ANTEBRAZO"
  },
  {
    "codigo":281917000,
    "descripcion":"FRACTURA DE LÁMINA DE VÉRTEBRA CERVICAL"
  },
  {
    "codigo":249149000,
    "descripcion":"CONTRACCIÓN DEL ÚTERO DURANTE EL TRABAJO PARTO"
  },
  {
    "codigo":314685008,
    "descripcion":"PESO DEL NIÑO: PERCENTILO 98,1-99,6"
  },
  {
    "codigo":19773009,
    "descripcion":"INFECCIÓN DE LA MAMA Y\/O DEL PEZÓN ASOCIADO CON EL PARTO"
  },
  {
    "codigo":1230354001,
    "descripcion":"DEFORMIDAD CONGÉNITA DE MANO"
  },
  {
    "codigo":1363261009,
    "descripcion":"METABOLIZADOR INTERMEDIO DE FAMILIA 2 SUBFAMILIA C MIEMBRO 9 *1\/*11 DE CITOCROMO P450"
  },
  {
    "codigo":1197586007,
    "descripcion":"SÍNDROME DE TALLA BAJA, EDAD ÓSEA AVANZADA, OSTEOARTRITIS DE INICIO TEMPRANO"
  },
  {
    "codigo":81639003,
    "descripcion":"FRACTURA NO EXPUESTA DE HUESOS NASALES"
  },
  {
    "codigo":1259452000,
    "descripcion":"ADENOSARCOMA PRIMARIO DE ÚTERO"
  },
  {
    "codigo":14268002,
    "descripcion":"ÁNTRAX DEL OMBLIGO"
  },
  {
    "codigo":47036002,
    "descripcion":"ACTINOBACILOSIS CAUSADA POR ACTINOBACILLUS SEMINIS"
  },
  {
    "codigo":473020005,
    "descripcion":"DISFUNCIÓN ERÉCTIL PRIMARIA"
  },
  {
    "codigo":733329000,
    "descripcion":"PARÁLISIS MONOCULAR DE MÚSCULO ELEVADOR"
  },
  {
    "codigo":276412008,
    "descripcion":"TESTÍCULO GRANDE"
  },
  {
    "codigo":1070911000000109,
    "descripcion":"DIFICULTAD PARA HACER COMPRAS EN SUPERMERCADO"
  },
  {
    "codigo":305510000,
    "descripcion":"BAJO ATENCIÓN DE INMUNOPATÓLOGO"
  },
  {
    "codigo":241809008,
    "descripcion":"ENVENENAMIENTO CAUSADO POR VENENO DE COLÚBRIDO"
  },
  {
    "codigo":895334003,
    "descripcion":"CURVATURA ANORMAL DE FALANGE DE DEDO MAYOR"
  },
  {
    "codigo":371046004,
    "descripcion":"ANEMIA HEMOLÍTICA TRAUMÁTICA"
  },
  {
    "codigo":403814004,
    "descripcion":"PIEL LAXA SECUNDARIA A TRASTORNO HEREDITARIO DEL TEJIDO CONECTIVO"
  },
  {
    "codigo":698726009,
    "descripcion":"DEMENCIA ASOCIADA CON ENCEFALITIS VIRAL"
  },
  {
    "codigo":303391000119105,
    "descripcion":"MIOSITIS OSIFICANTE DE MÚSCULO DE MANO DERECHA DEBIDA A QUEMADURA"
  },
  {
    "codigo":205371009,
    "descripcion":"CRECIMIENTO EXCESIVO CONGÉNITO DE EXTREMIDAD INFERIOR DISTAL"
  },
  {
    "codigo":238139009,
    "descripcion":"EXCESO DE MINERALES"
  },
  {
    "codigo":270907008,
    "descripcion":"HEMORRAGIA SUBARACNOIDEA INTRACRANEAL ESPONTÁNEA"
  },
  {
    "codigo":16906681000119100,
    "descripcion":"CARCINOMA IN SITU DE PIEL DE PÁRPADO INFERIOR IZQUIERDO"
  },
  {
    "codigo":269072006,
    "descripcion":"FRACTURA EXPUESTA DEL AXIS"
  },
  {
    "codigo":39696006,
    "descripcion":"FORMA DE UNA COLONIA BACTERIANA, IRREGULAR"
  },
  {
    "codigo":234469001,
    "descripcion":"TRASTORNO PLAQUETARIO HEREDITARIO"
  },
  {
    "codigo":5093001,
    "descripcion":"CISTITIS CON ACTINOMICOSIS"
  },
  {
    "codigo":70629007,
    "descripcion":"EMBOLIA DESDE LA AORTA TORÁCICA"
  },
  {
    "codigo":398309008,
    "descripcion":"TALIPES"
  },
  {
    "codigo":365541009,
    "descripcion":"CANTIDAD DE EMPLEOS SIMULTÁNEOS-HALLAZGO"
  },
  {
    "codigo":298170003,
    "descripcion":"INFLAMACIÓN DE ARTICULACIÓN ROTULIANA"
  },
  {
    "codigo":10625311000119109,
    "descripcion":"BRONCONEUMONÍA CAUSADA POR KLEBSIELLA PNEUMONIAE"
  },
  {
    "codigo":396474007,
    "descripcion":"MARGEN QUIRÚRGICO DE VÍAS BILIARES NO COMPROMETIDO POR CARCINOMA IN SITU"
  },
  {
    "codigo":789690008,
    "descripcion":"GRANULOMATOSIS LINFOMATOIDE MALIGNA DE PULMÓN"
  },
  {
    "codigo":296335002,
    "descripcion":"SOBREDOSIS DE BLOQUEANTE BETADRENÉRGICO"
  },
  {
    "codigo":230799003,
    "descripcion":"COMA POSTRAUMÁTICO"
  },
  {
    "codigo":198031007,
    "descripcion":"HEMATOMA DE LOS CUERPOS CAVERNOSOS"
  },
  {
    "codigo":65124004,
    "descripcion":"TUMEFACCIÓN"
  },
  {
    "codigo":15677881000119106,
    "descripcion":"CORIORRETINITIS DE OJO IZQUIERDO DEBIDA A SÍFILIS SECUNDARIA"
  },
  {
    "codigo":194361002,
    "descripcion":"VÉRTIGO POSICIONAL MALIGNO"
  },
  {
    "codigo":292665003,
    "descripcion":"REACCIÓN ADVERSA A RETINOIDE"
  },
  {
    "codigo":1306638004,
    "descripcion":"RADIOGRAFÍA DE PARTES BLANDAS DE CARA NORMAL"
  },
  {
    "codigo":126990005,
    "descripcion":"NEOPLASIA DE LOS NERVIOS PERIFÉRICOS DE LA CADERA"
  },
  {
    "codigo":94222008,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE HUESO"
  },
  {
    "codigo":290830009,
    "descripcion":"INTOXICACIÓN POR DOXEPINA"
  },
  {
    "codigo":92387002,
    "descripcion":"NEOPLASIA BENIGNA DE PARTES BLANDAS DEL ABDOMEN"
  },
  {
    "codigo":288995003,
    "descripcion":"INCAPAZ DE BEBER DE UNA BOTELLA"
  },
  {
    "codigo":125155008,
    "descripcion":"CÉLULAS ENDOMETRIALES EN MUJER POSMENOPÁUSICA, DE CARÁCTER BENIGNO SEGÚN EL EXAMEN CITOLÓGICO"
  },
  {
    "codigo":1237432000,
    "descripcion":"DERMATITIS ALÉRGICA DE CONTACTO CAUSADA POR ACEITE AUTOMOTRIZ"
  },
  {
    "codigo":711221000124104,
    "descripcion":"SINOVITIS CRÓNICA DE MUÑECA DERECHA DEBIDA A HEMARTROSIS"
  },
  {
    "codigo":254392009,
    "descripcion":"NEOPLASIA DE FRENILLO LABIAL"
  },
  {
    "codigo":2101000124106,
    "descripcion":"INCAPAZ DE AUTOADMINISTRARSE MEDICACIÓN"
  },
  {
    "codigo":11801171000119107,
    "descripcion":"CONTUSIÓN DE RIÑÓN DERECHO"
  },
  {
    "codigo":1268365004,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN METACARPOFALÁNGICA DE DEDO MEDIO"
  },
  {
    "codigo":332371000119107,
    "descripcion":"RETINOPATÍA POR PREMATUREZ DEL OJO DERECHO ETAPA 3 - CRESTA CON PROLIFERACIÓN FIBROVASCULAR EXTRARRETINIANA"
  },
  {
    "codigo":447330002,
    "descripcion":"TUBERCULOSIS DE ABDOMEN"
  },
  {
    "codigo":283490003,
    "descripcion":"HERIDA PUNZANTE EN DEDO DEL PIE"
  },
  {
    "codigo":185186007,
    "descripcion":"ATENDIDO EN CONSULTORIO ESPECIALIZADO EN LA ATENCIÓN DE NIÑO SANO"
  },
  {
    "codigo":248887000,
    "descripcion":"TEJIDO DE GRANULACIÓN ALREDEDOR DE FÍSTULA VAGINAL"
  },
  {
    "codigo":871479001,
    "descripcion":"PRESENTACIÓN DE FETO INCIERTA"
  },
  {
    "codigo":21346009,
    "descripcion":"ÚTERO DOBLE QUE AFECTA AL EMBARAZO"
  },
  {
    "codigo":183351002,
    "descripcion":"CAMBIO DE TRABAJO - MISMO EMPLEADOR"
  },
  {
    "codigo":412727007,
    "descripcion":"ALIMENTACIÓN DEL NIÑO AL NACER"
  },
  {
    "codigo":445495007,
    "descripcion":"ARTRITIS INFECCIOSA DE CODO"
  },
  {
    "codigo":609335007,
    "descripcion":"LESIÓN SUPERFICIAL DE PIERNA SIN INFECCIÓN"
  },
  {
    "codigo":312588002,
    "descripcion":"FLEBITIS DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":247052002,
    "descripcion":"CATARATA - HALLAZGO"
  },
  {
    "codigo":1197324006,
    "descripcion":"MELANOMA MALIGNO METASTÁSICO DE PIEL"
  },
  {
    "codigo":771340007,
    "descripcion":"SÍNDROME DE MICRODELECIÓN 15Q11.2"
  },
  {
    "codigo":15841002,
    "descripcion":"SÍNDROME DE MONOSOMÍA PARCIAL 21Q"
  },
  {
    "codigo":308918001,
    "descripcion":"HALLAZGOS DE SÍNTOMAS EN RELACIÓN CON EL MOMENTO DE INICIO"
  },
  {
    "codigo":439990003,
    "descripcion":"NEFRITIS TUBULOINTERSTICIAL MEDICAMENTOSA"
  },
  {
    "codigo":210614005,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DEL PULGAR A TRAVÉS DE ARTICULACIÓN METACARPOFALÁNGICA"
  },
  {
    "codigo":472758006,
    "descripcion":"HIPERTENSIÓN VENOSA PULMONAR DEBIDA A COMPRESIÓN DE GRAN VENA PULMONAR"
  },
  {
    "codigo":307083000,
    "descripcion":"CAPAZ DE PROCESAR INFORMACIÓN"
  },
  {
    "codigo":896907002,
    "descripcion":"FORMA ANCHA ANORMAL CONGÉNITA DE FALANGE DISTAL DE CUARTO DEDO DE PIE"
  },
  {
    "codigo":44939003,
    "descripcion":"SÍNDROME DE LIAN - SIGUER - WELTI"
  },
  {
    "codigo":700299005,
    "descripcion":"ENTROPIÓN ESPÁSTICO DE PÁRPADO SUPERIOR"
  },
  {
    "codigo":733067006,
    "descripcion":"SÍNDROME DE TELECANTO, HIPERTELORISMO, ESTRABISMO Y PIE CAVO"
  },
  {
    "codigo":110475006,
    "descripcion":"CUMPLIMIENTO DEL CUIDADO DENTAL INDICADO POR EL ESPECIALISTA"
  },
  {
    "codigo":208779009,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA EXPUESTA DE LA ARTICULACIÓN ACROMIOCLAVICULAR"
  },
  {
    "codigo":403552007,
    "descripcion":"APLASIA CUTÁNEA CONGÉNITA LUEGO DE INFECCIÓN INTRAUTERINA (TIPO 8)"
  },
  {
    "codigo":698464007,
    "descripcion":"CON MAYOR RIESGO DE DEMENCIA"
  },
  {
    "codigo":41269000,
    "descripcion":"BRONCONEUMONÍA POR INFLUENZA"
  },
  {
    "codigo":205109004,
    "descripcion":"CONTRACTURA EN ABDUCCIÓN CONGÉNITA DE LA CADERA"
  },
  {
    "codigo":237877004,
    "descripcion":"AMILOIDOSIS POR TRANSTIRETINA (ATTR) TIPO NATURAL"
  },
  {
    "codigo":203274002,
    "descripcion":"TUBERCULOSIS DE MÚLTIPLES HUESOS DE EXTREMIDAD"
  },
  {
    "codigo":399882002,
    "descripcion":"HIGROMA QUÍSTICO"
  },
  {
    "codigo":1153546005,
    "descripcion":"OCLUSIÓN DE AMBAS ARTERIAS CEREBRALES POSTERIORES"
  },
  {
    "codigo":301578005,
    "descripcion":"SE MOVILIZA EN SILLA DE RUEDAS"
  },
  {
    "codigo":1055242007,
    "descripcion":"ALTERACIÓN DE REFLEJO DE MÚSCULO TENSOR DE TÍMPANO"
  },
  {
    "codigo":365279000,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA LLENAR LA BAÑERA"
  },
  {
    "codigo":236042008,
    "descripcion":"HERNIA INTERNA OBSTRUIDA"
  },
  {
    "codigo":234207004,
    "descripcion":"HEMORRAGIA DE FÍSTULA ARTERIOVENOSA"
  },
  {
    "codigo":299743006,
    "descripcion":"REFLEJO DE MORO DE RESULTADO DUDOSO"
  },
  {
    "codigo":168671007,
    "descripcion":"RADIOGRAFÍA SIMPLE DE RÓTULA ANORMAL"
  },
  {
    "codigo":1348319007,
    "descripcion":"CANTIDAD ESCASA DE SANGRE HEMOLIZADA DETECTADA EN ORINA POR TIRA REACTIVA"
  },
  {
    "codigo":396212001,
    "descripcion":"GLÁNDULA SUPRARRENAL COMPROMETIDA POR INVASIÓN DIRECTA DE TUMOR RENAL"
  },
  {
    "codigo":363444001,
    "descripcion":"NEOPLASIA MALIGNA DE TROMPA DE FALOPIO"
  },
  {
    "codigo":230537000,
    "descripcion":"NEURALGIA IDIOPÁTICA DEL NERVIO TRIGÉMINO"
  },
  {
    "codigo":722057000,
    "descripcion":"ALBINISMO OCULOCUTÁNEO TIPO 5"
  },
  {
    "codigo":232372008,
    "descripcion":"ESTENOSIS NASOFARÍNGEA"
  },
  {
    "codigo":334881000119107,
    "descripcion":"ORZUELO EXTERNO DE PÁRPADO DERECHO"
  },
  {
    "codigo":1344649005,
    "descripcion":"TRASTORNO RESPIRATORIO CAUSADO POR FÁRMACO"
  },
  {
    "codigo":197769007,
    "descripcion":"PIELONEFRITIS AGUDA CON NECROSIS MEDULAR"
  },
  {
    "codigo":165001008,
    "descripcion":"RESPUESTA DE HIPERSENSIBILIDAD TIPO 4"
  },
  {
    "codigo":294238000,
    "descripcion":"ALERGIA A ORO"
  },
  {
    "codigo":11312161000119108,
    "descripcion":"FRACTURA POR ESTRÉS DE VÉRTEBRA DORSAL"
  },
  {
    "codigo":427145007,
    "descripcion":"TRASTORNO ARTICULAR DEBIDO A HIPERQUINESIA"
  },
  {
    "codigo":128563000,
    "descripcion":"APÉNDICE AURICULAR YUXTAPUESTO"
  },
  {
    "codigo":64862009,
    "descripcion":"RABDOMIOMA CONGÉNITO DEL CORAZÓN"
  },
  {
    "codigo":32094009,
    "descripcion":"ANEMIA MEGALOBLÁSTICA CAUSADA POR TENIA DE LOS PECES"
  },
  {
    "codigo":292403003,
    "descripcion":"REACCIÓN ADVERSA AL DECANOATO DE ZUCLOPENTIXOL"
  },
  {
    "codigo":11832951000119100,
    "descripcion":"ESGUINCE DE LIGAMENTO DE ARTICULACIÓN DE SEGUNDO A QUINTO DEDOS DE PIE DERECHO"
  },
  {
    "codigo":10962551000119101,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO PERÓNEO IZQUIERDO"
  },
  {
    "codigo":631000119102,
    "descripcion":"DOLOR DE ESPALDA CRÓNICO DE MÁS DE TRES MESES DE DURACIÓN"
  },
  {
    "codigo":16046711000119103,
    "descripcion":"ENFERMEDAD POR DEPÓSITO DE HIDROXIAPATITA DE MANO IZQUIERDA"
  },
  {
    "codigo":16320631000119104,
    "descripcion":"DEPENDENCIA DE DIÁLISIS PERITONEAL AMBULATORIA CONTINUA DEBIDA A ENFERMEDAD RENAL EN ESTADIO TERMINAL"
  },
  {
    "codigo":31351000119105,
    "descripcion":"RESERVA OVÁRICA DISMINUIDA"
  },
  {
    "codigo":16023671000119106,
    "descripcion":"VÁRICE DE VENA DE EXTREMIDAD SUPERIOR DERECHA"
  },
  {
    "codigo":15637111000119107,
    "descripcion":"DEDO EN MARTILLO CONGÉNITO BILATERAL DE SEGUNDO A QUINTO DEDOS DE PIE"
  },
  {
    "codigo":10680951000119108,
    "descripcion":"NÓDULO DE PIEL DE EXTREMIDAD INFERIOR DERECHA"
  },
  {
    "codigo":300151000119109,
    "descripcion":"OSTEOMIELITIS SUBAGUDA DE HUESO TIBIAL"
  },
  {
    "codigo":82551000119103,
    "descripcion":"RUBEOSIS DE IRIS DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":10632311000119102,
    "descripcion":"ABSCESO DE PULPEJO DE PULGAR"
  },
  {
    "codigo":126728003,
    "descripcion":"NEOPLASIA DEL DIAFRAGMA"
  },
  {
    "codigo":333431000119106,
    "descripcion":"HEMORRAGIA DE ÓRBITA DERECHA"
  },
  {
    "codigo":1075831000119106,
    "descripcion":"TENDINITIS CALCIFICANTE DE PIE IZQUIERDO"
  },
  {
    "codigo":93960003,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE FALANGE DE LA MANO"
  },
  {
    "codigo":10660471000119109,
    "descripcion":"ÚLCERA DE PIE IZQUIERDO DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":302711000119108,
    "descripcion":"SÍNDROME DE COMPRESIÓN DE ARTERIA RAQUÍDEA ANTERIOR DE MÉDULA ESPINAL DORSOLUMBAR"
  },
  {
    "codigo":388872005,
    "descripcion":"MENINGIOMA SECUNDARIO DE VAINA DE NERVIO ÓPTICO"
  },
  {
    "codigo":92125000,
    "descripcion":"NEOPLASIA BENIGNA DE LA CURVATURA MAYOR DEL ESTÓMAGO"
  },
  {
    "codigo":190429008,
    "descripcion":"HIPERINSULINEMIA AUTOINDUCIDA"
  },
  {
    "codigo":712882000,
    "descripcion":"NEUROPATÍA AUTONÓMICA DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":288733002,
    "descripcion":"INCAPAZ DE RESPONDER A LA COMUNICACIÓN ESTABLECIDA POR OTROS"
  },
  {
    "codigo":254130008,
    "descripcion":"HIPEROSTOSIS ENDÓSTICA"
  },
  {
    "codigo":24754009,
    "descripcion":"HIPOMAGNESEMIA INTESTINAL FAMILIAR AISLADA"
  },
  {
    "codigo":448903003,
    "descripcion":"DILATACIÓN DE ANILLO DE VÁLVULA AÓRTICA"
  },
  {
    "codigo":283228004,
    "descripcion":"ANZUELO EN EL TALÓN"
  },
  {
    "codigo":840284009,
    "descripcion":"ECCEMA COXSACKIUM"
  },
  {
    "codigo":19249002,
    "descripcion":"CIERRE PREMATURO DEL AGUJERO OVAL"
  },
  {
    "codigo":707377003,
    "descripcion":"CARCINOMA PRIMARIO DE CÉLULAS EN ANILLO DE SELLO DE TRÁQUEA"
  },
  {
    "codigo":84785006,
    "descripcion":"INFERTILIDAD FEMENINA SECUNDARIA A ESTENOSIS ADQUIRIDA DE TROMPA DE FALOPIO"
  },
  {
    "codigo":1231665007,
    "descripcion":"UVEÍTIS INTERMEDIA DEBIDA A SARCOIDOSIS"
  },
  {
    "codigo":248625008,
    "descripcion":"ONDA DE SUCUSIÓN HIPOCRÁTICA EN TÓRAX"
  },
  {
    "codigo":1197062001,
    "descripcion":"TRASTORNO PERINATAL DEBIDO A PLACENTA PREVIA"
  },
  {
    "codigo":771078002,
    "descripcion":"INMUNODEFICIENCIA POR DEFICIENCIA DE MASP-2"
  },
  {
    "codigo":838449006,
    "descripcion":"ESTENOSIS MODERADA DE VÁLVULA MITRAL"
  },
  {
    "codigo":17414004,
    "descripcion":"CONTUSIÓN MIOCÁRDICA"
  },
  {
    "codigo":212187001,
    "descripcion":"LESIÓN DE MÉDULA LUMBAR CENTRAL SIN LESIÓN ÓSEA"
  },
  {
    "codigo":48347002,
    "descripcion":"NEUMOPATÍA POR HUMIDIFICADOR"
  },
  {
    "codigo":310491007,
    "descripcion":"PESO AL NACER INFERIOR A 751 G"
  },
  {
    "codigo":81115009,
    "descripcion":"CÁLCULO DEL COLÉDOCO CON COLECISTITIS AGUDA CON OBSTRUCCIÓN"
  },
  {
    "codigo":79280005,
    "descripcion":"HIPERSOMNIA CON APNEA DEL SUEÑO"
  },
  {
    "codigo":10905071000119106,
    "descripcion":"HERIDA PUNZANTE DE PARED ABDOMINAL"
  },
  {
    "codigo":310921000119100,
    "descripcion":"DERRAME INTERMITENTE DE ARTICULACIÓN DE CADERA IZQUIERDA"
  },
  {
    "codigo":403290000,
    "descripcion":"LESIÓN UNGUEAL CAUSADA POR COSMÉTICO PARA UÑAS"
  },
  {
    "codigo":11779721000119102,
    "descripcion":"ABRASIÓN DE PIEL DE ANTEBRAZO IZQUIERDO"
  },
  {
    "codigo":110213009,
    "descripcion":"QUEMADURA DE TERCER GRADO DE LA ENCÍA UNIDA A LA MANDÍBULA"
  },
  {
    "codigo":75610003,
    "descripcion":"MUCOPOLISACARIDOSIS, MPS-I"
  },
  {
    "codigo":1288026004,
    "descripcion":"TUMOR DE CÉLULAS ENTEROCROMAFINES DE COLON"
  },
  {
    "codigo":1255258007,
    "descripcion":"ESTENOSIS DE PORCIÓN DISTAL DE RAMA CIRCUNFLEJA DE ARTERIA CORONARIA IZQUIERDA"
  },
  {
    "codigo":204847000,
    "descripcion":"FÍSTULAS CONGÉNITAS ENTRE EL ÚTERO Y LAS VÍAS DIGESTIVAS Y URINARIAS"
  },
  {
    "codigo":42842009,
    "descripcion":"SOPLO CARDÍACO EN MESETA"
  },
  {
    "codigo":1351727000,
    "descripcion":"INMUNODEFICIENCIA COMBINADA AUTOSÓMICA RECESIVA DEBIDA A MUTACIÓN DE MOLÉCULA CD28"
  },
  {
    "codigo":8239009,
    "descripcion":"FIBROELASTOSIS ENDOCÁRDICA PRIMARIA"
  },
  {
    "codigo":203012001,
    "descripcion":"MIOSITIS INFECCIOSA DE BRAZO"
  },
  {
    "codigo":792836003,
    "descripcion":"PULSO EN ARTERIA POPLÍTEA IZQUIERDA AUSENTE"
  },
  {
    "codigo":301316004,
    "descripcion":"CABEZA DE FORMA NORMAL"
  },
  {
    "codigo":39172002,
    "descripcion":"NEUMONÍA CAUSADA POR PROTEUS MIRABILIS"
  },
  {
    "codigo":235780005,
    "descripcion":"FÍSTULA COLOVAGINAL"
  },
  {
    "codigo":397785000,
    "descripcion":"COMPLICACIÓN DEBIDA A BLOQUEO NEUROMUSCULAR Y POSTERIOR A ÉL"
  },
  {
    "codigo":365017000,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA PRODUCIR LA CALIDAD APROPIADA DE VOZ"
  },
  {
    "codigo":299481002,
    "descripcion":"TUMEFACCIÓN ÓSEA DE ARTICULACIÓN DE PIE"
  },
  {
    "codigo":233945002,
    "descripcion":"HIPERTENSIÓN PULMONAR CAUSADA POR FÁRMACO"
  },
  {
    "codigo":11861641000119107,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO PERONEO DERECHO"
  },
  {
    "codigo":232110001,
    "descripcion":"PARÁLISIS DOBLE DEL MÚSCULO DEPRESOR"
  },
  {
    "codigo":363182001,
    "descripcion":"LESIÓN DE CARTÍLAGO"
  },
  {
    "codigo":721795001,
    "descripcion":"INFECCIÓN MUCOCUTÁNEA NEONATAL CAUSADA POR CANDIDA"
  },
  {
    "codigo":899001,
    "descripcion":"DIAGNÓSTICO EN EL EJE I"
  },
  {
    "codigo":263043002,
    "descripcion":"SUBLUXACIÓN DE ARTICULACIÓN DE LA COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":295811007,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE FÁRMACO ANOREXÍGENO DE ACCIÓN CENTRAL"
  },
  {
    "codigo":293976005,
    "descripcion":"ALERGIA A CARTEOLOL"
  },
  {
    "codigo":425048006,
    "descripcion":"CARCINOMA PULMONAR NO MICROCÍTICO, TNM ESTADIO 2"
  },
  {
    "codigo":228440007,
    "descripcion":"CONDUCTA OFENSIVA RELACIONADA CON LA DROGA"
  },
  {
    "codigo":195672007,
    "descripcion":"AMIGDALITIS NEUMOCÓCICA AGUDA"
  },
  {
    "codigo":292141002,
    "descripcion":"REACCIÓN ADVERSA A LAXANTE FORMADOR DE MASA"
  },
  {
    "codigo":95533003,
    "descripcion":"HEMORRAGIA DUODENAL"
  },
  {
    "codigo":128301004,
    "descripcion":"INTOXICACIÓN CRÓNICA"
  },
  {
    "codigo":93698000,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE VASO SANGUÍNEO DE LA MANO"
  },
  {
    "codigo":193837009,
    "descripcion":"DISTROFIA CORNEAL COMBINADA"
  },
  {
    "codigo":29997008,
    "descripcion":"NACIMIENTO PREMATURO DE TRILLIZOS"
  },
  {
    "codigo":290306003,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR TENOXICAM"
  },
  {
    "codigo":10743741000119103,
    "descripcion":"ARRITMIA CARDÍACA EN LA MADRE QUE COMPLICA EL NACIMIENTO"
  },
  {
    "codigo":419543003,
    "descripcion":"MARGEN QUIRÚRGICO INTERNO COMPROMETIDO POR CARCINOMA DUCTAL IN SITU"
  },
  {
    "codigo":91863007,
    "descripcion":"PERICORONITIS AGUDA"
  },
  {
    "codigo":57260004,
    "descripcion":"AMENORREA NUTRICIONAL"
  },
  {
    "codigo":450476008,
    "descripcion":"NO APTO PARA REANIMACIÓN CARDIOPULMONAR"
  },
  {
    "codigo":208435005,
    "descripcion":"FRACTURA NO EXPUESTA DE FALANGE PROXIMAL DE PULGAR, BASE"
  },
  {
    "codigo":219265004,
    "descripcion":"LESIÓN TRAUMÁTICA POR INTERVENCIÓN LEGAL CON OBÚS EXPLOSIVO"
  },
  {
    "codigo":284801006,
    "descripcion":"NO REALIZA ACTIVIDAD DE BAÑO"
  },
  {
    "codigo":339901000119108,
    "descripcion":"ECTROPIÓN SENIL DEL PÁRPADO INFERIOR IZQUIERDO"
  },
  {
    "codigo":1003862001,
    "descripcion":"CONDRODISPLASIA PUNTEADA RIZOMÉLICA TIPO 1"
  },
  {
    "codigo":414038002,
    "descripcion":"DISTANCIA DEL CARCINOMA INVASIVO DESDE EL MÁRGEN ANAL, DESCONOCIDO"
  },
  {
    "codigo":282966001,
    "descripcion":"INCAPAZ DE TOMAR ASIENTO"
  },
  {
    "codigo":444971006,
    "descripcion":"TENDINITIS DE EXTENSOR DE LA MANO"
  },
  {
    "codigo":443136000,
    "descripcion":"NEOPLASIA MALIGNA DE PIEL DE CARA"
  },
  {
    "codigo":408533004,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: TIGRINYA"
  },
  {
    "codigo":277461004,
    "descripcion":"ASTROCITOMA ANAPLÁSICO DE CEREBRO"
  },
  {
    "codigo":373930000,
    "descripcion":"FUNCIÓN COGNITIVA - HALLAZGO"
  },
  {
    "codigo":11837681000119102,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE RODILLA IZQUIERDA"
  },
  {
    "codigo":898218002,
    "descripcion":"FUSIÓN ANORMAL CONGÉNITA DE HUESOS DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":111786001,
    "descripcion":"INTOXICACIÓN POR HALOGETON GLOMERATUS"
  },
  {
    "codigo":210090004,
    "descripcion":"LESIÓN TRAUMÁTICA CERRADA DE CONDUCTO TORÁCICO"
  },
  {
    "codigo":767146004,
    "descripcion":"EFECTO TÓXICO DE ARSÉNICO Y\/O COMPUESTOS DE ARSÉNICO"
  },
  {
    "codigo":699775000,
    "descripcion":"DESVIACIÓN DE LÍNEA MEDIA MAXILAR Y MANDIBULAR HACIA LA DERECHA"
  },
  {
    "codigo":109951001,
    "descripcion":"NEOPLASIA SUPERPUESTA MALIGNA DE MÚLTIPLES GLÁNDULAS ENDOCRINAS"
  },
  {
    "codigo":239188000,
    "descripcion":"TRASTORNO DEL SITIO DONANTE DE PIEL"
  },
  {
    "codigo":15687921000119105,
    "descripcion":"CAPSULITIS DE ARTICULACIÓN METATARSOFALÁNGICA DE PIE IZQUIERDO"
  },
  {
    "codigo":208255008,
    "descripcion":"FRACTURA EXPUESTA DE HÚMERO, EPÍFISIS SUPERIOR"
  },
  {
    "codigo":271956003,
    "descripcion":"NEOPLASIA BENIGNA DE PÁNCREAS EXOCRINO"
  },
  {
    "codigo":403028009,
    "descripcion":"TIÑA CORPORAL CAUSADA POR MICROSPORUM EQUINUM"
  },
  {
    "codigo":16097521000119107,
    "descripcion":"ARTROFIBROSIS DE AMBAS RODILLAS"
  },
  {
    "codigo":1187625002,
    "descripcion":"HALLAZGO DEL AMBIENTE EMOCIONAL"
  },
  {
    "codigo":302889006,
    "descripcion":"DESGARRO RETINIANO POR TRACCIÓN"
  },
  {
    "codigo":366590000,
    "descripcion":"HALLAZGO RELACIONADO CON LA AMPLITUD DE LA EXTENSIÓN DE LA RODILLA"
  },
  {
    "codigo":7977009,
    "descripcion":"INFECCIÓN CAUSADA POR CRYPTOSPORIDIUM MELEAGRIDIS"
  },
  {
    "codigo":6142004,
    "descripcion":"GRIPE"
  },
  {
    "codigo":202750005,
    "descripcion":"RESORCIÓN DE DISCO DORSAL"
  },
  {
    "codigo":368881000119109,
    "descripcion":"SÍNDROME NEFRÍTICO RÁPIDAMENTE PROGRESIVO CONCOMITANTE CON GLOMERULONEFRITIS MEMBRANOPROLIFERATIVA TIPO III Y DEBIDO A ELLA"
  },
  {
    "codigo":266451002,
    "descripcion":"COLITIS Y GASTROENTERITIS ALÉRGICA"
  },
  {
    "codigo":233683003,
    "descripcion":"RINITIS ALÉRGICA CON ASMA"
  },
  {
    "codigo":713523008,
    "descripcion":"MIOCARDIOPATÍA CONCOMITANTE CON INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":299219007,
    "descripcion":"DEDO DE LA MANO AMPUTADO"
  },
  {
    "codigo":364755008,
    "descripcion":"ACTIVIDAD DEL MOVIMIENTO FETAL - HALLAZGO"
  },
  {
    "codigo":331987008,
    "descripcion":"INDIGESTIÓN MODERADA CAUSADA POR LA DIETA"
  },
  {
    "codigo":2472002,
    "descripcion":"ANURIA"
  },
  {
    "codigo":788904003,
    "descripcion":"TRASTORNO CAUSADO POR FÁRMACO DISOCIATIVO"
  },
  {
    "codigo":4307007,
    "descripcion":"DIABETES MELLITUS PREGESTACIONAL Y\/O TRASTORNO DE LA TOLERANCIA A LA GLUCOSA, CLASE F DE WHITE MODIFICADA"
  },
  {
    "codigo":395688005,
    "descripcion":"CEFALEA COITAL BENIGNA"
  },
  {
    "codigo":231848005,
    "descripcion":"MIOSITIS ORBITAL AGUDA"
  },
  {
    "codigo":37075008,
    "descripcion":"DEGENERACIÓN CISTOIDE PERIFÉRICA DE RETINA"
  },
  {
    "codigo":35240004,
    "descripcion":"DEFICIENCIA DE HIERRO"
  },
  {
    "codigo":342411000119107,
    "descripcion":"FILARIASIS LINFÁTICA DE PÁRPADO INFERIOR DERECHO"
  },
  {
    "codigo":295549004,
    "descripcion":"SOBREDOSIS DE AGENTE ANESTÉSICO DE ACCIÓN LOCAL"
  },
  {
    "codigo":424786000,
    "descripcion":"VOLUMEN DE ORINA EMITIDA ANORMAL"
  },
  {
    "codigo":31570000,
    "descripcion":"ATRESIA ARTERIAL"
  },
  {
    "codigo":230013009,
    "descripcion":"POSICIÓN DE TRONCO: ARREMETIDA LATERAL"
  },
  {
    "codigo":721533009,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO MEDIANO A NIVEL DE ANTEBRAZO"
  },
  {
    "codigo":195410000,
    "descripcion":"TROMBOFLEBITIS DE LA VENA FEMORAL"
  },
  {
    "codigo":262781009,
    "descripcion":"ERUPCIÓN VARICELIFORME DE KAPOSI CAUSADA POR VIRUS VACCINIA"
  },
  {
    "codigo":293714007,
    "descripcion":"ALERGIA A HALOTANO"
  },
  {
    "codigo":717863000,
    "descripcion":"ÚLCERA PÉPTICA ANASTOMÓTICA"
  },
  {
    "codigo":291879006,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR TIROTROFINA"
  },
  {
    "codigo":224508000,
    "descripcion":"APOYO DE COMUNIDAD SOLIDARIA"
  },
  {
    "codigo":58833000,
    "descripcion":"PSEUDOHIPOPARATIROIDISMO TIPO I A"
  },
  {
    "codigo":170035005,
    "descripcion":"TALLA DEL NIÑO ENTRE PERCENTILOS 3 Y 9"
  },
  {
    "codigo":419281007,
    "descripcion":"LENTIGLOBO"
  },
  {
    "codigo":288209009,
    "descripcion":"PARTO NORMAL - POSICIÓN OCCIPITOANTERIOR"
  },
  {
    "codigo":253606002,
    "descripcion":"ANOMALÍA DE VALVA AÓRTICA"
  },
  {
    "codigo":188070003,
    "descripcion":"MELANOMA MALIGNO DE RODILLA"
  },
  {
    "codigo":1269414003,
    "descripcion":"ASTROCITOMA FIBRILAR PRIMARIO DE SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":22395006,
    "descripcion":"MEMBRANA DEL CUERPO DEL ESÓFAGO"
  },
  {
    "codigo":16018111000119105,
    "descripcion":"TRASTORNO DE AMBOS PERONÉS POSTERIOR A POLIOMIELITIS"
  },
  {
    "codigo":1202043009,
    "descripcion":"DEFORMIDAD DE HUESO DE PELVIS"
  },
  {
    "codigo":282704005,
    "descripcion":"EMPUJA Y TIRA AL CORRER"
  },
  {
    "codigo":249936006,
    "descripcion":"INCAPAZ DE CERRAR OJOS"
  },
  {
    "codigo":1003600009,
    "descripcion":"SINOSTOSIS CONGÉNITA DE LADO IZQUIERDO DE SUTURA LAMBDOIDEA DE CRÁNEO"
  },
  {
    "codigo":51493001,
    "descripcion":"TRASTORNO DE ANSIEDAD CAUSADO POR COCAÍNA"
  },
  {
    "codigo":248101004,
    "descripcion":"PROSTITUCIÓN FEMENINA"
  },
  {
    "codigo":1231141008,
    "descripcion":"TRASTORNO CONGÉNITO DE GLICOSILACIÓN POR ALTERACIÓN EN FOSFOMANOSA ISOMERASA"
  },
  {
    "codigo":703183007,
    "descripcion":"OCLUSIÓN ASINTOMÁTICA DE ARTERIA"
  },
  {
    "codigo":308132000,
    "descripcion":"DISPLASIA DE LARINGE"
  },
  {
    "codigo":373668001,
    "descripcion":"PIOCITOS"
  },
  {
    "codigo":111524003,
    "descripcion":"DERMATOSIS NO INFECCIOSA DEL PÁRPADO"
  },
  {
    "codigo":275364007,
    "descripcion":"LESIÓN DE BAZO POR TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":207993005,
    "descripcion":"FRACTURAS MÚLTIPLES DE LA COLUMNA VERTEBRAL LUMBAR Y LA PELVIS"
  },
  {
    "codigo":240761008,
    "descripcion":"TRICOSPORONOSIS"
  },
  {
    "codigo":271694000,
    "descripcion":"CONDUCTA POSTURAL"
  },
  {
    "codigo":109689009,
    "descripcion":"ABSCESO MANDIBULAR CRÓNICO"
  },
  {
    "codigo":1254734001,
    "descripcion":"METÁSTASIS DE CARCINOMA DE CÉLULAS GRANDES EN PULMÓN IZQUIERDO"
  },
  {
    "codigo":1354873009,
    "descripcion":"LESIÓN TRAUMÁTICA DE VASO SANGUÍNEO DIGITAL DE DEDO ANULAR"
  },
  {
    "codigo":402766005,
    "descripcion":"LESIÓN CUTÁNEA POR SOBREDOSIS DE DROGAS"
  },
  {
    "codigo":238926009,
    "descripcion":"LUPUS ERITEMATOSO Y SÍNDROME TIPO ERITEMA MULTIFORME"
  },
  {
    "codigo":106019003,
    "descripcion":"HALLAZGO RELACIONADO CON EL PATRÓN DE EVACUACIÓN"
  },
  {
    "codigo":269859006,
    "descripcion":"URATO EN SANGRE POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":366328000,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA PUJAR EN EL TRABAJO DE PARTO"
  },
  {
    "codigo":237091009,
    "descripcion":"VAGINITIS INFECCIOSA"
  },
  {
    "codigo":268024004,
    "descripcion":"OSTEOCONDRITIS JUVENIL DEL BRAZO Y LA MANO"
  },
  {
    "codigo":300792007,
    "descripcion":"CAPAZ DE MANEJAR Y EMPUJAR UN JUGUETE"
  },
  {
    "codigo":36813001,
    "descripcion":"PLACENTA PREVIA"
  },
  {
    "codigo":399096009,
    "descripcion":"ESPONDILITIS NO DIFERENCIADA"
  },
  {
    "codigo":291981000119101,
    "descripcion":"TRASTORNO DE NERVIO GENITOCRURAL IZQUIERDO"
  },
  {
    "codigo":724941004,
    "descripcion":"LESIÓN TRAUMÁTICA DE FASCIA DE ANTEBRAZO"
  },
  {
    "codigo":298957006,
    "descripcion":"SIN AMPLITUD PASIVA DE FLEXIÓN DE MUÑECA"
  },
  {
    "codigo":460962001,
    "descripcion":"ORIGEN ANÓMALO DE LIGAMENTO ARTERIOSO EN ARTERIA BRAQUIOCEFÁLICA IZQUIERDA"
  },
  {
    "codigo":723106005,
    "descripcion":"INFLAMACIÓN DE INTESTINO DELGADO CAUSADA POR CUERPO EXTRAÑO"
  },
  {
    "codigo":428194005,
    "descripcion":"ÚLCERA EN MUSLO"
  },
  {
    "codigo":297122007,
    "descripcion":"SIN FOCO NEUROLÓGICO"
  },
  {
    "codigo":229751001,
    "descripcion":"TRASTORNO SEMÁNTICO-PRAGMÁTICO"
  },
  {
    "codigo":721271002,
    "descripcion":"INFECCIÓN QUE OCASIONA CONDRÓLISIS DE CARTÍLAGO ARTICULAR"
  },
  {
    "codigo":262519004,
    "descripcion":"TRAUMATISMOS MÚLTIPLES"
  },
  {
    "codigo":295287006,
    "descripcion":"SOBREDOSIS DE FENILBUTAZONA"
  },
  {
    "codigo":196983007,
    "descripcion":"ILEOCOLITIS REGIONAL"
  },
  {
    "codigo":129612002,
    "descripcion":"SÍNDROME DEL NERVIO ETMOIDAL ANTERIOR"
  },
  {
    "codigo":293452007,
    "descripcion":"REACCIÓN ADVERSA A LOS ANTIARRÍTMICOS DE CLASE IV"
  },
  {
    "codigo":226081000,
    "descripcion":"DIETA PROTEICA CON ALTO VALOR BIOLÓGICO"
  },
  {
    "codigo":291617001,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR CEFPODOXIMA"
  },
  {
    "codigo":783137003,
    "descripcion":"SÍNDROME DE DEFICIENCIA RADIAL E HIPOPLASIA TIBIAL"
  },
  {
    "codigo":95009004,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL MEDIASTINO POSTERIOR"
  },
  {
    "codigo":1084711000119102,
    "descripcion":"INFLAMACIÓN BILATERAL DE ESTRUCTURAS LABERÍNTICAS CAUSADA POR VIRUS"
  },
  {
    "codigo":289782005,
    "descripcion":"CUELLO UTERINO ANTERIOR"
  },
  {
    "codigo":1010678006,
    "descripcion":"ANOMALÍA DE VENA UMBILICAL GRUPO III"
  },
  {
    "codigo":191478006,
    "descripcion":"PARANOIA POR ALCOHOL"
  },
  {
    "codigo":224246006,
    "descripcion":"ÁREAS PRIVADAS EN LA VIVIENDA"
  },
  {
    "codigo":347431000119104,
    "descripcion":"EXOTROPÍA ALTERNANTE NO DIVERGENTE"
  },
  {
    "codigo":25803005,
    "descripcion":"FÍSTULA PANCREÁTICA"
  },
  {
    "codigo":1172683008,
    "descripcion":"SÍNDROME DE MICROCEFALIA, CATARATA CONGÉNITA Y DERMATITIS PSORIASIFORME"
  },
  {
    "codigo":417184001,
    "descripcion":"NUTACIÓN SACRA"
  },
  {
    "codigo":253344000,
    "descripcion":"ANOMALÍA DEL APÉNDICE AURICULAR DERECHO"
  },
  {
    "codigo":286112006,
    "descripcion":"INCAPAZ DE LIMPIAR EL POLVO"
  },
  {
    "codigo":87669002,
    "descripcion":"DESTRUCCIÓN DE LINFOCITOS DISMINUIDA"
  },
  {
    "codigo":185973002,
    "descripcion":"PACIENTE QUE ESPERA UNA INVESTIGACIÓN"
  },
  {
    "codigo":284277004,
    "descripcion":"INCAPAZ DE EMPLEAR AGARRE CON TRES DEDOS"
  },
  {
    "codigo":251509005,
    "descripcion":"ASIMETRÍA EN LA AMPLITUD ALFA"
  },
  {
    "codigo":22133005,
    "descripcion":"ANOMALÍA CONGÉNITA DEL SISTEMA NERVIOSO PERIFÉRICO"
  },
  {
    "codigo":448117008,
    "descripcion":"ANEURISMA DE SENO DE VALSALVA AÓRTICO CON PROTRUSIÓN EN CAVIDAD PERICÁRDICA"
  },
  {
    "codigo":249674001,
    "descripcion":"TÓRAX HIPERINSUFLADO"
  },
  {
    "codigo":11789761000119102,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE DEDO DE MANO IZQUIERDA"
  },
  {
    "codigo":118602004,
    "descripcion":"GRANULOMA DE HODGKIN"
  },
  {
    "codigo":870431002,
    "descripcion":"HEMÓLISIS TARDÍA DESPUÉS DE TRATAMIENTO CON ARTESUNATO"
  },
  {
    "codigo":51231003,
    "descripcion":"DETERMINACIÓN DEL ESTADO DE LA ENFERMEDAD: CURADA"
  },
  {
    "codigo":1263647008,
    "descripcion":"PULGAR EN GATILLO DE MANO IZQUIERDA EN EDAD PEDIÁTRICA"
  },
  {
    "codigo":772127009,
    "descripcion":"SÍNDROME DE WHITE SUTTON"
  },
  {
    "codigo":1163508000,
    "descripcion":"HIDROCEFALIA DEBIDA A MICOSIS"
  },
  {
    "codigo":311540003,
    "descripcion":"DIFICULTAD PARA PROCESAR INFORMACIÓN CON PRECISIÓN"
  },
  {
    "codigo":313375009,
    "descripcion":"ATENDIDO EN UN CONSULTORIO PRIVADO"
  },
  {
    "codigo":247839008,
    "descripcion":"MIEDO A ESTAR EN UN GRUPO PEQUEÑO"
  },
  {
    "codigo":15640001000119107,
    "descripcion":"DISTENSIÓN DE MÚSCULO ROMBOIDE DERECHO"
  },
  {
    "codigo":78494001,
    "descripcion":"AMELOGÉNESIS IMPERFECTA"
  },
  {
    "codigo":373406006,
    "descripcion":"TRASTORNO INFLAMATORIO DEL SISTEMA GENITOURINARIO"
  },
  {
    "codigo":240499000,
    "descripcion":"FIEBRE DE SEPIK"
  },
  {
    "codigo":699251001,
    "descripcion":"DISPLASIA FIBROSA DE HUESO CON MIXOMA INTRAMUSCULAR"
  },
  {
    "codigo":209566009,
    "descripcion":"ESGUINCE SACRO"
  },
  {
    "codigo":109427000,
    "descripcion":"DEFECTO SUPRACRESTÍLEO DE TABIQUE INTERVENTRICULAR"
  },
  {
    "codigo":9288000,
    "descripcion":"RESPUESTA IRRELEVANTE"
  },
  {
    "codigo":43891009,
    "descripcion":"PANADIZO HERPÉTICO"
  },
  {
    "codigo":304200002,
    "descripcion":"SIN AMPLITUD DE EXTENSIÓN PASIVA HORIZONTAL DE HOMBRO"
  },
  {
    "codigo":369736005,
    "descripcion":"INVASIÓN TUMORAL DE VASO VENOSO (DE GRAN CALIBRE), NO DETERMINADA"
  },
  {
    "codigo":271432005,
    "descripcion":"ESTENOSIS CONGÉNITA DE ARTERIA RENAL"
  },
  {
    "codigo":238664008,
    "descripcion":"LIQUEN PLANO ORAL HIPERTRÓFICO"
  },
  {
    "codigo":171293001,
    "descripcion":"SIN CONSENTIMIENTO PARA VACUNA ANTISARAMPIONOSA\/ANTIRRUBEÓLICA"
  },
  {
    "codigo":402504008,
    "descripcion":"CARCINOMA BASOCELULAR DE SURCO NASOLABIAL"
  },
  {
    "codigo":1285405005,
    "descripcion":"NECROSIS DE EPITELIO RESPIRATORIO"
  },
  {
    "codigo":204061006,
    "descripcion":"ATRESIA DEL FORAMEN DE MAGENDIE"
  },
  {
    "codigo":10835701000119102,
    "descripcion":"ANOMALÍA CONGÉNITA DE VULVA EN LA MADRE QUE COMPLICA EL EMBARAZO"
  },
  {
    "codigo":890354000,
    "descripcion":"ESTENOSIS SUBGLÓTICA CONGÉNITA DE COTTON-MYER GRADO 3"
  },
  {
    "codigo":300530003,
    "descripcion":"PRÓSTATA NO PALPABLE"
  },
  {
    "codigo":366066006,
    "descripcion":"VISIÓN BINOCULAR, SUPRESIÓN - HALLAZGO"
  },
  {
    "codigo":5618007,
    "descripcion":"QUISTE DEL LIGAMENTO ANCHO"
  },
  {
    "codigo":234994006,
    "descripcion":"PATOLOGÍA GINGIVAL CRÓNICA"
  },
  {
    "codigo":202226007,
    "descripcion":"LUXACIÓN RECURRENTE DE CABEZA DE RADIO"
  },
  {
    "codigo":169458008,
    "descripcion":"INICIA TOMA DE ANTICONCEPTIVOS ORALES"
  },
  {
    "codigo":298695003,
    "descripcion":"PRUEBA DE BRAGARD NEGATIVA"
  },
  {
    "codigo":3783004,
    "descripcion":"PERLAS DE ESMALTE"
  },
  {
    "codigo":429767005,
    "descripcion":"OTITIS MEDIA CRÓNICA DESPUÉS DE INSERCIÓN DE TUBO DE VENTILACIÓN"
  },
  {
    "codigo":724679007,
    "descripcion":"TRASTORNO DEL ESTADO DE ÁNIMO CON SÍNTOMAS MANÍACOS CAUSADO POR SEDANTE"
  },
  {
    "codigo":677621000119105,
    "descripcion":"NEOVASCULARIZACIÓN BILATERAL DE COROIDES OCULAR"
  },
  {
    "codigo":167623009,
    "descripcion":"CANTIDAD VOLUMINOSA DE MATERIA FECAL"
  },
  {
    "codigo":34716003,
    "descripcion":"INTOXICACIÓN POR THEVETIA PERUVIANA"
  },
  {
    "codigo":444438261000119106,
    "descripcion":"FIBROMATOSIS AGRESIVA DE CAVIDAD DE TÓRAX"
  },
  {
    "codigo":16052111000119100,
    "descripcion":"TENDINOSIS DE HOMBRO DERECHO"
  },
  {
    "codigo":722844007,
    "descripcion":"OBSTRUCCIÓN DE INTESTINO DELGADO CONCOMITANTE CON ADHERENCIAS PERITONEALES Y DEBIDA A ELLAS"
  },
  {
    "codigo":296860009,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE CLORPROPAMIDA"
  },
  {
    "codigo":1179761004,
    "descripcion":"EXPANSIÓN CORTICAL DE FÉMUR"
  },
  {
    "codigo":3464007,
    "descripcion":"INFECCIÓN CAUSADA POR OESOPHAGOSTOMUM DENTATUM"
  },
  {
    "codigo":295025007,
    "descripcion":"ALERGIA A MEFRUSIDA"
  },
  {
    "codigo":721009008,
    "descripcion":"SÍNDROME DE DEFECTO CARDÍACO Y ACORTAMIENTO DE LAS EXTREMIDADES"
  },
  {
    "codigo":1343601009,
    "descripcion":"ARTROSIS DE COLUMNA VERTEBRAL"
  },
  {
    "codigo":93235007,
    "descripcion":"HIPOPLASIA CONGÉNITA DE GLÁNDULA SUPRARRENAL"
  },
  {
    "codigo":63814006,
    "descripcion":"SIGNO CEREBRAL ANORMAL EN RECIÉN NACIDO"
  },
  {
    "codigo":1145158007,
    "descripcion":"INTOXICACIÓN CAUSADA POR PIPERAZINA Y\/O DERIVADO DE PIPERAZINA"
  },
  {
    "codigo":291355000,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR HIDRATO DE TERPINA"
  },
  {
    "codigo":225819001,
    "descripcion":"VÍCTIMA DE AMENAZAS"
  },
  {
    "codigo":1208859003,
    "descripcion":"NEUROPATÍA ÓPTICA ISQUÉMICA POSTERIOR DEBIDA A ARTERITIS"
  },
  {
    "codigo":94747006,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL BRAZO"
  },
  {
    "codigo":289520002,
    "descripcion":"TEJIDO DE GRANULACIÓN VAGINAL"
  },
  {
    "codigo":715504003,
    "descripcion":"PARAPARESIA ESPÁSTICA CONCOMITANTE SON SORDERA"
  },
  {
    "codigo":191216004,
    "descripcion":"ANEMIA HEMOLÍTICA NO AUTOINMUNITARIA"
  },
  {
    "codigo":1010416006,
    "descripcion":"TRASTORNO NEONATAL DEBIDO A EDEMA GESTACIONAL Y PROTEINURIA SIN HIPERTENSIÓN MATERNOS"
  },
  {
    "codigo":60144008,
    "descripcion":"INFECCIÓN CAUSADA POR GONGYLONEMA"
  },
  {
    "codigo":92912009,
    "descripcion":"FORMA ANORMAL CONGÉNITA DE HUESO FRONTAL"
  },
  {
    "codigo":58309001,
    "descripcion":"FLEBITIS DE VENA TIBIAL"
  },
  {
    "codigo":254917006,
    "descripcion":"CISTOADENOCARCINOMA PAPILAR DE RIÑÓN"
  },
  {
    "codigo":11792271000119108,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN DE DEDO DE MANO IZQUIERDA"
  },
  {
    "codigo":123845008,
    "descripcion":"ADENOCARCINOMA DE ENDOMETRIO"
  },
  {
    "codigo":89242004,
    "descripcion":"HIPERTENSIÓN ARTERIAL SECUNDARIA MALIGNA"
  },
  {
    "codigo":416922008,
    "descripcion":"LIPOGRANULOMA ESCLEROSANTE PRIMARIO"
  },
  {
    "codigo":285850008,
    "descripcion":"CAPAZ DE CONTROLAR EMOCIONES"
  },
  {
    "codigo":21871003,
    "descripcion":"INFECCIÓN CAUSADA POR ASCAROPS"
  },
  {
    "codigo":185711004,
    "descripcion":"CRIBADO PARA CÁNCER DE MAMA SOLICITADO"
  },
  {
    "codigo":709999005,
    "descripcion":"DIENTE SUPERNUMERARIO MOLARIFORME"
  },
  {
    "codigo":708164002,
    "descripcion":"GASTRITIS CAUSADA POR HELICOBACTER PYLORI"
  },
  {
    "codigo":314948003,
    "descripcion":"DEHISCENCIA DE HERIDA PERINEAL"
  },
  {
    "codigo":413252003,
    "descripcion":"ESCLEROSIS MUCOSA"
  },
  {
    "codigo":773700005,
    "descripcion":"SÍNDROME DE LEUCONIQUIA TOTAL, LESIONES TIPO ACANTOSIS NIGRICANS Y CABELLO ANÓMALO"
  },
  {
    "codigo":20036005,
    "descripcion":"SECRECIÓN POR EL CUELLO UTERINO"
  },
  {
    "codigo":11821251000119100,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN CARPOMETACARPIANA DE PULGAR DERECHO"
  },
  {
    "codigo":446020008,
    "descripcion":"DEFECTO ARQUEADO DEL CAMPO VISUAL"
  },
  {
    "codigo":282180007,
    "descripcion":"INCAPAZ DE SUBIR UN ESCALÓN"
  },
  {
    "codigo":81902001,
    "descripcion":"ESGUINCE DE LIGAMENTO LATERAL INTERNO DE RODILLA"
  },
  {
    "codigo":735427000,
    "descripcion":"ESTENOSIS DEL SISTEMA DIGESTIVO"
  },
  {
    "codigo":737262009,
    "descripcion":"FRACTURA DE EXTREMO DISTAL DE RADIO CON INCLINACIÓN PALMAR"
  },
  {
    "codigo":1359854008,
    "descripcion":"CARCINOMA IN SITU DE BERMELLÓN DE LABIO INFERIOR"
  },
  {
    "codigo":1259715004,
    "descripcion":"NEOPLASIA MALIGNA SUPERPUESTA PRIMARIA DE NASOFARINGE"
  },
  {
    "codigo":352451000119105,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE PIEL DE CADERA DERECHA"
  },
  {
    "codigo":276675009,
    "descripcion":"INFECCIÓN NEONATAL DEL OJO"
  },
  {
    "codigo":111000003,
    "descripcion":"CATARATA ADHERENTE"
  },
  {
    "codigo":405912003,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA COMPROMETIDO POR SARCOMA"
  },
  {
    "codigo":307608006,
    "descripcion":"SARCOMA ÓSEO DE EWING"
  },
  {
    "codigo":274840008,
    "descripcion":"VISCOSIDAD DEL PLASMA FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":209304008,
    "descripcion":"FRACTURA-LUXACIÓN NO EXPUESTA DE ARTICULACIÓN METACARPOFALÁNGICA"
  },
  {
    "codigo":76397002,
    "descripcion":"VARIACIÓN NORMAL EN LA DISTRIBUCIÓN"
  },
  {
    "codigo":404077005,
    "descripcion":"OSTEOSARCOMA EXTRAESQUELÉTICO"
  },
  {
    "codigo":764525006,
    "descripcion":"MIOPATÍA DE ESPIRALES CILÍNDRICOS"
  },
  {
    "codigo":698989007,
    "descripcion":"LINFEDEMA DEBIDO A ENFERMEDAD INFLAMATORIA"
  },
  {
    "codigo":205634000,
    "descripcion":"DELECIÓN OBSERVADA SOLAMENTE EN LA PROMETAFASE"
  },
  {
    "codigo":1256045009,
    "descripcion":"PIODERMA GANGRENOSO VEGETANTE SUPERFICIAL"
  },
  {
    "codigo":369474001,
    "descripcion":"TUMOR MALIGNO QUE COMPROMETE VEJIGA URINARIA POR PROPAGACIÓN DIRECTA DE ÚTERO"
  },
  {
    "codigo":402242003,
    "descripcion":"LIQUEN DE LA NUCA"
  },
  {
    "codigo":271170004,
    "descripcion":"AMPOLLA TRAUMÁTICA DE LA MANO, INFECTADA"
  },
  {
    "codigo":762690000,
    "descripcion":"LINFOMA DE HODGKIN CLÁSICO"
  },
  {
    "codigo":305773008,
    "descripcion":"ATENDIDO POR DIETISTA HOSPITALARIO"
  },
  {
    "codigo":236567003,
    "descripcion":"COLOCACIÓN ERRÓNEA DE CATÉTER DE DIÁLISIS PERITONEAL AGUDA"
  },
  {
    "codigo":300268000,
    "descripcion":"SALIVACIÓN REDUCIDA"
  },
  {
    "codigo":1186839009,
    "descripcion":"DETERIORO COGNITIVO DEBIDO A TOXICIDAD POR PLOMO"
  },
  {
    "codigo":201964002,
    "descripcion":"ARTRITIS ALÉRGICA DE REGIÓN DE HOMBRO"
  },
  {
    "codigo":105495008,
    "descripcion":"RETIRO FORZADO"
  },
  {
    "codigo":365804002,
    "descripcion":"NIVEL SÉRICO DE ALFA-FETOPROTEÍNA - HALLAZGO"
  },
  {
    "codigo":15972701000119106,
    "descripcion":"TROMBOSIS DE ARTERIA ESPLÉNICA"
  },
  {
    "codigo":460438000,
    "descripcion":"ORIGEN ANÓMALO DE GRAN ARTERIA DEL CONO EN ARTERIA CORONARIA DERECHA"
  },
  {
    "codigo":296598003,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE GENTAMICINA"
  },
  {
    "codigo":1148566005,
    "descripcion":"MUCOCELE DE SENO ETMOIDAL"
  },
  {
    "codigo":1686006,
    "descripcion":"TRASTORNO DE ANSIEDAD INDUCIDO POR SEDANTES, HIPNÓTICOS Y\/O ANSIOLÍTICOS"
  },
  {
    "codigo":1279638007,
    "descripcion":"CIERRE VELOFARÍNGEO INCOMPLETO CONGÉNITO DEBIDO A ANOMALÍA ANATÓMICA"
  },
  {
    "codigo":16028151000119103,
    "descripcion":"EXOSTOSIS DE AMBOS PIES"
  },
  {
    "codigo":294763001,
    "descripcion":"ALERGIA A CICLOFENILO"
  },
  {
    "codigo":720747002,
    "descripcion":"SÍNDROME DE COOKS"
  },
  {
    "codigo":427670006,
    "descripcion":"AZOOSPERMIA CAUSADA POR FÁRMACO"
  },
  {
    "codigo":425835006,
    "descripcion":"TRASTORNO DE LA RECONSTITUCIÓN INMUNOLÓGICA"
  },
  {
    "codigo":718912003,
    "descripcion":"DISCAPACIDAD INTELECTUAL LIGADA AL CROMOSOMA X TIPO TURNER"
  },
  {
    "codigo":20091000175107,
    "descripcion":"INSUFICIENCIA RESPIRATORIA HIPOXÉMICA E HIPERCÁPNICA CRÓNICA REAGUDIZADA"
  },
  {
    "codigo":30331000175109,
    "descripcion":"ÚLCERA POR PRESIÓN EN CABEZA, ESTADIO II"
  },
  {
    "codigo":15674001000119100,
    "descripcion":"MIOSITIS INFECCIOSA DE AMBOS MUSLOS"
  },
  {
    "codigo":94485005,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL TEJIDO PERIRRENAL"
  },
  {
    "codigo":127253006,
    "descripcion":"NEOPLASIA DE LOS GANGLIOS LINFÁTICOS RETROPERITONEALES"
  },
  {
    "codigo":125418000,
    "descripcion":"AGREGADO CITOPLÁSMICO CRISTALINO"
  },
  {
    "codigo":225557009,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN DE CABEZA"
  },
  {
    "codigo":92650001,
    "descripcion":"CARCINOMA IN SITU DE BRONQUIO PRINCIPAL"
  },
  {
    "codigo":715242008,
    "descripcion":"SÍNDROME DE DISPLASIA METAFISARIA DE CÚBITO"
  },
  {
    "codigo":123583002,
    "descripcion":"TUBERCÚLIDES"
  },
  {
    "codigo":254655003,
    "descripcion":"CARCINOMA VERRUGOSO PLANTAR"
  },
  {
    "codigo":285588004,
    "descripcion":"DEFICIENCIA NUTRICIONAL DEBIDA A INGESTA INSUFICIENTE"
  },
  {
    "codigo":56212008,
    "descripcion":"AGENESIA DE CÉLULAS DE LEYDIG"
  },
  {
    "codigo":283753000,
    "descripcion":"MORDEDURA DE PERRO EN LA MUÑECA"
  },
  {
    "codigo":11823761000119107,
    "descripcion":"HERIDA DE BRAZO IZQUIERDO DEBIDA A PICADURA DE INSECTO NO VENENOSO"
  },
  {
    "codigo":449428009,
    "descripcion":"AURÍCULA IZQUIERDA DIVIDIDA CON DESEMBOCADURA DE TODAS LAS VENAS PULMONARES EN LA CÁMARA PROXIMAL Y LUEGO EN LA AURÍCULA IZQUIERDA CON COMUNICACIÓN ADICIONAL CON LA CÁMARA VENOSA PULMONAR"
  },
  {
    "codigo":250985004,
    "descripcion":"VALVA AÓRTICA PERFORADA"
  },
  {
    "codigo":414825006,
    "descripcion":"NEOPLASIA DE TIPO DE CÉLULA HEMATOPOYÉTICA"
  },
  {
    "codigo":249150000,
    "descripcion":"TRANSMISIÓN DE LA ONDA DE CONTRACCIÓN UTERINA"
  },
  {
    "codigo":1363262002,
    "descripcion":"METABOLIZADOR INTERMEDIO DE FAMILIA 2 SUBFAMILIA C MIEMBRO 9 *1\/*8 DE CITOCROMO P450"
  },
  {
    "codigo":281918005,
    "descripcion":"FRACTURA DE APÓFISIS ESPINOSA DE VÉRTEBRA CERVICAL"
  },
  {
    "codigo":52542005,
    "descripcion":"NECROBACILOSIS"
  },
  {
    "codigo":1230355000,
    "descripcion":"ANOMALÍA CONGÉNITA DE AMBAS EXTREMIDADES SUPERIORES"
  },
  {
    "codigo":314686009,
    "descripcion":"PESO DEL NIÑO: > PERCENTILO 99,6"
  },
  {
    "codigo":1197587003,
    "descripcion":"SÍNDROME DE ESPASTICIDAD NEONATAL LETAL Y ENCEFALOPATÍA EPILÉPTICA"
  },
  {
    "codigo":47031000087100,
    "descripcion":"FRACTURA DE FALANGE PROXIMAL DE PULGAR IZQUIERDO"
  },
  {
    "codigo":39351000087101,
    "descripcion":"HERIDA PUNZANTE DE DEDO MEÑIQUE DERECHO CON CUERPO EXTRAÑO"
  },
  {
    "codigo":41911000087102,
    "descripcion":"CONTUSIÓN DE EXTREMIDAD SUPERIOR DERECHA"
  },
  {
    "codigo":1162984000,
    "descripcion":"ENFERMEDAD HEREDITARIA DOMINANTE LIGADA AL CROMOSOMA X"
  },
  {
    "codigo":702397002,
    "descripcion":"DISGENESIA TUBULAR RENAL"
  },
  {
    "codigo":626416581000119101,
    "descripcion":"PORTADOR DE ACINETOBACTER BAUMANNII RESISTENTE A CARBAPENEM"
  },
  {
    "codigo":276413003,
    "descripcion":"MUCOSA NASAL HÚMEDA"
  },
  {
    "codigo":11852741000119101,
    "descripcion":"LESIÓN TRAUMÁTICA DE DEDO DE PIE IZQUIERDO"
  },
  {
    "codigo":1259453005,
    "descripcion":"FIBROSARCOMA PRIMARIO DE TEJIDO CONECTIVO"
  },
  {
    "codigo":473021009,
    "descripcion":"DISFUNCIÓN ERÉCTIL SECUNDARIA"
  },
  {
    "codigo":241810003,
    "descripcion":"ENVENENAMIENTO CAUSADO POR VENENO DE SERPIENTE DE LOS ÁRBOLES"
  },
  {
    "codigo":733330005,
    "descripcion":"DESVIACIÓN DE LA MIRADA HACIA ARRIBA"
  },
  {
    "codigo":77970009,
    "descripcion":"CARDIOPATÍA HIPERTENSIVA BENIGNA SIN INSUFICIENCIA CARDÍACA CONGESTIVA"
  },
  {
    "codigo":895335002,
    "descripcion":"CURVATURA ANORMAL DE FALANGE DE DEDO ANULAR"
  },
  {
    "codigo":403815003,
    "descripcion":"MOTEADO AXILAR POR NEUROFIBROMATOSIS"
  },
  {
    "codigo":305511001,
    "descripcion":"BAJO ATENCIÓN DE MICROBIÓLOGO CLÍNICO"
  },
  {
    "codigo":371047008,
    "descripcion":"HIPOTONÍA TRAUMÁTICA"
  },
  {
    "codigo":1155644000,
    "descripcion":"INTOXICACIÓN CAUSADA POR METAL Y\/O COMPUESTO METÁLICO"
  },
  {
    "codigo":205372002,
    "descripcion":"CRECIMIENTO EXCESIVO CONGÉNITO DE PIE"
  },
  {
    "codigo":270908003,
    "descripcion":"FÍSTULA TRAQUEOESOFÁGICA ADQUIRIDA"
  },
  {
    "codigo":1066521000000103,
    "descripcion":"CAPAZ DE USAR TECLADO DE COMPUTADORA ADAPTADO"
  },
  {
    "codigo":8764008,
    "descripcion":"ACIDOSIS RESPIRATORIA CRÓNICA"
  },
  {
    "codigo":269073001,
    "descripcion":"FRACTURA EXPUESTA DE TERCERA VÉRTEBRA CERVICAL"
  },
  {
    "codigo":6929003,
    "descripcion":"CARÚNCULA URETRAL"
  },
  {
    "codigo":170769004,
    "descripcion":"PACIENTE DIABÉTICO - COOPERATIVO"
  },
  {
    "codigo":1071641000000109,
    "descripcion":"NO LAVA LA ROPA"
  },
  {
    "codigo":220101000119108,
    "descripcion":"IRITIS SECUNDARIA INFECCIOSA"
  },
  {
    "codigo":234470000,
    "descripcion":"DEFECTO DE LA MEMBRANA PLAQUETARIA"
  },
  {
    "codigo":70630002,
    "descripcion":"CARÁCTER ESQUIZOIDE"
  },
  {
    "codigo":365542002,
    "descripcion":"HALLAZGO RELACIONADO CON CAMBIOS LABORALES"
  },
  {
    "codigo":168934007,
    "descripcion":"ANGIOCARDIOGRAFÍA NORMAL"
  },
  {
    "codigo":10679391000119104,
    "descripcion":"TUMORACIÓN DE LA PIEL DE LA CABEZA"
  },
  {
    "codigo":298171004,
    "descripcion":"INFLAMACIÓN DE ARTICULACIÓN DE TOBILLO"
  },
  {
    "codigo":429243003,
    "descripcion":"FIBRILACIÓN VENTRICULAR SOSTENIDA"
  },
  {
    "codigo":3259006,
    "descripcion":"INTOXICACIÓN POR HOMERIA"
  },
  {
    "codigo":296336001,
    "descripcion":"SOBREDOSIS DE ATENOLOL"
  },
  {
    "codigo":230800004,
    "descripcion":"COMA ALCOHÓLICO"
  },
  {
    "codigo":165264009,
    "descripcion":"CAMINA 0-29 METROS EN 1 MINUTO"
  },
  {
    "codigo":294501004,
    "descripcion":"ALERGIA A CLOXACILINA"
  },
  {
    "codigo":292666002,
    "descripcion":"REACCIÓN ADVERSA AL ETRETINATO"
  },
  {
    "codigo":192527004,
    "descripcion":"ELABORACIÓN DE SÍNTOMAS FÍSICOS POR RAZONES PSICOLÓGICAS"
  },
  {
    "codigo":15731961000119105,
    "descripcion":"AGRANDAMIENTO DE AMBAS GLÁNDULAS LAGRIMALES"
  },
  {
    "codigo":126991009,
    "descripcion":"NEOPLASIA DE LOS NERVIOS PERIFÉRICOS DEL TÓRAX"
  },
  {
    "codigo":288996002,
    "descripcion":"BEBE DE UN BIBERÓN"
  },
  {
    "codigo":878820003,
    "descripcion":"RINOCONJUNTIVITIS"
  },
  {
    "codigo":290831008,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR DOXEPINA"
  },
  {
    "codigo":26852004,
    "descripcion":"DEMENCIA DEGENERATIVA PRIMARIA TIPO ALZHEIMER, DE INICIO EN LA EDAD SENIL, CON DEPRESIÓN"
  },
  {
    "codigo":92388007,
    "descripcion":"NEOPLASIA BENIGNA DE PARTES BLANDAS DE AXILA"
  },
  {
    "codigo":385465001,
    "descripcion":"CONCENTRACIÓN BACTERICIDA MÍNIMA - HALLAZGO"
  },
  {
    "codigo":125156009,
    "descripcion":"SATISFACTORIO PARA EVALUACIÓN, PERO ESCASO POR FALTA DE INFORMACIÓN CLÍNICA APROPIADA ACERCA DEL PACIENTE"
  },
  {
    "codigo":11773331000119101,
    "descripcion":"RUPTURA TRAUMÁTICA DE LIGAMENTO CUBITAL COLATERAL DE CODO IZQUIERDO"
  },
  {
    "codigo":254393004,
    "descripcion":"CARCINOMA DEL FRENILLO LABIAL"
  },
  {
    "codigo":1237433005,
    "descripcion":"DERMATITIS DE CONTACTO CAUSADA POR ACEITE AUTOMOTRIZ"
  },
  {
    "codigo":11855251000119102,
    "descripcion":"AMPOLLA TRAUMÁTICA DE LENGUA"
  },
  {
    "codigo":188857008,
    "descripcion":"NEOPLASIA BENIGNA DE PERITONEO Y RETROPERITONEO"
  },
  {
    "codigo":449166001,
    "descripcion":"SCHWANNOMA DE AXILA"
  },
  {
    "codigo":209373003,
    "descripcion":"FRACTURA-SUBLUXACIÓN NO EXPUESTA DE ARTICULACIÓN TARSOMETATARSIANA"
  },
  {
    "codigo":285326004,
    "descripcion":"ARO INCRUSTADO EN EL LÓBULO AURICULAR"
  },
  {
    "codigo":88718007,
    "descripcion":"DERMATITIS DE CONTACTO SUBAGUDA"
  },
  {
    "codigo":185187003,
    "descripcion":"ATENDIDO EN CONSULTORIO DE PSICOLOGÍA INFANTIL"
  },
  {
    "codigo":283491004,
    "descripcion":"HERIDA PUNZANTE EN DEDO GORDO"
  },
  {
    "codigo":447331003,
    "descripcion":"INFECCIÓN CAUSADA POR STREPTOCOCCUS DEL GRUPO D"
  },
  {
    "codigo":86883006,
    "descripcion":"EDAD GESTACIONAL, 23 SEMANAS"
  },
  {
    "codigo":414563008,
    "descripcion":"RESPIRACIÓN DE KUSSMAUL"
  },
  {
    "codigo":412728002,
    "descripcion":"ALIMENTADO CON BIBERÓN AL NACER"
  },
  {
    "codigo":248888005,
    "descripcion":"SECRECIÓN QUE DRENA DE UNA FÍSTULA VAGINAL"
  },
  {
    "codigo":445496008,
    "descripcion":"CONDROCALCINOSIS DE ARTICULACIÓN DE PELVIS"
  },
  {
    "codigo":19512009,
    "descripcion":"MIEDO A LOS INSECTOS"
  },
  {
    "codigo":771341006,
    "descripcion":"SÍNDROME DE MICRODUPLICACIÓN 14Q11.2"
  },
  {
    "codigo":1197325007,
    "descripcion":"CARCINOMA METASTÁSICO DE GANGLIO LINFÁTICO DE PELVIS"
  },
  {
    "codigo":441826000,
    "descripcion":"CORTOCIRCUITO CARDÍACO DE DERECHA A IZQUIERDA"
  },
  {
    "codigo":48610005,
    "descripcion":"PELO ÁSPERO"
  },
  {
    "codigo":15842009,
    "descripcion":"TROMBOSIS DE VENA RENAL"
  },
  {
    "codigo":767671002,
    "descripcion":"HIPERTROFIA DE LENGUA ADQUIRIDA"
  },
  {
    "codigo":472759003,
    "descripcion":"HIPERTENSIÓN VENOSA PULMONAR DEBIDA A COMPRESIÓN DE GRAN VENA PULMONAR POR MEDIASTINITIS ESCLEROSANTE"
  },
  {
    "codigo":210615006,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DEL PULGAR, FALANGE PROXIMAL"
  },
  {
    "codigo":46775006,
    "descripcion":"SÍNDROME DE DIFICULTAD RESPIRATORIA EN EL RECIÉN NACIDO"
  },
  {
    "codigo":11828781000119105,
    "descripcion":"AMPOLLA DE MUSLO DERECHO, CON INFECCIÓN"
  },
  {
    "codigo":308919009,
    "descripcion":"HALLAZGOS DE SÍNTOMAS EN RELACIÓN CON LA DURACIÓN"
  },
  {
    "codigo":733068001,
    "descripcion":"SÍNDROME DE AUSENCIA DE TIBIA, POLIDACTILIA Y QUISTE ARACNOIDEO"
  },
  {
    "codigo":44940001,
    "descripcion":"DEFICIENCIA DE ADENOSINA DESAMINASA"
  },
  {
    "codigo":438156004,
    "descripcion":"CONVULSIÓN EPILÉPTICA ANÓXICA"
  },
  {
    "codigo":700300002,
    "descripcion":"ECTROPIÓN CICATRIZAL DE PÁRPADO SUPERIOR"
  },
  {
    "codigo":307084006,
    "descripcion":"INCAPAZ DE PROCESAR INFORMACIÓN"
  },
  {
    "codigo":110476007,
    "descripcion":"DESEO DE PRESERVAR LA DENTADURA"
  },
  {
    "codigo":77708008,
    "descripcion":"HEMORRAGIA DE TESTÍCULO"
  },
  {
    "codigo":896908007,
    "descripcion":"FORMA ANCHA ANORMAL CONGÉNITA DE FALANGE DISTAL DE QUINTO DEDO DE PIE"
  },
  {
    "codigo":403553002,
    "descripcion":"APLASIA CUTÁNEA CONGÉNITA SECUNDARIA A SÍNDROME DE MALFORMACIÓN (TIPO 9)"
  },
  {
    "codigo":43105007,
    "descripcion":"COREOATETOSIS"
  },
  {
    "codigo":10337008,
    "descripcion":"INSUFICIENCIA VALVULAR"
  },
  {
    "codigo":698465008,
    "descripcion":"CON MAYOR RIESGO DE ENDOCARDITIS"
  },
  {
    "codigo":41270004,
    "descripcion":"REACCIÓN DE HIPERSENSIBILIDAD SIN ANTICUERPOS BLOQUEANTES"
  },
  {
    "codigo":205110009,
    "descripcion":"CONTRACTURA EN FLEXIÓN CONGÉNITA DE LA RODILLA"
  },
  {
    "codigo":1055243002,
    "descripcion":"REFLEJO TIPO TAPETAL"
  },
  {
    "codigo":39435002,
    "descripcion":"PULSO RADIAL ANORMAL"
  },
  {
    "codigo":236043003,
    "descripcion":"HERNIA INTERNA ESTRANGULADA"
  },
  {
    "codigo":6667002,
    "descripcion":"ANADÍDIMO"
  },
  {
    "codigo":301579002,
    "descripcion":"NO SE MOVILIZA CON SILLA DE RUEDAS"
  },
  {
    "codigo":299744000,
    "descripcion":"REFLEJO PALMAR PRESENTE"
  },
  {
    "codigo":1348320001,
    "descripcion":"GRAN CANTIDAD DE SANGRE HEMOLIZADA DETECTADA EN ORINA POR TIRA REACTIVA"
  },
  {
    "codigo":365280002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA LLENAR EL LAVABO"
  },
  {
    "codigo":37600001,
    "descripcion":"PERICONDRITIS"
  },
  {
    "codigo":1217248006,
    "descripcion":"LINFEDEMA PRIMARIO CON COMPROMISO SISTÉMICO Y VISCERAL"
  },
  {
    "codigo":363445000,
    "descripcion":"NEOPLASIA MALIGNA DE VAGINA"
  },
  {
    "codigo":234208009,
    "descripcion":"RUPTURA DE FÍSTULA ARTERIOVENOSA"
  },
  {
    "codigo":232373003,
    "descripcion":"ATRESIA DE COANAS CON HIPOPLASIA DE RAYO RADIAL"
  },
  {
    "codigo":428981009,
    "descripcion":"LA VÍA AÉREA CONTIENE VÓMITO"
  },
  {
    "codigo":66698002,
    "descripcion":"INTOXICACIÓN POR DIETILESTILBESTROL"
  },
  {
    "codigo":296074003,
    "descripcion":"SOBREDOSIS DE TRIAZOLAM"
  },
  {
    "codigo":230538005,
    "descripcion":"NEURALGIA SECUNDARIA DEL NERVIO TRIGÉMINO"
  },
  {
    "codigo":722058005,
    "descripcion":"ALBINISMO OCULOCUTÁNEO TIPO 6"
  },
  {
    "codigo":197770008,
    "descripcion":"PIONEFROSIS AGUDA"
  },
  {
    "codigo":427146008,
    "descripcion":"DOLOR PROVOCADO POR TOSER"
  },
  {
    "codigo":294239008,
    "descripcion":"ALERGIA A AUROTIOMALATO DE SODIO"
  },
  {
    "codigo":15708001000119106,
    "descripcion":"DISECCIÓN DE ARTERIA CARÓTIDA IZQUIERDA"
  },
  {
    "codigo":95796007,
    "descripcion":"ESCLERITIS PROFUNDA"
  },
  {
    "codigo":30260009,
    "descripcion":"ABORTO SÉPTICO"
  },
  {
    "codigo":292404009,
    "descripcion":"REACCIÓN ADVERSA AL ZUCLOPENTIXOL"
  },
  {
    "codigo":225033002,
    "descripcion":"HALLAZGO RELACIONADO CON LOS RECUERDOS"
  },
  {
    "codigo":93961004,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA FARINGE"
  },
  {
    "codigo":307041000119107,
    "descripcion":"ARTRITIS ENTEROPÁTICA DE ARTICULACIÓN DE PIE"
  },
  {
    "codigo":1306377005,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE CUADRANTE INFERIOR EXTERNO DE MAMA"
  },
  {
    "codigo":126729006,
    "descripcion":"MICROANGIOPATÍA TROMBÓTICA"
  },
  {
    "codigo":10956641000119108,
    "descripcion":"HERIDA ABIERTA DE DEDO ANULAR DE MANO IZQUIERDA"
  },
  {
    "codigo":26590002,
    "descripcion":"ECTROPIÓN CONGÉNITO"
  },
  {
    "codigo":92126004,
    "descripcion":"NEOPLASIA BENIGNA DE ENCÍA"
  },
  {
    "codigo":59358005,
    "descripcion":"INFESTACIÓN CAUSADA POR MALLOPHAGA"
  },
  {
    "codigo":90291000,
    "descripcion":"ASPECTO PERSONAL CONFORME A LA EDAD DECLARADA"
  },
  {
    "codigo":288734008,
    "descripcion":"RESPONDE A LA COMUNICACIÓN INICIADA POR OTROS"
  },
  {
    "codigo":286899003,
    "descripcion":"CARCINOMA DE ÓRGANO GENITAL"
  },
  {
    "codigo":21841000119100,
    "descripcion":"TRASTORNO MENTAL ORGÁNICO INDUCIDO POR FENCICLIDINA"
  },
  {
    "codigo":96081000119101,
    "descripcion":"PANCREATITIS AGUDA DEBIDA A CÁLCULO DE COLÉDOCO"
  },
  {
    "codigo":12058961000119102,
    "descripcion":"RUPTURA DE IMPLANTE DE MAMA IZQUIERDA"
  },
  {
    "codigo":367441000119103,
    "descripcion":"DISFUNCIÓN ERÉCTIL POSTERIOR A CISTECTOMÍA RADICAL"
  },
  {
    "codigo":15673681000119103,
    "descripcion":"GRANULOMA POR CUERPO EXTRAÑO DE PARTES BLANDAS BILATERALES DE HOMBROS"
  },
  {
    "codigo":98641000119100,
    "descripcion":"BRONCOESPASMO AGUDO"
  },
  {
    "codigo":15630161000119106,
    "descripcion":"ANTEVERSIÓN CONGÉNITA DE AMBOS FÉMURES"
  },
  {
    "codigo":15671121000119107,
    "descripcion":"GENU RECURVATUM CONGÉNITO DERECHO"
  },
  {
    "codigo":334161000119108,
    "descripcion":"LAGOFTALMOS DE PÁRPADO INFERIOR DERECHO"
  },
  {
    "codigo":12199761000119106,
    "descripcion":"INFECCIÓN ASOCIADA CON PRÓTESIS ARTICULAR DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":115769681000119108,
    "descripcion":"LACERACIÓN DE MÚSCULO INTRÍNSECO DE MANO"
  },
  {
    "codigo":103761000119107,
    "descripcion":"SÍNDROME PARALÍTICO DE LOS CUATRO MIEMBROS COMO SECUELA DE ACCIDENTE CEREBROVASCULAR"
  },
  {
    "codigo":290641000119107,
    "descripcion":"DISFAGIA DEBIDA A HEMORRAGIA INTRACEREBRAL NO TRAUMÁTICA Y POSTERIOR A ELLA"
  },
  {
    "codigo":16907601000119106,
    "descripcion":"ESPASMO HEMIFACIAL BILATERAL"
  },
  {
    "codigo":22920003,
    "descripcion":"ACNÉ CAUSADA POR SUSTANCIAS QUÍMICAS EXTERNAS"
  },
  {
    "codigo":15742801000119109,
    "descripcion":"TUMEFACCIÓN BILATERAL DE ARTICULACIÓN DE MUÑECA"
  },
  {
    "codigo":15668561000119109,
    "descripcion":"PIE VALGO IZQUIERDO"
  },
  {
    "codigo":15740241000119108,
    "descripcion":"DEFORMIDAD ORBITARIA DERECHA"
  },
  {
    "codigo":682321000119109,
    "descripcion":"ANGIOSARCOMA PRIMARIO DE CABEZA"
  },
  {
    "codigo":283229007,
    "descripcion":"CUERPO EXTRAÑO SUPERFICIAL, VIDRIO"
  },
  {
    "codigo":16091131000119108,
    "descripcion":"ANGIOSARCOMA PRIMARIO DE FRENTE"
  },
  {
    "codigo":1264434004,
    "descripcion":"LACERACIÓN DE TENDÓN DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":838450006,
    "descripcion":"ESTENOSIS SEVERA DE VÁLVULA MITRAL"
  },
  {
    "codigo":1231666008,
    "descripcion":"MACULOPATÍA ISQUÉMICA DEBIDA A OCLUSIÓN DE RAMA DE VENA RETINIANA"
  },
  {
    "codigo":248626009,
    "descripcion":"BOSTEZO"
  },
  {
    "codigo":707378008,
    "descripcion":"CARCINOMA MIOEPITELIAL PRIMARIO DE TRÁQUEA"
  },
  {
    "codigo":17415003,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE DEDO DE LA MANO, CON INFECCIÓN"
  },
  {
    "codigo":246791007,
    "descripcion":"CLIC DE OBLICUO SUPERIOR EN MOVIMIENTO OCULAR"
  },
  {
    "codigo":310492000,
    "descripcion":"PESO AL NACER ENTRE 751 G Y 1000 G"
  },
  {
    "codigo":1162460001,
    "descripcion":"DELECIÓN PARCIAL DE BRAZO LARGO DEL CROMOSOMA 15"
  },
  {
    "codigo":769244003,
    "descripcion":"TRASTORNO DE LA MÁCULA DERECHA DEBIDO A DIABETES MELLITUS"
  },
  {
    "codigo":81116005,
    "descripcion":"QUEMADURA DE LA BARBILLA"
  },
  {
    "codigo":212188006,
    "descripcion":"LESIÓN DE LA MÉDULA LUMBAR POSTERIOR SIN LESIÓN ÓSEA"
  },
  {
    "codigo":48348007,
    "descripcion":"RUIDOS RESPIRATORIOS NORMALES"
  },
  {
    "codigo":408796008,
    "descripcion":"MORTINATO - SE DESCONOCE SI LA MUERTE FETAL SE PRODUJO DURANTE EL PARTO O ANTES DEL TRABAJO DE PARTO"
  },
  {
    "codigo":1073301000119106,
    "descripcion":"ARTRITIS DE CADERA DERECHA CAUSADA POR BACTERIAS"
  },
  {
    "codigo":336021000119107,
    "descripcion":"CONJUNTIVITIS CRÓNICA DE OJO DERECHO"
  },
  {
    "codigo":441564005,
    "descripcion":"FRACTURA POR SOBRECARGA DEL CALCÁNEO"
  },
  {
    "codigo":77446002,
    "descripcion":"RESPUESTA LOCALIZADA"
  },
  {
    "codigo":110214003,
    "descripcion":"QUEMADURA DEL PISO DE LA BOCA"
  },
  {
    "codigo":700038005,
    "descripcion":"MASTITIS ASOCIADA CON LA LACTANCIA"
  },
  {
    "codigo":16471000202102,
    "descripcion":"RESPETA EL LÍMITE DE INTIMIDAD DE OTROS"
  },
  {
    "codigo":403291001,
    "descripcion":"LESIÓN UNGUEAL CAUSADA POR MICROONDAS"
  },
  {
    "codigo":763739002,
    "descripcion":"ESTUPOR RECURRENTE IDIOPÁTICO"
  },
  {
    "codigo":1255259004,
    "descripcion":"PÉRDIDA DE DIENTE TRAUMÁTICA"
  },
  {
    "codigo":1220656000,
    "descripcion":"INFECCIÓN GENITOPÉLVICA DEBIDA A INTERRUPCIÓN COMPLETA INDUCIDA DE EMBARAZO Y POSTERIOR A ELLA"
  },
  {
    "codigo":309551000119105,
    "descripcion":"NECROSIS AVASCULAR DE RADIO IZQUIERDO"
  },
  {
    "codigo":1288027008,
    "descripcion":"TUMOR DE CÉLULAS ENTEROCROMAFINES DE RECTO"
  },
  {
    "codigo":204848005,
    "descripcion":"FÍSTULA UTEROINTESTINAL CONGÉNITA"
  },
  {
    "codigo":1251589002,
    "descripcion":"RUPTURA TRAUMÁTICA DE PLACA PALMAR DE ARTICULACIÓN DE DEDO MEÑIQUE"
  },
  {
    "codigo":10877231000119107,
    "descripcion":"HERIDA ABIERTA DE MUSLO IZQUIERDO"
  },
  {
    "codigo":203013006,
    "descripcion":"MIOSITIS INFECCIOSA DE ANTEBRAZO"
  },
  {
    "codigo":792837007,
    "descripcion":"PULSO EN ARTERIA POPLÍTEA DERECHA AUSENTE"
  },
  {
    "codigo":301317008,
    "descripcion":"ANEMIA HEMOLÍTICA HEREDITARIA NO ESFEROCÍTICA"
  },
  {
    "codigo":71941009,
    "descripcion":"DISFONÍA DE ORIGEN NEUROLÓGICO"
  },
  {
    "codigo":235781009,
    "descripcion":"FÍSTULA INTESTINOURINARIA"
  },
  {
    "codigo":233946001,
    "descripcion":"HIPERTENSIÓN DE GRAN VASO PULMONAR"
  },
  {
    "codigo":365018005,
    "descripcion":"REACCIÓN A LA ESTIMULACIÓN REPETITIVA - HALLAZGO"
  },
  {
    "codigo":168410007,
    "descripcion":"EXTENDIDO CERVICAL: CAMBIOS LIMÍTROFES"
  },
  {
    "codigo":299482009,
    "descripcion":"TUMEFACCIÓN DE PARTES BLANDAS DE ARTICULACIÓN DE PIE"
  },
  {
    "codigo":363183006,
    "descripcion":"LESIÓN DE SISTEMA LINFÁTICO"
  },
  {
    "codigo":721796000,
    "descripcion":"INFECCIÓN CAUSADA POR CHRYSOSPORIUM"
  },
  {
    "codigo":263044008,
    "descripcion":"SUBLUXACIÓN DE ARTICULACIÓN DE LA COLUMNA VERTEBRAL LUMBAR"
  },
  {
    "codigo":293977001,
    "descripcion":"ALERGIA A LABETALOL"
  },
  {
    "codigo":195673002,
    "descripcion":"AMIGDALITIS ESTAFILOCÓCICA AGUDA"
  },
  {
    "codigo":1075811000119101,
    "descripcion":"TENDINITIS CALCIFICANTE DE PIE DERECHO"
  },
  {
    "codigo":228441006,
    "descripcion":"TRATA CON DROGAS"
  },
  {
    "codigo":11997641000119108,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DE PIE DERECHO"
  },
  {
    "codigo":62766000,
    "descripcion":"DESORIENTACIÓN EN RELACIÓN A LAS PERSONAS"
  },
  {
    "codigo":16067171000119102,
    "descripcion":"ALERGIA A ADITIVO ALIMENTARIO"
  },
  {
    "codigo":338531000119102,
    "descripcion":"IRIDOCICLITIS PRIMARIA DE OJO IZQUIERDO"
  },
  {
    "codigo":161070001,
    "descripcion":"FAMILIA MONOPARENTAL, PADRE PRESENTE"
  },
  {
    "codigo":128302006,
    "descripcion":"HEPATITIS C CRÓNICA"
  },
  {
    "codigo":292142009,
    "descripcion":"REACCIÓN ADVERSA A LAXANTE DE ANTRAQUINONA"
  },
  {
    "codigo":192003008,
    "descripcion":"TRASTORNO DE CONFUSIÓN AL DESPERTAR"
  },
  {
    "codigo":91864001,
    "descripcion":"CONJUNTIVITIS ROSÁCEA AGUDA"
  },
  {
    "codigo":93699008,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE VASO SANGUÍNEO DE LA CABEZA"
  },
  {
    "codigo":386776005,
    "descripcion":"HORMONA LUTEINIZANTE HIPOFISARIA ANORMAL"
  },
  {
    "codigo":419544009,
    "descripcion":"COLOBOMA PRIMARIO DEL CRISTALINO"
  },
  {
    "codigo":1204141008,
    "descripcion":"TROMBOSIS VENOSA PROFUNDA DE PANTORRILLA"
  },
  {
    "codigo":253869009,
    "descripcion":"RIÑÓN DISCOIDE"
  },
  {
    "codigo":219266003,
    "descripcion":"LESIÓN POR INTERVENCIÓN LEGAL CON GRANADA"
  },
  {
    "codigo":710786004,
    "descripcion":"GINGIVITIS DEBIDA A TRASTORNO DE COMPONENTE CELULAR DE LA SANGRE"
  },
  {
    "codigo":186498004,
    "descripcion":"ENCEFALITIS EPIDÉMICA"
  },
  {
    "codigo":284802004,
    "descripcion":"DIFICULTAD PARA REALIZAR ACTIVIDAD DE BAÑO"
  },
  {
    "codigo":282967005,
    "descripcion":"SE SIENTA"
  },
  {
    "codigo":86359006,
    "descripcion":"OTITIS MEDIA SUBAGUDA TRANSUDATIVA"
  },
  {
    "codigo":1003863006,
    "descripcion":"ESTENOSIS DE VÁLVULA TRONCAL DESPUÉS DE PROCEDIMIENTO"
  },
  {
    "codigo":18988001,
    "descripcion":"PLEURESÍA SÉPTICA"
  },
  {
    "codigo":446807009,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE CONDUCTO BILIAR PERIHILIAR"
  },
  {
    "codigo":444972004,
    "descripcion":"TENDINITIS DE ARTICULACIÓN METATARSOFALÁNGICA DE SEGUNDO DEDO DEL PIE"
  },
  {
    "codigo":246529004,
    "descripcion":"CONVULSIÓN PARCIAL SIMPLE CON SIGNOS MOTORES FOCALES QUE APARECEN DURANTE LA MARCHA"
  },
  {
    "codigo":443137009,
    "descripcion":"INFECCIÓN DE PABELLÓN AURICULAR PERFORADO"
  },
  {
    "codigo":408534005,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: PATUÁ"
  },
  {
    "codigo":13483000,
    "descripcion":"ESTENOSIS HIPERTRÓFICA DEL PÍLORO ADQUIRIDA"
  },
  {
    "codigo":373931001,
    "descripcion":"SENSACIÓN DE PESADEZ EN LAS EXTREMIDADES"
  },
  {
    "codigo":11836311000119104,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN DE PIE DERECHO"
  },
  {
    "codigo":46251005,
    "descripcion":"ENFERMEDAD MOTORA CORTICOESPINAL"
  },
  {
    "codigo":111787005,
    "descripcion":"INTOXICACIÓN POR HYPERICUM PERFORATUM"
  },
  {
    "codigo":79019005,
    "descripcion":"INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA II"
  },
  {
    "codigo":44416002,
    "descripcion":"CONSTRICCIÓN DE VÍA AÉREA"
  },
  {
    "codigo":11648002,
    "descripcion":"LINFANGITIS AGUDA DE LA REGIÓN SUBMANDIBULAR"
  },
  {
    "codigo":699776004,
    "descripcion":"DESVIACIÓN DE LA LÍNEA MEDIA MANDIBULAR HACIA LA DERECHA"
  },
  {
    "codigo":208256009,
    "descripcion":"FRACTURA EXPUESTA DE HÚMERO PROXIMAL, TRES PARTES"
  },
  {
    "codigo":403029001,
    "descripcion":"TIÑA CORPORAL CAUSADA POR MICROSPORUM FERRUGINEUM"
  },
  {
    "codigo":16669591000119108,
    "descripcion":"FRACTURA NO EXPUESTA DE ÓRBITA DERECHA"
  },
  {
    "codigo":239189008,
    "descripcion":"FALTA DE CICATRIZACIÓN DE SITIO DONANTE DE PIEL"
  },
  {
    "codigo":763477007,
    "descripcion":"LINFOMA PRIMARIO DE CONJUNTIVA"
  },
  {
    "codigo":302890002,
    "descripcion":"RUPTURAS RETINIANAS MÚLTIPLES"
  },
  {
    "codigo":401194005,
    "descripcion":"PRUEBA DE INCORPORACIÓN Y MARCHA - NORMAL"
  },
  {
    "codigo":237354006,
    "descripcion":"ABSCESO DE PEZÓN DE CAUSA OBSTÉTRICA"
  },
  {
    "codigo":366591001,
    "descripcion":"AMPLITUD DE MOVIMIENTO ACTIVO DE EXTENSIÓN DE LA RODILLA - HALLAZGO"
  },
  {
    "codigo":16888881000119105,
    "descripcion":"ESTENOSIS CONGÉNITA DE CONDUCTO AUDITIVO EXTERNO DERECHO"
  },
  {
    "codigo":202751009,
    "descripcion":"CALCIFICACIÓN DE DISCO DORSAL"
  },
  {
    "codigo":38911009,
    "descripcion":"ANEMIA HEMOLÍTICA HEREDITARIA"
  },
  {
    "codigo":102612005,
    "descripcion":"INTOLERANCIA AL ALCOHOL"
  },
  {
    "codigo":364756009,
    "descripcion":"NEFROPATÍA POR VIRUS PUUMALA"
  },
  {
    "codigo":788905002,
    "descripcion":"TRASTORNO CAUSADO POR ESTIMULANTE"
  },
  {
    "codigo":231849002,
    "descripcion":"DESPLAZAMIENTO DE ÓRBITA"
  },
  {
    "codigo":1149353004,
    "descripcion":"INTOXICACIÓN CAUSADA POR SUSTANCIA PSICOACTIVA"
  },
  {
    "codigo":68009005,
    "descripcion":"SIGNO DE ADSON"
  },
  {
    "codigo":395689002,
    "descripcion":"AMNESIA EPILÉPTICA TRANSITORIA"
  },
  {
    "codigo":2473007,
    "descripcion":"HETEROTROPÍA VERTICAL INTERMITENTE"
  },
  {
    "codigo":723369008,
    "descripcion":"PRESCRIPCIÓN DE MEDICACIÓN CORRESPONDIENTE A ATENCIÓN ANTICIPATORIA NO ADECUADA"
  },
  {
    "codigo":341041000119107,
    "descripcion":"PLIEGUE DE MEMBRANA DE DESCEMET DE OJO IZQUIERDO"
  },
  {
    "codigo":262782002,
    "descripcion":"LACERACIÓN DE CORAZÓN"
  },
  {
    "codigo":230014003,
    "descripcion":"POSICIÓN DEL TRONCO CON FLEXIÓN HACIA EL COSTADO"
  },
  {
    "codigo":721534003,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO RADIAL A NIVEL DE ANTEBRAZO"
  },
  {
    "codigo":197246005,
    "descripcion":"FÍSTULA UMBILICAL"
  },
  {
    "codigo":295550004,
    "descripcion":"SOBREDOSIS DE BUPIVACAÍNA"
  },
  {
    "codigo":195411001,
    "descripcion":"TROMBOFLEBITIS - VENA POPLÍTEA"
  },
  {
    "codigo":293715008,
    "descripcion":"ALERGIA A ISOFLURANO"
  },
  {
    "codigo":129875009,
    "descripcion":"TRASTORNO HABILIDAD DE INTERACCIÓN SOCIAL"
  },
  {
    "codigo":783400002,
    "descripcion":"FISURA COMPLETA DE PALADAR DURO"
  },
  {
    "codigo":193576003,
    "descripcion":"CATARATA CORTICAL"
  },
  {
    "codigo":717864006,
    "descripcion":"TRASTORNO VASCULAR DEL ESTÓMAGO"
  },
  {
    "codigo":29736007,
    "descripcion":"SÍNDROME DE INTOLERANCIA A LOS HIDRATOS DE CARBONO"
  },
  {
    "codigo":93437002,
    "descripcion":"OSIFICACIÓN DE CENTRO DE VÉRTEBRA CERVICAL CON FORMA DE MANCUERNA"
  },
  {
    "codigo":257277002,
    "descripcion":"TRASTORNO NEUROMUSCULAR"
  },
  {
    "codigo":15934821000119102,
    "descripcion":"DEDO EN GARRA CONGÉNITO DE PIE DERECHO"
  },
  {
    "codigo":224509008,
    "descripcion":"APOYO DEL LECHERO LOCAL"
  },
  {
    "codigo":288210004,
    "descripcion":"PARTO CON PRESENTACIÓN CEFÁLICA ANORMAL"
  },
  {
    "codigo":11838821000119103,
    "descripcion":"DISTENSIÓN DE MÚSCULO INTRÍNSECO DE MANO IZQUIERDA"
  },
  {
    "codigo":10691941000119103,
    "descripcion":"LESIÓN DE LA PIEL DE LA NARIZ"
  },
  {
    "codigo":10964171000119109,
    "descripcion":"LACERACIÓN DE CODO IZQUIERDO"
  },
  {
    "codigo":124370008,
    "descripcion":"DEFICIENCIA DE METILTRANSFERASA"
  },
  {
    "codigo":288101000119104,
    "descripcion":"INSOMNIO CONDUCTUAL INFANTIL, POR MALAS ASOCIACIONES CON EL INICIO DEL SUEÑO"
  },
  {
    "codigo":188071004,
    "descripcion":"MELANOMA MALIGNO DE LA REGIÓN DE LA FOSA POPLÍTEA"
  },
  {
    "codigo":253607006,
    "descripcion":"HIPOPLASIA DE CÚSPIDE DE VÁLVULA AÓRTICA"
  },
  {
    "codigo":1202044003,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE HUESO DE PELVIS"
  },
  {
    "codigo":284540006,
    "descripcion":"INFECCIÓN CAUSADA POR CLADOSPORIUM TRICHOIDES"
  },
  {
    "codigo":22396007,
    "descripcion":"ADOLESCENCIA"
  },
  {
    "codigo":249937002,
    "descripcion":"DEBILIDAD DE MÚSCULO DE TRONCO"
  },
  {
    "codigo":53329003,
    "descripcion":"PELVIS PLATIPÉLICA"
  },
  {
    "codigo":315473004,
    "descripcion":"NACIDO EN MALASIA"
  },
  {
    "codigo":282705006,
    "descripcion":"NO EMPUJA NI TIRA DE UN OBJETO AL CORRER"
  },
  {
    "codigo":1231142001,
    "descripcion":"MIASIS FURUNCULAR"
  },
  {
    "codigo":870694004,
    "descripcion":"RANGO DE FRECUENCIA CARDÍACA FETAL BASAL DE 40 A 80"
  },
  {
    "codigo":18726006,
    "descripcion":"ASTENIA SENIL"
  },
  {
    "codigo":248102006,
    "descripcion":"PROSTITUCIÓN MASCULINA"
  },
  {
    "codigo":82427000,
    "descripcion":"COMPLICACIÓN DE LA EXTREMIDAD SUPERIOR REIMPLANTADA"
  },
  {
    "codigo":279035001,
    "descripcion":"DORSALGIA AGUDA"
  },
  {
    "codigo":705019003,
    "descripcion":"DIFICULTAD EN EL MANEJO DEL CUIDADO DE ESTOMA"
  },
  {
    "codigo":1260240000,
    "descripcion":"RESISTENCIA A HORMONA TIROIDEA POR MUTACIÓN EN RECEPTOR ALFA DE HORMONA TIROIDEA"
  },
  {
    "codigo":703184001,
    "descripcion":"OCLUSIÓN ASINTOMÁTICA DE ARTERIA CARÓTIDA INTRACRANEAL"
  },
  {
    "codigo":770555009,
    "descripcion":"QUEMADURA DE GLOBO OCULAR"
  },
  {
    "codigo":11785881000119100,
    "descripcion":"ABRASIÓN DE PIEL DE REGIÓN DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":15056007,
    "descripcion":"ENVENENAMIENTO DEBIDO A PICADURA DE ARTRÓPODO VENENOSO"
  },
  {
    "codigo":111525002,
    "descripcion":"DEFORMIDAD ORBITARIA POR CIRUGÍA"
  },
  {
    "codigo":45989004,
    "descripcion":"HERNIA FEMORAL OBSTRUIDA CON GANGRENA"
  },
  {
    "codigo":11386000,
    "descripcion":"HERIDA ABIERTA DEL OÍDO"
  },
  {
    "codigo":275365008,
    "descripcion":"FRACTURA DE RADIO DURANTE EL PARTO"
  },
  {
    "codigo":109690000,
    "descripcion":"OSTEOMIELITIS ESCLEROSANTE CRÓNICA NO SUPURATIVA DE MAXILAR SUPERIOR"
  },
  {
    "codigo":1354874003,
    "descripcion":"LESIÓN TRAUMÁTICA DE VASO SANGUÍNEO DIGITAL DE DEDO MEÑIQUE"
  },
  {
    "codigo":1080831000119109,
    "descripcion":"HISTIOCITOMA FIBROSO MALIGNO PRIMARIO DE PARTES BLANDAS DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":238927000,
    "descripcion":"LUPUS ERITEMATOSO DISCOIDE CRÓNICO"
  },
  {
    "codigo":402767001,
    "descripcion":"SÍNDROME ECTODÉRMICO CON DEFECTOS EN PELO-DIENTE-SUDORACIÓN"
  },
  {
    "codigo":1254735000,
    "descripcion":"METÁSTASIS DE CARCINOMA DE CÉLULAS GRANDES EN AMBOS PULMONES"
  },
  {
    "codigo":9551004,
    "descripcion":"AMILOIDOSIS HEPÁTICA"
  },
  {
    "codigo":271695004,
    "descripcion":"CONDUCTA EMBARAZOSA"
  },
  {
    "codigo":763215008,
    "descripcion":"ANQUILOSIS CONGÉNITA DE ARTICULACIÓN TEMPOROMANDIBULAR"
  },
  {
    "codigo":202489000,
    "descripcion":"DOLOR DE ARTICULACIÓN TIBIOPERONEA"
  },
  {
    "codigo":106020009,
    "descripcion":"PATRÓN DE EJERCICIO FÍSICO"
  },
  {
    "codigo":300793002,
    "descripcion":"INCAPAZ DE MANEJAR Y EMPUJAR UN JUGUETE"
  },
  {
    "codigo":268025003,
    "descripcion":"OSTEOCONDROSIS JUVENIL DE CÓNDILO HUMERAL"
  },
  {
    "codigo":366329008,
    "descripcion":"HALLAZGO RELACIONADO CON LA VELOCIDAD DEL ALUMBRAMIENTO"
  },
  {
    "codigo":4046000,
    "descripcion":"ESPONDILOLISTESIS DEGENERATIVA"
  },
  {
    "codigo":724942006,
    "descripcion":"LESIÓN TRAUMÁTICA DE TENDÓN A LA ALTURA DEL ANTEBRAZO"
  },
  {
    "codigo":723107001,
    "descripcion":"ÚLCERA DE INTESTINO DELGADO CAUSADA POR CUERPO EXTRAÑO"
  },
  {
    "codigo":297123002,
    "descripcion":"DOLOR ANEXIAL A LA PALPACIÓN"
  },
  {
    "codigo":428195006,
    "descripcion":"CONTRACCIÓN DE LA PIEL DE LA MANO"
  },
  {
    "codigo":460963006,
    "descripcion":"ORIGEN ANÓMALO DE LIGAMENTO ARTERIOSO EN ARTERIA SUBCLAVIA DERECHA"
  },
  {
    "codigo":1149091008,
    "descripcion":"INFLUENZA CAUSADA POR VIRUS DE LA INFLUENZA A SUBTIPO H2"
  },
  {
    "codigo":33144001,
    "descripcion":"CIRROSIS PARASITARIA"
  },
  {
    "codigo":295288001,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE FENILBUTAZONA"
  },
  {
    "codigo":262520005,
    "descripcion":"LESIÓN TRAUMÁTICA DE PULGAR"
  },
  {
    "codigo":64077000,
    "descripcion":"DEGENERACIÓN DEL MIOCARDIO"
  },
  {
    "codigo":229752008,
    "descripcion":"TRASTORNO DEL PROCESAMIENTO AUDITIVO"
  },
  {
    "codigo":293453002,
    "descripcion":"REACCIÓN ADVERSA A DIURÉTICO"
  },
  {
    "codigo":346061000119101,
    "descripcion":"PTOSIS PALPEBRAL SUPERIOR BILATERAL"
  },
  {
    "codigo":721272009,
    "descripcion":"INFECCIÓN QUE OCASIONA ESPONDILOARTRITIS"
  },
  {
    "codigo":31309002,
    "descripcion":"FARINGITIS POR VIRUS SINCICIAL RESPIRATORIO"
  },
  {
    "codigo":129613007,
    "descripcion":"SÍNDROME DE NEURALGIA DEL PLEXO TIMPÁNICO"
  },
  {
    "codigo":1083341000119102,
    "descripcion":"OTITIS EXTERNA CRÓNICA DE AMBOS CONDUCTOS AUDITIVOS EXTERNOS CAUSADA POR HONGO"
  },
  {
    "codigo":62242007,
    "descripcion":"QUEMADURA EPIDÉRMICA DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":783138008,
    "descripcion":"PSEUDO-SÍNDROME DE MEIGS"
  },
  {
    "codigo":226082007,
    "descripcion":"DIETA DE PÉPTIDOS MODIFICADA"
  },
  {
    "codigo":95010009,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA PARED POSTERIOR DE LA NASOFARINGE"
  },
  {
    "codigo":1010679003,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE PARED LATERAL DE NASOFARINGE"
  },
  {
    "codigo":289783000,
    "descripcion":"CUELLO UTERINO CENTRALIZADO"
  },
  {
    "codigo":224247002,
    "descripcion":"TIENE SU PROPIA HABITACIÓN"
  },
  {
    "codigo":1172684002,
    "descripcion":"ENFERMEDAD DE CHARCOT-MARIE-TOOTH AUTOSÓMICA DOMINANTE TIPO 2 POR MUTACIÓN EN EL GEN DGAT2"
  },
  {
    "codigo":255180005,
    "descripcion":"NEOPLASIA BENIGNA DE HUESO DEL PIE"
  },
  {
    "codigo":11814861000119106,
    "descripcion":"RUPTURA TRAUMÁTICA DE PLACA PALMAR DE ARTICULACIÓN DE DEDO MEÑIQUE IZQUIERDO"
  },
  {
    "codigo":187809000,
    "descripcion":"NEOPLASIA MALIGNA DEL MESOCOLON"
  },
  {
    "codigo":286113001,
    "descripcion":"LIMPIA EL POLVO"
  },
  {
    "codigo":253345004,
    "descripcion":"APÉNDICE AURICULAR DERECHO AUSENTE"
  },
  {
    "codigo":12224461000119108,
    "descripcion":"INFECCIÓN DE CORAZÓN TRASPLANTADO"
  },
  {
    "codigo":251510000,
    "descripcion":"ASIMETRÍA EN LA FRECUENCIA ALFA"
  },
  {
    "codigo":319591000119102,
    "descripcion":"ARTRITIS REACTIVA DE ARTICULACIÓN DE CODO DERECHO"
  },
  {
    "codigo":448118003,
    "descripcion":"DEFECTO DEL TABIQUE AURICULOVENTRICULAR CON COMPONENTES AURICULARES Y VENTRICULARES Y VÁLVULAS AURICULOVENTRICULARES SEPARADAS"
  },
  {
    "codigo":10641511000119103,
    "descripcion":"NECROSIS DE MÚSCULO DE PIERNA CONCOMITANTE CON ÚLCERA CRÓNICA DE PIERNA Y DEBIDA A ELLA"
  },
  {
    "codigo":249675000,
    "descripcion":"TÓRAX RÍGIDO"
  },
  {
    "codigo":284278009,
    "descripcion":"UTILIZA EL TRÍPODE (MOVIMIENTO DE LA MANO)"
  },
  {
    "codigo":1003339008,
    "descripcion":"ECTRODACTILIA BILATERAL DE MANO"
  },
  {
    "codigo":53067009,
    "descripcion":"ASCITIS PANCREÁTICA"
  },
  {
    "codigo":1263648003,
    "descripcion":"PULGAR EN GATILLO DE MANO DERECHA EN EDAD PEDIÁTRICA"
  },
  {
    "codigo":772128004,
    "descripcion":"ANTECOLLIS"
  },
  {
    "codigo":444448004,
    "descripcion":"LESIÓN TRAUMÁTICA DE LIGAMENTO LATERAL INTERNO DE RODILLA"
  },
  {
    "codigo":247840005,
    "descripcion":"MIEDO A LAS REUNIONES SOCIALES"
  },
  {
    "codigo":311541004,
    "descripcion":"CAPAZ DE PROCESAR INFORMACIÓN A VELOCIDAD NORMAL"
  },
  {
    "codigo":213237007,
    "descripcion":"COMPLICACIÓN POR ANASTOMOSIS INTERNA EN LAS VÍAS URINARIAS"
  },
  {
    "codigo":1163509008,
    "descripcion":"HIPOADRENALISMO DEBIDO A PARACOCCIDIOIDOMICOSIS"
  },
  {
    "codigo":80330000,
    "descripcion":"INFERTILIDAD POR TRATAMIENTO FARMACOLÓGICO"
  },
  {
    "codigo":211402004,
    "descripcion":"ABRASIÓN DE PIEL DE PIE"
  },
  {
    "codigo":78495000,
    "descripcion":"HENDIDURA DE VALVA DE VÁLVULA MITRAL"
  },
  {
    "codigo":373407002,
    "descripcion":"TRASTORNO INFLAMATORIO DEL APARATO DIGESTIVO"
  },
  {
    "codigo":111263009,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE HOMBRO"
  },
  {
    "codigo":109428005,
    "descripcion":"DEFECTO PERIMEMBRANOSO DEL TABIQUE INTERVENTRICULAR"
  },
  {
    "codigo":369737001,
    "descripcion":"INVASIÓN TUMORAL VASCULAR, MACROSCÓPICAMENTE VISIBLE"
  },
  {
    "codigo":238665009,
    "descripcion":"LIQUEN PLANO DE LA LENGUA"
  },
  {
    "codigo":402505009,
    "descripcion":"CARCINOMA BASOCELULAR DE LABIO SUPERIOR"
  },
  {
    "codigo":7454002,
    "descripcion":"CONVULSIÓN PARCIAL SIMPLE CON DISFUNCIÓN AUTONÓMICA"
  },
  {
    "codigo":204062004,
    "descripcion":"ATRESIA DEL FORAMEN DE LUSCHKA"
  },
  {
    "codigo":348571000119103,
    "descripcion":"ABSCESO PERIORBITARIO DE OJO IZQUIERDO"
  },
  {
    "codigo":169459000,
    "descripcion":"SUSPENDE LA TOMA DE ANTICONCEPTIVOS ORALES"
  },
  {
    "codigo":366067002,
    "descripcion":"PREFERENCIA DE MANO - HALLAZGO"
  },
  {
    "codigo":202227003,
    "descripcion":"SUBLUXACIÓN RECURRENTE DE LA CABEZA RADIAL"
  },
  {
    "codigo":5619004,
    "descripcion":"SÍNDROME DE BARDET - BIEDL"
  },
  {
    "codigo":890355004,
    "descripcion":"ESTENOSIS SUBGLÓTICA CONGÉNITA DE COTTON-MYER GRADO 4"
  },
  {
    "codigo":300531004,
    "descripcion":"PRÓSTATA DE TAMAÑO NORMAL"
  },
  {
    "codigo":234995007,
    "descripcion":"GINGIVITIS FIBROSA CRÓNICA"
  },
  {
    "codigo":429768000,
    "descripcion":"ÚLCERA ISQUÉMICA DE DEDO DEL PIE"
  },
  {
    "codigo":298696002,
    "descripcion":"PRUEBA DE ESTIRAMIENTO DE NERVIO FEMORAL POSITIVA"
  },
  {
    "codigo":167624003,
    "descripcion":"VOLUMEN DE HECES: ESCASO"
  },
  {
    "codigo":724680005,
    "descripcion":"TRASTORNO DEL ESTADO DE ÁNIMO CON SÍNTOMAS MANÍACOS CAUSADO POR FÁRMACO HIPNÓTICO"
  },
  {
    "codigo":15968821000119100,
    "descripcion":"TROMBOFLEBITIS DE VENA ILÍACA DERECHA"
  },
  {
    "codigo":15641141000119100,
    "descripcion":"ADENOMA VELLOSO DE DUODENO"
  },
  {
    "codigo":427933004,
    "descripcion":"ATENDIDO EN CONSULTORIO ESPECIALIZADO EN TRASTORNOS MUSCULOESQUELÉTICOS"
  },
  {
    "codigo":296861008,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE CLORPROPAMIDA"
  },
  {
    "codigo":721010003,
    "descripcion":"SÍNDROME CORAZÓN-MANO TIPO 2"
  },
  {
    "codigo":1179762006,
    "descripcion":"NEOPLASIA MALIGNA DE LÓBULO MEDIO DE PULMÓN DERECHO"
  },
  {
    "codigo":360562008,
    "descripcion":"EDEMA NUTRICIONAL SIN DESPIGMENTACIÓN DE LA PIEL Y\/O DEL PELO"
  },
  {
    "codigo":295026008,
    "descripcion":"ALERGIA A METOLAZONA"
  },
  {
    "codigo":31047003,
    "descripcion":"PAPULOSIS LINFOMATOIDE"
  },
  {
    "codigo":1145159004,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR PIPERAZINA Y\/O DERIVADO DE PIPERAZINA"
  },
  {
    "codigo":293191008,
    "descripcion":"REACCIÓN ADVERSA A SULFONILUREA"
  },
  {
    "codigo":94748001,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE COLON ASCENDENTE"
  },
  {
    "codigo":424263008,
    "descripcion":"ADENOMA DE HÍGADO"
  },
  {
    "codigo":225820007,
    "descripcion":"VÍCTIMA DE INTIMIDACIÓN"
  },
  {
    "codigo":1208860008,
    "descripcion":"NISTAGMO PERIÓDICO ALTERNANTE ADQUIRIDO"
  },
  {
    "codigo":715505002,
    "descripcion":"DISPLASIA RIZOMÉLICA TIPO PATTERSON LOWRY"
  },
  {
    "codigo":289521003,
    "descripcion":"MASA VAGINAL"
  },
  {
    "codigo":92913004,
    "descripcion":"FORMA ANORMAL CONGÉNITA DE LA VESÍCULA BILIAR"
  },
  {
    "codigo":125681006,
    "descripcion":"PERSONA SOLTERA"
  },
  {
    "codigo":846577007,
    "descripcion":"ANGIOEDEMA DE PÁRPADO"
  },
  {
    "codigo":191217008,
    "descripcion":"ANEMIA HEMOLÍTICA MECÁNICA"
  },
  {
    "codigo":254918001,
    "descripcion":"SARCOMA DE RIÑÓN"
  },
  {
    "codigo":713670002,
    "descripcion":"INCLUIDO EN ESTUDIO CLÍNICO SOBRE FÁRMACO"
  },
  {
    "codigo":285851007,
    "descripcion":"INCAPAZ DE CONTROLAR LAS EMOCIONES"
  },
  {
    "codigo":49871000119105,
    "descripcion":"LESIÓN DE CANTO PALPEBRAL"
  },
  {
    "codigo":89243009,
    "descripcion":"POLIMELIA"
  },
  {
    "codigo":710000001,
    "descripcion":"SECUESTRO MANDIBULAR LINGUAL ESPONTÁNEO"
  },
  {
    "codigo":185712006,
    "descripcion":"EXAMINA SUS PROPIAS MAMAS"
  },
  {
    "codigo":216645001,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ALCOHOL ISOPROPÍLICO"
  },
  {
    "codigo":16024271000119107,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DEBIDO A OCLUSIÓN DE ARTERIA CEREBELOSA DERECHA"
  },
  {
    "codigo":251248009,
    "descripcion":"ONDA P BÍFIDA"
  },
  {
    "codigo":708165001,
    "descripcion":"GASTRITIS CAUSADA POR HELICOBACTER HEILMANNII"
  },
  {
    "codigo":249413006,
    "descripcion":"LÍNEA GRIS EN ENCÍA"
  },
  {
    "codigo":446021007,
    "descripcion":"CONJUNTIVITIS PRIMAVERAL DEL LIMBO"
  },
  {
    "codigo":413253008,
    "descripcion":"ESCLEROSIS MUCOSA POSTRATAMIENTO"
  },
  {
    "codigo":282181006,
    "descripcion":"SUBE ESCALONES"
  },
  {
    "codigo":247578003,
    "descripcion":"BAJO GRADO DE INTELIGENCIA"
  },
  {
    "codigo":38579007,
    "descripcion":"DESPRENDIMIENTO RETINIANO PARCIAL RECIENTE, CON DIÁLISIS RETINIANA"
  },
  {
    "codigo":50970007,
    "descripcion":"GONORREA AGUDA DEL APARATO GENITOURINARIO SUPERIOR"
  },
  {
    "codigo":737263004,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DE REGIÓN VERTEBRAL"
  },
  {
    "codigo":442351006,
    "descripcion":"TRASTORNO MENTAL CAUSADO POR DROGA"
  },
  {
    "codigo":81903006,
    "descripcion":"ORGASMO MASCULINO INHIBIDO"
  },
  {
    "codigo":1359855009,
    "descripcion":"CARCINOMA IN SITU DE BERMELLÓN DE LABIO SUPERIOR"
  },
  {
    "codigo":1259716003,
    "descripcion":"MESOTELIOMA PRIMARIO MALIGNO"
  },
  {
    "codigo":276676005,
    "descripcion":"INFECCIONES PERINATALES DE PIEL Y TEJIDO CELULAR SUBCUTÁNEO DE FETO Y\/O RECIÉN NACIDO"
  },
  {
    "codigo":10754921000119106,
    "descripcion":"HIPERTIROIDISMO EN EL MOMENTO DEL NACIMIENTO"
  },
  {
    "codigo":14532008,
    "descripcion":"ANOMALÍA CONGÉNITA DE LA TRÁQUEA"
  },
  {
    "codigo":80068009,
    "descripcion":"TUMEFACCIÓN DE MIEMBRO"
  },
  {
    "codigo":1088361000119107,
    "descripcion":"PERFORACIÓN CENTRAL DE LA MEMBRANA TIMPÁNICA IZQUIERDA"
  },
  {
    "codigo":307609003,
    "descripcion":"ADAMANTINOMA DE HUESO LARGO"
  },
  {
    "codigo":111001004,
    "descripcion":"GAMMAPATÍA"
  },
  {
    "codigo":404078000,
    "descripcion":"CONDROMA DE PARTES BLANDAS"
  },
  {
    "codigo":305774002,
    "descripcion":"VISTO POR TERAPEUTA OCUPACIONAL COMUNITARIO"
  },
  {
    "codigo":771000221107,
    "descripcion":"POLIOMIELITIS EN MENORES DE 15 AÑOS"
  },
  {
    "codigo":698990003,
    "descripcion":"LINFEDEMA DEBIDO A TRAUMATISMO"
  },
  {
    "codigo":1256046005,
    "descripcion":"CAMPTODACTILIA ESPORÁDICA"
  },
  {
    "codigo":371310004,
    "descripcion":"TRASTORNO CUTÁNEO ESTREPTOCÓCICO"
  },
  {
    "codigo":240238007,
    "descripcion":"DEFORMIDAD DE ADUCCIÓN DE DEDO DE LA MANO"
  },
  {
    "codigo":291123007,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR SULPIRIDA"
  },
  {
    "codigo":76398007,
    "descripcion":"DESDOBLAMIENTO MARCADO DEL SEGUNDO RUIDO CARDÍACO, R>2<"
  },
  {
    "codigo":43630006,
    "descripcion":"SIGNOS ELECTROCARDIOGRÁFICOS DE INFARTO ANTEROLATERAL"
  },
  {
    "codigo":9027003,
    "descripcion":"PRESIÓN DE ENCLAVAMIENTO NORMAL"
  },
  {
    "codigo":369475000,
    "descripcion":"TUMOR MALIGNO QUE COMPROMETE VEJIGA URINARIA POR PROPAGACIÓN DIRECTA DE VAGINA"
  },
  {
    "codigo":402243008,
    "descripcion":"LIQUEN SIMPLE DE VULVA"
  },
  {
    "codigo":39960009,
    "descripcion":"MUECAS"
  },
  {
    "codigo":105496009,
    "descripcion":"DESPIDO"
  },
  {
    "codigo":365805001,
    "descripcion":"NIVEL DE GLOBULINA - HALLAZGO"
  },
  {
    "codigo":300269008,
    "descripcion":"SALIVACIÓN NORMAL"
  },
  {
    "codigo":200130005,
    "descripcion":"PARTO CON FÓRCEPS - NACIDO"
  },
  {
    "codigo":298434005,
    "descripcion":"AMPLITUD DE FLEXIÓN LATERAL PASIVA HACIA LA DERECHA DE LA COLUMNA VERTEBRAL CERVICAL, NORMAL"
  },
  {
    "codigo":1148567001,
    "descripcion":"INTOXICACIÓN CAUSADA POR SEDANTE"
  },
  {
    "codigo":165527002,
    "descripcion":"RECUENTO DE BASÓFILOS DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":134301000119104,
    "descripcion":"HALLAZGO MAMOGRÁFICO INCONCLUYENTE"
  },
  {
    "codigo":296599006,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE GENTAMICINA"
  },
  {
    "codigo":460439008,
    "descripcion":"PERICARDITIS CAUSADA POR HAEMOPHILUS"
  },
  {
    "codigo":196460002,
    "descripcion":"OSTEÍTIS MANDIBULAR AGUDA"
  },
  {
    "codigo":720748007,
    "descripcion":"ATRESIA DE PABELLÓN AURICULAR CON MÚLTIPLES ANOMALÍAS CONGÉNITAS Y DISCAPACIDAD INTELECTUAL"
  },
  {
    "codigo":32620007,
    "descripcion":"PULPITIS"
  },
  {
    "codigo":294764007,
    "descripcion":"ALERGIA A DANAZOL"
  },
  {
    "codigo":107831000119101,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS METASTÁSICO DE HÍGADO"
  },
  {
    "codigo":292929005,
    "descripcion":"REACCIÓN ADVERSA A LA TOBRAMICINA"
  },
  {
    "codigo":161857006,
    "descripcion":"SÍNTOMA DE SUDORACIÓN"
  },
  {
    "codigo":1144897006,
    "descripcion":"NEFRITIS TUBULOINTERSTICIAL CRÓNICA DEBIDA A ENFERMEDAD METABÓLICA"
  },
  {
    "codigo":127254000,
    "descripcion":"NEOPLASIA DE LOS GANGLIOS LINFÁTICOS DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":63553008,
    "descripcion":"ENDOCARDITIS POR CANDIDA"
  },
  {
    "codigo":225558004,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN EN ESPALDA"
  },
  {
    "codigo":422166005,
    "descripcion":"TRASTORNO CIRCULATORIO PERIFÉRICO DEBIDO A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":94486006,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE FALANGE DEL PIE"
  },
  {
    "codigo":291094006,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR TEMAZEPAM"
  },
  {
    "codigo":59883002,
    "descripcion":"CELULITIS DE LA PARED ABDOMINAL"
  },
  {
    "codigo":92651002,
    "descripcion":"CARCINOMA IN SITU DE GLÁNDULA SALIVAL MAYOR"
  },
  {
    "codigo":289259007,
    "descripcion":"PARTO POR VÍA VAGINAL"
  },
  {
    "codigo":125419008,
    "descripcion":"AGREGADO DE LÍPIDOS CITOPLÁSMICOS"
  },
  {
    "codigo":353591000119105,
    "descripcion":"CARCINOMA IN SITU DE MAMA IZQUIERDA"
  },
  {
    "codigo":254656002,
    "descripcion":"CARCINOMA EPIDERMOIDE IN SITU DE PIEL"
  },
  {
    "codigo":189120005,
    "descripcion":"NEOPLASIA BENIGNA DE TROMPAS DE FALOPIO Y LIGAMENTOS UTERINOS"
  },
  {
    "codigo":123584008,
    "descripcion":"URTICARIA PERSISTENTE"
  },
  {
    "codigo":449429001,
    "descripcion":"AURÍCULA IZQUIERDA DIVIDIDA CON DESEMBOCADURA DE ALGUNAS VENAS PULMONARES EN LA CÁMARA PROXIMAL Y DRENAJE EN LA AURÍCULA DERECHA"
  },
  {
    "codigo":416661002,
    "descripcion":"CONSUMO DE DROGAS COMPULSIVO"
  },
  {
    "codigo":179005,
    "descripcion":"APRAXIA DEL VESTIR"
  },
  {
    "codigo":88981003,
    "descripcion":"PIOMETRA"
  },
  {
    "codigo":1137557006,
    "descripcion":"EVENTRACIÓN EN PARED ABDOMINAL ANTERIOR EN LUGAR DE PUNCIÓN DE TROCAR POSTERIOR A PROCEDIMIENTO LAPAROSCÓPICO"
  },
  {
    "codigo":25911000119108,
    "descripcion":"LEIOMIOMA DE ÚTERO INTRACAVITARIO"
  },
  {
    "codigo":283754006,
    "descripcion":"MORDEDURA DE PERRO EN LA MANO"
  },
  {
    "codigo":314687000,
    "descripcion":"TALLA DEL NIÑO: < PERCENTILO 0,4"
  },
  {
    "codigo":249151001,
    "descripcion":"INVERSIÓN DE LA ONDA DE CONTRACCIÓN UTERINA"
  },
  {
    "codigo":281919002,
    "descripcion":"FRACTURA DE DOS COLUMNAS DE VÉRTEBRA CERVICAL"
  },
  {
    "codigo":609599003,
    "descripcion":"NEUROPATÍA DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":1363263007,
    "descripcion":"METABOLIZADOR INTERMEDIO DE FAMILIA 2 SUBFAMILIA C MIEMBRO 9 *1\/*6 DE CITOCROMO P450"
  },
  {
    "codigo":17940001,
    "descripcion":"TRASTORNO MIONEURAL TÓXICO"
  },
  {
    "codigo":1230356004,
    "descripcion":"ANOMALÍA CONGÉNITA DE EXTREMIDAD SUPERIOR DERECHA"
  },
  {
    "codigo":1197588008,
    "descripcion":"SÍNDROME DE MICROCEFALIA, RETRASO DEL CRECIMIENTO, PROGNATISMO Y CRIPTORQUIDIA LIGADO AL CROMOSOMA X"
  },
  {
    "codigo":212713004,
    "descripcion":"INTOXICACIÓN POR ADENOCROMO"
  },
  {
    "codigo":442089008,
    "descripcion":"ESTRUCTURA ANORMAL DE GLOBULINA"
  },
  {
    "codigo":210878000,
    "descripcion":"CONTUSIÓN, ARTERIA POPLÍTEA"
  },
  {
    "codigo":473022002,
    "descripcion":"INTENCIONALMENTE SOLTERO Y CON ABSTINENCIA SEXUAL"
  },
  {
    "codigo":1259454004,
    "descripcion":"CARCINOMA ADENOESCAMOSO PRIMARIO"
  },
  {
    "codigo":702398007,
    "descripcion":"SÍNDROME DE HIPERFERRITINEMIA Y CATARATAS"
  },
  {
    "codigo":79806007,
    "descripcion":"ÚLCERA GÁSTRICA Y DUODENAL COMBINADA"
  },
  {
    "codigo":276414009,
    "descripcion":"CAPAZ DE OPONER PULGARES"
  },
  {
    "codigo":300651000119104,
    "descripcion":"TRASTORNO DE TENDÓN DE ANTEBRAZO DERECHO"
  },
  {
    "codigo":40081000087100,
    "descripcion":"FRACTURA DE MALÉOLO MEDIAL DERECHO"
  },
  {
    "codigo":405651005,
    "descripcion":"PROBLEMA CON EL EQUIPAMIENTO"
  },
  {
    "codigo":42641000087101,
    "descripcion":"HERIDA PUNZANTE DE EXTREMIDAD SUPERIOR DERECHA CON CUERPO EXTRAÑO"
  },
  {
    "codigo":12435008,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE ANO CON INFECCIÓN"
  },
  {
    "codigo":895336001,
    "descripcion":"CURVATURA ANORMAL DE FALANGE DE DEDO MEÑIQUE"
  },
  {
    "codigo":403816002,
    "descripcion":"MÚLTIPLES MÁCULAS CAFÉ CON LECHE POR NEUROFIBROMATOSIS"
  },
  {
    "codigo":239976003,
    "descripcion":"TENOSINOVITIS DEL EXTENSOR RADIAL DEL CARPO"
  },
  {
    "codigo":371048003,
    "descripcion":"ONIQUIA TRAUMÁTICA"
  },
  {
    "codigo":1255784000,
    "descripcion":"PARAGRANULOMA DE HODGKIN DE GANGLIOS LINFÁTICOS DE CABEZA"
  },
  {
    "codigo":733331009,
    "descripcion":"EXCESO DE DIVERGENCIA"
  },
  {
    "codigo":47761000087109,
    "descripcion":"FRACTURA DE TERCERA COSTILLA IZQUIERDA"
  },
  {
    "codigo":77971008,
    "descripcion":"IRIDOCICLITIS"
  },
  {
    "codigo":305512008,
    "descripcion":"BAJO ATENCIÓN DE NEUROPATÓLOGO"
  },
  {
    "codigo":238141005,
    "descripcion":"SOBRECARGA DE SAL"
  },
  {
    "codigo":270909006,
    "descripcion":"PERFORACIÓN DUODENAL"
  },
  {
    "codigo":205373007,
    "descripcion":"CRECIMIENTO EXCESIVO CONGÉNITO DE EXTREMIDAD INFERIOR EN SU TOTALIDAD"
  },
  {
    "codigo":400146000,
    "descripcion":"HAMARTOMA ESPLÉNICO"
  },
  {
    "codigo":72466000,
    "descripcion":"LESIÓN TRAUMÁTICA DE LAS ARTERIAS SUPRARRENALES"
  },
  {
    "codigo":8765009,
    "descripcion":"HEMATEMESIS"
  },
  {
    "codigo":170770003,
    "descripcion":"PACIENTE DIABÉTICO - NO COOPERATIVO"
  },
  {
    "codigo":683781000119103,
    "descripcion":"EPENDIMOMA MALIGNO PRIMARIO DE LÓBULO OCCIPITAL"
  },
  {
    "codigo":39698007,
    "descripcion":"EVALUACIÓN DE DISCAPACIDAD: 12%"
  },
  {
    "codigo":269074007,
    "descripcion":"FRACTURA EXPUESTA DE CUARTA VÉRTEBRA CERVICAL"
  },
  {
    "codigo":234471001,
    "descripcion":"DEFECTO DE GLUCOPROTEÍNA IA"
  },
  {
    "codigo":398311004,
    "descripcion":"DIVERTICULOSIS COLÓNICA SIN DIVERTICULITIS"
  },
  {
    "codigo":365543007,
    "descripcion":"PROYECTOS DE PROMOCIÓN - HALLAZGO"
  },
  {
    "codigo":5095008,
    "descripcion":"TRASTORNO DE LA IDENTIDAD SEXUAL EN LA NIÑEZ"
  },
  {
    "codigo":168935008,
    "descripcion":"ANGIOCARDIOGRAFÍA ANORMAL"
  },
  {
    "codigo":298172006,
    "descripcion":"INFLAMACIÓN DE ARTICULACIÓN DE PIE"
  },
  {
    "codigo":16058271000119100,
    "descripcion":"PLEXOPATÍA BRAQUIAL DE MIEMBRO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":1069811000000104,
    "descripcion":"DIFICULTAD PARA EVALUAR RIESGOS"
  },
  {
    "codigo":230801000,
    "descripcion":"COMA POSICTAL"
  },
  {
    "codigo":722321001,
    "descripcion":"GLAUCOMA DE OJO IZQUIERDO INDUCIDO POR CORTICOSTEROIDES"
  },
  {
    "codigo":165265005,
    "descripcion":"CAMINA 30-59 METROS EN 1 MINUTO"
  },
  {
    "codigo":198033005,
    "descripcion":"BALANITIS XERÓTICA OBLITERANTE"
  },
  {
    "codigo":296337005,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE ATENOLOL"
  },
  {
    "codigo":32358001,
    "descripcion":"TRASTORNO DELUSORIO POR ANFETAMINAS"
  },
  {
    "codigo":294502006,
    "descripcion":"ALERGIA A FLUCLOXACILINA"
  },
  {
    "codigo":292667006,
    "descripcion":"REACCIÓN ADVERSA A LA ACITRETINA"
  },
  {
    "codigo":290832001,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR DOXEPINA"
  },
  {
    "codigo":126992002,
    "descripcion":"NEOPLASIA DE LOS NERVIOS PERIFÉRICOS DEL ABDOMEN"
  },
  {
    "codigo":61456005,
    "descripcion":"HERNIA OBTURATRIZ CON OBSTRUCCIÓN"
  },
  {
    "codigo":716816005,
    "descripcion":"MYCOBACTERIUM ANGELICUM O MYCOBACTERIUM SZULGAI"
  },
  {
    "codigo":59621000,
    "descripcion":"HIPERTENSIÓN ARTERIAL ESENCIAL"
  },
  {
    "codigo":94224009,
    "descripcion":"NEOPLASIA MALIGNA SECUNDARIA DEL TRONCO ENCEFÁLICO"
  },
  {
    "codigo":125157000,
    "descripcion":"SATISFACTORIO PARA EVALUACIÓN, PERO LIMITADO POR AUSENCIA DE UN COMPONENTE ENDOCERVICAL O DE ZONA DE TRANSFORMACIÓN EN UNA PACIENTE CON CUELLO UTERINO"
  },
  {
    "codigo":92389004,
    "descripcion":"NEOPLASIA BENIGNA DE PARTES BLANDAS DE GLÚTEO"
  },
  {
    "codigo":288997006,
    "descripcion":"NO BEBE DE UNA BOTELLA"
  },
  {
    "codigo":385466000,
    "descripcion":"CONCENTRACIÓN INHIBITORIA MÍNIMA - HALLAZGO"
  },
  {
    "codigo":1335738000,
    "descripcion":"NECROSIS AVASCULAR DE RADIO"
  },
  {
    "codigo":1237434004,
    "descripcion":"DERMATITIS IRRITATIVA POR CONTACTO CAUSADA POR ACEITE AUTOMOTRIZ"
  },
  {
    "codigo":254394005,
    "descripcion":"CARCINOMA IN SITU DEL FRENILLO LABIAL"
  },
  {
    "codigo":1268367007,
    "descripcion":"RUPTURA TRAUMÁTICA DE FASCIA PLANTAR"
  },
  {
    "codigo":54116000,
    "descripcion":"DERMATITIS POLIMORFA POR LUZ SOLAR, TIPO PAPULOSA"
  },
  {
    "codigo":15704121000119105,
    "descripcion":"CONTRACTURA MUSCULAR BILATERAL DE TOBILLO"
  },
  {
    "codigo":414564002,
    "descripcion":"CIFOSIS DE COLUMNA VERTEBRAL"
  },
  {
    "codigo":285327008,
    "descripcion":"INSECTO EN EL MEATO AUDITIVO EXTERNO"
  },
  {
    "codigo":447332005,
    "descripcion":"ABSCESO TUBERCULOSO DE ESPACIO EPIDURAL"
  },
  {
    "codigo":686291000119100,
    "descripcion":"HISTIOCITOMA FIBROSO MALIGNO PRIMARIO DE PARTES BLANDAS DE GLÚTEO"
  },
  {
    "codigo":283492006,
    "descripcion":"HERIDA PUNZANTE EN EL DORSO DEL PIE"
  },
  {
    "codigo":185188008,
    "descripcion":"ATENDIDO EN CONSULTORIO ESPECIALIZADO EN PLANIFICACIÓN FAMILIAR"
  },
  {
    "codigo":445497004,
    "descripcion":"LACERACIÓN DE NERVIO DIGITAL EN DEDO DE PIE"
  },
  {
    "codigo":871481004,
    "descripcion":"PRESENTACIÓN DE FETO ALTA"
  },
  {
    "codigo":412729005,
    "descripcion":"AMAMANTADO AL NACER"
  },
  {
    "codigo":50446000,
    "descripcion":"DIPLOPÍA MONOCULAR"
  },
  {
    "codigo":312590001,
    "descripcion":"CUERPO EXTRAÑO LABIAL"
  },
  {
    "codigo":247054001,
    "descripcion":"OPACIDADES ANTERIORES DE CRISTALINO"
  },
  {
    "codigo":85049009,
    "descripcion":"TRITANOPÍA"
  },
  {
    "codigo":771342004,
    "descripcion":"SÍNDROME DE MICROCÓRNEA, DISTROFIA DE CONOS Y BASTONES, CATARATAS Y ESTAFILOMA POSTERIOR"
  },
  {
    "codigo":52281009,
    "descripcion":"MENINGOENCEFALITIS CAUSADA POR NAEGLERIA"
  },
  {
    "codigo":1197326008,
    "descripcion":"CARCINOMA METASTÁSICO DE GANGLIO LINFÁTICO DE CABEZA Y CUELLO"
  },
  {
    "codigo":212451003,
    "descripcion":"LESIÓN DE MÚSCULO Y TENDÓN DE LA CABEZA"
  },
  {
    "codigo":15843004,
    "descripcion":"AUSENCIA CONGÉNITA DE VÉRTEBRA"
  },
  {
    "codigo":1162723004,
    "descripcion":"ALANINA AMINOTRANSFERASA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":48611009,
    "descripcion":"ENFERMEDAD DE DARIER"
  },
  {
    "codigo":308920003,
    "descripcion":"HALLAZGOS DE SÍNTOMAS EN RELACIÓN CON LA FRECUENCIA"
  },
  {
    "codigo":6121000124102,
    "descripcion":"MEDICAMENTO TOMADO A UNA DOSIS INFERIOR A LA RECOMENDADA"
  },
  {
    "codigo":210616007,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE PULGAR A TRAVÉS DE ARTICULACIÓN INTERFALÁNGICA"
  },
  {
    "codigo":734904007,
    "descripcion":"EXACERBACIÓN AGUDA DE ASMA POTENCIALMENTE FATAL"
  },
  {
    "codigo":472760008,
    "descripcion":"HIPERTENSIÓN VENOSA PULMONAR DEBIDA A COMPRESIÓN DE GRAN VENA PULMONAR POR LINFADENOPATÍA"
  },
  {
    "codigo":110477003,
    "descripcion":"EXPECTATIVAS IRREALES CON RESPECTO A LOS RESULTADOS DE UN TRATAMIENTO"
  },
  {
    "codigo":896909004,
    "descripcion":"FORMA ANCHA ANORMAL CONGÉNITA DE FALANGE DE MANO"
  },
  {
    "codigo":1290125003,
    "descripcion":"NEOPLASIA NEUROENDOCRINA MALIGNA"
  },
  {
    "codigo":700301003,
    "descripcion":"HIPERTRICOSIS DE PÁRPADO SUPERIOR"
  },
  {
    "codigo":307085007,
    "descripcion":"DIFICULTAD PARA PROCESAR INFORMACIÓN"
  },
  {
    "codigo":733069009,
    "descripcion":"SÍNDROME DE SORDERA, VITILIGO Y ACALASIA"
  },
  {
    "codigo":1255522001,
    "descripcion":"RUPTURA TRAUMÁTICA DE TENDÓN ISQUIOTIBIAL"
  },
  {
    "codigo":403554008,
    "descripcion":"SÍNDROME ÓCULO-CEREBRO-CUTÁNEO"
  },
  {
    "codigo":698466009,
    "descripcion":"CON MAYOR RIESGO DE ENFERMEDAD DE INJERTO CONTRA HUÉSPED ASOCIADA CON TRANSFUSIÓN"
  },
  {
    "codigo":237879001,
    "descripcion":"TRASTORNO DEL METABOLISMO DEL FÓSFORO, DEL CALCIO Y DE LA VITAMINA D"
  },
  {
    "codigo":205111008,
    "descripcion":"CUÁDRICEPS CONGÉNITO CORTO"
  },
  {
    "codigo":399884001,
    "descripcion":"NEOPLASIA VASCULAR MALIGNA PRIMARIA DE BRAZO"
  },
  {
    "codigo":72204002,
    "descripcion":"LARINGOTRAQUEOBRONQUITIS POR VIRUS SINCICIAL RESPIRATORIO"
  },
  {
    "codigo":301580004,
    "descripcion":"DIFICULTAD PARA MOVILIZARSE CON SILLA DE RUEDAS"
  },
  {
    "codigo":1055244008,
    "descripcion":"REFLEJO TÓNICO DE CUELLO ASIMÉTRICO PERSISTENTE"
  },
  {
    "codigo":234209001,
    "descripcion":"TRASTORNO CAUSADO POR ELECTRODO DE MARCAPASOS"
  },
  {
    "codigo":236044009,
    "descripcion":"HERNIA LUMBAR SUPERIOR"
  },
  {
    "codigo":1217249003,
    "descripcion":"LINFEDEMA PRIMARIO CON COMPROMISO SISTÉMICO"
  },
  {
    "codigo":299745004,
    "descripcion":"REFLEJO PALMAR AUSENTE"
  },
  {
    "codigo":398049005,
    "descripcion":"ENFERMEDAD VASCULAR MIXTA DEL COLÁGENO"
  },
  {
    "codigo":365281003,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA VACIAR LA BAÑERA"
  },
  {
    "codigo":266977003,
    "descripcion":"FAMILIA MONOPARENTAL, MADRE PRESENTE"
  },
  {
    "codigo":10627591000119102,
    "descripcion":"FORÚNCULO DE MANO IZQUIERDA"
  },
  {
    "codigo":789430001,
    "descripcion":"SÍNDROME DE HORNER DEL LADO DERECHO ADQUIRIDO"
  },
  {
    "codigo":428982002,
    "descripcion":"DEPENDENCIA DE HEMODIÁLISIS POR INSUFICIENCIA RENAL EN ESTADIO TERMINAL"
  },
  {
    "codigo":363446004,
    "descripcion":"NEOPLASIA MALIGNA DE LABIOS MAYORES VULVARES"
  },
  {
    "codigo":230539002,
    "descripcion":"COMBINACIÓN DE CEFALEA EN SALVAS Y NEURALGIA DEL TRIGÉMINO"
  },
  {
    "codigo":722059002,
    "descripcion":"ALBINISMO OCULOCUTÁNEO TIPO 7"
  },
  {
    "codigo":296075002,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE TRIAZOLAM"
  },
  {
    "codigo":33931005,
    "descripcion":"LESIÓN TRAUMÁTICA DE LABIO"
  },
  {
    "codigo":16034311000119105,
    "descripcion":"HIPERTROFIA DE HUESO DE FÉMUR DERECHO"
  },
  {
    "codigo":392544003,
    "descripcion":"CRECIMIENTO ENDOFÍTICO"
  },
  {
    "codigo":294240005,
    "descripcion":"ALERGIA A AURANOFINA"
  },
  {
    "codigo":33441000119100,
    "descripcion":"LIPOMA TRANSICIONAL DE MÉDULA ESPINAL"
  },
  {
    "codigo":32096006,
    "descripcion":"DISMENORREA SECUNDARIA"
  },
  {
    "codigo":95797003,
    "descripcion":"ESCLERITIS NECROSANTE"
  },
  {
    "codigo":15680161000119101,
    "descripcion":"CONJUNTIVITIS DE OJO IZQUIERDO CAUSADA POR CHLAMYDIA TRACHOMATIS"
  },
  {
    "codigo":292405005,
    "descripcion":"REACCIÓN ADVERSA AL FLUPENTIXOL"
  },
  {
    "codigo":1144373007,
    "descripcion":"PALADAR ESTRECHO"
  },
  {
    "codigo":30261008,
    "descripcion":"PRESIÓN DE ENCLAVAMIENTO PULMONAR AUMENTADA"
  },
  {
    "codigo":1306378000,
    "descripcion":"NEOPLASIA DE PROLONGACIÓN AXILAR DE MAMA"
  },
  {
    "codigo":16908961000119102,
    "descripcion":"DERMATOFIBROMA DE PIEL DE PÁRPADO INFERIOR DERECHO"
  },
  {
    "codigo":421642003,
    "descripcion":"BAJO ANESTESIA"
  },
  {
    "codigo":194101008,
    "descripcion":"ESOTROPÍA INTERMITENTE MONOCULAR"
  },
  {
    "codigo":93962006,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA GLÁNDULA PINEAL"
  },
  {
    "codigo":225034008,
    "descripcion":"RECUERDOS DESAGRADABLES"
  },
  {
    "codigo":59359002,
    "descripcion":"INFECCIÓN CAUSADA POR OXYSPIRURA"
  },
  {
    "codigo":254132000,
    "descripcion":"HIPEROSTOSIS DEL ENDOSTIO CON HIPOPLASIA CEREBELOSA"
  },
  {
    "codigo":288735009,
    "descripcion":"NO RESPONDE A LA COMUNICACIÓN ESTABLECIDA POR OTROS"
  },
  {
    "codigo":712884004,
    "descripcion":"EVITACIÓN PATOLÓGICA DE LA DEMANDA"
  },
  {
    "codigo":448905005,
    "descripcion":"DILATACIÓN DE SENO DE VALSALVA AÓRTICO"
  },
  {
    "codigo":416137008,
    "descripcion":"DISFUNCIÓN SOMÁTICA DE HUESO COXAL"
  },
  {
    "codigo":283230002,
    "descripcion":"VIDRIO EN CABEZA Y CUELLO"
  },
  {
    "codigo":688801000119109,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE CÚPULA DE VEJIGA URINARIA"
  },
  {
    "codigo":53854005,
    "descripcion":"CICATRIZ CORIORRETINIANA"
  },
  {
    "codigo":21086008,
    "descripcion":"SÍNDROME DE COCKAYNE"
  },
  {
    "codigo":709214009,
    "descripcion":"NEOPLASIA DE CÉLULAS GIGANTES DE HUESO LARGO DE MIEMBRO INFERIOR"
  },
  {
    "codigo":707379000,
    "descripcion":"CARCINOMA MUCOEPIDERMOIDE PRIMARIO DE TRÁQUEA"
  },
  {
    "codigo":1071931000119104,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE TENDÓN EXTENSOR DE MUSLO"
  },
  {
    "codigo":1231667004,
    "descripcion":"RETINITIS POSTRAUMÁTICA"
  },
  {
    "codigo":838451005,
    "descripcion":"INSUFICIENCIA DE VÁLVULA MITRAL LEVE"
  },
  {
    "codigo":445235006,
    "descripcion":"OBSTRUCCIÓN DEL TRACTO DE SALIDA DEL VENTRÍCULO IZQUIERDO POR BANDA MUSCULAR ANTEROLATERAL"
  },
  {
    "codigo":1074731000119103,
    "descripcion":"ARTRITIS DE MUÑECA DERECHA"
  },
  {
    "codigo":1264435003,
    "descripcion":"NECROSIS HEPÁTICA AGUDA POSTERIOR A EMBARAZO ECTÓPICO"
  },
  {
    "codigo":291371000119100,
    "descripcion":"HEMORRAGIA ESPONTÁNEA DE ARTERIA INTRACRANEAL EN ESPACIO SUBARACNOIDEO"
  },
  {
    "codigo":688171000119106,
    "descripcion":"NEURILEMOMA DE NERVIO DEL CUELLO"
  },
  {
    "codigo":293931000119101,
    "descripcion":"SÍNDROME DE DOLOR REGIONAL COMPLEJO TIPO I DE MIEMBRO INFERIOR IZQUIERDO"
  },
  {
    "codigo":347691000119102,
    "descripcion":"ABSCESO DE PÁRPADO IZQUIERDO"
  },
  {
    "codigo":443400005,
    "descripcion":"LINFANGIOMAS CUTÁNEOS MÚLTIPLES"
  },
  {
    "codigo":32811000119109,
    "descripcion":"INFECCIÓN CAUSADA POR BACTERIAS RESISTENTES A MÚLTIPLES FÁRMACOS ANTIBACTERIANOS"
  },
  {
    "codigo":130091000119103,
    "descripcion":"FIEBRE POSPROCEDIMIENTO"
  },
  {
    "codigo":306731000119104,
    "descripcion":"GOTA DE MÚLTIPLES LOCALIZACIONES CAUSADA POR FÁRMACO"
  },
  {
    "codigo":368171000119104,
    "descripcion":"DERMATITIS DEBIDA A DIABETES MELLITUS INDUCIDA POR FÁRMACOS"
  },
  {
    "codigo":314411000119109,
    "descripcion":"SÍNDROME COMPARTIMENTAL NO TRAUMÁTICO DE EXTREMIDAD INFERIOR DERECHA"
  },
  {
    "codigo":11995691000119109,
    "descripcion":"EDEMA EN MUÑÓN DE AMPUTACIÓN DE EXTREMIDAD INFERIOR IZQUIERDA"
  },
  {
    "codigo":11839531000119108,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO INTRÍNSECO DE MANO IZQUIERDA"
  },
  {
    "codigo":408797004,
    "descripcion":"POSICIÓN EN CUCLILLAS"
  },
  {
    "codigo":321000161101,
    "descripcion":"HERIDA ABIERTA DE PIEL"
  },
  {
    "codigo":310493005,
    "descripcion":"PESO AL NACER ENTRE 1 Y 1,5 KILOS"
  },
  {
    "codigo":441565006,
    "descripcion":"DESGASTE DE SUPERFICIE ARTICULAR DE PRÓTESIS ARTICULAR"
  },
  {
    "codigo":308658001,
    "descripcion":"PATRÓN ALIMENTARIO ANORMAL"
  },
  {
    "codigo":769245002,
    "descripcion":"TRASTORNO DE LA MÁCULA IZQUIERDA DEBIDO A DIABETES MELLITUS"
  },
  {
    "codigo":13746004,
    "descripcion":"TRASTORNO BIPOLAR"
  },
  {
    "codigo":863879002,
    "descripcion":"CON BAJO RIESGO DE ÚLCERA DE PIE DERECHO DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":110215002,
    "descripcion":"QUEMADURA DE PRIMER GRADO DEL PISO DE LA BOCA"
  },
  {
    "codigo":44679005,
    "descripcion":"SECRECIÓN GÁSTRICA DE BICARBONATO AUMENTADA"
  },
  {
    "codigo":763740000,
    "descripcion":"INTOXICACIÓN INFANTIL CAUSADA POR MERCURIO"
  },
  {
    "codigo":10076004,
    "descripcion":"ATROFIA MUSCULAR ISQUÉMICA"
  },
  {
    "codigo":42844005,
    "descripcion":"MORFOLOGÍA DE UNA COLONIA BACTERIANA, BORDE FILAMENTOSO"
  },
  {
    "codigo":403292008,
    "descripcion":"LESIÓN UNGUEAL POR CAUSA EXTERNA"
  },
  {
    "codigo":1351729002,
    "descripcion":"BAJA CALIDAD DE VIDA EN RELACIÓN AL ASPECTO ALIMENTARIO Y\/O NUTRICIONAL"
  },
  {
    "codigo":204849002,
    "descripcion":"FÍSTULA UTEROVESICAL CONGÉNITA"
  },
  {
    "codigo":41009006,
    "descripcion":"TEMBLOR CEREBELOSO PROGRESIVO"
  },
  {
    "codigo":237617006,
    "descripcion":"ANEMIA MEGALOBLÁSTICA SENSIBLE A TIAMINA, CON DIABETES MELLITUS Y SORDERA NEUROSENSORIAL"
  },
  {
    "codigo":203014000,
    "descripcion":"MIOSITIS INFECCIOSA DE MANO"
  },
  {
    "codigo":1220657009,
    "descripcion":"DAÑO DE ÓRGANOS Y\/O TEJIDOS DE PELVIS DEBIDO A INTERRUPCIÓN COMPLETA INDUCIDA DE EMBARAZO Y DEBIDO A ELLA"
  },
  {
    "codigo":792838002,
    "descripcion":"PULSO EN ARTERIA TIBIAL ANTERIOR IZQUIERDA AUSENTE"
  },
  {
    "codigo":301318003,
    "descripcion":"CABEZA DE FORMA ANORMAL"
  },
  {
    "codigo":235782002,
    "descripcion":"FÍSTULA DE URÉTER HACIA EL INTESTINO DELGADO"
  },
  {
    "codigo":1251590006,
    "descripcion":"RUPTURA TRAUMÁTICA DE PLACA PALMAR DE ARTICULACIÓN DE DEDO ANULAR"
  },
  {
    "codigo":14641000202103,
    "descripcion":"COMUNICACIÓN FAMILIAR EFECTIVA"
  },
  {
    "codigo":17201000202105,
    "descripcion":"CAPAZ DE APRENDER"
  },
  {
    "codigo":365019002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA IMITAR VOCALIZACIÓN"
  },
  {
    "codigo":102875003,
    "descripcion":"EMBARAZO SUBROGANTE"
  },
  {
    "codigo":299483004,
    "descripcion":"TUMEFACCIÓN SINOVIAL DE ARTICULACIONES DEL PIE"
  },
  {
    "codigo":233947005,
    "descripcion":"HIPERTENSIÓN PULMONAR TROMBOEMBÓLICA"
  },
  {
    "codigo":168411006,
    "descripcion":"EXTENDIDO CERVICAL - CÉLULAS ENDOCERVICALES PRESENTES"
  },
  {
    "codigo":11832431000119104,
    "descripcion":"LACERACIÓN DE VASO SANGUÍNEO DE DEDO MEDIO DE MANO IZQUIERDA"
  },
  {
    "codigo":428720002,
    "descripcion":"NEFROPATÍA CAUSADA POR HEROÍNA"
  },
  {
    "codigo":2736005,
    "descripcion":"ATROFODERMIA VERMICULAR"
  },
  {
    "codigo":68272006,
    "descripcion":"SINUSITIS MAXILAR AGUDA"
  },
  {
    "codigo":232112009,
    "descripcion":"ESTRABISMO FIJO"
  },
  {
    "codigo":33669002,
    "descripcion":"DIABETES MELLITUS PREGESTACIONAL Y\/O TRASTORNO DE LA TOLERANCIA A LA GLUCOSA, CLASE D DE WHITE MODIFICADA"
  },
  {
    "codigo":337161000119101,
    "descripcion":"LAGOFTALMOS MECÁNICO DE PÁRPADO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":426885008,
    "descripcion":"ENFERMEDAD DE HODGKIN, AGOTAMIENTO DE LINFOCITOS DE GANGLIOS LINFÁTICOS DE LA CABEZA"
  },
  {
    "codigo":263045009,
    "descripcion":"SUBLUXACIÓN DEL SACRO"
  },
  {
    "codigo":721797009,
    "descripcion":"INFECCIÓN DISEMINADA CAUSADA POR CHRYSOSPORIUM"
  },
  {
    "codigo":425050003,
    "descripcion":"SUTURA CORNEAL COLOCADA"
  },
  {
    "codigo":228442004,
    "descripcion":"VENDE DROGAS"
  },
  {
    "codigo":293978006,
    "descripcion":"ALERGIA A LEVOBUNOLOL"
  },
  {
    "codigo":31834007,
    "descripcion":"SUBINVOLUCIÓN MAMARIA POSTPARTO"
  },
  {
    "codigo":292143004,
    "descripcion":"REACCIÓN ADVERSA A LA CÁSCARA SAGRADA"
  },
  {
    "codigo":95535005,
    "descripcion":"HEMORRAGIA ILEAL"
  },
  {
    "codigo":253192007,
    "descripcion":"FIBROLIPOMA DE FILAMENTO TERMINAL"
  },
  {
    "codigo":193839007,
    "descripcion":"DISTROFIA CORNEAL DE FUCHS"
  },
  {
    "codigo":290308002,
    "descripcion":"INTOXICACIÓN POR ÁCIDO TIAPROFÉNICO"
  },
  {
    "codigo":192004002,
    "descripcion":"INTERRUPCIONES REITERADAS EN LA FASE DE SUEÑO DE MOVIMIENTOS RÁPIDOS DE LOS OJOS"
  },
  {
    "codigo":386777001,
    "descripcion":"HORMONA ANTIDIURÉTICA ANORMAL"
  },
  {
    "codigo":93700009,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE VASO SANGUÍNEO DE LA CADERA"
  },
  {
    "codigo":26329005,
    "descripcion":"POCA CONCENTRACIÓN"
  },
  {
    "codigo":1204142001,
    "descripcion":"ENROJECIMIENTO DE CARA CAUSADO POR ALIMENTOS PICANTES"
  },
  {
    "codigo":124633009,
    "descripcion":"DEFICIENCIA DE HOMOCISTEÍNA DESULFHIDRASA"
  },
  {
    "codigo":286638005,
    "descripcion":"REGOCIJO"
  },
  {
    "codigo":448643005,
    "descripcion":"ANOMALÍA DE VÁLVULA PULMONAR"
  },
  {
    "codigo":219267007,
    "descripcion":"LESIÓN POR INTERVENCIÓN LEGAL CON BOMBA DE MORTERO"
  },
  {
    "codigo":282968000,
    "descripcion":"NO SE SIENTA"
  },
  {
    "codigo":186499007,
    "descripcion":"ENCEFALITIS LETÁRGICA"
  },
  {
    "codigo":1003864000,
    "descripcion":"DUPLICACIÓN DE PORCIÓN PROXIMAL DEL BRAZO LARGO DEL CROMOSOMA 5"
  },
  {
    "codigo":20824003,
    "descripcion":"COLECISTITIS CRÓNICA"
  },
  {
    "codigo":284803009,
    "descripcion":"CAPAZ DE BAÑARSE"
  },
  {
    "codigo":1264173008,
    "descripcion":"TATUAJE DE PIEL DE MEJILLA IZQUIERDA"
  },
  {
    "codigo":82690000,
    "descripcion":"LARINGITIS SUPURATIVA"
  },
  {
    "codigo":443138004,
    "descripcion":"GRANULOMATOSIS"
  },
  {
    "codigo":17154008,
    "descripcion":"FUNCIÓN CORPORAL GENERAL AUMENTADA"
  },
  {
    "codigo":246530009,
    "descripcion":"CRISIS VERSIVA"
  },
  {
    "codigo":408535006,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: SERBIO"
  },
  {
    "codigo":111788000,
    "descripcion":"INTOXICACIÓN POR JUGLANS NIGRA"
  },
  {
    "codigo":46252003,
    "descripcion":"OFTALMOPLEJÍA EXTERNA PROGRESIVA"
  },
  {
    "codigo":898220004,
    "descripcion":"FUSIÓN ANORMAL CONGÉNITA DE PRIMER HUESO METACARPIANO"
  },
  {
    "codigo":373932008,
    "descripcion":"SIENTE CALOR"
  },
  {
    "codigo":208257000,
    "descripcion":"FRACTURA EXPUESTA DE HÚMERO PROXIMAL, CUATRO PARTES"
  },
  {
    "codigo":699777008,
    "descripcion":"OCLUSIÓN CÉNTRICA - DISCREPANCIA EN LA RELACIÓN CÉNTRICA"
  },
  {
    "codigo":372097009,
    "descripcion":"NEOPLASIA MALIGNA DE ENDOCÉRVIX"
  },
  {
    "codigo":9814003,
    "descripcion":"ARCADAS VIOLENTAS"
  },
  {
    "codigo":239190004,
    "descripcion":"INFECCIÓN EN EL SITIO DONANTE DE PIEL"
  },
  {
    "codigo":403030006,
    "descripcion":"TIÑA CORPORAL CAUSADA POR TRICHOPHYTON MEGNINII"
  },
  {
    "codigo":206422009,
    "descripcion":"SANGRADO VAGINAL PERINATAL TRANSITORIO"
  },
  {
    "codigo":75350009,
    "descripcion":"INTOXICACIÓN POR TRIBULUS TERRESTRIS"
  },
  {
    "codigo":401195006,
    "descripcion":"PRUEBA DE INCORPORACIÓN Y MARCHA - ANORMAL"
  },
  {
    "codigo":237355007,
    "descripcion":"INGURGITACIÓN LÁCTEA DE LA MAMA"
  },
  {
    "codigo":11991000119105,
    "descripcion":"OBSTRUCCIÓN DE LA VÍA URINARIA DEBIDA A SISTEMA COLECTOR DUPLICADO"
  },
  {
    "codigo":202752002,
    "descripcion":"DISCITIS LUMBAR"
  },
  {
    "codigo":169984006,
    "descripcion":"ALIMENTADO ARTIFICIALMENTE A LOS 6 MESES"
  },
  {
    "codigo":364757000,
    "descripcion":"FUERZA DEL MOVIMIENTO FETAL - HALLAZGO"
  },
  {
    "codigo":102613000,
    "descripcion":"DOLOR ABDOMINAL LOCALIZADO"
  },
  {
    "codigo":299221002,
    "descripcion":"PIERNA PEQUEÑA"
  },
  {
    "codigo":67441000119101,
    "descripcion":"INSUFICIENCIA CARDÍACA CONGESTIVA ESTADIO C"
  },
  {
    "codigo":397525000,
    "descripcion":"CAPA DE MUCINA DE LAS LÁGRIMAS"
  },
  {
    "codigo":366592008,
    "descripcion":"AMPLITUD DE MOVIMIENTO PASIVO DE EXTENSIÓN DE LA RODILLA - HALLAZGO"
  },
  {
    "codigo":15986391000119107,
    "descripcion":"DEGENERACIÓN CORIORRETINIANA CONGÉNITA DE OJO DERECHO"
  },
  {
    "codigo":268288009,
    "descripcion":"ALOPECIA CONGÉNITA GENERALIZADA"
  },
  {
    "codigo":15714161000119102,
    "descripcion":"DEFORMIDAD EN VALGO DE DEDO GORDO DERECHO ADQUIRIDA DEBIDA A METATARSO PRIMUS VARO"
  },
  {
    "codigo":788906001,
    "descripcion":"TRASTORNO DE UÑA DEBIDO A DERMATOSIS"
  },
  {
    "codigo":231850002,
    "descripcion":"ENFISEMA DE ÓRBITA"
  },
  {
    "codigo":295551000,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE BUPIVACAÍNA"
  },
  {
    "codigo":197247001,
    "descripcion":"FÍSTULA ENTEROCUTÁNEA"
  },
  {
    "codigo":361087002,
    "descripcion":"DEFICIENCIA DE L-ASPARAGINASA"
  },
  {
    "codigo":230015002,
    "descripcion":"DIRECCIÓN DE LA POSICIÓN DEL TRONCO"
  },
  {
    "codigo":721535002,
    "descripcion":"NEUROCITOMA CENTRAL DE ENCÉFALO"
  },
  {
    "codigo":262783007,
    "descripcion":"LESIÓN DE PLEURA, PULMÓN O BRONQUIO"
  },
  {
    "codigo":129876005,
    "descripcion":"CAMBIO DE ROLES"
  },
  {
    "codigo":12001291000119100,
    "descripcion":"HEMATOMA DEBIDO A ARTROPLASTIA DE RODILLA DERECHA Y POSTERIOR A ELLA"
  },
  {
    "codigo":11863921000119106,
    "descripcion":"AMPUTACIÓN PARCIAL TRAUMÁTICA DE EXTREMIDAD INFERIOR DERECHA A NIVEL ENTRE RODILLA Y TOBILLO"
  },
  {
    "codigo":31572008,
    "descripcion":"SIBILANCIAS INSPIRATORIAS"
  },
  {
    "codigo":293716009,
    "descripcion":"ALERGIA A TRICLOROETILENO"
  },
  {
    "codigo":128041002,
    "descripcion":"TRASTORNO DEL TEJIDO CELULAR SUBCUTÁNEO"
  },
  {
    "codigo":195412008,
    "descripcion":"TROMBOFLEBITIS DE VENA TIBIAL ANTERIOR"
  },
  {
    "codigo":717865007,
    "descripcion":"VÁRICES GÁSTRICAS SIN SANGRADO"
  },
  {
    "codigo":27902000,
    "descripcion":"SECRECIÓN PANCREÁTICA DISMINUIDA"
  },
  {
    "codigo":291881008,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR VASOPRESINA"
  },
  {
    "codigo":193577007,
    "descripcion":"CATARATA ZONULAR LAMINAR"
  },
  {
    "codigo":224510003,
    "descripcion":"APOYO DEL CARTERO LOCAL"
  },
  {
    "codigo":11782001000119109,
    "descripcion":"RUPTURA TRAUMÁTICA DE RODETE COTILOIDEO IZQUIERDO"
  },
  {
    "codigo":93438007,
    "descripcion":"OSIFICACIÓN DE CENTRO DE LA VÉRTEBRA LUMBAR EN FORMA DE PALANCA"
  },
  {
    "codigo":26067004,
    "descripcion":"PIE DE MADURA CAUSADO POR STREPTOMYCES"
  },
  {
    "codigo":91603007,
    "descripcion":"CONTUSIÓN DE LA EXTREMIDAD INFERIOR"
  },
  {
    "codigo":253608001,
    "descripcion":"TEJIDO ACCESORIO SOBRE VALVA DE VÁLVULA AÓRTICA"
  },
  {
    "codigo":188072006,
    "descripcion":"MELANOMA MALIGNO DE PIERNA"
  },
  {
    "codigo":57000008,
    "descripcion":"APNEA TRAUMÁTICA"
  },
  {
    "codigo":24232008,
    "descripcion":"CELULITIS DE DEDO, CON LINFANGITIS"
  },
  {
    "codigo":1202045002,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE REGIÓN DE PELVIS"
  },
  {
    "codigo":284541005,
    "descripcion":"QUEMADURA DE CONJUNTIVA"
  },
  {
    "codigo":251773008,
    "descripcion":"CAMBIO EN LA DESVIACIÓN DEL EJE OCULAR"
  },
  {
    "codigo":1003602001,
    "descripcion":"SINOSTOSIS CONGÉNITA DE TODAS LAS SUTURAS DE CRÁNEO"
  },
  {
    "codigo":315474005,
    "descripcion":"NACIDO EN MALDIVAS"
  },
  {
    "codigo":249938007,
    "descripcion":"DEBILIDAD DEL DORSO"
  },
  {
    "codigo":280871000,
    "descripcion":"DEGENERACIÓN VASCULAR"
  },
  {
    "codigo":53330008,
    "descripcion":"LIVEDO TELANGIECTÁSICA"
  },
  {
    "codigo":282706007,
    "descripcion":"DIFICULTAD PARA EMPUJAR Y TIRAR DE UN OBJETO AL CORRER"
  },
  {
    "codigo":870695003,
    "descripcion":"RANGO DE FRECUENCIA CARDÍACA FETAL BASAL DE 180 A 200"
  },
  {
    "codigo":248103001,
    "descripcion":"RUBIFACCIÓN"
  },
  {
    "codigo":1263911005,
    "descripcion":"CARCINOMA EX ADENOMA PLEOMORFO DE GLÁNDULA PARÓTIDA METASTÁSICO"
  },
  {
    "codigo":51495008,
    "descripcion":"ANOXIA CEREBRAL POSTERIOR A LA ANESTESIA Y\/O SEDACIÓN EN EL TRABAJO DE PARTO Y\/O PARTO"
  },
  {
    "codigo":279036000,
    "descripcion":"SÍNDROME DE DOLOR MIOFASCIAL DEL TÓRAX"
  },
  {
    "codigo":311804006,
    "descripcion":"PROLAPSO DE DISCO INTERVERTEBRAL LUMBAR CON CIÁTICA"
  },
  {
    "codigo":10637631000119100,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN EN GLÚTEO IZQUIERDO NO ESTADIFICABLE"
  },
  {
    "codigo":80593000,
    "descripcion":"INGESTIÓN DE MATERIALES EXTRAÑOS"
  },
  {
    "codigo":1260241001,
    "descripcion":"RESISTENCIA A HORMONA TIROIDEA POR MUTACIÓN EN RECEPTOR BETA DE HORMONA TIROIDEA"
  },
  {
    "codigo":342181000119107,
    "descripcion":"DACRIOADENITIS AGUDA DE OJO IZQUIERDO"
  },
  {
    "codigo":703185000,
    "descripcion":"INSUFICIENCIA DE NEOVÁLVULA PULMONAR"
  },
  {
    "codigo":15634751000119101,
    "descripcion":"MASA DE OVARIO IZQUIERDO"
  },
  {
    "codigo":76923000,
    "descripcion":"EXOTROPÍA ALTERNANTE NO CONCOMITANTE DISTINTA DEL PATRÓN EN A O V"
  },
  {
    "codigo":275366009,
    "descripcion":"FRACTURA DE CÚBITO DURANTE EL PARTO"
  },
  {
    "codigo":1354875002,
    "descripcion":"LESIÓN TRAUMÁTICA DE VASO SANGUÍNEO DIGITAL DE MANO"
  },
  {
    "codigo":109691001,
    "descripcion":"OSTEOMIELITIS ESCLEROSANTE CRÓNICA NO SUPURATIVA DE MAXILAR INFERIOR"
  },
  {
    "codigo":240763006,
    "descripcion":"TRICOSPORONOSIS DISEMINADA"
  },
  {
    "codigo":11387009,
    "descripcion":"TRASTORNO MENTAL ORGÁNICO INDUCIDO POR SUSTANCIA PSICOACTIVA"
  },
  {
    "codigo":75088002,
    "descripcion":"NECESIDAD IMPERIOSA DE ORINAR"
  },
  {
    "codigo":699515009,
    "descripcion":"RETINITIS FOCAL DE POLO POSTERIOR DEL OJO"
  },
  {
    "codigo":238928005,
    "descripcion":"SABAÑÓN EN LUPUS ERITEMATOSO"
  },
  {
    "codigo":402768006,
    "descripcion":"SÍNDROME ECTODÉRMICO CON DEFECTOS DE PELO Y SUDORACIÓN"
  },
  {
    "codigo":1287504007,
    "descripcion":"ABRASIÓN DE PIEL DE MÚLTIPLES DEDOS DE PIE"
  },
  {
    "codigo":237093007,
    "descripcion":"VAGINITIS PREPUBERAL"
  },
  {
    "codigo":106021008,
    "descripcion":"HALLAZGO RELACIONADO CON EL PATRÓN DE DESCANSO DURANTE EL SUEÑO"
  },
  {
    "codigo":71418005,
    "descripcion":"QUISTE DE LA RINOFARINGE"
  },
  {
    "codigo":200655000,
    "descripcion":"CELULITIS Y ABSCESO DE TRONCO"
  },
  {
    "codigo":724943001,
    "descripcion":"LESIÓN TRAUMÁTICA DE BOLSA SEROSA A NIVEL DEL ANTEBRAZO"
  },
  {
    "codigo":202490009,
    "descripcion":"DOLOR DE ARTICULACIÓN DE TOBILLO"
  },
  {
    "codigo":300794008,
    "descripcion":"CABALGA E IMPULSA JUGUETES"
  },
  {
    "codigo":167887005,
    "descripcion":"VISCOSIDAD DE LÍQUIDO SINOVIAL, NORMAL"
  },
  {
    "codigo":36815008,
    "descripcion":"ACETONURIA"
  },
  {
    "codigo":430031008,
    "descripcion":"HIDRONEFROSIS FETAL"
  },
  {
    "codigo":460964000,
    "descripcion":"ORIGEN ANÓMALO DE LIGAMENTO ARTERIOSO EN ARTERIA SUBCLAVIA IZQUIERDA"
  },
  {
    "codigo":723108006,
    "descripcion":"HEPATITIS GRANULOMATOSA IDIOPÁTICA"
  },
  {
    "codigo":428196007,
    "descripcion":"INFARTO E ISQUEMIA MIOCÁRDICA COMBINADOS"
  },
  {
    "codigo":15690201000119107,
    "descripcion":"ARTRITIS BACTERIANA BILATERAL DE PIES"
  },
  {
    "codigo":721273004,
    "descripcion":"INFECCIÓN DE VÉRTEBRA"
  },
  {
    "codigo":129614001,
    "descripcion":"PARÁLISIS DEL NERVIO VAGO, NERVIOS ESPINAL E HIPOGLOSO"
  },
  {
    "codigo":262521009,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÉDULA ESPINAL Y\/O COLUMNA VERTEBRAL"
  },
  {
    "codigo":295289009,
    "descripcion":"SOBREDOSIS INTENCIONAL DE FENILBUTAZONA"
  },
  {
    "codigo":783139000,
    "descripcion":"EPILEPSIA MIOCLÓNICA PROGRESIVA TIPO 8"
  },
  {
    "codigo":293454008,
    "descripcion":"REACCIÓN ADVERSA A DIURÉTICO TIAZÍDICO"
  },
  {
    "codigo":291619003,
    "descripcion":"INTOXICACIÓN POR CEFTRIAXONA"
  },
  {
    "codigo":422691006,
    "descripcion":"CARCINOMA ESCAMOCELULAR DE NASOFARINGE"
  },
  {
    "codigo":1010680000,
    "descripcion":"ANOMALÍA DE VENA UMBILICAL GRUPO IV"
  },
  {
    "codigo":715768000,
    "descripcion":"DISTONÍA AUTOSÓMICA DOMINANTE SENSIBLE A DOPA"
  },
  {
    "codigo":191480000,
    "descripcion":"SÍNDROME DE ABSTINENCIA DE ALCOHOL"
  },
  {
    "codigo":95011008,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA PARED POSTERIOR DE LA OROFARINGE"
  },
  {
    "codigo":289784006,
    "descripcion":"CUELLO UTERINO POSTERIOR"
  },
  {
    "codigo":224248007,
    "descripcion":"CARECE DE ESPACIO DE PRIVACIDAD EN EL ALOJAMIENTO"
  },
  {
    "codigo":1172685001,
    "descripcion":"SÍNDROME DE MACROTROMBOCITOPENIA, LINFEDEMA, RETRASO DEL DESARROLLO, DISMORFIA FACIAL, CAMPTODACTILIA"
  },
  {
    "codigo":124109002,
    "descripcion":"DEFICIENCIA DE POLIOL DESHIDROGENASA (NADP^+^)"
  },
  {
    "codigo":255181009,
    "descripcion":"NEOPLASIA BENIGNA DE OÍDO"
  },
  {
    "codigo":253346003,
    "descripcion":"APÉNDICE AURICULAR DERECHO - IZQUIERDO - YUXTAPOSICIÓN"
  },
  {
    "codigo":417186004,
    "descripcion":"DISMINUCIÓN BRUSCA DEL HEMATÓCRITO"
  },
  {
    "codigo":187810005,
    "descripcion":"NEOPLASIA MALIGNA DEL MESOCIEGO"
  },
  {
    "codigo":286114007,
    "descripcion":"NO LIMPIA EL POLVO"
  },
  {
    "codigo":251511001,
    "descripcion":"ASIMETRÍA GENERALIZADA EN LA AMPLITUD DEL ELECTROENCEFALOGRAMA"
  },
  {
    "codigo":284279001,
    "descripcion":"NO EMPLEA AGARRE CON TRES DEDOS"
  },
  {
    "codigo":22135003,
    "descripcion":"LEUCOMA CORNEAL QUE INTERFIERE CON LA VISIÓN CENTRAL"
  },
  {
    "codigo":448119006,
    "descripcion":"DEFECTO DEL TABIQUE AURICULOVENTRICULAR CON INSUFICIENCIA DE VÁLVULA AURICULOVENTRICULAR"
  },
  {
    "codigo":85836000,
    "descripcion":"OBSTRUCCIÓN DUODENAL CONGÉNITA POR PÁNCREAS ANULAR"
  },
  {
    "codigo":13015821000119105,
    "descripcion":"MELANOCITOSIS OCULAR CONGÉNITA DE AMBOS OJOS"
  },
  {
    "codigo":1263649006,
    "descripcion":"PULGAR EN GATILLO BILATERAL EN EDAD PEDIÁTRICA"
  },
  {
    "codigo":772129007,
    "descripcion":"ATROFIA MUSCULAR ESPINAL PROXIMAL INFANTIL AUTOSÓMICA DOMINANTE"
  },
  {
    "codigo":49398001,
    "descripcion":"ATROFIA DE LA VESÍCULA SEMINAL"
  },
  {
    "codigo":247841009,
    "descripcion":"MIEDO A HABLAR POR TELÉFONO"
  },
  {
    "codigo":311542006,
    "descripcion":"INCAPAZ DE PROCESAR INFORMACIÓN A VELOCIDAD NORMAL"
  },
  {
    "codigo":47563007,
    "descripcion":"DEFICIENCIA NUTRICIONAL"
  },
  {
    "codigo":127911000119105,
    "descripcion":"NEFROPATÍA POR CADENAS LIVIANAS DEBIDA A MIELOMA MÚLTIPLE"
  },
  {
    "codigo":211403009,
    "descripcion":"ABRASIÓN DE PIEL DE DEDO DE PIE"
  },
  {
    "codigo":373408007,
    "descripcion":"VASCULOPATÍA DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":109429002,
    "descripcion":"DEFECTO MUSCULAR ÚNICO DEL TABIQUE VENTRICULAR"
  },
  {
    "codigo":43893007,
    "descripcion":"INTOXICACIÓN POR CEFALEXINA"
  },
  {
    "codigo":238666005,
    "descripcion":"LIQUEN PLANO DE LOS LABIOS"
  },
  {
    "codigo":369738006,
    "descripcion":"INVASIÓN VENOSA NO EVALUABLE"
  },
  {
    "codigo":15748161000119103,
    "descripcion":"MASA DE ARTICULACIÓN DE CODO IZQUIERDO"
  },
  {
    "codigo":402506005,
    "descripcion":"CARCINOMA BASOCELULAR DE LABIO INFERIOR"
  },
  {
    "codigo":72991005,
    "descripcion":"SÍNDROME DE POLIPLOIDÍA"
  },
  {
    "codigo":40223008,
    "descripcion":"ESTADIO V0"
  },
  {
    "codigo":1187103009,
    "descripcion":"REACCIÓN ADVERSA A DANAPAROIDE"
  },
  {
    "codigo":890356003,
    "descripcion":"POLIDACTILIA POSTAXIAL TIPO A BILATERAL DE MEÑIQUE"
  },
  {
    "codigo":169460005,
    "descripcion":"REINICIA TOMA DE ANTICONCEPTIVOS ORALES"
  },
  {
    "codigo":300532006,
    "descripcion":"LESIÓN DE PRÓSTATA"
  },
  {
    "codigo":366068007,
    "descripcion":"ALINEAMIENTO DEL EJE ÓPTICO - HALLAZGO"
  },
  {
    "codigo":234996008,
    "descripcion":"GINGIVITIS FIBROEDEMATOSA CRÓNICA"
  },
  {
    "codigo":202228008,
    "descripcion":"LUXACIÓN RECURRENTE DE LA ARTICULACIÓN RADIOCUBITAL DISTAL"
  },
  {
    "codigo":822985002,
    "descripcion":"COSTRA DE SANGRE SOBRE LA PIEL"
  },
  {
    "codigo":298697006,
    "descripcion":"PRUEBA DE ESTIRAMIENTO DE NERVIO FEMORAL NEGATIVA"
  },
  {
    "codigo":1148830000,
    "descripcion":"INTOXICACIÓN POR CRUFOMATO"
  },
  {
    "codigo":724681009,
    "descripcion":"TRASTORNO DEL ESTADO DE ÁNIMO CON SÍNTOMAS MANÍACOS CAUSADO POR ANSIOLÍTICO"
  },
  {
    "codigo":67486009,
    "descripcion":"TROMBOFLEBITIS PÉLVICA EN EL PUERPERIO"
  },
  {
    "codigo":295027004,
    "descripcion":"ALERGIA A XIPAMIDA"
  },
  {
    "codigo":1343603007,
    "descripcion":"ARTROSIS DE COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":32883009,
    "descripcion":"FIBROSIS SUBMUCOSA ORAL"
  },
  {
    "codigo":293192001,
    "descripcion":"REACCIÓN ADVERSA A LA ACETOHEXAMIDA"
  },
  {
    "codigo":162120004,
    "descripcion":"CONTROL DE LA MICCIÓN, NORMAL"
  },
  {
    "codigo":1145160009,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR PIPERAZINA Y\/O DERIVADO DE PIPERAZINA"
  },
  {
    "codigo":782877002,
    "descripcion":"SÍNDROME DE DUPLICACIÓN XP22.13P22.2"
  },
  {
    "codigo":225821006,
    "descripcion":"VÍCTIMA DE CHANTAJE"
  },
  {
    "codigo":1208861007,
    "descripcion":"SÍNDROME DE QT PROLONGADO TIPO 4"
  },
  {
    "codigo":715506001,
    "descripcion":"SÍNDROME DE FOCOMELIA, ECTRODACTILIA, SORDERA Y ARRITMIA SINUSAL"
  },
  {
    "codigo":94749009,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA AXILA"
  },
  {
    "codigo":191218003,
    "descripcion":"ANEMIA HEMOLÍTICA TÓXICA"
  },
  {
    "codigo":289522005,
    "descripcion":"TUMORACIÓN VAGINAL"
  },
  {
    "codigo":60146005,
    "descripcion":"SÍNDROME DE BAILEY - CUSHING"
  },
  {
    "codigo":1303495001,
    "descripcion":"ATRESIA CONGÉNITA DE PARTE ANTERIOR DE NARIZ"
  },
  {
    "codigo":713671003,
    "descripcion":"MÉDICAMENTE APTO PARA CIRUGÍA"
  },
  {
    "codigo":895624001,
    "descripcion":"FORMA ROMBOIDE ANORMAL CONGÉNITA DE FALANGE PROXIMAL DE DEDO MEÑIQUE"
  },
  {
    "codigo":285852000,
    "descripcion":"DIFICULTAD PARA CONTROLAR LAS EMOCIONES"
  },
  {
    "codigo":254919009,
    "descripcion":"ADENOMA CORTICAL DE RIÑÓN"
  },
  {
    "codigo":89244003,
    "descripcion":"ENREDO DE CORDONES DE MELLIZOS EN SACO MONOAMNIÓTICO"
  },
  {
    "codigo":677391000119100,
    "descripcion":"GLOBO OCULAR IZQUIERDO CONTRAÍDO"
  },
  {
    "codigo":449692007,
    "descripcion":"ACORTAMIENTO CONGÉNITO DE BRAZO"
  },
  {
    "codigo":416924009,
    "descripcion":"PRUEBA DE HEAF GRADO 0"
  },
  {
    "codigo":218481003,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR HORMONA PARATIROIDEA Y\/O DERIVADO DE HORMONA PARATIROIDEA"
  },
  {
    "codigo":446022000,
    "descripcion":"CARCINOMA DE ÚTERO"
  },
  {
    "codigo":54641008,
    "descripcion":"FRACTURA NO EXPUESTA DE LA BASE DE OTRO HUESO METACARPIANO QUE NO SEA EL PRIMER METACARPIANO"
  },
  {
    "codigo":413254002,
    "descripcion":"CONGESTIÓN DE LA MUCOSA"
  },
  {
    "codigo":773702002,
    "descripcion":"OSTEOMIELITIS MULTIFOCAL ESTÉRIL CON PERIOSTITIS Y PUSTULOSIS"
  },
  {
    "codigo":282182004,
    "descripcion":"NO SUBE UN ESCALÓN"
  },
  {
    "codigo":1086991000119103,
    "descripcion":"ABSCESO GONOCÓCICO DE CEREBRO"
  },
  {
    "codigo":314950006,
    "descripcion":"MIGRACIÓN DE ESTIMULADOR DE LA MÉDULA ESPINAL"
  },
  {
    "codigo":249414000,
    "descripcion":"BALANOPOSTITIS POR TRICOMONAS"
  },
  {
    "codigo":247579006,
    "descripcion":"SUBESTIMA CAPACIDAD INTELECTUAL"
  },
  {
    "codigo":278512001,
    "descripcion":"PARÁLISIS CEREBRAL ATÁXICA"
  },
  {
    "codigo":1359856005,
    "descripcion":"CARCINOMA PRIMARIO DE BERMELLÓN DE LABIO SUPERIOR"
  },
  {
    "codigo":735429002,
    "descripcion":"HIPERPLASIA DE HUESO"
  },
  {
    "codigo":14533003,
    "descripcion":"FLEXIBILIDAD VOCAL NORMAL"
  },
  {
    "codigo":1259717007,
    "descripcion":"MESOTELIOMA PRIMARIO MALIGNO DE PERITONEO PÉLVICO"
  },
  {
    "codigo":15724201000119102,
    "descripcion":"ENTESOPATÍA DE RODILLA DERECHA"
  },
  {
    "codigo":405914002,
    "descripcion":"NO SE PUEDE EVALUAR LA EXTENSIÓN DEL COMPROMISO DEL MARGEN DE RESECCIÓN QUIRÚRGICA POR SARCOMA"
  },
  {
    "codigo":209306005,
    "descripcion":"FRACTURA-LUXACIÓN NO EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA DISTAL"
  },
  {
    "codigo":111002006,
    "descripcion":"LINFADENOPATÍA PROTEINÁCEA"
  },
  {
    "codigo":307610008,
    "descripcion":"CARCINOMA PILOMATRICIAL DE PIEL"
  },
  {
    "codigo":1256047001,
    "descripcion":"FALLA DE INJERTO DE PIEL DE ESPESOR PARCIAL"
  },
  {
    "codigo":305775001,
    "descripcion":"VISTO POR TERAPEUTA OCUPACIONAL DE DEPARTAMENTO DE SERVICIOS SOCIALES"
  },
  {
    "codigo":76399004,
    "descripcion":"MAL DE OJO"
  },
  {
    "codigo":240239004,
    "descripcion":"DEFORMIDAD EN ABDUCCIÓN DEL DEDO DE LA MANO"
  },
  {
    "codigo":698991004,
    "descripcion":"LINFEDEMA DEBIDO A ENFERMEDAD VENOSA"
  },
  {
    "codigo":404079008,
    "descripcion":"CONDROSARCOMA MIXOIDE EXTRAESQUELÉTICO"
  },
  {
    "codigo":10863009,
    "descripcion":"INFECCIÓN CAUSADA POR THEILERIA LAWRENCI"
  },
  {
    "codigo":402244002,
    "descripcion":"REACCIÓN LIQUENOIDE ALÉRGICA DE CONTACTO CAUSADA POR CROMÓGENO"
  },
  {
    "codigo":238404003,
    "descripcion":"LINFANGITIS AGUDA DE LA PIEL, EXCEPTO EN LOS DEDOS DE LA MANO Y DEL PIE"
  },
  {
    "codigo":205636003,
    "descripcion":"MONOSOMÍA DE TODO UN CROMOSOMA - FALTA DE DISYUNCIÓN MEIÓTICA"
  },
  {
    "codigo":271172007,
    "descripcion":"AMPOLLA TRAUMÁTICA DE DEDO DE LA MANO, INFECTADA"
  },
  {
    "codigo":105497000,
    "descripcion":"AMENAZA DE DESPIDO"
  },
  {
    "codigo":236569000,
    "descripcion":"FALLO PRIMARIO DEL TRASPLANTE RENAL"
  },
  {
    "codigo":1186841005,
    "descripcion":"NEUROPATÍA CRANEAL DEBIDO A DEFICIENCIA DE MICRONUTRIENTES"
  },
  {
    "codigo":365806000,
    "descripcion":"HALLAZGO RELACIONADO CON EL NIVEL DE GLOBULINAS EN LÍQUIDO CEFALORRAQUÍDEO"
  },
  {
    "codigo":890094005,
    "descripcion":"HEMORRAGIA GENITAL"
  },
  {
    "codigo":300270009,
    "descripcion":"NO SE VISUALIZA FARINGE"
  },
  {
    "codigo":167363002,
    "descripcion":"MICROSCOPIA DE ORINA: AUSENCIA DE ORGANISMOS O CUERPOS EXTRAÑOS"
  },
  {
    "codigo":298435006,
    "descripcion":"AMPLITUD DE FLEXIÓN LATERAL PASIVA HACIA LA DERECHA DE LA COLUMNA VERTEBRAL CERVICAL, AUMENTADA"
  },
  {
    "codigo":460440005,
    "descripcion":"PERICARDITIS CON DERRAME PERICÁRDICO CAUSADA POR COMPLEJO MYCOBACTERIUM TUBERCULOSIS"
  },
  {
    "codigo":1148568006,
    "descripcion":"VÓLVULO DE YEYUNO"
  },
  {
    "codigo":67224007,
    "descripcion":"TRÍADA DE ARTRITIS REACTIVA"
  },
  {
    "codigo":788120007,
    "descripcion":"DEPRESIÓN PRENATAL"
  },
  {
    "codigo":165528007,
    "descripcion":"RECUENTO DE BASÓFILOS FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":65389002,
    "descripcion":"ADRENOLEUCODISTROFIA"
  },
  {
    "codigo":196461003,
    "descripcion":"OSTEÍTIS MANDIBULAR CRÓNICA"
  },
  {
    "codigo":720749004,
    "descripcion":"SÍNDROME DE DISTROFIA ENDOTELIAL HEREDITARIA CONGÉNITA Y SORDERA PERCEPTIVA"
  },
  {
    "codigo":292930000,
    "descripcion":"REACCIÓN ADVERSA A MACRÓLIDO"
  },
  {
    "codigo":161858001,
    "descripcion":"NO TRANSPIRA DE MANERA ANORMAL"
  },
  {
    "codigo":718914002,
    "descripcion":"DISCAPACIDAD INTELECTUAL LIGADA AL CROMOSOMA X TIPO VAN ESCH"
  },
  {
    "codigo":1144898001,
    "descripcion":"MIOSITIS EXTRAOCULAR"
  },
  {
    "codigo":294765008,
    "descripcion":"ALERGIA A GESTRINONA"
  },
  {
    "codigo":28951000,
    "descripcion":"INFECCIÓN CAUSADA POR TRICHURIS SUIS"
  },
  {
    "codigo":422167001,
    "descripcion":"HAEMOBARTONELLOSIS"
  },
  {
    "codigo":94487002,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE FALANGE DE LA MANO"
  },
  {
    "codigo":127255004,
    "descripcion":"NEOPLASIA DE LOS GANGLIOS LINFÁTICOS AXILARES"
  },
  {
    "codigo":225559007,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN EN CODO"
  },
  {
    "codigo":291095007,
    "descripcion":"INTOXICACIÓN INTENCIONAL CAUSADA POR TEMAZEPAM"
  },
  {
    "codigo":192791009,
    "descripcion":"DEGENERACIÓN CEREBRAL EN LA ENFERMEDAD DE GAUCHER"
  },
  {
    "codigo":289260002,
    "descripcion":"HERNIA EPIGÁSTRICA"
  },
  {
    "codigo":16054391000119102,
    "descripcion":"HIPOPLASIA CONGÉNITA DE NERVIO ÓPTICO DERECHO"
  },
  {
    "codigo":123585009,
    "descripcion":"SEPARACIÓN DEL PLIEGUE DE LAS UÑAS"
  },
  {
    "codigo":577931000005105,
    "descripcion":"MIEMBRO DE MAYOR EDAD EN PAREJA DE UNIÓN CIVIL"
  },
  {
    "codigo":88982005,
    "descripcion":"INSOMNIO DE REBOTE"
  },
  {
    "codigo":449430006,
    "descripcion":"DOBLE CAYADO AÓRTICO CON ARCO IZQUIERDO DOMINANTE Y ARCO DERECHO PERMEABLE"
  },
  {
    "codigo":250987007,
    "descripcion":"INSUFICIENCIA DE PRÓTESIS DE VÁLVULA MITRAL"
  },
  {
    "codigo":609600000,
    "descripcion":"NEUROPATÍA DE MIEMBRO INFERIOR"
  },
  {
    "codigo":183616001,
    "descripcion":"SEGUIMIENTO CONVENIDO"
  },
  {
    "codigo":29231000175105,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN DE GLÚTEO DERECHO GRADO 2"
  },
  {
    "codigo":19776001,
    "descripcion":"TAMAÑO DISMINUIDO"
  },
  {
    "codigo":283755007,
    "descripcion":"MORDEDURA DE PERRO EN EL DORSO DE LA MANO"
  },
  {
    "codigo":445760005,
    "descripcion":"ESGUINCE AGUDO DE LIGAMENTO DEL CUELLO"
  },
  {
    "codigo":314688005,
    "descripcion":"TALLA DEL NIÑO: PERCENTILO 0,5-1,9"
  },
  {
    "codigo":52544006,
    "descripcion":"INFESTACIÓN CAUSADA POR HYPODERMA"
  },
  {
    "codigo":1197589000,
    "descripcion":"SÍNDROME DE STEEL"
  },
  {
    "codigo":281920008,
    "descripcion":"FRACTURA DE TRES COLUMNAS DE VÉRTEBRA CERVICAL"
  },
  {
    "codigo":1230357008,
    "descripcion":"ANOMALÍA CONGÉNITA DE EXTREMIDAD SUPERIOR IZQUIERDA"
  },
  {
    "codigo":704234008,
    "descripcion":"FRACTURA EXPUESTA DE FALANGE DE DEDO MEÑIQUE"
  },
  {
    "codigo":81642009,
    "descripcion":"TRASTORNO DEBIDO A LESIÓN DE MÉDULA ESPINAL Y POSTERIOR A ELLA"
  },
  {
    "codigo":79807003,
    "descripcion":"PIE VALGO"
  },
  {
    "codigo":702399004,
    "descripcion":"ENFERMEDAD HEPÁTICA COMPENSADA"
  },
  {
    "codigo":276415005,
    "descripcion":"OPOSICIÓN DE PULGARES ALTERADA"
  },
  {
    "codigo":473023007,
    "descripcion":"COMPLICACIÓN ASOCIADA CON DISPOSITIVO"
  },
  {
    "codigo":210879008,
    "descripcion":"CONTUSIÓN, VENA POPLÍTEA"
  },
  {
    "codigo":77972001,
    "descripcion":"ADHERENCIA DE CONDUCTO BILIAR"
  },
  {
    "codigo":733332002,
    "descripcion":"DIVERGENCIA SINÉRGICA"
  },
  {
    "codigo":354731000119100,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE BRONQUIO PRINCIPAL DERECHO"
  },
  {
    "codigo":698729002,
    "descripcion":"HIPERCALCEMIA DEBIDA A TUBERCULOSIS"
  },
  {
    "codigo":305513003,
    "descripcion":"BAJO ATENCIÓN DE PSIQUIATRA"
  },
  {
    "codigo":1255785004,
    "descripcion":"PARAGRANULOMA DE HODGKIN DE GANGLIOS LINFÁTICOS DE CUELLO"
  },
  {
    "codigo":895337005,
    "descripcion":"CURVATURA ANORMAL DE FALANGE PROXIMAL DE DEDO ÍNDICE"
  },
  {
    "codigo":10601006,
    "descripcion":"DOLOR DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":272745007,
    "descripcion":"SIMULACIÓN DE ENFERMEDAD FÍSICA"
  },
  {
    "codigo":371049006,
    "descripcion":"ÚLCERA CUTÁNEA TRAUMÁTICA"
  },
  {
    "codigo":27051000119102,
    "descripcion":"PATRÓN DE USO NOCIVO CRÓNICO DE LAXANTES"
  },
  {
    "codigo":403817006,
    "descripcion":"NEUROFIBROMAS MÚLTIPLES EN LA NEUROFIBROMATOSIS"
  },
  {
    "codigo":238142003,
    "descripcion":"SOBRECARGA DE POTASIO"
  },
  {
    "codigo":270910001,
    "descripcion":"ENFERMEDAD QUÍSTICA MEDULAR, TIPO ADULTO"
  },
  {
    "codigo":170771004,
    "descripcion":"PACIENTE DIABÉTICO - INCUMPLIMIENTO DEL CONTROL"
  },
  {
    "codigo":269075008,
    "descripcion":"FRACTURA EXPUESTA DE QUINTA VÉRTEBRA CERVICAL"
  },
  {
    "codigo":38251000087104,
    "descripcion":"HIPOCINESIA DE SEGMENTO ANTEROLATERAL BASAL DE VENTRÍCULO IZQUIERDO DE CORAZÓN"
  },
  {
    "codigo":365544001,
    "descripcion":"CONCURRENCIA AL TRABAJO - HALLAZGO"
  },
  {
    "codigo":40811000087104,
    "descripcion":"ABRASIÓN DE PIEL DE SEGUNDO DEDO DE PIE IZQUIERDO"
  },
  {
    "codigo":37864005,
    "descripcion":"TEMBLOR TENDINOSO"
  },
  {
    "codigo":43371000087109,
    "descripcion":"DISCO INTERVERTEBRAL LUMBAR PROLAPSADO, L2-L3"
  },
  {
    "codigo":48491000087109,
    "descripcion":"FRACTURA INTERTROCANTÉREA DE FÉMUR DERECHO"
  },
  {
    "codigo":234472008,
    "descripcion":"DEFECTO DE GLICOPROTEÍNA IB"
  },
  {
    "codigo":5096009,
    "descripcion":"ROCE DE FRICCIÓN ABDOMINAL"
  },
  {
    "codigo":298173001,
    "descripcion":"ARTICULACIÓN SUBASTRAGALINA, INFLAMADA"
  },
  {
    "codigo":3261002,
    "descripcion":"OSTEÓLISIS MIGRATORIA"
  },
  {
    "codigo":682411000119106,
    "descripcion":"ANGIOSARCOMA PRIMARIO DE TÓRAX"
  },
  {
    "codigo":429245005,
    "descripcion":"ARTERIOSCLEROSIS CORONARIA RECURRENTE DESPUÉS DE ANGIOPLASTIA TRANSLUMINAL PERCUTÁNEA CORONARIA"
  },
  {
    "codigo":36029005,
    "descripcion":"ABSCESO DEL PENE"
  },
  {
    "codigo":789693005,
    "descripcion":"SÍNDROME DE BRUGADA ADQUIRIDO"
  },
  {
    "codigo":82501000119102,
    "descripcion":"ASTROCITOMA ANAPLÁSICO DE SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":296338000,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE ATENOLOL"
  },
  {
    "codigo":1426004,
    "descripcion":"GLOMERULONEFRITIS NECROSANTE"
  },
  {
    "codigo":1092011000119109,
    "descripcion":"OTOESCLEROSIS DE LOS HUESECILLOS DEL OÍDO DERECHO"
  },
  {
    "codigo":165266006,
    "descripcion":"CAMINA 60-89 METROS EN 1 MINUTO"
  },
  {
    "codigo":230802007,
    "descripcion":"MUERTE ENCEFÁLICA"
  },
  {
    "codigo":66962008,
    "descripcion":"GRANULOMA POR SUTURA"
  },
  {
    "codigo":34194007,
    "descripcion":"ANEMIA HEMOLÍTICA NO ESFEROCÍTICA HEREDITARIA POR DEFICIENCIA DE PIRIMIDINA-5'-NUCLEOTIDASA"
  },
  {
    "codigo":294503001,
    "descripcion":"ALERGIA A METICILINA"
  },
  {
    "codigo":720487006,
    "descripcion":"TUMOR ANGIECTÁSICO HIALINIZANTE PLEOMÓRFICO DE PARTES BLANDAS"
  },
  {
    "codigo":292668001,
    "descripcion":"REACCIÓN ADVERSA A LA TRETINOÍNA"
  },
  {
    "codigo":1073101000000104,
    "descripcion":"EVALÚA RIESGOS"
  },
  {
    "codigo":94225005,
    "descripcion":"NEOPLASIA MALIGNA SECUNDARIA DEL ENCÉFALO"
  },
  {
    "codigo":126993007,
    "descripcion":"NEOPLASIA DE NERVIO PERIFÉRICO DE LA PELVIS"
  },
  {
    "codigo":288998001,
    "descripcion":"DIFICULTAD PARA BEBER DE UNA BOTELLA"
  },
  {
    "codigo":125158005,
    "descripcion":"SATISFACTORIO PARA EVALUACIÓN PERO LIMITADO POR ARTIFICIO DE SECADO CON AIRE QUE ENMASCARA PARCIALMENTE EL RESULTADO"
  },
  {
    "codigo":878822006,
    "descripcion":"PANCREATITIS ISQUÉMICA"
  },
  {
    "codigo":92390008,
    "descripcion":"NEOPLASIA BENIGNA DE PARTES BLANDAS DE LA CARA"
  },
  {
    "codigo":1237435003,
    "descripcion":"BLEFARITIS SEBORREICA DE PÁRPADO INFERIOR"
  },
  {
    "codigo":254395006,
    "descripcion":"NEOPLASIA BENIGNA DE FRENILLO LABIAL"
  },
  {
    "codigo":188859006,
    "descripcion":"NEOPLASIA BENIGNA DE TEJIDO PERINÉFRICO"
  },
  {
    "codigo":185189000,
    "descripcion":"ATENDIDO EN CONSULTORIO ESPECIALIZADO EN VÁRICES"
  },
  {
    "codigo":447333000,
    "descripcion":"QUEMADURA DE ANEXOS OCULARES"
  },
  {
    "codigo":412730000,
    "descripcion":"HALLAZGO GENÉTICO NEGATIVO"
  },
  {
    "codigo":19514005,
    "descripcion":"ARTRITIS MUTILANTE"
  },
  {
    "codigo":871482006,
    "descripcion":"PRESENTACIÓN DE FETO EN CAVIDAD MEDIA DE PELVIS MATERNA"
  },
  {
    "codigo":684921000119103,
    "descripcion":"GLIOBLASTOMA MULTIFORME PRIMARIO DE LÓBULO OCCIPITAL"
  },
  {
    "codigo":247055000,
    "descripcion":"OPACIDADES DE CÁPSULA ANTERIOR DE CRISTALINO"
  },
  {
    "codigo":609338009,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE MIEMBRO SUPERIOR, INFECTADA"
  },
  {
    "codigo":312591002,
    "descripcion":"CARDIOPATÍA REUMÁTICA AGUDA"
  },
  {
    "codigo":445498009,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA BILATERAL DE MIEMBROS INFERIORES"
  },
  {
    "codigo":1197327004,
    "descripcion":"CARCINOMA METASTÁSICO DE GANGLIO LINFÁTICO DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":443663000,
    "descripcion":"UTILIZA DOS MULETAS PARA CAMINAR"
  },
  {
    "codigo":441828004,
    "descripcion":"ATENDIDO EN CENTRO PSIQUIÁTRICO ESPECIALIZADO PARA NIÑOS Y ADOLESCENTES"
  },
  {
    "codigo":275336002,
    "descripcion":"TENDÓN DE AQUILES CORTO"
  },
  {
    "codigo":212452005,
    "descripcion":"RUPTURA TRAUMÁTICA DE DISCO"
  },
  {
    "codigo":12235641000119107,
    "descripcion":"PTOSIS CONGÉNITA DE AMBOS PÁRPADOS SUPERIORES"
  },
  {
    "codigo":210617003,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA EL EXTREMO DEL PULGAR"
  },
  {
    "codigo":308921004,
    "descripcion":"SÍNTOMA NEUROLÓGICO"
  },
  {
    "codigo":472761007,
    "descripcion":"HIPERTENSIÓN VENOSA PULMONAR DEBIDA A COMPRESIÓN DE GRAN VENA PULMONAR POR NEOPLASIA"
  },
  {
    "codigo":734905008,
    "descripcion":"EXACERBACIÓN AGUDA DE ASMA MODERADA"
  },
  {
    "codigo":733070005,
    "descripcion":"SÍNDROME DE DUPLICACIÓN DE CEJAS Y SINDACTILIA"
  },
  {
    "codigo":700302005,
    "descripcion":"QUISTE DE PÁRPADO SUPERIOR"
  },
  {
    "codigo":698467000,
    "descripcion":"CON MAYOR RIESGO DE LINFEDEMA"
  },
  {
    "codigo":896910009,
    "descripcion":"FORMA ANCHA ANORMAL CONGÉNITA DE FALANGE DISTAL DE PULGAR"
  },
  {
    "codigo":75875004,
    "descripcion":"EPIDERMÓLISIS BULLOSA DISTRÓFICA DOMINANTE, TIPO ALBOPAPULAR"
  },
  {
    "codigo":1255523006,
    "descripcion":"RUPTURA TRAUMÁTICA DE TENDÓN DE REGIÓN DE CADERA"
  },
  {
    "codigo":237880003,
    "descripcion":"HIPERCALCEMIA SECUNDARIA"
  },
  {
    "codigo":8504008,
    "descripcion":"ENFERMEDAD RELACIONADA CON EL MEDIO"
  },
  {
    "codigo":304301000119101,
    "descripcion":"GOTA TOFÁCEA CRÓNICA DE VÉRTEBRA DEBIDA A DISFUNCIÓN RENAL"
  },
  {
    "codigo":434371000124108,
    "descripcion":"TRASTORNO CRÓNICO DE MÉDULA ESPINAL"
  },
  {
    "codigo":236045005,
    "descripcion":"HERNIA LUMBAR INFERIOR"
  },
  {
    "codigo":6669004,
    "descripcion":"CISTATIONINEMIA"
  },
  {
    "codigo":4834000,
    "descripcion":"FIEBRE TIFOIDEA"
  },
  {
    "codigo":1055245009,
    "descripcion":"AMPLITUD AUMENTADA DE POTENCIALES EVOCADOS SOMATOSENSORIALES CORTICALES"
  },
  {
    "codigo":1217250003,
    "descripcion":"LINFEDEMA PRIMARIO CON COMPROMISO VISCERAL"
  },
  {
    "codigo":299746003,
    "descripcion":"REFLEJO PALMAR DE RESULTADO DUDOSO"
  },
  {
    "codigo":365282005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA VACIAR EL LAVABO"
  },
  {
    "codigo":234210006,
    "descripcion":"INFECCIÓN OCASIONADA POR ELECTRODO DE MARCAPASOS"
  },
  {
    "codigo":398050005,
    "descripcion":"DIVERTICULOSIS COLÓNICA"
  },
  {
    "codigo":266978008,
    "descripcion":"LICENCIA DE CONDUCIR RECHAZADA"
  },
  {
    "codigo":789431002,
    "descripcion":"SÍNDROME DE HORNER DEL LADO IZQUIERDO ADQUIRIDO"
  },
  {
    "codigo":232375005,
    "descripcion":"TABIQUE NASAL FRACTURADO"
  },
  {
    "codigo":197772000,
    "descripcion":"ABSCESO PERINÉFRICO Y RENAL"
  },
  {
    "codigo":2999009,
    "descripcion":"LESIÓN TRAUMÁTICA DEL OÍDO"
  },
  {
    "codigo":230540000,
    "descripcion":"NEUROPATÍA DEL TRIGÉMINO, IDIOPÁTICA"
  },
  {
    "codigo":165004000,
    "descripcion":"PRUEBA CUTÁNEA PARA ALERGIA POSITIVA"
  },
  {
    "codigo":363447008,
    "descripcion":"NEOPLASIA MALIGNA DE LABIOS MENORES VULVARES"
  },
  {
    "codigo":296076001,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE TRIAZOLAM"
  },
  {
    "codigo":10681671000119100,
    "descripcion":"MASA DE PIEL DE AMBAS MANOS"
  },
  {
    "codigo":722060007,
    "descripcion":"DISTROFIA MUSCULAR OCULOGASTROINTESTINAL"
  },
  {
    "codigo":32097002,
    "descripcion":"ENTERITIS NECRÓTICA"
  },
  {
    "codigo":15951021000119107,
    "descripcion":"MELANOMA MALIGNO DE PIEL DE AMBAS EXTREMIDADES INFERIORES"
  },
  {
    "codigo":194102001,
    "descripcion":"ESOTROPÍA ALTERNANTE INTERMITENTE"
  },
  {
    "codigo":423478005,
    "descripcion":"DIFICULTAD PARA MANEJAR LA MENOPAUSIA"
  },
  {
    "codigo":292406006,
    "descripcion":"REACCIÓN ADVERSA A LA OXIPERTINA"
  },
  {
    "codigo":95798008,
    "descripcion":"ALTERACIÓN DE LA COLORACIÓN ESCLERAL"
  },
  {
    "codigo":128566008,
    "descripcion":"CONFLUENCIA CONGÉNITA DE LAS VENAS PULMONARES"
  },
  {
    "codigo":126731002,
    "descripcion":"NEOPLASIA DEL ENDOCARDIO"
  },
  {
    "codigo":93963001,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE HUESO PISIFORME DE REGIÓN DE MUÑECA"
  },
  {
    "codigo":1306379008,
    "descripcion":"NEOPLASIA DE CUADRANTE INFERIOR EXTERNO DE MAMA"
  },
  {
    "codigo":92128003,
    "descripcion":"NEOPLASIA BENIGNA DE MANO"
  },
  {
    "codigo":288736005,
    "descripcion":"DIFICULTAD PARA RESPONDER A LA COMUNICACIÓN ESTABLECIDA POR OTROS"
  },
  {
    "codigo":419808006,
    "descripcion":"HALLAZGO RELACIONADO CON ASPECTOS DEL SEGURO MÉDICO"
  },
  {
    "codigo":12238151000119107,
    "descripcion":"INFARTO AGUDO DE MIOCARDIO DE PARED INFEROPOSTERIOR CON ELEVACIÓN DEL SEGMENTO ST"
  },
  {
    "codigo":712885003,
    "descripcion":"DISTENSIÓN DE MÚSCULO Y\/O TENDÓN DE BÍCEPS BRAQUIAL"
  },
  {
    "codigo":254133005,
    "descripcion":"PAQUIDERMOPERIOSTOSIS FAMILIAR"
  },
  {
    "codigo":1237173008,
    "descripcion":"ÚLCERA DE EXTREMIDAD INFERIOR DEBIDA A HIPERTENSIÓN ARTERIAL"
  },
  {
    "codigo":16006471000119109,
    "descripcion":"ARTRITIS INFECCIOSA DE ARTICULACIONES DE AMBAS MANOS CAUSADA POR VIRUS"
  },
  {
    "codigo":22922006,
    "descripcion":"INFECCIÓN CAUSADA POR PHYSALOPTERA"
  },
  {
    "codigo":88458008,
    "descripcion":"CRECIMIENTO BACTERIANO PRESENTE"
  },
  {
    "codigo":447071003,
    "descripcion":"CICATRIZ DE CARA"
  },
  {
    "codigo":283231003,
    "descripcion":"VIDRIO EN CABEZA"
  },
  {
    "codigo":11310561000119104,
    "descripcion":"FRACTURA NO EXPUESTA DE SEGUNDA VÉRTEBRA DORSAL"
  },
  {
    "codigo":414303007,
    "descripcion":"ENDOFTALMITIS MICÓTICA"
  },
  {
    "codigo":707380002,
    "descripcion":"CARCINOMA PRIMARIO DE TRÁQUEA, TIPO GLÁNDULA SALIVAL"
  },
  {
    "codigo":838452003,
    "descripcion":"INSUFICIENCIA MODERADA DE VÁLVULA MITRAL"
  },
  {
    "codigo":445236007,
    "descripcion":"SÍNDROME CARDIORRENAL"
  },
  {
    "codigo":84788008,
    "descripcion":"DEPRESIÓN MENOPÁUSICA"
  },
  {
    "codigo":1231668009,
    "descripcion":"LESIÓN TRAUMÁTICA DE ESFÍNTER PUPILAR POSTERIOR A PROCEDIMIENTO QUIRÚRGICO"
  },
  {
    "codigo":5601000119107,
    "descripcion":"LEUCOPLASIA DE MUCOSA BUCAL Y LENGUA"
  },
  {
    "codigo":306811000119101,
    "descripcion":"GOTA DE HOMBRO CAUSADA POR FÁRMACO"
  },
  {
    "codigo":17417006,
    "descripcion":"ENGROSAMIENTO DE LA PIEL"
  },
  {
    "codigo":771081007,
    "descripcion":"NEUROPATÍA MOTORA HEREDITARIA DISTAL TIPO 7"
  },
  {
    "codigo":142971000119102,
    "descripcion":"ENCEFALOPATÍA CAUSADA POR VIRUS INFLUENZA A SUBTIPO H1N1"
  },
  {
    "codigo":333281000119108,
    "descripcion":"OCLUSIÓN PARCIAL DE ARTERIA DE LA RETINA DERECHA"
  },
  {
    "codigo":310494004,
    "descripcion":"PESO AL NACER ENTRE 1,5 Y 2 KILOS"
  },
  {
    "codigo":15582005,
    "descripcion":"AUSENCIA CONGÉNITA DE LÓBULO DEL PULMÓN"
  },
  {
    "codigo":1162462009,
    "descripcion":"SÍNDROME DE ANGELMAN POR MONOSOMÍA MATERNA 15Q11Q13"
  },
  {
    "codigo":15918341000119100,
    "descripcion":"FRACTURA EXPUESTA DE CRESTA ALVEOLAR DE LADO DERECHO DEL MAXILAR SUPERIOR"
  },
  {
    "codigo":322821000119101,
    "descripcion":"LESIÓN TRAUMÁTICA DE REGIÓN DE COLUMNA VERTEBRAL LUMBAR"
  },
  {
    "codigo":15936261000119101,
    "descripcion":"REQUIERE SUPERVISIÓN CONTINUA"
  },
  {
    "codigo":15931141000119103,
    "descripcion":"QUISTE DE CUERPO LÚTEO DE OVARIO IZQUIERDO"
  },
  {
    "codigo":439731006,
    "descripcion":"TROMBOFLEBITIS SÉPTICA"
  },
  {
    "codigo":335621000119105,
    "descripcion":"NEOVASCULARIZACIÓN DE LA CÓRNEA DERECHA"
  },
  {
    "codigo":368901000119106,
    "descripcion":"SÍNDROME NEFRÍTICO CRÓNICO CONCOMITANTE CON GLOMERULONEFRITIS MEMBRANOPROLIFERATIVA TIPO III Y DEBIDO A ELLA"
  },
  {
    "codigo":10939141000119107,
    "descripcion":"HERIDA ABIERTA DE REGIÓN AXILAR DERECHA"
  },
  {
    "codigo":11853061000119108,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE PIEL DE LA FRENTE"
  },
  {
    "codigo":110216001,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO DEL PISO DE LA BOCA"
  },
  {
    "codigo":678661000119104,
    "descripcion":"CATARATA DE OJO DERECHO CAUSADA POR MEDICACIÓN"
  },
  {
    "codigo":302341000119106,
    "descripcion":"HIPEROSTOSIS ESQUELÉTICA IDIOPÁTICA DIFUSA DE COLUMNA VERTEBRAL LUMBOSACRA"
  },
  {
    "codigo":15954181000119105,
    "descripcion":"HEMATOMA DE MAMA IZQUIERDA"
  },
  {
    "codigo":161541000119104,
    "descripcion":"ESTADO PERIMENOPÁUSICO"
  },
  {
    "codigo":863880004,
    "descripcion":"CON BAJO RIESGO DE ÚLCERA DE PIE IZQUIERDO DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":673541000119109,
    "descripcion":"EXOSTOSIS DE PERONÉ"
  },
  {
    "codigo":403293003,
    "descripcion":"INCLUSIONES EPIDERMOIDES SUBUNGUEALES"
  },
  {
    "codigo":1156957002,
    "descripcion":"CON MAYOR RIESGO DE INGESTA ALIMENTARIA SUPERIOR A LA REQUERIDA"
  },
  {
    "codigo":763741001,
    "descripcion":"SÍNDROME DE DISCAPACIDAD INTELECTUAL, ALACRIMA Y ACALASIA"
  },
  {
    "codigo":304989006,
    "descripcion":"PERIODONTITIS CRÓNICA CON AMONTONAMIENTO DE DIENTES"
  },
  {
    "codigo":1220658004,
    "descripcion":"SÍNDROME DE DISCONTINUACIÓN DE RUXOLITINIB"
  },
  {
    "codigo":203015004,
    "descripcion":"MIOSITIS INFECCIOSA DE PELVIS"
  },
  {
    "codigo":792839005,
    "descripcion":"PULSO EN ARTERIA TIBIAL ANTERIOR DERECHA AUSENTE"
  },
  {
    "codigo":301319006,
    "descripcion":"MANO PRESENTE"
  },
  {
    "codigo":71943007,
    "descripcion":"TUBERCULOSIS GRANULOMATOSA CRÓNICA"
  },
  {
    "codigo":37340000,
    "descripcion":"ENFERMEDAD DE LA NEURONA MOTORA"
  },
  {
    "codigo":235783007,
    "descripcion":"FÍSTULA DE URÉTER HACIA EL COLON"
  },
  {
    "codigo":102876002,
    "descripcion":"MÚLTIPLES EMBARAZOS PREVIOS"
  },
  {
    "codigo":1216988003,
    "descripcion":"INFLAMACIÓN IDIOPÁTICA SUBAGUDA DE CONDUCTO UVEAL ANTERIOR"
  },
  {
    "codigo":233948000,
    "descripcion":"HIPERTENSIÓN PULMONAR POSARTERÍTICA"
  },
  {
    "codigo":299484005,
    "descripcion":"DEFORMIDAD DE ARTICULACIÓN DE PIE"
  },
  {
    "codigo":365020008,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD DE PRODUCIR SONIDOS SONOROS"
  },
  {
    "codigo":35505001,
    "descripcion":"AMPOLLA DEL CUELLO, SIN INFECCIÓN"
  },
  {
    "codigo":430556008,
    "descripcion":"NEOPLASIA MALIGNA DE ESTRUCTURA GENITAL"
  },
  {
    "codigo":335791000119101,
    "descripcion":"EDEMA DE CONJUNTIVA DE OJO DERECHO"
  },
  {
    "codigo":363185004,
    "descripcion":"TRASTORNO HEREDITARIO DEL TEGUMENTO"
  },
  {
    "codigo":232113004,
    "descripcion":"SÍNDROME DE RETRACCIÓN VERTICAL"
  },
  {
    "codigo":16746261000119108,
    "descripcion":"RETINOPATÍA NO PROLIFERATIVA MODERADA DE OJO DERECHO DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":230278002,
    "descripcion":"AFASIA PROGRESIVA"
  },
  {
    "codigo":721798004,
    "descripcion":"ASPERGILOSIS INVASIVA"
  },
  {
    "codigo":263046005,
    "descripcion":"SUBLUXACIÓN DEL CÓCCIX"
  },
  {
    "codigo":295814004,
    "descripcion":"SOBREDOSIS DE LEVODOPA"
  },
  {
    "codigo":293979003,
    "descripcion":"ALERGIA A OXPRENOLOL"
  },
  {
    "codigo":10657711000119104,
    "descripcion":"ÚLCERA NEUROPÁTICA DE TALÓN IZQUIERDO"
  },
  {
    "codigo":1073071000119104,
    "descripcion":"ARTRITIS DE HOMBRO IZQUIERDO CAUSADA POR STREPTOCOCCUS"
  },
  {
    "codigo":195675009,
    "descripcion":"AQUINESIA CARDÍACA"
  },
  {
    "codigo":228443009,
    "descripcion":"COMPRA DROGAS"
  },
  {
    "codigo":292144005,
    "descripcion":"REACCIÓN ADVERSA AL SEN"
  },
  {
    "codigo":95536006,
    "descripcion":"GANGRENA ILEAL"
  },
  {
    "codigo":718128009,
    "descripcion":"DISPLASIA CONGÉNITA DE VÁLVULA CARDÍACA"
  },
  {
    "codigo":290309005,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ÁCIDO TIAPROFÉNICO"
  },
  {
    "codigo":1142277007,
    "descripcion":"HIPERTROFIA CONGÉNITA SOLITARIA DE EPITELIO PIGMENTARIO RETINIANO"
  },
  {
    "codigo":26330000,
    "descripcion":"CELULITIS DEL PERINEO"
  },
  {
    "codigo":93701008,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE VASO SANGUÍNEO DE LA REGIÓN INGUINAL"
  },
  {
    "codigo":1304282003,
    "descripcion":"GLAUCOMA HEMOLÍTICO BILATERAL"
  },
  {
    "codigo":91866004,
    "descripcion":"ADHERENCIAS DE LA ARTICULACIÓN TEMPOROMANDIBULAR"
  },
  {
    "codigo":124634003,
    "descripcion":"DEFICIENCIA DE LACTOILGLUTATIÓN LIASA"
  },
  {
    "codigo":386778006,
    "descripcion":"11 - DESOXI, 17 - HIDROXICORTICOSTERONA ANORMAL"
  },
  {
    "codigo":252036000,
    "descripcion":"INSUFICIENCIA ARTERIAL DE PENE"
  },
  {
    "codigo":88196000,
    "descripcion":"FRACTURA DE LA PARTE INTERLIGAMENTARIA DE LA CLAVÍCULA"
  },
  {
    "codigo":284804003,
    "descripcion":"INCAPAZ DE BAÑARSE"
  },
  {
    "codigo":448644004,
    "descripcion":"ANOMALÍA DE VENA CAVA INFERIOR DERECHA"
  },
  {
    "codigo":20825002,
    "descripcion":"HIPOGLUCEMIA CETÓSICA"
  },
  {
    "codigo":1003865004,
    "descripcion":"DUPLICACIÓN DE PORCIÓN PROXIMAL DEL BRAZO LARGO DEL CROMOSOMA 6"
  },
  {
    "codigo":414041006,
    "descripcion":"NO TIENE CUIDADOR"
  },
  {
    "codigo":11778121000119108,
    "descripcion":"RUPTURA TRAUMÁTICA DE MANGUITO ROTADOR DE HOMBRO DERECHO"
  },
  {
    "codigo":53593008,
    "descripcion":"FOLICULITIS DECALVANTE"
  },
  {
    "codigo":282969008,
    "descripcion":"DIFICULTAD PARA SENTARSE"
  },
  {
    "codigo":1264174002,
    "descripcion":"TATUAJE DE PIEL DE MEJILLA DERECHA"
  },
  {
    "codigo":15710281000119108,
    "descripcion":"ARTERIOSCLEROSIS DE INJERTO-PUENTE AUTÓLOGO DE EXTREMIDAD INFERIOR DERECHA"
  },
  {
    "codigo":971608291000119105,
    "descripcion":"ÚLCERA VENOSA DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":80856001,
    "descripcion":"EMBARAZOS PREVIOS: 8"
  },
  {
    "codigo":17155009,
    "descripcion":"TRICOTILOMANÍA"
  },
  {
    "codigo":49923008,
    "descripcion":"SÍFILIS DE TENDÓN"
  },
  {
    "codigo":338301000119100,
    "descripcion":"ASTIGMATISMO REGULAR DEL OJO IZQUIERDO"
  },
  {
    "codigo":48088006,
    "descripcion":"INTOXICACIÓN POR HIDROCARBURO CLORADO"
  },
  {
    "codigo":898221000,
    "descripcion":"FUSIÓN ANORMAL CONGÉNITA DE PRIMER HUESO METATARSIANO"
  },
  {
    "codigo":439469002,
    "descripcion":"DOLOR ABDOMINAL RECURRENTE"
  },
  {
    "codigo":210093002,
    "descripcion":"LESIÓN EXPUESTA DE BRONQUIO"
  },
  {
    "codigo":46253008,
    "descripcion":"TROMBOFLEBITIS DE EXTREMIDADES INFERIORES"
  },
  {
    "codigo":77186001,
    "descripcion":"INTENTO FALLIDO DE ABORTO CON NECROSIS TUBULAR RENAL"
  },
  {
    "codigo":111789008,
    "descripcion":"INTOXICACIÓN POR MESEMBRYANTHEMUM"
  },
  {
    "codigo":699778003,
    "descripcion":"DESVIACIÓN DE LA LÍNEA MEDIA MANDIBULAR HACIA LA IZQUIERDA"
  },
  {
    "codigo":372098004,
    "descripcion":"CARCINOMA DE ENDOCÉRVIX"
  },
  {
    "codigo":239191000,
    "descripcion":"CICATRIZACIÓN HIPERTRÓFICA DE SITIO DONANTE DE PIEL"
  },
  {
    "codigo":109954009,
    "descripcion":"EFECTOS DE LA INMUNOTERAPIA"
  },
  {
    "codigo":9815002,
    "descripcion":"DIVERTICULOSIS DEL ÍLEON SIN DIVERTICULITIS"
  },
  {
    "codigo":206423004,
    "descripcion":"HEMATEMESIS NEONATAL"
  },
  {
    "codigo":403031005,
    "descripcion":"TIÑA CORPORAL CAUSADA POR NANNIZZIA FULVUM"
  },
  {
    "codigo":271959005,
    "descripcion":"ENFERMEDAD DIVERTICULAR SIMPLE DE INTESTINO GRUESO"
  },
  {
    "codigo":763479005,
    "descripcion":"CARCINOMA METAPLÁSICO DE MAMA"
  },
  {
    "codigo":1187628000,
    "descripcion":"VASCULOPATÍA LIVEDOIDE DE EXTREMIDAD INFERIOR POR VÁRICES VENOSAS"
  },
  {
    "codigo":827180003,
    "descripcion":"PIEL ABDOMINAL SECA"
  },
  {
    "codigo":301057000,
    "descripcion":"POSICIÓN DEL NIÑO EN RELACIÓN AL ADULTO"
  },
  {
    "codigo":366593003,
    "descripcion":"AMPLITUD DE LA ROTACIÓN INTERNA DE LA RODILLA - HALLAZGO"
  },
  {
    "codigo":202753007,
    "descripcion":"DESGARRO ANULAR DE DISCO LUMBAR"
  },
  {
    "codigo":16040471000119102,
    "descripcion":"ARTRITIS IDIOPÁTICA JUVENIL DE INICIO SISTÉMICO DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":169985007,
    "descripcion":"AMAMANTADO A LOS 6 MESES"
  },
  {
    "codigo":397526004,
    "descripcion":"CAPA DE LÍPIDOS DE LAS LÁGRIMAS"
  },
  {
    "codigo":364758005,
    "descripcion":"RITMO CARDÍACO FETAL - HALLAZGO"
  },
  {
    "codigo":102614006,
    "descripcion":"DOLOR ABDOMINAL GENERALIZADO"
  },
  {
    "codigo":299222009,
    "descripcion":"PIERNA LARGA"
  },
  {
    "codigo":231851003,
    "descripcion":"HERIDA PENETRANTE DE ÓRBITA"
  },
  {
    "codigo":788907005,
    "descripcion":"TRASTORNO DISOCIATIVO CON SÍNTOMA NEUROLÓGICO CONCOMITANTE CON COREA"
  },
  {
    "codigo":428459007,
    "descripcion":"ESTRABISMO RESTRICTIVO"
  },
  {
    "codigo":262784001,
    "descripcion":"CONTUSIÓN PULMONAR"
  },
  {
    "codigo":166315009,
    "descripcion":"ANÁLISIS BIOQUÍMICO SANGUÍNEO NORMAL"
  },
  {
    "codigo":640003,
    "descripcion":"LESIÓN TRAUMÁTICA DEL NERVIO VAGO"
  },
  {
    "codigo":230016001,
    "descripcion":"POSICIÓN DEL TRONCO: BOCA ABAJO"
  },
  {
    "codigo":66176005,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE CARA SIN INFECCIÓN"
  },
  {
    "codigo":197248006,
    "descripcion":"FÍSTULA ILEOUMBILICAL"
  },
  {
    "codigo":295552007,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE BUPIVACAÍNA"
  },
  {
    "codigo":293717000,
    "descripcion":"ALERGIA A DESFLURANO"
  },
  {
    "codigo":291882001,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR VASOPRESINA"
  },
  {
    "codigo":160810002,
    "descripcion":"ACUSACIÓN DE DELITO"
  },
  {
    "codigo":12245681000119103,
    "descripcion":"RETENCIÓN URINARIA POSTERIOR A PROCEDIMIENTO"
  },
  {
    "codigo":717866008,
    "descripcion":"MALFORMACIÓN ARTERIOVENOSA DE ESTÓMAGO"
  },
  {
    "codigo":128042009,
    "descripcion":"ENFERMEDAD PAPULONODULAR DE LA PIEL"
  },
  {
    "codigo":29738008,
    "descripcion":"PROTEINURIA"
  },
  {
    "codigo":93439004,
    "descripcion":"OSIFICACIÓN DE CENTRO DE VÉRTEBRA SACRA CON FORMA DE MANCUERNA"
  },
  {
    "codigo":27903005,
    "descripcion":"INTOXICACIÓN POR HELIOTROPIUM EUROPAEUM"
  },
  {
    "codigo":60671007,
    "descripcion":"INTOXICACIÓN POR PASPALUM COMMERSONII"
  },
  {
    "codigo":91604001,
    "descripcion":"MIOCARDIOPATÍA DILATADA DEBIDA A POLIARTERITIS NODOSA"
  },
  {
    "codigo":419284004,
    "descripcion":"ESTADO MENTAL ALTERADO"
  },
  {
    "codigo":1172948006,
    "descripcion":"PARACETAMOL DENTRO DEL LÍMITE TERAPÉUTICO"
  },
  {
    "codigo":188073001,
    "descripcion":"MELANOMA MALIGNO DE TOBILLO"
  },
  {
    "codigo":26068009,
    "descripcion":"IMPACTO DE MUCOSIDAD EN LOS BRONQUIOS"
  },
  {
    "codigo":55166000,
    "descripcion":"OSTEOARTROPATÍA FAMILIAR DE DEDOS DE MANO"
  },
  {
    "codigo":840499006,
    "descripcion":"RUPTURA DE HÍGADO DEBIDA A INFECCIÓN POR ECHINOCOCCUS GRANULOSUS"
  },
  {
    "codigo":251774002,
    "descripcion":"DESVIACIÓN DEL EJE ÓPTICO SE CONVIERTE EN BINOCULAR"
  },
  {
    "codigo":253609009,
    "descripcion":"NÚMERO ANORMAL DE VALVAS AÓRTICAS"
  },
  {
    "codigo":282707003,
    "descripcion":"INHIBIDOR DE LA COAGULACIÓN ADQUIRIDO"
  },
  {
    "codigo":249939004,
    "descripcion":"DEBILIDAD DE MÚSCULOS PROXIMALES"
  },
  {
    "codigo":315475006,
    "descripcion":"NACIDO EN MALI"
  },
  {
    "codigo":444712000,
    "descripcion":"CARCINOMA MUCINOSO DE MAMA"
  },
  {
    "codigo":870696002,
    "descripcion":"RANGO DE FRECUENCIA CARDÍACA FETAL BASAL MAYOR DE 200"
  },
  {
    "codigo":1263912003,
    "descripcion":"CARCINOMA EX ADENOMA PLEOMORFO DE GLÁNDULA LAGRIMAL METASTÁSICO"
  },
  {
    "codigo":84264005,
    "descripcion":"DEFICIENCIA DE CARNITINA MUSCULAR"
  },
  {
    "codigo":340811000119106,
    "descripcion":"HEMORRAGIA EXPULSIVA DE COROIDES DE OJO IZQUIERDO"
  },
  {
    "codigo":51496009,
    "descripcion":"PÉRDIDA DE SANGRE FETAL POR RUPTURA DEL CORDÓN UMBILICAL"
  },
  {
    "codigo":1078091000119107,
    "descripcion":"OSTEOCONDRITIS DISECANTE DE PIE DERECHO"
  },
  {
    "codigo":705021008,
    "descripcion":"DIFICULTAD EN EL MANEJO DEL RÉGIMEN DEL EJERCICIO"
  },
  {
    "codigo":279037009,
    "descripcion":"DISFUNCIÓN DE SEGMENTO DORSAL"
  },
  {
    "codigo":703186004,
    "descripcion":"ESTENOSIS DE NEOVÁLVULA PULMONAR"
  },
  {
    "codigo":275367000,
    "descripcion":"HIPOXIA INTRAUTERINA"
  },
  {
    "codigo":441042008,
    "descripcion":"ELEVACIÓN HEREDITARIA DE FACTOR VIII"
  },
  {
    "codigo":308135003,
    "descripcion":"VENAS GENITALES VARICOSAS EN EL PUERPERIO"
  },
  {
    "codigo":111527005,
    "descripcion":"ATROFIA ÓPTICA PARCIAL"
  },
  {
    "codigo":45991007,
    "descripcion":"PÉRDIDA DE LA CAPACIDAD DE SENTIR EMOCIONES"
  },
  {
    "codigo":699516005,
    "descripcion":"RETINITIS FOCAL YUXTAPAPILAR"
  },
  {
    "codigo":109692008,
    "descripcion":"OSTEOMIELITIS MAXILAR"
  },
  {
    "codigo":238929002,
    "descripcion":"DEDOS FRÍOS FLEXIONADOS"
  },
  {
    "codigo":206161005,
    "descripcion":"TRASTORNO DEBIDO A CRECIMIENTO FETAL LENTO, PESO DE NACIMIENTO BAJO Y\/O ELEVADO"
  },
  {
    "codigo":271697007,
    "descripcion":"IRRITABILIDAD MUSCULAR"
  },
  {
    "codigo":1254737008,
    "descripcion":"TIENE CONTACTO CON LACTANTE"
  },
  {
    "codigo":106022001,
    "descripcion":"PATRÓN COGNITIVO-PERCEPTUAL - HALLAZGO"
  },
  {
    "codigo":7718000,
    "descripcion":"IRA"
  },
  {
    "codigo":1287505008,
    "descripcion":"ABRASIÓN DE PIEL DE TRONCO"
  },
  {
    "codigo":16016511000119102,
    "descripcion":"RUPTURA DEGENERATIVA DE MENISCOS EXTERNOS DE AMBAS RODILLAS"
  },
  {
    "codigo":237094001,
    "descripcion":"VULVOVAGINITIS ESTREPTOCÓCICA"
  },
  {
    "codigo":71419002,
    "descripcion":"VÓMITO BILIOSO"
  },
  {
    "codigo":11838591000119104,
    "descripcion":"LACERACIÓN DE MÚSCULO INTRÍNSECO DE MANO DERECHA"
  },
  {
    "codigo":366331004,
    "descripcion":"HALLAZGO RELACIONADO CON EL REFLEJO GLABELAR"
  },
  {
    "codigo":167888000,
    "descripcion":"VISCOSIDAD DE LÍQUIDO SINOVIAL, ALTA"
  },
  {
    "codigo":38651009,
    "descripcion":"MOMIFICACIÓN FETAL"
  },
  {
    "codigo":202491008,
    "descripcion":"DOLOR DE ARTICULACIÓN SUBASTRAGALINA"
  },
  {
    "codigo":300795009,
    "descripcion":"NO MANEJA NI EMPUJA UN JUGUETE"
  },
  {
    "codigo":200656004,
    "descripcion":"CELULITIS Y ABSCESO DE LA PARED TORÁCICA"
  },
  {
    "codigo":298960004,
    "descripcion":"AMPLITUD DE EXTENSIÓN ACTIVA DE LA MUÑECA NORMAL"
  },
  {
    "codigo":724944007,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO FLEXOR DE PULGAR A LA ALTURA DEL ANTEBRAZO"
  },
  {
    "codigo":2213002,
    "descripcion":"ANOMALÍA CONGÉNITA DE LA VENA CAVA"
  },
  {
    "codigo":460965004,
    "descripcion":"ORIGEN ANÓMALO DE LIGAMENTO ARTERIOSO EN ARTERIA CARÓTIDA DERECHA"
  },
  {
    "codigo":34981006,
    "descripcion":"DISFUNCIÓN UTERINA HIPERTÓNICA"
  },
  {
    "codigo":1149093006,
    "descripcion":"NEUMONÍA CAUSADA POR ENTEROCOCO RESISTENTE A VANCOMICINA"
  },
  {
    "codigo":343321000119102,
    "descripcion":"QUERATITIS SUPERFICIAL BILATERAL"
  },
  {
    "codigo":262522002,
    "descripcion":"LESIÓN DE COLUMNA CERVICAL"
  },
  {
    "codigo":1080601000119103,
    "descripcion":"LEIOMIOSARCOMA PRIMARIO DE CADERA DERECHA"
  },
  {
    "codigo":721274005,
    "descripcion":"INFECCIÓN CONGÉNITA CAUSADA POR ECHOVIRUS"
  },
  {
    "codigo":378007,
    "descripcion":"SÍNDROME DE MORQUIO"
  },
  {
    "codigo":129615000,
    "descripcion":"SÍNDROME DE TAPIA"
  },
  {
    "codigo":162383006,
    "descripcion":"NARIZ TUMEFACTA"
  },
  {
    "codigo":31311006,
    "descripcion":"INTOXICACIÓN POR LINO USITATISSIUM"
  },
  {
    "codigo":424527009,
    "descripcion":"DIFICULTAD PARA VER OBJETOS CERCANOS"
  },
  {
    "codigo":293455009,
    "descripcion":"REACCIÓN ADVERSA A LA BENDROFLUAZIDA"
  },
  {
    "codigo":783140003,
    "descripcion":"SÍNDROME DE DISPLASIA PÉLVICA Y ARTROGRIPOSIS DE MIEMBROS INFERIORES"
  },
  {
    "codigo":95012001,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA PARED POSTERIOR DE LA VEJIGA"
  },
  {
    "codigo":1340196008,
    "descripcion":"DISFUNCIÓN SEXUAL PERSISTENTE POSTERIOR A ABSTINENCIA DE INHIBIDOR DE LA RECAPTACIÓN DE SEROTONINA"
  },
  {
    "codigo":226084008,
    "descripcion":"DIETA A BASE DE PÉPTIDOS"
  },
  {
    "codigo":1010681001,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE LOCALIZACIONES SUPERPUESTAS DE NASOFARINGE"
  },
  {
    "codigo":291620009,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR CEFTRIAXONA"
  },
  {
    "codigo":289785007,
    "descripcion":"CUELLO UTERINO CENTRALIZÁNDOSE"
  },
  {
    "codigo":1172686000,
    "descripcion":"DERMATITIS POR CONTACTO CON PROTEÍNA"
  },
  {
    "codigo":715769008,
    "descripcion":"RETRACCIÓN ANORMAL CONGÉNITA DE PÁRPADO"
  },
  {
    "codigo":124110007,
    "descripcion":"DEFICIENCIA DE UDP GLUCOSA DESHIDROGENASA"
  },
  {
    "codigo":58574008,
    "descripcion":"NEFROPATÍA AGUDA"
  },
  {
    "codigo":89507002,
    "descripcion":"EFECTO TÓXICO DEL ALCOHOL DESTILADO"
  },
  {
    "codigo":16782771000119104,
    "descripcion":"MELANOMA IN SITU DE REGIÓN TEMPORAL"
  },
  {
    "codigo":23971007,
    "descripcion":"VÓMITO AGUDO"
  },
  {
    "codigo":448120000,
    "descripcion":"TRONCO ARTERIAL COMÚN CON ARTERIAS PULMONARES CRUZADAS"
  },
  {
    "codigo":286115008,
    "descripcion":"DIFICULTAD PARA LIMPIAR EL POLVO"
  },
  {
    "codigo":253347007,
    "descripcion":"ANEURISMA DE APÉNDICE AURICULAR DERECHO"
  },
  {
    "codigo":284280003,
    "descripcion":"DIFICULTAD PARA EMPLEAR AGARRE CON TRES DEDOS"
  },
  {
    "codigo":415352004,
    "descripcion":"ARTROPATÍA POR DESGARRO DEL MANGUITO ROTADOR"
  },
  {
    "codigo":187811009,
    "descripcion":"NEOPLASIA MALIGNA DEL MESORRECTO"
  },
  {
    "codigo":251512008,
    "descripcion":"ASIMETRÍA GENERALIZADA EN LA FRECUENCIA DEL ELECTROENCEFALOGRAMA"
  },
  {
    "codigo":118605002,
    "descripcion":"LINFOMA DE HODGKIN, CON PREDOMINIO LINFÁTICO NODULAR"
  },
  {
    "codigo":20301004,
    "descripcion":"DISFASIA"
  },
  {
    "codigo":772130002,
    "descripcion":"SÍNDROME DE PREDISPOSICIÓN A TUMORES RABDOIDES"
  },
  {
    "codigo":84002002,
    "descripcion":"PEDOFILIA"
  },
  {
    "codigo":247842002,
    "descripcion":"MIEDO A HABLARLE A AUTORIDADES"
  },
  {
    "codigo":1263650006,
    "descripcion":"DEDO EN GATILLO CONGÉNITO"
  },
  {
    "codigo":311543001,
    "descripcion":"DIFICULTAD PARA PROCESAR INFORMACIÓN A VELOCIDAD NORMAL"
  },
  {
    "codigo":82167006,
    "descripcion":"QUISTE EXUDATIVO EN LA CÁMARA ANTERIOR"
  },
  {
    "codigo":16631009,
    "descripcion":"SÍNDROME DE MIELOPATÍA TRANSVERSA"
  },
  {
    "codigo":301544004,
    "descripcion":"CAPAZ DE LLEGAR HASTA EL INODORO"
  },
  {
    "codigo":111265002,
    "descripcion":"LORDOSIS POSQUIRÚRGICA"
  },
  {
    "codigo":373409004,
    "descripcion":"TRASTORNO INFLAMATORIO DEL MEDIASTINO"
  },
  {
    "codigo":43894001,
    "descripcion":"ACTINOMICOSIS ABDOMINAL"
  },
  {
    "codigo":240502001,
    "descripcion":"FIEBRE POR MAGUARI"
  },
  {
    "codigo":109430007,
    "descripcion":"DEFECTO MUSCULAR MÚLTIPLE DEL TABIQUE VENTRICULAR"
  },
  {
    "codigo":9291000,
    "descripcion":"INTOXICACIÓN POR INHIBIDOR DE LA MONOAMINO OXIDASA"
  },
  {
    "codigo":699254009,
    "descripcion":"MICRODELECIÓN CROMOSÓMICA 15Q13.3"
  },
  {
    "codigo":238667001,
    "descripcion":"LIQUEN PLANO EROSIVO DE LOS LABIOS"
  },
  {
    "codigo":369739003,
    "descripcion":"VASOS VENOSOS EXTRATUMORALES, SIN COMPROMISO TUMORAL"
  },
  {
    "codigo":42059000,
    "descripcion":"DESPRENDIMIENTO DE RETINA"
  },
  {
    "codigo":402507001,
    "descripcion":"CARCINOMA BASOCELULAR DE MEJILLA"
  },
  {
    "codigo":7456000,
    "descripcion":"ENVENENAMIENTO DEBIDO A PICADURA DE AVISPA"
  },
  {
    "codigo":673511000119105,
    "descripcion":"EXOSTOSIS DE MANO"
  },
  {
    "codigo":72992003,
    "descripcion":"ESCOLIOSIS TORACÓGENA"
  },
  {
    "codigo":345831000119106,
    "descripcion":"HEMORRAGIA DE VAINAS DE AMBOS NERVIOS ÓPTICOS"
  },
  {
    "codigo":15992551000119106,
    "descripcion":"QUERATITIS INTERSTICIAL DE AMBOS OJOS CAUSADA POR VIRUS HERPES SIMPLE"
  },
  {
    "codigo":202229000,
    "descripcion":"SUBLUXACIÓN RECURRENTE DE ARTICULACIÓN RADIOCUBITAL DISTAL"
  },
  {
    "codigo":300533001,
    "descripcion":"PRÓSTATA TUMEFACTA"
  },
  {
    "codigo":234997004,
    "descripcion":"ENFERMEDAD GRANULOMATOSA GINGIVAL CRÓNICA"
  },
  {
    "codigo":366069004,
    "descripcion":"DESVIACIÓN DEL EJE ÓPTICO - HALLAZGO"
  },
  {
    "codigo":890357007,
    "descripcion":"POLIDACTILIA POSTAXIAL TIPO B BILATERAL DE MEÑIQUE"
  },
  {
    "codigo":69322001,
    "descripcion":"TRASTORNO PSICÓTICO"
  },
  {
    "codigo":724682002,
    "descripcion":"TRASTORNO DEL ESTADO DE ÁNIMO CON SÍNTOMAS MIXTOS DEPRESIVOS Y MANÍACOS CAUSADO POR SEDANTE"
  },
  {
    "codigo":36554003,
    "descripcion":"INTOXICACIÓN CRÓNICA POR SELENIO"
  },
  {
    "codigo":169461009,
    "descripcion":"NUEVA TOMA DE ANTICONCEPTIVO ORAL"
  },
  {
    "codigo":319361000119103,
    "descripcion":"LUXACIÓN RECURRENTE DE ARTICULACIÓN DE MANO DERECHA"
  },
  {
    "codigo":298698001,
    "descripcion":"PRUEBA DE COMPRESIÓN CEFÁLICA, POSITIVA"
  },
  {
    "codigo":722847000,
    "descripcion":"PSEUDOBSTRUCCIÓN INTESTINAL CRÓNICA SECUNDARIA"
  },
  {
    "codigo":296863006,
    "descripcion":"SOBREDOSIS DE GLIBENCLAMIDA"
  },
  {
    "codigo":165791007,
    "descripcion":"ANTICUERPO ANTIRRUBEÓLICO NO DETECTADO"
  },
  {
    "codigo":427935006,
    "descripcion":"ALIVIO DEL DOLOR MEDIANTE REPOSO"
  },
  {
    "codigo":1343604001,
    "descripcion":"ARTROSIS DE COLUMNA VERTEBRAL CERVICAL"
  },
  {
    "codigo":15720321000119106,
    "descripcion":"TRASTORNO DE CARTÍLAGO ARTICULAR DE MANO DERECHA"
  },
  {
    "codigo":11788161000119106,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DE DEDO MEÑIQUE IZQUIERDO"
  },
  {
    "codigo":293193006,
    "descripcion":"REACCIÓN ADVERSA A LA CLORPROPAMIDA"
  },
  {
    "codigo":1208862000,
    "descripcion":"POLIOSIS DE PESTAÑA ADQUIRIDA"
  },
  {
    "codigo":782878007,
    "descripcion":"DISPLASIA UNGUEAL AUTOSÓMICA RECESIVA"
  },
  {
    "codigo":289523000,
    "descripcion":"CICATRIZ VAGINAL"
  },
  {
    "codigo":27379001,
    "descripcion":"INADAPTACIÓN SEXUAL"
  },
  {
    "codigo":292891000119104,
    "descripcion":"GRANULOMA INTRACRANEAL"
  },
  {
    "codigo":846579005,
    "descripcion":"ANGIOEDEMA DE LABIO"
  },
  {
    "codigo":92915006,
    "descripcion":"FORMA ANORMAL CONGÉNITA DE HÚMERO"
  },
  {
    "codigo":715507005,
    "descripcion":"INFECCIÓN DEL SISTEMA NERVIOSO CENTRAL CAUSADA POR BORRELIA BURGDORFERI"
  },
  {
    "codigo":1303496000,
    "descripcion":"ATRESIA CONGÉNITA DE FOSA NASAL IZQUIERDA"
  },
  {
    "codigo":25544003,
    "descripcion":"INSUFICIENCIA CARDÍACA CON BAJO GASTO CARDÍACO"
  },
  {
    "codigo":254920003,
    "descripcion":"CISTOADENOMA DE RIÑÓN"
  },
  {
    "codigo":1085621000119101,
    "descripcion":"EDENTULISMO COMPLETO DE CLASE IV DEBIDO A TRAUMATISMO"
  },
  {
    "codigo":416925005,
    "descripcion":"INFECCIÓN POR VIRUS DE LA ENCEFALITIS EQUINA DEL ESTE"
  },
  {
    "codigo":285853005,
    "descripcion":"ADAPTACIÓN EMOCIONAL MADURA"
  },
  {
    "codigo":413255001,
    "descripcion":"PANCREAS DIVISUM - COMPLETO"
  },
  {
    "codigo":710002009,
    "descripcion":"DENTICIÓN FALTANTE POR NÚMERO DE DIENTE"
  },
  {
    "codigo":20039003,
    "descripcion":"DESTRUCCIÓN DE ERITROCITOS AUMENTADA"
  },
  {
    "codigo":249415004,
    "descripcion":"SECRECIÓN DE LAS ENCÍAS"
  },
  {
    "codigo":314951005,
    "descripcion":"RECIDIVA LOCAL DE NEOPLASIA MALIGNA DE LENGUA"
  },
  {
    "codigo":15749301000119105,
    "descripcion":"INESTABILIDAD DE AMBAS ARTICULACIONES SACROILÍACAS"
  },
  {
    "codigo":282183009,
    "descripcion":"DIFICULTAD PARA SUBIR UN ESCALÓN"
  },
  {
    "codigo":1359857001,
    "descripcion":"CARCINOMA PRIMARIO DE BERMELLÓN DE LABIO INFERIOR"
  },
  {
    "codigo":704497002,
    "descripcion":"UTILIZA INTÉRPRETE DE LENGUAJE DE SEÑAS BRITÁNICO"
  },
  {
    "codigo":737265006,
    "descripcion":"ANOMALÍA DEL DESARROLLO DE TEJIDO PERIODONTAL"
  },
  {
    "codigo":1259718002,
    "descripcion":"MESOTELIOMA PRIMARIO MALIGNO DE MESENTERIO"
  },
  {
    "codigo":735430007,
    "descripcion":"RIÑÓN CONTRAÍDO IRREGULARMENTE"
  },
  {
    "codigo":14534009,
    "descripcion":"TROMBOSIS DE LA VENA ESPLÉNICA"
  },
  {
    "codigo":111003001,
    "descripcion":"GOMA ESPOROTRICÓTICO"
  },
  {
    "codigo":209307001,
    "descripcion":"FRACTURA-LUXACIÓN NO EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA PROXIMAL"
  },
  {
    "codigo":274843005,
    "descripcion":"HALLAZGOS INMUNOLÓGICOS ANORMALES EN LÍQUIDO CEFALORRAQUÍDEO"
  },
  {
    "codigo":305776000,
    "descripcion":"ATENDIDO POR TERAPEUTA OCUPACIONAL HOSPITALARIO"
  },
  {
    "codigo":240240002,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE ARTICULACIÓN DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":1256048006,
    "descripcion":"ALOPECIA CICATRICIAL DE CUERO CABELLUDO DEBIDA A NEOPLASIA MALIGNA DE PIEL"
  },
  {
    "codigo":371312007,
    "descripcion":"ACTINOBACILOSIS CAUSADA POR ACTINOBACILLUS EQUULI"
  },
  {
    "codigo":404080006,
    "descripcion":"CONDROSARCOMA MESENQUIMATOSO EXTRAESQUELÉTICO"
  },
  {
    "codigo":402245001,
    "descripcion":"SÍNDROME DE LA PIEL EXCITADA"
  },
  {
    "codigo":238405002,
    "descripcion":"ADENITIS CERVICAL AGUDA"
  },
  {
    "codigo":762693003,
    "descripcion":"ECTIMA CAUSADO POR STREPTOCOCCUS PYOGENES"
  },
  {
    "codigo":41797007,
    "descripcion":"DEFICIENCIA DE 5, 10 - METILENTETRAHIDROFOLATO REDUCTASA"
  },
  {
    "codigo":1186842003,
    "descripcion":"MIELOPATÍA POR VENENO DE SERPIENTE"
  },
  {
    "codigo":236570004,
    "descripcion":"RECHAZO DEL TRASPLANTE RENAL"
  },
  {
    "codigo":105498005,
    "descripcion":"RENUNCIA VOLUNTARIA"
  },
  {
    "codigo":7194005,
    "descripcion":"PARAQUERATOSIS ESCUTULAR"
  },
  {
    "codigo":1285146007,
    "descripcion":"RESPIRACIÓN COSTODIAFRAGMÁTICA"
  },
  {
    "codigo":398575000,
    "descripcion":"TULAREMIA OROFARÍNGEA"
  },
  {
    "codigo":890095006,
    "descripcion":"FRACTURA ATÍPICA DE FÉMUR"
  },
  {
    "codigo":300271008,
    "descripcion":"HALLAZGO RELACIONADO CON EL ASPECTO DE LA FARINGE"
  },
  {
    "codigo":201967009,
    "descripcion":"ARTRITIS ALÉRGICA DE LA MANO"
  },
  {
    "codigo":472755009,
    "descripcion":"OCLUSIÓN DE VENA CAVA INFERIOR DEBIDA A NEOPLASIA"
  },
  {
    "codigo":36292003,
    "descripcion":"OTITIS EXTERNA CAUSADA POR HERPES ZÓSTER"
  },
  {
    "codigo":365807009,
    "descripcion":"HALLAZGO DE PROTEÍNA SÉRICA O PLASMÁTICA"
  },
  {
    "codigo":131561000119106,
    "descripcion":"STENT METÁLICO SIN CUBIERTA EN RAMA DE ARTERIA CORONARIA DERECHA"
  },
  {
    "codigo":298436007,
    "descripcion":"AMPLITUD DE FLEXIÓN LATERAL PASIVA HACIA LA DERECHA DE LA COLUMNA VERTEBRAL CERVICAL, DISMINUIDA"
  },
  {
    "codigo":1148569003,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR ANFETAMINA Y\/O DERIVADO DE ANFETAMINA"
  },
  {
    "codigo":198297004,
    "descripcion":"CISTOMA OVÁRICO SIMPLE"
  },
  {
    "codigo":296601008,
    "descripcion":"SOBREDOSIS DE TOBRAMICINA"
  },
  {
    "codigo":722585009,
    "descripcion":"POLICITEMIA NEONATAL DEBIDA A TRASTORNO HEREDITARIO DE LA PRODUCCIÓN DE ERITROPOYETINA"
  },
  {
    "codigo":720750004,
    "descripcion":"SÍNDROME DE DEGENERACIÓN ESPINOCEREBELOSA Y DISTROFIA CORNEAL"
  },
  {
    "codigo":65390006,
    "descripcion":"PERFORACIÓN INTESTINAL PERINATAL"
  },
  {
    "codigo":1179502006,
    "descripcion":"HALLAZGO RELACIONADO CON EL NIVEL DE AMINOÁCIDOS"
  },
  {
    "codigo":1144899009,
    "descripcion":"NEFRITIS TUBULOINTERSTICIAL CRÓNICA DEBIDA A ENFERMEDAD NEOPLÁSICA"
  },
  {
    "codigo":192792002,
    "descripcion":"DEGENERACIÓN CEREBRAL EN LA ENFERMEDAD DE NIEMANN-PICK"
  },
  {
    "codigo":127256003,
    "descripcion":"NEOPLASIA DE LOS GANGLIOS LINFÁTICOS AXILARES LATERALES"
  },
  {
    "codigo":94488007,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA FARINGE"
  },
  {
    "codigo":28952007,
    "descripcion":"INFECCIÓN CAUSADA POR CYSTICERCUS OVIS"
  },
  {
    "codigo":289261003,
    "descripcion":"PROBLEMA DEL PARTO"
  },
  {
    "codigo":92653004,
    "descripcion":"CARCINOMA IN SITU DE LOS ÓRGANOS GENITALES MASCULINOS"
  },
  {
    "codigo":90818000,
    "descripcion":"EVOLUCIÓN FETAL ESPONTÁNEA, MÉTODO DE DENHAM"
  },
  {
    "codigo":1173997008,
    "descripcion":"MICROANGIOPATÍA PONTINA AUTOSÓMICA DOMINANTE CON LEUCOENCEFALOPATÍA"
  },
  {
    "codigo":254658001,
    "descripcion":"NEOPLASIA EPITELIAL BENIGNA DE PIEL"
  },
  {
    "codigo":713410003,
    "descripcion":"DOLOR CONSECUTIVO A ACCIDENTE CEREBROVASCULAR"
  },
  {
    "codigo":11819651000119109,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA ANTERIOR DE ARTICULACIÓN ESCAPULOHUMERAL DERECHA"
  },
  {
    "codigo":123586005,
    "descripcion":"TENOSINOVITIS CREPITANTE"
  },
  {
    "codigo":350851000119109,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE MÉDULA DE GLÁNDULA SUPRARRENAL IZQUIERDA"
  },
  {
    "codigo":23447005,
    "descripcion":"DEFICIENCIA DE GTP CICLOHIDROLASA I"
  },
  {
    "codigo":1268631009,
    "descripcion":"CARCINOMA DE CÉLULAS ESMERILADAS PRIMARIO DE CUELLO DE ÚTERO"
  },
  {
    "codigo":250988002,
    "descripcion":"INSUFICIENCIA MITRAL PARAPROTÉSICA"
  },
  {
    "codigo":447596005,
    "descripcion":"NEOPLASIA MIELODISPLÁSICA\/MIELOPROLIFERATIVA, NO CLASIFICABLE"
  },
  {
    "codigo":283756008,
    "descripcion":"MORDEDURA DE PERRO EN LA PALMA DE LA MANO"
  },
  {
    "codigo":609601001,
    "descripcion":"NEUROPATÍA SUPRAESCAPULAR"
  },
  {
    "codigo":871745001,
    "descripcion":"SÍNDROME DE DISTRÉS POSPRANDIAL"
  },
  {
    "codigo":314689002,
    "descripcion":"TALLA DEL NIÑO: PERCENTILO 2"
  },
  {
    "codigo":183617005,
    "descripcion":"SEGUIMIENTO EN 1 DÍA"
  },
  {
    "codigo":281921007,
    "descripcion":"FRACTURA EN LÁGRIMA DE VÉRTEBRA DORSAL"
  },
  {
    "codigo":658021000005104,
    "descripcion":"PLACENTA UBICADA EN PARED POSTERIOR DE FONDO UTERINO"
  },
  {
    "codigo":247318005,
    "descripcion":"GUSTO ANORMAL EN LA BOCA"
  },
  {
    "codigo":212715006,
    "descripcion":"INTOXICACIÓN CAUSADA POR BLOQUEANTES DE LOS CANALES DEL CALCIO"
  },
  {
    "codigo":704235009,
    "descripcion":"FRACTURA EXPUESTA DE FALANGE DE DEDO MAYOR DE LA MANO"
  },
  {
    "codigo":1259456002,
    "descripcion":"GANGLIONEUROBLASTOMA PRIMARIO DE SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":14272003,
    "descripcion":"HINCHAZÓN PREMENSTRUAL"
  },
  {
    "codigo":276416006,
    "descripcion":"BUEN CONTROL DEL MOVIMIENTO"
  },
  {
    "codigo":47040006,
    "descripcion":"TRASTORNO DE LA AORTA"
  },
  {
    "codigo":702400006,
    "descripcion":"DISPLASIA ESPONDILOEPIFISARIA CON LUXACIONES ARTICULARES CONGÉNITAS"
  },
  {
    "codigo":210880006,
    "descripcion":"LESIÓN EXPUESTA, ARTERIA POPLÍTEA"
  },
  {
    "codigo":866240007,
    "descripcion":"CON MAYOR RIESGO DE ACCIDENTE CEREBROVASCULAR"
  },
  {
    "codigo":1090641000119100,
    "descripcion":"INFLAMACIÓN AGUDA DE TROMPA FARINGOTIMPÁNICA DERECHA"
  },
  {
    "codigo":16026551000119108,
    "descripcion":"NEUROPATÍA PERIFÉRICA DE AMBAS EXTREMIDADES INFERIORES"
  },
  {
    "codigo":11822161000119102,
    "descripcion":"SUBLUXACIÓN DE ARTICULACIÓN ACROMIOCLAVICULAR IZQUIERDA"
  },
  {
    "codigo":895338000,
    "descripcion":"CURVATURA ANORMAL DE FALANGE PROXIMAL DE DEDO MAYOR"
  },
  {
    "codigo":733333007,
    "descripcion":"REACCIÓN OCULAR DE INCLINACIÓN"
  },
  {
    "codigo":239978002,
    "descripcion":"RUPTURA DE TENDÓN EXTENSOR DE DEDO"
  },
  {
    "codigo":403818001,
    "descripcion":"NEUROFIBROMA PLEXIFORME"
  },
  {
    "codigo":1255786003,
    "descripcion":"PARAGRANULOMA DE HODGKIN DE GANGLIOS LINFÁTICOS DE CABEZA Y CUELLO"
  },
  {
    "codigo":371050006,
    "descripcion":"HEMATOMA SUBDURAL INTRACRANEAL TRAUMÁTICO CON PÉRDIDA BREVE DE LA CONSCIENCIA"
  },
  {
    "codigo":305514009,
    "descripcion":"BAJO ATENCIÓN DE PSIQUIATRA INFANTOJUVENIL"
  },
  {
    "codigo":1155647007,
    "descripcion":"INTOXICACIÓN ACCIDENTAL CAUSADA POR METAL Y\/O DERIVADO DE METAL"
  },
  {
    "codigo":238143008,
    "descripcion":"SOBRECARGA DE MAGNESIO"
  },
  {
    "codigo":400148004,
    "descripcion":"FIBROMATOSIS MUSCULOESQUELÉTICA"
  },
  {
    "codigo":681041000119106,
    "descripcion":"CATARATA CORTICAL CONGÉNITA DE AMBOS OJOS"
  },
  {
    "codigo":365545000,
    "descripcion":"ACEPTACIÓN DE LA AUTORIDAD EN EL TRABAJO - HALLAZGO"
  },
  {
    "codigo":1119209001,
    "descripcion":"ALERGIA A TINTURA DE PELO"
  },
  {
    "codigo":398313001,
    "descripcion":"TRAUMATISMO DE CUERDA VOCAL"
  },
  {
    "codigo":269076009,
    "descripcion":"FRACTURA EXPUESTA DE SEXTA VÉRTEBRA CERVICAL"
  },
  {
    "codigo":107601000119107,
    "descripcion":"CARCINOMA PRIMARIO DE CÉLULAS DE TRANSICIÓN DE URETRA"
  },
  {
    "codigo":789694004,
    "descripcion":"MESOTELIOMA PAPILAR DE PLEURA BIEN DIFERENCIADO"
  },
  {
    "codigo":298174007,
    "descripcion":"INFLAMACIÓN DE ARTICULACIÓN METATARSOFALÁNGICA"
  },
  {
    "codigo":1344915000,
    "descripcion":"METAPLASIA INTESTINAL DE CUERPO GÁSTRICO"
  },
  {
    "codigo":165267002,
    "descripcion":"CAMINA 90-120 METROS EN 1 MINUTO"
  },
  {
    "codigo":394643003,
    "descripcion":"OLOR DESAGRADABLE DE PIES"
  },
  {
    "codigo":230803002,
    "descripcion":"TRASTORNO DE LA REPARACIÓN NERVIOSA"
  },
  {
    "codigo":198035003,
    "descripcion":"EDEMA DE PENE"
  },
  {
    "codigo":38981000087102,
    "descripcion":"ABRASIÓN DE PIEL DE MIEMBRO INFERIOR IZQUIERDO"
  },
  {
    "codigo":44101000087104,
    "descripcion":"HERIDA CORTANTE DE MIEMBRO INFERIOR IZQUIERDO"
  },
  {
    "codigo":427411009,
    "descripcion":"SEUDOMENINGOCELE ADQUIRIDO"
  },
  {
    "codigo":46661000087104,
    "descripcion":"FRACTURA DE FALANGE DISTAL DE MEÑIQUE IZQUIERDO"
  },
  {
    "codigo":41541000087109,
    "descripcion":"HERIDA PUNZANTE DE EXTREMIDAD INFERIOR DERECHA"
  },
  {
    "codigo":425576009,
    "descripcion":"QUISTE TRAUMÁTICO LEPTOMENÍNGEO"
  },
  {
    "codigo":423741006,
    "descripcion":"CONDUCTA DOMINANTE"
  },
  {
    "codigo":126994001,
    "descripcion":"NEOPLASIA DE LOS NERVIOS PERIFÉRICOS DEL TRONCO"
  },
  {
    "codigo":292669009,
    "descripcion":"REACCIÓN ADVERSA A LA ISOTRETINOÍNA"
  },
  {
    "codigo":1208338004,
    "descripcion":"SÍNDROME DE DISRAFISMO, FISURA LABIOPALATINA, DEFECTOS POR REDUCCIÓN DE EXTREMIDADES"
  },
  {
    "codigo":28690004,
    "descripcion":"SIGNO DE LA ONDA"
  },
  {
    "codigo":61458006,
    "descripcion":"LUPUS ERITEMATOSO MEDICAMENTOSO CAUSADO POR DIFENILHIDANTOÍNA"
  },
  {
    "codigo":94226006,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL LIGAMENTO ANCHO"
  },
  {
    "codigo":125159002,
    "descripcion":"ESPÉCIMEN NO ROTULADO"
  },
  {
    "codigo":92391007,
    "descripcion":"NEOPLASIA BENIGNA DE PARTES BLANDAS DE LA CABEZA"
  },
  {
    "codigo":1237436002,
    "descripcion":"BLEFARITIS ANTERIOR DE PÁRPADO SUPERIOR CAUSADA POR ESTAFILOCOCOS"
  },
  {
    "codigo":1335740005,
    "descripcion":"NECROSIS AVASCULAR DE TIBIA"
  },
  {
    "codigo":57788006,
    "descripcion":"INTOXICACIÓN POR SORGO HALEPENSE"
  },
  {
    "codigo":449169008,
    "descripcion":"INTERVELLOSITIS SUBCORIÓNICA"
  },
  {
    "codigo":21350002,
    "descripcion":"QUISTE COLOIDE DEL TERCER VENTRÍCULO"
  },
  {
    "codigo":10759711000119103,
    "descripcion":"RUPTURA PREMATURA DE MEMBRANAS PRETÉRMINO CON COMIENZO DEL TRABAJO DE PARTO DENTRO DE LAS 24 HORAS DE LA RUPTURA"
  },
  {
    "codigo":283494007,
    "descripcion":"HERIDA PUNZANTE EN LA PLANTA DEL PIE"
  },
  {
    "codigo":609339001,
    "descripcion":"INFECCIÓN SUPERFICIAL DE INCISIÓN QUIRÚRGICA"
  },
  {
    "codigo":412731001,
    "descripcion":"HALLAZGO GENÉTICO DETECTADO"
  },
  {
    "codigo":185190009,
    "descripcion":"ATENDIDO EN CONSULTORIO DE AUDIOLOGÍA"
  },
  {
    "codigo":248891005,
    "descripcion":"FONDO DE SACO VAGINAL - HALLAZGO"
  },
  {
    "codigo":314427006,
    "descripcion":"DRUSAS Y DEGENERACIÓN MACULAR EN ETAPA DE CAMBIO PIGMENTARIO"
  },
  {
    "codigo":10677791000119105,
    "descripcion":"NÓDULO DEL TEJIDO CELULAR SUBCUTÁNEO DE LA PARED ABDOMINAL"
  },
  {
    "codigo":50448004,
    "descripcion":"FRACTURA DE COLUMNA VERTEBRAL"
  },
  {
    "codigo":247056004,
    "descripcion":"OPACIDADES ANTERIORES SUBCAPSULARES DE CRISTALINO"
  },
  {
    "codigo":443664006,
    "descripcion":"SÍNDROME DEL SUEÑO PROLONGADO"
  },
  {
    "codigo":1230096008,
    "descripcion":"SÍNDROME DE TIMOTHY"
  },
  {
    "codigo":212453000,
    "descripcion":"RUPTURA TRAUMÁTICA DE DISCO INTERVERTEBRAL DORSAL"
  },
  {
    "codigo":1197328009,
    "descripcion":"ADENOCARCINOMA METASTÁSICO DE GANGLIO LINFÁTICO TORÁCICO"
  },
  {
    "codigo":312592009,
    "descripcion":"ÉMBOLO DE ARTERIA DE CABEZA Y CUELLO"
  },
  {
    "codigo":15845006,
    "descripcion":"ÚLCERA DE BURULI"
  },
  {
    "codigo":472762000,
    "descripcion":"TRASTORNO DE AURÍCULA DERECHA"
  },
  {
    "codigo":703973009,
    "descripcion":"SÍNDROME DE PRIMERO Y SEGUNDO ARCOS BRANQUIALES"
  },
  {
    "codigo":15648441000119102,
    "descripcion":"ANEURISMA DE ARTERIA CARÓTIDA COMÚN DERECHA"
  },
  {
    "codigo":28191000119109,
    "descripcion":"SÍNDROME NEFRÍTICO CRÓNICO CON GLOMERULONEFRITIS MEMBRANOSA"
  },
  {
    "codigo":210618008,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE PUNTA DE PULGAR, TIPO 1"
  },
  {
    "codigo":700303000,
    "descripcion":"ECTROPIÓN SENIL DE PÁRPADO INFERIOR"
  },
  {
    "codigo":734906009,
    "descripcion":"REQUIERE DERIVACIÓN A FORENSE EN EL MOMENTO DE LA MUERTE"
  },
  {
    "codigo":110479000,
    "descripcion":"FALTA DE CUMPLIMIENTO DEL TRATAMIENTO DENTAL"
  },
  {
    "codigo":307087004,
    "descripcion":"CAPAZ DE ANALIZAR INFORMACIÓN"
  },
  {
    "codigo":79546008,
    "descripcion":"FRACTURA NO EXPUESTA DE TRES COSTILLAS"
  },
  {
    "codigo":1193658009,
    "descripcion":"ENTERITIS POR ESCHERICHIA COLI ENTEROHEMORRÁGICA"
  },
  {
    "codigo":896911008,
    "descripcion":"FORMA ANCHA ANORMAL CONGÉNITA DE FALANGE PROXIMAL DE DEDO DE MANO"
  },
  {
    "codigo":733071009,
    "descripcion":"SÍNDROME DE SORDERA, DIVERTICULOSIS DE INTESTINO DELGADO Y NEUROPATÍA"
  },
  {
    "codigo":403556005,
    "descripcion":"BANDAS DE CONSTRICCIÓN DE LA EXTREMIDAD"
  },
  {
    "codigo":10340008,
    "descripcion":"DEFICIENCIA AISLADA DE GONADOTROFINA"
  },
  {
    "codigo":43108009,
    "descripcion":"TROMBOSIS DEL CORDÓN ESPERMÁTICO"
  },
  {
    "codigo":736511000168107,
    "descripcion":"SE SABE QUE PORTA UN ARMA"
  },
  {
    "codigo":203278004,
    "descripcion":"TUBERCULOSIS DE HUESOS DE REGIÓN DE HOMBRO"
  },
  {
    "codigo":301582007,
    "descripcion":"CAPAZ DE MANEJARSE EN ESCALONES Y ESCALERAS"
  },
  {
    "codigo":365283000,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA OPERAR LOS CONTROLES DE LA DUCHA"
  },
  {
    "codigo":1217251004,
    "descripcion":"LINFEDEMA PRIMARIO SINDRÓMICO"
  },
  {
    "codigo":234211005,
    "descripcion":"DESPLAZAMIENTO DE ELECTRODO DE MARCAPASOS"
  },
  {
    "codigo":4835004,
    "descripcion":"INFECCIÓN CAUSADA POR NOSEMA BOMBYCIS"
  },
  {
    "codigo":299747007,
    "descripcion":"REFLEJO PALMOMENTONIANO PRESENTE"
  },
  {
    "codigo":398051009,
    "descripcion":"MIEMBRO DEL PERSONAL CANSADO"
  },
  {
    "codigo":1269256002,
    "descripcion":"DAÑO DE TEJIDO DE PELVIS DEBIDO A ABORTO INCOMPLETO"
  },
  {
    "codigo":232376006,
    "descripcion":"TABIQUE NASAL LUXADO"
  },
  {
    "codigo":2461000124104,
    "descripcion":"PRIMER PREMOLAR INFERIOR DERECHO PERMANENTE SUPERNUMERARIO"
  },
  {
    "codigo":230541001,
    "descripcion":"TRASTORNO CONGÉNITO DEL NERVIO FACIAL"
  },
  {
    "codigo":66701005,
    "descripcion":"ACTINOBACILOSIS POR ACTINOBACILLUS LIGNIERESI"
  },
  {
    "codigo":722061006,
    "descripcion":"SÍNDROME OCULOOSTEOCUTÁNEO"
  },
  {
    "codigo":294242002,
    "descripcion":"ALERGIA A PAPAVERINA"
  },
  {
    "codigo":1144375000,
    "descripcion":"AUSENCIA CONGÉNITA DE PALADAR BLANDO"
  },
  {
    "codigo":95799000,
    "descripcion":"LACERACIÓN DE LA ESCLERÓTICA"
  },
  {
    "codigo":292407002,
    "descripcion":"REACCIÓN ADVERSA A LA REMOXIPRIDA"
  },
  {
    "codigo":112621000119104,
    "descripcion":"DEHISCENCIA DE HERIDA DE TRASPLANTE DE CÓRNEA"
  },
  {
    "codigo":128567004,
    "descripcion":"AURÍCULA CONGÉNITA DE LA VENA PULMONAR"
  },
  {
    "codigo":194103006,
    "descripcion":"EXOTROPÍA MONOCULAR INTERMITENTE"
  },
  {
    "codigo":225036005,
    "descripcion":"DISTORSIÓN DE LA MEMORIA"
  },
  {
    "codigo":1306380006,
    "descripcion":"NEOPLASIA DE CUADRANTE SUPERIOR EXTERNO DE MAMA"
  },
  {
    "codigo":93964007,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA GLÁNDULA HIPÓFISIS"
  },
  {
    "codigo":28428009,
    "descripcion":"GOTA VISCERAL"
  },
  {
    "codigo":126732009,
    "descripcion":"NEOPLASIA DEL MIOCARDIO"
  },
  {
    "codigo":92129006,
    "descripcion":"NEOPLASIA BENIGNA DE LA BÓVEDA DEL PALADAR"
  },
  {
    "codigo":286902000,
    "descripcion":"CARCINOMA SECUNDARIO DEL TRACTO GASTROINTESTINAL"
  },
  {
    "codigo":254134004,
    "descripcion":"DISPLASIA CRANEOMETAFISARIA - TIPO SEVERO"
  },
  {
    "codigo":16060551000119103,
    "descripcion":"TUBERCULOSIS NEONATAL"
  },
  {
    "codigo":86624000,
    "descripcion":"INTOXICACIÓN CAUSADA POR AMOBARBITAL"
  },
  {
    "codigo":414304001,
    "descripcion":"FORÚNCULO DE LA CAVIDAD NASAL"
  },
  {
    "codigo":331911000119105,
    "descripcion":"QUERATITIS SUPERFICIAL DE OJO DERECHO"
  },
  {
    "codigo":16470151000119106,
    "descripcion":"INCONTINENCIA URINARIA DEBIDA A ACCIDENTE CEREBROVASCULAR ISQUÉMICO Y POSTERIOR A ÉL"
  },
  {
    "codigo":283232005,
    "descripcion":"VIDRIO EN CUERO CABELLUDO"
  },
  {
    "codigo":447072005,
    "descripcion":"HERNIACIÓN DE RECTO EN VAGINA"
  },
  {
    "codigo":1231669001,
    "descripcion":"INFECCIÓN DE ÓRBITA CAUSADA POR MYCOBACTERIUM TUBERCULOSIS"
  },
  {
    "codigo":248629002,
    "descripcion":"PULSO CON PAUSA DE LATIDOS"
  },
  {
    "codigo":707381003,
    "descripcion":"HAMARTOMA SOLITARIO DE PULMÓN"
  },
  {
    "codigo":445237003,
    "descripcion":"HIPERTENSIÓN PORTOPULMONAR"
  },
  {
    "codigo":838453008,
    "descripcion":"INSUFICIENCIA SEVERA DE VÁLVULA MITRAL"
  },
  {
    "codigo":15978631000119109,
    "descripcion":"OCLUSIÓN DE AMBAS ARTERIAS VERTEBRALES"
  },
  {
    "codigo":310495003,
    "descripcion":"DEPRESIÓN LEVE"
  },
  {
    "codigo":1162463004,
    "descripcion":"DUPLICACIÓN PARCIAL DE BRAZO LARGO DEL CROMOSOMA 15"
  },
  {
    "codigo":46516001,
    "descripcion":"HEMORROIDES INTERNAS ULCERADAS"
  },
  {
    "codigo":1258932003,
    "descripcion":"LINFOMA\/LEUCEMIA NATURAL KILLER-LINFOBLÁSTICO"
  },
  {
    "codigo":439732004,
    "descripcion":"DISTONÍA MIOCLÓNICA"
  },
  {
    "codigo":308660004,
    "descripcion":"ABSCESO DE DEDO GORDO"
  },
  {
    "codigo":863881000,
    "descripcion":"CON RIESGO MODERADO DE ÚLCERA DE PIE IZQUIERDO DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":110217005,
    "descripcion":"QUEMADURA DE TERCER GRADO DEL PISO DE LA BOCA"
  },
  {
    "codigo":304990002,
    "descripcion":"HEMANGIOMA DE ENCÍA"
  },
  {
    "codigo":10078003,
    "descripcion":"DIENTE DE TURNER"
  },
  {
    "codigo":75614007,
    "descripcion":"PANUVEÍTIS"
  },
  {
    "codigo":763742008,
    "descripcion":"SÍNDROME DE DISCAPACIDAD INTELECTUAL, POLIDACTILIA Y CABELLO IMPOSIBLE DE PEINAR"
  },
  {
    "codigo":370526008,
    "descripcion":"TORSIÓN DE LA RAÍZ DEL MESENTERIO"
  },
  {
    "codigo":403294009,
    "descripcion":"DISTROFIA UNGUEAL ASOCIADA CON DERMATOSIS AMPOLLARES"
  },
  {
    "codigo":42846007,
    "descripcion":"INTOXICACIÓN POR SESBANIA VESICARIA"
  },
  {
    "codigo":16039391000119100,
    "descripcion":"CONDROMALACIA DE HOMBRO DERECHO"
  },
  {
    "codigo":10640351000119101,
    "descripcion":"ÚLCERA NEUROPÁTICA DE MUSLO IZQUIERDO"
  },
  {
    "codigo":16011231000119102,
    "descripcion":"GANGRENA DE PIE DERECHO"
  },
  {
    "codigo":333791000119102,
    "descripcion":"EXOTROPÍA MONOCULAR DE OJO DERECHO CON ESTRABISMO CON PATRÓN EN V"
  },
  {
    "codigo":301320000,
    "descripcion":"HALLAZGO RELACIONADO CON LA APARIENCIA DE LA MANO"
  },
  {
    "codigo":15760351000119105,
    "descripcion":"TROMBOSIS VENOSA PROFUNDA CRÓNICA"
  },
  {
    "codigo":991000119106,
    "descripcion":"ENFERMEDAD REACTIVA DE LA VÍA AÉREA"
  },
  {
    "codigo":16047071000119107,
    "descripcion":"ENFERMEDAD POR DEPÓSITO DE HIDROXIAPATITA DE MANO DERECHA"
  },
  {
    "codigo":679391000119107,
    "descripcion":"CICATRIZ DE CONJUNTIVA DE OJO IZQUIERDO"
  },
  {
    "codigo":16052191000119109,
    "descripcion":"TENDINITIS DE TENDÓN DE CUÁDRICEPS DERECHO"
  },
  {
    "codigo":10942431000119101,
    "descripcion":"PERFORACIÓN TRAUMÁTICA DE MEMBRANA TIMPÁNICA DERECHA"
  },
  {
    "codigo":292831000119103,
    "descripcion":"SÍNDROME DE NERVIO INTERÓSEO ANTERIOR DE EXTREMIDAD SUPERIOR DERECHA"
  },
  {
    "codigo":15980511000119105,
    "descripcion":"TRASTORNO DEL DISCO ARTICULAR DE LA ARTICULACIÓN TEMPOROMANDIBULAR DERECHA"
  },
  {
    "codigo":10637791000119107,
    "descripcion":"OSTEONECROSIS DE HUESO DE TOBILLO DEBIDA A ÚLCERA CRÓNICA DE TOBILLO"
  },
  {
    "codigo":320991000119107,
    "descripcion":"ENTESOPATÍA VERTEBRAL DE REGIÓN CERVICODORSAL"
  },
  {
    "codigo":303071000119106,
    "descripcion":"DEFORMIDAD EN OJAL DE DEDO DE MANO IZQUIERDA"
  },
  {
    "codigo":203016003,
    "descripcion":"MIOSITIS INFECCIOSA DE MUSLO"
  },
  {
    "codigo":15637471000119109,
    "descripcion":"RUPTURA DEGENERATIVA DE MENISCO INTERNO DE RODILLA IZQUIERDA"
  },
  {
    "codigo":792840007,
    "descripcion":"PULSO EN ARTERIA TIBIAL POSTERIOR DERECHA AUSENTE"
  },
  {
    "codigo":365021007,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD DE PRODUCIR SONIDOS SORDOS"
  },
  {
    "codigo":233949008,
    "descripcion":"HEMANGIOMATOSIS CAPILAR PULMONAR"
  },
  {
    "codigo":102877006,
    "descripcion":"NULÍPARA"
  },
  {
    "codigo":789170003,
    "descripcion":"CONDUCTA DESINHIBIDA DEBIDA A DEMENCIA"
  },
  {
    "codigo":166578004,
    "descripcion":"FOSFATASA ÁCIDA SÉRICA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":232114005,
    "descripcion":"ESTRABISMO MECÁNICO SECUNDARIO"
  },
  {
    "codigo":428722005,
    "descripcion":"HERNIA INGUINAL RECURRENTE CON GANGRENA"
  },
  {
    "codigo":10820181000119103,
    "descripcion":"FRACTURA EXPUESTA DE EXTREMO DISTAL DE FÉMUR IZQUIERDO"
  },
  {
    "codigo":263047001,
    "descripcion":"SUBLUXACIÓN DE ARTICULACIÓN DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":295815003,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE LEVODOPA"
  },
  {
    "codigo":230279005,
    "descripcion":"DISFASIA PROGRESIVA DE TIPO NO ALZHEIMER"
  },
  {
    "codigo":903008,
    "descripcion":"INFARTO CORIORRETINIANO"
  },
  {
    "codigo":293980000,
    "descripcion":"ALERGIA A PENBUTOLOL"
  },
  {
    "codigo":228444003,
    "descripcion":"POSESIÓN DE DROGAS"
  },
  {
    "codigo":195676005,
    "descripcion":"AMIGDALITIS VIRAL AGUDA"
  },
  {
    "codigo":334421000119106,
    "descripcion":"FRAGMENTOS DE LENTE PARA CATARATAS EN VÍTREO DE OJO DERECHO DEBIDOS A CIRUGÍA DE CATARATAS Y POSTERIOR A ELLA"
  },
  {
    "codigo":89600751000119100,
    "descripcion":"ÚLCERA AGUDA DE ANTRO PILÓRICO"
  },
  {
    "codigo":95537002,
    "descripcion":"GANGRENA DE YEYUNO"
  },
  {
    "codigo":16036591000119101,
    "descripcion":"DETENCIÓN TOTAL DE CRECIMIENTO EPIFISARIO BILATERAL DE TIBIAS DISTALES"
  },
  {
    "codigo":292145006,
    "descripcion":"REACCIÓN ADVERSA AL DOCUSATO"
  },
  {
    "codigo":423217007,
    "descripcion":"PROVISIÓN TARDÍA DE LA ATENCIÓN DE LA SALUD CON NEGLIGENCIA COMO RESULTADO"
  },
  {
    "codigo":290310000,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR ÁCIDO TIAPROFÉNICO"
  },
  {
    "codigo":28166001,
    "descripcion":"DEGRADACIÓN MOLECULAR"
  },
  {
    "codigo":716294003,
    "descripcion":"RESTAURACIÓN DENTAL OCLUSAL INADECUADA"
  },
  {
    "codigo":386779003,
    "descripcion":"CORTISOL ANORMAL"
  },
  {
    "codigo":1204144000,
    "descripcion":"ATEROSCLEROSIS DE ARTERIA AXILAR"
  },
  {
    "codigo":91867008,
    "descripcion":"FORMA ADULTA DE ENFERMEDAD CELÍACA"
  },
  {
    "codigo":284805002,
    "descripcion":"SE BAÑA"
  },
  {
    "codigo":448645003,
    "descripcion":"HIPOPLASIA DE CAYADO AÓRTICO ENTRE ARTERIA SUBCLAVIA Y CARÓTIDA COMÚN"
  },
  {
    "codigo":219269005,
    "descripcion":"LESIÓN POR INTERVENCIÓN LEGAL CON GAS"
  },
  {
    "codigo":710789006,
    "descripcion":"LESIÓN DE CARIES DE RAÍZ EXTENSA QUE AFECTA A LA DENTINA"
  },
  {
    "codigo":10629871000119108,
    "descripcion":"CELULITIS DE CADERA IZQUIERDA"
  },
  {
    "codigo":252037009,
    "descripcion":"FUGA VENOSA DE PENE"
  },
  {
    "codigo":1003866003,
    "descripcion":"DUPLICACIÓN DE PORCIÓN PROXIMAL DEL BRAZO LARGO DEL CROMOSOMA 3"
  },
  {
    "codigo":11996041000119103,
    "descripcion":"INFECCIÓN DE MUÑÓN DE AMPUTACIÓN DE EXTREMIDAD SUPERIOR IZQUIERDA"
  },
  {
    "codigo":1264175001,
    "descripcion":"PIERCING EN TERCIO IZQUIERDO DE LABIO SUPERIOR"
  },
  {
    "codigo":408537003,
    "descripcion":"SÍNDROME DE BARBER-SAY"
  },
  {
    "codigo":734382000,
    "descripcion":"TROMBOSIS DE ARTERIA CARÓTIDA DERECHA"
  },
  {
    "codigo":439470001,
    "descripcion":"FÍSTULA ARTERIOVENOSA"
  },
  {
    "codigo":242862004,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE PARED NASOFARÍNGEA"
  },
  {
    "codigo":111790004,
    "descripcion":"INTOXICACIÓN POR OPUNTIA"
  },
  {
    "codigo":898222007,
    "descripcion":"FUSIÓN ANORMAL CONGÉNITA DE SEGUNDO METACARPIANO"
  },
  {
    "codigo":13486008,
    "descripcion":"SIGNO DE LUDINGTON"
  },
  {
    "codigo":210094008,
    "descripcion":"LESIÓN EXPUESTA DE LA PLEURA"
  },
  {
    "codigo":1074211000119104,
    "descripcion":"CONDROCALCINOSIS DE PIE IZQUIERDO"
  },
  {
    "codigo":109955005,
    "descripcion":"EFECTOS DE LA TERAPIA INMUNOSUPRESORA"
  },
  {
    "codigo":699779006,
    "descripcion":"DESVIACIÓN DE LA LÍNEA MEDIA MAXILAR HACIA LA IZQUIERDA"
  },
  {
    "codigo":372099007,
    "descripcion":"NEOPLASIA MALIGNA DE EXOCÉRVIX"
  },
  {
    "codigo":271960000,
    "descripcion":"ENFERMEDAD DIVERTICULAR DE INTESTINO GRUESO COMPLICADA"
  },
  {
    "codigo":403032003,
    "descripcion":"TIÑA CORPORAL CAUSADA POR MICROSPORUM GYPSEUM"
  },
  {
    "codigo":206424005,
    "descripcion":"MELENA NEONATAL"
  },
  {
    "codigo":239192007,
    "descripcion":"APÓSITO INCLUIDO EN EL PROCESO DE CICATRIZACIÓN DE SITIO DONANTE DE PIEL"
  },
  {
    "codigo":302893000,
    "descripcion":"TRASTORNO CORIORRETINIANO"
  },
  {
    "codigo":697944008,
    "descripcion":"CALCIFICACIÓN MAMOGRÁFICA DE MAMA"
  },
  {
    "codigo":11805731000119107,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA PROXIMAL DE DEDO DE MANO DERECHA"
  },
  {
    "codigo":204589003,
    "descripcion":"COMUNICACIÓN PLEUROPERICÁRDICA ANORMAL"
  },
  {
    "codigo":237357004,
    "descripcion":"INGURGITACIÓN VASCULAR DE LA MAMA"
  },
  {
    "codigo":91171000119107,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE GRANDES CÉLULAS INDIFERENCIADAS DE PARED TORÁCICA"
  },
  {
    "codigo":202754001,
    "descripcion":"RESORCIÓN DE DISCO LUMBAR"
  },
  {
    "codigo":301058005,
    "descripcion":"HALLAZGO RELACIONADO CON LA POSICIÓN DE LA BOCA"
  },
  {
    "codigo":268290005,
    "descripcion":"HIPOPLASIA DE PEZÓN"
  },
  {
    "codigo":169986008,
    "descripcion":"AMAMANTADO Y ALIMENTADO CON SUPLEMENTOS A LOS 6 MESES"
  },
  {
    "codigo":366594009,
    "descripcion":"AMPLITUD DE MOVIMIENTO PASIVO DE ROTACIÓN INTERNA DE LA RODILLA - HALLAZGO"
  },
  {
    "codigo":233687002,
    "descripcion":"ASMA POR COLOFONIA"
  },
  {
    "codigo":364759002,
    "descripcion":"INTENSIDAD DE LOS RUIDOS CARDÍACOS FETALES - HALLAZGO"
  },
  {
    "codigo":15957181000119104,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS METASTÁSICO DE PULMÓN DERECHO"
  },
  {
    "codigo":102615007,
    "descripcion":"DOLOR TIPO ÚLCERA"
  },
  {
    "codigo":788908000,
    "descripcion":"TRASTORNO DISOCIATIVO CON SÍNTOMA NEUROLÓGICO CONCOMITANTE CON DISTONÍA"
  },
  {
    "codigo":397527008,
    "descripcion":"CAPA LAGRIMAL ACUOSA"
  },
  {
    "codigo":428460002,
    "descripcion":"ARTROPATÍA DE ARTICULACIÓN CIGOAPOFISARIA DORSAL"
  },
  {
    "codigo":395692003,
    "descripcion":"PARAPROTEINEMIA BENIGNA"
  },
  {
    "codigo":231852005,
    "descripcion":"CUERPO EXTRAÑO ORBITAL"
  },
  {
    "codigo":166316005,
    "descripcion":"UREA Y ELECTRÓLITOS DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":262785000,
    "descripcion":"LACERACIÓN PULMONAR"
  },
  {
    "codigo":361089004,
    "descripcion":"DEFICIENCIA DE ALQUILHALIDASA"
  },
  {
    "codigo":230017005,
    "descripcion":"POSICIÓN DEL TRONCO HACIA ATRÁS"
  },
  {
    "codigo":721537005,
    "descripcion":"SÍNDROME DE HORNER ADQUIRIDO"
  },
  {
    "codigo":426625008,
    "descripcion":"INVASIÓN TUMORAL MÁS PROFUNDA QUE LA PIEL"
  },
  {
    "codigo":293718005,
    "descripcion":"ALERGIA A FÁRMACO ANESTÉSICO LOCAL"
  },
  {
    "codigo":129878006,
    "descripcion":"FAMILIA DISFUNCIONAL POR PROBLEMAS DE ALCOHOLISMO"
  },
  {
    "codigo":31574009,
    "descripcion":"SOPLO SISTÓLICO"
  },
  {
    "codigo":195414009,
    "descripcion":"TROMBOFLEBITIS DE VENA TIBIAL POSTERIOR"
  },
  {
    "codigo":160811003,
    "descripcion":"RECLAMO DE INDEMNIZACIÓN PENDIENTE"
  },
  {
    "codigo":128043004,
    "descripcion":"TRASTORNO DE LA PIEL Y\/O DEL TEJIDO CELULAR SUBCUTÁNEO DEL TRONCO"
  },
  {
    "codigo":11834711000119105,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA DE PULGAR IZQUIERDO"
  },
  {
    "codigo":62507009,
    "descripcion":"SENSACIÓN DE HORMIGUEO"
  },
  {
    "codigo":93440002,
    "descripcion":"OSIFICACIÓN DEL CENTRO DE LA VÉRTEBRA TORÁCICA EN FORMA DE PALANCA"
  },
  {
    "codigo":191744004,
    "descripcion":"NEUROSIS DEL CALAMBRE DEL ESCRITOR"
  },
  {
    "codigo":224512006,
    "descripcion":"CUIDADOR INFORMAL SIN APOYO"
  },
  {
    "codigo":91605000,
    "descripcion":"AUSENCIA CONGÉNITA DE ARTERIA"
  },
  {
    "codigo":1172949003,
    "descripcion":"PARACETAMOL POR ENCIMA DEL LÍMITE TERAPÉUTICO"
  },
  {
    "codigo":93681000119102,
    "descripcion":"INSOMNIO DEBIDO A TRASTORNO DE MOVIMIENTOS PERIÓDICOS DE EXTREMIDADES"
  },
  {
    "codigo":16641521000119102,
    "descripcion":"INFLAMACIÓN DE NERVIO PERIFÉRICO DE TOBILLOS BILATERALES"
  },
  {
    "codigo":253610004,
    "descripcion":"VÁLVULA AÓRTICA UNICÚSPIDE"
  },
  {
    "codigo":188074007,
    "descripcion":"MELANOMA MALIGNO DEL TALÓN"
  },
  {
    "codigo":22399000,
    "descripcion":"ENDOMETRITIS PUERPERAL"
  },
  {
    "codigo":251775001,
    "descripcion":"DESVIACIÓN DEL EJE ÓPTICO PERMANECE MANIFIESTO"
  },
  {
    "codigo":286378009,
    "descripcion":"DIFICULTAD PARA CONVERSAR"
  },
  {
    "codigo":339441000119104,
    "descripcion":"ESOTROPÍA MONOCULAR DE OJO IZQUIERDO CON ESTRABISMO CON PATRÓN EN V"
  },
  {
    "codigo":24234009,
    "descripcion":"HEMIHIPOALGESIA"
  },
  {
    "codigo":1003604000,
    "descripcion":"FUSIÓN ANORMAL CONGÉNITA DE OMÓPLATO Y HÚMERO"
  },
  {
    "codigo":53332000,
    "descripcion":"ESPONDILOARTROSIS"
  },
  {
    "codigo":249940002,
    "descripcion":"DEBILIDAD DE LA CINTURA ESCAPULAR"
  },
  {
    "codigo":315476007,
    "descripcion":"NACIDO EN MALTA"
  },
  {
    "codigo":86100009,
    "descripcion":"ENDOCARDITIS CON VEGETACIONES"
  },
  {
    "codigo":1296681004,
    "descripcion":"PRESIÓN INTRAOCULAR DE OJO DERECHO POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":870697006,
    "descripcion":"RANGO DE FRECUENCIA CARDÍACA FETAL BASAL DE 80 A 100"
  },
  {
    "codigo":248105008,
    "descripcion":"ACTIVIDAD SEXUAL SOLITARIA INUSUAL"
  },
  {
    "codigo":1263913008,
    "descripcion":"CARCINOMA RENAL DE CÉLULAS CROMÓFOBAS METASTÁSICO"
  },
  {
    "codigo":279038004,
    "descripcion":"DORSALGIA TORÁCICA"
  },
  {
    "codigo":770558006,
    "descripcion":"MIOPATÍA DISTAL DE INICIO TARDÍO TIPO MARKESBERY GRIGGS"
  },
  {
    "codigo":82430007,
    "descripcion":"ANEMIA MEGALOBLÁSTICA AGUDA"
  },
  {
    "codigo":15059000,
    "descripcion":"DISTROFIA RETINIANA EN LA LIPIDOSIS SISTÉMICA"
  },
  {
    "codigo":311806008,
    "descripcion":"APLASTAMIENTO OSTEOPORÓTICO DE VÉRTEBRA CERVICAL"
  },
  {
    "codigo":441043003,
    "descripcion":"VIRUS DE INFLUENZA A SUBTIPO H1 PRESENTE"
  },
  {
    "codigo":703187008,
    "descripcion":"FALLA DE PRÓTESIS DE VÁLVULA PULMONAR"
  },
  {
    "codigo":111528000,
    "descripcion":"ESOTROPÍA ALTERNANTE CON PATRÓN A"
  },
  {
    "codigo":766888002,
    "descripcion":"LIPOMATOSIS MÚLTIPLE FAMILIAR"
  },
  {
    "codigo":308136002,
    "descripcion":"TROMBOFLEBITIS SUPERFICIAL EN EL EMBARAZO"
  },
  {
    "codigo":275368005,
    "descripcion":"ANOXIA FETAL DURANTE EL TRABAJO DE PARTO"
  },
  {
    "codigo":15933221000119101,
    "descripcion":"ABSCESO DE TROMPA DE FALOPIO IZQUIERDA"
  },
  {
    "codigo":240765004,
    "descripcion":"CROMOBLASTOMICOSIS CUTÁNEA"
  },
  {
    "codigo":109693003,
    "descripcion":"OSTEOMIELITIS MAXILAR AGUDA"
  },
  {
    "codigo":11389007,
    "descripcion":"CARBUNCO PULMONAR"
  },
  {
    "codigo":271698002,
    "descripcion":"CONTRACTURA EN EXTENSIÓN MUSCULAR"
  },
  {
    "codigo":402770002,
    "descripcion":"ICTIOSIS AUTOSÓMICA DOMINANTE"
  },
  {
    "codigo":1254738003,
    "descripcion":"TIENE CONTACTO CON LACTANTE MENOR DE 6 MESES"
  },
  {
    "codigo":763218005,
    "descripcion":"ANESTESIA CONGÉNITA DEL NERVIO TRIGÉMINO"
  },
  {
    "codigo":238930007,
    "descripcion":"REACCIÓN ESCLERODERMIFORME"
  },
  {
    "codigo":237095000,
    "descripcion":"VULVOVAGINITIS GONOCÓCICA"
  },
  {
    "codigo":1287506009,
    "descripcion":"ABRASIÓN DE PIEL DE PELVIS"
  },
  {
    "codigo":400935002,
    "descripcion":"ESOTROPÍA ACOMODATIVA REFRACTARIA"
  },
  {
    "codigo":73255003,
    "descripcion":"ERITROPOYESIS MEGALOBLASTOIDE"
  },
  {
    "codigo":106023006,
    "descripcion":"PATRÓN DE AUTOPERCEPCIÓN - HALLAZGO"
  },
  {
    "codigo":268028001,
    "descripcion":"OSTEOPOROSIS LOCALIZADA POR INACTIVIDAD"
  },
  {
    "codigo":399100005,
    "descripcion":"TRASTORNO DE HIPOTÁLAMO"
  },
  {
    "codigo":366332006,
    "descripcion":"HALLAZGO RELACIONADO CON EL OLOR DE LA PLACENTA"
  },
  {
    "codigo":15988671000119100,
    "descripcion":"CONJUNTIVITIS ALÉRGICA PERENNE DE AMBOS OJOS"
  },
  {
    "codigo":298961000,
    "descripcion":"AMPLITUD DE EXTENSIÓN ACTIVA DE LA MUÑECA AUMENTADA"
  },
  {
    "codigo":300796005,
    "descripcion":"DIFICULTAD PARA MANEJAR Y EMPUJAR UN JUGUETE"
  },
  {
    "codigo":368421000119108,
    "descripcion":"ENFERMEDAD RENAL CRÓNICA ESTADIO 1 DEBIDA A DIABETES MELLITUS MEDICAMENTOSA"
  },
  {
    "codigo":200657008,
    "descripcion":"CELULITIS Y ABSCESO DE LA MAMA"
  },
  {
    "codigo":167889008,
    "descripcion":"VISCOSIDAD DE LÍQUIDO SINOVIAL, BAJA"
  },
  {
    "codigo":460966003,
    "descripcion":"ORIGEN ANÓMALO DE LIGAMENTO ARTERIOSO EN ARTERIA CARÓTIDA IZQUIERDA"
  },
  {
    "codigo":297126005,
    "descripcion":"ANEXOS UTERINOS NORMALES"
  },
  {
    "codigo":67750007,
    "descripcion":"VENTILACIÓN INEFECTIVA"
  },
  {
    "codigo":723110008,
    "descripcion":"SECUELA DE INFECCIÓN CAUSADA POR MORBILLIVIRUS"
  },
  {
    "codigo":295291001,
    "descripcion":"SOBREDOSIS DE PIROXICAM"
  },
  {
    "codigo":262523007,
    "descripcion":"LESIÓN TRAUMÁTICA DE COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":33147008,
    "descripcion":"SÍNDROME MEDULAR POSTERIOR DEBIDO A FRACTURA EXPUESTA A NIVEL DE C1 - C4"
  },
  {
    "codigo":196987008,
    "descripcion":"ILEOCOLITIS ULCERATIVA"
  },
  {
    "codigo":341951000119105,
    "descripcion":"ASTIGMATISMO DE OJO IZQUIERDO"
  },
  {
    "codigo":129616004,
    "descripcion":"POLINEUROPATÍA PORFÍRICA"
  },
  {
    "codigo":293456005,
    "descripcion":"REACCIÓN ADVERSA A LA CLOROTIAZIDA"
  },
  {
    "codigo":95013006,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA REGIÓN PRESACRA"
  },
  {
    "codigo":1079231000119108,
    "descripcion":"NEOPLASIA BENIGNA DE HUESO DE MANO IZQUIERDA"
  },
  {
    "codigo":291621008,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR CEFTRIAXONA"
  },
  {
    "codigo":226085009,
    "descripcion":"DIETA A BASE DE PÉPTIDOS DE CADENA CORTA"
  },
  {
    "codigo":11784281000119102,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE DEDO ANULAR DERECHO"
  },
  {
    "codigo":224250004,
    "descripcion":"CONDICIONES DE VIDA SATISFACTORIA"
  },
  {
    "codigo":1010682008,
    "descripcion":"NO HABILITADO PARA RECIBIR ASISTENCIA DE SERVICIOS SOCIALES POR PERCIBIR INGRESOS SOBRE EL LÍMITE"
  },
  {
    "codigo":27642008,
    "descripcion":"SIALIDOSIS DISMÓRFICA, FORMA CONGÉNITA"
  },
  {
    "codigo":715770009,
    "descripcion":"NEUROPATÍA AXONAL MOTORA AGUDA"
  },
  {
    "codigo":15716441000119104,
    "descripcion":"ENOSTOSIS DE PERONÉ DERECHO"
  },
  {
    "codigo":289786008,
    "descripcion":"CUELLO UTERINO MUY POSTERIOR"
  },
  {
    "codigo":124111006,
    "descripcion":"DEFICIENCIA DE HISTIDINOL DESHIDROGENASA"
  },
  {
    "codigo":253348002,
    "descripcion":"FIBROELASTOSIS ENDOCÁRDICA DE AURÍCULA DERECHA"
  },
  {
    "codigo":1231325000,
    "descripcion":"DEPENDENCIA DE ANFETAMINA Y\/O DERIVADO DE ANFETAMINA EN REMISIÓN"
  },
  {
    "codigo":251513003,
    "descripcion":"ACTIVIDAD BETA ASIMÉTRICA"
  },
  {
    "codigo":22137006,
    "descripcion":"HIPOXIA EN LACTANTE NACIDO VIVO"
  },
  {
    "codigo":54905006,
    "descripcion":"TRASTORNO DEL TRANSPORTE DE LOS HIDRATOS DE CARBONO"
  },
  {
    "codigo":415353009,
    "descripcion":"INTOXICACIÓN ALIMENTARIA POR ROTAVIRUS"
  },
  {
    "codigo":282446002,
    "descripcion":"LESIÓN DE LAS VÍAS RESPIRATORIAS INFERIORES"
  },
  {
    "codigo":249678003,
    "descripcion":"AUSENCIA DE CLAVÍCULA"
  },
  {
    "codigo":85838004,
    "descripcion":"INTOXICACIÓN POR ARISAEMA"
  },
  {
    "codigo":118606001,
    "descripcion":"SARCOMA DE HODGKIN"
  },
  {
    "codigo":772131003,
    "descripcion":"MUÑÓN DEL CORDÓN UMBILICAL DESPRENDIDO"
  },
  {
    "codigo":1263651005,
    "descripcion":"METÁSTASIS DE CARCINOMA MUCOEPIDERMOIDE EN PIEL"
  },
  {
    "codigo":247843007,
    "descripcion":"MIEDO A SER EL HAZMERREÍR"
  },
  {
    "codigo":16632002,
    "descripcion":"HEMONEUMOTÓRAX"
  },
  {
    "codigo":1081741000119100,
    "descripcion":"SARCOMA PRIMARIO DE PARTES BLANDAS DE CADERA DERECHA"
  },
  {
    "codigo":344461000119100,
    "descripcion":"PINGUECULITIS BILATERAL"
  },
  {
    "codigo":1259981006,
    "descripcion":"CURSO DE RADIOTERAPIA MODIFICADO DEBIDO A CAMBIOS EN PROPÓSITO DE TRATAMIENTO"
  },
  {
    "codigo":111266001,
    "descripcion":"ESCOLIOSIS ADQUIRIDA"
  },
  {
    "codigo":438946002,
    "descripcion":"ADENOCARCINOMA DE LA UNIÓN ESOFAGOGÁSTRICA TIPO I DE SIEWERT"
  },
  {
    "codigo":733858005,
    "descripcion":"EXACERBACIÓN REFRACTARIA AGUDA SEVERA DE ASMA"
  },
  {
    "codigo":373410009,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN"
  },
  {
    "codigo":12962009,
    "descripcion":"HISTOPLASMOSIS"
  },
  {
    "codigo":699255005,
    "descripcion":"FLUJO DE IZQUIERDA A DERECHA A TRAVÉS DEL AGUJERO OVAL DEL CORAZÓN FETAL"
  },
  {
    "codigo":109431006,
    "descripcion":"MALFORMACIÓN DE VÁLVULA MITRAL TIPO EBSTEIN"
  },
  {
    "codigo":764791008,
    "descripcion":"NEOPLASIA EPITELIAL DE OVARIO DE MAILGNIDAD LIMÍTROFE"
  },
  {
    "codigo":369740001,
    "descripcion":"VASOS VENOSOS EXTRATUMORALES, CON COMPROMISO TUMORAL INDETERMINADO"
  },
  {
    "codigo":304204006,
    "descripcion":"AMPLITUD DE MOVIMIENTO ACTIVO DE EXTENSIÓN HORIZONTAL DE HOMBRO NORMAL"
  },
  {
    "codigo":402508006,
    "descripcion":"CARCINOMA BASOCELULAR DE MENTÓN"
  },
  {
    "codigo":238668006,
    "descripcion":"LIQUEN PLANO GENITAL"
  },
  {
    "codigo":398838000,
    "descripcion":"HIPERQUERATOSIS SENIL"
  },
  {
    "codigo":7457009,
    "descripcion":"TRAQUEÍTIS CRÓNICA"
  },
  {
    "codigo":169462002,
    "descripcion":"ANTICONCEPCIÓN ORAL - SIN PROBLEMAS"
  },
  {
    "codigo":366070003,
    "descripcion":"ACOMODACIÓN OCULAR - HALLAZGO"
  },
  {
    "codigo":431606003,
    "descripcion":"ARTRITIS BACTERIANA DE CADERA"
  },
  {
    "codigo":202230005,
    "descripcion":"LUXACIÓN RECURRENTE DE LA MUÑECA"
  },
  {
    "codigo":15637031000119103,
    "descripcion":"TERATOMA QUÍSTICO MADURO BILATERAL DE OVARIOS"
  },
  {
    "codigo":300534007,
    "descripcion":"HALLAZGO RELACIONADO CON LA SENSIBILIDAD DE LA PRÓSTATA"
  },
  {
    "codigo":234998009,
    "descripcion":"GRANULOMATOSIS BUCOFACIAL DE LAS ENCÍAS"
  },
  {
    "codigo":822987005,
    "descripcion":"HALLAZGO RELACIONADO CON EL SEGMENTO ABDOMINOPÉLVICO DEL TRONCO"
  },
  {
    "codigo":167627005,
    "descripcion":"MATERIA FECAL: NINGÚN COMPONENTE ANORMAL"
  },
  {
    "codigo":724683007,
    "descripcion":"TRASTORNO DEL ESTADO DE ÁNIMO CON SÍNTOMAS MIXTOS DEPRESIVOS Y MANÍACOS CAUSADO POR HIPNÓTICO"
  },
  {
    "codigo":296864000,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE GLIBENCLAMIDA"
  },
  {
    "codigo":298699009,
    "descripcion":"PRUEBA DE COMPRESIÓN CEFÁLICA, NEGATIVA"
  },
  {
    "codigo":67488005,
    "descripcion":"ALOPECIA TRAUMÁTICA"
  },
  {
    "codigo":722848005,
    "descripcion":"MÚLTIPLES ÚLCERAS CRÓNICAS INESPECÍFICAS DE INTESTINO DELGADO"
  },
  {
    "codigo":203955004,
    "descripcion":"ESPINA BÍFIDA CON ESTENOSIS DEL ACUEDUCTO DE SILVIO"
  },
  {
    "codigo":1343605000,
    "descripcion":"ARTROSIS DE COLUMNA VERTEBRAL LUMBAR"
  },
  {
    "codigo":721013001,
    "descripcion":"SÍNDROME CORAZÓN-MANO TIPO 3"
  },
  {
    "codigo":295029001,
    "descripcion":"ALERGIA A DICLORFENAMIDA"
  },
  {
    "codigo":293194000,
    "descripcion":"REACCIÓN ADVERSA A LA GLIBENCLAMIDA"
  },
  {
    "codigo":1145162001,
    "descripcion":"INTOXICACIÓN CAUSADA POR ÁCIDO PROPIÓNICO Y\/O DERIVADO DE ÁCIDO PROPIÓNICO"
  },
  {
    "codigo":15692481000119104,
    "descripcion":"QUERATITIS DE AMBOS OJOS CAUSADA POR ADENOVIRUS"
  },
  {
    "codigo":782879004,
    "descripcion":"PAQUIGIRIA Y POLIMICROGIRIA OCCIPITAL"
  },
  {
    "codigo":1208863005,
    "descripcion":"SÍNDROME DE QT PROLONGADO TIPO 5"
  },
  {
    "codigo":94751008,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA ESPALDA"
  },
  {
    "codigo":225823009,
    "descripcion":"VÍCTIMA DE EXPLOTACIÓN"
  },
  {
    "codigo":291521000119105,
    "descripcion":"HEMORRAGIA ESPONTÁNEA DE PORCIÓN CORTICAL INTRACEREBRAL HEMISFÉRICA"
  },
  {
    "codigo":289524006,
    "descripcion":"TUMEFACCIÓN VAGINAL"
  },
  {
    "codigo":92916007,
    "descripcion":"FORMA ANORMAL CONGÉNITA DE HUESO HIOIDES"
  },
  {
    "codigo":713673000,
    "descripcion":"TIENE PLANIFICACIÓN DE ATENCIÓN PARA EL FIN DE LA VIDA"
  },
  {
    "codigo":418761001,
    "descripcion":"SÍNDROME TEMPORAL DE LA MEDIA LUNA"
  },
  {
    "codigo":254921004,
    "descripcion":"ANGIOMIOLIPOMA RENAL"
  },
  {
    "codigo":91081006,
    "descripcion":"VASODILATACIÓN PERIFÉRICA"
  },
  {
    "codigo":1303497009,
    "descripcion":"ATRESIA CONGÉNITA DE FOSA NASAL DERECHA"
  },
  {
    "codigo":56478004,
    "descripcion":"REACCIÓN LEUCEMOIDE"
  },
  {
    "codigo":23710009,
    "descripcion":"MASTITIS POR BACILOS COLIFORMES"
  },
  {
    "codigo":710003004,
    "descripcion":"PAPILITIS LINGUAL TRANSITORIA"
  },
  {
    "codigo":413256000,
    "descripcion":"PANCREAS DIVISUM - INCOMPLETO"
  },
  {
    "codigo":249416003,
    "descripcion":"ACUMULACIÓN DE DETRITUS DEBAJO DE ENCÍAS"
  },
  {
    "codigo":314952003,
    "descripcion":"RECIDIVA LOCAL DE NEOPLASIA MALIGNA DE CAVIDAD BUCAL"
  },
  {
    "codigo":83741001,
    "descripcion":"PLACENTA ESPURIA"
  },
  {
    "codigo":278514000,
    "descripcion":"ESTENOSIS E INSUFICIENCIA DE LOS CONDUCTOS LAGRIMALES"
  },
  {
    "codigo":1359858006,
    "descripcion":"CARCINOMA METASTÁSICO A BERMELLÓN DE LABIO SUPERIOR"
  },
  {
    "codigo":704498007,
    "descripcion":"CONSENTIMIENTO PARA USO EDUCATIVO DE FOTOGRAFÍA MÉDICA OTORGADO"
  },
  {
    "codigo":737266007,
    "descripcion":"DEFICIENCIA LONGITUDINAL DE MIEMBROS SUPERIORES E INFERIORES"
  },
  {
    "codigo":276679003,
    "descripcion":"ABSCESO NEONATAL DE MAMA"
  },
  {
    "codigo":14535005,
    "descripcion":"POLIOMIELITIS NO PARALÍTICA AGUDA"
  },
  {
    "codigo":1259719005,
    "descripcion":"MESOTELIOMA PRIMARIO MALIGNO DE EPIPLÓN"
  },
  {
    "codigo":209308006,
    "descripcion":"FRACTURA-LUXACIÓN NO EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA DE PULGAR"
  },
  {
    "codigo":698993001,
    "descripcion":"MÚLTIPLES HERIDAS CONTUSOCORTANTES DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":371313002,
    "descripcion":"ATROFIA CEREBELOSA CORTICAL CONGÉNITA"
  },
  {
    "codigo":10865002,
    "descripcion":"EPERITROZOONOSIS"
  },
  {
    "codigo":240241003,
    "descripcion":"COXA PLANA"
  },
  {
    "codigo":404081005,
    "descripcion":"TUMOR DE SACO VITELINO"
  },
  {
    "codigo":402246000,
    "descripcion":"SENSIBILIZACIÓN ALÉRGICA CAUSADA POR PRUEBA DEL PARCHE"
  },
  {
    "codigo":238406001,
    "descripcion":"INFECCIÓN PIÓGENA DE UNA LOCALIZACIÓN ESPECÍFICA DE LA PIEL O EL TEJIDO SUBCUTÁNEO"
  },
  {
    "codigo":43633008,
    "descripcion":"PERITONITIS POR ORINA"
  },
  {
    "codigo":205638002,
    "descripcion":"MONOSOMÍA 21, MOSAICISMO"
  },
  {
    "codigo":305777009,
    "descripcion":"VISTO POR ORTOPTISTA"
  },
  {
    "codigo":294031000119103,
    "descripcion":"HEMICRANIA PAROXÍSTICA EPISÓDICA"
  },
  {
    "codigo":1155910005,
    "descripcion":"PORFIRIA CUTÁNEA TARDÍA ADQUIRIDA"
  },
  {
    "codigo":271174008,
    "descripcion":"AMPOLLA TRAUMÁTICA DE LA CADERA"
  },
  {
    "codigo":762694009,
    "descripcion":"ECTIMA"
  },
  {
    "codigo":105499002,
    "descripcion":"CONVALECENCIA"
  },
  {
    "codigo":236571000,
    "descripcion":"RECHAZO HIPERAGUDO DEL TRASPLANTE RENAL"
  },
  {
    "codigo":39963006,
    "descripcion":"DIARREA EN NIÑO DE PRIMERA INFANCIA"
  },
  {
    "codigo":1186843008,
    "descripcion":"INFERTILIDAD MASCULINA DEBIDA A ENFERMEDAD SISTÉMICA"
  },
  {
    "codigo":300272001,
    "descripcion":"FAUCES NORMALES"
  },
  {
    "codigo":365808004,
    "descripcion":"HALLAZGO RELACIONADO CON EL NIVEL DE PROTEÍNAS EN LÍQUIDO CEFALORRAQUÍDEO"
  },
  {
    "codigo":201968004,
    "descripcion":"ARTRITIS ALÉRGICA DE LA REGIÓN PÉLVICA Y EL MUSLO"
  },
  {
    "codigo":890096007,
    "descripcion":"EMBARAZO CON ANTICONCEPTIVO IMPLANTABLE"
  },
  {
    "codigo":38128008,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DE LA RODILLA"
  },
  {
    "codigo":70896009,
    "descripcion":"INTOXICACIÓN POR SORGHUM"
  },
  {
    "codigo":69061003,
    "descripcion":"OBSTRUCCIÓN EXTRÍNSECA DE LA TRÁQUEA"
  },
  {
    "codigo":298437003,
    "descripcion":"SIN AMPLITUD DE FLEXIÓN LATERAL PASIVA HACIA LA DERECHA DE LA COLUMNA VERTEBRAL CERVICAL"
  },
  {
    "codigo":200133007,
    "descripcion":"PARTO CON COMBINACIÓN DE FÓRCEPS Y VENTOSA"
  },
  {
    "codigo":167365009,
    "descripcion":"CUERPO EXTRAÑO PRESENTE EN EXAMEN MICROSCÓPICO DE ORINA"
  },
  {
    "codigo":1148570002,
    "descripcion":"INTOXICACIÓN ACCIDENTAL CAUSADA POR ANFETAMINA Y\/O DERIVADO DE ANFETAMINA"
  },
  {
    "codigo":296602001,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE TOBRAMICINA"
  },
  {
    "codigo":722586005,
    "descripcion":"POLICITEMIA NEONATAL POSTERIOR A TRANSFUSIÓN DE SANGRE"
  },
  {
    "codigo":720751000,
    "descripcion":"SÍNDROME DE ABSCESO ASÉPTICO SENSIBLE A LOS CORTICOSTEROIDES"
  },
  {
    "codigo":294767000,
    "descripcion":"ALERGIA A FINASTERIDA"
  },
  {
    "codigo":196463000,
    "descripcion":"SECUESTRO DENTAL"
  },
  {
    "codigo":15668521000119104,
    "descripcion":"TALIPES CALCANEOVALGO BILATERAL"
  },
  {
    "codigo":1179503001,
    "descripcion":"ÁCIDO BETA AMINOISOBUTÍRICO DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":165530009,
    "descripcion":"RECUENTO DE LINFOCITOS DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":425839000,
    "descripcion":"DOLOR IRRADIADO A LA CABEZA"
  },
  {
    "codigo":261999007,
    "descripcion":"SIN CARGA DE PESO"
  },
  {
    "codigo":422169003,
    "descripcion":"TRASTORNO ALÉRGICO NO ATÓPICO MEDIADO POR IGE"
  },
  {
    "codigo":225561003,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN EN TALÓN"
  },
  {
    "codigo":94489004,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA GLÁNDULA PINEAL"
  },
  {
    "codigo":127257007,
    "descripcion":"NEOPLASIA DE LOS GANGLIOS LINFÁTICOS AXILARES PECTORALES"
  },
  {
    "codigo":61721007,
    "descripcion":"ASA VECTOCARDIOGRÁFICA EN SENTIDO CONTRARIO A LAS AGUJAS DEL RELOJ"
  },
  {
    "codigo":1173998003,
    "descripcion":"SÍNDROME DE MICROCEFALIA POSNATAL, HIPOTONÍA INFANTIL, DIPLEJÍA ESPÁSTICA, DISARTRIA Y DISCAPACIDAD INTELECTUAL"
  },
  {
    "codigo":289262005,
    "descripcion":"HALLAZGO RELACIONADO CON LAS ESTRUCTURAS DE LA CONCEPCIÓN"
  },
  {
    "codigo":92654005,
    "descripcion":"CARCINOMA IN SITU DE LAS CELDILLAS AÉREAS MASTOIDEAS"
  },
  {
    "codigo":223726008,
    "descripcion":"PAQUIDERMOPERIOSTOSIS UNGUEAL"
  },
  {
    "codigo":123587001,
    "descripcion":"BRONCONEUMONÍA AGUDA"
  },
  {
    "codigo":58051000,
    "descripcion":"INFECCIÓN CAUSADA POR ISOSPORA HOMINIS"
  },
  {
    "codigo":713411004,
    "descripcion":"SÍNDROME DE DEFECACIÓN OBSTRUCTIVA"
  },
  {
    "codigo":189123007,
    "descripcion":"NEOPLASIA BENIGNA DEL LIGAMENTO OVÁRICO"
  },
  {
    "codigo":90819008,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE HOMBRO SIN INFECCIÓN"
  },
  {
    "codigo":254659009,
    "descripcion":"EPITELIOMA MÚLTIPLE AUTOCICATRIZANTE DE FERGUSON-SMITH"
  },
  {
    "codigo":323011000119105,
    "descripcion":"PULGAR EN GATILLO DE MANO DERECHA"
  },
  {
    "codigo":1268632002,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS PRIMARIO DE VESÍCULA BILIAR Y VÍA BILIAR EXTRAHEPÁTICA"
  },
  {
    "codigo":1137560004,
    "descripcion":"HIPERPLASIA FIBROEPITELIAL INFLAMATORIA DE MEMBRANA MUCOSA ORAL"
  },
  {
    "codigo":418499009,
    "descripcion":"OBSTRUCCIÓN DE CONDUCTO TESTICULAR EFERENTE"
  },
  {
    "codigo":88984006,
    "descripcion":"PARÁLISIS DISOCIATIVA"
  },
  {
    "codigo":283757004,
    "descripcion":"MORDEDURA DE PERRO EN DEDO DE LA MANO"
  },
  {
    "codigo":250989005,
    "descripcion":"PROLAPSO DE VALVA DE VÁLVULA MITRAL"
  },
  {
    "codigo":183618000,
    "descripcion":"SEGUIMIENTO EN 2-3 DÍAS"
  },
  {
    "codigo":281922000,
    "descripcion":"FRACTURA EN CUÑA DE VÉRTEBRA DORSAL"
  },
  {
    "codigo":314690006,
    "descripcion":"TALLA DEL NIÑO: PERCENTILO 3-8"
  },
  {
    "codigo":249154009,
    "descripcion":"DESCENSO DE LA PRESENTACIÓN DURANTE EL TRABAJO DE PARTO"
  },
  {
    "codigo":247319002,
    "descripcion":"GUSTO DE LA COMIDA PERSISTENTE"
  },
  {
    "codigo":50711007,
    "descripcion":"HEPATITIS VIRAL TIPO C"
  },
  {
    "codigo":1197591008,
    "descripcion":"SÍNDROME DE DISCAPACIDAD INTELECTUAL GRAVE, HIPOTONÍA, ESTRABISMO, CARA TOSCA, PIES PLANOVALGOS"
  },
  {
    "codigo":704236005,
    "descripcion":"FRACTURA EXPUESTA DE FALANGE DE PULGAR"
  },
  {
    "codigo":242824002,
    "descripcion":"SOBREDOSIS INTENCIONAL DE PARACETAMOL"
  },
  {
    "codigo":442092007,
    "descripcion":"DISTENSIÓN DE MÚSCULO DE LA CARA"
  },
  {
    "codigo":473025000,
    "descripcion":"COMPLICACIÓN ASOCIADA CON IMPLANTE MUSCULOESQUELÉTICO"
  },
  {
    "codigo":16108008,
    "descripcion":"INFECCIÓN CAUSADA POR MONIEZIA EXPANSA"
  },
  {
    "codigo":276417002,
    "descripcion":"POBRE CONTROL DEL MOVIMIENTO"
  },
  {
    "codigo":679671000119101,
    "descripcion":"ENDOFTALMITIS DE OJO IZQUIERDO DEBIDA A CIRUGÍA Y POSTERIOR A ELLA"
  },
  {
    "codigo":210881005,
    "descripcion":"LESIÓN EXPUESTA, VENA POPLÍTEA"
  },
  {
    "codigo":1259457006,
    "descripcion":"NEUROBLASTOMA PRIMARIO DE SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":351991000119102,
    "descripcion":"MELANOMA MALIGNO DE PIEL DE CADERA DERECHA"
  },
  {
    "codigo":733334001,
    "descripcion":"NISTAGMO PERVERTIDO"
  },
  {
    "codigo":405654002,
    "descripcion":"TIPO DE EQUIPAMIENTO"
  },
  {
    "codigo":209046008,
    "descripcion":"LUXACIÓN NO EXPUESTA ENTRE LA SÉPTIMA VÉRTEBRA CERVICAL Y LA PRIMERA VÉRTEBRA DORSAL"
  },
  {
    "codigo":1089271000119104,
    "descripcion":"ACÚFENO OBJETIVO DEL OÍDO IZQUIERDO"
  },
  {
    "codigo":371051005,
    "descripcion":"TROMBOSIS TRAUMÁTICA DE VENA AXILAR"
  },
  {
    "codigo":239979005,
    "descripcion":"RUPTURA DEL TENDÓN DEL MÚSCULO FLEXOR COMÚN SUPERFICIAL DEL DEDO DE LA MANO"
  },
  {
    "codigo":305515005,
    "descripcion":"BAJO ATENCIÓN DE PSIQUIATRA FORENSE"
  },
  {
    "codigo":35811000175104,
    "descripcion":"ÚLCERA POR PRESIÓN EN TOBILLO, ESTADIO IV"
  },
  {
    "codigo":895339008,
    "descripcion":"CURVATURA ANORMAL DE FALANGE PROXIMAL DE DEDO ANULAR"
  },
  {
    "codigo":403819009,
    "descripcion":"ELEFANTIASIS NEUROFIBROMATOSA"
  },
  {
    "codigo":238144002,
    "descripcion":"SOBRECARGA DE FOSFATO"
  },
  {
    "codigo":23011000175109,
    "descripcion":"COLONIZACIÓN POR HONGOS DE LA VÍA URINARIA"
  },
  {
    "codigo":10151000132103,
    "descripcion":"FIEBRE CAUSADA POR VIRUS"
  },
  {
    "codigo":269077000,
    "descripcion":"FRACTURA EXPUESTA DE SÉPTIMA VÉRTEBRA CERVICAL"
  },
  {
    "codigo":367381002,
    "descripcion":"CIERRE DE LA BOCA DÉBIL"
  },
  {
    "codigo":203541003,
    "descripcion":"DEDO DEL PIE SOBREPUESTO"
  },
  {
    "codigo":400149007,
    "descripcion":"LIPOBLASTOMATOSIS"
  },
  {
    "codigo":365546004,
    "descripcion":"ACEPTACIÓN DE LA SUPERVISIÓN LABORAL - HALLAZGO"
  },
  {
    "codigo":168938005,
    "descripcion":"ARTERIOGRAFÍA CORONARIA NORMAL"
  },
  {
    "codigo":37866007,
    "descripcion":"CALLO BLANDO"
  },
  {
    "codigo":398314007,
    "descripcion":"LACERACIÓN DE HIPOFARINGE"
  },
  {
    "codigo":36031001,
    "descripcion":"SENSACIÓN DE QUEMAZÓN EN LOS PIES"
  },
  {
    "codigo":234474009,
    "descripcion":"TRASTORNO PLAQUETARIO CON DEFICIENCIA DE CUERPOS DENSOS"
  },
  {
    "codigo":789695003,
    "descripcion":"ADENOCARCINOMA NO MUCINOSO IN SITU DE PULMÓN"
  },
  {
    "codigo":134335004,
    "descripcion":"TUMOR FIBROSO SOLITARIO"
  },
  {
    "codigo":3263004,
    "descripcion":"VERUMONTANITIS"
  },
  {
    "codigo":298175008,
    "descripcion":"INFLAMACIÓN DE ARTICULACIÓN INTERFALÁNGICA DE DEDO DE PIE"
  },
  {
    "codigo":127155009,
    "descripcion":"LINFADENOPATÍA PRECECAL"
  },
  {
    "codigo":1344916004,
    "descripcion":"METAPLASIA INTESTINAL DE MEMBRANA MUCOSA DE FONDO GÁSTRICO"
  },
  {
    "codigo":296340005,
    "descripcion":"SOBREDOSIS DE PROPRANOLOL"
  },
  {
    "codigo":165268007,
    "descripcion":"CAMINA MÁS DE 120 METROS EN 1 MINUTO"
  },
  {
    "codigo":230804008,
    "descripcion":"DEHISCENCIA DE REPARACIÓN DE NERVIO"
  },
  {
    "codigo":294505008,
    "descripcion":"ALERGIA A AMOXICILINA"
  },
  {
    "codigo":30526003,
    "descripcion":"OMOCÉFALO"
  },
  {
    "codigo":94227002,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LOS GANGLIOS LINFÁTICOS BRONCOPULMONARES"
  },
  {
    "codigo":290835004,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR IMIPRAMINA"
  },
  {
    "codigo":39711000087101,
    "descripcion":"DOLOR VISCERAL CRÓNICO EN REGIÓN DE TÓRAX DEBIDO A TRASTORNO"
  },
  {
    "codigo":1208339007,
    "descripcion":"SÍNDROME DE NEUHAUSER-EICHNER-OPITZ"
  },
  {
    "codigo":92392000,
    "descripcion":"NEOPLASIA BENIGNA DE PARTES BLANDAS DE LA CADERA"
  },
  {
    "codigo":44831000087103,
    "descripcion":"INFARTO AGUDO DE MIOCARDIO CON ELEVACIÓN DE SEGMENTO ST DEBIDO A OCLUSIÓN DE RAMA OBTUSA MARGINAL DE RAMA CIRCUNFLEJA DE ARTERIA CORONARIA IZQUIERDA"
  },
  {
    "codigo":42271000087106,
    "descripcion":"HERIDA DE GENITALES EXTERNOS MASCULINOS POR MORDEDURA"
  },
  {
    "codigo":289000006,
    "descripcion":"CAPAZ DE ALIMENTARSE"
  },
  {
    "codigo":125160007,
    "descripcion":"INADECUADO PARA EVALUACIÓN POR RUPTURA DEL PORTAOBJETOS"
  },
  {
    "codigo":188861002,
    "descripcion":"NEOPLASIA BENIGNA DE MESOCOLON"
  },
  {
    "codigo":254397003,
    "descripcion":"NEOPLASIA DE FRENILLO DE LABIO SUPERIOR"
  },
  {
    "codigo":287165005,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ANALGÉSICO"
  },
  {
    "codigo":1237437006,
    "descripcion":"BLEFARITIS DE PÁRPADO INFERIOR CAUSADA POR ESTAFILOCOCOS"
  },
  {
    "codigo":299051000119108,
    "descripcion":"HEMARTROSIS DE PIE IZQUIERDO"
  },
  {
    "codigo":23186000,
    "descripcion":"JAQUECA MENSTRUAL"
  },
  {
    "codigo":416402001,
    "descripcion":"ENFERMEDAD TROFOBLÁSTICA GESTACIONAL"
  },
  {
    "codigo":1335741009,
    "descripcion":"HIPOFUNCIÓN TESTICULAR DEBIDA A RADIOTERAPIA Y POSTERIOR A ELLA"
  },
  {
    "codigo":418237007,
    "descripcion":"DOLOR EN DEDO GORDO"
  },
  {
    "codigo":10866731000119109,
    "descripcion":"LACERACIÓN DE LA REGIÓN INFERIOR DEL DORSO"
  },
  {
    "codigo":21351003,
    "descripcion":"FRACTURA DE FALANGE DE PIE"
  },
  {
    "codigo":54119007,
    "descripcion":"DEFICIENCIA CONGÉNITA DE TRIPSINA PANCREÁTICA"
  },
  {
    "codigo":185191008,
    "descripcion":"ATENDIDO EN CONSULTORIO ESPECIALIZADO EN FRACTURAS"
  },
  {
    "codigo":85052001,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO DE TOBILLO"
  },
  {
    "codigo":283495008,
    "descripcion":"HERIDA PUNZANTE EN EL TALÓN"
  },
  {
    "codigo":314428001,
    "descripcion":"CICLITIS POSTERIOR"
  },
  {
    "codigo":609340004,
    "descripcion":"INFECCIÓN PROFUNDA EN LOCALIZACIÓN DE HERIDA QUIRÚRGICA"
  },
  {
    "codigo":248892003,
    "descripcion":"NIVEL DE DESCENSO DEL FONDO DE SACO VAGINAL"
  },
  {
    "codigo":351000119100,
    "descripcion":"FALTA DE AUMENTO DE PESO EN LA INFANCIA"
  },
  {
    "codigo":447335007,
    "descripcion":"NEFRONOPTISIS TIPO 6"
  },
  {
    "codigo":1197329001,
    "descripcion":"CARCINOMA METASTÁSICO DE GANGLIO LINFÁTICO ABDOMINAL"
  },
  {
    "codigo":312593004,
    "descripcion":"ÉMBOLO DE ARTERIA DEL TRONCO"
  },
  {
    "codigo":1230097004,
    "descripcion":"SÍNDROME DE TIMOTHY ATÍPICO"
  },
  {
    "codigo":17681007,
    "descripcion":"HEPATITIS DEBIDA A TOXOPLASMOSIS DISEMINADA ADQUIRIDA"
  },
  {
    "codigo":12206431000119102,
    "descripcion":"INFECCIÓN ASOCIADA CON PRÓTESIS ARTICULAR DE RODILLA DERECHA"
  },
  {
    "codigo":247057008,
    "descripcion":"OPACIDADES CORTICALES DE CRISTALINO"
  },
  {
    "codigo":441830002,
    "descripcion":"TRASTORNO DEL DESPERTAR CONFUSIONAL"
  },
  {
    "codigo":212454006,
    "descripcion":"RUPTURA TRAUMÁTICA DE DISCO INTERVERTEBRAL LUMBAR"
  },
  {
    "codigo":210619000,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE PUNTA DE PULGAR, TIPO 2"
  },
  {
    "codigo":308923001,
    "descripcion":"SÍNTOMA OCULAR"
  },
  {
    "codigo":1193659001,
    "descripcion":"LESIÓN DE REGIÓN OCULAR CAUSADA POR TENSOR ELÁSTICO"
  },
  {
    "codigo":472763005,
    "descripcion":"TRASTORNO DE AURÍCULA IZQUIERDA"
  },
  {
    "codigo":14011008,
    "descripcion":"DIVERTICULOSIS TRAQUEAL"
  },
  {
    "codigo":896912001,
    "descripcion":"FORMA ANCHA ANORMAL CONGÉNITA DE FALANGE PROXIMAL DE PULGAR"
  },
  {
    "codigo":110480002,
    "descripcion":"ALTERACIÓN EN EL ESTILO DE VIDA, ASOCIADA CON LA POSICIÓN SOCIAL"
  },
  {
    "codigo":733072002,
    "descripcion":"SÍNDROME DE ALANINURIA, MICROCEFALIA, ENANISMO, HIPOPLASIA DEL ESMALTE DENTAL Y DIABETES MELLITUS"
  },
  {
    "codigo":700304006,
    "descripcion":"ARTROSIS PRIMARIA DE ARTICULACIÓN CALCANEOCUBOIDEA"
  },
  {
    "codigo":307088009,
    "descripcion":"INCAPAZ DE ANALIZAR INFORMACIÓN"
  },
  {
    "codigo":403557001,
    "descripcion":"HENDIDURA CERVICAL DE LÍNEA MEDIA"
  },
  {
    "codigo":10869241000119102,
    "descripcion":"HERIDA POR ARMA BLANCA DE REGIÓN LUMBAR"
  },
  {
    "codigo":1055247001,
    "descripcion":"AGENESIA DE EPÍFISIS DE FALANGE DISTAL DE DEDO ÍNDICE"
  },
  {
    "codigo":236047002,
    "descripcion":"EVENTRACIÓN PERINEAL"
  },
  {
    "codigo":301583002,
    "descripcion":"INCAPAZ DE MANEJARSE EN ESCALONES Y ESCALERAS"
  },
  {
    "codigo":432655005,
    "descripcion":"ESTADO DE ESFUERZO CARDÍACO"
  },
  {
    "codigo":203279007,
    "descripcion":"TUBERCULOSIS DE LOS HUESOS DE LA MANO"
  },
  {
    "codigo":39439008,
    "descripcion":"LEISHMANIASIS CUTÁNEA HÚMEDA"
  },
  {
    "codigo":299748002,
    "descripcion":"REFLEJO PALMOMENTONIANO AUSENTE"
  },
  {
    "codigo":234212003,
    "descripcion":"FRACTURA DE LA DERIVACIÓN DEL ELECTRODO DEL MARCAPASOS"
  },
  {
    "codigo":398052002,
    "descripcion":"HIPOTERMIA INDUCIDA"
  },
  {
    "codigo":15702521000119106,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE TENDÓN DE MANO IZQUIERDA"
  },
  {
    "codigo":365284006,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA INSERTAR Y REMOVER EL TAPÓN DE RESIDUOS"
  },
  {
    "codigo":232377002,
    "descripcion":"HEMATOMA DEL TABIQUE NASAL"
  },
  {
    "codigo":363449006,
    "descripcion":"NEOPLASIA MALIGNA DE TESTÍCULO"
  },
  {
    "codigo":301561000119108,
    "descripcion":"ABSCESO DE VAINA TENDINOSA DE ANTEBRAZO IZQUIERDO"
  },
  {
    "codigo":33934002,
    "descripcion":"OTITIS EXTERNA HEMORRÁGICA"
  },
  {
    "codigo":66702003,
    "descripcion":"INFECCIÓN CAUSADA POR SKRJABINEMA"
  },
  {
    "codigo":722062004,
    "descripcion":"OCULOTRICODISPLASIA"
  },
  {
    "codigo":230542008,
    "descripcion":"PARÁLISIS CONGÉNITA DEL NERVIO FACIAL"
  },
  {
    "codigo":294243007,
    "descripcion":"ALERGIA A FLAVOXATO"
  },
  {
    "codigo":30264000,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO DE RODILLA"
  },
  {
    "codigo":95800001,
    "descripcion":"HIALOSIS ASTEROIDE"
  },
  {
    "codigo":194104000,
    "descripcion":"EXOTROPÍA ALTERNANTE INTERMITENTE"
  },
  {
    "codigo":1144376004,
    "descripcion":"PALADAR ALTO"
  },
  {
    "codigo":423480004,
    "descripcion":"CARCINOMA DE OVARIO, ESTADIO 3"
  },
  {
    "codigo":292408007,
    "descripcion":"REACCIÓN ADVERSA A INHIBIDOR DE LA DESCARBOXILASA"
  },
  {
    "codigo":631000124104,
    "descripcion":"CUMPLE CON LA PRESCRIPCIÓN DE DIÁLISIS PERITONEAL"
  },
  {
    "codigo":225037001,
    "descripcion":"DESLICES MENORES DE LA MEMORIA"
  },
  {
    "codigo":128568009,
    "descripcion":"AURÍCULA VENOSA SISTÉMICA DE ORIGEN CONGÉNITO"
  },
  {
    "codigo":126733004,
    "descripcion":"NEOPLASIA DEL EPICARDIO"
  },
  {
    "codigo":1306381005,
    "descripcion":"NEOPLASIA DE CUADRANTE INFERIOR INTERNO DE MAMA"
  },
  {
    "codigo":10816301000119102,
    "descripcion":"FRACTURA EXPUESTA EN MARTILLO DE FALANGE DISTAL DE DEDO MEÑIQUE DE MANO DERECHA"
  },
  {
    "codigo":92130001,
    "descripcion":"NEOPLASIA BENIGNA DE LA CABEZA DEL PÁNCREAS"
  },
  {
    "codigo":26594006,
    "descripcion":"SIRINGOBULBIA"
  },
  {
    "codigo":288738006,
    "descripcion":"CAPAZ DE EMPLEAR AUTOEXPRESIÓN"
  },
  {
    "codigo":254135003,
    "descripcion":"DISPLASIA CRANEOMETAFISARIA - TIPO LEVE"
  },
  {
    "codigo":16032711000119100,
    "descripcion":"NECROSIS AVASCULAR DE HUESO DE REGIÓN DE CODO IZQUIERDO"
  },
  {
    "codigo":448908007,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE ÓRGANO DIGESTIVO"
  },
  {
    "codigo":447073000,
    "descripcion":"PULSO TIBIAL ANTERIOR TRIFÁSICO"
  },
  {
    "codigo":283233000,
    "descripcion":"VIDRIO EN REGIÓN OCULAR"
  },
  {
    "codigo":53857003,
    "descripcion":"SÍNDROME DE PARÁLISIS DEL PLEXO BRAQUIAL HEREDOFAMILIAR"
  },
  {
    "codigo":250465006,
    "descripcion":"DETERMINACIÓN DEL CRECIMIENTO BACTERIANO"
  },
  {
    "codigo":838454002,
    "descripcion":"INSUFICIENCIA DE VÁLVULA TRICÚSPIDE LEVE"
  },
  {
    "codigo":281398003,
    "descripcion":"TUMORACIÓN DE REGIÓN INGUINAL"
  },
  {
    "codigo":707382005,
    "descripcion":"HAMARTOMA MÚLTIPLE DE PULMÓN"
  },
  {
    "codigo":248630007,
    "descripcion":"FRECUENCIA DEL PULSO ALTERADA"
  },
  {
    "codigo":52022007,
    "descripcion":"AUSENCIA CONGÉNITA DEL CÚBITO"
  },
  {
    "codigo":10625991000119104,
    "descripcion":"ÁNTRAX DE AXILA IZQUIERDA"
  },
  {
    "codigo":771083005,
    "descripcion":"DOLOR EN EL BRAZO"
  },
  {
    "codigo":310496002,
    "descripcion":"DEPRESIÓN MODERADA"
  },
  {
    "codigo":212192004,
    "descripcion":"LESIÓN NO EXPUESTA DE LA COLA DE CABALLO"
  },
  {
    "codigo":16907361000119100,
    "descripcion":"ECTROPIÓN PARALÍTICO DE PÁRPADO INFERIOR DERECHO"
  },
  {
    "codigo":48352007,
    "descripcion":"INTOXICACIÓN POR DIAMIDINA"
  },
  {
    "codigo":308661000,
    "descripcion":"ABSCESO DE LA MEJILLA"
  },
  {
    "codigo":275893001,
    "descripcion":"CÁLCULO RENAL DE FOSFATO"
  },
  {
    "codigo":81120009,
    "descripcion":"TRASTORNO FUNCIONAL DEL INTESTINO"
  },
  {
    "codigo":110218000,
    "descripcion":"QUEMADURA DEL PALADAR DURO"
  },
  {
    "codigo":1258933008,
    "descripcion":"FÍSTULA ARTERIOVENOSA DE ARTERIA CARÓTIDA Y VENA YUGULAR INTERNA"
  },
  {
    "codigo":11914001,
    "descripcion":"PRESENTACIÓN TRANSVERSA U OBLICUA DEL FETO"
  },
  {
    "codigo":863882007,
    "descripcion":"CON MAYOR RIESGO DE ÚLCERA DE PIE IZQUIERDO DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":763743003,
    "descripcion":"SÍNDROME DE DISCAPACIDAD INTELECTUAL, ESPASTICIDAD Y ECTRODACTILIA"
  },
  {
    "codigo":761908002,
    "descripcion":"DEFICIENCIA BILATERAL DE ESTRUCTURAS DEL SISTEMA NERVIOSO"
  },
  {
    "codigo":237620003,
    "descripcion":"ESTADO METABÓLICO ANORMAL DEBIDO A DIABETES MELLITUS"
  },
  {
    "codigo":235785000,
    "descripcion":"FÍSTULA URETÉRICA HACIA EL RECTO"
  },
  {
    "codigo":10927201000119107,
    "descripcion":"FRACTURA NO EXPUESTA DE CUELLO DE PRIMER METACARPIANO DE MANO DERECHA"
  },
  {
    "codigo":792841006,
    "descripcion":"PULSO EN ARTERIA TIBIAL POSTERIOR IZQUIERDA AUSENTE"
  },
  {
    "codigo":203017007,
    "descripcion":"MIOSITIS INFECCIOSA DE PIERNA"
  },
  {
    "codigo":365022000,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD DE PRODUCIR COMBINACIONES SONORAS\/SORDAS"
  },
  {
    "codigo":102878001,
    "descripcion":"ABORTO RECURRENTE"
  },
  {
    "codigo":201182003,
    "descripcion":"PERIFOLICULITIS ABSCEDADA DE LA CABEZA"
  },
  {
    "codigo":168414003,
    "descripcion":"EXTENDIDO CERVICAL: CAMBIOS INFLAMATORIOS"
  },
  {
    "codigo":233950008,
    "descripcion":"HIPERTENSIÓN PULMONAR ASOCIADA CON HIPOVENTILACIÓN CRÓNICA"
  },
  {
    "codigo":428723000,
    "descripcion":"FRACTURA NO EXPUESTA POR AVULSIÓN DE LA ESPINA ILÍACA ANTEROSUPERIOR"
  },
  {
    "codigo":15748281000119100,
    "descripcion":"MASA BILATERAL DE ARTICULACIONES DE PIES"
  },
  {
    "codigo":15715001000119101,
    "descripcion":"OSTEOFITOS BILATERALES DE TOBILLOS"
  },
  {
    "codigo":316601000119102,
    "descripcion":"OSTEOFITO DE RODILLA IZQUIERDA"
  },
  {
    "codigo":339641000119102,
    "descripcion":"LUXACIÓN ESPONTÁNEA DE OJO IZQUIERDO"
  },
  {
    "codigo":298681000119104,
    "descripcion":"OSTEONECROSIS DE MANO DEBIDA A TRAUMATISMO"
  },
  {
    "codigo":334521000119105,
    "descripcion":"ESTENOSIS DE CANALÍCULO LAGRIMAL DERECHO"
  },
  {
    "codigo":35507009,
    "descripcion":"QUEMADURA PROFUNDA DE TERCER GRADO DE LA PARED DEL TÓRAX"
  },
  {
    "codigo":672441000119103,
    "descripcion":"HEMIPLEJÍA DE LADO NO DOMINANTE DEBIDA A ACCIDENTE CEREBROVASCULAR ISQUÉMICO Y POSTERIOR A ÉL"
  },
  {
    "codigo":367801000119102,
    "descripcion":"OLIGOZOOSPERMIA DEBIDA A ENFERMEDAD SISTÉMICA"
  },
  {
    "codigo":285881000119109,
    "descripcion":"ENFERMEDAD RENAL CRÓNICA POR HIPERTENSIÓN MALIGNA, ESTADIO 4"
  },
  {
    "codigo":15709881000119102,
    "descripcion":"HEMANGIOMA DE COROIDES DERECHA"
  },
  {
    "codigo":1087161000119105,
    "descripcion":"HEMORRAGIA GÁSTRICA DEBIDA A GASTRITIS HIPERTRÓFICA"
  },
  {
    "codigo":15668921000119109,
    "descripcion":"DEFORMIDAD CONGÉNITA DE MANO IZQUIERDA"
  },
  {
    "codigo":685574841000119108,
    "descripcion":"RETINOPATÍA PROLIFERATIVA DE OJO IZQUIERDO DEBIDA A ANEMIA DREPANOCÍTICA"
  },
  {
    "codigo":721800006,
    "descripcion":"INFECCIÓN CAUSADA POR LACAZIA"
  },
  {
    "codigo":293981001,
    "descripcion":"ALERGIA A PRACTOLOL"
  },
  {
    "codigo":687801000119108,
    "descripcion":"RABDOMIOSARCOMA PRIMARIO DE GLÚTEO"
  },
  {
    "codigo":16472761000119108,
    "descripcion":"SHOCK OBSTRUCTIVO"
  },
  {
    "codigo":1092281000119109,
    "descripcion":"CAMBIO TEMPORARIO DE UMBRAL AUDITIVO DE OÍDO DERECHO"
  },
  {
    "codigo":195677001,
    "descripcion":"AMIGDALITIS AGUDA RECURRENTE"
  },
  {
    "codigo":230280008,
    "descripcion":"ENFERMEDAD DE ALZHEIMER CON AFASIA PROGRESIVA"
  },
  {
    "codigo":228445002,
    "descripcion":"NO HACE EJERCICIO"
  },
  {
    "codigo":423218002,
    "descripcion":"FORMA DE LA BOCA NORMAL"
  },
  {
    "codigo":15953301000119102,
    "descripcion":"FISURA DE PEZÓN IZQUIERDO"
  },
  {
    "codigo":333051000119109,
    "descripcion":"LUXACIÓN POSTERIOR DE CRISTALINO DE OJO DERECHO"
  },
  {
    "codigo":161074005,
    "descripcion":"INFANCIA CARENCIADA"
  },
  {
    "codigo":292146007,
    "descripcion":"REACCIÓN ADVERSA A FÁRMACO ANTIESPASMÓDICO"
  },
  {
    "codigo":95538007,
    "descripcion":"GANGRENA DE INTESTINO GRUESO"
  },
  {
    "codigo":28167005,
    "descripcion":"HEBRAS VÍTREAS"
  },
  {
    "codigo":93703006,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE VASO SANGUÍNEO DEL MIEMBRO INFERIOR"
  },
  {
    "codigo":1142279005,
    "descripcion":"ATROFIA EN PARCHES DE EPITELIO PIGMENTARIO DE RETINA"
  },
  {
    "codigo":386780000,
    "descripcion":"CORTICOSTERONA ANORMAL"
  },
  {
    "codigo":192007009,
    "descripcion":"INDIVIDUO QUE REQUIERE POCAS HORAS DE SUEÑO"
  },
  {
    "codigo":60935008,
    "descripcion":"PARAMIOCLONÍA MÚLTIPLE"
  },
  {
    "codigo":1304284002,
    "descripcion":"GLAUCOMA DE OJO IZQUIERDO DEBIDO A HEMÓLISIS POSTERIOR A HEMORRAGIA INTRAOCULAR"
  },
  {
    "codigo":323079008,
    "descripcion":"TROMBOCITOPENIA ASOCIADA A SECUESTRO"
  },
  {
    "codigo":124636001,
    "descripcion":"DEFICIENCIA DE CARBONO - CARBONO LIASA"
  },
  {
    "codigo":714460000,
    "descripcion":"ENFERMEDAD DE CASTLEMAN CONCOMITANTE CON INFECCIÓN POR HERPESVIRUS HUMANO 8"
  },
  {
    "codigo":91868003,
    "descripcion":"AUSENCIA CONGÉNITA DE ESTÓMAGO"
  },
  {
    "codigo":286641001,
    "descripcion":"MALHUMORADO"
  },
  {
    "codigo":1204145004,
    "descripcion":"ATEROSCLEROSIS DE ARTERIA BRAQUIAL"
  },
  {
    "codigo":253873007,
    "descripcion":"RIÑÓN DOBLE CON REFLUJO EN UN URÉTER"
  },
  {
    "codigo":57265009,
    "descripcion":"OBSTRUCCIÓN CONGÉNITA DE INTESTINO GRUESO"
  },
  {
    "codigo":448646002,
    "descripcion":"HIPOPLASIA DE CAYADO AÓRTICO DISTAL A ARTERIA SUBCLAVIA"
  },
  {
    "codigo":284806001,
    "descripcion":"NO SE BAÑA"
  },
  {
    "codigo":306581000119109,
    "descripcion":"GOTA CRÓNICA, SIN TOFO, CAUSADA POR FÁRMACO"
  },
  {
    "codigo":10683951000119103,
    "descripcion":"NÓDULO DEL TEJIDO CELULAR SUBCUTÁNEO DEL PIE IZQUIERDO"
  },
  {
    "codigo":219270006,
    "descripcion":"LESIÓN POR INTERVENCIÓN LEGAL CON GAS LACRIMÓGENO"
  },
  {
    "codigo":55430005,
    "descripcion":"LESIÓN TRAUMÁTICA DE TOBILLO EN SUPINACIÓN-EVERSIÓN, GRADO 4"
  },
  {
    "codigo":1003867007,
    "descripcion":"DUPLICACIÓN DE PORCIÓN PROXIMAL DEL BRAZO LARGO DEL CROMOSOMA 4"
  },
  {
    "codigo":1264176000,
    "descripcion":"PIERCING EN TERCIO MEDIO DE LABIO INFERIOR"
  },
  {
    "codigo":444976001,
    "descripcion":"SÍNDROME URÉMICO HEMOLÍTICO CONGÉNITO"
  },
  {
    "codigo":282971008,
    "descripcion":"CAPAZ DE ESTAR PARADO"
  },
  {
    "codigo":51760006,
    "descripcion":"FRACTURA DE CUATRO COSTILLAS"
  },
  {
    "codigo":17157001,
    "descripcion":"QUERATITIS INTERSTICIAL DIFUSA"
  },
  {
    "codigo":281136009,
    "descripcion":"CAPAZ DE PENSAR EN FORMA ABSTRACTA"
  },
  {
    "codigo":246533006,
    "descripcion":"CRISIS EPILÉPTICA SENSORIAL CON CONCIENCIA PRESERVADA DE INICIO FOCAL"
  },
  {
    "codigo":16008751000119108,
    "descripcion":"ARTRITIS DE DEDO DE MANO DERECHA DEBIDA A TRAUMATISMO"
  },
  {
    "codigo":48090007,
    "descripcion":"DISFONÍA ESPÁSTICA NEUROLÓGICA DEL ADUCTOR"
  },
  {
    "codigo":308399000,
    "descripcion":"ESTADO DE RECONVOCATORIA DEL PACIENTE"
  },
  {
    "codigo":277466009,
    "descripcion":"TRASTORNO LINFOPROLIFERATIVO"
  },
  {
    "codigo":1293274007,
    "descripcion":"DERRAME ARTICULAR DE MUÑECA"
  },
  {
    "codigo":275631003,
    "descripcion":"PACIENTE EN ESTUDIO CARDÍACO"
  },
  {
    "codigo":111791000,
    "descripcion":"INTOXICACIÓN POR POLYGONUM"
  },
  {
    "codigo":734383005,
    "descripcion":"TROMBOSIS DE ARTERIA CEREBRAL MEDIA IZQUIERDA"
  },
  {
    "codigo":898223002,
    "descripcion":"FUSIÓN ANORMAL CONGÉNITA DE TERCER METACARPIANO"
  },
  {
    "codigo":210095009,
    "descripcion":"LESIÓN EXPUESTA DEL TIMO"
  },
  {
    "codigo":372100004,
    "descripcion":"CARCINOMA DE EXOCÉRVIX"
  },
  {
    "codigo":271961001,
    "descripcion":"MALFORMACIÓN CONGÉNITA DE OVARIOS Y TROMPAS DE FALOPIO"
  },
  {
    "codigo":239193002,
    "descripcion":"CICATRIZACIÓN TARDÍA DE SITIO DONANTE DE PIEL"
  },
  {
    "codigo":699780009,
    "descripcion":"DESVIACIÓN DE LÍNEA MEDIA MAXILAR Y MANDIBULAR HACIA LA IZQUIERDA"
  },
  {
    "codigo":206425006,
    "descripcion":"HEMORRAGIA RECTAL NEONATAL"
  },
  {
    "codigo":697945009,
    "descripcion":"TORUS MAXILAR PRESENTE"
  },
  {
    "codigo":73518002,
    "descripcion":"QUEMADURA DE LABIO"
  },
  {
    "codigo":1351470001,
    "descripcion":"ESOFORIA COMITANTE"
  },
  {
    "codigo":302894006,
    "descripcion":"CAMBIOS EN EL CUERPO CILIAR RELACIONADOS CON LA EDAD"
  },
  {
    "codigo":202755000,
    "descripcion":"CALCIFICACIÓN DE DISCO LUMBAR"
  },
  {
    "codigo":171822009,
    "descripcion":"PARÁLISIS ESPINAL ATRÓFICA AGUDA"
  },
  {
    "codigo":301059002,
    "descripcion":"HALLAZGO RELACIONADO CON LA POSICIÓN DEL CUELLO"
  },
  {
    "codigo":399363000,
    "descripcion":"MUERTE FETAL TARDÍA QUE AFECTA EL MANEJO DE LA MADRE"
  },
  {
    "codigo":169987004,
    "descripcion":"INCORPORACIÓN DE SÓLIDOS A LOS 6 MESES"
  },
  {
    "codigo":366595005,
    "descripcion":"AMPLITUD DE LA ROTACIÓN EXTERNA DE RODILLA - HALLAZGO"
  },
  {
    "codigo":200920000,
    "descripcion":"ERITEMA ANULAR"
  },
  {
    "codigo":397528003,
    "descripcion":"DEFICIENCIA DE LA CAPA ACUOSA DE LAS LÁGRIMAS"
  },
  {
    "codigo":69848004,
    "descripcion":"ESPERMATOSQUESIS"
  },
  {
    "codigo":299224005,
    "descripcion":"HALLAZGO RELACIONADO CON LA PROPORCIÓN DE LA EXTREMIDAD INFERIOR"
  },
  {
    "codigo":364760007,
    "descripcion":"CARACTERÍSTICAS DE LA CEFALEA - HALLAZGO"
  },
  {
    "codigo":102616008,
    "descripcion":"DOLOR EN LA BOCA"
  },
  {
    "codigo":231853000,
    "descripcion":"VÁRICE DE ÓRBITA"
  },
  {
    "codigo":233688007,
    "descripcion":"ASMA INDUCIDA POR SULFITO"
  },
  {
    "codigo":68013003,
    "descripcion":"INFECCIÓN CAUSADA POR LEPTOSPIRA AUSTRALIS"
  },
  {
    "codigo":166317001,
    "descripcion":"UREA Y ELECTRÓLITOS ANORMALES"
  },
  {
    "codigo":723373006,
    "descripcion":"ENFERMEDAD QUÍSTICA DE LA MÉDULA RENAL AUTOSÓMICA DOMINANTE CON HIPERURICEMIA"
  },
  {
    "codigo":788909008,
    "descripcion":"TRASTORNO DISOCIATIVO CON SÍNTOMA NEUROLÓGICO CONCOMITANTE CON ESPASMO FACIAL"
  },
  {
    "codigo":721538000,
    "descripcion":"PSORIASIS DE REGIÓN ANOGENITAL"
  },
  {
    "codigo":33410002,
    "descripcion":"SÍNDROME DE MARSHALL"
  },
  {
    "codigo":395693008,
    "descripcion":"DEFORMIDAD CONGÉNITA DE POSICIÓN DEL PIE"
  },
  {
    "codigo":262786004,
    "descripcion":"RUPTURA DE BRONQUIO"
  },
  {
    "codigo":197250003,
    "descripcion":"FÍSTULA COLÓNICA"
  },
  {
    "codigo":2477008,
    "descripcion":"TROMBOFLEBITIS SUPERFICIAL"
  },
  {
    "codigo":361090008,
    "descripcion":"DEFICIENCIA DE FOSFATASA"
  },
  {
    "codigo":295554008,
    "descripcion":"SOBREDOSIS DE CINCOCAÍNA"
  },
  {
    "codigo":293719002,
    "descripcion":"ALERGIA A BUPIVACAÍNA"
  },
  {
    "codigo":129879003,
    "descripcion":"HALLAZGO RELACIONADO CON LA PATERNIDAD O MATERNIDAD"
  },
  {
    "codigo":10850301000119105,
    "descripcion":"HERIDA ABIERTA DE PARED TORÁCICA DERECHA"
  },
  {
    "codigo":29740003,
    "descripcion":"MARASMO NUTRICIONAL"
  },
  {
    "codigo":160812005,
    "descripcion":"PROBLEMA RELACIONADO CON SEGURO LEGAL"
  },
  {
    "codigo":128044005,
    "descripcion":"TRASTORNO DE LA PIEL Y\/O DEL TEJIDO CELULAR SUBCUTÁNEO DEL CUELLO"
  },
  {
    "codigo":717868009,
    "descripcion":"HEMORRAGIA INTRAMURAL DE ESTÓMAGO"
  },
  {
    "codigo":224513001,
    "descripcion":"CUIDADOR INFORMAL CON APOYO"
  },
  {
    "codigo":93441003,
    "descripcion":"CENTRO CARTILAGINOSO DE VÉRTEBRA CERVICAL CON FORMA DE MANCUERNA"
  },
  {
    "codigo":879873008,
    "descripcion":"DERMATITIS IRRITATIVA POR CONTACTO CAUSADA POR SALIVA"
  },
  {
    "codigo":124374004,
    "descripcion":"DEFICIENCIA DE TRANSFORMILASA"
  },
  {
    "codigo":10741911000119103,
    "descripcion":"ANOMALÍA DE CUELLO DE ÚTERO QUE AFECTA EMBARAZO"
  },
  {
    "codigo":288214008,
    "descripcion":"RUPTURA DE MEMBRANA SINOVIAL - MÚLTIPLE"
  },
  {
    "codigo":253611000,
    "descripcion":"VÁLVULA AÓRTICA CUADRICÚSPIDE"
  },
  {
    "codigo":24235005,
    "descripcion":"HIDROTÓRAX TUBERCULOSO"
  },
  {
    "codigo":188075008,
    "descripcion":"MELANOMA MALIGNO DE PIE"
  },
  {
    "codigo":448384001,
    "descripcion":"LINFOMA NO HODGKIN DE NARIZ"
  },
  {
    "codigo":55168004,
    "descripcion":"HEMORROIDES EXTERNAS ULCERADAS"
  },
  {
    "codigo":282709000,
    "descripcion":"CAPAZ DE EMPUJAR Y ARRASTRAR HACIA ADELANTE UN JUGUETE PEQUEÑO CON RUEDAS"
  },
  {
    "codigo":338071000119107,
    "descripcion":"DEGENERACIÓN CISTOIDE PERIFÉRICA DE RETINA DE OJO IZQUIERDO"
  },
  {
    "codigo":249941003,
    "descripcion":"DEBILIDAD DE LA CINTURA PÉLVICA"
  },
  {
    "codigo":1003605004,
    "descripcion":"SOSPECHA DE GLAUCOMA DEBIDO A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":53333005,
    "descripcion":"MUTISMO AQUINÉTICO"
  },
  {
    "codigo":315477003,
    "descripcion":"NACIDO EN MAURITANIA"
  },
  {
    "codigo":11780401000119102,
    "descripcion":"LESIÓN TRAUMÁTICA DE CARTÍLAGO ARTICULAR DE RODILLA DERECHA"
  },
  {
    "codigo":870698001,
    "descripcion":"RANGO DE FRECUENCIA CARDÍACA FETAL BASAL DE 100 A 120"
  },
  {
    "codigo":1263914002,
    "descripcion":"CARCINOMA PAPILAR DE CÉLULAS RENALES METASTÁSICO"
  },
  {
    "codigo":11862321000119102,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE PIE DERECHO"
  },
  {
    "codigo":1296682006,
    "descripcion":"PRESIÓN INTRAOCULAR DE OJO IZQUIERDO POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":248106009,
    "descripcion":"MASTURBACIÓN PÚBLICA"
  },
  {
    "codigo":770559003,
    "descripcion":"LEIOMIOSARCOMA DE CUERPO UTERINO"
  },
  {
    "codigo":705023006,
    "descripcion":"NACIDO EN LA REPÚBLICA DEMOCRÁTICA DEL CONGO"
  },
  {
    "codigo":279039007,
    "descripcion":"LUMBALGIA"
  },
  {
    "codigo":703188003,
    "descripcion":"FALLA DE PRÓTESIS DE VÁLVULA PULMONAR QUE REQUIERE REEMPLAZO"
  },
  {
    "codigo":308137006,
    "descripcion":"TROMBOFLEBITIS SUPERFICIAL EN EL PUERPERIO"
  },
  {
    "codigo":13225007,
    "descripcion":"MENINGOENCEFALITIS CAUSADA POR VIRUS DE RUBÉOLA"
  },
  {
    "codigo":285131000119102,
    "descripcion":"MAL FUNCIONAMIENTO DE BATERÍA DE MARCAPASOS CARDÍACO BIVENTRICULAR"
  },
  {
    "codigo":111529008,
    "descripcion":"EXOTROPÍA MONOCULAR CON ESTRABISMO DE PATRÓN EN V"
  },
  {
    "codigo":240766003,
    "descripcion":"NÓDULO CROMOBLASTOMICÓTICO PRIMARIO"
  },
  {
    "codigo":42323001,
    "descripcion":"QUISTE DE ERUPCIÓN"
  },
  {
    "codigo":109694009,
    "descripcion":"OSTEOMIELITIS MAXILAR CRÓNICA"
  },
  {
    "codigo":226099008,
    "descripcion":"DIETA CON ALTO CONTENIDO DE GRASAS MONOINSATURADAS"
  },
  {
    "codigo":271699005,
    "descripcion":"CONTRACTURA EN FLEXIÓN MUSCULAR"
  },
  {
    "codigo":1254739006,
    "descripcion":"TIENE CONTACTO CON LACTANTE PREMATURO"
  },
  {
    "codigo":238931006,
    "descripcion":"CELULITIS EOSINOFÍLICA"
  },
  {
    "codigo":106024000,
    "descripcion":"PATRÓN DE RELACIÓN DE ROLES"
  },
  {
    "codigo":367051000119105,
    "descripcion":"CAMBIO MORFOLÓGICO DE RIÑÓN DEBIDO A SÍNDROME NEFRÍTICO CRÓNICO"
  },
  {
    "codigo":7720002,
    "descripcion":"CONDRODISPLASIA METAFISARIA, TIPO MCKUSICK"
  },
  {
    "codigo":1285672002,
    "descripcion":"HERIDA DE REGIÓN DE OJO POR MORDEDURA"
  },
  {
    "codigo":40488004,
    "descripcion":"SÍNDROME DE FANCONI"
  },
  {
    "codigo":237096004,
    "descripcion":"VULVOVAGINITIS GONOCÓCICA NEONATAL"
  },
  {
    "codigo":400936001,
    "descripcion":"ESOTROPÍA ACOMODATIVA NO REFRACTARIA"
  },
  {
    "codigo":366333001,
    "descripcion":"HALLAZGO RELACIONADO CON LA CANTIDAD DE MEMBRANAS"
  },
  {
    "codigo":202493006,
    "descripcion":"DOLOR DE ARTICULACIÓN ASTRAGALOESCAFOIDEA"
  },
  {
    "codigo":268029009,
    "descripcion":"FRACTURA PATOLÓGICA"
  },
  {
    "codigo":200658003,
    "descripcion":"CELULITIS Y ABSCESO DE DORSO"
  },
  {
    "codigo":298962007,
    "descripcion":"AMPLITUD DE EXTENSIÓN ACTIVA DE LA MUÑECA DISMINUIDA"
  },
  {
    "codigo":428199000,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DEL NERVIO FRÉNICO"
  },
  {
    "codigo":297127001,
    "descripcion":"SENSACIÓN DE ALGO QUE DESCIENDE POR VAGINA"
  },
  {
    "codigo":94821000119104,
    "descripcion":"CRIBADO EN SANGRE PARA SÍNDROME DE DOWN EN EL PRIMER TRIMESTRE ANORMAL"
  },
  {
    "codigo":1149095004,
    "descripcion":"MENINGITIS CAUSADA POR STREPTOCOCCUS SUIS"
  },
  {
    "codigo":723111007,
    "descripcion":"MASA DE HIPOFARINGE EN EL PERÍODO NEONATAL"
  },
  {
    "codigo":460967007,
    "descripcion":"LIGAMENTO ARTERIOSO DERECHO"
  },
  {
    "codigo":262524001,
    "descripcion":"LESIÓN TRAUMÁTICA DE COLUMNA VERTEBRAL LUMBAR"
  },
  {
    "codigo":426364002,
    "descripcion":"HEPATITIS ALÉRGICA"
  },
  {
    "codigo":1077861000119105,
    "descripcion":"ENFERMEDAD DE PAGET DE ESCÁPULA IZQUIERDA"
  },
  {
    "codigo":64081000,
    "descripcion":"DEFICIENCIA DE PORFOBILINÓGENO SINTETASA"
  },
  {
    "codigo":293457001,
    "descripcion":"REACCIÓN ADVERSA A LA CICLOPENTIAZIDA"
  },
  {
    "codigo":295292008,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE PIROXICAM"
  },
  {
    "codigo":129617008,
    "descripcion":"NEUROPATÍA HEPÁTICA"
  },
  {
    "codigo":1145425009,
    "descripcion":"HIPOPLASIA CONGÉNITA DE HUESO DE EXTREMIDAD"
  },
  {
    "codigo":95014000,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA PRÓSTATA"
  },
  {
    "codigo":226086005,
    "descripcion":"DIETA PROTEICA DE BAJO VALOR BIOLÓGICO"
  },
  {
    "codigo":783142006,
    "descripcion":"PANCITOPENIA DEBIDA A MUTACIONES DE IKZF1"
  },
  {
    "codigo":224251000,
    "descripcion":"PROBLEMA CON LA CONDENSACIÓN"
  },
  {
    "codigo":191483003,
    "descripcion":"PSICOSIS INDUCIDA POR FÁRMACO"
  },
  {
    "codigo":1010683003,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE EXTREMIDAD INFERIOR IZQUIERDA A TRAVÉS DEL MUSLO"
  },
  {
    "codigo":289787004,
    "descripcion":"CUELLO UTERINO LATERALIZADO"
  },
  {
    "codigo":60411006,
    "descripcion":"REACCIÓN DE INFELICIDAD Y TRISTEZA EN LA NIÑEZ"
  },
  {
    "codigo":715771008,
    "descripcion":"MICROFTALMÍA CONCOMITANTE CON COLOBOMA OCULAR CONGÉNITO"
  },
  {
    "codigo":255184001,
    "descripcion":"PAPILOMA DE PIEL"
  },
  {
    "codigo":124112004,
    "descripcion":"DEFICIENCIA DE QUINATO DESHIDROGENASA"
  },
  {
    "codigo":1172688004,
    "descripcion":"SÍNDROME DE DISTROFIA MUSCULAR CONGÉNITA, INSUFICIENCIA RESPIRATORIA, ANOMALÍAS CUTÁNEAS E HIPERLAXITUD ARTICULAR"
  },
  {
    "codigo":11838361000119100,
    "descripcion":"LACERACIÓN DE MÚSCULO INTRÍNSECO DE MANO IZQUIERDA"
  },
  {
    "codigo":58576005,
    "descripcion":"EPIGLOTITIS POR HAEMOPHILUS INFLUENZAE"
  },
  {
    "codigo":286117000,
    "descripcion":"CAPAZ DE LIMPIAR EL PISO"
  },
  {
    "codigo":419024006,
    "descripcion":"TRANSPORTE NO DISPONIBLE"
  },
  {
    "codigo":303368003,
    "descripcion":"CAPAZ DE TIRAR"
  },
  {
    "codigo":253349005,
    "descripcion":"HIPOPLASIA DE LA AURÍCULA DERECHA"
  },
  {
    "codigo":10636031000119108,
    "descripcion":"ÚLCERA CRÓNICA DE SEGMENTO MEDIO DE PIE IZQUIERDO"
  },
  {
    "codigo":22138001,
    "descripcion":"AUSENCIA CONGÉNITA DEL LÓBULO DE LA OREJA"
  },
  {
    "codigo":284282006,
    "descripcion":"CAPAZ DE EMPLEAR AGARRE CON DOS DEDOS"
  },
  {
    "codigo":251514009,
    "descripcion":"HALLAZGO NEUROFISIOLÓGICO PERIFÉRICO"
  },
  {
    "codigo":184143003,
    "descripcion":"ÚNICO MIEMBRO DE LA FAMILIA REGISTRADO"
  },
  {
    "codigo":16098201000119104,
    "descripcion":"ARTROFIBROSIS DE CADERA IZQUIERDA"
  },
  {
    "codigo":118607005,
    "descripcion":"LINFOMA DE HODGKIN RICO EN LINFOCITOS"
  },
  {
    "codigo":282447006,
    "descripcion":"HERIDA DE SEPTUM NASAL"
  },
  {
    "codigo":249679006,
    "descripcion":"CLAVÍCULA GRANDE"
  },
  {
    "codigo":84004001,
    "descripcion":"NEUMONITIS POR RADIACIÓN"
  },
  {
    "codigo":247844001,
    "descripcion":"MIEDO A SER VIGILADO"
  },
  {
    "codigo":1263652003,
    "descripcion":"METÁSTASIS DE CARCINOMA MUCOEPIDERMOIDE EN GLÁNDULA PARÓTIDA"
  },
  {
    "codigo":772132005,
    "descripcion":"RIESGO MODERADO DE DAÑAR A OTROS"
  },
  {
    "codigo":10937241000119107,
    "descripcion":"FRACTURA NO EXPUESTA DE HUESO SEMILUNAR DE MUÑECA DERECHA"
  },
  {
    "codigo":442617003,
    "descripcion":"AFASIA COMO EFECTO TARDÍO DE ACCIDENTE CEREBROVASCULAR"
  },
  {
    "codigo":97331000119101,
    "descripcion":"EDEMA MACULAR Y RETINOPATÍA DEBIDOS A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":213241006,
    "descripcion":"TRASTORNO DEL ESTOMA EXTERNO DE LAS VÍAS URINARIAS"
  },
  {
    "codigo":211406001,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE PIE"
  },
  {
    "codigo":543826841000119109,
    "descripcion":"TUMOR NEUROENDOCRINO BIEN DIFERENCIADO CON METÁSTASIS A PULMÓN DERECHO"
  },
  {
    "codigo":343091000119103,
    "descripcion":"HEMORRAGIA DE AMBOS CUERPOS VÍTREOS"
  },
  {
    "codigo":309710005,
    "descripcion":"DISTENSIÓN LUMBOSACRA"
  },
  {
    "codigo":12963004,
    "descripcion":"ASCITIS ASOCIADA A DIÁLISIS"
  },
  {
    "codigo":109432004,
    "descripcion":"BANDAS DE MÚSCULO CARDÍACO ANÓMALAS"
  },
  {
    "codigo":699256006,
    "descripcion":"SÍNDROME DE TIMOTHY TIPO 1"
  },
  {
    "codigo":369741002,
    "descripcion":"BORDE TUMORAL INFILTRANTE, MICROSCÓPICO"
  },
  {
    "codigo":74829002,
    "descripcion":"CLOACA PERSISTENTE"
  },
  {
    "codigo":762957002,
    "descripcion":"HEMORRAGIA PERIOPERATORIA"
  },
  {
    "codigo":271437004,
    "descripcion":"SITUACIÓN PROBLEMÁTICA RELACIONADA CON LOS ANTECEDENTES SOCIALES Y PERSONALES"
  },
  {
    "codigo":238669003,
    "descripcion":"LIQUEN PLANO EROSIVO DE LA VULVA"
  },
  {
    "codigo":304205007,
    "descripcion":"AMPLITUD DE MOVIMIENTO ACTIVO DE EXTENSIÓN HORIZONTAL DE HOMBRO"
  },
  {
    "codigo":40226000,
    "descripcion":"DETERIORO"
  },
  {
    "codigo":402509003,
    "descripcion":"CARCINOMA BASOCELULAR DE CUELLO"
  },
  {
    "codigo":9293002,
    "descripcion":"ATONÍA UTERINA"
  },
  {
    "codigo":7458004,
    "descripcion":"DIPLOPODIA"
  },
  {
    "codigo":1285410009,
    "descripcion":"ERITEMA MULTIFORME ASOCIADO CON FENITOÍNA Y CON RADIOTERAPIA CRANEAL"
  },
  {
    "codigo":234999001,
    "descripcion":"ENFERMEDAD DE CROHN GINGIVAL"
  },
  {
    "codigo":366071004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CALIDAD DEL FOCO OCULAR"
  },
  {
    "codigo":890359005,
    "descripcion":"POLIDACTILIA POSTAXIAL BILATERAL DE PIE"
  },
  {
    "codigo":169463007,
    "descripcion":"ANTICONCEPCIÓN ORAL - CON PROBLEMAS"
  },
  {
    "codigo":822988000,
    "descripcion":"TRASTORNO DEL SEGMENTO ABDOMINOPÉLVICO DEL TRONCO"
  },
  {
    "codigo":300535008,
    "descripcion":"DOLOR A LA PALPACIÓN EN PRÓSTATA"
  },
  {
    "codigo":202231009,
    "descripcion":"INESTABILIDAD CARPIANA"
  },
  {
    "codigo":724684001,
    "descripcion":"TRASTORNO DEL ESTADO DE ÁNIMO CON SÍNTOMAS MIXTOS DEPRESIVOS Y MANÍACOS CAUSADO POR ANSIOLÍTICO"
  },
  {
    "codigo":316621000119106,
    "descripcion":"OSTEOFITO DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":298700005,
    "descripcion":"PRUEBA DE ROTACIÓN SIMULADA, POSITIVA"
  },
  {
    "codigo":16018791000119100,
    "descripcion":"DEFORMIDAD CONGÉNITA DE DEDOS DE AMBAS MANOS"
  },
  {
    "codigo":722849002,
    "descripcion":"ENTERITIS ESTENOSANTE ULCEROSA MULTIFOCAL CRIPTOGÉNICA"
  },
  {
    "codigo":296865004,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE GLIBENCLAMIDA"
  },
  {
    "codigo":1953005,
    "descripcion":"DEFICIENCIA CONGÉNITA DEL PIGMENTO DE LA PIEL"
  },
  {
    "codigo":165793005,
    "descripcion":"ANTICUERPOS ANTIRRUBEÓLICOS - TÍTULO EN ASCENSO"
  },
  {
    "codigo":360566006,
    "descripcion":"OBESIDAD DE TIPO BÚFALO"
  },
  {
    "codigo":721014007,
    "descripcion":"SÍNDROME CORAZÓN-MANO TIPO ESLOVENO"
  },
  {
    "codigo":295030006,
    "descripcion":"ALERGIA A ACETAZOLAMIDA"
  },
  {
    "codigo":290151000119104,
    "descripcion":"LESIÓN DE NERVIO PLANTAR IZQUIERDO"
  },
  {
    "codigo":293195004,
    "descripcion":"REACCIÓN ADVERSA A LA GLIBORNURIDA"
  },
  {
    "codigo":1145163006,
    "descripcion":"INTOXICACIÓN POR TREMENTINA Y\/O DERIVADO DE TREMENTINA"
  },
  {
    "codigo":291360001,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR AMINOFILINA"
  },
  {
    "codigo":782880001,
    "descripcion":"HEMOGLOBINOPATÍA TOMS RIVER"
  },
  {
    "codigo":225824003,
    "descripcion":"VÍCTIMA DE MALTRATO FÍSICO"
  },
  {
    "codigo":1208864004,
    "descripcion":"SÍNDROME DE QT PROLONGADO TIPO 2"
  },
  {
    "codigo":94752001,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA BASE DE LA LENGUA"
  },
  {
    "codigo":345601000119100,
    "descripcion":"CORIORRETINITIS FOCAL YUXTAPAPILAR BILATERAL"
  },
  {
    "codigo":61984009,
    "descripcion":"QUEMADURA PROFUNDA DE TERCER GRADO DE LA MANO"
  },
  {
    "codigo":92917003,
    "descripcion":"FORMA ANORMAL CONGÉNITA DEL ILION"
  },
  {
    "codigo":289525007,
    "descripcion":"TUMEFACCIÓN DEL INTROITO VAGINAL"
  },
  {
    "codigo":715509008,
    "descripcion":"PROBLEMA CON YESO DE PARÍS"
  },
  {
    "codigo":25546001,
    "descripcion":"CONTUSIÓN DE UÑA DE DEDO DE LA MANO"
  },
  {
    "codigo":1010421009,
    "descripcion":"HIPERPLASIA DE APÓFISIS CONDÍLEA IZQUIERDA DE MANDÍBULA"
  },
  {
    "codigo":91082004,
    "descripcion":"VOLUMEN SISTÓLICO NORMAL"
  },
  {
    "codigo":126311000119109,
    "descripcion":"CÉLULAS GLANDULARES ATÍPICAS EN EXTENDIDO DE PAPANICOLAOU ANAL"
  },
  {
    "codigo":713674006,
    "descripcion":"DOLOR DE PIE ISQUÉMICO AL CAMINAR"
  },
  {
    "codigo":254922006,
    "descripcion":"ONCOCITOMA DE RIÑÓN"
  },
  {
    "codigo":285855003,
    "descripcion":"CAPAZ DE MANEJAR ENSERES DOMÉSTICOS"
  },
  {
    "codigo":250856961000119105,
    "descripcion":"ÚLCERA CRÓNICA DE ANTRO PILÓRICO"
  },
  {
    "codigo":447860000,
    "descripcion":"CONEXIÓN VENOSA PULMONAR ANÓMALA PARCIAL DE PARTE DEL PULMÓN DERECHO"
  },
  {
    "codigo":1082881000119106,
    "descripcion":"OTITIS EXTERNA AGUDA DE AMBOS CONDUCTOS AUDITIVOS EXTERNOS CAUSADA POR SUSTANCIA QUÍMICA"
  },
  {
    "codigo":282185002,
    "descripcion":"CAPAZ DE BAJAR UN ESCALÓN"
  },
  {
    "codigo":314953008,
    "descripcion":"RECIDIVA LOCAL DE NEOPLASIA MALIGNA DE GLÁNDULA TIROIDES"
  },
  {
    "codigo":247582001,
    "descripcion":"DIFICULTAD PARA RESOLVER PROBLEMAS"
  },
  {
    "codigo":73371000119103,
    "descripcion":"QUISTE DE PRIMERA HENDIDURA BRANQUIAL"
  },
  {
    "codigo":49139000,
    "descripcion":"DIETA CON 70 GRAMOS DE GRASA"
  },
  {
    "codigo":409587002,
    "descripcion":"DIARREA GRAVE"
  },
  {
    "codigo":737267003,
    "descripcion":"HEMOLINFANGIOMA DE CONJUNTIVA"
  },
  {
    "codigo":1359859003,
    "descripcion":"NEOPLASIA MALIGNA DE BERMELLÓN DE LABIO"
  },
  {
    "codigo":276680000,
    "descripcion":"CONJUNTIVITIS BACTERIANA NEONATAL"
  },
  {
    "codigo":1259720004,
    "descripcion":"GLIOMA MALIGNO PRIMARIO DE CEREBRO"
  },
  {
    "codigo":80072008,
    "descripcion":"ESCALA DEL COMA DE GLASGOW, 6"
  },
  {
    "codigo":274845003,
    "descripcion":"HALLAZGO INMUNOLÓGICO ANORMAL EN ESPÉCIMEN DE ÓRGANO GENITAL FEMENINO"
  },
  {
    "codigo":209309003,
    "descripcion":"FRACTURA-LUXACIÓN NO EXPUESTA DE MÚLTIPLES DÍGITOS"
  },
  {
    "codigo":111005008,
    "descripcion":"DEPÓSITO DE PIGMENTO ESQUISTOSÓMICO"
  },
  {
    "codigo":405917009,
    "descripcion":"HALLAZGO RELACIONADO CON EL EQUIPO INTERGRUPAL PARA EL ESTUDIO POSQUIRÚRGICO DE RABDOMIOSARCOMA"
  },
  {
    "codigo":43634002,
    "descripcion":"HEPATITIS VIRAL TIPO A RECURRENTE"
  },
  {
    "codigo":76402003,
    "descripcion":"SÍNDROME DE INSUFICIENCIA ARTERIAL CAROTÍDEA"
  },
  {
    "codigo":404082003,
    "descripcion":"MIXOMA"
  },
  {
    "codigo":1256050003,
    "descripcion":"ALOPECIA CICATRICIAL DEBIDA A ENFERMEDAD INFECCIOSA"
  },
  {
    "codigo":319131000119109,
    "descripcion":"ARTRITIS REUMATOIDEA SERONEGATIVA DE ARTICULACIÓN DE RODILLA DERECHA"
  },
  {
    "codigo":305778004,
    "descripcion":"VISTO POR ORTOTISTA"
  },
  {
    "codigo":371314008,
    "descripcion":"HALLAZGO DE CONDICIÓN DE LA ENFERMEDAD"
  },
  {
    "codigo":41799005,
    "descripcion":"DISTROFIA RETINIANA HEREDITARIA"
  },
  {
    "codigo":238407005,
    "descripcion":"DACTILITIS AMPOLLAR DISTAL"
  },
  {
    "codigo":292661000119105,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DEBIDO A ESTENOSIS DE ARTERIA VERTEBRAL DERECHA"
  },
  {
    "codigo":402247009,
    "descripcion":"REACCIÓN LIQUENOIDE ALÉRGICA POR CONTACTO QUE AFECTA LA MUCOSA BUCAL"
  },
  {
    "codigo":271175009,
    "descripcion":"AMPOLLA TRAUMÁTICA DE MUSLO"
  },
  {
    "codigo":302108003,
    "descripcion":"TRAQUEOSTOMÍA PRESENTE"
  },
  {
    "codigo":1186844002,
    "descripcion":"HEMOCROMATOSIS HEREDITARIA JUVENIL TIPO 2B"
  },
  {
    "codigo":236572007,
    "descripcion":"RECHAZO ACELERADO DEL TRASPLANTE RENAL"
  },
  {
    "codigo":38129000,
    "descripcion":"INFESTACIÓN CAUSADA POR PYEMOTES"
  },
  {
    "codigo":890097003,
    "descripcion":"BEBÉ PREMATURO DE MENOS DE 26 SEMANAS"
  },
  {
    "codigo":5361003,
    "descripcion":"CATARATA NUCLEAR EMBRIONARIA"
  },
  {
    "codigo":300273006,
    "descripcion":"SANGRADO FARÍNGEO"
  },
  {
    "codigo":365809007,
    "descripcion":"CONCENTRACIÓN DE HEMOGLOBINA, TIRA REACTIVA - HALLAZGO"
  },
  {
    "codigo":200134001,
    "descripcion":"NACIDO CON AYUDA DE FÓRCEPS EN LA CAVIDAD MEDIA, CON ROTACIÓN"
  },
  {
    "codigo":167366005,
    "descripcion":"EXAMEN MICROSCÓPICO DE ORINA: PARÁSITOS PRESENTES"
  },
  {
    "codigo":1279643000,
    "descripcion":"VÍCTIMA DE ABUSO PSICOLÓGICO"
  },
  {
    "codigo":198299001,
    "descripcion":"ATROFIA ADQUIRIDA DE OVARIO Y TROMPA DE FALOPIO"
  },
  {
    "codigo":67227000,
    "descripcion":"PEDOFILIA, MISMO SEXO"
  },
  {
    "codigo":1148571003,
    "descripcion":"INTOXICACIÓN CAUSADA POR ANFETAMINA Y\/O DERIVADO DE ANFETAMINA"
  },
  {
    "codigo":296603006,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE TOBRAMICINA"
  },
  {
    "codigo":165531008,
    "descripcion":"LINFOCITOSIS - ABSOLUTA"
  },
  {
    "codigo":294768005,
    "descripcion":"ALERGIA A FLUTAMIDA"
  },
  {
    "codigo":113901000052102,
    "descripcion":"INSUFICIENCIA CARDÍACA POSTERIOR A ADMINISTRACIÓN DE AGENTE ANTINEOPLÁSICO"
  },
  {
    "codigo":720752007,
    "descripcion":"SÍNDROME COXO-PODO-ROTULIANO"
  },
  {
    "codigo":1179504007,
    "descripcion":"CISTINA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":292933003,
    "descripcion":"REACCIÓN ADVERSA A LA CLARITROMICINA"
  },
  {
    "codigo":10670031000119108,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN DE PIERNA DERECHA ESTADIO III"
  },
  {
    "codigo":1208602000,
    "descripcion":"NEUMONÍA CAUSADA POR PSEUDOMONAS AERUGINOSA"
  },
  {
    "codigo":192794001,
    "descripcion":"DEGENERACIÓN CEREBRAL ASOCIADA CON OTRO TRASTORNO"
  },
  {
    "codigo":127258002,
    "descripcion":"NEOPLASIA DE LOS GANGLIOS LINFÁTICOS PARAMAMARIOS"
  },
  {
    "codigo":63557009,
    "descripcion":"EXPLORACIÓN SEXUAL"
  },
  {
    "codigo":225562005,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN EN REGIÓN SACRA DE ESPALDA"
  },
  {
    "codigo":12200041000119103,
    "descripcion":"AFLOJAMIENTO DE PRÓTESIS DE ARTICULACIÓN DE CADERA IZQUIERDA"
  },
  {
    "codigo":94490008,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE HUESO PISIFORME DE REGIÓN DE MUÑECA"
  },
  {
    "codigo":291098009,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR MEPROBAMATO"
  },
  {
    "codigo":420335002,
    "descripcion":"PUPILA DE TAMAÑO MEDIANO"
  },
  {
    "codigo":1173999006,
    "descripcion":"ENFERMEDAD INFLAMATORIA INTESTINAL DEL LACTANTE RELACIONADA CON IL21"
  },
  {
    "codigo":92655006,
    "descripcion":"CARCINOMA IN SITU DE SENO MAXILAR"
  },
  {
    "codigo":190959006,
    "descripcion":"LINFOHISTIOCITOSIS HEMOFAGOCÍTICA DEBIDA A INFECCIÓN"
  },
  {
    "codigo":713412006,
    "descripcion":"PIE ISQUÉMICO CON DOLOR EN REPOSO"
  },
  {
    "codigo":123588006,
    "descripcion":"BRONCONEUMONÍA CON FORMACIÓN DE ABSCESOS"
  },
  {
    "codigo":1137561000,
    "descripcion":"MEGACALICOSIS CONGÉNITA"
  },
  {
    "codigo":1268633007,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS PRIMARIO DE RECTO"
  },
  {
    "codigo":449433008,
    "descripcion":"ESTENOSIS DIFUSA DE ARTERIA PULMONAR IZQUIERDA"
  },
  {
    "codigo":250990001,
    "descripcion":"DISFUNCIÓN ISQUÉMICA DE VÁLVULA MITRAL"
  },
  {
    "codigo":447598006,
    "descripcion":"QUEMADURA PROFUNDA DE TERCER GRADO DE CARA"
  },
  {
    "codigo":283758009,
    "descripcion":"MORDEDURA DE PERRO EN EL PULGAR"
  },
  {
    "codigo":314691005,
    "descripcion":"TALLA DEL NIÑO: PERCENTILO 9"
  },
  {
    "codigo":281923005,
    "descripcion":"FRACTURA POR APLASTAMIENTO DE VÉRTEBRA DORSAL"
  },
  {
    "codigo":183619008,
    "descripcion":"SEGUIMIENTO EN 4-6 DÍAS"
  },
  {
    "codigo":871747009,
    "descripcion":"DIFICULTAD PARA CUIDAR POSESIONES PERSONALES"
  },
  {
    "codigo":1197592001,
    "descripcion":"SÍNDROME DE RESTRICCIÓN DEL CRECIMIENTO INTRAUTERINO, BAJA TALLA Y DIABETES DE INICIO TEMPRANO DEL ADULTO"
  },
  {
    "codigo":17944005,
    "descripcion":"CALCIFICACIÓN CEREBRAL"
  },
  {
    "codigo":350621000119100,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE NERVIO AUDITIVO DERECHO"
  },
  {
    "codigo":247320008,
    "descripcion":"LAS COSAS HUELEN DIFERENTE"
  },
  {
    "codigo":443928008,
    "descripcion":"INFECCIÓN NECROSANTE DE PARTES BLANDAS"
  },
  {
    "codigo":704237001,
    "descripcion":"FRACTURA EXPUESTA EN MARTILLO DE FALANGE DISTAL DE DEDO ÍNDICE"
  },
  {
    "codigo":131331000119108,
    "descripcion":"MIDRIASIS NO DEBIDA A COLIRIO MIDRIÁTICO"
  },
  {
    "codigo":1259458001,
    "descripcion":"CARCINOSARCOMA PRIMARIO DE ENDOMETRIO"
  },
  {
    "codigo":702402003,
    "descripcion":"CARIES EN LA PRIMERA INFANCIA"
  },
  {
    "codigo":473026004,
    "descripcion":"COMPLICACIÓN ASOCIADA CON ESTIMULADOR DE NERVIO VAGO"
  },
  {
    "codigo":363443007,
    "descripcion":"NEOPLASIA MALIGNA DE OVARIO"
  },
  {
    "codigo":866242004,
    "descripcion":"CON MAYOR RIESGO DE NEOPLASIA MALIGNA DE MAMA"
  },
  {
    "codigo":276418007,
    "descripcion":"NEOPLASIA BENIGNA DE PIEL DE PENE"
  },
  {
    "codigo":733335000,
    "descripcion":"NISTAGMO PALPEBRAL"
  },
  {
    "codigo":405655001,
    "descripcion":"CARACTERÍSTICA RELACIONADA CON EL EQUIPAMIENTO"
  },
  {
    "codigo":79810005,
    "descripcion":"INFECCIÓN CAUSADA POR SPIROCERCA"
  },
  {
    "codigo":678301000119105,
    "descripcion":"SINEQUIAS DE IRIS DE OJO DERECHO"
  },
  {
    "codigo":1255788002,
    "descripcion":"LINFOMA DE HODGKIN, VARIANTE CELULARIDAD MIXTA DE GANGLIOS LINFÁTICOS DE CABEZA"
  },
  {
    "codigo":371052003,
    "descripcion":"DEHISCENCIA TRAUMÁTICA DE HERIDA"
  },
  {
    "codigo":403820003,
    "descripcion":"MÁCULAS CAFÉ CON LECHE CON ESTENOSIS PULMONAR"
  },
  {
    "codigo":895340005,
    "descripcion":"CURVATURA ANORMAL DE FALANGE PROXIMAL DE DEDO MEÑIQUE"
  },
  {
    "codigo":1087901000119106,
    "descripcion":"NEURITIS ACÚSTICA DE OÍDO IZQUIERDO DEBIDA A ENFERMEDAD INFECCIOSA"
  },
  {
    "codigo":305516006,
    "descripcion":"BAJO ATENCIÓN DE PSIQUIATRA DE ENLACE"
  },
  {
    "codigo":764268008,
    "descripcion":"FLUJO SANGUÍNEO PERIFÉRICO INADECUADO"
  },
  {
    "codigo":239980008,
    "descripcion":"RUPTURA DEL TENDÓN DEL MÚSCULO FLEXOR COMÚN SUPERFICIAL DEL PULGAR"
  },
  {
    "codigo":8769003,
    "descripcion":"OLOR ANORMAL DE LA ORINA"
  },
  {
    "codigo":762433009,
    "descripcion":"TETRALOGÍA DE FALLOT CON ATRESIA PULMONAR CONCOMITANTE CON ARTERIA COLATERAL DE LA CIRCULACIÓN SISTÉMICA A LA CIRCULACIÓN PULMONAR"
  },
  {
    "codigo":170774007,
    "descripcion":"DIABETES: PROGRAMA DE CONSULTORIO"
  },
  {
    "codigo":72470008,
    "descripcion":"SARCOIDOSIS, TIPO LUPUS PERNIO"
  },
  {
    "codigo":301846009,
    "descripcion":"SÍNDROME DEL NIDO VACÍO"
  },
  {
    "codigo":168939002,
    "descripcion":"ARTERIOGRAFÍA CORONARIA ANORMAL"
  },
  {
    "codigo":1119211005,
    "descripcion":"DOLOR A LA PALPACIÓN EN REGIÓN ABDOMINAL LUMBAR IZQUIERDA"
  },
  {
    "codigo":234475005,
    "descripcion":"DEFECTO EN LA PRODUCCIÓN DE TROMBOXANO"
  },
  {
    "codigo":365547008,
    "descripcion":"HALLAZGO RELACIONADO CON LA CONCIENCIA DE LA SEGURIDAD LABORAL"
  },
  {
    "codigo":298176009,
    "descripcion":"INFLAMACIÓN DE ARTICULACIÓN DE COLUMNA VERTEBRAL CERVICAL"
  },
  {
    "codigo":198037006,
    "descripcion":"ATROFIA DE PENE"
  },
  {
    "codigo":1344917008,
    "descripcion":"METAPLASIA INTESTINAL DE PÍLORO"
  },
  {
    "codigo":230805009,
    "descripcion":"NEUROMA DE LA REPARACIÓN NERVIOSA"
  },
  {
    "codigo":296341009,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE PROPRANOLOL"
  },
  {
    "codigo":65130004,
    "descripcion":"ALOPECIA NUTRICIONAL"
  },
  {
    "codigo":32362007,
    "descripcion":"ABSCESO RETROPERITONEAL"
  },
  {
    "codigo":294506009,
    "descripcion":"ALERGIA A AMPICILINA"
  },
  {
    "codigo":423743009,
    "descripcion":"VISIÓN A DISTANCIA 6\/30"
  },
  {
    "codigo":126996004,
    "descripcion":"NEOPLASIA DE LA CONJUNTIVA"
  },
  {
    "codigo":94228007,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE BRONQUIO DEL LÓBULO INFERIOR IZQUIERDO DEL PULMÓN"
  },
  {
    "codigo":1208340009,
    "descripcion":"NEUROFIBROMATOSIS TIPO 6"
  },
  {
    "codigo":716820009,
    "descripcion":"MYROIDES ODORATIMIMUS O MYROIDES ODORATUS"
  },
  {
    "codigo":714985003,
    "descripcion":"OSTEOMIELITIS CRÓNICA DE HUESO DEL CARPO"
  },
  {
    "codigo":26857005,
    "descripcion":"HIPERESTESIA DOLOROSA"
  },
  {
    "codigo":125161006,
    "descripcion":"INADECUADO PARA EVALUACIÓN POR ESCASEZ DE COMPONENTE EPITELIAL ESCAMOSO"
  },
  {
    "codigo":289001005,
    "descripcion":"INCAPAZ DE ALIMENTARSE"
  },
  {
    "codigo":92393005,
    "descripcion":"NEOPLASIA BENIGNA DE PARTES BLANDAS DE LA REGIÓN INGUINAL"
  },
  {
    "codigo":287166006,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ALCOHOL ETÍLICO"
  },
  {
    "codigo":254398008,
    "descripcion":"CARCINOMA DEL FRENILLO LABIAL SUPERIOR"
  },
  {
    "codigo":187027001,
    "descripcion":"COCCIDIOIDOMICOSIS PULMONAR AGUDA"
  },
  {
    "codigo":188862009,
    "descripcion":"NEOPLASIA BENIGNA DEL MESORRECTO"
  },
  {
    "codigo":40441000087100,
    "descripcion":"CUERPO EXTRAÑO EN PIERNA IZQUIERDA"
  },
  {
    "codigo":43001000087102,
    "descripcion":"CUERPO EXTRAÑO DE MAMA IZQUIERDA"
  },
  {
    "codigo":680811000119105,
    "descripcion":"CATARATA DE OJO IZQUIERDO CAUSADA POR MEDICACIÓN"
  },
  {
    "codigo":23187009,
    "descripcion":"AFONÍA PARALÍTICA"
  },
  {
    "codigo":48121000087104,
    "descripcion":"FRACTURA DE APÓFISIS CORACOIDES DE OMÓPLATO IZQUIERDO"
  },
  {
    "codigo":449171008,
    "descripcion":"SATURACIÓN DE OXÍGENO POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":609341000,
    "descripcion":"INFECCIÓN DE SITIO QUIRÚRGICO EN ESPACIO DE ÓRGANO"
  },
  {
    "codigo":283496009,
    "descripcion":"HERIDA POR ESPADA"
  },
  {
    "codigo":248893008,
    "descripcion":"CICATRIZACIÓN DEL FONDO DE SACO VAGINAL"
  },
  {
    "codigo":214290000,
    "descripcion":"ACETONEMIA"
  },
  {
    "codigo":314429009,
    "descripcion":"UVEÍTIS INTERMEDIA"
  },
  {
    "codigo":83218005,
    "descripcion":"ACNÉ ESTIVAL"
  },
  {
    "codigo":1197330006,
    "descripcion":"ADENOCARCINOMA METASTÁSICO DE GANGLIOS LINFÁTICOS DE MÚLTIPLES SITIOS"
  },
  {
    "codigo":50450007,
    "descripcion":"COLELITIASIS Y COLECISTITIS CON OBSTRUCCIÓN"
  },
  {
    "codigo":48615000,
    "descripcion":"FÍSTULA LAGRIMAL"
  },
  {
    "codigo":1230098009,
    "descripcion":"COMPLEJO FÉMUR-PERONÉ-CÚBITO"
  },
  {
    "codigo":312594005,
    "descripcion":"TROMBOSIS ARTERIAL DE CABEZA Y CUELLO"
  },
  {
    "codigo":1162727003,
    "descripcion":"OBJETIVO DISCONTINUADO"
  },
  {
    "codigo":15847003,
    "descripcion":"CORIORRETINITIS FOCAL"
  },
  {
    "codigo":212455007,
    "descripcion":"RUPTURA TRAUMÁTICA DE DISCO INTERVERTEBRAL CERVICAL"
  },
  {
    "codigo":14012001,
    "descripcion":"PAREJA POR DERECHO CONSUETUDINARIO"
  },
  {
    "codigo":472764004,
    "descripcion":"TRASTORNO DE AURÍCULA DERECHA COMO COMPLICACIÓN DE PROCEDIMIENTO"
  },
  {
    "codigo":210620006,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE PUNTA DE PULGAR, TIPO 3"
  },
  {
    "codigo":767676007,
    "descripcion":"HERNIA INGUINAL IZQUIERDA IRREDUCTIBLE RECURRENTE"
  },
  {
    "codigo":1193660006,
    "descripcion":"INFLAMACIÓN INTESTINAL POR ESCHERICHIA COLI ENTEROHEMORRÁGICA"
  },
  {
    "codigo":439996009,
    "descripcion":"RESULTADO DE ANÁLISIS DE INTERFERÓN GAMMA INDETERMINADO"
  },
  {
    "codigo":307089001,
    "descripcion":"DIFICULTAD PARA ANALIZAR INFORMACIÓN"
  },
  {
    "codigo":1259196009,
    "descripcion":"CRISIS EPILÉPTICA DE INICIO NO MOTOR DE INICIO FOCAL"
  },
  {
    "codigo":208785002,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN DE CODO, ANTERIOR"
  },
  {
    "codigo":77713007,
    "descripcion":"GRANULOMA DEL RECTO"
  },
  {
    "codigo":15973381000119108,
    "descripcion":"MALFORMACIÓN CONGÉNITA DEL CALCÁNEO DERECHO"
  },
  {
    "codigo":700305007,
    "descripcion":"ARTROSIS DE ARTICULACIÓN CALCANEOCUBOIDEA"
  },
  {
    "codigo":10949791000119102,
    "descripcion":"HERIDA POR ARMA BLANCA DE ANTEBRAZO DERECHO"
  },
  {
    "codigo":239718003,
    "descripcion":"TRASTORNO ARTICULAR MECÁNICO"
  },
  {
    "codigo":75878002,
    "descripcion":"ANEURISMA DE AORTA ABDOMINAL SIN RUPTURA"
  },
  {
    "codigo":237883001,
    "descripcion":"SÍNDROME DE HUESO HAMBRIENTO"
  },
  {
    "codigo":96720031000119104,
    "descripcion":"ÚLCERA GÁSTRICA CRÓNICA CAUSADA POR HELICOBACTER PYLORI"
  },
  {
    "codigo":203280005,
    "descripcion":"TUBERCULOSIS DE LOS HUESOS DE TOBILLO Y PIE"
  },
  {
    "codigo":15920441000119100,
    "descripcion":"REACCIÓN ALÉRGICA CAUSADA POR SEMILLAS"
  },
  {
    "codigo":236048007,
    "descripcion":"HERNIA PARAESTOMAL"
  },
  {
    "codigo":301584008,
    "descripcion":"SUBE Y BAJA ESCALONES Y ESCALERAS"
  },
  {
    "codigo":1055248006,
    "descripcion":"AGENESIA DE EPÍFISIS DE FALANGE DISTAL DE DEDO MAYOR"
  },
  {
    "codigo":299749005,
    "descripcion":"REFLEJO PALMOMENTONIANO DE RESULTADO DUDOSO"
  },
  {
    "codigo":37605006,
    "descripcion":"OSTEOPENIA SENIL"
  },
  {
    "codigo":365285007,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA INSERTAR EL TAPÓN DE RESIDUOS"
  },
  {
    "codigo":234213008,
    "descripcion":"DESPLAZAMIENTO DE LA GUÍA DEL ELECTRODO DEL MARCAPASOS"
  },
  {
    "codigo":3002002,
    "descripcion":"HEMORRAGIA DE LA GLÁNDULA TIROIDES"
  },
  {
    "codigo":11824441000119103,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE BRAZO DERECHO"
  },
  {
    "codigo":363450006,
    "descripcion":"NEOPLASIA MALIGNA DE PREPUCIO"
  },
  {
    "codigo":232378007,
    "descripcion":"PERFORACIÓN TRAUMÁTICA DEL TABIQUE NASAL"
  },
  {
    "codigo":1344655000,
    "descripcion":"ACCESO DIGITAL ADECUADO"
  },
  {
    "codigo":427151002,
    "descripcion":"FÍSTULA ANAL TRANSESFINTERIANA EN HERRADURA"
  },
  {
    "codigo":296079008,
    "descripcion":"SOBREDOSIS DE ALPRAZOLAM"
  },
  {
    "codigo":458084001,
    "descripcion":"DISINCRONÍA INTERVENTRICULAR"
  },
  {
    "codigo":722063009,
    "descripcion":"SÍNDROME ODONTO-TRICO-UNGUEAL-DIGITOPALMAR"
  },
  {
    "codigo":359780007,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE GANGLIOS LINFÁTICOS AXILARES LATERALES"
  },
  {
    "codigo":718393002,
    "descripcion":"SÍNDROME DE RETT ATÍPICO"
  },
  {
    "codigo":292409004,
    "descripcion":"REACCIÓN ADVERSA A LA SELEGILINA"
  },
  {
    "codigo":30265004,
    "descripcion":"FLUOROSIS DENTAL"
  },
  {
    "codigo":402312004,
    "descripcion":"PSORIASIS AGUDA EN GOTAS"
  },
  {
    "codigo":1491000119102,
    "descripcion":"HEMORRAGIA DEL VÍTREO DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":1306382003,
    "descripcion":"NEOPLASIA DE CUADRANTE SUPERIOR INTERNO DE MAMA"
  },
  {
    "codigo":126734005,
    "descripcion":"NEOPLASIA DEL PERICARDIO"
  },
  {
    "codigo":225038006,
    "descripcion":"LAPSOS DE MEMORIA"
  },
  {
    "codigo":93966009,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA PLEURA"
  },
  {
    "codigo":92131002,
    "descripcion":"NEOPLASIA BENIGNA DE LA CABEZA"
  },
  {
    "codigo":288739003,
    "descripcion":"INCAPAZ DE EMPLEAR AUTOEXPRESIÓN"
  },
  {
    "codigo":26595007,
    "descripcion":"AUSENCIA CONGÉNITA DE PARTE DEL CEREBRO"
  },
  {
    "codigo":59363009,
    "descripcion":"ABORTO INEVITABLE"
  },
  {
    "codigo":286904004,
    "descripcion":"NEOPLASIA GENITAL BENIGNA"
  },
  {
    "codigo":416141007,
    "descripcion":"CORMACK Y LEHANE GRADO 4"
  },
  {
    "codigo":22925008,
    "descripcion":"TRASTORNO NEONATAL"
  },
  {
    "codigo":21090005,
    "descripcion":"INFECCIÓN CAUSADA POR OSTERTAGIA"
  },
  {
    "codigo":283234006,
    "descripcion":"VIDRIO EN REGIÓN AUDITIVA"
  },
  {
    "codigo":840290008,
    "descripcion":"UTILIZA HABILIDADES DE COMUNICACIÓN FUNCIONAL"
  },
  {
    "codigo":1231671001,
    "descripcion":"GRANULOMATOSIS CON POLIANGEÍTIS ORBITARIA"
  },
  {
    "codigo":838455001,
    "descripcion":"INSUFICIENCIA MODERADA DE VÁLVULA TRICÚSPIDE"
  },
  {
    "codigo":52023002,
    "descripcion":"ÁNTRAX DE DEDO DE LA MANO"
  },
  {
    "codigo":707383000,
    "descripcion":"CISTOADENOCARCINOMA MUCINOSO PRIMARIO DE TRÁQUEA"
  },
  {
    "codigo":248631006,
    "descripcion":"RITMO SINUSAL - PULSO"
  },
  {
    "codigo":10761991000119101,
    "descripcion":"DERMATITIS POR CONTACTO DE PÁRPADOS SUPERIOR E INFERIOR DERECHOS"
  },
  {
    "codigo":310497006,
    "descripcion":"DEPRESIÓN GRAVE"
  },
  {
    "codigo":210358000,
    "descripcion":"HERIDA ABIERTA EN LA BOCA"
  },
  {
    "codigo":212193009,
    "descripcion":"LESIÓN EXPUESTA DE LA COLA DE CABALLO"
  },
  {
    "codigo":1258934002,
    "descripcion":"ATEROSCLEROSIS DE ARTERIA FEMORAL"
  },
  {
    "codigo":852981511000119103,
    "descripcion":"FIBROMATOSIS AGRESIVA DE PARED DE TÓRAX"
  },
  {
    "codigo":10680071000119103,
    "descripcion":"TUMEFACCIÓN DEL TEJIDO CELULAR SUBCUTÁNEO DE LA MANO DERECHA"
  },
  {
    "codigo":863883002,
    "descripcion":"CON MAYOR RIESGO DE ÚLCERA DE PIE DERECHO DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":16004871000119104,
    "descripcion":"NECROSIS AVASCULAR DE HUESO DEL CARPO DE AMBAS MUÑECAS"
  },
  {
    "codigo":110219008,
    "descripcion":"QUEMADURA DE PRIMER GRADO DEL PALADAR DURO"
  },
  {
    "codigo":1255264000,
    "descripcion":"ESTENOSIS DE ARTERIA CORONARIA INTERMEDIA"
  },
  {
    "codigo":208523009,
    "descripcion":"FRACTURA NO EXPUESTA DE FÉMUR PROXIMAL, TRANSEPIFISARIA"
  },
  {
    "codigo":685831000119105,
    "descripcion":"LIPOSARCOMA PRIMARIO DE PARTES BLANDAS DE ABDOMEN"
  },
  {
    "codigo":111368002,
    "descripcion":"NECROSIS GRASA DEL PERITONEO"
  },
  {
    "codigo":403296006,
    "descripcion":"LÍNEAS DE BEAU SECUNDARIAS A ENFERMEDAD SISTÉMICA"
  },
  {
    "codigo":204853000,
    "descripcion":"ANOMALÍAS DEL CUELLO UTERINO, LA VAGINA Y LOS GENITALES EXTERNOS FEMENINOS"
  },
  {
    "codigo":763744009,
    "descripcion":"SÍNDROME DE DISCAPACIDAD INTELECTUAL, BRAQUIDACTILIA Y PIERRE ROBIN"
  },
  {
    "codigo":1288032009,
    "descripcion":"TUMOR NEUROENDOCRINO BIEN DIFERENCIADO DE RIÑÓN"
  },
  {
    "codigo":41013004,
    "descripcion":"DEFICIENCIA DE ARGININOSUCCINATO LIASA"
  },
  {
    "codigo":237621004,
    "descripcion":"HIPERGLUCEMIA SEVERA DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":203018002,
    "descripcion":"MIOSITIS INFECCIOSA DE PIE"
  },
  {
    "codigo":39178003,
    "descripcion":"IMPULSIVIDAD EMOCIONAL"
  },
  {
    "codigo":792842004,
    "descripcion":"ARTERIOESCLEROSIS CORONARIA EN ARTERIA DE CORAZÓN TRASPLANTADO"
  },
  {
    "codigo":399626004,
    "descripcion":"SIN TRATAMIENTO CONTRA EL CÁNCER POR DESCONOCIMIENTO DEL PRIMARIO"
  },
  {
    "codigo":235786004,
    "descripcion":"FÍSTULA RECTOPROSTÁTICA"
  },
  {
    "codigo":71946004,
    "descripcion":"ALCALOSIS RESPIRATORIA COMPENSADA"
  },
  {
    "codigo":301322008,
    "descripcion":"HALLAZGO RELACIONADO CON LA COLORACIÓN DE LA MANO"
  },
  {
    "codigo":4575002,
    "descripcion":"HIPONATREMIA AGUDA"
  },
  {
    "codigo":168415002,
    "descripcion":"EXTENDIDO CERVICAL: SIN INFLAMACIÓN"
  },
  {
    "codigo":365023005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA REALIZAR FUNCIONES RESPIRATORIAS"
  },
  {
    "codigo":11308961000119105,
    "descripcion":"MÚLTIPLES FRACTURAS POR COMPRESIÓN LATERAL DE PELVIS CON ANILLO PÉLVICO ESTABLE"
  },
  {
    "codigo":102879009,
    "descripcion":"NACIMIENTO POSTÉRMINO"
  },
  {
    "codigo":2740001,
    "descripcion":"PROTEINURIA GOTOSA"
  },
  {
    "codigo":35508004,
    "descripcion":"SIGNO DEL DELTA VACÍO"
  },
  {
    "codigo":331681000119106,
    "descripcion":"ECTROPIÓN CICATRIZAL SUPERIOR DERECHO"
  },
  {
    "codigo":428724006,
    "descripcion":"ARTROPATÍA DE LA ARTICULACIÓN DE LA RODILLA"
  },
  {
    "codigo":232116007,
    "descripcion":"PARÁLISIS DISOCIADA DE LA MIRADA"
  },
  {
    "codigo":263049003,
    "descripcion":"SUBLUXACIÓN DE ARTICULACIÓN ACROMIOCLAVICULAR"
  },
  {
    "codigo":721801005,
    "descripcion":"INFECCIÓN CAUSADA POR RHINOSPORIDIUM"
  },
  {
    "codigo":230281007,
    "descripcion":"ENFERMEDAD CEREBRAL ARGIROFÍLICA"
  },
  {
    "codigo":228446001,
    "descripcion":"HACE POCO EJERCICIO"
  },
  {
    "codigo":293982008,
    "descripcion":"ALERGIA A PROPRANOLOL"
  },
  {
    "codigo":128307000,
    "descripcion":"DENSIDAD RADIOLÓGICA NORMAL"
  },
  {
    "codigo":292147003,
    "descripcion":"REACCIÓN ADVERSA AL BUTILBROMURO DE HIOSCINA"
  },
  {
    "codigo":335251000119100,
    "descripcion":"EPIESCLERITIS DE OJO DERECHO"
  },
  {
    "codigo":332691000119101,
    "descripcion":"ASTIGMATISMO REGULAR DEL OJO DERECHO"
  },
  {
    "codigo":1075091000119102,
    "descripcion":"PRIMER DEDO EN MARTILLO DE PIE DERECHO, ADQUIRIDO"
  },
  {
    "codigo":348051000119102,
    "descripcion":"ATROFIA DE NERVIO ÓPTICO DERECHO DESPUÉS DE INFLAMACIÓN"
  },
  {
    "codigo":319891000119104,
    "descripcion":"NÓDULO REUMATOIDEO DE RODILLA IZQUIERDA"
  },
  {
    "codigo":16414611000119100,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE NERVIOS PERIFÉRICOS DE EXTREMIDAD SUPERIOR IZQUIERDA"
  },
  {
    "codigo":11763091000119106,
    "descripcion":"DISTENSIÓN DE GEMELO IZQUIERDO"
  },
  {
    "codigo":11993491000119107,
    "descripcion":"NECROSIS TISULAR DE PIE IZQUIERDO DEBIDA A CONGELAMIENTO Y POSTERIOR A ÉL"
  },
  {
    "codigo":192008004,
    "descripcion":"INVERSIÓN DEL RITMO DEL SUEÑO"
  },
  {
    "codigo":16698771000119109,
    "descripcion":"RUPTURA TRAUMÁTICA DE LIGAMENTO COLATERAL DE ARTICULACIÓN DE PULGAR DERECHO"
  },
  {
    "codigo":84371000119108,
    "descripcion":"HIPOGLUCEMIA DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":527788091000119106,
    "descripcion":"ENFERMEDAD DE CROHN DE INTESTINO DELGADO E INTESTINO GRUESO EN REMISIÓN"
  },
  {
    "codigo":1077651000119107,
    "descripcion":"OSTEOMIELITIS DE HOMBRO DERECHO"
  },
  {
    "codigo":93704000,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE VASO SANGUÍNEO DEL CUELLO"
  },
  {
    "codigo":94611000119105,
    "descripcion":"LITIASIS VESICULAR DURANTE EMBARAZO"
  },
  {
    "codigo":15631251000119109,
    "descripcion":"BLEFAROSPASMO DE PÁRPADO DERECHO"
  },
  {
    "codigo":386781001,
    "descripcion":"SÍNDROME ESPÁSTICO"
  },
  {
    "codigo":1304285001,
    "descripcion":"GLAUCOMA DE OJO DERECHO DEBIDO A HEMÓLISIS POSTERIOR A HEMORRAGIA INTRAOCULAR"
  },
  {
    "codigo":91869006,
    "descripcion":"AUSENCIA CONGÉNITA DE HUESO ALIESFENOIDAL"
  },
  {
    "codigo":290312008,
    "descripcion":"INTOXICACIÓN POR TOLMETINA"
  },
  {
    "codigo":26333003,
    "descripcion":"ANEMIA MEGALOBLÁSTICA POR MALABSORCIÓN DE VITAMINA B12 CON PROTEINURIA"
  },
  {
    "codigo":11774011000119107,
    "descripcion":"CONTUSIÓN DE DEDO ÍNDICE IZQUIERDO"
  },
  {
    "codigo":253874001,
    "descripcion":"RIÑÓN DOBLE CON REFLUJO EN AMBOS URÉTERES"
  },
  {
    "codigo":219271005,
    "descripcion":"LESIÓN POR INTERVENCIÓN LEGAL CON INTOXICACIÓN POR GAS"
  },
  {
    "codigo":448647006,
    "descripcion":"PULMONES BILATERALMENTE BILOBULADOS DEBIDO A ISOMERISMO DEL PULMÓN IZQUIERDO"
  },
  {
    "codigo":252039007,
    "descripcion":"TIPO DE FÍSTULA URINARIA"
  },
  {
    "codigo":20828000,
    "descripcion":"ENTROPIÓN ESPÁSTICO"
  },
  {
    "codigo":282972001,
    "descripcion":"SE PARA"
  },
  {
    "codigo":284807005,
    "descripcion":"DIFICULTAD PARA BAÑARSE"
  },
  {
    "codigo":1003868002,
    "descripcion":"DUPLICACIÓN DE PORCIÓN PROXIMAL DEL BRAZO LARGO DEL CROMOSOMA 18"
  },
  {
    "codigo":15980911000119101,
    "descripcion":"ANOMALÍA ESTRUCTURAL CONGÉNITA DE PÁRPADOS DE AMBOS OJOS"
  },
  {
    "codigo":334191000119101,
    "descripcion":"RETRACCIÓN ANORMAL DE PÁRPADO INFERIOR DERECHO"
  },
  {
    "codigo":444977005,
    "descripcion":"GLOMERULOESCLEROSIS FOCAL Y SEGMENTARIA AUTOSÓMICA DOMINANTE"
  },
  {
    "codigo":608817003,
    "descripcion":"PITUICITOMA"
  },
  {
    "codigo":248369007,
    "descripcion":"HALLAZGO RELACIONADO CON EL CRÁNEO"
  },
  {
    "codigo":1264177009,
    "descripcion":"PIERCING EN TERCIO DERECHO DE LABIO INFERIOR"
  },
  {
    "codigo":443142001,
    "descripcion":"DEGENERACIÓN DE CUERPO VÍTREO POSTERIOR"
  },
  {
    "codigo":408539000,
    "descripcion":"SÍNDROME DE AUTOINMUNIDAD POR INSULINA"
  },
  {
    "codigo":48091006,
    "descripcion":"SUEÑO PROLONGADO"
  },
  {
    "codigo":1293275008,
    "descripcion":"DERRAME ARTICULAR DE MUÑECA DERECHA"
  },
  {
    "codigo":734384004,
    "descripcion":"TROMBOSIS DE ARTERIA CEREBRAL MEDIA DERECHA"
  },
  {
    "codigo":210096005,
    "descripcion":"LESIÓN TRAUMÁTICA ABIERTA DE CONDUCTO TORÁCICO"
  },
  {
    "codigo":111792007,
    "descripcion":"INTOXICACIÓN POR SOFORA SECUNDIFLORA"
  },
  {
    "codigo":372101000,
    "descripcion":"CARCINOMA DE CONDUCTO BILIAR EXTRAHEPÁTICO"
  },
  {
    "codigo":13488009,
    "descripcion":"SIGNO DE LA BAYONETA"
  },
  {
    "codigo":109957002,
    "descripcion":"PÚRPURA INDUCIDA POR DROGAS"
  },
  {
    "codigo":898224008,
    "descripcion":"FUSIÓN ANORMAL CONGÉNITA DE CUARTO HUESO METACARPIANO"
  },
  {
    "codigo":699781008,
    "descripcion":"DIASTEMA DE LÍNEA MEDIA MAXILAR"
  },
  {
    "codigo":403034002,
    "descripcion":"TIÑA CORPORAL POR MICROSPORUM NANUM"
  },
  {
    "codigo":271962008,
    "descripcion":"RUPTURA TOTAL DEL ANILLO PÉLVICO"
  },
  {
    "codigo":40751003,
    "descripcion":"HIPERFENILALANINEMIA Y TIROSINEMIA PERSISTENTES"
  },
  {
    "codigo":1187631004,
    "descripcion":"GASTROENTERITIS VIRAL POR SAPOVIRUS"
  },
  {
    "codigo":202756004,
    "descripcion":"INFECCIÓN PIÓGENA DE DISCO INTERVERTEBRAL"
  },
  {
    "codigo":38916004,
    "descripcion":"QUEMADURA DE LA CÓRNEA Y\/O DEL SACO CONJUNTIVAL POR SUSTANCIAS QUÍMICAS ALCALINAS"
  },
  {
    "codigo":366596006,
    "descripcion":"AMPLITUD DE MOVIMIENTO PASIVO DE ROTACIÓN EXTERNA DE LA RODILLA - HALLAZGO"
  },
  {
    "codigo":200921001,
    "descripcion":"ERITEMA PAPULOSO"
  },
  {
    "codigo":169988009,
    "descripcion":"INICIA DIETA NORMAL A LOS 6 MESES"
  },
  {
    "codigo":4313003,
    "descripcion":"HEMIACARDÍACO"
  },
  {
    "codigo":102617004,
    "descripcion":"CONGESTIÓN DE GARGANTA"
  },
  {
    "codigo":397529006,
    "descripcion":"HALLAZGO RELACIONADO CON EL MENISCO LAGRIMAL"
  },
  {
    "codigo":69849007,
    "descripcion":"FASE PSICOSEXUAL GENITAL"
  },
  {
    "codigo":788910003,
    "descripcion":"TRASTORNO DISOCIATIVO CON SÍNTOMA NEUROLÓGICO CONCOMITANTE CON MIOCLONÍA"
  },
  {
    "codigo":35246005,
    "descripcion":"CELULITIS ANORRECTAL"
  },
  {
    "codigo":231854006,
    "descripcion":"CONJUNTIVITIS ATÓPICA"
  },
  {
    "codigo":166318006,
    "descripcion":"ANÁLISIS BIOQUÍMICO SANGUÍNEO ANORMAL"
  },
  {
    "codigo":426627000,
    "descripcion":"ELECTROCARDIOGRAMA: BRADICARDIA"
  },
  {
    "codigo":643001,
    "descripcion":"HIPERTROFIA DE LABIO"
  },
  {
    "codigo":33411003,
    "descripcion":"LESIÓN TRAUMÁTICA DE LAS RAÍCES NERVIOSAS Y\/O DE LOS PLEXOS ESPINALES DE SITIOS MÚLTIPLES"
  },
  {
    "codigo":361091007,
    "descripcion":"DEFICIENCIA DE HIDROLASA FOSFÓRICA MONOÉSTER"
  },
  {
    "codigo":262787008,
    "descripcion":"LESIÓN TRAUMÁTICA DEL DIAFRAGMA"
  },
  {
    "codigo":721539008,
    "descripcion":"VITILIGO DE PÁRPADO Y REGIÓN PERIOCULAR"
  },
  {
    "codigo":230019008,
    "descripcion":"POSICIÓN INCLINADA DEL TRONCO"
  },
  {
    "codigo":295555009,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE CINCOCAÍNA"
  },
  {
    "codigo":129880000,
    "descripcion":"HALLAZGO RELACIONADO CON LA ATENCIÓN DE UN ADULTO DEPENDIENTE"
  },
  {
    "codigo":117411000119106,
    "descripcion":"ACÚFENO PULSÁTIL OBJETIVO"
  },
  {
    "codigo":293720008,
    "descripcion":"ALERGIA A CINCOCAÍNA"
  },
  {
    "codigo":160813000,
    "descripcion":"LITIGACIÓN PENDIENTE"
  },
  {
    "codigo":128045006,
    "descripcion":"CELULITIS"
  },
  {
    "codigo":1073981000119102,
    "descripcion":"BURSITIS GOTOSA DE RODILLA DERECHA"
  },
  {
    "codigo":191746002,
    "descripcion":"NEUROSIS PSICOASTÉNICA"
  },
  {
    "codigo":879874002,
    "descripcion":"DERMATITIS IRRITATIVA POR CONTACTO CAUSADA POR MATERIA FECAL"
  },
  {
    "codigo":93442005,
    "descripcion":"CENTRO CARTILAGINOSO DE VÉRTEBRA LUMBAR CON FORMA DE MANCUERNA"
  },
  {
    "codigo":26071001,
    "descripcion":"ARTRITIS INFECCIOSA AGUDA"
  },
  {
    "codigo":1304023003,
    "descripcion":"MALFORMACIÓN CONGÉNITA DE HÉLICE DE OREJA"
  },
  {
    "codigo":1172951004,
    "descripcion":"DIENTES DECIDUOS PERSISTENTES"
  },
  {
    "codigo":419287006,
    "descripcion":"REACCIÓN ADVERSA A DERIVADO DEL PARA-AMINOFENOL"
  },
  {
    "codigo":288215009,
    "descripcion":"RUPTURA DE TENDÓN - MÚLTIPLE"
  },
  {
    "codigo":286380003,
    "descripcion":"CAPAZ DE ENCONTRAR LAS PALABRAS"
  },
  {
    "codigo":417452004,
    "descripcion":"DISFUNCIÓN DE HUESO PÚBICO"
  },
  {
    "codigo":253612007,
    "descripcion":"PROLAPSO DE CÚSPIDE DE VÁLVULA AÓRTICA"
  },
  {
    "codigo":188076009,
    "descripcion":"MELANOMA MALIGNO DE DEDO DEL PIE"
  },
  {
    "codigo":219009004,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR AGENTES OXITÓCICOS"
  },
  {
    "codigo":87937009,
    "descripcion":"ENDOFLEBITIS DE SENO VENOSO INTRACRANEAL"
  },
  {
    "codigo":249942005,
    "descripcion":"DEBILIDAD DE MÚSCULOS DISTALES"
  },
  {
    "codigo":282710005,
    "descripcion":"INCAPAZ DE EMPUJAR Y ARRASTRAR HACIA ADELANTE UN JUGUETE PEQUEÑO CON RUEDAS"
  },
  {
    "codigo":20566008,
    "descripcion":"METATARSO VALGO"
  },
  {
    "codigo":1296683001,
    "descripcion":"TAQUIARRITMIA ESTABLE"
  },
  {
    "codigo":51499002,
    "descripcion":"TRASTORNO DE LAS AMÍGDALAS Y\/O ADENOIDES"
  },
  {
    "codigo":10632151000119104,
    "descripcion":"ABSCESO DE DEDO DE PIE IZQUIERDO"
  },
  {
    "codigo":315478008,
    "descripcion":"NACIDO EN MAURICIO"
  },
  {
    "codigo":705024000,
    "descripcion":"CON MEDICACIÓN PSICOTRÓPICA"
  },
  {
    "codigo":870699009,
    "descripcion":"RANGO DE FRECUENCIA CARDÍACA FETAL BASAL DE 120 A 160"
  },
  {
    "codigo":770560008,
    "descripcion":"LISENCEFALIA POR MUTACIÓN EN LIS1"
  },
  {
    "codigo":279040009,
    "descripcion":"DOLOR LUMBAR DE CAUSA MECÁNICA"
  },
  {
    "codigo":311808009,
    "descripcion":"ARTERIA SUBCLAVIA RETROESOFÁGICA ABERRANTE QUE CAUSA DISFAGIA"
  },
  {
    "codigo":1293013003,
    "descripcion":"EXPERIENCIA DE INFLUENCIA, CONTROL Y PASIVIDAD"
  },
  {
    "codigo":80597004,
    "descripcion":"FRACTURA DE FALANGE MEDIA Y\/O PROXIMAL DE DEDO DE LA MANO"
  },
  {
    "codigo":703189006,
    "descripcion":"ENDOCARDITIS DE PRÓTESIS DE VÁLVULA AÓRTICA"
  },
  {
    "codigo":1356714000,
    "descripcion":"LESIÓN TRAUMÁTICA DE VASO SANGUÍNEO DIGITAL DE PIE"
  },
  {
    "codigo":373674001,
    "descripcion":"URTICARIA ANAFILÁCTICA"
  },
  {
    "codigo":111530003,
    "descripcion":"HETEROTROPÍA VERTICAL"
  },
  {
    "codigo":45994004,
    "descripcion":"EMESIS ERÓTICA"
  },
  {
    "codigo":15684721000119103,
    "descripcion":"PERIOSTITIS DE ANTEBRAZO IZQUIERDO"
  },
  {
    "codigo":11391004,
    "descripcion":"DESPRENDIMIENTO EXUDATIVO DEL EPITELIO PIGMENTARIO RETINIANO"
  },
  {
    "codigo":109695005,
    "descripcion":"OSTEOMIELITIS MANDIBULAR"
  },
  {
    "codigo":240767007,
    "descripcion":"ABSCESO CROMOBLASTOMICÓTICO PRIMARIO"
  },
  {
    "codigo":206164002,
    "descripcion":"FETO PEQUEÑO PARA LA EDAD GESTACIONAL CON SIGNOS DE DESNUTRICIÓN"
  },
  {
    "codigo":238932004,
    "descripcion":"LIQUEN ESCLEROSO GENITAL"
  },
  {
    "codigo":402772005,
    "descripcion":"ICTIOSIS AUTOSÓMICA RECESIVA"
  },
  {
    "codigo":271700006,
    "descripcion":"COREA"
  },
  {
    "codigo":11998321000119106,
    "descripcion":"QUEMADURA DE TERCER GRADO DE TÓRAX POSTERIOR"
  },
  {
    "codigo":763220008,
    "descripcion":"QUISTE DERMOIDE DE CARA"
  },
  {
    "codigo":1254740008,
    "descripcion":"METÁSTASIS DE CARCINOMA DE CÉLULAS GIGANTES EN PULMÓN"
  },
  {
    "codigo":1351209002,
    "descripcion":"INMUNODEFICIENCIA COMBINADA SEVERA T NEGATIVA B POSITIVA AUTOSÓMICA RECESIVA DEBIDA A MUTACIÓN DE SUBUNIDAD DELTA DE COMPLEJO CD3 RECEPTOR DE LINFOCITOS T"
  },
  {
    "codigo":287112003,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN EL BRAZO"
  },
  {
    "codigo":42324007,
    "descripcion":"DUPLICACIÓN CONGÉNITA DEL CIEGO"
  },
  {
    "codigo":400937005,
    "descripcion":"EXOTROPÍA SENSORIAL"
  },
  {
    "codigo":1285673007,
    "descripcion":"DISTENSIÓN DE MÚSCULO DE ANTEBRAZO"
  },
  {
    "codigo":1076491000119102,
    "descripcion":"RUPTURA COMPLETA NO TRAUMÁTICA DE MANGUITO ROTADOR DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":38654001,
    "descripcion":"CÓLICO BILIAR RECURRENTE"
  },
  {
    "codigo":237097008,
    "descripcion":"VULVOVAGINITIS POR CLAMIDIA"
  },
  {
    "codigo":268030004,
    "descripcion":"OSTEONECROSIS DE CÓNDILO FEMORAL INTERNO"
  },
  {
    "codigo":300798006,
    "descripcion":"CAPAZ DE PARTICIPAR EN ACTIVIDADES DEPORTIVAS"
  },
  {
    "codigo":366334007,
    "descripcion":"HALLAZGO RELACIONADO CON EL ESTADO DEL LÍQUIDO AMNIÓTICO"
  },
  {
    "codigo":167891000,
    "descripcion":"LÍQUIDO SINOVIAL: PRESENCIA DE COÁGULO DE FIBRINA"
  },
  {
    "codigo":298963002,
    "descripcion":"SIN AMPLITUD ACTIVA DE EXTENSIÓN DE LA MUÑECA"
  },
  {
    "codigo":430035004,
    "descripcion":"DILATACIÓN DE PELVIS RENAL FETAL"
  },
  {
    "codigo":200659006,
    "descripcion":"CELULITIS Y ABSCESO DE LA PARED ABDOMINAL"
  },
  {
    "codigo":723112000,
    "descripcion":"TEMOR A ENFERMEDAD ENDOCRINA"
  },
  {
    "codigo":460968002,
    "descripcion":"ORIGEN ANÓMALO DE LIGAMENTO ARTERIOSO DERECHO EN CAYADO AÓRTICO DERECHO"
  },
  {
    "codigo":2216005,
    "descripcion":"POLUCIÓN NOCTURNA"
  },
  {
    "codigo":297128006,
    "descripcion":"DOLOR DE NUCA"
  },
  {
    "codigo":262525000,
    "descripcion":"LESIÓN TRAUMÁTICA TORÁCICA"
  },
  {
    "codigo":198824009,
    "descripcion":"SALPINGOOFORITIS POSABORTO"
  },
  {
    "codigo":295293003,
    "descripcion":"SOBREDOSIS INTENCIONAL DE PIROXICAM"
  },
  {
    "codigo":195154000,
    "descripcion":"RUPTURA DE ANEURISMA SACULADO"
  },
  {
    "codigo":129618003,
    "descripcion":"DISREFLEXIA AUTÓNOMA"
  },
  {
    "codigo":1145426005,
    "descripcion":"HIPOPLASIA CONGÉNITA DE HUESO DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":293458006,
    "descripcion":"REACCIÓN ADVERSA A LA HIDROCLOROTIAZIDA"
  },
  {
    "codigo":783143001,
    "descripcion":"TRASTORNO SEMEJANTE A SÍNDROME DE NOONAN CON LEUCEMIA MIELOMONOCÍTICA JUVENIL"
  },
  {
    "codigo":422695002,
    "descripcion":"PERÍMETRO CEFÁLICO ANORMAL EN RELACIÓN CON EL ESTÁNDAR DE CRECIMIENTO \/ EDAD"
  },
  {
    "codigo":226087001,
    "descripcion":"DIETA DE AMINOÁCIDOS MODIFICADOS"
  },
  {
    "codigo":95015004,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL PUBIS"
  },
  {
    "codigo":193319001,
    "descripcion":"DESPRENDIMIENTO PARCIAL DE RETINA, NUEVO, CON DEFECTO ÚNICO"
  },
  {
    "codigo":291623006,
    "descripcion":"INTOXICACIÓN POR CEFTIBUTENO"
  },
  {
    "codigo":29479008,
    "descripcion":"ATONÍA DEL COLON"
  },
  {
    "codigo":93180003,
    "descripcion":"MACROMELIA"
  },
  {
    "codigo":60412004,
    "descripcion":"INFESTACIÓN CAUSADA POR LARVAS DE MOSCA"
  },
  {
    "codigo":224252007,
    "descripcion":"AUMENTO DE LA HUMEDAD EN EL HOGAR"
  },
  {
    "codigo":255185000,
    "descripcion":"TUMOR BENIGNO DE PIEL CON DIFERENCIACIÓN SEBÁCEA"
  },
  {
    "codigo":1010684009,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE EXTREMIDAD INFERIOR DERECHA A TRAVÉS DEL MUSLO"
  },
  {
    "codigo":289788009,
    "descripcion":"HALLAZGO RELACIONADO CON LA DIRECCIÓN DEL CUELLO UTERINO"
  },
  {
    "codigo":1172689007,
    "descripcion":"ATROFIA MUSCULAR ESPINAL DE INICIO PRENATAL CON FRACTURAS ÓSEAS CONGÉNITAS"
  },
  {
    "codigo":25809009,
    "descripcion":"VÍCTIMA DE TRAUMATISMO"
  },
  {
    "codigo":124113009,
    "descripcion":"DEFICIENCIA DE SHIQUIMATO DESHIDROGENASA"
  },
  {
    "codigo":187814001,
    "descripcion":"NEOPLASIA MALIGNA DE SACO DE DOUGLAS"
  },
  {
    "codigo":15959461000119109,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE AMBAS GLÁNDULAS SUPRARRENALES"
  },
  {
    "codigo":253350005,
    "descripcion":"DILATACIÓN DE LA AURÍCULA DERECHA"
  },
  {
    "codigo":286118005,
    "descripcion":"INCAPAZ DE LIMPIAR EL PISO"
  },
  {
    "codigo":284283001,
    "descripcion":"INCAPAZ DE EMPLEAR AGARRE CON DOS DEDOS"
  },
  {
    "codigo":251515005,
    "descripcion":"HALLAZGO EN EL ELECTROMIOGRAMA"
  },
  {
    "codigo":118608000,
    "descripcion":"ENFERMEDAD DE HODGKIN, ESCLEROSIS NODULAR (CLÍNICA)"
  },
  {
    "codigo":282448001,
    "descripcion":"LESIÓN DE SENO PARANASAL"
  },
  {
    "codigo":16670271000119106,
    "descripcion":"FRACTURA NO EXPUESTA DE RAMA DE MANDÍBULA IZQUIERDA"
  },
  {
    "codigo":773968006,
    "descripcion":"BURSITIS DE CADERA DERECHA"
  },
  {
    "codigo":15742681000119100,
    "descripcion":"TUMEFACCIÓN DE DEDO DE LA MANO DERECHA"
  },
  {
    "codigo":772133000,
    "descripcion":"ABSTINENCIA DE ABUSO RECREATIVO DE DROGAS"
  },
  {
    "codigo":249680009,
    "descripcion":"CLAVÍCULA ANCHA"
  },
  {
    "codigo":40511000119107,
    "descripcion":"HIPERTENSIÓN ESENCIAL PREEXISTENTE DESPUÉS DEL PARTO"
  },
  {
    "codigo":85840009,
    "descripcion":"EPIFISITIS"
  },
  {
    "codigo":18469004,
    "descripcion":"PRODUCCIÓN DE ERITROCITOS DISMINUIDA"
  },
  {
    "codigo":247845000,
    "descripcion":"TEMOR ESPECÍFICO"
  },
  {
    "codigo":1263653008,
    "descripcion":"METÁSTASIS DE CARCINOMA MUCOEPIDERMOIDE EN GLÁNDULA SALIVAL"
  },
  {
    "codigo":122431000119109,
    "descripcion":"INFECCIÓN ASOCIADA CON PRÓTESIS DE CRÁNEO"
  },
  {
    "codigo":442618008,
    "descripcion":"HALLAZGO ANORMAL EN PROCEDIMIENTO DE EVALUACIÓN"
  },
  {
    "codigo":211407005,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE DEDO DE PIE"
  },
  {
    "codigo":111268000,
    "descripcion":"LORDOESCOLIOSIS"
  },
  {
    "codigo":309711009,
    "descripcion":"PERSONALIDAD MANIPULADORA"
  },
  {
    "codigo":1290916005,
    "descripcion":"HAPLOINSUFICIENCIA DE A20"
  },
  {
    "codigo":1079001000119106,
    "descripcion":"ANGIOMIOLIPOMA DE RIÑÓN DERECHO"
  },
  {
    "codigo":109433009,
    "descripcion":"ESTEATOCISTOMA MÚLTIPLE"
  },
  {
    "codigo":238670002,
    "descripcion":"LIQUEN PLANO DEL PENE"
  },
  {
    "codigo":762958007,
    "descripcion":"HEMATOMA PERIOPERATORIO"
  },
  {
    "codigo":304206008,
    "descripcion":"AMPLITUD DE EXTENSIÓN HORIZONTAL ACTIVA DE HOMBRO DISMINUIDA"
  },
  {
    "codigo":369742009,
    "descripcion":"BORDE TUMORAL CON CRECIMIENTO EXPANSIVO"
  },
  {
    "codigo":402510008,
    "descripcion":"CARCINOMA BASOCELULAR DEL HÉLIX AURICULAR"
  },
  {
    "codigo":890360000,
    "descripcion":"POLIDACTILIA BILATERAL DE PULGAR"
  },
  {
    "codigo":169464001,
    "descripcion":"CEFALEA CAUSADA POR ANTICONCEPTIVOS ORALES"
  },
  {
    "codigo":235000001,
    "descripcion":"GRANULOMATOSIS DE WEGENER CON POLIANGEÍTIS DE ENCÍAS"
  },
  {
    "codigo":202232002,
    "descripcion":"SUBLUXACIÓN RECURRENTE DE MUÑECA"
  },
  {
    "codigo":366072006,
    "descripcion":"HALLAZGO RELACIONADO CON LA VELOCIDAD DEL FOCO OCULAR - HALLAZGO"
  },
  {
    "codigo":724685000,
    "descripcion":"TRASTORNO AMNÉSICO CAUSADO POR SEDANTE"
  },
  {
    "codigo":298701009,
    "descripcion":"PRUEBA DE ROTACIÓN SIMULADA, NEGATIVA"
  },
  {
    "codigo":722850002,
    "descripcion":"ENFERMEDAD DE CROHN DE ANASTOMOSIS GASTROINTESTINAL"
  },
  {
    "codigo":165794004,
    "descripcion":"AUSENCIA DE INMUNIDAD CONTRA RUBÉOLA DETERMINADA POR SEROLOGÍA"
  },
  {
    "codigo":262263007,
    "descripcion":"BANDA ONFALOMESENTÉRICA"
  },
  {
    "codigo":721015008,
    "descripcion":"SÍNDROME DE HIDROCEFALIA CON FIBROELASTOSIS ENDOCÁRDICA Y CATARATAS"
  },
  {
    "codigo":293196003,
    "descripcion":"REACCIÓN ADVERSA A LA GLICLAZIDA"
  },
  {
    "codigo":424268004,
    "descripcion":"ALTERACIONES DE LOS REFLEJOS POR CONSUMO DE SUSTANCIAS"
  },
  {
    "codigo":194892009,
    "descripcion":"ANEURISMA DE ARTERIA PULMONAR"
  },
  {
    "codigo":225825002,
    "descripcion":"VÍCTIMA DE MALTRATO VERBAL"
  },
  {
    "codigo":291361002,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR AMINOFILINA"
  },
  {
    "codigo":782881002,
    "descripcion":"NEUROPATÍA SENSORIOMOTRIZ HEREDITARIA CON PIEL HIPERELÁSTICA"
  },
  {
    "codigo":1208865003,
    "descripcion":"TROMBOEMBOLISMO VENOSO CON ORIGEN EN VENA CAVA"
  },
  {
    "codigo":717345006,
    "descripcion":"CORYNEBACTERIUM AMYCOLATUM O CORYNEBACTERIUM MINUTISSIMUM"
  },
  {
    "codigo":15935501000119108,
    "descripcion":"DEFORMIDAD EN FLEXIÓN DE ARTICULACIÓN DE AMBAS CADERAS"
  },
  {
    "codigo":1010422002,
    "descripcion":"HIPERPLASIA DE APÓFISIS CONDÍLEA DERECHA DE MANDÍBULA"
  },
  {
    "codigo":27382006,
    "descripcion":"ALOPECIA MUCINOSA"
  },
  {
    "codigo":289526008,
    "descripcion":"TUMEFACCIÓN DE LA PARED VAGINAL"
  },
  {
    "codigo":92918008,
    "descripcion":"FORMA ANORMAL CONGÉNITA DEL OÍDO INTERNO"
  },
  {
    "codigo":191222008,
    "descripcion":"HEMOGLOBINURIA SECUNDARIA A HEMÓLISIS POR CAUSAS EXTERNAS"
  },
  {
    "codigo":418763003,
    "descripcion":"TRASTORNO DE MOVIMIENTO PERIÓDICO DE UNA EXTREMIDAD"
  },
  {
    "codigo":254923001,
    "descripcion":"TUMOR FIBROSO SOLITARIO DE RIÑÓN"
  },
  {
    "codigo":89248000,
    "descripcion":"ZOOFILIA ERÓTICA"
  },
  {
    "codigo":1081511000119105,
    "descripcion":"NEVO EPIDÉRMICO PILOSO PIGMENTADO DE MIEMBRO SUPERIOR DERECHO"
  },
  {
    "codigo":285856002,
    "descripcion":"INCAPAZ DE MANEJAR ENSERES DOMÉSTICOS"
  },
  {
    "codigo":416928007,
    "descripcion":"RECIBE VACUNA ANTIGRIPAL EN EL TRABAJO"
  },
  {
    "codigo":447861001,
    "descripcion":"CONEXIÓN VENOSA PULMONAR ANÓMALA PARCIAL CON VENAS ANÓMALAS CONECTADAS EN PRIMER TÉRMINO A LA CONFLUENCIA VENOSA PULMONAR"
  },
  {
    "codigo":21877004,
    "descripcion":"SÍNDROME DE TELANGIECTASIA HEMORRÁGICA DE OSLER"
  },
  {
    "codigo":54645004,
    "descripcion":"FRACTURA DE BARTON"
  },
  {
    "codigo":12114241000119102,
    "descripcion":"QUEMADURA QUÍMICA DE RODILLA IZQUIERDA"
  },
  {
    "codigo":11786561000119102,
    "descripcion":"AMPOLLA DE DEDO MEDIO DE MANO DERECHA, CON INFECCIÓN"
  },
  {
    "codigo":249418002,
    "descripcion":"HEMORRAGIA DE LA MUCOSA ORAL"
  },
  {
    "codigo":446026002,
    "descripcion":"COMPLEJO HERNIA HIDROCELE"
  },
  {
    "codigo":413258004,
    "descripcion":"OBSTRUCCIÓN DE CONDUCTO PANCREÁTICO POR CÁLCULO"
  },
  {
    "codigo":314954002,
    "descripcion":"RECIDIVA LOCAL DE NEOPLASIA MALIGNA DE PULMÓN"
  },
  {
    "codigo":344231000119109,
    "descripcion":"PSEUDOEDEMA DE PAPILA BILATERAL"
  },
  {
    "codigo":282186001,
    "descripcion":"INCAPAZ DE BAJAR UN ESCALÓN"
  },
  {
    "codigo":50975002,
    "descripcion":"OPÉRCULO RETINIANO SIN DESPRENDIMIENTO"
  },
  {
    "codigo":278516003,
    "descripcion":"NEUMONÍA LOBULAR"
  },
  {
    "codigo":1259721000,
    "descripcion":"GLIOMA PRIMARIO MALIGNO DE MÉDULA ESPINAL"
  },
  {
    "codigo":276681001,
    "descripcion":"DACRIOCISTITIS NEONATAL POR CLAMIDIAS"
  },
  {
    "codigo":737268008,
    "descripcion":"HEMANGIOMA DE CONJUNTIVA"
  },
  {
    "codigo":735433009,
    "descripcion":"SARCOIDOSIS DE SISTEMA DIGESTIVO"
  },
  {
    "codigo":274846002,
    "descripcion":"HALLAZGO INMUNOLÓGICO ANORMAL EN ESPÉCIMEN OBTENIDO DE ÓRGANO GENITAL MASCULINO"
  },
  {
    "codigo":733598001,
    "descripcion":"LEUCEMIA MIELOIDE AGUDA CON TRANSLOCACIÓN T(6;9)(P23;Q34)"
  },
  {
    "codigo":405918004,
    "descripcion":"EQUIPO INTERGRUPAL PARA EL ESTUDIO POSQUIRÚRGICO DE RABDOMIOSARCOMA, NO APLICABLE"
  },
  {
    "codigo":209310008,
    "descripcion":"FRACTURA-LUXACIÓN EXPUESTA DE DEDO"
  },
  {
    "codigo":43635001,
    "descripcion":"QUEMADURA EPIDÉRMICA DE REGIÓN ESCAPULAR"
  },
  {
    "codigo":11760091000119104,
    "descripcion":"LACERACIÓN DE ARTERIA POPLÍTEA IZQUIERDA"
  },
  {
    "codigo":1256051004,
    "descripcion":"ALOPECIA CICATRICIAL DEBIDA A RADIOTERAPIA Y POSTERIOR A ELLA"
  },
  {
    "codigo":10867005,
    "descripcion":"CUELLO DE BISONTE"
  },
  {
    "codigo":238408000,
    "descripcion":"INFECCIÓN UNGUEAL"
  },
  {
    "codigo":371315009,
    "descripcion":"ANEMIA POR DEFICIENCIA DE HIERRO SECUNDARIA A INGESTA INADECUADA DE HIERRO DIETARIO"
  },
  {
    "codigo":9032002,
    "descripcion":"EXHUMACIÓN PARA RECUPERACIÓN DE TEJIDOS"
  },
  {
    "codigo":404083008,
    "descripcion":"ANGIOMIXOMA"
  },
  {
    "codigo":402248004,
    "descripcion":"REACCIÓN LIQUENOIDE ALÉRGICA DE CONTACTO CAUSADA POR TINTA DE TATUAJE"
  },
  {
    "codigo":271176005,
    "descripcion":"AMPOLLA TRAUMÁTICA DE LA RODILLA"
  },
  {
    "codigo":1186845001,
    "descripcion":"INFERTILIDAD MASCULINA DEBIDA A VARICOCELE"
  },
  {
    "codigo":236573002,
    "descripcion":"RECHAZO DE TRASPLANTE RENAL, MUY LEVE"
  },
  {
    "codigo":105501005,
    "descripcion":"DEPENDENCIA DE MÁQUINA O DISPOSITIVO VITAL"
  },
  {
    "codigo":302109006,
    "descripcion":"GASTROSTOMÍA, PRESENTE"
  },
  {
    "codigo":300274000,
    "descripcion":"SECRECIÓN FARÍNGEA"
  },
  {
    "codigo":346741000119102,
    "descripcion":"DEGENERACIÓN BILATERAL DE CUERPOS CILIARES OCULARES"
  },
  {
    "codigo":365810002,
    "descripcion":"PATRÓN CROMATOGRÁFICO DE HIDRATOS DE CARBONO-HALLAZGO"
  },
  {
    "codigo":201970008,
    "descripcion":"ARTRITIS ALÉRGICA DE TOBILLO Y PIE"
  },
  {
    "codigo":167367001,
    "descripcion":"MICROSCOPIA DE ORINA: BACTERIAS PRESENTES"
  },
  {
    "codigo":165532001,
    "descripcion":"LINFOCITOSIS RELATIVA"
  },
  {
    "codigo":720753002,
    "descripcion":"CRANEOOSTEOARTROPATÍA"
  },
  {
    "codigo":294769002,
    "descripcion":"ALERGIA A BICALUTAMIDA"
  },
  {
    "codigo":425841004,
    "descripcion":"DEPENDENCIA DE FENCICLIDINA EN REMISIÓN"
  },
  {
    "codigo":1084021000119107,
    "descripcion":"ENFERMEDAD DE MÉNIÈRE BILATERAL"
  },
  {
    "codigo":1179505008,
    "descripcion":"HISTIDINA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1144902007,
    "descripcion":"MONONEURITIS MÚLTIPLE DEBIDA A VASCULITIS CRIOGLOBULINÉMICA"
  },
  {
    "codigo":225563000,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN EN GLÚTEO"
  },
  {
    "codigo":292934009,
    "descripcion":"REACCIÓN ADVERSA A LA AZITROMICINA"
  },
  {
    "codigo":192795000,
    "descripcion":"DEGENERACIÓN CEREBRAL EN LA ENFERMEDAD DE HUNTER"
  },
  {
    "codigo":127259005,
    "descripcion":"NEOPLASIA DE LOS GANGLIOS LINFÁTICOS CUBITALES"
  },
  {
    "codigo":94491007,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA GLÁNDULA HIPÓFISIS"
  },
  {
    "codigo":92656007,
    "descripcion":"CARCINOMA IN SITU DEL DIVERTÍCULO DE MECKEL"
  },
  {
    "codigo":189125000,
    "descripcion":"PAPILOMA CUTÁNEO DE VAGINA"
  },
  {
    "codigo":1174000008,
    "descripcion":"SÍNDROME CONGÉNITO DE RIGIDEZ MUSCULAR HIPERCONTRÁCTIL GENERALIZADA"
  },
  {
    "codigo":254661000,
    "descripcion":"PAPILOMA DE CÉLULAS ESCAMOSAS DE LA PIEL"
  },
  {
    "codigo":713413001,
    "descripcion":"DOLOR ARTICULAR DE LA REGIÓN PÉLVICA"
  },
  {
    "codigo":123589003,
    "descripcion":"BRONCONEUMONÍA NECROSANTE"
  },
  {
    "codigo":10642191000119108,
    "descripcion":"OSTEONECROSIS DE SACRO DEBIDA A ÚLCERA CRÓNICA DE SACRO"
  },
  {
    "codigo":1268634001,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS PRIMARIO DE ESTÓMAGO"
  },
  {
    "codigo":449434002,
    "descripcion":"LOCALIZACIÓN SUPRACARDÍACA DE CONEXIÓN VENOSA PULMONAR ANÓMALA A VENA CAVA SUPERIOR IZQUIERDA"
  },
  {
    "codigo":293801000119103,
    "descripcion":"NEUROMA DE TOBILLO"
  },
  {
    "codigo":1137562007,
    "descripcion":"HIPERPLASIA FIBROEPITELIAL INFLAMATORIA DE MEMBRANA MUCOSA ORAL CAUSADA POR PRÓTESIS DENTAL"
  },
  {
    "codigo":56218007,
    "descripcion":"HIPERTENSIÓN ARTERIAL SISTÓLICA"
  },
  {
    "codigo":283759001,
    "descripcion":"MORDEDURA DE PERRO EN EL TRONCO"
  },
  {
    "codigo":416666007,
    "descripcion":"UVEÍTIS ANTERIOR DEBIDA A ARTRITIS IDIOPÁTICA JUVENIL"
  },
  {
    "codigo":21615003,
    "descripcion":"CEFALALGIA FACIAL AUTONÓMICA"
  },
  {
    "codigo":1332335009,
    "descripcion":"SÍNDROME DE NEVO DE BECKER"
  },
  {
    "codigo":183620002,
    "descripcion":"SEGUIMIENTO EN 1 SEMANA"
  },
  {
    "codigo":314692003,
    "descripcion":"TALLA DEL NIÑO: PERCENTILO 10-24"
  },
  {
    "codigo":871748004,
    "descripcion":"CAPAZ DE CUIDAR POSESIONES PERSONALES"
  },
  {
    "codigo":281924004,
    "descripcion":"FRACTURA POR ESTALLIDO DE VÉRTEBRA DORSAL"
  },
  {
    "codigo":443929000,
    "descripcion":"ENFERMEDAD CEREBROVASCULAR DE PEQUEÑOS VASOS"
  },
  {
    "codigo":52548009,
    "descripcion":"ESPASMO FACIAL CLÓNICO"
  },
  {
    "codigo":565951401000119107,
    "descripcion":"ÚLCERA VENOSA DE PANTORRILLA DERECHA"
  },
  {
    "codigo":85316008,
    "descripcion":"HIPERTROFIA DE PAPILA ANAL"
  },
  {
    "codigo":1197593006,
    "descripcion":"SÍNDROME DE DISCAPACIDAD INTELECTUAL, AFASIA DE EXPRESIÓN Y DISMORFIA FACIAL"
  },
  {
    "codigo":247321007,
    "descripcion":"OLOR INUSUAL EN LA NARIZ"
  },
  {
    "codigo":312857009,
    "descripcion":"DEFICIENCIA DE ALFA-2-ANTITRIPSINA"
  },
  {
    "codigo":737006004,
    "descripcion":"EXCAVACIÓN DE AMBAS PAPILAS ÓPTICAS DEBIDA A GLAUCOMA DE ÁNGULO ABIERTO"
  },
  {
    "codigo":16110005,
    "descripcion":"OFTALMOPLEJÍA"
  },
  {
    "codigo":350021000221109,
    "descripcion":"MICOSIS DE LOS SENOS PARANASALES"
  },
  {
    "codigo":704238006,
    "descripcion":"FRACTURA EXPUESTA EN MARTILLO DE FALANGE DISTAL DE DEDO MEÑIQUE"
  },
  {
    "codigo":179950008,
    "descripcion":"DEFECACIÓN ANORMAL"
  },
  {
    "codigo":212718008,
    "descripcion":"INTOXICACIÓN POR ANTAGONISTAS DEL RECEPTOR H2 DE HISTAMINA"
  },
  {
    "codigo":442094008,
    "descripcion":"NEUMONÍA CAUSADA POR HISTOPLASMA"
  },
  {
    "codigo":16077891000119104,
    "descripcion":"PREDISPOSICIÓN GENÉTICA PARA NEOPLASIA MALIGNA DE PRÓSTATA"
  },
  {
    "codigo":276419004,
    "descripcion":"NEOPLASIA MALIGNA DE CUERPO ESPONJOSO"
  },
  {
    "codigo":405656000,
    "descripcion":"RESULTADO ADVERSO DERIVADO DE LA ANESTESIA"
  },
  {
    "codigo":473027008,
    "descripcion":"COMPLICACIÓN ASOCIADA CON CATÉTER CENTRAL INSERTADO POR VÍA PERIFÉRICA"
  },
  {
    "codigo":866243009,
    "descripcion":"CON MAYOR RIESGO DE SÍNDROME DE PREDISPOSICIÓN HEREDITARIA A CÁNCER"
  },
  {
    "codigo":210883008,
    "descripcion":"LESIÓN DE VASOS SANGUÍNEOS TIBIALES"
  },
  {
    "codigo":733336004,
    "descripcion":"DEFORMIDAD DE GLOBO OCULAR"
  },
  {
    "codigo":77976003,
    "descripcion":"PIGOMELO"
  },
  {
    "codigo":1259459009,
    "descripcion":"CARCINOMA BASOCELULAR NODULAR DE PIEL PRIMARIO"
  },
  {
    "codigo":11818051000119106,
    "descripcion":"ESGUINCE DE LIGAMENTO DE ARTICULACIÓN METACARPOFALÁNGICA DE DEDO ANULAR DE MANO IZQUIERDA"
  },
  {
    "codigo":241816009,
    "descripcion":"EFECTO DE LA SALIVA DE LA COBRA VENENOSA EN LA CONJUNTIVA"
  },
  {
    "codigo":209048009,
    "descripcion":"LUXACIÓN VERTEBRAL NO EXPUESTA CON LESIÓN MEDULAR COMPLETA A NIVEL CERVICAL"
  },
  {
    "codigo":305517002,
    "descripcion":"BAJO ATENCIÓN DE PSICOGERIATRA"
  },
  {
    "codigo":403821004,
    "descripcion":"MÁCULAS CAFÉ CON LECHE CON DISRITMIA TEMPORAL"
  },
  {
    "codigo":1255789005,
    "descripcion":"LINFOMA DE HODGKIN, VARIANTE CELULARIDAD MIXTA DE GANGLIOS LINFÁTICOS DE CUELLO"
  },
  {
    "codigo":239981007,
    "descripcion":"RUPTURA DEL MÚSCULO EXTENSOR DEL PULGAR"
  },
  {
    "codigo":238146000,
    "descripcion":"HIPERVITAMINOSIS B6"
  },
  {
    "codigo":698733009,
    "descripcion":"OBSTRUCCIÓN INTESTINAL DEBIDA A TUBERCULOSIS"
  },
  {
    "codigo":43373009,
    "descripcion":"TIÑA DE LA BARBA POR MICROSPORUM CANIS"
  },
  {
    "codigo":762434003,
    "descripcion":"HIPOMAGNESURIA"
  },
  {
    "codigo":203543000,
    "descripcion":"SUPERPOSICIÓN DEL QUINTO DEDO DEL PIE"
  },
  {
    "codigo":6935003,
    "descripcion":"DIÁTESIS HEMORRÁGICA FAMILIAR"
  },
  {
    "codigo":170775008,
    "descripcion":"DIABETES: PROGRAMA DE CUIDADOS COMPARTIDOS"
  },
  {
    "codigo":1119212003,
    "descripcion":"DOLOR A LA PALPACIÓN EN REGIÓN ABDOMINAL LUMBAR DERECHA"
  },
  {
    "codigo":365548003,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD DE EMPRENDER TRABAJO VOLUNTARIO"
  },
  {
    "codigo":234476006,
    "descripcion":"DEFICIENCIA DE CICLOXIGENASA"
  },
  {
    "codigo":298177000,
    "descripcion":"INFLAMACIÓN DE ARTICULACIÓN DE COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":70636008,
    "descripcion":"HERNIA INTERSTICIAL"
  },
  {
    "codigo":398316009,
    "descripcion":"URACO PERMEABLE"
  },
  {
    "codigo":37868008,
    "descripcion":"TRASTORNO DE ANSIEDAD EN LA ADOLESCENCIA"
  },
  {
    "codigo":789697006,
    "descripcion":"GASTRITIS POR MASTOCITOS"
  },
  {
    "codigo":296342002,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE PROPRANOLOL"
  },
  {
    "codigo":230806005,
    "descripcion":"INFECCIÓN DE LA DERIVACIÓN VENTRICULAR CEREBRAL"
  },
  {
    "codigo":66966006,
    "descripcion":"LLANTO DEL SÍNDROME DE DOWN"
  },
  {
    "codigo":294507000,
    "descripcion":"ALERGIA A CICLACILINA"
  },
  {
    "codigo":292672002,
    "descripcion":"EFECTO ADVERSO DE ALCALOIDE DE COLCHICINA"
  },
  {
    "codigo":3991000175109,
    "descripcion":"ENCUENTRO FALLIDO - SE DEJÓ MENSAJE CON PERSONA"
  },
  {
    "codigo":106001000119101,
    "descripcion":"ENFERMEDAD PULMONAR OBSTRUCTIVA CRÓNICA CON BRONQUITIS AGUDA"
  },
  {
    "codigo":94229004,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE BRONQUIO DEL LÓBULO SUPERIOR IZQUIERDO DEL PULMÓN"
  },
  {
    "codigo":290837007,
    "descripcion":"INTOXICACIÓN POR IPRINDOL"
  },
  {
    "codigo":1208341008,
    "descripcion":"SÍNDROME OCULORRENOCEREBELOSO GRAVE"
  },
  {
    "codigo":126997008,
    "descripcion":"NEOPLASIA DE LOS NERVIOS PERIFÉRICOS DE LA CÓRNEA"
  },
  {
    "codigo":289002003,
    "descripcion":"SE ALIMENTA"
  },
  {
    "codigo":125162004,
    "descripcion":"INADECUADO PARA EVALUACIÓN POR ARTIFICIO DE SECADO"
  },
  {
    "codigo":92394004,
    "descripcion":"NEOPLASIA BENIGNA DE PARTES BLANDAS DE MIEMBRO INFERIOR"
  },
  {
    "codigo":254399000,
    "descripcion":"CARCINOMA IN SITU DEL FRENILLO LABIAL SUPERIOR"
  },
  {
    "codigo":15670801000119104,
    "descripcion":"LUXACIÓN CONGÉNITA DE RODILLA IZQUIERDA"
  },
  {
    "codigo":188863004,
    "descripcion":"NEOPLASIA BENIGNA DE EPIPLÓN"
  },
  {
    "codigo":57791006,
    "descripcion":"AGEUSIA PARCIAL"
  },
  {
    "codigo":1237439009,
    "descripcion":"LACERACIÓN DE MÚSCULO"
  },
  {
    "codigo":351761000119106,
    "descripcion":"NEVO MELANOCÍTICO DE MIEMBRO INFERIOR IZQUIERDO"
  },
  {
    "codigo":283497000,
    "descripcion":"HERIDA PUNZANTE DE PIEL"
  },
  {
    "codigo":55956009,
    "descripcion":"TRASTORNO EN EL CONTENIDO DEL PENSAMIENTO"
  },
  {
    "codigo":248894002,
    "descripcion":"HALLAZGO RELACIONADO CON EL CONTENIDO DE LA VAGINA"
  },
  {
    "codigo":412734009,
    "descripcion":"MUTACIÓN DEL GEN BRCA1 POSITIVA"
  },
  {
    "codigo":1197331005,
    "descripcion":"ADENOCARCINOMA METASTÁSICO DE GANGLIO LINFÁTICO PÉLVICO"
  },
  {
    "codigo":247059006,
    "descripcion":"HIPERREFRINGENCIA NUCLEAR DEL CRISTALINO"
  },
  {
    "codigo":41171000087107,
    "descripcion":"QUEMADURA DE OJO DERECHO PROPIAMENTE DICHO"
  },
  {
    "codigo":43731000087108,
    "descripcion":"TRASTORNO DE TENDÓN DE EXTREMIDAD INFERIOR IZQUIERDA"
  },
  {
    "codigo":46291000087109,
    "descripcion":"FRACTURA DE EXTREMO PROXIMAL DE CÚBITO IZQUIERDO"
  },
  {
    "codigo":212456008,
    "descripcion":"LESIÓN MUSCULAR Y TENDINOSA A NIVEL DORSAL"
  },
  {
    "codigo":1162728008,
    "descripcion":"OBSTRUCCIÓN INTESTINAL POR ESTENOSIS INTESTINAL"
  },
  {
    "codigo":15848008,
    "descripcion":"TRASTORNO NO INFLAMATORIO DEL LIGAMENTO ANCHO"
  },
  {
    "codigo":46781003,
    "descripcion":"PROBLEMA BÁSICO PARA EL APRENDIZAJE DE LA ESCRITURA"
  },
  {
    "codigo":472765003,
    "descripcion":"TROMBO DE AURÍCULA DERECHA FISIOLÓGICA COMO COMPLICACIÓN DE PROCEDIMIENTO"
  },
  {
    "codigo":210621005,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE PUNTA DE PULGAR, TIPO 4"
  },
  {
    "codigo":767677003,
    "descripcion":"HERNIA INGUINAL DERECHA IRREDUCTIBLE RECURRENTE"
  },
  {
    "codigo":1259197000,
    "descripcion":"CRISIS EPILÉPTICA MIOCLÓNICA DE INICIO FOCAL"
  },
  {
    "codigo":308925008,
    "descripcion":"SÍNTOMA DIGESTIVO"
  },
  {
    "codigo":77714001,
    "descripcion":"PUNTAJE DE APGAR 0"
  },
  {
    "codigo":208786001,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN DE CODO, POSTERIOR"
  },
  {
    "codigo":11849541000119103,
    "descripcion":"ABRASIÓN DE PIEL DE REGIÓN CLAVICULAR DERECHA"
  },
  {
    "codigo":12178007,
    "descripcion":"PROTEINURIA NEFRÓGENA"
  },
  {
    "codigo":700306008,
    "descripcion":"LAGOFTALMOS CICATRIZAL DE PÁRPADO INFERIOR"
  },
  {
    "codigo":403559003,
    "descripcion":"LESIÓN CUTÁNEA POR MIELODISRAFIA"
  },
  {
    "codigo":75879005,
    "descripcion":"MIGRAÑA ABDOMINAL"
  },
  {
    "codigo":239719006,
    "descripcion":"DAÑO CAPSULAR, DE LIGAMENTO LATERAL Y CRUZADO ANTIGUO DE RODILLA"
  },
  {
    "codigo":74044000,
    "descripcion":"INFECCIÓN CAUSADA POR POMPHORHYNCHUS"
  },
  {
    "codigo":11986911000119100,
    "descripcion":"QUEMADURA EPIDÉRMICA DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":237884007,
    "descripcion":"HIPOCALCEMIA FARMACÓGENA"
  },
  {
    "codigo":1055249003,
    "descripcion":"AGENESIA DE EPÍFISIS DE FALANGE DISTAL DE DEDO ANULAR"
  },
  {
    "codigo":236049004,
    "descripcion":"HERNIA PARACOLOSTOMÍA"
  },
  {
    "codigo":399889006,
    "descripcion":"LINFEDEMA HEREDITARIO TIPO I"
  },
  {
    "codigo":398054001,
    "descripcion":"CRITERIOS DE MUERTE DEL TRONCO ENCEFÁLICO CUMPLIDOS LUEGO DEL SEGUNDO EXAMEN"
  },
  {
    "codigo":234214002,
    "descripcion":"TRASTORNO DE GENERADOR DE PULSO DE MARCAPASOS"
  },
  {
    "codigo":301585009,
    "descripcion":"NO SE MANEJA EN ESCALONES Y ESCALERAS"
  },
  {
    "codigo":299750005,
    "descripcion":"REFLEJO DE CHUPETEO PRESENTE"
  },
  {
    "codigo":266982005,
    "descripcion":"CONCURRE A GUARDERÍA INFANTIL"
  },
  {
    "codigo":37606007,
    "descripcion":"DESNUDEZ DE LOS PADRES"
  },
  {
    "codigo":365286008,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA REMOVER EL TAPÓN DE RESIDUOS"
  },
  {
    "codigo":430822009,
    "descripcion":"REACCIÓN LEUCEMOIDE BASOFÍLICA"
  },
  {
    "codigo":232379004,
    "descripcion":"TRASTORNO NASAL EXTERNO"
  },
  {
    "codigo":68539005,
    "descripcion":"MALFORMACIÓN PREINTESTINAL BRONCOPULMONAR CONGÉNITA"
  },
  {
    "codigo":363451005,
    "descripcion":"NEOPLASIA MALIGNA DE GLANDE DE PENE"
  },
  {
    "codigo":723899008,
    "descripcion":"TRASTORNO DELIRANTE ACTUALMENTE SINTOMÁTICO"
  },
  {
    "codigo":428987008,
    "descripcion":"IMPLANTE ANTICONCEPTIVO SUBCUTÁNEO PRESENTE"
  },
  {
    "codigo":1091551000119105,
    "descripcion":"HIPERACUSIA DE OÍDO DERECHO"
  },
  {
    "codigo":722064003,
    "descripcion":"ODONTOLEUCODISTROFIA"
  },
  {
    "codigo":1344656004,
    "descripcion":"RESILIENCIA DIGITAL"
  },
  {
    "codigo":10676191000119106,
    "descripcion":"ASMA PERSISTENTE LEVE NO CONTROLADA"
  },
  {
    "codigo":66704002,
    "descripcion":"PERICARDITIS MENINGOCÓCICA"
  },
  {
    "codigo":1168007,
    "descripcion":"ALOTIPO"
  },
  {
    "codigo":294245000,
    "descripcion":"ALERGIA A MIFEPRISTONA"
  },
  {
    "codigo":458085000,
    "descripcion":"PARÁPAGOS"
  },
  {
    "codigo":296080006,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE ALPRAZOLAM"
  },
  {
    "codigo":11796601000119101,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN DE DEDO MEDIO DERECHO"
  },
  {
    "codigo":785765007,
    "descripcion":"DEPENDIENTE PARA ADOPTAR LA POSICIÓN SEDENTE"
  },
  {
    "codigo":425317008,
    "descripcion":"SECRECIÓN CONJUNTIVAL"
  },
  {
    "codigo":15728761000119102,
    "descripcion":"TRASTORNO DE ARTICULACIÓN DE CODO IZQUIERDO"
  },
  {
    "codigo":93967000,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA REGIÓN POSCRICOIDEA"
  },
  {
    "codigo":292410009,
    "descripcion":"REACCIÓN ADVERSA A FÁRMACO ESTIMULANTE DE ACCIÓN CENTRAL"
  },
  {
    "codigo":95802009,
    "descripcion":"VITRITIS"
  },
  {
    "codigo":225039003,
    "descripcion":"MEZCLA EL PASADO CON EL PRESENTE"
  },
  {
    "codigo":61199005,
    "descripcion":"ALUCINACIÓN ELEMENTAL"
  },
  {
    "codigo":126735006,
    "descripcion":"NEOPLASIA DEL TEJIDO MESOTELIAL DEL PERICARDIO"
  },
  {
    "codigo":1306383008,
    "descripcion":"NEOPLASIA DE PORCIÓN CENTRAL DE MAMA"
  },
  {
    "codigo":288740001,
    "descripcion":"SE EXPRESA A SÍ MISMO"
  },
  {
    "codigo":92132009,
    "descripcion":"NEOPLASIA BENIGNA DEL CORAZÓN"
  },
  {
    "codigo":286905003,
    "descripcion":"NEOPLASIA BENIGNA DE TEJIDO CONJUNTIVO"
  },
  {
    "codigo":254137006,
    "descripcion":"DISPLASIA OCULODENTOÓSEA"
  },
  {
    "codigo":95112004,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL ÁNGULO ESPLÉNICO DEL COLON"
  },
  {
    "codigo":283235007,
    "descripcion":"VIDRIO EN NARIZ"
  },
  {
    "codigo":838456000,
    "descripcion":"INSUFICIENCIA SEVERA DE VÁLVULA TRICÚSPIDE"
  },
  {
    "codigo":248632004,
    "descripcion":"INTERRUPCIÓN REGULAR DEL PULSO"
  },
  {
    "codigo":707384006,
    "descripcion":"CARCINOMA SÓLIDO PRIMARIO DE TRÁQUEA"
  },
  {
    "codigo":711211000124107,
    "descripcion":"SINOVITIS CRÓNICA DE MUÑECA IZQUIERDA DEBIDA A HEMARTROSIS"
  },
  {
    "codigo":50189006,
    "descripcion":"DEFICIENCIA HEREDITARIA DE FACTOR XIII"
  },
  {
    "codigo":310498001,
    "descripcion":"MELANOMA MALIGNO DEL DORSO"
  },
  {
    "codigo":212194003,
    "descripcion":"LESIÓN DE LA MÉDULA ESPINAL EN MÚLTIPLES SITIOS SIN LESIÓN ÓSEA"
  },
  {
    "codigo":1162466007,
    "descripcion":"DEPREDACIÓN POSTMORTEM POR ANIMALES"
  },
  {
    "codigo":1258935001,
    "descripcion":"AUSENCIA CONGÉNITA COMPLETA DE MIEMBRO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":13751005,
    "descripcion":"ENVENENAMIENTO DEBIDO A MORDEDURA DEL LAGARTO MEXICANO"
  },
  {
    "codigo":110220002,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO DEL PALADAR DURO"
  },
  {
    "codigo":11916004,
    "descripcion":"INFECCIÓN CAUSADA POR DIPLODINIUM"
  },
  {
    "codigo":330311000119100,
    "descripcion":"MONOPLEJÍA DE MIEMBRO SUPERIOR DERECHO"
  },
  {
    "codigo":16058951000119100,
    "descripcion":"DEFECTO DE CAMPO VISUAL PERIFÉRICO DE OJO IZQUIERDO"
  },
  {
    "codigo":42849000,
    "descripcion":"CHANCRO TRIPANOSÓMICO"
  },
  {
    "codigo":370529001,
    "descripcion":"APÓFISIS CORONOIDES FRAGMENTADA"
  },
  {
    "codigo":403297002,
    "descripcion":"LEUCONIQUIA SECUNDARIA A ENFERMEDAD SISTÉMICA"
  },
  {
    "codigo":75617000,
    "descripcion":"ONFALÓPAGO"
  },
  {
    "codigo":863884008,
    "descripcion":"CON ELEVADO RIESGO DE ÚLCERA DE PIE DERECHO DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":763745005,
    "descripcion":"DISCAPACIDAD INTELECTUAL TIPO WOLFF"
  },
  {
    "codigo":1255265004,
    "descripcion":"ESTENOSIS DE SEGMENTO PROXIMAL DE RAMA DESCENDENTE ANTERIOR DE ARTERIA CORONARIA IZQUIERDA"
  },
  {
    "codigo":1288033004,
    "descripcion":"TUMOR NEUROENDOCRINO BIEN DIFERENCIADO DE COLON SIGMOIDE"
  },
  {
    "codigo":237622006,
    "descripcion":"ESCASO CONTROL DE LA GLUCEMIA"
  },
  {
    "codigo":301323003,
    "descripcion":"PLIEGUES PALMARES - HALLAZGO"
  },
  {
    "codigo":203019005,
    "descripcion":"ABSCESO MUSCULAR"
  },
  {
    "codigo":39179006,
    "descripcion":"TRASTORNO DE DIFERENCIACIÓN SEXUAL"
  },
  {
    "codigo":235787008,
    "descripcion":"FÍSTULA PROSTÁTICA HACIA EL INTESTINO DELGADO"
  },
  {
    "codigo":792843009,
    "descripcion":"GANGRENA DE MIEMBRO DEBIDA A ATEROSCLEROSIS DE ARTERIA DE EXTREMIDAD"
  },
  {
    "codigo":168416001,
    "descripcion":"EXTENDIDO CERVICAL: INFLAMACIÓN GRAVE"
  },
  {
    "codigo":365024004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA RESPIRAR"
  },
  {
    "codigo":397792005,
    "descripcion":"RESISTENCIA INESPERADA AL BLOQUEO NEUROMUSCULAR"
  },
  {
    "codigo":70112005,
    "descripcion":"MORTINATO DE SEXO FEMENINO (2500 GRAMOS O MÁS)"
  },
  {
    "codigo":299488008,
    "descripcion":"AMPLITUD DE MOVIMIENTO ACTIVO DE PRONACIÓN MEDIOTARSIANA NORMAL"
  },
  {
    "codigo":37344009,
    "descripcion":"PATRÓN DE USO NOCIVO DE CANNABIS"
  },
  {
    "codigo":232117003,
    "descripcion":"PARÁLISIS DISOCIADA VERTICAL DE LA MIRADA"
  },
  {
    "codigo":230282000,
    "descripcion":"DEMENCIA POSTRAUMÁTICA"
  },
  {
    "codigo":10953441000119102,
    "descripcion":"HERIDA ABIERTA DE DEDO ÍNDICE DERECHO DEBIDA A MORDEDURA DE GATO"
  },
  {
    "codigo":295818001,
    "descripcion":"SOBREDOSIS DE AMANTADINA"
  },
  {
    "codigo":721802003,
    "descripcion":"INFECCIÓN CAUSADA POR PSEUDALLESCHERIA"
  },
  {
    "codigo":263050003,
    "descripcion":"SUBLUXACIÓN DE ARTICULACIÓN ESCAPULOTORÁCICA"
  },
  {
    "codigo":31839002,
    "descripcion":"MIASTENIA GRAVIS, FORMA ADULTA"
  },
  {
    "codigo":293983003,
    "descripcion":"ALERGIA A SOTALOL"
  },
  {
    "codigo":228447005,
    "descripcion":"ACTIVO FÍSICAMENTE"
  },
  {
    "codigo":425055008,
    "descripcion":"HERIDA DE ENTRADA DE DISPARO DE ARMA DE FUEGO"
  },
  {
    "codigo":193844000,
    "descripcion":"QUERATOCONO, ESTABLE"
  },
  {
    "codigo":95540002,
    "descripcion":"HEMORRAGIA DE COLON"
  },
  {
    "codigo":292148008,
    "descripcion":"REACCIÓN ADVERSA AL ACEITE DE MENTA"
  },
  {
    "codigo":60937000,
    "descripcion":"DEGENERACIÓN DE DISCO INTERVERTEBRAL LUMBOSACRO"
  },
  {
    "codigo":290313003,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR TOLMETINA"
  },
  {
    "codigo":93705004,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE VASO SANGUÍNEO PÉLVICO"
  },
  {
    "codigo":124638000,
    "descripcion":"DEFICIENCIA DE CARBOXI - LIASA"
  },
  {
    "codigo":91870007,
    "descripcion":"AUSENCIA CONGÉNITA DE HUESO BASIOCCIPITAL"
  },
  {
    "codigo":253875000,
    "descripcion":"DIVERTÍCULO CALICIAL CONGÉNITO"
  },
  {
    "codigo":188339002,
    "descripcion":"NEOPLASIA MALIGNA DE GLÁNDULA HIPÓFISIS Y DE CONDUCTO CRANEOFARÍNGEO"
  },
  {
    "codigo":18541000119100,
    "descripcion":"RETRASO DEL DESARROLLO COGNITIVO LIMÍTROFE"
  },
  {
    "codigo":12206701000119100,
    "descripcion":"LUXACIÓN DE PRÓTESIS DE ARTICULACIÓN DE CADERA DERECHA"
  },
  {
    "codigo":82541000119100,
    "descripcion":"DESPRENDIMIENTO DE RETINA POR TRACCIÓN DEBIDO A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":310381000119102,
    "descripcion":"SÍNDROME DE FRICCIÓN DE LA BANDELETA ILIOTIBIAL DE REGIÓN DE RODILLA IZQUIERDA"
  },
  {
    "codigo":1204147007,
    "descripcion":"ESTENOSIS DE ARTERIA CEREBRAL MEDIA ASINTOMÁTICA"
  },
  {
    "codigo":21101000119105,
    "descripcion":"DISFAGIA FARINGEA"
  },
  {
    "codigo":128621000119106,
    "descripcion":"ENFERMEDAD DE INJERTO VERSUS HUÉSPED REAGUDIZADA DESPUÉS DE TRASPLANTE DE RIÑÓN"
  },
  {
    "codigo":62061000119107,
    "descripcion":"LESIÓN ESCAMOSA INTRAEPITELIAL DE ALTO GRADO EN EL EXTENDIDO DE PAPANICOLAOU"
  },
  {
    "codigo":353901000119107,
    "descripcion":"CARCINOMA IN SITU DE PIEL DE MIEMBRO INFERIOR IZQUIERDO"
  },
  {
    "codigo":1086061000119109,
    "descripcion":"RADICULOMIELITIS DIFTÉRICA"
  },
  {
    "codigo":1091181000119108,
    "descripcion":"OTITIS MEDIA SUPURATIVA CRÓNICA DEL OÍDO MEDIO DERECHO"
  },
  {
    "codigo":333421000119108,
    "descripcion":"MIOSITIS DE ÓRBITA DERECHA"
  },
  {
    "codigo":219272003,
    "descripcion":"LESIÓN POR INTERVENCIÓN LEGAL CON ASFIXIA POR GAS"
  },
  {
    "codigo":10847341000119108,
    "descripcion":"HERIDA ABIERTA DE PIE IZQUIERDO DEBIDA A MORDEDURA DE ANIMAL"
  },
  {
    "codigo":302701000119105,
    "descripcion":"SÍNDROME DE COMPRESIÓN DE ARTERIA RAQUÍDEA ANTERIOR DE MÉDULA ESPINAL TORÁCICA"
  },
  {
    "codigo":341101000119109,
    "descripcion":"DACRIOPS DE APARATO LAGRIMAL DE OJO IZQUIERDO"
  },
  {
    "codigo":1075821000119108,
    "descripcion":"TENDINITIS CALCIFICANTE DEL TENDÓN DE AQUILES DERECHO"
  },
  {
    "codigo":1080941000119109,
    "descripcion":"MELANOMA MALIGNO DE COROIDES IZQUIERDA"
  },
  {
    "codigo":282973006,
    "descripcion":"NO SE PARA"
  },
  {
    "codigo":86365006,
    "descripcion":"POIQUILODERMATOMIOSITIS"
  },
  {
    "codigo":444978000,
    "descripcion":"MENINGOCELE DE VÉRTICE"
  },
  {
    "codigo":53597009,
    "descripcion":"DERMATITIS FOTOTÓXICA"
  },
  {
    "codigo":741725004,
    "descripcion":"ESCOLARIDAD PRIMARIA INICIADA PERO INCOMPLETA"
  },
  {
    "codigo":1003869005,
    "descripcion":"DUPLICACIÓN DE PORCIÓN PROXIMAL DEL BRAZO LARGO DEL CROMOSOMA 2"
  },
  {
    "codigo":1264178004,
    "descripcion":"PIERCING EN TERCIO IZQUIERDO DE LABIO INFERIOR"
  },
  {
    "codigo":332821000119104,
    "descripcion":"EXOFTALMÍA PULSÁTIL DE OJO DERECHO"
  },
  {
    "codigo":246535004,
    "descripcion":"CRISIS DISFÁSICA"
  },
  {
    "codigo":443143006,
    "descripcion":"DEPENDENCIA DE HEMODIÁLISIS"
  },
  {
    "codigo":80860003,
    "descripcion":"MENOFANIA"
  },
  {
    "codigo":408540003,
    "descripcion":"DIABETES MELLITUS CAUSADA POR FÁRMACOS NO ESTEROIDES"
  },
  {
    "codigo":1293276009,
    "descripcion":"DERRAME ARTICULAR DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":373937002,
    "descripcion":"OSIFICACIÓN INCOMPLETA DE HUESO ILÍACO"
  },
  {
    "codigo":111793002,
    "descripcion":"INTOXICACIÓN POR TRIFOLIUM PRATENSE"
  },
  {
    "codigo":10628271000119102,
    "descripcion":"PARONIQUIA DE DEDO DE PIE DERECHO"
  },
  {
    "codigo":11654001,
    "descripcion":"TENDINITIS DE AQUILES"
  },
  {
    "codigo":699782001,
    "descripcion":"CARA MESOCEFÁLICA"
  },
  {
    "codigo":898225009,
    "descripcion":"FUSIÓN ANORMAL CONGÉNITA DE QUINTO HUESO METACARPIANO"
  },
  {
    "codigo":44422006,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE LA CARA, CON INFECCIÓN"
  },
  {
    "codigo":109958007,
    "descripcion":"NEOPLASIA HEMATOLÓGICA DE COMPORTAMIENTO INCIERTO"
  },
  {
    "codigo":403035001,
    "descripcion":"TIÑA CORPORAL CAUSADA POR TRICHOPHYTON MENTAGROPHYTES VARIANTE ERINACEI"
  },
  {
    "codigo":271963003,
    "descripcion":"FRACTURA DE ALA ILÍACA"
  },
  {
    "codigo":1156699004,
    "descripcion":"CUMPLE CON FARMACOTERAPIA"
  },
  {
    "codigo":12102831000119104,
    "descripcion":"QUEMADURA DE PULGAR IZQUIERDO"
  },
  {
    "codigo":75355004,
    "descripcion":"ATRESIA DE CONDUCTO AUDITIVO EXTERNO"
  },
  {
    "codigo":239195009,
    "descripcion":"TRASTORNO DE COLGAJO"
  },
  {
    "codigo":401200002,
    "descripcion":"CON MAYOR RIESGO DE ENFERMEDAD PULMONAR OBSTRUCTIVA CRÓNICA"
  },
  {
    "codigo":40752005,
    "descripcion":"ÚLCERA DEL TABIQUE NASAL"
  },
  {
    "codigo":1187632006,
    "descripcion":"PAPILOMATOSIS BILIAR"
  },
  {
    "codigo":302896008,
    "descripcion":"QUERATOCONJUNTIVITIS SICCA"
  },
  {
    "codigo":301061006,
    "descripcion":"ESTENOSIS DE CONDUCTO AUDITIVO EXTERNO"
  },
  {
    "codigo":15926601000119102,
    "descripcion":"EROSIÓN DE ÓVULO VAGINAL EN PARED VAGINAL"
  },
  {
    "codigo":202757008,
    "descripcion":"DISCOPATÍA CERVICAL CON RADICULOPATÍA"
  },
  {
    "codigo":6149008,
    "descripcion":"AMNESIA PARA LOS EVENTOS REMOTOS"
  },
  {
    "codigo":69850007,
    "descripcion":"COLANGITIS SUPURATIVA"
  },
  {
    "codigo":1149359000,
    "descripcion":"RESONANCIA TORÁCICA A LA PERCUSIÓN ALTERADA"
  },
  {
    "codigo":299226007,
    "descripcion":"HALLAZGO RELACIONADO CON MEDICIONES DE LA EXTREMIDAD INFERIOR"
  },
  {
    "codigo":102618009,
    "descripcion":"SEQUEDAD FARÍNGEA"
  },
  {
    "codigo":200922008,
    "descripcion":"ERITEMA TUBERCULOSO"
  },
  {
    "codigo":233690008,
    "descripcion":"ASMA FICTICIA"
  },
  {
    "codigo":788911004,
    "descripcion":"TRASTORNO DISOCIATIVO CON SÍNTOMA NEUROLÓGICO CONCOMITANTE CON PARKINSONISMO"
  },
  {
    "codigo":35247001,
    "descripcion":"COLESTEATOMA DE OÍDO EXTERNO"
  },
  {
    "codigo":231855007,
    "descripcion":"CONJUNTIVITIS ALÉRGICA ESTACIONAL"
  },
  {
    "codigo":361092000,
    "descripcion":"DEFICIENCIA DE HIDROLASA ÉSTER SULFÚRICA"
  },
  {
    "codigo":16909641000119104,
    "descripcion":"DISFUNCIÓN DE GLÁNDULA DE MEIBOMIO DE PÁRPADO INFERIOR IZQUIERDO"
  },
  {
    "codigo":230020002,
    "descripcion":"POSICIÓN DE TRONCO: INCLINACIÓN LATERAL"
  },
  {
    "codigo":262788003,
    "descripcion":"LESIÓN DE CONDUCTO TORÁCICO"
  },
  {
    "codigo":721540005,
    "descripcion":"CARCINOMA PRIMARIO DE ANEXO CUTÁNEO"
  },
  {
    "codigo":426628005,
    "descripcion":"COLPODINIA CRÓNICA"
  },
  {
    "codigo":295556005,
    "descripcion":"SOBREDOSIS INTENCIONAL DE CINCOCAÍNA"
  },
  {
    "codigo":129881001,
    "descripcion":"DESARROLLO DE LA CONDUCTA ORGANIZADA DEL NIÑO"
  },
  {
    "codigo":689481000119107,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE BORDE BERMELLÓN DE LABIO INFERIOR"
  },
  {
    "codigo":31577002,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DE PALMA DE LA MANO"
  },
  {
    "codigo":293721007,
    "descripcion":"ALERGIA A PRILOCAÍNA"
  },
  {
    "codigo":422958000,
    "descripcion":"INCAPAZ DE COORDINAR MÚLTIPLES CITACIONES"
  },
  {
    "codigo":16227811000119102,
    "descripcion":"PRURITO DE AMBOS OJOS"
  },
  {
    "codigo":62510002,
    "descripcion":"INFECCIÓN CAUSADA POR PAECILOMYCES VARIOTII"
  },
  {
    "codigo":11830601000119109,
    "descripcion":"LACERACIÓN DE ARCO PALMAR SUPERFICIAL IZQUIERDO"
  },
  {
    "codigo":160814006,
    "descripcion":"CASO JUDICIAL PENDIENTE"
  },
  {
    "codigo":128046007,
    "descripcion":"TRASTORNO DE LA MUCOSA ORAL"
  },
  {
    "codigo":93443000,
    "descripcion":"CENTRO CARTILAGINOSO DE VÉRTEBRA SACRA CON FORMA DE MANCUERNA"
  },
  {
    "codigo":879875001,
    "descripcion":"DERMATITIS IRRITATIVA POR CONTACTO CAUSADA POR ORINA"
  },
  {
    "codigo":335331000119104,
    "descripcion":"SÍNDROME DE DUANE DE OJO DERECHO"
  },
  {
    "codigo":224515008,
    "descripcion":"CUIDADOR CON MEDIO DE TRANSPORTE PROPIO"
  },
  {
    "codigo":124376002,
    "descripcion":"DEFICIENCIA DE TRANSFORMIMINASA"
  },
  {
    "codigo":58840004,
    "descripcion":"RUIDOS RESPIRATORIOS DISMINUIDOS"
  },
  {
    "codigo":288216005,
    "descripcion":"RUPTURA DE TENDÓN - HOMBRO"
  },
  {
    "codigo":26072008,
    "descripcion":"REACCIÓN AUTOINMUNITARIA DESPUÉS DE ENFERMEDAD INFECCIOSA"
  },
  {
    "codigo":1304024009,
    "descripcion":"DEFORMIDAD CONGÉNITA DE HÉLICE DE OREJA"
  },
  {
    "codigo":10821091000119107,
    "descripcion":"FRACTURA EXPUESTA DEL PERONÉ DERECHO"
  },
  {
    "codigo":57005003,
    "descripcion":"INTOXICACIÓN CAUSADA POR CAFEÍNA"
  },
  {
    "codigo":286381004,
    "descripcion":"INCAPAZ DE ENCONTRAR LAS PALABRAS"
  },
  {
    "codigo":11804131000119107,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA DISTAL DE DEDO DE LA MANO DERECHA"
  },
  {
    "codigo":188077000,
    "descripcion":"MELANOMA MALIGNO DE DEDO GORDO"
  },
  {
    "codigo":448386004,
    "descripcion":"LINFOMA NO HODGKIN DE CAVIDAD BUCAL"
  },
  {
    "codigo":249943000,
    "descripcion":"DEBILIDAD DE LA REGIÓN DISTAL DE BRAZOS Y PIERNAS"
  },
  {
    "codigo":315479000,
    "descripcion":"NACIDO EN MÉXICO"
  },
  {
    "codigo":15955581000119104,
    "descripcion":"NEOPLASIA GERMINAL NO SEMINOMATOSA PRIMARIA DE AMBOS TESTÍCULOS DESCENDIDOS"
  },
  {
    "codigo":446551005,
    "descripcion":"CAPAZ DE LOGRAR UNA ERECCIÓN CUANDO ESTÁ SOLO"
  },
  {
    "codigo":86103006,
    "descripcion":"ESTRÍAS ANGIOIDES DE LA COROIDES"
  },
  {
    "codigo":282711009,
    "descripcion":"EMPUJA Y TIRA HACIA ADELANTE UN JUGUETE PEQUEÑO CON RUEDAS"
  },
  {
    "codigo":1231148002,
    "descripcion":"SÍNDROME DE NEVO EPIDÉRMICO VERRUGOSO LINEAL"
  },
  {
    "codigo":870700005,
    "descripcion":"RANGO DE FRECUENCIA CARDÍACA FETAL BASAL DE 160 A 180"
  },
  {
    "codigo":51500006,
    "descripcion":"SÍNDROME DE TRISOMÍA 18 COMPLETA"
  },
  {
    "codigo":1296684007,
    "descripcion":"ASIMETRÍA DE MAMA EN ADOLESCENCIA"
  },
  {
    "codigo":311809001,
    "descripcion":"DIFICULTADES SOCIOLINGÜÍSTICAS"
  },
  {
    "codigo":705025004,
    "descripcion":"CONSENTIMIENTO PARA COMUNICACIÓN POR CORREO ELECTRÓNICO OTORGADO"
  },
  {
    "codigo":770561007,
    "descripcion":"SÍNDROME DE MALFORMACIÓN DE EXTREMIDAD INFERIOR E HIPOSPADIAS"
  },
  {
    "codigo":279041008,
    "descripcion":"SÍNDROME DE DOLOR MIOFASCIAL DE REGIÓN LUMBAR"
  },
  {
    "codigo":703190002,
    "descripcion":"ENDOCARDITIS DE PRÓTESIS DE VÁLVULA TRICÚSPIDE"
  },
  {
    "codigo":441046006,
    "descripcion":"VIRUS RESISTENTE A OSELTAMIVIR PRESENTE"
  },
  {
    "codigo":735958007,
    "descripcion":"EXANTEMA CAUSADO POR CHLAMYDOPHILA PSITTACI"
  },
  {
    "codigo":80598009,
    "descripcion":"TRASTORNO DE LA FUNCIÓN ARTICULAR"
  },
  {
    "codigo":275371002,
    "descripcion":"VÓMITO NEGRO"
  },
  {
    "codigo":1293014009,
    "descripcion":"ANGIOFIBROMA CELULAR"
  },
  {
    "codigo":111531004,
    "descripcion":"ESTRABISMO MECÁNICO CAUSADO POR UN TRASTORNO MUSCULOFACIAL"
  },
  {
    "codigo":1356715004,
    "descripcion":"LESIÓN TRAUMÁTICA DE VASO SANGUÍNEO DIGITAL DE DEDO DE PIE"
  },
  {
    "codigo":47830009,
    "descripcion":"LATIDOS ESCAPADOS DE LA UNIÓN AURICULOVENTRICULAR"
  },
  {
    "codigo":240768002,
    "descripcion":"CROMOBLASTOMICOSIS LINFOCUTÁNEA"
  },
  {
    "codigo":208000003,
    "descripcion":"FRACTURA VERTEBRAL NO EXPUESTA CON LESIÓN COMPLETA DE MÉDULA ESPINAL CERVICAL, C1-4"
  },
  {
    "codigo":16011031000119106,
    "descripcion":"ARTRITIS REACTIVA DE ARTICULACIÓN DE AMBOS PIES"
  },
  {
    "codigo":109696006,
    "descripcion":"OSTEOMIELITIS MANDIBULAR AGUDA"
  },
  {
    "codigo":9557000,
    "descripcion":"CELULITIS DE LA CADERA"
  },
  {
    "codigo":699520009,
    "descripcion":"CATARATA ZONULAR NO SENIL"
  },
  {
    "codigo":402773000,
    "descripcion":"QUERATODERMIA PUNCTATA PALMOPLANTAR"
  },
  {
    "codigo":271701005,
    "descripcion":"POSTURA HEMIPLÉJICA"
  },
  {
    "codigo":11833111000119108,
    "descripcion":"ESGUINCE DE LIGAMENTO DE ARTICULACIÓN METATARSOFALÁNGICA DE DEDO GORDO DE PIE DERECHO"
  },
  {
    "codigo":400938000,
    "descripcion":"ESOTROPÍA SENSORIAL POR DEPRIVACIÓN"
  },
  {
    "codigo":238933009,
    "descripcion":"LIQUEN ESCLEROSO EXTRAGENITAL"
  },
  {
    "codigo":1285674001,
    "descripcion":"DISTENSIÓN DE TENDÓN DE ANTEBRAZO"
  },
  {
    "codigo":237098003,
    "descripcion":"ÚLCERA DE VAGINA POSTERIOR A RADIOTERAPIA"
  },
  {
    "codigo":7722005,
    "descripcion":"TORACÓPAGO EPIGÁSTRICO"
  },
  {
    "codigo":1351210007,
    "descripcion":"INMUNODEFICIENCIA COMBINADA SEVERA T NEGATIVA B POSITIVA AUTOSÓMICA RECESIVA DEBIDA A MUTACIÓN DE SUBUNIDAD ÉPSILON DE COMPLEJO CD3 RECEPTOR DE LINFOCITOS T"
  },
  {
    "codigo":38655000,
    "descripcion":"INFECCIÓN CAUSADA POR PHIALOPHORA VERRUCOSA"
  },
  {
    "codigo":204330009,
    "descripcion":"DEFECTO DE TABIQUE VENTRICULAR, TIPO CANAL AURICULOVENTRICULAR COMÚN"
  },
  {
    "codigo":300799003,
    "descripcion":"INCAPAZ DE PARTICIPAR EN ACTIVIDADES DEPORTIVAS"
  },
  {
    "codigo":202495004,
    "descripcion":"DOLOR DE LA PRIMERA ARTICULACIÓN METATARSOFALÁNGICA"
  },
  {
    "codigo":366335008,
    "descripcion":"HALLAZGO RELACIONADO CON LA CONSISTENCIA DEL LÍQUIDO AMNIÓTICO"
  },
  {
    "codigo":266196000,
    "descripcion":"RABIA - HIDROFOBIA"
  },
  {
    "codigo":200660001,
    "descripcion":"CELULITIS Y ABSCESO DE OMBLIGO"
  },
  {
    "codigo":69588003,
    "descripcion":"ERITEMA MIGRATORIO CRÓNICO"
  },
  {
    "codigo":167892007,
    "descripcion":"LÍQUIDO SINOVIAL: AUSENCIA DE COÁGULO DE FIBRINA"
  },
  {
    "codigo":337841000119107,
    "descripcion":"ESCLEROMALACIA PERFORANTE DE OJO IZQUIERDO"
  },
  {
    "codigo":460969005,
    "descripcion":"ORIGEN ANÓMALO DE LIGAMENTO ARTERIOSO DERECHO EN CAYADO AÓRTICO IZQUIERDO"
  },
  {
    "codigo":723113005,
    "descripcion":"TEMOR A ENFERMEDAD METABÓLICA"
  },
  {
    "codigo":262526004,
    "descripcion":"HERIDA DE PIEL"
  },
  {
    "codigo":721278008,
    "descripcion":"SEPSIS NEONATAL CAUSADA POR MALASSEZIA"
  },
  {
    "codigo":1145427001,
    "descripcion":"HIPOPLASIA CONGÉNITA DE HUESO CRANEAL"
  },
  {
    "codigo":382009,
    "descripcion":"HALLAZGO RELACIONADO CON ANTECEDENTE LEGAL DE NIÑO"
  },
  {
    "codigo":293459003,
    "descripcion":"REACCIÓN ADVERSA A LA HIDROFLUMETIAZIDA"
  },
  {
    "codigo":195155004,
    "descripcion":"HEMORRAGIA SUBARACNOIDEA DE SIFÓN Y BIFURCACIÓN CAROTÍDEOS"
  },
  {
    "codigo":291624000,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR CEFTIBUTENO"
  },
  {
    "codigo":160552003,
    "descripcion":"SIN RELIGIÓN"
  },
  {
    "codigo":95016003,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL ANTRO PILÓRICO"
  },
  {
    "codigo":226088006,
    "descripcion":"DIETA DE AMINOÁCIDOS ESENCIALES MODIFICADOS"
  },
  {
    "codigo":289789001,
    "descripcion":"CUELLO UTERINO ORIENTADO HACIA ADELANTE"
  },
  {
    "codigo":224253002,
    "descripcion":"HUMEDAD PENETRANTE EN EL HOGAR"
  },
  {
    "codigo":93181004,
    "descripcion":"MACROFTALMO"
  },
  {
    "codigo":1010685005,
    "descripcion":"ESPECTRO ÓCULO-AURÍCULO-VERTEBRAL"
  },
  {
    "codigo":191485005,
    "descripcion":"ESTADO PARANOIDE MEDICAMENTOSO"
  },
  {
    "codigo":1172690003,
    "descripcion":"TRASTORNO FETAL CAUSADO POR PROPILTIOURACILO"
  },
  {
    "codigo":255186004,
    "descripcion":"NEOPLASIA BENIGNA DE DERMIS"
  },
  {
    "codigo":15931621000119103,
    "descripcion":"QUISTE SEROSO DE OVARIO DERECHO"
  },
  {
    "codigo":419026008,
    "descripcion":"EFECTO DE LA EXPOSICIÓN A UNA FUERZA FÍSICA"
  },
  {
    "codigo":286119002,
    "descripcion":"LIMPIA LOS PISOS"
  },
  {
    "codigo":23975003,
    "descripcion":"VESICULITIS SEMINAL GONOCÓCICA CRÓNICA"
  },
  {
    "codigo":417191003,
    "descripcion":"ESCLEROSIS DE VÁLVULA MITRAL"
  },
  {
    "codigo":253351009,
    "descripcion":"AURÍCULA DERECHA GIGANTE"
  },
  {
    "codigo":284284007,
    "descripcion":"UTILIZA LA TIJERA (MOVIMIENTO DE LA MANO)"
  },
  {
    "codigo":54908008,
    "descripcion":"PULSO ARTERIAL CAROTÍDEO NORMAL"
  },
  {
    "codigo":446289001,
    "descripcion":"INFECCIÓN DE LECHO UNGUEAL DE DEDO DE LA MANO"
  },
  {
    "codigo":773969003,
    "descripcion":"BURSITIS DE CADERA IZQUIERDA"
  },
  {
    "codigo":1077631000119101,
    "descripcion":"OSTEOMIELITIS CRÓNICA DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":249681008,
    "descripcion":"DEFORMIDAD DE LA DIÁFISIS DE LA CLAVÍCULA"
  },
  {
    "codigo":20305008,
    "descripcion":"MIOTONÍA CONGÉNITA, FORMA AUTOSÓMICA RECESIVA"
  },
  {
    "codigo":282449009,
    "descripcion":"LESIÓN TRAUMÁTICA DE HUESOS NASALES"
  },
  {
    "codigo":1263654002,
    "descripcion":"METÁSTASIS DE CARCINOMA MUCOEPIDERMOIDE EN GLÁNDULA SALIVAL SUBMAXILAR"
  },
  {
    "codigo":247846004,
    "descripcion":"MIEDO A LOS FENÓMENOS NATURALES"
  },
  {
    "codigo":118609008,
    "descripcion":"ENFERMEDAD DE HODGKIN, CELULARIDAD MIXTA"
  },
  {
    "codigo":870438008,
    "descripcion":"CON PROBABILIDAD DE HALLAR COINCIDENCIA CON DONANTE NO EMPARENTADO"
  },
  {
    "codigo":16314751000119104,
    "descripcion":"ENFERMEDAD DE DUPUYTREN DE LA PALMA DE LA MANO IZQUIERDA"
  },
  {
    "codigo":14800001,
    "descripcion":"DERMATITIS VEGETANTE"
  },
  {
    "codigo":15987071000119106,
    "descripcion":"ANOMALÍA CONGÉNITA DE PUPILA IZQUIERDA"
  },
  {
    "codigo":1290917001,
    "descripcion":"TRASTORNO DE HÍGADO Y\/O VÍA BILIAR"
  },
  {
    "codigo":16779801000119101,
    "descripcion":"MASA DE ESPACIO PARAFARÍNGEO"
  },
  {
    "codigo":373413006,
    "descripcion":"SINDACTILIA"
  },
  {
    "codigo":82479641000119102,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN DE TEJIDO PROFUNDO DE CABEZA"
  },
  {
    "codigo":438949009,
    "descripcion":"VIVO"
  },
  {
    "codigo":109434003,
    "descripcion":"ANOMALÍA CONGÉNITA DE LA MUCOSA ORAL"
  },
  {
    "codigo":68121000119103,
    "descripcion":"PARÁLISIS FACIAL GRADO II DE HOUSE-BRACKMANN"
  },
  {
    "codigo":699258007,
    "descripcion":"NEUROPATÍA DEBIDA A DEFICIENCIA DE VITAMINA B12"
  },
  {
    "codigo":313881000119104,
    "descripcion":"ATROFIA MUSCULAR DE ANTEBRAZO DERECHO"
  },
  {
    "codigo":369743004,
    "descripcion":"MARGEN TUMORAL DELIMITADO"
  },
  {
    "codigo":304207004,
    "descripcion":"SIN AMPLITUD DE EXTENSIÓN HORIZONTAL ACTIVA DE HOMBRO"
  },
  {
    "codigo":238671003,
    "descripcion":"LIQUEN PLANO DE GLANDE DE PENE"
  },
  {
    "codigo":402511007,
    "descripcion":"CARCINOMA BASOCELULAR DE CONCHA DE PABELLÓN AURICULAR"
  },
  {
    "codigo":9295009,
    "descripcion":"SUBINVOLUCIÓN MAMARIA"
  },
  {
    "codigo":1252644006,
    "descripcion":"PAREJA DESATENTA"
  },
  {
    "codigo":300537000,
    "descripcion":"HALLAZGO RELACIONADO CON ESPERMATOZOIDES"
  },
  {
    "codigo":366073001,
    "descripcion":"FIJACIÓN OCULAR - HALLAZGO"
  },
  {
    "codigo":235001002,
    "descripcion":"PÓLIPO FIBROEPITELIAL GINGIVAL"
  },
  {
    "codigo":890361001,
    "descripcion":"POLIDACTILIA BILATERAL DE PULGAR TRIFALÁNGICO"
  },
  {
    "codigo":267769000,
    "descripcion":"ESTADIO SECUNDARIO DE LA FRAMBESIA"
  },
  {
    "codigo":169465000,
    "descripcion":"HIPERTENSIÓN CAUSADA POR PÍLDORA ANTICONCEPTIVA ORAL"
  },
  {
    "codigo":15714841000119108,
    "descripcion":"OSTEOFITOS DE AMBAS RODILLAS"
  },
  {
    "codigo":202233007,
    "descripcion":"INESTABILIDAD DEL CARPO CON INESTABILIDAD DEL SEGMENTO DORSAL INTERCALADO"
  },
  {
    "codigo":11864601000119108,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE PIE IZQUIERDO"
  },
  {
    "codigo":298702002,
    "descripcion":"PRUEBA DEL HUNDIMIENTO POSITIVA"
  },
  {
    "codigo":822990004,
    "descripcion":"NEVO MELANOCÍTICO RECURRENTE"
  },
  {
    "codigo":724686004,
    "descripcion":"TRASTORNO AMNÉSICO CAUSADO POR HIPNÓTICO"
  },
  {
    "codigo":11782681000119109,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN DE RODILLA DERECHA"
  },
  {
    "codigo":427939000,
    "descripcion":"NEOPLASIA BENIGNA DEL ESPACIO EXTRADURAL RAQUÍDEO"
  },
  {
    "codigo":148041000146104,
    "descripcion":"ENFERMEDAD POR DEPÓSITO DE CADENAS PESADAS"
  },
  {
    "codigo":34723002,
    "descripcion":"OTITIS EXTERNA DIFUSA"
  },
  {
    "codigo":1955003,
    "descripcion":"HOYUELO PREAURICULAR"
  },
  {
    "codigo":722851003,
    "descripcion":"DEFICIENCIA PRIMARIA DE LACTASA"
  },
  {
    "codigo":1343608003,
    "descripcion":"ERITROFOBIA"
  },
  {
    "codigo":31053003,
    "descripcion":"TRASTORNO DEL APARATO LAGRIMAL"
  },
  {
    "codigo":293197007,
    "descripcion":"REACCIÓN ADVERSA A LA GLIPIZIDA"
  },
  {
    "codigo":94754000,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE VEJIGA URINARIA"
  },
  {
    "codigo":225826001,
    "descripcion":"VÍCTIMA DE ABUSO SEXUAL"
  },
  {
    "codigo":1208866002,
    "descripcion":"SÍNDROME DE QT PROLONGADO TIPO 3"
  },
  {
    "codigo":92919000,
    "descripcion":"FORMA ANORMAL CONGÉNITA DE HUESO INTERPARIETAL"
  },
  {
    "codigo":782882009,
    "descripcion":"CONDRODISPLASIA CON LUXACIONES ARTICULARES TIPO GPAPP"
  },
  {
    "codigo":125687005,
    "descripcion":"CONTUSIÓN DE LOS ANEXOS OCULARES"
  },
  {
    "codigo":1010423007,
    "descripcion":"HIPERPLASIA DE APÓFISIS CORONOIDES IZQUIERDA DE MANDÍBULA"
  },
  {
    "codigo":10638311000119100,
    "descripcion":"ÚLCERA CRÓNICA DE MUSLO IZQUIERDO"
  },
  {
    "codigo":254924007,
    "descripcion":"NEOPLASIA DE CÁLIZ RENAL"
  },
  {
    "codigo":418764009,
    "descripcion":"FRACTURA DE HUESO CRANEAL"
  },
  {
    "codigo":416929004,
    "descripcion":"SACRO POSTERIOR"
  },
  {
    "codigo":23713006,
    "descripcion":"CONTUSIÓN DE LA CORTEZA CEREBRAL"
  },
  {
    "codigo":285857006,
    "descripcion":"OPERA DISPOSITIVOS DOMÉSTICOS"
  },
  {
    "codigo":1268897007,
    "descripcion":"NEOPLASIA PRIMARIA MALIGNA DE OVARIO DE CÉLULAS DE LA TECA PRODUCTORAS DE ESTEROIDES"
  },
  {
    "codigo":185718005,
    "descripcion":"INCUMPLIMIENTO DEL CONTROL DE LA HIPERTENSIÓN"
  },
  {
    "codigo":87414006,
    "descripcion":"DEPRESIÓN REACTIVA (SITUACIONAL)"
  },
  {
    "codigo":710006007,
    "descripcion":"FORMA DE DIENTE"
  },
  {
    "codigo":314955001,
    "descripcion":"RECIDIVA LOCAL DE NEOPLASIA MALIGNA DE MAMA"
  },
  {
    "codigo":282187005,
    "descripcion":"BAJA ESCALONES"
  },
  {
    "codigo":249419005,
    "descripcion":"SANGRADO GINGIVAL AL TACTO"
  },
  {
    "codigo":446027006,
    "descripcion":"HUESO DE POLLO EN ESÓFAGO"
  },
  {
    "codigo":247584000,
    "descripcion":"DIFICULTAD PARA HACER PLANES"
  },
  {
    "codigo":85579005,
    "descripcion":"FIEBRE DE O'NYONG - NYONG"
  },
  {
    "codigo":216651006,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ALCOHOL AMÍLICO"
  },
  {
    "codigo":737269000,
    "descripcion":"ASPECTO OCULAR ANORMAL"
  },
  {
    "codigo":409589004,
    "descripcion":"SARNA DE LA PIEL"
  },
  {
    "codigo":49141004,
    "descripcion":"INTOXICACIÓN POR HORMONA HIPOFISARIA"
  },
  {
    "codigo":1359861007,
    "descripcion":"ABRASIÓN DE SEGMENTO PÉLVICO DE TRONCO"
  },
  {
    "codigo":47306003,
    "descripcion":"LOBOMICOSIS"
  },
  {
    "codigo":735434003,
    "descripcion":"NEUTROFILIA ADQUIRIDA"
  },
  {
    "codigo":15690881000119103,
    "descripcion":"ARTRITIS ENTEROPÁTICA DE AMBAS ARTICULACIONES GLENOHUMERALES"
  },
  {
    "codigo":1259722007,
    "descripcion":"GLIOBLASTOMA MULTIFORME PRIMARIO DE ENCÉFALO"
  },
  {
    "codigo":276682008,
    "descripcion":"CONJUNTIVITIS VIRAL NEONATAL"
  },
  {
    "codigo":405919007,
    "descripcion":"EQUIPO CLÍNICO INTERGRUPAL PARA EL ESTUDIO (POSQUIRÚRGICO) DE RABDOMIOSARCOMA, NO PUEDE EVALUARSE"
  },
  {
    "codigo":43636000,
    "descripcion":"CICATRIZ TRAQUEAL"
  },
  {
    "codigo":733599009,
    "descripcion":"SÍNDROME DE DE DELECIÓN DE ÁCIDO DESOXIRRIBONUCLEICO MITOCONDRIAL MÚLTIPLE DEBIDO A DEFICIENCIA DE DESOXIGUANOSINA CINASA DE COMIENZO EN LA VIDA ADULTA"
  },
  {
    "codigo":404084002,
    "descripcion":"ANGIOMIXOMA SUPERFICIAL"
  },
  {
    "codigo":830068003,
    "descripcion":"TENSIÓN VERTICAL DE SINCONDROSIS ESFENOBASILAR"
  },
  {
    "codigo":371316005,
    "descripcion":"DEFICIENCIA DE ACETILESTERASA"
  },
  {
    "codigo":1256052006,
    "descripcion":"QUERATOSIS POSTERIOR A RADIOTERAPIA"
  },
  {
    "codigo":240244006,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE ARTICULACIÓN DE PIE"
  },
  {
    "codigo":305780005,
    "descripcion":"ATENDIDO POR TÉCNICO ESPECIALIZADO EN REHABILITACIÓN POSQUIRÚRGICA"
  },
  {
    "codigo":271177001,
    "descripcion":"AMPOLLA TRAUMÁTICA DE PIERNA"
  },
  {
    "codigo":1155913007,
    "descripcion":"COLESTASIS INTRAHEPÁTICA FAMILIAR PROGRESIVA TIPO 1"
  },
  {
    "codigo":238409008,
    "descripcion":"INFECCIÓN DE MEMBRANA INTERDIGITAL DEL PIE"
  },
  {
    "codigo":302110001,
    "descripcion":"YEYUNOSTOMÍA, PRESENTE"
  },
  {
    "codigo":402249007,
    "descripcion":"DERMATITIS ALÉRGICA POR CONTACTO DE PÁRPADO"
  },
  {
    "codigo":105502003,
    "descripcion":"DEPENDENCIA DE LA DIÁLISIS RENAL"
  },
  {
    "codigo":1186846000,
    "descripcion":"INFERTILIDAD MASCULINA DEBIDA A CRIPTORQUIDIA"
  },
  {
    "codigo":433182005,
    "descripcion":"QUISTE DE DEDO DE LA MANO"
  },
  {
    "codigo":236574008,
    "descripcion":"RECHAZO AGUDO DEL TRASPLANTE RENAL"
  },
  {
    "codigo":890099000,
    "descripcion":"ATRESIA DE ÍLEON TIPO I"
  },
  {
    "codigo":365811003,
    "descripcion":"NIVEL DE GLUCOSA - HALLAZGO"
  },
  {
    "codigo":300275004,
    "descripcion":"HALLAZGO RELACIONADO CON LA SENSIBILIDAD FARÍNGEA"
  },
  {
    "codigo":298440003,
    "descripcion":"AMPLITUD DE FLEXIÓN LATERAL ACTIVA HACIA LA IZQUIERDA DE LA COLUMNA VERTEBRAL CERVICAL, NORMAL"
  },
  {
    "codigo":429512006,
    "descripcion":"USO INAPROPIADO DE METADONA"
  },
  {
    "codigo":1148573000,
    "descripcion":"INSUFICIENCIA HEPÁTICA POSTERIOR A PROCEDIMIENTO QUIRÚRGICO"
  },
  {
    "codigo":3528008,
    "descripcion":"DIETA CON BAJO CONTENIDO DE HIDRATOS DE CARBONO Y CON CONTROL DE GRASAS"
  },
  {
    "codigo":67229002,
    "descripcion":"INVERSIÓN UTERINA ESPONTÁNEA"
  },
  {
    "codigo":724424009,
    "descripcion":"ACCIDENTE CEREBROVASCULAR ISQUÉMICO DEBIDO A OCLUSIÓN DE PEQUEÑA ARTERIA"
  },
  {
    "codigo":460445000,
    "descripcion":"PERICARDITIS VIRAL CON DERRAME PERICÁRDICO"
  },
  {
    "codigo":296605004,
    "descripcion":"SOBREDOSIS DE NETILMICINA"
  },
  {
    "codigo":198301008,
    "descripcion":"INVOLUCIÓN SENIL DE OVARIO"
  },
  {
    "codigo":65394002,
    "descripcion":"DERMATITIS DE CONTACTO CAUSADA POR URUSHIOL DE ÁRBOL DE LACA CHINO"
  },
  {
    "codigo":720754008,
    "descripcion":"SÍNDROME DE CONODISPLASIA CRANEOFACIAL"
  },
  {
    "codigo":1179506009,
    "descripcion":"TIROSINA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1144903002,
    "descripcion":"NEFRITIS TUBULOINTERSTICIAL CRÓNICA DEBIDA A ISQUEMIA"
  },
  {
    "codigo":718919007,
    "descripcion":"DISFUNCIÓN SOMÁTICA DE REGIÓN OCCIPITOCERVICAL"
  },
  {
    "codigo":94492000,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA PLACENTA"
  },
  {
    "codigo":127260000,
    "descripcion":"NEOPLASIA DE LOS GANGLIOS LINFÁTICOS EPITROCLEARES"
  },
  {
    "codigo":192796004,
    "descripcion":"DEGENERACIÓN CEREBRAL EN MUCOPOLISACARIDOSIS"
  },
  {
    "codigo":422172005,
    "descripcion":"NEOPLASIA DE CÉLULAS NATURAL KILLERS Y\/O CÉLULAS T"
  },
  {
    "codigo":16266831000119100,
    "descripcion":"EPISODIO ÚNICO DE TRASTORNO DEPRESIVO MAYOR MODERADO CONCOMITANTE CON ANSIEDAD"
  },
  {
    "codigo":225564006,
    "descripcion":"DOLOR DE LA NARIZ"
  },
  {
    "codigo":292431000119100,
    "descripcion":"INFLAMACIÓN DE NERVIO PERIFÉRICO DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":16021071000119100,
    "descripcion":"BURSITIS GOTOSA BILATERAL DE HOMBROS"
  },
  {
    "codigo":318901000119107,
    "descripcion":"ARTRITIS REUMATOIDEA SEROPOSITIVA DE ARTICULACIÓN DE REGIÓN DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":92657003,
    "descripcion":"CARCINOMA IN SITU DEL OÍDO MEDIO"
  },
  {
    "codigo":254662007,
    "descripcion":"QUERATOACANTOMA"
  },
  {
    "codigo":123590007,
    "descripcion":"NEUMONÍA FOCAL"
  },
  {
    "codigo":449435001,
    "descripcion":"CONEXIÓN VENOSA PULMONAR ANÓMALA DE LOCALIZACIÓN INFRACARDÍACA CON DOS VENAS DESCENDENTES"
  },
  {
    "codigo":1268635000,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS PRIMARIO DE COLON"
  },
  {
    "codigo":39987008,
    "descripcion":"AUSENCIA CONGÉNITA DE LA ARTERIA PULMONAR DERECHA"
  },
  {
    "codigo":283760006,
    "descripcion":"MORDEDURA DE PERRO EN LA ESPALDA"
  },
  {
    "codigo":249157002,
    "descripcion":"PRESENTACIÓN POR ENCIMA DE LAS ESPINAS CIÁTICAS"
  },
  {
    "codigo":183621003,
    "descripcion":"SEGUIMIENTO EN 2 SEMANAS"
  },
  {
    "codigo":281925003,
    "descripcion":"FRACTURA DE PEDÍCULO DE VÉRTEBRA DORSAL"
  },
  {
    "codigo":609605005,
    "descripcion":"NEUROPATÍA DE NERVIO SAFENO EXTERNO EN LA PANTORRILLA"
  },
  {
    "codigo":871749007,
    "descripcion":"INCAPAZ DE CUIDAR POSESIONES PERSONALES"
  },
  {
    "codigo":1085161000119102,
    "descripcion":"OBSTRUCCIÓN INTESTINAL DEBIDA A PANCOLITIS ULCEROSA CRÓNICA"
  },
  {
    "codigo":1197594000,
    "descripcion":"SÍNDROME AUTOINFLAMATORIO, FIEBRE PERIÓDICA Y ENTEROCOLITIS DEL LACTANTE"
  },
  {
    "codigo":83482000,
    "descripcion":"TRASTORNO DISMÓRFICO CORPORAL"
  },
  {
    "codigo":314693008,
    "descripcion":"TALLA DEL NIÑO: PERCENTILO 25"
  },
  {
    "codigo":312858004,
    "descripcion":"HEMORRAGIA TRAQUEOBRONQUIAL NEONATAL"
  },
  {
    "codigo":247322000,
    "descripcion":"SENSACIÓN ANORMAL"
  },
  {
    "codigo":17946007,
    "descripcion":"DERMATITIS DE CONTACTO CAUSADA POR FUNGICIDA"
  },
  {
    "codigo":704239003,
    "descripcion":"FRACTURA EXPUESTA EN MARTILLO DE FALANGE DISTAL DE DEDO MAYOR DE LA MANO"
  },
  {
    "codigo":81647003,
    "descripcion":"NIVEL DE PROTEÍNAS SÉRICAS POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":292531009,
    "descripcion":"REACCIÓN ADVERSA A LA TROPICAMIDA"
  },
  {
    "codigo":16111009,
    "descripcion":"FRACTURAS MÚLTIPLES DE LA EXTREMIDAD SUPERIOR Y EL ESTERNÓN"
  },
  {
    "codigo":15666921000119105,
    "descripcion":"ARQUEAMIENTO CONGÉNITO DE AMBOS FÉMURES"
  },
  {
    "codigo":79812002,
    "descripcion":"VÓLVULO DE DUODENO"
  },
  {
    "codigo":1259460004,
    "descripcion":"DISFUNCIÓN RENAL POSOPERATORIA"
  },
  {
    "codigo":702404002,
    "descripcion":"NIVEL DE ESTRADIOL Y DE HORMONA FOLICULOESTIMULANTE POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":276420005,
    "descripcion":"NEOPLASIA MALIGNA DE CUERPO CAVERNOSO"
  },
  {
    "codigo":14276000,
    "descripcion":"QUEMADURA DE CUALQUIER GRADO QUE COMPROMETE 10-19 PORCIENTO DE LA SUPERFICIE DEL CUERPO"
  },
  {
    "codigo":241817000,
    "descripcion":"ENVENENAMIENTO CAUSADO POR VENENO DE ARAÑA DE SIDNEY"
  },
  {
    "codigo":209049001,
    "descripcion":"LUXACIÓN VERTEBRAL NO EXPUESTA CON LESIÓN MEDULAR ANTERIOR A NIVEL CERVICAL"
  },
  {
    "codigo":77977007,
    "descripcion":"SIGNO DE BRYANT"
  },
  {
    "codigo":239982000,
    "descripcion":"CONTRACTURA DE TENDÓN DE LA MUÑECA Y LA MANO"
  },
  {
    "codigo":733337008,
    "descripcion":"PANUVEÍTIS NO INFECCIOSA"
  },
  {
    "codigo":1255790001,
    "descripcion":"LINFOMA DE HODGKIN, VARIANTE CELULARIDAD MIXTA DE GANGLIOS LINFÁTICOS DE CABEZA Y CUELLO"
  },
  {
    "codigo":698734003,
    "descripcion":"MENINGITIS BACTERIANA POSOPERATORIA"
  },
  {
    "codigo":762435002,
    "descripcion":"AUMENTO DE LA ACTIVIDAD DIRIGIDA A UN OBJETIVO"
  },
  {
    "codigo":8771003,
    "descripcion":"CELULITIS DE PARTES BLANDAS DE LA CAVIDAD BUCAL"
  },
  {
    "codigo":321411000119104,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE TENDÓN EXTENSOR DE BRAZO IZQUIERDO"
  },
  {
    "codigo":74307005,
    "descripcion":"OPODIMO"
  },
  {
    "codigo":238147009,
    "descripcion":"SÍNDROME DE DISFUNCIÓN ORGÁNICA"
  },
  {
    "codigo":6936002,
    "descripcion":"SECUENCIA DE LABIO LEPORINO"
  },
  {
    "codigo":269080004,
    "descripcion":"FRACTURA NO EXPUESTA DE HÚMERO DISTAL"
  },
  {
    "codigo":301848005,
    "descripcion":"VÉRTIGO EPIDÉMICO VIRAL"
  },
  {
    "codigo":37869000,
    "descripcion":"SABAÑONES"
  },
  {
    "codigo":234477002,
    "descripcion":"DEFICIENCIA DE TROMBOXANO SINTETASA"
  },
  {
    "codigo":70637004,
    "descripcion":"CELULITIS DE DEDO DEL PIE"
  },
  {
    "codigo":1119213008,
    "descripcion":"DOLOR A LA PALPACIÓN EN REGIÓN LUMBAR IZQUIERDA DEL DORSO"
  },
  {
    "codigo":298178005,
    "descripcion":"INFLAMACIÓN DE ARTICULACIÓN DE COLUMNA VERTEBRAL LUMBAR"
  },
  {
    "codigo":230807001,
    "descripcion":"DESPLAZAMIENTO DE LA DERIVACIÓN VENTRICULAR CEREBRAL"
  },
  {
    "codigo":294508005,
    "descripcion":"ALERGIA A MEZLOCILINA"
  },
  {
    "codigo":15997111000119100,
    "descripcion":"PLIEGUE COROIDEO IDIOPÁTICO DE AMBOS OJOS"
  },
  {
    "codigo":720492008,
    "descripcion":"SÍNDROME DE HIPEROSTOSIS VERTEBRAL ANQUILOSANTE CON TILOSIS"
  },
  {
    "codigo":30529005,
    "descripcion":"CITRULINEMIA, TIPO NEONATAL"
  },
  {
    "codigo":292673007,
    "descripcion":"EFECTO ADVERSO DE LA COLCHICINA"
  },
  {
    "codigo":63297008,
    "descripcion":"HEMORRAGIA RETINIANA SUPERFICIAL"
  },
  {
    "codigo":1208342001,
    "descripcion":"SÍNDROME DE ANOMALÍAS OCULARES, ARACNODACTILIA Y CARDIOPATÍA"
  },
  {
    "codigo":61462000,
    "descripcion":"PALUDISMO"
  },
  {
    "codigo":126998003,
    "descripcion":"NEOPLASIA DE LOS CUERPOS CILIARES"
  },
  {
    "codigo":816961009,
    "descripcion":"RETINOPATÍA PROLIFERATIVA TRATADA ESTABLE DE OJO DERECHO DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":678071000119103,
    "descripcion":"HEMORRAGIA PRERRETINIANA DE OJO IZQUIERDO"
  },
  {
    "codigo":290838002,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR IPRINDOL"
  },
  {
    "codigo":421910007,
    "descripcion":"PUPILA EN FORMA DE LÁGRIMA"
  },
  {
    "codigo":94230009,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE BRONQUIO DEL LÓBULO INFERIOR DERECHO DEL PULMÓN"
  },
  {
    "codigo":92395003,
    "descripcion":"NEOPLASIA BENIGNA DE PARTES BLANDAS DEL CUELLO"
  },
  {
    "codigo":714987006,
    "descripcion":"CAPAZ DE EMPUJAR CON MIEMBRO INFERIOR"
  },
  {
    "codigo":289003008,
    "descripcion":"NO SE ALIMENTA"
  },
  {
    "codigo":385472000,
    "descripcion":"ESQUISTOCITOSIS"
  },
  {
    "codigo":30321000175106,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN EN CABEZA, ESTADIO I"
  },
  {
    "codigo":1237440006,
    "descripcion":"LACERACIÓN DE LIGAMENTO"
  },
  {
    "codigo":90560007,
    "descripcion":"GOTA"
  },
  {
    "codigo":418240007,
    "descripcion":"POTENCIA ERRÓNEA DE LENTE INTRAOCULAR"
  },
  {
    "codigo":81632821000132105,
    "descripcion":"DESPLAZAMIENTO DE STENT PANCREÁTICO"
  },
  {
    "codigo":16898231000119107,
    "descripcion":"ERITEMA MULTIFORME MAYOR"
  },
  {
    "codigo":55957000,
    "descripcion":"ÚLCERA DE COLON PROXIMAL"
  },
  {
    "codigo":449173006,
    "descripcion":"LINFOMA NO HODGKIN DIFUSO DE AMÍGDALA PALATINA"
  },
  {
    "codigo":23189007,
    "descripcion":"VULVODINIA IDIOPÁTICA"
  },
  {
    "codigo":283498005,
    "descripcion":"HERIDA PUNZANTE DE CABEZA Y CUELLO"
  },
  {
    "codigo":254131007,
    "descripcion":"ENFERMEDAD DE WORTH"
  },
  {
    "codigo":314431000,
    "descripcion":"INTÉRPRETE PRESENTE"
  },
  {
    "codigo":54122009,
    "descripcion":"ENFERMEDAD DE EALES"
  },
  {
    "codigo":248895001,
    "descripcion":"SANGRE EN LA VAGINA"
  },
  {
    "codigo":85055004,
    "descripcion":"COCCIDIOIDOMICOSIS DISEMINADA"
  },
  {
    "codigo":1197332003,
    "descripcion":"MELANOMA MALIGNO PRIMARIO DE SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":15724881000119106,
    "descripcion":"ENTESOPATÍA DE REGIÓN DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":441833000,
    "descripcion":"CATATONÍA LETAL"
  },
  {
    "codigo":212457004,
    "descripcion":"LESIÓN MUSCULAR Y TENDINOSA A NIVEL DEL ABDOMEN, REGIÓN LUMBAR Y PELVIS"
  },
  {
    "codigo":703977005,
    "descripcion":"DIETA PARA AUMENTAR DE PESO"
  },
  {
    "codigo":472766002,
    "descripcion":"TRASTORNO DE AURÍCULA IZQUIERDA COMO COMPLICACIÓN DE PROCEDIMIENTO"
  },
  {
    "codigo":1193662003,
    "descripcion":"TRASTORNO PERINATAL DEBIDO A DAÑO PLACENTARIO POR OPERACIÓN CESÁREA"
  },
  {
    "codigo":1259198005,
    "descripcion":"CRISIS EPILÉPTICA CON ALTERACIÓN DE CONCIENCIA"
  },
  {
    "codigo":767678008,
    "descripcion":"HERNIA INGUINAL IZQUIERDA RECURRENTE"
  },
  {
    "codigo":110483000,
    "descripcion":"CONSUMIDOR DE TABACO"
  },
  {
    "codigo":34221000087100,
    "descripcion":"LESIONES TRAUMÁTICAS MÚLTIPLES DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":208787005,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN DE CODO, INTERNA"
  },
  {
    "codigo":47021000087102,
    "descripcion":"FRACTURA DE FALANGE PROXIMAL DE ANULAR IZQUIERDO"
  },
  {
    "codigo":700307004,
    "descripcion":"ARTROSIS SECUNDARIA DE ARTICULACIÓN CALCANEOCUBOIDEA"
  },
  {
    "codigo":41901000087104,
    "descripcion":"CONTUSIÓN DE EXTREMIDAD SUPERIOR IZQUIERDA"
  },
  {
    "codigo":307091009,
    "descripcion":"MUTACIÓN DEL FACTOR V LEIDEN"
  },
  {
    "codigo":239720000,
    "descripcion":"DESGARRO DE MENISCO DE RODILLA"
  },
  {
    "codigo":39341000087104,
    "descripcion":"HERIDA PUNZANTE DE DEDO ANULAR DE MANO IZQUIERDA CON CUERPO EXTRAÑO"
  },
  {
    "codigo":44461000087108,
    "descripcion":"HERIDA PUNZANTE DE PIE DERECHO CON CUERPO EXTRAÑO"
  },
  {
    "codigo":403560008,
    "descripcion":"HEMANGIOMA PLANO ASOCIADO CON MIELODISRAFIA"
  },
  {
    "codigo":1090181000119101,
    "descripcion":"EDENTULISMO PARCIAL CLASE III DEBIDO A TRAUMATISMO"
  },
  {
    "codigo":237885008,
    "descripcion":"HIPERCALCEMIA HIPOCALCIÚRICA FAMILIAR"
  },
  {
    "codigo":203282002,
    "descripcion":"TUBERCULOSIS DE LOS HUESOS DE MÚLTIPLES LOCALIZACIONES"
  },
  {
    "codigo":1055250003,
    "descripcion":"AGENESIA DE EPÍFISIS DE FALANGE DISTAL DE DEDO MEÑIQUE"
  },
  {
    "codigo":236050004,
    "descripcion":"HERNIA PARAILEOSTOMÍA"
  },
  {
    "codigo":301586005,
    "descripcion":"DIFICULTAD PARA MANEJARSE EN ESCALONES Y ESCALERAS"
  },
  {
    "codigo":398055000,
    "descripcion":"DEFICIENCIA DE LINFOCITOS T"
  },
  {
    "codigo":234215001,
    "descripcion":"INFECCIÓN DE MARCAPASOS"
  },
  {
    "codigo":266983000,
    "descripcion":"CONCURRE A GRUPO DE JUEGOS"
  },
  {
    "codigo":365287004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CANTIDAD DE PENSAMIENTO"
  },
  {
    "codigo":4839005,
    "descripcion":"AGRANDAMIENTO CRÓNICO DE GLÁNDULA LAGRIMAL"
  },
  {
    "codigo":70375006,
    "descripcion":"HEMORRAGIA DEL INTESTINO DELGADO"
  },
  {
    "codigo":168679009,
    "descripcion":"RADIOGRAFÍA SIMPLE DE ARTICULACIÓN DE TOBILLO NORMAL"
  },
  {
    "codigo":299751009,
    "descripcion":"REFLEJO DE CHUPETEO AUSENTE"
  },
  {
    "codigo":723900003,
    "descripcion":"TRASTORNO DELIRANTE ACTUALMENTE EN REMISIÓN PARCIAL"
  },
  {
    "codigo":3004001,
    "descripcion":"DILATACIÓN CONGÉNITA DE ESÓFAGO"
  },
  {
    "codigo":199612005,
    "descripcion":"BEBÉ PEQUEÑO PARA LA EDAD GESTACIONAL"
  },
  {
    "codigo":1240591000000102,
    "descripcion":"CORONAVIRUS 2 DEL SÍNDROME RESPIRATORIO AGUDO SEVERO NO DETECTADO"
  },
  {
    "codigo":363452003,
    "descripcion":"NEOPLASIA MALIGNA DE EPIDÍDIMO"
  },
  {
    "codigo":230545005,
    "descripcion":"NEUROPATÍA FACIAL POR COMPRESIÓN"
  },
  {
    "codigo":1066511000000109,
    "descripcion":"CAPAZ DE USAR TECLADO DE COMPUTADORA"
  },
  {
    "codigo":165009005,
    "descripcion":"PRUEBA DE ALERGIA - SIN REACCIÓN"
  },
  {
    "codigo":1344657008,
    "descripcion":"BAÑO INTERNO"
  },
  {
    "codigo":33937009,
    "descripcion":"ARTRITIS DE LYME"
  },
  {
    "codigo":296081005,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE ALPRAZOLAM"
  },
  {
    "codigo":32102004,
    "descripcion":"CONDUCTA SUPRAYACENTE"
  },
  {
    "codigo":294246004,
    "descripcion":"ALERGIA A SURFACTANTE NO IÓNICO"
  },
  {
    "codigo":359782004,
    "descripcion":"NEOPLASIA MALIGNA CON METÁSTASIS EN VÉRTICE DE VEJIGA URINARIA"
  },
  {
    "codigo":458086004,
    "descripcion":"PARÁPAGOS DITORÁCICOS"
  },
  {
    "codigo":95803004,
    "descripcion":"SECRECIÓN SEROSA DESDE EL CONDUCTO AUDITIVO EXTERNO"
  },
  {
    "codigo":292411008,
    "descripcion":"REACCIÓN ADVERSA A LA PEMOLINA"
  },
  {
    "codigo":718395009,
    "descripcion":"DEFECTOS DE LOS HUESOS TUBULARES Y DE LA COLUMNA VERTEBRAL"
  },
  {
    "codigo":225040001,
    "descripcion":"AMNESIA DISOCIATIVA LOCALIZADA"
  },
  {
    "codigo":28432003,
    "descripcion":"ABSCESO DE LA MAMA"
  },
  {
    "codigo":1264307003,
    "descripcion":"DERMATITIS GENERALIZADA CAUSADA POR SUSTANCIA ADMINISTRADA POR VÍA ORAL"
  },
  {
    "codigo":93968005,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA PARED POSTERIOR DE LA HIPOFARINGE"
  },
  {
    "codigo":126736007,
    "descripcion":"NEOPLASIA DE VASO SANGUÍNEO"
  },
  {
    "codigo":61200008,
    "descripcion":"DEGENERACIÓN PALIDONIGROLUISIANA"
  },
  {
    "codigo":190437000,
    "descripcion":"HIPOINSULINEMIA POSQUIRÚRGICA"
  },
  {
    "codigo":288741002,
    "descripcion":"NO EMPLEA AUTOEXPRESIÓN"
  },
  {
    "codigo":26597004,
    "descripcion":"HIPOPLASIA DEL ESMALTE"
  },
  {
    "codigo":92133004,
    "descripcion":"NEOPLASIA BENIGNA DEL ÁNGULO HEPÁTICO DEL COLON"
  },
  {
    "codigo":712890000,
    "descripcion":"NIVEL DE ENERGÍA NORMAL"
  },
  {
    "codigo":254138001,
    "descripcion":"DISPLASIA OCULODENTOÓSEA - GRAVE"
  },
  {
    "codigo":22927000,
    "descripcion":"CONDUCTA SOSPECHOSA"
  },
  {
    "codigo":416143005,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA NO EXPUESTA, ARTICULACIÓN INTERFALÁNGICA DISTAL DE DEDO DE LA MANO"
  },
  {
    "codigo":711055006,
    "descripcion":"DOLOR FANTASMA DESPUÉS DE RESECCIÓN DE OJO"
  },
  {
    "codigo":836488001,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR BROMO Y\/O COMPUESTO DE BROMO"
  },
  {
    "codigo":448911008,
    "descripcion":"TORSIÓN DE LEIOMIOMA DE ÚTERO"
  },
  {
    "codigo":21092002,
    "descripcion":"ABSCESO DE DEDO DE LA MANO"
  },
  {
    "codigo":283236008,
    "descripcion":"VIDRIO EN BOCA"
  },
  {
    "codigo":445241004,
    "descripcion":"TOS PERSISTENTE LUEGO DE INFECCIÓN RESPIRATORIA POR VIRUS"
  },
  {
    "codigo":707385007,
    "descripcion":"CARCINOMA PRIMARIO INDIFERENCIADO DE TRÁQUEA"
  },
  {
    "codigo":248633009,
    "descripcion":"PULSO DESIGUAL"
  },
  {
    "codigo":17422006,
    "descripcion":"TEJIDO TÍMICO ECTÓPICO"
  },
  {
    "codigo":82958007,
    "descripcion":"INTOXICACIÓN POR LOBELIA INFLATA"
  },
  {
    "codigo":1295374008,
    "descripcion":"NEVO AZUL ATÍPICO DE PIEL"
  },
  {
    "codigo":1258936000,
    "descripcion":"AUSENCIA CONGÉNITA COMPLETA DE MIEMBRO SUPERIOR DERECHO"
  },
  {
    "codigo":736483009,
    "descripcion":"MÉDICAMENTE APTO PARA COMPARECER ANTE LA JUSTICIA"
  },
  {
    "codigo":210360003,
    "descripcion":"HERIDA ABIERTA DE LA MUCOSA YUGAL"
  },
  {
    "codigo":13752003,
    "descripcion":"LESIÓN TRAUMÁTICA CEREBRAL CON HERIDA INTRACRANEAL ABIERTA Y PÉRDIDA DE LA CONSCIENCIA"
  },
  {
    "codigo":110221003,
    "descripcion":"QUEMADURA DE TERCER GRADO DEL PALADAR DURO"
  },
  {
    "codigo":720819006,
    "descripcion":"SÍNDROME DE CURRY JONES"
  },
  {
    "codigo":11917008,
    "descripcion":"FIEBRE DE BEBARU"
  },
  {
    "codigo":863885009,
    "descripcion":"CON RIESGO MODERADO DE ÚLCERA DE PIE DERECHO DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":1156962001,
    "descripcion":"RADICULOPATÍA DEBIDA A ESPONDILOSIS CERVICAL MULTINIVEL"
  },
  {
    "codigo":1092691000119109,
    "descripcion":"COMA HEPÁTICO DEBIDO A INSUFICIENCIA HEPÁTICA SUBAGUDA"
  },
  {
    "codigo":1255266003,
    "descripcion":"ESTENOSIS DE SEGMENTO MEDIO DE RAMA DESCENDENTE ANTERIOR DE ARTERIA CORONARIA IZQUIERDA"
  },
  {
    "codigo":763746006,
    "descripcion":"PERISTALTISMO DIGESTIVO ANORMAL"
  },
  {
    "codigo":403298007,
    "descripcion":"UÑA CON MEDIALUNA ROJA EN INSUFICIENCIA CARDÍACA CONGESTIVA"
  },
  {
    "codigo":10082001,
    "descripcion":"PANENCEFALITIS PROGRESIVA POR RUBÉOLA"
  },
  {
    "codigo":237623001,
    "descripcion":"HIPERGLUCEMIA AGUDA"
  },
  {
    "codigo":1288034005,
    "descripcion":"TUMOR DE CÉLULAS ENTEROCROMAFINES DE INTESTINO DELGADO"
  },
  {
    "codigo":293000001,
    "descripcion":"REACCIÓN ADVERSA A LA CEFRADINA"
  },
  {
    "codigo":8247009,
    "descripcion":"BERILIOSIS"
  },
  {
    "codigo":792844003,
    "descripcion":"DOLOR DE EXTREMIDAD EN REPOSO DEBIDO A ATEROSCLEROSIS DE ARTERIA DE MIEMBRO INFERIOR"
  },
  {
    "codigo":203020004,
    "descripcion":"ABSCESO DE MÚSCULO DE CUELLO"
  },
  {
    "codigo":235788003,
    "descripcion":"FÍSTULA PROSTÁTICA HACIA EL COLON"
  },
  {
    "codigo":6412007,
    "descripcion":"SIGNOS ELECTROCARDIOGRÁFICOS DE TOXICIDAD POR DIGITAL"
  },
  {
    "codigo":299489000,
    "descripcion":"AMPLITUD DE MOVIMIENTO ACTIVO DE PRONACIÓN MEDIOTARSIANA AUMENTADA"
  },
  {
    "codigo":39180009,
    "descripcion":"TÓRAX MATE A LA PERCUSIÓN"
  },
  {
    "codigo":301324009,
    "descripcion":"MANOS NORMALES"
  },
  {
    "codigo":365025003,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA CONTROLAR LA RESPIRACIÓN"
  },
  {
    "codigo":168417005,
    "descripcion":"EXTENDIDO CERVICAL: TRICHOMONAS"
  },
  {
    "codigo":102881006,
    "descripcion":"SECRECIÓN PLACENTARIA NORMAL DE GONADOTROFINA CORIÓNICA"
  },
  {
    "codigo":363190001,
    "descripcion":"TRASTORNO HEREDITARIO DEL SISTEMA LINFÁTICO"
  },
  {
    "codigo":35510002,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO DEL DORSO"
  },
  {
    "codigo":232118008,
    "descripcion":"ANOMALÍA DEL SISTEMA DE VERGENCIA"
  },
  {
    "codigo":264886009,
    "descripcion":"FUNCIÓN HIPOFISARIA NORMAL"
  },
  {
    "codigo":263051004,
    "descripcion":"SUBLUXACIÓN DE ARTICULACIÓN DE HOMBRO"
  },
  {
    "codigo":195680000,
    "descripcion":"LARINGITIS EDEMATOSA AGUDA"
  },
  {
    "codigo":721803008,
    "descripcion":"INFECCIÓN CAUSADA POR SAPROCHAETE"
  },
  {
    "codigo":295819009,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE AMANTADINA"
  },
  {
    "codigo":228448000,
    "descripcion":"SE EJERCITA REGULARMENTE"
  },
  {
    "codigo":392288006,
    "descripcion":"GLAUCOMA PRIMARIO DE ÁNGULO AGUDO"
  },
  {
    "codigo":292149000,
    "descripcion":"REACCIÓN ADVERSA A LA ALVERINA"
  },
  {
    "codigo":293984009,
    "descripcion":"ALERGIA A TIMOLOL"
  },
  {
    "codigo":128309002,
    "descripcion":"INFILTRADO RADIOLÓGICO"
  },
  {
    "codigo":12236321000119101,
    "descripcion":"BURSITIS DE DEDO DE MANO IZQUIERDA"
  },
  {
    "codigo":1142282000,
    "descripcion":"AGANGLIONOSIS CONGÉNITA DE INTESTINO DELGADO"
  },
  {
    "codigo":93706003,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE VASO SANGUÍNEO PERINEAL"
  },
  {
    "codigo":290314009,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR TOLMETINA"
  },
  {
    "codigo":59103002,
    "descripcion":"PARÁLISIS CEREBRAL CON ATAXIA HOMOLATERAL"
  },
  {
    "codigo":386783003,
    "descripcion":"TIC"
  },
  {
    "codigo":685601000119104,
    "descripcion":"LEIOMIOSARCOMA PRIMARIO DE GLÚTEO"
  },
  {
    "codigo":714463003,
    "descripcion":"LINFOMA PRIMARIO CON DERRAME CONCOMITANTE CON INFECCIÓN POR HERPESVIRUS HUMANO 8"
  },
  {
    "codigo":91871006,
    "descripcion":"AUSENCIA CONGÉNITA DE HUESO BASIESFENOIDAL"
  },
  {
    "codigo":188340000,
    "descripcion":"NEOPLASIA MALIGNA DE CONDUCTO CRANEOFARÍNGEO"
  },
  {
    "codigo":417716002,
    "descripcion":"CON MAYOR RIESGO DE DESCUIDO POR PARTE DE OTROS"
  },
  {
    "codigo":1204148002,
    "descripcion":"ESTENOSIS DE ARTERIA CEREBRAL POSTERIOR ASINTOMÁTICA"
  },
  {
    "codigo":253876004,
    "descripcion":"DEGENERACIÓN RENAL FIBROQUÍSTICA"
  },
  {
    "codigo":24500009,
    "descripcion":"AGNOSIA DE LA IMAGEN CORPORAL"
  },
  {
    "codigo":286644009,
    "descripcion":"NIVEL DE ANSIEDAD"
  },
  {
    "codigo":252041008,
    "descripcion":"HALLAZGO DE MICCIÓN"
  },
  {
    "codigo":284809008,
    "descripcion":"CAPAZ DE SENTARSE EN LA BAÑERA"
  },
  {
    "codigo":1003870006,
    "descripcion":"DISOMÍA UNIPARENTAL DE ORIGEN PATERNO DEL CROMOSOMA 4"
  },
  {
    "codigo":10899131000119104,
    "descripcion":"HERIDA ABIERTA DE LA BOCA DEBIDA A MORDEDURA"
  },
  {
    "codigo":218951000119100,
    "descripcion":"ALTERACIÓN VISUAL BILATERAL"
  },
  {
    "codigo":10633031000119101,
    "descripcion":"CELULITIS DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":16057671000119102,
    "descripcion":"PARÁLISIS FACIAL IZQUIERDA GRADO II DE HOUSE-BRACKMANN"
  },
  {
    "codigo":16026951000119102,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DEBIDO A ESTENOSIS DE ARTERIA CARÓTIDA DERECHA"
  },
  {
    "codigo":15985991000119104,
    "descripcion":"MALFORMACIÓN CONGÉNITA DE VASO SANGUÍNEO DE ÓRBITA DERECHA PROPIAMENTE DICHA"
  },
  {
    "codigo":15911751000119105,
    "descripcion":"HEMATOMA TRAUMÁTICO DE LIGAMENTO ANCHO DERECHO DE ÚTERO"
  },
  {
    "codigo":10942791000119105,
    "descripcion":"CONMOCIÓN DE RETINA IZQUIERDA"
  },
  {
    "codigo":10630471000119104,
    "descripcion":"LINFANGITIS AGUDA DE ANTEBRAZO DERECHO"
  },
  {
    "codigo":16052551000119108,
    "descripcion":"TENDINOSIS DE RODILLA DERECHA"
  },
  {
    "codigo":16034631000119109,
    "descripcion":"HIPERTROFIA DE HUESO DE MANO IZQUIERDA"
  },
  {
    "codigo":16021831000119108,
    "descripcion":"HIPERTROFIA DE MEMBRANA SINOVIAL DE ARTICULACIÓN DE AMBOS PIES"
  },
  {
    "codigo":1076551000119108,
    "descripcion":"PINZAMIENTO SUBCORACOIDEO DE REGIÓN DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":16009031000119108,
    "descripcion":"DEFORMIDAD CONGÉNITA DE HUESO DE AMBOS ANTEBRAZOS"
  },
  {
    "codigo":16037191000119105,
    "descripcion":"DETENCIÓN DE CRECIMIENTO EPIFISARIO DE FÉMUR IZQUIERDO"
  },
  {
    "codigo":21831000119109,
    "descripcion":"PSICOSIS POR FENCICLIDINA"
  },
  {
    "codigo":15755591000119106,
    "descripcion":"TRASTORNO DE LACTANCIA POSPARTO"
  },
  {
    "codigo":236871000119109,
    "descripcion":"PERICONDRITIS DE OÍDO EXTERNO"
  },
  {
    "codigo":82696006,
    "descripcion":"ICTERICIA NEONATAL DEBIDA A CONJUGACIÓN TARDÍA POR INHIBIDORES PRESENTES EN LECHE MATERNA"
  },
  {
    "codigo":1293277000,
    "descripcion":"DERRAME DE ARTICULACIÓN RADIOCARPIANA DERECHA"
  },
  {
    "codigo":15951701000119100,
    "descripcion":"NEVO DISPLÁSICO DE PIEL DE AMBAS EXTREMIDADES INFERIORES"
  },
  {
    "codigo":308402004,
    "descripcion":"SITUACIÓN DEL DESARROLLO DEL NIÑO"
  },
  {
    "codigo":79026005,
    "descripcion":"INTOXICACIÓN POR PRUNUS"
  },
  {
    "codigo":898226005,
    "descripcion":"SINOSTOSIS CONGÉNITA DE SEGUNDO HUESO METACARPIANO CON HUESO TRAPEZOIDE"
  },
  {
    "codigo":111794008,
    "descripcion":"INFECCIÓN ENMASCARADA"
  },
  {
    "codigo":44423001,
    "descripcion":"ENCEFALOPATÍA MIOCLÓNICA TEMPRANA"
  },
  {
    "codigo":372103002,
    "descripcion":"CARCINOMA DE GLOTIS"
  },
  {
    "codigo":699783006,
    "descripcion":"CARA BRAQUICEFÁLICA"
  },
  {
    "codigo":254600001,
    "descripcion":"GRANULOMA INTESTINAL POR SUTURA"
  },
  {
    "codigo":403036000,
    "descripcion":"TIÑA CORPORAL CAUSADA POR TRICHOPHYTON MENTAGROPHYTES"
  },
  {
    "codigo":239196005,
    "descripcion":"PÉRDIDA DEL COLGAJO"
  },
  {
    "codigo":32751000119100,
    "descripcion":"SEPSIS DE VÍA ASOCIADA CON CATÉTER DE DIÁLISIS"
  },
  {
    "codigo":1187633001,
    "descripcion":"RUPTURA DE ARTERIA PULMONAR"
  },
  {
    "codigo":302897004,
    "descripcion":"DEPÓSITO CONJUNTIVAL CAUSADO POR FÁRMACO"
  },
  {
    "codigo":38918003,
    "descripcion":"ENVENENAMIENTO POR ORUGA"
  },
  {
    "codigo":688111000119103,
    "descripcion":"NEURILEMOMA DE NERVIO DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":399366008,
    "descripcion":"POSICIÓN CORPORAL OBLICUA"
  },
  {
    "codigo":102619001,
    "descripcion":"DOLOR ESOFÁGICO"
  },
  {
    "codigo":37083002,
    "descripcion":"HIPEREROTISMO MASCULINO"
  },
  {
    "codigo":200923003,
    "descripcion":"ERITEMA URTICANTE"
  },
  {
    "codigo":6150008,
    "descripcion":"INFECCIÓN CAUSADA POR DIPLOSTOMUM"
  },
  {
    "codigo":233691007,
    "descripcion":"EOSINOFILIA PULMONAR ASMÁTICA"
  },
  {
    "codigo":10682351000119105,
    "descripcion":"TUMORACIÓN DE LA PIEL DE DEDO DEL PIE IZQUIERDO"
  },
  {
    "codigo":364763009,
    "descripcion":"HALLAZGO RELACIONADO CON LA FUNCIÓN MOTRIZ DEL PALADAR"
  },
  {
    "codigo":1187507004,
    "descripcion":"ENFERMEDAD RENAL ASOCIADA A INMUNOGLOBULINA G4"
  },
  {
    "codigo":231856008,
    "descripcion":"CONJUNTIVITIS ALÉRGICA PERENNE"
  },
  {
    "codigo":33413000,
    "descripcion":"LATIDOS ECTÓPICOS"
  },
  {
    "codigo":88201000119101,
    "descripcion":"FALTA DE DILATACIÓN CERVICAL DEBIDA A INERCIA UTERINA PRIMARIA"
  },
  {
    "codigo":230021003,
    "descripcion":"POSICIÓN DEL TRONCO INCLINADO HACIA ADELANTE"
  },
  {
    "codigo":361093005,
    "descripcion":"DEFICIENCIA DE AMINO OXIDASA"
  },
  {
    "codigo":15734921000119102,
    "descripcion":"PSEUDOQUISTE DE RETINA DE OJO DERECHO"
  },
  {
    "codigo":293722000,
    "descripcion":"ALERGIA A LIDOCAÍNA"
  },
  {
    "codigo":721541009,
    "descripcion":"SARCOMA MALIGNO CUTÁNEO PRIMARIO"
  },
  {
    "codigo":129882008,
    "descripcion":"AFRONTAMIENTO DISFUNCIONAL MEDIANTE EL EMPLEO DE MECANISMOS DE AUTODEFENSA"
  },
  {
    "codigo":717871001,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE DUODENO"
  },
  {
    "codigo":128047003,
    "descripcion":"ENFERMEDAD INFECCIOSA DE LAS MEMBRANAS MUCOSAS"
  },
  {
    "codigo":783407004,
    "descripcion":"FISURA DE PALADAR INCOMPLETA"
  },
  {
    "codigo":160815007,
    "descripcion":"SE DECLARA INOCENTE"
  },
  {
    "codigo":291887007,
    "descripcion":"INTOXICACIÓN ACCIDENTAL CON SUSTITUTO SANGUÍNEO MACROMOLECULAR"
  },
  {
    "codigo":27908001,
    "descripcion":"ABSCESO CEREBRAL AMEBIANO"
  },
  {
    "codigo":60676002,
    "descripcion":"DEGENERACIÓN VITREORRETINIANA SECUNDARIA"
  },
  {
    "codigo":95279007,
    "descripcion":"LEIOMIOMA SUBMUCOSO DEL ÚTERO"
  },
  {
    "codigo":93444006,
    "descripcion":"CENTRO CARTILAGINOSO DE LA VÉRTEBRA DORSAL EN FORMA DE PALANCA"
  },
  {
    "codigo":288217001,
    "descripcion":"RUPTURA DE TENDÓN DE MANO"
  },
  {
    "codigo":224516009,
    "descripcion":"CUIDADOR QUE UTILIZA MEDIO DE TRANSPORTE PÚBLICO"
  },
  {
    "codigo":1304025005,
    "descripcion":"ADHESIÓN CONGÉNITA DE HÉLICE DE OREJA"
  },
  {
    "codigo":286382006,
    "descripcion":"ENCUENTRA LAS PALABRAS PARA HABLAR"
  },
  {
    "codigo":253614008,
    "descripcion":"HIPOPLASIA TUBULAR DE AORTA"
  },
  {
    "codigo":12103971000119104,
    "descripcion":"QUEMADURA DE REGIÓN DE RODILLA IZQUIERDA"
  },
  {
    "codigo":251779007,
    "descripcion":"SUBACOMODACIÓN OCULAR"
  },
  {
    "codigo":1234819007,
    "descripcion":"LGMD (DISTROFIA MUSCULAR DE CINTURAS) POR DEFICIENCIA DE POMK (PROTEÍNA O-MANOSA CINASA)"
  },
  {
    "codigo":448387008,
    "descripcion":"LINFOMA NO HODGKIN DE TESTÍCULO"
  },
  {
    "codigo":282712002,
    "descripcion":"NO EMPUJA NI ARRASTRA HACIA ADELANTE UN JUGUETE PEQUEÑO CON RUEDAS"
  },
  {
    "codigo":315480002,
    "descripcion":"NACIDO EN MOLDAVIA"
  },
  {
    "codigo":249944006,
    "descripcion":"MONOPARESIA - BRAZO"
  },
  {
    "codigo":248109002,
    "descripcion":"CONDUCTA SEXUALMENTE OFENSIVA"
  },
  {
    "codigo":1231149005,
    "descripcion":"AMILOIDOSIS AH"
  },
  {
    "codigo":444717006,
    "descripcion":"UROLITIASIS DE OXALATO DE CALCIO"
  },
  {
    "codigo":1296685008,
    "descripcion":"NÁUSEA Y VÓMITO DURANTE EMBARAZO"
  },
  {
    "codigo":279042001,
    "descripcion":"DISFUNCIÓN LUMBAR SEGMENTARIA"
  },
  {
    "codigo":770562000,
    "descripcion":"DISOMÍA UNIPARENTAL MATERNA DEL CROMOSOMA 1"
  },
  {
    "codigo":277207000,
    "descripcion":"TUMEFACCIÓN SOBRE LA APÓFISIS MASTOIDES"
  },
  {
    "codigo":80599001,
    "descripcion":"DEFICIENCIA AISLADA DE CORTICOTROFINA"
  },
  {
    "codigo":441047002,
    "descripcion":"VIRUS RESISTENTE A ZANAMIVIR PRESENTE"
  },
  {
    "codigo":703191003,
    "descripcion":"ENDOCARDITIS DE PRÓTESIS DE VÁLVULA PULMONAR"
  },
  {
    "codigo":16746941000119104,
    "descripcion":"RETINOPATÍA NO PROLIFERATIVA SEVERA DE OJO IZQUIERDO DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":1293015005,
    "descripcion":"DEFICIENCIA DE METILMALONATO SEMIALDEHÍDO DESHIDROGENASA"
  },
  {
    "codigo":406444002,
    "descripcion":"ESPASMO LARÍNGEO"
  },
  {
    "codigo":1356716003,
    "descripcion":"HERIDAS ABIERTAS MÚLTIPLES DE VASO DIGITAL DE MANO"
  },
  {
    "codigo":373676004,
    "descripcion":"SIGNO DE ROMBERG"
  },
  {
    "codigo":308140006,
    "descripcion":"HEMORROIDES EN EL EMBARAZO"
  },
  {
    "codigo":111532006,
    "descripcion":"ESTRABISMO COMO PARTE DE OTRO TRASTORNO NEUROMUSCULAR"
  },
  {
    "codigo":109697002,
    "descripcion":"OSTEOMIELITIS MANDIBULAR CRÓNICA"
  },
  {
    "codigo":16638551000119101,
    "descripcion":"COMPRESIÓN BILATERAL DE NERVIOS CIÁTICOS POPLÍTEOS EXTERNOS"
  },
  {
    "codigo":208001004,
    "descripcion":"FRACTURA VERTEBRAL NO EXPUESTA CON LESIÓN ANTERIOR DE MÉDULA ESPINAL CERVICAL, C1-4"
  },
  {
    "codigo":240769005,
    "descripcion":"TRANSFORMACIÓN CARCINOMATOSA DE CROMOBLASTOMICOSIS"
  },
  {
    "codigo":765057007,
    "descripcion":"SÍNDROME DE PREDISPOSICIÓN TUMORAL ASOCIADO A LA PROTEÍNA BRCA1"
  },
  {
    "codigo":699521008,
    "descripcion":"CATARATA CORTICAL NO SENIL"
  },
  {
    "codigo":271702003,
    "descripcion":"POSTURA PARAPLÉJICA EN FLEXIÓN"
  },
  {
    "codigo":238934003,
    "descripcion":"LIQUEN ESCLEROSO EN GOTAS"
  },
  {
    "codigo":75094005,
    "descripcion":"HIDROPESÍA DE PLACENTA"
  },
  {
    "codigo":402774006,
    "descripcion":"DEFECTO GENÉTICO DE TALLO PILOSO"
  },
  {
    "codigo":336471000119104,
    "descripcion":"ENTROPIÓN SENIL DE PÁRPADO DERECHO"
  },
  {
    "codigo":1351211006,
    "descripcion":"INMUNODEFICIENCIA COMBINADA SEVERA T NEGATIVA B POSITIVA AUTOSÓMICA RECESIVA DEBIDA A MUTACIÓN DE CD3-ZETA"
  },
  {
    "codigo":400939008,
    "descripcion":"ESOTROPÍA PARÉTICA"
  },
  {
    "codigo":5888003,
    "descripcion":"QUERATITIS"
  },
  {
    "codigo":202496003,
    "descripcion":"DOLOR EN ARTICULACIONES METATARSOFALÁNGICAS SEGUNDA A QUINTA"
  },
  {
    "codigo":1073751000119106,
    "descripcion":"ARTRITIS REUMATOIDE DE LA MUÑECA IZQUIERDA"
  },
  {
    "codigo":300800004,
    "descripcion":"PARTICIPA EN ACTIVIDADES DEPORTIVAS"
  },
  {
    "codigo":366336009,
    "descripcion":"REACTIVIDAD CARDIOTOCOGRÁFICA - HALLAZGO"
  },
  {
    "codigo":200661002,
    "descripcion":"CELULITIS Y ABSCESO DE FLANCO"
  },
  {
    "codigo":167893002,
    "descripcion":"LÍQUIDO SINOVIAL: COÁGULO DE FIBRINA +"
  },
  {
    "codigo":69589006,
    "descripcion":"MIOENDOCARDITIS SUBAGUDA"
  },
  {
    "codigo":36821007,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE VULVA SIN INFECCIÓN"
  },
  {
    "codigo":298965009,
    "descripcion":"AMPLITUD DE EXTENSIÓN PASIVA DE LA MUÑECA NORMAL"
  },
  {
    "codigo":67754003,
    "descripcion":"ESCLEROSIS DE VÁLVULA AÓRTICA"
  },
  {
    "codigo":723114004,
    "descripcion":"TEMOR A ENFERMEDAD NUTRICIONAL"
  },
  {
    "codigo":428202005,
    "descripcion":"CONSUMO DE ALCOHOL DENTRO DEL LÍMITE DIARIO RECOMENDADO"
  },
  {
    "codigo":721279000,
    "descripcion":"INFECCIÓN NEONATAL CAUSADA POR ASPERGILLUS"
  },
  {
    "codigo":297130008,
    "descripcion":"FRACTURA DE FALANGE PROXIMAL DE DEDO DE LA MANO"
  },
  {
    "codigo":383004,
    "descripcion":"HALLAZGO RELACIONADO CON LA AMPLITUD DE LA EXTENSIÓN PASIVA DE LA CADERA"
  },
  {
    "codigo":295295005,
    "descripcion":"SOBREDOSIS DE SULINDAC"
  },
  {
    "codigo":262527008,
    "descripcion":"EDEMA TRAUMÁTICO SUPERFICIAL"
  },
  {
    "codigo":129620000,
    "descripcion":"DISTROFIA MUSCULAR ESCAPULOPERONEA"
  },
  {
    "codigo":1145428006,
    "descripcion":"HIPOPLASIA CONGÉNITA DE HUESO DE TÓRAX"
  },
  {
    "codigo":293460008,
    "descripcion":"REACCIÓN ADVERSA A LA METICLOTIAZIDA"
  },
  {
    "codigo":11778801000119107,
    "descripcion":"RUPTURA TRAUMÁTICA DE TENDÓN DE LA CABEZA LARGA DE BÍCEPS BRAQUIAL DERECHO"
  },
  {
    "codigo":226089003,
    "descripcion":"DIETA CON BAJO CONTENIDO DE METIONINA"
  },
  {
    "codigo":291625004,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR CEFTIBUTENO"
  },
  {
    "codigo":95017007,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL PÍLORO"
  },
  {
    "codigo":60414003,
    "descripcion":"ALACTASIA ADQUIRIDA"
  },
  {
    "codigo":289790005,
    "descripcion":"CUELLO UTERINO ORIENTADO HACIA ATRÁS"
  },
  {
    "codigo":1010686006,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA A TRAVÉS DE ANTEBRAZO IZQUIERDO"
  },
  {
    "codigo":93182006,
    "descripcion":"HISTIOCITOSIS MALIGNA DE GANGLIOS LINFÁTICOS INTRABDOMINALES"
  },
  {
    "codigo":191486006,
    "descripcion":"ALUCINOSIS CAUSADA POR FÁRMACO"
  },
  {
    "codigo":224254008,
    "descripcion":"ZONAS DE HUMEDAD EN LAS PAREDES DEL HOGAR"
  },
  {
    "codigo":124115002,
    "descripcion":"DEFICIENCIA DE L - LACTATO DESHIDROGENASA"
  },
  {
    "codigo":1172691004,
    "descripcion":"SÍNDROME DE DISCAPACIDAD INTELECTUAL LIGADA AL CROMOSOMA X ASOCIADO AL GEN CLCN4"
  },
  {
    "codigo":255187008,
    "descripcion":"LIPOMA CUTÁNEO"
  },
  {
    "codigo":253352002,
    "descripcion":"ANOMALÍA DE AURÍCULA IZQUIERDA"
  },
  {
    "codigo":417192005,
    "descripcion":"INFECCIÓN POR VIRUS DE LA ENCEFALITIS DE SAN LUIS"
  },
  {
    "codigo":286120008,
    "descripcion":"NO LIMPIA EL PISO"
  },
  {
    "codigo":185981001,
    "descripcion":"ERROR DE ENTRADA ANULADO"
  },
  {
    "codigo":284285008,
    "descripcion":"NO EMPLEA AGARRE CON DOS DEDOS"
  },
  {
    "codigo":249682001,
    "descripcion":"ANGULACIÓN DE LA CLAVÍCULA"
  },
  {
    "codigo":118610003,
    "descripcion":"ENFERMEDAD DE HODGKIN, DEPLECIÓN LINFOCÍTICA"
  },
  {
    "codigo":446290005,
    "descripcion":"FÍSTULA CUTÁNEA DE GLÚTEO"
  },
  {
    "codigo":11301000119103,
    "descripcion":"ANOMALÍA MAXILAR"
  },
  {
    "codigo":16641061000119103,
    "descripcion":"INFLAMACIÓN BILATERAL DE NERVIO PERIFÉRICO DE EXTREMIDADES SUPERIORES"
  },
  {
    "codigo":870439000,
    "descripcion":"CON BAJA PROBABILIDAD DE HALLAR COINCIDENCIA CON DONANTE NO EMPARENTADO"
  },
  {
    "codigo":20306009,
    "descripcion":"FÍSTULA COLECISTOENTÉRICA"
  },
  {
    "codigo":282450009,
    "descripcion":"CONTUSIÓN DEL TABIQUE NASAL"
  },
  {
    "codigo":51239001,
    "descripcion":"MASOQUISMO SEXUAL"
  },
  {
    "codigo":1263655001,
    "descripcion":"METÁSTASIS DE CARCINOMA DE CÉLULAS TRANSICIONALES EN PELVIS RENAL DERECHA"
  },
  {
    "codigo":84007008,
    "descripcion":"CHOQUE DURANTE Y\/O LUEGO DEL TRABAJO DE PARTO Y\/O PARTO"
  },
  {
    "codigo":247847008,
    "descripcion":"MIEDO A LA OSCURIDAD"
  },
  {
    "codigo":442620006,
    "descripcion":"HALLAZGO RELACIONADO CON LA EVALUACIÓN DE ESPÉCIMEN DE VÓMITO"
  },
  {
    "codigo":373414000,
    "descripcion":"ESCLEROSIS NUCLEAR"
  },
  {
    "codigo":338981000119109,
    "descripcion":"ESCOTOMA PARACENTRAL IZQUIERDO"
  },
  {
    "codigo":78502005,
    "descripcion":"DIETA LIBRE DE LACTOSA"
  },
  {
    "codigo":111270009,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE LA CABEZA"
  },
  {
    "codigo":109435002,
    "descripcion":"ANOMALÍA CONGÉNITA DE LA FORMACIÓN DE LA CORONA Y LA RAÍZ DEL DIENTE"
  },
  {
    "codigo":699259004,
    "descripcion":"NEUROPATÍA DEBIDA A DEFICIENCIA DE VITAMINA B"
  },
  {
    "codigo":371579007,
    "descripcion":"SITIO DONANTE DE PIEL, VISIBLE"
  },
  {
    "codigo":402512000,
    "descripcion":"CARCINOMA BASOCELULAR DE ANTITRAGO"
  },
  {
    "codigo":240507007,
    "descripcion":"FIEBRE TRIVITTATUS"
  },
  {
    "codigo":271440004,
    "descripcion":"CIRROSIS SECUNDARIA A COLESTASIS"
  },
  {
    "codigo":238672005,
    "descripcion":"DERMATITIS ALÉRGICA POR CONTACTO LIQUENOIDE"
  },
  {
    "codigo":369744005,
    "descripcion":"CONFIGURACIÓN TUMORAL ANULAR"
  },
  {
    "codigo":304208009,
    "descripcion":"AMPLITUD DE MOVIMIENTO PASIVO DE EXTENSIÓN HORIZONTAL DE HOMBRO NORMAL"
  },
  {
    "codigo":7461003,
    "descripcion":"TRASTORNO DE HIPERACTIVIDAD CON DÉFICIT DE ATENCIÓN, CON PREDOMINIO DE HIPERACTIVIDAD-IMPULSIVIDAD"
  },
  {
    "codigo":1252645007,
    "descripcion":"CUIDADO POR PAREJA"
  },
  {
    "codigo":286041000119102,
    "descripcion":"LACERACIÓN MODERADA DE CORAZÓN CONCOMITANTE CON HEMOPERICARDIO"
  },
  {
    "codigo":15687001000119102,
    "descripcion":"SINOVITIS DE ARTICULACIÓN DE RODILLA IZQUIERDA"
  },
  {
    "codigo":202234001,
    "descripcion":"INESTABILIDAD CARPIANA CON INESTABILIDAD DE SEGMENTO PALMAR INTERCALADO"
  },
  {
    "codigo":38394007,
    "descripcion":"OTITIS MEDIA CRÓNICA PURULENTA"
  },
  {
    "codigo":366074007,
    "descripcion":"PREFERENCIA DE LA FIJACIÓN OCULAR - HALLAZGO"
  },
  {
    "codigo":235002009,
    "descripcion":"GRANULOMA PIOGÉNICO DE ENCÍA"
  },
  {
    "codigo":890362008,
    "descripcion":"CRIPTOFTALMÍA PARCIAL BILATERAL"
  },
  {
    "codigo":397007003,
    "descripcion":"TRASTORNO DE MASTOCITOS"
  },
  {
    "codigo":62131008,
    "descripcion":"ÚTERO DE COUVELAIRE"
  },
  {
    "codigo":429775004,
    "descripcion":"CONSUMO DE ALCOHOL QUE EXCEDE EL LÍMITE DIARIO RECOMENDADO"
  },
  {
    "codigo":298703007,
    "descripcion":"PRUEBA DEL HUNDIMIENTO NEGATIVA"
  },
  {
    "codigo":724687008,
    "descripcion":"TRASTORNO AMNÉSICO CAUSADO POR ANSIOLÍTICO"
  },
  {
    "codigo":296868002,
    "descripcion":"SOBREDOSIS DE TOLBUTAMIDA"
  },
  {
    "codigo":722852005,
    "descripcion":"LESIÓN TRAUMÁTICA DE IRRIGACIÓN VASCULAR DE INTESTINO DELGADO"
  },
  {
    "codigo":1148836006,
    "descripcion":"DISMINUCIÓN DE NEGLIGENCIA ESPACIAL"
  },
  {
    "codigo":721017000,
    "descripcion":"SÍNDROME DE POLIDACTILIA POSTAXIAL Y DISCAPACIDAD INTELECTUAL"
  },
  {
    "codigo":367961000119108,
    "descripcion":"ESTRECHEZ DE URETRA BULBOSA DE ORIGEN TRAUMÁTICO"
  },
  {
    "codigo":295033008,
    "descripcion":"ALERGIA A BETANIDINA"
  },
  {
    "codigo":719182002,
    "descripcion":"PETEQUIAS PERIFOLICULARES CUTÁNEAS"
  },
  {
    "codigo":293198002,
    "descripcion":"REACCIÓN ADVERSA A LA GLIQUIDONA"
  },
  {
    "codigo":162126005,
    "descripcion":"CHORRO MICCIONAL, NORMAL"
  },
  {
    "codigo":314675007,
    "descripcion":"PESO DEL NIÑO: PERCENTILO 10-24"
  },
  {
    "codigo":424270008,
    "descripcion":"LESIÓN TRAUMÁTICA CONTUSA DE LA ESPALDA"
  },
  {
    "codigo":31054009,
    "descripcion":"LITIASIS URETERAL"
  },
  {
    "codigo":29219000,
    "descripcion":"INTOXICACIÓN POR DESCURAINIA PINNATA"
  },
  {
    "codigo":94755004,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE VASO SANGUÍNEO"
  },
  {
    "codigo":782883004,
    "descripcion":"MIOPATÍA MIOFIBRILAR HIPERTÓNICA INFANTIL FATAL"
  },
  {
    "codigo":1208867006,
    "descripcion":"TROMBO VENTRICULAR POSTERIOR A INFARTO AGUDO DE MIOCARDIO"
  },
  {
    "codigo":225827005,
    "descripcion":"VÍCTIMA DE ABUSO FINANCIERO"
  },
  {
    "codigo":341491000119105,
    "descripcion":"DEGENERACIÓN DE CUERPO CILIAR DE OJO IZQUIERDO"
  },
  {
    "codigo":1010424001,
    "descripcion":"HIPERPLASIA DE APÓFISIS CORONOIDES DERECHA DE MANDÍBULA"
  },
  {
    "codigo":291363004,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR TEOFILINA"
  },
  {
    "codigo":92920006,
    "descripcion":"FORMA ANORMAL CONGÉNITA DEL ISQUION"
  },
  {
    "codigo":289528009,
    "descripcion":"INFLAMACIÓN DE INTROITO VAGINAL"
  },
  {
    "codigo":1078771000119108,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE OJO IZQUIERDO"
  },
  {
    "codigo":23714000,
    "descripcion":"VESTIBULITIS NASAL"
  },
  {
    "codigo":285858001,
    "descripcion":"NO MANEJA ENSERES DOMÉSTICOS"
  },
  {
    "codigo":253090002,
    "descripcion":"INFECCIÓN CAUSADA POR FUSARIUM SPOROTRICHIELLA"
  },
  {
    "codigo":254925008,
    "descripcion":"NEOPLASIA BENIGNA DE CÁLIZ RENAL"
  },
  {
    "codigo":1268898002,
    "descripcion":"OLIGOASTROCITOMA MIXTO PRIMARIO"
  },
  {
    "codigo":710007003,
    "descripcion":"MORFOLOGÍA ANORMAL DE DIENTE"
  },
  {
    "codigo":251255006,
    "descripcion":"INTERVALO PR INCLINADO"
  },
  {
    "codigo":87415007,
    "descripcion":"OSTEOMIELITIS DE LA MANDÍBULA"
  },
  {
    "codigo":314956000,
    "descripcion":"TENSIÓN ARTERIAL LIMÍTROFE"
  },
  {
    "codigo":446028001,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO DIGITAL DE MANO"
  },
  {
    "codigo":282188000,
    "descripcion":"NO BAJA UN ESCALÓN"
  },
  {
    "codigo":52812002,
    "descripcion":"TRACOMA, ESTADIO ACTIVO"
  },
  {
    "codigo":249420004,
    "descripcion":"SANGRADO GINGIVAL AL TOCAR CON UNA LANCETA"
  },
  {
    "codigo":247585004,
    "descripcion":"DIFICULTAD PARA TOMAR DECISIONES"
  },
  {
    "codigo":81910000,
    "descripcion":"SENSACIÓN DE CALOR EN EL OJO"
  },
  {
    "codigo":1359862000,
    "descripcion":"ABRASIÓN DE PELVIS"
  },
  {
    "codigo":16017191000119102,
    "descripcion":"ALTERACIÓN CRÓNICA DE ASTA POSTERIOR DE MENISCO INTERNO DE AMBAS RODILLAS"
  },
  {
    "codigo":737270004,
    "descripcion":"SENSACIÓN OCULAR ANORMAL"
  },
  {
    "codigo":49142006,
    "descripcion":"FIEBRE DEL BOSQUE SEMLIKI"
  },
  {
    "codigo":409590008,
    "descripcion":"ESCARA CUTÁNEA"
  },
  {
    "codigo":735435002,
    "descripcion":"NEUTROFILIA CONSTITUCIONAL"
  },
  {
    "codigo":1259723002,
    "descripcion":"GLIOBLASTOMA MULTIFORME PRIMARIO DE MÉDULA ESPINAL"
  },
  {
    "codigo":47307007,
    "descripcion":"TRASTORNO POR INHIBIDOR DEL FACTOR VIII"
  },
  {
    "codigo":16836391000119105,
    "descripcion":"EMBARAZO ECTÓPICO EN TROMPA DE FALOPIO IZQUIERDA"
  },
  {
    "codigo":209312000,
    "descripcion":"FRACTURA-LUXACIÓN EXPUESTA DE ARTICULACIÓN METACARPOFALÁNGICA"
  },
  {
    "codigo":733600007,
    "descripcion":"DEFECTO COMBINADO DE LA FOSFORILACIÓN OXIDATIVA TIPO 8"
  },
  {
    "codigo":698997000,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚLTIPLES VASOS SANGUÍNEOS DE LA CABEZA"
  },
  {
    "codigo":78240009,
    "descripcion":"PARO CARDÍACO POR FALLA DEL MARCAPASO"
  },
  {
    "codigo":404085001,
    "descripcion":"ANGIOMIXOMA AGRESIVO"
  },
  {
    "codigo":830069006,
    "descripcion":"TORSIÓN DE SINCONDROSIS ESFENOBASILAR"
  },
  {
    "codigo":11839271000119108,
    "descripcion":"DISTENSIÓN DE MÚSCULO INTRÍNSECO DE DEDO ANULAR DE MANO DERECHA"
  },
  {
    "codigo":1081281000119102,
    "descripcion":"OSTEOSARCOMA PRIMARIO DE HUESO DE PIE IZQUIERDO"
  },
  {
    "codigo":305781009,
    "descripcion":"VISTO POR FISIOTERAPEUTA EXTRAHOSPITALARIO"
  },
  {
    "codigo":238410003,
    "descripcion":"INTERTRIGO ESTAFILOCÓCICO"
  },
  {
    "codigo":288551000119109,
    "descripcion":"PROBLEMA EN LA RELACIÓN CON FAMILIARES POLÍTICOS"
  },
  {
    "codigo":402250007,
    "descripcion":"QUEILITIS ALÉRGICA POR CONTACTO"
  },
  {
    "codigo":7199000,
    "descripcion":"SÍNDROME DE ESCLEROSIS TUBEROSA"
  },
  {
    "codigo":433183000,
    "descripcion":"VEJIGA URINARIA NEUROGÉNICA DEBIDO A ACCIDENTE CEREBROVASCULAR Y POSTERIOR A ÉL"
  },
  {
    "codigo":302111002,
    "descripcion":"ILEOSTOMÍA, PRESENTE"
  },
  {
    "codigo":72735007,
    "descripcion":"PLEURITIS INTERLOBULAR"
  },
  {
    "codigo":105503008,
    "descripcion":"DEPENDENCIA DE LA SILLA DE RUEDAS"
  },
  {
    "codigo":1186847009,
    "descripcion":"HEMOCROMATOSIS TIPO 1"
  },
  {
    "codigo":236575009,
    "descripcion":"RECHAZO AGUDO DEL TRASPLANTE RENAL - GRADO I"
  },
  {
    "codigo":300276003,
    "descripcion":"AMÍGDALA PRESENTE"
  },
  {
    "codigo":201972000,
    "descripcion":"ARTRITIS ALÉRGICA DE MÚLTIPLES LOCALIZACIONES"
  },
  {
    "codigo":15744961000119106,
    "descripcion":"DEFORMIDAD DE AMBOS PIES DEBIDA A ARTRITIS REUMATOIDE"
  },
  {
    "codigo":71771000119100,
    "descripcion":"ARTROPATÍA NEUROPÁTICA DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":70900007,
    "descripcion":"FUNCIÓN DE EXCRECIÓN AUMENTADA"
  },
  {
    "codigo":365812005,
    "descripcion":"HALLAZGO RELACIONADO CON EL NIVEL DE GLUCEMIA"
  },
  {
    "codigo":429513001,
    "descripcion":"RUPTURA DE TENDÓN DE AQUILES"
  },
  {
    "codigo":3529000,
    "descripcion":"INFECCIÓN CAUSADA POR SANGUINICOLA"
  },
  {
    "codigo":5364006,
    "descripcion":"ÚTERO SUBTABICADO"
  },
  {
    "codigo":298441004,
    "descripcion":"AMPLITUD DE FLEXIÓN LATERAL ACTIVA HACIA LA IZQUIERDA DE LA COLUMNA VERTEBRAL CERVICAL, AUMENTADA"
  },
  {
    "codigo":724425005,
    "descripcion":"ACCIDENTE CEREBROVASCULAR ISQUÉMICO DEBIDO A ATEROSCLEROSIS DE GRAN ARTERIA INTRACRANEAL"
  },
  {
    "codigo":165534000,
    "descripcion":"RECUENTO DE LINFOCITOS FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":198302001,
    "descripcion":"ATROFIA ADQUIRIDA DE TROMPA DE FALOPIO"
  },
  {
    "codigo":36297009,
    "descripcion":"VAGINA TABICADA QUE AFECTA EL EMBARAZO"
  },
  {
    "codigo":296606003,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE NETILMICINA"
  },
  {
    "codigo":394910004,
    "descripcion":"MALFORMACIÓN CONGÉNITA DE PULGAR"
  },
  {
    "codigo":1694004,
    "descripcion":"LÓBULO ACCESORIO DEL PULMÓN"
  },
  {
    "codigo":722590007,
    "descripcion":"FRAGILIDAD CUTÁNEA DE LA PREMATUREZ"
  },
  {
    "codigo":1179507000,
    "descripcion":"ÁCIDO ORÓTICO DENTRO DE RANGO DE REFERENCIA"
  },
  {
    "codigo":294771002,
    "descripcion":"ALERGIA A CIPROTERONA"
  },
  {
    "codigo":720755009,
    "descripcion":"SÍNDROME DE DISINOSTOSIS CRANEOFACIAL"
  },
  {
    "codigo":718920001,
    "descripcion":"DISFUNCIÓN SOMÁTICA DE REGIÓN DORSOLUMBAR"
  },
  {
    "codigo":1343347009,
    "descripcion":"TRASTORNO BIPOLAR I, ACTUALMENTE EPISODIO HIPOMANÍACO"
  },
  {
    "codigo":15636571000119106,
    "descripcion":"DISFUNCIÓN SOMÁTICA DE ARTICULACIÓN SACROILÍACA DERECHA"
  },
  {
    "codigo":292936006,
    "descripcion":"REACCIÓN ADVERSA A LA ESPECTINOMICINA"
  },
  {
    "codigo":127261001,
    "descripcion":"NEOPLASIA DE LOS GANGLIOS LINFÁTICOS DEL MIEMBRO INFERIOR"
  },
  {
    "codigo":94493005,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA PLEURA"
  },
  {
    "codigo":225565007,
    "descripcion":"DOLOR PERINEAL"
  },
  {
    "codigo":1174002000,
    "descripcion":"CUERPO EXTRAÑO EN PARED ABDOMINAL ANTERIOR"
  },
  {
    "codigo":59890007,
    "descripcion":"LAGOFTALMOS PARALÍTICO"
  },
  {
    "codigo":90823000,
    "descripcion":"ECCEMA INFANTIL"
  },
  {
    "codigo":92658008,
    "descripcion":"CARCINOMA IN SITU DEL TERCIO MEDIO DEL ESÓFAGO"
  },
  {
    "codigo":254663002,
    "descripcion":"QUERATOACANTOMA SOLITARIO"
  },
  {
    "codigo":15937781000119104,
    "descripcion":"NEOPLASIA BENIGNA DE PIEL DE AMBOS OÍDOS"
  },
  {
    "codigo":1336007002,
    "descripcion":"GLAUCOMA DEBIDO A QUISTE DE IRIS DE OJO IZQUIERDO"
  },
  {
    "codigo":123591006,
    "descripcion":"NEUMONÍA CONFLUENTE"
  },
  {
    "codigo":449436000,
    "descripcion":"AURÍCULA IZQUIERDA DIVIDIDA CON DESEMBOCADURA DE ALGUNAS VENAS PULMONARES EN LA CÁMARA PROXIMAL Y DRENAJE EN LA AURÍCULA IZQUIERDA"
  },
  {
    "codigo":58055009,
    "descripcion":"INTOXICACIÓN POR CANTARIDINA"
  },
  {
    "codigo":1268636004,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS PRIMARIO DE INTESTINO DELGADO"
  },
  {
    "codigo":416668008,
    "descripcion":"EPIGLOTIS VISIBLE, CUERDAS VOCALES NO VISIBLES"
  },
  {
    "codigo":285596009,
    "descripcion":"LESIÓN DE PLEXO NERVIOSO PERIFÉRICO"
  },
  {
    "codigo":54385001,
    "descripcion":"EXANTEMA SÚBITO"
  },
  {
    "codigo":100751000119101,
    "descripcion":"TROMBOSIS VENOSA DEBIDA A DISPOSITIVO DE ACCESO VENOSO CENTRAL"
  },
  {
    "codigo":250993004,
    "descripcion":"ORIFICIO CIRCULAR DE VÁLVULA MITRAL"
  },
  {
    "codigo":283761005,
    "descripcion":"MORDEDURA DE PERRO EN EL TÓRAX"
  },
  {
    "codigo":87153008,
    "descripcion":"MICROLITIASIS ALVEOLAR PULMONAR"
  },
  {
    "codigo":314694002,
    "descripcion":"TALLA DEL NIÑO: PERCENTILO 26-49"
  },
  {
    "codigo":281926002,
    "descripcion":"FRACTURA DE LA APÓFISIS TRANSVERSA DE VÉRTEBRA DORSAL"
  },
  {
    "codigo":19782003,
    "descripcion":"HIPOESTESIA SEXUAL"
  },
  {
    "codigo":183622005,
    "descripcion":"SEGUIMIENTO EN 3 SEMANAS"
  },
  {
    "codigo":249158007,
    "descripcion":"PRESENTACIÓN A NIVEL DE LAS ESPINAS CIÁTICAS"
  },
  {
    "codigo":50715003,
    "descripcion":"APLASIA PURA DE LA SERIE ROJA"
  },
  {
    "codigo":1197595004,
    "descripcion":"TRASTORNO DE SANGRADO ASOCIADO A TROMBOMODULINA"
  },
  {
    "codigo":247323005,
    "descripcion":"TENSIÓN EN LA GARGANTA"
  },
  {
    "codigo":48880000,
    "descripcion":"HEMORRAGIA POSTCOITAL"
  },
  {
    "codigo":16112002,
    "descripcion":"FÍSTULA DEL ÚTERO A LA PARED ABDOMINAL"
  },
  {
    "codigo":442096005,
    "descripcion":"HALLAZGO RELACIONADO CON MEDICIÓN FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":81648008,
    "descripcion":"INTOXICACIÓN CAUSADA POR ACEITE DE CASTOR"
  },
  {
    "codigo":1259461000,
    "descripcion":"CARCINOMA ESCAMOSO PRIMARIO DE PULMÓN DERECHO"
  },
  {
    "codigo":866245002,
    "descripcion":"RÓTULA BAJA"
  },
  {
    "codigo":346511000119107,
    "descripcion":"EDEMA DE CÓRNEAS DE AMBOS OJOS CAUSADO POR USO DE LENTES DE CONTACTO"
  },
  {
    "codigo":18831000119107,
    "descripcion":"NEOPLASIA ENDOCRINA MÚLTIPLE BENIGNA TIPO 2A"
  },
  {
    "codigo":702405001,
    "descripcion":"TUMOR MALIGNO DE CÉLULAS DE LA GRANULOSA TESTICULAR"
  },
  {
    "codigo":473029006,
    "descripcion":"COMPLICACIÓN ASOCIADA CON IMPLANTE MAMARIO RELLENO CON GEL DE SILICONA"
  },
  {
    "codigo":735173007,
    "descripcion":"CHOQUE ANAFILÁCTICO"
  },
  {
    "codigo":15993231000119108,
    "descripcion":"QUERATITIS INTERSTICIAL BILATERAL DEBIDA A SÍFILIS CONGÉNITA"
  },
  {
    "codigo":276421009,
    "descripcion":"SECCIÓN TRAUMÁTICA DE TENDÓN FLEXOR LARGO - ZONA 1"
  },
  {
    "codigo":77978002,
    "descripcion":"VENA CAVA SUPERIOR IZQUIERDA PERSISTENTE"
  },
  {
    "codigo":733338003,
    "descripcion":"ESCOTOMA PERIFÉRICO AISLADO"
  },
  {
    "codigo":1083791000119109,
    "descripcion":"HEMOTÍMPANO BILATERAL"
  },
  {
    "codigo":241818005,
    "descripcion":"ENVENENAMIENTO DEBIDO A PICADURA DE GARRAPATA"
  },
  {
    "codigo":764271000,
    "descripcion":"ESTENOSIS DE AGUJERO VERTEBRAL"
  },
  {
    "codigo":403823001,
    "descripcion":"FIBROMA PERIUNGUEAL EN ESCLEROSIS TUBEROSA"
  },
  {
    "codigo":12442008,
    "descripcion":"INTOXICACIÓN POR TIOUREA"
  },
  {
    "codigo":1255791002,
    "descripcion":"LINFOMA DE HODGKIN, VARIANTE ESCLEROSIS NODULAR DE GANGLIOS LINFÁTICOS DE CABEZA Y CUELLO"
  },
  {
    "codigo":305519004,
    "descripcion":"BAJO ATENCIÓN DE PSIQUIATRA ESPECIALISTA EN REHABILITACIÓN"
  },
  {
    "codigo":239983005,
    "descripcion":"SÍNDROME DE PELLIZCAMIENTO DE LA MUÑECA"
  },
  {
    "codigo":12198441000119105,
    "descripcion":"CONTRACTURA DE MAMA IZQUIERDA POSTERIOR A INSERCIÓN DE IMPLANTE MAMARIO"
  },
  {
    "codigo":762436001,
    "descripcion":"LESIÓN TRAUMÁTICA DE CORTEZA VISUAL IZQUIERDA"
  },
  {
    "codigo":269081000,
    "descripcion":"FRACTURA EXPUESTA DE HÚMERO DISTAL"
  },
  {
    "codigo":761000221103,
    "descripcion":"ENFERMEDAD FEBRIL EXANTEMÁTICA"
  },
  {
    "codigo":400153009,
    "descripcion":"FIBROMATOSIS AGRESIVA DE ABDOMEN"
  },
  {
    "codigo":1119214002,
    "descripcion":"DOLOR A LA PALPACIÓN EN REGIÓN LUMBAR DERECHA DEL DORSO"
  },
  {
    "codigo":5102002,
    "descripcion":"AGENESIA DEL CUERPO CALLOSO"
  },
  {
    "codigo":398318005,
    "descripcion":"GANGRENA DE FOURNIER"
  },
  {
    "codigo":365550006,
    "descripcion":"CIRCUNSTANCIAS FINANCIERAS - HALLAZGO"
  },
  {
    "codigo":237875007,
    "descripcion":"AMILOIDOSIS NO HEREDITARIA LOCALIZADA"
  },
  {
    "codigo":234478007,
    "descripcion":"SÍNDROME DE PLAQUETAS GIGANTES"
  },
  {
    "codigo":168942008,
    "descripcion":"AORTOGRAFÍA ABDOMINAL NORMAL"
  },
  {
    "codigo":298179002,
    "descripcion":"HALLAZGO RELACIONADO CON LA MOVILIDAD ARTICULAR"
  },
  {
    "codigo":10861251000119104,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO CIÁTICO DERECHO"
  },
  {
    "codigo":296344001,
    "descripcion":"SOBREDOSIS INTENCIONAL DE BLOQUEANTE BETADRENÉRGICO"
  },
  {
    "codigo":230808006,
    "descripcion":"OBSTRUCCIÓN DE LA DERIVACIÓN VENTRICULAR CEREBRAL"
  },
  {
    "codigo":425581000,
    "descripcion":"RESISTENCIA FARMACOLÓGICA A TRATAMIENTO ANTIRRETROVIRAL"
  },
  {
    "codigo":294509002,
    "descripcion":"ALERGIA A PIVAMPICILINA"
  },
  {
    "codigo":720493003,
    "descripcion":"LIQUEN PLANO ATRÓFICO ANULAR"
  },
  {
    "codigo":65133002,
    "descripcion":"ESCOTOMA FISIOLÓGICO"
  },
  {
    "codigo":423746001,
    "descripcion":"ADENOCARCINOMA DE PELVIS"
  },
  {
    "codigo":816962002,
    "descripcion":"RETINOPATÍA PROLIFERATIVA TRATADA ESTABLE DE OJO IZQUIERDO DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":290839005,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR IPRINDOL"
  },
  {
    "codigo":716823006,
    "descripcion":"COMPLEJO NOCARDIA ABSCESSUS O NOCARDIA EXALBIDA"
  },
  {
    "codigo":126999006,
    "descripcion":"NEOPLASIA DE LOS NERVIOS PERIFÉRICOS DE LA ESCLERÓTICA"
  },
  {
    "codigo":94231008,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE BRONQUIO DE LÓBULO MEDIO DE PULMÓN DERECHO"
  },
  {
    "codigo":714988001,
    "descripcion":"INCAPAZ DE EMPUJAR CON MIEMBRO INFERIOR"
  },
  {
    "codigo":289004002,
    "descripcion":"DIFICULTAD PARA ALIMENTARSE"
  },
  {
    "codigo":92396002,
    "descripcion":"NEOPLASIA BENIGNA DE PARTES BLANDAS DE LA PELVIS"
  },
  {
    "codigo":1335745000,
    "descripcion":"ENCEFALOPATÍA POSTERIOR A RADIOTERAPIA"
  },
  {
    "codigo":254401006,
    "descripcion":"NEOPLASIA DE FRENILLO DE LABIO INFERIOR"
  },
  {
    "codigo":449174000,
    "descripcion":"HEMANGIOMA DE PERITONEO"
  },
  {
    "codigo":283499002,
    "descripcion":"HERIDA PUNZANTE DE CABEZA"
  },
  {
    "codigo":54123004,
    "descripcion":"DIETA HIPOSÓDICA, 40 MILIEQUIVALENTES"
  },
  {
    "codigo":248896000,
    "descripcion":"PRODUCTOS DE LA CONCEPCIÓN EN VAGINA"
  },
  {
    "codigo":52288003,
    "descripcion":"INFECCIÓN CAUSADA POR CITTOTAENIA"
  },
  {
    "codigo":412736006,
    "descripcion":"MUTACIÓN DEL GEN BRCA1 NEGATIVA"
  },
  {
    "codigo":314432007,
    "descripcion":"INTÉRPRETE AUSENTE"
  },
  {
    "codigo":247061002,
    "descripcion":"OPACIDADES POLICROMÁTICAS POSTERIORES SUBCAPSULARES DE CRISTALINO"
  },
  {
    "codigo":1197333008,
    "descripcion":"VERRUGA VULGAR DE PÁRPADO"
  },
  {
    "codigo":132241000119103,
    "descripcion":"TROMBOSIS VENOSA PROFUNDA AGUDA DE PANTORRILLA"
  },
  {
    "codigo":767679000,
    "descripcion":"HERNIA INGUINAL DERECHA RECURRENTE"
  },
  {
    "codigo":212458009,
    "descripcion":"LESIÓN MUSCULAR Y TENDINOSA NIVEL DEL ANTEBRAZO"
  },
  {
    "codigo":472767006,
    "descripcion":"TROMBO DE AURÍCULA IZQUIERDA FISIOLÓGICA COMO COMPLICACIÓN DE PROCEDIMIENTO"
  },
  {
    "codigo":208788000,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN DE CODO, EXTERNA"
  },
  {
    "codigo":307092002,
    "descripcion":"TRICOFAGIA NOCTURNA HABITUAL"
  },
  {
    "codigo":77716004,
    "descripcion":"TESAURISMOSIS DEL PULMÓN"
  },
  {
    "codigo":239721001,
    "descripcion":"MENISCO DE RODILLA DISCOIDE CONGÉNITO"
  },
  {
    "codigo":10345003,
    "descripcion":"SÍFILIS PRIMARIA DE LAS AMÍGDALAS"
  },
  {
    "codigo":403561007,
    "descripcion":"LESIÓN CUTÁNEA POR ESPINA BÍFIDA"
  },
  {
    "codigo":74046003,
    "descripcion":"ÚLCERA CRÓNICA DE PENE"
  },
  {
    "codigo":8510008,
    "descripcion":"MOVILIDAD DISMINUIDA"
  },
  {
    "codigo":237886009,
    "descripcion":"HIPERCALCIURIA IDIOPÁTICA FAMILIAR"
  },
  {
    "codigo":72211003,
    "descripcion":"GRANULOMA DE LA LARINGE"
  },
  {
    "codigo":1055251004,
    "descripcion":"AGENESIA DE EPÍFISIS DE FALANGE MEDIA DE DEDO ÍNDICE"
  },
  {
    "codigo":40071000087102,
    "descripcion":"FRACTURA DE MALÉOLO MEDIAL IZQUIERDO"
  },
  {
    "codigo":234216000,
    "descripcion":"FALLA DE GENERADOR DE PULSOS DE MARCAPASOS"
  },
  {
    "codigo":299752002,
    "descripcion":"REFLEJO DE CHUPETEO DUDOSO"
  },
  {
    "codigo":42631000087107,
    "descripcion":"HERIDA PUNZANTE DE REGIÓN DE RODILLA DERECHA CON CUERPO EXTRAÑO"
  },
  {
    "codigo":398056004,
    "descripcion":"ANOMALÍA TRANSITORIA CON RECUPERACIÓN TOTAL"
  },
  {
    "codigo":47751000087106,
    "descripcion":"FRACTURA DE SEXTA COSTILLA IZQUIERDA"
  },
  {
    "codigo":266984006,
    "descripcion":"EN EDUCACIÓN ADICIONAL"
  },
  {
    "codigo":168680007,
    "descripcion":"RADIOGRAFÍA SIMPLE DE ARTICULACIÓN DE TOBILLO ANORMAL"
  },
  {
    "codigo":37608008,
    "descripcion":"HIPOVENTILACIÓN AGUDA"
  },
  {
    "codigo":365288009,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA DESCARGAR EL INODORO"
  },
  {
    "codigo":232381002,
    "descripcion":"AGENESIA DE LOS CARTÍLAGOS NASALES"
  },
  {
    "codigo":70376007,
    "descripcion":"INFECCIÓN CAUSADA POR RODENTIBACTER PNEUMOTROPICUS"
  },
  {
    "codigo":723901004,
    "descripcion":"TRASTORNO DELIRANTE ACTUALMENTE EN REMISIÓN COMPLETA"
  },
  {
    "codigo":679211000119106,
    "descripcion":"DEGENERACIÓN MARGINAL DE TERRIEN DE CÓRNEA PERIFÉRICA DE AMBOS OJOS"
  },
  {
    "codigo":11820331000119108,
    "descripcion":"LUXACIÓN TRAUMÁTICA POSTERIOR NO EXPUESTA DE ARTICULACIÓN ESCAPULOHUMERAL IZQUIERDA"
  },
  {
    "codigo":363453008,
    "descripcion":"NEOPLASIA MALIGNA DE CORDÓN ESPERMÁTICO"
  },
  {
    "codigo":722066001,
    "descripcion":"TRICROMACIA OLIGOCÓNICA"
  },
  {
    "codigo":1344658003,
    "descripcion":"TÍTULO DE ASOCIADO ALCANZADO"
  },
  {
    "codigo":230546006,
    "descripcion":"PARÁLISIS FAMILIAR DEL NERVIO FACIAL"
  },
  {
    "codigo":458087008,
    "descripcion":"PARÁPAGOS BICÉFALOS"
  },
  {
    "codigo":292412001,
    "descripcion":"REACCIÓN ADVERSA AL METILFENIDATO"
  },
  {
    "codigo":294247008,
    "descripcion":"ALERGIA A NONOXINOL"
  },
  {
    "codigo":194108002,
    "descripcion":"HETEROTROPÍA VERTICAL CONSTANTE"
  },
  {
    "codigo":95804005,
    "descripcion":"SECRECIÓN PURULENTA DESDE EL CONDUCTO AUDITIVO EXTERNO"
  },
  {
    "codigo":1144380009,
    "descripcion":"ATROFIA DE HILIO DE NÚCLEO DENTADO"
  },
  {
    "codigo":944361000000106,
    "descripcion":"CAPAZ DE MANTENER ROLES VITALES"
  },
  {
    "codigo":126737003,
    "descripcion":"NEOPLASIA DE GRANDES VASOS"
  },
  {
    "codigo":93969002,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL MEDIASTINO POSTERIOR"
  },
  {
    "codigo":1306385001,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE CUADRANTE SUPERIOR INTERNO DE MAMA"
  },
  {
    "codigo":225041002,
    "descripcion":"HABLA SOBRE EL PASADO"
  },
  {
    "codigo":11793861000119107,
    "descripcion":"AMPOLLA TRAUMÁTICA DE TOBILLO DERECHO"
  },
  {
    "codigo":419814004,
    "descripcion":"ALERGIA A ACEITE DE COCO"
  },
  {
    "codigo":92134005,
    "descripcion":"NEOPLASIA BENIGNA DEL HILIO PULMONAR"
  },
  {
    "codigo":288742009,
    "descripcion":"DIFICULTAD PARA EMPLEAR LA AUTOEXPRESIÓN"
  },
  {
    "codigo":1237179007,
    "descripcion":"SÍNDROME FG TIPO 1"
  },
  {
    "codigo":254139009,
    "descripcion":"DISPLASIA OCULODENTOÓSEA - LEVE"
  },
  {
    "codigo":711056007,
    "descripcion":"DOLOR FANTASMA POSTERIOR A AMPUTACIÓN DE PENE"
  },
  {
    "codigo":283237004,
    "descripcion":"VIDRIO EN LABIO"
  },
  {
    "codigo":84794000,
    "descripcion":"APRAXIA AMNÉSICA"
  },
  {
    "codigo":248634003,
    "descripcion":"ELEVACIÓN LENTA DEL PULSO"
  },
  {
    "codigo":681721000119103,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE CABEZA DE PÁNCREAS"
  },
  {
    "codigo":445242006,
    "descripcion":"HUESO ODONTOIDEO"
  },
  {
    "codigo":707386008,
    "descripcion":"CARCINOMA PRIMARIO DE CÉLULAS ACINARES DE TRÁQUEA"
  },
  {
    "codigo":19258009,
    "descripcion":"PLACENTA EXTRACORAL"
  },
  {
    "codigo":1231674009,
    "descripcion":"IMPLANTE EPIRRETINIANO IN SITU"
  },
  {
    "codigo":82959004,
    "descripcion":"DEMENCIA PARALÍTICA JUVENIL"
  },
  {
    "codigo":310500000,
    "descripcion":"DIETA BUENA"
  },
  {
    "codigo":246799009,
    "descripcion":"INCLINACIÓN ASCENDENTE DE HENDIDURA PALPEBRAL"
  },
  {
    "codigo":354041000119106,
    "descripcion":"NEOPLASIA BENIGNA DE HUESO LARGO DE MIEMBRO INFERIOR DERECHO"
  },
  {
    "codigo":1091321000119106,
    "descripcion":"TRASTORNO DE MEMBRANA TIMPÁNICA DERECHA"
  },
  {
    "codigo":210361004,
    "descripcion":"HERIDA ABIERTA DE LA ENCÍA"
  },
  {
    "codigo":11822841000119108,
    "descripcion":"ABRASIÓN DE PIEL DE AXILA DERECHA"
  },
  {
    "codigo":13753008,
    "descripcion":"ESPASMO HEMIFACIAL"
  },
  {
    "codigo":208526001,
    "descripcion":"FRACTURA NO EXPUESTA DE CABEZA DE FÉMUR"
  },
  {
    "codigo":110222005,
    "descripcion":"QUEMADURA DEL PALADAR BLANDO"
  },
  {
    "codigo":700046006,
    "descripcion":"CARIES DENTAL QUE SE EXTIENDE HASTA LA PULPA"
  },
  {
    "codigo":863886005,
    "descripcion":"CON ELEVADO RIESGO DE ÚLCERA DE PIE IZQUIERDO DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":763747002,
    "descripcion":"ANEURISMA CONGÉNITO DE PORCIÓN MEMBRANOSA DE TABIQUE INTERVENTRICULAR"
  },
  {
    "codigo":403299004,
    "descripcion":"UÑA EN VIDRIO DE RELOJ ASOCIADA CON TRASTORNO SISTÉMICO"
  },
  {
    "codigo":1156963006,
    "descripcion":"MIELOPATÍA DEBIDA A ESPONDILOSIS CERVICAL"
  },
  {
    "codigo":1255267007,
    "descripcion":"POLIDACTILIA DE IMAGEN ESPECULAR"
  },
  {
    "codigo":270392000,
    "descripcion":"ENFERMEDAD INFECCIOSA DECLARADA AL MÉDICO COMUNITARIO"
  },
  {
    "codigo":41016007,
    "descripcion":"SUEÑO CREPUSCULAR"
  },
  {
    "codigo":203021000,
    "descripcion":"ABSCESO DE MÚSCULO DE ESPALDA"
  },
  {
    "codigo":73784008,
    "descripcion":"TEJIDO RESECADO QUIRÚRGICAMENTE"
  },
  {
    "codigo":792845002,
    "descripcion":"CLAUDICACIÓN INTERMITENTE DEBIDA A ATEROSCLEROSIS DE ARTERIA DE EXTREMIDAD"
  },
  {
    "codigo":237624007,
    "descripcion":"HIPERGLUCEMIA POR ESTRÉS METABÓLICO"
  },
  {
    "codigo":301325005,
    "descripcion":"HALLAZGO RELACIONADO CON EL NIVEL GENERAL DE ENERGÍA"
  },
  {
    "codigo":39181008,
    "descripcion":"NEUROPATÍA DE PLEXO RADICULAR DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":168418000,
    "descripcion":"EXTENDIDO CERVICAL: CANDIDA"
  },
  {
    "codigo":365026002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA HACER INSPIRACIONES PROFUNDAS"
  },
  {
    "codigo":725474003,
    "descripcion":"CLOSTRIDIUM BOLTEAE O CLOSTRIDIUM CLOSTRIDIOFORME"
  },
  {
    "codigo":102882004,
    "descripcion":"SECRECIÓN PLACENTARIA ANORMAL DE GONADOTROFINA CORIÓNICA"
  },
  {
    "codigo":233954004,
    "descripcion":"HIPERTENSIÓN PULMONAR CAUSADA POR BAJA PRESIÓN DE AIRE DEBIDA A EXPOSICIÓN CRÓNICA A ALTITUD ELEVADA"
  },
  {
    "codigo":1216994006,
    "descripcion":"INFECCIÓN CORNEAL RECURRENTE POR VIRUS DE HERPES SIMPLE HUMANO"
  },
  {
    "codigo":232119000,
    "descripcion":"MIDRIASIS POR DEFECTO DE INERVACIÓN"
  },
  {
    "codigo":299490009,
    "descripcion":"AMPLITUD DE PRONACIÓN ACTIVA MEDIOTARSIANA DISMINUIDA"
  },
  {
    "codigo":166583007,
    "descripcion":"PROTEÍNA C REACTIVA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":789175008,
    "descripcion":"ACIDEZ DE HECES POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":721804002,
    "descripcion":"INFECCIÓN DE PULMÓN CAUSADA POR PNEUMOCYSTIS"
  },
  {
    "codigo":295820003,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE AMANTADINA"
  },
  {
    "codigo":230284004,
    "descripcion":"ENCEFALOPATÍA ESPONGIFORME"
  },
  {
    "codigo":263052006,
    "descripcion":"SUBLUXACIÓN DE ARTICULACIÓN DE CODO"
  },
  {
    "codigo":31841001,
    "descripcion":"NECROSIS HEMORRÁGICA DE INTESTINO"
  },
  {
    "codigo":55341000119107,
    "descripcion":"DEFICIENCIA DE CARNITINA DEBIDA A ERROR INNATO DEL METABOLISMO"
  },
  {
    "codigo":195681001,
    "descripcion":"LARINGITIS ULCEROSA AGUDA"
  },
  {
    "codigo":293985005,
    "descripcion":"ALERGIA A ANTAGONISTA DE RECEPTOR ADRENÉRGICO ALFA"
  },
  {
    "codigo":292150000,
    "descripcion":"REACCIÓN ADVERSA A LA MEBEVERINA"
  },
  {
    "codigo":62774004,
    "descripcion":"DILATACIÓN CERVICAL, 9CM"
  },
  {
    "codigo":128310007,
    "descripcion":"DENSIDAD RADIOLÓGICA DISMINUIDA"
  },
  {
    "codigo":10678471000119104,
    "descripcion":"TUMEFACCIÓN LOCALIZADA DE PIE IZQUIERDO"
  },
  {
    "codigo":93707007,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE VASO SANGUÍNEO DEL HUECO POPLÍTEO"
  },
  {
    "codigo":716299008,
    "descripcion":"RETENCIÓN DE DISPOSITIVO DENTAL EN DIENTE DESPUÉS DE PROCEDIMIENTO ODONTOLÓGICO"
  },
  {
    "codigo":28171008,
    "descripcion":"INFECCIÓN CAUSADA POR COOPERIA"
  },
  {
    "codigo":91872004,
    "descripcion":"AUSENCIA CONGÉNITA DEL CALCÁNEO"
  },
  {
    "codigo":124640005,
    "descripcion":"DEFICIENCIA DE ALDEHÍDO - LIASA"
  },
  {
    "codigo":26336006,
    "descripcion":"ALBINISMO OCULOCUTÁNEO TIROSINASA POSITIVO"
  },
  {
    "codigo":714464009,
    "descripcion":"SÍNDROME INFLAMATORIO DE RECONSTITUCIÓN INMUNOLÓGICA CAUSADO POR INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":384949003,
    "descripcion":"CÁLCULO = CISTINA"
  },
  {
    "codigo":417717006,
    "descripcion":"PSEUDOEXOTROPÍA"
  },
  {
    "codigo":88202002,
    "descripcion":"ALTERACIÓN EN LA NUTRICIÓN: CONSUMO INSUFICIENTE PARA LOS REQUERIMIENTOS CORPORALES"
  },
  {
    "codigo":219274002,
    "descripcion":"LESIÓN POR INTERVENCIÓN LEGAL CON OBJETO CONTUNDENTE"
  },
  {
    "codigo":284810003,
    "descripcion":"INCAPAZ DE SENTARSE EN LA BAÑERA"
  },
  {
    "codigo":448650009,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE ESCROTO Y TESTÍCULO"
  },
  {
    "codigo":186506009,
    "descripcion":"VACUNA Y PARAVACUNA"
  },
  {
    "codigo":282975004,
    "descripcion":"CAPAZ DE DOBLARSE"
  },
  {
    "codigo":1003871005,
    "descripcion":"DISOMÍA UNIPARENTAL DE ORIGEN PATERNO DEL CROMOSOMA 15"
  },
  {
    "codigo":53599007,
    "descripcion":"SÍNDROME DE REGRESIÓN TESTICULAR"
  },
  {
    "codigo":248372000,
    "descripcion":"CRÁNEO ASIMÉTRICO"
  },
  {
    "codigo":15731041000119105,
    "descripcion":"PARÁLISIS TOTAL DE NERVIO OCULOMOTOR DERECHO"
  },
  {
    "codigo":1264180005,
    "descripcion":"PIERCING EN TERCIO DERECHO DE LABIO SUPERIOR"
  },
  {
    "codigo":444980006,
    "descripcion":"ATROFIA OLIVOPONTOCEREBELOSA ESPORÁDICA"
  },
  {
    "codigo":11854331000119100,
    "descripcion":"LACERACIÓN DE MÚSCULO INTRÍNSECO DE PIE IZQUIERDO"
  },
  {
    "codigo":82697002,
    "descripcion":"INFECCIÓN CAUSADA POR SCHISTOSOMA NASALIS"
  },
  {
    "codigo":49929007,
    "descripcion":"INTOXICACIÓN POR COLECALCIFEROL"
  },
  {
    "codigo":1293278005,
    "descripcion":"DERRAME DE ARTICULACIÓN RADIOCARPIANA IZQUIERDA"
  },
  {
    "codigo":80862006,
    "descripcion":"ANERGIA CLONAL"
  },
  {
    "codigo":441310006,
    "descripcion":"CAPAZ DE RECONOCER NÚMEROS"
  },
  {
    "codigo":898227001,
    "descripcion":"SINOSTOSIS CONGÉNITA DE FALANGE PROXIMAL DE DEDO PULGAR CON PRIMER HUESO METACARPIANO"
  },
  {
    "codigo":15326009,
    "descripcion":"TALASEMIA BETA^+^, HB A>2< NORMAL, TIPO 2"
  },
  {
    "codigo":11304481000119100,
    "descripcion":"FRACTURA EXPUESTA DE SENO FRONTAL"
  },
  {
    "codigo":309281000119101,
    "descripcion":"NECROSIS AVASCULAR DE HUESO DE REGIÓN DE TOBILLO DERECHO"
  },
  {
    "codigo":150561000119100,
    "descripcion":"TRASTORNO DE TROMPA DE FALOPIO Y OVARIO"
  },
  {
    "codigo":688161000119100,
    "descripcion":"NEURILEMOMA DE NERVIO DE MIEMBRO INFERIOR"
  },
  {
    "codigo":1074721000119101,
    "descripcion":"ARTRITIS DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":15733281000119105,
    "descripcion":"QUISTE PRIMARIO DE RETINA DERECHA"
  },
  {
    "codigo":11790881000119106,
    "descripcion":"LESIÓN TRAUMÁTICA DE MUSLO DERECHO"
  },
  {
    "codigo":15746081000119107,
    "descripcion":"INESTABILIDAD DE ARTICULACIÓN DE CODO DERECHO"
  },
  {
    "codigo":15692321000119108,
    "descripcion":"ARTRITIS BILATERAL DE PRIMERAS ARTICULACIONES METATARSOFALÁNGICAS"
  },
  {
    "codigo":10953761000119109,
    "descripcion":"HERIDA ABIERTA DE ANTEBRAZO DERECHO DEBIDA A MORDEDURA DE GATO"
  },
  {
    "codigo":15920161000119108,
    "descripcion":"REACCIÓN ALÉRGICA CAUSADA POR PROTEÍNA DE HUEVO"
  },
  {
    "codigo":15697441000119106,
    "descripcion":"ABSCESO SUBPERIÓSTICO DE ÓRBITA DE OJO IZQUIERDO"
  },
  {
    "codigo":15743521000119108,
    "descripcion":"DOLOR CRÓNICO DE MIEMBRO SUPERIOR DERECHO"
  },
  {
    "codigo":15707681000119107,
    "descripcion":"DEGENERACIÓN CALCÁREA DE CÓRNEA DE OJO DERECHO"
  },
  {
    "codigo":301601000119108,
    "descripcion":"ABSCESO DE VAINA TENDINOSA DE MUSLO IZQUIERDO"
  },
  {
    "codigo":32801000119106,
    "descripcion":"ENFERMEDAD INFECCIOSA EN LA MADRE QUE COMPLICA EL NACIMIENTO"
  },
  {
    "codigo":15676961000119107,
    "descripcion":"MIOSITIS DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":337441000119109,
    "descripcion":"MACULOPATÍA TÓXICA IZQUIERDA"
  },
  {
    "codigo":239197001,
    "descripcion":"PÉRDIDA DEL COLGAJO DE ESPESOR TOTAL"
  },
  {
    "codigo":372104008,
    "descripcion":"CARCINOMA DE SUBGLOTIS"
  },
  {
    "codigo":403037009,
    "descripcion":"TIÑA CORPORAL CAUSADA POR TRICHOPHYTON PERSICOLOR"
  },
  {
    "codigo":11772411000119109,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXTERNA NO EXPUESTA DE CODO IZQUIERDO"
  },
  {
    "codigo":827186009,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE PIEL DE CADERA Y PIEL DE PIERNA"
  },
  {
    "codigo":38919006,
    "descripcion":"AUSENCIA CONGÉNITA DE PABELLÓN AURICULAR CON ATRESIA DE CONDUCTO AUDITIVO"
  },
  {
    "codigo":233692000,
    "descripcion":"EOSINOFILIA PULMONAR CRIPTOGÉNICA"
  },
  {
    "codigo":169991009,
    "descripcion":"ALIMENTADO ARTIFICIALMENTE A LOS 9 MESES"
  },
  {
    "codigo":364764003,
    "descripcion":"HALLAZGO RELACIONADO CON EL UMBRAL DE DOLOR"
  },
  {
    "codigo":4316006,
    "descripcion":"MIOMETRITIS"
  },
  {
    "codigo":15979311000119100,
    "descripcion":"OTITIS MEDIA SUPURATIVA CRÓNICA BILATERAL"
  },
  {
    "codigo":299228008,
    "descripcion":"TORSIÓN TIBIAL INTERNA"
  },
  {
    "codigo":200924009,
    "descripcion":"ERITEMA VESICULOSO"
  },
  {
    "codigo":68017002,
    "descripcion":"CUERPO EXTRAÑO EN EL APARATO GENITOURINARIO"
  },
  {
    "codigo":4911000119101,
    "descripcion":"ÚLCERA ANTRAL"
  },
  {
    "codigo":231857004,
    "descripcion":"CONJUNTIVITIS PAPILAR GIGANTE"
  },
  {
    "codigo":788913001,
    "descripcion":"DEGENERACIÓN MACULAR TEMPRANA RELACIONADA CON LA EDAD"
  },
  {
    "codigo":1149361009,
    "descripcion":"PARO CARDÍACO DEBIDO A PROCEDIMIENTO"
  },
  {
    "codigo":262790002,
    "descripcion":"HEMATOMA ESOFÁGICO"
  },
  {
    "codigo":721542002,
    "descripcion":"ERUPCIÓN AMPOLLAR CUTÁNEA AGUDA"
  },
  {
    "codigo":361094004,
    "descripcion":"DEFICIENCIA DE TIRAMINASA"
  },
  {
    "codigo":11827861000119109,
    "descripcion":"SUBLUXACIÓN DE ARTICULACIÓN DE CADERA IZQUIERDA"
  },
  {
    "codigo":230022005,
    "descripcion":"POSICIÓN DE TRONCO: INCLINACIÓN HACIA ADELANTE CON APOYO"
  },
  {
    "codigo":295558006,
    "descripcion":"SOBREDOSIS DE PRILOCAÍNA"
  },
  {
    "codigo":646009,
    "descripcion":"QUISTE IDIOPÁTICO DE LA CÁMARA ANTERIOR"
  },
  {
    "codigo":719707001,
    "descripcion":"ÁCIDO DESOXIRRIBONUCLEICO DE SALMONELLA NO DETECTADO"
  },
  {
    "codigo":293723005,
    "descripcion":"ALERGIA A COCAÍNA"
  },
  {
    "codigo":424795008,
    "descripcion":"MIOTONÍA NO DISTRÓFICA"
  },
  {
    "codigo":10736431000119105,
    "descripcion":"FIBROSIS DE MAMA DERECHA"
  },
  {
    "codigo":291888002,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR SUCEDÁNEO DE LA SANGRE MACROMOLECULAR"
  },
  {
    "codigo":95280005,
    "descripcion":"LEIOMIOMA SUBSEROSO DEL ÚTERO"
  },
  {
    "codigo":160816008,
    "descripcion":"SE DECLARA CULPABLE"
  },
  {
    "codigo":128048008,
    "descripcion":"TRASTORNO DEL ILION"
  },
  {
    "codigo":717872008,
    "descripcion":"DUODENITIS ALÉRGICA"
  },
  {
    "codigo":224517000,
    "descripcion":"SIN DISPONIBILIDAD DE TRANSPORTE PARA EL CUIDADOR"
  },
  {
    "codigo":93445007,
    "descripcion":"ESTENOSIS SUBAÓRTICA DINÁMICA"
  },
  {
    "codigo":290053009,
    "descripcion":"MAMA PRESENTE"
  },
  {
    "codigo":124378001,
    "descripcion":"DEFICIENCIA DE TRANSCARBOXILASA"
  },
  {
    "codigo":10955721000119103,
    "descripcion":"HERIDA PUNZANTE DE DEDO MEÑIQUE IZQUIERDO"
  },
  {
    "codigo":288218006,
    "descripcion":"RUPTURA DE TENDÓN - CADERA"
  },
  {
    "codigo":1269423000,
    "descripcion":"ADRENOMIELONEUROPATÍA"
  },
  {
    "codigo":286383001,
    "descripcion":"NO ENCUENTRA LAS PALABRAS"
  },
  {
    "codigo":253615009,
    "descripcion":"ANOMALÍAS AÓRTICAS EXCLUIDO COARTACIÓN"
  },
  {
    "codigo":384687009,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA NO AFECTADO POR CARCINOMA DUCTAL IN SITU"
  },
  {
    "codigo":251780005,
    "descripcion":"HIPERACOMODACIÓN OCULAR"
  },
  {
    "codigo":689251000119101,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE PARED POSTERIOR DE LA NASOFARINGE"
  },
  {
    "codigo":315481003,
    "descripcion":"NACIDO EN MÓNACO"
  },
  {
    "codigo":53337006,
    "descripcion":"ÚLCERA GÁSTRICA AGUDA CON HEMORRAGIA, PERFORACIÓN Y OBSTRUCCIÓN"
  },
  {
    "codigo":249945007,
    "descripcion":"MONOPARESIA DE MIEMBRO INFERIOR"
  },
  {
    "codigo":282713007,
    "descripcion":"DIFICULTAD PARA EMPUJAR Y ARRASTRAR HACIA ADELANTE UN JUGUETE PEQUEÑO CON RUEDAS"
  },
  {
    "codigo":444718001,
    "descripcion":"AGRANDAMIENTO BILATERAL DE AURÍCULAS"
  },
  {
    "codigo":1231150005,
    "descripcion":"HIPOPLASIA FOVEAL AISLADA"
  },
  {
    "codigo":1296686009,
    "descripcion":"DOLOR MUSCULAR DE INICIO RETARDADO"
  },
  {
    "codigo":770563005,
    "descripcion":"DISOMÍA UNIPARENTAL MATERNA DEL CROMOSOMA 13"
  },
  {
    "codigo":279043006,
    "descripcion":"DOLOR DE GLÚTEO"
  },
  {
    "codigo":33891000119105,
    "descripcion":"TAPÓN MUCOSO EN VÍAS RESPIRATORIAS"
  },
  {
    "codigo":80600003,
    "descripcion":"SUPURACIÓN AGUDA DE SENO NASAL"
  },
  {
    "codigo":703192005,
    "descripcion":"ESTENOSIS DE VÁLVULA PULMONAR POSTERIOR A PROCEDIMIENTO"
  },
  {
    "codigo":1293016006,
    "descripcion":"DELIRIO DE SER CONTROLADO"
  },
  {
    "codigo":441048007,
    "descripcion":"VIRUS SINCITIAL RESPIRATORIO DE TIPO B PRESENTE"
  },
  {
    "codigo":111533001,
    "descripcion":"NISTAGMO VERTICAL"
  },
  {
    "codigo":1356717007,
    "descripcion":"HERIDAS ABIERTAS MÚLTIPLES DE VASO DIGITAL DE PIE"
  },
  {
    "codigo":373677008,
    "descripcion":"PRESIÓN PARCIAL DE DIÓXIDO DE CARBONO ARTERIAL - HALLAZGO"
  },
  {
    "codigo":699522001,
    "descripcion":"LEUCORREA NO INFECCIOSA"
  },
  {
    "codigo":240770006,
    "descripcion":"FEOHIFOMICOSIS DE LA PIEL"
  },
  {
    "codigo":109698007,
    "descripcion":"SECUESTRO MAXILAR"
  },
  {
    "codigo":238935002,
    "descripcion":"DERMATOMIOSITIS SIN MIOSITIS"
  },
  {
    "codigo":9559002,
    "descripcion":"SOPLO PROTODIASTÓLICO"
  },
  {
    "codigo":1287511006,
    "descripcion":"ERUPCIÓN CUTÁNEA CAUSADA POR SALMONELLA PARATYPHI A"
  },
  {
    "codigo":402775007,
    "descripcion":"TRASTORNO GENÉTICO DE LA UÑA"
  },
  {
    "codigo":271703008,
    "descripcion":"POSTURA PARAPLÉJICA EN EXTENSIÓN"
  },
  {
    "codigo":106028002,
    "descripcion":"HALLAZGO EN EL SISTEMA MUSCULOESQUELÉTICO"
  },
  {
    "codigo":1351212004,
    "descripcion":"INMUNODEFICIENCIA COMBINADA SEVERA T NEGATIVA B POSITIVA AUTOSÓMICA RECESIVA DEBIDA A MUTACIÓN DE SLP76"
  },
  {
    "codigo":400940005,
    "descripcion":"HIPERACTIVIDAD DE OBLICUO INFERIOR"
  },
  {
    "codigo":40492006,
    "descripcion":"DISFUNCIÓN VESICAL"
  },
  {
    "codigo":16774551000119100,
    "descripcion":"CARCINOMA BASOCELULAR PRIMARIO DE PIEL DE MANO IZQUIERDA"
  },
  {
    "codigo":399105000,
    "descripcion":"PALADAR BLANDO REDUNDANTE"
  },
  {
    "codigo":366337000,
    "descripcion":"VARIABILLIDAD DE LA FRECUENCIA CARDÍACA FETAL - HALLAZGO"
  },
  {
    "codigo":7724006,
    "descripcion":"SÍNDROME NEFRÍTICO"
  },
  {
    "codigo":300801000,
    "descripcion":"NO PARTICIPA EN ACTIVIDADES DEPORTIVAS"
  },
  {
    "codigo":202497007,
    "descripcion":"DOLOR EN ARTICULACIÓN INTERFALÁNGICA DE DEDO DEL PIE"
  },
  {
    "codigo":431873008,
    "descripcion":"PERITONITIS DEBIDA A CATÉTER DE DIÁLISIS PERITONEAL INFECTADO"
  },
  {
    "codigo":335101000119108,
    "descripcion":"COROIDITIS FOCAL DERECHA"
  },
  {
    "codigo":724950002,
    "descripcion":"LACERACIÓN DE MÚSCULO FLEXOR DE PULGAR A LA ALTURA DEL ANTEBRAZO"
  },
  {
    "codigo":16037271000119103,
    "descripcion":"DETENCIÓN DE CRECIMIENTO EPIFISARIO DE PIERNA DERECHA"
  },
  {
    "codigo":298966005,
    "descripcion":"AMPLITUD DE EXTENSIÓN PASIVA DE LA MUÑECA AUMENTADA"
  },
  {
    "codigo":200662009,
    "descripcion":"CELULITIS Y ABSCESO DE LA INGLE"
  },
  {
    "codigo":2219003,
    "descripcion":"EVALUACIÓN DE DISCAPACIDAD: 100%"
  },
  {
    "codigo":723115003,
    "descripcion":"TEMOR A CÁNCER DE SISTEMA ENDOCRINO"
  },
  {
    "codigo":34987005,
    "descripcion":"SIGNO DE KUSSMAUL"
  },
  {
    "codigo":297131007,
    "descripcion":"FRACTURA DE FALANGE MEDIA DE DEDO DE LA MANO"
  },
  {
    "codigo":295296006,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE SULINDACO"
  },
  {
    "codigo":424533000,
    "descripcion":"DIFICULTAD PARA REALIZAR ACTIVIDADES DE LAVADO"
  },
  {
    "codigo":129621001,
    "descripcion":"MIOPATÍA NEMALÍNICA, INICIO PRECOZ"
  },
  {
    "codigo":1145429003,
    "descripcion":"HIPOPLASIA CONGÉNITA DE HUESO DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":15683121000119101,
    "descripcion":"BURSITIS DIGITAL DE AMBAS MANOS"
  },
  {
    "codigo":293461007,
    "descripcion":"REACCIÓN ADVERSA A LA POLITIAZIDA"
  },
  {
    "codigo":64085009,
    "descripcion":"UTILIZA MÉTODO DEL RITMO COMO ANTICONCEPTIVO"
  },
  {
    "codigo":160554002,
    "descripcion":"PRÁCTICA RELIGIOSA POCO DISCIPLINADA"
  },
  {
    "codigo":62250003,
    "descripcion":"ARACNODACTILIA"
  },
  {
    "codigo":193322004,
    "descripcion":"DESPRENDIMIENTO PARCIAL DE RETINA, NUEVO, CON DIÁLISIS RETINIANA"
  },
  {
    "codigo":95018002,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL SENO PIRIFORME"
  },
  {
    "codigo":226090007,
    "descripcion":"DIETA CON BAJO CONTENIDO DE LEUCINA"
  },
  {
    "codigo":783146009,
    "descripcion":"SÍNDROME DE FIEBRE PERIÓDICA HEREDITARIA ASOCIADO A LA PROTEÍNA NLR CON DOMINIO PIRINA 12"
  },
  {
    "codigo":1010687002,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA A TRAVÉS DEL ANTEBRAZO DERECHO"
  },
  {
    "codigo":93183001,
    "descripcion":"HISTIOCITOSIS MALIGNA DE GANGLIOS LINFÁTICOS INTRAPÉLVICOS"
  },
  {
    "codigo":58580000,
    "descripcion":"FRACTURA SUPRACONDÍLEA DE HÚMERO NO EXPUESTA"
  },
  {
    "codigo":124116001,
    "descripcion":"DEFICIENCIA DE D - LACTATO DESHIDROGENASA"
  },
  {
    "codigo":224255009,
    "descripcion":"MOHO EN EL HOGAR"
  },
  {
    "codigo":255188003,
    "descripcion":"ANGIOMIOMA CUTÁNEO"
  },
  {
    "codigo":289791009,
    "descripcion":"CUELLO UTERINO ORIENTADO HACIA LA IZQUIERDA"
  },
  {
    "codigo":1172692006,
    "descripcion":"SÍNDROME LIGADO AL CROMOSOMA X DE CICATRIZACIÓN QUELOIDE, MOVILIDAD ARTICULAR REDUCIDA Y AUMENTO DE LA RELACIÓN COPA-DISCO ÓPTICO"
  },
  {
    "codigo":286121007,
    "descripcion":"DIFICULTAD PARA LIMPIAR EL PISO"
  },
  {
    "codigo":253353007,
    "descripcion":"AURÍCULA IZQUIERDA DIVIDIDA"
  },
  {
    "codigo":1365630005,
    "descripcion":"VIVE EN RESIDENCIA CON AGUA CORRIENTE"
  },
  {
    "codigo":20307000,
    "descripcion":"DEFICIENCIA DE VITAMINA B2"
  },
  {
    "codigo":284286009,
    "descripcion":"DIFICULTAD PARA EMPLEAR AGARRE CON DOS DEDOS"
  },
  {
    "codigo":184147002,
    "descripcion":"CUESTIONARIO DE PACIENTE NUEVO - COMPLETADO"
  },
  {
    "codigo":118611004,
    "descripcion":"ENFERMEDAD DE SÉZARY"
  },
  {
    "codigo":249683006,
    "descripcion":"CLAVÍCULA ARQUEADA"
  },
  {
    "codigo":282451008,
    "descripcion":"QUEMADURA DE LA CAVIDAD NASAL"
  },
  {
    "codigo":1263656000,
    "descripcion":"METÁSTASIS DE CARCINOMA DE CÉLULAS TRANSICIONALES EN PELVIS RENAL IZQUIERDA"
  },
  {
    "codigo":10823371000119105,
    "descripcion":"FRACTURA EXPUESTA DE SEGUNDA FALANGE DE DEDO MEDIO DE MANO IZQUIERDA"
  },
  {
    "codigo":870440003,
    "descripcion":"DISPUESTO A SER DONANTE DE ENCÉFALO"
  },
  {
    "codigo":247848003,
    "descripcion":"TEMOR A LOS ANIMALES"
  },
  {
    "codigo":18472006,
    "descripcion":"RELAJACIÓN SEXUAL"
  },
  {
    "codigo":298419004,
    "descripcion":"AMPLITUD DE EXTENSIÓN ACTIVA DE LA COLUMNA CERVICAL DISMINUIDA"
  },
  {
    "codigo":213245002,
    "descripcion":"INFECCIÓN CRÓNICA DEL MUÑÓN DE AMPUTACIÓN"
  },
  {
    "codigo":337611000119107,
    "descripcion":"ESTAFILOMA POSTERIOR DE OJO IZQUIERDO"
  },
  {
    "codigo":1074891000119109,
    "descripcion":"ARTRITIS DE PIE IZQUIERDO"
  },
  {
    "codigo":229221000119103,
    "descripcion":"MIOPATÍA DEBIDA A SÍNDROME DE CUSHING"
  },
  {
    "codigo":209575006,
    "descripcion":"RUPTURA COMPLETA DE ARTICULACIÓN DEL HOMBRO"
  },
  {
    "codigo":111271008,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE LA CLAVÍCULA"
  },
  {
    "codigo":109436001,
    "descripcion":"DIENTE MOLAR DE MOON"
  },
  {
    "codigo":238673000,
    "descripcion":"TRASTORNO GRANULOMATOSO DE LA PIEL Y TEJIDO CELULAR SUBCUTÁNEO"
  },
  {
    "codigo":304209001,
    "descripcion":"AMPLITUD DE EXTENSIÓN HORIZONTAL PASIVA DE HOMBRO AUMENTADA"
  },
  {
    "codigo":9297001,
    "descripcion":"ÚTERO BICORNE QUE AFECTA EMBARAZO"
  },
  {
    "codigo":699260009,
    "descripcion":"HIPERCALCEMIA DEBIDA A HIPERVITAMINOSIS D"
  },
  {
    "codigo":402513005,
    "descripcion":"CARCINOMA BASOCELULAR DE TRAGO"
  },
  {
    "codigo":16668671000119102,
    "descripcion":"FRACTURA NO EXPUESTA DE TRÍPODE CIGOMÁTICO IZQUIERDO"
  },
  {
    "codigo":40230002,
    "descripcion":"ENCEFALITIS CAUSADA POR VIRUS DE LANGAT"
  },
  {
    "codigo":72998004,
    "descripcion":"QUEMADURA DEL DORSO"
  },
  {
    "codigo":202235000,
    "descripcion":"INESTABILIDAD CARPIANA CON TRANSLOCACIÓN CUBITAL"
  },
  {
    "codigo":726523002,
    "descripcion":"LESIÓN CAUSADA POR BAJA TEMPERATURA"
  },
  {
    "codigo":890363003,
    "descripcion":"HIPERPLASIA PRIMARIA PERSISTENTE DE CUERPO VÍTREO BILATERAL"
  },
  {
    "codigo":235003004,
    "descripcion":"TUMOR GINGIVAL DEL EMBARAZO"
  },
  {
    "codigo":300539002,
    "descripcion":"ESPERMATOZOIDES PRESENTES"
  },
  {
    "codigo":169467008,
    "descripcion":"UTILIZA ANTICONCEPTIVO ORAL SOLAMENTE CON PROGESTÁGENO"
  },
  {
    "codigo":298704001,
    "descripcion":"HALLAZGO RELACIONADO CON MEDICIONES DE LA COLUMNA VERTEBRAL"
  },
  {
    "codigo":69328002,
    "descripcion":"DISTRÉS"
  },
  {
    "codigo":366075008,
    "descripcion":"PROYECCIÓN DE LA FIJACIÓN OCULAR - HALLAZGO"
  },
  {
    "codigo":167632006,
    "descripcion":"MATERIA FECAL: FIBRAS DE CARNE NO DIGERIDA"
  },
  {
    "codigo":397008008,
    "descripcion":"MASTOCITOSIS LINFADENOPÁTICA AGRESIVA CON EOSINOFILIA"
  },
  {
    "codigo":722853000,
    "descripcion":"GANGLIONOSIS INMADURA DE INTESTINO GRUESO"
  },
  {
    "codigo":1148837002,
    "descripcion":"EQUILIBRIO ÁCIDO-BASE DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":296869005,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE TOLBUTAMIDA"
  },
  {
    "codigo":1279909006,
    "descripcion":"SÍNDROME DE CORDÓN CENTRAL DE MÉDULA TORÁCICA DEBIDO A FRACTURA NO EXPUESTA A NIVEL T7-T12"
  },
  {
    "codigo":67493008,
    "descripcion":"INFECCIÓN CAUSADA POR TRICHOSOMOIDES"
  },
  {
    "codigo":295034002,
    "descripcion":"ALERGIA A DEBRISOQUINA"
  },
  {
    "codigo":122003,
    "descripcion":"HEMORRAGIA COROIDEA"
  },
  {
    "codigo":32890004,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA VENA ÁCIGOS"
  },
  {
    "codigo":293199005,
    "descripcion":"REACCIÓN ADVERSA A LA GLIMIDINA"
  },
  {
    "codigo":719183007,
    "descripcion":"ATROFIA DE MÚSCULO CUÁDRICEPS FEMORAL"
  },
  {
    "codigo":225828000,
    "descripcion":"VÍCTIMA DE ABUSO RACIAL"
  },
  {
    "codigo":1208868001,
    "descripcion":"SÍNDROME DE QT PROLONGADO TIPO 12"
  },
  {
    "codigo":94756003,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL CUERPO DEL PÁNCREAS"
  },
  {
    "codigo":782884005,
    "descripcion":"DISPLASIA DEL TEGMENTO PONTINO"
  },
  {
    "codigo":422436006,
    "descripcion":"ACTIVIDADES RECREATIVAS MÍNIMAS"
  },
  {
    "codigo":291364005,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR TEOFILINA"
  },
  {
    "codigo":1010425000,
    "descripcion":"HIPOPLASIA DE APÓFISIS CORONOIDES IZQUIERDA DE MANDÍBULA"
  },
  {
    "codigo":289529001,
    "descripcion":"INFLAMACIÓN DE PARED VAGINAL"
  },
  {
    "codigo":7475005,
    "descripcion":"GASTRITIS POSTGASTRECTOMÍA"
  },
  {
    "codigo":92921005,
    "descripcion":"FORMA ANORMAL CONGÉNITA DE RIÑÓN"
  },
  {
    "codigo":387833009,
    "descripcion":"ENCANECIMIENTO PREMATURO"
  },
  {
    "codigo":340121000119109,
    "descripcion":"ESTENOSIS DE CANALÍCULO LAGRIMAL IZQUIERDO"
  },
  {
    "codigo":449699003,
    "descripcion":"NEOPLASIA BENIGNA DE BRAZO"
  },
  {
    "codigo":1268899005,
    "descripcion":"BLASTOMA PLEUROPULMONAR PRIMARIO"
  },
  {
    "codigo":89251007,
    "descripcion":"CÁLCULO DEL COLÉDOCO CON COLECISTITIS AGUDA"
  },
  {
    "codigo":313651000119105,
    "descripcion":"MONOARTRITIS DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":285859009,
    "descripcion":"DIFICULTAD PARA MANEJAR ENSERES DOMÉSTICOS"
  },
  {
    "codigo":416931008,
    "descripcion":"LACERACIÓN DE LA PARED CORNEOESCLERÓTICA"
  },
  {
    "codigo":15632691000119105,
    "descripcion":"EXOTROPÍA DE AMBOS OJOS"
  },
  {
    "codigo":251256007,
    "descripcion":"SEGMENTO ST INCLINADO"
  },
  {
    "codigo":249421000,
    "descripcion":"SANGRADO DE FAUCES"
  },
  {
    "codigo":218488009,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR TIROGLOBULINA"
  },
  {
    "codigo":710008008,
    "descripcion":"MONOSOMÍA X"
  },
  {
    "codigo":413261003,
    "descripcion":"PREPARACIÓN INTESTINAL INADECUADA"
  },
  {
    "codigo":20045006,
    "descripcion":"MENOPAUSIA TARDÍA"
  },
  {
    "codigo":52813007,
    "descripcion":"ORIENTACIÓN SEXUAL EGODISTÓNICA"
  },
  {
    "codigo":282189008,
    "descripcion":"DIFICULTAD PARA BAJAR UN ESCALÓN"
  },
  {
    "codigo":314957009,
    "descripcion":"APTO PARA IRSE DE VACACIONES"
  },
  {
    "codigo":446029009,
    "descripcion":"LESIÓN TRAUMÁTICA DE VASO SANGUÍNEO DE LA CABEZA"
  },
  {
    "codigo":83746006,
    "descripcion":"ESQUIZOFRENIA CRÓNICA"
  },
  {
    "codigo":737271000,
    "descripcion":"DEGENERACIÓN SUBCONJUNTIVAL"
  },
  {
    "codigo":1359863005,
    "descripcion":"AUMENTO DE VELOCIDAD DE FLUJO SANGUÍNEO DE ARTERIA CORONARIA FETAL"
  },
  {
    "codigo":735436001,
    "descripcion":"TRASTORNO ADQUIRIDO DE LA FUNCIÓN DE LOS NEUTRÓFILOS"
  },
  {
    "codigo":14540002,
    "descripcion":"COMPRESIÓN VENOSA"
  },
  {
    "codigo":1259724008,
    "descripcion":"ASTROCITOMA ANAPLÁSICO PRIMARIO DE ENCÉFALO"
  },
  {
    "codigo":276684009,
    "descripcion":"DACRIOCISTITIS BACTERIANA NEONATAL"
  },
  {
    "codigo":307617006,
    "descripcion":"LEUCEMIA NEUTRÓFILA"
  },
  {
    "codigo":733601006,
    "descripcion":"TRASTORNO CONGÉNITO DE GLICOSILACIÓN TIPO 1Q"
  },
  {
    "codigo":404086000,
    "descripcion":"PARACORDOMA"
  },
  {
    "codigo":305782002,
    "descripcion":"VISTO POR FISIOTERAPEUTA HOSPITALARIO"
  },
  {
    "codigo":1256054007,
    "descripcion":"LIQUEN PLANO ULCERATIVO"
  },
  {
    "codigo":342631000119104,
    "descripcion":"LUPUS ERITEMATOSO DISCOIDE DE PÁRPADO INFERIOR IZQUIERDO"
  },
  {
    "codigo":238411004,
    "descripcion":"INTERTRIGO ESTREPTOCÓCICO"
  },
  {
    "codigo":402251006,
    "descripcion":"GINGIVOESTOMATITIS ALÉRGICA POR CONTACTO"
  },
  {
    "codigo":369483006,
    "descripcion":"TUMOR MALIGNO QUE COMPROMETE EL CONDUCTO DEFERENTE POR PROPAGACIÓN DIRECTA DE LA PRÓSTATA"
  },
  {
    "codigo":1079911000119105,
    "descripcion":"NEVO EPIDÉRMICO DE MIEMBRO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":39968002,
    "descripcion":"AUSENCIA DE SIGNOS VITALES"
  },
  {
    "codigo":105504002,
    "descripcion":"DEPENDENCIA DE BASTÓN"
  },
  {
    "codigo":1186848004,
    "descripcion":"INFERTILIDAD MASCULINA DEBIDA A LESIÓN DE MÉDULA ESPINAL"
  },
  {
    "codigo":7200002,
    "descripcion":"ALCOHOLISMO"
  },
  {
    "codigo":236576005,
    "descripcion":"RECHAZO AGUDO DEL TRASPLANTE RENAL - GRADO II"
  },
  {
    "codigo":433184006,
    "descripcion":"DIVERTICULOSIS DE RECTO"
  },
  {
    "codigo":302112009,
    "descripcion":"COLOSTOMÍA, PRESENTE"
  },
  {
    "codigo":300277007,
    "descripcion":"AMÍGDALA AUSENTE"
  },
  {
    "codigo":890101007,
    "descripcion":"ATRESIA DE ÍLEON TIPO II"
  },
  {
    "codigo":167370002,
    "descripcion":"VOLUMEN DE ORINA DE 24 HORAS DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":200138003,
    "descripcion":"PARTO CON VENTOSA - NACIDO"
  },
  {
    "codigo":3530005,
    "descripcion":"TRASTORNO BIPOLAR I, UN SOLO EPISODIO MANÍACO, EN REMISIÓN TOTAL"
  },
  {
    "codigo":298442006,
    "descripcion":"AMPLITUD DISMINUIDA DE LA FLEXIÓN ACTIVA LATERAL IZQUIERDA DE LA COLUMNA VERTEBRAL CERVICAL"
  },
  {
    "codigo":429514007,
    "descripcion":"DEFICIENCIA DE HORMONA DE CRECIMIENTO LUEGO DE TRASPLANTE DE MÉDULA ÓSEA"
  },
  {
    "codigo":724426006,
    "descripcion":"ACCIDENTE CEREBROVASCULAR ISQUÉMICO DEBIDO A ATEROSCLEROSIS DE GRAN ARTERIA EXTRACRANEAL"
  },
  {
    "codigo":10965761000119103,
    "descripcion":"HERIDA PUNZANTE DE DEDOS SEGUNDO A QUINTO DE PIE DERECHO"
  },
  {
    "codigo":11784961000119103,
    "descripcion":"AMPOLLA TRAUMÁTICA DE DEDO ÍNDICE DE MANO IZQUIERDA"
  },
  {
    "codigo":427679007,
    "descripcion":"ASMA LEVE INTERMITENTE"
  },
  {
    "codigo":296607007,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE NETILMICINA"
  },
  {
    "codigo":720756005,
    "descripcion":"SÍNDROME CRANEOFACIAL-CUBITAL-RENAL"
  },
  {
    "codigo":1179508005,
    "descripcion":"SÍNDROME DE DESMIELINIZACIÓN OSMÓTICA"
  },
  {
    "codigo":424009001,
    "descripcion":"EXPERIMENTA TEMOR A PROCEDIMIENTO DEL PARTO"
  },
  {
    "codigo":718921002,
    "descripcion":"DISFUNCIÓN SOMÁTICA DE REGIÓN DE LA CADERA"
  },
  {
    "codigo":292937002,
    "descripcion":"REACCIÓN ADVERSA A LA VANCOMICINA"
  },
  {
    "codigo":1144905009,
    "descripcion":"LIPODISTROFIA DEBIDA A DERMATOMIOSITIS JUVENIL"
  },
  {
    "codigo":291102001,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR HIDRATO DE CLORAL"
  },
  {
    "codigo":94494004,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LOS GANGLIOS LINFÁTICOS POPLÍTEOS"
  },
  {
    "codigo":225566008,
    "descripcion":"DOLOR TORÁCICO ISQUÉMICO"
  },
  {
    "codigo":127262008,
    "descripcion":"NEOPLASIA DE LOS GANGLIOS LINFÁTICOS INGUINALES"
  },
  {
    "codigo":92659000,
    "descripcion":"CARCINOMA IN SITU DE LA GLÁNDULA SALIVAL MENOR"
  },
  {
    "codigo":289267004,
    "descripcion":"HALLAZGO RELACIONADO CON LA INTEGRIDAD DE LA PLACENTA"
  },
  {
    "codigo":27123005,
    "descripcion":"SEDIMENTO BILIAR"
  },
  {
    "codigo":125851000119106,
    "descripcion":"ABUSO CONTINUO DE SEDANTES"
  },
  {
    "codigo":58056005,
    "descripcion":"SÍFILIS DE VÁLVULA MITRAL"
  },
  {
    "codigo":1336008007,
    "descripcion":"GLAUCOMA DEBIDO A QUISTE DE IRIS DE OJO DERECHO"
  },
  {
    "codigo":285597000,
    "descripcion":"LESIÓN DE NERVIO PERIFÉRICO DE CABEZA Y CUELLO"
  },
  {
    "codigo":416669000,
    "descripcion":"MOLA HIDATIFORME INVASORA"
  },
  {
    "codigo":254664008,
    "descripcion":"QUERATOACANTOMA ERUPTIVO"
  },
  {
    "codigo":25288006,
    "descripcion":"INFESTACIÓN CAUSADA POR SARCOPTES SCABIEI VARIEDAD EQUI"
  },
  {
    "codigo":54386000,
    "descripcion":"FUSIÓN CONGÉNITA DE HUESECILLOS DEL OÍDO"
  },
  {
    "codigo":1268637008,
    "descripcion":"CARCINOMA DE CÉLULAS RENALES CON TRANSLOCACIÓN DE LA FAMILIA MIT PRIMARIO"
  },
  {
    "codigo":283762003,
    "descripcion":"MORDEDURA DE PERRO EN EL ABDOMEN"
  },
  {
    "codigo":17461000119103,
    "descripcion":"SECUELA DE LESIÓN TRAUMÁTICA INTRACRANEAL"
  },
  {
    "codigo":250994005,
    "descripcion":"ORIFICIO DE VÁLVULA MITRAL CON FORMA DE HENDIDURA"
  },
  {
    "codigo":183623000,
    "descripcion":"SEGUIMIENTO EN 1 MES"
  },
  {
    "codigo":314695001,
    "descripcion":"TALLA DEL NIÑO: PERCENTILO 50"
  },
  {
    "codigo":249159004,
    "descripcion":"PRESENTACIÓN POR DEBAJO DE LAS ESPINAS CIÁTICAS"
  },
  {
    "codigo":281927006,
    "descripcion":"FRACTURA DE LÁMINA DE VÉRTEBRA DORSAL"
  },
  {
    "codigo":1197596003,
    "descripcion":"LUXACIÓN POSTERIOR CERRADA DE ARTICULACIÓN GLENOHUMERAL"
  },
  {
    "codigo":247324004,
    "descripcion":"CONSTRICCIÓN EN LA GARGANTA"
  },
  {
    "codigo":83484004,
    "descripcion":"TRANSLUCIDEZ ANORMAL"
  },
  {
    "codigo":442097001,
    "descripcion":"MONOPLEJÍA DE MIEMBRO SUPERIOR COMO EFECTO TARDÍO DE ENFERMEDAD CEREBROVASCULAR"
  },
  {
    "codigo":704241002,
    "descripcion":"MIOCARDIOPATÍA HIPERTRÓFICA FETAL DEBIDA A DIABETES MELLITUS MATERNA"
  },
  {
    "codigo":48881001,
    "descripcion":"ENFERMEDAD POR EL VIRUS TRIBEC"
  },
  {
    "codigo":737009006,
    "descripcion":"RESISTENCIA A LA IRRIGACIÓN DE DISPOSITIVO DE ACCESO VENOSO COMPLETAMENTE IMPLANTABLE"
  },
  {
    "codigo":702406000,
    "descripcion":"TUMOR DE ESTROMA DE CORDONES SEXUALES DE TESTÍCULO DE COMPORTAMIENTO INCIERTO"
  },
  {
    "codigo":866246001,
    "descripcion":"RÓTULA ALTA"
  },
  {
    "codigo":473030001,
    "descripcion":"COMPLICACIÓN ASOCIADA CON IMPLANTE MAMARIO RELLENO CON SOLUCIÓN SALINA"
  },
  {
    "codigo":276422002,
    "descripcion":"SECCIÓN TRAUMÁTICA DE TENDÓN EXTENSOR - ZONA 1"
  },
  {
    "codigo":345141000119109,
    "descripcion":"ÚLCERA DE MOOREN DE AMBAS CÓRNEAS"
  },
  {
    "codigo":16538831000119103,
    "descripcion":"NEVO MELANOCÍTICO DE MEJILLA"
  },
  {
    "codigo":1259462007,
    "descripcion":"CARCINOMA NEUROENDOCRINO MICROCÍTICO PRIMARIO"
  },
  {
    "codigo":407494008,
    "descripcion":"ENFERMEDAD CAUSADA POR PARAMYXOVIRINAE"
  },
  {
    "codigo":209051002,
    "descripcion":"SÍNDROME MEDULAR POSTERIOR DE MÉDULA CERVICAL DEBIDO A LUXACIÓN VERTEBRAL NO EXPUESTA DE COLUMNA CERVICAL"
  },
  {
    "codigo":241819002,
    "descripcion":"PICADURA DE AVISPA"
  },
  {
    "codigo":733339006,
    "descripcion":"TRASTORNO DEL GLOBO OCULAR Y DE ANEXOS DEL OJO DEBIDO A PROCEDIMIENTO Y POSTERIOR A ÉL"
  },
  {
    "codigo":307355007,
    "descripcion":"ATETOSIS CONGÉNITA"
  },
  {
    "codigo":10608000,
    "descripcion":"INTOXICACIÓN POR TEFLÓN"
  },
  {
    "codigo":698736001,
    "descripcion":"HIDROCEFALIA COMUNICANTE POSOPERATORIA"
  },
  {
    "codigo":43376001,
    "descripcion":"ALELOS MÚLTIPLES"
  },
  {
    "codigo":239984004,
    "descripcion":"LESIÓN DEL LIGAMENTO DE LA MUÑECA Y DE LA MANO"
  },
  {
    "codigo":305520005,
    "descripcion":"BAJO ATENCIÓN DE TOCOGINECÓLOGO"
  },
  {
    "codigo":726707004,
    "descripcion":"SÍNDROME DE MICRODUPLICACIÓN 7Q11.23"
  },
  {
    "codigo":764272007,
    "descripcion":"COMPRESIÓN DE COLA DE CABALLO DEBIDA A ESTENOSIS DE VÉRTEBRA LUMBAR"
  },
  {
    "codigo":403824007,
    "descripcion":"SÍNDROME DE TORRÉ-MUIR"
  },
  {
    "codigo":860741001,
    "descripcion":"PUNTAJE DE GLEASON X"
  },
  {
    "codigo":1255792009,
    "descripcion":"LINFOMA DE HODGKIN, VARIANTE ESCLEROSIS NODULAR DE GANGLIOS LINFÁTICOS DE CABEZA"
  },
  {
    "codigo":15637711000119106,
    "descripcion":"ESOTROPÍA ACOMODATIVA DE OJO DERECHO"
  },
  {
    "codigo":762437005,
    "descripcion":"TETANIA NEONATAL SIN DEFICIENCIA DE MAGNESIO"
  },
  {
    "codigo":238149007,
    "descripcion":"SÍNDROME DE RESPUESTA INFLAMATORIA SISTÉMICA"
  },
  {
    "codigo":318671000119108,
    "descripcion":"ARTROSIS DE ARTICULACIÓN DE REGIÓN DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":400154003,
    "descripcion":"LEPRA DIMORFA INTERMEDIA"
  },
  {
    "codigo":72474004,
    "descripcion":"AMPOLLA DEL DORSO, SIN INFECCIÓN"
  },
  {
    "codigo":37871000,
    "descripcion":"HEPATITIS AGUDA"
  },
  {
    "codigo":1119215001,
    "descripcion":"DOLOR EN REGIÓN LUMBAR IZQUIERDA DEL DORSO"
  },
  {
    "codigo":1217519001,
    "descripcion":"HEMORRAGIA POSTQUIRÚRGICA POSTERIOR A RESECCIÓN TRANSURETRAL DE PRÓSTATA"
  },
  {
    "codigo":398319002,
    "descripcion":"ABSCESO DE TROMPA DE FALOPIO"
  },
  {
    "codigo":234479004,
    "descripcion":"TRASTORNO PLAQUETARIO ADQUIRIDO"
  },
  {
    "codigo":365551005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA RECONOCER SONIDOS"
  },
  {
    "codigo":168943003,
    "descripcion":"AORTOGRAFÍA ABDOMINAL ANORMAL"
  },
  {
    "codigo":298180004,
    "descripcion":"AMPLITUD DE MOVIMIENTO ARTICULAR-HALLAZGO"
  },
  {
    "codigo":789700005,
    "descripcion":"HEMANGIOMA RACEMOSO CONGÉNITO DE RETINA"
  },
  {
    "codigo":292201000119106,
    "descripcion":"TRASTORNO DE NERVIO PLANTAR EXTERNO DERECHO"
  },
  {
    "codigo":722329004,
    "descripcion":"GLAUCOMA DE ÁNGULO ABIERTO DE OJO DERECHO CAUSADO POR CORTICOSTEROIDES"
  },
  {
    "codigo":294510007,
    "descripcion":"ALERGIA A CARBENICILINA"
  },
  {
    "codigo":292675000,
    "descripcion":"REACCIÓN ADVERSA A AGENTE URICOSÚRICO"
  },
  {
    "codigo":720494009,
    "descripcion":"SÍNDROME DE ANONIQUIA CON MICROCEFALIA"
  },
  {
    "codigo":425582007,
    "descripcion":"TAQUICARDIA SINUSAL INADECUADA"
  },
  {
    "codigo":816963007,
    "descripcion":"MIEMBRO INFERIOR DERECHO AMPUTADO"
  },
  {
    "codigo":1208344000,
    "descripcion":"SÍNDROME DE FRYNS SMEETS THIRY"
  },
  {
    "codigo":1144643009,
    "descripcion":"NÓDULO DE LENGUA"
  },
  {
    "codigo":94232001,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE BRONQUIO DEL LÓBULO SUPERIOR DERECHO DEL PULMÓN"
  },
  {
    "codigo":675331000119106,
    "descripcion":"LEUCOMA CORNEAL BILATERAL"
  },
  {
    "codigo":127000009,
    "descripcion":"NEOPLASIA DE LA TÚNICA VASCULAR DEL OJO"
  },
  {
    "codigo":347651000119107,
    "descripcion":"ABSCESO DE PÁRPADO INFERIOR DERECHO"
  },
  {
    "codigo":92397006,
    "descripcion":"NEOPLASIA BENIGNA DE PARTES BLANDAS DEL PERINEO"
  },
  {
    "codigo":190701006,
    "descripcion":"ISOLEUCINOSIS"
  },
  {
    "codigo":714989009,
    "descripcion":"EMPUJA CON MIEMBRO INFERIOR"
  },
  {
    "codigo":90562004,
    "descripcion":"SUFRIMIENTO FETAL, EN RECIÉN NACIDO VIVO"
  },
  {
    "codigo":418242004,
    "descripcion":"PIEL DENUDADA"
  },
  {
    "codigo":1335746004,
    "descripcion":"NECROSIS AVASCULAR DE HUESO DE REGIÓN DE TOBILLO"
  },
  {
    "codigo":1084931000119109,
    "descripcion":"COLECISTITIS CRÓNICA DEBIDA A COLELITIASIS CONCOMITANTE CON COLEDOCOLITIASIS"
  },
  {
    "codigo":25026004,
    "descripcion":"EDAD GESTACIONAL, 18 SEMANAS"
  },
  {
    "codigo":1268375001,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN METACARPOFALÁNGICA DE DEDO ANULAR"
  },
  {
    "codigo":254402004,
    "descripcion":"CARCINOMA DEL FRENILLO LABIAL INFERIOR"
  },
  {
    "codigo":449175004,
    "descripcion":"HEMANGIOMA DE NARIZ"
  },
  {
    "codigo":23191004,
    "descripcion":"FRAMBESIA TEMPRANA"
  },
  {
    "codigo":285335006,
    "descripcion":"HEMORRAGIA DE ALVÉOLO DENTAL"
  },
  {
    "codigo":283500006,
    "descripcion":"HERIDA PUNZANTE DE CUERO CABELLUDO"
  },
  {
    "codigo":445505000,
    "descripcion":"CONTRACTURA DE ARTICULACIÓN DE COLUMNA VERTEBRAL"
  },
  {
    "codigo":281665002,
    "descripcion":"PÓLIPO UVULAR"
  },
  {
    "codigo":314433002,
    "descripcion":"PREFERENCIA POR PROFESIONAL DE LA SALUD"
  },
  {
    "codigo":85057007,
    "descripcion":"QUISTE HEPÁTICO"
  },
  {
    "codigo":248897009,
    "descripcion":"MATERIAL PURULENTO EN VAGINA"
  },
  {
    "codigo":1197334002,
    "descripcion":"MELANOMA MALIGNO DE TRACTO UVEAL"
  },
  {
    "codigo":212459001,
    "descripcion":"LESIÓN DEL TENDÓN Y MÚSCULO FLEXOR DEL PULGAR A NIVEL DEL ANTEBRAZO"
  },
  {
    "codigo":81387001,
    "descripcion":"ÚLCERA GASTROYEYUNAL AGUDA CON HEMORRAGIA Y PERFORACIÓN"
  },
  {
    "codigo":247062009,
    "descripcion":"CATARATA CUPULIFORME"
  },
  {
    "codigo":11845431000119105,
    "descripcion":"LESIÓN TRAUMÁTICA DE VENA YUGULAR EXTERNA DERECHA"
  },
  {
    "codigo":472768001,
    "descripcion":"OBSTRUCCIÓN DE GRAN VENA PULMONAR DEBIDA A COMPRESIÓN POR DILATACIÓN DE AURÍCULA DERECHA"
  },
  {
    "codigo":767680002,
    "descripcion":"HERNIA INGUINAL DERECHA RECURRENTE CON GANGRENA"
  },
  {
    "codigo":29221000175107,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN EN GLÚTEO DERECHO ESTADIO I"
  },
  {
    "codigo":46784006,
    "descripcion":"CRISTALURIA"
  },
  {
    "codigo":79552009,
    "descripcion":"DUPLICACIÓN CONGÉNITA DEL HÍGADO"
  },
  {
    "codigo":12181002,
    "descripcion":"ALVEOLITIS PULMONAR TROPICAL"
  },
  {
    "codigo":307093007,
    "descripcion":"NO CONOCE EL PELIGRO DE LAS AGUAS PROFUNDAS"
  },
  {
    "codigo":403562000,
    "descripcion":"DÍGITO RUDIMENTARIO"
  },
  {
    "codigo":208789008,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN DE CODO, DIVERGENTE"
  },
  {
    "codigo":43114002,
    "descripcion":"TRIGONITIS CRÓNICA"
  },
  {
    "codigo":698474005,
    "descripcion":"MONOARTRITIS DE RODILLA"
  },
  {
    "codigo":41279003,
    "descripcion":"FÍSTULA BRONCOESOFÁGICA CONGÉNITA"
  },
  {
    "codigo":8511007,
    "descripcion":"TRASTORNO DE TICS TRANSITORIOS, EPISODIO ÚNICO"
  },
  {
    "codigo":203284001,
    "descripcion":"OSTEOPATÍA COMO CONSECUENCIA DE POLIOMIELITIS"
  },
  {
    "codigo":39444001,
    "descripcion":"HIPOTIROIDISMO POR TIROIDITIS FIBROSA INVASIVA"
  },
  {
    "codigo":1055252006,
    "descripcion":"AGENESIA DE EPÍFISIS DE FALANGE MEDIA DE DEDO MAYOR"
  },
  {
    "codigo":301588006,
    "descripcion":"CAPAZ DE MANEJARSE EN ESCALERAS"
  },
  {
    "codigo":365289001,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA CONTROLAR ARTEFACTOS DOMÉSTICOS"
  },
  {
    "codigo":299753007,
    "descripcion":"REFLEJO DE HOCIQUEO PRESENTE"
  },
  {
    "codigo":398057008,
    "descripcion":"CEFALEA TENSIONAL"
  },
  {
    "codigo":234217009,
    "descripcion":"TRASTORNO DE LA FUNCIÓN DEL MARCAPASOS"
  },
  {
    "codigo":363454002,
    "descripcion":"NEOPLASIA MALIGNA DE ESCROTO"
  },
  {
    "codigo":266985007,
    "descripcion":"EN EDUCACIÓN SUPERIOR"
  },
  {
    "codigo":3006004,
    "descripcion":"ALTERACIÓN DE LA CONSCIENCIA"
  },
  {
    "codigo":166846000,
    "descripcion":"TRIGLICÉRIDOS SÉRICOS DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":43361000087100,
    "descripcion":"LACERACIÓN SIMPLE DE REGIÓN PERIORBITARIA DE OJO DERECHO"
  },
  {
    "codigo":722067005,
    "descripcion":"INMUNODEFICIENCIA COMBINADA SEVERA CON HIPEREOSINOFILIA"
  },
  {
    "codigo":1344659006,
    "descripcion":"ARTRITIS REACTIVA DEBIDA A DISENTERÍA Y POSTERIOR A ELLA"
  },
  {
    "codigo":40801000087101,
    "descripcion":"ABRASIÓN DE PIEL DE MIEMBRO SUPERIOR DERECHO"
  },
  {
    "codigo":323691000119105,
    "descripcion":"TUMOR TENOSINOVIAL DE CÉLULAS GIGANTES DIFUSO DE ARTICULACIÓN DE RODILLA DERECHA"
  },
  {
    "codigo":38241000087102,
    "descripcion":"HIPOCINESIA DE SEGMENTO BASAL ANTERIOR DE VENTRÍCULO CARDÍACO IZQUIERDO"
  },
  {
    "codigo":787603009,
    "descripcion":"PARÁLISIS COMPLETA DE CUERDA VOCAL IZQUIERDA"
  },
  {
    "codigo":294248003,
    "descripcion":"ALERGIA A OCTOXINOL"
  },
  {
    "codigo":48481000087107,
    "descripcion":"FRACTURA INTERTROCANTÉREA DE FÉMUR IZQUIERDO"
  },
  {
    "codigo":458088003,
    "descripcion":"ARTERIA COLATERAL MAYOR QUE DERIVA EL FLUJO SISTÉMICO HACIA LA CIRCULACIÓN PULMONAR"
  },
  {
    "codigo":296083008,
    "descripcion":"SOBREDOSIS DE BROMAZEPAM"
  },
  {
    "codigo":95805006,
    "descripcion":"SECRECIÓN MALOLIENTE DESDE EL CONDUCTO AUDITIVO EXTERNO"
  },
  {
    "codigo":292413006,
    "descripcion":"REACCIÓN ADVERSA AL PROLINTANO"
  },
  {
    "codigo":1144381008,
    "descripcion":"ATROFIA DE TRONCO ENCEFÁLICO"
  },
  {
    "codigo":61202000,
    "descripcion":"FRACTURA EXPUESTA DE SÍNFISIS DEL CUERPO DE LA MANDÍBULA"
  },
  {
    "codigo":93970001,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA PARED POSTERIOR DE LA NASOFARINGE"
  },
  {
    "codigo":126738008,
    "descripcion":"NEOPLASIA DE VASO SANGUÍNEO DE LA CABEZA"
  },
  {
    "codigo":225042009,
    "descripcion":"HALLAZGO RELACIONADO CON LA REMINISCENCIA"
  },
  {
    "codigo":92135006,
    "descripcion":"NEOPLASIA BENIGNA DE LOS GANGLIOS LINFÁTICOS HIPOGÁSTRICOS"
  },
  {
    "codigo":24764000,
    "descripcion":"CONCRECIÓN DE APÉNDICE"
  },
  {
    "codigo":254140006,
    "descripcion":"DESARROLLO DESORGANIZADO DE COMPONENTES CARTILAGINOSOS Y FIBROSOS DEL ESQUELETO"
  },
  {
    "codigo":1111491000000103,
    "descripcion":"CIERRE DE ÁNGULO AGUDO DEBIDO A UVEÍTIS"
  },
  {
    "codigo":711057003,
    "descripcion":"DOLOR FANTASMA POSTERIOR A AMPUTACIÓN DE MIEMBRO INFERIOR"
  },
  {
    "codigo":106911000119102,
    "descripcion":"GLOMERULONEFRITIS IDIOPÁTICA"
  },
  {
    "codigo":24991000119103,
    "descripcion":"MIELOPATÍA DORSAL"
  },
  {
    "codigo":283238009,
    "descripcion":"VIDRIO EN LA CARA"
  },
  {
    "codigo":248635002,
    "descripcion":"PULSO DE EYECCIÓN RÁPIDA"
  },
  {
    "codigo":1089951000119104,
    "descripcion":"INFECCIÓN POR ONCOVIRUS"
  },
  {
    "codigo":445243001,
    "descripcion":"COLITIS ULCEROSA IZQUIERDA"
  },
  {
    "codigo":707387004,
    "descripcion":"FIBROMA DE PULMÓN"
  },
  {
    "codigo":1231675005,
    "descripcion":"DESVIACIÓN POST-SACÁDICA"
  },
  {
    "codigo":838459007,
    "descripcion":"REACCIÓN ADVERSA CUTÁNEA A ACEITE BASE"
  },
  {
    "codigo":15999391000119104,
    "descripcion":"QUERATOPATÍA DE AMBOS OJOS CAUSADA POR FÁRMACO"
  },
  {
    "codigo":19259001,
    "descripcion":"FRACTURA NO EXPUESTA DE EXTREMO PROXIMAL DE RADIO Y CÚBITO"
  },
  {
    "codigo":15727161000119100,
    "descripcion":"HIPERLAXITUD ARTICULAR DE AMBOS HOMBROS"
  },
  {
    "codigo":246800008,
    "descripcion":"INCLINACIÓN ANTIMONGOLOIDE DE HENDIDURA PALPEBRAL"
  },
  {
    "codigo":310501001,
    "descripcion":"ENTUMECIMIENTO DE MIEMBROS"
  },
  {
    "codigo":392913311000119107,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN DE TEJIDO PROFUNDO DE CADERA IZQUIERDA"
  },
  {
    "codigo":81125004,
    "descripcion":"CISTITIS HEMORRÁGICA AGUDA"
  },
  {
    "codigo":212197005,
    "descripcion":"LESIÓN DE LA RAÍZ DEL NERVIO CERVICAL - C1"
  },
  {
    "codigo":10674591000119108,
    "descripcion":"QUISTE DE SENO FRONTAL"
  },
  {
    "codigo":79290002,
    "descripcion":"EMBARAZO CERVICAL"
  },
  {
    "codigo":13754002,
    "descripcion":"INTOXICACIÓN POR ÁCIDO 2, 4 - DICLOROFENILACÉTICO"
  },
  {
    "codigo":46522005,
    "descripcion":"LISTA DE REEMPLAZO DE LA FRUTA"
  },
  {
    "codigo":11795001000119103,
    "descripcion":"LACERACIÓN DE ARTERIA SUBCLAVIA IZQUIERDA"
  },
  {
    "codigo":110223000,
    "descripcion":"QUEMADURA DE PRIMER GRADO DEL PALADAR BLANDO"
  },
  {
    "codigo":863887001,
    "descripcion":"AGUDEZA VISUAL DE OJO DERECHO 6\/60"
  },
  {
    "codigo":1156964000,
    "descripcion":"RADICULOPATÍA DEBIDA A ESPONDILOSIS CERVICAL DE UN NIVEL"
  },
  {
    "codigo":1255268002,
    "descripcion":"SÍNDROME OCULOCEREBRODENTAL"
  },
  {
    "codigo":370532003,
    "descripcion":"CABEZA INCLINADA"
  },
  {
    "codigo":763748007,
    "descripcion":"ADERMATOGLIFIA CONGÉNITA AISLADA"
  },
  {
    "codigo":42852008,
    "descripcion":"LINFOCITOSIS INFECCIOSA"
  },
  {
    "codigo":1288036007,
    "descripcion":"TUMOR DE CÉLULAS ENTEROCROMAFINES DE ESTÓMAGO"
  },
  {
    "codigo":1351737005,
    "descripcion":"EXCAVACIÓN ASIMÉTRICA DE PAPILAS ÓPTICAS"
  },
  {
    "codigo":237625008,
    "descripcion":"TRASTORNO HIPERGLUCÉMICO DEL EMBARAZO"
  },
  {
    "codigo":792846001,
    "descripcion":"ÚLCERA DE TALÓN DEBIDA A ATEROSCLEROSIS DE ARTERIA DE MIEMBRO INFERIOR"
  },
  {
    "codigo":235790002,
    "descripcion":"FÍSTULA EXTERNA DEL INTESTINO GRUESO"
  },
  {
    "codigo":10811961000119109,
    "descripcion":"PARO CARDÍACO DEBIDO A ABORTO ESPONTÁNEO INCOMPLETO"
  },
  {
    "codigo":301326006,
    "descripcion":"HALLAZGO RELACIONADO CON EL VIGOR GENERAL"
  },
  {
    "codigo":203022007,
    "descripcion":"ABSCESO DE MÚSCULO DE HOMBRO"
  },
  {
    "codigo":233955003,
    "descripcion":"ATEROSCLEROSIS DE LA AORTA ABDOMINAL"
  },
  {
    "codigo":365027006,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA RESOPLAR"
  },
  {
    "codigo":397795007,
    "descripcion":"TRASTORNO POLISOMATIZANTE"
  },
  {
    "codigo":299491008,
    "descripcion":"SIN AMPLITUD ACTIVA DE PRONACIÓN MEDIOTARSIANA"
  },
  {
    "codigo":102883009,
    "descripcion":"SECRECIÓN PLACENTARIA AUMENTADA DE GONADOTROFINA CORIÓNICA"
  },
  {
    "codigo":166584001,
    "descripcion":"PROTEÍNA C REACTIVA FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":232120006,
    "descripcion":"REACCIÓN PUPILAR DISOCIADA AL EXAMEN CON LUZ CERCANA"
  },
  {
    "codigo":789176009,
    "descripcion":"ALCALINIDAD DE HECES POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":721805001,
    "descripcion":"INFECCIÓN CAUSADA POR PIEDRAIA"
  },
  {
    "codigo":230285003,
    "descripcion":"DEMENCIA VASCULAR DE INICIO AGUDO"
  },
  {
    "codigo":263053001,
    "descripcion":"SUBLUXACIÓN DE ARTICULACIÓN DE LA MUÑECA"
  },
  {
    "codigo":66445009,
    "descripcion":"LINFOMA ESTADIO IV"
  },
  {
    "codigo":293986006,
    "descripcion":"ALERGIA A ALFUZOSINA"
  },
  {
    "codigo":195682008,
    "descripcion":"LARINGITIS CATARRAL AGUDA"
  },
  {
    "codigo":718135001,
    "descripcion":"HIPOPLASIA DE VENTRÍCULO DERECHA AISLADA"
  },
  {
    "codigo":292151001,
    "descripcion":"REACCIÓN ADVERSA A LA DICICLOMINA"
  },
  {
    "codigo":1092461000119104,
    "descripcion":"SEPSIS SIN DISFUNCIÓN ORGÁNICA AGUDA"
  },
  {
    "codigo":93708002,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE VASO SANGUÍNEO DE HOMBRO"
  },
  {
    "codigo":91873009,
    "descripcion":"AUSENCIA CONGÉNITA DEL CARPO"
  },
  {
    "codigo":253878003,
    "descripcion":"RIÑÓN POLIQUÍSTICO DEL ADULTO TIPO 1"
  },
  {
    "codigo":1204150005,
    "descripcion":"ESTENOSIS ASINTOMÁTICA DE RAMA CRANEAL DE ARTERIA VERTEBRAL"
  },
  {
    "codigo":16057351000119103,
    "descripcion":"NEURALGIA DE NERVIO GLOSOFARÍNGEO IZQUIERDO"
  },
  {
    "codigo":286646006,
    "descripcion":"AUTOIMAGEN INESTABLE"
  },
  {
    "codigo":328711000119103,
    "descripcion":"INFECCIÓN DEBIDA A PROCEDIMIENTO BARIÁTRICO"
  },
  {
    "codigo":219275001,
    "descripcion":"LESIÓN POR INTERVENCIÓN LEGAL, GOLPEADO POR BASTÓN"
  },
  {
    "codigo":284811004,
    "descripcion":"SE SIENTA EN LA BAÑERA"
  },
  {
    "codigo":414048000,
    "descripcion":"CIFOSIS DORSAL"
  },
  {
    "codigo":448651008,
    "descripcion":"OBSTRUCCIÓN PARCIAL DE CORTOCIRCUITO SISTÉMICO-PULMONAR"
  },
  {
    "codigo":282976003,
    "descripcion":"INCAPAZ DE DOBLARSE"
  },
  {
    "codigo":1003872003,
    "descripcion":"DISOMÍA UNIPARENTAL DE ORIGEN PATERNO DEL CROMOSOMA 14"
  },
  {
    "codigo":1296949006,
    "descripcion":"MIEDO AL OLOR DEL CUERPO"
  },
  {
    "codigo":1264181009,
    "descripcion":"TRASTORNO FETAL CAUSADO POR TRANSFERENCIA PLACENTARIA DE ANALGESIA MATERNA"
  },
  {
    "codigo":246538002,
    "descripcion":"CONVULSIÓN QUE CAUSA ILUSIONES"
  },
  {
    "codigo":768991009,
    "descripcion":"DOBLE INCONTINENCIA EN LA INFANCIA"
  },
  {
    "codigo":111796005,
    "descripcion":"PIE DE MADURA CAUSADO POR STREPTOMYCES SOMALIENSIS"
  },
  {
    "codigo":210100006,
    "descripcion":"LESIÓN DE LA TRÁQUEA TORÁCICA"
  },
  {
    "codigo":898228006,
    "descripcion":"FUSIÓN ANORMAL CONGÉNITA DE FALANGE DE PULGAR"
  },
  {
    "codigo":699785004,
    "descripcion":"PERIODONTITIS COMO MANIFESTACIÓN DE ENFERMEDAD SISTÉMICA"
  },
  {
    "codigo":10624161000119108,
    "descripcion":"MEIBOMIANITIS DE PÁRPADO SUPERIOR E INFERIOR DERECHO"
  },
  {
    "codigo":372105009,
    "descripcion":"CARCINOMA DE SUPRAGLOTIS"
  },
  {
    "codigo":403038004,
    "descripcion":"TIÑA CORPORAL CAUSADA POR TRICHOPHYTON RUBRUM"
  },
  {
    "codigo":9822005,
    "descripcion":"HERNIA UMBILICAL CON GANGRENA Y OBSTRUCCIÓN"
  },
  {
    "codigo":271966006,
    "descripcion":"TRASTORNO OCASIONADO POR PRÓTESIS E IMPLANTES CARDIOVASCULARES"
  },
  {
    "codigo":239198006,
    "descripcion":"PÉRDIDA DEL COLGAJO DE ESPESOR PARCIAL"
  },
  {
    "codigo":11796731000119100,
    "descripcion":"LESIÓN TRAUMÁTICA DE ESÓFAGO TORÁCICO"
  },
  {
    "codigo":182960891000119101,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DEBIDO A OCLUSIÓN DE ARTERIA CEREBRAL ANTERIOR IZQUIERDA"
  },
  {
    "codigo":299771000119102,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE TENDÓN EXTENSOR DE ANTEBRAZO"
  },
  {
    "codigo":1075451000119103,
    "descripcion":"RUPTURA CRÓNICA DE LIGAMENTO CRUZADO ANTERIOR DE RODILLA IZQUIERDA"
  },
  {
    "codigo":10752251000119103,
    "descripcion":"GALACTORREA EN EL EMBARAZO"
  },
  {
    "codigo":302331000119102,
    "descripcion":"HIPEROSTOSIS ESQUELÉTICA IDIOPÁTICA DIFUSA DE COLUMNA VERTEBRAL LUMBAR"
  },
  {
    "codigo":153851000119106,
    "descripcion":"ENFERMEDAD RENAL CRÓNICA POR HIPERTENSIÓN MALIGNA, ESTADIO 5"
  },
  {
    "codigo":292091000119107,
    "descripcion":"TRASTORNO DE NERVIO CIÁTICO POPLÍTEO EXTERNO A LA ALTURA DE RAMA POPLÍTEA LATERAL"
  },
  {
    "codigo":322811000119108,
    "descripcion":"LESIÓN TRAUMÁTICA DE REGIONES CERVICAL Y DORSAL DE COLUMNA VERTEBRAL"
  },
  {
    "codigo":10954491000119108,
    "descripcion":"HERIDA POR DISPARO DE ARMA DE FUEGO DE CUELLO"
  },
  {
    "codigo":812500731000119109,
    "descripcion":"VULVOVAGINITIS CANDIDIÁSICA CRÓNICA DURANTE EL EMBARAZO"
  },
  {
    "codigo":10491000119106,
    "descripcion":"COMPLICACIÓN DE COLOSTOMÍA"
  },
  {
    "codigo":1187635008,
    "descripcion":"MIOCARDIOPATÍA MITOCONDRIAL HEREDADA POR LÍNEA MATERNA"
  },
  {
    "codigo":202760001,
    "descripcion":"ESTENOSIS IDIOPÁTICA DE CONDUCTO RAQUÍDEO CERVICAL"
  },
  {
    "codigo":11776251000119108,
    "descripcion":"LESIÓN TRAUMÁTICA DE ANTEBRAZO IZQUIERDO"
  },
  {
    "codigo":364765002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CANTIDAD DE TUMORACIONES"
  },
  {
    "codigo":299229000,
    "descripcion":"TORSIÓN TIBIAL EXTERNA"
  },
  {
    "codigo":11773691000119109,
    "descripcion":"HERIDA DE REGIÓN DE CODO IZQUIERDO DEBIDA A PICADURA DE INSECTO NO VENENOSO"
  },
  {
    "codigo":102621006,
    "descripcion":"VACIAMIENTO GÁSTRICO DETERIORADO"
  },
  {
    "codigo":37085009,
    "descripcion":"NEFRITIS POR SHUNT"
  },
  {
    "codigo":1149362002,
    "descripcion":"PARO CARDÍACO DURANTE PROCEDIMIENTO"
  },
  {
    "codigo":69853009,
    "descripcion":"OCLUSIÓN DE LA VAGINA"
  },
  {
    "codigo":788914007,
    "descripcion":"EDEMA DEBIDO A INFECCIÓN"
  },
  {
    "codigo":230023000,
    "descripcion":"POSICIÓN NEUTRA DEL TRONCO"
  },
  {
    "codigo":231858009,
    "descripcion":"CONJUNTIVITIS GONOCÓCICA"
  },
  {
    "codigo":361095003,
    "descripcion":"DEHISCENCIA Y\/O RUPTURA DE HERIDA UTERINA EN EL PUERPERIO"
  },
  {
    "codigo":262791003,
    "descripcion":"CONTUSIÓN ESOFÁGICA"
  },
  {
    "codigo":295559003,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE PRILOCAÍNA"
  },
  {
    "codigo":721543007,
    "descripcion":"ERUPCIÓN CUTÁNEA DESCAMATIVA AGUDA"
  },
  {
    "codigo":331221000119105,
    "descripcion":"CUERPO EXTRAÑO RETENIDO EN PÁRPADO SUPERIOR DERECHO"
  },
  {
    "codigo":293724004,
    "descripcion":"ALERGIA A BENZOCAÍNA"
  },
  {
    "codigo":128049000,
    "descripcion":"TRASTORNO DE LA COLUMNA CERVICAL"
  },
  {
    "codigo":783409001,
    "descripcion":"ARTERIA ECTÓPICA"
  },
  {
    "codigo":10626671000119101,
    "descripcion":"CARBUNCO DE EXTREMIDAD SUPERIOR IZQUIERDA"
  },
  {
    "codigo":160817004,
    "descripcion":"PERDIÓ LA CUSTODIA DE LOS HIJOS"
  },
  {
    "codigo":422961004,
    "descripcion":"EXCESO DE GRASA SUBCUTÁNEA MAMARIA"
  },
  {
    "codigo":717873003,
    "descripcion":"DUODENITIS EOSINOFÍLICA"
  },
  {
    "codigo":95281009,
    "descripcion":"MUERTE SÚBITA CARDÍACA"
  },
  {
    "codigo":816177009,
    "descripcion":"RETINOPATÍA NO PROLIFERATIVA DE OJO IZQUIERDO DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":290054003,
    "descripcion":"HALLAZGO RELACIONADO CON EL ASPECTO DE LA MAMA"
  },
  {
    "codigo":224518005,
    "descripcion":"ATENCIÓN PORMENORIZADA"
  },
  {
    "codigo":93446008,
    "descripcion":"CRESTA ALVEOLAR DESDENTADA"
  },
  {
    "codigo":1304027002,
    "descripcion":"GLAUCOMA DE ÁNGULO ABIERTO DE OJO IZQUIERDO DEBIDO A TRAUMATISMO OCULAR Y POSTERIOR A ÉL"
  },
  {
    "codigo":714203003,
    "descripcion":"BRONQUITIS AGUDA CONCOMITANTE CON BRONQUIECTASIAS"
  },
  {
    "codigo":384688004,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA AFECTADO POR CARCINOMA DUCTAL IN SITU"
  },
  {
    "codigo":1269424006,
    "descripcion":"INTOLERANCIA A GLUTEN"
  },
  {
    "codigo":286384007,
    "descripcion":"DIFICULTAD PARA ENCONTRAR LAS PALABRAS"
  },
  {
    "codigo":687881000119100,
    "descripcion":"RABDOMIOSARCOMA PRIMARIO DE PELVIS"
  },
  {
    "codigo":89776009,
    "descripcion":"EFECTO DE BOHR AUMENTADO"
  },
  {
    "codigo":1234821002,
    "descripcion":"LITIASIS INTRAHEPÁTICA PRIMARIA"
  },
  {
    "codigo":284549007,
    "descripcion":"LACERACIÓN DE MANO"
  },
  {
    "codigo":20570000,
    "descripcion":"ACROCORDÓN CENTINELA"
  },
  {
    "codigo":16908041000119102,
    "descripcion":"NEVO EPIDÉRMICO PILOSO PIGMENTADO DE PÁRPADO INFERIOR IZQUIERDO"
  },
  {
    "codigo":446554002,
    "descripcion":"QUEMADURA PROFUNDA DE TERCER GRADO DE CABEZA"
  },
  {
    "codigo":53338001,
    "descripcion":"ARTROPATÍA ASOCIADA CON UNA REACCIÓN DE HIPERSENSIBILIDAD"
  },
  {
    "codigo":315482005,
    "descripcion":"NACIDO EN MONGOLIA"
  },
  {
    "codigo":249946008,
    "descripcion":"DEBILIDAD DE MÚSCULO DE TIPO PIRAMIDAL"
  },
  {
    "codigo":18735004,
    "descripcion":"ONFALOCELE CONGÉNITO"
  },
  {
    "codigo":279044000,
    "descripcion":"SÍNDROME DE DOLOR CORPORAL TOTAL"
  },
  {
    "codigo":1231151009,
    "descripcion":"OSTEONECROSIS DE MANDÍBULA"
  },
  {
    "codigo":442884002,
    "descripcion":"CONDROCALCINOSIS DE ARTICULACIÓN DE MANO"
  },
  {
    "codigo":770564004,
    "descripcion":"ENANISMO PRIMORDIAL MICROCEFÁLICO TIPO ALAZAMI"
  },
  {
    "codigo":703193000,
    "descripcion":"MALFORMACIÓN CONGÉNITA DE SENO DURAL"
  },
  {
    "codigo":277209002,
    "descripcion":"CONTUSIÓN SOBRE LA MASTOIDES"
  },
  {
    "codigo":333731000119101,
    "descripcion":"ÚLCERA DE CÓRNEA MICÓTICA DE OJO DERECHO"
  },
  {
    "codigo":80601004,
    "descripcion":"CON MAYOR RIESGO DE INTOLERANCIA A ACTIVIDAD"
  },
  {
    "codigo":1293017002,
    "descripcion":"HISTIOCITOMA FIBROSO BENIGNO PROFUNDO"
  },
  {
    "codigo":441049004,
    "descripcion":"VIRUS DE INFLUENZA A SUBTIPO H3 PRESENTE"
  },
  {
    "codigo":406446000,
    "descripcion":"DEGENERACIÓN DE LA COROIDES"
  },
  {
    "codigo":111534007,
    "descripcion":"ESTAFILOMA ESCLERAL"
  },
  {
    "codigo":732291000,
    "descripcion":"PORTADOR DE STAPHYLOCOCCUS AUREUS SENSIBLE A METICILINA"
  },
  {
    "codigo":208003001,
    "descripcion":"FRACTURA VERTEBRAL NO EXPUESTA CON LESIÓN POSTERIOR DE MÉDULA ESPINAL CERVICAL, C1-4"
  },
  {
    "codigo":109699004,
    "descripcion":"SECUESTRO MANDIBULAR"
  },
  {
    "codigo":240771005,
    "descripcion":"QUISTE SUBCUTÁNEO FEOHIFOMICÓTICO"
  },
  {
    "codigo":699523006,
    "descripcion":"INFUSIÓN INADECUADA DE NUTRICIÓN ENTERAL"
  },
  {
    "codigo":76931005,
    "descripcion":"MIOCARDIOPATÍA RESTRICTIVA SECUNDARIA A GRANULOMAS"
  },
  {
    "codigo":238936001,
    "descripcion":"ESCLERODERMATOMIOSITIS"
  },
  {
    "codigo":271704002,
    "descripcion":"POSTURA EN FLEXIÓN PARKINSONIANA"
  },
  {
    "codigo":1287512004,
    "descripcion":"ERUPCIÓN CUTÁNEA CAUSADA POR SALMONELLA PARATYPHI B"
  },
  {
    "codigo":9560007,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DE LA EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":402776008,
    "descripcion":"DEFORMIDAD UNGUEAL HEREDITARIA"
  },
  {
    "codigo":75096007,
    "descripcion":"RICKETTSIOSIS PUSTULOSA"
  },
  {
    "codigo":237101004,
    "descripcion":"LEUCORREA"
  },
  {
    "codigo":7725007,
    "descripcion":"NEFRITIS POR RADIACIÓN"
  },
  {
    "codigo":10901411000119108,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO TRIGÉMINO DERECHO"
  },
  {
    "codigo":400941009,
    "descripcion":"HIPERACTIVIDAD DE OBLICUO SUPERIOR"
  },
  {
    "codigo":431874002,
    "descripcion":"INFLAMACIÓN DE RECTO CON PERFORACIÓN CAUSADA POR RADIACIÓN"
  },
  {
    "codigo":71426002,
    "descripcion":"EROTOGRAFOMANÍA"
  },
  {
    "codigo":366338005,
    "descripcion":"TRAZADO DE LA FRECUENCIA CARDÍACA FETAL BASAL - HALLAZGO"
  },
  {
    "codigo":300802007,
    "descripcion":"DIFICULTAD PARA PARTICIPAR EN ACTIVIDADES DEPORTIVAS"
  },
  {
    "codigo":298967001,
    "descripcion":"AMPLITUD DE EXTENSIÓN PASIVA DE LA MUÑECA DISMINUIDA"
  },
  {
    "codigo":724951003,
    "descripcion":"LACERACIÓN DE FASCIA DE MÚSCULO FLEXOR DEL PULGAR A LA ALTURA DEL ANTEBRAZO"
  },
  {
    "codigo":200663004,
    "descripcion":"CELULITIS Y ABSCESO DE PERINEO"
  },
  {
    "codigo":36823005,
    "descripcion":"DIETA NORMAL"
  },
  {
    "codigo":307261000119104,
    "descripcion":"ARTRITIS DE ARTICULACIÓN DE COLUMNA VERTEBRAL DEBIDA A ENFERMEDAD INFLAMATORIA INTESTINAL"
  },
  {
    "codigo":297132000,
    "descripcion":"FRACTURA DE FALANGE DISTAL DEL PULGAR"
  },
  {
    "codigo":11857981000119105,
    "descripcion":"DISTENSIÓN DE MÚSCULO DE LA PIERNA DERECHA"
  },
  {
    "codigo":723116002,
    "descripcion":"ESPONDILOARTRITIS AXIAL"
  },
  {
    "codigo":15953981000119106,
    "descripcion":"HIPERPLASIA BILATERAL DE CONDUCTO GALACTÓFORO MAMARIO"
  },
  {
    "codigo":35031000119100,
    "descripcion":"NEUMONÍA AGUDA POR ASPIRACIÓN"
  },
  {
    "codigo":16009431000119100,
    "descripcion":"EMBOLIA DE ARTERIA DE MIEMBRO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":295297002,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE SULINDACO"
  },
  {
    "codigo":721281003,
    "descripcion":"CONJUNTIVITIS Y DACRIOCISTITIS NEONATALES CAUSADAS POR NEISSERIA GONORRHOEAE"
  },
  {
    "codigo":385006,
    "descripcion":"NEUROPATÍA PERIFÉRICA SECUNDARIA"
  },
  {
    "codigo":293462000,
    "descripcion":"REACCIÓN ADVERSA A DIURÉTICO DE ASA"
  },
  {
    "codigo":129622008,
    "descripcion":"MIOPATÍA NEMALÍNICA, INICIO TARDÍO"
  },
  {
    "codigo":1145430008,
    "descripcion":"HIPOPLASIA CONGÉNITA DE HUESO DE RADIO Y\/O CÚBITO"
  },
  {
    "codigo":160555001,
    "descripcion":"PRÁCTICA RELIGIOSA MODERADA"
  },
  {
    "codigo":282163008,
    "descripcion":"CAMINA PENDIENTE ABAJO"
  },
  {
    "codigo":12241111000119104,
    "descripcion":"TENDINITIS DE CODO IZQUIERDO"
  },
  {
    "codigo":62251004,
    "descripcion":"ENFERMEDAD ALEUTIANA"
  },
  {
    "codigo":95019005,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE RADIO"
  },
  {
    "codigo":291627007,
    "descripcion":"INTOXICACIÓN POR CEFSULODINA"
  },
  {
    "codigo":226091006,
    "descripcion":"DIETA CON BAJO CONTENIDO DE VALINA"
  },
  {
    "codigo":60416001,
    "descripcion":"EDEMA DE LA RINOFARINGE"
  },
  {
    "codigo":193323009,
    "descripcion":"DESPRENDIMIENTO TOTAL DE RETINA, RECIENTE"
  },
  {
    "codigo":715776003,
    "descripcion":"PARAPLEJÍA ESPÁSTICA TIPO 7"
  },
  {
    "codigo":289792002,
    "descripcion":"CUELLO UTERINO ORIENTADO HACIA LA DERECHA"
  },
  {
    "codigo":224256005,
    "descripcion":"MOHO EN SUPERFICIES DEL HOGAR"
  },
  {
    "codigo":16638321000119100,
    "descripcion":"NEURALGIA DE AMBOS NERVIOS PUDENDOS"
  },
  {
    "codigo":27648007,
    "descripcion":"PERIOSTITIS SIFILÍTICA CONGÉNITA"
  },
  {
    "codigo":93184007,
    "descripcion":"HISTIOCITOSIS MALIGNA DE GANGLIOS LINFÁTICOS INTRATORÁCICOS"
  },
  {
    "codigo":58581001,
    "descripcion":"CHOQUE POSTOPERATORIO"
  },
  {
    "codigo":91349007,
    "descripcion":"VOZ EUNUCOIDE"
  },
  {
    "codigo":253354001,
    "descripcion":"ANILLO AURICULAR IZQUIERDO SUPRAMITRAL"
  },
  {
    "codigo":417194006,
    "descripcion":"SENSACIÓN TERMINAL"
  },
  {
    "codigo":251519004,
    "descripcion":"NUBE DE STALBERG"
  },
  {
    "codigo":249684000,
    "descripcion":"CLAVÍCULA ENCORVADA"
  },
  {
    "codigo":336241000119105,
    "descripcion":"QUERATOPATÍA BULLOSA DE OJO DERECHO"
  },
  {
    "codigo":53076002,
    "descripcion":"PERFORACIÓN GÁSTRICA CONGÉNITA"
  },
  {
    "codigo":446292002,
    "descripcion":"LINFADENITIS NECROSANTE"
  },
  {
    "codigo":282452001,
    "descripcion":"LACERACIÓN DE FARINGE"
  },
  {
    "codigo":315220002,
    "descripcion":"ESPERMATOZOIDES INMÓVILES"
  },
  {
    "codigo":118612006,
    "descripcion":"HISTIOCITOSIS MALIGNA"
  },
  {
    "codigo":184148007,
    "descripcion":"EL MÉDICO ABANDONÓ LA PRÁCTICA"
  },
  {
    "codigo":15628811000119100,
    "descripcion":"MANCHA DE FUCHS DE OJO IZQUIERDO"
  },
  {
    "codigo":1073521000119106,
    "descripcion":"ARTRITIS INFECCIOSA DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":247849006,
    "descripcion":"MIEDO A LAS PLUMAS"
  },
  {
    "codigo":15737201000119108,
    "descripcion":"OPACIFICACIÓN DE CÁPSULA POSTERIOR DERECHA QUE NO OBSTACULIZA LA VISIÓN"
  },
  {
    "codigo":213246001,
    "descripcion":"NECROSIS EN EL MUÑÓN DE AMPUTACIÓN"
  },
  {
    "codigo":1263657009,
    "descripcion":"METÁSTASIS DE CARCINOMA DE CÉLULAS TRANSICIONALES EN URÉTER"
  },
  {
    "codigo":209576007,
    "descripcion":"RUPTURA DE LIGAMENTO ACROMIOCLAVICULAR"
  },
  {
    "codigo":1290920009,
    "descripcion":"DERMATOFIBROSARCOMA PROTUBERANS EN PLACA"
  },
  {
    "codigo":109437005,
    "descripcion":"CÚSPIDE DENTAL EXAGERADA"
  },
  {
    "codigo":699261008,
    "descripcion":"OSTEOARTRITIS POSINFECCIOSA"
  },
  {
    "codigo":1156178003,
    "descripcion":"ETAPA DE TERMINACIÓN PARA LA DISPOSICIÓN A MODIFICAR LA CONDUCTA NUTRICIONAL"
  },
  {
    "codigo":42066004,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DE OÍDO"
  },
  {
    "codigo":402514004,
    "descripcion":"CARCINOMA BASOCELULAR DE ANVERSO DE PABELLÓN AURICULAR"
  },
  {
    "codigo":304210006,
    "descripcion":"AMPLITUD DE EXTENSIÓN HORIZONTAL PASIVA DE HOMBRO DISMINUIDA"
  },
  {
    "codigo":369746007,
    "descripcion":"CONFIGURACIÓN TUMORAL QUÍSTICA"
  },
  {
    "codigo":238674006,
    "descripcion":"SARCOIDOSIS CUTÁNEA AGUDA"
  },
  {
    "codigo":9298006,
    "descripcion":"HEMATOMA DE RIÑÓN SIN RUPTURA DE LA CÁPSULA Y SIN HERIDA ABIERTA HACIA CAVIDAD ABDOMINAL"
  },
  {
    "codigo":1252647004,
    "descripcion":"PAREJA NO EMPÁTICA"
  },
  {
    "codigo":202236004,
    "descripcion":"INESTABILIDAD CARPIANA CON SUBLUXACIÓN DORSAL"
  },
  {
    "codigo":235004005,
    "descripcion":"GINGIVITIS ARTEFACTA"
  },
  {
    "codigo":338751000119100,
    "descripcion":"DACRIOCISTITIS FLEMONOSA DE OJO IZQUIERDO"
  },
  {
    "codigo":267772007,
    "descripcion":"FORÚNCULO DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":298705000,
    "descripcion":"HALLAZGO DE REGIÓN DE TÓRAX"
  },
  {
    "codigo":397009000,
    "descripcion":"NEOPLASIA MALIGNA MASTOCÍTICA"
  },
  {
    "codigo":890364009,
    "descripcion":"MACRODACTILIA DE PIE BILATERAL"
  },
  {
    "codigo":69329005,
    "descripcion":"BOCIO UNINODULAR TÓXICO CON CRISIS TIROTÓXICA"
  },
  {
    "codigo":724689006,
    "descripcion":"TRASTORNO PSICÓTICO CAUSADO POR COCAÍNA"
  },
  {
    "codigo":722854006,
    "descripcion":"HIPOGANGLIONOSIS CONGÉNITA DE INTESTINO GRUESO"
  },
  {
    "codigo":1148838007,
    "descripcion":"FUNCIÓN CARDÍACA NORMAL"
  },
  {
    "codigo":426107000,
    "descripcion":"INFARTO LACUNAR AGUDO"
  },
  {
    "codigo":32891000,
    "descripcion":"SÍNDROME DE ROTOR"
  },
  {
    "codigo":295035001,
    "descripcion":"ALERGIA A GUANETIDINA"
  },
  {
    "codigo":427942006,
    "descripcion":"TUMOR FILOIDE DE MAMA, LIMÍTROFE"
  },
  {
    "codigo":296870006,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE TOLBUTAMIDA"
  },
  {
    "codigo":196731005,
    "descripcion":"GASTRODUODENITIS"
  },
  {
    "codigo":424272000,
    "descripcion":"ESTADO INMUNITARIO INADECUADO"
  },
  {
    "codigo":719184001,
    "descripcion":"ATROFIA DE MÚSCULO TRAPECIO"
  },
  {
    "codigo":31056006,
    "descripcion":"HEMORRAGIA ORBITARIA"
  },
  {
    "codigo":162128006,
    "descripcion":"CHORRO URINARIO DÉBIL"
  },
  {
    "codigo":293200008,
    "descripcion":"REACCIÓN ADVERSA A LA TOLAZAMIDA"
  },
  {
    "codigo":422437002,
    "descripcion":"SÍNDROME DE RETARDO MENTAL LIGADO AL CROMOSOMA X CON HÁBITO MARFANOIDE"
  },
  {
    "codigo":94757007,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL CUERPO DEL PENE"
  },
  {
    "codigo":92922003,
    "descripcion":"FORMA ANORMAL CONGÉNITA DE HUESO LAGRIMAL"
  },
  {
    "codigo":1010426004,
    "descripcion":"HIPOPLASIA DE APÓFISIS CORONOIDES DERECHA DE MANDÍBULA"
  },
  {
    "codigo":11863001000119103,
    "descripcion":"ABRASIÓN DE PIEL DE PIE DERECHO"
  },
  {
    "codigo":289530006,
    "descripcion":"HALLAZGO RELACIONADO CON SANGRADO VAGINAL"
  },
  {
    "codigo":254927000,
    "descripcion":"PAPILOMA BENIGNO DE PELVIS RENAL"
  },
  {
    "codigo":713679001,
    "descripcion":"QUISTE DE RETENCIÓN DE CUERPO LÚTEO"
  },
  {
    "codigo":11781081000119105,
    "descripcion":"AMPOLLA TRAUMÁTICA DE ANTEBRAZO DERECHO"
  },
  {
    "codigo":1268900000,
    "descripcion":"LINITIS PLÁSTICA PRIMARIA DE ESTÓMAGO"
  },
  {
    "codigo":710009000,
    "descripcion":"MORFOLOGÍA DE CRESTA ALVEOLAR RESIDUAL DE MAXILAR SUPERIOR CON TORUS PALATINO PRESENTE"
  },
  {
    "codigo":15713241000119107,
    "descripcion":"DEFORMIDAD EN VARO ADQUIRIDA DE ARTICULACIÓN DE AMBAS REGIONES DE MUÑECA"
  },
  {
    "codigo":251257003,
    "descripcion":"REGISTRO DEL SEGMENTO ST INVERTIDO"
  },
  {
    "codigo":216654003,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR AGENTES DE USO DOMÉSTICO"
  },
  {
    "codigo":314958004,
    "descripcion":"APTO PARA REALIZAR ACTIVIDAD"
  },
  {
    "codigo":413262005,
    "descripcion":"EXAMEN INCOMPLETO POR PREPARACIÓN INADECUADA"
  },
  {
    "codigo":247587007,
    "descripcion":"MEMORIA A LARGO PLAZO, DENTRO DE LOS LÍMITES NORMALES"
  },
  {
    "codigo":16376000,
    "descripcion":"ESTENOSIS DUODENAL CONGÉNITA"
  },
  {
    "codigo":442360003,
    "descripcion":"CALCIFICACIÓN DEL BAZO"
  },
  {
    "codigo":737272007,
    "descripcion":"DEPÓSITO SUBCONJUNTIVAL"
  },
  {
    "codigo":440525003,
    "descripcion":"CARCINOMA NEUROENDOCRINO MICROCÍTICO PRIMARIO DE TIMO"
  },
  {
    "codigo":276685005,
    "descripcion":"DACRIOCISTITIS NEONATAL VIRAL"
  },
  {
    "codigo":735437005,
    "descripcion":"TRASTORNO DE LA ADHERENCIA DE LOS NEUTRÓFILOS"
  },
  {
    "codigo":307618001,
    "descripcion":"TUMOR YUXTAGLOMERULAR"
  },
  {
    "codigo":1259725009,
    "descripcion":"MEDULOBLASTOMA PRIMARIO DE CEREBELO"
  },
  {
    "codigo":209314004,
    "descripcion":"FRACTURA-LUXACIÓN EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA DISTAL DE DEDO DE LA MANO"
  },
  {
    "codigo":698999002,
    "descripcion":"ATRESIA DE ACUEDUCTO DE SILVIO"
  },
  {
    "codigo":341261000119104,
    "descripcion":"EDEMA DE CÓRNEA IZQUIERDA CAUSADO POR USO DE LENTE DE CONTACTO"
  },
  {
    "codigo":830071006,
    "descripcion":"ÚLCERA DE PIE IZQUIERDO"
  },
  {
    "codigo":305783007,
    "descripcion":"ATENDIDO POR RADIÓLOGO"
  },
  {
    "codigo":271180000,
    "descripcion":"AMPOLLA TRAUMÁTICA DE EXTREMIDAD INFERIOR, INFECTADA"
  },
  {
    "codigo":404087009,
    "descripcion":"CARCINOSARCOMA DE PIEL"
  },
  {
    "codigo":76407009,
    "descripcion":"ENFERMEDAD POR DEFICIENCIA DE PROTEÍNA C"
  },
  {
    "codigo":41804000,
    "descripcion":"AMPOLLA DE LA AXILA, CON INFECCIÓN"
  },
  {
    "codigo":205644003,
    "descripcion":"TRANSLOCACIÓN AUTOSÓMICA ESTABLE"
  },
  {
    "codigo":402252004,
    "descripcion":"DERMATITIS ALÉRGICA POR CONTACTO DE LA PIEL PERIANAL"
  },
  {
    "codigo":238412006,
    "descripcion":"INFECCIÓN PERIANAL ESTREPTOCÓCICA DEL RECIÉN NACIDO"
  },
  {
    "codigo":1256055008,
    "descripcion":"PIODERMA GANGRENOSO ULCERATIVO"
  },
  {
    "codigo":11810061000119105,
    "descripcion":"ABRASIÓN DE PIEL DE MUSLO DERECHO"
  },
  {
    "codigo":236577001,
    "descripcion":"RECHAZO AGUDO DEL TRASPLANTE RENAL - GRADO III"
  },
  {
    "codigo":367649002,
    "descripcion":"MEMBRANA EPIRRETINIANA"
  },
  {
    "codigo":302113004,
    "descripcion":"UROSTOMÍA, PRESENTE"
  },
  {
    "codigo":1186849007,
    "descripcion":"HEMOCROMATOSIS HEREDITARIA JUVENIL TIPO 2A"
  },
  {
    "codigo":890102000,
    "descripcion":"ATRESIA DE ÍLEON TIPO IIIA"
  },
  {
    "codigo":300278002,
    "descripcion":"HALLAZGO RELACIONADO CON LA APARIENCIA DE LAS AMÍGDALAS"
  },
  {
    "codigo":201974004,
    "descripcion":"EFECTOS DE FUERZAS Y\/O ESTADOS GRAVITACIONALES (G) ANORMALES"
  },
  {
    "codigo":70902004,
    "descripcion":"DEFICIENCIA LONGITUDINAL DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":365814006,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD INTELECTUAL"
  },
  {
    "codigo":298443001,
    "descripcion":"SIN AMPLITUD DE FLEXIÓN LATERAL ACTIVA HACIA LA IZQUIERDA DE LA COLUMNA VERTEBRAL CERVICAL"
  },
  {
    "codigo":724427002,
    "descripcion":"ESTENOSIS ASINTOMÁTICA DE ARTERIA INTRACRANEAL"
  },
  {
    "codigo":167371003,
    "descripcion":"VOLUMEN DE ORINA DE 24 HORAS: EXCESIVO"
  },
  {
    "codigo":429515008,
    "descripcion":"FRACASO DE IMPLANTE ESPINAL"
  },
  {
    "codigo":3531009,
    "descripcion":"CONFLICTO INTRAPSÍQUICO"
  },
  {
    "codigo":69031000119105,
    "descripcion":"MARCAPASOS CARDÍACO BIVENTRICULAR PRESENTE"
  },
  {
    "codigo":720757001,
    "descripcion":"SÍNDROME DE DISPLASIA CRANEOFRONTONASAL CON ANOMALÍA DE POLAND"
  },
  {
    "codigo":1279648009,
    "descripcion":"ABRASIÓN DE ANEXOS OCULARES"
  },
  {
    "codigo":1179509002,
    "descripcion":"ÁCIDO ASCÓRBICO DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":294773004,
    "descripcion":"ALERGIA A ANDRÓGENO"
  },
  {
    "codigo":425845008,
    "descripcion":"HALLAZGO RELACIONADO CON LA PROTRUSIÓN MANDIBULAR"
  },
  {
    "codigo":1144906005,
    "descripcion":"MONONEURITIS MÚLTIPLE DEBIDA A VASCULITIS"
  },
  {
    "codigo":424010006,
    "descripcion":"TENDINITIS DE LA CADERA"
  },
  {
    "codigo":292938007,
    "descripcion":"REACCIÓN ADVERSA A LA TEICOPLANINA"
  },
  {
    "codigo":718922009,
    "descripcion":"DISFUNCIÓN SOMÁTICA DE REGIÓN ABDOMINAL"
  },
  {
    "codigo":127263003,
    "descripcion":"NEOPLASIA DE LOS GANGLIOS LINFÁTICOS INGUINALES SUPERFICIALES"
  },
  {
    "codigo":94495003,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA REGIÓN POSCRICOIDEA"
  },
  {
    "codigo":59892004,
    "descripcion":"INFANTILISMO"
  },
  {
    "codigo":92660005,
    "descripcion":"CARCINOMA IN SITU DE REGIÓN DE LA BOCA"
  },
  {
    "codigo":713417000,
    "descripcion":"PERINEURITIS ÓPTICA"
  },
  {
    "codigo":25289003,
    "descripcion":"HIPERACUSIA"
  },
  {
    "codigo":1081051000119101,
    "descripcion":"CARCINOMA DE CÉLULAS DE MERKEL PRIMARIO DE PIEL DE CADERA DERECHA"
  },
  {
    "codigo":418505005,
    "descripcion":"REACCIÓN ADVERSA A MINERALOCORTICOIDE"
  },
  {
    "codigo":1336009004,
    "descripcion":"GLAUCOMA DEBIDO A QUISTE DE IRIS DE AMBOS OJOS"
  },
  {
    "codigo":343771000119102,
    "descripcion":"RETINOPATÍA BILATERAL POR PREMATUREZ ETAPA 1 - LÍNEA DE DEMARCACIÓN"
  },
  {
    "codigo":254665009,
    "descripcion":"HIPERPLASIA SEUDOEPITELIOMATOSA"
  },
  {
    "codigo":123593009,
    "descripcion":"ATELECTASIA TOTAL DEL PULMÓN IZQUIERDO"
  },
  {
    "codigo":1268638003,
    "descripcion":"ADENOSARCOMA PRIMARIO DE CUELLO UTERINO"
  },
  {
    "codigo":250995006,
    "descripcion":"ORIFICIO IRREGULAR DE VÁLVULA MITRAL"
  },
  {
    "codigo":314696000,
    "descripcion":"TALLA DEL NIÑO: PERCENTILO 51-74"
  },
  {
    "codigo":281928001,
    "descripcion":"FRACTURA DE LA APÓFISIS ESPINOSA DE VÉRTEBRA DORSAL"
  },
  {
    "codigo":283763008,
    "descripcion":"MORDEDURA DE PERRO EN LA REGIÓN PÉLVICA"
  },
  {
    "codigo":183624006,
    "descripcion":"SEGUIMIENTO EN 2-3 MESES"
  },
  {
    "codigo":17949000,
    "descripcion":"MENINGOENCEFALITIS POR TOXOPLASMOSIS ADQUIRIDA"
  },
  {
    "codigo":312861003,
    "descripcion":"GRUPO ÉTNICO NO REGISTRADO"
  },
  {
    "codigo":247325003,
    "descripcion":"SENSIBILIDAD ALTERADA DE LA PIEL"
  },
  {
    "codigo":1197597007,
    "descripcion":"HIPERPLASIA LINFOIDE REACTIVA DE GLÁNDULA LAGRIMAL"
  },
  {
    "codigo":16114001,
    "descripcion":"FRACTURA DE TOBILLO"
  },
  {
    "codigo":442098006,
    "descripcion":"MASA DE PIE"
  },
  {
    "codigo":704242009,
    "descripcion":"INSUFICIENCIA CARDÍACA FETAL DEBIDA A ENFERMEDAD EXTRACARDÍACA"
  },
  {
    "codigo":473031002,
    "descripcion":"COMPLICACIÓN ASOCIADA CON DISPOSITIVO VASCULAR"
  },
  {
    "codigo":1259463002,
    "descripcion":"CARCINOMA ESCAMOSO PRIMARIO DE PULMÓN IZQUIERDO"
  },
  {
    "codigo":276423007,
    "descripcion":"SECCIÓN TRAUMÁTICA DE TENDÓN FLEXOR LARGO - ZONA 2"
  },
  {
    "codigo":210887009,
    "descripcion":"CONTUSIÓN, ARTERIA TIBIAL ANTERIOR"
  },
  {
    "codigo":702407009,
    "descripcion":"HIDROMETROCOLPOS, POLIDACTILIA POSTAXIAL Y MALFORMACIÓN CARDÍACA CONGÉNITA"
  },
  {
    "codigo":47047009,
    "descripcion":"TALASEMIA ASOCIADA A OTRA HEMOGLOBINOPATÍA"
  },
  {
    "codigo":407495009,
    "descripcion":"ENFERMEDAD CAUSADA POR RESPIROVIRUS"
  },
  {
    "codigo":45212007,
    "descripcion":"GENERACIÓN F>1<"
  },
  {
    "codigo":733340008,
    "descripcion":"PREOCUPACIÓN POR EL ASPECTO DE LAS MAMAS"
  },
  {
    "codigo":241820008,
    "descripcion":"PICADURA DE ABEJA"
  },
  {
    "codigo":764273002,
    "descripcion":"ESTENOSIS DE AGUJERO VERTEBRAL LUMBAR"
  },
  {
    "codigo":239985003,
    "descripcion":"LAXITUD LIGAMENTOSA DE LA MUÑECA Y DE LA MANO"
  },
  {
    "codigo":1255793004,
    "descripcion":"LINFOMA DE HODGKIN, VARIANTE ESCLEROSIS NODULAR DE GANGLIOS LINFÁTICOS DE CUELLO"
  },
  {
    "codigo":698737005,
    "descripcion":"HIDROCEFALIA OBSTRUCTIVA DEBIDA A Y DESPUÉS DE MENINGITIS"
  },
  {
    "codigo":895345000,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA BILATERAL DE RIÑÓN"
  },
  {
    "codigo":762438000,
    "descripcion":"NISTAGMO FISIOLÓGICO"
  },
  {
    "codigo":205382001,
    "descripcion":"SÍNDROME DEL ANILLO DE CONSTRICCIÓN DE LA EXTREMIDAD INFERIOR"
  },
  {
    "codigo":371057009,
    "descripcion":"MORDEDURA VENENOSA"
  },
  {
    "codigo":305521009,
    "descripcion":"BAJO ATENCIÓN DE GINECÓLOGO"
  },
  {
    "codigo":403825008,
    "descripcion":"TRICOEPITELIOMAS MÚLTIPLES FAMILIARES"
  },
  {
    "codigo":238150007,
    "descripcion":"SÍNDROME SÉPTICO"
  },
  {
    "codigo":860742008,
    "descripcion":"GRUPO DE GRADO 1 DE GLEASON"
  },
  {
    "codigo":269083002,
    "descripcion":"FRACTURA NO EXPUESTA DE COLLES"
  },
  {
    "codigo":16019471000119104,
    "descripcion":"ATEROSCLEROSIS DE ARTERIA ILÍACA IZQUIERDA"
  },
  {
    "codigo":1119216000,
    "descripcion":"DOLOR EN REGIÓN LUMBAR DERECHA DEL DORSO"
  },
  {
    "codigo":365552003,
    "descripcion":"DETALLES DE INGRESOS - HALLAZGO"
  },
  {
    "codigo":37872007,
    "descripcion":"TRASTORNO DE EVITACIÓN EN LA NIÑEZ O LA ADOLESCENCIA"
  },
  {
    "codigo":298181000,
    "descripcion":"AMPLITUD DE MOVIMIENTO ARTICULAR AUMENTADA"
  },
  {
    "codigo":398320008,
    "descripcion":"FÍSTULA DE URACO"
  },
  {
    "codigo":15665321000119101,
    "descripcion":"COLOBOMA CORIORRETINIANO CONGÉNITO DE OJO DERECHO"
  },
  {
    "codigo":296346004,
    "descripcion":"SOBREDOSIS DE BLOQUEANTE DE RECEPTOR ALFADRENÉRGICO"
  },
  {
    "codigo":673961000119103,
    "descripcion":"BURSITIS GOTOSA DE OLÉCRANON"
  },
  {
    "codigo":335291000119105,
    "descripcion":"ENTROPIÓN DE PÁRPADO DERECHO"
  },
  {
    "codigo":1344922008,
    "descripcion":"PATRÓN DE USO NOCIVO DE KETAMINA"
  },
  {
    "codigo":346281000119104,
    "descripcion":"ATROFIA SECUNDARIA DIFUSA BILATERAL DE COROIDES"
  },
  {
    "codigo":720495005,
    "descripcion":"SÍNDROME DE ANOFTALMÍA Y MEGALOCÓRNEA CON CARDIOPATÍA Y ANOMALÍAS ESQUELÉTICAS"
  },
  {
    "codigo":294511006,
    "descripcion":"ALERGIA A BACAMPICILINA"
  },
  {
    "codigo":816964001,
    "descripcion":"MIEMBRO INFERIOR DERECHO AMPUTADO POR DEBAJO DE LA RODILLA"
  },
  {
    "codigo":65135009,
    "descripcion":"DESCARRILAMIENTO MENTAL"
  },
  {
    "codigo":292676004,
    "descripcion":"REACCIÓN ADVERSA AL PROBENECID"
  },
  {
    "codigo":28697001,
    "descripcion":"LEISHMANIASIS CUTANEOMUCOSA DISEMINADA"
  },
  {
    "codigo":716825004,
    "descripcion":"SPHINGOBACTERIUM MULTIVORUM O SPHINGOBACTERIUM THALPOPHILUM"
  },
  {
    "codigo":389145006,
    "descripcion":"ASMA ALÉRGICA"
  },
  {
    "codigo":94233006,
    "descripcion":"NEOPLASIA SECUNDARIA MALIGNA DE BRONQUIO"
  },
  {
    "codigo":289006000,
    "descripcion":"CAPAZ DE LLEVAR ALIMENTO A LA BOCA"
  },
  {
    "codigo":421913009,
    "descripcion":"POLIFARMACIA NUTRACÉUTICA"
  },
  {
    "codigo":714990000,
    "descripcion":"NO EMPUJA CON MIEMBRO INFERIOR"
  },
  {
    "codigo":127001008,
    "descripcion":"NEOPLASIA DE LA COROIDES"
  },
  {
    "codigo":1083561000119109,
    "descripcion":"LESIÓN DE AMBOS OÍDOS"
  },
  {
    "codigo":92398001,
    "descripcion":"NEOPLASIA BENIGNA DE PARTES BLANDAS DE HOMBRO"
  },
  {
    "codigo":290841006,
    "descripcion":"INTOXICACIÓN POR LOFEPRAMINA"
  },
  {
    "codigo":1237443008,
    "descripcion":"PESO AL NACER MENOR O IGUAL A 1,5 KILOS"
  },
  {
    "codigo":1335747008,
    "descripcion":"NECROSIS AVASCULAR DE HUESO DE REGIÓN DE CODO"
  },
  {
    "codigo":254403009,
    "descripcion":"CARCINOMA IN SITU DEL FRENILLO LABIAL INFERIOR"
  },
  {
    "codigo":449176003,
    "descripcion":"LINFOMA NO HODGKIN DIFUSO DE INTESTINO"
  },
  {
    "codigo":23192006,
    "descripcion":"DISFONÍA COREICA"
  },
  {
    "codigo":55960007,
    "descripcion":"ESTRECHEZ DE CONDUCTO ANAL"
  },
  {
    "codigo":283501005,
    "descripcion":"HERIDA PUNZANTE DE CARA"
  },
  {
    "codigo":445506004,
    "descripcion":"INFLAMACIÓN DE MATRIZ UNGUEAL"
  },
  {
    "codigo":248898004,
    "descripcion":"TAMPÓN EN VAGINA"
  },
  {
    "codigo":412738007,
    "descripcion":"MUTACIÓN DEL GEN BRCA2 POSITIVA"
  },
  {
    "codigo":314434008,
    "descripcion":"PREFERENCIA POR PROFESIONAL FEMENINA DE LA SALUD"
  },
  {
    "codigo":50455002,
    "descripcion":"CURVA ANORMAL DE ADAPTACIÓN A LA OSCURIDAD"
  },
  {
    "codigo":83223005,
    "descripcion":"ENFERMEDAD CAUSADA POR PARVOVIRIDAE"
  },
  {
    "codigo":48620000,
    "descripcion":"NARCOSIS POR NITRÓGENO"
  },
  {
    "codigo":409068001,
    "descripcion":"ESTADO EMOCIONAL NORMAL"
  },
  {
    "codigo":1162732002,
    "descripcion":"ASPARTATO TRANSAMINASA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":210625001,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA, DEDO DE LA MANO A TRAVÉS DE ARTICULACIÓN METACARPOFALÁNGICA"
  },
  {
    "codigo":129501000119107,
    "descripcion":"DOLOR CRÓNICO EN SACRO DE MÁS DE TRES MESES DE DURACIÓN"
  },
  {
    "codigo":103031000119101,
    "descripcion":"EXPOSICIÓN FETAL A SUSTANCIA TERATÓGENA"
  },
  {
    "codigo":767681003,
    "descripcion":"HERNIA INGUINAL IZQUIERDA RECURRENTE CON GANGRENA"
  },
  {
    "codigo":46785007,
    "descripcion":"NEFROPATÍA GOTOSA FAMILIAR"
  },
  {
    "codigo":44950000,
    "descripcion":"LORDOSIS ADQUIRIDA"
  },
  {
    "codigo":472769009,
    "descripcion":"RESTRICCIÓN EXCESIVA DE COMUNICACIÓN INTERAURICULAR COMO COMPLICACIÓN DE PROCEDIMIENTO"
  },
  {
    "codigo":658011000005105,
    "descripcion":"PLACENTA DE UBICACIÓN BAJA EN PARED ANTERIOR DEL ÚTERO"
  },
  {
    "codigo":77718003,
    "descripcion":"INTOXICACIÓN POR ESTREPTOQUINASA"
  },
  {
    "codigo":208790004,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE LA ARTICULACIÓN RADIOCUBITAL SUPERIOR"
  },
  {
    "codigo":1086071000119103,
    "descripcion":"NEFROPATÍA TUBULOINTERSTICIAL DIFTÉRICA"
  },
  {
    "codigo":239723003,
    "descripcion":"DEFICIENCIA DE LOS LIGAMENTOS DE LA RODILLA"
  },
  {
    "codigo":10347006,
    "descripcion":"URTICARIA SOLAR"
  },
  {
    "codigo":698475006,
    "descripcion":"MONOARTRITIS DE MANO"
  },
  {
    "codigo":29951000175108,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN EN DORSO DE PIE DERECHO"
  },
  {
    "codigo":237888005,
    "descripcion":"RAQUITISMO HIPOFOSFATÉMICO CON ENANISMO NEFRÓTICO -GLUCOSÚRICO"
  },
  {
    "codigo":399893000,
    "descripcion":"TRASTORNO DE PIEL DE CUELLO"
  },
  {
    "codigo":1055253001,
    "descripcion":"AGENESIA DE EPÍFISIS DE FALANGE MEDIA DE DEDO ANULAR"
  },
  {
    "codigo":236053002,
    "descripcion":"HERNIA HIATAL POR DESLIZAMIENTO"
  },
  {
    "codigo":301589003,
    "descripcion":"INCAPAZ DE MANEJARSE EN ESCALERAS"
  },
  {
    "codigo":6677000,
    "descripcion":"INFECCIÓN CAUSADA POR SIMONDSIA"
  },
  {
    "codigo":299754001,
    "descripcion":"REFLEJO DE HOCIQUEO AUSENTE"
  },
  {
    "codigo":398058003,
    "descripcion":"DOLOR DURANTE LA ANESTESIA REGIONAL PARA CESÁREA"
  },
  {
    "codigo":234218004,
    "descripcion":"FALLA DE CAPTURA DEL MARCAPASOS"
  },
  {
    "codigo":365290005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA CONTROLAR LA TEMPERATURA DEL AGUA DOMÉSTICA"
  },
  {
    "codigo":37610005,
    "descripcion":"ENFERMEDAD INFLAMATORIA DEL CUELLO UTERINO"
  },
  {
    "codigo":266986008,
    "descripcion":"RECIBE EDUCACIÓN PARA ADULTOS"
  },
  {
    "codigo":723903001,
    "descripcion":"TRASTORNO BIPOLAR TIPO I, ACTUALMENTE EN REMISIÓN COMPLETA"
  },
  {
    "codigo":232383004,
    "descripcion":"DERMOIDE NASAL"
  },
  {
    "codigo":68543009,
    "descripcion":"ONICOMICOSIS CAUSADA POR EPIDERMOPHYTON FLOCCOSUM"
  },
  {
    "codigo":296084002,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE BROMAZEPAM"
  },
  {
    "codigo":787604003,
    "descripcion":"PARÁLISIS COMPLETA DE CUERDA VOCAL DERECHA"
  },
  {
    "codigo":1344660001,
    "descripcion":"PÓLIPO ADENOMATOSO TUBULOVELLOSO DE COLON"
  },
  {
    "codigo":11791121000119106,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DE MANO DERECHA"
  },
  {
    "codigo":359785002,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA AL DOMO DE LA VEJIGA"
  },
  {
    "codigo":294249006,
    "descripcion":"ALERGIA A PROSTAGLANDINA"
  },
  {
    "codigo":292414000,
    "descripcion":"REACCIÓN ADVERSA AL GRUPO DE ANFETAMINAS"
  },
  {
    "codigo":423486005,
    "descripcion":"COLAGENOPATÍA EOSINOFÍLICA DISEMINADA"
  },
  {
    "codigo":295851000119103,
    "descripcion":"TRAYECTO FISTULOSO PRODUCTIVO CONCOMITANTE CON OSTEOMIELITIS CRÓNICA DE FÉMUR Y DEBIDO A ELLA"
  },
  {
    "codigo":63038006,
    "descripcion":"ESPÉCIMEN ENMASCARADO POR INFLAMACIÓN"
  },
  {
    "codigo":126739000,
    "descripcion":"NEOPLASIA DE VASO SANGUÍNEO DE LA CARA"
  },
  {
    "codigo":30270006,
    "descripcion":"INFECCIÓN CAUSADA POR VIRUS PARAINFLUENZA 3 HUMANO"
  },
  {
    "codigo":93971002,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA PARED POSTERIOR DE LA OROFARINGE"
  },
  {
    "codigo":46651000087102,
    "descripcion":"FRACTURA DE FALANGE DISTAL DE ÍNDICE IZQUIERDO"
  },
  {
    "codigo":41531000087103,
    "descripcion":"HERIDA PUNZANTE DE EXTREMIDAD INFERIOR IZQUIERDA"
  },
  {
    "codigo":38971000087104,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE DEDOS SEGUNDO A QUINTO DE PIE DERECHO"
  },
  {
    "codigo":33851000087105,
    "descripcion":"INTOXICACIÓN CAUSADA POR COMPUESTO QUÍMICO CORROSIVO"
  },
  {
    "codigo":1306387009,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE CUADRANTE SUPERIOR EXTERNO DE MAMA"
  },
  {
    "codigo":190440000,
    "descripcion":"SECRECIÓN EXCESIVA DE GLUCAGÓN"
  },
  {
    "codigo":44091000087109,
    "descripcion":"HERIDA CORTANTE DE RODILLA DERECHA"
  },
  {
    "codigo":288744005,
    "descripcion":"CAPAZ DE HACERSE ENTENDER"
  },
  {
    "codigo":92136007,
    "descripcion":"NEOPLASIA BENIGNA DEL NERVIO HIPOGLOSO"
  },
  {
    "codigo":712893003,
    "descripcion":"LESIÓN DE ESPALDA"
  },
  {
    "codigo":678981000119101,
    "descripcion":"QUERATOPATÍA BULLOSA AFÁQUICA DE OJO IZQUIERDO"
  },
  {
    "codigo":286909009,
    "descripcion":"TIROTOXICOSIS CON O SIN BOCIO"
  },
  {
    "codigo":1237181009,
    "descripcion":"FORMA SINTOMÁTICA DE HEMOCROMATOSIS TIPO 1"
  },
  {
    "codigo":711058008,
    "descripcion":"DOLOR FANTASMA POSTERIOR A AMPUTACIÓN DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":86631001,
    "descripcion":"AUSENCIA DE SIGNOS"
  },
  {
    "codigo":21095000,
    "descripcion":"HIPERPROLACTINEMIA SECUNDARIA"
  },
  {
    "codigo":283239001,
    "descripcion":"VIDRIO EN LA FRENTE"
  },
  {
    "codigo":53863007,
    "descripcion":"APRAXIA MOTORA"
  },
  {
    "codigo":1088581000119105,
    "descripcion":"OTITIS MEDIA CRÓNICA TUBOTIMPÁNICA SUPURATIVA DE OÍDO MEDIO IZQUIERDO"
  },
  {
    "codigo":248636001,
    "descripcion":"PULSO RETRASADO"
  },
  {
    "codigo":19260006,
    "descripcion":"UMBRAL CONVULSIVO DISMINUIDO"
  },
  {
    "codigo":1231676006,
    "descripcion":"UVEÍTIS POSTERIOR DEBIDA A ENFERMEDAD DE VOGT KOYANAGI HARADA"
  },
  {
    "codigo":1295377001,
    "descripcion":"ACANTOMA DE CÉLULAS GRANDES"
  },
  {
    "codigo":707388009,
    "descripcion":"CARCINOMA PRIMARIO DE CÉLULAS ESCAMOSAS DE TRÁQUEA"
  },
  {
    "codigo":212198000,
    "descripcion":"LESIÓN DE LA RAÍZ DEL NERVIO CERVICAL - C2"
  },
  {
    "codigo":17425008,
    "descripcion":"INFECCIÓN CAUSADA POR STRONGYLOIDES STERCORALIS"
  },
  {
    "codigo":10837061000119109,
    "descripcion":"FRACTURA EXPUESTA DE PORCIÓN PROXIMAL DE PERONÉ IZQUIERDO"
  },
  {
    "codigo":351301000119109,
    "descripcion":"NEOPLASIA BENIGNA DE TESTÍCULO DERECHO"
  },
  {
    "codigo":310502008,
    "descripcion":"DIETA MALA"
  },
  {
    "codigo":210363001,
    "descripcion":"HERIDA ABIERTA DE LA LENGUA"
  },
  {
    "codigo":46523000,
    "descripcion":"ÚLCERA GASTROYEYUNAL CRÓNICA CON HEMORRAGIA Y PERFORACIÓN PERO SIN OBSTRUCCIÓN"
  },
  {
    "codigo":441574008,
    "descripcion":"ATEROSCLEROSIS ARTERIAL"
  },
  {
    "codigo":79291003,
    "descripcion":"LUPUS ERITEMATOSO DISCOIDE DEL PÁRPADO"
  },
  {
    "codigo":11920000,
    "descripcion":"LUXACIÓN EXPUESTA DE CODO"
  },
  {
    "codigo":208528000,
    "descripcion":"FRACTURA NO EXPUESTA DE FÉMUR PROXIMAL, SUBCAPITAL, GRADO I DE GARDEN"
  },
  {
    "codigo":77456003,
    "descripcion":"INFECCIÓN CAUSADA POR AUSTROBILHARZIA"
  },
  {
    "codigo":110224006,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO DEL PALADAR BLANDO"
  },
  {
    "codigo":863888006,
    "descripcion":"AGUDEZA VISUAL DE OJO IZQUIERDO 6\/60"
  },
  {
    "codigo":700048007,
    "descripcion":"AL CUIDADO DE CABEZA DE FAMILIA DE SEXO FEMENINO"
  },
  {
    "codigo":12203231000119107,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DE MUSLO IZQUIERDO"
  },
  {
    "codigo":42853003,
    "descripcion":"PÉRDIDA DE LA AUDICIÓN, PARADÓJICA"
  },
  {
    "codigo":10085004,
    "descripcion":"METATARSALGIA"
  },
  {
    "codigo":1255269005,
    "descripcion":"SÍNDROME DE HIPERNATREMIA ADÍPSICA HIPOTALÁMICA"
  },
  {
    "codigo":403301006,
    "descripcion":"ONICÓLISIS MEDICAMENTOSA"
  },
  {
    "codigo":1156965004,
    "descripcion":"MIELOPATÍA DEBIDA A ESPONDILOSIS CERVICAL DE UN NIVEL"
  },
  {
    "codigo":370533008,
    "descripcion":"ESTANCAMIENTO DEL CHI"
  },
  {
    "codigo":73786005,
    "descripcion":"INTOXICACIÓN POR OXYTROPIS"
  },
  {
    "codigo":8250007,
    "descripcion":"TUBERCULOSIS DEL TEJIDO CELULAR SUBCUTÁNEO"
  },
  {
    "codigo":203023002,
    "descripcion":"ABSCESO MUSCULAR DE BRAZO"
  },
  {
    "codigo":268559007,
    "descripcion":"NO AUTORIZA NINGUNA INMUNIZACIÓN"
  },
  {
    "codigo":365028001,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA EXPECTORAR"
  },
  {
    "codigo":233956002,
    "descripcion":"ATEROSCLEROSIS AORTOILÍACA"
  },
  {
    "codigo":102884003,
    "descripcion":"SECRECIÓN PLACENTARIA DE GONADOTROFINA CORIÓNICA DISMINUIDA"
  },
  {
    "codigo":108051000119101,
    "descripcion":"LATEROGNATIA MANDIBULAR"
  },
  {
    "codigo":232121005,
    "descripcion":"DEFECTO PUPILAR AFERENTE"
  },
  {
    "codigo":164750000,
    "descripcion":"ANOMALÍA EN LA AUDIOMETRÍA BILATERAL"
  },
  {
    "codigo":721806000,
    "descripcion":"INFECCIÓN CAUSADA POR SCYTALIDIUM"
  },
  {
    "codigo":230286002,
    "descripcion":"DEMENCIA VASCULAR SUBCORTICAL"
  },
  {
    "codigo":295822006,
    "descripcion":"SOBREDOSIS DE LISURIDA"
  },
  {
    "codigo":263054007,
    "descripcion":"SUBLUXACIÓN DE DEDO DE LA MANO"
  },
  {
    "codigo":293987002,
    "descripcion":"ALERGIA A DOXAZOSINA"
  },
  {
    "codigo":195683003,
    "descripcion":"LARINGITIS FLEMONOSA AGUDA"
  },
  {
    "codigo":353811000119104,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE CÓRNEA DE OJO DERECHO"
  },
  {
    "codigo":392291006,
    "descripcion":"GLAUCOMA POR CIERRE DE ÁNGULO"
  },
  {
    "codigo":1091091000119105,
    "descripcion":"INFLAMACIÓN CRÓNICA DE MEMBRANA TIMPÁNICA DERECHA"
  },
  {
    "codigo":64611009,
    "descripcion":"RINORREA CATARRAL"
  },
  {
    "codigo":2451000124101,
    "descripcion":"PRIMER PREMOLAR INFERIOR IZQUIERDO PERMANENTE SUPERNUMERARIO"
  },
  {
    "codigo":95544006,
    "descripcion":"DIARREA INFLAMATORIA"
  },
  {
    "codigo":292152008,
    "descripcion":"REACCIÓN ADVERSA AL MEPENZOLATO"
  },
  {
    "codigo":290317002,
    "descripcion":"INTOXICACIÓN POR RADIOFÁRMACO"
  },
  {
    "codigo":93709005,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE VASO SANGUÍNEO DE MUSLO"
  },
  {
    "codigo":124642002,
    "descripcion":"DEFICIENCIA DE OXO - ÁCIDO - LIASA"
  },
  {
    "codigo":1304290003,
    "descripcion":"TRASTORNO PSICÓTICO CAUSADO POR ANFETAMINA Y\/O DERIVADO DE ANFETAMINA"
  },
  {
    "codigo":59106005,
    "descripcion":"ANEMIA POR PRODUCCIÓN DISMINUIDA DE GLÓBULOS ROJOS"
  },
  {
    "codigo":286647002,
    "descripcion":"AUTOESTIMA BAJA"
  },
  {
    "codigo":253879006,
    "descripcion":"RIÑÓN POLIQUÍSTICO DEL ADULTO TIPO 2"
  },
  {
    "codigo":219276000,
    "descripcion":"LESIÓN TRAUMÁTICA POR INTERVENCIÓN LEGAL, GOLPEADO POR PORRA"
  },
  {
    "codigo":1204151009,
    "descripcion":"INFARTO AGUDO INFERIOR DE MIOCARDIO DE VENTRÍCULO DERECHO SIN ELEVACIÓN DE SEGMENTO ST"
  },
  {
    "codigo":22668006,
    "descripcion":"ESTENOSIS SUBGLÓTICA"
  },
  {
    "codigo":284812006,
    "descripcion":"NO SE SIENTA EN LA BAÑERA"
  },
  {
    "codigo":20833001,
    "descripcion":"INFESTACIÓN CAUSADA POR COCHLIOMYIA"
  },
  {
    "codigo":282977007,
    "descripcion":"SE INCLINA"
  },
  {
    "codigo":1003873008,
    "descripcion":"DISOMÍA UNIPARENTAL DE ORIGEN PATERNO DEL CROMOSOMA 11"
  },
  {
    "codigo":84534001,
    "descripcion":"APENDICITIS FULMINANTE AGUDA"
  },
  {
    "codigo":1264182002,
    "descripcion":"TRASTORNO NEONATAL CAUSADO POR ANALGESIA MATERNA TRANSMITIDA POR LECHE MATERNA"
  },
  {
    "codigo":51766000,
    "descripcion":"INTOXICACIÓN POR ADENIUM MULTIFLORUM"
  },
  {
    "codigo":248374004,
    "descripcion":"CRÁNEO AMPLIO"
  },
  {
    "codigo":1296950006,
    "descripcion":"TEMOR AL OLOR DEL PROPIO CUERPO"
  },
  {
    "codigo":51763008,
    "descripcion":"INFECCIÓN CAUSADA POR MENINGONEMA PERUZZI"
  },
  {
    "codigo":82699004,
    "descripcion":"SÍNDROME DE DYGGVE-MELCHIOR-CLAUSEN"
  },
  {
    "codigo":246539005,
    "descripcion":"CONVULSIÓN CON ALUCINACIONES ESTRUCTURADAS"
  },
  {
    "codigo":310240007,
    "descripcion":"SITUACIÓN DE PESQUISA PARA ALTERACIONES AUDITIVAS"
  },
  {
    "codigo":373941003,
    "descripcion":"MASA VENTRICULAR IZQUIERDA"
  },
  {
    "codigo":898229003,
    "descripcion":"SINOSTOSIS CONGÉNITA DE HUESO TARSIANO Y METATARSIANO"
  },
  {
    "codigo":275637004,
    "descripcion":"DERIVADO AL HEMATÓLOGO"
  },
  {
    "codigo":13493007,
    "descripcion":"EXOTROPÍA ALTERNANTE CON PATRÓN X Y\/O Y"
  },
  {
    "codigo":109962001,
    "descripcion":"LINFOMA NO HODGKIN DIFUSO"
  },
  {
    "codigo":372106005,
    "descripcion":"CARCINOMA DE PENE"
  },
  {
    "codigo":271967002,
    "descripcion":"TRASTORNO DEL PARAGUAS EN LA VENA CAVA"
  },
  {
    "codigo":239199003,
    "descripcion":"PÉRDIDA COMPLETA DEL COLGAJO"
  },
  {
    "codigo":403039007,
    "descripcion":"TIÑA CORPORAL CAUSADA POR TRICHOPHYTON SCHOENLEINII"
  },
  {
    "codigo":42591009,
    "descripcion":"FRACTURA EXPUESTA DE HUESO TRAPEZOIDE DE MUÑECA"
  },
  {
    "codigo":237364002,
    "descripcion":"MORTINATO"
  },
  {
    "codigo":302900006,
    "descripcion":"INFLAMACIÓN AGUDA DE LOS CONDUCTOS LAGRIMALES"
  },
  {
    "codigo":366601002,
    "descripcion":"HALLAZGO RELACIONADO CON COLORACIÓN DE ARTICULACIÓN DE RODILLA"
  },
  {
    "codigo":202761002,
    "descripcion":"ESTENOSIS DE CONDUCTO RAQUÍDEO CERVICAL DE CAUSA DEGENERATIVA"
  },
  {
    "codigo":10897531000119101,
    "descripcion":"HERIDA ABIERTA DE GENITALES EXTERNOS FEMENINOS"
  },
  {
    "codigo":169993007,
    "descripcion":"AMAMANTADO Y ALIMENTADO CON SUPLEMENTOS A LOS 9 MESES"
  },
  {
    "codigo":364766001,
    "descripcion":"RUTINA ALIMENTARIA - HALLAZGO"
  },
  {
    "codigo":102622004,
    "descripcion":"REGURGITACIÓN DE ALIMENTOS"
  },
  {
    "codigo":299230005,
    "descripcion":"PROTRUSIÓN DE LA CADERA"
  },
  {
    "codigo":233694004,
    "descripcion":"NEUMOPATÍA DE LA PERRERA"
  },
  {
    "codigo":10924001000119109,
    "descripcion":"FRACTURA NO EXPUESTA DE BASE DE QUINTO HUESO METACARPIANO DE MANO IZQUIERDA"
  },
  {
    "codigo":68019004,
    "descripcion":"DEPRESIÓN MAYOR RECURRENTE EN REMISIÓN"
  },
  {
    "codigo":338901000119101,
    "descripcion":"SÍNDROME OCULOGLANDULAR DE PARINAUD DE OJO IZQUIERDO"
  },
  {
    "codigo":308181000119100,
    "descripcion":"DEFORMIDAD EN FLEXIÓN DE ARTICULACIÓN DE CADERA IZQUIERDA"
  },
  {
    "codigo":1081301000119103,
    "descripcion":"OSTEOSARCOMA PRIMARIO DE HUESO DE EXTREMIDAD INFERIOR IZQUIERDA"
  },
  {
    "codigo":15934421000119104,
    "descripcion":"COXA VALGA CONGÉNITA IZQUIERDA"
  },
  {
    "codigo":721544001,
    "descripcion":"HEMANGIOMA DE CORDÓN UMBILICAL"
  },
  {
    "codigo":85461000119106,
    "descripcion":"FLICTÉNULA"
  },
  {
    "codigo":323451861000119105,
    "descripcion":"ESTENOSIS DE ESTOMA DE ILIOSTOMÍA"
  },
  {
    "codigo":157141000119108,
    "descripcion":"PROTEINURIA DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":11828181000119109,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO CUÁDRICEPS FEMORAL IZQUIERDO"
  },
  {
    "codigo":15972821000119108,
    "descripcion":"RADICULOPATÍA DE COLUMNA VERTEBRAL LUMBOSACRA DEBIDA A TRASTORNO DE DISCO"
  },
  {
    "codigo":10852821000119109,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO DIGITAL DE DEDO ANULAR DERECHO"
  },
  {
    "codigo":11797461000119104,
    "descripcion":"AMPOLLA DE DORSO INFERIOR CON INFECCIÓN"
  },
  {
    "codigo":328661000119108,
    "descripcion":"ENFERMEDAD INTERSTICIAL PULMONAR DE LA INFANCIA"
  },
  {
    "codigo":320981000119109,
    "descripcion":"ENTESOPATÍA ESPINAL DE REGIÓN CERVICAL"
  },
  {
    "codigo":262792005,
    "descripcion":"DESGARRO DE LA CAPA SEROSA DEL ESÓFAGO"
  },
  {
    "codigo":16441621000119100,
    "descripcion":"DISFUNCIÓN SEXUAL CAUSADA POR FÁRMACO"
  },
  {
    "codigo":310741000119108,
    "descripcion":"MIOSITIS INFECCIOSA DE PIERNA DERECHA"
  },
  {
    "codigo":392029006,
    "descripcion":"SÍNDROME DE UVEÍTIS-GLAUCOMA-HIFEMA"
  },
  {
    "codigo":293725003,
    "descripcion":"ALERGIA A TETRACAÍNA"
  },
  {
    "codigo":128050000,
    "descripcion":"NEOPLASIA DEL ABDOMEN"
  },
  {
    "codigo":291890001,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR PLASMA SANGUÍNEO"
  },
  {
    "codigo":195421009,
    "descripcion":"FLEBITIS DE LA VENA ILÍACA COMÚN"
  },
  {
    "codigo":95282002,
    "descripcion":"ARCO SUPERNUMERARIO DE VÉRTEBRA CERVICAL"
  },
  {
    "codigo":816178004,
    "descripcion":"RETINOPATÍA NO PROLIFERATIVA DE OJO DERECHO DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":27911000,
    "descripcion":"LAXITUD DE LIGAMENTO"
  },
  {
    "codigo":29746009,
    "descripcion":"DISTRIBUCIÓN NORMAL"
  },
  {
    "codigo":717874009,
    "descripcion":"DUODENITIS LINFOCÍTICA"
  },
  {
    "codigo":290055002,
    "descripcion":"MAMA DE TAMAÑO NORMAL"
  },
  {
    "codigo":93447004,
    "descripcion":"RINITIS NO ALÉRGICA EOSINOFÍLICA"
  },
  {
    "codigo":224519002,
    "descripcion":"PROBLEMA CON CUIDADOR INFORMAL"
  },
  {
    "codigo":11827631000119100,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA DE SEGUNDO A QUINTO DEDOS DE PIE IZQUIERDO"
  },
  {
    "codigo":124380007,
    "descripcion":"DEFICIENCIA DE TRANSCARBAMOILASA"
  },
  {
    "codigo":91612009,
    "descripcion":"ESCLERITIS GELATINOSA"
  },
  {
    "codigo":1269425007,
    "descripcion":"ALERGIA A GLUTEN"
  },
  {
    "codigo":384689007,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA AFECTADO POR NEOPLASIA MALIGNA"
  },
  {
    "codigo":22406001,
    "descripcion":"INMUNODEFICIENCIA COMBINADA SEVERA POR AUSENCIA DE CÉLULAS MADRE LINFOIDES"
  },
  {
    "codigo":57009009,
    "descripcion":"PROTEINURIA FUNCIONAL"
  },
  {
    "codigo":15950101000119108,
    "descripcion":"CARCINOMA BASOCELULAR PRIMARIO DE PIEL DE MAMA DERECHA"
  },
  {
    "codigo":415622003,
    "descripcion":"TUBERCULOSIS RESISTENTE A LA ESTREPTOMICINA"
  },
  {
    "codigo":284550007,
    "descripcion":"HERIDA ABIERTA EN LA REGIÓN SACROILÍACA"
  },
  {
    "codigo":315483000,
    "descripcion":"NACIDO EN MARRUECOS"
  },
  {
    "codigo":1003611001,
    "descripcion":"SUFUSIÓN CONJUNTIVAL"
  },
  {
    "codigo":1234822009,
    "descripcion":"DUCTOPENIA IDIOPÁTICA"
  },
  {
    "codigo":708699002,
    "descripcion":"CRIBADO PARA CÁNCER COLORRECTAL BASADO EN ADN EN MATERIA FECAL POSITIVO"
  },
  {
    "codigo":249947004,
    "descripcion":"FUERZA MUSCULAR DESIGUAL"
  },
  {
    "codigo":16005551000119105,
    "descripcion":"CELULITIS DE CODO IZQUIERDO"
  },
  {
    "codigo":53339009,
    "descripcion":"DUELO DISFUNCIONAL"
  },
  {
    "codigo":10680751000119105,
    "descripcion":"NÓDULO DE PIEL DE MANO IZQUIERDA"
  },
  {
    "codigo":4681000119100,
    "descripcion":"ALTERACIÓN DEL SUEÑO EN LA LACTANCIA"
  },
  {
    "codigo":84272007,
    "descripcion":"TROMBOSIS DE LA AORTA ABDOMINAL"
  },
  {
    "codigo":15733321000119100,
    "descripcion":"QUISTE PRIMARIO DE RETINA IZQUIERDA"
  },
  {
    "codigo":16901001,
    "descripcion":"ENCEFALITIS CAUSADA POR VIRUS DE ENCEFALITIS EUROPEA TRANSMITIDA POR GARRAPATAS"
  },
  {
    "codigo":770565003,
    "descripcion":"ENANISMO PRIMORDIAL MICROCEFÁLICO TIPO DAUBER"
  },
  {
    "codigo":332361000119101,
    "descripcion":"RETINOPATÍA POR PREMATUREZ DE OJO DERECHO, ETAPA 4 - DESPRENDIMIENTO SUBTOTAL DE RETINA"
  },
  {
    "codigo":703194006,
    "descripcion":"INSUFICIENCIA DE VÁLVULA TRICÚSPIDE POSTERIOR A PROCEDIMIENTO"
  },
  {
    "codigo":277210007,
    "descripcion":"DOLOR A LA PALPACIÓN EN APÓFISIS MASTOIDES"
  },
  {
    "codigo":80602006,
    "descripcion":"TUBERCULOSIS NODULAR DEL PULMÓN"
  },
  {
    "codigo":1293018007,
    "descripcion":"DEFICIENCIA DE METILMALONIL COENZIMA A EPIMERASA"
  },
  {
    "codigo":373679006,
    "descripcion":"NIVEL DE ASPARTATO TRANSAMINASA"
  },
  {
    "codigo":699524000,
    "descripcion":"INFUSIÓN INADECUADA DE NUTRICIÓN PARENTERAL"
  },
  {
    "codigo":111535008,
    "descripcion":"NECROSIS PARCIAL DE LOS HUESECILLOS DEL OÍDO"
  },
  {
    "codigo":1354884002,
    "descripcion":"USA MÉTODOS INSEGUROS PARA CALEFACCIONAR LA VIVIENDA DEBIDO A RECURSOS ECONÓMICOS LIMITADOS"
  },
  {
    "codigo":109700003,
    "descripcion":"EXOSTOSIS BUCAL"
  },
  {
    "codigo":406447009,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR OLEANDOMICINA"
  },
  {
    "codigo":308143008,
    "descripcion":"ARTRITIS REUMATOIDE EROSIVA SEROPOSITIVA"
  },
  {
    "codigo":240772003,
    "descripcion":"FEOHIFOMICOSIS DISEMINADA"
  },
  {
    "codigo":1254745003,
    "descripcion":"METÁSTASIS DE CARCINOMA DE CÉLULAS GIGANTES EN PULMÓN IZQUIERDO"
  },
  {
    "codigo":238937005,
    "descripcion":"PÉNFIGO VEGETANTE DE TIPO NEUMANN"
  },
  {
    "codigo":106030000,
    "descripcion":"HALLAZGO RELACIONADO CON EL MÚSCULO"
  },
  {
    "codigo":1287513009,
    "descripcion":"ERUPCIÓN CUTÁNEA CAUSADA POR SALMONELLA PARATYPHI C"
  },
  {
    "codigo":400942002,
    "descripcion":"ESTRABISMO PARALÍTICO"
  },
  {
    "codigo":10873571000119103,
    "descripcion":"HERIDA ABIERTA DE OÍDO IZQUIERDO"
  },
  {
    "codigo":237102006,
    "descripcion":"HEMATOMA DE LA CÚPULA VAGINAL"
  },
  {
    "codigo":40494007,
    "descripcion":"ALVEOLITIS DE LA MANDÍBULA"
  },
  {
    "codigo":431875001,
    "descripcion":"HERIDA ABIERTA DE CARA CON CUERPO EXTRAÑO"
  },
  {
    "codigo":169731002,
    "descripcion":"MOVIMIENTOS FETALES OBSERVADOS"
  },
  {
    "codigo":366339002,
    "descripcion":"FORMA GENERAL DE LA PELVIS - HALLAZGO"
  },
  {
    "codigo":399107008,
    "descripcion":"LESIÓN DE NERVIO CIÁTICO POPLÍTEO EXTERNO"
  },
  {
    "codigo":167896005,
    "descripcion":"RECUENTO CELULAR DE LÍQUIDO SINOVIAL: NORMAL"
  },
  {
    "codigo":724952005,
    "descripcion":"LACERACIÓN DE TENDÓN FLEXOR DE PULGAR A LA ALTURA DEL ANTEBRAZO"
  },
  {
    "codigo":298968006,
    "descripcion":"SIN AMPLITUD PASIVA DE EXTENSIÓN DE LA MUÑECA"
  },
  {
    "codigo":297133005,
    "descripcion":"FRACTURA DE FALANGE PROXIMAL DEL PULGAR"
  },
  {
    "codigo":723117006,
    "descripcion":"TEMOR A ENFERMEDAD MUSCULOESQUELÉTICA"
  },
  {
    "codigo":262530001,
    "descripcion":"PETEQUIAS TRAUMÁTICAS"
  },
  {
    "codigo":360834005,
    "descripcion":"DEFICIENCIA DE ARILSULFATASA"
  },
  {
    "codigo":426370008,
    "descripcion":"LEUCEMIA LINFOIDE SUBAGUDA EN REMISIÓN"
  },
  {
    "codigo":129623003,
    "descripcion":"SÍNDROME ENDOTELIAL IRIDOCORNEAL"
  },
  {
    "codigo":293463005,
    "descripcion":"REACCIÓN ADVERSA A LA FUROSEMIDA"
  },
  {
    "codigo":1145431007,
    "descripcion":"HIPOPLASIA CONGÉNITA DE CABEZA Y CUELLO DE FÉMUR"
  },
  {
    "codigo":160556000,
    "descripcion":"PRÁCTICA RELIGIOSA ESTRICTA"
  },
  {
    "codigo":29484002,
    "descripcion":"COLELITIASIS Y COLECISTITIS SIN OBSTRUCCIÓN"
  },
  {
    "codigo":291628002,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR CEFSULODINA"
  },
  {
    "codigo":95020004,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA UNIÓN RECTOSIGMOIDE"
  },
  {
    "codigo":783148005,
    "descripcion":"MIOPATÍA NEBULÍNICA DISTAL"
  },
  {
    "codigo":226092004,
    "descripcion":"DIETA CON BAJO CONTENIDO DE LISINA"
  },
  {
    "codigo":193324003,
    "descripcion":"DESPRENDIMIENTO SUBTOTAL DE RETINA, RECIENTE"
  },
  {
    "codigo":422700009,
    "descripcion":"AGENTE CONTAMINANTE EN EL AMBIENTE"
  },
  {
    "codigo":224257001,
    "descripcion":"MOHO EN LA ROPA EN EL HOGAR"
  },
  {
    "codigo":27649004,
    "descripcion":"CAMBIOS DEL SEGMENTO ST VENTRICULAR IZQUIERDO"
  },
  {
    "codigo":715777007,
    "descripcion":"DISTONÍA PRIMARIA TIPO 2"
  },
  {
    "codigo":124118000,
    "descripcion":"DEFICIENCIA DE 3 - HIDROXIBUTIRATO DESHIDROGENASA"
  },
  {
    "codigo":289793007,
    "descripcion":"POSICIÓN NORMAL DEL CUELLO UTERINO"
  },
  {
    "codigo":255190002,
    "descripcion":"HEMANGIOMATOSIS ULCEROMUTILANTES"
  },
  {
    "codigo":1172694007,
    "descripcion":"MIOPATÍA DISTAL ASOCIADA A ADSSL1"
  },
  {
    "codigo":253355000,
    "descripcion":"ANOMALÍA DEL APÉNDICE DE LA AURÍCULA IZQUIERDA"
  },
  {
    "codigo":286123005,
    "descripcion":"CAPAZ DE LIMPIAR LAS VENTANAS"
  },
  {
    "codigo":15981591000119105,
    "descripcion":"PTOSIS DE PÁRPADO DERECHO POSTERIOR A CIRUGÍA"
  },
  {
    "codigo":54912002,
    "descripcion":"LUPUS ERITEMATOSO MEDICAMENTOSO CAUSADO POR HIDRALAZINA"
  },
  {
    "codigo":284288005,
    "descripcion":"CAPAZ DE AGARRAR MEDIANTE LA PRONACIÓN DE LA MUÑECA"
  },
  {
    "codigo":251520005,
    "descripcion":"SIGNOS ELECTROMIOGRÁFICOS DE RECLUTAMIENTO TEMPRANO EN EL PATRÓN DE INTERFERENCIA"
  },
  {
    "codigo":118613001,
    "descripcion":"RETICULOENDOTELIOSIS LEUCÉMICA (CLÍNICA)"
  },
  {
    "codigo":315221003,
    "descripcion":"ESPERMATOZOIDES MÓVILES, SIN PROGRESIÓN"
  },
  {
    "codigo":249685004,
    "descripcion":"CLAVÍCULA BIPARTITA"
  },
  {
    "codigo":282453006,
    "descripcion":"QUEMADURA DE FARINGE POR AGENTES CORROSIVOS"
  },
  {
    "codigo":10958001000119102,
    "descripcion":"HERIDA ABIERTA DE SEGUNDO A QUINTO DEDOS DE PIE IZQUIERDO"
  },
  {
    "codigo":1263658004,
    "descripcion":"METÁSTASIS DE CARCINOMA DE CÉLULAS TRANSICIONALES EN URÉTER IZQUIERDO"
  },
  {
    "codigo":308401000119103,
    "descripcion":"GRANULOMA POR CUERPO EXTRAÑO DE PARTES BLANDAS DE MUSLO IZQUIERDO"
  },
  {
    "codigo":15709361000119103,
    "descripcion":"HIPERPIGMENTACIÓN DE PÁRPADO DERECHO Y DE ÁREA PERIOCULAR DERECHA"
  },
  {
    "codigo":247850006,
    "descripcion":"MIEDO A LOS ESPACIOS CERRADOS"
  },
  {
    "codigo":213247005,
    "descripcion":"PROMINENCIA ÓSEA EN EL MUÑÓN DE AMPUTACIÓN"
  },
  {
    "codigo":211412006,
    "descripcion":"AMPOLLA EN EL PIE POR NEUROPATÍA"
  },
  {
    "codigo":12969000,
    "descripcion":"TRASTORNO BIPOLAR II GRAVE, EPISODIO MÁS RECIENTE DE CARACTERÍSTICAS DEPRESIVAS PROFUNDAS, EN REMISIÓN TOTAL"
  },
  {
    "codigo":209577003,
    "descripcion":"DESGARRO TOTAL DEL LIGAMENTO CORACOCLAVICULAR"
  },
  {
    "codigo":111273006,
    "descripcion":"ENFERMEDAD RESPIRATORIA AGUDA"
  },
  {
    "codigo":109438000,
    "descripcion":"CÍNGULO DENTAL EXAGERADO"
  },
  {
    "codigo":11134001,
    "descripcion":"SUPURACIÓN AGUDA DE SENO ESFENOIDAL"
  },
  {
    "codigo":371582002,
    "descripcion":"ENFERMEDAD CAUSADA POR BACTERIAS GRAMPOSITIVAS"
  },
  {
    "codigo":699262001,
    "descripcion":"OSTEOARTRITIS POSTRAUMÁTICA"
  },
  {
    "codigo":892417201000119109,
    "descripcion":"MASA EN AXILA DERECHA"
  },
  {
    "codigo":76670001,
    "descripcion":"DISTROFIA MUSCULAR DE DUCHENNE"
  },
  {
    "codigo":369747003,
    "descripcion":"CONFIGURACIÓN TUMORAL DIFUSA"
  },
  {
    "codigo":402515003,
    "descripcion":"CARCINOMA BASOCELULAR DE LA REGIÓN TORÁCICA ANTERIOR"
  },
  {
    "codigo":304211005,
    "descripcion":"SIN AMPLITUD PASIVA DE EXTENSIÓN HORIZONTAL DE HOMBRO"
  },
  {
    "codigo":238675007,
    "descripcion":"ERITEMA NODOSO DEBIDO A SARCOIDOSIS"
  },
  {
    "codigo":204072001,
    "descripcion":"ADHERENCIAS CONGÉNITAS DE LAS MENINGES CEREBRALES"
  },
  {
    "codigo":7464006,
    "descripcion":"INTOXICACIÓN POR SCILLA"
  },
  {
    "codigo":366077000,
    "descripcion":"POSTURA OCULOCEFÁLICA - HALLAZGO"
  },
  {
    "codigo":300541001,
    "descripcion":"ESPERMATOZOIDE DEFORMADO"
  },
  {
    "codigo":38397000,
    "descripcion":"INTUSUSCEPCIÓN GASTROESOFÁGICA"
  },
  {
    "codigo":890365005,
    "descripcion":"MEMBRANA ANTROPILÓRICA CONGÉNITA INCOMPLETA"
  },
  {
    "codigo":235005006,
    "descripcion":"ENGROSAMIENTO DE FOLÍCULO DENTAL"
  },
  {
    "codigo":169469006,
    "descripcion":"PÍLDORA DE ANTICONCEPCIÓN ORAL PARA USO NO ANTICONCEPTIVO"
  },
  {
    "codigo":200402001,
    "descripcion":"RETRACCIÓN DE PEZÓN EN EMBARAZO, PUERPERIO O LACTANCIA"
  },
  {
    "codigo":724690002,
    "descripcion":"TRASTORNO DEL ESTADO DE ÁNIMO CON SÍNTOMAS DEPRESIVOS CAUSADO POR COCAÍNA"
  },
  {
    "codigo":298706004,
    "descripcion":"HALLAZGO RELACIONADO CON LA APARIENCIA DEL TÓRAX"
  },
  {
    "codigo":1074661000119103,
    "descripcion":"ARTRITIS DE ARTICULACIÓN ESTERNOCLAVICULAR IZQUIERDA"
  },
  {
    "codigo":9701000119103,
    "descripcion":"CELULITIS DE MANGUITO VAGINAL"
  },
  {
    "codigo":167634007,
    "descripcion":"EXAMEN DE HECES: CÉLULAS"
  },
  {
    "codigo":822994008,
    "descripcion":"FÍSTULA CUTÁNEA POSTERIOR A LESIÓN TRAUMÁTICA"
  },
  {
    "codigo":427943001,
    "descripcion":"OFTALMOPLEJÍA DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":1148839004,
    "descripcion":"CAPACIDAD DE ADAPTACIÓN DE LA PRESIÓN INTRACRANEAL, NORMAL"
  },
  {
    "codigo":722855007,
    "descripcion":"PERFORACIÓN Y ABSCESO DE INTESTINO GRUESO CONCOMITANTE CON DIVERTICULITIS Y DEBIDA A ELLA"
  },
  {
    "codigo":1959009,
    "descripcion":"INTOXICACIÓN POR ENCEPHALARTOS"
  },
  {
    "codigo":719185000,
    "descripcion":"ATROFIA DE MÚSCULO TEMPORAL"
  },
  {
    "codigo":337381000119107,
    "descripcion":"ENOFTALMOS IZQUIERDO TRAUMÁTICO"
  },
  {
    "codigo":293201007,
    "descripcion":"REACCIÓN ADVERSA A LA TOLBUTAMIDA"
  },
  {
    "codigo":94758002,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL CUERPO DEL ESTÓMAGO"
  },
  {
    "codigo":225830003,
    "descripcion":"VÍCTIMA DE ACOSO SEXUAL"
  },
  {
    "codigo":16039551000119103,
    "descripcion":"CONDROMALACIA DE ARTICULACIÓN DE MANO IZQUIERDA"
  },
  {
    "codigo":1208870005,
    "descripcion":"SÍNDROME DE QT PROLONGADO TIPO 13"
  },
  {
    "codigo":782886007,
    "descripcion":"SÍNDROME DE ESPASMOS INFANTILES, RETRASO PSICOMOTOR, ATROFIA CEREBRAL PROGRESIVA Y ENFERMEDAD DE GANGLIOS BASALES"
  },
  {
    "codigo":27387000,
    "descripcion":"ESQUIZOFRENIA DESORGANIZADA SUBCRÓNICA"
  },
  {
    "codigo":422438007,
    "descripcion":"ESPACIO DE EJERCICIOS INADECUADO"
  },
  {
    "codigo":10632831000119104,
    "descripcion":"ABSCESO DE ANTEBRAZO DERECHO"
  },
  {
    "codigo":420603006,
    "descripcion":"FILAMENTO DE LA CÓRNEA"
  },
  {
    "codigo":25552000,
    "descripcion":"TIFLITIS AGUDA"
  },
  {
    "codigo":1010427008,
    "descripcion":"HIPOPLASIA DE APÓFISIS CONDÍLEA IZQUIERDA DE MANDÍBULA"
  },
  {
    "codigo":58320001,
    "descripcion":"LUXACIÓN TRAUMÁTICA DE ARTICULACIÓN DE LA RODILLA"
  },
  {
    "codigo":92923008,
    "descripcion":"FORMA ANORMAL CONGÉNITA DE VÁLVULA MITRAL"
  },
  {
    "codigo":189392000,
    "descripcion":"NEOPLASIA DE CONDUCTO HEPÁTICO DE COMPORTAMIENTO INCIERTO"
  },
  {
    "codigo":254928005,
    "descripcion":"NEOPLASIA DE UNIÓN URETEROPÉLVICA"
  },
  {
    "codigo":285861000,
    "descripcion":"CAPAZ DE USAR EL LAVAPLATOS"
  },
  {
    "codigo":1268901001,
    "descripcion":"RETINOBLASTOMA PRIMARIO DE RETINA"
  },
  {
    "codigo":416933006,
    "descripcion":"BAJO ATENCIÓN DE ADMINISTRADOR DE CASOS"
  },
  {
    "codigo":23717007,
    "descripcion":"HIPERTENSIÓN ESENCIAL BENIGNA QUE COMPLICA EL EMBARAZO Y\/O CONSTITUYE UN MOTIVO DE ATENCIÓN DURANTE ESTE PERÍODO"
  },
  {
    "codigo":710010005,
    "descripcion":"SÍNDROME DE TURNER MOSAICO"
  },
  {
    "codigo":21882006,
    "descripcion":"PRESENTACIÓN DE CARA DEL FETO"
  },
  {
    "codigo":54650005,
    "descripcion":"NACIMIENTO PREMATURO DE GEMELOS MUERTOS"
  },
  {
    "codigo":251258008,
    "descripcion":"ONDA T BÍFIDA"
  },
  {
    "codigo":216655002,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR DETERGENTES SINTÉTICOS Y CHAMPÚES"
  },
  {
    "codigo":249423002,
    "descripcion":"SANGRADO DEL LECHO AMIGDALINO"
  },
  {
    "codigo":15685401000119104,
    "descripcion":"RETINITIS DE AMBOS OJOS CAUSADA POR TOXOPLASMA GONDII"
  },
  {
    "codigo":314959007,
    "descripcion":"APTO PARA VOLAR"
  },
  {
    "codigo":247588002,
    "descripcion":"MEMORIA A LARGO PLAZO, ESCASA"
  },
  {
    "codigo":278521000,
    "descripcion":"QUEILITIS ANGULAR CANDIDIÁSICA"
  },
  {
    "codigo":737273002,
    "descripcion":"DEGENERACIÓN DE POLO POSTERIOR DEL OJO"
  },
  {
    "codigo":212985008,
    "descripcion":"EFECTOS OCASIONADOS POR LÍQUIDOS DE ALTA PRESIÓN"
  },
  {
    "codigo":735438000,
    "descripcion":"TRASTORNO DE LA QUIMIOTAXIS DE LOS NEUTRÓFILOS"
  },
  {
    "codigo":35761000146100,
    "descripcion":"TRASTORNO DEL SUEÑO CAUSADO POR AGENTE HIPNÓTICO"
  },
  {
    "codigo":1259726005,
    "descripcion":"HEMANGIOENDOTELIOMA EPITELIOIDE PRIMARIO DE PULMÓN"
  },
  {
    "codigo":11999001000119109,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO DEL DORSO DE MANO IZQUIERDA"
  },
  {
    "codigo":209315003,
    "descripcion":"FRACTURA-LUXACIÓN EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA PROXIMAL"
  },
  {
    "codigo":699000000,
    "descripcion":"FÍSTULA DE CONDUCTO TIROGLOSO"
  },
  {
    "codigo":733603009,
    "descripcion":"CARCINOMA TUBULOQUÍSTICO DE CÉLULAS RENALES"
  },
  {
    "codigo":305784001,
    "descripcion":"VISTO POR RADIÓLOGO TERAPEUTA"
  },
  {
    "codigo":830072004,
    "descripcion":"ÚLCERA DE PIE DERECHO"
  },
  {
    "codigo":1077171000119106,
    "descripcion":"QUISTE ÓSEO DE PIE IZQUIERDO"
  },
  {
    "codigo":313421000119100,
    "descripcion":"ARTROFITO EN ARTICULACIÓN DE DEDO DE LA MANO DERECHA"
  },
  {
    "codigo":404088004,
    "descripcion":"SARCOMA FIBROMIXOIDE DE BAJO GRADO"
  },
  {
    "codigo":238413001,
    "descripcion":"BOTRIOMICOSIS"
  },
  {
    "codigo":271181001,
    "descripcion":"AMPOLLA TRAUMÁTICA DE LA CADERA, INFECTADA"
  },
  {
    "codigo":16068531000119107,
    "descripcion":"ARTRITIS GOTOSA DE AMBOS CODOS"
  },
  {
    "codigo":369485004,
    "descripcion":"TUMOR MALIGNO QUE COMPROMETE LA PRÓSTATA POR PROPAGACIÓN DIRECTA DE LA VEJIGA"
  },
  {
    "codigo":11808691000119108,
    "descripcion":"PERFORACIÓN TRAUMÁTICA DE COLON TRANSVERSO"
  },
  {
    "codigo":105506000,
    "descripcion":"DEPENDENCIA DE PERRO LAZARILLO"
  },
  {
    "codigo":15960141000119102,
    "descripcion":"ANGINA CONCOMITANTE CON ARTERIOSCLEROSIS CORONARIA Y DEBIDA A ELLA"
  },
  {
    "codigo":339891000119109,
    "descripcion":"ENTROPIÓN SENIL DE PÁRPADO INFERIOR IZQUIERDO"
  },
  {
    "codigo":302114005,
    "descripcion":"HALLAZGO RELACIONADO CON UN DISPOSITIVO GASTROINTESTINAL"
  },
  {
    "codigo":236578006,
    "descripcion":"RECHAZO CRÓNICO DE TRASPLANTE RENAL"
  },
  {
    "codigo":1186850007,
    "descripcion":"ATAXIA ESPINOCEREBELOSA DEBIDA A DEFICIENCIA DE VITAMINA E"
  },
  {
    "codigo":16697421000119103,
    "descripcion":"RETINOPATÍA NO PROLIFERATIVA MODERADA DE OJO IZQUIERDO DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":300279005,
    "descripcion":"AMÍGDALAS DE TAMAÑO NORMAL"
  },
  {
    "codigo":890103005,
    "descripcion":"ATRESIA DE YEYUNO TIPO I"
  },
  {
    "codigo":365815007,
    "descripcion":"LÍQUIDO CEFALORRAQUÍDEO: NIVEL DE GLUCOSA - HALLAZGO"
  },
  {
    "codigo":167372005,
    "descripcion":"VOLUMEN DE ORINA DE 24 HORAS POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":724428007,
    "descripcion":"ESTENOSIS ASINTOMÁTICA DE ARTERIA EXTRACRANEAL"
  },
  {
    "codigo":1279649001,
    "descripcion":"HERIDA PUNZANTE DE DEDO ÍNDICE DE MANO CON CUERPO EXTRAÑO"
  },
  {
    "codigo":198305004,
    "descripcion":"PROLAPSO DE OVARIO Y TROMPA DE FALOPIO"
  },
  {
    "codigo":165537007,
    "descripcion":"RECUENTO DE MONOCITOS DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":788129008,
    "descripcion":"TODA LA MEDICACIÓN VERIFICADA"
  },
  {
    "codigo":427681009,
    "descripcion":"QUISTE SINOVIAL DEL SACRO"
  },
  {
    "codigo":67233009,
    "descripcion":"INSOMNIO INTERMEDIO"
  },
  {
    "codigo":16015591000119102,
    "descripcion":"TRASTORNO DE HUESO DE AMBAS REGIONES DE ARTICULACIÓN DE TOBILLO POSTERIOR A POLIOMIELITIS"
  },
  {
    "codigo":294774005,
    "descripcion":"ALERGIA A MESTEROLONA"
  },
  {
    "codigo":1179510007,
    "descripcion":"BETAGLOBULINA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1144907001,
    "descripcion":"ENFERMEDAD DE INJERTO VERSUS HUÉSPED AGUDA TARDÍA"
  },
  {
    "codigo":292939004,
    "descripcion":"REACCIÓN ADVERSA A LA TRIMETOPRIMA"
  },
  {
    "codigo":291104000,
    "descripcion":"INTOXICACIÓN POR DICLORALFENAZONA"
  },
  {
    "codigo":94496002,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA PARED POSTERIOR DE LA HIPOFARINGE"
  },
  {
    "codigo":368871000119106,
    "descripcion":"SÍNDROME NEFRÍTICO AGUDO CONCOMITANTE CON GLOMERULONEFRITIS MEMBRANOPROLIFERATIVA TIPO III Y DEBIDO A ELLA"
  },
  {
    "codigo":289269001,
    "descripcion":"LESIÓN DE PLACENTA"
  },
  {
    "codigo":127264009,
    "descripcion":"NEOPLASIA DE LOS GANGLIOS LINFÁTICOS FEMORALES"
  },
  {
    "codigo":190965006,
    "descripcion":"OBESIDAD INDUCIDA POR FÁRMACOS"
  },
  {
    "codigo":16316801000119102,
    "descripcion":"MASTITIS PURULENTA POSPARTO"
  },
  {
    "codigo":92661009,
    "descripcion":"CARCINOMA IN SITU DE GLÁNDULAS ENDOCRINAS MÚLTIPLES"
  },
  {
    "codigo":189130001,
    "descripcion":"NEOPLASIA BENIGNA DE LA GLÁNDULA DE BARTOLINO"
  },
  {
    "codigo":123594003,
    "descripcion":"ATELECTASIA TOTAL DEL PULMÓN DERECHO"
  },
  {
    "codigo":254666005,
    "descripcion":"QUERATOSIS"
  },
  {
    "codigo":713418005,
    "descripcion":"CRUCES ARTERIOVENOSOS RETINIANOS"
  },
  {
    "codigo":416671000,
    "descripcion":"MICROESFEROFAQUIA"
  },
  {
    "codigo":1336010009,
    "descripcion":"QUISTE DE GLOBO OCULAR PROPIAMENTE DICHO"
  },
  {
    "codigo":285599002,
    "descripcion":"LESIÓN NERVIOSA EN EL TRONCO"
  },
  {
    "codigo":23455003,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN LA REGIÓN DE LA CADERA, SIN INFECCIÓN"
  },
  {
    "codigo":1268639006,
    "descripcion":"CARCINOSARCOMA PRIMARIO DE CUELLO DE ÚTERO"
  },
  {
    "codigo":449439007,
    "descripcion":"CONDUCTO VENOSO AUSENTE CON CONEXIÓN DIRECTA DE VENA UMBILICAL A AURÍCULA DERECHA"
  },
  {
    "codigo":283764002,
    "descripcion":"MORDEDURA DE PERRO EN EL PERINEO"
  },
  {
    "codigo":54388004,
    "descripcion":"EDEMA RETINIANO PERIFÉRICO"
  },
  {
    "codigo":1079681000119106,
    "descripcion":"NEVO MELANOCÍTICO PIGMENTADO CONGÉNITO DE PIEL DE MIEMBRO INFERIOR IZQUIERDO"
  },
  {
    "codigo":403251004,
    "descripcion":"PELO CASTAÑO OSCURO"
  },
  {
    "codigo":250996007,
    "descripcion":"ORIFICIO COMPLEJO DE VÁLVULA MITRAL"
  },
  {
    "codigo":609609004,
    "descripcion":"SÍNDROME PARALÍTICO DE UN MIEMBRO"
  },
  {
    "codigo":183625007,
    "descripcion":"SEGUIMIENTO EN 4-6 MESES"
  },
  {
    "codigo":249161008,
    "descripcion":"ESFUERZO MATERNO DURANTE LA SEGUNDA FASE DEL TRABAJO DE PARTO"
  },
  {
    "codigo":314697009,
    "descripcion":"TALLA DEL NIÑO: PERCENTILO 75"
  },
  {
    "codigo":281929009,
    "descripcion":"FRACTURA DE DOS COLUMNAS DE VÉRTEBRA DORSAL"
  },
  {
    "codigo":342401000119109,
    "descripcion":"FILARIASIS LINFÁTICA DE PÁRPADO SUPERIOR DERECHO"
  },
  {
    "codigo":442099003,
    "descripcion":"FATIGA PSICÓGENA"
  },
  {
    "codigo":48883003,
    "descripcion":"ESPÉCIMEN SATISFACTORIO PARA DIAGNÓSTICO"
  },
  {
    "codigo":276424001,
    "descripcion":"SECCIÓN TRAUMÁTICA DE TENDÓN FLEXOR LARGO - ZONA 3"
  },
  {
    "codigo":210888004,
    "descripcion":"CONTUSIÓN, ARTERIA TIBIAL POSTERIOR"
  },
  {
    "codigo":407496005,
    "descripcion":"INFECCIÓN CAUSADA POR VIRUS PARAINFLUENZA 1 HUMANO"
  },
  {
    "codigo":1259464008,
    "descripcion":"CARCINOMA UROTELIAL PRIMARIO DE PELVIS RENAL IZQUIERDA"
  },
  {
    "codigo":473032009,
    "descripcion":"COMPLICACIÓN ASOCIADA CON IMPLANTE VASCULAR"
  },
  {
    "codigo":77981007,
    "descripcion":"FUNCIÓN HEPÁTICA DISMINUIDA"
  },
  {
    "codigo":43378000,
    "descripcion":"SIGNO EXTRAPIRAMIDAL"
  },
  {
    "codigo":241821007,
    "descripcion":"ENVENENAMIENTO DEBIDO A PICADURA DE ORNITORRINCO"
  },
  {
    "codigo":698738000,
    "descripcion":"MIOCLONÍA DE TRONCO ENCEFÁLICO"
  },
  {
    "codigo":733341007,
    "descripcion":"PROBLEMA ALIMENTARIO EN LA VIDA ADULTA"
  },
  {
    "codigo":371058004,
    "descripcion":"PICADURA VENENOSA"
  },
  {
    "codigo":239986002,
    "descripcion":"DESGARRO DEL LIGAMENTO TRIANGULAR"
  },
  {
    "codigo":305522002,
    "descripcion":"BAJO ATENCIÓN DE OBSTETRA"
  },
  {
    "codigo":270919000,
    "descripcion":"PRUEBA DE HEAF: NEGATIVA"
  },
  {
    "codigo":403826009,
    "descripcion":"CILINDROMA FAMILIAR MÚLTIPLE"
  },
  {
    "codigo":860743003,
    "descripcion":"GRUPO DE GRADO 2 DE GLEASON"
  },
  {
    "codigo":762439008,
    "descripcion":"NISTAGMO DE TORSIÓN"
  },
  {
    "codigo":1082191000119100,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE PABELLÓN AURICULAR DERECHO"
  },
  {
    "codigo":365553008,
    "descripcion":"INGRESOS DOMÉSTICOS - HALLAZGO"
  },
  {
    "codigo":1119217009,
    "descripcion":"DOLOR EN REGIÓN ABDOMINAL LUMBAR DERECHA"
  },
  {
    "codigo":36038007,
    "descripcion":"GUNDÚ EN LA FRAMBESIA"
  },
  {
    "codigo":298182007,
    "descripcion":"AMPLITUD DE MOTILIDAD ARTICULAR ACTIVA AUMENTADA"
  },
  {
    "codigo":427419006,
    "descripcion":"MIGRAÑA TRANSFORMADA"
  },
  {
    "codigo":296347008,
    "descripcion":"SOBREDOSIS DE FENOXIBENZAMINA"
  },
  {
    "codigo":294512004,
    "descripcion":"ALERGIA A TALAMPICILINA"
  },
  {
    "codigo":344911000119106,
    "descripcion":"DRUSAS DE AMBAS PAPILAS ÓPTICAS"
  },
  {
    "codigo":720496006,
    "descripcion":"SÍNDROME DE ANOFTALMÍA PLUS"
  },
  {
    "codigo":15991631000119106,
    "descripcion":"IRIDOCICLITIS DE OJO DERECHO CAUSADA POR MYCOBACTERIUM TUBERCULOSIS"
  },
  {
    "codigo":816965000,
    "descripcion":"MIEMBRO INFERIOR DERECHO AMPUTADO POR ENCIMA DE LA RODILLA"
  },
  {
    "codigo":11787241000119100,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE DEDO DE MANO IZQUIERDA CON INFECCIÓN"
  },
  {
    "codigo":194373002,
    "descripcion":"DISFUNCIÓN LABERÍNTICA BILATERAL HIPERACTIVA"
  },
  {
    "codigo":94234000,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA MUCOSA YUGAL"
  },
  {
    "codigo":127002001,
    "descripcion":"NEOPLASIA DE LA RETINA"
  },
  {
    "codigo":292677008,
    "descripcion":"REACCIÓN ADVERSA A LA SULFINPIRAZONA"
  },
  {
    "codigo":1208346003,
    "descripcion":"SÍNDROME CONGÉNITO DE HIDROCEFALIA, OMBLIGO DE INSERCIÓN BAJA"
  },
  {
    "codigo":290842004,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR LOFEPRAMINA"
  },
  {
    "codigo":28698006,
    "descripcion":"TORSIÓN DEL LÓBULO HEPÁTICO"
  },
  {
    "codigo":714991001,
    "descripcion":"DIFICULTAD PARA EMPUJAR CON MIEMBRO INFERIOR"
  },
  {
    "codigo":16702441000119104,
    "descripcion":"RETRASO PSICOMOTOR DEBIDO A ACCIDENTE CEREBROVASCULAR ISQUÉMICO Y POSTERIOR A ÉL"
  },
  {
    "codigo":878831006,
    "descripcion":"HEMORRAGIA SUBMUCOSA DE CUERDA VOCAL"
  },
  {
    "codigo":59631007,
    "descripcion":"DRENAJE VENOSO PULMONAR ANÓMALO"
  },
  {
    "codigo":289007009,
    "descripcion":"INCAPAZ DE LLEVAR ALIMENTO A LA BOCA"
  },
  {
    "codigo":92399009,
    "descripcion":"NEOPLASIA BENIGNA DE PARTES BLANDAS DEL TÓRAX"
  },
  {
    "codigo":1335748003,
    "descripcion":"NECROSIS AVASCULAR DE PERONÉ"
  },
  {
    "codigo":254404003,
    "descripcion":"CARCINOMA DE LA COMISURA LABIAL"
  },
  {
    "codigo":416409005,
    "descripcion":"CONSENTIMIENTO PARA INCLUSIÓN DE DATOS EN REGISTRO MÉDICO ELECTRÓNICO COMPARTIDO A NIVEL LOCAL REHUSADO"
  },
  {
    "codigo":55961006,
    "descripcion":"HIPOCLORHIDRIA"
  },
  {
    "codigo":733064004,
    "descripcion":"SÍNDROME DE OSTEOSARCOMA, ANOMALÍAS DE LOS MIEMBROS Y MACROCITOSIS ERITROIDE"
  },
  {
    "codigo":88729006,
    "descripcion":"AFECTO LÁBIL"
  },
  {
    "codigo":449177007,
    "descripcion":"LINFOMA NO HODGKIN DIFUSO DE HUESO"
  },
  {
    "codigo":283502003,
    "descripcion":"HERIDA PUNZANTE DE FRENTE"
  },
  {
    "codigo":412739004,
    "descripcion":"MUTACIÓN DE GEN BRCA2 NEGATIVA"
  },
  {
    "codigo":85059005,
    "descripcion":"FÍSTULA DEL APARATO GENITAL FEMENINO"
  },
  {
    "codigo":248899007,
    "descripcion":"VAGINA VACÍA"
  },
  {
    "codigo":445507008,
    "descripcion":"INFLAMACIÓN DE PÁNCREAS CAUSADA POR ALCOHOL"
  },
  {
    "codigo":19523008,
    "descripcion":"HIPERTAURODONTISMO"
  },
  {
    "codigo":314435009,
    "descripcion":"PREFERENCIA POR PROFESIONAL DE LA SALUD MASCULINO"
  },
  {
    "codigo":771352000,
    "descripcion":"ALIMENTO ALOJADO EN ESÓFAGO"
  },
  {
    "codigo":1197336000,
    "descripcion":"ADENOMA TUBULAR BENIGNO DE INTESTINO DELGADO"
  },
  {
    "codigo":247064005,
    "descripcion":"CATARATA ENCOGIDA"
  },
  {
    "codigo":441837004,
    "descripcion":"SIGNO DE NIKOLSKY"
  },
  {
    "codigo":1193666000,
    "descripcion":"TRASTORNO PERINATAL DEBIDO A OPERACIÓN CESÁREA"
  },
  {
    "codigo":409069009,
    "descripcion":"HALLAZGO RELACIONADO CON EL USO DE SUSTANCIAS"
  },
  {
    "codigo":210626000,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA, DEDO DE LA MANO, FALANGE PROXIMAL"
  },
  {
    "codigo":347421000119102,
    "descripcion":"HETEROFORIA ALTERNANTE"
  },
  {
    "codigo":79554005,
    "descripcion":"NEUROPATÍA ASIMÉTRICA MOTORA PROXIMAL DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":308930007,
    "descripcion":"ATENDIDO POR PROFESIONAL SANITARIO"
  },
  {
    "codigo":865986008,
    "descripcion":"DOLOR A LA APLICACIÓN DE PRESIÓN EN DIENTE"
  },
  {
    "codigo":43116000,
    "descripcion":"ECCEMA"
  },
  {
    "codigo":403564004,
    "descripcion":"LIQUEN ESCLEROSO DEL PENE, FORMA INFANTIL"
  },
  {
    "codigo":75884004,
    "descripcion":"HEMORROIDES INTERNAS SANGRANTES"
  },
  {
    "codigo":698476007,
    "descripcion":"MONOARTRITIS DE MUÑECA"
  },
  {
    "codigo":239724009,
    "descripcion":"DEFICIENCIA DEL LIGAMENTO CRUZADO ANTERIOR"
  },
  {
    "codigo":237889002,
    "descripcion":"RAQUITISMO HIPOFOSFATÉMICO DOMINANTE AUTOSÓMICO"
  },
  {
    "codigo":8513005,
    "descripcion":"CONTUSIÓN DEL CUELLO"
  },
  {
    "codigo":320951000119102,
    "descripcion":"QUISTE ÓSEO SOLITARIO DE REGIÓN DE HOMBRO DERECHO"
  },
  {
    "codigo":268822004,
    "descripcion":"LESIÓN TRAUMÁTICA DEL CUERO CABELLUDO FETAL POR MONITOREO"
  },
  {
    "codigo":203286004,
    "descripcion":"OSTEOPATÍA POLIOMIELÍTICA DE REGIÓN DE HOMBRO"
  },
  {
    "codigo":399894006,
    "descripcion":"ENFERMEDAD DE KIMURA"
  },
  {
    "codigo":1055254007,
    "descripcion":"AGENESIA DE EPÍFISIS DE FALANGE MEDIA DE DEDO MEÑIQUE"
  },
  {
    "codigo":39446004,
    "descripcion":"INFERTILIDAD FEMENINA DE ORIGEN TUBÁRICO"
  },
  {
    "codigo":299755000,
    "descripcion":"REFLEJO DE HOCIQUEO DE RESULTADO DUDOSO"
  },
  {
    "codigo":236054008,
    "descripcion":"HERNIA DE HIATO POR DESLIZAMIENTO CON VÓLVULO GÁSTRICO"
  },
  {
    "codigo":6678005,
    "descripcion":"EDAD GESTACIONAL, 15 SEMANAS"
  },
  {
    "codigo":301590007,
    "descripcion":"SUBE Y BAJA ESCALERAS"
  },
  {
    "codigo":35801000175102,
    "descripcion":"ÚLCERA POR PRESIÓN EN TOBILLO, ESTADIO III"
  },
  {
    "codigo":234219007,
    "descripcion":"PROBLEMA DE SENSIBILIDAD DEL MARCAPASOS"
  },
  {
    "codigo":363456000,
    "descripcion":"NEOPLASIA MALIGNA DE URACO"
  },
  {
    "codigo":365291009,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA CONTROLAR EL TERMOSTATO DEL HOGAR"
  },
  {
    "codigo":1348331009,
    "descripcion":"VESTIBULODINIA"
  },
  {
    "codigo":68544003,
    "descripcion":"GLOMERULONEFRITIS AGUDA POSESTREPTOCÓCICA"
  },
  {
    "codigo":35776002,
    "descripcion":"INTOXICACIÓN POR HEPARINA"
  },
  {
    "codigo":232384005,
    "descripcion":"FÍSTULA DERMOIDE MEDIONASAL"
  },
  {
    "codigo":166848004,
    "descripcion":"TRIGLICÉRIDOS SÉRICOS POR ENCIMA DE RANGO DE REFERENCIA"
  },
  {
    "codigo":199616008,
    "descripcion":"FETO GRANDE PARA LA EDAD GESTACIONAL"
  },
  {
    "codigo":296085001,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE BROMAZEPAM"
  },
  {
    "codigo":1344661002,
    "descripcion":"PÓLIPO HIPERPLÁSICO DE COLON"
  },
  {
    "codigo":230549004,
    "descripcion":"PARÁLISIS MÚLTIPLES DE LOS PARES CRANEALES DE LOS NERVIOS MOTORES OCULARES"
  },
  {
    "codigo":66709007,
    "descripcion":"NEFROPATÍA HIPERTENSIVA QUE COMPLICA EL EMBARAZO Y\/O CONSTITUYE UN MOTIVO DE ATENCIÓN DURANTE ESTE PERÍODO"
  },
  {
    "codigo":33941008,
    "descripcion":"CONVULSIÓN PARCIAL SIMPLE CON ALTERACIÓN DE LA FUNCIÓN CEREBRAL SUPERIOR"
  },
  {
    "codigo":261482004,
    "descripcion":"MALFORMACIÓN ARTERIOVENOSA ESPINAL"
  },
  {
    "codigo":294250006,
    "descripcion":"ALERGIA A PROSTAGLANDINA, SERIE A"
  },
  {
    "codigo":425322008,
    "descripcion":"HERIDA POR PUÑALADA"
  },
  {
    "codigo":95807003,
    "descripcion":"TUMEFACCIÓN DEL PABELLÓN DE LA OREJA"
  },
  {
    "codigo":292415004,
    "descripcion":"REACCIÓN ADVERSA A LA DEXANFETAMINA"
  },
  {
    "codigo":30271005,
    "descripcion":"ASPECTO DE LA SUPERFICIE DE UNA COLONIA BACTERIANA, GRANULOSA"
  },
  {
    "codigo":1144383006,
    "descripcion":"ATROFIA DE NÚCLEO CAUDADO"
  },
  {
    "codigo":126740003,
    "descripcion":"NEOPLASIA DE VASO SANGUÍNEO DEL CUELLO"
  },
  {
    "codigo":290580006,
    "descripcion":"INTOXICACIÓN POR MITOBRONITOL"
  },
  {
    "codigo":257812009,
    "descripcion":"PERIAORTITIS CRÓNICA"
  },
  {
    "codigo":93972009,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA PARED POSTERIOR DE LA VEJIGA"
  },
  {
    "codigo":419817006,
    "descripcion":"PARACOCCIDIOIDOMICOSIS CUTÁNEA"
  },
  {
    "codigo":288745006,
    "descripcion":"INCAPAZ DE HACERSE ENTENDER"
  },
  {
    "codigo":90302003,
    "descripcion":"TUBERCULOSIS DE LAS MENINGES CEREBRALES"
  },
  {
    "codigo":57534004,
    "descripcion":"CAMBIOS EN EL ASPECTO VASCULAR RETINIANO"
  },
  {
    "codigo":11818731000119103,
    "descripcion":"ESGUINCE DE LIGAMENTO DE ARTICULACIÓN INTERFALÁNGICA DE DEDO MEÑIQUE DERECHO"
  },
  {
    "codigo":677611000119103,
    "descripcion":"MICROANEURISMA DE LA ARTERIA RETINIANA DERECHA"
  },
  {
    "codigo":24766003,
    "descripcion":"INFECCIÓN CAUSADA POR PORROCAECUM"
  },
  {
    "codigo":55699002,
    "descripcion":"FORMA DE UNA COLONIA BACTERIANA, PUNTIFORME"
  },
  {
    "codigo":186771002,
    "descripcion":"ENFERMEDAD POR RICKETSIAS DEL GRUPO DE LAS FIEBRES EXANTEMÁTICAS"
  },
  {
    "codigo":448915004,
    "descripcion":"FISURA DE PALADAR DURO"
  },
  {
    "codigo":44821000087100,
    "descripcion":"INFARTO AGUDO DE MIOCARDIO CON ELEVACIÓN DE SEGMENTO ST DEBIDO A OCLUSIÓN DE SEGMENTO MEDIO DE RAMA CIRCUNFLEJA DE ARTERIA CORONARIA IZQUIERDA"
  },
  {
    "codigo":42261000087102,
    "descripcion":"HERIDA DE VULVA POR MORDEDURA"
  },
  {
    "codigo":39701000087103,
    "descripcion":"DOLOR VISCERAL CRÓNICO EN REGIÓN DE PELVIS DEBIDO A TRASTORNO"
  },
  {
    "codigo":283240004,
    "descripcion":"VIDRIO EN LA MEJILLA"
  },
  {
    "codigo":707389001,
    "descripcion":"CARCINOMA PRIMARIO DE CÉLULAS ESCAMOSAS CLARAS DE TRÁQUEA"
  },
  {
    "codigo":1231677002,
    "descripcion":"DESVIACIÓN ALTERNANTE PERIÓDICA DE MIRADA"
  },
  {
    "codigo":52029003,
    "descripcion":"MIOCARDIOPATÍA DILATADA FAMILIAR PRIMARIA"
  },
  {
    "codigo":248637005,
    "descripcion":"PULSO BRAQUIFEMORAL RETARDADO"
  },
  {
    "codigo":246802000,
    "descripcion":"HENDIDURA PALPEBRAL CORTA"
  },
  {
    "codigo":115730009,
    "descripcion":"FENOTIPO DE GRUPO SANGUÍNEO HH"
  },
  {
    "codigo":310503003,
    "descripcion":"DIETA PROMEDIO"
  },
  {
    "codigo":212199008,
    "descripcion":"LESIÓN DE LA RAÍZ DEL NERVIO CERVICAL - C3"
  },
  {
    "codigo":441575009,
    "descripcion":"PRIAPISMO ISQUÉMICO"
  },
  {
    "codigo":1033591000000101,
    "descripcion":"HEMORRAGIA POSPARTO MASIVA"
  },
  {
    "codigo":210364007,
    "descripcion":"HERIDA ABIERTA DEL PISO DE LA BOCA"
  },
  {
    "codigo":275900007,
    "descripcion":"COMENZÓ CON FENOTIAZINAS INYECTABLES"
  },
  {
    "codigo":863889003,
    "descripcion":"PRURITO EN LUGAR DE APLICACIÓN"
  },
  {
    "codigo":700049004,
    "descripcion":"SÍNDROME DE RESPUESTA INFLAMATORIA SISTÉMICA NO INFECCIOSO"
  },
  {
    "codigo":110225007,
    "descripcion":"QUEMADURA DE TERCER GRADO DEL PALADAR BLANDO"
  },
  {
    "codigo":208529008,
    "descripcion":"FRACTURA NO EXPUESTA DE FÉMUR PROXIMAL, SUBCAPITAL, GRADO II DE GARDEN"
  },
  {
    "codigo":370534002,
    "descripcion":"DEFICIENCIA DE YANG"
  },
  {
    "codigo":1156966003,
    "descripcion":"RADICULOPATÍA DEBIDA A ESPONDILOSIS CERVICAL"
  },
  {
    "codigo":403302004,
    "descripcion":"LEUCONIQUIA MEDICAMENTOSA"
  },
  {
    "codigo":1255270006,
    "descripcion":"LINFOMA LINFOPLASMACÍTICO SIN PRODUCCIÓN DE IGM"
  },
  {
    "codigo":237627000,
    "descripcion":"EMBARAZO Y DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":73787001,
    "descripcion":"ENFERMEDAD CAUSADA POR ALPHAHERPESVIRINAE"
  },
  {
    "codigo":203024008,
    "descripcion":"ABSCESO DE MÚSCULO DE ANTEBRAZO"
  },
  {
    "codigo":102885002,
    "descripcion":"AUSENCIA DE SECRECIÓN PLACENTARIA DE GONADOTROFINA CORIÓNICA"
  },
  {
    "codigo":168421003,
    "descripcion":"EXTENDIDO CERVICAL: HERPES"
  },
  {
    "codigo":397797004,
    "descripcion":"DIENTE ERUPCIONADO"
  },
  {
    "codigo":233957006,
    "descripcion":"ISQUEMIA ARTERIAL"
  },
  {
    "codigo":299493006,
    "descripcion":"AMPLITUD DE MOVIMIENTO PASIVO DE PRONACIÓN MEDIOTARSIANA NORMAL"
  },
  {
    "codigo":365029009,
    "descripcion":"RESPUESTA POSACTIVACIÓN - HALLAZGO"
  },
  {
    "codigo":232122003,
    "descripcion":"DEFECTO PUPILAR AFERENTE RELATIVO"
  },
  {
    "codigo":363194005,
    "descripcion":"TRASTORNO DEL APARATO REPRODUCTOR MASCULINO"
  },
  {
    "codigo":428730006,
    "descripcion":"LUXACIÓN POSTERIOR DE ARTICULACIÓN ESTERNOCLAVICULAR"
  },
  {
    "codigo":66447001,
    "descripcion":"PULSO ANACRÓTICO"
  },
  {
    "codigo":164751001,
    "descripcion":"ANOMALÍA EN LA AUDIOMETRÍA IZQUIERDA"
  },
  {
    "codigo":295823001,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE LISURIDA"
  },
  {
    "codigo":230287006,
    "descripcion":"DEMENCIA VASCULAR MIXTA CORTICAL Y SUBCORTICAL"
  },
  {
    "codigo":263055008,
    "descripcion":"SUBLUXACIÓN DEL PULGAR"
  },
  {
    "codigo":721807009,
    "descripcion":"ABSCESO CAUSADO POR ENTAMOEBA HISTOLYTICA"
  },
  {
    "codigo":64612002,
    "descripcion":"INFESTACIÓN POR TUNGA PENETRANS"
  },
  {
    "codigo":228452000,
    "descripcion":"YA NO SEXUALMENTE ACTIVO"
  },
  {
    "codigo":719972004,
    "descripcion":"SÍNDROME DE HADDAD"
  },
  {
    "codigo":425060007,
    "descripcion":"CON MAYOR RIESGO DE FUNCIÓN HEPÁTICA ALTERADA"
  },
  {
    "codigo":293988007,
    "descripcion":"ALERGIA A INDORAMINA"
  },
  {
    "codigo":195684009,
    "descripcion":"LARINGITIS AGUDA POR HAEMOPHILUS INFLUENZAE"
  },
  {
    "codigo":24761000119107,
    "descripcion":"ARTRITIS SUPURATIVA CAUSADA POR BACTERIA PIÓGENA"
  },
  {
    "codigo":292153003,
    "descripcion":"REACCIÓN ADVERSA AL PIPENZOLATO"
  },
  {
    "codigo":161081003,
    "descripcion":"INFANCIA PERTURBADA"
  },
  {
    "codigo":95545007,
    "descripcion":"DIARREA HEMORRÁGICA"
  },
  {
    "codigo":93710000,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE VASO SANGUÍNEO DEL TÓRAX"
  },
  {
    "codigo":1142286002,
    "descripcion":"EDEMA DE TRACTO INTESTINAL"
  },
  {
    "codigo":290318007,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR RADIOFÁRMACO"
  },
  {
    "codigo":60942008,
    "descripcion":"CAPTACIÓN DIFUSA POR UN TEJIDO U ÓRGANO"
  },
  {
    "codigo":1304291004,
    "descripcion":"TRASTORNO DE ESTADO DE ÁNIMO INDUCIDO POR CONSUMO DE ANFETAMINA Y\/O DERIVADO DE ANFETAMINA"
  },
  {
    "codigo":1204152002,
    "descripcion":"INFARTO AGUDO DE MIOCARDIO INFERIOR SIN ELEVACIÓN DEL SEGMENTO ST"
  },
  {
    "codigo":621000124102,
    "descripcion":"INCUMPLIMIENTO CON EL ANÁLISIS DE DIALIZADO PERITONEAL"
  },
  {
    "codigo":253880009,
    "descripcion":"ENFERMEDAD RENAL POLIQUÍSTICA AUTOSÓMICA DOMINANTE EN LA NIÑEZ"
  },
  {
    "codigo":186509002,
    "descripcion":"ENCEFALITIS POSTERIOR A VARICELA"
  },
  {
    "codigo":440941000124107,
    "descripcion":"INGESTA EXCESIVA DE MAGNESIO"
  },
  {
    "codigo":1003874002,
    "descripcion":"DILATACIÓN DE NEOAORTA ASCENDENTE POSTERIOR A PROCEDIMIENTO"
  },
  {
    "codigo":53602002,
    "descripcion":"HIPOTRICOSIS"
  },
  {
    "codigo":282978002,
    "descripcion":"NO SE DOBLA"
  },
  {
    "codigo":20834007,
    "descripcion":"CÚBITO VARO CONGÉNITO"
  },
  {
    "codigo":414050008,
    "descripcion":"OBSERVACIÓN DE LA ACCIÓN MEDICAMENTOSA"
  },
  {
    "codigo":281143003,
    "descripcion":"PASIVIDAD DEL AFECTO"
  },
  {
    "codigo":18999004,
    "descripcion":"TASA DE RENOVACIÓN ÓSEA AUSENTE"
  },
  {
    "codigo":1264183007,
    "descripcion":"TRASTORNO FETAL CAUSADO POR TRANSFERENCIA PLACENTARIA DE ANALGESIA MATERNA DURANTE EL TRABAJO DE PARTO"
  },
  {
    "codigo":441313008,
    "descripcion":"MIELOMA MÚLTIPLE INDOLENTE"
  },
  {
    "codigo":10676871000119103,
    "descripcion":"DERMATITIS ALÉRGICA POR CONTACTO CAUSADA POR SUSTANCIA QUÍMICA"
  },
  {
    "codigo":46262005,
    "descripcion":"INTOXICACIÓN POR FENOL"
  },
  {
    "codigo":111798006,
    "descripcion":"CARBUNCO GASTROINTESTINAL"
  },
  {
    "codigo":11987591000119103,
    "descripcion":"QUEMADURA EPIDÉRMICA DE MANO DERECHA"
  },
  {
    "codigo":372107001,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE COSTILLAS, ESTERNÓN Y CLAVÍCULA"
  },
  {
    "codigo":439478008,
    "descripcion":"ADENOCARCINOMA DE LA UNIÓN ESOFAGOGÁSTRICA TIPO III DE SIEWERT"
  },
  {
    "codigo":208267005,
    "descripcion":"FRACTURA NO EXPUESTA DE HÚMERO DISTAL, EPICÓNDILO"
  },
  {
    "codigo":11659006,
    "descripcion":"NEUROPATÍA URÉMICA"
  },
  {
    "codigo":239200000,
    "descripcion":"ISQUEMIA DEL COLGAJO"
  },
  {
    "codigo":75360000,
    "descripcion":"TRASTORNO BIPOLAR I, UN SOLO EPISODIO MANÍACO, EN REMISIÓN"
  },
  {
    "codigo":365320002,
    "descripcion":"INDEPENDENCIA DEL PENSAMIENTO - HALLAZGO"
  },
  {
    "codigo":9824006,
    "descripcion":"CONJUNTIVITIS SEROSA, NO VIRAL"
  },
  {
    "codigo":271968007,
    "descripcion":"ALTERACIONES DE LAS PRÓTESIS E IMPLANTES DEL SISTEMA NERVIOSO"
  },
  {
    "codigo":697952006,
    "descripcion":"MACRODONCIA DE UN SOLO DIENTE"
  },
  {
    "codigo":237365001,
    "descripcion":"MORTINATO RECIENTE"
  },
  {
    "codigo":403040009,
    "descripcion":"TIÑA CORPORAL CAUSADA POR TRICHOPHYTON SIMII"
  },
  {
    "codigo":40757004,
    "descripcion":"AFAGIA ALGERA"
  },
  {
    "codigo":1092231000119108,
    "descripcion":"ACÚFENO PULSÁTIL SUBJECTIVO DE OÍDO DERECHO"
  },
  {
    "codigo":169994001,
    "descripcion":"INCORPORACIÓN DE SÓLIDOS A LOS 9 MESES"
  },
  {
    "codigo":82721000119103,
    "descripcion":"AGRANDAMIENTO DE GLÁNDULA LAGRIMAL"
  },
  {
    "codigo":71690006,
    "descripcion":"GALACTOSURIA"
  },
  {
    "codigo":15729441000119103,
    "descripcion":"ARTROPATÍA DE ARTICULACIONES DE AMBOS HOMBROS"
  },
  {
    "codigo":202762009,
    "descripcion":"ESTENOSIS IATROGÉNICA DE CONDUCTO RAQUÍDEO CERVICAL"
  },
  {
    "codigo":366602009,
    "descripcion":"PRUEBA DE MCMURRAY - HALLAZGO"
  },
  {
    "codigo":233695003,
    "descripcion":"NEUMOPATÍA POR PODREDUMBRE DE LA MADERA"
  },
  {
    "codigo":364767005,
    "descripcion":"RUTINA DE DESAYUNO - HALLAZGO"
  },
  {
    "codigo":266463007,
    "descripcion":"ABSCESO DE MÚSCULO PSOAS ILÍACO"
  },
  {
    "codigo":102623009,
    "descripcion":"MOTILIDAD AUMENTADA DE INTESTINO DELGADO"
  },
  {
    "codigo":299231009,
    "descripcion":"HALLAZGO RELACIONADO CON ARTICULACIÓN DE CADERA"
  },
  {
    "codigo":231860006,
    "descripcion":"PROTEINURIA DE CAUSA DESCONOCIDA"
  },
  {
    "codigo":35252006,
    "descripcion":"ESQUIZOFRENIA DESORGANIZADA"
  },
  {
    "codigo":262793000,
    "descripcion":"LACERACIÓN DE ESÓFAGO"
  },
  {
    "codigo":721545000,
    "descripcion":"NEOPLASIA BENIGNA DE REGIÓN OCULAR"
  },
  {
    "codigo":788916009,
    "descripcion":"ENCEFALOPATÍA CAUSADA POR AMONÍACO"
  },
  {
    "codigo":649002,
    "descripcion":"FRACTURA EXPUESTA DEL EXTREMO DISTAL DEL CÚBITO"
  },
  {
    "codigo":66185005,
    "descripcion":"EXCESO DE TRANSTIRRETINA AUTOSÓMICO DOMINANTE"
  },
  {
    "codigo":392030001,
    "descripcion":"GLAUCOMA HEMOLÍTICO"
  },
  {
    "codigo":195422002,
    "descripcion":"FLEBITIS DE LA VENA ILÍACA INTERNA"
  },
  {
    "codigo":293726002,
    "descripcion":"ALERGIA A OXIBUPROCAÍNA"
  },
  {
    "codigo":129886006,
    "descripcion":"HALLAZGO EN EL ASPECTO ESPIRITUAL DEL INDIVIDUO"
  },
  {
    "codigo":291891002,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR PLASMA SANGUÍNEO"
  },
  {
    "codigo":16004271000119100,
    "descripcion":"TENOSINOVITIS DE APÓFISIS ESTILOIDES DE RADIO DERECHA"
  },
  {
    "codigo":10676911000119100,
    "descripcion":"PRURITO DE PIEL DE REGIÓN ANOGENITAL"
  },
  {
    "codigo":10904751000119100,
    "descripcion":"HERIDA ABIERTA DE NALGA DERECHA"
  },
  {
    "codigo":134831000119103,
    "descripcion":"ENCEFALOPATÍA HIPÓXICA ISQUÉMICA LEVE DEL RECIÉN NACIDO"
  },
  {
    "codigo":10633391000119104,
    "descripcion":"CELULITIS DE MIEMBRO INFERIOR DERECHO"
  },
  {
    "codigo":10638511000119105,
    "descripcion":"ÚLCERA CRÓNICA DE MUSLO DERECHO"
  },
  {
    "codigo":690351000119103,
    "descripcion":"DISFASIA DEBIDA A ACCIDENTE CEREBROVASCULAR EMBÓLICO Y POSTERIOR A ÉL"
  },
  {
    "codigo":10643631000119106,
    "descripcion":"ÚLCERA VARICOSA DE PIE IZQUIERDO"
  },
  {
    "codigo":11844271000119108,
    "descripcion":"LESIÓN TRAUMÁTICA DE OÍDO DERECHO"
  },
  {
    "codigo":816179007,
    "descripcion":"EDEMA DE PIERNA IZQUIERDA"
  },
  {
    "codigo":285871000119106,
    "descripcion":"ENFERMEDAD RENAL CRÓNICA POR HIPERTENSIÓN MALIGNA, ESTADIO 3"
  },
  {
    "codigo":145071000119106,
    "descripcion":"CISTOCELE MASCULINO"
  },
  {
    "codigo":104111000119108,
    "descripcion":"PUPILA ATÓNICA"
  },
  {
    "codigo":132271000119105,
    "descripcion":"TROMBOSIS VENOSA PROFUNDA AGUDA DE MUSLO"
  },
  {
    "codigo":331951000119106,
    "descripcion":"PIGMENTACIÓN CORNEAL ESTROMAL DE OJO DERECHO"
  },
  {
    "codigo":14511000119108,
    "descripcion":"MUCOSITIS ULCEROSA GASTROINTESTINAL"
  },
  {
    "codigo":91613004,
    "descripcion":"CONTUSIÓN DE CODO"
  },
  {
    "codigo":26077002,
    "descripcion":"TRASTORNO DE FASCIA"
  },
  {
    "codigo":93448009,
    "descripcion":"ÚLCERA SUPERFICIAL DE LA PIEL"
  },
  {
    "codigo":1304029004,
    "descripcion":"GLAUCOMA DE ÁNGULO ABIERTO DE OJO DERECHO DEBIDO A TRAUMATISMO OCULAR Y POSTERIOR A ÉL"
  },
  {
    "codigo":11770811000119108,
    "descripcion":"LUXACIÓN TRAUMÁTICA POSTERIOR NO EXPUESTA DE CABEZA DEL RADIO IZQUIERDO"
  },
  {
    "codigo":384690003,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA NO AFECTADO POR NEOPLASIA MALIGNA"
  },
  {
    "codigo":286386009,
    "descripcion":"CAPAZ DE INICIAR LA EMISIÓN DE PALABRAS"
  },
  {
    "codigo":1234823004,
    "descripcion":"PELIOSIS HEPÁTICA IDIOPÁTICA"
  },
  {
    "codigo":219015004,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR ADIFENINA"
  },
  {
    "codigo":284551006,
    "descripcion":"LACERACIÓN DEL PIE"
  },
  {
    "codigo":22407005,
    "descripcion":"TRASTORNO BIPOLAR II, EPISODIO MÁS RECIENTE DE CARACTERÍSTICAS DEPRESIVAS PROFUNDAS CON SÍNTOMAS CATATÓNICOS"
  },
  {
    "codigo":415623008,
    "descripcion":"ÚLCERA POR ESTRÉS"
  },
  {
    "codigo":446556000,
    "descripcion":"QUEMADURA DE CÓRNEA POR SUSTANCIA QUÍMICA ÁCIDA"
  },
  {
    "codigo":53340006,
    "descripcion":"ALTERACIÓN EN LA ABSORCIÓN INTESTINAL DE GRASAS"
  },
  {
    "codigo":315484006,
    "descripcion":"NACIDO EN MOZAMBIQUE"
  },
  {
    "codigo":1003612008,
    "descripcion":"METABOLIZADOR LENTO DE LA FAMILIA 4 SUBFAMILIA F MIEMBRO 2 DEL CITOCROMO P450"
  },
  {
    "codigo":870705000,
    "descripcion":"ESCASA FIJACIÓN VISUAL"
  },
  {
    "codigo":1296689002,
    "descripcion":"VOLUMEN COMPLETO DE VACUNA NO ADMINISTRADO"
  },
  {
    "codigo":12235861000119107,
    "descripcion":"PIE CAVO CONGÉNITO DE PIE IZQUIERDO"
  },
  {
    "codigo":1231153007,
    "descripcion":"FRACASO PRIMARIO DE LA ERUPCIÓN DENTARIA"
  },
  {
    "codigo":16905301000119108,
    "descripcion":"MELANOMA MALIGNO DE PIEL DE PÁRPADO SUPERIOR DERECHO"
  },
  {
    "codigo":248113009,
    "descripcion":"CONDUCTA RELACIONADA CON LA INGESTA Y EL APETITO"
  },
  {
    "codigo":770566002,
    "descripcion":"SÍNDROME DE MONOSOMÍA 13Q14"
  },
  {
    "codigo":311814002,
    "descripcion":"FRACTURAS MÚLTIPLES NO EXPUESTAS DE LA COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":15650031000119103,
    "descripcion":"GANGRENA DE EXTREMIDAD SUPERIOR IZQUIERDA DEBIDA A ATEROSCLEROSIS"
  },
  {
    "codigo":1293019004,
    "descripcion":"TUMOR FIBROHISTIOCÍTICO PLEXIFORME"
  },
  {
    "codigo":277211006,
    "descripcion":"CICATRIZ RETROAURICULAR"
  },
  {
    "codigo":703195007,
    "descripcion":"INSUFICIENCIA DE NEOVÁLVULA AÓRTICA"
  },
  {
    "codigo":308144002,
    "descripcion":"SUBLUXACIÓN RECIDIVANTE DE LA ARTICULACIÓN DE LA CADERA"
  },
  {
    "codigo":406448004,
    "descripcion":"REACCIÓN ADVERSA A ESPIRAMICINA"
  },
  {
    "codigo":46000006,
    "descripcion":"QUEMADURA DE CUALQUIER GRADO QUE COMPROMETE 70-79 PORCIENTO DE LA SUPERFICIE DEL CUERPO"
  },
  {
    "codigo":275376007,
    "descripcion":"CORIZA SIFILÍTICA CONGÉNITA CRÓNICA"
  },
  {
    "codigo":111536009,
    "descripcion":"HEMATOTÍMPANO"
  },
  {
    "codigo":78768009,
    "descripcion":"HEMORRAGIA SUBCONJUNTIVAL"
  },
  {
    "codigo":44165003,
    "descripcion":"COMPLICACIÓN DEL PULMÓN TRASPLANTADO"
  },
  {
    "codigo":109701004,
    "descripcion":"EXOSTOSIS LINGUAL"
  },
  {
    "codigo":304521000119101,
    "descripcion":"OSTEOMIELITIS CRÓNICA DE MANO CON FÍSTULA PRODUCTIVA"
  },
  {
    "codigo":373680009,
    "descripcion":"AVULSIÓN DE CORDÓN UMBILICAL"
  },
  {
    "codigo":15977711000119107,
    "descripcion":"MELANOMA MALIGNO DE AMBAS CONJUNTIVAS"
  },
  {
    "codigo":271706000,
    "descripcion":"MARCHA DE PATO"
  },
  {
    "codigo":15705481000119102,
    "descripcion":"CONCRECIÓN EN CONJUNTIVA DE PÁRPADO INFERIOR IZQUIERDO"
  },
  {
    "codigo":238938000,
    "descripcion":"PÉNFIGO PREBULLOSO"
  },
  {
    "codigo":1287514003,
    "descripcion":"ABRASIÓN DE PIEL DE GENITALES EXTERNOS"
  },
  {
    "codigo":1254746002,
    "descripcion":"METÁSTASIS DE CARCINOMA DE CÉLULAS GIGANTES EN PULMÓN DERECHO"
  },
  {
    "codigo":42330007,
    "descripcion":"ÚLCERA DE LA PRÓSTATA"
  },
  {
    "codigo":402778009,
    "descripcion":"MELANOSIS DIFUSA HEREDITARIA"
  },
  {
    "codigo":1351215002,
    "descripcion":"ENFERMEDAD POR DEPÓSITO DE HIDROXIAPATITA DE ARTICULACIÓN DE MUÑECA"
  },
  {
    "codigo":237103001,
    "descripcion":"INFECCIÓN DE LA BÓVEDA VAGINAL"
  },
  {
    "codigo":366340000,
    "descripcion":"HALLAZGO RELACIONADO CON LA FORMA DE LA CURVATURA SACRA"
  },
  {
    "codigo":268036005,
    "descripcion":"DEFORMIDAD ADQUIRIDA CON FLEXIÓN FIJA DE DEDO DE LA MANO"
  },
  {
    "codigo":724953000,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO FLEXOR DE DEDO DE LA MANO A LA ALTURA DEL ANTEBRAZO"
  },
  {
    "codigo":167897001,
    "descripcion":"RECUENTO CELULAR DE LÍQUIDO SINOVIAL, ALTO"
  },
  {
    "codigo":169732009,
    "descripcion":"TAMAÑO FETAL CONCUERDA CON EDAD GESTACIONAL"
  },
  {
    "codigo":300804008,
    "descripcion":"CAPAZ DE DEDICARSE A ACTIVIDADES RELIGIOSAS"
  },
  {
    "codigo":69593000,
    "descripcion":"LUXACIÓN EXPUESTA DE LA CUARTA VÉRTEBRA CERVICAL"
  },
  {
    "codigo":723118001,
    "descripcion":"TEMOR A CÁNCER MUSCULOESQUELÉTICO"
  },
  {
    "codigo":297134004,
    "descripcion":"NEOPLASIA BENIGNA DE LA PIEL DE CUELLO Y CUERO CABELLUDO"
  },
  {
    "codigo":721283000,
    "descripcion":"ACIDOSIS DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":198830009,
    "descripcion":"HEMÓLISIS INTRAVASCULAR POSABORTO"
  },
  {
    "codigo":262531002,
    "descripcion":"MARCA POR PINCHAZO"
  },
  {
    "codigo":387003,
    "descripcion":"MELANURIA"
  },
  {
    "codigo":33155001,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN LA REGIÓN DEL FLANCO, CON INFECCIÓN"
  },
  {
    "codigo":295299004,
    "descripcion":"SOBREDOSIS DE TENOXICAM"
  },
  {
    "codigo":195160000,
    "descripcion":"HEMORRAGIA SUBARACNOIDEA INTRACRANEAL DE ARTERIA VERTEBRAL"
  },
  {
    "codigo":1145432000,
    "descripcion":"HIPOPLASIA CONGÉNITA DE HUESO DE PELVIS"
  },
  {
    "codigo":1259827009,
    "descripcion":"NEOPLASIA PRIMARIA DE CÉLULAS GERMINALES MIXTAS DE SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":293464004,
    "descripcion":"REACCIÓN ADVERSA A LA BUMETANIDA"
  },
  {
    "codigo":64088006,
    "descripcion":"HIPERVISCOSIDAD"
  },
  {
    "codigo":95021000,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL FONDO DE SACO RECTOUTERINO"
  },
  {
    "codigo":162392009,
    "descripcion":"NO RONCO"
  },
  {
    "codigo":424536008,
    "descripcion":"INFECCIÓN DISEMINADA POR MYCOBACTERIUM KANSASII"
  },
  {
    "codigo":783149002,
    "descripcion":"DISOMÍA UNIPARENTAL PATERNA DE GENOMA COMPLETO EN MOSAICO"
  },
  {
    "codigo":193325002,
    "descripcion":"DESPRENDIMIENTO PARCIAL DE RETINA, ANTIGUO"
  },
  {
    "codigo":291629005,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR CEFSULODINA"
  },
  {
    "codigo":422701008,
    "descripcion":"TUBO DE DRENAJE DE GLAUCOMA EN POSICIÓN CORRECTA"
  },
  {
    "codigo":226093009,
    "descripcion":"DIETA DE AMINOÁCIDOS NO ESENCIALES MODIFICADOS"
  },
  {
    "codigo":289794001,
    "descripcion":"LESIÓN DEL CUELLO UTERINO"
  },
  {
    "codigo":333501000119103,
    "descripcion":"CELULITIS ORBITARIA DERECHA"
  },
  {
    "codigo":224258006,
    "descripcion":"MOHO EN LAS CAMAS EN EL HOGAR"
  },
  {
    "codigo":255191003,
    "descripcion":"RETICULOHISTIOCITOMA MALIGNO LOCALIZADO"
  },
  {
    "codigo":124119008,
    "descripcion":"DEFICIENCIA DE 3-HIDROXIISOBUTIRATO DESHIDROGENASA"
  },
  {
    "codigo":253356004,
    "descripcion":"APÉNDICE AURICULAR IZQUIERDO AUSENTE"
  },
  {
    "codigo":286124004,
    "descripcion":"INCAPAZ DE LIMPIAR LAS VENTANAS"
  },
  {
    "codigo":284289002,
    "descripcion":"INCAPAZ DE REALIZAR LA PRENSIÓN CON PRONACIÓN DE LA MUÑECA"
  },
  {
    "codigo":10628951000119102,
    "descripcion":"LINFADENITIS AGUDA DE CARA"
  },
  {
    "codigo":282454000,
    "descripcion":"CONTUSIÓN DE FARINGE"
  },
  {
    "codigo":251521009,
    "descripcion":"SIGNOS ELECTROMIOGRÁFICOS DE DENSIDAD REDUCIDA EN EL PATRÓN DE INTERFERENCIA"
  },
  {
    "codigo":249686003,
    "descripcion":"CLAVÍCULA CORTA"
  },
  {
    "codigo":315222005,
    "descripcion":"PROGRESIÓN LENTA DE ESPERMATOZOIDES"
  },
  {
    "codigo":20310007,
    "descripcion":"INTOXICACIÓN POR DIFENADIONA"
  },
  {
    "codigo":118614007,
    "descripcion":"ENFERMEDAD DE LETTERER-SIWE"
  },
  {
    "codigo":772139001,
    "descripcion":"HERNIA FEMORAL IZQUIERDA OBSTRUIDA"
  },
  {
    "codigo":84011002,
    "descripcion":"FALSETTO MUTACIONAL"
  },
  {
    "codigo":313387002,
    "descripcion":"FONOFOBIA"
  },
  {
    "codigo":247851005,
    "descripcion":"MIEDO A LOS TÚNELES"
  },
  {
    "codigo":1263659007,
    "descripcion":"METÁSTASIS DE CARCINOMA DE CÉLULAS TRANSICIONALES EN PELVIS RENAL"
  },
  {
    "codigo":213248000,
    "descripcion":"MUÑÓN DE AMPUTACIÓN DE FORMA INSATISFACTORIA"
  },
  {
    "codigo":49408009,
    "descripcion":"ESTERILIDAD MASCULINA"
  },
  {
    "codigo":768469006,
    "descripcion":"INCOMPETENCIA DE LABIO DEBIDA A SOBREMORDIDA HORIZONTAL"
  },
  {
    "codigo":111274000,
    "descripcion":"ABSCESO AGUDO DE SENO PARANASAL"
  },
  {
    "codigo":1290922001,
    "descripcion":"DISPLASIA CONGÉNITA DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":699263006,
    "descripcion":"HEMATOMA DE MAMA POSOPERATORIO"
  },
  {
    "codigo":371583007,
    "descripcion":"ENFERMEDAD CAUSADA POR BACTERIAS GRAMNEGATIVAS"
  },
  {
    "codigo":11831281000119105,
    "descripcion":"LESIÓN TRAUMÁTICA DE VENA DORSAL DE PIE DERECHO"
  },
  {
    "codigo":109439008,
    "descripcion":"CORONA DENTAL ANORMAL"
  },
  {
    "codigo":402516002,
    "descripcion":"CARCINOMA BASOCELULAR DEL ABDOMEN"
  },
  {
    "codigo":74836001,
    "descripcion":"PRESENCIA DE GEN SECRETOR (SE)"
  },
  {
    "codigo":1354623008,
    "descripcion":"FRACTURA DE CUARTO HUESO METATARSIANO"
  },
  {
    "codigo":336011000119100,
    "descripcion":"DACRIOADENITIS CRÓNICA DE OJO DERECHO"
  },
  {
    "codigo":238676008,
    "descripcion":"SÍNDROME DE LOFGRENS"
  },
  {
    "codigo":1187113001,
    "descripcion":"ENFERMEDAD SIMILAR A MUCOPOLISACARIDOSIS PLUS"
  },
  {
    "codigo":1252649001,
    "descripcion":"RETRACCIÓN NORMAL DE SEGMENTO UTERINO SUPERIOR"
  },
  {
    "codigo":40233000,
    "descripcion":"SÍNDROME NEFRÓTICO - NEFRÍTICO"
  },
  {
    "codigo":7465007,
    "descripcion":"INFECCIÓN CAUSADA POR AMIDOSTOMUM"
  },
  {
    "codigo":12214411000119102,
    "descripcion":"INFECCIÓN DE HUESO DE PIE IZQUIERDO ASOCIADA CON DISPOSITIVO DE FIJACIÓN INTERNA"
  },
  {
    "codigo":202238003,
    "descripcion":"LUXACIÓN RECURRENTE DE ARTICULACIÓN CARPOMETACARPIANA"
  },
  {
    "codigo":366078005,
    "descripcion":"PREFERENCIA DE PIE - HALLAZGO"
  },
  {
    "codigo":38398005,
    "descripcion":"PRESIÓN VENOSA CENTRAL DISMINUIDA"
  },
  {
    "codigo":235006007,
    "descripcion":"LESIÓN PERIODÓNCICA Y ENDODÓNCICA"
  },
  {
    "codigo":300542008,
    "descripcion":"ESPERMATOZOIDES MÓVILES"
  },
  {
    "codigo":169470007,
    "descripcion":"FRACASO DE PÍLDORA ANTICONCEPTIVA ORAL COMBINADA"
  },
  {
    "codigo":890366006,
    "descripcion":"MACRODACTILIA DE MANO BILATERAL"
  },
  {
    "codigo":724691003,
    "descripcion":"TRASTORNO DEL ESTADO DE ÁNIMO CON SÍNTOMAS MANÍACOS CAUSADO POR COCAÍNA"
  },
  {
    "codigo":167635008,
    "descripcion":"EXAMEN DE HECES: CRECIMIENTO"
  },
  {
    "codigo":822995009,
    "descripcion":"HIPERGLUCEMIA DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":397011009,
    "descripcion":"NEOPLASIA MALIGNA DE MASTOCITOS EN GANGLIOS LINFÁTICOS"
  },
  {
    "codigo":296872003,
    "descripcion":"SOBREDOSIS DE BIGUANIDA"
  },
  {
    "codigo":298707008,
    "descripcion":"HALLAZGO RELACIONADO CON EL TAMAÑO DEL TÓRAX"
  },
  {
    "codigo":1073291000119105,
    "descripcion":"ARTRITIS DE MANO IZQUIERDA CAUSADA POR BACTERIAS"
  },
  {
    "codigo":15956261000119100,
    "descripcion":"ADENOCARCINOMA METASTÁSICO DE PULMÓN IZQUIERDO"
  },
  {
    "codigo":427944007,
    "descripcion":"ASIMETRÍA CONGÉNITA DE LA FRENTE"
  },
  {
    "codigo":722856008,
    "descripcion":"OBSTRUCCIÓN DE INTESTINO GRUESO CONCOMITANTE CON ADHERENCIAS PERITONEALES Y DEBIDA A ELLAS"
  },
  {
    "codigo":360573001,
    "descripcion":"HIPERTENSIÓN PULMONAR POSCAPILAR"
  },
  {
    "codigo":32893002,
    "descripcion":"GLAUCOMA FACOLÍTICO"
  },
  {
    "codigo":1343613004,
    "descripcion":"EPILEPSIA INSULAR"
  },
  {
    "codigo":293202000,
    "descripcion":"REACCIÓN ADVERSA A LA BIGUANIDA"
  },
  {
    "codigo":719186004,
    "descripcion":"ATROFIA DE MÚSCULO PECTORAL"
  },
  {
    "codigo":162130008,
    "descripcion":"GOTEO DE ORINA AL FINAL DE LA MICCIÓN"
  },
  {
    "codigo":782887003,
    "descripcion":"TETRAPLEJÍA ESPÁSTICA CONGÉNITA HEREDITARIA"
  },
  {
    "codigo":225831004,
    "descripcion":"HALLAZGO RELACIONADO CON EL AMPARO LEGAL"
  },
  {
    "codigo":94759005,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL CUERPO UTERINO"
  },
  {
    "codigo":1208871009,
    "descripcion":"ATAQUE ISQUÉMICO TRANSITORIO CONCOMITANTE CON HEMORRAGIA SUBARACNOIDEA"
  },
  {
    "codigo":92924002,
    "descripcion":"FORMA ANORMAL CONGÉNITA DEL HÍGADO"
  },
  {
    "codigo":289532003,
    "descripcion":"ELIMINACIÓN DE COÁGULOS POR VÍA VAGINAL"
  },
  {
    "codigo":1010428003,
    "descripcion":"HIPOPLASIA DE APÓFISIS CONDÍLEA DERECHA DE MANDÍBULA"
  },
  {
    "codigo":27388005,
    "descripcion":"PLACENTA PREVIA PARCIAL CON HEMORRAGIA INTRAPARTO"
  },
  {
    "codigo":191228007,
    "descripcion":"ESFEROCITOSIS ADQUIRIDA"
  },
  {
    "codigo":309541000119108,
    "descripcion":"NECROSIS AVASCULAR DE HÚMERO IZQUIERDO"
  },
  {
    "codigo":449702005,
    "descripcion":"CELULITIS Y ABSCESO DE MIEMBRO INFERIOR"
  },
  {
    "codigo":11833791000119103,
    "descripcion":"ESGUINCE DE LIGAMENTO PERONEOASTRAGALINO DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":285862007,
    "descripcion":"INCAPAZ DE USAR EL LAVAPLATOS"
  },
  {
    "codigo":251259000,
    "descripcion":"VOLTAJE DE LA ONDA T ELEVADO"
  },
  {
    "codigo":1268902008,
    "descripcion":"BLASTOMA PULMONAR PRIMARIO"
  },
  {
    "codigo":710011009,
    "descripcion":"INSERCIÓN MUSCULAR EN ESTADO EDÉNTULO"
  },
  {
    "codigo":216656001,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR JABONES"
  },
  {
    "codigo":314960002,
    "descripcion":"RECIDIVA LOCAL DE TUMOR MALIGNO DE ESÓFAGO"
  },
  {
    "codigo":52816004,
    "descripcion":"TRANSACTIVACIÓN GENÉTICA"
  },
  {
    "codigo":282192007,
    "descripcion":"CAPAZ DE SUBIR ESCALERAS"
  },
  {
    "codigo":249424008,
    "descripcion":"HALLAZGO RELACIONADO CON EL APARATO SALIVAL"
  },
  {
    "codigo":444197004,
    "descripcion":"ATROFIA SISTÉMICA MÚLTIPLE, VARIANTE PARKINSONIANA"
  },
  {
    "codigo":245754007,
    "descripcion":"ENFERMEDAD DEL REFLUJO GASTROESOFÁGICO CON ULCERACIÓN"
  },
  {
    "codigo":737274008,
    "descripcion":"CONVALECENCIA POSTERIOR A TERAPIA DE REHABILITACIÓN"
  },
  {
    "codigo":212986009,
    "descripcion":"EFECTOS DE LA VIBRACIÓN"
  },
  {
    "codigo":81914009,
    "descripcion":"INTOXICACIÓN CAUSADA POR TRANQUILIZANTES A BASE DE BENZODIAZEPINAS"
  },
  {
    "codigo":1075801000119104,
    "descripcion":"TENOSINOVITIS SUPURATIVA DE TENDÓN FLEXOR DE MANO IZQUIERDA"
  },
  {
    "codigo":1259727001,
    "descripcion":"CÁNCER PULMONAR DE CÉLULAS NO MICROCÍTICAS PRIMARIO"
  },
  {
    "codigo":250120006,
    "descripcion":"DERRAME INCIPIENTE EN LA RODILLA"
  },
  {
    "codigo":440527006,
    "descripcion":"CARCINOMA PRIMARIO DE CÉLULAS ESCAMOSAS DE ORIFICIOS NASALES"
  },
  {
    "codigo":276687002,
    "descripcion":"HIPERBILIRRUBINEMIA CONJUGADA EN LA LACTANCIA"
  },
  {
    "codigo":735439008,
    "descripcion":"EOSINOPENIA CONSTITUCIONAL"
  },
  {
    "codigo":209316002,
    "descripcion":"FRACTURA-LUXACIÓN EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA DEL PULGAR"
  },
  {
    "codigo":733604003,
    "descripcion":"SÍNDROME DE MICROCEFALIA, LINFEDEMA Y CORIORRETINOPATÍA"
  },
  {
    "codigo":111012004,
    "descripcion":"DESPOBLACIÓN DE NEURONAS"
  },
  {
    "codigo":45476004,
    "descripcion":"ENFERMEDAD POR DEFICIENCIA DE YODO, SIN BOCIO"
  },
  {
    "codigo":15739481000119106,
    "descripcion":"GLAUCOMA DE OJO IZQUIERDO DEBIDO A LESIÓN TRAUMÁTICA DE GLOBO OCULAR IZQUIERDO Y POSTERIOR A ELLA"
  },
  {
    "codigo":305785000,
    "descripcion":"VISTO POR RADIÓLOGO DIAGNÓSTICO"
  },
  {
    "codigo":240249001,
    "descripcion":"DEFORMIDAD EN DORSIFLEXIÓN DE PIE"
  },
  {
    "codigo":699001001,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DE CARA Y CUERO CABELLUDO"
  },
  {
    "codigo":404089007,
    "descripcion":"TUMOR RABDOIDE EXTRARRENAL"
  },
  {
    "codigo":205646001,
    "descripcion":"SÍNDROME DE TRISOMÍA DE TODO EL CROMOSOMA"
  },
  {
    "codigo":830073009,
    "descripcion":"CONTORNO SUAVE DE VESÍCULA BILIAR"
  },
  {
    "codigo":402254003,
    "descripcion":"DERMATITIS ALÉRGICA POR CONTACTO DE MANOS"
  },
  {
    "codigo":9038003,
    "descripcion":"INFECCIÓN CAUSADA POR TAENIA MULTICEPS"
  },
  {
    "codigo":651000146102,
    "descripcion":"SÍNDROME RESPIRATORIO DE MEDIO ORIENTE"
  },
  {
    "codigo":39051000146103,
    "descripcion":"TRASTORNO DEL SUEÑO CAUSADO POR SEDANTE"
  },
  {
    "codigo":238414007,
    "descripcion":"BOTRIOMICOSIS ESTAFILOCÓCICA"
  },
  {
    "codigo":72739001,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO SEVERO DE ÓRGANOS ABDOMINALES SIN HERIDA ABIERTA HACIA CAVIDAD"
  },
  {
    "codigo":271182008,
    "descripcion":"AMPOLLA TRAUMÁTICA DE MUSLO, INFECTADA"
  },
  {
    "codigo":236579003,
    "descripcion":"RECHAZO CRÓNICO DE TRASPLANTE RENAL - GRADO I"
  },
  {
    "codigo":1186851006,
    "descripcion":"TIROIDITIS CAUSADA POR RADIACIÓN DEBIDA A TRATAMIENTO CON YODO 131 Y POSTERIOR A ÉL"
  },
  {
    "codigo":302115006,
    "descripcion":"HALLAZGO RELACIONADO CON UN DISPOSITIVO UROLÓGICO"
  },
  {
    "codigo":105507009,
    "descripcion":"DEPENDENCIA DEL PACIENTE CON RESPECTO AL MÉDICO"
  },
  {
    "codigo":890104004,
    "descripcion":"ATRESIA DE YEYUNO TIPO II"
  },
  {
    "codigo":300280008,
    "descripcion":"FARINGE NORMAL"
  },
  {
    "codigo":167373000,
    "descripcion":"VOLUMEN DE ORINA DE 24 HORAS FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":69069001,
    "descripcion":"PRURITO DE PENE"
  },
  {
    "codigo":121741000119101,
    "descripcion":"NEUMOMEDIASTINO NEONATAL"
  },
  {
    "codigo":724429004,
    "descripcion":"ACCIDENTE CEREBROVASCULAR CONCOMITANTE CON MIGRAÑA"
  },
  {
    "codigo":5368009,
    "descripcion":"DIABETES MELLITUS MEDICAMENTOSA"
  },
  {
    "codigo":3533007,
    "descripcion":"BACTÉRIDE PUSTULOSA"
  },
  {
    "codigo":298445008,
    "descripcion":"AMPLITUD DE FLEXIÓN LATERAL PASIVA HACIA LA IZQUIERDA DE LA COLUMNA VERTEBRAL CERVICAL, NORMAL"
  },
  {
    "codigo":1698001,
    "descripcion":"ÚLCERA DE CONDUCTO BILIAR"
  },
  {
    "codigo":296610000,
    "descripcion":"SOBREDOSIS DE ERITROMICINA"
  },
  {
    "codigo":198306003,
    "descripcion":"DESPLAZAMIENTO DE OVARIO Y TROMPA DE FALOPIO"
  },
  {
    "codigo":1279650001,
    "descripcion":"HERIDA PUNZANTE DE DEDO ÍNDICE DE MANO"
  },
  {
    "codigo":460450006,
    "descripcion":"PERICARDITIS CONSTRICTIVA CAUSADA POR VIRUS"
  },
  {
    "codigo":1179511006,
    "descripcion":"BIOTINA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":65399007,
    "descripcion":"HISTIOCITOSIS X"
  },
  {
    "codigo":294775006,
    "descripcion":"ALERGIA A METILTESTOSTERONA"
  },
  {
    "codigo":292940002,
    "descripcion":"REACCIÓN ADVERSA A LA NITROFURANTOÍNA"
  },
  {
    "codigo":1144908006,
    "descripcion":"ENFERMEDAD DE INJERTO VERSUS HUÉSPED CRÓNICA TARDÍA"
  },
  {
    "codigo":225569001,
    "descripcion":"OJO CIEGO DOLORIDO"
  },
  {
    "codigo":422177004,
    "descripcion":"DISNEA ASOCIADA CON SIDA"
  },
  {
    "codigo":127265005,
    "descripcion":"NEOPLASIA DE LOS GANGLIOS LINFÁTICOS POPLÍTEOS"
  },
  {
    "codigo":94497006,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL MEDIASTINO POSTERIOR"
  },
  {
    "codigo":291105004,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR DICLORALFENAZONA"
  },
  {
    "codigo":289270000,
    "descripcion":"COÁGULO RETROPLACENTARIO RECIENTE"
  },
  {
    "codigo":420342002,
    "descripcion":"QUERATOPATÍA EN BANDA CALCIFICADA"
  },
  {
    "codigo":92662002,
    "descripcion":"CARCINOMA IN SITU DEL MIOMETRIO"
  },
  {
    "codigo":341031000119103,
    "descripcion":"RUPTURA DE MEMBRANA DE DESCEMET DE OJO IZQUIERDO"
  },
  {
    "codigo":190966007,
    "descripcion":"OBESIDAD EXTREMA CON HIPOVENTILACIÓN ALVEOLAR"
  },
  {
    "codigo":254667001,
    "descripcion":"QUERATOSIS SOLAR HIPERTRÓFICA"
  },
  {
    "codigo":123595002,
    "descripcion":"PULMÓN URÉMICO"
  },
  {
    "codigo":713419002,
    "descripcion":"PARO CARDIORRESPIRATORIO INTRAOPERATORIO"
  },
  {
    "codigo":23456002,
    "descripcion":"SÍSTOLE ABORTADA"
  },
  {
    "codigo":88992002,
    "descripcion":"POSICIÓN MENTOILÍACA IZQUIERDA POSTERIOR"
  },
  {
    "codigo":285600004,
    "descripcion":"LESIÓN DE NERVIO PUDENDO"
  },
  {
    "codigo":11783361000119100,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN DE CADERA IZQUIERDA"
  },
  {
    "codigo":711584006,
    "descripcion":"ALTURA FACIAL LARGA"
  },
  {
    "codigo":1268640008,
    "descripcion":"CARCINOMA LINFOEPITELIAL PRIMARIO"
  },
  {
    "codigo":283765001,
    "descripcion":"MORDEDURA DE PERRO EN LOS GENITALES"
  },
  {
    "codigo":449440009,
    "descripcion":"AURÍCULA IZQUIERDA DIVIDIDA CON DESEMBOCADURA DE TODAS LAS VENAS PULMONARES EN LA CÁMARA PROXIMAL SIN COMUNICACIÓN CON LA AURÍCULA IZQUIERDA CON COMUNICACIÓN EXTRACARDÍACA CON LA CÁMARA VENOSA PULMONAR"
  },
  {
    "codigo":250997003,
    "descripcion":"ORIFICIO MÚLTIPLE DE VÁLVULA MITRAL"
  },
  {
    "codigo":185461007,
    "descripcion":"VISITA DOMICILIARIA PLANEADA POR EL MÉDICO"
  },
  {
    "codigo":54389007,
    "descripcion":"PERIOSTITIS ALVEOLAR OSIFICANTE CRÓNICA"
  },
  {
    "codigo":150721000119102,
    "descripcion":"HEMORRAGIA GÁSTRICA DEBIDA A GASTRITIS ATRÓFICA"
  },
  {
    "codigo":249162001,
    "descripcion":"DESEO DE PUJAR DURANTE EL TRABAJO DE PARTO"
  },
  {
    "codigo":1363274003,
    "descripcion":"DESGARRO DE RETINA DE AMBOS OJOS"
  },
  {
    "codigo":314698004,
    "descripcion":"TALLA DEL NIÑO: PERCENTILO 76-90"
  },
  {
    "codigo":281930004,
    "descripcion":"FRACTURA DE TRES COLUMNAS DE VÉRTEBRA DORSAL"
  },
  {
    "codigo":312863000,
    "descripcion":"DATOS DEL PACIENTE NO REGISTRADOS"
  },
  {
    "codigo":183626008,
    "descripcion":"SEGUIMIENTO EN 7-11 MESES"
  },
  {
    "codigo":1197599005,
    "descripcion":"LUXACIÓN INFERIOR CERRADA DE ARTICULACIÓN GLENOHUMERAL"
  },
  {
    "codigo":16116004,
    "descripcion":"TOXOPLASMOSIS LINFADENOPÁTICA AGUDA"
  },
  {
    "codigo":704244005,
    "descripcion":"FRACTURA PATOLÓGICA DE CÚBITO EN SITIO DE NEOPLASIA"
  },
  {
    "codigo":1162996007,
    "descripcion":"TÍTULO DE ANTIESTREPTOLISINA O POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":276425000,
    "descripcion":"SECCIÓN TRAUMÁTICA DE TENDÓN FLEXOR LARGO - ZONA 4"
  },
  {
    "codigo":407497001,
    "descripcion":"INFECCIÓN POR VIRUS SENDAI"
  },
  {
    "codigo":473033004,
    "descripcion":"COMPLICACIÓN ASOCIADA CON BOMBA DE INSULINA"
  },
  {
    "codigo":210889007,
    "descripcion":"LESIÓN EXPUESTA, ARTERIA TIBIAL ANTERIOR"
  },
  {
    "codigo":866249008,
    "descripcion":"DIENTES QUE REQUIEREN TRATAMIENTO INMEDIATO"
  },
  {
    "codigo":47049007,
    "descripcion":"ANQUILOSIS DE LA COLUMNA VERTEBRAL"
  },
  {
    "codigo":241822000,
    "descripcion":"ENVENENAMIENTO CAUSADO POR PEZ VENENOSO"
  },
  {
    "codigo":1259465009,
    "descripcion":"DEMENCIA DEBIDA INSUFICIENCIA HEPÁTICA"
  },
  {
    "codigo":733342000,
    "descripcion":"CONTRACTURA ISQUÉMICA DE RIÑÓN"
  },
  {
    "codigo":209054005,
    "descripcion":"LUXACIÓN EXPUESTA DE LA COLUMNA CERVICAL"
  },
  {
    "codigo":45214008,
    "descripcion":"ARTRITIS INFECCIOSA CRÓNICA"
  },
  {
    "codigo":403827000,
    "descripcion":"DEFICIENCIA FAMILIAR DE LIPOPROTEINLIPASA CON FENOTIPO TIPO I"
  },
  {
    "codigo":1255795006,
    "descripcion":"HISTIOCITOSIS MALIGNA DE GANGLIOS LINFÁTICOS DE MIEMBRO INFERIOR"
  },
  {
    "codigo":371059007,
    "descripcion":"VÉRTIGO POR ARTROSIS CERVICAL"
  },
  {
    "codigo":305523007,
    "descripcion":"BAJO ATENCIÓN DE MÉDICO LABORAL"
  },
  {
    "codigo":239987006,
    "descripcion":"DEDO EN GATILLO"
  },
  {
    "codigo":762440005,
    "descripcion":"CUADRANTOPSIA HETERÓNIMA BINASAL"
  },
  {
    "codigo":270920006,
    "descripcion":"PRUEBA DE HEAF: POSITIVA"
  },
  {
    "codigo":8776008,
    "descripcion":"CISTITIS AMEBIANA"
  },
  {
    "codigo":860744009,
    "descripcion":"GRUPO DE GRADO 3 DE GLEASON"
  },
  {
    "codigo":334621009,
    "descripcion":"APRAXIA DE LA MOVILIDAD DE LAS EXTREMIDADES"
  },
  {
    "codigo":365554002,
    "descripcion":"INGRESOS INDIVIDUALES - HALLAZGO"
  },
  {
    "codigo":1119218004,
    "descripcion":"DOLOR EN REGIÓN ABDOMINAL LUMBAR IZQUIERDA"
  },
  {
    "codigo":288091000119109,
    "descripcion":"INSOMNIO CONDUCTUAL INFANTIL, POR FALTA DE LÍMITES"
  },
  {
    "codigo":70642007,
    "descripcion":"PIGÓPAGO"
  },
  {
    "codigo":234482009,
    "descripcion":"TROMBOCITOPENIA AMEGACARIOCÍTICA"
  },
  {
    "codigo":298183002,
    "descripcion":"AMPLITUD DE MOTILIDAD ARTICULAR PASIVA AUMENTADA"
  },
  {
    "codigo":36039004,
    "descripcion":"TRASTORNO DE RUMIACIÓN EN LA INFANCIA"
  },
  {
    "codigo":789703007,
    "descripcion":"ARTERIOSCLEROSIS DE ARTERIA DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":199879009,
    "descripcion":"ANOMALÍA CONGÉNITA DE PIEL"
  },
  {
    "codigo":296348003,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE FENOXIBENZAMINA"
  },
  {
    "codigo":1080821000119106,
    "descripcion":"HISTIOCITOMA FIBROSO MALIGNO PRIMARIO DE PARTES BLANDAS DE EXTREMIDAD INFERIOR IZQUIERDA"
  },
  {
    "codigo":66972006,
    "descripcion":"ENTEROPATÍA CON PÉRDIDA DE PROTEÍNAS"
  },
  {
    "codigo":1344924009,
    "descripcion":"RASGO DE INESTABILIDAD AFECTIVA"
  },
  {
    "codigo":720497002,
    "descripcion":"HIPERINMUNIZACIÓN ANTI-ANTÍGENO LEUCOCÍTICO HUMANO"
  },
  {
    "codigo":32369003,
    "descripcion":"OSTEOPOROSIS MENOPÁUSICA"
  },
  {
    "codigo":292678003,
    "descripcion":"REACCIÓN ADVERSA A INHIBIDOR DE XANTINA OXIDASA"
  },
  {
    "codigo":11812341000119109,
    "descripcion":"LESIÓN TRAUMÁTICA PRIMARIA DE COLON TRANSVERSO POR EXPLOSIÓN"
  },
  {
    "codigo":63302006,
    "descripcion":"PIELONEFRITIS CRÓNICA"
  },
  {
    "codigo":389147003,
    "descripcion":"POLICITEMIA RELATIVA"
  },
  {
    "codigo":94235004,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL CIEGO"
  },
  {
    "codigo":127003006,
    "descripcion":"NEOPLASIA DE ÓRBITA"
  },
  {
    "codigo":10638991000119105,
    "descripcion":"ÚLCERA NEUROPÁTICA DE PIERNA IZQUIERDA"
  },
  {
    "codigo":290843009,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR LOFEPRAMINA"
  },
  {
    "codigo":92400002,
    "descripcion":"NEOPLASIA BENIGNA DE PARTES BLANDAS DEL TRONCO"
  },
  {
    "codigo":289008004,
    "descripcion":"SE LLEVA ALIMENTOS A LA BOCA"
  },
  {
    "codigo":420080006,
    "descripcion":"ALERGIA A ZANAHORIA"
  },
  {
    "codigo":254405002,
    "descripcion":"NEOPLASIA DE DORSO DE LENGUA ANTERIOR"
  },
  {
    "codigo":57797005,
    "descripcion":"INTERRUPCIÓN INDUCIDA DEL EMBARAZO"
  },
  {
    "codigo":25029006,
    "descripcion":"DIAGNÓSTICO APLAZADO EN EL EJE III"
  },
  {
    "codigo":1335749006,
    "descripcion":"NECROSIS AVASCULAR DE HÚMERO"
  },
  {
    "codigo":449178002,
    "descripcion":"DEFECTO DE TABIQUE INTERVENTRICULAR SUPRACRISTAL EN DOBLE TRACTO DE SALIDA DE CONEXIÓN VENTRICULOARTERIAL"
  },
  {
    "codigo":285338008,
    "descripcion":"HUESO EN FARINGE"
  },
  {
    "codigo":86895006,
    "descripcion":"ÚLCERA DUODENAL AGUDA CON HEMORRAGIA Y PERFORACIÓN"
  },
  {
    "codigo":281668000,
    "descripcion":"HALLAZGO RELACIONADO CON LA PRESIÓN DEL LÍQUIDO CEFALORRAQUÍDEO"
  },
  {
    "codigo":283503008,
    "descripcion":"HERIDA PUNZANTE DE REGIÓN OCULAR"
  },
  {
    "codigo":248900002,
    "descripcion":"HALLAZGO EN EPITELIO VAGINAL"
  },
  {
    "codigo":412740002,
    "descripcion":"ERITEMA PERIORBITARIO"
  },
  {
    "codigo":871492003,
    "descripcion":"ESGUINCE DE LIGAMENTO SACROESPINOSO"
  },
  {
    "codigo":314436005,
    "descripcion":"SÍNDROME ISQUÉMICO OCULAR"
  },
  {
    "codigo":312601003,
    "descripcion":"ANOMALÍA DE AORTA TORÁCICA"
  },
  {
    "codigo":83225003,
    "descripcion":"TRASTORNO BIPOLAR II"
  },
  {
    "codigo":17689009,
    "descripcion":"NEURITIS DEL NERVIO MEDIANO"
  },
  {
    "codigo":1197337009,
    "descripcion":"ADENOMA TUBULAR BENIGNO DE ESTÓMAGO"
  },
  {
    "codigo":212462003,
    "descripcion":"LESIÓN DE LOS TENDONES Y MÚSCULOS EXTENSORES O ABDUCTORES DEL PULGAR A NIVEL DEL ANTEBRAZO"
  },
  {
    "codigo":346051000119103,
    "descripcion":"QUERATITIS FILAMENTOSA BILATERAL"
  },
  {
    "codigo":251000119105,
    "descripcion":"DEPRESIÓN MAYOR SEVERA, EPISODIO ÚNICO"
  },
  {
    "codigo":1259203002,
    "descripcion":"GRANULACIÓN ARACNOIDEA GIGANTE"
  },
  {
    "codigo":865987004,
    "descripcion":"DOLOR A LA PALPACIÓN DE DIENTE"
  },
  {
    "codigo":79555006,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DE ESCROTO"
  },
  {
    "codigo":210627009,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA, DEDO DE LA MANO, A TRAVÉS DE ARTICULACIÓN INTERFALÁNGICA PROXIMAL"
  },
  {
    "codigo":700312003,
    "descripcion":"ARTROSIS DE ARTICULACIÓN CALCANEOCUBOIDEA SECUNDARIA A TRAUMATISMO"
  },
  {
    "codigo":307096004,
    "descripcion":"CON ORGANIGRAMA DE EMPLEO DEL SECTOR VOLUNTARIO"
  },
  {
    "codigo":12184005,
    "descripcion":"DEFECTO DEL CAMPO VISUAL"
  },
  {
    "codigo":1083331000119106,
    "descripcion":"OTITIS CRÓNICA MUCOIDE DE AMBOS OÍDOS MEDIOS"
  },
  {
    "codigo":44952008,
    "descripcion":"EPIDERMOPOYESIS ANORMAL"
  },
  {
    "codigo":895085001,
    "descripcion":"ANEURISMA POR LESIÓN TRAUMÁTICA"
  },
  {
    "codigo":403565003,
    "descripcion":"LIQUEN ESCLEROSO VULVAR, FORMA INFANTIL"
  },
  {
    "codigo":75885003,
    "descripcion":"TRASTORNO DE LA VÍAS VISUALES ASOCIADO CON NEOPLASIA"
  },
  {
    "codigo":698477003,
    "descripcion":"MONOARTRITIS DE ARTICULACIÓN DE REGIÓN DE HOMBRO"
  },
  {
    "codigo":239725005,
    "descripcion":"RUPTURA DEL LIGAMENTO CRUZADO ANTERIOR"
  },
  {
    "codigo":10349009,
    "descripcion":"DEMENCIA VASCULAR, CON DELIRIO"
  },
  {
    "codigo":74050005,
    "descripcion":"ENFERMEDAD POR VIRUS DEL ORF"
  },
  {
    "codigo":237890006,
    "descripcion":"ENFERMEDAD ÓSEA HIPOFOSFATÉMICA AUTOSÓMICA DOMINANTE"
  },
  {
    "codigo":205122007,
    "descripcion":"POLIDACTILIA RADIAL DE WASSEL 1"
  },
  {
    "codigo":6679002,
    "descripcion":"ESPÉCIMEN SUBÓPTIMO PARA DIAGNÓSTICO"
  },
  {
    "codigo":301591006,
    "descripcion":"NO SE MANEJA EN ESCALERAS"
  },
  {
    "codigo":72215007,
    "descripcion":"HOMOEROTISMO JUVENIL MASCULINO"
  },
  {
    "codigo":203287008,
    "descripcion":"OSTEOPATÍA POLIOMIELÍTICA DE BRAZO"
  },
  {
    "codigo":236055009,
    "descripcion":"HERNIA HIATAL MIXTA"
  },
  {
    "codigo":365292002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA CONTROLAR LA INSTALACIÓN ELÉCTRICA PRINCIPAL"
  },
  {
    "codigo":168684003,
    "descripcion":"RADIOGRAFÍA SIMPLE DE FÉMUR NORMAL"
  },
  {
    "codigo":299756004,
    "descripcion":"REFLEJO DE SUCCIÓN PRESENTE"
  },
  {
    "codigo":234220001,
    "descripcion":"MARCAPASOS HIPERSENSIBLE"
  },
  {
    "codigo":1055255008,
    "descripcion":"AGENESIA DE EPÍFISIS DE FALANGE PROXIMAL DE DEDO ÍNDICE"
  },
  {
    "codigo":35777006,
    "descripcion":"MONONEUROPATÍA DIABÉTICA MÚLTIPLE"
  },
  {
    "codigo":3009006,
    "descripcion":"INTOXICACIÓN POR SOLANUM MALACOXYLON"
  },
  {
    "codigo":47351000119102,
    "descripcion":"COMPRESIÓN POSTRAUMÁTICA DE NERVIO"
  },
  {
    "codigo":723905008,
    "descripcion":"TRASTORNO BIPOLAR TIPO II, ACTUALMENTE EN REMISIÓN COMPLETA"
  },
  {
    "codigo":363457009,
    "descripcion":"NEOPLASIA MALIGNA DE PELVIS RENAL"
  },
  {
    "codigo":197782004,
    "descripcion":"PIELONEFRITIS ASOCIADA CON OTRO TRASTORNO"
  },
  {
    "codigo":165014009,
    "descripcion":"PRUEBA ALÉRGICA POSITIVA"
  },
  {
    "codigo":722070009,
    "descripcion":"EXCESO DE PIEL Y TEJIDO SUBCUTÁNEO"
  },
  {
    "codigo":32107005,
    "descripcion":"ANOMALÍA DEL PAR DE CROMOSOMAS 17"
  },
  {
    "codigo":1144384000,
    "descripcion":"ATROFIA DE VÍA PIRAMIDAL"
  },
  {
    "codigo":10860791000119105,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR ACTIVADOR DE PLASMINÓGENO TISULAR"
  },
  {
    "codigo":423488006,
    "descripcion":"EDEMA DE PAPILA - EDEMA DE PAPILA ÓPTICA POR ELEVACIÓN DE LA PRESIÓN INTRACRANEANA"
  },
  {
    "codigo":95808008,
    "descripcion":"INFECCIÓN DEL LÓBULO DE LA OREJA"
  },
  {
    "codigo":194112008,
    "descripcion":"ESOTROPÍA CON COMPENSACIÓN ACOMODATIVA"
  },
  {
    "codigo":126741004,
    "descripcion":"NEOPLASIA DE VASO SANGUÍNEO DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":290581005,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR MITOBRONITOL"
  },
  {
    "codigo":93973004,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA REGIÓN PRESACRA"
  },
  {
    "codigo":11843831000119108,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE OÍDO EXTERNO IZQUIERDO"
  },
  {
    "codigo":225045006,
    "descripcion":"CORTARSE LA GARGANTA"
  },
  {
    "codigo":716565009,
    "descripcion":"CON MAYOR RIESGO DE EXPLOTACIÓN SEXUAL INFANTIL"
  },
  {
    "codigo":26602006,
    "descripcion":"INTOXICACIÓN POR ORNITHOGALUM"
  },
  {
    "codigo":288746007,
    "descripcion":"SE HACE ENTENDER"
  },
  {
    "codigo":92138008,
    "descripcion":"NEOPLASIA BENIGNA DE LA CARA HIPOFARÍNGEA DEL PLIEGUE INTERARITENOIDEO"
  },
  {
    "codigo":59370009,
    "descripcion":"QUERATOSIS OBTURATRIZ DE CONDUCTO AUDITIVO EXTERNO"
  },
  {
    "codigo":1204415006,
    "descripcion":"SÍNDROME DE ATAXIA ESPINOCEREBELOSA AUTOSÓMICA RECESIVA, CEGUERA Y SORDERA"
  },
  {
    "codigo":283241000,
    "descripcion":"VIDRIO EN EL CUELLO"
  },
  {
    "codigo":874900008,
    "descripcion":"DEFICIENCIA MODERADA DE GLUCOSA-6-FOSFATO DESHIDROGENASA"
  },
  {
    "codigo":186772009,
    "descripcion":"FIEBRE MANCHADA DE LAS MONTAÑAS ROCOSAS"
  },
  {
    "codigo":1085841000119108,
    "descripcion":"HEMORRAGIA RECTAL DEBIDA A ENFERMEDAD DE CROHN DE INTESTINO DELGADO Y GRUESO"
  },
  {
    "codigo":248638000,
    "descripcion":"PULSO RADIOFEMORAL RETARDADO"
  },
  {
    "codigo":84798002,
    "descripcion":"INFECCIÓN CAUSADA POR SPICULOCAULUS"
  },
  {
    "codigo":707390005,
    "descripcion":"CARCINOMA BASALOIDE PRIMARIO DE CÉLULAS ESCAMOSAS DE TRÁQUEA"
  },
  {
    "codigo":1231678007,
    "descripcion":"DISTROFIA COROIDEA PERIPAPILAR"
  },
  {
    "codigo":246803005,
    "descripcion":"TELECANTO"
  },
  {
    "codigo":42991000087101,
    "descripcion":"QUEMADURA DE DEDO ANULAR DERECHO"
  },
  {
    "codigo":115731008,
    "descripcion":"GRUPO SANGUÍNEO O>H<BOMBAY"
  },
  {
    "codigo":279571009,
    "descripcion":"VARIACIÓN ESTACIONAL DEL HUMOR"
  },
  {
    "codigo":40431000087106,
    "descripcion":"CUERPO EXTRAÑO EN ANTEBRAZO IZQUIERDO"
  },
  {
    "codigo":50671000087107,
    "descripcion":"DOLOR MUSCULOESQUELÉTICO CRÓNICO DEBIDO A TRASTORNO DE TENDÓN"
  },
  {
    "codigo":15592002,
    "descripcion":"EMBARAZOS PREVIOS: 1"
  },
  {
    "codigo":48111000087107,
    "descripcion":"PUS EN INTESTINO GRUESO"
  },
  {
    "codigo":212200006,
    "descripcion":"LESIÓN DE LA RAÍZ DEL NERVIO CERVICAL - C4"
  },
  {
    "codigo":310504009,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LOCALIZACIÓN DESCONOCIDA"
  },
  {
    "codigo":271795006,
    "descripcion":"MALESTAR Y FATIGA"
  },
  {
    "codigo":210365008,
    "descripcion":"HERIDA ABIERTA DEL PALADAR"
  },
  {
    "codigo":44690000,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE VULVA CON INFECCIÓN"
  },
  {
    "codigo":208530003,
    "descripcion":"FRACTURA NO EXPUESTA DE FÉMUR PROXIMAL, SUBCAPITAL, GRADO III DE GARDEN"
  },
  {
    "codigo":700050004,
    "descripcion":"INFECCIÓN DEVASTADORA EN PACIENTE ASPLÉNICO"
  },
  {
    "codigo":863890007,
    "descripcion":"AMPOLLA EN LUGAR DE APLICACIÓN"
  },
  {
    "codigo":110226008,
    "descripcion":"QUEMADURA DE LA OROFARINGE"
  },
  {
    "codigo":370535001,
    "descripcion":"EXCESO DE YANG"
  },
  {
    "codigo":1255271005,
    "descripcion":"SÍNDROME DE DIABETES MELLITUS TIPO 1 Y NEURODEGENERACIÓN CENTRAL Y PERIFÉRICA"
  },
  {
    "codigo":42855005,
    "descripcion":"ABSCESO DE LA VESÍCULA SEMINAL"
  },
  {
    "codigo":1156967007,
    "descripcion":"MIELOPATÍA DEBIDA A ESPONDILOSIS CERVICAL MULTINIVEL"
  },
  {
    "codigo":10087007,
    "descripcion":"INFECCIÓN CAUSADA POR SCHISTOSOMA"
  },
  {
    "codigo":403303009,
    "descripcion":"DISTROFIA UNGUEAL DEBIDA A TRATAMIENTO CITOTÓXICO"
  },
  {
    "codigo":237628005,
    "descripcion":"ALTERACIÓN DE LA TOLERANCIA A LA GLUCOSA EN EL EMBARAZO"
  },
  {
    "codigo":12065631000119100,
    "descripcion":"QUEMADURA DE OÍDO DERECHO"
  },
  {
    "codigo":235793000,
    "descripcion":"FÍSTULA ANAL SUPRAESFINTÉRICA"
  },
  {
    "codigo":268561003,
    "descripcion":"INMUNIZACIÓN CONTRA INFLUENZA ACONSEJADA EN LA CIRUGÍA"
  },
  {
    "codigo":301329004,
    "descripcion":"PROBLEMA DE CRECIMIENTO CORPORAL"
  },
  {
    "codigo":71953008,
    "descripcion":"ANOMALÍA CONGÉNITA DEL LIGAMENTO ANCHO"
  },
  {
    "codigo":203025009,
    "descripcion":"ABSCESO DE MÚSCULO DE MANO"
  },
  {
    "codigo":233958001,
    "descripcion":"VASCULOPATÍA ISQUÉMICA PERIFÉRICA"
  },
  {
    "codigo":299494000,
    "descripcion":"AMPLITUD DE PRONACIÓN MEDIOTARSIANA PASIVA AUMENTADA"
  },
  {
    "codigo":365030004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA ELIMINAR EL ESPUTO"
  },
  {
    "codigo":37350004,
    "descripcion":"DEFICIENCIA HEREDITARIA DE FACTOR X"
  },
  {
    "codigo":102886001,
    "descripcion":"PRODUCCIÓN DE LÍQUIDO AMNIÓTICO, AUMENTADA"
  },
  {
    "codigo":168422005,
    "descripcion":"EXTENDIDO CERVICAL: ACTINOMYCES"
  },
  {
    "codigo":35515007,
    "descripcion":"INFESTACIÓN CAUSADA POR CTENOCEPHALIDES"
  },
  {
    "codigo":15997791000119105,
    "descripcion":"DEFECTO DE CAPA DE FIBRAS NERVIOSAS DE RETINA DERECHA"
  },
  {
    "codigo":230288001,
    "descripcion":"DEMENCIA SEMÁNTICA"
  },
  {
    "codigo":426896000,
    "descripcion":"INSUFICIENCIA RESPIRATORIA CRÓNICA HIPERCÁPNICA"
  },
  {
    "codigo":721808004,
    "descripcion":"INFECCIÓN DE INTESTINO CAUSADA POR ENTAMOEBA HISTOLYTICA"
  },
  {
    "codigo":912005,
    "descripcion":"ESTENOSIS CONGÉNITA DE ESÓFAGO"
  },
  {
    "codigo":295824007,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE LISURIDA"
  },
  {
    "codigo":164752008,
    "descripcion":"ANOMALÍA EN LA AUDIOMETRÍA DERECHA"
  },
  {
    "codigo":263056009,
    "descripcion":"SUBLUXACIÓN DE ARTICULACIÓN DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":293989004,
    "descripcion":"ALERGIA A FENOXIBENZAMINA"
  },
  {
    "codigo":195685005,
    "descripcion":"LARINGITIS NEUMOCÓCICA AGUDA"
  },
  {
    "codigo":425061006,
    "descripcion":"LINFADENOPATÍA DE CABEZA Y\/O CUELLO"
  },
  {
    "codigo":64613007,
    "descripcion":"INFLAMACIÓN DEL INTESTINO DELGADO"
  },
  {
    "codigo":228453005,
    "descripcion":"ACTIVO SEXUALMENTE"
  },
  {
    "codigo":719973009,
    "descripcion":"SÍNDROME DE HAIM MUNK"
  },
  {
    "codigo":161082005,
    "descripcion":"DISPUTA FAMILIAR"
  },
  {
    "codigo":423226005,
    "descripcion":"TENDINITIS DE DEDO DE LA MANO"
  },
  {
    "codigo":95546008,
    "descripcion":"PÓLIPOS CUTÁNEOS PERIANALES"
  },
  {
    "codigo":292154009,
    "descripcion":"REACCIÓN ADVERSA A LA POLDINA"
  },
  {
    "codigo":1145096006,
    "descripcion":"AUSENCIA DE PESTAÑAS DE PÁRPADO INFERIOR"
  },
  {
    "codigo":93711001,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE VASO SANGUÍNEO DE DEDO DEL PIE"
  },
  {
    "codigo":28175004,
    "descripcion":"HIPERPLASIA LINFOIDE DE ESTÓMAGO"
  },
  {
    "codigo":290319004,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR RADIOFÁRMACO"
  },
  {
    "codigo":124644001,
    "descripcion":"DEFICIENCIA DE CARBONO - OXÍGENO LIASA"
  },
  {
    "codigo":286649004,
    "descripcion":"DUDA DE SÍ MISMO"
  },
  {
    "codigo":1204153007,
    "descripcion":"DISECCIÓN CORONARIA AGUDA"
  },
  {
    "codigo":253881008,
    "descripcion":"ENFERMEDAD QUÍSTICA CORTICAL"
  },
  {
    "codigo":219278004,
    "descripcion":"LESIÓN POR INTERVENCIÓN LEGAL CON INSTRUMENTOS CORTANTE Y PUNZANTE"
  },
  {
    "codigo":284814007,
    "descripcion":"DIFICULTAD AL SENTARSE EN LA BAÑERA"
  },
  {
    "codigo":446819001,
    "descripcion":"TRASTORNO MIXTO DE OÍDO MEDIO Y MASTOIDES"
  },
  {
    "codigo":710798009,
    "descripcion":"HEMANGIOENDOTELIOMA JUVENIL"
  },
  {
    "codigo":1003875001,
    "descripcion":"DUPLICACIÓN DE PORCIÓN PROXIMAL DEL BRAZO LARGO DEL CROMOSOMA 17"
  },
  {
    "codigo":414051007,
    "descripcion":"OBSERVACIONES RELACIONADAS CON LA ADMINISTRACIÓN DE MEDICAMENTOS"
  },
  {
    "codigo":1264184001,
    "descripcion":"TRASTORNO NEONATAL PRECOZ CAUSADO POR ANALGESIA MATERNA TRANSMITIDA POR VÍA PLACENTARIA DURANTE TRABAJO DE PARTO"
  },
  {
    "codigo":281144009,
    "descripcion":"PASIVIDAD SOMÁTICA"
  },
  {
    "codigo":82701004,
    "descripcion":"DIABETES MELLITUS PREGESTACIONAL Y\/O TRASTORNO DE LA TOLERANCIA A LA GLUCOSA, CLASE FR DE WHITE MODIFICADA"
  },
  {
    "codigo":279309008,
    "descripcion":"OSTEOGÉNESIS IMPERFECTA TIPO IV B"
  },
  {
    "codigo":277474005,
    "descripcion":"VARIANTE DE LEUCEMIA LINFOCÍTICA CRÓNICA DE LINFOCITOS B"
  },
  {
    "codigo":46263000,
    "descripcion":"CATAPLEXIA"
  },
  {
    "codigo":408546009,
    "descripcion":"OCLUSIÓN DE INJERTO PUENTE DE ARTERIA CORONARIA"
  },
  {
    "codigo":79031007,
    "descripcion":"HEPATITIS VIRAL TIPO A ANICTÉRICA"
  },
  {
    "codigo":109964000,
    "descripcion":"LINFOMA NO HODGKINIANO DIFUSO, INDIFERENCIADO"
  },
  {
    "codigo":44428005,
    "descripcion":"CELULITIS DE LA NALGA"
  },
  {
    "codigo":372108006,
    "descripcion":"NEOPLASIA MALIGNA DE HUESO DE MIEMBRO INFERIOR"
  },
  {
    "codigo":16819501000119106,
    "descripcion":"RUPTURA ESPONTÁNEA DE FASCIA PLANTAR DE PIE DERECHO"
  },
  {
    "codigo":16711111000119100,
    "descripcion":"NEOVASCULARIZACIÓN DE LA RETINA DEBIDA A OCLUSIÓN DE AMBAS VENAS CENTRALES DE LA RETINA"
  },
  {
    "codigo":239201001,
    "descripcion":"INSUFICIENCIA ARTERIAL DEL COLGAJO"
  },
  {
    "codigo":271969004,
    "descripcion":"ALTERACIÓN DEL ESTIMULADOR DE LA COLUMNA DORSAL"
  },
  {
    "codigo":237366000,
    "descripcion":"MORTINATO MACERADO"
  },
  {
    "codigo":304737009,
    "descripcion":"PARÁLISIS PERIÓDICA HIPERCALÉMICA FAMILIAR"
  },
  {
    "codigo":7990002,
    "descripcion":"INMUNOGLOBULINEMIA CON DEFICIENCIA AISLADA DE SOMATOTROPINA"
  },
  {
    "codigo":302902003,
    "descripcion":"INFARTO DEL QUIASMA ÓPTICO"
  },
  {
    "codigo":403041008,
    "descripcion":"TIÑA CORPORAL CAUSADA POR TRICHOPHYTON SOUDANENSE"
  },
  {
    "codigo":1187638005,
    "descripcion":"INFLAMACIÓN INTESTINAL"
  },
  {
    "codigo":401206008,
    "descripcion":"CON MAYOR RIESGO DE AUTOAGRESIÓN INTENCIONAL"
  },
  {
    "codigo":169995000,
    "descripcion":"INICIA DIETA NORMAL A LOS 9 MESES"
  },
  {
    "codigo":10976711000119104,
    "descripcion":"NEOPLASIA NEUROECTODÉRMICA PRIMITIVA PRIMARIA DE SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":366603004,
    "descripcion":"NIVEL DE TOLERANCIA DEL DOLOR - HALLAZGO"
  },
  {
    "codigo":266464001,
    "descripcion":"HEMORRAGIA DE RECTO Y ANO"
  },
  {
    "codigo":299232002,
    "descripcion":"ARTICULACIÓN DE LA CADERA TUMEFACTA"
  },
  {
    "codigo":102624003,
    "descripcion":"MOTILIDAD INTESTINAL AUMENTADA"
  },
  {
    "codigo":233696002,
    "descripcion":"LICOPERDONOSIS"
  },
  {
    "codigo":4320005,
    "descripcion":"DEFICIENCIA DE FACTOR V"
  },
  {
    "codigo":788917000,
    "descripcion":"EROSIÓN DE HUESO"
  },
  {
    "codigo":35253001,
    "descripcion":"TRASTORNO DE HIPERACTIVIDAD CON DÉFICIT DE ATENCIÓN, CON PREDOMINIO DE DÉFICIT DE ATENCIÓN"
  },
  {
    "codigo":166325004,
    "descripcion":"NIVEL DE TRIYODOTIRONINA SÉRICA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":231861005,
    "descripcion":"CONJUNTIVITIS POR CLAMIDIA"
  },
  {
    "codigo":136801000119102,
    "descripcion":"ESTREÑIMIENTO INDUCIDO POR OPIOIDE ADMINISTRADO CON FINES TERAPÉUTICOS"
  },
  {
    "codigo":361098001,
    "descripcion":"REACCIÓN ALÉRGICA A LA TRANSFUSIÓN"
  },
  {
    "codigo":295562000,
    "descripcion":"SOBREDOSIS DE LIDOCAÍNA"
  },
  {
    "codigo":426634003,
    "descripcion":"CONVULSIÓN ECLÁMPTICA"
  },
  {
    "codigo":721546004,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE EPITELIO CILIAR"
  },
  {
    "codigo":66186006,
    "descripcion":"FORÚNCULO DEL ANO"
  },
  {
    "codigo":64351000,
    "descripcion":"INFESTACIÓN POR SANGUIJUELAS"
  },
  {
    "codigo":293727006,
    "descripcion":"ALERGIA A PROCAÍNA"
  },
  {
    "codigo":195423007,
    "descripcion":"FLEBITIS DE LA VENA ILÍACA EXTERNA"
  },
  {
    "codigo":15701601000119105,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE AMBOS TENDONES ROTULIANOS"
  },
  {
    "codigo":95284001,
    "descripcion":"ARCO SUPERNUMERARIO DE VÉRTEBRA SACRA"
  },
  {
    "codigo":29748005,
    "descripcion":"HIPERTROFIA DE GLÁNDULA PARÓTIDA"
  },
  {
    "codigo":717876006,
    "descripcion":"ENTERITIS FLEMONOSA DE DUODENO"
  },
  {
    "codigo":816180005,
    "descripcion":"EDEMA DE PIERNA DERECHA"
  },
  {
    "codigo":128052008,
    "descripcion":"ENFERMEDAD VASCULAR ABDOMINAL"
  },
  {
    "codigo":93449001,
    "descripcion":"GINGIVITIS ERUPTIVA"
  },
  {
    "codigo":421129002,
    "descripcion":"EDEMA CON FÓVEA 4+"
  },
  {
    "codigo":683771000119101,
    "descripcion":"EPENDIMOMA PRIMARIO DE LÓBULO FRONTAL"
  },
  {
    "codigo":191753006,
    "descripcion":"TRASTORNO DE LA PERSONALIDAD HIPOMANÍACA"
  },
  {
    "codigo":224521007,
    "descripcion":"MIEMBRO DE GRUPO DE AUTOAYUDA"
  },
  {
    "codigo":124382004,
    "descripcion":"DEFICIENCIA DE TRANSACILASA"
  },
  {
    "codigo":1172958005,
    "descripcion":"INFECCIÓN INTESTINAL CAUSADA POR CLOSTRIDIOIDES DIFFICILE"
  },
  {
    "codigo":91614005,
    "descripcion":"INFECCIÓN CAUSADA POR DRACUNCULUS INSIGNIS"
  },
  {
    "codigo":26078007,
    "descripcion":"HIPERTENSIÓN SECUNDARIA A NEFROPATÍA, QUE COMPLICA EL PARTO Y\/O CONSTITUYE UN MOTIVO DE ATENCIÓN DURANTE ESTE PROCEDIMIENTO"
  },
  {
    "codigo":286387000,
    "descripcion":"INCAPAZ DE INICIAR LA EMISIÓN DE PALABRAS"
  },
  {
    "codigo":1304030009,
    "descripcion":"GLAUCOMA DE ÁNGULO ABIERTO BILATERAL DEBIDO A TRAUMATISMO OCULAR"
  },
  {
    "codigo":1075081000119100,
    "descripcion":"JUANETE DE SASTRE DE PIE IZQUIERDO"
  },
  {
    "codigo":15669641000119101,
    "descripcion":"BRAQUIDACTILIA DE DEDO DE MANO IZQUIERDA"
  },
  {
    "codigo":10805641000119102,
    "descripcion":"ANOMALÍA CARDIOVASCULAR CONGÉNITA EN LA MADRE QUE COMPLICA EL NACIMIENTO"
  },
  {
    "codigo":15679881000119102,
    "descripcion":"CONJUNTIVITIS NEONATAL DE OJO DERECHO"
  },
  {
    "codigo":12198281000119104,
    "descripcion":"POSICIÓN ANÓMALA DE LENTE INTRAOCULAR IZQUIERDO"
  },
  {
    "codigo":15920521000119105,
    "descripcion":"REACCIÓN ALÉRGICA CAUSADA POR NUEZ"
  },
  {
    "codigo":11778441000119106,
    "descripcion":"DISTENSIÓN DE MÚSCULO Y\/O TENDÓN DE TRÍCEPS BRAQUIAL DERECHO"
  },
  {
    "codigo":368521000119107,
    "descripcion":"TRASTORNO DE NERVIO DEBIDO A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":11783561000119106,
    "descripcion":"AMPOLLA DE MANO DERECHA, CON INFECCIÓN"
  },
  {
    "codigo":350601000119109,
    "descripcion":"ENFERMEDAD HEMOLÍTICA DEL RECIÉN NACIDO CONCOMITANTE CON INMUNIZACIÓN ABO Y DEBIDA A ELLA"
  },
  {
    "codigo":11824521000119108,
    "descripcion":"LESIÓN TRAUMÁTICA DE VASO SANGUÍNEO DE BRAZO DERECHO"
  },
  {
    "codigo":15697801000119107,
    "descripcion":"ABSCESO DE BOLSA SEROSA DE AMBAS CADERAS"
  },
  {
    "codigo":16908681000119104,
    "descripcion":"PAPILOMA DE PIEL DE PÁRPADO INFERIOR DERECHO"
  },
  {
    "codigo":107401000119105,
    "descripcion":"DOLOR POSOPERATORIO AGUDO"
  },
  {
    "codigo":1082761000119106,
    "descripcion":"ESÓFAGO DE BARRETT CON DISPLASIA DE ALTO GRADO"
  },
  {
    "codigo":15664521000119109,
    "descripcion":"TUMOR TENOSINOVIAL DE CÉLULAS GIGANTES DIFUSO DE AMBAS ARTICULACIONES DE RODILLA"
  },
  {
    "codigo":16583561000119107,
    "descripcion":"QUISTE SINOVIAL DE TOBILLO DERECHO"
  },
  {
    "codigo":20573003,
    "descripcion":"PATRÓN RESPIRATORIO INEFECTIVO"
  },
  {
    "codigo":1234824005,
    "descripcion":"NEURORRETINOPATÍA MACULAR AGUDA"
  },
  {
    "codigo":194995005,
    "descripcion":"INSUFICIENCIA DE VÁLVULA PULMONAR, NO REUMÁTICA"
  },
  {
    "codigo":249949001,
    "descripcion":"SIN CONTRACCIÓN MUSCULAR ACTIVA"
  },
  {
    "codigo":446557009,
    "descripcion":"ESCALDADURA DE CARA"
  },
  {
    "codigo":315485007,
    "descripcion":"NACIDO EN NAMIBIA"
  },
  {
    "codigo":1296690006,
    "descripcion":"HIPERTENSIÓN OCULAR DE OJO IZQUIERDO DEBIDA A AFAQUIA"
  },
  {
    "codigo":311815001,
    "descripcion":"FRACTURAS MÚLTIPLES EXPUESTAS DE LA COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":770567006,
    "descripcion":"SÍNDROME PROGEROIDE TIPO PETTY"
  },
  {
    "codigo":279047007,
    "descripcion":"DOLOR PERSISTENTE LUEGO DE PROCEDIMIENTO"
  },
  {
    "codigo":47836003,
    "descripcion":"INTOXICACIÓN POR MORFINA"
  },
  {
    "codigo":277212004,
    "descripcion":"CICATRIZ ENDAURAL"
  },
  {
    "codigo":1293020005,
    "descripcion":"HISTIOCITOMA FIBROSO ANGIOMATOIDE"
  },
  {
    "codigo":80604007,
    "descripcion":"BARTOLINITIS GONOCÓCICA AGUDA"
  },
  {
    "codigo":703196008,
    "descripcion":"ESTENOSIS DE VÁLVULA TRICÚSPIDE POSTERIOR A PROCEDIMIENTO"
  },
  {
    "codigo":308145001,
    "descripcion":"FRACTURA PATOLÓGICA DE VÉRTEBRA CERVICAL"
  },
  {
    "codigo":78769001,
    "descripcion":"CORIORRETINITIS DISEMINADA"
  },
  {
    "codigo":1354886000,
    "descripcion":"RESIDENCIA INADECUADAMENTE IMPERMEABILIZADA"
  },
  {
    "codigo":240774002,
    "descripcion":"HIALOHIFOMICOSIS CUTÁNEA"
  },
  {
    "codigo":109702006,
    "descripcion":"EXOSTOSIS LABIAL"
  },
  {
    "codigo":208006009,
    "descripcion":"FRACTURA VERTEBRAL NO EXPUESTA CON LESIÓN COMPLETA DE MÉDULA ESPINAL CERVICAL, C5-7"
  },
  {
    "codigo":402779001,
    "descripcion":"MELANOSIS RETICULADA HEREDITARIA"
  },
  {
    "codigo":10625071000119104,
    "descripcion":"BRONCONEUMONÍA CAUSADA POR BACTERIAS"
  },
  {
    "codigo":1254747006,
    "descripcion":"METÁSTASIS DE CARCINOMA DE CÉLULAS GIGANTES EN AMBOS PULMONES"
  },
  {
    "codigo":238939008,
    "descripcion":"PÉNFIGO LOCALIZADO"
  },
  {
    "codigo":9563009,
    "descripcion":"ENDOMETRIOSIS DEL RECTO"
  },
  {
    "codigo":400944001,
    "descripcion":"PARÁLISIS BILATERAL DE CUARTO NERVIO CRANEAL"
  },
  {
    "codigo":237104007,
    "descripcion":"VULVITIS POR TRICOMONAS"
  },
  {
    "codigo":366341001,
    "descripcion":"HALLAZGO RELACIONADO CON LA POSICIÓN DE LAS ESPINAS CIÁTICAS"
  },
  {
    "codigo":169733004,
    "descripcion":"TAMAÑO FETAL NO CONCUERDA CON LA EDAD GESTACIONAL"
  },
  {
    "codigo":300805009,
    "descripcion":"INCAPAZ DE DEDICARSE A ACTIVIDADES RELIGIOSAS"
  },
  {
    "codigo":36826002,
    "descripcion":"TROMBOSIS DE LA VESÍCULA SEMINAL"
  },
  {
    "codigo":430042004,
    "descripcion":"NEUROPATÍA PANAUTONÓMICA AGUDA"
  },
  {
    "codigo":724954006,
    "descripcion":"LESIÓN TRAUMÁTICA DE FASCIA DE MÚSCULO FLEXOR DE DEDO DE LA MANO A LA ALTURA DEL ANTEBRAZO"
  },
  {
    "codigo":200666007,
    "descripcion":"CELULITIS Y ABSCESO DE HOMBRO"
  },
  {
    "codigo":1149103000,
    "descripcion":"CITRULINEMIA TIPO I"
  },
  {
    "codigo":297135003,
    "descripcion":"ÉMBOLO DE ARTERIA SUBCLAVIA"
  },
  {
    "codigo":67759008,
    "descripcion":"INMOVILIDAD MUSCULOESQUELÉTICO"
  },
  {
    "codigo":723119009,
    "descripcion":"TEMOR A ENFERMEDAD DEL OÍDO"
  },
  {
    "codigo":721284006,
    "descripcion":"ACIDOSIS DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":295300007,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE TENOXICAM"
  },
  {
    "codigo":262532009,
    "descripcion":"PATRÓN DE CONTUSIÓN"
  },
  {
    "codigo":293465003,
    "descripcion":"REACCIÓN ADVERSA AL ÁCIDO ETACRÍNICO"
  },
  {
    "codigo":424537004,
    "descripcion":"CONOCIMIENTO DEFICIENTE DE LAS PRÁCTICAS ANTICONCEPTIVAS"
  },
  {
    "codigo":1145433005,
    "descripcion":"HIPOPLASIA CONGÉNITA DE COLUMNA VERTEBRAL"
  },
  {
    "codigo":129625005,
    "descripcion":"ESCOTOMA ANULAR"
  },
  {
    "codigo":719449007,
    "descripcion":"DEFICIENCIA DE DIMETILGLICINA DESHIDROGENASA"
  },
  {
    "codigo":16906441000119108,
    "descripcion":"QUISTE DERMOIDE DE PÁRPADO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":193326001,
    "descripcion":"DESPRENDIMIENTO TOTAL DE RETINA, ANTIGUO"
  },
  {
    "codigo":783150002,
    "descripcion":"TRASTORNO LINFOPROLIFERATIVO ASOCIADO CON INMUNODEFICIENCIA IATROGÉNICA"
  },
  {
    "codigo":226094003,
    "descripcion":"DIETA CON BAJO CONTENIDO DE TIROSINA"
  },
  {
    "codigo":95022007,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL TABIQUE RECTOVAGINAL"
  },
  {
    "codigo":289795000,
    "descripcion":"OCLUSIÓN DEL ORIFICIO CERVICAL"
  },
  {
    "codigo":1340206009,
    "descripcion":"SÍNDROME COMPARTIMENTAL TIBIAL ANTERIOR DEBIDO A LESIÓN TRAUMÁTICA"
  },
  {
    "codigo":224259003,
    "descripcion":"HOGAR INUNDABLE"
  },
  {
    "codigo":124120002,
    "descripcion":"DEFICIENCIA DE MEVALDATO REDUCTASA"
  },
  {
    "codigo":91352004,
    "descripcion":"INSULINOPATÍA"
  },
  {
    "codigo":255192005,
    "descripcion":"HISTIOCITOSIS CEFÁLICA BENIGNA"
  },
  {
    "codigo":25816005,
    "descripcion":"COMPRESIÓN DEL TRONCO ENCEFÁLICO"
  },
  {
    "codigo":1172696009,
    "descripcion":"SÍNDROME DE RETRASO GLOBAL DEL DESARROLLO, ANOMALÍAS VISUALES, ATROFIA CEREBELOSA PROGRESIVA, HIPOTONÍA TRONCAL"
  },
  {
    "codigo":332131000119107,
    "descripcion":"DEFECTO DE SECTOR DE CAMPO VISUAL DE OJO DERECHO"
  },
  {
    "codigo":187821001,
    "descripcion":"ANGIOSARCOMA DE BAZO"
  },
  {
    "codigo":286125003,
    "descripcion":"LIMPIA LAS VENTANAS"
  },
  {
    "codigo":253357008,
    "descripcion":"APÉNDICE AURICULAR IZQUIERDO - DERECHO - YUXTAPOSICIÓN"
  },
  {
    "codigo":54914001,
    "descripcion":"PELVIS ESCOLIÓTICA"
  },
  {
    "codigo":251522002,
    "descripcion":"SIGNOS ELECTROMIOGRÁFICOS DE AMPLITUD AUMENTADA EN EL PATRÓN DE INTERFERENCIA"
  },
  {
    "codigo":87682005,
    "descripcion":"REORDENAMIENTO GENÉTICO, LINFOCITOS B"
  },
  {
    "codigo":284290006,
    "descripcion":"REALIZA LA PRENSIÓN CON PRONACIÓN DE MUÑECA"
  },
  {
    "codigo":315223000,
    "descripcion":"PROGRESIÓN DE ESPERMATOZOIDES RÁPIDA"
  },
  {
    "codigo":282455004,
    "descripcion":"HEMATOMA DE FARINGE"
  },
  {
    "codigo":249687007,
    "descripcion":"CLAVÍCULA LARGA"
  },
  {
    "codigo":118615008,
    "descripcion":"TUMOR MALIGNO DE CÉLULAS MASTOCITARIAS (CLÍNICO)"
  },
  {
    "codigo":1263660002,
    "descripcion":"METÁSTASIS DE CARCINOMA DE CÉLULAS TRANSICIONALES EN VÍA URINARIA SUPERIOR"
  },
  {
    "codigo":247852003,
    "descripcion":"MIEDO A LAS CABINAS DE TELÉFONOS PÚBLICOS"
  },
  {
    "codigo":772140004,
    "descripcion":"HERNIA FEMORAL DERECHA OBSTRUIDA"
  },
  {
    "codigo":51244008,
    "descripcion":"TRASTORNO ESPLÉNICO"
  },
  {
    "codigo":180481005,
    "descripcion":"TRASTORNO ANTI-FACTOR II"
  },
  {
    "codigo":1163521007,
    "descripcion":"GASTRITIS POR ENTEROCOCCUS"
  },
  {
    "codigo":47574003,
    "descripcion":"CUELLO UTERINO INMADURO"
  },
  {
    "codigo":1259990004,
    "descripcion":"DEMENCIA DEBIDA A NEURODEGENERACIÓN ASOCIADA A PANTOTENATO CINASA CLÁSICA"
  },
  {
    "codigo":768470007,
    "descripcion":"ADENOMA PRODUCTOR DE ALDOSTERONA"
  },
  {
    "codigo":209579000,
    "descripcion":"DESGARRO COMPLETO DE ARTICULACIÓN DE CODO"
  },
  {
    "codigo":111275004,
    "descripcion":"ABSCESO DE TABIQUE NASAL"
  },
  {
    "codigo":16007831000119105,
    "descripcion":"TROMBOSIS DE AMBAS ARTERIAS CUBITALES"
  },
  {
    "codigo":371584001,
    "descripcion":"IRRITACIÓN DEL PENE"
  },
  {
    "codigo":109440005,
    "descripcion":"ANODONCIA FALSA"
  },
  {
    "codigo":43904005,
    "descripcion":"CIRROSIS MACRONODULAR"
  },
  {
    "codigo":369749000,
    "descripcion":"CONFIGURACIÓN TUMORAL EXOFÍTICA (POLIPOIDE)"
  },
  {
    "codigo":240512008,
    "descripcion":"FIEBRE CALCHAQUÍ"
  },
  {
    "codigo":238677004,
    "descripcion":"SARCOIDOSIS MACULOPAPULAR"
  },
  {
    "codigo":42069006,
    "descripcion":"TRANSFORMACIÓN MIXOIDE DE VÁLVULA MITRAL"
  },
  {
    "codigo":402517006,
    "descripcion":"CARCINOMA BASOCELULAR DE LA REGIÓN DORSAL SUPERIOR"
  },
  {
    "codigo":204074000,
    "descripcion":"ANOMALÍAS CEREBRALES MÚLTIPLES"
  },
  {
    "codigo":304213008,
    "descripcion":"FIEBRE BAJA"
  },
  {
    "codigo":1156181008,
    "descripcion":"SÍNDROME DE RESISTENCIA AL ACTH"
  },
  {
    "codigo":334641000119103,
    "descripcion":"CORIORRETINITIS FOCAL YUXTAPAPILAR DE OJO DERECHO"
  },
  {
    "codigo":1187114007,
    "descripcion":"SÍNDROME DE MICROGNATISMO, INFECCIONES RECURRENTES, TRASTORNOS DE CONDUCTA Y DISCAPACIDAD INTELECTUAL LEVE"
  },
  {
    "codigo":5631002,
    "descripcion":"MOTILIDAD GÁSTRICA ANORMAL"
  },
  {
    "codigo":366079002,
    "descripcion":"MOVIMIENTO OCULAR - HALLAZGO"
  },
  {
    "codigo":890367002,
    "descripcion":"METATARSO EN VALGO CONGÉNITO BILATERAL"
  },
  {
    "codigo":202239006,
    "descripcion":"SUBLUXACIÓN RECURRENTE DE ARTICULACIÓN CARPOMETACARPIANA"
  },
  {
    "codigo":169471006,
    "descripcion":"FRACASO DE PÍLDORAS CON PROGESTERONA"
  },
  {
    "codigo":397012002,
    "descripcion":"MASTOCITOSIS CUTÁNEA"
  },
  {
    "codigo":298708003,
    "descripcion":"TÓRAX AGRANDADO"
  },
  {
    "codigo":724692005,
    "descripcion":"TRASTORNO DEL ESTADO DE ÁNIMO CON SÍNTOMAS MIXTOS DEPRESIVOS Y MANÍACOS CAUSADO POR COCAÍNA"
  },
  {
    "codigo":36564007,
    "descripcion":"LEIOMIOMA PARASITARIO"
  },
  {
    "codigo":34729003,
    "descripcion":"INTOXICACIÓN POR ESPERMICIDA"
  },
  {
    "codigo":722857004,
    "descripcion":"IMPACTACIÓN DE INTESTINO GRUESO DEBIDA A CUERPO EXTRAÑO"
  },
  {
    "codigo":1148841003,
    "descripcion":"APOYO FAMILIAR ADECUADO"
  },
  {
    "codigo":721022000,
    "descripcion":"COMPLICACIÓN DE LA ANESTESIA DURANTE EL PUERPERIO"
  },
  {
    "codigo":427945008,
    "descripcion":"DISTONÍA SEGMENTARIA"
  },
  {
    "codigo":296873008,
    "descripcion":"SOBREDOSIS DE METFORMINA"
  },
  {
    "codigo":11311921000119109,
    "descripcion":"FRACTURA EXPUESTA DE SEGUNDA VÉRTEBRA LUMBAR"
  },
  {
    "codigo":308171000119103,
    "descripcion":"DEFORMIDAD EN FLEXIÓN DE DEDO DE LA MANO IZQUIERDA"
  },
  {
    "codigo":1343614005,
    "descripcion":"MISOFOBIA"
  },
  {
    "codigo":1145171005,
    "descripcion":"EFECTO TÓXICO DE SELENIO Y\/O COMPUESTOS DE SELENIO"
  },
  {
    "codigo":293203005,
    "descripcion":"REACCIÓN ADVERSA A LA METFORMINA"
  },
  {
    "codigo":719187008,
    "descripcion":"ATROFIA DE MÚSCULO DORSAL ANCHO"
  },
  {
    "codigo":1208872002,
    "descripcion":"INFARTO DE MIOCARDIO ANTERIOR SIN ELEVACIÓN CONSECUENTE ANTERIOR DE SEGMENTO ST"
  },
  {
    "codigo":225832006,
    "descripcion":"SE AUTORREPRESENTA LEGALMENTE"
  },
  {
    "codigo":193064009,
    "descripcion":"PÉRDIDA DE LÍQUIDO CEFALORRAQUÍDEO POR PUNCIÓN RAQUÍDEA"
  },
  {
    "codigo":92925001,
    "descripcion":"FORMA ANORMAL CONGÉNITA DEL PULMÓN"
  },
  {
    "codigo":191229004,
    "descripcion":"PICNOCITOSIS DEL LACTANTE"
  },
  {
    "codigo":387837005,
    "descripcion":"NEOPLASIA DE PARTES BLANDAS"
  },
  {
    "codigo":11776971000119108,
    "descripcion":"LACERACIÓN DE PORCIÓN LARGA DE MÚSCULO BÍCEPS BRAQUIAL IZQUIERDO"
  },
  {
    "codigo":289533008,
    "descripcion":"ELIMINACIÓN DE COÁGULOS PEQUEÑOS POR VÍA VAGINAL"
  },
  {
    "codigo":1172434001,
    "descripcion":"ÍNDICE DE ANDRÓGENOS LIBRES POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":25554004,
    "descripcion":"LACERACIÓN MAYOR DEL HÍGADO CON HERIDA ABIERTA HACIA CAVIDAD ABDOMINAL"
  },
  {
    "codigo":449703000,
    "descripcion":"HEMATOMA DE MIEMBRO INFERIOR"
  },
  {
    "codigo":285863002,
    "descripcion":"OPERA LAVAPLATOS"
  },
  {
    "codigo":118195008,
    "descripcion":"HALLAZGO EN LA CAPACIDAD DE TOLERANCIA AL ESTRÉS DE ADAPTACIÓN"
  },
  {
    "codigo":710012002,
    "descripcion":"INSERCIÓN MUSCULAR EN ESTADO EDÉNTULO CON BASE MUCOSA ADHERIDA ADECUADA"
  },
  {
    "codigo":185724004,
    "descripcion":"CONTROL DE HIPERTENSIÓN BORRADO"
  },
  {
    "codigo":251260005,
    "descripcion":"ELEVACIÓN DEL TU"
  },
  {
    "codigo":447868007,
    "descripcion":"MASA DE REGIÓN PREAURICULAR"
  },
  {
    "codigo":87420007,
    "descripcion":"ADHERENCIAS LOCALIZADAS Y\/O HEBRAS DE LA CONJUNTIVA"
  },
  {
    "codigo":282193002,
    "descripcion":"SUBE ESCALERAS"
  },
  {
    "codigo":314961003,
    "descripcion":"RECIDIVA LOCAL DE NEOPLASIA MALIGNA DE ESTÓMAGO"
  },
  {
    "codigo":216657005,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR LUSTRES"
  },
  {
    "codigo":52817008,
    "descripcion":"RUPTURA DE MEMBRANA SINOVIAL"
  },
  {
    "codigo":247590001,
    "descripcion":"MEMORIA A CORTO PLAZO, DENTRO DE LOS LÍMITES NORMALES"
  },
  {
    "codigo":50982003,
    "descripcion":"INFECCIÓN CAUSADA POR ASCARIS LUMBRICOIDES"
  },
  {
    "codigo":10849381000119109,
    "descripcion":"CUERPO EXTRAÑO ASPIRADO EN LARINGE"
  },
  {
    "codigo":337151000119103,
    "descripcion":"LAGOFTALMÍA PARALÍTICA DE PÁRPADO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":442363001,
    "descripcion":"TROMBOFILIA CAUSADA POR DISPOSITIVO VASCULAR"
  },
  {
    "codigo":278523002,
    "descripcion":"LEUCONIQUIA ESTRIADA HEREDITARIA"
  },
  {
    "codigo":1163259003,
    "descripcion":"DEXTROCARDIA NO SINDRÓMICA"
  },
  {
    "codigo":15983871000119106,
    "descripcion":"MÚSCULO OCULAR SUPERNUMERARIO DE OJO IZQUIERDO"
  },
  {
    "codigo":1259728006,
    "descripcion":"NEOPLASIA FILOIDES PRIMARIA MALIGNA DE MAMA"
  },
  {
    "codigo":276688007,
    "descripcion":"DACRIOCISTITIS NEONATAL CAUSADA POR ESCHERICHIA COLI"
  },
  {
    "codigo":47312008,
    "descripcion":"HIDROPESÍA VESICULAR"
  },
  {
    "codigo":735440005,
    "descripcion":"EOSINOPENIA ADQUIRIDA"
  },
  {
    "codigo":733605002,
    "descripcion":"SÍNDROME DE DISGENESIA GONADAL TIPO XY CON ANOMALÍAS ASOCIADAS"
  },
  {
    "codigo":242085004,
    "descripcion":"LESIÓN AL SUBIR O BAJAR DE TREN"
  },
  {
    "codigo":209317006,
    "descripcion":"FRACTURA-LUXACIÓN EXPUESTA DE MÚLTIPLES DÍGITOS"
  },
  {
    "codigo":830074003,
    "descripcion":"CÁLCULO DE COLESTEROL DE VESÍCULA BILIAR"
  },
  {
    "codigo":404090003,
    "descripcion":"INFILTRACIÓN TUMORAL DE LA CAVIDAD ORAL, POR TUMOR SUBYACENTE"
  },
  {
    "codigo":305786004,
    "descripcion":"ATENDIDO POR LOGOTERAPEUTA EXTRAHOSPITALARIO"
  },
  {
    "codigo":402255002,
    "descripcion":"DERMATITIS ALÉRGICA POR CONTACTO DE PIERNA"
  },
  {
    "codigo":271183003,
    "descripcion":"AMPOLLA TRAUMÁTICA DE LA RODILLA, INFECTADA"
  },
  {
    "codigo":205647005,
    "descripcion":"TRISOMÍA 6"
  },
  {
    "codigo":1155919006,
    "descripcion":"FIEBRE REUMÁTICA AGUDA CON AORTITIS"
  },
  {
    "codigo":369487007,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA VESÍCULA SEMINAL"
  },
  {
    "codigo":238415008,
    "descripcion":"BOTRIOMICOSIS CUTÁNEA"
  },
  {
    "codigo":236580000,
    "descripcion":"RECHAZO DE TRASPLANTE RENAL, CRÓNICO - GRADO II"
  },
  {
    "codigo":11779481000119105,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE REGIÓN DE CODO DERECHO"
  },
  {
    "codigo":105508004,
    "descripcion":"ARRESTO POLICIAL"
  },
  {
    "codigo":1186852004,
    "descripcion":"HIPERTENSIÓN INTRACRANEAL BENIGNA DEBIDA A OBESIDAD"
  },
  {
    "codigo":7204006,
    "descripcion":"OCLUSIÓN DEL CUELLO UTERINO"
  },
  {
    "codigo":302116007,
    "descripcion":"HALLAZGO RELACIONADO CON UN DISPOSITIVO CARDIOVASCULAR"
  },
  {
    "codigo":890105003,
    "descripcion":"ATRESIA DE YEYUNO TIPO IIIA"
  },
  {
    "codigo":201977006,
    "descripcion":"ARTRITIS CLIMATÉRICA DE REGIÓN DE HOMBRO"
  },
  {
    "codigo":300281007,
    "descripcion":"PROBLEMA EN LA FARINGE"
  },
  {
    "codigo":267513007,
    "descripcion":"ANEMIAS POR DEFICIENCIA"
  },
  {
    "codigo":200142000,
    "descripcion":"EXTRACCIÓN DE NALGAS - NACIDO"
  },
  {
    "codigo":11861401000119108,
    "descripcion":"SUBLUXACIÓN DE ARTICULACIÓN DE TOBILLO DERECHO"
  },
  {
    "codigo":10960281000119109,
    "descripcion":"LACERACIÓN DE ANTEBRAZO DERECHO"
  },
  {
    "codigo":298446009,
    "descripcion":"AMPLITUD DE FLEXIÓN LATERAL PASIVA HACIA LA IZQUIERDA DE LA COLUMNA VERTEBRAL CERVICAL, AUMENTADA"
  },
  {
    "codigo":722595002,
    "descripcion":"SOBREPESO EN LA VIDA ADULTA CON ÍNDICE DE MASA CORPORAL DE 25 O MÁS PERO MENOR DE 30"
  },
  {
    "codigo":1279651002,
    "descripcion":"HERIDA PUNZANTE DE DEDO MEDIO DE MANO CON CUERPO EXTRAÑO"
  },
  {
    "codigo":296611001,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE ERITROMICINA"
  },
  {
    "codigo":165539005,
    "descripcion":"MONOCITOPENIA"
  },
  {
    "codigo":427683007,
    "descripcion":"ADHERENCIA DE TENDÓN DE LA MANO"
  },
  {
    "codigo":1343352004,
    "descripcion":"ACCESO DIGITAL INADECUADO"
  },
  {
    "codigo":294776007,
    "descripcion":"ALERGIA A TESTOSTERONA"
  },
  {
    "codigo":1144909003,
    "descripcion":"NEFRITIS TUBULOINTERSTICIAL CRÓNICA DEBIDA A ENFERMEDAD DE TEJIDO CONJUNTIVO"
  },
  {
    "codigo":292941003,
    "descripcion":"REACCIÓN ADVERSA AL HIPURATO DE HEXAMETILENAMINA"
  },
  {
    "codigo":63565007,
    "descripcion":"ANEMIA CONGÉNITA"
  },
  {
    "codigo":225570000,
    "descripcion":"CABELLO RIZADO"
  },
  {
    "codigo":94498001,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA PARED POSTERIOR DE LA NASOFARINGE"
  },
  {
    "codigo":291106003,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR DICLORALFENAZONA"
  },
  {
    "codigo":339661000119103,
    "descripcion":"BLEFARITIS ULCEROSA DE PÁRPADO INFERIOR IZQUIERDO"
  },
  {
    "codigo":127266006,
    "descripcion":"NEOPLASIA DE LOS GANGLIOS LINFÁTICOS TIBIALES"
  },
  {
    "codigo":289271001,
    "descripcion":"COÁGULO RETROPLACENTARIO ANTIGUO"
  },
  {
    "codigo":92663007,
    "descripcion":"CARCINOMA IN SITU DE LA CAVIDAD NASAL"
  },
  {
    "codigo":123596001,
    "descripcion":"TRASTORNO DE ENDOCARDIO"
  },
  {
    "codigo":254668006,
    "descripcion":"PAPILOMA BASOCELULAR IRRITADO"
  },
  {
    "codigo":285601000,
    "descripcion":"LESIÓN DE NERVIO OBTURADOR"
  },
  {
    "codigo":713420008,
    "descripcion":"TAQUICARDIA VENTRICULAR POLIMÓRFICA ELECTROCARDIOGRÁFICA"
  },
  {
    "codigo":90828009,
    "descripcion":"MIOCARDIOPATÍA RESTRICTIVA PRIMARIA"
  },
  {
    "codigo":416673002,
    "descripcion":"ARREGLO DENTAL PERDIDO"
  },
  {
    "codigo":88993007,
    "descripcion":"INTOXICACIÓN POR HALOPERIDOL"
  },
  {
    "codigo":283766000,
    "descripcion":"MORDEDURA DE PERRO EN EL INGLE"
  },
  {
    "codigo":1268641007,
    "descripcion":"CARCINOMA RENAL MUCINOSO DE CÉLULAS TUBULARES Y FUSIFORMES PRIMARIO"
  },
  {
    "codigo":449441008,
    "descripcion":"AURÍCULA IZQUIERDA DIVIDIDA CON DESEMBOCADURA DE TODAS LAS VENAS PULMONARES EN LA CÁMARA PROXIMAL SIN COMUNICACIÓN CON LA AURÍCULA IZQUIERDA CON COMUNICACIÓN DE LA CÁMARA VENOSA PULMONAR CON LA AURÍCULA DERECHA"
  },
  {
    "codigo":281931000,
    "descripcion":"FRACTURA EN LÁGRIMA DE VÉRTEBRA LUMBAR"
  },
  {
    "codigo":183627004,
    "descripcion":"SEGUIMIENTO EN 1 AÑO"
  },
  {
    "codigo":314699007,
    "descripcion":"TALLA DEL NIÑO: PERCENTILO 91"
  },
  {
    "codigo":609611008,
    "descripcion":"LESIÓN DE RAÍZ Y\/O PLEXO NERVIOSO"
  },
  {
    "codigo":247328001,
    "descripcion":"SENSIBLE AL TACTO"
  },
  {
    "codigo":67431000119105,
    "descripcion":"INSUFICIENCIA CARDÍACA CONGESTIVA ESTADIO D"
  },
  {
    "codigo":16041831000119105,
    "descripcion":"ARTRITIS IDIOPÁTICA JUVENIL DE AMBAS CADERAS"
  },
  {
    "codigo":443936004,
    "descripcion":"OLIGODENDROGLIOMA"
  },
  {
    "codigo":312864006,
    "descripcion":"RELIGIÓN NO REGISTRADA"
  },
  {
    "codigo":1197600008,
    "descripcion":"LUXACIÓN ANTERIOR CERRADA DE ARTICULACIÓN GLENOHUMERAL"
  },
  {
    "codigo":1162997003,
    "descripcion":"ACTIVIDAD DE INSECTOS POSTMORTEM"
  },
  {
    "codigo":442101005,
    "descripcion":"CLÍNICAMENTE APTO PARA INMUNIZACIÓN"
  },
  {
    "codigo":704245006,
    "descripcion":"FRACTURA PATOLÓGICA DE TIBIA EN SITIO DE NEOPLASIA"
  },
  {
    "codigo":210890003,
    "descripcion":"LESIÓN EXPUESTA, ARTERIA TIBIAL POSTERIOR"
  },
  {
    "codigo":276426004,
    "descripcion":"DEFICIENCIA DE ORNITINA AMINOTRANSFERASA"
  },
  {
    "codigo":473034005,
    "descripcion":"COMPLICACIÓN ASOCIADA CON CATÉTER DE DIÁLISIS"
  },
  {
    "codigo":1259466005,
    "descripcion":"CARCINOMA UROTELIAL PRIMARIO DE PELVIS RENAL DERECHA"
  },
  {
    "codigo":405663000,
    "descripcion":"ESTADO DE MANTENIMIENTO DEL EQUIPAMIENTO"
  },
  {
    "codigo":307359001,
    "descripcion":"AGENESIA DE NÚCLEOS DEL TRONCO ENCEFÁLICO"
  },
  {
    "codigo":241823005,
    "descripcion":"ENVENENAMIENTO DEBIDO A PICADURA DE ESPINA DE PEZ ARAÑA"
  },
  {
    "codigo":733343005,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE CAVIDAD BUCAL"
  },
  {
    "codigo":11837441000119105,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE PIERNA DERECHA"
  },
  {
    "codigo":239988001,
    "descripcion":"LESIÓN DE LA CÁPSULA ARTICULAR DE LA MUÑECA Y DE LA MANO"
  },
  {
    "codigo":371060002,
    "descripcion":"PÉRDIDA VISUAL LUEGO DE EXTRACCIÓN\/OPERACIÓN DE CATARATAS"
  },
  {
    "codigo":305524001,
    "descripcion":"BAJO ATENCIÓN DE ESPECIALISTA EN SALUD PÚBLICA"
  },
  {
    "codigo":403828005,
    "descripcion":"DEFICIENCIA FAMILIAR DE LIPOPROTEINLIPASA CON FENOTIPO TIPO V"
  },
  {
    "codigo":1255796007,
    "descripcion":"LINFOMA DE BURKITT DE GANGLIOS LINFÁTICOS DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":41545003,
    "descripcion":"ENFERMEDAD DE WHIPPLE"
  },
  {
    "codigo":205385004,
    "descripcion":"ANILLO DE CONSTRICCIÓN DE LA EXTREMIDAD INFERIOR CON LINFEDEMA"
  },
  {
    "codigo":860745005,
    "descripcion":"GRUPO DE GRADO 4 DE GLEASON"
  },
  {
    "codigo":400158000,
    "descripcion":"LINFEDEMA PRIMARIO DE TIPO TARDÍO"
  },
  {
    "codigo":238153009,
    "descripcion":"EMACIACIÓN TISULAR POR ENFERMEDAD SISTÉMICA SEVERA"
  },
  {
    "codigo":762441009,
    "descripcion":"CUADRANTOPSIA HETERÓNIMA BITEMPORAL"
  },
  {
    "codigo":301854006,
    "descripcion":"HOYUELO CUTÁNEO"
  },
  {
    "codigo":39710007,
    "descripcion":"ARTROPATÍA ASOCIADA CON UN TRASTORNO ENDOCRINO Y\/O METABÓLICO"
  },
  {
    "codigo":365555001,
    "descripcion":"HALLAZGO RELACIONADO CON LA FRECUENCIA DE PAGO DE INGRESOS"
  },
  {
    "codigo":367390009,
    "descripcion":"HIPERTENSIÓN EN EL CONTEXTO OBSTÉTRICO"
  },
  {
    "codigo":168947002,
    "descripcion":"ARTERIOGRAFÍA RENAL NORMAL"
  },
  {
    "codigo":234483004,
    "descripcion":"TROMBOCITOPENIA MEGACARIOCÍTICA"
  },
  {
    "codigo":398323005,
    "descripcion":"PREMEDICACIÓN INADECUADA PARA PROCEDIMIENTO ANESTÉSICO"
  },
  {
    "codigo":1119219007,
    "descripcion":"LESIÓN NO TRAUMÁTICA"
  },
  {
    "codigo":789704001,
    "descripcion":"ARTERIOSCLEROSIS DE ARTERIA DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":3272007,
    "descripcion":"ESTOMATOCITOSIS"
  },
  {
    "codigo":298184008,
    "descripcion":"HIPERMOVILIDAD DE ARTICULACIÓN TEMPOROMANDIBULAR"
  },
  {
    "codigo":66973001,
    "descripcion":"FRACTURA EXPUESTA DE TERCER HUESO CUNEIFORME DEL TARSO"
  },
  {
    "codigo":296349006,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE FENOXIBENZAMINA"
  },
  {
    "codigo":294514003,
    "descripcion":"ALERGIA A TEMOCILINA"
  },
  {
    "codigo":720498007,
    "descripcion":"SÍNDROME DE AFALANGIA Y SINDACTILIA CON MICROFEFALIA"
  },
  {
    "codigo":30535005,
    "descripcion":"INFECCIÓN CAUSADA POR CYSTOCAULUS"
  },
  {
    "codigo":292679006,
    "descripcion":"REACCIÓN ADVERSA AL ALOPURINOL"
  },
  {
    "codigo":816967008,
    "descripcion":"SUFRIMIENTO FETAL DEBIDO A INTENSIFICACIÓN DEL TRABAJO DE PARTO CON OXITOCINA"
  },
  {
    "codigo":127004000,
    "descripcion":"NEOPLASIA DE LA GLÁNDULA LAGRIMAL"
  },
  {
    "codigo":1208348002,
    "descripcion":"ENANISMO PRIMORDIAL MICROCEFÁLICO OSTEODISPLÁSICO TIPO II"
  },
  {
    "codigo":194375009,
    "descripcion":"DISFUNCIÓN LABERÍNTICA BILATERAL HIPOACTIVA"
  },
  {
    "codigo":94236003,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL CALCÁNEO"
  },
  {
    "codigo":389148008,
    "descripcion":"SEUDOPOLICITEMIA"
  },
  {
    "codigo":714993003,
    "descripcion":"CAPAZ DE NADAR"
  },
  {
    "codigo":92401003,
    "descripcion":"NEOPLASIA BENIGNA DE PARTES BLANDAS DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":289009007,
    "descripcion":"NO LLEVA ALIMENTO A LA BOCA"
  },
  {
    "codigo":26865008,
    "descripcion":"AUSENCIA CONGÉNITA DE LA VENA CAVA SUPERIOR"
  },
  {
    "codigo":254406001,
    "descripcion":"CARCINOMA IN SITU DE LOS DOS TERCIOS ANTERIORES DE LA LENGUA - CARA DORSAL"
  },
  {
    "codigo":385478001,
    "descripcion":"ADENOMA MALIGNO"
  },
  {
    "codigo":293939007,
    "descripcion":"ALERGIA A PERFENAZINA"
  },
  {
    "codigo":1335750006,
    "descripcion":"ENFERMEDAD DE PAGET DE PIE"
  },
  {
    "codigo":285339000,
    "descripcion":"ALVÉOLO DENTAL DOLOROSO"
  },
  {
    "codigo":1268379007,
    "descripcion":"ENFERMEDAD DE INJERTO CONTRA HUÉSPED DE INTESTINO"
  },
  {
    "codigo":414576002,
    "descripcion":"ONDA V GRANDE"
  },
  {
    "codigo":283504002,
    "descripcion":"HERIDA PUNZANTE DE REGIÓN AURICULAR"
  },
  {
    "codigo":21360006,
    "descripcion":"ABORTO ESPONTÁNEO CON AFIBRINOGENEMIA"
  },
  {
    "codigo":85061001,
    "descripcion":"TRASTORNO DE ANSIEDAD POR SEPARACIÓN EN LA NIÑEZ, DE INICIO TEMPRANO"
  },
  {
    "codigo":314437001,
    "descripcion":"RETINOPATÍA POR FLUJO LENTO"
  },
  {
    "codigo":248901003,
    "descripcion":"HALLAZGO RELACIONADO CON EL FONDO DE SACO VAGINAL"
  },
  {
    "codigo":609349003,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE PIERNA SIN INFECCIÓN"
  },
  {
    "codigo":10830441000119101,
    "descripcion":"FRACTURA EXPUESTA DE FALANGE DISTAL DE DEDO ANULAR DERECHO"
  },
  {
    "codigo":50458000,
    "descripcion":"LEUCONIQUIA ESTRIADA"
  },
  {
    "codigo":98921000119102,
    "descripcion":"DOLOR DEBIDO A ENFERMEDAD NEOPLÁSICA"
  },
  {
    "codigo":1197338004,
    "descripcion":"ADENOMA TUBULAR BENIGNO DE DUODENO"
  },
  {
    "codigo":15663721000119103,
    "descripcion":"HEMARTROSIS DE AMBOS TOBILLOS"
  },
  {
    "codigo":247066007,
    "descripcion":"REABSORCIÓN ESPONTÁNEA DE CATARATA"
  },
  {
    "codigo":472772002,
    "descripcion":"DILATACIÓN DE AURÍCULA DERECHA FETAL"
  },
  {
    "codigo":14020004,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DE MÚLTIPLES SITIOS DE BRAZO"
  },
  {
    "codigo":767684006,
    "descripcion":"HERNIA INGUINAL IZQUIERDA RECURRENTE OBSTRUIDA CON GANGRENA"
  },
  {
    "codigo":79556007,
    "descripcion":"DISTROFIA VITREORRETINIANA"
  },
  {
    "codigo":77721001,
    "descripcion":"INTOXICACIÓN CAUSADA POR OPIÁCEO"
  },
  {
    "codigo":344681000119107,
    "descripcion":"QUISTE DE RETINA DE AMBOS OJOS CAUSADO POR PARÁSITO"
  },
  {
    "codigo":350011000221104,
    "descripcion":"INFECCIÓN SUPERFICIAL CAUSADA POR LEVADURA DIFERENTE DE CANDIDA SPP. Y MALASSEZIA SPP"
  },
  {
    "codigo":895086000,
    "descripcion":"ENFERMEDAD POR VIRUS DE LA ESTOMATITIS VESICULAR"
  },
  {
    "codigo":403566002,
    "descripcion":"LIQUEN ESCLEROSO ANOGENITAL"
  },
  {
    "codigo":75886002,
    "descripcion":"OSTEOMIELITIS ESCLEROSANTE CRÓNICA NO SUPURATIVA"
  },
  {
    "codigo":700313008,
    "descripcion":"ARTROSIS PRIMARIA DE ARTICULACIÓN SUBASTRAGALINA"
  },
  {
    "codigo":307097008,
    "descripcion":"ADVERTIDO POR LA POLICÍA"
  },
  {
    "codigo":239726006,
    "descripcion":"DEFICIENCIA DEL LIGAMENTO CRUZADO POSTERIOR"
  },
  {
    "codigo":698478008,
    "descripcion":"MONOARTRITIS DE CODO"
  },
  {
    "codigo":205123002,
    "descripcion":"POLIDACTILIA RADIAL DE WASSEL 2"
  },
  {
    "codigo":41283003,
    "descripcion":"SÍNDROME CEREBRO-ÓCULO-FACIO-ESQUELÉTICO"
  },
  {
    "codigo":237891005,
    "descripcion":"ENFERMEDAD ÓSEA HIPOFOSFATÉMICA AUTOSÓMICA RECESIVA"
  },
  {
    "codigo":203288003,
    "descripcion":"OSTEOPATÍA COMO CONSECUENCIA DE POLIOMIELITIS, DEL ANTEBRAZO"
  },
  {
    "codigo":268824003,
    "descripcion":"FRACTURA DE RADIO Y\/O CÚBITO POR TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":301592004,
    "descripcion":"DIFICULTAD PARA MANEJARSE EN ESCALERAS"
  },
  {
    "codigo":1055256009,
    "descripcion":"AGENESIA DE EPÍFISIS DE FALANGE PROXIMAL DE DEDO MAYOR"
  },
  {
    "codigo":168685002,
    "descripcion":"RADIOGRAFÍA SIMPLE DE FÉMUR ANORMAL"
  },
  {
    "codigo":70381003,
    "descripcion":"LUXACIÓN EXPUESTA DEL EXTREMO DISTAL DEL CÚBITO"
  },
  {
    "codigo":234221002,
    "descripcion":"MARCAPASOS INFRASENSIBLE"
  },
  {
    "codigo":398061002,
    "descripcion":"ENTEROCELE VAGINAL"
  },
  {
    "codigo":365293007,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA ENCENDER LA INSTALACIÓN ELÉCTRICA PRINCIPAL"
  },
  {
    "codigo":299757008,
    "descripcion":"REFLEJO DE SUCCIÓN AUSENTE"
  },
  {
    "codigo":35778001,
    "descripcion":"ANEMIA MEGALOBLÁSTICA POR ERROR DEL METABOLISMO DEL FOLATO"
  },
  {
    "codigo":363458004,
    "descripcion":"NEOPLASIA MALIGNA DE URÉTER"
  },
  {
    "codigo":197783009,
    "descripcion":"PIELITIS ASOCIADA CON OTRO TRASTORNO"
  },
  {
    "codigo":296087009,
    "descripcion":"SOBREDOSIS DE CLORDIAZEPÓXIDO"
  },
  {
    "codigo":294252003,
    "descripcion":"ALERGIA A PROSTAGLANDINA, SERIE E"
  },
  {
    "codigo":64876005,
    "descripcion":"ENFERMEDAD INFECCIOSA POLIMICROBIANA"
  },
  {
    "codigo":95809000,
    "descripcion":"ECCEMA DEL LÓBULO DE LA OREJA"
  },
  {
    "codigo":127901000119107,
    "descripcion":"NEFROPATÍA DE CADENA LIVIANA DEBIDA A DISCRASIA DE CÉLULAS PLASMÁTICAS"
  },
  {
    "codigo":1144385004,
    "descripcion":"ATROFIA DE CAPA GRANULOSA INTERNA DE CORTEZA DE CEREBELO"
  },
  {
    "codigo":292417007,
    "descripcion":"REACCIÓN ADVERSA AL DISULFIRAM"
  },
  {
    "codigo":290582003,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR MITOBRONITOL"
  },
  {
    "codigo":28438004,
    "descripcion":"CONJUNTIVITIS NEONATAL GONOCÓCICA"
  },
  {
    "codigo":93974005,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA PRÓSTATA"
  },
  {
    "codigo":126742006,
    "descripcion":"NEOPLASIA DE VASO SANGUÍNEO DE HOMBRO"
  },
  {
    "codigo":225046007,
    "descripcion":"SALTO DESDE UN PUENTE"
  },
  {
    "codigo":92139000,
    "descripcion":"NEOPLASIA BENIGNA DE LA HIPOFARINGE"
  },
  {
    "codigo":1084471000119104,
    "descripcion":"COLESTEATOMA RECURRENTE DE AMBAS CAVIDADES MASTOIDEAS"
  },
  {
    "codigo":288747003,
    "descripcion":"NO SE HACE ENTENDER"
  },
  {
    "codigo":745664000,
    "descripcion":"REQUIERE SERVICIO DE INTÉRPRETE DE IDIOMAS POR TELÉFONO"
  },
  {
    "codigo":24768002,
    "descripcion":"FÍSTULA ARTERIAL"
  },
  {
    "codigo":254144002,
    "descripcion":"DISPLASIA OSTEOGLOFÓNICA"
  },
  {
    "codigo":57536002,
    "descripcion":"ENANISMO ASEXUAL LIGADO AL CROMOSOMA X"
  },
  {
    "codigo":15639761000119100,
    "descripcion":"PTOSIS DE CEJA DERECHA"
  },
  {
    "codigo":347191000119107,
    "descripcion":"LUXACIÓN ANTERIOR BILATERAL DE CRISTALINOS"
  },
  {
    "codigo":88469006,
    "descripcion":"SÍNDROME DE ZELLWEGER"
  },
  {
    "codigo":22933009,
    "descripcion":"ANEMIA VARIANTE G - 6 - PD CLASE I"
  },
  {
    "codigo":21098003,
    "descripcion":"ATROFIA ÓPTICA PRIMARIA"
  },
  {
    "codigo":53866004,
    "descripcion":"QUISTE EXUDATIVO EN EL IRIS"
  },
  {
    "codigo":445247000,
    "descripcion":"INFLAMACIÓN DE LA BOLSA SEROSA ROTULIANA"
  },
  {
    "codigo":1231679004,
    "descripcion":"OSCILACIONES PENDULARES DE VERGENCIA"
  },
  {
    "codigo":52031007,
    "descripcion":"EROSIÓN DENTAL POR VÓMITOS PERSISTENTES"
  },
  {
    "codigo":19263008,
    "descripcion":"GLOSOCELE"
  },
  {
    "codigo":15721681000119105,
    "descripcion":"CONTRACTURA DE ARTICULACIONES DE AMBOS TOBILLOS"
  },
  {
    "codigo":707391009,
    "descripcion":"CARCINOMA PAPILAR PRIMARIO DE CÉLULAS ESCAMOSAS DE TRÁQUEA"
  },
  {
    "codigo":115732001,
    "descripcion":"GRUPO SANGUÍNEO O>H<BOMBAY TIPO INDIO"
  },
  {
    "codigo":50196008,
    "descripcion":"FIBROSIS PULMONAR PERIALVEOLAR"
  },
  {
    "codigo":212201005,
    "descripcion":"LESIÓN DE LA RAÍZ DEL NERVIO CERVICAL - C5"
  },
  {
    "codigo":310505005,
    "descripcion":"ESTADO HIPEROSMOLAR NO CETÓSICO DEBIDO A DIABETES MELLITUS"
  },
  {
    "codigo":10861931000119102,
    "descripcion":"HERIDA POR DISPARO DE ARMA DE FUEGO DE MUSLO IZQUIERDO"
  },
  {
    "codigo":13758004,
    "descripcion":"PARAFIMOSIS"
  },
  {
    "codigo":700051000,
    "descripcion":"SEPSIS EN SUJETO ASPLÉNICO"
  },
  {
    "codigo":210366009,
    "descripcion":"DISLOCACIÓN DE DIENTE"
  },
  {
    "codigo":208531004,
    "descripcion":"FRACTURA NO EXPUESTA DE FÉMUR PROXIMAL, SUBCAPITAL, GRADO IV DE GARDEN"
  },
  {
    "codigo":110227004,
    "descripcion":"ERITEMA POR QUEMADURA DE LA OROFARINGE"
  },
  {
    "codigo":863891006,
    "descripcion":"INFLAMACIÓN EN LUGAR DE APLICACIÓN"
  },
  {
    "codigo":41161000087103,
    "descripcion":"CELULITIS DE TERCER DEDO DE PIE DERECHO"
  },
  {
    "codigo":370536000,
    "descripcion":"SÍNDROME BI"
  },
  {
    "codigo":25801000087105,
    "descripcion":"VIVE CON TUTOR"
  },
  {
    "codigo":43721000087106,
    "descripcion":"TRASTORNO DE TENDÓN DE PIE IZQUIERDO"
  },
  {
    "codigo":403304003,
    "descripcion":"LEUCONIQUIA ESTRIADA ADQUIRIDA"
  },
  {
    "codigo":1156968002,
    "descripcion":"RADICULOPATÍA DEBIDA A ESPONDILOSIS CERVICAL DE DOS NIVELES"
  },
  {
    "codigo":1255272003,
    "descripcion":"FRACTURA NO EXPUESTA DE FALANGE DISTAL DE MÚLTIPLES DEDOS DE MANO"
  },
  {
    "codigo":46281000087107,
    "descripcion":"FRACTURA DE EXTREMO PROXIMAL DE RADIO IZQUIERDO"
  },
  {
    "codigo":763752007,
    "descripcion":"VÉRTICE DENTAL INMADURO"
  },
  {
    "codigo":73789003,
    "descripcion":"DIETA PARA LA REALIZACIÓN DE UN ANÁLISIS ESPECIAL"
  },
  {
    "codigo":41021005,
    "descripcion":"DISPAREUNIA PSICOLÓGICA"
  },
  {
    "codigo":297637381000119102,
    "descripcion":"CREPITACIÓN DE ARTICULACIÓN DE TOBILLO DERECHO"
  },
  {
    "codigo":170258001,
    "descripcion":"EXAMEN DEL NIÑO AL AÑO: NORMAL"
  },
  {
    "codigo":203026005,
    "descripcion":"ABSCESO DE MÚSCULO DE PELVIS"
  },
  {
    "codigo":268562005,
    "descripcion":"INCAPAZ PARA MANEJAR"
  },
  {
    "codigo":235794006,
    "descripcion":"FÍSTULA EXTRAESFINTÉRICA"
  },
  {
    "codigo":365031000,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA LLEVAR A CABO LAS ACTIVIDADES DE LA VIDA DIARIA"
  },
  {
    "codigo":301330009,
    "descripcion":"MEDIDAS DE TALLA Y CRECIMIENTO CORPORAL - HALLAZGO"
  },
  {
    "codigo":792850008,
    "descripcion":"ÚLCERA DE TOBILLO DEBIDA A ATEROSCLEROSIS DE ARTERIA DE MIEMBRO INFERIOR"
  },
  {
    "codigo":168423000,
    "descripcion":"EXTENDIDO CERVICAL: GARDNERELLA"
  },
  {
    "codigo":299495004,
    "descripcion":"AMPLITUD DE PRONACIÓN MEDIOTARSIANA PASIVA DISMINUIDA"
  },
  {
    "codigo":102887005,
    "descripcion":"PRODUCCIÓN DE LÍQUIDO AMNIÓTICO DISMINUIDA"
  },
  {
    "codigo":201191004,
    "descripcion":"MILIARIA ALBA"
  },
  {
    "codigo":430567009,
    "descripcion":"EN CONDICIONES DE ALTA MÉDICA"
  },
  {
    "codigo":233959009,
    "descripcion":"ISQUEMIA DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":232124002,
    "descripcion":"NISTAGMO VOLUNTARIO"
  },
  {
    "codigo":723644002,
    "descripcion":"PARÁLISIS DE NERVIO CRANEAL DE CAUSA MICROVASCULAR"
  },
  {
    "codigo":68284008,
    "descripcion":"TALIPES EQUINOVALGO"
  },
  {
    "codigo":263057000,
    "descripcion":"SUBLUXACIÓN DE ARTICULACIÓN DE LA CADERA"
  },
  {
    "codigo":35516008,
    "descripcion":"HIPOVITAMINOSIS A CON XEROSIS CORNEAL"
  },
  {
    "codigo":721809007,
    "descripcion":"INFECCIÓN CAUSADA POR BLASTOCYSTIS"
  },
  {
    "codigo":230289009,
    "descripcion":"DÉFICIT COGNITIVO EN PARCHES"
  },
  {
    "codigo":719974003,
    "descripcion":"HEMOCROMATOSIS TIPO 3"
  },
  {
    "codigo":425062004,
    "descripcion":"DESPRENDIMIENTO DE EPITELIO PIGMENTARIO RETINIANO POR HERPES SIMPLE"
  },
  {
    "codigo":77471000119103,
    "descripcion":"MIASTENIA GRAVE SIN EXACERBACIÓN"
  },
  {
    "codigo":31846006,
    "descripcion":"RALES MEDIOS"
  },
  {
    "codigo":195686006,
    "descripcion":"LARINGITIS SUPURATIVA AGUDA"
  },
  {
    "codigo":293990008,
    "descripcion":"ALERGIA A FENTOLAMINA"
  },
  {
    "codigo":161083000,
    "descripcion":"AYUDA DE FAMILIARES"
  },
  {
    "codigo":95547004,
    "descripcion":"APENDICITIS SUPURATIVA PERFORADA"
  },
  {
    "codigo":292155005,
    "descripcion":"REACCIÓN ADVERSA A LA PROPANTELINA"
  },
  {
    "codigo":16051871000119105,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE TENDÓN DE AMBOS MÚSCULOS TRÍCEPS BRAQUIALES"
  },
  {
    "codigo":93712008,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE VASO SANGUÍNEO DEL TRONCO"
  },
  {
    "codigo":192016008,
    "descripcion":"TRASTORNO ALIMENTARIO NO ORGÁNICO EN LA LACTANCIA"
  },
  {
    "codigo":386789004,
    "descripcion":"RECUENTO DE EOSINÓFILOS POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":91877005,
    "descripcion":"AUSENCIA CONGÉNITA DE CENTRO DE VÉRTEBRA CERVICAL"
  },
  {
    "codigo":253882001,
    "descripcion":"ENFERMEDAD QUÍSTICA MEDULAR -NEFRONOPTISIS"
  },
  {
    "codigo":1204154001,
    "descripcion":"INFARTO AGUDO DE MIOCARDIO ANTERIOR SIN ELEVACIÓN DE SEGMENTO ST CON COMPROMISO VENTRICULAR DERECHO"
  },
  {
    "codigo":286650004,
    "descripcion":"NO CREE EN SU PROPIA CAPACIDAD"
  },
  {
    "codigo":219279007,
    "descripcion":"LESIÓN POR INTERVENCIÓN LEGAL CON BAYONETA"
  },
  {
    "codigo":1003876000,
    "descripcion":"DUPLICACIÓN DE PORCIÓN PROXIMAL DEL BRAZO LARGO DEL CROMOSOMA 12"
  },
  {
    "codigo":708964003,
    "descripcion":"GASTRITIS QUÍSTICA PROFUNDA"
  },
  {
    "codigo":41864002,
    "descripcion":"POLIENDOCRINOPATÍA AUTOINMUNITARIA"
  },
  {
    "codigo":1264185000,
    "descripcion":"TRASTORNO FETAL CAUSADO POR TRANSFERENCIA PLACENTARIA DE ANESTESIA MATERNA DURANTE EL TRABAJO DE PARTO"
  },
  {
    "codigo":282980008,
    "descripcion":"CAPAZ DE ARRODILLARSE"
  },
  {
    "codigo":679891000119101,
    "descripcion":"REACCIÓN PUPILAR TÓNICA DE OJO DERECHO"
  },
  {
    "codigo":707129008,
    "descripcion":"ENFERMEDAD GINGIVAL CAUSADA POR VIRUS"
  },
  {
    "codigo":1296953008,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE TENDÓN EXTENSOR DE MANO IZQUIERDA"
  },
  {
    "codigo":17166002,
    "descripcion":"AMPOLLA DE MANO, SIN INFECCIÓN"
  },
  {
    "codigo":15697721000119109,
    "descripcion":"PERIARTRITIS DE AMBAS MUÑECAS"
  },
  {
    "codigo":408547000,
    "descripcion":"HERIDA ABIERTA EN EL FLANCO"
  },
  {
    "codigo":277475006,
    "descripcion":"PÉNFIGO NEONATAL"
  },
  {
    "codigo":79032000,
    "descripcion":"MOVIMIENTO DIAFRAGMÁTICO PARADÓJICO"
  },
  {
    "codigo":210104002,
    "descripcion":"LESIONES MÚLTIPLES DE ÓRGANOS INTRATORÁCICOS"
  },
  {
    "codigo":111800004,
    "descripcion":"MANIFESTACIÓN DE CARBUNCO"
  },
  {
    "codigo":77197001,
    "descripcion":"SOPLO DE EYECCIÓN"
  },
  {
    "codigo":765325002,
    "descripcion":"NEUROPATÍA DESMIELINIZANTE PERIFÉRICA, LEUCODISTROFIA DISMIELINIZANTE CENTRAL, SÍNDROME DE WAARDENBURG, ENFERMEDAD DE HIRSCHSPRUNG"
  },
  {
    "codigo":372109003,
    "descripcion":"TRASTORNO DE ARTICULACIÓN DE LA COLUMNA VERTEBRAL"
  },
  {
    "codigo":15972461000119101,
    "descripcion":"TROMBOSIS DE ARTERIA ILÍACA IZQUIERDA"
  },
  {
    "codigo":711201000124109,
    "descripcion":"SINOVITIS CRÓNICA DE CADERA IZQUIERDA DEBIDA A HEMARTROSIS"
  },
  {
    "codigo":42594001,
    "descripcion":"TRASTORNO ORGÁNICO DEL ESTADO DE ÁNIMO DE TIPO DEPRESIVO"
  },
  {
    "codigo":206434001,
    "descripcion":"ANEMIA TARDÍA DEL RECIÉN NACIDO POR ISOINMUNIZACIÓN"
  },
  {
    "codigo":271970003,
    "descripcion":"ALTERACIÓN DE LOS ELECTRODOS IMPLANTADOS EN EL CEREBRO"
  },
  {
    "codigo":403042001,
    "descripcion":"TIÑA CORPORAL CAUSADA POR TRICHOPHYTON TONSURANS VARIANTE TONSURANS"
  },
  {
    "codigo":9826008,
    "descripcion":"CONJUNTIVITIS"
  },
  {
    "codigo":239202008,
    "descripcion":"FENÓMENO DE NO REFLUJO DEL COLGAJO"
  },
  {
    "codigo":1187639002,
    "descripcion":"EPITELIOPATÍA PIGMENTARIA RETINIANA ARRUGADA DE MARTINICA"
  },
  {
    "codigo":401207004,
    "descripcion":"EFECTOS ADVERSOS DE LA MEDICACIÓN PRESENTES"
  },
  {
    "codigo":71692003,
    "descripcion":"REACCIÓN LEUCOERITROBLÁSTICA"
  },
  {
    "codigo":366604005,
    "descripcion":"HALLAZGO RELACIONADO CON LA PRUEBA DE LACHMAN"
  },
  {
    "codigo":38924009,
    "descripcion":"RASGO DE PERSONALIDAD HISTÉRICA"
  },
  {
    "codigo":102625002,
    "descripcion":"MOTILIDAD DE INTESTINO GRUESO AUMENTADA"
  },
  {
    "codigo":16027911000119101,
    "descripcion":"EXOSTOSIS DE MANO DERECHA"
  },
  {
    "codigo":233697006,
    "descripcion":"NEUMONITIS POR HIPERSENSIBILIDAD DE NUEVA GUINEA"
  },
  {
    "codigo":299233007,
    "descripcion":"DEFORMIDAD DE ARTICULACIÓN DE CADERA"
  },
  {
    "codigo":428470000,
    "descripcion":"PÉRDIDA DE LA AUDICIÓN NEUROSENSORIAL, AUTOINMUNITARIA"
  },
  {
    "codigo":364769008,
    "descripcion":"MÉTODO DE ALIMENTACIÓN DEL LACTANTE - HALLAZGO"
  },
  {
    "codigo":231862003,
    "descripcion":"CONJUNTIVITIS POR HONGOS"
  },
  {
    "codigo":166326003,
    "descripcion":"NIVEL DE T3 SÉRICO POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":788918005,
    "descripcion":"LLANTO EXCESIVO EN LACTANTE"
  },
  {
    "codigo":33419001,
    "descripcion":"ESTADIO LX"
  },
  {
    "codigo":66187002,
    "descripcion":"ESTEATORREA"
  },
  {
    "codigo":651003,
    "descripcion":"RITUALES MÁGICOS"
  },
  {
    "codigo":197259002,
    "descripcion":"SÍNDROME DEL ÁNGULO HEPÁTICO DEL COLON"
  },
  {
    "codigo":295563005,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE LIDOCAÍNA"
  },
  {
    "codigo":262795007,
    "descripcion":"DESGARRO DE CÁPSULA DE HÍGADO"
  },
  {
    "codigo":721547008,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE EPITELIO DEL IRIS"
  },
  {
    "codigo":293728001,
    "descripcion":"ALERGIA A PROXIMETACAÍNA"
  },
  {
    "codigo":129888007,
    "descripcion":"TRASTORNO DEL ESTADO ESPIRITUAL"
  },
  {
    "codigo":95285000,
    "descripcion":"ARCO SUPERNUMERARIO DE LA VÉRTEBRA DORSAL"
  },
  {
    "codigo":717877002,
    "descripcion":"DUODENITIS GRANULOMATOSA"
  },
  {
    "codigo":29749002,
    "descripcion":"FRACTURA NO EXPUESTA DE OMÓPLATO"
  },
  {
    "codigo":291893004,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR FIBRINÓGENO HUMANO"
  },
  {
    "codigo":128053003,
    "descripcion":"TROMBOSIS VENOSA PROFUNDA"
  },
  {
    "codigo":160821006,
    "descripcion":"FALSIFICACIÓN O ALTERACIÓN DE PRESCRIPCIÓN"
  },
  {
    "codigo":422965008,
    "descripcion":"MOVIMIENTO COMPENSADO EN EL LUGAR DOLOROSO"
  },
  {
    "codigo":783413008,
    "descripcion":"ANEURISMAS MÚLTIPLES DE ARTERIA CEREBRAL"
  },
  {
    "codigo":816181009,
    "descripcion":"EDEMA DE AMBOS MIEMBROS INFERIORES"
  },
  {
    "codigo":193589009,
    "descripcion":"CATARATA SENIL NUCLEAR"
  },
  {
    "codigo":299271000119109,
    "descripcion":"ARTRITIS REUMATOIDEA SERONEGATIVA DE ARTICULACIÓN DE CODO"
  },
  {
    "codigo":354721000119103,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE BRONQUIO PRINCIPAL IZQUIERDO"
  },
  {
    "codigo":290058000,
    "descripcion":"VENAS VISIBLES EN LA MAMA"
  },
  {
    "codigo":1172959002,
    "descripcion":"INFECCIÓN EXTRAINTESTINAL CAUSADA POR CLOSTRIDIOIDES DIFFICILE"
  },
  {
    "codigo":15673761000119104,
    "descripcion":"GRANULOMA POR CUERPO EXTRAÑO DE PARTES BLANDAS BILATERALES DE MUSLOS"
  },
  {
    "codigo":26079004,
    "descripcion":"TEMBLOR"
  },
  {
    "codigo":11823521000119105,
    "descripcion":"AMPOLLA TRAUMÁTICA DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":1304031008,
    "descripcion":"GLAUCOMA DE ÁNGULO CERRADO DE OJO IZQUIERDO POSOPERATORIO"
  },
  {
    "codigo":286388005,
    "descripcion":"INICIA LA EMISIÓN DE PALABRAS"
  },
  {
    "codigo":15919521000119106,
    "descripcion":"ANAFILAXIA CAUSADA POR ANESTÉSICO"
  },
  {
    "codigo":448393000,
    "descripcion":"ARTRITIS INFECCIOSA DE ARTICULACIÓN INTERFALÁNGICA DE DEDO DE PIE"
  },
  {
    "codigo":253620009,
    "descripcion":"ANOMALÍA DEL TRONCO DE LA PULMONAR"
  },
  {
    "codigo":251785000,
    "descripcion":"FIJACIÓN OCULAR FOVEAL"
  },
  {
    "codigo":682401000119108,
    "descripcion":"ANGIOSARCOMA PRIMARIO DE REGIÓN DE HOMBRO"
  },
  {
    "codigo":86110000,
    "descripcion":"RUMIACIÓN - PENSAMIENTOS"
  },
  {
    "codigo":249950001,
    "descripcion":"CONTRACCIÓN MUSCULAR VISIBLE SOLAMENTE"
  },
  {
    "codigo":446558004,
    "descripcion":"PERFORACIÓN DE ARTERIA FEMORAL"
  },
  {
    "codigo":571000119103,
    "descripcion":"CEFALEA DIARIA"
  },
  {
    "codigo":315486008,
    "descripcion":"NACIDO EN NAURU"
  },
  {
    "codigo":1003614009,
    "descripcion":"SOSPECHA DE GLAUCOMA DE ÁNGULO ABIERTO"
  },
  {
    "codigo":310371000119100,
    "descripcion":"OSTEOFITO DE CRESTA ILÍACA DERECHA"
  },
  {
    "codigo":679011000119100,
    "descripcion":"QUERATOPATÍA PSEUDOFÁQUICA AMPOLLAR DE OJO DERECHO"
  },
  {
    "codigo":87651000119100,
    "descripcion":"PARÁLISIS FACIAL GRADO VI DE HOUSE-BRACKMANN"
  },
  {
    "codigo":307811000119103,
    "descripcion":"FÍSTULA DE ARTICULACIÓN DE PIE IZQUIERDO"
  },
  {
    "codigo":72291000119104,
    "descripcion":"ARRITMIA CARDÍACA DURANTE EMBARAZO"
  },
  {
    "codigo":62051000119105,
    "descripcion":"LESIÓN ESCAMOSA INTRAEPITELIAL DE BAJO GRADO EN EXTENDIDO DE PAPANICOLAOU CERVICAL"
  },
  {
    "codigo":279048002,
    "descripcion":"SÍNDROME DE LA ARTERIA MAMARIA INTERNA"
  },
  {
    "codigo":1086051000119107,
    "descripcion":"MIOCARDIOPATÍA DEBIDA A DIFTERIA"
  },
  {
    "codigo":16064611000119107,
    "descripcion":"HAMARTOMA CONGÉNITO DE IRIS DE OJO IZQUIERDO"
  },
  {
    "codigo":12268131000119109,
    "descripcion":"SÍNDROME COMPARTIMENTAL TRAUMÁTICO DE MIEMBRO INFERIOR DERECHO"
  },
  {
    "codigo":154211000119108,
    "descripcion":"PANCREATITIS CRÓNICA DEBIDA A ALCOHOLISMO CRÓNICO"
  },
  {
    "codigo":870707008,
    "descripcion":"ANESTESIA EN AMBOS MIEMBROS INFERIORES"
  },
  {
    "codigo":212455011000119105,
    "descripcion":"HEMATOMA INTRACRANEAL SUBDURAL SUBAGUDO ESPONTÁNEO"
  },
  {
    "codigo":15629411000119106,
    "descripcion":"SUBEPENDIMOMA ENCEFÁLICO"
  },
  {
    "codigo":133731000119108,
    "descripcion":"DOLOR CRÓNICO EN PELVIS MASCULINA"
  },
  {
    "codigo":292451000119106,
    "descripcion":"INFLAMACIÓN DE NERVIO PERIFÉRICO DE PIE IZQUIERDO"
  },
  {
    "codigo":5731000119108,
    "descripcion":"OSTEODISTROFIA CONGÉNITA"
  },
  {
    "codigo":16740451000119109,
    "descripcion":"SÍNDROME DE HELLP (HEMOLYSIS-ELEVATED LIVER ENZYMES-LOW PLATELET) POSPARTO"
  },
  {
    "codigo":16904009,
    "descripcion":"AUSENCIA CONGÉNITA INCOMPLETA DE MUSLO Y PIERNA"
  },
  {
    "codigo":15069006,
    "descripcion":"SÍNDROME DE RUSSELL - SILVER"
  },
  {
    "codigo":439218000,
    "descripcion":"INJERTO ARTERIOVENOSO CONSTRUIDO QUIRÚRGICAMENTE"
  },
  {
    "codigo":703197004,
    "descripcion":"HEMANGIOMA CAPILAR CONGÉNITO"
  },
  {
    "codigo":208007000,
    "descripcion":"FRACTURA VERTEBRAL NO EXPUESTA CON LESIÓN ANTERIOR DE MÉDULA ESPINAL CERVICAL, C5-7"
  },
  {
    "codigo":240775001,
    "descripcion":"HIALOHIFOMICOSIS DISEMINADA"
  },
  {
    "codigo":11399002,
    "descripcion":"ENFERMEDAD HIPERTENSIVA DE ARTERIA PULMONAR"
  },
  {
    "codigo":109703001,
    "descripcion":"REBORDE ÓSEO ALVEOLAR"
  },
  {
    "codigo":1354887009,
    "descripcion":"REQUIERE MEDICACIÓN REFRIGERADA"
  },
  {
    "codigo":1254748001,
    "descripcion":"METÁSTASIS DE CARCINOMA ESCAMOSO DE CÉLULAS CLARAS EN PIEL"
  },
  {
    "codigo":402780003,
    "descripcion":"SÍNDROME GENÉTICO CON HIPERMELANOSIS"
  },
  {
    "codigo":271708004,
    "descripcion":"HALLAZGO RELACIONADO CON LA POTENCIA DEL MÚSCULO ESQUELÉTICO"
  },
  {
    "codigo":238940005,
    "descripcion":"PENFIGOIDE VEGETANTE"
  },
  {
    "codigo":75100008,
    "descripcion":"ABSCESO ABDOMINAL"
  },
  {
    "codigo":400945000,
    "descripcion":"PARÁLISIS CONGÉNITA DEL SEXTO PAR"
  },
  {
    "codigo":237105008,
    "descripcion":"AMEBIASIS VULVAR"
  },
  {
    "codigo":169734005,
    "descripcion":"RUPTURA DE MEMBRANAS FETALES ESPONTÁNEA"
  },
  {
    "codigo":268038006,
    "descripcion":"DEFORMIDAD ADQUIRIDA DEL OMÓPLATO"
  },
  {
    "codigo":16003951000119103,
    "descripcion":"OSTEOPATÍA DE HÚMERO DERECHO POSTERIOR A POLIOMIELITIS"
  },
  {
    "codigo":366342008,
    "descripcion":"HALLAZGO EN REFLEJO DE NERVIO CRANEAL"
  },
  {
    "codigo":300806005,
    "descripcion":"REALIZA ACTIVIDADES RELIGIOSAS"
  },
  {
    "codigo":38662009,
    "descripcion":"HEPATITIS VIRAL TIPO B CRÓNICA PERSISTENTE"
  },
  {
    "codigo":167899003,
    "descripcion":"LÍQUIDO SINOVIAL: CONTENIDO ANORMAL"
  },
  {
    "codigo":298971003,
    "descripcion":"AMPLITUD DE ABDUCCIÓN ACTIVA DE ARTICULACIÓN DE MUÑECA, NORMAL"
  },
  {
    "codigo":200667003,
    "descripcion":"CELULITIS Y ABSCESO DE LA AXILA"
  },
  {
    "codigo":69595007,
    "descripcion":"PERIOSTITIS SIFILÍTICA SECUNDARIA"
  },
  {
    "codigo":2224000,
    "descripcion":"INTOXICACIÓN POR SELENIO"
  },
  {
    "codigo":198832001,
    "descripcion":"DAÑO DE ÓRGANOS O TEJIDOS PÉLVICOS POSABORTO"
  },
  {
    "codigo":297136002,
    "descripcion":"ÉMBOLO DE ARTERIA AXILAR"
  },
  {
    "codigo":724955007,
    "descripcion":"LESIÓN TRAUMÁTICA DE TENDÓN FLEXOR DE DEDO DE LA MANO A LA ALTURA DEL ANTEBRAZO"
  },
  {
    "codigo":684911000119105,
    "descripcion":"GLIOBASTOMA PRIMARIO MULTIFORME DE LÓBULO FRONTAL"
  },
  {
    "codigo":10679151000119106,
    "descripcion":"TUMEFACCIÓN LOCALIZADA DE EXTREMIDAD SUPERIOR DERECHA"
  },
  {
    "codigo":723120003,
    "descripcion":"TEMOR A ENFERMEDAD HEMATOLÓGICA"
  },
  {
    "codigo":262533004,
    "descripcion":"CONTUSIÓN POR IMPACTO"
  },
  {
    "codigo":426373005,
    "descripcion":"ESCLEROSIS MÚLTIPLE REMITENTE RECIDIVANTE"
  },
  {
    "codigo":295301006,
    "descripcion":"SOBREDOSIS INTENCIONAL DE TENOXICAM"
  },
  {
    "codigo":721285007,
    "descripcion":"ARTRITIS GOTOSA PRIMARIA CRÓNICA"
  },
  {
    "codigo":11826031000119108,
    "descripcion":"LACERACIÓN DE TENDÓN DE LA MUÑECA IZQUIERDA"
  },
  {
    "codigo":293466002,
    "descripcion":"REACCIÓN ADVERSA A LA PIRETANIDA"
  },
  {
    "codigo":1145434004,
    "descripcion":"HIPOPLASIA CONGÉNITA DE EPÍFISIS PROXIMAL DE FÉMUR"
  },
  {
    "codigo":129626006,
    "descripcion":"ESCOTOMA CUADRÁNTICO"
  },
  {
    "codigo":719450007,
    "descripcion":"SÍNDROME DE TRASTORNO DEL DESARROLLO SEXUAL CON DISCAPACIDAD INTELECTUAL"
  },
  {
    "codigo":64090007,
    "descripcion":"QUEMADURA DEL PULGAR"
  },
  {
    "codigo":291631001,
    "descripcion":"INTOXICACIÓN POR CEFALOSPORINA DE CUARTA GENERACIÓN"
  },
  {
    "codigo":95023002,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL TABIQUE RECTOVESICAL"
  },
  {
    "codigo":783151003,
    "descripcion":"HIPERPLASIA DE PRÓSTATA POST-ATRÓFICA"
  },
  {
    "codigo":226095002,
    "descripcion":"DIETA CON BAJO CONTENIDO DE CISTEÍNA"
  },
  {
    "codigo":1340207000,
    "descripcion":"MIEDO A LAS ARAÑAS"
  },
  {
    "codigo":193327005,
    "descripcion":"DESPRENDIMIENTO SUBTOTAL DE RETINA, ANTIGUO"
  },
  {
    "codigo":191492000,
    "descripcion":"DELIRIO MEDICAMENTOSO"
  },
  {
    "codigo":420868002,
    "descripcion":"TRASTORNO DEBIDO A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":289796004,
    "descripcion":"EDEMA DEL CUELLO UTERINO"
  },
  {
    "codigo":93188005,
    "descripcion":"HISTIOCITOSIS MALIGNA DE GANGLIOS LINFÁTICOS DE LOCALIZACIONES MÚLTIPLES"
  },
  {
    "codigo":224260008,
    "descripcion":"PELIGROS DOMÉSTICOS"
  },
  {
    "codigo":1172697000,
    "descripcion":"DISMORFIA FACIAL RESTRINGIDA A MUJERES LIGADA AL CROMOSOMA X, TALLA BAJA, ATRESIA DE COANAS Y DISCAPACIDAD INTELECTUAL"
  },
  {
    "codigo":715780008,
    "descripcion":"LISENCEFALIA TIPO 1 DEBIDA A MUTACIÓN DEL GEN DE DOBLECORTINA"
  },
  {
    "codigo":25817001,
    "descripcion":"ADHERENCIAS PERITONEALES CON OBSTRUCCIÓN"
  },
  {
    "codigo":124121003,
    "descripcion":"DEFICIENCIA DE HIDROXIMETILGLUTARIL - COA REDUCTASA (NADPH)"
  },
  {
    "codigo":58585005,
    "descripcion":"DELIRIO AUTÓCTONO"
  },
  {
    "codigo":304291000119102,
    "descripcion":"GOTA CRÓNICA DE HOMBRO, SIN TOFO, DEBIDA A DISFUNCIÓN RENAL"
  },
  {
    "codigo":286126002,
    "descripcion":"NO LIMPIA LAS VENTANAS"
  },
  {
    "codigo":253358003,
    "descripcion":"ANEURISMA DEL APÉNDICE AURICULAR IZQUIERDO"
  },
  {
    "codigo":87683000,
    "descripcion":"SINISTRÓMANO"
  },
  {
    "codigo":187822008,
    "descripcion":"FIBROSARCOMA DE BAZO"
  },
  {
    "codigo":284291005,
    "descripcion":"NO REALIZA LA PRENSIÓN CON PRONACIÓN DE LA MUÑECA"
  },
  {
    "codigo":251523007,
    "descripcion":"SIGNOS ELECTROMIOGRÁFICOS DE AMPLITUD REDUCIDA EN EL PATRÓN DE INTERFERENCIA"
  },
  {
    "codigo":12100771000119105,
    "descripcion":"QUEMADURA DE REGIÓN INGUINAL"
  },
  {
    "codigo":448131008,
    "descripcion":"SIALADENITIS ESCLEROSANTE CRÓNICA"
  },
  {
    "codigo":249688002,
    "descripcion":"PROTRUSIÓN DE LA EXTREMIDAD INTERNA DE LA CLAVÍCULA"
  },
  {
    "codigo":282456003,
    "descripcion":"HEMATOMA DE TRÁQUEA"
  },
  {
    "codigo":85848002,
    "descripcion":"ABRASIÓN CORNEAL"
  },
  {
    "codigo":315224006,
    "descripcion":"EPISODIO DE SANGRADO VAGINAL INTENSO"
  },
  {
    "codigo":53080007,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":772141000,
    "descripcion":"HERNIA INGUINAL DERECHA RECURRENTE Y OBSTRUIDA"
  },
  {
    "codigo":118616009,
    "descripcion":"ENFERMEDAD NEOPLÁSICA DE COMPORTAMIENTO INCIERTO"
  },
  {
    "codigo":1263661003,
    "descripcion":"INTUBACIÓN ESOFÁGICA ACCIDENTAL"
  },
  {
    "codigo":1163522000,
    "descripcion":"GASTRITIS POR ENTEROVIRUS HUMANO"
  },
  {
    "codigo":247853008,
    "descripcion":"MIEDO A VOLAR"
  },
  {
    "codigo":82178003,
    "descripcion":"MIASTENIA GRAVE NEONATAL"
  },
  {
    "codigo":11855011000119109,
    "descripcion":"AMPOLLA TRAUMÁTICA DE MAMA IZQUIERDA"
  },
  {
    "codigo":768471006,
    "descripcion":"SÍNDROME DE MICRODELECIÓN 16P12.2"
  },
  {
    "codigo":244183009,
    "descripcion":"FLUOROSIS"
  },
  {
    "codigo":45740001,
    "descripcion":"SÍNDROME DIENCEFÁLICO DE LA INFANCIA"
  },
  {
    "codigo":209580002,
    "descripcion":"DESGARRO COMPLETO DE LIGAMENTO LATERAL EXTERNO DE ARTICULACIÓN DE CODO"
  },
  {
    "codigo":373420004,
    "descripcion":"SÍNDROME DE UPSHAW-SCHULMAN"
  },
  {
    "codigo":78508009,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DE LOS GENITALES EXTERNOS MASCULINOS"
  },
  {
    "codigo":1354625001,
    "descripcion":"FRACTURA DE TERCER HUESO METATARSIANO"
  },
  {
    "codigo":240513003,
    "descripcion":"FIEBRE DE ISFAHAN"
  },
  {
    "codigo":207745006,
    "descripcion":"FRACTURA EXPUESTA DE LA BASE DE CRÁNEO CON LESIÓN INTRACRANEAL, SIN PÉRDIDA DE CONSCIENCIA"
  },
  {
    "codigo":369750000,
    "descripcion":"CONFIGURACIÓN TUMORAL EXPANSIVA (NO INFILTRATIVA)"
  },
  {
    "codigo":402518001,
    "descripcion":"CARCINOMA BASOCELULAR DE LA REGIÓN LUMBAR"
  },
  {
    "codigo":238678009,
    "descripcion":"SARCOIDOSIS CUTÁNEA CRÓNICA"
  },
  {
    "codigo":1187115008,
    "descripcion":"SÍNDROME AUTOSÓMICO DOMINANTE DE POLIDACTILIA PREAXIAL E HIPERTRICOSIS DE DORSO SUPERIOR"
  },
  {
    "codigo":15979991000119105,
    "descripcion":"ALTERACIÓN DE LA ALINEACIÓN DE LA ARTICULACIÓN TEMPOROMANDIBULAR IZQUIERDA"
  },
  {
    "codigo":333271000119105,
    "descripcion":"ÚLCERA PERFORADA DE CÓRNEA DERECHA"
  },
  {
    "codigo":366080004,
    "descripcion":"MOVIMIENTO OCULAR CON AMBOS OJOS ABIERTOS - HALLAZGO"
  },
  {
    "codigo":890368007,
    "descripcion":"DISTROFIA MUSCULAR CONGÉNITA TIPO 1C DEBIDA A MUTACIÓN DEL GEN DE LA PROTEÍNA RELACIONADA A FUKUTINA"
  },
  {
    "codigo":724693000,
    "descripcion":"TRASTORNO OBSESIVO COMPULSIVO CAUSADO POR COCAÍNA"
  },
  {
    "codigo":300544009,
    "descripcion":"ESPERMATOZOIDES NORMALES"
  },
  {
    "codigo":202240008,
    "descripcion":"LUXACIÓN RECURRENTE DE ARTICULACIÓN METACARPOFALÁNGICA"
  },
  {
    "codigo":298709006,
    "descripcion":"TÓRAX PEQUEÑO"
  },
  {
    "codigo":3797007,
    "descripcion":"QUISTE PERIODONTAL"
  },
  {
    "codigo":397013007,
    "descripcion":"MASTOCITOMA CUTÁNEO SOLITARIO"
  },
  {
    "codigo":296874002,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE METFORMINA"
  },
  {
    "codigo":34730008,
    "descripcion":"INFECCIÓN POR ERITROPARVOVIRUS DE PRIMATE 1"
  },
  {
    "codigo":722858009,
    "descripcion":"VASCULITIS DE INTESTINO GRUESO"
  },
  {
    "codigo":196735001,
    "descripcion":"GASTRITIS SUPERFICIAL CRÓNICA"
  },
  {
    "codigo":1343615006,
    "descripcion":"GEFIROFOBIA"
  },
  {
    "codigo":32895009,
    "descripcion":"ENFERMEDAD HEREDITARIA"
  },
  {
    "codigo":127009,
    "descripcion":"ABORTO ESPONTÁNEO CON LACERACIÓN DE CUELLO UTERINO"
  },
  {
    "codigo":424276002,
    "descripcion":"GLIOMA MALIGNO DEL TRONCO ENCEFÁLICO"
  },
  {
    "codigo":293204004,
    "descripcion":"REACCIÓN ADVERSA A LA GOMA GUAR"
  },
  {
    "codigo":15707761000119106,
    "descripcion":"CATARATA CALCIFICADA DE AMBOS OJOS"
  },
  {
    "codigo":719188003,
    "descripcion":"ATROFIA DE MÚSCULO INTERÓSEO DE LA MANO"
  },
  {
    "codigo":225833001,
    "descripcion":"USA AMPARO LEGAL"
  },
  {
    "codigo":94761001,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE HUESO DE LA CARA"
  },
  {
    "codigo":422441003,
    "descripcion":"MADAROSIS DE LA CEJA"
  },
  {
    "codigo":142961000119108,
    "descripcion":"GASTROENTERITIS CAUSADA POR VIRUS INFLUENZA A SUBTIPO H1N1"
  },
  {
    "codigo":92926000,
    "descripcion":"FORMA ANORMAL CONGÉNITA DE MANDÍBULA"
  },
  {
    "codigo":1208873007,
    "descripcion":"INFARTO DE MIOCARDIO INFERIOR SIN ELEVACIÓN CONSECUENTE ANTERIOR DE SEGMENTO ST"
  },
  {
    "codigo":289534002,
    "descripcion":"ELIMINACIÓN DE COÁGULOS GRANDES POR VÍA VAGINAL"
  },
  {
    "codigo":10956401000119109,
    "descripcion":"HERIDA ABIERTA DE DEDO MEDIO DE MANO IZQUIERDA DEBIDA A MORDEDURA"
  },
  {
    "codigo":1172435000,
    "descripcion":"ÍNDICE DE ANDRÓGENOS LIBRES POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":25555003,
    "descripcion":"INTOXICACIÓN POR CLOROFORMO"
  },
  {
    "codigo":58323004,
    "descripcion":"INFECCIÓN CAUSADA POR TOXASCARIS LEONINA"
  },
  {
    "codigo":416936003,
    "descripcion":"CON MAYOR RIESGO DE MALTRATO FÍSICO"
  },
  {
    "codigo":56488003,
    "descripcion":"EFECTO TÓXICO DE OTRO SOLVENTE HIDROCARBURO CLORADO"
  },
  {
    "codigo":449704006,
    "descripcion":"HEMATOMA DE PIERNA"
  },
  {
    "codigo":253096008,
    "descripcion":"TUMOR NEUROECTODÉRMICO PERIFÉRICO"
  },
  {
    "codigo":285864008,
    "descripcion":"NO USA LAVAPLATOS"
  },
  {
    "codigo":1268904009,
    "descripcion":"HEMANGIOENDOTELIOMA EPITELIOIDE PRIMARIO"
  },
  {
    "codigo":447869004,
    "descripcion":"MASA DE CUERO CABELLUDO"
  },
  {
    "codigo":710013007,
    "descripcion":"INSERCIÓN MUSCULAR EN ESTADO EDÉNTULO CON BASE MUCOSA ADHERIDA ÚNICAMENTE EN REGIÓN LINGUAL POSTERIOR"
  },
  {
    "codigo":251261009,
    "descripcion":"DEPRESIÓN DEL TU"
  },
  {
    "codigo":314962005,
    "descripcion":"RECIDIVA LOCAL DE NEOPLASIA MALIGNA DE VESÍCULA BILIAR"
  },
  {
    "codigo":282194008,
    "descripcion":"NO SUBE ESCALERAS"
  },
  {
    "codigo":335781000119104,
    "descripcion":"GRANULOMA DE CONJUNTIVA DERECHA"
  },
  {
    "codigo":50983008,
    "descripcion":"TRASTORNO DE PÁNICO CON AGORAFOBIA, EVITACIÓN AGORAFÓBICA LEVE Y ATAQUES DE PÁNICO EN REMISIÓN PARCIAL"
  },
  {
    "codigo":1073061000119105,
    "descripcion":"ARTRITIS DE HOMBRO DERECHO CAUSADA POR STREPTOCOCCUS"
  },
  {
    "codigo":737276005,
    "descripcion":"INJERTO-PUENTE AORTOCORONARIO PRESENTE"
  },
  {
    "codigo":81916006,
    "descripcion":"GRITO"
  },
  {
    "codigo":1163260008,
    "descripcion":"CAMPTODACTILIA DE LOS DEDOS DE LA MANO NO SINDRÓMICA"
  },
  {
    "codigo":276689004,
    "descripcion":"OFTALMÍA NEONATAL POR BACTERIAS COLIFORMES"
  },
  {
    "codigo":1290662000,
    "descripcion":"RADIOGRAFÍA DE COLUMNA LUMBOSACRA NORMAL"
  },
  {
    "codigo":211153009,
    "descripcion":"LESIONES SUPERFICIALES MÚLTIPLES EN EL TÓRAX"
  },
  {
    "codigo":274854000,
    "descripcion":"NIVELES ENZIMÁTICOS EN LÍQUIDO CEFALORRAQUÍDEO FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":209318001,
    "descripcion":"FRACTURA-SUBLUXACIÓN NO EXPUESTA DE DÍGITO"
  },
  {
    "codigo":242086003,
    "descripcion":"LESIÓN AL SUBIR O BAJAR DE TREN EN MOVIMIENTO"
  },
  {
    "codigo":10876991000119103,
    "descripcion":"HERIDA ABIERTA DE TOBILLO DERECHO"
  },
  {
    "codigo":307622006,
    "descripcion":"LINFOSARCOMA PROLINFOCÍTICO"
  },
  {
    "codigo":830075002,
    "descripcion":"CÁLCULO PIGMENTARIO DE VESÍCULA BILIAR"
  },
  {
    "codigo":309311000119104,
    "descripcion":"NECROSIS AVASCULAR DE PERONÉ DERECHO"
  },
  {
    "codigo":404091004,
    "descripcion":"INFILTRACIÓN TUMORAL DE LA PIEL, POR TUMOR SUBYACENTE"
  },
  {
    "codigo":10875004,
    "descripcion":"TRASTORNO BIPOLAR I GRAVE CON SÍNTOMAS PSICÓTICOS, INCONGRUENTE CON EL ESTADO DE ÁNIMO"
  },
  {
    "codigo":371323006,
    "descripcion":"COLIBACILOSIS NEONATAL"
  },
  {
    "codigo":205648000,
    "descripcion":"TRISOMÍA 7"
  },
  {
    "codigo":402256001,
    "descripcion":"DERMATITIS ALÉRGICA POR CONTACTO DE GENITALES MASCULINOS"
  },
  {
    "codigo":369488002,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA VESÍCULA SEMINAL"
  },
  {
    "codigo":305787008,
    "descripcion":"ATENDIDO POR LOGOTERAPEUTA HOSPITALARIO"
  },
  {
    "codigo":74576004,
    "descripcion":"TROMBOCITOPENIA ADQUIRIDA"
  },
  {
    "codigo":10631231000119106,
    "descripcion":"LINFANGITIS AGUDA DE EXTREMIDAD INFERIOR DERECHA"
  },
  {
    "codigo":236581001,
    "descripcion":"RECHAZO DE TRASPLANTE RENAL, CRÓNICO - GRADO III"
  },
  {
    "codigo":271184009,
    "descripcion":"AMPOLLA TRAUMÁTICA DE PIERNA, INFECTADA"
  },
  {
    "codigo":302117003,
    "descripcion":"HALLAZGO RELACIONADO CON UN DISPOSITIVO MUSCULOESQUELÉTICO"
  },
  {
    "codigo":105509007,
    "descripcion":"CONDENA A PRESTAR SERVICIOS COMUNITARIOS"
  },
  {
    "codigo":5370000,
    "descripcion":"ALETEO AURICULAR"
  },
  {
    "codigo":1186853009,
    "descripcion":"POLINEUROPATÍA SENSITIVA POR DEFICIENCIA DE VITAMINA E"
  },
  {
    "codigo":38138003,
    "descripcion":"FACIES ADENOIDEA"
  },
  {
    "codigo":298447000,
    "descripcion":"AMPLITUD DE FLEXIÓN LATERAL PASIVA HACIA LA IZQUIERDA DE LA COLUMNA VERTEBRAL CERVICAL, DISMINUIDA"
  },
  {
    "codigo":69071001,
    "descripcion":"SÍNDROME RADICULAR DE MIEMBROS INFERIORES"
  },
  {
    "codigo":429519002,
    "descripcion":"ATENDIDO EN CENTRO ESPECIALIZADO EN HEPATOLOGÍA"
  },
  {
    "codigo":724431008,
    "descripcion":"ATEROSCLEROSIS DE INJERTO-PUENTE AUTÓLOGO DE ARTERIA CORONARIA"
  },
  {
    "codigo":722596001,
    "descripcion":"OBESIDAD CAUSADA POR DESEQUILIBRIO ENERGÉTICO"
  },
  {
    "codigo":10824051000119100,
    "descripcion":"FRACTURA EXPUESTA DE FALANGE PROXIMAL DE DEDO PULGAR DE MANO IZQUIERDA"
  },
  {
    "codigo":165540007,
    "descripcion":"MONOCITOS ANORMALES"
  },
  {
    "codigo":296612008,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE ERITROMICINA"
  },
  {
    "codigo":1279652009,
    "descripcion":"HERIDA PUNZANTE DE DEDO MEDIO DE MANO"
  },
  {
    "codigo":1343353009,
    "descripcion":"ACCESO DIGITAL INADECUADO DEBIDO A FALTA DE SUSCRIPCIÓN A UN SERVICIO DE INTERNET ADECUADO"
  },
  {
    "codigo":292942005,
    "descripcion":"REACCIÓN ADVERSA A LA MUPIROCINA"
  },
  {
    "codigo":1144910008,
    "descripcion":"METABOLIZADOR LENTO DE LA FAMILIA 2 SUBFAMILIA C MIEMBRO 9 *3\/*3 DEL CITOCROMO P450"
  },
  {
    "codigo":225571001,
    "descripcion":"HALLAZGO RELACIONADO CON LA LIMPIEZA DE LAS UÑAS"
  },
  {
    "codigo":127267002,
    "descripcion":"NEOPLASIA DE LOS GANGLIOS LINFÁTICOS INTRAPÉLVICOS"
  },
  {
    "codigo":92664001,
    "descripcion":"CARCINOMA IN SITU DE LA NASOFARINGE"
  },
  {
    "codigo":94499009,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA PARED POSTERIOR DE LA OROFARINGE"
  },
  {
    "codigo":1075571000119106,
    "descripcion":"INESTABILIDAD DE ARTICULACIÓN DE LA RODILLA IZQUIERDA"
  },
  {
    "codigo":289272008,
    "descripcion":"ENFERMEDAD INFECCIOSA DE PLACENTA"
  },
  {
    "codigo":254669003,
    "descripcion":"DERMATOSIS PAPULOSA NIGRA"
  },
  {
    "codigo":123597005,
    "descripcion":"ENDOCARDITIS INFECCIOSA CICATRIZADA"
  },
  {
    "codigo":713421007,
    "descripcion":"TAQUICARDIA VENTRICULAR MONOMÓRFICA ELECTROCARDIOGRÁFICA"
  },
  {
    "codigo":1268642000,
    "descripcion":"CARCINOMA DE MÉDULA RENAL PRIMARIO"
  },
  {
    "codigo":449442001,
    "descripcion":"ANOMALÍA CONGÉNITA DE GRAN VENA CARDÍACA"
  },
  {
    "codigo":56226004,
    "descripcion":"ESTENOSIS INTESTINAL"
  },
  {
    "codigo":285602007,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO CUTÁNEO EXTERNO DE MUSLO"
  },
  {
    "codigo":250999000,
    "descripcion":"CAMBIOS EN VALVAS DE VÁLVULA MITRAL REUMÁTICA"
  },
  {
    "codigo":609612001,
    "descripcion":"TRASTORNO DE RAÍZ Y\/O PLEXO NERVIOSO"
  },
  {
    "codigo":283767009,
    "descripcion":"MORDEDURA DE PERRO EN EXTREMIDAD INFERIOR"
  },
  {
    "codigo":85324003,
    "descripcion":"CÁLCULO DE LA PRÓSTATA"
  },
  {
    "codigo":281932007,
    "descripcion":"FRACTURA EN CUÑA DE VÉRTEBRA LUMBAR"
  },
  {
    "codigo":314700008,
    "descripcion":"TALLA DEL NIÑO: PERCENTILO 92-97"
  },
  {
    "codigo":183628009,
    "descripcion":"SEGUIMIENTO EN 6 SEMANAS"
  },
  {
    "codigo":443937008,
    "descripcion":"GLIOMA MIXTO"
  },
  {
    "codigo":247329009,
    "descripcion":"SENSACIÓN DE CRUJIDO ARTICULAR"
  },
  {
    "codigo":704246007,
    "descripcion":"FRACTURA PATOLÓGICA DE OMÓPLATO EN SITIO DE NEOPLASIA"
  },
  {
    "codigo":1259467001,
    "descripcion":"DEMENCIA DEBIDA A HIPERCALCEMIA"
  },
  {
    "codigo":702411003,
    "descripcion":"SÍNDROME DE SUSCEPTIBILIDAD FAMILIAR AL BLASTOMA PLEUROPULMONAR"
  },
  {
    "codigo":473035006,
    "descripcion":"TRASTORNO ASOCIADO CON DISPOSITIVO GENITOURINARIO"
  },
  {
    "codigo":866251007,
    "descripcion":"MIELITIS CAUSADA POR VIRUS COXSACKIE HUMANO DEL GRUPO B"
  },
  {
    "codigo":16669351000119105,
    "descripcion":"FRACTURA NO EXPUESTA DE PISO DE ÓRBITA DERECHA"
  },
  {
    "codigo":276427008,
    "descripcion":"SECCIÓN TRAUMÁTICA DE TENDÓN FLEXOR LARGO - ZONA 5"
  },
  {
    "codigo":241824004,
    "descripcion":"ENVENENAMIENTO DEBIDO A PICADURA DE ESPINA DE PEZ LEÓN"
  },
  {
    "codigo":733344004,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE LABIO"
  },
  {
    "codigo":305525000,
    "descripcion":"BAJO ATENCIÓN DE CIRUJANO"
  },
  {
    "codigo":10613001,
    "descripcion":"BERILIOSIS AGUDA"
  },
  {
    "codigo":403829002,
    "descripcion":"HIPERCOLESTEROLEMIA FAMILIAR POR MUTACIÓN HETEROCIGOTA DEL RECEPTOR DE LDL"
  },
  {
    "codigo":371061003,
    "descripcion":"INFECCIÓN DE SONDA VESICAL"
  },
  {
    "codigo":95041000119101,
    "descripcion":"MUTILACIÓN GENITAL FEMENINA"
  },
  {
    "codigo":43381005,
    "descripcion":"FUMADOR PASIVO"
  },
  {
    "codigo":76149006,
    "descripcion":"AGOTAMIENTO POR CALOR SECUNDARIO A DEPLECIÓN SALINA"
  },
  {
    "codigo":1255797003,
    "descripcion":"LINFOMA DE HODGKIN, VARIANTE ESCLEROSIS NODULAR DE GANGLIOS LINFÁTICOS DE MIEMBRO INFERIOR"
  },
  {
    "codigo":698741009,
    "descripcion":"CUADRIPLEJÍA COMPLETA AGUDA DEBIDA A LESIÓN DE MÉDULA ESPINAL ENTRE PRIMERA Y CUARTA VÉRTEBRAS CERVICALES"
  },
  {
    "codigo":41546002,
    "descripcion":"ENFERMEDAD CAUSADA POR RINOVIRUS"
  },
  {
    "codigo":205386003,
    "descripcion":"AMPUTACIÓN INTRAUTERINA DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":238154003,
    "descripcion":"EMACIACIÓN DEL MÚSCULO ESQUELÉTICO PRODUCIDO POR ENFERMEDAD SISTÉMICA SEVERA"
  },
  {
    "codigo":39591000119109,
    "descripcion":"INFERTILIDAD FEMENINA DEBIDA A TRASTORNO DE LA GLÁNDULA HIPÓFISIS"
  },
  {
    "codigo":860746006,
    "descripcion":"GRUPO DE GRADO 5 DE GLEASON"
  },
  {
    "codigo":11836071000119109,
    "descripcion":"LUXACIÓN EXPUESTA DE ARTICULACIÓN DE TARSO DERECHO"
  },
  {
    "codigo":170783002,
    "descripcion":"ENFERMEDAD TIROIDEA INACTIVA"
  },
  {
    "codigo":301855007,
    "descripcion":"HALLAZGO RELACIONADO CON LOS GANGLIOS LINFÁTICOS"
  },
  {
    "codigo":367391008,
    "descripcion":"MALESTAR GENERAL"
  },
  {
    "codigo":365556000,
    "descripcion":"HALLAZGO RELACIONADO CON EL PATRÓN DE INGRESOS"
  },
  {
    "codigo":400159008,
    "descripcion":"MALFORMACIÓN VASCULAR CONGÉNITA"
  },
  {
    "codigo":37876005,
    "descripcion":"FLEBOLITIASIS"
  },
  {
    "codigo":168948007,
    "descripcion":"ARTERIOGRAFÍA RENAL ANORMAL"
  },
  {
    "codigo":70644008,
    "descripcion":"ACIDOSIS RESPIRATORIA AGUDA"
  },
  {
    "codigo":429257001,
    "descripcion":"TRASTORNO DE CORAZÓN TRASPLANTADO"
  },
  {
    "codigo":298185009,
    "descripcion":"HIPERMOVILIDAD DE LA COLUMNA"
  },
  {
    "codigo":294515002,
    "descripcion":"ALERGIA A PIPERACILINA"
  },
  {
    "codigo":32371003,
    "descripcion":"DERMATITIS DE CONTACTO CAUSADA POR NEOMICINA"
  },
  {
    "codigo":720499004,
    "descripcion":"SÍNDROME DE APLASIA CUTÁNEA CON MIOPÍA"
  },
  {
    "codigo":423752000,
    "descripcion":"CONDUCTA HIPERVIGILANTE"
  },
  {
    "codigo":290845002,
    "descripcion":"INTOXICACIÓN POR NORTRIPTILINA"
  },
  {
    "codigo":28701003,
    "descripcion":"BAJO AUMENTO DE PESO MATERNO"
  },
  {
    "codigo":15934581000119101,
    "descripcion":"DEFORMIDAD ADQUIRIDA EN CALCANEOVALGO DE AMBOS PIES"
  },
  {
    "codigo":1208349005,
    "descripcion":"CARCINOMA HEPATOCELULAR PEDIÁTRICO"
  },
  {
    "codigo":94237007,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL CARDIAS DEL ESTÓMAGO"
  },
  {
    "codigo":61469009,
    "descripcion":"DESTRUCCIÓN DE ERITROCITOS DISMINUIDA"
  },
  {
    "codigo":289010002,
    "descripcion":"DIFICULTAD PARA LLEVAR ALIMENTO A LA BOCA"
  },
  {
    "codigo":782771007,
    "descripcion":"SÍNDROME DE DEPLECIÓN DE ÁCIDO DESOXIRRIBONUCLEICO MITOCONDRIAL, FORMA HEPATOCEREBRORRENAL"
  },
  {
    "codigo":92402005,
    "descripcion":"NEOPLASIA BENIGNA DEL CORDÓN ESPERMÁTICO"
  },
  {
    "codigo":714994009,
    "descripcion":"INCAPAZ DE NADAR"
  },
  {
    "codigo":385479009,
    "descripcion":"BRONQUIOLITIS FOLICULAR"
  },
  {
    "codigo":23196009,
    "descripcion":"FRAMBÉSIDA PRECOZ DE LA FRAMBESIA"
  },
  {
    "codigo":205941000119107,
    "descripcion":"ALTERACIÓN DEL EPITELIO BUCAL"
  },
  {
    "codigo":283505001,
    "descripcion":"HERIDA PUNZANTE DE NARIZ"
  },
  {
    "codigo":86897003,
    "descripcion":"INFECCIÓN CAUSADA POR MECISTOCIRRUS"
  },
  {
    "codigo":709489006,
    "descripcion":"NEUROPATÍA DE FIBRAS PEQUEÑAS"
  },
  {
    "codigo":185201007,
    "descripcion":"LUGAR DE LA CONSULTA"
  },
  {
    "codigo":609350003,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE MIEMBRO INFERIOR SIN INFECCIÓN"
  },
  {
    "codigo":16891151000119103,
    "descripcion":"ENFERMEDAD DE ARTERIA CORONARIA DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":248902005,
    "descripcion":"OVARIO PALPABLE EN EL FONDO DE SACO VAGINAL"
  },
  {
    "codigo":312603000,
    "descripcion":"RECHAZO DE PULMÓN TRASPLANTADO"
  },
  {
    "codigo":247067003,
    "descripcion":"AFAQUIA - SIN CÁPSULA DEL CRISTALINO"
  },
  {
    "codigo":443675005,
    "descripcion":"SEMINOMA"
  },
  {
    "codigo":83227006,
    "descripcion":"INTOXICACIÓN POR PESCADO ESCOMBROIDEO"
  },
  {
    "codigo":1197339007,
    "descripcion":"ADENOMA TUBULAR BENIGNO DE INTESTINO GRUESO"
  },
  {
    "codigo":1080591000119105,
    "descripcion":"LEIOMIOSARCOMA PRIMARIO DE EXTREMIDAD SUPERIOR DERECHA"
  },
  {
    "codigo":212464002,
    "descripcion":"LESIÓN DE MÚLTIPLES MÚSCULOS Y TENDONES A NIVEL DEL ANTEBRAZO"
  },
  {
    "codigo":16235791000119106,
    "descripcion":"ENTROPIÓN CICATRIZAL DE AMBOS PÁRPADOS INFERIORES"
  },
  {
    "codigo":10966441000119100,
    "descripcion":"HERIDA POR ARMA BLANCA DE PIE DERECHO"
  },
  {
    "codigo":46789001,
    "descripcion":"TOS POSTPRANDIAL"
  },
  {
    "codigo":79557003,
    "descripcion":"MODIFICACIÓN DE LA ACTIVIDAD FETAL"
  },
  {
    "codigo":472773007,
    "descripcion":"DISFUNCIÓN DE VENTRÍCULO FETAL"
  },
  {
    "codigo":210629007,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA, DEDO DE LA MANO, A TRAVÉS DE ARTICULACIÓN INTERFALÁNGICA DISTAL"
  },
  {
    "codigo":1259205009,
    "descripcion":"TRASTORNO FETAL DEBIDO A PARTO DE NALGAS"
  },
  {
    "codigo":733082001,
    "descripcion":"ENFERMEDAD DE CUERPOS DE LAFORA DE COMIENZO TEMPRANO"
  },
  {
    "codigo":15990031000119108,
    "descripcion":"CATARATA SECUNDARIA DE OJO DERECHO"
  },
  {
    "codigo":343311000119109,
    "descripcion":"QUERATOCONJUNTIVITIS LÍMBICA SUPERIOR DE AMBOS OJOS"
  },
  {
    "codigo":700314002,
    "descripcion":"ARTROSIS SECUNDARIA DE ARTICULACIÓN SUBASTRAGALINA"
  },
  {
    "codigo":767685007,
    "descripcion":"HERNIA INGUINAL DERECHA RECURRENTE OBSTRUIDA CON GANGRENA"
  },
  {
    "codigo":698479000,
    "descripcion":"MONOARTRITIS DE TOBILLO Y\/O PIE"
  },
  {
    "codigo":239727002,
    "descripcion":"RUPTURA DEL LIGAMENTO CRUZADO POSTERIOR"
  },
  {
    "codigo":316841000119104,
    "descripcion":"DOLOR DE BRAZO IZQUIERDO"
  },
  {
    "codigo":403567006,
    "descripcion":"LIQUEN ESCLEROSO BUCAL"
  },
  {
    "codigo":10351008,
    "descripcion":"AMIGDALITIS SUPURATIVA"
  },
  {
    "codigo":1055257000,
    "descripcion":"AGENESIA DE EPÍFISIS DE FALANGE PROXIMAL DE DEDO ANULAR"
  },
  {
    "codigo":205124008,
    "descripcion":"POLIDACTILIA RADIAL DE WASSEL 3"
  },
  {
    "codigo":399897004,
    "descripcion":"CARCINOMA BASOCELULAR DE PIEL RETROAURICULAR"
  },
  {
    "codigo":203289006,
    "descripcion":"OSTEOPATÍA COMO CONSECUENCIA DE POLIOMIELITIS, DE LA MANO"
  },
  {
    "codigo":4846001,
    "descripcion":"HEPATITIS VIRAL ANICTÉRICA"
  },
  {
    "codigo":365294001,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA APAGAR LA INSTALACIÓN ELÉCTRICA PRINCIPAL"
  },
  {
    "codigo":299758003,
    "descripcion":"REFLEJO DE SUCCIÓN DE RESULTADO DUDOSO"
  },
  {
    "codigo":1348334001,
    "descripcion":"DOLOR CRÓNICO DE VESTÍBULO VULVAR PROVOCADO POR CONTACTO"
  },
  {
    "codigo":11785641000119109,
    "descripcion":"ABRASIÓN DE PIEL DE DEDO MEÑIQUE IZQUIERDO"
  },
  {
    "codigo":234222009,
    "descripcion":"MIOINHIBICIÓN OCASIONADA POR EL MARCAPASOS"
  },
  {
    "codigo":396227001,
    "descripcion":"QUERATODERMIA PALMOPLANTAR ADQUIRIDA"
  },
  {
    "codigo":232387003,
    "descripcion":"SURCO NASAL TRANSVERSO"
  },
  {
    "codigo":68547005,
    "descripcion":"SIGNO DEL TIMBRE"
  },
  {
    "codigo":363459007,
    "descripcion":"NEOPLASIA MALIGNA DE URETRA"
  },
  {
    "codigo":296088004,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE CLORDIAZEPÓXIDO"
  },
  {
    "codigo":427160005,
    "descripcion":"DISPOSICIÓN PARA MEJORAR LA COMUNICACIÓN"
  },
  {
    "codigo":230552007,
    "descripcion":"NEUROPATÍA MOTRIZ Y SENSITIVA HEREDITARIA LIGADA AL CROMOSOMA X"
  },
  {
    "codigo":359789008,
    "descripcion":"ARTERITIS DE TAKAYASU"
  },
  {
    "codigo":195949008,
    "descripcion":"BRONQUITIS ASMÁTICA CRÓNICA"
  },
  {
    "codigo":718402002,
    "descripcion":"DIURESIS AUMENTADA"
  },
  {
    "codigo":1144386003,
    "descripcion":"ATROFIA DE CÉLULAS DE PURKINJE DE CORTEZA DE CEREBELO"
  },
  {
    "codigo":294253008,
    "descripcion":"ALERGIA A DINOPROSTONA"
  },
  {
    "codigo":95810005,
    "descripcion":"INFECCIÓN DE CONDUCTO AUDITIVO EXTERNO"
  },
  {
    "codigo":63042009,
    "descripcion":"ATRESIA CONGÉNITA DE VÁLVULA TRICÚSPIDE"
  },
  {
    "codigo":225047003,
    "descripcion":"SALTO DESDE UN EDIFICIO"
  },
  {
    "codigo":93975006,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL PUBIS"
  },
  {
    "codigo":92140003,
    "descripcion":"NEOPLASIA BENIGNA DE ÍLEON"
  },
  {
    "codigo":319351000119100,
    "descripcion":"LUXACIÓN RECURRENTE DE ARTICULACIÓN DE PIE DERECHO"
  },
  {
    "codigo":188609000,
    "descripcion":"LINFOMA NODULAR DE GANGLIOS LINFÁTICOS DE CABEZA, CARA Y CUELLO"
  },
  {
    "codigo":190444009,
    "descripcion":"HIPOGASTRINEMIA"
  },
  {
    "codigo":288748008,
    "descripcion":"DIFICULTAD PARA HACERSE ENTENDER"
  },
  {
    "codigo":1204417003,
    "descripcion":"ESQUIZOFRENIA DE INICIO TEMPRANO"
  },
  {
    "codigo":345821000119108,
    "descripcion":"DESPRENDIMIENTO HEMORRÁGICO DE COROIDES DE AMBOS OJOS"
  },
  {
    "codigo":22934003,
    "descripcion":"ALOPECIA POR RADIACIÓN"
  },
  {
    "codigo":186774005,
    "descripcion":"FIEBRE BOTONOSA"
  },
  {
    "codigo":283243002,
    "descripcion":"VIDRIO EN EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":86635005,
    "descripcion":"SÍNDROME DE KASABACH - MERRITT"
  },
  {
    "codigo":1231680001,
    "descripcion":"PANUVEÍTIS DEBIDA A SARCOIDOSIS"
  },
  {
    "codigo":707392002,
    "descripcion":"CARCINOMA PRIMARIO DE CÉLULAS GIGANTES DE TRÁQUEA"
  },
  {
    "codigo":314176007,
    "descripcion":"MARMOLADO CUTÁNEO"
  },
  {
    "codigo":84800009,
    "descripcion":"CHORRO DE ORINA ANORMAL"
  },
  {
    "codigo":212202003,
    "descripcion":"LESIÓN DE LA RAÍZ DEL NERVIO CERVICAL - C6"
  },
  {
    "codigo":703722006,
    "descripcion":"PICHIA KUDRIAVZEVII O CANDIDA INCONSPICUA"
  },
  {
    "codigo":46527004,
    "descripcion":"ARTRITIS POR HAEMOPHILUS INFLUENZAE"
  },
  {
    "codigo":863892004,
    "descripcion":"ERITEMA EN LUGAR DE APLICACIÓN"
  },
  {
    "codigo":700052007,
    "descripcion":"SEPSIS POSESPLENECTOMÍA"
  },
  {
    "codigo":110228009,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO DE LA OROFARINGE"
  },
  {
    "codigo":42857002,
    "descripcion":"PERÍODO EXPULSIVO"
  },
  {
    "codigo":10752171000119101,
    "descripcion":"CANDIDIASIS DE VAGINA POSPARTO"
  },
  {
    "codigo":403305002,
    "descripcion":"COILONIQUIA ADQUIRIDA"
  },
  {
    "codigo":763753002,
    "descripcion":"FISURA DE LABIO INCOMPLETA DERECHA"
  },
  {
    "codigo":1156969005,
    "descripcion":"MIELOPATÍA DEBIDA A ESPONDILOSIS CERVICAL DE DOS NIVELES"
  },
  {
    "codigo":1255273008,
    "descripcion":"FRACTURA CONMINUTA NO EXPUESTA DE FALANGE DISTAL DE DEDO DE MANO"
  },
  {
    "codigo":370537009,
    "descripcion":"EXCESO DE YIN"
  },
  {
    "codigo":434238001,
    "descripcion":"RECHAZO AGUDO DE TRASPLANTE DE INTESTINO"
  },
  {
    "codigo":41022003,
    "descripcion":"DISCOPATÍA INTERVERTEBRAL DE LA REGIÓN DORSAL, CON MIELOPATÍA"
  },
  {
    "codigo":8254003,
    "descripcion":"ENFERMEDAD ENDOMIOCÁRDICA"
  },
  {
    "codigo":73790007,
    "descripcion":"AMENAZA DE ABORTO EN EL PRIMER TRIMESTRE"
  },
  {
    "codigo":237630007,
    "descripcion":"TRASTORNO HIPOGLUCÉMICO"
  },
  {
    "codigo":203027001,
    "descripcion":"ABSCESO DE MÚSCULO DE MUSLO"
  },
  {
    "codigo":41891000087100,
    "descripcion":"CONTUSIÓN DE EXTREMIDAD INFERIOR DERECHA"
  },
  {
    "codigo":235795007,
    "descripcion":"ABSCESO INTERESFINTERIANO"
  },
  {
    "codigo":301331008,
    "descripcion":"ÍNDICE DE MASA CORPORAL - HALLAZGO"
  },
  {
    "codigo":170259009,
    "descripcion":"EXAMEN AL AÑO: ANORMAL - PARA OBSERVACIÓN"
  },
  {
    "codigo":102888000,
    "descripcion":"TELARCA"
  },
  {
    "codigo":44451000087105,
    "descripcion":"HERIDA PUNZANTE DE TOBILLO DERECHO CON CUERPO EXTRAÑO"
  },
  {
    "codigo":299496003,
    "descripcion":"SIN AMPLITUD PASIVA DE PRONACIÓN MEDIOTARSIANA"
  },
  {
    "codigo":233960004,
    "descripcion":"ISQUEMIA CRÍTICA DE MIEMBROS SUPERIORES"
  },
  {
    "codigo":39331000087105,
    "descripcion":"HERIDA PUNZANTE DE DEDO MEÑIQUE DE MANO IZQUIERDA CON CUERPO EXTRAÑO"
  },
  {
    "codigo":365032007,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD DE UTILIZAR FUNCIONES COMUNICATIVAS"
  },
  {
    "codigo":2749000,
    "descripcion":"DEFORMIDAD CONGÉNITA DE LA ARTICULACIÓN DE LA CADERA"
  },
  {
    "codigo":723645001,
    "descripcion":"EPIFISIOLISIS DE HÚMERO PROXIMAL"
  },
  {
    "codigo":232125001,
    "descripcion":"HIPERMETROPÍA SIMPLE"
  },
  {
    "codigo":70120007,
    "descripcion":"SALPINGITIS SUBAGUDA"
  },
  {
    "codigo":35517004,
    "descripcion":"ÚLCERA GASTROYEYUNAL SIN HEMORRAGIA, SIN PERFORACIÓN Y SIN OBSTRUCCIÓN"
  },
  {
    "codigo":168424006,
    "descripcion":"EXTENDIDO CERVICAL: COILOCITOSIS"
  },
  {
    "codigo":201192006,
    "descripcion":"MILIARIA PAPULOSA"
  },
  {
    "codigo":1085611000119108,
    "descripcion":"EDENTULISMO COMPLETO DE CLASE III DEBIDO A TRAUMATISMO"
  },
  {
    "codigo":428733008,
    "descripcion":"NEUROMA DE MIEMBRO INFERIOR"
  },
  {
    "codigo":721810002,
    "descripcion":"INFECCIÓN CAUSADA POR CYCLOSPORA"
  },
  {
    "codigo":426898004,
    "descripcion":"VIRILIZACIÓN FEMENINA POR HIPERANDROGENISMO GESTACIONAL"
  },
  {
    "codigo":263058005,
    "descripcion":"SUBLUXACIÓN DE LA ARTICULACIÓN TIBIOFEMORAL"
  },
  {
    "codigo":64615000,
    "descripcion":"MIOCARDIOPATÍA RESTRICTIVA SECUNDARIA A GLUCOGENOSIS"
  },
  {
    "codigo":295826009,
    "descripcion":"SOBREDOSIS DE BROMOCRIPTINA"
  },
  {
    "codigo":719975002,
    "descripcion":"HEMOCROMATOSIS HEREDITARIA AUTOSÓMICA DOMINANTE"
  },
  {
    "codigo":15968581000119104,
    "descripcion":"SÍNDROME DE ABERTURA DE SALIDA TORÁCICA NEUROGÉNICO DE PLEXO BRAQUIAL IZQUIERDO"
  },
  {
    "codigo":293991007,
    "descripcion":"ALERGIA A PRAZOSINA"
  },
  {
    "codigo":16024031000119100,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DEBIDO A OCLUSIÓN DE ARTERIA PONTINA DERECHA"
  },
  {
    "codigo":1240581000000104,
    "descripcion":"CORONAVIRUS 2 DEL SÍNDROME RESPIRATORIO AGUDO SEVERO DETECTADO"
  },
  {
    "codigo":95548009,
    "descripcion":"EDEMA RETROPERITONEAL"
  },
  {
    "codigo":93713003,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE VASO SANGUÍNEO DEL MIEMBRO SUPERIOR"
  },
  {
    "codigo":716305005,
    "descripcion":"DESMINERALIZACIÓN DE DIENTE"
  },
  {
    "codigo":91878000,
    "descripcion":"AUSENCIA CONGÉNITA DE CENTRO DE VÉRTEBRA SACRA"
  },
  {
    "codigo":290321009,
    "descripcion":"INTOXICACIÓN POR SUSTANCIA DE CONTRASTE"
  },
  {
    "codigo":124646004,
    "descripcion":"DEFICIENCIA DE HIDROLIASA"
  },
  {
    "codigo":386790008,
    "descripcion":"TRASTORNO DE LA EYACULACIÓN"
  },
  {
    "codigo":417723001,
    "descripcion":"PRESIÓN INTRAOCULAR EN EL OJO DERECHO"
  },
  {
    "codigo":286651000,
    "descripcion":"AUTOESTIMA FRÁGIL"
  },
  {
    "codigo":1204155000,
    "descripcion":"INFARTO DE MIOCARDIO ANTERIOR AGUDO SIN ELEVACIÓN DE SEGMENTO ST"
  },
  {
    "codigo":253883006,
    "descripcion":"QUISTES RENALES MÚLTIPLES"
  },
  {
    "codigo":384955008,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA BRONQUIAL AFECTADO POR NEOPLASIA MALIGNA"
  },
  {
    "codigo":284816009,
    "descripcion":"CAPAZ DE PARARSE EN LA BAÑERA"
  },
  {
    "codigo":282981007,
    "descripcion":"INCAPAZ DE ARRODILLARSE"
  },
  {
    "codigo":608826000,
    "descripcion":"FENÓMENO DE CUSHING"
  },
  {
    "codigo":1003877009,
    "descripcion":"SÍNDROME DE PFEIFFER TIPO 1"
  },
  {
    "codigo":1296954002,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE TENDÓN EXTENSOR DE MANO DERECHA"
  },
  {
    "codigo":707130003,
    "descripcion":"ESTADO DE CONTROL DE TRASTORNO ENDOCRINO"
  },
  {
    "codigo":1264186004,
    "descripcion":"TRASTORNO NEONATAL PRECOZ CAUSADO POR ANESTESIA MATERNA TRANSMITIDA POR VÍA PLACENTARIA DURANTE TRABAJO DE PARTO"
  },
  {
    "codigo":131551000119109,
    "descripcion":"STENT RECUBIERTO CON MEDICACIÓN EN RAMA DE ARTERIA CORONARIA DERECHA"
  },
  {
    "codigo":1196815001,
    "descripcion":"NEOPLASIA BENIGNA DE APARATO LAGRIMAL"
  },
  {
    "codigo":312079003,
    "descripcion":"UTILIZA ANTICONCEPCIÓN INTRAUTERINA"
  },
  {
    "codigo":15669881000119105,
    "descripcion":"RETROVERSIÓN CONGÉNITA DE AMBOS FÉMURES"
  },
  {
    "codigo":15332004,
    "descripcion":"ANEMIA POR LECHE DE CABRA"
  },
  {
    "codigo":80868005,
    "descripcion":"ABSTINENCIA DE COCAÍNA"
  },
  {
    "codigo":277476007,
    "descripcion":"DISTENSIÓN VENTRICULAR CEREBRAL"
  },
  {
    "codigo":373945007,
    "descripcion":"DERRAME PERICÁRDICO"
  },
  {
    "codigo":308409008,
    "descripcion":"FALLA EN PESQUISA PARA ALTERACIONES AUDITIVAS EN NIÑOS"
  },
  {
    "codigo":765326001,
    "descripcion":"DEFICIENCIA FAMILIAR DE GLUCOCORTICOIDES"
  },
  {
    "codigo":13497008,
    "descripcion":"INTOXICACIÓN POR LOPHYROTOMA INTERRUPTA"
  },
  {
    "codigo":109966003,
    "descripcion":"LINFOMA NO HODGKINIANO DIFUSO, INMUNOBLÁSTICO (CLÍNICO)"
  },
  {
    "codigo":372110008,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LÓBULO INFERIOR, BRONQUIO O PULMÓN"
  },
  {
    "codigo":208270009,
    "descripcion":"FRACTURA NO EXPUESTA DE HÚMERO DISTAL, TRÓCLEA"
  },
  {
    "codigo":239203003,
    "descripcion":"TROMBOSIS ARTERIAL DEL COLGAJO"
  },
  {
    "codigo":271971004,
    "descripcion":"TRASTORNO DE INJERTO DE NERVIO PERIFÉRICO"
  },
  {
    "codigo":9827004,
    "descripcion":"FOLICULITIS EN RACIMOS"
  },
  {
    "codigo":403043006,
    "descripcion":"TIÑA CORPORAL CAUSADA POR TRICHOPHYTON VERRUCOSUM"
  },
  {
    "codigo":1187640000,
    "descripcion":"DEFICIENCIA COMBINADA DE LA FOSFORILACIÓN OXIDATIVA TIPO 28"
  },
  {
    "codigo":697955008,
    "descripcion":"ESPACIO PRIMATE PRESENTE"
  },
  {
    "codigo":302904002,
    "descripcion":"INFARTO DE LA CORTEZA VISUAL"
  },
  {
    "codigo":11848621000119101,
    "descripcion":"CONTUSIÓN DE PÁRPADO DERECHO"
  },
  {
    "codigo":399373003,
    "descripcion":"SÓLO CAMBIOS EN LA ONDA T"
  },
  {
    "codigo":366605006,
    "descripcion":"PRUEBA DEL CAJÓN ANTERIOR - HALLAZGO"
  },
  {
    "codigo":69858000,
    "descripcion":"PERFORACIÓN DEL DIAFRAGMA"
  },
  {
    "codigo":102626001,
    "descripcion":"DOLOR DE HÍGADO"
  },
  {
    "codigo":299234001,
    "descripcion":"DEFORMIDAD DE ARTICULACIÓN DE CADERA FIJA EN FLEXIÓN"
  },
  {
    "codigo":233698001,
    "descripcion":"NEUMOPATÍA DE LOS PARTIDORES DE PIMIENTO"
  },
  {
    "codigo":364770009,
    "descripcion":"ALIMENTACIÓN DEL LACTANTE A LOS 10 DÍAS - HALLAZGO"
  },
  {
    "codigo":428471001,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN MÚLTIPLES SITIOS CON INFECCIÓN"
  },
  {
    "codigo":788919002,
    "descripcion":"MENSTRUACIÓN EXCESIVA CON CICLO IRREGULAR"
  },
  {
    "codigo":723383005,
    "descripcion":"FISURA DE LA LÍNEA MEDIA DE LABIO INFERIOR"
  },
  {
    "codigo":166327007,
    "descripcion":"NIVEL DE T3 SÉRICO POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":231863008,
    "descripcion":"LESIÓN TRAUMÁTICA CONJUNTIVAL"
  },
  {
    "codigo":721548003,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE APARATO LAGRIMAL"
  },
  {
    "codigo":295564004,
    "descripcion":"SOBREDOSIS INTENCIONAL DE LIDOCAÍNA"
  },
  {
    "codigo":652005,
    "descripcion":"AMIGDALITIS GANGRENOSA"
  },
  {
    "codigo":107591000119100,
    "descripcion":"CARCINOMA PRIMARIO ESCAMOCELULAR DE URETRA"
  },
  {
    "codigo":33420007,
    "descripcion":"SÍNDROME CERVICOBRAQUIAL DIFUSO"
  },
  {
    "codigo":197260007,
    "descripcion":"LINFANGIECTASIA INTESTINAL"
  },
  {
    "codigo":262796008,
    "descripcion":"HEMATOMA DE HÍGADO"
  },
  {
    "codigo":195425000,
    "descripcion":"TROMBOFLEBITIS DE LA VENA ILÍACA COMÚN"
  },
  {
    "codigo":129889004,
    "descripcion":"TRASTORNO EN LA SIGNIFICACIÓN"
  },
  {
    "codigo":424801004,
    "descripcion":"ENDOTELITIS CORNEAL POR HERPES ZÓSTER"
  },
  {
    "codigo":681031000119102,
    "descripcion":"SÍNDROME DE TOLOSA-HUNT BILATERAL"
  },
  {
    "codigo":193590000,
    "descripcion":"CATARATA SENIL MADURA, TOTAL"
  },
  {
    "codigo":816182002,
    "descripcion":"EDEMA DE MIEMBRO INFERIOR IZQUIERDO"
  },
  {
    "codigo":160822004,
    "descripcion":"PROBLEMA EN LA RELACIÓN"
  },
  {
    "codigo":95286004,
    "descripcion":"VENA ÁCIGOS SUPERNUMERARIA"
  },
  {
    "codigo":16000071000119103,
    "descripcion":"SÍNDROME DE IRIS EN MESETA IZQUIERDO"
  },
  {
    "codigo":291894005,
    "descripcion":"INTOXICACIÓN VOLUNTARIO POR FIBRINÓGENO HUMANO"
  },
  {
    "codigo":717878007,
    "descripcion":"ÚLCERA DUODENAL EOSINOFÍLICA"
  },
  {
    "codigo":422966009,
    "descripcion":"TONO MUSCULAR AUMENTADO - LADO IZQUIERDO MÁS ACENTUADO QUE EL DERECHO"
  },
  {
    "codigo":128054009,
    "descripcion":"TROMBOSIS VENOSA PROFUNDA DE LAS EXTREMIDADES SUPERIORES"
  },
  {
    "codigo":93451002,
    "descripcion":"ERITROLEUCEMIA, FAB M6"
  },
  {
    "codigo":290059008,
    "descripcion":"MAMA DE FORMA NORMAL"
  },
  {
    "codigo":60683009,
    "descripcion":"INFECCIÓN CAUSADA POR STEPHANURUS"
  },
  {
    "codigo":1304032001,
    "descripcion":"GLAUCOMA DE ÁNGULO CERRADO BILATERAL POSOPERATORIO"
  },
  {
    "codigo":124384003,
    "descripcion":"DEFICIENCIA DE AMINOACILTRANSFERASA"
  },
  {
    "codigo":58848006,
    "descripcion":"AUSENCIA DE ACCIÓN DE UN FÁRMACO"
  },
  {
    "codigo":286389002,
    "descripcion":"NO INICIA LA EMISIÓN DE PALABRAS"
  },
  {
    "codigo":253621008,
    "descripcion":"ESTENOSIS DEL TRONCO PULMONAR"
  },
  {
    "codigo":55178001,
    "descripcion":"CETOACIDOSIS POR INANICIÓN"
  },
  {
    "codigo":284554003,
    "descripcion":"LESIÓN TRAUMÁTICA POR AVULSIÓN"
  },
  {
    "codigo":251786004,
    "descripcion":"FIJACIÓN OCULAR EXTRAFOVEAL"
  },
  {
    "codigo":249951002,
    "descripcion":"FUERZA INSUFICIENTE PARA MOVER ARTICULACIÓN"
  },
  {
    "codigo":315487004,
    "descripcion":"NACIDO EN NEPAL"
  },
  {
    "codigo":1003615005,
    "descripcion":"SOSPECHA DE GLAUCOMA DE ÁNGULO ABIERTO DE OJO IZQUIERDO"
  },
  {
    "codigo":870708003,
    "descripcion":"CAPAZ DE PARTICIPAR EN VIDA SOCIAL COMUNITARIA"
  },
  {
    "codigo":51508004,
    "descripcion":"INTOXICACIÓN POR CHENOPODIUM ALBUM"
  },
  {
    "codigo":1296692003,
    "descripcion":"HIPERTENSIÓN OCULAR BILATERAL DEBIDA A AFAQUIA"
  },
  {
    "codigo":279049005,
    "descripcion":"DOLOR EN REGIÓN DE DORSO POSTERIOR A PROCEDIMIENTO QUIRÚRGICO"
  },
  {
    "codigo":311817009,
    "descripcion":"FRACTURAS MÚLTIPLES EXPUESTAS DE CLAVÍCULA, OMÓPLATO Y HÚMERO"
  },
  {
    "codigo":277214003,
    "descripcion":"SONIDO LATERALIZADO HACIA EL OÍDO AFECTADO"
  },
  {
    "codigo":703198009,
    "descripcion":"MALFORMACIÓN VENOSA PERIFÉRICA"
  },
  {
    "codigo":111539002,
    "descripcion":"PERFORACIÓN POSTRAUMÁTICA PERSISTENTE DEL TÍMPANO"
  },
  {
    "codigo":80606009,
    "descripcion":"EMBOLIA DE ARTERIA CARÓTIDA"
  },
  {
    "codigo":26941000119100,
    "descripcion":"INFECCIÓN DE LARINGE"
  },
  {
    "codigo":290621000119101,
    "descripcion":"DÉFICIT COGNITIVO DEBIDO A ENFERMEDAD CARDIOVASCULAR Y POSTERIOR A ELLA"
  },
  {
    "codigo":687421000119101,
    "descripcion":"OSTEOSARCOMA PRIMARIO DE COLUMNA VERTEBRAL"
  },
  {
    "codigo":12207421000119103,
    "descripcion":"AFLOJAMIENTO DE PRÓTESIS DE ARTICULACIÓN DE CADERA DERECHA"
  },
  {
    "codigo":679741000119103,
    "descripcion":"SÍNDROME DE TOLOSA-HUNT DE OJO DERECHO"
  },
  {
    "codigo":341821000119105,
    "descripcion":"ÚLCERA DE CÓRNEA CENTRAL DE OJO IZQUIERDO"
  },
  {
    "codigo":16467261000119106,
    "descripcion":"MELORREOSTOSIS DE PIERNA IZQUIERDA"
  },
  {
    "codigo":15934781000119107,
    "descripcion":"DEDO EN GARRA CONGÉNITO DE PIE IZQUIERDO"
  },
  {
    "codigo":16899901000119104,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS PRIMARIO DE PIEL DE TÓRAX"
  },
  {
    "codigo":305981000119109,
    "descripcion":"TRASTORNO DE LIGAMENTO DE ARTICULACIÓN DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":699528002,
    "descripcion":"OSTEOPOROSIS TRANSITORIA"
  },
  {
    "codigo":103741000119108,
    "descripcion":"CONTRACTURA DE ARTICULACIÓN DE DEDO DE LA MANO CONCOMITANTE CON CICATRIZ Y DEBIDA A ELLA"
  },
  {
    "codigo":149821000119103,
    "descripcion":"INFARTO CEREBRAL DEBIDO A OCLUSIÓN DE ARTERIA CARÓTIDA"
  },
  {
    "codigo":15960381000119109,
    "descripcion":"ANGINA CONCOMITANTE CON ARTERIOESCLEROSIS DE INJERTO-PUENTE DE ARTERIA CORONARIA"
  },
  {
    "codigo":1354888004,
    "descripcion":"POBREZA ENERGÉTICA DOMÉSTICA DEBIDA A INTERRUPCIÓN DE SERVICIOS ENERGÉTICOS EN REGIÓN GEOGRÁFICA"
  },
  {
    "codigo":11828541000119109,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO DE MUSLO DERECHO"
  },
  {
    "codigo":1156445000,
    "descripcion":"CUMPLE CON PRECAUCIÓN DE SEGURIDAD"
  },
  {
    "codigo":15937341000119108,
    "descripcion":"DISTIQUIASIS CONGÉNITA DE PÁRPADO DERECHO"
  },
  {
    "codigo":1287517005,
    "descripcion":"ABRASIÓN DE PIEL DE ANO"
  },
  {
    "codigo":109704007,
    "descripcion":"ESCALONAMIENTO ÓSEO ALVEOLAR LINGUAL"
  },
  {
    "codigo":1254749009,
    "descripcion":"CARCINOMA ESCAMOSO ACANTOLÍTICO METASTÁSICO"
  },
  {
    "codigo":400946004,
    "descripcion":"SÍNDROME DE FIBROSIS CONGÉNITA"
  },
  {
    "codigo":300807001,
    "descripcion":"NO SE DEDICA A ACTIVIDADES RELIGIOSAS"
  },
  {
    "codigo":237106009,
    "descripcion":"BARTOLINITIS POR CLAMIDIA"
  },
  {
    "codigo":366343003,
    "descripcion":"DETALLES DEL NACIMIENTO - HALLAZGO"
  },
  {
    "codigo":5895007,
    "descripcion":"FRACTURAS MÚLTIPLES NO EXPUESTAS DE EXTREMO PROXIMAL DE RADIO"
  },
  {
    "codigo":298972005,
    "descripcion":"AMPLITUD DE ABDUCCIÓN ACTIVA DE ARTICULACIÓN DE MUÑECA, AUMENTADA"
  },
  {
    "codigo":167900008,
    "descripcion":"LÍQUIDO SINOVIAL: SIN CONTENIDO ANORMAL"
  },
  {
    "codigo":200668008,
    "descripcion":"CELULITIS Y ABSCESO DE BRAZO"
  },
  {
    "codigo":34993002,
    "descripcion":"PROTEINURIA MIXTA"
  },
  {
    "codigo":1711000119101,
    "descripcion":"NOCTURIA DEBIDA A HIPERTROFIA PROSTÁTICA BENIGNA"
  },
  {
    "codigo":67761004,
    "descripcion":"DEGENERACIÓN OLIVOPONTOCEREBELOSA"
  },
  {
    "codigo":724956008,
    "descripcion":"DISTENSIÓN DE MÚSCULO FLEXOR DE DEDO DE LA MANO A LA ALTURA DEL ANTEBRAZO"
  },
  {
    "codigo":297137006,
    "descripcion":"ÉMBOLO DE ARTERIA CELÍACA"
  },
  {
    "codigo":723121004,
    "descripcion":"TEMOR A CÁNCER HEMATOLÓGICO"
  },
  {
    "codigo":262534005,
    "descripcion":"CONTUSIÓN CONFLUENTE"
  },
  {
    "codigo":721286008,
    "descripcion":"HIPOINSULINEMIA POSTERIOR A PROCEDIMIENTO"
  },
  {
    "codigo":31323000,
    "descripcion":"INMUNODEFICIENCIA COMBINADA SEVERA"
  },
  {
    "codigo":129627002,
    "descripcion":"QUERATITIS VESICULAR"
  },
  {
    "codigo":1145435003,
    "descripcion":"HIPOPLASIA CONGÉNITA DE COLUMNA VERTEBRAL CERVICAL"
  },
  {
    "codigo":293467006,
    "descripcion":"REACCIÓN ADVERSA A LA TORASEMIDA"
  },
  {
    "codigo":719451006,
    "descripcion":"SÍNDROME DE MIOCARDIOPATÍA DILATADA CON HIPOGONADISMO HIPERGONADOTRÓFICO"
  },
  {
    "codigo":422704000,
    "descripcion":"DIFICULTAD PARA OBTENER ANTICONCEPCIÓN"
  },
  {
    "codigo":226096001,
    "descripcion":"DIETA DE AMINOÁCIDOS RAMIFICADOS MODIFICADOS"
  },
  {
    "codigo":95024008,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL RECTO"
  },
  {
    "codigo":291632008,
    "descripcion":"INTOXICACIÓN POR CEFPIROMA"
  },
  {
    "codigo":16058031000119107,
    "descripcion":"TRASTORNO DE NERVIO TRIGÉMINO DERECHO"
  },
  {
    "codigo":93189002,
    "descripcion":"HISTIOCITOSIS MALIGNA DE BAZO"
  },
  {
    "codigo":191493005,
    "descripcion":"DEMENCIA MEDICAMENTOSA"
  },
  {
    "codigo":289797008,
    "descripcion":"TUMORACIÓN DE CUELLO UTERINO"
  },
  {
    "codigo":11853641000119102,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA PARCIAL DE PIE DERECHO"
  },
  {
    "codigo":419034002,
    "descripcion":"INFECCIÓN POR EL VIRUS DEL VALLE CACHE"
  },
  {
    "codigo":1172698005,
    "descripcion":"SÍNDROME DE CRISIS ENCEFALOMIOPÁTICAS METABÓLICAS RECURRENTES, RABDOMIÓLISIS, ARRITMIA CARDÍACA Y DISCAPACIDAD INTELECTUAL"
  },
  {
    "codigo":124122005,
    "descripcion":"DEFICIENCIA DE 3 - HIDROXIACIL - COA DESHIDROGENASA"
  },
  {
    "codigo":15703881000119104,
    "descripcion":"CONTRACTURA DE MÚSCULO DE AMBOS MUSLOS"
  },
  {
    "codigo":253359006,
    "descripcion":"FIBROELASTOSIS ENDOCÁRDICA DE AURÍCULA IZQUIERDA"
  },
  {
    "codigo":286127006,
    "descripcion":"DIFICULTAD PARA LIMPIAR LAS VENTANAS"
  },
  {
    "codigo":284292003,
    "descripcion":"DIFICULTAD PARA REALIZAR LA PRENSIÓN CON PRONACIÓN DE LA MUÑECA"
  },
  {
    "codigo":118617000,
    "descripcion":"LINFOMA DE BURKITT"
  },
  {
    "codigo":249689005,
    "descripcion":"DESPLAZAMIENTO SUPERIOR DE LA EXTREMIDAD EXTERNA DE LA CLAVÍCULA"
  },
  {
    "codigo":315225007,
    "descripcion":"PULSO ARTERIAL DÉBIL"
  },
  {
    "codigo":282457007,
    "descripcion":"SECCIÓN DE TRÁQUEA"
  },
  {
    "codigo":20313009,
    "descripcion":"HIPEROSMOLALIDAD"
  },
  {
    "codigo":247854002,
    "descripcion":"FOBIA A VOLAR"
  },
  {
    "codigo":18478005,
    "descripcion":"TRASTORNO DE ADAPTACIÓN, CON SÍNTOMAS FÍSICOS"
  },
  {
    "codigo":51246005,
    "descripcion":"INTOXICACIÓN CAUSADA POR EPICAUTA VITTATA"
  },
  {
    "codigo":772142007,
    "descripcion":"HERNIA INGUINAL IZQUIERDA RECURRENTE OBSTRUIDA"
  },
  {
    "codigo":1163523005,
    "descripcion":"FIBROSIS DE VÍAS RESPIRATORIAS SUPERIORES DEBIDA A PARACOCCIDIOIDOMICOSIS"
  },
  {
    "codigo":702936000,
    "descripcion":"DERMACOCCUS NISHINOMIYAENSIS O KYTOCOCCUS SEDENTARIUS"
  },
  {
    "codigo":276952000,
    "descripcion":"CARCINOMA ESCAMOSO DE LA LENGUA"
  },
  {
    "codigo":14808008,
    "descripcion":"CEMENTOCLASIA"
  },
  {
    "codigo":373421000,
    "descripcion":"SÍNDROME URÉMICO HEMOLÍTICO ASOCIADO CON DIARREA"
  },
  {
    "codigo":209581003,
    "descripcion":"DESGARRO COMPLETO DE LIGAMENTO LATERAL INTERNO DE ARTICULACIÓN DE CODO"
  },
  {
    "codigo":111277007,
    "descripcion":"BURSITIS DE LA FARINGE"
  },
  {
    "codigo":1354626000,
    "descripcion":"FRACTURA DE SEGUNDO HUESO METATARSIANO"
  },
  {
    "codigo":109442002,
    "descripcion":"AUSENCIA CONGÉNITA DE UN DIENTE"
  },
  {
    "codigo":43906007,
    "descripcion":"BLOQUEO DE RAMA DERECHA CON BLOQUEO INCOMPLETO DE RAMA IZQUIERDA DEL HAZ DE HIS"
  },
  {
    "codigo":369751001,
    "descripcion":"TUMOR DE CONFIGURACIÓN INDETERMINADA"
  },
  {
    "codigo":238679001,
    "descripcion":"SARCOIDOSIS CICATRIZAL"
  },
  {
    "codigo":402519009,
    "descripcion":"CARCINOMA BASOCELULAR DE CARA"
  },
  {
    "codigo":73004004,
    "descripcion":"VISCEROPTOSIS"
  },
  {
    "codigo":10817661000119106,
    "descripcion":"FRACTURA EXPUESTA DE SEGUNDO HUESO METACARPIANO DE MANO DERECHA"
  },
  {
    "codigo":16034071000119100,
    "descripcion":"HIPERTROFIA DE HUESO DE PIE IZQUIERDO"
  },
  {
    "codigo":366081000,
    "descripcion":"MOVIMIENTOS OCULARES SEPARADOS - HALLAZGO"
  },
  {
    "codigo":267777001,
    "descripcion":"CELULITIS Y ABSCESO DE MEJILLA (EXTERNA)"
  },
  {
    "codigo":305431000119101,
    "descripcion":"CONTRACTURA DE ARTICULACIÓN DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":890369004,
    "descripcion":"ROTACIÓN ANÓMALA CONGÉNITA DE INTESTINO GRUESO"
  },
  {
    "codigo":300545005,
    "descripcion":"HALLAZGO RELACIONADO CON LA EXCITACIÓN SEXUAL"
  },
  {
    "codigo":202241007,
    "descripcion":"SUBLUXACIÓN RECURRENTE DE ARTICULACIÓN METACARPOFALÁNGICA"
  },
  {
    "codigo":429782000,
    "descripcion":"USO INAPROPIADO DE COCAÍNA"
  },
  {
    "codigo":397014001,
    "descripcion":"MASTOCITOSIS ERITRODÉRMICA DIFUSA"
  },
  {
    "codigo":298710001,
    "descripcion":"TÓRAX LARGO"
  },
  {
    "codigo":3798002,
    "descripcion":"NACIMIENTO PREMATURO DE GEMELOS MONOCIGÓTICOS, AMBOS MUERTOS"
  },
  {
    "codigo":167638005,
    "descripcion":"MATERIA FECAL: SIN COMPONENTE EXTRAÑO"
  },
  {
    "codigo":822998006,
    "descripcion":"GANGLIO LINFÁTICO FIRME"
  },
  {
    "codigo":724694006,
    "descripcion":"PATRÓN PERJUDICIAL DE CONSUMO DE CAFEÍNA"
  },
  {
    "codigo":427947000,
    "descripcion":"MONOARTRITIS DE ARTICULACIÓN DE LA CADERA"
  },
  {
    "codigo":722859001,
    "descripcion":"SÍNDROME TUMORAL HAMARTOMATOSO ASOCIADO A PTEN"
  },
  {
    "codigo":1963002,
    "descripcion":"HEMOGLOBINURIA PAROXÍSTICA NOCTURNA"
  },
  {
    "codigo":296875001,
    "descripcion":"SOBREDOSIS INTENCIONAL DE METFORMINA"
  },
  {
    "codigo":1279915006,
    "descripcion":"SÍNDROME DE CORDÓN CENTRAL DE MÉDULA TORÁCICA DEBIDO A FRACTURA EXPUESTA A NIVEL T1-T6"
  },
  {
    "codigo":65664004,
    "descripcion":"FRÉMITO RÓNQUICO"
  },
  {
    "codigo":426112004,
    "descripcion":"INTOXICACIÓN POR ANTICONGELANTE"
  },
  {
    "codigo":1343616007,
    "descripcion":"FORÚNCULO DE GENITAL MASCULINO"
  },
  {
    "codigo":293205003,
    "descripcion":"REACCIÓN ADVERSA AL ACARBOSE"
  },
  {
    "codigo":424277006,
    "descripcion":"FLUJO REDUCIDO DE LÍQUIDO CEFALORRAQUÍDEO"
  },
  {
    "codigo":719189006,
    "descripcion":"ATROFIA DE MÚSCULO GLÚTEO MAYOR"
  },
  {
    "codigo":63829008,
    "descripcion":"ESPESOR DISMINUIDO DE LA UÑA"
  },
  {
    "codigo":1208874001,
    "descripcion":"PATRÓN ELECTROCARDIOGRÁFICO DE BRUGADA ESPONTÁNEO"
  },
  {
    "codigo":427115009,
    "descripcion":"ENDOTELITIS CORNEAL POR HERPES SIMPLE"
  },
  {
    "codigo":225834007,
    "descripcion":"USA AMPARO CIUDADANO"
  },
  {
    "codigo":94762008,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE HUESO DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":92927009,
    "descripcion":"FORMA ANORMAL CONGÉNITA DEL MAXILAR"
  },
  {
    "codigo":1172436004,
    "descripcion":"ANGIOTENSINA II DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":254932004,
    "descripcion":"TUMOR DE CUELLO DE VEJIGA URINARIA"
  },
  {
    "codigo":1268905005,
    "descripcion":"TUMOR PRIMARIO MALIGNO DE VAINA DE NERVIO PERIFÉRICO"
  },
  {
    "codigo":710014001,
    "descripcion":"INSERCIÓN MUSCULAR EN ESTADO EDÉNTULO CON INSERCIÓN GENIOGLOSA ALTA"
  },
  {
    "codigo":251262002,
    "descripcion":"ONDA U PLANA"
  },
  {
    "codigo":447870003,
    "descripcion":"NÓDULO DE NALGA"
  },
  {
    "codigo":15679921000119109,
    "descripcion":"CONJUNTIVITIS NEONATAL DE OJO IZQUIERDO"
  },
  {
    "codigo":299827007,
    "descripcion":"REFLEJO TRICIPITAL VIVO"
  },
  {
    "codigo":314963000,
    "descripcion":"RECIDIVA LOCAL DE NEOPLASIA MALIGNA DE HÍGADO"
  },
  {
    "codigo":249427001,
    "descripcion":"SIN SALIVACIÓN"
  },
  {
    "codigo":216659008,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR AGENTES DE LIMPIEZA"
  },
  {
    "codigo":11803211000119105,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN METACARPOFALÁNGICA DE DEDO ÍNDICE DERECHO"
  },
  {
    "codigo":282195009,
    "descripcion":"DIFICULTAD PARA SUBIR ESCALERAS"
  },
  {
    "codigo":737277001,
    "descripcion":"PRÓTESIS DE VÁLVULA CARDÍACA IN SITU"
  },
  {
    "codigo":81917002,
    "descripcion":"OLOR DEL CUERPO"
  },
  {
    "codigo":247592009,
    "descripcion":"PÉRDIDA DE LA MEMORIA A CORTO PLAZO"
  },
  {
    "codigo":735442002,
    "descripcion":"EOSINOFILIA ADQUIRIDA"
  },
  {
    "codigo":276690008,
    "descripcion":"DACRIOCISTITIS NEONATAL CAUSADA POR STAPHYLOCOCCUS"
  },
  {
    "codigo":1259730008,
    "descripcion":"OLIGODENDROGLIOMA PRIMARIO DE ENCÉFALO"
  },
  {
    "codigo":307623001,
    "descripcion":"LINFOMA MALIGNO - LINFOPLASMOCÍTICO"
  },
  {
    "codigo":405927003,
    "descripcion":"SENO RENAL NO INVOLUCRADO POR TUMOR"
  },
  {
    "codigo":12711004,
    "descripcion":"ESTENOSIS DE PRÓSTATA"
  },
  {
    "codigo":1290663005,
    "descripcion":"RADIOGRAFÍA DE COLUMNA LUMBOSACRA ANORMAL"
  },
  {
    "codigo":45479006,
    "descripcion":"TRASTORNO BIPOLAR I MANÍACO EN REMISIÓN"
  },
  {
    "codigo":242087007,
    "descripcion":"LESIÓN AL SUBIR O BAJAR DE TREN DETENIDO"
  },
  {
    "codigo":305788003,
    "descripcion":"VISTO POR FARMACÉUTICO"
  },
  {
    "codigo":76412005,
    "descripcion":"VOZ ÁSPERA"
  },
  {
    "codigo":404092006,
    "descripcion":"CARCINOMA METASTÁSICO EN PIEL"
  },
  {
    "codigo":238417000,
    "descripcion":"INFECCIÓN CUTÁNEA NO PIOGÉNICA"
  },
  {
    "codigo":240252009,
    "descripcion":"DEFORMIDAD ADQUIRIDA DEL PIE EN ADUCCIÓN"
  },
  {
    "codigo":402257005,
    "descripcion":"DERMATITIS ALÉRGICA POR CONTACTO DE GENITALES FEMENINOS"
  },
  {
    "codigo":271185005,
    "descripcion":"AMPOLLA TRAUMÁTICA DE TOBILLO, INFECTADA"
  },
  {
    "codigo":369489005,
    "descripcion":"TUMOR MALIGNO QUE COMPROMETE LA VESÍCULA SEMINAL POR PROPAGACIÓN DIRECTA DE LA VEJIGA"
  },
  {
    "codigo":205649008,
    "descripcion":"TRISOMÍA 8"
  },
  {
    "codigo":105510002,
    "descripcion":"DISCORDIA SOCIAL"
  },
  {
    "codigo":1186854003,
    "descripcion":"COLESTASIS INTRAHEPÁTICA BENIGNA TIPO 2"
  },
  {
    "codigo":117631000119103,
    "descripcion":"NEUMATOSIS COLÓNICA"
  },
  {
    "codigo":302118008,
    "descripcion":"MEDIDAS DE LA INGESTA HÍDRICA POR VÍA ORAL - HALLAZGO"
  },
  {
    "codigo":5371001,
    "descripcion":"ESTRABISMO MECÁNICO"
  },
  {
    "codigo":236582008,
    "descripcion":"RECHAZO DE TRASPLANTE RENAL CRÓNICO REAGUDIZADO"
  },
  {
    "codigo":365819001,
    "descripcion":"HALLAZGO RELACIONADO CON LA PRESENCIA DE SUSTANCIAS REDUCTORAS"
  },
  {
    "codigo":7206008,
    "descripcion":"VELOCIDAD DE FLUJO ESPIRATORIO PICO, DISMINUIDA"
  },
  {
    "codigo":300283005,
    "descripcion":"SECRECIÓN AMIGDALINA"
  },
  {
    "codigo":16665471000119105,
    "descripcion":"FRACTURA EXPUESTA DE ÓRBITA IZQUIERDA"
  },
  {
    "codigo":724432001,
    "descripcion":"MAL FUNCIONAMIENTO DE DERIVACIÓN DE DESFIBRILADOR VENTRICULAR IMPLANTABLE"
  },
  {
    "codigo":200144004,
    "descripcion":"PARTOS POR CESÁREA"
  },
  {
    "codigo":298448005,
    "descripcion":"SIN AMPLITUD DE FLEXIÓN LATERAL PASIVA HACIA LA IZQUIERDA DE LA COLUMNA VERTEBRAL CERVICAL"
  },
  {
    "codigo":36304008,
    "descripcion":"ECTASIA VASCULAR DEL CIEGO"
  },
  {
    "codigo":788133001,
    "descripcion":"PAPILIOTREMA LAURENTII, RHODOTORULA GLUTINIS O RHODOTORULA MUCILAGINOSA"
  },
  {
    "codigo":427685000,
    "descripcion":"CARCINOMA DE MAMA POSITIVO PARA HER2"
  },
  {
    "codigo":91161000119101,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE PARED TORÁCICA"
  },
  {
    "codigo":1148581004,
    "descripcion":"HALLAZGO RELACIONADO CON UREMIA"
  },
  {
    "codigo":198309005,
    "descripcion":"TORSIÓN DE OVARIO Y TROMPA DE FALOPIO"
  },
  {
    "codigo":165541006,
    "descripcion":"RECUENTO DE MONOCITOS FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":11832191000119107,
    "descripcion":"LESIÓN TRAUMÁTICA DE VASO SANGUÍNEO DE DEDO ÍNDICE IZQUIERDO"
  },
  {
    "codigo":1074201000119102,
    "descripcion":"CONDROCALCINOSIS DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":1279653004,
    "descripcion":"HERIDA PUNZANTE DE DEDO ANULAR DE MANO"
  },
  {
    "codigo":1343354003,
    "descripcion":"ACCESO DIGITAL INADECUADO DEBIDO A RECURSOS ECONÓMICOS LIMITADOS PARA LA SUSCRIPCIÓN A UN SERVICIO DE INTERNET ADECUADO"
  },
  {
    "codigo":12241791000119109,
    "descripcion":"AMBOS OJOS ROJOS"
  },
  {
    "codigo":292943000,
    "descripcion":"REACCIÓN ADVERSA A LA NITROFURAZONA"
  },
  {
    "codigo":196474009,
    "descripcion":"ATROFIA DE GLÁNDULA PARÓTIDA"
  },
  {
    "codigo":65402008,
    "descripcion":"HIPERTENSIÓN PREEXISTENTE QUE COMPLICA EL EMBARAZO Y\/O CONSTITUYE UN MOTIVO DE ATENCIÓN DURANTE ESTE PERÍODO"
  },
  {
    "codigo":718927003,
    "descripcion":"DISFUNCIÓN SOMÁTICA DE REGIÓN SACROCOCCÍGEA"
  },
  {
    "codigo":129103003,
    "descripcion":"ENDOMETRIOSIS (CLÍNICA)"
  },
  {
    "codigo":63567004,
    "descripcion":"FISURA DE PALADAR DURO Y BLANDO"
  },
  {
    "codigo":1144911007,
    "descripcion":"CALCINOSIS DEBIDA A DERMATOMIOSITIS DEL ADULTO"
  },
  {
    "codigo":94500000,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA PARED POSTERIOR DE LA VEJIGA"
  },
  {
    "codigo":336921000119106,
    "descripcion":"IRITIS INDUCIDA POR LENTE"
  },
  {
    "codigo":127268007,
    "descripcion":"NEOPLASIA DE LOS GANGLIOS LINFÁTICOS ILÍACOS"
  },
  {
    "codigo":289273003,
    "descripcion":"DEPÓSITOS GRASOS PLACENTARIOS"
  },
  {
    "codigo":123598000,
    "descripcion":"POLISEROSITIS"
  },
  {
    "codigo":713422000,
    "descripcion":"TAQUICARDIA AURICULAR ELECTROCARDIOGRÁFICA"
  },
  {
    "codigo":254670002,
    "descripcion":"ACANTOMA DE CÉLULAS CLARAS"
  },
  {
    "codigo":88995000,
    "descripcion":"EDEMA DEL ESCROTO"
  },
  {
    "codigo":1137571003,
    "descripcion":"CICATRIZ CORIORRETINIANA DEBIDA A FOTOCOAGULACIÓN"
  },
  {
    "codigo":449443006,
    "descripcion":"LOCALIZACIÓN SUPRACARDÍACA DE CONEXIÓN VENOSA PULMONAR ANÓMALA A VENA VERTICAL EN EL LADO IZQUIERDO"
  },
  {
    "codigo":416675009,
    "descripcion":"FORÚNCULO"
  },
  {
    "codigo":251000001,
    "descripcion":"FIBROSIS DEL APARATO SUBVALVULAR MITRAL"
  },
  {
    "codigo":283768004,
    "descripcion":"MORDEDURA DE PERRO EN EL GLÚTEO"
  },
  {
    "codigo":773453000,
    "descripcion":"ALERGIA A DEXTROTIROXINA"
  },
  {
    "codigo":281933002,
    "descripcion":"FRACTURA POR APLASTAMIENTO DE VÉRTEBRA LUMBAR"
  },
  {
    "codigo":609613006,
    "descripcion":"ATRAPAMIENTO DE NERVIO CIÁTICO POPLÍTEO EXTERNO"
  },
  {
    "codigo":314701007,
    "descripcion":"TALLA DEL NIÑO: PERCENTILO 98"
  },
  {
    "codigo":247330004,
    "descripcion":"HALLAZGO RELACIONADO CON LA SENSIBILIDAD ABDOMINAL"
  },
  {
    "codigo":50722006,
    "descripcion":"TRASTORNO DELIRANTE POR FENCICLIDINA"
  },
  {
    "codigo":1162999000,
    "descripcion":"LESIÓN TRAUMÁTICA CAUSADA POR FUERZA PUNZANTE"
  },
  {
    "codigo":704247003,
    "descripcion":"FRACTURA PATOLÓGICA DE RADIO EN SITIO DE NEOPLASIA"
  },
  {
    "codigo":16119006,
    "descripcion":"ABSCESO DE MANDÍBULA"
  },
  {
    "codigo":212727009,
    "descripcion":"INTOXICACIÓN CON PAPAÍNA"
  },
  {
    "codigo":276428003,
    "descripcion":"SECCIÓN TRAUMÁTICA DE TENDÓN EXTENSOR - ZONA 2"
  },
  {
    "codigo":702412005,
    "descripcion":"SÍNDROME DE DEFICIENCIA INTELECTUAL LIGADA AL CROMOSOMA X-DISTONÍA-DISARTRIA"
  },
  {
    "codigo":15986151000119100,
    "descripcion":"COLOBOMA CONGÉNITO DE PAPILA ÓPTICA DERECHA"
  },
  {
    "codigo":473036007,
    "descripcion":"COMPLICACIÓN ASOCIADA CON IMPLANTE CARDÍACO"
  },
  {
    "codigo":309196005,
    "descripcion":"HALLAZGOS CITOLÓGICOS ANORMALES"
  },
  {
    "codigo":210892006,
    "descripcion":"LESIÓN DE VASOS SANGUÍNEOS PLANTARES PROFUNDOS"
  },
  {
    "codigo":1259468006,
    "descripcion":"CARCINOMA UROTELIAL PRIMARIO DE URÉTER DERECHO"
  },
  {
    "codigo":1076711000119101,
    "descripcion":"HIPERTROFIA DE ALMOHADILLA ADIPOSA DE RODILLA IZQUIERDA"
  },
  {
    "codigo":241825003,
    "descripcion":"ENVENENAMIENTO DEBIDO A PICADURA DE ESPINA DE PEZ PIEDRA"
  },
  {
    "codigo":733345003,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE FARINGE"
  },
  {
    "codigo":239990000,
    "descripcion":"LESIÓN DE PARTES BLANDAS DE LA REGIÓN PÉLVICA"
  },
  {
    "codigo":698742002,
    "descripcion":"CUADRIPLEJÍA CRÓNICA INCOMPLETA DEBIDA A LESIÓN DE MÉDULA ESPINAL ENTRE PRIMERA Y CUARTA VÉRTEBRAS CERVICALES"
  },
  {
    "codigo":305526004,
    "descripcion":"BAJO ATENCIÓN DE CIRUJANO MAMARIO"
  },
  {
    "codigo":10743271000119103,
    "descripcion":"ENFERMEDAD RELACIONADA CON INMUNOGLOBULINA G4"
  },
  {
    "codigo":371062005,
    "descripcion":"ACNÉ POR DEMODEX FOLICULORUM"
  },
  {
    "codigo":10614007,
    "descripcion":"DEFICIENCIA NUTRICIONAL POR FALTA DE UNA CLASE ESPECÍFICA DE ALIMENTO"
  },
  {
    "codigo":1255798008,
    "descripcion":"GRANULOMA DE HODGKIN DE GANGLIOS LINFÁTICOS DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":8779001,
    "descripcion":"INTOXICACIÓN POR EQUISETO PALUSTRE"
  },
  {
    "codigo":238155002,
    "descripcion":"ATROFIA VELLOSA INTESTINAL PRODUCIDA POR ENFERMEDAD SISTÉMICA GRAVE"
  },
  {
    "codigo":403830007,
    "descripcion":"HIPERCOLESTEROLEMIA FAMILIAR POR MUTACIÓN HOMOCIGOTA DEL RECEPTOR DE LDL"
  },
  {
    "codigo":41547006,
    "descripcion":"LESIÓN TRAUMÁTICA DE BRONQUIO SIN HERIDA ABIERTA HACIA CAVIDAD TORÁCICA"
  },
  {
    "codigo":205387007,
    "descripcion":"SÍNDROME DEL ANILLO DE CONSTRICCIÓN DE LA EXTREMIDAD INFERIOR CON AMPUTACIÓN"
  },
  {
    "codigo":74315008,
    "descripcion":"MICROEMBOLIA PULMONAR"
  },
  {
    "codigo":270923008,
    "descripcion":"HALLAZGO EN CÉLULAS GRANDES NO COLOREADAS"
  },
  {
    "codigo":400160003,
    "descripcion":"TRASTORNO DE PIEL DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":267253006,
    "descripcion":"ANOMALÍA CROMOSÓMICA FETAL"
  },
  {
    "codigo":365557009,
    "descripcion":"INGRESOS SUFICIENTES PARA CUBRIR LAS NECESIDADES - HALLAZGO"
  },
  {
    "codigo":298186005,
    "descripcion":"HIPERMOVILIDAD DE LA COLUMNA CERVICAL"
  },
  {
    "codigo":11863681000119103,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE SEGUNDO A QUINTO DEDOS DE PIE IZQUIERDO"
  },
  {
    "codigo":724170007,
    "descripcion":"SÍNDROME DE SINDACTILIA SINOSTÓSICA MESOAXIAL CON REDUCCIÓN DE FALANGES"
  },
  {
    "codigo":3274008,
    "descripcion":"TÓRAX PLANO"
  },
  {
    "codigo":34207001,
    "descripcion":"INFECCIÓN CAUSADA POR MYOBIA MUSCULI"
  },
  {
    "codigo":36042005,
    "descripcion":"NEUMOPATÍA PARIETOALVEOLAR"
  },
  {
    "codigo":296351005,
    "descripcion":"SOBREDOSIS DE NICOTINA"
  },
  {
    "codigo":294516001,
    "descripcion":"ALERGIA A AZLOCILINA"
  },
  {
    "codigo":198047009,
    "descripcion":"TORSIÓN DE APÉNDICE TESTICULAR"
  },
  {
    "codigo":720500008,
    "descripcion":"SÍNDROME DE APLASIA CUTÁNEA CONGÉNITA CON LINFANGIECTASIA INTESTINAL"
  },
  {
    "codigo":30537002,
    "descripcion":"CICATRIZ PERIFÉRICA DE POLO POSTERIOR DE RETINA DEL OJO"
  },
  {
    "codigo":423753005,
    "descripcion":"BLEFAROESPASMO REFLEJO"
  },
  {
    "codigo":816969006,
    "descripcion":"ACTIVIDAD UTERINA INEFICIENTE CON ESTIMULACIÓN CON OXITOCINA"
  },
  {
    "codigo":15713921000119108,
    "descripcion":"DEFORMIDAD EN VARO ADQUIRIDA DE PRIMEROS DEDOS DE AMBOS PIES"
  },
  {
    "codigo":63305008,
    "descripcion":"ESTRECHEZ DE ESÓFAGO"
  },
  {
    "codigo":290846001,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR NORTRIPTILINA"
  },
  {
    "codigo":94238002,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA CARINA"
  },
  {
    "codigo":127006003,
    "descripcion":"NEOPLASIA DEL OÍDO MEDIO"
  },
  {
    "codigo":92403000,
    "descripcion":"NEOPLASIA BENIGNA DE HUESO ESFENOIDES"
  },
  {
    "codigo":59635003,
    "descripcion":"TUMOR CLÍNICO (SIN CONFIRMACIÓN HISTOLÓGICA)"
  },
  {
    "codigo":714995005,
    "descripcion":"NADA"
  },
  {
    "codigo":254408000,
    "descripcion":"NEOPLASIA MALIGNA DE MARGEN LATERAL DE LENGUA"
  },
  {
    "codigo":25032009,
    "descripcion":"INTENTO FALLIDO DE ABORTO CON LACERACIÓN DEL CUELLO DEL ÚTERO"
  },
  {
    "codigo":416413003,
    "descripcion":"EMBARAZADA AÑOSA"
  },
  {
    "codigo":185202000,
    "descripcion":"ATENDIDO EN CONSULTORIO DE MÉDICO GENERAL"
  },
  {
    "codigo":1268381009,
    "descripcion":"HEMATOMA TRAUMÁTICO DE MAMA"
  },
  {
    "codigo":709490002,
    "descripcion":"DESMOSTEROLOSIS"
  },
  {
    "codigo":283506000,
    "descripcion":"HERIDA PUNZANTE DE MEJILLA"
  },
  {
    "codigo":248903000,
    "descripcion":"TROMPA DE FALOPIO PALPABLE EN EL FONDO DE SACO VAGINAL"
  },
  {
    "codigo":1332082008,
    "descripcion":"SE IDENTIFICA COMO PERSONA TRANSGÉNERO FEMENINO"
  },
  {
    "codigo":445511002,
    "descripcion":"CEFALEA ORTOSTÁTICA"
  },
  {
    "codigo":609351004,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE PIERNA CON INFECCIÓN"
  },
  {
    "codigo":1079221000119105,
    "descripcion":"NEOPLASIA BENIGNA DE HUESO DE PIE IZQUIERDO"
  },
  {
    "codigo":19527009,
    "descripcion":"EPISODIO ÚNICO DE DEPRESIÓN MAYOR EN REMISIÓN COMPLETA"
  },
  {
    "codigo":83228001,
    "descripcion":"ANOMALÍA CONGÉNITA DEL CORDÓN ESPERMÁTICO"
  },
  {
    "codigo":247068008,
    "descripcion":"AFAQUIA - CÁPSULA DEL CRISTALINO PRESENTE"
  },
  {
    "codigo":1197340009,
    "descripcion":"QUERATOSIS SEBORREICA TRAUMÁTICA"
  },
  {
    "codigo":341941000119108,
    "descripcion":"QUERATOPATÍA EN BANDA DE OJO IZQUIERDO"
  },
  {
    "codigo":472774001,
    "descripcion":"DISFUNCIÓN DE VENTRÍCULO DERECHO FETAL"
  },
  {
    "codigo":210630002,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA, VARIOS DEDOS DE LA MANO"
  },
  {
    "codigo":1259206005,
    "descripcion":"TRASTORNO NEONATAL PRECOZ DEBIDO A PARTO DE NALGAS"
  },
  {
    "codigo":14022007,
    "descripcion":"MUERTE FETAL QUE AFECTA EL MANEJO DE LA SITUACIÓN MATERNA"
  },
  {
    "codigo":767686008,
    "descripcion":"HERNIA INGUINAL IZQUIERDA IRREDUCTIBLE"
  },
  {
    "codigo":700315001,
    "descripcion":"ARTROSIS DE ARTICULACIÓN SUBASTRAGALINA SECUNDARIA A TRAUMATISMO"
  },
  {
    "codigo":733083006,
    "descripcion":"TRASTORNO CONGÉNITO DE GLICOSILACIÓN TIPO 1R"
  },
  {
    "codigo":403568001,
    "descripcion":"LIQUEN ESCLEROSO EXTRAGENITAL LOCALIZADO"
  },
  {
    "codigo":208795009,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN DE CODO, ANTERIOR"
  },
  {
    "codigo":75888001,
    "descripcion":"GLOMERULONEFRITIS MESANGIOCAPILAR, TIPO I"
  },
  {
    "codigo":239728007,
    "descripcion":"DEFICIENCIA DE LIGAMENTO LATERAL INTERNO DE RODILLA"
  },
  {
    "codigo":1352005003,
    "descripcion":"LESIÓN TRAUMÁTICA DEBIDA A ARMAMENTO MISILÍSTICO"
  },
  {
    "codigo":8517006,
    "descripcion":"EX-FUMADOR"
  },
  {
    "codigo":74053007,
    "descripcion":"LINFOMA ESTADIO IIIS"
  },
  {
    "codigo":10692841000119102,
    "descripcion":"EXCESO DE PIEL DE MUSLO"
  },
  {
    "codigo":268826001,
    "descripcion":"RUPTURA ESPLÉNICA POR TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":205125009,
    "descripcion":"POLIDACTILIA RADIAL DE WASSEL 4"
  },
  {
    "codigo":301594003,
    "descripcion":"CAPAZ DE SUBIR Y BAJAR ESCALERAS EN CUATRO PATAS"
  },
  {
    "codigo":1055258005,
    "descripcion":"AGENESIA DE EPÍFISIS DE FALANGE PROXIMAL DE DEDO MEÑIQUE"
  },
  {
    "codigo":236058006,
    "descripcion":"HERNIA DEL TENDÓN CENTRAL"
  },
  {
    "codigo":39450006,
    "descripcion":"CATARATA SENIL"
  },
  {
    "codigo":365295000,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA CONTROLAR LA INSTALACIÓN PRINCIPAL DE GAS"
  },
  {
    "codigo":37615000,
    "descripcion":"TRAQUEOBRONQUIOPATÍA OSTEOPLÁSTICA"
  },
  {
    "codigo":300296006,
    "descripcion":"LESIÓN DE ESTÓMAGO"
  },
  {
    "codigo":234223004,
    "descripcion":"INTERFERENCIA ELÉCTRICA DEL MARCAPASOS"
  },
  {
    "codigo":168687005,
    "descripcion":"RADIOGRAFÍA SIMPLE DE PIE NORMAL"
  },
  {
    "codigo":299759006,
    "descripcion":"REFLEJO DE DEGLUCIÓN PRESENTE"
  },
  {
    "codigo":15689961000119105,
    "descripcion":"ARTRITIS DE AMBAS CADERAS CAUSADA POR STAPHYLOCOCCUS"
  },
  {
    "codigo":363460002,
    "descripcion":"TUMOR MALIGNO DE GLÁNDULA PARAURETRAL"
  },
  {
    "codigo":166852004,
    "descripcion":"ELECTROFORESIS DE LIPOPROTEÍNAS DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":232388008,
    "descripcion":"NEOPLASIA DE CAVIDAD NASAL Y NASOFARINGE"
  },
  {
    "codigo":230553002,
    "descripcion":"NEUROPATÍA SENSITIVA AUTOSÓMICA DOMINANTE"
  },
  {
    "codigo":344451000119102,
    "descripcion":"PIGMENTACIÓN DE SUPERFICIE POSTERIOR DE CÓRNEA DE AMBOS OJOS"
  },
  {
    "codigo":427161009,
    "descripcion":"ORIENTADO EN ESPACIO"
  },
  {
    "codigo":294254002,
    "descripcion":"ALERGIA A GEMEPROST"
  },
  {
    "codigo":32110003,
    "descripcion":"TRASTORNO DEL ANO"
  },
  {
    "codigo":425326006,
    "descripcion":"MEDIOS INSUFICIENTES PARA LA ENTRADA AL LUGAR DE RESIDENCIA"
  },
  {
    "codigo":30275001,
    "descripcion":"RIÑÓN ACCESORIO"
  },
  {
    "codigo":63043004,
    "descripcion":"LESIÓN TRAUMÁTICA DE ARTERIA"
  },
  {
    "codigo":292419005,
    "descripcion":"REACCIÓN ADVERSA A BETABLOQUEANTE"
  },
  {
    "codigo":718403007,
    "descripcion":"DIURESIS DISMINUIDA"
  },
  {
    "codigo":1144387007,
    "descripcion":"ATROFIA DE VERMIS CEREBELOSO"
  },
  {
    "codigo":95811009,
    "descripcion":"ABSCESO DE CONDUCTO AUDITIVO EXTERNO"
  },
  {
    "codigo":421656001,
    "descripcion":"BRADICARDIA - FRECUENCIA CARDÍACA FETAL BASAL"
  },
  {
    "codigo":290584002,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR BUSULFANO"
  },
  {
    "codigo":126744007,
    "descripcion":"NEOPLASIA DE VASO SANGUÍNEO DE ANTEBRAZO"
  },
  {
    "codigo":225048008,
    "descripcion":"SALTAR DESDE LAS ALTURAS"
  },
  {
    "codigo":93976007,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL ANTRO PILÓRICO"
  },
  {
    "codigo":92141004,
    "descripcion":"NEOPLASIA BENIGNA DE LOS GANGLIOS LINFÁTICOS ILÍACOS"
  },
  {
    "codigo":254146000,
    "descripcion":"MIOFIBROMATOSIS INFANTIL"
  },
  {
    "codigo":90306000,
    "descripcion":"PRUEBA DE PARTO"
  },
  {
    "codigo":24770006,
    "descripcion":"SIGNO DE MUSSET"
  },
  {
    "codigo":1204418008,
    "descripcion":"PARÁLISIS CONGÉNITA DEL CUARTO NERVIO CRANEAL"
  },
  {
    "codigo":22935002,
    "descripcion":"PORFIRIA ERITROPOYÉTICA CONGÉNITA"
  },
  {
    "codigo":448919005,
    "descripcion":"DEFECTO DEL TABIQUE AURICULOVENTRICULAR CON COMPONENTE VENTRICULAR POR DEBAJO DE VALVA EN PUENTE SUPERIOR SIN FIJACIÓN DE CUERDAS TENDINOSAS A CRESTA DE TABIQUE VENTRICULAR"
  },
  {
    "codigo":88471006,
    "descripcion":"MARCHA EN TRES APOYOS"
  },
  {
    "codigo":184940001,
    "descripcion":"EXAMEN DE CONDUCTOR DE VEHÍCULO TAXÍMETRO - COMPLETADO"
  },
  {
    "codigo":840300001,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR INSULINA HUMANA"
  },
  {
    "codigo":53868003,
    "descripcion":"SÍNDROME MEDULAR ANTERIOR DEBIDO A FRACTURA NO EXPUESTA A NIVEL DE C1-C4"
  },
  {
    "codigo":283244008,
    "descripcion":"VIDRIO EN EL HOMBRO"
  },
  {
    "codigo":19265001,
    "descripcion":"TULAREMIA"
  },
  {
    "codigo":445249002,
    "descripcion":"NÓDULOS PULMONARES MÚLTIPLES"
  },
  {
    "codigo":1231681002,
    "descripcion":"SÍNDROME OCULOGLANDULAR DE PARINAUD"
  },
  {
    "codigo":707393007,
    "descripcion":"CARCINOMA ADENOESCAMOSO PRIMARIO DE TRÁQUEA"
  },
  {
    "codigo":84801008,
    "descripcion":"SÍNDROME DE JACCOUD"
  },
  {
    "codigo":248641009,
    "descripcion":"TRACCIÓN DEL BRAZO QUE OBSTRUYE EL PULSO RADIAL"
  },
  {
    "codigo":246806002,
    "descripcion":"INYECCIÓN EN LA CARÚNCULA LAGRIMAL"
  },
  {
    "codigo":82966003,
    "descripcion":"ANGIOEDEMA HEREDITARIO"
  },
  {
    "codigo":115734000,
    "descripcion":"GRUPO SANGUÍNEO O>H<BOMBAY TIPO REUNION"
  },
  {
    "codigo":291511000119103,
    "descripcion":"HEMORRAGIA ESPONTÁNEA DE REGIÓN PROFUNDA DE HEMISFERIO CEREBRAL"
  },
  {
    "codigo":443414005,
    "descripcion":"CORAZÓN BOVINO"
  },
  {
    "codigo":25921000175100,
    "descripcion":"PESTAÑA NORMAL"
  },
  {
    "codigo":212203008,
    "descripcion":"LESIÓN DE LA RAÍZ DEL NERVIO CERVICAL - C7"
  },
  {
    "codigo":210368005,
    "descripcion":"HERIDAS ABIERTAS MÚLTIPLES DE LA BOCA"
  },
  {
    "codigo":346961000119100,
    "descripcion":"CALCOSIS OCULAR BILATERAL"
  },
  {
    "codigo":110229001,
    "descripcion":"QUEMADURA OROFARÍNGEA DE TERCER GRADO"
  },
  {
    "codigo":700053002,
    "descripcion":"SEPSIS ASOCIADA CON SÍNDROME DE INMUNODEFICIENCIA ADQUIRIDA"
  },
  {
    "codigo":10750801000119102,
    "descripcion":"FALSO TRABAJO DE PARTO ANTES DE COMPLETAR 37 SEMANAS DE GESTACIÓN"
  },
  {
    "codigo":863893009,
    "descripcion":"QUEMADURA EN LUGAR DE APLICACIÓN"
  },
  {
    "codigo":1255274002,
    "descripcion":"MIOPATÍA CONGÉNITA CON REDUCCIÓN DE FIBRAS MUSCULARES DE TIPO 2"
  },
  {
    "codigo":403306001,
    "descripcion":"PTERIGIÓN ADQUIRIDO DE LA UÑA"
  },
  {
    "codigo":370538004,
    "descripcion":"DEFICIENCIA DE YIN"
  },
  {
    "codigo":763754008,
    "descripcion":"FISURA DE LABIO INCOMPLETA IZQUIERDA"
  },
  {
    "codigo":237631006,
    "descripcion":"NEUROGLUCOPENIA"
  },
  {
    "codigo":792852000,
    "descripcion":"ÚLCERA ISQUÉMICA DE PORCIÓN MEDIA DE PIE DEBIDA A ATEROSCLEROSIS DE ARTERIA DE MIEMBRO INFERIOR"
  },
  {
    "codigo":301332001,
    "descripcion":"HALLAZGO RELACIONADO CON EL PERCENTILO DE PESO AL NACER"
  },
  {
    "codigo":170260004,
    "descripcion":"EXAMEN DEL NIÑO AL AÑO: ANORMAL - DERIVADO"
  },
  {
    "codigo":203028006,
    "descripcion":"ABSCESO MUSCULAR DE PIERNA"
  },
  {
    "codigo":235796008,
    "descripcion":"ENFERMEDAD DE CROHN PERIANAL"
  },
  {
    "codigo":233961000,
    "descripcion":"ISQUEMIA DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":365033002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA COMUNICARSE"
  },
  {
    "codigo":102889008,
    "descripcion":"DESARROLLO PREMATURO DE LAS MAMAS"
  },
  {
    "codigo":232126000,
    "descripcion":"HIPERMETROPÍA LATENTE"
  },
  {
    "codigo":295827000,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE BROMOCRIPTINA"
  },
  {
    "codigo":230291001,
    "descripcion":"ENFERMEDAD DE PARKINSON JUVENIL"
  },
  {
    "codigo":263059002,
    "descripcion":"SUBLUXACIÓN DE ARTICULACIÓN FEMORORROTULIANA"
  },
  {
    "codigo":220767211000119104,
    "descripcion":"FRACTURA PATOLÓGICA DE PIE DERECHO DEBIDA A OSTEOPETROSIS"
  },
  {
    "codigo":66451004,
    "descripcion":"AMILOIDOSIS VISCERAL FAMILIAR, TIPO OSTERTAG"
  },
  {
    "codigo":426899007,
    "descripcion":"DOLOR PROVOCADO POR CAMINAR"
  },
  {
    "codigo":293992000,
    "descripcion":"ALERGIA A TERAZOSINA"
  },
  {
    "codigo":719976001,
    "descripcion":"SÍNDROME DE GLAUCOMA Y APNEA DEL SUEÑO"
  },
  {
    "codigo":42621000087105,
    "descripcion":"HERIDA PUNZANTE DE REGIÓN DE CODO DERECHO CON CUERPO EXTRAÑO"
  },
  {
    "codigo":40061000087106,
    "descripcion":"FRACTURA DE CÓNDILO LATERAL DE TIBIA DERECHA"
  },
  {
    "codigo":47741000087108,
    "descripcion":"FRACTURA DE SÉPTIMA COSTILLA IZQUIERDA"
  },
  {
    "codigo":425064003,
    "descripcion":"FRECUENCIA DE DEFECACIÓN ANORMAL"
  },
  {
    "codigo":31848007,
    "descripcion":"SÍNDROME CREST"
  },
  {
    "codigo":95549001,
    "descripcion":"HEMORRAGIA RETROPERITONEAL"
  },
  {
    "codigo":292157002,
    "descripcion":"REACCIÓN ADVERSA AL ÁCIDO QUENODEOXICÓLICO"
  },
  {
    "codigo":423229003,
    "descripcion":"PELIGRO DE TRÁNSITO EN EL AMBIENTE"
  },
  {
    "codigo":62781006,
    "descripcion":"DESTRUCCIÓN DE PLAQUETAS AUMENTADA"
  },
  {
    "codigo":718141008,
    "descripcion":"SÍNDROME NEFRÓTICO RESISTENTE A ESTEROIDES GENÉTICO"
  },
  {
    "codigo":716306006,
    "descripcion":"ALTERACIÓN ADQUIRIDA DE LA COMPRENSIÓN DE IDIOMA"
  },
  {
    "codigo":421394009,
    "descripcion":"TRASTORNO CUTÁNEO CON SIDA (SÍNDROME DE INMUNODEFICIENCIA ADQUIRIDA)"
  },
  {
    "codigo":93714009,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE VASO SANGUÍNEO"
  },
  {
    "codigo":91879008,
    "descripcion":"AUSENCIA CONGÉNITA DEL ARCO DE LA VÉRTEBRA CERVICAL"
  },
  {
    "codigo":253884000,
    "descripcion":"RIÑÓN CON MÉDULA ESPONJOSA Y NEFROCALCINOSIS"
  },
  {
    "codigo":1204156004,
    "descripcion":"ESTENOSIS ASINTOMÁTICA DE ARTERIA CARÓTIDA INTRACRANEAL"
  },
  {
    "codigo":286652007,
    "descripcion":"AUTODESTRUCCIÓN"
  },
  {
    "codigo":284817000,
    "descripcion":"INCAPAZ DE PARARSE EN LA BAÑERA"
  },
  {
    "codigo":384956009,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA VASCULAR AFECTADO POR NEOPLASIA MALIGNA"
  },
  {
    "codigo":350353007,
    "descripcion":"SÍNDROME DE DE VAAL"
  },
  {
    "codigo":282982000,
    "descripcion":"SE ARRODILLA"
  },
  {
    "codigo":1003878004,
    "descripcion":"DUPLICACIÓN DE PORCIÓN PROXIMAL DEL BRAZO LARGO DEL CROMOSOMA 16"
  },
  {
    "codigo":707131004,
    "descripcion":"URETRITIS POLIPOIDE"
  },
  {
    "codigo":313915006,
    "descripcion":"TRASTORNO MENTAL ORGÁNICO INDUCIDO POR HIPNÓTICO"
  },
  {
    "codigo":51771007,
    "descripcion":"SÍNDROME DE FATIGA POSTVIRAL"
  },
  {
    "codigo":1086751000119105,
    "descripcion":"FÍSTULA DE ENTEROSTOMÍA"
  },
  {
    "codigo":248379009,
    "descripcion":"CRÁNEO CORTO"
  },
  {
    "codigo":1264187008,
    "descripcion":"TRASTORNO FETAL CAUSADO POR TRANSFERENCIA PLACENTARIA DE ANESTESIA MATERNA"
  },
  {
    "codigo":246544003,
    "descripcion":"CRISIS EPILÉPTICA FOCAL CON PROGRESIÓN A CRISIS TÓNICO-CLÓNICA BILATERAL"
  },
  {
    "codigo":1196816000,
    "descripcion":"NEOPLASIA INTRAEPITELIAL GLANDULAR DE BAJO GRADO DE DUODENO"
  },
  {
    "codigo":310245002,
    "descripcion":"DIETA DE DESTETE"
  },
  {
    "codigo":210106000,
    "descripcion":"LESIÓN TRAUMÁTICA INTRATORÁCICA MULTIORGÁNICA CON HERIDA ABIERTA HACIA CAVIDAD"
  },
  {
    "codigo":79034004,
    "descripcion":"DETERMINACIÓN DEL ESTADO DEL PACIENTE, ESTADO CRÍTICO"
  },
  {
    "codigo":111802007,
    "descripcion":"INTOXICACIÓN ALIMENTARIA CAUSADA POR CLOSTRIDIA"
  },
  {
    "codigo":275642007,
    "descripcion":"CONSULTA O HA CONSULTADO A UN NUTRICIONISTA"
  },
  {
    "codigo":765327005,
    "descripcion":"SÍNDROME DE ANEMIA SIDEROBLÁSTICA CONGÉNITA, INMUNODEFICIENCIA DE LINFOCITOS B, FIEBRE PERIÓDICA Y RETRASO DEL DESARROLLO"
  },
  {
    "codigo":372111007,
    "descripcion":"CARCINOMA DE LÓBULO INFERIOR DE PULMÓN"
  },
  {
    "codigo":208271008,
    "descripcion":"FRACTURA NO EXPUESTA DE HÚMERO DISTAL, EPICÓNDILO EXTERNO"
  },
  {
    "codigo":1255012001,
    "descripcion":"DEPENDENCIA COMBINADA DE SUSTANCIAS, CONTINUA"
  },
  {
    "codigo":403044000,
    "descripcion":"TIÑA CORPORAL CAUSADA POR TRICHOPHYTON VIOLACEUM"
  },
  {
    "codigo":109967007,
    "descripcion":"LINFOMA NO HODGKINIANO DIFUSO, DE CÉLULAS HENDIDAS PEQUEÑAS (CLÍNICO)"
  },
  {
    "codigo":271972006,
    "descripcion":"TRASTORNO CON LA SONDA VESICAL"
  },
  {
    "codigo":9828009,
    "descripcion":"CORTOCIRCUITO DE AURÍCULA DERECHA A VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":239204009,
    "descripcion":"COMPRESIÓN ARTERIAL EXTRÍNSECA DEL COLGAJO"
  },
  {
    "codigo":1187641001,
    "descripcion":"INFLAMACIÓN CRÓNICA DE INTESTINO DELGADO CAUSADA POR RADIACIÓN"
  },
  {
    "codigo":302905001,
    "descripcion":"OTOMICOSIS POR ASPERGILLUS"
  },
  {
    "codigo":75364009,
    "descripcion":"DIPLOPÍA REFRACTARIA"
  },
  {
    "codigo":323001000119107,
    "descripcion":"PULGAR EN GATILLO DE MANO IZQUIERDA"
  },
  {
    "codigo":1351481003,
    "descripcion":"HIPOFORIA COMITANTE"
  },
  {
    "codigo":169998003,
    "descripcion":"ALIMENTADO ARTIFICIALMENTE AL AÑO"
  },
  {
    "codigo":268302006,
    "descripcion":"GLÁNDULA TIROIDES ABERRANTE"
  },
  {
    "codigo":366606007,
    "descripcion":"PRUEBA DEL CAJÓN POSTERIOR - HALLAZGO"
  },
  {
    "codigo":399374009,
    "descripcion":"METÁSTASIS DE GANGLIO LINFÁTICO REGIONAL PRESENTE"
  },
  {
    "codigo":102627005,
    "descripcion":"DOLOR A LA PALPACIÓN EN HÍGADO"
  },
  {
    "codigo":364771008,
    "descripcion":"ALIMENTACIÓN DEL LACTANTE A LAS 6 SEMANAS - HALLAZGO"
  },
  {
    "codigo":11847251000119105,
    "descripcion":"ABRASIÓN DE PIEL DE LABIO"
  },
  {
    "codigo":231864002,
    "descripcion":"CONJUNTIVITIS ARTEFACTA"
  },
  {
    "codigo":233699009,
    "descripcion":"ALVEOLITIS POR PIRETRO"
  },
  {
    "codigo":723384004,
    "descripcion":"SUSCEPTIBILIDAD MENDELIANA A ENFERMEDAD POR MICOBACTERIAS DEBIDA A DEFICIENCIA COMPLETA DEL GEN 15 ESTIMULADO POR INTERFERÓN"
  },
  {
    "codigo":395704004,
    "descripcion":"DISFUNCIÓN DIASTÓLICA DE VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":428472008,
    "descripcion":"PÓLIPO DE COLON SIGMOIDE"
  },
  {
    "codigo":788920008,
    "descripcion":"QUISTE EXTERNO DE GLÁNDULA DE MEIBOMIO"
  },
  {
    "codigo":262797004,
    "descripcion":"HEMATOMA SUBCAPSULAR DEL HÍGADO"
  },
  {
    "codigo":426637005,
    "descripcion":"ENFERMEDAD DE LYME AGUDA"
  },
  {
    "codigo":721549006,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE APARATO LAGRIMAL"
  },
  {
    "codigo":33421006,
    "descripcion":"INFECCIÓN CAUSADA POR PARAMPHISTOMUM"
  },
  {
    "codigo":162658001,
    "descripcion":"RESOLUCIÓN DE LA EPILEPSIA"
  },
  {
    "codigo":195426004,
    "descripcion":"TROMBOFLEBITIS DE LA VENA ILÍACA INTERNA"
  },
  {
    "codigo":424802006,
    "descripcion":"ANGIODISPLASIA DE ESTÓMAGO"
  },
  {
    "codigo":129890008,
    "descripcion":"TRASTORNO MUSCULOESQUELÉTICO"
  },
  {
    "codigo":783415001,
    "descripcion":"ANEURISMA DE BIFURCACIÓN DE CARÓTIDA INTERNA"
  },
  {
    "codigo":717879004,
    "descripcion":"ÚLCERA DUODENAL LINFOCÍTICA"
  },
  {
    "codigo":128055005,
    "descripcion":"TROMBOSIS VENOSA PROFUNDA DE LAS VENAS PÉLVICAS"
  },
  {
    "codigo":816183007,
    "descripcion":"EDEMA DE MIEMBRO INFERIOR DERECHO"
  },
  {
    "codigo":1089261000119105,
    "descripcion":"ACÚFENO PULSÁTIL OBJETIVO DEL OÍDO IZQUIERDO"
  },
  {
    "codigo":160823009,
    "descripcion":"PROBLEMA DE RELACIÓN CON EL NOVIO"
  },
  {
    "codigo":95287008,
    "descripcion":"CALCÁNEO SUPERNUMERARIO"
  },
  {
    "codigo":60684003,
    "descripcion":"SÍNDROME DE SINOVITIS - ACNÉ - PUSTULOSIS - HIPEROSTOSIS - OSTEOMIELITIS (SAPHO)"
  },
  {
    "codigo":290060003,
    "descripcion":"HALLAZGO RELACIONADO CON LA CONSISTENCIA DE LA MAMA"
  },
  {
    "codigo":27916005,
    "descripcion":"ABSCESO DE HÍGADO"
  },
  {
    "codigo":421132004,
    "descripcion":"DISFUNCIÓN PLAQUETARIA ASOCIADA CON UREMIA"
  },
  {
    "codigo":93452009,
    "descripcion":"TEJIDO SUPRARRENAL EXTRACAPSULAR"
  },
  {
    "codigo":26081002,
    "descripcion":"INFECCIÓN CAUSADA POR CRYPTOSPORIDIUM CROTALIS"
  },
  {
    "codigo":1172961006,
    "descripcion":"ENFERMEDAD GINGIVAL EXACERBADA POR TRASTORNO DE COMPONENTE CELULAR SANGUÍNEO"
  },
  {
    "codigo":1304033006,
    "descripcion":"GLAUCOMA DE ÁNGULO CERRADO DE OJO DERECHO POSOPERATORIO"
  },
  {
    "codigo":253622001,
    "descripcion":"HIPOPLASIA DEL TRONCO PULMONAR"
  },
  {
    "codigo":1269430006,
    "descripcion":"STENT METÁLICO SIN CUBIERTA EN ARTERIA CORONARIA"
  },
  {
    "codigo":286390006,
    "descripcion":"DIFICULTAD PARA INICIAR LA EMISIÓN DE PALABRAS"
  },
  {
    "codigo":57014008,
    "descripcion":"FÍSTULA COLI CONGÉNITA"
  },
  {
    "codigo":219019005,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR RELAJANTES DE MÚSCULO ESQUELÉTICO"
  },
  {
    "codigo":1003616006,
    "descripcion":"SOSPECHA DE GLAUCOMA DE ÁNGULO ABIERTO DE OJO DERECHO"
  },
  {
    "codigo":706869001,
    "descripcion":"CONOCIMIENTO DEFICIENTE SOBRE MEDICACIÓN"
  },
  {
    "codigo":315488009,
    "descripcion":"NACIDO EN NUEVA ZELANDA"
  },
  {
    "codigo":870709006,
    "descripcion":"INCAPAZ DE PARTICIPAR EN VIDA SOCIAL COMUNITARIA"
  },
  {
    "codigo":51509007,
    "descripcion":"PERIAPENDICITIS"
  },
  {
    "codigo":444725008,
    "descripcion":"DILATACIÓN QUÍSTICA DE GLÁNDULA PARAURETRAL"
  },
  {
    "codigo":279050005,
    "descripcion":"DOLOR POSHERNIORRAFIA"
  },
  {
    "codigo":703199001,
    "descripcion":"HEMANGIOMA LARINGOTRAQUEAL"
  },
  {
    "codigo":277215002,
    "descripcion":"SONIDO LATERALIZADO HACIA EL OÍDO NO AFECTADO"
  },
  {
    "codigo":373684000,
    "descripcion":"NINGÚN ORGANISMO VIVO IDENTIFICADO"
  },
  {
    "codigo":13236000,
    "descripcion":"ESPONDILOLISTESIS CONGÉNITA"
  },
  {
    "codigo":275380002,
    "descripcion":"LESIÓN PÉLVICA INTERNA"
  },
  {
    "codigo":299041000119106,
    "descripcion":"HEMARTROSIS DE CODO IZQUIERDO"
  },
  {
    "codigo":208009002,
    "descripcion":"FRACTURA VERTEBRAL NO EXPUESTA CON LESIÓN POSTERIOR DE MÉDULA ESPINAL CERVICAL, C5-7"
  },
  {
    "codigo":699529005,
    "descripcion":"EMBOLIA DE SULFATO DE BARIO"
  },
  {
    "codigo":1354889007,
    "descripcion":"PÉRDIDA DE AGUA EN RESIDENCIA"
  },
  {
    "codigo":1287518000,
    "descripcion":"ABRASIÓN DE PIEL DE VULVA"
  },
  {
    "codigo":44169009,
    "descripcion":"AUSENCIA DEL SENTIDO DEL OLFATO"
  },
  {
    "codigo":238942002,
    "descripcion":"ENFERMEDAD DE INMUNOGLOBULINA A LINEAL DEL ADULTO"
  },
  {
    "codigo":109705008,
    "descripcion":"ESCALONAMIENTO ÓSEO ALVEOLAR LABIAL"
  },
  {
    "codigo":1156446004,
    "descripcion":"DEMUESTRA CONTROL DE DOLOR ADECUADO"
  },
  {
    "codigo":240777009,
    "descripcion":"SEUDOALLESCHERIOSIS DISEMINADA"
  },
  {
    "codigo":402782006,
    "descripcion":"SEUDOXANTOMA ELÁSTICO HEREDITARIO"
  },
  {
    "codigo":271710002,
    "descripcion":"ESOTROPÍA PARCIALMENTE ACOMODATIVA"
  },
  {
    "codigo":1254750009,
    "descripcion":"METÁSTASIS DE CARCINOMA ESCAMOSO ACANTOLÍTICO EN PIEL"
  },
  {
    "codigo":1187379001,
    "descripcion":"ADENOMA"
  },
  {
    "codigo":69427008,
    "descripcion":"FRACTURA EXPUESTA DE CABEZA DE RADIO"
  },
  {
    "codigo":10743831000119100,
    "descripcion":"NEOPLASIA DE ÚTERO QUE AFECTA EL EMBARAZO"
  },
  {
    "codigo":16014871000119101,
    "descripcion":"OCLUSIÓN DE ARTERIA FEMORAL DERECHA"
  },
  {
    "codigo":299031000119102,
    "descripcion":"HEMARTROSIS DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":16050711000119102,
    "descripcion":"TRASTORNO DE AMBAS ARTICULACIONES GLENOHUMERALES POSTERIOR A VACUNACIÓN"
  },
  {
    "codigo":332311000119104,
    "descripcion":"ÚLCERA CORNEAL EN ANILLO DE OJO DERECHO"
  },
  {
    "codigo":337431000119100,
    "descripcion":"DESPRENDIMIENTO DE RETINA IZQUIERDA POR TRACCIÓN"
  },
  {
    "codigo":10759191000119106,
    "descripcion":"TROMBOFLEBITIS SÉPTICA EN EL PUERPERIO"
  },
  {
    "codigo":504145431000119104,
    "descripcion":"STENT EN RAMA DE ARTERIA CORONARIA IZQUIERDA"
  },
  {
    "codigo":677911000119108,
    "descripcion":"AGUJERO MACULAR DE ESPESOR COMPLETO DE OJO IZQUIERDO"
  },
  {
    "codigo":291351000119109,
    "descripcion":"HEMORRAGIA ESPONTÁNEA DE ARTERIA BASILAR EN ESPACIO SUBARACNOIDEO"
  },
  {
    "codigo":314391000119109,
    "descripcion":"ESCOLIOSIS NEUROMUSCULAR DORSAL"
  },
  {
    "codigo":688151000119102,
    "descripcion":"NEURILEMOMA DE NERVIO DE LA CABEZA"
  },
  {
    "codigo":10641431000119109,
    "descripcion":"OSTEONECROSIS DE HUESO DE PIERNA DEBIDA A ÚLCERA CRÓNICA DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":399112009,
    "descripcion":"ARTRITIS SERONEGATIVA"
  },
  {
    "codigo":15989271000119107,
    "descripcion":"CONJUNTIVITIS DE OJO DERECHO CAUSADA POR VIRUS HERPES ZÓSTER"
  },
  {
    "codigo":300808006,
    "descripcion":"DIFICULTAD PARA DEDICARSE A ACTIVIDADES RELIGIOSAS"
  },
  {
    "codigo":16035351000119107,
    "descripcion":"OSTEÓLISIS DE HÚMERO IZQUIERDO"
  },
  {
    "codigo":200669000,
    "descripcion":"CELULITIS Y ABSCESO DE CODO"
  },
  {
    "codigo":16058391000119109,
    "descripcion":"TRASTORNO DE PLEXO LUMBOSACRO DERECHO"
  },
  {
    "codigo":366344009,
    "descripcion":"HALLAZGO RELACIONADO CON EL LUGAR DE NACIMIENTO"
  },
  {
    "codigo":341000119102,
    "descripcion":"TATUAJE DE PIEL"
  },
  {
    "codigo":297138001,
    "descripcion":"ÉMBOLO DEL POLÍGONO DE WILLIS"
  },
  {
    "codigo":724957004,
    "descripcion":"DISTENSIÓN DE FASCIA DE MÚSCULO FLEXOR DE DEDO DE LA MANO A LA ALTURA DEL ANTEBRAZO"
  },
  {
    "codigo":167901007,
    "descripcion":"LÍQUIDO SINOVIAL: CÉLULAS LE"
  },
  {
    "codigo":723122006,
    "descripcion":"TRASTORNO DE TIC PRIMARIO"
  },
  {
    "codigo":196999001,
    "descripcion":"ÉMBOLO DE ARTERIA MESENTÉRICA SUPERIOR"
  },
  {
    "codigo":721287004,
    "descripcion":"HIPOPARATIROIDISMO POSTERIOR A PROCEDIMIENTO"
  },
  {
    "codigo":65927007,
    "descripcion":"AGOTAMIENTO MUSCULAR DE BAJA FRECUENCIA"
  },
  {
    "codigo":295303009,
    "descripcion":"SOBREDOSIS DE ÁCIDO TIAPROFÉNICO"
  },
  {
    "codigo":293468001,
    "descripcion":"REACCIÓN ADVERSA A DIURÉTICO AHORRADOR DE POTASIO"
  },
  {
    "codigo":424540004,
    "descripcion":"NO SIGUE LA PAUTA POSOLÓGICA RECOMENDADA"
  },
  {
    "codigo":719452004,
    "descripcion":"FÍSTULA BRONCOBILIAR CONGÉNITA"
  },
  {
    "codigo":129628007,
    "descripcion":"LABERINTITIS RECURRENTE"
  },
  {
    "codigo":291633003,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR CEFPIROMA"
  },
  {
    "codigo":226097005,
    "descripcion":"DIETA RICA EN GRASAS"
  },
  {
    "codigo":29489007,
    "descripcion":"EJE DEL ECG PERPENDICULAR AL PLANO FRONTAL"
  },
  {
    "codigo":193329008,
    "descripcion":"RETINOSQUISIS Y QUISTES RETINIANOS"
  },
  {
    "codigo":95025009,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA PELVIS RENAL"
  },
  {
    "codigo":224262000,
    "descripcion":"HOGAR EN BUEN ESTADO DE REPARACIÓN"
  },
  {
    "codigo":191494004,
    "descripcion":"SÍNDROME AMNÉSICO MEDICAMENTOSO"
  },
  {
    "codigo":124123000,
    "descripcion":"DEFICIENCIA DE ACETOACETIL - COA REDUCTASA"
  },
  {
    "codigo":1172699002,
    "descripcion":"TROMBOCITOPENIA HEREDITARIA CON MIELOFIBROSIS DE INICIO TEMPRANO"
  },
  {
    "codigo":255195007,
    "descripcion":"NEOPLASIA BENIGNA DE PARTES BLANDAS DE CABEZA, CARA Y CUELLO"
  },
  {
    "codigo":253360001,
    "descripcion":"HIPOPLASIA DE LA AURÍCULA IZQUIERDA"
  },
  {
    "codigo":417200003,
    "descripcion":"INCLINACIÓN DESCENDENTE DE HUESO INNOMINADO"
  },
  {
    "codigo":251525000,
    "descripcion":"ACTIVIDAD ELECTROMIOGRÁFICA ESPONTÁNEA"
  },
  {
    "codigo":187824009,
    "descripcion":"NEOPLASIA MALIGNA DE LOCALIZACIONES SUPERPUESTAS DEL APARATO DIGESTIVO"
  },
  {
    "codigo":22149007,
    "descripcion":"SENOS DE ASCHOFF - ROKITANSKY"
  },
  {
    "codigo":827059006,
    "descripcion":"REFLEJOS BICIPITALES DESIGUALES"
  },
  {
    "codigo":249690001,
    "descripcion":"PSEUDOARTROSIS DE CLAVÍCULA"
  },
  {
    "codigo":282458002,
    "descripcion":"SECCIÓN DE LARINGE"
  },
  {
    "codigo":446298003,
    "descripcion":"FRACTURA NO EXPUESTA DE PILÓN TIBIAL"
  },
  {
    "codigo":118618005,
    "descripcion":"MICOSIS FUNGOIDE"
  },
  {
    "codigo":1263663000,
    "descripcion":"BLOQUEO DE ARTICULACIÓN INTERFALÁNGICA DE DEDO PULGAR EN FLEXIÓN FIJA EN EDAD PEDIÁTRICA"
  },
  {
    "codigo":51247001,
    "descripcion":"URTICARIA VIBRATORIA"
  },
  {
    "codigo":247855001,
    "descripcion":"TEMOR ASOCIADO CON LA ENFERMEDAD Y LA FUNCIÓN DEL ORGANISMO"
  },
  {
    "codigo":772143002,
    "descripcion":"OBSTRUCCIÓN CONCOMITANTE CON HERNIA INGUINAL IZQUIERDA Y DEBIDA A ELLA"
  },
  {
    "codigo":315226008,
    "descripcion":"DOLOR EN GANGLIOS LINFÁTICOS LUEGO DEL CONSUMO DE ALCOHOL"
  },
  {
    "codigo":16747341000119101,
    "descripcion":"RETINOPATÍA NO PROLIFERATIVA SEVERA DE OJO DERECHO DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":16644004,
    "descripcion":"NEUROPATÍA RADIAL"
  },
  {
    "codigo":1163524004,
    "descripcion":"INTOXICACIÓN ALIMENTARIA POR CLOSTRIDIUM DIFFICILE"
  },
  {
    "codigo":82180009,
    "descripcion":"HEMIANOPÍA CUADRÁNTICA"
  },
  {
    "codigo":15676041000119107,
    "descripcion":"TENOSINOVITIS BILATERAL DE MUÑECA"
  },
  {
    "codigo":2851000119101,
    "descripcion":"DEFICIENCIA DE HORMONA DE HIPÓFISIS ANTERIOR"
  },
  {
    "codigo":276953005,
    "descripcion":"CARCINOMA ESCAMOSO DE LAS ENCÍAS"
  },
  {
    "codigo":31027006,
    "descripcion":"TRASTORNO ESQUIZOTÍPICO DE LA PERSONALIDAD"
  },
  {
    "codigo":768473009,
    "descripcion":"SÍNDROME DE PROTEÍNA A FIJADORA DE ELEMENTOS RICOS EN PURINA"
  },
  {
    "codigo":111278002,
    "descripcion":"EDEMA DE GLOTIS"
  },
  {
    "codigo":1290926003,
    "descripcion":"ICTERICIA FETAL CAUSADA POR SUSTANCIA TRANSMITIDA POR MADRE"
  },
  {
    "codigo":702937009,
    "descripcion":"AGROBACTERIUM RADIOBACTER O AGROBACTERIUM TUMEFACIENS"
  },
  {
    "codigo":373422007,
    "descripcion":"SÍNDROME URÉMICO HEMOLÍTICO SIN DIARREA"
  },
  {
    "codigo":240515005,
    "descripcion":"FIEBRE POR VIRUS DEL GRUPO UUKIUNIEMI"
  },
  {
    "codigo":699267007,
    "descripcion":"MIOPATÍA POR ALMACENAMIENTO DE MIOSINA"
  },
  {
    "codigo":304216000,
    "descripcion":"PACIENTE CON TARJETA DE DONANTE"
  },
  {
    "codigo":109443007,
    "descripcion":"ANODONCIA DE DENTICIÓN PRIMARIA"
  },
  {
    "codigo":1156184000,
    "descripcion":"METATARSO PRIMUS VARO DE PIE IZQUIERDO"
  },
  {
    "codigo":238680003,
    "descripcion":"SARCOIDOSIS PAPULAR"
  },
  {
    "codigo":402520003,
    "descripcion":"CARCINOMA BASOCELULAR DE LA MANO"
  },
  {
    "codigo":1354627009,
    "descripcion":"FRACTURA DE PRIMER HUESO METATARSIANO"
  },
  {
    "codigo":369752008,
    "descripcion":"CONFIGURACIÓN TUMORAL INFILTRANTE"
  },
  {
    "codigo":40237004,
    "descripcion":"INFECCIÓN CAUSADA POR GONGYLONEMA NEOPLASTICUM"
  },
  {
    "codigo":202242000,
    "descripcion":"LUXACIÓN RECURRENTE DE ARTICULACIÓN INTERFALÁNGICA"
  },
  {
    "codigo":890370003,
    "descripcion":"MEGACALICOSIS CONGÉNITA BILATERAL"
  },
  {
    "codigo":235010005,
    "descripcion":"PERIODONTITIS ULCEROSA NECROSANTE AGUDA"
  },
  {
    "codigo":267778006,
    "descripcion":"CELULITIS Y ABSCESO DE NARIZ (PORCIÓN EXTERNA)"
  },
  {
    "codigo":366082007,
    "descripcion":"CONVERGENCIA OCULAR - HALLAZGO"
  },
  {
    "codigo":397015000,
    "descripcion":"MASTOCITOSIS SISTÉMICA CON ENFERMEDAD CLONAL ASOCIADA DE LINAJE CELULAR HEMATOLÓGICO NO MASTOCÍTICO"
  },
  {
    "codigo":298711002,
    "descripcion":"HALLAZGO RELACIONADO CON LAS PROPORCIONES DEL TÓRAX"
  },
  {
    "codigo":822999003,
    "descripcion":"COSTRA DE PUS CUTÁNEA"
  },
  {
    "codigo":429783005,
    "descripcion":"PARESTESIA DE MIEMBRO INFERIOR"
  },
  {
    "codigo":283571009,
    "descripcion":"HERIDA DE PERDIGÓN EN TRONCO"
  },
  {
    "codigo":722860006,
    "descripcion":"SURCO PERINEAL CONGÉNITO"
  },
  {
    "codigo":10681431000119101,
    "descripcion":"NÓDULO DE PIEL DE CUELLO"
  },
  {
    "codigo":1343617003,
    "descripcion":"MELANOMA MALIGNO DE CARA"
  },
  {
    "codigo":129007,
    "descripcion":"HOMEOTERMIA"
  },
  {
    "codigo":424278001,
    "descripcion":"HECES SECAS"
  },
  {
    "codigo":293206002,
    "descripcion":"REACCIÓN ADVERSA A LAS HORMONAS SEXUALES"
  },
  {
    "codigo":719190002,
    "descripcion":"ATROFIA DE MÚSCULO GEMELO"
  },
  {
    "codigo":162134004,
    "descripcion":"ORINA DE ASPECTO NORMAL"
  },
  {
    "codigo":1208875000,
    "descripcion":"ESTENOSIS DE ARTERIA RENAL DEBIDA A DISPLASIA FIBROMUSCULAR"
  },
  {
    "codigo":193067002,
    "descripcion":"COMPLICACIÓN EN EL SISTEMA NERVIOSO POR DISPOSITIVO IMPLANTADO QUIRÚRGICAMENTE"
  },
  {
    "codigo":94763003,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LOS HUESOS DEL CRÁNEO"
  },
  {
    "codigo":289536000,
    "descripcion":"SANGRE FRESCA POR VAGINA"
  },
  {
    "codigo":29227009,
    "descripcion":"NOCARDIOSIS"
  },
  {
    "codigo":225835008,
    "descripcion":"NECESITA UN ABOGADO"
  },
  {
    "codigo":92928004,
    "descripcion":"FORMA ANORMAL CONGÉNITA DEL METACARPO"
  },
  {
    "codigo":387840005,
    "descripcion":"NEOPLASIA DEL CORAZÓN Y\/O EL PERICARDIO"
  },
  {
    "codigo":189397006,
    "descripcion":"NEOPLASIA DEL ESFÍNTER DE ODDI DE COMPORTAMIENTO INCIERTO"
  },
  {
    "codigo":1172437008,
    "descripcion":"HORMONA ANTIDIURÉTICA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":12237911000119109,
    "descripcion":"AMAUROSIS FUGAZ DE OJO IZQUIERDO"
  },
  {
    "codigo":285866005,
    "descripcion":"DIFICULTAD PARA USAR EL LAVAPLATOS"
  },
  {
    "codigo":710015000,
    "descripcion":"INSERCIÓN MUSCULAR EN ESTADO EDÉNTULO CON INSERCIÓN MENTONIANA ALTA"
  },
  {
    "codigo":253098009,
    "descripcion":"DEFECTO DEL TUBO NEURAL"
  },
  {
    "codigo":251263007,
    "descripcion":"ONDA U BAJA"
  },
  {
    "codigo":314964006,
    "descripcion":"RECIDIVA LOCAL DE NEOPLASIA MALIGNA DE PÁNCREAS"
  },
  {
    "codigo":249428006,
    "descripcion":"CONDUCTO SALIVAL - HALLAZGO"
  },
  {
    "codigo":20052008,
    "descripcion":"FRUCTOSURIA HEREDITARIA"
  },
  {
    "codigo":247593004,
    "descripcion":"OLVIDA LO QUE IBA A HACER"
  },
  {
    "codigo":11775371000119102,
    "descripcion":"CONTUSIÓN DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":737278006,
    "descripcion":"INJERTO DE ARTERIA CORONARIA PRESENTE"
  },
  {
    "codigo":735443007,
    "descripcion":"LINFOCITOPENIA ADQUIRIDA"
  },
  {
    "codigo":276691007,
    "descripcion":"OFTALMÍA NEONATAL ESTAFILOCÓCICA"
  },
  {
    "codigo":1259731007,
    "descripcion":"ASTROCITOMA PRIMARIO DE MÉDULA ESPINAL"
  },
  {
    "codigo":242088002,
    "descripcion":"LESIÓN TRAUMÁTICA DE OCUPANTE DE VEHÍCULO FERROVIARIO EN COLISIÓN CON VEHÍCULO VIAL"
  },
  {
    "codigo":209320003,
    "descripcion":"FRACTURA-SUBLUXACIÓN NO EXPUESTA DE ARTICULACIÓN METACARPOFALÁNGICA"
  },
  {
    "codigo":733608000,
    "descripcion":"CARCINOMA PAPILAR DE CÉLULAS RENALES"
  },
  {
    "codigo":307624007,
    "descripcion":"LINFOMA MALIGNO DIFUSO - CENTROBLÁSTICO CENTROCÍTICO"
  },
  {
    "codigo":405928008,
    "descripcion":"VASO DE SENO RENAL INVOLUCRADO POR TUMOR"
  },
  {
    "codigo":404093001,
    "descripcion":"METÁSTASIS SARCOMATOSA EN PIEL"
  },
  {
    "codigo":43645004,
    "descripcion":"TRASTORNO DEGENERATIVO DE LA ESCLERÓTICA"
  },
  {
    "codigo":240253004,
    "descripcion":"DEFORMIDAD ADQUIRIDA DEL PIE EN ABDUCCIÓN"
  },
  {
    "codigo":1256061006,
    "descripcion":"TRICOTEIROMANÍA"
  },
  {
    "codigo":305789006,
    "descripcion":"VISTO POR JEFE DEL DEPARTAMENTO DE SERVICIOS SOCIALES"
  },
  {
    "codigo":402258000,
    "descripcion":"ERITEMA POR DANTRON"
  },
  {
    "codigo":369490001,
    "descripcion":"TUMOR MALIGNO DE LA VESÍCULA SEMINAL POR PROPAGACIÓN DIRECTA DE LA PRÓSTATA"
  },
  {
    "codigo":74578003,
    "descripcion":"PIODERMIA GANGRENOSA"
  },
  {
    "codigo":238418005,
    "descripcion":"ERITRASMA"
  },
  {
    "codigo":205650008,
    "descripcion":"TRISOMÍA 9"
  },
  {
    "codigo":1186855002,
    "descripcion":"HIPOPITUITARISMO AUTOINMUNE"
  },
  {
    "codigo":105511003,
    "descripcion":"DESAVENENCIA CON LOS LOCATARIOS DE UNA VIVIENDA"
  },
  {
    "codigo":236583003,
    "descripcion":"TRASPLANTE RENAL QUE HA FALLADO"
  },
  {
    "codigo":70908000,
    "descripcion":"VOLUMEN SANGUÍNEO DISMINUIDO"
  },
  {
    "codigo":116261000119105,
    "descripcion":"ANAFILAXIA CAUSADA POR HUEVO"
  },
  {
    "codigo":300284004,
    "descripcion":"HALLAZGO RELACIONADO CON EL ESÓFAGO"
  },
  {
    "codigo":365820007,
    "descripcion":"HALLAZGO RELACIONADO CON PRESENCIA DE SUSTANCIAS REDUCTORAS EN MATERIA FECAL"
  },
  {
    "codigo":201980007,
    "descripcion":"ARTRITIS CLIMATÉRICA DE LA MANO"
  },
  {
    "codigo":724433006,
    "descripcion":"FINAL DE VIDA ÚTIL DE BATERÍA DE CARDIOVERSOR IMPLANTABLE"
  },
  {
    "codigo":722598000,
    "descripcion":"ESPONDILOLISTESIS SIN DEFECTO DE LA PARTE INTERARTICULAR VERTEBRAL"
  },
  {
    "codigo":335551000119103,
    "descripcion":"EDEMA MACULAR CISTOIDEO DE RETINA DERECHA"
  },
  {
    "codigo":1148582006,
    "descripcion":"HALLAZGO RELACIONADO CON LA FUNCIÓN RENAL"
  },
  {
    "codigo":1279654005,
    "descripcion":"HERIDA PUNZANTE DE DEDO ANULAR DE MANO CON CUERPO EXTRAÑO"
  },
  {
    "codigo":296614009,
    "descripcion":"SOBREDOSIS DE AZITROMICINA"
  },
  {
    "codigo":1343355002,
    "descripcion":"ACCESO DIGITAL INADECUADO DEBIDO A RECURSOS ECONÓMICOS LIMITADOS"
  },
  {
    "codigo":15982271000119104,
    "descripcion":"DEBILIDAD DE MÚSCULO FACIAL DERECHO DEBIDA A ENFERMEDAD CEREBROVASCULAR Y POSTERIOR A ELLA"
  },
  {
    "codigo":196475005,
    "descripcion":"ATROFIA DE GLÁNDULA SUBMAXILAR"
  },
  {
    "codigo":1144912000,
    "descripcion":"MICROANGIOPATÍA TROMBÓTICA CRÓNICA"
  },
  {
    "codigo":30800001,
    "descripcion":"VAGINITIS"
  },
  {
    "codigo":292944006,
    "descripcion":"REACCIÓN ADVERSA AL ÁCIDO FUSÍDICO"
  },
  {
    "codigo":192805000,
    "descripcion":"HIDROCEFALIA NO OBSTRUCTIVA"
  },
  {
    "codigo":129104009,
    "descripcion":"TRASTORNO MENTAL CONGÉNITO"
  },
  {
    "codigo":94501001,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LOS GANGLIOS LINFÁTICOS PREAURICULARES"
  },
  {
    "codigo":28965003,
    "descripcion":"DEFICIENCIA DE REPARACIÓN DE ADN"
  },
  {
    "codigo":127269004,
    "descripcion":"NEOPLASIA DE LOS GANGLIOS LINFÁTICOS DEL OBTURADOR"
  },
  {
    "codigo":69896004,
    "descripcion":"ARTRITIS REUMATOIDE"
  },
  {
    "codigo":59898000,
    "descripcion":"RECESIÓN GINGIVAL LOCALIZADA"
  },
  {
    "codigo":10958681000119102,
    "descripcion":"HERIDA PUNZANTE DE MANO DERECHA"
  },
  {
    "codigo":11777881000119103,
    "descripcion":"RUPTURA TRAUMÁTICA DE TENDÓN DE MÚSCULO DELTOIDES IZQUIERDO"
  },
  {
    "codigo":254671003,
    "descripcion":"QUISTE SEBÁCEO INFECTADO"
  },
  {
    "codigo":713423005,
    "descripcion":"TAQUICARDIA AURICULAR MULTIFOCAL ELECTROCARDIOGRÁFICA"
  },
  {
    "codigo":189135006,
    "descripcion":"NEOPLASIA BENIGNA DE CUERPO ESPONJOSO"
  },
  {
    "codigo":123599008,
    "descripcion":"PERICARDITIS SEROFIBRINOSA"
  },
  {
    "codigo":449444000,
    "descripcion":"CONEXIÓN VENOSA PULMONAR ANÓMALA DE LOCALIZACIÓN INFRACARDÍACA A VENA HEPÁTICA"
  },
  {
    "codigo":88996004,
    "descripcion":"LIQUEN"
  },
  {
    "codigo":416676005,
    "descripcion":"MACROAMILASEMIA"
  },
  {
    "codigo":251001002,
    "descripcion":"CALCIFICACIÓN DEL APARATO SUBVALVULAR MITRAL"
  },
  {
    "codigo":283769007,
    "descripcion":"MORDEDURA DE PERRO EN LA CADERA"
  },
  {
    "codigo":609614000,
    "descripcion":"NEUROPATÍA POR COMPRESIÓN DE MIEMBRO INFERIOR"
  },
  {
    "codigo":314702000,
    "descripcion":"TALLA DEL NIÑO: PERCENTILO 98,1-99,6"
  },
  {
    "codigo":249166003,
    "descripcion":"FALTA DE PROGRESIÓN EN LA SEGUNDA ETAPA DEL TRABAJO DE PARTO"
  },
  {
    "codigo":281934008,
    "descripcion":"FRACTURA POR ESTALLIDO DE VÉRTEBRA LUMBAR"
  },
  {
    "codigo":212728004,
    "descripcion":"INTOXICACIÓN CON PEPSINA"
  },
  {
    "codigo":702413000,
    "descripcion":"SÍNDROME DE MALFORMACIONES RADIALES, ANOMALÍAS DE RÓTULA Y PALADAR, DIARREA Y LUXACIONES ARTICULARES, ANOMALÍAS DE MIEMBROS Y BAJA ESTATURA, NARIZ DELGADA E INTELIGENCIA NORMAL"
  },
  {
    "codigo":210893001,
    "descripcion":"CONTUSIÓN, ARTERIA PLANTAR PROFUNDA"
  },
  {
    "codigo":704248008,
    "descripcion":"FRACTURA PATOLÓGICA DE HÚMERO EN SITIO DE NEOPLASIA"
  },
  {
    "codigo":473037003,
    "descripcion":"COMPLICACIÓN ASOCIADA CON DISPOSITIVO NEUROLÓGICO"
  },
  {
    "codigo":338061000119101,
    "descripcion":"NEOVASCULARIZACIÓN RETINIANA IZQUIERDA"
  },
  {
    "codigo":1259469003,
    "descripcion":"DEMENCIA DEBIDA A SÍNDROME DE GERSTMANN STRAUSSLER SCHEINKER"
  },
  {
    "codigo":276429006,
    "descripcion":"SECCIÓN TRAUMÁTICA DE TENDÓN EXTENSOR - ZONA 3"
  },
  {
    "codigo":241826002,
    "descripcion":"ENVENENAMIENTO DEBIDO A PICADURA DE RAYA"
  },
  {
    "codigo":307362003,
    "descripcion":"EMBOLIA SÉPTICA VENOSA INTRACRANEAL"
  },
  {
    "codigo":36851000119109,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE TEJIDO CELULAR SUBCUTÁNEO DE MANO"
  },
  {
    "codigo":733346002,
    "descripcion":"NEOPLASIA QUÍSTICA MUCINOSA PRIMARIA CON CARCINOMA INVASIVO ASOCIADO DE CONDUCTO BILIAR PERIHILIAR"
  },
  {
    "codigo":371063000,
    "descripcion":"NO INMUNE A LA PAROTIDITIS URLIANA"
  },
  {
    "codigo":1255799000,
    "descripcion":"ENFERMEDAD DE SÉZARY DE GANGLIOS LINFÁTICOS DE CABEZA"
  },
  {
    "codigo":76151005,
    "descripcion":"MIOMETRITIS AGUDA"
  },
  {
    "codigo":403831006,
    "descripcion":"HIPERCOLESTEROLEMIA FAMILIAR POR DEFECTO GENÉTICO DE APOLIPOPROTEÍNA B"
  },
  {
    "codigo":698743007,
    "descripcion":"CUADRIPLEJÍA COMPLETA AGUDA DEBIDA A LESIÓN DE MÉDULA ESPINAL ENTRE QUINTA Y SÉPTIMA VÉRTEBRAS CERVICALES"
  },
  {
    "codigo":43383008,
    "descripcion":"DIVERTÍCULO CONGÉNITO DE BRONQUIOS"
  },
  {
    "codigo":238156001,
    "descripcion":"ATROFIA CUTÁNEA PRODUCIDA POR ENFERMEDAD SISTÉMICA SEVERA"
  },
  {
    "codigo":305527008,
    "descripcion":"BAJO ATENCIÓN DE CIRUJANO CARDIOTORÁCICO"
  },
  {
    "codigo":400161004,
    "descripcion":"QUEMADURA DE PIEL POR FÓSFORO"
  },
  {
    "codigo":367393006,
    "descripcion":"MANO EN GARRA ADQUIRIDA"
  },
  {
    "codigo":1284897006,
    "descripcion":"FRACTURA PATOLÓGICA DE PIE DEBIDA A OSTEOPETROSIS"
  },
  {
    "codigo":267254000,
    "descripcion":"DAÑO FETAL DEBIDO A INFECCIÓN VIRAL MATERNA"
  },
  {
    "codigo":365558004,
    "descripcion":"HALLAZGO RELACIONADO CON EL ESTADO DE UN SUBSIDIO"
  },
  {
    "codigo":10633511000119103,
    "descripcion":"CELULITIS DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":234486007,
    "descripcion":"SÍNDROME PLAQUETARIO DE MONTREAL"
  },
  {
    "codigo":68811000,
    "descripcion":"PROBLEMA DE LA MENOPAUSIA"
  },
  {
    "codigo":298187001,
    "descripcion":"HIPERMOVILIDAD DE LA COLUMNA LUMBAR"
  },
  {
    "codigo":724171006,
    "descripcion":"MENINGIOMA BENIGNO"
  },
  {
    "codigo":3275009,
    "descripcion":"SÍNDROME DE BEHCET, VASCULAR"
  },
  {
    "codigo":296352003,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE NICOTINA"
  },
  {
    "codigo":165280004,
    "descripcion":"MEMORIA: NO RECUERDA SU PROPIA EDAD"
  },
  {
    "codigo":285121000119100,
    "descripcion":"MAL FUNCIONAMIENTO DE GENERADOR DE CARDIOVERSOR DESFIBRILADOR IMPLANTABLE AUTOMÁTICO BIVENTRICULAR"
  },
  {
    "codigo":65141002,
    "descripcion":"NEUMONÍA POR CUERPO EXTRAÑO"
  },
  {
    "codigo":294517005,
    "descripcion":"ALERGIA A TICARCILINA"
  },
  {
    "codigo":786037006,
    "descripcion":"HIPERPARATIROIDISMO FAMILIAR AISLADO"
  },
  {
    "codigo":720501007,
    "descripcion":"SÍNDROME DE ARACNODACTILIA CON OSIFICACIÓN ANORMAL Y DISCAPACIDAD INTELECTUAL"
  },
  {
    "codigo":292682001,
    "descripcion":"REACCIÓN ADVERSA A RELAJANTE MUSCULAR DESPOLARIZANTE"
  },
  {
    "codigo":423754004,
    "descripcion":"DIFICULTAD CON LAS RESPONSABILIDADES DE CUIDADO"
  },
  {
    "codigo":390986009,
    "descripcion":"FRACTURA INCOMPLETA DE RADIO CON ABULTAMIENTO CORTICAL (TORUS)"
  },
  {
    "codigo":94239005,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL CUERPO CAROTÍDEO"
  },
  {
    "codigo":290847005,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR NORTRIPTILINA"
  },
  {
    "codigo":59636002,
    "descripcion":"ENFERMEDAD DE PELIZAEUS - MERZBACHER, VARIANTE CONNATAL"
  },
  {
    "codigo":289012005,
    "descripcion":"CAPAZ DE COLOCAR ALIMENTO EN LA BOCA"
  },
  {
    "codigo":714996006,
    "descripcion":"NO NADA"
  },
  {
    "codigo":92404006,
    "descripcion":"NEOPLASIA BENIGNA DE SENO ESFENOIDAL"
  },
  {
    "codigo":15686081000119107,
    "descripcion":"ARTROSIS DE AMBAS ARTICULACIONES TEMPOROMANDIBULARES"
  },
  {
    "codigo":340571000119101,
    "descripcion":"GLAUCOMA SECUNDARIO DE ÁNGULO CERRADO DE OJO IZQUIERDO DEBIDO A BLOQUEO PUPILAR"
  },
  {
    "codigo":57801006,
    "descripcion":"ACTIVIDAD HORMONAL AUMENTADA"
  },
  {
    "codigo":254409008,
    "descripcion":"CARCINOMA IN SITU DE LOS DOS TERCIOS ANTERIORES DE LA LENGUA - BORDE LATERAL"
  },
  {
    "codigo":1268382002,
    "descripcion":"AMPUTACIÓN PARCIAL TRAUMÁTICA DE EXTREMIDAD INFERIOR A NIVEL ENTRE RODILLA Y TOBILLO"
  },
  {
    "codigo":86899000,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN DE DEDO DEL PIE"
  },
  {
    "codigo":1332083003,
    "descripcion":"SE IDENTIFICA COMO PERSONA TRANSGÉNERO MASCULINO"
  },
  {
    "codigo":185203005,
    "descripcion":"ATENDIDO EN CENTRO DE SALUD"
  },
  {
    "codigo":283507009,
    "descripcion":"HERIDA PUNZANTE DE BOCA"
  },
  {
    "codigo":412744006,
    "descripcion":"DIETA CON ALTO CONTENIDO DE AZÚCAR"
  },
  {
    "codigo":248904006,
    "descripcion":"PULSACIÓN EN EL FONDO DE SACO VAGINAL"
  },
  {
    "codigo":445512009,
    "descripcion":"CALCIFICACIÓN DE ARTERIA CORONARIA"
  },
  {
    "codigo":1077851000119108,
    "descripcion":"ENFERMEDAD DE PAGET DE ESCÁPULA DERECHA"
  },
  {
    "codigo":1197341008,
    "descripcion":"ADENOMA TUBULAR BENIGNO DE APÉNDICE"
  },
  {
    "codigo":703986000,
    "descripcion":"FRACTURA NO EXPUESTA DE FALANGE DISTAL DE DEDO ÍNDICE"
  },
  {
    "codigo":472775000,
    "descripcion":"DISFUNCIÓN DE VENTRÍCULO IZQUIERDO FETAL"
  },
  {
    "codigo":767687004,
    "descripcion":"HERNIA INGUINAL DERECHA IRREDUCTIBLE"
  },
  {
    "codigo":700316000,
    "descripcion":"ARTROSIS DE ARTICULACIÓN SUBASTRAGALINA SECUNDARIA A ARTRITIS INFLAMATORIA"
  },
  {
    "codigo":733084000,
    "descripcion":"TRASTORNO CONGÉNITO DE GLICOSILACIÓN TIPO 1N"
  },
  {
    "codigo":208796005,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN DE CODO, POSTERIOR"
  },
  {
    "codigo":12188008,
    "descripcion":"PARAINFLUENZA"
  },
  {
    "codigo":43121002,
    "descripcion":"INSUFICIENCIA VALVULAR REUMÁTICA"
  },
  {
    "codigo":16671631000119101,
    "descripcion":"FRACTURA NO EXPUESTA DE PISO DE ÓRBITA IZQUIERDA, EN ESTALLIDO"
  },
  {
    "codigo":239729004,
    "descripcion":"RUPTURA DEL LIGAMENTO LATERAL INTERNO DE LA RODILLA"
  },
  {
    "codigo":403569009,
    "descripcion":"CALCINOSIS EN VÁRICES"
  },
  {
    "codigo":237894002,
    "descripcion":"RAQUITISMO DEPENDIENTE DE VITAMINA D TIPO II CON ALOPECIA"
  },
  {
    "codigo":205126005,
    "descripcion":"POLIDACTILIA RADIAL DE WASSEL 5"
  },
  {
    "codigo":72219001,
    "descripcion":"ÚLCERA GASTROYEYUNAL AGUDA CON PERFORACIÓN Y OBSTRUCCIÓN"
  },
  {
    "codigo":1055259002,
    "descripcion":"AGENESIA DE EPÍFISIS DE PRIMER HUESO METACARPIANO"
  },
  {
    "codigo":203291003,
    "descripcion":"OSTEOPATÍA COMO CONSECUENCIA DE POLIOMIELITIS, DE LA PIERNA"
  },
  {
    "codigo":236059003,
    "descripcion":"HERNIA DIAFRAGMÁTICA TRAUMÁTICA"
  },
  {
    "codigo":39451005,
    "descripcion":"EFECTO TÓXICO DEL ÁCIDO"
  },
  {
    "codigo":399899001,
    "descripcion":"NEVO MELANOCÍTICO ADQUIRIDO"
  },
  {
    "codigo":301595002,
    "descripcion":"INCAPAZ DE SUBIR Y BAJAR ESCALERAS EN CUATRO PATAS"
  },
  {
    "codigo":168688000,
    "descripcion":"RADIOGRAFÍA SIMPLE DE PIE ANORMAL"
  },
  {
    "codigo":299760001,
    "descripcion":"REFLEJO DE DEGLUCIÓN AUSENTE"
  },
  {
    "codigo":1153563009,
    "descripcion":"PROGESTERONA SÉRICA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":365296004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA ENCENDER LA INSTALACIÓN PRINCIPAL DE GAS"
  },
  {
    "codigo":234224005,
    "descripcion":"SÍNDROME DEL MARCAPASOS"
  },
  {
    "codigo":398064005,
    "descripcion":"VEJIGA URINARIA NEUROGÉNICA"
  },
  {
    "codigo":232389000,
    "descripcion":"SINUSITIS FRONTAL AGUDA CON OSTEOMIELITIS DE HUESO FRONTAL"
  },
  {
    "codigo":363461003,
    "descripcion":"NEOPLASIA MALIGNA DE OJO"
  },
  {
    "codigo":166853009,
    "descripcion":"ELECTROFORESIS DE LIPOPROTEÍNAS FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":296090003,
    "descripcion":"SOBREDOSIS DE CLOBAZAM"
  },
  {
    "codigo":165018007,
    "descripcion":"PRUEBA DE FUNCIÓN PULMONAR NORMAL"
  },
  {
    "codigo":294255001,
    "descripcion":"ALERGIA A ALPROSTADIL"
  },
  {
    "codigo":425327002,
    "descripcion":"NEUROFIBROMA DE TEJIDO SUBCUTÁNEO"
  },
  {
    "codigo":195951007,
    "descripcion":"EXACERBACIÓN AGUDA DE ENFERMEDAD PULMONAR OBSTRUCTIVA CRÓNICA"
  },
  {
    "codigo":30276000,
    "descripcion":"HÁLITO DE AJO"
  },
  {
    "codigo":392559009,
    "descripcion":"OSTEOMALACIA INDUCIDA POR TUMOR"
  },
  {
    "codigo":1144388002,
    "descripcion":"HIPOPLASIA CONGÉNITA DE TRACTO OLFATORIO"
  },
  {
    "codigo":95812002,
    "descripcion":"ECCEMA DE CONDUCTO AUDITIVO EXTERNO"
  },
  {
    "codigo":292420004,
    "descripcion":"REACCIÓN ADVERSA A BETABLOQUEANTE CARDIOSELECTIVO"
  },
  {
    "codigo":225049000,
    "descripcion":"AHORCARSE"
  },
  {
    "codigo":290585001,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR BUSULFANO"
  },
  {
    "codigo":716569003,
    "descripcion":"ATENDIDO POR EQUIPO ESPECIALIZADO EN TRASTORNOS DEL APRENDIZAJE"
  },
  {
    "codigo":889967811000119101,
    "descripcion":"DEFICIENCIA DE CÉLULAS MADRE LIMBARES DE OJO DERECHO"
  },
  {
    "codigo":93977003,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL PÍLORO"
  },
  {
    "codigo":126745008,
    "descripcion":"NEOPLASIA DE VASO SANGUÍNEO DE LA MANO"
  },
  {
    "codigo":288750000,
    "descripcion":"CAPAZ DE COMUNICAR ALGO SOBRE SÍ MISMO"
  },
  {
    "codigo":92142006,
    "descripcion":"NEOPLASIA BENIGNA DEL ILION"
  },
  {
    "codigo":316611000119104,
    "descripcion":"OSTEOFITO DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":254147009,
    "descripcion":"OSTEÓLISIS IDIOPÁTICAS"
  },
  {
    "codigo":88472004,
    "descripcion":"ENFERMEDAD INTERCURRENTE"
  },
  {
    "codigo":55704005,
    "descripcion":"ABSCESO DE MAMA ASOCIADO CON EL PARTO"
  },
  {
    "codigo":448920004,
    "descripcion":"ANOMALÍA CONGÉNITA DE APARATO SUBVALVULAR MITRAL"
  },
  {
    "codigo":840301002,
    "descripcion":"CON MAYOR RIESGO DE RESPUESTA ALÉRGICA"
  },
  {
    "codigo":290141000119101,
    "descripcion":"LESIÓN DE NERVIO TIBIAL DERECHO"
  },
  {
    "codigo":447085008,
    "descripcion":"PULMÓN FUNCIONALMENTE ÚNICO CONGÉNITO"
  },
  {
    "codigo":283245009,
    "descripcion":"VIDRIO EN LA AXILA"
  },
  {
    "codigo":707394001,
    "descripcion":"CARCINOMA PRIMARIO DE CÉLULAS FUSIFORMES DE TRÁQUEA"
  },
  {
    "codigo":1231682009,
    "descripcion":"OPACIDAD CORNEAL POSTRAUMÁTICA"
  },
  {
    "codigo":115735004,
    "descripcion":"GRUPO SANGUÍNEO PARA - BOMBAY"
  },
  {
    "codigo":246807006,
    "descripcion":"CICATRIZACIÓN DE CARÚNCULA OCULAR"
  },
  {
    "codigo":443415006,
    "descripcion":"CUERPO EXTRAÑO DEBAJO DE PREPUCIO"
  },
  {
    "codigo":408812003,
    "descripcion":"POSICIÓN SACROILÍACA DIRECTA ANTERIOR"
  },
  {
    "codigo":48364004,
    "descripcion":"CIRCUNLOCUCIÓN"
  },
  {
    "codigo":126301000119106,
    "descripcion":"LESIÓN ESCAMOSA INTRAEPITELIAL DE BAJO GRADO EN EXTENDIDO DE PAPANICOLAOU ANAL"
  },
  {
    "codigo":15992311000119100,
    "descripcion":"QUERATITIS DE OJO IZQUIERDO DEBIDA A HERPES ZÓSTER"
  },
  {
    "codigo":863894003,
    "descripcion":"PRURITO EN LUGAR DE INYECCIÓN"
  },
  {
    "codigo":110230006,
    "descripcion":"QUEMADURA DE LA REGIÓN AMIGDALINA"
  },
  {
    "codigo":700054008,
    "descripcion":"SEPSIS CAUSADA POR HONGOS"
  },
  {
    "codigo":1255275001,
    "descripcion":"FRACTURA EXPUESTA CONMINUTA DE FALANGE PROXIMAL DE DEDO DE MANO"
  },
  {
    "codigo":10091002,
    "descripcion":"INSUFICIENCIA CARDÍACA CON ALTO GASTO CARDÍACO"
  },
  {
    "codigo":10667511000119104,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN EN PIERNA DERECHA ESTADIO I"
  },
  {
    "codigo":403307005,
    "descripcion":"ALINEAMIENTO ANÓMALO ADQUIRIDO DE UÑA DEL PIE"
  },
  {
    "codigo":370539007,
    "descripcion":"FRACASO EN LA TRANSFERENCIA DE INMUNIDAD PASIVA AL RECIÉN NACIDO"
  },
  {
    "codigo":763755009,
    "descripcion":"SÍNDROME DE LUXACIÓN DE CADERA Y DISMORFISMO FACIAL"
  },
  {
    "codigo":237632004,
    "descripcion":"EVENTO HIPOGLUCÉMICO DEBIDO A DIABETES MELLITUS"
  },
  {
    "codigo":7570001000004103,
    "descripcion":"MASA DE REGIÓN DE CADERA"
  },
  {
    "codigo":170261000,
    "descripcion":"EXAMEN DEL NIÑO AL AÑO: ANORMAL - EN TRATAMIENTO"
  },
  {
    "codigo":345591000119107,
    "descripcion":"COROIDITIS YUXTAPAPILAR FOCAL DE AMBOS OJOS"
  },
  {
    "codigo":203029003,
    "descripcion":"ABSCESO DE MÚSCULO DE PIE"
  },
  {
    "codigo":235797004,
    "descripcion":"PROLAPSO DE ESTOMA"
  },
  {
    "codigo":8530001000004108,
    "descripcion":"FRACTURA DE MALGAIGNE NO EXPUESTA"
  },
  {
    "codigo":1082871000119108,
    "descripcion":"OTITIS MEDIA ALÉRGICA AGUDA BILATERAL"
  },
  {
    "codigo":4586000,
    "descripcion":"COMPLICACIÓN DE DISPOSITIVO DE FIJACIÓN INTERNA"
  },
  {
    "codigo":12115601000119102,
    "descripcion":"QUEMADURA QUÍMICA DE PALMA DERECHA"
  },
  {
    "codigo":397802005,
    "descripcion":"VENTILACIÓN MINUTO"
  },
  {
    "codigo":233962007,
    "descripcion":"ISQUEMIA CRÍTICA DE MIEMBROS INFERIORES"
  },
  {
    "codigo":365034008,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA EMPLEAR LA COMUNICACIÓN NO VERBAL"
  },
  {
    "codigo":428735001,
    "descripcion":"HALLAZGO RELACIONADO CON LA UBICACIÓN FÍSICA DEL PACIENTE"
  },
  {
    "codigo":2751001,
    "descripcion":"DIABETES PANCREÁTICA FIBROCALCULOSA"
  },
  {
    "codigo":11787921000119104,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DE DEDO ÍNDICE IZQUIERDO"
  },
  {
    "codigo":232127009,
    "descripcion":"HIPERMETROPÍA MANIFIESTA"
  },
  {
    "codigo":721812005,
    "descripcion":"QUISTE DE CONDUCTO PARAMESONÉFRICO"
  },
  {
    "codigo":66452006,
    "descripcion":"TENOSINOVITIS ESTENOSANTE"
  },
  {
    "codigo":263060007,
    "descripcion":"SUBLUXACIÓN DE ARTICULACIÓN DE TOBILLO"
  },
  {
    "codigo":230292008,
    "descripcion":"PARKINSONISMO SECUNDARIO"
  },
  {
    "codigo":319121000119106,
    "descripcion":"ARTRITIS REUMATOIDEA SERONEGATIVA DE ARTICULACIÓN DE CADERA DERECHA"
  },
  {
    "codigo":15720081000119107,
    "descripcion":"TRASTORNO DE CARTÍLAGO ARTICULAR DE AMBOS TOBILLOS"
  },
  {
    "codigo":295828005,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE BROMOCRIPTINA"
  },
  {
    "codigo":293993005,
    "descripcion":"ALERGIA A NICOTINA"
  },
  {
    "codigo":95550001,
    "descripcion":"FIBROSIS PERITONEAL"
  },
  {
    "codigo":292158007,
    "descripcion":"REACCIÓN ADVERSA AL ÁCIDO DEHIDROCÓLICO"
  },
  {
    "codigo":423230008,
    "descripcion":"PEZONES AMPLIAMENTE SEPARADOS"
  },
  {
    "codigo":192019001,
    "descripcion":"DESEO VEHEMENTE DE INGERIR UN ALIMENTO DETERMINADO"
  },
  {
    "codigo":40791000087100,
    "descripcion":"ABRASIÓN DE PIEL DE MIEMBRO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":93715005,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL CUERPO DEL PÁNCREAS"
  },
  {
    "codigo":43351000087103,
    "descripcion":"PROLAPSO DE DISCO INTERVERTEBRAL L1-L2"
  },
  {
    "codigo":48471000087105,
    "descripcion":"FRACTURA DE TERCER HUESO METATARSIANO DE PIE DERECHO"
  },
  {
    "codigo":124648003,
    "descripcion":"DEFICIENCIA DE CARBONO - NITRÓGENO LIASA"
  },
  {
    "codigo":38231000087108,
    "descripcion":"HIPOCINESIA DE SEGMENTO APICAL SEPTAL DE VENTRÍCULO CARDÍACO IZQUIERDO"
  },
  {
    "codigo":91880006,
    "descripcion":"AUSENCIA CONGÉNITA DE VÉRTEBRA CERVICAL"
  },
  {
    "codigo":384957000,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA PARENQUIMATOSA AFECTADO POR NEOPLASIA MALIGNA"
  },
  {
    "codigo":712637001,
    "descripcion":"LEUCODISTROFIA RELACIONADA CON POLIMERASA III DE ÁCIDO RIBONUCLEICO"
  },
  {
    "codigo":286653002,
    "descripcion":"AUTODRAMATIZACIÓN"
  },
  {
    "codigo":253885004,
    "descripcion":"RIÑÓN CON MÉDULA ESPONJOSA SIN NEFROCALCINOSIS"
  },
  {
    "codigo":417725008,
    "descripcion":"FLEXIÓN DEL SACRO"
  },
  {
    "codigo":348101000119102,
    "descripcion":"EDEMA PERIORBITARIO DE OJO DERECHO"
  },
  {
    "codigo":55442000,
    "descripcion":"DISNEA PAROXÍSTICA NOCTURNA"
  },
  {
    "codigo":102341000119103,
    "descripcion":"CISTOURETROCELE MASCULINO"
  },
  {
    "codigo":284818005,
    "descripcion":"SE PARA EN LA BAÑERA"
  },
  {
    "codigo":282983005,
    "descripcion":"NO SE ARRODILLA"
  },
  {
    "codigo":1003879007,
    "descripcion":"MAGALOURETRA PENIANA"
  },
  {
    "codigo":53607008,
    "descripcion":"TRASTORNO BIPOLAR I DEPRESIVO EN REMISIÓN"
  },
  {
    "codigo":86375009,
    "descripcion":"INFECCIÓN CAUSADA POR CORYNEBACTERIUM KUTSCHERI"
  },
  {
    "codigo":51772000,
    "descripcion":"CONTUSIÓN DE LA VAGINA"
  },
  {
    "codigo":1264188003,
    "descripcion":"PIGMENTACIÓN LOCAL EXÓGENA DE MUCOSA YUGAL IZQUIERDA"
  },
  {
    "codigo":881081000000100,
    "descripcion":"VÍCTIMA DE VIOLENCIA DOMÉSTICA EN LA CASA"
  },
  {
    "codigo":1111481000000100,
    "descripcion":"CIERRE DE ÁNGULO SECUNDARIO AGUDO"
  },
  {
    "codigo":707132006,
    "descripcion":"CAMBIO DE SÍNTOMA ENDOCRINO"
  },
  {
    "codigo":248380007,
    "descripcion":"CRÁNEO GRUESO"
  },
  {
    "codigo":312081001,
    "descripcion":"UTILIZA ANTICONCEPCIÓN CON DIU"
  },
  {
    "codigo":246545002,
    "descripcion":"CRISIS CONVULSIVA EPILÉPTICA GENERALIZADA"
  },
  {
    "codigo":443153007,
    "descripcion":"ENCEFALOMIELITIS TÓXICA"
  },
  {
    "codigo":1196817009,
    "descripcion":"NEOPLASIA BENIGNA DE CARÚNCULA LAGRIMAL"
  },
  {
    "codigo":277478008,
    "descripcion":"ENCEFALOPATÍA POSTERIOR A ASFIXIA"
  },
  {
    "codigo":767163000,
    "descripcion":"EFECTO TÓXICO DE BERILIO Y\/O COMPUESTOS DE BERILIO"
  },
  {
    "codigo":275643002,
    "descripcion":"VIVIENDA - A LA ESPERA DE ACCIÓN"
  },
  {
    "codigo":79035003,
    "descripcion":"ANEMIA POR MECANISMO DESCONOCIDO"
  },
  {
    "codigo":13499006,
    "descripcion":"ANOMALÍA CONGÉNITA DEL SISTEMA LAGRIMAL"
  },
  {
    "codigo":765328000,
    "descripcion":"MICOSIS FUNGOIDE CLÁSICA"
  },
  {
    "codigo":208272001,
    "descripcion":"FRACTURA NO EXPUESTA DE HÚMERO DISTAL, CÓNDILO HUMERAL"
  },
  {
    "codigo":109968002,
    "descripcion":"LINFOMA NO HODGKINIANO DIFUSO, MICROCÍTICO (CLÍNICO)"
  },
  {
    "codigo":11664005,
    "descripcion":"SENTARSE Y PARARSE EN FORMA ALTERNADA"
  },
  {
    "codigo":271973001,
    "descripcion":"TRASTORNO OCASIONADO POR DISPOSITIVO ANTICONCEPTIVO INTRAUTERINO"
  },
  {
    "codigo":9829001,
    "descripcion":"ÚLCERA GÁSTRICA PERFORADA"
  },
  {
    "codigo":321631000119107,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE TENDÓN FLEXOR DE MUSLO DERECHO"
  },
  {
    "codigo":403045004,
    "descripcion":"TIÑA CORPORAL CAUSADA POR TRICHOPHYTON YAOUNDEI"
  },
  {
    "codigo":239205005,
    "descripcion":"INSUFICIENCIA VENOSA DEL COLGAJO"
  },
  {
    "codigo":1255013006,
    "descripcion":"DEPENDENCIA COMBINADA DE SUSTANCIA OPIOIDE Y NO OPIOIDE"
  },
  {
    "codigo":302906000,
    "descripcion":"HEMATOMA AGUDO DEL PABELLÓN AURICULAR"
  },
  {
    "codigo":40762003,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE MANO SIN INFECCIÓN"
  },
  {
    "codigo":1351482005,
    "descripcion":"HETEROFORIA COMITANTE"
  },
  {
    "codigo":401210006,
    "descripcion":"PRUEBA DE LA MARCHA EN TÁNDEM - NORMAL"
  },
  {
    "codigo":1187642008,
    "descripcion":"SÍNDROME DE MACROCEFALIA, DISCAPACIDAD INTELECTUAL Y VENTRÍCULO IZQUIERDO NO COMPACTO"
  },
  {
    "codigo":71695001,
    "descripcion":"COMPLICACIÓN DE LA TERAPIA POR VENTILACIÓN"
  },
  {
    "codigo":366607003,
    "descripcion":"PRUEBA DE COMPRESIÓN ROTULIANA"
  },
  {
    "codigo":202767003,
    "descripcion":"TORTÍCOLIS INTERMITENTE"
  },
  {
    "codigo":399375005,
    "descripcion":"HALLAZGO DEL TAMAÑO TUMORAL"
  },
  {
    "codigo":169999006,
    "descripcion":"AMAMANTADO AL AÑO"
  },
  {
    "codigo":1251343008,
    "descripcion":"PAPILOMATOSIS CUTÁNEA FLORIDA"
  },
  {
    "codigo":364772001,
    "descripcion":"ALIMENTACIÓN DEL LACTANTE A LOS 3 MESES - HALLAZGO"
  },
  {
    "codigo":102628000,
    "descripcion":"DOLOR DE VESÍCULA"
  },
  {
    "codigo":397540003,
    "descripcion":"DAÑO VISUAL"
  },
  {
    "codigo":299236004,
    "descripcion":"COXA VALGA"
  },
  {
    "codigo":295161000119106,
    "descripcion":"ABSCESO DE VAINA TENDINOSA DE ANTEBRAZO"
  },
  {
    "codigo":725220006,
    "descripcion":"OCLUSIÓN DE VASO SANGUÍNEO DE CUERPO CAVERNOSO DE PENE"
  },
  {
    "codigo":4324001,
    "descripcion":"CISTITIS SUBAGUDA"
  },
  {
    "codigo":266468003,
    "descripcion":"CIRROSIS DE CAUSA NO ALCOHÓLICA"
  },
  {
    "codigo":231865001,
    "descripcion":"HERIDA EN LA CONJUNTIVA"
  },
  {
    "codigo":233700005,
    "descripcion":"NEUMOPATÍA DE LOS MANIPULADORES DE ROEDORES"
  },
  {
    "codigo":723385003,
    "descripcion":"SUSCEPTIBILIDAD MENDELIANA A ENFERMEDAD POR MICOBACTERIAS DEBIDA A DEFICIENCIA PARCIAL DE INTERFERÓN REGULADOR DE FACTOR 8"
  },
  {
    "codigo":1149369006,
    "descripcion":"CONOCIMIENTO ESCASO SOBRE ALIMENTOS Y\/O NUTRICIÓN"
  },
  {
    "codigo":264633009,
    "descripcion":"DEGENERACIÓN MACULAR, ESTADIO DE DRUSAS"
  },
  {
    "codigo":197262004,
    "descripcion":"FÍSTULA FECAL"
  },
  {
    "codigo":104851000119103,
    "descripcion":"DEPRESIÓN MAYOR PUERPERAL EN REMISIÓN"
  },
  {
    "codigo":721550006,
    "descripcion":"QUISTE ADQUIRIDO DE ÓRBITA"
  },
  {
    "codigo":66190008,
    "descripcion":"VÍCTIMA DE TRAUMATISMO CON HERIDAS MÚLTIPLES"
  },
  {
    "codigo":262798009,
    "descripcion":"HEMATOMA INTRAHEPÁTICO"
  },
  {
    "codigo":129891007,
    "descripcion":"TENSIÓN EMOCIONAL DE UN PROVEEDOR DE ATENCIÓN MÉDICA RELACIONADA CON SU ROL"
  },
  {
    "codigo":783416000,
    "descripcion":"ANEURISMA DE ARTERIA CEREBRAL ANTERIOR"
  },
  {
    "codigo":162659009,
    "descripcion":"RESOLUCIÓN DE LA HIPERTENSIÓN"
  },
  {
    "codigo":717880001,
    "descripcion":"MALFORMACIÓN ARTERIOVENOSA DE DUODENO"
  },
  {
    "codigo":160824003,
    "descripcion":"PROBLEMA DE RELACIÓN CON LA NOVIA"
  },
  {
    "codigo":816184001,
    "descripcion":"EDEMA DE MIEMBRO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":195427008,
    "descripcion":"TROMBOFLEBITIS DE LA VENA ILÍACA EXTERNA"
  },
  {
    "codigo":128056006,
    "descripcion":"TRASTORNO DEL SISTEMA VENOSO PORTAL"
  },
  {
    "codigo":422968005,
    "descripcion":"CARCINOMA PULMONAR NO MICROCÍTICO, TNM ESTADIO 3"
  },
  {
    "codigo":350611000119107,
    "descripcion":"ENFERMEDAD HEMOLÍTICA DEL FETO DEBIDA A INMUNIZACIÓN ABO"
  },
  {
    "codigo":1087891000119107,
    "descripcion":"TRASTORNO DE NERVIO AUDITIVO IZQUIERDO"
  },
  {
    "codigo":290061004,
    "descripcion":"MAMA BLANDA"
  },
  {
    "codigo":1304034000,
    "descripcion":"GLAUCOMA DE ÁNGULO ABIERTO BILATERAL DEBIDO A NEOVASCULARIZACIÓN"
  },
  {
    "codigo":124386001,
    "descripcion":"DEFICIENCIA DE GLUCOSILTRANSFERASA"
  },
  {
    "codigo":678291000119109,
    "descripcion":"SINEQUIAS DE IRIS DE OJO IZQUIERDO"
  },
  {
    "codigo":419298007,
    "descripcion":"ALERGIA A SANDÍA"
  },
  {
    "codigo":91618008,
    "descripcion":"RESORCIÓN DE LA MANDÍBULA"
  },
  {
    "codigo":1269431005,
    "descripcion":"CUERPO EXTRAÑO RETENIDO EN CÁMARA ANTERIOR DE OJO"
  },
  {
    "codigo":286391005,
    "descripcion":"INFECCIÓN CAUSADA POR PHIALOPHORA JEANSELMEI"
  },
  {
    "codigo":253623006,
    "descripcion":"ATRESIA DE TRONCO PULMONAR"
  },
  {
    "codigo":415628004,
    "descripcion":"CONTROL DE ACCIDENTE CEREBROVASCULAR\/ATAQUE ISQUÉMICO TRANSITORIO, PRIMERA CARTA"
  },
  {
    "codigo":324141000119106,
    "descripcion":"MONOARTRITIS DE PIE DERECHO"
  },
  {
    "codigo":55180007,
    "descripcion":"DIETA POTÁSICA"
  },
  {
    "codigo":1234828008,
    "descripcion":"DISPLASIA OSTEOFIBROSA"
  },
  {
    "codigo":315489001,
    "descripcion":"NACIDO EN NICARAGUA"
  },
  {
    "codigo":1003617002,
    "descripcion":"SOSPECHA DE GLAUCOMA DE ÁNGULO ABIERTO BILATERAL"
  },
  {
    "codigo":86113003,
    "descripcion":"OBSTRUCCIÓN COMPLETA DE LAS VÍAS URINARIAS"
  },
  {
    "codigo":249953004,
    "descripcion":"MOVIMIENTO CON COMPONENTE DE GRAVEDAD ELIMINADO"
  },
  {
    "codigo":706870000,
    "descripcion":"EMBOLIA PULMONAR AGUDA"
  },
  {
    "codigo":870710001,
    "descripcion":"DIFICULTAD PARA PARTICIPAR EN VIDA SOCIAL COMUNITARIA"
  },
  {
    "codigo":51510002,
    "descripcion":"ERGOTISMO"
  },
  {
    "codigo":1231158003,
    "descripcion":"DEPENDENCIA DE HIPNÓTICO EN REMISIÓN"
  },
  {
    "codigo":16026311000119102,
    "descripcion":"MALFORMACIÓN ARTERIOVENOSA CONGÉNITA DE AMBOS MIEMBROS INFERIORES"
  },
  {
    "codigo":248118000,
    "descripcion":"PURGACIÓN AUTOINDUCIDA PARA PERDER PESO"
  },
  {
    "codigo":84278006,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE CUELLO CON INFECCIÓN"
  },
  {
    "codigo":344587002,
    "descripcion":"HEMOCROMATOSIS PRECIRRÓTICA"
  },
  {
    "codigo":305715008,
    "descripcion":"ATENDIDO POR CIRUJANO COLORRECTAL"
  },
  {
    "codigo":311819007,
    "descripcion":"FRACTURAS NO EXPUESTAS QUE COMPROMETEN REGIONES MÚLTIPLES DE AMBAS EXTREMIDADES SUPERIORES"
  },
  {
    "codigo":277216001,
    "descripcion":"SONIDO PERCIBIDO EN LA LÍNEA MEDIA"
  },
  {
    "codigo":279051009,
    "descripcion":"DOLOR POSADMINISTRACIÓN DE UN AGENTE"
  },
  {
    "codigo":703200003,
    "descripcion":"ESTENOSIS DE PRÓTESIS DE VÁLVULA TRICÚSPIDE"
  },
  {
    "codigo":80608005,
    "descripcion":"AFECTO APROPIADO"
  },
  {
    "codigo":111541001,
    "descripcion":"VÉRTIGO POSICIONAL PAROXÍSTICO BENIGNO"
  },
  {
    "codigo":11821921000119101,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN DE LA REGIÓN DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":209845006,
    "descripcion":"CONTUSIÓN CORTICAL CON LESIÓN INTRACRANEAL ABIERTA SIN PÉRDIDA DE CONSCIENCIA"
  },
  {
    "codigo":699530000,
    "descripcion":"LIPOHEMARTROSIS"
  },
  {
    "codigo":76938004,
    "descripcion":"ENCEFALOPATÍA INFANTIL Y ACIDOSIS LÁCTICA"
  },
  {
    "codigo":44170005,
    "descripcion":"SOPLO EN VAIVÉN"
  },
  {
    "codigo":240778004,
    "descripcion":"MUCORMICOSIS CUTÁNEA"
  },
  {
    "codigo":109706009,
    "descripcion":"PÉRDIDA DE HUESO ALVEOLAR"
  },
  {
    "codigo":238943007,
    "descripcion":"ESPONGIOSIS EOSINOFÍLICA"
  },
  {
    "codigo":1254751008,
    "descripcion":"ASA VASCULAR PREPAPILAR CONGÉNITA"
  },
  {
    "codigo":1156447008,
    "descripcion":"BUENA CALIDAD DE VIDA"
  },
  {
    "codigo":1287519008,
    "descripcion":"PRODUCTO MÉDICO SUBESTÁNDAR"
  },
  {
    "codigo":400948003,
    "descripcion":"ESPASMO DE CABECEO"
  },
  {
    "codigo":237108005,
    "descripcion":"CICATRIZ DE EPISIOTOMÍA ANTIGUA"
  },
  {
    "codigo":302644007,
    "descripcion":"CORION INMADURO ANORMAL"
  },
  {
    "codigo":680801000119107,
    "descripcion":"ATROFIA DE IRIS DE OJO DERECHO"
  },
  {
    "codigo":366345005,
    "descripcion":"DATOS PRENATALES - HALLAZGO"
  },
  {
    "codigo":167902000,
    "descripcion":"LÍQUIDO SINOVIAL: CRISTALES"
  },
  {
    "codigo":36830004,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO DE MAMA"
  },
  {
    "codigo":200670004,
    "descripcion":"CELULITIS Y ABSCESO DE ANTEBRAZO"
  },
  {
    "codigo":4062006,
    "descripcion":"LESIÓN DEL PLEXO LUMBOSACRO"
  },
  {
    "codigo":298974006,
    "descripcion":"SIN AMPLITUD DE ABDUCCIÓN ACTIVA DE ARTICULACIÓN DE MUÑECA"
  },
  {
    "codigo":690171000119105,
    "descripcion":"DEBILIDAD DE MÚSCULO FACIAL DEBIDO A ACCIDENTE CEREBROVASCULAR EMBÓLICO Y POSTERIOR A ÉL"
  },
  {
    "codigo":67763001,
    "descripcion":"CRISIS HIPOTENSIVA"
  },
  {
    "codigo":723123001,
    "descripcion":"DEMENCIA VASCULAR ISQUÉMICA"
  },
  {
    "codigo":724958009,
    "descripcion":"DISTENSIÓN DE TENDÓN FLEXOR DE DEDO DE LA MANO A LA ALTURA DEL ANTEBRAZO"
  },
  {
    "codigo":12398321000119100,
    "descripcion":"TRASTORNO DEL ESTADO DE ÁNIMO CAUSADO POR METANFETAMINA"
  },
  {
    "codigo":1075441000119100,
    "descripcion":"RUPTURA CRÓNICA DE LIGAMENTO LATERAL INTERNO DE RODILLA IZQUIERDA"
  },
  {
    "codigo":133361000119101,
    "descripcion":"RETINOPATÍA CAUSADA POR TRIFLUOPERAZINA"
  },
  {
    "codigo":302321000119100,
    "descripcion":"HIPEROSTOSIS ESQUELÉTICA IDIOPÁTICA DIFUSA DE COLUMNA VERTEBRAL CERVICODORSAL"
  },
  {
    "codigo":15708401000119100,
    "descripcion":"TROMBOSIS AGUDA DE VENA PROFUNDA DE MIEMBRO SUPERIOR IZQUIERDO POSTERIOR A PROCEDIMIENTO"
  },
  {
    "codigo":33521000119105,
    "descripcion":"NEOPLASIA DE OVARIO CON BAJO POTENCIAL MALIGNO"
  },
  {
    "codigo":11863281000119100,
    "descripcion":"AMPOLLA DE DEDO GORDO DE PIE IZQUIERDO, CON INFECCIÓN"
  },
  {
    "codigo":10759921000119107,
    "descripcion":"SÍFILIS EN LA MADRE QUE COMPLICA EL NACIMIENTO"
  },
  {
    "codigo":10481000119108,
    "descripcion":"QUISTE COLOIDE DE CEREBRO"
  },
  {
    "codigo":11717361000119108,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE PARTES BLANDAS DE LA ESPALDA"
  },
  {
    "codigo":15713521000119103,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE AMBOS BRAZOS"
  },
  {
    "codigo":7921000119104,
    "descripcion":"DOLOR PLEURÍTICO ANTERIOR"
  },
  {
    "codigo":15741681000119107,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE AMBAS REGIONES DE LA RODILLA"
  },
  {
    "codigo":304881000119104,
    "descripcion":"DETENCIÓN TOTAL DE CRECIMIENTO EPIFISARIO DE TIBIA DISTAL DERECHA"
  },
  {
    "codigo":140633841000119106,
    "descripcion":"TUMOR NEUROENDOCRINO BIEN DIFERENCIADO CON METÁSTASIS A GANGLIO LINFÁTICO REGIONAL"
  },
  {
    "codigo":197000003,
    "descripcion":"TROMBOSIS DE LA ARTERIA MESENTÉRICA SUPERIOR"
  },
  {
    "codigo":162397003,
    "descripcion":"DOLOR DE GARGANTA"
  },
  {
    "codigo":195165005,
    "descripcion":"HEMORRAGIA DE LOS GANGLIOS BASALES"
  },
  {
    "codigo":721288009,
    "descripcion":"HIPOPITUITARISMO POSTERIOR A PROCEDIMIENTO"
  },
  {
    "codigo":31325007,
    "descripcion":"SÍNDROME DEL CROMOSOMA 21 EN ANILLO"
  },
  {
    "codigo":129629004,
    "descripcion":"PRESBIACUSIA METABÓLICA"
  },
  {
    "codigo":719453009,
    "descripcion":"ANEMIA DISERITROPOYÉTICA CONGÉNITA TIPO IV"
  },
  {
    "codigo":293469009,
    "descripcion":"REACCIÓN ADVERSA AL TRIAMTERENO"
  },
  {
    "codigo":422706003,
    "descripcion":"FIBROMA DE LA LENGUA"
  },
  {
    "codigo":95026005,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LAS VÍAS RESPIRATORIAS"
  },
  {
    "codigo":60423000,
    "descripcion":"DISFUNCIÓN DEL NÓDULO SINOAURICULAR"
  },
  {
    "codigo":291634009,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR CEFPIROMA"
  },
  {
    "codigo":191495003,
    "descripcion":"ESTADO DEPRESIVO MEDICAMENTOSO"
  },
  {
    "codigo":93191005,
    "descripcion":"LINFOMA MALIGNO DE LOS GANGLIOS LINFÁTICOS INTRABDOMINALES"
  },
  {
    "codigo":289799006,
    "descripcion":"CUELLO UTERINO HEMORRÁGICO"
  },
  {
    "codigo":91356001,
    "descripcion":"ÁNTRAX DE LA CARA"
  },
  {
    "codigo":124124006,
    "descripcion":"DEFICIENCIA DE MALATO DESHIDROGENASA"
  },
  {
    "codigo":58588007,
    "descripcion":"CUTIS LAXO"
  },
  {
    "codigo":255196008,
    "descripcion":"PÓLIPO ADENOMATOSO DE CUELLO DE ÚTERO"
  },
  {
    "codigo":253361002,
    "descripcion":"DILATACIÓN DE LA AURÍCULA IZQUIERDA"
  },
  {
    "codigo":286129009,
    "descripcion":"CAPAZ DE LIMPIAR EL ÁREA DE PREPARACIÓN DE COMIDAS"
  },
  {
    "codigo":284294002,
    "descripcion":"CAPAZ DE REALIZAR LA PRENSIÓN CON SUPINACIÓN DE LA MUÑECA"
  },
  {
    "codigo":251526004,
    "descripcion":"DISFUNCIÓN DE UN SOLO ÓRGANO"
  },
  {
    "codigo":22150007,
    "descripcion":"INTOXICACIÓN POR PITHECELLOBIUM JIRINGA"
  },
  {
    "codigo":282459005,
    "descripcion":"LACERACIÓN DE TRÁQUEA"
  },
  {
    "codigo":247856000,
    "descripcion":"MIEDO A LA ANESTESIA"
  },
  {
    "codigo":1481000119100,
    "descripcion":"DIABETES MELLITUS TIPO 2 SIN RETINOPATÍA"
  },
  {
    "codigo":15648201000119100,
    "descripcion":"ANEURISMA DE PORCIÓN INTRACRANEAL DE ARTERIA CARÓTIDA INTERNA DERECHA"
  },
  {
    "codigo":772144008,
    "descripcion":"HERNIA INGUINAL DERECHA OBSTRUIDA"
  },
  {
    "codigo":180485001,
    "descripcion":"TESAURISMOSIS POR GLUCOCEREBRÓSIDOS"
  },
  {
    "codigo":16645003,
    "descripcion":"ANEMIA CAUSADA POR VENENO DE INSECTO"
  },
  {
    "codigo":1163525003,
    "descripcion":"OCULOPATÍA ADENOVIRAL"
  },
  {
    "codigo":10677551000119108,
    "descripcion":"HIPERHIDROSIS FOCAL PRIMARIA DE AXILA"
  },
  {
    "codigo":702938004,
    "descripcion":"KLEBSIELLA PNEUMONIAE O KLEBSIELLA OXYTOCA"
  },
  {
    "codigo":276954004,
    "descripcion":"CARCINOMA ESCAMOSO DEL PISO DE LA BOCA"
  },
  {
    "codigo":209583000,
    "descripcion":"DESGARRO COMPLETO DE LIGAMENTO DE MUÑECA Y\/O MANO"
  },
  {
    "codigo":373423002,
    "descripcion":"ANESTESIA CORNEAL"
  },
  {
    "codigo":45743004,
    "descripcion":"FÍSTULA DUODENORRENAL"
  },
  {
    "codigo":78511005,
    "descripcion":"HISTOPLASMOSIS AFRICANA"
  },
  {
    "codigo":897711006,
    "descripcion":"NEUROESTIMULADOR IN SITU"
  },
  {
    "codigo":92040001,
    "descripcion":"NEOPLASIA BENIGNA DEL CIEGO"
  },
  {
    "codigo":109444001,
    "descripcion":"ANODONCIA DE LA DENTICIÓN PERMANENTE"
  },
  {
    "codigo":699268002,
    "descripcion":"MIOPATÍA CON DEFICIENCIA DE ENZIMA DE ENSAMBLADO DE GRUPOS DE HIERRO-AZUFRE"
  },
  {
    "codigo":12975009,
    "descripcion":"INFECCIÓN CAUSADA POR PARAFILARIA"
  },
  {
    "codigo":369753003,
    "descripcion":"CONFIGURACIÓN TUMORAL INTRADUCTAL"
  },
  {
    "codigo":271449003,
    "descripcion":"PAPILOMATOSIS MÚLTIPLE POR FRAMBESIA"
  },
  {
    "codigo":1156185004,
    "descripcion":"METATARSO PRIMUS VARO DE PIE DERECHO"
  },
  {
    "codigo":402521004,
    "descripcion":"CARCINOMA BASOCELULAR DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":238681004,
    "descripcion":"SARCOIDOSIS LIQUENOIDE"
  },
  {
    "codigo":42073009,
    "descripcion":"APORTE DE OXÍGENO AUMENTADO"
  },
  {
    "codigo":304217009,
    "descripcion":"FAMILIARES RETICENTES A LA DONACIÓN DE ÓRGANOS"
  },
  {
    "codigo":366083002,
    "descripcion":"CONVERGENCIA AL APROXIMAR UN OBJETO - HALLAZGO"
  },
  {
    "codigo":267779003,
    "descripcion":"CELULITIS Y ABSCESO DE CUELLO"
  },
  {
    "codigo":202243005,
    "descripcion":"SUBLUXACIÓN RECURRENTE DE ARTICULACIÓN INTERFALÁNGICA"
  },
  {
    "codigo":38403006,
    "descripcion":"VÉRTIGO DE ORIGEN CENTRAL"
  },
  {
    "codigo":726531007,
    "descripcion":"SÍNDROME DE DOLOR MIOFASCIAL"
  },
  {
    "codigo":167640000,
    "descripcion":"HUEVOS PRESENTES EN MATERIA FECAL"
  },
  {
    "codigo":235011009,
    "descripcion":"ABSCESO DENTAL MIGRATORIO"
  },
  {
    "codigo":823000002,
    "descripcion":"FIJACIÓN DE GANGLIO LINFÁTICO"
  },
  {
    "codigo":429784004,
    "descripcion":"PULSOS FEMORALES IGUALES"
  },
  {
    "codigo":397016004,
    "descripcion":"ENFERMEDAD SISTÉMICA DE LOS MASTOCITOS"
  },
  {
    "codigo":36568005,
    "descripcion":"SÍNDROME URÉMICO HEMOLÍTICO DE LA INFANCIA"
  },
  {
    "codigo":724696008,
    "descripcion":"TRASTORNO PSICÓTICO CAUSADO POR ALUCINÓGENO"
  },
  {
    "codigo":11771491000119107,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN DE CODO IZQUIERDO"
  },
  {
    "codigo":722861005,
    "descripcion":"DERMATOSIS DE REGIÓN PERIANAL CAUSADA POR ENTEROBIUS VERMICULARIS"
  },
  {
    "codigo":1148845007,
    "descripcion":"LINFOMA FOLICULAR GRADO 3B"
  },
  {
    "codigo":1965009,
    "descripcion":"PH NORMAL DE LA PIEL"
  },
  {
    "codigo":296877009,
    "descripcion":"SOBREDOSIS DE HORMONA SEXUAL"
  },
  {
    "codigo":11826941000119103,
    "descripcion":"LESIÓN TRAUMÁTICA DE ARTERIA FEMORAL DERECHA"
  },
  {
    "codigo":360578005,
    "descripcion":"HIPERTENSIÓN PULMONAR SECUNDARIA A ELEVACIÓN DE LA RESISTENCIA VASCULAR PULMONAR"
  },
  {
    "codigo":1343618008,
    "descripcion":"MUCOCELE CRÓNICO LAGRIMAL"
  },
  {
    "codigo":1179778008,
    "descripcion":"IMAGEN ANORMAL EN RESONANCIA MAGNÉTICA DE CEREBRO CAUSADA POR PÉPTIDO BETA AMILOIDE"
  },
  {
    "codigo":162135003,
    "descripcion":"ORINA DE COLOR CLARO"
  },
  {
    "codigo":719191003,
    "descripcion":"ATROFIA DE MÚSCULO DELTOIDES"
  },
  {
    "codigo":16905981000119104,
    "descripcion":"CARCINOMA DE CÉLULAS DE MERKEL PRIMARIO DE PIEL DE PÁRPADO INFERIOR IZQUIERDO"
  },
  {
    "codigo":293207006,
    "descripcion":"REACCIÓN ADVERSA A PROGESTÁGENOS"
  },
  {
    "codigo":424279009,
    "descripcion":"LEIOMIOMA DEL INTESTINO DELGADO"
  },
  {
    "codigo":1208876004,
    "descripcion":"PARÁLISIS DE MIRADA HORIZONTAL ADQUIRIDA"
  },
  {
    "codigo":422444006,
    "descripcion":"LESIÓN TRAUMÁTICA DEL PULGAR POR HIPEREXTENSIÓN"
  },
  {
    "codigo":225836009,
    "descripcion":"NO QUIERE UN AMPARO"
  },
  {
    "codigo":94764009,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE HUESO DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":685821000119107,
    "descripcion":"LIPOMA DE TRONCO"
  },
  {
    "codigo":92929007,
    "descripcion":"FORMA ANORMAL CONGÉNITA DEL METATARSO"
  },
  {
    "codigo":289537009,
    "descripcion":"ELIMINACIÓN DE SANGRE MODIFICADA POR VAGINA"
  },
  {
    "codigo":1172438003,
    "descripcion":"CORTICOSTERONA DENTRO DE RANGO DE REFERENCIA"
  },
  {
    "codigo":254934003,
    "descripcion":"NEOPLASIA MALIGNA DE MUÑÓN URETRAL"
  },
  {
    "codigo":58326007,
    "descripcion":"NEGATIVISMO"
  },
  {
    "codigo":449707004,
    "descripcion":"EDEMA DE PIERNA"
  },
  {
    "codigo":251264001,
    "descripcion":"ONDA U BÍFIDA"
  },
  {
    "codigo":710016004,
    "descripcion":"INSERCIÓN MUSCULAR EN ESTADO EDÉNTULO SIN MUCOSA ADHERIDA EN NINGUNA REGIÓN"
  },
  {
    "codigo":282197001,
    "descripcion":"CAPAZ DE BAJAR ESCALERAS"
  },
  {
    "codigo":249429003,
    "descripcion":"SECRECIÓN DE CONDUCTO SALIVAL"
  },
  {
    "codigo":314965007,
    "descripcion":"RECIDIVA LOCAL DE NEOPLASIA MALIGNA DE COLON"
  },
  {
    "codigo":50986000,
    "descripcion":"FÍSTULA CONGÉNITA DEL URACO"
  },
  {
    "codigo":313130001,
    "descripcion":"MEMBRANA UTERINA - HALLAZGO"
  },
  {
    "codigo":85589009,
    "descripcion":"SÍNDROME DE APLASIA RADIAL - TROMBOCITOPENIA"
  },
  {
    "codigo":331671000119108,
    "descripcion":"ENTROPIÓN CICATRIZAL DE PÁRPADO SUPERIOR DERECHO"
  },
  {
    "codigo":247594005,
    "descripcion":"OLVIDA LO QUE IBA A DECIR"
  },
  {
    "codigo":278527001,
    "descripcion":"HIPERPLASIA NODULAR FOCAL DEL HÍGADO"
  },
  {
    "codigo":81919004,
    "descripcion":"HIBRIDIZACIÓN"
  },
  {
    "codigo":276692000,
    "descripcion":"NEUMONÍA VIRAL CONGÉNITA"
  },
  {
    "codigo":735444001,
    "descripcion":"LINFOCITOSIS ADQUIRIDA"
  },
  {
    "codigo":1259732000,
    "descripcion":"OLIGODENDROGLIOMA PRIMARIO DE MÉDULA ESPINAL"
  },
  {
    "codigo":405929000,
    "descripcion":"PARTES BLANDAS DE SENO RENAL INVOLUCRADAS POR TUMOR"
  },
  {
    "codigo":12713001,
    "descripcion":"CELULITIS DE LA PIEL, CON LINFANGITIS"
  },
  {
    "codigo":307625008,
    "descripcion":"LINFOMA MALIGNO - CENTROCÍTICO"
  },
  {
    "codigo":10878002,
    "descripcion":"ANEURISMA DE ARTERIA CARÓTIDA PRIMITIVA"
  },
  {
    "codigo":305790002,
    "descripcion":"VISTO POR PERSONAL DEL DEPARTAMENTO DE SERVICIOS SOCIALES"
  },
  {
    "codigo":1256062004,
    "descripcion":"TRICOTEMNOMANÍA"
  },
  {
    "codigo":240254005,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE ARTICULACIÓN DE PRIMER DEDO DEL PIE"
  },
  {
    "codigo":699006006,
    "descripcion":"DISPOSITIVO DE DERIVACIÓN VENTRICULAR IN SITU"
  },
  {
    "codigo":404094007,
    "descripcion":"METÁSTASIS QUE INVOLUCRA CAVIDAD BUCAL"
  },
  {
    "codigo":762707000,
    "descripcion":"DEMENCIA SUBCORTICAL"
  },
  {
    "codigo":238419002,
    "descripcion":"LINFANGITIS GONOCÓCICA DE PENE"
  },
  {
    "codigo":205651007,
    "descripcion":"TRISOMÍA 10"
  },
  {
    "codigo":402259008,
    "descripcion":"QUEMADURA POR DITRANOL"
  },
  {
    "codigo":1186856001,
    "descripcion":"NEURODEGENERACIÓN ATÍPICA ASOCIADA A PANTOTENATO CINASA"
  },
  {
    "codigo":105512005,
    "descripcion":"DESAVENENCIA CON EL PROPIETARIO DE UNA VIVIENDA"
  },
  {
    "codigo":302120006,
    "descripcion":"APTO PARA VOLVER A TRABAJAR"
  },
  {
    "codigo":72744008,
    "descripcion":"SÍNDROME DE GRONBLAD - STRANDBERG"
  },
  {
    "codigo":236584009,
    "descripcion":"LESIÓN POR PERFUSIÓN EN EL TRASPLANTE RENAL"
  },
  {
    "codigo":1285160009,
    "descripcion":"DOLOR AGRAVADO POR POSICIÓN"
  },
  {
    "codigo":201981006,
    "descripcion":"ARTRITIS CLIMATÉRICA DE LA REGIÓN PÉLVICA Y EL MUSLO"
  },
  {
    "codigo":365821006,
    "descripcion":"HALLAZGO RELACIONADO CON PRESENCIA DE SUSTANCIA REDUCTORAS EN ORINA"
  },
  {
    "codigo":267517008,
    "descripcion":"ANEMIA POR DEFICIENCIA DE VITAMINA B12, DE CAUSA ALIMENTARIA"
  },
  {
    "codigo":724434000,
    "descripcion":"CHOQUE INADECUADO DE CARDIOVERSOR IMPLANTABLE"
  },
  {
    "codigo":327768421000119103,
    "descripcion":"RETINOPATÍA NO PROLIFERATIVA DE OJO IZQUIERDO DEBIDA A ANEMIA DREPANOCÍTICA"
  },
  {
    "codigo":1148583001,
    "descripcion":"FLEBITIS EN EL EMBARAZO"
  },
  {
    "codigo":334181000119104,
    "descripcion":"ORZUELO EXTERNO DE PÁRPADO INFERIOR DE OJO DERECHO"
  },
  {
    "codigo":296615005,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE AZITROMICINA"
  },
  {
    "codigo":1703007,
    "descripcion":"CIRCUNFERENCIA DE PIERNA AUMENTADA"
  },
  {
    "codigo":722599008,
    "descripcion":"PARKINSONISMO DEBIDO A PARAPLEJÍA ESPÁSTICA HEREDITARIA"
  },
  {
    "codigo":427687008,
    "descripcion":"IMAGEN RADIOGRÁFICA NO CORRELACIONADA CON EL HALLAZGO TUMORAL DE ANATOMÍA PATOLÓGICA"
  },
  {
    "codigo":1343356001,
    "descripcion":"ACCESO DIGITAL INADECUADO QUE AFECTA LA ATENCIÓN DE LA SALUD"
  },
  {
    "codigo":788135008,
    "descripcion":"GEOBACILLUS THERMODENITRIFICANS O GEOBACILLUS THERMOGLUCOSIDASIUS"
  },
  {
    "codigo":165543009,
    "descripcion":"LEUCOCITOS INMADUROS"
  },
  {
    "codigo":425852005,
    "descripcion":"CONSOLIDACIÓN DE FRACTURA DEFECTUOSA"
  },
  {
    "codigo":196476006,
    "descripcion":"ATROFIA DE GLÁNDULA SUBLINGUAL"
  },
  {
    "codigo":718929000,
    "descripcion":"DISFUNCIÓN SOMÁTICA DE REGIÓN LUMBAR"
  },
  {
    "codigo":63569001,
    "descripcion":"METABOLISMO DEFECTUOSO"
  },
  {
    "codigo":32636009,
    "descripcion":"PERIOSTITIS DE REGIÓN DE HOMBRO"
  },
  {
    "codigo":65404009,
    "descripcion":"DESNUTRICIÓN"
  },
  {
    "codigo":161873000,
    "descripcion":"PIERNAS PESADAS"
  },
  {
    "codigo":1144913005,
    "descripcion":"METABOLIZADOR INTERMEDIO DE LA FAMILIA 2 SUBFAMILIA C MIEMBRO 9 *1\/*3 DEL CITOCROMO P450"
  },
  {
    "codigo":292945007,
    "descripcion":"REACCIÓN ADVERSA A 4-QUINOLONAS"
  },
  {
    "codigo":424017009,
    "descripcion":"HALLAZGO RELACIONADO CON LA ACTIVIDAD ENZIMÁTICA"
  },
  {
    "codigo":28966002,
    "descripcion":"PERICARDITIS PARASITARIA"
  },
  {
    "codigo":127270003,
    "descripcion":"NEOPLASIA DE LOS GANGLIOS LINFÁTICOS HIPOGÁSTRICOS"
  },
  {
    "codigo":190971000,
    "descripcion":"SECUELAS DE HIPERALIMENTACIÓN"
  },
  {
    "codigo":225574009,
    "descripcion":"DOLOR A LA PALPACIÓN EN PEZÓN"
  },
  {
    "codigo":1208614008,
    "descripcion":"SÍNDROME DE SORDERA ONICODISTROFIA AUTOSÓMICA DOMINANTE"
  },
  {
    "codigo":94502008,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA REGIÓN PRESACRA"
  },
  {
    "codigo":289275005,
    "descripcion":"OLOR NAUSEABUNDO DE LA PLACENTA"
  },
  {
    "codigo":713424004,
    "descripcion":"TAQUICARDIA AURICULAR FOCAL ELECTROCARDIOGRÁFICA"
  },
  {
    "codigo":10629631000119106,
    "descripcion":"PANSINUSITIS AGUDA RECURRENTE"
  },
  {
    "codigo":123600006,
    "descripcion":"GASTROMALACIA"
  },
  {
    "codigo":189136007,
    "descripcion":"NEOPLASIA BENIGNA DE CUERPO CAVERNOSO"
  },
  {
    "codigo":449445004,
    "descripcion":"MALA POSICIÓN CORREGIDA ANATÓMICAMENTE CON CONEXIONES VENTRICULOARTERIALES CONCORDANTES Y GRANDES ARTERIAS PARALELAS"
  },
  {
    "codigo":54394007,
    "descripcion":"LUXACIÓN EXPUESTA DE TOBILLO"
  },
  {
    "codigo":1332346007,
    "descripcion":"HIPERTROFIA DE RADIO"
  },
  {
    "codigo":52559000,
    "descripcion":"DISFUNCIÓN MOTORA"
  },
  {
    "codigo":21626009,
    "descripcion":"HIPERSENSIBILIDAD CUTÁNEA"
  },
  {
    "codigo":251002009,
    "descripcion":"CALCIFICACIÓN DE ANILLO DE VÁLVULA MITRAL"
  },
  {
    "codigo":283770008,
    "descripcion":"MORDEDURA DE PERRO EN EL MUSLO"
  },
  {
    "codigo":314703005,
    "descripcion":"TALLA DEL NIÑO: > PERCENTILO 99,6"
  },
  {
    "codigo":281935009,
    "descripcion":"FRACTURA DE PEDÍCULO DE VÉRTEBRA LUMBAR"
  },
  {
    "codigo":16583321000119106,
    "descripcion":"ARTROSIS DE TOBILLO DERECHO DEBIDA A TRAUMATISMO"
  },
  {
    "codigo":1073971000119100,
    "descripcion":"BURSITIS GOTOSA DE OLÉCRANON IZQUIERDO"
  },
  {
    "codigo":50724007,
    "descripcion":"PRESENTACIÓN FETAL LONGITUDINAL"
  },
  {
    "codigo":1163001000,
    "descripcion":"HEMORRAGIA EPIPLOICA"
  },
  {
    "codigo":16121001,
    "descripcion":"ÚLCERA GASTROYEYUNAL"
  },
  {
    "codigo":704249000,
    "descripcion":"FRACTURA PATOLÓGICA DE FÉMUR PROXIMAL EN SITIO DE NEOPLASIA"
  },
  {
    "codigo":247332007,
    "descripcion":"OÍDO QUE SE SIENTE LLENO DE AGUA"
  },
  {
    "codigo":442105001,
    "descripcion":"EMBOLIA SÉPTICA DE ARTERIA"
  },
  {
    "codigo":276430001,
    "descripcion":"SECCIÓN TRAUMÁTICA DE TENDÓN EXTENSOR - ZONA 4"
  },
  {
    "codigo":1259470002,
    "descripcion":"CARCINOMA NO QUERATINIZANTE DE NASOFARINGE PRIMARIO"
  },
  {
    "codigo":47054003,
    "descripcion":"VAGINA TABICADA"
  },
  {
    "codigo":11831961000119109,
    "descripcion":"LACERACIÓN DE VASO SANGUÍNEO DE DEDO MEDIO DE MANO DERECHA"
  },
  {
    "codigo":14286004,
    "descripcion":"FORNICACIÓN"
  },
  {
    "codigo":309198006,
    "descripcion":"HALLAZGOS HISTOLÓGICOS ANORMALES"
  },
  {
    "codigo":210894007,
    "descripcion":"LESIÓN EXPUESTA, ARTERIA PLANTAR PROFUNDA"
  },
  {
    "codigo":473038008,
    "descripcion":"COMPLICACIÓN ASOCIADA CON DISPOSITIVO ORTOPÉDICO"
  },
  {
    "codigo":12451000,
    "descripcion":"EXCAVACIÓN DE PAPILA ÓPTICA"
  },
  {
    "codigo":77987006,
    "descripcion":"ÚLCERA GASTROYEYUNAL AGUDA SIN HEMORRAGIA, SIN PERFORACIÓN Y SIN OBSTRUCCIÓN"
  },
  {
    "codigo":241827006,
    "descripcion":"INTOXICACIÓN POR MOLUSCO VENENOSO"
  },
  {
    "codigo":307363008,
    "descripcion":"INFARTOS LAGUNARES MÚLTIPLES"
  },
  {
    "codigo":698744001,
    "descripcion":"CUADRIPLEJÍA CRÓNICA INCOMPLETA DEBIDA A LESIÓN DE MÉDULA ESPINAL ENTRE QUINTA Y SÉPTIMA VÉRTEBRAS CERVICALES"
  },
  {
    "codigo":43384002,
    "descripcion":"TOXICIDAD POR GLIFOSFATO"
  },
  {
    "codigo":1255800001,
    "descripcion":"ENFERMEDAD DE SÉZARY DE GANGLIOS LINFÁTICOS DE CUELLO"
  },
  {
    "codigo":403832004,
    "descripcion":"TRASTORNO HEREDITARIO EN EL METABOLISMO DE LA PORFIRINA"
  },
  {
    "codigo":733347006,
    "descripcion":"NEOPLASIA QUÍSTICA MUCINOSA PRIMARIA CON CARCINOMA INVASIVO ASOCIADO DE CONDUCTO CÍSTICO"
  },
  {
    "codigo":371064006,
    "descripcion":"FRACASO DE TRATAMIENTO DEBIDO A RESISTENCIA A ANTIBIÓTICO"
  },
  {
    "codigo":305528003,
    "descripcion":"BAJO ATENCIÓN DE CIRUJANO TORÁCICO"
  },
  {
    "codigo":74317000,
    "descripcion":"EPIDERMOPOYESIS DISMINUIDA"
  },
  {
    "codigo":239992008,
    "descripcion":"BURSITIS DE LA REGIÓN PÉLVICA"
  },
  {
    "codigo":860749004,
    "descripcion":"NIVEL DE SUSTANCIA EN SANGRE POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":238157005,
    "descripcion":"ALTERACIÓN DE LOS GASES SANGUÍNEOS"
  },
  {
    "codigo":367394000,
    "descripcion":"TEXTURA DE LA PIEL O DE LA MUCOSA"
  },
  {
    "codigo":203554005,
    "descripcion":"DEFORMIDAD EN FLEXIÓN DE DEDO DE LA MANO"
  },
  {
    "codigo":1186594006,
    "descripcion":"PENTOSA DENTRO DE RANGO DE REFERENCIA"
  },
  {
    "codigo":170786005,
    "descripcion":"CAMBIO EN LOS SÍNTOMAS TIROIDEOS"
  },
  {
    "codigo":70647001,
    "descripcion":"FRAMBESIA"
  },
  {
    "codigo":234487003,
    "descripcion":"TROMBOCITOPENIA DEL MEDITERRÁNEO"
  },
  {
    "codigo":365559007,
    "descripcion":"DERECHO A RECIBIR SUBSIDIO - HALLAZGO"
  },
  {
    "codigo":724172004,
    "descripcion":"SÍNDROME DE NEUROACANTOCITOSIS DE MCLEOD"
  },
  {
    "codigo":3276005,
    "descripcion":"INTOXICACIÓN POR INGESTA DE SAPO"
  },
  {
    "codigo":298188006,
    "descripcion":"HIPERMOVILIDAD DE ARTICULACIÓN DE HOMBRO"
  },
  {
    "codigo":429260008,
    "descripcion":"TRASTORNO DEL CORDÓN UMBILICAL"
  },
  {
    "codigo":165281000,
    "descripcion":"MEMORIA: RECUERDA SU PROPIA EDAD"
  },
  {
    "codigo":310221000119107,
    "descripcion":"ARTRITIS GOTOSA DE RODILLA IZQUIERDA"
  },
  {
    "codigo":34209003,
    "descripcion":"HEMIPLEJÍA CEREBRAL"
  },
  {
    "codigo":720502000,
    "descripcion":"SÍNDROME DE ARACNODACTILIA Y DISCAPACIDAD INTELECTUAL CON DISMORFISMO FACIAL"
  },
  {
    "codigo":786038001,
    "descripcion":"CARCINOMA NO MEDULAR DE GLÁNDULA TIROIDES FAMILIAR PRIMARIO"
  },
  {
    "codigo":294518000,
    "descripcion":"ALERGIA A CARFECILINA"
  },
  {
    "codigo":296353008,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE NICOTINA"
  },
  {
    "codigo":390987000,
    "descripcion":"PACIENTE CONSCIENTE DE SU MAMA"
  },
  {
    "codigo":127008002,
    "descripcion":"NEOPLASIA DE LAS CELDILLAS MASTOIDEAS"
  },
  {
    "codigo":421920002,
    "descripcion":"CATARATA DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":1076481000119100,
    "descripcion":"RUPTURA COMPLETA NO TRAUMÁTICA DE ESTRUCTURA MUSCULAR O TENDINOSA DE MANGUITO ROTADOR DE HOMBRO DERECHO"
  },
  {
    "codigo":94240007,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE HUESO DEL CARPO"
  },
  {
    "codigo":289013000,
    "descripcion":"INCAPAZ DE COLOCAR ALIMENTO EN LA BOCA"
  },
  {
    "codigo":714997002,
    "descripcion":"DIFICULTAD PARA NADAR"
  },
  {
    "codigo":92405007,
    "descripcion":"NEOPLASIA BENIGNA DE LA MÉDULA ESPINAL"
  },
  {
    "codigo":339201000119102,
    "descripcion":"SIDEROSIS DE OJO IZQUIERDO"
  },
  {
    "codigo":11834471000119108,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA DE PULGAR IZQUIERDO"
  },
  {
    "codigo":1335754002,
    "descripcion":"TRASTORNO DE LIGAMENTO DE ARTICULACIÓN DE TOBILLO"
  },
  {
    "codigo":254410003,
    "descripcion":"NEOPLASIA BENIGNA DE PARTE LATERAL DE CUERPO DE LA LENGUA"
  },
  {
    "codigo":385482004,
    "descripcion":"OSTEOGÉNESIS IMPERFECTA TIPO I"
  },
  {
    "codigo":55967005,
    "descripcion":"TRASTORNO DE ANSIEDAD CAUSADO POR FENCICLIDINA"
  },
  {
    "codigo":1268383007,
    "descripcion":"USUARIO DE METILENDIOXIMETANFETAMINA"
  },
  {
    "codigo":187039009,
    "descripcion":"HISTOPLASMA CAPSULATUM CON RETINITIS"
  },
  {
    "codigo":283508004,
    "descripcion":"HERIDA PUNZANTE DE CUELLO"
  },
  {
    "codigo":709492005,
    "descripcion":"AUSENCIA DE CÓNDILO MANDIBULAR"
  },
  {
    "codigo":86900005,
    "descripcion":"PIE CAVO ADQUIRIDO"
  },
  {
    "codigo":447348006,
    "descripcion":"LACERACIÓN DE ARTERIA TIBIAL POSTERIOR"
  },
  {
    "codigo":12217601000119107,
    "descripcion":"FRACTURA DE HUESO ADYACENTE A PRÓTESIS DE ARTICULACIÓN DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":52297004,
    "descripcion":"SANGRADO MAMARIO"
  },
  {
    "codigo":445513004,
    "descripcion":"HEMANGIOMA CAVERNOSO INTRACRANEAL"
  },
  {
    "codigo":412745007,
    "descripcion":"ANGIOCARDIOGRAFÍA EQUÍVOCA"
  },
  {
    "codigo":248905007,
    "descripcion":"CALOR EN EL FONDO DE SACO VAGINAL"
  },
  {
    "codigo":1197342001,
    "descripcion":"TERATOCARCINOMA PRIMARIO DE HÍGADO"
  },
  {
    "codigo":247070004,
    "descripcion":"AFAQUIA - PERLAS DE ELSCHNIG"
  },
  {
    "codigo":66971000119103,
    "descripcion":"PORTADOR DE HEMOCROMATOSIS"
  },
  {
    "codigo":443678007,
    "descripcion":"CUERPO EXTRAÑO: ASTILLA"
  },
  {
    "codigo":15859004,
    "descripcion":"DIETA PARA HEMODIÁLISIS CRÓNICA"
  },
  {
    "codigo":212467009,
    "descripcion":"LESIÓN DE MÚSCULO Y TENDÓN A NIVEL DE CADERA Y MUSLO"
  },
  {
    "codigo":703987009,
    "descripcion":"FRACTURA NO EXPUESTA DE FALANGE DISTAL DE DEDO MEÑIQUE"
  },
  {
    "codigo":472776004,
    "descripcion":"DISFUNCIÓN BIVENTRICULAR FETAL"
  },
  {
    "codigo":210632005,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DEL PULPEJO DE DEDO DE LA MANO, TIPO 1 (SÓLO COMPROMISO DEL PULPEJO)"
  },
  {
    "codigo":1259208006,
    "descripcion":"TRASTORNO NEONATAL PRECOZ DEBIDO A EXTRACCIÓN DE NALGAS"
  },
  {
    "codigo":79560005,
    "descripcion":"ABSCESO MEDIO ABDOMINAL"
  },
  {
    "codigo":12189000,
    "descripcion":"ANEMIA HEMOLÍTICA COOMBS NEGATIVA"
  },
  {
    "codigo":208797001,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN DE CODO, INTERNA"
  },
  {
    "codigo":1290141002,
    "descripcion":"ORINA DE ASPECTO LEVEMENTE TURBIO"
  },
  {
    "codigo":14024008,
    "descripcion":"ANEMIA APLÁSICA RELACIONADA CON TRASTORNO DE LA INMUNIDAD HUMORAL"
  },
  {
    "codigo":733085004,
    "descripcion":"TRASTORNO CONGÉNITO DE GLICOSILACIÓN TIPO 1P"
  },
  {
    "codigo":307101004,
    "descripcion":"ABANDONADO POR EL PADRE"
  },
  {
    "codigo":700317009,
    "descripcion":"ARTROSIS DE ARTICULACIÓN CALCANEOCUBOIDEA SECUNDARIA A ARTRITIS INFLAMATORIA"
  },
  {
    "codigo":698482005,
    "descripcion":"ENFERMEDAD OCUPACIONAL DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":403570005,
    "descripcion":"CALCINOSIS CON QUISTE O TUMOR CUTÁNEO"
  },
  {
    "codigo":237895001,
    "descripcion":"RAQUITISMO DEPENDIENTE DE VITAMINA D TIPO II SIN ALOPECIA"
  },
  {
    "codigo":239730009,
    "descripcion":"DEFICIENCIA DEL LIGAMENTO LATERAL EXTERNO DE LA RODILLA"
  },
  {
    "codigo":205127001,
    "descripcion":"POLIDACTILIA RADIAL DE WASSEL 6"
  },
  {
    "codigo":15932981000119104,
    "descripcion":"OBSTRUCCIÓN PARCIAL DE TROMPA UTERINA DERECHA"
  },
  {
    "codigo":1352007006,
    "descripcion":"RECUPERACIÓN COMPLETA DE EVENTO ADVERSO"
  },
  {
    "codigo":286261000119105,
    "descripcion":"PUENTE CON STENT CON CUBIERTA PRESENTE"
  },
  {
    "codigo":8519009,
    "descripcion":"TRAQUEÍTIS AGUDA CON OBSTRUCCIÓN"
  },
  {
    "codigo":301596001,
    "descripcion":"SUBE Y BAJA ESCALERAS GATEANDO"
  },
  {
    "codigo":39452003,
    "descripcion":"TRASTORNO DEL METABOLISMO DE LA FRUCTOSA"
  },
  {
    "codigo":1153564003,
    "descripcion":"PROGESTERONA SÉRICA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":203292005,
    "descripcion":"OSTEOPATÍA POR POLIOMIELITIS DE TOBILLO Y\/O PIE"
  },
  {
    "codigo":299761002,
    "descripcion":"REFLEJO DE DEGLUCIÓN DUDOSO"
  },
  {
    "codigo":1162291005,
    "descripcion":"INFLAMACIÓN DE MÚSCULO ESQUELÉTICO CAUSADA POR MYCOBACTERIUM"
  },
  {
    "codigo":15988431000119101,
    "descripcion":"CONJUNTIVITIS BILATERAL CAUSADA POR MYCOBACTERIUM TUBERCULOSIS"
  },
  {
    "codigo":234225006,
    "descripcion":"TAQUICARDIA REENTRANTE POR MARCAPASOS CARDÍACO"
  },
  {
    "codigo":398065006,
    "descripcion":"PACIENTE CON LA CABEZA LEVANTADA"
  },
  {
    "codigo":365297008,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD DE APAGAR LA INSTALACIÓN PRINCIPAL DE GAS"
  },
  {
    "codigo":70385007,
    "descripcion":"FARINGOCONJUNTIVITIS ADENOVIRAL"
  },
  {
    "codigo":3014005,
    "descripcion":"DERMATITIS POR SENSIBILIZACIÓN"
  },
  {
    "codigo":363462005,
    "descripcion":"NEOPLASIA MALIGNA DE ÓRBITA"
  },
  {
    "codigo":68550008,
    "descripcion":"ALTERACIÓN DE LA REGULACIÓN DE LA TEMPERATURA DEL RECIÉN NACIDO"
  },
  {
    "codigo":396230008,
    "descripcion":"DERMATOMIOSITIS"
  },
  {
    "codigo":165019004,
    "descripcion":"PRUEBA DE FUNCIÓN PULMONAR ANORMAL"
  },
  {
    "codigo":722075004,
    "descripcion":"SÍNDROME OROFACIAL DIGITAL TIPO 10"
  },
  {
    "codigo":296091004,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE CLOBAZAM"
  },
  {
    "codigo":33947007,
    "descripcion":"ENFERMEDAD CAUSADA POR TOGAVIRIDAE"
  },
  {
    "codigo":294256000,
    "descripcion":"ALERGIA A PROSTAGLANDINA, SERIE F"
  },
  {
    "codigo":64880000,
    "descripcion":"BRONCONEUMONÍA CAUSADA POR EL VIRUS PARAINFLUENZA"
  },
  {
    "codigo":341711000119106,
    "descripcion":"CICATRIZ CORIORRETINIANA DE OJO IZQUIERDO"
  },
  {
    "codigo":32112006,
    "descripcion":"FLEBITIS DEL SENO SAGITAL INFERIOR"
  },
  {
    "codigo":16699241000119100,
    "descripcion":"SARCOMA DE KAPOSI DE DEDO DEL PIE"
  },
  {
    "codigo":292421000,
    "descripcion":"REACCIÓN ADVERSA AL ACEBUTOLOL"
  },
  {
    "codigo":1078991000119106,
    "descripcion":"ANGIOMIOLIPOMA DE RIÑÓN IZQUIERDO"
  },
  {
    "codigo":1144389005,
    "descripcion":"HIPOPLASIA CONGÉNITA DE VERMIS INFERIOR"
  },
  {
    "codigo":95813007,
    "descripcion":"PERFORACIÓN DE LA MEMBRANA TIMPÁNICA CON PROLIFERACIÓN DE EPITELIO QUERATINIZADO DESDE EL OÍDO MEDIO AL OÍDO EXTERNO"
  },
  {
    "codigo":225050000,
    "descripcion":"AHOGARSE"
  },
  {
    "codigo":28442001,
    "descripcion":"POLIURIA"
  },
  {
    "codigo":30277009,
    "descripcion":"RUPTURA DE VENTRÍCULO DEBIDA A INFARTO AGUDO DE MIOCARDIO"
  },
  {
    "codigo":11784041000119103,
    "descripcion":"HERIDA INFECTADA DE MUÑECA DERECHA DEBIDA A PICADURA DE INSECTO NO VENENOSO"
  },
  {
    "codigo":93978008,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL SENO PIRIFORME"
  },
  {
    "codigo":126746009,
    "descripcion":"NEOPLASIA DE VASO SANGUÍNEO DE DEDO DE LA MANO"
  },
  {
    "codigo":92143001,
    "descripcion":"NEOPLASIA BENIGNA DE LOS GANGLIOS LINFÁTICOS INFRACLAVICULARES"
  },
  {
    "codigo":288751001,
    "descripcion":"INCAPAZ DE COMUNICAR ALGO SOBRE SÍ MISMO"
  },
  {
    "codigo":190447002,
    "descripcion":"DIABETES INDUCIDA POR ESTEROIDES"
  },
  {
    "codigo":188612002,
    "descripcion":"LINFOMA NODULAR DE GANGLIOS LINFÁTICOS DE AXILA Y EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":254148004,
    "descripcion":"ACROSTEÓLISIS HEREDITARIA"
  },
  {
    "codigo":315241000119106,
    "descripcion":"OSTEOCONDRITIS DISECANTE DE RODILLA DERECHA"
  },
  {
    "codigo":1204420006,
    "descripcion":"OSTEOMIELITIS CRÓNICA NO BACTERIANA\/OSTEOMIELITIS CRÓNICA MULTIFOCAL RECURRENTE"
  },
  {
    "codigo":57540006,
    "descripcion":"INFECCIÓN INTESTINAL POR NEMATODOS"
  },
  {
    "codigo":448921000,
    "descripcion":"ASPERMIA"
  },
  {
    "codigo":416153006,
    "descripcion":"DESLIZAMIENTO INFERIOR DE HUESO INNOMINADO"
  },
  {
    "codigo":370851000221105,
    "descripcion":"ANEMIA FERROPÉNICA LEVE DEL EMBARAZO"
  },
  {
    "codigo":283246005,
    "descripcion":"VIDRIO EN EL BRAZO"
  },
  {
    "codigo":217710005,
    "descripcion":"SÍNDROME DE HIPOTIROIDISMO CONGÉNITO DEBIDO A DEFICIENCIA DE YODO"
  },
  {
    "codigo":86638007,
    "descripcion":"NEUMOPATÍA DE LOS DESCORTEZADORES DE ARCE"
  },
  {
    "codigo":707395000,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE HIPOFARINGE"
  },
  {
    "codigo":445251003,
    "descripcion":"FALTA DE FUSIÓN DE ACROMION DE OMÓPLATO"
  },
  {
    "codigo":1231683004,
    "descripcion":"OFTALMOPLEJÍA DEBIDA A ENFERMEDAD DE ALMACENAMIENTO DE ÁCIDO FITÁNICO"
  },
  {
    "codigo":52035003,
    "descripcion":"INFARTO AGUDO DE MIOCARDIO ANTEROAPICAL"
  },
  {
    "codigo":281411007,
    "descripcion":"DIPLEJÍA ESPÁSTICA"
  },
  {
    "codigo":246808001,
    "descripcion":"PLIEGUE SEMILUNAR - HALLAZGO"
  },
  {
    "codigo":19267009,
    "descripcion":"ANTICOAGULANTE LÚPICO"
  },
  {
    "codigo":115736003,
    "descripcion":"GRUPO SANGUÍNEO A>H<"
  },
  {
    "codigo":443416007,
    "descripcion":"NEOPLASIA ADENOMATOSA BENIGNA"
  },
  {
    "codigo":212205001,
    "descripcion":"LESIÓN DE LA RAÍZ DEL NERVIO CERVICAL - C8"
  },
  {
    "codigo":16754691000119107,
    "descripcion":"SANGRADO UTERINO ANORMAL DEBIDO A FIBROMA UTERINO SUBMUCOSO"
  },
  {
    "codigo":81133003,
    "descripcion":"TUBERCULOSIS DE LOS HUESOS DE LAS EXTREMIDADES INFERIORES"
  },
  {
    "codigo":408813008,
    "descripcion":"POSICIÓN OCCIPITOILÍACA DIRECTA"
  },
  {
    "codigo":13762005,
    "descripcion":"EXOTROPÍA MONOCULAR NO CONCOMITANTE DISTINTA DEL PATRÓN EN A O V"
  },
  {
    "codigo":112066009,
    "descripcion":"FUNCIÓN RENAL AUSENTE"
  },
  {
    "codigo":79298009,
    "descripcion":"DEPRESIÓN MAYOR LEVE, UN SOLO EPISODIO"
  },
  {
    "codigo":44695005,
    "descripcion":"PARÁLISIS"
  },
  {
    "codigo":110231005,
    "descripcion":"QUEMADURA DE PRIMER GRADO DE LA REGIÓN AMIGDALINA"
  },
  {
    "codigo":403308000,
    "descripcion":"DEFORMIDAD UNGUEAL ADQUIRIDA"
  },
  {
    "codigo":700055009,
    "descripcion":"SEPSIS CON MANIFESTACIONES CUTÁNEAS"
  },
  {
    "codigo":1255276000,
    "descripcion":"FRACTURA NO EXPUESTA DE FALANGE PROXIMAL DE MÚLTIPLES DEDOS DE MANO"
  },
  {
    "codigo":344221000119106,
    "descripcion":"PSEUDOPTERIGIÓN DE AMBOS OJOS"
  },
  {
    "codigo":370540009,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR ALIMENTO"
  },
  {
    "codigo":16236701000119107,
    "descripcion":"DELIRIO DEBIDO A SÍNDROME DE ABSTINENCIA DE SUSTANCIA"
  },
  {
    "codigo":1081501000119107,
    "descripcion":"NEVO EPIDÉRMICO PILOSO PIGMENTADO DE MIEMBRO INFERIOR IZQUIERDO"
  },
  {
    "codigo":11813021000119108,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA PARCIAL DE ÓRGANO GENITAL FEMENINO"
  },
  {
    "codigo":237633009,
    "descripcion":"HIPOGLUCEMIA DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":658001000005107,
    "descripcion":"PLACENTA UBICADA EN PARED ANTERIOR DE FONDO UTERINO"
  },
  {
    "codigo":71958004,
    "descripcion":"OTITIS MEDIA CRÓNICA ALÉRGICA"
  },
  {
    "codigo":792854004,
    "descripcion":"ÚLCERA ISQUÉMICA DE PIE DEBIDA A ATEROSCLEROSIS DE ARTERIA DE MIEMBRO INFERIOR"
  },
  {
    "codigo":102891000,
    "descripcion":"DISMINUCIÓN DE LA CAPACIDAD COGNITIVA RELACIONADA CON LA EDAD"
  },
  {
    "codigo":235798009,
    "descripcion":"PERFORACIÓN DEL CIEGO"
  },
  {
    "codigo":153911000119104,
    "descripcion":"INSUFICIENCIA ARTERIAL PERIFÉRICA"
  },
  {
    "codigo":299499005,
    "descripcion":"AMPLITUD NORMAL DE MOVIMIENTO ACTIVO DE SUPINACIÓN MEDIOTARSIANA"
  },
  {
    "codigo":201195008,
    "descripcion":"MILIARIA VESICULOSA"
  },
  {
    "codigo":70123009,
    "descripcion":"CÚBITO VALGO CONGÉNITO"
  },
  {
    "codigo":29941000175106,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN DE TALÓN IZQUIERDO GRADO 4"
  },
  {
    "codigo":365035009,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA EMPLEAR EL LENGUAJE CORPORAL"
  },
  {
    "codigo":232128004,
    "descripcion":"HIPERMETROPÍA PATOLÓGICA"
  },
  {
    "codigo":35520007,
    "descripcion":"SÍNDROME DE NAGER"
  },
  {
    "codigo":721813000,
    "descripcion":"INFECCIÓN MUCOCUTÁNEA CAUSADA POR LEISHMANIA"
  },
  {
    "codigo":230293003,
    "descripcion":"PARQUINSONISMO PRODUCIDO POR MONÓXIDO DE CARBONO"
  },
  {
    "codigo":263061006,
    "descripcion":"SUBLUXACIÓN DE ARTICULACIÓN DEL PIE"
  },
  {
    "codigo":16046391000119108,
    "descripcion":"ENFERMEDAD POR DEPÓSITO DE HIDROXIAPATITA DE AMBAS MUÑECAS"
  },
  {
    "codigo":425066001,
    "descripcion":"CARCINOMA DE VEJIGA, INVASIVO"
  },
  {
    "codigo":317751000119109,
    "descripcion":"TENDINITIS PERONEA DE MIEMBRO INFERIOR DERECHO"
  },
  {
    "codigo":95551002,
    "descripcion":"FIBROSIS DE LA CAVIDAD PÉLVICA"
  },
  {
    "codigo":161087004,
    "descripcion":"VIAJA AL EXTRANJERO CON FRECUENCIA"
  },
  {
    "codigo":292159004,
    "descripcion":"REACCIÓN ADVERSA AL ÁCIDO URSODEOXICÓLICO"
  },
  {
    "codigo":1084011000119100,
    "descripcion":"INFLAMACIÓN DE AMBAS MASTOIDES"
  },
  {
    "codigo":93716006,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL CUERPO DEL PENE"
  },
  {
    "codigo":1142292008,
    "descripcion":"EXTENSIÓN DE CRECIMIENTO DE PELO DESDE LA SIEN HASTA LA PORCIÓN EXTERNA DE LA CEJA"
  },
  {
    "codigo":59113005,
    "descripcion":"ATELECTASIA SECUNDARIA PERINATAL"
  },
  {
    "codigo":10858961000119108,
    "descripcion":"HERIDA ABIERTA DE PARED TORÁCICA DERECHA DEBIDA A MORDEDURA DE PERRO"
  },
  {
    "codigo":1204158003,
    "descripcion":"ESTENOSIS ASINTOMÁTICA DE ARTERIA CARÓTIDA EXTRACRANEAL"
  },
  {
    "codigo":16347601000119109,
    "descripcion":"ENCONDROMA DE HÚMERO IZQUIERDO"
  },
  {
    "codigo":253886003,
    "descripcion":"DEFECTO OBSTRUCTIVO CONGÉNITO DE LA PELVIS RENAL"
  },
  {
    "codigo":384958005,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA DE PLEURA PARIETAL AFECTADO POR NEOPLASIA MALIGNA"
  },
  {
    "codigo":417726009,
    "descripcion":"RESONANCIA MAGNÉTICA DE COLUMNA LUMBAR, ANORMAL"
  },
  {
    "codigo":284819002,
    "descripcion":"NO SE PARA EN LA BAÑERA"
  },
  {
    "codigo":41521000087100,
    "descripcion":"HERIDA PUNZANTE DE EXTREMIDAD SUPERIOR DERECHA"
  },
  {
    "codigo":46641000087100,
    "descripcion":"FRACTURA DE FALANGE DISTAL DE PULGAR IZQUIERDO"
  },
  {
    "codigo":44081000087107,
    "descripcion":"HERIDA CORTANTE DE RODILLA IZQUIERDA"
  },
  {
    "codigo":38961000087108,
    "descripcion":"FRACTURA DE PIE DERECHO"
  },
  {
    "codigo":346731000119106,
    "descripcion":"CATARATA POLAR SUBCAPSULAR ANTERIOR CONGÉNITA DE AMBOS OJOS"
  },
  {
    "codigo":1003880005,
    "descripcion":"DUPLICACIÓN DE PORCIÓN PROXIMAL DEL BRAZO LARGO DEL CROMOSOMA 10"
  },
  {
    "codigo":248381006,
    "descripcion":"HALLAZGO RELACIONADO CON LA FONTANELA"
  },
  {
    "codigo":608829007,
    "descripcion":"RUPTURA INTERNA DE DISCO INTERVERTEBRAL LUMBAR"
  },
  {
    "codigo":1264189006,
    "descripcion":"PIGMENTACIÓN LOCAL EXÓGENA DE REGIÓN INFERIOR DE MUCOSA YUGAL IZQUIERDA"
  },
  {
    "codigo":1196818004,
    "descripcion":"NEOPLASIA INTRAEPITELIAL GLANDULAR DE BAJO GRADO DE ESÓFAGO"
  },
  {
    "codigo":17170005,
    "descripcion":"PELO RETORCIDO"
  },
  {
    "codigo":279314007,
    "descripcion":"SÍNDROME SOMÁTICO - HALLAZGO"
  },
  {
    "codigo":13500002,
    "descripcion":"SILENCIO ELECTROENCEFALOGRÁFICO"
  },
  {
    "codigo":734396006,
    "descripcion":"RUPTURA ESPONTÁNEA DE ARTERIA COMUNICANTE POSTERIOR IZQUIERDA"
  },
  {
    "codigo":275644008,
    "descripcion":"ESTADO DE TRATAMIENTO Y ADMISIÓN"
  },
  {
    "codigo":1073811000000106,
    "descripcion":"MANEJA RIESGO EN CASA"
  },
  {
    "codigo":109969005,
    "descripcion":"LINFOMA DIFUSO DE CÉLULAS B GRANDES"
  },
  {
    "codigo":208273006,
    "descripcion":"FRACTURA NO EXPUESTA DE HÚMERO DISTAL, BICONDÍLEA (FRACTURA EN T-Y)"
  },
  {
    "codigo":1255014000,
    "descripcion":"DEPENDENCIA COMBINADA DE SUSTANCIAS EXCEPTO OPIOIDES"
  },
  {
    "codigo":44433009,
    "descripcion":"TRASTORNO DE TICS TRANSITORIOS RECIDIVANTE"
  },
  {
    "codigo":16022431000119102,
    "descripcion":"ATROFIA DE MÚSCULOS DE AMBOS PIES"
  },
  {
    "codigo":765329008,
    "descripcion":"DEFICIENCIA DE CARBAMOIL-FOSFATO SINTETASA 1"
  },
  {
    "codigo":239206006,
    "descripcion":"TROMBOSIS VENOSA DEL COLGAJO"
  },
  {
    "codigo":271974007,
    "descripcion":"TRASTORNO DE RECONSTRUCCIÓN DE CONDUCTO DEFERENTE CON PRÓTESIS"
  },
  {
    "codigo":1351483000,
    "descripcion":"HIPERFORIA COMITANTE"
  },
  {
    "codigo":1187643003,
    "descripcion":"ATAXIA ESPINOCEREBELOSA AUTOSÓMICA RECESIVA TIPO 21"
  },
  {
    "codigo":401211005,
    "descripcion":"PRUEBA DE LA MARCHA EN TÁNDEM - ANORMAL"
  },
  {
    "codigo":71696000,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN LA REGIÓN DE LA CARA, SIN INFECCIÓN"
  },
  {
    "codigo":302907009,
    "descripcion":"CUERPO EXTRAÑO EN EL OÍDO MEDIO"
  },
  {
    "codigo":6160004,
    "descripcion":"HEMOCROMATOSIS NEONATAL"
  },
  {
    "codigo":48031000119106,
    "descripcion":"EX FUMADOR DURANTE MÁS DE 1 AÑO"
  },
  {
    "codigo":38928007,
    "descripcion":"VOLUMEN SANGUÍNEO AUMENTADO"
  },
  {
    "codigo":202768008,
    "descripcion":"TORTÍCOLIS REUMÁTICO"
  },
  {
    "codigo":366608008,
    "descripcion":"PRUEBA DE HIPERFLEXIÓN DE LA RODILLA - HALLAZGO"
  },
  {
    "codigo":4325000,
    "descripcion":"SÍNDROME DE MONOSOMÍA PARCIAL 11Q"
  },
  {
    "codigo":397541004,
    "descripcion":"ALTERACIÓN VISUAL GRAVE"
  },
  {
    "codigo":200933006,
    "descripcion":"ROSÁCEA OCULAR"
  },
  {
    "codigo":364773006,
    "descripcion":"ALIMENTACIÓN DEL LACTANTE A LOS 6 MESES - HALLAZGO"
  },
  {
    "codigo":102629008,
    "descripcion":"SIGNO PANCREÁTICO"
  },
  {
    "codigo":231866000,
    "descripcion":"CUERPO EXTRAÑO CONJUNTIVAL"
  },
  {
    "codigo":299237008,
    "descripcion":"DEFORMACIÓN DE ARTICULACIÓN DE CADERA EN ROTACIÓN EXTERNA"
  },
  {
    "codigo":723386002,
    "descripcion":"SUSCEPTIBILIDAD MENDELIANA A ENFERMEDAD POR MICOBACTERIAS DEBIDA A DEFICIENCIA PARCIAL DE TRANSDUCTOR DE LA SEÑAL Y ACTIVADOR DE LA TRANSCRIPCIÓN 1"
  },
  {
    "codigo":233701009,
    "descripcion":"NEUMONITIS POR HIPERSENSIBILIDAD DE LOS TRABAJADORES DE SERVICIOS CLOACALES"
  },
  {
    "codigo":166330000,
    "descripcion":"NIVEL DE TIROXINA SÉRICA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":266469006,
    "descripcion":"CIRROSIS PORTAL MULTILOBULAR"
  },
  {
    "codigo":788922000,
    "descripcion":"MUTILACIÓN DE GENITALES FEMENINOS TIPO 1A"
  },
  {
    "codigo":262799001,
    "descripcion":"CONTUSIÓN DEL HÍGADO"
  },
  {
    "codigo":721551005,
    "descripcion":"AUSENCIA ADQUIRIDA DE MAMA"
  },
  {
    "codigo":655007,
    "descripcion":"LATIDO CARDÍACO FETAL ANORMAL DETECTADO ANTES DEL TRABAJO DE PARTO EN NIÑO NACIDO VIVO"
  },
  {
    "codigo":129892000,
    "descripcion":"SÍNDROME POR INACTIVIDAD"
  },
  {
    "codigo":197263009,
    "descripcion":"FÍSTULA DE LA PARED ABDOMINAL"
  },
  {
    "codigo":66191007,
    "descripcion":"ARTROPATÍA TRANSITORIA"
  },
  {
    "codigo":162660004,
    "descripcion":"ASMA RESUELTA"
  },
  {
    "codigo":293732007,
    "descripcion":"ALERGIA A AMIFOSTINA"
  },
  {
    "codigo":816185000,
    "descripcion":"EDEMA DE MIEMBRO SUPERIOR DERECHO"
  },
  {
    "codigo":29753000,
    "descripcion":"CONVULSIÓN PARCIAL"
  },
  {
    "codigo":160825002,
    "descripcion":"RELACIÓN FAMILIAR PROBLEMÁTICA"
  },
  {
    "codigo":95289006,
    "descripcion":"CENTRO SUPERNUMERARIO DE VÉRTEBRA CERVICAL"
  },
  {
    "codigo":783417009,
    "descripcion":"ANEURISMA DE ARTERIA CEREBELOSA POSTEROINFERIOR"
  },
  {
    "codigo":1142030006,
    "descripcion":"ANEMIA NUTRICIONAL DEL EMBARAZO"
  },
  {
    "codigo":1162760000,
    "descripcion":"MIGRACIÓN DE TUBO DE GASTROSTOMÍA PERCUTÁNEA ENDOSCÓPICA"
  },
  {
    "codigo":58851004,
    "descripcion":"CRIPTOMENORREA"
  },
  {
    "codigo":1304035004,
    "descripcion":"GLAUCOMA DE ÁNGULO ABIERTO DE OJO IZQUIERDO DEBIDO A NEOVASCULARIZACIÓN"
  },
  {
    "codigo":253624000,
    "descripcion":"ATRESIA PULMONAR CON ARTERIAS PULMONARES CONFLUENTES"
  },
  {
    "codigo":10863981000119100,
    "descripcion":"HERIDA POR DISPARO DE ARMA DE FUEGO DE PIE IZQUIERDO"
  },
  {
    "codigo":2441000124103,
    "descripcion":"CANINO INFERIOR IZQUIERDO PERMANENTE SUPERNUMERARIO"
  },
  {
    "codigo":384696009,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA AFECTADO POR NEOPLASIA MALIGNA, UNIFOCAL"
  },
  {
    "codigo":445321000124107,
    "descripcion":"MÉTODO INADECUADO DE ADMINISTRACIÓN DE NUTRICIÓN PARENTERAL"
  },
  {
    "codigo":251789006,
    "descripcion":"PROYECCIÓN DURANTE LA FIJACIÓN - EXACTA"
  },
  {
    "codigo":415629007,
    "descripcion":"CONTROL DE ACCIDENTE CEREBROVASCULAR\/ATAQUE ISQUÉMICO TRANSITORIO, SEGUNDA CARTA"
  },
  {
    "codigo":53346000,
    "descripcion":"SÍNDROME DE TRISOMÍA 20 COMPLETA"
  },
  {
    "codigo":249954005,
    "descripcion":"MOVIMIENTO CONTRA LA GRAVEDAD"
  },
  {
    "codigo":315490005,
    "descripcion":"NACIDO EN NÍGER"
  },
  {
    "codigo":870711002,
    "descripcion":"ÚLCERA DEBIDA A CÁNCER"
  },
  {
    "codigo":1231159006,
    "descripcion":"DEPENDENCIA DE ANSIOLÍTICO EN REMISIÓN"
  },
  {
    "codigo":279052002,
    "descripcion":"DOLOR INDEPENDIENTE DEL SISTEMA NERVIOSO SIMPÁTICO"
  },
  {
    "codigo":366728002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA CAMINAR EN TERRENO PLANO"
  },
  {
    "codigo":277217005,
    "descripcion":"COLAPSO ALAR PARCIAL"
  },
  {
    "codigo":47841006,
    "descripcion":"RINOFARINGITIS CRÓNICA"
  },
  {
    "codigo":275382005,
    "descripcion":"TRAUMA CEREBRAL"
  },
  {
    "codigo":109707000,
    "descripcion":"PÉRDIDA DE HUESO ALVEOLAR CON CRATERIZACIÓN"
  },
  {
    "codigo":11403006,
    "descripcion":"ECONÓMICAMENTE POBRE"
  },
  {
    "codigo":240779007,
    "descripcion":"MUCORMICOSIS CUTÁNEA NECROSANTE"
  },
  {
    "codigo":238944001,
    "descripcion":"ENFERMEDAD METABÓLICA Y NUTRICIONAL QUE AFECTA LA PIEL"
  },
  {
    "codigo":1287520002,
    "descripcion":"PRODUCTO MÉDICO FALSIFICADO"
  },
  {
    "codigo":1156448003,
    "descripcion":"FUNCIÓN URINARIA ALTERADA"
  },
  {
    "codigo":1254752001,
    "descripcion":"METÁSTASIS DE CARCINOMA VERRUGOSO EN CAVIDAD ORAL"
  },
  {
    "codigo":271712005,
    "descripcion":"OBSERVACIÓN RELACIONADA CON LA SENSIBILIDAD"
  },
  {
    "codigo":1089031000119106,
    "descripcion":"PERFORACIÓN DEL BORDE DEL TÍMPANO IZQUIERDO"
  },
  {
    "codigo":402784007,
    "descripcion":"SÍNDROME DE INESTABILIDAD DEL ÁCIDO DESOXIRRIBONUCLEICO"
  },
  {
    "codigo":237109002,
    "descripcion":"VERRUGA VULVAR"
  },
  {
    "codigo":400949006,
    "descripcion":"NISTAGMO DE RETRACCIÓN DE LA DIVERGENCIA"
  },
  {
    "codigo":399114005,
    "descripcion":"CAPSULITIS ADHESIVA DE HOMBRO"
  },
  {
    "codigo":366346006,
    "descripcion":"HALLAZGO RELACIONADO CON EL TAMAÑO DE LA MAMA"
  },
  {
    "codigo":300810008,
    "descripcion":"CAPAZ DE REALIZAR TRABAJO VOLUNTARIO"
  },
  {
    "codigo":4063001,
    "descripcion":"AQUILODINIA"
  },
  {
    "codigo":724959001,
    "descripcion":"LACERACIÓN DE MÚSCULO FLEXOR DE DEDO DE LA MANO A LA ALTURA DEL ANTEBRAZO"
  },
  {
    "codigo":430047005,
    "descripcion":"LACERACIÓN DE NERVIO"
  },
  {
    "codigo":167903005,
    "descripcion":"LÍQUIDO SINOVIAL: ÁCIDO ÚRICO"
  },
  {
    "codigo":2228002,
    "descripcion":"ESCOTOMA CENTELLEANTE"
  },
  {
    "codigo":428212003,
    "descripcion":"DEGENERACIÓN DE FOTORRECEPTOR"
  },
  {
    "codigo":297140006,
    "descripcion":"ÉMBOLO DE ARTERIA MESENTÉRICA INFERIOR"
  },
  {
    "codigo":723124007,
    "descripcion":"APRAXIA PROGRESIVA PRIMARIA DEL HABLA"
  },
  {
    "codigo":721289001,
    "descripcion":"HIPOFUNCIÓN TESTICULAR POSTERIOR A PROCEDIMIENTO"
  },
  {
    "codigo":295305002,
    "descripcion":"SOBREDOSIS INTENCIONAL DE ÁCIDO TIAPROFÉNICO"
  },
  {
    "codigo":197001004,
    "descripcion":"TROMBOSIS DE LA VENA MESENTÉRICA SUPERIOR"
  },
  {
    "codigo":64094003,
    "descripcion":"ÚLCERA GASTROYEYUNAL CON HEMORRAGIA Y PERFORACIÓN"
  },
  {
    "codigo":719454003,
    "descripcion":"DEFECTO CONGÉNITO DE LA SÍNTESIS DE ÁCIDOS BILIARES TIPO 3"
  },
  {
    "codigo":11767611000119103,
    "descripcion":"DISTENSIÓN DE MÚSCULO Y\/O TENDÓN DE BÍCEPS BRAQUIAL IZQUIERDO"
  },
  {
    "codigo":293470005,
    "descripcion":"REACCIÓN ADVERSA A LOS ANTAGONISTAS DE LA ALDOSTERONA"
  },
  {
    "codigo":95027001,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA RETINA"
  },
  {
    "codigo":129630009,
    "descripcion":"PRESBIACUSIA MECÁNICA"
  },
  {
    "codigo":354251000119100,
    "descripcion":"CARCINOMA IN SITU DE PIEL DE MIEMBRO SUPERIOR DERECHO"
  },
  {
    "codigo":214019531000119101,
    "descripcion":"HERIDA POR MORDEDURA DE LORO"
  },
  {
    "codigo":113611000119100,
    "descripcion":"SÍNDROME DE DOLOR MIOFASCIAL DE LA COLUMNA LUMBAR"
  },
  {
    "codigo":12201931000119100,
    "descripcion":"DOLOR DEBIDO A ARTROPLASTIA DE MUÑECA DERECHA Y POSTERIOR A ELLA"
  },
  {
    "codigo":11774411000119100,
    "descripcion":"AMPOLLA DE DEDO PULGAR DERECHO, CON INFECCIÓN"
  },
  {
    "codigo":346571000119104,
    "descripcion":"BLEFAROCONJUNTIVITIS DE AMBOS OJOS POR CONTACTO"
  },
  {
    "codigo":300491000119106,
    "descripcion":"TRASTORNO DE TENDÓN DE ANTEBRAZO IZQUIERDO"
  },
  {
    "codigo":93192003,
    "descripcion":"LINFOMA MALIGNO DE LOS GANGLIOS LINFÁTICOS INTRAPÉLVICOS"
  },
  {
    "codigo":41931000119102,
    "descripcion":"SINUSITIS CONCOMITANTE CON PÓLIPOS NASALES"
  },
  {
    "codigo":310731000119104,
    "descripcion":"MIOSITIS INFECCIOSA DE MANO DERECHA"
  },
  {
    "codigo":15650251000119101,
    "descripcion":"CREPITACIÓN DE RODILLA IZQUIERDA"
  },
  {
    "codigo":669274571000119102,
    "descripcion":"ÚLCERA VENOSA DE TOBILLO DERECHO"
  },
  {
    "codigo":783155007,
    "descripcion":"NEOPLASIA EPITELIAL MALIGNA DE GLÁNDULA SALIVAL"
  },
  {
    "codigo":10947531000119104,
    "descripcion":"HERIDA ABIERTA DE DEDO ÍNDICE DERECHO DEBIDA A MORDEDURA DE PERRO"
  },
  {
    "codigo":320971000119106,
    "descripcion":"QUISTE ÓSEO SOLITARIO DE RADIO DERECHO"
  },
  {
    "codigo":191496002,
    "descripcion":"TRASTORNO DE LA PERSONALIDAD MEDICAMENTOSO"
  },
  {
    "codigo":1071051000119109,
    "descripcion":"REUMATISMO PALINDRÓMICO DE ARTICULACIÓN DE MUÑECA"
  },
  {
    "codigo":559151051000119108,
    "descripcion":"PORTADOR DE SÍNDROME DE BLOOM"
  },
  {
    "codigo":1172701002,
    "descripcion":"DIPLEJÍA FACIAL CON PARESTESIA"
  },
  {
    "codigo":124125007,
    "descripcion":"DEFICIENCIA DE MALATO DESHIDROGENASA (OXALOACETATO - DESCARBOXILANTE)"
  },
  {
    "codigo":25821008,
    "descripcion":"ESCLEROSIS GLOMERULAR FOCAL"
  },
  {
    "codigo":23986001,
    "descripcion":"GLAUCOMA"
  },
  {
    "codigo":91357005,
    "descripcion":"ENDOCARDITIS AGUDA"
  },
  {
    "codigo":286130004,
    "descripcion":"INCAPAZ DE LIMPIAR EL ÁREA DE PREPARACIÓN DE COMIDAS"
  },
  {
    "codigo":354261000119103,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE CUERPO CILIAR IZQUIERDO"
  },
  {
    "codigo":417202006,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA NO EXPUESTA DE DEDO DE LA MANO"
  },
  {
    "codigo":284295001,
    "descripcion":"INCAPAZ DE REALIZAR LA PRENSIÓN CON SUPINACIÓN DE LA MUÑECA"
  },
  {
    "codigo":253362009,
    "descripcion":"AURÍCULA IZQUIERDA GIGANTE"
  },
  {
    "codigo":448135004,
    "descripcion":"TERATOMA BENIGNO DE REGIÓN PINEAL"
  },
  {
    "codigo":1300103006,
    "descripcion":"SIENTE QUE LAS RELACIONES SOCIALES SON SATISFACTORIAS Y SUFICIENTES"
  },
  {
    "codigo":282460000,
    "descripcion":"QUEMADURA DE BRONQUIO"
  },
  {
    "codigo":251527008,
    "descripcion":"ONDAS AGUDAS POSITIVAS EN EL ELECTROMIOGRAMA"
  },
  {
    "codigo":413532003,
    "descripcion":"ANEMIA POR PÉRDIDA DE SANGRE"
  },
  {
    "codigo":53084003,
    "descripcion":"NEUMONÍA BACTERIANA"
  },
  {
    "codigo":184156005,
    "descripcion":"TIENE UN CUIDADOR"
  },
  {
    "codigo":249692009,
    "descripcion":"AUSENCIA DE ESTERNÓN"
  },
  {
    "codigo":681941000119107,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE PÍLORO"
  },
  {
    "codigo":84017003,
    "descripcion":"BURSITIS"
  },
  {
    "codigo":16302191000119101,
    "descripcion":"LESIÓN DE HUESO DE MANO DERECHA"
  },
  {
    "codigo":1263665007,
    "descripcion":"HIPERPLASIA DE PLEXO COROIDEO"
  },
  {
    "codigo":247857009,
    "descripcion":"MIEDO A LA ANESTESIA GENERAL"
  },
  {
    "codigo":1163526002,
    "descripcion":"PARACOCCIDIOIDOMICOSIS EXTRAPULMONAR"
  },
  {
    "codigo":49414002,
    "descripcion":"OPACIDADES DEL ESMALTE NO CAUSADAS POR FLÚOR"
  },
  {
    "codigo":111000119104,
    "descripcion":"MIOCARDIOPATÍA CONGESTIVA NO ISQUÉMICA"
  },
  {
    "codigo":702939007,
    "descripcion":"STAPHYLOCOCCUS AUREUS O STAPHYLOCOCCUS INTERMEDIUS"
  },
  {
    "codigo":12206191000119105,
    "descripcion":"FRACTURA DE HUESO ADYACENTE A PRÓTESIS DE ARTICULACIÓN DE TOBILLO DERECHO"
  },
  {
    "codigo":1290928002,
    "descripcion":"ICTERICIA NEONATAL CAUSADA POR SUSTANCIA TRANSMITIDA POR LECHE MATERNA"
  },
  {
    "codigo":45744005,
    "descripcion":"TRASTORNO DEL METABOLISMO MINERAL"
  },
  {
    "codigo":209584006,
    "descripcion":"DESGARRO COMPLETO DE LIGAMENTO DE LA MUÑECA"
  },
  {
    "codigo":373424008,
    "descripcion":"DEPÓSITOS NODULARES EN LA MEMBRANA DE DESCEMET"
  },
  {
    "codigo":699269005,
    "descripcion":"MIOPATÍA MIOFIBRILAR"
  },
  {
    "codigo":74842002,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO DEL TRONCO"
  },
  {
    "codigo":42074003,
    "descripcion":"LESIÓN TRAUMÁTICA MÚLTIPLE DE NERVIOS"
  },
  {
    "codigo":1156186003,
    "descripcion":"METATARSO PRIMUS VARO DE AMBOS PIES"
  },
  {
    "codigo":238682006,
    "descripcion":"GRANULOMA MULTIFORME"
  },
  {
    "codigo":402522006,
    "descripcion":"CARCINOMA BASOCELULAR DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":369754009,
    "descripcion":"CONFIGURACIÓN TUMORAL LOCALIZADA"
  },
  {
    "codigo":1187119002,
    "descripcion":"ENFERMEDAD PEDIÁTRICA HEREDITARIA SIMILAR A BEHÇET"
  },
  {
    "codigo":38404000,
    "descripcion":"FRACTURA EXPUESTA DE LA APÓFISIS ACROMIAL DEL OMÓPLATO"
  },
  {
    "codigo":235012002,
    "descripcion":"PLACA SUBGINGIVAL"
  },
  {
    "codigo":890372006,
    "descripcion":"MALFORMACIÓN CONGÉNITA DEL SISTEMA LINFÁTICO DE LA REGIÓN CERVICOFACIAL"
  },
  {
    "codigo":300548007,
    "descripcion":"CAPAZ DE MANTENER RELACIONES SEXUALES"
  },
  {
    "codigo":366084008,
    "descripcion":"DIVERGENCIA OCULAR - HALLAZGO"
  },
  {
    "codigo":167641001,
    "descripcion":"MATERIA FECAL: BACTERIAS PRESENTES"
  },
  {
    "codigo":15702281000119107,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE TENDÓN DE MÚSCULO BÍCEPS FEMORAL DE EXTREMIDAD INFERIOR DERECHA"
  },
  {
    "codigo":823001003,
    "descripcion":"COSTRA SEROSA CUTÁNEA"
  },
  {
    "codigo":724697004,
    "descripcion":"PATRÓN PERJUDICIAL DE CONSUMO DE NICOTINA"
  },
  {
    "codigo":298713004,
    "descripcion":"TÓRAX SIMÉTRICO"
  },
  {
    "codigo":165806002,
    "descripcion":"ANTÍGENO DE SUPERFICIE DE HEPATITIS B DETECTADO"
  },
  {
    "codigo":722862003,
    "descripcion":"DENGUE SIN SIGNOS DE ALARMA"
  },
  {
    "codigo":296878004,
    "descripcion":"SOBREDOSIS DE PROGESTÁGENO"
  },
  {
    "codigo":1148846008,
    "descripcion":"NEOPLASIA BENIGNA EPITELIAL Y ESTROMAL MIXTA DE RIÑÓN"
  },
  {
    "codigo":426115002,
    "descripcion":"FRACTURA PATOLÓGICA DE PELVIS"
  },
  {
    "codigo":37384000,
    "descripcion":"HERIDA OBSTÉTRICA DEL CUERO CABELLUDO"
  },
  {
    "codigo":293208001,
    "descripcion":"REACCIÓN ADVERSA AL ALILESTRENOL"
  },
  {
    "codigo":719192005,
    "descripcion":"ENCÍA PÁLIDA"
  },
  {
    "codigo":225837000,
    "descripcion":"EN CONTACTO CON GRUPO DE AMPARO VOLUNTARIO"
  },
  {
    "codigo":193069004,
    "descripcion":"HIPOTENSIÓN INTRACRANEAL POSDERIVACIÓN VENTRICULAR"
  },
  {
    "codigo":94765005,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE HUESO"
  },
  {
    "codigo":715522000,
    "descripcion":"FOCOMELIA TIPO SCHINZEL"
  },
  {
    "codigo":1208877008,
    "descripcion":"AFAQUIA ADQUIRIDA"
  },
  {
    "codigo":387842002,
    "descripcion":"NEOPLASIA CARDÍACA"
  },
  {
    "codigo":92930002,
    "descripcion":"FORMA ANORMAL CONGÉNITA DE HUESO NASAL"
  },
  {
    "codigo":289538004,
    "descripcion":"SANGRADO VAGINAL ESCASO"
  },
  {
    "codigo":330301000119103,
    "descripcion":"COMPRESIÓN DE NERVIO RADIAL IZQUIERDO"
  },
  {
    "codigo":254935002,
    "descripcion":"TUMOR INTRACRANEAL"
  },
  {
    "codigo":58327003,
    "descripcion":"TRASTORNO POR INHIBIDOR DEL FACTOR I"
  },
  {
    "codigo":1172439006,
    "descripcion":"CORTISONA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":123863008,
    "descripcion":"TRASTORNO DE LA EPIGLOTIS"
  },
  {
    "codigo":25559009,
    "descripcion":"AUSENCIA CONGÉNITA DE LA ARTERIA PULMONAR IZQUIERDA"
  },
  {
    "codigo":189399009,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE PERITONEO Y RETROPERITONEO"
  },
  {
    "codigo":56492005,
    "descripcion":"TEMOR ANTE LA JUBILACIÓN FUTURA"
  },
  {
    "codigo":285868006,
    "descripcion":"CAPAZ DE USAR LAVARROPAS"
  },
  {
    "codigo":1268908007,
    "descripcion":"ENFERMEDAD DE PAGET PRIMARIA DE PEZÓN"
  },
  {
    "codigo":415105001,
    "descripcion":"DESPRENDIMIENTO PLACENTARIO"
  },
  {
    "codigo":710017008,
    "descripcion":"INSERCIÓN MUSCULAR EN ESTADO EDÉNTULO SIN BASE MUCOSA ADHERIDA EN REGIÓN MANDIBULAR ANTERIOR"
  },
  {
    "codigo":16032471000119102,
    "descripcion":"NECROSIS AVASCULAR DE HUESO DE AMBAS REGIONES DE TOBILLO"
  },
  {
    "codigo":216662006,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR PINTURAS CON PLOMO"
  },
  {
    "codigo":282198006,
    "descripcion":"INCAPAZ DE BAJAR ESCALERAS"
  },
  {
    "codigo":314966008,
    "descripcion":"RECIDIVA LOCAL DE NEOPLASIA MALIGNA DE RECTO"
  },
  {
    "codigo":249430008,
    "descripcion":"EXOLARINGE - HALLAZGO"
  },
  {
    "codigo":247595006,
    "descripcion":"OLVIDA ACTIVIDADES RECIENTES"
  },
  {
    "codigo":737280000,
    "descripcion":"IMPLANTE AUDIOLÓGICO IN SITU"
  },
  {
    "codigo":10625751000119106,
    "descripcion":"BRONCONEUMONÍA DEBIDA A VIRUS"
  },
  {
    "codigo":278528006,
    "descripcion":"TUMEFACCIÓN FACIAL"
  },
  {
    "codigo":735445000,
    "descripcion":"TRASTORNO ALÉRGICO DEL TRACTO RESPIRATORIO"
  },
  {
    "codigo":309461001,
    "descripcion":"DERMATITIS ATÓPICA CRÓNICA LIQUENIFICADA"
  },
  {
    "codigo":139991000119107,
    "descripcion":"HEMORRAGIA POSTERIOR A INJERTO PUENTE DE ARTERIA CORONARIA"
  },
  {
    "codigo":47317002,
    "descripcion":"MILIARIA PROFUNDA"
  },
  {
    "codigo":276693005,
    "descripcion":"NEUMONÍA BACTERIANA CONGÉNITA"
  },
  {
    "codigo":1259733005,
    "descripcion":"ASTROCITOMA PRIMARIO MALIGNO DE NERVIO ÓPTICO"
  },
  {
    "codigo":10926961000119102,
    "descripcion":"FRACTURA NO EXPUESTA DE DIÁFISIS DE TERCER HUESO METACARPIANO DE MANO DERECHA"
  },
  {
    "codigo":45482001,
    "descripcion":"AFALANGIA PARCIAL DE LA EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":1290666002,
    "descripcion":"LINFEDEMA PEDIÁTRICO SECUNDARIO"
  },
  {
    "codigo":274858002,
    "descripcion":"PRUEBA DE TOLERANCIA A LA GLUCOSA FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":78250005,
    "descripcion":"CORAZÓN ECTÓPICO"
  },
  {
    "codigo":209322006,
    "descripcion":"FRACTURA-SUBLUXACIÓN NO EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA DISTAL"
  },
  {
    "codigo":699007002,
    "descripcion":"DERIVACIÓN ARTERIOVENOSA IN SITU"
  },
  {
    "codigo":305791003,
    "descripcion":"VISTO POR EL SERVICIO"
  },
  {
    "codigo":686961000119104,
    "descripcion":"MICOSIS FUNGOIDE DE GANGLIO LINFÁTICO AXILAR"
  },
  {
    "codigo":240255006,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE ARTICULACIÓN DE SEGUNDO A QUINTO DEDOS DEL PIE"
  },
  {
    "codigo":43647007,
    "descripcion":"PARÁLISIS AGITANTE JUVENIL DE HUNT"
  },
  {
    "codigo":404095008,
    "descripcion":"QUISTE EPIDERMOIDE CALCIFICADO"
  },
  {
    "codigo":1256063009,
    "descripcion":"GRANULOMA CUTÁNEO CAUSADO POR TALCO"
  },
  {
    "codigo":205652000,
    "descripcion":"TRISOMÍA 11"
  },
  {
    "codigo":426803004,
    "descripcion":"DOLOR IRRADIADO AL BRAZO DERECHO"
  },
  {
    "codigo":271188007,
    "descripcion":"AMPOLLA TRAUMÁTICA DEL PIE"
  },
  {
    "codigo":105513000,
    "descripcion":"DESAVENENCIA CON LOS VECINOS"
  },
  {
    "codigo":236585005,
    "descripcion":"ENFERMEDAD DE NOVO POSTRASPLANTE"
  },
  {
    "codigo":300286002,
    "descripcion":"LESIÓN DE ESÓFAGO"
  },
  {
    "codigo":70910003,
    "descripcion":"MASTOCITOSIS SISTÉMICA INDOLORA"
  },
  {
    "codigo":890110004,
    "descripcion":"SÍNDROME DE DUPLICACIÓN 17Q23.1-Q23.2"
  },
  {
    "codigo":267518003,
    "descripcion":"ANEMIA POR DEFICIENCIA DE FOLATOS, DE CAUSA ALIMENTARIA"
  },
  {
    "codigo":365822004,
    "descripcion":"NIVEL DE URATO - HALLAZGO"
  },
  {
    "codigo":298451003,
    "descripcion":"AMPLITUD DE ROTACIÓN ACTIVA HACIA LA DERECHA DE LA COLUMNA CERVICAL NORMAL"
  },
  {
    "codigo":724435004,
    "descripcion":"ANOMALÍA CONGÉNITA DE AORTA TORÁCICA DESCENDENTE"
  },
  {
    "codigo":69075005,
    "descripcion":"CRISIS APLÁSICA"
  },
  {
    "codigo":200147006,
    "descripcion":"CESÁREA - EMBARAZO A TÉRMINO"
  },
  {
    "codigo":3539006,
    "descripcion":"ENTEROMENIA"
  },
  {
    "codigo":165544003,
    "descripcion":"LEUCOCITOS INMADUROS NO DETECTADOS"
  },
  {
    "codigo":427688003,
    "descripcion":"FRACTURA NO EXPUESTA POR AVULSIÓN DE TROCÁNTER MENOR DE FÉMUR"
  },
  {
    "codigo":332811000119106,
    "descripcion":"COROIDOPATÍA PUNTEADA INTERNA DE OJO DERECHO"
  },
  {
    "codigo":722600006,
    "descripcion":"ENFERMEDAD DE ALZHEIMER SIN AMNESIA"
  },
  {
    "codigo":1148584007,
    "descripcion":"TROMBOSIS VENOSA EN EL EMBARAZO"
  },
  {
    "codigo":1279656007,
    "descripcion":"HERIDA PUNZANTE DE DEDO MEÑIQUE CON CUERPO EXTRAÑO"
  },
  {
    "codigo":296616006,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE AZITROMICINA"
  },
  {
    "codigo":294781003,
    "descripcion":"ALERGIA A ESTRÓGENO"
  },
  {
    "codigo":1343357005,
    "descripcion":"ACCESO DIGITAL INADECUADO QUE AFECTA EL EMPLEO"
  },
  {
    "codigo":63570000,
    "descripcion":"INFECCIÓN CAUSADA POR TRICHOBILHARZIA OCELLATA"
  },
  {
    "codigo":1144914004,
    "descripcion":"ENFERMEDAD DE BEHCET CUTÁNEA"
  },
  {
    "codigo":161874006,
    "descripcion":"SENSACIÓN DE PESADEZ"
  },
  {
    "codigo":292946008,
    "descripcion":"REACCIÓN ADVERSA A LA ACROSOXACINA"
  },
  {
    "codigo":422183001,
    "descripcion":"ÚLCERA CUTÁNEA DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":94503003,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA PRÓSTATA"
  },
  {
    "codigo":127271004,
    "descripcion":"NEOPLASIA DE LOS GANGLIOS LINFÁTICOS PARAMETRIALES"
  },
  {
    "codigo":225575005,
    "descripcion":"INCAPAZ DE ELIMINAR ESPUTO MEDIANTE LA TOS"
  },
  {
    "codigo":28967006,
    "descripcion":"LESIÓN TRAUMÁTICA DE VENA BRAQUIOCEFÁLICA"
  },
  {
    "codigo":1300104000,
    "descripcion":"COMPLETÓ PROGRAMA DE ENTRENAMIENTO EN HABILIDADES BÁSICAS"
  },
  {
    "codigo":1208615009,
    "descripcion":"SÍNDROME ESCAPULOPERONEO NEUROGÉNICO DE TIPO KAESER"
  },
  {
    "codigo":92668003,
    "descripcion":"CARCINOMA IN SITU DE LA OROFARINGE"
  },
  {
    "codigo":289276006,
    "descripcion":"HALLAZGO RELACIONADO CON EL COLOR DE LA PLACENTA"
  },
  {
    "codigo":27132007,
    "descripcion":"DELECIÓN CLONAL"
  },
  {
    "codigo":254673000,
    "descripcion":"QUISTE EPIDÉRMICO ROTO"
  },
  {
    "codigo":251528003,
    "descripcion":"COMPLEJO DE DESCARGAS REPETITIVAS EN EL ELECTROMIOGRAMA"
  },
  {
    "codigo":713425003,
    "descripcion":"COMPRESIÓN DE LA MÉDULA ESPINAL DEBIDA A METÁSTASIS EN COLUMNA VERTEBRAL"
  },
  {
    "codigo":25297005,
    "descripcion":"DISFONÍA ESPÁSTICA PSICOGÉNICA TIPO ADUCTOR"
  },
  {
    "codigo":123601005,
    "descripcion":"APENDICITIS FOCAL"
  },
  {
    "codigo":1336017007,
    "descripcion":"SÍNDROME COMPARTIMENTAL NO TRAUMÁTICO DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":23462007,
    "descripcion":"ENFERMEDAD VULVOVAGINAL"
  },
  {
    "codigo":1332347003,
    "descripcion":"DELIRIO DE CONTROL DE ACCIONES"
  },
  {
    "codigo":251003004,
    "descripcion":"VALVA MITRAL DESGARRADA"
  },
  {
    "codigo":283771007,
    "descripcion":"MORDEDURA DE PERRO EN LA RODILLA"
  },
  {
    "codigo":281936005,
    "descripcion":"FRACTURA DE APÓFISIS TRANSVERSA DE VÉRTEBRA LUMBAR"
  },
  {
    "codigo":247333002,
    "descripcion":"SENSACIÓN DE HISOPO DE ALGODÓN EN OÍDO"
  },
  {
    "codigo":335321000119102,
    "descripcion":"ECTROPIÓN DE PÁRPADO DERECHO"
  },
  {
    "codigo":704250000,
    "descripcion":"FRACTURA PATOLÓGICA DE HUESO DE MANO EN SITIO DE NEOPLASIA"
  },
  {
    "codigo":689471000119109,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE CARA INFERIOR DE LA LENGUA"
  },
  {
    "codigo":276431002,
    "descripcion":"SECCIÓN TRAUMÁTICA DE TENDÓN EXTENSOR - ZONA 5"
  },
  {
    "codigo":79823003,
    "descripcion":"PÁNICO"
  },
  {
    "codigo":1259471003,
    "descripcion":"DEMENCIA DEBIDA A ENCEFALOPATÍA DE HASHIMOTO"
  },
  {
    "codigo":241828001,
    "descripcion":"ENVENENAMIENTO POR MOLUSCOS DEL GÉNERO CONUS"
  },
  {
    "codigo":733348001,
    "descripcion":"NEOPLASIA NEUROENDOCRINA MALIGNA PRIMARIA DE CONDUCTO CÍSTICO"
  },
  {
    "codigo":1255801002,
    "descripcion":"ENFERMEDAD DE SÉZARY DE GANGLIOS LINFÁTICOS DE CABEZA Y CUELLO"
  },
  {
    "codigo":239993003,
    "descripcion":"BURSITIS ISQUIÁTICA"
  },
  {
    "codigo":305529006,
    "descripcion":"BAJO ATENCIÓN DE CARDIOCIRUJANO"
  },
  {
    "codigo":238158000,
    "descripcion":"HIPEROXIA"
  },
  {
    "codigo":403833009,
    "descripcion":"SÍNDROME DE FIEBRE PERIÓDICA ASOCIADO CON EL RECEPTOR DEL TNF"
  },
  {
    "codigo":860750004,
    "descripcion":"ENFERMEDAD DIVERTICULAR DE INTESTINO DELGADO"
  },
  {
    "codigo":170787001,
    "descripcion":"EFECTOS ADVERSOS DE FÁRMACO TIROIDEO"
  },
  {
    "codigo":203555006,
    "descripcion":"DEFORMIDAD EN EXTENSIÓN DE DEDO DE LA MANO"
  },
  {
    "codigo":1186595007,
    "descripcion":"FOSFOLÍPIDO DENTRO DE RANGO DE REFERENCIA"
  },
  {
    "codigo":365560002,
    "descripcion":"HALLAZGO RELACIONADO CON EL ESTADO DE RECEPCIÓN DE SUBSIDIOS"
  },
  {
    "codigo":267256003,
    "descripcion":"SUFRIMIENTO FETAL QUE AFECTA LA ATENCIÓN"
  },
  {
    "codigo":168952007,
    "descripcion":"ARTERIOGRAFÍA FEMORAL NORMAL"
  },
  {
    "codigo":5112009,
    "descripcion":"HIPERREFLEXIA AUTONÓMICA DE VEJIGA URINARIA"
  },
  {
    "codigo":298189003,
    "descripcion":"HIPERMOVILIDAD DE ARTICULACIÓN DE CODO"
  },
  {
    "codigo":724173009,
    "descripcion":"SÍNDROME DE MIOCARDIOPATÍA HEREDADA DE LA MADRE E HIPOACUSIA"
  },
  {
    "codigo":66978005,
    "descripcion":"HIPERMAGNESEMIA"
  },
  {
    "codigo":427426006,
    "descripcion":"CRISIS DE SUEÑO"
  },
  {
    "codigo":256571000119105,
    "descripcion":"ALCALOSIS HIPOCALIÉMICA DEBIDA A DIARREA"
  },
  {
    "codigo":294519008,
    "descripcion":"ALERGIA A MECILINAM"
  },
  {
    "codigo":786039009,
    "descripcion":"SÍNDROME DE ARTROGRIPOSIS Y DISPLASIA ECTODÉRMICA"
  },
  {
    "codigo":292684000,
    "descripcion":"REACCIÓN ADVERSA A MIORRELAJANTE NO DESPOLARIZANTE"
  },
  {
    "codigo":390988005,
    "descripcion":"PATRÓN DE SANGRADO EN TERAPIA DE REEMPLAZO HORMONAL, NORMAL"
  },
  {
    "codigo":127009005,
    "descripcion":"TRASTORNO DE RECEPTOR ENDOCRINO"
  },
  {
    "codigo":94241006,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE CARTÍLAGO DE LA NARIZ"
  },
  {
    "codigo":1208353007,
    "descripcion":"ALERGIA A DAPAGLIFLOZINA"
  },
  {
    "codigo":290849008,
    "descripcion":"INTOXICACIÓN POR PROTRIPTILINA"
  },
  {
    "codigo":190710003,
    "descripcion":"ARTRITIS TUBERCULOSA"
  },
  {
    "codigo":10850061000119109,
    "descripcion":"LACERACIÓN DE MAMA IZQUIERDA"
  },
  {
    "codigo":337831000119103,
    "descripcion":"QUERATITIS ESCLEROSANTE DE OJO IZQUIERDO"
  },
  {
    "codigo":289014006,
    "descripcion":"COLOCA ALIMENTOS EN LA BOCA"
  },
  {
    "codigo":92406008,
    "descripcion":"NEOPLASIA BENIGNA DE LAS MENINGES ESPINALES"
  },
  {
    "codigo":1335755001,
    "descripcion":"TRASTORNO DE LIGAMENTO DE ARTICULACIÓN DE MANO"
  },
  {
    "codigo":25035006,
    "descripcion":"FÍSTULA DE CONDUCTO SEMICIRCULAR"
  },
  {
    "codigo":385483009,
    "descripcion":"OSTEOGÉNESIS IMPERFECTA TIPO III"
  },
  {
    "codigo":57803009,
    "descripcion":"COREA REUMÁTICA CON COMPROMISO CARDÍACO"
  },
  {
    "codigo":1268384001,
    "descripcion":"USUARIO DE ÓXIDO NITROSO"
  },
  {
    "codigo":449184004,
    "descripcion":"DILATACIÓN DE AORTA DESCENDENTE"
  },
  {
    "codigo":711328005,
    "descripcion":"CON ALTO RIESGO DE TROMBOEMBOLIA VENOSA"
  },
  {
    "codigo":187040006,
    "descripcion":"HISTOPLASMA CAPSULATUM CON PERICARDITIS"
  },
  {
    "codigo":285344007,
    "descripcion":"GASTRITIS VIRAL"
  },
  {
    "codigo":709493000,
    "descripcion":"REFLUJO DEL SISTEMA DIGESTIVO"
  },
  {
    "codigo":416416006,
    "descripcion":"MEMBRANA FIBROSA RETROCORNEAL"
  },
  {
    "codigo":447349003,
    "descripcion":"DISPOSITIVO OCLUSIVO DURO PRESENTE"
  },
  {
    "codigo":11862081000119101,
    "descripcion":"AMPOLLA TRAUMÁTICA DE TOBILLO DERECHO CON INFECCIÓN"
  },
  {
    "codigo":414581006,
    "descripcion":"REFLUJO LARINGOFARÍNGEO"
  },
  {
    "codigo":283509007,
    "descripcion":"HERIDA PUNZANTE DE GARGANTA"
  },
  {
    "codigo":445514005,
    "descripcion":"ANTICUERPO ANTI-HELICOBACTER PYLORI POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":183370007,
    "descripcion":"CONVALECENCIA DESPUÉS DE CIRUGÍA"
  },
  {
    "codigo":248906008,
    "descripcion":"FLATO VAGINAL"
  },
  {
    "codigo":412746008,
    "descripcion":"ESTUDIO CARDÍACO CON RADIONÚCLIDOS NORMAL"
  },
  {
    "codigo":52298009,
    "descripcion":"SECUENCIA DE NEVO SEBÁCEO LINEAL"
  },
  {
    "codigo":247071000,
    "descripcion":"ENGROSAMIENTO DE LA CÁPSULA DEL CRISTALINO EN LA AFAQUIA"
  },
  {
    "codigo":312607004,
    "descripcion":"INSUFICIENCIA VASCULAR DEL TRACTO GASTROINTESTINAL"
  },
  {
    "codigo":443679004,
    "descripcion":"NEOPLASIA MALIGNA DE SISTEMA ESQUELÉTICO"
  },
  {
    "codigo":1197343006,
    "descripcion":"TERATOMA PRIMARIO DE ENCÉFALO"
  },
  {
    "codigo":212468004,
    "descripcion":"LESIÓN DE MÚSCULO ADUCTOR Y TENDÓN DE MUSLO"
  },
  {
    "codigo":703988004,
    "descripcion":"FRACTURA NO EXPUESTA DE FALANGE DISTAL DE DEDO MEDIO"
  },
  {
    "codigo":441844008,
    "descripcion":"PRUEBA CUTÁNEA DE HIPERSENSIBILIDAD TARDÍA PARA HISTOPLASMINA, NEGATIVA"
  },
  {
    "codigo":210633000,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DEL PULPEJO DEL DEDO, TIPO 2 (PÉRDIDA DE PULPEJO Y UÑA)"
  },
  {
    "codigo":11780161000119108,
    "descripcion":"CONTUSIÓN DE TOBILLO DERECHO"
  },
  {
    "codigo":472777008,
    "descripcion":"QUISTE INTRAPERICÁRDICO CONGÉNITO"
  },
  {
    "codigo":733086003,
    "descripcion":"SÍNDROME DE PSEUDOPROGERIA"
  },
  {
    "codigo":700318004,
    "descripcion":"ARTROSIS DE TOBILLO SECUNDARIA A ARTRITIS INFLAMATORIA"
  },
  {
    "codigo":208798006,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN DE CODO, EXTERNA"
  },
  {
    "codigo":307102006,
    "descripcion":"ABANDONADO POR LA MADRE"
  },
  {
    "codigo":43123004,
    "descripcion":"HIPERMETIONINEMIA"
  },
  {
    "codigo":239731008,
    "descripcion":"RUPTURA DEL LIGAMENTO LATERAL EXTERNO DE LA RODILLA"
  },
  {
    "codigo":403571009,
    "descripcion":"CALCINOSIS ESCROTAL IDIOPÁTICA"
  },
  {
    "codigo":340341000119100,
    "descripcion":"ESOTROPÍA MONOCULAR INTERMITENTE DE OJO IZQUIERDO"
  },
  {
    "codigo":1153565002,
    "descripcion":"SODIO SÉRICO POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":399901005,
    "descripcion":"QUERATODERMIA PLANTAR ADQUIRIDA"
  },
  {
    "codigo":301597005,
    "descripcion":"NO SUBE NI BAJA ESCALERAS EN CUATRO PATAS"
  },
  {
    "codigo":268829008,
    "descripcion":"ASFIXIA GRAVE DURANTE EL PARTO - PUNTAJE DE APGAR MENOR A 4 EN EL PRIMER MINUTO"
  },
  {
    "codigo":365298003,
    "descripcion":"HALLAZGO RELACIONADO CON LA CLARIDAD DE PENSAMIENTO"
  },
  {
    "codigo":37618003,
    "descripcion":"HIPERTENSIÓN CRÓNICA QUE COMPLICA EL EMBARAZO Y\/O CONSTITUYE UN MOTIVO DE ATENCIÓN DURANTE ESTE PERÍODO"
  },
  {
    "codigo":234226007,
    "descripcion":"MARCAPASOS FUERA DE CONTROL"
  },
  {
    "codigo":363463000,
    "descripcion":"NEOPLASIA MALIGNA DE CONJUNTIVA"
  },
  {
    "codigo":299762009,
    "descripcion":"REFLEJO DE ENDEREZAMIENTO Y MARCHA: PRESENTE"
  },
  {
    "codigo":1077621000119104,
    "descripcion":"OSTEOMIELITIS CRÓNICA DE PIE DERECHO"
  },
  {
    "codigo":68551007,
    "descripcion":"SÍNDROME DE REDUCCIÓN DE MIEMBRO - ICTIOSIS"
  },
  {
    "codigo":232391008,
    "descripcion":"SINUSITIS AGUDA RECURRENTE"
  },
  {
    "codigo":396231007,
    "descripcion":"BUBONOCELE"
  },
  {
    "codigo":33948002,
    "descripcion":"AUSENCIA DE ACTIVIDAD HORMONAL"
  },
  {
    "codigo":165020005,
    "descripcion":"FUNCIÓN PULMONAR LEVEMENTE OBSTRUIDA"
  },
  {
    "codigo":230556005,
    "descripcion":"NEUROPATÍA SENSITIVA RECESIVA LIGADA AL CROMOSOMA X"
  },
  {
    "codigo":296092006,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE CLOBAZAM"
  },
  {
    "codigo":32113001,
    "descripcion":"SINDACTILIA DE LOS DEDOS DEL PIE"
  },
  {
    "codigo":359793002,
    "descripcion":"SÍNDROME DE OBSTRUCCIÓN DE LA AMPOLLA DE VATER"
  },
  {
    "codigo":195953005,
    "descripcion":"BRONQUITIS SIMPLE Y CRÓNICA MUCOPURULENTA COMBINADAS"
  },
  {
    "codigo":95814001,
    "descripcion":"ENFERMEDAD VESTIBULAR PERIFÉRICA"
  },
  {
    "codigo":1144390001,
    "descripcion":"HIPOPLASIA CONGÉNITA DE GENITALES EXTERNOS"
  },
  {
    "codigo":294257009,
    "descripcion":"ALERGIA A DINOPROST"
  },
  {
    "codigo":30278004,
    "descripcion":"SÍNDROME DE KUNDRAT"
  },
  {
    "codigo":423494003,
    "descripcion":"MELANOMA MALIGNO DE LA PIEL DEL PÁRPADO SUPERIOR"
  },
  {
    "codigo":194118007,
    "descripcion":"PARÁLISIS PARCIAL DE NERVIO OCULOMOTOR"
  },
  {
    "codigo":126747000,
    "descripcion":"NEOPLASIA DE VASO SANGUÍNEO DE MIEMBRO INFERIOR"
  },
  {
    "codigo":93979000,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL RADIO"
  },
  {
    "codigo":421659008,
    "descripcion":"CÁMARA OCULAR ANTERIOR SIN POSIBILIDAD DE OCLUSIÓN"
  },
  {
    "codigo":290587009,
    "descripcion":"INTOXICACIÓN POR TREOSULFANO"
  },
  {
    "codigo":26608005,
    "descripcion":"SECUENCIA DE CARBOHIDRATOS"
  },
  {
    "codigo":92144007,
    "descripcion":"NEOPLASIA BENIGNA DE GANGLIOS LINFÁTICOS INGUINALES"
  },
  {
    "codigo":288752008,
    "descripcion":"COMUNICA SOBRE SÍ MISMO"
  },
  {
    "codigo":286917001,
    "descripcion":"HIPERGONADISMO"
  },
  {
    "codigo":190448007,
    "descripcion":"HIPOGLUCEMIA MEDICAMENTOSA, SIN COMA"
  },
  {
    "codigo":1204421005,
    "descripcion":"SÍNDROME DE LINFEDEMA Y ATRESIA POSTERIOR DE COANAS"
  },
  {
    "codigo":1237189006,
    "descripcion":"TRASTORNO FETAL DEBIDO A PLACENTA PEQUEÑA"
  },
  {
    "codigo":254149007,
    "descripcion":"OSTEÓLISIS CARPO-TARSAL CON NEFROPATÍA"
  },
  {
    "codigo":416154000,
    "descripcion":"ENCEFALITIS CON CUERPOS DE INCLUSIÓN DEL SARAMPIÓN"
  },
  {
    "codigo":188613007,
    "descripcion":"LINFOMA NODULAR DE GANGLIOS LINFÁTICOS DE REGIÓN INGUINAL Y EXTREMIDAD INFERIOR"
  },
  {
    "codigo":447087000,
    "descripcion":"TOMA SIDRA CON ALCOHOL"
  },
  {
    "codigo":283247001,
    "descripcion":"VIDRIO EN EL CODO"
  },
  {
    "codigo":840303004,
    "descripcion":"HIPERTROFIA DE VENTRÍCULO IZQUIERDO LEVE"
  },
  {
    "codigo":1297220000,
    "descripcion":"QUEMADURA DE PABELLÓN AURICULAR"
  },
  {
    "codigo":248644001,
    "descripcion":"HALLAZGO DE VOLUMEN DEL PULSO ALTERNANTE"
  },
  {
    "codigo":609092003,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: BAMÚN"
  },
  {
    "codigo":707396004,
    "descripcion":"ADENOCARCINOMA OXIFÍLICO PRIMARIO DE OROFARINGE"
  },
  {
    "codigo":445252005,
    "descripcion":"SÍNDROME DE DEFICIENCIA DE PROTEÍNA TRANSPORTADORA DE GLUCOSA TIPO 1"
  },
  {
    "codigo":1231684005,
    "descripcion":"QUERATITIS CAUSADA POR PARÁSITO"
  },
  {
    "codigo":82969005,
    "descripcion":"CHASQUIDO DE APERTURA"
  },
  {
    "codigo":11838121000119108,
    "descripcion":"LESIÓN TRAUMÁTICA DE TENDÓN DE LA MANO DERECHA"
  },
  {
    "codigo":212206000,
    "descripcion":"LESIÓN DE LA RAÍZ DEL NERVIO DORSAL - D1"
  },
  {
    "codigo":17433009,
    "descripcion":"EMBARAZO ECTÓPICO ROTO"
  },
  {
    "codigo":246809009,
    "descripcion":"CICATRIZACIÓN DEL PLIEGUE SEMILUNAR"
  },
  {
    "codigo":115737007,
    "descripcion":"GRUPO SANGUÍNEO B>H<"
  },
  {
    "codigo":1162478006,
    "descripcion":"DELECIÓN DE PARTE DEL BRAZO LARGO DEL CROMOSOMA 16"
  },
  {
    "codigo":13763000,
    "descripcion":"EDAD GESTACIONAL, 34 SEMANAS"
  },
  {
    "codigo":110232003,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO DE LA REGIÓN AMIGDALINA"
  },
  {
    "codigo":700056005,
    "descripcion":"SÍNDROME DE ANEUPLOIDÍA EN MOSAICO ABIGARRADA"
  },
  {
    "codigo":11928007,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DEL FLANCO, SIN INFECCIÓN"
  },
  {
    "codigo":208536009,
    "descripcion":"FRACTURA EXPUESTA DE FÉMUR PROXIMAL, TRANSEPIFISARIA"
  },
  {
    "codigo":698221003,
    "descripcion":"ESPECIE DE NOCARDIA NO AISLADA"
  },
  {
    "codigo":10093004,
    "descripcion":"ANISAQUIASIS CAUSADA POR LARVA DE ANISAKIS SIMPLEX"
  },
  {
    "codigo":8258000,
    "descripcion":"PERIOVARITIS"
  },
  {
    "codigo":403309008,
    "descripcion":"ELCONIXIS"
  },
  {
    "codigo":42861008,
    "descripcion":"TROMBOFLEBITIS DE LA VENA ILÍACA"
  },
  {
    "codigo":1288045008,
    "descripcion":"TUMOR NEUROENDOCRINO BIEN DIFERENCIADO"
  },
  {
    "codigo":1255277009,
    "descripcion":"FRACTURA CONMINUTA NO EXPUESTA DE FALANGE PROXIMAL DE DEDO DE MANO"
  },
  {
    "codigo":235799001,
    "descripcion":"RUPTURA DEL INTESTINO"
  },
  {
    "codigo":792855003,
    "descripcion":"ÚLCERA DE PANTORRILLA DEBIDA A ATEROSCLEROSIS DE ARTERIA DE MIEMBRO INFERIOR"
  },
  {
    "codigo":71959007,
    "descripcion":"MUTISMO ELECTIVO"
  },
  {
    "codigo":299500001,
    "descripcion":"AMPLITUD DE MOVIMIENTO ACTIVO DE SUPINACIÓN MEDIOTARSIANA AUMENTADA"
  },
  {
    "codigo":70124003,
    "descripcion":"PULSO CAPILAR"
  },
  {
    "codigo":365036005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA UTILIZAR UN SISTEMA NO VERBAL PARA LA COMUNICACIÓN"
  },
  {
    "codigo":102892007,
    "descripcion":"ASPECTO PERSONAL DESCUIDADO"
  },
  {
    "codigo":233964008,
    "descripcion":"ESTENOSIS DE LA ARTERIA CARÓTIDA INTERNA"
  },
  {
    "codigo":1217004007,
    "descripcion":"QUERATITIS RECURRENTE POR VIRUS DE HERPES SIMPLE HUMANO"
  },
  {
    "codigo":232129007,
    "descripcion":"HIPERMETROPÍA AXIAL"
  },
  {
    "codigo":263062004,
    "descripcion":"SUBLUXACIÓN DE ARTICULACIÓN DE DEDO DEL PIE"
  },
  {
    "codigo":721814006,
    "descripcion":"MENINGITIS CAUSADA POR TRYPANOSOMA BRUCEI"
  },
  {
    "codigo":164758007,
    "descripcion":"TIMPANOGRAMA NORMAL"
  },
  {
    "codigo":295830007,
    "descripcion":"SOBREDOSIS DE FÁRMACO ANTIDEPRESIVO"
  },
  {
    "codigo":230294009,
    "descripcion":"PARQUINSONISMO PRODUCIDO POR MANGANESO"
  },
  {
    "codigo":66454007,
    "descripcion":"ENCEFALITIS DE MURRAY VALLEY"
  },
  {
    "codigo":293995003,
    "descripcion":"ALERGIA A LIDOFLAZINA"
  },
  {
    "codigo":359531004,
    "descripcion":"TROMBOCITOPENIA AMEGACARIOCÍTICA CON MALFORMACIÓN CONGÉNITA"
  },
  {
    "codigo":425067005,
    "descripcion":"HALLAZGO RELACIONADO CON EL DESARROLLO DEL HABLA Y EL LENGUAJE"
  },
  {
    "codigo":35791000175103,
    "descripcion":"ÚLCERA POR PRESIÓN EN TOBILLO ESTADIO II"
  },
  {
    "codigo":719979008,
    "descripcion":"ENFERMEDAD DE CHARCOT-MARIE-TOOTH, TIPO ID"
  },
  {
    "codigo":290325000,
    "descripcion":"INTOXICACIÓN POR MEDIO DE CONTRASTE RADIOGRÁFICO"
  },
  {
    "codigo":126485001,
    "descripcion":"URTICARIA"
  },
  {
    "codigo":95552009,
    "descripcion":"FIBROSIS DE MESENTERIO"
  },
  {
    "codigo":161088009,
    "descripcion":"VIAJES PREVIOS AL EXTERIOR ++"
  },
  {
    "codigo":1142293003,
    "descripcion":"HIPOPLASIA CONGÉNITA DE CEJA"
  },
  {
    "codigo":93717002,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL CUERPO DEL ESTÓMAGO"
  },
  {
    "codigo":15664401000119101,
    "descripcion":"NEOPLASIA BENIGNA DE AMBAS CONJUNTIVAS"
  },
  {
    "codigo":1082641000119102,
    "descripcion":"ALERGIA A MATERIAL DE RESTAURACIÓN DENTAL EXISTENTE"
  },
  {
    "codigo":91882003,
    "descripcion":"AUSENCIA CONGÉNITA DE EPIDÍDIMO"
  },
  {
    "codigo":124650006,
    "descripcion":"DEFICIENCIA DE AMONÍACO - LIASA"
  },
  {
    "codigo":384959002,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA DE PARED TORÁCICA AFECTADO POR NEOPLASIA MALIGNA"
  },
  {
    "codigo":1204159006,
    "descripcion":"LINFADENITIS MEDIASTÍNICA AGUDA"
  },
  {
    "codigo":253887007,
    "descripcion":"VÁLVULAS URETERALES CONGÉNITAS"
  },
  {
    "codigo":448660000,
    "descripcion":"DOLOR A LA PALPACIÓN DE CUADRANTE SUPERIOR IZQUIERDO DEL ABDOMEN"
  },
  {
    "codigo":55444004,
    "descripcion":"NEUTROPENIA NEONATAL TRANSITORIA"
  },
  {
    "codigo":345361000119106,
    "descripcion":"SUBLUXACIÓN BILATERAL DE CRISTALINO"
  },
  {
    "codigo":284820008,
    "descripcion":"DIFICULTAD AL PARARSE EN LA BAÑERA"
  },
  {
    "codigo":88212009,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE HOMBRO, CON INFECCIÓN"
  },
  {
    "codigo":282985003,
    "descripcion":"CAPAZ DE VOLTEAR"
  },
  {
    "codigo":1003881009,
    "descripcion":"ENFERMEDAD DE PELIZAEUS-MERZBACHER EN PORTADORA FEMENINA"
  },
  {
    "codigo":608830002,
    "descripcion":"DOLOR DISCOGÉNICO"
  },
  {
    "codigo":1264190002,
    "descripcion":"PIGMENTACIÓN LOCAL EXÓGENA DE REGIÓN INFERIOR DE MUCOSA YUGAL DERECHA"
  },
  {
    "codigo":248382004,
    "descripcion":"CIERRE DE FONTANELA"
  },
  {
    "codigo":19006008,
    "descripcion":"OSTEÍTIS NO SUPURATIVA DE LA MANDÍBULA"
  },
  {
    "codigo":42251000087100,
    "descripcion":"HERIDA PENETRANTE DE OJO IZQUIERDO PROPIAMENTE DICHO DEBIDA A CUERPO EXTRAÑO"
  },
  {
    "codigo":47371000087101,
    "descripcion":"DISTENSIÓN DE MÚSCULO TRÍCEPS BRAQUIAL DERECHO"
  },
  {
    "codigo":39691000087103,
    "descripcion":"DOLOR VISCERAL CRÓNICO EN REGIÓN ABDOMINAL DEBIDO A TRASTORNO"
  },
  {
    "codigo":279315008,
    "descripcion":"SÍNTOMA PSICÓTICO - HALLAZGO"
  },
  {
    "codigo":310248000,
    "descripcion":"ATENCIÓN PRENATAL CONDUCIDA POR OBSTÉTRICA"
  },
  {
    "codigo":277480002,
    "descripcion":"ENCEFALOPATÍA ASFIXIANTE NEONATAL"
  },
  {
    "codigo":1196819007,
    "descripcion":"MESENQUIMOMA BENIGNO DE INTESTINO DELGADO"
  },
  {
    "codigo":44811000087108,
    "descripcion":"INFARTO AGUDO DE MIOCARDIO CON ELEVACIÓN DE SEGMENTO ST DEBIDO A OCLUSIÓN DE SEGMENTO DISTAL DE RAMA CIRCUNFLEJA DE ARTERIA CORONARIA IZQUIERDA"
  },
  {
    "codigo":734397002,
    "descripcion":"RUPTURA ESPONTÁNEA DE ARTERIA COMUNICANTE POSTERIOR DERECHA"
  },
  {
    "codigo":79037006,
    "descripcion":"PÁNCREAS ACCESORIO"
  },
  {
    "codigo":318891000119108,
    "descripcion":"ARTRITIS REUMATOIDEA SEROPOSITIVA DE ARTICULACIÓN DE REGIÓN DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":208274000,
    "descripcion":"FRACTURA NO EXPUESTA DE HÚMERO DISTAL, MÚLTIPLE"
  },
  {
    "codigo":275645009,
    "descripcion":"DERIVADO A ENFERMERA"
  },
  {
    "codigo":111805009,
    "descripcion":"INFECCIÓN CAUSADA POR CLOSTRIDIUM CHAUVOEI"
  },
  {
    "codigo":44434003,
    "descripcion":"FRACTURA NO EXPUESTA DE LA COLUMNA DORSAL CON LESIÓN TRAUMÁTICA DE LA MÉDULA ESPINAL"
  },
  {
    "codigo":765330003,
    "descripcion":"ENFERMEDAD RENAL POLIQUÍSTICA AUTOSÓMICA DOMINANTE"
  },
  {
    "codigo":109970006,
    "descripcion":"LINFOMA NO HODGKIN FOLICULAR, DE CÉLULAS HENDIDAS PEQUEÑAS (CLÍNICO)"
  },
  {
    "codigo":11666007,
    "descripcion":"HIDROCELE INFECTADO"
  },
  {
    "codigo":239207002,
    "descripcion":"COMPRESIÓN VENOSA EXTRÍNSECA DEL COLGAJO"
  },
  {
    "codigo":1255015004,
    "descripcion":"DEPENDENCIA COMBINADA DE SUSTANCIA OPIOIDE Y NO OPIOIDE, EPISÓDICA"
  },
  {
    "codigo":42599006,
    "descripcion":"TRAUMATISMO POR INSTRUMENTAL DURANTE EL PARTO"
  },
  {
    "codigo":206439006,
    "descripcion":"ICTERICIA NEONATAL DEBIDA A DEFICIENCIA DE GLUCOSA-6-FOSFATO DESHIDROGENASA"
  },
  {
    "codigo":403047007,
    "descripcion":"TIÑA DE LA MANO CAUSADA POR EPIDERMOPHYTON FLOCCOSUM"
  },
  {
    "codigo":271975008,
    "descripcion":"ALTERACIÓN DE REPARACIÓN DE URÉTER CON INJERTO"
  },
  {
    "codigo":73532000,
    "descripcion":"LARVA MIGRATORIA CUTÁNEA CAUSADA POR ANCYLOSTOMA CANINUM"
  },
  {
    "codigo":1351484006,
    "descripcion":"EXOFORIA COMITANTE"
  },
  {
    "codigo":366609000,
    "descripcion":"PRUEBA DE ACCIDENTE CEREBROVASCULAR - HALLAZGO"
  },
  {
    "codigo":7996008,
    "descripcion":"SUFRIMIENTO FETAL INTRAUTERINO DETECTADO POR PRIMERA VEZ DURANTE EL TRABAJO DE PARTO Y\/O EL PARTO EN NIÑO NACIDO VIVO"
  },
  {
    "codigo":1187644009,
    "descripcion":"SÍNDROME DE BASEL VANAGAITE SMIRIN YOSEF"
  },
  {
    "codigo":170001007,
    "descripcion":"AMAMANTADO Y ALIMENTADO CON SUPLEMENTOS AL AÑO"
  },
  {
    "codigo":364774000,
    "descripcion":"HALLAZGO RELACIONADO CON EL MOVIMIENTO DE LA ÚVULA"
  },
  {
    "codigo":233702002,
    "descripcion":"NEUMONITIS ALÉRGICA ESTIVAL"
  },
  {
    "codigo":397542006,
    "descripcion":"ALTERACIÓN VISUAL MODERADA"
  },
  {
    "codigo":266470007,
    "descripcion":"CIRROSIS PORTAL CARDIÓGENA"
  },
  {
    "codigo":166331001,
    "descripcion":"NIVEL DE TIROXINA SÉRICA FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1085151000119104,
    "descripcion":"FÍSTULA DE INTESTINO DEBIDA A PANCOLITIS ULCEROSA CRÓNICA"
  },
  {
    "codigo":788923005,
    "descripcion":"MUTILACIÓN DE GENITALES FEMENINOS TIPO 1B"
  },
  {
    "codigo":1149371006,
    "descripcion":"SOBREDOSIS DE SULFAMETOXAZOL Y\/O TRIMETOPRIMA"
  },
  {
    "codigo":231867009,
    "descripcion":"QUEMADURA TÉRMICA DE LA CONJUNTIVA"
  },
  {
    "codigo":721552003,
    "descripcion":"AUSENCIA TOTAL ADQUIRIDA DE MAMA"
  },
  {
    "codigo":293733002,
    "descripcion":"ALERGIA A ALDESLEUKINA"
  },
  {
    "codigo":129893005,
    "descripcion":"ALTERACIÓN RESPIRATORIA"
  },
  {
    "codigo":719717006,
    "descripcion":"PSICOSIS CONCOMITANTE CON ENFERMEDAD DE PARKINSON Y DEBIDA A ELLA"
  },
  {
    "codigo":424805008,
    "descripcion":"EJERCICIO POR ENCIMA DEL NIVEL RECOMENDADO"
  },
  {
    "codigo":160826001,
    "descripcion":"PROBLEMAS MARITALES ENTRE LOS PADRES"
  },
  {
    "codigo":95290002,
    "descripcion":"CENTRO DE LA VÉRTEBRA LUMBAR SUPERNUMERARIO"
  },
  {
    "codigo":422970001,
    "descripcion":"PARO CARDÍACO POR TRAUMATISMO"
  },
  {
    "codigo":783418004,
    "descripcion":"ANEURISMA DE ARTERIA COMUNICANTE ANTERIOR"
  },
  {
    "codigo":816186004,
    "descripcion":"EDEMA DE AMBOS MIEMBROS SUPERIORES"
  },
  {
    "codigo":11790201000119102,
    "descripcion":"LESIÓN TRAUMÁTICA DE DEDO DE MANO IZQUIERDA"
  },
  {
    "codigo":128058007,
    "descripcion":"TRASTORNO DE LA DERIVACIÓN VASCULAR PORTOSISTÉMICA"
  },
  {
    "codigo":321401000119102,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE TENDÓN EXTENSOR DE MUSLO IZQUIERDO"
  },
  {
    "codigo":717882009,
    "descripcion":"HEMORRAGIA INTRAMURAL DE DUODENO"
  },
  {
    "codigo":290063001,
    "descripcion":"CONSISTENCIA DE LA MAMA NORMAL"
  },
  {
    "codigo":1142031005,
    "descripcion":"ATROFIA ÓPTICA DEBIDA A SÍFILIS CONGÉNITA TARDÍA"
  },
  {
    "codigo":124388000,
    "descripcion":"DEFICIENCIA DE HEXOSILTRANSFERASA"
  },
  {
    "codigo":189924002,
    "descripcion":"XANTOASTROCITOMA PLEOMÓRFICO"
  },
  {
    "codigo":1304036003,
    "descripcion":"GLAUCOMA DE ÁNGULO ABIERTO DE OJO DERECHO DEBIDO A NEOVASCULARIZACIÓN"
  },
  {
    "codigo":384697000,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA AFECTADO POR NEOPLASIA MALIGNA, MULTIFOCAL"
  },
  {
    "codigo":188089003,
    "descripcion":"NEOPLASIA MALIGNA DE PIEL DE OÍDO Y CONDUCTO AUDITIVO EXTERNO"
  },
  {
    "codigo":253625004,
    "descripcion":"ATRESIA PULMONAR CON ARTERIA PULMONAR AUSENTE"
  },
  {
    "codigo":286393008,
    "descripcion":"CAPAZ DE UTILIZAR ADECUADAMENTE EL LENGUAJE"
  },
  {
    "codigo":1269433008,
    "descripcion":"PINZAMIENTO SUBCORACOIDEO DE REGIÓN DE HOMBRO"
  },
  {
    "codigo":415630002,
    "descripcion":"ESTADO DE MONITOREO DE ACCIDENTE CEREBROVASCULAR\/ATAQUE ISQUÉMICO TRANSITORIO"
  },
  {
    "codigo":55182004,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA SIN COMPROMISO TUMORAL"
  },
  {
    "codigo":1234830005,
    "descripcion":"SÍNDROME DE DUPLICACIÓN 14Q32"
  },
  {
    "codigo":87950005,
    "descripcion":"TRASTORNO BIPOLAR I, UN SOLO EPISODIO MANÍACO CON SÍNTOMAS CATATÓNICOS"
  },
  {
    "codigo":446563000,
    "descripcion":"HEMATOMA SUCONDRAL DE PABELLÓN AURICULAR"
  },
  {
    "codigo":282723003,
    "descripcion":"CONTUSIÓN DE BRONQUIO"
  },
  {
    "codigo":249955006,
    "descripcion":"MOVIMIENTO CONTRA RESISTENCIA"
  },
  {
    "codigo":1231160001,
    "descripcion":"DEPENDENCIA DE HIPNÓTICO EPISÓDICA"
  },
  {
    "codigo":248120002,
    "descripcion":"EJERCICIO EXCESIVO PARA PERDER PESO"
  },
  {
    "codigo":315491009,
    "descripcion":"NACIDO EN NIGERIA"
  },
  {
    "codigo":51512005,
    "descripcion":"SECUENCIA REPETITIVA DE ÁCIDOS NUCLEICOS"
  },
  {
    "codigo":1263928008,
    "descripcion":"SHOCK SÉPTICO POSTERIOR A EMBARAZO MOLAR"
  },
  {
    "codigo":611000124105,
    "descripcion":"INCUMPLIMIENTO CON LA RECOLECCIÓN DE MUESTRA DE DIALIZADO PERITONEAL"
  },
  {
    "codigo":471651000124106,
    "descripcion":"MIGRAÑA EPISÓDICA"
  },
  {
    "codigo":870712009,
    "descripcion":"ALERGIA A PIPERACILINA Y\/O TAZOBACTAM"
  },
  {
    "codigo":311821002,
    "descripcion":"FRACTURA NO EXPUESTA DE DEDO GORDO"
  },
  {
    "codigo":706872008,
    "descripcion":"ANCIANO VÍCTIMA DE MALTRATO"
  },
  {
    "codigo":279053007,
    "descripcion":"DOLOR MANTENIDO POR LA VÍA SIMPÁTICA"
  },
  {
    "codigo":277218000,
    "descripcion":"COLAPSO ALAR COMPLETO"
  },
  {
    "codigo":240780005,
    "descripcion":"CELULITIS GANGRENOSA MUCORMICÓTICA"
  },
  {
    "codigo":109708005,
    "descripcion":"PÉRDIDA DE HUESO ALVEOLAR QUE EXCEDE LA DIVISIÓN RADICULAR"
  },
  {
    "codigo":271713000,
    "descripcion":"INESTABILIDAD GENERAL"
  },
  {
    "codigo":76940009,
    "descripcion":"VÓLVULO GÁSTRICO AGUDO"
  },
  {
    "codigo":238945000,
    "descripcion":"MUCINOSIS DIFUSA DE LA PIEL"
  },
  {
    "codigo":1287521003,
    "descripcion":"NECROSIS AVASCULAR DE CUELLO DE FÉMUR"
  },
  {
    "codigo":1156449006,
    "descripcion":"DISPOSICIÓN A APRENDER"
  },
  {
    "codigo":1254753006,
    "descripcion":"METÁSTASIS DE CARCINOMA VERRUGOSO EN PIEL DE PLANTA DE PIE"
  },
  {
    "codigo":402785008,
    "descripcion":"HIPERLIPEMIA PRIMARIA GENÉTICA"
  },
  {
    "codigo":204342004,
    "descripcion":"ATRESIA CONGÉNITA DE VÁLVULA PULMONAR"
  },
  {
    "codigo":678061000119109,
    "descripcion":"HEMORRAGIA SUBRETINIANA DE AMBOS OJOS"
  },
  {
    "codigo":237110007,
    "descripcion":"CONDILOMA ACUMINADO VULVAR"
  },
  {
    "codigo":366347002,
    "descripcion":"HALLAZGO RELACIONADO CON LAS CARACTERÍSTICAS SUPERFICIALES DE LA MAMA"
  },
  {
    "codigo":300811007,
    "descripcion":"INCAPAZ DE REALIZAR TRABAJO VOLUNTARIO"
  },
  {
    "codigo":69600003,
    "descripcion":"TEMBLOR VOCAL"
  },
  {
    "codigo":167904004,
    "descripcion":"LÍQUIDO SINOVIAL: PIROFOSFATO"
  },
  {
    "codigo":298976008,
    "descripcion":"AMPLITUD DE ABDUCCIÓN PASIVA DE ARTICULACIÓN DE MUÑECA, NORMAL"
  },
  {
    "codigo":34997001,
    "descripcion":"PETROSITIS"
  },
  {
    "codigo":1149109001,
    "descripcion":"MIOCARDIOPATÍA DILATADA DEBIDA A DESEQUILIBRIO ELECTROLÍTICO"
  },
  {
    "codigo":2229005,
    "descripcion":"QUIMERA"
  },
  {
    "codigo":297141005,
    "descripcion":"ÉMBOLO DE ARTERIA POPLÍTEA"
  },
  {
    "codigo":723125008,
    "descripcion":"ENCEFALOPATÍA EPILÉPTICA"
  },
  {
    "codigo":428213008,
    "descripcion":"EFECTO TARDÍO DE HEMATOMA SUBDURAL POR TRAUMATISMO"
  },
  {
    "codigo":10645831000119109,
    "descripcion":"ÚLCERA VARICOSA DE PIERNA DERECHA"
  },
  {
    "codigo":721290005,
    "descripcion":"HIPOFUNCIÓN ADRENOCORTICAL POSTERIOR A PROCEDIMIENTO"
  },
  {
    "codigo":786826006,
    "descripcion":"PLASMODIUM OVALE O PLASMODIUM VIVAX"
  },
  {
    "codigo":11792711000119109,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN DE DEDO ÍNDICE IZQUIERDO"
  },
  {
    "codigo":262538008,
    "descripcion":"EXCORIACIÓN POR FRICCIÓN"
  },
  {
    "codigo":195167002,
    "descripcion":"HEMORRAGIA DE CÁPSULA EXTERNA"
  },
  {
    "codigo":719455002,
    "descripcion":"DISTROFIA DE CONOS CON RESPUESTA DE BASTONES SUPERNORMAL"
  },
  {
    "codigo":31327004,
    "descripcion":"CHOQUE POR QUEMADURA"
  },
  {
    "codigo":129631008,
    "descripcion":"SORDERA POR TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":293471009,
    "descripcion":"REACCIÓN ADVERSA AL CANRENOATO POTÁSICO"
  },
  {
    "codigo":422708002,
    "descripcion":"CARECE DE CUIDADO FÍSICO ADECUADO"
  },
  {
    "codigo":226100000,
    "descripcion":"DIETA CON ALTO CONTENIDO DE ÁCIDOS GRASOS MONOINSATURADOS"
  },
  {
    "codigo":680571000119100,
    "descripcion":"MEIBOMIANITIS DE PÁRPADO INFERIOR IZQUIERDO"
  },
  {
    "codigo":62260007,
    "descripcion":"PARCHES PIGMENTADOS PRETIBIALES DEBIDOS A DIABETES MELLITUS"
  },
  {
    "codigo":783156008,
    "descripcion":"SÍNDROME DE APLASIA DE PERONÉ, CAMPOMELIA TIBIAL Y OLIGOSINDACTILIA"
  },
  {
    "codigo":95028006,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL TEJIDO RETROCECAL"
  },
  {
    "codigo":291636006,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR CEFALORIDINA"
  },
  {
    "codigo":93193008,
    "descripcion":"LINFOMA MALIGNO DE LOS GANGLIOS LINFÁTICOS INTRATORÁCICOS"
  },
  {
    "codigo":25822001,
    "descripcion":"PAQUIMENINGITIS"
  },
  {
    "codigo":124126008,
    "descripcion":"DEFICIENCIA DE MALATO DESHIDROGENASA (DESCARBOXILANTE)"
  },
  {
    "codigo":417203001,
    "descripcion":"LUXACIÓN DE ARTICULACIÓN DE DÍGITO"
  },
  {
    "codigo":286131000,
    "descripcion":"LIMPIA EL ÁREA DE PREPARACIÓN DE ALIMENTOS"
  },
  {
    "codigo":288421000119100,
    "descripcion":"HIPOSOMNIA CONCOMITANTE CON TRASTORNO PSICOLÓGICO Y DEBIDA A ÉL"
  },
  {
    "codigo":367781000119101,
    "descripcion":"OLIGOZOOSPERMIA DEBIDA A OBSTRUCCIÓN DE CONDUCTO EFERENTE"
  },
  {
    "codigo":11857061000119102,
    "descripcion":"HEMATOMA SUBUNGUEAL DE DEDO DE PIE DERECHO"
  },
  {
    "codigo":10756261000119102,
    "descripcion":"MALTRATO FÍSICO QUE COMPLICA EL NACIMIENTO"
  },
  {
    "codigo":10835621000119104,
    "descripcion":"ANOMALÍA CONGÉNITA DE VAGINA EN LA MADRE QUE COMPLICA EL EMBARAZO"
  },
  {
    "codigo":1089701000119101,
    "descripcion":"NEURONITIS VESTIBULAR IZQUIERDA"
  },
  {
    "codigo":15973541000119106,
    "descripcion":"DEFORMIDAD CONGÉNITA DE MIEMBRO INFERIOR DERECHO"
  },
  {
    "codigo":127141000119107,
    "descripcion":"CHOQUE SÉPTICO CONCOMITANTE CON DISFUNCIÓN ORGÁNICA AGUDA CAUSADO POR BACTERIAS ANAERÓBICAS"
  },
  {
    "codigo":298661000119108,
    "descripcion":"OSTEONECROSIS DE FALANGE DE DEDO DE MANO DEBIDA A TRAUMATISMO"
  },
  {
    "codigo":16836261000119107,
    "descripcion":"EMBARAZO ECTÓPICO DE OVARIO IZQUIERDO"
  },
  {
    "codigo":334501000119101,
    "descripcion":"QUISTE DE GLÁNDULA LAGRIMAL DERECHA"
  },
  {
    "codigo":16636581000119107,
    "descripcion":"TRASTORNO DE NERVIOS SUPRAESCAPULARES BILATERALES"
  },
  {
    "codigo":12235941000119104,
    "descripcion":"DEFORMIDAD CONGÉNITA DE PIE IZQUIERDO"
  },
  {
    "codigo":87688009,
    "descripcion":"COLESTEATOMA DE OÍDO MEDIO"
  },
  {
    "codigo":282461001,
    "descripcion":"CUERPO EXTRAÑO EN BRONQUIO"
  },
  {
    "codigo":316581000119106,
    "descripcion":"OSTEOFITO DE MANO IZQUIERDA"
  },
  {
    "codigo":15932581000119107,
    "descripcion":"PROLAPSO DE TROMPA DE FALOPIO DERECHA"
  },
  {
    "codigo":331941000119109,
    "descripcion":"GLAUKOMFLECKEN DE OJO DERECHO"
  },
  {
    "codigo":249693004,
    "descripcion":"ESTERNÓN GRANDE"
  },
  {
    "codigo":413533008,
    "descripcion":"ANEMIA POR PÉRDIDA CRÓNICA DE SANGRE"
  },
  {
    "codigo":247858004,
    "descripcion":"MIEDO A MANTENER LA CONSCIENCIA DURANTE LA ANESTESIA GENERAL"
  },
  {
    "codigo":49415001,
    "descripcion":"ALIMENTACIÓN LENTA EN EL RECIÉN NACIDO"
  },
  {
    "codigo":213255003,
    "descripcion":"SHOCK ENDOTÓXICO POSOPERATORIO"
  },
  {
    "codigo":1163527006,
    "descripcion":"EPILEPSIA DEBIDA A ENFERMEDAD PARASITARIA"
  },
  {
    "codigo":448947009,
    "descripcion":"ANOMALÍA CONGÉNITA DE VÁLVULA AURICULOVENTRICULAR IZQUIERDA EN VENTRÍCULO CON DOBLE TRACTO DE ENTRADA"
  },
  {
    "codigo":14812002,
    "descripcion":"CELULITIS DE PENE"
  },
  {
    "codigo":47580006,
    "descripcion":"INTOXICACIÓN POR ACARICIDA"
  },
  {
    "codigo":438961001,
    "descripcion":"FÍSTULA ARTERIOVENOSA IATROGÉNICA"
  },
  {
    "codigo":307889002,
    "descripcion":"ESTADO DE CERTIFICADO DE CORTE DE PROTECCIÓN"
  },
  {
    "codigo":1290929005,
    "descripcion":"DEPÓSITO DE CALCIO EN BOLSA SEROSA DE MANO"
  },
  {
    "codigo":209585007,
    "descripcion":"DESGARRO COMPLETO DE LIGAMENTO LATERAL RADIAL"
  },
  {
    "codigo":16028591000119102,
    "descripcion":"EXOSTOSIS BILATERAL DE FÉMUR"
  },
  {
    "codigo":373425009,
    "descripcion":"ENDOTELITIS CORNEAL"
  },
  {
    "codigo":1354630002,
    "descripcion":"FRACTURA DE QUINTO HUESO METATARSIANO"
  },
  {
    "codigo":43910005,
    "descripcion":"HIPOPLASIA CONGÉNITA DE LA AORTA"
  },
  {
    "codigo":402523001,
    "descripcion":"CARCINOMA BASOCELULAR DE PIEL DE TRONCO"
  },
  {
    "codigo":1187120008,
    "descripcion":"SÍNDROME DE STROMME"
  },
  {
    "codigo":890373001,
    "descripcion":"POLIDACTILIA CENTRAL DE LOS DEDOS DE AMBAS MANOS"
  },
  {
    "codigo":202245003,
    "descripcion":"LUXACIÓN RECURRENTE DE RODILLA"
  },
  {
    "codigo":300549004,
    "descripcion":"INCAPAZ DE MANTENER RELACIONES SEXUALES"
  },
  {
    "codigo":169477005,
    "descripcion":"DISPOSITIVO ANTICONCEPTIVO INTRAUTERINO AJUSTADO"
  },
  {
    "codigo":11824201000119101,
    "descripcion":"CONTUSIÓN DE BRAZO DERECHO"
  },
  {
    "codigo":235013007,
    "descripcion":"ANORMALIDAD DE CRESTA ALVEOLAR"
  },
  {
    "codigo":366085009,
    "descripcion":"REFLEJO FOTOMOTOR - HALLAZGO"
  },
  {
    "codigo":298714005,
    "descripcion":"HALLAZGO RELACIONADO CON EL MOVIMIENTO DEL TÓRAX"
  },
  {
    "codigo":823002005,
    "descripcion":"GANGLIO LINFÁTICO AISLADO"
  },
  {
    "codigo":69338007,
    "descripcion":"SIGNO DE KANTER"
  },
  {
    "codigo":167642008,
    "descripcion":"MATERIA FECAL: CÁLCULOS BILIARES PRESENTES"
  },
  {
    "codigo":395183000,
    "descripcion":"HEMATOMA SUBPERIÓSTICO"
  },
  {
    "codigo":1967001,
    "descripcion":"AUSENCIA LONGITUDINAL DE RADIO Y CÚBITO"
  },
  {
    "codigo":15920201000119103,
    "descripcion":"REACCIÓN ALÉRGICA CAUSADA POR PESCADO"
  },
  {
    "codigo":1148847004,
    "descripcion":"LINFOMA NO HODGKIN FOLICULAR IN SITU"
  },
  {
    "codigo":165807006,
    "descripcion":"ANTÍGENO DE HEPATITIS BE DETECTADO"
  },
  {
    "codigo":296879007,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE PROGESTÁGENO"
  },
  {
    "codigo":722863008,
    "descripcion":"DENGUE CON SIGNOS DE ALARMA"
  },
  {
    "codigo":426116001,
    "descripcion":"DISPOSICIÓN PARA MEJORAR LA NUTRICIÓN"
  },
  {
    "codigo":65668001,
    "descripcion":"OTORREA"
  },
  {
    "codigo":1179780002,
    "descripcion":"CAROTENO DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1343620006,
    "descripcion":"CATÉTER PERITONEAL INTERNO IN SITU"
  },
  {
    "codigo":719193000,
    "descripcion":"LECHO UNGUEAL PÁLIDO"
  },
  {
    "codigo":194905000,
    "descripcion":"PERICARDITIS AGUDA CAUSADA POR VIRUS COXSACKIE"
  },
  {
    "codigo":196740009,
    "descripcion":"GASTRITIS CORROSIVA"
  },
  {
    "codigo":61998001,
    "descripcion":"DEFICIENCIA DE GLUCAGÓN"
  },
  {
    "codigo":29230002,
    "descripcion":"CRECIMIENTO BACTERIANO EN MEDIO ARTIFICIAL"
  },
  {
    "codigo":1208878003,
    "descripcion":"CAVIDAD ANOFTÁLMICA ADQUIRIDA CON IMPLANTE ORBITARIO"
  },
  {
    "codigo":293209009,
    "descripcion":"REACCIÓN ADVERSA A LA DIDROGESTERONA"
  },
  {
    "codigo":225838005,
    "descripcion":"COMPRENDE LOS FUNDAMENTOS DE REPRESENTACIÓN LEGAL"
  },
  {
    "codigo":94766006,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL TRONCO ENCEFÁLICO"
  },
  {
    "codigo":422446008,
    "descripcion":"INFILTRADOS SUBEPITELIALES POR HERPES ZÓSTER"
  },
  {
    "codigo":715523005,
    "descripcion":"SÍNDROME DE POLIDACTILIA EN ESPEJO, SEGMENTACIÓN VERTEBRAL Y DEFECTO DE MIEMBROS"
  },
  {
    "codigo":289539007,
    "descripcion":"SANGRADO VAGINAL MODERADO"
  },
  {
    "codigo":254936001,
    "descripcion":"TUMOR GLIAL DE CEREBRO"
  },
  {
    "codigo":89261000,
    "descripcion":"DEFICIENCIA AISLADA DE TIROTROFINA"
  },
  {
    "codigo":285869003,
    "descripcion":"INCAPAZ DE USAR LAVARROPAS"
  },
  {
    "codigo":1268909004,
    "descripcion":"CARCINOFIBROMA PRIMARIO DE CUERPO DE ÚTERO"
  },
  {
    "codigo":253101008,
    "descripcion":"HERNIA CEREBRAL CONGÉNITA"
  },
  {
    "codigo":218498003,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR ANTIHISTAMÍNICOS"
  },
  {
    "codigo":710018003,
    "descripcion":"INSERCIÓN MUSCULAR EN ESTADO EDÉNTULO SIN BASE MUCOSA ADHERIDA EN REGIÓN MANDIBULAR ANTERIOR Y VESTÍBULO LINGUAL"
  },
  {
    "codigo":251266004,
    "descripcion":"PATRÓN DEL MARCAPASO VENTRICULAR"
  },
  {
    "codigo":21890006,
    "descripcion":"INTOXICACIÓN POR DRYMARIA PACHYPHYLLA"
  },
  {
    "codigo":447874007,
    "descripcion":"ANOMALÍA CONGÉNITA DE TABIQUE INTERAURICULAR"
  },
  {
    "codigo":185730004,
    "descripcion":"INCUMPLIMIENTO DEL CONTROL DEL ASMA"
  },
  {
    "codigo":282199003,
    "descripcion":"BAJA ESCALERAS"
  },
  {
    "codigo":314967004,
    "descripcion":"RECIDIVA LOCAL DE NEOPLASIA MALIGNA DE RIÑÓN"
  },
  {
    "codigo":249431007,
    "descripcion":"CREPITACIÓN LARÍNGEA"
  },
  {
    "codigo":83756005,
    "descripcion":"INTOXICACIÓN POR PIERIS JAPONICA"
  },
  {
    "codigo":11826711000119100,
    "descripcion":"DISTENSIÓN DE TENDÓN DE MUÑECA DERECHA"
  },
  {
    "codigo":247596007,
    "descripcion":"OLVIDA LO QUE ACABA DE HACER"
  },
  {
    "codigo":737281001,
    "descripcion":"LARINGE ARTIFICIAL IN SITU"
  },
  {
    "codigo":313132009,
    "descripcion":"HALLAZGO RELACIONADO CON LOS DÍGITOS DE LA MANO"
  },
  {
    "codigo":1259734004,
    "descripcion":"MENINGIOMA PRIMARIO MALIGNO DE VAINA DE NERVIO ÓPTICO"
  },
  {
    "codigo":47318007,
    "descripcion":"NEUTROPENIA INDUCIDA POR DROGAS"
  },
  {
    "codigo":473302008,
    "descripcion":"CONSCIENTE DEL DIAGNÓSTICO"
  },
  {
    "codigo":702678008,
    "descripcion":"UTILIZA PESARIO ANTICONCEPTIVO VAGINAL"
  },
  {
    "codigo":309462008,
    "descripcion":"INFECCIÓN DEL DEDO GORDO DEL PIE"
  },
  {
    "codigo":209323001,
    "descripcion":"FRACTURA-SUBLUXACIÓN NO EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA PROXIMAL"
  },
  {
    "codigo":305792005,
    "descripcion":"ATENDIDO POR SERVICIO DE ANESTESIOLOGÍA"
  },
  {
    "codigo":830080006,
    "descripcion":"ALERGIA A CINC Y\/O COMPUESTO DE CINC"
  },
  {
    "codigo":10679831000119106,
    "descripcion":"TUMORACIÓN DEL TEJIDO CELULAR SUBCUTÁNEO DE DEDO DE LA MANO IZQUIERDA"
  },
  {
    "codigo":369493004,
    "descripcion":"TUMOR MALIGNO QUE COMPROMETE EL CUERPO UTERINO POR PROPAGACIÓN DIRECTA DE LA VEJIGA"
  },
  {
    "codigo":205653005,
    "descripcion":"TRISOMÍA 12"
  },
  {
    "codigo":271189004,
    "descripcion":"AMPOLLA TRAUMÁTICA DE DEDO DEL PIE"
  },
  {
    "codigo":238421007,
    "descripcion":"INFECCIÓN CUTÁNEA POR FUSOBACTERIAS"
  },
  {
    "codigo":1186858000,
    "descripcion":"HIPOFUNCIÓN CORTICAL SUPRARRENAL DEBIDO A INTERRUPCIÓN DE TRATAMIENTO CON CORTICOESTEROIDES"
  },
  {
    "codigo":74581008,
    "descripcion":"ENFERMEDAD POR EL VIRUS GANJAM"
  },
  {
    "codigo":302122003,
    "descripcion":"PROBLEMAS RELACIONADOS CON EL TRABAJO Y LA JUBILACIÓN"
  },
  {
    "codigo":72746005,
    "descripcion":"INFERTILIDAD POR BLOQUEO INCOMPLETO DE LA ESPERMATOGÉNESIS"
  },
  {
    "codigo":105514006,
    "descripcion":"DESAVENENCIA EN EL TRABAJO"
  },
  {
    "codigo":236586006,
    "descripcion":"GLOMERULONEFRITIS DE NOVO"
  },
  {
    "codigo":398591002,
    "descripcion":"ERUPCIÓN CENTRÍPETA"
  },
  {
    "codigo":70911004,
    "descripcion":"HERNIA ISQUIÁTICA"
  },
  {
    "codigo":5375005,
    "descripcion":"INSUFICIENCIA VENTRICULAR IZQUIERDA CONGESTIVA CRÓNICA"
  },
  {
    "codigo":300287006,
    "descripcion":"MASA ESOFÁGICA"
  },
  {
    "codigo":201983009,
    "descripcion":"ARTRITIS CLIMATÉRICA DE TOBILLO Y\/O PIE"
  },
  {
    "codigo":200148001,
    "descripcion":"PARTO POR CESÁREA PROGRAMADA"
  },
  {
    "codigo":724436003,
    "descripcion":"ANOMALÍA CONGÉNITA DE AORTA ABDOMINAL"
  },
  {
    "codigo":365823009,
    "descripcion":"NIVEL DE URICEMIA - HALLAZGO"
  },
  {
    "codigo":298452005,
    "descripcion":"AMPLITUD DE ROTACIÓN ACTIVA HACIA LA DERECHA DE LA COLUMNA CERVICAL AUMENTADA"
  },
  {
    "codigo":1705000,
    "descripcion":"FRACTURA NO EXPUESTA DE BASE DE CUELLO DE FÉMUR"
  },
  {
    "codigo":15732401000119107,
    "descripcion":"ENTROPIÓN CON ECTROPIÓN DE PÁRPADO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":1279657003,
    "descripcion":"HERIDA PUNZANTE DE PÁRPADO"
  },
  {
    "codigo":722601005,
    "descripcion":"TRASTORNO DE LA SUSTANCIA BLANCA CAUSADO POR INFECCIÓN"
  },
  {
    "codigo":1343358000,
    "descripcion":"ACCESO DIGITAL INADECUADO QUE AFECTA LA EDUCACIÓN"
  },
  {
    "codigo":460457009,
    "descripcion":"PERICARDITIS CONSTRICTIVA CAUSADA POR BACTERIAS"
  },
  {
    "codigo":1148585008,
    "descripcion":"INFECCIÓN INTESTINAL CAUSADA POR VIBRIO PARAHAEMOLYTICUS"
  },
  {
    "codigo":294782005,
    "descripcion":"ALERGIA A ESTRADIOL"
  },
  {
    "codigo":1144915003,
    "descripcion":"POLIMIOSITIS JUVENIL DEBIDA A SÍNDROME PARANEOPLÁSICO"
  },
  {
    "codigo":292947004,
    "descripcion":"REACCIÓN ADVERSA AL CINOXACINO"
  },
  {
    "codigo":127272006,
    "descripcion":"NEOPLASIA DE LOS GANGLIOS LINFÁTICOS PARAVAGINALES"
  },
  {
    "codigo":225576006,
    "descripcion":"CAPAZ DE ELIMINAR ESPUTO MEDIANTE LA TOS"
  },
  {
    "codigo":94504009,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL PUBIS"
  },
  {
    "codigo":289277002,
    "descripcion":"PLACENTA PÁLIDA"
  },
  {
    "codigo":304971000119107,
    "descripcion":"AUSENCIA CONGÉNITA DE PIERNA Y PIE DERECHOS"
  },
  {
    "codigo":59901004,
    "descripcion":"MORDEDURA DE CARRILLO"
  },
  {
    "codigo":688101000119101,
    "descripcion":"NEURILEMOMA DE NERVIO ABDOMINAL"
  },
  {
    "codigo":92669006,
    "descripcion":"CARCINOMA IN SITU DE OVARIO"
  },
  {
    "codigo":90834002,
    "descripcion":"DOLOR EN EXTREMIDAD"
  },
  {
    "codigo":713426002,
    "descripcion":"BLOQUEO INCOMPLETO DE RAMA DERECHA ELECTROCARDIOGRÁFICO"
  },
  {
    "codigo":1336018002,
    "descripcion":"SÍNDROME COMPARTIMENTAL NO TRAUMÁTICO DE AMBAS EXTREMIDADES SUPERIORES"
  },
  {
    "codigo":123602003,
    "descripcion":"APENDICITIS CURADA"
  },
  {
    "codigo":189138008,
    "descripcion":"NEOPLASIA BENIGNA DE PIEL DE ESCROTO"
  },
  {
    "codigo":156370009,
    "descripcion":"ARTRITIS PSORIÁSICA"
  },
  {
    "codigo":56231002,
    "descripcion":"PÚRPURA ANULAR TELANGIECTÁSICA DE MAJOCCHI"
  },
  {
    "codigo":283772000,
    "descripcion":"MORDEDURA DE PERRO EN LA PIERNA"
  },
  {
    "codigo":251004005,
    "descripcion":"MASAS PRESENTES EN EL APARATO MITRAL"
  },
  {
    "codigo":1332348008,
    "descripcion":"HIPERTROFIA DE HUESO DE MANO"
  },
  {
    "codigo":281937001,
    "descripcion":"FRACTURA DE LÁMINA DE VÉRTEBRA LUMBAR"
  },
  {
    "codigo":314705003,
    "descripcion":"PLAN DE TRATAMIENTO OTORGADO"
  },
  {
    "codigo":11829221000119109,
    "descripcion":"AMPOLLA TRAUMÁTICA DE PIERNA IZQUIERDA"
  },
  {
    "codigo":15980671000119103,
    "descripcion":"ARTRITIS DE ARTICULACIÓN TEMPOROMANDIBULAR DERECHA"
  },
  {
    "codigo":17958007,
    "descripcion":"INTOXICACIÓN POR ALEURITES FORDII"
  },
  {
    "codigo":247334008,
    "descripcion":"SENSACIÓN SEMEJANTE AL COMIENZO DE LA MENSTRUACIÓN"
  },
  {
    "codigo":50726009,
    "descripcion":"INTENTO FALLIDO DE ABORTO CON PERFORACIÓN DE ÚTERO"
  },
  {
    "codigo":704251001,
    "descripcion":"FRACTURA PATOLÓGICA DE HUESO DE PIE EN SITIO DE NEOPLASIA"
  },
  {
    "codigo":16123003,
    "descripcion":"HALLUX VARUS ADQUIRIDO"
  },
  {
    "codigo":81659004,
    "descripcion":"SIGNO O SÍNTOMA PSICOLÓGICO"
  },
  {
    "codigo":473040003,
    "descripcion":"COMPLICACIÓN ASOCIADA CON DERIVACIÓN DE MARCAPASOS CARDÍACO"
  },
  {
    "codigo":407504003,
    "descripcion":"ENFERMEDAD CAUSADA POR GAMMARETROVIRUS"
  },
  {
    "codigo":1259472005,
    "descripcion":"OSTEOSARCOMA PERIÓSTICO PRIMARIO DE MANDÍBULA"
  },
  {
    "codigo":702416008,
    "descripcion":"SÍNDROME DE RETRASO MENTAL LIGADO AL CROMOSOMA X DE SNYDER-ROBINSON"
  },
  {
    "codigo":307365001,
    "descripcion":"NERVIO MUSCULOCUTÁNEO EXTERNO COMPROMETIDO EN LESIÓN DE MUSLO"
  },
  {
    "codigo":210896009,
    "descripcion":"LESIÓN DE ARTERIA PERONEA"
  },
  {
    "codigo":241829009,
    "descripcion":"ENVENENAMIENTO POR PULPO VENENOSO"
  },
  {
    "codigo":895354002,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE URÉTER IZQUIERDO"
  },
  {
    "codigo":403834003,
    "descripcion":"SÍNDROME DE FIEBRE PERIÓDICA ASOCIADA CON HIPER-IGD"
  },
  {
    "codigo":733349009,
    "descripcion":"NEOPLASIA QUÍSTICA MUCINOSA PRIMARIA CON CARCINOMA INVASIVO ASOCIADO DE CONDUCTO BILIAR DISTAL"
  },
  {
    "codigo":305530001,
    "descripcion":"BAJO ATENCIÓN DE CIRUJANO DENTAL"
  },
  {
    "codigo":371066008,
    "descripcion":"ABRASIÓN DE CÓRNEA RELACIONADA CON USO DE LENTES DE CONTACTO"
  },
  {
    "codigo":239994009,
    "descripcion":"ENTESOPATÍA DE LA REGIÓN PÉLVICA"
  },
  {
    "codigo":926287002,
    "descripcion":"EPÍFISIS PEQUEÑA"
  },
  {
    "codigo":1255802009,
    "descripcion":"LINFOMA DE HODGKIN DE GANGLIOS LINFÁTICOS DE CABEZA"
  },
  {
    "codigo":238159008,
    "descripcion":"DESATURACIÓN SANGUÍNEA"
  },
  {
    "codigo":39716001,
    "descripcion":"CONTUSIÓN DE LA VULVA"
  },
  {
    "codigo":449416001,
    "descripcion":"NEOPLASIA EPITELIAL MALIGNA DE PIEL DEL ANO"
  },
  {
    "codigo":170788006,
    "descripcion":"GLÁNDULA TIROIDES - CRITERIOS DIAGNÓSTICOS DUDOSOS"
  },
  {
    "codigo":400164007,
    "descripcion":"AMPOLLA DE PIEL SIN INFECCIÓN"
  },
  {
    "codigo":203556007,
    "descripcion":"DESVIACIÓN DE DEDO DE LA MANO"
  },
  {
    "codigo":168953002,
    "descripcion":"ARTERIOGRAFÍA FEMORAL ANORMAL"
  },
  {
    "codigo":365561003,
    "descripcion":"HALLAZGO RELACIONADO CON EL MANEJO DE ASUNTOS FINANCIEROS"
  },
  {
    "codigo":16527641000119107,
    "descripcion":"CARCINOMA NO MICROCÍTICO PRIMARIO DE PULMÓN IZQUIERDO"
  },
  {
    "codigo":267257007,
    "descripcion":"TRABAJO DE PARTO Y PARTO COMPLICADOS POR ANOMALÍA EN LA FRECUENCIA CARDÍACA FETAL"
  },
  {
    "codigo":398329009,
    "descripcion":"ENCEFALITIS POR VIH"
  },
  {
    "codigo":724174003,
    "descripcion":"SÍNDROME DE MOEBIUS, NEUROPATÍA AXONAL E HIPOGONADISMO HIPOGONADOTRÓFICO"
  },
  {
    "codigo":10957081000119109,
    "descripcion":"HERIDA ABIERTA DE DEDO ANULAR DE MANO IZQUIERDA DEBIDA A MORDEDURA HUMANA"
  },
  {
    "codigo":298190007,
    "descripcion":"HIPERMOVILIDAD DE ARTICULACIÓN DE MUÑECA"
  },
  {
    "codigo":36046008,
    "descripcion":"ABSCESO ISQUIORRECTAL"
  },
  {
    "codigo":296355001,
    "descripcion":"SOBREDOSIS DE FÁRMACOS BLOQUEANTES DE LOS CANALES DEL CALCIO"
  },
  {
    "codigo":165283002,
    "descripcion":"MEMORIA: NO TIENE CONSCIENCIA DEL MOMENTO ACTUAL"
  },
  {
    "codigo":394659003,
    "descripcion":"SÍNDROME CORONARIO AGUDO"
  },
  {
    "codigo":68814008,
    "descripcion":"INTOXICACIÓN POR SALSOLA TUBERCULATIFORMIS"
  },
  {
    "codigo":294520002,
    "descripcion":"ALERGIA A PIVMECILINAM"
  },
  {
    "codigo":720504004,
    "descripcion":"INADECUADO PARA EL PROGRAMA EDUCACIÓN SOBRE DIABETES Y AUTOGESTIÓN PARA ENFERMEDAD EN CURSO Y RECIENTEMENTE DIAGNOSTICADA"
  },
  {
    "codigo":65144005,
    "descripcion":"MENINGOCELE ESPINAL CONGÉNITO"
  },
  {
    "codigo":786040006,
    "descripcion":"PROLAPSO DE VALVA POSTERIOR DE VÁLVULA MITRAL"
  },
  {
    "codigo":63309002,
    "descripcion":"TUBERCULOSIS PRIMARIA"
  },
  {
    "codigo":16910771000119107,
    "descripcion":"NEVO MELANOCÍTICO CONGÉNITO DE PIEL DE PÁRPADO SUPERIOR DERECHO"
  },
  {
    "codigo":390989002,
    "descripcion":"PATRÓN DE SANGRADO EN TERAPIA DE REEMPLAZO HORMONAL, ANORMAL"
  },
  {
    "codigo":292685004,
    "descripcion":"REACCIÓN ADVERSA AL MIVACURIO"
  },
  {
    "codigo":423757006,
    "descripcion":"BALANCEO INVOLUNTARIO DEL TRONCO"
  },
  {
    "codigo":1208354001,
    "descripcion":"ALERGIA A ERTUGLIFLOZINA"
  },
  {
    "codigo":61474001,
    "descripcion":"LESIÓN TRAUMÁTICA DE RIÑÓN CON HERIDA ABIERTA HACIA CAVIDAD ABDOMINAL"
  },
  {
    "codigo":94242004,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA COLA DE CABALLO"
  },
  {
    "codigo":290850008,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR PROTRIPTILINA"
  },
  {
    "codigo":92407004,
    "descripcion":"NEOPLASIA BENIGNA DE LA COLUMNA VERTEBRAL"
  },
  {
    "codigo":714999004,
    "descripcion":"CAPAZ DE MOVILIZARSE EN EL HOGAR"
  },
  {
    "codigo":289015007,
    "descripcion":"NO COLOCA ALIMENTO EN LA BOCA"
  },
  {
    "codigo":418252000,
    "descripcion":"CÓRNEA CON PARCHES COLOR SALMÓN"
  },
  {
    "codigo":1335756000,
    "descripcion":"TRASTORNO DE LIGAMENTO DE ARTICULACIÓN DE CADERA"
  },
  {
    "codigo":59639009,
    "descripcion":"FRACTURA NO EXPUESTA DE EXTREMO PROXIMAL DE PERONÉ"
  },
  {
    "codigo":254412006,
    "descripcion":"NEOPLASIA MALIGNA DE PUNTA DE LENGUA"
  },
  {
    "codigo":711329002,
    "descripcion":"PAPILOMA"
  },
  {
    "codigo":416417002,
    "descripcion":"RASGO DE HEMOGLOBINA S HEREDITARIO"
  },
  {
    "codigo":449185003,
    "descripcion":"DILATACIÓN DE UNIÓN SENOTUBULAR AÓRTICA"
  },
  {
    "codigo":187041005,
    "descripcion":"ENDOCARDITIS POR HISTOPLASMA CAPSULATUM"
  },
  {
    "codigo":21366000,
    "descripcion":"IMPACTO DE PARTES BLANDAS SOBRE LOS DIENTES"
  },
  {
    "codigo":12106471000119102,
    "descripcion":"QUEMADURA DE ANTEBRAZO IZQUIERDO"
  },
  {
    "codigo":86902002,
    "descripcion":"DISPERSIÓN"
  },
  {
    "codigo":283510002,
    "descripcion":"HERIDA PUNZANTE DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":1073741000119109,
    "descripcion":"ARTRITIS REUMATOIDE DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":447350003,
    "descripcion":"LACERACIÓN DE CEJA"
  },
  {
    "codigo":285345008,
    "descripcion":"LACERACIONES MÚLTIPLES"
  },
  {
    "codigo":412747004,
    "descripcion":"ESTUDIO CARDÍACO CON RADIONÚCLIDOS ANORMAL"
  },
  {
    "codigo":183371006,
    "descripcion":"CONVALECENCIA DE ENFERMEDAD CLÍNICA"
  },
  {
    "codigo":871499007,
    "descripcion":"REACCIÓN ADVERSA A ÁCIDO FÓLICO Y\/O HIERRO"
  },
  {
    "codigo":1197344000,
    "descripcion":"LINFOMA DE LINFOCITOS T DE INTESTINO DELGADO"
  },
  {
    "codigo":247072007,
    "descripcion":"CÁPSULA DEL CRISTALINO EN SEUDOFAQUIA - HALLAZGO"
  },
  {
    "codigo":312608009,
    "descripcion":"LACERACIÓN - LESIÓN TRAUMÁTICA"
  },
  {
    "codigo":212469007,
    "descripcion":"LESIÓN DE MÚLTIPLES MÚSCULOS Y TENDONES A NIVEL DE CADERA Y MUSLO"
  },
  {
    "codigo":441845009,
    "descripcion":"MASA SUPERFICIAL"
  },
  {
    "codigo":46794001,
    "descripcion":"BAMBOLEO OCULAR"
  },
  {
    "codigo":472778003,
    "descripcion":"QUISTE EXTRAPERICÁRDICO CONGÉNITO"
  },
  {
    "codigo":210634006,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE PULPEJO DE DEDO DE MANO, TIPO 3 (PÉRDIDA PARCIAL DE FALANGE TERMINAL, CON LA CORRESPONDIENTE PÉRDIDA DE PULPEJO Y UÑA, SIN PÉRDIDA DE LÁNULA)"
  },
  {
    "codigo":307103001,
    "descripcion":"TIENE PADRE ADOLESCENTE"
  },
  {
    "codigo":208799003,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN DE CODO, DIVERGENTE"
  },
  {
    "codigo":733087007,
    "descripcion":"SÍNDROME DE POLIDACTILIA Y MIOPÍA"
  },
  {
    "codigo":239732001,
    "descripcion":"TRASTORNO DE LA ARTICULACIÓN ROTULOFEMORAL"
  },
  {
    "codigo":403572002,
    "descripcion":"CALCIFICACIÓN METASTÁSICA HIPERCALCÉMICA DE LA PIEL"
  },
  {
    "codigo":11998081000119107,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DE PULGAR DERECHO"
  },
  {
    "codigo":205129003,
    "descripcion":"POLIDACTILIA RADIAL DE WASSEL 7"
  },
  {
    "codigo":301598000,
    "descripcion":"DIFICULTAD PARA SUBIR Y BAJAR ESCALERAS EN CUATRO PATAS"
  },
  {
    "codigo":237897009,
    "descripcion":"CALCIFICACIÓN VASCULAR"
  },
  {
    "codigo":399902003,
    "descripcion":"TRASTORNO DE CAVIDAD CORPORAL"
  },
  {
    "codigo":268830003,
    "descripcion":"ASFIXIA AL NACER LEVE A MODERADA - PUNTAJE DE APGAR 4-7 EN EL PRIMER MINUTO"
  },
  {
    "codigo":6686005,
    "descripcion":"EXPECTORACIÓN DE ESPUTO CON VESTIGIOS DE SANGRE"
  },
  {
    "codigo":72222004,
    "descripcion":"CISTITIS PAPILAR"
  },
  {
    "codigo":203294006,
    "descripcion":"OSTEOPATÍA COMO CONSECUENCIA DE POLIOMIELITIS, DE MÚLTIPLES LOCALIZACIONES"
  },
  {
    "codigo":234227003,
    "descripcion":"DIÁLOGO CRUZADO EN MARCAPASOS DE CÁMARA DUAL"
  },
  {
    "codigo":299763004,
    "descripcion":"REFLEJO DE ENDEREZAMIENTO Y MARCHA: AUSENTE"
  },
  {
    "codigo":398067003,
    "descripcion":"ENFERMEDAD DE WEIL"
  },
  {
    "codigo":365299006,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA ENCENDER UN ARTEFACTO DOMÉSTICO"
  },
  {
    "codigo":4851007,
    "descripcion":"ENDOCARDITIS CRÓNICA"
  },
  {
    "codigo":396232000,
    "descripcion":"HERNIA INGUINAL"
  },
  {
    "codigo":37619006,
    "descripcion":"FRACTURAS MÚLTIPLES EXPUESTAS DE LA EXTREMIDAD INFERIOR Y LAS COSTILLAS"
  },
  {
    "codigo":723912004,
    "descripcion":"TRASTORNO DEL ESTADO DE ÁNIMO SECUNDARIO"
  },
  {
    "codigo":1076251000119106,
    "descripcion":"BURSITIS DE PATA DE GANSO DE RODILLA IZQUIERDA"
  },
  {
    "codigo":363464006,
    "descripcion":"NEOPLASIA MALIGNA DE CÓRNEA"
  },
  {
    "codigo":230557001,
    "descripcion":"DISAUTONOMÍA HEREDITARIA CON NEUROPATÍA MOTRIZ"
  },
  {
    "codigo":722077007,
    "descripcion":"NECROSIS PAPILAR RENAL CAUSADA POR FÁRMACO ANALGÉSICO"
  },
  {
    "codigo":165021009,
    "descripcion":"FUNCIÓN PULMONAR SIGNIFICATIVAMENTE OBSTRUIDA"
  },
  {
    "codigo":294258004,
    "descripcion":"ALERGIA A CARBOPROST"
  },
  {
    "codigo":15959221000119103,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE AMBAS PELVIS RENALES"
  },
  {
    "codigo":392562007,
    "descripcion":"CON MAYOR RIESGO DE MUERTE SÚBITA DEL LACTANTE"
  },
  {
    "codigo":95815000,
    "descripcion":"VÉRTIGO POSICIONAL CENTRAL"
  },
  {
    "codigo":1144391002,
    "descripcion":"HIPOPLASIA CONGÉNITA DE MÚSCULO BÍCEPS BRAQUIAL"
  },
  {
    "codigo":194119004,
    "descripcion":"PARÁLISIS TOTAL DE NERVIO OCULOMOTOR"
  },
  {
    "codigo":718407008,
    "descripcion":"NO SE OBSERVA SARCOPTES SCABIEI"
  },
  {
    "codigo":93980002,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA UNIÓN RECTOSIGMOIDEA"
  },
  {
    "codigo":421660003,
    "descripcion":"FALTA DE PROGRESO ASOCIADO CON SIDA EN EL LACTANTE"
  },
  {
    "codigo":290588004,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR TREOSULFANO"
  },
  {
    "codigo":126748005,
    "descripcion":"NEOPLASIA DE VASO SANGUÍNEO DE LA CADERA"
  },
  {
    "codigo":61212007,
    "descripcion":"TRASTORNO DE PÁNICO CON AGORAFOBIA, EVITACIÓN AGORAFÓBICA GRAVE Y ATAQUES DE PÁNICO GRAVES"
  },
  {
    "codigo":26609002,
    "descripcion":"AMIOTROFIA NEURÁLGICA"
  },
  {
    "codigo":288753003,
    "descripcion":"NO COMUNICA NADA SOBRE SÍ MISMO"
  },
  {
    "codigo":92145008,
    "descripcion":"NEOPLASIA BENIGNA DE LA REGIÓN INGUINAL"
  },
  {
    "codigo":419825008,
    "descripcion":"MOVIMIENTO OCULAR HACIA LA IZQUIERDA LIMITADO"
  },
  {
    "codigo":90310002,
    "descripcion":"DEFICIENCIA DE LOS MOVIMIENTOS SACÁDICOS DEL OJO"
  },
  {
    "codigo":1237190002,
    "descripcion":"TRASTORNO FETAL DEBIDO A PLACENTITIS"
  },
  {
    "codigo":40271000119102,
    "descripcion":"HEMORRAGIA DE INTESTINO DELGADO DEBIDA A DIVERTICULOSIS"
  },
  {
    "codigo":11836751000119102,
    "descripcion":"SUBLUXACIÓN DE ARTICULACIÓN INTERTARSIANA DE PIE DERECHO"
  },
  {
    "codigo":286918006,
    "descripcion":"FALLA GONADAL POSABLATIVA"
  },
  {
    "codigo":254150007,
    "descripcion":"SÍNDROME DE FRANCOIS"
  },
  {
    "codigo":11842171000119105,
    "descripcion":"LACERACIÓN DE TENDÓN DEL PIE IZQUIERDO"
  },
  {
    "codigo":448923002,
    "descripcion":"HIPOPLASIA DE TABIQUE INFUNDIBULAR"
  },
  {
    "codigo":286031000119106,
    "descripcion":"PROLAPSO DE VÁLVULA MITRAL REUMÁTICA"
  },
  {
    "codigo":283248006,
    "descripcion":"VIDRIO EN EL ANTEBRAZO"
  },
  {
    "codigo":840304005,
    "descripcion":"HIPERTROFIA MODERADA DE VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":445253000,
    "descripcion":"SÍNDROME DE INTERSECCIÓN"
  },
  {
    "codigo":1297221001,
    "descripcion":"QUEMADURA DE PÁRPADO SUPERIOR"
  },
  {
    "codigo":84805004,
    "descripcion":"DIETA BLANDA DENTAL"
  },
  {
    "codigo":1231685006,
    "descripcion":"MIOPATÍA EXTRAOCULAR VASCULAR"
  },
  {
    "codigo":609093008,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: DARI"
  },
  {
    "codigo":707397008,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE OROFARINGE, DE CÉLULAS BASALES"
  },
  {
    "codigo":280221000009107,
    "descripcion":"OTITIS EXTERNA BACTERIANA"
  },
  {
    "codigo":246810004,
    "descripcion":"PÉRDIDA DEL PLIEGUE SEMILUNAR"
  },
  {
    "codigo":16833871000119109,
    "descripcion":"OBSTRUCCIÓN PARCIAL DE COLON"
  },
  {
    "codigo":50202006,
    "descripcion":"ALTERACIÓN EN EL ESTILO DE VIDA"
  },
  {
    "codigo":16561641000119105,
    "descripcion":"LUXACIÓN CERRADA DE ARTICULACIÓN TEMPOROMANDIBULAR IZQUIERDA"
  },
  {
    "codigo":212207009,
    "descripcion":"LESIÓN DE LA RAÍZ DEL NERVIO DORSAL - D2"
  },
  {
    "codigo":112068005,
    "descripcion":"GASTROMENIA"
  },
  {
    "codigo":700057001,
    "descripcion":"SÍNDROME DE EMBERGER"
  },
  {
    "codigo":44697002,
    "descripcion":"MELORREOSTOSIS"
  },
  {
    "codigo":341481000119107,
    "descripcion":"CATARATA POLAR SUBCAPSULAR ANTERIOR CONGÉNITA DE OJO IZQUIERDO"
  },
  {
    "codigo":863897005,
    "descripcion":"INTENTO FALLIDO DE INTERRUPCIÓN DEL EMBARAZO COMPLICADO POR NECROSIS HEPÁTICA AGUDA"
  },
  {
    "codigo":15742441000119108,
    "descripcion":"APOFISITIS DE EPITRÓCLEA DE CODO IZQUIERDO DEBIDA A USO EXCESIVO"
  },
  {
    "codigo":110233008,
    "descripcion":"QUEMADURA DE TERCER GRADO DE LA REGIÓN AMIGDALINA"
  },
  {
    "codigo":403310003,
    "descripcion":"ATROFIA UNGUEAL IDIOPÁTICA DE LA INFANCIA"
  },
  {
    "codigo":1255278004,
    "descripcion":"SÍNDROME DE MIOPATÍA MIOTUBULAR, ANOMALÍAS GENITALES LIGADO AL CROMOSOMA X"
  },
  {
    "codigo":75630004,
    "descripcion":"ALTERACIÓN DE ARTICULACIÓN TEMPOROMANDIBULAR"
  },
  {
    "codigo":1288046009,
    "descripcion":"TUMOR DE CÉLULAS ENTEROCROMAFINES"
  },
  {
    "codigo":237635002,
    "descripcion":"HIPOGLUCEMIA NOCTURNA DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":73795002,
    "descripcion":"INFARTO AGUDO DE MIOCARDIO DE PARED INFERIOR"
  },
  {
    "codigo":204867009,
    "descripcion":"AGENESIA DE VULVA"
  },
  {
    "codigo":792856002,
    "descripcion":"TRASTORNO DE REPETICIÓN DE TRINUCLEÓTIDOS"
  },
  {
    "codigo":301336003,
    "descripcion":"PROBLEMA DE PESO CORPORAL"
  },
  {
    "codigo":235800002,
    "descripcion":"RUPTURA DE COLON"
  },
  {
    "codigo":365037001,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA ESTABLECER LA COMUNICACIÓN"
  },
  {
    "codigo":102893002,
    "descripcion":"EXCITABILIDAD"
  },
  {
    "codigo":299501002,
    "descripcion":"AMPLITUD DE SUPINACIÓN ACTIVA MEDIOTARSIANA DISMINUIDA"
  },
  {
    "codigo":10692381000119102,
    "descripcion":"TUMORACIÓN DE LA PIEL DEL PULGAR DERECHO"
  },
  {
    "codigo":233965009,
    "descripcion":"ESTENOSIS DE LA AORTA TORÁCICA"
  },
  {
    "codigo":35522004,
    "descripcion":"TIMPANOESCLEROSIS QUE COMPROMETE SÓLO A LA MEMBRANA TIMPÁNICA"
  },
  {
    "codigo":363202005,
    "descripcion":"TRASTORNOS MENDELIANOS"
  },
  {
    "codigo":164759004,
    "descripcion":"TIMPANOGRAMA ANORMAL"
  },
  {
    "codigo":230295005,
    "descripcion":"PARQUINSONISMO CON CALCIFICACIÓN DE GANGLIOS BASALES"
  },
  {
    "codigo":33687004,
    "descripcion":"GASTROENTERITIS DIETÉTICA"
  },
  {
    "codigo":721815007,
    "descripcion":"ENCEFALITIS CAUSADA POR TRYPANOSOMA BRUCEI"
  },
  {
    "codigo":392300000,
    "descripcion":"GLAUCOMA FACOMÓRFICO POR CIERRE DE ÁNGULO DEBIDO A TRASTORNO DE CRISTALINO"
  },
  {
    "codigo":263063009,
    "descripcion":"FRACTURA-LUXACIÓN ARTICULAR"
  },
  {
    "codigo":293996002,
    "descripcion":"ALERGIA A NIFEDIPINO"
  },
  {
    "codigo":228460004,
    "descripcion":"MÚLTIPLES PAREJAS SEXUALES ACTUALES"
  },
  {
    "codigo":359532006,
    "descripcion":"SÍNDROME DE PELLIZCAMIENTO DEL MANGUITO ROTADOR"
  },
  {
    "codigo":719980006,
    "descripcion":"ENFERMEDAD DE CHARCOT-MARIE-TOOTH, TIPO IF"
  },
  {
    "codigo":128321003,
    "descripcion":"TRASTORNO VASCULAR DEL INTESTINO"
  },
  {
    "codigo":126486000,
    "descripcion":"ERITEMA DE MEMBRANA MUCOSA"
  },
  {
    "codigo":290326004,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR MEDIO DE CONTRASTE RADIOGRÁFICO"
  },
  {
    "codigo":60950004,
    "descripcion":"EFECTO TÓXICO DE PESTICIDA DERIVADO DE HIDROCARBURO CLORADO"
  },
  {
    "codigo":1142294009,
    "descripcion":"CEJA ANCHA"
  },
  {
    "codigo":91883008,
    "descripcion":"AUSENCIA CONGÉNITA DE HUESO EXOCCIPITAL"
  },
  {
    "codigo":1204160001,
    "descripcion":"ESTENOSIS ASINTOMÁTICA DE ARTERIA VERTEBRAL EXTRACRANEAL"
  },
  {
    "codigo":712640001,
    "descripcion":"DEFICIENCIA DE FOSFOMANOMUTASA 2"
  },
  {
    "codigo":253888002,
    "descripcion":"URÉTER TRIPLE"
  },
  {
    "codigo":448661001,
    "descripcion":"DOLOR A LA PALPACIÓN DE CUADRANTE INFERIOR DERECHO DEL ABDOMEN"
  },
  {
    "codigo":88213004,
    "descripcion":"HIPERALDOSTERONISMO"
  },
  {
    "codigo":282986002,
    "descripcion":"INCAPAZ DE VOLTEAR"
  },
  {
    "codigo":1003882002,
    "descripcion":"DUPLICACIÓN DE PORCIÓN PROXIMAL DEL BRAZO LARGO DEL CROMOSOMA 11"
  },
  {
    "codigo":11786321000119103,
    "descripcion":"AMPOLLA DE DEDO ÍNDICE DE MANO IZQUIERDA, CON INFECCIÓN"
  },
  {
    "codigo":86378006,
    "descripcion":"DESGARRO ANTIGUO EN ASA DE BALDE DEL MENISCO INTERNO"
  },
  {
    "codigo":20842008,
    "descripcion":"LUXACIÓN DEL GLOBO OCULAR"
  },
  {
    "codigo":608831003,
    "descripcion":"DOLOR DISCOGÉNICO DORSAL"
  },
  {
    "codigo":1264191003,
    "descripcion":"PIGMENTACIÓN LOCAL EXÓGENA DE REGIÓN SUPERIOR DE MUCOSA YUGAL IZQUIERDA"
  },
  {
    "codigo":444991004,
    "descripcion":"MICROCALCIFICACIONES DIFUSAS DE MAMA"
  },
  {
    "codigo":1296959007,
    "descripcion":"DEFICIENCIA HEREDITARIA DE BUTIRILCOLINESTERASA"
  },
  {
    "codigo":707135008,
    "descripcion":"PROCTITIS QUÍSTICA PROFUNDA"
  },
  {
    "codigo":1196820001,
    "descripcion":"LIPOMA DE ÓRBITA"
  },
  {
    "codigo":1231423008,
    "descripcion":"HIPOPLASIA DE HIPOTÁLAMO"
  },
  {
    "codigo":738068003,
    "descripcion":"ALIVIO DEL DOLOR MEDIANTE DESCENSO DE PIERNA"
  },
  {
    "codigo":82708005,
    "descripcion":"DEFENSA ABDOMINAL VOLUNTARIA"
  },
  {
    "codigo":312084009,
    "descripcion":"SURCO GINGIVAL DE STILLMAN"
  },
  {
    "codigo":277481003,
    "descripcion":"HIPERCALCEMIA IDIOPÁTICA SEVERA DE LA LACTANCIA"
  },
  {
    "codigo":310249008,
    "descripcion":"EVALUACIÓN ORTOPÉDICA DE SEGUIMIENTO"
  },
  {
    "codigo":111806005,
    "descripcion":"PROSTATITIS GONOCÓCICA AGUDA"
  },
  {
    "codigo":372115003,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE HUESOS PÉLVICOS, SACRO Y CÓCCIX"
  },
  {
    "codigo":765331004,
    "descripcion":"ENFERMEDAD RENAL POLIQUÍSTICA AUTOSÓMICA DOMINANTE TIPO 1 CON ESCLEROSIS TUBEROSA"
  },
  {
    "codigo":109971005,
    "descripcion":"LINFOMA NO HODGKIN FOLICULAR, DE CÉLULAS HENDIDAS PEQUEÑAS Y DE CÉLULAS GRANDES"
  },
  {
    "codigo":50661000087103,
    "descripcion":"DOLOR MUSCULOESQUELÉTICO CRÓNICO DEBIDO A TRASTORNO ARTICULAR"
  },
  {
    "codigo":42981000087103,
    "descripcion":"QUEMADURA DE DEDO MEDIO DERECHO"
  },
  {
    "codigo":48101000087105,
    "descripcion":"PSEUDOMEMBRANA EN INTESTINO GRUESO"
  },
  {
    "codigo":403048002,
    "descripcion":"TIÑA DE LA MANO CAUSADA POR TRICHOPHYTON MENTAGROPHYTES VARIANTE INTERDIGITALE"
  },
  {
    "codigo":1255016003,
    "descripcion":"DEPENDENCIA COMBINADA EPISÓDICA DE SUSTANCIAS EXCEPTO OPIOIDES"
  },
  {
    "codigo":40421000087109,
    "descripcion":"CUERPO EXTRAÑO EN OÍDO EXTERNO IZQUIERDO"
  },
  {
    "codigo":239208007,
    "descripcion":"FALLA DE ANASTOMOSIS DE COLGAJO"
  },
  {
    "codigo":697960007,
    "descripcion":"MACRODONCIA GENERALIZADA RELATIVA"
  },
  {
    "codigo":271976009,
    "descripcion":"TRASTORNO DE INJERTO DE HUESO"
  },
  {
    "codigo":302909007,
    "descripcion":"ENFERMEDAD CEREBROVASCULAR DIFUSA"
  },
  {
    "codigo":1251346000,
    "descripcion":"FALLO DE INJERTO DE PIEL DE ESPESOR COMPLETO"
  },
  {
    "codigo":170002000,
    "descripcion":"INCORPORACIÓN DE SÓLIDOS AL AÑO"
  },
  {
    "codigo":202770004,
    "descripcion":"PANICULITIS DEL CUELLO"
  },
  {
    "codigo":366610005,
    "descripcion":"PRUEBA DE APREHENSIÓN - HALLAZGO"
  },
  {
    "codigo":11815301000119103,
    "descripcion":"RUPTURA TRAUMÁTICA DE LIGAMENTO COLATERAL DE ARTICULACIÓN DE DEDO MEDIO DE MANO DERECHA"
  },
  {
    "codigo":397543001,
    "descripcion":"ALTERACIÓN VISUAL LEVE"
  },
  {
    "codigo":364775004,
    "descripcion":"ALIMENTACIÓN DEL LACTANTE A LOS 9 MESES - HALLAZGO"
  },
  {
    "codigo":102631004,
    "descripcion":"DOLOR PANCREÁTICO"
  },
  {
    "codigo":266471006,
    "descripcion":"CIRROSIS PORTAL JUVENIL"
  },
  {
    "codigo":233703007,
    "descripcion":"ENFERMEDAD PULMONAR INTERSTICIAL"
  },
  {
    "codigo":1149372004,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE SULFAMETOXAZOL Y\/O TRIMETOPRIMA"
  },
  {
    "codigo":788924004,
    "descripcion":"MUTILACIÓN DE GENITALES FEMENINOS TIPO 2A"
  },
  {
    "codigo":2492009,
    "descripcion":"TRASTORNO DE LA NUTRICIÓN"
  },
  {
    "codigo":1070151000000105,
    "descripcion":"DIFICULTAD PARA LEVANTARSE DE CAMA SIN ASISTENCIA"
  },
  {
    "codigo":262801003,
    "descripcion":"RUPTURA TARDÍA DEL HÍGADO"
  },
  {
    "codigo":182661000119107,
    "descripcion":"ESTRECHEZ DE CUELLO DE VEJIGA URINARIA"
  },
  {
    "codigo":721553008,
    "descripcion":"AUSENCIA ADQUIRIDA DE ÓRGANO GENITAL FEMENINO"
  },
  {
    "codigo":129894004,
    "descripcion":"FOTOPTARMOSIS"
  },
  {
    "codigo":291899000,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR CUMARINA"
  },
  {
    "codigo":424806009,
    "descripcion":"INTENSIDAD DEL DOLOR INFORMADA DENTRO DE LÍMITES ACEPTABLES"
  },
  {
    "codigo":422971002,
    "descripcion":"INDUCCIÓN DE ENZIMA DE CITOCROMO P450 CYP3A POR SUSTANCIA"
  },
  {
    "codigo":95291003,
    "descripcion":"CENTRO SUPERNUMERARIO DE VÉRTEBRA SACRA"
  },
  {
    "codigo":128059004,
    "descripcion":"DERIVACIÓN VASCULAR PORTOSISTÉMICA PARCIAL"
  },
  {
    "codigo":717883004,
    "descripcion":"PÓLIPO DUODENAL HIPERPLÁSICO"
  },
  {
    "codigo":783419007,
    "descripcion":"ANEURISMA DE ARTERIA CEREBRAL POSTERIOR"
  },
  {
    "codigo":29755007,
    "descripcion":"ÚLCERA DUODENAL CON AUMENTO DEL PEPSINÓGENO I SÉRICO"
  },
  {
    "codigo":1142032003,
    "descripcion":"MASTITIS NEONATAL POR ESTAFILOCOCO"
  },
  {
    "codigo":290064007,
    "descripcion":"MAMAS SIMÉTRICAS"
  },
  {
    "codigo":1269434002,
    "descripcion":"TRASTORNO FETAL INTRAPARTO"
  },
  {
    "codigo":286394002,
    "descripcion":"INCAPAZ DE UTILIZAR ADECUADAMENTE EL LENGUAJE"
  },
  {
    "codigo":384698005,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA AFECTADO POR NEOPLASIA MALIGNA, EXTENSO"
  },
  {
    "codigo":188090007,
    "descripcion":"NEOPLASIA MALIGNA DE PIEL DEL PABELLÓN AURICULAR"
  },
  {
    "codigo":415631003,
    "descripcion":"CONTROL DE ACCIDENTE CEREBROVASCULAR\/ATAQUE ISQUÉMICO TRANSITORIO, TERCERA CARTA"
  },
  {
    "codigo":20580001,
    "descripcion":"LESIÓN TRAUMÁTICA DE BRONQUIO CON HERIDA ABIERTA HACIA CAVIDAD TORÁCICA"
  },
  {
    "codigo":1234831009,
    "descripcion":"SÍNDROME DE MIELODISPLASIA, INFECCIÓN, RESTRICCIÓN DEL CRECIMIENTO, HIPOPLASIA SUPRARRENAL, ANOMALÍAS GENITALES Y ENTEROPATÍA"
  },
  {
    "codigo":315492002,
    "descripcion":"NACIDO EN COREA DEL NORTE"
  },
  {
    "codigo":1003620005,
    "descripcion":"CLINODACTILIA CONGÉNITA DE DEDO DE MANO"
  },
  {
    "codigo":129721000119106,
    "descripcion":"INSUFICIENCIA RENAL AGUDA EN DIÁLISIS"
  },
  {
    "codigo":295816002,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE LEVODOPA"
  },
  {
    "codigo":1263929000,
    "descripcion":"SHOCK SÉPTICO POSTERIOR A EMBARAZO ECTÓPICO"
  },
  {
    "codigo":282724009,
    "descripcion":"HEMATOMA DE BRONQUIO"
  },
  {
    "codigo":18745002,
    "descripcion":"DESCENSO FETAL"
  },
  {
    "codigo":706873003,
    "descripcion":"SUFRIMIENTO"
  },
  {
    "codigo":248121003,
    "descripcion":"COME ENTRE COMIDAS"
  },
  {
    "codigo":1231161002,
    "descripcion":"DEPENDENCIA DE ANSIOLÍTICO, EPISÓDICA"
  },
  {
    "codigo":11817811000119101,
    "descripcion":"ESGUINCE DE LIGAMENTO DE DEDO ANULAR DERECHO"
  },
  {
    "codigo":49678000,
    "descripcion":"HERNIA INGUINAL OBSTRUIDA CON GANGRENA"
  },
  {
    "codigo":279054001,
    "descripcion":"DOLOR CON LA BAJADA DE LA LECHE"
  },
  {
    "codigo":311822009,
    "descripcion":"FRACTURA EXPUESTA DEL DEDO GORDO"
  },
  {
    "codigo":277219008,
    "descripcion":"GIBA NASAL"
  },
  {
    "codigo":431421000124103,
    "descripcion":"ARTERIOSCLEROSIS DE ARTERIA CARÓTIDA"
  },
  {
    "codigo":433981000124105,
    "descripcion":"INSERCIÓN ALTA DE FRENILLO LABIAL"
  },
  {
    "codigo":111544009,
    "descripcion":"DISFUNCIÓN ENDOCRINA COMBINADA"
  },
  {
    "codigo":699533003,
    "descripcion":"LESIÓN TRAUMÁTICA POR CIZALLAMIENTO"
  },
  {
    "codigo":109709002,
    "descripcion":"PÉRDIDA HORIZONTAL DE HUESO ALVEOLAR"
  },
  {
    "codigo":44173007,
    "descripcion":"INTOXICACIÓN POR DICENTRA SPECTABILIS"
  },
  {
    "codigo":76941008,
    "descripcion":"INTOXICACIÓN CAUSADA POR CARBENICILINA"
  },
  {
    "codigo":240781009,
    "descripcion":"MUCORMICOSIS DISEMINADA"
  },
  {
    "codigo":42338000,
    "descripcion":"GASTROENTERITIS POR SALMONELLA"
  },
  {
    "codigo":238946004,
    "descripcion":"MUCINOSIS ERITEMATOSA RETICULAR"
  },
  {
    "codigo":1287522005,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE ANO"
  },
  {
    "codigo":1156450006,
    "descripcion":"SATISFECHO CON LA ATENCIÓN DE LA SALUD"
  },
  {
    "codigo":402786009,
    "descripcion":"SÍNDROME DE QUILOMICRONEMIA"
  },
  {
    "codigo":400951005,
    "descripcion":"CRIPTOFTALMOS"
  },
  {
    "codigo":237111006,
    "descripcion":"FUSIÓN ADQUIRIDA DE LABIOS VULVARES"
  },
  {
    "codigo":322541000119105,
    "descripcion":"SINOVITIS TRANSITORIA DE CADERA IZQUIERDA"
  },
  {
    "codigo":204343009,
    "descripcion":"HIPOPLASIA DE VÁLVULA PULMONAR"
  },
  {
    "codigo":300812000,
    "descripcion":"DIFICULTAD PARA REALIZAR TRABAJO VOLUNTARIO"
  },
  {
    "codigo":71436005,
    "descripcion":"SÍNDROME DEL LEUCOCITO PEREZOSO"
  },
  {
    "codigo":5900006,
    "descripcion":"MENINGITIS POR HAEMOPHILUS INFLUENZAE"
  },
  {
    "codigo":366348007,
    "descripcion":"HALLAZGO RELACIONADO CON LA SIMETRÍA MAMARIA"
  },
  {
    "codigo":298977004,
    "descripcion":"AMPLITUD DE ABDUCCIÓN PASIVA DE ARTICULACIÓN DE MUÑECA, AUMENTADA"
  },
  {
    "codigo":297142003,
    "descripcion":"TUMEFACCIÓN DEL PIE"
  },
  {
    "codigo":5361000122104,
    "descripcion":"ALERGIA A PROMESTRIENO"
  },
  {
    "codigo":262539000,
    "descripcion":"QUEMADURA SUPERFICIAL POR FRICCIÓN"
  },
  {
    "codigo":67766009,
    "descripcion":"ADHERENCIAS INTESTINALES CON OBSTRUCCIÓN"
  },
  {
    "codigo":295307005,
    "descripcion":"SOBREDOSIS DE TOLMETINA"
  },
  {
    "codigo":129632001,
    "descripcion":"SÍNDROME DE ADAPTACIÓN GENERAL"
  },
  {
    "codigo":721291009,
    "descripcion":"TRASTORNO DE RÓTULA"
  },
  {
    "codigo":719456001,
    "descripcion":"SÍNDROME DE FISURA DE LABIO Y PALADAR CON ROTACIÓN INTESTINAL ANÓMALA Y CARDIOPATÍA"
  },
  {
    "codigo":293472002,
    "descripcion":"REACCIÓN ADVERSA A LA ESPIRONOLACTONA"
  },
  {
    "codigo":162400007,
    "descripcion":"IRRITACIÓN DE FAUCES"
  },
  {
    "codigo":195168007,
    "descripcion":"HEMORRAGIA INTRACEREBRAL CON HEMORRAGIA INTRAVENTRICULAR"
  },
  {
    "codigo":226101001,
    "descripcion":"DIETA CON ALTO CONTENIDO DE GRASAS POLINSATURADAS"
  },
  {
    "codigo":291637002,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR CEFALORIDINA"
  },
  {
    "codigo":95029003,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL ÁREA RETROMOLAR"
  },
  {
    "codigo":224266002,
    "descripcion":"HOGAR BIEN PERSONALIZADO"
  },
  {
    "codigo":1141770006,
    "descripcion":"TEMBLOR DE MANO"
  },
  {
    "codigo":23841000119104,
    "descripcion":"URETEROCELE ORTOTÓPICO"
  },
  {
    "codigo":1172703004,
    "descripcion":"DISTROFIA MUSCULAR DE CINTURAS R21 ASOCIADA AL GEN POGLUT1"
  },
  {
    "codigo":124127004,
    "descripcion":"DEFICIENCIA DE ISOCITRATO DESHIDROGENASA (NAD^+^)"
  },
  {
    "codigo":419039007,
    "descripcion":"DISTROFIA GRANULAR DE CÓRNEA TIPO I"
  },
  {
    "codigo":253364005,
    "descripcion":"ANEURISMA DE LA VALVA DEL FORAMEN OVAL"
  },
  {
    "codigo":187828007,
    "descripcion":"NEOPLASIA MALIGNA DE LAS CAVIDADES NASALES, EL OÍDO MEDIO Y LOS SENOS PARANASALES"
  },
  {
    "codigo":286132007,
    "descripcion":"NO LIMPIA EL ÁREA DE PREPARACIÓN DE COMIDAS"
  },
  {
    "codigo":1300105004,
    "descripcion":"COMPLETÓ PROGRAMA DE EDUCACIÓN VOCACIONAL"
  },
  {
    "codigo":251529006,
    "descripcion":"SALVAS DE DESACELERACIÓN EN EL ELECTROMIOGRAMA"
  },
  {
    "codigo":679201000119108,
    "descripcion":"DEGENERACIÓN MARGINAL PELÚCIDA DE CÓRNEA DE AMBOS OJOS"
  },
  {
    "codigo":284297009,
    "descripcion":"NO REALIZA LA PRENSIÓN CON SUPINACIÓN DE LA MUÑECA"
  },
  {
    "codigo":1003358004,
    "descripcion":"DELECIÓN DISTAL DEL BRAZO CORTO DEL CROMOSOMA 8"
  },
  {
    "codigo":315230006,
    "descripcion":"MELANOMA IN SITU DEL DORSO"
  },
  {
    "codigo":319871000119100,
    "descripcion":"NÓDULO REUMATOIDE SUBCUTÁNEO DE MANO IZQUIERDA"
  },
  {
    "codigo":94591000119100,
    "descripcion":"NEOPLASIA DE PARTES BLANDAS DE MANO"
  },
  {
    "codigo":296831000119102,
    "descripcion":"HIPERTROFIA DE HÚMERO"
  },
  {
    "codigo":10631551000119103,
    "descripcion":"ABSCESO DE PIEL DE RODILLA DERECHA"
  },
  {
    "codigo":82184000,
    "descripcion":"SOPLO AÓRTICO"
  },
  {
    "codigo":122751000119105,
    "descripcion":"CEFALEA POSTRAUMÁTICA AGUDA"
  },
  {
    "codigo":99711000119104,
    "descripcion":"TRASTORNO ORGÁNICO DEL CICLO DE SUEÑO-VIGILIA"
  },
  {
    "codigo":10628991000119107,
    "descripcion":"LINFADENITIS AGUDA DE CABEZA"
  },
  {
    "codigo":15923071000119108,
    "descripcion":"CICATRIZACIÓN TARDÍA DE HERIDA POSTRAUMÁTICA"
  },
  {
    "codigo":12275071000119109,
    "descripcion":"EMBARAZO DE SIAMESES"
  },
  {
    "codigo":104831000119109,
    "descripcion":"APNEA DEL SUEÑO CENTRAL MEDICAMENTOSA"
  },
  {
    "codigo":11798911000119109,
    "descripcion":"LESIÓN TRAUMÁTICA DE ARTERIA ILÍACA IZQUIERDA"
  },
  {
    "codigo":1082751000119109,
    "descripcion":"ESÓFAGO DE BARRETT CON DISPLASIA"
  },
  {
    "codigo":345471000119107,
    "descripcion":"FÍSTULA DE AMBOS APARATOS LAGRIMALES"
  },
  {
    "codigo":12205951000119109,
    "descripcion":"CONTRACTURA CAPSULAR DE MAMA DERECHA"
  },
  {
    "codigo":678271000119108,
    "descripcion":"QUISTE DE IMPLANTACIÓN EN CÁMARA ANTERIOR DE OJO DERECHO"
  },
  {
    "codigo":291711000119109,
    "descripcion":"DÉFICIT COGNITIVO DEBIDO A HEMORRAGIA INTRACEREBRAL NO TRAUMÁTICA Y POSTERIOR A ELLA"
  },
  {
    "codigo":16376191000119109,
    "descripcion":"NEUROPATÍA ÓPTICA ISQUÉMICA ANTERIOR ARTERÍTICA DE AMBOS OJOS"
  },
  {
    "codigo":15999871000119109,
    "descripcion":"TRASTORNO OCULAR BILATERAL POSTERIOR A CIRUGÍA DE CATARATAS"
  },
  {
    "codigo":211421007,
    "descripcion":"PICADURA DE INSECTO, NO VENENOSO, DE DEDO DEL PIE"
  },
  {
    "codigo":78514002,
    "descripcion":"MERALGIA"
  },
  {
    "codigo":373426005,
    "descripcion":"DISTROFIA DE MEMBRANA BASAL EPITELIAL"
  },
  {
    "codigo":209586008,
    "descripcion":"DESGARRO COMPLETO DE LIGAMENTO RADIOCARPIANO PROXIMAL NO ESPECÍFICO"
  },
  {
    "codigo":240519004,
    "descripcion":"FIEBRE DE NÁPOLES TRANSMITIDA POR MOSQUITO SIMÚLIDO"
  },
  {
    "codigo":109447008,
    "descripcion":"HIPODONCIA FAMILIAR"
  },
  {
    "codigo":369756006,
    "descripcion":"CONFIGURACIÓN TUMORAL PAPILAR"
  },
  {
    "codigo":238684007,
    "descripcion":"ERITEMA FUGAZ"
  },
  {
    "codigo":40241000,
    "descripcion":"DESNATURALIZACIÓN"
  },
  {
    "codigo":402524007,
    "descripcion":"CARCINOMA BASOCELULAR TIPO ADAMANTINOIDE"
  },
  {
    "codigo":204081007,
    "descripcion":"HIPOPLASIA DE LA MÉDULA ESPINAL"
  },
  {
    "codigo":235014001,
    "descripcion":"CRESTA ALVEOLAR FLÁCIDA"
  },
  {
    "codigo":202246002,
    "descripcion":"LUXACIÓN RECURRENTE DE ARTICULACIÓN FEMORORROTULIANA"
  },
  {
    "codigo":300550004,
    "descripcion":"HALLAZGO RELACIONADO CON EL ORGASMO"
  },
  {
    "codigo":366086005,
    "descripcion":"POSICIÓN DEL REFLEJO FOTOMOTOR - HALLAZGO"
  },
  {
    "codigo":890374007,
    "descripcion":"TERATOMA BENIGNO DE CORDÓN UMBILICAL"
  },
  {
    "codigo":823003000,
    "descripcion":"GANGLIO LINFÁTICO FLUCTUANTE"
  },
  {
    "codigo":724699001,
    "descripcion":"TRASTORNO DEL SUEÑO CAUSADO POR NICOTINA"
  },
  {
    "codigo":167643003,
    "descripcion":"MATERIA FECAL: ENTEROLITOS PRESENTES"
  },
  {
    "codigo":69339004,
    "descripcion":"NEUMOPATÍA DE LOS AVICULTORES"
  },
  {
    "codigo":1091311000119104,
    "descripcion":"COLESTEATOMA DE MEMBRANA TIMPÁNICA DERECHA"
  },
  {
    "codigo":298715006,
    "descripcion":"MOVIMIENTO NORMAL DEL TÓRAX"
  },
  {
    "codigo":16000751000119105,
    "descripcion":"ESCLERITIS BILATERAL POR HERPES ZOSTER"
  },
  {
    "codigo":165808001,
    "descripcion":"HEPATITIS B, NO INMUNE"
  },
  {
    "codigo":34736002,
    "descripcion":"CONGESTIÓN PASIVA CRÓNICA DEL HÍGADO"
  },
  {
    "codigo":722864002,
    "descripcion":"INSUFICIENCIA HEPÁTICA AGUDA CAUSADA POR VIRUS DE HEPATITIS"
  },
  {
    "codigo":296880005,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE PROGESTÁGENO"
  },
  {
    "codigo":67504007,
    "descripcion":"DIENTES EN CÁSCARA"
  },
  {
    "codigo":1148848009,
    "descripcion":"EMBARAZO MÚLTIPLE POSTERIOR A FERTILIZACIÓN ASISTIDA"
  },
  {
    "codigo":1179781003,
    "descripcion":"CEREBRÓSIDO DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1343621005,
    "descripcion":"CATÉTER PLEURAL INTERNO IN SITU"
  },
  {
    "codigo":162138001,
    "descripcion":"DOLOR GENITOURINARIO"
  },
  {
    "codigo":31066003,
    "descripcion":"ÚLCERA DE LA VAGINA"
  },
  {
    "codigo":391514003,
    "descripcion":"ACTIVIDAD ANTIMICROBIANA"
  },
  {
    "codigo":194906004,
    "descripcion":"PERICARDITIS MENINGOCÓCICA AGUDA"
  },
  {
    "codigo":719194006,
    "descripcion":"PELO ARRANCADO FÁCILMENTE"
  },
  {
    "codigo":293210004,
    "descripcion":"REACCIÓN ADVERSA A LA PROGESTERONA"
  },
  {
    "codigo":225839002,
    "descripcion":"HALLAZGO RELACIONADO CON LA DEMOSTRACIÓN DE RESPETO"
  },
  {
    "codigo":94767002,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL ENCÉFALO"
  },
  {
    "codigo":193071004,
    "descripcion":"ADHERENCIAS DE MENINGES CEREBRALES"
  },
  {
    "codigo":27396000,
    "descripcion":"CLONO DE APERTURA CATÓDICO"
  },
  {
    "codigo":60164003,
    "descripcion":"ANEMIA MEGALOBLÁSTICA ASOCIADA A SÍNDROME DE ASA CIEGA"
  },
  {
    "codigo":715524004,
    "descripcion":"OSIFICACIÓN CRANEAL MEMBRANOSA TARDÍA"
  },
  {
    "codigo":92932005,
    "descripcion":"DEFORMACIÓN CONGÉNITA DE OVARIO"
  },
  {
    "codigo":58329000,
    "descripcion":"TRASTORNO ORGÁNICO DEL ESTADO DE ÁNIMO DE TIPO MANÍACO"
  },
  {
    "codigo":289540009,
    "descripcion":"SANGRADO VAGINAL PROFUSO"
  },
  {
    "codigo":189401003,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE PERITONEO"
  },
  {
    "codigo":285870002,
    "descripcion":"OPERA LAVARROPAS"
  },
  {
    "codigo":449710006,
    "descripcion":"CELULITIS DE MIEMBRO INFERIOR"
  },
  {
    "codigo":1268910009,
    "descripcion":"INCONTINENCIA DE ESFUERZO RECURRENTE"
  },
  {
    "codigo":710019006,
    "descripcion":"MOSAICISMO 45, X U OTRA LÍNEA CELULAR CON CROMOSOMA SEXUAL ANORMAL"
  },
  {
    "codigo":249432000,
    "descripcion":"CICATRIZ LARÍNGEA"
  },
  {
    "codigo":447875008,
    "descripcion":"MASA CONGÉNITA DE VALVA DE VÁLVULA MITRAL"
  },
  {
    "codigo":251267008,
    "descripcion":"PATRÓN SECUENCIAL DEL MARCAPASO AURICULOVENTRICULAR"
  },
  {
    "codigo":282200000,
    "descripcion":"NO BAJA ESCALERAS"
  },
  {
    "codigo":216664007,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR LACRES"
  },
  {
    "codigo":85592008,
    "descripcion":"DEGENERACIÓN CEREBELOSA PROGRESIVA PRIMARIA"
  },
  {
    "codigo":314968009,
    "descripcion":"RECIDIVA LOCAL DE NEOPLASIA MALIGNA DE VEJIGA"
  },
  {
    "codigo":52824009,
    "descripcion":"TRASTORNO DEL DESARROLLO DE LA LECTURA"
  },
  {
    "codigo":247597003,
    "descripcion":"OLVIDA LO QUE ACABA DE DECIR"
  },
  {
    "codigo":313133004,
    "descripcion":"HALLAZGO RELACIONADO CON LOS DEDOS DE LA MANO"
  },
  {
    "codigo":278530008,
    "descripcion":"ATRESIA DE CONDUCTO NASOLAGRIMAL"
  },
  {
    "codigo":309463003,
    "descripcion":"DEFORMIDAD EN FLEXIÓN DE LA MANO"
  },
  {
    "codigo":276695003,
    "descripcion":"NEUMONÍA NEONATAL POR ASPIRACIÓN"
  },
  {
    "codigo":1259735003,
    "descripcion":"FIBROHISTIOCITOMA PRIMARIO MALIGNO DE ÓRBITA"
  },
  {
    "codigo":735447008,
    "descripcion":"ANAFILAXIA CAUSADA POR VENENO DE INSECTO"
  },
  {
    "codigo":440535009,
    "descripcion":"CATÉTER VENOSO CENTRAL NO TUNELIZADO IN SITU"
  },
  {
    "codigo":45484000,
    "descripcion":"ABLÉFARON PARCIAL"
  },
  {
    "codigo":209324007,
    "descripcion":"FRACTURA-SUBLUXACIÓN NO EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA DEL PULGAR"
  },
  {
    "codigo":305793000,
    "descripcion":"ATENDIDO POR SERVICIO DE ONCOLOGÍA CLÍNICA"
  },
  {
    "codigo":404097000,
    "descripcion":"MILIO NEONATAL"
  },
  {
    "codigo":1256065002,
    "descripcion":"MASA DE TEJIDO CELULAR SUBCUTÁNEO DE MÚLTIPLES LOCALIZACIONES"
  },
  {
    "codigo":240257003,
    "descripcion":"DEFORMIDAD DE DEDO DEL PIE EN MARTILLO EN ADUCTOVARO"
  },
  {
    "codigo":830081005,
    "descripcion":"ALERGIA A BROMHEXINA"
  },
  {
    "codigo":369494005,
    "descripcion":"TUMOR MALIGNO QUE COMPROMETE EL CUERPO UTERINO POR PROPAGACIÓN DIRECTA DEL OVARIO"
  },
  {
    "codigo":41814009,
    "descripcion":"NEUTROPENIA CON DISGRANULOPOYESIS"
  },
  {
    "codigo":236587002,
    "descripcion":"GLOMERULOPATÍA DEL TRASPLANTE"
  },
  {
    "codigo":105515007,
    "descripcion":"DESAVENENCIA EN LA ESCUELA"
  },
  {
    "codigo":1186859008,
    "descripcion":"INFERTILIDAD MASCULINA AUTOINMUNE"
  },
  {
    "codigo":300288001,
    "descripcion":"HALLAZGO RELACIONADO CON LA FUNCIÓN ESOFÁGICA"
  },
  {
    "codigo":302123008,
    "descripcion":"HALLAZGO EN LA SATISFACCIÓN CON RESPECTO AL TRABAJO"
  },
  {
    "codigo":365824003,
    "descripcion":"QUÍMICA DEL LÍQUIDO AMNIÓTICO - HALLAZGO"
  },
  {
    "codigo":70912006,
    "descripcion":"MASTITIS SUBAGUDA"
  },
  {
    "codigo":890112007,
    "descripcion":"PATRÓN DE USO NOCIVO DE TABACO SIN DEPENDENCIA"
  },
  {
    "codigo":298453000,
    "descripcion":"AMPLITUD DE ROTACIÓN ACTIVA HACIA LA DERECHA DE LA COLUMNA CERVICAL DISMINUIDA"
  },
  {
    "codigo":10953201000119100,
    "descripcion":"HERIDA ABIERTA DE DEDO DE LA MANO IZQUIERDA DEBIDA A MORDEDURA DE GATO"
  },
  {
    "codigo":36309003,
    "descripcion":"ARTRITIS NEUMOCÓCICA"
  },
  {
    "codigo":724437007,
    "descripcion":"COMPRESIÓN DE TRÁQUEA Y ESÓFAGO CONCOMITANTE CON ANOMALÍA CONGÉNITA DEL CAYADO AÓRTICO Y DEBIDA A ELLA"
  },
  {
    "codigo":200149009,
    "descripcion":"PARTO POR CESÁREA DE URGENCIA"
  },
  {
    "codigo":67242002,
    "descripcion":"BAGASOSIS"
  },
  {
    "codigo":722602003,
    "descripcion":"LEUCOENCEFALOPATÍA TÓXICA"
  },
  {
    "codigo":165546001,
    "descripcion":"METAMIELOCITOS, PRESENTES"
  },
  {
    "codigo":296618007,
    "descripcion":"SOBREDOSIS DE CLARITROMICINA"
  },
  {
    "codigo":1279658008,
    "descripcion":"HERIDA PUNZANTE DE PÁRPADO SUPERIOR"
  },
  {
    "codigo":229247004,
    "descripcion":"MOVIMIENTOS EN ESPEJO"
  },
  {
    "codigo":196479004,
    "descripcion":"HIPERTROFIA DE GLÁNDULA SUBLINGUAL"
  },
  {
    "codigo":1343359008,
    "descripcion":"ACCESO DIGITAL INADECUADO DEBIDO A AUSENCIA DE DESEO DE INSTALAR EL SERVICIO"
  },
  {
    "codigo":718932002,
    "descripcion":"DISFUNCIÓN SOMÁTICA DE REGIÓN DE LA RODILLA"
  },
  {
    "codigo":1144916002,
    "descripcion":"CALCIFICACIÓN DE PARTES BLANDAS DEBIDA A NEFROPATÍA CRÓNICA"
  },
  {
    "codigo":1208617001,
    "descripcion":"TROMBOCITOPENIA DE PLAQUETAS PEQUEÑAS CONGÉNITA AUTOSÓMICA RECESIVA"
  },
  {
    "codigo":225577002,
    "descripcion":"HALLAZGO DE ESTOMA"
  },
  {
    "codigo":291113003,
    "descripcion":"INTOXICACIÓN POR BUSPIRONA"
  },
  {
    "codigo":127273001,
    "descripcion":"NEOPLASIA DE LOS GANGLIOS LINFÁTICOS PARARRECTALES"
  },
  {
    "codigo":94505005,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL ANTRO PILÓRICO"
  },
  {
    "codigo":422185008,
    "descripcion":"INJERTO CORNEAL"
  },
  {
    "codigo":92670007,
    "descripcion":"CARCINOMA IN SITU DE PALADAR"
  },
  {
    "codigo":1336019005,
    "descripcion":"QUISTE DE GLOBO OCULAR IZQUIERDO PROPIAMENTE DICHO"
  },
  {
    "codigo":713427006,
    "descripcion":"BLOQUEO COMPLETO DE RAMA DERECHA ELECTROCARDIOGRÁFICO"
  },
  {
    "codigo":58067006,
    "descripcion":"ACIDOSIS METABÓLICA, BRECHA ANIÓNICA NORMAL, FALTA DE REGENERACIÓN DE BICARBONATO"
  },
  {
    "codigo":25299008,
    "descripcion":"FUNCIÓN ANORMAL DE EXCRECIÓN"
  },
  {
    "codigo":416680000,
    "descripcion":"MOVIMIENTOS ACCESORIOS"
  },
  {
    "codigo":123603008,
    "descripcion":"HEPATITIS FOCAL AGUDA"
  },
  {
    "codigo":1332349000,
    "descripcion":"HIPERTROFIA DE CÚBITO"
  },
  {
    "codigo":89000008,
    "descripcion":"HIPERTRICOSIS DEL PABELLÓN AURICULAR"
  },
  {
    "codigo":23464008,
    "descripcion":"EDAD GESTACIONAL, 20 SEMANAS"
  },
  {
    "codigo":283773005,
    "descripcion":"MORDEDURA DE PERRO EN LA ESPINILLA"
  },
  {
    "codigo":183634002,
    "descripcion":"SIN SEGUIMIENTO: PROBLEMA RESUELTO"
  },
  {
    "codigo":314706002,
    "descripcion":"PRUEBA DE ANTICUERPOS CONTRA HEPATITIS C DETECTADO"
  },
  {
    "codigo":249170006,
    "descripcion":"PLACENTA COMPLETA EN EL MOMENTO DEL PARTO"
  },
  {
    "codigo":281938006,
    "descripcion":"FRACTURA DE APÓFISIS ESPINOSA DE VÉRTEBRA LUMBAR"
  },
  {
    "codigo":443943005,
    "descripcion":"LESIÓN TRAUMÁTICA AGUDA DE LIGAMENTO CRUZADO POSTERIOR"
  },
  {
    "codigo":1197607006,
    "descripcion":"ALERGIA A SUSTANCIA CON ESTRUCTURA TRIAZÓLICA"
  },
  {
    "codigo":247335009,
    "descripcion":"SENSACIÓN DE VEJIGA URINARIA LLENA"
  },
  {
    "codigo":442108004,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR RITUXIMAB ADMINISTRADO POR INFUSIÓN"
  },
  {
    "codigo":210897000,
    "descripcion":"LESIÓN DE VENA SAFENA INTERNA A NIVEL DE PIERNA"
  },
  {
    "codigo":16124009,
    "descripcion":"INADECUACIÓN SEXUAL"
  },
  {
    "codigo":1259473000,
    "descripcion":"DEMENCIA DEBIDA A SÍNDROME DE CROMOSOMA X FRÁGIL"
  },
  {
    "codigo":704252008,
    "descripcion":"FRACTURA PATOLÓGICA DE PERONÉ EN SITIO DE NEOPLASIA"
  },
  {
    "codigo":702417004,
    "descripcion":"SÍNDROME DE DER(22)T(11;22) SUPERNUMERARIO"
  },
  {
    "codigo":276433004,
    "descripcion":"PICADURA DE INSECTO - HERIDA"
  },
  {
    "codigo":14289006,
    "descripcion":"MIOPATÍA EN EL HIPOPITUITARISMO"
  },
  {
    "codigo":241830004,
    "descripcion":"ENVENENAMIENTO POR HAPALOCHLAENA LUNULATA"
  },
  {
    "codigo":12454008,
    "descripcion":"SÍNDROME DE COLA DE CABALLO CON VEJIGA NEUROGÉNICA"
  },
  {
    "codigo":895355001,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE URÉTER DERECHO"
  },
  {
    "codigo":10619002,
    "descripcion":"ANEMIA MEGALOBLÁSTICA SECUNDARIA A DIETA INADECUADA"
  },
  {
    "codigo":403835002,
    "descripcion":"SÍNDROME DE HIPER-IGM LIGADO A CROMOSOMA X"
  },
  {
    "codigo":371067004,
    "descripcion":"SÍNDROME HEPATOPULMONAR"
  },
  {
    "codigo":239995005,
    "descripcion":"LESIÓN DE LIGAMENTO DE CINTURA PÉLVICA"
  },
  {
    "codigo":1255803004,
    "descripcion":"LINFOMA DE HODGKIN DE GANGLIOS LINFÁTICOS DE CUELLO"
  },
  {
    "codigo":733350009,
    "descripcion":"NEOPLASIA NEUROENDOCRINA MALIGNA PRIMARIA DE CONDUCTO BILIAR DISTAL"
  },
  {
    "codigo":305531002,
    "descripcion":"BAJO ATENCIÓN DE ORTODONCISTA"
  },
  {
    "codigo":43387009,
    "descripcion":"FETO EN FETO"
  },
  {
    "codigo":41552001,
    "descripcion":"TRASTORNO BIPOLAR I LEVE, UN SOLO EPISODIO MANÍACO"
  },
  {
    "codigo":238160003,
    "descripcion":"TRASTORNO DEL TRANSPORTE DE OXÍGENO"
  },
  {
    "codigo":926288007,
    "descripcion":"EPÍFISIS PEQUEÑA DE FALANGE DE DEDO ÍNDICE"
  },
  {
    "codigo":74320008,
    "descripcion":"SÍNDROME DE WOOLF"
  },
  {
    "codigo":203557003,
    "descripcion":"DEFORMIDAD ROTACIONAL DE DEDO DE MANO"
  },
  {
    "codigo":367397007,
    "descripcion":"POSICIÓN EN BANCO DE PLAZA"
  },
  {
    "codigo":267258002,
    "descripcion":"FETO PEQUEÑO PARA LA EDAD GESTACIONAL"
  },
  {
    "codigo":70650003,
    "descripcion":"CÁLCULO VESICAL"
  },
  {
    "codigo":10628031000119109,
    "descripcion":"CARBUNCO DE RODILLA DERECHA"
  },
  {
    "codigo":365562005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA RECONOCER SONIDOS DE ADVERTENCIA"
  },
  {
    "codigo":11830361000119103,
    "descripcion":"LACERACIÓN DE ARCO PALMAR PROFUNDO DE ARTERIA RADIAL DERECHA"
  },
  {
    "codigo":724175002,
    "descripcion":"DISTROFIA DE EPITELIO CORNEAL DE LISCH"
  },
  {
    "codigo":298191006,
    "descripcion":"HIPERMOVILIDAD DE ARTICULACIÓN DE MANO"
  },
  {
    "codigo":296356000,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE FÁRMACOS BLOQUEANTES DE LOS CANALES DEL CALCIO"
  },
  {
    "codigo":68815009,
    "descripcion":"GLOMERULONEFRITIS ASOCIADA CON LUPUS ERITEMATOSO SISTÉMICO"
  },
  {
    "codigo":11803891000119100,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA PROXIMAL DE DEDO ANULAR DERECHO"
  },
  {
    "codigo":165284008,
    "descripcion":"MEMORIA: TIENE CONSCIENCIA DEL MOMENTO ACTUAL"
  },
  {
    "codigo":786041005,
    "descripcion":"FÍSTULA ARTERIOVENOSA SISTÉMICA CONGÉNITA"
  },
  {
    "codigo":292686003,
    "descripcion":"REACCIÓN ADVERSA AL ALCURONIO"
  },
  {
    "codigo":390990006,
    "descripcion":"PATRÓN DE SANGRADO EN TERAPIA DE REEMPLAZO HORMONAL, NO RELEVANTE"
  },
  {
    "codigo":61475000,
    "descripcion":"PRODUCCIÓN NORMAL DE ERITROCITOS"
  },
  {
    "codigo":1208355000,
    "descripcion":"ALERGIA A CANAGLIFLOZINA"
  },
  {
    "codigo":127011001,
    "descripcion":"NEUROPATÍA SENSITIVA DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":10820851000119104,
    "descripcion":"FRACTURA EXPUESTA DE BASE DE QUINTO HUESO METACARPIANO DE MANO IZQUIERDA"
  },
  {
    "codigo":290851007,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR PROTRIPTILINA"
  },
  {
    "codigo":94243009,
    "descripcion":"NEOPLASIA MALIGNA SECUNDARIA DEL SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":715000004,
    "descripcion":"INCAPAZ DE MOVILIZARSE EN EL HOGAR"
  },
  {
    "codigo":289016008,
    "descripcion":"DIFICULTAD PARA COLOCAR ALIMENTO EN LA BOCA"
  },
  {
    "codigo":92408009,
    "descripcion":"NEOPLASIA BENIGNA DE BAZO"
  },
  {
    "codigo":188877001,
    "descripcion":"NEOPLASIA BENIGNA DEL CARTÍLAGO TIROIDES"
  },
  {
    "codigo":57805002,
    "descripcion":"EXOTROPÍA ALTERNANTE CON PATRÓN V"
  },
  {
    "codigo":254413001,
    "descripcion":"CARCINOMA IN SITU DE LA PUNTA DE LA LENGUA"
  },
  {
    "codigo":15955341000119101,
    "descripcion":"SEMINOMA PRIMARIO DE AMBOS TESTÍCULOS NO DESCENDIDOS"
  },
  {
    "codigo":1335757009,
    "descripcion":"TRASTORNO DE LIGAMENTO DE REGIÓN DE HOMBRO"
  },
  {
    "codigo":449186002,
    "descripcion":"DILATACIÓN DE ANILLO DE VÁLVULA PULMONAR"
  },
  {
    "codigo":1268386004,
    "descripcion":"CARCINOMA METASTÁSICO INDIFERENCIADO DE CUERPO UTERINO"
  },
  {
    "codigo":711330007,
    "descripcion":"VIRUS INFLUENZA A SUBTIPO H1N1 DETECTADO"
  },
  {
    "codigo":23202007,
    "descripcion":"HEMORROIDES INTERNAS ESTRANGULADAS"
  },
  {
    "codigo":55970009,
    "descripcion":"INTOXICACIÓN POR TOXICODENDRON RADICANS"
  },
  {
    "codigo":283511003,
    "descripcion":"HERIDA PUNZANTE DE HOMBRO"
  },
  {
    "codigo":447351004,
    "descripcion":"ENFERMEDAD DE SUSTANCIA BLANCA EVANESCENTE"
  },
  {
    "codigo":185207006,
    "descripcion":"ATENDIDO EN UNA INSTITUCIÓN"
  },
  {
    "codigo":709495007,
    "descripcion":"LÍNEA ALBA OCLUSAL"
  },
  {
    "codigo":1363020000,
    "descripcion":"HALLAZGO RELACIONADO CON PRESENCIA DE INTÉRPRETE"
  },
  {
    "codigo":21367009,
    "descripcion":"FORMA VARIANTE DE ALBÚMINA, AUTOSÓMICA DOMINANTE"
  },
  {
    "codigo":871500003,
    "descripcion":"ALERGIA A CIPROTERONA Y\/O ETINILESTRADIOL"
  },
  {
    "codigo":183372004,
    "descripcion":"CONVALECENCIA CONSECUTIVA A RADIOTERAPIA"
  },
  {
    "codigo":19532005,
    "descripcion":"ATONÍA MUSCULAR"
  },
  {
    "codigo":85068007,
    "descripcion":"INFECCIÓN CAUSADA POR PROTOTHECA SEGBWEMA"
  },
  {
    "codigo":707660007,
    "descripcion":"CARCINOMA PRIMARIO DE CÉLULAS GIGANTES DE LARINGE"
  },
  {
    "codigo":312609001,
    "descripcion":"HERIDA PUNZANTE - LESIÓN"
  },
  {
    "codigo":83233002,
    "descripcion":"ENFERMEDAD DE LOS ESPÍRITUS"
  },
  {
    "codigo":412748009,
    "descripcion":"ESTUDIOS CARDÍACOS CON RADIONÚCLIDOS CON RESULTADOS EQUÍVOCOS"
  },
  {
    "codigo":16010791000119102,
    "descripcion":"GANGRENA DE DEDO DE PIE IZQUIERDO"
  },
  {
    "codigo":441846005,
    "descripcion":"REACCIÓN INESPECÍFICA A LA PRUEBA DE TUBERCULINA"
  },
  {
    "codigo":46795000,
    "descripcion":"QUEILITIS ACTÍNICA"
  },
  {
    "codigo":212470008,
    "descripcion":"LESIÓN DE MÚSCULO Y TENDÓN A NIVEL DE PIERNA"
  },
  {
    "codigo":472779006,
    "descripcion":"ANOMALÍA ADQUIRIDA DE VENA BRAQUIOCEFÁLICA"
  },
  {
    "codigo":210635007,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE PULPEJO DE DEDO DE MANO, TIPO 4 (PÉRDIDA PARCIAL DE FALANGE TERMINAL, PULPEJO Y UÑA, INCLUIDA LÁNULA)"
  },
  {
    "codigo":733088002,
    "descripcion":"SÍNDROME DE POLIDACTILIA PREAXIAL, COLOBOMAS Y DISCAPACIDAD INTELECTUAL"
  },
  {
    "codigo":208800004,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE LA ARTICULACIÓN RADIOCUBITAL SUPERIOR"
  },
  {
    "codigo":307104007,
    "descripcion":"VIVE CON UN COMPAÑERO"
  },
  {
    "codigo":75893003,
    "descripcion":"SÍNDROME DE TRISOMÍA PARCIAL 19Q"
  },
  {
    "codigo":1157237004,
    "descripcion":"PERCEPCIÓN ALTERADA"
  },
  {
    "codigo":239733006,
    "descripcion":"DOLOR DE REGIÓN ANTERIOR DE RODILLA"
  },
  {
    "codigo":403573007,
    "descripcion":"CALCIFICACIÓN METASTÁSICA NORMOCALCÉMICA DE LA PIEL"
  },
  {
    "codigo":237898004,
    "descripcion":"CALCIFICACIÓN PERIARTICULAR"
  },
  {
    "codigo":8522006,
    "descripcion":"CLISMAFILIA"
  },
  {
    "codigo":205130008,
    "descripcion":"POLIDACTILIA CENTRAL DE DEDOS DE LA MANO"
  },
  {
    "codigo":236063005,
    "descripcion":"GASTROENTERITIS ADENOVIRAL"
  },
  {
    "codigo":1153567005,
    "descripcion":"SODIO SÉRICO POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":399903008,
    "descripcion":"FIBROMATOSIS DIGITAL INFANTIL"
  },
  {
    "codigo":365300003,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA APAGAR UN ARTEFACTO DOMÉSTICO"
  },
  {
    "codigo":299764005,
    "descripcion":"REFLEJO DE ENDEREZAMIENTO Y MARCHA: RESULTADO DUDOSO"
  },
  {
    "codigo":234228008,
    "descripcion":"TRASTORNO DE DESFIBRILADOR IMPLANTABLE"
  },
  {
    "codigo":199625002,
    "descripcion":"SÍNDROMES DE TRANSFUSIÓN PLACENTARIA"
  },
  {
    "codigo":396233005,
    "descripcion":"ARTROPATÍA ASOCIADA CON INFECCIÓN"
  },
  {
    "codigo":232393006,
    "descripcion":"SINUSITIS ETMOIDAL ANTERIOR CRÓNICA"
  },
  {
    "codigo":363465007,
    "descripcion":"NEOPLASIA MALIGNA DE RETINA"
  },
  {
    "codigo":723913009,
    "descripcion":"TRASTORNO DE REFERENCIA OLFATIVA"
  },
  {
    "codigo":165022002,
    "descripcion":"FUNCIÓN PULMONAR RESTRICTIVA"
  },
  {
    "codigo":722078002,
    "descripcion":"NEFROPATÍA OBSTRUCTIVA DEBIDA A VEJIGA NEUROGÉNICA"
  },
  {
    "codigo":33950005,
    "descripcion":"DIFERENCIAS VENTILATORIAS REGIONALES POR LA GRAVEDAD"
  },
  {
    "codigo":230558006,
    "descripcion":"NEUROPATÍA HEREDITARIA CON SUSCEPTIBILIDAD A LA PRESIÓN"
  },
  {
    "codigo":294259007,
    "descripcion":"ALERGIA A PROSTAGLANDINA, SERIE I"
  },
  {
    "codigo":311131000119105,
    "descripcion":"MIOSITIS INTERSTICIAL DE ANTEBRAZO DERECHO"
  },
  {
    "codigo":359795009,
    "descripcion":"ENFERMEDAD DE GUSANO DE SUELO DE CONGO"
  },
  {
    "codigo":718408003,
    "descripcion":"DISFUNCIÓN SOMÁTICA DE HUESO PÚBICO"
  },
  {
    "codigo":128584005,
    "descripcion":"CONDUCTO CONGÉNITO DE LA ARTERIA PULMONAR"
  },
  {
    "codigo":30280005,
    "descripcion":"TROMPA DE EUSTAQUIO ABIERTA"
  },
  {
    "codigo":292424008,
    "descripcion":"REACCIÓN ADVERSA AL BETAXOLOL"
  },
  {
    "codigo":1144392009,
    "descripcion":"HIPOPLASIA CONGÉNITA DE MÚSCULO DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":126749002,
    "descripcion":"NEOPLASIA DE VASO SANGUÍNEO DE MUSLO"
  },
  {
    "codigo":93981003,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL FONDO DE SACO RECTOUTERINO"
  },
  {
    "codigo":290589007,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR TREOSULFANO"
  },
  {
    "codigo":26610007,
    "descripcion":"AMUSIA"
  },
  {
    "codigo":288754009,
    "descripcion":"DIFICULTAD PARA COMUNICAR ALGO SOBRE SÍ MISMO"
  },
  {
    "codigo":1237191003,
    "descripcion":"TRASTORNO FETAL DEBIDO A SÍNDROME DE TRANSFUSIÓN PLACENTARIA"
  },
  {
    "codigo":254151006,
    "descripcion":"SÍNDROME DE WINCHESTER"
  },
  {
    "codigo":15931381000119105,
    "descripcion":"RUPTURA DE QUISTE DE OVARIO IZQUIERDO"
  },
  {
    "codigo":120821000119107,
    "descripcion":"INFECCIÓN CAUSADA POR ESTAFILOCOCO COAGULASA NEGATIVO"
  },
  {
    "codigo":283249003,
    "descripcion":"VIDRIO EN MUÑECA"
  },
  {
    "codigo":840305006,
    "descripcion":"HIPERTROFIA SEVERA DE VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":609094002,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: KONKANI"
  },
  {
    "codigo":707398003,
    "descripcion":"ADENOCARCINOMA POLIMORFO PRIMARIO DE BAJO GRADO DE OROFARINGE"
  },
  {
    "codigo":1231686007,
    "descripcion":"PSEUDOPAPILEDEMA CONGÉNITO"
  },
  {
    "codigo":246811000,
    "descripcion":"INYECCIÓN EN EL PLIEGUE SEMILUNAR"
  },
  {
    "codigo":1297222008,
    "descripcion":"CIERRE DE ÁNGULO PRIMARIO DE OJO DERECHO"
  },
  {
    "codigo":82971005,
    "descripcion":"MOVILIDAD ALTERADA"
  },
  {
    "codigo":65971000052100,
    "descripcion":"PSICOSIS AGUDA"
  },
  {
    "codigo":212208004,
    "descripcion":"LESIÓN DE LA RAÍZ DEL NERVIO DORSAL - D3"
  },
  {
    "codigo":15600009,
    "descripcion":"NEUMOQUILOTÓRAX"
  },
  {
    "codigo":112069002,
    "descripcion":"MASTOMENIA"
  },
  {
    "codigo":176271000119108,
    "descripcion":"BILIRRUBINA TOTAL POR ENCIMA DE RANGO DE REFERENCIA"
  },
  {
    "codigo":275909008,
    "descripcion":"PAREJA ESTERILIZADA"
  },
  {
    "codigo":110234002,
    "descripcion":"QUEMADURA DE PRIMER GRADO DE LA LENGUA"
  },
  {
    "codigo":700058006,
    "descripcion":"TRASTORNO SIMILAR A ATAXIA-TELANGIECTASIA"
  },
  {
    "codigo":403311004,
    "descripcion":"NEVO MELANOCÍTICO DE LA UNIÓN DERMOEPIDÉRMICA DE MATRIZ UNGUEAL"
  },
  {
    "codigo":1255279007,
    "descripcion":"FRACTURA EXPUESTA DE MÚLTIPLES FALANGES DE DEDO DE MANO"
  },
  {
    "codigo":237636001,
    "descripcion":"HIPOGLUCEMIA SEVERA RECURRENTE"
  },
  {
    "codigo":8260003,
    "descripcion":"INTOXICACIÓN POR ORGANOFOSFORADOS"
  },
  {
    "codigo":204868004,
    "descripcion":"ATRESIA DE CUELLO UTERINO"
  },
  {
    "codigo":71961003,
    "descripcion":"TRASTORNO DESINTEGRATIVO INFANTIL"
  },
  {
    "codigo":203033005,
    "descripcion":"CALCIFICACIÓN\/OSIFICACIÓN PARALÍTICA DE MÚSCULO"
  },
  {
    "codigo":350001000221102,
    "descripcion":"INFECCIÓN SUPERFICIAL CAUSADA POR HONGOS MICELIALES"
  },
  {
    "codigo":301337007,
    "descripcion":"HALLAZGO RELACIONADO CON LA COMPOSICIÓN CORPORAL"
  },
  {
    "codigo":792857006,
    "descripcion":"ACETILADOR LENTO DE N-ACETILTRANSFERASA 2"
  },
  {
    "codigo":233966005,
    "descripcion":"ESTENOSIS DE LA AORTA ABDOMINAL"
  },
  {
    "codigo":365038006,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA EMPLEAR EL LENGUAJE"
  },
  {
    "codigo":363203000,
    "descripcion":"COMPLICACIÓN METABÓLICA DE PROCEDIMIENTOS"
  },
  {
    "codigo":397806008,
    "descripcion":"EQUIPO EMPLEADO POR ERROR"
  },
  {
    "codigo":789187001,
    "descripcion":"ACROGIGANTISMO LIGADO AL CROMOSOMA X DEBIDO A MICRODUPLICACIÓN DE XQ26"
  },
  {
    "codigo":232131003,
    "descripcion":"HIPERMETROPÍA POR CURVATURA"
  },
  {
    "codigo":102894008,
    "descripcion":"SENTIMIENTO DE RELAJACIÓN"
  },
  {
    "codigo":299502009,
    "descripcion":"SIN AMPLITUD ACTIVA DE SUPINACIÓN MEDIOTARSIANA"
  },
  {
    "codigo":263064003,
    "descripcion":"FRACTURA-LUXACIÓN DE ARTICULACIÓN TEMPOROMANDIBULAR"
  },
  {
    "codigo":369091000119106,
    "descripcion":"HIPOTIROIDISMO CAUSADO POR AMIODARONA"
  },
  {
    "codigo":230296006,
    "descripcion":"PARQUINSONISMO VASCULAR"
  },
  {
    "codigo":721816008,
    "descripcion":"INFECCIÓN CAUSADA POR NAEGLERIA FOWLERI"
  },
  {
    "codigo":33688009,
    "descripcion":"COLESTASIS"
  },
  {
    "codigo":228461000,
    "descripcion":"ÚNICA PAREJA SEXUAL ACTUAL"
  },
  {
    "codigo":719981005,
    "descripcion":"ENFERMEDAD DE CHARCOT-MARIE-TOOTH, TIPO 2B2"
  },
  {
    "codigo":293997006,
    "descripcion":"ALERGIA A PRENILAMINA"
  },
  {
    "codigo":342621000119102,
    "descripcion":"LUPUS ERITEMATOSO DISCOIDE DE PÁRPADO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":292162001,
    "descripcion":"REACCIÓN ADVERSA A FÁRMACO ANESTÉSICO GENERAL"
  },
  {
    "codigo":423234004,
    "descripcion":"LESIÓN POR INHALACIÓN"
  },
  {
    "codigo":95554005,
    "descripcion":"DERRAME PERITONEAL SANGUINOLENTO"
  },
  {
    "codigo":161090005,
    "descripcion":"VIAJA AL EXTRANJERO POR NEGOCIOS"
  },
  {
    "codigo":1142295005,
    "descripcion":"CEJA LATERAL ANCHA"
  },
  {
    "codigo":28183005,
    "descripcion":"DEFICIENCIA DE FRUCTOSA BIFOSFATASA"
  },
  {
    "codigo":126487009,
    "descripcion":"TRASTORNO DE LA GRASA SUBCUTÁNEA"
  },
  {
    "codigo":59116002,
    "descripcion":"INTOXICACIÓN CAUSADA POR EPICAUTA"
  },
  {
    "codigo":124652003,
    "descripcion":"DEFICIENCIA DE CARBONO - AZUFRE LIASA"
  },
  {
    "codigo":1204161002,
    "descripcion":"LINFADENITIS INGUINAL AGUDA"
  },
  {
    "codigo":712641002,
    "descripcion":"DEFICIENCIA DE GLUCOSILTRANSFERASA 1"
  },
  {
    "codigo":1079901000119107,
    "descripcion":"NEVO DISPLÁSICO DE PIEL DE MIEMBRO INFERIOR DERECHO"
  },
  {
    "codigo":284822000,
    "descripcion":"CAPAZ DE ARRODILLARSE EN LA BAÑERA"
  },
  {
    "codigo":55446002,
    "descripcion":"MUTACIÓN GENÉTICA"
  },
  {
    "codigo":282987006,
    "descripcion":"GIRA"
  },
  {
    "codigo":1003883007,
    "descripcion":"DUPLICACIÓN DE PORCIÓN PROXIMAL DEL BRAZO CORTO DEL CROMOSOMA 9"
  },
  {
    "codigo":708971008,
    "descripcion":"CARCINOMA PAPILAR ESCLEROSANTE DIFUSO DE TIROIDES"
  },
  {
    "codigo":414059009,
    "descripcion":"OBSERVACIONES RELACIONADAS CON EL CUMPLIMIENTO DEL TRATAMIENTO FARMACOLÓGICO"
  },
  {
    "codigo":1296960002,
    "descripcion":"VERRUGA VIRAL"
  },
  {
    "codigo":608832005,
    "descripcion":"DOLOR DISCOGÉNICO LUMBAR"
  },
  {
    "codigo":1264192005,
    "descripcion":"PIGMENTACIÓN LOCAL EXÓGENA DE REGIÓN SUPERIOR DE MUCOSA YUGAL DERECHA"
  },
  {
    "codigo":182848008,
    "descripcion":"PACIENTE QUE CONSUME NUMEROSOS FÁRMACOS"
  },
  {
    "codigo":707136009,
    "descripcion":"NEVO SEBÁCEO"
  },
  {
    "codigo":49941000,
    "descripcion":"INTOXICACIÓN POR GALEGA"
  },
  {
    "codigo":1196821002,
    "descripcion":"MESENQUIMOMA BENIGNO DE ESTÓMAGO"
  },
  {
    "codigo":312085005,
    "descripcion":"INFECCIÓN - NO SUPURATIVA"
  },
  {
    "codigo":738069006,
    "descripcion":"INTOLERANCIA A LA LECHE DE VACA"
  },
  {
    "codigo":17173007,
    "descripcion":"SED EXCESIVA"
  },
  {
    "codigo":16837521000119102,
    "descripcion":"NEOVASCULARIZACIÓN DE COROIDES DE OJO IZQUIERDO DEBIDA A MIOPÍA DEGENERATIVA"
  },
  {
    "codigo":211946004,
    "descripcion":"CORROSIÓN DE MUÑECA Y MANO"
  },
  {
    "codigo":13503000,
    "descripcion":"INTOXICACIÓN POR NALOXONA"
  },
  {
    "codigo":275647001,
    "descripcion":"DADO DE ALTA DEL SEGUIMIENTO"
  },
  {
    "codigo":111807001,
    "descripcion":"ENDOFTALMÍA GONOCÓCICA"
  },
  {
    "codigo":441322009,
    "descripcion":"PÚRPURA TROMBÓTICA TROMBOCITOPÉNICA INDUCIDA POR FÁRMACOS"
  },
  {
    "codigo":308415008,
    "descripcion":"SITUACIÓN DE LA INMUNIZACIÓN CONTRA LA RUBÉOLA"
  },
  {
    "codigo":372116002,
    "descripcion":"CARCINOMA DE HUESOS PÉLVICOS, SACRO Y CÓCCIX"
  },
  {
    "codigo":109972003,
    "descripcion":"LINFOMA NO HODGKIN FOLICULAR, DE CÉLULAS GRANDES (CLÍNICO)"
  },
  {
    "codigo":271977000,
    "descripcion":"TRASTORNO DE INJERTO DE CARTÍLAGO"
  },
  {
    "codigo":239209004,
    "descripcion":"TRASTORNO DE EXPANSIÓN TISULAR"
  },
  {
    "codigo":403049005,
    "descripcion":"TIÑA DE LA MANO CAUSADA POR TRICHOPHYTON MENTAGROPHYTES VARIANTE ERINACEI"
  },
  {
    "codigo":1255017007,
    "descripcion":"DEPENDENCIA COMBINADA DE SUSTANCIAS EXCEPTO OPIOIDES, CONTINUA"
  },
  {
    "codigo":42601008,
    "descripcion":"ANEMIA HEMOLÍTICA CONGÉNITA"
  },
  {
    "codigo":40766000,
    "descripcion":"FARINGITIS LINFONODULAR POR ENTEROVIRUS"
  },
  {
    "codigo":302910002,
    "descripcion":"ESTENOSIS ATEROSCLERÓTICA DE LA ARTERIA RENAL"
  },
  {
    "codigo":202771000,
    "descripcion":"OSIFICACIÓN DE LIGAMENTO LONGITUDINAL POSTERIOR DEL CUELLO"
  },
  {
    "codigo":7998009,
    "descripcion":"ENVENENAMIENTO DEBIDO A PICADURA DE ABEJA"
  },
  {
    "codigo":6163002,
    "descripcion":"FRACTURA NO EXPUESTA DE CABEZA DE CÚBITO"
  },
  {
    "codigo":399379004,
    "descripcion":"GASTROPATÍA REACTIVA"
  },
  {
    "codigo":170003005,
    "descripcion":"INICIA DIETA NORMAL AL AÑO"
  },
  {
    "codigo":41151000087101,
    "descripcion":"CELULITIS DE TERCER DEDO DE PIE IZQUIERDO"
  },
  {
    "codigo":43711000087103,
    "descripcion":"TRASTORNO DE TENDÓN EXTENSOR DE REGIÓN DE MUÑECA DERECHA"
  },
  {
    "codigo":366611009,
    "descripcion":"PRUEBA DE DESPLAZAMIENTO DEL EJE - HALLAZGO"
  },
  {
    "codigo":46271000087105,
    "descripcion":"FRACTURA DE EXTREMO PROXIMAL DE HÚMERO IZQUIERDO"
  },
  {
    "codigo":200936003,
    "descripcion":"LUPUS ERITEMATOSO"
  },
  {
    "codigo":364776003,
    "descripcion":"ALIMENTACIÓN DEL LACTANTE AL AÑO - HALLAZGO"
  },
  {
    "codigo":25791000087106,
    "descripcion":"VIVE CON FAMILIA SUSTITUTA"
  },
  {
    "codigo":102632006,
    "descripcion":"BIOSÍNTESIS DEFECTUOSA"
  },
  {
    "codigo":428477002,
    "descripcion":"NÓDULO DE CONJUNTIVA"
  },
  {
    "codigo":788925003,
    "descripcion":"MUTILACIÓN DE GENITALES FEMENINOS TIPO 2B"
  },
  {
    "codigo":35261006,
    "descripcion":"INFECCIÓN CAUSADA POR MAMMOMONOGAMUS"
  },
  {
    "codigo":231869007,
    "descripcion":"QUEMADURA DE LA CONJUNTIVA POR SUSTANCIA QUÍMICA"
  },
  {
    "codigo":1149373009,
    "descripcion":"SOBREDOSIS INTENCIONAL DE SULFAMETOXAZOL Y\/O TRIMETOPRIMA"
  },
  {
    "codigo":721554002,
    "descripcion":"AUSENCIA ADQUIRIDA DE ÓRGANO GENITAL MASCULINO"
  },
  {
    "codigo":426642002,
    "descripcion":"ERITROLEUCEMIA, FAB M6 EN REMISIÓN"
  },
  {
    "codigo":262802005,
    "descripcion":"LACERACIÓN DE HÍGADO"
  },
  {
    "codigo":361106007,
    "descripcion":"REACCIÓN A LA TRANSFUSIÓN CAUSADA POR PRESENCIA DE ALÉRGENOS EN LA SANGRE"
  },
  {
    "codigo":658009,
    "descripcion":"LESIÓN TRAUMÁTICA DE COLON SIN HERIDA ABIERTA HACIA CAVIDAD ABDOMINAL"
  },
  {
    "codigo":129895003,
    "descripcion":"VENTILACIÓN ESPONTÁNEA ALTERADA"
  },
  {
    "codigo":64359003,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO DE DEDO DEL PIE"
  },
  {
    "codigo":160828000,
    "descripcion":"PROBLEMA DE RELACIÓN ENTRE LOS PADRES ADOPTIVOS"
  },
  {
    "codigo":783420001,
    "descripcion":"ANEURISMA DE ARTERIA CEREBRAL MEDIA"
  },
  {
    "codigo":293735009,
    "descripcion":"ALERGIA A MOLGRAMOSTIM"
  },
  {
    "codigo":62524003,
    "descripcion":"OVARIO ECTÓPICO"
  },
  {
    "codigo":95292005,
    "descripcion":"CENTRO SUPERNUMERARIO DE LA VÉRTEBRA DORSAL"
  },
  {
    "codigo":291900005,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR CUMARINA"
  },
  {
    "codigo":717884005,
    "descripcion":"DIVERTÍCULO CONGÉNITO DE DUODENO"
  },
  {
    "codigo":29756008,
    "descripcion":"PELAGRA ALCOHÓLICA"
  },
  {
    "codigo":128060009,
    "descripcion":"VÁRICES VENOSAS"
  },
  {
    "codigo":93457003,
    "descripcion":"LÍQUIDO EN CAVIDAD PERITONEAL"
  },
  {
    "codigo":421137005,
    "descripcion":"PÉRDIDA CUTÁNEA DE ESPESOR COMPLETO"
  },
  {
    "codigo":1142033008,
    "descripcion":"FÍSTULA URETROVAGINAL NO CIRCUNFERENCIAL CON COMPROMISO DEL MECANISMO DE CONTINENCIA"
  },
  {
    "codigo":1172966001,
    "descripcion":"DEFICIENCIA MÚLTIPLE DE CARBOXILASA"
  },
  {
    "codigo":27921008,
    "descripcion":"POSICIÓN ACROMIOILÍACA IZQUIERDA POSTERIOR"
  },
  {
    "codigo":290065008,
    "descripcion":"HALLAZGO RELACIONADO CON EL COLOR DE LA MAMA"
  },
  {
    "codigo":124390004,
    "descripcion":"DEFICIENCIA DE PENTOSILTRANSFERASA"
  },
  {
    "codigo":417467000,
    "descripcion":"ALTA DE ATENCIÓN DE ENFERMERA ESPECIALIZADA EN DIABETES"
  },
  {
    "codigo":1269435001,
    "descripcion":"TRASTORNO FETAL INTRAPARTO Y\/O NEONATAL TEMPRANO"
  },
  {
    "codigo":24251002,
    "descripcion":"HEMORRAGIA EN OVARIO"
  },
  {
    "codigo":57019003,
    "descripcion":"VERRUGA VULGAR"
  },
  {
    "codigo":286395001,
    "descripcion":"UTILIZA ADECUADAMENTE EL LENGUAJE"
  },
  {
    "codigo":188091006,
    "descripcion":"NEOPLASIA MALIGNA DE PIEL DEL MEATO AUDITIVO EXTERNO"
  },
  {
    "codigo":253627007,
    "descripcion":"TRONCO PULMONAR AUSENTE CON ARTERIAS PULMONARES CONFLUENTES"
  },
  {
    "codigo":55184003,
    "descripcion":"ENTERITIS INFECCIOSA"
  },
  {
    "codigo":282725005,
    "descripcion":"SECCIÓN DE BRONQUIO"
  },
  {
    "codigo":315493007,
    "descripcion":"NACIDO EN IRLANDA DEL NORTE"
  },
  {
    "codigo":15666681000119102,
    "descripcion":"HUESO ACCESORIO DEL TARSO DEL PIE IZQUIERDO"
  },
  {
    "codigo":1003621009,
    "descripcion":"CLINODACTILIA CONGÉNITA DE MEÑIQUE"
  },
  {
    "codigo":1263930005,
    "descripcion":"EQUIMOSIS FETAL"
  },
  {
    "codigo":870714005,
    "descripcion":"ALERGIA A SULFAMETOXAZOL Y\/O TRIMETOPRIMA"
  },
  {
    "codigo":51514006,
    "descripcion":"SÍNDROME MEDULAR POSTERIOR DEBIDO A FRACTURA NO EXPUESTA A NIVEL DE C1 - C4"
  },
  {
    "codigo":279055000,
    "descripcion":"DOLOR OBSTÉTRICO"
  },
  {
    "codigo":706874009,
    "descripcion":"CON MAYOR RIESGO DE NEGLIGENCIA EN ANCIANO"
  },
  {
    "codigo":1231162009,
    "descripcion":"DEPENDENCIA DE HIPNÓTICO CONTINUA"
  },
  {
    "codigo":705039004,
    "descripcion":"ACTITUD CONFLICTIVA DEL CUIDADOR"
  },
  {
    "codigo":347641000119105,
    "descripcion":"ABSCESO DE PÁRPADO SUPERIOR DERECHO"
  },
  {
    "codigo":277220002,
    "descripcion":"DEFORMIDAD NASAL EN PICO DE LORO"
  },
  {
    "codigo":1293028003,
    "descripcion":"DESCONEXIÓN DE CATÉTER INTRATECAL"
  },
  {
    "codigo":47844003,
    "descripcion":"ANEMIA MEGALOBLÁSTICA POR ANEMIA HEMOLÍTICA CRÓNICA"
  },
  {
    "codigo":80612004,
    "descripcion":"LEISHMANIASIS"
  },
  {
    "codigo":111545005,
    "descripcion":"SÍNDROME DE DEFICIENCIA ENDOCRINA MÚLTIPLE"
  },
  {
    "codigo":275385007,
    "descripcion":"INTOXICACIÓN CAUSADA POR SUSTANCIA BIOLÓGICA"
  },
  {
    "codigo":308153009,
    "descripcion":"FRACTURA NO EXPUESTA DEL PERONÉ DISTAL"
  },
  {
    "codigo":240782002,
    "descripcion":"INFECCIÓN POR ENTOMOPHTHORA"
  },
  {
    "codigo":208014003,
    "descripcion":"FRACTURA VERTEBRAL EXPUESTA CON LESIÓN COMPLETA DE MÉDULA ESPINAL CERVICAL, C1-4"
  },
  {
    "codigo":11406003,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DE LA NARIZ"
  },
  {
    "codigo":109710007,
    "descripcion":"PÉRDIDA VERTICAL DE HUESO ALVEOLAR"
  },
  {
    "codigo":1287523000,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE VULVA"
  },
  {
    "codigo":699534009,
    "descripcion":"LESIÓN TRAUMÁTICA POR ROTACIÓN"
  },
  {
    "codigo":402787000,
    "descripcion":"HIPERLIPEMIA PRIMARIA GENÉTICA MIXTA"
  },
  {
    "codigo":1254755004,
    "descripcion":"METÁSTASIS DE CARCINOMA BASOESCAMOSO EN PIEL"
  },
  {
    "codigo":238947008,
    "descripcion":"MUCINOSIS CUTÁNEA JUVENIL AUTOCICATRIZANTE"
  },
  {
    "codigo":1285688002,
    "descripcion":"MALFORMACIÓN CONGÉNITA DE VENA RENAL"
  },
  {
    "codigo":400952003,
    "descripcion":"ANQUILOBLÉFARON FILIFORME CONGÉNITO"
  },
  {
    "codigo":237112004,
    "descripcion":"LIQUEN PLANO DE LA VULVA"
  },
  {
    "codigo":711191000124106,
    "descripcion":"SINOVITIS CRÓNICA DE CADERA DERECHA DEBIDA A HEMARTROSIS"
  },
  {
    "codigo":366349004,
    "descripcion":"HALLAZGO RELACIONADO CON EL DESARROLLO DE LAS MAMAS"
  },
  {
    "codigo":169741004,
    "descripcion":"ALIMENTADO A PECHO"
  },
  {
    "codigo":200674008,
    "descripcion":"CELULITIS Y ABSCESO DE LA MUÑECA"
  },
  {
    "codigo":2231001,
    "descripcion":"TRASTORNO DE PLEXO NERVIOSO"
  },
  {
    "codigo":298978009,
    "descripcion":"AMPLITUD DE ABDUCCIÓN PASIVA DE ARTICULACIÓN DE MUÑECA, DISMINUIDA"
  },
  {
    "codigo":297143008,
    "descripcion":"ÉMBOLO DE ARTERIA SUPRARRENAL"
  },
  {
    "codigo":295308000,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE TOLMETINA"
  },
  {
    "codigo":721292002,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE CONDUCTO AUDITIVO EXTERNO"
  },
  {
    "codigo":262540003,
    "descripcion":"HERIDA INCISA SUPERFICIAL"
  },
  {
    "codigo":22471000119100,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE DURAMADRE ESPINAL"
  },
  {
    "codigo":195169004,
    "descripcion":"HEMORRAGIA INTRACEREBRAL, LOCALIZACIONES MÚLTIPLES"
  },
  {
    "codigo":129633006,
    "descripcion":"SÍNDROME DE HIPOGONADISMO INDUCIDO EN LA MUJER"
  },
  {
    "codigo":293473007,
    "descripcion":"REACCIÓN ADVERSA AL AMILORIDA"
  },
  {
    "codigo":95030008,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE COSTILLA"
  },
  {
    "codigo":783158009,
    "descripcion":"INFUNDIBULONEUROHIPOFISITIS"
  },
  {
    "codigo":226102008,
    "descripcion":"DIETA CON ALTO CONTENIDO DE ÁCIDOS GRASOS POLINSATURADOS"
  },
  {
    "codigo":60427004,
    "descripcion":"CRUJIDO MEDIASTÍNICO"
  },
  {
    "codigo":1141771005,
    "descripcion":"TEMBLOR DE EXTREMIDAD"
  },
  {
    "codigo":125963005,
    "descripcion":"CONDUCTO ARTERIAL PERSISTENTE CON DERIVACIÓN DE IZQUIERDA A DERECHA"
  },
  {
    "codigo":224267006,
    "descripcion":"HOGAR ESCASAMENTE PERSONALIZADO"
  },
  {
    "codigo":191499009,
    "descripcion":"PSICOSIS ORGÁNICAS TRANSITORIAS"
  },
  {
    "codigo":255200003,
    "descripcion":"NEOPLASIA BENIGNA DE HIPOTÁLAMO"
  },
  {
    "codigo":1172704005,
    "descripcion":"LINFOMA DE LINFOCITOS B DE ALTO GRADO CON REORDENAMIENTOS MYC Y BCL2 Y\/O BCL6"
  },
  {
    "codigo":124128009,
    "descripcion":"DEFICIENCIA DE FOSFOGLUCONATO DESHIDROGENASA"
  },
  {
    "codigo":286133002,
    "descripcion":"DIFICULTAD PARA LIMPIAR EL ÁREA DE PREPARACIÓN DE COMIDAS"
  },
  {
    "codigo":677831000119107,
    "descripcion":"OCLUSIÓN PARCIAL DE VENA DE LA RETINA DERECHA"
  },
  {
    "codigo":187829004,
    "descripcion":"NEOPLASIA MALIGNA DE CARTÍLAGO DE LA NARIZ"
  },
  {
    "codigo":15724641000119102,
    "descripcion":"ENTESOPATÍA BILATERAL DE CADERAS"
  },
  {
    "codigo":89525009,
    "descripcion":"CRISIS EPILÉPTICA GELÁSTICA"
  },
  {
    "codigo":1300106003,
    "descripcion":"COMPLETÓ PROGRAMA DE APRENDIZAJE DE INGLÉS COMO SEGUNDO IDIOMA"
  },
  {
    "codigo":284298004,
    "descripcion":"DIFICULTAD PARA REALIZAR LA PRENSIÓN CON SUPINACIÓN DE LA MUÑECA"
  },
  {
    "codigo":184159003,
    "descripcion":"SUPERVISIÓN INFANTIL NO REGISTRADA"
  },
  {
    "codigo":282463003,
    "descripcion":"LACERACIÓN DE BRONQUIO"
  },
  {
    "codigo":118623005,
    "descripcion":"DEFORMIDAD EN VALGO DEL PRIMER DEDO DEL PIE Y BUNIO"
  },
  {
    "codigo":249695006,
    "descripcion":"AUSENCIA COSTILLA"
  },
  {
    "codigo":20319008,
    "descripcion":"DISFRUTE NORMAL DEL SEXO"
  },
  {
    "codigo":247860002,
    "descripcion":"NEUTROPENIA FAMILIAR"
  },
  {
    "codigo":444468005,
    "descripcion":"LESIÓN TRAUMÁTICA DE LIGAMENTO LATERAL EXTERNO DE RODILLA"
  },
  {
    "codigo":18484008,
    "descripcion":"MIOCARDITIS INTERSTICIAL SUBAGUDA"
  },
  {
    "codigo":213257006,
    "descripcion":"ESTADO DE SALUD GENERAL MALO"
  },
  {
    "codigo":80350001,
    "descripcion":"EFECTO TARDÍO DE UNA CONTUSIÓN"
  },
  {
    "codigo":1163529009,
    "descripcion":"EPILEPSIA DEBIDA A ENDOCARDITIS BACTERIANA"
  },
  {
    "codigo":47582003,
    "descripcion":"TRICONODOSIS"
  },
  {
    "codigo":373427001,
    "descripcion":"FUSIÓN CONGÉNITA DE FALANGES"
  },
  {
    "codigo":12979003,
    "descripcion":"FATIGA TRANSITORIA POR CALOR"
  },
  {
    "codigo":209587004,
    "descripcion":"DESGARRO COMPLETO DE LIGAMENTO RADIOCARPIANO PALMAR NO ESPECÍFICO"
  },
  {
    "codigo":307891005,
    "descripcion":"ESTADO DE CERTIFICADO DE PROTECCIÓN"
  },
  {
    "codigo":15721561000119102,
    "descripcion":"CONTRACTURA DE ARTICULACIONES DE AMBOS CODOS"
  },
  {
    "codigo":341081000119102,
    "descripcion":"MIOPÍA ALTA PROGRESIVA DEGENERATIVA DE OJO IZQUIERDO"
  },
  {
    "codigo":703340121000119102,
    "descripcion":"PROLAPSO DE GASTROSTOMÍA"
  },
  {
    "codigo":97881000119105,
    "descripcion":"INCIDENTALOMA SUPRARRENAL"
  },
  {
    "codigo":15711321000119106,
    "descripcion":"TROMBOSIS VENOSA PROFUNDA AGUDA DE AMBAS EXTREMIDADES INFERIORES POSTERIOR A PROCEDIMIENTO"
  },
  {
    "codigo":302681000119107,
    "descripcion":"SÍNDROME DE COMPRESIÓN DE ARTERIA RAQUÍDEA ANTERIOR DE MÉDULA ESPINAL LUMBAR"
  },
  {
    "codigo":103001000119108,
    "descripcion":"LESIÓN DE PIEL DEL PIE"
  },
  {
    "codigo":292441000119109,
    "descripcion":"INFLAMACIÓN DE NERVIO PERIFÉRICO DE PIE DERECHO"
  },
  {
    "codigo":8281000119109,
    "descripcion":"ANQUILOSIS DE COMPLEJO OCCIPITO-ATLANTO-AXIAL"
  },
  {
    "codigo":16097881000119109,
    "descripcion":"ARTROFIBROSIS DE CADERA DERECHA"
  },
  {
    "codigo":15703641000119108,
    "descripcion":"TRASTORNO DE TENDÓN DE REGIÓN DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":1086041000119105,
    "descripcion":"HEMORRAGIA GÁSTRICA DEBIDA A LESIÓN DE ESTÓMAGO DE DIEULAFOY"
  },
  {
    "codigo":369757002,
    "descripcion":"CONFIGURACIÓN TUMORAL SÓLIDA"
  },
  {
    "codigo":335961000119106,
    "descripcion":"IRITIS CRÓNICA DE OJO DERECHO"
  },
  {
    "codigo":15736921000119108,
    "descripcion":"DEPÓSITO DE PIGMENTO EN CÁPSULA DE CRISTALINO DE OJO DERECHO POSTERIOR A TRAUMATISMO CONTUSO"
  },
  {
    "codigo":42077005,
    "descripcion":"HIPERFLEXIÓN"
  },
  {
    "codigo":136281000119109,
    "descripcion":"ANEMIA CAUSADA POR AGENTE ANTINEOPLÁSICO"
  },
  {
    "codigo":10946811000119108,
    "descripcion":"AVULSIÓN DE UNIDAD UNGUEAL DE DEDO MEDIO DERECHO"
  },
  {
    "codigo":1187122000,
    "descripcion":"SÍNDROME DE WITTEVEEN KOLK"
  },
  {
    "codigo":402525008,
    "descripcion":"CARCINOMA BASOCELULAR TIPO ADENOIDE"
  },
  {
    "codigo":472729851000119109,
    "descripcion":"ÚLCERA VENOSA DE PIE DERECHO"
  },
  {
    "codigo":300551000,
    "descripcion":"FERTILIDAD NORMAL"
  },
  {
    "codigo":366087001,
    "descripcion":"HALLAZGO RELACIONADO CON PATRONES DE MOVIMIENTO OCULAR"
  },
  {
    "codigo":235015000,
    "descripcion":"CRESTA ALVEOLAR BISELADA"
  },
  {
    "codigo":5639000,
    "descripcion":"ERUPCIÓN TARDÍA DE DIENTE"
  },
  {
    "codigo":169479008,
    "descripcion":"RECOLOCACIÓN DE DISPOSITIVO ANTICONCEPTIVO INTRAUTERINO"
  },
  {
    "codigo":10838421000119105,
    "descripcion":"FRACTURA ABIERTA DE CAVIDAD GLENOIDEA IZQUIERDA"
  },
  {
    "codigo":823004006,
    "descripcion":"COSTRA EN LA NARIZ"
  },
  {
    "codigo":298716007,
    "descripcion":"SIGNO CON NOMBRE PROPIO DEL TÓRAX"
  },
  {
    "codigo":167644009,
    "descripcion":"MATERIA FECAL: PÓLIPOS PRESENTES"
  },
  {
    "codigo":722865001,
    "descripcion":"INSUFICIENCIA HEPÁTICA SUBAGUDA CAUSADA POR VIRUS DE HEPATITIS"
  },
  {
    "codigo":1148849001,
    "descripcion":"TRASTORNO FIBRINOLÍTICO CAUSADO POR UROQUINASA"
  },
  {
    "codigo":1279921005,
    "descripcion":"SÍNDROME DE CORDÓN CENTRAL DE MÉDULA TORÁCICA DEBIDO A FRACTURA EXPUESTA A NIVEL T7-T12"
  },
  {
    "codigo":295046003,
    "descripcion":"PROCTOCOLITIS ULCEROSA"
  },
  {
    "codigo":1179782005,
    "descripcion":"COLINA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":134006,
    "descripcion":"CRECIMIENTO DISMINUIDO DEL PELO"
  },
  {
    "codigo":293211000,
    "descripcion":"REACCIÓN ADVERSA AL GESTRONOL"
  },
  {
    "codigo":719195007,
    "descripcion":"PROMINENCIA ANORMAL DE RÓTULA"
  },
  {
    "codigo":225840000,
    "descripcion":"RESPETA LA VIDA"
  },
  {
    "codigo":424283009,
    "descripcion":"ALTERACIÓN DE LOS RITUALES ESPIRITUALES"
  },
  {
    "codigo":194907008,
    "descripcion":"PERICARDITIS SIFILÍTICA AGUDA"
  },
  {
    "codigo":63835008,
    "descripcion":"VOYEURISMO"
  },
  {
    "codigo":193072006,
    "descripcion":"ADHERENCIAS DE MENINGES MEDULARES"
  },
  {
    "codigo":94768007,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL LIGAMENTO ANCHO"
  },
  {
    "codigo":92933000,
    "descripcion":"FORMA ANORMAL CONGÉNITA DE TROMPA DE FALOPIO"
  },
  {
    "codigo":717360009,
    "descripcion":"PELO BIFURCADO"
  },
  {
    "codigo":60165002,
    "descripcion":"LINFANGITIS AGUDA DE LA AXILA"
  },
  {
    "codigo":1208880009,
    "descripcion":"OFTALMOPLEJÍA POR ABETALIPOPROTEINEMIA"
  },
  {
    "codigo":15864521000119102,
    "descripcion":"DEFORMIDAD CONGÉNITA DE DEDO DEL PIE IZQUIERDO"
  },
  {
    "codigo":254938000,
    "descripcion":"ASTROCITOMA CEREBRAL"
  },
  {
    "codigo":16054831000119109,
    "descripcion":"ASTIGMATISMO IRREGULAR BILATERAL POSTQUIRÚRGICO"
  },
  {
    "codigo":91098006,
    "descripcion":"QUILURIA"
  },
  {
    "codigo":285871003,
    "descripcion":"NO USA EL LAVARROPAS"
  },
  {
    "codigo":449711005,
    "descripcion":"CELULITIS DE PIERNA"
  },
  {
    "codigo":253103006,
    "descripcion":"ENCEFALOCELE FRONTAL"
  },
  {
    "codigo":710020000,
    "descripcion":"MORFOLOGÍA DE CRESTA ALVEOLAR RESIDUAL DE MAXILAR SUPERIOR CON ESPINA NASAL ANTERIOR PROMINENTE"
  },
  {
    "codigo":1268911008,
    "descripcion":"PANCREATOBLASTOMA PRIMARIO"
  },
  {
    "codigo":251268003,
    "descripcion":"PATRÓN DEL MARCAPASO AURICULAR"
  },
  {
    "codigo":314969001,
    "descripcion":"RECIDIVA LOCAL DE NEOPLASIA MALIGNA DE PRÓSTATA"
  },
  {
    "codigo":447876009,
    "descripcion":"ANEURISMA CONGÉNITO DE REGIÓN SUBAÓRTICA DE VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":282201001,
    "descripcion":"DIFICULTAD PARA BAJAR ESCALERAS"
  },
  {
    "codigo":249433005,
    "descripcion":"CICATRIZ DE LARINGECTOMÍA"
  },
  {
    "codigo":216665008,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR PINTURAS AL ACEITE"
  },
  {
    "codigo":313134005,
    "descripcion":"HALLAZGO RELACIONADO CON EL PULGAR"
  },
  {
    "codigo":247598008,
    "descripcion":"OLVIDA LO QUE ACABA DE LEER"
  },
  {
    "codigo":737283003,
    "descripcion":"IMPLANTE DE RAÍZ DENTAL IN SITU"
  },
  {
    "codigo":1163267006,
    "descripcion":"CAPAZ DE ACCEDER AL AGUA POTABLE CON DIFICULTAD"
  },
  {
    "codigo":278531007,
    "descripcion":"HIDROCALICOSIS CONGÉNITA"
  },
  {
    "codigo":16387008,
    "descripcion":"VÍCTIMA DE CONTIENDA CIVIL"
  },
  {
    "codigo":1259736002,
    "descripcion":"NEVO AZUL MALIGNO PRIMARIO DE PIEL"
  },
  {
    "codigo":735448003,
    "descripcion":"ANAFILAXIA DEBIDA A TRASTORNO DE LOS MASTOCITOS"
  },
  {
    "codigo":309464009,
    "descripcion":"FRACTURA DE CODO"
  },
  {
    "codigo":14552009,
    "descripcion":"VESTIGIOS REMANENTES DE CONDUCTO DE CLOQUET"
  },
  {
    "codigo":111021003,
    "descripcion":"NEOVASCULARIZACIÓN DE LA REGIÓN SUBEPIDÉRMICA"
  },
  {
    "codigo":45485004,
    "descripcion":"ÚLCERA PÉPTICA AGUDA SIN HEMORRAGIA Y SIN PERFORACIÓN"
  },
  {
    "codigo":274861001,
    "descripcion":"NIVELES HORMONALES EN LÍQUIDO CEFALORRAQUÍDEO FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":209325008,
    "descripcion":"FRACTURA-SUBLUXACIÓN NO EXPUESTA DE MÚLTIPLES DEDOS"
  },
  {
    "codigo":1256066001,
    "descripcion":"XANTOMA DEBIDO A HIPERLIPIDEMIA SECUNDARIA"
  },
  {
    "codigo":12207101000119102,
    "descripcion":"FALLA MECÁNICA DE PRÓTESIS DE RODILLA DERECHA"
  },
  {
    "codigo":404098005,
    "descripcion":"QUISTE MUCOSO DIGITAL"
  },
  {
    "codigo":43650005,
    "descripcion":"FUNCIÓN CARDÍACA DISMINUIDA"
  },
  {
    "codigo":305794006,
    "descripcion":"VISTO POR SERVICIO DE RADIOTERAPIA"
  },
  {
    "codigo":76418009,
    "descripcion":"CONMOCIÓN CON CONFUSIÓN MENTAL Y\/O DESORIENTACIÓN, SIN PÉRDIDA DE LA CONSCIENCIA"
  },
  {
    "codigo":205655003,
    "descripcion":"TRISOMÍA 22"
  },
  {
    "codigo":238423005,
    "descripcion":"ÚLCERA DEL DESIERTO"
  },
  {
    "codigo":369495006,
    "descripcion":"TUMOR MALIGNO QUE COMPROMETE EL CUERPO UTERINO POR PROPAGACIÓN DIRECTA DEL CUELLO UTERINO"
  },
  {
    "codigo":271191007,
    "descripcion":"AMPOLLA TRAUMÁTICA DEL PIE, INFECTADA"
  },
  {
    "codigo":302124002,
    "descripcion":"SATISFECHO CON EL TRABAJO"
  },
  {
    "codigo":1186860003,
    "descripcion":"INFERTILIDAD MASCULINA CAUSADA POR TOXINA AMBIENTAL"
  },
  {
    "codigo":236111000112100,
    "descripcion":"E. COLI O21:H7 O O50:H7"
  },
  {
    "codigo":39980005,
    "descripcion":"DIETA RESTRINGIDA EN GRASAS"
  },
  {
    "codigo":236588007,
    "descripcion":"GLOMERULOPATÍA DEL TRASPLANTE - FORMA TEMPRANA"
  },
  {
    "codigo":105516008,
    "descripcion":"DESAVENENCIA CON LOS MAESTROS"
  },
  {
    "codigo":365825002,
    "descripcion":"HALLAZGO RELACIONADO CON EL ESTADO DE LA VESTIMENTA"
  },
  {
    "codigo":201985002,
    "descripcion":"ARTRITIS CLIMATÉRICA DE MÚLTIPLES LOCALIZACIONES"
  },
  {
    "codigo":16030871000119101,
    "descripcion":"OSTEOMIELITIS SUBAGUDA DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":3542000,
    "descripcion":"LACERACIÓN QUE SE EXTIENDE HACIA PARÉNQUIMA DE BAZO CON HERIDA ABIERTA HACIA CAVIDAD ABDOMINAL"
  },
  {
    "codigo":298454006,
    "descripcion":"SIN ROTACIÓN ACTIVA DE LA COLUMNA CERVICAL HACIA LA DERECHA"
  },
  {
    "codigo":69078007,
    "descripcion":"AMILOIDOSIS ASOCIADA CON LA EDAD"
  },
  {
    "codigo":1148587000,
    "descripcion":"FLEGMASIA ALBA DOLENS EN EL EMBARAZO"
  },
  {
    "codigo":200150009,
    "descripcion":"PARTO POR CESÁREA - HISTERECTOMÍA"
  },
  {
    "codigo":296619004,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE CLARITROMICINA"
  },
  {
    "codigo":165547005,
    "descripcion":"BLASTOCITOS, PRESENTES"
  },
  {
    "codigo":198315005,
    "descripcion":"SUBINVOLUCIÓN CRÓNICA DEL ÚTERO"
  },
  {
    "codigo":394923006,
    "descripcion":"VIVE EN HOGAR RESIDENCIAL"
  },
  {
    "codigo":1343360003,
    "descripcion":"ACCESO DIGITAL INADECUADO DEBIDO A AUSENCIA DE DISPOSITIVO DIGITAL"
  },
  {
    "codigo":262016004,
    "descripcion":"BOCA ABIERTA"
  },
  {
    "codigo":425856008,
    "descripcion":"ELECTROCARDIOGRAMA: TAQUICARDIA VENTRICULAR PAROXÍSTICA"
  },
  {
    "codigo":292949001,
    "descripcion":"REACCIÓN ADVERSA AL CIPROFLOXACINO"
  },
  {
    "codigo":260181005,
    "descripcion":"ENFERMEDAD CAUSADA POR EIMERIA"
  },
  {
    "codigo":1144917006,
    "descripcion":"PAPILOMA INTRADUCTAL DE MAMA CON HIPERPLASIA ATÍPICA DE CONDUCTO GALACTÓFORO"
  },
  {
    "codigo":61738006,
    "descripcion":"SÍNDROME DE ENTEROPATÍA NO SENSIBLE AL GLUTEN"
  },
  {
    "codigo":225578007,
    "descripcion":"HALLAZGO RELACIONADO CON LA BEBIDA"
  },
  {
    "codigo":127274007,
    "descripcion":"NEOPLASIA DE LOS GANGLIOS LINFÁTICOS DE MÚLTIPLES SITIOS ANATÓMICOS"
  },
  {
    "codigo":59903001,
    "descripcion":"BRONQUIOLITIS OBLITERANTE AGUDA"
  },
  {
    "codigo":94506006,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL PÍLORO"
  },
  {
    "codigo":291114009,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR BUSPIRONA"
  },
  {
    "codigo":289279004,
    "descripcion":"PLACENTA SANA"
  },
  {
    "codigo":420351005,
    "descripcion":"DEFICIENCIA DE HORMONA DE CRECIMIENTO DE COMIENZO EN LA EDAD ADULTA"
  },
  {
    "codigo":92671006,
    "descripcion":"CARCINOMA IN SITU DE AMÍGDALAS"
  },
  {
    "codigo":27135009,
    "descripcion":"FIBROSIS DEL CUELLO UTERINO"
  },
  {
    "codigo":123604002,
    "descripcion":"CIRROSIS TÓXICA"
  },
  {
    "codigo":189140003,
    "descripcion":"NEOPLASIA BENIGNA DE VESÍCULA SEMINAL"
  },
  {
    "codigo":254676008,
    "descripcion":"DISQUERATOMA VERRUGOSO"
  },
  {
    "codigo":56233004,
    "descripcion":"RAQUITISMO CALCIOPÉNICO"
  },
  {
    "codigo":1332350000,
    "descripcion":"HIPERTROFIA DE HUESO DE PIE"
  },
  {
    "codigo":283774004,
    "descripcion":"MORDEDURA DE PERRO EN LA PANTORRILLA"
  },
  {
    "codigo":54398005,
    "descripcion":"INFECCIÓN AGUDA DE VÍAS RESPIRATORIAS SUPERIORES"
  },
  {
    "codigo":21630007,
    "descripcion":"DEFICIENCIA DE GLUTATIÓN S - TRANSFERASA"
  },
  {
    "codigo":251006007,
    "descripcion":"ESTENOSIS DE VÁLVULA PULMONAR CON DEFORMIDAD EN CÚPULA"
  },
  {
    "codigo":183635001,
    "descripcion":"REGRESAR SÓLO SI ES NECESARIO"
  },
  {
    "codigo":85331004,
    "descripcion":"ABORTO ESPONTÁNEO CON LACERACIÓN DE LIGAMENTO ANCHO"
  },
  {
    "codigo":609619005,
    "descripcion":"TRASTORNO DE REGIÓN PÉLVICA DE TRONCO"
  },
  {
    "codigo":314707006,
    "descripcion":"ANTICUERPO CONTRA HEPATITIS C NO DETECTADO"
  },
  {
    "codigo":445779008,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÉDULA ESPINAL A NIVEL DE D7-D12"
  },
  {
    "codigo":247336005,
    "descripcion":"SENSACIÓN ABDOMINAL PERSISTENTE DESPUÉS DE LA MICCIÓN"
  },
  {
    "codigo":1230376005,
    "descripcion":"ENCEFALOPATÍA EPILÉPTICA Y DEL DESARROLLO ASOCIADA AL GEN CNTNAP2 (PROTEÍNA ASOCIADA A LA CONTACTINA 2)"
  },
  {
    "codigo":17960009,
    "descripcion":"SÍNDROME DE PIULACHS - HEDERICH"
  },
  {
    "codigo":704253003,
    "descripcion":"FRACTURA PATOLÓGICA DE FÉMUR EN SITIO DE NEOPLASIA"
  },
  {
    "codigo":866258001,
    "descripcion":"REACCIÓN ADVERSA A ESTABILIZANTE DE MASTOCITOS"
  },
  {
    "codigo":210898005,
    "descripcion":"LESIÓN DE VENA SAFENA EXTERNA A NIVEL DE PIERNA"
  },
  {
    "codigo":241831000,
    "descripcion":"ENVENENAMIENTO DEBIDO A PICADURA DE MEDUSA"
  },
  {
    "codigo":702418009,
    "descripcion":"SÍNDROME DE HERNIA DIAFRAGMÁTICA-ONFALOCELE-HIPERTELORISMO"
  },
  {
    "codigo":76156000,
    "descripcion":"DEGENERACIÓN CEREBELOSA JUVENIL Y MIOCLONÍA"
  },
  {
    "codigo":15951461000119105,
    "descripcion":"MELANOMA IN SITU DE PIEL DE AMBOS MIEMBROS SUPERIORES"
  },
  {
    "codigo":403836001,
    "descripcion":"SÍNDROME DE HIPERGAMMAGLOBULINEMIA M DE HERENCIA AUTOSÓMICA RECESIVA"
  },
  {
    "codigo":698748003,
    "descripcion":"HISTORIA CLÍNICA DEL PACIENTE, PERDIDA"
  },
  {
    "codigo":733351008,
    "descripcion":"NEOPLASIA NEUROENDOCRINA MALIGNA PRIMARIA DE AMPOLLA DE VATER"
  },
  {
    "codigo":1255804005,
    "descripcion":"LINFOMA DE HODGKIN DE GANGLIOS LINFÁTICOS DE CABEZA Y CUELLO"
  },
  {
    "codigo":239996006,
    "descripcion":"LAXITUD LIGAMENTOSA DE LA REGIÓN PÉLVICA"
  },
  {
    "codigo":895356000,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA BILATERAL DE URÉTER"
  },
  {
    "codigo":305532009,
    "descripcion":"BAJO ATENCIÓN DE ODONTÓLOGO PEDIÁTRICO"
  },
  {
    "codigo":926289004,
    "descripcion":"EPÍFISIS PEQUEÑA DE FALANGE DE SEGUNDO DEDO DE PIE"
  },
  {
    "codigo":238161004,
    "descripcion":"SUMINISTRO DEFICIENTE DE OXÍGENO"
  },
  {
    "codigo":41553006,
    "descripcion":"ASMA POR DETERGENTES"
  },
  {
    "codigo":72486001,
    "descripcion":"ÚLCERA GÁSTRICA PERFORADA CON OBSTRUCCIÓN"
  },
  {
    "codigo":6950007,
    "descripcion":"DISPRAXIA"
  },
  {
    "codigo":365563000,
    "descripcion":"UTILIZACIÓN DE BANCOS Y SOCIEDADES EDILICIAS - HALLAZGO"
  },
  {
    "codigo":400166009,
    "descripcion":"QUERATODERMIA ADQUIRIDA"
  },
  {
    "codigo":201723002,
    "descripcion":"SÍNDROME DE LA MANO DIABÉTICA"
  },
  {
    "codigo":1186598009,
    "descripcion":"PORFIRINA DENTRO DE RANGO DE REFERENCIA"
  },
  {
    "codigo":70651004,
    "descripcion":"SIGNO DE CALKIN"
  },
  {
    "codigo":724176001,
    "descripcion":"LIPODISTROFIA DEBIDA A DEFICIENCIA DE FACTORES DE CRECIMIENTO PEPTÍDICOS"
  },
  {
    "codigo":298192004,
    "descripcion":"HIPERMOVILIDAD DE ARTICULACIÓN METACARPOFALÁNGICA"
  },
  {
    "codigo":11311001000119101,
    "descripcion":"FRACTURA NO EXPUESTA DE QUINTA VÉRTEBRA LUMBAR"
  },
  {
    "codigo":296357009,
    "descripcion":"SOBREDOSIS INTENCIONAL DE BLOQUEANTE DE LOS CANALES DE CALCIO"
  },
  {
    "codigo":720506002,
    "descripcion":"SÍNDROME DE SORDERA Y MIOPÍA"
  },
  {
    "codigo":10737561000119103,
    "descripcion":"CISTOADENOCARCINOMA MUCINOSO PRIMARIO DE OVARIO IZQUIERDO"
  },
  {
    "codigo":65146007,
    "descripcion":"BAZO ECTÓPICO"
  },
  {
    "codigo":333721000119104,
    "descripcion":"PTOSIS MIÓGENA DEL OJO DERECHO"
  },
  {
    "codigo":390991005,
    "descripcion":"PATRÓN DE SANGRADO EN TERAPIA DE REEMPLAZO HORMONAL, SIN SANGRADO"
  },
  {
    "codigo":292687007,
    "descripcion":"REACCIÓN ADVERSA AL ATRACURIO"
  },
  {
    "codigo":61476004,
    "descripcion":"QUISTE EMBRIONARIO DE LA VAGINA"
  },
  {
    "codigo":127012008,
    "descripcion":"DIABETES LIPOATRÓFICA"
  },
  {
    "codigo":715001000,
    "descripcion":"SE MOVILIZA EN EL HOGAR"
  },
  {
    "codigo":92409001,
    "descripcion":"NEOPLASIA BENIGNA DEL ÁNGULO ESPLÉNICO DEL COLON"
  },
  {
    "codigo":90574000,
    "descripcion":"EFECTO TÓXICO DEL ETILYODOACETATO"
  },
  {
    "codigo":385486001,
    "descripcion":"COMPLICACIÓN POSTOPERATORIA"
  },
  {
    "codigo":1237454003,
    "descripcion":"METÁSTASIS DE CARCINOMA DE ÁNGULO ESPLÉNICO"
  },
  {
    "codigo":418254004,
    "descripcion":"QUELOIDE CORNEAL"
  },
  {
    "codigo":1335758004,
    "descripcion":"DETENCIÓN DE CRECIMIENTO EPIFISARIO DE HÚMERO"
  },
  {
    "codigo":188878006,
    "descripcion":"NEOPLASIA BENIGNA DEL CARTÍLAGO CRICOIDES"
  },
  {
    "codigo":254414007,
    "descripcion":"NEOPLASIA BENIGNA DE PUNTA DE LENGUA"
  },
  {
    "codigo":285347000,
    "descripcion":"HERIDAS MÚLTIPLES POR ARMA BLANCA"
  },
  {
    "codigo":23203002,
    "descripcion":"INTOXICACIÓN POR VICIA VILLOSA"
  },
  {
    "codigo":416419004,
    "descripcion":"CONTINUIDAD DE LA REALIZACIÓN DE EXTENDIDOS CERVICALES DESPUÉS DE LA HISTERECTOMÍA"
  },
  {
    "codigo":711331006,
    "descripcion":"HEPATITIS C DETECTADO POR PRUEBA DE REACCIÓN EN CADENA DE POLIMERASA"
  },
  {
    "codigo":449187006,
    "descripcion":"DEFICIENCIA DE CADENA LIVIANA KAPPA"
  },
  {
    "codigo":1268387008,
    "descripcion":"CARCINOMA PRIMARIO INDIFERENCIADO DE CUERPO DE ÚTERO"
  },
  {
    "codigo":185208001,
    "descripcion":"ATENDIDO EN EL LUGAR DE TRABAJO"
  },
  {
    "codigo":21368004,
    "descripcion":"DISTENSIBILIDAD PULMONAR AUMENTADA"
  },
  {
    "codigo":283512005,
    "descripcion":"HERIDA PUNZANTE DE AXILA"
  },
  {
    "codigo":15927501000119100,
    "descripcion":"SINQUINESIA DE PÁRPADO INFERIOR IZQUIERDO"
  },
  {
    "codigo":1332088007,
    "descripcion":"AMPUTACIÓN PARCIAL TRAUMÁTICA DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":709496008,
    "descripcion":"ÁNGULO DEL PLANO MANDIBULAR INFERIOR"
  },
  {
    "codigo":248909001,
    "descripcion":"ESPASMO DE LOS MÚSCULOS PÉLVICOS ALREDEDOR DE LA VAGINA"
  },
  {
    "codigo":1363021001,
    "descripcion":"ATROFIA DE TRACTO CORTICOESPINAL"
  },
  {
    "codigo":871501004,
    "descripcion":"ALERGIA A ÁCIDO QUENODEOXICÓLICO Y\/O ÁCIDO URSODEOXICÓLICO"
  },
  {
    "codigo":183373009,
    "descripcion":"CONVALECENCIA CONSECUTIVA A QUIMIOTERAPIA"
  },
  {
    "codigo":247074008,
    "descripcion":"CÁPSULA DEL CRISTALINO CLARA EN SEUDOFAQUIA"
  },
  {
    "codigo":15863006,
    "descripcion":"CONFLICTO"
  },
  {
    "codigo":212471007,
    "descripcion":"LESIÓN DE MÚSCULO(S) Y TENDÓN(ES) DE GRUPO MUSCULAR ANTERIOR A NIVEL DE PIERNA"
  },
  {
    "codigo":48631008,
    "descripcion":"PIONEFROSIS"
  },
  {
    "codigo":14028006,
    "descripcion":"ESPESOR ANORMAL"
  },
  {
    "codigo":8551000119100,
    "descripcion":"NEOPLASIA BENIGNA DE ESPACIO EXTRAMEDULAR INTRADURAL ESPINAL"
  },
  {
    "codigo":472780009,
    "descripcion":"OCLUSIÓN ADQUIRIDA DE VENA CAVA INFERIOR"
  },
  {
    "codigo":733089005,
    "descripcion":"SÍNDROME DE PARAPLEJÍA ESPÁSTICA, NEFRITIS Y SORDERA"
  },
  {
    "codigo":12193006,
    "descripcion":"AVULSIÓN DEL OJO"
  },
  {
    "codigo":239734000,
    "descripcion":"CONTRACTURA DE ARTICULACIÓN DE CODO"
  },
  {
    "codigo":403574001,
    "descripcion":"PRURITO POSMENOPÁUSICO"
  },
  {
    "codigo":1073511000119104,
    "descripcion":"ARTRITIS INFECCIOSA DE RODILLA DERECHA"
  },
  {
    "codigo":41291007,
    "descripcion":"ANGIOEDEMA"
  },
  {
    "codigo":237899007,
    "descripcion":"CALCINOSIS SEUDOMOTRIZ"
  },
  {
    "codigo":205131007,
    "descripcion":"POLIDACTILIA CUBITAL DE DEDOS DE LA MANO"
  },
  {
    "codigo":399904002,
    "descripcion":"SÍNDROME DE PIEL RÍGIDA INFANTIL"
  },
  {
    "codigo":72224003,
    "descripcion":"FRACTURA EXPUESTA DE DIÁFISIS DE METACARPIANO"
  },
  {
    "codigo":6688006,
    "descripcion":"AUSENCIA CONGÉNITA DE LA RÓTULA"
  },
  {
    "codigo":268832006,
    "descripcion":"ASPIRACIÓN DE LÍQUIDO O MOCO EN RECIÉN NACIDO"
  },
  {
    "codigo":203296008,
    "descripcion":"OSTEOMIELITIS SUBAGUDA DE COLUMNA VERTEBRAL CERVICAL"
  },
  {
    "codigo":234229000,
    "descripcion":"TRASTORNO DE ELECTRODO DE DESFRIBILADOR CARDÍACO IMPLANTADO"
  },
  {
    "codigo":301600006,
    "descripcion":"CAPAZ DE SUBIR Y BAJAR ESCALERAS SENTADO"
  },
  {
    "codigo":365301004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA CONECTAR Y DESCONECTAR ARTEFACTOS DOMÉSTICOS"
  },
  {
    "codigo":4853005,
    "descripcion":"COITO SECO"
  },
  {
    "codigo":299765006,
    "descripcion":"REFLEJO DE PRENSIÓN PLANTAR PRESENTE"
  },
  {
    "codigo":232394000,
    "descripcion":"SINUSITIS ETMOIDAL POSTERIOR CRÓNICA"
  },
  {
    "codigo":35786001,
    "descripcion":"TUBERCULOMA DE MENINGES"
  },
  {
    "codigo":224435006,
    "descripcion":"INSTALACIONES DE AGUA POTABLE ADECUADAS EN EL TRABAJO"
  },
  {
    "codigo":723914003,
    "descripcion":"TRASTORNO DE DUELO PROLONGADO"
  },
  {
    "codigo":68554004,
    "descripcion":"INTOXICACIÓN POR TRIAZINA"
  },
  {
    "codigo":396234004,
    "descripcion":"ARTRITIS INFECCIOSA"
  },
  {
    "codigo":3018008,
    "descripcion":"HERIDA PENETRANTE DE GLOBO OCULAR CAUSADA POR CUERPO EXTRAÑO MAGNÉTICO"
  },
  {
    "codigo":363466008,
    "descripcion":"NEOPLASIA MALIGNA DE COROIDES"
  },
  {
    "codigo":230559003,
    "descripcion":"NEUROPATÍA HIPERTRÓFICA HEREDITARIA CON PARAPROTEINEMIA"
  },
  {
    "codigo":15710721000119104,
    "descripcion":"DISECCIÓN DE ARTERIA VERTEBRAL IZQUIERDA"
  },
  {
    "codigo":427167008,
    "descripcion":"ANGIOEDEMA HEREDITARIO CON ACTIVIDAD NORMAL DE INHIBIDOR DE ESTERASA C1"
  },
  {
    "codigo":327028001,
    "descripcion":"HIPERTROFIA PUBERAL MASIVA DE LA MAMA"
  },
  {
    "codigo":294260002,
    "descripcion":"ALERGIA A EPOPROSTENOL"
  },
  {
    "codigo":63049000,
    "descripcion":"OSIFICACIÓN NORMAL"
  },
  {
    "codigo":1144393004,
    "descripcion":"HIPOPLASIA CONGÉNITA DE CANAL SEMICIRCULAR"
  },
  {
    "codigo":95817008,
    "descripcion":"CONCUSIÓN LABERÍNTICA"
  },
  {
    "codigo":292425009,
    "descripcion":"REACCIÓN ADVERSA AL BISOPROLOL"
  },
  {
    "codigo":126750002,
    "descripcion":"NEOPLASIA DE VASO SANGUÍNEO DE FOSA POPLÍTEA"
  },
  {
    "codigo":30281009,
    "descripcion":"TRASTORNO DE LA PRÓSTATA"
  },
  {
    "codigo":93982005,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL TABIQUE RECTOVAGINAL"
  },
  {
    "codigo":26611006,
    "descripcion":"PARA 7"
  },
  {
    "codigo":24776000,
    "descripcion":"ENFERMEDAD POR EL VIRUS CARAPARU"
  },
  {
    "codigo":57544002,
    "descripcion":"SÍNDROME DE ANOMALÍAS CONGÉNITAS MÚLTIPLES CAUSADAS POR AGENTES AMBIENTALES NO INFECCIOSOS"
  },
  {
    "codigo":254152004,
    "descripcion":"OSTEÓLISIS DEL TIPO TORG"
  },
  {
    "codigo":1237192005,
    "descripcion":"TRASTORNO FETAL DEBIDO A INFARTO DE PLACENTA"
  },
  {
    "codigo":55709000,
    "descripcion":"ETMOCÉFALO"
  },
  {
    "codigo":286920009,
    "descripcion":"TRASTORNO METABÓLICO DE AMINOÁCIDOS Y CARBOHIDRATOS"
  },
  {
    "codigo":186781003,
    "descripcion":"TIFUS DEL NORTE DE ASIA"
  },
  {
    "codigo":88477005,
    "descripcion":"QUISTE DE DESARROLLO LATERAL DE LA MANDÍBULA"
  },
  {
    "codigo":416157007,
    "descripcion":"DEPRESIÓN COSTAL"
  },
  {
    "codigo":283250003,
    "descripcion":"VIDRIO EN LA MANO"
  },
  {
    "codigo":53874003,
    "descripcion":"PERIENDOCARDITIS AGUDA"
  },
  {
    "codigo":840306007,
    "descripcion":"HIPERTENSIÓN PULMONAR LEVE"
  },
  {
    "codigo":609095001,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: TETUN"
  },
  {
    "codigo":21106009,
    "descripcion":"ENFERMEDAD CAUSADA POR SUIPOXVIRIDAE"
  },
  {
    "codigo":1231687003,
    "descripcion":"HEMORRAGIA VÍTREA DEBIDA A OCLUSIÓN DE RAMA DE VENA RETINIANA"
  },
  {
    "codigo":1297223003,
    "descripcion":"CIERRE DE ÁNGULO PRIMARIO DE OJO IZQUIERDO"
  },
  {
    "codigo":707399006,
    "descripcion":"ADENOCARCINOMA PAPILAR PRIMARIO DE OROFARINGE"
  },
  {
    "codigo":84807007,
    "descripcion":"INFECCIÓN CAUSADA POR MOSGOVOYIA"
  },
  {
    "codigo":1076021000119106,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE TENDÓN FLEXOR DE PIE IZQUIERDO"
  },
  {
    "codigo":246812007,
    "descripcion":"HALLAZGO RELACIONADO CON LOS PÁRPADOS"
  },
  {
    "codigo":1295388007,
    "descripcion":"PRESENCIA POSOPERATORIA DE NEOPLASIA RESIDUAL POSTERIOR A RESECCIÓN DE NEOPLASIA"
  },
  {
    "codigo":212209007,
    "descripcion":"LESIÓN DE LA RAÍZ DEL NERVIO DORSAL - D4"
  },
  {
    "codigo":15601008,
    "descripcion":"HEMÓLISIS INTRAVASCULAR"
  },
  {
    "codigo":112070001,
    "descripcion":"INICIO DE TRABAJO DE PARTO INDUCIDO"
  },
  {
    "codigo":66511000119102,
    "descripcion":"PORTADOR DE TRANSLOCACIÓN CROMOSÓMICA"
  },
  {
    "codigo":79302001,
    "descripcion":"INTOXICACIÓN POR ECHINOPOGON OVATUS"
  },
  {
    "codigo":13766008,
    "descripcion":"TÉTANOS PUERPERAL"
  },
  {
    "codigo":110235001,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO DE LA LENGUA"
  },
  {
    "codigo":1255280005,
    "descripcion":"FRACTURA DE MÚLTIPLES HUESOS TARSIANOS"
  },
  {
    "codigo":403312006,
    "descripcion":"HIPERTRICOSIS EN LA DESNUTRICIÓN"
  },
  {
    "codigo":75632007,
    "descripcion":"ORQUITIS CON ABSCESO"
  },
  {
    "codigo":237637005,
    "descripcion":"HIPOGLUCEMIA NO RELACIONADA CON DIABETES"
  },
  {
    "codigo":792858001,
    "descripcion":"SÍNDROME DE DELIRIO-SEDACIÓN POSINYECCIÓN"
  },
  {
    "codigo":301338002,
    "descripcion":"HALLAZGO RELACIONADO CON EL PERÍMETRO CEFÁLICO"
  },
  {
    "codigo":39194005,
    "descripcion":"EPILEPSIA VISUAL"
  },
  {
    "codigo":233967001,
    "descripcion":"ESTENOSIS DE LA ARTERIA ILÍACA COMÚN"
  },
  {
    "codigo":365039003,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA HABLAR"
  },
  {
    "codigo":397807004,
    "descripcion":"EQUIPO NO DISPONIBLE"
  },
  {
    "codigo":35524003,
    "descripcion":"ARTROPATÍA ASOCIADA CON OTRA ENFERMEDAD"
  },
  {
    "codigo":232132005,
    "descripcion":"HIPERMETROPÍA DE ÍNDICE"
  },
  {
    "codigo":363204006,
    "descripcion":"TRASTORNO METABÓLICO FETAL"
  },
  {
    "codigo":263065002,
    "descripcion":"FRACTURA-LUXACIÓN DE ARTICULACIÓN COSTOVERTEBRAL"
  },
  {
    "codigo":230297002,
    "descripcion":"ATROFIA SISTÉMICA MÚLTIPLE"
  },
  {
    "codigo":721817004,
    "descripcion":"TRASTORNO DE RIÑÓN Y\/O URÉTER CAUSADO POR SCHISTOSOMA HAEMATOBIUM"
  },
  {
    "codigo":293998001,
    "descripcion":"ALERGIA A ISRADIPINO"
  },
  {
    "codigo":1091221000119100,
    "descripcion":"DIVISIÓN CONGÉNITA DE LÓBULO DE LA OREJA DERECHA"
  },
  {
    "codigo":95555006,
    "descripcion":"DAÑO HEPATOCELULAR NEONATAL"
  },
  {
    "codigo":193859006,
    "descripcion":"CONJUNTIVITIS SEROSA"
  },
  {
    "codigo":292163006,
    "descripcion":"REACCIÓN ADVERSA A LOS ANESTÉSICOS ENDOVENOSOS"
  },
  {
    "codigo":161091009,
    "descripcion":"VIAJE AL EXTRANJERO DE VACACIONES"
  },
  {
    "codigo":192024003,
    "descripcion":"ENCOPRESIS CONTINUA NO ORGÁNICA"
  },
  {
    "codigo":126488004,
    "descripcion":"NEOPLASIA DE LA PIEL"
  },
  {
    "codigo":93720005,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE MÉDULA ÓSEA"
  },
  {
    "codigo":1142296006,
    "descripcion":"CRECIMIENTO DE CEJA HACIA PÁRPADO SUPERIOR"
  },
  {
    "codigo":60952007,
    "descripcion":"DEFICIENCIA DE UROCANATO HIDRATASA"
  },
  {
    "codigo":714477000,
    "descripcion":"GINGIVITIS SEVERA"
  },
  {
    "codigo":91885001,
    "descripcion":"AUSENCIA CONGÉNITA DE HUESO FRONTAL"
  },
  {
    "codigo":16125341000119100,
    "descripcion":"DERRAME INTERMITENTE DE ARTICULACIÓN DE AMBOS TOBILLOS"
  },
  {
    "codigo":253890001,
    "descripcion":"URÉTER ECTÓPICO CRUZADO"
  },
  {
    "codigo":1204162009,
    "descripcion":"ESTENOSIS DE ARTERIA CEREBRAL ANTERIOR ASINTOMÁTICA"
  },
  {
    "codigo":24514009,
    "descripcion":"GRADO DE GLEASON: 10"
  },
  {
    "codigo":448663003,
    "descripcion":"LINFOMA NO HODGKIN DIFUSO DE ESTÓMAGO"
  },
  {
    "codigo":284823005,
    "descripcion":"INCAPAZ DE ARRODILLARSE EN LA BAÑERA"
  },
  {
    "codigo":250220000,
    "descripcion":"HALLAZGO RELACIONADO CON LA HEMOGLOBINA"
  },
  {
    "codigo":282988001,
    "descripcion":"NO VOLTEA"
  },
  {
    "codigo":86380000,
    "descripcion":"DEDOS DEL PIE EN GARRA ADQUIRIDOS"
  },
  {
    "codigo":1003884001,
    "descripcion":"CATARATA PULVERULENTA"
  },
  {
    "codigo":1264193000,
    "descripcion":"PIGMENTACIÓN LOCAL EXÓGENA DE MUCOSA YUGAL DERECHA"
  },
  {
    "codigo":215617000,
    "descripcion":"QUEILITIS GRANULOMATOSA DE MIESCHER-MELKERSSON-ROSENTHAL"
  },
  {
    "codigo":248385002,
    "descripcion":"FONTANELA APLANADA"
  },
  {
    "codigo":51777006,
    "descripcion":"DÉFICIT EN EL AUTOCONTROL DEL DOLOR, CRÓNICO"
  },
  {
    "codigo":288311000119103,
    "descripcion":"CONDUCTA HOMOSEXUAL DE ALTO RIESGO"
  },
  {
    "codigo":82710007,
    "descripcion":"QUERATITIS MICÓTICA CAUSADA POR FUSARIUM OXYSPORUM"
  },
  {
    "codigo":1196822009,
    "descripcion":"LIPOMA DE INTESTINO DELGADO"
  },
  {
    "codigo":30301000175100,
    "descripcion":"ÚLCERA POR PRESIÓN EN CODO IZQUIERDO, ESTADIO IV"
  },
  {
    "codigo":80875006,
    "descripcion":"ANEMIA ACLORHÍDRICA"
  },
  {
    "codigo":211947008,
    "descripcion":"CORROSIÓN DE PRIMER GARDO DE MUÑECA Y MANO"
  },
  {
    "codigo":79040006,
    "descripcion":"QUISTE ESPLÉNICO"
  },
  {
    "codigo":13504006,
    "descripcion":"ESOFAGITIS POR PÍLDORAS"
  },
  {
    "codigo":46272008,
    "descripcion":"FRACTURA EXPUESTA DE HUESO INNOMINADO"
  },
  {
    "codigo":44437005,
    "descripcion":"TROMBO DE CUERPO CAVERNOSO DE PENE"
  },
  {
    "codigo":1255018002,
    "descripcion":"DEPENDENCIA COMBINADA DE SUSTANCIA OPIOIDE Y NO OPIOIDE, CONTINUA"
  },
  {
    "codigo":697962004,
    "descripcion":"HIPERPLASIA HEMIFACIAL"
  },
  {
    "codigo":271978005,
    "descripcion":"TRASTORNO DE INJERTO DE MÚSCULO"
  },
  {
    "codigo":403050005,
    "descripcion":"TIÑA DE LA MANO CAUSADA POR TRICHOPHYTON RUBRUM"
  },
  {
    "codigo":763498007,
    "descripcion":"LABIO LEPORINO IZQUIERDO INCOMPLETO Y FISURA ALVEOLAR IZQUIERDA INCOMPLETA"
  },
  {
    "codigo":1081041000119103,
    "descripcion":"CARCINOMA DE CÉLULAS DE MERKEL PRIMARIO DE PIEL DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":239210009,
    "descripcion":"EXPANSOR TISULAR INFECTADO"
  },
  {
    "codigo":302911003,
    "descripcion":"AMIGDALITIS LINGUAL AGUDA"
  },
  {
    "codigo":366612002,
    "descripcion":"PRUEBA DE EXTENSIÓN DINÁMICA - HALLAZGO"
  },
  {
    "codigo":1251348004,
    "descripcion":"LIQUEN ESCLEROSO Y MORFEA EXTRAGENITALES"
  },
  {
    "codigo":233705000,
    "descripcion":"EDEMA PULMONAR NEUROGÉNICO"
  },
  {
    "codigo":102633001,
    "descripcion":"ORTODEOXIA"
  },
  {
    "codigo":37097005,
    "descripcion":"ERITROBLASTOSIS"
  },
  {
    "codigo":364777007,
    "descripcion":"HALLAZGO EN LAS CAPACIDADES DE NUTRICIÓN \/ ALIMENTACIÓN \/ BEBIDA"
  },
  {
    "codigo":723390000,
    "descripcion":"DEMENCIA RÁPIDAMENTE PROGRESIVA"
  },
  {
    "codigo":200937007,
    "descripcion":"LUPUS ERITEMATOSO CRÓNICO"
  },
  {
    "codigo":299241007,
    "descripcion":"AMPLITUD DE FLEXIÓN ACTIVA DE LA CADERA NORMAL"
  },
  {
    "codigo":1149374003,
    "descripcion":"SOBREDOSIS DE DEXTROPROPOXIFENO Y\/O PARACETAMOL"
  },
  {
    "codigo":343761000119108,
    "descripcion":"RETINOPATÍA BILATERAL POR PREMATUREZ ETAPA 2 - CRESTA INTRARRETINIANA"
  },
  {
    "codigo":788926002,
    "descripcion":"MUTILACIÓN DE GENITALES FEMENINOS TIPO 2C"
  },
  {
    "codigo":231870008,
    "descripcion":"TELANGIECTASIA DE LA CONJUNTIVA"
  },
  {
    "codigo":262803000,
    "descripcion":"SECCIÓN DEL HÍGADO"
  },
  {
    "codigo":787091002,
    "descripcion":"ADENOCARCINOMA DE HÍGADO Y VÍA BILIAR INTRAHEPÁTICA"
  },
  {
    "codigo":721555001,
    "descripcion":"LINFOMA FOLICULAR DE INTESTINO DELGADO"
  },
  {
    "codigo":41881000087102,
    "descripcion":"CONTUSIÓN DE EXTREMIDAD INFERIOR IZQUIERDA"
  },
  {
    "codigo":295571009,
    "descripcion":"SOBREDOSIS DE BENZOCAÍNA"
  },
  {
    "codigo":129896002,
    "descripcion":"HALLAZGO EN LA RESPIRACIÓN ARTIFICIAL"
  },
  {
    "codigo":44441000087107,
    "descripcion":"HERIDA PUNZANTE DE PIE IZQUIERDO CON CUERPO EXTRAÑO"
  },
  {
    "codigo":39321000087108,
    "descripcion":"HERIDA PUNZANTE DE DEDO PULGAR DERECHO CON CUERPO EXTRAÑO"
  },
  {
    "codigo":293736005,
    "descripcion":"ALERGIA A LENOGRASTIM"
  },
  {
    "codigo":47001000087108,
    "descripcion":"FRACTURA DE FALANGE PROXIMAL DE ÍNDICE IZQUIERDO"
  },
  {
    "codigo":95293000,
    "descripcion":"VÉRTEBRA CERVICAL SUPERNUMERARIA"
  },
  {
    "codigo":783421002,
    "descripcion":"ANEURISMA DE ARTERIA COMUNICANTE POSTERIOR"
  },
  {
    "codigo":29757004,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN LA REGIÓN DEL PIE, SIN INFECCIÓN"
  },
  {
    "codigo":128061008,
    "descripcion":"DEFICIENCIA EN EL CRECIMIENTO LONGITUDINAL DEL PIE"
  },
  {
    "codigo":160829008,
    "descripcion":"VIOLENCIA ENTRE LOS PADRES"
  },
  {
    "codigo":1142034002,
    "descripcion":"LESIÓN TRAUMÁTICA EN RECIÉN NACIDO POR ESCALDADURA"
  },
  {
    "codigo":716050002,
    "descripcion":"PARO CARDÍACO DURANTE INTERVENCIÓN QUIRÚRGICA"
  },
  {
    "codigo":93458008,
    "descripcion":"CUERPO EXTRAÑO EN LA PIEL"
  },
  {
    "codigo":290066009,
    "descripcion":"MAMA PIGMENTADA"
  },
  {
    "codigo":1304039005,
    "descripcion":"PATRÓN NOCIVO DE USO DE HEROÍNA"
  },
  {
    "codigo":286396000,
    "descripcion":"NO UTILIZA ADECUADAMENTE EL LENGUAJE"
  },
  {
    "codigo":91623008,
    "descripcion":"HIDROA HERPETIFORME"
  },
  {
    "codigo":253628002,
    "descripcion":"TRONCO PULMONAR AUSENTE CON ARTERIAS PULMONARES NO CONFLUENTES"
  },
  {
    "codigo":57020009,
    "descripcion":"ENFERMEDAD DE STOKVIS"
  },
  {
    "codigo":448401007,
    "descripcion":"CORIOCARCINOMA DE PLACENTA"
  },
  {
    "codigo":346271000119102,
    "descripcion":"FIBROSIS SUBRETINIANA DIFUSA DE AMBOS OJOS"
  },
  {
    "codigo":315494001,
    "descripcion":"NACIDO EN NORUEGA"
  },
  {
    "codigo":282726006,
    "descripcion":"HERIDA PENETRANTE DE PULMÓN"
  },
  {
    "codigo":248123000,
    "descripcion":"PATRÓN DE INGESTA EXCESIVA Y VÓMITO"
  },
  {
    "codigo":1231163004,
    "descripcion":"DEPENDENCIA DE ANSIOLÍTICO, CONTINUA"
  },
  {
    "codigo":706875005,
    "descripcion":"SUMINISTRO DE ALIMENTOS INSUFICIENTE"
  },
  {
    "codigo":1296699007,
    "descripcion":"HIPERTENSIÓN OCULAR DE OJO IZQUIERDO DEBIDA A PRESIÓN VENOSA EPIESCLERAL AUMENTADA"
  },
  {
    "codigo":1263931009,
    "descripcion":"EQUIMOSIS NEONATAL"
  },
  {
    "codigo":705040002,
    "descripcion":"CONSENTIMIENTO OTORGADO PARA EL PASE DE GUARDIA AL LADO DE LA CAMA DEL PACIENTE"
  },
  {
    "codigo":279056004,
    "descripcion":"DOLOR DURANTE LA PENETRACIÓN"
  },
  {
    "codigo":49680006,
    "descripcion":"ABSORCIÓN INTESTINAL NORMAL"
  },
  {
    "codigo":15720761000119100,
    "descripcion":"LUXACIÓN PATOLÓGICA DE CADERA DERECHA"
  },
  {
    "codigo":277221003,
    "descripcion":"MUCOSA NASAL TUMEFACTA"
  },
  {
    "codigo":703205008,
    "descripcion":"OCLUSIÓN ASINTOMÁTICA DE ARTERIA CEREBRAL POSTERIOR"
  },
  {
    "codigo":308154003,
    "descripcion":"HEMATOMA DE VAINA DEL MÚSCULO RECTO ABDOMINAL"
  },
  {
    "codigo":111546006,
    "descripcion":"DISFUNCIÓN POLIGLANDULAR"
  },
  {
    "codigo":78778007,
    "descripcion":"ADHERENCIAS DEL IRIS"
  },
  {
    "codigo":275386008,
    "descripcion":"BEBEDOR EXCESIVO DE CAFÉ"
  },
  {
    "codigo":371855002,
    "descripcion":"PARED VENTRICULAR HIPERCINÉTICA"
  },
  {
    "codigo":699535005,
    "descripcion":"LESIÓN TRAUMÁTICA POR HIPERFLEXIÓN"
  },
  {
    "codigo":109711006,
    "descripcion":"ALVÉOLO DENTAL ANORMAL"
  },
  {
    "codigo":240783007,
    "descripcion":"INFECCIÓN POR CONIDIOBOLUS"
  },
  {
    "codigo":1156452003,
    "descripcion":"GERMINOMA MIXTO"
  },
  {
    "codigo":402788005,
    "descripcion":"TRASTORNO GENÉTICO DEL DEPÓSITO DE LÍPIDOS"
  },
  {
    "codigo":1287524006,
    "descripcion":"SÍNDROME DE STEVENS-JOHNSON FOTOINDUCIDO"
  },
  {
    "codigo":204345002,
    "descripcion":"FUSIÓN CONGÉNITA DE CÚSPIDES DE VÁLVULA PULMONAR"
  },
  {
    "codigo":1285689005,
    "descripcion":"ANOMALÍA CONGÉNITA DE VENA RENAL IZQUIERDA"
  },
  {
    "codigo":400953008,
    "descripcion":"INVERSIÓN CONGÉNITA DE PÁRPADO SUPERIOR"
  },
  {
    "codigo":237113009,
    "descripcion":"PROLAPSO DE LA BÓVEDA VAGINAL"
  },
  {
    "codigo":300814004,
    "descripcion":"CAPAZ DE CUIDAR UNA MASCOTA"
  },
  {
    "codigo":202510005,
    "descripcion":"RIGIDECES ARTICULARES MÚLTIPLES"
  },
  {
    "codigo":366350004,
    "descripcion":"TEMPERATURA MAMARIA - HALLAZGO"
  },
  {
    "codigo":298979001,
    "descripcion":"SIN AMPLITUD DE ABDUCCIÓN PASIVA DE ARTICULACIÓN DE MUÑECA"
  },
  {
    "codigo":428216000,
    "descripcion":"ASTILLA DE MADERA EN LA FARINGE"
  },
  {
    "codigo":723128005,
    "descripcion":"SECUELA POSTERIOR A CONVULSIÓN"
  },
  {
    "codigo":453361000124103,
    "descripcion":"RETROVERSIÓN CONGÉNITA DE FÉMUR IZQUIERDO"
  },
  {
    "codigo":241000124106,
    "descripcion":"ESTADO DE MEDICIÓN DE DESEMPEÑO"
  },
  {
    "codigo":65933003,
    "descripcion":"HIDRONEUMOTÓRAX"
  },
  {
    "codigo":262541004,
    "descripcion":"LACERACIÓN SUPERFICIAL"
  },
  {
    "codigo":721293007,
    "descripcion":"DIVERTÍCULO DE TROMPA DE EUSTAQUIO"
  },
  {
    "codigo":129634000,
    "descripcion":"SÍNDROME DE HIPOGONADISMO INDUCIDO EN EL HOMBRE"
  },
  {
    "codigo":295309008,
    "descripcion":"SOBREDOSIS INTENCIONAL DE TOLMETINA"
  },
  {
    "codigo":1145442003,
    "descripcion":"HIPOPLASIA CONGÉNITA DE OMÓPLATO"
  },
  {
    "codigo":162402004,
    "descripcion":"SENOS PARANASALES OBSTRUIDOS"
  },
  {
    "codigo":783159001,
    "descripcion":"SÍNDROME DE HOLZGREVE"
  },
  {
    "codigo":226103003,
    "descripcion":"DIETA CON ALTO CONTENIDO DE ÁCIDOS GRASOS N-3 POLINSATURADOS"
  },
  {
    "codigo":291639004,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR SULFADIAZINA"
  },
  {
    "codigo":95031007,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL LÓBULO INFERIOR DERECHO DEL PULMÓN"
  },
  {
    "codigo":29495008,
    "descripcion":"ANEURISMA DE ARTERIA DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":715788001,
    "descripcion":"MIOTONÍA FLUCTUANTE"
  },
  {
    "codigo":10834541000119105,
    "descripcion":"FRACTURA EXPUESTA DE FALANGE PROXIMAL DE DEDO ÍNDICE DE MANO DERECHA"
  },
  {
    "codigo":1141772003,
    "descripcion":"TEMBLOR POSTURAL DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":125964004,
    "descripcion":"CONDUCTO ARTERIOSO PERSISTENTE CON DERIVACIÓN DE DERECHA A IZQUIERDA"
  },
  {
    "codigo":124129001,
    "descripcion":"DEFICIENCIA DE FOSFOGLUCONATO DESHIDROGENASA (DESCARBOXILANTE)"
  },
  {
    "codigo":322311000119101,
    "descripcion":"HIPERTROFIA DE MEMBRANA SINOVIAL DE ARTICULACIÓN GLENOHUMERAL IZQUIERDA"
  },
  {
    "codigo":58593005,
    "descripcion":"MOVIMIENTO ATETÓSICO"
  },
  {
    "codigo":1172705006,
    "descripcion":"SÍNDROME LETAL DE HIDRANENCEFALIA, HERNIA DIAFRAGMÁTICA"
  },
  {
    "codigo":253366007,
    "descripcion":"DEFECTO DEL TABIQUE INTERAURICULAR"
  },
  {
    "codigo":187830009,
    "descripcion":"NEOPLASIA MALIGNA DE CORNETE NASAL"
  },
  {
    "codigo":251531002,
    "descripcion":"ACTIVIDAD CONTINUA DE LA UNIDAD MOTORA"
  },
  {
    "codigo":448139005,
    "descripcion":"FIBROSARCOMA DE TEJIDO CONJUNTIVO"
  },
  {
    "codigo":1300107007,
    "descripcion":"COMPLETÓ PROGRAMA EN CENTRO DE APRENDIZAJE PARA ADULTOS"
  },
  {
    "codigo":773984007,
    "descripcion":"SÍNDROME DE PIEBALDISMO Y NEUROPATÍAS"
  },
  {
    "codigo":184160008,
    "descripcion":"SUPERVISIÓN INFANTIL REGISTRADA"
  },
  {
    "codigo":249696007,
    "descripcion":"COSTILLA CORTA"
  },
  {
    "codigo":70835005,
    "descripcion":"TRASTORNO DE LOS GANGLIOS BASALES"
  },
  {
    "codigo":772149003,
    "descripcion":"HERNIA INGUINAL BILATERAL RECURRENTE OBSTRUIDA"
  },
  {
    "codigo":247861003,
    "descripcion":"MIEDO A LA ANESTESIA LOCAL"
  },
  {
    "codigo":313397006,
    "descripcion":"TRANSPIRACIÓN - HALLAZGO"
  },
  {
    "codigo":213258001,
    "descripcion":"SHOCK HIPOVOLÉMICO POSOPERATORIO"
  },
  {
    "codigo":442634006,
    "descripcion":"FUNCIÓN PANCREÁTICA FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":47583008,
    "descripcion":"ANOMALÍA CONGÉNITA DE LA PELVIS"
  },
  {
    "codigo":78516000,
    "descripcion":"FRACTURA DE ESTERNÓN"
  },
  {
    "codigo":768479008,
    "descripcion":"HIFAS ANGOSTAS DEL REINO FUNGI DETECTADAS"
  },
  {
    "codigo":307892003,
    "descripcion":"ESTADO DE LA HISTORIA CLÍNICA"
  },
  {
    "codigo":373428006,
    "descripcion":"EDEMA DEL EPITELIO CORNEAL"
  },
  {
    "codigo":209588009,
    "descripcion":"DESGARRO COMPLETO SUPERFICIAL DE LIGAMENTO RADIOCARPIANO PALMAR"
  },
  {
    "codigo":50081000119107,
    "descripcion":"MASA DE BAZO"
  },
  {
    "codigo":11145003,
    "descripcion":"ATAXIA EN UNA SOLA EXTREMIDAD"
  },
  {
    "codigo":207753003,
    "descripcion":"FRACTURA NO EXPUESTA DE MAXILAR INFERIOR"
  },
  {
    "codigo":764809005,
    "descripcion":"HERNIA CRURAL DERECHA IRREDUCTIBLE"
  },
  {
    "codigo":109449006,
    "descripcion":"DIENTE PERMANENTE SUPERNUMERARIO"
  },
  {
    "codigo":240521009,
    "descripcion":"FIEBRE POR RHABDOVIRUS TRANSMITIDA POR EL MOSQUITO SIMÚLIDO"
  },
  {
    "codigo":15696801000119109,
    "descripcion":"OSTEOMIELITIS DE AMBOS PIES"
  },
  {
    "codigo":402526009,
    "descripcion":"CARCINOMA BASOCELULAR TIPO FOLICULAR"
  },
  {
    "codigo":336691000119100,
    "descripcion":"BLEBITIS POSTERIOR A PROCEDIMIENTO"
  },
  {
    "codigo":1187123005,
    "descripcion":"LEUCEMIA AGUDA DE FENOTIPO MIXTO"
  },
  {
    "codigo":10947891000119102,
    "descripcion":"HERIDA ABIERTA DE DEDO ANULAR DE MANO IZQUIERDA DEBIDA A MORDEDURA DE ANIMAL"
  },
  {
    "codigo":341811000119103,
    "descripcion":"PTERIGIÓN CENTRAL DE OJO IZQUIERDO"
  },
  {
    "codigo":318771000119104,
    "descripcion":"TENDINITIS DE TENDÓN DEL MÚSCULO PSOAS IZQUIERDO"
  },
  {
    "codigo":21811000119104,
    "descripcion":"VÍA AÉREA FARÍNGEA ESTRECHA"
  },
  {
    "codigo":202248001,
    "descripcion":"SUBLUXACIÓN RECURRENTE DE LA RÓTULA"
  },
  {
    "codigo":679731000119107,
    "descripcion":"SÍNDROME DE TOLOSA-HUNT DE OJO IZQUIERDO"
  },
  {
    "codigo":111411000119103,
    "descripcion":"ENFERMEDAD RENAL EN ESTADIO TERMINAL DEBIDA A HIPERTENSIÓN"
  },
  {
    "codigo":12081971000119109,
    "descripcion":"QUEMADURA DE REGIÓN DEL OJO DERECHO"
  },
  {
    "codigo":366088006,
    "descripcion":"MOVIMIENTO OCULAR REFLEJO - HALLAZGO"
  },
  {
    "codigo":1076531000119102,
    "descripcion":"BURSITIS ESCAPULOTORÁCICA DE HOMBRO DERECHO"
  },
  {
    "codigo":169480006,
    "descripcion":"DISPOSITIVO ANTICONCEPTIVO INTRAUTERINO CONTROLADO - SIN PROBLEMAS"
  },
  {
    "codigo":724701001,
    "descripcion":"ABSTINENCIA DE DROGA INHALANTE VOLÁTIL"
  },
  {
    "codigo":890376009,
    "descripcion":"FÍSTULA ARTERIOVENOSA CONGÉNITA DE VASOS SANGUÍNEOS DEL CORDÓN UMBILICAL"
  },
  {
    "codigo":298717003,
    "descripcion":"HALLAZGO RELACIONADO CON MEDICIONES DEL TÓRAX"
  },
  {
    "codigo":11777331000119107,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO TRÍCEPS BRAQUIAL IZQUIERDO"
  },
  {
    "codigo":300552007,
    "descripcion":"OVULACIÓN - HALLAZGO"
  },
  {
    "codigo":11808051000119109,
    "descripcion":"RUPTURA TRAUMÁTICA DE LIGAMENTO DE ARTICULACIÓN DE MUÑECA DERECHA"
  },
  {
    "codigo":823005007,
    "descripcion":"CABELLO FINO Y SEDOSO"
  },
  {
    "codigo":722866000,
    "descripcion":"ESTEATOSIS DE HÍGADO ASOCIADA A DISFUNCIÓN METABÓLICA"
  },
  {
    "codigo":34738001,
    "descripcion":"REACCIÓN Y\/O INTOXICACIÓN POR DROGAS ESPECÍFICA DEL RECIÉN NACIDO"
  },
  {
    "codigo":11793621000119101,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO DE DEDO DE PIE DERECHO (SEGUNDO A QUINTO)"
  },
  {
    "codigo":351291000119108,
    "descripcion":"NEOPLASIA BENIGNA DE URÉTER DERECHO"
  },
  {
    "codigo":11820091000119109,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN RADIOCUBITAL DISTAL IZQUIERDA"
  },
  {
    "codigo":296882002,
    "descripcion":"SOBREDOSIS DE ANABÓLICO ESTEROIDE"
  },
  {
    "codigo":1179783000,
    "descripcion":"COPROPORFIRINA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":194908003,
    "descripcion":"PERICARDITIS TUBERCULOSA AGUDA"
  },
  {
    "codigo":424284003,
    "descripcion":"OLOR FÉTIDO AMBIENTAL"
  },
  {
    "codigo":293212007,
    "descripcion":"REACCIÓN ADVERSA A LA HIDROXIPROGESTERONA"
  },
  {
    "codigo":719196008,
    "descripcion":"PROMINENCIA ANORMAL DE CRESTA ILÍACA"
  },
  {
    "codigo":225841001,
    "descripcion":"RESPETA A LOS DEMÁS"
  },
  {
    "codigo":193073001,
    "descripcion":"QUISTE DE MENINGES ESPINALES"
  },
  {
    "codigo":63836009,
    "descripcion":"GRUPO VOCAL"
  },
  {
    "codigo":94769004,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE BRONQUIO DEL LÓBULO INFERIOR IZQUIERDO DEL PULMÓN"
  },
  {
    "codigo":1208881008,
    "descripcion":"SÍNDROME DE QT PROLONGADO TIPO 11"
  },
  {
    "codigo":715526002,
    "descripcion":"ESTOMATOCITOSIS HEREDITARIA DESHIDRATADA"
  },
  {
    "codigo":92934006,
    "descripcion":"FORMA ANORMAL CONGÉNITA DEL PALADAR RUGOSO"
  },
  {
    "codigo":1010438008,
    "descripcion":"DESCENSO DE LA MITAD DERECHA DEL DIAFRAGMA"
  },
  {
    "codigo":420614009,
    "descripcion":"DEMENCIA ORGÁNICA CON SIDA (SÍNDROME DE INMUNODEFICIENCIA ADQUIRIDA)"
  },
  {
    "codigo":418779002,
    "descripcion":"ALERGIA A TOMATE"
  },
  {
    "codigo":713691005,
    "descripcion":"TRASTORNO DEL TRACTO GASTROINTESTINAL CAUSADO POR FÁRMACO ANTIRRETROVIRAL"
  },
  {
    "codigo":254939008,
    "descripcion":"EPENDIMOMA CEREBRAL"
  },
  {
    "codigo":253104000,
    "descripcion":"ENCEFALOCELE FRONTOETMOIDAL"
  },
  {
    "codigo":449712003,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE PIERNA"
  },
  {
    "codigo":285872005,
    "descripcion":"DIFICULTAD PARA USAR EL LAVARROPAS"
  },
  {
    "codigo":23728006,
    "descripcion":"PARÁLISIS BILATERAL PARCIAL"
  },
  {
    "codigo":710021001,
    "descripcion":"MORFOLOGÍA DE CRESTA ALVEOLAR RESIDUAL DE MAXILAR SUPERIOR CON RESISTENCIA MÍNIMA A LA BÓVEDA PALATINA"
  },
  {
    "codigo":251269006,
    "descripcion":"PATRÓN DE MARCAPASOS CARDÍACO INEFECTIVO"
  },
  {
    "codigo":21893008,
    "descripcion":"MANO VALGA"
  },
  {
    "codigo":314970000,
    "descripcion":"RECIDIVA LOCAL DE NEOPLASIA MALIGNA DE CUELLO UTERINO"
  },
  {
    "codigo":353801000119102,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA COROIDES DEL OJO DERECHO"
  },
  {
    "codigo":249434004,
    "descripcion":"CICATRIZ DE TRAQUEOSTOMÍA"
  },
  {
    "codigo":247599000,
    "descripcion":"OLVIDA LO QUE ACABA DE VER"
  },
  {
    "codigo":216666009,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR PINTURAS SIN PLOMO"
  },
  {
    "codigo":83759003,
    "descripcion":"DISFONÍA ESPÁSTICA DE TIPO ADUCTOR POR REACCIÓN A LA TENSIÓN MUSCULOESQUELÉTICA"
  },
  {
    "codigo":278532000,
    "descripcion":"HEMIMELIA - A NIVEL DE LA RODILLA"
  },
  {
    "codigo":11822601000119105,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN AXILA DERECHA CON INFECCIÓN"
  },
  {
    "codigo":737284009,
    "descripcion":"IMPLANTE MANDIBULAR IN SITU"
  },
  {
    "codigo":442372009,
    "descripcion":"DISTENSIÓN DE MÚSCULO Y\/O TENDÓN DE MUSLO"
  },
  {
    "codigo":1091081000119107,
    "descripcion":"OTITIS EXTERNA CRÓNICA DE CONDUCTO AUDITIVO EXTERNO DERECHO CAUSADA POR HONGO"
  },
  {
    "codigo":309465005,
    "descripcion":"INFECCIÓN POR VIRUS VARICELA ZÓSTER"
  },
  {
    "codigo":735449006,
    "descripcion":"REACCIÓN DE HIPERSENSIBILIDAD CAUSADA POR ALIMENTO"
  },
  {
    "codigo":276697006,
    "descripcion":"CAMBIO EN LA ICTIOSIS TIPO ARLEQUÍN"
  },
  {
    "codigo":1259737006,
    "descripcion":"ADAMANTINOMA PRIMARIO DE TIBIA"
  },
  {
    "codigo":284979006,
    "descripcion":"CAPAZ DE CALZARSE"
  },
  {
    "codigo":209326009,
    "descripcion":"FRACTURA-SUBLUXACIÓN EXPUESTA DE DEDO"
  },
  {
    "codigo":404099002,
    "descripcion":"METAPLASIA SINOVIAL CUTÁNEA"
  },
  {
    "codigo":10883005,
    "descripcion":"QUISTE GINGIVAL DEL ADULTO"
  },
  {
    "codigo":305795007,
    "descripcion":"VISTO POR EL SERVICIO DE PLANIFICACIÓN FAMILIAR"
  },
  {
    "codigo":699011008,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR AGENTE PSICOTRÓPICO"
  },
  {
    "codigo":43651009,
    "descripcion":"ESTENOSIS ADQUIRIDA DE VAGINA QUE AFECTA EL EMBARAZO"
  },
  {
    "codigo":271192000,
    "descripcion":"AMPOLLA TRAUMÁTICA DE DEDO DEL PIE, INFECTADA"
  },
  {
    "codigo":238424004,
    "descripcion":"INFECCIÓN DE LA PIEL POR CORINEBACTERIUM PYOGENES"
  },
  {
    "codigo":41816006,
    "descripcion":"CRIOFIBRINOGENEMIA SECUNDARIA"
  },
  {
    "codigo":402264007,
    "descripcion":"DERMATITIS IRRITATIVA DE CONTACTO CAUSADA POR ANILLO"
  },
  {
    "codigo":369496007,
    "descripcion":"TUMOR MALIGNO QUE COMPROMETE EL CUERPO UTERINO POR PROPAGACIÓN DIRECTA DE LA VAGINA"
  },
  {
    "codigo":1186861004,
    "descripcion":"NEURODEGENERACIÓN ASOCIADA A PANTOTENATO CINASA, FORMA CLÁSICA"
  },
  {
    "codigo":105517004,
    "descripcion":"DESAVENENCIA CON LOS ALUMNOS"
  },
  {
    "codigo":236589004,
    "descripcion":"GLOMERULOPATÍA DEL TRASPLANTE - FORMA TARDÍA"
  },
  {
    "codigo":300290000,
    "descripcion":"REFLUJO GÁSTRICO EXCESIVO"
  },
  {
    "codigo":365826001,
    "descripcion":"HALLAZGO RELATIVO A LAS FACULTADES INTELECTUALES"
  },
  {
    "codigo":890114008,
    "descripcion":"IRITIS PAPULOSA POR TREPONEMA PALLIDUM"
  },
  {
    "codigo":724439005,
    "descripcion":"EMBOLIA MICROVASCULAR DE ARTERIOLA"
  },
  {
    "codigo":36311007,
    "descripcion":"EDEMA DE LA VULVA"
  },
  {
    "codigo":200151008,
    "descripcion":"CESÁREA LUEGO DE CESÁREA PREVIA"
  },
  {
    "codigo":394924000,
    "descripcion":"SÍNTOMAS DE DEPRESIÓN"
  },
  {
    "codigo":722604002,
    "descripcion":"DISPLASIA DE PAPILA ÓPTICA"
  },
  {
    "codigo":427692005,
    "descripcion":"ABSCESO SUBPERIÓSTICO DE ÓRBITA"
  },
  {
    "codigo":1148588005,
    "descripcion":"HALLAZGO RELACIONADO CON PH DE SANGRE ARTERIAL"
  },
  {
    "codigo":198316006,
    "descripcion":"HIPERTROFIA DE ÚTERO"
  },
  {
    "codigo":34476008,
    "descripcion":"ENCEFALITIS VIRAL"
  },
  {
    "codigo":296620005,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE CLARITROMICINA"
  },
  {
    "codigo":10678231000119101,
    "descripcion":"TUMEFACCIÓN LOCALIZADA DE DEDOS DE AMBOS PIES"
  },
  {
    "codigo":1343361004,
    "descripcion":"ACCESO DIGITAL INADECUADO DEBIDO A RECURSOS ECONÓMICOS LIMITADOS PARA DISPONER DE DISPOSITIVO DIGITAL"
  },
  {
    "codigo":65409004,
    "descripcion":"COMPLICACIÓN OBSTÉTRICA POR LA ANESTESIA"
  },
  {
    "codigo":425857004,
    "descripcion":"EVIDENCIA DE RECONSTITUCIÓN INMUNOLÓGICA"
  },
  {
    "codigo":1144918001,
    "descripcion":"PROTEINURIA DE BENCE JONES INTERMITENTE"
  },
  {
    "codigo":292950001,
    "descripcion":"REACCIÓN ADVERSA A ENOXACINO"
  },
  {
    "codigo":683991000119103,
    "descripcion":"CARCINOMA MICROCÍTICO PRIMARIO EN ESTADIO EXTENSIVO DE PULMÓN"
  },
  {
    "codigo":30806007,
    "descripcion":"ABORTO ESPONTÁNEO CON ENDOMETRITIS"
  },
  {
    "codigo":192811002,
    "descripcion":"ENCEFALOPATÍA ALCOHÓLICA"
  },
  {
    "codigo":94507002,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE SENO PIRIFORME"
  },
  {
    "codigo":225579004,
    "descripcion":"INGIERE LÍQUIDOS"
  },
  {
    "codigo":291115005,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR BUSPIRONA"
  },
  {
    "codigo":127275008,
    "descripcion":"LESIÓN TRAUMÁTICA DEL APARATO RESPIRATORIO"
  },
  {
    "codigo":289280001,
    "descripcion":"PLACENTA PATOLÓGICA"
  },
  {
    "codigo":92672004,
    "descripcion":"CARCINOMA IN SITU DE PÁNCREAS"
  },
  {
    "codigo":1336021000,
    "descripcion":"QUISTE DE GLOBO OCULAR DERECHO PROPIAMENTE DICHO"
  },
  {
    "codigo":123605001,
    "descripcion":"CIRROSIS NUTRICIONAL"
  },
  {
    "codigo":254677004,
    "descripcion":"QUISTE TRIQUILEMAL"
  },
  {
    "codigo":1332351001,
    "descripcion":"HIPERTROFIA DE FÉMUR"
  },
  {
    "codigo":283775003,
    "descripcion":"MORDEDURA DE PERRO EN EL TOBILLO"
  },
  {
    "codigo":251007003,
    "descripcion":"ESTENOSIS DE VÁLVULA PULMONAR CON CHORRO EXIGUO"
  },
  {
    "codigo":183636000,
    "descripcion":"SIN SEGUIMIENTO: ENCUENTRO PROBLEMÁTICO"
  },
  {
    "codigo":185471009,
    "descripcion":"VISITA DOMICILIARIA - SIN RESPUESTA"
  },
  {
    "codigo":1363284002,
    "descripcion":"TUBULOPATÍA RENAL DE TIPO GITELMAN DEBIDA A MUTACIÓN DEL ÁCIDO DESOXIRRIBONUCLEICO MITOCONDRIAL"
  },
  {
    "codigo":249172003,
    "descripcion":"HALLAZGO RELACIONADO CON LA CONSISTENCIA DE LA PLACENTA"
  },
  {
    "codigo":609620004,
    "descripcion":"TRASTORNO DE PELVIS"
  },
  {
    "codigo":281940001,
    "descripcion":"FRACTURA DE DOS COLUMNAS DE VÉRTEBRA LUMBAR"
  },
  {
    "codigo":445780006,
    "descripcion":"INFECCIÓN CAUSADA POR ACINETOBACTER RESISTENTE A CARBAPENEM"
  },
  {
    "codigo":247337001,
    "descripcion":"SENSACIÓN PERINEAL PERSISTENTE DESPUÉS DE LA MICCIÓN"
  },
  {
    "codigo":17961008,
    "descripcion":"TRASTORNO DE CONDUCTA, DE INICIO EN LA NIÑEZ"
  },
  {
    "codigo":442110002,
    "descripcion":"FIBROSIS DE PLEURA"
  },
  {
    "codigo":48894004,
    "descripcion":"INTOXICACIÓN POR SENECIO"
  },
  {
    "codigo":702419001,
    "descripcion":"NEURODEGENERACIÓN ASOCIADA CON HIDROXILASA DE ÁCIDOS GRASOS"
  },
  {
    "codigo":210899002,
    "descripcion":"LESIÓN DE MÚLTIPLES VASOS SANGUÍNEOS A NIVEL DE PIERNA"
  },
  {
    "codigo":14291003,
    "descripcion":"ESQUIZOFRENIA DESORGANIZADA SUBCRÓNICA CON EXACERBACIONES AGUDAS"
  },
  {
    "codigo":704254009,
    "descripcion":"FRACTURA PATOLÓGICA DE CLAVÍCULA EN SITIO DE NEOPLASIA"
  },
  {
    "codigo":276435006,
    "descripcion":"HALLAZGO RELACIONADO CON EL DOLOR Y LA SENSIBILIDAD"
  },
  {
    "codigo":209064001,
    "descripcion":"LUXACIÓN EXPUESTA ENTRE LA SÉPTIMA VÉRTEBRA CERVICAL Y LA PRIMERA VÉRTEBRA DORSAL"
  },
  {
    "codigo":733352001,
    "descripcion":"NEOPLASIA QUÍSTICA MUCINOSA PRIMARIA CON CARCINOMA INVASIVO ASOCIADO DE LA VÍA BILIAR"
  },
  {
    "codigo":12456005,
    "descripcion":"TRASTORNO IATROGÉNICO"
  },
  {
    "codigo":241832007,
    "descripcion":"ENVENENAMIENTO DEBIDO A PICADURA DE FRAGATA PORTUGUESA"
  },
  {
    "codigo":371069001,
    "descripcion":"DISFUNCIÓN DE LA DERIVACIÓN PORTAL INTRAHEPÁTICA"
  },
  {
    "codigo":239997002,
    "descripcion":"LESIÓN DE LA CÁPSULA ARTICULAR DE LA REGIÓN PÉLVICA"
  },
  {
    "codigo":305533004,
    "descripcion":"BAJO ATENCIÓN DE ODONTÓLOGO ESPECIALISTA EN RESTAURACIÓN"
  },
  {
    "codigo":403837005,
    "descripcion":"VARIANTE AUTOSÓMICA DOMINANTE DEL SÍNDROME DE WISKOTT-ALDRICH"
  },
  {
    "codigo":1255805006,
    "descripcion":"LINFOMA MALIGNO DE GANGLIOS LINFÁTICOS DE CABEZA"
  },
  {
    "codigo":698749006,
    "descripcion":"DOLOR DURANTE LAVADO DE DISPOSITIVO DE ACCESO VENOSO IMPLANTADO"
  },
  {
    "codigo":76157009,
    "descripcion":"BITUMINOSIS"
  },
  {
    "codigo":238162006,
    "descripcion":"EXTRACCIÓN ALTERADA DE OXÍGENO"
  },
  {
    "codigo":926290008,
    "descripcion":"EPÍFISIS PEQUEÑA DE FALANGE DE DEDO MEDIO"
  },
  {
    "codigo":1186599001,
    "descripcion":"PERIODONTITIS EXACERBADA POR GLUCOGENOSIS"
  },
  {
    "codigo":367399005,
    "descripcion":"PARÁLISIS DEL NERVIO CUBITAL"
  },
  {
    "codigo":39719008,
    "descripcion":"TRANSPOSICIÓN DE INTESTINO"
  },
  {
    "codigo":301863008,
    "descripcion":"CAVITACIÓN PULMONAR"
  },
  {
    "codigo":168956005,
    "descripcion":"ARTERIOGRAFÍA DE EXTREMIDAD INFERIOR: NORMAL"
  },
  {
    "codigo":365564006,
    "descripcion":"GRUPO SOCIAL - HALLAZGO"
  },
  {
    "codigo":201724008,
    "descripcion":"ARTROPATÍA NEUROPÁTICA DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":429265003,
    "descripcion":"CALLOSIDAD DE TALÓN"
  },
  {
    "codigo":724177005,
    "descripcion":"SÍNDROME DE LIGASA 4"
  },
  {
    "codigo":298193009,
    "descripcion":"HIPERMOVILIDAD DE ARTICULACIÓN DE DEDO DE MANO"
  },
  {
    "codigo":332351000119103,
    "descripcion":"RETINOPATÍA POR PREMATUREZ ETAPA 5 DE OJO DERECHO"
  },
  {
    "codigo":165286005,
    "descripcion":"MEMORIA: NO TIENE CONSCIENCIA DEL LUGAR"
  },
  {
    "codigo":65147003,
    "descripcion":"EMBARAZO GEMELAR"
  },
  {
    "codigo":720507006,
    "descripcion":"DISRITMIA AURICULAR E INTESTINAL CRÓNICA"
  },
  {
    "codigo":15979071000119105,
    "descripcion":"MALFORMACIÓN CONGÉNITA DE HUESECILLOS DE OÍDO DERECHO"
  },
  {
    "codigo":292688002,
    "descripcion":"REACCIÓN ADVERSA A LA GALAMINA"
  },
  {
    "codigo":390992003,
    "descripcion":"AÑOS BAJO TERAPIA DE REEMPLAZO HORMONAL"
  },
  {
    "codigo":28709001,
    "descripcion":"CELULITIS DE LARINGE"
  },
  {
    "codigo":389157002,
    "descripcion":"DISPLASIA TANATOFÓRICA, TIPO 1"
  },
  {
    "codigo":127013003,
    "descripcion":"ENFERMEDAD RENAL DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":94245002,
    "descripcion":"NEOPLASIA MALIGNA SECUNDARIA DEL CEREBELO"
  },
  {
    "codigo":290853005,
    "descripcion":"INTOXICACIÓN POR TRIMIPRAMINA"
  },
  {
    "codigo":420090003,
    "descripcion":"ENFERMEDAD NEUROINVASIVA POR VIRUS DEL VALLE DE CACHE"
  },
  {
    "codigo":26874005,
    "descripcion":"HIPERTROFIA DE VÍA BILIAR"
  },
  {
    "codigo":92410006,
    "descripcion":"NEOPLASIA BENIGNA DEL ESTERNÓN"
  },
  {
    "codigo":715002007,
    "descripcion":"NO SE MOVILIZA EN EL HOGAR"
  },
  {
    "codigo":289018009,
    "descripcion":"CAPAZ DE EMPLEAR LAS MANOS PARA ALIMENTARSE"
  },
  {
    "codigo":1237455002,
    "descripcion":"METÁSTASIS DE CARCINOMA DE COLON DESCENDENTE"
  },
  {
    "codigo":90575004,
    "descripcion":"LANUGO PERSISTENTE"
  },
  {
    "codigo":449188001,
    "descripcion":"VENA CAVA SUPERIOR IZQUIERDA PERSISTENTE CON DESEMBOCADURA EN SENO CORONARIO Y LUEGO, EN AURÍCULA DEL LADO DERECHO"
  },
  {
    "codigo":1268388003,
    "descripcion":"CARCINOMA METASTÁSICO INDIFERENCIADO DE ESÓFAGO"
  },
  {
    "codigo":88740003,
    "descripcion":"TIROTOXICOSIS FACTICIA CON CRISIS TIROTÓXICA"
  },
  {
    "codigo":416420005,
    "descripcion":"CAMBIOS DE TEXTURA DE PARTES BLANDAS"
  },
  {
    "codigo":285348005,
    "descripcion":"DISTENSIÓN DE MÚSCULO ABDOMINAL"
  },
  {
    "codigo":283513000,
    "descripcion":"HERIDA PUNZANTE EN BRAZO"
  },
  {
    "codigo":447353001,
    "descripcion":"INFECCIÓN DE CUELLO UTERINO CAUSADA POR CHLAMYDIA TRACHOMATIS"
  },
  {
    "codigo":414585002,
    "descripcion":"INCLINACIÓN LATERAL IZQUIERDA"
  },
  {
    "codigo":12266201000119107,
    "descripcion":"CALCIFICACIÓN MAMOGRÁFICA DE MAMA IZQUIERDA"
  },
  {
    "codigo":54137008,
    "descripcion":"HIPOVITAMINOSIS E"
  },
  {
    "codigo":185209009,
    "descripcion":"ATENDIDO EN UN LUGAR DE RECREACIÓN"
  },
  {
    "codigo":183374003,
    "descripcion":"CONVALECENCIA CONSECUTIVA A PSICOTERAPIA"
  },
  {
    "codigo":707662004,
    "descripcion":"CARCINOMA BASALOIDE PRIMARIO DE CÉLULAS ESCAMOSAS DE LARINGE"
  },
  {
    "codigo":871502006,
    "descripcion":"REACCIÓN ADVERSA A ERGOMETRINA Y\/O OXITOCINA"
  },
  {
    "codigo":248910006,
    "descripcion":"HALLAZGO RELACIONADO CON EL CUELLO UTERINO"
  },
  {
    "codigo":212472000,
    "descripcion":"LESIÓN DE MÚSCULO(S) Y TENDÓN(ES) DE GRUPO MUSCULAR PERONEO A NIVEL DE PIERNA"
  },
  {
    "codigo":247075009,
    "descripcion":"OPACIDAD EN CÁPSULA DEL CRISTALINO EN SEUDOFAQUIA"
  },
  {
    "codigo":79565000,
    "descripcion":"ALTERACIÓN DEL ASPECTO"
  },
  {
    "codigo":472781008,
    "descripcion":"OCLUSIÓN ADQUIRIDA DE VENA CAVA SUPERIOR"
  },
  {
    "codigo":403575000,
    "descripcion":"PRURITO POR TRASTORNO SISTÉMICO"
  },
  {
    "codigo":307106009,
    "descripcion":"VIVE EN UN INTERNADO"
  },
  {
    "codigo":239735004,
    "descripcion":"CONTRACTURA DE ARTICULACIÓN DE LA MUÑECA"
  },
  {
    "codigo":75895005,
    "descripcion":"IRIS BOMBÉ"
  },
  {
    "codigo":205132000,
    "descripcion":"POLIDACTILIA PREAXIAL DE DEDO DEL PIE"
  },
  {
    "codigo":237900002,
    "descripcion":"CALCIFILAXIS"
  },
  {
    "codigo":399905001,
    "descripcion":"AMPOLLA TRAUMÁTICA DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":72225002,
    "descripcion":"ESTENOSIS URETRAL SECUNDARIA A INFECCIÓN GONOCÓCICA"
  },
  {
    "codigo":367137004,
    "descripcion":"LESIÓN DEL NERVIO CIÁTICO"
  },
  {
    "codigo":203297004,
    "descripcion":"OSTEOMIELITIS SUBAGUDA DE COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":301601005,
    "descripcion":"INCAPAZ DE SUBIR Y BAJAR ESCALERAS SENTADO"
  },
  {
    "codigo":32904004,
    "descripcion":"LARINGITIS NEUMOCÓCICA"
  },
  {
    "codigo":4854004,
    "descripcion":"ANEMIA HEMOLÍTICA ADQUIRIDA"
  },
  {
    "codigo":10630311000119103,
    "descripcion":"LINFANGITIS AGUDA DE PIE DERECHO"
  },
  {
    "codigo":365302006,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA PONER UN ENCHUFE ELÉCTRICO EN UN TOMACORRIENTE"
  },
  {
    "codigo":299766007,
    "descripcion":"REFLEJO DE PRENSIÓN PLANTAR AUSENTE"
  },
  {
    "codigo":3019000,
    "descripcion":"LUXACIÓN CERRADA ANTERIOR DE CODO"
  },
  {
    "codigo":234230005,
    "descripcion":"INFECCIÓN DE ELECTRODO DE DESFRIBILADOR CARDÍACO IMPLANTADO"
  },
  {
    "codigo":723915002,
    "descripcion":"SÍNDROME DISOCIATIVO SECUNDARIO"
  },
  {
    "codigo":363467004,
    "descripcion":"NEOPLASIA MALIGNA DEL LÓBULO FRONTAL"
  },
  {
    "codigo":232395004,
    "descripcion":"SINUSITIS PANETMOIDAL CRÓNICA"
  },
  {
    "codigo":166859008,
    "descripcion":"NIVEL DE AMINOÁCIDOS SÉRICOS DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":33952002,
    "descripcion":"OSTEOARTROSIS LOCALIZADA"
  },
  {
    "codigo":427168003,
    "descripcion":"DOLOR PROVOCADO POR ALÉRGENO"
  },
  {
    "codigo":1184008,
    "descripcion":"ESCALA DEL COMA DE GLASGOW, 10"
  },
  {
    "codigo":230560008,
    "descripcion":"POLINEUROPATÍA CONGÉNITA"
  },
  {
    "codigo":359797001,
    "descripcion":"SÍNDROME DE COURVOISIER-TERRIER"
  },
  {
    "codigo":294261003,
    "descripcion":"ALERGIA A TERPENO"
  },
  {
    "codigo":32117000,
    "descripcion":"SULFAHEMOGLOBINEMIA"
  },
  {
    "codigo":425333006,
    "descripcion":"TRASTORNO MIELOPROLIFERATIVO"
  },
  {
    "codigo":195957006,
    "descripcion":"ENFISEMA BULLOSO"
  },
  {
    "codigo":95818003,
    "descripcion":"ESTATOCONIAS"
  },
  {
    "codigo":292426005,
    "descripcion":"REACCIÓN ADVERSA AL CELIPROLOL"
  },
  {
    "codigo":1144394005,
    "descripcion":"HIPOPLASIA CONGÉNITA DE ESTRUCTURA VESTIBULAR DE OÍDO INTERNO"
  },
  {
    "codigo":93983000,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL TABIQUE RECTOVESICAL"
  },
  {
    "codigo":285448006,
    "descripcion":"CAPAZ DE MOVER LA MANDÍBULA REPETIDAMENTE"
  },
  {
    "codigo":290591004,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR TIO-TEPA"
  },
  {
    "codigo":419828005,
    "descripcion":"MARGEN QUIRÚRGICO EXTERNO AFECTADO POR CARCINOMA DUCTAL IN SITU"
  },
  {
    "codigo":288756006,
    "descripcion":"CAPAZ DE COMUNICAR PENSAMIENTOS"
  },
  {
    "codigo":1237193000,
    "descripcion":"TRASTORNO FETAL DEBIDO A EDEMA DE PLACENTA"
  },
  {
    "codigo":90313000,
    "descripcion":"GEMELARES AUTOSÍTICOS UNIDOS ASIMÉTRICOS"
  },
  {
    "codigo":88478000,
    "descripcion":"MOTILIDAD ANORMAL DEL INTESTINO DELGADO"
  },
  {
    "codigo":24777009,
    "descripcion":"TRASTORNO DEL NERVIO HIPOGLOSO"
  },
  {
    "codigo":254153009,
    "descripcion":"OSTEÓLISIS EXPANSIVA FAMILIAR"
  },
  {
    "codigo":416158002,
    "descripcion":"DISFUNCIÓN SISTÓLICA DEL VENTRÍCULO DERECHO"
  },
  {
    "codigo":21107000,
    "descripcion":"PASAJERO EN ACCIDENTE VEHICULAR Y\/O DE TRÁNSITO"
  },
  {
    "codigo":86643000,
    "descripcion":"GRADO DE AFECTACIÓN: DETERIORO SEVERO EN AMBOS OJOS"
  },
  {
    "codigo":840307003,
    "descripcion":"HIPERTENSIÓN PULMONAR MODERADA"
  },
  {
    "codigo":283251004,
    "descripcion":"VIDRIO EN EL DORSO DE LA MANO"
  },
  {
    "codigo":19272000,
    "descripcion":"CERVICITIS AGUDA"
  },
  {
    "codigo":248648003,
    "descripcion":"PALPITACIONES - RÁPIDAS"
  },
  {
    "codigo":707400004,
    "descripcion":"ADENOCARCINOMA MUCINOSO PRIMARIO DE OROFARINGE"
  },
  {
    "codigo":314184006,
    "descripcion":"ANEURISMA AÓRTICO SUPRARRENAL ROTO"
  },
  {
    "codigo":445256008,
    "descripcion":"EDEMA DE GLÚTEO"
  },
  {
    "codigo":1297224009,
    "descripcion":"CIERRE DE ÁNGULO PRIMARIO DE AMBOS OJOS"
  },
  {
    "codigo":246813002,
    "descripcion":"PTOSIS DE CEJA"
  },
  {
    "codigo":212210002,
    "descripcion":"LESIÓN DE LA RAÍZ DEL NERVIO DORSAL - D5"
  },
  {
    "codigo":79303006,
    "descripcion":"SÍNDROME EXPANDIDO DE RUBÉOLA"
  },
  {
    "codigo":110236000,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO DE LA LENGUA"
  },
  {
    "codigo":77468007,
    "descripcion":"HALLAZGO RELACIONADO CON LA ACTITUD FETAL"
  },
  {
    "codigo":403313001,
    "descripcion":"HIPERTRICOSIS EN LA ANOREXIA NERVIOSA"
  },
  {
    "codigo":75633002,
    "descripcion":"FÍSTULA ANOPERINEAL CONGÉNITA"
  },
  {
    "codigo":237638000,
    "descripcion":"HIPOGLUCEMIA POSPRANDIAL"
  },
  {
    "codigo":1255281009,
    "descripcion":"FRACTURA DE MÚLTIPLES HUESOS METATARSIANOS"
  },
  {
    "codigo":41030002,
    "descripcion":"COCCIDIOIDOMICOSIS CON ERITEMA MULTIFORME"
  },
  {
    "codigo":310901000119109,
    "descripcion":"DERRAME INTERMITENTE DE ARTICULACIÓN DE CODO IZQUIERDO"
  },
  {
    "codigo":38671000119103,
    "descripcion":"MICCIÓN ANORMAL"
  },
  {
    "codigo":8262006,
    "descripcion":"ENFERMEDAD BILIAR OBSTRUCTIVA EXTRAHEPÁTICA"
  },
  {
    "codigo":16668431000119103,
    "descripcion":"FRACTURA NO EXPUESTA DE TRÍPODE CIGOMÁTICO DERECHO"
  },
  {
    "codigo":170267001,
    "descripcion":"EXAMEN DEL NIÑO A LOS 6 MESES: NORMAL"
  },
  {
    "codigo":399643001,
    "descripcion":"NIVEL DE ALFA-FETOPROTEÍNA SÉRICA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":301339005,
    "descripcion":"HALLAZGO RELACIONADO CON MEDICIONES DEL PERÍMETRO CEFÁLICO"
  },
  {
    "codigo":16013071000119105,
    "descripcion":"TROMBOSIS BILATERAL DE ARTERIA FEMORAL COMÚN"
  },
  {
    "codigo":365040001,
    "descripcion":"POTENCIAL DE ACCIÓN - HALLAZGO"
  },
  {
    "codigo":430576002,
    "descripcion":"CON MAYOR RIESGO DE LESIÓN TRAUMÁTICA POR CAÍDA"
  },
  {
    "codigo":299504005,
    "descripcion":"AMPLITUD DE MOVIMIENTO PASIVO DE SUPINACIÓN MEDIOTARSIANA"
  },
  {
    "codigo":1217008005,
    "descripcion":"ESPASMOS EPILÉPTICOS"
  },
  {
    "codigo":233968006,
    "descripcion":"ESTENOSIS DE LA ARTERIA ILÍACA EXTERNA"
  },
  {
    "codigo":232133000,
    "descripcion":"MIOPÍA SIMPLE"
  },
  {
    "codigo":4592006,
    "descripcion":"GALOPE POR CUARTO RUIDO"
  },
  {
    "codigo":10907561000119101,
    "descripcion":"HERIDA DE ARMA DE FUEGO EN REGIÓN AXILAR IZQUIERDA"
  },
  {
    "codigo":11835151000119108,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA DE PULGAR DERECHO"
  },
  {
    "codigo":723653009,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR DESCONGESTIVO"
  },
  {
    "codigo":263066001,
    "descripcion":"FRACTURA-LUXACIÓN DE ARTICULACIÓN SACROILÍACA"
  },
  {
    "codigo":721818009,
    "descripcion":"ENCEFALITIS CAUSADA POR SCHISTOSOMA"
  },
  {
    "codigo":62788000,
    "descripcion":"CANIBALISMO"
  },
  {
    "codigo":293999009,
    "descripcion":"ALERGIA A FELODIPINO"
  },
  {
    "codigo":423236002,
    "descripcion":"INDUCCIÓN FARMACOLÓGICA DE ENZIMA CYP3A DEL CITOCROMO P450"
  },
  {
    "codigo":161092002,
    "descripcion":"VIAJE CON HOSPEDAJE SIN SERVICIO DE COMIDAS"
  },
  {
    "codigo":292164000,
    "descripcion":"REACCIÓN ADVERSA AL ETOMIDATO"
  },
  {
    "codigo":339881000119106,
    "descripcion":"BLEFARITIS DE PÁRPADO INFERIOR IZQUIERDO"
  },
  {
    "codigo":95556007,
    "descripcion":"HEPATITIS COLESTÁSICA"
  },
  {
    "codigo":1142297002,
    "descripcion":"CEJA ARQUEADA"
  },
  {
    "codigo":192025002,
    "descripcion":"ENCOPRESIS INTERMITENTE NO ORGÁNICA"
  },
  {
    "codigo":290329006,
    "descripcion":"INTOXICACIÓN POR MEDIOS DE CONTRASTE PARA RESONANCIA MAGNÉTICA"
  },
  {
    "codigo":126489007,
    "descripcion":"NEOPLASIA DE PIEL CON DIFERENCIACIÓN DE ANEXOS CUTÁNEOS"
  },
  {
    "codigo":15632451000119102,
    "descripcion":"SÍNDROME DE DISFUNCIÓN DOLOROSA DE LA ARTICULACIÓN TEMPOROMANDIBULAR DERECHA"
  },
  {
    "codigo":59118001,
    "descripcion":"BLOQUEO DE LA RAMA DERECHA DEL HAZ DE HIS"
  },
  {
    "codigo":124654002,
    "descripcion":"DEFICIENCIA DE CARBONO - HALURO LIASA"
  },
  {
    "codigo":419566002,
    "descripcion":"MOVIMIENTO OCULAR HACIA LA DERECHA LIMITADO"
  },
  {
    "codigo":93721009,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE HUESO DE LA CARA"
  },
  {
    "codigo":714478005,
    "descripcion":"GINGIVITIS MODERADA"
  },
  {
    "codigo":253891002,
    "descripcion":"URÉTER TRANSCAVA"
  },
  {
    "codigo":1204163004,
    "descripcion":"LINFADENITIS CERVICAL AGUDA"
  },
  {
    "codigo":417731006,
    "descripcion":"TORSIÓN POSTERIOR DEL SACRO"
  },
  {
    "codigo":1236931008,
    "descripcion":"METÁSTASIS DE CARCINOMA DE CUERPO DE PÁNCREAS"
  },
  {
    "codigo":55448001,
    "descripcion":"FÍSTULA TRAQUEOESOFÁGICA SECUNDARIA A TRAQUEOSTOMÍA"
  },
  {
    "codigo":384963009,
    "descripcion":"PARED TORÁCICA AFECTADA POR PROPAGACIÓN DIRECTA DE NEOPLASIA MALIGNA"
  },
  {
    "codigo":284824004,
    "descripcion":"SE ARRODILLA EN LA BAÑERA"
  },
  {
    "codigo":414061000,
    "descripcion":"PENFIGOIDE CICATRIZAL PRODUCIDO POR DROGAS"
  },
  {
    "codigo":448664009,
    "descripcion":"NEOPLASIA EPITELIAL MALIGNA DE INTESTINO DELGADO"
  },
  {
    "codigo":313411000119107,
    "descripcion":"ARTROFITO EN ARTICULACIÓN DE CODO DERECHO"
  },
  {
    "codigo":1003885000,
    "descripcion":"DUPLICACIÓN DE PORCIÓN PROXIMAL DEL BRAZO CORTO DEL CROMOSOMA 7"
  },
  {
    "codigo":20845005,
    "descripcion":"MECONIO EN LÍQUIDO AMNIÓTICO QUE AFECTA EL MANEJO DE LA SITUACIÓN MATERNA"
  },
  {
    "codigo":182850000,
    "descripcion":"FÁRMACOS NO ENTREGADOS"
  },
  {
    "codigo":248386001,
    "descripcion":"SUPERPOSICIÓN DE LOS MÁRGENES DE LA FONTANELA"
  },
  {
    "codigo":1264194006,
    "descripcion":"AMIOPLASIA CONGÉNITA"
  },
  {
    "codigo":312087002,
    "descripcion":"TRASTORNO POSTERIOR A UN PROCEDIMIENTO MÉDICO"
  },
  {
    "codigo":49943002,
    "descripcion":"INFESTACIÓN CAUSADA POR CALLIPHORA"
  },
  {
    "codigo":1196823004,
    "descripcion":"LIPOMA DE APÉNDICE"
  },
  {
    "codigo":310252000,
    "descripcion":"ÍNDICE DE MASA CORPORAL INFERIOR A 20"
  },
  {
    "codigo":211948003,
    "descripcion":"CORROSIÓN DE SEGUNDO GRADO DE MUÑECA Y MANO"
  },
  {
    "codigo":703468005,
    "descripcion":"AMIGDALITIS BACTERIANA"
  },
  {
    "codigo":408556008,
    "descripcion":"EVALUACIÓN DE CAÍDAS POR EQUIPO MULTIDISCIPLINARIO OMITIDA"
  },
  {
    "codigo":767169001,
    "descripcion":"OBSTRUCCIÓN ADQUIRIDA DE SENO CORONARIO"
  },
  {
    "codigo":46273003,
    "descripcion":"ABSCESO DE PEZÓN ASOCIADO CON EL PARTO"
  },
  {
    "codigo":111809003,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM LEPRAEMURIUM"
  },
  {
    "codigo":15933661000119109,
    "descripcion":"LESIÓN DE TROMPA DE FALOPIO DERECHO"
  },
  {
    "codigo":271979002,
    "descripcion":"TRASTORNO DE INJERTO DE TENDÓN"
  },
  {
    "codigo":763499004,
    "descripcion":"LABIO LEPORINO DERECHO INCOMPLETO Y FISURA ALVEOLAR DERECHA INCOMPLETA"
  },
  {
    "codigo":1255019005,
    "descripcion":"DEPENDENCIA COMBINADA DE SUSTANCIA OPIOIDE Y NO OPIOIDE EN REMISIÓN"
  },
  {
    "codigo":239211008,
    "descripcion":"EXPOSICIÓN DEL EXPANSOR TISULAR"
  },
  {
    "codigo":403051009,
    "descripcion":"TIÑA DE LA MANO CAUSADA POR MICROSPORUM VANBREUSEGHEMII"
  },
  {
    "codigo":204608004,
    "descripcion":"LABIO LEPORINO CENTRAL"
  },
  {
    "codigo":25911000175109,
    "descripcion":"PÁRPADO NORMAL"
  },
  {
    "codigo":302912005,
    "descripcion":"PARÁLISIS DE CUERDA VOCAL"
  },
  {
    "codigo":10965521000119100,
    "descripcion":"HERIDA PUNZANTE DE CADERA IZQUIERDA"
  },
  {
    "codigo":399381002,
    "descripcion":"TUMOR RENAL QUE SE EXTIENDE MACROSCÓPICAMENTE MÁS ALLÁ DE LA FASCIA DE GEROTA"
  },
  {
    "codigo":38933006,
    "descripcion":"FIEBRE REUMÁTICA RECURRENTE"
  },
  {
    "codigo":366613007,
    "descripcion":"HALLAZGO RELACIONADO CON LA AMPLITUD DE MOVIMIENTO PASIVO DE ARTICULACIÓN DE TOBILLO"
  },
  {
    "codigo":1251349007,
    "descripcion":"HIPERTROFIA DE UÑA CAUSADA POR FÁRMACO"
  },
  {
    "codigo":37098000,
    "descripcion":"CELULITIS DE LA CARA EXTERNA DE LA NARIZ"
  },
  {
    "codigo":364778002,
    "descripcion":"CAPACIDAD PARA BEBER - HALLAZGO"
  },
  {
    "codigo":266474003,
    "descripcion":"CÁLCULO EN LA VÍA BILIAR"
  },
  {
    "codigo":233706004,
    "descripcion":"EDEMA AGUDO DE PULMÓN, MEDICAMENTOSO"
  },
  {
    "codigo":200938002,
    "descripcion":"LUPUS ERITEMATOSO DISCOIDE"
  },
  {
    "codigo":299242000,
    "descripcion":"AMPLITUD DE FLEXIÓN ACTIVA DE LA CADERA AUMENTADA"
  },
  {
    "codigo":102634007,
    "descripcion":"DÉFICIT DE BASE"
  },
  {
    "codigo":1149375002,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE DEXTROPROPOXIFENO Y\/O PARACETAMOL"
  },
  {
    "codigo":428479004,
    "descripcion":"ANEURISMA DE ARTERIA TEMPORAL SUPERFICIAL"
  },
  {
    "codigo":2495006,
    "descripcion":"ANEURISMA ARTERIOVENOSO CEREBRAL CONGÉNITO"
  },
  {
    "codigo":231871007,
    "descripcion":"LINFANGIECTASIA DE LA CONJUNTIVA"
  },
  {
    "codigo":197268000,
    "descripcion":"NECROSIS HEPÁTICA AGUDA Y SUBAGUDA"
  },
  {
    "codigo":721556000,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE PALADAR"
  },
  {
    "codigo":295572002,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE BENZOCAÍNA"
  },
  {
    "codigo":788927006,
    "descripcion":"MUTILACIÓN DE GENITALES FEMENINOS TIPO 3A"
  },
  {
    "codigo":11784721000119106,
    "descripcion":"AMPOLLA TRAUMÁTICA DE DEDO GORDO DE PIE IZQUIERDO"
  },
  {
    "codigo":262804006,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA VÍA BILIAR"
  },
  {
    "codigo":787092009,
    "descripcion":"NECROSIS AVASCULAR DE HUESO NO TRAUMÁTICA SECUNDARIA"
  },
  {
    "codigo":293737001,
    "descripcion":"ALERGIA A FILGRASTIM"
  },
  {
    "codigo":129897006,
    "descripcion":"DISFUNCIÓN EN LA RESPUESTA AL DESTETE DEL RESPIRADOR"
  },
  {
    "codigo":128062001,
    "descripcion":"DERIVACIÓN PORTOSISTÉMICA CONGÉNITA"
  },
  {
    "codigo":291902002,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR HEPARINA"
  },
  {
    "codigo":816190002,
    "descripcion":"EDEMA DE AMBAS PIERNAS"
  },
  {
    "codigo":193598007,
    "descripcion":"CATARATA TRAUMÁTICA CON RESOLUCIÓN PARCIAL"
  },
  {
    "codigo":93459000,
    "descripcion":"CUERPO EXTRAÑO EN EL TEJIDO CELULAR SUBCUTÁNEO"
  },
  {
    "codigo":783422009,
    "descripcion":"ANEURISMA DE LA ZONA DE LA ARTERIA COMUNICANTE ANTERIOR DE LA CARÓTIDA INTERNA"
  },
  {
    "codigo":290067000,
    "descripcion":"MAMA HIPOPIGMENTADA"
  },
  {
    "codigo":716051003,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DURANTE INTERVENCIÓN QUIRÚRGICA"
  },
  {
    "codigo":717886007,
    "descripcion":"ROTACIÓN ANÓMALA DE DUODENO"
  },
  {
    "codigo":42611000087102,
    "descripcion":"HERIDA PUNZANTE DE GLÚTEO DERECHO CON CUERPO EXTRAÑO"
  },
  {
    "codigo":47731000087102,
    "descripcion":"FRACTURA DE SEGUNDA COSTILLA IZQUIERDA"
  },
  {
    "codigo":40051000087108,
    "descripcion":"FRACTURA DE CÓNDILO LATERAL DE TIBIA IZQUIERDA"
  },
  {
    "codigo":124392007,
    "descripcion":"DEFICIENCIA DE AMIDINOTRANSFERASA"
  },
  {
    "codigo":1304040007,
    "descripcion":"PATRÓN NOCIVO DE USO DE HEROÍNA INTRAVENOSA"
  },
  {
    "codigo":58856009,
    "descripcion":"NEURITIS TORÁCICA"
  },
  {
    "codigo":384701002,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA AFECTADO POR CARCINOMA IN SITU DUCTAL, UNIFOCAL"
  },
  {
    "codigo":89789003,
    "descripcion":"HEPATITIS VIRAL CRÓNICA AGRESIVA"
  },
  {
    "codigo":253629005,
    "descripcion":"TRONCO PULMONAR AUSENTE CON ARTERIA PULMONAR AUSENTE"
  },
  {
    "codigo":286397009,
    "descripcion":"DIFICULTAD PARA UTILIZAR ADECUADAMENTE EL LENGUAJE"
  },
  {
    "codigo":1082181000119103,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE CONJUNTIVA DE OJO DERECHO"
  },
  {
    "codigo":315495000,
    "descripcion":"NACIDO EN OMÁN"
  },
  {
    "codigo":248124006,
    "descripcion":"PROBLEMA ALIMENTARIO"
  },
  {
    "codigo":706876006,
    "descripcion":"SOSPECHA"
  },
  {
    "codigo":51516008,
    "descripcion":"PRODUCCIÓN ANORMAL DE NEUTRÓFILOS"
  },
  {
    "codigo":1296700008,
    "descripcion":"HIPERTENSIÓN OCULAR DE OJO DERECHO DEBIDA A PRESIÓN VENOSA EPIESCLERAL AUMENTADA"
  },
  {
    "codigo":49681005,
    "descripcion":"INTOXICACIÓN POR GÉNERO HYPERICUM"
  },
  {
    "codigo":279057008,
    "descripcion":"SÍNDROME DE COMPARTIMIENTO DE PSOAS DEBIDO A LESIÓN TRAUMÁTICA"
  },
  {
    "codigo":80614003,
    "descripcion":"ALVEOLITIS PULMONAR PROLONGADA"
  },
  {
    "codigo":277222005,
    "descripcion":"MUCOSA NASAL PÁLIDA"
  },
  {
    "codigo":408294007,
    "descripcion":"CONTRACCIÓN DE LA PIEL POR QUEMADURA"
  },
  {
    "codigo":703206009,
    "descripcion":"OCLUSIÓN ASINTOMÁTICA DE ARTERIA BASILAR"
  },
  {
    "codigo":308155002,
    "descripcion":"INFECCIÓN DE HERIDA POSOPERATORIA POR STAPHYLOCOCCUS AUREUS RESISTENTE A METICILINA"
  },
  {
    "codigo":13243006,
    "descripcion":"FRAMBESIA DEL CANGREJO"
  },
  {
    "codigo":371856001,
    "descripcion":"HEMODINAMIA DEL HEMICARDIO IZQUIERDO, NORMAL"
  },
  {
    "codigo":240784001,
    "descripcion":"CONIDIOBOLOMICOSIS RINOFACIAL"
  },
  {
    "codigo":44176004,
    "descripcion":"TRASTORNO DEL METABOLISMO DE LA HISTIDINA"
  },
  {
    "codigo":109712004,
    "descripcion":"ALVÉOLO DENTAL AMPLIO"
  },
  {
    "codigo":699536006,
    "descripcion":"LESIÓN TRAUMÁTICA POR HIPEREXTENSIÓN"
  },
  {
    "codigo":271717004,
    "descripcion":"RESPUESTA DE FLEXIÓN PLANTAR BILATERAL"
  },
  {
    "codigo":238949006,
    "descripcion":"MUCINOSIS PAPULAR PERSISTENTE DE LAS EXTREMIDADES"
  },
  {
    "codigo":1287525007,
    "descripcion":"ABRASIÓN DE PIEL DE CUERO CABELLUDO"
  },
  {
    "codigo":1156453008,
    "descripcion":"CORDOMA"
  },
  {
    "codigo":42341009,
    "descripcion":"AGNOSIA"
  },
  {
    "codigo":400954002,
    "descripcion":"EURIBLÉFARON"
  },
  {
    "codigo":204346001,
    "descripcion":"FUSIÓN CONGÉNITA DE SEGMENTO DE VÁLVULA PULMONAR"
  },
  {
    "codigo":1285690001,
    "descripcion":"ANOMALÍA CONGÉNITA DE VENA RENAL DERECHA"
  },
  {
    "codigo":399119000,
    "descripcion":"TOXICIDAD POR RADIOTERAPIA"
  },
  {
    "codigo":169743001,
    "descripcion":"AMAMANTAMIENTO CON SUPLEMENTO"
  },
  {
    "codigo":366351000,
    "descripcion":"HALLAZGO RELACIONADO CON EL TAMAÑO DEL PEZÓN"
  },
  {
    "codigo":300815003,
    "descripcion":"INCAPAZ DE CUIDAR UNA MASCOTA"
  },
  {
    "codigo":5903008,
    "descripcion":"INTOXICACIÓN POR PINUS PONDEROSA"
  },
  {
    "codigo":200676005,
    "descripcion":"CELULITIS Y ABSCESO DE GLÚTEO"
  },
  {
    "codigo":1084691000119100,
    "descripcion":"NEURONITIS VESTIBULAR BILATERAL"
  },
  {
    "codigo":69604007,
    "descripcion":"SECUENCIA ANORMAL DE AMINOÁCIDOS"
  },
  {
    "codigo":297145001,
    "descripcion":"EXOSTOSIS DE TIBIA"
  },
  {
    "codigo":723129002,
    "descripcion":"COMPRESIÓN DE MÉDULA ESPINAL DEBIDA A TRASTORNO DEGENERATIVO DE COLUMNA VERTEBRAL"
  },
  {
    "codigo":35001004,
    "descripcion":"ANAFILAXIS NO ALÉRGICA"
  },
  {
    "codigo":721294001,
    "descripcion":"HIPOACUSIA ADQUIRIDA"
  },
  {
    "codigo":398002,
    "descripcion":"SIGNOS ELECTROCARDIOGRÁFICOS DE DESVIACIÓN DEL EJE HACIA LA IZQUIERDA, MAYOR DE - 90 GRADOS"
  },
  {
    "codigo":428217009,
    "descripcion":"INFECCIÓN DISEMINADA POR CITOMEGALOVIRUS"
  },
  {
    "codigo":426382004,
    "descripcion":"FRACTURA NO EXPUESTA POR AVULSIÓN DE TROCÁNTER MAYOR DE FÉMUR"
  },
  {
    "codigo":197006009,
    "descripcion":"SÍNDROME DE LA ARTERIA MESENTÉRICA SUPERIOR"
  },
  {
    "codigo":129635004,
    "descripcion":"SÍNDROME DE HIPERESTIMULACIÓN OVÁRICA"
  },
  {
    "codigo":1145443008,
    "descripcion":"HIPOPLASIA CONGÉNITA DE HUESO DE ESTERNÓN"
  },
  {
    "codigo":162403009,
    "descripcion":"SENSACIÓN DE PRESIÓN AURICULAR"
  },
  {
    "codigo":95032000,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LÓBULO MEDIO DE PULMÓN DERECHO"
  },
  {
    "codigo":291640002,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR SULFADIAZINA"
  },
  {
    "codigo":783160006,
    "descripcion":"AMILOIDOSIS HEREDITARIA POR GELSOLINA"
  },
  {
    "codigo":422712008,
    "descripcion":"LA VIVIENDA CONTIENE EQUIPAMIENTO INSEGURO"
  },
  {
    "codigo":191501001,
    "descripcion":"ESTADO CONFUSIONAL AGUDO, POSTRAUMÁTICO"
  },
  {
    "codigo":226104009,
    "descripcion":"DIETA CON ALTO CONTENIDO DE ÁCIDO ALFALINOLEICO"
  },
  {
    "codigo":420877009,
    "descripcion":"DERMATOMICOSIS CON SIDA (SÍNDROME DE INMUNODEFICIENCIA ADQUIRIDA)"
  },
  {
    "codigo":93197009,
    "descripcion":"LINFOMA MALIGNO DE GANGLIOS LINFÁTICOS DE LOCALIZACIONES MÚLTIPLES"
  },
  {
    "codigo":715789009,
    "descripcion":"MIOTONÍA PERMANENTE"
  },
  {
    "codigo":224269009,
    "descripcion":"HOGAR LIMPIO"
  },
  {
    "codigo":124130006,
    "descripcion":"DEFICIENCIA DE L - GULONATO DESHIDROGENASA"
  },
  {
    "codigo":56759000,
    "descripcion":"ANOMALÍA CONGÉNITA DEL TEJIDO SUBCUTÁNEO"
  },
  {
    "codigo":23991000,
    "descripcion":"RECHAZO CRÓNICO ACTIVO DE INJERTO"
  },
  {
    "codigo":187831008,
    "descripcion":"NEOPLASIA MALIGNA DE VESTÍBULO NASAL"
  },
  {
    "codigo":286135009,
    "descripcion":"CAPAZ DE LIMPIAR ARTEFACTOS DOMÉSTICOS"
  },
  {
    "codigo":284300004,
    "descripcion":"CAPAZ DE REALIZAR LA PRENSIÓN CON OPOSICIÓN DEL PULGAR"
  },
  {
    "codigo":218764006,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR ESPIPERONA"
  },
  {
    "codigo":448140007,
    "descripcion":"ESPÉCIMEN INSATISFACTORIO PARA EVALUACIÓN DEBIDO A ENMASCARAMIENTO POR JALEA LUBRICANTE"
  },
  {
    "codigo":249697003,
    "descripcion":"COSTILLA DELGADA"
  },
  {
    "codigo":184161007,
    "descripcion":"SUPERVISIÓN INFANTIL SUSPENDIDA"
  },
  {
    "codigo":11845191000119102,
    "descripcion":"LESIÓN TRAUMÁTICA DE VENA YUGULAR INTERNA DERECHA"
  },
  {
    "codigo":444470001,
    "descripcion":"LESIÓN TRAUMÁTICA DE LIGAMENTO CRUZADO ANTERIOR"
  },
  {
    "codigo":413537009,
    "descripcion":"LINFOMA DE CÉLULAS T ANGIOINMUNOBLÁSTICO"
  },
  {
    "codigo":85857008,
    "descripcion":"SÍFILIS SECUNDARIA, RECIDIVA (TRATADA)"
  },
  {
    "codigo":247862005,
    "descripcion":"MIEDO A TENER UN PROBLEMA LUEGO DE LA ANESTESIA"
  },
  {
    "codigo":51254007,
    "descripcion":"FIEBRE PARATIFOIDEA TIPO C"
  },
  {
    "codigo":1163531000,
    "descripcion":"DUODENITIS CAUSADA POR MYCOBACTERIUM"
  },
  {
    "codigo":442635007,
    "descripcion":"ORGANISMO AISLADO POR CULTIVO MICROBIANO"
  },
  {
    "codigo":768480006,
    "descripcion":"HIFAS RAMIFICADAS DEL REINO FUNGI DETECTADAS"
  },
  {
    "codigo":209589001,
    "descripcion":"DESGARRO COMPLETO DE LIGAMENTO RADIOESCAFOCAPITAL"
  },
  {
    "codigo":111285003,
    "descripcion":"MIOCARDIOPATÍA DILATADA DEBIDA A TRASTORNO METABÓLICO"
  },
  {
    "codigo":677601000119101,
    "descripcion":"MICROANEURISMA DE LA ARTERIA RETINIANA IZQUIERDA"
  },
  {
    "codigo":373429003,
    "descripcion":"EDEMA BULLOSO DEL EPITELIO CORNEAL"
  },
  {
    "codigo":130631000119108,
    "descripcion":"MUTILACIÓN GENITAL FEMENINA TIPO 1"
  },
  {
    "codigo":764810000,
    "descripcion":"SÍNDROME BRANQUIO-ÓTICO"
  },
  {
    "codigo":240522002,
    "descripcion":"FIEBRE DE CANDIRU"
  },
  {
    "codigo":699274002,
    "descripcion":"SUPERPOSICIÓN AUMENTADA"
  },
  {
    "codigo":76682005,
    "descripcion":"TRASTORNO DEL CUERPO VÍTREO"
  },
  {
    "codigo":306058006,
    "descripcion":"ANEMIA APLÁSICA"
  },
  {
    "codigo":238687000,
    "descripcion":"URTICARIA FAMILIAR POR FRÍO"
  },
  {
    "codigo":402527000,
    "descripcion":"CARCINOMA BASOCELULAR TIPO INFILTRATIVO"
  },
  {
    "codigo":1156191002,
    "descripcion":"INESTABILIDAD HABITACIONAL"
  },
  {
    "codigo":9311003,
    "descripcion":"SÍNDROME DE HERMANSKY - PUDLAK"
  },
  {
    "codigo":1187124004,
    "descripcion":"AMILOIDOSIS POR DEPÓSITO DE APOLIPOPROTEÍNA A-IV"
  },
  {
    "codigo":1252660005,
    "descripcion":"PAREJA ARRESTADA"
  },
  {
    "codigo":890377000,
    "descripcion":"AGENESIA DE CORDÓN UMBILICAL"
  },
  {
    "codigo":300553002,
    "descripcion":"OVULACIÓN PRESENTE"
  },
  {
    "codigo":366089003,
    "descripcion":"DOMINANCIA DEL OJO - HALLAZGO"
  },
  {
    "codigo":71177003,
    "descripcion":"RETRACCIÓN DE LA MEMBRANA TIMPÁNICA"
  },
  {
    "codigo":169481005,
    "descripcion":"DISPOSITIVO ANTICONCEPTIVO INTRAUTERINO CONTROLADO - PROBLEMAS"
  },
  {
    "codigo":235017008,
    "descripcion":"MUCOCELE BUCAL"
  },
  {
    "codigo":202249009,
    "descripcion":"LUXACIÓN HABITUAL DE ARTICULACIÓN ROTULOFEMORAL"
  },
  {
    "codigo":36574005,
    "descripcion":"DEFICIENCIA TRANSVERSA DE LA EXTREMIDAD INFERIOR"
  },
  {
    "codigo":724702008,
    "descripcion":"TRASTORNO PSICÓTICO CAUSADO POR INHALANTE VOLÁTIL"
  },
  {
    "codigo":1148851002,
    "descripcion":"LINFOMA FOLICULAR GRADO 3A"
  },
  {
    "codigo":11857421000119100,
    "descripcion":"DISTENSIÓN DE MÚSCULO PERONEO DERECHO"
  },
  {
    "codigo":690701000119101,
    "descripcion":"ORINA CON OLOR FÉTIDO"
  },
  {
    "codigo":1082381000119101,
    "descripcion":"TAMAÑO DE DIENTE ANORMAL"
  },
  {
    "codigo":427955007,
    "descripcion":"HALLAZGO RELACIONADO CON EL ESTADO DE COINCIDENCIA CON UN HALLAZGO PREVIO"
  },
  {
    "codigo":150541000119104,
    "descripcion":"TRASTORNO FUNCIONAL DEL TRACTO GASTROINTESTINAL"
  },
  {
    "codigo":130061000119105,
    "descripcion":"DEFECTOS DEL TUBO NEURAL DETECTADO POR CRIBADO CON MÚLTIPLES MARCADORES"
  },
  {
    "codigo":722867009,
    "descripcion":"HIPERTENSIÓN PORTAL IDIOPÁTICA"
  },
  {
    "codigo":295048002,
    "descripcion":"ALERGIA A TRIMETAFÁN"
  },
  {
    "codigo":117261000119108,
    "descripcion":"MICROLITIASIS TESTICULAR"
  },
  {
    "codigo":887190541000119108,
    "descripcion":"DIFICULTAD PARA COMPRENDER LA INDICACIÓN MÉDICA"
  },
  {
    "codigo":337421000119103,
    "descripcion":"OCLUSIÓN TRANSITORIA DE ARTERIA DE LA RETINA IZQUIERDA"
  },
  {
    "codigo":368141000119106,
    "descripcion":"NEUROPATÍA AUTÓNOMA DEBIDA A DIABETES MELLITUS INDUCIDA POR FÁRMACOS"
  },
  {
    "codigo":12400141000119103,
    "descripcion":"DOLOR CRÓNICO POSTERIOR A ARTROPLASTIA TOTAL DE CADERA BILATERAL"
  },
  {
    "codigo":316941000119108,
    "descripcion":"DOLOR EN LA PIERNA DERECHA"
  },
  {
    "codigo":293213002,
    "descripcion":"REACCIÓN ADVERSA AL MEGESTROL"
  },
  {
    "codigo":721032007,
    "descripcion":"QUISTE Y TROFOZOÍTO DE ENTAMOEBA DISPAR O ENTAMOEBA HISTOLYTICA"
  },
  {
    "codigo":719197004,
    "descripcion":"PROMINENCIA ANORMAL DE COLUMNA VERTEBRAL"
  },
  {
    "codigo":1179784006,
    "descripcion":"ÁCIDO FÓLICO DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":194909006,
    "descripcion":"PERICARDITIS AGUDA SECUNDARIA A UREMIA"
  },
  {
    "codigo":1145181009,
    "descripcion":"ENFERMEDAD VASCULAR TESTICULAR"
  },
  {
    "codigo":94770003,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE BRONQUIO DEL LÓBULO SUPERIOR IZQUIERDO DEL PULMÓN"
  },
  {
    "codigo":291378006,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR TRATAMIENTO CAPILAR"
  },
  {
    "codigo":193074007,
    "descripcion":"MENINGITIS QUÍMICA"
  },
  {
    "codigo":225842008,
    "descripcion":"HALLAZGO RELACIONADO CON LA DEMOSTRACIÓN DE PRINCIPIOS ÉTICOS"
  },
  {
    "codigo":1010439000,
    "descripcion":"PÉRDIDA DE AUDICIÓN CONDUCTIVA DE OÍDO IZQUIERDO CON AUDICIÓN NORMAL DEL OÍDO DERECHO"
  },
  {
    "codigo":715527006,
    "descripcion":"SÍNDROME DE SORDERA Y OLIGODONCIA"
  },
  {
    "codigo":92935007,
    "descripcion":"FORMA ANORMAL CONGÉNITA DE HUESO PALATINO"
  },
  {
    "codigo":713692003,
    "descripcion":"LIPOATROFIA CAUSADA POR FÁRMACO ANTIRRETROVIRAL"
  },
  {
    "codigo":418780004,
    "descripcion":"CLASE I DEL CENTRO DE PREVENCIÓN Y CONTROL DE ENFERMEDADES\/LIMPIO"
  },
  {
    "codigo":254940005,
    "descripcion":"OLIGODENDROGLIOMA DE ENCÉFALO"
  },
  {
    "codigo":416945002,
    "descripcion":"APNEA RECURRENTE"
  },
  {
    "codigo":56497004,
    "descripcion":"DETERIORO DE LA INHIBICIÓN ÁCIDA DE LA LIBERACIÓN DE GASTRINA"
  },
  {
    "codigo":253105004,
    "descripcion":"AUSENCIA DEL TECHO ORBITARIO"
  },
  {
    "codigo":449713008,
    "descripcion":"ARQUEAMIENTO DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":415110002,
    "descripcion":"MIELOMA DE CÉLULAS PLASMÁTICAS\/PLASMOCITOMA"
  },
  {
    "codigo":1089711000119103,
    "descripcion":"TRASTORNO DE NERVIO VESTIBULAR IZQUIERDO"
  },
  {
    "codigo":216667000,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR BLANQUEADORES"
  },
  {
    "codigo":710022008,
    "descripcion":"MORFOLOGÍA DE CRESTA ALVEOLAR RESIDUAL DE MAXILAR SUPERIOR SIN RESISTENCIA DE LA CÚPULA PALATINA A LOS MOVIMIENTOS HORIZONTALES O VERTICALES"
  },
  {
    "codigo":249435003,
    "descripcion":"AUSENCIA DE LARINGE"
  },
  {
    "codigo":20059004,
    "descripcion":"OCLUSIÓN DE ARTERIA CEREBRAL"
  },
  {
    "codigo":282203003,
    "descripcion":"CAPAZ DE EMPEZAR A CAMINAR"
  },
  {
    "codigo":352431000119104,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE PIEL DE OREJA DERECHA"
  },
  {
    "codigo":247600002,
    "descripcion":"OLVIDA LO QUE ACABA DE OIR"
  },
  {
    "codigo":50992006,
    "descripcion":"TRISOMÍA PARCIAL 22Q"
  },
  {
    "codigo":81925000,
    "descripcion":"PLIEGUES DE VERAGUTH"
  },
  {
    "codigo":737285005,
    "descripcion":"IMPLANTE ARTICULAR IN SITU"
  },
  {
    "codigo":278533005,
    "descripcion":"TRASTORNO DE FÍSTULA ARTERIOVENOSA QUIRÚRGICA"
  },
  {
    "codigo":276698001,
    "descripcion":"DEFECTO CRANEAL PERINATAL"
  },
  {
    "codigo":1259738001,
    "descripcion":"GLIOMA MIXTO PRIMARIO"
  },
  {
    "codigo":80201000119103,
    "descripcion":"LESIÓN PIGMENTADA ATÍPICA"
  },
  {
    "codigo":735450006,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA NEUROEPITELIOMATOSA DE CAVIDAD NASAL"
  },
  {
    "codigo":80090009,
    "descripcion":"LUXACIÓN EXPUESTA DE ARTICULACIÓN METACARPOFALÁNGICA DE DEDO DE LA MANO"
  },
  {
    "codigo":1256068000,
    "descripcion":"QUERATOSIS TÉRMICA"
  },
  {
    "codigo":699012001,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR SEDANTE"
  },
  {
    "codigo":10884004,
    "descripcion":"AMENAZA DE ABORTO EN EL TERCER TRIMESTRE"
  },
  {
    "codigo":404100005,
    "descripcion":"SEUDOTUMOR INFLAMATORIO DE PIEL"
  },
  {
    "codigo":305796008,
    "descripcion":"ATENDIDO EN EL SERVICIO DE CUIDADOS INTENSIVOS"
  },
  {
    "codigo":238425003,
    "descripcion":"ERUPCIÓN MENINGOCÓCICA"
  },
  {
    "codigo":369497003,
    "descripcion":"TUMOR MALIGNO QUE COMPROMETE EL CUELLO UTERINO POR PROPAGACIÓN DIRECTA DESDE TROMPA DE FALOPIO"
  },
  {
    "codigo":205657006,
    "descripcion":"TRISOMÍA DE TODO UN CROMOSOMA, MOSAICISMO"
  },
  {
    "codigo":15864291000119103,
    "descripcion":"ATRESIA CONGÉNITA DE OÍDO EXTERNO DERECHO"
  },
  {
    "codigo":1186862006,
    "descripcion":"INFERTILIDAD MASCULINA CAUSADA POR RADIACIÓN"
  },
  {
    "codigo":236590008,
    "descripcion":"GLOMERULONEFRITIS INDUCIDA POR CITOMEGALOVIRUS"
  },
  {
    "codigo":105518009,
    "descripcion":"DESAVENENCIA CON LOS COMPAÑEROS"
  },
  {
    "codigo":300291001,
    "descripcion":"REFLUJO GÁSTRICO MODERADO"
  },
  {
    "codigo":365827005,
    "descripcion":"ALFA-FETOPROTEÍNA EN LÍQUIDO AMNIÓTICO - HALLAZGO"
  },
  {
    "codigo":890115009,
    "descripcion":"ROSÉOLA DEL IRIS POR TREPONEMA PALLIDUM"
  },
  {
    "codigo":69080001,
    "descripcion":"ACIDEMIA PROPIÓNICA"
  },
  {
    "codigo":3544004,
    "descripcion":"PREOCUPACIÓN POR COSAS TRIVIALES"
  },
  {
    "codigo":724440007,
    "descripcion":"ATEROSCLEROSIS DE ARTERIA DE MIEMBRO INFERIOR"
  },
  {
    "codigo":427693000,
    "descripcion":"VARIABILIDAD MÍNIMA DE LA FRECUENCIA CARDÍACA FETAL"
  },
  {
    "codigo":298456008,
    "descripcion":"AMPLITUD DE ROTACIÓN PASIVA HACIA LA DERECHA DE LA COLUMNA CERVICAL NORMAL"
  },
  {
    "codigo":1148589002,
    "descripcion":"HALLAZGO RELACIONADO CON PH DE SANGRE VENOSA"
  },
  {
    "codigo":230323005,
    "descripcion":"RETROCOLIS ESPASMÓDICA"
  },
  {
    "codigo":1279661009,
    "descripcion":"QUEMADURA DE DEDO DE MANO"
  },
  {
    "codigo":65410009,
    "descripcion":"MASOQUISMO SEXUAL COMPULSIVO"
  },
  {
    "codigo":292951002,
    "descripcion":"REACCIÓN ADVERSA A OFLOXACINO"
  },
  {
    "codigo":225580001,
    "descripcion":"HALLAZGO RELACIONADO CON UN DISPOSITIVO PARA ESTOMA"
  },
  {
    "codigo":1144919009,
    "descripcion":"ENFERMEDAD DE BEHCET OCULAR"
  },
  {
    "codigo":422188005,
    "descripcion":"IMPLANTE DE LENTE INTRAOCULAR DESCENTRADO"
  },
  {
    "codigo":94508007,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE RADIO"
  },
  {
    "codigo":127276009,
    "descripcion":"LESIÓN TRAUMÁTICA EN LA CABEZA CON RINORRAGIA"
  },
  {
    "codigo":192812009,
    "descripcion":"DEGENERACIÓN CEREBRAL POR BERIBERI"
  },
  {
    "codigo":1208620009,
    "descripcion":"SÍNDROME DE DISFUNCIÓN MITOCONDRIAL MÚLTIPLE TIPO 3"
  },
  {
    "codigo":123606000,
    "descripcion":"CIRROSIS COLANGIOLÍTICA"
  },
  {
    "codigo":92673009,
    "descripcion":"CARCINOMA IN SITU DE CONDUCTO PANCREÁTICO"
  },
  {
    "codigo":1336022007,
    "descripcion":"GLAUCOMA DEBIDO A QUISTE DE OJO DERECHO PROPIAMENTE DICHO"
  },
  {
    "codigo":254678009,
    "descripcion":"QUISTE TRIQUILEMAL PROLIFERANTE"
  },
  {
    "codigo":414848001,
    "descripcion":"SÍNDROME DE ABERTURA DE SALIDA TORÁCICA NEUROGÉNICO DEBIDO A BANDA CERVICAL"
  },
  {
    "codigo":185472002,
    "descripcion":"VISITA DOMICILIARIA CANCELADA POR EL PACIENTE"
  },
  {
    "codigo":449451009,
    "descripcion":"LOCALIZACIÓN SUPRACARDÍACA DE CONEXIÓN ANÓMALA DE VENA PULMONAR A VENA HEMIÁCIGOS"
  },
  {
    "codigo":283776002,
    "descripcion":"MORDEDURA DE PERRO EN EL PIE"
  },
  {
    "codigo":52565000,
    "descripcion":"ANEMIA NO MEGALOBLÁSTICA ASOCIADA A DÉFICIT NUTRICIONAL"
  },
  {
    "codigo":1363285001,
    "descripcion":"DISPLASIA ESPONDILOEPIFISARIA RELACIONADA CON MICROARN 140"
  },
  {
    "codigo":1332352008,
    "descripcion":"HIPERTROFIA DE TIBIA"
  },
  {
    "codigo":609621000,
    "descripcion":"TRASTORNO DEL PERINEO"
  },
  {
    "codigo":281941002,
    "descripcion":"FRACTURA DE TRES COLUMNAS DE VÉRTEBRA LUMBAR"
  },
  {
    "codigo":249173008,
    "descripcion":"PLACENTA ARENOSA"
  },
  {
    "codigo":183637009,
    "descripcion":"PACIENTE TRANSITORIO: SIN SEGUIMIENTO"
  },
  {
    "codigo":791000119109,
    "descripcion":"ANGINA DE PECHO ASOCIADA CON DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":247338006,
    "descripcion":"SENSACIÓN DE INTESTINO LLENO"
  },
  {
    "codigo":704255005,
    "descripcion":"FRACTURA PATOLÓGICA DE TOBILLO EN SITIO DE NEOPLASIA"
  },
  {
    "codigo":866260004,
    "descripcion":"REACCIÓN ADVERSA A ANTICONCEPTIVO ORAL"
  },
  {
    "codigo":210900007,
    "descripcion":"LESIÓN DE VASOS SANGUÍNEOS A NIVEL DE TOBILLO Y PIE"
  },
  {
    "codigo":1259476008,
    "descripcion":"DEMENCIA DEBIDA A ENFERMEDAD GENÉTICA"
  },
  {
    "codigo":276436007,
    "descripcion":"DISTROFIA MACULAR HEREDITARIA"
  },
  {
    "codigo":241833002,
    "descripcion":"ENVENENAMIENTO DEBIDO A PICADURA DE AVISPA DE MAR"
  },
  {
    "codigo":79828007,
    "descripcion":"INTOXICACIÓN POR TRISETUM FLAVESCENS"
  },
  {
    "codigo":733353006,
    "descripcion":"NEOPLASIA NEUROENDOCRINA MALIGNA PRIMARIA DE VÍA BILIAR"
  },
  {
    "codigo":307369007,
    "descripcion":"HALLAZGO RELACIONADO CON PRUEBA EN EL AIRE ESPIRADO PARA HELICOBACTER PYLORI"
  },
  {
    "codigo":403838000,
    "descripcion":"SÍNDROME DE JUNG"
  },
  {
    "codigo":895358004,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE TESTÍCULO IZQUIERDO"
  },
  {
    "codigo":305534005,
    "descripcion":"BAJO ATENCIÓN DE CIRUJANO ESPECIALISTA EN OTORRINOLARINGOLOGÍA"
  },
  {
    "codigo":239998007,
    "descripcion":"INESTABILIDAD DE LA SÍNFISIS PÚBICA"
  },
  {
    "codigo":1255806007,
    "descripcion":"LINFOMA MALIGNO DE GANGLIOS LINFÁTICOS DE CUELLO"
  },
  {
    "codigo":238163001,
    "descripcion":"DEMANDA DE OXÍGENO AUMENTADA"
  },
  {
    "codigo":74323005,
    "descripcion":"DOLOR EN REGIÓN DE CODO"
  },
  {
    "codigo":205395006,
    "descripcion":"ANGULACIÓN CONGÉNITA DE TIBIA"
  },
  {
    "codigo":926291007,
    "descripcion":"EPÍFISIS PEQUEÑA DE FALANGE DE TERCER DEDO DE PIE"
  },
  {
    "codigo":762451005,
    "descripcion":"DOLOR CRÓNICO POSTERIOR A TRAUMATISMO"
  },
  {
    "codigo":72488000,
    "descripcion":"ENFERMEDAD DE NIEMANN - PICK, TIPO C, FORMA CRÓNICA"
  },
  {
    "codigo":301864002,
    "descripcion":"SINOVITIS TRANSITORIA DE CADERA"
  },
  {
    "codigo":203560005,
    "descripcion":"TORSIÓN FEMORAL INTERNA ADQUIRIDA"
  },
  {
    "codigo":168957001,
    "descripcion":"ARTERIOGRAFÍA DE EXTREMIDAD INFERIOR: ANORMAL"
  },
  {
    "codigo":234493006,
    "descripcion":"PÚRPURA NO TROMBOCITOPÉNICA"
  },
  {
    "codigo":365565007,
    "descripcion":"ASUNTOS Y RESTRICCIONES LEGALES - HALLAZGO"
  },
  {
    "codigo":724178000,
    "descripcion":"SÍNDROME DE PARÁLISIS DE ABDUCTOR LARÍNGEO CON DISCAPACIDAD INTELECTUAL"
  },
  {
    "codigo":429266002,
    "descripcion":"GEMIDO RELACIONADO CON EL SUEÑO"
  },
  {
    "codigo":298194003,
    "descripcion":"HIPERMOVILIDAD DE ARTICULACIÓN DE DEDO PULGAR"
  },
  {
    "codigo":3282008,
    "descripcion":"QUERATITIS DE LOS SOLDADORES"
  },
  {
    "codigo":1447000,
    "descripcion":"ICTIOPARASITISMO"
  },
  {
    "codigo":165287001,
    "descripcion":"MEMORIA: TIENE CONSCIENCIA DEL LUGAR"
  },
  {
    "codigo":296359007,
    "descripcion":"SOBREDOSIS DE PARASIMPATICOMIMÉTICO"
  },
  {
    "codigo":722343009,
    "descripcion":"ENFERMEDAD POR ALMACENAMIENTO DE GLUCÓGENO DEBIDO A MALTASA ÁCIDA, DE COMIENZO TARDÍO"
  },
  {
    "codigo":425596001,
    "descripcion":"VEJIGA URINARIA NEUROGÉNICA ESPÁSTICA"
  },
  {
    "codigo":292689005,
    "descripcion":"REACCIÓN ADVERSA AL PANCURONIO"
  },
  {
    "codigo":10626431000119102,
    "descripcion":"CARBUNCO DE PULGAR DE MANO DERECHA"
  },
  {
    "codigo":94246001,
    "descripcion":"NEOPLASIA MALIGNA SECUNDARIA DE LAS MENINGES CEREBRALES"
  },
  {
    "codigo":290854004,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR TRIMIPRAMINA"
  },
  {
    "codigo":28710006,
    "descripcion":"TRASTORNO DEL METABOLISMO DE LOS ESTEROIDES"
  },
  {
    "codigo":389158007,
    "descripcion":"DISPLASIA TANATOFÓRICA, TIPO 2"
  },
  {
    "codigo":127014009,
    "descripcion":"ANGIOPATÍA PERIFÉRICA DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":289019001,
    "descripcion":"INCAPAZ DE EMPLEAR LAS MANOS PARA ALIMENTARSE"
  },
  {
    "codigo":715003002,
    "descripcion":"DIFICULTAD PARA MOVILIZARSE EN EL HOGAR"
  },
  {
    "codigo":420091004,
    "descripcion":"REACCIÓN ALÉRGICA CAUSADA POR NÍQUEL"
  },
  {
    "codigo":92411005,
    "descripcion":"NEOPLASIA BENIGNA DEL ESTÓMAGO"
  },
  {
    "codigo":26875006,
    "descripcion":"ELEVACIÓN DE UNA COLONIA BACTERIANA, CONVEXA"
  },
  {
    "codigo":188880000,
    "descripcion":"NEOPLASIA BENIGNA DE CARTÍLAGO ARITENOIDES"
  },
  {
    "codigo":1237456001,
    "descripcion":"METÁSTASIS DE CARCINOMA DE ÁNGULO HEPÁTICO"
  },
  {
    "codigo":254416009,
    "descripcion":"NEOPLASIA DE FRENILLO LINGUAL"
  },
  {
    "codigo":55973006,
    "descripcion":"PRESIÓN DE ENCLAVAMIENTO CAPILAR PULMONAR DISMINUIDA"
  },
  {
    "codigo":1268389006,
    "descripcion":"CARCINOMA PRIMARIO INDIFERENCIADO DE ESÓFAGO"
  },
  {
    "codigo":23205009,
    "descripcion":"TROMBOCITOPENIA NEONATAL TRANSITORIA"
  },
  {
    "codigo":449189009,
    "descripcion":"MASA ASOCIADA CON VALVA DE VÁLVULA AURICULOVENTRICULAR EN DEFECTO DEL TABIQUE AURICULOVENTRICULAR"
  },
  {
    "codigo":54138003,
    "descripcion":"ABSCESO DE EPIPLÓN"
  },
  {
    "codigo":185210004,
    "descripcion":"ATENDIDO EN SERVICIO DE URGENCIA HOSPITALARIA"
  },
  {
    "codigo":283514006,
    "descripcion":"HERIDA PUNZANTE DE CODO"
  },
  {
    "codigo":447354007,
    "descripcion":"INFECCIÓN INTESTINAL CAUSADA POR CAMPYLOBACTER JEJUNI"
  },
  {
    "codigo":871503001,
    "descripcion":"ALERGIA A BENSERAZIDA Y\/O LEVODOPA"
  },
  {
    "codigo":183375002,
    "descripcion":"CONVALECENCIA CONSECUTIVA A TRATAMIENTO DE FRACTURA"
  },
  {
    "codigo":248911005,
    "descripcion":"CUELLO UTERINO AUSENTE"
  },
  {
    "codigo":52303006,
    "descripcion":"EMBOLIA DE VASO SANGUÍNEO DE CUERPO CAVERNOSO DE PENE"
  },
  {
    "codigo":247076005,
    "descripcion":"PLIEGUES DE LA CÁPSULA DEL CRISTALINO EN SEUDOFAQUIA"
  },
  {
    "codigo":441849003,
    "descripcion":"RUPTURA DE MEMBRANA AMNIÓTICA DETECTADA MEDIANTE PRUEBA CON AMARILLO DE NITRAZINA (AMARILLO)"
  },
  {
    "codigo":212473005,
    "descripcion":"LESIÓN DE MÚLTIPLES MÚSCULOS Y TENDONES A NIVEL DE PIERNA"
  },
  {
    "codigo":472782001,
    "descripcion":"ESTENOSIS DE REGIÓN SUBVALVULAR DE NEOVÁLVULA PULMONAR"
  },
  {
    "codigo":733091002,
    "descripcion":"PARÁLISIS FACIAL CONGÉNITA HEREDITARIA AISLADA"
  },
  {
    "codigo":1290147003,
    "descripcion":"ARTROSIS SECUNDARIA DE HOMBRO"
  },
  {
    "codigo":12195004,
    "descripcion":"CATARATA CORONARIA"
  },
  {
    "codigo":208803002,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA NO EXPUESTA DE CODO"
  },
  {
    "codigo":44963006,
    "descripcion":"DIETA GENERAL PARA EL EMBARAZO Y LA LACTANCIA"
  },
  {
    "codigo":896931007,
    "descripcion":"FORMA DE BALA ANORMAL CONGÉNITA DE FALANGE DE PIE"
  },
  {
    "codigo":10360000,
    "descripcion":"PATAS DE GALLO"
  },
  {
    "codigo":239736003,
    "descripcion":"CONTRACTURA DE LA ARTICULACIÓN DEL PULGAR"
  },
  {
    "codigo":403576004,
    "descripcion":"PRURITO GENERALIZADO DE ETIOLOGÍA DESCONOCIDA"
  },
  {
    "codigo":1157240004,
    "descripcion":"INTOXICACIÓN POR ANFETAMINA Y\/O DERIVADO DE ANFETAMINA"
  },
  {
    "codigo":205133005,
    "descripcion":"POLIDACTILIA POSAXIAL DE DEDO DEL PIE"
  },
  {
    "codigo":399906000,
    "descripcion":"HAMARTOMA DE APÉNDICE CUTÁNEO"
  },
  {
    "codigo":236066002,
    "descripcion":"DIARREA POR PROTOTECA"
  },
  {
    "codigo":301602003,
    "descripcion":"SUBE Y BAJA ESCALERAS SENTADO"
  },
  {
    "codigo":11802291000119109,
    "descripcion":"AMPOLLA TRAUMÁTICA DE PIEL DE GENITALES MASCULINOS"
  },
  {
    "codigo":39458004,
    "descripcion":"INFECCIÓN CAUSADA POR CYSTOISOSPORA"
  },
  {
    "codigo":398071000,
    "descripcion":"EPIDERMÓLISIS BULLOSA SIMPLE TIPO OGNA"
  },
  {
    "codigo":203298009,
    "descripcion":"OSTEOMIELITIS SUBAGUDA DE COLUMNA VERTEBRAL LUMBAR"
  },
  {
    "codigo":1153570009,
    "descripcion":"DEPRESIÓN RESISTENTE AL TRATAMIENTO"
  },
  {
    "codigo":4855003,
    "descripcion":"RETINOPATÍA DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":299767003,
    "descripcion":"REFLEJO DE PRENSIÓN PLANTAR DE RESULTADO DUDOSO"
  },
  {
    "codigo":15953741000119104,
    "descripcion":"ABSCESO DE MAMA DERECHA ASOCIADO CON LA LACTANCIA"
  },
  {
    "codigo":365303001,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA SACAR UN ENCHUFE ELÉCTRICO DE UN TOMACORRIENTE"
  },
  {
    "codigo":723916001,
    "descripcion":"TRASTORNO DE SUFRIMIENTO CORPORAL"
  },
  {
    "codigo":168695009,
    "descripcion":"RADIOGRAFÍA SIMPLE DE CALCÁNEO NORMAL"
  },
  {
    "codigo":166860003,
    "descripcion":"NIVEL DE AMINOÁCIDOS SÉRICOS FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":232396003,
    "descripcion":"ENFERMEDAD OSTEOMEATAL CRÓNICA"
  },
  {
    "codigo":234231009,
    "descripcion":"DESPLAZAMIENTO DE ELECTRODO DE DESFRIBILADOR CARDÍACO IMPLANTADO"
  },
  {
    "codigo":363468009,
    "descripcion":"NEOPLASIA MALIGNA DEL LÓBULO TEMPORAL"
  },
  {
    "codigo":722081007,
    "descripcion":"NEFROPATÍA OBSTRUCTIVA DEBIDA A CARCINOMA DE PRÓSTATA"
  },
  {
    "codigo":226707431000119102,
    "descripcion":"SINOSTOSIS RADIOCUBITAL DE AMBOS ANTEBRAZOS POSTERIOR A LESIÓN TRAUMÁTICA"
  },
  {
    "codigo":195958001,
    "descripcion":"ENFISEMA BULLOSO SEGMENTARIO"
  },
  {
    "codigo":292427001,
    "descripcion":"REACCIÓN ADVERSA AL ESMOLOL"
  },
  {
    "codigo":1144395006,
    "descripcion":"HIPOPLASIA CONGÉNITA DE ARTERIA CARÓTIDA"
  },
  {
    "codigo":30283007,
    "descripcion":"ÚLCERA FRAMBESIAL INICIAL"
  },
  {
    "codigo":126752005,
    "descripcion":"NEOPLASIA DE VASO SANGUÍNEO DE PIE"
  },
  {
    "codigo":93984006,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL RECTO"
  },
  {
    "codigo":290592006,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR TIO-TEPA"
  },
  {
    "codigo":92149002,
    "descripcion":"NEOPLASIA BENIGNA DE LOS GANGLIOS LINFÁTICOS INTERCOSTALES"
  },
  {
    "codigo":288757002,
    "descripcion":"INCAPAZ DE COMUNICAR PENSAMIENTOS"
  },
  {
    "codigo":26613009,
    "descripcion":"BRONCOCELE"
  },
  {
    "codigo":254154003,
    "descripcion":"DEFECTO ECTODÉRMICO CONGÉNITO"
  },
  {
    "codigo":10684391000119109,
    "descripcion":"NÓDULO DEL TEJIDO CELULAR SUBCUTÁNEO DE DEDO DE LA MANO DERECHA"
  },
  {
    "codigo":1237194006,
    "descripcion":"ENFERMEDAD ASOCIADA A ANTICUERPOS CONTRA GLUCOPROTEÍNA DE MIELINA DE OLIGODENDROCITO"
  },
  {
    "codigo":90314006,
    "descripcion":"CREPITACIÓN ARTICULAR PERCEPTIBLE"
  },
  {
    "codigo":874911000,
    "descripcion":"HIPERPLASIA NODULAR DE LA CORTEZA SUPRARRENAL"
  },
  {
    "codigo":55711009,
    "descripcion":"SÍNDROME DE EHLERS-DANLOS ARTROCALASIA"
  },
  {
    "codigo":86644006,
    "descripcion":"DIAGNÓSTICO DE ENFERMERÍA"
  },
  {
    "codigo":283252006,
    "descripcion":"VIDRIO EN LA PALMA DE LA MANO"
  },
  {
    "codigo":1231689000,
    "descripcion":"OSCILACIONES SACÁDICAS VOLUNTARIAS"
  },
  {
    "codigo":707401000,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE CÉLULAS CLARAS DE OROFARINGE"
  },
  {
    "codigo":1073281000119107,
    "descripcion":"ARTRITIS DE MANO DERECHA CAUSADA POR BACTERIAS"
  },
  {
    "codigo":840308008,
    "descripcion":"HIPERTENSIÓN PULMONAR SEVERA"
  },
  {
    "codigo":445257004,
    "descripcion":"SÍNDROME DE NANCE-HORAN"
  },
  {
    "codigo":1297225005,
    "descripcion":"CIERRE DE ÁNGULO AGUDO DE OJO DERECHO CAUSADO POR FÁRMACO"
  },
  {
    "codigo":314185007,
    "descripcion":"ANEURISMA AÓRTICO YUXTARRENAL"
  },
  {
    "codigo":17438000,
    "descripcion":"ÁNTRAX DE LA PARED DEL TÓRAX"
  },
  {
    "codigo":12269851000119103,
    "descripcion":"QUEMADURA QUÍMICA DE ESPESOR TOTAL DE ANTEBRAZO DERECHO"
  },
  {
    "codigo":246814008,
    "descripcion":"EXCESO DE TEJIDO PALPEBRAL"
  },
  {
    "codigo":736499003,
    "descripcion":"PÓLIPO DE FOSA NASAL Y\/O SENO PARANASAL"
  },
  {
    "codigo":81139004,
    "descripcion":"MIOESFERULOSIS"
  },
  {
    "codigo":212211003,
    "descripcion":"LESIÓN DE LA RAÍZ DEL NERVIO DORSAL - D6"
  },
  {
    "codigo":703731006,
    "descripcion":"PSEUDOARTROSIS DE ARTICULACIÓN DE TOBILLO CON INFECCIÓN"
  },
  {
    "codigo":46536000,
    "descripcion":"ENFERMEDAD INFLAMATORIA TUBO - OVÁRICA"
  },
  {
    "codigo":308680003,
    "descripcion":"CONVULSIÓN INDUCIDA POR HIPOGLUCEMIA"
  },
  {
    "codigo":208541001,
    "descripcion":"FRACTURA EXPUESTA SUBCAPITAL DE FÉMUR PROXIMAL GRADO I DE GARDEN"
  },
  {
    "codigo":44701004,
    "descripcion":"LUXACIONES TRAUMÁTICAS NO EXPUESTAS DE VÉRTEBRAS CERVICALES MÚLTIPLES"
  },
  {
    "codigo":110237009,
    "descripcion":"CONTUSIÓN DE LA APÓFISIS CONDÍLEA DE LA MANDÍBULA"
  },
  {
    "codigo":1255282002,
    "descripcion":"DOLOR DEBIDO A ARTROPLASTIA DE MUÑECA Y POSTERIOR A ELLA"
  },
  {
    "codigo":42866003,
    "descripcion":"ESCLEROSIS CORONARIA CONGÉNITA"
  },
  {
    "codigo":403314007,
    "descripcion":"HIPERTRICOSIS EN EL HIPERTIROIDISMO"
  },
  {
    "codigo":237639008,
    "descripcion":"HIPOGLUCEMIA NUTRICIONAL"
  },
  {
    "codigo":170268006,
    "descripcion":"EXAMEN PEDIÁTRICO A LOS 6 MESES, ANORMAL - PARA OBSERVACIÓN"
  },
  {
    "codigo":301340007,
    "descripcion":"HALLAZGO RELACIONADO CON LOS OLORES CORPORALES"
  },
  {
    "codigo":201201000,
    "descripcion":"ECCEMA VESICULAR DE PIE"
  },
  {
    "codigo":397809001,
    "descripcion":"HEMORRAGIA EXTRADURAL INTRACRANEAL NO TRAUMÁTICA"
  },
  {
    "codigo":1217009002,
    "descripcion":"LINFEDEMA PRIMARIO"
  },
  {
    "codigo":233969003,
    "descripcion":"ESTENOSIS DE LA ARTERIA FEMORAL SUPERFICIAL"
  },
  {
    "codigo":102897001,
    "descripcion":"SENSACIÓN DE INTOXICACIÓN"
  },
  {
    "codigo":299505006,
    "descripcion":"AMPLITUD DE MOVIMIENTO PASIVO DE SUPINACIÓN MEDIOTARSIANA AUMENTADA"
  },
  {
    "codigo":70129008,
    "descripcion":"PLACENTA ACRETA"
  },
  {
    "codigo":35526001,
    "descripcion":"EPIDIDIMORQUITIS GONOCÓCICA CRÓNICA"
  },
  {
    "codigo":428742001,
    "descripcion":"NIVEL DE TRIPSINÓGENO INMUNORREACTIVO POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":232134006,
    "descripcion":"MIOPÍA AXIAL CONGÉNITA"
  },
  {
    "codigo":721819001,
    "descripcion":"ENCEFALITIS CAUSADA POR SCHISTOSOMA HAEMATOBIUM"
  },
  {
    "codigo":735880006,
    "descripcion":"FRACTURA DE HUESO CUNEIFORME INTERNO"
  },
  {
    "codigo":295835002,
    "descripcion":"SOBREDOSIS DE AMITRIPTILINA"
  },
  {
    "codigo":426907004,
    "descripcion":"ENFERMEDAD DE PEQUEÑOS VASOS DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":230299004,
    "descripcion":"ENFERMEDAD DE HUNTINGTON DE INICIO JUVENIL"
  },
  {
    "codigo":263067005,
    "descripcion":"FRACTURA-LUXACIÓN DE SÍNFISIS PÚBICA"
  },
  {
    "codigo":294000006,
    "descripcion":"ALERGIA A LACIDIPINO"
  },
  {
    "codigo":15713001000119100,
    "descripcion":"INFARTO AGUDO DE MIOCARDIO DE AURÍCULA CON ELEVACIÓN DE SEGMENTO ST"
  },
  {
    "codigo":64624009,
    "descripcion":"ENCEFALOPATÍA HIPOGLUCÉMICA"
  },
  {
    "codigo":359536009,
    "descripcion":"APLASIA MEGACARIOCÍTICA"
  },
  {
    "codigo":95557003,
    "descripcion":"SECUESTRO HEPÁTICO DE GLÓBULOS ROJOS"
  },
  {
    "codigo":292165004,
    "descripcion":"REACCIÓN ADVERSA A LA KETAMINA"
  },
  {
    "codigo":423237006,
    "descripcion":"ESTADO DE DESEMPEÑO ECOG - GRADO 4"
  },
  {
    "codigo":161093007,
    "descripcion":"VACACIONES EN CAMPAMENTO"
  },
  {
    "codigo":290330001,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR MEDIOS DE CONTRASTE PARA RESONANCIA MAGNÉTICA"
  },
  {
    "codigo":93722002,
    "descripcion":"NEOPLASIA PRIMARIA MALIGNA DE HUESO DE MIEMBRO INFERIOR"
  },
  {
    "codigo":126490003,
    "descripcion":"NEOPLASIA DE LAS GLÁNDULAS SUDORÍPARAS"
  },
  {
    "codigo":1142298007,
    "descripcion":"CEJA HORIZONTAL"
  },
  {
    "codigo":419567006,
    "descripcion":"CON DELIRIO"
  },
  {
    "codigo":91887009,
    "descripcion":"AUSENCIA CONGÉNITA DE HUESO HIOIDES"
  },
  {
    "codigo":384964003,
    "descripcion":"DIAFRAGMA AFECTADO POR PROPAGACIÓN DIRECTA DE NEOPLASIA MALIGNA"
  },
  {
    "codigo":712644005,
    "descripcion":"INFLAMACIÓN DE NERVIO OBTURADOR"
  },
  {
    "codigo":1204164005,
    "descripcion":"ESTENOSIS DE ARTERIA BASILAR ASINTOMÁTICA"
  },
  {
    "codigo":57284007,
    "descripcion":"ASFIXIA NEONATAL SEVERA"
  },
  {
    "codigo":286660008,
    "descripcion":"CONDUCTA INHIBIDA"
  },
  {
    "codigo":253892009,
    "descripcion":"DIVERTÍCULO CONGÉNITO DE URÉTER"
  },
  {
    "codigo":284825003,
    "descripcion":"NO SE ARRODILLA EN LA BAÑERA"
  },
  {
    "codigo":22681004,
    "descripcion":"QUISTE MIÓTICO EN EL MARGEN PUPILAR"
  },
  {
    "codigo":448665005,
    "descripcion":"NEOPLASIA EPITELIAL MALIGNA DE HIPOFARINGE"
  },
  {
    "codigo":219289006,
    "descripcion":"EFECTOS TARDÍOS DE LESIÓN POR INTERVENCIÓN LEGAL"
  },
  {
    "codigo":11862761000119108,
    "descripcion":"ABRASIÓN DE PIEL DE REGIÓN DE TOBILLO DERECHO"
  },
  {
    "codigo":282990000,
    "descripcion":"CAPAZ DE VOLTEAR LA CABEZA"
  },
  {
    "codigo":1003886004,
    "descripcion":"DUPLICACIÓN DE PORCIÓN PROXIMAL DEL BRAZO CORTO DEL CROMOSOMA 8"
  },
  {
    "codigo":414062007,
    "descripcion":"OJO SECO DESPUÉS DE KERATOMILEUSIS IN SITU ASISTIDA CON LÁSER"
  },
  {
    "codigo":182851001,
    "descripcion":"FÁRMACO NO RETIRADO - SIN NINGUNA RAZÓN"
  },
  {
    "codigo":248387005,
    "descripcion":"SUTURA CRANEAL - HALLAZGO"
  },
  {
    "codigo":1196824005,
    "descripcion":"LIPOMA DE INTESTINO GRUESO"
  },
  {
    "codigo":11809821000119100,
    "descripcion":"HERIDA DE REGIÓN DE RODILLA DERECHA DEBIDA A PICADURA DE INSECTO NO VENENOSO"
  },
  {
    "codigo":312088007,
    "descripcion":"GASTROENTERITIS FÚNGICA"
  },
  {
    "codigo":703469002,
    "descripcion":"OTITIS MEDIA BACTERIANA"
  },
  {
    "codigo":408557004,
    "descripcion":"EVALUACIÓN DE CAÍDAS POR EL EQUIPO DE ATENCIÓN PRIMARIA OMITIDA"
  },
  {
    "codigo":310253005,
    "descripcion":"DENSITOMETRÍA DE HUESO, NORMAL"
  },
  {
    "codigo":211949006,
    "descripcion":"CORROSIÓN DE TERCER GRADO DE MUÑECA Y MANO"
  },
  {
    "codigo":277485007,
    "descripcion":"HIPOPLASIA PULMONAR SECUNDARIA"
  },
  {
    "codigo":308418005,
    "descripcion":"SITUACIÓN DEL EXTENDIDO CERVICAL"
  },
  {
    "codigo":210114006,
    "descripcion":"LESIÓN TRAUMÁTICA DE INTESTINO DELGADO CON HERIDA ABIERTA HACIA CAVIDAD ABDOMINAL"
  },
  {
    "codigo":109975001,
    "descripcion":"LINFOMA DE ZONA T (CLÍNICO)"
  },
  {
    "codigo":239212001,
    "descripcion":"DEFLACIÓN DEL EXPANSOR TISULAR"
  },
  {
    "codigo":403052002,
    "descripcion":"TIÑA DE LA MANO CAUSADA POR TRICHOPHYTON VIOLACEUM"
  },
  {
    "codigo":372119009,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA CABEZA DEL PÁNCREAS"
  },
  {
    "codigo":1255020004,
    "descripcion":"DEPENDENCIA COMBINADA DE SUSTANCIAS EXCEPTO OPIOIDES, EN REMISIÓN"
  },
  {
    "codigo":75372006,
    "descripcion":"ANOMALÍA CONGÉNITA DE VÁLVULA MITRAL"
  },
  {
    "codigo":302913000,
    "descripcion":"CALCINOSIS PULMONAR DIFUSA"
  },
  {
    "codigo":71702000,
    "descripcion":"ENFERMEDAD DE LA ORINA EN JARABE DE ARCE, FORMA DESHIDROGENASA MÚLTIPLE"
  },
  {
    "codigo":366614001,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA MANTENER EL EQUILIBRIO"
  },
  {
    "codigo":170006002,
    "descripcion":"PESO DEL NIÑO MENOR AL PERCENTILO TRES"
  },
  {
    "codigo":1251350007,
    "descripcion":"OCLUSIÓN DE MICROVASCULATURA DE PIEL DEBIDA A EMBOLIA CARDÍACA"
  },
  {
    "codigo":399382009,
    "descripcion":"DISPLASIA DE VULVA"
  },
  {
    "codigo":364779005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA BEBER"
  },
  {
    "codigo":200939005,
    "descripcion":"LUPUS ERITEMATOSO MIGRATORIO"
  },
  {
    "codigo":299243005,
    "descripcion":"AMPLITUD DE FLEXIÓN ACTIVA DE LA CADERA DISMINUIDA"
  },
  {
    "codigo":233707008,
    "descripcion":"EDEMA PULMONAR DE LAS ALTURAS"
  },
  {
    "codigo":231872000,
    "descripcion":"TRASTORNO ESCLERAL Y EPIESCLERAL"
  },
  {
    "codigo":102635008,
    "descripcion":"DEFICIENCIA AGUDA"
  },
  {
    "codigo":29201000175101,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN EN GLÚTEO DERECHO"
  },
  {
    "codigo":1149376001,
    "descripcion":"SOBREDOSIS INTENCIONAL DE DEXTROPROPOXIFENO Y\/O PARACETAMOL"
  },
  {
    "codigo":788928001,
    "descripcion":"MUTILACIÓN DE GENITALES FEMENINOS TIPO 3B"
  },
  {
    "codigo":166336006,
    "descripcion":"NIVEL DE HORMONA TIROESTIMULANTE EN SUERO DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":2496007,
    "descripcion":"ACALCULIA"
  },
  {
    "codigo":787093004,
    "descripcion":"SÍNDROME DE RETRASO DEL DESARROLLO Y DISMORFISMO FACIAL DEBIDO A DEFICIENCIA DEL GEN SIMILAR A LA SUBUNIDAD 13 DEL COMPLEJO MEDIADOR"
  },
  {
    "codigo":262805007,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA VESÍCULA BILIAR"
  },
  {
    "codigo":197269008,
    "descripcion":"NECROSIS AGUDA DE HÍGADO"
  },
  {
    "codigo":129898001,
    "descripcion":"TRASTORNO DEL APARATO CARDIOVASCULAR"
  },
  {
    "codigo":721557009,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE GLÁNDULA PARÓTIDA"
  },
  {
    "codigo":295573007,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE BENZOCAÍNA"
  },
  {
    "codigo":293738006,
    "descripcion":"ALERGIA A LEVAMISOL"
  },
  {
    "codigo":717887003,
    "descripcion":"SÍNDROME DE BIEMOND TIPO 2"
  },
  {
    "codigo":783423004,
    "descripcion":"ANEURISMA DE LA ZONA DE LA ARTERIA COMUNICANTE POSTERIOR DE LA CARÓTIDA INTERNA"
  },
  {
    "codigo":128063006,
    "descripcion":"DERIVACIÓN PORTOSISTÉMICA EXTRAHEPÁTICA CONGÉNITA"
  },
  {
    "codigo":95295007,
    "descripcion":"VÉRTEBRA ESTERNAL FUSIONADA SUPERNUMERARIA"
  },
  {
    "codigo":1142036000,
    "descripcion":"INFECCIÓN NEONATAL DE PIEL CAUSADA POR PSEUDOMONAS"
  },
  {
    "codigo":291903007,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR HEPARINA"
  },
  {
    "codigo":93460005,
    "descripcion":"COSTILLA SUPERNUMERARIA COMPLETA"
  },
  {
    "codigo":288081000119106,
    "descripcion":"INSOMNIO CONDUCTUAL INFANTIL, TIPO COMBINADO"
  },
  {
    "codigo":290068005,
    "descripcion":"MAMA DESPIGMENTADA"
  },
  {
    "codigo":26089000,
    "descripcion":"INFECCIÓN POR TREMATODOS"
  },
  {
    "codigo":386537007,
    "descripcion":"PILOROSPASMO PSICÓGENO"
  },
  {
    "codigo":253630000,
    "descripcion":"DILATACIÓN DEL TRONCO PULMONAR"
  },
  {
    "codigo":417470001,
    "descripcion":"HALLAZGO RELACIONADO CON HUESO DE LA PELVIS"
  },
  {
    "codigo":89790007,
    "descripcion":"GASTRITIS ANTRAL CRÓNICA"
  },
  {
    "codigo":87955000,
    "descripcion":"ESTADO DE PORTADOR, ENFERMEDAD SINTOMÁTICA"
  },
  {
    "codigo":22419002,
    "descripcion":"TRASTORNO DEL ESTADO DE ÁNIMO CON SÍNTOMAS MIXTOS, POR UNA ENFERMEDAD MÉDICA GENERAL"
  },
  {
    "codigo":1080811000119104,
    "descripcion":"HISTIOCITOMA FIBROSO MALIGNO PRIMARIO DE PARTES BLANDAS DE CADERA IZQUIERDA"
  },
  {
    "codigo":55187005,
    "descripcion":"SIGNO DE TARNIER"
  },
  {
    "codigo":43341000087101,
    "descripcion":"LACERACIÓN SIMPLE DE PABELLÓN AURICULAR IZQUIERDO"
  },
  {
    "codigo":186259007,
    "descripcion":"ABSCESO TUBERCULOSO ESCROFULOSO"
  },
  {
    "codigo":45901000087102,
    "descripcion":"ENFERMEDAD CAUSADA POR VIRUS DE ÉBOLA"
  },
  {
    "codigo":40781000087102,
    "descripcion":"ABRASIÓN DE PIEL DE GLÚTEO DERECHO"
  },
  {
    "codigo":38221000087106,
    "descripcion":"HIPOCINESIA DE MIOCARDIO DE VÉRTICE DE VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":48461000087101,
    "descripcion":"FRACTURA DE TERCER HUESO METATARSIANO DE PIE IZQUIERDO"
  },
  {
    "codigo":315496004,
    "descripcion":"NACIDO EN PAKISTÁN"
  },
  {
    "codigo":282728007,
    "descripcion":"LESIÓN CARDIOVASCULAR"
  },
  {
    "codigo":446568009,
    "descripcion":"INFECCIÓN DE HERIDA PUNZANTE"
  },
  {
    "codigo":706877002,
    "descripcion":"PROBLEMA CON ALTO GRADO DE COMPLEJIDAD DE RÉGIMEN TERAPÉUTICO"
  },
  {
    "codigo":248125007,
    "descripcion":"NO SABE QUE COMIDA ÉL O ELLA QUIERE"
  },
  {
    "codigo":1263933007,
    "descripcion":"HEMORRAGIA INTRACRANEAL EXTRADURAL FETAL"
  },
  {
    "codigo":18749008,
    "descripcion":"COILONIQUIA CONGÉNITA"
  },
  {
    "codigo":16291461000119102,
    "descripcion":"UÑA ENCARNADA DE DEDOS DE AMBOS PIES"
  },
  {
    "codigo":279058003,
    "descripcion":"DOLOR NEUROGÉNICO"
  },
  {
    "codigo":894991851000119108,
    "descripcion":"LACERACIÓN DE ARTERIA SUBCLAVIA"
  },
  {
    "codigo":1296701007,
    "descripcion":"HIPERTENSIÓN OCULAR BILATERAL DEBIDA A PRESIÓN VENOSA EPIESCLERAL AUMENTADA"
  },
  {
    "codigo":311826007,
    "descripcion":"EDEMA ENCEFÁLICO TRAUMÁTICO CON HERIDA INTRACRANEAL ABIERTA"
  },
  {
    "codigo":277223000,
    "descripcion":"MUCOSA NASAL INFLAMADA"
  },
  {
    "codigo":703207000,
    "descripcion":"OCLUSIÓN DE ARTERIA CEREBRAL ANTERIOR ASINTOMÁTICA"
  },
  {
    "codigo":735975001,
    "descripcion":"CHOQUE ANAFILÁCTICO CAUSADO POR SUERO Y DEBIDO A ELLA"
  },
  {
    "codigo":1356732000,
    "descripcion":"HERIDAS CERRADAS MÚLTIPLES DE VASO DIGITAL DE MANO"
  },
  {
    "codigo":1111471000000102,
    "descripcion":"ÁNGULO CERRADO PRIMARIO AGUDO"
  },
  {
    "codigo":111548007,
    "descripcion":"SÍNDROME DE ORIGEN DIENCÉFALO - HIPOFISARIO"
  },
  {
    "codigo":404625000,
    "descripcion":"POSICIÓN ANÓMALA DE PÁRPADO"
  },
  {
    "codigo":275388009,
    "descripcion":"INTOXICACIÓN POR ANTIHISTAMÍNICOS"
  },
  {
    "codigo":240785000,
    "descripcion":"CONIDIOBOLOMICOSIS DISEMINADA"
  },
  {
    "codigo":699537002,
    "descripcion":"HISTIOCITOSIS ESCLEROSANTE POLIOSTÓTICA"
  },
  {
    "codigo":371857005,
    "descripcion":"FUNCIÓN SISTÓLICA Y MOVILIDAD DE LA PARED DEL VENTRÍCULO IZQUIERDO, NORMALES"
  },
  {
    "codigo":208017005,
    "descripcion":"FRACTURA VERTEBRAL EXPUESTA CON LESIÓN POSTERIOR DE MÉDULA ESPINAL CERVICAL, C1-4"
  },
  {
    "codigo":11409005,
    "descripcion":"POSICIÓN OCCIPITOILÍACA IZQUIERDA ANTERIOR"
  },
  {
    "codigo":109713009,
    "descripcion":"ALVÉOLO DENTAL DELGADO"
  },
  {
    "codigo":1254758002,
    "descripcion":"INTOXICACIÓN AUTOINFLIGIDA CON SUSTANCIA CORROSIVA"
  },
  {
    "codigo":1156454002,
    "descripcion":"CARCINOMA EMBRIONARIO"
  },
  {
    "codigo":402790006,
    "descripcion":"FIEBRE PERIÓDICA HEREDITARIA"
  },
  {
    "codigo":1287526008,
    "descripcion":"ABRASIÓN DE PIEL DE CUERO CABELLUDO DEBIDA A TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":400955001,
    "descripcion":"EPICANTO TARSAL"
  },
  {
    "codigo":1285691002,
    "descripcion":"ANOMALÍA CONGÉNITA DE VENA RENAL"
  },
  {
    "codigo":7739007,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE PARED TORÁCICA SIN INFECCIÓN"
  },
  {
    "codigo":40507009,
    "descripcion":"HIPERMOVILIDAD MUSCULOESQUELÉTICA"
  },
  {
    "codigo":300816002,
    "descripcion":"CUIDA DE UNA MASCOTA"
  },
  {
    "codigo":399120006,
    "descripcion":"CATARATA INFANTIL"
  },
  {
    "codigo":169744007,
    "descripcion":"CAMBIO DE LACTANCIA MATERNA A LACTANCIA ARTIFICIAL"
  },
  {
    "codigo":366352007,
    "descripcion":"POSICIÓN DE PEZÓN - HALLAZGO"
  },
  {
    "codigo":724965001,
    "descripcion":"DISTENSIÓN DE MÚSCULO FLEXOR A LA ALTURA DEL ANTEBRAZO"
  },
  {
    "codigo":4069002,
    "descripcion":"LESIÓN TRAUMÁTICA ANÓXICA DEL CEREBRO DURANTE UN PROCEDIMIENTO Y\/O COMO CONSECUENCIA DE ÉL"
  },
  {
    "codigo":297146000,
    "descripcion":"TROMBOSIS DE ARTERIA HUMERAL"
  },
  {
    "codigo":428218004,
    "descripcion":"ARTRITIS ALÉRGICA DE COLUMNA VERTEBRAL"
  },
  {
    "codigo":723130007,
    "descripcion":"LESIÓN DE FOSA POSTERIOR DE CAVIDAD CRANEAL"
  },
  {
    "codigo":721295000,
    "descripcion":"ANEMIA POR DEFICIENCIA ADQUIRIDA DE TIAMINA"
  },
  {
    "codigo":33167004,
    "descripcion":"COMPLICACIÓN DEL HÍGADO TRASPLANTADO"
  },
  {
    "codigo":295311004,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE AGENTE ANTIINFLAMATORIO NO ESTEROIDE"
  },
  {
    "codigo":459151006,
    "descripcion":"ENDOCARDITIS INFECCIOSA DE VÁLVULA TRICÚSPIDE"
  },
  {
    "codigo":31332003,
    "descripcion":"ALTERACIÓN EN EL ESTILO DE VIDA, ASOCIADA CON LA COMUNIDAD"
  },
  {
    "codigo":129636003,
    "descripcion":"TRASTORNO DE LA CORTEZA ADRENAL"
  },
  {
    "codigo":783161005,
    "descripcion":"DEMENCIA FAMILIAR TIPO BRITÁNICA"
  },
  {
    "codigo":95033005,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL LÓBULO SUPERIOR DERECHO DEL PULMÓN"
  },
  {
    "codigo":1083321000119108,
    "descripcion":"INFLAMACIÓN CRÓNICA DE AMBAS MASTOIDES"
  },
  {
    "codigo":226105005,
    "descripcion":"DIETA CON ALTO CONTENIDO DE ÁCIDOS GRASOS N-6 POLINSATURADOS"
  },
  {
    "codigo":93198004,
    "descripcion":"LINFOMA MALIGNO DEL BAZO"
  },
  {
    "codigo":319571000119103,
    "descripcion":"ARTRITIS REACTIVA DE ARTICULACIÓN DE REGIÓN DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":289806004,
    "descripcion":"MOCO CERVICAL - HALLAZGO"
  },
  {
    "codigo":224270005,
    "descripcion":"HOGAR SUCIO"
  },
  {
    "codigo":191502008,
    "descripcion":"ESTADO CONFUSIONAL AGUDO, DE ORIGEN INFECCIOSO"
  },
  {
    "codigo":124131005,
    "descripcion":"DEFICIENCIA DE L - ARABINOSA DESHIDROGENASA"
  },
  {
    "codigo":286136005,
    "descripcion":"INCAPAZ DE LIMPIAR LOS ELECTRODOMÉSTICOS"
  },
  {
    "codigo":284301000,
    "descripcion":"INCAPAZ DE REALIZAR LA PRENSIÓN CON OPOSICIÓN DEL PULGAR"
  },
  {
    "codigo":22157005,
    "descripcion":"ÚLCERA PÉPTICA AGUDA CON HEMORRAGIA PERO SIN OBSTRUCCIÓN"
  },
  {
    "codigo":448141006,
    "descripcion":"ESPÉCIMEN INSATISFACTORIO PARA LA EVALUACIÓN DEBIDO A DEGENERACIÓN CELULAR ACENTUADA"
  },
  {
    "codigo":249698008,
    "descripcion":"COSTILLA GRANDE"
  },
  {
    "codigo":773986009,
    "descripcion":"SÍNDROME DE NEVO EPIDÉRMICO VERRUGOSO CON ANGIODISPLASIA Y ANEURISMA"
  },
  {
    "codigo":444471002,
    "descripcion":"ZONA ROJA EN LA ESTIMACIÓN DE PESO PEDIÁTRICO DE BROSELOW LUTEN"
  },
  {
    "codigo":49420001,
    "descripcion":"PÉNFIGO VULGAR"
  },
  {
    "codigo":16652001,
    "descripcion":"ENFERMEDAD DE FABRY"
  },
  {
    "codigo":1163532007,
    "descripcion":"INFECCIÓN DE SISTEMA NERVIOSO CAUSADA POR ADENOVIRUS"
  },
  {
    "codigo":80353004,
    "descripcion":"CARIES DEL ESMALTE"
  },
  {
    "codigo":768481005,
    "descripcion":"HIFAS NO RAMIFICADAS DEL REINO FUNGI DETECTADAS"
  },
  {
    "codigo":14817008,
    "descripcion":"EFECTO TARDÍO DE LESIÓN TRAUMÁTICA"
  },
  {
    "codigo":307894002,
    "descripcion":"ESTADO DE REGISTRO EN LA COMPUTADORA"
  },
  {
    "codigo":111286002,
    "descripcion":"ENDOCARDITIS BACTERIANA AGUDA"
  },
  {
    "codigo":209590005,
    "descripcion":"DESGARRO COMPLETO DE LIGAMENTO RADIOSEMILUNAR"
  },
  {
    "codigo":373430008,
    "descripcion":"EDEMA DEL ESTROMA CORNEAL"
  },
  {
    "codigo":764811001,
    "descripcion":"INFESTACIÓN DE CAVIDAD CORPORAL CAUSADA POR LARVAS DE MOSCA"
  },
  {
    "codigo":699275001,
    "descripcion":"APLASIA DE DERIVADOS DE LOS CONDUCTOS DE MÜLLER Y DISFUNCIÓN OVÁRICA POR ANOMALÍA DEL GEN WNT4"
  },
  {
    "codigo":12982008,
    "descripcion":"INTENSIDAD DISMINUIDA DEL PRIMER RUIDO CARDÍACO, R>1<"
  },
  {
    "codigo":207755005,
    "descripcion":"FRACTURA NO EXPUESTA DE LA APÓFISIS CONDÍLEA DE LA MANDÍBULA"
  },
  {
    "codigo":240523007,
    "descripcion":"FIEBRE HEMORRÁGICA VIRAL"
  },
  {
    "codigo":9312005,
    "descripcion":"RINITIS NECRÓTICA"
  },
  {
    "codigo":238688005,
    "descripcion":"URTICARIA REFLEJA POR FRÍO"
  },
  {
    "codigo":402528005,
    "descripcion":"CARCINOMA BASOCELULAR TIPO QUERATÓSICO"
  },
  {
    "codigo":369760009,
    "descripcion":"CONFIGURACIÓN TUMORAL ULCERADA"
  },
  {
    "codigo":73013002,
    "descripcion":"TRASTORNO DE NERVIO CRANEAL"
  },
  {
    "codigo":1156192009,
    "descripcion":"INESTABILIDAD HABITACIONAL DEBIDA A RIESGO INMINENTE DE SINHOGARISMO"
  },
  {
    "codigo":1252661009,
    "descripcion":"PAREJA QUE COCINA ALIMENTOS PARA SUJETO"
  },
  {
    "codigo":169482003,
    "descripcion":"DISPOSITIVO ANTICONCEPTIVO INTRAUTERINO - NO SE PRESENTÓ AL CONTROL"
  },
  {
    "codigo":235018003,
    "descripcion":"ESTOMATITIS ARTEFACTA"
  },
  {
    "codigo":890378005,
    "descripcion":"CORISTOMA OCULAR EPIBULBAR CONGÉNITO BILATERAL"
  },
  {
    "codigo":366090007,
    "descripcion":"MOVIMIENTOS ASOCIADOS DURANTE EL MOVIMIENTO OCULAR - HALLAZGO"
  },
  {
    "codigo":202250009,
    "descripcion":"LUXACIÓN RECURRENTE DE TOBILLO"
  },
  {
    "codigo":167647002,
    "descripcion":"MATERIA FECAL: EFECTO NORMAL DEL PÁNCREAS"
  },
  {
    "codigo":296884001,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE NANDROLONA"
  },
  {
    "codigo":722868004,
    "descripcion":"ANOMALÍA CONGÉNITA DEL DESARROLLO DE CONDUCTO CÍSTICO"
  },
  {
    "codigo":67508005,
    "descripcion":"HERNIA UMBILICAL CON GANGRENA"
  },
  {
    "codigo":15723041000119106,
    "descripcion":"ARTROSIS SECUNDARIA DE AMBOS PIES"
  },
  {
    "codigo":1148852009,
    "descripcion":"NEFROMA QUÍSTICO MALIGNO"
  },
  {
    "codigo":426121003,
    "descripcion":"LINFADENITIS GRANULOMATOSA"
  },
  {
    "codigo":295049005,
    "descripcion":"ALERGIA A METIROSINA"
  },
  {
    "codigo":1179785007,
    "descripcion":"GANGLIÓSIDO DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":424286001,
    "descripcion":"DISPLASIA FIBROSA DE ÓRBITA"
  },
  {
    "codigo":194910001,
    "descripcion":"PERICARDITIS GONOCÓCICA AGUDA"
  },
  {
    "codigo":31070006,
    "descripcion":"EPIDIDIMITIS"
  },
  {
    "codigo":293214008,
    "descripcion":"REACCIÓN ADVERSA A LA NORETISTERONA"
  },
  {
    "codigo":719198009,
    "descripcion":"PROMINENCIA ANORMAL DE OMÓPLATO"
  },
  {
    "codigo":225843003,
    "descripcion":"DEMUESTRA PRINCIPIOS ÉTICOS"
  },
  {
    "codigo":105191000119100,
    "descripcion":"HIPOVENTILACIÓN ALVEOLAR CENTRAL ADQUIRIDA"
  },
  {
    "codigo":15997671000119100,
    "descripcion":"COROIDOPATÍA SEROSA CENTRAL DE OJO IZQUIERDO"
  },
  {
    "codigo":166631000119101,
    "descripcion":"CALAMBRE MUSCULAR NOCTURNO"
  },
  {
    "codigo":16002791000119101,
    "descripcion":"DOLOR EN MIEMBRO INFERIOR DERECHO CONCOMITANTE CON ISQUEMIA Y DEBIDO A ELLA"
  },
  {
    "codigo":16891111000119104,
    "descripcion":"ACCIDENTE CEREBROVASCULAR CRIPTOGÉNICO"
  },
  {
    "codigo":10859751000119104,
    "descripcion":"ALIMENTO ASPIRADO EN LARINGE"
  },
  {
    "codigo":10637031000119106,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN EN GLÚTEO ESTADIO I"
  },
  {
    "codigo":10667751000119106,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN EN PIERNA IZQUIERDA ESTADIO I"
  },
  {
    "codigo":302311000119107,
    "descripcion":"HIPEROSTOSIS ESQUELÉTICA IDIOPÁTICA DIFUSA DE COLUMNA VERTEBRAL CERVICAL"
  },
  {
    "codigo":14720231000119109,
    "descripcion":"INFLAMACIÓN DE APÉNDICE EPIPLOICO"
  },
  {
    "codigo":10900711000119106,
    "descripcion":"HERIDA PENETRANTE DE ÓRBITA IZQUIERDA"
  },
  {
    "codigo":151271000119102,
    "descripcion":"PRUEBA SANGUÍNEA ANORMAL"
  },
  {
    "codigo":92936008,
    "descripcion":"FORMA ANORMAL CONGÉNITA DE HUESO PARIETAL"
  },
  {
    "codigo":16025831000119106,
    "descripcion":"ANEURISMA AGUDO DE VENA POPLÍTEA DERECHA"
  },
  {
    "codigo":348391000119105,
    "descripcion":"COLOBOMA ADQUIRIDO DE DISCO ÓPTICO DE OJO DERECHO"
  },
  {
    "codigo":16018151000119106,
    "descripcion":"OSTEOPATÍA DE TIBIA DERECHA POSTERIOR A POLIOMIELITIS"
  },
  {
    "codigo":10677991000119107,
    "descripcion":"TUMEFACCIÓN LOCALIZADA BILATERAL DE ANTEBRAZO"
  },
  {
    "codigo":1075431000119109,
    "descripcion":"RUPTURA CRÓNICA DE LIGAMENTO LATERAL EXTERNO DE RODILLA IZQUIERDA"
  },
  {
    "codigo":343271000119109,
    "descripcion":"PARÁLISIS DE AMBOS NERVIOS OCULOMOTORES"
  },
  {
    "codigo":713693008,
    "descripcion":"LIPODISTROFIA CAUSADA POR FÁRMACO ANTIRRETROVIRAL"
  },
  {
    "codigo":254941009,
    "descripcion":"TUMOR GLIAL MIXTO DE CEREBRO"
  },
  {
    "codigo":449714002,
    "descripcion":"ARQUEAMIENTO DE BRAZO"
  },
  {
    "codigo":253106003,
    "descripcion":"ENCEFALOCELE NASOFRONTAL"
  },
  {
    "codigo":89266005,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DE TOBILLO"
  },
  {
    "codigo":285874006,
    "descripcion":"CAPAZ DE USAR LA COCINA"
  },
  {
    "codigo":56498009,
    "descripcion":"TUBERCULOSIS DE LA NASOFARINGE"
  },
  {
    "codigo":415111003,
    "descripcion":"NEOPLASIA DE CÉLULAS PLASMÁTICAS"
  },
  {
    "codigo":710023003,
    "descripcion":"MORFOLOGÍA DE CRESTA ALVEOLAR RESIDUAL DE MAXILAR SUPERIOR SIN VESTÍBULO BUCAL PRESENTE"
  },
  {
    "codigo":249436002,
    "descripcion":"LARINGE PARCIAL"
  },
  {
    "codigo":10836821000119106,
    "descripcion":"FRACTURA EXPUESTA DE EXTREMO SUPERIOR DE TIBIA IZQUIERDA"
  },
  {
    "codigo":413276006,
    "descripcion":"ESTENOSIS COLÓNICA POR ENFERMEDAD DE CROHN"
  },
  {
    "codigo":52828007,
    "descripcion":"ALTERACIÓN MACROMOLECULAR"
  },
  {
    "codigo":282204009,
    "descripcion":"INCAPAZ DE EMPEZAR A CAMINAR"
  },
  {
    "codigo":50993001,
    "descripcion":"ENDOMETRIOSIS DEL PULMÓN"
  },
  {
    "codigo":83761007,
    "descripcion":"HEMOSIDEROSIS HEPÁTICA"
  },
  {
    "codigo":678741000119108,
    "descripcion":"CUADRANTANOPIA DE OJO DERECHO"
  },
  {
    "codigo":278534004,
    "descripcion":"TRASTORNO RELACIONADO CON CATÉTER PARA CISTOSTOMÍA"
  },
  {
    "codigo":442374005,
    "descripcion":"HEPATITIS B Y HEPATITIS C"
  },
  {
    "codigo":737286006,
    "descripcion":"PRÓTESIS DENTAL IN SITU"
  },
  {
    "codigo":735451005,
    "descripcion":"INFECCIÓN CRÓNICA CAUSADA POR VIRUS DE HEPATITIS D"
  },
  {
    "codigo":600224751000119105,
    "descripcion":"NÓDULO DE DESGASTE DE HÉLICE DE PABELLÓN AURICULAR DERECHO"
  },
  {
    "codigo":276699009,
    "descripcion":"TERCERA FONTANELA"
  },
  {
    "codigo":1259739009,
    "descripcion":"GLIOMA PRIMARIO MALIGNO DE HIPOTÁLAMO"
  },
  {
    "codigo":373168002,
    "descripcion":"RETICULOSARCOMA"
  },
  {
    "codigo":307632004,
    "descripcion":"HIPERTENSIÓN DEL EMBARAZO SIN PROTEINURIA"
  },
  {
    "codigo":11793391000119106,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":111024006,
    "descripcion":"ALOPECIA LIMINARIS FRONTALIS"
  },
  {
    "codigo":209328005,
    "descripcion":"FRACTURA-SUBLUXACIÓN EXPUESTA DE ARTICULACIÓN METACARPOFALÁNGICA"
  },
  {
    "codigo":12720008,
    "descripcion":"FEMINEIDAD"
  },
  {
    "codigo":274864009,
    "descripcion":"ENFERMEDAD POR DEPÓSITO DE GLUCÓGENO DEBIDA A DEFICIENCIA DE MALTASA"
  },
  {
    "codigo":10885003,
    "descripcion":"SÍNTOMA PREMENSTRUAL"
  },
  {
    "codigo":305797004,
    "descripcion":"ATENDIDO EN SERVICIO DE CUIDADOS INTENSIVOS DE ADULTOS"
  },
  {
    "codigo":15699081000119101,
    "descripcion":"ATROFIA ÓPTICA HEREDITARIA BILATERAL"
  },
  {
    "codigo":699013006,
    "descripcion":"HEMOPERITONEO TRAUMÁTICO"
  },
  {
    "codigo":1256069008,
    "descripcion":"CALLOSIDAD ASTRAGALINA"
  },
  {
    "codigo":240261009,
    "descripcion":"HIPERMOVILIDAD GENERALIZADA BENIGNA DE LA ARTICULACIÓN"
  },
  {
    "codigo":238426002,
    "descripcion":"INFECCIÓN DE LA PIEL POR MORAXELLA"
  },
  {
    "codigo":404101009,
    "descripcion":"PSEUDOLINFOMA SOLITARIO DE CÉLULAS T"
  },
  {
    "codigo":369498008,
    "descripcion":"TUMOR MALIGNO QUE COMPROMETE EL CUELLO UTERINO POR PROPAGACIÓN DIRECTA DE OVARIO"
  },
  {
    "codigo":105519001,
    "descripcion":"DESAVENENCIA CON EL TRABAJADOR SOCIAL"
  },
  {
    "codigo":1186863001,
    "descripcion":"DEFICIENCIA DE HORMONA ANTIDIURÉTICA DEBIDA A TRAUMATISMO"
  },
  {
    "codigo":402266009,
    "descripcion":"DERMATITIS IRRITATIVA POR CONTACTO DE MANOS CAUSADA POR SOLVENTE"
  },
  {
    "codigo":236591007,
    "descripcion":"DILATACIÓN Y OBSTRUCCIÓN DEL TRACTO URINARIO SUPERIOR"
  },
  {
    "codigo":365828000,
    "descripcion":"DENSIDAD RELATIVA - HALLAZGO"
  },
  {
    "codigo":201988000,
    "descripcion":"ARTROPATÍA TRANSITORIA DE REGIÓN DE HOMBRO"
  },
  {
    "codigo":5380001,
    "descripcion":"ESPECTADOR EN TIERRA, VÍCTIMA DE ACCIDENTE AÉREO"
  },
  {
    "codigo":890116005,
    "descripcion":"SÍNDROME DE DUPLICACIÓN 17Q24-QTER"
  },
  {
    "codigo":300292008,
    "descripcion":"REFLUJO GÁSTRICO MÍNIMO"
  },
  {
    "codigo":267524009,
    "descripcion":"ANEMIA APLÁSICA CONSTITUCIONAL CON MALFORMACIÓN"
  },
  {
    "codigo":3545003,
    "descripcion":"DISFUNCIÓN DIASTÓLICA"
  },
  {
    "codigo":298457004,
    "descripcion":"AMPLITUD DE ROTACIÓN PASIVA HACIA LA DERECHA DE LA COLUMNA CERVICAL AUMENTADA"
  },
  {
    "codigo":36313005,
    "descripcion":"PELVIS DOLICOPÉLICA"
  },
  {
    "codigo":724441006,
    "descripcion":"ENFERMEDAD ARTERIAL OCLUSIVA CRÓNICA NO ATEROSCLERÓTICA"
  },
  {
    "codigo":200153006,
    "descripcion":"INFECCIÓN SÉPTICA LOCALIZADA CAUSADA POR PASTEURELLA MULTOCIDA DEBIDA A MORDEDURA DE GATO Y\/O PERRO"
  },
  {
    "codigo":722606000,
    "descripcion":"NEUROPATÍA ÓPTICA DEBIDA A RADIOTERAPIA Y POSTERIOR A ELLA"
  },
  {
    "codigo":1090851000119102,
    "descripcion":"OTITIS MEDIA ADHESIVA DEL OÍDO DERECHO"
  },
  {
    "codigo":1279662002,
    "descripcion":"QUEMADURA DE DEDO ANULAR"
  },
  {
    "codigo":1148590006,
    "descripcion":"PH DE SANGRE ARTERIAL DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":198318007,
    "descripcion":"ÚTERO VOLUMINOSO"
  },
  {
    "codigo":34478009,
    "descripcion":"INTENTO FALLIDO DE ABORTO CON SÍNDROME DE DESFIBRINACIÓN"
  },
  {
    "codigo":32643003,
    "descripcion":"SÍNDROME DE HEDBLOM"
  },
  {
    "codigo":294787004,
    "descripcion":"ALERGIA A QUINESTRADOL"
  },
  {
    "codigo":161880003,
    "descripcion":"SÍNTOMA DE RIGIDEZ DEL CUELLO"
  },
  {
    "codigo":718936004,
    "descripcion":"DISFUNCIÓN SOMÁTICA DE REGIÓN SACRA"
  },
  {
    "codigo":1144920003,
    "descripcion":"SÍNDROME DE SOLAPAMIENTO EN DERMATOMIOSITIS JUVENIL"
  },
  {
    "codigo":63576006,
    "descripcion":"DISFONÍA PSEUDOBULBAR FLÁCCIDA - ESPÁSTICA MIXTA"
  },
  {
    "codigo":107811000119106,
    "descripcion":"CARCINOMA NEUROENDOCRINO MICROCÍTICO CON METÁSTASIS HEPÁTICA"
  },
  {
    "codigo":127277000,
    "descripcion":"LESIÓN TRAUMÁTICA DE LOS GENITALES FEMENINOS"
  },
  {
    "codigo":292952009,
    "descripcion":"REACCIÓN ADVERSA A NORFLOXACINO"
  },
  {
    "codigo":225581002,
    "descripcion":"DETERIORO VISUAL"
  },
  {
    "codigo":291117002,
    "descripcion":"INTOXICACIÓN POR CLORMETIAZOL"
  },
  {
    "codigo":192813004,
    "descripcion":"DEGENERACIÓN CEREBRAL POR ENFERMEDAD CEREBROVASCULAR"
  },
  {
    "codigo":422189002,
    "descripcion":"BAJA VISIÓN ASOCIADA CON SIDA (SÍNDROME DE INMUNODEFICIENCIA ADQUIRIDA)"
  },
  {
    "codigo":94509004,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA UNIÓN RECTOSIGMOIDE"
  },
  {
    "codigo":1208621008,
    "descripcion":"SÍNDROME DE DISFUNCIÓN MITOCONDRIAL MÚLTIPLE TIPO 4"
  },
  {
    "codigo":715266002,
    "descripcion":"INFECCIÓN DE LA PIEL DE PÁRPADO Y REGIÓN PERIOCULAR"
  },
  {
    "codigo":92674003,
    "descripcion":"CARCINOMA IN SITU DEL PARAMETRIO"
  },
  {
    "codigo":1351531009,
    "descripcion":"MACULOPATÍA EN CÚPULA DE AMBOS OJOS"
  },
  {
    "codigo":1303255001,
    "descripcion":"EMBARAZO DE RIESGO MEDIO"
  },
  {
    "codigo":289282009,
    "descripcion":"MEMBRANA AMNIÓTICA - HALLAZGO"
  },
  {
    "codigo":254679001,
    "descripcion":"MILIUM"
  },
  {
    "codigo":1336023002,
    "descripcion":"GLAUCOMA DEBIDO A QUISTE DE OJO IZQUIERDO PROPIAMENTE DICHO"
  },
  {
    "codigo":1268652001,
    "descripcion":"PUBALGIA ATLÉTICA"
  },
  {
    "codigo":123607009,
    "descripcion":"FIBROSIS SEPTAL HEPÁTICA"
  },
  {
    "codigo":449452002,
    "descripcion":"CONEXIÓN VENOSA PULMONAR ANÓMALA DE LOCALIZACIÓN INTRACARDÍCA EN AURÍCULA DERECHA"
  },
  {
    "codigo":1332353003,
    "descripcion":"HIPERTROFIA DE PERONÉ"
  },
  {
    "codigo":283777006,
    "descripcion":"MORDEDURA DE PERRO EN DEDO DEL PIE"
  },
  {
    "codigo":1363286000,
    "descripcion":"SÍNDROME DE DISPLASIA MESOMÉLICA, ANOMALÍAS DIGITALES Y DISCAPACIDAD INTELECTUAL"
  },
  {
    "codigo":414849009,
    "descripcion":"ESTADO NEUROLÓGICO IGUAL O MEJORADO CON RESPECTO AL ESTADO PREQUIRÚRGICO"
  },
  {
    "codigo":249174002,
    "descripcion":"PLACENTA CALCIFICADA"
  },
  {
    "codigo":10950231000119103,
    "descripcion":"HERIDA POR DISPARO DE ARMA DE FUEGO DE MANO IZQUIERDA"
  },
  {
    "codigo":609622007,
    "descripcion":"TRASTORNO DEL SEGMENTO TORÁCICO DEL TRONCO"
  },
  {
    "codigo":247339003,
    "descripcion":"SENSACIÓN DE PERMANENCIA DE LA MATERIA FECAL EN RECTO"
  },
  {
    "codigo":81664000,
    "descripcion":"REACCIÓN AUTOINMUNITARIA MEDIADA POR ANTICUERPOS ANTI - TEJIDO, CON PARTICIPACIÓN DE COMPLEMENTO"
  },
  {
    "codigo":1163008006,
    "descripcion":"REACCIÓN ADVERSA A GLUCÓSIDO DIGITÁLICO"
  },
  {
    "codigo":866261000,
    "descripcion":"OBSTRUCCIÓN COMPLETA DE PUNTO LAGRIMAL SUPERIOR"
  },
  {
    "codigo":702421006,
    "descripcion":"ENCEFALOPATÍA FAMILIAR CON CUERPOS DE INCLUSIÓN DE NEUROSERPINA"
  },
  {
    "codigo":210901006,
    "descripcion":"LESIÓN DE LA VENA DORSAL DEL PIE"
  },
  {
    "codigo":733354000,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE LA VÍA BILIAR"
  },
  {
    "codigo":209066004,
    "descripcion":"LUXACIÓN VERTEBRAL EXPUESTA CON LESIÓN MEDULAR COMPLETA A NIVEL CERVICAL"
  },
  {
    "codigo":12458006,
    "descripcion":"MACROGNATISMO CONGÉNITO"
  },
  {
    "codigo":241834008,
    "descripcion":"ENVENENAMIENTO DEBIDO A PICADURA DE NEMATOCISTO"
  },
  {
    "codigo":371071001,
    "descripcion":"DISFUNCIÓN DE DERIVACIÓN PORTOCAVA"
  },
  {
    "codigo":77994009,
    "descripcion":"OSTEOARTROSIS LOCALIZADA PRIMARIA DE LA REGIÓN PÉLVICA"
  },
  {
    "codigo":1255807003,
    "descripcion":"LINFOMA MALIGNO DE GANGLIOS LINFÁTICOS DE CABEZA Y CUELLO"
  },
  {
    "codigo":239999004,
    "descripcion":"LESIÓN DE PARTES BLANDAS DE LA REGIÓN DE LA RODILLA"
  },
  {
    "codigo":10623005,
    "descripcion":"DISPLASIA FIBROSA DE HUESO"
  },
  {
    "codigo":305535006,
    "descripcion":"BAJO ATENCIÓN DE CIRUJANO ENDOCRINOLÓGICO"
  },
  {
    "codigo":895359007,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE TESTÍCULO DERECHO"
  },
  {
    "codigo":926292000,
    "descripcion":"EPÍFISIS PEQUEÑA DE FALANGE DE DEDO ANULAR"
  },
  {
    "codigo":11824881000119105,
    "descripcion":"CONTUSIÓN DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":403839008,
    "descripcion":"SÍNDROME DE SICCARDI"
  },
  {
    "codigo":762452003,
    "descripcion":"DOLOR MUSCULOESQUELÉTICO CRÓNICO"
  },
  {
    "codigo":74324004,
    "descripcion":"LACERACIÓN DE RIÑÓN SIN HERIDA ABIERTA HACIA CAVIDAD ABDOMINAL"
  },
  {
    "codigo":10923761000119105,
    "descripcion":"FRACTURA NO EXPUESTA DE BASE DE SEGUNDO HUESO METACARPIANO DE MANO IZQUIERDA"
  },
  {
    "codigo":683761000119107,
    "descripcion":"EPENDIMOMA PRIMARIO DE VENTRÍCULO CEREBRAL"
  },
  {
    "codigo":234494000,
    "descripcion":"PÚRPURA NO TROMBOCITOPÉNICA PRIMARIA"
  },
  {
    "codigo":15675121000119109,
    "descripcion":"TENDINITIS DE TENDÓN SUPRAESPINOSO IZQUIERDO"
  },
  {
    "codigo":201726005,
    "descripcion":"ARTROPATÍA ASOCIADA CON TRASTORNO GASTROINTESTINAL NO INFECCIOSO"
  },
  {
    "codigo":267262008,
    "descripcion":"RUPTURA ESPONTÁNEA DE MEMBRANAS PROLONGADA"
  },
  {
    "codigo":365566008,
    "descripcion":"DETALLES DE ANTECEDENTES CRIMINALES Y PRONTUARIO - HALLAZGO"
  },
  {
    "codigo":298195002,
    "descripcion":"HIPERMOVILIDAD DE ARTICULACIÓN SACROILÍACA"
  },
  {
    "codigo":3283003,
    "descripcion":"SENSACIÓN DE PRESENCIA DE ARENA O CUERPO EXTRAÑO EN EL OJO"
  },
  {
    "codigo":68819003,
    "descripcion":"FRACTURA NO EXPUESTA DE LA APÓFISIS CORONOIDES DEL CÚBITO"
  },
  {
    "codigo":724179008,
    "descripcion":"SÍNDROME DE LARON CON INMUNODEFICIENCIA"
  },
  {
    "codigo":427432001,
    "descripcion":"SÍNDROME PARALÍTICO COMO EFECTO TARDÍO DE INFARTO TALÁMICO"
  },
  {
    "codigo":34216002,
    "descripcion":"PROBANDOS"
  },
  {
    "codigo":198056001,
    "descripcion":"TRASTORNO DE ÓRGANO GENITAL MASCULINO ASOCIADO CON OTRO TRASTORNO"
  },
  {
    "codigo":296360002,
    "descripcion":"SOBREDOSIS DE PILOCARPINA"
  },
  {
    "codigo":720509009,
    "descripcion":"CAPAZ DE INDICAR NECESIDADES PROPIAS DE ACTIVIDADES RELACIONADAS CON EL USO DEL BAÑO"
  },
  {
    "codigo":292690001,
    "descripcion":"REACCIÓN ADVERSA A LA TUBOCURARINA"
  },
  {
    "codigo":290855003,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR TRIMIPRAMINA"
  },
  {
    "codigo":389159004,
    "descripcion":"DISPLASIA ESPONDILOEPIFISARIA LEVE CON ARTROSIS DE INICIO PREMATURO"
  },
  {
    "codigo":28711005,
    "descripcion":"INTOXICACIÓN CAUSADA POR UROQUINASA"
  },
  {
    "codigo":94247005,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE VENTRÍCULO CEREBRAL"
  },
  {
    "codigo":59644002,
    "descripcion":"ANEMIA HEMOLÍTICA NO ESFEROCÍTICA HEREDITARIA POR DEFICIENCIA DE FOSFOGLICERATO QUINASA"
  },
  {
    "codigo":92412003,
    "descripcion":"NEOPLASIA BENIGNA DE LA SUBGLOTIS"
  },
  {
    "codigo":289020007,
    "descripcion":"UTILIZA LAS MANOS PARA ALIMENTARSE"
  },
  {
    "codigo":254417000,
    "descripcion":"CARCINOMA DEL FRENILLO LINGUAL"
  },
  {
    "codigo":188881001,
    "descripcion":"NEOPLASIA BENIGNA DE CARTÍLAGO CORNICULADO"
  },
  {
    "codigo":1335761003,
    "descripcion":"ENFERMEDAD DE PAGET DE AMBOS HOMBROS"
  },
  {
    "codigo":1237457005,
    "descripcion":"METÁSTASIS DE CARCINOMA DE VEJIGA URINARIA"
  },
  {
    "codigo":57809008,
    "descripcion":"ENFERMEDAD MIOCÁRDICA"
  },
  {
    "codigo":449190000,
    "descripcion":"DEFECTO DE PORCIÓN MUSCULAR DEL TABIQUE INTERVENTRICULAR EN TABIQUE TRABECULAR"
  },
  {
    "codigo":1268390002,
    "descripcion":"CARCINOMA METASTÁSICO INDIFERENCIADO DE HÍGADO Y VÍA BILIAR INTRAHEPÁTICA"
  },
  {
    "codigo":711334003,
    "descripcion":"VIRUS INFLUENZA A SUBTIPO H1N1 NO DETECTADO"
  },
  {
    "codigo":12236991000119103,
    "descripcion":"DOLOR EN REPOSO DE AMBAS EXTREMIDADES INFERIORES DEBIDO A ATEROSCLEROSIS"
  },
  {
    "codigo":185211000,
    "descripcion":"ATENDIDO POR SERVICIO DE MEDICINA AMBULATORIA EN HOSPITAL"
  },
  {
    "codigo":16005311000119104,
    "descripcion":"AMIOTROFIA NEURÁLGICA BILATERAL"
  },
  {
    "codigo":283515007,
    "descripcion":"HERIDA PUNZANTE DE ANTEBRAZO"
  },
  {
    "codigo":86907008,
    "descripcion":"LIPODISTROFIA GENERALIZADA ADQUIRIDA"
  },
  {
    "codigo":707664003,
    "descripcion":"CARCINOMA PRIMARIO DE CÉLULAS ESCAMOSAS DE GLOTIS"
  },
  {
    "codigo":248912003,
    "descripcion":"CUELLO UTERINO DOBLE"
  },
  {
    "codigo":773200006,
    "descripcion":"PÁNCREAS GRASO"
  },
  {
    "codigo":871504007,
    "descripcion":"REACCIÓN ADVERSA A AMPICILINA Y\/O CLOXACILINA"
  },
  {
    "codigo":1197349005,
    "descripcion":"PARAGANGLIOMA PRIMARIO MALIGNO DE CUERPO CAROTÍDEO"
  },
  {
    "codigo":703994007,
    "descripcion":"FRACTURA INTRAARTICULAR NO EXPUESTA DE CABEZA DE FÉMUR"
  },
  {
    "codigo":15733081000119104,
    "descripcion":"RETINOSQUISIS PLANA DE OJO DERECHO"
  },
  {
    "codigo":46799006,
    "descripcion":"DIARREA DISENTÉRICA"
  },
  {
    "codigo":472783006,
    "descripcion":"ESTENOSIS DE REGIÓN SUBVALVULAR DE NEOVÁLVULA AÓRTICA"
  },
  {
    "codigo":896932000,
    "descripcion":"FORMA DE BALA ANORMAL CONGÉNITA DE FALANGE DE DEDO GORDO"
  },
  {
    "codigo":44964000,
    "descripcion":"FUSIÓN CONGÉNITA DE TESTÍCULO"
  },
  {
    "codigo":700324005,
    "descripcion":"ARTROSIS DE ARTICULACIÓN ASTRAGALOESCAFOIDEA"
  },
  {
    "codigo":1010568002,
    "descripcion":"TESTÍCULO IZQUIERDO NO DESCENDIDO"
  },
  {
    "codigo":10361001,
    "descripcion":"DELIRIO POR AGOTAMIENTO"
  },
  {
    "codigo":733092009,
    "descripcion":"SÍNDROME DE MICROCEFALIA, HIPOGONADISMO HIPERGONADOTRÓFICO Y BAJA ESTATURA"
  },
  {
    "codigo":239737007,
    "descripcion":"CONTRACTURA DE LA ARTICULACIÓN DEL DEDO DE LA MANO"
  },
  {
    "codigo":403577008,
    "descripcion":"DISTROFIA UNGUEAL POR ONICOTILOMANÍA"
  },
  {
    "codigo":237902005,
    "descripcion":"HIPOFOSFATEMIA ADQUIRIDA"
  },
  {
    "codigo":203299001,
    "descripcion":"OSTEOMIELITIS SUBAGUDA DE COLUMNA VERTEBRAL SACRA"
  },
  {
    "codigo":8526009,
    "descripcion":"MELANODERMIA SENIL"
  },
  {
    "codigo":11774451000119104,
    "descripcion":"AMPOLLA TRAUMÁTICA DE PULGAR IZQUIERDO"
  },
  {
    "codigo":301603008,
    "descripcion":"NO SUBE NI BAJA ESCALERAS SENTADO"
  },
  {
    "codigo":399907009,
    "descripcion":"HERIDA POR MORDEDURA DE ANIMAL"
  },
  {
    "codigo":234232002,
    "descripcion":"FRACTURA DE LA DERIVACIÓN DEL ELECTRODO DEL DESFRIBILADOR CARDÍACO IMPLANTADO"
  },
  {
    "codigo":168696005,
    "descripcion":"RADIOGRAFÍA SIMPLE DE CALCÁNEO ANORMAL"
  },
  {
    "codigo":365304007,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD DE REALIZAR ACTIVIDADES ADMINISTRATIVAS DEL HOGAR"
  },
  {
    "codigo":299768008,
    "descripcion":"REACCIÓN DE COLOCACIÓN: PRESENTE"
  },
  {
    "codigo":363469001,
    "descripcion":"NEOPLASIA MALIGNA DEL LÓBULO PARIETAL"
  },
  {
    "codigo":3021005,
    "descripcion":"ACIDEZ GÁSTRICA NORMAL"
  },
  {
    "codigo":723917005,
    "descripcion":"PESO CORPORAL PELIGROSAMENTE BAJO CONCOMITANTE CON ANOREXIA NERVIOSA DE TIPO RESTRICTIVO Y DEBIDO A ELLA"
  },
  {
    "codigo":232397007,
    "descripcion":"SINUSITIS FRONTOETMOIDAL CRÓNICA"
  },
  {
    "codigo":230562000,
    "descripcion":"NEUROPATÍA HIPOMIELINIZANTE CONGÉNITA"
  },
  {
    "codigo":68557006,
    "descripcion":"TALIPES PLANOVALGO"
  },
  {
    "codigo":722082000,
    "descripcion":"NEFROPATÍA OBSTRUCTIVA DEBIDA A HIPERPLASIA PROSTÁTICA BENIGNA"
  },
  {
    "codigo":35789008,
    "descripcion":"INTOXICACIÓN POR BULNESIA SARMIENTII"
  },
  {
    "codigo":296098005,
    "descripcion":"SOBREDOSIS DE KETAZOLAM"
  },
  {
    "codigo":197794008,
    "descripcion":"CÁLCULO CORALIFORME"
  },
  {
    "codigo":359799003,
    "descripcion":"DIFILOBOTRIASIS INTESTINAL"
  },
  {
    "codigo":95820000,
    "descripcion":"PÉRDIDA DE LA AUDICIÓN, BILATERAL"
  },
  {
    "codigo":195959009,
    "descripcion":"ENFISEMA BULLOSO LOCAL"
  },
  {
    "codigo":688781000119105,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE COMISURA DE LABIO"
  },
  {
    "codigo":292428006,
    "descripcion":"REACCIÓN ADVERSA AL METOPROLOL"
  },
  {
    "codigo":1144396007,
    "descripcion":"HIPOPLASIA CONGÉNITA DE NERVIO VESTIBULAR"
  },
  {
    "codigo":126753000,
    "descripcion":"NEOPLASIA DE VASO SANGUÍNEO DE DEDO DE PIE"
  },
  {
    "codigo":225057002,
    "descripcion":"ASMA INESTABLE"
  },
  {
    "codigo":93985007,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA PELVIS RENAL"
  },
  {
    "codigo":92150002,
    "descripcion":"NEOPLASIA BENIGNA DE LOS GANGLIOS LINFÁTICOS INTESTINALES"
  },
  {
    "codigo":26614003,
    "descripcion":"HIDROCELE DE TESTÍCULO"
  },
  {
    "codigo":288758007,
    "descripcion":"EXPRESA PENSAMIENTOS"
  },
  {
    "codigo":190454008,
    "descripcion":"PARATIROIDITIS AUTOINMUNITARIA"
  },
  {
    "codigo":286923006,
    "descripcion":"TRASTORNO DEL METABOLISMO DE HIERRO, COBRE, MAGNESIO"
  },
  {
    "codigo":24779007,
    "descripcion":"ACTINOMICOSIS DISEMINADA"
  },
  {
    "codigo":55712002,
    "descripcion":"LESIÓN DEL NERVIO FACIAL COMO MANIFESTACIÓN DE TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":448928006,
    "descripcion":"MASA DE ANTEBRAZO"
  },
  {
    "codigo":874912007,
    "descripcion":"NÓDULO DE LA CORTEZA SUPRARRENAL"
  },
  {
    "codigo":840309000,
    "descripcion":"INFARTO AGUDO DE MIOCARDIO CON ELEVACIÓN DEL SEGMENTO ST DEBIDO A OCLUSIÓN DE PORCIÓN PROXIMAL DE RAMA DESCENDENTE ANTERIOR DE ARTERIA CORONARIA IZQUIERDA"
  },
  {
    "codigo":283253001,
    "descripcion":"VIDRIO EN DEDO DE LA MANO"
  },
  {
    "codigo":334631000119107,
    "descripcion":"COROIDITIS YUXTAPAPILAR FOCAL DERECHA"
  },
  {
    "codigo":53877005,
    "descripcion":"ÚLCERA GÁSTRICA CON HEMORRAGIA Y OBSTRUCCIÓN"
  },
  {
    "codigo":1264458000,
    "descripcion":"LEUCEMIA AGUDA INDIFERENCIADA"
  },
  {
    "codigo":10957761000119102,
    "descripcion":"LACERACIÓN DE PULGAR DERECHO"
  },
  {
    "codigo":447093008,
    "descripcion":"QUEMADURA PROFUNDA DE TERCER GRADO DE MEJILLA"
  },
  {
    "codigo":52042003,
    "descripcion":"GLOMERULONEFRITIS ASOCIADA CON LUPUS ERITEMATOSO SISTÉMICO, CLASE V DE LA OMS"
  },
  {
    "codigo":19274004,
    "descripcion":"NEUMOPATÍA DE LOS TRABAJADORES DEL CEREAL"
  },
  {
    "codigo":1297226006,
    "descripcion":"CIERRE DE ÁNGULO AGUDO DE OJO IZQUIERDO CAUSADO POR FÁRMACO"
  },
  {
    "codigo":707402007,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE OROFARINGE"
  },
  {
    "codigo":314186008,
    "descripcion":"ANEURISMA AÓRTICO ABDOMINAL INFLAMATORIO"
  },
  {
    "codigo":445258009,
    "descripcion":"GLOMERULONEFRITIS IDIOPÁTICA RÁPIDAMENTE PROGRESIVA"
  },
  {
    "codigo":1231690009,
    "descripcion":"VITÍLIGO DE PIEL DE PÁRPADO SUPERIOR"
  },
  {
    "codigo":15604000,
    "descripcion":"OSTEÍTIS DE LA REGIÓN DE HOMBRO"
  },
  {
    "codigo":246815009,
    "descripcion":"EXCESO DE PIEL DE PÁRPADO"
  },
  {
    "codigo":408820001,
    "descripcion":"VIVE CON SU ESPOSO"
  },
  {
    "codigo":310516003,
    "descripcion":"VISTO POR MÉDICO ONCÓLOGO"
  },
  {
    "codigo":212212005,
    "descripcion":"LESIÓN DE LA RAÍZ DEL NERVIO DORSAL - D7"
  },
  {
    "codigo":736500007,
    "descripcion":"PÓLIPO DE FOSA NASAL"
  },
  {
    "codigo":112073004,
    "descripcion":"POSICIÓN SACROILÍACA DERECHA POSTERIOR"
  },
  {
    "codigo":1258953007,
    "descripcion":"TUMEFACCIÓN DE TEJIDO CELULAR SUBCUTÁNEO DE SITIOS MÚLTIPLES"
  },
  {
    "codigo":11934000,
    "descripcion":"PTOSIS DE PÁRPADO"
  },
  {
    "codigo":700062000,
    "descripcion":"SÍNDROME DE SCHÖPF-SCHULZ-PASSARGE"
  },
  {
    "codigo":77470003,
    "descripcion":"FIEBRE EXANTEMATOSA ENTEROVIRAL"
  },
  {
    "codigo":110238004,
    "descripcion":"CONTUSIÓN DE LA REGIÓN SUBCONDÍLEA DE LA MANDÍBULA"
  },
  {
    "codigo":208542008,
    "descripcion":"FRACTURA EXPUESTA SUBCAPITAL DE FÉMUR PROXIMAL GRADO II DE GARDEN"
  },
  {
    "codigo":698227004,
    "descripcion":"INFECCIÓN CAUSADA POR RHODOCOCCUS HOAGII"
  },
  {
    "codigo":403315008,
    "descripcion":"HIPERTRICOSIS EN EL HIPOTIROIDISMO"
  },
  {
    "codigo":237640005,
    "descripcion":"HIPOGLUCEMIA FARMACÓGENA"
  },
  {
    "codigo":170269003,
    "descripcion":"EXAMEN PEDIÁTRICO ANORMAL A LOS 6\/12 MESES: DERIVADO"
  },
  {
    "codigo":301341006,
    "descripcion":"OLOR CORPORAL NORMAL"
  },
  {
    "codigo":235805007,
    "descripcion":"OBSTRUCCIÓN INTESTINAL EXTRÍNSECA"
  },
  {
    "codigo":233970002,
    "descripcion":"ESTENOSIS DE ARTERIA CORONARIA"
  },
  {
    "codigo":102898006,
    "descripcion":"RELACIÓN EMOCIONAL"
  },
  {
    "codigo":397810006,
    "descripcion":"PIOSÁLPINX"
  },
  {
    "codigo":299506007,
    "descripcion":"AMPLITUD DE SUPINACIÓN MEDIOTARSIANA PASIVA DISMINUIDA"
  },
  {
    "codigo":365042009,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA ENCONTRAR LAS PALABRAS"
  },
  {
    "codigo":68295002,
    "descripcion":"RAQUITISMO DEPENDIENTE DE VITAMINA D"
  },
  {
    "codigo":428743006,
    "descripcion":"ANZUELO EN FARINGE"
  },
  {
    "codigo":232135007,
    "descripcion":"MIOPÍA DE ÍNDICE"
  },
  {
    "codigo":263068000,
    "descripcion":"FRACTURA-LUXACIÓN DE LA COLUMNA VERTEBRAL"
  },
  {
    "codigo":295836001,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE AMITRIPTILINA"
  },
  {
    "codigo":230300007,
    "descripcion":"ENFERMEDAD DE HUNTINGTON DE INICIO TARDÍO"
  },
  {
    "codigo":721820007,
    "descripcion":"ENCEFALITIS CAUSADA POR SCHISTOSOMA MANSONI"
  },
  {
    "codigo":719985001,
    "descripcion":"DISTROFIA MUSCULAR AUTOSÓMICA DOMINANTE CON DISTRIBUCIÓN EN LAS CINTURAS ESCAPULAR O PÉLVICA TIPO 1A"
  },
  {
    "codigo":294001005,
    "descripcion":"ALERGIA A NIMODIPINO"
  },
  {
    "codigo":423238001,
    "descripcion":"DIFICULTAD PARA ESTABLECER RELACIONES"
  },
  {
    "codigo":161094001,
    "descripcion":"VACACIONES DE MOCHILERO"
  },
  {
    "codigo":292166003,
    "descripcion":"REACCIÓN ADVERSA AL PROPOFOL"
  },
  {
    "codigo":95558008,
    "descripcion":"PNEUMOCOLECISTITIS"
  },
  {
    "codigo":290331002,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR MEDIO DE CONTRASTE PARA RESONANCIA MAGNÉTICA"
  },
  {
    "codigo":1142299004,
    "descripcion":"EXTENSIÓN LATERAL DE CEJA"
  },
  {
    "codigo":126491004,
    "descripcion":"NEOPLASIA DE PIEL CON DIFERENCIACIÓN SEBÁCEA"
  },
  {
    "codigo":93723007,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE HUESO DEL CRÁNEO"
  },
  {
    "codigo":124656000,
    "descripcion":"DEFICIENCIA DE FÓSFORO - OXÍGENO LIASA"
  },
  {
    "codigo":421403008,
    "descripcion":"CRIPTOCOCOSIS ASOCIADA CON SIDA (SÍNDROME DE INMUNODEFICIENCIA ADQUIRIDA)"
  },
  {
    "codigo":310671000119105,
    "descripcion":"MIOSITIS INFECCIOSA DE BRAZO IZQUIERDO"
  },
  {
    "codigo":91888004,
    "descripcion":"AUSENCIA CONGÉNITA DEL ILION"
  },
  {
    "codigo":11998761000119100,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO DE PIERNA IZQUIERDA"
  },
  {
    "codigo":384965002,
    "descripcion":"PLEURA MEDIASTÍNICA AFECTADA POR PROPAGACIÓN DIRECTA DE NEOPLASIA MALIGNA"
  },
  {
    "codigo":253893004,
    "descripcion":"PÓLIPO CONGÉNITO DE URÉTER"
  },
  {
    "codigo":712645006,
    "descripcion":"INFLAMACIÓN DE NERVIO FEMORAL"
  },
  {
    "codigo":286661007,
    "descripcion":"CONDUCTA DE EVITACIÓN DEL DAÑO"
  },
  {
    "codigo":90053006,
    "descripcion":"HEMATOCOLPOMETRA"
  },
  {
    "codigo":284826002,
    "descripcion":"DIFICULTAD AL ARRODILLARSE EN LA BAÑERA"
  },
  {
    "codigo":22682006,
    "descripcion":"LUXACIÓN EXPUESTA LATERAL DEL EXTREMO PROXIMAL DE LA TIBIA"
  },
  {
    "codigo":448666006,
    "descripcion":"LINFOMA NO HODGKIN FOLICULAR DE HUESO"
  },
  {
    "codigo":282991001,
    "descripcion":"INCAPAZ DE VOLTEAR LA CABEZA"
  },
  {
    "codigo":414063002,
    "descripcion":"SÍNDROME DE DUANE CON DESVIACIÓN VERTICAL"
  },
  {
    "codigo":952768041000119104,
    "descripcion":"PSEUDOQUISTE DE AMBAS OREJAS"
  },
  {
    "codigo":708975004,
    "descripcion":"OSTEODISTROFIA RENAL MIXTA"
  },
  {
    "codigo":53615006,
    "descripcion":"PULSO PEDIO NORMAL"
  },
  {
    "codigo":248388000,
    "descripcion":"SUPERPOSICIÓN DE LAS SUTURAS CRANEALES"
  },
  {
    "codigo":15685161000119105,
    "descripcion":"TRASTORNO DE EPITELIO CORNEAL DE AMBOS OJOS CAUSADO POR VIRUS VARICELA ZÓSTER"
  },
  {
    "codigo":1003887008,
    "descripcion":"DUPLICACIÓN DE PORCIÓN PROXIMAL DEL BRAZO CORTO DEL CROMOSOMA 3"
  },
  {
    "codigo":1231428004,
    "descripcion":"BACILOS GRAMPOSITIVOS CON FORMA DE MICROESFERA RAMIFICADOS PRESENTES"
  },
  {
    "codigo":93891000119100,
    "descripcion":"LESIÓN ULCEROSA POR CITOMEGALOVIRUS"
  },
  {
    "codigo":51780007,
    "descripcion":"SÍNDROME CEREBROCOSTOMANDIBULAR"
  },
  {
    "codigo":182852008,
    "descripcion":"FÁRMACO NO RETIRADO - PERDIÓ LA RECETA"
  },
  {
    "codigo":1264196008,
    "descripcion":"TRASTORNO FETAL CAUSADO POR TRANSFERENCIA PLACENTARIA DE ANESTESIA GENERAL MATERNA"
  },
  {
    "codigo":339651000119100,
    "descripcion":"XANTOMA DE PÁRPADO INFERIOR IZQUIERDO"
  },
  {
    "codigo":312089004,
    "descripcion":"EFECTO TÓXICO CAUSADO POR PRODUCTO DE LIMPIEZA"
  },
  {
    "codigo":1196825006,
    "descripcion":"LEIOMIOMA DE APÉNDICE"
  },
  {
    "codigo":703470001,
    "descripcion":"SINUSITIS BACTERIANA"
  },
  {
    "codigo":15342002,
    "descripcion":"ENTEROCOLITIS ULCEROSA CRÓNICA"
  },
  {
    "codigo":370841000221108,
    "descripcion":"ANEMIA FERROPÉNICA GRAVE DEL EMBARAZO"
  },
  {
    "codigo":310254004,
    "descripcion":"DENSITOMETRÍA DE HUESO, ANORMAL"
  },
  {
    "codigo":277486008,
    "descripcion":"HIPOPLASIA PULMONAR ASOCIADA CON GESTACIÓN BREVE"
  },
  {
    "codigo":13507004,
    "descripcion":"PÚRPURA FULMINANTE"
  },
  {
    "codigo":111811007,
    "descripcion":"INFECCIÓN MICOBACTERIANA (EXCLUIDAS TUBERCULOSIS Y LEPRA)"
  },
  {
    "codigo":79043008,
    "descripcion":"FACIES DE CORVISART"
  },
  {
    "codigo":109976000,
    "descripcion":"LINFOMA LINFOEPITELOIDE (CLÍNICO)"
  },
  {
    "codigo":372120003,
    "descripcion":"CARCINOMA DE BRONQUIO FUENTE"
  },
  {
    "codigo":44440005,
    "descripcion":"CONFLICTO PSÍQUICO"
  },
  {
    "codigo":105331000220102,
    "descripcion":"PÉRDIDA HORIZONTAL DE HUESO ALVEOLAR ALREDEDOR DE IMPLANTE DE DIENTE"
  },
  {
    "codigo":11672007,
    "descripcion":"VÓLVULO GÁSTRICO ORGANOAXIAL"
  },
  {
    "codigo":271981000,
    "descripcion":"DETRITOS AMIGDALINOS"
  },
  {
    "codigo":697965002,
    "descripcion":"COLANGITIS CON SIDA (SÍNDROME DE INMUNODEFICIENCIA ADQUIRIDA)"
  },
  {
    "codigo":206445003,
    "descripcion":"DEPÓSITO DE PIGMENTO PALÚDICO"
  },
  {
    "codigo":239213006,
    "descripcion":"RUPTURA DEL EXPANSOR TISULAR"
  },
  {
    "codigo":403053007,
    "descripcion":"TIÑA INGUINAL CAUSADA POR TRICHOPHYTON GALLINAE"
  },
  {
    "codigo":302914006,
    "descripcion":"ESÓFAGO DE BARRET"
  },
  {
    "codigo":399383004,
    "descripcion":"VAGINA COMPROMETIDA POR EXTENSIÓN DIRECTA DE NEOPLASIA MALIGNA"
  },
  {
    "codigo":71703005,
    "descripcion":"SÍNDROME DE TRISOMÍA 22 COMPLETA"
  },
  {
    "codigo":1251351006,
    "descripcion":"MELANOSIS DE GENITALES EXTERNOS"
  },
  {
    "codigo":170007006,
    "descripcion":"PESO DEL NIÑO ENTRE PERCENTILOS 3 Y 9"
  },
  {
    "codigo":16697181000119105,
    "descripcion":"ANOMALÍA CONGÉNITA DE ARTERIA RENAL DERECHA"
  },
  {
    "codigo":233708003,
    "descripcion":"EDEMA PULMONAR CONSECUTIVO A OBSTRUCCIÓN DE VÍA AÉREA SUPERIOR"
  },
  {
    "codigo":299244004,
    "descripcion":"SIN AMPLITUD ACTIVA DE FLEXIÓN DE LA CADERA"
  },
  {
    "codigo":69868005,
    "descripcion":"REGIÓN DE OPERACIÓN GENÉTICA"
  },
  {
    "codigo":16015351000119100,
    "descripcion":"PELLIZCAMIENTO DE AMBAS ARTICULACIONES DE TOBILLO"
  },
  {
    "codigo":200940007,
    "descripcion":"LUPUS ERITEMATOSO NODULAR"
  },
  {
    "codigo":364780008,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA BEBER DE UN BEBEDERO"
  },
  {
    "codigo":102636009,
    "descripcion":"DEFICIENCIA CRÓNICA"
  },
  {
    "codigo":35265002,
    "descripcion":"SÍNDROME DE MALLORY - WEISS"
  },
  {
    "codigo":166337002,
    "descripcion":"NIVEL DE HORMONA TIROESTIMULANTE EN SUERO FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":68033004,
    "descripcion":"COMPLICACIÓN DE TRAQUEOSTOMÍA"
  },
  {
    "codigo":231873005,
    "descripcion":"EPISCLERITIS SIMPLE"
  },
  {
    "codigo":395713002,
    "descripcion":"MÁRGENES DE RESECCIÓN QUIRÚRGICA PROFUNDOS COMPROMETIDOS POR NEOPLASIA MALIGNA, FOCAL"
  },
  {
    "codigo":426646004,
    "descripcion":"FRACTURA POR COMPRESIÓN DE LA COLUMNA VERTEBRAL LUMBAR"
  },
  {
    "codigo":787094005,
    "descripcion":"SÍNDROME DE CRECIMIENTO EXCESIVO SEGMENTARIO PROGRESIVO CON HIPERPLASIA FIBROADIPOSA"
  },
  {
    "codigo":721558004,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE CONDUCTO CÍSTICO"
  },
  {
    "codigo":162667001,
    "descripcion":"CONDICIÓN DEL PACIENTE, MALA"
  },
  {
    "codigo":197270009,
    "descripcion":"INSUFICIENCIA HEPÁTICA AGUDA"
  },
  {
    "codigo":31595004,
    "descripcion":"MALACOPLASIA DEL RECTO"
  },
  {
    "codigo":29931000175100,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN DE TALÓN IZQUIERDO GRADO 3"
  },
  {
    "codigo":128064000,
    "descripcion":"AUSENCIA CONGÉNITA DE LA VENA PORTA"
  },
  {
    "codigo":129899009,
    "descripcion":"TRASTORNO DE LA PRESIÓN ARTERIAL"
  },
  {
    "codigo":193600001,
    "descripcion":"CATARATA COMPLICADA"
  },
  {
    "codigo":12020001000004102,
    "descripcion":"FRACTURA DE COSTILLA DERECHA"
  },
  {
    "codigo":160832006,
    "descripcion":"EN PRISIÓN PREVENTIVA"
  },
  {
    "codigo":717888008,
    "descripcion":"HIPERINSULINISMO DEBIDO A HIPERPLASIA ADENOMATOSA FOCAL"
  },
  {
    "codigo":290069002,
    "descripcion":"ALTERACIÓN DE LA COLORACIÓN DE LA PIEL MAMARIA"
  },
  {
    "codigo":191765005,
    "descripcion":"TRASTORNO RELATIVO A LA PERSONALIDAD EMOCIONAL INESTABLE"
  },
  {
    "codigo":421141009,
    "descripcion":"MOVIMIENTO PUPILAR LENTO"
  },
  {
    "codigo":1142037009,
    "descripcion":"PIODERMIA NEONATAL CAUSADA POR STREPTOCOCCUS PYOGENES"
  },
  {
    "codigo":93461009,
    "descripcion":"DISFORIA DE GÉNERO"
  },
  {
    "codigo":342161000119103,
    "descripcion":"CONJUNTIVITIS FOLICULAR AGUDA DE OJO IZQUIERDO"
  },
  {
    "codigo":124394008,
    "descripcion":"DEFICIENCIA DE AMINOTRANSFERASA"
  },
  {
    "codigo":253631001,
    "descripcion":"ESTENOSIS PERIFÉRICA DE ARTERIA PULMONAR"
  },
  {
    "codigo":417471002,
    "descripcion":"ABUSO DE SUSTANCIAS PERSISTENTE"
  },
  {
    "codigo":188095002,
    "descripcion":"NEOPLASIA MALIGNA DE PIEL DE MEJILLA, EXTERNA"
  },
  {
    "codigo":384703004,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA AFECTADO POR CARCINOMA IN SITU DUCTAL, MULTIFOCAL"
  },
  {
    "codigo":1234836004,
    "descripcion":"LESIÓN TRAUMÁTICA PENETRANTE CAUSADA POR FRAGMENTO DE VIDRIO"
  },
  {
    "codigo":87956004,
    "descripcion":"TRANSLUCIDEZ DISMINUIDA"
  },
  {
    "codigo":282729004,
    "descripcion":"CUERPO EXTRAÑO EN EL CORAZÓN"
  },
  {
    "codigo":1296702000,
    "descripcion":"HIPERTENSIÓN OCULAR DE OJO IZQUIERDO DEBIDA A HEMORRAGIA INTRAOCULAR"
  },
  {
    "codigo":249961009,
    "descripcion":"PÉRDIDA DE CONTROL DE MOVIMIENTO"
  },
  {
    "codigo":1263934001,
    "descripcion":"HEMORRAGIA INTRACRANEANA EXTRADURAL NEONATAL"
  },
  {
    "codigo":444734003,
    "descripcion":"NO CUMPLE CON LOS CRITERIOS DE ELEGIBILIDAD PARA ENSAYO CLÍNICO"
  },
  {
    "codigo":315497008,
    "descripcion":"NACIDO EN PALESTINA"
  },
  {
    "codigo":706878007,
    "descripcion":"ABSCESO CRÓNICO DE PIERNA"
  },
  {
    "codigo":248126008,
    "descripcion":"COMIDA CÓMODA"
  },
  {
    "codigo":18750008,
    "descripcion":"REACCIÓN AUTOINMUNITARIA MEDIADA POR CÉLULAS B"
  },
  {
    "codigo":311827003,
    "descripcion":"LESIÓN INTRACRANEAL CON COMA PROLONGADO, SIN HERIDA ABIERTA"
  },
  {
    "codigo":82451005,
    "descripcion":"AMPOLLA DEL BRAZO, CON INFECCIÓN"
  },
  {
    "codigo":279059006,
    "descripcion":"NEURALGIA DE NERVIO HIPOGLOSO"
  },
  {
    "codigo":47848000,
    "descripcion":"FRACTURA NO EXPUESTA DEL CÓNDILO DE LA TIBIA"
  },
  {
    "codigo":38951000087105,
    "descripcion":"FRACTURA DE PIE IZQUIERDO"
  },
  {
    "codigo":44071000087105,
    "descripcion":"CORTE EN PIEL DE CODO DERECHO"
  },
  {
    "codigo":46631000087106,
    "descripcion":"FRACTURA DE FALANGE DISTAL DE PULGAR DERECHO"
  },
  {
    "codigo":41511000087108,
    "descripcion":"HERIDA PUNZANTE DE EXTREMIDAD SUPERIOR IZQUIERDA"
  },
  {
    "codigo":703208005,
    "descripcion":"OCLUSIÓN ASINTOMÁTICA DE ARTERIA CEREBRAL MEDIA"
  },
  {
    "codigo":15080006,
    "descripcion":"MIOPATÍA MIOTUBULAR CON ATROFIA DE TIPO I"
  },
  {
    "codigo":277224006,
    "descripcion":"MUCOSA NASAL CIANÓTICA"
  },
  {
    "codigo":275389001,
    "descripcion":"BAYAS - EFECTO TÓXICO"
  },
  {
    "codigo":111549004,
    "descripcion":"HIPERFUNCIÓN OVÁRICA"
  },
  {
    "codigo":1356733005,
    "descripcion":"HERIDAS CERRADAS MÚLTIPLES DE VASO DIGITAL DE PIE"
  },
  {
    "codigo":406461004,
    "descripcion":"LATIDOS AURICULARES ECTÓPICOS"
  },
  {
    "codigo":371858000,
    "descripcion":"HEMODINAMIA DE LAS CÁMARAS CARDÍACAS IZQUIERDAS Y DERECHAS, NORMAL"
  },
  {
    "codigo":109714003,
    "descripcion":"OSTEÍTIS FIBROSA PERIRRADICULAR LOCALIZADA"
  },
  {
    "codigo":240786004,
    "descripcion":"BASIDIOBOLOMICOSIS CUTÁNEA"
  },
  {
    "codigo":699538007,
    "descripcion":"LIPOMA INTRAÓSEO"
  },
  {
    "codigo":271719001,
    "descripcion":"PRESIÓN INTRACRANEAL AUMENTADA"
  },
  {
    "codigo":1156455001,
    "descripcion":"XANTOASTROCITOMA PLEOMÓRFICO DE CEREBRO"
  },
  {
    "codigo":1287527004,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE CUERO CABELLUDO"
  },
  {
    "codigo":402791005,
    "descripcion":"INMUNODEFICIENCIA DE LINFOCITOS B"
  },
  {
    "codigo":238951005,
    "descripcion":"XANTELASMA"
  },
  {
    "codigo":42343007,
    "descripcion":"INSUFICIENCIA CARDÍACA CONGESTIVA"
  },
  {
    "codigo":400956000,
    "descripcion":"EPICANTO INVERSO"
  },
  {
    "codigo":237116001,
    "descripcion":"ENDOMETRIOMA"
  },
  {
    "codigo":1254759005,
    "descripcion":"INTOXICACIÓN AUTOINFLIGIDA CON SUSTANCIA CÁUSTICA"
  },
  {
    "codigo":38673002,
    "descripcion":"ÚLCERA DEL CORDÓN ESPERMÁTICO"
  },
  {
    "codigo":366353002,
    "descripcion":"HALLAZGO RELACIONADO CON EL REFLEJO MASETÉRICO"
  },
  {
    "codigo":300817006,
    "descripcion":"NO CUIDA UNA MASCOTA"
  },
  {
    "codigo":724966000,
    "descripcion":"DISTENSIÓN DE FASCIA DE MÚSCULO FLEXOR A LA ALTURA DEL ANTEBRAZO"
  },
  {
    "codigo":4070001,
    "descripcion":"PALINFRASIA"
  },
  {
    "codigo":169745008,
    "descripcion":"LACTANCIA MATERNA INICIADA"
  },
  {
    "codigo":200678006,
    "descripcion":"CELULITIS Y ABSCESO DE LA CADERA"
  },
  {
    "codigo":298982006,
    "descripcion":"AMPLITUD DE ADUCCIÓN ACTIVA DE ARTICULACIÓN DE MUÑECA, NORMAL"
  },
  {
    "codigo":723131006,
    "descripcion":"MEGALOPAPILA"
  },
  {
    "codigo":428219007,
    "descripcion":"DEPENDENCIA DE CAFEÍNA"
  },
  {
    "codigo":297147009,
    "descripcion":"ATROFIA VAGINAL"
  },
  {
    "codigo":721296004,
    "descripcion":"SÍNDROME DE FUHRMANN"
  },
  {
    "codigo":459152004,
    "descripcion":"ENDOCARDITIS INFECCIOSA DE VÁLVULA MITRAL"
  },
  {
    "codigo":262544007,
    "descripcion":"LACERACIÓN SUPERFICIAL DE LA CABEZA"
  },
  {
    "codigo":33168009,
    "descripcion":"ENTROPIÓN"
  },
  {
    "codigo":424549003,
    "descripcion":"NEOPLASIA MALIGNA DE MÉDULA ESPINAL, EXTRAMEDULAR"
  },
  {
    "codigo":129637007,
    "descripcion":"TRASTORNO DE LA MÉDULA ADRENAL"
  },
  {
    "codigo":62266001,
    "descripcion":"MIOPATÍA HIPERMETABÓLICA DE LUFT"
  },
  {
    "codigo":95034004,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL LIGAMENTO REDONDO DEL ÚTERO"
  },
  {
    "codigo":291642005,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR SULFAFURAZOL"
  },
  {
    "codigo":226106006,
    "descripcion":"DIETA CON ALTO CONTENIDO DE ÁCIDO LINOLEICO"
  },
  {
    "codigo":191503003,
    "descripcion":"ESTADO CONFUSIONAL AGUDO, DE ORIGEN ENDOCRINO"
  },
  {
    "codigo":93199007,
    "descripcion":"LINFOMA MALIGNO DE LOCALIZACIÓN EN ÓRGANO MACIZO Y\/O EXTRAGANGLIONAR"
  },
  {
    "codigo":713956000,
    "descripcion":"TORTÍCOLIS ESPASMÓDICO COMO EFECTO TARDÍO DE TRAUMATISMO"
  },
  {
    "codigo":224271009,
    "descripcion":"VIVE EN CONDICIONES SÓRDIDAS"
  },
  {
    "codigo":58596002,
    "descripcion":"ESTRIDOR INSPIRATORIO"
  },
  {
    "codigo":124132003,
    "descripcion":"DEFICIENCIA DE GLUCOSA DESHIDROGENASA"
  },
  {
    "codigo":289807008,
    "descripcion":"HALLAZGO RELACIONADO CON LA CONSISTENCIA DE MOCO CERVICAL"
  },
  {
    "codigo":253369000,
    "descripcion":"DEFECTO DE SENO VENOSO CON CABALGAMIENTO DE VENA CAVA SUPERIOR"
  },
  {
    "codigo":286137001,
    "descripcion":"LIMPIA LOS ELECTRODOMÉSTICOS"
  },
  {
    "codigo":187833006,
    "descripcion":"NEOPLASIA MALIGNA DEL CONDUCTO AUDITIVO, EL OÍDO MEDIO Y LAS CELDILLAS AÉREAS MASTOIDEAS"
  },
  {
    "codigo":1269177007,
    "descripcion":"INTOXICACIÓN AGUDA POR ANTIDEPRESIVO TRICÍCLICO"
  },
  {
    "codigo":87694001,
    "descripcion":"DEFICIENCIA DE PIRUVATO CARBOXILASA"
  },
  {
    "codigo":284302007,
    "descripcion":"REALIZA LA PRENSIÓN CON OPOSICIÓN DE PULGAR"
  },
  {
    "codigo":773987000,
    "descripcion":"HIPOTIROIDISMO NEONATAL TRANSITORIO DEBIDO A EXPOSICIÓN NEONATAL A YODO"
  },
  {
    "codigo":249699000,
    "descripcion":"COSTILLA ANCHA"
  },
  {
    "codigo":85859006,
    "descripcion":"ÚLCERA GÁSTRICA CRÓNICA CON HEMORRAGIA Y OBSTRUCCIÓN"
  },
  {
    "codigo":247864006,
    "descripcion":"MIEDO DE LAS MÁSCARAS QUIRÚRGICAS"
  },
  {
    "codigo":460671000124103,
    "descripcion":"INCONTINENCIA FECAL FRECUENTE"
  },
  {
    "codigo":213261000,
    "descripcion":"HEMORRAGIA INTRAOPERATORIA"
  },
  {
    "codigo":445311000124104,
    "descripcion":"MÉTODO DE ADMINISTRACIÓN DE NUTRICIÓN ENTERAL INADECUADO"
  },
  {
    "codigo":1163533002,
    "descripcion":"ENCEFALITIS POR VIRUS KOKOBERA"
  },
  {
    "codigo":2431000124108,
    "descripcion":"PRIMER MOLAR INFERIOR IZQUIERDO PERMANENTE SUPERNUMERARIO"
  },
  {
    "codigo":47586000,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE LA VULVA, CON INFECCIÓN"
  },
  {
    "codigo":11842451000119109,
    "descripcion":"DISTENSIÓN DE TENDÓN DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":276962007,
    "descripcion":"CARCINOMA ESCAMOSO DEL PALADAR"
  },
  {
    "codigo":307895001,
    "descripcion":"ESTADO DE LA TARJETA DE REPETICIÓN DE LA PRESCRIPCIÓN"
  },
  {
    "codigo":12983003,
    "descripcion":"INTENTO FALLIDO DE ABORTO CON CHOQUE SÉPTICO"
  },
  {
    "codigo":111287006,
    "descripcion":"INSUFICIENCIA DE VÁLVULA TRICÚSPIDE"
  },
  {
    "codigo":373431007,
    "descripcion":"VASOS FANTASMAS DE CÓRNEA"
  },
  {
    "codigo":699276000,
    "descripcion":"MUCOSA DEL MASTICADOR DE BETEL"
  },
  {
    "codigo":240524001,
    "descripcion":"FIEBRE HEMORRÁGICA BRASILEÑA"
  },
  {
    "codigo":209591009,
    "descripcion":"DESGARRO COMPLETO DE LIGAMENTO RADIOESCAFOSEMILUNAR"
  },
  {
    "codigo":109452003,
    "descripcion":"MESIODENS ERUPCIONADO"
  },
  {
    "codigo":43916004,
    "descripcion":"MUCOPOLISACARIDOSIS, MPS - VII"
  },
  {
    "codigo":764812008,
    "descripcion":"ARTROGRIPOSIS MÚLTIPLE CONGÉNITA MIOGÉNICA AUTOSÓMICA RECESIVA"
  },
  {
    "codigo":371596008,
    "descripcion":"TRASTORNO BIPOLAR I"
  },
  {
    "codigo":238689002,
    "descripcion":"SENSIBILIDAD RETARDADA AL FRÍO"
  },
  {
    "codigo":11815981000119107,
    "descripcion":"LESIÓN TRAUMÁTICA DE ARTERIA HUMERAL DERECHA"
  },
  {
    "codigo":101421000119107,
    "descripcion":"DEMENCIA DEBIDA A ENFERMEDAD DE PARKINSON"
  },
  {
    "codigo":1156193004,
    "descripcion":"INESTABILIDAD HABITACIONAL DEBIDA A CAMBIOS FRECUENTES DE VIVIENDA"
  },
  {
    "codigo":402529002,
    "descripcion":"CARCINOMA BASOCELULAR-MICRONODULAR"
  },
  {
    "codigo":10832941000119108,
    "descripcion":"FRACTURA EXPUESTA DE CUARTO HUESO METACARPIANO DE MANO IZQUIERDA"
  },
  {
    "codigo":369761008,
    "descripcion":"RESPUESTA LINFOCÍTICA PERITUMORAL, LEVE A MODERADA"
  },
  {
    "codigo":1187126002,
    "descripcion":"AMILOIDOSIS ITM2B"
  },
  {
    "codigo":204086002,
    "descripcion":"DESPLAZAMIENTO DEL PLEXO BRAQUIAL"
  },
  {
    "codigo":347181000119109,
    "descripcion":"ESCLERITIS ANTERIOR DE AMBOS OJOS"
  },
  {
    "codigo":236854007,
    "descripcion":"ESPLENITIS SÉPTICA"
  },
  {
    "codigo":73014008,
    "descripcion":"PROTEINURIA PIÓGENA"
  },
  {
    "codigo":890379002,
    "descripcion":"DUPLICACIÓN CONGÉNITA DE VESÍCULA BILIAR TIPO 2"
  },
  {
    "codigo":366091006,
    "descripcion":"SONIDOS ASOCIADOS CON EL MOVIMIENTO OCULAR - HALLAZGO"
  },
  {
    "codigo":235019006,
    "descripcion":"EROSIÓN DE LA MUCOSA BUCAL"
  },
  {
    "codigo":169483008,
    "descripcion":"DISPOSITIVO ANTICONCEPTIVO INTRAUTERINO - EN ESPERA DE AJUSTE"
  },
  {
    "codigo":202251008,
    "descripcion":"SUBLUXACIÓN RECURRENTE DE TOBILLO"
  },
  {
    "codigo":298720006,
    "descripcion":"HALLAZGO RELACIONADO CON HUESO DEL TÓRAX"
  },
  {
    "codigo":167648007,
    "descripcion":"GRASA FECAL NORMAL"
  },
  {
    "codigo":1973000,
    "descripcion":"TRASTORNO PSICÓTICO CON DELUSIONES INDUCIDO POR SEDANTES, HIPNÓTICOS Y\/O ANSIOLÍTICOS"
  },
  {
    "codigo":823008009,
    "descripcion":"QUISTE DE PIEL DE CEJA"
  },
  {
    "codigo":200416006,
    "descripcion":"INGURGITACIÓN MAMARIA EN EL EMBARAZO, EL PUERPERIO O LA LACTANCIA"
  },
  {
    "codigo":296885000,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE NANDROLONA"
  },
  {
    "codigo":1148853004,
    "descripcion":"ANEMIA FERROPÉNICA POSGASTRECTOMÍA"
  },
  {
    "codigo":34741005,
    "descripcion":"NERVIOS (ATAQUE)"
  },
  {
    "codigo":722869007,
    "descripcion":"CÁLCULO DE VESÍCULA BILIAR SIN COLECISTITIS O COLANGITIS"
  },
  {
    "codigo":32906002,
    "descripcion":"VÍCTIMA, PEATÓN EN ACCIDENTE VEHICULAR Y\/O DE TRÁNSITO"
  },
  {
    "codigo":196746003,
    "descripcion":"VÓMITOS PERSISTENTES"
  },
  {
    "codigo":360586005,
    "descripcion":"DEFICIENCIA DE ACETILCOLINESTERASA"
  },
  {
    "codigo":197811007,
    "descripcion":"REFLUJO VESICOURETERAL"
  },
  {
    "codigo":1179786008,
    "descripcion":"GLUCÓGENO DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":719199001,
    "descripcion":"PROMINENCIA ANORMAL DE COSTILLA"
  },
  {
    "codigo":1145183007,
    "descripcion":"TROMBOSIS DE PLEXO PAMPINIFORME"
  },
  {
    "codigo":162143008,
    "descripcion":"DOLOR EN APARATO GENITAL FEMENINO"
  },
  {
    "codigo":1208884000,
    "descripcion":"SÍNDROME DE QT PROLONGADO TIPO 10"
  },
  {
    "codigo":293215009,
    "descripcion":"REACCIÓN ADVERSA AL DIACETATO DE ETINODIOL"
  },
  {
    "codigo":94772006,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE BRONQUIO DE LÓBULO MEDIO DE PULMÓN DERECHO"
  },
  {
    "codigo":225844009,
    "descripcion":"CARECE DE PRINCIPIOS ÉTICOS"
  },
  {
    "codigo":92937004,
    "descripcion":"FORMA ANORMAL CONGÉNITA DEL PABELLÓN AURICULAR"
  },
  {
    "codigo":1010441004,
    "descripcion":"PÉRDIDA DE LA AUDICIÓN NEUROSENSORIAL DE OÍDO DERECHO CON AUDICIÓN NORMAL DEL OÍDO IZQUIERDO"
  },
  {
    "codigo":289545004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CONSISTENCIA DEL FLUJO VAGINAL"
  },
  {
    "codigo":103931000119102,
    "descripcion":"COMA HEPÁTICO DEBIDO A HEPATITIS"
  },
  {
    "codigo":715529009,
    "descripcion":"SORDERA PROGRESIVA CON FIJACIÓN DEL ESTRIBO"
  },
  {
    "codigo":713694002,
    "descripcion":"TRASTORNO DE COMPONENTE CELULAR DE LA SANGRE CAUSADO POR FÁRMACO ANTIRRETROVIRAL"
  },
  {
    "codigo":254942002,
    "descripcion":"NEOPLASIA DE PLEXO COROIDEO"
  },
  {
    "codigo":781065009,
    "descripcion":"TRANSPOSICIÓN DE VENA CAVA INFERIOR"
  },
  {
    "codigo":189406008,
    "descripcion":"NEOPLASIA DE CONDUCTO Y ESFÍNTER ANAL DE COMPORTAMIENTO INCIERTO"
  },
  {
    "codigo":449715001,
    "descripcion":"DEFORMIDAD DE MIEMBRO INFERIOR"
  },
  {
    "codigo":1268915004,
    "descripcion":"QUISTE DE CONDUCTO DE NUCK"
  },
  {
    "codigo":349121000119101,
    "descripcion":"SÍNDROME DE DISPERSIÓN DE PIGMENTO DE AMBOS OJOS"
  },
  {
    "codigo":1091521000119102,
    "descripcion":"HEMOTÍMPANO DE LA CAVIDAD TIMPÁNICA DERECHA"
  },
  {
    "codigo":8641000119101,
    "descripcion":"SÍNDROME DE HETEROTAXIA CON POLIESPLENIA"
  },
  {
    "codigo":961000119104,
    "descripcion":"ESGUINCE DE MANGUITO ROTADOR DEL HOMBRO"
  },
  {
    "codigo":15673281000119100,
    "descripcion":"NÓDULO REUMATOIDEO DE TEJIDO CELULAR SUBCUTÁNEO DE AMBAS REGIONES DE MUÑECA"
  },
  {
    "codigo":15750081000119106,
    "descripcion":"BEBÉ PREMATURO, 30 SEMANAS"
  },
  {
    "codigo":100801000119107,
    "descripcion":"CONSUMO MATERNO DE TABACO DURANTE EL EMBARAZO"
  },
  {
    "codigo":367041000119108,
    "descripcion":"ADRENOLEUCODISTROFIA CEREBRAL LIGADA AL CROMOSOMA X DE LA INFANCIA"
  },
  {
    "codigo":328641000119109,
    "descripcion":"TRASTORNO GENÉTICO DE DISFUNCIÓN DEL SURFACTANTE"
  },
  {
    "codigo":308161000119109,
    "descripcion":"DEFORMIDAD EN FLEXIÓN DE ARTICULACIÓN DE CODO IZQUIERDO"
  },
  {
    "codigo":290241000119109,
    "descripcion":"ADHERENCIAS MENÍNGEAS"
  },
  {
    "codigo":15714241000119109,
    "descripcion":"DEDO DEL PIE DERECHO EN MARTILLO ADQUIRIDO"
  },
  {
    "codigo":11313601000119105,
    "descripcion":"FRACTURA NO EXPUESTA DE HUESO OCCIPITAL"
  },
  {
    "codigo":413277002,
    "descripcion":"ESTENOSIS POSOPERATORIA"
  },
  {
    "codigo":314973003,
    "descripcion":"RECIDIVA LOCAL DE NEOPLASIA MALIGNA DE HUESO"
  },
  {
    "codigo":85597002,
    "descripcion":"ATRAGANTAMIENTO CAUSADO POR PRESENCIA DE FLEMA EN LA LARINGE"
  },
  {
    "codigo":282205005,
    "descripcion":"COMIENZA A CAMINAR"
  },
  {
    "codigo":249437006,
    "descripcion":"NO SE VISUALIZAN CUERDAS VOCALES"
  },
  {
    "codigo":710024009,
    "descripcion":"MORFOLOGÍA DE CRESTA ALVEOLAR RESIDUAL DE MAXILAR SUPERIOR CON REBORDE ANTERIOR MÓVIL HIPERPLÁSICO"
  },
  {
    "codigo":247602005,
    "descripcion":"FUNCIÓN DE LA MEMORIA, NORMAL"
  },
  {
    "codigo":313138008,
    "descripcion":"ESTADIO DE MARCADOR SEROLÓGICO TUMORAL SX"
  },
  {
    "codigo":737287002,
    "descripcion":"AUDÍFONO EXTERNO IN SITU"
  },
  {
    "codigo":278535003,
    "descripcion":"TRASTORNO RELACIONADO CON PRÓTESIS DE CONDUCTO BILIAR"
  },
  {
    "codigo":80092001,
    "descripcion":"INTOXICACIÓN POR CEFALORIDINA"
  },
  {
    "codigo":735452003,
    "descripcion":"ANEMIA POR DEFICIENCIA HEREDITARIA DE VITAMINA B12"
  },
  {
    "codigo":276700005,
    "descripcion":"RINITIS SIFILÍTICA CONGÉNITA"
  },
  {
    "codigo":1259740006,
    "descripcion":"GLIOMA PRIMARIO MALIGNO DE CEREBELO"
  },
  {
    "codigo":111025007,
    "descripcion":"HIPERTROFIA DE LAS PAPILAS DÉRMICAS"
  },
  {
    "codigo":699014000,
    "descripcion":"NEUMONÍA RECURRENTE"
  },
  {
    "codigo":12721007,
    "descripcion":"LENGUA TRÍFIDA"
  },
  {
    "codigo":240262002,
    "descripcion":"HIPERMOVILIDAD LOCALIZADA BENIGNA DE LA ARTICULACIÓN"
  },
  {
    "codigo":895622002,
    "descripcion":"FORMA ROMBOIDE ANORMAL CONGÉNITA DE FALANGE MEDIA DE DEDO MEÑIQUE"
  },
  {
    "codigo":76422004,
    "descripcion":"LINFOMA ESTADIO II"
  },
  {
    "codigo":404102002,
    "descripcion":"ERUPCIÓN PREMICÓTICA"
  },
  {
    "codigo":307633009,
    "descripcion":"ENFERMEDAD DE HODGKIN, AGOTAMIENTO DE LINFOCITOS, FIBROSIS DIFUSA"
  },
  {
    "codigo":402267000,
    "descripcion":"DERMATITIS IRRITATIVA CAUSADA POR CONTACTO CON VIRUTAS DE METAL"
  },
  {
    "codigo":305798009,
    "descripcion":"ATENDIDO EN SERVICIO DE CUIDADOS INTENSIVOS PEDIÁTRICOS"
  },
  {
    "codigo":369499000,
    "descripcion":"TUMOR MALIGNO QUE COMPROMETE EL CUELLO UTERINO POR PROPAGACIÓN DIRECTA DE LA VAGINA"
  },
  {
    "codigo":238427006,
    "descripcion":"ESCARLATINA ESTAFILOCÓCICA"
  },
  {
    "codigo":74587007,
    "descripcion":"INFECCIÓN CAUSADA POR TRICHOBILHARZIA STAGNICOLAE"
  },
  {
    "codigo":9051008,
    "descripcion":"TRASTORNO DE CARTÍLAGO ARTICULAR DE BRAZO"
  },
  {
    "codigo":236592000,
    "descripcion":"ESTENOSIS DEL CUELLO DE CÁLIZ RENAL"
  },
  {
    "codigo":1186864007,
    "descripcion":"ENFERMEDAD HEPÁTICA DEBIDA A TRASTORNO DE FUNCIÓN PEROXISÓMICA"
  },
  {
    "codigo":70917000,
    "descripcion":"MIOSITIS OSIFICANTE TRAUMÁTICA"
  },
  {
    "codigo":890117001,
    "descripcion":"SÍNDROME DE DELECIÓN 20P12.2"
  },
  {
    "codigo":105520007,
    "descripcion":"DESAVENENCIA CON EL CONSEJERO"
  },
  {
    "codigo":300293003,
    "descripcion":"HALLAZGO RELACIONADO CON MEDICIONES DEL ESÓFAGO"
  },
  {
    "codigo":169221005,
    "descripcion":"ECOGRAFÍA OBSTÉTRICA NORMAL"
  },
  {
    "codigo":200154000,
    "descripcion":"PARTOS POR OPERACIÓN DESTRUCTIVA"
  },
  {
    "codigo":38149009,
    "descripcion":"INTOXICACIÓN POR ESPIRAMICINA"
  },
  {
    "codigo":365829008,
    "descripcion":"DENSIDAD RELATIVA DE LÍQUIDO PLEURAL - HALLAZGO"
  },
  {
    "codigo":429530004,
    "descripcion":"MAREO DE CAUSA DESCONOCIDA"
  },
  {
    "codigo":724442004,
    "descripcion":"DISECCIÓN DE AORTA ASCENDENTE Y CAYADO AÓRTICO"
  },
  {
    "codigo":298458009,
    "descripcion":"AMPLITUD DE ROTACIÓN PASIVA HACIA LA DERECHA DE LA COLUMNA CERVICAL DISMINUIDA"
  },
  {
    "codigo":198319004,
    "descripcion":"ÚTERO AUMENTADO DE TAMAÑO"
  },
  {
    "codigo":1148591005,
    "descripcion":"PH DE SANGRE VENOSA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":67247008,
    "descripcion":"FIEBRE HEMORRÁGICA BOLIVIANA"
  },
  {
    "codigo":130948000,
    "descripcion":"TRASTORNO RENAL"
  },
  {
    "codigo":722607009,
    "descripcion":"TUMEFACCIÓN DE PAPILA ÓPTICA CONCOMITANTE CON UVEÍTIS"
  },
  {
    "codigo":425860006,
    "descripcion":"DOLOR IRRADIADO AL ABDOMEN INFERIOR"
  },
  {
    "codigo":32644009,
    "descripcion":"CONTRACCIONES DE BRAXTON HICKS"
  },
  {
    "codigo":294788009,
    "descripcion":"ALERGIA A QUINESTROL"
  },
  {
    "codigo":1144921004,
    "descripcion":"TRASTORNO CARDÍACO DEBIDO A LUPUS ERITEMATOSO SISTÉMICO"
  },
  {
    "codigo":292953004,
    "descripcion":"REACCIÓN ADVERSA AL TEMAFLOXACINO"
  },
  {
    "codigo":718937008,
    "descripcion":"DISFUNCIÓN SOMÁTICA DE REGIÓN DE TOBILLO"
  },
  {
    "codigo":448946121000119109,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE ESPACIO INTRAMEDULAR INTRADURAL ESPINAL"
  },
  {
    "codigo":127278005,
    "descripcion":"LESIÓN TRAUMÁTICA DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":192814005,
    "descripcion":"DEGENERACIÓN CEREBRAL POR HIDROCEFALIA CONGÉNITA"
  },
  {
    "codigo":291118007,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR CLORMETIAZOL"
  },
  {
    "codigo":225582009,
    "descripcion":"USA ANTEOJOS"
  },
  {
    "codigo":92675002,
    "descripcion":"CARCINOMA IN SITU DE LA GLÁNDULA PARATIROIDES"
  },
  {
    "codigo":190979003,
    "descripcion":"DEFICIENCIA SELECTIVA DE INMUNOGLOBULINA A"
  },
  {
    "codigo":289283004,
    "descripcion":"MEMBRANAS AMNIÓTICAS PRESENTES"
  },
  {
    "codigo":94510009,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL FONDO DE SACO RECTOUTERINO"
  },
  {
    "codigo":715267006,
    "descripcion":"INTOXICACIÓN CON DISULFIRAM"
  },
  {
    "codigo":254680003,
    "descripcion":"MILIUM PRIMARIO"
  },
  {
    "codigo":123608004,
    "descripcion":"COLANGIECTASIA"
  },
  {
    "codigo":1336024008,
    "descripcion":"GLAUCOMA DEBIDO A QUISTE DE AMBOS OJOS"
  },
  {
    "codigo":416685005,
    "descripcion":"HALLAZGO RELACIONADO CON EL HUESO PÚBICO"
  },
  {
    "codigo":283778001,
    "descripcion":"MORDEDURA DE PERRO EN DEDO GORDO"
  },
  {
    "codigo":21634003,
    "descripcion":"SÍNDROME DE BORJESON - FORSSMAN - LEHMANN"
  },
  {
    "codigo":314711000,
    "descripcion":"CITACIÓN RECIBIDA"
  },
  {
    "codigo":1332354009,
    "descripcion":"HIPERTROFIA DE CLAVÍCULA"
  },
  {
    "codigo":609623002,
    "descripcion":"HALLAZGO RELACIONADO CON EL SEGMENTO SUPERIOR DEL TRONCO"
  },
  {
    "codigo":414850009,
    "descripcion":"NEUTROFILIA TRASTORNO"
  },
  {
    "codigo":247340001,
    "descripcion":"SENSACIÓN DE COMIENZO INMINENTE DE DIARREA"
  },
  {
    "codigo":442113000,
    "descripcion":"RECUENTO DE NEUTRÓFILOS EN CAYADO POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1163009003,
    "descripcion":"REACCIÓN ADVERSA A ÁCIDO BILIAR Y\/O DERIVADO DE ÁCIDO BILIAR"
  },
  {
    "codigo":212737004,
    "descripcion":"INTOXICACIÓN POR CLORMERODRINA"
  },
  {
    "codigo":16129004,
    "descripcion":"MONOSOMÍA PARCIAL 10Q"
  },
  {
    "codigo":1285256004,
    "descripcion":"SIN RANGO PASIVO DE DORSIFLEXIÓN DE TOBILLO"
  },
  {
    "codigo":735190001,
    "descripcion":"AGOTAMIENTO POR CALOR CONCOMITANTE CON ANHIDROSIS Y DEBIDO A ELLA"
  },
  {
    "codigo":210902004,
    "descripcion":"LESIÓN DE MÚLTIPLES VASOS SANGUÍNEOS A NIVEL DE TOBILLO Y PIE"
  },
  {
    "codigo":866262007,
    "descripcion":"OBSTRUCCIÓN COMPLETA DE PUNTO LAGRIMAL INFERIOR"
  },
  {
    "codigo":473046009,
    "descripcion":"COMPLICACIÓN ASOCIADA CON IMPLANTE EN EL SISTEMA NERVIOSO"
  },
  {
    "codigo":79830009,
    "descripcion":"HIPERTRICOSIS PALPEBRAL"
  },
  {
    "codigo":274603003,
    "descripcion":"REFLEJO CILIOESPINAL NEGATIVO"
  },
  {
    "codigo":733355004,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE ÓRGANO DIGESTIVO"
  },
  {
    "codigo":1259478009,
    "descripcion":"DEMENCIA DEBIDA A ENFERMEDAD DE CREUTZFELDT-JAKOB FAMILIAR"
  },
  {
    "codigo":307371007,
    "descripcion":"OBSERVACIONES DE CLO - TEST PARA HELICOBACTER"
  },
  {
    "codigo":209067008,
    "descripcion":"LUXACIÓN VERTEBRAL EXPUESTA CON LESIÓN MEDULAR ANTERIOR A NIVEL CERVICAL"
  },
  {
    "codigo":45227007,
    "descripcion":"MIOCARDIOPATÍA OBSTRUCTIVA HIPERTRÓFICA"
  },
  {
    "codigo":241835009,
    "descripcion":"ENVENENAMIENTO CAUSADO POR ANÉMONA DE MAR"
  },
  {
    "codigo":76160002,
    "descripcion":"INFECCIÓN CAUSADA POR ASCARIDIA"
  },
  {
    "codigo":403840005,
    "descripcion":"INFECCIÓN ESTAFILOCÓCICA NEONATAL DE LA PIEL"
  },
  {
    "codigo":305536007,
    "descripcion":"BAJO ATENCIÓN DE CIRUJANO ESPECIALISTA EN TRACTO GASTROINTESTINAL"
  },
  {
    "codigo":371072008,
    "descripcion":"NEUMONÍA POSOBSTRUCTIVA"
  },
  {
    "codigo":1255808008,
    "descripcion":"SARCOMA DE HODGKIN DE GANGLIOS LINFÁTICOS DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":205397003,
    "descripcion":"TOBILLO EN VARO CONGÉNITO"
  },
  {
    "codigo":74325003,
    "descripcion":"ENFERMEDAD CAUSADA POR MORBILLIVIRUS"
  },
  {
    "codigo":926293005,
    "descripcion":"EPÍFISIS PEQUEÑA DE FALANGE DE CUARTO DEDO DE PIE"
  },
  {
    "codigo":15729201000119101,
    "descripcion":"DISLOCACIÓN DE AMBAS ARTICULACIONES DE TOBILLO DEBIDA A DISPLASIA CONGÉNITA DE AMBAS ARTICULACIONES DE TOBILLO"
  },
  {
    "codigo":301866000,
    "descripcion":"HALLAZGO RELACIONADO CON EL TAMAÑO DE UN GANGLIO LINFÁTICO"
  },
  {
    "codigo":400170001,
    "descripcion":"HIPOCALCEMIA DEL PUERPERIO"
  },
  {
    "codigo":203562002,
    "descripcion":"TORSIÓN FEMORAL EXTERNA ADQUIRIDA"
  },
  {
    "codigo":6954003,
    "descripcion":"FRACTURA EXPUESTA DE CÓNDILO DE HÚMERO"
  },
  {
    "codigo":201727001,
    "descripcion":"ARTROPATÍA EN LA COLITIS ULCEROSA"
  },
  {
    "codigo":37887002,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN LA REGIÓN DEL CUELLO, CON INFECCIÓN"
  },
  {
    "codigo":234495004,
    "descripcion":"PÚRPURA NO TROMBOCITOPÉNICA SECUNDARIA"
  },
  {
    "codigo":365567004,
    "descripcion":"HALLAZGO DE ANTECEDENTES LEGALES RELACIONADOS CON NOMBRAMIENTO DEL APODERADO LEGAL"
  },
  {
    "codigo":70655008,
    "descripcion":"TRASTORNO DE ANSIEDAD INDUCIDO POR CAFEÍNA"
  },
  {
    "codigo":429268001,
    "descripcion":"INFECCIÓN DE CATÉTER VASCULAR"
  },
  {
    "codigo":298196001,
    "descripcion":"HIPERMOVILIDAD DE ARTICULACIÓN DE CADERA"
  },
  {
    "codigo":363732003,
    "descripcion":"ENFERMEDAD DE ADDISON"
  },
  {
    "codigo":296361003,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE PILOCARPINA"
  },
  {
    "codigo":165289003,
    "descripcion":"MEMORIA: NO TIENE CONSCIENCIA DEL AÑO ACTUAL"
  },
  {
    "codigo":198057005,
    "descripcion":"VASCULOPATÍAS EN LOS ÓRGANOS GENITALES MASCULINOS"
  },
  {
    "codigo":425598000,
    "descripcion":"PULSOS CENTRALES PRESENTES"
  },
  {
    "codigo":137931000119102,
    "descripcion":"HIPERLIPIDEMIA DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":66985009,
    "descripcion":"SÍNDROME DE TRISOMÍA PARCIAL 18Q"
  },
  {
    "codigo":11770571000119103,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA ANTERIOR DE CABEZA RADIAL DERECHA"
  },
  {
    "codigo":194387002,
    "descripcion":"SORDERA ISQUÉMICA TRANSITORIA"
  },
  {
    "codigo":292691002,
    "descripcion":"REACCIÓN ADVERSA AL VECURONIO"
  },
  {
    "codigo":94248000,
    "descripcion":"NEOPLASIA MALIGNA SECUNDARIA DEL CEREBRO"
  },
  {
    "codigo":816979008,
    "descripcion":"NEOPLASIA INTRAEPITELIAL DIFERENCIADA DE VULVA"
  },
  {
    "codigo":127016006,
    "descripcion":"NEOPLASIA DE MÚLTIPLES GLÁNDULAS ENDOCRINAS"
  },
  {
    "codigo":389160009,
    "descripcion":"DISPLASIA ESPONDILOEPIFISARIA CON LAXITUD ARTICULAR"
  },
  {
    "codigo":59645001,
    "descripcion":"BULIMIA NERVIOSA, TIPO NO PURGATIVO"
  },
  {
    "codigo":26877003,
    "descripcion":"ALTA AFINIDAD INMUNOLÓGICA"
  },
  {
    "codigo":289021006,
    "descripcion":"NO EMPLEA LAS MANOS PARA ALIMENTARSE"
  },
  {
    "codigo":92413008,
    "descripcion":"NEOPLASIA BENIGNA DE LA GLÁNDULA SUBLINGUAL"
  },
  {
    "codigo":715005009,
    "descripcion":"CAPAZ DE CABALGAR"
  },
  {
    "codigo":90578002,
    "descripcion":"CONFIGURACIÓN MOLECULAR"
  },
  {
    "codigo":1237458000,
    "descripcion":"METÁSTASIS DE CARCINOMA DE COLON TRANSVERSO"
  },
  {
    "codigo":254418005,
    "descripcion":"CARCINOMA IN SITU DEL FRENILLO LINGUAL"
  },
  {
    "codigo":188882008,
    "descripcion":"NEOPLASIA BENIGNA DE CARTÍLAGO CUNEIFORME DE LA LARINGE"
  },
  {
    "codigo":88743001,
    "descripcion":"LUXACIÓN EXPUESTA DE VÉRTEBRA"
  },
  {
    "codigo":449191001,
    "descripcion":"LOGORREA"
  },
  {
    "codigo":1268391003,
    "descripcion":"CARCINOMA PRIMARIO INDIFERENCIADO DE HÍGADO Y VÍA BILIAR INTRAHEPÁTICA"
  },
  {
    "codigo":185212007,
    "descripcion":"ATENDIDO EN SALA DE HOSPITAL"
  },
  {
    "codigo":283516008,
    "descripcion":"HERIDA PUNZANTE DE MUÑECA"
  },
  {
    "codigo":707665002,
    "descripcion":"ANOMALÍA DE ÁRBOL ARTERIAL PULMONAR COMO COMPLICACIÓN DE PROCEDIMIENTO"
  },
  {
    "codigo":16059391000119101,
    "descripcion":"TUMEFACCIÓN LOCALIZADA BILATERAL DE PULGAR"
  },
  {
    "codigo":412753004,
    "descripcion":"ROTULADO DE MEDICAMENTO EN LETRAS GRANDES REQUERIDO"
  },
  {
    "codigo":445521005,
    "descripcion":"TESTIGO DE EPISODIO DE VIOLENCIA DOMÉSTICA EN ADULTO"
  },
  {
    "codigo":1363025005,
    "descripcion":"INFECCIÓN DE MARCAPASOS IMPLANTABLE PARA TERAPIA DE RESINCRONIZACIÓN CARDÍACA"
  },
  {
    "codigo":52305004,
    "descripcion":"GASTRITIS MEDICAMENTOSA"
  },
  {
    "codigo":871505008,
    "descripcion":"ALERGIA A AMPICILINA Y\/O FLUCLOXACILINA"
  },
  {
    "codigo":684901000119107,
    "descripcion":"GLIOBLASTOMA MULTIFORME PRIMARIO DE CEREBRO"
  },
  {
    "codigo":247078006,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAVIDAD VÍTREA"
  },
  {
    "codigo":212475003,
    "descripcion":"LESIÓN DE MÚSCULO Y TENDÓN A NIVEL DE TOBILLO Y PIE"
  },
  {
    "codigo":409083006,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD DE ATENCIÓN"
  },
  {
    "codigo":14032000,
    "descripcion":"INFECCIÓN CAUSADA POR ARMILLIFER ARMILLATUS"
  },
  {
    "codigo":472784000,
    "descripcion":"DISFUNCIÓN DEL VENTRÍCULO DERECHO DEBIDA A TRASTORNO DEL VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":15977471000119105,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE AMBAS ÓRBITAS"
  },
  {
    "codigo":46800005,
    "descripcion":"COLOR NORMAL DE LA ORINA"
  },
  {
    "codigo":866000008,
    "descripcion":"ABSCESO DE PIEL Y\/O TEJIDO SUBCUTÁNEO CAUSADO POR PELO ENCARNADO"
  },
  {
    "codigo":307109002,
    "descripcion":"SIN AUTOMÓVIL"
  },
  {
    "codigo":733093004,
    "descripcion":"SÍNDROME DE BANKI"
  },
  {
    "codigo":896933005,
    "descripcion":"FORMA DE BALA ANORMAL CONGÉNITA DE FALANGE DE SEGUNDO DEDO DE PIE"
  },
  {
    "codigo":77733006,
    "descripcion":"QUERATINIZACIÓN ANORMAL DEL FOLÍCULO PILOSO"
  },
  {
    "codigo":700325006,
    "descripcion":"ARTROSIS PRIMARIA DE ARTICULACIÓN ASTRAGALOESCAFOIDEA"
  },
  {
    "codigo":208805009,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA NO EXPUESTA DE LA ARTICULACIÓN RADIOCUBITAL SUPERIOR"
  },
  {
    "codigo":239738002,
    "descripcion":"CONTRACTURA DE LA CADERA"
  },
  {
    "codigo":403578003,
    "descripcion":"AMPOLLAS FALSAS"
  },
  {
    "codigo":10362008,
    "descripcion":"BAZO ACCESORIO"
  },
  {
    "codigo":237903000,
    "descripcion":"HIPOFOSFATEMIA NUTRICIONAL"
  },
  {
    "codigo":205135003,
    "descripcion":"POLIDACTILIA RADIAL"
  },
  {
    "codigo":301604002,
    "descripcion":"DIFICULTAD PARA SUBIR O BAJAR ESCALERAS SENTADO"
  },
  {
    "codigo":15705241000119106,
    "descripcion":"CONDROCALCINOSIS DE AMBOS HOMBROS"
  },
  {
    "codigo":299769000,
    "descripcion":"REACCIÓN DE COLOCACIÓN: AUSENTE"
  },
  {
    "codigo":203300009,
    "descripcion":"OSTEOMIELITIS SUBAGUDA DEL CÓCCIX"
  },
  {
    "codigo":234233007,
    "descripcion":"DESPLAZAMIENTO DE LA DERIVACIÓN DEL ELECTRODO DEL DESFRIBILADOR CARDÍACO IMPLANTADO"
  },
  {
    "codigo":365305008,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA CUIDAR LA ROPA"
  },
  {
    "codigo":363470000,
    "descripcion":"NEOPLASIA MALIGNA DEL LÓBULO OCCIPITAL"
  },
  {
    "codigo":723918000,
    "descripcion":"PESO CORPORAL PELIGROSAMENTE BAJO CONCOMITANTE CON ANOREXIA NERVIOSA DE TIPO INGESTA COMPULSIVA Y PURGAS Y DEBIDO A ELLA"
  },
  {
    "codigo":232398002,
    "descripcion":"OSTEOMA DE SENO PARANASAL"
  },
  {
    "codigo":35790004,
    "descripcion":"LESIÓN TRAUMÁTICA DE RETROPERITONEO SIN HERIDA ABIERTA HACIA CAVIDAD ABDOMINAL"
  },
  {
    "codigo":10953881000119109,
    "descripcion":"HERIDA ABIERTA DE MANO IZQUIERDA DEBIDA A MORDEDURA DE GATO"
  },
  {
    "codigo":166862006,
    "descripcion":"FENILALANINA SÉRICA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":296099002,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE KETAZOLAM"
  },
  {
    "codigo":230563005,
    "descripcion":"POLINEUROPATÍA SIFILÍTICA CONGÉNITA TARDÍA"
  },
  {
    "codigo":165027008,
    "descripcion":"PRUEBA DE VOLUMEN PULMONAR NORMAL"
  },
  {
    "codigo":294264006,
    "descripcion":"ALERGIA A IPECACUANA"
  },
  {
    "codigo":95821001,
    "descripcion":"PÉRDIDA DE LA AUDICIÓN, NEONATAL"
  },
  {
    "codigo":63053003,
    "descripcion":"QUEMADURA PROFUNDA DE TERCER GRADO DE LA RODILLA"
  },
  {
    "codigo":1144397003,
    "descripcion":"HIPOPLASIA CONGÉNITA DE RETINA"
  },
  {
    "codigo":1177165005,
    "descripcion":"ENFERMEDAD DE CHARCOT-MARIE-TOOTH TIPO 1 ASOCIADA A PMP2"
  },
  {
    "codigo":126754006,
    "descripcion":"NEOPLASIA DE VASO SANGUÍNEO DEL TRONCO"
  },
  {
    "codigo":290594007,
    "descripcion":"INTOXICACIÓN POR DERIVADOS DE MOSTAZAS NITROGENADAS"
  },
  {
    "codigo":93986008,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LAS VÍAS RESPIRATORIAS"
  },
  {
    "codigo":716578009,
    "descripcion":"ALTERACIÓN DEL DESARROLLO DE LA COMPRENSIÓN DEL LENGUAJE"
  },
  {
    "codigo":92151003,
    "descripcion":"NEOPLASIA BENIGNA DEL INTESTINO"
  },
  {
    "codigo":288759004,
    "descripcion":"NO COMUNICA PENSAMIENTOS"
  },
  {
    "codigo":333261000119104,
    "descripcion":"SINEQUIAS PERIFÉRICAS ANTERIORES DE OJO DERECHO"
  },
  {
    "codigo":286924000,
    "descripcion":"TRASTORNOS DE CALCIO Y FÓSFORO"
  },
  {
    "codigo":254156001,
    "descripcion":"ERITRODERMIA ICTIOSIFORME CONGÉNITA"
  },
  {
    "codigo":190455009,
    "descripcion":"HIPOPARATIROIDISMO POSQUIRÚRGICO"
  },
  {
    "codigo":1237196008,
    "descripcion":"DEPENDENCIA DE ERGOTAMINA"
  },
  {
    "codigo":417996009,
    "descripcion":"INSUFICIENCIA CARDÍACA SISTÓLICA"
  },
  {
    "codigo":90316008,
    "descripcion":"LESIÓN TRAUMÁTICA POR ABRASIÓN RITUAL DE DIENTE"
  },
  {
    "codigo":448929003,
    "descripcion":"MASA DE REGIÓN RETROAURICULAR"
  },
  {
    "codigo":55713007,
    "descripcion":"OPACIDAD PERIFÉRICA DE LA CÓRNEA"
  },
  {
    "codigo":447094002,
    "descripcion":"QUEMADURA DE CÓRNEA POR SUSTANCIA QUÍMICA ALCALINA"
  },
  {
    "codigo":840310005,
    "descripcion":"OCLUSIÓN DE PORCIÓN PROXIMAL DE RAMA DESCENDENTE ANTERIOR DE ARTERIA CORONARIA IZQUIERDA"
  },
  {
    "codigo":119414006,
    "descripcion":"HALLAZGO EN LA COLUMNA VERTEBRAL"
  },
  {
    "codigo":283254007,
    "descripcion":"VIDRIO EN PULGAR"
  },
  {
    "codigo":84811001,
    "descripcion":"INTOXICACIÓN CAUSADA POR CLORAMBUCILO"
  },
  {
    "codigo":707403002,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE PULMÓN FETAL"
  },
  {
    "codigo":1297227002,
    "descripcion":"CIERRE DE ÁNGULO AGUDO DE AMBOS OJOS CAUSADO POR FÁRMACO"
  },
  {
    "codigo":314187004,
    "descripcion":"OCLUSIÓN DE ARTERIA ILÍACA"
  },
  {
    "codigo":248651005,
    "descripcion":"FRECUENCIA CARDÍACA IRREGULAR INTERMITENTE"
  },
  {
    "codigo":1231691008,
    "descripcion":"HEMORRAGIA VÍTREA DEBIDA A RETINOPATÍA DIABÉTICA PROLIFERATIVA"
  },
  {
    "codigo":17440005,
    "descripcion":"ESPASMO ANAL"
  },
  {
    "codigo":246816005,
    "descripcion":"PÉRDIDA DE TEJIDO PALPEBRAL"
  },
  {
    "codigo":142951000119106,
    "descripcion":"MIOCARDITIS CAUSADA POR VIRUS INFLUENZA A SUBTIPO H1N1"
  },
  {
    "codigo":212213000,
    "descripcion":"LESIÓN DE LA RAÍZ DEL NERVIO DORSAL - D8"
  },
  {
    "codigo":10929921000119100,
    "descripcion":"FRACTURA NO EXPUESTA DE METÁFISIS DE CUARTO METATARSIANO DE PIE IZQUIERDO"
  },
  {
    "codigo":408821002,
    "descripcion":"VIVE CON SU PAREJA"
  },
  {
    "codigo":81141003,
    "descripcion":"FUNCIÓN RENAL NORMAL"
  },
  {
    "codigo":310517007,
    "descripcion":"BAJO ATENCIÓN DE MÉDICO ONCÓLOGO"
  },
  {
    "codigo":1258954001,
    "descripcion":"DOLOR RADICULAR LUMBAR"
  },
  {
    "codigo":112074005,
    "descripcion":"ESTADO DE LA MEMBRANA FETAL"
  },
  {
    "codigo":863903001,
    "descripcion":"ALERGIA A VACUNA"
  },
  {
    "codigo":306847001,
    "descripcion":"OCLUSIÓN DE INJERTO-PUENTE ARTERIAL"
  },
  {
    "codigo":208543003,
    "descripcion":"FRACTURA EXPUESTA SUBCAPITAL DE FÉMUR PROXIMAL GRADO III DE GARDEN"
  },
  {
    "codigo":77471004,
    "descripcion":"SINOTIA"
  },
  {
    "codigo":700063005,
    "descripcion":"MEGALENCEFALIA MALFORMACIÓN CAPILAR"
  },
  {
    "codigo":110239007,
    "descripcion":"CONTUSIÓN DE LA APÓFISIS CORONOIDES DE LA MANDÍBULA"
  },
  {
    "codigo":42868002,
    "descripcion":"ESQUIZOFRENIA CATATÓNICA SUBCRÓNICA"
  },
  {
    "codigo":296755004,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE DOXICICLINA"
  },
  {
    "codigo":403316009,
    "descripcion":"HIPERTRICOSIS EN LA PORFIRIA"
  },
  {
    "codigo":11804571000119101,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA DISTAL DE DEDO ÍNDICE DERECHO"
  },
  {
    "codigo":16910081000119108,
    "descripcion":"LAGOFTALMÍA DE PÁRPADOS SUPERIOR E INFERIOR DERECHOS"
  },
  {
    "codigo":237641009,
    "descripcion":"HIPOGLUCEMIA INDUCIDA POR ALCOHOL"
  },
  {
    "codigo":170270002,
    "descripcion":"EXAMEN PEDIÁTRICO ANORMAL A LOS 6\/12 MESES - EN TRATAMIENTO"
  },
  {
    "codigo":432414001,
    "descripcion":"CONSTIPACIÓN ATÓNICA"
  },
  {
    "codigo":301342004,
    "descripcion":"PROBLEMA CON EL OLOR CORPORAL"
  },
  {
    "codigo":235806008,
    "descripcion":"COMPRESIÓN ARTERIOMESENTÉRICA DEL ÁNGULO YEYUNODUODENAL"
  },
  {
    "codigo":399646009,
    "descripcion":"TUMOR QUE INVADE COROIDES"
  },
  {
    "codigo":233971003,
    "descripcion":"ESTENOSIS DE ARTERIA TRASPLANTADA"
  },
  {
    "codigo":365043004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA COMENZAR A HABLAR"
  },
  {
    "codigo":102899003,
    "descripcion":"RELACIÓN EMOCIONAL ABUSIVA"
  },
  {
    "codigo":299507003,
    "descripcion":"SIN AMPLITUD PASIVA DE SUPINACIÓN MEDIOTARSIANA"
  },
  {
    "codigo":428744000,
    "descripcion":"ANZUELO EN REGIÓN ANTERIOR DEL CUELLO"
  },
  {
    "codigo":35528000,
    "descripcion":"ACIDOSIS METABÓLICA CAUSADA POR SALICILATO"
  },
  {
    "codigo":232136008,
    "descripcion":"ASTIGMATISMO REGULAR - CORNEAL"
  },
  {
    "codigo":295837005,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE AMITRIPTILINA"
  },
  {
    "codigo":230301006,
    "descripcion":"FORMA RÍGIDA ACINÉTICA DE LA ENFERMEDAD DE HUNTINGTON"
  },
  {
    "codigo":721821006,
    "descripcion":"ENCEFALITIS CAUSADA POR SCHISTOSOMA JAPONICUM"
  },
  {
    "codigo":263069008,
    "descripcion":"FRACTURA-LUXACIÓN DE COLUMNA VERTEBRAL CERVICAL"
  },
  {
    "codigo":294002003,
    "descripcion":"ALERGIA A AMLODIPINO"
  },
  {
    "codigo":161095000,
    "descripcion":"VACACIONES DE SAFARI"
  },
  {
    "codigo":95559000,
    "descripcion":"COLECISTITIS LITIÁSICA CRÓNICA"
  },
  {
    "codigo":30023002,
    "descripcion":"HIDRANENCEFALIA"
  },
  {
    "codigo":11860021000119104,
    "descripcion":"ESGUINCE DE LIGAMENTO CRUZADO POSTERIOR DE RODILLA DERECHA"
  },
  {
    "codigo":128327004,
    "descripcion":"ANOMALÍA CONGÉNITA DE LOS ANEXOS OCULARES"
  },
  {
    "codigo":292167007,
    "descripcion":"REACCIÓN ADVERSA AL TIOPENTAL"
  },
  {
    "codigo":28188001,
    "descripcion":"LESIÓN TRAUMÁTICA CEREBRAL CON HERIDA INTRACRANEAL ABIERTA"
  },
  {
    "codigo":93724001,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE HUESO DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":126492006,
    "descripcion":"NEOPLASIA DE LA PIEL DE LA CARA"
  },
  {
    "codigo":1142300007,
    "descripcion":"LONGITUD DE PELO DE CEJA AUMENTADA"
  },
  {
    "codigo":11833551000119100,
    "descripcion":"ESGUINCE DE LIGAMENTO CALCANEOPERONEO DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":59121004,
    "descripcion":"INFECCIÓN CAUSADA POR LEISHMANIA AETHIOPICA"
  },
  {
    "codigo":91889007,
    "descripcion":"AUSENCIA CONGÉNITA DE HUESO INTERPARIETAL"
  },
  {
    "codigo":90054000,
    "descripcion":"HIPERINSULINISMO IATROGÉNICO"
  },
  {
    "codigo":384966001,
    "descripcion":"PLEURA VISCERAL AFECTADA POR PROPAGACIÓN DIRECTA DE NEOPLASIA MALIGNA"
  },
  {
    "codigo":124657009,
    "descripcion":"DEFICIENCIA DE ISOMERASA"
  },
  {
    "codigo":286662000,
    "descripcion":"EXPRESIÓN - MECANISMO DE DEFENSA PSICOLÓGICA"
  },
  {
    "codigo":16666831000119102,
    "descripcion":"FRACTURA EXPUESTA DE CUERPO DE MITAD IZQUIERDA DE LA MANDÍBULA"
  },
  {
    "codigo":253894005,
    "descripcion":"URETEROCELE ECTÓPICO"
  },
  {
    "codigo":712646007,
    "descripcion":"GANGRENA DE COLOSTOMÍA"
  },
  {
    "codigo":88219000,
    "descripcion":"SÍNDROME DEL PLEXO CELÍACO"
  },
  {
    "codigo":57286009,
    "descripcion":"RETRAIMIENTO PUPILAR"
  },
  {
    "codigo":448667002,
    "descripcion":"HEMANGIOMA DE LENGUA"
  },
  {
    "codigo":1003888003,
    "descripcion":"DUPLICACIÓN DE PORCIÓN PROXIMAL DEL BRAZO CORTO DEL CROMOSOMA 6"
  },
  {
    "codigo":1075561000119100,
    "descripcion":"INESTABILIDAD DE ARTICULACIÓN FEMORORROTULIANA DERECHA"
  },
  {
    "codigo":53616007,
    "descripcion":"NECROSIS PANCREÁTICA SUBAGUDA"
  },
  {
    "codigo":444997000,
    "descripcion":"LINFOCELE INFECTADO"
  },
  {
    "codigo":282992008,
    "descripcion":"GIRA LA CABEZA"
  },
  {
    "codigo":20848007,
    "descripcion":"INFESTACIÓN CAUSADA POR PEDICULUS"
  },
  {
    "codigo":1264197004,
    "descripcion":"TRASTORNO NEONATAL PRECOZ CAUSADO POR ANESTESIA GENERAL MATERNA TRANSMITIDA POR VÍA PLACENTARIA"
  },
  {
    "codigo":1231429007,
    "descripcion":"BACILOS GRAMPOSITIVOS CON FORMA DE MICROESFERA PRESENTES"
  },
  {
    "codigo":248389008,
    "descripcion":"ESPACIO ENTRE SUTURAS CRANEALES"
  },
  {
    "codigo":1196826007,
    "descripcion":"LEIOMIOMA DE INTESTINO GRUESO"
  },
  {
    "codigo":310255003,
    "descripcion":"ANTICUERPO CONTRA CITOPLASMA DE NEUTRÓFILOS NO DETECTADO"
  },
  {
    "codigo":111812000,
    "descripcion":"INFECCIÓN POR MICOBACTERIAS ATÍPICAS"
  },
  {
    "codigo":79044002,
    "descripcion":"INTOXICACIÓN POR HEXADIMETRINA"
  },
  {
    "codigo":46276006,
    "descripcion":"HEMORROIDES PROLAPSADAS"
  },
  {
    "codigo":275652006,
    "descripcion":"PACIENTE REGISTRADO - FP13"
  },
  {
    "codigo":210116008,
    "descripcion":"LESIÓN TRAUMÁTICA DE DUODENO CON HERIDA ABIERTA HACIA CAVIDAD ABDOMINAL"
  },
  {
    "codigo":372121004,
    "descripcion":"CARCINOMA DE COSTILLAS, ESTERNÓN Y CLAVÍCULA"
  },
  {
    "codigo":208281007,
    "descripcion":"FRACTURA EXPUESTA DE PORCIÓN DISTAL DE HÚMERO, TRÓCLEA"
  },
  {
    "codigo":239214000,
    "descripcion":"FUNCIONAMIENTO DEFECTUOSO DE VÁLVULA DE EXPANSOR TISULAR"
  },
  {
    "codigo":403054001,
    "descripcion":"TIÑA DEL PIE CAUSADA POR TRICHOPHYTON MENTAGROPHYTES VARIEDAD INTERDIGITALE"
  },
  {
    "codigo":109977009,
    "descripcion":"LINFOMA PERIFÉRICO DE LINFOCITOS T (CLÍNICO)"
  },
  {
    "codigo":15630851000119103,
    "descripcion":"UVEÍTIS BILATERAL"
  },
  {
    "codigo":271982007,
    "descripcion":"INTOXICACIÓN INTENCIONAL AUTOINFLIGIDA"
  },
  {
    "codigo":40771007,
    "descripcion":"RESPUESTA A LA INMUNIZACIÓN PASIVA"
  },
  {
    "codigo":38936003,
    "descripcion":"PRESIÓN ARTERIAL ANORMAL"
  },
  {
    "codigo":1251352004,
    "descripcion":"FRAGILIDAD DE UÑA CAUSADA POR FÁRMACO"
  },
  {
    "codigo":202776005,
    "descripcion":"SÍNDROME DE RAÍZ CERVICAL"
  },
  {
    "codigo":367261000119100,
    "descripcion":"HIPEROSMOLARIDAD DEBIDA A DIABETES MELLITUS INDUCIDA POR FÁRMACO"
  },
  {
    "codigo":397549002,
    "descripcion":"DISFUNCIÓN DE GLÁNDULA DE MEIBOMIO"
  },
  {
    "codigo":233709006,
    "descripcion":"EDEMA PULMONAR TÓXICO"
  },
  {
    "codigo":364781007,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA BEBER CON SORBETE"
  },
  {
    "codigo":200941006,
    "descripcion":"LUPUS ERITEMATOSO HIPERTRÓFICO"
  },
  {
    "codigo":35266001,
    "descripcion":"DUPLICACIÓN CONGÉNITA DE APÉNDICE ILEOCECAL"
  },
  {
    "codigo":788930004,
    "descripcion":"CONTUSIÓN FOCAL DE ENCÉFALO"
  },
  {
    "codigo":231874004,
    "descripcion":"ESCLEROTENONITIS"
  },
  {
    "codigo":295575000,
    "descripcion":"SOBREDOSIS DE OXIBUPROCAÍNA"
  },
  {
    "codigo":395714008,
    "descripcion":"MÁRGENES DE RESECCIÓN QUIRÚRGICA PROFUNDOS COMPROMETIDOS POR NEOPLASIA MALIGNA, MULTIFOCAL"
  },
  {
    "codigo":721559007,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE COLÉDOCO"
  },
  {
    "codigo":197271008,
    "descripcion":"HEPATITIS AGUDA - NO INFECCIOSA"
  },
  {
    "codigo":293740001,
    "descripcion":"ALERGIA A AGENTE ALQUILANTE"
  },
  {
    "codigo":129900004,
    "descripcion":"TRASTORNO DEL VOLUMEN MINUTO"
  },
  {
    "codigo":162668006,
    "descripcion":"CONDICIÓN DEL PACIENTE, INESTABLE"
  },
  {
    "codigo":719724007,
    "descripcion":"ÁCIDO DESOXIRRIBONUCLEICO DE CAMPYLOBACTER NO DETECTADO"
  },
  {
    "codigo":717889000,
    "descripcion":"HIPERGASTRINEMIA CAUSADA POR FÁRMACO"
  },
  {
    "codigo":291905000,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR FENINDIONA"
  },
  {
    "codigo":422977003,
    "descripcion":"ANOMALÍA CONGÉNITA DE DIENTE"
  },
  {
    "codigo":128065004,
    "descripcion":"DERIVACIÓN PORTOSISTÉMICA PARCIAL CONGÉNITA"
  },
  {
    "codigo":95297004,
    "descripcion":"LÓBULO HEPÁTICO SUPERNUMERARIO"
  },
  {
    "codigo":290070001,
    "descripcion":"MAMA ERITEMATOSA"
  },
  {
    "codigo":35781000175101,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN DE TOBILLO ESTADIO I"
  },
  {
    "codigo":286400000,
    "descripcion":"CAPAZ DE HABLAR CON FLUIDEZ"
  },
  {
    "codigo":89792004,
    "descripcion":"HIPERTROFIA VENTRICULAR DERECHA"
  },
  {
    "codigo":15987511000119106,
    "descripcion":"ANOMALÍA ESTRUCTURAL CONGÉNITA DE CÓRNEA IZQUIERDA"
  },
  {
    "codigo":384704005,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA AFECTADO POR CARCINOMA IN SITU DUCTAL, EXTENSO"
  },
  {
    "codigo":253632008,
    "descripcion":"ANOMALÍA EN EL ORIGEN DE LA ARTERIA PULMONAR DERECHA"
  },
  {
    "codigo":417472009,
    "descripcion":"MÉDICO ELEGIBLE PARA CERTIFICACIÓN POR LA AUTORIDAD DE SU ESPECIALIDAD"
  },
  {
    "codigo":340791000119107,
    "descripcion":"QUISTE EXUDATIVO DE PARS PLANA DE CUERPO CILIAR DE OJO IZQUIERDO"
  },
  {
    "codigo":22421007,
    "descripcion":"AUSENCIA CONGÉNITA DE VEJIGA URINARIA"
  },
  {
    "codigo":249962002,
    "descripcion":"MOVIMIENTO DESIGUAL"
  },
  {
    "codigo":315498003,
    "descripcion":"NACIDO EN PANAMÁ"
  },
  {
    "codigo":1263935000,
    "descripcion":"RESISTENCIA FARMACOLÓGICA A MEDICACIÓN ANTIEPILÉPTICA"
  },
  {
    "codigo":51519001,
    "descripcion":"INSERCIÓN MARGINAL DEL CORDÓN UMBILICAL"
  },
  {
    "codigo":444735002,
    "descripcion":"INESTABILIDAD DE PISO PÉLVICO"
  },
  {
    "codigo":706879004,
    "descripcion":"LESIÓN FÍSICA DEBIDA A MALTRATO"
  },
  {
    "codigo":248127004,
    "descripcion":"RECHAZA LOS SÓLIDOS"
  },
  {
    "codigo":1296703005,
    "descripcion":"HIPERTENSIÓN OCULAR DE OJO DERECHO DEBIDA A HEMORRAGIA INTRAOCULAR"
  },
  {
    "codigo":1268531004,
    "descripcion":"SARCOMA ALVEOLAR DE PARTES BLANDAS PRIMARIO"
  },
  {
    "codigo":705044006,
    "descripcion":"DIFICULTAD DEL CUIDADOR PARA REALIZAR SU TAREA"
  },
  {
    "codigo":703209002,
    "descripcion":"INFARTO DE PARED INFERIOR DE MIOCARDIO CON ELEVACIÓN ULTERIOR DE SEGMENTO ST"
  },
  {
    "codigo":277225007,
    "descripcion":"MUCOSA NASAL COSTROSA"
  },
  {
    "codigo":11783121000119108,
    "descripcion":"LUXACIÓN TRAUMÁTICA POSTERIOR NO EXPUESTA DE CADERA IZQUIERDA"
  },
  {
    "codigo":111550004,
    "descripcion":"INSUFICIENCIA OVÁRICA"
  },
  {
    "codigo":275390005,
    "descripcion":"EFECTO TÓXICO DE PLANTA"
  },
  {
    "codigo":46014006,
    "descripcion":"CALLO DE DEDO DE PIE"
  },
  {
    "codigo":1356734004,
    "descripcion":"NEOPLASIA EMBRIONARIA CON ROSETAS DE CAPAS MÚLTIPLES"
  },
  {
    "codigo":11411001,
    "descripcion":"EVALUACIÓN DE DISCAPACIDAD: 20%"
  },
  {
    "codigo":109715002,
    "descripcion":"OSTEORRADIONECROSIS MAXILAR"
  },
  {
    "codigo":699539004,
    "descripcion":"QUISTE ÓSEO YUXTARTICULAR"
  },
  {
    "codigo":39681000087100,
    "descripcion":"DOLOR CRÓNICO POSTERIOR A COLECISTECTOMÍA"
  },
  {
    "codigo":57601000087103,
    "descripcion":"STREPTOCOCCUS EQUI SUBESPECIE RUMINATORUM O STREPTOCOCCUS EQUI SUBESPECIE ZOOEPIDEMICUS"
  },
  {
    "codigo":371859008,
    "descripcion":"HEMODINAMIA DEL HEMICARDIO DERECHO, NORMAL"
  },
  {
    "codigo":240787008,
    "descripcion":"BASIDIOBOLOMICOSIS DISEMINADA"
  },
  {
    "codigo":42241000087103,
    "descripcion":"HERIDA PENETRANTE DE OJO DERECHO PROPIAMENTE DICHO DEBIDA A CUERPO EXTRAÑO"
  },
  {
    "codigo":402792003,
    "descripcion":"INMUNODEFICIENCIA DE LINFOCITOS T"
  },
  {
    "codigo":238952003,
    "descripcion":"XANTOMA ERUPTIVO"
  },
  {
    "codigo":47361000087105,
    "descripcion":"DISTENSIÓN DE MÚSCULO TRÍCEPS BRAQUIAL IZQUIERDO"
  },
  {
    "codigo":1156456000,
    "descripcion":"ASTROCITOMA PILOMIXOIDE DE ENCÉFALO"
  },
  {
    "codigo":271720007,
    "descripcion":"PRESIÓN INTRACRANEAL NORMAL"
  },
  {
    "codigo":44801000087106,
    "descripcion":"OCLUSIÓN DE PORCIÓN PROXIMAL DE RAMA CIRCUNFLEJA DE ARTERIA CORONARIA IZQUIERDA"
  },
  {
    "codigo":237117005,
    "descripcion":"ENDOMETRIOSIS FUERA DE LA PELVIS"
  },
  {
    "codigo":400957009,
    "descripcion":"EPICANTO PALPEBRAL"
  },
  {
    "codigo":300818001,
    "descripcion":"DIFICULTAD PARA CUIDAR UNA MASCOTA"
  },
  {
    "codigo":366354008,
    "descripcion":"ÍNDICE METABÓLICO BASAL - HALLAZGO"
  },
  {
    "codigo":71442009,
    "descripcion":"POSICIÓN DE COITO"
  },
  {
    "codigo":167911000,
    "descripcion":"EXAMEN DE MÉDULA ÓSEA, ANORMAL"
  },
  {
    "codigo":298983001,
    "descripcion":"AMPLITUD DE ADUCCIÓN ACTIVA DE ARTICULACIÓN DE MUÑECA, AUMENTADA"
  },
  {
    "codigo":200679003,
    "descripcion":"CELULITIS Y ABSCESO DE MUSLO"
  },
  {
    "codigo":169746009,
    "descripcion":"LACTANCIA MATERNA SUSPENDIDA"
  },
  {
    "codigo":428220001,
    "descripcion":"DESGARRO TRAUMÁTICO DE PIEL"
  },
  {
    "codigo":724967009,
    "descripcion":"DISTENSIÓN DE TENDÓN FLEXOR A LA ALTURA DEL ANTEBRAZO"
  },
  {
    "codigo":723132004,
    "descripcion":"NEUROPATÍA ÓPTICA ISQUÉMICA NO ARTERÍTICA SECUNDARIA PERIOPERATORIA"
  },
  {
    "codigo":297148004,
    "descripcion":"TROMBOSIS DE ARTERIA CELÍACA"
  },
  {
    "codigo":343301000119106,
    "descripcion":"SIMBLÉFARON DE AMBOS OJOS"
  },
  {
    "codigo":67772009,
    "descripcion":"ALOPECIA POR QUEMADURAS TÉRMICAS"
  },
  {
    "codigo":65937002,
    "descripcion":"HIMEN IMPERFORADO"
  },
  {
    "codigo":295313001,
    "descripcion":"SOBREDOSIS DE AGENTE PARA USO DIAGNÓSTICO"
  },
  {
    "codigo":33169001,
    "descripcion":"DEFICIENCIA DE FACTOR XI, TIPO II"
  },
  {
    "codigo":1080581000119107,
    "descripcion":"LEIOMIOSARCOMA PRIMARIO DE REGIÓN DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":262545008,
    "descripcion":"HERIDA ABIERTA DE UÑA"
  },
  {
    "codigo":721297008,
    "descripcion":"SÍNDROME DE GALLOWAY MOWAT"
  },
  {
    "codigo":129638002,
    "descripcion":"ANEMIA HEMOLÍTICA CAUSADA POR ADMINISTRACIÓN DE OXÍGENO HIPERBÁRICO"
  },
  {
    "codigo":1145446000,
    "descripcion":"HIPOPLASIA CONGÉNITA DE VÉRTEBRA"
  },
  {
    "codigo":459153009,
    "descripcion":"ENDOCARDITIS INFECCIOSA DE VÁLVULA PULMONAR"
  },
  {
    "codigo":725043006,
    "descripcion":"DISTROFIA MUSCULAR DE LAS CINTURAS DE LAS EXTREMIDADES TIPO 2O AUTOSÓMICA RECESIVA"
  },
  {
    "codigo":64102008,
    "descripcion":"GOMA SIFILÍTICO"
  },
  {
    "codigo":609590581000119102,
    "descripcion":"ANEURISMA ROTO DE AORTA TORÁCICA DESCENDENTE"
  },
  {
    "codigo":291643000,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR SULFAFURAZOL"
  },
  {
    "codigo":95035003,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA REGIÓN SACROCOCCÍGEA"
  },
  {
    "codigo":226107002,
    "descripcion":"DIETA CON ALTO CONTENIDO EN ACEITE DE PESCADO"
  },
  {
    "codigo":289808003,
    "descripcion":"MOCO CERVICAL FINO"
  },
  {
    "codigo":93200005,
    "descripcion":"MASTOCITOMA MALIGNO DE GANGLIOS LINFÁTICOS INTRABDOMINALES"
  },
  {
    "codigo":191504009,
    "descripcion":"ESTADO CONFUSIONAL AGUDO, DE ORIGEN METABÓLICO"
  },
  {
    "codigo":15691321000119101,
    "descripcion":"ARTRITIS REUMATOIDEA SERONEGATIVA BILATERAL DE MUÑECA"
  },
  {
    "codigo":419045004,
    "descripcion":"PÉRDIDA DE LA CONSCIENCIA"
  },
  {
    "codigo":25829005,
    "descripcion":"BIORRITMO NORMAL"
  },
  {
    "codigo":124133008,
    "descripcion":"DEFICIENCIA DE GALACTOSA DESHIDROGENASA"
  },
  {
    "codigo":187834000,
    "descripcion":"NEOPLASIA MALIGNA DE TROMPA FARINGOTIMPÁNICA"
  },
  {
    "codigo":16045471000119109,
    "descripcion":"ALTERACIÓN DE AMBAS ARTICULACIONES DE TOBILLO"
  },
  {
    "codigo":253370004,
    "descripcion":"DEFECTO DE SENO VENOSO CON CABALGAMIENTO DE VENA CAVA INFERIOR"
  },
  {
    "codigo":286138006,
    "descripcion":"NO LIMPIA LOS ELECTRODOMÉSTICOS"
  },
  {
    "codigo":87695000,
    "descripcion":"BRONQUIOLITIS NECROSANTE"
  },
  {
    "codigo":284303002,
    "descripcion":"NO REALIZA LA PRENSIÓN CON OPOSICIÓN DEL PULGAR"
  },
  {
    "codigo":249700004,
    "descripcion":"ANGULACIÓN DE COSTILLA"
  },
  {
    "codigo":1003364006,
    "descripcion":"DELECIÓN DISTAL DEL CROMOSOMA 13"
  },
  {
    "codigo":345811000119101,
    "descripcion":"DESPRENDIMIENTO HEMORRÁGICO DE EPITELIO PIGMENTARIO DE LA RETINA DE AMBOS OJOS"
  },
  {
    "codigo":247865007,
    "descripcion":"MIEDO A LOS HOSPITALES"
  },
  {
    "codigo":82190001,
    "descripcion":"TROMBOCITOPENIA POR PRODUCCIÓN DEFECTUOSA DE PLAQUETAS"
  },
  {
    "codigo":213262007,
    "descripcion":"FORMACIÓN DE HEMATOMA EN EL POSOPERATORIO"
  },
  {
    "codigo":49422009,
    "descripcion":"HEMORRAGIA CORTICAL"
  },
  {
    "codigo":307896000,
    "descripcion":"ESTADO DE LA TARJETA DE COOPERACIÓN OBSTÉTRICA"
  },
  {
    "codigo":111288001,
    "descripcion":"ALETEO VENTRICULAR"
  },
  {
    "codigo":209592002,
    "descripcion":"DESGARRO COMPLETO DE LIGAMENTO RADIOCARPIANO DORSAL"
  },
  {
    "codigo":440921000124100,
    "descripcion":"INGESTA EXCESIVA DE SODIO"
  },
  {
    "codigo":1290936006,
    "descripcion":"RADIOGRAFÍA PELVIMÉTRICA NORMAL"
  },
  {
    "codigo":240525000,
    "descripcion":"FIEBRE HEMORRÁGICA FILOVIRAL"
  },
  {
    "codigo":207757002,
    "descripcion":"FRACTURA NO EXPUESTA DE LA APÓFISIS CORONOIDES DE LA MANDÍBULA"
  },
  {
    "codigo":601000124107,
    "descripcion":"CONTROL INADECUADO DE ADMINISTRACIÓN DE DOSIS DE DIÁLISIS PERITONEAL"
  },
  {
    "codigo":371597004,
    "descripcion":"EMACIADO"
  },
  {
    "codigo":551001000124108,
    "descripcion":"NEOPLASIA MALIGNA EN REMISIÓN PARCIAL"
  },
  {
    "codigo":109453008,
    "descripcion":"MESIODENS IMPACTADO"
  },
  {
    "codigo":369762001,
    "descripcion":"RESPUESTA LINFOCÍTICA PERITUMORAL, ACENTUADA"
  },
  {
    "codigo":699277009,
    "descripcion":"SIALADENOMA PAPILÍFERO"
  },
  {
    "codigo":1156194005,
    "descripcion":"INESTABILIDAD HABITACIONAL POSTERIOR A SITUACIÓN DE SINHOGARISMO RECIENTE"
  },
  {
    "codigo":238690006,
    "descripcion":"URTICARIA COLINÉRGICA PERSISTENTE"
  },
  {
    "codigo":74850006,
    "descripcion":"TRASTORNO DE CONDUCTA, TIPO AGRESIVO SOLITARIO"
  },
  {
    "codigo":402530007,
    "descripcion":"CARCINOMA BASOCELULAR CON DIFERENCIACIÓN MATRICIAL"
  },
  {
    "codigo":202252001,
    "descripcion":"LUXACIÓN RECURRENTE DE ARTICULACIÓN DEL PIE"
  },
  {
    "codigo":169484002,
    "descripcion":"DISPOSITIVO ANTICONCEPTIVO INTRAUTERINO - EN ESPERA DE REMOCIÓN"
  },
  {
    "codigo":71180002,
    "descripcion":"INFECCIÓN CAUSADA POR POSTERIOSTOMUM"
  },
  {
    "codigo":366092004,
    "descripcion":"MEDICIONES DEL OJO - HALLAZGO"
  },
  {
    "codigo":890380004,
    "descripcion":"DEFORMIDAD DE MADELUNG BILATERAL"
  },
  {
    "codigo":726540006,
    "descripcion":"ÚLCERA DE PIEL CAUSADA POR CROMO"
  },
  {
    "codigo":16021511000119100,
    "descripcion":"INFLAMACIÓN DE BOLSA SEROSA SUBTENDINOSA INFERIOR DE MÚSCULO BÍCEPS FEMORAL DE AMBAS RODILLAS"
  },
  {
    "codigo":73015009,
    "descripcion":"FRACTURA EXPUESTA DE HUESO NAVICULAR DE PIE"
  },
  {
    "codigo":823009001,
    "descripcion":"PLENITUD RECTAL DEBIDA A HECES"
  },
  {
    "codigo":167649004,
    "descripcion":"GRASA FECAL EXCESIVA"
  },
  {
    "codigo":298721005,
    "descripcion":"HALLAZGO RELACIONADO CON LA ESTRUCTURA DEL ESTERNÓN"
  },
  {
    "codigo":724705005,
    "descripcion":"DELIRIO CAUSADO POR METILENODIOXIMETANFETAMINA"
  },
  {
    "codigo":34742003,
    "descripcion":"HIPERTENSIÓN PORTAL"
  },
  {
    "codigo":1148854005,
    "descripcion":"DERMATITIS IRRITATIVA POR CONTACTO DE GENITALES MASCULINOS"
  },
  {
    "codigo":67510007,
    "descripcion":"ICTIOSIS HYSTRIX"
  },
  {
    "codigo":722870008,
    "descripcion":"COLANGITIS ESCLEROSANTE RELACIONADA CON INMUNOGLOBUINA G4"
  },
  {
    "codigo":6280008,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO DE MUÑECA"
  },
  {
    "codigo":293216005,
    "descripcion":"REACCIÓN ADVERSA AL LEVONORGESTREL"
  },
  {
    "codigo":94773001,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE BRONQUIO DEL LÓBULO SUPERIOR DERECHO DEL PULMÓN"
  },
  {
    "codigo":1208885004,
    "descripcion":"APRAXIA OCULOMOTORA ADQUIRIDA"
  },
  {
    "codigo":225845005,
    "descripcion":"CONOCE ACERCA DE LA LIBERTAD DE EXPRESIÓN"
  },
  {
    "codigo":62005008,
    "descripcion":"COCCIDIOSIS"
  },
  {
    "codigo":289546003,
    "descripcion":"SECRECIÓN VAGINAL ESPUMOSA"
  },
  {
    "codigo":11843591000119109,
    "descripcion":"HERIDA DE PABELLÓN AURICULAR IZQUIERDO DEBIDA A PICADURA DE INSECTO NO VENENOSO"
  },
  {
    "codigo":715530004,
    "descripcion":"TETRASOMÍA DE BRAZO CORTO DE CROMOSOMA 9"
  },
  {
    "codigo":1010442006,
    "descripcion":"PÉRDIDA DE LA AUDICIÓN NEUROSENSORIAL DE OÍDO IZQUIERDO CON AUDICIÓN NORMAL DEL OÍDO DERECHO"
  },
  {
    "codigo":92938009,
    "descripcion":"FORMA ANORMAL CONGÉNITA DEL PREMAXILAR"
  },
  {
    "codigo":846602009,
    "descripcion":"TRASTORNO FETAL DEBIDO A CORANGIOMA DE PLACENTA"
  },
  {
    "codigo":713695001,
    "descripcion":"SÍNDROME NEFRÓTICO CONCOMITANTE CON INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":254943007,
    "descripcion":"NEOPLASIA BENIGNA DE PLEXO COROIDEO"
  },
  {
    "codigo":449716000,
    "descripcion":"DEFORMIDAD DE PIERNA"
  },
  {
    "codigo":23732000,
    "descripcion":"DEGENERACIÓN CEREBELOSA PRIMARIA"
  },
  {
    "codigo":253108002,
    "descripcion":"ENCEFALOCELE TEMPORAL"
  },
  {
    "codigo":285876008,
    "descripcion":"OPERA UN HORNO"
  },
  {
    "codigo":87433001,
    "descripcion":"ENFISEMA DE PULMÓN"
  },
  {
    "codigo":185737001,
    "descripcion":"CONTROL DE ASMA SUPRIMIDO"
  },
  {
    "codigo":710025005,
    "descripcion":"MORFOLOGÍA DE CRESTA ALVEOLAR RESIDUAL DE MAXILAR SUPERIOR CON MUESCA HAMULAR PRESENTE"
  },
  {
    "codigo":54665006,
    "descripcion":"TAMAÑO DE UNA COLONIA BACTERIANA, MEDIANA"
  },
  {
    "codigo":348321000119108,
    "descripcion":"CATARATA ZONULAR CONGÉNITA DE OJO DERECHO"
  },
  {
    "codigo":773726000,
    "descripcion":"HIPERCOLESTEROLEMIA DEBIDA A DEFICIENCIA DE COLESTEROL 7 ALFA-HIDROXILASA"
  },
  {
    "codigo":249438001,
    "descripcion":"CUERDAS VOCALES - HALLAZGO"
  },
  {
    "codigo":21897009,
    "descripcion":"TRASTORNO DE ANSIEDAD GENERALIZADA"
  },
  {
    "codigo":20062001,
    "descripcion":"VÍCTIMA DE ACCIDENTE DE EMBARCACIÓN"
  },
  {
    "codigo":216670001,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR PRODUCTOS DERIVADOS DEL PETRÓLEO"
  },
  {
    "codigo":282206006,
    "descripcion":"NO EMPIEZA A CAMINAR"
  },
  {
    "codigo":85598007,
    "descripcion":"PERICARDITIS CONSTRICTIVA"
  },
  {
    "codigo":413278007,
    "descripcion":"LESIÓN TUMORAL EXCAVADA"
  },
  {
    "codigo":314974009,
    "descripcion":"RECIDIVA LOCAL DE NEOPLASIA MALIGNA DE PARTES BLANDAS"
  },
  {
    "codigo":247603000,
    "descripcion":"USO EXTREMADAMENTE EFICIENTE DE LA NEMOTECNIA"
  },
  {
    "codigo":313139000,
    "descripcion":"ESTADIO DE MARCADOR SEROLÓGICO TUMORAL S0"
  },
  {
    "codigo":331931000119100,
    "descripcion":"HEMORRAGIA SUBCONJUNTIVAL DE OJO DERECHO"
  },
  {
    "codigo":329371000119101,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DEBIDO A OCLUSIÓN DE ARTERIA CEREBRAL MEDIA IZQUIERDA POR ÉMBOLO"
  },
  {
    "codigo":1087131000119102,
    "descripcion":"ESCLERITIS POR HERPES ZOSTER"
  },
  {
    "codigo":1089691000119101,
    "descripcion":"DISFUNCIÓN DEL SISTEMA VESTIBULAR IZQUIERDO"
  },
  {
    "codigo":367771000119104,
    "descripcion":"OLIGOZOOSPERMIA DEBIDA A INFECCIÓN"
  },
  {
    "codigo":1082011000119105,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS INTRAEPIDÉRMICO DE MIEMBRO SUPERIOR DERECHO"
  },
  {
    "codigo":298651000119106,
    "descripcion":"OSTEONECROSIS DE PERONÉ DEBIDA A TRAUMATISMO"
  },
  {
    "codigo":10879131000119107,
    "descripcion":"HEMATOMA TRAUMÁTICO DE ÓRBITA IZQUIERDA PROPIAMENTE DICHA"
  },
  {
    "codigo":334491000119108,
    "descripcion":"LUXACIÓN DE GLÁNDULA LAGRIMAL DERECHA"
  },
  {
    "codigo":690331000119109,
    "descripcion":"DÉFICIT DEL HABLA Y DEL LENGUAJE DEBIDO A ACCIDENTE CEREBROVASCULAR EMBÓLICO Y POSTERIOR A ÉL"
  },
  {
    "codigo":342171000119109,
    "descripcion":"DACRIOCISTITIS AGUDA DE SACO LAGRIMAL IZQUIERDO"
  },
  {
    "codigo":737288007,
    "descripcion":"DISPOSITIVO ANTICONCEPTIVO INTRAUTERINO IN SITU"
  },
  {
    "codigo":352411000119109,
    "descripcion":"LINFOMA PEQUEÑO LINFOCÍTICO DE CÉLULAS B DE LOS GANGLIOS LINFÁTICOS INTRABDOMINALES"
  },
  {
    "codigo":316571000119108,
    "descripcion":"OSTEOFITO DE PIE IZQUIERDO"
  },
  {
    "codigo":15863451000119107,
    "descripcion":"LIPOMA DE ENCÉFALO"
  },
  {
    "codigo":134811000119108,
    "descripcion":"ENCEFALOPATÍA HIPÓXICA ISQUÉMICA NEONATAL SEVERA"
  },
  {
    "codigo":309469004,
    "descripcion":"PARTO ESPONTÁNEO DE VÉRTICE"
  },
  {
    "codigo":324494491000119108,
    "descripcion":"DERMATOCALASIA DE AMBOS PÁRPADOS INFERIORES"
  },
  {
    "codigo":80093006,
    "descripcion":"ENOFTALMOS"
  },
  {
    "codigo":1259741005,
    "descripcion":"GLIOMA PRIMARIO MALIGNO DE OJO"
  },
  {
    "codigo":735453008,
    "descripcion":"ANEMIA POR DEFICIENCIA HEREDITARIA DE FOLATO"
  },
  {
    "codigo":276701009,
    "descripcion":"SÍNDROME FETAL POR CITOMEGALOVIRUS"
  },
  {
    "codigo":307634003,
    "descripcion":"ENFERMEDAD DE HODGKIN, DEPLECIÓN LINFOCÍTICA, TIPO RETICULAR"
  },
  {
    "codigo":274866006,
    "descripcion":"NIVEL DE MINERAL EN SANGRE FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":209330007,
    "descripcion":"FRACTURA-SUBLUXACIÓN EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA DISTAL"
  },
  {
    "codigo":111026008,
    "descripcion":"HIPERPLASIA MESOTELIAL PLEURAL"
  },
  {
    "codigo":305799001,
    "descripcion":"VISTO EN EL SERVICIO DE MANEJO DEL DOLOR"
  },
  {
    "codigo":240263007,
    "descripcion":"TRASTORNO DE LA REPARACIÓN TENDINOSA"
  },
  {
    "codigo":895623007,
    "descripcion":"FORMA ROMBOIDE ANORMAL CONGÉNITA DE FALANGE DISTAL DE DEDO MEÑIQUE"
  },
  {
    "codigo":238428001,
    "descripcion":"TUBÉRCULO PAPULAR"
  },
  {
    "codigo":1256071008,
    "descripcion":"XANTOMA DEBIDO A HIPERTRIGLICERIDEMIA PRIMARIA"
  },
  {
    "codigo":404103007,
    "descripcion":"PAPULOSIS LINFOMATOIDE TIPO A (TIPO CD 30+)"
  },
  {
    "codigo":205660004,
    "descripcion":"SÍNDROMES DE TRISOMÍAS PARCIALES"
  },
  {
    "codigo":236593005,
    "descripcion":"HIDRONEFROSIS ADQUIRIDA"
  },
  {
    "codigo":105521006,
    "descripcion":"DESAVENENCIA CON EL OFICIAL DE LIBERTAD CONDICIONAL"
  },
  {
    "codigo":1186865008,
    "descripcion":"COLESTASIS INTRAHEPÁTICA FAMILIAR PROGRESIVA TIPO 3"
  },
  {
    "codigo":365830003,
    "descripcion":"QUÍMICA DEL LÍQUIDO ASCÍTICO - HALLAZGO"
  },
  {
    "codigo":169222003,
    "descripcion":"ECOGRAFÍA OBSTÉTRICA ANORMAL"
  },
  {
    "codigo":70918005,
    "descripcion":"HIPERPLASIA MIELOIDE DE LA MÉDULA ÓSEA"
  },
  {
    "codigo":890118006,
    "descripcion":"SÍNDROME DE MOWAT-WILSON DEBIDO A MONOSOMÍA 2Q22"
  },
  {
    "codigo":678511000119103,
    "descripcion":"CATARATA PRESENIL DE OJO DERECHO"
  },
  {
    "codigo":167387000,
    "descripcion":"NIVEL DE 17-CETOSTEROIDES EN ORINA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":300294009,
    "descripcion":"ESÓFAGO NORMAL"
  },
  {
    "codigo":298459001,
    "descripcion":"SIN ROTACIÓN PASIVA DE LA COLUMNA CERVICAL HACIA LA DERECHA"
  },
  {
    "codigo":36315003,
    "descripcion":"CARDIOPATÍA HIPERTENSIVA MALIGNA SIN INSUFICIENCIA CARDÍACA CONGESTIVA"
  },
  {
    "codigo":429531000,
    "descripcion":"DOLOR DURANTE ESTIRAMIENTO PASIVO DE ARTICULACIÓN"
  },
  {
    "codigo":350831000119103,
    "descripcion":"NEOPLASIA BENIGNA DE GLÁNDULA SUPRARRENAL IZQUIERDA"
  },
  {
    "codigo":726278009,
    "descripcion":"LACERACIÓN DE TOBILLO SIN CUERPO EXTRAÑO"
  },
  {
    "codigo":1279664001,
    "descripcion":"QUEMADURA DE DEDO MEÑIQUE"
  },
  {
    "codigo":67248003,
    "descripcion":"MOVIMIENTO DIAFRAGMÁTICO NORMAL"
  },
  {
    "codigo":722608004,
    "descripcion":"MORDEDURA SUPERFICIAL DE CUERO CABELLUDO"
  },
  {
    "codigo":1148592003,
    "descripcion":"PH DE SANGRE VENOSA FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":460464006,
    "descripcion":"PERICARDITIS CONSTRICTIVA CAUSADA POR COMPLEJO DE MYCOBACTERIUM TUBERCULOSIS"
  },
  {
    "codigo":294789001,
    "descripcion":"ALERGIA A DIENESTROL"
  },
  {
    "codigo":15725321000119101,
    "descripcion":"DERRAME ARTICULAR DE AMBOS CODOS"
  },
  {
    "codigo":196485006,
    "descripcion":"SIALOADENITIS DE GLÁNDULA SUBMAXILAR"
  },
  {
    "codigo":15997551000119108,
    "descripcion":"ISQUEMIA DE RETINA DE OJO DERECHO"
  },
  {
    "codigo":130949008,
    "descripcion":"PERISTALTISMO URETERAL AUMENTADO"
  },
  {
    "codigo":718938003,
    "descripcion":"DISFUNCIÓN SOMÁTICA DE REGIÓN TORÁCICA"
  },
  {
    "codigo":292954005,
    "descripcion":"REACCIÓN ADVERSA A LA PENICILINA"
  },
  {
    "codigo":161882006,
    "descripcion":"CUELLO RÍGIDO"
  },
  {
    "codigo":1144922006,
    "descripcion":"TIMOMA TIPO AB"
  },
  {
    "codigo":28975000,
    "descripcion":"ANEMIA APLÁSICA CONSTITUCIONAL"
  },
  {
    "codigo":127279002,
    "descripcion":"LESIÓN TRAUMÁTICA DE MIEMBRO INFERIOR"
  },
  {
    "codigo":61743004,
    "descripcion":"PÉRDIDA AUDITIVA DE CONDUCCIÓN A NIVEL DEL OÍDO MEDIO"
  },
  {
    "codigo":225583004,
    "descripcion":"SONRISAS"
  },
  {
    "codigo":192815006,
    "descripcion":"DEGENERACIÓN CEREBRAL POR NEOPLASIA"
  },
  {
    "codigo":291119004,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR CLORMETIAZOL"
  },
  {
    "codigo":420356000,
    "descripcion":"ERITEMA CUTÁNEO PERSISTENTE"
  },
  {
    "codigo":94511008,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL TABIQUE RECTOVAGINAL"
  },
  {
    "codigo":190980000,
    "descripcion":"DEFICIENCIA SELECTIVA DE IG M"
  },
  {
    "codigo":715268001,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR DISULFIRAM"
  },
  {
    "codigo":92676001,
    "descripcion":"CARCINOMA IN SITU DE LAS GLÁNDULAS PARAURETRALES"
  },
  {
    "codigo":254681004,
    "descripcion":"MILIUM SECUNDARIO"
  },
  {
    "codigo":123609007,
    "descripcion":"GLOMERULONEFRITIS SUBAGUDA"
  },
  {
    "codigo":23470002,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE PERINEO SIN INFECCIÓN"
  },
  {
    "codigo":56238008,
    "descripcion":"TROMBOEMBOLIA LUEGO DE INFUSIÓN, PERFUSIÓN Y\/O TRANSFUSIÓN"
  },
  {
    "codigo":10947491000119104,
    "descripcion":"HERIDA ABIERTA DE DEDO DE LA MANO DERECHA DEBIDA A MORDEDURA DE PERRO"
  },
  {
    "codigo":1332355005,
    "descripcion":"HIPERTROFIA DE OMÓPLATO"
  },
  {
    "codigo":283779009,
    "descripcion":"MORDEDURA DE PERRO EN EL DORSO DEL PIE"
  },
  {
    "codigo":609624008,
    "descripcion":"HALLAZGO RELACIONADO CON EL ABDOMEN"
  },
  {
    "codigo":247341002,
    "descripcion":"SENSACIÓN DE TUMEFACCIÓN"
  },
  {
    "codigo":83501007,
    "descripcion":"TRASTORNO ORGÁNICO DEL ESTADO DE ÁNIMO DE TIPO MIXTO"
  },
  {
    "codigo":107581000119103,
    "descripcion":"ASTROCITOMA DE TRONCO ENCEFÁLICO"
  },
  {
    "codigo":473047000,
    "descripcion":"INFECCIÓN ASOCIADA CON DISPOSITIVO"
  },
  {
    "codigo":1163010008,
    "descripcion":"REACCIÓN ADVERSA A XANTINA Y\/O DERIVADO DE XANTINA"
  },
  {
    "codigo":212738009,
    "descripcion":"INTOXICACIÓN CON MERCAPTOMERINA"
  },
  {
    "codigo":276439000,
    "descripcion":"ADENOIDES PEQUEÑAS"
  },
  {
    "codigo":79831008,
    "descripcion":"LENGUA CRENADA"
  },
  {
    "codigo":702423009,
    "descripcion":"SÍNDROME DE SORDERA-DISTONÍA-NEURONOPATÍA ÓPTICA"
  },
  {
    "codigo":733356003,
    "descripcion":"CARCINOMA MUCINOSO PRIMARIO DE ÓRGANO DIGESTIVO"
  },
  {
    "codigo":241836005,
    "descripcion":"ENVENENAMIENTO POR ESPINA DE ERIZO DE MAR"
  },
  {
    "codigo":1090621000119106,
    "descripcion":"OTITIS EXTERNA AGUDA DE CONTACTO DE CONDUCTO AUDITIVO EXTERNO DERECHO"
  },
  {
    "codigo":1255809000,
    "descripcion":"MASTOCITOMA MALIGNO DE GANGLIOS LINFÁTICOS DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":274604009,
    "descripcion":"REFLEJO CILIOESPINAL POSITIVO"
  },
  {
    "codigo":240001002,
    "descripcion":"RUPTURA DE TENDÓN DE REGIÓN DE LA RODILLA"
  },
  {
    "codigo":371073003,
    "descripcion":"SÍNDROME DE TAQUICARDIA POSTURAL ORTOSTÁTICA"
  },
  {
    "codigo":895361003,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA BILATERAL DE TESTÍCULO"
  },
  {
    "codigo":305537003,
    "descripcion":"BAJO ATENCIÓN DE CIRUJANO GENERAL ESPECIALISTA EN TRACTO GASTROINTESTINAL"
  },
  {
    "codigo":403841009,
    "descripcion":"ONFALITIS ESTAFILOCÓCICA DEL RECIÉN NACIDO"
  },
  {
    "codigo":762454002,
    "descripcion":"DOLOR OROFACIAL CRÓNICO"
  },
  {
    "codigo":926294004,
    "descripcion":"EPÍFISIS PEQUEÑA DE FALANGE DE DEDO MEÑIQUE"
  },
  {
    "codigo":205398008,
    "descripcion":"TOBILLO EN VALGO CONGÉNITO"
  },
  {
    "codigo":367403001,
    "descripcion":"ESTENOSIS PILÓRICA"
  },
  {
    "codigo":400171002,
    "descripcion":"PAPULOSIS ATRÓFICA MALIGNA"
  },
  {
    "codigo":6955002,
    "descripcion":"ENCEFALITIS DE NEGISHI"
  },
  {
    "codigo":301867009,
    "descripcion":"EDEMA DE TRONCO"
  },
  {
    "codigo":234496003,
    "descripcion":"PÚRPURA METABÓLICA"
  },
  {
    "codigo":168960008,
    "descripcion":"ARTERIOGRAFÍA DE EXTREMIDAD SUPERIOR: NORMAL"
  },
  {
    "codigo":365568009,
    "descripcion":"ACCESO AL NIÑO - HALLAZGO"
  },
  {
    "codigo":298197005,
    "descripcion":"HIPERMOVILIDAD DE ARTICULACIÓN DE RODILLA"
  },
  {
    "codigo":198058000,
    "descripcion":"HEMATOMA ESCROTAL DE CAUSA ATRAUMÁTICA"
  },
  {
    "codigo":66986005,
    "descripcion":"TUBERCULOSIS DE LA PIEL"
  },
  {
    "codigo":296362005,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE PILOCARPINA"
  },
  {
    "codigo":165290007,
    "descripcion":"MEMORIA: TIENE CONSCIENCIA DEL AÑO ACTUAL"
  },
  {
    "codigo":720511000,
    "descripcion":"SÍNDROME DE ARRINIA CON ATRESIA DE COANAS Y MICROFTALMÍA"
  },
  {
    "codigo":816980006,
    "descripcion":"NEOPLASIA INTRAEPITELIAL DIFERENCIADA DE PENE"
  },
  {
    "codigo":421929001,
    "descripcion":"MIOCARDITIS ASOCIADA CON SIDA"
  },
  {
    "codigo":292692009,
    "descripcion":"REACCIÓN ADVERSA AL ROCURONIO"
  },
  {
    "codigo":94249008,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL ESÓFAGO CERVICAL"
  },
  {
    "codigo":389161008,
    "descripcion":"DISPLASIA DE TIPO ESPONASTRIME (CAMBIOS ESPONDILARES, ANOMALÍAS NASALES, ESTRIADAS Y METAFISARIAS)"
  },
  {
    "codigo":92414002,
    "descripcion":"NEOPLASIA BENIGNA DE LOS GANGLIOS LINFÁTICOS SUBMANDIBULARES"
  },
  {
    "codigo":289022004,
    "descripcion":"DIFICULTAD PARA EMPLEAR LAS MANOS PARA ALIMENTARSE"
  },
  {
    "codigo":715006005,
    "descripcion":"INCAPAZ DE CABALGAR"
  },
  {
    "codigo":420094007,
    "descripcion":"REACCIÓN ADVERSA A LA GENTAMICINA"
  },
  {
    "codigo":254419002,
    "descripcion":"NEOPLASIA BENIGNA DE FRENILLO LINGUAL"
  },
  {
    "codigo":188883003,
    "descripcion":"NEOPLASIA BENIGNA DEL PLIEGUE ARITENOEPIGLÓTICO"
  },
  {
    "codigo":55976003,
    "descripcion":"ABORTO ESPONTÁNEO CON EMBOLIA DE COÁGULO DE SANGRE"
  },
  {
    "codigo":1268392005,
    "descripcion":"CARCINOMA METASTÁSICO INDIFERENCIADO DE SENO PARANASAL"
  },
  {
    "codigo":88744007,
    "descripcion":"LESIÓN TRAUMÁTICA DE VASOS SANGUÍNEOS DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":840573001,
    "descripcion":"CARCINOMA DE EPIDÍDIMO Y CORDÓN ESPERMÁTICO"
  },
  {
    "codigo":283517004,
    "descripcion":"HERIDA PUNZANTE DE MANO"
  },
  {
    "codigo":248914002,
    "descripcion":"CUELLO UTERINO PEQUEÑO"
  },
  {
    "codigo":609362004,
    "descripcion":"ABRASIÓN DE CONJUNTIVA"
  },
  {
    "codigo":1363026006,
    "descripcion":"CEFALEA TUSÍGENA PRIMARIA"
  },
  {
    "codigo":19538009,
    "descripcion":"VERBIGERACIÓN"
  },
  {
    "codigo":871506009,
    "descripcion":"ALERGIA A AMPICILINA Y\/O CLOXACILINA"
  },
  {
    "codigo":1701000119104,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE COLON"
  },
  {
    "codigo":212476002,
    "descripcion":"LESIÓN TRAUMÁTICA MUSCULAR Y TENDINOSA DE MÚSCULO FLEXOR LARGO A NIVEL DE TOBILLO Y PIE"
  },
  {
    "codigo":276177000,
    "descripcion":"ENFERMEDAD OCULAR TIROIDEA"
  },
  {
    "codigo":210641000,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA A NIVEL DE CODO"
  },
  {
    "codigo":472785004,
    "descripcion":"OBSTRUCCIÓN AL TRACTO DE SALIDA DEL VENTRÍCULO DERECHO DEBIDA A NEOPLASIA"
  },
  {
    "codigo":1193681006,
    "descripcion":"ENTERITIS POR ESCHERICHIA COLI ENTEROINVASIVA"
  },
  {
    "codigo":46801009,
    "descripcion":"INFECCIÓN CAUSADA POR SUBULURA"
  },
  {
    "codigo":44966003,
    "descripcion":"TRASTORNO PASIVO - AGRESIVO DE LA PERSONALIDAD"
  },
  {
    "codigo":896934004,
    "descripcion":"FORMA DE BALA ANORMAL CONGÉNITA DE FALANGE DE TERCER DEDO DE PIE"
  },
  {
    "codigo":733094005,
    "descripcion":"SÍNDROME DE MALFORMACIÓN DE DANDY-WALKER CON POLIDACTILIA POSTAXIAL"
  },
  {
    "codigo":208806005,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA EXPUESTA DE CODO"
  },
  {
    "codigo":700326007,
    "descripcion":"ARTROSIS SECUNDARIA DE ARTICULACIÓN ASTRAGALOESCAFOIDEA"
  },
  {
    "codigo":307110007,
    "descripcion":"CAMBIO DE TRABAJO"
  },
  {
    "codigo":10363003,
    "descripcion":"INTOXICACIÓN POR AMIANTHIUM MUSCAETOXICUM"
  },
  {
    "codigo":239739005,
    "descripcion":"CONTRACTURA DE LA RODILLA"
  },
  {
    "codigo":403579006,
    "descripcion":"LINFEDEMA FALSO"
  },
  {
    "codigo":303440003,
    "descripcion":"CAPAZ DE CONSTRUIR COSAS"
  },
  {
    "codigo":8528005,
    "descripcion":"MIELITIS ASCENDENTE AGUDA"
  },
  {
    "codigo":237904006,
    "descripcion":"HIPERFOSFATEMIA ASOCIADA A INSUFICIENCIA RENAL"
  },
  {
    "codigo":268837000,
    "descripcion":"GRANULOMA UMBILICAL INFECTADO"
  },
  {
    "codigo":1153573006,
    "descripcion":"TESTOSTERONA SÉRICA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":236069009,
    "descripcion":"ESTREÑIMIENTO CRÓNICO"
  },
  {
    "codigo":70394001,
    "descripcion":"CONJUNTIVITIS FLICTENULAR"
  },
  {
    "codigo":234234001,
    "descripcion":"TRASTORNO DEL GENERADOR DE DESFIBRILADOR IMPLANTADO"
  },
  {
    "codigo":299770004,
    "descripcion":"REACCIÓN DE COLOCACIÓN DE RESULTADOS DUDOSOS"
  },
  {
    "codigo":201466005,
    "descripcion":"ARTRITIS Y POLIARTRITIS ESTAFILOCÓCICA"
  },
  {
    "codigo":365306009,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA REALIZAR LIMPIEZA Y LAVADO DOMÉSTICO"
  },
  {
    "codigo":363471001,
    "descripcion":"NEOPLASIA MALIGNA DE VENTRÍCULO CEREBRAL"
  },
  {
    "codigo":166863001,
    "descripcion":"FENILALANINA SÉRICA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":232399005,
    "descripcion":"FARINGITIS AGUDA POR HERPES SIMPLE"
  },
  {
    "codigo":723919008,
    "descripcion":"PESO CORPORAL SIGNIFICATIVAMENTE BAJO CONCOMITANTE CON ANOREXIA NERVIOSA DE TIPO RESTRICTIVO Y DEBIDO A ELLA"
  },
  {
    "codigo":3023008,
    "descripcion":"ÚLCERA PÉPTICA AGUDA SIN HEMORRAGIA, SIN PERFORACIÓN Y SIN OBSTRUCCIÓN"
  },
  {
    "codigo":165028003,
    "descripcion":"PRUEBA DE VOLUMEN PULMONAR ANORMAL"
  },
  {
    "codigo":427172004,
    "descripcion":"ELECTROCARDIOGRAMA: CONTRACCIONES VENTRICULARES PREMATURAS"
  },
  {
    "codigo":230564004,
    "descripcion":"POLIRRADICULONEUROPATÍA DESMIELINIZANTE INFLAMATORIA CRÓNICA CON DESMIELINIZACIÓN DEL SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":296100005,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE KETAZOLAM"
  },
  {
    "codigo":294265007,
    "descripcion":"ALERGIA A CARBÓN ACTIVADO"
  },
  {
    "codigo":32121007,
    "descripcion":"HIPERTROFIA DE TESTÍCULO"
  },
  {
    "codigo":1177166006,
    "descripcion":"SÍNDROME DE DISPLASIA FRONTONASAL, NARIZ BÍFIDA Y ANOMALÍAS DE EXTREMIDADES SUPERIORES"
  },
  {
    "codigo":423502007,
    "descripcion":"DIFICULTAD CON EL PATRÓN DE DESCANSO DESPUÉS DEL PARTO"
  },
  {
    "codigo":95822008,
    "descripcion":"ACÚFENOS EN CHASQUIDO"
  },
  {
    "codigo":292430008,
    "descripcion":"REACCIÓN ADVERSA AL NADOLOL"
  },
  {
    "codigo":1144398008,
    "descripcion":"HIPOPLASIA CONGÉNITA DE TRONCO ENCEFÁLICO"
  },
  {
    "codigo":93987004,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE RETINA"
  },
  {
    "codigo":126755007,
    "descripcion":"NEOPLASIA DE VASO SANGUÍNEO DEL TÓRAX"
  },
  {
    "codigo":290595008,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR CLORAMBUCILO"
  },
  {
    "codigo":92152005,
    "descripcion":"NEOPLASIA BENIGNA DE LOS GANGLIOS LINFÁTICOS INTRABDOMINALES"
  },
  {
    "codigo":288760009,
    "descripcion":"DIFICULTAD PARA COMUNICAR PENSAMIENTOS"
  },
  {
    "codigo":254157005,
    "descripcion":"ICTIOSIS VULGAR"
  },
  {
    "codigo":24781009,
    "descripcion":"TRASTORNO DE PÁNICO CON AGORAFOBIA, EVITACIÓN AGORAFÓBICA LEVE Y ATAQUES DE PÁNICO EN REMISIÓN TOTAL"
  },
  {
    "codigo":874914008,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN ENCÍA"
  },
  {
    "codigo":448930008,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS DE LA NARIZ"
  },
  {
    "codigo":447095001,
    "descripcion":"QUEMADURA DE SACO CONJUNTIVAL POR SUSTANCIA QUÍMICA ÁCIDA"
  },
  {
    "codigo":21111006,
    "descripcion":"SÍNDROME DE TRISOMÍA 13 COMPLETA"
  },
  {
    "codigo":283255008,
    "descripcion":"VIDRIO EN TRONCO"
  },
  {
    "codigo":1231692001,
    "descripcion":"SÍNDROME DE UNO Y MEDIO VERTICAL"
  },
  {
    "codigo":248652003,
    "descripcion":"FRECUENCIA CARDÍACA IRREGULAR CONTINUA"
  },
  {
    "codigo":445260006,
    "descripcion":"DIABETES MELLITUS POSTRASPLANTE"
  },
  {
    "codigo":707404008,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE PULMÓN, SUBTIPO MIXTO"
  },
  {
    "codigo":246817001,
    "descripcion":"DEFECTO DE TEJIDO PALPEBRAL"
  },
  {
    "codigo":345121001,
    "descripcion":"DEFECTO DEL CAMPO VISUAL BILATERAL HETERÓNIMO"
  },
  {
    "codigo":314188009,
    "descripcion":"OCLUSIÓN DE ARTERIA FEMORAL"
  },
  {
    "codigo":81142005,
    "descripcion":"ÚLCERA DUODENAL CRÓNICA CON HEMORRAGIA Y PERFORACIÓN PERO SIN OBSTRUCCIÓN"
  },
  {
    "codigo":1162486006,
    "descripcion":"BAROTRAUMA"
  },
  {
    "codigo":212214006,
    "descripcion":"LESIÓN DE LA RAÍZ DEL NERVIO DORSAL - D9"
  },
  {
    "codigo":441590008,
    "descripcion":"NEUMONÍA CAUSADA POR CORONAVIRUS DEL SÍNDROME RESPIRATORIO AGUDO GRAVE"
  },
  {
    "codigo":408822009,
    "descripcion":"ESTADO DE ANTICONCEPCIÓN, NO DECIDIDO"
  },
  {
    "codigo":13771001,
    "descripcion":"SAPONIFICACIÓN MESENTÉRICA"
  },
  {
    "codigo":112075006,
    "descripcion":"NACIMIENTO PREMATURO DE SEXTILLIZOS"
  },
  {
    "codigo":79307007,
    "descripcion":"FLEXIÓN DE LA CABEZA FLOTANTE DEL FETO"
  },
  {
    "codigo":275915008,
    "descripcion":"COMENZÓ CON APORTE DE OXÍGENO DOMICILIARIO"
  },
  {
    "codigo":11936003,
    "descripcion":"ENCEFALOMIELOCARDITIS VIRAL"
  },
  {
    "codigo":274080003,
    "descripcion":"GASTROENTERITIS BACTERIANA"
  },
  {
    "codigo":16007591000119106,
    "descripcion":"ANOMALÍA CONGÉNITA DE VASO SANGUÍNEO DE EXTREMIDAD SUPERIOR IZQUIERDA"
  },
  {
    "codigo":306848006,
    "descripcion":"OCLUSIÓN DE INJERTO-PUENTE FEMOROPOPLÍTEO"
  },
  {
    "codigo":403317000,
    "descripcion":"HIRSUTISMO RACIAL CONSTITUCIONALMENTE DETERMINADO"
  },
  {
    "codigo":208544009,
    "descripcion":"FRACTURA EXPUESTA SUBCAPITAL DE FÉMUR PROXIMAL GRADO IV DE GARDEN"
  },
  {
    "codigo":1255285000,
    "descripcion":"FRACTURA EXPUESTA DE MÚLTIPLES HUESOS DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":110240009,
    "descripcion":"CONTUSIÓN DE RAMA MANDIBULAR"
  },
  {
    "codigo":11311681000119101,
    "descripcion":"FRACTURA PATOLÓGICA DE VÉRTEBRA EN SITIO DE NEOPLASIA"
  },
  {
    "codigo":370549005,
    "descripcion":"REMODELACIÓN ÓSEA"
  },
  {
    "codigo":237642002,
    "descripcion":"HIPOGLUCEMIA POR FACTOR DE CRECIMIENTO TIPO INSULÍNICO ECTÓPICO"
  },
  {
    "codigo":399647000,
    "descripcion":"METÁSTASIS EN GANGLIO LINFÁTICO NO REGIONAL"
  },
  {
    "codigo":39199000,
    "descripcion":"ABORTO ESPONTÁNEO CON LACERACIÓN DE VEJIGA URINARIA"
  },
  {
    "codigo":432415000,
    "descripcion":"PORTADOR DE STAPHYLOCOCCUS AUREUS RESISTENTE A METICILINA"
  },
  {
    "codigo":301343009,
    "descripcion":"HALLAZGO RELACIONADO CON LA TEMPERATURA"
  },
  {
    "codigo":233972005,
    "descripcion":"OBSTRUCCIÓN AORTOILÍACA"
  },
  {
    "codigo":365044005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA EMPLEAR EL DISCURSO DE MANERA APROPIADA"
  },
  {
    "codigo":102900008,
    "descripcion":"RELACIÓN EMOCIONAL ABUSIVA CON LOS PADRES"
  },
  {
    "codigo":428745004,
    "descripcion":"HIPERTROFIA DE EPITELIO CORNEAL"
  },
  {
    "codigo":232137004,
    "descripcion":"ASTIGMATISMO REGULAR - LENTICULAR"
  },
  {
    "codigo":2761008,
    "descripcion":"CALIBRE DE LA MATERIA FECAL DISMINUIDO"
  },
  {
    "codigo":787358002,
    "descripcion":"METABOLIZADOR INTERMEDIO ALTO DE LA FAMILIA 2 SUBFAMILIA C MIEMBRO 19 DEL CITOCROMO P450"
  },
  {
    "codigo":721822004,
    "descripcion":"EQUINOCOCOSIS QUÍSTICA"
  },
  {
    "codigo":230302004,
    "descripcion":"DEGENERACIÓN DEL GLOBO PÁLIDO"
  },
  {
    "codigo":15735361000119109,
    "descripcion":"RETINOPATÍA DE OJO DERECHO CAUSADA POR HIDROXICLOROQUINA"
  },
  {
    "codigo":263070009,
    "descripcion":"FRACTURA DEL AHORCADO"
  },
  {
    "codigo":64627002,
    "descripcion":"INFARTO AGUDO DE MIOCARDIO DE PARED LATERAL ALTA"
  },
  {
    "codigo":228467001,
    "descripcion":"RELACIÓN SEXUAL CASUAL"
  },
  {
    "codigo":294003008,
    "descripcion":"ALERGIA A DILTIAZEM"
  },
  {
    "codigo":719987009,
    "descripcion":"DISTROFIA MUSCULAR AUTOSÓMICA DOMINANTE CON DISTRIBUCIÓN EN LAS CINTURAS ESCAPULAR O PÉLVICA TIPO 1D"
  },
  {
    "codigo":292168002,
    "descripcion":"REACCIÓN ADVERSA A METOHEXITAL"
  },
  {
    "codigo":161096004,
    "descripcion":"VIAJARÁ AL EXTRANJERO"
  },
  {
    "codigo":95560005,
    "descripcion":"HEMORRAGIA ATRAUMÁTICA DE VESÍCULA BILIAR"
  },
  {
    "codigo":62792007,
    "descripcion":"UROFILIA"
  },
  {
    "codigo":93725000,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE HUESO"
  },
  {
    "codigo":128328009,
    "descripcion":"SÍNDROME SUPRASELAR"
  },
  {
    "codigo":126493001,
    "descripcion":"NEOPLASIA DE LA PIEL DE LA MEJILLA"
  },
  {
    "codigo":1142301006,
    "descripcion":"CRECIMIENTO INTERNO DE CEJA ANORMAL"
  },
  {
    "codigo":192029008,
    "descripcion":"DORSALGIA PSICÓGENA"
  },
  {
    "codigo":10849141000119102,
    "descripcion":"CUERPO EXTRAÑO EN CÓRNEA DERECHA"
  },
  {
    "codigo":28189009,
    "descripcion":"BLOQUEO AURICULOVENTRICULAR DE MOBITZ TIPO II"
  },
  {
    "codigo":91890003,
    "descripcion":"AUSENCIA CONGÉNITA DEL TRACTO INTESTINAL"
  },
  {
    "codigo":124658004,
    "descripcion":"DEFICIENCIA DE LISINA RACEMASA"
  },
  {
    "codigo":1304306004,
    "descripcion":"ALTERACIÓN DE LA CAPACIDAD PARA DISTINGUIR EXPERIENCIAS MENTALES INTERNAS DE LA REALIDAD EXTERNA"
  },
  {
    "codigo":714482007,
    "descripcion":"TEJIDO PERIODONTAL NORMAL"
  },
  {
    "codigo":417735002,
    "descripcion":"DISFUNCIÓN SOMÁTICA DE HUESO ILÍACO"
  },
  {
    "codigo":712647003,
    "descripcion":"TORTÍCOLIS ESPASMÓDICA DEBIDA A INFECCIÓN"
  },
  {
    "codigo":1204167003,
    "descripcion":"TAQUICARDIA VENTRICULAR POLIMÓRFICA CATECOLAMINÉRGICA DEBIDA A MUTACIÓN DE CALSECUESTRINA"
  },
  {
    "codigo":384967005,
    "descripcion":"PERICARDIO PARIETAL AFECTADO POR PROPAGACIÓN DIRECTA DE NEOPLASIA MALIGNA"
  },
  {
    "codigo":286663005,
    "descripcion":"ALTRUISMO - MECANISMO DE DEFENSA PSICOLÓGICA"
  },
  {
    "codigo":284828001,
    "descripcion":"CAPAZ DE SECARSE"
  },
  {
    "codigo":88220006,
    "descripcion":"SÍNDROME DE PAQUIDERMOPERIOSTOSIS"
  },
  {
    "codigo":22684007,
    "descripcion":"ACIDURIA METILCROTÓNICA"
  },
  {
    "codigo":448668007,
    "descripcion":"NEOPLASIA MALIGNA DE MANDÍBULA"
  },
  {
    "codigo":282993003,
    "descripcion":"NO VOLTEA LA CABEZA"
  },
  {
    "codigo":250225005,
    "descripcion":"PRUEBA DE FORMACIÓN DE DREPANOCITOS POSITIVA"
  },
  {
    "codigo":1003889006,
    "descripcion":"DUPLICACIÓN DE PORCIÓN PROXIMAL DEL BRAZO CORTO DEL CROMOSOMA 2"
  },
  {
    "codigo":16419701000119108,
    "descripcion":"PENACHO VITREORRETINIANO DE AMBOS OJOS"
  },
  {
    "codigo":1231430002,
    "descripcion":"BACILOS GRAMPOSITIVOS RAMIFICADOS PRESENTES"
  },
  {
    "codigo":248390004,
    "descripcion":"SEPARACIÓN ORBITARIA"
  },
  {
    "codigo":444998005,
    "descripcion":"ARTRITIS INFECCIOSA DE PELVIS"
  },
  {
    "codigo":91151000119103,
    "descripcion":"CARCINOMA PRIMARIO ESCAMOCELULAR DE PARED TORÁCICA"
  },
  {
    "codigo":10904591000119103,
    "descripcion":"HERIDA PUNZANTE DE NALGA DERECHA"
  },
  {
    "codigo":182854009,
    "descripcion":"FÁRMACO NO RETIRADO - COSTO EXCESIVO"
  },
  {
    "codigo":1264198009,
    "descripcion":"TRASTORNO FETAL DEBIDO A ANESTESIA EPIDURAL MATERNA DURANTE TRABAJO DE PARTO"
  },
  {
    "codigo":336911000119104,
    "descripcion":"COROIDITIS FOCAL MACULAR"
  },
  {
    "codigo":1196827003,
    "descripcion":"MESENQUIMOMA BENIGNO DE INTESTINO GRUESO"
  },
  {
    "codigo":312091007,
    "descripcion":"MOVILIDAD DENTARIA - GRADO 1"
  },
  {
    "codigo":80880002,
    "descripcion":"QUISTE DE CONDUCTO ONFALOMESENTÉRICO"
  },
  {
    "codigo":310256002,
    "descripcion":"ANTICUERPO CONTRA CITOPLASMA DE NEUTRÓFILOS DETECTADO"
  },
  {
    "codigo":441328008,
    "descripcion":"ELECTRONISTAGMOGRAMA ANORMAL"
  },
  {
    "codigo":277488009,
    "descripcion":"TRAUMA PERINATAL"
  },
  {
    "codigo":11779241000119101,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE ANTEBRAZO DERECHO"
  },
  {
    "codigo":109978004,
    "descripcion":"LINFOMA DE LINFOCITOS T (CLÍNICO)"
  },
  {
    "codigo":372122006,
    "descripcion":"NEOPLASIA MALIGNA DE LA PIEL DE LA CABEZA Y EL CUELLO"
  },
  {
    "codigo":11674008,
    "descripcion":"NUTRIENTE PARENTERAL"
  },
  {
    "codigo":699802009,
    "descripcion":"SÍNDROME DEL SENO SILENCIOSO"
  },
  {
    "codigo":271983002,
    "descripcion":"ALTERACIÓN DEL SISTEMA DE MARCAPASOS CARDÍACO"
  },
  {
    "codigo":403055000,
    "descripcion":"TIÑA DEL PIE CAUSADA POR TRICHOPHYTON RUBRUM"
  },
  {
    "codigo":239215004,
    "descripcion":"DOLOR POR EL EXPANSOR TISULAR"
  },
  {
    "codigo":9839007,
    "descripcion":"ANOMALÍA DEL PAR DE CROMOSOMAS 20"
  },
  {
    "codigo":75375008,
    "descripcion":"ENTERITIS BACTERIANA"
  },
  {
    "codigo":8004003,
    "descripcion":"SÍNDROME DE DENTICIÓN"
  },
  {
    "codigo":302916008,
    "descripcion":"DIVERTÍCULO MEDIOESOFÁGICO POR TRACCIÓN"
  },
  {
    "codigo":399385006,
    "descripcion":"NO SE PUEDE EVALUAR EL MARGEN QUIRÚRGICO LATERAL COMPROMETIDO POR MELANOMA"
  },
  {
    "codigo":10960041000119108,
    "descripcion":"HERIDA PUNZANTE DE ANTEBRAZO IZQUIERDO"
  },
  {
    "codigo":364782000,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA BEBER A SORBOS"
  },
  {
    "codigo":170009009,
    "descripcion":"PESO DEL NIÑO ENTRE PERCENTILOS 25 Y 49"
  },
  {
    "codigo":1251353009,
    "descripcion":"HIPERTRICOSIS CAUSADA POR FÁRMACO"
  },
  {
    "codigo":299246002,
    "descripcion":"AMPLITUD DE FLEXIÓN PASIVA DE LA CADERA NORMAL"
  },
  {
    "codigo":200942004,
    "descripcion":"LUPUS ERITEMATOSO UNGUEAL MUTILANTE"
  },
  {
    "codigo":233710001,
    "descripcion":"EDEMA PULMONAR INDUCIDO POR AGENTES QUÍMICOS"
  },
  {
    "codigo":168174000,
    "descripcion":"PRUEBA DEL SUDOR DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":788931000,
    "descripcion":"CONTUSIÓN FOCAL DE LÓBULO OCCIPITAL"
  },
  {
    "codigo":37102008,
    "descripcion":"DISFUNCIÓN OVÁRICA"
  },
  {
    "codigo":428483004,
    "descripcion":"EN CONDICIONES CLÍNICAS PARA EL ALTA MÉDICA"
  },
  {
    "codigo":164504000,
    "descripcion":"EXAMEN ORTOPÉDICO - NO SE DETECTARON ANOMALÍAS"
  },
  {
    "codigo":721560002,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE CAVIDAD NASAL"
  },
  {
    "codigo":426648003,
    "descripcion":"ELECTROCARDIOGRAMA: TAQUICARDIA DE LA UNIÓN AURICULOVENTRICULAR"
  },
  {
    "codigo":361112002,
    "descripcion":"AVULSIÓN DE REGIÓN CIGOMÁTICA DE MEJILLA"
  },
  {
    "codigo":295576004,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE OXIBUPROCAÍNA"
  },
  {
    "codigo":664002,
    "descripcion":"OVULACIÓN DEMORADA"
  },
  {
    "codigo":129901000,
    "descripcion":"TRASTORNO PERIFÉRICO"
  },
  {
    "codigo":262808009,
    "descripcion":"HEMATOMA DE VESÍCULA BILIAR"
  },
  {
    "codigo":293741002,
    "descripcion":"ALERGIA A MITOBRONITOL"
  },
  {
    "codigo":162669003,
    "descripcion":"CONDICIÓN DEL PACIENTE, SATISFACTORIA"
  },
  {
    "codigo":195437003,
    "descripcion":"EMBOLIA Y TROMBOSIS DE LA VENA CAVA"
  },
  {
    "codigo":719725008,
    "descripcion":"ÁCIDO NUCLEICO DE COMPLEJO DE MYCOBACTERIUM TUBERCULOSIS NO DETECTADO CON REACCIÓN EN CADENA DE POLIMERASA"
  },
  {
    "codigo":128066003,
    "descripcion":"DERIVACIÓN ESPLENORRENAL CONGÉNITA"
  },
  {
    "codigo":291906004,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR FENINDIONA"
  },
  {
    "codigo":816194006,
    "descripcion":"EDEMA DE BRAZO IZQUIERDO"
  },
  {
    "codigo":717890009,
    "descripcion":"ÚLCERA ANASTOMÓTICA DEBIDA A SÍNDROME DE ZOLLINGER-ELLISON"
  },
  {
    "codigo":193602009,
    "descripcion":"CATARATA DEBIDA A TRASTORNO OCULAR INFLAMATORIO"
  },
  {
    "codigo":95298009,
    "descripcion":"VÉRTEBRA LUMBAR SUPERNUMERARIA"
  },
  {
    "codigo":290071002,
    "descripcion":"COLORACIÓN NORMAL DE LA MAMA"
  },
  {
    "codigo":1142039007,
    "descripcion":"FASCITIS NECROSANTE NEONATAL ESTAFILOCÓCICA"
  },
  {
    "codigo":93463007,
    "descripcion":"MACRODONCIA GENERALIZADA"
  },
  {
    "codigo":339421000119105,
    "descripcion":"EXOTROPÍA MONOCULAR DE OJO IZQUIERDO"
  },
  {
    "codigo":124396005,
    "descripcion":"DEFICIENCIA DE FOSFOTRANSFERASA"
  },
  {
    "codigo":286401001,
    "descripcion":"INCAPAZ DE HABLAR CON FLUIDEZ"
  },
  {
    "codigo":24257003,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA PARED ABDOMINAL"
  },
  {
    "codigo":253633003,
    "descripcion":"ORIGEN ANÓMALO DE ARTERIA PULMONAR DERECHA EN CONDUCTO ARTERIOSO"
  },
  {
    "codigo":315499006,
    "descripcion":"NACIDO EN PAPÚA NUEVA GUINEA"
  },
  {
    "codigo":249963007,
    "descripcion":"PARPADEO EXCESIVO - INVOLUNTARIO"
  },
  {
    "codigo":706880001,
    "descripcion":"CON MAYOR RIESGO DE CONFUSIÓN"
  },
  {
    "codigo":1263936004,
    "descripcion":"MASA DE PERINEO FEMENINO"
  },
  {
    "codigo":1296704004,
    "descripcion":"HIPERTENSIÓN OCULAR BILATERAL DEBIDA A HEMORRAGIA INTRAOCULAR"
  },
  {
    "codigo":12246801000119100,
    "descripcion":"RUPTURA NO TRAUMÁTICA BILATERAL DE MANGUITO ROTADOR DE HOMBRO"
  },
  {
    "codigo":84288007,
    "descripcion":"EPIESCLERITIS TUBERCULOSA"
  },
  {
    "codigo":1231168008,
    "descripcion":"INFARTO MALIGNO DE ARTERIA CEREBRAL MEDIA"
  },
  {
    "codigo":311829000,
    "descripcion":"LESIÓN INTRACRANEAL CON COMA PROLONGADO, CON HERIDA ABIERTA"
  },
  {
    "codigo":248128009,
    "descripcion":"RECHAZA COMIDAS GRUMOSAS"
  },
  {
    "codigo":16917007,
    "descripcion":"DEFICIENCIA AGUDA DE CINC"
  },
  {
    "codigo":705045007,
    "descripcion":"DIFICULTAD PARA PARTICIPAR EN EL PLAN DE CUIDADO"
  },
  {
    "codigo":82453008,
    "descripcion":"TROMBOSIS DE ARTERIA ILÍACA"
  },
  {
    "codigo":286481000119102,
    "descripcion":"PORTADOR DE CÁNCER HEREDITARIO"
  },
  {
    "codigo":15082003,
    "descripcion":"CÁLCULO DE VÍA BILIAR CON COLECISTITIS CRÓNICA CON OBSTRUCCIÓN"
  },
  {
    "codigo":770581008,
    "descripcion":"MICROANEURISMA DE ARTERIA DE LA RETINA DERECHA DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":703210007,
    "descripcion":"INFARTO DE PARED ANTERIOR DE MIOCARDIO CON ELEVACIÓN ULTERIOR DE SEGMENTO ST"
  },
  {
    "codigo":111551000,
    "descripcion":"HIPOFUNCIÓN TESTICULAR"
  },
  {
    "codigo":277226008,
    "descripcion":"MUCOSA NASAL ULCERADA"
  },
  {
    "codigo":47850008,
    "descripcion":"CALLO DURO"
  },
  {
    "codigo":1356735003,
    "descripcion":"SÍNDROME DE NEURODESARROLLO OCULOGASTROINTESTINAL"
  },
  {
    "codigo":275391009,
    "descripcion":"EFECTO DE LA ALTURA SOBRE LOS SENOS PARANASALES"
  },
  {
    "codigo":208020002,
    "descripcion":"FRACTURA VERTEBRAL EXPUESTA CON LESIÓN COMPLETA DE MÉDULA ESPINAL CERVICAL, C 5-7"
  },
  {
    "codigo":371860003,
    "descripcion":"ARTERIAS CORONARIAS NORMALES"
  },
  {
    "codigo":109716001,
    "descripcion":"OSTEORRADIONECROSIS MANDIBULAR"
  },
  {
    "codigo":76948002,
    "descripcion":"DOLOR SEVERO"
  },
  {
    "codigo":42345000,
    "descripcion":"POLINEUROPATÍA"
  },
  {
    "codigo":11837201000119107,
    "descripcion":"CUERPO EXTRAÑO SUPERFICIAL DE CADERA IZQUIERDA CON INFECCIÓN"
  },
  {
    "codigo":271721006,
    "descripcion":"DISFUNCIÓN SIMBÓLICA"
  },
  {
    "codigo":402793008,
    "descripcion":"TRASTORNO HEREDITARIO DE LA PRODUCCIÓN DE NEUTRÓFILOS"
  },
  {
    "codigo":238953008,
    "descripcion":"XANTOMA PLANO"
  },
  {
    "codigo":1156457009,
    "descripcion":"TUMOR GLIONEURONAL PAPILAR DE CEREBRO"
  },
  {
    "codigo":400958004,
    "descripcion":"QUISTE PRIMARIO DE IRIS"
  },
  {
    "codigo":1351230006,
    "descripcion":"CONSUMO DE TABACO MATERNO REDUCIDO DURANTE EMBARAZO"
  },
  {
    "codigo":169747000,
    "descripcion":"INICIO DE LA LACTANCIA ARTIFICIAL"
  },
  {
    "codigo":48091000087100,
    "descripcion":"ÚLCERA SUPERFICIAL DE MEMBRANA MUCOSA DE INTESTINO GRUESO"
  },
  {
    "codigo":50651000087101,
    "descripcion":"DOLOR MUSCULOESQUELÉTICO CRÓNICO DEBIDO A TRASTORNO ÓSEO"
  },
  {
    "codigo":40411000087101,
    "descripcion":"CUERPO EXTRAÑO EN PABELLÓN AURICULAR IZQUIERDO"
  },
  {
    "codigo":42971000087100,
    "descripcion":"QUEMADURA DE DEDO MEÑIQUE DERECHO"
  },
  {
    "codigo":399123008,
    "descripcion":"QUISTE DE RETENCIÓN BENIGNO DE MAMA"
  },
  {
    "codigo":366355009,
    "descripcion":"COCIENTE RESPIRATORIO - HALLAZGO"
  },
  {
    "codigo":200680000,
    "descripcion":"CELULITIS Y ABSCESO DE RODILLA"
  },
  {
    "codigo":38675009,
    "descripcion":"CRIOINMUNOGLOBULINEMIA MONOCLONAL"
  },
  {
    "codigo":724968004,
    "descripcion":"LACERACIÓN DE MÚSCULO FLEXOR A LA ALTURA DEL ANTEBRAZO"
  },
  {
    "codigo":298984007,
    "descripcion":"AMPLITUD DE ADUCCIÓN ACTIVA DE ARTICULACIÓN DE MUÑECA, DISMINUIDA"
  },
  {
    "codigo":2237002,
    "descripcion":"DOLOR PLEURÍTICO"
  },
  {
    "codigo":297149007,
    "descripcion":"TROMBOSIS DE LA ARTERIA FEMORAL COMÚN"
  },
  {
    "codigo":723133009,
    "descripcion":"RABDOMIÓLISIS SECUNDARIA"
  },
  {
    "codigo":459154003,
    "descripcion":"ENDOCARDITIS INFECCIOSA DE VÁLVULA TRONCAL"
  },
  {
    "codigo":721298003,
    "descripcion":"LACERACIÓN MENOR DE BAZO"
  },
  {
    "codigo":295314007,
    "descripcion":"SOBREDOSIS DE RADIOFÁRMACO"
  },
  {
    "codigo":262546009,
    "descripcion":"LACERACIÓN SUPERFICIAL EN COLGAJO"
  },
  {
    "codigo":165299008,
    "descripcion":"MEMORIA: RECUERDA EVENTOS IMPORTANTES"
  },
  {
    "codigo":424551004,
    "descripcion":"CISTITIS BACTERIANA"
  },
  {
    "codigo":129639005,
    "descripcion":"NEUTROFILIA HEREDITARIA"
  },
  {
    "codigo":62268000,
    "descripcion":"ANEMIA HEMOLÍTICA NO ESFEROCÍTICA HEREDITARIA POR DEFICIENCIA DE DIFOSFOGLICERATO MUTASA"
  },
  {
    "codigo":1145447009,
    "descripcion":"APLASIA DE HUESO DE EXTREMIDAD"
  },
  {
    "codigo":95036002,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL SACRO"
  },
  {
    "codigo":422716006,
    "descripcion":"DIFICULTAD PARA COMPRENDER EL PAPEL DE PROVEEDOR DE SERVICIOS COMUNITARIOS"
  },
  {
    "codigo":29500006,
    "descripcion":"ESTENOSIS URETRAL SECUNDARIA A SÍFILIS"
  },
  {
    "codigo":715793003,
    "descripcion":"MIOTONÍA SENSIBLE A ACETAZOLAMIDA"
  },
  {
    "codigo":191505005,
    "descripcion":"ESTADO CONFUSIONAL AGUDO, DE ORIGEN CEREBROVASCULAR"
  },
  {
    "codigo":289809006,
    "descripcion":"MOCO CERVICAL ESPESO"
  },
  {
    "codigo":842944581000119108,
    "descripcion":"DEDO EN GARRA ADQUIRIDO DE PIE DERECHO"
  },
  {
    "codigo":224273007,
    "descripcion":"HOGAR PULCRO"
  },
  {
    "codigo":1141777009,
    "descripcion":"DISMETRÍA DE EXTREMIDAD"
  },
  {
    "codigo":124134002,
    "descripcion":"DEFICIENCIA DE GLUCOSA - 6 - FOSFATO DESHIDROGENASA"
  },
  {
    "codigo":93201009,
    "descripcion":"MASTOCITOMA MALIGNO DE GANGLIOS LINFÁTICOS INTRAPÉLVICOS"
  },
  {
    "codigo":419046003,
    "descripcion":"DISFOTOPSIA NEGATIVA"
  },
  {
    "codigo":1172710005,
    "descripcion":"ALFA-FETOPROTEÍNA EN LÍQUIDO AMNIÓTICO POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":253371000,
    "descripcion":"DEFECTO DEL TABIQUE AURICULAR A TRAVÉS DE ORIFICIO DE SENO CORONARIO"
  },
  {
    "codigo":286139003,
    "descripcion":"DIFICULTAD PARA LIMPIAR LOS ELECTRODOMÉSTICOS"
  },
  {
    "codigo":187835004,
    "descripcion":"NEOPLASIA MALIGNA DE CAVIDAD TIMPÁNICA"
  },
  {
    "codigo":448144003,
    "descripcion":"PAPILOMA DE PIEL DE CUERO CABELLUDO"
  },
  {
    "codigo":87696004,
    "descripcion":"CISTITIS HEMORRÁGICA"
  },
  {
    "codigo":54928007,
    "descripcion":"FRÉMITO POR FRICCIÓN PLEURAL"
  },
  {
    "codigo":249701000,
    "descripcion":"ARQUEAMIENTO DE COSTILLA"
  },
  {
    "codigo":284304008,
    "descripcion":"DIFICULTAD PARA REALIZAR LA PRENSIÓN CON OPOSICIÓN DEL PULGAR"
  },
  {
    "codigo":85861002,
    "descripcion":"ESQUIZOFRENIA INDIFERENCIADA SUBCRÓNICA"
  },
  {
    "codigo":184165003,
    "descripcion":"REGISTRADO EN ÁREA DE BAJOS RECURSOS"
  },
  {
    "codigo":773989002,
    "descripcion":"DEFICIENCIA AISLADA DE ACTH DE INICIO TARDÍO"
  },
  {
    "codigo":20325007,
    "descripcion":"TIÑA DE LA BARBA POR MICROSPORUM"
  },
  {
    "codigo":16017631000119108,
    "descripcion":"ALTERACIÓN DE LA ALINEACIÓN DEL ASTA ANTERIOR DEL MENISCO EXTERNO DE LA RODILLA IZQUIERDA"
  },
  {
    "codigo":444474005,
    "descripcion":"ZONA AZUL EN LA ESTIMACIÓN DE PESO PEDIÁTRICO DE BROSELOW LUTEN"
  },
  {
    "codigo":51258005,
    "descripcion":"SÍNDROME MEDULAR POSTERIOR DEBIDO A FRACTURA EXPUESTA A NIVEL DE T7 - T12"
  },
  {
    "codigo":247866008,
    "descripcion":"MIEDO A CONTRAER ENFERMEDADES"
  },
  {
    "codigo":344441000119104,
    "descripcion":"CICLITIS POSTERIOR DE AMBOS OJOS"
  },
  {
    "codigo":10830201000119104,
    "descripcion":"FRACTURA EXPUESTA DE FALANGE MEDIA DE DEDO ANULAR DERECHO"
  },
  {
    "codigo":1163535009,
    "descripcion":"ENFERMEDAD DE SISTEMA NERVIOSO CAUSADA POR ENTEROVIRUS HUMANO"
  },
  {
    "codigo":1081721000119106,
    "descripcion":"SARCOMA PRIMARIO DE PARTES BLANDAS DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":15663481000119106,
    "descripcion":"RETINOPATÍA DE PURTSCHER DE OJO DERECHO"
  },
  {
    "codigo":1290937002,
    "descripcion":"RADIOGRAFÍA PELVIMÉTRICA ANORMAL"
  },
  {
    "codigo":897721003,
    "descripcion":"RUPTURA DE CARTÍLAGO ARTICULAR DE RODILLA"
  },
  {
    "codigo":373433005,
    "descripcion":"HIPOESTESIA CORNEAL"
  },
  {
    "codigo":12985005,
    "descripcion":"TUBERCULOSIS DE LA VESÍCULA SEMINAL"
  },
  {
    "codigo":209593007,
    "descripcion":"DESGARRO COMPLETO DE COMPLEJO CUBITAL INESPECÍFICO DEL CARPO"
  },
  {
    "codigo":307897009,
    "descripcion":"ESTADO DE REGISTRO DE MOVIMIENTOS FETALES"
  },
  {
    "codigo":111289009,
    "descripcion":"FÍSTULA ARTERIOVENOSA DE VASOS PULMONARES"
  },
  {
    "codigo":43918003,
    "descripcion":"ERITROCITOSIS POR TUMOR RENAL"
  },
  {
    "codigo":240526004,
    "descripcion":"PAROTIDITIS URLIANA"
  },
  {
    "codigo":699278004,
    "descripcion":"FIBROSIS DE ESFÍNTER URETRAL EXTERNO"
  },
  {
    "codigo":109454002,
    "descripcion":"MESIODENS INVERTIDO"
  },
  {
    "codigo":371598009,
    "descripcion":"NÓDULO DE HEBERDEN"
  },
  {
    "codigo":304227003,
    "descripcion":"CUTIS CETRINO"
  },
  {
    "codigo":238691005,
    "descripcion":"PRURITO COLINÉRGICO"
  },
  {
    "codigo":369763006,
    "descripcion":"INVASIÓN MACROSCÓPICA DE GLÁNDULA SUPRARRENAL POR TUMOR RENAL"
  },
  {
    "codigo":74851005,
    "descripcion":"PATRÓN DE USO NOCIVO DE ALUCINÓGENO"
  },
  {
    "codigo":402531006,
    "descripcion":"CARCINOMA BASOCELULAR CON CAMBIOS EN LAS CÉLULAS DE LA GRANULOSA"
  },
  {
    "codigo":1187128001,
    "descripcion":"ENFERMEDAD DE CHARCOT-MARIE-TOOTH TIPO 2T"
  },
  {
    "codigo":1156195006,
    "descripcion":"INESTABILIDAD HABITACIONAL DEBIDA A RETRASO EN LOS PAGOS POR LA VIVIENDA"
  },
  {
    "codigo":1252664001,
    "descripcion":"PAREJA INCAPAZ DE CUIDAR A SUJETO"
  },
  {
    "codigo":890381000,
    "descripcion":"ECTROPIÓN CONGÉNITO BILATERAL"
  },
  {
    "codigo":169485001,
    "descripcion":"DISPOSITIVO ANTICONCEPTIVO INTRAUTERINO - CAMBIO PENDIENTE"
  },
  {
    "codigo":235021001,
    "descripcion":"QUEMADURA DE LA MUCOSA BUCAL CON SUSTANCIA QUÍMICA"
  },
  {
    "codigo":300557001,
    "descripcion":"REACCIÓN ACETO-BLANCO POSITIVA"
  },
  {
    "codigo":126899005,
    "descripcion":"NEOPLASIA DEL CUERPO DEL PENE"
  },
  {
    "codigo":726541005,
    "descripcion":"LESIÓN RENAL AGUDA DEBIDA A TRAUMATISMO"
  },
  {
    "codigo":202253006,
    "descripcion":"SUBLUXACIÓN RECURRENTE DE LA ARTICULACIÓN SUBASTRAGALINA"
  },
  {
    "codigo":5645008,
    "descripcion":"HETEROTOPÍA GLIAL NASAL"
  },
  {
    "codigo":366093009,
    "descripcion":"HALLAZGO RELACIONADO CON EL TAMAÑO DEL PABELLÓN AURICULAR"
  },
  {
    "codigo":298722003,
    "descripcion":"HALLAZGO RELACIONADO CON EL TAMAÑO DEL ESTERNÓN"
  },
  {
    "codigo":167650004,
    "descripcion":"GRÁNULOS DE ALMIDÓN FECALES: NORMALES"
  },
  {
    "codigo":823010006,
    "descripcion":"SUEÑOS PLACENTEROS"
  },
  {
    "codigo":724706006,
    "descripcion":"TRASTORNO PSICÓTICO CAUSADO POR METILENDIOXIMETANFETAMINA"
  },
  {
    "codigo":1148855006,
    "descripcion":"ANEMIA FERROPÉNICA DEBIDA A REQUERIMIENTO AUMENTADO EN LA ADOLESCENCIA"
  },
  {
    "codigo":722871007,
    "descripcion":"PANCREATITIS DEL SURCO"
  },
  {
    "codigo":34743008,
    "descripcion":"INTOXICACIÓN POR PSILOCINA"
  },
  {
    "codigo":165815009,
    "descripcion":"VIH NO DETECTADO"
  },
  {
    "codigo":296887008,
    "descripcion":"SOBREDOSIS DE OXIMETOLONA"
  },
  {
    "codigo":140004,
    "descripcion":"FARINGITIS CRÓNICA"
  },
  {
    "codigo":426124006,
    "descripcion":"LEUCEMIA MIELOIDE AGUDA CON MADURACIÓN, FAB M2, EN REMISIÓN"
  },
  {
    "codigo":63841001,
    "descripcion":"CONGESTIÓN PULMONAR CRÓNICA"
  },
  {
    "codigo":162145001,
    "descripcion":"DOLOR VULVAR"
  },
  {
    "codigo":293217001,
    "descripcion":"REACCIÓN ADVERSA A LA MEDROXIPROGESTERONA"
  },
  {
    "codigo":719201004,
    "descripcion":"DISPLASIA ESPONDILOEPIMETAFISARIA TIPO SHOHAT"
  },
  {
    "codigo":424289008,
    "descripcion":"ANISOFORIA INDUCIDA POR LENTES"
  },
  {
    "codigo":1208886003,
    "descripcion":"PARÁLISIS DE MIRADA HORIZONTAL AISLADA ADQUIRIDA"
  },
  {
    "codigo":422454005,
    "descripcion":"INCAPAZ DE UTILIZAR EL DISPOSITIVO DE COMUNICACIÓN PARA COMUNICARSE CON LOS RECURSOS COMUNITARIOS"
  },
  {
    "codigo":193078005,
    "descripcion":"SEUDOMENINGOCELE"
  },
  {
    "codigo":94774007,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE BRONQUIO"
  },
  {
    "codigo":715531000,
    "descripcion":"SÍNDROME DE APLASIA DE TIBIA Y ECTRODACTILIA"
  },
  {
    "codigo":291382008,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ALOPURINOL"
  },
  {
    "codigo":92939001,
    "descripcion":"FORMA ANORMAL CONGÉNITA DE HUESO PREESFENOIDAL"
  },
  {
    "codigo":781067001,
    "descripcion":"OVARIO POLIQUÍSTICO"
  },
  {
    "codigo":846603004,
    "descripcion":"FRAGILIDAD CAPILAR DETECTADA POR PRUEBA DE FRAGILIDAD CAPILAR"
  },
  {
    "codigo":225846006,
    "descripcion":"CONOCE ACERCA DE LA LIBERTAD DE ELECCIÓN"
  },
  {
    "codigo":289547007,
    "descripcion":"SECRECIÓN VAGINAL HEMÁTICA"
  },
  {
    "codigo":713696000,
    "descripcion":"SÍNDROME DE INSUFICIENCIA RENAL CONCOMITANTE CON INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":16894791000119107,
    "descripcion":"FIBROMA DE BOCA"
  },
  {
    "codigo":285877004,
    "descripcion":"NO USA LA COCINA"
  },
  {
    "codigo":253109005,
    "descripcion":"ENCEFALOCELE PARIETAL"
  },
  {
    "codigo":56501009,
    "descripcion":"PERICARDITIS ADHERENTE REUMÁTICA"
  },
  {
    "codigo":449717009,
    "descripcion":"CELULITIS Y ABSCESO DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":251274003,
    "descripcion":"ECG DE ESFUERZO DE RESULTADO DUDOSO"
  },
  {
    "codigo":710026006,
    "descripcion":"MORFOLOGÍA DE CRESTA ALVEOLAR MAXILAR RESIDUAL CON TEJIDO REDUNDANTE PRESENTE"
  },
  {
    "codigo":447882007,
    "descripcion":"NEOPLASIA EPITELIAL MALIGNA DE VULVA"
  },
  {
    "codigo":282207002,
    "descripcion":"DIFICULTAD PARA EMPEZAR A CAMINAR"
  },
  {
    "codigo":216671002,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR SOLVENTE DE PETRÓLEO"
  },
  {
    "codigo":413279004,
    "descripcion":"LESIÓN TUMORAL APLANADA"
  },
  {
    "codigo":85599004,
    "descripcion":"PLANTILLA GÉNICA"
  },
  {
    "codigo":314975005,
    "descripcion":"RECIDIVA LOCAL DE NEOPLASIA MALIGNA DE PIEL"
  },
  {
    "codigo":249439009,
    "descripcion":"CUERDA VOCAL AUSENTE"
  },
  {
    "codigo":773727009,
    "descripcion":"DESPRENDIMIENTO DE RETINA REGMATÓGENO AUTOSÓMICO DOMINANTE"
  },
  {
    "codigo":313140003,
    "descripcion":"ESTADIO DE MARCADOR SEROLÓGICO TUMORAL S1"
  },
  {
    "codigo":737289004,
    "descripcion":"DISPOSITIVO DE DRENAJE DE LÍQUIDO CEFALORRAQUÍDEO IN SITU"
  },
  {
    "codigo":278537006,
    "descripcion":"FRACTURA DE TIBIA DISTAL"
  },
  {
    "codigo":1163273007,
    "descripcion":"DEPÓSITO DE HOLLÍN EN TRÁQUEA"
  },
  {
    "codigo":409609008,
    "descripcion":"INFILTRADO PULMONAR EN IMAGEN RADIOLÓGICA"
  },
  {
    "codigo":276702002,
    "descripcion":"RAQUITISMO NEONATAL"
  },
  {
    "codigo":735454002,
    "descripcion":"BRONCOESPASMO ALÉRGICO CAUSADO POR SUSTANCIA ALIMENTICIA"
  },
  {
    "codigo":1259742003,
    "descripcion":"GLIOMA PRIMARIO MALIGNO DE TELENCÉFALO"
  },
  {
    "codigo":307635002,
    "descripcion":"ENFERMEDAD DE HODGKIN, ESCLEROSIS NODULAR - FASE CELULAR"
  },
  {
    "codigo":11811701000119100,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE PIEL DE REGIÓN SACRA"
  },
  {
    "codigo":345461000119101,
    "descripcion":"QUISTES BILATERALES DE GLÁNDULAS LAGRIMALES"
  },
  {
    "codigo":99701000119102,
    "descripcion":"METATARSO ADUCTO ADQUIRIDO"
  },
  {
    "codigo":12001141000119100,
    "descripcion":"HEMATOMA DEBIDO A ARTROPLASTIA DE CADERA IZQUIERDA Y POSTERIOR A ELLA"
  },
  {
    "codigo":673141000119104,
    "descripcion":"ESTENOSIS DE CONDUCTO VERTEBRAL DE REGIÓN SACRA DE COLUMNA VERTEBRAL"
  },
  {
    "codigo":240264001,
    "descripcion":"SEPARACIÓN DE TENDÓN"
  },
  {
    "codigo":319861000119106,
    "descripcion":"NÓDULO REUMATOIDE SUBCUTÁNEO DE CODO IZQUIERDO"
  },
  {
    "codigo":2421000119107,
    "descripcion":"ALUCINACIONES CONCOMITANTES CON DEMENCIA DE COMIENZO TARDÍO Y DEBIDAS A ELLA"
  },
  {
    "codigo":1090421000119108,
    "descripcion":"ÚLCERA VULVAR RECIDIVANTE POR VIRUS DEL HERPES SIMPLE"
  },
  {
    "codigo":81781000119107,
    "descripcion":"INTOLERANCIA A FÓRMULA PARA LACTANTES"
  },
  {
    "codigo":15933301000119103,
    "descripcion":"QUISTE EMBRIONARIO DE TROMPA DE FALOPIO IZQUIERDA"
  },
  {
    "codigo":678261000119102,
    "descripcion":"QUISTE DE IMPLANTACIÓN EN CÁMARA ANTERIOR DE OJO IZQUIERDO"
  },
  {
    "codigo":205661000,
    "descripcion":"TRISOMÍA MAYOR PARCIAL"
  },
  {
    "codigo":305800002,
    "descripcion":"VISTO POR SERVICIO MÉDICO"
  },
  {
    "codigo":145781000119106,
    "descripcion":"INFECCIÓN DE RIÑÓN TRASPLANTADO"
  },
  {
    "codigo":1075061000119109,
    "descripcion":"JUANETE DE SASTRE DE PIE DERECHO"
  },
  {
    "codigo":16644981000119109,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DEBIDO A OCLUSIÓN DE AMBAS ARTERIAS COMUNICANTES POSTERIORES"
  },
  {
    "codigo":11857781000119108,
    "descripcion":"RUPTURA TRAUMÁTICA DE TENDÓN DE MÚSCULO PERONEO IZQUIERDO"
  },
  {
    "codigo":9053006,
    "descripcion":"DEFENSA MUCOSA GÁSTRICA DETERIORADA"
  },
  {
    "codigo":1155933006,
    "descripcion":"POLINEUROPATÍA SIMÉTRICA DISTAL"
  },
  {
    "codigo":238429009,
    "descripcion":"TUBÉRCULO NODULAR"
  },
  {
    "codigo":433202001,
    "descripcion":"INFECCIÓN DE SITIO QUIRÚRGICO"
  },
  {
    "codigo":105522004,
    "descripcion":"MANÍAS ALIMENTARIAS"
  },
  {
    "codigo":236594004,
    "descripcion":"HIDROURÉTER OBSTRUCTIVO"
  },
  {
    "codigo":201991000,
    "descripcion":"ARTROPATÍA TRANSITORIA DE LA MANO"
  },
  {
    "codigo":1186866009,
    "descripcion":"MIOCARDIOPATÍA CAUSADA POR ACROMEGALIA"
  },
  {
    "codigo":267527002,
    "descripcion":"ANEMIA APLÁSICA FARMACÓGENA"
  },
  {
    "codigo":890119003,
    "descripcion":"MIOCARDIOPATÍA HIPERTRÓFICA DEBIDA A ATAXIA DE FRIEDREICH"
  },
  {
    "codigo":726279001,
    "descripcion":"LACERACIÓN DE PIE SIN CUERPO EXTRAÑO"
  },
  {
    "codigo":300295005,
    "descripcion":"HALLAZGO RELACIONADO CON EL ASPECTO DEL ESTÓMAGO"
  },
  {
    "codigo":3548001,
    "descripcion":"TRASTORNO DEL PLEXO BRAQUIAL"
  },
  {
    "codigo":724444003,
    "descripcion":"MEDIÓLISIS ARTERIAL SEGMENTARIA"
  },
  {
    "codigo":167388005,
    "descripcion":"NIVEL DE 17-CETOSTEROIDES EN ORINA FUERA DE RANGO DE REFERENCIA"
  },
  {
    "codigo":1279665000,
    "descripcion":"QUEMADURA DE DEDO ÍNDICE"
  },
  {
    "codigo":427697004,
    "descripcion":"NO ES POSIBLE DETERMINAR NECROSIS HISTOLÓGICA"
  },
  {
    "codigo":722609007,
    "descripcion":"LACERACIÓN DE CABEZA CON CUERPO EXTRAÑO"
  },
  {
    "codigo":1148593008,
    "descripcion":"PH DE SANGRE ARTERIAL FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":198321009,
    "descripcion":"HIPERPLASIA QUÍSTICA ENDOMETRIAL"
  },
  {
    "codigo":196486007,
    "descripcion":"SIALOADENITIS DE GLÁNDULA SUBLINGUAL"
  },
  {
    "codigo":130950008,
    "descripcion":"PERISTALTISMO URETERAL DISMINUIDO"
  },
  {
    "codigo":1144923001,
    "descripcion":"TRASTORNO INMUNOLÓGICO DEBIDO A LUPUS ERITEMATOSO SISTÉMICO"
  },
  {
    "codigo":718939006,
    "descripcion":"DISFUNCIÓN SOMÁTICA DE REGIÓN COSTOCONDRAL"
  },
  {
    "codigo":292955006,
    "descripcion":"REACCIÓN ADVERSA A LAS PENICILINAS SENSIBLES A LA PENICILINASA"
  },
  {
    "codigo":94512001,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL TABIQUE RECTOVESICAL"
  },
  {
    "codigo":30811009,
    "descripcion":"ÚLCERA DE ESÓFAGO"
  },
  {
    "codigo":28976004,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO DE REGIÓN ESCAPULAR"
  },
  {
    "codigo":127280004,
    "descripcion":"FRACTURA DE PORCIÓN BASILAR DE HUESO OCCIPITAL"
  },
  {
    "codigo":61744005,
    "descripcion":"TROMBOCITOPENIA NEONATAL POR TROMBOCITOPENIA MATERNA IDIOPÁTICA"
  },
  {
    "codigo":192816007,
    "descripcion":"ENCEFALOPATÍA POR MIXEDEMA"
  },
  {
    "codigo":225584005,
    "descripcion":"DESEO VEHEMENTE DE ELEMENTO NO ALIMENTICIO"
  },
  {
    "codigo":190981001,
    "descripcion":"DEFICIENCIA SELECTIVA DE IG G"
  },
  {
    "codigo":16543151000119106,
    "descripcion":"FRACTURA ABIERTA DE METÁFISIS DE RADIO DISTAL DERECHO"
  },
  {
    "codigo":15697481000119101,
    "descripcion":"ABSCESO DE ÓRBITA IZQUIERDA"
  },
  {
    "codigo":27141002,
    "descripcion":"ORQUIEPIDIDIMITIS CON ABSCESO"
  },
  {
    "codigo":92677005,
    "descripcion":"CARCINOMA IN SITU DE LA PLEURA PARIETAL"
  },
  {
    "codigo":289285006,
    "descripcion":"HALLAZGO RELACIONADO CON LA INTEGRIDAD DE LAS MEMBRANAS"
  },
  {
    "codigo":715269009,
    "descripcion":"INTOXICACIÓN INTENCIONAL CON DISULFIRAM"
  },
  {
    "codigo":123610002,
    "descripcion":"GLOMERULONEFRITIS CURADA"
  },
  {
    "codigo":1336026005,
    "descripcion":"MANDÍBULA HACIA ADELANTE"
  },
  {
    "codigo":449455000,
    "descripcion":"FIJACIÓN ANORMAL DE CUERDAS TENDINOSAS DE VÁLVULA TRICÚSPIDE"
  },
  {
    "codigo":416687002,
    "descripcion":"LOS \"FLASHBACKS\" HAN CESADO"
  },
  {
    "codigo":23471003,
    "descripcion":"ENVENENAMIENTO POR SAPO DEL RÍO COLORADO"
  },
  {
    "codigo":711599006,
    "descripcion":"ENTROPIÓN DE PÁRPADO INFERIOR CONCOMITANTE CON ECTROPIÓN DE PÁRPADO INFERIOR"
  },
  {
    "codigo":54404000,
    "descripcion":"RADICULOPATÍA CERVICAL"
  },
  {
    "codigo":283780007,
    "descripcion":"MORDEDURA DE PERRO LA PLANTA DEL PIE"
  },
  {
    "codigo":1363289007,
    "descripcion":"INFECCIÓN DE INJERTO-PUENTE DE ARTERIA CORONARIA"
  },
  {
    "codigo":183641008,
    "descripcion":"RECONVOCATORIA CONVENIDA"
  },
  {
    "codigo":609625009,
    "descripcion":"HALLAZGO RELACIONADO CON LA REGIÓN PÉLVICA DEL TRONCO"
  },
  {
    "codigo":249177009,
    "descripcion":"COÁGULO RETROPLACENTARIO"
  },
  {
    "codigo":351971000119103,
    "descripcion":"MELANOMA MALIGNO DE PIEL DE OREJA DERECHA"
  },
  {
    "codigo":212739001,
    "descripcion":"INTOXICACIÓN CON MERSALIL"
  },
  {
    "codigo":247342009,
    "descripcion":"SENSACIÓN DE CUERPO EXTRAÑO"
  },
  {
    "codigo":11820771000119105,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN GLENOHUMERAL DERECHA"
  },
  {
    "codigo":79832001,
    "descripcion":"ESTOMATITIS GRANULAR"
  },
  {
    "codigo":702424003,
    "descripcion":"MIOCARDIOPATÍA DILATADA 3B"
  },
  {
    "codigo":1259480003,
    "descripcion":"DEMENCIA DEBIDA A INSOMNIO FAMILIAR MORTAL"
  },
  {
    "codigo":473048005,
    "descripcion":"INFECCIÓN ASOCIADA CON IMPLANTE"
  },
  {
    "codigo":47064007,
    "descripcion":"ÚLCERA PÉPTICA AGUDA CON HEMORRAGIA Y PERFORACIÓN PERO SIN OBSTRUCCIÓN"
  },
  {
    "codigo":866264008,
    "descripcion":"ALTERACIÓN DE LA COLORACIÓN DE LA SALIVA"
  },
  {
    "codigo":241837001,
    "descripcion":"ENVENENAMIENTO POR PEPINO DE MAR"
  },
  {
    "codigo":274605005,
    "descripcion":"REFLEJO RADIAL, AUSENTE"
  },
  {
    "codigo":209069006,
    "descripcion":"SÍNDROME MEDULAR POSTERIOR DE MÉDULA CERVICAL DEBIDA A LUXACIÓN VERTEBRAL EXPUESTA DE COLUMNA CERVICAL"
  },
  {
    "codigo":733357007,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE ÓRGANO INTRATORÁCICO"
  },
  {
    "codigo":1089251000119108,
    "descripcion":"OTITIS MEDIA NO SUPURATIVA DE OÍDO MEDIO IZQUIERDO"
  },
  {
    "codigo":698754002,
    "descripcion":"PARÁLISIS CRÓNICA DEBIDA A LESIÓN DE MÉDULA ESPINAL"
  },
  {
    "codigo":403842002,
    "descripcion":"INFECCIÓN ESTREPTOCÓCICA NEONATAL"
  },
  {
    "codigo":10626002,
    "descripcion":"EXTRASÍSTOLES VENTRICULARES PREMATURAS MULTIFOCALES"
  },
  {
    "codigo":205399000,
    "descripcion":"ENARTROSIS DE TOBILLO CONGÉNITA"
  },
  {
    "codigo":762455001,
    "descripcion":"ANAFILAXIA CAUSADA POR BAJA TEMPERATURA"
  },
  {
    "codigo":371074009,
    "descripcion":"TROMBOCITOPENIA POR RADIACIÓN"
  },
  {
    "codigo":926295003,
    "descripcion":"EPÍFISIS PEQUEÑA DE FALANGE DE QUINTO DEDO DE PIE"
  },
  {
    "codigo":240002009,
    "descripcion":"BURSITIS POPLÍTEA"
  },
  {
    "codigo":305538008,
    "descripcion":"BAJO ATENCIÓN DE CIRUJANO ESPECIALISTA EN TRACTO GASTROINTESTINAL SUPERIOR"
  },
  {
    "codigo":6956001,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA ARTERIA CARÓTIDA"
  },
  {
    "codigo":203564001,
    "descripcion":"RODILLA EN VARO Y EN VALGO ADQUIRIDAS"
  },
  {
    "codigo":170796001,
    "descripcion":"COMPRENDE LA DIETA PARA REDUCCIÓN DE PESO"
  },
  {
    "codigo":1186604007,
    "descripcion":"PRUEBA DE FUNCIÓN TIROIDEA ANORMAL CAUSADA POR SUSTANCIA"
  },
  {
    "codigo":726017001,
    "descripcion":"ENFERMEDAD RENAL TUBULOINTERSTICIAL AUTOSÓMICA DOMINANTE RELACIONADA CON EL GEN DE MUCINA 1"
  },
  {
    "codigo":365569001,
    "descripcion":"TUTELA - HALLAZGO"
  },
  {
    "codigo":267265005,
    "descripcion":"INERCIA UTERINA HIPERTÓNICA"
  },
  {
    "codigo":234497007,
    "descripcion":"PÚRPURA EMBÓLICA"
  },
  {
    "codigo":298198000,
    "descripcion":"HIPERMOVILIDAD DE ARTICULACIÓN DE TOBILLO"
  },
  {
    "codigo":168961007,
    "descripcion":"ARTERIOGRAFÍA DE EXTREMIDAD SUPERIOR: ANORMAL"
  },
  {
    "codigo":68822001,
    "descripcion":"INTOXICACIÓN POR FENINDIONA"
  },
  {
    "codigo":16027671000119103,
    "descripcion":"EXOSTOSIS DE AMBAS TIBIAS"
  },
  {
    "codigo":3286006,
    "descripcion":"DETERMINACIÓN DEL ESTADO DEL PACIENTE, GRAN MEJORÍA"
  },
  {
    "codigo":66987001,
    "descripcion":"ENFISEMA LOBULAR CONGÉNITO"
  },
  {
    "codigo":427435004,
    "descripcion":"QUERATOPATÍA PUNTEADA DESPUÉS DE QUERATOPLASTIA PENETRANTE"
  },
  {
    "codigo":394667006,
    "descripcion":"SENSIBILIDAD AL MONOFILAMENTO 10G DEL PIE DERECHO ANORMAL"
  },
  {
    "codigo":198059008,
    "descripcion":"TROMBOSIS ESCROTAL"
  },
  {
    "codigo":425600006,
    "descripcion":"ANEURISMA ROTO DE ARTERIA ILÍACA INTERNA"
  },
  {
    "codigo":720512007,
    "descripcion":"SÍNDROME DE DISECCIÓN ARTERIAL Y LENTIGINOSIS"
  },
  {
    "codigo":294528009,
    "descripcion":"ALERGIA A POLIMIXINA"
  },
  {
    "codigo":292693004,
    "descripcion":"REACCIÓN ADVERSA AL BACLOFENO"
  },
  {
    "codigo":63317005,
    "descripcion":"QUISTE EXUDATIVO EN LA PORCIÓN PLANA"
  },
  {
    "codigo":389162001,
    "descripcion":"ACROCIFODISPLASIA"
  },
  {
    "codigo":127018007,
    "descripcion":"NEOPLASIA DE LA GLÁNDULA TIROIDES"
  },
  {
    "codigo":94250008,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA COLUMNA VERTEBRAL CERVICAL"
  },
  {
    "codigo":715007001,
    "descripcion":"CABALGA"
  },
  {
    "codigo":92415001,
    "descripcion":"NEOPLASIA BENIGNA DE LA GLÁNDULA SUBMAXILAR"
  },
  {
    "codigo":1237460003,
    "descripcion":"METÁSTASIS DE CARCINOMA EN COLON ASCENDENTE"
  },
  {
    "codigo":25044007,
    "descripcion":"NEUROMIELITIS ÓPTICA"
  },
  {
    "codigo":1268393000,
    "descripcion":"CARCINOMA METASTÁSICO INDIFERENCIADO DE NASOFARINGE"
  },
  {
    "codigo":328011000119101,
    "descripcion":"CUELLO UTERINO IMPERFORADO CONGÉNITO"
  },
  {
    "codigo":187049007,
    "descripcion":"HISTOPLASMA DUBOISII CON RETINITIS"
  },
  {
    "codigo":871507000,
    "descripcion":"REACCIÓN ADVERSA A PIPERACILINA Y\/O TAZOBACTAM"
  },
  {
    "codigo":19539001,
    "descripcion":"DENSIDAD DE UNA COLONIA BACTERIANA"
  },
  {
    "codigo":248915001,
    "descripcion":"ATROFIA CERVICAL"
  },
  {
    "codigo":185214008,
    "descripcion":"ATENDIDO EN VIVIENDA CUSTODIADA"
  },
  {
    "codigo":283518009,
    "descripcion":"HERIDA PUNZANTE DE DORSO DE MANO"
  },
  {
    "codigo":707667005,
    "descripcion":"OBSTRUCCIÓN DE VENA PULMONAR COMO COMPLICACIÓN DE PROCEDIMIENTO"
  },
  {
    "codigo":247080000,
    "descripcion":"DESPLAZAMIENTO DEL VÍTREO"
  },
  {
    "codigo":609363009,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE MIEMBRO SUPERIOR SIN INFECCIÓN"
  },
  {
    "codigo":83240001,
    "descripcion":"ESTADO Y DESARROLLO SEXUAL ANORMAL"
  },
  {
    "codigo":17704007,
    "descripcion":"MASTURBACIÓN"
  },
  {
    "codigo":212477006,
    "descripcion":"LESIÓN TRAUMÁTICA MUSCULAR Y TENDINOSA DE MÚSCULO EXTENSOR LARGO A NIVEL DE TOBILLO Y PIE"
  },
  {
    "codigo":81405006,
    "descripcion":"HERIDA ABIERTA DE LA EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":48637007,
    "descripcion":"SÍNDROME DE MALFORMACIÓN MÚLTIPLE CON CRECIMIENTO INICIAL EXCESIVO"
  },
  {
    "codigo":440018001,
    "descripcion":"NEFRITIS TUBULOINTERSTICIAL INDUCIDA POR METALES PESADOS"
  },
  {
    "codigo":46802002,
    "descripcion":"TOS DEL FUMADOR"
  },
  {
    "codigo":472786003,
    "descripcion":"OBSTRUCCIÓN AL TRACTO DE SALIDA DEL VENTRÍCULO DERECHO DEBIDA A CUERPO EXTRAÑO"
  },
  {
    "codigo":243410003,
    "descripcion":"TROMBOSIS DE ARTERIA MESENTÉRICA"
  },
  {
    "codigo":1193682004,
    "descripcion":"INFLAMACIÓN INTESTINAL POR ESCHERICHIA COLI ENTEROINVASIVA"
  },
  {
    "codigo":210642007,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA POR DEBAJO DE CODO"
  },
  {
    "codigo":700327003,
    "descripcion":"EDEMA DE PÁRPADO INFERIOR"
  },
  {
    "codigo":896935003,
    "descripcion":"FORMA DE BALA ANORMAL CONGÉNITA DE FALANGE DE CUARTO DEDO DE PIE"
  },
  {
    "codigo":733095006,
    "descripcion":"SÍNDROME DE DISPLASIA ESQUELÉTICA Y BRAQUIDACTILIA"
  },
  {
    "codigo":239740007,
    "descripcion":"CONTRACTURA DE TOBILLO"
  },
  {
    "codigo":403580009,
    "descripcion":"ESTIGMAS RELIGIOSOS"
  },
  {
    "codigo":11852261000119107,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE DEDO GORDO DE PIE IZQUIERDO"
  },
  {
    "codigo":75900009,
    "descripcion":"DENSIDAD DE UNA COLONIA BACTERIANA, TRANSLÚCIDA"
  },
  {
    "codigo":303441004,
    "descripcion":"INCAPAZ DE CONSTRUIR COSAS"
  },
  {
    "codigo":237905007,
    "descripcion":"HIPERFOSFATEMIA IATROGÉNICA"
  },
  {
    "codigo":1153574000,
    "descripcion":"TESTOSTERONA SÉRICA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":301606000,
    "descripcion":"CAPAZ DE SUBIR Y BAJAR ESCALERAS HACIA ATRÁS"
  },
  {
    "codigo":72230003,
    "descripcion":"CIRCUNDUCCIÓN DISMINUIDA"
  },
  {
    "codigo":39462005,
    "descripcion":"QUISTE DE CONDUCTO TIROGLOSO"
  },
  {
    "codigo":268838005,
    "descripcion":"CONJUNTIVITIS O DACRIOCISTITIS NEONATALES CAUSADAS POR ESCHERICHIA COLI"
  },
  {
    "codigo":236070005,
    "descripcion":"ESTREÑIMIENTO SIMPLE"
  },
  {
    "codigo":70395000,
    "descripcion":"ENFERMEDAD RELACIONADA CON EL AMBIENTE DOMÉSTICO"
  },
  {
    "codigo":299771000,
    "descripcion":"REACCIÓN PRIMARIA DE MARCHA PRESENTE"
  },
  {
    "codigo":365307000,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD DE REALIZAR ACTIVIDADES DE LAVADO DE ROPA"
  },
  {
    "codigo":10678911000119104,
    "descripcion":"TUMEFACCIÓN LOCALIZADA DE DEDO DE LA MANO DERECHA"
  },
  {
    "codigo":11825791000119104,
    "descripcion":"RUPTURA TRAUMÁTICA DE TENDÓN DE REGIÓN DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":234235000,
    "descripcion":"INFECCIÓN DEL GENERADOR DE DESFIBRILADOR IMPLANTADO"
  },
  {
    "codigo":201467001,
    "descripcion":"ARTRITIS Y POLIARTRITIS NEUMOCÓCICA"
  },
  {
    "codigo":4859009,
    "descripcion":"LIQUEN ESPINULOSO"
  },
  {
    "codigo":723920002,
    "descripcion":"PESO CORPORAL SIGNIFICATIVAMENTE BAJO CONCOMITANTE CON ANOREXIA NERVIOSA DE TIPO INGESTA COMPULSIVA Y PURGAS Y DEBIDO A ELLA"
  },
  {
    "codigo":232400003,
    "descripcion":"FARINGITIS AGUDA POR HERPES ZÓSTER"
  },
  {
    "codigo":396240006,
    "descripcion":"NO SE PUEDE VALORAR LA EXTENSIÓN DE LA INVASIÓN TUMORAL DEL ESTROMA"
  },
  {
    "codigo":66725002,
    "descripcion":"GLAUCOMA DEBIDO A LESIÓN PERFORANTE DE GLOBO OCULAR Y POSTERIOR A ELLA"
  },
  {
    "codigo":230565003,
    "descripcion":"NEUROPATÍA INFLAMATORIA DEL PLEXO LUMBOSACRO"
  },
  {
    "codigo":722085003,
    "descripcion":"NECROSIS PAPILAR RENAL DEBIDA A ENFERMEDAD DREPANOCÍTICA"
  },
  {
    "codigo":392570002,
    "descripcion":"TENSIÓN ARTERIAL - HALLAZGO"
  },
  {
    "codigo":425338002,
    "descripcion":"ANIMALES EN EL AMBIENTE"
  },
  {
    "codigo":294266008,
    "descripcion":"ALERGIA A NITRITO DE SODIO"
  },
  {
    "codigo":1144399000,
    "descripcion":"HIPOPLASIA CONGÉNITA DE MAMA IZQUIERDA"
  },
  {
    "codigo":1177167002,
    "descripcion":"SÍNDROME DE DISCAPACIDAD INTELECTUAL, CRISIS CONVULSIVAS, TRASTORNOS DE LA MARCHA Y DISMORFIA FACIAL"
  },
  {
    "codigo":95823003,
    "descripcion":"ACÚFENOS DE LEUDET"
  },
  {
    "codigo":292431007,
    "descripcion":"REACCIÓN ADVERSA AL PINDOLOL"
  },
  {
    "codigo":30287008,
    "descripcion":"SÍNDROME DE HIPERORNITINEMIA - HIPERAMONEMIA - HOMOCITRULINURIA"
  },
  {
    "codigo":92153000,
    "descripcion":"NEOPLASIA BENIGNA DE LOS ÓRGANOS INTRABDOMINALES"
  },
  {
    "codigo":126756008,
    "descripcion":"NEOPLASIA DE VASO SANGUÍNEO DE AXILA"
  },
  {
    "codigo":290596009,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR CLORAMBUCILO"
  },
  {
    "codigo":254158000,
    "descripcion":"ICTIOSIS VULGAR AUTOSÓMICA DOMINANTE"
  },
  {
    "codigo":24782002,
    "descripcion":"HIPERTROFIA DE LA PIEL"
  },
  {
    "codigo":88968005,
    "descripcion":"ÚLCERA DUODENAL CON PERFORACIÓN"
  },
  {
    "codigo":11854771000119103,
    "descripcion":"AMPOLLA TRAUMÁTICA DE OÍDO IZQUIERDO"
  },
  {
    "codigo":448931007,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS DE HOMBRO"
  },
  {
    "codigo":447096000,
    "descripcion":"HEMATOMA DE PARED ABDOMINAL"
  },
  {
    "codigo":874915009,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE ENCÍA"
  },
  {
    "codigo":840312002,
    "descripcion":"INFARTO AGUDO DE MIOCARDIO CON ELEVACIÓN DEL SEGMENTO ST DEBIDO A OCLUSIÓN DE PORCIÓN MEDIA DE RAMA DESCENDENTE ANTERIOR DE ARTERIA CORONARIA IZQUIERDA"
  },
  {
    "codigo":21112004,
    "descripcion":"ENFERMEDAD HEMOSTÁTICA VASCULAR"
  },
  {
    "codigo":119416008,
    "descripcion":"MALESTAR EPIGÁSTRICO"
  },
  {
    "codigo":283256009,
    "descripcion":"VIDRIO EN ESPALDA"
  },
  {
    "codigo":314189001,
    "descripcion":"OCLUSIÓN DE ARTERIA POPLÍTEA"
  },
  {
    "codigo":445261005,
    "descripcion":"HIPERLIPIDEMIA POSTRASPLANTE"
  },
  {
    "codigo":1231693006,
    "descripcion":"VITÍLIGO DE PIEL DE PÁRPADO INFERIOR"
  },
  {
    "codigo":707405009,
    "descripcion":"CARCINOMA ADENOESCAMOSO PRIMARIO DE PULMÓN"
  },
  {
    "codigo":17442002,
    "descripcion":"FÍSTULA RECTOUTERINA"
  },
  {
    "codigo":1295394004,
    "descripcion":"RADIOGRAFÍA DE PÁNCREAS NORMAL"
  },
  {
    "codigo":246818006,
    "descripcion":"MUESCA DE BORDE DE PÁRPADO"
  },
  {
    "codigo":1162487002,
    "descripcion":"DUPLICACIÓN PARCIAL DEL BRAZO CORTO DEL CROMOSOMA 16"
  },
  {
    "codigo":408823004,
    "descripcion":"ESTADO DE CRIBADO PRENATAL DE VIRUS HEPATITIS B EN SANGRE"
  },
  {
    "codigo":212215007,
    "descripcion":"LESIÓN DE LA RAÍZ DEL NERVIO DORSAL - D10"
  },
  {
    "codigo":15607007,
    "descripcion":"LINFANGITIS SUBAGUDA"
  },
  {
    "codigo":112076007,
    "descripcion":"MOTIVACIÓN EXTRÍNSECA"
  },
  {
    "codigo":308684007,
    "descripcion":"DEDO GORDO AMPUTADO"
  },
  {
    "codigo":275916009,
    "descripcion":"INYECCIÓN DE FENOTIAZINA - MONITOREO"
  },
  {
    "codigo":306849003,
    "descripcion":"OCLUSIÓN DE INJERTO-PUENTE FEMOROFEMORAL CRUZADO"
  },
  {
    "codigo":274081004,
    "descripcion":"DISENTERÍA BACILAR"
  },
  {
    "codigo":208545005,
    "descripcion":"INFECCIÓN CAUSADA POR BORRELIA CROCIDURAE"
  },
  {
    "codigo":700065003,
    "descripcion":"MIOCARDIOPATÍA HIPERTRÓFICA PRIMARIA"
  },
  {
    "codigo":11937007,
    "descripcion":"ALTERACIÓN EN EL ESTILO DE VIDA, ASOCIADA CON LA RECREACIÓN"
  },
  {
    "codigo":110241008,
    "descripcion":"CONTUSIÓN DE LA SÍNFISIS DEL CUERPO MANDIBULAR"
  },
  {
    "codigo":1255286004,
    "descripcion":"ABRASIÓN DE PIEL DE MÚLTIPLES DEDOS DE MANO"
  },
  {
    "codigo":370550005,
    "descripcion":"NÚCLEOS CARTILAGINOSOS ENDOCONDRALES RETENIDOS"
  },
  {
    "codigo":403318005,
    "descripcion":"ALOPECIA ANDROGÉNICA ASOCIADA CON OVARIOS POLIQUÍSTICOS"
  },
  {
    "codigo":15979751000119103,
    "descripcion":"DESPLAZAMIENTO DE MENISCO DE ARTICULACIÓN TEMPOROMANDIBULAR IZQUIERDA"
  },
  {
    "codigo":333031000119103,
    "descripcion":"CORIORRETINITIS DISEMINADA DE POLO POSTERIOR DERECHO"
  },
  {
    "codigo":237643007,
    "descripcion":"HIPOGLUCEMIA POR FACTOR DE CRECIMIENTO TIPO INSULÍNICO 1 ECTÓPICO"
  },
  {
    "codigo":301344003,
    "descripcion":"HALLAZGO RELACIONADO CON MEDICIONES DE LA TEMPERATURA CORPORAL"
  },
  {
    "codigo":306561000119100,
    "descripcion":"GOTA CRÓNICA DE VÉRTEBRA, SIN TOFO, CAUSADA POR FÁRMACO"
  },
  {
    "codigo":299509000,
    "descripcion":"ARTICULACIÓN MEDIOTARSIANA INESTABLE"
  },
  {
    "codigo":233973000,
    "descripcion":"ÉMBOLO DE ARTERIA FEMORAL"
  },
  {
    "codigo":365045006,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA HABLAR FLUIDAMENTE"
  },
  {
    "codigo":102901007,
    "descripcion":"RELACIÓN EMOCIONAL ABUSIVA CON EL CÓNYUGE"
  },
  {
    "codigo":397813008,
    "descripcion":"TRAUMATISMO DE LA VÍA AÉREA"
  },
  {
    "codigo":1217013009,
    "descripcion":"POSICIÓN ANÓMALA DE DERIVACIÓN EN VENTRÍCULO CEREBRAL"
  },
  {
    "codigo":166602006,
    "descripcion":"PRUEBAS DE FUNCIÓN HEPÁTICA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":264906008,
    "descripcion":"MACROADENOMA HIPOFISARIO CON EXTENSIÓN EXTRASELAR"
  },
  {
    "codigo":232138009,
    "descripcion":"ASTIGMATISMO IRREGULAR - CORNEAL"
  },
  {
    "codigo":263071008,
    "descripcion":"FRACTURA-LUXACIÓN DE COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":721823009,
    "descripcion":"ENCEFALITIS CAUSADA POR ECHINOCOCCUS GRANULOSUS"
  },
  {
    "codigo":294004002,
    "descripcion":"ALERGIA A NICARDIPINO"
  },
  {
    "codigo":295839008,
    "descripcion":"SOBREDOSIS DE AMOXAPINA"
  },
  {
    "codigo":719988004,
    "descripcion":"DISTROFIA MUSCULAR AUTOSÓMICA DOMINANTE CON DISTRIBUCIÓN EN LAS CINTURAS ESCAPULAR O PÉLVICA TIPO 1E"
  },
  {
    "codigo":228468006,
    "descripcion":"PAREJA SEXUAL CASUAL"
  },
  {
    "codigo":31860008,
    "descripcion":"PERITONITIS BACTERIANA AGUDA"
  },
  {
    "codigo":128329001,
    "descripcion":"TRASTORNO DE LA CORTEZA VISUAL"
  },
  {
    "codigo":292169005,
    "descripcion":"REACCIÓN ADVERSA A LOS ANESTÉSICOS INHALATORIOS"
  },
  {
    "codigo":95561009,
    "descripcion":"FÍSTULA BRONCOBILIAR"
  },
  {
    "codigo":357705009,
    "descripcion":"SÍNDROME DE COTARD"
  },
  {
    "codigo":716318002,
    "descripcion":"SÍNDROME DE LYNCH"
  },
  {
    "codigo":1142302004,
    "descripcion":"CEJA RALA"
  },
  {
    "codigo":12240411000119103,
    "descripcion":"CALAMBRE DE MÚSCULO DE EXTREMIDAD INFERIOR IZQUIERDA"
  },
  {
    "codigo":93726004,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL TRONCO ENCEFÁLICO"
  },
  {
    "codigo":126494007,
    "descripcion":"NEOPLASIA DE LA PIEL DE LA CEJA"
  },
  {
    "codigo":91891004,
    "descripcion":"AUSENCIA CONGÉNITA DEL ISQUION"
  },
  {
    "codigo":124659007,
    "descripcion":"DEFICIENCIA DE LACTATO RACEMASA"
  },
  {
    "codigo":1304307008,
    "descripcion":"PRUEBA DE REALIDAD INTACTA"
  },
  {
    "codigo":384968000,
    "descripcion":"MEDIASTINO AFECTADO POR PROPAGACIÓN DIRECTA DE NEOPLASIA MALIGNA"
  },
  {
    "codigo":286664004,
    "descripcion":"ANTICIPACIÓN - MECANISMO DE DEFENSA PSICOLÓGICA"
  },
  {
    "codigo":24520005,
    "descripcion":"VAGINITIS AGUDA"
  },
  {
    "codigo":712648008,
    "descripcion":"QUISTE DE EPIGLOTIS"
  },
  {
    "codigo":1204168008,
    "descripcion":"PATRÓN ELECTROCARDIOGRÁFICO DE BRUGADA"
  },
  {
    "codigo":448669004,
    "descripcion":"NEOPLASIA MALIGNA DE PARTES BLANDAS DE ÓRBITA"
  },
  {
    "codigo":710813008,
    "descripcion":"DACTILITIS DE DEDO DEL PIE"
  },
  {
    "codigo":284829009,
    "descripcion":"INCAPAZ DE SECARSE"
  },
  {
    "codigo":1003890002,
    "descripcion":"DUPLICACIÓN DE PORCIÓN PROXIMAL DEL BRAZO LARGO DEL CROMOSOMA 9"
  },
  {
    "codigo":250226006,
    "descripcion":"PRUEBA DE DREPANOFORMACIÓN NEGATIVA"
  },
  {
    "codigo":248391000,
    "descripcion":"SEPARACIÓN ORBITARIA APARENTEMENTE EXCESIVA"
  },
  {
    "codigo":1264199001,
    "descripcion":"TRASTORNO NEONATAL PRECOZ DEBIDO A ANESTESIA EPIDURAL MATERNA DURANTE TRABAJO DE PARTO"
  },
  {
    "codigo":444999002,
    "descripcion":"ARTRITIS INFECCIOSA DE TOBILLO Y\/O PIE"
  },
  {
    "codigo":1231431003,
    "descripcion":"BACILOS GRAMPOSITIVOS FILAMENTOSOS RAMIFICADOS PRESENTES"
  },
  {
    "codigo":312092000,
    "descripcion":"MOVILIDAD DENTARIA - GRADO 2"
  },
  {
    "codigo":246556002,
    "descripcion":"HALLAZGO EN EL SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":279324004,
    "descripcion":"INFECCIÓN CUTÁNEA LOCALIZADA"
  },
  {
    "codigo":443164005,
    "descripcion":"EDEMA DE PARED TORÁCICA"
  },
  {
    "codigo":1196828008,
    "descripcion":"MESENQUIMOMA BENIGNO DE DUODENO"
  },
  {
    "codigo":277489001,
    "descripcion":"TRAUMATISMO FETAL"
  },
  {
    "codigo":703473004,
    "descripcion":"PACIENTE NO APTO PARA PROCEDIMIENTO DEBIDO A AFECCIÓN PSICOLÓGICA"
  },
  {
    "codigo":408561005,
    "descripcion":"CAÍDAS PROVOCADAS POR MEDICACIÓN"
  },
  {
    "codigo":48113006,
    "descripcion":"FIEBRE HEMORRÁGICA DE OMSK"
  },
  {
    "codigo":310257006,
    "descripcion":"ANTICUERPOS ANTI - RO NO DETECTADOS"
  },
  {
    "codigo":372123001,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA PIEL DE LA CABEZA Y EL CUELLO"
  },
  {
    "codigo":208283005,
    "descripcion":"FRACTURA EXPUESTA DE PORCIÓN DISTAL DE HÚMERO, EPICÓNDILO"
  },
  {
    "codigo":109979007,
    "descripcion":"LINFOMA DE LINFOCITOS B (CLÍNICO)"
  },
  {
    "codigo":403056004,
    "descripcion":"TIÑA DEL PIE CAUSADA POR TRICHOPHYTON VIOLACEUM"
  },
  {
    "codigo":271984008,
    "descripcion":"TRASTORNO DE VÁLVULA CARDÍACA PROTÉSICA"
  },
  {
    "codigo":38938002,
    "descripcion":"HEMORRAGIA DIGESTIVA ALTA AGUDA"
  },
  {
    "codigo":1251354003,
    "descripcion":"INFECCIÓN CUTÁNEA POSTERIOR A CIRUGÍA ESTÉTICA"
  },
  {
    "codigo":170010004,
    "descripcion":"PESO DEL NIÑO ENTRE PERCENTILOS 50 Y 74"
  },
  {
    "codigo":233711002,
    "descripcion":"EDEMA PULMONAR CAUSADO POR OXÍGENO"
  },
  {
    "codigo":168175004,
    "descripcion":"PRUEBA DEL SUDOR FUERA DE RANGO DE REFERENCIA"
  },
  {
    "codigo":364783005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD DE LLEVARSE BEBIDA A LA BOCA"
  },
  {
    "codigo":299247006,
    "descripcion":"AMPLITUD DE FLEXIÓN PASIVA DE LA CADERA AUMENTADA"
  },
  {
    "codigo":231876002,
    "descripcion":"ESCLERITIS GRANULOMATOSA NO PIOGÉNICA"
  },
  {
    "codigo":428484005,
    "descripcion":"FALTA DE PROGRESO DE CAUSA ORGÁNICA"
  },
  {
    "codigo":395716005,
    "descripcion":"INVASIÓN TUMORAL DE VASOS LINFÁTICOS PEQUEÑOS, AUSENTE"
  },
  {
    "codigo":788932007,
    "descripcion":"CONTUSIÓN FOCAL DE LÓBULO PARIETAL"
  },
  {
    "codigo":68036007,
    "descripcion":"CONFIGURACIÓN DE CARBOHIDRATOS"
  },
  {
    "codigo":262809001,
    "descripcion":"CONTUSIÓN DE VESÍCULA"
  },
  {
    "codigo":721561003,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE OÍDO MEDIO"
  },
  {
    "codigo":349991000221102,
    "descripcion":"HIDROARSENICISMO CRÓNICO REGIONAL ENDÉMICO"
  },
  {
    "codigo":295577008,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE OXIBUPROCAÍNA"
  },
  {
    "codigo":64366002,
    "descripcion":"ABSCESO CORNEAL"
  },
  {
    "codigo":31598002,
    "descripcion":"ABSCESO CRÓNICO DE LA ARÉOLA"
  },
  {
    "codigo":338051000119103,
    "descripcion":"DEGENERACIÓN EN EMPEDRADO DE RETINA IZQUIERDA"
  },
  {
    "codigo":457582006,
    "descripcion":"ABSCESO DE PARED DE VENTRÍCULO DERECHO"
  },
  {
    "codigo":129902007,
    "descripcion":"HALLAZGO EN UNA INCISIÓN CUTÁNEA"
  },
  {
    "codigo":422979000,
    "descripcion":"HALLAZGO RELACIONADO CON EL COMPORTAMIENTO RELATIVO AL RÉGIMEN DE MEDICACIÓN"
  },
  {
    "codigo":195438008,
    "descripcion":"EMBOLIA Y TROMBOSIS DE LA VENA RENAL"
  },
  {
    "codigo":293742009,
    "descripcion":"ALERGIA A BUSULFANO"
  },
  {
    "codigo":95299001,
    "descripcion":"METATARSO SUPERNUMERARIO"
  },
  {
    "codigo":62531004,
    "descripcion":"PLACENTA PREVIA MARGINAL"
  },
  {
    "codigo":816195007,
    "descripcion":"EDEMA DE BRAZO DERECHO"
  },
  {
    "codigo":717891008,
    "descripcion":"ÚLCERA GÁSTRICA DEBIDA A SÍNDROME DE ZOLLINGER-ELLISON"
  },
  {
    "codigo":93464001,
    "descripcion":"GINGIVITIS MARGINAL GENERALIZADA"
  },
  {
    "codigo":128067007,
    "descripcion":"DERIVACIÓN PORTOSISTÉMICA INTRAHEPÁTICA CONGÉNITA"
  },
  {
    "codigo":716056008,
    "descripcion":"ANTÍGENO DE CRYPTOSPORIDIUM NO DETECTADO"
  },
  {
    "codigo":1142040009,
    "descripcion":"TAQUICARDIA AURICULAR DE MACRORREENTRADA NO DEPENDIENTE DE ISTMO CAVOTRICUSPÍDEO DE AURÍCULA DERECHA"
  },
  {
    "codigo":290072009,
    "descripcion":"DISCO MAMARIO PALPABLE"
  },
  {
    "codigo":417474005,
    "descripcion":"FRACTURA-LUXACIÓN NO EXPUESTA DE DEDO DE LA MANO"
  },
  {
    "codigo":286402008,
    "descripcion":"HABLA CON FLUIDEZ"
  },
  {
    "codigo":253634009,
    "descripcion":"ORIGEN ANÓMALO DE ARTERIA PULMONAR DERECHA EN AORTA ASCENDENTE"
  },
  {
    "codigo":186263000,
    "descripcion":"CORIORRETINITIS TUBERCULOSA"
  },
  {
    "codigo":12108061000119104,
    "descripcion":"QUEMADURA QUÍMICA DE LARINGE"
  },
  {
    "codigo":219031007,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR EXPECTORANTE"
  },
  {
    "codigo":776087007,
    "descripcion":"ATROFIA CEREBRAL AUTOSÓMICA RECESIVA"
  },
  {
    "codigo":249964001,
    "descripcion":"RUMIACIÓN ORAL"
  },
  {
    "codigo":315500002,
    "descripcion":"NACIDO EN PARAGUAY"
  },
  {
    "codigo":1231169000,
    "descripcion":"ANOMALÍA CONGÉNITA DE LA SEGUNDA HENDIDURA BRANQUIAL"
  },
  {
    "codigo":248129001,
    "descripcion":"RECHAZO DE COMER EN PRESENCIA DE OTROS"
  },
  {
    "codigo":706881002,
    "descripcion":"BARRERA PARA LA COMUNICACIÓN"
  },
  {
    "codigo":1296705003,
    "descripcion":"HIPERTENSIÓN OCULAR DE OJO IZQUIERDO DEBIDA A NEOVASCULARIZACIÓN"
  },
  {
    "codigo":18753005,
    "descripcion":"RESISTENCIA VASCULAR AUMENTADA"
  },
  {
    "codigo":770582001,
    "descripcion":"MICROANEURISMA DE ARTERIA DE LA RETINA IZQUIERDA DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":82454002,
    "descripcion":"ÁNTRAX DEL TABIQUE NASAL"
  },
  {
    "codigo":15958301000119109,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS METASTÁSICO DE RIÑÓN DERECHO"
  },
  {
    "codigo":311830005,
    "descripcion":"LESIÓN CARDÍACA CERRADA CON HEMOPERICARDIO"
  },
  {
    "codigo":705046008,
    "descripcion":"DÉFICIT DE SUMINISTRO DE MEDICAMENTO"
  },
  {
    "codigo":279062009,
    "descripcion":"DOLOR MIOFASCIAL"
  },
  {
    "codigo":277227004,
    "descripcion":"MUCOSA NASAL GRANULOMATOSA"
  },
  {
    "codigo":703211006,
    "descripcion":"INFARTO DE MIOCARDIO CON ELEVACIÓN ULTERIOR DE SEGMENTO ST"
  },
  {
    "codigo":1356736002,
    "descripcion":"SÍNDROME DE DISPLASIA ESPONDILOEPIFISARIA, HIPOACUSIA NEUROSENSORIAL, DISCAPACIDAD INTELECTUAL Y AMAUROSIS CONGÉNITA DE LEBER"
  },
  {
    "codigo":275392002,
    "descripcion":"TUMOR FUNGOIDE DE GANGLIO LINFÁTICO"
  },
  {
    "codigo":78784005,
    "descripcion":"AMIELIA"
  },
  {
    "codigo":16669111000119106,
    "descripcion":"FRACTURA NO EXPUESTA DE PISO DE ÓRBITA IZQUIERDA"
  },
  {
    "codigo":11413003,
    "descripcion":"LESIÓN INCOMPLETA DE LA MÉDULA ESPINAL A NIVEL DE T1 - T6 SIN LESIÓN ÓSEA"
  },
  {
    "codigo":371861004,
    "descripcion":"IRREGULARIDADES LEVES DE LA ÍNTIMA CORONARIA SIN ESTENOSIS SIGNIFICATIVAS"
  },
  {
    "codigo":109717005,
    "descripcion":"HIPERPLASIA CONDÍLEA MANDIBULAR BILATERAL"
  },
  {
    "codigo":240789006,
    "descripcion":"ESQUISTOSOMIASIS HEPATOESPLÉNICA"
  },
  {
    "codigo":11835831000119108,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA DE SEGUNDO A QUINTO DEDOS DE PIE IZQUIERDO"
  },
  {
    "codigo":402794002,
    "descripcion":"TRASTORNO HEREDITARIO EN LA FUNCIÓN DE LOS NEUTRÓFILOS"
  },
  {
    "codigo":238954002,
    "descripcion":"XANTOMA TUBEROSO"
  },
  {
    "codigo":1187391005,
    "descripcion":"NIVEL DE COMPLEMENTO POR ENCIMA DE RANGO DE REFERENCIA"
  },
  {
    "codigo":1351231005,
    "descripcion":"FUNCIÓN NORMAL DE ABCG2 (TRANSPORTADOR DE MEMBRANA DEPENDIENTE DE ATP, SUBFAMILIA G, MIEMBRO 2)"
  },
  {
    "codigo":400959007,
    "descripcion":"QUISTE SECUNDARIO DE IRIS"
  },
  {
    "codigo":7743006,
    "descripcion":"EFECTO TÓXICO DEL METILFENOL"
  },
  {
    "codigo":204351007,
    "descripcion":"TRILOGÍA DE FALLOT"
  },
  {
    "codigo":237119008,
    "descripcion":"AMENORREA RELACIONADA CON EL EJERCICIO"
  },
  {
    "codigo":366356005,
    "descripcion":"INGESTA DE COMIDA Y BEBIDA - HALLAZGO"
  },
  {
    "codigo":71444005,
    "descripcion":"TROMBOSIS DE ARTERIA CEREBRAL"
  },
  {
    "codigo":169748005,
    "descripcion":"SUSPENSIÓN DE LA LACTANCIA ARTIFICIAL"
  },
  {
    "codigo":200681001,
    "descripcion":"CELULITIS Y ABSCESO DE PIERNA"
  },
  {
    "codigo":69609002,
    "descripcion":"MIOCARDIOPATÍA NO OBSTRUCTIVA"
  },
  {
    "codigo":724969007,
    "descripcion":"LACERACIÓN DE FASCIA DE MÚSCULO FLEXOR A LA ALTURA DEL ANTEBRAZO"
  },
  {
    "codigo":298985008,
    "descripcion":"SIN AMPLITUD DE ADUCCIÓN ACTIVA DE ARTICULACIÓN DE MUÑECA"
  },
  {
    "codigo":723134003,
    "descripcion":"PRODUCCIÓN AUMENTADA DE LÍQUIDO CEFALORRAQUÍDEO"
  },
  {
    "codigo":15741521000119109,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE DEDO DE AMBOS PIES"
  },
  {
    "codigo":10963691000119103,
    "descripcion":"LACERACIÓN DE DEDO ANULAR DERECHO"
  },
  {
    "codigo":297150007,
    "descripcion":"TROMBOSIS DE LA ARTERIA ILÍACA COMÚN"
  },
  {
    "codigo":35006009,
    "descripcion":"FALLA DE INJERTO POR ENFERMEDAD RECURRENTE DEL RECEPTOR"
  },
  {
    "codigo":459155002,
    "descripcion":"ABSCESO DE ESTRUCTURA CARDIOVASCULAR DEL TRONCO"
  },
  {
    "codigo":65939004,
    "descripcion":"FRAMBESIA MUCOSA"
  },
  {
    "codigo":426387005,
    "descripcion":"DEFICIENCIA DE TRANSPORTE DE ÁCIDOS GRASOS DE CADENA LARGA"
  },
  {
    "codigo":197011006,
    "descripcion":"GASTROENTERITIS POR RADIACIÓN"
  },
  {
    "codigo":46261000087101,
    "descripcion":"FRACTURA DE FALANGE DE TERCER DEDO DE PIE DERECHO"
  },
  {
    "codigo":162408000,
    "descripcion":"DESCRIPCIÓN DE SÍNTOMA GENERAL"
  },
  {
    "codigo":295315008,
    "descripcion":"METAHEMOGLOBINEMIA ADQUIRIDA"
  },
  {
    "codigo":43701000087100,
    "descripcion":"TRASTORNO DE TENDÓN EXTENSOR DE REGIÓN DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":721299006,
    "descripcion":"LACERACIÓN MODERADA DE BAZO"
  },
  {
    "codigo":1145448004,
    "descripcion":"APLASIA DE HUESO DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":41141000087104,
    "descripcion":"CELULITIS DE SEGUNDO DEDO DE PIE DERECHO"
  },
  {
    "codigo":129640007,
    "descripcion":"GRANULOCITOPENIA BENIGNA DE LA NIÑEZ"
  },
  {
    "codigo":195176009,
    "descripcion":"HEMORRAGIA SUBDURAL INTRACRANEAL NO TRAUMÁTICA"
  },
  {
    "codigo":422717002,
    "descripcion":"ESQUEMAS PERSONALES INCONGRUENTES"
  },
  {
    "codigo":193341001,
    "descripcion":"DESGARRO RETINIANO EN HERRADURA SIN DESPRENDIMIENTO DE RETINA"
  },
  {
    "codigo":226109004,
    "descripcion":"DIETA CON MUY BAJO CONTENIDO DE GRASAS"
  },
  {
    "codigo":95037006,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE OMÓPLATO"
  },
  {
    "codigo":291645007,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR SULFAMETOXAZOL"
  },
  {
    "codigo":289810001,
    "descripcion":"HALLAZGO RELACIONADO CON LA CELULARIDAD DEL MOCO CERVICAL"
  },
  {
    "codigo":93202002,
    "descripcion":"MASTOCITOMA MALIGNO DE GANGLIOS LINFÁTICOS INTRATORÁCICOS"
  },
  {
    "codigo":224274001,
    "descripcion":"HOGAR DESASEADO"
  },
  {
    "codigo":1141778004,
    "descripcion":"DISMETRÍA DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":15934341000119103,
    "descripcion":"ACORTAMIENTO CONGÉNITO DE AMBOS TENDONES DE AQUILES"
  },
  {
    "codigo":715794009,
    "descripcion":"ENCEFALOPATÍA PROGRESIVA CON ANOREXIA INFANTIL SEVERA"
  },
  {
    "codigo":25831001,
    "descripcion":"TUBERCULOSIS DEL TABIQUE NASAL"
  },
  {
    "codigo":124135001,
    "descripcion":"DEFICIENCIA DE 3 ALFA - HIDROXIESTEROIDE DESHIDROGENASA"
  },
  {
    "codigo":1172711009,
    "descripcion":"ALTERACIÓN TRANSITORIA DE LA CONSCIENCIA"
  },
  {
    "codigo":187836003,
    "descripcion":"NEOPLASIA MALIGNA DE SENO MASTOIDEO"
  },
  {
    "codigo":817685381000119106,
    "descripcion":"TRASTORNO DE ALIMENTACIÓN PEDIÁTRICO AGUDO"
  },
  {
    "codigo":448145002,
    "descripcion":"PAPILOMA DE PIEL DE PÁRPADO INFERIOR"
  },
  {
    "codigo":708454000,
    "descripcion":"APERTURA DE MANDÍBULA LIMITADA"
  },
  {
    "codigo":184166002,
    "descripcion":"REGISTRADO EN ÁREA DE BAJOS RECURSOS - ALTO"
  },
  {
    "codigo":773990006,
    "descripcion":"ELEVACIÓN ASINTOMÁTICA AISLADA DE CREATINFOSFOCINASA"
  },
  {
    "codigo":249702007,
    "descripcion":"ROSARIO COSTAL"
  },
  {
    "codigo":84027009,
    "descripcion":"ANEMIA PERNICIOSA"
  },
  {
    "codigo":1163536005,
    "descripcion":"ANEURISMA CEREBRAL MICÓTICO POR ASPERGILLUS"
  },
  {
    "codigo":49424005,
    "descripcion":"INTOXICACIÓN POR DISULFOTONA"
  },
  {
    "codigo":849827001000119100,
    "descripcion":"ENDOMETRIOSIS PROFUNDA DE COLON SIGMOIDE"
  },
  {
    "codigo":14821001,
    "descripcion":"SITUS AMBIGUUS"
  },
  {
    "codigo":15717561000119101,
    "descripcion":"OSTEOCONDRITIS DISECANTE DE HUESO DE AMBAS MANOS"
  },
  {
    "codigo":702949005,
    "descripcion":"SÍNDROME DE DEFICIENCIA DE PROOPIOMELANOCORTINA"
  },
  {
    "codigo":111290000,
    "descripcion":"ANEURISMA DE ARTERIA CELÍACA"
  },
  {
    "codigo":209594001,
    "descripcion":"DESGARRO COMPLETO DE MENISCO CUBITOCARPIANO"
  },
  {
    "codigo":211429009,
    "descripcion":"CUERPO EXTRAÑO EN EL TALÓN"
  },
  {
    "codigo":373434004,
    "descripcion":"TRASTORNO DE VASOS SANGUÍNEOS DEL TÓRAX"
  },
  {
    "codigo":10966201000119103,
    "descripcion":"HERIDA POR ARMA BLANCA DE MUSLO IZQUIERDO"
  },
  {
    "codigo":371599001,
    "descripcion":"TRASTORNO BIPOLAR I GRAVE"
  },
  {
    "codigo":207759004,
    "descripcion":"FRACTURA NO EXPUESTA DE LA MANDÍBULA, ÁNGULO DE LA MANDÍBULA"
  },
  {
    "codigo":764815005,
    "descripcion":"PSICOLÓGICAMENTE PREPARADO PARA SOMETERSE A CIRUGÍA"
  },
  {
    "codigo":240527008,
    "descripcion":"SIALOADENITIS SUBMAXILAR POR PAROTIDITIS"
  },
  {
    "codigo":369764000,
    "descripcion":"TUMOR RENAL QUE SE EXTIENDE MACROSCÓPICAMENTE HACIA VENA MAYOR (VENA RENAL O VENA CAVA)"
  },
  {
    "codigo":11785401000119105,
    "descripcion":"ABRASIÓN DE PIEL DE DEDO DE LA MANO DERECHA"
  },
  {
    "codigo":402532004,
    "descripcion":"CARCINOMA BASOCELULAR CON CÉLULAS MONSTRUOSAS"
  },
  {
    "codigo":1156196007,
    "descripcion":"INESTABILIDAD HABITACIONAL DEBIDA A AMENAZA DE DESALOJO"
  },
  {
    "codigo":304228008,
    "descripcion":"BUEN COLOR CUTÁNEO"
  },
  {
    "codigo":1252665000,
    "descripcion":"CUIDA DE PAREJA CON ENFERMEDAD CRÓNICA"
  },
  {
    "codigo":7481002,
    "descripcion":"ATRESIA CONGÉNITA DE EPIGLOTIS"
  },
  {
    "codigo":169486000,
    "descripcion":"DISPOSITIVO ANTICONCEPTIVO INTRAUTERINO - CONTROL PENDIENTE"
  },
  {
    "codigo":366094003,
    "descripcion":"HALLAZGO RELACIONADO CON CONTENIDO DE CONDUCTO AUDITIVO"
  },
  {
    "codigo":300558006,
    "descripcion":"REACCIÓN ACETO-BLANCA NEGATIVA"
  },
  {
    "codigo":890382007,
    "descripcion":"ATRESIA DE COANAS BILATERAL"
  },
  {
    "codigo":167651000,
    "descripcion":"GRÁNULOS DE ALMIDÓN FECALES: EN EXCESO"
  },
  {
    "codigo":235022008,
    "descripcion":"QUEMADURA CON ASPIRINA DE LA MUCOSA ORAL"
  },
  {
    "codigo":724707002,
    "descripcion":"TRASTORNO DEL ESTADO DE ÁNIMO CAUSADO POR METILENDIOXIMETANFETAMINA"
  },
  {
    "codigo":69347004,
    "descripcion":"ICTERICIA NEONATAL POR CONJUGACIÓN RETARDADA POR RETRASO DE DESARROLLO DE SISTEMA DE CONJUGACIÓN"
  },
  {
    "codigo":823011005,
    "descripcion":"HERNIACIÓN QUE DESCIENDE HASTA ESCROTO"
  },
  {
    "codigo":722872000,
    "descripcion":"PANCREATITIS AUTOINMUNITARIA TIPO 1"
  },
  {
    "codigo":298723008,
    "descripcion":"ESTERNÓN PEQUEÑO"
  },
  {
    "codigo":296888003,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE OXIMETOLONA"
  },
  {
    "codigo":165816005,
    "descripcion":"VIRUS DE INMUNODEFICIENCIA HUMANA DETECTADO"
  },
  {
    "codigo":16674131000119106,
    "descripcion":"FRACTURA PATOLÓGICA DE MITAD IZQUIERDA DE MANDÍBULA"
  },
  {
    "codigo":1148856007,
    "descripcion":"ANEMIA FERROPÉNICA DEBIDA A REQUERIMIENTO AUMENTADO EN LA LACTANCIA"
  },
  {
    "codigo":262285001,
    "descripcion":"PESO DISMINUIDO"
  },
  {
    "codigo":711181000124108,
    "descripcion":"SINOVITIS CRÓNICA DEBIDA A HEMARTROSIS"
  },
  {
    "codigo":32909009,
    "descripcion":"ATROFODERMIA NEURÍTICA"
  },
  {
    "codigo":719202006,
    "descripcion":"DISPLASIA ESPONDILOEPIFISARIA TARDÍA TIPO KOHN"
  },
  {
    "codigo":293218006,
    "descripcion":"REACCIÓN ADVERSA A LOS ESTEROIDES ANABÓLICOS"
  },
  {
    "codigo":291383003,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR ALOPURINOL"
  },
  {
    "codigo":1208887007,
    "descripcion":"ENFERMEDAD SILENTE DE SUSTANCIA BLANCA POR ENFERMEDAD VASCULAR"
  },
  {
    "codigo":94775008,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA MUCOSA YUGAL"
  },
  {
    "codigo":289548002,
    "descripcion":"SECRECIÓN VAGINAL SEROSA"
  },
  {
    "codigo":191244003,
    "descripcion":"ANEMIA APLÁSICA POR ENFERMEDAD CRÓNICA"
  },
  {
    "codigo":92940004,
    "descripcion":"FORMA ANORMAL CONGÉNITA DEL PUBIS"
  },
  {
    "codigo":846604005,
    "descripcion":"OSTEOMIELITIS DE ESTERNÓN"
  },
  {
    "codigo":715532007,
    "descripcion":"SÍNDROME DE WEISMANN NETTER"
  },
  {
    "codigo":254945000,
    "descripcion":"TUMOR EMBRIONARIO DE CEREBRO"
  },
  {
    "codigo":27404009,
    "descripcion":"INFESTACIÓN CAUSADA POR TROMBICULA"
  },
  {
    "codigo":91105001,
    "descripcion":"ÚLCERA ESTERCORAL DEL ANO"
  },
  {
    "codigo":25569003,
    "descripcion":"TAQUICARDIA VENTRICULAR"
  },
  {
    "codigo":123873005,
    "descripcion":"INTOXICACIÓN POR POACEAE"
  },
  {
    "codigo":713697009,
    "descripcion":"ENFERMEDAD CAUSADA POR HERPESVIRUS HUMANO 8"
  },
  {
    "codigo":89270002,
    "descripcion":"PULSO CUBITAL ANORMAL"
  },
  {
    "codigo":449718004,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO DE SITIOS MÚLTIPLES DE BRAZO"
  },
  {
    "codigo":285878009,
    "descripcion":"DIFICULTAD PARA USAR LA COCINA"
  },
  {
    "codigo":710027002,
    "descripcion":"TOXICIDAD ASOCIADA A CITOQUINAS"
  },
  {
    "codigo":251275002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CIRCULACIÓN EXTRACORPÓREA"
  },
  {
    "codigo":447883002,
    "descripcion":"NEOPLASIA MALIGNA DE CUERPO CAROTÍDEO"
  },
  {
    "codigo":415115007,
    "descripcion":"RECUENTO PLAQUETARIO POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":413280001,
    "descripcion":"TUMOR FRONDOSO\/VELLOSO"
  },
  {
    "codigo":773728004,
    "descripcion":"DEFICIENCIA DE GLOBULINA FIJADORA DE CORTICOSTERIODES"
  },
  {
    "codigo":249440006,
    "descripcion":"CUERDA VOCAL OBLITERADA"
  },
  {
    "codigo":314976006,
    "descripcion":"RECIDIVA LOCAL DE MELANOMA MALIGNO DE PIEL"
  },
  {
    "codigo":50997000,
    "descripcion":"DIROFILARIASIS PULMONAR"
  },
  {
    "codigo":216672009,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ÉTER DE PETRÓLEO"
  },
  {
    "codigo":83765003,
    "descripcion":"ABURRIMIENTO"
  },
  {
    "codigo":18229003,
    "descripcion":"COLITIS SUPURATIVA"
  },
  {
    "codigo":313141004,
    "descripcion":"ESTADIO DE MARCADOR SEROLÓGICO TUMORAL S2"
  },
  {
    "codigo":247605007,
    "descripcion":"MEMORIA AGUDIZADA PARA EVENTOS LEJANOS"
  },
  {
    "codigo":409610003,
    "descripcion":"DENSIDAD PULMONAR AUMENTADA VISUALIZADA POR RADIOGRAFÍA"
  },
  {
    "codigo":180234006,
    "descripcion":"TRASTORNO INFECCIOSO DEL SISTEMA NERVIOSO PERIFÉRICO"
  },
  {
    "codigo":737290008,
    "descripcion":"ANASTOMOSIS INTESTINAL PRESENTE"
  },
  {
    "codigo":735455001,
    "descripcion":"ESOFAGITIS EOSINOFÍLICA CAUSADA POR ALIMENTO"
  },
  {
    "codigo":15693601000119104,
    "descripcion":"QUERATITIS DE OJO IZQUIERDO CAUSADA POR BACTERIA"
  },
  {
    "codigo":80095004,
    "descripcion":"INFECCIÓN CAUSADA POR CYATHOCEPHALUS"
  },
  {
    "codigo":276703007,
    "descripcion":"OSTEOPENIA DEL PREMATURO"
  },
  {
    "codigo":1259743008,
    "descripcion":"ASTROCITOMA PRIMARIO DE TRONCO ENCEFÁLICO"
  },
  {
    "codigo":307636001,
    "descripcion":"LINFOMA MALIGNO, LINFOCÍTICO HISTIOCÍTICO MIXTO, NODULAR"
  },
  {
    "codigo":209332004,
    "descripcion":"FRACTURA-SUBLUXACIÓN EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA DE DEDO PULGAR"
  },
  {
    "codigo":240265000,
    "descripcion":"ADHERENCIA DE LA REPARACIÓN TENDINOSA"
  },
  {
    "codigo":111028009,
    "descripcion":"ATROFIA GRANULAR ARTERIOPÁTICA DE LA CORTEZA CEREBRAL"
  },
  {
    "codigo":895625000,
    "descripcion":"FORMA TRIANGULAR ANORMAL CONGÉNITA DE FALANGE DISTAL DE MANO"
  },
  {
    "codigo":305801003,
    "descripcion":"ATENDIDO POR SERVICIO DE ALERGIA CLÍNICA"
  },
  {
    "codigo":45492009,
    "descripcion":"ESTENOSIS CONGÉNITA DE LA VENA CAVA SUPERIOR"
  },
  {
    "codigo":404105000,
    "descripcion":"PAPULOSIS LINFOMATOIDE TIPO C (TIPO LINFOMA ANAPLÁSICO DE CÉLULAS GRANDES)"
  },
  {
    "codigo":1256073006,
    "descripcion":"XANTOMA DEBIDO A HIPERLIPIDEMIA COMBINADA PRIMARIA"
  },
  {
    "codigo":402270001,
    "descripcion":"DERMATITIS IRRITATIVA DE MANOS POR CONTACTO CAUSADA POR FRICCIÓN"
  },
  {
    "codigo":238430004,
    "descripcion":"COMPLICACIÓN CUTÁNEA DE INMUNIZACIÓN CON BACILO CALMETTE-GUERIN"
  },
  {
    "codigo":205662007,
    "descripcion":"TRISOMÍA MENOR PARCIAL"
  },
  {
    "codigo":1186867000,
    "descripcion":"INFERTILIDAD MASCULINA MEDICAMENTOSA"
  },
  {
    "codigo":302131003,
    "descripcion":"TUBERCULOSIS CARDÍACA"
  },
  {
    "codigo":1075791000119100,
    "descripcion":"TENOSINOVITIS SUPURATIVA DE TENDÓN FLEXOR DE MANO DERECHA"
  },
  {
    "codigo":21071000119101,
    "descripcion":"TRASTORNO DEL ESTADO DE ÁNIMO DE TIPO MANÍACO"
  },
  {
    "codigo":433203006,
    "descripcion":"ESPASMO DEL MÚSCULO PARAESPINOSO"
  },
  {
    "codigo":123471000119103,
    "descripcion":"FIEBRE POSVACUNACIÓN"
  },
  {
    "codigo":328271000119104,
    "descripcion":"PORTADOR ASINTOMÁTICO DE ENFERMEDAD POR DEFICIENCIA HEREDITARIA DE FACTOR VIII"
  },
  {
    "codigo":105523009,
    "descripcion":"APOSTAR A JUEGOS DE AZAR"
  },
  {
    "codigo":398600002,
    "descripcion":"ERUPCIÓN CENTRÍFUGA"
  },
  {
    "codigo":338511000119107,
    "descripcion":"ATROFIA PRIMARIA DE GLÁNDULA LAGRIMAL DE OJO IZQUIERDO"
  },
  {
    "codigo":7219007,
    "descripcion":"DESPRENDIMIENTO DE RETINA POR TRACCIÓN, CON ORGANIZACIÓN VITREORRETINIANA"
  },
  {
    "codigo":10683471000119104,
    "descripcion":"MASA SUBCUTÁNEA DE CABEZA"
  },
  {
    "codigo":10665551000119107,
    "descripcion":"ÚLCERA ISQUÉMICA ATEROSCLERÓTICA DE MUSLO DERECHO"
  },
  {
    "codigo":12204111000119105,
    "descripcion":"SEPSIS DEBIDA A PROCEDIMIENTO Y POSTERIOR A ÉL"
  },
  {
    "codigo":12245071000119108,
    "descripcion":"MAL FUNCIONAMIENTO DE BATERÍA DE MARCAPASOS CARDÍACO"
  },
  {
    "codigo":348751000119104,
    "descripcion":"INFILTRADO DE CÓRNEA DE OJO IZQUIERDO POSTERIOR A QUERATOMILEUSIS IN SITU ASISTIDA CON LÁSER DE OJO IZQUIERDO"
  },
  {
    "codigo":10629711000119108,
    "descripcion":"SINUSITIS ETMOIDAL AGUDA RECURRENTE"
  },
  {
    "codigo":10757711000119106,
    "descripcion":"ENFERMEDAD TIROIDEA POSPARTO"
  },
  {
    "codigo":353871000119107,
    "descripcion":"CARCINOMA IN SITU DE PIEL DE MIEMBRO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":335951000119109,
    "descripcion":"CANALICULITIS LAGRIMAL CRÓNICA DE OJO DERECHO"
  },
  {
    "codigo":36317006,
    "descripcion":"CAPACIDAD PULMONAR TOTAL DISMINUIDA"
  },
  {
    "codigo":365832006,
    "descripcion":"FENOTIPO DE ALFA-1-ANTITRIPSINA - HALLAZGO"
  },
  {
    "codigo":201992007,
    "descripcion":"ARTROPATÍA TRANSITORIA DE LA REGIÓN PÉLVICA Y EL MUSLO"
  },
  {
    "codigo":3549009,
    "descripcion":"ATROFIA ACINAR PANCREÁTICA"
  },
  {
    "codigo":1148594002,
    "descripcion":"ARTRITIS CRÓNICA REUMÁTICA"
  },
  {
    "codigo":722610002,
    "descripcion":"HERIDA PUNZANTE DE CABEZA SIN CUERPO EXTRAÑO"
  },
  {
    "codigo":1279666004,
    "descripcion":"QUEMADURA DE DEDO MEDIO"
  },
  {
    "codigo":1714005,
    "descripcion":"FOTOQUERATITIS"
  },
  {
    "codigo":296626004,
    "descripcion":"SOBREDOSIS DE ESPECTINOMICINA"
  },
  {
    "codigo":198322002,
    "descripcion":"HIPERPLASIA ENDOMETRIAL COMPLEJA"
  },
  {
    "codigo":427698009,
    "descripcion":"SÍNDROME DE REALIMENTACIÓN"
  },
  {
    "codigo":263858009,
    "descripcion":"AGUA DE ARROZ"
  },
  {
    "codigo":196487003,
    "descripcion":"SIALOANGITIS"
  },
  {
    "codigo":1144924007,
    "descripcion":"TIMOMA TIPO B"
  },
  {
    "codigo":127281000,
    "descripcion":"FRACTURA DE CÓNDILO OCCIPITAL"
  },
  {
    "codigo":718940008,
    "descripcion":"DISFUNCIÓN SOMÁTICA DE ARTICULACIÓN COSTOVERTEBRAL"
  },
  {
    "codigo":292956007,
    "descripcion":"EFECTO ADVERSO DE PENICILINA BENETAMINA"
  },
  {
    "codigo":192817003,
    "descripcion":"DEGENERACIÓN CEREBRAL POR HIPOVITAMINOSIS B12"
  },
  {
    "codigo":225585006,
    "descripcion":"ASPIRADO GÁSTRICO - HALLAZGO"
  },
  {
    "codigo":61745006,
    "descripcion":"DIETA HIPERPROTEICA, HIPERGRASA, HIPOHIDROCARBONADA"
  },
  {
    "codigo":92678000,
    "descripcion":"CARCINOMA IN SITU DE LA GLÁNDULA PARÓTIDA"
  },
  {
    "codigo":291121009,
    "descripcion":"INTOXICACIÓN POR NEUROLÉPTICO"
  },
  {
    "codigo":94513006,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL RECTO"
  },
  {
    "codigo":289286007,
    "descripcion":"CANTIDAD DE MEMBRANAS AMNIÓTICAS - HALLAZGO"
  },
  {
    "codigo":58075000,
    "descripcion":"CONTUSIÓN DE DEDO DE PIE"
  },
  {
    "codigo":1336027001,
    "descripcion":"INMUNODEFICIENCIA COMBINADA DEBIDA A HAPLOINSUFICIENCIA DE RELA"
  },
  {
    "codigo":123611003,
    "descripcion":"PIELONEFRITIS SUBAGUDA"
  },
  {
    "codigo":449456004,
    "descripcion":"DEFECTO DEL TABIQUE AURICULOVENTRICULAR CON INSUFICIENCIA DE VÁLVULA AURICULOVENTRICULAR A TRAVÉS DE COMISURA SEPTAL IZQUIERDA"
  },
  {
    "codigo":1332357002,
    "descripcion":"BURSITIS GOTOSA DE RODILLA"
  },
  {
    "codigo":87173003,
    "descripcion":"FRACTURA EXPUESTA DE EPÍFISIS FEMORAL"
  },
  {
    "codigo":283781006,
    "descripcion":"MORDEDURA DE PERRO EN EL TALÓN"
  },
  {
    "codigo":609626005,
    "descripcion":"HALLAZGO RELACIONADO CON LA PELVIS"
  },
  {
    "codigo":1163012000,
    "descripcion":"REACCIÓN ADVERSA A HIERRO Y\/O COMPUESTO FÉRRICO"
  },
  {
    "codigo":280111008,
    "descripcion":"TRASTORNO VASCULAR DEL CUERPO CAVERNOSO DE PENE"
  },
  {
    "codigo":678281000119106,
    "descripcion":"SINEQUIAS DE IRIS DE AMBOS OJOS"
  },
  {
    "codigo":702425002,
    "descripcion":"SÍNDROME MANO-PIE-GENITAL"
  },
  {
    "codigo":473049002,
    "descripcion":"INFECCIÓN ASOCIADA CON IMPLANTE MUSCULOESQUELÉTICO"
  },
  {
    "codigo":324131000119102,
    "descripcion":"MONOARTRITIS DE PIE IZQUIERDO"
  },
  {
    "codigo":866265009,
    "descripcion":"ALTERACIÓN DE LA COLORACIÓN DE LA LENGUA"
  },
  {
    "codigo":733358002,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE SISTEMA RESPIRATORIO"
  },
  {
    "codigo":12462000,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE VÉRTEBRA"
  },
  {
    "codigo":274606006,
    "descripcion":"REFLEJO ABDOMINAL AUSENTE"
  },
  {
    "codigo":305539000,
    "descripcion":"BAJO ATENCIÓN DE CIRUJANO COLORRECTAL"
  },
  {
    "codigo":698755001,
    "descripcion":"PARÁLISIS AGUDA DEBIDA A LESIÓN DE MÉDULA ESPINAL"
  },
  {
    "codigo":240003004,
    "descripcion":"BURSITIS SUPRARROTULIANA"
  },
  {
    "codigo":371075005,
    "descripcion":"DISFUNCIÓN DE LA DERIVACIÓN ESPLENORRENAL"
  },
  {
    "codigo":403843007,
    "descripcion":"ONFALITIS ESTREPTOCÓCICA DEL RECIÉN NACIDO"
  },
  {
    "codigo":1255811009,
    "descripcion":"LINFOMA DE HODGKIN, VARIANTE CELULARIDAD MIXTA DE GANGLIOS LINFÁTICOS DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":926296002,
    "descripcion":"EPÍFISIS PEQUEÑA DE FALANGE DISTAL DE MANO"
  },
  {
    "codigo":400173004,
    "descripcion":"CARCINOMA ECRINO DE PIEL"
  },
  {
    "codigo":170797005,
    "descripcion":"HA CONSULTADO AL NUTRICIONISTA - OBESIDAD"
  },
  {
    "codigo":365570000,
    "descripcion":"CRITERIOS PARA INDEMNIZACIÓN POR LESIONES CRIMINALES - HALLAZGO"
  },
  {
    "codigo":726018006,
    "descripcion":"ENFERMEDAD RENAL TUBULOINTERSTICIAL AUTOSÓMICA DOMINANTE"
  },
  {
    "codigo":298199008,
    "descripcion":"HIPERMOVILIDAD DE ARTICULACIÓN DE PIE"
  },
  {
    "codigo":429271009,
    "descripcion":"NEUMONÍA ASOCIADA CON EL USO DE RESPIRADOR"
  },
  {
    "codigo":394668001,
    "descripcion":"SENSIBILIDAD AL MONOFILAMENTO 10G DEL PIE IZQUIERDO ANORMAL"
  },
  {
    "codigo":165292004,
    "descripcion":"MEMORIA: NO RECUERDA SU FECHA DE CUMPLEAÑOS"
  },
  {
    "codigo":296364006,
    "descripcion":"SOBREDOSIS DE ACETILCOLINA"
  },
  {
    "codigo":294529001,
    "descripcion":"ALERGIA A COLISTINA"
  },
  {
    "codigo":720513002,
    "descripcion":"SÍNDROME DE ARTROGRIPOSIS CON DISFUNCIÓN RENAL Y COLESTASIS"
  },
  {
    "codigo":786049007,
    "descripcion":"OCLUSIÓN DE RAMA DE VENA DE LA RETINA DE OJO IZQUIERDO"
  },
  {
    "codigo":11848381000119108,
    "descripcion":"HERIDA INFECTADA DE PÁRPADO IZQUIERDO DEBIDA A PICADURA DE INSECTO NO VENENOSO"
  },
  {
    "codigo":292694005,
    "descripcion":"REACCIÓN ADVERSA AL CARISOPRODOL"
  },
  {
    "codigo":423766005,
    "descripcion":"TUBO DE DRENAJE DE GLAUCOMA EN CONTACTO CON EL IRIS"
  },
  {
    "codigo":28715001,
    "descripcion":"ACÚFENOS OBJETIVO"
  },
  {
    "codigo":127019004,
    "descripcion":"NEOPLASIA DE CONDUCTO TIROGLOSO"
  },
  {
    "codigo":421931005,
    "descripcion":"DEFICIENCIA DE HORMONA DE CRECIMIENTO DE COMIENZO EN LA INFANCIA"
  },
  {
    "codigo":389163006,
    "descripcion":"CONDRODISPLASIA METAFISARIA, TIPO SEDAGHATIAN"
  },
  {
    "codigo":92416000,
    "descripcion":"NEOPLASIA BENIGNA DE LOS GANGLIOS LINFÁTICOS SUBMENTONIANOS"
  },
  {
    "codigo":289024003,
    "descripcion":"CAPAZ DE COMER CON LOS DEDOS"
  },
  {
    "codigo":680791000119106,
    "descripcion":"ATROFIA DE IRIS DE OJO IZQUIERDO"
  },
  {
    "codigo":715008006,
    "descripcion":"NO CABALGA"
  },
  {
    "codigo":1237461004,
    "descripcion":"METÁSTASIS DE ADENOCARCINOMA EN EPITELIO PIGMENTARIO DE RETINA"
  },
  {
    "codigo":254421007,
    "descripcion":"NEOPLASIA DE PLIEGUE GLOSOEPIGLÓTICO"
  },
  {
    "codigo":25045008,
    "descripcion":"PARÁLISIS DE MÉDULA ESPINAL A NIVEL MOTOR"
  },
  {
    "codigo":353111000119108,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE PELVIS RENAL IZQUIERDA"
  },
  {
    "codigo":1268394006,
    "descripcion":"CARCINOMA METASTÁSICO INDIFERENCIADO DE OVARIO"
  },
  {
    "codigo":187050007,
    "descripcion":"HISTOPLASMA DUBOISII CON PERICARDITIS"
  },
  {
    "codigo":88746009,
    "descripcion":"ORINA NEGRA"
  },
  {
    "codigo":283519001,
    "descripcion":"HERIDA PUNZANTE DE PALMA DE MANO"
  },
  {
    "codigo":707668000,
    "descripcion":"ANOMALÍA DE VENA PULMONAR COMO COMPLICACIÓN DE PROCEDIMIENTO"
  },
  {
    "codigo":185215009,
    "descripcion":"ATENDIDO EN DEPARTAMENTO SUPERVISADO POR CELADOR"
  },
  {
    "codigo":248916000,
    "descripcion":"CUELLO UTERINO GRANDE"
  },
  {
    "codigo":871508005,
    "descripcion":"ALERGIA A AMOXICILINA Y\/O ÁCIDO CLAVULÁNICO"
  },
  {
    "codigo":85076009,
    "descripcion":"PLACENTA FENESTRADA"
  },
  {
    "codigo":247081001,
    "descripcion":"DESPRENDIMIENTO VÍTREO POSTERIOR"
  },
  {
    "codigo":15727601000119108,
    "descripcion":"ARTROFITO EN ARTICULACIÓN DE AMBOS CODOS"
  },
  {
    "codigo":48638002,
    "descripcion":"NEFROCALCINOSIS"
  },
  {
    "codigo":703998005,
    "descripcion":"FRACTURA BICONDÍLEA NO EXPUESTA DE PLATILLO TIBIAL"
  },
  {
    "codigo":441854007,
    "descripcion":"REACTIVACIÓN DE CORIORRETINITIS POR TOXOPLASMOSIS"
  },
  {
    "codigo":210643002,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA A NIVEL DE LA MUÑECA"
  },
  {
    "codigo":11768971000119104,
    "descripcion":"DISTENSIÓN DE MÚSCULO DE ANTEBRAZO DERECHO"
  },
  {
    "codigo":866003005,
    "descripcion":"ACÚFENO TONAL"
  },
  {
    "codigo":79571006,
    "descripcion":"INFESTACIÓN CAUSADA POR KNEMIDOKOPTES GALLINAE"
  },
  {
    "codigo":472787007,
    "descripcion":"OBSTRUCCIÓN DE TRACTO DE SALIDA DE VENTRÍCULO IZQUIERDO DEBIDA A NEOPLASIA"
  },
  {
    "codigo":896936002,
    "descripcion":"FORMA DE BALA ANORMAL CONGÉNITA DE FALANGE DE QUINTO DEDO DE PIE"
  },
  {
    "codigo":307112004,
    "descripcion":"CON TRASLADO TEMPORARIO FUERA DEL TRABAJO"
  },
  {
    "codigo":208808006,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA EXPUESTA DE LA ARTICULACIÓN RADIOCUBITAL SUPERIOR"
  },
  {
    "codigo":733096007,
    "descripcion":"SÍNDROME TIROCEREBRORRENAL"
  },
  {
    "codigo":12200008,
    "descripcion":"DISCERNIMIENTO ALTERADO"
  },
  {
    "codigo":1290152008,
    "descripcion":"EMBARAZO ÚNICO"
  },
  {
    "codigo":700328008,
    "descripcion":"ARTROSIS DE ARTICULACIÓN ASTRAGALOESCAFOIDEA SECUNDARIA A TRAUMATISMO"
  },
  {
    "codigo":10365005,
    "descripcion":"TROMBOSIS DE TRONCO DE LA ARTERIA CORONARIA DERECHA"
  },
  {
    "codigo":239741006,
    "descripcion":"CONTRACTURA DE LA ARTICULACIÓN SUBASTRAGALINA"
  },
  {
    "codigo":403581008,
    "descripcion":"SEUDOESTIGMAS"
  },
  {
    "codigo":303442006,
    "descripcion":"CONSTRUYE COSAS"
  },
  {
    "codigo":268839002,
    "descripcion":"CONJUNTIVITIS O DACRIOCISTITIS NEONATALES CAUSADAS POR STAPHYLOCOCCUS"
  },
  {
    "codigo":399911003,
    "descripcion":"PAPULOSIS BOWENOIDE DE VULVA CON NEOPLASIA INTRAEPITELIAL VULVAR GRADO III"
  },
  {
    "codigo":1153575004,
    "descripcion":"TRASTORNO DEPRESIVO PERSISTENTE"
  },
  {
    "codigo":236071009,
    "descripcion":"DIARREA CRÓNICA"
  },
  {
    "codigo":301607009,
    "descripcion":"INCAPAZ DE SUBIR Y BAJAR ESCALERAS HACIA ATRÁS"
  },
  {
    "codigo":70396004,
    "descripcion":"HECES ACÓLICAS"
  },
  {
    "codigo":398076005,
    "descripcion":"LACERACIÓN DE RINOFARINGE"
  },
  {
    "codigo":4860004,
    "descripcion":"INFECCIÓN CAUSADA POR ASPERGILLUS NIGER"
  },
  {
    "codigo":299772007,
    "descripcion":"REACCIÓN PRIMARIA DE MARCHA AUSENTE"
  },
  {
    "codigo":365308005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD DE CLASIFICAR LA ROPA PARA LAVAR"
  },
  {
    "codigo":234236004,
    "descripcion":"FALLA DEL GENERADOR DE DESFIBRILADOR DEL MARCAPASOS"
  },
  {
    "codigo":363473003,
    "descripcion":"NEOPLASIA MALIGNA DEL TRONCO CEREBRAL"
  },
  {
    "codigo":232401004,
    "descripcion":"FARINGITIS POR MONONUCLEOSIS INFECCIOSA"
  },
  {
    "codigo":297937005,
    "descripcion":"SÍNDROME DE CUENCA ORBITARIA POSTERIOR A ENUCLEACIÓN"
  },
  {
    "codigo":722086002,
    "descripcion":"GLOMERULONEFRITIS MEMBRANOSA DEBIDA A ENFERMEDAD NEOPLÁSICA MALIGNA"
  },
  {
    "codigo":33958003,
    "descripcion":"TRASTORNO DE PENE"
  },
  {
    "codigo":296102002,
    "descripcion":"SOBREDOSIS DE MEDAZEPAM"
  },
  {
    "codigo":1344678006,
    "descripcion":"QUISTE DERMOIDE DE PÁRPADO SUPERIOR"
  },
  {
    "codigo":392571003,
    "descripcion":"HALLAZGO RELACIONADO CON LA PRESIÓN DE PULSO ARTERIAL"
  },
  {
    "codigo":425339005,
    "descripcion":"ABSTINENCIA DE BARBITÚRICO"
  },
  {
    "codigo":32123005,
    "descripcion":"SÍNDROME DE HOOFT"
  },
  {
    "codigo":292432000,
    "descripcion":"REACCIÓN ADVERSA AL CARVEDILOL"
  },
  {
    "codigo":30288003,
    "descripcion":"DEFECTO DEL TABIQUE INTERVENTRICULAR"
  },
  {
    "codigo":1144400007,
    "descripcion":"HIPOPLASIA CONGÉNITA DE MAMA DERECHA"
  },
  {
    "codigo":1177168007,
    "descripcion":"PARAPARESIA ESPÁSTICA AUTOSÓMICA RECESIVA TIPO 78"
  },
  {
    "codigo":95824009,
    "descripcion":"ACÚFENOS NERVIOSO"
  },
  {
    "codigo":93989001,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL ÁREA RETROMOLAR"
  },
  {
    "codigo":126757004,
    "descripcion":"NEOPLASIA DE VASO SANGUÍNEO DE ABDOMEN"
  },
  {
    "codigo":61221008,
    "descripcion":"CAMBIOS DE BAGGENSTOSS DEL PÁNCREAS"
  },
  {
    "codigo":714746001,
    "descripcion":"ENFERMEDAD GINGIVAL DEBIDA A INFECCIÓN BUCAL RECURRENTE POR HERPES SIMPLE"
  },
  {
    "codigo":92154006,
    "descripcion":"NEOPLASIA BENIGNA DE LAS VÍAS BILIARES INTRAHEPÁTICAS"
  },
  {
    "codigo":450767000,
    "descripcion":"ALERGIA A TRAMADOL"
  },
  {
    "codigo":254159008,
    "descripcion":"ICTIOSIS SEVERA"
  },
  {
    "codigo":55716004,
    "descripcion":"FRACTURA DE LA BASE DE HUESO METACARPIANO, EXCEPTO EL PRIMERO"
  },
  {
    "codigo":874916005,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN NARIZ"
  },
  {
    "codigo":685811000119100,
    "descripcion":"LIPOMA DE MIEMBRO"
  },
  {
    "codigo":283257000,
    "descripcion":"VIDRIO EN TÓRAX"
  },
  {
    "codigo":86649001,
    "descripcion":"NEUMONITIS POR MECONIO"
  },
  {
    "codigo":186788009,
    "descripcion":"FIEBRE Q"
  },
  {
    "codigo":53881005,
    "descripcion":"EMBARAZOS PREVIOS: 0"
  },
  {
    "codigo":840313007,
    "descripcion":"OCLUSIÓN DE PORCIÓN MEDIA DE RAMA DESCENDENTE ANTERIOR DE ARTERIA CORONARIA IZQUIERDA"
  },
  {
    "codigo":1231694000,
    "descripcion":"DESPLAZAMIENTO SUPERIOR DE GLOBO OCULAR"
  },
  {
    "codigo":248654002,
    "descripcion":"GALOPE POR TERCER RUIDO"
  },
  {
    "codigo":707406005,
    "descripcion":"CARCINOMA MUCOEPIDERMOIDE PRIMARIO DE HIPOFARINGE"
  },
  {
    "codigo":281422006,
    "descripcion":"CRITERIOS DE MUERTE DEL TRONCO ENCEFÁLICO"
  },
  {
    "codigo":84814009,
    "descripcion":"ESTRÍA GONADAL"
  },
  {
    "codigo":1295395003,
    "descripcion":"RADIOGRAFÍA DE PÁNCREAS ANORMAL"
  },
  {
    "codigo":50211006,
    "descripcion":"TRAQUEÍTIS CATARRAL"
  },
  {
    "codigo":703736001,
    "descripcion":"PSEUDOARTROSIS DE ARTICULACIÓN DEL PIE CON INFECCIÓN"
  },
  {
    "codigo":277752003,
    "descripcion":"1\/3 METRO"
  },
  {
    "codigo":48376004,
    "descripcion":"PSEUDOPORENCEFALIA CONGÉNITA"
  },
  {
    "codigo":1162488007,
    "descripcion":"DUPLICACIÓN PARCIAL DEL BRAZO LARGO DEL CROMOSOMA 16"
  },
  {
    "codigo":212216008,
    "descripcion":"LESIÓN DE LA RAÍZ DEL NERVIO DORSAL - D11"
  },
  {
    "codigo":112077003,
    "descripcion":"DESORIENTACIÓN CON RESPECTO AL ESPACIO"
  },
  {
    "codigo":79309005,
    "descripcion":"FASE LEPTOSPIRÉMICA DE LA LEPTOSPIROSIS"
  },
  {
    "codigo":331661000119102,
    "descripcion":"LAGOFTALMOS CICATRIZAL SUPERIOR DERECHO"
  },
  {
    "codigo":110242001,
    "descripcion":"CONTUSIÓN DEL BORDE ALVEOLAR DEL CUERPO MANDIBULAR"
  },
  {
    "codigo":11938002,
    "descripcion":"CLONORQUIASIS"
  },
  {
    "codigo":306850003,
    "descripcion":"OCLUSIÓN DE INJERTO-PUENTE AXILOFEMORAL"
  },
  {
    "codigo":403319002,
    "descripcion":"ALOPECIA ANDROGÉNICA POSMENOPÁUSICA"
  },
  {
    "codigo":763767006,
    "descripcion":"ERITEMA PALMAR HEREDITARIO"
  },
  {
    "codigo":1255287008,
    "descripcion":"ABRASIONES MÚLTIPLES DE PIEL DE DEDO DE MANO"
  },
  {
    "codigo":370551009,
    "descripcion":"OBSTRUCCIÓN DINÁMICA DEL TRACTO DE SALIDA DEL VENTRÍCULO DERECHO"
  },
  {
    "codigo":237644001,
    "descripcion":"HIPOGLUCEMIA POR FACTOR DE CRECIMIENTO TIPO INSULÍNICO 2 ECTÓPICO"
  },
  {
    "codigo":73804003,
    "descripcion":"REGIÓN DE HOMOLOGÍA"
  },
  {
    "codigo":41036008,
    "descripcion":"FRACTURA NO EXPUESTA DE LA APÓFISIS ESTILOIDES DEL CÚBITO"
  },
  {
    "codigo":235809001,
    "descripcion":"ESTENOSIS DE INTESTINO POSTERIOR A RADIOTERAPIA"
  },
  {
    "codigo":301345002,
    "descripcion":"DIFICULTAD PARA DORMIR"
  },
  {
    "codigo":203041005,
    "descripcion":"SÍNDROME DE INMOVILIDAD"
  },
  {
    "codigo":102902000,
    "descripcion":"RELACIÓN EMOCIONAL ABUSIVA CON EL ESPOSO"
  },
  {
    "codigo":299510005,
    "descripcion":"ARTICULACIÓN DEL PIE ESTABLE"
  },
  {
    "codigo":233974006,
    "descripcion":"ÉMBOLO DE ARTERIA HUMERAL"
  },
  {
    "codigo":365046007,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA HABLAR INTELIGIBLEMENTE"
  },
  {
    "codigo":4598005,
    "descripcion":"OSTEOMALACIA"
  },
  {
    "codigo":166603001,
    "descripcion":"PRUEBAS DE FUNCIÓN HEPÁTICA FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":232139001,
    "descripcion":"ASTIGMATISMO IRREGULAR - LENTICULAR"
  },
  {
    "codigo":70134007,
    "descripcion":"ALCALOSIS HIPOCLORÉMICA"
  },
  {
    "codigo":928000,
    "descripcion":"TRASTORNO DEL SISTEMA MUSCULOESQUELÉTICO"
  },
  {
    "codigo":787360000,
    "descripcion":"METABOLIZADOR LENTO-NORMAL DE LA FAMILIA 2 SUBFAMILIA C MIEMBRO 19 DEL CITOCROMO P450"
  },
  {
    "codigo":164768002,
    "descripcion":"PROCEDIMIENTO OTORRINOLARINGOLÓGICO ESPECIAL - NORMAL"
  },
  {
    "codigo":230304003,
    "descripcion":"COREA MEDICAMENTOSA"
  },
  {
    "codigo":263072001,
    "descripcion":"FRACTURA-LUXACIÓN DE COLUMNA VERTEBRAL LUMBAR"
  },
  {
    "codigo":721824003,
    "descripcion":"MENINGITIS CAUSADA POR TAENIA SOLIUM"
  },
  {
    "codigo":295840005,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE AMOXAPINA"
  },
  {
    "codigo":294005001,
    "descripcion":"ALERGIA A VERAPAMILO"
  },
  {
    "codigo":15679681000119101,
    "descripcion":"IRITIS DE AMBOS OJOS CAUSADA POR TREPONEMA PALLIDUM"
  },
  {
    "codigo":228469003,
    "descripcion":"RELACIÓN SEXUAL COMPROMETIDA"
  },
  {
    "codigo":31861007,
    "descripcion":"EFECTO TÓXICO DEL CLORDANO"
  },
  {
    "codigo":16908481000119102,
    "descripcion":"CARCINOMA SEBÁCEO DE PIEL DE PÁRPADO SUPERIOR DERECHO"
  },
  {
    "codigo":719989007,
    "descripcion":"DISTROFIA MUSCULAR AUTOSÓMICA DOMINANTE CON DISTRIBUCIÓN EN LAS CINTURAS ESCAPULAR O PÉLVICA TIPO 1F"
  },
  {
    "codigo":95562002,
    "descripcion":"HEMORRAGIA DEL PÁNCREAS"
  },
  {
    "codigo":161098003,
    "descripcion":"VIAJE A EUROPA"
  },
  {
    "codigo":292170006,
    "descripcion":"REACCIÓN ADVERSA AL ENFLURANO"
  },
  {
    "codigo":716319005,
    "descripcion":"ANTÍGENO DE LEGIONELLA PNEUMOPHILA SEROGRUPO 1 NO DETECTADO"
  },
  {
    "codigo":126495008,
    "descripcion":"NEOPLASIA DE LA PIEL DE LA NARIZ"
  },
  {
    "codigo":1142303009,
    "descripcion":"PORCIÓN EXTERNA DE CEJA RALA"
  },
  {
    "codigo":93727008,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL ENCÉFALO"
  },
  {
    "codigo":124660002,
    "descripcion":"DEFICIENCIA DE 3 - HIDROXIBUTIRILO - COA EPIMERASA"
  },
  {
    "codigo":386804004,
    "descripcion":"TRASTORNO MENSTRUAL"
  },
  {
    "codigo":91892006,
    "descripcion":"AUSENCIA CONGÉNITA DE HUESO LAGRIMAL"
  },
  {
    "codigo":712649000,
    "descripcion":"PROLAPSO DE EPIGLOTIS"
  },
  {
    "codigo":688321000119107,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE PIEL DE PUENTE DE LA NARIZ"
  },
  {
    "codigo":286665003,
    "descripcion":"CONVERSIÓN - MECANISMO DE DEFENSA PSICOLÓGICA"
  },
  {
    "codigo":253897003,
    "descripcion":"REFLUJO VESICOURETERORRENAL CONGÉNITO, BILATERAL"
  },
  {
    "codigo":188361007,
    "descripcion":"TUMOR MALIGNO DE TÓRAX"
  },
  {
    "codigo":384969008,
    "descripcion":"CORAZÓN AFECTADO POR PROPAGACIÓN DIRECTA DE NEOPLASIA MALIGNA"
  },
  {
    "codigo":114881000119108,
    "descripcion":"GONORREA MATERNA DURANTE EL EMBARAZO"
  },
  {
    "codigo":334171000119102,
    "descripcion":"ORZUELO INTERNO DEL PÁRPADO INFERIOR DERECHO"
  },
  {
    "codigo":448670003,
    "descripcion":"NEOPLASIA MALIGNA DE MEDIASTINO POSTERIOR"
  },
  {
    "codigo":284830004,
    "descripcion":"SE SECA"
  },
  {
    "codigo":53619000,
    "descripcion":"TRASTORNO DEL APARATO DIGESTIVO"
  },
  {
    "codigo":22686009,
    "descripcion":"HIPOVITAMINOSIS A CON QUERATOSIS FOLICULAR"
  },
  {
    "codigo":11802971000119104,
    "descripcion":"ESGUINCE DE LIGAMENTO DE ARTICULACIÓN INTERCARPIANA DE MUÑECA DERECHA"
  },
  {
    "codigo":1003891003,
    "descripcion":"DUPLICACIÓN DE PORCIÓN PROXIMAL DEL BRAZO CORTO DEL CROMOSOMA 1"
  },
  {
    "codigo":446835008,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÉDULA ESPINAL SACRA"
  },
  {
    "codigo":182856006,
    "descripcion":"FÁRMACO NO DISPONIBLE - FUERA DE STOCK"
  },
  {
    "codigo":248392007,
    "descripcion":"SEPARACIÓN ORBITARIA EXCESIVA VERDADERA"
  },
  {
    "codigo":1196829000,
    "descripcion":"MESENQUIMOMA BENIGNO DE ESÓFAGO"
  },
  {
    "codigo":707144009,
    "descripcion":"HALLAZGO RELACIONADO CON ESTADO DE DIENTE PILAR"
  },
  {
    "codigo":279325003,
    "descripcion":"CANDIDIASIS SUBMAMARIA"
  },
  {
    "codigo":49949003,
    "descripcion":"COREOATETOSIS PAROXÍSTICA"
  },
  {
    "codigo":312093005,
    "descripcion":"MOVILIDAD DENTARIA - GRADO 3"
  },
  {
    "codigo":443165006,
    "descripcion":"FRACTURA OSTEOPORÓTICA"
  },
  {
    "codigo":310258001,
    "descripcion":"ANTICUERPOS ANTI - RO DETECTADOS"
  },
  {
    "codigo":408562003,
    "descripcion":"CORREO ELECTRÓNICO ENVIADO A AGENCIA EXTERNA"
  },
  {
    "codigo":15346004,
    "descripcion":"HIPOALFALIPOPROTEINEMIA FAMILIAR"
  },
  {
    "codigo":703474005,
    "descripcion":"PACIENTE NO APTO PARA PROCEDIMIENTO DEBIDO A LA EDAD"
  },
  {
    "codigo":277490005,
    "descripcion":"HIDROPESÍA ENDOLINFÁTICA SECUNDARIA"
  },
  {
    "codigo":15954421000119103,
    "descripcion":"LESIÓN DE PEZÓN IZQUIERDO"
  },
  {
    "codigo":46279004,
    "descripcion":"INFECCIÓN CAUSADA POR LEUCOCYTOZOON"
  },
  {
    "codigo":44444001,
    "descripcion":"DEFICIENCIA LONGITUDINAL DEL CÚBITO"
  },
  {
    "codigo":208284004,
    "descripcion":"FRACTURA EXPUESTA DE PORCIÓN DISTAL DE HÚMERO, CÓNDILO"
  },
  {
    "codigo":109980005,
    "descripcion":"ENFERMEDAD INMUNOPROLIFERATIVA MALIGNA (CLÍNICO)"
  },
  {
    "codigo":11676005,
    "descripcion":"LEPTOMENINGITIS TUBERCULOSA"
  },
  {
    "codigo":372124007,
    "descripcion":"NEOPLASIA MALIGNA DE LA PIEL DE LA EXTREMIDAD INFERIOR"
  },
  {
    "codigo":697969008,
    "descripcion":"COLITIS ULCEROSA EN REMISIÓN"
  },
  {
    "codigo":271985009,
    "descripcion":"TRASTORNO DEL BALÓN DE CONTRAPULSACIÓN AÓRTICA"
  },
  {
    "codigo":204614006,
    "descripcion":"PALADAR HENDIDO COMPLETO BILATERAL CON LABIO LEPORINO"
  },
  {
    "codigo":170011000,
    "descripcion":"PESO DEL NIÑO ENTRE PERCENTILOS 75 Y 89"
  },
  {
    "codigo":302918009,
    "descripcion":"TRASTORNO DE ESTOMA"
  },
  {
    "codigo":1251355002,
    "descripcion":"HIRSUTISMO CAUSADO POR FÁRMACO"
  },
  {
    "codigo":299248001,
    "descripcion":"AMPLITUD DE FLEXIÓN PASIVA DE LA CADERA DISMINUIDA"
  },
  {
    "codigo":364784004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD DE RETENER LÍQUIDOS EN LA BOCA"
  },
  {
    "codigo":397552005,
    "descripcion":"QUERATITIS VACUNAL"
  },
  {
    "codigo":266480006,
    "descripcion":"SÍNDROME DE MALABSORCIÓN POSQUIRÚRGICO"
  },
  {
    "codigo":233712009,
    "descripcion":"EDEMA PULMONAR POR SOBRECARGA DE LÍQUIDOS"
  },
  {
    "codigo":788933002,
    "descripcion":"CONTUSIÓN FOCAL DE LÓBULO TEMPORAL"
  },
  {
    "codigo":37104009,
    "descripcion":"AGRANDAMIENTO CONGÉNITO DEL SENO CORONARIO"
  },
  {
    "codigo":395717001,
    "descripcion":"INVASIÓN TUMORAL DE VASOS LINFÁTICOS PEQUEÑOS, PRESENTE"
  },
  {
    "codigo":12241551000119107,
    "descripcion":"RUPTURA COMPLETA NO TRAUMÁTICA DE TENDÓN DE CABEZA LARGA DE BÍCEPS BRAQUIAL DE HOMBRO DERECHO"
  },
  {
    "codigo":166341003,
    "descripcion":"PRUEBA DE CAPTACIÓN DE TRIYODOTIRONINA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":197274000,
    "descripcion":"NECROSIS HEPÁTICA SUBAGUDA"
  },
  {
    "codigo":721562005,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE LESIÓN SUPERPUESTA DE RETROPERITONEO, PERITONEO Y EPIPLÓN"
  },
  {
    "codigo":262810006,
    "descripcion":"LACERACIÓN DE VESÍCULA BILIAR"
  },
  {
    "codigo":719727000,
    "descripcion":"ANTICUERPO CONTRA VIRUS DE LA INMUNODEFICIENCIA HUMANA TIPO 1 INDETERMINADO"
  },
  {
    "codigo":129903002,
    "descripcion":"PATRÓN INEFICAZ DE ALIMENTACIÓN DEL LACTANTE"
  },
  {
    "codigo":293743004,
    "descripcion":"ALERGIA A TREOSULFANO"
  },
  {
    "codigo":717892001,
    "descripcion":"ÚLCERA DUODENAL DEBIDA A SÍNDROME DE ZOLLINGER-ELLISON"
  },
  {
    "codigo":128068002,
    "descripcion":"TRASTORNO DE LA MEMBRANA MUCOSA GASTROINTESTINAL"
  },
  {
    "codigo":291908003,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ÁCIDO AMINOCAPROICO"
  },
  {
    "codigo":1073961000119106,
    "descripcion":"BURSITIS GOTOSA DE OLÉCRANON DERECHO"
  },
  {
    "codigo":816196008,
    "descripcion":"EDEMA DE AMBOS BRAZOS"
  },
  {
    "codigo":95300009,
    "descripcion":"VÉRTEBRA SACRA SUPERNUMERARIA"
  },
  {
    "codigo":93465000,
    "descripcion":"NANUKAYAMI"
  },
  {
    "codigo":290073004,
    "descripcion":"LESIÓN MAMARIA"
  },
  {
    "codigo":1142041008,
    "descripcion":"TAQUICARDIA AURICULAR DE MACRORREENTRADA NO DEPENDIENTE DE ISTMO CAVOTRICUSPÍDEO DE AURÍCULA DERECHA NO MEDIADA POR CICATRIZ"
  },
  {
    "codigo":124398006,
    "descripcion":"DEFICIENCIA DE PIROFOSFOTRANSFERASA"
  },
  {
    "codigo":286403003,
    "descripcion":"NO HABLA CON FLUIDEZ"
  },
  {
    "codigo":319171004,
    "descripcion":"ANOMALÍA GRANULOCITARIA CUALITATIVA"
  },
  {
    "codigo":253635005,
    "descripcion":"ORIGEN ANÓMALO DE LA ARTERIA PULMONAR IZQUIERDA"
  },
  {
    "codigo":146371000119104,
    "descripcion":"COMA HEPÁTICO DEBIDO A HEPATITIS C CRÓNICA"
  },
  {
    "codigo":57027007,
    "descripcion":"PERIOSTITIS DE LA REGIÓN PÉLVICA"
  },
  {
    "codigo":188099008,
    "descripcion":"NEOPLASIA MALIGNA DE PIEL DE NARIZ (EXTERNA)"
  },
  {
    "codigo":284568005,
    "descripcion":"CUERPO EXTRAÑO METÁLICO EN EL CUERO CABELLUDO"
  },
  {
    "codigo":249965000,
    "descripcion":"CONTORSIONES"
  },
  {
    "codigo":86125000,
    "descripcion":"CONTUSIÓN CEREBELOSA CON HERIDA INTRACRANEAL ABIERTA Y CONMOCIÓN"
  },
  {
    "codigo":315501003,
    "descripcion":"NACIDO EN PERÚ"
  },
  {
    "codigo":16749661000119102,
    "descripcion":"RETINOPATÍA PROLIFERATIVA DE OJO DERECHO DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":1296706002,
    "descripcion":"HIPERTENSIÓN OCULAR DE OJO DERECHO DEBIDA A NEOVASCULARIZACIÓN"
  },
  {
    "codigo":1231170004,
    "descripcion":"ANOMALÍA CONGÉNITA DE LA TERCERA HENDIDURA BRANQUIAL"
  },
  {
    "codigo":15930461000119103,
    "descripcion":"LESIÓN DE OVARIO DERECHO"
  },
  {
    "codigo":248130006,
    "descripcion":"PREOCUPACIÓN ACERCA DE LA COMIDA"
  },
  {
    "codigo":51522004,
    "descripcion":"PSEUDO-OBSTRUCCIÓN INTESTINAL SECUNDARIA"
  },
  {
    "codigo":706882009,
    "descripcion":"CRISIS HIPERTENSIVA"
  },
  {
    "codigo":279063004,
    "descripcion":"DOLOR DE ARTICULACIÓN CIGOAPOFISARIA LUMBAR"
  },
  {
    "codigo":705047004,
    "descripcion":"TEMOR A CONTAGIO"
  },
  {
    "codigo":311831009,
    "descripcion":"LESIÓN CARDÍACA ABIERTA CON HEMOPERICARDIO"
  },
  {
    "codigo":1260268001,
    "descripcion":"SÍNDROME MIELODISPLÁSICO CON ESCASOS BLASTOS"
  },
  {
    "codigo":15084002,
    "descripcion":"LUPUS ERITEMATOSO PROFUNDO"
  },
  {
    "codigo":703212004,
    "descripcion":"INFARTO AGUDO DE MIOCARDIO DURANTE PROCEDIMIENTO"
  },
  {
    "codigo":277228009,
    "descripcion":"MUCOSA NASAL HIPERÉMICA"
  },
  {
    "codigo":46017004,
    "descripcion":"ASPECTO DESARREGLADO"
  },
  {
    "codigo":275393007,
    "descripcion":"INFECCIÓN ORAL"
  },
  {
    "codigo":109718000,
    "descripcion":"HIPERPLASIA CONDÍLEA CON ASIMETRÍA MANDIBULAR"
  },
  {
    "codigo":44182001,
    "descripcion":"OSTEONECROSIS TUBERCULOSA"
  },
  {
    "codigo":240790002,
    "descripcion":"HEPATOMEGALIA ESQUISTOSÓMICA"
  },
  {
    "codigo":404630001,
    "descripcion":"CONFIGURACIÓN PLANA DEL IRIS"
  },
  {
    "codigo":208022005,
    "descripcion":"FRACTURA VERTEBRAL EXPUESTA CON LESIÓN CENTRAL DE MÉDULA ESPINAL CERVICAL, C5-7"
  },
  {
    "codigo":371862006,
    "descripcion":"DEPRESIÓN DE LA FUNCIÓN SISTÓLICA DEL VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":1076471000119103,
    "descripcion":"RUPTURA PARCIAL NO TRAUMÁTICA DE MANGUITO ROTADOR IZQUIERDO"
  },
  {
    "codigo":402795001,
    "descripcion":"DERMATOSIS NEONATAL"
  },
  {
    "codigo":238955001,
    "descripcion":"XANTOMA PLANO GENERALIZADO"
  },
  {
    "codigo":30291000175101,
    "descripcion":"ÚLCERA POR PRESIÓN EN CODO IZQUIERDO, ESTADIO III"
  },
  {
    "codigo":1287531005,
    "descripcion":"ABRASIÓN DE PIEL DE REGIÓN ANTERIOR DE CUELLO"
  },
  {
    "codigo":1156459007,
    "descripcion":"GANGLIOGLIOMA ANAPLÁSICO DEL SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":204352000,
    "descripcion":"CÚSPIDES SUPERNUMERARIAS DE VÁLVULA PULMONAR"
  },
  {
    "codigo":271723009,
    "descripcion":"AGNOSIA SENSITIVA"
  },
  {
    "codigo":237120002,
    "descripcion":"AMENORREA HIPOTALÁMICA"
  },
  {
    "codigo":1351232003,
    "descripcion":"FUNCIÓN INADECUADA DE ABCG2 (TRANSPORTADOR DE MEMBRANA DEPENDIENTE DE ATP, SUBFAMILIA G, MIEMBRO 2)"
  },
  {
    "codigo":400960002,
    "descripcion":"MANCHAS DE BRUSHFIELD"
  },
  {
    "codigo":1187392003,
    "descripcion":"NIVEL DE COMPLEMENTO DENTRO DE RANGO DE REFERENCIA"
  },
  {
    "codigo":12311000132101,
    "descripcion":"LEUCEMIA LINFOIDE AGUDA REFRACTARIA"
  },
  {
    "codigo":106048009,
    "descripcion":"HALLAZGO RELACIONADO CON EL SISTEMA RESPIRATORIO"
  },
  {
    "codigo":366357001,
    "descripcion":"INGESTA DE BEBIDA - HALLAZGO"
  },
  {
    "codigo":169749002,
    "descripcion":"DESTETE DEL LACTANTE"
  },
  {
    "codigo":200682008,
    "descripcion":"CELULITIS Y ABSCESO DE TOBILLO"
  },
  {
    "codigo":724970008,
    "descripcion":"LACERACIÓN DE TENDÓN FLEXOR A LA ALTURA DEL ANTEBRAZO"
  },
  {
    "codigo":723135002,
    "descripcion":"FRACTURA DE ESCAMA DE HUESO FRONTAL"
  },
  {
    "codigo":2239004,
    "descripcion":"EMBARAZOS PREVIOS: 6"
  },
  {
    "codigo":297151006,
    "descripcion":"TROMBOSIS DE LA ARTERIA ILÍACA EXTERNA"
  },
  {
    "codigo":459156001,
    "descripcion":"ABSCESO DE HOMOINJERTO CARDIOVASCULAR"
  },
  {
    "codigo":786836003,
    "descripcion":"ASMA CASI FATAL"
  },
  {
    "codigo":197012004,
    "descripcion":"GASTRITIS CAUSADA POR RADIACIÓN"
  },
  {
    "codigo":262548005,
    "descripcion":"HERIDA SUPERFICIAL POR AVULSIÓN"
  },
  {
    "codigo":721300003,
    "descripcion":"LACERACIÓN MAYOR DE BAZO"
  },
  {
    "codigo":11863441000119106,
    "descripcion":"CONTUSIÓN DE DEDO GORDO DEL PIE IZQUIERDO"
  },
  {
    "codigo":424553001,
    "descripcion":"GASTOS MÉDICOS SIN SEGURO"
  },
  {
    "codigo":295316009,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE RADIOFÁRMACO"
  },
  {
    "codigo":129641006,
    "descripcion":"NEUTROPENIA BENIGNA CRÓNICA DE LA NIÑEZ"
  },
  {
    "codigo":1145449007,
    "descripcion":"APLASIA DE HUESO DE CRÁNEO"
  },
  {
    "codigo":293481008,
    "descripcion":"OBESIDAD HIPERTRÓFICA-HIPERPLÁSICA"
  },
  {
    "codigo":31337009,
    "descripcion":"SÍNDROME FEMINIZANTE DE ORIGEN SUPRARRENAL"
  },
  {
    "codigo":95038001,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA ESCLERÓTICA"
  },
  {
    "codigo":783166000,
    "descripcion":"ANOCTAMINOPATÍA DISTAL"
  },
  {
    "codigo":715144004,
    "descripcion":"GLAUCOMA CAUSADO POR ACEITE DE SILICONA"
  },
  {
    "codigo":291646008,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR SULFAMETOXAZOL"
  },
  {
    "codigo":226110009,
    "descripcion":"DIETA CON MÍNIMA CANTIDAD DE GRASAS"
  },
  {
    "codigo":191507002,
    "descripcion":"DELIRIO SUBAGUDO"
  },
  {
    "codigo":289811002,
    "descripcion":"MOCO CERVICAL CELULAR"
  },
  {
    "codigo":39311000087100,
    "descripcion":"CUERPO EXTRAÑO EN DEDO PULGAR IZQUIERDO"
  },
  {
    "codigo":715795005,
    "descripcion":"ENFERMEDAD DE CHARCOT-MARIE-TOOTH TIPO 4"
  },
  {
    "codigo":44431000087101,
    "descripcion":"HERIDA PUNZANTE DE TOBILLO IZQUIERDO CON CUERPO EXTRAÑO"
  },
  {
    "codigo":46991000087100,
    "descripcion":"FRACTURA DE FALANGE MEDIA DE ANULAR DERECHO"
  },
  {
    "codigo":41871000087104,
    "descripcion":"BURSITIS DE CODO DERECHO"
  },
  {
    "codigo":124136000,
    "descripcion":"DEFICIENCIA DE 3 - BETA - HIDROXIESTEROIDE DESHIDROGENASA"
  },
  {
    "codigo":34191000087109,
    "descripcion":"MÚLTIPLES LESIONES BUCALES TRAUMÁTICAS"
  },
  {
    "codigo":58600007,
    "descripcion":"PERICARDITIS POSTPERICARDIOTOMÍA"
  },
  {
    "codigo":23997001,
    "descripcion":"ANOMALÍA DEL ARCO DENTAL"
  },
  {
    "codigo":286141002,
    "descripcion":"CAPAZ DE LIMPIAR LA OLLA PARA COCINAR"
  },
  {
    "codigo":253373002,
    "descripcion":"DEFECTO DEL TABIQUE AURICULOVENTRICULAR- COMPONENTE AURICULAR ÚNICO"
  },
  {
    "codigo":89533005,
    "descripcion":"INFECCIÓN CAUSADA POR CAPREOCAULUS"
  },
  {
    "codigo":448146001,
    "descripcion":"PAPILOMA DE PIEL DE LA INGLE"
  },
  {
    "codigo":87698003,
    "descripcion":"ATROFIA TENAR PARCIAL"
  },
  {
    "codigo":284306005,
    "descripcion":"CAPAZ DE LIBERAR LA PRENSIÓN"
  },
  {
    "codigo":251538008,
    "descripcion":"POTENCIALES SATÉLITE - HALLAZGO"
  },
  {
    "codigo":249703002,
    "descripcion":"ONDULACIONES DE LAS COSTILLAS"
  },
  {
    "codigo":85863004,
    "descripcion":"FALLA DE INJERTO DEBIDA A TROMBOSIS"
  },
  {
    "codigo":773991005,
    "descripcion":"UVEÍTIS POSTERIOR IDIOPÁTICA"
  },
  {
    "codigo":446311006,
    "descripcion":"POLIOMIELITIS BULBAR AGUDA CAUSADA POR POLIOVIRUS HUMANO 2"
  },
  {
    "codigo":1003367004,
    "descripcion":"DEFICIENCIA DE COFACTOR DE MOLIBDENO, GRUPO DE COMPLEMENTACIÓN A"
  },
  {
    "codigo":184167006,
    "descripcion":"REGISTRADO EN ÁREA DE BAJOS RECURSOS - MEDIO"
  },
  {
    "codigo":1263676006,
    "descripcion":"TRASTORNO FETAL DEBIDO A ANOMALÍA DE PARTES BLANDAS MATERNAS"
  },
  {
    "codigo":1066481000000103,
    "descripcion":"CAPAZ DE MANTENER AMISTADES"
  },
  {
    "codigo":1163537001,
    "descripcion":"MIELITIS POR LARVAS DE TAENIA SOLIUM"
  },
  {
    "codigo":14021000119107,
    "descripcion":"URETROCELE FEMENINO"
  },
  {
    "codigo":247868009,
    "descripcion":"MIEDO A CONTRAER ENFERMEDAD DE TRANSMISIÓN SEXUAL"
  },
  {
    "codigo":1240561000000108,
    "descripcion":"ENCEFALOPATÍA DEBIDA A COVID-19"
  },
  {
    "codigo":341701000119108,
    "descripcion":"CORIORRETINITIS DE OJO IZQUIERDO"
  },
  {
    "codigo":309734000,
    "descripcion":"QUISTE AMIGDALINO"
  },
  {
    "codigo":735718000,
    "descripcion":"MALABSORCIÓN NEONATAL CONCOMITANTE CON TUMOR ENDOCRINO GASTROINTESTINAL SECRETANTE DE HORMONAS Y DEBIDA A ÉL"
  },
  {
    "codigo":315231000119102,
    "descripcion":"OSTEOCONDRITIS DISECANTE DE CADERA DERECHA"
  },
  {
    "codigo":15634271000119103,
    "descripcion":"HALLAZGO MAMOGRÁFICO DE MASA DE MAMA DERECHA"
  },
  {
    "codigo":209595000,
    "descripcion":"DESGARRO COMPLETO DEL FIBROCARTÍLAGO TRIANGULAR"
  },
  {
    "codigo":111291001,
    "descripcion":"ENDARTERITIS SENIL"
  },
  {
    "codigo":373435003,
    "descripcion":"ENFERMEDAD DE BATTEY"
  },
  {
    "codigo":78523004,
    "descripcion":"EFECTO TARDÍO DE LA RADIACIÓN"
  },
  {
    "codigo":109456000,
    "descripcion":"DIENTES SUPERNUMERARIOS RELACIONADOS CON UNA ENFERMEDAD SISTÉMICA"
  },
  {
    "codigo":371600003,
    "descripcion":"TRASTORNO BIPOLAR GRAVE"
  },
  {
    "codigo":764816006,
    "descripcion":"FÍSICAMENTE PREPARADO PARA SOMETERSE A CIRUGÍA"
  },
  {
    "codigo":304229000,
    "descripcion":"PIEL CIANÓTICA"
  },
  {
    "codigo":207760009,
    "descripcion":"FRACTURA NO EXPUESTA DE MANDÍBULA: SÍNFISIS MANDIBULAR"
  },
  {
    "codigo":42085001,
    "descripcion":"VÍCTIMA DE VIOLACIÓN"
  },
  {
    "codigo":1156197003,
    "descripcion":"COMPLICACIÓN DE TRANSFERENCIA EMBRIONARIA"
  },
  {
    "codigo":369765004,
    "descripcion":"INVASIÓN MACROSCÓPICA DE TEJIDOS PERINÉFRICOS POR TUMOR RENAL"
  },
  {
    "codigo":74853008,
    "descripcion":"FIBROSIS DE LA PIEL"
  },
  {
    "codigo":238693008,
    "descripcion":"URTICARIA REFLEJA"
  },
  {
    "codigo":15689721000119102,
    "descripcion":"ARTRITIS ESTREPTOCÓCICA DE AMBAS MANOS"
  },
  {
    "codigo":402533009,
    "descripcion":"CARCINOMA BASOCELULAR CON DIFERENCIACIÓN SEBÁCEA"
  },
  {
    "codigo":1187130004,
    "descripcion":"AGENESIA DE ESCROTO"
  },
  {
    "codigo":366095002,
    "descripcion":"SENSACIONES DEL OÍDO - HALLAZGO"
  },
  {
    "codigo":300559003,
    "descripcion":"PRUEBA DE LAS AMINAS POSITIVA"
  },
  {
    "codigo":890383002,
    "descripcion":"DIVERTÍCULO CONGÉNITO DE INTESTINO GRUESO"
  },
  {
    "codigo":726543008,
    "descripcion":"SENSIBILIDAD A WARFARINA"
  },
  {
    "codigo":169487009,
    "descripcion":"DISPOSITIVO INTRAUTERINO EXPULSADO"
  },
  {
    "codigo":298724002,
    "descripcion":"ESTERNÓN CORTO"
  },
  {
    "codigo":823012003,
    "descripcion":"TUMEFACCIÓN DE MITAD IZQUIERDA DE ESCROTO"
  },
  {
    "codigo":36580002,
    "descripcion":"MORFOLOGÍA DE UNA COLONIA BACTERIANA, BORDE LOBULADO"
  },
  {
    "codigo":167652007,
    "descripcion":"LIPASA FECAL DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":724708007,
    "descripcion":"TRASTORNO DE ANSIEDAD CAUSADO POR METILENDIOXIMETANFETAMINA"
  },
  {
    "codigo":1148857003,
    "descripcion":"TRASTORNO FIBRINOLÍTICO CAUSADO POR ACTIVADOR DEL PLASMINÓGENO TISULAR"
  },
  {
    "codigo":1977004,
    "descripcion":"INTOXICACIÓN POR OXIMETOLONA"
  },
  {
    "codigo":722873005,
    "descripcion":"INSUFICIENCIA PANCREÁTICA SECUNDARIA"
  },
  {
    "codigo":296889006,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE OXIMETOLONA"
  },
  {
    "codigo":262286000,
    "descripcion":"PESO AUMENTADO"
  },
  {
    "codigo":295054001,
    "descripcion":"ALERGIA A DIGOXINA"
  },
  {
    "codigo":719203001,
    "descripcion":"DISPLASIA ESPONDILOEPIFISARIA TIPO KIMBERLEY"
  },
  {
    "codigo":293219003,
    "descripcion":"REACCIÓN ADVERSA A LA TIBOLONA"
  },
  {
    "codigo":1208888002,
    "descripcion":"PARÁLISIS MONOCULAR DE MÚSCULO ELEVADOR ADQUIRIDA"
  },
  {
    "codigo":225848007,
    "descripcion":"HABLA SOBRE SU PROBLEMA"
  },
  {
    "codigo":92941000,
    "descripcion":"FORMA ANORMAL CONGÉNITA DE VÁLVULA PULMONAR"
  },
  {
    "codigo":94776009,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL CALCÁNEO"
  },
  {
    "codigo":715533002,
    "descripcion":"SÍNDROME DE MICROCEFALIA, MICROFTALMIA, ECTRODACTILIA DE MIEMBROS INFERIORES Y PROGNATISMO"
  },
  {
    "codigo":27405005,
    "descripcion":"SÍNDROME DE APNEA DEL SUEÑO CENTRAL"
  },
  {
    "codigo":846605006,
    "descripcion":"TOXICIDAD PULMONAR MEDICAMENTOSA"
  },
  {
    "codigo":289549005,
    "descripcion":"SECRECIÓN VAGINAL ACUOSA"
  },
  {
    "codigo":1010445008,
    "descripcion":"DESCENSO DE LA MITAD IZQUIERDA DEL DIAFRAGMA"
  },
  {
    "codigo":713698004,
    "descripcion":"HIPERPLASIA REGENERATIVA NODULAR DE HÍGADO CAUSADA POR FÁRMACO ANTIRRETROVIRAL"
  },
  {
    "codigo":254946004,
    "descripcion":"TUMOR GLIAL DE MÉDULA ESPINAL"
  },
  {
    "codigo":189410006,
    "descripcion":"NEOPLASIA DE CARTÍLAGO TIROIDES DE COMPORTAMIENTO INCIERTO"
  },
  {
    "codigo":123874004,
    "descripcion":"INTOXICACIÓN POR FABÁCEAS"
  },
  {
    "codigo":253111001,
    "descripcion":"ESPINA BÍFIDA TORACOLUMBAR SIN HIDROCEFALIA - NO EXPUESTA"
  },
  {
    "codigo":23735003,
    "descripcion":"DACRIOCISTITIS NEONATAL"
  },
  {
    "codigo":449719007,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO DE SITIOS MÚLTIPLES DE PIERNA"
  },
  {
    "codigo":21900002,
    "descripcion":"TRASTORNO BIPOLAR I, EPISODIO MÁS RECIENTE DEPRESIVO CON SÍNTOMAS CATATÓNICOS"
  },
  {
    "codigo":415116008,
    "descripcion":"RECUENTO PLAQUETARIO POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":54668008,
    "descripcion":"ÚTERO BIORIFICIAL"
  },
  {
    "codigo":413281002,
    "descripcion":"TUMOR FUNGIFORME"
  },
  {
    "codigo":282209004,
    "descripcion":"CAPAZ DE DETENERSE AL CAMINAR"
  },
  {
    "codigo":249441005,
    "descripcion":"CUERDA VOCAL IRREGULAR"
  },
  {
    "codigo":52833006,
    "descripcion":"ESTADO DE HIPOSEXUALIDAD"
  },
  {
    "codigo":773729007,
    "descripcion":"MIOPATÍA LIGADA AL CROMOSOMA X CON ATROFIA MUSCULAR POSTURAL"
  },
  {
    "codigo":50998005,
    "descripcion":"QUERATITIS AREOLAR"
  },
  {
    "codigo":313142006,
    "descripcion":"ESTADIO DE MARCADOR SEROLÓGICO TUMORAL S3"
  },
  {
    "codigo":16019911000119104,
    "descripcion":"SINOVITIS TRANSITORIA DE AMBOS TOBILLOS"
  },
  {
    "codigo":737291007,
    "descripcion":"DERIVACIÓN INTESTINAL PRESENTE"
  },
  {
    "codigo":735456000,
    "descripcion":"ENFERMEDAD DE HIPERSENSIBILIDAD HEPÁTICA CAUSADA POR FÁRMACO"
  },
  {
    "codigo":276704001,
    "descripcion":"LESIÓN POR ELECTRODO EN CUERO CABELLUDO DURANTE EL PARTO"
  },
  {
    "codigo":1259744002,
    "descripcion":"GLIOBLASTOMA MULTIFORME PRIMARIO DE SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":80096003,
    "descripcion":"AUMENTO DE TAMAÑO DE ÓRBITA"
  },
  {
    "codigo":14560005,
    "descripcion":"MICOSIS DÉRMICA"
  },
  {
    "codigo":440544005,
    "descripcion":"SÍNDROME DE INTESTINO IRRITABLE CARACTERIZADO POR HÁBITO INTESTINAL ALTERNANTE"
  },
  {
    "codigo":111029001,
    "descripcion":"ACROQUERATOELASTOIDOSIS DE COSTA"
  },
  {
    "codigo":78261002,
    "descripcion":"TEMBLOR GRUESO"
  },
  {
    "codigo":307637005,
    "descripcion":"LINFOMA MALIGNO, CENTROBLÁSTICO CENTROCÍTICO, FOLICULAR"
  },
  {
    "codigo":733621007,
    "descripcion":"SÍNDROME DE TRASTORNO DEL DESARROLLO SEXUAL 46,XX CON ANOMALÍAS ESQUELÉTICAS"
  },
  {
    "codigo":10890000,
    "descripcion":"TRASTORNO DE GLÁNDULA SALIVAL"
  },
  {
    "codigo":76426001,
    "descripcion":"DIETA CALÓRICA"
  },
  {
    "codigo":699018002,
    "descripcion":"INTOXICACIÓN CAUSADA POR HEMODERIVADO"
  },
  {
    "codigo":43658003,
    "descripcion":"OBSTRUCCIÓN DE ARTERIA VERTEBRAL"
  },
  {
    "codigo":240266004,
    "descripcion":"TRASTORNO DE PRÓTESIS ARTICULAR"
  },
  {
    "codigo":895626004,
    "descripcion":"FORMA TRIANGULAR ANORMAL CONGÉNITA DE FALANGE DISTAL DE PIE"
  },
  {
    "codigo":305802005,
    "descripcion":"ATENDIDO POR SERVICIO DE CARDIOLOGÍA"
  },
  {
    "codigo":1084001000119103,
    "descripcion":"TRASTORNO DE AMBAS MASTOIDES"
  },
  {
    "codigo":238431000,
    "descripcion":"GRANULOMA POR BCG"
  },
  {
    "codigo":404106004,
    "descripcion":"PAPULOSIS LINFOMATOIDE CON ENFERMEDAD DE HODGKIN"
  },
  {
    "codigo":402271002,
    "descripcion":"DERMATITIS IRRITATIVA POR CONTACTO CAUSADA POR CLORO"
  },
  {
    "codigo":369503006,
    "descripcion":"TUMOR MALIGNO QUE COMPROMETE LA VAGINA POR PROPAGACIÓN DIRECTA DEL ÚTERO"
  },
  {
    "codigo":7220001,
    "descripcion":"INTOXICACIÓN POR URGINEA MARITIMA"
  },
  {
    "codigo":236596002,
    "descripcion":"DILATACIÓN IDIOPÁTICA DE URÉTER"
  },
  {
    "codigo":105524003,
    "descripcion":"ALTERACIÓN EN EL ESTILO DE VIDA, ASOCIADA CON LA ACTIVIDAD DE VIAJAR"
  },
  {
    "codigo":1186868005,
    "descripcion":"ENCEFALOPATÍA POR MONÓXIDO DE CARBONO"
  },
  {
    "codigo":365833001,
    "descripcion":"FENOTIPO E DE APOLIPOPROTEÍNA"
  },
  {
    "codigo":300297002,
    "descripcion":"MASA EN EL ESTÓMAGO"
  },
  {
    "codigo":346721000119108,
    "descripcion":"CATARATA CONGÉNITA DE AMBOS OJOS"
  },
  {
    "codigo":890121008,
    "descripcion":"MIOCARDIOPATÍA HIPERTRÓFICA POR HIPERTIROIDISMO"
  },
  {
    "codigo":724446001,
    "descripcion":"ENDOFIBROSIS DE ARTERIA ILÍACA EXTERNA"
  },
  {
    "codigo":298462003,
    "descripcion":"AMPLITUD DE ROTACIÓN ACTIVA HACIA LA IZQUIERDA DE DE LA COLUMNA CERVICAL NORMAL"
  },
  {
    "codigo":1148595001,
    "descripcion":"ARTRITIS REUMÁTICA SUBAGUDA"
  },
  {
    "codigo":165555003,
    "descripcion":"RECUENTO DE PLAQUETAS DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1091881000119100,
    "descripcion":"ACÚFENO OBJETIVO DEL OÍDO DERECHO"
  },
  {
    "codigo":67251005,
    "descripcion":"FUNCIÓN HEPÁTICA AUMENTADA"
  },
  {
    "codigo":11864361000119102,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE PIE DERECHO CON INFECCIÓN"
  },
  {
    "codigo":341801000119101,
    "descripcion":"OCLUSIÓN DE ARTERIA CENTRAL DE LA RETINA IZQUIERDA"
  },
  {
    "codigo":15630121000119101,
    "descripcion":"ANTEVERSIÓN CONGÉNITA DE FÉMUR IZQUIERDO"
  },
  {
    "codigo":11795241000119105,
    "descripcion":"LESIÓN TRAUMÁTICA DE VENA SUBCLAVIA IZQUIERDA"
  },
  {
    "codigo":15724841000119101,
    "descripcion":"ENTESOPATÍA DE REGIÓN DE HOMBRO DERECHO"
  },
  {
    "codigo":1086761000119107,
    "descripcion":"HEMORRAGIA POR ENTEROSTOMÍA"
  },
  {
    "codigo":15673641000119108,
    "descripcion":"GRANULOMA DE PARTES BLANDAS DE AMBAS MANOS POR CUERPO EXTRAÑO"
  },
  {
    "codigo":751960361000119108,
    "descripcion":"LESIÓN DE CAVIDAD NASAL"
  },
  {
    "codigo":142121000119101,
    "descripcion":"ECTASIA DE AORTA ABDOMINAL"
  },
  {
    "codigo":32648007,
    "descripcion":"ESFEROCITOSIS HEREDITARIA LEVE POR DEFICIENCIA DE ESPECTRINA"
  },
  {
    "codigo":15747881000119103,
    "descripcion":"HIPERTROFIA DE AMBOS MÚSCULOS MASETEROS"
  },
  {
    "codigo":1084201000119108,
    "descripcion":"ACÚFENO OBJETIVO BILATERAL"
  },
  {
    "codigo":15717161000119109,
    "descripcion":"OSTEÓLISIS BILATERAL DE EXTREMO ACROMIAL DE CLAVÍCULAS"
  },
  {
    "codigo":294792002,
    "descripcion":"ALERGIA A MESTRANOL"
  },
  {
    "codigo":16705321000119109,
    "descripcion":"NEOPLASIA DE RIÑÓN DERECHO"
  },
  {
    "codigo":313641000119108,
    "descripcion":"MONOARTRITIS DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":292957003,
    "descripcion":"REACCIÓN ADVERSA A LA PENICILINA BENZATÍNICA"
  },
  {
    "codigo":718941007,
    "descripcion":"DISFUNCIÓN SOMÁTICA DE REGIÓN ESTERNOCONDRAL"
  },
  {
    "codigo":1144925008,
    "descripcion":"ESCLEROSIS SISTÉMICA DIFUSA INFANTIL"
  },
  {
    "codigo":94514000,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA PELVIS RENAL"
  },
  {
    "codigo":422194002,
    "descripcion":"HIPERHIDROSIS ASOCIADA CON SIDA"
  },
  {
    "codigo":28978003,
    "descripcion":"OFTALMOPLEJÍA SUPRANUCLEAR PROGRESIVA"
  },
  {
    "codigo":291122002,
    "descripcion":"INTOXICACIÓN POR SULPIRIDA"
  },
  {
    "codigo":225586007,
    "descripcion":"VOMITA ALIMENTO"
  },
  {
    "codigo":192818008,
    "descripcion":"DEGENERACIÓN CEREBRAL POR ENFERMEDAD DE CREUTZFELDT-JAKOB"
  },
  {
    "codigo":127282007,
    "descripcion":"FRACTURA DE CLIVUS OCCIPITAL"
  },
  {
    "codigo":289287003,
    "descripcion":"DOS MEMBRANAS PLACENTARIAS PRESENTES"
  },
  {
    "codigo":27143004,
    "descripcion":"DETERMINACIÓN DEL ESTADO DEL PACIENTE, PRETERMINAL"
  },
  {
    "codigo":92679008,
    "descripcion":"CARCINOMA IN SITU DE PENE"
  },
  {
    "codigo":123612005,
    "descripcion":"PIELONEFRITIS CICATRIZADA"
  },
  {
    "codigo":1336028006,
    "descripcion":"LABIO SUPERIOR E INFERIOR RELAJADOS"
  },
  {
    "codigo":1268657007,
    "descripcion":"CAPAZ DE PAGAR ELECTRICIDAD EN VIVIENDA"
  },
  {
    "codigo":21638000,
    "descripcion":"PERIODONTITIS AGUDA"
  },
  {
    "codigo":449457008,
    "descripcion":"DEFECTO DEL TABIQUE AURICULOVENTRICULAR CON INSUFICIENCIA DE VÁLVULA AURICULOVENTRICULAR A TRAVÉS DE COMISURA MURAL LATERAL DE VALVA EN PUENTE SUPERIOR"
  },
  {
    "codigo":185478003,
    "descripcion":"PROBLEMAS MÉDICO\/PACIENTE"
  },
  {
    "codigo":218246003,
    "descripcion":"EFECTO TARDÍO DE LESIÓN TRAUMÁTICA ACCIDENTAL"
  },
  {
    "codigo":283782004,
    "descripcion":"HERIDA POR MORDEDURA DE GATO"
  },
  {
    "codigo":1332358007,
    "descripcion":"SCHWANNOMATOSIS COMPLETA"
  },
  {
    "codigo":94856006,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA GLOTIS"
  },
  {
    "codigo":52571006,
    "descripcion":"TRAQUEOBRONQUITIS CRÓNICA"
  },
  {
    "codigo":249179007,
    "descripcion":"ESTADO DE LAS MEMBRANAS AL MOMENTO DEL PARTO"
  },
  {
    "codigo":443952001,
    "descripcion":"PÉRDIDA CUTÁNEA QUE EXPONE HUESO"
  },
  {
    "codigo":1230384009,
    "descripcion":"DEFORMIDAD CONGÉNITA DE HOMBRO"
  },
  {
    "codigo":1163013005,
    "descripcion":"REACCIÓN ADVERSA A CARBROMAL"
  },
  {
    "codigo":349231000119108,
    "descripcion":"TRASTORNO DE DIRECCIÓN DE FLUJO DE HUMOR ACUOSO DE AMBOS OJOS"
  },
  {
    "codigo":702426001,
    "descripcion":"DEMENCIA FRONTOTEMPORAL RELACIONADA CON EL GEN GRN"
  },
  {
    "codigo":473050002,
    "descripcion":"INFECCIÓN ASOCIADA CON DISPOSITIVO DE FIJACIÓN INTERNA"
  },
  {
    "codigo":15723721000119103,
    "descripcion":"HIPERTROFIA DE MEMBRANA SINOVIAL DE AMBAS ARTICULACIONES GLENOHUMERALES"
  },
  {
    "codigo":276442006,
    "descripcion":"ADENOIDES GRANDES"
  },
  {
    "codigo":45231001,
    "descripcion":"BURSITIS INFRARROTULIANA"
  },
  {
    "codigo":274607002,
    "descripcion":"REFLEJO CREMASTÉRICO NEGATIVO"
  },
  {
    "codigo":241839003,
    "descripcion":"EFECTO TÓXICO CAUSADO POR PRODUCTO PARA LA LIMPIEZA DE COCINAS"
  },
  {
    "codigo":12463005,
    "descripcion":"GASTROENTERITIS INFECCIOSA"
  },
  {
    "codigo":209071006,
    "descripcion":"LUXACIÓN EXPUESTA DE MÚLTIPLES VÉRTEBRAS CERVICALES"
  },
  {
    "codigo":733359005,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE ENDOMETRIO"
  },
  {
    "codigo":403844001,
    "descripcion":"INFECCIÓN PSEUDOMONIÁSICA NEONATAL"
  },
  {
    "codigo":1255812002,
    "descripcion":"LINFOMA DE HODGKIN, VARIANTE ESCLEROSIS NODULAR DE GANGLIOS LINFÁTICOS DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":305540003,
    "descripcion":"BAJO ATENCIÓN DE CIRUJANO GENERAL"
  },
  {
    "codigo":240004005,
    "descripcion":"BURSITIS SEMIMEMBRANOSA"
  },
  {
    "codigo":371076006,
    "descripcion":"SIRINGOMIELIA CONGÉNITA"
  },
  {
    "codigo":926297006,
    "descripcion":"EPÍFISIS PEQUEÑA DE FALANGE DE DEDO GORDO"
  },
  {
    "codigo":762457009,
    "descripcion":"ASTROBLASTOMA DE CEREBRO"
  },
  {
    "codigo":11791561000119109,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":400174005,
    "descripcion":"CARCINOMA BASOCELULAR DEL ANTEHÉLIX DE PABELLÓN AURICULAR"
  },
  {
    "codigo":1119235000,
    "descripcion":"MIOGLOBINURIA RECURRENTE"
  },
  {
    "codigo":365571001,
    "descripcion":"HALLAZGO RELACIONADO CON LA DISPOSICIÓN PARA SER DONANTE"
  },
  {
    "codigo":367406009,
    "descripcion":"DEFICIENCIA DE ALFA.DEXTRINA ENDO.1,6.ALFA.GLUCOSIDASA"
  },
  {
    "codigo":726019003,
    "descripcion":"MELANOMA MALIGNO DE PIEL FAMILIAR"
  },
  {
    "codigo":72494008,
    "descripcion":"NÉBULA CORNEAL"
  },
  {
    "codigo":298200006,
    "descripcion":"HIPERMOVILIDAD DE ARTICULACIÓN SUBASTRAGALINA"
  },
  {
    "codigo":66989003,
    "descripcion":"INSUFICIENCIA VENTRICULAR DERECHA, CONGESTIVA CRÓNICA"
  },
  {
    "codigo":296365007,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE ACETILCOLINA"
  },
  {
    "codigo":394669009,
    "descripcion":"SENSIBILIDAD AL MONOFILAMENTO 10G DEL PIE DERECHO NORMAL"
  },
  {
    "codigo":165293009,
    "descripcion":"MEMORIA: RECUERDA SU FECHA DE NACIMIENTO"
  },
  {
    "codigo":294530006,
    "descripcion":"ALERGIA A POLIMIXINA B"
  },
  {
    "codigo":786050007,
    "descripcion":"OCLUSIÓN DE RAMA DE VENA DE LA RETINA DE OJO DERECHO"
  },
  {
    "codigo":720514008,
    "descripcion":"SÍNDROME DE ARTROGRIPOSIS MÚLTIPLE CONGÉNITA Y CARA DE SILBIDO"
  },
  {
    "codigo":65154009,
    "descripcion":"INFECCIÓN CAUSADA POR CLOSTRIDIUM PERFRINGENS"
  },
  {
    "codigo":718679004,
    "descripcion":"SÍNDROME MAMARIO-DIGITOUNGUEAL"
  },
  {
    "codigo":292695006,
    "descripcion":"REACCIÓN ADVERSA AL METOCARBAMOL"
  },
  {
    "codigo":94252000,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA MEJILLA"
  },
  {
    "codigo":290860004,
    "descripcion":"INTOXICACIÓN POR FENELZINA"
  },
  {
    "codigo":127020005,
    "descripcion":"NEOPLASIA DE LA GLÁNDULA PARATIROIDES"
  },
  {
    "codigo":289025002,
    "descripcion":"INCAPAZ DE COMER CON LOS DEDOS"
  },
  {
    "codigo":715009003,
    "descripcion":"DIFICULTAD PARA CABALGAR"
  },
  {
    "codigo":351741000119107,
    "descripcion":"NEVO MELANOCÍTICO DE PIEL DE OREJA IZQUIERDA"
  },
  {
    "codigo":92417009,
    "descripcion":"NEOPLASIA BENIGNA DE GANGLIOS LINFÁTICOS INGUINALES SUPERFICIALES"
  },
  {
    "codigo":1237462006,
    "descripcion":"MICROHIDRANENCEFALIA ASOCIADA AL GEN NDE1"
  },
  {
    "codigo":451030007,
    "descripcion":"FÍSTULA URACAL"
  },
  {
    "codigo":385494008,
    "descripcion":"HEMATOMA"
  },
  {
    "codigo":154283005,
    "descripcion":"TUBERCULOSIS PULMONAR"
  },
  {
    "codigo":187051006,
    "descripcion":"ENDOCARDITIS POR HISTOPLASMA DUBOISII"
  },
  {
    "codigo":285355007,
    "descripcion":"AMPOLLA DE SANGRE"
  },
  {
    "codigo":1268395007,
    "descripcion":"CARCINOMA METASTÁSICO INDIFERENCIADO DE ESTÓMAGO"
  },
  {
    "codigo":447360007,
    "descripcion":"DERMATITIS PERIVASCULAR"
  },
  {
    "codigo":283520007,
    "descripcion":"HERIDA PUNZANTE DE DEDO DE MANO"
  },
  {
    "codigo":445525001,
    "descripcion":"ARTRITIS INFECCIOSA DE MUÑECA"
  },
  {
    "codigo":871509002,
    "descripcion":"ALERGIA A DEXTROPROPOXIFENO Y\/O PARACETAMOL"
  },
  {
    "codigo":840576009,
    "descripcion":"OPACIDAD DE CRISTALINO TEMPRANA"
  },
  {
    "codigo":12203671000119107,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":1197354001,
    "descripcion":"NEOPLASIA MESENQUIMAL PRIMARIA MALIGNA DE COLON"
  },
  {
    "codigo":248917009,
    "descripcion":"HIPERTROFIA CERVICAL"
  },
  {
    "codigo":247082008,
    "descripcion":"AVULSIÓN DE BASE DE CUERPO VÍTREO"
  },
  {
    "codigo":81407003,
    "descripcion":"GRANULOMA APICAL"
  },
  {
    "codigo":134961000119104,
    "descripcion":"TROMBOSIS VENOSA PROFUNDA AGUDA DE VENA AXILAR"
  },
  {
    "codigo":46804001,
    "descripcion":"MIOPATÍA MIOTUBULAR SEVERA LIGADA AL CROMOSOMA X"
  },
  {
    "codigo":472788002,
    "descripcion":"OBSTRUCCIÓN DE VÍA VENOSA SISTÉMICA CONSTRUIDA QUIRÚRGICAMENTE COMO COMPLICACIÓN DE PROCEDIMIENTO"
  },
  {
    "codigo":734932003,
    "descripcion":"LESIÓN CUTÁNEA PIGMENTADA BENIGNA"
  },
  {
    "codigo":866004004,
    "descripcion":"QUISTE PILONIDAL DE SURCO INTERGLÚTEO"
  },
  {
    "codigo":14036002,
    "descripcion":"ACTINOBACILOSIS CAUSADA POR SALPINGITIS POR ACTINOBACILLUS"
  },
  {
    "codigo":1193684003,
    "descripcion":"ENTERITIS POR ESCHERICHIA COLI ENTEROPATÓGENA"
  },
  {
    "codigo":210644008,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE LA MANO, A TRAVÉS DEL METACARPO"
  },
  {
    "codigo":700329000,
    "descripcion":"CUERPO EXTRAÑO RETENIDO DE PÁRPADO SUPERIOR"
  },
  {
    "codigo":733097003,
    "descripcion":"SÍNDROME DE ICTIOSIS, DISCAPACIDAD INTELECTUAL, ENANISMO Y ALTERACIONES RENALES"
  },
  {
    "codigo":44969005,
    "descripcion":"INTOXICACIÓN CAUSADA POR FÁRMACO Y\/O PREPARADO PARA EL TRATAMIENTO DEL CABELLO"
  },
  {
    "codigo":896937006,
    "descripcion":"FORMA DE BALA ANORMAL CONGÉNITA DE FALANGE PROXIMAL DE PIE"
  },
  {
    "codigo":403582001,
    "descripcion":"QUEMADURA AUTOINFLIGIDA POR AGENTES CÁUSTICOS"
  },
  {
    "codigo":239742004,
    "descripcion":"CONTRACTURA DE ARTICULACIÓN DEL PIE"
  },
  {
    "codigo":303443001,
    "descripcion":"NO CONSTRUYE COSAS"
  },
  {
    "codigo":237907004,
    "descripcion":"HIPOMAGNESEMIA SECUNDARIA"
  },
  {
    "codigo":762195006,
    "descripcion":"QUISTE BRONCOGÉNICO CONGÉNITO"
  },
  {
    "codigo":8531006,
    "descripcion":"SORDERA TOTAL"
  },
  {
    "codigo":41299009,
    "descripcion":"ENFERMEDAD DE CUSHING IATROGÉNICA"
  },
  {
    "codigo":205139009,
    "descripcion":"SINDACTILIA SIMPLE DE DEDOS DE LA MANO - PRIMERA MEMBRANA INTERDIGITAL"
  },
  {
    "codigo":1153576003,
    "descripcion":"HORMONA TIROESTIMULANTE SÉRICA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":301608004,
    "descripcion":"SUBE Y BAJA ESCALERAS HACIA ATRÁS"
  },
  {
    "codigo":365309002,
    "descripcion":"HALLAZGO RELACIONADO CON EL USO DE LA IMAGINACIÓN"
  },
  {
    "codigo":299773002,
    "descripcion":"REACCIÓN PRIMARIA DE MARCHA DE RESULTADO DUDOSO"
  },
  {
    "codigo":234237008,
    "descripcion":"TRASTORNO DE LA FUNCIÓN DEL DESFRIBILADOR"
  },
  {
    "codigo":232402006,
    "descripcion":"FARINGITIS MENINGOCÓCICA"
  },
  {
    "codigo":363474009,
    "descripcion":"NEOPLASIA MALIGNA DE LAS MENINGES CEREBRALES"
  },
  {
    "codigo":1344679003,
    "descripcion":"QUISTE DERMOIDE DE PÁRPADO INFERIOR"
  },
  {
    "codigo":66727005,
    "descripcion":"MESOTAURODONTISMO"
  },
  {
    "codigo":230567006,
    "descripcion":"NEUROPATÍA POR DEFICIENCIA DE ÁCIDO FÓLICO"
  },
  {
    "codigo":296103007,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE MEDAZEPAM"
  },
  {
    "codigo":445875009,
    "descripcion":"FRACTURA DE TROCÁNTER DE FÉMUR"
  },
  {
    "codigo":392572005,
    "descripcion":"HALLAZGO RELACIONADO CON EL LATIDO PRECORDIAL"
  },
  {
    "codigo":359804008,
    "descripcion":"GASTROENTERITIS EOSINOFÍLICA"
  },
  {
    "codigo":294268009,
    "descripcion":"ALERGIA A FRAGMENTO FAB INMUNITARIO ANTIDIGOXINA"
  },
  {
    "codigo":1177169004,
    "descripcion":"ATAXIA CEREBELOSA CONGÉNITA POR UNA MUTACIÓN EN GEN RNU12"
  },
  {
    "codigo":95825005,
    "descripcion":"ACÚFENOS NO VIBRATORIO"
  },
  {
    "codigo":292433005,
    "descripcion":"REACCIÓN ADVERSA AL METIPRANOLOL"
  },
  {
    "codigo":1144401006,
    "descripcion":"HIPOPLASIA CONGÉNITA DE ESTRUCTURA ÓSEA DE PRIMERA COSTILLA"
  },
  {
    "codigo":290598005,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR CICLOFOSFAMIDA"
  },
  {
    "codigo":93990005,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE COSTILLA"
  },
  {
    "codigo":126758009,
    "descripcion":"NEOPLASIA DE VASO SANGUÍNEO DE LA PELVIS"
  },
  {
    "codigo":419835002,
    "descripcion":"PROGRESIÓN TUMORAL"
  },
  {
    "codigo":190459003,
    "descripcion":"QUISTE PARATIROIDEO"
  },
  {
    "codigo":288763006,
    "descripcion":"CAPAZ DE COMUNICAR SENTIMIENTOS"
  },
  {
    "codigo":92155007,
    "descripcion":"NEOPLASIA BENIGNA DE LOS GANGLIOS LINFÁTICOS INTRAPÉLVICOS"
  },
  {
    "codigo":286928002,
    "descripcion":"ANEMIAS POR DEFICIENCIA, EXCEPTO DE HIERRO"
  },
  {
    "codigo":1237200003,
    "descripcion":"SÍNDROME DE ABSTINENCIA DE BUPRENORFINA Y\/O NALOXONA"
  },
  {
    "codigo":874917001,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE FLANCO"
  },
  {
    "codigo":416165005,
    "descripcion":"ESPASMO DEL REFLEJO SINQUINÉTICO DE PROXIMIDAD"
  },
  {
    "codigo":22949006,
    "descripcion":"ECTASIA VENOSA DE VENA MESENTÉRICA"
  },
  {
    "codigo":283258005,
    "descripcion":"VIDRIO EN MAMA"
  },
  {
    "codigo":281423001,
    "descripcion":"CRITERIOS CUMPLIDOS DE MUERTE DEL TRONCO ENCEFÁLICO"
  },
  {
    "codigo":707407001,
    "descripcion":"CARCINOMA PRIMARIO DE CÉLULAS EN ANILLO DE SELLO DE PULMÓN"
  },
  {
    "codigo":445263008,
    "descripcion":"BLOQUEO DE RAMA DERECHA Y DE FASCÍCULO ANTERIOR IZQUIERDO EN ELECTROCARDIOGRAMA"
  },
  {
    "codigo":115748000,
    "descripcion":"FENOTIPO DEL GRUPO SANGUÍNEO LEWIS"
  },
  {
    "codigo":314191009,
    "descripcion":"CISTOADENOCARCINOMA DE OVARIO"
  },
  {
    "codigo":82980005,
    "descripcion":"ANEMIA DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":212217004,
    "descripcion":"LESIÓN DE LA RAÍZ DE NERVIO DORSAL - D12"
  },
  {
    "codigo":408825006,
    "descripcion":"PRUEBA PARA CRIBADO PRENATAL DE HEPATITIS B EN SANGRE ENVIADA"
  },
  {
    "codigo":15675801000119108,
    "descripcion":"TENDINITIS CALCIFICADA DE AMBAS RODILLAS"
  },
  {
    "codigo":277753008,
    "descripcion":"DISTANCIA LEJANA"
  },
  {
    "codigo":1258958003,
    "descripcion":"CISTITIS BACTERIANA SIMPLE AGUDA"
  },
  {
    "codigo":863907000,
    "descripcion":"CELULITIS EN LUGAR DE VACUNACIÓN"
  },
  {
    "codigo":112078008,
    "descripcion":"ASPECTO JOVEN PARA LA EDAD"
  },
  {
    "codigo":274083001,
    "descripcion":"QUERIÓN DE LA BARBA"
  },
  {
    "codigo":44707000,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE CODO SIN INFECCIÓN"
  },
  {
    "codigo":306851004,
    "descripcion":"OCLUSIÓN DE INJERTO-PUENTE DE LA BIFURCACIÓN AÓRTICA"
  },
  {
    "codigo":11939005,
    "descripcion":"ARTRITIS AGUDA"
  },
  {
    "codigo":110243006,
    "descripcion":"CONTUSIÓN MAXILAR"
  },
  {
    "codigo":308686009,
    "descripcion":"QUINTO DEDO DEL PIE AMPUTADO"
  },
  {
    "codigo":77475008,
    "descripcion":"TRASTORNO DELIRANTE, TIPO CELOTÍPICO"
  },
  {
    "codigo":763768001,
    "descripcion":"ICTIOSIS EXFOLIATIVA AUTOSÓMICA RECESIVA"
  },
  {
    "codigo":370552002,
    "descripcion":"OBSTRUCCIÓN DINÁMICA DEL TRACTO DE SALIDA AÓRTICO"
  },
  {
    "codigo":1255288003,
    "descripcion":"HERIDA ABIERTA DE MÚLTIPLES DEDOS DE MANO"
  },
  {
    "codigo":42872003,
    "descripcion":"INFECCIÓN CAUSADA POR TRYPANOSOMA RHODESIENSE"
  },
  {
    "codigo":403320008,
    "descripcion":"ALOPECIA AREATA CIRCUNSCRIPTA DE CUERO CABELLUDO"
  },
  {
    "codigo":237645000,
    "descripcion":"HIPOGLUCEMIA INDUCIDA POR TUMOR"
  },
  {
    "codigo":8269002,
    "descripcion":"ANGIOPATÍA CEREBROESPINAL"
  },
  {
    "codigo":301346001,
    "descripcion":"HALLAZGO RELACIONADO CON EL ASPECTO DE LABIO"
  },
  {
    "codigo":399650002,
    "descripcion":"HALLAZGO RELACIONADO CON EL MARGEN DE RESECCIÓN QUIRÚRGICA PANCREÁTICO"
  },
  {
    "codigo":203042003,
    "descripcion":"MIOSITIS EN LA SARCOIDOSIS"
  },
  {
    "codigo":432418003,
    "descripcion":"ARTRITIS BACTERIANA DE ARTICULACIÓN ROTULOFEMORAL"
  },
  {
    "codigo":235810006,
    "descripcion":"OBSTRUCCIÓN INTESTINAL POR BOLO"
  },
  {
    "codigo":1217015002,
    "descripcion":"CAMBIO DE VOZ PUBERAL"
  },
  {
    "codigo":365047003,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA HABLAR A VELOCIDAD NORMAL"
  },
  {
    "codigo":102903005,
    "descripcion":"RELACIÓN EMOCIONAL ABUSIVA CON LA ESPOSA"
  },
  {
    "codigo":37367006,
    "descripcion":"ANOMALÍA DEL PAR DE CROMOSOMAS 7"
  },
  {
    "codigo":233975007,
    "descripcion":"SÍNDROME DE EMBOLIA GRASA FULMINANTE"
  },
  {
    "codigo":2764000,
    "descripcion":"CREPITACIÓN ARTICULAR"
  },
  {
    "codigo":299511009,
    "descripcion":"ARTICULACIÓN MEDIOTARSIANA ESTABLE"
  },
  {
    "codigo":363212003,
    "descripcion":"TRASTORNO HEREDITARIO DEL SISTEMA MUSCULOESQUELÉTICO"
  },
  {
    "codigo":232140004,
    "descripcion":"INSUFICIENCIA DE ACOMODACIÓN"
  },
  {
    "codigo":230305002,
    "descripcion":"DEGENERACIÓN HEPATOCEREBRAL CRÓNICA"
  },
  {
    "codigo":721825002,
    "descripcion":"ENCEFALITIS CAUSADA POR TAENIA SOLIUM"
  },
  {
    "codigo":16907111000119101,
    "descripcion":"NEVO MELANOCÍTICO DE PÁRPADO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":164769005,
    "descripcion":"PROCEDIMIENTO OTORRINOLARINGOLÓGICO ESPECIAL - ANORMAL"
  },
  {
    "codigo":263073006,
    "descripcion":"FRACTURA-LUXACIÓN DE ARTICULACIÓN DE MIEMBROS SUPERIORES"
  },
  {
    "codigo":295841009,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE AMOXAPINA"
  },
  {
    "codigo":719990003,
    "descripcion":"DISTROFIA MUSCULAR AUTOSÓMICA DOMINANTE CON DISTRIBUCIÓN EN LAS CINTURAS ESCAPULAR O PÉLVICA TIPO 1G"
  },
  {
    "codigo":128331005,
    "descripcion":"TRASTORNO DE LA PAPILA ÓPTICA"
  },
  {
    "codigo":161099006,
    "descripcion":"VIAJE A OTRO LUGAR DISTINTO DE EUROPA"
  },
  {
    "codigo":95563007,
    "descripcion":"PANCREATITIS POR CÁLCULO BILIAR"
  },
  {
    "codigo":423243008,
    "descripcion":"SECRECIÓN CONJUNTIVAL PURULENTA"
  },
  {
    "codigo":1142304003,
    "descripcion":"PORCIÓN INTERNA DE CEJA RALA"
  },
  {
    "codigo":716320004,
    "descripcion":"ARN DE ENTEROVIRUS NO DETECTADO"
  },
  {
    "codigo":93728003,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL LIGAMENTO ANCHO"
  },
  {
    "codigo":28192008,
    "descripcion":"MENINGITIS CAUSADA POR ENTEROVIRUS"
  },
  {
    "codigo":126496009,
    "descripcion":"NEOPLASIA DE LA PIEL DE LA FRENTE"
  },
  {
    "codigo":91893001,
    "descripcion":"AUSENCIA CONGÉNITA DEL ARCO DE LA VÉRTEBRA LUMBAR"
  },
  {
    "codigo":124661003,
    "descripcion":"DEFICIENCIA DE RIBULOSA - FOSFATO 3 - EPIMERASA"
  },
  {
    "codigo":386805003,
    "descripcion":"TRASTORNO NEUROCOGNITIVO LEVE"
  },
  {
    "codigo":60960008,
    "descripcion":"INFECCIÓN CAUSADA POR APATEMON"
  },
  {
    "codigo":419573007,
    "descripcion":"ALERGIA A MAÍZ"
  },
  {
    "codigo":712650000,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE UÑA DE DEDO DE LA MANO"
  },
  {
    "codigo":714485009,
    "descripcion":"GINGIVITIS LOCALIZADA"
  },
  {
    "codigo":286666002,
    "descripcion":"PROYECCIÓN DELIRANTE - MECANISMO DE DEFENSA PSICOLÓGICA"
  },
  {
    "codigo":1204170004,
    "descripcion":"ATEROSCLEROSIS DE ARTERIA VISCERAL ABDOMINAL"
  },
  {
    "codigo":284831000,
    "descripcion":"NO SE SECA"
  },
  {
    "codigo":384970009,
    "descripcion":"GRANDES VASOS AFECTADOS POR PROPAGACIÓN DIRECTA DE NEOPLASIA MALIGNA"
  },
  {
    "codigo":88223008,
    "descripcion":"HIPERTENSIÓN PULMONAR SECUNDARIA"
  },
  {
    "codigo":1003892005,
    "descripcion":"DUPLICACIÓN DE PORCIÓN PROXIMAL DEL BRAZO LARGO DEL CROMOSOMA 7"
  },
  {
    "codigo":282996006,
    "descripcion":"CAPAZ DE VOLTEAR EL CUERPO"
  },
  {
    "codigo":250228007,
    "descripcion":"HALLAZGO RELACIONADO CON LOS ERITROCITOS"
  },
  {
    "codigo":708980008,
    "descripcion":"MORFOLOGÍA DE CRESTA MAXILAR RESIDUAL"
  },
  {
    "codigo":446836009,
    "descripcion":"LESIÓN TRAUMÁTICA DE ARTERIA MESENTÉRICA"
  },
  {
    "codigo":182857002,
    "descripcion":"FÁRMACO NO DISPONIBLE - RETIRADO DE MERCADO"
  },
  {
    "codigo":248393002,
    "descripcion":"HALLAZGO RELACIONADO CON ASIMETRÍA VERTICAL DE ÓRBITA"
  },
  {
    "codigo":1264201004,
    "descripcion":"TRASTORNO FETAL CAUSADO POR TRANSFERENCIA PLACENTARIA DE MEPERIDINA MATERNA DURANTE EL TRABAJO DE PARTO"
  },
  {
    "codigo":707145005,
    "descripcion":"PERIOSTITIS REACTIVA FLORIDA"
  },
  {
    "codigo":445001003,
    "descripcion":"OBSTRUCCIÓN DEL TRACTO DE SALIDA DEL VENTRÍCULO IZQUIERDO POR TABIQUE DE SALIDA DESVIADO"
  },
  {
    "codigo":20852007,
    "descripcion":"SÍNDROME DE ROMANO - WARD"
  },
  {
    "codigo":1296969001,
    "descripcion":"HIDROCISTOMA APOCRINO"
  },
  {
    "codigo":17182001,
    "descripcion":"AGRANULOCITOSIS"
  },
  {
    "codigo":332801000119108,
    "descripcion":"QUERATITIS PUNTEADA DEL OJO DERECHO"
  },
  {
    "codigo":1196830005,
    "descripcion":"MESENQUIMOMA BENIGNO DE APÉNDICE"
  },
  {
    "codigo":408563008,
    "descripcion":"CORREO ELECTRÓNICO ENVIADO A ESPECIALISTA"
  },
  {
    "codigo":277491009,
    "descripcion":"VÉRTIGO POSICIONAL PERIFÉRICO"
  },
  {
    "codigo":111816002,
    "descripcion":"AMIGDALITIS NEUMOCÓCICA"
  },
  {
    "codigo":310259009,
    "descripcion":"ANTICUERPO ANTI - LA NO DETECTADO"
  },
  {
    "codigo":10847541000119100,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR ÁCIDO VALPROICO"
  },
  {
    "codigo":208285003,
    "descripcion":"FRACTURA EXPUESTA DE PORCIÓN DISTAL DE HÚMERO, BICONDÍLEA (FRACTURA T-Y)"
  },
  {
    "codigo":372125008,
    "descripcion":"CARCINOMA DE LA PIEL DE LA EXTREMIDAD INFERIOR"
  },
  {
    "codigo":271986005,
    "descripcion":"ALTERACIÓN DE LA DERIVACIÓN VENTRICULAR CEREBRAL"
  },
  {
    "codigo":75378005,
    "descripcion":"INTOXICACIÓN POR MANIHOT"
  },
  {
    "codigo":302919001,
    "descripcion":"HEPATITIS CAUSADA POR VIRUS DE EPSTEIN-BARR"
  },
  {
    "codigo":697970009,
    "descripcion":"TUMOR DE CÉLULAS GIGANTES DE HUESO"
  },
  {
    "codigo":40775003,
    "descripcion":"HERNIA INTESTINAL"
  },
  {
    "codigo":8007005,
    "descripcion":"BROMODERMIA"
  },
  {
    "codigo":1251356001,
    "descripcion":"HIPERHIDROSIS CAUSADA POR FÁRMACO"
  },
  {
    "codigo":170012007,
    "descripcion":"PESO DEL NIÑO ENTRE PERCENTILOS 90 Y 96"
  },
  {
    "codigo":364785003,
    "descripcion":"HALLAZGO RELACIONADO CON LA FUNCIÓN MOTRIZ DE LA MANDÍBULA"
  },
  {
    "codigo":233713004,
    "descripcion":"NEUMONÍA ESTACIONAL CRIPTOGÉNICA EN ORGANIZACIÓN, CON COLESTASIS BIOQUÍMICA"
  },
  {
    "codigo":231878001,
    "descripcion":"LESIÓN EN LA ESCLERÓTICA"
  },
  {
    "codigo":299249009,
    "descripcion":"SIN AMPLITUD PASIVA DE FLEXIÓN DE LA CADERA"
  },
  {
    "codigo":199110003,
    "descripcion":"INFECCIONES RENALES EN EL EMBARAZO"
  },
  {
    "codigo":166342005,
    "descripcion":"PRUEBA DE CAPTACIÓN DE TRIYODOTIRONINA FUERA DE RANGO DE REFERENCIA"
  },
  {
    "codigo":395718006,
    "descripcion":"INVASIÓN TUMORAL INTRAMURAL DE PEQUEÑOS VASOS LINFÁTICOS, PRESENTE"
  },
  {
    "codigo":788934008,
    "descripcion":"LACERACIÓN FOCAL DE ENCÉFALO"
  },
  {
    "codigo":721563000,
    "descripcion":"MELANOMA MALIGNO PRIMARIO DE VAGINA"
  },
  {
    "codigo":361115000,
    "descripcion":"SINEQUIAS INTRAUTERINAS"
  },
  {
    "codigo":197275004,
    "descripcion":"INSUFICIENCIA HEPÁTICA SUBAGUDA"
  },
  {
    "codigo":262811005,
    "descripcion":"LESIÓN TRAUMÁTICA DE VÍA BILIAR CON HERIDA ABIERTA HACIA CAVIDAD"
  },
  {
    "codigo":295579006,
    "descripcion":"SOBREDOSIS DE PROCAÍNA"
  },
  {
    "codigo":426651005,
    "descripcion":"OCLUSIÓN CAROTÍDEA BILATERAL"
  },
  {
    "codigo":15982031000119106,
    "descripcion":"AUSENCIA ADQUIRIDA DE NARIZ"
  },
  {
    "codigo":719728005,
    "descripcion":"CAPAZ DE RECONOCER PALABRAS ESCRITAS"
  },
  {
    "codigo":160837000,
    "descripcion":"PROBLEMAS EXTRAMARITALES"
  },
  {
    "codigo":129904008,
    "descripcion":"TRASTORNO DE LA DENTICIÓN"
  },
  {
    "codigo":422981003,
    "descripcion":"VALORES PERSONALES INCONGRUENTES"
  },
  {
    "codigo":128069005,
    "descripcion":"LESIÓN TRAUMÁTICA DEL ABDOMEN"
  },
  {
    "codigo":717893006,
    "descripcion":"CATARATA DEBIDA A HIPOPARATIROIDISMO IDIOPÁTICO"
  },
  {
    "codigo":291909006,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR ÁCIDO AMINOCAPROICO"
  },
  {
    "codigo":95301008,
    "descripcion":"HUESO ACCESORIO DEL TARSO"
  },
  {
    "codigo":1142042001,
    "descripcion":"FÍSTULA RECTOVAGINAL CON COMPROMISO DE ESFÍNTER ANAL"
  },
  {
    "codigo":1240346000,
    "descripcion":"METÁSTASIS DE ADENOCARCINOMA EN DIVERTÍCULO DE MECKEL"
  },
  {
    "codigo":93466004,
    "descripcion":"DISGENESIA GONADAL CON DISFUNCIÓN AUDITIVA, HERENCIA AUTOSÓMICA RECESIVA"
  },
  {
    "codigo":290074005,
    "descripcion":"NÓDULO DE PIEL DE MAMA"
  },
  {
    "codigo":60698006,
    "descripcion":"ESOFAGITIS HEMORRÁGICA"
  },
  {
    "codigo":188100000,
    "descripcion":"NEOPLASIA MALIGNA DE PIEL DE LA SIEN"
  },
  {
    "codigo":253636006,
    "descripcion":"ORIGEN ANÓMALO DE ARTERIA PULMONAR IZQUIERDA EN CONDUCTO ARTERIOSO"
  },
  {
    "codigo":286404009,
    "descripcion":"DIFICULTAD PARA HABLAR CON FLUIDEZ"
  },
  {
    "codigo":284569002,
    "descripcion":"CUERPO EXTRAÑO METÁLICO EN LA REGIÓN OCULAR"
  },
  {
    "codigo":11777641000119107,
    "descripcion":"DISTENSIÓN DE CABEZA LARGA DE MÚSCULO Y\/O TENDÓN DE BÍCEPS BRAQUIAL IZQUIERDO"
  },
  {
    "codigo":87961002,
    "descripcion":"ENFERMEDAD DE TYZZER"
  },
  {
    "codigo":55193002,
    "descripcion":"ANOMALÍA CONGÉNITA DEL INTESTINO DELGADO"
  },
  {
    "codigo":53358000,
    "descripcion":"FACTOR F"
  },
  {
    "codigo":249966004,
    "descripcion":"MOVIMIENTO ESPASMÓDICO"
  },
  {
    "codigo":413806004,
    "descripcion":"ISLA CENTRAL"
  },
  {
    "codigo":315502005,
    "descripcion":"NACIDO EN FILIPINAS"
  },
  {
    "codigo":18755003,
    "descripcion":"CÁLCULO DENTAL SUPRAGINGIVAL"
  },
  {
    "codigo":706883004,
    "descripcion":"DOLOR DEBIDO A VENAS VARICOSAS DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":248131005,
    "descripcion":"GULA"
  },
  {
    "codigo":1296707006,
    "descripcion":"NEOVASCULARIZACIÓN DE OJO IZQUIERDO"
  },
  {
    "codigo":51523009,
    "descripcion":"LARINGOCELE CONGÉNITO"
  },
  {
    "codigo":277229001,
    "descripcion":"AUSENCIA DE CORNETE NASAL"
  },
  {
    "codigo":703213009,
    "descripcion":"INFARTO AGUDO DE PARED INFERIOR DE MIOCARDIO CON ELEVACIÓN DEL SEGMENTO ST"
  },
  {
    "codigo":208023000,
    "descripcion":"FRACTURA VERTEBRAL EXPUESTA CON LESIÓN POSTERIOR DE MÉDULA ESPINAL CERVICAL, C5-7"
  },
  {
    "codigo":371863001,
    "descripcion":"PERFUSIÓN - HALLAZGO"
  },
  {
    "codigo":404631002,
    "descripcion":"SÍNDROME DE IRIS PLANO"
  },
  {
    "codigo":240791003,
    "descripcion":"GRANULOMA ESQUISTOSÓMICO HEPÁTICO"
  },
  {
    "codigo":238956000,
    "descripcion":"CALCIFICACIÓN IDIOPÁTICA CUTÁNEA"
  },
  {
    "codigo":206188000,
    "descripcion":"HEMORRAGIA SUBDURAL Y ENCEFÁLICA POR TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":402796000,
    "descripcion":"INFECCIÓN VIRAL NEONATAL DE PIEL"
  },
  {
    "codigo":1156460002,
    "descripcion":"MEDULOBLASTOMA NODULAR DESMOPLÁSICO DE CEREBRO"
  },
  {
    "codigo":1287532003,
    "descripcion":"HISTIOCITOMA FIBROSO MALIGNO PRIMARIO DE PARTES BLANDAS DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":75116005,
    "descripcion":"ORNITOSIS"
  },
  {
    "codigo":400961003,
    "descripcion":"NÓDULO DE WOFFLIN"
  },
  {
    "codigo":73281004,
    "descripcion":"DEFICIENCIA CRÓNICA DE CINC"
  },
  {
    "codigo":237121003,
    "descripcion":"NEUMONITIS INTERSTICIAL USUAL"
  },
  {
    "codigo":1351233008,
    "descripcion":"FUNCIÓN DISMINUIDA DE ABCG2 (TRANSPORTADOR DE MEMBRANA DEPENDIENTE DE ATP DE SUBFAMILIA G MIEMBRO 2)"
  },
  {
    "codigo":366358006,
    "descripcion":"INGESTA DE NUTRIENTES - HALLAZGO"
  },
  {
    "codigo":298987000,
    "descripcion":"AMPLITUD DE ADUCCIÓN PASIVA DE ARTICULACIÓN DE MUÑECA, NORMAL"
  },
  {
    "codigo":268054009,
    "descripcion":"ARTROSIS DE MÚLTIPLES ARTICULACIONES"
  },
  {
    "codigo":4075006,
    "descripcion":"INTOXICACIÓN POR PEGANUM HARMALA"
  },
  {
    "codigo":724971007,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO EXTENSOR DE DEDO DE LA MANO A LA ALTURA DEL ANTEBRAZO"
  },
  {
    "codigo":788672001,
    "descripcion":"AMEBOMA DE PIEL"
  },
  {
    "codigo":297152004,
    "descripcion":"TROMBOSIS DE ARTERIA ILÍACA INTERNA"
  },
  {
    "codigo":35008005,
    "descripcion":"INTOXICACIÓN POR TERBUFOS"
  },
  {
    "codigo":295317000,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE RADIOFÁRMACO"
  },
  {
    "codigo":262549002,
    "descripcion":"HERIDA SUPERFICIAL POR PUNCIÓN"
  },
  {
    "codigo":33173003,
    "descripcion":"FRACTURA NO EXPUESTA DE CLAVÍCULA"
  },
  {
    "codigo":721301004,
    "descripcion":"NEOPLASIA MIELOIDE Y LINFOIDE CON ANOMALÍA DEL RECEPTOR DE FACTOR DE CRECIMIENTO DE FIBROBLASTOS 1"
  },
  {
    "codigo":459157005,
    "descripcion":"ABSCESO DE HETEROINJERTO CARDIOVASCULAR"
  },
  {
    "codigo":65941003,
    "descripcion":"ESOFAGITIS POR PÍLDORAS CAUSADA POR CLORURO DE POTASIO"
  },
  {
    "codigo":786837007,
    "descripcion":"SENSACIÓN DE HORMIGUEO DOLOROSA"
  },
  {
    "codigo":293482001,
    "descripcion":"REACCIÓN ADVERSA A DIURÉTICO OSMÓTICO"
  },
  {
    "codigo":197013009,
    "descripcion":"ENTEROCOLITIS POR RADIACIÓN"
  },
  {
    "codigo":129642004,
    "descripcion":"NEUTROPENIA INMUNITARIA CRÓNICA IDIOPÁTICA EN ADULTO"
  },
  {
    "codigo":1145450007,
    "descripcion":"APLASIA DE HUESO DE TÓRAX"
  },
  {
    "codigo":719466009,
    "descripcion":"SÍNDROME DE FISURA DE PALADAR CON BAJA ESTATURA Y ANOMALÍA VERTEBRAL"
  },
  {
    "codigo":15685841000119104,
    "descripcion":"RETINITIS DE OJO IZQUIERDO"
  },
  {
    "codigo":160575005,
    "descripcion":"BEBEDOR LEVE - 1 A 2 UNIDADES POR DÍA"
  },
  {
    "codigo":226111008,
    "descripcion":"DIETA POBRE EN GRASAS SATURADAS"
  },
  {
    "codigo":95039009,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL ESCROTO"
  },
  {
    "codigo":224276004,
    "descripcion":"HOSPEDAJE RECIENTEMENTE DECORADO"
  },
  {
    "codigo":715796006,
    "descripcion":"ENFERMEDAD DE CHARCOT-MARIE-TOOTH TIPO 4A"
  },
  {
    "codigo":191508007,
    "descripcion":"ESTADO CONFUSIONAL SUBAGUDO, POSTRAUMÁTICO"
  },
  {
    "codigo":289812009,
    "descripcion":"MOCO CERVICAL ACELULAR"
  },
  {
    "codigo":419049005,
    "descripcion":"EXPRESA VERBALMENTE PLANES DE REPOSICIÓN DE LA MEDICACIÓN"
  },
  {
    "codigo":284881000119108,
    "descripcion":"ATEROSCLEROSIS DE ARTERIA CARÓTIDA DERECHA"
  },
  {
    "codigo":124137009,
    "descripcion":"DEFICIENCIA DE 3 ALFA - HIDROXICOLANATO DESHIDROGENASA"
  },
  {
    "codigo":253374008,
    "descripcion":"ANOMALÍA CONGÉNITA DE VÁLVULAS AURICULOVENTRICULARES EN DEFECTO DEL TABIQUE AURICULOVENTRICULAR"
  },
  {
    "codigo":284307001,
    "descripcion":"INCAPAZ DE LIBERAR LA PRENSIÓN"
  },
  {
    "codigo":251539000,
    "descripcion":"UNIDADES MOTORAS CON DESCARGAS ADICIONALES"
  },
  {
    "codigo":286142009,
    "descripcion":"INCAPAZ DE LIMPIAR LA COCINA"
  },
  {
    "codigo":448147005,
    "descripcion":"PAPILOMA DE MUCOSA BUCAL"
  },
  {
    "codigo":54931008,
    "descripcion":"IDENTIFICACIÓN DE UN CUERPO POR LAS CICATRICES"
  },
  {
    "codigo":22121000087104,
    "descripcion":"TOLERANCIA FÍSICA A OPIÁCEO"
  },
  {
    "codigo":40041000087105,
    "descripcion":"FRACTURA DE PLATILLO TIBIAL DERECHO"
  },
  {
    "codigo":773992003,
    "descripcion":"TELANGIECTASIA MACULAR IDIOPÁTICA TIPO 3"
  },
  {
    "codigo":446312004,
    "descripcion":"POLIOMIELITIS AGUDA CAUSADA POR POLIOVIRUS HUMANO 1"
  },
  {
    "codigo":53096005,
    "descripcion":"PARAFASIA"
  },
  {
    "codigo":1077611000119106,
    "descripcion":"OSTEOMIELITIS CRÓNICA DE TOBILLO DERECHO"
  },
  {
    "codigo":16206341000119100,
    "descripcion":"COMPRESIÓN DE AMBOS NERVIOS CUBITALES A LA ALTURA DEL CODO"
  },
  {
    "codigo":249704008,
    "descripcion":"COSTILLAS INFLAMADAS"
  },
  {
    "codigo":1003368009,
    "descripcion":"DEFICIENCIA DE COFACTOR DE MOLIBDENO, GRUPO DE COMPLEMENTACIÓN B"
  },
  {
    "codigo":184168001,
    "descripcion":"REGISTRADO EN ÁREA DE BAJOS RECURSOS - BAJO"
  },
  {
    "codigo":247869001,
    "descripcion":"MIEDO A CONTRAER UNA ENFERMEDAD POR RADIACIÓN"
  },
  {
    "codigo":15960581000119102,
    "descripcion":"ANGINA CONCOMITANTE CON ARTERIOESCLEROSIS DE INJERTO PUENTE DE ARTERIA CORONARIA CON VENA AUTÓLOGA Y DEBIDA A ELLA"
  },
  {
    "codigo":340331000119109,
    "descripcion":"EXOTROPÍA MONOCULAR INTERMITENTE DE OJO IZQUIERDO"
  },
  {
    "codigo":213266005,
    "descripcion":"LESIÓN DE VASO SANGUÍNEO DURANTE LA CIRUGÍA"
  },
  {
    "codigo":1163538006,
    "descripcion":"PARACOCCIDIOIDOMICOSIS MUCOCUTÁNEA"
  },
  {
    "codigo":80359000,
    "descripcion":"DIETA PARA LACTANTES DE 7 A 9 MESES: CARNE Y HUEVO"
  },
  {
    "codigo":309735004,
    "descripcion":"TROMBOSIS VENOSA DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":735719008,
    "descripcion":"PERFORACIÓN INTESTINAL NEONATAL CONCOMITANTE CON ATRESIA INTESTINAL Y DEBIDA A ELLA"
  },
  {
    "codigo":307900002,
    "descripcion":"ESTADO DE CERTIFICACIÓN"
  },
  {
    "codigo":1290940002,
    "descripcion":"ELASTOFIBROMA"
  },
  {
    "codigo":209596004,
    "descripcion":"DESGARRO COMPLETO DE LIGAMENTO CUBITOSEMILUNAR"
  },
  {
    "codigo":78524005,
    "descripcion":"DISFUNCIÓN SEXUAL INDUCIDA POR EL ALCOHOL"
  },
  {
    "codigo":941771000000100,
    "descripcion":"CAPAZ DE ACOSTARSE SIN ASISTENCIA"
  },
  {
    "codigo":373436002,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM INTRACELLULARE"
  },
  {
    "codigo":111292008,
    "descripcion":"GRANULOMATOSIS SARCOIDE NECROSANTE"
  },
  {
    "codigo":240529006,
    "descripcion":"SIALOADENITIS SUBLINGUAL POR PAROTIDITIS"
  },
  {
    "codigo":42086000,
    "descripcion":"PRODUCCIÓN HORMONAL ANORMAL"
  },
  {
    "codigo":699281009,
    "descripcion":"DEBILIDAD MOTRIZ FOCAL"
  },
  {
    "codigo":238694002,
    "descripcion":"ANGIOEDEMA VIBRATORIO"
  },
  {
    "codigo":369766003,
    "descripcion":"BAJO GRADO (LINFOMA)"
  },
  {
    "codigo":109457009,
    "descripcion":"FUSIÓN DE LA CORONA DENTAL"
  },
  {
    "codigo":304230005,
    "descripcion":"PIEL ROSADA"
  },
  {
    "codigo":402534003,
    "descripcion":"CARCINOMA BASOCELULAR CON CAMBIOS DE CÉLULAS EN ANILLO DE SELLO"
  },
  {
    "codigo":366096001,
    "descripcion":"MOVILIDAD DE LA MEMBRANA TIMPÁNICA - HALLAZGO"
  },
  {
    "codigo":169488004,
    "descripcion":"FALLA DE DISPOSITIVO INTRAUTERINO - EMBARAZO"
  },
  {
    "codigo":300560008,
    "descripcion":"PRUEBA DE LAS AMINAS NEGATIVA"
  },
  {
    "codigo":890384008,
    "descripcion":"POLIDACTILIA CENTRAL BILATERAL DE PIE"
  },
  {
    "codigo":167653002,
    "descripcion":"LIPASA FECAL POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":823013008,
    "descripcion":"TUMEFACCIÓN DE MITAD DERECHA DE ESCROTO"
  },
  {
    "codigo":722874004,
    "descripcion":"PERITONITIS MESENTÉRICA CONCOMITANTE CON ESTEATONECROSIS MESENTÉRICA"
  },
  {
    "codigo":16671391000119109,
    "descripcion":"FRACTURA NO EXPUESTA DE PISO DE ÓRBITA DERECHA, EN ESTALLIDO"
  },
  {
    "codigo":1148858008,
    "descripcion":"INFERTILIDAD FEMENINA DEBIDA A ENFERMEDAD GENÉTICA"
  },
  {
    "codigo":295055000,
    "descripcion":"ALERGIA A DIGITOXINA"
  },
  {
    "codigo":32911000,
    "descripcion":"PERSONA SIN HOGAR"
  },
  {
    "codigo":65679006,
    "descripcion":"INTOXICACIÓN CAUSADA POR SANGRE ENTERA"
  },
  {
    "codigo":31076000,
    "descripcion":"ATROFIA ISQUÉMICA CONGÉNITA DE LA ESTRUCTURA DEL SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":719204007,
    "descripcion":"DISPLASIA ESPONDILOEPIFISARIA TIPO MAROTEAUX"
  },
  {
    "codigo":94777000,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL CARDIAS DEL ESTÓMAGO"
  },
  {
    "codigo":63844009,
    "descripcion":"ALBINISMO OCULOCUTÁNEO"
  },
  {
    "codigo":62009002,
    "descripcion":"LIPOFUSCINOSIS CEROIDE NEURONAL ADULTA"
  },
  {
    "codigo":194916007,
    "descripcion":"PERICARDITIS NEUMOCÓCICA AGUDA"
  },
  {
    "codigo":225849004,
    "descripcion":"NO HABLA SOBRE EL PROBLEMA"
  },
  {
    "codigo":1208889005,
    "descripcion":"LIPOLINFEDEMA"
  },
  {
    "codigo":291385005,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR COLCHICINA"
  },
  {
    "codigo":293220009,
    "descripcion":"REACCIÓN ADVERSA AL PROPIONATO DE DROSTANOLONA"
  },
  {
    "codigo":191246001,
    "descripcion":"ANEMIA APLÁSICA POR INFECCIÓN"
  },
  {
    "codigo":342841000119109,
    "descripcion":"PLIEGUE COROIDEO CONGÉNITO"
  },
  {
    "codigo":289550005,
    "descripcion":"SECRECIÓN VAGINAL PURULENTA"
  },
  {
    "codigo":846606007,
    "descripcion":"ENFERMEDAD DE INJERTO VERSUS HUÉSPED DE HÍGADO"
  },
  {
    "codigo":715534008,
    "descripcion":"SÍNDROME DE CONVULSIÓN INFANTIL Y COREOATETOSIS"
  },
  {
    "codigo":92942007,
    "descripcion":"FORMA ANORMAL CONGÉNITA DEL RADIO"
  },
  {
    "codigo":1172451008,
    "descripcion":"HORMONA SEXUAL FEMENINA ANORMAL"
  },
  {
    "codigo":416952000,
    "descripcion":"HERIDA ENDOTELIAL DE LA CÓRNEA"
  },
  {
    "codigo":254947008,
    "descripcion":"GLIOMA DE MÉDULA ESPINAL"
  },
  {
    "codigo":285880003,
    "descripcion":"CAPAZ DE USAR EL HORNO DE MICROONDAS"
  },
  {
    "codigo":449720001,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN MIEMBRO INFERIOR, SIN INFECCIÓN"
  },
  {
    "codigo":15635411000119106,
    "descripcion":"BEBÉ PREMATURO, 32 SEMANAS"
  },
  {
    "codigo":415117004,
    "descripcion":"HALLAZGO RELACIONADO CON LA PRODUCCIÓN PLAQUETARIA"
  },
  {
    "codigo":447885009,
    "descripcion":"SARCOMA DE PELVIS"
  },
  {
    "codigo":773730002,
    "descripcion":"SÍNDROME DE OSTEOPETROSIS E HIPOGAMMAGLOBULINEMIA"
  },
  {
    "codigo":249442003,
    "descripcion":"CUERDAS VOCALES MEMBRANOSAS"
  },
  {
    "codigo":314978007,
    "descripcion":"NEUMONÍA POSQUIRÚRGICA"
  },
  {
    "codigo":413282009,
    "descripcion":"LESIÓN TUMORAL PROMINENTE"
  },
  {
    "codigo":282210009,
    "descripcion":"INCAPAZ DE DETENER LA MARCHA"
  },
  {
    "codigo":10939501000119104,
    "descripcion":"HERIDA PUNZANTE DE REGIÓN DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":247607004,
    "descripcion":"AMNESIA PARA LOS ACONTECIMIENTOS DÍA A DÍA"
  },
  {
    "codigo":18231007,
    "descripcion":"SÍNDROME DE INMOVILIDAD (PARAPLÉJICO)"
  },
  {
    "codigo":870199008,
    "descripcion":"UVEÍTIS NO INFECCIOSA DE SEGMENTO POSTERIOR DEL OJO"
  },
  {
    "codigo":276705000,
    "descripcion":"LESIÓN POR TOMA DE MUESTRA EN CUERO CABELLUDO DURANTE EL PARTO"
  },
  {
    "codigo":81932009,
    "descripcion":"FORÚNCULO DE BRAZO"
  },
  {
    "codigo":1259745001,
    "descripcion":"GLIOMA MALIGNO PRIMARIO DE SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":99591000119101,
    "descripcion":"HEMORRAGIA ASOCIADA CON INJERTO PARA DIÁLISIS RENAL"
  },
  {
    "codigo":733622000,
    "descripcion":"SÍNDROME DE TRASTORNO DEL DESARROLLO SEXUAL 46,XX CON ANOMALÍAS ANORRECTALES"
  },
  {
    "codigo":735457009,
    "descripcion":"CITOPENIA CAUSADA POR FÁRMACO"
  },
  {
    "codigo":111030006,
    "descripcion":"SÍNDROME DE CARCINOMA ESOFÁGICO POR QUERATODERMIA PALMOPLANTAR"
  },
  {
    "codigo":371339004,
    "descripcion":"HALLAZGO EN RESTOS HUMANOS"
  },
  {
    "codigo":76427005,
    "descripcion":"HEMARTROSIS DE SITIOS MÚLTIPLES"
  },
  {
    "codigo":1256075004,
    "descripcion":"XANTOMA DEBIDO A HIPERCOLESTEROLEMIA PRIMARIA"
  },
  {
    "codigo":43659006,
    "descripcion":"AGNOSIA ACÚSTICA"
  },
  {
    "codigo":240267008,
    "descripcion":"AFLOJAMIENTO DE LA PRÓTESIS ARTICULAR DE LA CADERA"
  },
  {
    "codigo":895627008,
    "descripcion":"FORMA TRIANGULAR ANORMAL CONGÉNITA DE FALANGE DISTAL DE SEGUNDO DEDO DE PIE"
  },
  {
    "codigo":369504000,
    "descripcion":"TUMOR MALIGNO QUE COMPROMETE LA VAGINA POR PROPAGACIÓN DIRECTA DE LA VEJIGA"
  },
  {
    "codigo":446813000,
    "descripcion":"HIPERTROFIA DE AURÍCULA IZQUIERDA"
  },
  {
    "codigo":404107008,
    "descripcion":"MICOSIS FUNGOIDE, ESTADIO EN PLACAS"
  },
  {
    "codigo":238432007,
    "descripcion":"ÚLCERA POR BCG"
  },
  {
    "codigo":402272009,
    "descripcion":"DERMATITIS IRRITATIVA POR CONTACTO CAUSADA POR BIOCIDA"
  },
  {
    "codigo":105525002,
    "descripcion":"PROBLEMA AL VIAJAR AL EXTRANJERO"
  },
  {
    "codigo":1186869002,
    "descripcion":"CARCINOMA PANCREÁTICO NEUROENDOCRINO"
  },
  {
    "codigo":70922000,
    "descripcion":"PEDOFILIA COMPULSIVA"
  },
  {
    "codigo":890122001,
    "descripcion":"MIOCARDIOPATÍA HIPERTRÓFICA SECUNDARIA A OTRO TRASTORNO"
  },
  {
    "codigo":300298007,
    "descripcion":"HALLAZGO RELACIONADO CON MEDICIONES DEL ESTÓMAGO"
  },
  {
    "codigo":201994008,
    "descripcion":"ARTROPATÍA TRANSITORIA DE TOBILLO Y PIE"
  },
  {
    "codigo":267530009,
    "descripcion":"ANEMIA POSHEMORRÁGICA AGUDA"
  },
  {
    "codigo":365834007,
    "descripcion":"HALLAZGO RELACIONADO CON CÉLULAS MIELOIDES DE MÉDULA ÓSEA"
  },
  {
    "codigo":69087003,
    "descripcion":"ERUPCIÓN DENTAL OBSTRUIDA"
  },
  {
    "codigo":724447005,
    "descripcion":"LINFEDEMA DEBIDO A INFILTRACIÓN MALIGNA"
  },
  {
    "codigo":298463008,
    "descripcion":"AMPLITUD DE ROTACIÓN ACTIVA HACIA LA IZQUIERDA DE LA COLUMNA CERVICAL AUMENTADA"
  },
  {
    "codigo":198324001,
    "descripcion":"HIPERPLASIA ENDOMETRIAL SIMPLE"
  },
  {
    "codigo":296628003,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE ESPECTINOMICINA"
  },
  {
    "codigo":722612005,
    "descripcion":"MÚLTIPLES HERIDAS ABIERTAS DE CABEZA"
  },
  {
    "codigo":394932008,
    "descripcion":"GRADO 5 - 7 DE ESCALA DE GLEASON PARA PRÓSTATA (MEDIO)"
  },
  {
    "codigo":196489000,
    "descripcion":"SIALOADENITIS INFECCIOSA"
  },
  {
    "codigo":11787681000119107,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE DEDO ÍNDICE DERECHO CON INFECCIÓN"
  },
  {
    "codigo":294793007,
    "descripcion":"ALERGIA A ETINILESTRADIOL"
  },
  {
    "codigo":12115361000119108,
    "descripcion":"QUEMADURA QUÍMICA DE OJO DERECHO"
  },
  {
    "codigo":192819000,
    "descripcion":"DEGENERACIÓN CEREBRAL POR LEUCOENCEFALOPATÍA MULTIFOCAL PROGRESIVA"
  },
  {
    "codigo":1144926009,
    "descripcion":"MIOSITIS POR CUERPOS DE INCLUSIÓN ESPORÁDICA"
  },
  {
    "codigo":127283002,
    "descripcion":"FRACTURA DE ETMOIDES"
  },
  {
    "codigo":225587003,
    "descripcion":"REFLUJO GÁSTRICO"
  },
  {
    "codigo":334851000119100,
    "descripcion":"HIPERMETROPÍA DE OJO DERECHO"
  },
  {
    "codigo":16636931000119100,
    "descripcion":"LESIÓN BILATERAL DE NERVIOS FEMORALES"
  },
  {
    "codigo":16703491000119101,
    "descripcion":"DÉFICIT DE MEMORIA DEBIDO A HEMORRAGIA INTRACEREBRAL ESPONTÁNEA Y POSTERIOR A ELLA"
  },
  {
    "codigo":339971000119103,
    "descripcion":"CONJUNTIVITIS LEÑOSA DE OJO IZQUIERDO"
  },
  {
    "codigo":16782851000119103,
    "descripcion":"MELANOMA IN SITU DE PIEL DE ANO"
  },
  {
    "codigo":145411000119105,
    "descripcion":"SEROMA POSTERIOR A PROCEDIMIENTO"
  },
  {
    "codigo":337411000119105,
    "descripcion":"PÉRDIDA TRANSITORIA DE VISIÓN DEL OJO IZQUIERDO"
  },
  {
    "codigo":352771000119107,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE NERVIOS PERIFÉRICOS DE EXTREMIDAD INFERIOR DERECHA"
  },
  {
    "codigo":12003331000119107,
    "descripcion":"HEMORRAGIA DE SISTEMA MUSCULOESQUELÉTICO DURANTE OPERACIÓN DE SISTEMA MUSCULOESQUELÉTICO"
  },
  {
    "codigo":10835971000119109,
    "descripcion":"SENSIBILIZACIÓN ANTI-A EN EL EMBARAZO"
  },
  {
    "codigo":1090051000119109,
    "descripcion":"EDENTULISMO PARCIAL DEBIDO A CARIES"
  },
  {
    "codigo":16314371000119109,
    "descripcion":"INFECCIÓN POR TIÑA DE MIEMBRO INFERIOR MODIFICADA POR ESTEROIDES"
  },
  {
    "codigo":27144005,
    "descripcion":"ONDA ASCÍTICA ABDOMINAL"
  },
  {
    "codigo":16462851000119106,
    "descripcion":"MIALGIA CAUSADA POR ESTATINA"
  },
  {
    "codigo":123613000,
    "descripcion":"VULVITIS HIPERTRÓFICA CRÓNICA"
  },
  {
    "codigo":1336029003,
    "descripcion":"LABIO SUPERIOR E INFERIOR CERRADOS"
  },
  {
    "codigo":289288008,
    "descripcion":"UNA MEMBRANA PLACENTARIA PRESENTE"
  },
  {
    "codigo":11839491000119108,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO DE MANO IZQUIERDA"
  },
  {
    "codigo":92680006,
    "descripcion":"CARCINOMA IN SITU DE LA PIEL PERIANAL"
  },
  {
    "codigo":1264051004,
    "descripcion":"TRASTORNO NEONATAL CAUSADO POR ANTIBACTERIANO TRANSMITIDO POR LECHE MATERNA"
  },
  {
    "codigo":58077008,
    "descripcion":"SÍNCOPE POR HIPOTENSIÓN"
  },
  {
    "codigo":254685008,
    "descripcion":"QUISTES ERUPTIVOS DE PELO VELLOSO"
  },
  {
    "codigo":1268658002,
    "descripcion":"CAPAZ DE PAGAR VESTIMENTA ADECUADA"
  },
  {
    "codigo":10751701000119102,
    "descripcion":"COMIENZO ESPONTÁNEO DE TRABAJO DE PARTO ENTRE LAS 37 Y LAS 39 SEMANAS DE GESTACIÓN CON OPERACIÓN CESÁREA PLANEADA"
  },
  {
    "codigo":449458003,
    "descripcion":"VENA CAVA SUPERIOR DERECHA CONECTADA A SENO CORONARIO Y LUEGO, A AURÍCULA UBICADA EN EL LADO IZQUIERDO"
  },
  {
    "codigo":251015000,
    "descripcion":"ARTERIA CORONARIA - HALLAZGO"
  },
  {
    "codigo":185479006,
    "descripcion":"PACIENTE NO SATISFECHO CON RESULTADO"
  },
  {
    "codigo":54407007,
    "descripcion":"RÁPIDO PARA APRENDER"
  },
  {
    "codigo":21639008,
    "descripcion":"HIPERVOLEMIA"
  },
  {
    "codigo":183644000,
    "descripcion":"SEGUIMIENTO QUIRÚRGICO"
  },
  {
    "codigo":218247007,
    "descripcion":"EFECTO TARDÍO DE ACCIDENTE DE VEHÍCULO DE MOTOR"
  },
  {
    "codigo":283783009,
    "descripcion":"HERIDA POR MORDEDURA DE HÁMSTER"
  },
  {
    "codigo":314716005,
    "descripcion":"DOLOR PÉLVICO AGUDO"
  },
  {
    "codigo":249180005,
    "descripcion":"MEMBRANAS AUSENTES"
  },
  {
    "codigo":1230385005,
    "descripcion":"DEFORMIDAD CONGÉNITA DE BRAZO"
  },
  {
    "codigo":443953006,
    "descripcion":"PÉRDIDA CUTÁNEA QUE EXPONE MÚSCULO"
  },
  {
    "codigo":276443001,
    "descripcion":"LARINGITIS Y\/O TRAQUEÍTIS AGUDAS"
  },
  {
    "codigo":473051003,
    "descripcion":"INFECCIÓN ASOCIADA CON CATÉTER INTERNO EN LA VÍA URINARIA"
  },
  {
    "codigo":702427005,
    "descripcion":"LEUCOENCEFALOPATÍA DIFUSA HEREDITARIA CON ESFEROIDES"
  },
  {
    "codigo":733360000,
    "descripcion":"CARCINOMA INDIFERENCIADO PRIMARIO DE ENDOMETRIO"
  },
  {
    "codigo":241840001,
    "descripcion":"EFECTO TÓXICO CAUSADO POR PRODUCTO PARA RASQUETEADO"
  },
  {
    "codigo":274608007,
    "descripcion":"REFLEJO CREMASTÉRICO POSITIVO"
  },
  {
    "codigo":403845000,
    "descripcion":"FOLICULITIS PUSTULOSA EOSINOFÍLICA NEONATAL"
  },
  {
    "codigo":371077002,
    "descripcion":"DISFUNCIÓN DE LA DERIVACIÓN VENTRICULOPERITONEAL"
  },
  {
    "codigo":305541004,
    "descripcion":"BAJO ATENCIÓN DE CIRUJANO DE MANO"
  },
  {
    "codigo":240005006,
    "descripcion":"LESIÓN DE LIGAMENTOS DE LA REGIÓN DE LA RODILLA"
  },
  {
    "codigo":10629009,
    "descripcion":"TETANIA"
  },
  {
    "codigo":8794002,
    "descripcion":"VOLUMEN SISTÓLICO AUMENTADO"
  },
  {
    "codigo":926298001,
    "descripcion":"EPÍFISIS PEQUEÑA DE HUESO METACARPIANO"
  },
  {
    "codigo":205402004,
    "descripcion":"ARTROGRIPOSIS MÚLTIPLE CONGÉNITA"
  },
  {
    "codigo":698757009,
    "descripcion":"NEUROPATÍA DEBIDA A OBSTRUCCIÓN ADQUIRIDA DE LA VÍA URINARIA"
  },
  {
    "codigo":762458004,
    "descripcion":"CARCINOMA ENDOMETRIOIDE PRIMARIO DE ENDOMETRIO"
  },
  {
    "codigo":39727004,
    "descripcion":"HIPERTENSIÓN SECUNDARIA A NEFROPATÍA, QUE COMPLICA EL PUERPERIO Y\/O CONSTITUYE UN MOTIVO DE ATENCIÓN DURANTE ESTE PERÍODO"
  },
  {
    "codigo":400175006,
    "descripcion":"MIXOFIBROSARCOMA DE PIEL"
  },
  {
    "codigo":301871007,
    "descripcion":"LIPOMA DE CABEZA Y\/O CUELLO"
  },
  {
    "codigo":234500001,
    "descripcion":"TROMBOCITOSIS REACTIVA"
  },
  {
    "codigo":70660007,
    "descripcion":"HIDROCELE DE LA TÚNICA VAGINAL"
  },
  {
    "codigo":365572008,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA RECONOCER OLORES"
  },
  {
    "codigo":267268007,
    "descripcion":"TRAUMATISMO PERINEAL Y VULVAR DURANTE EL PARTO"
  },
  {
    "codigo":726020009,
    "descripcion":"INFESTACIÓN CAUSADA POR CORDYLOBIA ANTHROPOPHAGA"
  },
  {
    "codigo":3289004,
    "descripcion":"ANISOMETROPÍA"
  },
  {
    "codigo":298201005,
    "descripcion":"HIPERMOVILIDAD DE ARTICULACIÓN METATARSOFALÁNGICA"
  },
  {
    "codigo":789721005,
    "descripcion":"PARAGANGLIOMA MALIGNO DE OÍDO MEDIO"
  },
  {
    "codigo":394670005,
    "descripcion":"SENSIBILIDAD AL MONOFILAMENTO 10G DEL PIE IZQUIERDO NORMAL"
  },
  {
    "codigo":32387000,
    "descripcion":"INTOXICACIÓN AGUDA POR SELENIO"
  },
  {
    "codigo":296366008,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE ACETILCOLINA"
  },
  {
    "codigo":294531005,
    "descripcion":"ALERGIA A CARBAPENEM"
  },
  {
    "codigo":16079011000119105,
    "descripcion":"ÁCIDO DESOXIRRIBONUCLEICO DE PAPILOMAVIRUS HUMANO DE BAJO RIESGO DETECTADO EN MUESTRA OBTENIDA DE CUELLO UTERINO"
  },
  {
    "codigo":720515009,
    "descripcion":"ARTROGRIPOSIS DISTAL TIPO 6"
  },
  {
    "codigo":718680001,
    "descripcion":"SÍNDROME OROFACIODIGITAL TIPO 9"
  },
  {
    "codigo":816984002,
    "descripcion":"ESCLEROSIS MÚLTIPLE PROGRESIVA"
  },
  {
    "codigo":292696007,
    "descripcion":"REACCIÓN ADVERSA AL DANTROLENO"
  },
  {
    "codigo":290861000,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR FENELZINA"
  },
  {
    "codigo":678051000119107,
    "descripcion":"HEMORRAGIA PRERRETINIANA BILATERAL"
  },
  {
    "codigo":389165004,
    "descripcion":"BRAQUIOLMIA - TIPO MAROTEAUX"
  },
  {
    "codigo":94253005,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA PARED DEL TÓRAX"
  },
  {
    "codigo":11819171000119108,
    "descripcion":"ESGUINCE DE LIGAMENTO DE ARTICULACIÓN DE HOMBRO DERECHO"
  },
  {
    "codigo":190722000,
    "descripcion":"TRASTORNO DEL METABOLISMO DE LA TREONINA"
  },
  {
    "codigo":127021009,
    "descripcion":"NEOPLASIA DE LA GLÁNDULA SUPRARRENAL"
  },
  {
    "codigo":289026001,
    "descripcion":"COME CON LOS DEDOS"
  },
  {
    "codigo":92418004,
    "descripcion":"NEOPLASIA BENIGNA DE LA PARED SUPERIOR DE LA NASOFARINGE"
  },
  {
    "codigo":188887002,
    "descripcion":"NEOPLASIA BENIGNA DE CARINA BRONQUIAL"
  },
  {
    "codigo":254423005,
    "descripcion":"CARCINOMA DE LA AMÍGDALA LINGUAL"
  },
  {
    "codigo":713175006,
    "descripcion":"BRONQUITIS POSOPERATORIA"
  },
  {
    "codigo":187052004,
    "descripcion":"HISTOPLASMOSIS PULMONAR AFRICANA"
  },
  {
    "codigo":840577000,
    "descripcion":"SURCO MEDIO DE LA PRÓSTATA PALPABLE"
  },
  {
    "codigo":1268396008,
    "descripcion":"CARCINOMA PRIMARIO INDIFERENCIADO DE ESTÓMAGO"
  },
  {
    "codigo":283521006,
    "descripcion":"HERIDA PUNZANTE DE PULGAR"
  },
  {
    "codigo":445526000,
    "descripcion":"FRACTURA PATOLÓGICA DE TIBIA"
  },
  {
    "codigo":85078005,
    "descripcion":"INFERTILIDAD FEMENINA SECUNDARIA A OCLUSIÓN DE LAS TROMPAS DE FALOPIO"
  },
  {
    "codigo":871510007,
    "descripcion":"REACCIÓN ADVERSA A ÁCIDO CLAVULÁNICO Y\/O TICARCILINA"
  },
  {
    "codigo":1197355000,
    "descripcion":"NEOPLASIA MESENQUIMAL PRIMARIA MALIGNA DE RECTO"
  },
  {
    "codigo":707670009,
    "descripcion":"BLASTOMA PLEUROPULMONAR"
  },
  {
    "codigo":247083003,
    "descripcion":"ENCARCELAMIENTO DEL VÍTREO"
  },
  {
    "codigo":83243004,
    "descripcion":"PISO PÉLVICO RÍGIDO QUE AFECTA AL EMBARAZO"
  },
  {
    "codigo":278016005,
    "descripcion":"CONGELACIÓN URÉMICA"
  },
  {
    "codigo":1193685002,
    "descripcion":"INFLAMACIÓN INTESTINAL POR ESCHERICHIA COLI ENTEROPATÓGENA"
  },
  {
    "codigo":472789005,
    "descripcion":"OBSTRUCCIÓN DE VÍA VENOSA PULMONAR CONSTRUIDA QUIRÚRGICAMENTE COMO COMPLICACIÓN DE PROCEDIMIENTO"
  },
  {
    "codigo":896938001,
    "descripcion":"FORMA DE BALA ANORMAL CONGÉNITA DE FALANGE PROXIMAL DE DEDO GORDO"
  },
  {
    "codigo":307114003,
    "descripcion":"SOLICITUD DE TRASLADO LABORAL"
  },
  {
    "codigo":700330005,
    "descripcion":"QUISTE DE PÁRPADO INFERIOR"
  },
  {
    "codigo":403583006,
    "descripcion":"HERIDA CORTANTE AUTOINFLIGIDA DELIBERADAMENTE"
  },
  {
    "codigo":239743009,
    "descripcion":"CONTRACTURA DE LA ARTICULACIÓN DE DEDO DEL PIE"
  },
  {
    "codigo":41300001,
    "descripcion":"DISMINUCIÓN DE GLOBULINA LIGADORA DE TIROXINA LIGADA AL CROMOSOMA X"
  },
  {
    "codigo":205140006,
    "descripcion":"SINDACTILIA SIMPLE DE DEDOS DE LA MANO - SEGUNDA A CUARTA MEMBRANA INTERDIGITAL"
  },
  {
    "codigo":303444007,
    "descripcion":"DIFICULTAD PARA CONSTRUIR COSAS"
  },
  {
    "codigo":268841001,
    "descripcion":"DACRIOCISTITIS O CONJUNTIVITIS NEONATALES CAUSADAS POR VIRUS"
  },
  {
    "codigo":237908009,
    "descripcion":"HIPOMAGNESEMIA FARMACÓGENA"
  },
  {
    "codigo":170537006,
    "descripcion":"REQUIERE UN REFUERZO DE VACUNA ANTITETÁNICA"
  },
  {
    "codigo":39465007,
    "descripcion":"ENANISMO PSICOSOCIAL"
  },
  {
    "codigo":1153577007,
    "descripcion":"HORMONA TIROESTIMULANTE SÉRICA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":301609007,
    "descripcion":"NO SUBIR NI BAJA ESCALERAS HACIA ATRÁS"
  },
  {
    "codigo":234238003,
    "descripcion":"UMBRAL ALTO DEL DESFIBRILADOR IMPLANTADO"
  },
  {
    "codigo":398078006,
    "descripcion":"DEFECTO PERICÁRDICO"
  },
  {
    "codigo":365310007,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA LAVAR LA ROPA"
  },
  {
    "codigo":299774008,
    "descripcion":"REFLEJO TÓNICO CERVICAL PRESENTE"
  },
  {
    "codigo":1348350009,
    "descripcion":"FLUOROSCOPIA DE TRACTO GASTROINTESTINAL ANORMAL"
  },
  {
    "codigo":68563002,
    "descripcion":"INTOXICACIÓN POR INHIBIDOR DE LA ANHIDRASA CARBÓNICA"
  },
  {
    "codigo":232403001,
    "descripcion":"FARINGITIS POR CLAMIDIAS"
  },
  {
    "codigo":363475005,
    "descripcion":"NEOPLASIA MALIGNA DE MÉDULA ESPINAL"
  },
  {
    "codigo":1344680000,
    "descripcion":"QUISTE DERMOIDE DE PÁRPADO IZQUIERDO"
  },
  {
    "codigo":722088001,
    "descripcion":"NEFROPATÍA OBSTRUCTIVA DEBIDA A NEOPLASIA MALIGNA"
  },
  {
    "codigo":396243008,
    "descripcion":"MARGEN QUIRÚRGICO ENDOCERVICAL NO COMPROMETIDO POR NEOPLASIA MALIGNA"
  },
  {
    "codigo":230568001,
    "descripcion":"NEUROPATÍA POR DEFICIENCIA DE VITAMINA B6"
  },
  {
    "codigo":296104001,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE MEDAZEPAM"
  },
  {
    "codigo":294269001,
    "descripcion":"ALERGIA A MESNA"
  },
  {
    "codigo":32125003,
    "descripcion":"INTOXICACIÓN POR IPOMOEA"
  },
  {
    "codigo":1144402004,
    "descripcion":"HIPOPLASIA CONGÉNITA DE CINTILLA ÓPTICA"
  },
  {
    "codigo":292434004,
    "descripcion":"REACCIÓN ADVERSA AL CARTEOLOL"
  },
  {
    "codigo":95826006,
    "descripcion":"ACÚFENOS VIBRATORIO"
  },
  {
    "codigo":423506005,
    "descripcion":"CARCINOMA ESCAMOCELULAR DE CONDUCTO AUDITIVO EXTERNO"
  },
  {
    "codigo":126759001,
    "descripcion":"NEOPLASIA DE VASO SANGUÍNEO DE GLÚTEO"
  },
  {
    "codigo":421671002,
    "descripcion":"NEUMONÍA CON SÍNDROME DE INMUNODEFICIENCIA ADQUIRIDA"
  },
  {
    "codigo":290599002,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR CICLOFOSFAMIDA"
  },
  {
    "codigo":714748000,
    "descripcion":"TIENE PLANIFICACIÓN ANTICIPADA DE CUIDADOS"
  },
  {
    "codigo":93991009,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL LÓBULO INFERIOR DERECHO DEL PULMÓN"
  },
  {
    "codigo":288764000,
    "descripcion":"INCAPAZ DE COMUNICAR SENTIMIENTOS"
  },
  {
    "codigo":190460008,
    "descripcion":"HEMORRAGIA PARATIROIDEA"
  },
  {
    "codigo":1204433000,
    "descripcion":"INTOXICACIÓN POR DETERGENTE"
  },
  {
    "codigo":92156008,
    "descripcion":"NEOPLASIA BENIGNA DE LOS GANGLIOS LINFÁTICOS INTRATORÁCICOS"
  },
  {
    "codigo":254161004,
    "descripcion":"ICTIOSIS LAMELAR ERITRODÉRMICA"
  },
  {
    "codigo":10759231000119102,
    "descripcion":"SALPINGOOFORITIS EN EL EMBARAZO"
  },
  {
    "codigo":57553009,
    "descripcion":"ALUCINACIÓN INCONGRUENTE CON EL ESTADO DE ÁNIMO"
  },
  {
    "codigo":683071000119103,
    "descripcion":"COLANGIOADENOMA DE VÍA BILIAR EXTRAHEPÁTICA"
  },
  {
    "codigo":416166006,
    "descripcion":"ASIMETRÍA SUPERIOR-INFERIOR (IMAGEN EN ESPEJO) DURANTE EL MOVIMIENTO"
  },
  {
    "codigo":840315000,
    "descripcion":"OCLUSIÓN DE PORCIÓN DISTAL DE RAMA DESCENDENTE ANTERIOR DE ARTERIA CORONARIA IZQUIERDA"
  },
  {
    "codigo":119419001,
    "descripcion":"CIANOSIS CUTÁNEA"
  },
  {
    "codigo":283259002,
    "descripcion":"VIDRIO EN ABDOMEN"
  },
  {
    "codigo":1004155003,
    "descripcion":"SUSCEPTIBILIDAD GENÉTICA INCIERTA A LA HIPERTERMIA MALIGNA DEBIDA A MUTACIÓN DEL GEN CACNA1S"
  },
  {
    "codigo":86651002,
    "descripcion":"FRECUENCIA DEL PULSO AUMENTADA"
  },
  {
    "codigo":445264002,
    "descripcion":"DEFECTO DEL TABIQUE AURICULOVENTRICULAR CON DESEQUILIBRIO VENTRICULAR CONSISTENTE EN VENTRÍCULO IZQUIERDO DOMINANTE Y VENTRÍCULO DERECHO HIPOPLÁSICO"
  },
  {
    "codigo":1231696003,
    "descripcion":"PÉRDIDA TRANSITORIA DE VISIÓN CAUSADA POR LUZ"
  },
  {
    "codigo":52048004,
    "descripcion":"FALLO DE VÁLVULA PULMONAR REUMÁTICA"
  },
  {
    "codigo":84816006,
    "descripcion":"PORFIRIA TIPO CHESTER"
  },
  {
    "codigo":281424007,
    "descripcion":"CRITERIOS NO CUMPLIDOS DE MUERTE DEL TRONCO ENCEFÁLICO"
  },
  {
    "codigo":707408006,
    "descripcion":"CARCINOMA PRIMARIO MICROCÍTICO, NO QUERATINIZANTE, DE CÉLULAS ESCAMOSAS DE PULMÓN"
  },
  {
    "codigo":312357002,
    "descripcion":"DERIVADO POR CONSULTOR"
  },
  {
    "codigo":115749008,
    "descripcion":"FENOTIPO LEWIS NULO"
  },
  {
    "codigo":277754002,
    "descripcion":"DISTANCIA DE LA PRUEBA OCULAR COMO ESTABA ESPECIFICADO"
  },
  {
    "codigo":308687000,
    "descripcion":"SOPLO, AÓRTICO"
  },
  {
    "codigo":212218009,
    "descripcion":"LESIÓN DE RAÍZ DE NERVIO LUMBAR - L1"
  },
  {
    "codigo":1258959006,
    "descripcion":"OSTEORRADIONECROSIS DE CLIVUS"
  },
  {
    "codigo":110244000,
    "descripcion":"CONTUSIÓN DE LA FRENTE"
  },
  {
    "codigo":863908005,
    "descripcion":"TUMORACIÓN EN LUGAR DE VACUNACIÓN"
  },
  {
    "codigo":306852006,
    "descripcion":"OCLUSIÓN DE INJERTO-PUENTE DE ARTERIA RENAL"
  },
  {
    "codigo":274084007,
    "descripcion":"CARCINOMA DE PALADAR"
  },
  {
    "codigo":1255289006,
    "descripcion":"TRASTORNO DE MAMA DURANTE EMBARAZO, PARTO Y\/O PUERPERIO"
  },
  {
    "codigo":403321007,
    "descripcion":"ALOPECIA AREATA CIRCUNSCRIPTA DE PESTAÑAS\/CEJAS"
  },
  {
    "codigo":73806001,
    "descripcion":"OOFORITIS SUBAGUDA"
  },
  {
    "codigo":204878001,
    "descripcion":"TESTÍCULO NO DESCENDIDO"
  },
  {
    "codigo":237646004,
    "descripcion":"HIPERINSULINEMIA FARMACÓGENA"
  },
  {
    "codigo":301347005,
    "descripcion":"HALLAZGO RELACIONADO CON EL TAMAÑO DE LABIO"
  },
  {
    "codigo":235811005,
    "descripcion":"VÓLVULO CECAL"
  },
  {
    "codigo":299512002,
    "descripcion":"DOLOR A LA PALPACIÓN EN ARTICULACIÓN DE PIE"
  },
  {
    "codigo":102904004,
    "descripcion":"RELACIÓN EMOCIONAL ABUSIVA CON LOS HIJOS"
  },
  {
    "codigo":199373000,
    "descripcion":"CABEZA ALTA DE TÉRMINO"
  },
  {
    "codigo":70136009,
    "descripcion":"EFECTO TÓXICO DEL MALATIÓN"
  },
  {
    "codigo":233976008,
    "descripcion":"TROMBOSIS EN LA BIFURCACIÓN DE LA AORTA"
  },
  {
    "codigo":365048008,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA EMPLEAR LOS ELEMENTOS DEL LENGUAJE"
  },
  {
    "codigo":68301001,
    "descripcion":"FÍSTULA VESICORRECTAL"
  },
  {
    "codigo":428749005,
    "descripcion":"HALLADO SOBRE MUEBLE"
  },
  {
    "codigo":263074000,
    "descripcion":"FRACTURA-LUXACIÓN DE ARTICULACIÓN ESTERNOCLAVICULAR"
  },
  {
    "codigo":230306001,
    "descripcion":"COREA HEREDITARIA BENIGNA"
  },
  {
    "codigo":721826001,
    "descripcion":"ENCEFALITIS CAUSADA POR COENURUS CEREBRALIS"
  },
  {
    "codigo":228471003,
    "descripcion":"RELACIÓN HETEROSEXUAL"
  },
  {
    "codigo":425079005,
    "descripcion":"ACETILADOR LENTO POR VARIANTE ENZIMÁTICA DE N-ACETILTRANSFERASA"
  },
  {
    "codigo":64631008,
    "descripcion":"ENFERMEDAD POR TIERRA DE FULLER"
  },
  {
    "codigo":294007009,
    "descripcion":"ALERGIA A PILOCARPINA"
  },
  {
    "codigo":95564001,
    "descripcion":"PANCREATENFRAXIS"
  },
  {
    "codigo":128332003,
    "descripcion":"ANOMALÍA CONGÉNITA DE ÓRGANO DEL APARATO DIGESTIVO"
  },
  {
    "codigo":292172003,
    "descripcion":"REACCIÓN ADVERSA AL HALOTANO"
  },
  {
    "codigo":30028006,
    "descripcion":"ESPONDILOSQUISIS"
  },
  {
    "codigo":126497000,
    "descripcion":"NEOPLASIA DE LA PIEL DEL MENTÓN"
  },
  {
    "codigo":1142305002,
    "descripcion":"PELO DE CEJA FINO"
  },
  {
    "codigo":28193003,
    "descripcion":"OSTEODISTROFIA HEPÁTICA"
  },
  {
    "codigo":3751000119101,
    "descripcion":"HIPERTROFIA LABIOS VULVARES"
  },
  {
    "codigo":93729006,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE BRONQUIO DEL LÓBULO INFERIOR IZQUIERDO DEL PULMÓN"
  },
  {
    "codigo":386806002,
    "descripcion":"COGNICIÓN ALTERADA"
  },
  {
    "codigo":91894007,
    "descripcion":"AUSENCIA CONGÉNITA DEL CENTRO DE LA VÉRTEBRA LUMBAR"
  },
  {
    "codigo":26358008,
    "descripcion":"PLACENTA ECTÓPICA"
  },
  {
    "codigo":1204171000,
    "descripcion":"TAQUICARDIA VENTRICULAR BIDIRECCIONAL"
  },
  {
    "codigo":253899000,
    "descripcion":"DIVERTÍCULO DEL URACO"
  },
  {
    "codigo":286667006,
    "descripcion":"DEVALUACIÓN - MECANISMO DE DEFENSA PSICOLÓGICA"
  },
  {
    "codigo":448672006,
    "descripcion":"LINFOMA NO HODGKIN FOLICULAR DE PULMÓN"
  },
  {
    "codigo":284832007,
    "descripcion":"DIFICULTAD PARA SECARSE"
  },
  {
    "codigo":1003893000,
    "descripcion":"DUPLICACIÓN DE PORCIÓN PROXIMAL DEL BRAZO LARGO DEL CROMOSOMA 8"
  },
  {
    "codigo":282997002,
    "descripcion":"INCAPAZ DE VOLTEAR EL CUERPO"
  },
  {
    "codigo":414069003,
    "descripcion":"SOPLO DE DUROZIEZ"
  },
  {
    "codigo":304961000119101,
    "descripcion":"AUSENCIA CONGÉNITA DE PIERNA Y PIE IZQUIERDOS"
  },
  {
    "codigo":53621005,
    "descripcion":"FLUJO CARDÍACO ANORMAL"
  },
  {
    "codigo":445002005,
    "descripcion":"DEFECTO DEL TABIQUE AURICULOVENTRICULAR CON ORIFICIOS AURICULOVENTRICULARES SEPARADOS"
  },
  {
    "codigo":1264202006,
    "descripcion":"TRASTORNO NEONATAL PRECOZ CAUSADO POR TRANSFERENCIA PLACENTARIA DE MEPERIDINA MATERNA DURANTE TRABAJO DE PARTO"
  },
  {
    "codigo":248394008,
    "descripcion":"ÓRBITA ELEVADA"
  },
  {
    "codigo":1196831009,
    "descripcion":"NEVO MELANOCÍTICO CUTÁNEO IRRITADO"
  },
  {
    "codigo":310260004,
    "descripcion":"ANTICUERPO ANTI - LA DETECTADO"
  },
  {
    "codigo":80884006,
    "descripcion":"DESDOBLAMIENTO DISMINUIDO DEL SEGUNDO RUIDO CARDÍACO, R>2<"
  },
  {
    "codigo":111817006,
    "descripcion":"INFECCIÓN CAUSADA POR SHIGELLA"
  },
  {
    "codigo":79049007,
    "descripcion":"CIRCUNDUCCIÓN AUMENTADA"
  },
  {
    "codigo":77214000,
    "descripcion":"INFECCIÓN CAUSADA POR CYLONOCOTYLE"
  },
  {
    "codigo":208286002,
    "descripcion":"FRACTURA EXPUESTA DE HÚMERO DISTAL, MÚLTIPLE"
  },
  {
    "codigo":109982002,
    "descripcion":"ENFERMEDAD DE CADENAS PESADAS ALFA (CLÍNICO)"
  },
  {
    "codigo":1156723000,
    "descripcion":"DEFORMIDAD DE CONVEXIDAD DOBLE EN POLO INFERIOR DE MAMA DEBIDA A AUMENTO QUIRÚRGICO DE MAMA CON INSERCIÓN DE PRÓTESIS Y POSTERIOR A ÉL"
  },
  {
    "codigo":372126009,
    "descripcion":"NEOPLASIA MALIGNA DE PIEL DE TRONCO"
  },
  {
    "codigo":9843006,
    "descripcion":"COLANGITIS - COLANGIOHEPATITIS LINFOCÍTICA CRÓNICA"
  },
  {
    "codigo":403059006,
    "descripcion":"ONICOMICOSIS DEL PIE"
  },
  {
    "codigo":302920007,
    "descripcion":"MALABSORCIÓN PANCREÁTICA"
  },
  {
    "codigo":399389000,
    "descripcion":"TUMOR UNIFOCAL"
  },
  {
    "codigo":204616008,
    "descripcion":"PALADAR HENDIDO COMPLETO CENTRAL CON LABIO LEPORINO"
  },
  {
    "codigo":170013002,
    "descripcion":"PESO DEL NIÑO MAYOR AL PERCENTILO 97"
  },
  {
    "codigo":10737781000119101,
    "descripcion":"CARCINOMA ENDOMETRIOIDE PRIMARIO DE OVARIO DERECHO"
  },
  {
    "codigo":1251357005,
    "descripcion":"DERMATITIS SEBORREICA DE PLIEGUE CUTÁNEO INGUINAL"
  },
  {
    "codigo":38941006,
    "descripcion":"DISCINESIA TARDÍA INDUCIDA POR NEUROLÉPTICOS"
  },
  {
    "codigo":200946001,
    "descripcion":"SÍNDROME ESTAFILOCÓCICO DE LA PIEL ESCALDADA"
  },
  {
    "codigo":364786002,
    "descripcion":"HALLAZGO EN LA CAPACIDAD DE ALIMENTARSE"
  },
  {
    "codigo":4338008,
    "descripcion":"SÍNDROME DE TOS REFLEJA NERVIOSA DE ARNOLD"
  },
  {
    "codigo":428487003,
    "descripcion":"OBSTRUCCIÓN PARCIAL DE LA VÍA AÉREA CAUSADA POR LA LENGUA"
  },
  {
    "codigo":199111004,
    "descripcion":"INFECCIÓN DE VÍAS URINARIAS, POSPARTO"
  },
  {
    "codigo":6261000119104,
    "descripcion":"INTERRUPCIÓN INDUCIDA DEL EMBARAZO EN EL SEGUNDO TRIMESTRE"
  },
  {
    "codigo":395719003,
    "descripcion":"INVASIÓN TUMORAL EXTRAMURAL DE PEQUEÑOS VASOS LINFÁTICOS, PRESENTE"
  },
  {
    "codigo":788935009,
    "descripcion":"FOLICULITIS CRURAL PUSTULOSA ATRÓFICA"
  },
  {
    "codigo":231879009,
    "descripcion":"HERIDA PERFORANTE DE ESCLERÓTICA"
  },
  {
    "codigo":295580009,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE PROCAÍNA"
  },
  {
    "codigo":719729002,
    "descripcion":"CAPAZ DE PARTICIPAR EN ACTIVIDADES DEL AULA"
  },
  {
    "codigo":424817005,
    "descripcion":"FRACTURA EXPUESTA DE LA BASE DEL QUINTO METATARSIANO"
  },
  {
    "codigo":293745006,
    "descripcion":"ALERGIA A TIOTEPA"
  },
  {
    "codigo":31601007,
    "descripcion":"EMBARAZO COMBINADO"
  },
  {
    "codigo":717894000,
    "descripcion":"CATARATA DEBIDA A PSEUDOHIPOPARATIROIDISMO"
  },
  {
    "codigo":1342321009,
    "descripcion":"EMPIEMA DE ESPACIO SUBDURAL"
  },
  {
    "codigo":95302001,
    "descripcion":"VÉRTEBRA DORSAL SUPERNUMERARIA"
  },
  {
    "codigo":64369009,
    "descripcion":"TRAQUEÍTIS AGUDA SIN OBSTRUCCIÓN"
  },
  {
    "codigo":10629391000119103,
    "descripcion":"RINITIS ALÉRGICA CAUSADA POR PLUMAS"
  },
  {
    "codigo":128070006,
    "descripcion":"ENFERMEDAD INFECCIOSA DEL ABDOMEN"
  },
  {
    "codigo":60699003,
    "descripcion":"ANOMALÍA CONGÉNITA DE ESTÓMAGO"
  },
  {
    "codigo":1142043006,
    "descripcion":"INSUFICIENCIA DE VÁLVULA PULMONAR DEBIDA A SÍFILIS TARDÍA"
  },
  {
    "codigo":124400005,
    "descripcion":"DEFICIENCIA DE SULFUROTRANSFERASA"
  },
  {
    "codigo":91632005,
    "descripcion":"HIPOFOSFATURIA"
  },
  {
    "codigo":253637002,
    "descripcion":"ORIGEN ANÓMALO DE ARTERIA PULMONAR IZQUIERDA EN AORTA ASCENDENTE"
  },
  {
    "codigo":89797005,
    "descripcion":"SÍNCOPE POR CALOR"
  },
  {
    "codigo":57029005,
    "descripcion":"COMPLICACIÓN TRAUMÁTICA DE LESIÓN"
  },
  {
    "codigo":284570001,
    "descripcion":"CUERPO EXTRAÑO METÁLICO EN LA REGIÓN AURICULAR"
  },
  {
    "codigo":11995561000119103,
    "descripcion":"DEHISCENCIA DE HERIDA DE MUÑÓN DE AMPUTACIÓN DE EXTREMIDAD SUPERIOR DERECHA"
  },
  {
    "codigo":186266008,
    "descripcion":"IRIDOCICLITIS CRÓNICA TUBERCULOSA"
  },
  {
    "codigo":315503000,
    "descripcion":"NACIDO EN POLONIA"
  },
  {
    "codigo":249967008,
    "descripcion":"MOVIMIENTO DE AGITACIÓN DE BRAZO"
  },
  {
    "codigo":1296708001,
    "descripcion":"NEOVASCULARIZACIÓN DE OJO DERECHO"
  },
  {
    "codigo":413807008,
    "descripcion":"HERNIA DE CEREBELO"
  },
  {
    "codigo":18756002,
    "descripcion":"GANGLIOSIDOSIS GM1 JUVENIL"
  },
  {
    "codigo":248132003,
    "descripcion":"DESEO VEHEMENTE DE ALIMENTOS O BEBIDAS"
  },
  {
    "codigo":84292000,
    "descripcion":"PERÍODO RETRASADO"
  },
  {
    "codigo":1073731000119100,
    "descripcion":"ARTRITIS REUMATOIDE DE RODILLA IZQUIERDA"
  },
  {
    "codigo":1263940008,
    "descripcion":"HEMORRAGIA FETAL INTRACRANEAL SUBDURAL NO TRAUMÁTICA"
  },
  {
    "codigo":705049001,
    "descripcion":"DIFICULTAD EN AUTOCUIDADO DE ENFERMEDAD"
  },
  {
    "codigo":10930601000119107,
    "descripcion":"FRACTURA NO EXPUESTA DE HUESO METATARSIANO DE PIE DERECHO"
  },
  {
    "codigo":16228931000119102,
    "descripcion":"MIOCARDIOPATÍA CAUSADA POR FÁRMACO"
  },
  {
    "codigo":703214003,
    "descripcion":"ENFERMEDAD VASOESPÁSTICA CORONARIA SILENCIOSA"
  },
  {
    "codigo":441070005,
    "descripcion":"ENTEROVIRUS HUMANO PRESENTE"
  },
  {
    "codigo":277230006,
    "descripcion":"ADENOIDES AUSENTES"
  },
  {
    "codigo":1260270005,
    "descripcion":"SÍNDROME MIELODISPLÁSICO HIPOPLÁSICO"
  },
  {
    "codigo":275395000,
    "descripcion":"CARCINOMA DE DOS TERCIOS ANTERIORES DE CARA VENTRAL DE LENGUA"
  },
  {
    "codigo":8771000119104,
    "descripcion":"ALTERACIÓN VISUAL BILATERAL MODERADA A SEVERA"
  },
  {
    "codigo":109720002,
    "descripcion":"HIPERPLASIA CORONOIDE MANDIBULAR BILATERAL"
  },
  {
    "codigo":240792005,
    "descripcion":"FIBROSIS EN BOQUILLA DE PIPA DE SYMMER"
  },
  {
    "codigo":371864007,
    "descripcion":"TIMI GRADO 2: PERFUSIÓN PARCIAL"
  },
  {
    "codigo":75117001,
    "descripcion":"FORMA DE UNA COLONIA BACTERIANA"
  },
  {
    "codigo":11805251000119107,
    "descripcion":"SUBLUXACIÓN DE ARTICULACIÓN INTERFALÁNGICA PROXIMAL DE DEDO MEDIO DE MANO IZQUIERDA"
  },
  {
    "codigo":1156461003,
    "descripcion":"GLIOSARCOMA CEREBRAL"
  },
  {
    "codigo":1287533008,
    "descripcion":"ABRASIÓN DE PIEL DE CARA PALMAR DE REGIÓN DE MUÑECA"
  },
  {
    "codigo":106050001,
    "descripcion":"HALLAZGO RELACIONADO CON EL MOVIMIENTO RESPIRATORIO"
  },
  {
    "codigo":238957009,
    "descripcion":"CÁLCULO CUTÁNEO"
  },
  {
    "codigo":402797009,
    "descripcion":"INFECCIÓN NEONATAL PIÓGENA DE LA PIEL"
  },
  {
    "codigo":204354004,
    "descripcion":"ATRESIA Y ESTENOSIS CONGÉNITA DE VÁLVULA TRICÚSPIDE"
  },
  {
    "codigo":400962005,
    "descripcion":"MIOSIS CONGÉNITA"
  },
  {
    "codigo":237122005,
    "descripcion":"AMENORREA RELACIONADA CON LA LACTANCIA"
  },
  {
    "codigo":169751003,
    "descripcion":"CAMBIO DE LACTANCIA ARTIFICIAL A LACTANCIA MATERNA"
  },
  {
    "codigo":724972000,
    "descripcion":"LESIÓN TRAUMÁTICA DE FASCIA DE MÚSCULO EXTENSOR DE DEDO DE LA MANO A LA ALTURA DEL ANTEBRAZO"
  },
  {
    "codigo":298988005,
    "descripcion":"AMPLITUD DE ADUCCIÓN PASIVA DE ARTICULACIÓN DE MUÑECA, AUMENTADA"
  },
  {
    "codigo":2241003,
    "descripcion":"AUSENCIA DE GLOBULINA LIGADORA DE TIROXINA LIGADA AL CROMOSOMA X"
  },
  {
    "codigo":459158000,
    "descripcion":"ENDOCARDITIS INFECCIOSA DE VÁLVULA AURICULOVENTRICULAR IZQUIERDA (MORFOLÓGICAMENTE NO MITRAL)"
  },
  {
    "codigo":297153009,
    "descripcion":"TROMBOSIS DE ARTERIA FEMORAL PROFUNDA"
  },
  {
    "codigo":786838002,
    "descripcion":"NÓDULO DE PULMÓN"
  },
  {
    "codigo":262550002,
    "descripcion":"PICADURA DE INSECTO INFECTADA"
  },
  {
    "codigo":15956701000119109,
    "descripcion":"CARCINOMA MICROCÍTICO METASTÁSICO DE PULMÓN IZQUIERDO"
  },
  {
    "codigo":360854006,
    "descripcion":"DEFICIENCIA DE ISOMALTASA"
  },
  {
    "codigo":293483006,
    "descripcion":"REACCIÓN ADVERSA AL MANITOL"
  },
  {
    "codigo":31339007,
    "descripcion":"QUISTE CONGÉNITO DE LA VULVA"
  },
  {
    "codigo":424555008,
    "descripcion":"PUNTAJE DE MALLAMPATI NO EVALUABLE"
  },
  {
    "codigo":129643009,
    "descripcion":"NEUTROPENIA HIPOPLÁSICA CRÓNICA"
  },
  {
    "codigo":717632002,
    "descripcion":"SÍNDROME DE LISENCEFALIA LIGADA AL CROMOSOMA X CON AGENESIA DE CUERPO CALLOSO Y ANOMALÍAS GENITALES"
  },
  {
    "codigo":1145451006,
    "descripcion":"APLASIA DE HUESO DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":29504002,
    "descripcion":"DISTROFIA CORNEAL POLIMORFA POSTERIOR"
  },
  {
    "codigo":226112001,
    "descripcion":"DIETA CON CONTENIDO BAJO EN GRASAS MONOINSATURADAS"
  },
  {
    "codigo":160576006,
    "descripcion":"BEBEDOR MODERADO - 3 A 6 UNIDADES POR DÍA"
  },
  {
    "codigo":95040006,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LAS GLÁNDULAS SEBÁCEAS"
  },
  {
    "codigo":338961000119100,
    "descripcion":"PTOSIS PARALÍTICA DE PÁRPADO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":11834231000119106,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN RADIOCARPIANA DE MUÑECA DERECHA"
  },
  {
    "codigo":715797002,
    "descripcion":"ENFERMEDAD DE CHARCOT-MARIE-TOOTH TIPO 4C"
  },
  {
    "codigo":291648009,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR DOXICICLINA"
  },
  {
    "codigo":191509004,
    "descripcion":"ESTADO CONFUSIONAL SUBAGUDO, DE ORIGEN INFECCIOSO"
  },
  {
    "codigo":289813004,
    "descripcion":"HALLAZGO RELACIONADO CON EL PATRÓN DE MOCO CERVICAL EN HOJA DE HELECHO"
  },
  {
    "codigo":1010709006,
    "descripcion":"DEFICIENCIA LONGITUDINAL BILATERAL DE PERONÉ"
  },
  {
    "codigo":224277008,
    "descripcion":"HOSPEDAJE NO DECORADO RECIENTEMENTE"
  },
  {
    "codigo":1141781009,
    "descripcion":"DISMETRÍA DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":124138004,
    "descripcion":"DEFICIENCIA DE (R) - 20 - HIDROXIESTEROIDE DESHIDROGENASA"
  },
  {
    "codigo":89535003,
    "descripcion":"INTOXICACIÓN POR ESTRÓGENO"
  },
  {
    "codigo":286143004,
    "descripcion":"LIMPIA EL HORNO"
  },
  {
    "codigo":448148000,
    "descripcion":"NEOPLASIA HIPOFISARIA FUNCIONANTE"
  },
  {
    "codigo":253375009,
    "descripcion":"DISPLASIA DE VALVA TRICUSPÍDEA"
  },
  {
    "codigo":251540003,
    "descripcion":"UNIDADES POLIFÁSICAS"
  },
  {
    "codigo":1300116006,
    "descripcion":"ALBINISMO OCULOCUTÁNEO TIPO 8"
  },
  {
    "codigo":284308006,
    "descripcion":"LIBERA LA PRENSIÓN"
  },
  {
    "codigo":20329001,
    "descripcion":"BAJO VOLTAJE VENTRICULAR EN EL ECG"
  },
  {
    "codigo":1003369001,
    "descripcion":"MICROFTALMÍA DEBIDA A SÍNDROME DE DELLEMAN"
  },
  {
    "codigo":773993008,
    "descripcion":"TELANGIECTASIA MACULAR IDIOPÁTICA TIPO 1"
  },
  {
    "codigo":315241008,
    "descripcion":"DOLOR POR METÁSTASIS"
  },
  {
    "codigo":249705009,
    "descripcion":"SEPARACIÓN DE SEGMENTOS COSTALES"
  },
  {
    "codigo":446313009,
    "descripcion":"LACERACIÓN DE TENDÓN DE DEDO DE LA MANO"
  },
  {
    "codigo":84030002,
    "descripcion":"FRACTURA DE HUESO PISIFORME DE LA MUÑECA"
  },
  {
    "codigo":247870000,
    "descripcion":"MIEDO AL HOMBRE DE LA BOLSA"
  },
  {
    "codigo":213267001,
    "descripcion":"LESIÓN NERVIOSA DURANTE LA CIRUGÍA"
  },
  {
    "codigo":1163539003,
    "descripcion":"DACRIOADENITIS POR VIRUS DE LA PAROTIDITIS URLIANA"
  },
  {
    "codigo":770323005,
    "descripcion":"EDEMA DE RETINA DEBIDO A DIABETES MELLITUS"
  },
  {
    "codigo":82195006,
    "descripcion":"FUNCIÓN SEXUAL MASCULINA NORMAL"
  },
  {
    "codigo":38211000087103,
    "descripcion":"HIPOCINESIA DE SEGMENTO APICAL LATERAL DE VENTRÍCULO CARDÍACO IZQUIERDO"
  },
  {
    "codigo":40771000087104,
    "descripcion":"ABRASIÓN DE PIEL DE GLÚTEO IZQUIERDO"
  },
  {
    "codigo":48451000087104,
    "descripcion":"FRACTURA DE APÓFISIS ESTILOIDES DE CÚBITO DERECHO"
  },
  {
    "codigo":43331000087107,
    "descripcion":"LACERACIÓN SIMPLE DE REGIÓN PERIORBITARIA IZQUIERDA"
  },
  {
    "codigo":768488004,
    "descripcion":"HIFAS ANCHAS IRREGULARES DEL REINO FUNGI DETECTADAS"
  },
  {
    "codigo":1260008006,
    "descripcion":"COREA DEBIDA A ACIDEMIA ORGÁNICA HEREDITARIA"
  },
  {
    "codigo":276968006,
    "descripcion":"TUMOR ODONTOGÉNICO DE LA MANDÍBULA"
  },
  {
    "codigo":45757002,
    "descripcion":"PROBLEMA EN EL TRABAJO DE PARTO"
  },
  {
    "codigo":111293003,
    "descripcion":"TROMBOSIS VENOSA"
  },
  {
    "codigo":1290941003,
    "descripcion":"FIBROMA DE GARDNER"
  },
  {
    "codigo":373437006,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM BOVIS"
  },
  {
    "codigo":209597008,
    "descripcion":"DESGARRO COMPLETO DE LIGAMENTO LATERAL DEL CÚBITO"
  },
  {
    "codigo":240530001,
    "descripcion":"ENFERMEDAD CAUSADA POR EL VIRUS DE EPSTEIN-BARR"
  },
  {
    "codigo":109458004,
    "descripcion":"DUPLICACIÓN DE DIENTES"
  },
  {
    "codigo":76690005,
    "descripcion":"ADENOSIS VAGINAL RELACIONADA CON ESTILBESTROL"
  },
  {
    "codigo":43922008,
    "descripcion":"CLAUDICACIÓN DE MANDÍBULA"
  },
  {
    "codigo":238695001,
    "descripcion":"PRURITO ACUAGÉNICO"
  },
  {
    "codigo":369767007,
    "descripcion":"ALTO GRADO (LINFOMA)"
  },
  {
    "codigo":304231009,
    "descripcion":"PIEL GRISÁCEA"
  },
  {
    "codigo":7484005,
    "descripcion":"DOBLE SALIDA DEL VENTRÍCULO DERECHO"
  },
  {
    "codigo":15932741000119106,
    "descripcion":"OBSTRUCCIÓN PROXIMAL DE TROMPA DE FALOPIO DERECHA"
  },
  {
    "codigo":1187132007,
    "descripcion":"BRAQUIDACTILIA DE SUGARMAN"
  },
  {
    "codigo":73020009,
    "descripcion":"HEMORRAGIA DE HEMISFERIO CEREBRAL"
  },
  {
    "codigo":366097005,
    "descripcion":"REFLEJO DE LUZ DE MEMBRANA TIMPÁNICA - HALLAZGO"
  },
  {
    "codigo":235025005,
    "descripcion":"AMPOLLA HEMORRÁGICA TRAUMÁTICA BUCAL"
  },
  {
    "codigo":300561007,
    "descripcion":"VÍAS GENITOURINARIAS NORMALES"
  },
  {
    "codigo":169489007,
    "descripcion":"DISPOSITIVO ANTICONCEPTIVO INTRAUTERINO - EXPULSADO PARCIALMENTE"
  },
  {
    "codigo":298726000,
    "descripcion":"ESTERNÓN ANCHO"
  },
  {
    "codigo":823014002,
    "descripcion":"TRANSMISIÓN DE LA LUZ BLOQUEADA POR TUMEFACCIÓN DE ESCROTO"
  },
  {
    "codigo":890385009,
    "descripcion":"DUPLICACIÓN CONGÉNITA DE VESÍCULA BILIAR TIPO 1"
  },
  {
    "codigo":167654008,
    "descripcion":"ACTIVIDAD DE TRIPSINA FECAL DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1148859000,
    "descripcion":"TRASTORNO FIBRINOLÍTICO MEDICAMENTOSO"
  },
  {
    "codigo":1979001,
    "descripcion":"COROIDITIS FOCAL"
  },
  {
    "codigo":722875003,
    "descripcion":"DISFAGIA FUNCIONAL"
  },
  {
    "codigo":296891003,
    "descripcion":"SOBREDOSIS DE METANDRIOL"
  },
  {
    "codigo":237619009,
    "descripcion":"DIABETES DE HERENCIA MATERNA Y SORDERA"
  },
  {
    "codigo":295056004,
    "descripcion":"ALERGIA A LANATÓSIDO C"
  },
  {
    "codigo":1343632005,
    "descripcion":"TRASTORNO DE CÓRNEA POSTERIOR A CIRUGÍA DE CATARATA"
  },
  {
    "codigo":144008,
    "descripcion":"VISIÓN PERIFÉRICA NORMAL"
  },
  {
    "codigo":426128009,
    "descripcion":"MENINGITIS LINFOMATOSA"
  },
  {
    "codigo":65680009,
    "descripcion":"PÉRDIDA DE LA AUDICIÓN NEUROSENSORIAL EN SITIOS COMBINADOS"
  },
  {
    "codigo":194917003,
    "descripcion":"PERICARDITIS ESTAFILOCÓCICA AGUDA"
  },
  {
    "codigo":15634041000119101,
    "descripcion":"ECOGRAFÍA DE VEJIGA ANORMAL"
  },
  {
    "codigo":719205008,
    "descripcion":"SÍNDROME DE DISPLASIA ESPONDILOMETAFISARIA CON DISTROFIA DE CONOS Y BASTONES"
  },
  {
    "codigo":1208890001,
    "descripcion":"DEGENERACIÓN MACULAR EXUDATIVA AVANZADA RELACIONADA CON LA EDAD"
  },
  {
    "codigo":293221008,
    "descripcion":"REACCIÓN ADVERSA A LA OXIMETOLONA"
  },
  {
    "codigo":15988191000119109,
    "descripcion":"ANOMALÍA CONGÉNITA DE ESCLERÓTICA DERECHA"
  },
  {
    "codigo":94778005,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA CARINA"
  },
  {
    "codigo":291386006,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR COLCHICINA"
  },
  {
    "codigo":29242007,
    "descripcion":"PROCEDIMIENTO QUIRÚRGICO CANCELADO"
  },
  {
    "codigo":341471000119109,
    "descripcion":"CATARATA CONGÉNITA DE OJO IZQUIERDO"
  },
  {
    "codigo":92943002,
    "descripcion":"FORMA ANORMAL CONGÉNITA DE COSTILLA"
  },
  {
    "codigo":191247005,
    "descripcion":"ANEMIA APLÁSICA CAUSADA POR RADIACIÓN"
  },
  {
    "codigo":715535009,
    "descripcion":"SÍNDROME DE QUERATOSIS PALMOPLANTAR Y MIOCARDIOPATÍA ARRITMOGÉNICA"
  },
  {
    "codigo":123876002,
    "descripcion":"INTOXICACIÓN POR APOCYNACEAE"
  },
  {
    "codigo":189412003,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL CARTÍLAGO CRICOIDES"
  },
  {
    "codigo":91108004,
    "descripcion":"OTOESCLEROSIS COCLEAR"
  },
  {
    "codigo":1172452001,
    "descripcion":"HORMONA SEXUAL FEMENINA FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":254948003,
    "descripcion":"ASTROCITOMA DE LA MÉDULA ESPINAL"
  },
  {
    "codigo":289551009,
    "descripcion":"HALLAZGO RELACIONADO CON EL COLOR DE LA SECRECIÓN VAGINAL"
  },
  {
    "codigo":56505000,
    "descripcion":"VOZ ASPIRADA"
  },
  {
    "codigo":58340008,
    "descripcion":"QUEMADURA EPIDÉRMICA DE NARIZ"
  },
  {
    "codigo":449721002,
    "descripcion":"HIPERMETROPÍA FACULTATIVA"
  },
  {
    "codigo":253113003,
    "descripcion":"RAQUISQUISIS CON HIDROCEFALIA"
  },
  {
    "codigo":285881004,
    "descripcion":"INCAPAZ DE USAR EL HORNO DE MICROONDAS"
  },
  {
    "codigo":124691000119101,
    "descripcion":"NEUMONÍA CAUSADA POR STAPHYLOCOCCUS AUREUS RESISTENTE A LA METICILINA"
  },
  {
    "codigo":87438005,
    "descripcion":"LESIÓN TRAUMÁTICA DE VASOS SANGUÍNEOS MÚLTIPLES DEL TÓRAX"
  },
  {
    "codigo":447886005,
    "descripcion":"ADENOCARCINOMA DE UNIÓN ANORRECTAL"
  },
  {
    "codigo":415118009,
    "descripcion":"COMUNICACIÓN PARA LA INVITACIÓN A LA VACUNACIÓN CONTRA EL NEUMOCOCO ENVIADA"
  },
  {
    "codigo":710030009,
    "descripcion":"MORFOLOGÍA DE CRESTA ALVEOLAR RESIDUAL DE MAXILAR SUPERIOR CON DISMINUCIÓN DEL ESPACIO RETROMALAR"
  },
  {
    "codigo":413283004,
    "descripcion":"TUMOR COMPLETAMENTE OBSTRUCTIVO"
  },
  {
    "codigo":18232000,
    "descripcion":"ADAPTACIÓN DETERIORADA"
  },
  {
    "codigo":282211008,
    "descripcion":"SE DETIENE AL CAMINAR"
  },
  {
    "codigo":51000003,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚLTIPLES ÓRGANOS INTRABDOMINALES SIN HERIDA ABIERTA HACIA CAVIDAD ABDOMINAL"
  },
  {
    "codigo":11812781000119100,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DE MUÑECA Y MANO IZQUIERDAS"
  },
  {
    "codigo":313144007,
    "descripcion":"ARTICULACIÓN LARÍNGEA - HALLAZGO"
  },
  {
    "codigo":452251000124103,
    "descripcion":"TRASTORNO DE ARTICULACIÓN DE CODO DERECHO"
  },
  {
    "codigo":247608009,
    "descripcion":"INCAPAZ DE RECORDAR LA FECHA DEL DÍA"
  },
  {
    "codigo":429211000124107,
    "descripcion":"TRASTORNO FETAL CAUSADO POR ANTICONVULSIVANTE TRANSMITIDO POR VÍA PLACENTARIA"
  },
  {
    "codigo":737293005,
    "descripcion":"ESTOMA PRESENTE EN VEJIGA URINARIA"
  },
  {
    "codigo":1259746000,
    "descripcion":"FEOCROMOCITOMA PRIMARIO MALIGNO"
  },
  {
    "codigo":47330001,
    "descripcion":"NEFRITIS TUBULOINTERSTICIAL AGUDA IDIOPÁTICA"
  },
  {
    "codigo":80098002,
    "descripcion":"ENFERMEDAD DE CUERPOS DE LEWY DIFUSA"
  },
  {
    "codigo":735458004,
    "descripcion":"SÍNDROME DE HIPERSENSIBILIDAD A MÚLTIPLES FÁRMACOS"
  },
  {
    "codigo":276706004,
    "descripcion":"ISQUEMIA CEREBRAL PERINATAL"
  },
  {
    "codigo":209335002,
    "descripcion":"FRACTURA-LUXACIÓN NO EXPUESTA DE ARTICULACIÓN DE LA CADERA"
  },
  {
    "codigo":733623005,
    "descripcion":"SÍNDROME DE TRASTORNO DEL ESPECTRO AUTISTA, EPILEPSIA Y ARTROGRIPOSIS"
  },
  {
    "codigo":240268003,
    "descripcion":"EXTRUSIÓN DE PRÓTESIS ARTICULAR"
  },
  {
    "codigo":895628003,
    "descripcion":"FORMA TRIANGULAR ANORMAL CONGÉNITA DE FALANGE DISTAL DE QUINTO DEDO DE PIE"
  },
  {
    "codigo":404108003,
    "descripcion":"MICOSIS FUNGOIDE POIQUILODERMATOSA"
  },
  {
    "codigo":1081261000119106,
    "descripcion":"GLIOMA DE NERVIO ÓPTICO DERECHO"
  },
  {
    "codigo":402273004,
    "descripcion":"DERMATITIS DE CONTACTO IRRITATIVA CRÓNICA DE MANOS"
  },
  {
    "codigo":369505004,
    "descripcion":"TUMOR MALIGNO QUE COMPROMETE LA VAGINA POR PROPAGACIÓN DIRECTA DEL ENDOMETRIO"
  },
  {
    "codigo":1186870001,
    "descripcion":"ENCEFALOPATÍA POR ORGANOFOSFORADO"
  },
  {
    "codigo":205665009,
    "descripcion":"DUPLICACIÓN OBSERVADA SOLAMENTE EN LA PROMETAFASE"
  },
  {
    "codigo":433206003,
    "descripcion":"CAPAZ DE DORMIR"
  },
  {
    "codigo":105526001,
    "descripcion":"FAMILIA SIN HOGAR"
  },
  {
    "codigo":72758005,
    "descripcion":"LESIÓN TRAUMÁTICA DEL NERVIO OLFATORIO"
  },
  {
    "codigo":431371001,
    "descripcion":"PLIEGUES DE MEMBRANA DE BOWMAN"
  },
  {
    "codigo":5387003,
    "descripcion":"NEVO EPIDÉRMICO PILOSO PIGMENTADO"
  },
  {
    "codigo":300299004,
    "descripcion":"ASPIRADO GÁSTRICO CON CONTENIDO DE MATERIA FECAL"
  },
  {
    "codigo":890123006,
    "descripcion":"SÍNDROME DE DELECIÓN 3P25.3"
  },
  {
    "codigo":365835008,
    "descripcion":"HALLAZGO RELACIONADO CON ERITROPOYESIS DE MÉDULA ÓSEA"
  },
  {
    "codigo":724448000,
    "descripcion":"TEMOR A ENFERMEDAD GENITAL"
  },
  {
    "codigo":298464002,
    "descripcion":"OBESIDAD DE ORIGEN ENDOCRINO"
  },
  {
    "codigo":429536005,
    "descripcion":"DISCAPACIDAD DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":722613000,
    "descripcion":"HERIDA PENETRANTE DE GLOBO OCULAR SIN CUERPO EXTRAÑO"
  },
  {
    "codigo":1717003,
    "descripcion":"HIPOMELANOSIS IDIOPÁTICA EN GOTAS"
  },
  {
    "codigo":127201000119101,
    "descripcion":"CHOQUE SÉPTICO CONCOMITANTE CON DISFUNCIÓN ORGÁNICA AGUDA CAUSADO POR PSEUDOMONAS"
  },
  {
    "codigo":15692001000119101,
    "descripcion":"ARTRITIS REUMATOIDEA SEROPOSITIVA DE ARTICULACIÓN DE AMBOS CODOS"
  },
  {
    "codigo":34485008,
    "descripcion":"DIAGNÓSTICO EN EL EJE IV"
  },
  {
    "codigo":1148597009,
    "descripcion":"ARTRITIS REUMÁTICA"
  },
  {
    "codigo":294794001,
    "descripcion":"ALERGIA A ESTRIOL"
  },
  {
    "codigo":161887000,
    "descripcion":"HEMATOMAS ESPONTÁNEOS"
  },
  {
    "codigo":1144927000,
    "descripcion":"TRASTORNO DEL TRACTO GASTROINTESTINAL DEBIDO A LUPUS ERITEMATOSO SISTÉMICO"
  },
  {
    "codigo":30815000,
    "descripcion":"INTOXICACIÓN POR LEUCAENA"
  },
  {
    "codigo":292959000,
    "descripcion":"REACCIÓN ADVERSA A LA FENOXIMETILPENICILINA"
  },
  {
    "codigo":63583004,
    "descripcion":"AGREGACIÓN SOLITARIA"
  },
  {
    "codigo":291124001,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR SULPIRIDA"
  },
  {
    "codigo":94516003,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA RETINA"
  },
  {
    "codigo":289289000,
    "descripcion":"LESIÓN DE MEMBRANA AMNIÓTICA"
  },
  {
    "codigo":127284008,
    "descripcion":"FRACTURA DE PLACA ORBITARIA DE HUESO ETMOIDES"
  },
  {
    "codigo":28980009,
    "descripcion":"INFECCIÓN CAUSADA POR CHILOMASTIX"
  },
  {
    "codigo":92681005,
    "descripcion":"CARCINOMA IN SITU DE LA FARINGE"
  },
  {
    "codigo":59913009,
    "descripcion":"ÚLCERA GÁSTRICA SIN HEMORRAGIA, SIN PERFORACIÓN Y SIN OBSTRUCCIÓN"
  },
  {
    "codigo":123614006,
    "descripcion":"CATARATA PARCIAL"
  },
  {
    "codigo":1336030008,
    "descripcion":"QUERATITIS FUGAZ HEREDITARIA"
  },
  {
    "codigo":254686009,
    "descripcion":"QUISTES MÚLTIPLES DE PELO TERMINAL PIGMENTADO"
  },
  {
    "codigo":15954141000119100,
    "descripcion":"HEMATOMA DE MAMA DERECHA"
  },
  {
    "codigo":102621000119101,
    "descripcion":"ÚLCERA DE PIEL DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":221000119102,
    "descripcion":"NUNCA FUMÓ NINGUNA SUSTANCIA"
  },
  {
    "codigo":1268659005,
    "descripcion":"CAPAZ DE PAGAR REFRIGERACIÓN EN VIVIENDA"
  },
  {
    "codigo":66781000119102,
    "descripcion":"PORTADOR DE SÍNDROME DE COWDEN"
  },
  {
    "codigo":15918301000119102,
    "descripcion":"FRACTURA EXPUESTA DE CRESTA ALVEOLAR DE LADO IZQUIERDO DEL MAXILAR SUPERIOR"
  },
  {
    "codigo":1075421000119106,
    "descripcion":"RUPTURA CRÓNICA DE LIGAMENTO CRUZADO POSTERIOR DE RODILLA DERECHA"
  },
  {
    "codigo":12403421000119107,
    "descripcion":"INESTABILIDAD DE PRÓTESIS DE ARTICULACIÓN GLENOHUMERAL DERECHA"
  },
  {
    "codigo":10754781000119108,
    "descripcion":"CÁLCULO DE VESÍCULA BILIAR EN LA MADRE QUE COMPLICA EL NACIMIENTO"
  },
  {
    "codigo":691421000119108,
    "descripcion":"ANEMIA CONCOMITANTE CON ENFERMEDAD RENAL CRÓNICA EN ESTADIO 3 Y DEBIDA A ELLA"
  },
  {
    "codigo":243421000119104,
    "descripcion":"PROTEINURIA DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":348381000119107,
    "descripcion":"ENDOFTALMITIS AGUDA DE OJO DERECHO"
  },
  {
    "codigo":10939101000119105,
    "descripcion":"HERIDA ABIERTA DE REGIÓN AXILAR IZQUIERDA"
  },
  {
    "codigo":185480009,
    "descripcion":"PACIENTE QUE DEMANDA AL MÉDICO"
  },
  {
    "codigo":335581000119105,
    "descripcion":"ÚLCERA CORNEAL DE HIPOPIÓN DE OJO DERECHO"
  },
  {
    "codigo":673501000119107,
    "descripcion":"EXOSTOSIS DE CÚBITO"
  },
  {
    "codigo":871773004,
    "descripcion":"REACCIÓN ADVERSA A DICLOROACETAMIDA"
  },
  {
    "codigo":183645004,
    "descripcion":"SEGUIMIENTO QUIRÚRGICO, NORMAL"
  },
  {
    "codigo":12103901000119109,
    "descripcion":"QUEMADURA DE PIERNA DERECHA"
  },
  {
    "codigo":100731000119107,
    "descripcion":"ASTROCITOMA CEREBRAL DE BAJO GRADO"
  },
  {
    "codigo":249181009,
    "descripcion":"MEMBRANAS COMPLETAS"
  },
  {
    "codigo":17970006,
    "descripcion":"ESTRECHEZ DE LA VESÍCULA BILIAR"
  },
  {
    "codigo":442119001,
    "descripcion":"CORTOCIRCUITO CARDÍACO"
  },
  {
    "codigo":48903002,
    "descripcion":"ÁNTRAX DE LA AXILA"
  },
  {
    "codigo":702428000,
    "descripcion":"SÍNDROME DE ANGIOPATÍA HEREDITARIA CON NEFROPATÍA, ANEURISMAS Y CALAMBRES MUSCULARES"
  },
  {
    "codigo":210908000,
    "descripcion":"LESIÓN DE MÚLTIPLES VASOS SANGUÍNEOS A NIVEL DE LA CADERA Y EL MUSLO"
  },
  {
    "codigo":473052005,
    "descripcion":"INFECCIÓN ASOCIADA CON DISPOSITIVO DE ACCESO VENOSO COMPLETAMENTE IMPLANTABLE"
  },
  {
    "codigo":276444007,
    "descripcion":"PRURITO GENERALIZADO"
  },
  {
    "codigo":733361001,
    "descripcion":"ADENOCARCINOMA MUCINOSO PRIMARIO DE OVARIO"
  },
  {
    "codigo":405681002,
    "descripcion":"HISTORIA CLÍNICA DEL PACIENTE, NO DISPONIBLE"
  },
  {
    "codigo":45233003,
    "descripcion":"TEMBLOR PERSISTENTE"
  },
  {
    "codigo":274609004,
    "descripcion":"RESPUESTA PLANTAR IZQUIERDA, FLEXORA"
  },
  {
    "codigo":241841002,
    "descripcion":"EFECTO TÓXICO CAUSADO POR LÍQUIDO PARA LAVADO DE VAJILLA"
  },
  {
    "codigo":1255814001,
    "descripcion":"LINFOMA DE HODGKIN DE GANGLIOS LINFÁTICOS DE MIEMBRO SUPERIOR, PREDOMINIO LINFOCÍTICO-HISTIOCÍTICO"
  },
  {
    "codigo":403846004,
    "descripcion":"DERMATOSIS AMPOLLAR NEONATAL CAUSADA POR ANTICUERPOS MATERNOS"
  },
  {
    "codigo":305542006,
    "descripcion":"BAJO ATENCIÓN DE CIRUJANO HEPATOBILIAR"
  },
  {
    "codigo":371078007,
    "descripcion":"PATRÓN DE INGESTA COMPULSIVA"
  },
  {
    "codigo":240006007,
    "descripcion":"LAXITUD LIGAMENTOSA DE LA REGIÓN DE LA RODILLA"
  },
  {
    "codigo":762459007,
    "descripcion":"TRASTORNO DEBIDO A REDUCCIÓN MAMARIA Y POSTERIOR A ELLA"
  },
  {
    "codigo":301872000,
    "descripcion":"LIPOMA DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":926299009,
    "descripcion":"EPÍFISIS PEQUEÑA DE FALANGE PROXIMAL DE MANO"
  },
  {
    "codigo":16022191000119105,
    "descripcion":"TRASTORNO DE LIGAMENTO DE AMBOS PIES"
  },
  {
    "codigo":72496005,
    "descripcion":"DISOCIACIÓN ELECTROMECÁNICA CAUSADA POR MARCAPASOS CARDÍACO"
  },
  {
    "codigo":1186608005,
    "descripcion":"APOYO FAMILIAR INADECUADO"
  },
  {
    "codigo":5125001,
    "descripcion":"TRICOFAGIA HABITUAL"
  },
  {
    "codigo":234501002,
    "descripcion":"QUISTE ESPLÉNICO EPIDERMOIDE"
  },
  {
    "codigo":168965003,
    "descripcion":"VENOGRAFÍA NORMAL"
  },
  {
    "codigo":267269004,
    "descripcion":"HEMATOMA PERINEO-VULVAR DURANTE EL PARTO"
  },
  {
    "codigo":37893005,
    "descripcion":"PELVIS CIFOESCOLIÓTICA"
  },
  {
    "codigo":431109006,
    "descripcion":"PORTADOR DE ENTEROCOCO RESISTENTE A LA VANCOMICINA"
  },
  {
    "codigo":726021008,
    "descripcion":"DEFICIENCIA DE 3-HIDROXIACIL-COENZIMA A DESHIDROGENASA DE CADENA LARGA"
  },
  {
    "codigo":429274001,
    "descripcion":"ESTRECHEZ DE RECTO POR RADIACIÓN"
  },
  {
    "codigo":298202003,
    "descripcion":"HIPERMOVILIDAD DE ARTICULACIÓN INTERFALÁNGICA DE DEDO DE PIE"
  },
  {
    "codigo":165295002,
    "descripcion":"MEMORIA: NO TIENE CONSCIENCIA DEL MES ACTUAL"
  },
  {
    "codigo":427439005,
    "descripcion":"TRASTORNO DE HIPERSENSIBILIDAD INMUNOLÓGICA POR MECANISMO"
  },
  {
    "codigo":15749961000119105,
    "descripcion":"DEBILIDAD DE MÚSCULOS FACIALES DE AMBOS LADOS"
  },
  {
    "codigo":294532003,
    "descripcion":"ALERGIA A CEFALOSPORINA"
  },
  {
    "codigo":32388005,
    "descripcion":"TRASTORNO DE PÁNICO CON AGORAFOBIA, EVITACIÓN AGORAFÓBICA EN REMISIÓN PARCIAL Y ATAQUES DE PÁNICO MODERADOS"
  },
  {
    "codigo":1086281000119106,
    "descripcion":"PERFORACIÓN DE ÍLEON DEBIDA A DIVERTICULITIS"
  },
  {
    "codigo":718681002,
    "descripcion":"SÍNDROME OROFACIODIGITAL TIPO 11"
  },
  {
    "codigo":292697003,
    "descripcion":"REACCIÓN ADVERSA AL ORO"
  },
  {
    "codigo":30553004,
    "descripcion":"PÉRDIDA SENSITIVA DEL NERVIO ESPINAL"
  },
  {
    "codigo":127022002,
    "descripcion":"NEOPLASIA DE LA CORTEZA SUPRARRENAL"
  },
  {
    "codigo":61486003,
    "descripcion":"SACRALGIA"
  },
  {
    "codigo":389166003,
    "descripcion":"DISPLASIA TRICORRINOFALÁNGICA TIPO III"
  },
  {
    "codigo":421934002,
    "descripcion":"ÚLCERA CORNEAL PERIFÉRICA CON CULTIVO NEGATIVO"
  },
  {
    "codigo":94254004,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA COROIDES"
  },
  {
    "codigo":290862007,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR FENELZINA"
  },
  {
    "codigo":26883000,
    "descripcion":"ABSCESO DE RODILLA"
  },
  {
    "codigo":289027005,
    "descripcion":"NO COME CON LOS DEDOS"
  },
  {
    "codigo":59651006,
    "descripcion":"DEMENCIA PERSISTENTE INDUCIDA POR SEDANTES, HIPNÓTICOS Y\/O ANSIOLÍTICOS"
  },
  {
    "codigo":715011007,
    "descripcion":"CAPAZ DE CAMINAR SOBRE UNA SUPERFICIE DESPAREJA"
  },
  {
    "codigo":92419007,
    "descripcion":"NEOPLASIA BENIGNA DE LOS GANGLIOS LINFÁTICOS SUPRACLAVICULARES"
  },
  {
    "codigo":90584004,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA MÉDULA ESPINAL"
  },
  {
    "codigo":254424004,
    "descripcion":"CARCINOMA DE LA ENCÍA SUPERIOR"
  },
  {
    "codigo":283522004,
    "descripcion":"HERIDA PUNZANTE DE TRONCO"
  },
  {
    "codigo":185218006,
    "descripcion":"ATENDIDO EN CENTRO DE CUIDADOS DE PACIENTES CRÓNICOS CON ATENCIÓN DE ENFERMERÍA"
  },
  {
    "codigo":52311001,
    "descripcion":"HOMOCISTINEMIA"
  },
  {
    "codigo":238088006,
    "descripcion":"HIPERLIPIDEMIA COMBINADA PRIMARIA"
  },
  {
    "codigo":871511006,
    "descripcion":"ALERGIA A ÁCIDO CLAVULÁNICO Y\/O TICARCILINA"
  },
  {
    "codigo":281687006,
    "descripcion":"NACIMIENTO EN PRESENTACIÓN DE CARA"
  },
  {
    "codigo":1363031008,
    "descripcion":"CORAZÓN CON MORFOLOGÍA NORMAL"
  },
  {
    "codigo":443692001,
    "descripcion":"SINQUINESIA DE PÁRPADO"
  },
  {
    "codigo":445527009,
    "descripcion":"FRACTURA PATOLÓGICA DE PERONÉ"
  },
  {
    "codigo":248919007,
    "descripcion":"CUELLO UTERINO ELONGADO"
  },
  {
    "codigo":707671008,
    "descripcion":"BLASTOMA PLEUROPULMONAR TIPO I"
  },
  {
    "codigo":278017001,
    "descripcion":"ORINA MALOLIENTE"
  },
  {
    "codigo":704001001,
    "descripcion":"FRACTURA NO EXPUESTA DE FALANGE DISTAL DE DEDO ANULAR"
  },
  {
    "codigo":1088791000119101,
    "descripcion":"LESIÓN DE CONDUCTO AUDITIVO EXTERNO IZQUIERDO"
  },
  {
    "codigo":409089005,
    "descripcion":"NEUTROPENIA FEBRIL"
  },
  {
    "codigo":736769008,
    "descripcion":"AISLAMIENTO SOCIAL DE LOS PADRES"
  },
  {
    "codigo":472790001,
    "descripcion":"HIPERTENSIÓN VENOSA PULMONAR DEBIDA A TRASTORNO DEL CORAZÓN IZQUIERDO"
  },
  {
    "codigo":132221000119109,
    "descripcion":"TROMBOSIS VENOSA PROFUNDA CRÓNICA DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":307115002,
    "descripcion":"MUTACIÓN DEL FACTOR V LEIDEN HOMOCIGÓTICO"
  },
  {
    "codigo":1290155005,
    "descripcion":"TRASTORNO DE DISCO INTERVERTEBRAL CERVICODORSAL"
  },
  {
    "codigo":403584000,
    "descripcion":"URTICARIA DE CONTACTO ARTEFACTA"
  },
  {
    "codigo":896939009,
    "descripcion":"FORMA DE BALA ANORMAL CONGÉNITA DE FALANGE PROXIMAL DE SEGUNDO DEDO DE PIE"
  },
  {
    "codigo":700331009,
    "descripcion":"ARTROSIS DE ARTICULACIÓN ASTRAGALOESCAFOIDEA SECUNDARIA A ARTRITIS INFLAMATORIA"
  },
  {
    "codigo":239744003,
    "descripcion":"INESTABILIDAD ARTICULAR CRÓNICA"
  },
  {
    "codigo":679191000119105,
    "descripcion":"DEGENERACIÓN NODULAR DE CÓRNEA DE SALZMANN DE OJO DERECHO"
  },
  {
    "codigo":237909001,
    "descripcion":"TRASTORNO DE LA REGULACIÓN DE LA OSMOLALIDAD"
  },
  {
    "codigo":6698000,
    "descripcion":"FRACTURA TRIMALEOLAR NO EXPUESTA"
  },
  {
    "codigo":236074001,
    "descripcion":"DIARREA DEBIDA A ABUSO DE LAXANTES"
  },
  {
    "codigo":170538001,
    "descripcion":"REQUIERE SERIE DE VACUNACIÓN ANTITETÁNICA COMPLETA"
  },
  {
    "codigo":301610002,
    "descripcion":"DIFICULTAD PARA SUBIR Y BAJAR ESCALERAS HACIA ATRÁS"
  },
  {
    "codigo":399914006,
    "descripcion":"ERITEMA ANULAR CENTRÍFUGO"
  },
  {
    "codigo":168703000,
    "descripcion":"RADIOGRAFÍA SIMPLE DE ABDOMEN NORMAL"
  },
  {
    "codigo":268842008,
    "descripcion":"CONJUNTIVITIS O DACRIOCISTITIS NEONATALES CAUSADAS POR CLAMIDIAS"
  },
  {
    "codigo":4863002,
    "descripcion":"TRASTORNO DEL ESTADO DE ÁNIMO POR PCP"
  },
  {
    "codigo":365311006,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA LAVAR EN SECO"
  },
  {
    "codigo":234239006,
    "descripcion":"CHOQUES INAPROPIADOS DE DESFIBRILADOR IMPLANTADO"
  },
  {
    "codigo":1348351008,
    "descripcion":"FLUOROSCOPIA DE TRACTO GASTROINTESTINAL NORMAL"
  },
  {
    "codigo":299775009,
    "descripcion":"REFLEJO TÓNICO CERVICAL AUSENTE"
  },
  {
    "codigo":297940005,
    "descripcion":"ERITEMA NUDOSO CAUSADO POR FÁRMACO"
  },
  {
    "codigo":363476006,
    "descripcion":"NEOPLASIA MALIGNA DE LAS MENINGES ESPINALES"
  },
  {
    "codigo":232404007,
    "descripcion":"CANDIDIASIS FARÍNGEA AGUDA"
  },
  {
    "codigo":79281000119106,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE PIEL"
  },
  {
    "codigo":1344681001,
    "descripcion":"QUISTE DERMOIDE DE PÁRPADO DERECHO"
  },
  {
    "codigo":197801000,
    "descripcion":"QUISTE RENAL ÚNICO ADQUIRIDO"
  },
  {
    "codigo":294270000,
    "descripcion":"ALERGIA A ANTAGONISTA DE RECEPTOR DE BENZODIAZEPINA"
  },
  {
    "codigo":230569009,
    "descripcion":"NEUROPATÍA POR DEFICIENCIA DE VITAMINA E"
  },
  {
    "codigo":66729008,
    "descripcion":"ENFERMEDAD POR HEMOGLOBINA D"
  },
  {
    "codigo":722089009,
    "descripcion":"NEFROPATÍA OBSTRUCTIVA DEBIDA A CÁNCER DE VEJIGA"
  },
  {
    "codigo":12367281000119109,
    "descripcion":"TROMBO MURAL DE VENTRÍCULO DERECHO"
  },
  {
    "codigo":95827002,
    "descripcion":"TRASTORNO AUDITIVO CONGÉNITO"
  },
  {
    "codigo":292435003,
    "descripcion":"REACCIÓN ADVERSA AL LABETALOL"
  },
  {
    "codigo":1177171004,
    "descripcion":"HIPERFIBRINÓLISIS"
  },
  {
    "codigo":194131002,
    "descripcion":"CONVERGENCIA INSUFICIENTE"
  },
  {
    "codigo":1144403009,
    "descripcion":"HIPOPLASIA CONGÉNITA DE MÚSCULO DILATADOR DE LA PUPILA"
  },
  {
    "codigo":93992002,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LÓBULO MEDIO DE PULMÓN DERECHO"
  },
  {
    "codigo":28456004,
    "descripcion":"INFECCIÓN SUBCLÍNICA"
  },
  {
    "codigo":126760006,
    "descripcion":"NEOPLASIA DE VASO SANGUÍNEO DE REGIÓN INGUINAL"
  },
  {
    "codigo":716584007,
    "descripcion":"FIEBRE HEMORRÁGICA CAUSADA POR VIRUS CHAPARE"
  },
  {
    "codigo":354021000119100,
    "descripcion":"NEOPLASIA BENIGNA DE PELVIS RENAL IZQUIERDA"
  },
  {
    "codigo":92157004,
    "descripcion":"NEOPLASIA BENIGNA DE LOS ÓRGANOS INTRATORÁCICOS"
  },
  {
    "codigo":288765004,
    "descripcion":"EXPRESA SENTIMIENTOS"
  },
  {
    "codigo":286930000,
    "descripcion":"HEMOGLOBINURIA - CAUSA EXTERNA"
  },
  {
    "codigo":24786004,
    "descripcion":"MONOSOMÍA PARCIAL 7P"
  },
  {
    "codigo":1204434006,
    "descripcion":"INTOXICACIÓN INTENCIONAL CAUSADA POR DETERGENTE"
  },
  {
    "codigo":1237202006,
    "descripcion":"ABSTINENCIA DE ANFETAMINA Y\/O DERIVADO DE ANFETAMINA"
  },
  {
    "codigo":874919003,
    "descripcion":"CUERPO EXTRAÑO SUPERFICIAL EN ANO"
  },
  {
    "codigo":55719006,
    "descripcion":"ESTENOSIS ADQUIRIDA DE CONDUCTO AUDITIVO EXTERNO SECUNDARIA A INFLAMACIÓN"
  },
  {
    "codigo":186791009,
    "descripcion":"PALUDISMO CAUSADO POR PLASMODIUM FALCIPARUM, CON COMPLICACIONES CEREBRALES"
  },
  {
    "codigo":447100004,
    "descripcion":"LINFOMA DE LA ZONA MARGINAL"
  },
  {
    "codigo":840316004,
    "descripcion":"INFARTO AGUDO DE MIOCARDIO CON ELEVACIÓN DEL SEGMENTO ST DEBIDO A OCLUSIÓN DE PORCIÓN DISTAL DE RAMA DESCENDENTE ANTERIOR DE ARTERIA CORONARIA IZQUIERDA"
  },
  {
    "codigo":283260007,
    "descripcion":"VIDRIO EN PERINEO"
  },
  {
    "codigo":119420007,
    "descripcion":"QUISTE OVÁRICO HEMORRÁGICO"
  },
  {
    "codigo":86652009,
    "descripcion":"FALTA DE RESPUESTA CEREBRAL"
  },
  {
    "codigo":681701000119107,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE LA CURVATURA MAYOR DEL ESTÓMAGO"
  },
  {
    "codigo":707409003,
    "descripcion":"CARCINOMA PRIMARIO DE CÉLULAS ACINARES DE PULMÓN"
  },
  {
    "codigo":19281006,
    "descripcion":"TAMAÑO DE UNA COLONIA BACTERIANA"
  },
  {
    "codigo":1231697007,
    "descripcion":"TRICOEPITELIOMA DE PÁRPADO"
  },
  {
    "codigo":246822001,
    "descripcion":"ECTROPIÓN PALPEBRAL INFERIOR CON EVERSIÓN"
  },
  {
    "codigo":443430002,
    "descripcion":"REQUIERE ASISTENCIA EN TODAS LAS ACTIVIDADES COTIDIANAS"
  },
  {
    "codigo":248657009,
    "descripcion":"LATIDOS CARDÍACOS INTENSOS"
  },
  {
    "codigo":115750008,
    "descripcion":"FENOTIPO DE GRUPO SANGUÍNEO I"
  },
  {
    "codigo":212219001,
    "descripcion":"LESIÓN DE RAÍZ DE NERVIO LUMBAR - L2"
  },
  {
    "codigo":310523002,
    "descripcion":"RECIÉN NACIDO PREMATURO: 24-26 SEMANAS"
  },
  {
    "codigo":441595003,
    "descripcion":"ESTRUCTURA ANORMAL DE ALFA-FETOPROTEÍNA"
  },
  {
    "codigo":408827003,
    "descripcion":"SITUACIÓN DE CRIBADO PRENATAL MEDIANTE PRUEBA PARA VIRUS DE INMUNODEFICIENCIA HUMANA EN SANGRE"
  },
  {
    "codigo":81147004,
    "descripcion":"MIEDO AL COITO"
  },
  {
    "codigo":112080002,
    "descripcion":"ÁNIMO FELIZ"
  },
  {
    "codigo":308688005,
    "descripcion":"REFLEJOS PERIFÉRICOS ACTIVOS"
  },
  {
    "codigo":306853001,
    "descripcion":"TROMBOSIS DE INJERTO-PUENTE FEMOROPOPLÍTEO"
  },
  {
    "codigo":863909002,
    "descripcion":"ERUPCIÓN EN LUGAR DE VACUNACIÓN"
  },
  {
    "codigo":110245004,
    "descripcion":"CONTUSIÓN DEL PABELLÓN AURICULAR"
  },
  {
    "codigo":11941006,
    "descripcion":"TRASTORNO DE PÁNICO CON AGORAFOBIA, EVITACIÓN AGORAFÓBICA EN REMISIÓN TOTAL Y ATAQUES DE PÁNICO EN REMISIÓN TOTAL"
  },
  {
    "codigo":16711551000119108,
    "descripcion":"NEOVASCULARIZACIÓN DE RETINA DEBIDA A OCLUSIÓN DE RAMA DE VENA RETINIANA DE OJO IZQUIERDO"
  },
  {
    "codigo":403322000,
    "descripcion":"ALOPECIA AREATA CIRCUNSCRIPTA DE REGIÓN DE LA BARBA"
  },
  {
    "codigo":274085008,
    "descripcion":"CARCINOMA DE AMÍGDALA"
  },
  {
    "codigo":370554001,
    "descripcion":"VULVA RESECADA"
  },
  {
    "codigo":1255290002,
    "descripcion":"HERIDA ABIERTA DE MÚLTIPLES SITIOS DE DEDOS DE MANO"
  },
  {
    "codigo":763770005,
    "descripcion":"MIOCLONÍA CORTICAL FAMILIAR"
  },
  {
    "codigo":301348000,
    "descripcion":"LABIOS FINOS"
  },
  {
    "codigo":237647008,
    "descripcion":"HIPERINSULINEMIA DE CAUSA NUTRICIONAL"
  },
  {
    "codigo":235812003,
    "descripcion":"ROTACIÓN PATOLÓGICA DEL INTESTINO, TIPO IA"
  },
  {
    "codigo":15702041000119106,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE TENDÓN DE BRAZO DERECHO"
  },
  {
    "codigo":39204006,
    "descripcion":"ÚLCERA PILÓRICA"
  },
  {
    "codigo":399652005,
    "descripcion":"COMPROMISO TUMORAL DE MARGEN DE RESECCIÓN QUIRÚRGICO PROFUNDO, NO PUEDE SER EVALUADO"
  },
  {
    "codigo":70137000,
    "descripcion":"TRASTORNO FUNCIONAL ENDOCRINO DE LA PLACENTA"
  },
  {
    "codigo":170276008,
    "descripcion":"EXAMEN DEL NIÑO A LOS 21 MESES: NORMAL"
  },
  {
    "codigo":365049000,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA EMPLEAR PALABRAS"
  },
  {
    "codigo":233977004,
    "descripcion":"COMPRESIÓN EXTRÍNSECA DE ARTERIA"
  },
  {
    "codigo":299513007,
    "descripcion":"ARTICULACIÓN DEL PIE - DOLOROSA AL MOVIMIENTO"
  },
  {
    "codigo":37369009,
    "descripcion":"FÍSTULA DE APÉNDICE ILEOCECAL"
  },
  {
    "codigo":428750005,
    "descripcion":"ANOMALÍA INESPECÍFICA DE ST-T EN EL ELECTROCARDIOGRAMA"
  },
  {
    "codigo":232142007,
    "descripcion":"PARÁLISIS INFECCIOSA DE ACOMODACIÓN"
  },
  {
    "codigo":426915001,
    "descripcion":"PROTRUSIÓN MANDIBULAR LIMITADA"
  },
  {
    "codigo":787363003,
    "descripcion":"METABOLIZADOR LENTO DE LA FAMILIA 1 SUBFAMILIA A MIEMBRO 2 DEL CITOCROMO P450"
  },
  {
    "codigo":263075004,
    "descripcion":"FRACTURA-LUXACIÓN DE ARTICULACIÓN ACROMIOCLAVICULAR"
  },
  {
    "codigo":230307005,
    "descripcion":"COREA DEBIDA A LUPUS SISTÉMICO ERITEMATOSO"
  },
  {
    "codigo":931004,
    "descripcion":"EDAD GESTACIONAL, 9 SEMANAS"
  },
  {
    "codigo":295843007,
    "descripcion":"SOBREDOSIS DE BUTRIPTILINA"
  },
  {
    "codigo":721827005,
    "descripcion":"INFECCIÓN CAUSADA POR SPIROMETRA"
  },
  {
    "codigo":228472005,
    "descripcion":"RELACIÓN HOMOSEXUAL"
  },
  {
    "codigo":95565000,
    "descripcion":"PSEUDOPORFIRIA"
  },
  {
    "codigo":423245001,
    "descripcion":"CON MAYOR RIESGO DE COMPROMISO DE LA DIGNIDAD HUMANA"
  },
  {
    "codigo":15649101000119101,
    "descripcion":"ANEURISMA DE ARTERIA ILÍACA INTERNA DERECHA"
  },
  {
    "codigo":128333008,
    "descripcion":"TRASTORNO DIARREICO"
  },
  {
    "codigo":1142306001,
    "descripcion":"CEJA RALA Y DELGADA"
  },
  {
    "codigo":93730001,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE BRONQUIO DEL LÓBULO SUPERIOR IZQUIERDO DEL PULMÓN"
  },
  {
    "codigo":292173008,
    "descripcion":"REACCIÓN ADVERSA AL ISOFLURANO"
  },
  {
    "codigo":126498005,
    "descripcion":"NEOPLASIA DE LA PIEL DE LOS LABIOS"
  },
  {
    "codigo":716322007,
    "descripcion":"BURKHOLDERIA CEPACIA NO AISLADA"
  },
  {
    "codigo":124663000,
    "descripcion":"DEFICIENCIA DE ALDOSA 1 - EPIMERASA"
  },
  {
    "codigo":386807006,
    "descripcion":"TRASTORNO DE LA MEMORIA"
  },
  {
    "codigo":91895008,
    "descripcion":"AUSENCIA CONGÉNITA DE LA VÉRTEBRA LUMBAR"
  },
  {
    "codigo":286668001,
    "descripcion":"DESPLAZAMIENTO - MECANISMO DE DEFENSA PSICOLÓGICA"
  },
  {
    "codigo":417740005,
    "descripcion":"LAGOFTALMÍA NOCTURNA"
  },
  {
    "codigo":253900005,
    "descripcion":"VÁLVULAS URETRALES POSTERIORES CONGÉNITAS"
  },
  {
    "codigo":1204172007,
    "descripcion":"ATEROSCLEROSIS DE ARTERIA FEMORAL SUPERFICIAL"
  },
  {
    "codigo":1236940007,
    "descripcion":"METÁSTASIS DE CARCINOMA DE COLA DE PÁNCREAS"
  },
  {
    "codigo":55457007,
    "descripcion":"CÁMARA ANTERIOR DEL OJO AUSENTE"
  },
  {
    "codigo":303591000119102,
    "descripcion":"DISCREPANCIA EN LA INTERCUSPIDACIÓN MÁXIMA"
  },
  {
    "codigo":53622003,
    "descripcion":"PALUDISMO CEREBRAL"
  },
  {
    "codigo":1003894006,
    "descripcion":"DELECIÓN PROXIMAL DEL BRAZO LARGO DEL CROMOSOMA 8"
  },
  {
    "codigo":282998007,
    "descripcion":"VOLTEA EL CUERPO"
  },
  {
    "codigo":445003000,
    "descripcion":"OBSTRUCCIÓN DEL TRACTO DE SALIDA DEL VENTRÍCULO IZQUIERDO POR RODETE FIBROMUSCULAR SUBPULMONAR"
  },
  {
    "codigo":1264203001,
    "descripcion":"TRASTORNO FETAL CAUSADO POR TRANSFERENCIA PLACENTARIA DE TRANQUILIZANTE MATERNO DURANTE EL TRABAJO DE PARTO"
  },
  {
    "codigo":707147002,
    "descripcion":"ASPLENIA"
  },
  {
    "codigo":10625511000119104,
    "descripcion":"BRONCONEUMONÍA CAUSADA POR PSEUDOMONAS"
  },
  {
    "codigo":1196832002,
    "descripcion":"MESENQUIMOMA BENIGNO DE VÍA BILIAR"
  },
  {
    "codigo":443168008,
    "descripcion":"EDEMA DE CUERO CABELLUDO FETAL"
  },
  {
    "codigo":408565001,
    "descripcion":"REQUIERE COMUNICACIÓN DE LA PAREJA"
  },
  {
    "codigo":310261000,
    "descripcion":"ANTICUERPOS ANTIRRIBONUCLEOPROTEÍNAS NO DETECTADOS"
  },
  {
    "codigo":703477003,
    "descripcion":"RETRASO DEL DESARROLLO DE LA FUNCIÓN MOTRIZ FINA"
  },
  {
    "codigo":16906881000119101,
    "descripcion":"NEOPLASIA BENIGNA DE PIEL DE PÁRPADO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":277493007,
    "descripcion":"TRASTORNO VASCULAR DEL OÍDO INTERNO"
  },
  {
    "codigo":308426002,
    "descripcion":"SITUACIÓN DEL CRIBADO EN ADULTOS"
  },
  {
    "codigo":15678081000119103,
    "descripcion":"COROIDITIS DE OJO DERECHO CAUSADA POR TOXOPLASMA GONDII"
  },
  {
    "codigo":372127000,
    "descripcion":"CARCINOMA DE LA PIEL DEL TRONCO"
  },
  {
    "codigo":11679003,
    "descripcion":"DOLOR RADICULAR"
  },
  {
    "codigo":109983007,
    "descripcion":"GAMMAPATÍA MONOCLONAL (CLÍNICA)"
  },
  {
    "codigo":10926721000119105,
    "descripcion":"FRACTURA NO EXPUESTA DE LA DIÁFISIS DEL PRIMER METACARPIANO DE LA MANO DERECHA"
  },
  {
    "codigo":403060001,
    "descripcion":"ONICOMICOSIS CAUSADA POR TRICHOPHYTON MENTAGROPHYTES VARIEDAD INTERDIGITALE"
  },
  {
    "codigo":73545001,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO DEL MENTÓN"
  },
  {
    "codigo":204617004,
    "descripcion":"PALADAR HENDIDO INCOMPLETO CENTRAL CON LABIO LEPORINO"
  },
  {
    "codigo":40777006,
    "descripcion":"HIPERCALIEMIA CRÓNICA"
  },
  {
    "codigo":302921006,
    "descripcion":"MALABSORCIÓN DEBIDA A INTOLERANCIA A PROTEÍNA"
  },
  {
    "codigo":8009008,
    "descripcion":"ENURESIS NOCTURNA"
  },
  {
    "codigo":1251358000,
    "descripcion":"PIEL REDUNDANTE GENERALIZADA POR RESTRICCIÓN CALÓRICA INTENCIONAL"
  },
  {
    "codigo":301086002,
    "descripcion":"MENINGITIS SIFILÍTICA"
  },
  {
    "codigo":366622008,
    "descripcion":"HALLAZGO RELACIONADO CON COLORACIÓN DE ARTICULACIÓN DE TOBILLO"
  },
  {
    "codigo":202782008,
    "descripcion":"ESTENOSIS IDIOPÁTICA DE CONDUCTO RAQUÍDEO DORSAL"
  },
  {
    "codigo":233715006,
    "descripcion":"OSIFICACIÓN PULMONAR DIFUSA IDIOPÁTICA"
  },
  {
    "codigo":364787006,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD DE INGERIR ALIMENTOS"
  },
  {
    "codigo":69875006,
    "descripcion":"LACERACIÓN DE LA CORTEZA CEREBRAL CON HERIDA INTRACRANEAL ABIERTA Y CONMOCIÓN"
  },
  {
    "codigo":35272001,
    "descripcion":"MICROFAQUIA"
  },
  {
    "codigo":788936005,
    "descripcion":"FRACTURA DE CUELLO ANATÓMICO DE HÚMERO"
  },
  {
    "codigo":199112006,
    "descripcion":"INFECCIONES DEL APARATO GENITAL DURANTE EL EMBARAZO"
  },
  {
    "codigo":231880007,
    "descripcion":"HERIDA PERFORANTE DE CÓRNEA Y ESCLERÓTICA"
  },
  {
    "codigo":395720009,
    "descripcion":"INVASIÓN TUMORAL DE PEQUEÑOS VASOS LINFÁTICOS, INDETERMINADA"
  },
  {
    "codigo":424818000,
    "descripcion":"CAMBIO DE TEMPERATURA EN SITIO ANATÓMICO"
  },
  {
    "codigo":295581008,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE PROCAÍNA"
  },
  {
    "codigo":1342322002,
    "descripcion":"TRASTORNO DE SISTEMA MUSCULOESQUELÉTICO POSTERIOR A REPARACIÓN DE SISTEMA MUSCULOESQUELÉTICO"
  },
  {
    "codigo":361117008,
    "descripcion":"SÍNDROME DE HIPOGONADISMO HIPOGONADOTRÓFICO FEMENINO"
  },
  {
    "codigo":64370005,
    "descripcion":"AGANGLIONOSIS DEL GANGLIO NERVIOSO PARASIMPÁTICO"
  },
  {
    "codigo":293746007,
    "descripcion":"ALERGIA A DERIVADO DE MOSTAZA NITROGENADA"
  },
  {
    "codigo":719730007,
    "descripcion":"CAPAZ DE RECONOCER PALABRAS HABLADAS"
  },
  {
    "codigo":160839002,
    "descripcion":"FINALIZACIÓN DE AVENTURA AMOROSA"
  },
  {
    "codigo":717895004,
    "descripcion":"HIPOPARATIROIDISMO DEBIDO A ALTERACIÓN DE LA SECRECIÓN DE HORMONA PARATIROIDEA"
  },
  {
    "codigo":128071005,
    "descripcion":"ENFERMEDAD DE LA REGIÓN RETROPERITONEAL, EXCEPTO DE LOS ÓRGANOS PRINCIPALES"
  },
  {
    "codigo":95303006,
    "descripcion":"PAROTITIS SUPURATIVA"
  },
  {
    "codigo":1142044000,
    "descripcion":"DIABETES MELLITUS PREEXISTENTE RELACIONADA CON DESNUTRICIÓN, EN EL EMBARAZO"
  },
  {
    "codigo":15952821000119105,
    "descripcion":"NEOPLASIA FILOIDE BENIGNA BILATERAL DE MAMA"
  },
  {
    "codigo":60700002,
    "descripcion":"PÉRDIDA DE LA AUDICIÓN NEUROSENSORIAL"
  },
  {
    "codigo":93468003,
    "descripcion":"HEMANGIOMA DE ESTRUCTURA INTRACRANEAL"
  },
  {
    "codigo":191772006,
    "descripcion":"TRASTORNO EXCÉNTRICO DE LA PERSONALIDAD"
  },
  {
    "codigo":290076007,
    "descripcion":"FÍSTULA DE MAMA"
  },
  {
    "codigo":91633000,
    "descripcion":"FÓRMULA SIN HIERRO PARA LACTANTES"
  },
  {
    "codigo":58865002,
    "descripcion":"ESTADO PRENATAL DEL FETO, 2DO TRIMESTRE"
  },
  {
    "codigo":288241003,
    "descripcion":"DOLOR EN EXTREMIDAD - MÚLTIPLE"
  },
  {
    "codigo":384710005,
    "descripcion":"ESGUINCE DE LIGAMENTO RADIOCARPIANO"
  },
  {
    "codigo":286406006,
    "descripcion":"CAPAZ DE HABLAR INTELIGIBLEMENTE"
  },
  {
    "codigo":253638007,
    "descripcion":"ORIGEN ANÓMALO DE ARTERIA PULMONAR IZQUIERDA EN ARTERIA PULMONAR DERECHA"
  },
  {
    "codigo":251803000,
    "descripcion":"DESARROLLO INFANTIL - HALLAZGO"
  },
  {
    "codigo":448411000,
    "descripcion":"CIERRE ESPONTÁNEO DE DEFECTO DE TABIQUE INTERVENTRICULAR DEBIDO A PROLAPSO DE CÚSPIDE DE VÁLVULA AÓRTICA"
  },
  {
    "codigo":284571002,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DE ESTRUCTURA NEUROLÓGICA"
  },
  {
    "codigo":188102008,
    "descripcion":"NEOPLASIA MALIGNA DE LA PIEL DEL CUELLO Y\/O DEL CUERO CABELLUDO"
  },
  {
    "codigo":186267004,
    "descripcion":"QUERATOCONJUNTIVITIS TUBERCULOSA"
  },
  {
    "codigo":249968003,
    "descripcion":"MOVIMIENTO DE AGITACIÓN DE PIERNA"
  },
  {
    "codigo":413808003,
    "descripcion":"AGRANDAMIENTO DE VENTRÍCULO CEREBRAL"
  },
  {
    "codigo":16008271000119106,
    "descripcion":"CONDROCALCINOSIS DE AMBAS MUÑECAS"
  },
  {
    "codigo":86128003,
    "descripcion":"RUPTURA DEL TENDÓN DEL MÚSCULO BÍCEPS, PORCIÓN LARGA"
  },
  {
    "codigo":315504006,
    "descripcion":"NACIDO EN PORTUGAL"
  },
  {
    "codigo":280901000,
    "descripcion":"COUVADE"
  },
  {
    "codigo":689231000119107,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE PARED POSTERIOR DE VEJIGA URINARIA"
  },
  {
    "codigo":706885006,
    "descripcion":"QUERATODERMIA PALMOPLANTAR"
  },
  {
    "codigo":1263941007,
    "descripcion":"HEMORRAGIA INTRACRANEANA SUBDURAL NO TRAUMÁTICA NEONATAL"
  },
  {
    "codigo":248133008,
    "descripcion":"DESEO VEHEMENTE DE UNA BEBIDA EN PARTICULAR"
  },
  {
    "codigo":444741009,
    "descripcion":"CUMPLE CON CRITERIOS DE ELEGIBILIDAD PARA CIRUGÍA CONSERVADORA DE MAMA"
  },
  {
    "codigo":1296709009,
    "descripcion":"NEOVASCULARIZACIÓN DE AMBOS OJOS"
  },
  {
    "codigo":82458004,
    "descripcion":"ESTENOSIS CONGÉNITA DE VÁLVULA MITRAL"
  },
  {
    "codigo":16922007,
    "descripcion":"DEFICIENCIA HEREDITARIA DE LOS FACTORES DE COAGULACIÓN"
  },
  {
    "codigo":279066007,
    "descripcion":"DOLOR DE ARTICULACIÓN DE PIE"
  },
  {
    "codigo":80623000,
    "descripcion":"TRASTORNO DEL CICLO DE SUEÑO-VIGILIA, TIPO FASE TARDÍA"
  },
  {
    "codigo":703215002,
    "descripcion":"HEMORRAGIA INTRACRANEAL SUBARACNOIDEA NO DEBIDA A RUPTURA DE ANEURISMA"
  },
  {
    "codigo":1260271009,
    "descripcion":"INFARTO CEREBRAL HEMORRÁGICO DEBIDO A HIPERTENSIÓN"
  },
  {
    "codigo":275396004,
    "descripcion":"CARCINOMA DORSAL DE LOS DOS TERCIOS ANTERIORES DE LA LENGUA"
  },
  {
    "codigo":111556005,
    "descripcion":"CETOACIDOSIS DIABÉTICA SIN COMA"
  },
  {
    "codigo":46020007,
    "descripcion":"FRACTURA EXPUESTA DE HUESO CUNEIFORME DEL PIE"
  },
  {
    "codigo":240793000,
    "descripcion":"ESPLENOMEGALIA POR ESQUISTOSOMIASIS"
  },
  {
    "codigo":109721003,
    "descripcion":"HIPOPLASIA CONDÍLEA MANDIBULAR BILATERAL"
  },
  {
    "codigo":404633004,
    "descripcion":"SÍNDROME DE COGAN-REESE"
  },
  {
    "codigo":76953007,
    "descripcion":"DIVERTICULITIS DE COLON CON PERFORACIÓN"
  },
  {
    "codigo":371865008,
    "descripcion":"TIMI (THROMBOLYSIS IN MYOCARDIAL INFARCTION) GRADO 3: PERFUSIÓN COMPLETA"
  },
  {
    "codigo":1287534002,
    "descripcion":"ABRASIÓN DE PIEL DE CABEZA"
  },
  {
    "codigo":238958004,
    "descripcion":"AUTO-EXCORIACIÓN REPETIDA"
  },
  {
    "codigo":402798004,
    "descripcion":"INFECCIÓN NEONATAL MICÓTICA DE LA PIEL"
  },
  {
    "codigo":237123000,
    "descripcion":"MENOPAUSIA NORMAL"
  },
  {
    "codigo":1285699000,
    "descripcion":"DESPLAZAMIENTO DE RAÍZ DE DIENTE HACIA EL SENO MAXILAR DEBIDO A EXTRACCIÓN DENTAL Y POSTERIOR A ELLA"
  },
  {
    "codigo":106051002,
    "descripcion":"HALLAZGO RELACIONADO CON LOS RUIDOS RESPIRATORIOS"
  },
  {
    "codigo":1351235001,
    "descripcion":"INMUNODEFICIENCIA COMBINADA SEVERA T NEGATIVA B NEGATIVA AUTOSÓMICA DOMINANTE DEBIDA A DEFECTO DE RAC2 ACTIVADA"
  },
  {
    "codigo":400963000,
    "descripcion":"MIDRIASIS CONGÉNITA"
  },
  {
    "codigo":40515007,
    "descripcion":"CONCRECIÓN DEL INTESTINO"
  },
  {
    "codigo":431896008,
    "descripcion":"RECHAZO CRÓNICO DE TRASPLANTE CARDÍACO"
  },
  {
    "codigo":298989002,
    "descripcion":"AMPLITUD DE ADUCCIÓN PASIVA DE ARTICULACIÓN DE MUÑECA, DISMINUIDA"
  },
  {
    "codigo":724973005,
    "descripcion":"LESIÓN TRAUMÁTICA DE TENDÓN DE MÚSCULO EXTENSOR DE DEDO DE LA MANO A LA ALTURA DEL ANTEBRAZO"
  },
  {
    "codigo":723138000,
    "descripcion":"HEMORRAGIA TRAUMÁTICA PRIMARIA DE TRONCO ENCEFÁLICO"
  },
  {
    "codigo":788674000,
    "descripcion":"TRASTORNO LINFOPROLIFERATIVO CUTÁNEO PRIMARIO DE LINFOCITOS T PEQUEÑOS Y MEDIANOS POSITIVO PARA CD4"
  },
  {
    "codigo":297154003,
    "descripcion":"TROMBOSIS DE ARTERIA SUBCLAVIA"
  },
  {
    "codigo":35010007,
    "descripcion":"CLONO DE CIERRE CATÓDICO"
  },
  {
    "codigo":407000,
    "descripcion":"HEPATOMEGALIA CONGÉNITA"
  },
  {
    "codigo":295319002,
    "descripcion":"SOBREDOSIS DE MEDIO DE CONTRASTE"
  },
  {
    "codigo":293484000,
    "descripcion":"REACCIÓN ADVERSA A DIURÉTICO MERCURIAL"
  },
  {
    "codigo":459159008,
    "descripcion":"ENDOCARDITIS INFECCIOSA DE VÁLVULA AURICULOVENTRICULAR DERECHA (MORFOLÓGICAMENTE NO TRICÚSPIDE)"
  },
  {
    "codigo":129644003,
    "descripcion":"SÍNDROME POR DEFICIENCIA DE MIELOPEROXIDASA"
  },
  {
    "codigo":195180004,
    "descripcion":"OCLUSIÓN DE ARTERIA BASILAR"
  },
  {
    "codigo":719468005,
    "descripcion":"SÍNDROME DE FISURA DE PALADAR CON FIJACIÓN DEL ESTRIBO Y OLIGODONCIA"
  },
  {
    "codigo":1145452004,
    "descripcion":"APLASIA DE HUESO DE RADIO Y\/O CÚBITO"
  },
  {
    "codigo":291649001,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR DOXICICLINA"
  },
  {
    "codigo":160577002,
    "descripcion":"BEBEDOR EXCESIVO - 7 A 9 UNIDADES POR DÍA"
  },
  {
    "codigo":95041005,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL SEGUNDO HUESO CUNEIFORME DEL TARSO"
  },
  {
    "codigo":226113006,
    "descripcion":"DIETA CON BAJO CONTENIDO DE GRASAS POLINSATURADAS"
  },
  {
    "codigo":717633007,
    "descripcion":"SÍNDROME DE MONOSOMÍA 1Q DISTAL"
  },
  {
    "codigo":10734651000119106,
    "descripcion":"FIBROADENOSIS DE MAMA DERECHA"
  },
  {
    "codigo":289814005,
    "descripcion":"HALLAZGO RELACIONADO CON LA SENSIBILIDAD DEL CUELLO UTERINO"
  },
  {
    "codigo":715798007,
    "descripcion":"ENFERMEDAD DE CHARCOT-MARIE-TOOTH TIPO 4D"
  },
  {
    "codigo":191510009,
    "descripcion":"ESTADO CONFUSIONAL SUBAGUDO, DE ORIGEN ENDOCRINO"
  },
  {
    "codigo":124139007,
    "descripcion":"DEFICIENCIA DE MANITOL DESHIDROGENASA"
  },
  {
    "codigo":29921000175103,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN DE TALÓN IZQUIERDO GRADO 2"
  },
  {
    "codigo":419051009,
    "descripcion":"DEGENERACIÓN AMILOIDE POLIMÓRFICA DE LA CÓRNEA"
  },
  {
    "codigo":253376005,
    "descripcion":"HIPOPLASIA DEL ANILLO TRICUSPÍDEO"
  },
  {
    "codigo":286144005,
    "descripcion":"NO LIMPIA LA COCINA"
  },
  {
    "codigo":1300117002,
    "descripcion":"SÍNDROME DE LUSCAN LUMISH"
  },
  {
    "codigo":284309003,
    "descripcion":"NO LIBERA LA PRENSIÓN"
  },
  {
    "codigo":251541004,
    "descripcion":"UNIDADES POLIFÁSICAS DE CORTA DURACIÓN - HALLAZGO"
  },
  {
    "codigo":1003370000,
    "descripcion":"MICROFTALMÍA DEBIDA A SÍNDROME DE FRYNS"
  },
  {
    "codigo":773994002,
    "descripcion":"QUERATITIS INTERSTICIAL LINEAL IDIOPÁTICA"
  },
  {
    "codigo":446314003,
    "descripcion":"LACERACIÓN DE LECHO UNGUEAL DE DEDO DE MANO"
  },
  {
    "codigo":249706005,
    "descripcion":"GIBA DE COSTILLA"
  },
  {
    "codigo":282474007,
    "descripcion":"CAPAZ DE CORRER"
  },
  {
    "codigo":247871001,
    "descripcion":"MIEDO A LOS FANTASMAS"
  },
  {
    "codigo":84031003,
    "descripcion":"PELVIS INFANTIL"
  },
  {
    "codigo":1163540001,
    "descripcion":"MENINGITIS POR TOXOCARA"
  },
  {
    "codigo":770324004,
    "descripcion":"ISQUEMIA DE RETINA DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":82196007,
    "descripcion":"INSUFICIENCIA VASCULAR INTESTINAL"
  },
  {
    "codigo":49428008,
    "descripcion":"ELASTOSIS PERFORANTE SERPIGINOSA"
  },
  {
    "codigo":735721003,
    "descripcion":"PERFORACIÓN INTESTINAL NEONATAL DEBIDA A VÓLVULO INTESTINAL INTRAUTERINO"
  },
  {
    "codigo":14825005,
    "descripcion":"LACERACIÓN PERINEAL QUE COMPROMETE LA VAGINA"
  },
  {
    "codigo":309737007,
    "descripcion":"DOLOR ABDOMINAL EN EL EMBARAZO"
  },
  {
    "codigo":11861841000119108,
    "descripcion":"RUPTURA TRAUMÁTICA DE LIGAMENTO LATERAL EXTERNO DE ARTICULACIÓN DE RODILLA DERECHA"
  },
  {
    "codigo":373438001,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM MARINUM"
  },
  {
    "codigo":209598003,
    "descripcion":"DESGARRO COMPLETO INESPECÍFICO DE LIGAMENTO INTRÍNSECO CORTO"
  },
  {
    "codigo":1290942005,
    "descripcion":"LIPOFIBROMATOSIS"
  },
  {
    "codigo":111294009,
    "descripcion":"VENAS UMBILICALES DISTENDIDAS"
  },
  {
    "codigo":240531002,
    "descripcion":"LINFOMA DE BURKITT AFRICANO"
  },
  {
    "codigo":764819004,
    "descripcion":"COMPLICACIÓN DE DISPOSITIVO DE ACCESO VENOSO TOTALMENTE IMPLANTABLE"
  },
  {
    "codigo":44061000087101,
    "descripcion":"HERIDA CORTANTE DE PIEL DE CODO IZQUIERDO"
  },
  {
    "codigo":207763006,
    "descripcion":"FRACTURA NO EXPUESTA DE MÚLTIPLES SITIOS DE LA MANDÍBULA"
  },
  {
    "codigo":109459007,
    "descripcion":"PROYECCIÓN DEL ESMALTE"
  },
  {
    "codigo":49181000087105,
    "descripcion":"CONSENTIMIENTO PARA SEDACIÓN RECHAZADO"
  },
  {
    "codigo":304232002,
    "descripcion":"MALA COLORACIÓN CUTÁNEA"
  },
  {
    "codigo":76691009,
    "descripcion":"NEURALGIA DE PLEXO BRAQUIAL"
  },
  {
    "codigo":41501000087106,
    "descripcion":"HEMATOMA DE REGIÓN PERIORBITARIA DE OJO DERECHO"
  },
  {
    "codigo":46621000087109,
    "descripcion":"FRACTURA DE EXTREMO PROXIMAL DE TIBIA DERECHA"
  },
  {
    "codigo":38941000087107,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE DEDOS SEGUNDO A QUINTO DE PIE IZQUIERDO"
  },
  {
    "codigo":369768002,
    "descripcion":"MÁS DE 4 MITOSIS\/CAMPO DE GRAN AUMENTO"
  },
  {
    "codigo":402536001,
    "descripcion":"CARCINOMA BASOCELULAR PRIMARIO"
  },
  {
    "codigo":171325001,
    "descripcion":"CRIBADO DE PACIENTE NUEVO - SOLICITADO"
  },
  {
    "codigo":300562000,
    "descripcion":"PROBLEMA DE LAS VÍAS GENITOURINARIAS"
  },
  {
    "codigo":366098000,
    "descripcion":"RESPUESTA A LOS SONIDOS DE FRECUENCIA ALTA - HALLAZGO"
  },
  {
    "codigo":169490003,
    "descripcion":"DISPOSITIVO ANTICONCEPTIVO INTRAUTERINO - HILO PERDIDO"
  },
  {
    "codigo":890386005,
    "descripcion":"ESTENOSIS SUBGLÓTICA CONGÉNITA DE COTTON-MYER GRADO 1"
  },
  {
    "codigo":235026006,
    "descripcion":"ABSCESO DE PARTES BLANDAS DE LA BOCA"
  },
  {
    "codigo":71186008,
    "descripcion":"CRUP"
  },
  {
    "codigo":823015001,
    "descripcion":"MECHÓN DE PELO EN PIEL DE REGIÓN SACRA"
  },
  {
    "codigo":36583000,
    "descripcion":"TRASTORNO BIPOLAR I MIXTO EN REMISIÓN PARCIAL"
  },
  {
    "codigo":3815005,
    "descripcion":"ENFERMEDAD DE CROHN DEL RECTO"
  },
  {
    "codigo":724711008,
    "descripcion":"INTOXICACIÓN CAUSADA POR KETAMINA"
  },
  {
    "codigo":167655009,
    "descripcion":"ACTIVIDAD DE TRIPSINA FECAL POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":298727009,
    "descripcion":"DEFORMIDAD DEL ESTERNÓN"
  },
  {
    "codigo":722876002,
    "descripcion":"PIROSIS FUNCIONAL"
  },
  {
    "codigo":34748004,
    "descripcion":"SÍNDROME DE ADAM - OLIVER"
  },
  {
    "codigo":11808901000119106,
    "descripcion":"ABRASIÓN DE PIEL DE REGIÓN DE CADERA DERECHA"
  },
  {
    "codigo":296892005,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE METANDRIOL"
  },
  {
    "codigo":1980003,
    "descripcion":"OTITIS MEDIA SEROMUCINOSA"
  },
  {
    "codigo":1343633000,
    "descripcion":"HERNIA PARAUMBILICAL RECURRENTE"
  },
  {
    "codigo":165820009,
    "descripcion":"ANTICUERPO ANTI - LEGIONELLA NO DETECTADO"
  },
  {
    "codigo":196753007,
    "descripcion":"ATONÍA GÁSTRICA"
  },
  {
    "codigo":295057008,
    "descripcion":"ALERGIA A METILDIGOXINA"
  },
  {
    "codigo":293222001,
    "descripcion":"REACCIÓN ADVERSA A LA NANDROLONA"
  },
  {
    "codigo":194918008,
    "descripcion":"PERICARDITIS ESTREPTOCÓCICA AGUDA"
  },
  {
    "codigo":94779002,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL CUERPO CAROTÍDEO"
  },
  {
    "codigo":313631000119104,
    "descripcion":"MONOARTRITIS DE RODILLA IZQUIERDA"
  },
  {
    "codigo":10963231000119104,
    "descripcion":"LACERACIÓN DE REGIÓN DE CADERA DERECHA"
  },
  {
    "codigo":191248000,
    "descripcion":"ANEMIA APLÁSICA CAUSADA POR TÓXICO"
  },
  {
    "codigo":289552002,
    "descripcion":"SECRECIÓN VAGINAL BLANCA"
  },
  {
    "codigo":1010448005,
    "descripcion":"LESIÓN DE NEURONA MOTORA SUPERIOR IZQUIERDA"
  },
  {
    "codigo":92944008,
    "descripcion":"FORMA ANORMAL CONGÉNITA DE VÁLVULA TRICÚSPIDE"
  },
  {
    "codigo":123877006,
    "descripcion":"INTOXICACIÓN POR RANUNCULACEAE"
  },
  {
    "codigo":91109007,
    "descripcion":"VÁRICES GÁSTRICAS"
  },
  {
    "codigo":254949006,
    "descripcion":"EPENDIMOMA DE LA MÉDULA ESPINAL"
  },
  {
    "codigo":89274006,
    "descripcion":"ÁNTRAX DE LA REGIÓN TEMPORAL"
  },
  {
    "codigo":285882006,
    "descripcion":"OPERA HORNO DE MICROONDAS"
  },
  {
    "codigo":449722009,
    "descripcion":"HIPERMETROPÍA TOTAL"
  },
  {
    "codigo":253114009,
    "descripcion":"MIELOCELE CON HIDROCEFALIA"
  },
  {
    "codigo":87439002,
    "descripcion":"CALIDAD VOCAL NORMAL"
  },
  {
    "codigo":185743004,
    "descripcion":"CONTROL DE OBESIDAD - AUSENTE"
  },
  {
    "codigo":710031008,
    "descripcion":"ISQUEMIA INDUCIBLE QUE SE MANIFIESTA EN LA PRUEBA DE ESFUERZO POSTERIOR A INFARTO DE MIOCARDIO"
  },
  {
    "codigo":314980001,
    "descripcion":"REVERSIBILIDAD ESPIROMÉTRICA NEGATIVA"
  },
  {
    "codigo":249444002,
    "descripcion":"QUISTE EN CUERDA VOCAL"
  },
  {
    "codigo":282212001,
    "descripcion":"NO DETIENE LA MARCHA"
  },
  {
    "codigo":413284005,
    "descripcion":"TUMOR PARCIALMENTE OBSTRUCTIVO"
  },
  {
    "codigo":773732005,
    "descripcion":"DERMATITIS GRANULOMATOSA INTERSTICIAL CON ARTRITIS"
  },
  {
    "codigo":1363556008,
    "descripcion":"CARCINOMA NEUROENDOCRINO DE CÉLULAS GRANDES DE PULMÓN"
  },
  {
    "codigo":247609001,
    "descripcion":"INCAPAZ DE RECORDAR EL NOMBRE DEL MONARCA REINANTE"
  },
  {
    "codigo":278542003,
    "descripcion":"HALLAZGO RELACIONADO CON UN APARATO O RESTAURACIÓN DENTAL"
  },
  {
    "codigo":737294004,
    "descripcion":"ÓRGANO TRASPLANTADO PRESENTE"
  },
  {
    "codigo":81934005,
    "descripcion":"LENGUA PILOSA NEGRA"
  },
  {
    "codigo":735459007,
    "descripcion":"HIPERSENSIBILIDAD GASTROINTESTINAL CAUSADA POR ALIMENTO"
  },
  {
    "codigo":276707008,
    "descripcion":"NIÑO EN MAL ESTADO GENERAL AL NACER"
  },
  {
    "codigo":702691009,
    "descripcion":"SEROSITIS AGUDA"
  },
  {
    "codigo":209336001,
    "descripcion":"FRACTURA-LUXACIÓN EXPUESTA DE ARTICULACIÓN DE LA CADERA"
  },
  {
    "codigo":111032003,
    "descripcion":"AMILOIDOSIS CUTÁNEA MACULAR"
  },
  {
    "codigo":405944004,
    "descripcion":"BRONQUITIS ASMÁTICA"
  },
  {
    "codigo":1259747009,
    "descripcion":"INSULINOMA PRIMARIO MALIGNO"
  },
  {
    "codigo":699021000,
    "descripcion":"INTOXICACIÓN POR COAGULANTE"
  },
  {
    "codigo":1290680009,
    "descripcion":"RADIOGRAFÍA DE COLUMNA SACRA NORMAL"
  },
  {
    "codigo":43661002,
    "descripcion":"ALEXIA MOTORA"
  },
  {
    "codigo":10893003,
    "descripcion":"ADENITIS TUBERCULOSA"
  },
  {
    "codigo":2421000124105,
    "descripcion":"SEGUNDO PREMOLAR INFERIOR DERECHO PERMANENTE SUPERNUMERARIO"
  },
  {
    "codigo":240269006,
    "descripcion":"EXPOSICIÓN DE PRÓTESIS ARTICULAR"
  },
  {
    "codigo":1256077007,
    "descripcion":"XANTOMA DEBIDO A ENFERMEDAD POR ALMACENAMIENTO DE LÍPIDOS"
  },
  {
    "codigo":305805007,
    "descripcion":"ATENDIDO EN SERVICIO DE MEDICINA RESPIRATORIA"
  },
  {
    "codigo":895629006,
    "descripcion":"FORMA TRIANGULAR ANORMAL CONGÉNITA DE FALANGE DISTAL DE DEDO GORDO"
  },
  {
    "codigo":9058002,
    "descripcion":"FÍSTULA DUODENOAÓRTICA"
  },
  {
    "codigo":404109006,
    "descripcion":"MICOSIS FUNGOIDE TIPO MUCINOSIS FOLICULAR"
  },
  {
    "codigo":342611000119109,
    "descripcion":"LUPUS ERITEMATOSO DISCOIDE DE PIEL DE PÁRPADO DERECHO"
  },
  {
    "codigo":205666005,
    "descripcion":"DUPLICACIÓN CON OTRO REORDENAMIENTO COMPLEJO"
  },
  {
    "codigo":369506003,
    "descripcion":"TUMOR MALIGNO QUE COMPROMETE VAGINA POR EXTENSIÓN DIRECTA DESDE TROMPA DE FALOPIO"
  },
  {
    "codigo":74594005,
    "descripcion":"ECTOPIA RENAL CRUZADA"
  },
  {
    "codigo":1186871002,
    "descripcion":"MIELOPATÍA DEBIDA A INTOXICACIÓN ALIMENTARIA"
  },
  {
    "codigo":72759002,
    "descripcion":"QUEMADURA PROFUNDA DE TERCER GRADO DE HOMBRO"
  },
  {
    "codigo":105527005,
    "descripcion":"VIVIR EN CONDICIONES SANITARIAS INSUFICIENTES"
  },
  {
    "codigo":890124000,
    "descripcion":"SÍNDROME DE DELECIÓN 5Q22.2"
  },
  {
    "codigo":267532001,
    "descripcion":"TRASTORNO PLAQUETARIO CUALITATIVO"
  },
  {
    "codigo":236599009,
    "descripcion":"ESQUISTOSOMIASIS DE URÉTER"
  },
  {
    "codigo":201996005,
    "descripcion":"ARTROPATÍA TRANSITORIA DE MÚLTIPLES LOCALIZACIONES"
  },
  {
    "codigo":300300007,
    "descripcion":"ASPIRADO GÁSTRICO CON CONTENIDO DE SANGRE"
  },
  {
    "codigo":5388008,
    "descripcion":"DEFICIENCIA CONGÉNITA DE LACTASA"
  },
  {
    "codigo":298465001,
    "descripcion":"AMPLITUD DE ROTACIÓN ACTIVA HACIA LA IZQUIERDA DE LA COLUMNA CERVICAL DISMINUIDA"
  },
  {
    "codigo":365836009,
    "descripcion":"MÉDULA ÓSEA: CÉLULAS EXTRAÑAS - HALLAZGO"
  },
  {
    "codigo":36321004,
    "descripcion":"SOMNILOQUIA"
  },
  {
    "codigo":724449008,
    "descripcion":"TEMOR A ENFERMEDAD MAMARIA"
  },
  {
    "codigo":165558001,
    "descripcion":"RECUENTO DE PLAQUETAS FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":296630001,
    "descripcion":"SOBREDOSIS DE VANCOMICINA"
  },
  {
    "codigo":1148598004,
    "descripcion":"ARTRITIS REUMÁTICA DE ARTICULACIÓN TEMPOROMANDIBULAR"
  },
  {
    "codigo":722614006,
    "descripcion":"CONTUSIÓN NO HEMORRÁGICA FOCAL DE CEREBRO"
  },
  {
    "codigo":427702008,
    "descripcion":"MASA DUODENAL"
  },
  {
    "codigo":34486009,
    "descripcion":"HIPERTIROIDISMO"
  },
  {
    "codigo":294795000,
    "descripcion":"ALERGIA A ESTRÓGENO CONJUGADO"
  },
  {
    "codigo":130955003,
    "descripcion":"SUFRIMIENTO FETAL"
  },
  {
    "codigo":65419005,
    "descripcion":"SITOSTEROLEMIA CON XANTOMATOSIS"
  },
  {
    "codigo":196491008,
    "descripcion":"ABSCESO DE GLÁNDULA PARÓTIDA"
  },
  {
    "codigo":792210311000119105,
    "descripcion":"LACERACIÓN DE MÚSCULO INTRÍNSECO DE DEDO MEÑIQUE"
  },
  {
    "codigo":1144928005,
    "descripcion":"TIMOMA TIPO A"
  },
  {
    "codigo":292960005,
    "descripcion":"REACCIÓN ADVERSA A LA PENICILINA PROCAÍNA"
  },
  {
    "codigo":225589000,
    "descripcion":"SE AHOGA AL TRAGAR"
  },
  {
    "codigo":1208629005,
    "descripcion":"CONVULSIÓN CON AUSENCIA MIOCLÓNICA"
  },
  {
    "codigo":94517007,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL TEJIDO RETROCECAL"
  },
  {
    "codigo":127285009,
    "descripcion":"FRACTURA DE HUESO LAGRIMAL"
  },
  {
    "codigo":92682003,
    "descripcion":"CARCINOMA IN SITU DE LA GLÁNDULA PINEAL"
  },
  {
    "codigo":190986006,
    "descripcion":"DEFICIENCIA DE ANTICUERPOS CON INMUNOGLOBULINAS CASI NORMALES O CON HIPERINMUNOGLOBULINEMIA"
  },
  {
    "codigo":289290009,
    "descripcion":"HALLAZGO RELACIONADO CON MEDICIONES DE LAS MEMBRANAS AMNIÓTICAS"
  },
  {
    "codigo":189151003,
    "descripcion":"NEOPLASIA BENIGNA DE IRIS"
  },
  {
    "codigo":123615007,
    "descripcion":"ATROFIA VISUAL SECUNDARIA"
  },
  {
    "codigo":1268660000,
    "descripcion":"CAPAZ DE PAGAR SERVICIO DE INTERNET"
  },
  {
    "codigo":25311008,
    "descripcion":"INTENSIDAD DEL SOPLO CARDÍACO, GRADO IV"
  },
  {
    "codigo":1170356005,
    "descripcion":"3, 3' - DIYODOTIRONINA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":87177002,
    "descripcion":"QUEMADURA DE LA BOCA"
  },
  {
    "codigo":15664161000119107,
    "descripcion":"NEOPLASIA BENIGNA DE AMBAS ÓRBITAS"
  },
  {
    "codigo":283785002,
    "descripcion":"HERIDA POR MORDEDURA DE CONEJO"
  },
  {
    "codigo":218249005,
    "descripcion":"TRASTORNO DEBIDO A INTOXICACIÓN ACCIDENTAL Y POSTERIOR A ELLA"
  },
  {
    "codigo":185481008,
    "descripcion":"DISCONFORME CON EL MÉDICO"
  },
  {
    "codigo":249182002,
    "descripcion":"MEMBRANAS INCOMPLETAS"
  },
  {
    "codigo":183646003,
    "descripcion":"CONSULTA POSQUIRÚRGICA"
  },
  {
    "codigo":871774005,
    "descripcion":"REACCIÓN ADVERSA A OXIQUINOLINA"
  },
  {
    "codigo":609630008,
    "descripcion":"HALLAZGO RELACIONADO CON LA AXILA"
  },
  {
    "codigo":116275003,
    "descripcion":"HALLAZGO RELACIONADO CON LA COLUMNA CERVICAL"
  },
  {
    "codigo":1081271000119100,
    "descripcion":"OSTEOSARCOMA PRIMARIO DE HUESO DE EXTREMIDAD SUPERIOR IZQUIERDA"
  },
  {
    "codigo":6071000119100,
    "descripcion":"ALERGIA DEL TRACTO RESPIRATORIO SUPERIOR"
  },
  {
    "codigo":10676151000119101,
    "descripcion":"ASMA ALÉRGICA PERSISTENTE LEVE NO CONTROLADA"
  },
  {
    "codigo":290231000119100,
    "descripcion":"LESIÓN DE NERVIO CUBITAL IZQUIERDO"
  },
  {
    "codigo":336311000119103,
    "descripcion":"BLEFARITIS DE PÁRPADO DERECHO"
  },
  {
    "codigo":494884791000119105,
    "descripcion":"PORTADOR DE ANEMIA DE FANCONI DE GRUPO COMPLEMENTARIO C"
  },
  {
    "codigo":16023991000119104,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DEBIDO A OCLUSIÓN DE ARTERIA PONTINA IZQUIERDA"
  },
  {
    "codigo":16006071000119100,
    "descripcion":"TROMBOFLEBITIS DE VENA DE MIEMBRO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":10624951000119108,
    "descripcion":"OTITIS MEDIA CAUSADA POR VIRUS INFLUENZA"
  },
  {
    "codigo":1091511000119109,
    "descripcion":"OTITIS EXTERNA HEMORRÁGICA DE CONDUCTO AUDITIVO EXTERNO DERECHO"
  },
  {
    "codigo":292791000119109,
    "descripcion":"TRASTORNO DE NERVIO MEDIANO DERECHO"
  },
  {
    "codigo":442120007,
    "descripcion":"PARÁLISIS DEL SUEÑO AISLADA RECURRENTE"
  },
  {
    "codigo":473053000,
    "descripcion":"INFECCIÓN ASOCIADA CON DISPOSITIVO ORTOPÉDICO"
  },
  {
    "codigo":16036791000119108,
    "descripcion":"DETENCIÓN DE CRECIMIENTO EPIFISARIO DE PIERNA IZQUIERDA"
  },
  {
    "codigo":15637431000119106,
    "descripcion":"ALTERACIÓN DE MENISCO DE RODILLA IZQUIERDA"
  },
  {
    "codigo":16047031000119109,
    "descripcion":"ENFERMEDAD POR DEPÓSITO DE HIDROXIAPATITA DE RODILLA IZQUIERDA"
  },
  {
    "codigo":10645431000119107,
    "descripcion":"ÚLCERA VARICOSA DE PIE DERECHO"
  },
  {
    "codigo":16311000119108,
    "descripcion":"NEUMONÍA CAUSADA POR VIRUS INFLUENZA"
  },
  {
    "codigo":702429008,
    "descripcion":"DEMENCIA FRONTOTEMPORAL ASOCIADA CON PARKINSONISMO LIGADO AL CROMOSOMA 17"
  },
  {
    "codigo":1259485008,
    "descripcion":"DEMENCIA DEBIDA A VASCULITIS CEREBRAL"
  },
  {
    "codigo":209074003,
    "descripcion":"LUXACIÓN NO EXPUESTA DE LA COLUMNA VERTEBRAL LUMBAR"
  },
  {
    "codigo":10631000,
    "descripcion":"PULMÓN IZQUIERDO TRILOBULADO"
  },
  {
    "codigo":405682009,
    "descripcion":"ESTADO DE SUPERVISIÓN"
  },
  {
    "codigo":274610009,
    "descripcion":"RESPUESTA PLANTAR DERECHA, FLEXORA"
  },
  {
    "codigo":240007003,
    "descripcion":"LESIÓN DE LA CÁPSULA DE LA REGIÓN DE LA RODILLA"
  },
  {
    "codigo":1255815000,
    "descripcion":"HISTIOCITOSIS MALIGNA DE GANGLIOS LINFÁTICOS DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":371079004,
    "descripcion":"PARÁLISIS CEREBRAL PARAPLÉJICA"
  },
  {
    "codigo":241842009,
    "descripcion":"EFECTO TÓXICO CAUSADO POR PRODUCTO LAVAVAJILLA"
  },
  {
    "codigo":733362008,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE GLÁNDULA PARAURETRAL"
  },
  {
    "codigo":403847008,
    "descripcion":"TRAUMATISMO CUTÁNEO PERINATAL POR TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":926300001,
    "descripcion":"EPÍFISIS PEQUEÑA DE FALANGE DE MANO"
  },
  {
    "codigo":762460002,
    "descripcion":"DEFECTO DE TABIQUE INTERVENTRICULAR SIN SIGNIFICACIÓN HEMODINÁMICA"
  },
  {
    "codigo":860764004,
    "descripcion":"ALERGIA A TRIAZOL"
  },
  {
    "codigo":15912431000119100,
    "descripcion":"FRACTURA NO EXPUESTA DE CABEZA DE FÉMUR DERECHO"
  },
  {
    "codigo":41564009,
    "descripcion":"PTERIGIÓN DOBLE"
  },
  {
    "codigo":39729001,
    "descripcion":"ABSCESO DE EPIDÍDIMO"
  },
  {
    "codigo":72497001,
    "descripcion":"FRACTURA NO EXPUESTA DE CUELLO DE RADIO"
  },
  {
    "codigo":1186609002,
    "descripcion":"APOYO EMOCIONAL INADECUADO"
  },
  {
    "codigo":301873005,
    "descripcion":"LIPOMA DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":203569006,
    "descripcion":"DEFORMIDAD EN FLEXIÓN DE LA RODILLA"
  },
  {
    "codigo":5126000,
    "descripcion":"HIPERTROFIA DE LAS PAPILAS FOLIADAS"
  },
  {
    "codigo":168966002,
    "descripcion":"VENOGRAFÍA ANORMAL"
  },
  {
    "codigo":365574009,
    "descripcion":"HALLAZGO RELACIONADO CON EVENTO DEL CICLO VITAL"
  },
  {
    "codigo":1084911000119104,
    "descripcion":"COLANGITIS CRÓNICA DEBIDA A CÁLCULO DE CONDUCTO BILIAR CON OBSTRUCCIÓN"
  },
  {
    "codigo":3291007,
    "descripcion":"FRACTURA NO EXPUESTA DE DOS COSTILLAS"
  },
  {
    "codigo":298203008,
    "descripcion":"LAXITUD ARTICULAR"
  },
  {
    "codigo":787888001,
    "descripcion":"ACTINOMYCES MEYERI O ACTINOMYCES ODONTOLYTICUS"
  },
  {
    "codigo":165296001,
    "descripcion":"MEMORIA: TIENE CONSCIENCIA DEL MES ACTUAL"
  },
  {
    "codigo":1344944003,
    "descripcion":"DELIRIO CAUSADO POR CANNABIS"
  },
  {
    "codigo":198064007,
    "descripcion":"ESTENOSIS DE ÓRGANO GENITAL MASCULINO"
  },
  {
    "codigo":720517001,
    "descripcion":"SÍNDROME DE ATAXIA CON SORDERA Y DISCAPACIDAD INTELECTUAL"
  },
  {
    "codigo":425605001,
    "descripcion":"ALERGIA A LANA"
  },
  {
    "codigo":32389002,
    "descripcion":"ACTINOBACILOSIS CAUSADA POR ACTINOBACILLUS SUIS"
  },
  {
    "codigo":296368009,
    "descripcion":"SOBREDOSIS DE ANTICOLINESTERASA"
  },
  {
    "codigo":194394004,
    "descripcion":"SEPSIS POR GRAMPOSITIVOS"
  },
  {
    "codigo":11789961000119104,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE DEDO DE MANO DERECHA"
  },
  {
    "codigo":94255003,
    "descripcion":"NEOPLASIA MALIGNA SECUNDARIA DEL CUERPO CILIAR"
  },
  {
    "codigo":389167007,
    "descripcion":"DISPLASIA ACROMESOMÉLICA TIPO HUNTER - THOMPSON"
  },
  {
    "codigo":715012000,
    "descripcion":"INCAPAZ DE CAMINAR SOBRE UNA SUPERFICIE DESPAREJA"
  },
  {
    "codigo":92420001,
    "descripcion":"NEOPLASIA BENIGNA DE LA REGIÓN SUPRACLAVICULAR"
  },
  {
    "codigo":127023007,
    "descripcion":"NEOPLASIA DE LA MÉDULA DE LA GLÁNDULA SUPRARRENAL"
  },
  {
    "codigo":878852003,
    "descripcion":"FRACTURA DE RODILLA"
  },
  {
    "codigo":289028000,
    "descripcion":"DIFICULTAD PARA COMER CON LOS DEDOS"
  },
  {
    "codigo":190724004,
    "descripcion":"TRASTORNO DEL METABOLISMO DE LA GLUTAMINA"
  },
  {
    "codigo":26884006,
    "descripcion":"MANCHADO POSTERUPTIVO DEL DIENTE POR HEMORRAGIA DE LA PULPA"
  },
  {
    "codigo":90585003,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE LA PARED ABDOMINAL, SIN INFECCIÓN"
  },
  {
    "codigo":188889004,
    "descripcion":"NEOPLASIA BRONCOPULMONAR BENIGNA DE LÓBULO SUPERIOR"
  },
  {
    "codigo":254425003,
    "descripcion":"CARCINOMA DE LA ENCÍA INFERIOR"
  },
  {
    "codigo":1237465008,
    "descripcion":"METÁSTASIS DE ADENOCARCINOMA EN VEJIGA URINARIA"
  },
  {
    "codigo":187054003,
    "descripcion":"HISTOPLASMOSIS PULMONAR"
  },
  {
    "codigo":185219003,
    "descripcion":"ATENDIDO EN HOGAR PARA ANCIANOS DISCAPACITADOS"
  },
  {
    "codigo":21379009,
    "descripcion":"SENO DE VALSALVA ROTO"
  },
  {
    "codigo":283523009,
    "descripcion":"HERIDA PUNZANTE DE DORSO"
  },
  {
    "codigo":707672001,
    "descripcion":"BLASTOMA PLEUROPULMONAR TIPO II"
  },
  {
    "codigo":871512004,
    "descripcion":"REACCIÓN ADVERSA A PIVAMPICILINA Y\/O PIVMECILINAM"
  },
  {
    "codigo":85080004,
    "descripcion":"DISTIMIA SECUNDARIA"
  },
  {
    "codigo":17709002,
    "descripcion":"VÁRICES ESOFÁGICAS SANGRANTES"
  },
  {
    "codigo":50477003,
    "descripcion":"FÍSTULA URETROVAGINAL"
  },
  {
    "codigo":1197357008,
    "descripcion":"SÍNDROME DE DISCO ÓPTICO COLOBOMATOSO, ATROFIA MACULAR Y CORIORRETINOPATÍA"
  },
  {
    "codigo":441858005,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR TRASTUZUMAB ADMINISTRADO POR INFUSIÓN"
  },
  {
    "codigo":472791002,
    "descripcion":"ESTENOSIS DE GRAN VENA PULMONAR COMO COMPLICACIÓN DE PROCEDIMIENTO"
  },
  {
    "codigo":1193687005,
    "descripcion":"ENTERITIS POR ESCHERICHIA COLI ENTEROTOXIGÉNICA"
  },
  {
    "codigo":307116001,
    "descripcion":"MUTACIÓN DEL FACTOR V LEIDEN HETEROCIGÓTICO"
  },
  {
    "codigo":700332002,
    "descripcion":"ARTROSIS SECUNDARIA DE PRIMERA ARTICULACIÓN METATARSOFALÁNGICA"
  },
  {
    "codigo":12204004,
    "descripcion":"FRACTURA NO EXPUESTA DE MÚLTIPLES COSTILLAS"
  },
  {
    "codigo":896940006,
    "descripcion":"FORMA DE BALA ANORMAL CONGÉNITA DE FALANGE PROXIMAL DE TERCER DEDO DE PIE"
  },
  {
    "codigo":239745002,
    "descripcion":"INESTABILIDAD CRÓNICA DE ARTICULACIÓN METACARPOFALÁNGICA DE PULGAR"
  },
  {
    "codigo":1157249003,
    "descripcion":"ADENOMA HIPOFISARIO BENIGNO INVASIVO"
  },
  {
    "codigo":403585004,
    "descripcion":"ARTIFICIO DE LA PRUEBA DEL PARCHE"
  },
  {
    "codigo":16052311000119102,
    "descripcion":"TRASTORNO DE TENDÓN DE AMBAS MANOS"
  },
  {
    "codigo":205142003,
    "descripcion":"SINDACTILIA ÓSEA DE DEDOS DE LA MANO - PRIMERA MEMBRANA INTERDIGITAL"
  },
  {
    "codigo":677821000119109,
    "descripcion":"OCLUSIÓN PARCIAL DE VENA DE LA RETINA IZQUIERDA"
  },
  {
    "codigo":237910006,
    "descripcion":"TRASTORNO OSMÓTICO"
  },
  {
    "codigo":236075000,
    "descripcion":"DIARREA CAUSADA POR INGESTIÓN DE SUSTANCIAS NO ABSORBIBLES"
  },
  {
    "codigo":303446009,
    "descripcion":"NO COLOCA UN OBJETO DENTRO DE OTRO"
  },
  {
    "codigo":399915007,
    "descripcion":"DERMATOSIS ACANTOLÍTICA ADQUIRIDA"
  },
  {
    "codigo":398080000,
    "descripcion":"MORBILIDAD EN INTUBACIÓN TRAQUEAL"
  },
  {
    "codigo":1348352001,
    "descripcion":"TC DE TRACTO GASTROINTESTINAL NORMAL"
  },
  {
    "codigo":37632001,
    "descripcion":"PLEURITIS OBLITERANTE"
  },
  {
    "codigo":170539009,
    "descripcion":"REQUIERE VACUNACIÓN ANTIPOLIOMIELÍTICA"
  },
  {
    "codigo":365312004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA PLANCHAR"
  },
  {
    "codigo":299776005,
    "descripcion":"REFLEJO TÓNICO CERVICAL DE RESULTADO DUDOSO"
  },
  {
    "codigo":168704006,
    "descripcion":"RADIOGRAFÍA SIMPLE DE ABDOMEN ANORMAL"
  },
  {
    "codigo":234240008,
    "descripcion":"RUPTURA DEL BALÓN INTRAÓRTICO"
  },
  {
    "codigo":363477002,
    "descripcion":"NEOPLASIA MALIGNA DE LA COLA DE CABALLO"
  },
  {
    "codigo":11792471000119107,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN DE DEDO DE MANO DERECHA"
  },
  {
    "codigo":427178000,
    "descripcion":"ESPASMO DEL MÚSCULO PIRIFORME"
  },
  {
    "codigo":297941009,
    "descripcion":"ERITEMA TÓXICO CAUSADO POR FÁRMACO"
  },
  {
    "codigo":232405008,
    "descripcion":"FARINGITIS ULCEROSA CRÓNICA"
  },
  {
    "codigo":1194003,
    "descripcion":"DETERMINACIÓN DEL ESTADO DE LA ENFERMEDAD: BIEN CONTROLADA"
  },
  {
    "codigo":68565009,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO ABDOMINAL"
  },
  {
    "codigo":230570005,
    "descripcion":"SÍNDROME DE ARDOR EN LOS PIES"
  },
  {
    "codigo":296106004,
    "descripcion":"SOBREDOSIS DE OXAZEPAM"
  },
  {
    "codigo":197802007,
    "descripcion":"QUISTE LINFÁTICO PERIPÉLVICO"
  },
  {
    "codigo":1344682008,
    "descripcion":"ENFERMEDAD DE KASHIN-BECK DE MUÑECA"
  },
  {
    "codigo":195967001,
    "descripcion":"ASMA"
  },
  {
    "codigo":294271001,
    "descripcion":"ALERGIA A FLUMAZENIL"
  },
  {
    "codigo":292436002,
    "descripcion":"REACCIÓN ADVERSA AL LEVOBUNOLOL"
  },
  {
    "codigo":128596003,
    "descripcion":"INSUFICIENCIA DE ACILCOENZIMA A DESHIDROGENASA DE CADENA MEDIA"
  },
  {
    "codigo":1144404003,
    "descripcion":"HIPOPLASIA CONGÉNITA DE HÉLICE DE OREJA"
  },
  {
    "codigo":30292005,
    "descripcion":"MONONEURITIS MÚLTIPLE"
  },
  {
    "codigo":95828007,
    "descripcion":"SORDERA CONGÉNITA"
  },
  {
    "codigo":194132009,
    "descripcion":"PARÁLISIS DE CONVERGENCIA"
  },
  {
    "codigo":126761005,
    "descripcion":"NEOPLASIA DE VASO SANGUÍNEO DE PERINEO"
  },
  {
    "codigo":93993007,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LÓBULO SUPERIOR DE PULMÓN DERECHO"
  },
  {
    "codigo":419838000,
    "descripcion":"REACCIÓN ALÉRGICA CAUSADA POR SUSTANCIA QUÍMICA"
  },
  {
    "codigo":716585008,
    "descripcion":"FIEBRE HEMORRÁGICA CAUSADA POR VIRUS LUJO"
  },
  {
    "codigo":288766003,
    "descripcion":"NO COMUNICA SENTIMIENTOS"
  },
  {
    "codigo":714750008,
    "descripcion":"TRASTORNO INFLAMATORIO DE REGIÓN MANDIBULAR"
  },
  {
    "codigo":92158009,
    "descripcion":"NEOPLASIA BENIGNA DEL ISQUION"
  },
  {
    "codigo":254163001,
    "descripcion":"ICTIOSIS LAMELAR NO ERITRODÉRMICA"
  },
  {
    "codigo":188627002,
    "descripcion":"MICOSIS FUNGOIDE DE GANGLIOS LINFÁTICOS DE MÚLTIPLES LOCALIZACIONES"
  },
  {
    "codigo":24787008,
    "descripcion":"AUSENCIA CONGÉNITA DEL LIGAMENTO ANCHO"
  },
  {
    "codigo":186792002,
    "descripcion":"PALUDISMO CAUSADO POR PLASMODIUM VIVAX, CON RUPTURA ESPLÉNICA"
  },
  {
    "codigo":53885001,
    "descripcion":"HIPOTONÍA OCULAR CONCOMITANTE CON FÍSTULA OCULAR Y DEBIDA A ELLA"
  },
  {
    "codigo":21117005,
    "descripcion":"HEMORRAGIA CONJUNTIVAL"
  },
  {
    "codigo":283261006,
    "descripcion":"VIDRIO EN GENITALES"
  },
  {
    "codigo":119421006,
    "descripcion":"CISTOADENOMA SEROSO OVÁRICO"
  },
  {
    "codigo":445266000,
    "descripcion":"TUMOR TENOSINOVIAL DE CÉLULAS GIGANTES DIFUSO DE ARTICULACIÓN DE RODILLA"
  },
  {
    "codigo":314194001,
    "descripcion":"DIABÉTICO EN TRATAMIENTO POR VÍA ORAL Y CON INSULINA"
  },
  {
    "codigo":1231698002,
    "descripcion":"DESPRENDIMIENTO DE RETINA TRACCIONAL CON COMPROMISO MACULAR DEBIDO A RETINOPATÍA PROLIFERATIVA DIABÉTICA"
  },
  {
    "codigo":19282004,
    "descripcion":"TOS DURANTE EL EJERCICIO"
  },
  {
    "codigo":248658004,
    "descripcion":"PRIMER RUIDO MITRAL PALPABLE"
  },
  {
    "codigo":707410008,
    "descripcion":"CARCINOMA SÓLIDO PRIMARIO DE PULMÓN"
  },
  {
    "codigo":50215002,
    "descripcion":"DIFTERIA LARÍNGEA"
  },
  {
    "codigo":312359004,
    "descripcion":"NEVO BENIGNO DE LA PLANTA DEL PIE"
  },
  {
    "codigo":246823006,
    "descripcion":"ECTROPIÓN DE PÁRPADO INFERIOR CON RETRACCIÓN"
  },
  {
    "codigo":115751007,
    "descripcion":"FENOTIPO I>CORDÓN<"
  },
  {
    "codigo":212220007,
    "descripcion":"LESIÓN DE RAÍZ DE NERVIO LUMBAR - L3"
  },
  {
    "codigo":310524008,
    "descripcion":"TUMOR DE PARTES BLANDAS DE LA ESPALDA"
  },
  {
    "codigo":408828008,
    "descripcion":"PRUEBA PARA CRIBADO PRENATAL DE VIH EN SANGRE ENVIADA"
  },
  {
    "codigo":308689002,
    "descripcion":"LESIÓN NUMULAR DE PULMÓN"
  },
  {
    "codigo":81148009,
    "descripcion":"TONO VOCAL NORMAL"
  },
  {
    "codigo":112081003,
    "descripcion":"TORTURA SÁDICA"
  },
  {
    "codigo":275921007,
    "descripcion":"PICAZÓN EN EL CUERO CABELLUDO"
  },
  {
    "codigo":210385007,
    "descripcion":"HERIDA ABIERTA DE LA LARINGE"
  },
  {
    "codigo":110246003,
    "descripcion":"CONTUSIÓN DE LA REGIÓN PREAURICULAR DE LA CARA"
  },
  {
    "codigo":11942004,
    "descripcion":"LACERACIÓN PERINEAL QUE COMPROMETE EL PISO PÉLVICO"
  },
  {
    "codigo":77478005,
    "descripcion":"OTITIS MEDIA AGUDA SANGUINOLENTA"
  },
  {
    "codigo":208550004,
    "descripcion":"FRACTURA NO EXPUESTA DE FÉMUR PROXIMAL, INTERTROCANTÉREA, DOS PARTES"
  },
  {
    "codigo":863910007,
    "descripcion":"TUMEFACCIÓN EN LUGAR DE VACUNACIÓN"
  },
  {
    "codigo":370555000,
    "descripcion":"INCONTINENCIA URINARIA POR INCOMPETENCIA DEL ESFÍNTER URETRAL"
  },
  {
    "codigo":306854007,
    "descripcion":"TROMBOSIS DE INJERTO-PUENTE FEMOROFEMORAL CRUZADO"
  },
  {
    "codigo":44710007,
    "descripcion":"ANOMALÍA DEL PAR DE CROMOSOMAS 6"
  },
  {
    "codigo":403323005,
    "descripcion":"ALOPECIA AREATA CIRCUNSCRIPTA DE MIEMBROS"
  },
  {
    "codigo":763771009,
    "descripcion":"LEIOMIOSARCOMA DE CUELLO UTERINO"
  },
  {
    "codigo":41040004,
    "descripcion":"SÍNDROME DE TRISOMÍA 21 COMPLETA"
  },
  {
    "codigo":203045001,
    "descripcion":"ENFERMEDAD DE DUPUYTREN DE LA PALMA"
  },
  {
    "codigo":217791000119107,
    "descripcion":"CATARATA SENIL HIPERMADURA"
  },
  {
    "codigo":71973003,
    "descripcion":"APLASIA CONGÉNITA DEL OÍDO INTERNO"
  },
  {
    "codigo":170277004,
    "descripcion":"EXAMEN DEL NIÑO A LOS 21 MESES: ANORMAL - PARA OBSERVACIÓN"
  },
  {
    "codigo":39205007,
    "descripcion":"PANCREATITIS INFECCIOSA"
  },
  {
    "codigo":301349008,
    "descripcion":"HALLAZGO RELACIONADO CON LA DISPOSICIÓN DE LABIO"
  },
  {
    "codigo":299514001,
    "descripcion":"CREPITACIÓN DE ARTICULACIÓN DE PIE"
  },
  {
    "codigo":102906002,
    "descripcion":"CONDUCTA DELICTIVA"
  },
  {
    "codigo":168442001,
    "descripcion":"TEJIDO CITOLÓGICO NORMAL"
  },
  {
    "codigo":365050000,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA EMPLEAR CONSTRUCCIONES GRAMATICALES"
  },
  {
    "codigo":37370005,
    "descripcion":"ANEMIA MEGALOBLÁSTICA CAUSADA POR DROGAS"
  },
  {
    "codigo":235813008,
    "descripcion":"ROTACIÓN PATOLÓGICA DEL INTESTINO, TIPO IIA"
  },
  {
    "codigo":4602007,
    "descripcion":"SUCESIÓN DE ROBIN"
  },
  {
    "codigo":723663001,
    "descripcion":"DIAGNÓSTICO NO REALIZADO"
  },
  {
    "codigo":233978009,
    "descripcion":"SÍNDROME DE ATRAPAMIENTO POPLÍTEO"
  },
  {
    "codigo":232143002,
    "descripcion":"PARÁLISIS FUNCIONAL DE ACOMODACIÓN"
  },
  {
    "codigo":230308000,
    "descripcion":"COREA TIROTÓXICA"
  },
  {
    "codigo":295844001,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE BUTRIPTILINA"
  },
  {
    "codigo":721828000,
    "descripcion":"INFECCIÓN CAUSADA POR ONCHOCERCA"
  },
  {
    "codigo":263076003,
    "descripcion":"FRACTURA-LUXACIÓN DE ARTICULACIÓN ESCAPULOTORÁCICA"
  },
  {
    "codigo":932006,
    "descripcion":"AFECTO PLANO"
  },
  {
    "codigo":33700007,
    "descripcion":"SENO DE VALSALVA ROTO EN AURÍCULA DERECHA"
  },
  {
    "codigo":787364009,
    "descripcion":"METABOLIZADOR INTERMEDIO DE LA FAMILIA 1 SUBFAMILIA A MIEMBRO 2 DEL CITOCROMO P450"
  },
  {
    "codigo":294009007,
    "descripcion":"ALERGIA A METACOLINA"
  },
  {
    "codigo":423246000,
    "descripcion":"AGENTE INFECCIOSO EN EL AMBIENTE"
  },
  {
    "codigo":292174002,
    "descripcion":"REACCIÓN ADVERSA AL TRICLORETILENO"
  },
  {
    "codigo":128334002,
    "descripcion":"ANOMALÍA CONGÉNITA DE LA BOCA"
  },
  {
    "codigo":95566004,
    "descripcion":"LITIASIS URINARIA"
  },
  {
    "codigo":161102006,
    "descripcion":"MIEMBRO DE LA ASOCIACIÓN DIABÉTICA"
  },
  {
    "codigo":126499002,
    "descripcion":"NEOPLASIA DE LA PIEL DE LOS PÁRPADOS"
  },
  {
    "codigo":93731002,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE BRONQUIO DEL LÓBULO INFERIOR DERECHO DEL PULMÓN"
  },
  {
    "codigo":1142307005,
    "descripcion":"CRECIMIENTO DE PELO DE CEJA AUMENTADO"
  },
  {
    "codigo":386808001,
    "descripcion":"FOBIA"
  },
  {
    "codigo":59128005,
    "descripcion":"PULMÓN EN PANAL DE ABEJAS CONGÉNITO"
  },
  {
    "codigo":26360005,
    "descripcion":"ATROFIA ÓPTICA HEREDITARIA"
  },
  {
    "codigo":124664006,
    "descripcion":"DEFICIENCIA DE MALEILOACETOACETATO ISOMERASA"
  },
  {
    "codigo":91896009,
    "descripcion":"AUSENCIA CONGÉNITA DE MANDÍBULA"
  },
  {
    "codigo":1204173002,
    "descripcion":"ATEROSCLEROSIS DE ARTERIA POPLÍTEA"
  },
  {
    "codigo":712653003,
    "descripcion":"PARTO POR OPERACIÓN CESÁREA POR PRESENTACIÓN PODÁLICA"
  },
  {
    "codigo":155597006,
    "descripcion":"NEUMONITIS POR ASPIRACIÓN"
  },
  {
    "codigo":1236941006,
    "descripcion":"METÁSTASIS DE CARCINOMA DE CONDUCTO BILIAR INTRAHEPÁTICO"
  },
  {
    "codigo":286669009,
    "descripcion":"DISOCIACIÓN - MECANISMO DE DEFENSA PSICOLÓGICA"
  },
  {
    "codigo":253901009,
    "descripcion":"ESTENOSIS POR VÁLVULA URETRAL CONGÉNITA POSTERIOR"
  },
  {
    "codigo":448674007,
    "descripcion":"NEOPLASIA MALIGNA DE PARAMETRIO"
  },
  {
    "codigo":284834008,
    "descripcion":"CAPAZ DE LIMPIARSE LA BOCA"
  },
  {
    "codigo":282999004,
    "descripcion":"NO VOLTEA EL CUERPO"
  },
  {
    "codigo":1003895007,
    "descripcion":"DELECIÓN PROXIMAL DEL BRAZO LARGO DEL CROMOSOMA 9"
  },
  {
    "codigo":19020001,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM SCROFULACEUM"
  },
  {
    "codigo":84556003,
    "descripcion":"GRADO DE GLEASON: 6"
  },
  {
    "codigo":281164004,
    "descripcion":"CUERPO EXTRAÑO EN EL PIE"
  },
  {
    "codigo":445004006,
    "descripcion":"PRESIÓN INTRABDOMINAL POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1264204007,
    "descripcion":"TRASTORNO NEONATAL PRECOZ CAUSADO POR TRANSFERENCIA PLACENTARIA DE TRANQUILIZANTE MATERNO DURANTE TRABAJO DE PARTO"
  },
  {
    "codigo":707148007,
    "descripcion":"ENFERMEDAD RENAL RECURRENTE POSTERIOR A TRASPLANTE DE RIÑÓN"
  },
  {
    "codigo":1231436008,
    "descripcion":"POSICIÓN FETAL EN PRESENTACIÓN PÉLVICA EN EMBARAZO"
  },
  {
    "codigo":950410381000119107,
    "descripcion":"INMUNODEFICIENCIA CAUSADA POR USO TERAPÉUTICO A LARGO PLAZO DE INMUNOSUPRESOR"
  },
  {
    "codigo":82721003,
    "descripcion":"SÍNDROME DE GIANOTTI-CROSTI"
  },
  {
    "codigo":17185004,
    "descripcion":"INFECCIÓN CAUSADA POR WEHRDIKMANSIA"
  },
  {
    "codigo":1196833007,
    "descripcion":"NEOPLASIA DE ESTROMA GASTROINTESTINAL BENIGNA DE INTESTINO GRUESO"
  },
  {
    "codigo":11826471000119102,
    "descripcion":"DISTENSIÓN DE TENDÓN DE MÚSCULO FLEXOR DE CADERA DERECHA"
  },
  {
    "codigo":277494001,
    "descripcion":"ASAS VASCULARES DEL OÍDO INTERNO"
  },
  {
    "codigo":15350006,
    "descripcion":"GRANULOMA GIGANTOCELULAR REPARATIVO DEL CENTRO DE LA MANDÍBULA"
  },
  {
    "codigo":310262007,
    "descripcion":"ANTICUERPOS ANTIRRIBONUCLEOPROTEÍNAS DETECTADOS"
  },
  {
    "codigo":703478008,
    "descripcion":"RETRASO DEL DESARROLLO DE APTITUDES SOCIALES"
  },
  {
    "codigo":769014008,
    "descripcion":"CARIES INACTIVA CAVITADA DE LA RAÍZ DEL DIENTE"
  },
  {
    "codigo":111819009,
    "descripcion":"GASTROENTERITIS ESTAFILOCÓCICA"
  },
  {
    "codigo":109984001,
    "descripcion":"ENFERMEDAD DE CADENAS PESADAS GAMMA (CLÍNICO)"
  },
  {
    "codigo":372128005,
    "descripcion":"NEOPLASIA MALIGNA DE LA PIEL DE LA EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":403061002,
    "descripcion":"ONICOMICOSIS CAUSADA POR TRICHOPHYTON SCHOENLEINII"
  },
  {
    "codigo":271989003,
    "descripcion":"TRASTORNO POR IMPLANTE DE MAMA"
  },
  {
    "codigo":15732161000119101,
    "descripcion":"QUISTE SEBÁCEO DE PÁRPADO DERECHO"
  },
  {
    "codigo":1156725007,
    "descripcion":"BOMBA DE INFUSIÓN INTRATECAL IMPLANTABLE IN SITU"
  },
  {
    "codigo":302922004,
    "descripcion":"HIPERTROFIA COMPENSATORIA DE RIÑÓN ÚNICO"
  },
  {
    "codigo":202783003,
    "descripcion":"ESTENOSIS DE CONDUCTO RAQUÍDEO DORSAL DE CAUSA DEGENERATIVA"
  },
  {
    "codigo":1251359008,
    "descripcion":"DERMATITIS SEBORREICA GENERALIZADA"
  },
  {
    "codigo":364788001,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA COMER CIERTOS ALIMENTOS"
  },
  {
    "codigo":299252001,
    "descripcion":"AMPLITUD DE EXTENSIÓN ACTIVA DE LA CADERA NORMAL"
  },
  {
    "codigo":4340003,
    "descripcion":"ACRODERMATITIS ATRÓFICA CRÓNICA"
  },
  {
    "codigo":399391008,
    "descripcion":"DISPLASIA DE INTESTINO GRUESO"
  },
  {
    "codigo":200948000,
    "descripcion":"PITIRIASIS ROJA (DE HEBRA)"
  },
  {
    "codigo":233716007,
    "descripcion":"OSIFICACIÓN PULMONAR MICRONODULAR"
  },
  {
    "codigo":428489000,
    "descripcion":"ATENDIDO EN CONSULTORIO ESPECIALIZADO EN PATOLOGÍA RESPIRATORIA"
  },
  {
    "codigo":788937001,
    "descripcion":"FRACTURA DE HUESO DESPUÉS DE IMPLANTE DE DISPOSITIVO ORTOPÉDICO"
  },
  {
    "codigo":68041004,
    "descripcion":"INCICLOTROPÍA"
  },
  {
    "codigo":231881006,
    "descripcion":"RUPTURA DE LA ESCLERÓTICA"
  },
  {
    "codigo":166345007,
    "descripcion":"PRUEBAS DE HORMONA TIROIDEA FUERA DE RANGO DE REFERENCIA"
  },
  {
    "codigo":262814002,
    "descripcion":"HEMATOMA QUE RODEA A LAS VÍAS BILIARES"
  },
  {
    "codigo":361118003,
    "descripcion":"FRACTURA EXPUESTA DE CADERA"
  },
  {
    "codigo":457587000,
    "descripcion":"ABSCESO DE PARED DE VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":129907001,
    "descripcion":"EXCESO DE BASE"
  },
  {
    "codigo":293747003,
    "descripcion":"ALERGIA A CLORAMBUCILO"
  },
  {
    "codigo":719731006,
    "descripcion":"CAPAZ DE RECORDAR LUGARES"
  },
  {
    "codigo":160840000,
    "descripcion":"AVENTURA AMOROSA NO SATISFACTORIA"
  },
  {
    "codigo":95304000,
    "descripcion":"HEMIVÉRTEBRA DORSAL"
  },
  {
    "codigo":128072003,
    "descripcion":"DERIVACIÓN PORTOSISTÉMICA ADQUIRIDA POR CIRROSIS"
  },
  {
    "codigo":11773531000119106,
    "descripcion":"ABRASIÓN DE DEDO ÍNDICE DERECHO"
  },
  {
    "codigo":191773001,
    "descripcion":"TRASTORNO DE LA PERSONALIDAD INMADURA"
  },
  {
    "codigo":291912009,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR SULFATO FERROSO"
  },
  {
    "codigo":290077003,
    "descripcion":"EDEMA DE MAMA"
  },
  {
    "codigo":1142045004,
    "descripcion":"INFECCIÓN PRIMARIA POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":879901005,
    "descripcion":"FRACTURAS EXPUESTAS MÚLTIPLES DE CRÁNEO"
  },
  {
    "codigo":93469006,
    "descripcion":"HEMANGIOMA HEPÁTICO"
  },
  {
    "codigo":124402002,
    "descripcion":"DEFICIENCIA DE SULFOTRANSFERASA"
  },
  {
    "codigo":26098002,
    "descripcion":"MICROCÓRNEA"
  },
  {
    "codigo":288242005,
    "descripcion":"OSTEOMIELITIS AGUDA DE RODILLA"
  },
  {
    "codigo":91634006,
    "descripcion":"COMISURAS FUSIONADAS DE VÁLVULA MITRAL"
  },
  {
    "codigo":286407002,
    "descripcion":"INCAPAZ DE HABLAR INTELIGIBLEMENTE"
  },
  {
    "codigo":188103003,
    "descripcion":"NEOPLASIA MALIGNA DE CUERO CABELLUDO"
  },
  {
    "codigo":1269447007,
    "descripcion":"ÚLCERA DE PIEL DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":22428001,
    "descripcion":"QUEMADURA DE CUALQUIER GRADO QUE COMPROMETE 20-29 PORCIENTO DE LA SUPERFICIE DEL CUERPO"
  },
  {
    "codigo":219036002,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR FÁRMACO ANTIASMÁTICO"
  },
  {
    "codigo":68232002,
    "descripcion":"INTOXICACIÓN POR CENTAUREA"
  },
  {
    "codigo":448412007,
    "descripcion":"ORIGEN TRAQUEAL DE BRONQUIO DE LÓBULO SUPERIOR DERECHO"
  },
  {
    "codigo":284572009,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DE ESTRUCTURA RESPIRATORIA"
  },
  {
    "codigo":11828981000119107,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE PIEL DE RODILLA IZQUIERDA"
  },
  {
    "codigo":20593006,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA ARTERIA FEMORAL SUPERFICIAL"
  },
  {
    "codigo":315505007,
    "descripcion":"NACIDO EN PUERTO RICO"
  },
  {
    "codigo":1263942000,
    "descripcion":"SHOCK POSTERIOR A EMBARAZO ECTÓPICO"
  },
  {
    "codigo":248134002,
    "descripcion":"AVERSIÓN HACIA LA COMIDA O LA BEBIDA"
  },
  {
    "codigo":687861000119109,
    "descripcion":"RABDOMIOSARCOMA PRIMARIO DE CUELLO"
  },
  {
    "codigo":706886007,
    "descripcion":"FRACTURA SIMPLE DE HUESO"
  },
  {
    "codigo":705051002,
    "descripcion":"DIFICULTAD PARA EL MANEJO DE RÉGIMEN NUTRICIONAL"
  },
  {
    "codigo":279067003,
    "descripcion":"DOLOR DE ARTICULACIÓN METATARSOFALÁNGICA"
  },
  {
    "codigo":49691004,
    "descripcion":"BRONQUITIS LABORAL"
  },
  {
    "codigo":703216001,
    "descripcion":"HEMORRAGIA SUBARACNOIDEA PERIMESENCEFÁLICA"
  },
  {
    "codigo":441072002,
    "descripcion":"CÉLULAS GLANDULARES ATÍPICAS EN EL EXTENDIDO VAGINAL DE PAPANICOLAOU"
  },
  {
    "codigo":277232003,
    "descripcion":"RINOFARINGE INFLAMADA"
  },
  {
    "codigo":1293040003,
    "descripcion":"LESIÓN LÍTICA DE HUESO EVIDENCIADA EN RADIOGRAFÍA SIMPLE"
  },
  {
    "codigo":78789000,
    "descripcion":"PLACENTA ANORMAL MADURA"
  },
  {
    "codigo":1356741005,
    "descripcion":"PARKINSONISMO CON POLINEUROPATÍA"
  },
  {
    "codigo":275397008,
    "descripcion":"CARCINOMA DE LA LÍNEA MEDIA DE LA LENGUA"
  },
  {
    "codigo":44186003,
    "descripcion":"DISOMNIA"
  },
  {
    "codigo":109722005,
    "descripcion":"HIPOPLASIA CONDÍLEA CON ASIMETRÍA MANDIBULAR"
  },
  {
    "codigo":307241000119103,
    "descripcion":"ARTRITIS ENTEROPÁTICA DE ARTICULACIÓN RADIOCARPIANA DERECHA"
  },
  {
    "codigo":11418007,
    "descripcion":"ENJUICIAMIENTO"
  },
  {
    "codigo":206191000,
    "descripcion":"HEMATOMA SUBDURAL LOCAL POR TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":371866009,
    "descripcion":"TIMI (THROMBOLYSIS IN MYOCARDIAL INFARCTION) GRADO 1: PENETRACIÓN SIN PERFUSIÓN"
  },
  {
    "codigo":1287535001,
    "descripcion":"ABRASIÓN DE PIEL DE MEJILLA"
  },
  {
    "codigo":75119003,
    "descripcion":"ABSCESO HEPÁTICO AMEBIANO"
  },
  {
    "codigo":240794006,
    "descripcion":"LINFOMA DE CÉLULAS GIGANTES ESQUISTOSÓMICO ESPLÉNICO"
  },
  {
    "codigo":271727005,
    "descripcion":"BORDE DE LA PAPILA, NÍTIDO"
  },
  {
    "codigo":10816341000119100,
    "descripcion":"FRACTURA EXPUESTA DE FALANGE DISTAL DE DEDO MEÑIQUE DERECHO"
  },
  {
    "codigo":238959007,
    "descripcion":"TRASTORNOS DE LA PERCEPCIÓN E IMAGEN CUTÁNEAS"
  },
  {
    "codigo":1351236000,
    "descripcion":"INMUNODEFICIENCIA COMBINADA AUTOSÓMICA RECESIVA DEBIDA A DEFICIENCIA DE COESTIMULADOR INDUCIBLE DE CÉLULAS T"
  },
  {
    "codigo":1285700004,
    "descripcion":"DESPLAZAMIENTO DE RAÍZ DE DIENTE HACIA EL SENO MAXILAR DEBIDO A TRAUMATISMO DENTAL Y POSTERIOR A ÉL"
  },
  {
    "codigo":400964006,
    "descripcion":"TRANSILUMINACIÓN DEL IRIS"
  },
  {
    "codigo":73284007,
    "descripcion":"SÍNDROME DE MARSHALL-SMITH"
  },
  {
    "codigo":71449000,
    "descripcion":"FÍSTULA RECTOCUTÁNEA"
  },
  {
    "codigo":237124006,
    "descripcion":"HEMATOPIOMETRA"
  },
  {
    "codigo":5913000,
    "descripcion":"FRACTURA DE CUELLO DE FÉMUR"
  },
  {
    "codigo":366361007,
    "descripcion":"INGESTA DE SODIO CON LA DIETA - HALLAZGO"
  },
  {
    "codigo":69614003,
    "descripcion":"DEFECTO DE LA SÍNTESIS DE ADENOSILCOBALAMINA"
  },
  {
    "codigo":724974004,
    "descripcion":"DISTENSIÓN DE MÚSCULO EXTENSOR DE DEDO DE LA MANO A LA ALTURA DEL ANTEBRAZO"
  },
  {
    "codigo":10956841000119109,
    "descripcion":"HERIDA ABIERTA DE DEDO ANULAR DERECHO"
  },
  {
    "codigo":298990006,
    "descripcion":"SIN AMPLITUD DE ADUCCIÓN PASIVA DE ARTICULACIÓN DE MUÑECA"
  },
  {
    "codigo":200686006,
    "descripcion":"CELULITIS Y ABSCESO DE TALÓN"
  },
  {
    "codigo":2243000,
    "descripcion":"HIPERCALCEMIA SECUNDARIA A HIPERTIROIDISMO"
  },
  {
    "codigo":297155002,
    "descripcion":"TROMBOSIS DE ARTERIA FEMORAL SUPERFICIAL"
  },
  {
    "codigo":723139008,
    "descripcion":"HEMORRAGIA TRAUMÁTICA SECUNDARIA DE TRONCO ENCEFÁLICO"
  },
  {
    "codigo":459160003,
    "descripcion":"ABSCESO EN LOCALIZACIÓN DE COARTACIÓN AÓRTICA"
  },
  {
    "codigo":408005,
    "descripcion":"CASTAÑETEO DE DIENTES"
  },
  {
    "codigo":721304007,
    "descripcion":"TROMBOCITOPENIA REFRACTARIA"
  },
  {
    "codigo":786840007,
    "descripcion":"MYCOBACTEROIDES ABSCESSUS O MYCOBACTEROIDES CHELONAE"
  },
  {
    "codigo":129645002,
    "descripcion":"SÍNDROME DE DEFICIENCIA LEUCOCÍTICA DE GLUCOSA-6-FOSFATO DESHIDROGENASA DEL ADULTO"
  },
  {
    "codigo":64109004,
    "descripcion":"COSTOCONDRITIS"
  },
  {
    "codigo":293485004,
    "descripcion":"REACCIÓN ADVERSA AL MERSALILO"
  },
  {
    "codigo":31341008,
    "descripcion":"HEMORRAGIA VÍTREA"
  },
  {
    "codigo":1145453009,
    "descripcion":"APLASIA DE HUESO DE CABEZA Y CUELLO DE FÉMUR"
  },
  {
    "codigo":422722002,
    "descripcion":"VÍCTIMA DE AMBIENTE VIOLENTO"
  },
  {
    "codigo":95042003,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL TABIQUE DE LA NARIZ"
  },
  {
    "codigo":1073501000119102,
    "descripcion":"ARTRITIS INFECCIOSA DE RODILLA IZQUIERDA"
  },
  {
    "codigo":226114000,
    "descripcion":"DIETA CON CONTENIDO MÍNIMO DE TRIGLICÉRIDOS DE CADENA LARGA"
  },
  {
    "codigo":160578007,
    "descripcion":"BEBEDOR EXCESIVO - MÁS DE 9 UNIDADES POR DÍA"
  },
  {
    "codigo":336221000119104,
    "descripcion":"OPACIDAD CENTRAL DE CÓRNEA DERECHA"
  },
  {
    "codigo":715799004,
    "descripcion":"ENFERMEDAD DE CHARCOT-MARIE-TOOTH TIPO 4G"
  },
  {
    "codigo":289815006,
    "descripcion":"DOLOR A LA PALPACIÓN DE CUELLO DE ÚTERO"
  },
  {
    "codigo":191511008,
    "descripcion":"ESTADO CONFUSIONAL SUBAGUDO, DE ORIGEN METABÓLICO"
  },
  {
    "codigo":419052002,
    "descripcion":"NEOPLASIA MALIGNA DE APARATO URINARIO"
  },
  {
    "codigo":287980003,
    "descripcion":"RUPTURA DE TENDÓN DE CODO"
  },
  {
    "codigo":713964006,
    "descripcion":"INFECCIÓN DE MÚLTIPLES DERMATOMAS CAUSADA POR HERPES ZÓSTER CONCOMITANTE CON INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":710195004,
    "descripcion":"NEOPLASIA MALIGNA ODONTÓGENA DE MAXILAR INFERIOR"
  },
  {
    "codigo":253377001,
    "descripcion":"DILATACIÓN DEL ANILLO TRICUSPÍDEO"
  },
  {
    "codigo":124140009,
    "descripcion":"DEFICIENCIA DE IMP DESHIDROGENASA"
  },
  {
    "codigo":24001002,
    "descripcion":"ÚLCERA GASTROYEYUNAL CRÓNICA CON HEMORRAGIA, PERFORACIÓN Y OBSTRUCCIÓN"
  },
  {
    "codigo":89537006,
    "descripcion":"LABERINTITIS DIFUSA"
  },
  {
    "codigo":286145006,
    "descripcion":"DIFICULTAD EN LIMPIAR LA COCINA"
  },
  {
    "codigo":56769006,
    "descripcion":"ESTADIO A DE DUKES MODIFICADO"
  },
  {
    "codigo":187841006,
    "descripcion":"NEOPLASIA MALIGNA DE GLOTIS"
  },
  {
    "codigo":251542006,
    "descripcion":"UNIDADES POLIFÁSICAS DE LARGA DURACIÓN - HALLAZGO"
  },
  {
    "codigo":1300118007,
    "descripcion":"NEURITIS ACÚSTICA DEBIDA A ENFERMEDAD INFECCIOSA"
  },
  {
    "codigo":284310008,
    "descripcion":"DIFICULTAD PARA LIBERAR LA PRENSIÓN"
  },
  {
    "codigo":22166009,
    "descripcion":"DOLOR A LA PALPACIÓN EN MÚSCULO ESQUELÉTICO"
  },
  {
    "codigo":1003371001,
    "descripcion":"ENANISMO MICROMÉLICO TIPO FRYN"
  },
  {
    "codigo":773995001,
    "descripcion":"LINFOMA CUTÁNEO PRIMARIO ANAPLÁSICO DE CÉLULAS GRANDES"
  },
  {
    "codigo":315243006,
    "descripcion":"SOMNOLENCIA INTERMITENTE"
  },
  {
    "codigo":282475008,
    "descripcion":"INCAPAZ DE CORRER"
  },
  {
    "codigo":1263680001,
    "descripcion":"TRASTORNO FETAL DEBIDO A PRESENTACIÓN DE CARA DURANTE TRABAJO DE PARTO"
  },
  {
    "codigo":51264003,
    "descripcion":"COMPROMISO CORNEAL Y\/O LIMBAL EN LA CONJUNTIVITIS PRIMAVERAL"
  },
  {
    "codigo":14230001000004101,
    "descripcion":"PERCEPCIÓN DE PÉRDIDA DE LA AUDICIÓN"
  },
  {
    "codigo":84032005,
    "descripcion":"SIGNO DE HALBAN"
  },
  {
    "codigo":13270001000004101,
    "descripcion":"FRACTURA DE CÚBITO IZQUIERDO"
  },
  {
    "codigo":10877431000119106,
    "descripcion":"HERIDA ABIERTA DE PIERNA IZQUIERDA"
  },
  {
    "codigo":247872008,
    "descripcion":"PENSAMIENTOS OBSESIVOS ACERCA DE DAÑO A LA PROPIEDAD"
  },
  {
    "codigo":18070001000004106,
    "descripcion":"ABSCESO DE PIEL DE ABDOMEN"
  },
  {
    "codigo":213269003,
    "descripcion":"LESIÓN DE VÍSCERAS DURANTE CIRUGÍA"
  },
  {
    "codigo":1163541002,
    "descripcion":"MENINGITIS POR VIRUS DE LA CORIOMENINGITIS LINFOCÍTICA"
  },
  {
    "codigo":19350001000004107,
    "descripcion":"FRACTURA POR ESTRÉS DE TIBIA Y PERONÉ"
  },
  {
    "codigo":278805002,
    "descripcion":"SÍNDROME DE DERRAME UVEAL"
  },
  {
    "codigo":737557007,
    "descripcion":"ANGIOEDEMA INTESTINAL CAUSADO POR INHIBIDOR DE LA ENZIMA CONVERTIDORA DE ANGIOTENSINA"
  },
  {
    "codigo":735722005,
    "descripcion":"PERFORACIÓN INTESTINAL NEONATAL CONCOMITANTE CON OBSTRUCCIÓN INTRALUMINAL INTRAUTERINA Y DEBIDA A ELLA"
  },
  {
    "codigo":1290943000,
    "descripcion":"MIOFIBROMA"
  },
  {
    "codigo":45759004,
    "descripcion":"PERINEO RÍGIDO QUE AFECTA EL EMBARAZO"
  },
  {
    "codigo":373439009,
    "descripcion":"SECCIÓN TRAUMÁTICA EXPUESTA DE LIGAMENTO"
  },
  {
    "codigo":109460002,
    "descripcion":"MICRODONCIA DE UN PAR DENTAL"
  },
  {
    "codigo":371604007,
    "descripcion":"TRASTORNO BIPOLAR II GRAVE"
  },
  {
    "codigo":240532009,
    "descripcion":"INFECCIÓN POR PAPILOMAVIRUS HUMANO"
  },
  {
    "codigo":369769005,
    "descripcion":"< 4 MITOSIS\/CAMPO DE GRAN AUMENTO"
  },
  {
    "codigo":402537005,
    "descripcion":"CARCINOMA BASOCELULAR METASTÁSICO"
  },
  {
    "codigo":304233007,
    "descripcion":"LESIÓN POR PINCHAZO CON AGUJA LIMPIA"
  },
  {
    "codigo":42089007,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN LA REGIÓN DEL ANO, CON INFECCIÓN"
  },
  {
    "codigo":238697009,
    "descripcion":"URTICARIA POR INMUNOCOMPLEJOS"
  },
  {
    "codigo":11997841000119109,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DE CODO DERECHO"
  },
  {
    "codigo":890387001,
    "descripcion":"ESTENOSIS SUBGLÓTICA CONGÉNITA DE COTTON-MYER GRADO 2"
  },
  {
    "codigo":235027002,
    "descripcion":"LEUCOPLASIA ORAL HOMOGÉNEA"
  },
  {
    "codigo":1076011000119104,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE TENDÓN FLEXOR DE PIE DERECHO"
  },
  {
    "codigo":169491004,
    "descripcion":"CONTROL DE DISPOSITIVO ANTICONCEPTIVO INTRAUTERINO"
  },
  {
    "codigo":300563005,
    "descripcion":"BAZO PRESENTE"
  },
  {
    "codigo":39671000087102,
    "descripcion":"DOLOR CRÓNICO POSTERIOR A ARTROPLASTIA"
  },
  {
    "codigo":366099008,
    "descripcion":"RESPUESTA A LOS SONIDOS DE FRECUENCIA BAJA - HALLAZGO"
  },
  {
    "codigo":34551000087105,
    "descripcion":"MÚLTIPLES LESIONES TRAUMÁTICAS SUPERFICIALES"
  },
  {
    "codigo":823016000,
    "descripcion":"TELANGIECTASIA MACULAR IDIOPÁTICA TIPO 2"
  },
  {
    "codigo":47351000087107,
    "descripcion":"DISTENSIÓN DE TENDÓN DE CUÁDRICEPS DERECHO"
  },
  {
    "codigo":298728004,
    "descripcion":"HALLAZGO RELACIONADO CON LA SENSIBILIDAD ESTERNAL"
  },
  {
    "codigo":42231000087109,
    "descripcion":"RUPTURA DE TENDÓN DE HOMBRO DERECHO"
  },
  {
    "codigo":44791000087107,
    "descripcion":"OCLUSIÓN DE RAMA LATERAL POSTERIOR DE RAMA CIRCUNFLEJA DE ARTERIA CORONARIA IZQUIERDA"
  },
  {
    "codigo":69352009,
    "descripcion":"VÁRICES DE LA EXTREMIDAD INFERIOR CON ÚLCERA E INFLAMACIÓN"
  },
  {
    "codigo":1981004,
    "descripcion":"URHIDROSIS"
  },
  {
    "codigo":722877006,
    "descripcion":"SÍNDROME DE RUMIACIÓN DE ALIMENTOS INGERIDOS EN EL ADULTO"
  },
  {
    "codigo":165821008,
    "descripcion":"ANTICUERPO ANTI- LEGIONELLA DETECTADO"
  },
  {
    "codigo":196754001,
    "descripcion":"ESPASMO GÁSTRICO"
  },
  {
    "codigo":1148861009,
    "descripcion":"ANEMIA FERROPÉNICA DEBIDA A CELIAQUÍA"
  },
  {
    "codigo":295058003,
    "descripcion":"ALERGIA A OUABAÍNA"
  },
  {
    "codigo":32914008,
    "descripcion":"PIERNAS INQUIETAS"
  },
  {
    "codigo":719207000,
    "descripcion":"ATAXIA ESPINOCEREBELOSA TIPO 11"
  },
  {
    "codigo":293223006,
    "descripcion":"REACCIÓN ADVERSA AL ESTANOZOLOL"
  },
  {
    "codigo":94780004,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE HUESO DEL CARPO"
  },
  {
    "codigo":225852007,
    "descripcion":"CONSCIENTE DE REGLAS Y LÍMITES"
  },
  {
    "codigo":291388007,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR PROBENECID"
  },
  {
    "codigo":1208892009,
    "descripcion":"ALOPECIA AREATA DE CEJA"
  },
  {
    "codigo":1010449002,
    "descripcion":"LESIÓN DE NEURONA MOTORA SUPERIOR DERECHA"
  },
  {
    "codigo":121951000119101,
    "descripcion":"HEMANGIOMA DE ÓRBITA"
  },
  {
    "codigo":27409004,
    "descripcion":"MACROQUEILIA CONGÉNITA"
  },
  {
    "codigo":289553007,
    "descripcion":"SECRECIÓN VAGINAL CREMOSA"
  },
  {
    "codigo":713702000,
    "descripcion":"GASTROPARESIA DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":123878001,
    "descripcion":"INTOXICACIÓN POR PASSIFIFLORACEAE"
  },
  {
    "codigo":189414002,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL CARTÍLAGO ARITENOIDES"
  },
  {
    "codigo":92945009,
    "descripcion":"FORMA ANORMAL CONGÉNITA DEL OMÓPLATO"
  },
  {
    "codigo":254950006,
    "descripcion":"OLIGODENDROGLIOMA DE MÉDULA ESPINAL"
  },
  {
    "codigo":285883001,
    "descripcion":"NO USA EL HORNO DE MICROONDAS"
  },
  {
    "codigo":416955003,
    "descripcion":"RECUENTO GRANULOCÍTICO POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":449723004,
    "descripcion":"HIPERMETROPÍA ABSOLUTA"
  },
  {
    "codigo":710032001,
    "descripcion":"MORFOLOGÍA DE CRESTA ALVEOLAR RESIDUAL DE MAXILAR SUPERIOR CON AUSENCIA DE VESTÍBULO LABIAL ANTERIOR"
  },
  {
    "codigo":447888006,
    "descripcion":"ADENOMA PLEOMÓRFICO DE GLÁNDULA SALIVAL"
  },
  {
    "codigo":773733000,
    "descripcion":"SINOSTOSIS HUMERORRADIOCUBITAL"
  },
  {
    "codigo":314981002,
    "descripcion":"REVERSIBILIDAD ESPIROMÉTRICA POSITIVA"
  },
  {
    "codigo":216677003,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ADITIVOS ANTICHOQUE DEL PETRÓLEO"
  },
  {
    "codigo":1363557004,
    "descripcion":"CARCINOMA DE CÉLULAS PEQUEÑAS COMBINADO DE PULMÓN"
  },
  {
    "codigo":282213006,
    "descripcion":"DIFICULTAD PARA DETENER LA MARCHA"
  },
  {
    "codigo":52837007,
    "descripcion":"DEFICIENCIA LONGITUDINAL DE FÉMUR"
  },
  {
    "codigo":11836511000119109,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN MEDIOTARSIANA IZQUIERDA"
  },
  {
    "codigo":51002006,
    "descripcion":"DIABETES MELLITUS ASOCIADA CON ENFERMEDAD PANCREÁTICA"
  },
  {
    "codigo":247610006,
    "descripcion":"INCAPAZ DE RECORDAR EL NOMBRE DEL PRIMER MINISTRO ACTUAL"
  },
  {
    "codigo":16399001,
    "descripcion":"DIFICULTAD PARA AFRONTAR EL DOLOR"
  },
  {
    "codigo":737295003,
    "descripcion":"RIÑÓN TRASPLANTADO PRESENTE"
  },
  {
    "codigo":81935006,
    "descripcion":"CONFLICTO FAMILIAR"
  },
  {
    "codigo":278543008,
    "descripcion":"BUENA HIGIENE BUCAL"
  },
  {
    "codigo":15742201000119105,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE AMBOS MUSLOS"
  },
  {
    "codigo":735460002,
    "descripcion":"REACCIÓN DE HIPERSENSIBILIDAD CUTÁNEA CAUSADA POR VENENO DE HYMENOPTERA"
  },
  {
    "codigo":276708003,
    "descripcion":"EL RECIÉN NACIDO TARDA EN ESTABLECER LA RESPIRACIÓN"
  },
  {
    "codigo":1259748004,
    "descripcion":"AMELOBLASTOMA PRIMARIO MALIGNO DE MANDÍBULA"
  },
  {
    "codigo":733625003,
    "descripcion":"SÍNDROME 48;XYYY"
  },
  {
    "codigo":405945003,
    "descripcion":"NEOPLASIA MALIGNA DE METATARSIANO"
  },
  {
    "codigo":209337005,
    "descripcion":"FRACTURA-SUBLUXACIÓN NO EXPUESTA DE ARTICULACIÓN DE LA CADERA"
  },
  {
    "codigo":55571001,
    "descripcion":"CETOACIDOSIS DEBIDA A INTOXICACIÓN ALCOHÓLICA AGUDA"
  },
  {
    "codigo":111033008,
    "descripcion":"ATROFIA CEREBRAL CIRCUNSCRIPTA"
  },
  {
    "codigo":12729009,
    "descripcion":"RUPTURA PROLONGADA DE MEMBRANAS"
  },
  {
    "codigo":404110001,
    "descripcion":"MICOSIS FUNGOIDE HIPOMELANÓTICA"
  },
  {
    "codigo":1290681008,
    "descripcion":"RADIOGRAFÍA DE COLUMNA SACRA ANORMAL"
  },
  {
    "codigo":895630001,
    "descripcion":"FORMA TRIANGULAR ANORMAL CONGÉNITA DE FALANGE DISTAL DE DEDO PULGAR"
  },
  {
    "codigo":76430003,
    "descripcion":"AMPOLLAS POR FRICCIÓN DE LAS PALMAS DE LAS MANOS"
  },
  {
    "codigo":1256078002,
    "descripcion":"PIODERMA GANGRENOSO DEBIDO A ENFERMEDAD INFLAMATORIA INTESTINAL"
  },
  {
    "codigo":240270007,
    "descripcion":"SINOVITIS POR SILICONA"
  },
  {
    "codigo":305806008,
    "descripcion":"ATENDIDO POR SERVICIO DE INMUNOLOGÍA CLÍNICA"
  },
  {
    "codigo":402275006,
    "descripcion":"DERMATITIS IRRITATIVA POR CONTACTO CAUSADA POR CONTACTO CON ORINA Y\/O HECES"
  },
  {
    "codigo":369507007,
    "descripcion":"TUMOR MALIGNO QUE COMPROMETE LA VULVA POR PROPAGACIÓN DIRECTA DEL ENDOMETRIO"
  },
  {
    "codigo":238435009,
    "descripcion":"INFECCIÓN POR TIÑA MODIFICADA POR ESTEROIDES"
  },
  {
    "codigo":39992005,
    "descripcion":"ARTROPATÍA ASOCIADA CON URETRITIS INESPECÍFICA"
  },
  {
    "codigo":236600007,
    "descripcion":"URETERITIS POR CANDIDA"
  },
  {
    "codigo":591000124104,
    "descripcion":"CUMPLE CON EL ANÁLISIS DE DIALIZADO PERITONEAL"
  },
  {
    "codigo":1186872009,
    "descripcion":"ENCEFALOPATÍA POR ARSÉNICO"
  },
  {
    "codigo":365837000,
    "descripcion":"HALLAZGO RELACIONADO CON EL JUICIO"
  },
  {
    "codigo":550991000124107,
    "descripcion":"NEOPLASIA MALIGNA EN REMISIÓN COMPLETA"
  },
  {
    "codigo":890125004,
    "descripcion":"SÍNDROME DE DELECIÓN 7P12-P14"
  },
  {
    "codigo":440911000124108,
    "descripcion":"INGESTA INADECUADA DE COBALTO"
  },
  {
    "codigo":300301006,
    "descripcion":"ASPIRADO GÁSTRICO CON CONTENIDO DE ALIMENTO"
  },
  {
    "codigo":201997001,
    "descripcion":"ARTROPATÍA TRANSITORIA DE HOMBRO"
  },
  {
    "codigo":298466000,
    "descripcion":"SIN ROTACIÓN ACTIVA DE LA COLUMNA CERVICAL HACIA LA IZQUIERDA"
  },
  {
    "codigo":288301000119101,
    "descripcion":"CONDUCTA HETEROSEXUAL DE ALTO RIESGO"
  },
  {
    "codigo":396770002,
    "descripcion":"TÚNICA VAGINAL COMPROMETIDA POR EXTENSIÓN DIRECTA DE NEOPLASIA MALIGNA"
  },
  {
    "codigo":724450008,
    "descripcion":"TEMOR A CÁNCER GENITAL"
  },
  {
    "codigo":460471001,
    "descripcion":"ORIGEN ANÓMALO DE ARTERIA DEL CONO EN ORIFICIO DE SENO AÓRTICO SEPARADO"
  },
  {
    "codigo":296631002,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE VANCOMICINA"
  },
  {
    "codigo":1279671006,
    "descripcion":"FIEBRE RECURRENTE CAUSADA POR BORRELIA MIYAMOTOI"
  },
  {
    "codigo":722615007,
    "descripcion":"CONTUSIÓN HEMORRÁGICA FOCAL DE CEREBRO"
  },
  {
    "codigo":15935021000119105,
    "descripcion":"SUPERPOSICIÓN ADQUIRIDA DE DEDOS DE AMBOS PIES"
  },
  {
    "codigo":196492001,
    "descripcion":"ABSCESO DE GLÁNDULA SUBMAXILAR"
  },
  {
    "codigo":65420004,
    "descripcion":"FLEXIBILIDAD VOCAL ANORMAL"
  },
  {
    "codigo":294796004,
    "descripcion":"ALERGIA A DIETILESTILBESTROL"
  },
  {
    "codigo":425868004,
    "descripcion":"PAPILOMA BENIGNO DE PLEXO COROIDES"
  },
  {
    "codigo":1144929002,
    "descripcion":"AGRANULOCITOSIS SECUNDARIA"
  },
  {
    "codigo":424033007,
    "descripcion":"RETRACCIÓN PALPEBRAL POSQUIRÚRGICA"
  },
  {
    "codigo":15990471000119102,
    "descripcion":"DEPÓSITOS RETINIANOS DE OJO DERECHO"
  },
  {
    "codigo":292961009,
    "descripcion":"REACCIÓN ADVERSA A LA BENCILPENICILINA"
  },
  {
    "codigo":94518002,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL ÁREA RETROMOLAR"
  },
  {
    "codigo":61750000,
    "descripcion":"INFECCIÓN CAUSADA POR ANGIOSTRONGYLUS"
  },
  {
    "codigo":291126004,
    "descripcion":"INTOXICACIÓN POR LOXAPINA"
  },
  {
    "codigo":127286005,
    "descripcion":"FRACTURA DE EXTREMO SUPERIOR DE HÚMERO"
  },
  {
    "codigo":289291008,
    "descripcion":"MEMBRANAS AMNIÓTICAS NORMALES"
  },
  {
    "codigo":92683008,
    "descripcion":"CARCINOMA IN SITU DE LA GLÁNDULA HIPÓFISIS"
  },
  {
    "codigo":343751000119106,
    "descripcion":"RETINOPATÍA BILATERAL POR PREMATUREZ ETAPA 3 - CRESTA CON PROLIFERACIÓN FIBROVASCULAR EXTRARRETINIANA"
  },
  {
    "codigo":123616008,
    "descripcion":"HIPERPLASIA GRANULOCÍTICA DE LA MÉDULA ÓSEA"
  },
  {
    "codigo":1268661001,
    "descripcion":"CAPAZ DE PAGAR GUARDERÍA"
  },
  {
    "codigo":89013002,
    "descripcion":"LEUCOQUERATOSIS DEL PALADAR POR NICOTINA"
  },
  {
    "codigo":1170357001,
    "descripcion":"YODO FIJADO A PROTEÍNAS DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1081031000119107,
    "descripcion":"CARCINOMA DE CÉLULAS DE MERKEL PRIMARIO DE PIEL DE CADERA IZQUIERDA"
  },
  {
    "codigo":23477004,
    "descripcion":"INFECCIÓN CAUSADA POR ASCARIDIA DISSIMILIS"
  },
  {
    "codigo":185482001,
    "descripcion":"PACIENTE DEPENDIENTE"
  },
  {
    "codigo":283786001,
    "descripcion":"HERIDA POR MORDEDURA DE RATA"
  },
  {
    "codigo":251018003,
    "descripcion":"ARTERIA CORONARIA PERMEABLE"
  },
  {
    "codigo":218250005,
    "descripcion":"EFECTO TARDÍO DE CAÍDA ACCIDENTAL"
  },
  {
    "codigo":87178007,
    "descripcion":"EDAD GESTACIONAL, 1 SEMANA"
  },
  {
    "codigo":871775006,
    "descripcion":"REACCIÓN ADVERSA A TRIAZENO"
  },
  {
    "codigo":609631007,
    "descripcion":"HALLAZGO RELACIONADO CON LA REGIÓN SACRA"
  },
  {
    "codigo":183647007,
    "descripcion":"SEGUIMIENTO DE UN PACIENTE CON IMPLANTE DE ALTO RIESGO"
  },
  {
    "codigo":83508001,
    "descripcion":"DERMATITIS DE CONTACTO CAUSADA POR NAILON"
  },
  {
    "codigo":116276002,
    "descripcion":"HALLAZGO MUSCULOESQUELÉTICO RELACIONADO CON EL TÓRAX"
  },
  {
    "codigo":280116003,
    "descripcion":"NEOPLASIA DE TÚNICA VAGINAL"
  },
  {
    "codigo":12113761000119105,
    "descripcion":"QUEMADURA QUÍMICA DE FRENTE"
  },
  {
    "codigo":312884005,
    "descripcion":"BAJO CUIDADO DE PERSONA"
  },
  {
    "codigo":247348008,
    "descripcion":"DOLOR A LA PALPACIÓN"
  },
  {
    "codigo":737033000,
    "descripcion":"ÁNGULO NASOLABIAL AGUDO"
  },
  {
    "codigo":442121006,
    "descripcion":"TROMBOFILIA DEBIDA A ANOMALÍA VASCULAR"
  },
  {
    "codigo":47070001,
    "descripcion":"MEMBRANA CONGÉNITA DE LA LARINGE"
  },
  {
    "codigo":14302001,
    "descripcion":"AMENORREA"
  },
  {
    "codigo":473054006,
    "descripcion":"INFECCIÓN DE TÚNEL DE CATÉTER VENOSO CENTRAL"
  },
  {
    "codigo":209075002,
    "descripcion":"LUXACIÓN NO EXPUESTA DE COLUMNA DORSAL"
  },
  {
    "codigo":11851921000119100,
    "descripcion":"CONTUSIÓN DE PARED TORÁCICA POSTERIOR"
  },
  {
    "codigo":478493841000119100,
    "descripcion":"DERIVACIÓN VENTRICULOPLEURAL IN SITU"
  },
  {
    "codigo":15684241000119102,
    "descripcion":"PERIOSTITIS DE MANO IZQUIERDA"
  },
  {
    "codigo":88721000119100,
    "descripcion":"ANOMALÍA CONGÉNITA DE UNIÓN CRANEOVERTEBRAL"
  },
  {
    "codigo":331921000119103,
    "descripcion":"PÉRDIDA SÚBITA DE VISIÓN DE OJO DERECHO"
  },
  {
    "codigo":1092241000119104,
    "descripcion":"ACÚFENOS SUBJETIVO DEL OÍDO DERECHO"
  },
  {
    "codigo":371080001,
    "descripcion":"DISCREPANCIA CONGÉNITA DE LONGITUD DE LAS PIERNAS"
  },
  {
    "codigo":301201000119105,
    "descripcion":"TRASTORNO REPETITIVO DEL MOVIMIENTO DE PIERNA IZQUIERDA"
  },
  {
    "codigo":403848003,
    "descripcion":"LESIÓN TRAUMÁTICA PERINATAL POR FÓRCEPS"
  },
  {
    "codigo":298641000119109,
    "descripcion":"OSTEONECROSIS DE FÉMUR DEBIDA A TRAUMATISMO"
  },
  {
    "codigo":689727121000119109,
    "descripcion":"ENDOMETRIOSIS DE MEMBRANA SEROSA DE RECTO"
  },
  {
    "codigo":15748241000119105,
    "descripcion":"MASA BILATERAL DE TOBILLOS"
  },
  {
    "codigo":240008008,
    "descripcion":"QUISTE SINOVIAL DE RODILLA"
  },
  {
    "codigo":11798161000119105,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO ESQUELÉTICO DE PARED TORÁCICA POSTERIOR"
  },
  {
    "codigo":74333002,
    "descripcion":"TORTÍCOLIS ESPASMÓDICO"
  },
  {
    "codigo":860765003,
    "descripcion":"ALERGIA A TIAZIDA"
  },
  {
    "codigo":762461003,
    "descripcion":"TRASTORNO DISOCIATIVO COMPLEJO DE INTRUSIÓN"
  },
  {
    "codigo":41565005,
    "descripcion":"PERIODONTITIS"
  },
  {
    "codigo":15740561000119109,
    "descripcion":"CONTRACCIÓN DE CAVIDAD ORBITARIA DERECHA"
  },
  {
    "codigo":43400009,
    "descripcion":"ANOMALÍA ELECTROENCEFALOGRÁFICA CON CONVULSIÓN"
  },
  {
    "codigo":10832021000119101,
    "descripcion":"FRACTURA TRIMALEOLAR EXPUESTA DE TOBILLO DERECHO"
  },
  {
    "codigo":8797009,
    "descripcion":"FORMACIÓN ÓSEA ENDOCONDRAL ANORMAL"
  },
  {
    "codigo":673941000119102,
    "descripcion":"ARTRITIS ESTREPTOCÓCICA DE COLUMNA"
  },
  {
    "codigo":6962006,
    "descripcion":"RETINOPATÍA HIPERTENSIVA"
  },
  {
    "codigo":72498006,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN LA REGIÓN DE LA MAMA, SIN INFECCIÓN"
  },
  {
    "codigo":400178008,
    "descripcion":"LINFANGIOMA"
  },
  {
    "codigo":269106006,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN DE HOMBRO, ANTERIOR (SUBCORACOIDEA)"
  },
  {
    "codigo":37895003,
    "descripcion":"ARTROSIS DE ARTICULACIÓN CARPOMETACARPIANA DE DEDO PULGAR"
  },
  {
    "codigo":234503004,
    "descripcion":"QUISTE HIDATÍDICO DEL BAZO"
  },
  {
    "codigo":365575005,
    "descripcion":"ACONTECIMIENTOS PERSONALES - HALLAZGO"
  },
  {
    "codigo":11815061000119104,
    "descripcion":"RUPTURA DE LIGAMENTO DE DEDO MEÑIQUE DE MANO DERECHA"
  },
  {
    "codigo":16238741000119105,
    "descripcion":"TRASTORNO BIPOLAR CAUSADO POR FÁRMACO"
  },
  {
    "codigo":5127009,
    "descripcion":"SÍNDROME DE PARPADEO MANDIBULAR"
  },
  {
    "codigo":298204002,
    "descripcion":"LAXITUD DE ARTICULACIÓN TEMPOROMANDIBULAR"
  },
  {
    "codigo":429276004,
    "descripcion":"TRASTORNO AMBIENTAL DEL SUEÑO"
  },
  {
    "codigo":296369001,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE ANTICOLINESTERASA"
  },
  {
    "codigo":1344945002,
    "descripcion":"DELIRIO CAUSADO POR COCAÍNA"
  },
  {
    "codigo":346261000119108,
    "descripcion":"CICATRICES CORIORRETINIANAS DISEMINADAS DE AMBOS OJOS"
  },
  {
    "codigo":34225008,
    "descripcion":"HIPERCALCEMIA IDIOPÁTICA DE LA LACTANCIA"
  },
  {
    "codigo":66993009,
    "descripcion":"NEFRITIS TUBULOINTERSTICIAL INFECCIOSA AGUDA"
  },
  {
    "codigo":787889009,
    "descripcion":"STREPTOCOCCUS ANGINOSUS O STREPTOCOCCUS DYSGALACTIAE"
  },
  {
    "codigo":786054003,
    "descripcion":"OCLUSIÓN DE VENA CENTRAL DE LA RETINA DE OJO DERECHO"
  },
  {
    "codigo":294534002,
    "descripcion":"ALERGIA A CEFADROXILO"
  },
  {
    "codigo":198065008,
    "descripcion":"ESTENOSIS DE CORDÓN ESPERMÁTICO"
  },
  {
    "codigo":720518006,
    "descripcion":"SÍNDROME DE DISGENESIA DE TRONCO ENCEFÁLICO ATABASCANA"
  },
  {
    "codigo":32390006,
    "descripcion":"PANHIPOPITUITARISMO"
  },
  {
    "codigo":292699000,
    "descripcion":"REACCIÓN ADVERSA A LA AURANOFINA"
  },
  {
    "codigo":423771003,
    "descripcion":"PTOSIS NEUROMUSCULAR ADQUIRIDA"
  },
  {
    "codigo":127024001,
    "descripcion":"NEOPLASIA DE LA GLÁNDULA HIPÓFISIS"
  },
  {
    "codigo":389168002,
    "descripcion":"SÍNDROME DE BRAQUIDACTILIA TIPO B"
  },
  {
    "codigo":94256002,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA CLAVÍCULA"
  },
  {
    "codigo":290864008,
    "descripcion":"INTOXICACIÓN POR IPRONIAZIDA"
  },
  {
    "codigo":92421002,
    "descripcion":"NEOPLASIA BENIGNA DE LA SUPRAGLOTIS"
  },
  {
    "codigo":715013005,
    "descripcion":"CAMINA SOBRE UNA SUPERFICIE DESPAREJA"
  },
  {
    "codigo":26885007,
    "descripcion":"AURÍCULA CERVICAL"
  },
  {
    "codigo":420101009,
    "descripcion":"VÍCTIMA DE EVENTO AMBIENTAL"
  },
  {
    "codigo":25050002,
    "descripcion":"ENFERMEDAD DE CADENA PESADA ALFA, FORMA RESPIRATORIA"
  },
  {
    "codigo":451034003,
    "descripcion":"HEMORRAGIA EN ESPACIO SUBPIAL DEL NEUROEJE"
  },
  {
    "codigo":254426002,
    "descripcion":"NEOPLASIA DE PISO ANTERIOR DE BOCA"
  },
  {
    "codigo":188890008,
    "descripcion":"NEOPLASIA BRONCOPULMONAR BENIGNA DE LÓBULO MEDIO"
  },
  {
    "codigo":1237466009,
    "descripcion":"METÁSTASIS DE CARCINOMA ESCAMOSO EN BRONQUIO DE LÓBULO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":283524003,
    "descripcion":"HERIDA PUNZANTE DE TÓRAX"
  },
  {
    "codigo":840580004,
    "descripcion":"ENFERMEDAD ARTERIAL PERIFÉRICA"
  },
  {
    "codigo":85081000,
    "descripcion":"TRONCO ARTERIAL COMÚN Y ORIGEN AMPLIAMENTE SEPARADO DE ARTERIAS PULMONARES"
  },
  {
    "codigo":185220009,
    "descripcion":"ATENDIDO EN UN CONSULTORIO UROLÓGICO"
  },
  {
    "codigo":248921002,
    "descripcion":"DESPLAZAMIENTO DEL CUELLO UTERINO"
  },
  {
    "codigo":1363033006,
    "descripcion":"CANDIDIASIS INVASIVA"
  },
  {
    "codigo":707673006,
    "descripcion":"BLASTOMA PLEUROPULMONAR TIPO III"
  },
  {
    "codigo":609369008,
    "descripcion":"HALLAZGO RELACIONADO CON LA ESCALA DE CALIFICACIÓN DEL COMPORTAMIENTO DE FRANKL"
  },
  {
    "codigo":443694000,
    "descripcion":"DIABETES MELLITUS TIPO II NO CONTROLADA"
  },
  {
    "codigo":871513009,
    "descripcion":"REACCIÓN ADVERSA A ÁCIDO QUENODESOXICÓLICO Y\/O ÁCIDO URSODESOXICÓLICO"
  },
  {
    "codigo":1197358003,
    "descripcion":"DISGENESIA DE SEGMENTO ANTERIOR DE OJO AUTOSÓMICA RECESIVA"
  },
  {
    "codigo":281689009,
    "descripcion":"MARCA DE BOFETADA"
  },
  {
    "codigo":247086006,
    "descripcion":"CÉLULAS DEL VÍTREO"
  },
  {
    "codigo":704003003,
    "descripcion":"FRACTURA NO EXPUESTA DE QUINTO METACARPIANO"
  },
  {
    "codigo":1193688000,
    "descripcion":"INFLAMACIÓN INTESTINAL POR ESCHERICHIA COLI ENTEROTOXIGÉNICA"
  },
  {
    "codigo":212483009,
    "descripcion":"LESIONES ENCEFÁLICAS MÚLTIPLES"
  },
  {
    "codigo":46808003,
    "descripcion":"ATAXIA CEREBELOSA DE MARIE"
  },
  {
    "codigo":11817571000119106,
    "descripcion":"ESGUINCE DE LIGAMENTO DE DEDO MEDIO IZQUIERDO"
  },
  {
    "codigo":472792009,
    "descripcion":"ANOMALÍA CONGÉNITA DE RAMA SUPRAÓRTICA DE AORTA TORÁCICA"
  },
  {
    "codigo":15969021000119101,
    "descripcion":"HEMORROIDE INTERNA TROMBOSADA GRADO IV"
  },
  {
    "codigo":896941005,
    "descripcion":"FORMA DE BALA ANORMAL CONGÉNITA DE FALANGE PROXIMAL DE CUARTO DEDO DE PIE"
  },
  {
    "codigo":700333007,
    "descripcion":"ARTROSIS PRIMARIA DE PRIMERA ARTICULACIÓN METATARSOFALÁNGICA"
  },
  {
    "codigo":348771000119108,
    "descripcion":"CATARATA ZONULAR CONGÉNITA DE OJO IZQUIERDO"
  },
  {
    "codigo":239746001,
    "descripcion":"SUBLUXACIÓN NO TRAUMÁTICA DE LA ARTICULACIÓN"
  },
  {
    "codigo":10370003,
    "descripcion":"RITMO DE ESTIMULACIÓN CARDÍACA ARTIFICIAL"
  },
  {
    "codigo":403586003,
    "descripcion":"SÍNDROME DE MÜNCHHAUSEN, MANIFESTACIONES CUTÁNEAS"
  },
  {
    "codigo":237911005,
    "descripcion":"TRASTORNO DEL METABOLISMO DE LOS AMINOÁCIDOS Y ÁCIDOS ORGÁNICOS"
  },
  {
    "codigo":1352023006,
    "descripcion":"INMUNODEFICIENCIA COMBINADA VARIABLE AUTOSÓMICA RECESIVA DEBIDA A DEFICIENCIA DEL RECEPTOR DE BAFF"
  },
  {
    "codigo":205143008,
    "descripcion":"SINDACTILIA ÓSEA DE DEDOS DE LA MANO - SEGUNDA A CUARTA MEMBRANA INTERDIGITAL"
  },
  {
    "codigo":301612005,
    "descripcion":"CAPAZ DE MANEJARSE EN ESCALONES"
  },
  {
    "codigo":170540006,
    "descripcion":"REQUIERE VACUNACIÓN ANTITIFOIDEA"
  },
  {
    "codigo":299777001,
    "descripcion":"REACCIÓN DE PARACAÍDAS PRESENTE"
  },
  {
    "codigo":398081001,
    "descripcion":"HUMEDAD EN VIVIENDA"
  },
  {
    "codigo":1348353006,
    "descripcion":"TC DE TRACTO GASTROINTESTINAL ANORMAL"
  },
  {
    "codigo":234241007,
    "descripcion":"INFECCIÓN DEL BALÓN INTRAÓRTICO"
  },
  {
    "codigo":396246000,
    "descripcion":"MARGEN QUIRÚRGICO ENDOCERVICAL COMPROMETIDO POR NEOPLASIA MALIGNA"
  },
  {
    "codigo":37633006,
    "descripcion":"FRACTURA NO EXPUESTA DE HUESO SEMILUNAR DE LA MUÑECA"
  },
  {
    "codigo":297942002,
    "descripcion":"ERITEMA MULTIFORME MEDICAMENTOSO"
  },
  {
    "codigo":365313009,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA DOBLAR LA ROPA LAVADA"
  },
  {
    "codigo":68566005,
    "descripcion":"INFECCIÓN URINARIA"
  },
  {
    "codigo":363478007,
    "descripcion":"NEOPLASIA MALIGNA DE GLÁNDULA TIROIDES"
  },
  {
    "codigo":723926008,
    "descripcion":"ALTERACIONES PERCEPTIVAS Y CONVULSIONES CONCOMITANTES CON ABSTINENCIA DE ALCOHOL Y DEBIDAS A ELLA"
  },
  {
    "codigo":232406009,
    "descripcion":"CANDIDIASIS FARÍNGEA CRÓNICA"
  },
  {
    "codigo":296107008,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE OXAZEPAM"
  },
  {
    "codigo":230571009,
    "descripcion":"NEUROPATÍA ASOCIADA CON TRASTORNO ENDOCRINO"
  },
  {
    "codigo":32128001,
    "descripcion":"ESGUINCE DE ARTICULACIÓN METACARPOFALÁNGICA"
  },
  {
    "codigo":1177173001,
    "descripcion":"SÍNDROME CONGÉNITO DE INSUFICIENCIA MEDULAR PROGRESIVA, INMUNODEFICIENCIA DE CÉLULAS B Y DISPLASIA ESQUELÉTICA"
  },
  {
    "codigo":1144405002,
    "descripcion":"HIPOPLASIA CONGÉNITA DE PUNTA DE NARIZ"
  },
  {
    "codigo":95829004,
    "descripcion":"LESIÓN DEL NERVIO ACÚSTICO"
  },
  {
    "codigo":292437006,
    "descripcion":"REACCIÓN ADVERSA AL OXPRENOLOL"
  },
  {
    "codigo":128597007,
    "descripcion":"TRASTORNO DE LOS DEDOS"
  },
  {
    "codigo":93994001,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL LIGAMENTO REDONDO DEL ÚTERO"
  },
  {
    "codigo":126762003,
    "descripcion":"COALICIÓN ASTRAGALOCALCÁNEA"
  },
  {
    "codigo":28458003,
    "descripcion":"INTOXICACIÓN POR GALENIA AFRICANA"
  },
  {
    "codigo":290602007,
    "descripcion":"INTOXICACIÓN POR ETOGLÚCIDO"
  },
  {
    "codigo":26623000,
    "descripcion":"INTENTO FALLIDO DE ABORTO COMPLICADO POR HEMORRAGIA TARDÍA Y\/O EXCESIVA"
  },
  {
    "codigo":716586009,
    "descripcion":"CARCINOMA DE ESTÓMAGO DEBIDO A ENFERMEDAD POR VIRUS DE EPSTEIN-BARR"
  },
  {
    "codigo":714751007,
    "descripcion":"TRASTORNO INFLAMATORIO DE HUESO DE LA MANDÍBULA"
  },
  {
    "codigo":351281000119105,
    "descripcion":"NEOPLASIA BENIGNA DE HUESO CORTO DE MIEMBRO INFERIOR IZQUIERDO"
  },
  {
    "codigo":288767007,
    "descripcion":"DIFICULTAD PARA COMUNICAR SENTIMIENTOS"
  },
  {
    "codigo":678961000119105,
    "descripcion":"QUERATOPATÍA BULLOSA AFÁQUICA DE AMBOS OJOS"
  },
  {
    "codigo":254164007,
    "descripcion":"ICTIOSIS LAMELAR AUTOSÓMICA DOMINANTE"
  },
  {
    "codigo":53886000,
    "descripcion":"TORSIÓN DE COLON"
  },
  {
    "codigo":283262004,
    "descripcion":"VIDRIO EN EXTREMIDAD INFERIOR"
  },
  {
    "codigo":119422004,
    "descripcion":"CISTOADENOMA MUCINOSO OVÁRICO"
  },
  {
    "codigo":447102007,
    "descripcion":"GRANULOMA DE COLESTEROL DE MASTOIDES"
  },
  {
    "codigo":314195000,
    "descripcion":"LUXACIÓN DE ARTICULACIÓN CIGOAPOFISARIA CERVICAL"
  },
  {
    "codigo":248659007,
    "descripcion":"LATIDO APEXIANO"
  },
  {
    "codigo":246824000,
    "descripcion":"PTOSIS SIN COMPLICACIONES"
  },
  {
    "codigo":707411007,
    "descripcion":"ADENOCARCINOMA PAPILAR PRIMARIO DE PULMÓN"
  },
  {
    "codigo":115752000,
    "descripcion":"FENOTIPO I >ADULTO<"
  },
  {
    "codigo":1162493005,
    "descripcion":"GRANULOMA DE SILICONA ASOCIADO CON IMPLANTE MAMARIO RELLENO DE GEL DE SILICONA"
  },
  {
    "codigo":212221006,
    "descripcion":"LESIÓN DE RAÍZ DE NERVIO LUMBAR - L4"
  },
  {
    "codigo":310525009,
    "descripcion":"NEOPLASIA BENIGNA DE PARTES BLANDAS DE ESPALDA"
  },
  {
    "codigo":112082005,
    "descripcion":"CONDUCTA IMPROPIA"
  },
  {
    "codigo":210386008,
    "descripcion":"HERIDA ABIERTA DE LA TRÁQUEA"
  },
  {
    "codigo":274087000,
    "descripcion":"MELANOMA MALIGNO DE OJO"
  },
  {
    "codigo":77479002,
    "descripcion":"DEUTERANOMALÍA"
  },
  {
    "codigo":208551000,
    "descripcion":"FRACTURA NO EXPUESTA DE FÉMUR PROXIMAL, SUBTROCANTÉREA"
  },
  {
    "codigo":110247007,
    "descripcion":"CONTUSIÓN DE LA REGIÓN CIGOMÁTICA DE LA CARA"
  },
  {
    "codigo":306855008,
    "descripcion":"TROMBOSIS DE INJERTO-PUENTE AXILOFEMORAL"
  },
  {
    "codigo":763772002,
    "descripcion":"SALMONELOSIS NO TIFOIDEA INVASIVA"
  },
  {
    "codigo":403324004,
    "descripcion":"ALOPECIA AREATA CIRCUNSCRIPTA DE TRONCO"
  },
  {
    "codigo":8273004,
    "descripcion":"INTELIGENCIA SUPERIOR (C.I.....)"
  },
  {
    "codigo":11849061000119108,
    "descripcion":"ABRASIÓN DE PIEL DE MAMA DERECHA"
  },
  {
    "codigo":235814002,
    "descripcion":"ROTACIÓN PATOLÓGICA DEL INTESTINO, TIPO IIB"
  },
  {
    "codigo":353791000119103,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE CONJUNTIVA DE OJO DERECHO"
  },
  {
    "codigo":399654006,
    "descripcion":"TUMOR QUE INVADE MÍNIMAMENTE LA COROIDES"
  },
  {
    "codigo":11986431000119103,
    "descripcion":"QUEMADURA EPIDÉRMICA DE PIE IZQUIERDO"
  },
  {
    "codigo":299515000,
    "descripcion":"CRÉPITO PALPABLE DE ARTICULACIÓN DEL PIE"
  },
  {
    "codigo":233979001,
    "descripcion":"COMPRESIÓN DE ARTERIA TRASPLANTADA"
  },
  {
    "codigo":70139002,
    "descripcion":"URTICARIA MULTIFORME ENDÉMICA"
  },
  {
    "codigo":301350008,
    "descripcion":"LESIÓN DE LABIO"
  },
  {
    "codigo":71974009,
    "descripcion":"FALTA DE RESPUESTA SUPRARRENAL A LA CORTICOTROFINA HEREDITARIA"
  },
  {
    "codigo":170278009,
    "descripcion":"EXAMEN DEL NIÑO A LOS 21 MESES: ANORMAL - DERIVADO"
  },
  {
    "codigo":102907006,
    "descripcion":"GESTICULACIÓN"
  },
  {
    "codigo":168443006,
    "descripcion":"CITOLOGÍA TISULAR ANORMAL"
  },
  {
    "codigo":10675711000119106,
    "descripcion":"ASMA PERSISTENTE SEVERA NO CONTROLADA CONCOMITANTE CON RINITIS ALÉRGICA"
  },
  {
    "codigo":232144008,
    "descripcion":"PARÁLISIS DE ACOMODACIÓN TÓXICA"
  },
  {
    "codigo":295845000,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE BUTRIPTILINA"
  },
  {
    "codigo":787365005,
    "descripcion":"METABOLIZADOR INTERMEDIO ALTO DE LA FAMILIA 1 SUBFAMILIA A MIEMBRO 2 DEL CITOCROMO P450"
  },
  {
    "codigo":33701006,
    "descripcion":"AMPOLLA DE LA CARA, SIN INFECCIÓN"
  },
  {
    "codigo":263077007,
    "descripcion":"FRACTURA-LUXACIÓN DE ARTICULACIÓN DE HOMBRO"
  },
  {
    "codigo":425082000,
    "descripcion":"QUEMADURA POR INHALACIÓN CAUSADA POR GAS CALIENTE"
  },
  {
    "codigo":230309008,
    "descripcion":"COREOATETOSIS KINESIOGÉNICA"
  },
  {
    "codigo":64634000,
    "descripcion":"OPACIDAD CORNEAL"
  },
  {
    "codigo":721829008,
    "descripcion":"INFECCIÓN CAUSADA POR LOA"
  },
  {
    "codigo":1091071000119109,
    "descripcion":"OTITIS CRÓNICA MUCOIDE DE OÍDO MEDIO DERECHO"
  },
  {
    "codigo":228474006,
    "descripcion":"BISEXUAL - PREDOMINANTEMENTE HETEROSEXUAL"
  },
  {
    "codigo":128335001,
    "descripcion":"ANOMALÍA CONGÉNITA DEL DUODENO"
  },
  {
    "codigo":161103001,
    "descripcion":"MIEMBRO DE ASOCIACIÓN RELACIONADA CON LA ESQUIZOFRENIA"
  },
  {
    "codigo":11796121000119104,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN METACARPOFALÁNGICA DE DEDO MEÑIQUE IZQUIERDO"
  },
  {
    "codigo":62799003,
    "descripcion":"INFECCIÓN CAUSADA POR TRYPANOSOMA EQUINUM"
  },
  {
    "codigo":292175001,
    "descripcion":"REACCIÓN ADVERSA AL DESFLURANO"
  },
  {
    "codigo":1142308000,
    "descripcion":"INSUFICIENCIA DE VÁLVULA MITRAL DEBIDA A INFARTO AGUDO DE MIOCARDIO"
  },
  {
    "codigo":95567008,
    "descripcion":"HEMATURIA TRAUMÁTICA"
  },
  {
    "codigo":11304601000119105,
    "descripcion":"FRACTURA EXPUESTA DE PARED INTERNA DE ÓRBITA"
  },
  {
    "codigo":126500006,
    "descripcion":"NEOPLASIA DE LA PIEL DEL CUERO CABELLUDO"
  },
  {
    "codigo":716324008,
    "descripcion":"ENTEROCOCO NO AISLADO"
  },
  {
    "codigo":91897000,
    "descripcion":"AUSENCIA CONGÉNITA DE MAXILAR"
  },
  {
    "codigo":93732009,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE BRONQUIO DE LÓBULO MEDIO DE PULMÓN DERECHO"
  },
  {
    "codigo":124665007,
    "descripcion":"DEFICIENCIA DE ISOMERASA RETINIANA"
  },
  {
    "codigo":417742002,
    "descripcion":"TUMOR POSITIVO PARA RECEPTOR HORMONAL"
  },
  {
    "codigo":188366002,
    "descripcion":"TUMOR MALIGNO DE ABDOMEN"
  },
  {
    "codigo":24526004,
    "descripcion":"ENFERMEDAD INFLAMATORIA INTESTINAL"
  },
  {
    "codigo":286670005,
    "descripcion":"HUMOR - MECANISMO DE DEFENSA PSICOLÓGICA"
  },
  {
    "codigo":253902002,
    "descripcion":"ATRESIA DE URETRA"
  },
  {
    "codigo":1204174008,
    "descripcion":"ATEROSCLEROSIS DE ARTERIA SUBCLAVIA"
  },
  {
    "codigo":712654009,
    "descripcion":"PARTO POR OPERACIÓN CESÁREA POR PRESENTACIÓN DE NALGAS"
  },
  {
    "codigo":448675008,
    "descripcion":"NEOPLASIA MALIGNA DE APARATO DIGESTIVO"
  },
  {
    "codigo":284835009,
    "descripcion":"INCAPAZ DE HIGIENIZAR SU BOCA"
  },
  {
    "codigo":414072005,
    "descripcion":"EL ECOCARDIOGRAMA MUESTRA FUNCIÓN VENTRICULAR IZQUIERDA NORMAL"
  },
  {
    "codigo":1003896008,
    "descripcion":"DELECIÓN PROXIMAL DEL BRAZO LARGO DEL CROMOSOMA 6"
  },
  {
    "codigo":19021002,
    "descripcion":"OTITIS MEDIA POR HAEMOPHILUS INFLUENZAE"
  },
  {
    "codigo":707149004,
    "descripcion":"LINFADENITIS POR MICOBACTERIAS"
  },
  {
    "codigo":84557007,
    "descripcion":"LENGUA BÍFIDA"
  },
  {
    "codigo":1264205008,
    "descripcion":"TRASTORNO FETAL CAUSADO POR TRANSFERENCIA PLACENTARIA DE TABACO MATERNO"
  },
  {
    "codigo":312098001,
    "descripcion":"TRASTORNO RELACIONADO CON SEDANTES, HIPNÓTICOS Y\/O ANSIOLÍTICOS"
  },
  {
    "codigo":51789008,
    "descripcion":"POSICIÓN ANÓMALA CONGÉNITA DEL VÉRTICE CARDÍACO"
  },
  {
    "codigo":1196834001,
    "descripcion":"NEOPLASIA PAPILAR INTRADUCTAL CON NEOPLASIA INTRAEPITELIAL DE ALTO GRADO DE HÍGADO"
  },
  {
    "codigo":17186003,
    "descripcion":"INVAGINACIÓN ILEOCÓLICA"
  },
  {
    "codigo":82722005,
    "descripcion":"INTOXICACIÓN POR OXALIS"
  },
  {
    "codigo":246562007,
    "descripcion":"PÉRDIDA DE LA IMAGEN CORPORAL"
  },
  {
    "codigo":277495000,
    "descripcion":"MALFORMACIÓN VASCULAR DEL OÍDO INTERNO"
  },
  {
    "codigo":80887004,
    "descripcion":"ACIDEMIA METILMALÓNICA Y HOMOCISTINURIA HEREDITARIAS"
  },
  {
    "codigo":48119005,
    "descripcion":"DISPLASIA DE TIMO CON INMUNODEFICIENCIA"
  },
  {
    "codigo":13516000,
    "descripcion":"ADHERENCIA DE VESÍCULA BILIAR"
  },
  {
    "codigo":439500002,
    "descripcion":"LINFEDEMA DE MIEMBRO"
  },
  {
    "codigo":111820003,
    "descripcion":"ARTRITIS ESTAFILOCÓCICA"
  },
  {
    "codigo":46284005,
    "descripcion":"OBSTRUCCIÓN CONGÉNITA DE CUELLO DE VEJIGA URINARIA"
  },
  {
    "codigo":109985000,
    "descripcion":"ENFERMEDAD INMUNOPROLIFERATIVA DEL INTESTINO DELGADO (CLÍNICA)"
  },
  {
    "codigo":372129002,
    "descripcion":"CARCINOMA DE LA PIEL DE LA EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":206454000,
    "descripcion":"ICTERICIA NEONATAL DEBIDA A SÍNDROME DE CRIGLER-NAJJAR"
  },
  {
    "codigo":697974000,
    "descripcion":"HALLAZGO RELACIONADO CON EL NIVEL DE GAMMA-GLUTAMIL TRANSFERASA"
  },
  {
    "codigo":271990007,
    "descripcion":"AVULSIÓN DE INJERTO VASCULAR"
  },
  {
    "codigo":403062009,
    "descripcion":"ONICOMICOSIS CAUSADA POR TRICHOPHYTON SOUDANENSE"
  },
  {
    "codigo":401227003,
    "descripcion":"PIGMENTACIÓN DE PIEL DE PIERNA"
  },
  {
    "codigo":8011004,
    "descripcion":"DISARTRIA"
  },
  {
    "codigo":302923009,
    "descripcion":"MASTITIS PUBERAL"
  },
  {
    "codigo":40779009,
    "descripcion":"ATELECTASIA DISCOIDE"
  },
  {
    "codigo":1251360003,
    "descripcion":"NECROSIS TOTAL DE COLGAJO CUTÁNEO"
  },
  {
    "codigo":366624009,
    "descripcion":"TAMAÑO DEL CALZADO - HALLAZGO"
  },
  {
    "codigo":233717003,
    "descripcion":"NEUROFIBROMATOSIS PULMONAR DIFUSA"
  },
  {
    "codigo":37109004,
    "descripcion":"ENFERMEDAD POR VIRUS ÉBOLA"
  },
  {
    "codigo":299253006,
    "descripcion":"AMPLITUD DE EXTENSIÓN ACTIVA DE LA CADERA AUMENTADA"
  },
  {
    "codigo":364789009,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA CONTROLAR EL BOLO ALIMENTICIO"
  },
  {
    "codigo":2506003,
    "descripcion":"DISTIMIA DE INICIO TEMPRANO"
  },
  {
    "codigo":231882004,
    "descripcion":"CUERPO EXTRAÑO EN LA ESCLERÓTICA"
  },
  {
    "codigo":303361000119103,
    "descripcion":"CALCIFICACIÓN Y OSIFICACIÓN DE MÚSCULO DE MÚLTIPLES LOCALIZACIONES DEBIDA A QUEMADURA"
  },
  {
    "codigo":788938006,
    "descripcion":"FRACTURA DE CABEZA DE HÚMERO"
  },
  {
    "codigo":262815001,
    "descripcion":"CONTUSIÓN DE VÍAS BILIARES"
  },
  {
    "codigo":33439002,
    "descripcion":"ENTESOPATÍA DE LA MUÑECA Y\/O DEL CARPO"
  },
  {
    "codigo":426655001,
    "descripcion":"TRASTORNO DEL METABOLISMO DE AMINOÁCIDOS AROMÁTICOS"
  },
  {
    "codigo":721567004,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE PLACENTA"
  },
  {
    "codigo":66207005,
    "descripcion":"EFECTO TÓXICO DEL CIANURO"
  },
  {
    "codigo":361119006,
    "descripcion":"FRACTURA EXPUESTA DE CUELLO DE FÉMUR"
  },
  {
    "codigo":295583006,
    "descripcion":"SOBREDOSIS DE PROXIMETACAÍNA"
  },
  {
    "codigo":719732004,
    "descripcion":"CAPAZ DE RECONOCER SÍNTOMAS PROPIOS"
  },
  {
    "codigo":31604004,
    "descripcion":"AMPOLLA DEL FLANCO, CON INFECCIÓN"
  },
  {
    "codigo":129908006,
    "descripcion":"HALLAZGO EN LAS FUNCIONES DE DIGESTIÓN - HIDRATACIÓN"
  },
  {
    "codigo":193609000,
    "descripcion":"CATARATA MEDICAMENTOSA"
  },
  {
    "codigo":62537000,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DE PIE"
  },
  {
    "codigo":15704321000119107,
    "descripcion":"ATROFIA MUSCULAR BILATERAL DE MUSLO"
  },
  {
    "codigo":293748008,
    "descripcion":"ALERGIA A CICLOFOSFAMIDA"
  },
  {
    "codigo":95305004,
    "descripcion":"TORACOSQUISIS"
  },
  {
    "codigo":816201004,
    "descripcion":"NEVO ACRO"
  },
  {
    "codigo":291913004,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR SULFATO FERROSO"
  },
  {
    "codigo":422985007,
    "descripcion":"CARCINOMA DE COLON, ESTADIO IV"
  },
  {
    "codigo":717897007,
    "descripcion":"HIPOPARATIROIDISMO AISLADO HEREDITARIO DEBIDO A AGENESIA DE GLÁNDULA PARATIROIDES"
  },
  {
    "codigo":128073008,
    "descripcion":"TRASTORNO DE URÉTER"
  },
  {
    "codigo":1142046003,
    "descripcion":"PITIRIASIS RUBRA PILARIS DEBIDA A INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":879902003,
    "descripcion":"FRACTURAS EXPUESTAS MÚLTIPLES DE HUESOS FACIALES"
  },
  {
    "codigo":191774007,
    "descripcion":"TRASTORNO MASOQUISTA DE LA PERSONALIDAD"
  },
  {
    "codigo":290078008,
    "descripcion":"HALLAZGO RELACIONADO CON LA SENSIBILIDAD DE LAS MAMAS"
  },
  {
    "codigo":93470007,
    "descripcion":"HEMANGIOMA DE RETINA"
  },
  {
    "codigo":253640002,
    "descripcion":"ANORMALIDAD DE LA AORTA ASCENDENTE"
  },
  {
    "codigo":286408007,
    "descripcion":"HABLA INTELIGIBLEMENTE"
  },
  {
    "codigo":186269001,
    "descripcion":"TUBERCULOSIS ÓTICA"
  },
  {
    "codigo":55197001,
    "descripcion":"DIENTE INVAGINADO"
  },
  {
    "codigo":448413002,
    "descripcion":"CABALGAMIENTO DE VÁLVULA PULMONAR SOBRE EL TABIQUE INTERVENTRICULAR"
  },
  {
    "codigo":284573004,
    "descripcion":"CUERPO EXTRAÑO METÁLICO EN LA NARIZ"
  },
  {
    "codigo":20594000,
    "descripcion":"FRACTURAS MÚLTIPLES EXPUESTAS DE LA EXTREMIDAD INFERIOR CON LAS COSTILLAS Y EL ESTERNÓN"
  },
  {
    "codigo":315506008,
    "descripcion":"NACIDO EN QATAR"
  },
  {
    "codigo":248135001,
    "descripcion":"AVERSIÓN A UN ALIMENTO EN PARTICULAR"
  },
  {
    "codigo":1296711000,
    "descripcion":"HIPERTENSIÓN OCULAR BILATERAL DEBIDA A NEOVASCULARIZACIÓN"
  },
  {
    "codigo":84295003,
    "descripcion":"AMPOLLA DEL CUERO CABELLUDO, SIN INFECCIÓN"
  },
  {
    "codigo":706887003,
    "descripcion":"ALERGIA A PROTEÍNA DE FUMAGINA"
  },
  {
    "codigo":1263943005,
    "descripcion":"SHOCK POSTERIOR A EMBARAZO MOLAR"
  },
  {
    "codigo":10818101000119104,
    "descripcion":"FRACTURA EXPUESTA EN MARTILLO DE FALANGE DISTAL DE DEDO MEDIO DE MANO DERECHA"
  },
  {
    "codigo":117063007,
    "descripcion":"DESTINO FINAL DE UNA UNIDAD DE HEMODERIVADO"
  },
  {
    "codigo":444743007,
    "descripcion":"CICATRIZ CUTÁNEA SINTOMÁTICA"
  },
  {
    "codigo":1231175009,
    "descripcion":"ANOMALÍA CONGÉNITA DE LA CUARTA HENDIDURA BRANQUIAL"
  },
  {
    "codigo":870727009,
    "descripcion":"ALERGIA A ÁCIDO FÓLICO Y\/O COMPUESTO DE HIERRO"
  },
  {
    "codigo":770588002,
    "descripcion":"DERMATITIS POR CONTACTO ALÉRGICA CAUSADA POR YODÓFORO"
  },
  {
    "codigo":49692006,
    "descripcion":"ENFERMEDAD DE SCHILDER"
  },
  {
    "codigo":16924008,
    "descripcion":"HIPERTROFIA DE VULVA"
  },
  {
    "codigo":1293041004,
    "descripcion":"RADIOGRAFÍA DE CABEZA NORMAL"
  },
  {
    "codigo":703217005,
    "descripcion":"HEMORRAGIA SUBARACNOIDEA DE LA CONVEXIDAD"
  },
  {
    "codigo":277233008,
    "descripcion":"RINORREA ANTERIOR"
  },
  {
    "codigo":46022004,
    "descripcion":"PUJO"
  },
  {
    "codigo":4661000119109,
    "descripcion":"MALA OCLUSIÓN ESQUELÉTICA"
  },
  {
    "codigo":111558006,
    "descripcion":"COMA INSULÍNICO"
  },
  {
    "codigo":371867000,
    "descripcion":"TIMI (THROMBOLYSIS IN MYOCARDIAL INFARCTION) GRADO 0: SIN PERFUSIÓN"
  },
  {
    "codigo":142031000119104,
    "descripcion":"DEFECTO DEL CAMPO VISUAL DEBIDO A ACCIDENTE CEREBROVASCULAR Y POSTERIOR A ÉL"
  },
  {
    "codigo":1287536000,
    "descripcion":"ABRASIÓN DE PIEL DE CARA"
  },
  {
    "codigo":271728000,
    "descripcion":"ARTERIAS DE LA RETINA ATENUADAS"
  },
  {
    "codigo":238960002,
    "descripcion":"NO-ENFERMEDAD DERMATOLÓGICA"
  },
  {
    "codigo":206192007,
    "descripcion":"DESGARRO TENTORIAL DEBIDO A TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":1285701000,
    "descripcion":"RAÍZ DE DIENTE RETENIDO POSTERIOR A TRAUMATISMO DENTAL"
  },
  {
    "codigo":302661005,
    "descripcion":"DEFICIENCIA DE GLICOSIDASA"
  },
  {
    "codigo":204357006,
    "descripcion":"ANOMALÍA DE EBSTEIN DE VÁLVULA TRICÚSPIDE"
  },
  {
    "codigo":400965007,
    "descripcion":"ECTROPIÓN CONGÉNITO DEL IRIS"
  },
  {
    "codigo":71450000,
    "descripcion":"ÚLCERA POR CONTACTO DE LOS PLIEGUES VOCALES"
  },
  {
    "codigo":366362000,
    "descripcion":"ECCEMA VARICOSO"
  },
  {
    "codigo":237125007,
    "descripcion":"MENORRAGIA PUBERAL"
  },
  {
    "codigo":15680361000119103,
    "descripcion":"CONJUNTIVITIS FOLICULAR AGUDA POR ADENOVIRUS DE OJO IZQUIERDO"
  },
  {
    "codigo":169754006,
    "descripcion":"PROVEEDOR DE ATENCIÓN POSNATAL"
  },
  {
    "codigo":268058007,
    "descripcion":"INFECCIÓN POR SCHISTOSOMA JAPONICUM"
  },
  {
    "codigo":200687002,
    "descripcion":"CELULITIS DE PIE DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":724975003,
    "descripcion":"DISTENSIÓN DE FASCIA DE MÚSCULO EXTENSOR DE DEDO DE LA MANO A LA ALTURA DEL ANTEBRAZO"
  },
  {
    "codigo":297156001,
    "descripcion":"TROMBOSIS DE VENA AXILAR"
  },
  {
    "codigo":723140005,
    "descripcion":"HERIDA COMPLEJA DE CABEZA CON MATERIAL EXTERNO RETENIDO"
  },
  {
    "codigo":428228008,
    "descripcion":"RUPTURA DEL TENDÓN DEL CUÁDRICEPS POR CAUSA TRAUMÁTICA"
  },
  {
    "codigo":409002,
    "descripcion":"DIETA PARA ALERGIA ALIMENTARIA"
  },
  {
    "codigo":459161004,
    "descripcion":"ABSCESO EN LOCALIZACIÓN DE DEFECTO DE TABIQUE INTERVENTRICULAR"
  },
  {
    "codigo":31342001,
    "descripcion":"VISIÓN AUMENTADA"
  },
  {
    "codigo":129646001,
    "descripcion":"HIPERGLOBULINEMIA"
  },
  {
    "codigo":1145454003,
    "descripcion":"APLASIA DE HUESO DE PELVIS"
  },
  {
    "codigo":16909161000119109,
    "descripcion":"HIDROCISTOMA APOCRINO DE PÁRPADO INFERIOR IZQUIERDO"
  },
  {
    "codigo":195182007,
    "descripcion":"OCLUSIÓN DE ARTERIA VERTEBRAL"
  },
  {
    "codigo":291651002,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR MINOCICLINA"
  },
  {
    "codigo":226115004,
    "descripcion":"DIETA HIPOLIPEMIANTE"
  },
  {
    "codigo":160579004,
    "descripcion":"CESÓ DE BEBER ALCOHOL"
  },
  {
    "codigo":715800000,
    "descripcion":"ENFERMEDAD DE CHARCOT-MARIE-TOOTH TIPO 4B2"
  },
  {
    "codigo":95043008,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE HUESO CORTO DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":191512001,
    "descripcion":"ESTADO CONFUSIONAL SUBAGUDO, DE ORIGEN CEREBROVASCULAR"
  },
  {
    "codigo":1010712009,
    "descripcion":"DISTROFIA MUSCULAR DE EMERY-DREIFUSS AUTOSÓMICA DOMINANTE"
  },
  {
    "codigo":224280009,
    "descripcion":"CATEGORÍA ESPECIAL DE USUARIO TELEFÓNICO"
  },
  {
    "codigo":15955101000119101,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE GLÁNDULA DE BARTOLINO DERECHA"
  },
  {
    "codigo":419053007,
    "descripcion":"REFLEJO AQUÍLEO, FASE DE RECUPERACIÓN LENTA"
  },
  {
    "codigo":124141008,
    "descripcion":"DEFICIENCIA DE L - LACTATO DESHIDROGENASA (CITOCROMO)"
  },
  {
    "codigo":713965007,
    "descripcion":"ESCLEROSIS DE VENA PORTA Y VENA ESPLÉNICA CAUSADA POR FÁRMACO ANTIRRETROVIRAL"
  },
  {
    "codigo":89538001,
    "descripcion":"GASTRITIS ASOCIADA CON HELICOBACTER"
  },
  {
    "codigo":187842004,
    "descripcion":"NEOPLASIA MALIGNA DE SUPRAGLOTIS"
  },
  {
    "codigo":308381000119103,
    "descripcion":"GRANULOMA POR CUERPO EXTRAÑO DE PARTES BLANDAS DE PIERNA IZQUIERDA"
  },
  {
    "codigo":253378006,
    "descripcion":"CABALGAMIENTO DE VÁLVULA TRICÚSPIDE"
  },
  {
    "codigo":11803651000119109,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA PROXIMAL DE DEDO MEDIO IZQUIERDO"
  },
  {
    "codigo":22167000,
    "descripcion":"PIOPERICARDIO"
  },
  {
    "codigo":1300119004,
    "descripcion":"SÍNDROME DE MICROCEFALIA-DISCAPACIDAD INTELECTUAL GRAVE-ANOMALÍAS CONGÉNITAS MÚLTIPLES ASOCIADO AL GEN SETD2"
  },
  {
    "codigo":448151007,
    "descripcion":"OPCIONES DE MEDICACIÓN EFECTIVAS EN RELACIÓN AL COSTO DISPONIBLES"
  },
  {
    "codigo":184172002,
    "descripcion":"PACIENTE RETIRADO DEL REGISTRO POR MÉDICO GENERAL"
  },
  {
    "codigo":1003372008,
    "descripcion":"MICROFTALMÍA DEBIDA A SÍNDROME BRANQUIO-ÓCULO-FACIAL"
  },
  {
    "codigo":870465001,
    "descripcion":"INGESTA EXCESIVA DE VITAMINA A Y\/O DERIVADO DE VITAMINA A"
  },
  {
    "codigo":1263681002,
    "descripcion":"TRASTORNO FETAL DEBIDO A PRESENTACIÓN DE CARA ANTES DE PRE-TRABAJO DE PARTO"
  },
  {
    "codigo":282476009,
    "descripcion":"CORRE"
  },
  {
    "codigo":402995005,
    "descripcion":"ACTINOMICETOMA CAUSADO POR STREPTOMYCES SOMALIENSIS"
  },
  {
    "codigo":247873003,
    "descripcion":"PENSAMIENTOS OBSESIVOS ACERCA DE SER VÍCTIMA DE UN ROBO"
  },
  {
    "codigo":213270002,
    "descripcion":"FRACTURA INTRAOPERATORIA"
  },
  {
    "codigo":442646005,
    "descripcion":"ESTUDIO POR IMÁGENES DE PULMÓN, ANORMAL"
  },
  {
    "codigo":702955000,
    "descripcion":"ALTERACIÓN COGNITIVA MODERADA"
  },
  {
    "codigo":735723000,
    "descripcion":"PERFORACIÓN NEONATAL AISLADA DE ÍLEON"
  },
  {
    "codigo":1163542009,
    "descripcion":"MENINGITIS POR STRONGYLOIDES STERCORALIS"
  },
  {
    "codigo":16010551000119104,
    "descripcion":"NECROSIS AVASCULAR DE HUESO METATARSIANO DE AMBOS PIES"
  },
  {
    "codigo":309739005,
    "descripcion":"ESTAFILOCOCO COAGULASA-NEGATIVO EN EL PERÍODO PERINATAL"
  },
  {
    "codigo":1260011007,
    "descripcion":"FRACTURA DE CORONA Y RAÍZ DE DIENTE PERMANENTE INMADURO POSTERIOR A TRATAMIENTO DE CONDUCTO DE RAÍZ DENTAL DE DIENTE"
  },
  {
    "codigo":111296006,
    "descripcion":"EMBOLIA DE ARTERIA BASILAR"
  },
  {
    "codigo":1290944006,
    "descripcion":"FIBROMA DESMOPLÁSICO"
  },
  {
    "codigo":209600009,
    "descripcion":"DESGARRO COMPLETO DE LIGAMENTO ESCAFOTRAPEZOIDE"
  },
  {
    "codigo":109461003,
    "descripcion":"MICRODONCIA DE UN SOLO DIENTE"
  },
  {
    "codigo":240533004,
    "descripcion":"VERRUGA FACIAL"
  },
  {
    "codigo":43925005,
    "descripcion":"INFECCIÓN CAUSADA POR SAKSENAEA"
  },
  {
    "codigo":11157007,
    "descripcion":"BIGEMINISMO VENTRICULAR"
  },
  {
    "codigo":402538000,
    "descripcion":"CARCINOMA BASOCELULAR RECURRENTE"
  },
  {
    "codigo":304234001,
    "descripcion":"PINCHAZO CON AGUJA CONTAMINADA"
  },
  {
    "codigo":42090003,
    "descripcion":"BIORRITMO CIRCASEPTANO NORMAL"
  },
  {
    "codigo":238698004,
    "descripcion":"TRASTORNO HIPERMELANÓTICO ADQUIRIDO"
  },
  {
    "codigo":369770006,
    "descripcion":"PATRÓN DE GLEASON 1"
  },
  {
    "codigo":7487003,
    "descripcion":"DIETA CON 200 MILIGRAMOS DE CALCIO"
  },
  {
    "codigo":171327009,
    "descripcion":"CRIBADO EN PACIENTE NUEVO - NO SE DETECTAN ANOMALÍAS"
  },
  {
    "codigo":300564004,
    "descripcion":"BAZO AUSENTE"
  },
  {
    "codigo":38420005,
    "descripcion":"TUBERCULOSIS DEL INTESTINO GRUESO"
  },
  {
    "codigo":890388006,
    "descripcion":"MALFORMACIÓN CONGÉNITA DE LA VÍA AÉREA PULMONAR TIPO 4"
  },
  {
    "codigo":235028007,
    "descripcion":"LEUCOPLASIA ORAL ULCERADA"
  },
  {
    "codigo":298729007,
    "descripcion":"DOLOR A LA PALPACIÓN EN ESTERNÓN"
  },
  {
    "codigo":36585007,
    "descripcion":"LINFADENITIS DERMATOPÁTICA"
  },
  {
    "codigo":722878001,
    "descripcion":"TRASTORNO DE ERUCTACIÓN FUNCIONAL"
  },
  {
    "codigo":427966000,
    "descripcion":"EFECTO TARDÍO DE HEMATOMA EPIDURAL CAUSADO POR TRAUMATISMO"
  },
  {
    "codigo":1148862002,
    "descripcion":"DEFICIENCIA DE FACTOR X DEBIDA A AMILOIDOSIS SISTÉMICA"
  },
  {
    "codigo":823017009,
    "descripcion":"CARCINOMA DUCTAL INFILTRANTE DE PRÓSTATA"
  },
  {
    "codigo":296894006,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE METANDRIOL"
  },
  {
    "codigo":1279934006,
    "descripcion":"VÍCTIMA DE ABUSO PSICOLÓGICO DURANTE LA INFANCIA"
  },
  {
    "codigo":360595002,
    "descripcion":"OTITIS MEDIA AGUDA NECROSANTE"
  },
  {
    "codigo":48081000087102,
    "descripcion":"MUCOSA HEMORRÁGICA DE INTESTINO GRUESO"
  },
  {
    "codigo":295059006,
    "descripcion":"ALERGIA A INHIBIDOR DE LA FOSFODIESTERASA"
  },
  {
    "codigo":293224000,
    "descripcion":"REACCIÓN ADVERSA AL CICLOFENILO"
  },
  {
    "codigo":40401000087103,
    "descripcion":"CUERPO EXTRAÑO EN CONDUCTO AUDITIVO IZQUIERDO"
  },
  {
    "codigo":1343635007,
    "descripcion":"CARCINOMA IN SITU DE PIEL DE PÁRPADO INFERIOR"
  },
  {
    "codigo":65683006,
    "descripcion":"EDAD GESTACIONAL, 17 SEMANAS"
  },
  {
    "codigo":424296005,
    "descripcion":"HALLAZGO RELACIONADO CON EL PUNTAJE DE MALLAMPATI"
  },
  {
    "codigo":31080005,
    "descripcion":"PERICARDITIS SECUNDARIA A ENANISMO MULIBREY"
  },
  {
    "codigo":63848007,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE MUÑECA CON INFECCIÓN"
  },
  {
    "codigo":94781000,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL CARTÍLAGO DE LA NARIZ"
  },
  {
    "codigo":719208005,
    "descripcion":"ATAXIA ESPINOCEREBELOSA TIPO 12"
  },
  {
    "codigo":225853002,
    "descripcion":"DESCONOCE REGLAS Y LÍMITES"
  },
  {
    "codigo":42961000087109,
    "descripcion":"QUEMADURA DE DEDO ÍNDICE DERECHO"
  },
  {
    "codigo":782909004,
    "descripcion":"ENFERMEDAD HEMORRÁGICA DEBIDA A MUTACIÓN PITTSBURGH DE ANTITRIPSINA ALFA-1"
  },
  {
    "codigo":1208893004,
    "descripcion":"FRACTURA DE CABLE AURICULAR DE DESFIBRILADOR CARDIOVERSOR IMPLANTABLE"
  },
  {
    "codigo":291389004,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR PROBENECID"
  },
  {
    "codigo":422461009,
    "descripcion":"INSATISFECHO CON LA RELACIÓN SEXUAL"
  },
  {
    "codigo":1010450002,
    "descripcion":"PREFERENCIA DE FIJACIÓN OCULAR DE OJO DERECHO"
  },
  {
    "codigo":289554001,
    "descripcion":"SECRECIÓN VAGINAL AMARILLA"
  },
  {
    "codigo":92946005,
    "descripcion":"FORMA ANORMAL CONGÉNITA DEL BAZO"
  },
  {
    "codigo":189415001,
    "descripcion":"NEOPLASIA DEL CARTÍLAGO CORNICULADO DE COMPORTAMIENTO INCIERTO"
  },
  {
    "codigo":713703005,
    "descripcion":"GASTROPARESIA DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":254951005,
    "descripcion":"TUMOR GLIAL MIXTO DE MÉDULA ESPINAL"
  },
  {
    "codigo":416956002,
    "descripcion":"POLIARTRITIS INFLAMATORIA NO DIFERENCIADA"
  },
  {
    "codigo":449724005,
    "descripcion":"ASTIGMATISMO MIÓPICO"
  },
  {
    "codigo":23740006,
    "descripcion":"PARÁLISIS BILATERAL DE LA LENGUA"
  },
  {
    "codigo":1070131000000103,
    "descripcion":"DIFICULTAD PARA ACOSTARSE SIN ASISTENCIA"
  },
  {
    "codigo":826931000000104,
    "descripcion":"PACIENTE FRECUENTE DEL SERVICIO DE EMERGENTOLOGÍA Y URGENCIAS"
  },
  {
    "codigo":1268924008,
    "descripcion":"ESMEGMA EN CANTIDAD EXCESIVA EN CLÍTORIS"
  },
  {
    "codigo":285884007,
    "descripcion":"DIFICULTAD PARA USAR EL HORNO DE MICROONDAS"
  },
  {
    "codigo":710033006,
    "descripcion":"MORFOLOGÍA DE CRESTA ALVEOLAR RESIDUAL DE MAXILAR SUPERIOR CON MUESCA HAMULAR ESCASA"
  },
  {
    "codigo":21905007,
    "descripcion":"ANOMALÍA CONGÉNITA DEL OÍDO MEDIO"
  },
  {
    "codigo":249446000,
    "descripcion":"LEUCOPLASIA INTERARITENOIDE"
  },
  {
    "codigo":708198006,
    "descripcion":"HEPATITIS C ACTIVA CRÓNICA"
  },
  {
    "codigo":313147000,
    "descripcion":"TUMOR GRADO G0"
  },
  {
    "codigo":216678008,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR GASOIL"
  },
  {
    "codigo":15986591000119104,
    "descripcion":"HIPERTROFIA CONGÉNITA DE EPITELIO PIGMENTARIO DE LA RETINA DEL OJO IZQUIERDO"
  },
  {
    "codigo":247611005,
    "descripcion":"AMNESIA PARA LA INFORMACIÓN PERSONAL IMPORTANTE"
  },
  {
    "codigo":737296002,
    "descripcion":"PULMÓN TRASPLANTADO PRESENTE"
  },
  {
    "codigo":278544002,
    "descripcion":"HALLAZGO DE DIENTE"
  },
  {
    "codigo":49168004,
    "descripcion":"PRESENTACIÓN PÉLVICA COMPLETA"
  },
  {
    "codigo":409616009,
    "descripcion":"INTOXICACIÓN POR SEMILLA DE RICINO"
  },
  {
    "codigo":1163280009,
    "descripcion":"DIÁLOGO INTERNO POSITIVO ACERCA DE LOS ALIMENTOS Y\/O LA NUTRICIÓN"
  },
  {
    "codigo":735461003,
    "descripcion":"DISCINESIA TRAQUEAL"
  },
  {
    "codigo":80101003,
    "descripcion":"ESTENOSIS DE TROMPA DE EUSTAQUIO"
  },
  {
    "codigo":47333004,
    "descripcion":"DISCINESIA AURICULAR"
  },
  {
    "codigo":276709006,
    "descripcion":"FONTANELA GRANDE"
  },
  {
    "codigo":1259749007,
    "descripcion":"MENINGIOMA PRIMARIO MALIGNO DE MENINGE CEREBRAL"
  },
  {
    "codigo":339871000119108,
    "descripcion":"BLEFAROCALASIA DE PÁRPADO INFERIOR IZQUIERDO"
  },
  {
    "codigo":209338000,
    "descripcion":"FRACTURA-SUBLUXACIÓN EXPUESTA DE ARTICULACIÓN DE LA CADERA"
  },
  {
    "codigo":405946002,
    "descripcion":"REFLEJO TENDINOSO DISMINUIDO"
  },
  {
    "codigo":733626002,
    "descripcion":"ENFERMEDAD DE NORRIE ATÍPICA DEBIDA A MONOSOMÍA XP11.3"
  },
  {
    "codigo":895631002,
    "descripcion":"FORMA TRIANGULAR ANORMAL CONGÉNITA DE FALANGE MEDIA DE DEDO DE MANO"
  },
  {
    "codigo":11782201000119104,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA ANTERIOR DE RODILLA DERECHA"
  },
  {
    "codigo":76431004,
    "descripcion":"ÁNTRAX DE LA INGLE"
  },
  {
    "codigo":305807004,
    "descripcion":"ATENDIDO POR SERVICIO DE NEUROFISIOLOGÍA CLÍNICA"
  },
  {
    "codigo":240271006,
    "descripcion":"DOLOR PERSISTENTE ASOCIADO CON PRÓTESIS ARTICULAR"
  },
  {
    "codigo":1256079005,
    "descripcion":"PIODERMA GANGRENOSO DEBIDO A POLIARTROPATÍA INFLAMATORIA"
  },
  {
    "codigo":404111002,
    "descripcion":"MICOSIS FUNGOIDE ASOCIADA CON PAPULOSIS LINFOMATOIDE"
  },
  {
    "codigo":369508002,
    "descripcion":"TUMOR MALIGNO QUE COMPROMETE LA VULVA POR EXTENSIÓN DIRECTA DESDE TROMPA DE FALOPIO"
  },
  {
    "codigo":238436005,
    "descripcion":"ALTERNARIOSIS CUTÁNEA"
  },
  {
    "codigo":39993000,
    "descripcion":"FRACTURA EXPUESTA DE DIÁFISIS DE RADIO Y CÚBITO"
  },
  {
    "codigo":1186873004,
    "descripcion":"MIELOPATÍA ESPINAL DEBIDA A OBESIDAD"
  },
  {
    "codigo":236601006,
    "descripcion":"HIDROURÉTER DEBIDO A PAPILA NECRÓTICA EN EL URÉTER"
  },
  {
    "codigo":267534000,
    "descripcion":"TROMBOCITOPENIA PRIMARIA"
  },
  {
    "codigo":105529008,
    "descripcion":"VIVE SOLO"
  },
  {
    "codigo":300302004,
    "descripcion":"ASPIRADO GÁSTRICO CON CONTENIDO DE ALIMENTO DIGERIDO"
  },
  {
    "codigo":365838005,
    "descripcion":"MEGACARIOCITOS DE MÉDULA ÓSEA - HALLAZGO"
  },
  {
    "codigo":201998006,
    "descripcion":"ARTROPATÍA TRANSITORIA DE LA ARTICULACIÓN ESTERNOCLAVICULAR"
  },
  {
    "codigo":396771003,
    "descripcion":"GRASA PERIHILIAR COMPROMETIDA POR EXTENSIÓN DIRECTA DE NEOPLASIA MALIGNA"
  },
  {
    "codigo":724451007,
    "descripcion":"TEMOR AL CÁNCER DE MAMA"
  },
  {
    "codigo":67256000,
    "descripcion":"TUBERCULOSIS DEL PERICARDIO"
  },
  {
    "codigo":198328003,
    "descripcion":"POSICIÓN UTERINA ANÓMALA"
  },
  {
    "codigo":1279672004,
    "descripcion":"FIEBRE RECURRENTE CAUSADA POR BORRELIA LATYSCHEWII"
  },
  {
    "codigo":34488005,
    "descripcion":"DIMELIA"
  },
  {
    "codigo":722616008,
    "descripcion":"LACERACIÓN FOCAL DE CEREBRO"
  },
  {
    "codigo":296632009,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE VANCOMICINA"
  },
  {
    "codigo":65421000,
    "descripcion":"VIVIR EN UNA CARPA"
  },
  {
    "codigo":196493006,
    "descripcion":"ABSCESO DE GLÁNDULA SUBLINGUAL"
  },
  {
    "codigo":425869007,
    "descripcion":"LEUCEMIA PROMIELOCÍTICA AGUDA, FAB M3, EN REMISIÓN"
  },
  {
    "codigo":1079661000119102,
    "descripcion":"NEVO MELANOCÍTICO PIGMENTADO CONGÉNITO DE PIEL DE OREJA IZQUIERDA"
  },
  {
    "codigo":292962002,
    "descripcion":"REACCIÓN ADVERSA A LAS PENICILINAS RESISTENTE A LA PENICILINASA"
  },
  {
    "codigo":30818003,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN LA REGIÓN DEL PERINEO, CON INFECCIÓN"
  },
  {
    "codigo":1144930007,
    "descripcion":"METABOLIZADOR LENTO DE LA FAMILIA 2 SUBFAMILIA C MIEMBRO 9 *2\/*3 DEL CITOCROMO P450"
  },
  {
    "codigo":127287001,
    "descripcion":"FRACTURA INTERTROCANTÉREA"
  },
  {
    "codigo":94519005,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LOS GANGLIOS LINFÁTICOS RETROPERITONEALES"
  },
  {
    "codigo":225591008,
    "descripcion":"HALLAZGO RELACIONADO CON LA FORMA DE LA PUPILA"
  },
  {
    "codigo":291127008,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR LOXAPINA"
  },
  {
    "codigo":92684002,
    "descripcion":"CARCINOMA IN SITU DE LA PLACENTA"
  },
  {
    "codigo":27148008,
    "descripcion":"ENFERMEDAD DE LA PLACA MOTORA TERMINAL HEREDITARIA"
  },
  {
    "codigo":418529003,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE APARATO LAGRIMAL"
  },
  {
    "codigo":123617004,
    "descripcion":"FLECKMILZ"
  },
  {
    "codigo":342381000119109,
    "descripcion":"IRITIS GONOCÓCICA"
  },
  {
    "codigo":285622006,
    "descripcion":"DIFICULTAD PARA ADMINISTRAR EL TIEMPO"
  },
  {
    "codigo":1170358006,
    "descripcion":"HEMATOMA DE ESPACIO RETROPÚBICO"
  },
  {
    "codigo":54411001,
    "descripcion":"SÍNDROME DE PEUTZ-JEGHERS"
  },
  {
    "codigo":414859005,
    "descripcion":"SIN CONSENTIMIENTO PARA COMPARTIR HISTORIA ELECTRÓNICA"
  },
  {
    "codigo":251019006,
    "descripcion":"HALLAZGO RELACIONADO CON INJERTO-PUENTE CORONARIO"
  },
  {
    "codigo":21643007,
    "descripcion":"CONTUSIÓN DE LA INGLE"
  },
  {
    "codigo":283787005,
    "descripcion":"HERIDA POR MORDEDURA DE MONO"
  },
  {
    "codigo":218251009,
    "descripcion":"EFECTO TARDÍO DE ACCIDENTE PROVOCADO POR FUEGO"
  },
  {
    "codigo":52576001,
    "descripcion":"LESIÓN TRAUMÁTICA DE ARTERIA TIBIAL ANTERIOR"
  },
  {
    "codigo":871776007,
    "descripcion":"REACCIÓN ADVERSA A TIOUREA"
  },
  {
    "codigo":247349000,
    "descripcion":"DENTICIÓN DOLOROSA"
  },
  {
    "codigo":116277006,
    "descripcion":"ASPIRACIÓN PULMONAR DE LÍQUIDO"
  },
  {
    "codigo":443957007,
    "descripcion":"INFECCIÓN DE LA CÓRNEA POR VIRUS HERPES SIMPLE DESPUÉS DE CIRUGÍA OFTÁLMICA"
  },
  {
    "codigo":312885006,
    "descripcion":"FUNDOSCOPIA CON DILATACIÓN: NORMAL"
  },
  {
    "codigo":48906005,
    "descripcion":"PRESENTACIÓN PODÁLICA, DOBLE"
  },
  {
    "codigo":737034006,
    "descripcion":"ÁNGULO NASOLABIAL OBTUSO"
  },
  {
    "codigo":278282006,
    "descripcion":"VÍA AÉREA BUCAL - HALLAZGO"
  },
  {
    "codigo":276447000,
    "descripcion":"ÁCARO PRESENTE"
  },
  {
    "codigo":1259487000,
    "descripcion":"CARCINOSARCOMA PRIMARIO DE ANEXOS UTERINOS"
  },
  {
    "codigo":407519002,
    "descripcion":"ENFERMEDAD CAUSADA POR DELTARETROVIRUS"
  },
  {
    "codigo":1357791002,
    "descripcion":"MUTACIÓN DE GEN HOMÓLOGO DE FOSFATASA Y TENSINA NO DETECTADA"
  },
  {
    "codigo":210911004,
    "descripcion":"CONTUSIÓN, ARTERIA PEDIA DORSAL"
  },
  {
    "codigo":79839005,
    "descripcion":"LACERACIÓN PERINEAL QUE COMPROMETE LA VULVA"
  },
  {
    "codigo":702431004,
    "descripcion":"SÍNDROME OCULO-DIGITO-ESOFÁGICO-DUODENAL Y MICROCEFALIA"
  },
  {
    "codigo":473055007,
    "descripcion":"INFECCIÓN DE LOCALIZACIÓN DE GENERADOR DE PULSOS DE MARCAPASO"
  },
  {
    "codigo":78004001,
    "descripcion":"BULIMIA NERVIOSA"
  },
  {
    "codigo":240009000,
    "descripcion":"CONTRACTURA DE LOS TENDONES DE LA REGIÓN DE LA RODILLA"
  },
  {
    "codigo":76169001,
    "descripcion":"DEFICIENCIA DE ÁCIDO ASCÓRBICO"
  },
  {
    "codigo":371081002,
    "descripcion":"ARTRITIS DE RODILLA"
  },
  {
    "codigo":10633002,
    "descripcion":"INSUFICIENCIA CARDÍACA CONGESTIVA AGUDA"
  },
  {
    "codigo":403849006,
    "descripcion":"LESIÓN TRAUMÁTICA DE CUERO CABELLUDO POR EXTRACCIÓN POR ASPIRACIÓN"
  },
  {
    "codigo":1286750004,
    "descripcion":"FRACTURA CERRADA DE FALANGES DE MÚLTIPLES DEDOS DE MANO"
  },
  {
    "codigo":762462005,
    "descripcion":"BRONCOESPASMO CAUSADO POR FÁRMACO"
  },
  {
    "codigo":400179000,
    "descripcion":"PUBERTAD PRECOZ"
  },
  {
    "codigo":926302009,
    "descripcion":"EPÍFISIS PEQUEÑA DE FALANGE DE DEDO DE PIE"
  },
  {
    "codigo":269107002,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN DE HOMBRO, POSTERIOR"
  },
  {
    "codigo":135531000119100,
    "descripcion":"INSUFICIENCIA DE ARTERIA TIBIAL POSTERIOR"
  },
  {
    "codigo":15628651000119100,
    "descripcion":"DISTROFIA PSEUDOINFLAMATORIA DE SORSBY DE FONDO DE OJO DERECHO"
  },
  {
    "codigo":286571000119101,
    "descripcion":"AUMENTO DE TRANSLUCIDEZ NUCAL DETECTADO POR SCREENING CON MÚLTIPLES MARCADORES"
  },
  {
    "codigo":345451000119103,
    "descripcion":"LUXACIÓN BILATERAL DE GLÁNDULAS LAGRIMALES"
  },
  {
    "codigo":1082731000119103,
    "descripcion":"ENTERITIS CAUSADA POR ASTROVIRUS"
  },
  {
    "codigo":15864171000119105,
    "descripcion":"ANOMALÍA CONGÉNITA DE OÍDO DERECHO"
  },
  {
    "codigo":11801451000119106,
    "descripcion":"LESIÓN TRAUMÁTICA DE RIÑÓN IZQUIERDO"
  },
  {
    "codigo":17771000119103,
    "descripcion":"MIELOMENINGOCELE LUMBAR BAJO"
  },
  {
    "codigo":117611000119108,
    "descripcion":"URGENCIA URINARIA DURANTE EMBARAZO"
  },
  {
    "codigo":307051000119109,
    "descripcion":"ARTRITIS ENTEROPÁTICA DE MANO"
  },
  {
    "codigo":267272006,
    "descripcion":"DEFECTOS DE COAGULACIÓN EN EL POSPARTO"
  },
  {
    "codigo":11773291000119107,
    "descripcion":"RUPTURA TRAUMÁTICA DE LIGAMENTO CUBITAL COLATERAL DE CODO DERECHO"
  },
  {
    "codigo":122731000119104,
    "descripcion":"CEFALEA EN TRUENO PRIMARIA"
  },
  {
    "codigo":298205001,
    "descripcion":"LAXITUD DE LA COLUMNA CERVICAL"
  },
  {
    "codigo":234504005,
    "descripcion":"BAZO POLIQUÍSTICO"
  },
  {
    "codigo":15638891000119106,
    "descripcion":"OSTEONECROSIS DE HUESO DE AMBAS CADERAS"
  },
  {
    "codigo":365576006,
    "descripcion":"ACONTECIMIENTOS FAMILIARES - HALLAZGO"
  },
  {
    "codigo":11842411000119108,
    "descripcion":"DISTENSIÓN DE TENDÓN DE PIE IZQUIERDO"
  },
  {
    "codigo":10948971000119109,
    "descripcion":"HERIDA PUNZANTE DE BRAZO DERECHO"
  },
  {
    "codigo":99131000119108,
    "descripcion":"ASTROCITOMA DE CEREBRO"
  },
  {
    "codigo":787890000,
    "descripcion":"STREPTOCOCCUS MITIS, STREPTOCOCCUS ORALIS O STREPTOCOCCUS PNEUMONIAE"
  },
  {
    "codigo":1344946001,
    "descripcion":"DELIRIO CAUSADO POR ABSTINENCIA DE COCAÍNA"
  },
  {
    "codigo":296370000,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE ANTICOLINESTERASA"
  },
  {
    "codigo":66994003,
    "descripcion":"INTOXICACIÓN POR PLATA"
  },
  {
    "codigo":165298000,
    "descripcion":"MEMORIA: NO RECUERDA EVENTOS IMPORTANTES"
  },
  {
    "codigo":198066009,
    "descripcion":"ESTENOSIS DE TÚNICA VAGINAL"
  },
  {
    "codigo":786055002,
    "descripcion":"OCLUSIÓN DE VENA CENTRAL DE LA RETINA DE OJO IZQUIERDO"
  },
  {
    "codigo":720519003,
    "descripcion":"SÍNDROME DE ATEROSCLEROSIS SORDERA, DIABETES, EPILEPSIA Y NEFROPATÍA"
  },
  {
    "codigo":294535001,
    "descripcion":"ALERGIA A CEFALEXINA"
  },
  {
    "codigo":425607009,
    "descripcion":"HEMANGIOENDOTELIOMA RETROPERITONEAL"
  },
  {
    "codigo":292700004,
    "descripcion":"REACCIÓN ADVERSA A RELAJANTE DEL MÚSCULO LISO"
  },
  {
    "codigo":30556007,
    "descripcion":"LUXACIÓN RECURRENTE DE REGIÓN DE HOMBRO"
  },
  {
    "codigo":127025000,
    "descripcion":"NEOPLASIA DE CONDUCTO CRANEOFARÍNGEO"
  },
  {
    "codigo":389169005,
    "descripcion":"SÍNDROME DE BRAQUIDACTILIA TIPO C"
  },
  {
    "codigo":94257006,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL CLÍTORIS"
  },
  {
    "codigo":290865009,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR IPRONIAZIDA"
  },
  {
    "codigo":289030003,
    "descripcion":"CAPAZ DE ALIMENTARSE CON LA MANO IZQUIERDA"
  },
  {
    "codigo":715014004,
    "descripcion":"NO CAMINA SOBRE UNA SUPERFICIE DESPAREJA"
  },
  {
    "codigo":1237467000,
    "descripcion":"METÁSTASIS DE CARCINOMA ESCAMOSO EN BRONQUIO DE LÓBULO SUPERIOR DERECHO"
  },
  {
    "codigo":92422009,
    "descripcion":"NEOPLASIA BENIGNA DE LAS GLÁNDULAS SUDORÍPARAS"
  },
  {
    "codigo":451035002,
    "descripcion":"HEMORRAGIA INTRACRANEAL SUBPIAL"
  },
  {
    "codigo":26886008,
    "descripcion":"PARA 6"
  },
  {
    "codigo":254427006,
    "descripcion":"CARCINOMA DE LA PORCIÓN ANTERIOR DEL PISO DE LA BOCA"
  },
  {
    "codigo":188891007,
    "descripcion":"NEOPLASIA BRONCOPULMONAR BENIGNA DE LÓBULO INFERIOR"
  },
  {
    "codigo":1137328006,
    "descripcion":"HIPOGLUCEMIA IATROGÉNICA"
  },
  {
    "codigo":283525002,
    "descripcion":"HERIDA PUNZANTE DE MAMA"
  },
  {
    "codigo":86917003,
    "descripcion":"TRANSMISIÓN DE PENSAMIENTO"
  },
  {
    "codigo":21381006,
    "descripcion":"NECROSIS GRASA DE LA MAMA"
  },
  {
    "codigo":742277008,
    "descripcion":"HERNIA FEMORAL RECURRENTE BILATERAL"
  },
  {
    "codigo":185221008,
    "descripcion":"ATENDIDA EN UN CONSULTORIO GINECOLÓGICO"
  },
  {
    "codigo":281690000,
    "descripcion":"MARCA DE IMPRESIÓN DE LA MANO"
  },
  {
    "codigo":871514003,
    "descripcion":"REACCIÓN ADVERSA A SUBNITRATO DE BISMUTO Y\/O YODOFORMO"
  },
  {
    "codigo":707674000,
    "descripcion":"NEOPLASIA EPITELIAL MALIGNA PRIMARIA DE TRÁQUEA"
  },
  {
    "codigo":1084681000119103,
    "descripcion":"DISFUNCIÓN DE AMBOS SISTEMAS VESTIBULARES"
  },
  {
    "codigo":609370009,
    "descripcion":"CALIFICACIÓN DEL COMPORTAMIENTO SEGÚN LA ESCALA DE FRANKL DEFINIDAMENTE NEGATIVA"
  },
  {
    "codigo":247087002,
    "descripcion":"INFILTRADO INFLAMATORIO DEL VÍTREO"
  },
  {
    "codigo":248922009,
    "descripcion":"CUELLO UTERINO PROLAPSADO HACIA LA VAGINA"
  },
  {
    "codigo":1197359006,
    "descripcion":"CÁNCER COLORRECTAL FAMILIAR TIPO X"
  },
  {
    "codigo":81412002,
    "descripcion":"CONTUSIÓN DE LA CORTEZA CEREBRAL CON HERIDA INTRACRANEAL ABIERTA Y PÉRDIDA DE LA CONSCIENCIA"
  },
  {
    "codigo":212484003,
    "descripcion":"LESIONES SUPERFICIALES MÚLTIPLES DEL CUELLO"
  },
  {
    "codigo":48644003,
    "descripcion":"ESTENOSIS HIPERTRÓFICA DEL PÍLORO CONGÉNITA"
  },
  {
    "codigo":347401000119106,
    "descripcion":"GLAUCOMA ABSOLUTO DE AMBOS OJOS"
  },
  {
    "codigo":704004009,
    "descripcion":"FRACTURA NO EXPUESTA DE CUARTO METACARPIANO"
  },
  {
    "codigo":210649003,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA A TRAVÉS DE ARTICULACIÓN DE HOMBRO"
  },
  {
    "codigo":472793004,
    "descripcion":"ESTENOSIS SUBAÓRTICA COMO COMPLICACIÓN DE PROCEDIMIENTO"
  },
  {
    "codigo":14041005,
    "descripcion":"APNEA POR DEGLUCIÓN"
  },
  {
    "codigo":1259225008,
    "descripcion":"FIBROSIS DE CUELLO DE VEJIGA URINARIA"
  },
  {
    "codigo":700334001,
    "descripcion":"LUPUS ERITEMATOSO DISCOIDE DE PÁRPADO SUPERIOR"
  },
  {
    "codigo":896942003,
    "descripcion":"FORMA DE BALA ANORMAL CONGÉNITA DE FALANGE PROXIMAL DE QUINTO DEDO DE PIE"
  },
  {
    "codigo":365064000,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA FINALIZAR UNA CONVERSACIÓN"
  },
  {
    "codigo":698499006,
    "descripcion":"LESIÓN TRAUMÁTICA DE COLUMNA VERTEBRAL DEBIDA A TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":403587007,
    "descripcion":"ADICCIÓN A LA EXPOSICIÓN SOLAR"
  },
  {
    "codigo":205144002,
    "descripcion":"SINDACTILIA SIMPLE DE DEDOS DEL PIE"
  },
  {
    "codigo":301613000,
    "descripcion":"INCAPAZ DE MANEJARSE EN ESCALONES"
  },
  {
    "codigo":170541005,
    "descripcion":"REQUIERE VACUNACIÓN CONTRA HEPATITIS A"
  },
  {
    "codigo":1153581007,
    "descripcion":"FORMACIÓN DE CÁLCULO DE MATRIZ DURANTE DIÁLISIS RENAL"
  },
  {
    "codigo":236077008,
    "descripcion":"DIARREA PROLONGADA"
  },
  {
    "codigo":234242000,
    "descripcion":"TROMBOSIS DEL BALÓN INTRAÓRTICO"
  },
  {
    "codigo":365314003,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD DE VENTILAR LA ROPA LAVADA"
  },
  {
    "codigo":299778006,
    "descripcion":"REACCIÓN DE PARACAÍDAS AUSENTE"
  },
  {
    "codigo":201474006,
    "descripcion":"ARTRITIS REACTIVA DE ARTICULACIÓN DE REGIÓN DE HOMBRO DEBIDA A ENFERMEDAD INFECCIOSA TRANSMITIDA POR VÍA SEXUAL Y POSTERIOR A ELLA"
  },
  {
    "codigo":232407000,
    "descripcion":"ESPASMO FARÍNGEO"
  },
  {
    "codigo":723927004,
    "descripcion":"TRASTORNO PSICÓTICO CAUSADO POR ALCOHOL CON SÍNTOMAS ESQUIZOFRENIFORMES"
  },
  {
    "codigo":130621000119105,
    "descripcion":"MUTILACIÓN GENITAL FEMENINA TIPO 2"
  },
  {
    "codigo":1196001,
    "descripcion":"TRASTORNO BIPOLAR II CRÓNICO, EPISODIO MÁS RECIENTE DE CARACTERÍSTICAS DEPRESIVAS PROFUNDAS"
  },
  {
    "codigo":230572002,
    "descripcion":"NEUROPATÍA DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":296108003,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE OXAZEPAM"
  },
  {
    "codigo":396247009,
    "descripcion":"MARGEN QUIRÚRGICO ENDOCERVICAL COMPROMETIDO POR NEOPLASIA MALIGNA, FOCAL"
  },
  {
    "codigo":427180006,
    "descripcion":"TRASTORNO DE LA CÓRNEA INDUCIDO POR FÁRMACOS"
  },
  {
    "codigo":722092008,
    "descripcion":"FILTRACIÓN POR EL MUÑÓN RECTAL"
  },
  {
    "codigo":294273003,
    "descripcion":"ALERGIA A PRALIDOXIMA"
  },
  {
    "codigo":292438001,
    "descripcion":"REACCIÓN ADVERSA AL PENBUTOLOL"
  },
  {
    "codigo":128598002,
    "descripcion":"TRASTORNO TEGUMENTARIO"
  },
  {
    "codigo":1144406001,
    "descripcion":"HIPOPLASIA CONGÉNITA DE UNIDAD UNGUEAL DE PULGAR"
  },
  {
    "codigo":194134005,
    "descripcion":"ESPASMO DE CONVERGENCIA"
  },
  {
    "codigo":1177174007,
    "descripcion":"INSUFICIENCIA RENAL AGUDA POSTERIOR A ADMINISTRACIÓN DE AGENTE DE CONTRASTE"
  },
  {
    "codigo":93995000,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA REGIÓN SACROCOCCÍGEA"
  },
  {
    "codigo":95830009,
    "descripcion":"INFARTO DE HIPÓFISIS"
  },
  {
    "codigo":290603002,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ETOGLÚCIDO"
  },
  {
    "codigo":126763008,
    "descripcion":"ANOMALÍA CONGÉNITA DEL PERINEO"
  },
  {
    "codigo":26624006,
    "descripcion":"ANODONCIA"
  },
  {
    "codigo":92160006,
    "descripcion":"NEOPLASIA BENIGNA DEL ISTMO UTERINO"
  },
  {
    "codigo":124928008,
    "descripcion":"PARCHE INMUNOLÓGICO"
  },
  {
    "codigo":90325002,
    "descripcion":"VÓMITOS EN EL EMBARAZO"
  },
  {
    "codigo":286933003,
    "descripcion":"ESTADO DE CONFUSIÓN"
  },
  {
    "codigo":57557005,
    "descripcion":"SÍNDROME LACTOALCALINO CRÓNICO"
  },
  {
    "codigo":24789006,
    "descripcion":"GASTROENTERITIS CAUSADA POR VIRUS SIMILAR AL AGENTE NORWALK"
  },
  {
    "codigo":677591000119108,
    "descripcion":"MICROANEURISMA DE AMBAS ARTERIAS RETINIANAS"
  },
  {
    "codigo":416170003,
    "descripcion":"RESONANCIA MAGNÉTICA DE COLUMNA VERTEBRAL LUMBAR: NORMAL"
  },
  {
    "codigo":840319006,
    "descripcion":"PARESTESIAS DE AMBAS MANOS"
  },
  {
    "codigo":707412000,
    "descripcion":"TROMBOEMBOLIA PULMONAR CRÓNICA"
  },
  {
    "codigo":283263009,
    "descripcion":"VIDRIO EN GLÚTEO"
  },
  {
    "codigo":119423009,
    "descripcion":"TERATOMA OVÁRICO BENIGNO"
  },
  {
    "codigo":19284003,
    "descripcion":"ABSCESO DE REGIÓN DORSAL EXCEPTO NALGA"
  },
  {
    "codigo":445268004,
    "descripcion":"VÉRTICE CARDÍACO POR DELANTE DE LA BASE CARDÍACA"
  },
  {
    "codigo":281428005,
    "descripcion":"INFECCIÓN EN LA REPARACIÓN DE TENDÓN"
  },
  {
    "codigo":1231700006,
    "descripcion":"ENDOFTALMITIS CAUSADA POR BACTERIA POSTERIOR A PROCEDIMIENTO QUIRÚRGICO"
  },
  {
    "codigo":771113001,
    "descripcion":"RETENCIÓN DE SODIO"
  },
  {
    "codigo":115753005,
    "descripcion":"FENOTIPO I>1<"
  },
  {
    "codigo":212222004,
    "descripcion":"LESIÓN DE RAÍZ DE NERVIO LUMBAR - L5"
  },
  {
    "codigo":310526005,
    "descripcion":"NEOPLASIA MALIGNA DE PARTES BLANDAS DE DORSO"
  },
  {
    "codigo":10946571000119103,
    "descripcion":"AVULSIÓN DE UNIDAD UNGUEAL DE DEDO MEÑIQUE IZQUIERDO"
  },
  {
    "codigo":275923005,
    "descripcion":"EVALUACIÓN DEL 8VO. MES ANORMAL - EN TRATAMIENTO"
  },
  {
    "codigo":110248002,
    "descripcion":"CONTUSIÓN DE LA REGIÓN PERIORAL DE LA CARA"
  },
  {
    "codigo":11944003,
    "descripcion":"NEUMOPATÍA DE LOS RECOGEDORES DE PLUMAS"
  },
  {
    "codigo":77480004,
    "descripcion":"ATRESIA BILIAR"
  },
  {
    "codigo":274088005,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LOCALIZACIÓN DESCONOCIDA"
  },
  {
    "codigo":208552007,
    "descripcion":"FRACTURA NO EXPUESTA DE FÉMUR PROXIMAL, INTERTROCANTÉREA, CONMINUTA"
  },
  {
    "codigo":306856009,
    "descripcion":"TROMBOSIS DE INJERTO-PUENTE DE LA BIFURCACIÓN AÓRTICA"
  },
  {
    "codigo":403325003,
    "descripcion":"ALOPECIA FIBROSANTE FRONTAL POSMENOPÁUSICA"
  },
  {
    "codigo":763773007,
    "descripcion":"SÍNDROME DE MACROCEFALIA Y RETRASO DEL DESARROLLO"
  },
  {
    "codigo":352421000119102,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE PIEL DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":170279001,
    "descripcion":"EXAMEN ANORMAL DE NIÑO DE 21 MESES DE EDAD - EN TRATAMIENTO"
  },
  {
    "codigo":235815001,
    "descripcion":"ROTACIÓN PATOLÓGICA DEL INTESTINO, TIPO IIC"
  },
  {
    "codigo":301351007,
    "descripcion":"HALLAZGO RELACIONADO CON LA HUMEDAD DE LABIO"
  },
  {
    "codigo":399655007,
    "descripcion":"EXTENSIÓN EXTRACAPSULAR DE TUMOR GANGLIONAR INDETERMINADO"
  },
  {
    "codigo":102908001,
    "descripcion":"HURGARSE LA NARIZ"
  },
  {
    "codigo":37372002,
    "descripcion":"HEMORRAGIA GASTROINTESTINAL SUPERIOR"
  },
  {
    "codigo":233980003,
    "descripcion":"ACODAMIENTO DE ARTERIA TRASPLANTADA"
  },
  {
    "codigo":299516004,
    "descripcion":"CRÉPITO AUDIBLE DE ARTICULACIÓN DEL PIE"
  },
  {
    "codigo":1217020002,
    "descripcion":"CARCINOMA SARCOMATOIDE UROTERIAL DE URÉTER"
  },
  {
    "codigo":35537000,
    "descripcion":"SIGNO DE LADIN"
  },
  {
    "codigo":365052008,
    "descripcion":"SIMETRÍA DEL POTENCIAL EVOCADO VISUAL - HALLAZGO"
  },
  {
    "codigo":80191000119101,
    "descripcion":"INFECCIÓN SINTOMÁTICA POR VIRUS DE LA INMUNODEFICIENCIA HUMANA I"
  },
  {
    "codigo":428753007,
    "descripcion":"GLIOMA DE CEREBELO DE BAJO GRADO"
  },
  {
    "codigo":723665008,
    "descripcion":"SANGRADO VAGINAL QUE COMPLICA EL COMIENZO DEL EMBARAZO"
  },
  {
    "codigo":232145009,
    "descripcion":"PARÁLISIS DE ACOMODACIÓN FARMACOLÓGICA"
  },
  {
    "codigo":263078002,
    "descripcion":"FRACTURA-LUXACIÓN DE ARTICULACIÓN DE CODO"
  },
  {
    "codigo":230310003,
    "descripcion":"DISTONÍA PAROXÍSTICA"
  },
  {
    "codigo":721830003,
    "descripcion":"INFECCIÓN CAUSADA POR TRICHINELLA"
  },
  {
    "codigo":787366006,
    "descripcion":"METABOLIZADOR NORMAL-LENTO DE LA FAMILIA 1 SUBFAMILIA A MIEMBRO 2 DEL CITOCROMO P450"
  },
  {
    "codigo":934007,
    "descripcion":"TALASEMIA INTERMEDIA"
  },
  {
    "codigo":294011003,
    "descripcion":"ALERGIA A FISOSTIGMINA"
  },
  {
    "codigo":392315004,
    "descripcion":"ESTRÍAS DE VOGT"
  },
  {
    "codigo":64635004,
    "descripcion":"NISTAGMO CONGÉNITO"
  },
  {
    "codigo":228475007,
    "descripcion":"BISEXUAL - PREDOMINANTEMENTE HOMOSEXUAL"
  },
  {
    "codigo":128336000,
    "descripcion":"ANOMALÍA CONGÉNITA DEL PALADAR"
  },
  {
    "codigo":292176000,
    "descripcion":"REACCIÓN ADVERSA A FÁRMACO ANESTÉSICO DE ACCIÓN LOCAL"
  },
  {
    "codigo":16054591000119105,
    "descripcion":"ESTRABISMO PARALÍTICO DE OJO DERECHO"
  },
  {
    "codigo":95568003,
    "descripcion":"TRASTORNO TUBULAR RENAL"
  },
  {
    "codigo":423248004,
    "descripcion":"CRESTA RETINIANA PERIFÉRICA DE TRACCIÓN ZONULAR"
  },
  {
    "codigo":161104007,
    "descripcion":"MIEMBRO DE LA ASOCIACIÓN DE MANÍACOS-DEPRESIVOS"
  },
  {
    "codigo":192037000,
    "descripcion":"ESTADO DE PÁNICO AGUDO POR REACCIÓN A ESTRÉS AGUDO"
  },
  {
    "codigo":783696009,
    "descripcion":"HIPERANDROGENISMO DEBIDO A DEFICIENCIA DE CORTISONA REDUCTASA"
  },
  {
    "codigo":93733004,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE BRONQUIO DEL LÓBULO SUPERIOR DERECHO DEL PULMÓN"
  },
  {
    "codigo":126501005,
    "descripcion":"NEOPLASIA DE LA PIEL DE LA OREJA"
  },
  {
    "codigo":386810004,
    "descripcion":"TRASTORNO FÓBICO"
  },
  {
    "codigo":91898005,
    "descripcion":"AUSENCIA CONGÉNITA DEL METACARPO"
  },
  {
    "codigo":712655005,
    "descripcion":"PARTO POR OPERACIÓN CESÁREA POR PRESENTACIÓN DE NALGAS COMPLETA"
  },
  {
    "codigo":253903007,
    "descripcion":"URETRA CORTA CONGÉNITA"
  },
  {
    "codigo":286671009,
    "descripcion":"IDEALIZACIÓN - MECANISMO DE DEFENSA PSICOLÓGICA"
  },
  {
    "codigo":1204175009,
    "descripcion":"ATEROSCLEROSIS DE ARTERIA CRURAL"
  },
  {
    "codigo":1236943009,
    "descripcion":"METÁSTASIS DE CARCINOMA EN SUPERFICIE VENTRAL DE DOS TERCIOS ANTERIORES DE LENGUA"
  },
  {
    "codigo":284836005,
    "descripcion":"SE LAVA LA BOCA"
  },
  {
    "codigo":1003897004,
    "descripcion":"DELECIÓN PROXIMAL DEL BRAZO LARGO DEL CROMOSOMA 7"
  },
  {
    "codigo":86393005,
    "descripcion":"DISTROFIA UNGULAR MEDIANA"
  },
  {
    "codigo":250233006,
    "descripcion":"INCLUSIÓN ERITROCÍTICA"
  },
  {
    "codigo":281166002,
    "descripcion":"ESTALLIDO DE BALÓN DE SONDA VESICAL DE AUTO-RETENCIÓN"
  },
  {
    "codigo":707150004,
    "descripcion":"PRURITO COLESTÁSICO"
  },
  {
    "codigo":248398006,
    "descripcion":"HUESO FACIAL - HALLAZGO"
  },
  {
    "codigo":445006008,
    "descripcion":"DISTONÍA FOCAL"
  },
  {
    "codigo":1264206009,
    "descripcion":"TRASTORNO NEONATAL CAUSADO POR CONSUMO MATERNO DE TABACO"
  },
  {
    "codigo":246563002,
    "descripcion":"DESCUIDO DE PARTE DEL CUERPO"
  },
  {
    "codigo":1196835000,
    "descripcion":"NEOPLASIA DE ESTROMA GASTROINTESTINAL BENIGNA DE INTESTINO DELGADO"
  },
  {
    "codigo":49955008,
    "descripcion":"PARA 3"
  },
  {
    "codigo":312099009,
    "descripcion":"INFECCIÓN GENITOURINARIA POR CHLAMYDIA"
  },
  {
    "codigo":277496004,
    "descripcion":"COMPRESIÓN DEL NERVIO AUDITIVO"
  },
  {
    "codigo":408568004,
    "descripcion":"TAC CEREBRAL - NORMAL"
  },
  {
    "codigo":310264008,
    "descripcion":"DIETA PARA PACIENTES INMUNOSUPRIMIDOS"
  },
  {
    "codigo":767181002,
    "descripcion":"GANGLIÓN DE TOBILLO Y PIE"
  },
  {
    "codigo":308429009,
    "descripcion":"SITUACIÓN DE CRIBADO PARA HIPERTENSIÓN"
  },
  {
    "codigo":898253009,
    "descripcion":"ANQUILOSIS CONGÉNITA DE ARTICULACIÓN INTERFALÁNGICA DE DEDO ÍNDICE"
  },
  {
    "codigo":372130007,
    "descripcion":"NEOPLASIA MALIGNA DE PIEL"
  },
  {
    "codigo":206455004,
    "descripcion":"ICTERICIA NEONATAL DEBIDA A SÍNDROME DE DUBIN-JOHNSON"
  },
  {
    "codigo":403063004,
    "descripcion":"ONICOMICOSIS CAUSADA POR TRICHOPHYTON TONSURANS VARIEDAD TONSURANS"
  },
  {
    "codigo":697975004,
    "descripcion":"DESGARRO RADIAL DE ANILLO FIBROSO DE DISCO INTERVERTEBRAL"
  },
  {
    "codigo":302924003,
    "descripcion":"HEMATOMA MAMARIO"
  },
  {
    "codigo":40780007,
    "descripcion":"INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA I"
  },
  {
    "codigo":204620007,
    "descripcion":"PALADAR DURO HENDIDO CON LABIO LEPORINO, BILATERAL"
  },
  {
    "codigo":1251361004,
    "descripcion":"DERMATITIS DE CONTACTO POR TEDANIA IGNIS"
  },
  {
    "codigo":202785005,
    "descripcion":"ESTENOSIS IATROGÉNICA DE CONDUCTO RAQUÍDEO DORSAL"
  },
  {
    "codigo":366625005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA MANTENER EL EQUILIBRIO AL SENTARSE"
  },
  {
    "codigo":364790000,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA RETENER ALIMENTOS EN LA BOCA"
  },
  {
    "codigo":299254000,
    "descripcion":"AMPLITUD DE EXTENSIÓN ACTIVA DE LA CADERA DISMINUIDA"
  },
  {
    "codigo":233718008,
    "descripcion":"ESCLEROSIS TUBEROSA PULMONAR"
  },
  {
    "codigo":37110009,
    "descripcion":"SECRECIÓN EXCESIVA DE LECHE"
  },
  {
    "codigo":788939003,
    "descripcion":"FRACTURA DE FALANGE DE DEDO ÍNDICE"
  },
  {
    "codigo":723403008,
    "descripcion":"SÍNDROME DE MICROBRAQUICEFALIA, PTOSIS Y FISURA DE LABIO"
  },
  {
    "codigo":426656000,
    "descripcion":"ASMA PERSISTENTE SEVERA"
  },
  {
    "codigo":231883009,
    "descripcion":"CUERPO EXTRAÑO EN LA PARED POSTERIOR DEL OJO"
  },
  {
    "codigo":1149387009,
    "descripcion":"SOBREDOSIS DE AGENTE QUELANTE"
  },
  {
    "codigo":361120000,
    "descripcion":"AMBLIOPÍA NUTRICIONAL"
  },
  {
    "codigo":301991000119105,
    "descripcion":"ESCOLIOSIS IDIOPÁTICA DEL ADOLESCENTE, COLUMNA CERVICAL"
  },
  {
    "codigo":295584000,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE PROXIMETACAÍNA"
  },
  {
    "codigo":262816000,
    "descripcion":"SECCIÓN DE VÍA BILIAR"
  },
  {
    "codigo":293749000,
    "descripcion":"ALERGIA A ETOGLÚCIDO"
  },
  {
    "codigo":721568009,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE PARAMETRIO"
  },
  {
    "codigo":719733009,
    "descripcion":"CAPAZ DE REALIZAR SECUENCIAS DE TAREAS Y ACTIVIDADES"
  },
  {
    "codigo":128074002,
    "descripcion":"TRASTORNO DEL HIMEN"
  },
  {
    "codigo":95306003,
    "descripcion":"PERFORACIÓN TRAUMÁTICA DE LA FARINGE"
  },
  {
    "codigo":717898002,
    "descripcion":"HIPOPARATIROIDISMO AISLADO HEREDITARIO DEBIDO A ALTERACIÓN DE LA SECRECIÓN DE HORMONA PARATIROIDEA"
  },
  {
    "codigo":816202006,
    "descripcion":"NEVO MELANOCÍTICO DE PIEL DE GENITALES EXTERNOS"
  },
  {
    "codigo":60703000,
    "descripcion":"NEUROPATÍA AXÓNICA"
  },
  {
    "codigo":290079000,
    "descripcion":"DOLOR GENERALIZADO A LA PALPACIÓN DE LA MAMA"
  },
  {
    "codigo":93471006,
    "descripcion":"HEMANGIOMA CUTÁNEO"
  },
  {
    "codigo":1142047007,
    "descripcion":"TRASTORNO DE TRANCE Y POSESIÓN"
  },
  {
    "codigo":58868000,
    "descripcion":"FIEBRE HEMORRÁGICA ARGENTINA"
  },
  {
    "codigo":716063008,
    "descripcion":"ENTEROCOLITIS NECROSANTE EN EL ADULTO"
  },
  {
    "codigo":124404001,
    "descripcion":"DEFICIENCIA DE COENZIMA - A - TRANSFERASA"
  },
  {
    "codigo":1240351006,
    "descripcion":"METÁSTASIS DE CARCINOMA DE ENCÍA INFERIOR"
  },
  {
    "codigo":288244006,
    "descripcion":"CONSOLIDACIÓN DEFECTUOSA DE FRACTURA DE BRAZO"
  },
  {
    "codigo":111681000119107,
    "descripcion":"INFECCIÓN ASOCIADA CON DISCO INTERVERTEBRAL PROTÉSICO"
  },
  {
    "codigo":253641003,
    "descripcion":"ESTENOSIS SUPRAVALVULAR AÓRTICA LOCALIZADA"
  },
  {
    "codigo":286409004,
    "descripcion":"NO HABLA INTELIGIBLEMENTE"
  },
  {
    "codigo":15676481000119107,
    "descripcion":"TENDINITIS BILATERAL DE TENDÓN FLEXOR DE LA MANO"
  },
  {
    "codigo":89801006,
    "descripcion":"LUXACIONES TRAUMÁTICAS NO EXPUESTAS MÚLTIPLES DE BRAZO"
  },
  {
    "codigo":186270000,
    "descripcion":"ENFERMEDAD DE ADDISON SECUNDARIA A TUBERCULOSIS SUPRARRENAL"
  },
  {
    "codigo":358518971000119106,
    "descripcion":"DISTENSIÓN DE MÚSCULO INTRÍNSECO DE DEDO ANULAR"
  },
  {
    "codigo":284574005,
    "descripcion":"CUERPO EXTRAÑO METÁLICO EN LA BOCA"
  },
  {
    "codigo":251806008,
    "descripcion":"GENITALES EN ESTADIO 1 DE TANNER"
  },
  {
    "codigo":448414008,
    "descripcion":"COMUNICACIÓN INTERAURICULAR RESTRICTIVA"
  },
  {
    "codigo":413811002,
    "descripcion":"DISFUNCIÓN DEL MOCO CERVICAL"
  },
  {
    "codigo":315507004,
    "descripcion":"NACIDO EN LA REPÚBLICA DE IRLANDA"
  },
  {
    "codigo":248136000,
    "descripcion":"AVERSIÓN A UNA BEBIDA EN PARTICULAR"
  },
  {
    "codigo":444744001,
    "descripcion":"SÍNDROME DEL MARTILLO HIPOTENAR"
  },
  {
    "codigo":84296002,
    "descripcion":"ATRESIA DEL INTESTINO DELGADO"
  },
  {
    "codigo":870728004,
    "descripcion":"EXANTEMA CAUSADO POR ECOVIRUS HUMANO 16"
  },
  {
    "codigo":1231176005,
    "descripcion":"FÍSTULA CONGÉNITA EN COMISURA DE LABIO"
  },
  {
    "codigo":279069000,
    "descripcion":"DOLOR MUSCULOESQUELÉTICO"
  },
  {
    "codigo":706888008,
    "descripcion":"ALERGIA A PROTEÍNA DE ROYA"
  },
  {
    "codigo":705053004,
    "descripcion":"DIFICULTAD PARA EL MANEJO DE DISPOSITIVO PARA INCONTINENCIA"
  },
  {
    "codigo":770589005,
    "descripcion":"DERMATITIS POR CONTACTO ALÉRGICA CAUSADA POR YODOPOVIDONA"
  },
  {
    "codigo":703218000,
    "descripcion":"SÍNDROME DE VASOCONSTRICCIÓN CEREBRAL"
  },
  {
    "codigo":111559003,
    "descripcion":"HIPOGLUCEMIA ESPONTÁNEA"
  },
  {
    "codigo":15951221000119104,
    "descripcion":"NEOPLASIA BENIGNA DE PIEL DE AMBAS MAMAS"
  },
  {
    "codigo":46023009,
    "descripcion":"PEDOFILIA, CON AMBOS SEXOS"
  },
  {
    "codigo":371868005,
    "descripcion":"HIPOCINESIA LEVE DE LA PARED CARDÍACA"
  },
  {
    "codigo":109724006,
    "descripcion":"HIPOPLASIA CORONOIDE MANDIBULAR BILATERAL"
  },
  {
    "codigo":240796008,
    "descripcion":"ESQUISTOSOMIASIS INTESTINAL"
  },
  {
    "codigo":208028009,
    "descripcion":"FRACTURA VERTEBRAL NO EXPUESTA CON LESIÓN COMPLETA DE MÉDULA ESPINAL DORSAL, D1-6"
  },
  {
    "codigo":9585003,
    "descripcion":"CICATRIZ RETINIANA POSTRAUMÁTICA"
  },
  {
    "codigo":238961003,
    "descripcion":"TRICOFOBIA"
  },
  {
    "codigo":402801005,
    "descripcion":"TRASTORNO NEONATAL DE LA GRASA SUBCUTÁNEA"
  },
  {
    "codigo":1287537009,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE PÁRPADO"
  },
  {
    "codigo":400966008,
    "descripcion":"ESTRABISMO PARALÍTICO MANIFIESTO"
  },
  {
    "codigo":73286009,
    "descripcion":"GLOMERULONEFRITIS ASOCIADA CON LUPUS ERITEMATOSO SISTÉMICO, CLASE I DE LA OMS"
  },
  {
    "codigo":399131003,
    "descripcion":"SANGRADO VAGINAL NO MENSTRUAL"
  },
  {
    "codigo":38683003,
    "descripcion":"ENTROPIÓN MECÁNICO"
  },
  {
    "codigo":366363005,
    "descripcion":"INGESTA DE POTASIO CON LA DIETA - HALLAZGO"
  },
  {
    "codigo":724976002,
    "descripcion":"DISTENSIÓN DE TENDÓN DE MÚSCULO EXTENSOR DE DEDO DE LA MANO A LA ALTURA DEL ANTEBRAZO"
  },
  {
    "codigo":16907791000119106,
    "descripcion":"NEVO DISPLÁSICO DE PIEL DE PÁRPADO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":167920009,
    "descripcion":"MÉDULA ÓSEA NORMOBLÁSTICA"
  },
  {
    "codigo":67781003,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DE GENITALES FEMENINOS"
  },
  {
    "codigo":297157005,
    "descripcion":"TROMBO DE VENA INTRACRANEAL"
  },
  {
    "codigo":2245007,
    "descripcion":"CUERPO EXTRAÑO EN LA NASOFARINGE"
  },
  {
    "codigo":295322000,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE MEDIO DE CONTRASTE RADIOGRÁFICO DIAGNÓSTICO"
  },
  {
    "codigo":723141009,
    "descripcion":"HEMORRAGIA INTRACRANEAL CONCOMITANTE CON HERIDA COMPLEJA DE CABEZA Y DEBIDA A ELLA"
  },
  {
    "codigo":262554006,
    "descripcion":"HERIDA SUPERFICIAL POR MORDEDURA DE MAMÍFERO"
  },
  {
    "codigo":459162006,
    "descripcion":"ABSCESO DE VÁLVULA AURICULOVENTRICULAR COMÚN"
  },
  {
    "codigo":426394008,
    "descripcion":"TENDINITIS CALCIFICANTE DEL TENDÓN DE AQUILES"
  },
  {
    "codigo":721306009,
    "descripcion":"LEUCEMIA MIELOIDE AGUDA Y SÍNDROME MIELODISPLÁSICO RELACIONADOS CON EL TRATAMIENTO"
  },
  {
    "codigo":719471002,
    "descripcion":"SÍNDROME CLEIDORRIZOMÉLICO"
  },
  {
    "codigo":1145455002,
    "descripcion":"APLASIA DE COLUMNA VERTEBRAL"
  },
  {
    "codigo":195183002,
    "descripcion":"OCLUSIÓN MÚLTIPLE Y BILATERAL DE ARTERIA PRECEREBRAL"
  },
  {
    "codigo":10737321000119104,
    "descripcion":"TERATOMA QUÍSTICO MADURO DEL OVARIO IZQUIERDO"
  },
  {
    "codigo":129647005,
    "descripcion":"HIPOGLOBULINEMIA"
  },
  {
    "codigo":293487007,
    "descripcion":"REACCIÓN ADVERSA A LA CLORTALIDONA"
  },
  {
    "codigo":783172000,
    "descripcion":"ROTACIÓN PÉLVICA"
  },
  {
    "codigo":160580001,
    "descripcion":"CONSUMO DE ALCOHOL DESCONOCIDO"
  },
  {
    "codigo":95044002,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE HUESO CORTO DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":62276003,
    "descripcion":"INTOXICACIÓN POR SUCCINIMIDA"
  },
  {
    "codigo":226116003,
    "descripcion":"DIETA HIPOTRIGLICERIDÉMICA"
  },
  {
    "codigo":715801001,
    "descripcion":"ENFERMEDAD DE CHARCOT-MARIE-TOOTH TIPO 4F"
  },
  {
    "codigo":291652009,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR MINOCICLINA"
  },
  {
    "codigo":289817003,
    "descripcion":"DOLOR DE CUELLO UTERINO"
  },
  {
    "codigo":349981000221100,
    "descripcion":"ENFERMEDAD DEL TABACO VERDE"
  },
  {
    "codigo":93209006,
    "descripcion":"MELANOMA MALIGNO DE LA PIEL PERIANAL"
  },
  {
    "codigo":27673007,
    "descripcion":"INVAGINACIÓN DE COLON"
  },
  {
    "codigo":224281008,
    "descripcion":"USUARIO TELEFÓNICO DISCAPACITADO"
  },
  {
    "codigo":58606001,
    "descripcion":"DEFICIENCIA INMUNOLÓGICA PRIMARIA"
  },
  {
    "codigo":124142001,
    "descripcion":"DEFICIENCIA DE MALATO OXIDASA"
  },
  {
    "codigo":91374005,
    "descripcion":"ÁNTRAX DE LA PIEL Y\/O DEL TEJIDO CELULAR SUBCUTÁNEO"
  },
  {
    "codigo":11775811000119103,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE CODO DERECHO"
  },
  {
    "codigo":713966008,
    "descripcion":"HEPATITIS VIRAL CRÓNICA DE TIPO B, OCULTA"
  },
  {
    "codigo":253379003,
    "descripcion":"VÁLVULA TRICÚSPIDE CABALGANTE"
  },
  {
    "codigo":24003004,
    "descripcion":"ATROFIA ÓPTICA POSTINFLAMATORIA"
  },
  {
    "codigo":56771006,
    "descripcion":"FUMADOR EMPEDERNIDO (MÁS DE 20 CIGARRILLOS POR DÍA)"
  },
  {
    "codigo":448152000,
    "descripcion":"DOSIS DE MEDICACIÓN DEMASIADO BAJA"
  },
  {
    "codigo":187843009,
    "descripcion":"NEOPLASIA MALIGNA DE CARTÍLAGO ARITENOIDES"
  },
  {
    "codigo":284312000,
    "descripcion":"CAPAZ DE MANIPULAR OBJETOS"
  },
  {
    "codigo":1300120005,
    "descripcion":"ENFERMEDAD INFLAMATORIA DEL INTESTINO RELACIONADA CON EL GEN DE FOSFATASA ALCALINA INTESTINAL"
  },
  {
    "codigo":251544007,
    "descripcion":"UNIDADES MOTORAS INESTABLES"
  },
  {
    "codigo":282477000,
    "descripcion":"NO CORRE"
  },
  {
    "codigo":1003373003,
    "descripcion":"MICROCEFALIA CON PATRÓN SIMPLIFICADO DE CIRCUNVOLUCIONES"
  },
  {
    "codigo":315245004,
    "descripcion":"DETERIORO DEL DESEMPEÑO ESCOLAR"
  },
  {
    "codigo":15927261000119101,
    "descripcion":"LESIÓN DE AMBOS PÁRPADOS"
  },
  {
    "codigo":184173007,
    "descripcion":"PACIENTE A QUIEN EL MÉDICO GENERAL LE COMUNICA ESTAR FUERA DEL REGISTRO"
  },
  {
    "codigo":870466000,
    "descripcion":"INGESTA INADECUADA DE VITAMINA A Y\/O DERIVADO DE VITAMINA A"
  },
  {
    "codigo":1260040005,
    "descripcion":"CARCINOMA ADENOESCAMOSO DE HIPOFARINGE"
  },
  {
    "codigo":247874009,
    "descripcion":"PENSAMIENTOS OBSESIVOS ACERCA DEL FUEGO"
  },
  {
    "codigo":1260012000,
    "descripcion":"FRACTURA DE RAÍZ DE DIENTE PERMANENTE INMADURO POSTERIOR A TRATAMIENTO DE CONDUCTO DE RAÍZ DENTAL DE DIENTE"
  },
  {
    "codigo":702956004,
    "descripcion":"ALTERACIÓN COGNITIVA SEVERA"
  },
  {
    "codigo":735724006,
    "descripcion":"ANOMALÍA DEL DESARROLLO DE RAÍZ DE DIENTE"
  },
  {
    "codigo":309740007,
    "descripcion":"AFTOSIS GENERALIZADA"
  },
  {
    "codigo":111297002,
    "descripcion":"ACCIDENTE CEREBROVASCULAR NO PARALÍTICO"
  },
  {
    "codigo":10657911000119101,
    "descripcion":"ÚLCERA NEUROPÁTICA DE DEDO DE PIE IZQUIERDO"
  },
  {
    "codigo":307905007,
    "descripcion":"ESTADO DE CERTIFICACIÓN PRIVADA"
  },
  {
    "codigo":95795006,
    "descripcion":"ESCLERITIS SUPERFICIAL"
  },
  {
    "codigo":209601008,
    "descripcion":"DESGARRO COMPLETO DE LIGAMENTO SEMILUNAR-PIRAMIDAL"
  },
  {
    "codigo":1290945007,
    "descripcion":"NEUROFIBROMA ATÍPICO"
  },
  {
    "codigo":568011000005108,
    "descripcion":"VALORACIÓN DE RIESGO PRENATAL DESEADA"
  },
  {
    "codigo":240534005,
    "descripcion":"VERRUGA EN LA MANO"
  },
  {
    "codigo":1354646005,
    "descripcion":"DISPLASIA ECTODÉRMICA ANHIDRÓTICA CON DEFICIENCIA INMUNITARIA DEBIDA A MUTACIÓN DE GANANCIA DE FUNCIÓN EN EL INHIBIDOR ALFA DEL FACTOR NUCLEAR KAPPA-B"
  },
  {
    "codigo":109462005,
    "descripcion":"DIENTE CON MÚLTIPLES RAÍCES DIVERGENTES"
  },
  {
    "codigo":304235000,
    "descripcion":"LESIÓN POR ELEMENTO PUNZANTE"
  },
  {
    "codigo":335991000119104,
    "descripcion":"CONJUNTIVITIS FOLICULAR CRÓNICA DE OJO DERECHO"
  },
  {
    "codigo":271467005,
    "descripcion":"NEOPLASIA MALIGNA DE HUESO, TEJIDO CONECTIVO, PIEL Y MAMA"
  },
  {
    "codigo":369771005,
    "descripcion":"PATRÓN DE GLEASON 2"
  },
  {
    "codigo":238699007,
    "descripcion":"HIPERPIGMENTACIÓN POSINFLAMATORIA"
  },
  {
    "codigo":402539008,
    "descripcion":"CARCINOMA BASOCELULAR RECURRENTE LUEGO DE RESECCIÓN"
  },
  {
    "codigo":171328004,
    "descripcion":"CRIBADO EN PACIENTE NUEVO - PROBLEMA IDENTIFICADO"
  },
  {
    "codigo":366101001,
    "descripcion":"ATENCIÓN PARA DIRIGIR LA COMUNICACIÓN VERBAL - HALLAZGO"
  },
  {
    "codigo":300565003,
    "descripcion":"HALLAZGO RELACIONADO CON LA SENSIBILIDAD DEL BAZO"
  },
  {
    "codigo":890389003,
    "descripcion":"ESTENOSIS TRAQUEOBRONQUIAL CONGÉNITA"
  },
  {
    "codigo":235029004,
    "descripcion":"LEUCOPLASIA BUCAL MOTEADA"
  },
  {
    "codigo":133978931000132109,
    "descripcion":"COLANGIOPANCREATOGRAFÍA RETRÓGRADA ENDOSCÓPICA NORMAL"
  },
  {
    "codigo":145681000119101,
    "descripcion":"INSUFICIENCIA RENAL AGUDA DEBIDA A NECROSIS TUBULAR"
  },
  {
    "codigo":309521000119102,
    "descripcion":"NECROSIS AVASCULAR DE HUESO DE PIE IZQUIERDO"
  },
  {
    "codigo":10959121000119102,
    "descripcion":"HERIDA ABIERTA DE BRAZO DERECHO DEBIDA A MORDEDURA HUMANA"
  },
  {
    "codigo":823018004,
    "descripcion":"PARESIA MUSCULAR DEBIDA A BLOQUEO NEUROMUSCULAR Y POSTERIOR A ÉL"
  },
  {
    "codigo":1073271000119109,
    "descripcion":"ARTRITIS DE MUÑECA IZQUIERDA CAUSADA POR BACTERIAS"
  },
  {
    "codigo":200426004,
    "descripcion":"LISTERIOSIS INFANTIL DISEMINADA"
  },
  {
    "codigo":1148863007,
    "descripcion":"TRASTORNO DE PIEL DEBIDO A INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":1279935007,
    "descripcion":"VÍCTIMA DE ABUSO EMOCIONAL DURANTE LA INFANCIA"
  },
  {
    "codigo":295060001,
    "descripcion":"ALERGIA A ENOXIMONA"
  },
  {
    "codigo":722879009,
    "descripcion":"METEORISMO FUNCIONAL"
  },
  {
    "codigo":427967009,
    "descripcion":"ARTROPATÍA EN EL SÍNDROME DE BEHCET DE LA COLUMNA VERTEBRAL"
  },
  {
    "codigo":32916005,
    "descripcion":"NEFROSCLEROSIS"
  },
  {
    "codigo":719209002,
    "descripcion":"ATAXIA ESPINOCEREBELOSA TIPO 13"
  },
  {
    "codigo":293225004,
    "descripcion":"REACCIÓN ADVERSA AL DANAZOL"
  },
  {
    "codigo":62014003,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR FÁRMACO"
  },
  {
    "codigo":1208894005,
    "descripcion":"RUPTURA DE AISLAMIENTO AURICULAR DE DESFIBRILADOR CARDIOVERSOR IMPLANTABLE"
  },
  {
    "codigo":94782007,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA COLA DE CABALLO"
  },
  {
    "codigo":289555000,
    "descripcion":"SECRECIÓN VAGINAL VERDE"
  },
  {
    "codigo":92947001,
    "descripcion":"FORMA ANORMAL CONGÉNITA DE HUESO ESCAMOSO"
  },
  {
    "codigo":782910009,
    "descripcion":"DERMATITIS SEMEJANTE A LA SEBORREA CON ELEMENTOS PSORIASIFORMES"
  },
  {
    "codigo":1010451003,
    "descripcion":"PREFERENCIA DE FIJACIÓN OCULAR DE OJO IZQUIERDO"
  },
  {
    "codigo":43691000087100,
    "descripcion":"CORTE EN CADERA IZQUIERDA"
  },
  {
    "codigo":60179005,
    "descripcion":"INTOXICACIÓN POR CLORATO DE SODIO"
  },
  {
    "codigo":191251007,
    "descripcion":"ANEMIA HIPOPLÁSICA TRANSITORIA"
  },
  {
    "codigo":189416000,
    "descripcion":"NEOPLASIA DEL CARTÍLAGO CUNEIFORME DE COMPORTAMIENTO INCIERTO"
  },
  {
    "codigo":46251000087104,
    "descripcion":"FRACTURA DE FALANGE DE SEGUNDO DEDO DE PIE DERECHO"
  },
  {
    "codigo":41131000087105,
    "descripcion":"CELULITIS DE SEGUNDO DEDO DE PIE IZQUIERDO"
  },
  {
    "codigo":1172456003,
    "descripcion":"CAPAZ DE MODIFICAR LA CONDUCTA Y EL ESTILO DE VIDA PARA PROMOVER UN CAMBIO EN LAS CIRCUNSTANCIAS"
  },
  {
    "codigo":713704004,
    "descripcion":"GASTROPARESIA DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":123880007,
    "descripcion":"INTOXICACIÓN POR LILIACEAE"
  },
  {
    "codigo":253117002,
    "descripcion":"ESPINA BÍFIDA NO EXPUESTA CON MALFORMACIÓN DE ARNOLD-CHIARI"
  },
  {
    "codigo":23741005,
    "descripcion":"FRACTURA EXPUESTA DE DIÁFISIS DE HÚMERO"
  },
  {
    "codigo":56509006,
    "descripcion":"DISFONÍA ESPÁSTICA DE TIPO ADUCTOR EN EL TEMBLOR ORGÁNICO DE LA VOZ"
  },
  {
    "codigo":449725006,
    "descripcion":"ASTIGMATISMO MIXTO"
  },
  {
    "codigo":21906008,
    "descripcion":"HALLAZGO RELACIONADO CON FRÉMITO VOCAL"
  },
  {
    "codigo":87442008,
    "descripcion":"PERICARDITIS SECUNDARIA A ESCLERODERMIA"
  },
  {
    "codigo":216679000,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR GASOLINA"
  },
  {
    "codigo":85607003,
    "descripcion":"MORFOLOGÍA DESCONOCIDA"
  },
  {
    "codigo":314983004,
    "descripcion":"DETERIORO DE LA FUNCIÓN RENAL"
  },
  {
    "codigo":282215004,
    "descripcion":"CAPAZ DE COMENZAR A CAMINAR Y DETENERSE ESPONTÁNEAMENTE"
  },
  {
    "codigo":413287003,
    "descripcion":"MÁS DE 3 CAMBIOS DE DOMICILIO EN 12 MESES"
  },
  {
    "codigo":773735007,
    "descripcion":"SÍNDROME DE SORDERA CON ONICODISTROFIA"
  },
  {
    "codigo":247612003,
    "descripcion":"NO PUEDE RECORDAR LOS NOMBRES DE LOS ALLEGADOS MÁS ÍNTIMOS"
  },
  {
    "codigo":313148005,
    "descripcion":"ATENDIDO EN UN CONSULTORIO VASCULAR"
  },
  {
    "codigo":51004007,
    "descripcion":"HERNIACIÓN DEBAJO DE LA HOZ CEREBRAL"
  },
  {
    "codigo":409617000,
    "descripcion":"INTOXICACIÓN POR RICINA"
  },
  {
    "codigo":278545001,
    "descripcion":"HALLAZGO DE RESTAURACIÓN DENTAL"
  },
  {
    "codigo":737297006,
    "descripcion":"HÍGADO TRASPLANTADO PRESENTE"
  },
  {
    "codigo":1163281008,
    "descripcion":"DIÁLOGO INTERNO NEGATIVO ACERCA DE LOS ALIMENTOS Y\/O LA NUTRICIÓN"
  },
  {
    "codigo":276710001,
    "descripcion":"FONTANELA PEQUEÑA"
  },
  {
    "codigo":338501000119109,
    "descripcion":"ATROFIA ÓPTICA PRIMARIA DE OJO IZQUIERDO"
  },
  {
    "codigo":735462005,
    "descripcion":"OSIFICACIÓN DE LA TRÁQUEA"
  },
  {
    "codigo":1259750007,
    "descripcion":"ASTROCITOMA PRIMARIO DE TELENCÉFALO"
  },
  {
    "codigo":78267003,
    "descripcion":"PATRÓN DE USO NOCIVO DE COCAÍNA"
  },
  {
    "codigo":405947006,
    "descripcion":"RIGIDEZ DE NUCA"
  },
  {
    "codigo":733627006,
    "descripcion":"LINFOMA PRIMARIO CUTÁNEO DE LINFOCITOS T GAMMA-DELTA-POSITIVOS"
  },
  {
    "codigo":240272004,
    "descripcion":"INFECCIÓN DE HUESO ASOCIADA CON DISPOSITIVO DE FIJACIÓN ÓSEA"
  },
  {
    "codigo":43664005,
    "descripcion":"PESO NORMAL"
  },
  {
    "codigo":1256080008,
    "descripcion":"HIPERTROFIA UNGUEAL PSORIÁSICA"
  },
  {
    "codigo":895632009,
    "descripcion":"FORMA TRIANGULAR ANORMAL CONGÉNITA DE FALANGE MEDIA DE PIE"
  },
  {
    "codigo":305808009,
    "descripcion":"ATENDIDO POR SERVICIO DE FARMACOLOGÍA CLÍNICA"
  },
  {
    "codigo":404112009,
    "descripcion":"MICOSIS FUNGOIDE GRANULOMATOSA"
  },
  {
    "codigo":369509005,
    "descripcion":"TUMOR MALIGNO QUE COMPROMETE LA VULVA POR PROPAGACIÓN DIRECTA DEL OVARIO"
  },
  {
    "codigo":41829006,
    "descripcion":"DIETA"
  },
  {
    "codigo":762725007,
    "descripcion":"INFECCIÓN CONGÉNITA CAUSADA POR VIRUS ZIKA"
  },
  {
    "codigo":15686521000119102,
    "descripcion":"SINOVITIS TRANSITORIA DE RODILLA DERECHA"
  },
  {
    "codigo":105530003,
    "descripcion":"VIVIR EN UNA PENSIÓN"
  },
  {
    "codigo":236602004,
    "descripcion":"ESTRECHAMIENTO DE URÉTER DEBIDO A TUBERCULOSIS"
  },
  {
    "codigo":1186874005,
    "descripcion":"MIELOPATÍA POR EXCESO DE ZINC"
  },
  {
    "codigo":7226007,
    "descripcion":"PÚRPURA ASOCIADA CON INFECCIÓN"
  },
  {
    "codigo":365839002,
    "descripcion":"PRUEBA SOBRE APARATO LOCOMOTOR-HALLAZGO"
  },
  {
    "codigo":201999003,
    "descripcion":"ARTROPATÍA TRANSITORIA DE LA ARTICULACIÓN ACROMIOCLAVICULAR"
  },
  {
    "codigo":890127007,
    "descripcion":"SÍNDROME DE DELECIÓN 7P21.1"
  },
  {
    "codigo":724452000,
    "descripcion":"TEMOR A LA DISFUNCIÓN SEXUAL"
  },
  {
    "codigo":300303009,
    "descripcion":"ASPIRADO GÁSTRICO CON CONTENIDO DE ALIMENTO NO DIGERIDO"
  },
  {
    "codigo":298468004,
    "descripcion":"AMPLITUD DE ROTACIÓN PASIVA HACIA LA IZQUIERDA DE LA COLUMNA CERVICAL NORMAL"
  },
  {
    "codigo":396772005,
    "descripcion":"CORDÓN ESPERMÁTICO COMPROMETIDO POR EXTENSIÓN DIRECTA DE NEOPLASIA MALIGNA"
  },
  {
    "codigo":200164009,
    "descripcion":"AGOTAMIENTO MATERNO DURANTE EL TRABAJO DE PARTO"
  },
  {
    "codigo":722617004,
    "descripcion":"MÚLTIPLES LESIONES FOCALES DE CEREBRO"
  },
  {
    "codigo":1148601009,
    "descripcion":"CAPAZ DE PROGRESAR"
  },
  {
    "codigo":130958001,
    "descripcion":"TRASTORNO DE LA FUNCIÓN CIRCULATORIA DE LA PLACENTA"
  },
  {
    "codigo":294798003,
    "descripcion":"ALERGIA A CLOMIFENO"
  },
  {
    "codigo":1279673009,
    "descripcion":"INFECCIÓN CAUSADA POR BORRELIA LATYSCHEWII"
  },
  {
    "codigo":161891005,
    "descripcion":"DOLOR DE ESPALDA"
  },
  {
    "codigo":1144931006,
    "descripcion":"SÍNDROME DE SOLAPAMIENTO DE DERMATOMIOSITIS"
  },
  {
    "codigo":30819006,
    "descripcion":"ÁNIMO DISFÓRICO"
  },
  {
    "codigo":292963007,
    "descripcion":"REACCIÓN ADVERSA A LA CLOXACILINA"
  },
  {
    "codigo":225592001,
    "descripcion":"HALLAZGO RELACIONADO CON EL COLOR DE LA MATERIA FECAL"
  },
  {
    "codigo":291128003,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR LOXAPINA"
  },
  {
    "codigo":94520004,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LOS GANGLIOS LINFÁTICOS RETROFARÍNGEOS"
  },
  {
    "codigo":127288006,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA MEDIAL DE ARTICULACIÓN SUBASTRAGALINA"
  },
  {
    "codigo":92685001,
    "descripcion":"CARCINOMA IN SITU DE LA PLEURA"
  },
  {
    "codigo":2051000124106,
    "descripcion":"DERIVADO POR ASISTENTE DE MÉDICO"
  },
  {
    "codigo":289293006,
    "descripcion":"LÍQUIDO AMNIÓTICO POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":341011000119108,
    "descripcion":"ATROFIA SECUNDARIA DIFUSA DE COROIDES DE OJO IZQUIERDO"
  },
  {
    "codigo":254690006,
    "descripcion":"QUISTE MUCOSO DEL PENE"
  },
  {
    "codigo":285623001,
    "descripcion":"NO ADMINISTRA EL TIEMPO"
  },
  {
    "codigo":123618009,
    "descripcion":"FRACTURA NO EXPUESTA DE COLLES INVERTIDA"
  },
  {
    "codigo":1170359003,
    "descripcion":"GANGRENA DE ÍLEON TERMINAL"
  },
  {
    "codigo":283788000,
    "descripcion":"HERIDA POR MORDEDURA DE ARDILLA"
  },
  {
    "codigo":414860000,
    "descripcion":"SIN EFECTOS SECUNDARIOS DE FÁRMACO ANTIEPILÉPTICO"
  },
  {
    "codigo":218252002,
    "descripcion":"EFECTO TARDÍO DE ACCIDENTE PROVOCADO POR FACTORES NATURALES Y AMBIENTALES"
  },
  {
    "codigo":871777003,
    "descripcion":"REACCIÓN ADVERSA A CUMARINA"
  },
  {
    "codigo":85345005,
    "descripcion":"ESPESOR AUMENTADO DE LA PIEL"
  },
  {
    "codigo":247350000,
    "descripcion":"DOLOR DE PEZÓN"
  },
  {
    "codigo":17974002,
    "descripcion":"NEURALGIA DEL TRIGÉMINO POSTHERPÉTICA"
  },
  {
    "codigo":14304000,
    "descripcion":"TRASTORNO DE LA GLÁNDULA TIROIDES"
  },
  {
    "codigo":1163019009,
    "descripcion":"BOCIO ENDÉMICO DIFUSO"
  },
  {
    "codigo":735200002,
    "descripcion":"AUSENCIA DE MIEMBRO INFERIOR DEBIDA A DIABETES"
  },
  {
    "codigo":276448005,
    "descripcion":"ANEMIA SIDEROBLÁSTICA IDIOPÁTICA"
  },
  {
    "codigo":702432006,
    "descripcion":"HERNIA DIAFRAGMÁTICA, CARA ANORMAL Y ANOMALÍAS DISTALES DE MIEMBROS"
  },
  {
    "codigo":79840007,
    "descripcion":"MELASMA IDIOPÁTICO"
  },
  {
    "codigo":473056008,
    "descripcion":"INFECCIÓN ASOCIADA CON DISPOSITIVO UROGENITAL"
  },
  {
    "codigo":210912006,
    "descripcion":"LESIÓN EXPUESTA, ARTERIA PEDIA DORSAL"
  },
  {
    "codigo":45237002,
    "descripcion":"DILATACIÓN CONGÉNITA DE LA AORTA"
  },
  {
    "codigo":407520008,
    "descripcion":"ENFERMEDAD CAUSADA POR BETARETROVIRUS"
  },
  {
    "codigo":1357792009,
    "descripcion":"MUTACIÓN DE GEN HOMÓLOGO DE FOSFATASA Y TENSINA DETECTADA"
  },
  {
    "codigo":209077005,
    "descripcion":"LUXACIÓN VERTEBRAL NO EXPUESTA CON LESIÓN MEDULAR COMPLETA A NIVEL DORSAL"
  },
  {
    "codigo":241845006,
    "descripcion":"EFECTO TÓXICO CAUSADO POR LIMPIAHORNOS"
  },
  {
    "codigo":274613006,
    "descripcion":"RIÑONES NO PALPABLES"
  },
  {
    "codigo":240010005,
    "descripcion":"LESIÓN DE PARTES BLANDAS DE PIERNA Y TOBILLO"
  },
  {
    "codigo":403850006,
    "descripcion":"TRAUMATISMO CUTÁNEO IATROGÉNICO NEONATAL"
  },
  {
    "codigo":762463000,
    "descripcion":"HIPERTENSIÓN DIASTÓLICA CONCOMITANTE CON HIPERTENSIÓN SISTÓLICA"
  },
  {
    "codigo":371082009,
    "descripcion":"ARTRITIS DE COLUMNA VERTEBRAL"
  },
  {
    "codigo":305546009,
    "descripcion":"BAJO ATENCIÓN DE CIRUJANO ORTOPÉDICO"
  },
  {
    "codigo":8799007,
    "descripcion":"DOLOR DEL TALÓN POSTERIOR"
  },
  {
    "codigo":39732003,
    "descripcion":"SIGNOS ELECTROCARDIOGRÁFICOS DE DESVIACIÓN DEL EJE HACIA LA IZQUIERDA"
  },
  {
    "codigo":1186612004,
    "descripcion":"CARCINOMA HEPATOCELULAR METASTÁSICO"
  },
  {
    "codigo":15744481000119106,
    "descripcion":"DEFORMIDAD DE AMBAS MUÑECAS DEBIDA A ARTRITIS REUMATOIDE"
  },
  {
    "codigo":493721211000119100,
    "descripcion":"ESPONDILOARTRITIS AXIAL NO RADIOGRÁFICA DE REGIÓN LUMBOSACRA"
  },
  {
    "codigo":6964007,
    "descripcion":"AMPOLLA DE MAMA, CON INFECCIÓN"
  },
  {
    "codigo":72500007,
    "descripcion":"VARIACIÓN NORMAL EN LA CONSISTENCIA"
  },
  {
    "codigo":269108007,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN DE HOMBRO, INFERIOR (INFRAGLENOIDEA)"
  },
  {
    "codigo":365577002,
    "descripcion":"HALLAZGO EN LAS PREFERENCIAS RELIGIOSAS"
  },
  {
    "codigo":203572004,
    "descripcion":"PIE EQUINOVARO ADQUIRIDO - TALIPES"
  },
  {
    "codigo":234505006,
    "descripcion":"SEUDOQUISTE ESPLÉNICO"
  },
  {
    "codigo":298206000,
    "descripcion":"LAXITUD DE LA COLUMNA LUMBAR"
  },
  {
    "codigo":787891001,
    "descripcion":"STREPTOCOCCUS ACIDOMINIMUS O STREPTOCOCCUS PNEUMONIAE"
  },
  {
    "codigo":16371781000119100,
    "descripcion":"ACCIDENTE VASCULAR CEREBELOSO"
  },
  {
    "codigo":581000119100,
    "descripcion":"USUARIO DE METOTREXATO POR UN PERÍODO PROLONGADO"
  },
  {
    "codigo":307781000119100,
    "descripcion":"DISPLASIA FIBROSA MONOSTÓTICA DE HÚMERO DERECHO"
  },
  {
    "codigo":292421000119103,
    "descripcion":"INFLAMACIÓN DE NERVIO PERIFÉRICO DE TOBILLO DERECHO"
  },
  {
    "codigo":1091141000119103,
    "descripcion":"OTITIS MEDIA CRÓNICA DEL OÍDO DERECHO LUEGO DE LA INSERCIÓN DE DISPOSITIVO DE VENTILACIÓN TIMPÁNICA"
  },
  {
    "codigo":294981000119103,
    "descripcion":"OSTEOMIELITIS DE PIE"
  },
  {
    "codigo":10760261000119106,
    "descripcion":"LACERACIÓN DEL ÚTERO DURANTE EL PARTO"
  },
  {
    "codigo":674814021000119106,
    "descripcion":"SÍNDROME DE DISTRÉS RESPIRATORIO AGUDO DEBIDO A COVID-19"
  },
  {
    "codigo":302661000119103,
    "descripcion":"SÍNDROME DE COMPRESIÓN DE ARTERIA RAQUÍDEA ANTERIOR DE MÉDULA ESPINAL CERVICAL"
  },
  {
    "codigo":341061000119106,
    "descripcion":"DERMATOCALASIA DE PÁRPADO IZQUIERDO"
  },
  {
    "codigo":11858501000119106,
    "descripcion":"LESIÓN TRAUMÁTICA DE ARTERIA TIBIAL POSTERIOR IZQUIERDA"
  },
  {
    "codigo":11812421000119108,
    "descripcion":"LESIÓN TRAUMÁTICA PRIMARIA DE COLON SIGMOIDE POR EXPLOSIÓN"
  },
  {
    "codigo":292701000,
    "descripcion":"REACCIÓN ADVERSA A LA PAPAVERINA"
  },
  {
    "codigo":1080901000119107,
    "descripcion":"MELANOMA IN SITU DE EXTREMIDAD SUPERIOR IZQUIERDA"
  },
  {
    "codigo":15931461000119106,
    "descripcion":"QUISTE FOLICULAR DE OVARIO DERECHO"
  },
  {
    "codigo":120901000119108,
    "descripcion":"INSUFICIENCIA CARDÍACA DIASTÓLICA, ESTADIO B"
  },
  {
    "codigo":32392003,
    "descripcion":"OSTEOMIELITIS AGUDA DE LA MANDÍBULA"
  },
  {
    "codigo":15954501000119108,
    "descripcion":"CICATRIZ RADIAL DE MAMA DERECHA"
  },
  {
    "codigo":718685006,
    "descripcion":"HIPOTENSIÓN ORTOSTÁTICA CONCOMITANTE CON ENFERMEDAD DE PARKINSON Y DEBIDA A ELLA"
  },
  {
    "codigo":63325007,
    "descripcion":"AGREGACIÓN MOLECULAR"
  },
  {
    "codigo":720520009,
    "descripcion":"SÍNDROME DE CHÉDIAK-HIGASHI ATENUADO"
  },
  {
    "codigo":61490001,
    "descripcion":"ANGINA DE PECHO, CLASE I"
  },
  {
    "codigo":94258001,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL CUERPO COCCÍGEO"
  },
  {
    "codigo":127026004,
    "descripcion":"NEOPLASIA DE LA GLÁNDULA PINEAL"
  },
  {
    "codigo":290866005,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR IPRONIAZIDA"
  },
  {
    "codigo":389170006,
    "descripcion":"OSTEODISPLASIA PRECOZ"
  },
  {
    "codigo":192562009,
    "descripcion":"TRASTORNO DEL DESARROLLO PSICOLÓGICO"
  },
  {
    "codigo":59655002,
    "descripcion":"HIPERPROLINEMIA"
  },
  {
    "codigo":715015003,
    "descripcion":"DIFICULTAD PARA CAMINAR SOBRE UNA SUPERFICIE DESPAREJA"
  },
  {
    "codigo":92423004,
    "descripcion":"NEOPLASIA BENIGNA DE LA COLA DEL PÁNCREAS"
  },
  {
    "codigo":289031004,
    "descripcion":"INCAPAZ DE ALIMENTARSE CON LA MANO IZQUIERDA"
  },
  {
    "codigo":420103007,
    "descripcion":"OJO LLOROSO"
  },
  {
    "codigo":451036001,
    "descripcion":"HEMORRAGIA EN ESPACIO SUBPIAL DE MÉDULA ESPINAL"
  },
  {
    "codigo":713180002,
    "descripcion":"GASTROENTERITIS ISQUÉMICA"
  },
  {
    "codigo":254428001,
    "descripcion":"CARCINOMA IN SITU DE PISO DE LA BOCA: REGIÓN ANTERIOR"
  },
  {
    "codigo":1237468005,
    "descripcion":"DERMATITIS IRRITATIVA POR CONTACTO DE MANO CAUSADA POR ACEITE AUTOMOTRIZ"
  },
  {
    "codigo":10749871000119100,
    "descripcion":"ENFERMEDAD NEOPLÁSICA MALIGNA EN EL EMBARAZO"
  },
  {
    "codigo":55985003,
    "descripcion":"REACCIÓN ATÓPICA"
  },
  {
    "codigo":1083311000119101,
    "descripcion":"INFLAMACIÓN CRÓNICA DE AMBAS CAVIDADES MASTOIDEAS"
  },
  {
    "codigo":285361005,
    "descripcion":"AMPOLLA DE SANGRE EN CAVIDAD BUCAL"
  },
  {
    "codigo":185222001,
    "descripcion":"ATENDIDO EN UN CONSULTORIO OFTALMOLÓGICO"
  },
  {
    "codigo":283526001,
    "descripcion":"HERIDA PUNZANTE DE ABDOMEN"
  },
  {
    "codigo":21382004,
    "descripcion":"ÁNTRAX DE LA CADERA"
  },
  {
    "codigo":15992751000119103,
    "descripcion":"EPISCLERITIS DE OJO IZQUIERDO CAUSADA POR MYCOBACTERIUM TUBERCULOSIS"
  },
  {
    "codigo":54150009,
    "descripcion":"INFECCIÓN DE VÍAS RESPIRATORIAS SUPERIORES"
  },
  {
    "codigo":871515002,
    "descripcion":"REACCIÓN ADVERSA A CIPROTERONA Y\/O ETINILESTRADIOL"
  },
  {
    "codigo":773211003,
    "descripcion":"HIPERMOVILIDAD DE COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":19547001,
    "descripcion":"INTOXICACIÓN ALIMENTARIA CAUSADA POR ESTREPTOCOCOS"
  },
  {
    "codigo":85083002,
    "descripcion":"LARINGITIS ESTREPTOCÓCICA"
  },
  {
    "codigo":609371008,
    "descripcion":"ESCALA DE CALIFICACIÓN DEL COMPORTAMIENTO DE FRANKL NEGATIVA"
  },
  {
    "codigo":1197360001,
    "descripcion":"PROTOPORFIRIA ERITROPOYÉTICA LIGADA AL CROMOSOMA X"
  },
  {
    "codigo":212485002,
    "descripcion":"LESIONES ABIERTAS MÚLTIPLES DEL CUELLO"
  },
  {
    "codigo":310789003,
    "descripcion":"TRASTORNO DEL APARATO GENITAL FEMENINO"
  },
  {
    "codigo":704005005,
    "descripcion":"FRACTURA NO EXPUESTA DE MANO"
  },
  {
    "codigo":278021008,
    "descripcion":"INYECCIÓN DE LA CONJUNTIVA BULBAR EXPUESTA"
  },
  {
    "codigo":15877009,
    "descripcion":"HIPERBILIRRUBINEMIA NO CONJUGADA PREMENSTRUAL CÍCLICA"
  },
  {
    "codigo":210650003,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA POR ARRIBA DE CODO"
  },
  {
    "codigo":346031000119109,
    "descripcion":"CORIORRETINITIS FOCAL BILATERAL"
  },
  {
    "codigo":472794005,
    "descripcion":"ESTENOSIS SUBAÓRTICA ADQUIRIDA ASOCIADA CON CORAZÓN FUNCIONALMENTE UNIVENTRICULAR"
  },
  {
    "codigo":700335000,
    "descripcion":"ARTROSIS DE PRIMERA ARTICULACIÓN METATARSOFALÁNGICA SECUNDARIA A TRAUMATISMO"
  },
  {
    "codigo":1259226009,
    "descripcion":"DISPOSITIVO DE OCLUSIÓN IN SITU DE APÉNDICE AURICULAR IZQUIERDO"
  },
  {
    "codigo":208815003,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE LA ARTICULACIÓN RADIOCARPIANA"
  },
  {
    "codigo":239748000,
    "descripcion":"SUBLUXACIÓN RECURRENTE DE ARTICULACIÓN"
  },
  {
    "codigo":77743009,
    "descripcion":"ASINERGIA"
  },
  {
    "codigo":698500002,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÉDULA ESPINAL DEBIDA A TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":896943008,
    "descripcion":"FORMA DE BALA ANORMAL CONGÉNITA DE FALANGE MEDIA DE PIE"
  },
  {
    "codigo":403588002,
    "descripcion":"ADICCIÓN AL USO DE CAMA SOLAR"
  },
  {
    "codigo":43140008,
    "descripcion":"INTOXICACIÓN POR PENTACLOROFENOL"
  },
  {
    "codigo":205145001,
    "descripcion":"SINDACTILIA SIMPLE DE DEDOS DEL PIE - PRIMERA MEMBRANA INTERDIGITAL"
  },
  {
    "codigo":74073002,
    "descripcion":"HEMANGIOBLASTOMATOSIS CEREBELOSA"
  },
  {
    "codigo":303449002,
    "descripcion":"CAPAZ DE ACUCLILLARSE SOBRE EL INODORO"
  },
  {
    "codigo":41305006,
    "descripcion":"OXALOSIS SECUNDARIA"
  },
  {
    "codigo":1153582000,
    "descripcion":"VITAMINA B12 SÉRICA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":237913008,
    "descripcion":"TRASTORNO DEL METABOLISMO DE TETRAHIDROBIOPTERINA"
  },
  {
    "codigo":236078003,
    "descripcion":"DIARREA POSVAGOTOMÍA"
  },
  {
    "codigo":170542003,
    "descripcion":"REQUIERE SERIE DE VACUNACIÓN CONTRA HEPATITIS B"
  },
  {
    "codigo":268846006,
    "descripcion":"HIPOCALCEMIA NEONATAL"
  },
  {
    "codigo":301614006,
    "descripcion":"SUBE Y BAJA ESCALONES"
  },
  {
    "codigo":399918009,
    "descripcion":"HAMARTOMA DEL APARATO GLANDULAR SUDORÍPARA ECRINA"
  },
  {
    "codigo":365315002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA GUARDAR LA ROPA LAVADA"
  },
  {
    "codigo":299779003,
    "descripcion":"REACCIÓN DE PARACAÍDAS DUDOSA"
  },
  {
    "codigo":37635004,
    "descripcion":"SORDERA TÓXICA"
  },
  {
    "codigo":234243005,
    "descripcion":"AUMENTO INADECUADO CON BALÓN AÓRTICO"
  },
  {
    "codigo":297944001,
    "descripcion":"COMPRESIÓN DEL PLEXO BRAQUIAL"
  },
  {
    "codigo":396248004,
    "descripcion":"MARGEN QUIRÚRGICO ENDOCERVICAL COMPROMETIDO POR NEOPLASIA MALIGNA, DIFUSO"
  },
  {
    "codigo":232408005,
    "descripcion":"ESTENOSIS FARÍNGEA"
  },
  {
    "codigo":3032005,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN LA REGIÓN DE LA MEJILLA, SIN INFECCIÓN"
  },
  {
    "codigo":1197005,
    "descripcion":"ÁNTRAX DEL TALÓN"
  },
  {
    "codigo":425346001,
    "descripcion":"HERIDA MAYOR ABIERTA"
  },
  {
    "codigo":197805009,
    "descripcion":"ESTENOSIS URETERAL POSOPERATORIA"
  },
  {
    "codigo":10834301000119104,
    "descripcion":"FRACTURA SUBCAPITAL EXPUESTA DE FÉMUR DERECHO"
  },
  {
    "codigo":128599005,
    "descripcion":"TRASTORNO CARDÍACO ESTRUCTURAL"
  },
  {
    "codigo":1144407005,
    "descripcion":"HIPOPLASIA CONGÉNITA DE UNIDAD UNGUEAL DE DEDO DE PIE"
  },
  {
    "codigo":63063006,
    "descripcion":"AGUDEZA VISUAL SIN PERCEPCIÓN DE LA LUZ"
  },
  {
    "codigo":95831008,
    "descripcion":"SECRECIÓN ECTÓPICA DE SOMATOTROPINA"
  },
  {
    "codigo":1177175008,
    "descripcion":"SÍNDROME DE DISPLASIA ESQUELÉTICA, INMUNODEFICIENCIA DE CÉLULAS T Y RETRASO DEL DESARROLLO"
  },
  {
    "codigo":292439009,
    "descripcion":"REACCIÓN ADVERSA AL PRACTOLOL"
  },
  {
    "codigo":126764002,
    "descripcion":"ANOMALÍA CONGÉNITA DEL TRACTO INTESTINAL"
  },
  {
    "codigo":93996004,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL SACRO"
  },
  {
    "codigo":716588005,
    "descripcion":"CORIOCARCINOMA DE OVARIO NO GESTACIONAL PRIMARIO"
  },
  {
    "codigo":30295007,
    "descripcion":"GLUCOSURIA RENAL, TIPO B"
  },
  {
    "codigo":290604008,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR ETOGLÚCIDO"
  },
  {
    "codigo":102781000119107,
    "descripcion":"NEUROPATÍA SENSITIVA DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":16624151000119101,
    "descripcion":"HEMATOMA INTRAMURAL DE AORTA ABDOMINAL"
  },
  {
    "codigo":59393003,
    "descripcion":"HIDROSADENITIS SUPURATIVA"
  },
  {
    "codigo":288769005,
    "descripcion":"CAPAZ DE DIRIGIR LA ATENCIÓN"
  },
  {
    "codigo":92161005,
    "descripcion":"NEOPLASIA BENIGNA DE MANDÍBULA"
  },
  {
    "codigo":24790002,
    "descripcion":"ACIDOSIS TUBULAR RENAL PROXIMAL"
  },
  {
    "codigo":186795000,
    "descripcion":"PALUDISMO CAUSADO POR PLASMODIOS SIMIANOS"
  },
  {
    "codigo":840320000,
    "descripcion":"EVIDENCIA DE CESACIÓN DE USO INAPROPIADO DE SUSTANCIAS"
  },
  {
    "codigo":21120002,
    "descripcion":"OSTEOMIELITIS DE LA PIERNA"
  },
  {
    "codigo":283264003,
    "descripcion":"VIDRIO EN CADERA"
  },
  {
    "codigo":53888004,
    "descripcion":"PERTURBACIÓN EN LA CONDUCTA DURANTE EL SUEÑO"
  },
  {
    "codigo":1264469002,
    "descripcion":"RETICULINA AUMENTADA EN MÉDULA ÓSEA"
  },
  {
    "codigo":248661003,
    "descripcion":"LATIDO DEL VÉRTICE DESPLAZADO"
  },
  {
    "codigo":281429002,
    "descripcion":"INFECCIÓN EN EL INJERTO DE TENDÓN"
  },
  {
    "codigo":707413005,
    "descripcion":"TROMBOEMBOLIA PULMONAR CRÓNICA SIN HIPERTENSIÓN PULMONAR"
  },
  {
    "codigo":445269007,
    "descripcion":"LINFOMA DE CÉLULAS B DE LA ZONA MARGINAL EXTRAGANGLIONAR DE TEJIDO LINFOIDE ASOCIADO A MUCOSA"
  },
  {
    "codigo":314197008,
    "descripcion":"LUXACIÓN DE ARTICULACIÓN CIGOAPOFISARIA DORSAL"
  },
  {
    "codigo":246826003,
    "descripcion":"REGENERACIÓN NERVIOSA ABERRANTE TIPO III"
  },
  {
    "codigo":82986004,
    "descripcion":"HEMORRAGIA UMBILICAL DESPUÉS DEL NACIMIENTO"
  },
  {
    "codigo":115754004,
    "descripcion":"FENOTIPO I>2<"
  },
  {
    "codigo":17450006,
    "descripcion":"MIOCLONO"
  },
  {
    "codigo":212223009,
    "descripcion":"LESIÓN DE LA RAÍZ DEL NERVIO SACRO - S1"
  },
  {
    "codigo":408831009,
    "descripcion":"SITUACIÓN DE CRIBADO PRENATAL MEDIANTE PRUEBA DE DETECCIÓN DE TALASEMIA EN SANGRE"
  },
  {
    "codigo":308692003,
    "descripcion":"RUBEFACCIÓN INDUCIDA POR ALCOHOL"
  },
  {
    "codigo":112084006,
    "descripcion":"ACTIVIDAD DE EVACUACIÓN"
  },
  {
    "codigo":306857000,
    "descripcion":"TROMBOSIS DE INJERTO-PUENTE DE ARTERIA RENAL"
  },
  {
    "codigo":767444009,
    "descripcion":"CÁNCER DE MAMA METASTÁSICO NEGATIVO PARA HER2, CON MUTACIÓN DE BRCA EN LA LÍNEA GERMINAL"
  },
  {
    "codigo":110249005,
    "descripcion":"CONTUSIÓN DEL MENTÓN"
  },
  {
    "codigo":763774001,
    "descripcion":"SÍNDROME DE KEIPERT"
  },
  {
    "codigo":370558003,
    "descripcion":"ELIMINACIÓN INADECUADA"
  },
  {
    "codigo":42878004,
    "descripcion":"TROMBOSIS DE LA AORTA TORÁCICA"
  },
  {
    "codigo":303187001,
    "descripcion":"PACIENTE INFORMAL"
  },
  {
    "codigo":447283008,
    "descripcion":"VENTRÍCULO ÚNICO DE MORFOLOGÍA INDETERMINADA"
  },
  {
    "codigo":678731000119104,
    "descripcion":"CUADRANTANOPIA DE OJO IZQUIERDO"
  },
  {
    "codigo":237651005,
    "descripcion":"RESISTENCIA INSULÍNICA - TIPO A"
  },
  {
    "codigo":301352000,
    "descripcion":"LABIOS NORMALES"
  },
  {
    "codigo":235816000,
    "descripcion":"ROTACIÓN PATOLÓGICA DEL INTESTINO, TIPO IIIA"
  },
  {
    "codigo":39208009,
    "descripcion":"HIDROPESÍA FETAL QUE CAUSA DESPROPORCIÓN"
  },
  {
    "codigo":365053003,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA EMPLEAR LENGUAJE AUTOMÁTICO"
  },
  {
    "codigo":233981004,
    "descripcion":"ANEURISMA ARTERIAL"
  },
  {
    "codigo":37373007,
    "descripcion":"DIVERTÍCULO DE MECKEL"
  },
  {
    "codigo":232146005,
    "descripcion":"OFTALMOPLEJÍA INTERNA"
  },
  {
    "codigo":723666009,
    "descripcion":"NEUROPATÍA PERIFÉRICA DEPENDIENTE DE LA LONGITUD"
  },
  {
    "codigo":199378009,
    "descripcion":"EMBARAZO MÚLTIPLE CON PRESENTACIÓN FETAL ANÓMALA"
  },
  {
    "codigo":787367002,
    "descripcion":"METABOLIZADOR RÁPIDO DE LA FAMILIA 1 SUBFAMILIA A MIEMBRO 2 DEL CITOCROMO P450"
  },
  {
    "codigo":230311004,
    "descripcion":"DEGENERACIÓN DE LOS GANGLIOS BASALES CON CALCIFICACIÓN"
  },
  {
    "codigo":295847008,
    "descripcion":"SOBREDOSIS DE CLOMIPRAMINA"
  },
  {
    "codigo":195708003,
    "descripcion":"INFECCIONES RECURRENTES DE LAS VÍAS RESPIRATORIAS SUPERIORES"
  },
  {
    "codigo":294012005,
    "descripcion":"ALERGIA A DEMECARIO"
  },
  {
    "codigo":16026751000119100,
    "descripcion":"RADICULOPATÍA DE COLUMNA VERTEBRAL DORSOLUMBAR DEBIDA A TRASTORNO DE DISCO"
  },
  {
    "codigo":783697000,
    "descripcion":"PARAPLEJÍA ESPÁSTICA LIGADA AL CROMOSOMA X TIPO 16"
  },
  {
    "codigo":95569006,
    "descripcion":"COMA URÉMICO"
  },
  {
    "codigo":161105008,
    "descripcion":"MIEMBRO DE LA SOCIEDAD DE ASMA"
  },
  {
    "codigo":128337009,
    "descripcion":"TRASTORNO DEL PALADAR"
  },
  {
    "codigo":292177009,
    "descripcion":"REACCIÓN ADVERSA A LA BUPIVACAÍNA"
  },
  {
    "codigo":126502003,
    "descripcion":"NEOPLASIA DE PIEL DE CONDUCTO AUDITIVO EXTERNO"
  },
  {
    "codigo":192038005,
    "descripcion":"ESTADO DE FUGA AGUDO POR REACCIÓN A ESTRÉS AGUDO"
  },
  {
    "codigo":93734005,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE BRONQUIO"
  },
  {
    "codigo":28198007,
    "descripcion":"SÍFILIS PRIMARIA DE LABIO"
  },
  {
    "codigo":290342006,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR COMPUESTO DE BISMUTO"
  },
  {
    "codigo":91899002,
    "descripcion":"AUSENCIA CONGÉNITA DEL METATARSO"
  },
  {
    "codigo":124667004,
    "descripcion":"DEFICIENCIA DE RIBOSA - 5 - FOSFATO ISOMERASA"
  },
  {
    "codigo":419579006,
    "descripcion":"EL MARGEN DE RESECCIÓN QUIRÚRGICA INFERIOR ES EL MARGEN NO AFECTADO MÁS CERCANO AL CARCINOMA DUCTAL IN SITU"
  },
  {
    "codigo":57296000,
    "descripcion":"ÚTERO GRÁVIDO ENCARCELADO"
  },
  {
    "codigo":417744001,
    "descripcion":"INCLINACIÓN DE LA BASE DEL SACRO"
  },
  {
    "codigo":286672002,
    "descripcion":"IDENTIFICACIÓN - MECANISMO DE DEFENSA PSICOLÓGICA"
  },
  {
    "codigo":253904001,
    "descripcion":"SÍNDROME DE MEGAVEJIGA-MEGAURÉTER"
  },
  {
    "codigo":1236944003,
    "descripcion":"METÁSTASIS DE CARCINOMA DE DORSO DE PORCIÓN ANTERIOR DE LENGUA"
  },
  {
    "codigo":1204176005,
    "descripcion":"ATEROSCLEROSIS DE ARTERIA ILÍACA"
  },
  {
    "codigo":266954003,
    "descripcion":"NIÑO ABANDONADO POR LOS PADRES"
  },
  {
    "codigo":284837001,
    "descripcion":"NO SE LAVA LA BOCA"
  },
  {
    "codigo":53626000,
    "descripcion":"MARCHA ARRASTRADA"
  },
  {
    "codigo":250234000,
    "descripcion":"CUERPO DE HOWELL JOLLY"
  },
  {
    "codigo":707151000,
    "descripcion":"PRURITO URÉMICO"
  },
  {
    "codigo":1264207000,
    "descripcion":"TRASTORNO FETAL CAUSADO POR TRANSFERENCIA PLACENTARIA DE AGENTE ANTIHIPERTENSIVO MATERNO"
  },
  {
    "codigo":1003898009,
    "descripcion":"DELECIÓN PROXIMAL DEL BRAZO LARGO DEL CROMOSOMA 5"
  },
  {
    "codigo":248399003,
    "descripcion":"MAXILAR PROMINENTE"
  },
  {
    "codigo":11822361000119104,
    "descripcion":"DESGARRO ANTEROPOSTERIOR DE RODETE GLENOIDEO SUPERIOR DE HOMBRO DERECHO"
  },
  {
    "codigo":10757401000119104,
    "descripcion":"CARDIOPATÍA HIPERTENSIVA Y ENFERMEDAD RENAL CRÓNICA HIPERTENSIVA MATERNA PREEXISTENTES QUE COMPLICAN EL NACIMIENTO"
  },
  {
    "codigo":1196836004,
    "descripcion":"ADENOMA PAPILAR MUCINOSO INTRADUCTAL DE VÍA BILIAR EXTRAHEPÁTICA"
  },
  {
    "codigo":48121000,
    "descripcion":"CARDIOMEGALIA CONGÉNITA"
  },
  {
    "codigo":49956009,
    "descripcion":"TROMBOSIS DE VENAS PROFUNDAS PREPARTO"
  },
  {
    "codigo":769017001,
    "descripcion":"CARIES CAVITADA ACTIVA DE RAÍZ DENTAL"
  },
  {
    "codigo":310265009,
    "descripcion":"DIETA MODIFICADA EN SU CONTENIDO DE ELECTRÓLITOS"
  },
  {
    "codigo":898254003,
    "descripcion":"ANQUILOSIS CONGÉNITA DE ARTICULACIÓN INTERFALÁNGICA DE DEDO MEDIO"
  },
  {
    "codigo":46286007,
    "descripcion":"VASCULITIS LINFOCÍTICA DE LA PIEL"
  },
  {
    "codigo":767182009,
    "descripcion":"QUISTE SINOVIAL DE TOBILLO Y PIE"
  },
  {
    "codigo":11683003,
    "descripcion":"MALACOPLASIA DEL COLON"
  },
  {
    "codigo":372131006,
    "descripcion":"NEOPLASIA MALIGNA DE LOS HUESOS DEL MIEMBRO SUPERIOR Y OMÓPLATO"
  },
  {
    "codigo":1255032000,
    "descripcion":"ESGUINCE DE LIGAMENTO DE ARTICULACIÓN METACARPOFALÁNGICA DE DEDO ANULAR DE MANO"
  },
  {
    "codigo":9848002,
    "descripcion":"AMPOLLA DE LA REGIÓN ESCAPULAR, SIN INFECCIÓN"
  },
  {
    "codigo":206456003,
    "descripcion":"ICTERICIA NEONATAL DEBIDA A SÍNDROME DE GILBERT"
  },
  {
    "codigo":697976003,
    "descripcion":"DISFUNCIÓN MICROVASCULAR CORONARIA"
  },
  {
    "codigo":403064005,
    "descripcion":"ONICOMICOSIS CAUSADA POR TRICHOPHYTON VIOLACEUM"
  },
  {
    "codigo":42616006,
    "descripcion":"ERITROCITOSIS POR HEPATOMA"
  },
  {
    "codigo":401229000,
    "descripcion":"PENSAMIENTOS DE AUTOINFLIGIRSE DAÑO INTENCIONALMENTE"
  },
  {
    "codigo":1351501003,
    "descripcion":"DEFICIENCIA DEL COMPLEJO MAYOR DE HISTOCOMPATIBILIDAD CLASE II DEBIDA A MUTACIÓN DEL GEN RFXAP"
  },
  {
    "codigo":40781006,
    "descripcion":"INSUFICIENCIA HIPOFISARIA SECUNDARIA A TUMOR HIPOFISARIO"
  },
  {
    "codigo":399394000,
    "descripcion":"INVASIÓN DE TUMOR DE OVARIO, IMPLANTES EPIPLOICOS AUSENTES"
  },
  {
    "codigo":366626006,
    "descripcion":"AMPLITUD DE MOVIMIENTO DE ARTICULACIÓN DE PIE - HALLAZGO"
  },
  {
    "codigo":1251362006,
    "descripcion":"XANTOMA PLANO DIFUSO DEBIDO A HIPERLIPIDEMIA"
  },
  {
    "codigo":233719000,
    "descripcion":"LINFANGIOLEIOMIOMATOSIS DE LA PIEL"
  },
  {
    "codigo":364791001,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA MOVER ALIMENTOS EN LA BOCA"
  },
  {
    "codigo":299255004,
    "descripcion":"SIN AMPLITUD ACTIVA DE EXTENSIÓN DE LA CADERA"
  },
  {
    "codigo":200951007,
    "descripcion":"ERITEMA MARGINADO EN LA FIEBRE REUMÁTICA AGUDA"
  },
  {
    "codigo":788940001,
    "descripcion":"FRACTURA DE FALANGE DE DEDO MEÑIQUE"
  },
  {
    "codigo":723404002,
    "descripcion":"DISPLASIA OSTEODISPLÁSICA MICROCEFÁLICA TIPO SAUL WILSON"
  },
  {
    "codigo":231884003,
    "descripcion":"QUEMADURA DE LA ESCLERÓTICA"
  },
  {
    "codigo":721569001,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE LIGAMENTO UTERINO"
  },
  {
    "codigo":295585004,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE PROXIMETACAÍNA"
  },
  {
    "codigo":293750000,
    "descripcion":"ALERGIA A IFOSFAMIDA"
  },
  {
    "codigo":719734003,
    "descripcion":"CAPAZ DE IDENTIFICAR ELECCIONES"
  },
  {
    "codigo":816203001,
    "descripcion":"NEVO MELANOCÍTICO DE GANGLIO LINFÁTICO"
  },
  {
    "codigo":717899005,
    "descripcion":"HIPOPARATIROIDISMO POSTERIOR A ABLACIÓN TIROIDEA CON YODO"
  },
  {
    "codigo":95307007,
    "descripcion":"PERFORACIÓN TRAUMÁTICA DE LA TRÁQUEA"
  },
  {
    "codigo":290080002,
    "descripcion":"DOLOR A LA PALPACIÓN LOCALIZADO EN LA MAMA"
  },
  {
    "codigo":1142048002,
    "descripcion":"PROTEINURIA GESTACIONAL PERSISTENTE"
  },
  {
    "codigo":93472004,
    "descripcion":"HEMANGIOMA ESPLÉNICO"
  },
  {
    "codigo":1240352004,
    "descripcion":"METÁSTASIS DE CARCINOMA DE ENCÍA SUPERIOR"
  },
  {
    "codigo":60704006,
    "descripcion":"ERECCIÓN DEL PENE"
  },
  {
    "codigo":419317000,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL APARATO LAGRIMAL"
  },
  {
    "codigo":91637004,
    "descripcion":"MIASTENIA GRAVIS"
  },
  {
    "codigo":288245007,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE ANTEBRAZO"
  },
  {
    "codigo":386549008,
    "descripcion":"ASPECTO NORMAL"
  },
  {
    "codigo":253642005,
    "descripcion":"ESTENOSIS AÓRTICA SUPRAVALVULAR DIFUSA"
  },
  {
    "codigo":286410009,
    "descripcion":"DIFICULTAD PARA HABLAR INTELIGIBLEMENTE"
  },
  {
    "codigo":87967003,
    "descripcion":"ABORTO ESPONTÁNEO CON PERFORACIÓN DE VAGINA"
  },
  {
    "codigo":251807004,
    "descripcion":"GENITALES EN ESTADIO 2 DE TANNER"
  },
  {
    "codigo":284575006,
    "descripcion":"CUERPO EXTRAÑO METÁLICO EN EL LABIO"
  },
  {
    "codigo":448415009,
    "descripcion":"ESTENOSIS SUBAÓRTICA DEBIDA A VÁLVULA AURICULOVENTRICULAR COMÚN"
  },
  {
    "codigo":20596003,
    "descripcion":"FRACTURA DE HUESO LARGO DEBIDO A TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":249972004,
    "descripcion":"PATRÓN FLEXOR"
  },
  {
    "codigo":11306881000119106,
    "descripcion":"FRACTURAS MÚLTIPLES NO EXPUESTAS DE LA PELVIS POR COMPRESIÓN ANTEROPOSTERIOR CON ANILLO PÉLVICO INESTABLE"
  },
  {
    "codigo":53364007,
    "descripcion":"ENFERMEDAD RELACIONADA CON EL MEDIO SOCIAL"
  },
  {
    "codigo":706889000,
    "descripcion":"LESIÓN TRAUMÁTICA DURANTE TRANSFERENCIA O TRASLADO"
  },
  {
    "codigo":444745000,
    "descripcion":"QUISTE MUCOSO DE SENO PARANASAL INFECTADO"
  },
  {
    "codigo":315508009,
    "descripcion":"NACIDO EN LA REPÚBLICA DE COREA"
  },
  {
    "codigo":1263945003,
    "descripcion":"SHOCK POSOPERATORIO POSTERIOR A EMBARAZO ECTÓPICO"
  },
  {
    "codigo":139291000119101,
    "descripcion":"OSTEOPENIA CON ALTO RIESGO DE FRACTURA"
  },
  {
    "codigo":11771931000119101,
    "descripcion":"LUXACIÓN TRAUMÁTICA POSTERIOR NO EXPUESTA DE CODO IZQUIERDO"
  },
  {
    "codigo":870729007,
    "descripcion":"EXANTEMA CAUSADO POR ECOVIRUS HUMANO"
  },
  {
    "codigo":311838003,
    "descripcion":"LESIÓN CERRADA DE LA TRÁQUEA TORÁCICA"
  },
  {
    "codigo":279070004,
    "descripcion":"DOLOR POR TENSIÓN MUSCULAR"
  },
  {
    "codigo":703219008,
    "descripcion":"ARTERIOPATÍA CEREBRAL AUTOSÓMICA RECESIVA CON INFARTOS SUBCORTICALES Y LEUCOENCEFALOPATÍA"
  },
  {
    "codigo":209864000,
    "descripcion":"LACERACIÓN CORTICAL CON LESIÓN INTRACRANEAL ABIERTA, SIN PÉRDIDA DE CONSCIENCIA"
  },
  {
    "codigo":275400004,
    "descripcion":"BEZOAR POR ANTIÁCIDOS"
  },
  {
    "codigo":111560008,
    "descripcion":"TRASTORNO DE LA SECRECIÓN PANCREÁTICA ENDOCRINA"
  },
  {
    "codigo":208029001,
    "descripcion":"FRACTURA VERTEBRAL NO EXPUESTA CON LESIÓN ANTERIOR DE MÉDULA ESPINAL DORSAL, D1-6"
  },
  {
    "codigo":371869002,
    "descripcion":"HIPOCINESIA MODERADA DE LA PARED CARDÍACA"
  },
  {
    "codigo":109725007,
    "descripcion":"ASIMETRÍA MAXILAR POR ATROFIA HEMIFACIAL"
  },
  {
    "codigo":76957008,
    "descripcion":"BOLA FÚNGICA GASTROINTESTINAL"
  },
  {
    "codigo":75122001,
    "descripcion":"TRASTORNO PSICÓTICO CON IDEAS DELLIRANTES INDUCIDO POR INHALANTES"
  },
  {
    "codigo":402802003,
    "descripcion":"ANOMALÍA FISIOLÓGICA DE PIEL NEONATAL"
  },
  {
    "codigo":1287538004,
    "descripcion":"ABRASIÓN DE PIEL DE PERINEO"
  },
  {
    "codigo":7751009,
    "descripcion":"MALESTAR VISUAL"
  },
  {
    "codigo":366364004,
    "descripcion":"HALLAZGO RELACIONADO CON EL ESTADO NUTRICIONAL"
  },
  {
    "codigo":169756008,
    "descripcion":"ATENCIÓN POSNATAL POR MÉDICO GENERAL"
  },
  {
    "codigo":686261000119107,
    "descripcion":"HISTIOCITOMA FIBROSO MALIGNO PRIMARIO DE PARTES BLANDAS DE ABDOMEN"
  },
  {
    "codigo":724977006,
    "descripcion":"LACERACIÓN DE MÚSCULO EXTENSOR DE DEDO DE LA MANO A LA ALTURA DEL ANTEBRAZO"
  },
  {
    "codigo":297158000,
    "descripcion":"FRACTURA DE ALVÉOLO MANDIBULAR"
  },
  {
    "codigo":167921008,
    "descripcion":"MÉDULA ÓSEA MEGALOBLÁSTICA"
  },
  {
    "codigo":430065009,
    "descripcion":"ABSCESO DE VÁLVULA AÓRTICA"
  },
  {
    "codigo":298993008,
    "descripcion":"AMPLITUD DE SUPINACIÓN ACTIVA DE LA MUÑECA NORMAL"
  },
  {
    "codigo":723142002,
    "descripcion":"HERIDA COMPLEJA DE CABEZA POR PERFORACIÓN DE LADO A LADO"
  },
  {
    "codigo":67782005,
    "descripcion":"SÍNDROME DE DISTRÉS RESPIRATORIO AGUDO"
  },
  {
    "codigo":428230005,
    "descripcion":"VAGINITIS POR TRICOMONAS EN EL EMBARAZO"
  },
  {
    "codigo":332111000119102,
    "descripcion":"DESPRENDIMIENTO SEROSO DE COROIDES DE OJO DERECHO"
  },
  {
    "codigo":721307000,
    "descripcion":"MIELOPOYESIS ANORMAL TRANSITORIA"
  },
  {
    "codigo":459163001,
    "descripcion":"ENDARTERITIS INFECCIOSA EN LOCALIZACIÓN DE COARTACIÓN DE AORTA"
  },
  {
    "codigo":16224591000119103,
    "descripcion":"ALERGIA A VENENO DE ABEJA MELÍFERA"
  },
  {
    "codigo":10899791000119104,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO TROCLEAR IZQUIERDO"
  },
  {
    "codigo":262555007,
    "descripcion":"HERIDA POR MORDEDURA HUMANA"
  },
  {
    "codigo":129648000,
    "descripcion":"HIPOALFAGLOBULINEMIA"
  },
  {
    "codigo":1145456001,
    "descripcion":"APLASIA DE EPÍFISIS PROXIMAL DE FÉMUR"
  },
  {
    "codigo":786843009,
    "descripcion":"BACILLUS AMYLOLIQUEFACIENS, BACILLUS ATROPHAEUS O BACILLUS SUBTILIS"
  },
  {
    "codigo":293488002,
    "descripcion":"REACCIÓN ADVERSA A LA INDAPAMIDA"
  },
  {
    "codigo":95045001,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE HOMBRO"
  },
  {
    "codigo":193349004,
    "descripcion":"RETINOPATÍA PREPROLIFERATIVA DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":226117007,
    "descripcion":"DIETA PARA DISMINUIR LAS LIPOPROTEÍNAS DE BAJA DENSIDAD"
  },
  {
    "codigo":60442001,
    "descripcion":"PERFORACIÓN DE MEMBRANA TIMPÁNICA"
  },
  {
    "codigo":420890002,
    "descripcion":"LINFOMA LINFOBLÁSTICO\/LEUCEMIA LINFOBLÁSTICA DE CÉLULAS T"
  },
  {
    "codigo":93210001,
    "descripcion":"MELANOMA MALIGNO DE LA PIEL DEL ABDOMEN"
  },
  {
    "codigo":224282001,
    "descripcion":"USUARIO TELEFÓNICO CIEGO"
  },
  {
    "codigo":419055000,
    "descripcion":"REACCIÓN ADVERSA A DIURÉTICO DERIVADO DE LA SULFONAMIDA"
  },
  {
    "codigo":715802008,
    "descripcion":"ENFERMEDAD DE CHARCOT-MARIE-TOOTH TIPO 4H"
  },
  {
    "codigo":289818008,
    "descripcion":"DOLOR A LA MOVILIZACIÓN DEL CUELLO UTERINO"
  },
  {
    "codigo":781338009,
    "descripcion":"ENFERMEDAD CAUSADA POR SYNGAMIDAE"
  },
  {
    "codigo":713967004,
    "descripcion":"INFECCIÓN ATÍPICA DISEMINADA CAUSADA POR MYCOBACTERIUM CONCOMITANTE CON INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":124143006,
    "descripcion":"DEFICIENCIA DE GLUCOSA OXIDASA"
  },
  {
    "codigo":91375006,
    "descripcion":"ATRESIA DEL RECTO"
  },
  {
    "codigo":253380000,
    "descripcion":"ANOMALÍA DE VALVA TRICUSPÍDEA"
  },
  {
    "codigo":320751009,
    "descripcion":"DEPRESIÓN MAYOR, TIPO MELANCÓLICO"
  },
  {
    "codigo":187844003,
    "descripcion":"NEOPLASIA MALIGNA DEL CARTÍLAGO CRICOIDES"
  },
  {
    "codigo":286148008,
    "descripcion":"CAPAZ DE LIMPIAR EL BAÑO"
  },
  {
    "codigo":22169002,
    "descripcion":"DEFICIENCIA DE DISACARIDASA INTESTINAL"
  },
  {
    "codigo":284313005,
    "descripcion":"INCAPAZ DE MANIPULAR OBJETOS"
  },
  {
    "codigo":448153005,
    "descripcion":"ANILLO VASCULAR CON CAYADO AÓRTICO IZQUIERDO Y CONDUCTO ARTERIAL DERECHO ORIGINADO EN ARTERIA SUBCLAVIA DERECHA RETROESOFÁGICA ABERRANTE"
  },
  {
    "codigo":20334002,
    "descripcion":"PROCTOMENIA"
  },
  {
    "codigo":315246003,
    "descripcion":"TOS DE CAUSA INEXPLICABLE"
  },
  {
    "codigo":85870004,
    "descripcion":"LACERACIÓN MENOR DE HÍGADO CON HERIDA ABIERTA HACIA CAVIDAD ABDOMINAL"
  },
  {
    "codigo":11993731000119103,
    "descripcion":"LESIÓN POR FRÍO DE MANO IZQUIERDA"
  },
  {
    "codigo":282478005,
    "descripcion":"NO INTENTA CORRER"
  },
  {
    "codigo":249710008,
    "descripcion":"LORDOSIS ACENTUADA"
  },
  {
    "codigo":1003374009,
    "descripcion":"MICROLISENCEFALIA"
  },
  {
    "codigo":1263683004,
    "descripcion":"TRASTORNO FETAL DEBIDO A PRESENTACIÓN DE HOMBROS DURANTE TRABAJO DE PARTO"
  },
  {
    "codigo":247875005,
    "descripcion":"PENSAMIENTOS OBSESIVOS ACERCA DE LAS EXPLOSIONES"
  },
  {
    "codigo":278808000,
    "descripcion":"BLEFARITIS ESTAFILOCÓCICA"
  },
  {
    "codigo":737560000,
    "descripcion":"NIVEL SANGUÍNEO DE COBRE POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":442648006,
    "descripcion":"TUMEFACCIÓN DE AMÍGDALA IZQUIERDA"
  },
  {
    "codigo":16664009,
    "descripcion":"OTITIS MEDIA MALIGNA"
  },
  {
    "codigo":10820381000119101,
    "descripcion":"FRACTURA ABIERTA DE TRAPECIO DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":1260013005,
    "descripcion":"FRACTURA DE CORONA DE DIENTE PERMANENTE INMADURO POSTERIOR A TRATAMIENTO DE CONDUCTO DE RAÍZ DENTAL DE DIENTE"
  },
  {
    "codigo":735725007,
    "descripcion":"ANGIODISPLASIA DE ESÓFAGO"
  },
  {
    "codigo":702957008,
    "descripcion":"PIE EQUINO CAVOVARO"
  },
  {
    "codigo":209602001,
    "descripcion":"DESGARRO COMPLETO DE LIGAMENTO ESCAFOSEMILUNAR"
  },
  {
    "codigo":111298007,
    "descripcion":"ISQUEMIA CEREBRAL CRÓNICA"
  },
  {
    "codigo":307906008,
    "descripcion":"ESTADO DE LA CERTIFICACIÓN DE LICENCIA POR ENFERMEDAD DE LAS FUERZAS"
  },
  {
    "codigo":109463000,
    "descripcion":"DIENTE CON MÚLTIPLES RAÍCES CONVERGENTES"
  },
  {
    "codigo":240535006,
    "descripcion":"VERRUGA SUBUNGUEAL"
  },
  {
    "codigo":207767007,
    "descripcion":"FRACTURA EXPUESTA DE CÓNDILO DE MAXILAR INFERIOR"
  },
  {
    "codigo":271468000,
    "descripcion":"NEOPLASIA MALIGNA DE ÓRGANO GENITOURINARIO"
  },
  {
    "codigo":762988003,
    "descripcion":"PORTADOR DE BACTERIAS PRODUCTORAS DE BETA-LACTAMASA DE AMPLIO ESPECTRO"
  },
  {
    "codigo":369772003,
    "descripcion":"PATRÓN DE GLEASON 3"
  },
  {
    "codigo":304236004,
    "descripcion":"LESIÓN POR LEVANTAMIENTO Y MANIPULACIÓN"
  },
  {
    "codigo":402540005,
    "descripcion":"CARCINOMA BASOCELULAR RECIDIVANTE LUEGO DE RESECCIÓN DE MOHS"
  },
  {
    "codigo":40257000,
    "descripcion":"CONTUSIÓN DE REGIÓN DE HOMBRO"
  },
  {
    "codigo":238700008,
    "descripcion":"MELANOSIS UNIVERSAL ADQUIRIDA"
  },
  {
    "codigo":398870000,
    "descripcion":"ÚLCERA AFTOSA RECURRENTE"
  },
  {
    "codigo":300566002,
    "descripcion":"DOLOR A LA PALPACIÓN EN BAZO"
  },
  {
    "codigo":890390007,
    "descripcion":"MALFORMACIÓN CONGÉNITA DE LA VÍA AÉREA PULMONAR TIPO 2"
  },
  {
    "codigo":366102008,
    "descripcion":"HALLAZGO RELACIONADO CON LA LOCALIZACIÓN DE LA FUENTE DE SONIDO"
  },
  {
    "codigo":235030009,
    "descripcion":"LEUCOPLASIA ORAL DISPLÁSICA"
  },
  {
    "codigo":298731003,
    "descripcion":"DOLOR DE ESTERNÓN"
  },
  {
    "codigo":724715004,
    "descripcion":"DEPENDENCIA DE KETAMINA"
  },
  {
    "codigo":823019007,
    "descripcion":"PARÁLISIS MUSCULAR DEBIDA A BLOQUEO NEUROMUSCULAR Y POSTERIOR A ÉL"
  },
  {
    "codigo":30281000175104,
    "descripcion":"ÚLCERA POR PRESIÓN EN CODO IZQUIERDO, ESTADIO II"
  },
  {
    "codigo":1148864001,
    "descripcion":"HEMATURIA MICROSCÓPICA INTERMITENTE"
  },
  {
    "codigo":722880007,
    "descripcion":"TRASTORNO ANORRECTAL FUNCIONAL"
  },
  {
    "codigo":296896008,
    "descripcion":"SOBREDOSIS DE ANTICONCEPTIVO ORAL"
  },
  {
    "codigo":12301000132103,
    "descripcion":"RECAÍDA DE LEUCEMIA LINFOIDE AGUDA"
  },
  {
    "codigo":196757008,
    "descripcion":"TRASTORNO GASTROINTESTINAL CAUSADO POR FÁRMACO"
  },
  {
    "codigo":31082002,
    "descripcion":"ALOPECIA POR CONGELACIÓN"
  },
  {
    "codigo":293226003,
    "descripcion":"REACCIÓN ADVERSA A LA GESTRINONA"
  },
  {
    "codigo":719210007,
    "descripcion":"ATAXIA ESPINOCEREBELOSA TIPO 14"
  },
  {
    "codigo":94783002,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL CIEGO"
  },
  {
    "codigo":1208895006,
    "descripcion":"DEGENERACIÓN MACULAR AVANZADA RELACIONADA CON LA EDAD"
  },
  {
    "codigo":782911008,
    "descripcion":"CRIOHIDROCITOSIS HEREDITARIA CON ESTOMATINA REDUCIDA"
  },
  {
    "codigo":225855009,
    "descripcion":"HALLAZGO RELACIONADO CON REGLAS Y LÍMITES"
  },
  {
    "codigo":289556004,
    "descripcion":"SECRECIÓN VAGINAL MARRÓN"
  },
  {
    "codigo":92948006,
    "descripcion":"FORMA ANORMAL CONGÉNITA DE LA VÉRTEBRA ESTERNAL"
  },
  {
    "codigo":11996241000119107,
    "descripcion":"NECROSIS DE MUÑÓN DE AMPUTACIÓN DE MIEMBRO INFERIOR IZQUIERDO"
  },
  {
    "codigo":713705003,
    "descripcion":"POLINEUROPATÍA DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":123881006,
    "descripcion":"INTOXICACIÓN POR CARYOPHYLLACEAE"
  },
  {
    "codigo":189417009,
    "descripcion":"NEOPLASIA DE PLIEGUE ARITENOEPIGLÓTICO DE COMPORTAMIENTO INCIERTO"
  },
  {
    "codigo":1268926005,
    "descripcion":"ESMEGMA EN CANTIDAD EXCESIVA EN PENE"
  },
  {
    "codigo":449726007,
    "descripcion":"ASTIGMATISMO OBLICUO"
  },
  {
    "codigo":253118007,
    "descripcion":"ESPINA BÍFIDA TORACOLUMBAR CON HIDROCEFALIA - NO EXPUESTA"
  },
  {
    "codigo":285886009,
    "descripcion":"CAPAZ DE UTILIZAR LA PAVA"
  },
  {
    "codigo":39301000087102,
    "descripcion":"CUERPO EXTRAÑO EN DEDO PULGAR DERECHO"
  },
  {
    "codigo":44421000087103,
    "descripcion":"LACERACIÓN COMPLEJA DE PABELLÓN AURICULAR DERECHO"
  },
  {
    "codigo":46981000087102,
    "descripcion":"FRACTURA DE FALANGE MEDIA DE DEDO MEDIO DERECHO"
  },
  {
    "codigo":54675009,
    "descripcion":"TRAQUEOPATÍA OSTEOPLÁSTICA"
  },
  {
    "codigo":216680002,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR QUEROSÉN"
  },
  {
    "codigo":282216003,
    "descripcion":"INCAPAZ DE EMPEZAR A CAMINAR Y DETENER LA MARCHA ESPONTÁNEAMENTE"
  },
  {
    "codigo":41861000087108,
    "descripcion":"BURSITIS DE CODO IZQUIERDO"
  },
  {
    "codigo":314984005,
    "descripcion":"PRESCRIPCIÓN EXTRAVIADA"
  },
  {
    "codigo":249448004,
    "descripcion":"CUERDA VOCAL EN ADUCCIÓN EN REPOSO"
  },
  {
    "codigo":34181000087107,
    "descripcion":"MÚLTIPLES LESIONES GENITALES INTRAABDOMINALES TRAUMÁTICAS"
  },
  {
    "codigo":413288008,
    "descripcion":"TIENE ACCESO A VEHÍCULO DE TRANSPORTE PÚBLICO"
  },
  {
    "codigo":313149002,
    "descripcion":"UTILIZA DISPOSITIVO ESPACIADOR"
  },
  {
    "codigo":18237006,
    "descripcion":"MASTITIS PARENQUIMATOSA ASOCIADA CON EL PARTO"
  },
  {
    "codigo":278546000,
    "descripcion":"APARATO DENTAL-HALLAZGO"
  },
  {
    "codigo":737298001,
    "descripcion":"HUESO TRASPLANTADO PRESENTE"
  },
  {
    "codigo":16402000,
    "descripcion":"RASGO DE DREPANOCITOSIS"
  },
  {
    "codigo":247613008,
    "descripcion":"INCAPAZ DE RECORDAR SU EDAD"
  },
  {
    "codigo":337131000119109,
    "descripcion":"ENTROPIÓN ESPÁSTICO DE PÁRPADO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":735463000,
    "descripcion":"PERICONDRITIS DE TRÁQUEA"
  },
  {
    "codigo":440551001,
    "descripcion":"POSICIÓN ANÓMALA DE CATÉTER DE DIÁLISIS PERITONEAL"
  },
  {
    "codigo":276711002,
    "descripcion":"FONTANELA IMPALPABLE"
  },
  {
    "codigo":1259751006,
    "descripcion":"NEOPLASIA PRIMARIA MALIGNA ODONTÓGENA DE MAXILAR INFERIOR"
  },
  {
    "codigo":111036000,
    "descripcion":"OBESIDAD HIPERINSULÍNICA"
  },
  {
    "codigo":405948001,
    "descripcion":"RIGIDEZ DE NUCA POR MENINGITIS"
  },
  {
    "codigo":733628001,
    "descripcion":"DUPLICACIÓN ENTÉRICA TORACOABDOMINAL"
  },
  {
    "codigo":209340005,
    "descripcion":"FRACTURA-LUXACIÓN NO EXPUESTA DE ARTICULACIÓN DE LA RODILLA"
  },
  {
    "codigo":305809001,
    "descripcion":"ATENDIDO POR SERVICIO DE FISIOLOGÍA CLÍNICA"
  },
  {
    "codigo":10897002,
    "descripcion":"ÚLCERA GASTROYEYUNAL CRÓNICA CON PERFORACIÓN Y CON OBSTRUCCIÓN"
  },
  {
    "codigo":895633004,
    "descripcion":"FORMA TRIANGULAR ANORMAL CONGÉNITA DE FALANGE MEDIA DE SEGUNDO DEDO DE PIE"
  },
  {
    "codigo":404113004,
    "descripcion":"MICOSIS FUNGOIDE, ESTADIO TUMORAL"
  },
  {
    "codigo":1256081007,
    "descripcion":"PIODERMA GANGRENOSO PUSTULAR"
  },
  {
    "codigo":369510000,
    "descripcion":"TUMOR MALIGNO QUE COMPROMETE LA VULVA POR PROPAGACIÓN DIRECTA DEL CUELLO UTERINO"
  },
  {
    "codigo":240273009,
    "descripcion":"AFLOJAMIENTO DE DISPOSITIVO DE FIJACIÓN ÓSEO"
  },
  {
    "codigo":1155942004,
    "descripcion":"ALERGIA A METAL Y\/O COMPUESTO METÁLICO"
  },
  {
    "codigo":238438006,
    "descripcion":"INFECCIÓN DE LA PIEL POR SCYTALIDIUM HYALINUM"
  },
  {
    "codigo":9062008,
    "descripcion":"OTOTOXICIDAD"
  },
  {
    "codigo":74598008,
    "descripcion":"ABSCESO PERIAPICAL CON TRACTO SINUSAL"
  },
  {
    "codigo":762726008,
    "descripcion":"DERMATITIS ALÉRGICA POR CONTACTO OCUPACIONAL CAUSADA POR VESTIMENTA"
  },
  {
    "codigo":302139001,
    "descripcion":"RECIBE EDUCACIÓN EN EL HOGAR"
  },
  {
    "codigo":105531004,
    "descripcion":"CONDICIONES DE VIVIENDA INSATISFACTORIAS"
  },
  {
    "codigo":1186875006,
    "descripcion":"MIELOPATÍA DEBIDA A FLUOROSIS"
  },
  {
    "codigo":38160000,
    "descripcion":"VOZ ANORMAL"
  },
  {
    "codigo":236603009,
    "descripcion":"ACODAMIENTO DE URÉTER"
  },
  {
    "codigo":890128002,
    "descripcion":"SÍNDROME DE DELECIÓN 9P24.3"
  },
  {
    "codigo":300304003,
    "descripcion":"ASPIRADO GÁSTRICO CON CONTENIDO ALCOHÓLICO"
  },
  {
    "codigo":396773000,
    "descripcion":"RETE TESTIS COMPROMETIDA POR EXTENSIÓN DIRECTA DE NEOPLASIA MALIGNA"
  },
  {
    "codigo":724453005,
    "descripcion":"PROBLEMA DE PRÓSTATA"
  },
  {
    "codigo":69093006,
    "descripcion":"SÍNDROME DE ROTHMUND - THOMSON"
  },
  {
    "codigo":298469007,
    "descripcion":"AMPLITUD DE ROTACIÓN PASIVA HACIA LA IZQUIERDA DE LA COLUMNA CERVICAL AUMENTADA"
  },
  {
    "codigo":11834911000119108,
    "descripcion":"SUBLUXACIÓN DE ARTICULACIÓN CARPOMETACARPIANA DE PULGAR DERECHO"
  },
  {
    "codigo":370952005,
    "descripcion":"TIEMPO DE RUPTURA DE LA PELÍCULA LAGRIMAL DISMINUIDO"
  },
  {
    "codigo":296634005,
    "descripcion":"SOBREDOSIS DE TRIMETOPRIMA"
  },
  {
    "codigo":165562007,
    "descripcion":"PRUEBAS DE COAGULACIÓN\/SANGRADO NORMALES"
  },
  {
    "codigo":722618009,
    "descripcion":"CONTUSIÓN NO HEMORRÁGICA FOCAL DE CEREBELO"
  },
  {
    "codigo":196495004,
    "descripcion":"FÍSTULA DE GLÁNDULA PARÓTIDA"
  },
  {
    "codigo":294799006,
    "descripcion":"ALERGIA A ERGOLINA"
  },
  {
    "codigo":425871007,
    "descripcion":"ESPONDILOLISTESIS CONGÉNITA DE VÉRTEBRA CERVICAL"
  },
  {
    "codigo":130959009,
    "descripcion":"TRASTORNO EN EL RECAMBIO DE LÍQUIDO AMNIÓTICO"
  },
  {
    "codigo":292964001,
    "descripcion":"REACCIÓN ADVERSA A LA FLUCLOXACILINA"
  },
  {
    "codigo":161892003,
    "descripcion":"DORSALGIA CON IRRADIACIÓN"
  },
  {
    "codigo":1144932004,
    "descripcion":"VASCULITIS DE PEQUEÑOS VASOS POR INMUNOCOMPLEJOS DEBIDA A ENFERMEDAD INFECCIOSA"
  },
  {
    "codigo":94521000,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE COSTILLA"
  },
  {
    "codigo":127289003,
    "descripcion":"LUXACIÓN TRAUMÁTICA LATERAL NO EXPUESTA DE LA ARTICULACIÓN SUBASTRAGALINA"
  },
  {
    "codigo":225593006,
    "descripcion":"ESPARCIR LAS HECES"
  },
  {
    "codigo":59918000,
    "descripcion":"LACERACIÓN CEREBELOSA CON HERIDA INTRACRANEAL ABIERTA Y CONMOCIÓN"
  },
  {
    "codigo":289294000,
    "descripcion":"LÍQUIDO AMNIÓTICO TEÑIDO CON MECONIO ESPESO"
  },
  {
    "codigo":92686000,
    "descripcion":"CARCINOMA IN SITU DE LA REGIÓN POSCRICOIDEA"
  },
  {
    "codigo":15740601000119109,
    "descripcion":"ASTIGMATISMO ALTO DE OJO IZQUIERDO"
  },
  {
    "codigo":420366008,
    "descripcion":"EXTENSIÓN TUMORAL EXTRAPROSTÁTICA PRESENTE, LOCALIZADA"
  },
  {
    "codigo":123619001,
    "descripcion":"FRACTURA DE COLLES INVERTIDA EXPUESTA"
  },
  {
    "codigo":254691005,
    "descripcion":"NEOPLASIA BENIGNA DE PIEL CON DIFERENCIACIÓN PILOSA"
  },
  {
    "codigo":418531007,
    "descripcion":"ENFERMEDAD NEUROINVASIVA POR VIRUS DEL SEROGRUPO CALIFORNIA"
  },
  {
    "codigo":189155007,
    "descripcion":"NEOPLASIA BENIGNA DE SACO LAGRIMAL"
  },
  {
    "codigo":416696002,
    "descripcion":"ATENDIDO EN CONSULTORIO EXTRAHOSPITALARIO DE ENFERMERÍA ESPECIALIZADO EN DIABETES"
  },
  {
    "codigo":89016005,
    "descripcion":"DIAGNÓSTICO EN EL EJE III"
  },
  {
    "codigo":285624007,
    "descripcion":"ADMINISTRA EL TIEMPO"
  },
  {
    "codigo":440541000124104,
    "descripcion":"INGESTA EXCESIVA DE PROTEÍNA DE SOJA"
  },
  {
    "codigo":87181002,
    "descripcion":"HIPERPLASIA DE LAS CÉLULAS ALFA DE LOS ISLOTES PANCREÁTICOS CON EXCESO DE GLUCAGÓN"
  },
  {
    "codigo":283789008,
    "descripcion":"MORDEDURA DE ANIMAL EN LA CABEZA Y EL CUELLO"
  },
  {
    "codigo":249186004,
    "descripcion":"COÁGULOS DE SANGRE EN LAS MEMBRANAS"
  },
  {
    "codigo":183650005,
    "descripcion":"SEGUIMIENTO DE RADIOTERAPIA"
  },
  {
    "codigo":871778008,
    "descripcion":"EDEMA DE MÁCULA CON COMPROMISO CENTRAL DEBIDO A DIABETES MELLITUS"
  },
  {
    "codigo":1230391007,
    "descripcion":"SOCIALIZACIÓN ADECUADA"
  },
  {
    "codigo":442124003,
    "descripcion":"EVALUACIÓN DE CARIOTIPO, ANORMAL"
  },
  {
    "codigo":212748006,
    "descripcion":"INTOXICACIÓN CON ÁCIDO ETACRÍNICO"
  },
  {
    "codigo":278284007,
    "descripcion":"HEMIPLEJÍA DERECHA"
  },
  {
    "codigo":16140007,
    "descripcion":"INFECCIÓN POR ACTINOBACILLUS"
  },
  {
    "codigo":702433001,
    "descripcion":"CATARATAS CONGÉNITAS, DISMORFISMO FACIAL Y NEUROPATÍA"
  },
  {
    "codigo":1259489002,
    "descripcion":"CARCINOMA DE CÉLULAS RENALES PRIMARIO"
  },
  {
    "codigo":735201003,
    "descripcion":"FRACTURA EXPUESTA DE CALCÁNEO IZQUIERDO"
  },
  {
    "codigo":1357793004,
    "descripcion":"UNO DE EMBARAZO MÚLTIPLE"
  },
  {
    "codigo":15988871000119101,
    "descripcion":"CONJUNTIVITIS NEONATAL DE AMBOS OJOS CAUSADA POR NEISSERIA GONORRHOEAE"
  },
  {
    "codigo":274614000,
    "descripcion":"LATIDO DEL VÉRTICE DESPLAZADO - HIPERTROFIA DE VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":241846007,
    "descripcion":"EFECTO TÓXICO CAUSADO POR LIMPIADOR PARA BAÑOS"
  },
  {
    "codigo":305547000,
    "descripcion":"BAJO ATENCIÓN DE CIRUJANO PEDIÁTRICO"
  },
  {
    "codigo":76171001,
    "descripcion":"ATRAPAMIENTO AÉREO"
  },
  {
    "codigo":371083004,
    "descripcion":"MAXILAR SUPERIOR PARCIALMENTE EDÉNTULO"
  },
  {
    "codigo":403851005,
    "descripcion":"CALCINOSIS SECUNDARIA A LESIÓN TRAUMÁTICA POR PUNCIÓN DEL TALÓN EN EL RECIÉN NACIDO"
  },
  {
    "codigo":1155680000,
    "descripcion":"ACCESO LIMITADO A FUENTES NUTRICIONALES"
  },
  {
    "codigo":926304005,
    "descripcion":"NEUROPATÍA IATROGÉNICA"
  },
  {
    "codigo":8800006,
    "descripcion":"PSEUDOHERMAFRODITISMO FEMENINO"
  },
  {
    "codigo":170805002,
    "descripcion":"DESEA ADELGAZAR"
  },
  {
    "codigo":400181003,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN"
  },
  {
    "codigo":72501006,
    "descripcion":"ANEMIA CAUSADA POR HIDRURO DE ARSÉNICO"
  },
  {
    "codigo":6965008,
    "descripcion":"OTITIS MEDIA SUBAGUDA NO SUPURATIVA"
  },
  {
    "codigo":300042001,
    "descripcion":"SEGUIMIENTO POR 6 MESES"
  },
  {
    "codigo":201738001,
    "descripcion":"ARTRITIS POSTERIOR A SÍFILIS"
  },
  {
    "codigo":11784481000119103,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE DEDO ANULAR IZQUIERDO"
  },
  {
    "codigo":365578007,
    "descripcion":"HALLAZGO RELACIONADO CON UN MOVIMIENTO O CREENCIA RELIGIOSA"
  },
  {
    "codigo":234506007,
    "descripcion":"RUPTURA DE BAZO"
  },
  {
    "codigo":429279006,
    "descripcion":"ATENDIDO EN CONSULTORIO ESPECIALIZADO EN EPILEPSIA"
  },
  {
    "codigo":1344948000,
    "descripcion":"DELIRIO CAUSADO POR ALUCINÓGENO"
  },
  {
    "codigo":298207009,
    "descripcion":"LAXITUD DE ARTICULACIÓN DE HOMBRO"
  },
  {
    "codigo":198068005,
    "descripcion":"EDEMA DE LOS ÓRGANOS GENITALES MASCULINOS"
  },
  {
    "codigo":787892008,
    "descripcion":"LACTICASEIBACILLUS CASEI O LACTICASEIBACILLUS PARACASEI"
  },
  {
    "codigo":296372008,
    "descripcion":"SOBREDOSIS DE SIMPATICOMIMÉTICO"
  },
  {
    "codigo":128862000,
    "descripcion":"SEUDOLINFOMA CUTÁNEO"
  },
  {
    "codigo":194398001,
    "descripcion":"DISCRIMINACIÓN AUDITIVA DAÑADA"
  },
  {
    "codigo":32393008,
    "descripcion":"INTOXICACIÓN POR FLUOROURACILO"
  },
  {
    "codigo":720521008,
    "descripcion":"MACROTROMBOCITOPENIA AUTOSÓMICA DOMINANTE"
  },
  {
    "codigo":294537009,
    "descripcion":"ALERGIA A CEFAZOLINA"
  },
  {
    "codigo":292702007,
    "descripcion":"REACCIÓN ADVERSA AL FLAVOXATO"
  },
  {
    "codigo":718686007,
    "descripcion":"ÁCIDO DESOXIRRIBONUCLEICO DE ESPECIE DE SHIGELLA O ESCHERICHIA COLI ENTEROINVASIVA DETECTADO"
  },
  {
    "codigo":16057631000119100,
    "descripcion":"PARÁLISIS FACIAL DERECHA GRADO II DE HOUSE-BRACKMANN"
  },
  {
    "codigo":10942751000119100,
    "descripcion":"CONMOCIÓN DE RETINA DERECHA"
  },
  {
    "codigo":15980831000119102,
    "descripcion":"ANOMALÍA ESTRUCTURAL CONGÉNITA DE PÁRPADO DERECHO"
  },
  {
    "codigo":1091871000119103,
    "descripcion":"ACÚFENO PULSÁTIL OBJETIVO DEL OÍDO DERECHO"
  },
  {
    "codigo":298271000119104,
    "descripcion":"MIOSITIS OSIFICANTE TRAUMÁTICA DE BRAZO"
  },
  {
    "codigo":94259009,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL CÓCCIX"
  },
  {
    "codigo":127027008,
    "descripcion":"NEOPLASIA DE PARAGANGLIO"
  },
  {
    "codigo":288031000119105,
    "descripcion":"TRASTORNO INDUCIDO POR ALCOHOL CONCOMITANTE CON DEPENDENCIA DEL ALCOHOL Y DEBIDO A ELLA"
  },
  {
    "codigo":62751000119108,
    "descripcion":"HEMOFILIA FETAL"
  },
  {
    "codigo":10676511000119109,
    "descripcion":"EXACERBACIÓN SEVERA AGUDA DE ASMA ALÉRGICA MODERADA PERSISTENTE CONCOMITANTE CON RINITIS ALÉRGICA"
  },
  {
    "codigo":753480991000119109,
    "descripcion":"PÉRDIDA DE CONSCIENCIA DEBIDA A HEMORRAGIA EPIDURAL INTRACRANEAL"
  },
  {
    "codigo":142111000119108,
    "descripcion":"ECTASIA DE AORTA TORÁCICA"
  },
  {
    "codigo":25053000,
    "descripcion":"COMPLICACIÓN OBSTÉTRICA DEL SISTEMA NERVIOSO CENTRAL POR LA ANESTESIA Y\/O LA SEDACIÓN"
  },
  {
    "codigo":16034591000119109,
    "descripcion":"HIPERTROFIA DE HUESO DE OMÓPLATO IZQUIERDO"
  },
  {
    "codigo":1076511000119107,
    "descripcion":"PELLIZCAMIENTO SUBCORACOIDEO DE REGIÓN DEL HOMBRO DERECHO"
  },
  {
    "codigo":713181003,
    "descripcion":"ENFERMEDAD HEPÁTICA ALCOHÓLICA CRÓNICA"
  },
  {
    "codigo":92424005,
    "descripcion":"NEOPLASIA BENIGNA DEL ASTRÁGALO"
  },
  {
    "codigo":451037005,
    "descripcion":"HEMORRAGIA EN GLOBO PÁLIDO"
  },
  {
    "codigo":10643231000119109,
    "descripcion":"ÚLCERA VARICOSA DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":1237469002,
    "descripcion":"METÁSTASIS DE CARCINOMA ESCAMOSO EN BRONQUIO DE LÓBULO INFERIOR IZQUIERDO"
  },
  {
    "codigo":187058000,
    "descripcion":"HISTOPLASMOSIS CON RETINITIS"
  },
  {
    "codigo":254429009,
    "descripcion":"NEOPLASIA BENIGNA DE PORCIÓN ANTERIOR DE PISO DE BOCA"
  },
  {
    "codigo":344661000119103,
    "descripcion":"OCLUSIÓN PARCIAL DE ARTERIA RETINIANA DE AMBOS OJOS"
  },
  {
    "codigo":283527005,
    "descripcion":"HERIDA PUNZANTE DE REGIÓN PÉLVICA"
  },
  {
    "codigo":185223006,
    "descripcion":"ATENDIDO EN CONSULTORIO ESPECIALIZADO EN OTORRINOLARINGOLOGÍA"
  },
  {
    "codigo":871516001,
    "descripcion":"REACCIÓN ADVERSA A CARBONATO DE CALCIO Y\/O ÁCIDO ETIDRÓNICO"
  },
  {
    "codigo":609372001,
    "descripcion":"ESCALA DE CALIFICACIÓN DEL COMPORTAMIENTO DE FRANKL POSITIVA"
  },
  {
    "codigo":1363036003,
    "descripcion":"METABOLIZADOR INTERMEDIO DE FAMILIA 2 SUBFAMILIA C MIEMBRO 9 *5\/*5 DE CITOCROMO P450"
  },
  {
    "codigo":1197361002,
    "descripcion":"SÍNDROME LINFOPROLIFERATIVO AUTOINMUNITARIO DEBIDO A HAPLOINSUFICIENCIA DE ANTÍGENO 4 DE LINFOCITOS T CITOTÓXICOS"
  },
  {
    "codigo":16046831000119101,
    "descripcion":"ENFERMEDAD POR DEPÓSITO DE HIDROXIAPATITA DE AMBOS PIES"
  },
  {
    "codigo":771377004,
    "descripcion":"CORYNEBACTERIUM AMYCOLATUM O CORYNEBACTERIUM XEROSIS"
  },
  {
    "codigo":41608004,
    "descripcion":"FRACTURAS NO EXPUESTAS DE HUESOS DE TARSO Y METATARSO"
  },
  {
    "codigo":278022001,
    "descripcion":"BALANCE HÍDRICO NEUTRO"
  },
  {
    "codigo":212486001,
    "descripcion":"LESIONES MÚLTIPLES DEL CUELLO"
  },
  {
    "codigo":440027000,
    "descripcion":"INFILTRADO CORNEAL"
  },
  {
    "codigo":472795006,
    "descripcion":"ESTENOSIS SUBAÓRTICA ADQUIRIDA DEBIDA A DEFECTO RESTRICTIVO DE TABIQUE INTERVENTRICULAR ASOCIADA CON CORAZÓN FUNCIONALMENTE UNIVENTRICULAR"
  },
  {
    "codigo":896944002,
    "descripcion":"FORMA DE BALA ANORMAL CONGÉNITA DE FALANGE MEDIA DE SEGUNDO DEDO DE PIE"
  },
  {
    "codigo":208816002,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN MEDIOCARPIANA"
  },
  {
    "codigo":700336004,
    "descripcion":"ARTROSIS DE PRIMERA ARTICULACIÓN METATARSOFALÁNGICA SECUNDARIA A ARTRITIS INFLAMATORIA"
  },
  {
    "codigo":15692681000119101,
    "descripcion":"QUERATITIS DISCIFORME DE AMBOS OJOS CAUSADA POR VIRUS HERPES SIMPLE HUMANO"
  },
  {
    "codigo":698501003,
    "descripcion":"CONTUSIÓN DE MÚLTIPLES SITIOS DE HOMBRO"
  },
  {
    "codigo":205146000,
    "descripcion":"SINDACTILIA SIMPLE DE SEGUNDO A QUINTO DEDOS DEL PIE"
  },
  {
    "codigo":239749008,
    "descripcion":"SUBLUXACIÓN HABITUAL DE ARTICULACIÓN"
  },
  {
    "codigo":291721000119102,
    "descripcion":"AFASIA DEBIDA A HEMORRAGIA INTRACEREBRAL NO TRAUMÁTICA Y POSTERIOR A ELLA"
  },
  {
    "codigo":1352026003,
    "descripcion":"INMUNODEFICIENCIA COMBINADA VARIABLE AUTOSÓMICA DOMINANTE DEBIDA A MUTACIÓN DE TWEAK"
  },
  {
    "codigo":428487561000119102,
    "descripcion":"CARCINOMA PRIMARIO DE CÉLULAS BASALES DE PIEL DE PIE IZQUIERDO"
  },
  {
    "codigo":8538000,
    "descripcion":"INTOXICACIÓN POR BRASSICA SINAPIS"
  },
  {
    "codigo":237914002,
    "descripcion":"DEFICIENCIA DE 6-PIRUVOILTETRAHIDROBIOPTERINA SINTASA"
  },
  {
    "codigo":303450002,
    "descripcion":"INCAPAZ DE ACUCLILLARSE SOBRE EL INODORO"
  },
  {
    "codigo":72239002,
    "descripcion":"DOLICOCEFALIA"
  },
  {
    "codigo":1153583005,
    "descripcion":"DELECIÓN PARCIAL DEL BRAZO CORTO DEL CROMOSOMA 5"
  },
  {
    "codigo":6703006,
    "descripcion":"HIPERPLASIA DE LOBULILLO MAMARIO"
  },
  {
    "codigo":236079006,
    "descripcion":"ESCURRIMIENTO FECAL PERINEAL"
  },
  {
    "codigo":170543008,
    "descripcion":"REQUIERE UNA DOSIS DE VACUNA ANTIRRÁBICA"
  },
  {
    "codigo":365316001,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA REALIZAR LA LIMPIEZA DOMÉSTICA"
  },
  {
    "codigo":299780000,
    "descripcion":"REFLEJO DE OJOS DE MUÑECA PRESENTE"
  },
  {
    "codigo":37636003,
    "descripcion":"FROTE PLEURAL"
  },
  {
    "codigo":1348356003,
    "descripcion":"DOLOR DE ARTICULACIÓN DE CADERA"
  },
  {
    "codigo":301615007,
    "descripcion":"NO SE MANEJA EN ESCALONES"
  },
  {
    "codigo":430852001,
    "descripcion":"DEPRESIÓN MAYOR GRAVE, ÚNICO EPISODIO, CON CARACTERÍSTICAS PSICÓTICAS"
  },
  {
    "codigo":297945000,
    "descripcion":"LESIÓN DE NERVIO DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":3033000,
    "descripcion":"TRASTORNO DE LOS HUESOS Y\/O DE LAS ARTICULACIONES DE LA PELVIS MATERNA QUE COMPLICA EL EMBARAZO, EL PARTO Y\/O EL PUERPERIO"
  },
  {
    "codigo":232409002,
    "descripcion":"ESTENOSIS TRAUMÁTICA DE FARINGE"
  },
  {
    "codigo":363481002,
    "descripcion":"NEOPLASIA MALIGNA DE GLÁNDULA PARATIROIDES"
  },
  {
    "codigo":68569003,
    "descripcion":"TRASTORNO BIPOLAR I MANÍACO"
  },
  {
    "codigo":396249007,
    "descripcion":"MARGEN QUIRÚRGICO ENDOCERVICAL NO COMPROMETIDO POR NEOPLASIA INTRAEPITELIAL"
  },
  {
    "codigo":230574001,
    "descripcion":"POLINEUROPATÍA DOLOROSA AGUDA DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":296110001,
    "descripcion":"SOBREDOSIS DE PRAZEPAM"
  },
  {
    "codigo":294275005,
    "descripcion":"ALERGIA A ANTAGONISTA DE RECEPTOR OPIOIDE"
  },
  {
    "codigo":63064000,
    "descripcion":"ABSCESO INTRADIAFRAGMÁTICO"
  },
  {
    "codigo":95832001,
    "descripcion":"SECRECIÓN ECTÓPICA DE PROLACTINA"
  },
  {
    "codigo":1144408000,
    "descripcion":"HIPOPLASIA CONGÉNITA DE MÁCULA LÚTEA"
  },
  {
    "codigo":347171000119106,
    "descripcion":"AFAQUIA DE AMBOS OJOS"
  },
  {
    "codigo":292440006,
    "descripcion":"REACCIÓN ADVERSA AL PROPRANOLOL"
  },
  {
    "codigo":128600008,
    "descripcion":"COLITIS ULCEROSA AGUDA"
  },
  {
    "codigo":1177176009,
    "descripcion":"EPIDERMÓLISIS AMPOLLOSA SIMPLE INTERMEDIA CON MIOCARDIOPATÍA"
  },
  {
    "codigo":126765001,
    "descripcion":"OBSTRUCCIÓN GASTROINTESTINAL"
  },
  {
    "codigo":1084451000119108,
    "descripcion":"ESTENOSIS TRAUMÁTICA DE AMBOS CONDUCTOS AUDITIVOS EXTERNOS"
  },
  {
    "codigo":93997008,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE OMÓPLATO"
  },
  {
    "codigo":419842002,
    "descripcion":"CARCINOMA ESCAMOCELULAR DE LA MEMBRANA MUCOSA BUCAL"
  },
  {
    "codigo":92162003,
    "descripcion":"NEOPLASIA BENIGNA DE YEYUNO"
  },
  {
    "codigo":288770006,
    "descripcion":"INCAPAZ DE DIRIGIR LA ATENCIÓN"
  },
  {
    "codigo":254167000,
    "descripcion":"ERITRODERMIA ICTIOSIFORME BULLOSA"
  },
  {
    "codigo":59394009,
    "descripcion":"SADISMO SEXUAL"
  },
  {
    "codigo":188631008,
    "descripcion":"ENFERMEDAD DE SÉZARY DE GANGLIOS LINFÁTICOS INTRATORÁCICOS"
  },
  {
    "codigo":186796004,
    "descripcion":"PALUDISMO CAUSADO POR PLASMODIUM MALARIAE, CON NEFROPATÍA"
  },
  {
    "codigo":88492006,
    "descripcion":"DESTRUCCIÓN ANORMAL DE ERITROCITOS"
  },
  {
    "codigo":840321001,
    "descripcion":"SIGNOS DE ABSTINENCIA DE DROGAS"
  },
  {
    "codigo":283265002,
    "descripcion":"VIDRIO EN INGLE"
  },
  {
    "codigo":53889007,
    "descripcion":"CATARATA NUCLEAR"
  },
  {
    "codigo":19286001,
    "descripcion":"QUISTE DE LA VESÍCULA BILIAR"
  },
  {
    "codigo":52054003,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE LA MUÑECA"
  },
  {
    "codigo":707414004,
    "descripcion":"TROMBOEMBOLIA PULMONAR AGUDA"
  },
  {
    "codigo":248662005,
    "descripcion":"PULSACIÓN EXTRACARDÍACA ASOCIADA CON LATIDO CARDÍACO"
  },
  {
    "codigo":314198003,
    "descripcion":"LUXACIÓN DE ARTICULACIÓN CIGOAPOFISARIA LUMBAR"
  },
  {
    "codigo":281430007,
    "descripcion":"FALLA DE INJERTO TENDINOSO"
  },
  {
    "codigo":1231702003,
    "descripcion":"TRASTORNO DE RETINA DEBIDO A RASGO DREPANOCÍTICO"
  },
  {
    "codigo":445270008,
    "descripcion":"ORIFICIO AÓRTICO A LA IZQUIERDA JUNTO AL ORIFICIO PULMONAR"
  },
  {
    "codigo":115755003,
    "descripcion":"FENOTIPO I"
  },
  {
    "codigo":50219008,
    "descripcion":"VOZ RONCA"
  },
  {
    "codigo":771115008,
    "descripcion":"HIPERNATREMIA"
  },
  {
    "codigo":212224003,
    "descripcion":"LESIÓN DE LA RAÍZ DEL NERVIO SACRO - S2"
  },
  {
    "codigo":15616006,
    "descripcion":"TRASTORNO DEL METABOLISMO DE LOS OLIGOELEMENTOS"
  },
  {
    "codigo":81152009,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DE REGIÓN ESCAPULAR"
  },
  {
    "codigo":275925003,
    "descripcion":"LLANTO EXCESIVO DE UN NIÑO"
  },
  {
    "codigo":46549005,
    "descripcion":"LESIONES TRAUMÁTICAS MÚLTIPLES DE LA MÉDULA ESPINAL SIN LESIÓN ÓSEA"
  },
  {
    "codigo":110250005,
    "descripcion":"CONTUSIÓN DE LA BOCA"
  },
  {
    "codigo":763775000,
    "descripcion":"SÍNDROME DE QUERATOSIS LINEAL, ICTIOSIS CONGÉNITA Y QUERATODERMIA ESCLEROSANTE"
  },
  {
    "codigo":403327006,
    "descripcion":"EFLUVIO TELÓGENO DEL RECIÉN NACIDO"
  },
  {
    "codigo":270420001,
    "descripcion":"ATENDIDO EN SU PROPIO DOMICILIO"
  },
  {
    "codigo":237652003,
    "descripcion":"RESISTENCIA INSULÍNICA - TIPO B"
  },
  {
    "codigo":1251625001,
    "descripcion":"DERMATITIS DE CONTACTO DE CUELLO"
  },
  {
    "codigo":39209001,
    "descripcion":"CONTRACCIÓN DE ÓRBITA OCULAR DESPUÉS DE PROCEDIMIENTO DE ENUCLEACIÓN"
  },
  {
    "codigo":15668721000119107,
    "descripcion":"DEFORMIDAD CONGÉNITA DE AMBOS PIES"
  },
  {
    "codigo":6441003,
    "descripcion":"VÓLVULO DE COLON"
  },
  {
    "codigo":268585006,
    "descripcion":"INFARTO PLACENTARIO"
  },
  {
    "codigo":203049007,
    "descripcion":"ENFERMEDAD DE DUPUYTREN DE DEDO DE LA MANO"
  },
  {
    "codigo":235817009,
    "descripcion":"ROTACIÓN PATOLÓGICA DEL INTESTINO, TIPO IIIB"
  },
  {
    "codigo":266750002,
    "descripcion":"SIN SEGUIMIENTO CONVENIDO"
  },
  {
    "codigo":299518003,
    "descripcion":"ARTICULACIÓN DEL PIE - ROJA"
  },
  {
    "codigo":102910004,
    "descripcion":"PENSAMIENTO PRELÓGICO"
  },
  {
    "codigo":1217022005,
    "descripcion":"COLONIZACIÓN DE APARATO GENITOURINARIO POR STREPTOCOCCUS AGALACTIAE"
  },
  {
    "codigo":233982006,
    "descripcion":"ANEURISMA CIRSOIDE"
  },
  {
    "codigo":70142008,
    "descripcion":"COMUNICACIÓN INTERAURICULAR"
  },
  {
    "codigo":232147001,
    "descripcion":"AMBLIOPÍA ANISOMETRÓPICA"
  },
  {
    "codigo":365054009,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA JUGAR CON LAS PALABRAS Y LOS SIGNIFICADOS"
  },
  {
    "codigo":397822009,
    "descripcion":"EXOTROPÍA SECUNDARIA"
  },
  {
    "codigo":166611006,
    "descripcion":"BILIRRUBINA SÉRICA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":363219007,
    "descripcion":"TRASTORNO GASTROINTESTINAL NEONATAL"
  },
  {
    "codigo":295848003,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE CLOMIPRAMINA"
  },
  {
    "codigo":230312006,
    "descripcion":"SÍNDROME DE AICARDI GOUTIERES"
  },
  {
    "codigo":787368007,
    "descripcion":"METABOLIZADOR NORMAL DE LA FAMILIA 1 SUBFAMILIA A MIEMBRO 2 DEL CITOCROMO P450"
  },
  {
    "codigo":263080008,
    "descripcion":"FRACTURA-LUXACIÓN DE LA ARTICULACIÓN RADIOCARPIANA"
  },
  {
    "codigo":294013000,
    "descripcion":"ALERGIA A DISTIGMINA"
  },
  {
    "codigo":721832006,
    "descripcion":"INFECCIÓN CAUSADA POR WUCHERERIA"
  },
  {
    "codigo":195709006,
    "descripcion":"FARINGOLARINGITIS"
  },
  {
    "codigo":292178004,
    "descripcion":"REACCIÓN ADVERSA A LA CINCOCAÍNA"
  },
  {
    "codigo":783698005,
    "descripcion":"PARAPLEJÍA ESPÁSTICA AUTOSÓMICA DOMINANTE TIPO 13"
  },
  {
    "codigo":95570007,
    "descripcion":"CÁLCULO RENAL"
  },
  {
    "codigo":290343001,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR COMPUESTO DE BISMUTO"
  },
  {
    "codigo":192039002,
    "descripcion":"ESTADO DE ESTUPOR AGUDO POR REACCIÓN A ESTRÉS AGUDO"
  },
  {
    "codigo":161106009,
    "descripcion":"MIEMBRO DE LA SOCIEDAD DE PARKINSON"
  },
  {
    "codigo":60967006,
    "descripcion":"VAGINITIS ALÉRGICA"
  },
  {
    "codigo":421415007,
    "descripcion":"ENCEFALITIS SUBAGUDA POR ADENOVIRUS CON SÍNDROME DE INMUNODEFICIENCIA ADQUIRIDA"
  },
  {
    "codigo":126503008,
    "descripcion":"NEOPLASIA DE LA PIEL DE LA REGIÓN TEMPORAL"
  },
  {
    "codigo":91900007,
    "descripcion":"AUSENCIA CONGÉNITA DE HUESO NASAL"
  },
  {
    "codigo":253905000,
    "descripcion":"MEGAURETRA"
  },
  {
    "codigo":1204177001,
    "descripcion":"OCLUSIÓN AGUDA DE ARTERIA SUBCLAVIA DEBIDA A TROMBOEMBOLISMO"
  },
  {
    "codigo":124668009,
    "descripcion":"DEFICIENCIA DE MANOSA - 6 - FOSFATO ISOMERASA"
  },
  {
    "codigo":712657002,
    "descripcion":"INFECCIÓN CAUSADA POR FUSOBACTERIUM"
  },
  {
    "codigo":1236945002,
    "descripcion":"METÁSTASIS DE CARCINOMA DE LÍNEA MEDIA DE LENGUA"
  },
  {
    "codigo":24529006,
    "descripcion":"ALTERACIÓN DEL POTASIO"
  },
  {
    "codigo":286673007,
    "descripcion":"IDENTIFICACIÓN CON EL AGRESOR - MECANISMO DE DEFENSA PSICOLÓGICA"
  },
  {
    "codigo":679871000119102,
    "descripcion":"REACCIÓN PUPILAR TÓNICA BILATERAL"
  },
  {
    "codigo":88230002,
    "descripcion":"TRASTORNO DEL SISTEMA ESQUELÉTICO"
  },
  {
    "codigo":284838006,
    "descripcion":"DIFICULTAD PARA LIMPIARSE LA BOCA"
  },
  {
    "codigo":1003899001,
    "descripcion":"DELECIÓN PROXIMAL DEL BRAZO LARGO DEL CROMOSOMA 3"
  },
  {
    "codigo":15998911000119104,
    "descripcion":"INFECCIÓN DE OJO DERECHO CAUSADA POR NEISSERIA GONORRHOEAE"
  },
  {
    "codigo":250235004,
    "descripcion":"CUERPO DE PAPPENHEIMER"
  },
  {
    "codigo":53627009,
    "descripcion":"FRACTURA NO EXPUESTA DE RADIO Y CÚBITO"
  },
  {
    "codigo":1264208005,
    "descripcion":"TRASTORNO NEONATAL CAUSADO POR MEDICACIÓN ANTIHIPERTENSIVA MATERNA TRANSMITIDA POR LECHE MATERNA"
  },
  {
    "codigo":707152007,
    "descripcion":"INMUNODEFICIENCIA FAGOCÍTICA"
  },
  {
    "codigo":445008009,
    "descripcion":"GANGLIÓN"
  },
  {
    "codigo":279333002,
    "descripcion":"TRASTORNO PRURIGINOSO"
  },
  {
    "codigo":82725007,
    "descripcion":"MIOSITIS OSIFICANTE PROGRESIVA"
  },
  {
    "codigo":1196837008,
    "descripcion":"NEOPLASIA NEUROEPITELIAL DISEMBRIOPLÁSICA DE CEREBRO"
  },
  {
    "codigo":246565009,
    "descripcion":"DESCUIDO DEL LADO AFECTADO"
  },
  {
    "codigo":15726681000119102,
    "descripcion":"ANQUILOSIS DE ARTICULACIÓN DE AMBOS CODOS"
  },
  {
    "codigo":80890005,
    "descripcion":"ESPOROTRICOSIS CUTÁNEA"
  },
  {
    "codigo":310266005,
    "descripcion":"ANTICUERPO ANTI - SCL 70 NO DETECTADO"
  },
  {
    "codigo":408570008,
    "descripcion":"DOPPLER DE ARTERIA CARÓTIDA, NORMAL"
  },
  {
    "codigo":898255002,
    "descripcion":"ANQUILOSIS CONGÉNITA DE ARTICULACIÓN INTERFALÁNGICA DE DEDO ANULAR"
  },
  {
    "codigo":767183004,
    "descripcion":"GANGLIÓN DE CODO"
  },
  {
    "codigo":699812002,
    "descripcion":"HETEROTOPÍA NODULAR SUBEPENDIMARIA"
  },
  {
    "codigo":44452003,
    "descripcion":"ANEMIA NORMOCÍTICA HIPOCRÓMICA"
  },
  {
    "codigo":109988003,
    "descripcion":"SARCOMA HISTIOCÍTICO (CLÍNICO)"
  },
  {
    "codigo":1156729001,
    "descripcion":"LESIÓN VASCULAR DE PIEL"
  },
  {
    "codigo":1255033005,
    "descripcion":"RUPTURA TRAUMÁTICA DE LIGAMENTO DE ARTICULACIÓN DE DEDO ÍNDICE"
  },
  {
    "codigo":403065006,
    "descripcion":"TIÑA CAUSADA POR EPIDERMOPHYTON FLOCCOSUM"
  },
  {
    "codigo":206457007,
    "descripcion":"ICTERICIA NEONATAL CON HIPOTIROIDISMO CONGÉNITO"
  },
  {
    "codigo":697977007,
    "descripcion":"ÚLCERA DE MUCOSA BUCAL"
  },
  {
    "codigo":302926001,
    "descripcion":"CICATRIZ DE CUELLO UTERINO"
  },
  {
    "codigo":40782004,
    "descripcion":"SÍNDROME DE HENNEBERT"
  },
  {
    "codigo":1351502005,
    "descripcion":"DEFICIENCIA DE CLASE II DEL COMPLEJO MAYOR DE HISTOCOMPATIBILIDAD DEBIDA A MUTACIÓN DE CIITA (TRANSACTIVADOR DEL COMPLEJO MAYOR DE HISTOCOMPATIBILIDAD CLASE II)"
  },
  {
    "codigo":401230005,
    "descripcion":"PLANES PARA LLEVAR A CABO LESIÓN AUTOINFLIGIDA DELIBERADA SIN PROPÓSITO"
  },
  {
    "codigo":8014007,
    "descripcion":"PRESENTACIÓN CEFÁLICA DE BREGMA"
  },
  {
    "codigo":1251363001,
    "descripcion":"REACCIÓN CUTÁNEA POR CONTACTO CON PORIFERA"
  },
  {
    "codigo":202787002,
    "descripcion":"ESTENOSIS IDIOPÁTICA DE CONDUCTO RAQUÍDEO LUMBAR"
  },
  {
    "codigo":366627002,
    "descripcion":"HALLAZGO RELACIONADO CON LA AMPLITUD DE MOVIMIENTO DE PRONACIÓN MEDIOTARSIANA"
  },
  {
    "codigo":399395004,
    "descripcion":"TUMOR QUE INVADE RETINA"
  },
  {
    "codigo":69880002,
    "descripcion":"XANTOMA TENDINOSO"
  },
  {
    "codigo":430328004,
    "descripcion":"INFLAMACIÓN DE ESÓFAGO DEBIDA A QUIMIOTERAPIA"
  },
  {
    "codigo":233720006,
    "descripcion":"ENFERMEDAD DE ALMACENAMIENTO PULMONAR DE LÍPIDOS"
  },
  {
    "codigo":364792008,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA REMOVER ALIMENTOS DEL SURCO VESTIBULAR"
  },
  {
    "codigo":723405001,
    "descripcion":"SÍNDROME DE MICROLISENCEFALIA Y MICROMELIA"
  },
  {
    "codigo":788941002,
    "descripcion":"FRACTURA DE FALANGE DE DEDO MEDIO DE LA MANO"
  },
  {
    "codigo":428493006,
    "descripcion":"ABUSO DE COCAÍNA CRACK"
  },
  {
    "codigo":1149389007,
    "descripcion":"FUNCIÓN DEL SISTEMA URINARIO NORMAL"
  },
  {
    "codigo":721570000,
    "descripcion":"NEOPLASIA BENIGNA DE ESTROMA DE TRACTO GASTROINTESTINAL"
  },
  {
    "codigo":262818004,
    "descripcion":"HEMATOMA ESPLÉNICO"
  },
  {
    "codigo":424823000,
    "descripcion":"EXPRESA INQUIETUDES ESPIRITUALES"
  },
  {
    "codigo":64375000,
    "descripcion":"LARINGOTRAQUEÍTIS AGUDA"
  },
  {
    "codigo":719735002,
    "descripcion":"CAPAZ DE RECONOCER SÍMBOLOS"
  },
  {
    "codigo":293751001,
    "descripcion":"ALERGIA A MELFALÁN"
  },
  {
    "codigo":361122008,
    "descripcion":"GRADO DE AFECTACIÓN VISUAL"
  },
  {
    "codigo":128076000,
    "descripcion":"TRASTORNO ÓSEO Y\/O ARTICULAR EN LA MADRE, QUE COMPLICA EL EMBARAZO, EL PARTO Y\/O EL PUERPERIO"
  },
  {
    "codigo":717900000,
    "descripcion":"HIPOPARATIROIDISMO POSTERIOR A RADIOTERAPIA CON HAZ EXTERNO"
  },
  {
    "codigo":95308002,
    "descripcion":"MICRODONCIA GENERALIZADA VERDADERA"
  },
  {
    "codigo":816204007,
    "descripcion":"MELANOMA NODULAR DE MEMBRANA MUCOSA"
  },
  {
    "codigo":27937002,
    "descripcion":"SÍNDROME MEDULAR ANTERIOR DEBIDO A FRACTURA EXPUESTA A NIVEL DE T7-T12"
  },
  {
    "codigo":1142049005,
    "descripcion":"ENFERMEDAD PARASITARIA DEBIDA A INFECCIÓN POR VIRUS DE INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":682381000119108,
    "descripcion":"ANGIOSARCOMA PRIMARIO DE PELVIS"
  },
  {
    "codigo":93473009,
    "descripcion":"HEMANGIOMA DEL TEJIDO CELULAR SUBCUTÁNEO"
  },
  {
    "codigo":1240353009,
    "descripcion":"METÁSTASIS DE CARCINOMA ESCAMOSO EN PRÓSTATA"
  },
  {
    "codigo":124406004,
    "descripcion":"DEFICIENCIA DE NUCLEOTIDILTRANSFERASA"
  },
  {
    "codigo":253643000,
    "descripcion":"ATRESIA DE AORTA ASCENDENTE"
  },
  {
    "codigo":188107002,
    "descripcion":"NEOPLASIA MALIGNA DE PIEL DEL PLIEGUE AXILAR"
  },
  {
    "codigo":57035005,
    "descripcion":"ANEURISMA ARTERIAL, NO AÓRTICO"
  },
  {
    "codigo":710560006,
    "descripcion":"DEAMBULA DURANTE EL DÍA Y LA NOCHE"
  },
  {
    "codigo":284576007,
    "descripcion":"CUERPO EXTRAÑO METÁLICO EN LA FRENTE"
  },
  {
    "codigo":186272008,
    "descripcion":"TUBERCULOSIS GÁSTRICA"
  },
  {
    "codigo":251808009,
    "descripcion":"GENITALES EN ESTADIO 3 DE TANNER"
  },
  {
    "codigo":315509001,
    "descripcion":"NACIDO EN RUMANIA"
  },
  {
    "codigo":413813004,
    "descripcion":"REFLEJO DE CHADDOCK"
  },
  {
    "codigo":86133004,
    "descripcion":"INFECCIÓN POR CESTODOS"
  },
  {
    "codigo":282741006,
    "descripcion":"NEURITIS POSHERPÉTICA"
  },
  {
    "codigo":249973009,
    "descripcion":"PATRÓN EXTENSOR"
  },
  {
    "codigo":1263946002,
    "descripcion":"SHOCK POSOPERATORIO POSTERIOR A EMBARAZO MOLAR"
  },
  {
    "codigo":870730002,
    "descripcion":"ALERGIA A PIVAMPICILINA Y\/O PIVMECILINAM"
  },
  {
    "codigo":444746004,
    "descripcion":"EXACERBACIÓN AGUDA DE DOLOR ABDOMINAL CRÓNICO"
  },
  {
    "codigo":51530003,
    "descripcion":"NEUMONÍA CAUSADA POR ESCHERICHIA COLI"
  },
  {
    "codigo":1231178006,
    "descripcion":"ACTIVIDAD CONTINUA DE FIBRA MUSCULAR HEREDITARIA"
  },
  {
    "codigo":15702721000119103,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE TENDÓN EXTENSOR DE REGIÓN DE MUÑECA DERECHA"
  },
  {
    "codigo":279071000,
    "descripcion":"DOLOR EN EL MEATO URETRAL"
  },
  {
    "codigo":770591002,
    "descripcion":"ÚTERO PSEUDOUNICORNE"
  },
  {
    "codigo":311839006,
    "descripcion":"LESIÓN ABIERTA DE LA TRÁQUEA TORÁCICA"
  },
  {
    "codigo":705055006,
    "descripcion":"VISTO POR MÉDICO ESPECIALISTA"
  },
  {
    "codigo":277236000,
    "descripcion":"EVIDENCIA DE EPISTAXIS RECIENTE"
  },
  {
    "codigo":78793006,
    "descripcion":"MUCOCELE DE LA VESÍCULA BILIAR"
  },
  {
    "codigo":371870001,
    "descripcion":"HIPOCINESIA GRAVE DE LA PARED CARDÍACA"
  },
  {
    "codigo":11422002,
    "descripcion":"FORMA COMBINADA DE CATARATA SENIL"
  },
  {
    "codigo":109726008,
    "descripcion":"ASIMETRÍA MAXILAR POR HIPERTROFIA HEMIFACIAL"
  },
  {
    "codigo":240798009,
    "descripcion":"INFECCIÓN POR DUELA HEPÁTICA"
  },
  {
    "codigo":1287539007,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE PERINEO"
  },
  {
    "codigo":402803008,
    "descripcion":"DERMATOSIS EN UN NIÑO"
  },
  {
    "codigo":7752002,
    "descripcion":"HIPERBILIRRUBINEMIA NO CONJUGADA"
  },
  {
    "codigo":1285704008,
    "descripcion":"RAÍZ DENTAL RETENIDA POSTERIOR A EXTRACCIÓN DE DIENTE"
  },
  {
    "codigo":400968009,
    "descripcion":"MANTIENE UN BUEN CONTACTO VISUAL"
  },
  {
    "codigo":300829002,
    "descripcion":"CAPAZ DE REALIZAR ACTIVIDADES DE BRICOLAJE"
  },
  {
    "codigo":366365003,
    "descripcion":"HALLAZGO EN EL REFLEJO CORNEAL"
  },
  {
    "codigo":5917004,
    "descripcion":"GEOFAGIA"
  },
  {
    "codigo":38685005,
    "descripcion":"VÓMITO OCULTO"
  },
  {
    "codigo":1351240009,
    "descripcion":"BEBE ALCOHOL CON LAS COMIDAS"
  },
  {
    "codigo":684891000119108,
    "descripcion":"GLIOBLASTOMA MULTIFORME PRIMARIO DE VENTRÍCULO CEREBRAL"
  },
  {
    "codigo":266226000,
    "descripcion":"DEBILIDAD CONSECUTIVA A INFECCIÓN VIRAL"
  },
  {
    "codigo":724978001,
    "descripcion":"LACERACIÓN DE FASCIA DE MÚSCULO EXTENSOR DE DEDO DE LA MANO A LA ALTURA DEL ANTEBRAZO"
  },
  {
    "codigo":167922001,
    "descripcion":"MÉDULA ÓSEA CON HIPERPLASIA ERITROIDE"
  },
  {
    "codigo":298994002,
    "descripcion":"AMPLITUD DE SUPINACIÓN ACTIVA DE LA MUÑECA AUMENTADA"
  },
  {
    "codigo":3061000119102,
    "descripcion":"DOLOR CRÓNICO DE ETIOLOGÍA NO MALIGNA"
  },
  {
    "codigo":4082005,
    "descripcion":"MIOCARDITIS CAUSADA POR TREPONEMA PALLIDUM"
  },
  {
    "codigo":723143007,
    "descripcion":"HERIDA COMPLEJA DE CABEZA CON PÉRDIDA AVULSIVA DE PARTE DEL CRÁNEO Y CONTENIDO CRANEAL"
  },
  {
    "codigo":297159008,
    "descripcion":"MEMBRANA LARÍNGEA"
  },
  {
    "codigo":15649781000119105,
    "descripcion":"ANEURISMA DE ARTERIA BRAQUIAL IZQUIERDA"
  },
  {
    "codigo":295324004,
    "descripcion":"SOBREDOSIS DE MEDIO DE CONTRASTE RADIOGRÁFICO"
  },
  {
    "codigo":426396005,
    "descripcion":"DOLOR TORÁCICO DE ORIGEN CARDÍACO"
  },
  {
    "codigo":721308005,
    "descripcion":"LEUCEMIA AGUDA DE LINAJE AMBIGUO"
  },
  {
    "codigo":459164007,
    "descripcion":"ARTERIA COLATERAL QUE DERIVA EL FLUJO SISTÉMICO HACIA LA CIRCULACIÓN PULMONAR DESDE LA AORTA TORÁCICA DESCENDENTE"
  },
  {
    "codigo":262556008,
    "descripcion":"HERIDA SUPERFICIAL POR MORDEDURA DE PERRO"
  },
  {
    "codigo":1145457005,
    "descripcion":"APLASIA DE COLUMNA VERTEBRAL CERVICAL"
  },
  {
    "codigo":64113006,
    "descripcion":"AGOTAMIENTO POR EJERCICIO EXCESIVO"
  },
  {
    "codigo":293489005,
    "descripcion":"REACCIÓN ADVERSA A MEFRUSIDA"
  },
  {
    "codigo":129649008,
    "descripcion":"HIPOBETAGLOBULINEMIA"
  },
  {
    "codigo":195185009,
    "descripcion":"INFARTO CEREBRAL DEBIDO A TROMBOSIS DE ARTERIA PRECEREBRAL"
  },
  {
    "codigo":226118002,
    "descripcion":"DIETA MODIFICADA EN CONTENIDO DE CARBOHIDRATOS"
  },
  {
    "codigo":62278002,
    "descripcion":"BOCIO MULTINODULAR TÓXICO CON CRISIS TIROTÓXICA"
  },
  {
    "codigo":783174004,
    "descripcion":"DISTROFIA MUSCULAR CONGÉNITA CON DISCAPACIDAD INTELECTUAL"
  },
  {
    "codigo":95046000,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE COLON SIGMOIDE"
  },
  {
    "codigo":193350004,
    "descripcion":"MACULOPATÍA AVANZADA DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":16032911000119102,
    "descripcion":"NECROSIS AVASCULAR DE HUESO DE AMBAS MANOS"
  },
  {
    "codigo":291654005,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR OXITETRACICLINA"
  },
  {
    "codigo":160582009,
    "descripcion":"EX-BEBEDOR OCASIONAL - MENOS DE 1 UNIDAD\/DÍA"
  },
  {
    "codigo":93211002,
    "descripcion":"MELANOMA MALIGNO DE PIEL DE TOBILLO"
  },
  {
    "codigo":715803003,
    "descripcion":"ENFERMEDAD DE CHARCOT-MARIE-TOOTH TIPO 4B1"
  },
  {
    "codigo":289819000,
    "descripcion":"EXCITACIÓN DEL CUELLO UTERINO, PRESENTE"
  },
  {
    "codigo":224283006,
    "descripcion":"USUARIO TELEFÓNICO SORDO"
  },
  {
    "codigo":124144000,
    "descripcion":"DEFICIENCIA DE HEXOSA OXIDASA"
  },
  {
    "codigo":419056004,
    "descripcion":"REACCIÓN ADVERSA A LA ERITROMICINA"
  },
  {
    "codigo":286149000,
    "descripcion":"INCAPAZ DE LIMPIAR EL BAÑO"
  },
  {
    "codigo":253381001,
    "descripcion":"AUSENCIA DE VALVA TRICUSPÍDEA"
  },
  {
    "codigo":187845002,
    "descripcion":"NEOPLASIA MALIGNA DE CARTÍLAGO CUNEIFORME DE LA LARINGE"
  },
  {
    "codigo":24005006,
    "descripcion":"ADHERENCIA VITREORRETINIANA"
  },
  {
    "codigo":448154004,
    "descripcion":"ANILLO VASCULAR CON CAYADO AÓRTICO IZQUIERDO Y CONDUCTO ARTERIAL DERECHO ORIGINADO EN DIVERTÍCULO AÓRTICO RETROESOFÁGICO"
  },
  {
    "codigo":710298005,
    "descripcion":"XEROSTOMÍA POSTERIOR A RADIOTERAPIA"
  },
  {
    "codigo":284314004,
    "descripcion":"MANIPULA OBJETOS"
  },
  {
    "codigo":85871000,
    "descripcion":"INTOXICACIÓN POR CREOSOTA"
  },
  {
    "codigo":20335001,
    "descripcion":"ENTEROCOLITIS FULMINANTE"
  },
  {
    "codigo":282479002,
    "descripcion":"DIFICULTAD PARA CORRER"
  },
  {
    "codigo":708463003,
    "descripcion":"RESORCIÓN CERVICAL DE RAÍZ DENTAL"
  },
  {
    "codigo":1003375005,
    "descripcion":"LEUCODISTROFIA METACROMÁTICA DEBIDA A DEFICIENCIA DE PROTEÍNA 1 ACTIVADORA DE ESFINGOLÍPIDO"
  },
  {
    "codigo":249711007,
    "descripcion":"LORDOSIS APLANADA"
  },
  {
    "codigo":315247007,
    "descripcion":"QUISTE RECURRENTE DE MAMA"
  },
  {
    "codigo":413551009,
    "descripcion":"HERNIA PERINEAL ANTERIOR"
  },
  {
    "codigo":687401000119105,
    "descripcion":"OSTEOSARCOMA PRIMARIO DE MAXILAR INFERIOR"
  },
  {
    "codigo":247876006,
    "descripcion":"PENSAMIENTOS OBSESIVOS ACERCA DE LA POSIBILIDAD DE CAUSAR ACCIDENTES"
  },
  {
    "codigo":84036008,
    "descripcion":"DERMATITIS POLIMORFA POR LUZ SOLAR, TIPO ECCEMATOSA"
  },
  {
    "codigo":333251000119101,
    "descripcion":"CICATRIZ CORIORRETINIANA PERIFÉRICA DEL OJO DERECHO"
  },
  {
    "codigo":721000221106,
    "descripcion":"FIEBRE DEL NILO OCCIDENTAL"
  },
  {
    "codigo":702958003,
    "descripcion":"MORDIDA ABIERTA POSTERIOR DERECHA"
  },
  {
    "codigo":309742004,
    "descripcion":"ANEMIA HEMOLÍTICA AUTOINMUNITARIA MEDICAMENTOSA"
  },
  {
    "codigo":211438006,
    "descripcion":"CONTUSIÓN DE DEDOS DEL PIE CON DAÑO UNGUEAL"
  },
  {
    "codigo":735726008,
    "descripcion":"MALFORMACIÓN ARTERIOVENOSA DE ESÓFAGO"
  },
  {
    "codigo":111299004,
    "descripcion":"ATEROMA DE ARTERIA CEREBRAL"
  },
  {
    "codigo":307907004,
    "descripcion":"ESTADO DE CERTIFICADO DE PERMISO PARA PORTACIÓN DE ESCOPETA"
  },
  {
    "codigo":45763006,
    "descripcion":"DESMORALIZACIÓN"
  },
  {
    "codigo":209603006,
    "descripcion":"DESGARRO TOTAL DE LIGAMENTO INTERCARPIANO PALMAR (V LIGAMENTO)"
  },
  {
    "codigo":11160000,
    "descripcion":"ALBINISMO OCULOCUTÁNEO PARDO"
  },
  {
    "codigo":207768002,
    "descripcion":"FRACTURA SUBCONDÍLEA EXPUESTA DE MANDÍBULA"
  },
  {
    "codigo":699288003,
    "descripcion":"INJERTO ARTERIOVENOSO MADURO"
  },
  {
    "codigo":1354648006,
    "descripcion":"SÍNDROME DE MAYER ROKITANSKY KÜSTER HAUSER"
  },
  {
    "codigo":240536007,
    "descripcion":"VERRUGA FILIFORME"
  },
  {
    "codigo":109464006,
    "descripcion":"CONDUCTOS RADICULARES ACCESORIOS LATERALES"
  },
  {
    "codigo":238701007,
    "descripcion":"MELANOSIS PRECANCEROSA"
  },
  {
    "codigo":369773008,
    "descripcion":"PATRÓN DE GLEASON 4"
  },
  {
    "codigo":402541009,
    "descripcion":"CARCINOMA BASOCELULAR RECIDIVANTE LUEGO DE RASPADO"
  },
  {
    "codigo":40258005,
    "descripcion":"TUBERCULOSIS DE TESTÍCULO"
  },
  {
    "codigo":398871001,
    "descripcion":"CONTROL DIABÉTICO - SITIOS DE INYECCIÓN ANORMALES"
  },
  {
    "codigo":366103003,
    "descripcion":"HALLAZGO RELACIONADO CON LA LOCALIZACIÓN DE LA VOZ"
  },
  {
    "codigo":890391006,
    "descripcion":"MALFORMACIÓN CONGÉNITA DE LA VÍA AÉREA PULMONAR TIPO 3"
  },
  {
    "codigo":5655007,
    "descripcion":"TRASTORNO HEREDITARIO DEL METABOLISMO DE LA BILIRRUBINA"
  },
  {
    "codigo":235031008,
    "descripcion":"LEUCOPLASIA BUCAL VERRUGOSA"
  },
  {
    "codigo":11857501000119105,
    "descripcion":"DISTENSIÓN DE TENDÓN DE AQUILES DERECHO"
  },
  {
    "codigo":724716003,
    "descripcion":"DELIRIO CAUSADO POR KETAMINA"
  },
  {
    "codigo":298732005,
    "descripcion":"HALLAZGO RELACIONADO CON LA ESTRUCTURA COSTAL"
  },
  {
    "codigo":3820005,
    "descripcion":"PÉRDIDA DE LA AUDICIÓN CONDUCTIVA A NIVEL DE OÍDO INTERNO"
  },
  {
    "codigo":15953501000119106,
    "descripcion":"INVERSIÓN DE PEZÓN IZQUIERDO"
  },
  {
    "codigo":165825004,
    "descripcion":"TÍTULOS INFECCIOSOS NO DETECTADOS EN SANGRE"
  },
  {
    "codigo":296897004,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE ANTICONCEPTIVO ORAL"
  },
  {
    "codigo":788417006,
    "descripcion":"SÍNDROME DE ALOPECIA, EPILEPSIA Y DISCAPACIDAD INTELECTUAL TIPO MOYNAHAN"
  },
  {
    "codigo":722881006,
    "descripcion":"INCONTINENCIA FECAL FUNCIONAL"
  },
  {
    "codigo":426134002,
    "descripcion":"GANGLIONEUROMA BENIGNO DEL ABDOMEN"
  },
  {
    "codigo":150003,
    "descripcion":"CONTINENCIA ANORMAL DE VEJIGA URINARIA"
  },
  {
    "codigo":142941000119109,
    "descripcion":"INFECCIÓN DEL TRACTO RESPIRATORIO SUPERIOR CAUSADA POR VIRUS INFLUENZA H1N1"
  },
  {
    "codigo":262294007,
    "descripcion":"CON MEJILLA INFLADA"
  },
  {
    "codigo":63851000,
    "descripcion":"EXHUMACIÓN PARA RECUPERACIÓN DE OBJETOS"
  },
  {
    "codigo":295062009,
    "descripcion":"ALERGIA A MILRINONA"
  },
  {
    "codigo":293227007,
    "descripcion":"REACCIÓN ADVERSA A LOS ANTIANDRÓGENOS"
  },
  {
    "codigo":291392000,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR SALES DE ORO"
  },
  {
    "codigo":782912001,
    "descripcion":"DISPLASIA ESPONDILOMETAFISARIA TIPO A4"
  },
  {
    "codigo":29248006,
    "descripcion":"CONDRODISPLASIA METAFISARIA, TIPO SCHMID"
  },
  {
    "codigo":1208896007,
    "descripcion":"DESPLAZAMIENTO DE DERIVACIÓN AURICULAR DE DESFIBRILADOR CARDIOVERSOR IMPLANTABLE"
  },
  {
    "codigo":94784008,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":92949003,
    "descripcion":"FORMA ANORMAL CONGÉNITA DE HUESO SUPRAOCCIPITAL"
  },
  {
    "codigo":60181007,
    "descripcion":"EXCLUSIÓN ALÉLICA"
  },
  {
    "codigo":289557008,
    "descripcion":"HALLAZGO RELACIONADO CON LA CANTIDAD DE SECRECIÓN VAGINAL"
  },
  {
    "codigo":254954002,
    "descripcion":"TUMOR EMBRIONARIO DE MÉDULA ESPINAL"
  },
  {
    "codigo":713706002,
    "descripcion":"POLINEUROPATÍA DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":123882004,
    "descripcion":"INTOXICACIÓN POR EUPHORBIACEAE"
  },
  {
    "codigo":689911000119109,
    "descripcion":"CARCINOMA PRIMARIO INDIFERENCIADO DE PARED SUPERIOR DE NASOFARINGE"
  },
  {
    "codigo":285887000,
    "descripcion":"INCAPAZ DE UTILIZAR LA PAVA"
  },
  {
    "codigo":253119004,
    "descripcion":"HEMIMIELOCELE"
  },
  {
    "codigo":15736721000119106,
    "descripcion":"GLAUCOMA DE ÁNGULO ESTRECHO DE AMBOS OJOS"
  },
  {
    "codigo":773737004,
    "descripcion":"SÍNDROME SIMILAR AL SÍNDROME DE MECKEL RELACIONADO CON NEFROCISTINA 3"
  },
  {
    "codigo":249449007,
    "descripcion":"CUERDA VOCAL EN ABDUCCIÓN EN REPOSO"
  },
  {
    "codigo":83774001,
    "descripcion":"CERVICITIS CON EROSIÓN"
  },
  {
    "codigo":247614002,
    "descripcion":"NO PUEDE RECORDAR EL ANIVERSARIO DE CASAMIENTO"
  },
  {
    "codigo":309291000119103,
    "descripcion":"NECROSIS AVASCULAR DE HUESO DEL CARPO DE MUÑECA DERECHA"
  },
  {
    "codigo":49171007,
    "descripcion":"NEFROPATÍA HIPERTENSIVA QUE COMPLICA EL PARTO Y\/O CONSTITUYE UN MOTIVO DE ATENCIÓN DURANTE ESTE PROCEDIMIENTO"
  },
  {
    "codigo":40031000087104,
    "descripcion":"FRACTURA DE PLATILLO TIBIAL IZQUIERDO"
  },
  {
    "codigo":737299009,
    "descripcion":"CÓRNEA TRASPLANTADA PRESENTE"
  },
  {
    "codigo":42591000087107,
    "descripcion":"HERIDA DE PARED POSTERIOR DE TÓRAX POR MORDEDURA"
  },
  {
    "codigo":14568003,
    "descripcion":"FÍSTULA VESICOCERVICOVAGINAL"
  },
  {
    "codigo":50271000087109,
    "descripcion":"ÚLCERA DE MUCOSA DE INTESTINO GRUESO"
  },
  {
    "codigo":735464006,
    "descripcion":"BRONQUITIS NO INFECCIOSA AGUDA"
  },
  {
    "codigo":1259752004,
    "descripcion":"NEOPLASIA PRIMARIA MALIGNA ODONTÓGENA DE MAXILAR SUPERIOR"
  },
  {
    "codigo":440552008,
    "descripcion":"NECESIDAD DE ANTICONCEPCIÓN COMPLICADA POR AFECCIÓN CLÍNICA"
  },
  {
    "codigo":276712009,
    "descripcion":"PESO NORMAL AL NACIMIENTO"
  },
  {
    "codigo":78269000,
    "descripcion":"TRASTORNO BIPOLAR I, UN SOLO EPISODIO MANÍACO, EN REMISIÓN PARCIAL"
  },
  {
    "codigo":16748741000119101,
    "descripcion":"RETINOPATÍA PROLIFERATIVA DE OJO DERECHO DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":47711000087107,
    "descripcion":"FRACTURA DE CUARTA COSTILLA IZQUIERDA"
  },
  {
    "codigo":1256082000,
    "descripcion":"PRURITO CAUSADO POR ANTIPALÚDICO"
  },
  {
    "codigo":405949009,
    "descripcion":"RIGIDEZ DE NUCA POR HEMORRAGIA SUBARACNOIDEA"
  },
  {
    "codigo":111037009,
    "descripcion":"HIPERPLASIA BASOFÍLICA"
  },
  {
    "codigo":240274003,
    "descripcion":"PROTRUSIÓN DE DISPOSITIVO DE FIJACIÓN ÓSEO"
  },
  {
    "codigo":209341009,
    "descripcion":"FRACTURA-LUXACIÓN EXPUESTA DE ARTICULACIÓN DE LA RODILLA"
  },
  {
    "codigo":895634005,
    "descripcion":"FORMA TRIANGULAR ANORMAL CONGÉNITA DE FALANGE DE SEGUNDO DEDO DE PIE"
  },
  {
    "codigo":305810006,
    "descripcion":"VISTO POR EL SERVICIO DE DERMATOLOGÍA"
  },
  {
    "codigo":404114005,
    "descripcion":"MICOSIS FUNGOIDE ERITRODÉRMICA"
  },
  {
    "codigo":74599000,
    "descripcion":"SIN CONFIRMACIÓN MICROSCÓPICA: TUMOR CLÍNICAMENTE MALIGNO (CÁNCER)"
  },
  {
    "codigo":402279000,
    "descripcion":"DERMATITIS IRRITATIVA POR CONTACTO DEBIDA A ILEOSTOMÍA"
  },
  {
    "codigo":369511001,
    "descripcion":"TUMOR MALIGNO QUE COMPROMETE LA VULVA POR PROPAGACIÓN DIRECTA DEL ÚTERO"
  },
  {
    "codigo":9063003,
    "descripcion":"QUEMADURA EPIDÉRMICA DEL DORSO"
  },
  {
    "codigo":1155943009,
    "descripcion":"DERMATITIS POR CONTACTO ALÉRGICA CAUSADA POR METAL Y\/O COMPUESTO METÁLICO"
  },
  {
    "codigo":236604003,
    "descripcion":"CUERPO EXTRAÑO EN EL URÉTER"
  },
  {
    "codigo":302140004,
    "descripcion":"RECIBIÓ EDUCACIÓN ADICIONAL"
  },
  {
    "codigo":105532006,
    "descripcion":"VIVIENDA HACINADA"
  },
  {
    "codigo":1186876007,
    "descripcion":"MIELOPATÍA DEBIDA A EXCESO DE NUTRIENTES"
  },
  {
    "codigo":365841001,
    "descripcion":"ANÁLISIS DE SUSTANCIA CORPORAL - HALLAZGO"
  },
  {
    "codigo":300305002,
    "descripcion":"ESTÓMAGO NORMAL"
  },
  {
    "codigo":202001008,
    "descripcion":"ARTROPATÍA TRANSITORIA DE CODO"
  },
  {
    "codigo":70929009,
    "descripcion":"ELEVACIÓN DE COLONIA BACTERIANA, UMBONADO"
  },
  {
    "codigo":3558002,
    "descripcion":"INFARTO MESENTÉRICO"
  },
  {
    "codigo":724454004,
    "descripcion":"ENDOMETRIOSIS SUPERFICIAL DE PERITONEO PÉLVICO"
  },
  {
    "codigo":396774006,
    "descripcion":"EPIDÍDIMO COMPROMETIDO POR EXTENSIÓN DIRECTA DE NEOPLASIA MALIGNA"
  },
  {
    "codigo":298470008,
    "descripcion":"AMPLITUD DE ROTACIÓN PASIVA HACIA LA IZQUIERDA DE LA COLUMNA CERVICAL DISMINUIDA"
  },
  {
    "codigo":722619001,
    "descripcion":"HEMORRAGIA TRAUMÁTICA FOCAL DE CEREBELO"
  },
  {
    "codigo":165563002,
    "descripcion":"PRUEBAS DE COAGULACIÓN\/SANGRADO ANORMALES"
  },
  {
    "codigo":394939004,
    "descripcion":"ESTADIO A DE DUKES"
  },
  {
    "codigo":296635006,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE TRIMETOPRIMA"
  },
  {
    "codigo":1148603007,
    "descripcion":"ELECTRORRETINOGRAMA DE PATRÓN ANORMAL"
  },
  {
    "codigo":1723008,
    "descripcion":"ESTENOSIS URETRAL SECUNDARIA A ESQUISTOSOMIASIS"
  },
  {
    "codigo":196496003,
    "descripcion":"FÍSTULA DE GLÁNDULA SUBMAXILAR"
  },
  {
    "codigo":130960004,
    "descripcion":"TRASTORNO EN LA PRODUCCIÓN DE LÍQUIDO AMNIÓTICO"
  },
  {
    "codigo":294800005,
    "descripcion":"ALERGIA A CABERGOLINA"
  },
  {
    "codigo":292965000,
    "descripcion":"REACCIÓN ADVERSA A LA METICILINA"
  },
  {
    "codigo":161893008,
    "descripcion":"DORSALGIA QUE SE INTENSIFICA AL ESTORNUDAR"
  },
  {
    "codigo":1144933009,
    "descripcion":"INFECCIÓN RECURRENTE DEBIDA A DEFICIENCIA DE ISOTIPO DE INMUNOGLOBULINA"
  },
  {
    "codigo":225594000,
    "descripcion":"CONDUCTA RELACIONADA CON LAS HECES"
  },
  {
    "codigo":424037008,
    "descripcion":"DIFICULTAD PARA CUMPLIR UNA RUTINA DE EJERCICIOS PRENATAL"
  },
  {
    "codigo":291130001,
    "descripcion":"INTOXICACIÓN POR CLOZAPINA"
  },
  {
    "codigo":94522007,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL LÓBULO INFERIOR DERECHO DEL PULMÓN"
  },
  {
    "codigo":127290007,
    "descripcion":"LUXACIÓN MEDIAL EXPUESTA DE LA ARTICULACIÓN SUBASTRAGALINA"
  },
  {
    "codigo":27151001,
    "descripcion":"SÍNDROME POSLAMINECTOMÍA"
  },
  {
    "codigo":289295004,
    "descripcion":"HALLAZGO RELACIONADO CON LA ONDA LÍQUIDA DE LÍQUIDO AMNIÓTICO"
  },
  {
    "codigo":418532000,
    "descripcion":"MOVIMIENTO DE LA PARED ABDOMINAL"
  },
  {
    "codigo":59919008,
    "descripcion":"INTENTO FALLIDO DE ABORTO CON COMPLICACIÓN"
  },
  {
    "codigo":92687009,
    "descripcion":"CARCINOMA IN SITU DE LA PARED POSTERIOR DE LA HIPOFARINGE"
  },
  {
    "codigo":254692003,
    "descripcion":"PORO DILATADO DE WINER"
  },
  {
    "codigo":15712761000119105,
    "descripcion":"VÁRICES EN RETINA DE AMBOS OJOS"
  },
  {
    "codigo":713444005,
    "descripcion":"SÍNDROME HEMOFAGOCÍTICO CON INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":11862521000119106,
    "descripcion":"HERIDA INFECTADA DE PIE DERECHO DEBIDA A PICADURA DE INSECTO NO VENENOSO"
  },
  {
    "codigo":189156008,
    "descripcion":"NEOPLASIA BENIGNA DE CONDUCTO NASOLAGRIMAL"
  },
  {
    "codigo":89017001,
    "descripcion":"REORDENAMIENTO GENÉTICO, LINFOCITOS B, CADENA LIVIAN"
  },
  {
    "codigo":1303268009,
    "descripcion":"LUXACIÓN CONGÉNITA VERDADERA DE HOMBRO"
  },
  {
    "codigo":285625008,
    "descripcion":"INCAPAZ DE ADMINISTRAR EL TIEMPO"
  },
  {
    "codigo":283790004,
    "descripcion":"MORDEDURA DE ANIMAL EN LA CABEZA"
  },
  {
    "codigo":871779000,
    "descripcion":"REACCIÓN ADVERSA A DIAMIDINA"
  },
  {
    "codigo":1230392000,
    "descripcion":"SIN SENTIMIENTO DE SOLEDAD"
  },
  {
    "codigo":52579008,
    "descripcion":"PULMÓN ACCESORIO"
  },
  {
    "codigo":6071000124102,
    "descripcion":"USO EXCESIVO DE MEDICACIÓN"
  },
  {
    "codigo":247352008,
    "descripcion":"DOLOR SUBCOSTAL"
  },
  {
    "codigo":12081811000119107,
    "descripcion":"QUEMADURA DE PÁRPADO IZQUIERDO"
  },
  {
    "codigo":737037004,
    "descripcion":"SÍNDROME DE CRECIMIENTO EXCESIVO RELACIONADO CON LA SUBUNIDAD ALFA CATALÍTICA DE FOSFATIDILINOSITOL-4,5-BISFOSFATO 3-CINASA"
  },
  {
    "codigo":471991000124109,
    "descripcion":"VIVIENDA QUE NO SATISFACE NECESIDADES FUNCIONALES"
  },
  {
    "codigo":278285008,
    "descripcion":"HEMIPLEJÍA IZQUIERDA"
  },
  {
    "codigo":81677009,
    "descripcion":"TETANIA DE LA LACTANCIA"
  },
  {
    "codigo":407522000,
    "descripcion":"ENFERMEDAD CAUSADA POR ALPHARETROVIRUS"
  },
  {
    "codigo":79842004,
    "descripcion":"DEPRESIÓN ESTUPOROSA"
  },
  {
    "codigo":702434007,
    "descripcion":"HIPOSPADIAS DE PENE DISTAL"
  },
  {
    "codigo":1290423002,
    "descripcion":"RADIOGRAFÍA SIMPLE DE PARTES BLANDAS NORMAL"
  },
  {
    "codigo":405687003,
    "descripcion":"REPOSICIÓN INSUFICIENTE DE LÍQUIDOS CORPORALES"
  },
  {
    "codigo":241847003,
    "descripcion":"EFECTO TÓXICO CAUSADO POR BLANQUEADOR"
  },
  {
    "codigo":274615004,
    "descripcion":"LATIDO DEL VÉRTICE DESPLAZADO - HIPERTROFIA DE VENTRÍCULO DERECHO"
  },
  {
    "codigo":11809581000119104,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE MUSLO DERECHO"
  },
  {
    "codigo":403852003,
    "descripcion":"HIPERPLASIA NEONATAL DE GLÁNDULA SEBÁCEA"
  },
  {
    "codigo":371084005,
    "descripcion":"MANDÍBULA PARCIALMENTE EDÉNTULA"
  },
  {
    "codigo":698764006,
    "descripcion":"EPILEPSIA DE GRAN MAL POSINFECCIOSA"
  },
  {
    "codigo":305548005,
    "descripcion":"BAJO ATENCIÓN DE CIRUJANO PANCREÁTICO"
  },
  {
    "codigo":76172008,
    "descripcion":"INFECCIÓN CAUSADA POR TAENIA"
  },
  {
    "codigo":1155681001,
    "descripcion":"PÓLIPO DE MEMBRANA MUCOSA DE COANA"
  },
  {
    "codigo":41569004,
    "descripcion":"SIALODOQUITIS"
  },
  {
    "codigo":8801005,
    "descripcion":"DIABETES MELLITUS SECUNDARIA"
  },
  {
    "codigo":926305006,
    "descripcion":"VEGETARIANISMO JAINA"
  },
  {
    "codigo":10963911000119102,
    "descripcion":"LACERACIÓN DE RODILLA DERECHA"
  },
  {
    "codigo":170806001,
    "descripcion":"DIFICULTAD EN EL MANTENIMIENTO DE LA PÉRDIDA DE PESO"
  },
  {
    "codigo":39734002,
    "descripcion":"GLUCOSURIA RENAL, TIPO O"
  },
  {
    "codigo":1186614003,
    "descripcion":"SARCOMA DE KAPOSI PRIMARIO DE TRACTO GASTROINTESTINAL"
  },
  {
    "codigo":340781000119109,
    "descripcion":"RETINOPATÍA EXUDATIVA DE OJO IZQUIERDO"
  },
  {
    "codigo":234507003,
    "descripcion":"HEMATOMA ESPLÉNICO SUBCAPSULAR"
  },
  {
    "codigo":365579004,
    "descripcion":"NIVEL DE OBEDIENCIA RELIGIOSA - HALLAZGO"
  },
  {
    "codigo":70667005,
    "descripcion":"MEGAESÓFAGO"
  },
  {
    "codigo":300043006,
    "descripcion":"REDUCCIÓN DE MASA MUSCULAR"
  },
  {
    "codigo":396512000,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA LATERAL NO COMPROMETIDO POR MELANOMA MALIGNO"
  },
  {
    "codigo":298208004,
    "descripcion":"LAXITUD DE ARTICULACIÓN DE CODO"
  },
  {
    "codigo":165301001,
    "descripcion":"MEMORIA: NO RECUERDA PERSONAS IMPORTANTES"
  },
  {
    "codigo":427445002,
    "descripcion":"NEUMOMEDIASTINO A TENSIÓN"
  },
  {
    "codigo":787893003,
    "descripcion":"NEISSERIA FLAVESCENS O NEISSERIA SUBFLAVA"
  },
  {
    "codigo":296373003,
    "descripcion":"SOBREDOSIS DE AGONISTA DE RECEPTOR ALFADRENÉRGICO"
  },
  {
    "codigo":1344949008,
    "descripcion":"DELIRIO POR INTOXICACIÓN CON ANFETAMINA"
  },
  {
    "codigo":720522001,
    "descripcion":"DISTROFIA MUSCULAR DE LAS CINTURAS DE LAS EXTREMIDADES TIPO 2G AUTOSÓMICA RECESIVA"
  },
  {
    "codigo":32394002,
    "descripcion":"HIPERSECRECIÓN ANDROGÉNICA SUPRARRENAL ADQUIRIDA BENIGNA"
  },
  {
    "codigo":294538004,
    "descripcion":"ALERGIA A CEFRADINA"
  },
  {
    "codigo":1144671003,
    "descripcion":"APLASIA DE DEDO DE PIE"
  },
  {
    "codigo":718687003,
    "descripcion":"SÍNDROME DE MONOSOMÍA 10Q DISTAL"
  },
  {
    "codigo":128863005,
    "descripcion":"HIPERPLASIA LINFOIDE"
  },
  {
    "codigo":194399009,
    "descripcion":"RECLUTAMIENTO DE INTENSIDAD"
  },
  {
    "codigo":127028003,
    "descripcion":"NEOPLASIA DEL CUERPO CAROTÍDEO"
  },
  {
    "codigo":782388003,
    "descripcion":"SÍNDROME DE LA COLA DE CABALLO INCOMPLETO"
  },
  {
    "codigo":28724005,
    "descripcion":"SÍNDROME DE COLESTASIS - EDEMA, TIPO NORUEGO"
  },
  {
    "codigo":290868006,
    "descripcion":"INTOXICACIÓN POR ISOCARBOXAZIDA"
  },
  {
    "codigo":94260004,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE COLON"
  },
  {
    "codigo":26889001,
    "descripcion":"MIOSITIS"
  },
  {
    "codigo":289033001,
    "descripcion":"NO SE ALIMENTA CON LA MANO IZQUIERDA"
  },
  {
    "codigo":92425006,
    "descripcion":"NEOPLASIA BENIGNA DE HUESO DEL TARSO"
  },
  {
    "codigo":451038000,
    "descripcion":"HEMORRAGIA EN NÚCLEO CAUDADO"
  },
  {
    "codigo":1237470001,
    "descripcion":"SÍNDROME DE MALFORMACIÓN CEREBRAL FETAL LETAL, ATRESIA DUODENAL E HIPOPLASIA RENAL BILATERAL"
  },
  {
    "codigo":878857009,
    "descripcion":"GRANULOMATOSIS LINFOMATOIDE MALIGNA GRADO 3"
  },
  {
    "codigo":254430004,
    "descripcion":"NEOPLASIA DE PISO LATERAL DE BOCA"
  },
  {
    "codigo":11780601000119100,
    "descripcion":"LESIÓN TRAUMÁTICA DE BRAZO IZQUIERDO"
  },
  {
    "codigo":11995641000119101,
    "descripcion":"EDEMA DE MUÑÓN DE AMPUTACIÓN DE MIEMBRO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":316921000119102,
    "descripcion":"DOLOR DE ARTICULACIÓN DE CADERA DERECHA"
  },
  {
    "codigo":329721000119103,
    "descripcion":"COMPRESIÓN DE NERVIO MEDIANO DERECHO"
  },
  {
    "codigo":188174841000119103,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DEBIDO A OCLUSIÓN DE AMBAS ARTERIAS CEREBRALES MEDIAS"
  },
  {
    "codigo":15669241000119104,
    "descripcion":"AUSENCIA CONGÉNITA DE EXTREMIDAD INFERIOR IZQUIERDA"
  },
  {
    "codigo":15748601000119106,
    "descripcion":"RIGIDEZ DE MÚSCULO GEMELO DERECHO"
  },
  {
    "codigo":88755007,
    "descripcion":"FLEBITIS DE SENO VENOSO LATERAL"
  },
  {
    "codigo":9721000119107,
    "descripcion":"MALFORMACIÓN DE SISTEMA NERVIOSO CENTRAL FETAL"
  },
  {
    "codigo":16716281000119108,
    "descripcion":"ICTERICIA NEONATAL DEBIDA A INCOMPATIBILIDAD ABO"
  },
  {
    "codigo":1074681000119107,
    "descripcion":"ARTRITIS DE ARTICULACIÓN ESTERNOCLAVICULAR DERECHA"
  },
  {
    "codigo":11865081000119107,
    "descripcion":"LESIÓN TRAUMÁTICA DE EXTREMIDAD INFERIOR IZQUIERDA"
  },
  {
    "codigo":11312121000119103,
    "descripcion":"FRACTURA POR ESTRÉS DE VÉRTEBRA CERVICAL"
  },
  {
    "codigo":112121000119105,
    "descripcion":"ENFERMEDAD VENÉREA CAUSADA POR CHLAMYDIA TRACHOMATIS"
  },
  {
    "codigo":275122681000119107,
    "descripcion":"ESTENOSIS DE ESOFAGOSTOMÍA"
  },
  {
    "codigo":140281000119108,
    "descripcion":"HEMIPARESIA COMO EFECTO TARDÍO DE ENFERMEDAD CEREBROVASCULAR"
  },
  {
    "codigo":304121000119108,
    "descripcion":"GOTA TOFÁCEA CRÓNICA DE MÚLTIPLES LOCALIZACIONES DEBIDA A DISFUNCIÓN RENAL"
  },
  {
    "codigo":871517005,
    "descripcion":"REACCIÓN ADVERSA A CLORHEXIDINA Y\/O NEOMICINA"
  },
  {
    "codigo":609373006,
    "descripcion":"ESCALA DE CALIFICACIÓN DEL COMPORTAMIENTO DE FRANKL DEFINIDAMENTE POSITIVA"
  },
  {
    "codigo":1363037007,
    "descripcion":"METABOLIZADOR INTERMEDIO DE FAMILIA 2 SUBFAMILIA C MIEMBRO 9 *5\/*8 DE CITOCROMO P450"
  },
  {
    "codigo":83250000,
    "descripcion":"REACCIÓN HEMOLÍTICA RETARDADA A UNA TRANSFUSIÓN"
  },
  {
    "codigo":248925006,
    "descripcion":"ORIFICIO CERVICAL PERMEABLE"
  },
  {
    "codigo":19549003,
    "descripcion":"INFECCIÓN CAUSADA POR STRONGYLOIDES CEBUS"
  },
  {
    "codigo":1080571000119109,
    "descripcion":"LEIOMIOSARCOMA PRIMARIO DE EXTREMIDAD INFERIOR IZQUIERDA"
  },
  {
    "codigo":247090008,
    "descripcion":"SINÉRESIS DEL VÍTREO"
  },
  {
    "codigo":1197362009,
    "descripcion":"ENFERMEDAD AUTOINMUNE MULTISISTÉMICA DE INICIO TEMPRANO ASOCIADA A STAT-3"
  },
  {
    "codigo":212487005,
    "descripcion":"LESIONES MÚLTIPLES DEL TÓRAX"
  },
  {
    "codigo":712365461000119105,
    "descripcion":"FRACTURA PATOLÓGICA DE PIE IZQUIERDO DEBIDA A OSTEOPETROSIS"
  },
  {
    "codigo":14044002,
    "descripcion":"DIETA HIPOSÓDICA, 20 MILIEQUIVALENTES"
  },
  {
    "codigo":440028005,
    "descripcion":"FIBRILACIÓN AURICULAR PERMANENTE"
  },
  {
    "codigo":472796007,
    "descripcion":"ESTENOSIS SUBAÓRTICA CONGÉNITA DEBIDA A DEFECTO RESTRICTIVO DEL TABIQUE INTERVENTRICULAR ASOCIADA CON CORAZÓN FUNCIONALMENTE UNIVENTRICULAR"
  },
  {
    "codigo":896945001,
    "descripcion":"FORMA DE BALA ANORMAL CONGÉNITA DE FALANGE MEDIA DE TERCER DEDO DE PIE"
  },
  {
    "codigo":414771005,
    "descripcion":"INMUNOGLOBULINA G MONOCLONAL DETECTADA"
  },
  {
    "codigo":700337008,
    "descripcion":"ELEFANTIASIS DE PÁRPADO SUPERIOR"
  },
  {
    "codigo":403590001,
    "descripcion":"TRASTORNO FACTICIO INFLIGIDO A OTRO CON MANIFESTACIONES CUTÁNEAS"
  },
  {
    "codigo":698502005,
    "descripcion":"HEMORRAGIA RECURRENTE"
  },
  {
    "codigo":16018991000119103,
    "descripcion":"ATEROSCLEROSIS DE INJERTO-PUENTE DE VENA AUTÓLOGA DE EXTREMIDAD SUPERIOR IZQUIERDA"
  },
  {
    "codigo":1157254007,
    "descripcion":"RECUENTO DE GRANULOCITOS POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":239750008,
    "descripcion":"SUBLUXACIÓN NEUROMUSCULAR DE LA ARTICULACIÓN"
  },
  {
    "codigo":303451003,
    "descripcion":"SE ACUCLILLA SOBRE EL INODORO"
  },
  {
    "codigo":8539008,
    "descripcion":"INFESTACIÓN CAUSADA POR OESTRUS OVIS"
  },
  {
    "codigo":170544002,
    "descripcion":"REQUIERE UNA DOSIS DE VACUNA CONTRA MENINGITIS"
  },
  {
    "codigo":301616008,
    "descripcion":"DIFICULTAD PARA MANEJARSE EN ESCALONES"
  },
  {
    "codigo":236080009,
    "descripcion":"INCONTINENCIA FECAL NEUROMIOPÁTICA"
  },
  {
    "codigo":299781001,
    "descripcion":"REFLEJO DE OJOS DE MUÑECA AUSENTE"
  },
  {
    "codigo":201477004,
    "descripcion":"ARTRITIS REACTIVA DE ARTICULACIÓN DE MANO DEBIDA A ENFERMEDAD INFECCIOSA TRANSMITIDA POR VÍA SEXUAL Y POSTERIOR A ELLA"
  },
  {
    "codigo":365317005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD DE LAVAR LOS PLATOS"
  },
  {
    "codigo":70405009,
    "descripcion":"ANEURISMA DE ARTERIA ESPLÉNICA"
  },
  {
    "codigo":297946004,
    "descripcion":"LESIÓN DE NERVIO DE MIEMBRO INFERIOR"
  },
  {
    "codigo":232410007,
    "descripcion":"QUISTE VALECULAR"
  },
  {
    "codigo":165039000,
    "descripcion":"CAPACIDAD VITAL FORZADA NORMAL"
  },
  {
    "codigo":230575000,
    "descripcion":"POLINEUROPATÍA DOLOROSA CRÓNICA DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":396250007,
    "descripcion":"HALLAZGO RELACIONADO CON EL MARGEN QUIRÚRGICO ENDOCERVICAL"
  },
  {
    "codigo":363482009,
    "descripcion":"NEOPLASIA MALIGNA DE GLÁNDULA HIPÓFISIS"
  },
  {
    "codigo":18121000119104,
    "descripcion":"CARCINOMA PRIMARIO ESCAMOCELULAR DE AMÍGDALA PALATINA"
  },
  {
    "codigo":722095005,
    "descripcion":"LESIÓN RENAL AGUDA DEBIDA A FALLA CIRCULATORIA"
  },
  {
    "codigo":296111002,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE PRAZEPAM"
  },
  {
    "codigo":294276006,
    "descripcion":"ALERGIA A NALTREXONA"
  },
  {
    "codigo":1177177000,
    "descripcion":"HIPERFENILALANINEMIA POR DEFICIENCIA DE DNAJC12"
  },
  {
    "codigo":292441005,
    "descripcion":"REACCIÓN ADVERSA AL SOTALOL"
  },
  {
    "codigo":95833006,
    "descripcion":"LIPODISTROFIA FACIAL PARCIAL"
  },
  {
    "codigo":128601007,
    "descripcion":"NEUMOPATÍA INFECCIOSA"
  },
  {
    "codigo":126766000,
    "descripcion":"SIALOADENITIS LINFOEPITELIAL EN EL SÍNDROME DE SJÖGREN"
  },
  {
    "codigo":1144409008,
    "descripcion":"HIPOPLASIA CONGÉNITA DE HEMITÓRAX IZQUIERDO"
  },
  {
    "codigo":93998003,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE ESCLERÓTICA DEL OJO"
  },
  {
    "codigo":290606005,
    "descripcion":"INTOXICACIÓN POR IFOSFAMIDA"
  },
  {
    "codigo":716590006,
    "descripcion":"ANGIOFIBROMA JUVENIL DE RINOFARINGE"
  },
  {
    "codigo":288771005,
    "descripcion":"DIRIGE LA ATENCIÓN"
  },
  {
    "codigo":92163008,
    "descripcion":"NEOPLASIA BENIGNA DE LA REGIÓN DE UNIÓN DE LA EPIGLOTIS"
  },
  {
    "codigo":418008001,
    "descripcion":"VE MANCHAS FRENTE A LOS OJOS"
  },
  {
    "codigo":188632001,
    "descripcion":"ENFERMEDAD DE SÉZARY DE GANGLIOS LINFÁTICOS INTRABDOMINALES"
  },
  {
    "codigo":254168005,
    "descripcion":"ERITRODERMIA ICTIOSIFORME BULLOSA LOCALIZADA"
  },
  {
    "codigo":250498001,
    "descripcion":"HALLAZGO EN EL ESPERMA"
  },
  {
    "codigo":283266001,
    "descripcion":"VIDRIO EN MUSLO"
  },
  {
    "codigo":53890003,
    "descripcion":"PRESIÓN DEL HABLA"
  },
  {
    "codigo":22957009,
    "descripcion":"INTOXICACIÓN POR BRASSICA OLERACEA"
  },
  {
    "codigo":447106005,
    "descripcion":"QUEMADURA PROFUNDA DE TERCER GRADO DE GENITALES"
  },
  {
    "codigo":248663000,
    "descripcion":"CHOQUE ESTERNAL SUPERIOR"
  },
  {
    "codigo":707415003,
    "descripcion":"MIOBLASTOMA TRAQUEOBRONQUIAL DE CÉLULAS GRANULARES"
  },
  {
    "codigo":281431006,
    "descripcion":"FALLA DE INJERTO MUSCULAR"
  },
  {
    "codigo":445271007,
    "descripcion":"ARTRITIS VELLOSA"
  },
  {
    "codigo":246828002,
    "descripcion":"RETRACCIÓN DE PÁRPADO SUPERIOR NO ASOCIADA CON MOVIMIENTO OCULAR"
  },
  {
    "codigo":50220002,
    "descripcion":"ANEMIA APLÁSICA RELACIONADA CON TRASTORNO DE LA INMUNIDAD CELULAR"
  },
  {
    "codigo":115756002,
    "descripcion":"FENOTIPO I>INT<"
  },
  {
    "codigo":1295404006,
    "descripcion":"RADIOGRAFÍA POSTMORTEM ANORMAL"
  },
  {
    "codigo":771116009,
    "descripcion":"QUEMADURA PROFUNDA DE TERCER GRADO DE CABEZA Y\/O CUELLO"
  },
  {
    "codigo":212225002,
    "descripcion":"LESIÓN DE LA RAÍZ DEL NERVIO SACRO - S3"
  },
  {
    "codigo":408833007,
    "descripcion":"PRUEBA PARA CRIBADO PRENATAL DE TALASEMIA EN SANGRE ENVIADA"
  },
  {
    "codigo":767446006,
    "descripcion":"INESTABILIDAD CONGÉNITA DE ARTICULACIÓN DE LA CADERA IZQUIERDA"
  },
  {
    "codigo":700075000,
    "descripcion":"QUERATOMA PLANTAR"
  },
  {
    "codigo":77483002,
    "descripcion":"ORINA FEBRIL"
  },
  {
    "codigo":863915002,
    "descripcion":"DEHISCENCIA DE ANASTOMOSIS DE CONDUCTO PANCREÁTICO"
  },
  {
    "codigo":44715002,
    "descripcion":"INTOXICACIÓN POR ESPECIE DE NICOTIANA"
  },
  {
    "codigo":306859002,
    "descripcion":"BAJO ATENCIÓN DE MÉDICO AUDIÓLOGO"
  },
  {
    "codigo":110251009,
    "descripcion":"CONTUSIÓN DEL VESTÍBULO MAXILAR"
  },
  {
    "codigo":370560001,
    "descripcion":"AGRESIÓN REDIRIGIDA"
  },
  {
    "codigo":403328001,
    "descripcion":"EFLUVIO TELÓGENO CRÓNICO"
  },
  {
    "codigo":763776004,
    "descripcion":"MIOPATÍA DISTAL DE COMIENZO TEMPRANO RELACIONADA CON EL MIEMBRO 9 DE LA FAMILIA SIMILAR A KELCH"
  },
  {
    "codigo":1156992005,
    "descripcion":"HIPERPLASIA CONGÉNITA DE CÉLULAS INTERSTICIALES DE CAJAL CON DISPLASIA NEURONAL INTESTINAL"
  },
  {
    "codigo":73813001,
    "descripcion":"ELASTOSIS SENIL"
  },
  {
    "codigo":270421002,
    "descripcion":"VISTO EN HOGAR CUSTODIADO CON VIGILANCIA"
  },
  {
    "codigo":237653008,
    "descripcion":"HIPERPARATIROIDISMO PRIMARIO FAMILIAR"
  },
  {
    "codigo":301354004,
    "descripcion":"DOLOR DE OÍDO"
  },
  {
    "codigo":6442005,
    "descripcion":"TIRAJE INTERCOSTAL"
  },
  {
    "codigo":102911000,
    "descripcion":"PENSAMIENTOS DE AUTOAGRESIÓN"
  },
  {
    "codigo":233983001,
    "descripcion":"RUPTURA DE ANEURISMA CEREBRAL"
  },
  {
    "codigo":266751003,
    "descripcion":"TRANSFERIDO DEL DEPARTAMENTO"
  },
  {
    "codigo":70143003,
    "descripcion":"LEPRA TUBERCULOIDE"
  },
  {
    "codigo":201215003,
    "descripcion":"ACNÉ POR BROMUROS"
  },
  {
    "codigo":299519006,
    "descripcion":"ARTICULACIÓN DEL PIE - AZUL"
  },
  {
    "codigo":168447007,
    "descripcion":"EVALUACIÓN CROMOSÓMICA CELULAR, NORMAL"
  },
  {
    "codigo":365055005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA DEDUCIR SIGNIFICADOS"
  },
  {
    "codigo":2772003,
    "descripcion":"EPIDERMÓLISIS BULLOSA ADQUIRIDA"
  },
  {
    "codigo":166612004,
    "descripcion":"BILIRRUBINA SÉRICA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":232148006,
    "descripcion":"CEGUERA A LOS COLORES CONGÉNITA"
  },
  {
    "codigo":230313001,
    "descripcion":"DEGENERACIÓN AUTOSÓMICA DOMINANTE DE LOS GANGLIOS BASALES DE INICIO TARDÍO"
  },
  {
    "codigo":721833001,
    "descripcion":"INFECCIÓN CAUSADA POR BRUGIA"
  },
  {
    "codigo":787369004,
    "descripcion":"METABOLIZADOR ULTRARRÁPIDO DE LA FAMILIA 1 SUBFAMILIA A MIEMBRO 2 DEL CITOCROMO P450"
  },
  {
    "codigo":295849006,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE CLOMIPRAMINA"
  },
  {
    "codigo":263081007,
    "descripcion":"FRACTURA-LUXACIÓN DE ARTICULACIÓN MEDIOCARPIANA"
  },
  {
    "codigo":64638002,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA VENA HEPÁTICA"
  },
  {
    "codigo":294014006,
    "descripcion":"ALERGIA A ECOTIOPATO"
  },
  {
    "codigo":161107000,
    "descripcion":"MIEMBRO DE LA ASOCIACIÓN DE ENCEFALOPATÍA MIÁLGICA"
  },
  {
    "codigo":62803002,
    "descripcion":"DISPLASIA FRONTOMETAFISARIA"
  },
  {
    "codigo":95571006,
    "descripcion":"HEMORRAGIA RENAL"
  },
  {
    "codigo":292179007,
    "descripcion":"REACCIÓN ADVERSA A LA PRILOCAÍNA"
  },
  {
    "codigo":60968001,
    "descripcion":"BOCIO ADENOMATOSO"
  },
  {
    "codigo":126504002,
    "descripcion":"NEOPLASIA DE LA PIEL DEL CUELLO"
  },
  {
    "codigo":1142312006,
    "descripcion":"ATROFIA DE MÚSCULO MASETERO"
  },
  {
    "codigo":124669001,
    "descripcion":"DEFICIENCIA DE GLUCOSA - 6 - FOSFATO ISOMERASA"
  },
  {
    "codigo":386813002,
    "descripcion":"RESPIRACIÓN ANORMAL"
  },
  {
    "codigo":350821000119101,
    "descripcion":"NEOPLASIA BENIGNA DE MAMA IZQUIERDA"
  },
  {
    "codigo":678501000119101,
    "descripcion":"CATARATA PRESENIL DE OJO IZQUIERDO"
  },
  {
    "codigo":288509005,
    "descripcion":"QUEMADURA DE PIEL DE REGIÓN DE CUERPO"
  },
  {
    "codigo":91901006,
    "descripcion":"AUSENCIA CONGÉNITA DE HUESO PALATINO"
  },
  {
    "codigo":419581008,
    "descripcion":"SUEÑOS EXTRAÑOS"
  },
  {
    "codigo":286674001,
    "descripcion":"INTELECTUALIZACIÓN - MECANISMO DE DEFENSA PSICOLÓGICA"
  },
  {
    "codigo":417746004,
    "descripcion":"LESIÓN TRAUMÁTICA"
  },
  {
    "codigo":253906004,
    "descripcion":"SIRINGOCELE URETRAL CONGÉNITO"
  },
  {
    "codigo":1204178006,
    "descripcion":"OCLUSIÓN AGUDA DE ARTERIA SUBCLAVIA DEBIDA A TROMBOSIS"
  },
  {
    "codigo":186535001,
    "descripcion":"ECCEMA HERPÉTICO"
  },
  {
    "codigo":250236003,
    "descripcion":"CUERPO DE HEINZ"
  },
  {
    "codigo":1003900006,
    "descripcion":"DELECIÓN PROXIMAL DEL BRAZO LARGO DEL CROMOSOMA 4"
  },
  {
    "codigo":20860008,
    "descripcion":"MIASIS INTESTINAL"
  },
  {
    "codigo":445009001,
    "descripcion":"AZOEMIA"
  },
  {
    "codigo":248401009,
    "descripcion":"DEFORMIDAD DE ARTICULACIÓN TEMPOROMANDIBULAR"
  },
  {
    "codigo":17190001,
    "descripcion":"HERNIA DIAFRAGMÁTICA CONGÉNITA"
  },
  {
    "codigo":49958005,
    "descripcion":"TEMBLOR POR ASPERGILLUS CLAVATUS"
  },
  {
    "codigo":246566005,
    "descripcion":"DESCUIDO DEL BRAZO"
  },
  {
    "codigo":279334008,
    "descripcion":"DERMATOSIS INDUCIDA POR CALOR"
  },
  {
    "codigo":310267001,
    "descripcion":"ANTICUERPO ANTI - SCL 70 DETECTADO"
  },
  {
    "codigo":48123002,
    "descripcion":"CONTUSIÓN DE MUÑECA"
  },
  {
    "codigo":277499006,
    "descripcion":"DONOVANOSIS COMPLICADA"
  },
  {
    "codigo":408571007,
    "descripcion":"DOPPLER ANORMAL DE ARTERIA CARÓTIDA"
  },
  {
    "codigo":79056001,
    "descripcion":"AMPOLLA DE MUÑECA, SIN INFECCIÓN"
  },
  {
    "codigo":898256001,
    "descripcion":"ANQUILOSIS CONGÉNITA DE ARTICULACIÓN INTERFALÁNGICA DE DEDO MEÑIQUE"
  },
  {
    "codigo":767184005,
    "descripcion":"QUISTE SINOVIAL DE MANO"
  },
  {
    "codigo":46288008,
    "descripcion":"SÍNDROME DE PAYR"
  },
  {
    "codigo":77221000,
    "descripcion":"BLOQUEO AURICULOVENTRICULAR INCOMPLETO CON RESPUESTA AURICULOVENTRICULAR"
  },
  {
    "codigo":109989006,
    "descripcion":"MIELOMA MÚLTIPLE"
  },
  {
    "codigo":699813007,
    "descripcion":"XANTOGRANULOMA DE PLEXO COROIDEO"
  },
  {
    "codigo":372133009,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE HUESOS DE MIEMBRO SUPERIOR Y OMÓPLATO"
  },
  {
    "codigo":206458002,
    "descripcion":"ICTERICIA NEONATAL CON PORFIRIA"
  },
  {
    "codigo":1255034004,
    "descripcion":"ESGUINCE DE LIGAMENTO DE ARTICULACIÓN METACARPOFALÁNGICA DE DEDO MEÑIQUE"
  },
  {
    "codigo":403066007,
    "descripcion":"TIÑA CAUSADA POR MICROSPORUM AUDOUINII"
  },
  {
    "codigo":42618007,
    "descripcion":"ATRESIA CONGÉNITA DE TROMPA DE FALOPIO"
  },
  {
    "codigo":1351503000,
    "descripcion":"DEFICIENCIA DEL COMPLEJO MAYOR DE HISTOCOMPATIBILIDAD CLASE II DEBIDA A MUTACIÓN DEL GEN RFXANK"
  },
  {
    "codigo":302927005,
    "descripcion":"ESTRECHEZ VAGINAL ADQUIRIDA"
  },
  {
    "codigo":8015008,
    "descripcion":"AUSENTISMO"
  },
  {
    "codigo":401231009,
    "descripcion":"PROPÓSITO DE LLEVAR A CABO LESIÓN AUTOINFLIGIDA CON PLANES DETALLADOS"
  },
  {
    "codigo":6180003,
    "descripcion":"BLOQUEO TOTAL DE LA RAMA IZQUIERDA DEL HAZ DE HIS"
  },
  {
    "codigo":71716005,
    "descripcion":"ERITROCITOSIS POR QUISTE RENAL"
  },
  {
    "codigo":1251364007,
    "descripcion":"DERMATITIS DE CONTACTO SISTÉMICA"
  },
  {
    "codigo":366628007,
    "descripcion":"AMPLITUD DE MOVIMIENTO ACTIVO DE PRONACIÓN MEDIOTARSIANA - HALLAZGO"
  },
  {
    "codigo":202788007,
    "descripcion":"ESTENOSIS DEGENERATIVA DE CONDUCTO RAQUÍDEO LUMBAR"
  },
  {
    "codigo":364793003,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA MASTICAR"
  },
  {
    "codigo":397561005,
    "descripcion":"SÍNDROME DE USO EXCESIVO DE LENTES DE CONTACTO"
  },
  {
    "codigo":299257007,
    "descripcion":"AMPLITUD DE EXTENSIÓN PASIVA DE LA CADERA NORMAL"
  },
  {
    "codigo":723406000,
    "descripcion":"EMBRIOPATÍA CAUSADA POR MICOFENOLATO MOFETILO"
  },
  {
    "codigo":1149390003,
    "descripcion":"DEMUESTRA CONOCIMIENTO SOBRE MEDIDA DE SEGURIDAD"
  },
  {
    "codigo":788942009,
    "descripcion":"FRACTURA DE FALANGE DE DEDO ANULAR"
  },
  {
    "codigo":721571001,
    "descripcion":"NEOPLASIA BENIGNA DE ESTROMA ENDOMETRIAL"
  },
  {
    "codigo":675003,
    "descripcion":"TORSIÓN DE INTESTINO"
  },
  {
    "codigo":1090611000119104,
    "descripcion":"OTITIS EXTERNA AGUDA DE CONDUCTO AUDITIVO EXTERNO DERECHO CAUSADA POR SUSTANCIA QUÍMICA"
  },
  {
    "codigo":262819007,
    "descripcion":"HEMATOMA INTRAPARENQUIMATOSO DE BAZO"
  },
  {
    "codigo":719736001,
    "descripcion":"CAPAZ DE MANEJAR SUS PROPIAS NECESIDADES DE SALUD FÍSICA"
  },
  {
    "codigo":1342328003,
    "descripcion":"CONTUSIÓN DE CÓNDILO INTERNO DE TIBIA"
  },
  {
    "codigo":64376004,
    "descripcion":"PSEUDO-OBSTRUCCIÓN CRÓNICA PRIMARIA DEL ESTÓMAGO"
  },
  {
    "codigo":457592003,
    "descripcion":"OCLUSIÓN DE SENO CORONARIO"
  },
  {
    "codigo":195448005,
    "descripcion":"VENAS VARICOSAS DE LA PIERNA CON RUPTURA"
  },
  {
    "codigo":293752008,
    "descripcion":"ALERGIA A ESTRAMUSTINA"
  },
  {
    "codigo":422989001,
    "descripcion":"APÉNDICE ILEOCECAL CON COMPROMISO TUMORAL, CON PERFORACIÓN EN UN LUGAR DIFERENTE AL TUMOR"
  },
  {
    "codigo":717901001,
    "descripcion":"HIPOPARATIROIDISMO DEBIDO A HEMOCROMATOSIS"
  },
  {
    "codigo":244941000119101,
    "descripcion":"FUNCIÓN TUBULAR RENAL ANORMAL"
  },
  {
    "codigo":15973581000119101,
    "descripcion":"DISPLASIA CONGÉNITA DE EXTREMIDAD INFERIOR DERECHA"
  },
  {
    "codigo":160845005,
    "descripcion":"NUEVA RELACIÓN"
  },
  {
    "codigo":816205008,
    "descripcion":"BLASTOMA HIPOFISARIO MALIGNO"
  },
  {
    "codigo":128077009,
    "descripcion":"TRAUMATISMO VAGINAL DURANTE EL PARTO"
  },
  {
    "codigo":27938007,
    "descripcion":"DIETA BLANDA, ESTADIO 3"
  },
  {
    "codigo":60706008,
    "descripcion":"FLEBITIS DE LA PRENSA DE HERÓFILO"
  },
  {
    "codigo":26103000,
    "descripcion":"HIDATIDOSIS HEPÁTICA"
  },
  {
    "codigo":124407008,
    "descripcion":"DEFICIENCIA DE HIDROLASA"
  },
  {
    "codigo":286412001,
    "descripcion":"CAPAZ DE HABLAR A VELOCIDAD NORMAL"
  },
  {
    "codigo":417484006,
    "descripcion":"ABSCESO TUBERCULOSO DE LA MÉDULA ESPINAL"
  },
  {
    "codigo":253644006,
    "descripcion":"AORTA ASCENDENTE AUSENTE"
  },
  {
    "codigo":251809001,
    "descripcion":"GENITALES EN ESTADIO 4 DE TANNER"
  },
  {
    "codigo":448417001,
    "descripcion":"SEPSIS CAUSADA POR STAPHYLOCOCCUS AUREUS"
  },
  {
    "codigo":284577003,
    "descripcion":"CUERPO EXTRAÑO METÁLICO EN LA MEJILLA"
  },
  {
    "codigo":186273003,
    "descripcion":"TUBERCULOSIS HEPÁTICA"
  },
  {
    "codigo":249974003,
    "descripcion":"PATRÓN FLEXOR DE RETRACCIÓN"
  },
  {
    "codigo":282742004,
    "descripcion":"NEURITIS INTERCOSTAL POSHERPÉTICA"
  },
  {
    "codigo":413814005,
    "descripcion":"SIGNO DE CHADWICK"
  },
  {
    "codigo":86134005,
    "descripcion":"POSICIÓN NORMAL"
  },
  {
    "codigo":315510006,
    "descripcion":"NACIDO EN RUSIA"
  },
  {
    "codigo":1231179003,
    "descripcion":"NECROSIS AVASCULAR IDIOPÁTICA DE HUESO"
  },
  {
    "codigo":870731003,
    "descripcion":"ALERGIA A CARBIDOPA Y\/O LEVODOPA"
  },
  {
    "codigo":1263947006,
    "descripcion":"UREMIA POSTERIOR A EMBARAZO MOLAR"
  },
  {
    "codigo":706891008,
    "descripcion":"NEUROPATÍA DEBIDA A DIABETES MELLITUS TIPO 1 INESTABLE"
  },
  {
    "codigo":1296715009,
    "descripcion":"PRESIÓN INTRAOCULAR DE AMBOS OJOS POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":279072007,
    "descripcion":"LABIO DOLORIDO"
  },
  {
    "codigo":47861000,
    "descripcion":"RESONANCIA AUSENTE"
  },
  {
    "codigo":770592009,
    "descripcion":"ESOFAGITIS EOSINOFÍLICA CON RESPUESTA A INHIBIDOR DE LA BOMBA DE PROTONES"
  },
  {
    "codigo":703221003,
    "descripcion":"MALFORMACIÓN VASCULAR CONGÉNITA INTRACRANEAL"
  },
  {
    "codigo":768757004,
    "descripcion":"ADHERENCIA DE PELVIS"
  },
  {
    "codigo":1356746000,
    "descripcion":"CONJUNTIVITIS AGUDA DE OJO DERECHO"
  },
  {
    "codigo":439242001,
    "descripcion":"PORTADOR DE ENFERMEDAD POR DEFICIENCIA HEREDITARIA DE FACTOR IX"
  },
  {
    "codigo":78794000,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE TRONCO SIN INFECCIÓN"
  },
  {
    "codigo":275402007,
    "descripcion":"ESTENOSIS DE INTESTINO GRUESO"
  },
  {
    "codigo":109727004,
    "descripcion":"ARREGLO DENTAL PRESENTE"
  },
  {
    "codigo":208031005,
    "descripcion":"FRACTURA VERTEBRAL NO EXPUESTA CON LESIÓN POSTERIOR DE MÉDULA ESPINAL DORSAL, D1-6"
  },
  {
    "codigo":402804002,
    "descripcion":"DERMATOSIS DE LA MENOPAUSIA"
  },
  {
    "codigo":206196005,
    "descripcion":"HEMORRAGIA CEREBRAL DEBIDA A LESIÓN OBSTÉTRICA"
  },
  {
    "codigo":271732006,
    "descripcion":"PUPILA IRREGULAR"
  },
  {
    "codigo":400969001,
    "descripcion":"OBSERVACIONES SOBRE EL CONTACTO VISUAL"
  },
  {
    "codigo":1287540009,
    "descripcion":"ADAMANTINOMA MALIGNO PRIMARIO DE HUESO LARGO DE MIEMBRO INFERIOR"
  },
  {
    "codigo":1156468009,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL PROFUNDA"
  },
  {
    "codigo":40521006,
    "descripcion":"CONTUSIÓN DE CORAZÓN CON HERIDA TORÁCICA ABIERTA"
  },
  {
    "codigo":7753007,
    "descripcion":"ENFERMEDAD CAUSADA POR PENTASTOMIDA"
  },
  {
    "codigo":300830007,
    "descripcion":"INCAPAZ DE REALIZAR ACTIVIDADES DE BRICOLAJE"
  },
  {
    "codigo":169758009,
    "descripcion":"SIN ATENCIÓN POSNATAL"
  },
  {
    "codigo":298995001,
    "descripcion":"AMPLITUD DE SUPINACIÓN ACTIVA DE LA MUÑECA DISMINUIDA"
  },
  {
    "codigo":167923006,
    "descripcion":"MÉDULA ÓSEA CON HIPOPLASIA ERITROIDE"
  },
  {
    "codigo":724979009,
    "descripcion":"LACERACIÓN DE TENDÓN DE MÚSCULO EXTENSOR DE DEDO DE LA MANO A LA ALTURA DEL ANTEBRAZO"
  },
  {
    "codigo":428232002,
    "descripcion":"FRACTURA NO EXPUESTA TIPO V DE SALTER-HARRIS DE EPÍFISIS DISTAL DE FÉMUR"
  },
  {
    "codigo":297160003,
    "descripcion":"ANEURISMA VENTRICULAR IZQUIERDO"
  },
  {
    "codigo":723144001,
    "descripcion":"FRACTURA POR ESTALLIDO DE PRIMERA VÉRTEBRA CERVICAL, ESTABLE"
  },
  {
    "codigo":65949001,
    "descripcion":"RUIDOS RESPIRATORIOS AUMENTADOS"
  },
  {
    "codigo":786845002,
    "descripcion":"BACILLUS CEREUS, BACILLUS MYCOIDES O BACILLUS THURINGIENSIS"
  },
  {
    "codigo":295325003,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE MEDIO DE CONTRASTE RADIOGRÁFICO"
  },
  {
    "codigo":262557004,
    "descripcion":"HERIDA PROFUNDA"
  },
  {
    "codigo":1145458000,
    "descripcion":"APLASIA DE CLAVÍCULA"
  },
  {
    "codigo":293490001,
    "descripcion":"REACCIÓN ADVERSA A LA METOLAZONA"
  },
  {
    "codigo":459165008,
    "descripcion":"ARTERIA COLATERAL QUE DERIVA EL FLUJO SISTÉMICO HACIA LA CIRCULACIÓN PULMONAR DESDE LA AORTA ABDOMINAL"
  },
  {
    "codigo":195186005,
    "descripcion":"INFARTO CEREBRAL POR EMBOLIA DE ARTERIAS PRECEREBRALES"
  },
  {
    "codigo":129650008,
    "descripcion":"HIPERALFAGLOBULINEMIA"
  },
  {
    "codigo":783175003,
    "descripcion":"DISTROFIA MUSCULAR CONGÉNITA SIN DISCAPACIDAD INTELECTUAL"
  },
  {
    "codigo":160583004,
    "descripcion":"EX-BEBEDOR LEVE - 1 A 2 UNIDADES POR DÍA"
  },
  {
    "codigo":291655006,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR OXITETRACICLINA"
  },
  {
    "codigo":224284000,
    "descripcion":"USUARIO TELEFÓNICO SORDO Y CIEGO"
  },
  {
    "codigo":95047009,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA PIEL DEL ABDOMEN"
  },
  {
    "codigo":1141788003,
    "descripcion":"PELIOSIS BACILAR CAUSADA POR BARTONELLA QUINTANA"
  },
  {
    "codigo":289820006,
    "descripcion":"EXCITACIÓN DEL CUELLO UTERINO, AUSENTE"
  },
  {
    "codigo":715804009,
    "descripcion":"TOILETTE EN EL EXTERIOR"
  },
  {
    "codigo":91377003,
    "descripcion":"HIPERPROLACTINEMIA TRANSITORIA"
  },
  {
    "codigo":124145004,
    "descripcion":"DEFICIENCIA DE COLESTEROL OXIDASA"
  },
  {
    "codigo":419057008,
    "descripcion":"HALLAZGO RELACIONADO CON EL SONAMBULISMO"
  },
  {
    "codigo":287985008,
    "descripcion":"ASFIXIA EN EL PARTO GRAVE, PUNTAJE DE APGAR 0-3"
  },
  {
    "codigo":187846001,
    "descripcion":"NEOPLASIA MALIGNA DE CARTÍLAGO TIROIDES"
  },
  {
    "codigo":286150000,
    "descripcion":"LIMPIA LA BAÑERA"
  },
  {
    "codigo":251547000,
    "descripcion":"HALLAZGO DE LA FIBRA MUSCULAR AISLADA"
  },
  {
    "codigo":253382008,
    "descripcion":"DOBLE ORIFICIO DE VÁLVULA TRICÚSPIDE"
  },
  {
    "codigo":284315003,
    "descripcion":"NO MANIPULA OBJETOS"
  },
  {
    "codigo":448155003,
    "descripcion":"ATRESIA PULMONAR Y DEFECTO DE TABIQUE INTERVENTRICULAR TIPO FALLOT"
  },
  {
    "codigo":413552002,
    "descripcion":"ISQUEMIA DEL SEGMENTO ANTERIOR"
  },
  {
    "codigo":315248002,
    "descripcion":"DOLOR MAMARIO INTRATABLE"
  },
  {
    "codigo":53104002,
    "descripcion":"NECROSIS HEPÁTICA PERIFÉRICA"
  },
  {
    "codigo":184176004,
    "descripcion":"RESPONSABILIDAD DEL MÉDICO GENERAL POR EL PACIENTE: SUSPENDIDA"
  },
  {
    "codigo":10762191000119106,
    "descripcion":"ADHERENCIA VITREOMACULAR DE OJO DERECHO"
  },
  {
    "codigo":1003376006,
    "descripcion":"DUPLICACIÓN DE PORCIÓN MEDIA DE BRAZO LARGO DE CROMOSOMA 9"
  },
  {
    "codigo":247877002,
    "descripcion":"PENSAMIENTOS OBSESIVOS ACERCA DE INTOXICACIÓN"
  },
  {
    "codigo":313413008,
    "descripcion":"CÁLCULOS - HALLAZGO"
  },
  {
    "codigo":49434001,
    "descripcion":"ENFERMEDAD DEL VÓMITO DE JAMAICA"
  },
  {
    "codigo":442650003,
    "descripcion":"ESTUDIO POR IMÁGENES DEL BAZO, ANORMAL"
  },
  {
    "codigo":278810003,
    "descripcion":"DISTANCIA DE LA PRUEBA DE OCLUSIÓN OCULAR"
  },
  {
    "codigo":16005071000119109,
    "descripcion":"TRASTORNO DE NERVIO AXILAR DERECHO"
  },
  {
    "codigo":1163546007,
    "descripcion":"ENCEFALOMIELITIS CAUSADA POR MYCOBACTERIUM"
  },
  {
    "codigo":737562008,
    "descripcion":"DISPLASIA RENAL MULTIQUÍSTICA"
  },
  {
    "codigo":735727004,
    "descripcion":"DIVERTÍCULO DE INTESTINO DELGADO CONCOMITANTE CON HEMORRAGIA DE INTESTINO DELGADO"
  },
  {
    "codigo":702959006,
    "descripcion":"MORDIDA ABIERTA POSTERIOR IZQUIERDA"
  },
  {
    "codigo":276975007,
    "descripcion":"CARCINOMA DE LARINGE"
  },
  {
    "codigo":209604000,
    "descripcion":"DESGARRO COMPLETO DE LIGAMENTO INTERCARPIANO DORSAL"
  },
  {
    "codigo":111300007,
    "descripcion":"PERICARDITIS OBLITERANTE"
  },
  {
    "codigo":307908009,
    "descripcion":"ESTADO DE CERTIFICADOS VARIADOS"
  },
  {
    "codigo":15732841000119107,
    "descripcion":"BLEFAROCALASIA BILATERAL"
  },
  {
    "codigo":240537003,
    "descripcion":"VERRUGA DIGITAL"
  },
  {
    "codigo":1354649003,
    "descripcion":"DEFECTO AUTOSÓMICO RECESIVO DE REPARACIÓN DE ÁCIDO DESOXIRRIBONUCLEICO DEBIDO A DEFICIENCIA DE ADN LIGASA 1"
  },
  {
    "codigo":457131000221101,
    "descripcion":"CON RIESGO DE COMPLICACIÓN PERIOPERATORIA AUMENTADO"
  },
  {
    "codigo":43929004,
    "descripcion":"SÍNDROME DE SMITH - LEMLI - OPITZ"
  },
  {
    "codigo":11718761000119108,
    "descripcion":"LAGOFTALMOS BILATERAL DE PÁRPADO INFERIOR"
  },
  {
    "codigo":238702000,
    "descripcion":"INCONTINENCIA PIGMENTARIA"
  },
  {
    "codigo":9326001,
    "descripcion":"HIPERBILIRRUBINEMIA CONJUGADA"
  },
  {
    "codigo":369774002,
    "descripcion":"PATRÓN DE GLEASON 5"
  },
  {
    "codigo":402542002,
    "descripcion":"CARCINOMA BASOCELULAR RECIDIVANTE LUEGO DE CRIOCIRUGÍA"
  },
  {
    "codigo":11774211000119101,
    "descripcion":"CONTUSIÓN DE DEDO MEÑIQUE DERECHO"
  },
  {
    "codigo":207769005,
    "descripcion":"FRACTURA EXPUESTA DE LA APÓFISIS CORONOIDES DE LA MANDÍBULA"
  },
  {
    "codigo":42094007,
    "descripcion":"ESPOROTRICOSIS"
  },
  {
    "codigo":40259002,
    "descripcion":"ATAXIA SENSITIVA PROGRESIVA DE CHAROLAIS"
  },
  {
    "codigo":300568001,
    "descripcion":"TUMORACIÓN ISQUIORRECTAL"
  },
  {
    "codigo":235032001,
    "descripcion":"LEUCOPLASIA BUCAL SIFILÍTICA"
  },
  {
    "codigo":890392004,
    "descripcion":"MALFORMACIÓN CONGÉNITA DE LA VÍA AÉREA PULMONAR TIPO 1"
  },
  {
    "codigo":298733000,
    "descripcion":"HALLAZGO RELACIONADO CON EL TAMAÑO COSTAL"
  },
  {
    "codigo":366104009,
    "descripcion":"HALLAZGO RELACIONADO CON LA LATERALIZACIÓN DEL SONIDO"
  },
  {
    "codigo":202264009,
    "descripcion":"CONTRACTURA DE MÚLTIPLES ARTICULACIONES"
  },
  {
    "codigo":69357003,
    "descripcion":"TROMBOSIS PULMONAR"
  },
  {
    "codigo":11010461000119101,
    "descripcion":"CARCINOMA NEUROENDOCRINO MICROCÍTICO"
  },
  {
    "codigo":724717007,
    "descripcion":"DELIRIO CAUSADO POR FÁRMACO DISOCIATIVO"
  },
  {
    "codigo":722882004,
    "descripcion":"TRASTORNO FUNCIONAL DE LA PORCIÓN BILIAR DEL ESFÍNTER DE ODDI"
  },
  {
    "codigo":1148866004,
    "descripcion":"PROTEINURIA ORTOSTÁTICA INTERMITENTE"
  },
  {
    "codigo":427970008,
    "descripcion":"HIPERTIROIDISMO SUBCLÍNICO"
  },
  {
    "codigo":426135001,
    "descripcion":"PROSTATITIS CRÓNICA - SÍNDROME DE DOLOR PÉLVICO CRÓNICO"
  },
  {
    "codigo":296898009,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE ANTICONCEPTIVO ORAL"
  },
  {
    "codigo":32919003,
    "descripcion":"FUSIÓN CON ESTEREOPSIA DEFECTUOSA"
  },
  {
    "codigo":151004,
    "descripcion":"MENINGITIS GONOCÓCICA"
  },
  {
    "codigo":162156001,
    "descripcion":"SÍNTOMA DE SECRECIÓN VAGINAL"
  },
  {
    "codigo":293228002,
    "descripcion":"REACCIÓN ADVERSA A LA FINASTERIDA"
  },
  {
    "codigo":424300006,
    "descripcion":"ACTIVIDADES COMPARTIDAS MÍNIMAS"
  },
  {
    "codigo":225857001,
    "descripcion":"NO RESPETA REGLAS NI LÍMITES"
  },
  {
    "codigo":1208897003,
    "descripcion":"MIOCARDITIS POR SÍNDROME HIPEREOSINOFÍLICO IDIOPÁTICO"
  },
  {
    "codigo":782913006,
    "descripcion":"SÍNDROME DE DISPLASIA ESPONDILOMETAFISARIA, ANTEBRAZOS ARQUEADOS Y DISMORFISMO FACIAL"
  },
  {
    "codigo":10656311000119102,
    "descripcion":"ÚLCERA DE DEDO DE PIE IZQUIERDO"
  },
  {
    "codigo":92950003,
    "descripcion":"FORMA ANORMAL CONGÉNITA DEL ASTRÁGALO"
  },
  {
    "codigo":688541000119109,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS INTRAEPIDÉRMICO DE PIEL DE REGIÓN PERIANAL"
  },
  {
    "codigo":289558003,
    "descripcion":"SECRECIÓN VAGINAL ESCASA"
  },
  {
    "codigo":254955001,
    "descripcion":"CARCINOMA DE HIPÓFISIS"
  },
  {
    "codigo":334391000119104,
    "descripcion":"SUBLUXACIÓN DEL CRISTALINO DEL OJO DERECHO"
  },
  {
    "codigo":1172459005,
    "descripcion":"EPINEFRINA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":713707006,
    "descripcion":"ALERGIA A ABACAVIR"
  },
  {
    "codigo":8701000175105,
    "descripcion":"INFILTRADO PULMONAR EN UN SOLO LÓBULO"
  },
  {
    "codigo":123883009,
    "descripcion":"INTOXICACIÓN POR PLANTA INFERIOR"
  },
  {
    "codigo":416960004,
    "descripcion":"DISTROFIA ENDOTELIAL DE LA CÓRNEA"
  },
  {
    "codigo":285888005,
    "descripcion":"USA LA PAVA"
  },
  {
    "codigo":253120005,
    "descripcion":"LIPOMENINGOCELE"
  },
  {
    "codigo":449728008,
    "descripcion":"CALCIFICACIONES NODULARES DIFUSAS DE MAMA"
  },
  {
    "codigo":21909001,
    "descripcion":"VIABILIDAD FETAL"
  },
  {
    "codigo":251285001,
    "descripcion":"INTERCAMBIO GASEOSO EXTRACORPÓREO - HALLAZGO"
  },
  {
    "codigo":56512009,
    "descripcion":"RUPTURA DE CONDUCTO BILIAR"
  },
  {
    "codigo":185749000,
    "descripcion":"CONTROL DE LA OBESIDAD - CANCELADO"
  },
  {
    "codigo":415125002,
    "descripcion":"NEUMONÍA POR PNEUMOCYSTIS JIROVECI"
  },
  {
    "codigo":447893009,
    "descripcion":"ADENOMA PLEOMÓRFICO DE PALADAR"
  },
  {
    "codigo":282218002,
    "descripcion":"COMIENZA A CAMINAR Y SE DETIENE ESPONTÁNEAMENTE"
  },
  {
    "codigo":52842004,
    "descripcion":"TURBIDEZ DISMINUIDA"
  },
  {
    "codigo":249450007,
    "descripcion":"PROLAPSO DE CUERDA VOCAL"
  },
  {
    "codigo":773738009,
    "descripcion":"SÍNDROME DE INFECCIÓN CRÓNICA POR VIRUS DE EPSTEIN-BARR"
  },
  {
    "codigo":413290009,
    "descripcion":"ATENDIDO POR SERVICIO DE ATENCIÓN DE AGUDOS"
  },
  {
    "codigo":313151003,
    "descripcion":"ATENDIDO EN UN CONSULTORIO DE CIRUGÍA PEDIÁTRICA"
  },
  {
    "codigo":10957521000119104,
    "descripcion":"HERIDA ABIERTA DE PULGAR IZQUIERDO"
  },
  {
    "codigo":247615001,
    "descripcion":"NO PUEDE RECORDAR LA FECHA DE NACIMIENTO DE LOS HIJOS"
  },
  {
    "codigo":49172000,
    "descripcion":"ENFERMEDAD CAUSADA POR VESICULOVIRUS"
  },
  {
    "codigo":737300001,
    "descripcion":"TRASPLANTE DE MÉDULA ÓSEA PRESENTE"
  },
  {
    "codigo":1163284000,
    "descripcion":"PREOCUPACIÓN POR LA FORMA CORPORAL"
  },
  {
    "codigo":15708881000119105,
    "descripcion":"LUXACIÓN RECURRENTE DE ARTICULACIÓN DE AMBOS TOBILLOS"
  },
  {
    "codigo":278548004,
    "descripcion":"RESTAURACIÓN DENTARIA CON SUPERFICIE RUGOSA"
  },
  {
    "codigo":276713004,
    "descripcion":"ELIMINACIÓN TARDÍA DEL MECONIO"
  },
  {
    "codigo":735465007,
    "descripcion":"BRONQUITIS PROLONGADA CAUSADA POR BACTERIAS"
  },
  {
    "codigo":1259753009,
    "descripcion":"NEOPLASIA PRIMARIA MALIGNA DE CORDONES SEXUALES DE TESTÍCULO"
  },
  {
    "codigo":209342002,
    "descripcion":"FRACTURA-SUBLUXACIÓN NO EXPUESTA DE ARTICULACIÓN DE LA RODILLA"
  },
  {
    "codigo":733630004,
    "descripcion":"DEFICIENCIA DE ALFA-CETOGLUTARATO DESHIDROGENASA"
  },
  {
    "codigo":307646004,
    "descripcion":"LINFOMA MALIGNO, LINFOCÍTICO, MAL DIFERENCIADO, NODULAR"
  },
  {
    "codigo":405950009,
    "descripcion":"ABSCESO DE TÓRAX"
  },
  {
    "codigo":240275002,
    "descripcion":"FALLA DE DISPOSITIVO DE FIJACIÓN ÓSEO"
  },
  {
    "codigo":371347004,
    "descripcion":"TRASTORNO DE LA PIEL DE LA VULVA"
  },
  {
    "codigo":305811005,
    "descripcion":"ATENDIDO POR EL SERVICIO DE ENDOCRINOLOGÍA"
  },
  {
    "codigo":895635006,
    "descripcion":"FORMA TRIANGULAR ANORMAL CONGÉNITA DE FALANGE DE TERCER DEDO DE PIE"
  },
  {
    "codigo":38201000087100,
    "descripcion":"HIPOCINESIA DE SEGMENTO APICAL INFERIOR DE VENTRÍCULO CARDÍACO IZQUIERDO"
  },
  {
    "codigo":76435008,
    "descripcion":"FRACTURA EXPUESTA A NIVEL DE C1 - C4 CON LESIÓN TRAUMÁTICA DE LA MÉDULA ESPINAL"
  },
  {
    "codigo":43321000087105,
    "descripcion":"CUERPO EXTRAÑO DE ÓRBITA DERECHA PROPIAMENTE DICHA"
  },
  {
    "codigo":402280002,
    "descripcion":"DERMATITIS IRRITATIVA POR CONTACTO DEBIDA A COLOSTOMÍA"
  },
  {
    "codigo":1155944003,
    "descripcion":"INTOXICACIÓN CAUSADA POR METAL PESADO Y\/O COMPUESTO DE METAL PESADO"
  },
  {
    "codigo":238440001,
    "descripcion":"BLASTOMICOSIS CUTÁNEA PRIMARIA"
  },
  {
    "codigo":205672005,
    "descripcion":"INVERSIÓN CROMOSÓMICA EN EL INDIVIDUO NORMAL"
  },
  {
    "codigo":48441000087102,
    "descripcion":"FRACTURA DE APÓFISIS ESTILOIDES DE CÚBITO IZQUIERDO"
  },
  {
    "codigo":40761000087108,
    "descripcion":"ABRASIÓN DE PIEL DE CUARTO DEDO DE PIE DERECHO"
  },
  {
    "codigo":302141000,
    "descripcion":"HALLAZGO RELACIONADO CON NECESIDADES EDUCATIVAS ESPECIALES"
  },
  {
    "codigo":369512008,
    "descripcion":"TUMOR MALIGNO QUE COMPROMETE LA VAGINA POR PROPAGACIÓN DIRECTA DEL OVARIO"
  },
  {
    "codigo":236605002,
    "descripcion":"NECROSIS ISQUÉMICA URETERAL"
  },
  {
    "codigo":1186877003,
    "descripcion":"DEMENCIA DEBIDA A DEFICIENCIA DE VITAMINA E"
  },
  {
    "codigo":41832009,
    "descripcion":"TRASTORNO BIPOLAR I GRAVE, UN SOLO EPISODIO MANÍACO CON SÍNTOMAS PSICÓTICOS"
  },
  {
    "codigo":890130000,
    "descripcion":"SÍNDROME DE DELECIÓN 9Q34"
  },
  {
    "codigo":300306001,
    "descripcion":"PROBLEMA GÁSTRICO"
  },
  {
    "codigo":202002001,
    "descripcion":"ARTROPATÍA TRANSITORIA DE ARTICULACIÓN RADIOCUBITAL DISTAL"
  },
  {
    "codigo":1119506007,
    "descripcion":"FATIGA MUSCULAR INDUCIDA POR EJERCICIO"
  },
  {
    "codigo":724455003,
    "descripcion":"BOLSILLOS PERITONEALES CONCOMITANTES CON ENDOMETRIOSIS"
  },
  {
    "codigo":396775007,
    "descripcion":"PARED ESCROTAL COMPROMETIDA POR EXTENSIÓN DIRECTA DE NEOPLASIA MALIGNA"
  },
  {
    "codigo":298471007,
    "descripcion":"SIN ROTACIÓN PASIVA DE LA COLUMNA CERVICAL HACIA LA IZQUIERDA"
  },
  {
    "codigo":1148604001,
    "descripcion":"FRECUENCIA ANORMAL DE ELECTRORRETINOGRAMA DE PATRÓN"
  },
  {
    "codigo":1279676001,
    "descripcion":"LUXACIÓN DE ARTICULACIÓN DE DEDO ANULAR DE MANO"
  },
  {
    "codigo":34492003,
    "descripcion":"REACCIÓN A TRANSFUSIÓN DEBIDA A EMBOLIA GASEOSA"
  },
  {
    "codigo":394940002,
    "descripcion":"ESTADIO B DE DUKES"
  },
  {
    "codigo":1724002,
    "descripcion":"INFECCIÓN CAUSADA POR CRENOSOMA"
  },
  {
    "codigo":460476006,
    "descripcion":"TRAYECTO POSTERIOR DE ARTERIA DE NÓDULO SINUSAL EN RELACIÓN CON LA VENA CAVA SUPERIOR"
  },
  {
    "codigo":722620007,
    "descripcion":"HEMATOMA TRAUMÁTICO FOCAL DE CEREBELO"
  },
  {
    "codigo":130961000,
    "descripcion":"FORMA NORMAL DEL PEZÓN MAMARIO"
  },
  {
    "codigo":198332009,
    "descripcion":"LACERACIÓN UTERINA ANTIGUA, DE CAUSA OBSTÉTRICA"
  },
  {
    "codigo":1111451000000106,
    "descripcion":"GLAUCOMA DE ÁNGULO CERRADO AGUDO"
  },
  {
    "codigo":1343377003,
    "descripcion":"CICATRIZ DEBIDA A PROCEDIMIENTO CON LÁSER Y POSTERIOR A ÉL"
  },
  {
    "codigo":10632351000119101,
    "descripcion":"ABSCESO DE PULGAR DE MANO DERECHA"
  },
  {
    "codigo":296636007,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE TRIMETOPRIMA"
  },
  {
    "codigo":196497007,
    "descripcion":"FÍSTULA DE GLÁNDULA SUBLINGUAL"
  },
  {
    "codigo":294801009,
    "descripcion":"ALERGIA A QUINAGOLIDA"
  },
  {
    "codigo":65425009,
    "descripcion":"INTOXICACIÓN POR IMIPRAMINA"
  },
  {
    "codigo":1144934003,
    "descripcion":"INFECCIÓN RECURRENTE DEBIDA A DEFICIENCIA ESPECÍFICA GRANULAR"
  },
  {
    "codigo":292966004,
    "descripcion":"REACCIÓN ADVERSA A LAS PENICILINAS DE AMPLIO ESPECTRO"
  },
  {
    "codigo":291131002,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR CLOZAPINA"
  },
  {
    "codigo":94523002,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LÓBULO MEDIO DE PULMÓN DERECHO"
  },
  {
    "codigo":225595004,
    "descripcion":"DOLOR ASOCIADO CON LA DEFECACIÓN"
  },
  {
    "codigo":127291006,
    "descripcion":"LUXACIÓN LATERAL EXPUESTA DE ARTICULACIÓN SUBASTRAGALINA"
  },
  {
    "codigo":28987007,
    "descripcion":"ACIDURIA GLUTÁRICA"
  },
  {
    "codigo":289296003,
    "descripcion":"ONDA LÍQUIDA DE LÍQUIDO AMNIÓTICO, PRESENTE"
  },
  {
    "codigo":92688004,
    "descripcion":"CARCINOMA IN SITU DE LA PARED POSTERIOR DE LA NASOFARINGE"
  },
  {
    "codigo":27152008,
    "descripcion":"HIPEREMESIS GRAVÍDICA ANTES DEL FIN DE LA SEMANA 22 DE GESTACIÓN CON DEPLECIÓN DE CARBOHIDRATOS"
  },
  {
    "codigo":58085004,
    "descripcion":"ÚLCERA PÉPTICA AGUDA SIN HEMORRAGIA NI PERFORACIÓN PERO CON OBSTRUCCIÓN"
  },
  {
    "codigo":123621006,
    "descripcion":"EXTENSIÓN NORMAL"
  },
  {
    "codigo":25317007,
    "descripcion":"FALLA DE INJERTO POR FILTRACIÓN POR ANASTOMOSIS"
  },
  {
    "codigo":254693008,
    "descripcion":"ACANTOMA DE LA ENVOLTURA PILAR"
  },
  {
    "codigo":11998521000119102,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":711610000,
    "descripcion":"LAMIDA SEXUAL"
  },
  {
    "codigo":713445006,
    "descripcion":"INFECCIÓN DISEMINADA CAUSADA POR STRONGYLOIDES CONCOMITANTE CON INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":1268666006,
    "descripcion":"RECIÉN NACIDO A TÉRMINO 38 SEMANAS"
  },
  {
    "codigo":449466007,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE PARED TORÁCICA"
  },
  {
    "codigo":283791000,
    "descripcion":"MORDEDURA DE ANIMAL EN EL CUERO CABELLUDO"
  },
  {
    "codigo":285626009,
    "descripcion":"CAPAZ DE ADMINISTRAR EL TIEMPO"
  },
  {
    "codigo":251023003,
    "descripcion":"INJERTO CORONARIO PERMEABLE"
  },
  {
    "codigo":21647008,
    "descripcion":"DEPENDENCIA DE ANFETAMINAS"
  },
  {
    "codigo":871780002,
    "descripcion":"REACCIÓN ADVERSA A BENZIMIDAZOL"
  },
  {
    "codigo":50745000,
    "descripcion":"HEMIANALGESIA"
  },
  {
    "codigo":443961001,
    "descripcion":"NEOPLASIA MALIGNA ADENOMATOSA"
  },
  {
    "codigo":1230393005,
    "descripcion":"PARTICIPACIÓN SOCIAL ADECUADA"
  },
  {
    "codigo":212750003,
    "descripcion":"INTOXICACIÓN POR AGENTE ELECTROLÍTICO"
  },
  {
    "codigo":81678004,
    "descripcion":"SÍNDROME DE CROMOSOMA 4 EN ANILLO"
  },
  {
    "codigo":16142004,
    "descripcion":"INFECCIÓN CAUSADA POR NOSEMA"
  },
  {
    "codigo":897559009,
    "descripcion":"DISPLASIA RETINIANA CONGÉNITA CAUSADA POR SUSTANCIA TERATOGÉNICA"
  },
  {
    "codigo":735203000,
    "descripcion":"MÉDICAMENTE NO APTO PARA EL TRASLADO A PRISIÓN"
  },
  {
    "codigo":278286009,
    "descripcion":"HEMIPARESIA DERECHA"
  },
  {
    "codigo":737038009,
    "descripcion":"CONSENTIMIENTO PARA TRATAMIENTO REHUSADO"
  },
  {
    "codigo":407523005,
    "descripcion":"SECUESTRO ÓSEO"
  },
  {
    "codigo":1357795006,
    "descripcion":"LESIÓN TRAUMÁTICA PERFORANTE DE GLOBO OCULAR IZQUIERDO"
  },
  {
    "codigo":1259491005,
    "descripcion":"CARCINOMA EX ADENOMA PLEOMORFO PRIMARIO DE GLÁNDULA PARÓTIDA"
  },
  {
    "codigo":733368007,
    "descripcion":"MÚLTIPLES LESIONES TRAUMÁTICAS SUPERFICIALES DE DORSO INFERIOR"
  },
  {
    "codigo":1290424008,
    "descripcion":"RADIOGRAFÍA SIMPLE DE PARTES BLANDAS ANORMAL"
  },
  {
    "codigo":241848008,
    "descripcion":"EFECTO TÓXICO CAUSADO POR LIMPIADOR DE INODOROS"
  },
  {
    "codigo":305549002,
    "descripcion":"BAJO ATENCIÓN DE CIRUJANO PLÁSTICO"
  },
  {
    "codigo":43405004,
    "descripcion":"SÍNDROME MEDULAR ANTERIOR DEBIDO A FRACTURA EXPUESTA A NIVEL DE C5-C7"
  },
  {
    "codigo":371085006,
    "descripcion":"NO INMUNE AL SARAMPIÓN"
  },
  {
    "codigo":698765007,
    "descripcion":"SÍNDROME PHACE"
  },
  {
    "codigo":403853008,
    "descripcion":"AMPOLLA DE SUCCIÓN EN EL RECIÉN NACIDO"
  },
  {
    "codigo":74338006,
    "descripcion":"INTOXICACIÓN CAUSADA POR FÁRMACO ANTIMUSCARÍNICO"
  },
  {
    "codigo":926306007,
    "descripcion":"DISPOSITIVO NEUROESTIMULADOR ENCEFÁLICO IN SITU"
  },
  {
    "codigo":762466008,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL SUPERFICIAL DE CABEZA"
  },
  {
    "codigo":203575002,
    "descripcion":"TALÓN EN VARO ADQUIRIDO"
  },
  {
    "codigo":1186615002,
    "descripcion":"SARCOMA DE KAPOSI PRIMARIO DE PALADAR"
  },
  {
    "codigo":170807005,
    "descripcion":"MOTIVO PARA TRATAMIENTO DE OBESIDAD - LABORAL"
  },
  {
    "codigo":70668000,
    "descripcion":"FÍSTULA ARTERIOVENOSA ADQUIRIDA DEL HÍGADO"
  },
  {
    "codigo":365580001,
    "descripcion":"HALLAZGO RELACIONADO CON LA CONDICIÓN PERSONAL"
  },
  {
    "codigo":5132005,
    "descripcion":"QUERATOSIS PILARIS"
  },
  {
    "codigo":286471000119100,
    "descripcion":"PORTADOR DE TRASTORNO NEUROGENÉTICO"
  },
  {
    "codigo":234508008,
    "descripcion":"RUPTURA TARDÍA DEL BAZO"
  },
  {
    "codigo":267276009,
    "descripcion":"ANESTESIA OBSTÉTRICA CON COMPLICACIONES PULMONARES"
  },
  {
    "codigo":363745004,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL TRACTO GASTROINTESTINAL"
  },
  {
    "codigo":396513005,
    "descripcion":"MARGEN QUIRÚRGICO LATERAL COMPROMETIDO POR MELANOMA MALIGNO"
  },
  {
    "codigo":298209007,
    "descripcion":"LAXITUD DE ARTICULACIÓN DE MUÑECA"
  },
  {
    "codigo":66998000,
    "descripcion":"OVARIO GRANDE"
  },
  {
    "codigo":34230007,
    "descripcion":"HIPERPARATIROIDISMO DEBIDO A TERAPIA CON LITIO"
  },
  {
    "codigo":1344950008,
    "descripcion":"TRASTORNO DE ANSIEDAD EN EL EMBARAZO"
  },
  {
    "codigo":787894009,
    "descripcion":"LYSINIBACILLUS FUSIFORMIS O LYSINIBACILLUS SPHAERICUS"
  },
  {
    "codigo":296374009,
    "descripcion":"SOBREDOSIS DE METARAMINOL"
  },
  {
    "codigo":16015111000119104,
    "descripcion":"TRASTORNO DE LIGAMENTOS DE ARTICULACIONES DE AMBOS TOBILLOS"
  },
  {
    "codigo":165302008,
    "descripcion":"MEMORIA: RECUERDA PERSONAS IMPORTANTES"
  },
  {
    "codigo":720523006,
    "descripcion":"DISTROFIA MUSCULAR DE LAS CINTURAS DE LAS EXTREMIDADES TIPO 2K AUTOSÓMICA RECESIVA"
  },
  {
    "codigo":294539007,
    "descripcion":"ALERGIA A LATAMOXEF"
  },
  {
    "codigo":128864004,
    "descripcion":"SEUDOLINFOMA CUTÁNEO DE LINFOCITOS T"
  },
  {
    "codigo":1144672005,
    "descripcion":"HIPOPLASIA CONGÉNITA DE DEDO DE PIE"
  },
  {
    "codigo":816992006,
    "descripcion":"FISURA CUTÁNEA BILATERAL DE MANOS"
  },
  {
    "codigo":292704008,
    "descripcion":"REACCIÓN ADVERSA A LA MIFEPRISTONA"
  },
  {
    "codigo":94261000,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA COMISURA LABIAL"
  },
  {
    "codigo":718688008,
    "descripcion":"MONOSOMÍA 6P DISTAL"
  },
  {
    "codigo":290869003,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ISOCARBOXAZIDA"
  },
  {
    "codigo":1079201000119101,
    "descripcion":"CARCINOMA BASOCELULAR PRIMARIO DE PIEL DE HOMBRO DERECHO"
  },
  {
    "codigo":61493004,
    "descripcion":"ENFERMEDAD DE CADENA PESADA MU"
  },
  {
    "codigo":127029006,
    "descripcion":"NEOPLASIA DEL CUERPO AÓRTICO"
  },
  {
    "codigo":59658000,
    "descripcion":"HERNIA EPIGÁSTRICA CON GANGRENA Y OBSTRUCCIÓN"
  },
  {
    "codigo":878858004,
    "descripcion":"GRANULOMATOSIS LINFOMATOIDE MALIGNA GRADO 3 DE PULMÓN"
  },
  {
    "codigo":92426007,
    "descripcion":"NEOPLASIA BENIGNA DE HUESO TEMPORAL"
  },
  {
    "codigo":289034007,
    "descripcion":"DIFICULTAD PARA ALIMENTARSE CON LA MANO IZQUIERDA"
  },
  {
    "codigo":254431000,
    "descripcion":"CARCINOMA DE LA PORCIÓN LATERAL DEL PISO DE LA BOCA"
  },
  {
    "codigo":1237471002,
    "descripcion":"METÁSTASIS DE CARCINOMA ESCAMOSO EN BRONQUIO DE LÓBULO INFERIOR DERECHO"
  },
  {
    "codigo":451039008,
    "descripcion":"HEMORRAGIA EN PUTAMEN"
  },
  {
    "codigo":449204005,
    "descripcion":"LEIOMIOMA PILAR"
  },
  {
    "codigo":88756008,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DEL MENTÓN"
  },
  {
    "codigo":185225004,
    "descripcion":"ATENDIDO EN UN CONSULTORIO PSICOLÓGICO"
  },
  {
    "codigo":283529008,
    "descripcion":"HERIDA PUNZANTE DE GENITALES"
  },
  {
    "codigo":1363038002,
    "descripcion":"METABOLIZADOR INTERMEDIO DE LA FAMILIA 2 SUBFAMILIA C MIEMBRO 9 *5\/*11 DEL CITOCROMO P450"
  },
  {
    "codigo":19550003,
    "descripcion":"MONOSOMÍA PARCIAL 22Q"
  },
  {
    "codigo":507891771000119103,
    "descripcion":"ATRAPAMIENTO DE MÚSCULO RECTO SUPERIOR DE OJO IZQUIERDO"
  },
  {
    "codigo":299731000119100,
    "descripcion":"QUISTE ÓSEO SOLITARIO DE CÚBITO"
  },
  {
    "codigo":82131000119101,
    "descripcion":"HERPES SIMPLE RECURRENTE NO GENITAL"
  },
  {
    "codigo":368851000119102,
    "descripcion":"SÍNDROME DE INSENSIBILIDAD COMPLETA A ANDRÓGENOS"
  },
  {
    "codigo":1197363004,
    "descripcion":"ACCIDENTE CEREBROVASCULAR ISQUÉMICO PEDIÁTRICO"
  },
  {
    "codigo":278024000,
    "descripcion":"RABDOMIOSARCOMA DE VEJIGA URINARIA"
  },
  {
    "codigo":10752211000119104,
    "descripcion":"VAGINOSIS BACTERIANA POSPARTO"
  },
  {
    "codigo":247091007,
    "descripcion":"VITREOSQUISIS"
  },
  {
    "codigo":338131000119105,
    "descripcion":"DESPRENDIMIENTO DE RETINA DE OJO IZQUIERDO DEBIDO A DESGARRO DE RETINA"
  },
  {
    "codigo":720138451000119108,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO DE MANO"
  },
  {
    "codigo":15880005,
    "descripcion":"PARAFRASIA"
  },
  {
    "codigo":10941651000119102,
    "descripcion":"HEMORRAGIA CEREBRAL IZQUIERDA TRAUMÁTICA"
  },
  {
    "codigo":128211000119102,
    "descripcion":"MENINGOENCEFALITIS DEBIDA A AMEBA DE VIDA LIBRE"
  },
  {
    "codigo":11842771000119106,
    "descripcion":"DISTENSIÓN DE MÚSCULO DEL PIE IZQUIERDO"
  },
  {
    "codigo":1075411000119104,
    "descripcion":"RUPTURA CRÓNICA DE LIGAMENTO CRUZADO ANTERIOR DE RODILLA DERECHA"
  },
  {
    "codigo":1259229002,
    "descripcion":"MASA DE CUELLO DE VEJIGA"
  },
  {
    "codigo":11776211000119107,
    "descripcion":"LESIÓN TRAUMÁTICA DE ANTEBRAZO DERECHO"
  },
  {
    "codigo":348371000119109,
    "descripcion":"FASE HIDRÓPICA AGUDA DE QUERATOCONO DE OJO DERECHO"
  },
  {
    "codigo":11768531000119108,
    "descripcion":"HEMATOMA SUBUNGUEAL DE DEDO ÍNDICE DE MANO DERECHA"
  },
  {
    "codigo":472797003,
    "descripcion":"ESTENOSIS SUBAÓRTICA ASOCIADA CON CORAZÓN FUNCIONALMENTE UNIVENTRICULAR COMO COMPLICACIÓN DE PROCEDIMIENTO"
  },
  {
    "codigo":896946000,
    "descripcion":"FORMA DE BALA ANORMAL CONGÉNITA DE FALANGE MEDIA DE CUARTO DEDO DE PIE"
  },
  {
    "codigo":77746001,
    "descripcion":"LEONTIASIS"
  },
  {
    "codigo":700338003,
    "descripcion":"XANTOMA DE PÁRPADO INFERIOR"
  },
  {
    "codigo":403591002,
    "descripcion":"RITUAL DE LAVADO DE MANOS"
  },
  {
    "codigo":895111002,
    "descripcion":"CORDOMA DE COLUMNA VERTEBRAL"
  },
  {
    "codigo":239751007,
    "descripcion":"SUBLUXACIÓN PATOLÓGICA DE LA ARTICULACIÓN"
  },
  {
    "codigo":10375008,
    "descripcion":"SECUESTRO PULMONAR SUBPLEURAL EXTRAPULMONAR"
  },
  {
    "codigo":1157255008,
    "descripcion":"RECUENTO DE GRANULOCITOS DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":205148004,
    "descripcion":"SINDACTILIA ÓSEA DE DEDOS DEL PIE - PRIMERA MEMBRANA INTERDIGITAL"
  },
  {
    "codigo":303452005,
    "descripcion":"NO SE ACUCLILLA SOBRE EL INODORO"
  },
  {
    "codigo":41308008,
    "descripcion":"CONJUNTIVITIS FOLICULAR AGUDA"
  },
  {
    "codigo":72241001,
    "descripcion":"ENFERMEDAD INFECCIOSA TRANSMITIDA POR EL POLVO"
  },
  {
    "codigo":170545001,
    "descripcion":"REQUIERE UNA DOSIS DE VACUNA CONTRA FIEBRE AMARILLA"
  },
  {
    "codigo":399921006,
    "descripcion":"HAMARTOMA DE PIEL"
  },
  {
    "codigo":236081008,
    "descripcion":"INCONTINENCIA FECAL CONGÉNITA"
  },
  {
    "codigo":365318000,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA DESECHAR LA BASURA DOMÉSTICA"
  },
  {
    "codigo":1348358002,
    "descripcion":"ARTRITIS DE CODO DEBIDA A GOTA"
  },
  {
    "codigo":37638002,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE REGIÓN INTERESCAPULAR SIN INFECCIÓN"
  },
  {
    "codigo":299782008,
    "descripcion":"REFLEJO DE OJOS DE MUÑECA DUDOSO"
  },
  {
    "codigo":1081711000119104,
    "descripcion":"SARCOMA PRIMARIO DE MIEMBRO INFERIOR IZQUIERDO"
  },
  {
    "codigo":363483004,
    "descripcion":"NEOPLASIA MALIGNA DE GLÁNDULA PINEAL"
  },
  {
    "codigo":232411006,
    "descripcion":"EDEMA DE ÚVULA"
  },
  {
    "codigo":396251006,
    "descripcion":"MARGEN QUIRÚRGICO ENDOCERVICAL COMPROMETIDO POR NEOPLASIA INTRAEPITELIAL"
  },
  {
    "codigo":297947008,
    "descripcion":"HALLAZGO RELACIONADO CON LA CONSISTENCIA DE LA PIEL"
  },
  {
    "codigo":429019009,
    "descripcion":"HALLAZGO RELACIONADO CON EL SEXO BIOLÓGICO"
  },
  {
    "codigo":427184002,
    "descripcion":"TROMBOSIS DE ARTERIA CUBITAL"
  },
  {
    "codigo":165040003,
    "descripcion":"CAPACIDAD VITAL FORZADA ANORMAL"
  },
  {
    "codigo":230576004,
    "descripcion":"POLINEUROPATÍA ASIMÉTRICA DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":15991151000119105,
    "descripcion":"PARS PLANITIS DE OJO DERECHO"
  },
  {
    "codigo":197808006,
    "descripcion":"FIBROSIS RETROPERITONEAL IDIOPÁTICA"
  },
  {
    "codigo":722096006,
    "descripcion":"LESIÓN RENAL AGUDA DEBIDA A HIPOVOLEMIA"
  },
  {
    "codigo":296112009,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE PRAZEPAM"
  },
  {
    "codigo":294277002,
    "descripcion":"ALERGIA A NALOXONA"
  },
  {
    "codigo":12114441000119101,
    "descripcion":"QUEMADURA QUÍMICA DE MUSLO IZQUIERDO"
  },
  {
    "codigo":344431000119108,
    "descripcion":"LUXACIÓN POSTERIOR DE AMBOS CRISTALINOS"
  },
  {
    "codigo":95834000,
    "descripcion":"HEMIATROFIA FACIAL"
  },
  {
    "codigo":128602000,
    "descripcion":"HETEROTROPÍA"
  },
  {
    "codigo":292442003,
    "descripcion":"REACCIÓN ADVERSA AL TIMOLOL"
  },
  {
    "codigo":1144410003,
    "descripcion":"HIPOPLASIA CONGÉNITA DE HEMITÓRAX DERECHO"
  },
  {
    "codigo":1177178005,
    "descripcion":"SÍNDROME DE RESTRICCIÓN DEL CRECIMIENTO INTRAUTERINO, MÚLTIPLES MÁCULAS CAFÉ CON LECHE CONGÉNITAS, ELEVADA TASA DE INTERCAMBIO ENTRE CROMÁTIDES HERMANAS"
  },
  {
    "codigo":290607001,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR IFOSFAMIDA"
  },
  {
    "codigo":28463004,
    "descripcion":"QUERATITIS POR VIRUS DEL SARAMPIÓN"
  },
  {
    "codigo":92164002,
    "descripcion":"NEOPLASIA BENIGNA DE LA ZONA DE UNIÓN DE LA LENGUA"
  },
  {
    "codigo":288772003,
    "descripcion":"NO DIRIGE LA ATENCIÓN"
  },
  {
    "codigo":26628009,
    "descripcion":"TRASTORNO DEL PENSAMIENTO"
  },
  {
    "codigo":254169002,
    "descripcion":"ICTIOSIS BULLOSA DE SIEMENS"
  },
  {
    "codigo":188633006,
    "descripcion":"ENFERMEDAD DE SÉZARY DE GANGLIOS LINFÁTICOS DE AXILA Y MIEMBRO SUPERIOR"
  },
  {
    "codigo":53891004,
    "descripcion":"LIQUEN SIMPLE CRÓNICO"
  },
  {
    "codigo":283267005,
    "descripcion":"VIDRIO EN RODILLA"
  },
  {
    "codigo":445272000,
    "descripcion":"EFECTO TARDÍO DE ABUSO INFANTIL"
  },
  {
    "codigo":19288000,
    "descripcion":"INFECCIÓN CAUSADA POR PENTASTOMA NAJAE"
  },
  {
    "codigo":707416002,
    "descripcion":"PAPILOMA TRAQUEOBRONQUIAL SOLITARIO"
  },
  {
    "codigo":1231704002,
    "descripcion":"DEFORMIDAD DE HUESO Y PARTES BLANDAS DE ÓRBITA DEBIDA A RADIOTERAPIA Y POSTERIOR A ELLA"
  },
  {
    "codigo":281432004,
    "descripcion":"INFECCIÓN DE INJERTO MUSCULAR"
  },
  {
    "codigo":248664006,
    "descripcion":"RUIDOS CARDÍACOS DIFERENTES"
  },
  {
    "codigo":11815741000119100,
    "descripcion":"RUPTURA TRAUMÁTICA DE PLACA PALMAR DE ARTICULACIÓN DE DEDO ANULAR DERECHO"
  },
  {
    "codigo":443437004,
    "descripcion":"AGUJERO DE ESPESOR COMPLETO DE MÁCULA LÚTEA"
  },
  {
    "codigo":246829005,
    "descripcion":"ADHERENCIAS PALPEBRALES"
  },
  {
    "codigo":291491000119108,
    "descripcion":"HEMORRAGIA ATRAUMÁTICA DE ESPACIO SUBARACNOIDEO DE ARTERIA VERTEBRAL DERECHA"
  },
  {
    "codigo":1295405007,
    "descripcion":"RADIOGRAFÍA POSTMORTEM NORMAL"
  },
  {
    "codigo":212226001,
    "descripcion":"LESIÓN DE LA RAÍZ DEL NERVIO SACRO - S4"
  },
  {
    "codigo":48386003,
    "descripcion":"REGRESIÓN - MECANISMO DE DEFENSA PSICOLÓGICA"
  },
  {
    "codigo":703746004,
    "descripcion":"GEOTRICHUM CAPITATUM O PROTOTHECA ZOPFII O PICHIA KUDRIAVZEVII"
  },
  {
    "codigo":310530008,
    "descripcion":"RECIÉN NACIDO PREMATURO: 36 SEMANAS"
  },
  {
    "codigo":767447002,
    "descripcion":"INESTABILIDAD CONGÉNITA DE ARTICULACIÓN DE LA CADERA DERECHA"
  },
  {
    "codigo":275927006,
    "descripcion":"FARMACOTERAPIA - INCUMPLIMIENTO TOTAL"
  },
  {
    "codigo":110252002,
    "descripcion":"CONTUSIÓN DEL VESTÍBULO MANDIBULAR"
  },
  {
    "codigo":700076004,
    "descripcion":"OSTEOMIELITIS DE TOBILLO"
  },
  {
    "codigo":306860007,
    "descripcion":"ATENDIDO POR MÉDICO AUDIÓLOGO"
  },
  {
    "codigo":317641000112107,
    "descripcion":"FLORA AERÓBICA NORMAL"
  },
  {
    "codigo":10832701000119108,
    "descripcion":"FRACTURA EXPUESTA DE DIÁFISIS DE TERCER HUESO METACARPIANO DE MANO DERECHA"
  },
  {
    "codigo":403329009,
    "descripcion":"SÍNDROME DE ANÁGENO CORTO"
  },
  {
    "codigo":237654002,
    "descripcion":"HIPOPARATIROIDISMO IDIOPÁTICO"
  },
  {
    "codigo":399659001,
    "descripcion":"INVASIÓN PLEURAL POR TUMOR INDETERMINADA"
  },
  {
    "codigo":270422009,
    "descripcion":"ATENDIDO EN CONSULTORIO DERMATOLÓGICO"
  },
  {
    "codigo":301355003,
    "descripcion":"DOLOR EN UNA ESTRUCTURA RESPIRATORIA"
  },
  {
    "codigo":299520000,
    "descripcion":"HALLAZGO RELACIONADO CON TEMPERATURA DE ARTICULACIÓN DE PIE"
  },
  {
    "codigo":168448002,
    "descripcion":"EVALUACIÓN CROMOSÓMICA CELULAR, ANORMAL"
  },
  {
    "codigo":1217024006,
    "descripcion":"COLONIZACIÓN DE DISPOSITIVO"
  },
  {
    "codigo":233984007,
    "descripcion":"ANEURISMA DE AORTA TORACOABDOMINAL"
  },
  {
    "codigo":102912007,
    "descripcion":"TANATOFOBIA"
  },
  {
    "codigo":35541001,
    "descripcion":"RECESIÓN GINGIVAL POSTOPERATORIA"
  },
  {
    "codigo":365056006,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA ENTABLAR CONVERSACIÓN"
  },
  {
    "codigo":263082000,
    "descripcion":"FRACTURA-LUXACIÓN SEMILUNAR"
  },
  {
    "codigo":428757008,
    "descripcion":"RUPTURA TRAUMÁTICA DE MÚSCULO ESQUELÉTICO"
  },
  {
    "codigo":33706001,
    "descripcion":"TRISOMÍA PARCIAL 7Q"
  },
  {
    "codigo":264917009,
    "descripcion":"PORCIÓN SUPERIOR DE URÉTER DE RIÑÓN DOBLE"
  },
  {
    "codigo":164778004,
    "descripcion":"PRUEBA ESPECIAL DEL APARATO CARDIOVASCULAR NORMAL"
  },
  {
    "codigo":721834007,
    "descripcion":"HIPERINSULINISMO DEBIDO A DEFICIENCIA DE PROTEÍNA DE DESACOPLAMIENTO 2"
  },
  {
    "codigo":230314007,
    "descripcion":"SÍNDROME DE SANDIFER"
  },
  {
    "codigo":294015007,
    "descripcion":"ALERGIA A EDROFONIO"
  },
  {
    "codigo":783700001,
    "descripcion":"SÍNDROME DE SÍNDACTILIA, POLIDACTILIA Y LÓBULO AURICULAR"
  },
  {
    "codigo":31871009,
    "descripcion":"INFECCIÓN Y\/O REACCIÓN INFLAMATORIA DEBIDAS A DISPOSITIVO PROTÉSICO INTERNO, IMPLANTE Y\/O INJERTO"
  },
  {
    "codigo":193876005,
    "descripcion":"CONJUNTIVITIS CON TRASTORNO MUCOCUTÁNEO"
  },
  {
    "codigo":292180005,
    "descripcion":"REACCIÓN ADVERSA A LIDOCAÍNA"
  },
  {
    "codigo":161108005,
    "descripcion":"MIEMBRO DE LA SOCIEDAD DE ENFERMEDAD DE ALZHEIMER"
  },
  {
    "codigo":126505001,
    "descripcion":"NEOPLASIA DE LA PIEL DEL TRONCO"
  },
  {
    "codigo":192041001,
    "descripcion":"MALESTAR CIRCUNSTANCIAL AGUDO"
  },
  {
    "codigo":1142313001,
    "descripcion":"ATROFIA DE MÚSCULO AXIAL"
  },
  {
    "codigo":93737003,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL CALCÁNEO"
  },
  {
    "codigo":290345008,
    "descripcion":"INTOXICACIÓN POR SUCRALFATO"
  },
  {
    "codigo":124670000,
    "descripcion":"DEFICIENCIA DE GLUCOSAMINA - 6 - FOSFATO ISOMERASA"
  },
  {
    "codigo":288510000,
    "descripcion":"QUEMADURA CON COMPROMISO DE 9% DE LA SUPERFICIE CORPORAL"
  },
  {
    "codigo":91902004,
    "descripcion":"AUSENCIA CONGÉNITA DE HUESO PARIETAL"
  },
  {
    "codigo":11818251000119103,
    "descripcion":"ESGUINCE DE LIGAMENTO DE ARTICULACIÓN METACARPOFALÁNGICA DE DEDO ANULAR DE MANO DERECHA"
  },
  {
    "codigo":286675000,
    "descripcion":"INTROYECCIÓN - MECANISMO DE DEFENSA PSICOLÓGICA"
  },
  {
    "codigo":1204179003,
    "descripcion":"OCLUSIÓN AGUDA DE ARTERIA RENAL DEBIDA A TROMBOEMBOLISMO"
  },
  {
    "codigo":1086731000119104,
    "descripcion":"INFECCIÓN DE MÚLTIPLES LOCALIZACIONES POR ECHINOCOCCUS MULTILOCULARIS"
  },
  {
    "codigo":384979005,
    "descripcion":"BRONQUIO FUENTE (DISTALMENTE A MENOS DE 2 CM DE LA CARINA) AFECTADO POR PROPAGACIÓN DIRECTA DE NEOPLASIA MALIGNA"
  },
  {
    "codigo":1236947005,
    "descripcion":"METÁSTASIS DE CARCINOMA DE DORSO DE BASE DE LENGUA"
  },
  {
    "codigo":253907008,
    "descripcion":"VÁLVULA URETRAL ANTERIOR CONGÉNITA"
  },
  {
    "codigo":284840001,
    "descripcion":"CAPAZ DE LAVARSE LOS DIENTES"
  },
  {
    "codigo":448680004,
    "descripcion":"CONEXIONES VENTRICULOARTERIALES CONCORDANTES"
  },
  {
    "codigo":88232005,
    "descripcion":"TRASTORNO DE LAS GLÁNDULAS SUDORÍPARAS"
  },
  {
    "codigo":55464009,
    "descripcion":"LUPUS ERITEMATOSO SISTÉMICO"
  },
  {
    "codigo":446845005,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN DEDO DE MANO"
  },
  {
    "codigo":1003901005,
    "descripcion":"DELECIÓN PROXIMAL DEL BRAZO LARGO DEL CROMOSOMA 18"
  },
  {
    "codigo":53629007,
    "descripcion":"CONTUSIÓN DE TESTÍCULO"
  },
  {
    "codigo":250237007,
    "descripcion":"INCLUSIONES DE HEMOGLOBINA H"
  },
  {
    "codigo":248402002,
    "descripcion":"HALLAZGO GENERAL RELACIONADO CON PARTES BLANDAS"
  },
  {
    "codigo":445010006,
    "descripcion":"MUTACIÓN DE RECEPTOR DE LIPOPROTEÍNA DE BAJA DENSIDAD"
  },
  {
    "codigo":51794008,
    "descripcion":"ANOMALÍA CONGÉNITA DE URÉTER"
  },
  {
    "codigo":246567001,
    "descripcion":"DESCUIDO DE PIERNA"
  },
  {
    "codigo":1196839006,
    "descripcion":"CARCINOMA EMBRIONARIO PRIMARIO DE ENCÉFALO"
  },
  {
    "codigo":310268006,
    "descripcion":"ANTICUERPO ANTI - SM NO DETECTADO"
  },
  {
    "codigo":48124008,
    "descripcion":"FIBROSIS DE CONDUCTO BILIAR"
  },
  {
    "codigo":769020009,
    "descripcion":"CARIES DE LA RAÍZ DEL DIENTE NO CAVITADA"
  },
  {
    "codigo":11873701000119107,
    "descripcion":"MÚLTIPLES NEVOS DISPLÁSICOS"
  },
  {
    "codigo":767185006,
    "descripcion":"GANGLIÓN DE CADERA"
  },
  {
    "codigo":15969701000119108,
    "descripcion":"HEMORROIDES INTERNAS ESTRANGULADAS GRADO IV"
  },
  {
    "codigo":111825008,
    "descripcion":"TUBERCULOSIS DE LA CONJUNTIVA"
  },
  {
    "codigo":699814001,
    "descripcion":"ANGEÍTIS PRIMARIA DEL SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":75387001,
    "descripcion":"HIPERTIROSINEMIA NEONATAL TRANSITORIA"
  },
  {
    "codigo":208294009,
    "descripcion":"FRACTURA NO EXPUESTA DEL OLÉCRANON, EXTRARTICULAR"
  },
  {
    "codigo":403067003,
    "descripcion":"TIÑA CAUSADA POR TRICHOPHYTON EQUINUM"
  },
  {
    "codigo":1255035003,
    "descripcion":"ESGUINCE DE LIGAMENTO DE ARTICULACIÓN METACARPOFALÁNGICA DE DEDO MEDIO DE MANO"
  },
  {
    "codigo":206459005,
    "descripcion":"ICTERICIA NEONATAL DEBIDA A SÍNDROME DE ROTOR"
  },
  {
    "codigo":302928000,
    "descripcion":"CICATRIZ VULVAR"
  },
  {
    "codigo":9851009,
    "descripcion":"HALLAZGO RELACIONADO CON POSICIÓN DEL CUERPO"
  },
  {
    "codigo":401232002,
    "descripcion":"RIESGO DE PRODUCCIÓN INTENCIONAL DE DAÑO A SÍ MISMO DESCONOCIDO"
  },
  {
    "codigo":1351504006,
    "descripcion":"DEFICIENCIA DEL COMPLEJO MAYOR DE HISTOCOMPATIBILIDAD CLASE II DEBIDA A MUTACIÓN DEL GEN RFX5"
  },
  {
    "codigo":8016009,
    "descripcion":"HIPOFORIA"
  },
  {
    "codigo":202789004,
    "descripcion":"ESTENOSIS IATROGÉNICA DE CONDUCTO RAQUÍDEO LUMBAR"
  },
  {
    "codigo":366629004,
    "descripcion":"AMPLITUD DE MOVIMIENTO PASIVO DE PRONACIÓN MEDIOTARSIANA - HALLAZGO"
  },
  {
    "codigo":1251365008,
    "descripcion":"REACCIÓN CUTÁNEA POR CONTACTO CON CNIDARIA"
  },
  {
    "codigo":299258002,
    "descripcion":"AMPLITUD DE EXTENSIÓN PASIVA DE LA CADERA AUMENTADA"
  },
  {
    "codigo":397562003,
    "descripcion":"MUCORMICOSIS ORBITARIA"
  },
  {
    "codigo":364794009,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA IMPULSAR EL BOLO ALIMENTICIO HACIA LA FARINGE"
  },
  {
    "codigo":283315008,
    "descripcion":"ASTILLA DE MADERA EN DEDO DEL PIE"
  },
  {
    "codigo":1149391004,
    "descripcion":"DEMUESTRA CONOCIMIENTO SOBRE CONDUCTA SEXUAL"
  },
  {
    "codigo":788943004,
    "descripcion":"FRACTURA DE EPÍFISIS PROXIMAL DE FÉMUR"
  },
  {
    "codigo":231887005,
    "descripcion":"ECTASIA TOTAL DE LA ESCLERÓTICA"
  },
  {
    "codigo":428495004,
    "descripcion":"USO INAPROPIADO DE SOLVENTE"
  },
  {
    "codigo":723407009,
    "descripcion":"DISTROFIA MUSCULAR TIPO SELCEN"
  },
  {
    "codigo":262820001,
    "descripcion":"CONTUSIÓN DE BAZO"
  },
  {
    "codigo":197284004,
    "descripcion":"HEPATITIS ACTIVA CRÓNICA"
  },
  {
    "codigo":721572008,
    "descripcion":"SEPSIS CAUSADA POR PSEUDOMONAS AERUGINOSA"
  },
  {
    "codigo":293753003,
    "descripcion":"ALERGIA A MUSTINA"
  },
  {
    "codigo":719737005,
    "descripcion":"CAPAZ DE SUBIR Y BAJAR ESCALERAS INTERNAS"
  },
  {
    "codigo":1342329006,
    "descripcion":"EDEMA DE CEREBELO"
  },
  {
    "codigo":31609009,
    "descripcion":"FÓRMULA PARA LACTANTES, PARA TRATAMIENTO DE DISFUNCIÓN METABÓLICA"
  },
  {
    "codigo":29774004,
    "descripcion":"MIELOPATÍA VASCULAR"
  },
  {
    "codigo":128078004,
    "descripcion":"POLIRRADICULONEUROPATÍA"
  },
  {
    "codigo":160846006,
    "descripcion":"PRIMERA RELACIÓN"
  },
  {
    "codigo":422990005,
    "descripcion":"MENISCO LAGRIMAL BAJO"
  },
  {
    "codigo":717902008,
    "descripcion":"HIPOPARATIROIDISMO NEONATAL TRANSITORIO DEBIDO A HIPERPARATIROIDISMO MATERNO"
  },
  {
    "codigo":93475002,
    "descripcion":"HEMORRAGIA EPIDIDIMARIA"
  },
  {
    "codigo":1240355002,
    "descripcion":"METÁSTASIS DE CARCINOMA ESCAMOSO EN EPIDÍDIMO Y CORDÓN ESPERMÁTICO"
  },
  {
    "codigo":58872001,
    "descripcion":"ERITEMA ELEVADO PERSISTENTE"
  },
  {
    "codigo":157176002,
    "descripcion":"FRACTURA DE HUESO DE LA CARA"
  },
  {
    "codigo":124408003,
    "descripcion":"DEFICIENCIA DE CARBOXILESTERASA"
  },
  {
    "codigo":288248009,
    "descripcion":"ENCORVAMIENTO CONGÉNITO DE TIBIA, PERONÉ Y FÉMUR"
  },
  {
    "codigo":89805002,
    "descripcion":"ENFERMEDAD POR EL VIRUS CATU"
  },
  {
    "codigo":24269006,
    "descripcion":"SÍNDROME DE ARTROGRIFOSIS DISTAL"
  },
  {
    "codigo":286413006,
    "descripcion":"INCAPAZ DE HABLAR A VELOCIDAD NORMAL"
  },
  {
    "codigo":1269453007,
    "descripcion":"CAPAZ DE ADMINISTRAR INYECCIÓN SUBCUTÁNEA"
  },
  {
    "codigo":253645007,
    "descripcion":"DILATACIÓN DE AORTA ASCENDENTE"
  },
  {
    "codigo":415650003,
    "descripcion":"HEMORRAGIA SUBEPITELIAL DEL APARATO DIGESTIVO"
  },
  {
    "codigo":87970004,
    "descripcion":"SUMERSIÓN NO FATAL"
  },
  {
    "codigo":251810006,
    "descripcion":"GENITALES EN ESTADIO 5 DE TANNER"
  },
  {
    "codigo":448418006,
    "descripcion":"SEPSIS CAUSADA POR STREPTOCOCCUS"
  },
  {
    "codigo":22434008,
    "descripcion":"DERMATITIS AGUDA POR RADIACIÓN"
  },
  {
    "codigo":249975002,
    "descripcion":"REACCIÓN DE APOYO POSITIVA"
  },
  {
    "codigo":315511005,
    "descripcion":"NACIDO EN RUANDA"
  },
  {
    "codigo":86135006,
    "descripcion":"TRIQUIASIS CICATRIZAL"
  },
  {
    "codigo":1231180000,
    "descripcion":"ANGIOENDOTELIOMA PAPILAR INTRALINFÁTICO"
  },
  {
    "codigo":1263948001,
    "descripcion":"UREMIA POSTERIOR A EMBARAZO ECTÓPICO"
  },
  {
    "codigo":282743009,
    "descripcion":"DOLOR ÓSEO MALIGNO"
  },
  {
    "codigo":444748003,
    "descripcion":"OSIFICACIÓN HETEROTÓPICA POSQUIRÚRGICA"
  },
  {
    "codigo":870732005,
    "descripcion":"SISTEMA HEMATOPOYÉTICO NORMAL"
  },
  {
    "codigo":279073002,
    "descripcion":"NARINA DOLOROSA"
  },
  {
    "codigo":11849741000119107,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE FRENTE"
  },
  {
    "codigo":770593004,
    "descripcion":"CELIAQUÍA REFRACTARIA"
  },
  {
    "codigo":277238004,
    "descripcion":"DOLOR A LA PALPACIÓN SOBRE EL SENO MAXILAR"
  },
  {
    "codigo":703222005,
    "descripcion":"INSUFICIENCIA DE VÁLVULA AÓRTICA POSTERIOR A PROCEDIMIENTO"
  },
  {
    "codigo":275403002,
    "descripcion":"ATROFIA VELLOSA"
  },
  {
    "codigo":1356747009,
    "descripcion":"CONJUNTIVITIS AGUDA DE OJO IZQUIERDO"
  },
  {
    "codigo":240800002,
    "descripcion":"CLONORQUIASIS AGUDA"
  },
  {
    "codigo":404640003,
    "descripcion":"MAREO"
  },
  {
    "codigo":371872009,
    "descripcion":"DILATACIÓN POSESTENÓTICA"
  },
  {
    "codigo":1254773001,
    "descripcion":"RUPTURA TRAUMÁTICA DE LIGAMENTO COLATERAL DE ARTICULACIÓN DE PULGAR"
  },
  {
    "codigo":402805001,
    "descripcion":"HIPERMELANOSIS CIRCUNSCRIPTA"
  },
  {
    "codigo":1156469001,
    "descripcion":"MEDULOBLASTOMA DE CÉLULAS GRANDES DE CEREBRO"
  },
  {
    "codigo":109728009,
    "descripcion":"RESTAURACIÓN DENTAL DEFECTUOSA"
  },
  {
    "codigo":238965007,
    "descripcion":"VENEREOFOBIA"
  },
  {
    "codigo":354471000119108,
    "descripcion":"CARCINOMA LOBAR IN SITU DE MAMA DERECHA"
  },
  {
    "codigo":42357009,
    "descripcion":"TRASTORNO DEL APARATO DIGESTIVO ESPECÍFICO DEL FETO O RECIÉN NACIDO"
  },
  {
    "codigo":16001191000119109,
    "descripcion":"BUFTALMOS DE OJO IZQUIERDO"
  },
  {
    "codigo":1285706005,
    "descripcion":"SARCOMA DE EWING PRIMARIO DE OMÓPLATO"
  },
  {
    "codigo":237130006,
    "descripcion":"SANGRADO INTERMENSTRUAL"
  },
  {
    "codigo":204362007,
    "descripcion":"MALFORMACIÓN EN PARACAÍDAS DE VÁLVULA MITRAL"
  },
  {
    "codigo":5919001,
    "descripcion":"RUPTURA DEL MÚSCULO PAPILAR"
  },
  {
    "codigo":366367006,
    "descripcion":"EGRESO DE LÍQUIDOS - HALLAZGO"
  },
  {
    "codigo":298996000,
    "descripcion":"SIN AMPLITUD ACTIVA DE SUPINACIÓN DE LA MUÑECA"
  },
  {
    "codigo":724980007,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO EXTENSOR A LA ALTURA DEL ANTEBRAZO"
  },
  {
    "codigo":723145000,
    "descripcion":"TRAUMATISMO QUE PRODUCE LUXACIÓN PARCIAL DE ARTICULACIÓN ATLANTOAXOIDEA"
  },
  {
    "codigo":428233007,
    "descripcion":"LACERACIÓN DE NERVIO DIGITAL EN DEDO DE LA MANO"
  },
  {
    "codigo":65950001,
    "descripcion":"PELO EN BAYONETA"
  },
  {
    "codigo":721310007,
    "descripcion":"LEUCEMIA AGRESIVA DE CÉLULAS ASESINAS NATURALES"
  },
  {
    "codigo":459166009,
    "descripcion":"EMBARAZO GEMELAR BICORIÓNICO, BIAMNIÓTICO"
  },
  {
    "codigo":293491002,
    "descripcion":"REACCIÓN ADVERSA A LA XIPAMIDA"
  },
  {
    "codigo":719475006,
    "descripcion":"SÍNDROME DE PROLIFERACIÓN LIPOMATOSA CONGÉNITA, MALFORMACIÓN VASCULAR, NEVOS EPIDÉRMICOS Y ANOMALÍAS ESQUELÉTICAS"
  },
  {
    "codigo":129651007,
    "descripcion":"HIPERBETAGLOBULINEMIA"
  },
  {
    "codigo":1145459008,
    "descripcion":"APLASIA DE PERONÉ"
  },
  {
    "codigo":783176002,
    "descripcion":"DISTROFIA MUSCULAR CONGÉNITA CON COMPROMISO DEL CEREBELO"
  },
  {
    "codigo":422728003,
    "descripcion":"INDUCCIÓN DE ENZIMA DE CITOCROMO P450 POR SUSTANCIA"
  },
  {
    "codigo":95048004,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE PIEL DE TOBILLO"
  },
  {
    "codigo":29512005,
    "descripcion":"ALACTASIA EN ENFERMEDADES QUE NO AFECTAN AL INTESTINO DELGADO"
  },
  {
    "codigo":226120004,
    "descripcion":"DIETA RICA EN HIDRATOS DE CARBONO"
  },
  {
    "codigo":160584005,
    "descripcion":"EX - BEBEDOR MODERADO - 3 A 6 UNIDADES POR DÍA"
  },
  {
    "codigo":11770331000119106,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE CABEZA RADIAL DERECHA"
  },
  {
    "codigo":10760821000119100,
    "descripcion":"QUINTILLIZOS, ALGUNOS NACIDOS VIVOS"
  },
  {
    "codigo":93213004,
    "descripcion":"MELANOMA MALIGNO DE LA PIEL DE LA AXILA"
  },
  {
    "codigo":289821005,
    "descripcion":"EXCITACIÓN CERVICAL DUDOSA"
  },
  {
    "codigo":1141789006,
    "descripcion":"PELIOSIS BASILAR CAUSADA POR BARTONELLA HENSELAE"
  },
  {
    "codigo":27677008,
    "descripcion":"INTOXICACIÓN POR ARGEMONE"
  },
  {
    "codigo":58610003,
    "descripcion":"ATROFIA ÓPTICA DE LEBER"
  },
  {
    "codigo":124146003,
    "descripcion":"DEFICIENCIA DE (S) - 2 - HIDROXI - ÁCIDO OXIDASA"
  },
  {
    "codigo":287986009,
    "descripcion":"ASFIXIA NEONATAL LEVE, PUNTAJE DE APGAR 4-7"
  },
  {
    "codigo":286151001,
    "descripcion":"NO LIMPIA EL BAÑO"
  },
  {
    "codigo":253383003,
    "descripcion":"PROLAPSO DE VÁLVULA TRICÚSPIDE"
  },
  {
    "codigo":1300124001,
    "descripcion":"ENFERMEDAD INFLAMATORIA INTESTINAL ASOCIADA A GEN TRIM22"
  },
  {
    "codigo":284316002,
    "descripcion":"DIFICULTAD PARA MANIPULAR OBJETOS"
  },
  {
    "codigo":282481000,
    "descripcion":"CAPAZ DE CORRER EN TERRENO PLANO"
  },
  {
    "codigo":1003377002,
    "descripcion":"DUPLICACIÓN DE PORCIÓN MEDIA DE BRAZO CORTO DE CROMOSOMA 1"
  },
  {
    "codigo":315249005,
    "descripcion":"NODULARIDAD MAMARIA PERSISTENTE"
  },
  {
    "codigo":249713005,
    "descripcion":"LORDOSIS REVERTIDA"
  },
  {
    "codigo":1263686007,
    "descripcion":"TRASTORNO FETAL DEBIDO A HEMORRAGIA MATERNA DURANTE EMBARAZO"
  },
  {
    "codigo":82203000,
    "descripcion":"SÍNDROME DE TREACHER COLLINS"
  },
  {
    "codigo":49435000,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE LA NALGA, CON INFECCIÓN"
  },
  {
    "codigo":16667002,
    "descripcion":"TRASTORNO DE LA TASA DE RECAMBIO ÓSEO"
  },
  {
    "codigo":84038009,
    "descripcion":"ÚLCERA GÁSTRICA PERFORADA SIN OBSTRUCCIÓN"
  },
  {
    "codigo":247878007,
    "descripcion":"PENSAMIENTOS OBSESIVOS ACERCA DE TRANSMITIR UNA ENFERMEDAD A OTROS"
  },
  {
    "codigo":702960001,
    "descripcion":"DESVIACIÓN DE LA MANDÍBULA HACIA LA IZQUIERDA DURANTE LA APERTURA"
  },
  {
    "codigo":309744003,
    "descripcion":"DESGARRO ANTIGUO DE CUERNO POSTERIOR DE MENISCO INTERNO"
  },
  {
    "codigo":10953641000119100,
    "descripcion":"HERIDA ABIERTA DE PULGAR DERECHO DEBIDA A MORDEDURA DE GATO"
  },
  {
    "codigo":735728009,
    "descripcion":"DIVERTÍCULO DE INTESTINO GRUESO"
  },
  {
    "codigo":2831000119107,
    "descripcion":"ANEURISMA DE AORTA TORÁCICA DESCENDENTE"
  },
  {
    "codigo":111301006,
    "descripcion":"PERICARDITIS DEBIDA A FIEBRE MEDITERRÁNEA FAMILIAR"
  },
  {
    "codigo":16059151000119108,
    "descripcion":"ESCOTOMA DE OJO IZQUIERDO"
  },
  {
    "codigo":699290002,
    "descripcion":"MUCOSITIS LIQUENOIDE YUGAL"
  },
  {
    "codigo":371610007,
    "descripcion":"HEMATOMA DE HERIDA PERINEAL"
  },
  {
    "codigo":109466008,
    "descripcion":"ERUPCIÓN DENTAL PASIVA ALTERADA"
  },
  {
    "codigo":369775001,
    "descripcion":"PUNTAJE DE GLEASON 2-4: BIEN DIFERENCIADO"
  },
  {
    "codigo":240538008,
    "descripcion":"VERRUGA DE BUTCHER"
  },
  {
    "codigo":1156207004,
    "descripcion":"DIENTE SUPERNUMERARIO PARAMOLAR"
  },
  {
    "codigo":238703005,
    "descripcion":"HIPERMELANOSIS PERIORBITAL"
  },
  {
    "codigo":9327005,
    "descripcion":"FRACTURAS MÚLTIPLES DE LA EXTREMIDAD INFERIOR Y DE LAS COSTILLAS"
  },
  {
    "codigo":402543007,
    "descripcion":"CARCINOMA BASOCELULAR RECIDIVANTE LUEGO DE RADIOTERAPIA"
  },
  {
    "codigo":433476000,
    "descripcion":"FALTA DE PROGRESO EN EL LACTANTE"
  },
  {
    "codigo":73028002,
    "descripcion":"ENDOCARDITIS ESTAFILOCÓCICA"
  },
  {
    "codigo":366105005,
    "descripcion":"NIVEL DE SONIDO - HALLAZGO"
  },
  {
    "codigo":401541000221102,
    "descripcion":"ALERGIA IDIOPÁTICA"
  },
  {
    "codigo":71193007,
    "descripcion":"FIBROSIS DE PULMÓN CAUSADA POR RADIACIÓN"
  },
  {
    "codigo":202265005,
    "descripcion":"CONTRACTURA DE HOMBRO EN FLEXIÓN"
  },
  {
    "codigo":300569009,
    "descripcion":"TUMORACIÓN PERINEAL"
  },
  {
    "codigo":200430001,
    "descripcion":"AMAMANTAMIENTO DOLOROSO"
  },
  {
    "codigo":724718002,
    "descripcion":"TRASTORNO PSICÓTICO CAUSADO POR DROGA DISOCIATIVA"
  },
  {
    "codigo":235033006,
    "descripcion":"QUERATOSIS DEL FUMADOR"
  },
  {
    "codigo":890393009,
    "descripcion":"PROLAPSO CONGÉNITO DE VÁLVULA MITRAL"
  },
  {
    "codigo":298734006,
    "descripcion":"COSTILLA LARGA"
  },
  {
    "codigo":823022009,
    "descripcion":"QUEMADURA QUÍMICA DE PIEL"
  },
  {
    "codigo":426136000,
    "descripcion":"FUNCIONAMIENTO TARDÍO DE INJERTO RENAL"
  },
  {
    "codigo":722883009,
    "descripcion":"TRASTORNO FUNCIONAL DE LA PORCIÓN PANCREÁTICA DEL ESFÍNTER DE ODDI"
  },
  {
    "codigo":1148867008,
    "descripcion":"GLOMERULOPATÍA DEBIDA A CITOPATÍA MITOCONDRIAL"
  },
  {
    "codigo":196760001,
    "descripcion":"CONSTRICCIÓN ADQUIRIDA DEL PÍLORO"
  },
  {
    "codigo":1179800005,
    "descripcion":"INFLAMACIÓN SUPURATIVA DE PERINEO"
  },
  {
    "codigo":31085000,
    "descripcion":"INSUFICIENCIA MITRAL REUMÁTICA"
  },
  {
    "codigo":293229005,
    "descripcion":"REACCIÓN ADVERSA A LA FLUTAMIDA"
  },
  {
    "codigo":782914000,
    "descripcion":"SÍNDROME DE BRAQUIDACTILIA, BAJA ESTATURA Y RETINITIS PIGMENTOSA"
  },
  {
    "codigo":719213009,
    "descripcion":"BAJA ESTATURA TIPO BRUSELAS"
  },
  {
    "codigo":94786005,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL CEREBELO"
  },
  {
    "codigo":225858006,
    "descripcion":"HALLAZGO RELACIONADO CON LA SEGURIDAD"
  },
  {
    "codigo":1208898008,
    "descripcion":"FENÓMENO DE RAYNAUD OCUPACIONAL"
  },
  {
    "codigo":191255003,
    "descripcion":"APLASIA ERITROCÍTICA PURA, ADQUIRIDA, TRANSITORIA"
  },
  {
    "codigo":92951004,
    "descripcion":"FORMA ANORMAL CONGÉNITA DEL TARSO"
  },
  {
    "codigo":289559006,
    "descripcion":"SECRECIÓN VAGINAL MODERADA"
  },
  {
    "codigo":254956000,
    "descripcion":"ADENOMA DE HIPÓFISIS"
  },
  {
    "codigo":123884003,
    "descripcion":"INTOXICACIÓN POR APIACEAE"
  },
  {
    "codigo":449729000,
    "descripcion":"RINITIS ALÉRGICA CAUSADA POR ÁCARO DEL POLVO"
  },
  {
    "codigo":285889002,
    "descripcion":"NO UTILIZA LA PAVA"
  },
  {
    "codigo":283784003,
    "descripcion":"HERIDA POR MORDEDURA DE CABALLO"
  },
  {
    "codigo":306551000119102,
    "descripcion":"GOTA TOFÁCEA CRÓNICA DE VÉRTEBRA CAUSADA POR FÁRMACO"
  },
  {
    "codigo":415126001,
    "descripcion":"NEUMONITIS CAUSADA POR SUSTANCIA INHALADA"
  },
  {
    "codigo":185750000,
    "descripcion":"CONSULTA DE CONTROL DE LA OBESIDAD - REALIZADA"
  },
  {
    "codigo":447894003,
    "descripcion":"SEPSIS CAUSADA POR STAPHYLOCOCCUS"
  },
  {
    "codigo":216683000,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR SÓLIDO DE PETRÓLEO"
  },
  {
    "codigo":20075001,
    "descripcion":"ARTROPATÍA DE SITIOS MÚLTIPLES POR CRISTALES"
  },
  {
    "codigo":16035191000119104,
    "descripcion":"OSTEÓLISIS BILATERAL DE PIES"
  },
  {
    "codigo":282219005,
    "descripcion":"NO EMPIEZA A CAMINAR NI DETIENE LA MARCHA ESPONTÁNEAMENTE"
  },
  {
    "codigo":249451006,
    "descripcion":"HALLAZGO RELACIONADO CON LA FUNCIÓN DE LAS CUERDAS VOCALES"
  },
  {
    "codigo":247616000,
    "descripcion":"NO PUEDE RECORDAR EL NOMBRE DE LA ESCUELA"
  },
  {
    "codigo":29911000175107,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN EN TALÓN IZQUIERDO ESTADIO I"
  },
  {
    "codigo":313152005,
    "descripcion":"ATENDIDO EN CONSULTORIO ESPECIALIZADO EN AUDÍFONOS"
  },
  {
    "codigo":16690551000119106,
    "descripcion":"DOLOR PROFUNDO EN LA MUJER DURANTE LA RELACIÓN SEXUAL"
  },
  {
    "codigo":1359893004,
    "descripcion":"TRASTORNO FETAL CAUSADO POR RADIACIÓN IONIZANTE"
  },
  {
    "codigo":1163285004,
    "descripcion":"OBJETIVO ALIMENTARIO Y\/O NUTRICIONAL NO ALCANZABLE"
  },
  {
    "codigo":278549007,
    "descripcion":"FILTRACIÓN EN RESTAURACIÓN DENTAL"
  },
  {
    "codigo":1259754003,
    "descripcion":"CÁNCER DE PULMÓN NO MICROCÍTICO ESCAMOSO PRIMARIO"
  },
  {
    "codigo":276714005,
    "descripcion":"DEGLUCIÓN INCOORDINADA EN EL RECIÉN NACIDO"
  },
  {
    "codigo":16909841000119103,
    "descripcion":"LAGOFTALMÍA PARALÍTICA DE PÁRPADOS SUPERIOR E INFERIOR IZQUIERDOS"
  },
  {
    "codigo":735466008,
    "descripcion":"NEUMONITIS DEBIDA A ASPIRACIÓN DE SANGRE"
  },
  {
    "codigo":45503006,
    "descripcion":"VENTRÍCULO ÚNICO"
  },
  {
    "codigo":209343007,
    "descripcion":"FRACTURA-SUBLUXACIÓN EXPUESTA DE ARTICULACIÓN DE LA RODILLA"
  },
  {
    "codigo":405951008,
    "descripcion":"ABSCESO DE CAVIDAD PLEURAL"
  },
  {
    "codigo":240276001,
    "descripcion":"TRASTORNO DEL MUÑÓN DE AMPUTACIÓN"
  },
  {
    "codigo":11830801000119105,
    "descripcion":"LESIÓN TRAUMÁTICA DE ARTERIA PEDIA DERECHA"
  },
  {
    "codigo":305812003,
    "descripcion":"VISTO POR EL SERVICIO DE GASTROENTEROLOGÍA"
  },
  {
    "codigo":1256084004,
    "descripcion":"PENFIGOIDE PRETIBIAL"
  },
  {
    "codigo":307647008,
    "descripcion":"LINFOMA MALIGNO, TIPO CENTROBLÁSTICO, FOLICULAR"
  },
  {
    "codigo":699028006,
    "descripcion":"TUMOR NEUROECTODÉRMICO PRIMITIVO"
  },
  {
    "codigo":895636007,
    "descripcion":"FORMA TRIANGULAR ANORMAL CONGÉNITA DE FALANGE DE CUARTO DEDO DE PIE"
  },
  {
    "codigo":205673000,
    "descripcion":"REORDENAMIENTO AUTOSÓMICO EQUILIBRADO EN EL INDIVIDUO ANORMAL"
  },
  {
    "codigo":404116007,
    "descripcion":"MICOSIS FUNGOIDE CON INFILTRACIÓN SISTÉMICA"
  },
  {
    "codigo":402281003,
    "descripcion":"DERMATITIS IRRITATIVA POR CONTACTO DEBIDA A UROSTOMÍA"
  },
  {
    "codigo":369513003,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA TROMPA DE FALOPIO IZQUIERDA"
  },
  {
    "codigo":236606001,
    "descripcion":"HEMORRAGIA DE URÉTER"
  },
  {
    "codigo":70931000,
    "descripcion":"RESORCIÓN PATOLÓGICA DE DIENTE"
  },
  {
    "codigo":39998009,
    "descripcion":"SECRECIÓN EXCESIVA DE PÉPTIDO INTESTINAL VASOACTIVO"
  },
  {
    "codigo":1186878008,
    "descripcion":"SÍNDROME DE SECRECIÓN ECTÓPICA INADECUADA DE HORMONA ANTIDIURÉTICA"
  },
  {
    "codigo":1119507003,
    "descripcion":"AGOTAMIENTO MUSCULAR FATIGABLE"
  },
  {
    "codigo":38163003,
    "descripcion":"HERNIA FEMORAL BILATERAL CON GANGRENA"
  },
  {
    "codigo":46611000087101,
    "descripcion":"FRACTURA DE EXTREMO PROXIMAL DE TIBIA IZQUIERDA"
  },
  {
    "codigo":202003006,
    "descripcion":"ARTROPATÍA TRANSITORIA DE LA MUÑECA"
  },
  {
    "codigo":41491000087103,
    "descripcion":"HEMATOMA DE REGIÓN PERIORBITARIA DE OJO IZQUIERDO"
  },
  {
    "codigo":298472000,
    "descripcion":"HALLAZGO RELACIONADO CON LA ESTABILIDAD DEL CUELLO"
  },
  {
    "codigo":300307005,
    "descripcion":"HALLAZGO RELACIONADO CON EL APÉNDICE ILEOCECAL"
  },
  {
    "codigo":724456002,
    "descripcion":"ENDOMETRIOSIS DE CÁPSULA DE OVARIO"
  },
  {
    "codigo":38931000087101,
    "descripcion":"ABRASIÓN DE PIEL DE REGIÓN PERIORBITARIA DE OJO DERECHO"
  },
  {
    "codigo":44051000087104,
    "descripcion":"CORTE EN PIEL DE OREJA DERECHA"
  },
  {
    "codigo":3560000,
    "descripcion":"HERNIA INGUINAL BILATERAL RECURRENTE"
  },
  {
    "codigo":1148605000,
    "descripcion":"RELACIÓN ANORMAL DE ONDAS N95\/P50 EN ELECTRORRETINOGRAMA DE PATRÓN"
  },
  {
    "codigo":394941003,
    "descripcion":"ESTADIO C1 DE DUKES"
  },
  {
    "codigo":198333004,
    "descripcion":"ÚLCERA DE ÚTERO"
  },
  {
    "codigo":1279677005,
    "descripcion":"LUXACIÓN DE ARTICULACIÓN DE DEDO MEDIO DE MANO"
  },
  {
    "codigo":11804331000119109,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA DISTAL DE DEDO DE MANO IZQUIERDA"
  },
  {
    "codigo":12105541000119103,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO DE REGIÓN PALMAR DE MANO IZQUIERDA"
  },
  {
    "codigo":130962007,
    "descripcion":"FORMA ANORMAL DEL PEZÓN MAMARIO"
  },
  {
    "codigo":129127001,
    "descripcion":"INFECCIÓN ÓTICA"
  },
  {
    "codigo":1144935002,
    "descripcion":"INGESTA INADECUADA DE VITAMINA B12 Y\/O DERIVADO DE VITAMINA B12"
  },
  {
    "codigo":11859781000119104,
    "descripcion":"ESGUINCE DE LIGAMENTO LATERAL EXTERNO DE RODILLA DERECHA"
  },
  {
    "codigo":292967008,
    "descripcion":"REACCIÓN ADVERSA A LA AMOXICILINA"
  },
  {
    "codigo":225596003,
    "descripcion":"ASPIRADO GÁSTRICO PRESENTE"
  },
  {
    "codigo":127292004,
    "descripcion":"ESGUINCE DE LIGAMENTO CRUZADO ANTERIOR DE RODILLA"
  },
  {
    "codigo":780817000,
    "descripcion":"ENFERMEDAD MIELOPROLIFERATIVA INDIFERENCIADA"
  },
  {
    "codigo":420369001,
    "descripcion":"ÚLCERAS TIPO CRÁTER"
  },
  {
    "codigo":291132009,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR CLOZAPINA"
  },
  {
    "codigo":94524008,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL LÓBULO SUPERIOR DERECHO DEL PULMÓN"
  },
  {
    "codigo":16666591000119101,
    "descripcion":"FRACTURA EXPUESTA DE CUERPO DE MITAD DERECHA DE LA MANDÍBULA"
  },
  {
    "codigo":289297007,
    "descripcion":"ONDA LÍQUIDA DE LÍQUIDO AMNIÓTICO, AUSENTE"
  },
  {
    "codigo":92689007,
    "descripcion":"CARCINOMA IN SITU DE LA PARED POSTERIOR DE LA OROFARINGE"
  },
  {
    "codigo":254694002,
    "descripcion":"TUMOR DE INFUNDÍBULO FOLICULAR"
  },
  {
    "codigo":123622004,
    "descripcion":"FLEXIÓN NORMAL"
  },
  {
    "codigo":713446007,
    "descripcion":"INFECCIÓN CRÓNICA CAUSADA POR VIRUS HERPES SIMPLE CONCOMITANTE CON INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":1268667002,
    "descripcion":"RECIÉN NACIDO A TÉRMINO 37 SEMANAS"
  },
  {
    "codigo":89019003,
    "descripcion":"PIEL ROMBOIDAL DE LA NUCA"
  },
  {
    "codigo":449467003,
    "descripcion":"ESTENOSIS DIFUSA DE ARTERIA PULMONAR DERECHA"
  },
  {
    "codigo":1332368002,
    "descripcion":"TRASTORNO DE NERVIO OBTURADOR"
  },
  {
    "codigo":21648003,
    "descripcion":"MASTITIS CRÓNICA"
  },
  {
    "codigo":11833311000119106,
    "descripcion":"ESGUINCE DE PIE IZQUIERDO"
  },
  {
    "codigo":338041000119100,
    "descripcion":"TELANGIECTASIA DE RETINA IZQUIERDA"
  },
  {
    "codigo":283792007,
    "descripcion":"MORDEDURA DE ANIMAL EN LA CARA"
  },
  {
    "codigo":16640121000119100,
    "descripcion":"COMPRESIÓN DE AMBOS NERVIOS MUSCULOCUTÁNEOS"
  },
  {
    "codigo":251024009,
    "descripcion":"ESTENOSIS DE INJERTO CORONARIO"
  },
  {
    "codigo":871781003,
    "descripcion":"EDEMA DE MÁCULA SIN COMPROMISO CENTRAL DEBIDO A DIABETES MELLITUS"
  },
  {
    "codigo":249189006,
    "descripcion":"EXCESO DE GELATINA DE WHARTON"
  },
  {
    "codigo":183653007,
    "descripcion":"SEGUIMIENTO DE TRATAMIENTO DE FRACTURA"
  },
  {
    "codigo":1230394004,
    "descripcion":"INFECCIÓN CAUSADA POR PROTEUS MIRABILIS BLEE"
  },
  {
    "codigo":280122007,
    "descripcion":"EMPEORAMIENTO AUDITIVO"
  },
  {
    "codigo":278287000,
    "descripcion":"HEMIPARESIA IZQUIERDA"
  },
  {
    "codigo":247354009,
    "descripcion":"DOLOR EN FOSA ILÍACA"
  },
  {
    "codigo":129715009,
    "descripcion":"HALLAZGO EN LA COMPOSICIÓN MAMARIA DURANTE EL ESTUDIO MAMOGRÁFICO"
  },
  {
    "codigo":1259492003,
    "descripcion":"DEMENCIA DEBIDA A NEOPLASIA METASTÁSICA MALIGNA CEREBRAL"
  },
  {
    "codigo":473060006,
    "descripcion":"INFECCIÓN ASOCIADA CON IMPLANTE CARDÍACO"
  },
  {
    "codigo":1357796007,
    "descripcion":"LESIÓN TRAUMÁTICA PERFORANTE DE GLOBO OCULAR DERECHO"
  },
  {
    "codigo":438457000,
    "descripcion":"TUMEFACCIÓN TESTICULAR"
  },
  {
    "codigo":735204006,
    "descripcion":"NACIDO EN SERBIA"
  },
  {
    "codigo":702436009,
    "descripcion":"HIPOSPADIAS DE PENE PROXIMAL"
  },
  {
    "codigo":733369004,
    "descripcion":"MÚLTIPLES LESIONES TRAUMÁTICAS SUPERFICIALES DE REGIÓN PÉLVICA"
  },
  {
    "codigo":240014001,
    "descripcion":"RUPTURA DE TENDONES DE LA PIERNA Y EL TOBILLO"
  },
  {
    "codigo":403854002,
    "descripcion":"DESCAMACIÓN FISIOLÓGICA DEL RECIÉN NACIDO"
  },
  {
    "codigo":43406003,
    "descripcion":"ÚLCERA PÉPTICA AGUDA CON HEMORRAGIA Y OBSTRUCCIÓN"
  },
  {
    "codigo":305550002,
    "descripcion":"BAJO ATENCIÓN DE CIRUJANO ESPECIALISTA EN TRASPLANTES"
  },
  {
    "codigo":76174009,
    "descripcion":"FRACTURA NO EXPUESTA DE CRESTA ALVEOLAR DEL CUERPO DE LA MANDÍBULA"
  },
  {
    "codigo":926307003,
    "descripcion":"NEUROESTIMULADOR DE MÉDULA ESPINAL IN SITU"
  },
  {
    "codigo":74339003,
    "descripcion":"AGREGACIÓN DE LAS PROTEÍNAS DEL CRISTALINO"
  },
  {
    "codigo":762467004,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO PROFUNDA DE CABEZA"
  },
  {
    "codigo":203576001,
    "descripcion":"TALÓN EN VALGO ADQUIRIDO"
  },
  {
    "codigo":1186616001,
    "descripcion":"SARCOMA DE KAPOSI PRIMARIO DE PIEL"
  },
  {
    "codigo":400184006,
    "descripcion":"AMPOLLA TRAUMÁTICA DE TRONCO"
  },
  {
    "codigo":2411000124102,
    "descripcion":"TERCER MOLAR INFERIOR DERECHO PERMANENTE SUPERNUMERARIO"
  },
  {
    "codigo":234509000,
    "descripcion":"TORSIÓN DEL BAZO"
  },
  {
    "codigo":365581002,
    "descripcion":"HALLAZGO DEL ESTADO CIVIL O DE PAREJA"
  },
  {
    "codigo":726029005,
    "descripcion":"SÍNDROME DE MCCUNE-ALBRIGHT"
  },
  {
    "codigo":3298001,
    "descripcion":"TRASTORNO AMNÉSICO"
  },
  {
    "codigo":298210002,
    "descripcion":"LAXITUD DE ARTICULACIÓN DE MANO"
  },
  {
    "codigo":363746003,
    "descripcion":"FARINGITIS AGUDA"
  },
  {
    "codigo":396514004,
    "descripcion":"HALLAZGO RELACIONADO CON EL MARGEN QUIRÚRGICO LATERAL"
  },
  {
    "codigo":68834009,
    "descripcion":"ÚLCERA DUODENAL GIGANTE"
  },
  {
    "codigo":198071002,
    "descripcion":"SOPLO RESPIRATORIO"
  },
  {
    "codigo":15931821000119104,
    "descripcion":"TORSIÓN CONGÉNITA DE OVARIO IZQUIERDO"
  },
  {
    "codigo":34231006,
    "descripcion":"SEUDODIARREA"
  },
  {
    "codigo":394679006,
    "descripcion":"ESPASTICIDAD DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":66999008,
    "descripcion":"HIPERPARATIROIDISMO"
  },
  {
    "codigo":1344951007,
    "descripcion":"ANSIEDAD EN EL EMBARAZO"
  },
  {
    "codigo":65164000,
    "descripcion":"PLACA DENTAL SUPRAGINGIVAL"
  },
  {
    "codigo":1144673000,
    "descripcion":"APLASIA DE UNIDAD UNGUEAL DE DEDO DE PIE"
  },
  {
    "codigo":816993001,
    "descripcion":"FISURA EN PIEL DE AMBOS PIES"
  },
  {
    "codigo":63329001,
    "descripcion":"DEFICIENCIA DE GLICINA DESHIDROGENASA (DESCARBOXILANTE)"
  },
  {
    "codigo":128865003,
    "descripcion":"PSEUDOLINFOMA CUTÁNEO DE LINFOCITOS B"
  },
  {
    "codigo":718689000,
    "descripcion":"TRISOMÍA 10Q DISTAL"
  },
  {
    "codigo":292705009,
    "descripcion":"REACCIÓN ADVERSA A SURFACTANTE NO IÓNICO"
  },
  {
    "codigo":127030001,
    "descripcion":"NEOPLASIA DEL GLOMO YUGULAR"
  },
  {
    "codigo":782390002,
    "descripcion":"RETENCIÓN INDOLORA DE ORINA DEBIDA A SÍNDROME DE LA COLA DE CABALLO"
  },
  {
    "codigo":290870002,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR ISOCARBOXAZIDA"
  },
  {
    "codigo":94262007,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL COLÉDOCO"
  },
  {
    "codigo":92427003,
    "descripcion":"NEOPLASIA BENIGNA DEL LÓBULO TEMPORAL"
  },
  {
    "codigo":10662471000119105,
    "descripcion":"ÚLCERA DE REGIÓN MEDIA DE PIE IZQUIERDO"
  },
  {
    "codigo":254432007,
    "descripcion":"CARCINOMA IN SITU DE REGIÓN LATERAL DE PISO DE BOCA"
  },
  {
    "codigo":285365001,
    "descripcion":"DOLOR EN DEDO DEL PIE"
  },
  {
    "codigo":1237472009,
    "descripcion":"METÁSTASIS DE CARCINOMA ESCAMOSO EN BRONQUIO DE LÓBULO MEDIO DE PULMÓN DERECHO"
  },
  {
    "codigo":55989009,
    "descripcion":"ESTENOSIS ADQUIRIDA DE CONDUCTO AUDITIVO EXTERNO"
  },
  {
    "codigo":185226003,
    "descripcion":"ATENDIDO EN UN CONSULTORIO DE ATENCIÓN PRENATAL"
  },
  {
    "codigo":283530003,
    "descripcion":"HERIDA PUNZANTE DE INGLE"
  },
  {
    "codigo":1332106007,
    "descripcion":"FÍSTULA CAROTIDEOCAVERNOSA TRAUMÁTICA"
  },
  {
    "codigo":15715041000119104,
    "descripcion":"OSTEOFITO DE MANO BILATERAL"
  },
  {
    "codigo":609375004,
    "descripcion":"ABSCESO DE PIERNA"
  },
  {
    "codigo":1363039005,
    "descripcion":"METABOLIZADOR INTERMEDIO DE FAMILIA 2 SUBFAMILIA C MIEMBRO 9 *8\/*8 DE CITOCROMO P450"
  },
  {
    "codigo":707679005,
    "descripcion":"HIPOPLASIA DE PRIMER MOLAR PERMANENTE"
  },
  {
    "codigo":445535007,
    "descripcion":"SÍNCOPE PRESENCIADO POR RELATOR DE LA HISTORIA DIFERENTE AL SUJETO"
  },
  {
    "codigo":247092000,
    "descripcion":"FIBROSIS DEL VÍTREO"
  },
  {
    "codigo":17716001,
    "descripcion":"ENDOMIOMETRITIS CRÓNICA"
  },
  {
    "codigo":116020001,
    "descripcion":"TRASTORNO DEL METABOLISMO DE AMINOÁCIDOS DE CADENA RAMIFICADA"
  },
  {
    "codigo":248927003,
    "descripcion":"ORIFICIO CERVICAL EXTERNO DE MULTÍPARA"
  },
  {
    "codigo":1197364005,
    "descripcion":"DISECCIÓN CORONARIA ESPONTÁNEA IDIOPÁTICA"
  },
  {
    "codigo":443700006,
    "descripcion":"TRASTORNO DE DISCO LUMBAR"
  },
  {
    "codigo":1162761001,
    "descripcion":"PSEUDOANEURISMA DEL SITIO DE ACCESO VASCULAR"
  },
  {
    "codigo":212489008,
    "descripcion":"LESIÓN DE MÚLTIPLES ÓRGANOS INTRABDOMINALES"
  },
  {
    "codigo":14046000,
    "descripcion":"DEGENERACIÓN RETINIANA MACULAR CISTOIDE"
  },
  {
    "codigo":46814005,
    "descripcion":"INFECCIÓN CAUSADA POR DISPHARYNX"
  },
  {
    "codigo":472798008,
    "descripcion":"ESTENOSIS SUBPULMONAR COMO COMPLICACIÓN DE PROCEDIMIENTO"
  },
  {
    "codigo":10847661000119100,
    "descripcion":"CUERPO EXTRAÑO EN OÍDO IZQUIERDO"
  },
  {
    "codigo":305581000119101,
    "descripcion":"CONTRACTURA DE ARTICULACIÓN DE MUÑECA DERECHA"
  },
  {
    "codigo":336301000119101,
    "descripcion":"BLEFAROCALASIA DE PÁRPADO DERECHO"
  },
  {
    "codigo":44979007,
    "descripcion":"MOLA CARNOSA"
  },
  {
    "codigo":290221000119103,
    "descripcion":"LESIÓN DE NERVIO CUBITAL DERECHO"
  },
  {
    "codigo":11718061000119105,
    "descripcion":"MASA DE PARTES BLANDAS DE MIEMBRO INFERIOR DERECHO"
  },
  {
    "codigo":479404461000119102,
    "descripcion":"ATRAPAMIENTO DE MÚSCULO EXTRAOCULAR DE OJO DERECHO"
  },
  {
    "codigo":11828141000119104,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO CUÁDRICEPS FEMORAL DERECHO"
  },
  {
    "codigo":341421000119108,
    "descripcion":"QUISTE CONJUNTIVAL DEL OJO IZQUIERDO"
  },
  {
    "codigo":218541000119109,
    "descripcion":"HEMORRAGIA GÁSTRICA DEBIDA A GASTRITIS EROSIVA IDIOPÁTICA"
  },
  {
    "codigo":43144004,
    "descripcion":"QUISTE DE MAXILAR"
  },
  {
    "codigo":39341000119109,
    "descripcion":"INFECCIÓN DE HERIDA QUIRÚRGICA DE CESÁREA"
  },
  {
    "codigo":41309000,
    "descripcion":"HEPATOPATÍA ALCOHÓLICA"
  },
  {
    "codigo":16264621000119109,
    "descripcion":"TRASTORNO DEPRESIVO MAYOR LEVE RECURRENTE CONCOMITANTE CON ANSIEDAD"
  },
  {
    "codigo":698504006,
    "descripcion":"INSUFICIENCIA CARDIOPULMONAR POSOPERATORIA"
  },
  {
    "codigo":16466861000119107,
    "descripcion":"MELORREOSTOSIS DE HUESO DE MANO IZQUIERDA"
  },
  {
    "codigo":1088941000119107,
    "descripcion":"HIPERACUSIA DE OÍDO IZQUIERDO"
  },
  {
    "codigo":105901000119108,
    "descripcion":"DERRAME PLEURAL CAUSADO POR BACTERIA"
  },
  {
    "codigo":403592009,
    "descripcion":"ACAROFOBIA"
  },
  {
    "codigo":205149007,
    "descripcion":"SINDACTILIA ÓSEA DE SEGUNDO A QUINTO DEDOS DEL PIE"
  },
  {
    "codigo":170546000,
    "descripcion":"REQUIERE UN REFUERZO DE VACUNA CONTRA EL CÓLERA"
  },
  {
    "codigo":268850004,
    "descripcion":"DIARREA NEONATAL"
  },
  {
    "codigo":72242008,
    "descripcion":"COARTACIÓN DE AORTA POSTDUCTAL"
  },
  {
    "codigo":70407001,
    "descripcion":"ESTRIDOR"
  },
  {
    "codigo":398087002,
    "descripcion":"MIEMBRO DEL PERSONAL MAL ATENDIDO"
  },
  {
    "codigo":299783003,
    "descripcion":"REFLEJO DE OJOS DE MUÑECA HORIZONTAL PRESENTE"
  },
  {
    "codigo":37639005,
    "descripcion":"RETORNO VENOSO PULMONAR ANÓMALO HACIA LA AURÍCULA DERECHA"
  },
  {
    "codigo":365319008,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA LIMPIAR LA HABITACIÓN"
  },
  {
    "codigo":297948003,
    "descripcion":"CONSISTENCIA CUTÁNEA NORMAL"
  },
  {
    "codigo":232412004,
    "descripcion":"EPIGLOTIS BÍFIDA"
  },
  {
    "codigo":363484005,
    "descripcion":"NEOPLASIA MALIGNA DE PELVIS"
  },
  {
    "codigo":1344689004,
    "descripcion":"DEFORMIDAD CONGÉNITA DE SISTEMA MUSCULOEQUELÉTICO"
  },
  {
    "codigo":1201005,
    "descripcion":"HIPERTENSIÓN ARTERIAL ESENCIAL BENIGNA"
  },
  {
    "codigo":230577008,
    "descripcion":"MONONEUROPATÍA DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":785798002,
    "descripcion":"CARCINOMA IN SITU DE CAVIDAD BUCAL"
  },
  {
    "codigo":359814004,
    "descripcion":"VIRUELA DEL MONO"
  },
  {
    "codigo":70831000119103,
    "descripcion":"HIDROPESÍA COCLEAR"
  },
  {
    "codigo":294278007,
    "descripcion":"ALERGIA A PROTAMINA"
  },
  {
    "codigo":64902007,
    "descripcion":"FRACTURA NO EXPUESTA DEL OLÉCRANON DEL CÚBITO"
  },
  {
    "codigo":1177179002,
    "descripcion":"SÍNDROME OROFACIODIGITAL CON TALLA BAJA Y BRAQUIMESOFALANGIA"
  },
  {
    "codigo":423515003,
    "descripcion":"ARTRITIS POSINFECCIOSA DE ARTICULACIÓN DE PIE"
  },
  {
    "codigo":95835004,
    "descripcion":"SECRECIÓN ECTÓPICA DE ALDOSTERONA"
  },
  {
    "codigo":128603005,
    "descripcion":"TRASTORNO DEL MÚSCULO EXTRAOCULAR"
  },
  {
    "codigo":292443008,
    "descripcion":"REACCIÓN ADVERSA A FÁRMACO BLOQUEANTE DE LOS RECEPTORES ALFA-ADRENÉRGICOS"
  },
  {
    "codigo":716592003,
    "descripcion":"LIPONEUROCITOMA DE CEREBELO"
  },
  {
    "codigo":126768004,
    "descripcion":"NEOPLASIA DE TRACTO GASTROINTESTINAL"
  },
  {
    "codigo":15691081000119100,
    "descripcion":"ARTRITIS REUMATOIDEA SERONEGATIVA DE ARTICULACIÓN DE AMBOS PIES"
  },
  {
    "codigo":290608006,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR IFOSFAMIDA"
  },
  {
    "codigo":94000008,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE GLÁNDULA SEBÁCEA"
  },
  {
    "codigo":26629001,
    "descripcion":"SÍNDROME DEL INTESTINO CORTO"
  },
  {
    "codigo":92165001,
    "descripcion":"NEOPLASIA BENIGNA DE RIÑÓN"
  },
  {
    "codigo":288773008,
    "descripcion":"DIFICULTAD PARA DIRIGIR LA ATENCIÓN"
  },
  {
    "codigo":254170001,
    "descripcion":"ICTIOSIS HYSTRIX DE CURTH-MACKLIN"
  },
  {
    "codigo":712922002,
    "descripcion":"ENFERMEDAD DE CADENA PESADA 9 DE MIOSINA NO RELACIONADA CON EL MÚSCULO"
  },
  {
    "codigo":188634000,
    "descripcion":"ENFERMEDAD DE SÉZARY DE GANGLIOS LINFÁTICOS DE REGIÓN INGUINAL Y MIEMBRO INFERIOR"
  },
  {
    "codigo":418010004,
    "descripcion":"CANTIDAD DE LINFOCITOS EN SANGRE POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":10857801000119103,
    "descripcion":"HERIDA ABIERTA DE MITAD DERECHA DE PARED TORÁCICA POSTERIOR"
  },
  {
    "codigo":416175008,
    "descripcion":"LÍNEAS DEL ESTROMA CORNEAL"
  },
  {
    "codigo":283268000,
    "descripcion":"VIDRIO EN LA PIERNA"
  },
  {
    "codigo":86660005,
    "descripcion":"QUEMADURA DE CUALQUIER GRADO QUE COMPROMETE 40-49 PORCIENTO DE LA SUPERFICIE DEL CUERPO"
  },
  {
    "codigo":21124006,
    "descripcion":"SIGNO DE PHALEN"
  },
  {
    "codigo":447108006,
    "descripcion":"PSEUDOLIPOMATOSIS"
  },
  {
    "codigo":1231705001,
    "descripcion":"TRASTORNO DE GLÁNDULA LAGRIMAL DEBIDO A SÍNDROME DE SJÖGREN"
  },
  {
    "codigo":445273005,
    "descripcion":"PATRÓN DE USO NOCIVO DE MÚLTIPLES SUSTANCIAS"
  },
  {
    "codigo":707417006,
    "descripcion":"CREPITACIÓN DE ARTICULACIÓN TEMPOROMANDIBULAR DURANTE LA APERTURA DE LA MANDÍBULA"
  },
  {
    "codigo":314201008,
    "descripcion":"LUXACIÓN DE PRÓTESIS ARTICULAR DE LA CADERA"
  },
  {
    "codigo":281433009,
    "descripcion":"INFECCIÓN DE INJERTO CARTILAGINOSO"
  },
  {
    "codigo":246830000,
    "descripcion":"ADHERENCIAS DE TARSORRAFIA"
  },
  {
    "codigo":115758001,
    "descripcion":"FENOTIPO DE GRUPO SANGUÍNEO RH"
  },
  {
    "codigo":408835000,
    "descripcion":"CONSENTIMIENTO PARA PROCEDIMIENTO, OTORGADO"
  },
  {
    "codigo":443438009,
    "descripcion":"MIOCLONÍA HÍPNICA"
  },
  {
    "codigo":212227005,
    "descripcion":"LESIÓN DE LA RAÍZ DEL NERVIO SACRO - S5"
  },
  {
    "codigo":310531007,
    "descripcion":"VAGABUNDEA DURANTE EL DÍA"
  },
  {
    "codigo":703747008,
    "descripcion":"GEOTRICHUM CAPITATUM O PROTOTHECA ZOPFII"
  },
  {
    "codigo":275928001,
    "descripcion":"FARMACOTERAPIA - INCUMPLIMIENTO PARCIAL"
  },
  {
    "codigo":345571000119106,
    "descripcion":"ANILLO DE KAYSER-FLEISCHER DE AMBOS OJOS"
  },
  {
    "codigo":767448007,
    "descripcion":"PINEOBLASTOMA"
  },
  {
    "codigo":1258968008,
    "descripcion":"ESGUINCE DE LIGAMENTO DE ARTICULACIÓN INTERFALÁNGICA DE PULGAR"
  },
  {
    "codigo":112088009,
    "descripcion":"EGOMANÍA"
  },
  {
    "codigo":208557001,
    "descripcion":"FRACTURA EXPUESTA DE FÉMUR PROXIMAL, INTERTROCANTÉREA, DOS PARTES"
  },
  {
    "codigo":44717005,
    "descripcion":"SIGNO DE CHVOSTEK"
  },
  {
    "codigo":110253007,
    "descripcion":"CONTUSIÓN DE LA ENCÍA UNIDA AL MAXILAR SUPERIOR"
  },
  {
    "codigo":274093008,
    "descripcion":"PUPILA ANORMAL"
  },
  {
    "codigo":700077008,
    "descripcion":"ARTROPATÍA DE CHARCOT DE ARTICULACIÓN DE TOBILLO"
  },
  {
    "codigo":319101000119102,
    "descripcion":"ARTRITIS REUMATOIDEA SERONEGATIVA DE ARTICULACIÓN DE CODO DERECHO"
  },
  {
    "codigo":763778003,
    "descripcion":"SÍNDROME SIMILAR A LARSEN TIPO B3GAT3"
  },
  {
    "codigo":403330004,
    "descripcion":"ALOPECIA POR MASAJE"
  },
  {
    "codigo":11949008,
    "descripcion":"EROSIÓN DENTAL CAUSADA POR MEDICAMENTO"
  },
  {
    "codigo":10114008,
    "descripcion":"ESTERILIDAD FEMENINA"
  },
  {
    "codigo":237655001,
    "descripcion":"HIPOPARATIROIDISMO LIGADO AL CROMOSOMA X"
  },
  {
    "codigo":41047001,
    "descripcion":"TOXICIDAD DEL BÓRAX"
  },
  {
    "codigo":270423004,
    "descripcion":"PROVEEDOR DE LA ENTREVISTA"
  },
  {
    "codigo":235820001,
    "descripcion":"NUDO ILEOSIGMOIDE"
  },
  {
    "codigo":301356002,
    "descripcion":"DOLOR EN SENO MAXILAR"
  },
  {
    "codigo":399660006,
    "descripcion":"MELANOMA EN ANILLO DE CUERPO CILIAR"
  },
  {
    "codigo":299521001,
    "descripcion":"ARTICULACIÓN DEL PIE - CALIENTE"
  },
  {
    "codigo":365057002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA COMENZAR UNA CONVERSACIÓN"
  },
  {
    "codigo":102913002,
    "descripcion":"TAFOFOBIA"
  },
  {
    "codigo":397825006,
    "descripcion":"ÚLCERA GÁSTRICA"
  },
  {
    "codigo":201217006,
    "descripcion":"ACNÉ POR YODO"
  },
  {
    "codigo":233985008,
    "descripcion":"ANEURISMA DE AORTA ABDOMINAL"
  },
  {
    "codigo":292631000119102,
    "descripcion":"OCLUSIÓN DE ARTERIA VERTEBRAL IZQUIERDA"
  },
  {
    "codigo":232150003,
    "descripcion":"VISIÓN PARCIAL - AMBOS OJOS"
  },
  {
    "codigo":264918004,
    "descripcion":"PORCIÓN INFERIOR DE URÉTER DE RIÑÓN DOBLE"
  },
  {
    "codigo":35542008,
    "descripcion":"PIODERMIA CHANCRIFORME"
  },
  {
    "codigo":363222009,
    "descripcion":"TRASTORNO NEUROMUSCULAR NEONATAL"
  },
  {
    "codigo":263083005,
    "descripcion":"FRACTURA-LUXACIÓN DE LA ARTICULACIÓN PERISEMILUNAR"
  },
  {
    "codigo":33707005,
    "descripcion":"INFECCIÓN CAUSADA POR KLOSSIELLA"
  },
  {
    "codigo":164779007,
    "descripcion":"PRUEBA ESPECIAL DEL APARATO CARDIOVASCULAR ANORMAL"
  },
  {
    "codigo":230315008,
    "descripcion":"DISTONÍA MEDICAMENTOSA"
  },
  {
    "codigo":721835008,
    "descripcion":"DISOSTOSIS ACROFRONTOFACIONASAL TIPO 2"
  },
  {
    "codigo":16021271000119105,
    "descripcion":"BURSITIS DE AMBOS PIES"
  },
  {
    "codigo":228480003,
    "descripcion":"UTILIZA GUANTES COMO PROTECCIÓN PARA EL SEXO"
  },
  {
    "codigo":11843351000119106,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE OREJA IZQUIERDA CON INFECCIÓN"
  },
  {
    "codigo":294016008,
    "descripcion":"ALERGIA A PIRIDOSTIGMINA"
  },
  {
    "codigo":783701002,
    "descripcion":"SÍNDROME DE NEVOS EN VINO DE OPORTO, MEGACISTERNA MAGNA E HIDROCEFALIA"
  },
  {
    "codigo":30037006,
    "descripcion":"FISURA ANAL"
  },
  {
    "codigo":126506000,
    "descripcion":"NEOPLASIA DE LA PIEL DE LA AXILA"
  },
  {
    "codigo":292181009,
    "descripcion":"REACCIÓN ADVERSA A LA COCAÍNA"
  },
  {
    "codigo":60970005,
    "descripcion":"MIOSITIS PARASITARIA"
  },
  {
    "codigo":1142314007,
    "descripcion":"ATROFIA DE PRIMER MÚSCULO INTERÓSEO DORSAL DE MANO"
  },
  {
    "codigo":192042008,
    "descripcion":"ESTADO DE ESTRÉS POSTRAUMÁTICO AGUDO"
  },
  {
    "codigo":124671001,
    "descripcion":"DEFICIENCIA DE FENILPIRUVATO TAUTOMERASA"
  },
  {
    "codigo":290346009,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR SUCRALFATO"
  },
  {
    "codigo":421418009,
    "descripcion":"NEOPLASIA DE LINFOCITOS T MADUROS Y\/O DE CÉLULAS ASESINAS NATURALES"
  },
  {
    "codigo":93738008,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL CARDIAS GÁSTRICO"
  },
  {
    "codigo":288511001,
    "descripcion":"QUEMADURA CON COMPROMISO DE 8% DE LA SUPERFICIE CORPORAL"
  },
  {
    "codigo":1204180000,
    "descripcion":"OCLUSIÓN AGUDA DE ARTERIA RENAL DEBIDA A TROMBOSIS"
  },
  {
    "codigo":91903009,
    "descripcion":"AUSENCIA CONGÉNITA DEL PREMAXILAR"
  },
  {
    "codigo":1236948000,
    "descripcion":"METÁSTASIS DE CARCINOMA DE TROMPA DE FALOPIO"
  },
  {
    "codigo":417748003,
    "descripcion":"DREPANOCITOSIS-ENFERMEDAD DE HEMOGLOBINA D CON CRISIS HEMOLÍTICA"
  },
  {
    "codigo":286676004,
    "descripcion":"AISLAMIENTO - MECANISMO DE DEFENSA PSICOLÓGICA"
  },
  {
    "codigo":90068007,
    "descripcion":"TRASTORNO DE CARTÍLAGO ARTICULAR DE LA MANO"
  },
  {
    "codigo":88233000,
    "descripcion":"PARAPSORIASIS"
  },
  {
    "codigo":384980008,
    "descripcion":"ATELECTASIA Y\/O NEUMONITIS OBSTRUCTIVA DE TODO EL PULMÓN ASOCIADA CON PROPAGACIÓN DIRECTA DE NEOPLASIA MALIGNA"
  },
  {
    "codigo":448681000,
    "descripcion":"DISPOSICIÓN AURICULAR INDETERMINADA"
  },
  {
    "codigo":284841002,
    "descripcion":"INCAPAZ DE LAVARSE LOS DIENTES"
  },
  {
    "codigo":321611000119102,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE TENDÓN FLEXOR DE PIERNA DERECHA"
  },
  {
    "codigo":186537009,
    "descripcion":"INFECCIÓN HERPÉTICA DEL RECTO Y LA PIEL PERIANAL"
  },
  {
    "codigo":1003902003,
    "descripcion":"DELECIÓN PROXIMAL DEL BRAZO LARGO DEL CROMOSOMA 2"
  },
  {
    "codigo":445011005,
    "descripcion":"EDEMA DE PLANTA DE PIE"
  },
  {
    "codigo":312104005,
    "descripcion":"COLANGIOCARCINOMA DE VÍAS BILIARES"
  },
  {
    "codigo":246568006,
    "descripcion":"APRAXIA GESTUAL"
  },
  {
    "codigo":17192009,
    "descripcion":"ENANISMO ASEXUAL AUTOSÓMICO RECESIVO"
  },
  {
    "codigo":310269003,
    "descripcion":"ANTICUERPO ANTI - SM DETECTADO"
  },
  {
    "codigo":408573005,
    "descripcion":"RESULTADO DE ESTUDIO DE DIAGNÓSTICO POR IMÁGENES NORMAL"
  },
  {
    "codigo":769021008,
    "descripcion":"CARIES NO CAVITADA ACTIVA DE RAÍZ DENTAL"
  },
  {
    "codigo":48125009,
    "descripcion":"LESIÓN TRAUMÁTICA DEL TRONCO"
  },
  {
    "codigo":210130003,
    "descripcion":"LESIÓN TRAUMÁTICA DE COLON ASCENDENTE CON HERIDA ABIERTA HACIA CAVIDAD ABDOMINAL"
  },
  {
    "codigo":767186007,
    "descripcion":"QUISTE SINOVIAL DE CADERA"
  },
  {
    "codigo":44455001,
    "descripcion":"HIPERSOMNIA RELACIONADA CON UN FACTOR ORGÁNICO CONOCIDO"
  },
  {
    "codigo":11687002,
    "descripcion":"DIABETES MELLITUS GESTACIONAL"
  },
  {
    "codigo":109991003,
    "descripcion":"PANMIELOSIS AGUDA CON MIELOFIBROSIS"
  },
  {
    "codigo":208295005,
    "descripcion":"FRACTURA NO EXPUESTA DE CÚBITO PROXIMAL, CONMINUTA"
  },
  {
    "codigo":404903008,
    "descripcion":"UTILIZA LENGUAJE DE SEÑAS"
  },
  {
    "codigo":1255036002,
    "descripcion":"RUPTURA TRAUMÁTICA DE LIGAMENTO COLATERAL DE ARTICULACIÓN DE DEDO ÍNDICE"
  },
  {
    "codigo":75388006,
    "descripcion":"INFECCIÓN PULMONAR POR ECHINOCOCCUS GRANULOSUS"
  },
  {
    "codigo":403068008,
    "descripcion":"TIÑA CAUSADA POR MICROSPORUM CANIS VARIANTE CANIS"
  },
  {
    "codigo":401233007,
    "descripcion":"CON MAYOR RIESGO DE AUTODESCUIDO"
  },
  {
    "codigo":302929008,
    "descripcion":"CIRCULAR DE CORDÓN UMBILICAL ALREDEDOR DEL CUELLO"
  },
  {
    "codigo":15997311000119102,
    "descripcion":"PLIEGUE COROIDEO CONGÉNITO BILATERAL"
  },
  {
    "codigo":71718006,
    "descripcion":"HINCHAZÓN DE LA PIEL"
  },
  {
    "codigo":38950008,
    "descripcion":"ESCOTOMA DEL ÁREA CENTRAL"
  },
  {
    "codigo":1251366009,
    "descripcion":"REACCIÓN CUTÁNEA POR VENENO DE MOLUSCO"
  },
  {
    "codigo":366630009,
    "descripcion":"HALLAZGO RELACIONADO CON LA AMPLITUD DE MOVIMIENTO DE SUPINACIÓN MEDIOTARSIANA"
  },
  {
    "codigo":364795005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA LIMPIAR LA BOCA DE RESIDUOS"
  },
  {
    "codigo":168187006,
    "descripcion":"NO SE AISLARON MICROORGANISMOS EN EL ESPÉCIMEN"
  },
  {
    "codigo":299259005,
    "descripcion":"AMPLITUD DE EXTENSIÓN PASIVA DE LA CADERA DISMINUIDA"
  },
  {
    "codigo":231888000,
    "descripcion":"ESTAFILOMA ANTERIOR"
  },
  {
    "codigo":723408004,
    "descripcion":"DISTROFIA DEL EPITELIO PIGMENTARIO DE LA RETINA CON PATRÓN MULTIFOCAL QUE SIMULA EL FONDO FLAVIMACULATUS"
  },
  {
    "codigo":788944005,
    "descripcion":"TALASEMIA GAMMA DELTA BETA"
  },
  {
    "codigo":15725081000119100,
    "descripcion":"DERRAME DE ARTICULACIÓN DE AMBOS PIES"
  },
  {
    "codigo":262821002,
    "descripcion":"AVULSIÓN DE BAZO"
  },
  {
    "codigo":721573003,
    "descripcion":"NEOPLASIA DE SISTEMA CARDIOVASCULAR"
  },
  {
    "codigo":361125005,
    "descripcion":"TIROIDITIS SUBAGUDA AUTOINMUNITARIA"
  },
  {
    "codigo":1342330001,
    "descripcion":"EDEMA DE CEREBELO TRAUMÁTICO"
  },
  {
    "codigo":195450002,
    "descripcion":"ÚLCERA VARICOSA INFECTADA"
  },
  {
    "codigo":424826008,
    "descripcion":"EXPECTATIVAS IRREALES CON RESPECTO AL CRECIMIENTO Y DESARROLLO"
  },
  {
    "codigo":291919000,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR YODURO"
  },
  {
    "codigo":193615000,
    "descripcion":"POST-CATARATA CON ALTERACIÓN DE LA VISIÓN DESPUÉS DE LA EXTRACCIÓN DE CATARATA"
  },
  {
    "codigo":717903003,
    "descripcion":"HIPOPARATIROIDISMO SECUNDARIO"
  },
  {
    "codigo":293754009,
    "descripcion":"ALERGIA A NITROSOUREA"
  },
  {
    "codigo":93476001,
    "descripcion":"HEMORRAGIA DE TROMPA DE FALOPIO"
  },
  {
    "codigo":290084006,
    "descripcion":"MAMA NORMAL"
  },
  {
    "codigo":124409006,
    "descripcion":"DEFICIENCIA DE ARILESTERASA"
  },
  {
    "codigo":286414000,
    "descripcion":"HABLA A VELOCIDAD NORMAL"
  },
  {
    "codigo":284579000,
    "descripcion":"ASTILLA DE MADERA EN EL CUERO CABELLUDO"
  },
  {
    "codigo":188110009,
    "descripcion":"NEOPLASIA MALIGNA DE PIEL DE LA PARED ABDOMINAL"
  },
  {
    "codigo":253646008,
    "descripcion":"ANEURISMA CONGÉNITO DE LA AORTA ASCENDENTE"
  },
  {
    "codigo":448419003,
    "descripcion":"SEPSIS CAUSADA POR STREPTOCOCCUS AGALACTIAE"
  },
  {
    "codigo":415651004,
    "descripcion":"SUBLUXACIÓN DE COLGAJO CORNEAL"
  },
  {
    "codigo":249976001,
    "descripcion":"MOVIMIENTOS DE COMPENSACIÓN"
  },
  {
    "codigo":315512003,
    "descripcion":"NACIDO EN SAN MARINO"
  },
  {
    "codigo":708728007,
    "descripcion":"LESIÓN TRAUMÁTICA CEREBRAL INFLIGIDA CON INTENCIÓN DESCONOCIDA"
  },
  {
    "codigo":870733000,
    "descripcion":"EDEMA DE CUERDA VOCAL"
  },
  {
    "codigo":1231181001,
    "descripcion":"CRANEOSINOSTOSIS METÓPICA NO SINDRÓMICA"
  },
  {
    "codigo":1296717001,
    "descripcion":"HIPERTENSIÓN OCULAR DE OJO IZQUIERDO DEBIDA A RETRACCIÓN DE ÁNGULO"
  },
  {
    "codigo":117069006,
    "descripcion":"UNIDAD DE HEMODERIVADO DESPACHADA PARA PROCESAMIENTO POSTERIOR"
  },
  {
    "codigo":706893006,
    "descripcion":"VÍCTIMA DE MALTRATO POR PARTE DE PAREJA ÍNTIMA"
  },
  {
    "codigo":248141008,
    "descripcion":"MASTICACIÓN DE CUERPO EXTRAÑO"
  },
  {
    "codigo":1263949009,
    "descripcion":"OLIGURIA POSTERIOR A EMBARAZO MOLAR"
  },
  {
    "codigo":444749006,
    "descripcion":"NEFRONOPTISIS DEL ADOLESCENTE"
  },
  {
    "codigo":49698005,
    "descripcion":"COMPLICACIÓN URINARIA"
  },
  {
    "codigo":770594005,
    "descripcion":"DISTROFIA MACULAR DE LA RETINA TIPO 2"
  },
  {
    "codigo":703223000,
    "descripcion":"ESTENOSIS DE VÁLVULA AÓRTICA POSTERIOR A PROCEDIMIENTO"
  },
  {
    "codigo":279074008,
    "descripcion":"PIEL DOLORIDA"
  },
  {
    "codigo":705058008,
    "descripcion":"ARTROPATÍA DE CHARCOT DE ANTEPIÉ"
  },
  {
    "codigo":1090381000119104,
    "descripcion":"CERVICITIS RECURRENTE CAUSADO POR VIRUS HERPES SIMPLE HUMANO"
  },
  {
    "codigo":80631005,
    "descripcion":"HALLAZGO RELACIONADO CON EL ESTADIO CLÍNICO"
  },
  {
    "codigo":211703005,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO PROFUNDA DEL PABELLÓN AURICULAR"
  },
  {
    "codigo":277239007,
    "descripcion":"TUMEFACCIÓN SOBRE EL SENO MAXILAR"
  },
  {
    "codigo":1356748004,
    "descripcion":"CONJUNTIVITIS AGUDA DE AMBOS OJOS"
  },
  {
    "codigo":111564004,
    "descripcion":"DEFICIENCIA DE EPINEFRINA"
  },
  {
    "codigo":406476007,
    "descripcion":"EPISPADIAS"
  },
  {
    "codigo":275404008,
    "descripcion":"RAQUITISMO CELÍACO"
  },
  {
    "codigo":109729001,
    "descripcion":"SALIENTE EN UNA RESTAURACIÓN DENTAL"
  },
  {
    "codigo":240801003,
    "descripcion":"CLONORQUIASIS CRÓNICA"
  },
  {
    "codigo":404641004,
    "descripcion":"VAHÍDO"
  },
  {
    "codigo":765089003,
    "descripcion":"SÍNDROME DE EPILEPSIA FOCAL, DISCAPACIDAD INTELECTUAL Y MALFORMACIÓN CEREBRO-CEREBELOSA"
  },
  {
    "codigo":371873004,
    "descripcion":"IRREGULARIDADES LUMINALES DE LA ARTERIA CORONARIA"
  },
  {
    "codigo":680781000119108,
    "descripcion":"ATROFIA DE IRIS DE AMBOS OJOS"
  },
  {
    "codigo":9590000,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO DE MANO"
  },
  {
    "codigo":1156470000,
    "descripcion":"PAPILOMA ATÍPICO DEL PLEXO COROIDEO"
  },
  {
    "codigo":1254774007,
    "descripcion":"RUPTURA TRAUMÁTICA DE TENDÓN DE MÚSCULO PECTORAL MAYOR"
  },
  {
    "codigo":106059000,
    "descripcion":"HALLAZGO RELACIONADO CON EL CONTROL RESPIRATORIO POR PARTE DEL SISTEMA NERVIOSO"
  },
  {
    "codigo":1285707001,
    "descripcion":"HIPERTENSIÓN OCULAR DEBIDA A CIRUGÍA OCULAR"
  },
  {
    "codigo":238966008,
    "descripcion":"SIFILOFOBIA"
  },
  {
    "codigo":204363002,
    "descripcion":"VALVAS SUPERNUMERARIAS DE VÁLVULA MITRAL"
  },
  {
    "codigo":73291005,
    "descripcion":"AUSENCIA CONGÉNITA DE LA GLÁNDULA PARATIROIDES"
  },
  {
    "codigo":1351243006,
    "descripcion":"TRABAJO DE PARTO INTERRUMPIDO EN PRIMER ESTADIO"
  },
  {
    "codigo":366368001,
    "descripcion":"EGRESOS DE LÍQUIDOS POR DRENAJE - HALLAZGO"
  },
  {
    "codigo":300832004,
    "descripcion":"REALIZA ACTIVIDADES DE BRICOLAJE"
  },
  {
    "codigo":71456006,
    "descripcion":"FRACTURA NO EXPUESTA DE LARINGE"
  },
  {
    "codigo":5920007,
    "descripcion":"LENGUA AFRAMBUESADA"
  },
  {
    "codigo":724981006,
    "descripcion":"LESIÓN TRAUMÁTICA DE FASCIA DE MÚSCULO EXTENSOR A LA ALTURA DEL ANTEBRAZO"
  },
  {
    "codigo":723146004,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO CUTÁNEO ANTERIOR DEL CUELLO"
  },
  {
    "codigo":16546791000119109,
    "descripcion":"DISTENSIÓN DE TENDÓN ROTULIANO IZQUIERDO"
  },
  {
    "codigo":297162006,
    "descripcion":"TROMBOSIS DE ARTERIA CRURAL"
  },
  {
    "codigo":11850881000119103,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE HEMITÓRAX DERECHO"
  },
  {
    "codigo":459167000,
    "descripcion":"EMBARAZO GEMELAR MONOCORIÓNICO"
  },
  {
    "codigo":262559001,
    "descripcion":"HEMATOMA PROFUNDO"
  },
  {
    "codigo":426399003,
    "descripcion":"LIPOMATOSIS EPIDURAL"
  },
  {
    "codigo":33183004,
    "descripcion":"PÚRPURA TROMBOCITOPÉNICA POSTINFECCIOSA"
  },
  {
    "codigo":721311006,
    "descripcion":"ENFERMEDAD LINFOPROLIFERATIVA SISTÉMICA DE LINFOCITOS T POSITIVA PARA VIRUS DE EPSTEIN BARR DE LA INFANCIA"
  },
  {
    "codigo":64116003,
    "descripcion":"INTOXICACIÓN POR BORATO"
  },
  {
    "codigo":1145460003,
    "descripcion":"APLASIA DE HÚMERO"
  },
  {
    "codigo":300161000119106,
    "descripcion":"TRASTORNO DEL TEJIDO CONJUNTIVO CONCOMITANTE CON ENFERMEDAD SISTÉMICA Y DEBIDO A ELLA"
  },
  {
    "codigo":226121000,
    "descripcion":"DIETA RICA EN CARBOHIDRATOS COMPLEJOS"
  },
  {
    "codigo":293492009,
    "descripcion":"REACCIÓN ADVERSA A INHIBIDOR DE LA ANHIDRASA CARBÓNICA"
  },
  {
    "codigo":291657003,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR TETRACICLINA"
  },
  {
    "codigo":783177006,
    "descripcion":"HIPOTIROIDISMO CONGÉNITO DEBIDO A INGESTA MATERNA DE FÁRMACO ANTITIROIDEO"
  },
  {
    "codigo":160585006,
    "descripcion":"EX - BEBEDOR EXCESIVO - 7 A 9 UNIDADES POR DÍA"
  },
  {
    "codigo":95049007,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA PIEL DEL BRAZO"
  },
  {
    "codigo":1141790002,
    "descripcion":"FIBROSIS INTRAPERITONEAL"
  },
  {
    "codigo":27678003,
    "descripcion":"MIOQUIMIA"
  },
  {
    "codigo":289822003,
    "descripcion":"HALLAZGO RELACIONADO CON EL COLOR DEL CUELLO UTERINO"
  },
  {
    "codigo":93214005,
    "descripcion":"MELANOMA MALIGNO DE LA PIEL DE LA ESPALDA"
  },
  {
    "codigo":1172723003,
    "descripcion":"TIEMPO DE LISIS DE EUGLOBULINA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":124147007,
    "descripcion":"DEFICIENCIA DE XANTINA OXIDASA"
  },
  {
    "codigo":56776001,
    "descripcion":"ÚLCERA DUODENAL SIN HEMORRAGIA Y SIN PERFORACIÓN"
  },
  {
    "codigo":286152008,
    "descripcion":"DIFICULTAD PARA LIMPIAR EL BAÑO"
  },
  {
    "codigo":253384009,
    "descripcion":"TEJIDO ACCESORIO SOBRE VALVA DE VÁLVULA TRICÚSPIDE"
  },
  {
    "codigo":684633371000119107,
    "descripcion":"MENINGOTELIOMATOSIS PULMONAR DIFUSA"
  },
  {
    "codigo":27931000119107,
    "descripcion":"MICROCALCIFICACIÓN MAMOGRÁFICA DE MAMA"
  },
  {
    "codigo":22173004,
    "descripcion":"CRECIMIENTO FETAL EXCESIVO QUE AFECTA EL MANEJO DE LA SITUACIÓN MATERNA"
  },
  {
    "codigo":251549002,
    "descripcion":"EXCITACIÓN DE FIBRA MUSCULAR AISLADA"
  },
  {
    "codigo":448157006,
    "descripcion":"ANOMALÍA DE VENA SISTÉMICA"
  },
  {
    "codigo":53106000,
    "descripcion":"QUEMADURA DE LA PARED ABDOMINAL"
  },
  {
    "codigo":20338004,
    "descripcion":"FRICCIÓN DEL CUERO CABELLUDO"
  },
  {
    "codigo":315250005,
    "descripcion":"MASTALGIA PERSISTENTE"
  },
  {
    "codigo":249714004,
    "descripcion":"CARECE DE EXTENSIÓN LUMBAR"
  },
  {
    "codigo":1003378007,
    "descripcion":"HIPOPLASIA DE NERVIO ÓPTICO DEBIDA A DEFICIENCIA ENDOCRINA"
  },
  {
    "codigo":341306651000119109,
    "descripcion":"CARCINOMA EX ADENOMA PLEOMORFO PRIMARIO DE GLÁNDULA LAGRIMAL DERECHA"
  },
  {
    "codigo":282482007,
    "descripcion":"INCAPAZ DE CORRER EN TERRENO PLANO"
  },
  {
    "codigo":18503002,
    "descripcion":"HEMORRAGIA CUTÁNEA PERINATAL"
  },
  {
    "codigo":1263687003,
    "descripcion":"TRASTORNO NEONATAL PRECOZ DEBIDO A HEMORRAGIA MATERNA DURANTE EMBARAZO"
  },
  {
    "codigo":118642009,
    "descripcion":"ANOMALÍA CONGÉNITA DEL TRACTO URINARIO PROPIAMENTE DICHO"
  },
  {
    "codigo":247879004,
    "descripcion":"PENSAMIENTOS OBSESIVOS ACERCA DE LA CONTAMINACIÓN"
  },
  {
    "codigo":870471007,
    "descripcion":"INGESTA EXCESIVA DE VITAMINA D Y\/O DERIVADO DE VITAMINA D"
  },
  {
    "codigo":49436004,
    "descripcion":"FIBRILACIÓN AURICULAR"
  },
  {
    "codigo":442652006,
    "descripcion":"INFECCIÓN CAUSADA POR LARVA DE ANISAKIS"
  },
  {
    "codigo":16668007,
    "descripcion":"REACCIÓN A TRANSFUSIÓN CAUSADA POR LEUCOAGLUTININAS"
  },
  {
    "codigo":1163548008,
    "descripcion":"ENCEFALITIS POR VIRUS VILYUISK DE LA ENCEFALITIS HUMANA"
  },
  {
    "codigo":735729001,
    "descripcion":"DIVERTÍCULO DE INTESTINO GRUESO CONCOMITANTE CON HEMORRAGIA DE INTESTINO GRUESO"
  },
  {
    "codigo":702961002,
    "descripcion":"DESVIACIÓN DE LA MANDÍBULA HACIA LA DERECHA DURANTE LA APERTURA"
  },
  {
    "codigo":80369006,
    "descripcion":"NEUTROFILIA CRÓNICA"
  },
  {
    "codigo":209606003,
    "descripcion":"DESGARRO COMPLETO DE LIGAMENTO DEL PULGAR"
  },
  {
    "codigo":240539000,
    "descripcion":"VERRUGA PLANA"
  },
  {
    "codigo":109467004,
    "descripcion":"RETRASO GENERALIZADO DE ERUPCIÓN DENTAL DEBIDO A ENFERMEDAD SISTÉMICA"
  },
  {
    "codigo":207771005,
    "descripcion":"FRACTURA EXPUESTA DE MANDÍBULA, ÁNGULO MANDIBULAR"
  },
  {
    "codigo":369776000,
    "descripcion":"PUNTAJE DE GLEASON 5-6: MODERADAMENTE DIFERENCIADO"
  },
  {
    "codigo":271472001,
    "descripcion":"NEOPLASIA BENIGNA DE LA NARIZ, EL OÍDO MEDIO Y LOS SENOS PARANASALES"
  },
  {
    "codigo":402544001,
    "descripcion":"CARCINOMA BASOCELULAR RECIDIVANTE - PRIMERA RECIDIVA"
  },
  {
    "codigo":238704004,
    "descripcion":"HIPERMELANOSIS DE PENE"
  },
  {
    "codigo":304240008,
    "descripcion":"SOLICITA EUTANASIA PASIVA"
  },
  {
    "codigo":42096009,
    "descripcion":"DIETA LÍQUIDA POR CAUSA ODONTOLÓGICA"
  },
  {
    "codigo":40261006,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO DE CUELLO"
  },
  {
    "codigo":7493006,
    "descripcion":"INFECCIÓN CAUSADA POR PLAGIORCHIS"
  },
  {
    "codigo":235034000,
    "descripcion":"QUERATOSIS FRICCIONAL BUCAL"
  },
  {
    "codigo":267802000,
    "descripcion":"PRURITO DE ÓRGANOS GENITALES"
  },
  {
    "codigo":890394003,
    "descripcion":"MALFORMACIÓN CONGÉNITA DE LA VÍA AÉREA PULMONAR TIPO 0"
  },
  {
    "codigo":300570005,
    "descripcion":"TUMORACIÓN PERIANAL"
  },
  {
    "codigo":202266006,
    "descripcion":"CONTRACTURA DE HOMBRO EN EXTENSIÓN"
  },
  {
    "codigo":724719005,
    "descripcion":"TRASTORNO PSICÓTICO CAUSADO POR KETAMINA"
  },
  {
    "codigo":298735007,
    "descripcion":"DEFORMIDAD DE COSTILLA"
  },
  {
    "codigo":427972000,
    "descripcion":"NEURALGIA DE NERVIO PUDENDO"
  },
  {
    "codigo":395204000,
    "descripcion":"ESTADO HIPEROSMOLAR NO CETÓSICO DEBIDO A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":722884003,
    "descripcion":"REGURGITACIÓN GASTROINTESTINAL INFANTIL"
  },
  {
    "codigo":296900006,
    "descripcion":"SOBREDOSIS DE ANDRÓGENO"
  },
  {
    "codigo":15677161000119107,
    "descripcion":"MIOSITIS DE AMBOS BRAZOS"
  },
  {
    "codigo":196761002,
    "descripcion":"ESTENOSIS PILÓRICA ADQUIRIDA"
  },
  {
    "codigo":293230000,
    "descripcion":"REACCIÓN ADVERSA A LA BICALUTAMIDA"
  },
  {
    "codigo":11800451000119102,
    "descripcion":"LACERACIÓN DE VENA RENAL IZQUIERDA"
  },
  {
    "codigo":426137009,
    "descripcion":"ENTERITIS POR CITOMEGALOVIRUS"
  },
  {
    "codigo":424302003,
    "descripcion":"MELANOMA MALIGNO DE LA PIEL DE LABIO INFERIOR"
  },
  {
    "codigo":1208899000,
    "descripcion":"TAQUICARDIA VENTRICULAR ANULAR MITRAL"
  },
  {
    "codigo":94787001,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LAS MENINGES CEREBRALES"
  },
  {
    "codigo":225859003,
    "descripcion":"ES SEGURO QUE PERMANEZCA SIN ATENCIÓN"
  },
  {
    "codigo":782915004,
    "descripcion":"LINFOHISTIOCITOSIS HEMOFAGOCÍTICA ADQUIRIDA ASOCIADA CON ENFERMEDAD MALIGNA"
  },
  {
    "codigo":291395003,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR FÁRMACO ANTIRREUMÁTICO"
  },
  {
    "codigo":289560001,
    "descripcion":"SECRECIÓN VAGINAL PROFUSA"
  },
  {
    "codigo":191256002,
    "descripcion":"ANEMIA APLÁSICA IDIOPÁTICA"
  },
  {
    "codigo":92952006,
    "descripcion":"FORMA ANORMAL CONGÉNITA DE TESTÍCULO"
  },
  {
    "codigo":1010456008,
    "descripcion":"BLOQUEO DE CONDUCCIÓN NERVIOSA MOTORA IZQUIERDA"
  },
  {
    "codigo":123885002,
    "descripcion":"INTOXICACIÓN POR BORAGINACEAE"
  },
  {
    "codigo":91117004,
    "descripcion":"RESTITUCIÓN FETAL"
  },
  {
    "codigo":15951901000119102,
    "descripcion":"HIPERTRICOSIS DE PÁRPADOS DE AMBOS OJOS"
  },
  {
    "codigo":713709009,
    "descripcion":"ESCOLIOSIS IDIOPÁTICA DE COLUMNA VERTEBRAL CON TRIPLE CURVA"
  },
  {
    "codigo":58349009,
    "descripcion":"EXHIBICIONISMO"
  },
  {
    "codigo":154818001,
    "descripcion":"AFIBRINOGENEMIA CONGÉNITA"
  },
  {
    "codigo":254957009,
    "descripcion":"ADENOMA SOMATOTRÓFICO"
  },
  {
    "codigo":449730005,
    "descripcion":"SÍNDROME AUTOINMUNITARIO POLIGLANDULAR, TIPO 4"
  },
  {
    "codigo":285890006,
    "descripcion":"DIFICULTAD PARA UTILIZAR LA PAVA"
  },
  {
    "codigo":11718531000119109,
    "descripcion":"RETRACCIÓN ANORMAL DE AMBOS PÁRPADOS SUPERIORES"
  },
  {
    "codigo":54679003,
    "descripcion":"TRAUMATISMO OBSTÉTRICO DE VEJIGA URINARIA"
  },
  {
    "codigo":251287009,
    "descripcion":"EXCESO DE PIEL Y MÚSCULO EN EL PÁRPADO"
  },
  {
    "codigo":282220004,
    "descripcion":"DIFICULTAD PARA EMPEZAR A CAMINAR Y DETENER LA MARCHA ESPONTÁNEAMENTE"
  },
  {
    "codigo":249452004,
    "descripcion":"CUERDA VOCAL NO ADUCE DURANTE LA FONACIÓN"
  },
  {
    "codigo":216684006,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR CERA PARAFINA"
  },
  {
    "codigo":18241005,
    "descripcion":"SECUENCIA DE OBSTRUCCIÓN URETRAL TEMPRANA"
  },
  {
    "codigo":409622000,
    "descripcion":"FALLA RESPIRATORIA"
  },
  {
    "codigo":247617009,
    "descripcion":"CAPACIDAD ALTERADA PARA APRENDER MATERIAL NUEVO"
  },
  {
    "codigo":1163286003,
    "descripcion":"EMOCIÓN NEGATIVA ACERCA DE LOS ALIMENTOS Y\/O LA NUTRICIÓN"
  },
  {
    "codigo":278550007,
    "descripcion":"OBTURACIÓN DENTAL PRESENTE"
  },
  {
    "codigo":47339000,
    "descripcion":"TRASTORNO SECUNDARIO DEL SENTIDO DEL GUSTO DE LOS SABORES DULCES"
  },
  {
    "codigo":1259755002,
    "descripcion":"CORDOMA PRIMARIO DE CLIVUS"
  },
  {
    "codigo":735467004,
    "descripcion":"COLANGITIS CONCOMITANTE CON CÁLCULO DE VESÍCULA Y DEBIDA A ÉL"
  },
  {
    "codigo":276715006,
    "descripcion":"ASFIXIA EN EL RECIÉN NACIDO"
  },
  {
    "codigo":209344001,
    "descripcion":"FRACTURA-LUXACIÓN NO EXPUESTA DE ARTICULACIÓN FEMORORROTULIANA"
  },
  {
    "codigo":76437000,
    "descripcion":"CONTUSIÓN DEL PULGAR"
  },
  {
    "codigo":1256085003,
    "descripcion":"TRASTORNO PRURIGINOSO MULTIFACTORIAL"
  },
  {
    "codigo":895637003,
    "descripcion":"FORMA TRIANGULAR ANORMAL CONGÉNITA DE FALANGE DE QUINTO DEDO DE PIE"
  },
  {
    "codigo":404117003,
    "descripcion":"MICOSIS FUNGOIDE ESPONGIÓTICA"
  },
  {
    "codigo":16007351000119108,
    "descripcion":"FUSIÓN ANORMAL CONGÉNITA DE HUESOS DE CARPO IZQUIERDO"
  },
  {
    "codigo":305813008,
    "descripcion":"VISTO POR EL SERVICIO DE MEDICINA GENERAL"
  },
  {
    "codigo":10901008,
    "descripcion":"DERMATITIS DE CONTACTO CAUSADA POR URUSHIOL DE ZUMAQUE VENENOSO"
  },
  {
    "codigo":402282005,
    "descripcion":"DERMATITIS PAPILOMATOSA CRÓNICA POR UROSTOMÍA"
  },
  {
    "codigo":205674006,
    "descripcion":"REORDENAMIENTO AUTOSÓMICO\/SEXUAL EQUILIBRADO EN EL INDIVIDUO ANORMAL"
  },
  {
    "codigo":9066006,
    "descripcion":"SENTIMIENTO DE DESÁNIMO"
  },
  {
    "codigo":1186879000,
    "descripcion":"DEMENCIA DEBIDA A DEFICIENCIA DE TIAMINA"
  },
  {
    "codigo":238442009,
    "descripcion":"CIGOMICOSIS SUBCUTÁNEA"
  },
  {
    "codigo":369514009,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA TROMPA DE FALOPIO IZQUIERDA"
  },
  {
    "codigo":236607005,
    "descripcion":"PÉRDIDA DE ORINA DESDE EL URÉTER"
  },
  {
    "codigo":202004000,
    "descripcion":"ARTROPATÍA TRANSITORIA DE LA ARTICULACIÓN METACARPOFALÁNGICA"
  },
  {
    "codigo":7231009,
    "descripcion":"DERMATOSIS AMPOLLAR"
  },
  {
    "codigo":300308000,
    "descripcion":"APÉNDICE ILEOCECAL PRESENTE"
  },
  {
    "codigo":10738001000119105,
    "descripcion":"CARCINOMA INDIFERENCIADO DE OVARIO IZQUIERDO"
  },
  {
    "codigo":105535008,
    "descripcion":"VIVIENDA SIN CALEFACCIÓN"
  },
  {
    "codigo":267540007,
    "descripcion":"AGRANULOCITOSIS CAUSADA POR RADIACIÓN"
  },
  {
    "codigo":1119508008,
    "descripcion":"AGOTAMIENTO FATIGABLE DE MÚSCULO DE MASTICACIÓN"
  },
  {
    "codigo":38164009,
    "descripcion":"ANOMALÍA CONGÉNITA DE LOS TEGUMENTOS"
  },
  {
    "codigo":70932007,
    "descripcion":"DISFUNCIÓN SEXUAL INDUCIDA POR ANFETAMINAS"
  },
  {
    "codigo":396777004,
    "descripcion":"MARGEN QUIRÚRGICO DE CORDÓN ESPERMÁTICO COMPROMETIDO POR TUMOR"
  },
  {
    "codigo":298473005,
    "descripcion":"CUELLO ESTABLE"
  },
  {
    "codigo":724457006,
    "descripcion":"ENDOMETRIOSIS PROFUNDA"
  },
  {
    "codigo":1279678000,
    "descripcion":"FIEBRE RECURRENTE CAUSADA POR BORRELIA HERMSII"
  },
  {
    "codigo":1148606004,
    "descripcion":"AMPLITUD DE ELECTRORRETINOGRAMA DE PATRÓN ANORMAL"
  },
  {
    "codigo":394942005,
    "descripcion":"ESTADIO C2 DE DUKES"
  },
  {
    "codigo":722622004,
    "descripcion":"CONTUSIÓN NO HEMORRÁGICA FOCAL DE TRONCO ENCEFÁLICO"
  },
  {
    "codigo":11311441000119109,
    "descripcion":"FRACTURA POR OSTEOPOROSIS SECUNDARIA DE VÉRTEBRA LUMBAR"
  },
  {
    "codigo":296638008,
    "descripcion":"SOBREDOSIS DE DERIVADO DEL NITROFURANO"
  },
  {
    "codigo":130963002,
    "descripcion":"INVOLUCIÓN MAMARIA ASINCRÓNICA"
  },
  {
    "codigo":32659003,
    "descripcion":"HIPOPLASIA CONGÉNITA DE RIÑÓN"
  },
  {
    "codigo":196499005,
    "descripcion":"SIALOLITIASIS PAROTÍDEA"
  },
  {
    "codigo":360339005,
    "descripcion":"HIPOGLUCEMIA HIPERINSULINÉMICA PERSISTENTE DE LA LACTANCIA"
  },
  {
    "codigo":294803007,
    "descripcion":"ALERGIA A LIOTIRONINA"
  },
  {
    "codigo":1144936001,
    "descripcion":"POLINEUROPATÍA DEBIDA A MONONUCLEOSIS POR HERPESVIRUS DEL GRUPO GAMMA"
  },
  {
    "codigo":39661000087106,
    "descripcion":"DOLOR CRÓNICO POSTERIOR A AMPUTACIÓN"
  },
  {
    "codigo":34541000087107,
    "descripcion":"MÚLTIPLES HERIDAS ABIERTAS"
  },
  {
    "codigo":42221000087107,
    "descripcion":"RUPTURA DE TENDÓN DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":47341000087109,
    "descripcion":"DISTENSIÓN DE MÚSCULO CUÁDRICEPS FEMORAL DERECHO"
  },
  {
    "codigo":129128006,
    "descripcion":"ENFERMEDAD INFECCIOSA RENAL"
  },
  {
    "codigo":292968003,
    "descripcion":"REACCIÓN ADVERSA A LA AMPICILINA"
  },
  {
    "codigo":424040008,
    "descripcion":"SEUDOCIESIS"
  },
  {
    "codigo":44781000087105,
    "descripcion":"OCLUSIÓN DE RAMA OBTUSA MARGINAL DE RAMA CIRCUNFLEJA DE ARTERIA CORONARIA IZQUIERDA"
  },
  {
    "codigo":94525009,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL LIGAMENTO REDONDO DEL ÚTERO"
  },
  {
    "codigo":127293009,
    "descripcion":"ESGUINCE DE LIGAMENTO CRUZADO POSTERIOR DE RODILLA"
  },
  {
    "codigo":92690003,
    "descripcion":"CARCINOMA IN SITU DE LA PARED POSTERIOR DE LA VEJIGA"
  },
  {
    "codigo":780818005,
    "descripcion":"FÍSTULA CONGÉNITA DE PABELLÓN AURICULAR"
  },
  {
    "codigo":387602005,
    "descripcion":"AFASIA SINTÁCTICA"
  },
  {
    "codigo":254695001,
    "descripcion":"TRICOADENOMA"
  },
  {
    "codigo":713447003,
    "descripcion":"CONOCIMIENTO DEFICIENTE DE LA FUNCIÓN PARENTAL"
  },
  {
    "codigo":16747141000119104,
    "descripcion":"RETINOPATÍA NO PROLIFERATIVA SEVERA DE OJO DERECHO DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":25319005,
    "descripcion":"DIARREA CRÓNICA EN LOS LACTANTES Y\/O NIÑOS PEQUEÑOS"
  },
  {
    "codigo":15927941000119105,
    "descripcion":"DISTORSIÓN VISUAL DEL OJO DERECHO"
  },
  {
    "codigo":123623009,
    "descripcion":"FLEXIÓN ANORMAL"
  },
  {
    "codigo":285628005,
    "descripcion":"DIFICULTAD PARA DECIR LA HORA"
  },
  {
    "codigo":23484007,
    "descripcion":"CANDIDIASIS DE LAS UÑAS"
  },
  {
    "codigo":1268668007,
    "descripcion":"RECIÉN NACIDO A TÉRMINO 39 SEMANAS"
  },
  {
    "codigo":283793002,
    "descripcion":"MORDEDURA DE ANIMAL EN LA FRENTE"
  },
  {
    "codigo":54417002,
    "descripcion":"TRASTORNO DE LA IDENTIDAD SEXUAL DEL ADULTO, SEXUALMENTE ATRAÍDO POR MUJERES"
  },
  {
    "codigo":21649006,
    "descripcion":"CRECIMIENTO Y DESARROLLO ALTERADOS: HABILIDADES DE COMUNICACIÓN"
  },
  {
    "codigo":183654001,
    "descripcion":"SEGUIMIENTO EN CENTRO DE ATENCIÓN AMBULATORIA"
  },
  {
    "codigo":871782005,
    "descripcion":"REACCIÓN ADVERSA A ALDEHÍDO"
  },
  {
    "codigo":1230395003,
    "descripcion":"INFECCIÓN CAUSADA POR KLEBSIELLA OXYTOCA BLEE"
  },
  {
    "codigo":247355005,
    "descripcion":"DOLOR EN EL FLANCO"
  },
  {
    "codigo":17979007,
    "descripcion":"INTOXICACIÓN POR BUXUS SEMPERVIRENS"
  },
  {
    "codigo":704272003,
    "descripcion":"LEUCOMA CORNEAL"
  },
  {
    "codigo":278288005,
    "descripcion":"VOCALIZACIÓN"
  },
  {
    "codigo":81680005,
    "descripcion":"CERVICALGIA"
  },
  {
    "codigo":11860921000119100,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXTERNA NO EXPUESTA DE RODILLA DERECHA"
  },
  {
    "codigo":702437000,
    "descripcion":"MICROCEFALIA LETAL DE LOS AMISH"
  },
  {
    "codigo":1357797003,
    "descripcion":"LESIÓN TRAUMÁTICA DE GLOBO OCULAR DE AMBOS OJOS"
  },
  {
    "codigo":14309005,
    "descripcion":"SÍNDROME DE LA ARTERIA COROIDEA ANTERIOR"
  },
  {
    "codigo":735205007,
    "descripcion":"TRAZADO DE CARDIOTOCOGRAFÍA ANORMAL"
  },
  {
    "codigo":241850000,
    "descripcion":"EFECTO TÓXICO CAUSADO POR LIMPIATAPIZADOS"
  },
  {
    "codigo":1259493008,
    "descripcion":"CARCINOMA PRIMARIO INVASIVO DE CUELLO DE ÚTERO"
  },
  {
    "codigo":209082003,
    "descripcion":"LUXACIÓN VERTEBRAL NO EXPUESTA CON LESIÓN MEDULAR COMPLETA A NIVEL LUMBAR"
  },
  {
    "codigo":733370003,
    "descripcion":"HERIDA ABIERTA DE REGIÓN INFERIOR DEL DORSO"
  },
  {
    "codigo":310201000119103,
    "descripcion":"ARTRITIS GOTOSA DE MANO IZQUIERDA"
  },
  {
    "codigo":1073951000119109,
    "descripcion":"BURSITIS GOTOSA DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":240015000,
    "descripcion":"CONTRACTURA DE TENDÓN DE REGIÓN DE TOBILLO"
  },
  {
    "codigo":403855001,
    "descripcion":"ANOMALÍA DIGITAL CONGÉNITA"
  },
  {
    "codigo":371087003,
    "descripcion":"ÚLCERA DE PIE DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":698767004,
    "descripcion":"EPILEPSIA POST-ACCIDENTE CEREBROVASCULAR"
  },
  {
    "codigo":305551003,
    "descripcion":"BAJO ATENCIÓN DE CIRUJANO ESPECIALISTA EN TRAUMA"
  },
  {
    "codigo":41572006,
    "descripcion":"MUCOPOLISACARIDOSIS, MPS - III - A"
  },
  {
    "codigo":762468009,
    "descripcion":"QUEMADURA COMPLEJA DE CABEZA"
  },
  {
    "codigo":203577005,
    "descripcion":"DEFORMIDAD EN FLEXIÓN PLANTAR DE ARTICULACIÓN MEDIOTARSIANA"
  },
  {
    "codigo":269113006,
    "descripcion":"DESGARRO AGUDO DEL MENISCO INTERNO"
  },
  {
    "codigo":11779001000119108,
    "descripcion":"LESIÓN TRAUMÁTICA DE TENDÓN DE CABEZA LARGA DE BÍCEPS BRAQUIAL DERECHO"
  },
  {
    "codigo":726030000,
    "descripcion":"OSTEOCONDRITIS DISECANTE DE HUESO METATARSIANO"
  },
  {
    "codigo":234510005,
    "descripcion":"AMILOIDOSIS ESPLÉNICA"
  },
  {
    "codigo":267278005,
    "descripcion":"PARTOS CON VENTOSA"
  },
  {
    "codigo":5134006,
    "descripcion":"POLINEUROPATÍA AMILOIDE FAMILIAR, TIPO VI"
  },
  {
    "codigo":70670009,
    "descripcion":"FUNCIÓN VASOMOTORA ANORMAL"
  },
  {
    "codigo":365582009,
    "descripcion":"ANTECEDENTE SOCIAL - HALLAZGO INICIAL"
  },
  {
    "codigo":298211003,
    "descripcion":"LAXITUD DE ARTICULACIÓN METACARPOFALÁNGICA"
  },
  {
    "codigo":427448000,
    "descripcion":"DISPOSICIÓN PARA MEJORAR EL PATRÓN DE SUEÑO"
  },
  {
    "codigo":581000124102,
    "descripcion":"CUMPLE CON LA RECOLECCIÓN DE ESPÉCIMEN DE DIALIZADO PERITONEAL"
  },
  {
    "codigo":296376006,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE METARAMINOL"
  },
  {
    "codigo":394680009,
    "descripcion":"ESPASTICIDAD DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":440901000124105,
    "descripcion":"INGESTA INADECUADA DE BORO"
  },
  {
    "codigo":165304009,
    "descripcion":"MEMORIA: PUEDE CONTAR AL REVÉS"
  },
  {
    "codigo":294541008,
    "descripcion":"ALERGIA A CEFACLOR"
  },
  {
    "codigo":292706005,
    "descripcion":"REACCIÓN ADVERSA AL NONOXINOL"
  },
  {
    "codigo":1144674006,
    "descripcion":"ADECUADAMENTE HIDRATADO"
  },
  {
    "codigo":816994007,
    "descripcion":"ERITEMA DE PIEL DE NARIZ"
  },
  {
    "codigo":423778009,
    "descripcion":"TENOSINOVITIS DE LA MANO"
  },
  {
    "codigo":127031002,
    "descripcion":"NEOPLASIA DEL CUERPO PARAÓRTICO"
  },
  {
    "codigo":718690009,
    "descripcion":"HIPOTIROIDISMO CONGÉNITO DEBIDO A AUSENCIA DE GLÁNDULA TIROIDES"
  },
  {
    "codigo":94263002,
    "descripcion":"NEOPLASIA MALIGNA SECUNDARIA DE LA CONJUNTIVA"
  },
  {
    "codigo":716855006,
    "descripcion":"NEOPLASIA MALIGNA DE OVARIO DE CÉLULAS DE LA TECA PRODUCTORAS DE ESTEROIDES"
  },
  {
    "codigo":190732007,
    "descripcion":"ALANINEMIA"
  },
  {
    "codigo":92428008,
    "descripcion":"NEOPLASIA BENIGNA DE TESTÍCULO"
  },
  {
    "codigo":289036009,
    "descripcion":"CAPAZ DE ALIMENTARSE CON LA MANO DERECHA"
  },
  {
    "codigo":418273000,
    "descripcion":"EL MARGEN DE RESECCIÓN QUIRÚRGICA EXTERNO ES EL MARGEN NO AFECTADO MÁS CERCANO AL CARCINOMA DUCTAL IN SITU"
  },
  {
    "codigo":1237473004,
    "descripcion":"METÁSTASIS DE CARCINOMA DE CABEZA DE PÁNCREAS"
  },
  {
    "codigo":188897006,
    "descripcion":"NEOPLASIA BENIGNA DEL MEDIASTINO SUPERIOR"
  },
  {
    "codigo":187062006,
    "descripcion":"HISTOPLASMOSIS HEPÁTICA"
  },
  {
    "codigo":449206007,
    "descripcion":"SARCOMA DE TIBIA"
  },
  {
    "codigo":250763003,
    "descripcion":"HALLAZGO RELACIONADO CON AGENTE ANESTÉSICO"
  },
  {
    "codigo":414603003,
    "descripcion":"LEUCOPLASIA DE LA MUCOSA ORAL"
  },
  {
    "codigo":283531004,
    "descripcion":"HERIDA PUNZANTE EN EXTREMIDADES INFERIORES"
  },
  {
    "codigo":185227007,
    "descripcion":"ATENDIDO EN UN CONSULTORIO REUMATOLÓGICO"
  },
  {
    "codigo":86923008,
    "descripcion":"RETINOSQUISIS JUVENIL"
  },
  {
    "codigo":10634631000119105,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN EN TALÓN IZQUIERDO NO ESTADIFICABLE"
  },
  {
    "codigo":447371008,
    "descripcion":"TUBERCULOSIS DE ÍLEON"
  },
  {
    "codigo":412768003,
    "descripcion":"ÍNDICE MASA CORPORAL 20-24, NORMAL"
  },
  {
    "codigo":609376003,
    "descripcion":"LINFEDEMA ADQUIRIDO DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":1363040007,
    "descripcion":"METABOLIZADOR INTERMEDIO DE FAMILIA 2 SUBFAMILIA C MIEMBRO 9 *8\/*11 DE CITOCROMO P450"
  },
  {
    "codigo":248928008,
    "descripcion":"ORIFICIO CERVICAL DE NULÍPARA"
  },
  {
    "codigo":116021002,
    "descripcion":"TRASTORNO DEL METABOLISMO DE LOS ÁCIDOS ORGÁNICOS"
  },
  {
    "codigo":83253003,
    "descripcion":"TRASTORNO DE TIMIDEZ EN LA NIÑEZ"
  },
  {
    "codigo":12246561000119101,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE AMBAS GLÁNDULAS SUPRARRENALES"
  },
  {
    "codigo":247093005,
    "descripcion":"CONTENIDO EXTRAÑO DEL VÍTREO"
  },
  {
    "codigo":1197365006,
    "descripcion":"ANOMALÍA CAVITARIA FAMILIAR DEL DISCO ÓPTICO"
  },
  {
    "codigo":50485007,
    "descripcion":"GLAUCOMA DE BAJA TENSIÓN"
  },
  {
    "codigo":11836961000119102,
    "descripcion":"AMPOLLA DE PIERNA IZQUIERDA, CON INFECCIÓN"
  },
  {
    "codigo":278026003,
    "descripcion":"PATRÓN CUTÁNEO ARBORESCENTE"
  },
  {
    "codigo":81418003,
    "descripcion":"ECCEMA NUMULAR"
  },
  {
    "codigo":212490004,
    "descripcion":"LESIONES ABIERTAS MÚLTIPLES DEL ANTEBRAZO"
  },
  {
    "codigo":1162762008,
    "descripcion":"OBSTRUCCIÓN DE CATÉTER DE DRENAJE BILIAR TRANSHEPÁTICO PERCUTÁNEO"
  },
  {
    "codigo":472799000,
    "descripcion":"ESTENOSIS SUBPULMONAR ADQUIRIDA ASOCIADA CON CORAZÓN FUNCIONALMENTE UNIVENTRICULAR"
  },
  {
    "codigo":1259231006,
    "descripcion":"MODIFICACIÓN DEL CURSO DE RADIOTERAPIA DEBIDA A CAMBIOS EN ZONA BLANCO"
  },
  {
    "codigo":208820003,
    "descripcion":"LUXACIÓN PERISEMILUNAR TRAUMÁTICA NO EXPUESTA (DORSAL)"
  },
  {
    "codigo":896948004,
    "descripcion":"FORMA DE BALA ANORMAL CONGÉNITA DE FALANGE MEDIA DE QUINTO DEDO DE PIE"
  },
  {
    "codigo":1157257000,
    "descripcion":"INTOXICACIÓN POR AGENTE HIPNÓTICO"
  },
  {
    "codigo":700340008,
    "descripcion":"DERMATITIS ALÉRGICA POR CONTACTO DE PÁRPADO SUPERIOR"
  },
  {
    "codigo":15687201000119107,
    "descripcion":"ARTRITIS REUMATOIDE DE AMBAS RODILLAS"
  },
  {
    "codigo":403593004,
    "descripcion":"FOBIA AL CÁNCER DE PIEL"
  },
  {
    "codigo":11892411000119102,
    "descripcion":"RUPTURA DE MANGUITO ROTADOR DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":237918004,
    "descripcion":"SÍNDROME DE WAARDENBURG TIPO 3"
  },
  {
    "codigo":74078006,
    "descripcion":"ENFERMEDAD POR EL VIRUS CANDIRU"
  },
  {
    "codigo":301619001,
    "descripcion":"CAPAZ DE UTILIZAR ASCENSOR"
  },
  {
    "codigo":342151000119100,
    "descripcion":"UVEÍTIS ANTERIOR AGUDA DE OJO IZQUIERDO"
  },
  {
    "codigo":10628231000119100,
    "descripcion":"PARONIQUIA DE DEDO DE PIE IZQUIERDO"
  },
  {
    "codigo":236083006,
    "descripcion":"VÓMITOS INTERMITENTES"
  },
  {
    "codigo":1089671000119102,
    "descripcion":"CAMBIO TEMPORARIO DE UMBRAL AUDITIVO DE OÍDO IZQUIERDO"
  },
  {
    "codigo":10948231000119103,
    "descripcion":"HERIDA ABIERTA DE PULGAR IZQUIERDO DEBIDA A MORDEDURA DE PERRO"
  },
  {
    "codigo":316551000119104,
    "descripcion":"OSTEOFITO DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":239789191000119106,
    "descripcion":"ATRAPAMIENTO DE MÚSCULO EXTRAOCULAR DE OJO IZQUIERDO"
  },
  {
    "codigo":15983751000119107,
    "descripcion":"ANOMALÍA ESTRUCTURAL CONGÉNITA DE ÓRBITA IZQUIERDA"
  },
  {
    "codigo":10681991000119107,
    "descripcion":"NÓDULO DE TEJIDO CELULAR SUBCUTÁNEO DE PIE BILATERAL"
  },
  {
    "codigo":10664071000119107,
    "descripcion":"ÚLCERA ISQUÉMICA ATEROSCLERÓTICA DE PANTORRILLA IZQUIERDA"
  },
  {
    "codigo":93831000119104,
    "descripcion":"ADAPTACIÓN A ENFERMEDAD POTENCIALMENTE FATAL"
  },
  {
    "codigo":16055431000119108,
    "descripcion":"HIPOTENSIÓN POSTERIOR A PROCEDIMIENTO"
  },
  {
    "codigo":10679431000119109,
    "descripcion":"TUMEFACCIÓN LOCALIZADA DE DORSO"
  },
  {
    "codigo":399923009,
    "descripcion":"ARTERITIS REUMATOIDE"
  },
  {
    "codigo":16057991000119109,
    "descripcion":"TRASTORNO DE NERVIO TRIGÉMINO IZQUIERDO"
  },
  {
    "codigo":10633351000119109,
    "descripcion":"CELULITIS DE MIEMBRO INFERIOR IZQUIERDO"
  },
  {
    "codigo":334471000119107,
    "descripcion":"EVERSIÓN DE PUNTO LAGRIMAL DE PÁRPADO DERECHO"
  },
  {
    "codigo":285831000119108,
    "descripcion":"ENFERMEDAD RENAL CRÓNICA POR HIPERTENSIÓN MALIGNA"
  },
  {
    "codigo":297949006,
    "descripcion":"HALLAZGO RELACIONADO CON LA HUMEDAD DE LA PIEL"
  },
  {
    "codigo":315221000119100,
    "descripcion":"OSTEOCONDRITIS DISECANTE DE CODO DERECHO"
  },
  {
    "codigo":427186000,
    "descripcion":"DERMATOFIBROMA"
  },
  {
    "codigo":232413009,
    "descripcion":"FÍSTULA FARÍNGEA"
  },
  {
    "codigo":363485006,
    "descripcion":"NEOPLASIA MALIGNA DE GLÁNDULA SALIVAL MENOR"
  },
  {
    "codigo":33970004,
    "descripcion":"ESCOTOMA DE ÁREA CIEGA"
  },
  {
    "codigo":296114005,
    "descripcion":"SOBREDOSIS DE MIDAZOLAM"
  },
  {
    "codigo":722098007,
    "descripcion":"ENFERMEDAD RENAL CRÓNICA POSTERIOR A NEFRECTOMÍA DE DONANTE"
  },
  {
    "codigo":292444002,
    "descripcion":"REACCIÓN ADVERSA A LA ALFUZOSINA"
  },
  {
    "codigo":95836003,
    "descripcion":"PRODUCCIÓN ECTÓPICA DE CALCITONINA"
  },
  {
    "codigo":128604004,
    "descripcion":"TRASTORNO DE LOS PRODUCTOS DE LA CONCEPCIÓN"
  },
  {
    "codigo":30300009,
    "descripcion":"EVENTRACIÓN OBSTRUIDA CON GANGRENA"
  },
  {
    "codigo":61233003,
    "descripcion":"ENFERMEDAD PULMONAR DE LOS TRABAJADORES DE LOS SILOS"
  },
  {
    "codigo":126769007,
    "descripcion":"NEOPLASIA DEL INTESTINO"
  },
  {
    "codigo":92166000,
    "descripcion":"NEOPLASIA BENIGNA DE LABIOS MAYORES VULVARES"
  },
  {
    "codigo":94001007,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL SEGUNDO HUESO CUNEIFORME DEL TARSO"
  },
  {
    "codigo":716593008,
    "descripcion":"CARCINOMA MAMARIO TIPO GLÁNDULA SALIVAL"
  },
  {
    "codigo":190470005,
    "descripcion":"PANHIPOPITUITARISMO IDIOPÁTICO"
  },
  {
    "codigo":418011000,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA INFERIOR COMPROMETIDO POR NEOPLASIA MALIGNA"
  },
  {
    "codigo":254171002,
    "descripcion":"ICTIOSIS HYSTRIX TIPO BÄFVERSTEDT"
  },
  {
    "codigo":188635004,
    "descripcion":"ENFERMEDAD DE SÉZARY DE GANGLIOS LINFÁTICOS INTRAPÉLVICOS"
  },
  {
    "codigo":90331004,
    "descripcion":"INFECCIÓN CAUSADA POR CYLICODONTOPHORUS"
  },
  {
    "codigo":1237211006,
    "descripcion":"MASA QUE OCUPA PARTE DE CUADRANTE INFERIOR DERECHO DE ABDOMEN"
  },
  {
    "codigo":55728007,
    "descripcion":"TRASTORNO DE AVERSIÓN SEXUAL"
  },
  {
    "codigo":414341000,
    "descripcion":"ARTERITIS DE CÉLULAS GIGANTES"
  },
  {
    "codigo":53893001,
    "descripcion":"INFECCIÓN CAUSADA POR ASPERGILLUS NIDULANS"
  },
  {
    "codigo":416176009,
    "descripcion":"FRACTURA-LUXACIÓN NO EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA DISTAL DE DEDO DE LA MANO"
  },
  {
    "codigo":447109003,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE CONDUCTO BILIAR INTRAHEPÁTICO"
  },
  {
    "codigo":840325005,
    "descripcion":"PILOERECCIÓN"
  },
  {
    "codigo":1231706000,
    "descripcion":"OPACIDAD SUBEPITELIAL CORNEAL POSQUIRÚRGICA"
  },
  {
    "codigo":344201000119102,
    "descripcion":"EXOFTALMÍA PULSÁTIL DE AMBOS OJOS"
  },
  {
    "codigo":283269008,
    "descripcion":"VIDRIO EN LA ESPINILLA"
  },
  {
    "codigo":281434003,
    "descripcion":"FALLA DE INJERTO CARTILAGINOSO"
  },
  {
    "codigo":19290004,
    "descripcion":"ARTICULACIONES DE CLUTTON"
  },
  {
    "codigo":445274004,
    "descripcion":"DEFICIENCIA DE ISOBUTIRIL-COENZIMA A DESHIDROGENASA"
  },
  {
    "codigo":707418001,
    "descripcion":"INFERTILIDAD MASCULINA DEBIDA A FIBROSIS QUÍSTICA"
  },
  {
    "codigo":248666008,
    "descripcion":"TERCER RUIDO CARDÍACO NORMAL EN UNA PERSONA JOVEN"
  },
  {
    "codigo":443439001,
    "descripcion":"HISTIOCITOMA FIBROSO MALIGNO"
  },
  {
    "codigo":771119002,
    "descripcion":"INFECCIÓN CAUSADA POR COCCIDIOS CONCOMITANTE CON SÍNDROME DE INMUNODEFICIENCIA ADQUIRIDA"
  },
  {
    "codigo":82991003,
    "descripcion":"DOLORES CORPORALES GENERALIZADOS"
  },
  {
    "codigo":1229871006,
    "descripcion":"CARCINOMA PRIMARIO DE CÉLULAS ESCAMOSAS DE LA CAVIDAD NASAL Y SENOS PARANASALES"
  },
  {
    "codigo":212228000,
    "descripcion":"CONTUSIÓN, PLEXO BRAQUIAL, RAÍCES SUPERIORES"
  },
  {
    "codigo":310532000,
    "descripcion":"VAGABUNDEA POR LA NOCHE"
  },
  {
    "codigo":115759009,
    "descripcion":"FENOTIPO >NULO<RH"
  },
  {
    "codigo":441604003,
    "descripcion":"MIOCLONÍA ASOCIADA CON FIEBRE"
  },
  {
    "codigo":1258969000,
    "descripcion":"ESGUINCE DE LIGAMENTO DE ARTICULACIÓN METACARPOFALÁNGICA DE PULGAR"
  },
  {
    "codigo":112089001,
    "descripcion":"DISPROSODIA DE COMPRENSIÓN"
  },
  {
    "codigo":15636771000119101,
    "descripcion":"INESTABILIDAD DE AMBOS TOBILLOS"
  },
  {
    "codigo":153891000119101,
    "descripcion":"ENFERMEDAD RENAL TERMINAL EN DIÁLISIS DEBIDA A HIPERTENSIÓN"
  },
  {
    "codigo":210393007,
    "descripcion":"HERIDA ABIERTA DE LA GLÁNDULA TIROIDES"
  },
  {
    "codigo":110254001,
    "descripcion":"CONTUSIÓN DE LA ENCÍA UNIDA A LA MANDÍBULA"
  },
  {
    "codigo":274094002,
    "descripcion":"DESTRUCCIÓN DE TÍMPANO"
  },
  {
    "codigo":700078003,
    "descripcion":"TUBO DE GASTROSTOMÍA IN SITU"
  },
  {
    "codigo":77486005,
    "descripcion":"TRASTORNO DEL ESTADO DE ÁNIMO CON UN EPISODIO MAYOR SIMILAR AL DEPRESIVO, POR UNA ENFERMEDAD MÉDICA GENERAL"
  },
  {
    "codigo":208558006,
    "descripcion":"FRACTURA EXPUESTA DE FÉMUR PROXIMAL, SUBTROCANTÉREA"
  },
  {
    "codigo":403331000,
    "descripcion":"ALOPECIA MARGINAL"
  },
  {
    "codigo":370563004,
    "descripcion":"AGRESIÓN TERRITORIAL"
  },
  {
    "codigo":42883007,
    "descripcion":"ANOXIA CAUSADA POR ALTURA ELEVADA"
  },
  {
    "codigo":237656000,
    "descripcion":"TUMOR ESPLÉNICO AGUDO"
  },
  {
    "codigo":204888000,
    "descripcion":"HIPOSPADIAS PENIANO"
  },
  {
    "codigo":41048006,
    "descripcion":"LARINGITIS POR HAEMOPHILUS INFLUENZAE"
  },
  {
    "codigo":235821002,
    "descripcion":"OBSTRUCCIÓN INTESTINAL POSQUIRÚRGICA"
  },
  {
    "codigo":71981002,
    "descripcion":"EPENDIMITIS"
  },
  {
    "codigo":301357006,
    "descripcion":"DOLOR EN SENO FRONTAL"
  },
  {
    "codigo":170285008,
    "descripcion":"EXAMEN NORMAL DE NIÑO DE 3 AÑOS DE EDAD"
  },
  {
    "codigo":39213008,
    "descripcion":"NACIMIENTO PREMATURO DE MELLIZOS IDÉNTICOS, UNO VIVO, UNO MUERTO"
  },
  {
    "codigo":397826007,
    "descripcion":"SÍNDROME DE BRIQUET"
  },
  {
    "codigo":299522008,
    "descripcion":"ARTICULACIÓN DEL PIE - TIBIA"
  },
  {
    "codigo":233986009,
    "descripcion":"ANEURISMA DE LA ARTERIA FEMORAL COMÚN"
  },
  {
    "codigo":2775001,
    "descripcion":"ARTROFITO"
  },
  {
    "codigo":35543003,
    "descripcion":"ENDOMETRIOSIS CUTÁNEA"
  },
  {
    "codigo":363223004,
    "descripcion":"TRASTORNO OFTALMOLÓGICO NEONATAL"
  },
  {
    "codigo":365058007,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA ELEGIR TEMAS DE CONVERSACIÓN"
  },
  {
    "codigo":295852003,
    "descripcion":"SOBREDOSIS DE DESIPRAMINA"
  },
  {
    "codigo":263084004,
    "descripcion":"FRACTURA-LUXACIÓN DE DEDO DE LA MANO O PULGAR"
  },
  {
    "codigo":720001001,
    "descripcion":"ORINA DE COLOR AMARILLO OSCURO"
  },
  {
    "codigo":721836009,
    "descripcion":"SÍNDROME DE HIPERTELORISMO CON MICROTIA Y HENDIDURA FACIAL"
  },
  {
    "codigo":230316009,
    "descripcion":"DISTONÍA AGUDA MEDICAMENTOSA"
  },
  {
    "codigo":294017004,
    "descripcion":"ALERGIA A NEOSTIGMINA"
  },
  {
    "codigo":228481004,
    "descripcion":"UTILIZA DEDIL COMO PROTECCIÓN PARA EL SEXO"
  },
  {
    "codigo":346711000119101,
    "descripcion":"CATARATA COMBINADA CONGÉNITA DE AMBOS OJOS"
  },
  {
    "codigo":292182002,
    "descripcion":"REACCIÓN ADVERSA A LA BENZOCAÍNA"
  },
  {
    "codigo":95574003,
    "descripcion":"ESTENOSIS URETERAL"
  },
  {
    "codigo":127421000119109,
    "descripcion":"SÍNDROME DE CHOQUE TÓXICO DEBIDO A INFECCIÓN POR STAPHYLOCOCCUS AUREUS RESISTENTE A LA METICILINA"
  },
  {
    "codigo":93739000,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA CARINA"
  },
  {
    "codigo":783702009,
    "descripcion":"DISCAPACIDAD INTELECTUAL LIGADA AL CROMOSOMA X DEBIDO A MUTACIONES DE LA SUBUNIDAD 3 DEL TIPO AMPA DEL RECEPTOR IONOTRÓPICO DE GLUTAMATO"
  },
  {
    "codigo":290347000,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR SUCRALFATO"
  },
  {
    "codigo":1142315008,
    "descripcion":"ATROFIA DE PRIMER MÚSCULO INTERÓSEO DORSAL DE PIE"
  },
  {
    "codigo":59136001,
    "descripcion":"ENFERMEDAD TIROIDEA EN LA MADRE, QUE COMPLICA EL EMBARAZO, EL PARTO Y\/O EL PUERPERIO"
  },
  {
    "codigo":126507009,
    "descripcion":"NEOPLASIA DE LA PIEL DEL ABDOMEN"
  },
  {
    "codigo":91904003,
    "descripcion":"AUSENCIA CONGÉNITA DE HUESO PREESFENOIDAL"
  },
  {
    "codigo":386816005,
    "descripcion":"PROBLEMAS EMOCIONALES"
  },
  {
    "codigo":124672008,
    "descripcion":"DEFICIENCIA DE ESTEROIDE DELTA - ISOMERASA"
  },
  {
    "codigo":1204181001,
    "descripcion":"OCLUSIÓN AGUDA DE ARTERIA POPLÍTEA DEBIDA A TROMBOSIS"
  },
  {
    "codigo":288512008,
    "descripcion":"QUEMADURA CON COMPROMISO DE 7% DE LA SUPERFICIE CORPORAL"
  },
  {
    "codigo":15639281000119101,
    "descripcion":"PSEUDOEXFOLIACIÓN DE CÁPSULA DE CRISTALINO DERECHO"
  },
  {
    "codigo":24533004,
    "descripcion":"TORACODELFO"
  },
  {
    "codigo":253909006,
    "descripcion":"FÍSTULA DEL TRACTO GASTROINTESINAL-URINARIO CONGÉNITA"
  },
  {
    "codigo":712661008,
    "descripcion":"LESIÓN TRAUMÁTICA POR EXPLOSIÓN DE REGIÓN OCULAR"
  },
  {
    "codigo":1236949008,
    "descripcion":"HALLAZGO RELACIONADO CON EL VOLUMEN DE PLACENTA"
  },
  {
    "codigo":286677008,
    "descripcion":"MANÍA - MECANISMO DE DEFENSA PSICOLÓGICA"
  },
  {
    "codigo":186538004,
    "descripcion":"INFECCIÓN ANOGENITAL POR VIRUS DEL HERPES"
  },
  {
    "codigo":55466006,
    "descripcion":"TRABAJO DE PARTO DETENIDO"
  },
  {
    "codigo":448682007,
    "descripcion":"TABIQUE INTERAURICULAR ENGROSADO"
  },
  {
    "codigo":284842009,
    "descripcion":"SE LAVA LOS DIENTES"
  },
  {
    "codigo":250239005,
    "descripcion":"POBLACIÓN ERITROCÍTICA - HALLAZGO"
  },
  {
    "codigo":1003903008,
    "descripcion":"DELECIÓN PROXIMAL DEL BRAZO LARGO DEL CROMOSOMA 16"
  },
  {
    "codigo":248404001,
    "descripcion":"HALLAZGO GENERAL DE LA MANO"
  },
  {
    "codigo":445012003,
    "descripcion":"INFECCIÓN DE HUESO DE LA MANO"
  },
  {
    "codigo":1264212004,
    "descripcion":"HIPERLIPOPROTEINEMIA DE LIPOPROTEÍNA (A)"
  },
  {
    "codigo":82729001,
    "descripcion":"TUMOR SEROSANGUÍNEO DEL CUERO CABELLUDO DURANTE EL PARTO"
  },
  {
    "codigo":312105006,
    "descripcion":"INFECCIÓN POR MONGANELLA"
  },
  {
    "codigo":1196841007,
    "descripcion":"MESOTELIOMA PLEURAL DESMOPLÁSICO PRIMARIO"
  },
  {
    "codigo":408574004,
    "descripcion":"RESULTADO DE ESTUDIO DE DIAGNÓSTICO POR IMÁGENES ANORMAL"
  },
  {
    "codigo":210131004,
    "descripcion":"LESIÓN TRAUMÁTICA DE COLON TRANSVERSO CON HERIDA ABIERTA HACIA CAVIDAD ABDOMINAL"
  },
  {
    "codigo":44456000,
    "descripcion":"ERITROCITOSIS SECUNDARIA INAPROPIADA"
  },
  {
    "codigo":404904002,
    "descripcion":"ANCIANO FRÁGIL"
  },
  {
    "codigo":699816004,
    "descripcion":"FRACTURA VERTICAL DE DIENTE CON COMPROMISO DE LA PULPA"
  },
  {
    "codigo":109992005,
    "descripcion":"POLICITEMIA VERA (CLÍNICA)"
  },
  {
    "codigo":208296006,
    "descripcion":"FRACTURA NO EXPUESTA DE RADIO PROXIMAL, CONMINUTA"
  },
  {
    "codigo":403069000,
    "descripcion":"TIÑA CAUSADA POR MICROSPORUM CANIS VARIANTE DISTORTUM"
  },
  {
    "codigo":77224008,
    "descripcion":"ESPINA BÍFIDA DE LA REGIÓN LUMBAR"
  },
  {
    "codigo":1255037006,
    "descripcion":"HERNIA OBSTRUIDA DE CAVIDAD ABDOMINAL"
  },
  {
    "codigo":1156733008,
    "descripcion":"ALERGIA A AGONISTA DE RECEPTOR DE ERITROPOYETINA"
  },
  {
    "codigo":401234001,
    "descripcion":"BAJO RIESGO DE AUTODESCUIDO"
  },
  {
    "codigo":40786001,
    "descripcion":"NEUMONITIS POR ASPIRACIÓN CAUSADA POR REGURGITACIÓN DE SECRECIONES GÁSTRICAS"
  },
  {
    "codigo":302930003,
    "descripcion":"ENDARTERITIS OBLITERANTE"
  },
  {
    "codigo":8018005,
    "descripcion":"INTOXICACIÓN POR CHEILANTHES SIEBERI"
  },
  {
    "codigo":1251367000,
    "descripcion":"DERMATOSIS NEUTROFÍLICA FEBRIL AGUDA DEBIDA A ENFERMEDAD NEOPLÁSICA"
  },
  {
    "codigo":6183001,
    "descripcion":"CIRROSIS INFANTIL DE NIÑOS INDIOS"
  },
  {
    "codigo":71719003,
    "descripcion":"TROMBOFLEBITIS DE LA VENA RETINIANA"
  },
  {
    "codigo":301095005,
    "descripcion":"HALLAZGO CARDÍACO"
  },
  {
    "codigo":38951007,
    "descripcion":"INTENTO FALLIDO DE ABORTO CON LACERACIÓN DE INTESTINO"
  },
  {
    "codigo":299260000,
    "descripcion":"SIN AMPLITUD PASIVA DE EXTENSIÓN DE LA CADERA"
  },
  {
    "codigo":168188001,
    "descripcion":"ORGANISMO AISLADO EN ESPÉCIMEN"
  },
  {
    "codigo":397564002,
    "descripcion":"QUERATITIS ESTROMAL FOCAL"
  },
  {
    "codigo":366631008,
    "descripcion":"AMPLITUD DE MOVIMIENTO ACTIVO DE SUPINACIÓN MEDIOTARSIANA - HALLAZGO"
  },
  {
    "codigo":200956002,
    "descripcion":"ARTRITIS PSORIÁSICA CON COMPROMISO VERTEBRAL"
  },
  {
    "codigo":430332005,
    "descripcion":"INFECCIÓN DE INJERTO ARTERIOVENOSO PARA HEMODIÁLISIS"
  },
  {
    "codigo":364796006,
    "descripcion":"HALLAZGO RELACIONADO CON UN PATRÓN DE MOVIMIENTO"
  },
  {
    "codigo":2513003,
    "descripcion":"TIÑA DE CUERO CABELLUDO CAUSADA POR TRICHOPHYTON"
  },
  {
    "codigo":788945006,
    "descripcion":"GLAUCOMA CAUSADO POR LENTE DE CONTACTO"
  },
  {
    "codigo":723409007,
    "descripcion":"SÍNDROME DE BOCIO MULTINODULAR, RIÑONES QUÍSTICOS Y POLIDACTILIA"
  },
  {
    "codigo":231889008,
    "descripcion":"ESTAFILOMA CILIAR"
  },
  {
    "codigo":197286002,
    "descripcion":"HEPATITIS RECURRENTE"
  },
  {
    "codigo":361126006,
    "descripcion":"TIROIDITIS LINFOCÍTICA SUBAGUDA"
  },
  {
    "codigo":31611000,
    "descripcion":"TRASTORNO DE PERSONALIDAD MÚLTIPLE"
  },
  {
    "codigo":262822009,
    "descripcion":"LACERACIÓN DE BAZO"
  },
  {
    "codigo":721574009,
    "descripcion":"RABDOMIOSARCOMA PRIMARIO DE ÓRGANO GENITAL MASCULINO"
  },
  {
    "codigo":293755005,
    "descripcion":"ALERGIA A CARMUSTINA"
  },
  {
    "codigo":64379006,
    "descripcion":"APETITO ALIMENTARIO DISMINUIDO"
  },
  {
    "codigo":719739008,
    "descripcion":"CAPAZ DE ESCRIBIR MENSAJES"
  },
  {
    "codigo":785275009,
    "descripcion":"DISFUNCIÓN SEXUAL CAUSADA POR ANFETAMINA Y\/O DERIVADO DE ANFETAMINA"
  },
  {
    "codigo":128080005,
    "descripcion":"QUERATITIS NEUROTRÓFICA"
  },
  {
    "codigo":291920006,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR YODURO"
  },
  {
    "codigo":160848007,
    "descripcion":"ABANDONÓ EL HOGAR"
  },
  {
    "codigo":717904009,
    "descripcion":"HIPOPARATIROIDISMO DEBIDO A ENFERMEDAD GRANULOMATOSA"
  },
  {
    "codigo":93477005,
    "descripcion":"HEMORRAGIA DE TIMO"
  },
  {
    "codigo":290085007,
    "descripcion":"PROBLEMA MAMARIO"
  },
  {
    "codigo":1142053007,
    "descripcion":"PUSTULOSIS CEFÁLICA NEONATAL CAUSADA POR MALASSEZIA"
  },
  {
    "codigo":288250001,
    "descripcion":"HIPERTENSIÓN MATERNA"
  },
  {
    "codigo":58874000,
    "descripcion":"VOLUMEN SISTÓLICO DISMINUIDO"
  },
  {
    "codigo":124410001,
    "descripcion":"DEFICIENCIA DE TRIACILGLICEROL LIPASA"
  },
  {
    "codigo":253647004,
    "descripcion":"ANOMALÍA DE SENO DE VALSALVA"
  },
  {
    "codigo":89807005,
    "descripcion":"OSTEOCONDROSIS JUVENIL DE LA CABEZA DE LOS HUESOS METACARPIANOS"
  },
  {
    "codigo":286415004,
    "descripcion":"NO HABLA A VELOCIDAD NORMAL"
  },
  {
    "codigo":15697241000119105,
    "descripcion":"INFLAMACIÓN DE AMBOS NERVIOS CUBITALES"
  },
  {
    "codigo":284580002,
    "descripcion":"ASTILLA DE MADERA EN LA REGIÓN OCULAR"
  },
  {
    "codigo":251812003,
    "descripcion":"MAMAS EN ESTADIO 1 DE TANNER"
  },
  {
    "codigo":415652006,
    "descripcion":"NEOPLASIA DE SUBMUCOSA DE DUODENO"
  },
  {
    "codigo":186276006,
    "descripcion":"TUBERCULOSIS MILIAR AGUDA"
  },
  {
    "codigo":448420009,
    "descripcion":"SEPSIS CAUSADA POR STREPTOCOCCUS DEL GRUPO D"
  },
  {
    "codigo":53369002,
    "descripcion":"FUNCIÓN AXÓNICA NORMAL"
  },
  {
    "codigo":1003641004,
    "descripcion":"ANTÍGENO LEUCOCÍTICO HUMANO DQB1*02:02 DETECTADO"
  },
  {
    "codigo":249977005,
    "descripcion":"CORRIGE CON EL LADO NO AFECTADO"
  },
  {
    "codigo":706894000,
    "descripcion":"RETINOPATÍA DEBIDA A DIABETES MELLITUS TIPO 1 INESTABLE"
  },
  {
    "codigo":248142001,
    "descripcion":"SUCCIÓN DE ELEMENTOS"
  },
  {
    "codigo":315513008,
    "descripcion":"NACIDO EN SANTO TOMÉ Y PRÍNCIPE"
  },
  {
    "codigo":105971000119103,
    "descripcion":"MASA DE TEJIDO SUBCUTÁNEO DE DORSO"
  },
  {
    "codigo":870734006,
    "descripcion":"CUERDA VOCAL DE COLOR ROSA"
  },
  {
    "codigo":117070007,
    "descripcion":"DESTRUCCIÓN DE UNIDAD DE HEMODERIVADO"
  },
  {
    "codigo":1231182008,
    "descripcion":"OSTEOPOIQUILOSIS AISLADA"
  },
  {
    "codigo":1263950009,
    "descripcion":"OLIGURIA POSTERIOR A EMBARAZO ECTÓPICO"
  },
  {
    "codigo":705059000,
    "descripcion":"OSTEOMIELITIS DE REGIÓN ANTERIOR DEL PIE"
  },
  {
    "codigo":49699002,
    "descripcion":"VALVULOPATÍA TRICUSPÍDEA REUMÁTICA"
  },
  {
    "codigo":11820531000119103,
    "descripcion":"SUBLUXACIÓN POSTERIOR DE HOMBRO DERECHO"
  },
  {
    "codigo":1296718006,
    "descripcion":"HIPERTENSIÓN OCULAR DE OJO DERECHO DEBIDA A RETRACCIÓN DE ÁNGULO"
  },
  {
    "codigo":770595006,
    "descripcion":"SÍNDROME DEL CROMOSOMA 12 EN ANILLO"
  },
  {
    "codigo":1293048005,
    "descripcion":"DEPÓSITO DE CALCIO EN BOLSA SEROSA DE RODILLA"
  },
  {
    "codigo":703224006,
    "descripcion":"INSUFICIENCIA DE VÁLVULA MITRAL POSTERIOR A PROCEDIMIENTO"
  },
  {
    "codigo":47864008,
    "descripcion":"FRACTURA EXPUESTA DEL OMÓPLATO"
  },
  {
    "codigo":277240009,
    "descripcion":"ERITEMA SOBRE EL SENO MAXILAR"
  },
  {
    "codigo":15096009,
    "descripcion":"INSUFICIENCIA CONGÉNITA DE VÁLVULA PULMONAR"
  },
  {
    "codigo":111565003,
    "descripcion":"HIPERFUNCIÓN MEDULOADRENAL"
  },
  {
    "codigo":406477003,
    "descripcion":"EPISPADIAS MASCULINO"
  },
  {
    "codigo":275405009,
    "descripcion":"ATROFIA VELLOSA PARCIAL"
  },
  {
    "codigo":208034002,
    "descripcion":"FRACTURA VERTEBRAL NO EXPUESTA CON LESIÓN COMPLETA DE MÉDULA ESPINAL DORSAL, D7-12"
  },
  {
    "codigo":11426004,
    "descripcion":"AMILOIDOSIS GINGIVAL"
  },
  {
    "codigo":11794061000119103,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE DEDO GORDO IZQUIERDO CON INFECCIÓN"
  },
  {
    "codigo":240802005,
    "descripcion":"INFECCIÓN POR DUELA INTESTINAL"
  },
  {
    "codigo":765090007,
    "descripcion":"INTOXICACIÓN CAUSADA POR ÁCIDO MONOCLOROACÉTICO"
  },
  {
    "codigo":109730006,
    "descripcion":"RESTAURACIÓN DENTAL ESTÉTICAMENTE INADECUADA O DESAGRADABLE"
  },
  {
    "codigo":1156471001,
    "descripcion":"CARCINOMA DE PLEXO COROIDEO"
  },
  {
    "codigo":238967004,
    "descripcion":"TRASTORNO SENSORIAL PSICOGÉNICO DE LA PIEL"
  },
  {
    "codigo":1254775008,
    "descripcion":"RUPTURA TRAUMÁTICA DE TENDÓN DE REGIÓN DE TOBILLO"
  },
  {
    "codigo":402807009,
    "descripcion":"HIPOMELANOSIS CIRCUNSCRIPTA"
  },
  {
    "codigo":1351244000,
    "descripcion":"TRABAJO DE PARTO INTERRUMPIDO EN SEGUNDO ESTADIO"
  },
  {
    "codigo":237132003,
    "descripcion":"SANGRADO INTERMENSTRUAL - REGULAR"
  },
  {
    "codigo":269900004,
    "descripcion":"MATERIA FECAL: SANGRE PRESENTE"
  },
  {
    "codigo":1285708006,
    "descripcion":"CIERRE DE ÁNGULO CAUSADO POR FÁRMACO"
  },
  {
    "codigo":71457002,
    "descripcion":"DISFAGIA OROFARÍNGEA"
  },
  {
    "codigo":38689004,
    "descripcion":"ANEMIA HEMOLÍTICA ASOCIADA CON UNA INFECCIÓN"
  },
  {
    "codigo":366369009,
    "descripcion":"HALLAZGO RELACIONADO CON EL TAMAÑO DE LA CABEZA"
  },
  {
    "codigo":300833009,
    "descripcion":"NO REALIZA ACTIVIDADES DE BRICOLAJE"
  },
  {
    "codigo":167926003,
    "descripcion":"MÉDULA ÓSEA: CÉLULAS MIELOIDES NORMALES"
  },
  {
    "codigo":724982004,
    "descripcion":"LESIÓN TRAUMÁTICA DE TENDÓN DE MÚSCULO EXTENSOR A LA ALTURA DEL ANTEBRAZO"
  },
  {
    "codigo":298998004,
    "descripcion":"AMPLITUD DE SUPINACIÓN PASIVA DE LA MUÑECA NORMAL"
  },
  {
    "codigo":36854009,
    "descripcion":"ESTRECHEZ DE LA ENTRADA DE LA PELVIS"
  },
  {
    "codigo":2251002,
    "descripcion":"HIPOTONÍA PRIMARIA DEL OJO"
  },
  {
    "codigo":16027431000119104,
    "descripcion":"QUISTE ÓSEO DE AMBOS HÚMEROS"
  },
  {
    "codigo":67787004,
    "descripcion":"ANQUILOGLOSIA"
  },
  {
    "codigo":297163001,
    "descripcion":"VÁLVULA URETRAL CONGÉNITA"
  },
  {
    "codigo":35019008,
    "descripcion":"TRASTORNO DEL METABOLISMO DEL COBALTO"
  },
  {
    "codigo":723147008,
    "descripcion":"TRASTORNO AUTONÓMICO CONCOMITANTE CON ENFERMEDAD DE CHAGAS Y DEBIDO A ELLA"
  },
  {
    "codigo":295328001,
    "descripcion":"SOBREDOSIS DE MEDIO DE CONTRASTE PARA RESONANCIA MAGNÉTICA"
  },
  {
    "codigo":33184005,
    "descripcion":"ECOPRAXIA"
  },
  {
    "codigo":262560006,
    "descripcion":"HERIDA PENETRANTE"
  },
  {
    "codigo":197024006,
    "descripcion":"ENTEROCOLITIS ALÉRGICA"
  },
  {
    "codigo":459168005,
    "descripcion":"EMBARAZO GEMELAR MONOCORIÓNICO DIAMNIÓTICO"
  },
  {
    "codigo":195189003,
    "descripcion":"INFARTO CEREBRAL POR TROMBOSIS DE ARTERIAS CEREBRALES"
  },
  {
    "codigo":293493004,
    "descripcion":"REACCIÓN ADVERSA A LA DICLORFENAMIDA"
  },
  {
    "codigo":1145461004,
    "descripcion":"APLASIA DE MAXILAR INFERIOR"
  },
  {
    "codigo":719477003,
    "descripcion":"CAPAZ DE GIRAR EL CUERPO 360 GRADOS"
  },
  {
    "codigo":64117007,
    "descripcion":"HIPOVITAMINOSIS B12 (NO ANÉMICA)"
  },
  {
    "codigo":681921000119101,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE PARED POSTERIOR DE VEJIGA URINARIA"
  },
  {
    "codigo":422730001,
    "descripcion":"REPOSO\/SUEÑO INSUFICIENTE PARA EL ESTADO FÍSICO"
  },
  {
    "codigo":783178001,
    "descripcion":"DEFICIENCIA COMBINADA DE LA FOSFORILACIÓN OXIDATIVA TIPO 20"
  },
  {
    "codigo":226122007,
    "descripcion":"DIETA RICA EN CARBOHIDRATOS SIMPLES"
  },
  {
    "codigo":291658008,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR TETRACICLINA"
  },
  {
    "codigo":95050007,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA PIEL DE LA AXILA"
  },
  {
    "codigo":715807002,
    "descripcion":"ENFERMEDAD DE CREUTZFELDT-JAKOB FAMILIAR"
  },
  {
    "codigo":191519005,
    "descripcion":"DEMENCIA ASOCIADA CON OTRA ENFERMEDAD"
  },
  {
    "codigo":93215006,
    "descripcion":"MELANOMA MALIGNO DE PIEL DE MAMA"
  },
  {
    "codigo":60447007,
    "descripcion":"ANOMALÍA CONGÉNITA DE LA LENGUA"
  },
  {
    "codigo":11823041000119105,
    "descripcion":"AMPOLLA DE BRAZO IZQUIERDO CON INFECCIÓN"
  },
  {
    "codigo":289823008,
    "descripcion":"ALTERACIÓN DE LA COLORACIÓN DEL CUELLO UTERINO"
  },
  {
    "codigo":124148002,
    "descripcion":"DEFICIENCIA DE COLINA DESHIDROGENASA"
  },
  {
    "codigo":58612006,
    "descripcion":"INFARTO AGUDO DE MIOCARDIO DE PARED LATERAL"
  },
  {
    "codigo":1172724009,
    "descripcion":"TIEMPO DE LISIS DE EUGLOBULINA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":253385005,
    "descripcion":"ANOMALÍA DE CUERDAS TENDINOSAS DE VÁLVULA TRICÚSPIDE"
  },
  {
    "codigo":448158001,
    "descripcion":"ANOMALÍA DE AORTA TORACOABDOMINAL"
  },
  {
    "codigo":284318001,
    "descripcion":"CAPAZ DE MANIPULAR OBJETOS INTERRELACIONADOS"
  },
  {
    "codigo":54942004,
    "descripcion":"ESGUINCE DEL ESTERNÓN"
  },
  {
    "codigo":282483002,
    "descripcion":"CORRE SOBRE TERRENO PLANO"
  },
  {
    "codigo":249715003,
    "descripcion":"DEFORMIDAD ROTACIONAL DEL TRONCO"
  },
  {
    "codigo":1003379004,
    "descripcion":"OSTEOGÉNESIS IMPERFECTA TIPO 5"
  },
  {
    "codigo":184179006,
    "descripcion":"EL PACIENTE COMUNICA QUE ABANDONA LA LISTA"
  },
  {
    "codigo":870472000,
    "descripcion":"INGESTA INADECUADA DE VITAMINA D Y\/O DERIVADO DE VITAMINA D"
  },
  {
    "codigo":53107009,
    "descripcion":"DERMATITIS SUBAGUDA"
  },
  {
    "codigo":247880001,
    "descripcion":"PENSAMIENTOS OBSESIVOS ACERCA DE UNA ENFERMEDAD"
  },
  {
    "codigo":1263688008,
    "descripcion":"TRASTORNO NEONATAL PRECOZ DEBIDO A MALA PRESENTACIÓN DURANTE PARTO"
  },
  {
    "codigo":444488009,
    "descripcion":"ZONA ROSA EN LA ESTIMACIÓN DE PESO PEDIÁTRICO DE BROSELOW LUTEN"
  },
  {
    "codigo":18504008,
    "descripcion":"SÍNDROME DEL SHOCK TÓXICO"
  },
  {
    "codigo":1163549000,
    "descripcion":"ENCEFALITIS POR TRYPANOSOMA CRUZI"
  },
  {
    "codigo":213277004,
    "descripcion":"CUERPO EXTRAÑO DEJADO ACCIDENTALMENTE EN EL PACIENTE DURANTE LA CIRUGÍA"
  },
  {
    "codigo":49437008,
    "descripcion":"INFECCIÓN CAUSADA POR OCTOMITUS"
  },
  {
    "codigo":1260018001,
    "descripcion":"CARCINOMA ADENOIDE QUÍSTICO DE HIPOFARINGE"
  },
  {
    "codigo":735730006,
    "descripcion":"DIVERTÍCULO DE INTESTINO GRUESO SIN HEMORRAGIA"
  },
  {
    "codigo":209607007,
    "descripcion":"DESGARRO COMPLETO DEL PULGAR, ARTICULACIÓN METACARPOFALÁNGICA, LIGAMENTO LATERAL RADIAL"
  },
  {
    "codigo":11852021000119105,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DE DEDO GORDO DEL PIE IZQUIERDO"
  },
  {
    "codigo":111303009,
    "descripcion":"SÍNDROME DE SJÖGREN-LARSSON"
  },
  {
    "codigo":240540003,
    "descripcion":"VERRUGA PLANTAR EN MOSAICO"
  },
  {
    "codigo":402545000,
    "descripcion":"CARCINOMA BASOCELULAR RECIDIVANTE - SEGUNDA RECIDIVA"
  },
  {
    "codigo":11164009,
    "descripcion":"TRASTORNO HEREDITARIO DOMINANTE"
  },
  {
    "codigo":238705003,
    "descripcion":"HIPERMELANOSIS VULVOVAGINAL"
  },
  {
    "codigo":271473006,
    "descripcion":"NEOPLASIA BENIGNA DE BRONQUIO Y PULMÓN"
  },
  {
    "codigo":74865007,
    "descripcion":"COMPLICACIÓN DE DEDO REIMPLANTADO"
  },
  {
    "codigo":73030000,
    "descripcion":"NEFROPATÍA HIPERTENSIVA EN EL CONTEXTO OBSTÉTRICO"
  },
  {
    "codigo":369777009,
    "descripcion":"PUNTAJE DE GLEASON 8 -10: ESCASAMENTE DIFERENCIADO"
  },
  {
    "codigo":304241007,
    "descripcion":"SOLICITA EUTANASIA ACTIVA"
  },
  {
    "codigo":204102004,
    "descripcion":"SÍNDROME DE CRIPTOFTALMÍA"
  },
  {
    "codigo":366107002,
    "descripcion":"FUNCIÓN COCLEAR - HALLAZGO"
  },
  {
    "codigo":202267002,
    "descripcion":"CONTRACTURA EN ABDUCCIÓN DE HOMBRO"
  },
  {
    "codigo":235035004,
    "descripcion":"MORDEDURA DE LA MUCOSA ORAL"
  },
  {
    "codigo":169499002,
    "descripcion":"CAPUCHÓN VAGINAL - NO SE PRESENTÓ AL CONTROL"
  },
  {
    "codigo":890395002,
    "descripcion":"DISTROFIA MUSCULAR CONGÉNITA TIPO 1D POR MUTACIÓN DEL GEN LARGE"
  },
  {
    "codigo":16003471000119104,
    "descripcion":"ARTRITIS REACTIVA DE AMBAS ARTICULACIONES GLENOHUMERALES"
  },
  {
    "codigo":300571009,
    "descripcion":"HALLAZGO RELACIONADO CON EL SACO GESTACIONAL"
  },
  {
    "codigo":724720004,
    "descripcion":"TRASTORNO DEL ESTADO DE ÁNIMO CAUSADO POR DROGA DISOCIATIVA"
  },
  {
    "codigo":298736008,
    "descripcion":"MUESCAS COSTALES"
  },
  {
    "codigo":722885002,
    "descripcion":"DISQUECIA INFANTIL"
  },
  {
    "codigo":15731241000119101,
    "descripcion":"EDEMA DE DISCO ÓPTICO DE OJO IZQUIERDO DEBIDO A PRESIÓN INTRACRANEAL POR ENCIMA DE RANGO DE REFERENCIA"
  },
  {
    "codigo":11307561000119101,
    "descripcion":"FRACTURA NO EXPUESTA DE TECHO DE ACETÁBULO DERECHO"
  },
  {
    "codigo":427973005,
    "descripcion":"FÍSTULA DE ARTICULACIÓN DE LA RODILLA"
  },
  {
    "codigo":1148869006,
    "descripcion":"GLOMERULOPATÍA DEBIDA A ENFERMEDAD NEOPLÁSICA"
  },
  {
    "codigo":67525007,
    "descripcion":"PESTE NEUMÓNICA SECUNDARIA"
  },
  {
    "codigo":296901005,
    "descripcion":"SOBREDOSIS DE TESTOSTERONA"
  },
  {
    "codigo":1179802002,
    "descripcion":"IMAGEN ANORMAL EN RESONANCIA MAGNÉTICA DE CEREBRO CAUSADA POR PÉPTIDO BETA AMILOIDE CON EDEMA O DERRAME"
  },
  {
    "codigo":262298005,
    "descripcion":"CON LA PELÍCULA EN EL SURCO ALVEOLAR"
  },
  {
    "codigo":295066007,
    "descripcion":"ALERGIA A ALCALOIDE DEL CORNEZUELO"
  },
  {
    "codigo":424303008,
    "descripcion":"DESARROLLO DEL LENGUAJE - VOCALIZA SÍLABAS NO REDUPLICADAS"
  },
  {
    "codigo":782916003,
    "descripcion":"SÍNDROME DERMOTRÍQUICO"
  },
  {
    "codigo":1208900005,
    "descripcion":"SÍNDROME DE AUMENTO AGUDO IDIOPÁTICO DE MANCHA CIEGA"
  },
  {
    "codigo":94788006,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE VENTRÍCULO ENCEFÁLICO"
  },
  {
    "codigo":10871491000119100,
    "descripcion":"CISTOADENOMA SEROSO DE OVARIO IZQUIERDO"
  },
  {
    "codigo":225860008,
    "descripcion":"ES SEGURO QUE PERMANEZCA SIN ATENCIÓN POR BREVES PERÍODOS"
  },
  {
    "codigo":92953001,
    "descripcion":"FORMA ANORMAL CONGÉNITA DEL TIMO"
  },
  {
    "codigo":289561002,
    "descripcion":"SECRECIÓN VAGINAL MALOLIENTE"
  },
  {
    "codigo":1010457004,
    "descripcion":"BLOQUEO DE CONDUCCIÓN NERVIOSA MOTORA DERECHA"
  },
  {
    "codigo":123886001,
    "descripcion":"INTOXICACIÓN POR PRIMULACEAE"
  },
  {
    "codigo":254958004,
    "descripcion":"ADENOMA CORTICOTRÓFICO"
  },
  {
    "codigo":25582006,
    "descripcion":"ENFERMEDAD POR EL VIRUS ORIBOCA"
  },
  {
    "codigo":56515006,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA VENA CAVA INFERIOR"
  },
  {
    "codigo":449731009,
    "descripcion":"SÍNDROME AUTOINMUNITARIO POLIGLANDULAR, TIPO 3"
  },
  {
    "codigo":139971000119106,
    "descripcion":"TROMBOSIS DE INJERTO DE ARTERIA CORONARIA"
  },
  {
    "codigo":52845002,
    "descripcion":"NEFRITIS"
  },
  {
    "codigo":249453009,
    "descripcion":"ADUCCIÓN ALTERADA DE LA CUERDA VOCAL DURANTE LA FONACIÓN"
  },
  {
    "codigo":247618004,
    "descripcion":"EVALUACIÓN DE LA MEMORIA - HALLAZGO"
  },
  {
    "codigo":313154006,
    "descripcion":"ESOTROPÍA PARA LA VISIÓN CERCANA"
  },
  {
    "codigo":51010007,
    "descripcion":"VÓLVULO ORGANOAXIAL CONGÉNITO DE ESTÓMAGO"
  },
  {
    "codigo":737303004,
    "descripcion":"AUSENCIA ADQUIRIDA DE ÓRGANO"
  },
  {
    "codigo":409623005,
    "descripcion":"INSUFICIENCIA RESPIRATORIA"
  },
  {
    "codigo":278551006,
    "descripcion":"INCRUSTACIÓN DENTAL PRESENTE"
  },
  {
    "codigo":1163287007,
    "descripcion":"EMOCIÓN POSITIVA ACERCA DE LOS ALIMENTOS Y\/O LA NUTRICIÓN"
  },
  {
    "codigo":213015009,
    "descripcion":"SÍNDROMES DE MALTRATO"
  },
  {
    "codigo":1259756001,
    "descripcion":"MEDULOEPITELIOMA PRIMARIO"
  },
  {
    "codigo":47340003,
    "descripcion":"PESO AL NACER"
  },
  {
    "codigo":276716007,
    "descripcion":"LACTANTE QUE NO TOLERA LA ALIMENTACIÓN"
  },
  {
    "codigo":209345000,
    "descripcion":"FRACTURA-LUXACIÓN EXPUESTA DE ARTICULACIÓN FEMORORROTULIANA"
  },
  {
    "codigo":735468009,
    "descripcion":"URTICARIA POR CONTACTO CAUSADA POR ALIMENTO"
  },
  {
    "codigo":45505004,
    "descripcion":"FACTOR PSICOSOMÁTICO EN UNA ENFERMEDAD FÍSICA, COMPONENTE PSICOLÓGICO IMPORTANTE"
  },
  {
    "codigo":405953006,
    "descripcion":"AUSENCIA DE ANAPLASIA"
  },
  {
    "codigo":307649006,
    "descripcion":"MICROGLIOMA"
  },
  {
    "codigo":371350001,
    "descripcion":"HALLAZGO RELACIONADO CON LA TOLERANCIA"
  },
  {
    "codigo":1256086002,
    "descripcion":"DERMATOSIS TÓXICA OCUPACIONAL"
  },
  {
    "codigo":305814002,
    "descripcion":"VISTO POR EL SERVICIO DE GENÉTICA"
  },
  {
    "codigo":895638008,
    "descripcion":"FORMA TRIANGULAR ANORMAL CONGÉNITA DE FALANGE DE DEDO GORDO"
  },
  {
    "codigo":699030008,
    "descripcion":"CONSCIENCIA BAJO ANESTESIA GENERAL"
  },
  {
    "codigo":9067002,
    "descripcion":"EDEMA DE PARTES BLANDAS DE LA CAVIDAD BUCAL"
  },
  {
    "codigo":404118008,
    "descripcion":"MICOSIS FUNGOIDE SIRINGOTRÓFICA"
  },
  {
    "codigo":369515005,
    "descripcion":"NEOPLASIA MALIGNA QUE COMPROMETE LA TROMPA DE FALOPIO IZQUIERDA POR PROPAGACIÓN DIRECTA DESDE ENDOMETRIO"
  },
  {
    "codigo":41835006,
    "descripcion":"REACCIÓN DE DESNERVACIÓN POR ELECTROMIOGRAMA"
  },
  {
    "codigo":205675007,
    "descripcion":"INDIVIDUO CON HETEROCROMATINA MARCADORA"
  },
  {
    "codigo":15979511000119105,
    "descripcion":"HIPOPLASIA CONGÉNITA DE HUESO CIGOMÁTICO DERECHO"
  },
  {
    "codigo":236608000,
    "descripcion":"EXTRAVASACIÓN DE ORINA DESDE URÉTER"
  },
  {
    "codigo":1186880002,
    "descripcion":"DEMENCIA DEBIDA A DEFICIENCIA DE COBALAMINA"
  },
  {
    "codigo":1119509000,
    "descripcion":"AGOTAMIENTO MUSCULAR FATIGABLE DE MÚSCULO DE PIERNA"
  },
  {
    "codigo":105536009,
    "descripcion":"VIVIENDA SIN ELECTRICIDAD"
  },
  {
    "codigo":70933002,
    "descripcion":"AORTITIS"
  },
  {
    "codigo":10955921000119101,
    "descripcion":"HERIDA PUNZANTE DE DEDO MEÑIQUE DERECHO"
  },
  {
    "codigo":202005004,
    "descripcion":"ARTROPATÍA TRANSITORIA DE ARTICULACIÓN INTERFALÁNGICA PROXIMAL DE DEDO DE LA MANO"
  },
  {
    "codigo":2360001000004109,
    "descripcion":"ASMA DEPENDIENTE DE ESTEROIDES"
  },
  {
    "codigo":365845005,
    "descripcion":"HEMOGLOBINA A1C - CONTROL DE DIABETES - HALLAZGO"
  },
  {
    "codigo":5397007,
    "descripcion":"ANOMALÍA CONGÉNITA DE LA PELVIS RENAL"
  },
  {
    "codigo":300309008,
    "descripcion":"APÉNDICE ILEOCECAL AUSENTE"
  },
  {
    "codigo":724458001,
    "descripcion":"ANOMALÍA ADQUIRIDA DEL CUELLO UTERINO"
  },
  {
    "codigo":69098002,
    "descripcion":"PARÁLISIS DEL COLON"
  },
  {
    "codigo":298474004,
    "descripcion":"CUELLO INESTABLE"
  },
  {
    "codigo":10900471000119109,
    "descripcion":"LACERACIÓN DEL GLOBO OCULAR IZQUIERDO"
  },
  {
    "codigo":394943000,
    "descripcion":"ESTADIO D DE DUKES"
  },
  {
    "codigo":396778009,
    "descripcion":"MARGEN QUIRÚRGICO DE CORDÓN ESPERMÁTICO NO COMPROMETIDO POR TUMOR"
  },
  {
    "codigo":296639000,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE DERIVADO DEL NITROFURANO"
  },
  {
    "codigo":788159003,
    "descripcion":"CLIENTE DE PROSTITUTAS"
  },
  {
    "codigo":1148607008,
    "descripcion":"ELECTRORRETINOGRAMA DE CAMPO COMPLETO ANORMAL"
  },
  {
    "codigo":196500001,
    "descripcion":"SIALOLITIASIS DE GLÁNDULA SUBMAXILAR"
  },
  {
    "codigo":722623009,
    "descripcion":"HEMORRAGIA TRAUMÁTICA FOCAL DE TRONCO ENCEFÁLICO"
  },
  {
    "codigo":294804001,
    "descripcion":"ALERGIA A TIROXINA"
  },
  {
    "codigo":1279679008,
    "descripcion":"INFECCIÓN CAUSADA POR BORRELIA HERMSII"
  },
  {
    "codigo":689451000119100,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE ÚVULA"
  },
  {
    "codigo":130964008,
    "descripcion":"SÍNDROME DE INTERPRETACIÓN AMBIENTAL ERRÓNEA"
  },
  {
    "codigo":129129003,
    "descripcion":"PERITONITIS INFECCIOSA"
  },
  {
    "codigo":1144937005,
    "descripcion":"ADHERENCIAS DENSAS DE FONDO DE SACO DE DOUGLAS DEBIDAS A ENDOMETRIOSIS"
  },
  {
    "codigo":292969006,
    "descripcion":"REACCIÓN ADVERSA A LA CICLACILINA"
  },
  {
    "codigo":63593006,
    "descripcion":"LATIDOS SUPRAVENTRICULARES PREMATUROS"
  },
  {
    "codigo":127294003,
    "descripcion":"LESIÓN TRAUMÁTICA O NO TRAUMÁTICA DE CEREBRO"
  },
  {
    "codigo":94526005,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA REGIÓN SACROCOCCÍGEA"
  },
  {
    "codigo":291134005,
    "descripcion":"INTOXICACIÓN POR RISPERIDONA"
  },
  {
    "codigo":61758007,
    "descripcion":"SECUENCIA DE EXTROFIA VESICAL"
  },
  {
    "codigo":387603000,
    "descripcion":"ALTERACIÓN DEL EQUILIBRIO"
  },
  {
    "codigo":59923000,
    "descripcion":"TRASTORNO DE PÁNICO CON AGORAFOBIA Y ATAQUES DE PÁNICO EN REMISIÓN TOTAL"
  },
  {
    "codigo":780819002,
    "descripcion":"QUISTE CONGÉNITO DE PABELLÓN AURICULAR"
  },
  {
    "codigo":190995003,
    "descripcion":"APLASIA O DISPLASIA TÍMICA CON INMUNODEFICIENCIA"
  },
  {
    "codigo":92691004,
    "descripcion":"CARCINOMA IN SITU DE LA PRÓSTATA"
  },
  {
    "codigo":289299005,
    "descripcion":"CORDÓN UMBILICAL - HALLAZGO"
  },
  {
    "codigo":1099051000119104,
    "descripcion":"OPACIDAD DE CÓRNEA DE OJO DERECHO"
  },
  {
    "codigo":254696000,
    "descripcion":"HAMARTOMA EPITELIAL DESMOPLÁSICO"
  },
  {
    "codigo":37831000087106,
    "descripcion":"AEROMONAS SALMONICIDA SUBESPECIE ACHROMOGENES O AEROMONAS SALMONICIDA SUBESPECIE MASOUCIDA"
  },
  {
    "codigo":42951000087106,
    "descripcion":"QUEMADURA DE DEDO ANULAR IZQUIERDO"
  },
  {
    "codigo":713448008,
    "descripcion":"CONOCIMIENTO DEFICIENTE DE LA ALIMENTACIÓN DEL LACTANTE"
  },
  {
    "codigo":56253000,
    "descripcion":"PARAPSORIASIS EN PLACAS"
  },
  {
    "codigo":285629002,
    "descripcion":"INCAPAZ DE DECIR LA HORA"
  },
  {
    "codigo":89021008,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO, SIN INFECCIÓN"
  },
  {
    "codigo":1137597009,
    "descripcion":"BERMELLÓN DE LABIO INFERIOR GRUESO"
  },
  {
    "codigo":871783000,
    "descripcion":"REACCIÓN ADVERSA A ARSÉNICO Y\/O COMPUESTO DE ARSÉNICO"
  },
  {
    "codigo":183655000,
    "descripcion":"SEGUIMIENTO DE TRASPLANTE"
  },
  {
    "codigo":283794008,
    "descripcion":"MORDEDURA DE ANIMAL EN LA REGIÓN OCULAR"
  },
  {
    "codigo":335301000119106,
    "descripcion":"ENOFTALMOS DE OJO DERECHO DEBIDO A ATROFIA DE TEJIDO ORBITARIO"
  },
  {
    "codigo":1098281000000102,
    "descripcion":"INFECCIÓN CAUSADA POR PSEUDOMONAS AERUGINOSA, CEPA EPIDÉMICA LIVERPOOL"
  },
  {
    "codigo":704273008,
    "descripcion":"CONSENTIMIENTO PARA EXAMEN DEL SISTEMA CARDIOVASCULAR REHUSADO"
  },
  {
    "codigo":14310000,
    "descripcion":"SECRECIÓN NASAL PURULENTA"
  },
  {
    "codigo":81681009,
    "descripcion":"EXTRASÍSTOLE DE LA UNIÓN AURICULOVENTRICULAR"
  },
  {
    "codigo":1259494002,
    "descripcion":"DEMENCIA DEBIDA A LEUCODISTROFIA"
  },
  {
    "codigo":735206008,
    "descripcion":"HIDROCEFALIA COMUNICANTE DEBIDA A HEMORRAGIA TRAUMÁTICA Y POSTERIOR A ELLA"
  },
  {
    "codigo":1357798008,
    "descripcion":"LESIÓN TRAUMÁTICA DE OJO DEBIDA A TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":78011002,
    "descripcion":"TÓRAX INESTABLE"
  },
  {
    "codigo":241851001,
    "descripcion":"EFECTO TÓXICO CAUSADO POR LUSTRADOR DE METALES"
  },
  {
    "codigo":733371004,
    "descripcion":"HERIDA ABIERTA DE ABDOMEN"
  },
  {
    "codigo":403856000,
    "descripcion":"HEMANGIOMA PLANO EN EL SÍNDROME DE PROTEUS"
  },
  {
    "codigo":209083008,
    "descripcion":"LUXACIÓN VERTEBRAL NO EXPUESTA CON LESIÓN MEDULAR ANTERIOR A NIVEL LUMBAR"
  },
  {
    "codigo":43408002,
    "descripcion":"REFLEJO ROJO"
  },
  {
    "codigo":305552005,
    "descripcion":"BAJO ATENCIÓN DE URÓLOGO"
  },
  {
    "codigo":371088008,
    "descripcion":"SÍNDROME DE DISFUNCIÓN REACTIVA DE LA VÍAS AÉREAS"
  },
  {
    "codigo":762469001,
    "descripcion":"QUEMADURA COMPLEJA DE CUELLO"
  },
  {
    "codigo":74341002,
    "descripcion":"ÚLCERA GÁSTRICA CRÓNICA CON HEMORRAGIA Y PERFORACIÓN PERO SIN OBSTRUCCIÓN"
  },
  {
    "codigo":698768009,
    "descripcion":"INTERFERENCIA OCLUSAL FUNCIONAL EN EL ÁREA DE TRABAJO"
  },
  {
    "codigo":860773007,
    "descripcion":"ALERGIA A TRIAZENO"
  },
  {
    "codigo":203578000,
    "descripcion":"CONTRACTURA DE FLEXIÓN PLANTAR DE LA ARTICULACIÓN TARSOMETATARSIANA"
  },
  {
    "codigo":400186008,
    "descripcion":"NEOPLASIA DEL APARATO TEGUMENTARIO"
  },
  {
    "codigo":726031001,
    "descripcion":"SÍNDROME DE ATAXIA CEREBELOSA, DISCAPACIDAD INTELECTUAL, ATROFIA ÓPTICA Y ANOMALÍAS CUTÁNEAS"
  },
  {
    "codigo":15683321000119104,
    "descripcion":"BURSITIS DE AMBAS RODILLAS"
  },
  {
    "codigo":365583004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA RECONOCER EL ENTORNO"
  },
  {
    "codigo":234511009,
    "descripcion":"TRASTORNO POSESPLENECTOMÍA"
  },
  {
    "codigo":396516002,
    "descripcion":"MARGEN QUIRÚRGICO PROFUNDO NO COMPROMETIDO POR MELANOMA MALIGNO"
  },
  {
    "codigo":298212005,
    "descripcion":"LAXITUD DE ARTICULACIÓN DE DEDO DE MANO"
  },
  {
    "codigo":296377002,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE METARAMINOL"
  },
  {
    "codigo":165305005,
    "descripcion":"MEMORIA: NO PUEDE CONTAR AL REVÉS"
  },
  {
    "codigo":294542001,
    "descripcion":"ALERGIA A CEFUROXIMA"
  },
  {
    "codigo":32398004,
    "descripcion":"BRONQUITIS"
  },
  {
    "codigo":786062006,
    "descripcion":"BLEFAROCONJUNTIVITIS ANGULAR DE OJO DERECHO"
  },
  {
    "codigo":292707001,
    "descripcion":"REACCIÓN ADVERSA AL OCTOXINOL"
  },
  {
    "codigo":10823571000119104,
    "descripcion":"FRACTURA EXPUESTA EN MARTILLO DE FALANGE DISTAL DE DEDO ANULAR DE MANO IZQUIERDA"
  },
  {
    "codigo":816995008,
    "descripcion":"PIEL ÁSPERA"
  },
  {
    "codigo":718691008,
    "descripcion":"CRIPTOFTALMOS AISLADO"
  },
  {
    "codigo":782392005,
    "descripcion":"NÓDULO DE PIEL DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":290872005,
    "descripcion":"INTOXICACIÓN POR TRANILCIPROMINA"
  },
  {
    "codigo":456991000124103,
    "descripcion":"LESIÓN DE PIEL DE MAMA"
  },
  {
    "codigo":94264008,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE PARTES BLANDAS"
  },
  {
    "codigo":127032009,
    "descripcion":"NEOPLASIA DEL CUERPO COCCÍGEO"
  },
  {
    "codigo":92429000,
    "descripcion":"NEOPLASIA BENIGNA DEL MESENTERIO"
  },
  {
    "codigo":289037000,
    "descripcion":"INCAPAZ DE ALIMENTARSE CON LA MANO DERECHA"
  },
  {
    "codigo":420109006,
    "descripcion":"HALLAZGO RELACIONADO CON LA CLASIFICACIÓN DE HERIDAS DEL CDC"
  },
  {
    "codigo":188898001,
    "descripcion":"NEOPLASIA BENIGNA DEL MEDIASTINO ANTEROINFERIOR"
  },
  {
    "codigo":1237474005,
    "descripcion":"METÁSTASIS DE CARCINOMA DE HUESO DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":416439000,
    "descripcion":"LIPOGRANULOMA"
  },
  {
    "codigo":713186008,
    "descripcion":"GASTROENTERITIS CAUSADA POR FÁRMACO"
  },
  {
    "codigo":254434008,
    "descripcion":"CARCINOMA DEL PALADAR DURO"
  },
  {
    "codigo":12107821000119104,
    "descripcion":"QUEMADURA DE REGIÓN ESCAPULAR IZQUIERDA"
  },
  {
    "codigo":449207003,
    "descripcion":"SARCOMA DE HÚMERO"
  },
  {
    "codigo":447372001,
    "descripcion":"INFECCIÓN DE RECTO CAUSADA POR CHLAMYDIA TRACHOMATIS"
  },
  {
    "codigo":185228002,
    "descripcion":"ATENDIDO EN CONSULTORIO CARDIOLÓGICO"
  },
  {
    "codigo":283532006,
    "descripcion":"HERIDA PUNZANTE DE GLÚTEO"
  },
  {
    "codigo":840588006,
    "descripcion":"INFECCIÓN CAUSADA POR ACINETOBACTER"
  },
  {
    "codigo":414604009,
    "descripcion":"LEUCOPLASIA DE LENGUA ASOCIADA A ENFERMEDAD POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":871521003,
    "descripcion":"REACCIÓN ADVERSA A ESTRÓGENO Y\/O PROGESTERONA"
  },
  {
    "codigo":445537004,
    "descripcion":"FRACTURA PATOLÓGICA DE RADIO DISTAL"
  },
  {
    "codigo":412769006,
    "descripcion":"VIVE EN UNIDAD MATERNOINFANTIL"
  },
  {
    "codigo":609377007,
    "descripcion":"DEFORMIDAD ANGULADA DE PIERNA"
  },
  {
    "codigo":17718000,
    "descripcion":"DEFECTO DEL OSTIUM PRIMUM"
  },
  {
    "codigo":707681007,
    "descripcion":"HIPOPLASIA LOCALIZADA DE DIENTE"
  },
  {
    "codigo":247094004,
    "descripcion":"GAS EN LA CAVIDAD DEL VÍTREO"
  },
  {
    "codigo":1197366007,
    "descripcion":"INMUNODEFICIENCIA PRIMARIA AUTOSÓMICA RECESIVA CON DEFECTO DE CITOTOXICIDAD ESPONTÁNEA DE CÉLULAS NATURAL KILLER"
  },
  {
    "codigo":212491000,
    "descripcion":"MÚLTIPLES HERIDAS ABIERTAS EN PIERNA"
  },
  {
    "codigo":1162763003,
    "descripcion":"MIGRACIÓN DEL CATÉTER PARA COLECISTOSTOMÍA PERCUTÁNEA"
  },
  {
    "codigo":441867005,
    "descripcion":"YA NO MANEJA UN AUTOMÓVIL"
  },
  {
    "codigo":278027007,
    "descripcion":"LESIÓN NEUROLÓGICA POR IMPACTO DE UN RAYO"
  },
  {
    "codigo":704011008,
    "descripcion":"FRACTURA EXPUESTA DE FALANGE DE DEDO ÍNDICE"
  },
  {
    "codigo":472800001,
    "descripcion":"ESTENOSIS SUBPULMONAR ADQUIRIDA DEBIDA A DEFECTO VENTRICULAR RESTRICTIVO ASOCIADA CON CORAZÓN FUNCIONALMENTE UNIVENTRICULAR"
  },
  {
    "codigo":79584002,
    "descripcion":"TRASTORNO BIPOLAR MODERADO"
  },
  {
    "codigo":284871000119105,
    "descripcion":"ATEROSCLEROSIS DE ARTERIA CARÓTIDA IZQUIERDA"
  },
  {
    "codigo":1259232004,
    "descripcion":"MODIFICACIÓN DE CURSO DE RADIOTERAPIA DEBIDO A CAMBIO EN ÓRGANO EN RIESGO"
  },
  {
    "codigo":767712006,
    "descripcion":"DEFICIENCIA DE FACTOR IX"
  },
  {
    "codigo":307125007,
    "descripcion":"CAPAZ DE ESCRIBIR"
  },
  {
    "codigo":896949007,
    "descripcion":"FORMA DE BALA ANORMAL CONGÉNITA DE FALANGE DISTAL DE PIE"
  },
  {
    "codigo":700341007,
    "descripcion":"DERMATITIS ALÉRGICA POR CONTACTO DE PÁRPADO INFERIOR"
  },
  {
    "codigo":239754004,
    "descripcion":"LUXACIÓN ARTICULAR IRREDUCTIBLE"
  },
  {
    "codigo":403594005,
    "descripcion":"HORMIGUEO PSICÓGENO"
  },
  {
    "codigo":11835591000119109,
    "descripcion":"SUBLUXACIÓN DE ARTICULACIÓN METATARSOFALÁNGICA DE DEDO (SEGUNDO A QUINTO) DE PIE DERECHO"
  },
  {
    "codigo":237919007,
    "descripcion":"ALBINISMO OCULOCUTÁNEO PIGMENTARIO MÍNIMO"
  },
  {
    "codigo":8543007,
    "descripcion":"ESTRECHEZ DE COLON"
  },
  {
    "codigo":399924003,
    "descripcion":"AMEBIASIS PERIANAL"
  },
  {
    "codigo":340321000119106,
    "descripcion":"OFTALMOPLEJÍA INTERNA TOTAL IZQUIERDA"
  },
  {
    "codigo":39476006,
    "descripcion":"ESTRECHEZ CONGÉNITA DE RECTO"
  },
  {
    "codigo":301620007,
    "descripcion":"INCAPAZ DE UTILIZAR ASCENSOR"
  },
  {
    "codigo":4873000,
    "descripcion":"VASCULARIZACIÓN LOCALIZADA DE LA CÓRNEA"
  },
  {
    "codigo":365321003,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD DE LUSTRAR"
  },
  {
    "codigo":398089004,
    "descripcion":"ANTECEDENTES ÉTNICOS"
  },
  {
    "codigo":201481004,
    "descripcion":"ARTRITIS REACTIVA DE MÚLTIPLES LOCALIZACIONES DEBIDA A ENFERMEDAD INFECCIOSA TRANSMITIDA POR VÍA SEXUAL Y POSTERIOR A ELLA"
  },
  {
    "codigo":299785005,
    "descripcion":"REFLEJO DE OJOS DE MUÑECA HORIZONTAL DUDOSO"
  },
  {
    "codigo":297950006,
    "descripcion":"HALLAZGO RELACIONADO CON UNA CONTUSIÓN"
  },
  {
    "codigo":68574006,
    "descripcion":"CEGUERA CORTICAL"
  },
  {
    "codigo":363486007,
    "descripcion":"NEOPLASIA MALIGNA DE CUERDAS VOCALES"
  },
  {
    "codigo":165043001,
    "descripcion":"RELACIÓN VEF1\/CVF NORMAL"
  },
  {
    "codigo":3038009,
    "descripcion":"LINFANGITIS AGUDA DEL OMBLIGO"
  },
  {
    "codigo":722099004,
    "descripcion":"ONICOCLASIA"
  },
  {
    "codigo":345441000119100,
    "descripcion":"GRANULOMA DE AMBOS SACOS LAGRIMALES"
  },
  {
    "codigo":880529761000119102,
    "descripcion":"INFECCIÓN DEL TRACTO RESPIRATORIO INFERIOR CAUSADA POR SARS-COV-2"
  },
  {
    "codigo":135521000119103,
    "descripcion":"MASA DE URETRA"
  },
  {
    "codigo":15633761000119102,
    "descripcion":"TUMEFACCIÓN DE AMBAS EXTREMIDADES SUPERIORES"
  },
  {
    "codigo":15677281000119105,
    "descripcion":"MIOSITIS DE AMBAS PIERNAS"
  },
  {
    "codigo":230579006,
    "descripcion":"RADICULOPATÍA DORSAL DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":294280001,
    "descripcion":"ALERGIA A ARCILLA DE BATÁN"
  },
  {
    "codigo":15741281000119105,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE REGIÓN DE PELVIS DERECHA"
  },
  {
    "codigo":291681000119108,
    "descripcion":"DISFAGIA DEBIDA A HEMORRAGIA SUBARACNOIDEA NO TRAUMÁTICA Y POSTERIOR A ELLA"
  },
  {
    "codigo":12198241000119109,
    "descripcion":"POSICIÓN ANÓMALA DE DISPOSITIVO ANTICONCEPTIVO INTRAUTERINO"
  },
  {
    "codigo":289566561000119108,
    "descripcion":"ISQUEMIA AGUDA DE INTESTINO DELGADO DEBIDA A TROMBOSIS DE VENA MESENTÉRICA"
  },
  {
    "codigo":89441000119109,
    "descripcion":"VENTRICULITIS CEREBRAL"
  },
  {
    "codigo":292445001,
    "descripcion":"REACCIÓN ADVERSA A LA DOXAZOSINA"
  },
  {
    "codigo":15723361000119107,
    "descripcion":"GANGLIÓN DE AMBOS CODOS"
  },
  {
    "codigo":128605003,
    "descripcion":"TRASTORNO DE EXTREMIDAD"
  },
  {
    "codigo":17761000119109,
    "descripcion":"MIELOMENINGOCELE LUMBAR ALTO"
  },
  {
    "codigo":350561000119109,
    "descripcion":"TEMBLOR RUBRAL"
  },
  {
    "codigo":11778401000119109,
    "descripcion":"DISTENSIÓN DE TENDÓN DE MÚSCULO TRAPECIO IZQUIERDO"
  },
  {
    "codigo":95837007,
    "descripcion":"CIANOSIS CENTRAL"
  },
  {
    "codigo":94002000,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL TABIQUE NASAL"
  },
  {
    "codigo":716594002,
    "descripcion":"GONADOBLASTOMA DE OVARIO"
  },
  {
    "codigo":15632891000119109,
    "descripcion":"ATROFIA ÓPTICA DE AMBOS OJOS"
  },
  {
    "codigo":15934101000119103,
    "descripcion":"HALLUX RÍGIDO ADQUIRIDO BILATERAL"
  },
  {
    "codigo":28466007,
    "descripcion":"OSTEOCONDROSIS JUVENIL DEL SEGUNDO HUESO METATARSIANO"
  },
  {
    "codigo":126770008,
    "descripcion":"NEOPLASIA DE LABIO"
  },
  {
    "codigo":290610008,
    "descripcion":"INTOXICACIÓN POR MELFALÁN"
  },
  {
    "codigo":59399004,
    "descripcion":"CUTIS LAXA, LIGADO AL CROMOSOMA X"
  },
  {
    "codigo":190471009,
    "descripcion":"PANHIPOPITUITARISMO POSTRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":92167009,
    "descripcion":"NEOPLASIA BENIGNA DE LABIOS MENORES VULVARES"
  },
  {
    "codigo":1237212004,
    "descripcion":"MASA QUE OCUPA PARTE DE CUADRANTE INFERIOR IZQUIERDO DE ABDOMEN"
  },
  {
    "codigo":342831000119100,
    "descripcion":"CATARATA CONGÉNITA, FORMA COMBINADA"
  },
  {
    "codigo":414342007,
    "descripcion":"QUISTE GINGIVAL DEL RECIÉN NACIDO"
  },
  {
    "codigo":447110008,
    "descripcion":"LACERACIÓN DE ARTERIA CUBITAL"
  },
  {
    "codigo":283270009,
    "descripcion":"VIDRIO EN PANTORRILLA"
  },
  {
    "codigo":281435002,
    "descripcion":"RECHAZO DE INJERTO ÓSEO"
  },
  {
    "codigo":445275003,
    "descripcion":"DEFICIENCIA DE SUCCINATO-COA LIGASA"
  },
  {
    "codigo":248667004,
    "descripcion":"TERCER RUIDO AGUDO PREMATURO"
  },
  {
    "codigo":1264475006,
    "descripcion":"VÍA DE ADMINISTRACIÓN DE MEDICACIÓN INADECUADA PARA PACIENTE"
  },
  {
    "codigo":17456000,
    "descripcion":"ESTADIO DE BRESLOW, PROFUNDIDAD DE 0,76 A 1,75 MM"
  },
  {
    "codigo":1231707009,
    "descripcion":"QUISTE ORBITARIO POR PARÁSITO"
  },
  {
    "codigo":1297243009,
    "descripcion":"TRASTORNO DE TENDÓN DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":707419009,
    "descripcion":"OSTEOPOROSIS DEBIDA A FIBROSIS QUÍSTICA"
  },
  {
    "codigo":1229872004,
    "descripcion":"SÍNDROME DE MICRODUPLICACIÓN XQ25"
  },
  {
    "codigo":82992005,
    "descripcion":"SIGNO DE WILSON"
  },
  {
    "codigo":115760004,
    "descripcion":"FENOTIPO DE GRUPO SANGUÍNEO X^O^RX^O^R"
  },
  {
    "codigo":736517000,
    "descripcion":"FRACTURA POR AVULSIÓN DE PERONÉ ANTERIOR"
  },
  {
    "codigo":1162501001,
    "descripcion":"DIENTES NATALES"
  },
  {
    "codigo":212229008,
    "descripcion":"CONTUSIÓN, PLEXO BRAQUIAL, RAÍCES INFERIORES"
  },
  {
    "codigo":15717321000119102,
    "descripcion":"OSTEOCONDRITIS DISECANTE DE HUESO DE AMBAS REGIONES DE MUÑECA"
  },
  {
    "codigo":308698004,
    "descripcion":"SÍNTOMA DE FLATULENCIA"
  },
  {
    "codigo":112090005,
    "descripcion":"IMÁGENES EIDÉTICAS"
  },
  {
    "codigo":1258970004,
    "descripcion":"ESGUINCE DE LIGAMENTO DE ARTICULACIÓN INTERFALÁNGICA DISTAL DE DEDO DE MANO"
  },
  {
    "codigo":110255000,
    "descripcion":"CONTUSIÓN DEL PISO DE LA BOCA"
  },
  {
    "codigo":16290761000119104,
    "descripcion":"VÍCTIMA DE TRATA DE PERSONAS EN ADULTEZ"
  },
  {
    "codigo":208559003,
    "descripcion":"FRACTURA EXPUESTA DE FÉMUR PROXIMAL, INTERTROCANTÉREA, CONMINUTA"
  },
  {
    "codigo":11785161000119104,
    "descripcion":"AMPOLLA TRAUMÁTICA DE DEDO ÍNDICE DE MANO DERECHA"
  },
  {
    "codigo":700079006,
    "descripcion":"TRASTORNO DEL PERINEO FEMENINO"
  },
  {
    "codigo":370564005,
    "descripcion":"AGRESIÓN DURANTE EL JUEGO"
  },
  {
    "codigo":403332007,
    "descripcion":"ALOPECIA POR USO DE CEPILLO REDONDO"
  },
  {
    "codigo":75652008,
    "descripcion":"IMINOGLICINURIA RENAL FAMILIAR"
  },
  {
    "codigo":73817000,
    "descripcion":"ENTERITIS CAUSADA POR RADIACIÓN"
  },
  {
    "codigo":8281003,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA ARTERIA UTERINA"
  },
  {
    "codigo":41049003,
    "descripcion":"HOLOACARDIO AMORFO"
  },
  {
    "codigo":59272004,
    "descripcion":"PARASÍSTOLE VENTRICULAR"
  },
  {
    "codigo":192801891000119102,
    "descripcion":"LACERACIÓN DE MÚSCULO INTRÍNSECO DE DEDO MEDIO DE MANO"
  },
  {
    "codigo":301358001,
    "descripcion":"DOLOR DE ESTRUCTURA CARDIOVASCULAR"
  },
  {
    "codigo":204889008,
    "descripcion":"HIPOSPADIAS PENOESCROTAL"
  },
  {
    "codigo":399662003,
    "descripcion":"COMPROMISO TUMORAL DE MARGEN EPIPLOICO, NO PUEDE SER EVALUADO"
  },
  {
    "codigo":233987000,
    "descripcion":"ANEURISMA DE LA ARTERIA FEMORAL SUPERFICIAL"
  },
  {
    "codigo":170286009,
    "descripcion":"EXAMEN ANORMAL DE NIÑO DE 3 AÑOS DE EDAD - PARA OBSERVACIÓN"
  },
  {
    "codigo":235822009,
    "descripcion":"OBSTRUCCIÓN INTESTINAL MECÁNICA POSQUIRÚRGICA"
  },
  {
    "codigo":299523003,
    "descripcion":"ARTICULACIÓN DEL PIE - FRÍA"
  },
  {
    "codigo":397827003,
    "descripcion":"DEFICIENCIA DE SOMATOTROFINA"
  },
  {
    "codigo":365059004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA SUMARSE A UNA CONVERSACIÓN"
  },
  {
    "codigo":70147002,
    "descripcion":"VIVIR EN UNA CASA - REMOLQUE"
  },
  {
    "codigo":311816000,
    "descripcion":"FRACTURAS MÚLTIPLES NO EXPUESTAS DE CLAVÍCULA Y\/U OMÓPLATO Y\/O HÚMERO"
  },
  {
    "codigo":2776000,
    "descripcion":"DELIRIO"
  },
  {
    "codigo":201219009,
    "descripcion":"ACNÉ INFANTIL"
  },
  {
    "codigo":102915009,
    "descripcion":"NOSOFOBIA"
  },
  {
    "codigo":363224005,
    "descripcion":"NEFROPATÍA NEONATAL"
  },
  {
    "codigo":230317000,
    "descripcion":"DISTONÍA TARDÍA MEDICAMENTOSA"
  },
  {
    "codigo":263085003,
    "descripcion":"FRACTURA-LUXACIÓN DE DEDO DE LA MANO"
  },
  {
    "codigo":295853008,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE DESIPRAMINA"
  },
  {
    "codigo":195714005,
    "descripcion":"BRONQUITIS FIBRINOSA AGUDA"
  },
  {
    "codigo":228482006,
    "descripcion":"UTILIZA DIQUE DENTAL COMO PROTECCIÓN PARA EL SEXO"
  },
  {
    "codigo":720002008,
    "descripcion":"ORINA DE COLOR COBRIZO"
  },
  {
    "codigo":294018009,
    "descripcion":"ALERGIA A BETANECOL"
  },
  {
    "codigo":359554008,
    "descripcion":"ARTROPATÍA DE CHARCOT"
  },
  {
    "codigo":95575002,
    "descripcion":"OBSTRUCCIÓN URETEROPÉLVICA"
  },
  {
    "codigo":783703004,
    "descripcion":"SÍNDROME DE HIPOPLASIA DE LA SUSTANCIA BLANCA, AGENESIA DE CUERPO CALLOSO Y DISCAPACIDAD INTELECTUAL"
  },
  {
    "codigo":93740003,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL CUERPO CAROTÍDEO"
  },
  {
    "codigo":126508004,
    "descripcion":"NEOPLASIA DE LA PIEL DE LA ESPALDA"
  },
  {
    "codigo":28204005,
    "descripcion":"ARTROGRIFOSIS HEREDITARIA"
  },
  {
    "codigo":1142316009,
    "descripcion":"ATROFIA GENERALIZADA DE MÚSCULO DE EXTREMIDAD"
  },
  {
    "codigo":192044009,
    "descripcion":"REACCIÓN AL ESTRÉS QUE CAUSA ALTERACIÓN MIXTA DE LA CONDUCTA Y LAS EMOCIONES"
  },
  {
    "codigo":386817001,
    "descripcion":"PROBLEMA DE CONDUCTA DE LA INFANCIA Y LA ADOLESCENCIA"
  },
  {
    "codigo":419585004,
    "descripcion":"FIBROMA DE LA MUCOSA BUCAL CON FORMA DE HOJA"
  },
  {
    "codigo":91905002,
    "descripcion":"AUSENCIA CONGÉNITA DEL PUBIS"
  },
  {
    "codigo":124673003,
    "descripcion":"DEFICIENCIA DE ISOPENTENILO - DIFOSFATO DELTA - ISOMERASA"
  },
  {
    "codigo":288513003,
    "descripcion":"QUEMADURA CON COMPROMISO DE 6% DE LA SUPERFICIE CORPORAL"
  },
  {
    "codigo":90070003,
    "descripcion":"NEUMOTÓRAX TRAUMÁTICO"
  },
  {
    "codigo":286678003,
    "descripcion":"OMNIPOTENCIA - MECANISMO DE DEFENSA PSICOLÓGICA"
  },
  {
    "codigo":417750006,
    "descripcion":"LACERACIÓN DE LA CONJUNTIVA"
  },
  {
    "codigo":1204182008,
    "descripcion":"OCLUSIÓN AGUDA DE ARTERIA ILÍACA DEBIDA A TROMBOSIS"
  },
  {
    "codigo":1236950008,
    "descripcion":"VOLUMEN PLACENTARIO DENTRO DE RANGO DE REFERENCIA"
  },
  {
    "codigo":448683002,
    "descripcion":"HÍGADO EN EL LADO IZQUIERDO"
  },
  {
    "codigo":284843004,
    "descripcion":"NO SE LAVA LOS DIENTES"
  },
  {
    "codigo":1003904002,
    "descripcion":"DELECIÓN PROXIMAL DEL BRAZO LARGO DEL CROMOSOMA 17"
  },
  {
    "codigo":20864004,
    "descripcion":"INSUFICIENCIA SUBAGUDA"
  },
  {
    "codigo":53632005,
    "descripcion":"ESTOMATITIS VESICULAR POR VIRUS INDIANA"
  },
  {
    "codigo":250240007,
    "descripcion":"POBLACIÓN ERITROCÍTICA DISMÓRFICA"
  },
  {
    "codigo":248405000,
    "descripcion":"MANOS LISAS Y SUAVES"
  },
  {
    "codigo":1196842000,
    "descripcion":"LINFANGIOMA DE INTESTINO DELGADO"
  },
  {
    "codigo":17194005,
    "descripcion":"EFECTO TARDÍO DE FRACTURA DE CUELLO DE FÉMUR"
  },
  {
    "codigo":312106007,
    "descripcion":"LARVA MIGRANS CUTÁNEA POR TOXOCARA"
  },
  {
    "codigo":211967004,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO SUPERFICIAL DE DEDO(S) DEL PIE"
  },
  {
    "codigo":441343005,
    "descripcion":"VIRUS DE INFLUENZA A SUBTIPO H5 PRESENTE"
  },
  {
    "codigo":769023006,
    "descripcion":"CARIES INACTIVA NO CAVITADA DE LA RAÍZ DEL DIENTE"
  },
  {
    "codigo":15693361000119105,
    "descripcion":"QUERATITIS BILATERAL CAUSADA POR NEISSERIA GONORRHOEAE"
  },
  {
    "codigo":210132006,
    "descripcion":"LESIÓN TRAUMÁTICA DE COLON DESCENDENTE CON HERIDA ABIERTA HACIA CAVIDAD ABDOMINAL"
  },
  {
    "codigo":109993000,
    "descripcion":"TRASTORNO MIELOPROLIFERATIVO CRÓNICO (CLÍNICO)"
  },
  {
    "codigo":404905001,
    "descripcion":"DISTRÉS POSTERIOR A ACCIDENTE"
  },
  {
    "codigo":767188008,
    "descripcion":"GANGLIÓN DE MÚLTIPLES ARTICULACIONES"
  },
  {
    "codigo":11689004,
    "descripcion":"ATELECTASIA LINEAL"
  },
  {
    "codigo":372137005,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA MAMA"
  },
  {
    "codigo":699817008,
    "descripcion":"NEOPLASIA DE SACO ENDOLINFÁTICO"
  },
  {
    "codigo":77225009,
    "descripcion":"SÍNDROME DEL ASA CIEGA"
  },
  {
    "codigo":1156734002,
    "descripcion":"REACCIÓN ADVERSA A AGONISTA DE RECEPTOR DE ERITROPOYETINA"
  },
  {
    "codigo":1255038001,
    "descripcion":"RUPTURA TRAUMÁTICA DE PLACA PALMAR DE ARTICULACIÓN DE DEDO ÍNDICE"
  },
  {
    "codigo":403070004,
    "descripcion":"TIÑA CAUSADA POR MICROSPORUM EQUINUM"
  },
  {
    "codigo":401235000,
    "descripcion":"RIESGO MODERADO DE AUTODESCUIDO"
  },
  {
    "codigo":302931004,
    "descripcion":"TRASTORNO DEL COLOR DE PELO"
  },
  {
    "codigo":40787005,
    "descripcion":"DEGENERACIÓN CONJUNTIVAL"
  },
  {
    "codigo":366632001,
    "descripcion":"AMPLITUD DE MOVIMIENTO PASIVO DE SUPINACIÓN MEDIOTARSIANA - HALLAZGO"
  },
  {
    "codigo":301096006,
    "descripcion":"HALLAZGO RELACIONADO CON EL VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":430333000,
    "descripcion":"HEMATOMA EN EL SITIO DE ACCESO A LA DIÁLISIS"
  },
  {
    "codigo":397565001,
    "descripcion":"QUERATITIS POR MICROSPORIDIA"
  },
  {
    "codigo":364797002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA DEGLUTIR"
  },
  {
    "codigo":4349002,
    "descripcion":"FRACTURA EXPUESTA DE SITIOS MÚLTIPLES DEL METACARPO"
  },
  {
    "codigo":321381000119102,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE TENDÓN EXTENSOR DE PIERNA IZQUIERDA"
  },
  {
    "codigo":723410002,
    "descripcion":"SÍNDROME N"
  },
  {
    "codigo":788946007,
    "descripcion":"GLAUCOMA DEBIDO A INFLAMACIÓN OCULAR"
  },
  {
    "codigo":361127002,
    "descripcion":"TIROIDITIS SUBAGUDA ATÍPICA"
  },
  {
    "codigo":262823004,
    "descripcion":"DESGARRO DE LA CÁPSULA ESPLÉNICA"
  },
  {
    "codigo":721575005,
    "descripcion":"ANGIOSARCOMA PRIMARIO DE CORAZÓN"
  },
  {
    "codigo":719740005,
    "descripcion":"CAPAZ DE SUBIR Y BAJAR ESCALONES EXTERNOS"
  },
  {
    "codigo":293756006,
    "descripcion":"ALERGIA A LOMUSTINA"
  },
  {
    "codigo":1342332009,
    "descripcion":"DISPLASIA CONGÉNITA DE AMBAS ARTICULACIONES DE TOBILLO"
  },
  {
    "codigo":160849004,
    "descripcion":"VOLVIÓ AL HOGAR"
  },
  {
    "codigo":93478000,
    "descripcion":"HEMORRAGIA INTRAOCULAR"
  },
  {
    "codigo":879910002,
    "descripcion":"HALLAZGO DE HUESO DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":27942005,
    "descripcion":"CHOQUE"
  },
  {
    "codigo":716070008,
    "descripcion":"ACANTHAMOEBA NO AISLADA"
  },
  {
    "codigo":290086008,
    "descripcion":"HALLAZGO RELACIONADO CON LA APARIENCIA DEL PEZÓN"
  },
  {
    "codigo":124411002,
    "descripcion":"DEFICIENCIA DE FOSFOLIPASA A>2<"
  },
  {
    "codigo":255483000,
    "descripcion":"BALANITIS EROSIVA"
  },
  {
    "codigo":746913791000119104,
    "descripcion":"DEFICIENCIA DE CÉLULAS MADRE LIMBARES DE AMBOS OJOS"
  },
  {
    "codigo":419323005,
    "descripcion":"PARACOCCIDIOMICOSIS LINFÁTICA"
  },
  {
    "codigo":286416003,
    "descripcion":"DIFICULTAD PARA HABLAR A VELOCIDAD NORMAL"
  },
  {
    "codigo":24272004,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA VENA CUBITAL"
  },
  {
    "codigo":415653001,
    "descripcion":"NEOPLASIA DE SUBMUCOSA DE ESÓFAGO"
  },
  {
    "codigo":253648009,
    "descripcion":"ANEURISMA DE SENO DE VALSALVA CON RUPTURA"
  },
  {
    "codigo":284581003,
    "descripcion":"ASTILLA DE MADERA EN LA REGIÓN AURICULAR"
  },
  {
    "codigo":710565001,
    "descripcion":"NEFROPATÍA ISQUÉMICA"
  },
  {
    "codigo":249978000,
    "descripcion":"EMPUJE CON LADO NO AFECTADO"
  },
  {
    "codigo":251813008,
    "descripcion":"MAMAS EN ESTADIO 2 DE TANNER"
  },
  {
    "codigo":282746001,
    "descripcion":"LESIÓN NERVIOSA AUTÓNOMA"
  },
  {
    "codigo":20602000,
    "descripcion":"ÁNIMO INDIFERENTE"
  },
  {
    "codigo":317349009,
    "descripcion":"QUERATOCONJUNTIVITIS PRIMAVERAL"
  },
  {
    "codigo":448421008,
    "descripcion":"SEPSIS CAUSADA POR STREPTOCOCCUS PNEUMONIAE"
  },
  {
    "codigo":315514002,
    "descripcion":"NACIDO EN ARABIA SAUDITA"
  },
  {
    "codigo":1231183003,
    "descripcion":"TORTUOSIDAD ARTERIAL RETINIANA AISLADA FAMILIAR"
  },
  {
    "codigo":1296719003,
    "descripcion":"HIPERTENSIÓN OCULAR BILATERAL DEBIDA A RETRACCIÓN DE ÁNGULO"
  },
  {
    "codigo":444751005,
    "descripcion":"HEMOGLOBINA A1C POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":117071006,
    "descripcion":"UNIDAD DE HEMODERIVADO DEVUELTA AL PROVEEDOR"
  },
  {
    "codigo":870735007,
    "descripcion":"SUPRESIÓN SENSITIVA"
  },
  {
    "codigo":16932000,
    "descripcion":"NÁUSEAS Y VÓMITOS"
  },
  {
    "codigo":248143006,
    "descripcion":"SUCCIÓN DE LAPICERA"
  },
  {
    "codigo":311844004,
    "descripcion":"LESIÓN DE MÚLTIPLES ÓRGANOS PÉLVICOS CON HERIDA ABIERTA HACIA CAVIDAD ABDOMINAL"
  },
  {
    "codigo":770596007,
    "descripcion":"ENFERMEDAD DEL MÚSCULO ONDULANTE CON MIASTENIA GRAVE"
  },
  {
    "codigo":1293049002,
    "descripcion":"DEPÓSITO DE CALCIO EN BOLSA SEROSA DE CADERA"
  },
  {
    "codigo":703225007,
    "descripcion":"ESTENOSIS DE VÁLVULA MITRAL POSTERIOR A PROCEDIMIENTO"
  },
  {
    "codigo":277241008,
    "descripcion":"DOLOR A LA PALPACIÓN SOBRE EL SENO FRONTAL"
  },
  {
    "codigo":441081008,
    "descripcion":"CAPAZ DE REALIZAR CÁLCULOS ARITMÉTICOS SIMPLES MENTALMENTE"
  },
  {
    "codigo":111566002,
    "descripcion":"HIPOTIROIDISMO ADQUIRIDO"
  },
  {
    "codigo":1260281008,
    "descripcion":"QUISTE DE RETENCIÓN MUCOSA DE GLÁDULA SALIVAL"
  },
  {
    "codigo":275406005,
    "descripcion":"DOLOR APENDICULAR"
  },
  {
    "codigo":240803000,
    "descripcion":"PARASITOSIS PRODUCIDA POR TREMATODOS DEL GÉNERO HAPLORCHIS"
  },
  {
    "codigo":208035001,
    "descripcion":"FRACTURA VERTEBRAL NO EXPUESTA CON LESIÓN ANTERIOR DE MÉDULA ESPINAL DORSAL, D7-12"
  },
  {
    "codigo":13262009,
    "descripcion":"SINEQUIA VULVAR"
  },
  {
    "codigo":109731005,
    "descripcion":"FRACASO DE RESTAURACIÓN DENTAL"
  },
  {
    "codigo":371875006,
    "descripcion":"DISPOSITIVO RETIRADO Y \/ O EXTRAÍDO"
  },
  {
    "codigo":765091006,
    "descripcion":"ATAXIA ESPINOCEREBELOSA CON NEUROPATÍA AXÓNICA TIPO 1"
  },
  {
    "codigo":206200000,
    "descripcion":"CEFALOHEMATOMA DEBIDO A TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":75128002,
    "descripcion":"HERNIA LABIAL"
  },
  {
    "codigo":402808004,
    "descripcion":"MALFORMACIÓN VASCULAR CONGÉNITA POR SÍNDROME HEREDITARIO"
  },
  {
    "codigo":269901000,
    "descripcion":"MATERIA FECAL EN JALEA DE GROSELLAS"
  },
  {
    "codigo":238968009,
    "descripcion":"VULVODINIA"
  },
  {
    "codigo":1156472008,
    "descripcion":"TUMOR PAPILAR DE LA REGIÓN PINEAL"
  },
  {
    "codigo":1285709003,
    "descripcion":"CIERRE DE ÁNGULO AGUDO CAUSADO POR FÁRMACO"
  },
  {
    "codigo":11848141000119101,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE PÁRPADO DERECHO"
  },
  {
    "codigo":1351245004,
    "descripcion":"INMUNODEFICIENCIA COMBINADA AUTOSÓMICA RECESIVA DEBIDA A DEFICIENCIA DE LIGANDO DE COESTIMULADOR INDUCIBLE DE LINFOCITOS T"
  },
  {
    "codigo":235016004,
    "descripcion":"CRESTA ALVEOLAR PUNTIAGUDA"
  },
  {
    "codigo":300834003,
    "descripcion":"DIFICULTAD PARA REALIZAR ACTIVIDADES DE BRICOLAJE"
  },
  {
    "codigo":366370005,
    "descripcion":"HALLAZGO RELACIONADO CON LA SIMETRÍA CRANEAL"
  },
  {
    "codigo":71458007,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DE LOS GENITALES EXTERNOS"
  },
  {
    "codigo":69623000,
    "descripcion":"EFECTO TÓXICO DEL NITROGLICOL"
  },
  {
    "codigo":298999007,
    "descripcion":"AMPLITUD DE SUPINACIÓN PASIVA DE LA MUÑECA AUMENTADA"
  },
  {
    "codigo":724983009,
    "descripcion":"DISTENSIÓN DE MÚSCULO EXTENSOR A LA ALTURA DEL ANTEBRAZO"
  },
  {
    "codigo":1149132002,
    "descripcion":"INTOXICACIÓN CAUSADA POR COMPUESTO DE HIERRO FÉRRICO"
  },
  {
    "codigo":723148003,
    "descripcion":"SÍNCOPE DEBIDO A FALLA AUTONÓMICA"
  },
  {
    "codigo":297164007,
    "descripcion":"QUISTE DUODENAL"
  },
  {
    "codigo":459169002,
    "descripcion":"EMBARAZO GEMELAR MONOCORIÓNICO DIAMNIÓTICO CON VOLÚMENES DE LÍQUIDO AMNIÓTICO SIMILARES"
  },
  {
    "codigo":262561005,
    "descripcion":"HERIDA PROFUNDA DE PIEL INCISA"
  },
  {
    "codigo":162422000,
    "descripcion":"DISTRIBUCIÓN DEL SÍNTOMA"
  },
  {
    "codigo":295329009,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE MEDIO DE CONTRASTE PARA RESONANCIA MAGNÉTICA"
  },
  {
    "codigo":721313009,
    "descripcion":"NEOPLASIA INDETERMINADA DE CÉLULAS DENDRÍTICAS"
  },
  {
    "codigo":129654004,
    "descripcion":"TRASTORNO ADQUIRIDO DEL FACTOR PLAQUETARIO 3"
  },
  {
    "codigo":293494005,
    "descripcion":"REACCIÓN ADVERSA A LA ACETAZOLAMIDA"
  },
  {
    "codigo":1145462006,
    "descripcion":"APLASIA DE MAXILAR SUPERIOR"
  },
  {
    "codigo":195190007,
    "descripcion":"INFARTO CEREBRAL POR EMBOLIA DE ARTERIAS CEREBRALES"
  },
  {
    "codigo":422731002,
    "descripcion":"DISGENESIA DEL ORIFICIO LAGRIMAL"
  },
  {
    "codigo":160587003,
    "descripcion":"EX - BEBEDOR EXCESIVO - MÁS DE 9 UNIDADES POR DÍA"
  },
  {
    "codigo":226123002,
    "descripcion":"DIETA LIBRE DE CARBOHIDRATOS"
  },
  {
    "codigo":95051006,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA PIEL DE LA ESPALDA"
  },
  {
    "codigo":783179009,
    "descripcion":"DISTONÍA CRANEOCERVICAL CON COMPROMISO LARÍNGEO Y DEL MIEMBRO SUPERIOR"
  },
  {
    "codigo":289824002,
    "descripcion":"HALLAZGO RELACIONADO CON MEDICIONES DEL CUELLO UTERINO"
  },
  {
    "codigo":93216007,
    "descripcion":"MELANOMA MALIGNO DE LA PIEL DE LAS NALGAS"
  },
  {
    "codigo":27680009,
    "descripcion":"HIPERPLASIA CONGÉNITA DE LAS GLÁNDULAS SEBÁCEAS DE LABIO"
  },
  {
    "codigo":124149005,
    "descripcion":"DEFICIENCIA DE 2 - HIDROXIGLUTARATO DESHIDROGENASA"
  },
  {
    "codigo":1172725005,
    "descripcion":"TIEMPO DE LISIS DE EUGLOBULINA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1090151000119108,
    "descripcion":"EDENTULISMO PARCIAL DEBIDO A TRAUMATISMO"
  },
  {
    "codigo":24010005,
    "descripcion":"AFAQUIA"
  },
  {
    "codigo":253386006,
    "descripcion":"ANOMALÍA EN ARCADA DE LAS CUERDAS TENDINOSAS TRICUSPÍDEAS"
  },
  {
    "codigo":286154009,
    "descripcion":"CAPAZ DE LIMPIAR LA DUCHA"
  },
  {
    "codigo":1003380001,
    "descripcion":"SÍNDROME DE MICRODELECIÓN 6Q16"
  },
  {
    "codigo":249716002,
    "descripcion":"DEFORMIDAD ROTACIONAL DE LA COLUMNA DORSAL"
  },
  {
    "codigo":315252002,
    "descripcion":"LESIÓN CUTÁNEA PIGMENTADA DE FORMA CAMBIANTE"
  },
  {
    "codigo":448159009,
    "descripcion":"ANOMALÍA DE APARATO SUBVALVULAR TRICUSPÍDEO"
  },
  {
    "codigo":53108004,
    "descripcion":"DELIRIO DE CULPA"
  },
  {
    "codigo":446324006,
    "descripcion":"DEHISCENCIA DE HERIDA DE APENDICECTOMÍA"
  },
  {
    "codigo":284319009,
    "descripcion":"INCAPAZ DE MANIPULAR OBJETOS INTERRELACIONADOS"
  },
  {
    "codigo":1263689000,
    "descripcion":"TRASTORNO FETAL DEBIDO A ELIMINACIÓN DE MECONIO DURANTE EL PARTO"
  },
  {
    "codigo":444489001,
    "descripcion":"ZONA PÚRPURA EN LA ESTIMACIÓN DE PESO PEDIÁTRICO DE BROSELOW LUTEN"
  },
  {
    "codigo":184180009,
    "descripcion":"SE SOLICITA FIRMAR TARJETA MÉDICA - EFECTUADO"
  },
  {
    "codigo":282484008,
    "descripcion":"NO CORRE EN TERRENO PLANO"
  },
  {
    "codigo":413556004,
    "descripcion":"TUBERCULOSIS RESISTENTE A LOS ANTIBIÓTICOS"
  },
  {
    "codigo":870473005,
    "descripcion":"INGESTA EXCESIVA DE VITAMINA E Y\/O DERIVADO DE VITAMINA E"
  },
  {
    "codigo":247881002,
    "descripcion":"PENSAMIENTOS OBSESIVOS ACERCA DE LA SUCIEDAD"
  },
  {
    "codigo":1163550000,
    "descripcion":"ENCEFALITIS POR VIRUS DE LA ENFERMEDAD DE LA SELVA DE KYASANUR"
  },
  {
    "codigo":442654007,
    "descripcion":"TROMBOFILIA DEBIDA A TRATAMIENTO HORMONAL"
  },
  {
    "codigo":213278009,
    "descripcion":"ADHERENCIAS COMO CONSECUENCIA DE CUERPO EXTRAÑO DEJADO EN EL PACIENTE DURANTE CIRUGÍA"
  },
  {
    "codigo":11768731000119104,
    "descripcion":"HEMATOMA SUBUNGUEAL DE DEDO ANULAR DE MANO DERECHA"
  },
  {
    "codigo":735731005,
    "descripcion":"ENTERITIS NO INFECCIOSA CRÓNICA IDIOPÁTICA"
  },
  {
    "codigo":1260019009,
    "descripcion":"CARCINOMA ADENOIDE QUÍSTICO DE PULMÓN"
  },
  {
    "codigo":209608002,
    "descripcion":"DESGARRO COMPLETO DEL PULGAR, ARTICULACIÓN METACARPOFALÁNGICA, LIGAMENTO LATERAL CUBITAL"
  },
  {
    "codigo":111304003,
    "descripcion":"DISPLASIA ESPONDILOMETAFISARIA DE KOZLOWSKI"
  },
  {
    "codigo":733896006,
    "descripcion":"AMAMANTADO Y ALIMENTADO CON BIBERÓN"
  },
  {
    "codigo":699293000,
    "descripcion":"MIELOFIBROSIS ISQUÉMICA"
  },
  {
    "codigo":1354653001,
    "descripcion":"DOLOR A LA PALPACIÓN DE TESTÍCULO"
  },
  {
    "codigo":240541004,
    "descripcion":"VERRUGA PLANTAR - MYRMECIA"
  },
  {
    "codigo":271474000,
    "descripcion":"NEOPLASIA BENIGNA DE CRÁNEO Y HUESOS FACIALES"
  },
  {
    "codigo":1092661000119102,
    "descripcion":"ARTRITIS POR ESPOROTRICOSIS"
  },
  {
    "codigo":238706002,
    "descripcion":"SÍNDROME DE LAUGIER-HUNZIKER"
  },
  {
    "codigo":402546004,
    "descripcion":"CARCINOMA BASOCELULAR RECIDIVANTE - TERCERA RECIDIVA"
  },
  {
    "codigo":369778004,
    "descripcion":"FORMACIÓN DE TÚBULOS MAMARIOS: MAYOR PARTE DEL TUMOR, >75% (PUNTAJE = 1)"
  },
  {
    "codigo":890396001,
    "descripcion":"EXCAVACIÓN CONGÉNITA DE PAPILA ÓPTICA BILATERAL"
  },
  {
    "codigo":300572002,
    "descripcion":"SACO GESTACIONAL PRESENTE"
  },
  {
    "codigo":235036003,
    "descripcion":"MORDEDURA DE LA LENGUA"
  },
  {
    "codigo":71196004,
    "descripcion":"TRASTORNO TÓXICO DE REFRACCIÓN Y\/O ACOMODACIÓN"
  },
  {
    "codigo":38428003,
    "descripcion":"NEUROPATÍA DEL PLEXO BRAQUIAL SUPERIOR"
  },
  {
    "codigo":169500006,
    "descripcion":"SUSPENDIÓ EL USO DE CAPUCHÓN VAGINAL"
  },
  {
    "codigo":366108007,
    "descripcion":"FUNCIÓN DEL OÍDO MEDIO - HALLAZGO"
  },
  {
    "codigo":202268007,
    "descripcion":"CONTRACTURA EN ADUCCIÓN DE HOMBRO"
  },
  {
    "codigo":724721000,
    "descripcion":"TRASTORNO DEL ESTADO DE ÁNIMO CAUSADO POR KETAMINA"
  },
  {
    "codigo":298737004,
    "descripcion":"HALLAZGO RELACIONADO CON LA DISPOSICIÓN DE LAS COSTILLAS"
  },
  {
    "codigo":722886001,
    "descripcion":"HEMORRAGIA GASTROINTESTINAL OSCURA"
  },
  {
    "codigo":69361009,
    "descripcion":"CLEPTOMANÍA"
  },
  {
    "codigo":296902003,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE TESTOSTERONA"
  },
  {
    "codigo":1148870007,
    "descripcion":"PIURIA BACTERIANA"
  },
  {
    "codigo":262299002,
    "descripcion":"CON EL PISO DE LA BOCA DEPRIMIDO"
  },
  {
    "codigo":1179803007,
    "descripcion":"IMAGEN ANORMAL EN RESONANCIA MAGNÉTICA DE CEREBRO CAUSADA POR PÉPTIDO BETA AMILOIDE CON MICROHEMORRAGIA O HEMOSIDEROSIS"
  },
  {
    "codigo":719216001,
    "descripcion":"COMA HIPOGLUCÉMICO DEBIDO A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":293232008,
    "descripcion":"REACCIÓN ADVERSA A LA CIPROTERONA"
  },
  {
    "codigo":94789003,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL CEREBRO"
  },
  {
    "codigo":422469006,
    "descripcion":"FRACTURA PATOLÓGICA DEL OMÓPLATO"
  },
  {
    "codigo":225861007,
    "descripcion":"NO ES SEGURO QUE QUEDE SOLO"
  },
  {
    "codigo":782917007,
    "descripcion":"HIPOPLASIA SUPRARRENAL FAMILIAR CON AUSENCIA DE HORMONA LUTEINIZANTE HIPOFISARIA"
  },
  {
    "codigo":193093009,
    "descripcion":"PARÁLISIS DE BELL"
  },
  {
    "codigo":1208901009,
    "descripcion":"PARÁLISIS DE CUARTO NERVIO CRANEAL AGUDA"
  },
  {
    "codigo":92954007,
    "descripcion":"FORMA ANORMAL CONGÉNITA DE TIBIA"
  },
  {
    "codigo":713711000,
    "descripcion":"ESCOLIOSIS IDIOPÁTICA DE COLUMNA VERTEBRAL DORSAL Y LUMBAR"
  },
  {
    "codigo":1010458009,
    "descripcion":"BLOQUEO DE CONDUCCIÓN NERVIOSA SENSITIVA DERECHA"
  },
  {
    "codigo":289562009,
    "descripcion":"SECRECIÓN VAGINAL URINARIA"
  },
  {
    "codigo":1172463003,
    "descripcion":"ESTRADIOL SÉRICO POR ENCIMA DE RANGO DE REFERENCIA"
  },
  {
    "codigo":6141000179100,
    "descripcion":"EVALUACIÓN MAMOGRÁFICA (CATEGORÍA 4C) - ANOMALÍA SOSPECHOSA, DEBE CONSIDERARSE LA REALIZACIÓN DE UNA BIOPSIA, ALTA SOSPECHA DE MALIGNIDAD"
  },
  {
    "codigo":123887005,
    "descripcion":"INTOXICACIÓN POR PAPAVERACEAE"
  },
  {
    "codigo":254959007,
    "descripcion":"ADENOMA TIROTRÓFICO"
  },
  {
    "codigo":418799008,
    "descripcion":"HALLAZGO INFORMADO POR EL SUJETO O EL QUE RELATA LA HISTORIA"
  },
  {
    "codigo":253124001,
    "descripcion":"MIELODISPLASIA DE MÉDULA ESPINAL"
  },
  {
    "codigo":449732002,
    "descripcion":"QUERATOSIS ACTÍNICA PIGMENTADA"
  },
  {
    "codigo":10624361000119106,
    "descripcion":"BLEFARITIS DE PÁRPADOS SUPERIOR E INFERIOR DERECHOS"
  },
  {
    "codigo":447897005,
    "descripcion":"SEPSIS CAUSADA POR ACINETOBACTER"
  },
  {
    "codigo":349971000221103,
    "descripcion":"TOXOPLASMOSIS EN EL EMBARAZO"
  },
  {
    "codigo":21913008,
    "descripcion":"INFESTACIÓN CAUSADA POR PSORERGATES SIMPLEX"
  },
  {
    "codigo":249454003,
    "descripcion":"ARTICULACIÓN CRICOARITENOIDEA FIJA DURANTE LA FONACIÓN"
  },
  {
    "codigo":282222007,
    "descripcion":"CAPAZ DE CAMINAR SOBRE UNA LÍNEA ESTRECHA"
  },
  {
    "codigo":444227004,
    "descripcion":"SÍNDROME DE DOLOR AGUDO POSTORACOTOMÍA"
  },
  {
    "codigo":83779006,
    "descripcion":"PALINESTESIA"
  },
  {
    "codigo":247619007,
    "descripcion":"HALLAZGO RELACIONADO CON EL PENSAMIENTO"
  },
  {
    "codigo":685571000119105,
    "descripcion":"LEIOMIOSARCOMA PRIMARIO DE ABDOMEN"
  },
  {
    "codigo":313155007,
    "descripcion":"ESOTROPÍA PARA LA VISIÓN LEJANA"
  },
  {
    "codigo":49176002,
    "descripcion":"GANGRENA ARTERIOSCLERÓTICA"
  },
  {
    "codigo":409624004,
    "descripcion":"PARÁLISIS PARCIAL"
  },
  {
    "codigo":278552004,
    "descripcion":"CORONA DENTAL PRESENTE"
  },
  {
    "codigo":735469001,
    "descripcion":"QUEMADURA QUÍMICA DE PIEL CAUSADA POR SUSTANCIA CORROSIVA"
  },
  {
    "codigo":276717003,
    "descripcion":"ESCASA ALIMENTACIÓN DEL RECIÉN NACIDO"
  },
  {
    "codigo":1259757005,
    "descripcion":"NEOPLASIA DE PULMÓN DE CÉLULAS NO MICROCÍTICAS NO ESCAMOSAS PRIMARIA"
  },
  {
    "codigo":405954000,
    "descripcion":"ANAPLASIA FOCAL"
  },
  {
    "codigo":1290690001,
    "descripcion":"COLANGIOCARCINOMA METASTÁSICO"
  },
  {
    "codigo":45506003,
    "descripcion":"INTOXICACIÓN POR LEWISITA"
  },
  {
    "codigo":209346004,
    "descripcion":"FRACTURA-SUBLUXACIÓN NO EXPUESTA DE ARTICULACIÓN FEMORORROTULIANA"
  },
  {
    "codigo":307650006,
    "descripcion":"RETICULOSIS MEDULAR HISTIOCÍTICA"
  },
  {
    "codigo":895639000,
    "descripcion":"FORMA TRIANGULAR ANORMAL CONGÉNITA DE FALANGE DE DEDO DE MANO"
  },
  {
    "codigo":242114008,
    "descripcion":"LESIÓN POR MOVIMIENTO DE PARTE DEL VEHÍCULO AL SUBIR O BAJAR"
  },
  {
    "codigo":305815001,
    "descripcion":"ATENDIDO POR SERVICIO DE GENÉTICA CLÍNICA"
  },
  {
    "codigo":78274008,
    "descripcion":"INFECCIÓN CAUSADA POR PROTOSPIRURA"
  },
  {
    "codigo":404119000,
    "descripcion":"RETICULOSIS PAGETOIDE"
  },
  {
    "codigo":699031007,
    "descripcion":"TUMEFACCIÓN DURANTE LAVADO DE DISPOSITIVO DE ACCESO VENOSO IMPLANTADO"
  },
  {
    "codigo":238444005,
    "descripcion":"TRICOFITIDA"
  },
  {
    "codigo":402284006,
    "descripcion":"DERMATITIS DE CONTACTO IRRITATIVA POR BABEO Y\/O DENTICIÓN"
  },
  {
    "codigo":9068007,
    "descripcion":"AMPOLLA DE LA VAGINA, CON INFECCIÓN"
  },
  {
    "codigo":41836007,
    "descripcion":"TRASTORNO BIPOLAR EN REMISIÓN TOTAL"
  },
  {
    "codigo":205676008,
    "descripcion":"INDIVIDUO CON SITIO AUTOSÓMICO FRÁGIL"
  },
  {
    "codigo":369516006,
    "descripcion":"NEOPLASIA MALIGNA QUE COMPROMETE LA TROMPA DE FALOPIO IZQUIERDA POR PROPAGACIÓN DIRECTA DESDE OVARIO"
  },
  {
    "codigo":1186881003,
    "descripcion":"DEMENCIA DEBIDA A DEFICIENCIA DE NIACINA"
  },
  {
    "codigo":11718301000119106,
    "descripcion":"XANTOMA DE AMBOS PÁRPADOS"
  },
  {
    "codigo":105537000,
    "descripcion":"VIVIENDA CON PROBLEMAS TÉCNICOS"
  },
  {
    "codigo":72769008,
    "descripcion":"PULSO ANATRICÓTICO"
  },
  {
    "codigo":236609008,
    "descripcion":"URINOMA PARAURETERAL"
  },
  {
    "codigo":302145009,
    "descripcion":"ES DUEÑO DE SU HOGAR"
  },
  {
    "codigo":202006003,
    "descripcion":"ARTROPATÍA TRANSITORIA DE LA ARTICULACIÓN INTERFALÁNGICA DISTAL DE DEDO DE LA MANO"
  },
  {
    "codigo":300310003,
    "descripcion":"HALLAZGO RELACIONADO CON EL COLON"
  },
  {
    "codigo":396779001,
    "descripcion":"CALCIFICACIÓN DE ARTERIA DE MAMA"
  },
  {
    "codigo":298475003,
    "descripcion":"MOVIMIENTO NORMAL DEL CUELLO"
  },
  {
    "codigo":167403003,
    "descripcion":"NIVEL DE ADRENALINA EN ORINA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":724459009,
    "descripcion":"ADHERENCIA DE PERITONEO PÉLVICO"
  },
  {
    "codigo":722624003,
    "descripcion":"HEMATOMA TRAUMÁTICO FOCAL DE TRONCO ENCEFÁLICO"
  },
  {
    "codigo":1148608003,
    "descripcion":"ELECTRORRETINOGRAMA CON ADAPTACIÓN A OSCURIDAD ANORMAL"
  },
  {
    "codigo":296640003,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE DERIVADO DEL NITROFURANO"
  },
  {
    "codigo":1279680006,
    "descripcion":"FIEBRE RECURRENTE CAUSADA POR BORRELIA VENEZUELENSIS"
  },
  {
    "codigo":198336007,
    "descripcion":"TRASTORNO NO INFLAMATORIO DEL CUELLO UTERINO"
  },
  {
    "codigo":788160008,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR GAMMAGLOBULINA"
  },
  {
    "codigo":165568006,
    "descripcion":"TIEMPO DE PROTROMBINA ANORMAL"
  },
  {
    "codigo":196501002,
    "descripcion":"SIALOLITIASIS SUBLINGUAL"
  },
  {
    "codigo":1343667005,
    "descripcion":"ATELECTASIA DE MEMBRANA TIMPÁNICA DEBIDA A INFLAMACIÓN ADHESIVA DE OÍDO MEDIO"
  },
  {
    "codigo":1144938000,
    "descripcion":"ADHERENCIAS DENSAS DE ANEXOS UTERINOS DEBIDAS A ENDOMETRIOSIS"
  },
  {
    "codigo":130965009,
    "descripcion":"PERSISTENCIA"
  },
  {
    "codigo":161898004,
    "descripcion":"SE CAE"
  },
  {
    "codigo":30826006,
    "descripcion":"INFERTILIDAD FEMENINA DE ORIGEN VAGINAL"
  },
  {
    "codigo":292970007,
    "descripcion":"REACCIÓN ADVERSA A LA MEZLOCILINA"
  },
  {
    "codigo":94527001,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL SACRO"
  },
  {
    "codigo":127295002,
    "descripcion":"LESIÓN TRAUMÁTICA CEREBRAL"
  },
  {
    "codigo":225599005,
    "descripcion":"CONDUCTA SOCIAL"
  },
  {
    "codigo":291135006,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR RISPERIDONA"
  },
  {
    "codigo":1010196001,
    "descripcion":"PREOCUPACIÓN ACERCA DE LA PROTECCIÓN"
  },
  {
    "codigo":190996002,
    "descripcion":"INMUNODEFICIENCIA COMBINADA GRAVE, CON DISGENESIA RETICULAR"
  },
  {
    "codigo":16908241000119106,
    "descripcion":"CARCINOMA ESCAMOCELULAR IN SITU DE PIEL DE PÁRPADO SUPERIOR DERECHO"
  },
  {
    "codigo":387604006,
    "descripcion":"SÍNDROME DE DESAJUSTE HORARIO"
  },
  {
    "codigo":27156006,
    "descripcion":"CIRROSIS POSTHEPÁTICA"
  },
  {
    "codigo":713449000,
    "descripcion":"CONOCIMIENTO DEFICIENTE DEL CUIDADO DEL LACTANTE"
  },
  {
    "codigo":780820008,
    "descripcion":"DEFICIENCIA AISLADA DE ADENOSINA TRIFOSFATO SINTASA"
  },
  {
    "codigo":92692006,
    "descripcion":"CARCINOMA IN SITU DEL ANTRO PILÓRICO"
  },
  {
    "codigo":1303273003,
    "descripcion":"SÍNDROME DE TRASTORNO DEL NEURODESARROLLO REGRESIVO, DISTONIA, CRISIS ASOCIADO AL GEN IRF2BPL"
  },
  {
    "codigo":6251000119101,
    "descripcion":"INTERRUPCIÓN INDUCIDA DEL EMBARAZO EN EL PRIMER TRIMESTRE"
  },
  {
    "codigo":418537006,
    "descripcion":"TUBO ENDOTRAQUEAL NASAL PRESENTE"
  },
  {
    "codigo":688081000119108,
    "descripcion":"SARCOMA PRIMARIO DE TÓRAX"
  },
  {
    "codigo":254697009,
    "descripcion":"TRICOEPITELIOMA SOLITARIO GIGANTE"
  },
  {
    "codigo":1137598004,
    "descripcion":"BERMELLÓN DE LABIO SUPERIOR GRUESO"
  },
  {
    "codigo":285630007,
    "descripcion":"CAPAZ DE DECIR LA HORA"
  },
  {
    "codigo":11802731000119104,
    "descripcion":"RUPTURA TRAUMÁTICA DE COMPLEJO FIBROCARTILAGINOSO TRIANGULAR DE REGIÓN DE MUÑECA DERECHA"
  },
  {
    "codigo":333931000119104,
    "descripcion":"ÚLCERA MARGINAL DE CÓRNEA DE OJO DERECHO"
  },
  {
    "codigo":1332371005,
    "descripcion":"INFLAMACIÓN DE NERVIO PERIFÉRICO DE TOBILLO"
  },
  {
    "codigo":46241000087102,
    "descripcion":"FRACTURA DE FALANGE DE QUINTO DEDO DE PIE DERECHO"
  },
  {
    "codigo":43681000087102,
    "descripcion":"CORTE EN TOBILLO IZQUIERDO"
  },
  {
    "codigo":10901611000119105,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO VAGO IZQUIERDO"
  },
  {
    "codigo":283795009,
    "descripcion":"MORDEDURA DE ANIMAL EN LA REGIÓN AURICULAR"
  },
  {
    "codigo":41121000087108,
    "descripcion":"CELULITIS DE DEDO GORDO DE PIE DERECHO"
  },
  {
    "codigo":609640006,
    "descripcion":"NEUROPATÍA POR COMPRESIÓN DE NERVIO GENITOCRURAL"
  },
  {
    "codigo":1230397006,
    "descripcion":"DERMATOSIS PURPÚRICA PIGMENTADA"
  },
  {
    "codigo":50749006,
    "descripcion":"SÍNDROME DE DOBLE Y"
  },
  {
    "codigo":16146001,
    "descripcion":"BRONQUITIS VIRAL"
  },
  {
    "codigo":81682002,
    "descripcion":"ENFERMEDAD FUNCIONAL DEL SISTEMA NERVIOSO CENTRAL CON TRASTORNOS NEUROENDOCRINOS"
  },
  {
    "codigo":704274002,
    "descripcion":"CONSENTIMIENTO PARA EXAMEN DEL SISTEMA NERVIOSO CENTRAL REHUSADO"
  },
  {
    "codigo":442130003,
    "descripcion":"DISTENSIÓN DE MÚSCULO Y\/O TENDÓN DE REGIÓN DE CODO"
  },
  {
    "codigo":278290006,
    "descripcion":"ROTACIÓN INTERNA DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":14311001,
    "descripcion":"COLITIS ULCEROSA CRÓNICA SEVERA"
  },
  {
    "codigo":702439002,
    "descripcion":"AGENESIA DE CUERPO CALLOSO CON NEUROPATÍA PERIFÉRICA"
  },
  {
    "codigo":1259495001,
    "descripcion":"CARCINOMA ADENOIDE QUÍSTICO PRIMARIO DE PARATIROIDES"
  },
  {
    "codigo":405692001,
    "descripcion":"LESIÓN TRAUMÁTICA PROVOCADA POR SUJECIÓN LEGAL CON ESPOSAS"
  },
  {
    "codigo":12476004,
    "descripcion":"OBSTRUCCIÓN CARTILAGINOSA INTRÍNSECA DE TROMPA DE EUSTAQUIO"
  },
  {
    "codigo":733372006,
    "descripcion":"HERIDA PUNZANTE DE ABDOMEN CON CUERPO EXTRAÑO"
  },
  {
    "codigo":371089000,
    "descripcion":"SÍNDROME SEROTONINÉRGICO"
  },
  {
    "codigo":241852008,
    "descripcion":"EFECTO TÓXICO CAUSADO POR LIMPIADOR DE SUMIDEROS"
  },
  {
    "codigo":305553000,
    "descripcion":"BAJO ATENCIÓN DE CIRUJANO VASCULAR"
  },
  {
    "codigo":698769001,
    "descripcion":"OCLUSIÓN LINGUAL POSTERIOR BILATERAL DE DIENTES MANDIBULARES"
  },
  {
    "codigo":11858181000119108,
    "descripcion":"DISTENSIÓN DE MÚSCULO CRURAL ANTERIOR DE PIERNA IZQUIERDA"
  },
  {
    "codigo":240017008,
    "descripcion":"BURSITIS DE REGIÓN DE TOBILLO"
  },
  {
    "codigo":403857009,
    "descripcion":"ACROCORDONES MÚLTIPLES"
  },
  {
    "codigo":762470000,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL SUPERFICIAL DE CARA"
  },
  {
    "codigo":41574007,
    "descripcion":"PARAMIOTONÍA CONGÉNITA"
  },
  {
    "codigo":74342009,
    "descripcion":"ENFERMEDAD POR EL VIRUS NEPUYO"
  },
  {
    "codigo":6971002,
    "descripcion":"HIPERTROFIA DE LAS PAPILAS LINGUALES"
  },
  {
    "codigo":269115004,
    "descripcion":"LUXACIÓN NO EXPUESTA DE LA ARTICULACIÓN ATLANTO-OCCIPITAL"
  },
  {
    "codigo":234512002,
    "descripcion":"TROMBOCITOSIS POSESPLENECTOMÍA"
  },
  {
    "codigo":267280004,
    "descripcion":"COMPLICACIÓN VENOSA DE EMBARAZO Y\/O PUERPERIO"
  },
  {
    "codigo":365584005,
    "descripcion":"NIVEL DE AUTOANTICUERPOS - HALLAZGO"
  },
  {
    "codigo":298213000,
    "descripcion":"LAXITUD DE ARTICULACIÓN DE PULGAR"
  },
  {
    "codigo":726032008,
    "descripcion":"SÍNDROME DE COSTILLAS CORTAS Y POLIDACTILIA TIPO 1"
  },
  {
    "codigo":396517006,
    "descripcion":"MARGEN QUIRÚRGICO PROFUNDO COMPROMETIDO POR MELANOMA MALIGNO"
  },
  {
    "codigo":67002003,
    "descripcion":"TRASTORNO BIPOLAR II GRAVE, EPISODIO MÁS RECIENTE DE CARACTERÍSTICAS DEPRESIVAS PROFUNDAS, EN REMISIÓN PARCIAL"
  },
  {
    "codigo":1073721000119103,
    "descripcion":"ARTRITIS REUMATOIDE DE CADERA IZQUIERDA"
  },
  {
    "codigo":786063001,
    "descripcion":"USUARIO DE CIGARRILLO ELECTRÓNICO NO CARGADO CON NICOTINA"
  },
  {
    "codigo":294543006,
    "descripcion":"ALERGIA A CEFAMANDOL"
  },
  {
    "codigo":425615007,
    "descripcion":"ALETEO AURICULAR CRÓNICO"
  },
  {
    "codigo":292708006,
    "descripcion":"REACCIÓN ADVERSA A P-DI-ISOBUTILFENOXIPOLIETOXIETANOL"
  },
  {
    "codigo":782393000,
    "descripcion":"NÓDULO DE PIEL DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":1144676008,
    "descripcion":"APLASIA DE FALANGE DISTAL DE PIE"
  },
  {
    "codigo":28729000,
    "descripcion":"SINOVITIS PROLIFERATIVA"
  },
  {
    "codigo":290873000,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR TRANILCIPROMINA"
  },
  {
    "codigo":716857003,
    "descripcion":"FEOCROMOCITOMA Y PARAGANGLIOMA HEREDITARIO"
  },
  {
    "codigo":127033004,
    "descripcion":"ELEMENTOS CELULARES EN SANGRE ANORMALMENTE AUMENTADOS"
  },
  {
    "codigo":94265009,
    "descripcion":"NEOPLASIA MALIGNA SECUNDARIA DE LA CÓRNEA"
  },
  {
    "codigo":289038005,
    "descripcion":"UTILIZA LA MANO DERECHA PARA ALIMENTARSE"
  },
  {
    "codigo":713187004,
    "descripcion":"POLIHIDRAMNIOS DEBIDO A ENFERMEDAD MATERNA"
  },
  {
    "codigo":1237475006,
    "descripcion":"SÍNDROME CEREBELOSO, FACIAL Y DENTAL"
  },
  {
    "codigo":1268408001,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA PARCIAL DE PIE"
  },
  {
    "codigo":188899009,
    "descripcion":"NEOPLASIA BENIGNA DEL MEDIASTINO MEDIO INFERIOR"
  },
  {
    "codigo":254435009,
    "descripcion":"CARCINOMA DEL PALADAR BLANDO"
  },
  {
    "codigo":88760006,
    "descripcion":"HIPOPARATIROIDISMO AISLADO DE INICIACIÓN TARDÍA"
  },
  {
    "codigo":449208008,
    "descripcion":"SARCOMA DE CÓCCIX"
  },
  {
    "codigo":86925001,
    "descripcion":"CEFALEA OCULAR"
  },
  {
    "codigo":283533001,
    "descripcion":"HERIDA PUNZANTE DE CADERA"
  },
  {
    "codigo":840589003,
    "descripcion":"REACCIÓN ADVERSA A INHIBIDOR DE LA AGREGACIÓN PLAQUETARIA"
  },
  {
    "codigo":185229005,
    "descripcion":"ATENDIDO EN CONSULTORIO ESPECIALIZADO EN DIABETES"
  },
  {
    "codigo":54157007,
    "descripcion":"ÚLCERA PÉPTICA SIN HEMORRAGIA Y SIN PERFORACIÓN PERO CON OBSTRUCCIÓN"
  },
  {
    "codigo":871522005,
    "descripcion":"REACCIÓN ADVERSA A DIHIDROERGOCORNINA, DIHIDROERGOCRISTINA Y\/O DIHIDROERGOCRIPTINA"
  },
  {
    "codigo":85090007,
    "descripcion":"HALLAZGO DE DEXTROCARDIA\/SITUS INVERSO"
  },
  {
    "codigo":445538009,
    "descripcion":"FRACTURA PATOLÓGICA DE CÚBITO DISTAL"
  },
  {
    "codigo":247095003,
    "descripcion":"ACEITE EN LA CAVIDAD DEL VÍTREO"
  },
  {
    "codigo":1230135006,
    "descripcion":"GINGIVITIS Y PERIODONTITIS PERI-IMPLANTE DEBIDA A PLACA DENTAL"
  },
  {
    "codigo":17719008,
    "descripcion":"ESPESOR DE LA PIEL DISMINUIDO"
  },
  {
    "codigo":704012001,
    "descripcion":"FRACTURA EXPUESTA DE FALANGE DE DEDO ANULAR"
  },
  {
    "codigo":278028002,
    "descripcion":"LESIÓN OCULAR POR RAYO"
  },
  {
    "codigo":1076231000119100,
    "descripcion":"BURSITIS ROTULIANA DE RODILLA IZQUIERDA"
  },
  {
    "codigo":212492007,
    "descripcion":"LESIONES ABIERTAS QUE COMPROMETEN EL TÓRAX CON EL ABDOMEN, LA REGIÓN LUMBAR Y LA PELVIS"
  },
  {
    "codigo":1162764009,
    "descripcion":"STENT URETERAL PRESENTE"
  },
  {
    "codigo":767713001,
    "descripcion":"DEFICIENCIA DE FACTOR XI"
  },
  {
    "codigo":472801002,
    "descripcion":"ESTENOSIS SUBPULMONAR CONGÉNITA DEBIDA A DEFECTO RESTRICTIVO DEL TABIQUE INTERVENTRICULAR ASOCIADA CON CORAZÓN FUNCIONALMENTE UNIVENTRICULAR"
  },
  {
    "codigo":14049007,
    "descripcion":"SIGNO DE CHAUSSIER"
  },
  {
    "codigo":700342000,
    "descripcion":"XANTOMA DE PÁRPADO SUPERIOR"
  },
  {
    "codigo":1259233009,
    "descripcion":"URETRITIS QUÍSTICA"
  },
  {
    "codigo":733110004,
    "descripcion":"SÍNDROME DE VAN DEN BOSCH"
  },
  {
    "codigo":896950007,
    "descripcion":"FORMA DE BALA ANORMAL CONGÉNITA DE FALANGE DISTAL DE DEDO GORDO"
  },
  {
    "codigo":307126008,
    "descripcion":"INCAPAZ DE ESCRIBIR"
  },
  {
    "codigo":10379002,
    "descripcion":"HIPOMOVILIDAD MUSCULOESQUELÉTICA"
  },
  {
    "codigo":239755003,
    "descripcion":"LUXACIÓN NEUROMUSCULAR DE ARTICULACIÓN"
  },
  {
    "codigo":403595006,
    "descripcion":"SÍNDROME DE PINOCHO"
  },
  {
    "codigo":237920001,
    "descripcion":"ALBINISMO OCULOCUTÁNEO SENSIBLE A LA TEMPERATURA"
  },
  {
    "codigo":236085004,
    "descripcion":"FILTRACIÓN POR ANASTOMOSIS GASTROINTESTINAL"
  },
  {
    "codigo":72245005,
    "descripcion":"VÓMITO POSTOPERATORIO"
  },
  {
    "codigo":301621006,
    "descripcion":"UTILIZA EL ASCENSOR"
  },
  {
    "codigo":365322005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA QUITAR EL POLVO"
  },
  {
    "codigo":299786006,
    "descripcion":"REFLEJO DE OJOS DE MUÑECA VERTICAL PRESENTE"
  },
  {
    "codigo":4874006,
    "descripcion":"SÍNDROME DE TRISOMÍA PARCIAL 11Q"
  },
  {
    "codigo":398090008,
    "descripcion":"PACIENTE NO DISPONIBLE"
  },
  {
    "codigo":70410008,
    "descripcion":"ACROCEFALOSINDACTILIA TIPO V"
  },
  {
    "codigo":232415002,
    "descripcion":"FALTA DE COORDINACIÓN PALATOFARÍNGEA"
  },
  {
    "codigo":363487003,
    "descripcion":"NEOPLASIA MALIGNA DE PLIEGUE ARIEPIGLÓTICO - ASPECTO LARÍNGEO"
  },
  {
    "codigo":396255002,
    "descripcion":"HALLAZGO RELACIONADO CON EL MARGEN DE RESECCIÓN QUIRÚRGICA EXOCERVICAL"
  },
  {
    "codigo":11781281000119104,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO POSTERIOR DE MUSLO IZQUIERDO"
  },
  {
    "codigo":68575007,
    "descripcion":"TRASTORNO DEL CUERPO CILIAR"
  },
  {
    "codigo":197812000,
    "descripcion":"HEMORRAGIA DE ARTERIA RENAL"
  },
  {
    "codigo":367931000119100,
    "descripcion":"ESTRECHEZ DE MEATO URETRAL MASCULINO, CONSECUTIVA A PROCEDIMIENTO"
  },
  {
    "codigo":165044007,
    "descripcion":"RELACIÓN VEF1\/CVF ANORMAL"
  },
  {
    "codigo":296116007,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE MIDAZOLAM"
  },
  {
    "codigo":230580009,
    "descripcion":"NEUROPATÍA POR MIXEDEMA"
  },
  {
    "codigo":294281002,
    "descripcion":"ALERGIA A BENTONITA"
  },
  {
    "codigo":195977004,
    "descripcion":"ASMA MIXTA"
  },
  {
    "codigo":425353005,
    "descripcion":"DIFICULTAD PARA VESTIR LA PARTE INFERIOR DEL CUERPO"
  },
  {
    "codigo":359817006,
    "descripcion":"FRACTURA NO EXPUESTA DE CADERA"
  },
  {
    "codigo":15713441000119108,
    "descripcion":"DEFORMIDAD EN OJAL DE DEDO DE AMBAS MANOS"
  },
  {
    "codigo":292446000,
    "descripcion":"REACCIÓN ADVERSA A LA INDORAMINA"
  },
  {
    "codigo":64905009,
    "descripcion":"ESQUIZOFRENIA PARANOIDE"
  },
  {
    "codigo":95838002,
    "descripcion":"CIANOSIS PULMONAR"
  },
  {
    "codigo":128606002,
    "descripcion":"TRASTORNO DE APARATO URINARIO"
  },
  {
    "codigo":10901051000119100,
    "descripcion":"RUPTURA DE GLOBO OCULAR IZQUIERDO"
  },
  {
    "codigo":12398651000119100,
    "descripcion":"TRASTORNO DEL SUEÑO CAUSADO POR METANFETAMINA"
  },
  {
    "codigo":138811000119100,
    "descripcion":"COMPLICACIÓN DEBIDA A DIABETES MELLITUS SECUNDARIA"
  },
  {
    "codigo":126771007,
    "descripcion":"NEOPLASIA DE BORDE BERMELLÓN DE LABIO"
  },
  {
    "codigo":678971000119104,
    "descripcion":"QUERATOPATÍA BULLOSA PSEUDOFÁQUICA DE AMBOS OJOS"
  },
  {
    "codigo":292411000119105,
    "descripcion":"TRASTORNO DE NERVIO OBTURADOR IZQUIERDO"
  },
  {
    "codigo":190472002,
    "descripcion":"PANHIPOPITUITARISMO POSINFARTO"
  },
  {
    "codigo":12268091000119107,
    "descripcion":"SÍNDROME COMPARTIMENTAL TRAUMÁTICO DE MIEMBRO INFERIOR IZQUIERDO"
  },
  {
    "codigo":1088571000119107,
    "descripcion":"OTITIS MEDIA SUPURATIVA CRÓNICA DEL OÍDO MEDIO IZQUIERDO"
  },
  {
    "codigo":126011000119107,
    "descripcion":"FÍSTULA CAROTIDEOCAVERNOSA ADQUIRIDA"
  },
  {
    "codigo":1080891000119108,
    "descripcion":"GLIOMA ÓPTICO MALIGNO PRIMARIO DE OJO DERECHO"
  },
  {
    "codigo":62011000119109,
    "descripcion":"INCOMPETENCIA DE TEJIDO RECTOVAGINAL"
  },
  {
    "codigo":128571000119108,
    "descripcion":"NEOPLASIA POSTERIOR A TRASPLANTE DE RIÑÓN"
  },
  {
    "codigo":18491000119109,
    "descripcion":"TRASTORNO PSICOLÓGICO DURANTE EL EMBARAZO"
  },
  {
    "codigo":10970171000119108,
    "descripcion":"HERIDA ABIERTA DE PIE DERECHO DEBIDA A MORDEDURA DE ANIMAL"
  },
  {
    "codigo":10624571000119106,
    "descripcion":"OSIFICACIÓN DE LIGAMENTO LONGITUDINAL ANTERIOR DE COLUMNA VERTEBRAL"
  },
  {
    "codigo":418013002,
    "descripcion":"REFLEJO DE DEFECACIÓN ANORMAL - CONSTIPADO"
  },
  {
    "codigo":120891000119109,
    "descripcion":"INSUFICIENCIA CARDÍACA DIASTÓLICA, ESTADIO C"
  },
  {
    "codigo":59400006,
    "descripcion":"NEFROPATÍA POR ANALGÉSICOS"
  },
  {
    "codigo":188637007,
    "descripcion":"ENFERMEDAD DE SÉZARY DE GANGLIOS LINFÁTICOS DE MÚLTIPLES LOCALIZACIONES"
  },
  {
    "codigo":874930000,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN ESCROTO"
  },
  {
    "codigo":1237213009,
    "descripcion":"MASA QUE OCUPA PARTE DE CUADRANTE SUPERIOR IZQUIERDO DE ABDOMEN"
  },
  {
    "codigo":57565008,
    "descripcion":"QUEMADURA PROFUNDA DE TERCER GRADO DEL PIE"
  },
  {
    "codigo":448946000,
    "descripcion":"ORIENTACIÓN ANTEROPOSTERIOR DE VÁLVULA PULMONAR BICÚSPIDE"
  },
  {
    "codigo":341461000119103,
    "descripcion":"FORMA COMBINADA DE CATARATA CONGÉNITA DE OJO IZQUIERDO"
  },
  {
    "codigo":840327002,
    "descripcion":"SISTEMA NERVIOSO SENSITIVO INTACTO"
  },
  {
    "codigo":21127004,
    "descripcion":"NACIMIENTO DE TÉRMINO DE RECIÉN NACIDO DE SEXO MASCULINO"
  },
  {
    "codigo":447111007,
    "descripcion":"MALFORMACIÓN VASCULAR DIEULAFOY DE ESTÓMAGO"
  },
  {
    "codigo":314204000,
    "descripcion":"ETAPA INICIAL DEL EMBARAZO"
  },
  {
    "codigo":283271008,
    "descripcion":"VIDRIO EN TOBILLO"
  },
  {
    "codigo":445276002,
    "descripcion":"TENDINITIS DEL EXTENSOR CUBITAL DEL CARPO"
  },
  {
    "codigo":84828003,
    "descripcion":"LEUCOPENIA"
  },
  {
    "codigo":281436001,
    "descripcion":"DESPLAZAMIENTO DE INJERTO ÓSEO"
  },
  {
    "codigo":707420003,
    "descripcion":"HIPERTENSIÓN PORTAL DEBIDA A FIBROSIS QUÍSTICA"
  },
  {
    "codigo":443441000,
    "descripcion":"SINCINESIA DE CARA"
  },
  {
    "codigo":248668009,
    "descripcion":"RUIDO CARDÍACO INAUDIBLE"
  },
  {
    "codigo":115761000,
    "descripcion":"FENOTIPO DE GRUPO SANGUÍNEO RR^ - ^"
  },
  {
    "codigo":312369005,
    "descripcion":"ESTUDIO DOPPLER NORMAL"
  },
  {
    "codigo":1229873009,
    "descripcion":"SÍNDROME DE MICRODELECIÓN 17Q24.2"
  },
  {
    "codigo":212230003,
    "descripcion":"CONTUSIÓN, PLEXO BRAQUIAL, TODAS LAS RAÍCES (COMPLETA)"
  },
  {
    "codigo":408838003,
    "descripcion":"PARTO DOMICILIARIO NO PLANIFICADO"
  },
  {
    "codigo":277766008,
    "descripcion":"PERCEPCIÓN DEL LATIDO CARDÍACO"
  },
  {
    "codigo":210395000,
    "descripcion":"HERIDA ABIERTA DE LA FARINGE"
  },
  {
    "codigo":1258971000,
    "descripcion":"ESGUINCE DE LIGAMENTO DE ARTICULACIÓN INTERFALÁNGICA PROXIMAL DE DEDO DE MANO"
  },
  {
    "codigo":1162502008,
    "descripcion":"INCLINACIÓN DE PIEZAS DENTALES"
  },
  {
    "codigo":112091009,
    "descripcion":"RASGO DE PERSONALIDAD OBSESIVO-COMPULSIVA"
  },
  {
    "codigo":295560008,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE PRILOCAÍNA"
  },
  {
    "codigo":110256004,
    "descripcion":"CONTUSIÓN LINGUAL"
  },
  {
    "codigo":700080009,
    "descripcion":"INFRAERUPCIÓN DENTARIA"
  },
  {
    "codigo":288521000119101,
    "descripcion":"PROBLEMA RELACIONADO CON DIFICULTAD PARA MANEJAR LA VIDA"
  },
  {
    "codigo":370565006,
    "descripcion":"AGRESIÓN RELACIONADA CON EL MIEDO"
  },
  {
    "codigo":303194003,
    "descripcion":"METÁSTASIS EN GANGLIOS LINFÁTICOS DE CABEZA Y CUELLO"
  },
  {
    "codigo":237658004,
    "descripcion":"PSEUDOHIPOPARATIROIDISMO Y PSEUDOPSEUDOHIPOPARATIROIDISMO"
  },
  {
    "codigo":204890004,
    "descripcion":"HIPOSPADIAS PERINEAL"
  },
  {
    "codigo":170287000,
    "descripcion":"EXAMEN ANORMAL DE NIÑO DE 3 AÑOS DE EDAD - DERIVADO"
  },
  {
    "codigo":235823004,
    "descripcion":"TRASTORNO DE LA MOTILIDAD INTESTINAL"
  },
  {
    "codigo":301359009,
    "descripcion":"DOLOR EN ESTRUCTURA LINFORRETICULAR"
  },
  {
    "codigo":168452002,
    "descripcion":"EXAMEN FORENSE NORMAL"
  },
  {
    "codigo":201220003,
    "descripcion":"ACNÉ OCUPACIONAL"
  },
  {
    "codigo":233988005,
    "descripcion":"ANEURISMA DE ARTERIA CARÓTIDA"
  },
  {
    "codigo":102916005,
    "descripcion":"ARACNOFOBIA"
  },
  {
    "codigo":397828008,
    "descripcion":"NEUROPATÍA DEL NERVIO MEDIANO"
  },
  {
    "codigo":299524009,
    "descripcion":"ARTICULACIÓN DEL PIE - HELADA"
  },
  {
    "codigo":428761002,
    "descripcion":"RUPTURA DEL MÚSCULO PECTORAL MAYOR"
  },
  {
    "codigo":365060009,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA TOMAR TURNOS EN UNA CONVERSACIÓN"
  },
  {
    "codigo":35545005,
    "descripcion":"DEGENERACIÓN SECUNDARIA DEL EPITELIO PIGMENTARIO DE LA RETINA"
  },
  {
    "codigo":363225006,
    "descripcion":"TRASTORNO DEL APARATO RESPIRATORIO NEONATAL"
  },
  {
    "codigo":263086002,
    "descripcion":"FRACTURA-LUXACIÓN DE PULGAR"
  },
  {
    "codigo":295854002,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE DESIPRAMINA"
  },
  {
    "codigo":33710003,
    "descripcion":"TRICOESTRONGILIASIS"
  },
  {
    "codigo":230318005,
    "descripcion":"DISTONÍA FAMILIAR IDIOPÁTICA"
  },
  {
    "codigo":721838005,
    "descripcion":"HIPERTRIPTOFANEMIA FAMILIAR"
  },
  {
    "codigo":31875000,
    "descripcion":"ANERGIA"
  },
  {
    "codigo":294019001,
    "descripcion":"ALERGIA A CARBACOL"
  },
  {
    "codigo":425091001,
    "descripcion":"DIFICULTAD PARA ESCUCHAR LOS TONOS DEL HABLA NORMAL"
  },
  {
    "codigo":720003003,
    "descripcion":"ORINA ROJIZA"
  },
  {
    "codigo":228483001,
    "descripcion":"UTILIZA DUCHA VAGINAL COMO MÉTODO DE PROTECCIÓN EN LAS RELACIONES SEXUALES"
  },
  {
    "codigo":193880000,
    "descripcion":"PTERIGIÓN PERIFÉRICO, ESTACIONARIO"
  },
  {
    "codigo":95576001,
    "descripcion":"DILATACIÓN DE URÉTER"
  },
  {
    "codigo":292184001,
    "descripcion":"REACCIÓN ADVERSA A LA OXIBUPROCAÍNA"
  },
  {
    "codigo":161112004,
    "descripcion":"ANALFABETISMO"
  },
  {
    "codigo":783704005,
    "descripcion":"CARCINOMA INDIFERENCIADO DE ESÓFAGO"
  },
  {
    "codigo":317501000119100,
    "descripcion":"DETENCIÓN PARCIAL DEL CRECIMIENTO EPIFISARIO DE TIBIA PROXIMAL DERECHA"
  },
  {
    "codigo":1142317000,
    "descripcion":"ATROFIA DE MÚSCULO DE MANO"
  },
  {
    "codigo":290349002,
    "descripcion":"INTOXICACIÓN POR MISOPROSTOL"
  },
  {
    "codigo":93741004,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE HUESO DEL CARPO"
  },
  {
    "codigo":126509007,
    "descripcion":"NEOPLASIA DE LA PIEL DEL TÓRAX"
  },
  {
    "codigo":91906001,
    "descripcion":"AUSENCIA CONGÉNITA DE ARCO DE VÉRTEBRA SACRA"
  },
  {
    "codigo":386818006,
    "descripcion":"CONDUCTA ASOCIAL EN EL NIÑO O EL ADOLESCENTE"
  },
  {
    "codigo":124674009,
    "descripcion":"DEFICIENCIA DE LISOLECITINA ACILMUTASA"
  },
  {
    "codigo":288514009,
    "descripcion":"QUEMADURA CON COMPROMISO DE 5% DE LA SUPERFICIE CORPORAL"
  },
  {
    "codigo":1204183003,
    "descripcion":"OCLUSIÓN AGUDA DE ARTERIA POPLÍTEA DEBIDA A TROMBOEMBOLISMO"
  },
  {
    "codigo":286679006,
    "descripcion":"AGRESIÓN PASIVA - MECANISMO DE DEFENSA PSICOLÓGICA"
  },
  {
    "codigo":1236951007,
    "descripcion":"VOLUMEN PLACENTARIO POR ENCIMA DE RANGO DE REFERENCIA"
  },
  {
    "codigo":284844005,
    "descripcion":"DIFICULTAD PARA LAVARSE LOS DIENTES"
  },
  {
    "codigo":53633000,
    "descripcion":"PÓLIPOS DE PEUTZ - JEGHERS DEL INTESTINO DELGADO"
  },
  {
    "codigo":1003905001,
    "descripcion":"DUPLICACIÓN DE PORCIÓN PROXIMAL DEL CROMOSOMA 21"
  },
  {
    "codigo":448684008,
    "descripcion":"PROLAPSO DE CÚSPIDE CORONARIA IZQUIERDA DE VÁLVULA AÓRTICA"
  },
  {
    "codigo":16019671000119101,
    "descripcion":"SINOVITIS TRANSITORIA DE AMBAS ARTICULACIONES GLENOHUMERALES"
  },
  {
    "codigo":445014002,
    "descripcion":"ENCEFALITIS LÍMBICA PARANEOPLÁSICA"
  },
  {
    "codigo":248406004,
    "descripcion":"ANILLO AJUSTADO EN DEDOS DE LA MANO"
  },
  {
    "codigo":51798006,
    "descripcion":"NIVEL DE GLUCOSA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":246571003,
    "descripcion":"REFLEJO DE MORO ASIMÉTRICO"
  },
  {
    "codigo":127191000119104,
    "descripcion":"CHOQUE SÉPTICO CONCOMITANTE CON DISFUNCIÓN ORGÁNICA AGUDA CAUSADO POR STAPHYLOCOCCUS AUREUS SENSIBLE A LA METICILINA"
  },
  {
    "codigo":1196843005,
    "descripcion":"HEMANGIOMA COROIDEO DIFUSO"
  },
  {
    "codigo":441344004,
    "descripcion":"VIRUS PARAINFLUENZA HUMANO PRESENTE"
  },
  {
    "codigo":736256005,
    "descripcion":"REACCIÓN PERSISTENTE A PICADURA DE INSECTO"
  },
  {
    "codigo":48128006,
    "descripcion":"ATROFIA DE GLÁNDULA SALIVAL"
  },
  {
    "codigo":18801000119100,
    "descripcion":"NEUROPATÍA DE MÚLTIPLES NERVIOS CRANEALES"
  },
  {
    "codigo":767189000,
    "descripcion":"QUISTE SINOVIAL DE MÚLTIPLES ARTICULACIONES"
  },
  {
    "codigo":346481000119100,
    "descripcion":"NEOVASCULARIZACIÓN DE AMBAS CÓRNEAS"
  },
  {
    "codigo":211968009,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO SUPERFICIAL DE PIE"
  },
  {
    "codigo":898261004,
    "descripcion":"ANQUILOSIS CONGÉNITA DE ARTICULACIÓN INTERFALÁNGICA DE DEDO GORDO"
  },
  {
    "codigo":404906000,
    "descripcion":"CONFUSIÓN POSOPERATORIA"
  },
  {
    "codigo":372138000,
    "descripcion":"CARCINOMA DE ESÓFAGO"
  },
  {
    "codigo":699818003,
    "descripcion":"LEUCEMIA LINFOCÍTICA GRANULAR DE LINFOCITOS T GRANDES"
  },
  {
    "codigo":109994006,
    "descripcion":"TROMBOCITEMIA ESENCIAL"
  },
  {
    "codigo":208298007,
    "descripcion":"FRACTURA NO EXPUESTA DEL OLÉCRANON, INTRARTICULAR"
  },
  {
    "codigo":403071000,
    "descripcion":"TIÑA CAUSADA POR MICROSPORUM FERRUGINEUM"
  },
  {
    "codigo":1156735001,
    "descripcion":"SOBREDOSIS DE AGONISTA DE RECEPTOR DE ERITROPOYETINA"
  },
  {
    "codigo":40788000,
    "descripcion":"HIPOSFAGMA"
  },
  {
    "codigo":401236004,
    "descripcion":"INSOMNIO DEL DESPERTAR TEMPRANO POR LA MAÑANA"
  },
  {
    "codigo":302932006,
    "descripcion":"DESGARRO DE MENISCO INTERNO DE LA RODILLA"
  },
  {
    "codigo":301097002,
    "descripcion":"HALLAZGO RELACIONADO CON EL VENTRÍCULO DERECHO"
  },
  {
    "codigo":1251369002,
    "descripcion":"ANGIOEDEMA ADQUIRIDO TIPO II"
  },
  {
    "codigo":168190000,
    "descripcion":"ORGANISMO CULTIVADO EN MUESTRA"
  },
  {
    "codigo":6185008,
    "descripcion":"ENFERMEDAD ASOCIADA CON HELICOBACTER"
  },
  {
    "codigo":397566000,
    "descripcion":"QUERATOCONJUNTIVITIS POR MICROSPORIDIA"
  },
  {
    "codigo":233726000,
    "descripcion":"FIBROSIS PULMONAR LOCALIZADA"
  },
  {
    "codigo":100721000119109,
    "descripcion":"ASTROCITOMA CEREBRAL DE ALTO GRADO"
  },
  {
    "codigo":364798007,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA DEGLUTIR ALIMENTOS"
  },
  {
    "codigo":231891000,
    "descripcion":"ESTAFILOMA INTERCALAR"
  },
  {
    "codigo":723411003,
    "descripcion":"SÍNDROME DE LIPOMA NASOPALPEBRAL Y COLOBOMA"
  },
  {
    "codigo":788947003,
    "descripcion":"GLAUCOMA DEBIDO A NEOPLASIA INTRAOCULAR"
  },
  {
    "codigo":262824005,
    "descripcion":"SECCIÓN DE BAZO"
  },
  {
    "codigo":426664006,
    "descripcion":"RITMO ACELERADO DE LA UNIÓN AURICULOVENTRICULAR EN EL ELECTROCARDIOGRAMA"
  },
  {
    "codigo":721576006,
    "descripcion":"ANGIOSARCOMA PRIMARIO DE MAMA"
  },
  {
    "codigo":785277001,
    "descripcion":"PATRÓN PERJUDICIAL DE USO DE ANFETAMINA Y\/O DERIVADO DE ANFETAMINA"
  },
  {
    "codigo":457597009,
    "descripcion":"OCLUSIÓN DE VENA ILÍACA"
  },
  {
    "codigo":128082002,
    "descripcion":"SÍNDROME DE DUANE, TIPO 1"
  },
  {
    "codigo":291922003,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR VITAMINA A"
  },
  {
    "codigo":10963451000119106,
    "descripcion":"LACERACIÓN DE DEDO MEDIO IZQUIERDO"
  },
  {
    "codigo":1142055000,
    "descripcion":"ENFERMEDAD DERMATOLÓGICA MODIFICADA EN INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":290087004,
    "descripcion":"PEZÓN DE TAMAÑO NORMAL"
  },
  {
    "codigo":716071007,
    "descripcion":"ANTÍGENO DE LEGIONELLA NO DETECTADO"
  },
  {
    "codigo":1240359008,
    "descripcion":"CARCINOMA NEUROENDOCRINO MICROCÍTICO CON METÁSTASIS A PRÓSTATA"
  },
  {
    "codigo":1172988001,
    "descripcion":"DIENTES ECTÓPICOS"
  },
  {
    "codigo":189948006,
    "descripcion":"SCHWANNOMA"
  },
  {
    "codigo":417489001,
    "descripcion":"ALIMENTACIÓN DEL LACTANTE A LOS 4 MESES"
  },
  {
    "codigo":124412009,
    "descripcion":"DEFICIENCIA DE LISOFOSFOLIPASA"
  },
  {
    "codigo":253649001,
    "descripcion":"TÚNEL AÓRTICO"
  },
  {
    "codigo":286417007,
    "descripcion":"CAPAZ DE REALIZAR SERVICIO DE BANQUETES"
  },
  {
    "codigo":1234854000,
    "descripcion":"DERMATOSIS CAUSADA POR INMUNOSUPRESOR"
  },
  {
    "codigo":24273009,
    "descripcion":"ANQUILOSIS DE ARTICULACIÓN DE LA CADERA"
  },
  {
    "codigo":251814002,
    "descripcion":"MAMAS EN ESTADIO 3 DE TANNER"
  },
  {
    "codigo":448422001,
    "descripcion":"SEPSIS DEBIDA A STREPTOCOCCUS SUIS"
  },
  {
    "codigo":284582005,
    "descripcion":"ASTILLA DE MADERA EN LA NARIZ"
  },
  {
    "codigo":22438006,
    "descripcion":"ANEMIA POR ALTERACIÓN DE LA PROLIFERACIÓN Y\/O DIFERENCIACIÓN DE LAS CÉLULAS MADRE HEMATOPOYÉTICAS"
  },
  {
    "codigo":186278007,
    "descripcion":"TUBERCULOSIS MILIAR AGUDA DE MÚLTIPLES LOCALIZACIONES"
  },
  {
    "codigo":415654007,
    "descripcion":"NEOPLASIA DE SUBMUCOSA GASTROINTESTINAL"
  },
  {
    "codigo":315515001,
    "descripcion":"NACIDO EN ESCOCIA"
  },
  {
    "codigo":282747005,
    "descripcion":"LESIÓN ESTRUCTURAL DE NERVIO SIMPÁTICO"
  },
  {
    "codigo":249979008,
    "descripcion":"SÍNDROME DE PUSHER"
  },
  {
    "codigo":117072004,
    "descripcion":"UNIDAD DE HEMODERIVADO MEZCLADO"
  },
  {
    "codigo":84304005,
    "descripcion":"SÍNDROME DE DEFICIENCIA DEL CUERPO LÚTEO"
  },
  {
    "codigo":18768006,
    "descripcion":"INTOXICACIÓN POR DERIVADO DEL FENANTRENO"
  },
  {
    "codigo":442917000,
    "descripcion":"SÍNDROME DE INTERVALO QT LARGO FAMILIAR"
  },
  {
    "codigo":1231184009,
    "descripcion":"SINCINESIA DE NERVIO OCULOMOTOR"
  },
  {
    "codigo":51536009,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA ARTERIA HIPOGÁSTRICA"
  },
  {
    "codigo":311845003,
    "descripcion":"ESTRECHEZ DE INJERTO VENOSO"
  },
  {
    "codigo":49701002,
    "descripcion":"TRASTORNO DEL ESCROTO"
  },
  {
    "codigo":277242001,
    "descripcion":"TUMEFACCIÓN SOBRE EL SENO FRONTAL"
  },
  {
    "codigo":1293050002,
    "descripcion":"DEPÓSITO DE CALCIO EN BOLSA SEROSA DE PIE"
  },
  {
    "codigo":705061009,
    "descripcion":"SÍNDROME MIELODISPLÁSICO DE LA INFANCIA"
  },
  {
    "codigo":211706002,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO PROFUNDA DE MENTÓN"
  },
  {
    "codigo":703226008,
    "descripcion":"ANEURISMA CEREBRAL SACULAR FAMILIAR"
  },
  {
    "codigo":275407001,
    "descripcion":"RIÑÓN DOBLE CON PELVIS DOBLE"
  },
  {
    "codigo":322521000119104,
    "descripcion":"SINOVITIS TRANSITORIA DE CODO IZQUIERDO"
  },
  {
    "codigo":111567006,
    "descripcion":"SÍNDROME DE REFETOFF"
  },
  {
    "codigo":723848001,
    "descripcion":"OSTEOSARCOMA PRIMARIO DE HUESO MANDIBULAR"
  },
  {
    "codigo":766927009,
    "descripcion":"PEZÓN SUPERNUMERARIO FAMILIAR"
  },
  {
    "codigo":109732003,
    "descripcion":"RESTAURACIÓN DENTAL FLOJA"
  },
  {
    "codigo":765092004,
    "descripcion":"MIOPATÍA POR CUERPOS ESFEROIDES"
  },
  {
    "codigo":15723481000119106,
    "descripcion":"GANGLIÓN DE AMBAS MANOS"
  },
  {
    "codigo":240804006,
    "descripcion":"FIBRICOLIASIS"
  },
  {
    "codigo":371876007,
    "descripcion":"DISPOSITIVO EN EL SITIO DE INTERÉS"
  },
  {
    "codigo":271737000,
    "descripcion":"ANEMIA"
  },
  {
    "codigo":206201001,
    "descripcion":"CAPUT SUCCEDANEUM POR EXTRACCIÓN CON VENTOSA"
  },
  {
    "codigo":238969001,
    "descripcion":"SÍNDROME DE ARDOR EN ESCROTO"
  },
  {
    "codigo":1156473003,
    "descripcion":"PINEOCITOMA"
  },
  {
    "codigo":402809007,
    "descripcion":"MALFORMACIÓN CONGÉNITA DE VASO LINFÁTICO DE PIEL"
  },
  {
    "codigo":106062002,
    "descripcion":"HALLAZGO RELACIONADO CON EL DIAFRAGMA"
  },
  {
    "codigo":1285710008,
    "descripcion":"GLAUCOMA DE ÁNGULO ABIERTO FÁRMACO-INDUCIDO"
  },
  {
    "codigo":300835002,
    "descripcion":"CAPAZ DE REALIZAR ACTIVIDADES DE MANTENIMIENTO DEL AUTO"
  },
  {
    "codigo":38691007,
    "descripcion":"NEGLIGENCIA SEXUAL"
  },
  {
    "codigo":366371009,
    "descripcion":"HALLAZGO RELACIONADO CON EL TAMAÑO DE LA FONTANELA"
  },
  {
    "codigo":167928002,
    "descripcion":"MÉDULA ÓSEA CON HIPOPLASIA MIELOIDE"
  },
  {
    "codigo":724984003,
    "descripcion":"DISTENSIÓN DE FASCIA DE MÚSCULO EXTENSOR DE MÚSCULO AL NIVEL DEL ANTEBRAZO"
  },
  {
    "codigo":351501000119100,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE OVARIO IZQUIERDO"
  },
  {
    "codigo":4088009,
    "descripcion":"HIDROCEFALIA ADQUIRIDA"
  },
  {
    "codigo":299000009,
    "descripcion":"AMPLITUD DE SUPINACIÓN PASIVA DE LA MUÑECA DISMINUIDA"
  },
  {
    "codigo":723149006,
    "descripcion":"FALLA SUDOMOTORA PURA IDIOPÁTICA"
  },
  {
    "codigo":1149133007,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR COMPUESTO DE HIERRO FÉRRICO"
  },
  {
    "codigo":360866000,
    "descripcion":"DEFICIENCIA DE INOSINASA"
  },
  {
    "codigo":459170001,
    "descripcion":"EMBARAZO GEMELAR MONOCORIÓNICO DIAMNIÓTICO CON VOLÚMENES DISÍMILES DE LÍQUIDO AMNIÓTICO"
  },
  {
    "codigo":10837261000119102,
    "descripcion":"FRACTURA EXPUESTA DE TERCER HUESO METACARPIANO DE MANO IZQUIERDA"
  },
  {
    "codigo":262562003,
    "descripcion":"LACERACIÓN PROFUNDA"
  },
  {
    "codigo":295330004,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE MEDIO DE CONTRASTE PARA RESONANCIA MAGNÉTICA"
  },
  {
    "codigo":721314003,
    "descripcion":"NEOPLASIA DE CÉLULAS RETICULARES FIBROBLÁSTICAS"
  },
  {
    "codigo":297165008,
    "descripcion":"MEMBRANA DUODENAL"
  },
  {
    "codigo":33186007,
    "descripcion":"ESPERMATORREA"
  },
  {
    "codigo":719479000,
    "descripcion":"CAPAZ DE PONERSE DE PIE DESDE UNA SILLA TRAS MÁS DE UN INTENTO"
  },
  {
    "codigo":1145463001,
    "descripcion":"APLASIA DE HUESO NASAL"
  },
  {
    "codigo":1088781000119104,
    "descripcion":"EXOSTOSIS DE CONDUCTO AUDITIVO EXTERNO IZQUIERDO"
  },
  {
    "codigo":424567005,
    "descripcion":"ONCOCITOMA BENIGNO DE GLÁNDULA SALIVAL"
  },
  {
    "codigo":293495006,
    "descripcion":"REACCIÓN ADVERSA A FÁRMACO ANTIHIPERTENSIVO"
  },
  {
    "codigo":31351009,
    "descripcion":"SÍNDROME MENOPÁUSICO POSTARTIFICIAL"
  },
  {
    "codigo":95052004,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE PIEL DE MAMA"
  },
  {
    "codigo":291660005,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR CLORANFENICOL"
  },
  {
    "codigo":783180007,
    "descripcion":"SÍNDROME COMBINADO DE DISFUNCIÓN CON HIPERACTIVIDAD DE NERVIOS CRANEALES"
  },
  {
    "codigo":1141793000,
    "descripcion":"PRURITO DE LENGUA"
  },
  {
    "codigo":160588008,
    "descripcion":"BEBEDOR DE BEBIDAS ALCOHÓLICAS FUERTES"
  },
  {
    "codigo":679181000119107,
    "descripcion":"DEGENERACIÓN NODULAR DE SALZMANN DE CÓRNEA DE OJO IZQUIERDO"
  },
  {
    "codigo":226124008,
    "descripcion":"DIETA CON BAJO CONTENIDO DE CARBOHIDRATOS SIMPLES"
  },
  {
    "codigo":93217003,
    "descripcion":"MELANOMA MALIGNO DE LA PIEL DE LA MEJILLA"
  },
  {
    "codigo":27681008,
    "descripcion":"GONORREA CRÓNICA"
  },
  {
    "codigo":124150005,
    "descripcion":"DEFICIENCIA DE GLUCONATO 2 - DESHIDROGENASA"
  },
  {
    "codigo":253387002,
    "descripcion":"CUERDAS TENDINOSAS TRICUSPÍDEAS EXCESIVAMENTE CORTAS"
  },
  {
    "codigo":417227004,
    "descripcion":"LESIÓN POR DESOLLAMIENTO DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":286155005,
    "descripcion":"INCAPAZ DE LIMPIAR LA DUCHA"
  },
  {
    "codigo":1300128003,
    "descripcion":"SÍNDROME DE RETRASO DEL DESARROLLO, MICROCEFALIA, TALLA BAJA, EPILEPSIA ASOCIADO A METENILTETRAHIDROFOLATO SINTETASA"
  },
  {
    "codigo":448160004,
    "descripcion":"ORIFICIO AÓRTICO EN REGIÓN POSTERIOR DERECHA DEL ORIFICIO PULMONAR"
  },
  {
    "codigo":284320003,
    "descripcion":"MANIPULA OBJETOS RELACIONADOS"
  },
  {
    "codigo":1003381002,
    "descripcion":"SÍNDROME DE ONICOTRICODISPLASIA"
  },
  {
    "codigo":315253007,
    "descripcion":"LESIÓN CUTÁNEA PIGMENTADA DE CONTORNO IRREGULAR"
  },
  {
    "codigo":20341008,
    "descripcion":"LESIÓN TRAUMÁTICA DE RIÑÓN SIN HERIDA ABIERTA HACIA CAVIDAD ABDOMINAL"
  },
  {
    "codigo":51274000,
    "descripcion":"ATEROSCLEROSIS DE ARTERIAS DE LAS EXTREMIDADES"
  },
  {
    "codigo":282485009,
    "descripcion":"DIFICULTAD PARA CORRER EN TERRENO PLANO"
  },
  {
    "codigo":870474004,
    "descripcion":"INGESTA INADECUADA DE VITAMINA E Y\/O DERIVADO DE VITAMINA E"
  },
  {
    "codigo":1263690009,
    "descripcion":"TRASTORNO NEONATAL PRECOZ DEBIDO A MUERTE MATERNA"
  },
  {
    "codigo":213279001,
    "descripcion":"OBSTRUCCIÓN COMO CONSECUENCIA DE CUERPO EXTRAÑO DEJADO EN EL PACIENTE DURANTE CIRUGÍA"
  },
  {
    "codigo":1163551001,
    "descripcion":"ENCEFALITIS POR VIRUS DEL MAL DEL BRINCO"
  },
  {
    "codigo":247882009,
    "descripcion":"PENSAMIENTOS OBSESIVOS ACERCA DE LOS GÉRMENES"
  },
  {
    "codigo":735732003,
    "descripcion":"ENFERMEDAD HEPÁTICA CONCOMITANTE CON TRASTORNO MITOCONDRIAL Y DEBIDA A ÉL"
  },
  {
    "codigo":440820004,
    "descripcion":"ENFERMEDAD LEVE POR DEFICIENCIA HEREDITARIA DE FACTOR VIII SIN INHIBIDORES"
  },
  {
    "codigo":47604008,
    "descripcion":"TUBERCULOSIS MILIAR"
  },
  {
    "codigo":209609005,
    "descripcion":"DESGARRO COMPLETO DEL PULGAR, ARTICULACIÓN INTERFALÁNGICA, LIGAMENTO LATERAL RADIAL"
  },
  {
    "codigo":78537008,
    "descripcion":"HIPERCEMENTOSIS"
  },
  {
    "codigo":109470000,
    "descripcion":"ALTERACIÓN DE LA COLORACIÓN DEL ESMALTE DENTAL INTRÍNSECA DE LA ERITROBLASTOSIS FETAL"
  },
  {
    "codigo":371614003,
    "descripcion":"HEMATOMA DE HERIDA OBSTÉTRICA"
  },
  {
    "codigo":240542006,
    "descripcion":"CONDILOMA ACUMINADO DE LA REGIÓN ANOGENITAL"
  },
  {
    "codigo":699294006,
    "descripcion":"DESNERVACIÓN DE ESFÍNTER EXTERNO DE LA URETRA"
  },
  {
    "codigo":1354654007,
    "descripcion":"DOLOR A LA PALPACIÓN DE TESTÍCULO DERECHO"
  },
  {
    "codigo":42099002,
    "descripcion":"MIOCARDIOPATÍA PRIMARIA RESTRICTIVA CON FIBROSIS ENDOMIOCÁRDICA"
  },
  {
    "codigo":9331004,
    "descripcion":"CUERPO NO IDENTIFICADO"
  },
  {
    "codigo":271475004,
    "descripcion":"NEOPLASIA BENIGNA DE COSTILLAS, ESTERNÓN Y\/O CLAVÍCULA"
  },
  {
    "codigo":304243005,
    "descripcion":"ACEPTACIÓN DE LA IDEA DE MORIR"
  },
  {
    "codigo":369779007,
    "descripcion":"FORMACIÓN DE TÚBULOS MAMARIOS: MODERADA, 10% A 75% (PUNTAJE = 2)"
  },
  {
    "codigo":402547008,
    "descripcion":"CARCINOMA BASOCELULAR RECIDIVANTE - RECIDIVAS MÚLTIPLES (MÁS DE TRES VECES)"
  },
  {
    "codigo":1187144005,
    "descripcion":"MIELOPATÍA CAUSADA POR MANDIOCA"
  },
  {
    "codigo":354011000119107,
    "descripcion":"NEOPLASIA BENIGNA DE HUESO CORTO DE MIEMBRO SUPERIOR DERECHO"
  },
  {
    "codigo":681691000119107,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE TRACTO GASTROINTESTINAL"
  },
  {
    "codigo":202269004,
    "descripcion":"CONTRACTURA EN ROTACIÓN INTERNA DE HOMBRO"
  },
  {
    "codigo":890397005,
    "descripcion":"ENCORVAMIENTO CONGÉNITO DE CÚBITO"
  },
  {
    "codigo":366109004,
    "descripcion":"RESPUESTA OPTOCINÉTICA - HALLAZGO"
  },
  {
    "codigo":300573007,
    "descripcion":"SACO GESTACIONAL AUSENTE"
  },
  {
    "codigo":235037007,
    "descripcion":"LESIÓN PIGMENTADA DE LA MUCOSA ORAL"
  },
  {
    "codigo":169501005,
    "descripcion":"FRACASO DEL DIAFRAGMA - EMBARAZO"
  },
  {
    "codigo":724722007,
    "descripcion":"TRASTORNO DE ANSIEDAD CAUSADO POR FÁRMACO DISOCIATIVO"
  },
  {
    "codigo":165831001,
    "descripcion":"TÍTULO DE ANTIESTREPTOLISINA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":298738009,
    "descripcion":"HALLAZGO RELACIONADO CON EL MOVIMIENTO DE LAS COSTILLAS"
  },
  {
    "codigo":427975003,
    "descripcion":"TRASTORNO DELIRANTE INDUCIDO POR FÁRMACO"
  },
  {
    "codigo":1148871006,
    "descripcion":"GLOMERULOPATÍA DEBIDA A SÍNDROME NEFRÓTICO CONGÉNITO TIPO FINLANDÉS"
  },
  {
    "codigo":296903008,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE TESTOSTERONA"
  },
  {
    "codigo":196764005,
    "descripcion":"CICATRIZ DUODENAL"
  },
  {
    "codigo":295068008,
    "descripcion":"ALERGIA A ERGOMETRINA"
  },
  {
    "codigo":1145201004,
    "descripcion":"MIGRACIÓN POSOPERATORIA DE OCLUSOR SEPTAL"
  },
  {
    "codigo":194929007,
    "descripcion":"ENDOCARDITIS - TIFOIDEA"
  },
  {
    "codigo":127558001,
    "descripcion":"HALLAZGO EN LA DENSIDAD"
  },
  {
    "codigo":1208902002,
    "descripcion":"CONJUNTIVITIS CICATRIZANTE AGUDA DEBIDA A SÍNDROME DE STEVENS-JOHNSON"
  },
  {
    "codigo":291398001,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR PROSTAGLANDINA"
  },
  {
    "codigo":782918002,
    "descripcion":"ACIDURIA 2-AMINOADÍPICA 2-OXOADÍPICA"
  },
  {
    "codigo":94790007,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL ESÓFAGO CERVICAL"
  },
  {
    "codigo":422470007,
    "descripcion":"ADENOLINFOMA"
  },
  {
    "codigo":1010459001,
    "descripcion":"BLOQUEO DE CONDUCCIÓN NERVIOSA SENSITIVA IZQUIERDA"
  },
  {
    "codigo":289563004,
    "descripcion":"SECRECIÓN VAGINAL INODORA"
  },
  {
    "codigo":846619006,
    "descripcion":"INGESTA EXCESIVA DE GRASAS Y ACEITES"
  },
  {
    "codigo":92955008,
    "descripcion":"FORMA ANORMAL CONGÉNITA DEL ANILLO TIMPÁNICO"
  },
  {
    "codigo":123888000,
    "descripcion":"INTOXICACIÓN POR ARACEAE"
  },
  {
    "codigo":254960002,
    "descripcion":"ADENOMA GONADOTRÓFICO"
  },
  {
    "codigo":253125000,
    "descripcion":"HAMARTOMA ESPINAL"
  },
  {
    "codigo":386032009,
    "descripcion":"OSTEOCONDRITIS DEL ASTRÁGALO"
  },
  {
    "codigo":1172464009,
    "descripcion":"ESTRADIOL DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":56517003,
    "descripcion":"HEMORRAGIA ESPLÉNICA"
  },
  {
    "codigo":449733007,
    "descripcion":"QUERATOSIS ACTÍNICA HIPERQUERATÓSICA"
  },
  {
    "codigo":285893008,
    "descripcion":"CAPAZ DE UTILIZAR UTENSILIOS DE COCINA"
  },
  {
    "codigo":447898000,
    "descripcion":"SEPSIS CAUSADA POR ACTINOMYCES"
  },
  {
    "codigo":21914002,
    "descripcion":"ANEMIA POR DISFUNCIÓN TIROIDEA"
  },
  {
    "codigo":251290003,
    "descripcion":"OBSERVACIONES DE LA EVALUACIÓN DENTAL"
  },
  {
    "codigo":87450004,
    "descripcion":"LESIÓN TRAUMÁTICA DEL NERVIO RADIAL"
  },
  {
    "codigo":54682008,
    "descripcion":"HIPOPLASIA CONGÉNITA DE LA ARTERIA PULMONAR"
  },
  {
    "codigo":282223002,
    "descripcion":"INCAPAZ DE CAMINAR SOBRE UNA LÍNEA ANGOSTA"
  },
  {
    "codigo":249455002,
    "descripcion":"CURVATURA DE LA CUERDA VOCAL DURANTE LA FONACIÓN"
  },
  {
    "codigo":413295004,
    "descripcion":"PREOCUPADO POR EL PROPIO CONSUMO DE DROGAS"
  },
  {
    "codigo":216687004,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR BENCENO"
  },
  {
    "codigo":247620001,
    "descripcion":"PENSAMIENTO AUMENTADO"
  },
  {
    "codigo":313156008,
    "descripcion":"ESOTROPÍA CÍCLICA"
  },
  {
    "codigo":444228009,
    "descripcion":"BLANQUEAMIENTO DE PIEL DE PIE AL ELEVARLO"
  },
  {
    "codigo":15675561000119107,
    "descripcion":"TENDINITIS CALCIFICANTE DE AMBOS TENDONES DE AQUILES"
  },
  {
    "codigo":737305006,
    "descripcion":"DOLOR CRÓNICO PRIMARIO"
  },
  {
    "codigo":49177006,
    "descripcion":"DEFECTO DE COAGULACIÓN POSTPARTO CON HEMORRAGIA"
  },
  {
    "codigo":735470000,
    "descripcion":"LESIÓN TRAUMÁTICA CUTÁNEA AGUDA CAUSADA POR SUSTANCIA CORROSIVA"
  },
  {
    "codigo":16409009,
    "descripcion":"TUBERCULOSIS DE LOS GANGLIOS LINFÁTICOS RETROPERITONEALES"
  },
  {
    "codigo":278553009,
    "descripcion":"ENCHAPADO DENTAL PRESENTE"
  },
  {
    "codigo":1259758000,
    "descripcion":"CÁNCER DE PULMÓN NO MICROCÍTICO PRIMARIO POSITIVO PARA EL GEN DE ESPECIES REACTIVAS DEL OXÍGENO 1"
  },
  {
    "codigo":702702004,
    "descripcion":"INTOXICACIÓN POR INHIBIDOR DE CALCINEURINA"
  },
  {
    "codigo":276718008,
    "descripcion":"ACTIVIDAD EN ZONA DE INSERCIÓN AUMENTADA"
  },
  {
    "codigo":405955004,
    "descripcion":"ANAPLASIA DIFUSA"
  },
  {
    "codigo":307651005,
    "descripcion":"MIELOFIBROSIS PRIMARIA"
  },
  {
    "codigo":10904000,
    "descripcion":"POSICIÓN CORPORAL ORTOSTÁTICA"
  },
  {
    "codigo":78275009,
    "descripcion":"SÍNDROME DE APNEA OBSTRUCTIVA DEL SUEÑO"
  },
  {
    "codigo":305816000,
    "descripcion":"ATENDIDO POR SERVICIO DE CITOGENÉTICA CLÍNICA"
  },
  {
    "codigo":895640003,
    "descripcion":"FORMA TRIANGULAR ANORMAL CONGÉNITA DE FALANGE DE DEDO DE PIE"
  },
  {
    "codigo":209347008,
    "descripcion":"FRACTURA-SUBLUXACIÓN EXPUESTA DE ARTICULACIÓN FEMORORROTULIANA"
  },
  {
    "codigo":404120006,
    "descripcion":"RETICULOSIS PAGETOIDE LOCALIZADA"
  },
  {
    "codigo":369517002,
    "descripcion":"NEOPLASIA MALIGNA QUE COMPROMETE TROMPA DE FALOPIO IZQUIERDA POR PROPAGACIÓN DIRECTA DESDE TROMPA DE FALOPIO DERECHA"
  },
  {
    "codigo":238445006,
    "descripcion":"MICROSPORIDA"
  },
  {
    "codigo":402285007,
    "descripcion":"DERMATITIS DE CONTACTO IRRITATIVA POR RELAMERSE LOS LABIOS"
  },
  {
    "codigo":236610003,
    "descripcion":"ESCAPE DE ORINA DESDE URÉTER TRASPLANTADO"
  },
  {
    "codigo":1186882005,
    "descripcion":"MIELOPATÍA POR LESIÓN VENENOSA"
  },
  {
    "codigo":302146005,
    "descripcion":"ACCESO A MEDIOS DE TRANSPORTE Y HALLAZGOS RELACIONADOS"
  },
  {
    "codigo":300311004,
    "descripcion":"HALLAZGO RELACIONADO CON LA APARIENCIA DEL RECTO"
  },
  {
    "codigo":298476002,
    "descripcion":"SENSACIÓN DE ESTRUCTURA MUSCULOESQUELÉTICA DEL CUELLO- HALLAZGO"
  },
  {
    "codigo":724460004,
    "descripcion":"SANGRADO UTERINO DE CAUSA NO MENSTRUAL POSTERIOR A PROCEDIMIENTO"
  },
  {
    "codigo":167404009,
    "descripcion":"NIVEL DE ADRENALINA EN ORINA FUERA DE RANGO DE REFERENCIA"
  },
  {
    "codigo":722625002,
    "descripcion":"LACERACIÓN FOCAL DE TRONCO ENCEFÁLICO"
  },
  {
    "codigo":165569003,
    "descripcion":"TIEMPO DE PROTROMBINA DISMINUIDO"
  },
  {
    "codigo":1279681005,
    "descripcion":"INFECCIÓN CAUSADA POR BORRELIA VENEZUELENSIS"
  },
  {
    "codigo":1148609006,
    "descripcion":"ELECTRORRETINOGRAMA DE DESTELLO BRILLANTE CON ADAPTACIÓN A OSCURIDAD ANORMAL"
  },
  {
    "codigo":788161007,
    "descripcion":"REACCIÓN ADVERSA A CONSTITUYENTE DE INMUNOGLOBULINA"
  },
  {
    "codigo":425878001,
    "descripcion":"TRASTORNO DE DISCO INTERVERTEBRAL CERVICAL"
  },
  {
    "codigo":130966005,
    "descripcion":"PENA CRÓNICA SECUNDARIA A EVENTO DEL CICLO VITAL"
  },
  {
    "codigo":196502009,
    "descripcion":"SIALODOCOLITIASIS PAROTÍDEA"
  },
  {
    "codigo":30271000175102,
    "descripcion":"ÚLCERA POR PRESIÓN EN CODO IZQUIERDO, ESTADIO I"
  },
  {
    "codigo":129131007,
    "descripcion":"POLINEURITIS INFECCIOSA AGUDA"
  },
  {
    "codigo":1144939008,
    "descripcion":"COLITIS CAUSADA POR VASCULITIS POR INMUNOGLOBULINA A"
  },
  {
    "codigo":127296001,
    "descripcion":"LESIÓN TRAUMÁTICA INTRACRANEAL"
  },
  {
    "codigo":292971006,
    "descripcion":"REACCIÓN ADVERSA A LA PIVAMPICILINA"
  },
  {
    "codigo":12291000132102,
    "descripcion":"LEUCEMIA MIELOIDE AGUDA REFRACTARIA"
  },
  {
    "codigo":291136007,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR RISPERIDONA"
  },
  {
    "codigo":94528006,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LOS GANGLIOS LINFÁTICOS ESCALENOS"
  },
  {
    "codigo":92693001,
    "descripcion":"CARCINOMA IN SITU DEL PÍLORO"
  },
  {
    "codigo":27157002,
    "descripcion":"TIEMPO DE RELLENO CAPILAR DISMINUIDO"
  },
  {
    "codigo":420373003,
    "descripcion":"TRASTORNO ALÉRGICO DEL APARATO DIGESTIVO"
  },
  {
    "codigo":289301003,
    "descripcion":"CORDÓN UMBILICAL DELGADO"
  },
  {
    "codigo":715285004,
    "descripcion":"PERIODONTITIS CRÓNICA LOCALIZADA LEVE"
  },
  {
    "codigo":190997006,
    "descripcion":"INMUNODEFICIENCIA GRAVE COMBINADA CON BAJO RECUENTO DE LINFOCITOS B Y T"
  },
  {
    "codigo":387605007,
    "descripcion":"ESTADO CRONOBIOLÓGICO ANORMAL"
  },
  {
    "codigo":713450000,
    "descripcion":"NEUROPATÍA CAUSADA POR ISONIAZIDA"
  },
  {
    "codigo":59925007,
    "descripcion":"PARACOCCIDIOIDOMICOSIS"
  },
  {
    "codigo":780821007,
    "descripcion":"CARCINOMA PAPILAR-MUCINOSO INTRADUCTAL INVASIVO DE PÁNCREAS"
  },
  {
    "codigo":189162003,
    "descripcion":"NEOPLASIA BENIGNA DE CEREBRO, SUPRATENTORIAL"
  },
  {
    "codigo":90858003,
    "descripcion":"ANGIODISPLASIA DE COLON"
  },
  {
    "codigo":1336042003,
    "descripcion":"GLAUCOMA DEBIDO A IRIS PLANO"
  },
  {
    "codigo":254698004,
    "descripcion":"FIBROMA PERIFOLICULAR"
  },
  {
    "codigo":711615005,
    "descripcion":"ENTROPIÓN DE PÁRPADO SUPERIOR CONCOMITANTE CON ECTROPIÓN DE PÁRPADO SUPERIOR"
  },
  {
    "codigo":416703007,
    "descripcion":"VASCULITIS RETINIANA POR POLIARTERITIS NUDOSA"
  },
  {
    "codigo":1332372003,
    "descripcion":"INFLAMACIÓN DE NERVIO PERIFÉRICO DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":54420005,
    "descripcion":"LUXACIÓN EXPUESTA DE DEDO DE LA MANO"
  },
  {
    "codigo":283796005,
    "descripcion":"MORDEDURA DE ANIMAL EN LA NARIZ"
  },
  {
    "codigo":52585001,
    "descripcion":"NEUROPATÍA CIÁTICA"
  },
  {
    "codigo":609641005,
    "descripcion":"NEUROPATÍA POR COMPRESIÓN DE NERVIO ILIOINGUINAL"
  },
  {
    "codigo":773481006,
    "descripcion":"ALERGIA AL ÁCIDO CLODRÓNICO"
  },
  {
    "codigo":312894000,
    "descripcion":"OSTEOPENIA"
  },
  {
    "codigo":280126005,
    "descripcion":"TRASTORNO DE PARTES BLANDAS DE REGIÓN DE PARED CORPORAL"
  },
  {
    "codigo":704275001,
    "descripcion":"CONSENTIMIENTO PARA EXAMEN DEL SISTEMA GENITOURINARIO REHUSADO"
  },
  {
    "codigo":737043002,
    "descripcion":"AUMENTO DE LA VISUALIZACIÓN INCISAL AL SONREÍR"
  },
  {
    "codigo":278291005,
    "descripcion":"ROTACIÓN EXTERNA DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":39291000087101,
    "descripcion":"CUERPO EXTRAÑO EN MUSLO DERECHO"
  },
  {
    "codigo":49531000087104,
    "descripcion":"NÓDULO DE INTESTINO GRUESO"
  },
  {
    "codigo":34171000087105,
    "descripcion":"MÚLTIPLES LESIONES INTESTINALES TRAUMÁTICAS"
  },
  {
    "codigo":44411000087106,
    "descripcion":"LACERACIÓN COMPLEJA DE PABELLÓN AURICULAR IZQUIERDO"
  },
  {
    "codigo":41851000087105,
    "descripcion":"CELULITIS DE GLÚTEO DERECHO"
  },
  {
    "codigo":702440000,
    "descripcion":"SÍNDROME DE DEFICIENCIA DE CREATINA CEREBRAL TIPO 3"
  },
  {
    "codigo":1259496000,
    "descripcion":"DEMENCIA DEBIDA A ENFERMEDAD DE LYME"
  },
  {
    "codigo":46971000087104,
    "descripcion":"FRACTURA DE FALANGE MEDIA DE MEÑIQUE DERECHO"
  },
  {
    "codigo":733373001,
    "descripcion":"HERIDA PUNZANTE DE REGIÓN INFERIOR DEL DORSO CON CUERPO EXTRAÑO"
  },
  {
    "codigo":209085001,
    "descripcion":"SÍNDROME MEDULAR POSTERIOR DE MÉDULA LUMBAR DEBIDO A LUXACIÓN VERTEBRAL NO EXPUESTA DE COLUMNA LUMBAR"
  },
  {
    "codigo":241853003,
    "descripcion":"EFECTO TÓXICO CAUSADO POR LIMPIADOR DE LADRILLOS"
  },
  {
    "codigo":405693006,
    "descripcion":"LESIÓN TRAUMÁTICA PROVOCADA POR ELEMENTO DE SUJECIÓN LEGAL"
  },
  {
    "codigo":12477008,
    "descripcion":"DERMATITIS FOTOTÓXICA AGUDA"
  },
  {
    "codigo":698770000,
    "descripcion":"AMELOBLASTOMA INTRAÓSEO MULTIQUÍSTICO DE MANDÍBULA"
  },
  {
    "codigo":240018003,
    "descripcion":"ENTESOPATÍA DE TARSO"
  },
  {
    "codigo":403858004,
    "descripcion":"ACROCORDONES MÚLTIPLES DE LOS PÁRPADOS"
  },
  {
    "codigo":338117701000119103,
    "descripcion":"ÚLCERA VENOSA DE PIE IZQUIERDO"
  },
  {
    "codigo":305554006,
    "descripcion":"BAJO ATENCIÓN DE ENFERMERA"
  },
  {
    "codigo":860775000,
    "descripcion":"ALERGIA A IMIDAZOL"
  },
  {
    "codigo":371090009,
    "descripcion":"COLESTASIS POR NUTRICIÓN PARENTERAL"
  },
  {
    "codigo":762471001,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO PROFUNDA DE CARA"
  },
  {
    "codigo":269116003,
    "descripcion":"LUXACIÓN NO EXPUESTA DE LA ARTICULACIÓN ATLOAXOIDEA"
  },
  {
    "codigo":39740009,
    "descripcion":"INFECCIÓN CAUSADA POR RHIZOPUS"
  },
  {
    "codigo":400188009,
    "descripcion":"DERMATOSIS ACANTOLÍTICA LINEAL RECURRENTE"
  },
  {
    "codigo":1240541000000107,
    "descripcion":"INFECCIÓN DEL TRACTO RESPIRATORIO SUPERIOR CAUSADA POR SARS-COV-2"
  },
  {
    "codigo":5137004,
    "descripcion":"LUXACIÓN RECURRENTE DE ARTICULACIÓN"
  },
  {
    "codigo":70673006,
    "descripcion":"SÍNDROME DE INERVACIÓN ANORMAL"
  },
  {
    "codigo":234513007,
    "descripcion":"LEUCOCITOSIS POSESPLENECTOMÍA"
  },
  {
    "codigo":365585006,
    "descripcion":"NIVEL DE ANTICUERPOS ESPECÍFICOS - HALLAZGO"
  },
  {
    "codigo":15981791000119103,
    "descripcion":"SÍNDROME DE HIPERLAXITUD PALPEBRAL DE AMBOS OJOS"
  },
  {
    "codigo":298214006,
    "descripcion":"LAXITUD DE ARTICULACIÓN SACROILÍACA"
  },
  {
    "codigo":36070007,
    "descripcion":"SÍNDROME DE WISKOTT - ALDRICH"
  },
  {
    "codigo":134374006,
    "descripcion":"ANORMALIDAD BILATERAL EN PRUEBA AUDITIVA"
  },
  {
    "codigo":7391000119103,
    "descripcion":"CARCINOMA QUÍSTICO ADENOIDE PRIMARIO DE NASOFARINGE"
  },
  {
    "codigo":165307002,
    "descripcion":"MEMORIA: RECUERDA DIRECCIONES"
  },
  {
    "codigo":1344955003,
    "descripcion":"ETAPA DE MANTENIMIENTO PARA LOGRAR CAMBIOS EN CONDUCTA DE USO DE SUSTANCIAS"
  },
  {
    "codigo":296379004,
    "descripcion":"SOBREDOSIS DE AGONISTA BETA-ADRENÉRGICO"
  },
  {
    "codigo":198075006,
    "descripcion":"DISPAREUNIA DE CAUSA NO PSICÓGENA EN EL HOMBRE"
  },
  {
    "codigo":427451007,
    "descripcion":"TEMBLOR DISTÓNICO"
  },
  {
    "codigo":292709003,
    "descripcion":"REACCIÓN ADVERSA A LA PROSTAGLANDINA"
  },
  {
    "codigo":1144677004,
    "descripcion":"APLASIA DE FALANGE DISTAL DE CUARTO DEDO DE PIE"
  },
  {
    "codigo":128869009,
    "descripcion":"INFESTACIÓN POR SARCOPTES SCABIEI, VARIEDAD HOMINIS"
  },
  {
    "codigo":127034005,
    "descripcion":"PANCITOPENIA"
  },
  {
    "codigo":782394006,
    "descripcion":"NÓDULO DE PIEL DE MANO"
  },
  {
    "codigo":94266005,
    "descripcion":"NEOPLASIA MALIGNA SECUNDARIA DE NERVIO CRANEAL"
  },
  {
    "codigo":290874006,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR TRANILCIPROMINA"
  },
  {
    "codigo":59663001,
    "descripcion":"ACNÉ PREMENSTRUAL EN MUJERES ADULTAS"
  },
  {
    "codigo":715023001,
    "descripcion":"CAPAZ DE CAMINAR POR UN CORREDOR"
  },
  {
    "codigo":289039002,
    "descripcion":"NO SE ALIMENTA CON LA MANO DERECHA"
  },
  {
    "codigo":188900004,
    "descripcion":"NEOPLASIA BENIGNA DE MEDIASTINO POSTEROINFERIOR"
  },
  {
    "codigo":254436005,
    "descripcion":"CARCINOMA DE LA ÚVULA"
  },
  {
    "codigo":1237476007,
    "descripcion":"METÁSTASIS DE CARCINOMA DE HUESO DE MIEMBRO INFERIOR"
  },
  {
    "codigo":185230000,
    "descripcion":"ATENDIDO EN UN CONSULTORIO NEUROLÓGICO"
  },
  {
    "codigo":86926000,
    "descripcion":"AMPOLLA DE LA PARED TORÁCICA, SIN INFECCIÓN"
  },
  {
    "codigo":1268409009,
    "descripcion":"SINOSTOSIS RADIOCUBITAL CONGÉNITA"
  },
  {
    "codigo":447374000,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO DE CARA"
  },
  {
    "codigo":187065008,
    "descripcion":"BLASTOMICOSIS CUTÁNEA"
  },
  {
    "codigo":283534007,
    "descripcion":"HERIDA PUNZANTE DE MUSLO"
  },
  {
    "codigo":709518008,
    "descripcion":"DISFASIA ADQUIRIDA"
  },
  {
    "codigo":445539001,
    "descripcion":"DIVERTÍCULO DE VENTRÍCULO DERECHO"
  },
  {
    "codigo":609379005,
    "descripcion":"DEFORMIDAD EN FORMA DE ARCO DE PIERNA"
  },
  {
    "codigo":314467007,
    "descripcion":"ATROFIA GIRATA DE LA COROIDES Y\/O RETINA"
  },
  {
    "codigo":248931009,
    "descripcion":"SUPERFICIE DEL CUELLO UTERINO SALUDABLE"
  },
  {
    "codigo":247096002,
    "descripcion":"HALLAZGO PRERRETINIANO Y EPIRRETINIANO"
  },
  {
    "codigo":83256006,
    "descripcion":"HEMORROIDES ESTRANGULADAS"
  },
  {
    "codigo":337581000119100,
    "descripcion":"AMBLIOPÍA POR ESTRABISMO DEL OJO IZQUIERDO"
  },
  {
    "codigo":81421001,
    "descripcion":"INFECCIÓN CAUSADA POR ASCARIS SUUM"
  },
  {
    "codigo":440531000124109,
    "descripcion":"INGESTA EXCESIVA DE PSYLLIUM"
  },
  {
    "codigo":48653005,
    "descripcion":"LESIÓN TRAUMÁTICA DE APÉNDICE ILEOCECAL SIN HERIDA ABIERTA HACIA CAVIDAD ABDOMINAL"
  },
  {
    "codigo":736781007,
    "descripcion":"AUSENCIA CONGÉNITA DE CÓNDILO MANDIBULAR DERECHO"
  },
  {
    "codigo":79586000,
    "descripcion":"EMBARAZO TUBÁRICO"
  },
  {
    "codigo":704013006,
    "descripcion":"FRACTURA EXPUESTA DE MANO"
  },
  {
    "codigo":1074861000119102,
    "descripcion":"ARTRITIS DE ARTICULACIÓN DE RODILLA DERECHA"
  },
  {
    "codigo":733111000,
    "descripcion":"TRASTORNO CONGÉNITO DE GLICOSILACIÓN TIPO 1W"
  },
  {
    "codigo":472802009,
    "descripcion":"ESTENOSIS SUBPULMONAR ASOCIADA CON CORAZÓN FUNCIONALMENTE UNIVENTRICULAR COMO COMPLICACIÓN DE PROCEDIMIENTO"
  },
  {
    "codigo":307127004,
    "descripcion":"DEFICIENCIA AISLADA DE HIDROXIACIL-COA DESHIDROGENASA DE CADENA LARGA"
  },
  {
    "codigo":700343005,
    "descripcion":"DERMATITIS ECCEMATOSA DE PÁRPADO SUPERIOR"
  },
  {
    "codigo":44983007,
    "descripcion":"DISCOPATÍA CON MIELOPATÍA"
  },
  {
    "codigo":239756002,
    "descripcion":"LUXACIÓN NEUROMUSCULAR DE LA ARTICULACIÓN DE LA CADERA"
  },
  {
    "codigo":10380004,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DE DEDO DE LA MANO"
  },
  {
    "codigo":403596007,
    "descripcion":"HIPERALGESIA CUTÁNEA"
  },
  {
    "codigo":237921002,
    "descripcion":"TRASTORNO DE LA SÍNTESIS DE CATECOLAMINAS"
  },
  {
    "codigo":303457004,
    "descripcion":"DIFICULTAD PARA ACUCLILLARSE SOBRE EL INODORO"
  },
  {
    "codigo":399926001,
    "descripcion":"NEVO COLÁGENO DE PIEL"
  },
  {
    "codigo":236086003,
    "descripcion":"FILTRACIÓN POR ANASTOMOSIS ESOFÁGICA"
  },
  {
    "codigo":301622004,
    "descripcion":"NO UTILIZA ASCENSOR"
  },
  {
    "codigo":170550007,
    "descripcion":"ENFERMEDAD CRÓNICA - GENERAL"
  },
  {
    "codigo":268854008,
    "descripcion":"INSUFICIENCIA RENAL CONGÉNITA"
  },
  {
    "codigo":365323000,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA LIMPIAR PISOS"
  },
  {
    "codigo":299787002,
    "descripcion":"REFLEJO DE OJOS DE MUÑECA VERTICAL AUSENTE"
  },
  {
    "codigo":723936000,
    "descripcion":"TRASTORNO PSICÓTICO CAUSADO POR CANNABIS"
  },
  {
    "codigo":232416001,
    "descripcion":"CIERRE INCOMPLETO DE APARATO VELOFARÍNGEO DEBIDO A DISFUNCIÓN NEUROMUSCULAR"
  },
  {
    "codigo":396256001,
    "descripcion":"MARGEN QUIRÚRGICO EXOCERVICAL COMPROMETIDO POR NEOPLASIA MALIGNA"
  },
  {
    "codigo":297952003,
    "descripcion":"COLOR CUTÁNEO NORMAL"
  },
  {
    "codigo":363488008,
    "descripcion":"NEOPLASIA MALIGNA DE CUERDA VOCAL FALSA"
  },
  {
    "codigo":197813005,
    "descripcion":"HEMATOMA INTRARRENAL"
  },
  {
    "codigo":427189007,
    "descripcion":"CONSUMO MATERNO DE TABACO"
  },
  {
    "codigo":230581008,
    "descripcion":"NEUROPATÍA EN ACROMEGALIA"
  },
  {
    "codigo":163210008,
    "descripcion":"AORTA PALPABLE"
  },
  {
    "codigo":1179018009,
    "descripcion":"DEFORMIDAD ANGULAR DE HUESO LARGO"
  },
  {
    "codigo":259679003,
    "descripcion":"SIDEROBLASTOS ANILLADOS"
  },
  {
    "codigo":11999201000119104,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO DE BRAZO DERECHO"
  },
  {
    "codigo":95839005,
    "descripcion":"TRASTORNO DE LA FIBRINÓLISIS"
  },
  {
    "codigo":126772000,
    "descripcion":"NEOPLASIA DE BORDE BERMELLÓN DE LABIO SUPERIOR"
  },
  {
    "codigo":292447009,
    "descripcion":"REACCIÓN ADVERSA A LA FENOXIBENZAMINA"
  },
  {
    "codigo":290612000,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR MELFALÁN"
  },
  {
    "codigo":94004004,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE HUESO CORTO DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":421684006,
    "descripcion":"DEFICIENCIA DE HORMONA DE CRECIMIENTO DEL ADULTO"
  },
  {
    "codigo":59401005,
    "descripcion":"QUISTE DE TROMPA DE FALOPIO"
  },
  {
    "codigo":419849006,
    "descripcion":"EXPRESA VERBALMENTE LA TOLERANCIA A LA ACTIVIDAD"
  },
  {
    "codigo":92169007,
    "descripcion":"NEOPLASIA BENIGNA DE LA GLÁNDULA LAGRIMAL"
  },
  {
    "codigo":288777009,
    "descripcion":"INCAPAZ DE COMUNICAR INTENCIONES"
  },
  {
    "codigo":1237214003,
    "descripcion":"MASA QUE OCUPA PARTE DE CUADRANTE SUPERIOR DERECHO DE ABDOMEN"
  },
  {
    "codigo":874931001,
    "descripcion":"SÍNDROME DE ACONDROPLASIA SEVERA, RETRASO DEL DESARROLLO, ACANTOSIS NIGRICANS"
  },
  {
    "codigo":416179002,
    "descripcion":"CONTUSIÓN DEL OJO Y DE LOS ANEXOS OCULARES"
  },
  {
    "codigo":341781000119100,
    "descripcion":"ESCOTOMA CENTRAL DE OJO IZQUIERDO"
  },
  {
    "codigo":290581000119101,
    "descripcion":"ATAXIA DEBIDA A ACCIDENTE CEREBROVASCULAR Y POSTERIOR A ÉL"
  },
  {
    "codigo":308501000119102,
    "descripcion":"GRANULOMA POR CUERPO EXTRAÑO DE PARTES BLANDAS DE HOMBRO"
  },
  {
    "codigo":12240661000119103,
    "descripcion":"EN TRATAMIENTO PROLONGADO CON ESTEROIDE SISTÉMICO"
  },
  {
    "codigo":447112000,
    "descripcion":"SECRECIÓN SEROSA POR HERIDA"
  },
  {
    "codigo":298261000119105,
    "descripcion":"MIOSITIS OSIFICANTE TRAUMÁTICA DE MUSLO"
  },
  {
    "codigo":15937301000119106,
    "descripcion":"DISTIQUIASIS CONGÉNITA DE PÁRPADO IZQUIERDO"
  },
  {
    "codigo":186803007,
    "descripcion":"LEISHMANIASIS VISCERAL"
  },
  {
    "codigo":10760981000119107,
    "descripcion":"MALTRATO PSICOLÓGICO QUE COMPLICA EL EMBARAZO"
  },
  {
    "codigo":15960341000119104,
    "descripcion":"ANGINA INESTABLE DEBIDA A ARTERIOESCLEROSIS DE INJERTO-PUENTE DE ARTERIA CORONARIA DE CORAZÓN TRASPLANTADO"
  },
  {
    "codigo":55731008,
    "descripcion":"DEFICIENCIA DE ARILSULFATASA SIN LEUCODISTROFIA METACROMÁTICA"
  },
  {
    "codigo":11810581000119105,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO DE CADERA IZQUIERDA"
  },
  {
    "codigo":1079061000119107,
    "descripcion":"ANGIOSARCOMA PRIMARIO DE REGIÓN DE CADERA DERECHA"
  },
  {
    "codigo":283272001,
    "descripcion":"VIDRIO EN PIE"
  },
  {
    "codigo":15911701000119106,
    "descripcion":"HEMATOMA TRAUMÁTICO DE LIGAMENTO ANCHO IZQUIERDO DE ÚTERO"
  },
  {
    "codigo":12207381000119107,
    "descripcion":"AFLOJAMIENTO DE PRÓTESIS DE ARTICULACIÓN DE RODILLA DERECHA"
  },
  {
    "codigo":15927061000119108,
    "descripcion":"LESIÓN DE PÁRPADO INFERIOR DERECHO"
  },
  {
    "codigo":281437005,
    "descripcion":"FRACTURA DE INJERTO ÓSEO"
  },
  {
    "codigo":707421004,
    "descripcion":"CARCINOMA PRIMARIO INDIFERENCIADO DE LARINGE"
  },
  {
    "codigo":1077371000119108,
    "descripcion":"OSTEOMIELITIS AGUDA DE PIE IZQUIERDO"
  },
  {
    "codigo":248669001,
    "descripcion":"VOLUMEN DEL RUIDO CARDÍACO, VARIABLE"
  },
  {
    "codigo":1297245002,
    "descripcion":"CIERRE DE ÁNGULO AGUDO DE OJO IZQUIERDO DEBIDO A NEOVASCULARIZACIÓN"
  },
  {
    "codigo":53896009,
    "descripcion":"EX FUMADOR TOLERANTE"
  },
  {
    "codigo":82994006,
    "descripcion":"DEFICIENCIA DE AMINOÁCIDOS"
  },
  {
    "codigo":312370006,
    "descripcion":"ESTUDIO DOPPLER ANORMAL"
  },
  {
    "codigo":81159000,
    "descripcion":"INTOXICACIÓN ALIMENTARIA CAUSADA POR VIBRIO PARAHAEMOLYTICUS"
  },
  {
    "codigo":246834009,
    "descripcion":"CICATRIZACIÓN DE PÁRPADO"
  },
  {
    "codigo":115762007,
    "descripcion":"FENOTIPO DE GRUPO SANGUÍNEO RH>MOD<"
  },
  {
    "codigo":212231004,
    "descripcion":"LESIÓN ABIERTA DE TRONCOS PRIMARIOS DE PLEXO BRAQUIAL"
  },
  {
    "codigo":408839006,
    "descripcion":"PARTO DOMICILIARIO PLANIFICADO"
  },
  {
    "codigo":46556004,
    "descripcion":"AMINOACIDEMIA"
  },
  {
    "codigo":1258972007,
    "descripcion":"SÍNDROME CEREBROFRONTOFACIAL DE BARAITSER WINTER"
  },
  {
    "codigo":77489003,
    "descripcion":"PTERIGIÓN"
  },
  {
    "codigo":896689003,
    "descripcion":"INFARTO AGUDO DE MIOCARDIO POR OBSTRUCCIÓN DE RAMA CIRCUNFLEJA DE LA ARTERIA CORONARIA IZQUIERDA"
  },
  {
    "codigo":110257008,
    "descripcion":"CONTUSIÓN DE MUCOSA YUGAL"
  },
  {
    "codigo":274097009,
    "descripcion":"VALVULOPATÍA CARDÍACA NO REUMÁTICA"
  },
  {
    "codigo":700081008,
    "descripcion":"TRASTORNO DEL PERINEO MASCULINO"
  },
  {
    "codigo":272262003,
    "descripcion":"ESTIÓMENO"
  },
  {
    "codigo":370566007,
    "descripcion":"AGRESIÓN DE AUTORIDAD"
  },
  {
    "codigo":403334008,
    "descripcion":"ALOPECIA POR CEPILLADO"
  },
  {
    "codigo":237659007,
    "descripcion":"PSEUDOPSEUDOHIPOPARATIROIDISMO"
  },
  {
    "codigo":369071000119105,
    "descripcion":"QUISTE RENAL CONGÉNITO"
  },
  {
    "codigo":399664002,
    "descripcion":"COMPROMISO TUMORAL DEL MARGEN QUIRÚRGICO PERIMETRAL, NO PUEDE SER EVALUADO"
  },
  {
    "codigo":301360004,
    "descripcion":"DOLOR DE GANGLIO LINFÁTICO"
  },
  {
    "codigo":170288005,
    "descripcion":"EXAMEN ANORMAL DE NIÑO DE 3 AÑOS DE EDAD - EN TRATAMIENTO"
  },
  {
    "codigo":71984005,
    "descripcion":"TRASTORNO BIPOLAR I MANÍACO LEVE"
  },
  {
    "codigo":235824005,
    "descripcion":"AUSENCIA DE PERISTALTISMO INTESTINAL"
  },
  {
    "codigo":397829000,
    "descripcion":"ASISTOLIA"
  },
  {
    "codigo":102917001,
    "descripcion":"HEMOFOBIA"
  },
  {
    "codigo":233989002,
    "descripcion":"ANEURISMA DE ARTERIA TRASPLANTADA"
  },
  {
    "codigo":168453007,
    "descripcion":"EXAMEN FORENSE ANORMAL"
  },
  {
    "codigo":365061008,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA MANTENER UNA CONVERSACIÓN"
  },
  {
    "codigo":16015791000119109,
    "descripcion":"ARTRITIS DE ARTICULACIÓN SUBASTRAGALINA IZQUIERDA"
  },
  {
    "codigo":723674005,
    "descripcion":"CRIOGLOBULINEMIA SIMPLE"
  },
  {
    "codigo":35546006,
    "descripcion":"GLOMERULONEFRITIS PROLIFERATIVA MESANGIAL"
  },
  {
    "codigo":363226007,
    "descripcion":"TRASTORNO TRAUMÁTICO NEONATAL"
  },
  {
    "codigo":428762009,
    "descripcion":"PICADURA DE INSECTO INFECTADA EN MANO"
  },
  {
    "codigo":230319002,
    "descripcion":"DISTONÍA IDIOPÁTICA FAMILIAR, AUTOSÓMICA DOMINANTE"
  },
  {
    "codigo":943003,
    "descripcion":"ANEURISMA RETINIANO CONGÉNITO"
  },
  {
    "codigo":263087006,
    "descripcion":"LUXACIÓN DE ARTICULACIÓN DE MIEMBRO INFERIOR"
  },
  {
    "codigo":1079881000119105,
    "descripcion":"NEVO DISPLÁSICO DE PIEL DE OÍDO EXTERNO DERECHO"
  },
  {
    "codigo":342601000119106,
    "descripcion":"LUPUS ERITEMATOSO DISCOIDE DE PÁRPADO INFERIOR DERECHO"
  },
  {
    "codigo":292185000,
    "descripcion":"REACCIÓN ADVERSA A LA PROCAÍNA"
  },
  {
    "codigo":193881001,
    "descripcion":"PTERIGIÓN PERIFÉRICO, PROGRESIVO"
  },
  {
    "codigo":62809003,
    "descripcion":"CÁLCULO DE CONDUCTO CÍSTICO CON OBSTRUCCIÓN"
  },
  {
    "codigo":128345004,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA TRÁQUEA"
  },
  {
    "codigo":95577005,
    "descripcion":"FIBROSIS RENAL INTERSTICIAL"
  },
  {
    "codigo":783705006,
    "descripcion":"HIPEREXPLEXIA ESPORÁDICA"
  },
  {
    "codigo":30041005,
    "descripcion":"GLAUCOMA AGUDO DE ÁNGULO ESTRECHO"
  },
  {
    "codigo":126510002,
    "descripcion":"NEOPLASIA DE LA PIEL DE LA MAMA"
  },
  {
    "codigo":290350002,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR MISOPROSTOL"
  },
  {
    "codigo":716334004,
    "descripcion":"SÍNDROME DE DISCAPACIDAD INTELECTUAL Y BAJA ESTATURA CON CONTRACTURA DE MANO Y ANOMALÍAS GENITALES"
  },
  {
    "codigo":1142318005,
    "descripcion":"ATROFIA DE MÚSCULO INTRÍNSECO DE MANO"
  },
  {
    "codigo":192046006,
    "descripcion":"REACCIÓN DE ADAPTACIÓN DEPRESIVA BREVE"
  },
  {
    "codigo":93742006,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE CARTÍLAGO NASAL"
  },
  {
    "codigo":124675005,
    "descripcion":"DEFICIENCIA DE FOSFOGLICERATO MUTASA"
  },
  {
    "codigo":91907005,
    "descripcion":"AUSENCIA CONGÉNITA DE VÉRTEBRA SACRA"
  },
  {
    "codigo":288515005,
    "descripcion":"QUEMADURA CON COMPROMISO DE 4% DE LA SUPERFICIE CORPORAL"
  },
  {
    "codigo":59139008,
    "descripcion":"DOLOR DE PECHO POR APLASTAMIENTO"
  },
  {
    "codigo":1236952000,
    "descripcion":"VOLUMEN PLACENTARIO POR DEBAJO DE RANGO DE REFERENCIA"
  },
  {
    "codigo":10939261000119100,
    "descripcion":"HERIDA ABIERTA DE BRAZO IZQUIERDO"
  },
  {
    "codigo":24536007,
    "descripcion":"POSICIÓN MENTOILÍACA DERECHA ANTERIOR"
  },
  {
    "codigo":286680009,
    "descripcion":"EVITACIÓN FÓBICA - MECANISMO DE DEFENSA PSICOLÓGICA"
  },
  {
    "codigo":1204184009,
    "descripcion":"OCLUSIÓN AGUDA DE ARTERIA CRURAL DEBIDA A TROMBOSIS"
  },
  {
    "codigo":1003906000,
    "descripcion":"DUPLICACIÓN DE PORCIÓN PROXIMAL DEL BRAZO LARGO DEL CROMOSOMA 1"
  },
  {
    "codigo":250242004,
    "descripcion":"ELIPTOCITOSIS"
  },
  {
    "codigo":86402005,
    "descripcion":"CONJUNTIVITIS FOLICULAR"
  },
  {
    "codigo":1231447001,
    "descripcion":"DESPRENDIMIENTO VÍTREO POSTERIOR AGUDO"
  },
  {
    "codigo":84567002,
    "descripcion":"ESPÉCIMEN ENMASCARADO POR PRESENCIA DE SANGRE"
  },
  {
    "codigo":1264215002,
    "descripcion":"INFECCIÓN FETAL CAUSADA POR STREPTOCOCCUS DEL GRUPO B"
  },
  {
    "codigo":248407008,
    "descripcion":"MANOS SUCIAS, MANCHADAS POR EL TRABAJO"
  },
  {
    "codigo":19031009,
    "descripcion":"DESPRENDIMIENTO COROIDEO HEMORRÁGICO"
  },
  {
    "codigo":49964003,
    "descripcion":"FETO ECTÓPICO"
  },
  {
    "codigo":82732003,
    "descripcion":"PARÁLISIS PERIÓDICA HIPOCALIÉMICA FAMILIAR"
  },
  {
    "codigo":1196844004,
    "descripcion":"ASTROCITOMA PRIMARIO MALIGNO DE ENCÉFALO"
  },
  {
    "codigo":312108008,
    "descripcion":"ENFERMEDAD INTESTINAL INFECCIOSA DE ORIGEN BACTERIANO"
  },
  {
    "codigo":211969001,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO SUPERFICIAL DE TOBILLO"
  },
  {
    "codigo":441345003,
    "descripcion":"VIRUS INFLUENZA B PRESENTE"
  },
  {
    "codigo":277505007,
    "descripcion":"MEDULOBLASTOMA DE CEREBELO"
  },
  {
    "codigo":898262006,
    "descripcion":"ANQUILOSIS CONGÉNITA DE ARTICULACIÓN INTERFALÁNGICA DE DEDO DE PIE"
  },
  {
    "codigo":111830007,
    "descripcion":"TUBERCULOSIS DE LOS ÓRGANOS URINARIOS"
  },
  {
    "codigo":308438006,
    "descripcion":"TABAQUISMO REINICIADO - HALLAZGO"
  },
  {
    "codigo":767190009,
    "descripcion":"GANGLIÓN DE HOMBRO"
  },
  {
    "codigo":109995007,
    "descripcion":"SÍNDROME MIELODISPLÁSICO (CLÍNICO)"
  },
  {
    "codigo":372139008,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA VESÍCULA BILIAR"
  },
  {
    "codigo":404907009,
    "descripcion":"MEGACOLON TÓXICO DEBIDO A INFECCIÓN POR CLOSTRIDIUM DIFFICILE"
  },
  {
    "codigo":403072007,
    "descripcion":"TIÑA CAUSADA POR TRICHOPHYTON MENTAGROPHYTES VARIANTE INTERDIGITALE"
  },
  {
    "codigo":302933001,
    "descripcion":"DESGARRO DE MENISCO EXTERNO DE LA RODILLA"
  },
  {
    "codigo":318641000119101,
    "descripcion":"ARTROSIS DE ARTICULACIÓN DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":73557005,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA VENA MAMARIA INTERNA"
  },
  {
    "codigo":366634000,
    "descripcion":"HALLAZGO RELACIONADO CON COLORACIÓN DE ARTICULACIÓN DE PIE"
  },
  {
    "codigo":204629008,
    "descripcion":"LUXACIÓN DE LA LENGUA"
  },
  {
    "codigo":1251370001,
    "descripcion":"ANGIOEDEMA ADQUIRIDO TIPO I"
  },
  {
    "codigo":401237008,
    "descripcion":"ACCIONES VIOLENTAS DIRIGIDAS HACIA LOS DEMÁS"
  },
  {
    "codigo":202794004,
    "descripcion":"LUMBOCIATALGIA"
  },
  {
    "codigo":301098007,
    "descripcion":"VÁLVULA CARDÍACA - HALLAZGO"
  },
  {
    "codigo":299263003,
    "descripcion":"AMPLITUD DE ABDUCCIÓN ACTIVA DE LA CADERA NORMAL"
  },
  {
    "codigo":364799004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA DEGLUTIR SÓLIDOS"
  },
  {
    "codigo":11787441000119104,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE DEDO DE MANO DERECHA"
  },
  {
    "codigo":430335007,
    "descripcion":"APNEA PRIMARIA DEL RECIÉN NACIDO"
  },
  {
    "codigo":233727009,
    "descripcion":"FIBROSIS DE MEDIASTINO POR RADIACIÓN"
  },
  {
    "codigo":397567009,
    "descripcion":"QUERATOCONJUNTIVITIS CAUSADA POR MOLUSCO CONTAGIOSO"
  },
  {
    "codigo":68052005,
    "descripcion":"ASPIRACIÓN PULMONAR"
  },
  {
    "codigo":128331000119100,
    "descripcion":"ALTO RIESGO PARA CÁNCER DE CUELLO UTERINO"
  },
  {
    "codigo":231892007,
    "descripcion":"ÚLCERA DE CÓRNEA INFECCIOSA"
  },
  {
    "codigo":788948008,
    "descripcion":"GLAUCOMA DEBIDO A DESPRENDIMIENTO DE RETINA"
  },
  {
    "codigo":721577002,
    "descripcion":"LIPOSARCOMA PRIMARIO DE PARTES BLANDAS DE EXTREMIDAD"
  },
  {
    "codigo":361129004,
    "descripcion":"HIPERCALCEMIA CAUSADA POR LITIO"
  },
  {
    "codigo":33449004,
    "descripcion":"TRASTORNO DE LA PERSONALIDAD"
  },
  {
    "codigo":295593004,
    "descripcion":"SOBREDOSIS DE FÁRMACO INMUNOESTIMULANTE"
  },
  {
    "codigo":11842891000119102,
    "descripcion":"LESIÓN TRAUMÁTICA DE ARTERIA CARÓTIDA DERECHA"
  },
  {
    "codigo":293758007,
    "descripcion":"ALERGIA A DACARBAZINA"
  },
  {
    "codigo":31614008,
    "descripcion":"MOTIVACIÓN PERSONAL"
  },
  {
    "codigo":95315005,
    "descripcion":"LEIOMIOMA DEL ÚTERO"
  },
  {
    "codigo":128083007,
    "descripcion":"SÍNDROME DE DUANE, TIPO 2"
  },
  {
    "codigo":291923008,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR VITAMINA A"
  },
  {
    "codigo":1142056004,
    "descripcion":"ACCIDENTE CEREBROVASCULAR ISQUÉMICO NEONATAL"
  },
  {
    "codigo":707592003,
    "descripcion":"CARCINOMA DUCTAL INFILTRANTE PRIMARIO DE OROFARINGE"
  },
  {
    "codigo":419325003,
    "descripcion":"SÍNDROME DE BROWN-MCLEAN"
  },
  {
    "codigo":386557006,
    "descripcion":"HALLAZGO RELACIONADO CON LA ESCALA DE COMA DE GLASGOW"
  },
  {
    "codigo":253650001,
    "descripcion":"AORTA HACIA EL TÚNEL DEL VENTRÍCULO DERECHO"
  },
  {
    "codigo":286418002,
    "descripcion":"INCAPAZ DE REALIZAR SERVICIO DE BANQUETES"
  },
  {
    "codigo":1269458003,
    "descripcion":"NEOPLASIA MALIGNA DE VAINA DE NERVIO PERIFÉRICO DE NERVIO PERIFÉRICO DE COLUMNA VERTEBRAL LUMBAR"
  },
  {
    "codigo":89810003,
    "descripcion":"TALASEMIA ^A^GAMMA DELTA BETA^0^"
  },
  {
    "codigo":284583000,
    "descripcion":"ASTILLA DE MADERA EN LA BOCA"
  },
  {
    "codigo":251815001,
    "descripcion":"MAMAS EN ESTADIO 4 DE TANNER"
  },
  {
    "codigo":415655008,
    "descripcion":"NEOPLASIA DE SUBMUCOSA DE ESTÓMAGO"
  },
  {
    "codigo":282748000,
    "descripcion":"LESIÓN DE NERVIO PARASIMPÁTICO"
  },
  {
    "codigo":315516000,
    "descripcion":"NACIDO EN SENEGAL"
  },
  {
    "codigo":86140003,
    "descripcion":"CÓSMIDO"
  },
  {
    "codigo":249980006,
    "descripcion":"TIRA HACIA ADELANTE EN FLEXIÓN"
  },
  {
    "codigo":1003644007,
    "descripcion":"AGENESIA DE AMBOS PIES"
  },
  {
    "codigo":53372009,
    "descripcion":"SIGMOIDITIS NO INFECCIOSA"
  },
  {
    "codigo":248145004,
    "descripcion":"MOVIMIENTO FACIAL INAPROPIADO"
  },
  {
    "codigo":739665005,
    "descripcion":"LESIÓN TRAUMÁTICA COMPLETA DE MÉDULA ESPINAL"
  },
  {
    "codigo":84305006,
    "descripcion":"ENDOMETRIOSIS DEL PARAMETRIO"
  },
  {
    "codigo":1263953006,
    "descripcion":"NECROSIS TUBULAR RENAL POSTERIOR A EMBARAZO ECTÓPICO"
  },
  {
    "codigo":82470000,
    "descripcion":"FASCICULACIÓN"
  },
  {
    "codigo":117073009,
    "descripcion":"UNIDAD DE HEMODERIVADO VENCIDA"
  },
  {
    "codigo":1296721008,
    "descripcion":"SINOVITIS CRÓNICA DE HOMBRO DEBIDA A HEMARTROSIS"
  },
  {
    "codigo":1231185005,
    "descripcion":"SÍNDROME DE OPSOCLONO MIOCLONO PARANEOPLÁSICO"
  },
  {
    "codigo":16934004,
    "descripcion":"ENFERMEDAD VASCULAR RENAL"
  },
  {
    "codigo":705062002,
    "descripcion":"ATENDIDO EN CONSULTORIO ESPECIALIZADO EN CIRUGÍA BARIÁTRICA"
  },
  {
    "codigo":1293051003,
    "descripcion":"DISTROFIA UNGUEAL CAUSADA POR SUSTANCIA QUÍMICA"
  },
  {
    "codigo":703227004,
    "descripcion":"STREPTOCOCCUS LUTETIENSIS O STREPTOCOCCUS BOVIS"
  },
  {
    "codigo":277243006,
    "descripcion":"ERITEMA SOBRE EL SENO FRONTAL"
  },
  {
    "codigo":211707006,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO PROFUNDA DE LA NARIZ"
  },
  {
    "codigo":111568001,
    "descripcion":"SÍNDROME HIPOTALÁMICO"
  },
  {
    "codigo":766928004,
    "descripcion":"SÍNDROME DE HAMARTOMA FOLICULAR BASALOIDE GENERALIZADO"
  },
  {
    "codigo":275408006,
    "descripcion":"INSUFICIENCIA RENAL POSOPERATORIA"
  },
  {
    "codigo":371877003,
    "descripcion":"DISPOSITIVO INSERTADO EN LA FUNDA"
  },
  {
    "codigo":238970000,
    "descripcion":"PROCTODINIA"
  },
  {
    "codigo":765093009,
    "descripcion":"SÍNDROME DE EPILEPSIA ROLÁNDICA CON DISPRAXIA DEL HABLA"
  },
  {
    "codigo":402810002,
    "descripcion":"MALFORMACIÓN DEL DESARROLLO DE UN ARCO BRANQUIAL"
  },
  {
    "codigo":208037009,
    "descripcion":"FRACTURA VERTEBRAL NO EXPUESTA CON LESIÓN POSTERIOR DE MÉDULA ESPINAL DORSAL, D7-12"
  },
  {
    "codigo":206202008,
    "descripcion":"HEMORRAGIA SUBAPONEURÓTICA EPICRANEAL MASIVA DEBIDA A TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":9594009,
    "descripcion":"AGLUTINACIÓN CERVICAL"
  },
  {
    "codigo":1156474009,
    "descripcion":"HEMANGIOBLASTOMA"
  },
  {
    "codigo":40527005,
    "descripcion":"HEMOSIDEROSIS PULMONAR IDIOPÁTICA"
  },
  {
    "codigo":106063007,
    "descripcion":"HALLAZGO EN EL SISTEMA CARDIOVASCULAR"
  },
  {
    "codigo":38692000,
    "descripcion":"PROTEINOSIS LIPÍDICA"
  },
  {
    "codigo":300836001,
    "descripcion":"INCAPAZ DE REALIZAR ACTIVIDADES DE MANTENIMIENTO DEL AUTO"
  },
  {
    "codigo":366372002,
    "descripcion":"HALLAZGO RELACIONADO CON EL NIVEL DE LA FONTANELA"
  },
  {
    "codigo":1285711007,
    "descripcion":"GLAUCOMA DE ÁNGULO ABIERTO DE OJO DERECHO CAUSADO POR FÁRMACO"
  },
  {
    "codigo":4089001,
    "descripcion":"MENINGOCOCCEMIA"
  },
  {
    "codigo":36857002,
    "descripcion":"ONIQUIA DE DEDO DE LA MANO"
  },
  {
    "codigo":724985002,
    "descripcion":"DISTENSIÓN DE TENDÓN DE MÚSCULO EXTENSOR A LA ALTURA DEL ANTEBRAZO"
  },
  {
    "codigo":71460009,
    "descripcion":"TRIPANOSOMIASIS CON ENCEFALITIS"
  },
  {
    "codigo":167929005,
    "descripcion":"MÉDULA ÓSEA: CÉLULAS BLÁSTICAS PRIMITIVAS"
  },
  {
    "codigo":200697006,
    "descripcion":"LINFADENITIS AGUDA DE TRONCO"
  },
  {
    "codigo":299001008,
    "descripcion":"SIN AMPLITUD PASIVA DE SUPINACIÓN DE MUÑECA"
  },
  {
    "codigo":1149134001,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR COMPUESTO DE HIERRO FÉRRICO"
  },
  {
    "codigo":677811000119102,
    "descripcion":"ÉMBOLO RETINIANO DE COLESTEROL DE OJO DERECHO"
  },
  {
    "codigo":723150006,
    "descripcion":"HIPOHIDROSIS DE ETIOLOGÍA DESCONOCIDA"
  },
  {
    "codigo":459171002,
    "descripcion":"EMBARAZO GEMELAR MONOCORIÓNICO MONOAMNIÓTICO"
  },
  {
    "codigo":426403007,
    "descripcion":"INGRESO TARDÍO A ATENCIÓN PRENATAL"
  },
  {
    "codigo":424568000,
    "descripcion":"FIBROMA"
  },
  {
    "codigo":129656002,
    "descripcion":"COMPLICACIÓN DURANTE UN PROCEDIMIENTO DIAGNÓSTICO"
  },
  {
    "codigo":293496007,
    "descripcion":"REACCIÓN ADVERSA A FÁRMACO BLOQUEANTE ADRENÉRGICO NEURONALES"
  },
  {
    "codigo":160589000,
    "descripcion":"BEBEDOR DE CERVEZA"
  },
  {
    "codigo":1145464007,
    "descripcion":"APLASIA DE HUESO PREMAXILAR"
  },
  {
    "codigo":193357001,
    "descripcion":"RETINOPATÍA RENAL"
  },
  {
    "codigo":11874381000119101,
    "descripcion":"FRACTURA OSTEOPORÓTICA DE COSTILLA DERECHA"
  },
  {
    "codigo":783181006,
    "descripcion":"SÍNDROME DE CRÁNEO EN HOJA DE TRÉBOL Y DISPLASIA TORÁCICA ASFIXIANTE"
  },
  {
    "codigo":289826000,
    "descripcion":"HALLAZGO RELACIONADO CON DISPOSITIVO DEL CUELLO UTERINO"
  },
  {
    "codigo":95053009,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA PIEL DE LOS GLÚTEOS"
  },
  {
    "codigo":224290001,
    "descripcion":"EDUCACIÓN ININTERRUMPIDA"
  },
  {
    "codigo":226125009,
    "descripcion":"DIETA CON BAJO CONTENIDO EN CARBOHIDRATOS COMPLEJOS"
  },
  {
    "codigo":93218008,
    "descripcion":"MELANOMA MALIGNO DE LA PIEL DEL TÓRAX"
  },
  {
    "codigo":25847004,
    "descripcion":"PSORIASIS SEBORREICA"
  },
  {
    "codigo":124151009,
    "descripcion":"DEFICIENCIA DE DEHIDROGLUCONATO DESHIDROGENASA"
  },
  {
    "codigo":286156006,
    "descripcion":"LIMPIA LA DUCHA"
  },
  {
    "codigo":253388007,
    "descripcion":"CUERDAS TENDINOSAS TRICUSPÍDEAS EXCESIVAMENTE LARGAS"
  },
  {
    "codigo":448161000,
    "descripcion":"CABALGAMIENTO DE VÁLVULA AÓRTICA SOBRE EL TABIQUE INTERVENTRICULAR"
  },
  {
    "codigo":417228009,
    "descripcion":"CARTÍLAGOS ARITENOIDES Y PORCIÓN POSTERIOR DE LAS CUERDAS VOCALES VISIBLES"
  },
  {
    "codigo":251553000,
    "descripcion":"BLOQUEO DE FIBRA MUSCULAR AISLADA - HALLAZGO"
  },
  {
    "codigo":284321004,
    "descripcion":"NO MANIPULA OBJETOS INTERRELACIONADOS"
  },
  {
    "codigo":20342001,
    "descripcion":"CÁLCULO URETRAL"
  },
  {
    "codigo":315254001,
    "descripcion":"LESIÓN CUTÁNEA PIGMENTADA DE COLOR CAMBIANTE"
  },
  {
    "codigo":446326008,
    "descripcion":"ESTRECHEZ PREMATURA DEL AGUJERO OVAL"
  },
  {
    "codigo":870475003,
    "descripcion":"INGESTA EXCESIVA DE VITAMINA K Y\/O DERIVADO DE VITAMINA K"
  },
  {
    "codigo":247883004,
    "descripcion":"DUDAS OBSESIVAS"
  },
  {
    "codigo":1263691008,
    "descripcion":"TRASTORNO FETAL DEBIDO A MUERTE MATERNA"
  },
  {
    "codigo":213280003,
    "descripcion":"PERFORACIÓN COMO CONSECUENCIA DE CUERPO EXTRAÑO DEJADO EN EL PACIENTE DURANTE CIRUGÍA"
  },
  {
    "codigo":1163552008,
    "descripcion":"ENCEFALITIS POR VIRUS KOUTANGO"
  },
  {
    "codigo":1260021004,
    "descripcion":"CARCINOMA ADENOIDE DE CÉLULAS ESCAMOSAS DE HIPOFARINGE"
  },
  {
    "codigo":309749008,
    "descripcion":"PESTAÑA CLAVADA EN EL ORIFICIO LAGRIMAL"
  },
  {
    "codigo":111306001,
    "descripcion":"SÍNDROME DE LENTIGINOSIS MÚLTIPLE"
  },
  {
    "codigo":209610000,
    "descripcion":"DESGARRO COMPLETO DEL PULGAR, ARTICULACIÓN INTERFALÁNGICA, LIGAMENTO LATERAL CUBITAL"
  },
  {
    "codigo":15671681000119102,
    "descripcion":"MACRODACTILIA DE DEDO DE PIE DERECHO"
  },
  {
    "codigo":735733008,
    "descripcion":"CIRROSIS HEPÁTICA CONCOMITANTE CON COLANGITIS ESCLEROSANTE PRIMARIA Y DEBIDA A ELLA"
  },
  {
    "codigo":109471001,
    "descripcion":"AMELOGÉNESIS IMPERFECTA, TIPO HIPOCALCIFICACIÓN"
  },
  {
    "codigo":43935004,
    "descripcion":"ECTASIA VASCULAR DEL ANTRO GÁSTRICO"
  },
  {
    "codigo":1354655008,
    "descripcion":"DOLOR A LA PALPACIÓN DE TESTÍCULO IZQUIERDO"
  },
  {
    "codigo":271476003,
    "descripcion":"NEOPLASIA BENIGNA DE HUESOS CORTOS DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":402548003,
    "descripcion":"NEVO MELANOCÍTICO COMPUESTO VERRUGOSO"
  },
  {
    "codigo":42100005,
    "descripcion":"FIEBRE AMARILLA DE LA JUNGLA"
  },
  {
    "codigo":369780005,
    "descripcion":"FORMACIÓN DE TÚBULOS MAMARIOS: MÍNIMA < 10% (PUNTAJE = 3)"
  },
  {
    "codigo":1187145006,
    "descripcion":"NEUROPATÍA ÓPTICA DEBIDA A DEFICIENCIA DE TIAMINA"
  },
  {
    "codigo":890398000,
    "descripcion":"BRONCOCELE CONGÉNITO"
  },
  {
    "codigo":235038002,
    "descripcion":"PIGMENTACIÓN MELÁNICA DE LA MUCOSA ORAL"
  },
  {
    "codigo":202270003,
    "descripcion":"CONTRACTURA DE HOMBRO EN ROTACIÓN EXTERNA"
  },
  {
    "codigo":5662003,
    "descripcion":"CONTUSIÓN DE LA MANO"
  },
  {
    "codigo":398878007,
    "descripcion":"ESGUINCE LIGAMENTARIO"
  },
  {
    "codigo":298739001,
    "descripcion":"HALLAZGO RELACIONADO CON LA SENSIBILIDAD COSTAL"
  },
  {
    "codigo":724723002,
    "descripcion":"TRASTORNO DE ANSIEDAD CAUSADO POR KETAMINA"
  },
  {
    "codigo":167667006,
    "descripcion":"SANGRE OCULTA NO DETECTADA EN MATERIA FECAL"
  },
  {
    "codigo":3827008,
    "descripcion":"ANEURISMA DE ARTERIA DEL CUELLO"
  },
  {
    "codigo":722888000,
    "descripcion":"PALUDISMO CAUSADO POR PLASMODIUM NO FALCIPARUM"
  },
  {
    "codigo":165832008,
    "descripcion":"TÍTULO DE ANTIESTREPTOLISINA FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":719218000,
    "descripcion":"NEUMONÍA CRIPTOGÉNICA ORGANIZADA"
  },
  {
    "codigo":424306000,
    "descripcion":"EXANTEMA CAUSADO POR VIRUS DEL SARAMPIÓN"
  },
  {
    "codigo":31090002,
    "descripcion":"MATIDEZ CARDÍACA"
  },
  {
    "codigo":1145202006,
    "descripcion":"MIGRACIÓN POSOPERATORIA DE BANDA EN TRONCO DE ARTERIA PULMONAR"
  },
  {
    "codigo":62023000,
    "descripcion":"ANOMALÍA ARTERIAL DEL CORDÓN UMBILICAL"
  },
  {
    "codigo":293234009,
    "descripcion":"REACCIÓN ADVERSA A ANDRÓGENO"
  },
  {
    "codigo":422471006,
    "descripcion":"NECROSIS RETINIANA AGUDA POR HERPES ZÓSTER"
  },
  {
    "codigo":1208903007,
    "descripcion":"CONJUNTIVITIS TÓXICA AGUDA"
  },
  {
    "codigo":94791006,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA COLUMNA VERTEBRAL CERVICAL"
  },
  {
    "codigo":291399009,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR PROSTAGLANDINA"
  },
  {
    "codigo":191260004,
    "descripcion":"ANEMIA SIDEROBLÁSTICA SENSIBLE A PIRIDOXINA"
  },
  {
    "codigo":27420004,
    "descripcion":"VULVOVAGINITIS HERPÉTICA"
  },
  {
    "codigo":1010460006,
    "descripcion":"NISTAGMO UNIOCULAR DE OJO DERECHO"
  },
  {
    "codigo":289564005,
    "descripcion":"SECRECIÓN VAGINAL CON OLOR A PESCADO"
  },
  {
    "codigo":92956009,
    "descripcion":"FORMA ANORMAL CONGÉNITA DEL CÚBITO"
  },
  {
    "codigo":254961003,
    "descripcion":"ADENOMA HIPOFISARIO DE FUNCIÓN MIXTA"
  },
  {
    "codigo":386033004,
    "descripcion":"NEUROPATÍA"
  },
  {
    "codigo":418801006,
    "descripcion":"SÍNDROME DEL IRIS FLÁCCIDO INTRAOPERATORIO"
  },
  {
    "codigo":123889008,
    "descripcion":"INTOXICACIÓN POR ASTERACEAE"
  },
  {
    "codigo":25585008,
    "descripcion":"PLACENTA PERCRETA"
  },
  {
    "codigo":285894002,
    "descripcion":"INCAPAZ DE UTILIZAR UTENSILIOS DE COCINA"
  },
  {
    "codigo":449734001,
    "descripcion":"ASTIGMATISMO HIPERÓPICO"
  },
  {
    "codigo":682831000119104,
    "descripcion":"PÓLIPO BENIGNO DE DUODENO"
  },
  {
    "codigo":185755005,
    "descripcion":"INCUMPLIMIENTO DEL CONTROL DE DIABETES"
  },
  {
    "codigo":446064000,
    "descripcion":"QUISTE DE ABDOMEN"
  },
  {
    "codigo":249456001,
    "descripcion":"CUERDA VOCAL NO ADUCE DURANTE LA TOS"
  },
  {
    "codigo":11987791000119105,
    "descripcion":"QUEMADURA EPIDÉRMICA DE HOMBRO DERECHO"
  },
  {
    "codigo":413296003,
    "descripcion":"DEPRESIÓN QUE REQUIERE INTERVENCIÓN"
  },
  {
    "codigo":447899008,
    "descripcion":"SEPSIS CAUSADA POR ESCHERICHIA COLI"
  },
  {
    "codigo":282224008,
    "descripcion":"CAMINA SOBRE UNA LÍNEA ANGOSTA"
  },
  {
    "codigo":247621002,
    "descripcion":"IDEACIÓN EXPANSIVA"
  },
  {
    "codigo":15729641000119101,
    "descripcion":"ARTROPATÍA DE HOMBRO DERECHO DEBIDA A SÍNDROME DE BEHCET"
  },
  {
    "codigo":313157004,
    "descripcion":"SEUDOESTRABISMO"
  },
  {
    "codigo":83781008,
    "descripcion":"RASGO DE PERSONALIDAD INMADURA"
  },
  {
    "codigo":442394001,
    "descripcion":"TUMEFACCIÓN DE AMÍGDALA"
  },
  {
    "codigo":278554003,
    "descripcion":"PUENTE DENTAL PRESENTE"
  },
  {
    "codigo":737306007,
    "descripcion":"DOLOR VISCERAL CRÓNICO"
  },
  {
    "codigo":276719000,
    "descripcion":"FOTOTERAPIA PARA ERUPCIÓN DE PIEL"
  },
  {
    "codigo":735471001,
    "descripcion":"QUISTE RENAL COMPLEJO"
  },
  {
    "codigo":1259759008,
    "descripcion":"NEOPLASIA PRIMARIA MALIGNA DE CÉLULAS GRANULOSAS DE TESTÍCULO"
  },
  {
    "codigo":45508002,
    "descripcion":"EXPANSIÓN TORÁCICA DISMINUIDA"
  },
  {
    "codigo":405956003,
    "descripcion":"COMPROMISO TUMORAL POR ANAPLASIA, INDETERMINADO"
  },
  {
    "codigo":733636005,
    "descripcion":"FORMA JUVENIL DE DEFICIENCIA DE 3-FOSFOGLICERATO DESHIDROGENASA"
  },
  {
    "codigo":76441001,
    "descripcion":"DEPRESIÓN MAYOR GRAVE, UN SOLO EPISODIO, SIN SÍNTOMAS PSICÓTICOS"
  },
  {
    "codigo":43673002,
    "descripcion":"SOPLO UMBILICAL"
  },
  {
    "codigo":895641004,
    "descripcion":"FORMA TRIANGULAR ANORMAL CONGÉNITA DE FALANGE PROXIMAL DE DEDO DE MANO"
  },
  {
    "codigo":711000221101,
    "descripcion":"CARBUNCO EXTRACUTÁNEO"
  },
  {
    "codigo":404121005,
    "descripcion":"RETICULOSIS PAGETOIDE GENERALIZADA"
  },
  {
    "codigo":305817009,
    "descripcion":"ATENDIDO POR SERVICIO DE GENÉTICA CLÍNICA MOLECULAR"
  },
  {
    "codigo":369518007,
    "descripcion":"NEOPLASIA MALIGNA QUE COMPROMETE TROMPA DE FALOPIO IZQUIERDA POR PROPAGACIÓN DIRECTA DESDE CUELLO UTERINO"
  },
  {
    "codigo":1186883000,
    "descripcion":"DEMENCIA DEBIDA A DEFICIENCIA NUTRICIONAL"
  },
  {
    "codigo":238446007,
    "descripcion":"EPIDERMOFITIDES"
  },
  {
    "codigo":105539002,
    "descripcion":"NO FUMADOR POR MOTIVOS PERSONALES"
  },
  {
    "codigo":236611004,
    "descripcion":"FÍSTULA URETÉRICA HACIA LA PIEL"
  },
  {
    "codigo":11771011000119105,
    "descripcion":"ESGUINCE DE LIGAMENTO CUBITAL COLATERAL DE ARTICULACIÓN DE CODO IZQUIERDO"
  },
  {
    "codigo":169240004,
    "descripcion":"ECOCARDIOGRAMA NORMAL"
  },
  {
    "codigo":70936005,
    "descripcion":"DEMENCIA MULTINFARTO, NO COMPLICADA"
  },
  {
    "codigo":890136006,
    "descripcion":"DERMATITIS POR CONTACTO CAUSADA POR JACOBAEA VULGARIS"
  },
  {
    "codigo":300312006,
    "descripcion":"LESIÓN DE RECTO"
  },
  {
    "codigo":724461000,
    "descripcion":"INSUFICIENCIA OVÁRICA DEBIDA A PROCEDIMIENTO"
  },
  {
    "codigo":200173001,
    "descripcion":"HEMORRAGIA INTRAPARTO CON DEFECTO DE LA COAGULACIÓN"
  },
  {
    "codigo":365848007,
    "descripcion":"HALLAZGO RELACIONADO CON EL DESEMPEÑO EN LA PRUEBA DE LA MEMORIA DE DÍGITOS"
  },
  {
    "codigo":298477006,
    "descripcion":"COLUMNA CERVICAL DOLOROSA A LA PALPACIÓN"
  },
  {
    "codigo":788162000,
    "descripcion":"REACCIÓN ADVERSA A CONSTITUYENTE DE ANTISUERO"
  },
  {
    "codigo":722626001,
    "descripcion":"MÚLTIPLES LESIONES FOCALES DE TRONCO ENCEFÁLICO"
  },
  {
    "codigo":1148610001,
    "descripcion":"AMPLITUD DE ELECTRORRETINOGRAMA DE DESTELLO BRILLANTE CON ADAPTACIÓN A OSCURIDAD ANORMAL"
  },
  {
    "codigo":1279682003,
    "descripcion":"FIEBRE RECURRENTE CAUSADA POR BORRELIA MAZZOTTII"
  },
  {
    "codigo":165570002,
    "descripcion":"TIEMPO DE PROTROMBINA NORMAL"
  },
  {
    "codigo":296642006,
    "descripcion":"SOBREDOSIS DE ÁCIDO FUSÍDICO"
  },
  {
    "codigo":198338008,
    "descripcion":"ÚLCERA DE CUELLO UTERINO"
  },
  {
    "codigo":130967001,
    "descripcion":"NEGACIÓN INEFICAZ"
  },
  {
    "codigo":16905501000119104,
    "descripcion":"CARCINOMA BASOCELULAR PRIMARIO DE PÁRPADO INFERIOR IZQUIERDO"
  },
  {
    "codigo":196503004,
    "descripcion":"SIALODOCOLITIASIS SUBMANDIBULAR"
  },
  {
    "codigo":294807008,
    "descripcion":"ALERGIA A DESMOPRESINA"
  },
  {
    "codigo":425879009,
    "descripcion":"NEFROPATÍA POR AMILOIDE A"
  },
  {
    "codigo":129132000,
    "descripcion":"ENFERMEDAD INFECCIOSA CEREBRAL DE ORIGEN BACTERIANO"
  },
  {
    "codigo":292972004,
    "descripcion":"REACCIÓN ADVERSA A LA CARBENICILINA"
  },
  {
    "codigo":1144940005,
    "descripcion":"DERMATITIS DE CONTACTO DE GENITALES MASCULINOS"
  },
  {
    "codigo":30828007,
    "descripcion":"ANOXIA EN RECIÉN NACIDO VIVO"
  },
  {
    "codigo":94529003,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE OMÓPLATO"
  },
  {
    "codigo":127297005,
    "descripcion":"LESIÓN TRAUMÁTICA INTRACRANEAL CON PÉRDIDA DE LA CONSCIENCIA"
  },
  {
    "codigo":225601007,
    "descripcion":"INCAPAZ DE MOVERSE"
  },
  {
    "codigo":780822000,
    "descripcion":"ASTROCITOMA Y GANGLIOGLIOMA INFANTIL DESMOPLÁSICO"
  },
  {
    "codigo":190998001,
    "descripcion":"INMUNODEFICIENCIA COMBINADA GRAVE, CON RECUENTO BAJO O NORMAL DE LINFOCITOS B"
  },
  {
    "codigo":715286003,
    "descripcion":"PERIODONTITIS CRÓNICA MODERADA LOCALIZADA"
  },
  {
    "codigo":289302005,
    "descripcion":"CORDÓN UMBILICAL GRUESO"
  },
  {
    "codigo":27158007,
    "descripcion":"LESIÓN TRAUMÁTICA DEL TIMO"
  },
  {
    "codigo":92694007,
    "descripcion":"CARCINOMA IN SITU DEL SENO PIRIFORME"
  },
  {
    "codigo":713451001,
    "descripcion":"CONOCIMIENTO DEFICIENTE DEL TRABAJO DE PARTO Y PARTO"
  },
  {
    "codigo":420374009,
    "descripcion":"MACROPSIA POR ENFERMEDAD ORGÁNICA"
  },
  {
    "codigo":254699007,
    "descripcion":"FIBROFOLICULOMA"
  },
  {
    "codigo":89024000,
    "descripcion":"TIROIDITIS DE RIEDEL"
  },
  {
    "codigo":1336043008,
    "descripcion":"EPISODIO DE USO NOCIVO DE ANTIÁCIDO"
  },
  {
    "codigo":5401000175106,
    "descripcion":"OBTIENE MEDICAMENTOS DE MÚLTIPLES FARMACIAS"
  },
  {
    "codigo":1137600005,
    "descripcion":"EVERSIÓN DE BERMELLÓN DE LABIO SUPERIOR"
  },
  {
    "codigo":711616006,
    "descripcion":"CORIORRETINITIS CAUSADA POR CITOMEGALOVIRUS"
  },
  {
    "codigo":449472007,
    "descripcion":"NEOPLASIA EPITELIAL MALIGNA DE ALVÉOLO DENTAL"
  },
  {
    "codigo":251029004,
    "descripcion":"STENT CORONARIO PERMEABLE"
  },
  {
    "codigo":1332373008,
    "descripcion":"RITMO VENTRICULAR AGÓNICO"
  },
  {
    "codigo":54421009,
    "descripcion":"CUERPO EXTRAÑO EN LA TRÁQUEA"
  },
  {
    "codigo":773482004,
    "descripcion":"ALERGIA A ÁCIDO HIALURÓNICO"
  },
  {
    "codigo":1197631001,
    "descripcion":"PLOMO EN LA VIVIENDA"
  },
  {
    "codigo":15705681000119104,
    "descripcion":"DEPÓSITO DE CALCIO EN BOLSA SEROSA DE AMBOS PIES"
  },
  {
    "codigo":312895004,
    "descripcion":"TRASTORNO DEL ÍLEON"
  },
  {
    "codigo":50751005,
    "descripcion":"SENO DEL PERICRÁNEO"
  },
  {
    "codigo":704276000,
    "descripcion":"CONSENTIMIENTO PARA EXAMEN DEL SISTEMA MUSCULOESQUELÉTICO REHUSADO"
  },
  {
    "codigo":48916002,
    "descripcion":"SÍNDROME DE HIPERNASALIDAD POR INCOORDINACIÓN VELOFARÍNGEA"
  },
  {
    "codigo":702441001,
    "descripcion":"ATAXIA LIGADA AL CROMOSOMA X FATAL CON SORDERA Y PÉRDIDA DE VISIÓN"
  },
  {
    "codigo":473065001,
    "descripcion":"INFECCIÓN ASOCIADA CON DISPOSITIVO ANTICONCEPTIVO INTRAUTERINO RETENIDO"
  },
  {
    "codigo":209086000,
    "descripcion":"LUXACIÓN VERTEBRAL NO EXPUESTA CON LESIÓN DE LA COLA DE CABALLO"
  },
  {
    "codigo":407529009,
    "descripcion":"ARTERITIS SISTÉMICA PRIMARIA"
  },
  {
    "codigo":1259497009,
    "descripcion":"CARCINOMA PRIMARIO MUCOEPIDERMOIDE DE GLÁNDULA PARÓTIDA"
  },
  {
    "codigo":307390004,
    "descripcion":"HEMATOMA DE INGLE"
  },
  {
    "codigo":733374007,
    "descripcion":"HERIDA PUNZANTE DE REGIÓN PÉLVICA CON CUERPO EXTRAÑO"
  },
  {
    "codigo":43411001,
    "descripcion":"PROLAPSO RECTAL COMPLETO CON DESPLAZAMIENTO DEL ESFÍNTER ANAL"
  },
  {
    "codigo":241854009,
    "descripcion":"EFECTO TÓXICO CAUSADO POR LUSTRAMUEBLES"
  },
  {
    "codigo":698771001,
    "descripcion":"SOBREMORDIDA CON ROCE"
  },
  {
    "codigo":40021000087101,
    "descripcion":"HERIDA PUNZANTE DE BRAZO DERECHO CON CUERPO EXTRAÑO"
  },
  {
    "codigo":240019006,
    "descripcion":"LESIÓN DE LIGAMENTOS DE REGIÓN DE TOBILLO"
  },
  {
    "codigo":403859007,
    "descripcion":"ACROCORDONES MÚLTIPLES DEL CUELLO"
  },
  {
    "codigo":371091008,
    "descripcion":"INFECCIÓN DE VULVA POSPARTO"
  },
  {
    "codigo":305555007,
    "descripcion":"BAJO ATENCIÓN DE ENFERMERA CONTRATADA"
  },
  {
    "codigo":42581000087105,
    "descripcion":"HERIDA DE PENE POR MORDEDURA"
  },
  {
    "codigo":47701000087105,
    "descripcion":"FRACTURA DE PRIMERA COSTILLA IZQUIERDA"
  },
  {
    "codigo":860776004,
    "descripcion":"ALERGIA A OXIQUINOLINA"
  },
  {
    "codigo":8808004,
    "descripcion":"DEFICIENCIA DE BIOTINIDASA"
  },
  {
    "codigo":1155688007,
    "descripcion":"EMBOLIA DE AMBAS ARTERIAS CARÓTIDAS"
  },
  {
    "codigo":762472008,
    "descripcion":"QUEMADURA COMPLEJA DE LA CARA"
  },
  {
    "codigo":138045004,
    "descripcion":"DIETA VEGANA"
  },
  {
    "codigo":203581005,
    "descripcion":"CONTRACTURA DE FLEXIÓN DE ARTICULACIÓN DE DEDO DEL PIE"
  },
  {
    "codigo":269117007,
    "descripcion":"LUXACIÓN NO EXPUESTA ENTRE LA SEGUNDA Y LA TERCERA VÉRTEBRAS CERVICALES"
  },
  {
    "codigo":37906005,
    "descripcion":"INFARTO EMBÓLICO"
  },
  {
    "codigo":185779007,
    "descripcion":"INCUMPLIMIENTO CON CONTROL DEL ESTRÉS"
  },
  {
    "codigo":267282007,
    "descripcion":"VENAS VARICOSAS DE PERINEO Y VULVA EN EL EMBARAZO Y EL PUERPERIO"
  },
  {
    "codigo":365586007,
    "descripcion":"NIVEL DE ANTICUERPOS ANTIVIRALES - HALLAZGO"
  },
  {
    "codigo":3303004,
    "descripcion":"ENFERMEDAD CAUSADA POR ARENAVIRUS"
  },
  {
    "codigo":36071006,
    "descripcion":"CONDROMALACIA DE RÓTULA"
  },
  {
    "codigo":134375007,
    "descripcion":"PRUEBA AUDITIVA EN OÍDO IZQUIERDO ANORMAL"
  },
  {
    "codigo":298215007,
    "descripcion":"LAXITUD DE ARTICULACIÓN DE CADERA"
  },
  {
    "codigo":296380001,
    "descripcion":"SOBREDOSIS DE SALBUTAMOL"
  },
  {
    "codigo":396519009,
    "descripcion":"10 O MÁS FIGURAS MITÓTICAS EN 10 CAMPOS DE GRAN AUMENTO"
  },
  {
    "codigo":61471000119100,
    "descripcion":"CARCINOMA BASOCELULAR DE NARINA"
  },
  {
    "codigo":165308007,
    "descripcion":"MEMORIA: NO RECUERDA DIRECCIONES"
  },
  {
    "codigo":294545004,
    "descripcion":"ALERGIA A CEFOTAXIMA"
  },
  {
    "codigo":333701000119108,
    "descripcion":"MIOPÍA DE OJO DERECHO"
  },
  {
    "codigo":816998005,
    "descripcion":"TRAYECTO FISTULOSO DE PIEL DESPUÉS DE PROCEDIMIENTO QUIRÚRGICO"
  },
  {
    "codigo":423782006,
    "descripcion":"INCAPAZ DE COORDINAR MÚLTIPLES PLANES DE TRATAMIENTO"
  },
  {
    "codigo":128870005,
    "descripcion":"SARNA COSTROSA"
  },
  {
    "codigo":716859000,
    "descripcion":"CARCINOMA DIFUSO HEREDITARIO DE ESTÓMAGO"
  },
  {
    "codigo":94267001,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE CONDUCTO CRANEOFARÍNGEO"
  },
  {
    "codigo":292710008,
    "descripcion":"REACCIÓN ADVERSA A LA PROSTAGLANDINA, SERIE A"
  },
  {
    "codigo":1144678009,
    "descripcion":"APLASIA DE FALANGE DISTAL DE QUINTO DEDO DE PIE"
  },
  {
    "codigo":127035006,
    "descripcion":"TRASTORNO DE LA MÉDULA ÓSEA"
  },
  {
    "codigo":782395007,
    "descripcion":"NÓDULO DE PIEL DE PIE"
  },
  {
    "codigo":289040000,
    "descripcion":"DIFICULTAD PARA ALIMENTARSE CON LA MANO DERECHA"
  },
  {
    "codigo":92432002,
    "descripcion":"NEOPLASIA BENIGNA DEL PERITONEO"
  },
  {
    "codigo":715024007,
    "descripcion":"INCAPAZ DE CAMINAR POR UN CORREDOR"
  },
  {
    "codigo":254437001,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS DE LA MUCOSA YUGAL"
  },
  {
    "codigo":307231000119107,
    "descripcion":"ARTRITIS ENTEROPÁTICA DE ARTICULACIÓN GLENOHUMERAL DERECHA"
  },
  {
    "codigo":1237477003,
    "descripcion":"METÁSTASIS DE CARCINOMA DE PIEL DE LA CABEZA"
  },
  {
    "codigo":713189001,
    "descripcion":"INSULINOMA MALIGNO"
  },
  {
    "codigo":57829009,
    "descripcion":"ESTENOSIS DE LA VAGINA"
  },
  {
    "codigo":1268410004,
    "descripcion":"SINOSTOSIS RADIOCUBITAL POSTERIOR A LESIÓN TRAUMÁTICA"
  },
  {
    "codigo":416442006,
    "descripcion":"INFECCIÓN POR VIRUS DE LA ENCEFALITIS DE CALIFORNIA"
  },
  {
    "codigo":187066009,
    "descripcion":"BLASTOMICOSIS PULMONAR PRIMARIA"
  },
  {
    "codigo":11995321000119104,
    "descripcion":"CONTRACTURA DE MUÑÓN DE AMPUTACIÓN DE EXTREMIDAD SUPERIOR IZQUIERDA"
  },
  {
    "codigo":840591006,
    "descripcion":"ÚLCERA DUODENAL CAUSADA POR INHIBIDOR DE LA AGREGACIÓN PLAQUETARIA"
  },
  {
    "codigo":283535008,
    "descripcion":"HERIDA PUNZANTE DE RODILLA"
  },
  {
    "codigo":86927009,
    "descripcion":"DACRIOADENITIS"
  },
  {
    "codigo":52324001,
    "descripcion":"LINFADENOPATÍA MEDIASTÍNICA"
  },
  {
    "codigo":281700003,
    "descripcion":"PAPILOMA BENIGNO DE VEJIGA URINARIA"
  },
  {
    "codigo":445540004,
    "descripcion":"DIVERTÍCULO VENTRICULAR IZQUIERDO"
  },
  {
    "codigo":871524006,
    "descripcion":"REACCIÓN ADVERSA A ALUMINIO Y\/O COMPUESTO DE ALUMINIO"
  },
  {
    "codigo":609380008,
    "descripcion":"DEFORMIDAD EN FORMA DE ARCO DE MIEMBRO INFERIOR"
  },
  {
    "codigo":1197369000,
    "descripcion":"COLITIS POR CHLAMYDIA TRACHOMATIS"
  },
  {
    "codigo":1230137003,
    "descripcion":"PLACA DENTAL EN IMPLANTE DENTAL"
  },
  {
    "codigo":247097006,
    "descripcion":"HEMORRAGIA EN LA INTERFASE VÍTREA"
  },
  {
    "codigo":736782000,
    "descripcion":"AUSENCIA CONGÉNITA DE CÓNDILO MANDIBULAR IZQUIERDO"
  },
  {
    "codigo":310798000,
    "descripcion":"BRAQUIDACTILIA DE LA MANO"
  },
  {
    "codigo":704014000,
    "descripcion":"FRACTURA EXPUESTA DE TUBEROSIDAD MENOR DE HÚMERO"
  },
  {
    "codigo":212494008,
    "descripcion":"HERIDAS ABIERTAS QUE COMPROMETEN MÚLTIPLES REGIONES DE MIEMBRO\/S SUPERIOR\/ES CON MIEMBRO\/S INFERIOR\/ES"
  },
  {
    "codigo":263048006,
    "descripcion":"SUBLUXACIÓN DE ARTICULACIÓN ESTERNOCLAVICULAR"
  },
  {
    "codigo":866019003,
    "descripcion":"DEPURACIÓN RENAL AUMENTADA"
  },
  {
    "codigo":734947007,
    "descripcion":"SÍNDROME DE DOLOR REGIONAL COMPLEJO TIPO I"
  },
  {
    "codigo":700344004,
    "descripcion":"RETRACCIÓN ANORMAL DE PÁRPADO SUPERIOR"
  },
  {
    "codigo":896952004,
    "descripcion":"FORMA DE BALA ANORMAL CONGÉNITA DE FALANGE DISTAL DE SEGUNDO DEDO DE PIE"
  },
  {
    "codigo":454061000124102,
    "descripcion":"INCAPAZ DE COSTEAR MEDICACIÓN"
  },
  {
    "codigo":733112007,
    "descripcion":"TRASTORNO CONGÉNITO DE GLICOSILACIÓN TIPO 1X"
  },
  {
    "codigo":10381000,
    "descripcion":"INFECCIÓN CAUSADA POR PNEUMOSTRONGYLUS"
  },
  {
    "codigo":272525001,
    "descripcion":"POSICIONES DEL PACIENTE-HALLAZGO"
  },
  {
    "codigo":307128009,
    "descripcion":"DEFICIENCIA COMBINADA DE HIDROXIACIL-COA DESHIDROGENASA DE CADENA LARGA"
  },
  {
    "codigo":403597003,
    "descripcion":"ALODINIA CUTÁNEA"
  },
  {
    "codigo":698509001,
    "descripcion":"AL CUIDADO DE ENFERMERA ESPECIALISTA EN ASMA"
  },
  {
    "codigo":1073491000119109,
    "descripcion":"ARTRITIS INFECCIOSA DE CADERA DERECHA"
  },
  {
    "codigo":309741000119104,
    "descripcion":"GOTA PRIMARIA CRÓNICA DE RODILLA, SIN TOFO"
  },
  {
    "codigo":39479004,
    "descripcion":"EFLUVIO TELÓGENO"
  },
  {
    "codigo":170551006,
    "descripcion":"ÚLTIMO PACIENTE INTERNADO"
  },
  {
    "codigo":236087007,
    "descripcion":"FILTRACIÓN POR ANASTOMOSIS GÁSTRICA"
  },
  {
    "codigo":268855009,
    "descripcion":"SUTURAS CRANEANAS SEPARADAS"
  },
  {
    "codigo":301623009,
    "descripcion":"DIFICULTAD PARA UTILIZAR ASCENSOR"
  },
  {
    "codigo":16011911000119100,
    "descripcion":"TROMBOFLEBITIS DE VENA POPLÍTEA IZQUIERDA"
  },
  {
    "codigo":299788007,
    "descripcion":"REFLEJO DE OJOS DE MUÑECA VERTICAL DUDOSO"
  },
  {
    "codigo":1217292008,
    "descripcion":"LÍNEAS B PULMONARES"
  },
  {
    "codigo":363489000,
    "descripcion":"NEOPLASIA MALIGNA DE CUELLO"
  },
  {
    "codigo":365324006,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA LIMPIAR VENTANAS"
  },
  {
    "codigo":11833991000119101,
    "descripcion":"SUBLUXACIÓN DE ARTICULACIÓN METACARPOFALÁNGICA DE PULGAR IZQUIERDO"
  },
  {
    "codigo":68577004,
    "descripcion":"MIELITIS NECROSANTE AGUDA"
  },
  {
    "codigo":789473005,
    "descripcion":"MIGRACIÓN DE DISPOSITIVO ANTICONCEPTIVO INTRAUTERINO"
  },
  {
    "codigo":232417005,
    "descripcion":"AMIGDALITIS DE VINCENT"
  },
  {
    "codigo":396257005,
    "descripcion":"MARGEN QUIRÚRGICO EXOCERVICAL COMPROMETIDO POR NEOPLASIA INTRAEPITELIAL"
  },
  {
    "codigo":297953008,
    "descripcion":"HALLAZGO RELACIONADO CON EL ESTADO DE LIMPIEZA CUTÁNEA"
  },
  {
    "codigo":723937009,
    "descripcion":"TRASTORNO DEL SUEÑO CAUSADO POR CANNABIS"
  },
  {
    "codigo":16667271000119103,
    "descripcion":"FRACTURA ABIERTA DE RAMA DE MITAD IZQUIERDA DE MANDÍBULA"
  },
  {
    "codigo":296118008,
    "descripcion":"SOBREDOSIS DE DIAZEPAM"
  },
  {
    "codigo":32139003,
    "descripcion":"NEUMOCONIOSIS POR POLVOS MIXTOS"
  },
  {
    "codigo":294283004,
    "descripcion":"ALERGIA A DIMERCAPROL"
  },
  {
    "codigo":30304000,
    "descripcion":"COLITIS ALÉRGICA"
  },
  {
    "codigo":128608001,
    "descripcion":"ANEURISMA DE ARTERIA CEREBRAL"
  },
  {
    "codigo":259680000,
    "descripcion":"NEOCITO"
  },
  {
    "codigo":292448004,
    "descripcion":"REACCIÓN ADVERSA A LA FENTOLAMINA"
  },
  {
    "codigo":95840007,
    "descripcion":"HIPOPLASMINOGENEMIA"
  },
  {
    "codigo":1177184008,
    "descripcion":"TRANSMISIÓN DE VIRUS VACCINIA DE UNA PERSONA A OTRA DEBIDA A CONTACTO CON PUNTO DE INOCULACIÓN DE VACUNA ANTIVARIÓLICA"
  },
  {
    "codigo":94005003,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE HOMBRO"
  },
  {
    "codigo":126773005,
    "descripcion":"NEOPLASIA DE BORDE BERMELLÓN DE LABIO INFERIOR"
  },
  {
    "codigo":1076001000119102,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE TENDÓN EXTENSOR DE PIE IZQUIERDO"
  },
  {
    "codigo":288778004,
    "descripcion":"EXPRESA INTENCIONES"
  },
  {
    "codigo":92170008,
    "descripcion":"NEOPLASIA BENIGNA DEL INTESTINO GRUESO"
  },
  {
    "codigo":254175006,
    "descripcion":"ERUPCIÓN BULLOSA DE MANO"
  },
  {
    "codigo":416180004,
    "descripcion":"ENFERMEDAD DE LA HEMOGLOBINA SS SIN CRISIS HEMOLÍTICA"
  },
  {
    "codigo":283273006,
    "descripcion":"VIDRIO EN DEDO DEL PIE"
  },
  {
    "codigo":338721000119108,
    "descripcion":"GLAUCOMA PIGMENTARIO DEL OJO IZQUIERDO"
  },
  {
    "codigo":281438000,
    "descripcion":"REABSORCIÓN DE INJERTO ÓSEO"
  },
  {
    "codigo":248670000,
    "descripcion":"DESDOBLAMIENTO DE RUIDOS CARDÍACOS"
  },
  {
    "codigo":1297246001,
    "descripcion":"CIERRE DE ÁNGULO AGUDO DE OJO DERECHO DEBIDO A NEOVASCULARIZACIÓN"
  },
  {
    "codigo":314206003,
    "descripcion":"INSUFICIENCIA CARDÍACA REFRACTARIA"
  },
  {
    "codigo":707422006,
    "descripcion":"CARCINOMA PRIMARIO DE CÉLULAS ESCAMOSAS FUSIFORMES DE LARINGE"
  },
  {
    "codigo":1229875002,
    "descripcion":"SÍNDROME DE MICRODELECIÓN 9Q21.13"
  },
  {
    "codigo":15631291000119104,
    "descripcion":"BLEFAROSPASMO DE PÁRPADO IZQUIERDO"
  },
  {
    "codigo":124911000119100,
    "descripcion":"SUPERPOSICIÓN DE SÍNDROME DE STEVENS JOHNSON Y NECRÓLISIS EPIDÉRMICA TÓXICA"
  },
  {
    "codigo":288751000119101,
    "descripcion":"PSICOSIS DEPRESIVA REACTIVA, EPISODIO ÚNICO"
  },
  {
    "codigo":10751471000119101,
    "descripcion":"DEFICIENCIA NUTRICIONAL EN LA MADRE QUE COMPLICA EL NACIMIENTO"
  },
  {
    "codigo":10628591000119103,
    "descripcion":"DERMATITIS IRRITATIVA POR CONTACTO CAUSADA POR SUSTANCIA QUÍMICA"
  },
  {
    "codigo":246835005,
    "descripcion":"GLÁNDULA DE MEIBOMIO - HALLAZGO"
  },
  {
    "codigo":329711000119105,
    "descripcion":"COMPRESIÓN DE NERVIO PERIFÉRICO DE EXTREMIDAD INFERIOR IZQUIERDA"
  },
  {
    "codigo":10759151000119101,
    "descripcion":"HEPATITIS VIRAL EN LA MADRE QUE COMPLICA EL EMBARAZO"
  },
  {
    "codigo":10679791000119100,
    "descripcion":"TUMEFACCIÓN DEL TEJIDO CELULAR SUBCUTÁNEO DE EXTREMIDAD SUPERIOR IZQUIERDA"
  },
  {
    "codigo":10943471000119107,
    "descripcion":"CONTUSIÓN DE CEREBRO IZQUIERDO"
  },
  {
    "codigo":132591000119109,
    "descripcion":"TROMBOSIS AGUDA DE VENA SUPERFICIAL DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":212232006,
    "descripcion":"LESIÓN ABIERTA DE TRONCOS SECUNDARIOS DE PLEXO BRAQUIAL"
  },
  {
    "codigo":352751000119103,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE NERVIOS PERIFÉRICOS DE EXTREMIDAD SUPERIOR DERECHA"
  },
  {
    "codigo":10674671000119106,
    "descripcion":"ABSCESO DE SENO NASAL"
  },
  {
    "codigo":1162504009,
    "descripcion":"ISQUEMIA DE COLOSTOMÍA"
  },
  {
    "codigo":1258973002,
    "descripcion":"DESPRENDIMIENTO DE CATÉTER PARA COLECISTOSTOMÍA PERCUTÁNEA"
  },
  {
    "codigo":334831000119106,
    "descripcion":"TRASTORNO DE RETINA DERECHA CONCOMITANTE CON HIPERTENSIÓN Y DEBIDO A ELLA"
  },
  {
    "codigo":293871000119108,
    "descripcion":"SÍNDROME DEL TÚNEL CARPIANO DE MUÑECA DERECHA"
  },
  {
    "codigo":1074671000119109,
    "descripcion":"ARTRITIS DE ARTICULACIÓN GLENOHUMERAL DERECHA"
  },
  {
    "codigo":46557008,
    "descripcion":"TRASTORNO DE LOS TEJIDOS DUROS DE LOS DIENTES"
  },
  {
    "codigo":700082001,
    "descripcion":"LIQUEN ESCLEROSO DE PENE"
  },
  {
    "codigo":208562000,
    "descripcion":"FRACTURA PERTROCANTÉREA"
  },
  {
    "codigo":110258003,
    "descripcion":"CONTUSIÓN DEL PALADAR BLANDO"
  },
  {
    "codigo":274098004,
    "descripcion":"RUPTURA DE CUERDAS TENDINOSAS"
  },
  {
    "codigo":77490007,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO DE HOMBRO"
  },
  {
    "codigo":896690007,
    "descripcion":"OCLUSIÓN DE RAMA CIRCUNFLEJA DE ARTERIA CORONARIA IZQUIERDA"
  },
  {
    "codigo":15932501000119104,
    "descripcion":"TORSIÓN DE TROMPA DE FALOPIO DERECHO"
  },
  {
    "codigo":370567003,
    "descripcion":"FOBIA AL RUIDO"
  },
  {
    "codigo":698247007,
    "descripcion":"ARRITMIA CARDÍACA"
  },
  {
    "codigo":42887008,
    "descripcion":"TIÑA CAUSADA POR TRICHOPHYTON GALLINAE"
  },
  {
    "codigo":403335009,
    "descripcion":"ALOPECIA CRÓNICA DIFUSA"
  },
  {
    "codigo":237660002,
    "descripcion":"LESIÓN DE LA GLÁNDULA PARATIROIDES"
  },
  {
    "codigo":73820008,
    "descripcion":"TRASTORNO TESTICULAR ENDOCRINO"
  },
  {
    "codigo":71985006,
    "descripcion":"SÍNDROME CARCINOMATOSO MIOPÁTICO"
  },
  {
    "codigo":235825006,
    "descripcion":"PSEUDO-OBSTRUCCIÓN INTESTINAL"
  },
  {
    "codigo":365062001,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD DE REESTABLECER LA CONVERSACIÓN"
  },
  {
    "codigo":397830005,
    "descripcion":"ANOMALÍA PERICÁRDICA"
  },
  {
    "codigo":233990006,
    "descripcion":"ANEURISMA DE CONDUCTO ARTERIOSO"
  },
  {
    "codigo":299526006,
    "descripcion":"HALLAZGO RELACIONADO CON ARTICULACIÓN SUBASTRAGALINA"
  },
  {
    "codigo":201222006,
    "descripcion":"ACNÉ POR ESTEROIDES"
  },
  {
    "codigo":102918006,
    "descripcion":"MICROFOBIA"
  },
  {
    "codigo":35547002,
    "descripcion":"POLIOTIA"
  },
  {
    "codigo":363227003,
    "descripcion":"NEOPLASIA DE EXTREMIDAD"
  },
  {
    "codigo":428763004,
    "descripcion":"BACTERIEMIA CAUSADA POR STAPHYLOCOCCUS AUREUS"
  },
  {
    "codigo":723675006,
    "descripcion":"SIALIDOSIS TIPO 1"
  },
  {
    "codigo":721840000,
    "descripcion":"SÍNDROME DE HIPERURICEMIA, ANEMIA E INSUFICIENCIA RENAL"
  },
  {
    "codigo":263088001,
    "descripcion":"FRACTURA-LUXACIÓN DE LA ARTICULACIÓN DE LA CADERA"
  },
  {
    "codigo":295856000,
    "descripcion":"SOBREDOSIS DE DOTIEPINA"
  },
  {
    "codigo":230320008,
    "descripcion":"DISTONÍA IDIOPÁTICA FAMILIAR, AUTOSÓMICA RECESIVA"
  },
  {
    "codigo":359557001,
    "descripcion":"TRASTORNO ARTERIAL"
  },
  {
    "codigo":195717003,
    "descripcion":"BRONQUITIS PURULENTA AGUDA"
  },
  {
    "codigo":720005005,
    "descripcion":"ÁCIDO DESOXIRRIBONUCLEICO DE VIRUS PAPILOMA HUMANO DETECTADO, ALTO RIESGO EN MUESTRA CERVICAL"
  },
  {
    "codigo":95578000,
    "descripcion":"VASCULITIS RENAL"
  },
  {
    "codigo":31877008,
    "descripcion":"ENFERMEDAD DE CHAGAS CON COMPROMISO DE OTROS ÓRGANOS"
  },
  {
    "codigo":161114003,
    "descripcion":"EDUCACIÓN NO SATISFACTORIA"
  },
  {
    "codigo":128346003,
    "descripcion":"ANOMALÍA CONGÉNITA DEL PERITONEO"
  },
  {
    "codigo":292186004,
    "descripcion":"REACCIÓN ADVERSA A LA PROXIMETACAÍNA"
  },
  {
    "codigo":30042003,
    "descripcion":"FIBROSIS PULMONAR CONFLUENTE"
  },
  {
    "codigo":783706007,
    "descripcion":"CISTOADENOCARCINOMA SEROSO DE PÁNCREAS"
  },
  {
    "codigo":93743001,
    "descripcion":"NEOPLASIA PRIMARIA MALIGNA DE LA COLA DE CABALLO"
  },
  {
    "codigo":1142319002,
    "descripcion":"ATROFIA DE MÚSCULO ELEVADOR DE PÁRPADO SUPERIOR"
  },
  {
    "codigo":716335003,
    "descripcion":"PARESIA SUPRABULBAR CONGÉNITA"
  },
  {
    "codigo":126511003,
    "descripcion":"NEOPLASIA DE LA PIEL DE LOS GLÚTEOS"
  },
  {
    "codigo":290351003,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR MISOPROSTOL"
  },
  {
    "codigo":91908000,
    "descripcion":"AUSENCIA CONGÉNITA DEL OMÓPLATO"
  },
  {
    "codigo":15633801000119105,
    "descripcion":"RESONANCIA MAGNÉTICA DE MAMA ANORMAL"
  },
  {
    "codigo":59140005,
    "descripcion":"SECRECIÓN SALIVAL ANORMAL"
  },
  {
    "codigo":124676006,
    "descripcion":"DEFICIENCIA DE FOSFOGLUCOMUTASA"
  },
  {
    "codigo":10692131000119100,
    "descripcion":"TUMEFACCIÓN LOCALIZADA DEL PULGAR DERECHO"
  },
  {
    "codigo":288516006,
    "descripcion":"QUEMADURA CON COMPROMISO DE 3% DE LA SUPERFICIE CORPORAL"
  },
  {
    "codigo":90073001,
    "descripcion":"SÍNDROME POR DEFICIENCIA DE COLÁGENO"
  },
  {
    "codigo":386820009,
    "descripcion":"TRASTORNO DE CONDUCTA SOCIALIZADA"
  },
  {
    "codigo":450521003,
    "descripcion":"ARTROSIS DE ARTICULACIÓN ROTULOFEMORAL"
  },
  {
    "codigo":15715721000119107,
    "descripcion":"SECUESTRO DE AMBOS HUESOS CIGOMÁTICOS"
  },
  {
    "codigo":1204185005,
    "descripcion":"OCLUSIÓN AGUDA DE ARTERIA ILÍACA DEBIDA A TROMBOEMBOLISMO"
  },
  {
    "codigo":1236953005,
    "descripcion":"METÁSTASIS DE CARCINOMA DE HUESO, TEJIDO CONECTIVO, PIEL Y MAMA"
  },
  {
    "codigo":286681008,
    "descripcion":"IDEALIZACIÓN PRIMITIVA - MECANISMO DE DEFENSA PSICOLÓGICA"
  },
  {
    "codigo":57305009,
    "descripcion":"INTOXICACIÓN POR FIBRINÓGENO HUMANO"
  },
  {
    "codigo":186542001,
    "descripcion":"HERPES SIMPLE OFTÁLMICO"
  },
  {
    "codigo":22702000,
    "descripcion":"GLOMERULITIS"
  },
  {
    "codigo":288291000119102,
    "descripcion":"CONDUCTA BISEXUAL DE ALTO RIESGO"
  },
  {
    "codigo":284846007,
    "descripcion":"CAPAZ DE LIMPIAR SUS PRÓTESIS DENTALES"
  },
  {
    "codigo":446851000,
    "descripcion":"CUERPO EXTRAÑO EN SENO MAXILAR"
  },
  {
    "codigo":250243009,
    "descripcion":"DACRIOCITOSIS"
  },
  {
    "codigo":1264216001,
    "descripcion":"INFECCIÓN NEONATAL PRECOZ CAUSADA POR STREPTOCOCCUS GRUPO B"
  },
  {
    "codigo":248408003,
    "descripcion":"PLIEGUES PALMARES"
  },
  {
    "codigo":1003907009,
    "descripcion":"DUPLICACIÓN DE PORCIÓN PROXIMAL DEL CROMOSOMA 14"
  },
  {
    "codigo":11839011000119106,
    "descripcion":"DISTENSIÓN DE MÚSCULO INTRÍNSECO DE DEDO ANULAR DE MANO IZQUIERDA"
  },
  {
    "codigo":1231448006,
    "descripcion":"DESPRENDIMIENTO VÍTREO POSTERIOR HEMORRÁGICO AGUDO"
  },
  {
    "codigo":84568007,
    "descripcion":"GASTRITIS ATRÓFICA"
  },
  {
    "codigo":312109000,
    "descripcion":"DISENTERÍA BACTERIANA"
  },
  {
    "codigo":443181001,
    "descripcion":"OBSTRUCCIÓN DE TUBO DE GASTROSTOMÍA ENDOSCÓPICA PERCUTÁNEA"
  },
  {
    "codigo":1196845003,
    "descripcion":"LINFANGIOMA DE INTESTINO GRUESO"
  },
  {
    "codigo":211970000,
    "descripcion":"QUEMADURA SUPERFICIAL DE ESPESOR PARCIAL DE PIERNA"
  },
  {
    "codigo":408578001,
    "descripcion":"META DE LA ACTIVIDAD FÍSICA: EJERCICIO MÍNIMO"
  },
  {
    "codigo":15362005,
    "descripcion":"FÓRMULA DE HIPERALIMENTACIÓN PARA EL TRATAMIENTO DE LA DIARREA SEVERA"
  },
  {
    "codigo":48130008,
    "descripcion":"HIPOGONADISMO"
  },
  {
    "codigo":898263001,
    "descripcion":"ANQUILOSIS CONGÉNITA DE ARTICULACIÓN INTERFALÁNGICA DE DEDO DE MANO"
  },
  {
    "codigo":767191008,
    "descripcion":"QUISTE SINOVIAL DE HOMBRO"
  },
  {
    "codigo":210135008,
    "descripcion":"LESIONES TRAUMÁTICAS MÚLTIPLES DE COLON O RECTO CON HERIDA ABIERTA HACIA CAVIDAD"
  },
  {
    "codigo":404908004,
    "descripcion":"MEGACOLON TÓXICO POR COLITIS ULCEROSA"
  },
  {
    "codigo":372140005,
    "descripcion":"CARCINOMA DE VESÍCULA BILIAR"
  },
  {
    "codigo":403073002,
    "descripcion":"TIÑA CAUSADA POR TRICHOPHYTON MEGNINII"
  },
  {
    "codigo":697985003,
    "descripcion":"VARICOCELE VISIBLE A TRAVÉS DE LA PIEL"
  },
  {
    "codigo":9857008,
    "descripcion":"DETERMINACIÓN DEL RESULTADO: MUERTE EVITABLE DERIVADA DE UN ERROR EN EL DIAGNÓSTICO"
  },
  {
    "codigo":8022000,
    "descripcion":"PROTEINURIA POR ESFUERZO"
  },
  {
    "codigo":204630003,
    "descripcion":"LENGUA HENDIDA"
  },
  {
    "codigo":343741000119109,
    "descripcion":"RETINOPATÍA POR PREMATUREZ BILATERAL, ETAPA 4 - DESPRENDIMIENTO SUBTOTAL DE RETINA"
  },
  {
    "codigo":1251371002,
    "descripcion":"DERMATOSIS ACANTOLÍTICA"
  },
  {
    "codigo":301099004,
    "descripcion":"VÁLVULA AÓRTICA - HALLAZGO"
  },
  {
    "codigo":366635004,
    "descripcion":"AMPLITUD DE MOVIMIENTO ARTICULACIÓN SUBASTRAGALINA - HALLAZGO"
  },
  {
    "codigo":364800000,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA DEGLUTIR ALIMENTOS BLANDOS"
  },
  {
    "codigo":397568004,
    "descripcion":"DISTROFIA GRANULAR DE CÓRNEA TIPO II"
  },
  {
    "codigo":233728004,
    "descripcion":"NEUMONITIS POR COLESTEROL"
  },
  {
    "codigo":788949000,
    "descripcion":"ÚLCERA VENOSA DE PIERNA CICATRIZADA"
  },
  {
    "codigo":299264009,
    "descripcion":"AMPLITUD DE ABDUCCIÓN ACTIVA DE LA CADERA AUMENTADA"
  },
  {
    "codigo":231893002,
    "descripcion":"ÚLCERA BACTERIANA DE LA CÓRNEA"
  },
  {
    "codigo":362965005,
    "descripcion":"TRASTORNO DE SISTEMA CORPORAL"
  },
  {
    "codigo":295594005,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE FÁRMACO INMUNOESTIMULANTE"
  },
  {
    "codigo":66218005,
    "descripcion":"INFECCIÓN CAUSADA POR CLOSTRIDIUM PERFRINGENS TIPO A"
  },
  {
    "codigo":262826007,
    "descripcion":"HEMATOMA PERIPANCREÁTICO"
  },
  {
    "codigo":721578007,
    "descripcion":"LIPOSARCOMA PRIMARIO DE ÓRGANO GENITAL MASCULINO"
  },
  {
    "codigo":361130009,
    "descripcion":"RETINOSQUISIS PERIFÉRICA"
  },
  {
    "codigo":64383006,
    "descripcion":"ENFERMEDAD DE WERNIG - HOFFMANN"
  },
  {
    "codigo":719743007,
    "descripcion":"CAPAZ DE ADOPTAR DECISIONES"
  },
  {
    "codigo":31615009,
    "descripcion":"HIPOPARATIROIDISMO NEONATAL TRANSITORIO"
  },
  {
    "codigo":128084001,
    "descripcion":"SÍNDROME DE DUANE, TIPO 3"
  },
  {
    "codigo":816212004,
    "descripcion":"ALBUMINURIA GRADO A1"
  },
  {
    "codigo":95316006,
    "descripcion":"VÍCTIMA DE SECUESTRO"
  },
  {
    "codigo":62548007,
    "descripcion":"TOS NOCTURNA"
  },
  {
    "codigo":290089001,
    "descripcion":"HALLAZGO RELACIONADO CON LA PROPORCIÓN ENTRE LOS PEZONES"
  },
  {
    "codigo":60713008,
    "descripcion":"QUEMADURA DEL CUELLO"
  },
  {
    "codigo":1142057008,
    "descripcion":"TAQUICARDIA DE MACRORREENTRADA DEPENDIENTE DEL ISTMO CAVOTRICUSPÍDEO EN SENTIDO ANTIHORARIO"
  },
  {
    "codigo":419326002,
    "descripcion":"MOVIMIENTO OCULAR LIMITADO"
  },
  {
    "codigo":91646005,
    "descripcion":"AFASIA DE JERIGONZA"
  },
  {
    "codigo":26110006,
    "descripcion":"SUFRIMIENTO ESPIRITUAL"
  },
  {
    "codigo":253651002,
    "descripcion":"ANOMALÍA DEL CAYADO AÓRTICO Y LA AORTA DESCENDENTE"
  },
  {
    "codigo":286419005,
    "descripcion":"PROVEE SERVICIO DE BANQUETES"
  },
  {
    "codigo":1269459006,
    "descripcion":"SÍNDROME MEDULAR CENTRAL DEBIDO A FRACTURA ABIERTA A NIVEL DE C1-C4"
  },
  {
    "codigo":251816000,
    "descripcion":"MAMAS EN ESTADIO 5 DE TANNER"
  },
  {
    "codigo":22440001,
    "descripcion":"ÚLCERA DE MOOREN"
  },
  {
    "codigo":346251000119106,
    "descripcion":"CORIORRETINITIS DISEMINADA DE AMBOS OJOS"
  },
  {
    "codigo":284584006,
    "descripcion":"ASTILLA DE MADERA EN EL LABIO"
  },
  {
    "codigo":249981005,
    "descripcion":"SOPORTE DEL PESO"
  },
  {
    "codigo":282749008,
    "descripcion":"LESIÓN TRAUMÁTICA DE CABEZA Y CUELLO"
  },
  {
    "codigo":1263954000,
    "descripcion":"NECROSIS TUBULAR RENAL POSTERIOR A EMBARAZO MOLAR"
  },
  {
    "codigo":315517009,
    "descripcion":"NACIDO EN SEYCHELLES"
  },
  {
    "codigo":117074003,
    "descripcion":"UNIDAD DE HEMODERIVADO TRANSFERIDA A OTRO SECTOR"
  },
  {
    "codigo":739666006,
    "descripcion":"LESIÓN TRAUMÁTICA INCOMPLETA DE MÉDULA ESPINAL"
  },
  {
    "codigo":84306007,
    "descripcion":"PAQUIMENINGITIS ADHESIVA CRÓNICA"
  },
  {
    "codigo":770599000,
    "descripcion":"VENAS DE LA RETINA DE OJO DERECHO EN CUENTAS DE ROSARIO DEBIDAS A DIABETES MELLITUS"
  },
  {
    "codigo":1231186006,
    "descripcion":"LATEROPULSIÓN OCULAR"
  },
  {
    "codigo":279079003,
    "descripcion":"DISESTESIA"
  },
  {
    "codigo":49703004,
    "descripcion":"COITO RESERVATUS"
  },
  {
    "codigo":16935003,
    "descripcion":"ARTRITIS ALÉRGICA"
  },
  {
    "codigo":311847006,
    "descripcion":"FRACTURAS NO EXPUESTAS QUE COMPROMETEN CABEZA Y CUELLO"
  },
  {
    "codigo":705063007,
    "descripcion":"ATENDIDO EN CONSULTORIO ESPECIALIZADO EN ENDOCRINOLOGÍA"
  },
  {
    "codigo":211708001,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO PROFUNDA DE CUERO CABELLUDO"
  },
  {
    "codigo":15100005,
    "descripcion":"ESTADO POSTPARTO, 2 SEMANAS"
  },
  {
    "codigo":703228009,
    "descripcion":"CÁNCER DE PULMÓN NO MICROCÍTICO CON MUTACIÓN DEL RECEPTOR DEL FACTOR DE CRECIMIENTO EPIDÉRMICO"
  },
  {
    "codigo":11844031000119101,
    "descripcion":"CONTUSIÓN DE OREJA DERECHA"
  },
  {
    "codigo":13265006,
    "descripcion":"HEPATITIS VIRAL TIPO B AGUDA FULMINANTE"
  },
  {
    "codigo":766929007,
    "descripcion":"HIPERFERRITINEMIA GENÉTICA SIN SOBRECARGA DE HIERRO"
  },
  {
    "codigo":111569009,
    "descripcion":"SÍNDROME DE HIPERTERMIA - HIPERFAGIA - HIPOTIROIDISMO"
  },
  {
    "codigo":109734002,
    "descripcion":"FRACASO DE RESTAURACIÓN DENTAL QUE AFECTA LA INTEGRIDAD DE LOS DIENTES ADYACENTES"
  },
  {
    "codigo":240806008,
    "descripcion":"INFECCIÓN POR PHANEROPSULUS BONNEI"
  },
  {
    "codigo":404646009,
    "descripcion":"DESLUMBRAMIENTO EXTREMO"
  },
  {
    "codigo":271739002,
    "descripcion":"CERA EN EL CONDUCTO AUDITIVO"
  },
  {
    "codigo":402811003,
    "descripcion":"NEOPLASIA ESCAMOSA DE SUPERFICIE EPITELIAL"
  },
  {
    "codigo":206203003,
    "descripcion":"ABRASIÓN DE CUERO CABELLUDO DEBIDA A TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":9595005,
    "descripcion":"INFESTACIÓN CAUSADA POR DERMANYSSIDAE"
  },
  {
    "codigo":1156475005,
    "descripcion":"PIE EQUINOVARO CONGÉNITO"
  },
  {
    "codigo":1285712000,
    "descripcion":"GLAUCOMA DE ÁNGULO ABIERTO DE OJO IZQUIERDO CAUSADO POR FÁRMACO"
  },
  {
    "codigo":106064001,
    "descripcion":"HALLAZGO CARDIOVASCULAR RELACIONADO CON LA PRESIÓN Y\/O EL PULSO"
  },
  {
    "codigo":204368006,
    "descripcion":"ESTENOSIS SUBAÓRTICA"
  },
  {
    "codigo":300837005,
    "descripcion":"REALIZA ACTIVIDADES DE MANTENIMIENTO DEL AUTO"
  },
  {
    "codigo":366373007,
    "descripcion":"ESTRUCTURA ESQUELÉTICA DE LA CARA - HALLAZGO"
  },
  {
    "codigo":15749721000119102,
    "descripcion":"UÑA ENCARNADA DE DEDO DEL PIE DERECHO"
  },
  {
    "codigo":200698001,
    "descripcion":"LINFADENITIS AGUDA DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":35023000,
    "descripcion":"GASTROESOFAGITIS"
  },
  {
    "codigo":723151005,
    "descripcion":"ESTADO VEGETATIVO PERMANENTE"
  },
  {
    "codigo":721316001,
    "descripcion":"HERIDA ABIERTA DE CABEZA POR MORDEDURA"
  },
  {
    "codigo":262564002,
    "descripcion":"HERIDA CONTUSA PROFUNDA"
  },
  {
    "codigo":322291000119100,
    "descripcion":"HIPERTROFIA DE MEMBRANA SINOVIAL DE ARTICULACIÓN DE MANO IZQUIERDA"
  },
  {
    "codigo":64121000,
    "descripcion":"ÚLCERA PÉPTICA CON HEMORRAGIA"
  },
  {
    "codigo":197028009,
    "descripcion":"GASTRITIS ALIMENTARIA"
  },
  {
    "codigo":459172009,
    "descripcion":"ENDOCARDITIS INFECCIOSA EN LOCALIZACIÓN DE DEFECTO DE TABIQUE INTERVENTRICULAR"
  },
  {
    "codigo":293497003,
    "descripcion":"REACCIÓN ADVERSA A LA BETANIDINA"
  },
  {
    "codigo":109448003,
    "descripcion":"DIENTE DECIDUO SUPERNUMERARIO"
  },
  {
    "codigo":1145465008,
    "descripcion":"APLASIA DE PUBIS"
  },
  {
    "codigo":291662002,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR CLORANFENICOL"
  },
  {
    "codigo":95054003,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA PIEL DE LA MEJILLA"
  },
  {
    "codigo":783182004,
    "descripcion":"DIFICULTAD RESPIRATORIA CRÓNICA CON DEFICIENCIA DEL METABOLISMO DEL SURFACTANTE"
  },
  {
    "codigo":422734005,
    "descripcion":"FUNCIÓN DE CUIDADO ABUSIVA"
  },
  {
    "codigo":15887091000119103,
    "descripcion":"BEBÉ PREMATURO, 26 SEMANAS"
  },
  {
    "codigo":226126005,
    "descripcion":"DIETA CON BAJO CONTENIDO DE GALACTOSA"
  },
  {
    "codigo":93219000,
    "descripcion":"MELANOMA MALIGNO DE LA PIEL DEL MENTÓN"
  },
  {
    "codigo":160590009,
    "descripcion":"BEBEDOR DE CERVEZA Y BEBIDAS ALCOHÓLICAS FUERTES"
  },
  {
    "codigo":224291002,
    "descripcion":"EDUCACIÓN INTERRUMPIDA"
  },
  {
    "codigo":289827009,
    "descripcion":"HALLAZGO RELACIONADO CON SUTURA DE CERCLAJE CERVICAL"
  },
  {
    "codigo":124152002,
    "descripcion":"DEFICIENCIA DE D - 2 - HIDROXI - ÁCIDO DESHIDROGENASA"
  },
  {
    "codigo":1172728007,
    "descripcion":"PROLAPSO DE INTESTINO DELGADO"
  },
  {
    "codigo":25848009,
    "descripcion":"FUNCIÓN CARDÍACA AUMENTADA"
  },
  {
    "codigo":417229001,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR FÁRMACO QUE ACTÚA PRINCIPALMENTE SOBRE LA NUTRICIÓN"
  },
  {
    "codigo":286157002,
    "descripcion":"NO LIMPIA LA DUCHA"
  },
  {
    "codigo":253389004,
    "descripcion":"CUERDA TENDINOSA TRICUSPÍDEA AL TABIQUE DEL TRACTO DE SALIDA"
  },
  {
    "codigo":187853005,
    "descripcion":"NEOPLASIA MALIGNA DEL CARTÍLAGO TRAQUEAL"
  },
  {
    "codigo":89549007,
    "descripcion":"BRONQUITIS CATARRAL"
  },
  {
    "codigo":24013007,
    "descripcion":"HIPERLEUCINEMIA"
  },
  {
    "codigo":1300130001,
    "descripcion":"HIPOMIELINIZACIÓN DE ESTRUCTURAS MIELINIZADAS A TEMPRANA EDAD"
  },
  {
    "codigo":251554006,
    "descripcion":"ONDA F - HALLAZGO"
  },
  {
    "codigo":284322006,
    "descripcion":"DIFICULTAD PARA MANIPULAR OBJETOS INTERRELACIONADOS"
  },
  {
    "codigo":22178008,
    "descripcion":"ESTADO POSTPARTO, 8 SEMANAS"
  },
  {
    "codigo":315255000,
    "descripcion":"LESIÓN CUTÁNEA PIGMENTADA DE COLOR MIXTO"
  },
  {
    "codigo":282487001,
    "descripcion":"CAPAZ DE CORRER PENDIENTE ARRIBA"
  },
  {
    "codigo":85879003,
    "descripcion":"FIBROSITIS SECUNDARIA"
  },
  {
    "codigo":53111003,
    "descripcion":"INTENTO FALLIDO DE ABORTO CON CHOQUE POSTOPERATORIO"
  },
  {
    "codigo":448162007,
    "descripcion":"VENTRÍCULO DERECHO BIPARTITO"
  },
  {
    "codigo":20343006,
    "descripcion":"DERMATITIS LIQUENOIDE PURPÚRICA PIGMENTADA DE GOUGEROT Y BLUM"
  },
  {
    "codigo":1263692001,
    "descripcion":"TRASTORNO FETAL DEBIDO A EMBARAZO MÚLTIPLE"
  },
  {
    "codigo":870476002,
    "descripcion":"INGESTA INADECUADA DE VITAMINA K Y\/O DERIVADO DE VITAMINA K"
  },
  {
    "codigo":247884005,
    "descripcion":"PENSAMIENTOS OBSESIVOS ACERCA DE NO ESTAR COMPLETO"
  },
  {
    "codigo":16673001,
    "descripcion":"ESTENOSIS DE CONDUCTO AUDITIVO EXTERNO TRAUMÁTICA"
  },
  {
    "codigo":1163553003,
    "descripcion":"ENCEFALITIS POR VIRUS KUNJIN"
  },
  {
    "codigo":213281004,
    "descripcion":"CETONEMIA"
  },
  {
    "codigo":735734002,
    "descripcion":"CÁLCULO DE CONDUCTO BILIAR SIN INFLAMACIÓN DE LA VÍA BILIAR"
  },
  {
    "codigo":1088551000119103,
    "descripcion":"OTITIS MEDIA SEROSANGUINOLENTA CRÓNICA DE OÍDO MEDIO IZQUIERDO"
  },
  {
    "codigo":309750008,
    "descripcion":"EXTRAVASACIÓN DEBIDA A TRANSFUSIÓN SANGUÍNEA Y POSTERIOR A ELLA"
  },
  {
    "codigo":187431000119104,
    "descripcion":"NECROSIS AVASCULAR DE MAXILAR INFERIOR"
  },
  {
    "codigo":111307005,
    "descripcion":"SÍNDROME DE LEPRECAUNISMO"
  },
  {
    "codigo":1290955006,
    "descripcion":"ANGIOFIBROMA DE PARTES BLANDAS"
  },
  {
    "codigo":13003007,
    "descripcion":"CISTATIONINURIA"
  },
  {
    "codigo":207776000,
    "descripcion":"FRACTURA EXPUESTA DE MÚLTIPLES SITIOS DE MANDÍBULA"
  },
  {
    "codigo":109472008,
    "descripcion":"AMELOGÉNESIS IMPERFECTA, TIPO HIPOPLASIA POR HIPOMADURACIÓN CON TAURODONTISMO"
  },
  {
    "codigo":699296008,
    "descripcion":"PERFIL RECTO DE PARTES BLANDAS FACIALES"
  },
  {
    "codigo":15997991000119107,
    "descripcion":"OCLUSIÓN VASCULAR BILATERAL DE RETINA"
  },
  {
    "codigo":402549006,
    "descripcion":"NEVO MELANOCÍTICO PENETRANTE PROFUNDO"
  },
  {
    "codigo":678951000119108,
    "descripcion":"DEPÓSITO EN CÓRNEA DE OJO IZQUIERDO DEBIDO A TRASTORNO METABÓLICO"
  },
  {
    "codigo":369781009,
    "descripcion":"PLEOMORFISMO NUCLEAR DE CARCINOMA DUCTAL IN SITU, GRADO 1: MONOTONÍA NUCLEAR, DIÁMETRO ERITROCÍTICO DE 1,5 A 2 CON CROMATINA FINAMENTE DISTRIBUIDA Y NUCLÉOLOS AISLADOS"
  },
  {
    "codigo":171338009,
    "descripcion":"EXAMEN ESPECIAL CONVENIDO"
  },
  {
    "codigo":202271004,
    "descripcion":"CONTRACTURA EN FLEXIÓN DE CODO"
  },
  {
    "codigo":235039005,
    "descripcion":"PIGMENTACIÓN RACIAL DE LA MUCOSA BUCAL"
  },
  {
    "codigo":890399008,
    "descripcion":"ANOMALÍA CONGÉNITA DE RÓTULA"
  },
  {
    "codigo":298740004,
    "descripcion":"DOLOR A LA PALPACIÓN EN COSTILLA"
  },
  {
    "codigo":67529001,
    "descripcion":"CICATRIZ DE AMÍGDALA"
  },
  {
    "codigo":296905001,
    "descripcion":"SOBREDOSIS DE ESTRÓGENO"
  },
  {
    "codigo":34761004,
    "descripcion":"RECIÉN NACIDO FLÁCCIDO"
  },
  {
    "codigo":722889008,
    "descripcion":"ENFERMEDAD DE CHAGAS AGUDA SIN COMPROMISO CARDÍACO"
  },
  {
    "codigo":426142001,
    "descripcion":"DOLOR IRRADIADO AL HOMBRO DERECHO"
  },
  {
    "codigo":1148873009,
    "descripcion":"GLOMERULOPATÍA DEBIDA A ENFERMEDAD HEMATOLÓGICA"
  },
  {
    "codigo":1179806004,
    "descripcion":"CONDUCTO LAGRIMAL DIVIDIDO LUEGO DE INTUBACIÓN"
  },
  {
    "codigo":1145203001,
    "descripcion":"TORSIÓN DE EPIPLÓN MAYOR"
  },
  {
    "codigo":31091003,
    "descripcion":"INTERCAMBIO DE CROMÁTIDES HERMANAS"
  },
  {
    "codigo":194931003,
    "descripcion":"ENDOCARDITIS - BLASTOMICOSIS"
  },
  {
    "codigo":1208904001,
    "descripcion":"CONJUNTIVITIS CICATRIZANTE AGUDA INDUCIDA POR FÁRMACO"
  },
  {
    "codigo":94792004,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL CUELLO UTERINO"
  },
  {
    "codigo":191261000,
    "descripcion":"ANEMIA SIDEROBLÁSTICA SECUNDARIA POR ENFERMEDAD"
  },
  {
    "codigo":846621001,
    "descripcion":"MIOPÍA DEGENERATIVA DE OJO IZQUIERDO"
  },
  {
    "codigo":92957000,
    "descripcion":"FORMA ANORMAL CONGÉNITA DEL ÚTERO"
  },
  {
    "codigo":353781000119101,
    "descripcion":"CARCINOMA IN SITU DE BRONQUIO Y PULMÓN DERECHOS"
  },
  {
    "codigo":1010461005,
    "descripcion":"NISTAGMO UNIOCULAR DE OJO IZQUIERDO"
  },
  {
    "codigo":125725006,
    "descripcion":"SOLTERO, NO CASADO ANTERIORMENTE"
  },
  {
    "codigo":60189009,
    "descripcion":"DEGENERACIÓN VÍTREA"
  },
  {
    "codigo":123890004,
    "descripcion":"INTOXICACIÓN POR ASCLEPIADACEAE"
  },
  {
    "codigo":386034005,
    "descripcion":"MASTOIDITIS AGUDA"
  },
  {
    "codigo":254962005,
    "descripcion":"ADENOMA DE HIPÓFISIS NO FUNCIONANTE"
  },
  {
    "codigo":416967001,
    "descripcion":"NUTACIÓN ANTERIOR DEL SACRO"
  },
  {
    "codigo":285895001,
    "descripcion":"USA UTENSILIOS DE COCINA"
  },
  {
    "codigo":249457005,
    "descripcion":"ÚLCERA SUPRAGLÓTICA"
  },
  {
    "codigo":413297007,
    "descripcion":"DIETA INAPROPIADA PARA LA EDAD"
  },
  {
    "codigo":85617008,
    "descripcion":"RITMO RESPIRATORIO ANORMAL"
  },
  {
    "codigo":282225009,
    "descripcion":"NO CAMINA SOBRE UNA LÍNEA ANGOSTA"
  },
  {
    "codigo":51014003,
    "descripcion":"TUBERCULOSIS POR REINFECCIÓN"
  },
  {
    "codigo":247622009,
    "descripcion":"PENSAMIENTO ASTUTO"
  },
  {
    "codigo":278555002,
    "descripcion":"EMPASTE DE AMALGAMA DENTAL PRESENTE"
  },
  {
    "codigo":737307003,
    "descripcion":"DEFICIENCIA DE CÉLULAS ASESINAS NATURALES"
  },
  {
    "codigo":313158009,
    "descripcion":"EXOTROPÍA PARA LA VISIÓN LEJANA"
  },
  {
    "codigo":1259760003,
    "descripcion":"CÁNCER PULMONAR DE CÉLULAS NO MICROCÍTICAS PRIMARIO CON MUTACIÓN EN RECEPTOR DE FACTOR DE CRECIMIENTO EPIDÉRMICO"
  },
  {
    "codigo":276720006,
    "descripcion":"DISMORFISMO"
  },
  {
    "codigo":47344007,
    "descripcion":"ANOMALÍA DE LA SECRECIÓN DE GASTRINA"
  },
  {
    "codigo":735472008,
    "descripcion":"ACODAMIENTO DE URÉTER SIN OBSTRUCCIÓN"
  },
  {
    "codigo":733637001,
    "descripcion":"FORMA INFANTIL DE DEFICIENCIA DE 3-FOSFOGLICERATO DESHIDROGENASA"
  },
  {
    "codigo":45509005,
    "descripcion":"SENSIBILIDAD AUMENTADA DE LAS CÉLULAS PARIETALES A LOS SECRETAGOGOS"
  },
  {
    "codigo":209349006,
    "descripcion":"FRACTURA-LUXACIÓN NO EXPUESTA DE ARTICULACIÓN DE TOBILLO"
  },
  {
    "codigo":405957007,
    "descripcion":"EQUIPO INTERGRUPAL PARA EL ESTUDIO POSQUIRÚRGICO DE RABDOMIOSARCOMA IA: TUMOR LOCALIZADO, LIMITADO AL SITIO DE ORIGEN, TOTALMENTE RESECADO"
  },
  {
    "codigo":307653008,
    "descripcion":"TORPEZA - RETRASO MOTRIZ"
  },
  {
    "codigo":404122003,
    "descripcion":"INFILTRACIÓN LEUCÉMICA DE LA PIEL (LEUCEMIA LINFOCÍTICA CRÓNICA DE CÉLULAS T)"
  },
  {
    "codigo":305818004,
    "descripcion":"ATENDIDO EN EL SERVICIO DE MEDICINA GENITOURINARIA"
  },
  {
    "codigo":895642006,
    "descripcion":"FORMA TRIANGULAR ANORMAL CONGÉNITA DE FALANGE PROXIMAL DE DEDO DE PIE"
  },
  {
    "codigo":238447003,
    "descripcion":"INFESTACIÓN CUTÁNEA POR NEMATODOS"
  },
  {
    "codigo":369519004,
    "descripcion":"NEOPLASIA MALIGNA QUE COMPROMETE TROMPA DE FALOPIO IZQUIERDA POR PROPAGACIÓN DIRECTA DESDE ÚTERO"
  },
  {
    "codigo":105540000,
    "descripcion":"NO FUMADOR POR MOTIVOS RELIGIOSOS"
  },
  {
    "codigo":15701801000119106,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE TENDÓN FLEXOR DE MUÑECA DERECHA"
  },
  {
    "codigo":1186884006,
    "descripcion":"MIELOPATÍA POR DEFICIENCIA DE COBRE"
  },
  {
    "codigo":236612006,
    "descripcion":"FÍSTULA DE URÉTER HACIA EL CUELLO UTERINO"
  },
  {
    "codigo":169241000,
    "descripcion":"ECOCARDIOGRAMA ANORMAL"
  },
  {
    "codigo":300313001,
    "descripcion":"RECTO NORMAL"
  },
  {
    "codigo":890137002,
    "descripcion":"INTOXICACIÓN POR JACOBAEA VULGARIS"
  },
  {
    "codigo":16275241000119107,
    "descripcion":"ENTROPIÓN SENIL DE AMBOS PÁRPADOS INFERIORES"
  },
  {
    "codigo":202009005,
    "descripcion":"ARTROPATÍA TRANSITORIA DE LA ARTICULACIÓN SACROILÍACA"
  },
  {
    "codigo":298478001,
    "descripcion":"DOLOR AL MOVIMIENTO DE COLUMNA CERVICAL"
  },
  {
    "codigo":36334003,
    "descripcion":"INFECCIÓN POR HYMENOLEPIS DIMINUTA"
  },
  {
    "codigo":69102005,
    "descripcion":"FRACTURA NO EXPUESTA DE TRÁQUEA"
  },
  {
    "codigo":167406006,
    "descripcion":"NIVEL DE NORADRENALINA EN ORINA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":724462007,
    "descripcion":"TRASTORNO DEBIDO A REPRODUCCIÓN ASISTIDA MÉDICAMENTE"
  },
  {
    "codigo":296643001,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE ÁCIDO FUSÍDICO"
  },
  {
    "codigo":1148611002,
    "descripcion":"FRECUENCIA DE ELECTRORRETINOGRAMA DE DESTELLO BRILLANTE CON ADAPTACIÓN A OSCURIDAD ANORMAL"
  },
  {
    "codigo":460483004,
    "descripcion":"TRAYECTO ANTERIOR DE ARTERIA DEL NÓDULO SINUSAL EN RELACIÓN A LA VENA CAVA SUPERIOR"
  },
  {
    "codigo":722627005,
    "descripcion":"LESIÓN TRAUMÁTICA FOCAL DE TRONCO ENCEFÁLICO"
  },
  {
    "codigo":788163005,
    "descripcion":"ALERGIA A INSULINA BOVINA"
  },
  {
    "codigo":1279683008,
    "descripcion":"INFECCIÓN CAUSADA POR BORRELIA MAZZOTTII"
  },
  {
    "codigo":196504005,
    "descripcion":"SIALODOCOLITIASIS SUBLINGUAL"
  },
  {
    "codigo":130968006,
    "descripcion":"AUTOMUTILACIÓN"
  },
  {
    "codigo":424045003,
    "descripcion":"PUENTE MIOCÁRDICO DE ARTERIA CORONARIA"
  },
  {
    "codigo":129133005,
    "descripcion":"ARTROPATÍA POSBACTERIANA"
  },
  {
    "codigo":63597007,
    "descripcion":"COMPLICACIÓN DE ESTOMA EXTERNO DEL TRACTO URINARIO"
  },
  {
    "codigo":127298000,
    "descripcion":"LESIÓN TRAUMÁTICA CEREBRAL CON PÉRDIDA DE LA CONSCIENCIA"
  },
  {
    "codigo":1144941009,
    "descripcion":"NEFRITIS TUBULOINTERSTICIAL CRÓNICA POSTERIOR A TRASPLANTE RENAL"
  },
  {
    "codigo":225602000,
    "descripcion":"INCAPAZ DE SENTARSE SIN SOSTÉN"
  },
  {
    "codigo":292973009,
    "descripcion":"REACCIÓN ADVERSA A LA BACAMPICILINA"
  },
  {
    "codigo":291138008,
    "descripcion":"INTOXICACIÓN POR TETRABENAZINA"
  },
  {
    "codigo":94530008,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA ESCLERÓTICA"
  },
  {
    "codigo":289303000,
    "descripcion":"HALLAZGO RELACIONADO CON EL LATIDO DEL CORDÓN"
  },
  {
    "codigo":59927004,
    "descripcion":"INSUFICIENCIA HEPÁTICA"
  },
  {
    "codigo":715287007,
    "descripcion":"PERIODONTITIS CRÓNICA LOCALIZADA SEVERA"
  },
  {
    "codigo":92695008,
    "descripcion":"CARCINOMA IN SITU DE LA UNIÓN RECTOSIGMOIDE"
  },
  {
    "codigo":90860001,
    "descripcion":"OSTEOARTROSIS LOCALIZADA DE CARÁCTER PRIMARIO O SECUNDARIO INCIERTO"
  },
  {
    "codigo":1336044002,
    "descripcion":"EPISODIO DE USO NOCIVO DE BARBITÚRICO"
  },
  {
    "codigo":713452008,
    "descripcion":"CONOCIMIENTO DEFICIENTE DEL DESARROLLO FETAL"
  },
  {
    "codigo":254700008,
    "descripcion":"TRICODISCOMA"
  },
  {
    "codigo":711617002,
    "descripcion":"IRITIS SIFILÍTICA"
  },
  {
    "codigo":1137601009,
    "descripcion":"ALTERACIÓN DE COLORACIÓN DE LABIO"
  },
  {
    "codigo":54422002,
    "descripcion":"OBLITERACIÓN FIBROSA DE APÉNDICE ILEOCECAL"
  },
  {
    "codigo":414870003,
    "descripcion":"MUCOSA DE ÓRGANO DEL APARATO DIGESTIVO, NODULAR"
  },
  {
    "codigo":283798006,
    "descripcion":"MORDEDURA DE ANIMAL EN LA MEJILLA"
  },
  {
    "codigo":251030009,
    "descripcion":"ESTENOSIS DE STENT CORONARIO"
  },
  {
    "codigo":249195007,
    "descripcion":"SITUACIÓN MATERNA DURANTE EL TRABAJO DE PARTO"
  },
  {
    "codigo":116288000,
    "descripcion":"ACCIDENTE CEREBROVASCULAR PARALÍTICO"
  },
  {
    "codigo":773483009,
    "descripcion":"ALERGIA A NITROPRUSIATO"
  },
  {
    "codigo":8691000175105,
    "descripcion":"INFILTRADO PULMONAR MULTILOBULAR"
  },
  {
    "codigo":280128006,
    "descripcion":"TRASTORNO DE PARTES BLANDAS DE CAVIDAD DEL CUERPO"
  },
  {
    "codigo":81685000,
    "descripcion":"DEFICIENCIA DE ALFA - AMILASA PANCREÁTICA"
  },
  {
    "codigo":212757000,
    "descripcion":"INTOXICACIÓN POR RELAJANTE DEL MÚSCULO LISO"
  },
  {
    "codigo":1197632008,
    "descripcion":"EQUIPAMIENTO INADECUADO PARA ALMACENAMIENTO SEGURO DE ALIMENTOS EN LA VIVIENDA"
  },
  {
    "codigo":15677841000119101,
    "descripcion":"CORIORRETINITIS DE AMBOS OJOS DEBIDA A SÍFILIS SECUNDARIA"
  },
  {
    "codigo":704277009,
    "descripcion":"CONSENTIMIENTO PARA EXAMEN DEL SISTEMA RESPIRATORIO REHUSADO"
  },
  {
    "codigo":407530004,
    "descripcion":"VASCULITIS SISTÉMICA PRIMARIA"
  },
  {
    "codigo":47082005,
    "descripcion":"NEUMONÍA CONGÉNITA POR RUBÉOLA"
  },
  {
    "codigo":10625271000119109,
    "descripcion":"BRONCONEUMONÍA CAUSADA POR METAPNEUMOVIRUS HUMANO"
  },
  {
    "codigo":1259498004,
    "descripcion":"CARCINOMA ADENOIDE QUÍSTICO PRIMARIO DE GLÁNDULA SUBMAXILAR"
  },
  {
    "codigo":307391000,
    "descripcion":"HEMATOMA DE MUSLO"
  },
  {
    "codigo":276458009,
    "descripcion":"ONICOATROFIA"
  },
  {
    "codigo":702442008,
    "descripcion":"ATAXIA CON DEFICIENCIA DE VITAMINA E"
  },
  {
    "codigo":241855005,
    "descripcion":"EFECTO TÓXICO CAUSADO POR QUITAMANCHAS"
  },
  {
    "codigo":12479006,
    "descripcion":"COMPULSIÓN"
  },
  {
    "codigo":733375008,
    "descripcion":"MORDEDURA ABIERTA DE ABDOMEN"
  },
  {
    "codigo":371092001,
    "descripcion":"ASUNTO DE SEGURIDAD COGNITIVA"
  },
  {
    "codigo":240020000,
    "descripcion":"LAXITUD LIGAMENTARIA DE REGIÓN DE TOBILLO"
  },
  {
    "codigo":403860002,
    "descripcion":"ACROCORDONES MÚLTIPLES DE AXILA"
  },
  {
    "codigo":16906641000119105,
    "descripcion":"CARCINOMA IN SITU DE PIEL DE PÁRPADO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":76180001,
    "descripcion":"AGRESIÓN OFENSIVA"
  },
  {
    "codigo":698772008,
    "descripcion":"QUISTE ODONTÓGENO CALCIFICANTE EXTRAÓSEO"
  },
  {
    "codigo":305556008,
    "descripcion":"BAJO ATENCIÓN DE ESPECIALISTA EN ENFERMERÍA CLÍNICA"
  },
  {
    "codigo":762473003,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL SUPERFICIAL DE TRONCO"
  },
  {
    "codigo":1155689004,
    "descripcion":"EMBOLIA DE AMBAS ARTERIAS CEREBELOSAS"
  },
  {
    "codigo":74345006,
    "descripcion":"ENFERMEDAD CROMOSÓMICA"
  },
  {
    "codigo":113041000119108,
    "descripcion":"ARTROSIS DE AMBOS HOMBROS"
  },
  {
    "codigo":860777008,
    "descripcion":"ALERGIA A DICLOROACETAMIDA"
  },
  {
    "codigo":301886001,
    "descripcion":"POSICIÓN DE LAS RODILLAS HACIA ARRIBA"
  },
  {
    "codigo":269118002,
    "descripcion":"LUXACIÓN NO EXPUESTA ENTRE LA TERCERA Y LA CUARTA VÉRTEBRAS CERVICALES"
  },
  {
    "codigo":203582003,
    "descripcion":"ANTEPIÉ CON FLEXIÓN PLANTAR ADQUIRIDA"
  },
  {
    "codigo":400190005,
    "descripcion":"CONDICIÓN ATRÓFICA DE LA PIEL"
  },
  {
    "codigo":6974005,
    "descripcion":"HIPOGLUCEMIA POR AYUNO"
  },
  {
    "codigo":432958009,
    "descripcion":"RECHAZO CRÓNICO DE TRASPLANTE DE PULMÓN"
  },
  {
    "codigo":365587003,
    "descripcion":"TÍTULO DE ANTICUERPOS ANTIVIRUS DE LA INMUNODEFICIENCIA HUMANA - HALLAZGO"
  },
  {
    "codigo":43311000087102,
    "descripcion":"CUERPO EXTRAÑO DE REGIÓN DE OJO DERECHO"
  },
  {
    "codigo":38191000087102,
    "descripcion":"HIPOCINESIA DE SEGMENTO APICAL ANTERIOR DE VENTRÍCULO CARDÍACO IZQUIERDO"
  },
  {
    "codigo":40751000087105,
    "descripcion":"ABRASIÓN DE PIEL DE CUARTO DEDO DE PIE IZQUIERDO"
  },
  {
    "codigo":429288002,
    "descripcion":"RITMO DE ESCAPE VENTRICULAR EN EL ELECTROCARDIOGRAMA"
  },
  {
    "codigo":396520003,
    "descripcion":"MARGEN QUIRÚRGICO LATERAL NO COMPROMETIDO POR MELANOMA MALIGNO"
  },
  {
    "codigo":48431000087108,
    "descripcion":"FRACTURA DE SEGUNDO HUESO METATARSIANO DE PIE DERECHO"
  },
  {
    "codigo":3304005,
    "descripcion":"COMPRESIÓN BRONQUIAL"
  },
  {
    "codigo":134376008,
    "descripcion":"PRUEBA AUDITIVA DERECHA ANORMAL"
  },
  {
    "codigo":789736008,
    "descripcion":"DISTIQUIASIS ADQUIRIDA"
  },
  {
    "codigo":298216008,
    "descripcion":"LAXITUD DE ARTICULACIÓN DE RODILLA"
  },
  {
    "codigo":296381002,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE SALBUTAMOL"
  },
  {
    "codigo":394685004,
    "descripcion":"ALTO RIESGO DE SUICIDIO"
  },
  {
    "codigo":1469007,
    "descripcion":"ABORTO ESPONTÁNEO CON INFECCIÓN DE VÍAS URINARIAS"
  },
  {
    "codigo":294546003,
    "descripcion":"ALERGIA A CEFTAZIDIMA"
  },
  {
    "codigo":32402008,
    "descripcion":"ESPASMO FACIAL"
  },
  {
    "codigo":1179282009,
    "descripcion":"TRASTORNO DEL NEURODESARROLLO GRAVE CON DIFICULTAD PARA LA ALIMENTACIÓN, MOVIMIENTOS ESTEREOTIPADOS DE LAS MANOS Y CATARATAS BILATERALES"
  },
  {
    "codigo":816999002,
    "descripcion":"FÍSTULA SUPURATIVA DE PIEL"
  },
  {
    "codigo":425618009,
    "descripcion":"QUERATITIS MICOBACTERIANA"
  },
  {
    "codigo":1144679001,
    "descripcion":"APLASIA DE FALANGE DISTAL DE DEDO GORDO DE PIE"
  },
  {
    "codigo":292711007,
    "descripcion":"REACCIÓN ADVERSA A LA PROSTAGLANDINA, SERIE E"
  },
  {
    "codigo":161639008,
    "descripcion":"CON MAYOR RIESGO DE SUFRIR ENFERMEDAD CARDÍACA"
  },
  {
    "codigo":128871009,
    "descripcion":"TRASTORNO LINFOPROLIFERATIVO ATÍPICO ASOCIADO CON UN VIRUS"
  },
  {
    "codigo":421948002,
    "descripcion":"ANESTESIA GENERAL - BAJO ANESTESIA ADECUADA"
  },
  {
    "codigo":258108004,
    "descripcion":"VOZ GRABADA"
  },
  {
    "codigo":716860005,
    "descripcion":"INFECCIÓN DE INTESTINO CAUSADA POR CYCLOSPORA CAYETANENSIS"
  },
  {
    "codigo":94268006,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LOS GANGLIOS LINFÁTICOS CUBITALES"
  },
  {
    "codigo":782396008,
    "descripcion":"NÓDULO DE PIEL DE DEDO DE MANO"
  },
  {
    "codigo":61500009,
    "descripcion":"PROSTATITIS GRANULOMATOSA"
  },
  {
    "codigo":290876008,
    "descripcion":"INTOXICACIÓN POR MOCLOBEMIDA"
  },
  {
    "codigo":190737001,
    "descripcion":"IMINOACIDOPATÍA"
  },
  {
    "codigo":420113004,
    "descripcion":"REACCIÓN ADVERSA A VACUNA ANTIGRIPAL"
  },
  {
    "codigo":92433007,
    "descripcion":"NEOPLASIA BENIGNA DEL RETROPERITONEO"
  },
  {
    "codigo":715025008,
    "descripcion":"CAMINA POR UN CORREDOR"
  },
  {
    "codigo":131123006,
    "descripcion":"VITAMINA K2 POR DEBAJO DE RANGO DE REFERENCIA"
  },
  {
    "codigo":385510003,
    "descripcion":"QUEMADURA DE LA PIEL POR BLANQUEADOR"
  },
  {
    "codigo":254438006,
    "descripcion":"NEOPLASIA DE SURCO BUCAL"
  },
  {
    "codigo":1268411000,
    "descripcion":"RUPTURA ESPONTÁNEA DE FASCIA PLANTAR"
  },
  {
    "codigo":187067000,
    "descripcion":"BLASTOMICOSIS DISEMINADA"
  },
  {
    "codigo":1237478008,
    "descripcion":"METÁSTASIS DE CARCINOMA DE PIEL DE CUELLO"
  },
  {
    "codigo":55995005,
    "descripcion":"ESFEROCITOSIS HEREDITARIA"
  },
  {
    "codigo":54160000,
    "descripcion":"ANEURISMA CONGÉNITO DE SENO DE VALSALVA"
  },
  {
    "codigo":449211009,
    "descripcion":"NEOPLASIA EPITELIAL MALIGNA DE CARA"
  },
  {
    "codigo":840592004,
    "descripcion":"ÚLCERA GÁSTRICA CAUSADA POR INHIBIDOR DE LA AGREGACIÓN PLAQUETARIA"
  },
  {
    "codigo":19557000,
    "descripcion":"HIPEREXPLEXIA"
  },
  {
    "codigo":185232008,
    "descripcion":"ATENDIDO EN UN CONSULTORIO PSIQUIÁTRICO"
  },
  {
    "codigo":1363045002,
    "descripcion":"METABOLIZADOR INTERMEDIO DE FAMILIA 2 SUBFAMILIA C MIEMBRO 9 *11\/*11 DE CITOCROMO P450"
  },
  {
    "codigo":283536009,
    "descripcion":"HERIDA PUNZANTE EN PIERNA"
  },
  {
    "codigo":609381007,
    "descripcion":"DEFORMIDAD ANGULADA DE MIEMBRO INFERIOR"
  },
  {
    "codigo":871525007,
    "descripcion":"REACCIÓN ADVERSA A TERODILINA"
  },
  {
    "codigo":247098001,
    "descripcion":"HEMORRAGIA SUBHIALOIDE"
  },
  {
    "codigo":15735801000119102,
    "descripcion":"DEGENERACIÓN DE CÓRNEA DE AMBOS OJOS"
  },
  {
    "codigo":50490005,
    "descripcion":"ENCEFALOPATÍA HIPERTENSIVA"
  },
  {
    "codigo":48655003,
    "descripcion":"HIPOMAGNESEMIA RENAL FAMILIAR AISLADA"
  },
  {
    "codigo":81423003,
    "descripcion":"FIBROSIS QUÍSTICA SIN ÍLEO MECONIAL"
  },
  {
    "codigo":704015004,
    "descripcion":"FRACTURA EXPUESTA DE FALANGE PROXIMAL DE PRIMER DEDO DEL PIE"
  },
  {
    "codigo":14052004,
    "descripcion":"TRASTORNO DE TOLERANCIA A GLUCOSA EN CASO DE DIABETES MELLITUS HEREDITARIA DE INICIO TARDÍO EN LA JUVENTUD"
  },
  {
    "codigo":733113002,
    "descripcion":"SÍNDROME DE HIPOGONADISMO HIPOGONADOTRÓFICO Y RETINITIS PIGMENTOSA"
  },
  {
    "codigo":308371000119101,
    "descripcion":"GRANULOMA POR CUERPO EXTRAÑO DE PARTES BLANDAS DE LA MANO IZQUIERDA"
  },
  {
    "codigo":77753005,
    "descripcion":"ENFERMEDAD PULMONAR LÚPICA"
  },
  {
    "codigo":272526000,
    "descripcion":"BIPEDESTACIÓN CON LOS PIES JUNTOS"
  },
  {
    "codigo":896953009,
    "descripcion":"FORMA DE BALA ANORMAL CONGÉNITA DE FALANGE DISTAL DE TERCER DEDO DE PIE"
  },
  {
    "codigo":403598008,
    "descripcion":"SÍNDROME DOLOROSO CUTÁNEO"
  },
  {
    "codigo":43150009,
    "descripcion":"TRASTORNO DE PÁNICO SIN AGORAFOBIA CON ATAQUES DE PÁNICO GRAVES"
  },
  {
    "codigo":237923004,
    "descripcion":"DEFICIENCIA DE DOPAMINA BETA-HIDROLASA"
  },
  {
    "codigo":8547008,
    "descripcion":"ABUSO DE LA VOZ EN LOS NIÑOS"
  },
  {
    "codigo":236088002,
    "descripcion":"FILTRACIÓN POR ANASTOMOSIS DUODENAL"
  },
  {
    "codigo":37645002,
    "descripcion":"QUEMADURA DE CARA, CABEZA Y\/O CUELLO"
  },
  {
    "codigo":1217293003,
    "descripcion":"BRONCOGRAMA AÉREO"
  },
  {
    "codigo":299789004,
    "descripcion":"OJO QUE SE DESPLAZA EN DIRECCIÓN AL SONIDO, PRESENTE"
  },
  {
    "codigo":70413005,
    "descripcion":"DERMATOFILOSIS CAUSADA POR DERMATOPHILUS CONGOLENSIS"
  },
  {
    "codigo":11777171000119108,
    "descripcion":"LACERACIÓN DE TENDÓN DE MÚSCULO TRÍCEPS BRAQUIAL IZQUIERDO"
  },
  {
    "codigo":232418000,
    "descripcion":"INFECCIÓN AGUDA DE RESTOS AMIGDALINOS"
  },
  {
    "codigo":201485008,
    "descripcion":"ARTROPATÍA DE REGIÓN DE HOMBRO POR SÍNDROME DE BEHCET"
  },
  {
    "codigo":297954002,
    "descripcion":"PIEL LIMPIA"
  },
  {
    "codigo":396258000,
    "descripcion":"MARGEN QUIRÚRGICO EXOCERVICAL NO COMPROMETIDO POR NEOPLASIA INTRAEPITELIAL"
  },
  {
    "codigo":723938004,
    "descripcion":"EXPOSICIÓN DE IMPLANTE OCULAR"
  },
  {
    "codigo":365325007,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA LIMPIAR EL ÁREA DE PREPARACIÓN DE COMIDAS"
  },
  {
    "codigo":296119000,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE DIAZEPAM"
  },
  {
    "codigo":363490009,
    "descripcion":"NEOPLASIA MALIGNA DE ANO"
  },
  {
    "codigo":427191004,
    "descripcion":"BURSITIS INTERMETATARSIANA"
  },
  {
    "codigo":1207009,
    "descripcion":"ATROFIA DE PAPILA ÓPTICA POR GLAUCOMA"
  },
  {
    "codigo":425356002,
    "descripcion":"DESPRENDIMIENTO DE EPITELIO PIGMENTARIO RETINIANO POR HERPES ZÓSTER"
  },
  {
    "codigo":722103009,
    "descripcion":"CÁNCER DE PRÓSTATA SENSIBLE A HORMONAS"
  },
  {
    "codigo":359820003,
    "descripcion":"FRACTURA PROXIMAL NO EXPUESTA DE CUELLO DE FÉMUR"
  },
  {
    "codigo":294284005,
    "descripcion":"ALERGIA A DEFEROXAMINA"
  },
  {
    "codigo":95841006,
    "descripcion":"HIPOPLASMINOGENEMIA HEREDITARIA"
  },
  {
    "codigo":292449007,
    "descripcion":"REACCIÓN ADVERSA A LA PRAZOSINA"
  },
  {
    "codigo":128609009,
    "descripcion":"ANEURISMA INTRACRANEAL"
  },
  {
    "codigo":94006002,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE COLON SIGMOIDE"
  },
  {
    "codigo":28470004,
    "descripcion":"DETERMINACIÓN DEL RESULTADO: COMPLICACIÓN EVITABLE"
  },
  {
    "codigo":126774004,
    "descripcion":"NEOPLASIA DE LA CARA INTERNA DE LABIO"
  },
  {
    "codigo":290614004,
    "descripcion":"INTOXICACIÓN POR ESTRAMUSTINA"
  },
  {
    "codigo":26635001,
    "descripcion":"PUNTAJE DE APGAR 3"
  },
  {
    "codigo":92171007,
    "descripcion":"NEOPLASIA BENIGNA DE LA CARA LARÍNGEA DEL PLIEGUE ARITENOEPIGLÓTICO"
  },
  {
    "codigo":59403008,
    "descripcion":"RECIÉN NACIDO PREMATURO DE SEXO FEMENINO"
  },
  {
    "codigo":288779007,
    "descripcion":"NO COMUNICA INTENCIONES"
  },
  {
    "codigo":24800002,
    "descripcion":"ESTADO DE PORTADOR, ENFERMEDAD ASINTOMÁTICA"
  },
  {
    "codigo":57568005,
    "descripcion":"GRUPO DE VOZ RONCA ESFORZADA - CONTINUA"
  },
  {
    "codigo":1074631000119106,
    "descripcion":"ARTRITIS DE AMBAS ARTICULACIONES GLENOHUMERALES"
  },
  {
    "codigo":254176007,
    "descripcion":"EPIDERMÓLISIS BULLOSA DISTRÓFICA RECESIVA PROGRESIVA"
  },
  {
    "codigo":285109002,
    "descripcion":"PENETRACIÓN VAGINAL CON DEDO DE LA MANO"
  },
  {
    "codigo":10905031000119108,
    "descripcion":"HERIDA POR ARMA BLANCA DE PARED ABDOMINAL"
  },
  {
    "codigo":283274000,
    "descripcion":"VIDRIO EN DEDO GORDO DEL PIE"
  },
  {
    "codigo":53898005,
    "descripcion":"LITOPEDION"
  },
  {
    "codigo":1299082006,
    "descripcion":"RUPTURA ACCIDENTAL DE DURAMADRE"
  },
  {
    "codigo":840330009,
    "descripcion":"REFLEJO SUPRARROTULIANO AUSENTE"
  },
  {
    "codigo":248671001,
    "descripcion":"DESDOBLAMIENTO FISIOLÓGICO DEL SEGUNDO RUIDO CARDÍACO"
  },
  {
    "codigo":707423001,
    "descripcion":"CARCINOMA BASALOIDE PRIMARIO DE LARINGE"
  },
  {
    "codigo":1297247005,
    "descripcion":"CIERRE DE ÁNGULO AGUDO DE AMBOS OJOS DEBIDO A NEOVASCULARIZACIÓN"
  },
  {
    "codigo":314207007,
    "descripcion":"INFARTO DE MIOCARDIO SIN ONDA Q"
  },
  {
    "codigo":281439008,
    "descripcion":"AFLOJAMIENTO DE PRÓTESIS DE ARTICULACIÓN DE HOMBRO"
  },
  {
    "codigo":1229876001,
    "descripcion":"SÍNDROME DE DEFECTOS DEL DESARROLLO CEREBRAL Y CARDÍACO LETALES"
  },
  {
    "codigo":11861601000119105,
    "descripcion":"LESIÓN DE MÚSCULO CRURAL ANTERIOR DE PIERNA IZQUIERDA"
  },
  {
    "codigo":312372003,
    "descripcion":"ACINETOPSIA CEREBRAL"
  },
  {
    "codigo":246836006,
    "descripcion":"AUSENCIA DE GLÁNDULAS DE MEIBOMIO"
  },
  {
    "codigo":115764008,
    "descripcion":"FENOTIPO D DÉBIL HEREDADO"
  },
  {
    "codigo":212233001,
    "descripcion":"LESIÓN ABIERTA DE TRONCOS PRIMARIOS Y SECUNDARIOS DE PLEXO BRAQUIAL"
  },
  {
    "codigo":50228009,
    "descripcion":"CONTUSIÓN DE LA OREJA"
  },
  {
    "codigo":1162505005,
    "descripcion":"AGRANULOCITOSIS CAUSADA POR AGENTE ANTITIROIDEO"
  },
  {
    "codigo":310537006,
    "descripcion":"ADMISIONES HOSPITALARIAS PREVIAS MÚLTIPLES"
  },
  {
    "codigo":11779681000119108,
    "descripcion":"ABRASIÓN DE PIEL DE ANTEBRAZO DERECHO"
  },
  {
    "codigo":112094001,
    "descripcion":"AUTOEXPLORACIÓN GENITAL"
  },
  {
    "codigo":210398003,
    "descripcion":"HERIDA ABIERTA EN LA NUCA"
  },
  {
    "codigo":1258974008,
    "descripcion":"SECUESTRO DE ESBOZO DE DIENTE PERMANENTE DEBIDO A TRAUMATISMO DENTAL Y POSTERIOR A ÉL"
  },
  {
    "codigo":439774009,
    "descripcion":"DOLOR A LA PALPACIÓN DE CUADRANTE INFERIOR IZQUIERDO DEL ABDOMEN"
  },
  {
    "codigo":10759881000119100,
    "descripcion":"TUBERCULOSIS EN LA MADRE QUE COMPLICA EL NACIMIENTO"
  },
  {
    "codigo":335561000119101,
    "descripcion":"CICLOTROPÍA DE OJO DERECHO"
  },
  {
    "codigo":15741641000119102,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE AMBOS ANTEBRAZOS"
  },
  {
    "codigo":11996361000119102,
    "descripcion":"NEUROMA DE MUÑÓN DE AMPUTACIÓN DE MIEMBRO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":141001000119104,
    "descripcion":"ENTEROPATÍA POR PROTEÍNAS DE LA LECHE"
  },
  {
    "codigo":673481000119103,
    "descripcion":"EXOSTOSIS DE HÚMERO"
  },
  {
    "codigo":691401000119104,
    "descripcion":"ANEMIA CONCOMITANTE CON ENFERMEDAD RENAL CRÓNICA EN ESTADIO 4 Y DEBIDA A ELLA"
  },
  {
    "codigo":11822281000119104,
    "descripcion":"LUXACIÓN NO EXPUESTA DE ARTICULACIÓN ACROMIOCLAVICULAR IZQUIERDA"
  },
  {
    "codigo":11829961000119107,
    "descripcion":"HEMATOMA DE REGIÓN DE CADERA DERECHA"
  },
  {
    "codigo":94921000119107,
    "descripcion":"TRASTORNO EPISÓDICO DEL ESTADO DE ÁNIMO"
  },
  {
    "codigo":315081000119107,
    "descripcion":"ENFERMEDAD DE PAGET DE HOMBRO"
  },
  {
    "codigo":10749641000119106,
    "descripcion":"TRASTORNO DE LA COAGULACIÓN SANGUÍNEA QUE COMPLICA EL EMBARAZO"
  },
  {
    "codigo":15708361000119109,
    "descripcion":"TROMBOSIS VENOSA PROFUNDA AGUDA DE EXTREMIDAD INFERIOR IZQUIERDA COMO EFECTO TARDÍO DE INJERTO PUENTE DE ARTERIA CORONARIA"
  },
  {
    "codigo":75656006,
    "descripcion":"LEISHMANIASIS CUTÁNEA ULCEROSA"
  },
  {
    "codigo":201000119106,
    "descripcion":"TRASTORNO DEBIDO A DIABETES MELLITUS TIPO 2 BIEN CONTROLADA"
  },
  {
    "codigo":237661003,
    "descripcion":"SECRECIÓN ECTÓPICA DE GHRH CAUSANTE DE ACROMEGALIA"
  },
  {
    "codigo":403336005,
    "descripcion":"TRICOSQUISIS"
  },
  {
    "codigo":143561000119108,
    "descripcion":"TROMBOSIS AGUDA DE VENA ESPLÉNICA"
  },
  {
    "codigo":681161000119109,
    "descripcion":"NEVO CISTOIDE DE CONJUNTIVA DE OJO IZQUIERDO"
  },
  {
    "codigo":1251634006,
    "descripcion":"RETRACCIÓN EXCESIVA DE SEGMENTO UTERINO SUPERIOR"
  },
  {
    "codigo":301362007,
    "descripcion":"DOLOR DE ESTRUCTURA DIGESTIVA"
  },
  {
    "codigo":235826007,
    "descripcion":"PSEUDO-OBSTRUCCIÓN INTESTINAL AGUDA"
  },
  {
    "codigo":168455000,
    "descripcion":"ANATOMÍA PATOLÓGICA MACROSCÓPICA"
  },
  {
    "codigo":102919003,
    "descripcion":"TEMOR A LAS INFECCIONES"
  },
  {
    "codigo":233991005,
    "descripcion":"ANEURISMA MICÓTICO"
  },
  {
    "codigo":365063006,
    "descripcion":"HALLAZGO RELACIONADO CON EL PATRÓN DE COMPONENTE DEL POTENCIAL EVOCADO VISUAL"
  },
  {
    "codigo":723676007,
    "descripcion":"SÍNDROME DE DISCAPACIDAD INTELECTUAL SEVERA, EPILEPSIA, ANOMALÍAS ANALES E HIPOPLASIA FALÁNGICA DISTAL"
  },
  {
    "codigo":363228008,
    "descripcion":"NEOPLASIA DE OÍDO"
  },
  {
    "codigo":721841001,
    "descripcion":"SÍNDROME DE HIPOGONADISMO CON PROLAPSO DE VÁLVULA MITRAL Y DISCAPACIDAD INTELECTUAL"
  },
  {
    "codigo":230321007,
    "descripcion":"DISTONÍA IDIOPÁTICA NO FAMILIAR"
  },
  {
    "codigo":263089009,
    "descripcion":"FRACTURA-LUXACIÓN DE LA ARTICULACIÓN DE LA RODILLA"
  },
  {
    "codigo":295857009,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE DOTIEPINA"
  },
  {
    "codigo":783707003,
    "descripcion":"ANEURISMA CEREBRAL DEBIDO A DISECCIÓN DE ARTERIA CEREBRAL"
  },
  {
    "codigo":128347007,
    "descripcion":"ANOMALÍA CONGÉNITA - TRACTO GASTROINTESTINAL"
  },
  {
    "codigo":95579008,
    "descripcion":"TROMBOSIS DE ARTERIA RENAL"
  },
  {
    "codigo":716336002,
    "descripcion":"TROMBOCITOPENIA AMEGACARIOCÍTICA CONGÉNITA"
  },
  {
    "codigo":126512005,
    "descripcion":"NEOPLASIA DE LA PIEL DE LA INGLE"
  },
  {
    "codigo":93744007,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":1142320008,
    "descripcion":"ATROFIA DE MÚSCULO PROXIMAL"
  },
  {
    "codigo":288517002,
    "descripcion":"ENFERMEDAD CONSUNTIVA"
  },
  {
    "codigo":124677002,
    "descripcion":"DEFICIENCIA DE FOSFOACETILGLUCOSAMINA MUTASA"
  },
  {
    "codigo":91909008,
    "descripcion":"AUSENCIA CONGÉNITA DE HUESO ESCAMOSO"
  },
  {
    "codigo":386821008,
    "descripcion":"REACCIÓN ADAPTATIVA EN EL PRIMER AÑO DE VIDA"
  },
  {
    "codigo":26373009,
    "descripcion":"HEMORROIDES EXTERNAS TROMBOSADAS"
  },
  {
    "codigo":286682001,
    "descripcion":"NEGACIÓN PSICÓTICA - MECANISMO DE DEFENSA PSICOLÓGICA"
  },
  {
    "codigo":1236954004,
    "descripcion":"METÁSTASIS DE CARCINOMA EN BORDE BERMELLÓN DE LABIO SUPERIOR"
  },
  {
    "codigo":57306005,
    "descripcion":"ESTADIO C2 DE DUKES MODIFICADO"
  },
  {
    "codigo":1204186006,
    "descripcion":"OCLUSIÓN AGUDA DE ARTERIA FEMORAL COMÚN DEBIDA A TROMBOSIS"
  },
  {
    "codigo":284847003,
    "descripcion":"INCAPAZ DE LIMPIAR SUS PRÓTESIS DENTALES"
  },
  {
    "codigo":250244003,
    "descripcion":"PICNOCITOSIS"
  },
  {
    "codigo":1003908004,
    "descripcion":"DUPLICACIÓN DE PORCIÓN PROXIMAL DEL CROMOSOMA 15"
  },
  {
    "codigo":16097481000119107,
    "descripcion":"ARTROFIBROSIS DE HOMBRO DERECHO"
  },
  {
    "codigo":409805001000119107,
    "descripcion":"ATRAPAMIENTO DE MÚSCULO OBLICUO SUPERIOR DE OJO DERECHO"
  },
  {
    "codigo":1264217005,
    "descripcion":"INFECCIÓN FETAL CAUSADA POR BACTERIA"
  },
  {
    "codigo":248409006,
    "descripcion":"PLIEGUE PALMAR TRANSVERSAL ÚNICO"
  },
  {
    "codigo":1196846002,
    "descripcion":"CISTOADENOCARCINOMA PRIMARIO DE VÍA BILIAR INTRAHEPÁTICA"
  },
  {
    "codigo":312110005,
    "descripcion":"CÁLCULOS DE VESÍCULA Y VÍAS BILIARES"
  },
  {
    "codigo":443182008,
    "descripcion":"TRASTORNO DE CÓRNEA ASOCIADO CON LENTE DE CONTACTO"
  },
  {
    "codigo":17198008,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN LA REGIÓN DEL OÍDO, CON INFECCIÓN"
  },
  {
    "codigo":211971001,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO SUPERFICIAL DE RODILLA"
  },
  {
    "codigo":1079651000119104,
    "descripcion":"NEVO MELANOCÍTICO PIGMENTADO CONGÉNITO DE PIEL DE MIEMBRO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":277507004,
    "descripcion":"ASTROCITOMA PILOCÍTICO DEL CEREBELO"
  },
  {
    "codigo":80899006,
    "descripcion":"ESOTROPÍA MONOCULAR NO CONCOMITANTE DISTINTA DEL PATRÓN EN A O V"
  },
  {
    "codigo":408579009,
    "descripcion":"META DE ACTIVIDAD FÍSICA: EJERCICIO EXTENUANTE"
  },
  {
    "codigo":767192001,
    "descripcion":"QUISTE SINOVIAL DE MUÑECA"
  },
  {
    "codigo":111832004,
    "descripcion":"TUBERCULOSIS PRIMARIA PROGRESIVA"
  },
  {
    "codigo":342371000119106,
    "descripcion":"HIPERTRICOSIS DE PÁRPADO IZQUIERDO"
  },
  {
    "codigo":898264007,
    "descripcion":"ANQUILOSIS CONGÉNITA DE ARTICULACIÓN INTERFALÁNGICA DE PULGAR"
  },
  {
    "codigo":79064007,
    "descripcion":"INFECCIÓN CAUSADA POR COTYLURUS"
  },
  {
    "codigo":208301006,
    "descripcion":"FRACTURA EXPUESTA DEL OLÉCRANON, EXTRARTICULAR"
  },
  {
    "codigo":372141009,
    "descripcion":"CARCINOMA DE CUERDA VOCAL"
  },
  {
    "codigo":403074008,
    "descripcion":"TIÑA CAUSADA POR NANNIZZIA FULVA"
  },
  {
    "codigo":204631004,
    "descripcion":"LENGUA PLEGADA CONGÉNITA"
  },
  {
    "codigo":302935008,
    "descripcion":"DISCITIS INFECCIOSA"
  },
  {
    "codigo":202796002,
    "descripcion":"NEURITIS DORSAL Y LUMBOSACRA"
  },
  {
    "codigo":366636003,
    "descripcion":"HALLAZGO EN EL ASPECTO DE LA CARA"
  },
  {
    "codigo":317631000112101,
    "descripcion":"SANGRADO VAGINAL PREPUBERAL"
  },
  {
    "codigo":301100007,
    "descripcion":"VÁLVULA AÓRTICA NORMAL"
  },
  {
    "codigo":1251372009,
    "descripcion":"DERMATITIS DE CONTACTO DE CUERO CABELLUDO"
  },
  {
    "codigo":364801001,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA DEGLUTIR LÍQUIDOS"
  },
  {
    "codigo":299265005,
    "descripcion":"AMPLITUD DE ABDUCCIÓN ACTIVA DE LA CADERA DISMINUIDA"
  },
  {
    "codigo":397569007,
    "descripcion":"CONJUNTIVITIS FOLICULAR CAUSADA POR MOLUSCO CONTAGIOSO"
  },
  {
    "codigo":788950000,
    "descripcion":"INSUFICIENCIA CARDÍACA CON FRACCIÓN DE EYECCIÓN EN EL RANGO INTERMEDIO"
  },
  {
    "codigo":362966006,
    "descripcion":"TRASTORNO DEL SISTEMA AUDITIVO"
  },
  {
    "codigo":2518007,
    "descripcion":"PRECOCIDAD SEXUAL CRIPTOGÉNICA"
  },
  {
    "codigo":231894008,
    "descripcion":"ÚLCERA DE CÓRNEA VIRAL"
  },
  {
    "codigo":197291001,
    "descripcion":"CIRROSIS PORTAL UNILOBULAR"
  },
  {
    "codigo":262827003,
    "descripcion":"CONTUSIÓN DE PÁNCREAS"
  },
  {
    "codigo":721579004,
    "descripcion":"SARCOMA SINOVIAL PRIMARIO DE PARTES BLANDAS DE EXTREMIDAD"
  },
  {
    "codigo":295595006,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE FÁRMACO INMUNOESTIMULANTE"
  },
  {
    "codigo":230059006,
    "descripcion":"FUMADOR OCASIONAL DE CIGARRILLOS"
  },
  {
    "codigo":361131008,
    "descripcion":"FENÓMENO DE RAYNAUD AISLADO PRIMARIO"
  },
  {
    "codigo":719744001,
    "descripcion":"CAPAZ DE SUBIR Y BAJAR ESCALERAS EXTERNAS"
  },
  {
    "codigo":293760009,
    "descripcion":"ALERGIA A DACTINOMICINA"
  },
  {
    "codigo":95317002,
    "descripcion":"VÍCTIMA DE TERRORISMO"
  },
  {
    "codigo":291925001,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR VITAMINA D"
  },
  {
    "codigo":717909004,
    "descripcion":"SÍNDROME DE MICROTIA BILATERAL CON SORDERA Y PALADAR HENDIDO"
  },
  {
    "codigo":29781006,
    "descripcion":"ÍNDICE CARDÍACO DISMINUIDO"
  },
  {
    "codigo":1142058003,
    "descripcion":"AMENORREA DEBIDA A FÍSTULA OBSTÉTRICA"
  },
  {
    "codigo":290090005,
    "descripcion":"PEZONES DEL MISMO TAMAÑO"
  },
  {
    "codigo":1240362006,
    "descripcion":"CARCINOMA NEUROENDOCRINO MICROCÍTICO METASTÁSICO"
  },
  {
    "codigo":91647001,
    "descripcion":"FRÉMITO DIASTÓLICO APICAL"
  },
  {
    "codigo":15745841000119104,
    "descripcion":"RIGIDEZ DE ARTICULACIONES DE AMBOS CODOS"
  },
  {
    "codigo":26111005,
    "descripcion":"MIOPATÍA METABÓLICA"
  },
  {
    "codigo":419327006,
    "descripcion":"NEOPLASIA INTRAEPITELIAL ENDOMETRIAL"
  },
  {
    "codigo":99121000119105,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE VAGINA"
  },
  {
    "codigo":417492002,
    "descripcion":"CONJUNTIVITIS ASOCIADA CON ENFERMEDAD CUTÁNEA AUTOINMUNITARIA"
  },
  {
    "codigo":286420004,
    "descripcion":"NO REALIZA ACTIVIDADES PARA ABASTECERSE"
  },
  {
    "codigo":344881000119106,
    "descripcion":"QUISTE DE ORA SERRATA DE RETINA DE AMBOS OJOS"
  },
  {
    "codigo":57044006,
    "descripcion":"QUISTE DE CONDUCTO DE GLÁNDULA DE BARTOLINO"
  },
  {
    "codigo":415657000,
    "descripcion":"SÍNDROME DE FIBROSIS SUBRETINIANA Y UVEÍTIS"
  },
  {
    "codigo":253652009,
    "descripcion":"AORTA DESCENDENTE DERECHA"
  },
  {
    "codigo":284585007,
    "descripcion":"ASTILLA DE MADERA EN LA CARA"
  },
  {
    "codigo":315518004,
    "descripcion":"NACIDO EN SIERRA LEONA"
  },
  {
    "codigo":86142006,
    "descripcion":"PENFIGOIDE"
  },
  {
    "codigo":444755001,
    "descripcion":"TRASTORNO DEL METABOLISMO DE LA ISOLEUCINA"
  },
  {
    "codigo":117075002,
    "descripcion":"UNIDAD DE HEMODERIVADO ENTREGADA, NO TRANSFUNDIDA"
  },
  {
    "codigo":1263955004,
    "descripcion":"INSUFICIENCIA RENAL AGUDA POSTERIOR A EMBARAZO ECTÓPICO"
  },
  {
    "codigo":311848001,
    "descripcion":"FRACTURAS EXPUESTAS QUE COMPROMETEN CABEZA Y CUELLO"
  },
  {
    "codigo":770600002,
    "descripcion":"VENAS DE LA RETINA DEL OJO IZQUIERDO EN CUENTAS DE ROSARIO DEBIDAS A DIABETES MELLITUS"
  },
  {
    "codigo":705064001,
    "descripcion":"ATENDIDO EN CONSULTORIO ESPECIALIZADO EN DREPANOCITEMIA Y TALASEMIA"
  },
  {
    "codigo":1293053000,
    "descripcion":"RETROVERSIÓN CONGÉNITA DE FÉMUR"
  },
  {
    "codigo":703229001,
    "descripcion":"PROTEUS MIRABILIS O PROTEUS PENNERI"
  },
  {
    "codigo":773555005,
    "descripcion":"SÍNDROME NEURODEGENERATIVO SEVERO CON LIPODISTROFIA"
  },
  {
    "codigo":211709009,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO PROFUNDA DE FRENTE"
  },
  {
    "codigo":766930002,
    "descripcion":"CARCINOMA DE CÉLULAS VIDRIOSAS DEL CUELLO UTERINO"
  },
  {
    "codigo":111570005,
    "descripcion":"ANEMIA POR INFECCIÓN"
  },
  {
    "codigo":13266007,
    "descripcion":"SINUSITIS ESFENOIDAL"
  },
  {
    "codigo":404647000,
    "descripcion":"CATARATA INDUCIDA POR CORTICOSTEROIDES"
  },
  {
    "codigo":44199000,
    "descripcion":"PENETRACIÓN DE GLOBO OCULAR POR CUERPO EXTRAÑO NO MAGNÉTICO"
  },
  {
    "codigo":275410008,
    "descripcion":"DIVERTÍCULO INFECTADO DE VEJIGA URINARIA"
  },
  {
    "codigo":109735001,
    "descripcion":"FRACASO DE RESTAURACIÓN DENTAL QUE AFECTA LA INTEGRIDAD DENTAL MARGINAL"
  },
  {
    "codigo":765095002,
    "descripcion":"CARCINOMA DE LA MÉDULA RENAL"
  },
  {
    "codigo":271740000,
    "descripcion":"DETRITOS EN EL CONDUCTO AUDITIVO"
  },
  {
    "codigo":238972008,
    "descripcion":"PSICOSIS DELIRANTE MONOSINTOMÁTICA CUTÁNEA"
  },
  {
    "codigo":206204009,
    "descripcion":"CONTUSIÓN DE CUERO CABELLUDO POR TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":1285713005,
    "descripcion":"GLAUCOMA DE ÁNGULO ABIERTO DE AMBOS OJOS CAUSADO POR FÁRMACO"
  },
  {
    "codigo":300838000,
    "descripcion":"NO REALIZA ACTIVIDADES DE MANTENIMIENTO DEL AUTO"
  },
  {
    "codigo":73297009,
    "descripcion":"DISTROFIA MUSCULAR"
  },
  {
    "codigo":237137009,
    "descripcion":"FALLA OVÁRICA INCIPIENTE"
  },
  {
    "codigo":38694004,
    "descripcion":"TRASTORNO DEPRESIVO MAYOR RECURRENTE CON SÍNTOMAS ATÍPICOS"
  },
  {
    "codigo":36859004,
    "descripcion":"DOLOR TORÁCICO DE ORIGEN ESOFÁGICO"
  },
  {
    "codigo":266235007,
    "descripcion":"PERICARDITIS IDIOPÁTICA AGUDA"
  },
  {
    "codigo":200699009,
    "descripcion":"LINFADENITIS AGUDA DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":67792002,
    "descripcion":"FÍSTULA BRONCOESOFÁGICA ADQUIRIDA"
  },
  {
    "codigo":723152003,
    "descripcion":"ESTADO MÍNIMAMENTE CONSCIENTE PLUS"
  },
  {
    "codigo":2256007,
    "descripcion":"GEMELOS MONOCIGÓTICOS"
  },
  {
    "codigo":428240008,
    "descripcion":"DISTENSIÓN DE CUERDA VOCAL"
  },
  {
    "codigo":262565001,
    "descripcion":"HERIDA PROFUNDA POR AVULSIÓN"
  },
  {
    "codigo":459173004,
    "descripcion":"ENDARTERITIS INFECCIOSA EN LOCALIZACIÓN DE VENTANA AORTOPULMONAR"
  },
  {
    "codigo":721317005,
    "descripcion":"FRACTURA DE PORCIÓN ESCAMOSA DE HUESO TEMPORAL DEL CRÁNEO"
  },
  {
    "codigo":31354001,
    "descripcion":"ENDOCERVICITIS"
  },
  {
    "codigo":162426002,
    "descripcion":"SÍNTOMA: PARED ABDOMINAL"
  },
  {
    "codigo":293498008,
    "descripcion":"REACCIÓN ADVERSA A LA DEBRISOQUINA"
  },
  {
    "codigo":1145466009,
    "descripcion":"APLASIA DE RADIO"
  },
  {
    "codigo":95055002,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA PIEL DEL TÓRAX"
  },
  {
    "codigo":226127001,
    "descripcion":"DIETA CON BAJO CONTENIDO DE GLUCOSA"
  },
  {
    "codigo":27684000,
    "descripcion":"PERIOSTITIS GOMOSA EN LA FRAMBESIA"
  },
  {
    "codigo":160591008,
    "descripcion":"BEBEDOR DE VINO"
  },
  {
    "codigo":783183009,
    "descripcion":"CARCINOMA DE ESÓFAGO TIPO GLÁNDULA SALIVAL"
  },
  {
    "codigo":289828004,
    "descripcion":"SUTURA DE CERCLAJE CERVICAL, AUSENTE"
  },
  {
    "codigo":420900006,
    "descripcion":"FATIGA ASOCIADA CON SIDA (SÍNDROME DE INMUNODEFICIENCIA ADQUIRIDA)"
  },
  {
    "codigo":93220006,
    "descripcion":"MELANOMA MALIGNO DE LA PIEL DE LA OREJA"
  },
  {
    "codigo":224292009,
    "descripcion":"SUSPENDIDO EN LA ESCUELA"
  },
  {
    "codigo":419065006,
    "descripcion":"POSPÚBER"
  },
  {
    "codigo":255225007,
    "descripcion":"HIPERPLASIA DE PAPILA FILIFORME"
  },
  {
    "codigo":124153007,
    "descripcion":"DEFICIENCIA DE URACILO DESHIDROGENASA"
  },
  {
    "codigo":187854004,
    "descripcion":"NEOPLASIA MALIGNA DE LA MUCOSA TRAQUEAL"
  },
  {
    "codigo":130611000119103,
    "descripcion":"MUTILACIÓN GENITAL FEMENINA TIPO 3"
  },
  {
    "codigo":89550007,
    "descripcion":"POSICIÓN SACROILÍACA DERECHA TRANSVERSA"
  },
  {
    "codigo":286158007,
    "descripcion":"DIFICULTAD PARA LIMPIAR LA DUCHA"
  },
  {
    "codigo":253390008,
    "descripcion":"ANOMALÍA DE MÚSCULO PAPILAR DE VÁLVULA TRICÚSPIDE"
  },
  {
    "codigo":448163002,
    "descripcion":"VENA BRAQUIOCEFÁLICA PRESENTE"
  },
  {
    "codigo":1300131002,
    "descripcion":"TRASTORNO DEL NEURODESARROLLO GRAVE, ESTEREOTIPIAS MOTORAS, ESTREÑIMIENTO CRÓNICO, ALTERACIÓN DEL CICLO SUEÑO VIGILIA ASOCIADO AL GEN NRXN1 (NEUREXINA 1)"
  },
  {
    "codigo":157861000146108,
    "descripcion":"PASA TIEMPO FRENTE A UNA PANTALLA ANTES DE IR A DORMIR"
  },
  {
    "codigo":251555007,
    "descripcion":"LATENCIA DE ONDA F AUMENTADA"
  },
  {
    "codigo":85880000,
    "descripcion":"SEUDOHIPOALDOSTERONISMO, TIPO 1, FORMA DOMINANTE"
  },
  {
    "codigo":87715008,
    "descripcion":"XEROSTOMÍA"
  },
  {
    "codigo":249720003,
    "descripcion":"MOVIMIENTO REDUCE LA DEFORMIDAD DE LA COLUMNA VERTEBRAL"
  },
  {
    "codigo":315256004,
    "descripcion":"LESIÓN CUTÁNEA PIGMENTADA PRURIGINOSA"
  },
  {
    "codigo":1003384005,
    "descripcion":"DEFECTOS CONGÉNITOS MÚLTIPLES DE SEGMENTACIÓN VERTEBRAL"
  },
  {
    "codigo":282488006,
    "descripcion":"INCAPAZ DE CORRER PENDIENTE ARRIBA"
  },
  {
    "codigo":446328009,
    "descripcion":"INFECCIÓN INTESTINAL CAUSADA POR ESCHERICHIA COLI O157:H7"
  },
  {
    "codigo":1263693006,
    "descripcion":"TRASTORNO NEONATAL PRECOZ DEBIDO A EMBARAZO MÚLTIPLE"
  },
  {
    "codigo":51277007,
    "descripcion":"ESTAÑOSIS"
  },
  {
    "codigo":49442000,
    "descripcion":"FRAMBESIA, LESIÓN INICIAL"
  },
  {
    "codigo":247885006,
    "descripcion":"PENSAMIENTOS OBSESIVOS ACERCA DE TIRAR LAS COSAS"
  },
  {
    "codigo":213282006,
    "descripcion":"CUERPO EXTRAÑO DEJADO EN HERIDA"
  },
  {
    "codigo":735735001,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA NEUROENDOCRINA DE PÁNCREAS"
  },
  {
    "codigo":80375002,
    "descripcion":"ESTENOSIS URETRAL SECUNDARIA A INFECCIÓN"
  },
  {
    "codigo":309751007,
    "descripcion":"HERNIA DE HIATO IRREDUCIBLE"
  },
  {
    "codigo":677581000119105,
    "descripcion":"DESGARRO EN HERRADURA DE RETINA DE OJO DERECHO SIN DESPRENDIMIENTO"
  },
  {
    "codigo":209612008,
    "descripcion":"DESGARRO COMPLETO DE LIGAMENTO DE DEDO DE LA MANO"
  },
  {
    "codigo":104141000119107,
    "descripcion":"GANGLIÓN DE CARA PALMAR DE MUÑECA"
  },
  {
    "codigo":109473003,
    "descripcion":"AMELOGÉNESIS IMPERFECTA, TIPO HIPOPLÁSICA CON MICRODONCIA"
  },
  {
    "codigo":699297004,
    "descripcion":"SÍNDROME DE BLEFAROFIMOSIS-RETARDO MENTAL, TIPO MAAT-KIEVIT-BRUNNER"
  },
  {
    "codigo":240545008,
    "descripcion":"NEOPLASIA INTRAEPITELIAL POR PAPILOMAVIRUS ANOGENITAL"
  },
  {
    "codigo":369782002,
    "descripcion":"PLEOMORFISMO NUCLEAR DE CARCINOMA DUCTAL IN SITU, GRADO 2: NO PRESENTA GRADO NUCLEAR 1 NI GRADO NUCLEAR 3"
  },
  {
    "codigo":10835661000119109,
    "descripcion":"DUPLICACIÓN DE ÚTERO CON DUPLICACIÓN DE CUELLO UTERINO Y VAGINA CON OBSTRUCCIÓN"
  },
  {
    "codigo":402550006,
    "descripcion":"NEVOS DE SPITZ EN RACIMOS MÚLTIPLES"
  },
  {
    "codigo":1187147003,
    "descripcion":"AMILOIDOSIS CARDÍACA NO NEUROPÁTICA FAMILIAR"
  },
  {
    "codigo":73035005,
    "descripcion":"SÍNDROME DE TRISOMÍA PARCIAL 10Q"
  },
  {
    "codigo":267808001,
    "descripcion":"TRASTORNO DE CRECIMIENTO DEL PELO"
  },
  {
    "codigo":890400001,
    "descripcion":"AGENESIA MAMARIA BILATERAL"
  },
  {
    "codigo":5664002,
    "descripcion":"DESEO SEXUAL HIPOACTIVO SITUACIONAL"
  },
  {
    "codigo":202272006,
    "descripcion":"CONTRACTURA EN EXTENSIÓN - CODO"
  },
  {
    "codigo":235040007,
    "descripcion":"INCONTINENCIA PIGMENTARIA BUCAL"
  },
  {
    "codigo":71200009,
    "descripcion":"TEMPERATURA CUTÁNEA DISMINUIDA"
  },
  {
    "codigo":36597008,
    "descripcion":"DISOCIACIÓN MOLECULAR"
  },
  {
    "codigo":296906000,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE ESTRÓGENO"
  },
  {
    "codigo":722890004,
    "descripcion":"CARDIOPATÍA CONCOMITANTE CON ENFERMEDAD DE CHAGAS CRÓNICA Y DEBIDA A ELLA"
  },
  {
    "codigo":295071000,
    "descripcion":"ALERGIA A MINOXIDIL"
  },
  {
    "codigo":1343647001,
    "descripcion":"RETINITIS DISEMINADA DE POLO POSTERIOR"
  },
  {
    "codigo":196767003,
    "descripcion":"FÍSTULA GÁSTRICA EXTERNA"
  },
  {
    "codigo":721055005,
    "descripcion":"SÍNDROME VESTIBULAR AGUDO"
  },
  {
    "codigo":293236006,
    "descripcion":"REACCIÓN ADVERSA A LA MESTEROLONA"
  },
  {
    "codigo":162164007,
    "descripcion":"SÍNTOMA DE SECRECIÓN DEL PEZÓN"
  },
  {
    "codigo":1145204007,
    "descripcion":"EROSIÓN DE VAGINA CAUSADA POR MALLA"
  },
  {
    "codigo":29257000,
    "descripcion":"SÍNDROME DE MONOSOMÍA PARCIAL 13Q"
  },
  {
    "codigo":1208905000,
    "descripcion":"LINFEDEMA DE CARA DEBIDO A ROSÁCEA"
  },
  {
    "codigo":62025007,
    "descripcion":"QUEMADURA DEL CUELLO DEL ÚTERO"
  },
  {
    "codigo":60190000,
    "descripcion":"LESIÓN TRAUMÁTICA DE VASOS SANGUÍNEOS DEL TÓRAX"
  },
  {
    "codigo":94793009,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA MEJILLA"
  },
  {
    "codigo":92958005,
    "descripcion":"FORMA ANORMAL CONGÉNITA DEL VÓMER"
  },
  {
    "codigo":289566007,
    "descripcion":"SECRECIONES VAGINALES NORMALES"
  },
  {
    "codigo":846622008,
    "descripcion":"MIOPÍA DEGENERATIVA DE OJO DERECHO"
  },
  {
    "codigo":123891000,
    "descripcion":"INTOXICACIÓN POR SOLANACEAE"
  },
  {
    "codigo":254963000,
    "descripcion":"MICROADENOMA HIPOFISARIO"
  },
  {
    "codigo":287731003,
    "descripcion":"ISQUEMIA CEREBRAL"
  },
  {
    "codigo":285896000,
    "descripcion":"NO UTILIZA UTENSILIOS DE COCINA"
  },
  {
    "codigo":418803009,
    "descripcion":"REFLEJO SUPRARROTULIANO DISMINUIDO"
  },
  {
    "codigo":253128003,
    "descripcion":"ANOMALÍA DE LA NEUROGÉNESIS"
  },
  {
    "codigo":449736004,
    "descripcion":"HALLAZGO RELACIONADO CON PIEL PERILESIONAL"
  },
  {
    "codigo":447901004,
    "descripcion":"VENTANA AORTOPULMONAR CON CONEXIÓN TUBULAR"
  },
  {
    "codigo":54685005,
    "descripcion":"SINCINESIA"
  },
  {
    "codigo":249458000,
    "descripcion":"ABSCESO SUPRAGLÓTICO"
  },
  {
    "codigo":413298002,
    "descripcion":"DISCAPACIDAD QUE AFECTA LA VIDA COTIDIANA"
  },
  {
    "codigo":85618003,
    "descripcion":"INTOXICACIÓN POR METISAZONA"
  },
  {
    "codigo":282226005,
    "descripcion":"DIFICULTAD PARA CAMINAR SOBRE UNA LÍNEA ANGOSTA"
  },
  {
    "codigo":313159001,
    "descripcion":"EXOTROPÍA PARA LA VISIÓN CERCANA"
  },
  {
    "codigo":247623004,
    "descripcion":"IDEAS EXCITANTES"
  },
  {
    "codigo":444231005,
    "descripcion":"TIMOMA"
  },
  {
    "codigo":278556001,
    "descripcion":"RESINA DENTAL COMPUESTA: PRESENTE"
  },
  {
    "codigo":16412007,
    "descripcion":"CAMBIO PATOLÓGICO DE LA VOZ"
  },
  {
    "codigo":737308008,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE GLÁNDULA SUBLINGUAL"
  },
  {
    "codigo":213020009,
    "descripcion":"ALERGIA A PROTEÍNA DEL HUEVO"
  },
  {
    "codigo":735473003,
    "descripcion":"DESVIACIÓN DE URÉTER SIN OBSTRUCCIÓN"
  },
  {
    "codigo":1259761004,
    "descripcion":"CÁNCER PULMONAR DE CÉLULAS NO MICROCÍTICAS PRIMARIO SIN MUTACIÓN EN RECEPTOR DE FACTOR DE CRECIMIENTO EPIDÉRMICO"
  },
  {
    "codigo":80113008,
    "descripcion":"COMPLICACIÓN DEL PUERPERIO"
  },
  {
    "codigo":47345008,
    "descripcion":"ADHERENCIA DE VAGINA POSTERIOR A RADIOTERAPIA"
  },
  {
    "codigo":405958002,
    "descripcion":"EQUIPO INTERGRUPAL PARA EL ESTUDIO (POSQUIRÚRGICO) DE RABDOMIOSARCOMA IB: TUMOR LOCALIZADO QUE EXCEDE EL SITIO DE ORIGEN, TOTALMENTE RESECADO"
  },
  {
    "codigo":1290694005,
    "descripcion":"LESIÓN TRAUMÁTICA DE PULMÓN DURANTE PROCEDIMIENTO QUIRÚRGICO"
  },
  {
    "codigo":733638006,
    "descripcion":"EPIDERMÓLISIS BULLOSA DISTRÓFICA ACRA"
  },
  {
    "codigo":209350006,
    "descripcion":"FRACTURA-LUXACIÓN EXPUESTA DE ARTICULACIÓN DE TOBILLO"
  },
  {
    "codigo":895643001,
    "descripcion":"FORMA TRIANGULAR ANORMAL CONGÉNITA DE FALANGE PROXIMAL DE SEGUNDO DEDO DE PIE"
  },
  {
    "codigo":699035003,
    "descripcion":"CON BAJO RIESGO DE TROMBOEMBOLIA VENOSA"
  },
  {
    "codigo":305819007,
    "descripcion":"ATENDIDO POR SERVICIO DE GERIATRÍA"
  },
  {
    "codigo":404123008,
    "descripcion":"INFILTRACIÓN LEUCÉMICA DE LA PIEL (LEUCEMIA PROLINFOCÍTICA DE CÉLULAS T)"
  },
  {
    "codigo":369520005,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA TROMPA DE FALOPIO DERECHA"
  },
  {
    "codigo":238448008,
    "descripcion":"ESTREPTOCERCIASIS"
  },
  {
    "codigo":402288009,
    "descripcion":"QUEILITIS IRRITATIVA POR CONTACTO"
  },
  {
    "codigo":236613001,
    "descripcion":"FÍSTULA URETÉRICA HACIA LA URETRA"
  },
  {
    "codigo":15673961000119101,
    "descripcion":"MIOSITIS INFECCIOSA BILATERAL DE ANTEBRAZOS"
  },
  {
    "codigo":105541001,
    "descripcion":"NO FUMADOR POR RAZONES DE SALUD"
  },
  {
    "codigo":1186885007,
    "descripcion":"SÍNDROME DE CUSHING DEBIDO A HIPERPLASIA SUPRARRENAL BILATERAL"
  },
  {
    "codigo":202010000,
    "descripcion":"ARTROPATÍA TRANSITORIA DE LA RODILLA"
  },
  {
    "codigo":1119514001,
    "descripcion":"AGOTAMIENTO MUSCULAR FATIGABLE DE MÚSCULO DE ANTEBRAZO"
  },
  {
    "codigo":11823721000119102,
    "descripcion":"HERIDA DE BRAZO DERECHO DEBIDA A PICADURA DE INSECTO NO VENENOSO"
  },
  {
    "codigo":639766991000119109,
    "descripcion":"DESGARRO PARCIAL DE MANGUITO ROTADOR IZQUIERDO"
  },
  {
    "codigo":300314007,
    "descripcion":"ANO PRESENTE"
  },
  {
    "codigo":167407002,
    "descripcion":"NIVEL DE NORADRENALINA EN ORINA FUERA DE RANGO DE REFERENCIA"
  },
  {
    "codigo":724463002,
    "descripcion":"TRASTORNO DEBIDO A INSEMINACIÓN ARTIFICIAL"
  },
  {
    "codigo":722628000,
    "descripcion":"HEMORRAGIA TRAUMÁTICA DE ESPACIO SUBDURAL DE REGIÓN INFRATENTORIAL"
  },
  {
    "codigo":298479009,
    "descripcion":"CREPITACIÓN DE LA COLUMNA CERVICAL"
  },
  {
    "codigo":1279684002,
    "descripcion":"LUXACIÓN DE ARTICULACIÓN DE PULGAR"
  },
  {
    "codigo":788164004,
    "descripcion":"ALERGIA A INSULINA PORCINA"
  },
  {
    "codigo":296644007,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE ÁCIDO FUSÍDICO"
  },
  {
    "codigo":1148612009,
    "descripcion":"AMPLITUD DE ONDA A DE ELECTRORRETINOGRAMA DE DESTELLO BRILLANTE CON ADAPTACIÓN A OSCURIDAD REDUCIDA"
  },
  {
    "codigo":130969003,
    "descripcion":"CONDUCTA SALUDABLE"
  },
  {
    "codigo":32665003,
    "descripcion":"HERNIA ESCROTAL"
  },
  {
    "codigo":425881006,
    "descripcion":"ALTERACIÓN DEL SUEÑO POR LÍMITES MAL ESTABLECIDOS"
  },
  {
    "codigo":294809006,
    "descripcion":"ALERGIA A TERLIPRESINA"
  },
  {
    "codigo":1144942002,
    "descripcion":"TRASTORNO NEUROPSIQUIÁTRICO DEBIDO A LUPUS ERITEMATOSO SISTÉMICO"
  },
  {
    "codigo":292974003,
    "descripcion":"REACCIÓN ADVERSA A LA TALAMPICILINA"
  },
  {
    "codigo":129134004,
    "descripcion":"TRASTORNO INFLAMATORIO DE LAS VÍAS RESPIRATORIAS SUPERIORES"
  },
  {
    "codigo":291139000,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR TETRABENAZINA"
  },
  {
    "codigo":225603005,
    "descripcion":"LACTANCIA NO ESTABLECIDA"
  },
  {
    "codigo":94531007,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL ESCROTO"
  },
  {
    "codigo":127299008,
    "descripcion":"LESIÓN TRAUMÁTICA CEREBRAL CON PÉRDIDA BREVE DE LA CONSCIENCIA"
  },
  {
    "codigo":27160009,
    "descripcion":"LESIÓN TRAUMÁTICA HABITUAL POR FRICCIÓN DE DIENTE"
  },
  {
    "codigo":1336045001,
    "descripcion":"EPISODIO DE USO NOCIVO DE CATHA EDULIS"
  },
  {
    "codigo":713453003,
    "descripcion":"DISFUNCIÓN RENAL CAUSADA POR POLIOMAVIRUS"
  },
  {
    "codigo":92696009,
    "descripcion":"CARCINOMA IN SITU DEL RECTO"
  },
  {
    "codigo":418541005,
    "descripcion":"DEPÓSITO EPITELIAL CORNEAL DE ORIGEN MEDICAMENTOSO"
  },
  {
    "codigo":254701007,
    "descripcion":"CARCINOMA DE CÉLULAS BASALES DE PIEL"
  },
  {
    "codigo":416706004,
    "descripcion":"CONJUNTIVITIS POR LIQUEN PLANO"
  },
  {
    "codigo":11852701000119103,
    "descripcion":"LESIÓN TRAUMÁTICA DE DEDO DE PIE DERECHO"
  },
  {
    "codigo":283799003,
    "descripcion":"MORDEDURA DE ANIMAL EN LA BOCA"
  },
  {
    "codigo":87191008,
    "descripcion":"TORSIÓN DISMINUIDA"
  },
  {
    "codigo":251031008,
    "descripcion":"STENT CORONARIO OCLUIDO"
  },
  {
    "codigo":773484003,
    "descripcion":"ALERGIA A TRICLOFÓS"
  },
  {
    "codigo":52588004,
    "descripcion":"SIGNO DE ROBERT"
  },
  {
    "codigo":249196008,
    "descripcion":"DISTRÉS PROVOCADO POR EL DOLOR DEL TRABAJO DE PARTO"
  },
  {
    "codigo":17985000,
    "descripcion":"REACCIÓN A UNA TRANSFUSIÓN, CAUSADA POR ERROR ADMINISTRATIVO"
  },
  {
    "codigo":301981000119107,
    "descripcion":"CAPSULITIS ADHESIVA DE REGIÓN DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":280129003,
    "descripcion":"TRASTORNO DE PARTES BLANDAS DE LA CAVIDAD TORÁCICA"
  },
  {
    "codigo":116289008,
    "descripcion":"HINCHAZÓN ABDOMINAL"
  },
  {
    "codigo":247361008,
    "descripcion":"CÓLICO NOCTURNO"
  },
  {
    "codigo":212758005,
    "descripcion":"INTOXICACIÓN CON ADIFENINA"
  },
  {
    "codigo":442134007,
    "descripcion":"HEPATITIS B ASOCIADA CON INFECCIÓN POR VIRUS DE INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":440299000,
    "descripcion":"MASA DE ESTRUCTURA TORÁCICA"
  },
  {
    "codigo":16150008,
    "descripcion":"CICATRIZ CORIORRETINIANA POSTRAUMÁTICA"
  },
  {
    "codigo":702443003,
    "descripcion":"SÍNDROME AURICULOCONDILAR"
  },
  {
    "codigo":1259499007,
    "descripcion":"DEMENCIA DEBIDA A INFARTO CEREBRAL HEMORRÁGICO DEBIDO A HIPERTENSIÓN"
  },
  {
    "codigo":15922231000119106,
    "descripcion":"RUPTURA TRAUMÁTICA DE TENDÓN DE BÍCEPS FEMORAL IZQUIERDO"
  },
  {
    "codigo":241856006,
    "descripcion":"EFECTO TÓXICO CAUSADO POR LÍQUIDO PARA LIMPIEZA EN SECO"
  },
  {
    "codigo":307392007,
    "descripcion":"HEMATOMA DE AXILA"
  },
  {
    "codigo":45248009,
    "descripcion":"VIRILIZACIÓN ISOSEXUAL"
  },
  {
    "codigo":240021001,
    "descripcion":"SÍNDROME DE PELLIZCAMIENTO DE TOBILLO"
  },
  {
    "codigo":698773003,
    "descripcion":"DEFORMIDAD DE HUESO EN MATRAZ DE ERLENMEYER"
  },
  {
    "codigo":733376009,
    "descripcion":"MORDEDURA ABIERTA EN REGIÓN INFERIOR DEL DORSO"
  },
  {
    "codigo":76181002,
    "descripcion":"ÚLCERA GÁSTRICA CRÓNICA CON HEMORRAGIA Y PERFORACIÓN"
  },
  {
    "codigo":403861003,
    "descripcion":"ACROCORDONES MÚLTIPLES DE LA INGLE"
  },
  {
    "codigo":305557004,
    "descripcion":"BAJO ATENCIÓN DE ENFERMERA ESPECIALIZADA EN CUIDADOS MAMARIOS"
  },
  {
    "codigo":860778003,
    "descripcion":"ALERGIA A DIAMIDINA"
  },
  {
    "codigo":685111000119109,
    "descripcion":"HEMOGLOBINA E BETA 0 TALASEMIA"
  },
  {
    "codigo":205418005,
    "descripcion":"SÍNDROME DE GOLDENHAR"
  },
  {
    "codigo":367423000,
    "descripcion":"CONTUSIÓN DE OJO"
  },
  {
    "codigo":1155690008,
    "descripcion":"ETAPA DE PRECONTEMPLACIÓN PARA LA DISPOSICIÓN A MODIFICAR LA CONDUCTA NUTRICIONAL"
  },
  {
    "codigo":762474009,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO PROFUNDA DE TRONCO"
  },
  {
    "codigo":1186623000,
    "descripcion":"AMBIENTE COMPLEJO"
  },
  {
    "codigo":301887005,
    "descripcion":"NECESIDAD DE ASISTENCIA DOMICILIARIA"
  },
  {
    "codigo":269119005,
    "descripcion":"LUXACIÓN NO EXPUESTA ENTRE LA CUARTA Y QUINTA VÉRTEBRAS CERVICALES"
  },
  {
    "codigo":203583008,
    "descripcion":"PRIMER RAYO CON FLEXIÓN PLANTAR ADQUIRIDO"
  },
  {
    "codigo":735624002,
    "descripcion":"ALBUMINURIA DE GRADO A3"
  },
  {
    "codigo":267284008,
    "descripcion":"EMBOLIA PULMONAR OBSTÉTRICA PIÉMICA Y SÉPTICA"
  },
  {
    "codigo":365588008,
    "descripcion":"TÍTULO DE ANTICUERPOS ANTIRRUBEÓLICOS - HALLAZGO"
  },
  {
    "codigo":298217004,
    "descripcion":"LAXITUD DE ARTICULACIÓN DE TOBILLO"
  },
  {
    "codigo":396521004,
    "descripcion":"MARGEN QUIRÚRGICO LATERAL NO COMPROMETIDO POR CARCINOMA IN SITU"
  },
  {
    "codigo":3305006,
    "descripcion":"TRASTORNO DE VASO LINFÁTICO"
  },
  {
    "codigo":394686003,
    "descripcion":"RIESGO MODERADO DE SUICIDIO"
  },
  {
    "codigo":427454004,
    "descripcion":"CUIDADO POR VECINOS"
  },
  {
    "codigo":786067000,
    "descripcion":"EMBARAZO ECTÓPICO INTRAMURAL DE MIOMETRIO"
  },
  {
    "codigo":296382009,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE SALBUTAMOL"
  },
  {
    "codigo":1179283004,
    "descripcion":"SÍNDROME DE CRESTA METÓPICA, PTOSIS, DISMORFIA FACIAL"
  },
  {
    "codigo":41481000087100,
    "descripcion":"HEMATOMA DE EXTREMIDAD INFERIOR DERECHA"
  },
  {
    "codigo":44041000087102,
    "descripcion":"HERIDA CORTANTE DE PIEL DE OÍDO IZQUIERDO"
  },
  {
    "codigo":46601000087103,
    "descripcion":"ESGUINCE DE LIGAMENTO DE ARTICULACIÓN TIBIOPERONEA PROXIMAL IZQUIERDA"
  },
  {
    "codigo":292712000,
    "descripcion":"REACCIÓN ADVERSA A LA DINOPROSTONA"
  },
  {
    "codigo":294547007,
    "descripcion":"ALERGIA A CEFTIZOXIMA"
  },
  {
    "codigo":128872002,
    "descripcion":"MONONUCLEOSIS INFECCIOSA MORTAL"
  },
  {
    "codigo":1144680003,
    "descripcion":"APLASIA DE FALANGE MEDIA DE PIE"
  },
  {
    "codigo":817000004,
    "descripcion":"USO DE CALZADO ADECUADO"
  },
  {
    "codigo":38921000087103,
    "descripcion":"ABRASIÓN DE PIEL DE REGIÓN PERIORBITARIA DE OJO IZQUIERDO"
  },
  {
    "codigo":11828741000119100,
    "descripcion":"AMPOLLA TRAUMÁTICA DE CADERA IZQUIERDA"
  },
  {
    "codigo":229011009,
    "descripcion":"ACTIVIDAD SEXUAL CON PENETRACIÓN"
  },
  {
    "codigo":161640005,
    "descripcion":"ALTO RIESGO DE ENFERMEDAD CARDÍACA"
  },
  {
    "codigo":127037003,
    "descripcion":"METAHEMOGLOBINEMIA TÓXICA CON CIANOSIS"
  },
  {
    "codigo":782397004,
    "descripcion":"NÓDULO DEL TEJIDO CELULAR SUBCUTÁNEO DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":290877004,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR MOCLOBEMIDA"
  },
  {
    "codigo":94269003,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE HUESO CUBOIDES"
  },
  {
    "codigo":92434001,
    "descripcion":"NEOPLASIA BENIGNA DE MUSLO"
  },
  {
    "codigo":289042008,
    "descripcion":"CAPAZ DE UTILIZAR CUBIERTOS PARA ALIMENTARSE"
  },
  {
    "codigo":715026009,
    "descripcion":"NO CAMINA POR UN CORREDOR"
  },
  {
    "codigo":418279001,
    "descripcion":"DEFICIENCIA DE NIACINA"
  },
  {
    "codigo":1237479000,
    "descripcion":"METÁSTASIS DE CARCINOMA EN CONDUCTO ANAL"
  },
  {
    "codigo":385511004,
    "descripcion":"QUEMADURA POR FRÍO - NITRÓGENO LÍQUIDO"
  },
  {
    "codigo":713191009,
    "descripcion":"POLIHIDRAMNIOS DEBIDO A ANOMALÍA PLACENTARIA"
  },
  {
    "codigo":187068005,
    "descripcion":"BLASTOMICOSIS HEPÁTICA"
  },
  {
    "codigo":55996006,
    "descripcion":"TRASTORNO DE LA APÓFISIS MASTOIDEA"
  },
  {
    "codigo":1268412007,
    "descripcion":"RUPTURA DE FASCIA PLANTAR"
  },
  {
    "codigo":283537000,
    "descripcion":"HERIDA PUNZANTE DE LA ESPINILLA"
  },
  {
    "codigo":185233003,
    "descripcion":"ATENDIDO EN UN CONSULTORIO DE EVALUACIÓN GERIÁTRICA"
  },
  {
    "codigo":447377007,
    "descripcion":"CUERPO EXTRAÑO EN HUESO DE LA MANDÍBULA"
  },
  {
    "codigo":609382000,
    "descripcion":"HEMORRAGIA SUBDURAL INTRACRANEAL NO TRAUMÁTICA CRÓNICA"
  },
  {
    "codigo":1363046001,
    "descripcion":"CONTACTO IRIDOTRABECULAR DE MÁS DE 180 GRADOS"
  },
  {
    "codigo":707686002,
    "descripcion":"CARCINOMA PRIMARIO DE CÉLULAS ESCAMOSAS DE PARED POSTERIOR DE HIPOFARINGE"
  },
  {
    "codigo":248934001,
    "descripcion":"DESGARROS LATERALES CURADOS DEL CUELLO UTERINO"
  },
  {
    "codigo":281702006,
    "descripcion":"ADAMANTINOMA TIBIAL"
  },
  {
    "codigo":445542007,
    "descripcion":"RASGO DE HEMOGLOBINA O ARAB"
  },
  {
    "codigo":17723000,
    "descripcion":"INFECCIÓN CAUSADA POR NAEGLERIA"
  },
  {
    "codigo":192136006,
    "descripcion":"TRASTORNO DE LA LECTURA ESPECÍFICO"
  },
  {
    "codigo":247099009,
    "descripcion":"NEOVASCULARIZACIÓN DE LA PAPILA ÓPTICA"
  },
  {
    "codigo":441872001,
    "descripcion":"CICATRIZACIÓN RENAL"
  },
  {
    "codigo":704016003,
    "descripcion":"FRACTURA EXPUESTA DE CUELLO DE TERCER METACARPIANO"
  },
  {
    "codigo":310800007,
    "descripcion":"BRAQUIFALANGIA DE DEDO DE PIE"
  },
  {
    "codigo":1259237005,
    "descripcion":"NEOPLASIA MALIGNA RECURRENTE"
  },
  {
    "codigo":472805006,
    "descripcion":"OBSTRUCCIÓN DE TÚNEL DE AURÍCULA DERECHA DESPUÉS DE PROCEDIMIENTO DE CONEXIÓN CAVOPULMONAR TOTAL PREVIO"
  },
  {
    "codigo":276197005,
    "descripcion":"INFECCIÓN CAUSADA POR CORYNEBACTERIUM DIPHTHERIAE"
  },
  {
    "codigo":14053009,
    "descripcion":"ENDOMIOMETRITIS AGUDA"
  },
  {
    "codigo":700346002,
    "descripcion":"XERODERMIA DE PÁRPADO SUPERIOR"
  },
  {
    "codigo":896954003,
    "descripcion":"FORMA DE BALA ANORMAL CONGÉNITA DE FALANGE DISTAL DE CUARTO DEDO DE PIE"
  },
  {
    "codigo":77754004,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE LA CADERA, CON INFECCIÓN"
  },
  {
    "codigo":307130006,
    "descripcion":"DEFICIENCIA DE 3-CETOACIL-COA TRIOLASA"
  },
  {
    "codigo":403599000,
    "descripcion":"SENSACIÓN DE PINCHAZO EN LA PIEL"
  },
  {
    "codigo":208826009,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE LA ARTICULACIÓN RADIOCUBITAL DISTAL"
  },
  {
    "codigo":272527009,
    "descripcion":"PARARSE EN PUNTAS DE PIE"
  },
  {
    "codigo":239759009,
    "descripcion":"LUXACIÓN PATOLÓGICA DE LA CADERA"
  },
  {
    "codigo":434532004,
    "descripcion":"FUNGEMIA"
  },
  {
    "codigo":10956601000119106,
    "descripcion":"HERIDA ABIERTA DE DEDO MEDIO DE MANO IZQUIERDA"
  },
  {
    "codigo":301625002,
    "descripcion":"CAPAZ DE USAR ASCENSOR DE ESCALERAS"
  },
  {
    "codigo":72249004,
    "descripcion":"ABSCESO SUBHEPÁTICO"
  },
  {
    "codigo":236089005,
    "descripcion":"FILTRACIÓN POR EL MUÑÓN DUODENAL"
  },
  {
    "codigo":399929008,
    "descripcion":"PAPULOSIS BOWENOIDE DE ANO CON NEOPLASIA INTRAEPITELIAL ANAL GRADO III"
  },
  {
    "codigo":15707961000119109,
    "descripcion":"DISECCIÓN BILATERAL DE ARTERIAS CARÓTIDAS"
  },
  {
    "codigo":299790008,
    "descripcion":"OJO QUE SE DESPLAZA EN DIRECCIÓN AL SONIDO, AUSENTE"
  },
  {
    "codigo":1217294009,
    "descripcion":"OPACIDAD PULMONAR EN VIDRIO DESLUSTRADO"
  },
  {
    "codigo":297955001,
    "descripcion":"PLIEGUE CUTÁNEO SUCIO"
  },
  {
    "codigo":365326008,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA LIMPIAR ARTEFACTOS DOMÉSTICOS"
  },
  {
    "codigo":723939007,
    "descripcion":"EXTRUSIÓN DE IMPLANTE OCULAR"
  },
  {
    "codigo":363491008,
    "descripcion":"NEOPLASIA MALIGNA DE ZONA CLOACÓGENA"
  },
  {
    "codigo":232419008,
    "descripcion":"AGRANDAMIENTO DE AMÍGDALA O ADENOIDES"
  },
  {
    "codigo":230584000,
    "descripcion":"NEUROPATÍA EN DISCRASIAS SANGUÍNEAS"
  },
  {
    "codigo":197816002,
    "descripcion":"FÍSTULA URETERAL"
  },
  {
    "codigo":1208004,
    "descripcion":"GASTROPTOSIS"
  },
  {
    "codigo":445281000124101,
    "descripcion":"NUTRICIÓN ALTERADA DEBIDA A ACCESO LIMITADO A ALIMENTOS SALUDABLES"
  },
  {
    "codigo":396259008,
    "descripcion":"MARGEN QUIRÚRGICO EXOCERVICAL NO COMPROMETIDO POR NEOPLASIA MALIGNA"
  },
  {
    "codigo":2401000124100,
    "descripcion":"SEGUNDO MOLAR INFERIOR DERECHO PERMANENTE SUPERNUMERARIO"
  },
  {
    "codigo":32141002,
    "descripcion":"ABSCESO MESENTÉRICO"
  },
  {
    "codigo":294285006,
    "descripcion":"ALERGIA A EDETATO"
  },
  {
    "codigo":335981000119102,
    "descripcion":"CONJUNTIVITIS PAPILAR GIGANTE CRÓNICA DE OJO DERECHO"
  },
  {
    "codigo":63074002,
    "descripcion":"EDEMA MENSTRUAL"
  },
  {
    "codigo":95842004,
    "descripcion":"DEFICIENCIA DE PLASMINÓGENO AUTOSÓMICA DOMINANTE"
  },
  {
    "codigo":1073261000119103,
    "descripcion":"ARTRITIS DE MUÑECA DERECHA CAUSADA POR BACTERIAS"
  },
  {
    "codigo":292450007,
    "descripcion":"REACCIÓN ADVERSA A LA TERAZOSINA"
  },
  {
    "codigo":290615003,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ESTRAMUSTINA"
  },
  {
    "codigo":126775003,
    "descripcion":"NEOPLASIA DE LA CARA INTERNA DE LABIO SUPERIOR"
  },
  {
    "codigo":94007006,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA PIEL DEL ABDOMEN"
  },
  {
    "codigo":92172000,
    "descripcion":"NEOPLASIA BENIGNA DE LA CARA LARÍNGEA DEL PLIEGUE INTERARITENOIDEO"
  },
  {
    "codigo":288780005,
    "descripcion":"DIFICULTAD PARA COMUNICAR INTENCIONES"
  },
  {
    "codigo":254177003,
    "descripcion":"EPIDERMÓLISIS BULLOSA SIMPLE CON HIPODONCIA"
  },
  {
    "codigo":188641006,
    "descripcion":"HISTIOCITOSIS MALIGNA DE GANGLIOS LINFÁTICOS DE AXILA Y EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":55734000,
    "descripcion":"ENDOFLEBITIS DEL SENO BASILAR"
  },
  {
    "codigo":10877191000119103,
    "descripcion":"HERIDA ABIERTA DE MUSLO DERECHO"
  },
  {
    "codigo":285110007,
    "descripcion":"PENETRACIÓN ANAL CON DEDO DE LA MANO"
  },
  {
    "codigo":22966008,
    "descripcion":"CARDIOPATÍA Y NEFROPATÍA HIPERTENSIVAS QUE COMPLICAN EL EMBARAZO Y\/O CONSTITUYEN UN MOTIVO DE ATENCIÓN DURANTE ESTE PERÍODO"
  },
  {
    "codigo":283275004,
    "descripcion":"VIDRIO EN EL DORSO DEL PIE"
  },
  {
    "codigo":184971005,
    "descripcion":"DECLARACIÓN REALIZADA A LA POLICÍA"
  },
  {
    "codigo":840331008,
    "descripcion":"MASA ABDOMINAL TIMPÁNICA"
  },
  {
    "codigo":10631431000119105,
    "descripcion":"ABSCESO DE PIEL DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":314208002,
    "descripcion":"FIBRILACIÓN AURICULAR RÁPIDA"
  },
  {
    "codigo":281440005,
    "descripcion":"AFLOJAMIENTO DE HEMIARTROPLASTIA DE HOMBRO"
  },
  {
    "codigo":445280007,
    "descripcion":"EDEMA INDURADO SIN FÓVEA"
  },
  {
    "codigo":248672008,
    "descripcion":"SOPLO SISTÓLICO LEVE"
  },
  {
    "codigo":52064007,
    "descripcion":"GAMMAPATÍA BICLONAL"
  },
  {
    "codigo":246837002,
    "descripcion":"PÉRDIDA DE GLÁNDULAS DE MEIBOMIO"
  },
  {
    "codigo":707424007,
    "descripcion":"CARCINOMA PRIMARIO DE LARINGE, DE CÉLULAS ADENOESCAMOSAS"
  },
  {
    "codigo":736522000,
    "descripcion":"MOVIMIENTO NORMAL DE LA ÚVULA"
  },
  {
    "codigo":310538001,
    "descripcion":"PESO AL NACER ENTRE 2 Y 2,5 KILOS"
  },
  {
    "codigo":312373008,
    "descripcion":"PSEUDOANEURISMA FEMORAL"
  },
  {
    "codigo":81162002,
    "descripcion":"DESNATURALIZACIÓN DE LAS PROTEÍNAS DEL CRISTALINO"
  },
  {
    "codigo":408842000,
    "descripcion":"PRUEBA PARA CRIBADO PRENATAL DE VIH EN SANGRE SOLICITADA"
  },
  {
    "codigo":1162506006,
    "descripcion":"GANGRENA CECAL"
  },
  {
    "codigo":212234007,
    "descripcion":"LESIÓN NO EXPUESTA DEL PLEXO SACRO"
  },
  {
    "codigo":112095000,
    "descripcion":"AUTOEROTISMO"
  },
  {
    "codigo":12243361000119104,
    "descripcion":"ABSCESO DE HERIDA POSTERIOR A PROCEDIMIENTO"
  },
  {
    "codigo":210399006,
    "descripcion":"HERIDA ABIERTA EN LA REGIÓN SUPRACLAVICULAR"
  },
  {
    "codigo":13791008,
    "descripcion":"ASTENIA"
  },
  {
    "codigo":110260001,
    "descripcion":"CONTUSIÓN AMIGDALINA"
  },
  {
    "codigo":274100004,
    "descripcion":"HEMORRAGIA CEREBRAL"
  },
  {
    "codigo":11997601000119106,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DE DEDO DE PIE DERECHO"
  },
  {
    "codigo":44724006,
    "descripcion":"DISTRIBUCIÓN ANORMAL"
  },
  {
    "codigo":370569000,
    "descripcion":"MIELOSUPRESIÓN"
  },
  {
    "codigo":403337001,
    "descripcion":"POLIOSIS EN EL SÍNDROME VOGT-KOYANAGI-HARADA"
  },
  {
    "codigo":698249005,
    "descripcion":"BLOQUEO CARDÍACO FAMILIAR PROGRESIVO"
  },
  {
    "codigo":338491000119102,
    "descripcion":"OFTALMOPLEJÍA EXTERNA PROGRESIVA DE OJO IZQUIERDO"
  },
  {
    "codigo":434270001,
    "descripcion":"RECHAZO CRÓNICO DE TRASPLANTE INTESTINAL"
  },
  {
    "codigo":237662005,
    "descripcion":"HIPERPROLACTINEMIA"
  },
  {
    "codigo":290611007,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR MELFALÁN"
  },
  {
    "codigo":301363002,
    "descripcion":"DOLOR EN ESTRUCTURA ENDOCRINA"
  },
  {
    "codigo":235827003,
    "descripcion":"PSEUDO-OBSTRUCCIÓN AGUDA DEL INTESTINO DELGADO"
  },
  {
    "codigo":1153331004,
    "descripcion":"GOTA AGUDA POLIARTICULAR PRIMARIA"
  },
  {
    "codigo":432435004,
    "descripcion":"PACIENTE QUE PROPAGA VIRUS"
  },
  {
    "codigo":297891000119101,
    "descripcion":"MIOSITIS INTERSTICIAL DE HOMBRO"
  },
  {
    "codigo":10970531000119102,
    "descripcion":"HERIDA ABIERTA DE PIERNA IZQUIERDA DEBIDA A MORDEDURA DE ANIMAL"
  },
  {
    "codigo":126371000119101,
    "descripcion":"EVIDENCIA CITOLÓGICA DE NEOPLASIA MALIGNA EN EXTENDIDO DE PAPANICOLAOU VAGINAL"
  },
  {
    "codigo":290211000119105,
    "descripcion":"LESIÓN DE NERVIO CIÁTICO DERECHO"
  },
  {
    "codigo":15650211000119102,
    "descripcion":"CREPITACIÓN DE RODILLA DERECHA"
  },
  {
    "codigo":931000119107,
    "descripcion":"DEPENDENCIA DE OXÍGENO SUPLEMENTARIO"
  },
  {
    "codigo":320931000119108,
    "descripcion":"QUISTE ÓSEO SOLITARIO DEL HÚMERO DERECHO"
  },
  {
    "codigo":6051000119109,
    "descripcion":"ÚLCERA CRÓNICA DE PANTORRILLA"
  },
  {
    "codigo":292771000119108,
    "descripcion":"LESIÓN DE NERVIO MEDIANO DERECHO"
  },
  {
    "codigo":12214691000119109,
    "descripcion":"INFECCIÓN DE TIBIA IZQUIERDA ASOCIADA CON DISPOSITIVO DE FIJACIÓN INTERNA"
  },
  {
    "codigo":363229000,
    "descripcion":"NEOPLASIA DEL SISTEMA MUSCULOESQUELÉTICO"
  },
  {
    "codigo":367011000119109,
    "descripcion":"HEMATURIA MICROSCÓPICA ESENCIAL BENIGNA"
  },
  {
    "codigo":323491000119107,
    "descripcion":"DEFORMIDAD EN VARO ADQUIRIDA DE CODO IZQUIERDO"
  },
  {
    "codigo":1071011000119108,
    "descripcion":"TUMOR TENOSINOVIAL DIFUSO DE CÉLULAS GIGANTES DE PIE"
  },
  {
    "codigo":201224007,
    "descripcion":"ACNÉ URTICANTE"
  },
  {
    "codigo":1083811000119108,
    "descripcion":"PÉRDIDA DE AUDICIÓN NEUROSENSORIAL DE ALTA FRECUENCIA DE AMBOS OÍDOS"
  },
  {
    "codigo":1081251000119109,
    "descripcion":"GLIOMA DE NERVIO ÓPTICO IZQUIERDO"
  },
  {
    "codigo":102920009,
    "descripcion":"MIEDO A CONTRAER INFECCIÓN POR HIV"
  },
  {
    "codigo":230322000,
    "descripcion":"DISTONÍA CERVICAL AISLADA"
  },
  {
    "codigo":263090000,
    "descripcion":"FRACTURA-LUXACIÓN DE ARTICULACIÓN FEMORORROTULIANA"
  },
  {
    "codigo":295858004,
    "descripcion":"SOBREDOSIS INTENCIONAL DE DOTIEPINA"
  },
  {
    "codigo":721842008,
    "descripcion":"SÍNDROME DE HIPOGONADISMO HIPOGONADOTRÓFICO CON ALOPECIA FRONTOPARIETAL"
  },
  {
    "codigo":195719000,
    "descripcion":"BRONQUITIS NEUMOCÓCICA AGUDA"
  },
  {
    "codigo":359559003,
    "descripcion":"INFERTILIDAD POR AZOOSPERMIA"
  },
  {
    "codigo":64647005,
    "descripcion":"QUEMADURA DE CUALQUIER GRADO QUE COMPROMETE 50-59 PORCIENTO DE LA SUPERFICIE DEL CUERPO"
  },
  {
    "codigo":31879006,
    "descripcion":"VIVE EN COMUNIDAD"
  },
  {
    "codigo":294023009,
    "descripcion":"ALERGIA A PSEUDOEFEDRINA"
  },
  {
    "codigo":128348002,
    "descripcion":"NEOPLASIA DEL APARATO DIGESTIVO"
  },
  {
    "codigo":292188003,
    "descripcion":"REACCIÓN ADVERSA A FÁRMACO INMUNOESTIMULANTE"
  },
  {
    "codigo":30044002,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO DE PIE"
  },
  {
    "codigo":95580006,
    "descripcion":"EMBOLIA DE ARTERIA RENAL"
  },
  {
    "codigo":126513000,
    "descripcion":"NEOPLASIA DE LA PIEL DEL PERINEO"
  },
  {
    "codigo":290353000,
    "descripcion":"INTOXICACIÓN POR CIMETIDINA"
  },
  {
    "codigo":192049004,
    "descripcion":"REACCIÓN DE ADAPTACIÓN DEPRESIVA PROLONGADA"
  },
  {
    "codigo":716337006,
    "descripcion":"SÍNDROME DE SEAVER CASSIDY"
  },
  {
    "codigo":1142321007,
    "descripcion":"ATROFIA DE FIBRA DE MÚSCULO ESQUELÉTICO"
  },
  {
    "codigo":39791000119102,
    "descripcion":"TRASTORNO DE MAMA DURANTE EMBARAZO"
  },
  {
    "codigo":386822001,
    "descripcion":"REACCIÓN ADAPTATIVA DE LA ADOLESCENCIA"
  },
  {
    "codigo":26374003,
    "descripcion":"QUEILITIS GLANDULAR"
  },
  {
    "codigo":91910003,
    "descripcion":"AUSENCIA CONGÉNITA DE VÉRTEBRA ESTERNAL"
  },
  {
    "codigo":124678007,
    "descripcion":"DEFICIENCIA DE BIFOSFOGLICERATO MUTASA"
  },
  {
    "codigo":288518007,
    "descripcion":"QUEMADURA CON COMPROMISO DE 2% DE LA SUPERFICIE CORPORAL"
  },
  {
    "codigo":1204187002,
    "descripcion":"OCLUSIÓN AGUDA DE ARTERIA CRURAL DEBIDA A TROMBOEMBOLISMO"
  },
  {
    "codigo":1236955003,
    "descripcion":"METÁSTASIS DE CARCINOMA DE FRENILLO LABIAL"
  },
  {
    "codigo":11836271000119104,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN DE PIE IZQUIERDO"
  },
  {
    "codigo":286683006,
    "descripcion":"RACIONALIZACIÓN - MECANISMO DE DEFENSA PSICOLÓGICA"
  },
  {
    "codigo":712667007,
    "descripcion":"TOXINA SHIGA 1 Y TOXINA SHIGA 2 DETECTADAS"
  },
  {
    "codigo":186544000,
    "descripcion":"DERMATITIS DE PÁRPADO POR VIRUS HERPES SIMPLEX"
  },
  {
    "codigo":367471000119105,
    "descripcion":"DISFUNCIÓN ERÉCTIL DEBIDA A OPERACIÓN DE URETRA Y POSTERIOR A ELLA"
  },
  {
    "codigo":55472006,
    "descripcion":"ABSCESO SUBMAMARIO ASOCIADO CON EL PARTO"
  },
  {
    "codigo":284848008,
    "descripcion":"LIMPIA SUS PRÓTESIS DENTALES"
  },
  {
    "codigo":1003909007,
    "descripcion":"DUPLICACIÓN DE PORCIÓN PROXIMAL DEL CROMOSOMA 13"
  },
  {
    "codigo":1264218000,
    "descripcion":"INFECCIÓN NEONATAL PRECOZ CAUSADA POR BACTERIA"
  },
  {
    "codigo":248410001,
    "descripcion":"PIGMENTACIÓN DE LOS PLIEGUES PALMARES"
  },
  {
    "codigo":19034001,
    "descripcion":"HIPERPARATIROIDISMO SECUNDARIO A INSUFICIENCIA RENAL"
  },
  {
    "codigo":445018004,
    "descripcion":"ESPONDILOLISIS DE COLUMNA VERTEBRAL CERVICAL"
  },
  {
    "codigo":1296986007,
    "descripcion":"CIERRE DE ÁNGULO AGUDO PRIMARIO DE OJO IZQUIERDO"
  },
  {
    "codigo":443183003,
    "descripcion":"HERIDA PENETRANTE DE ABDOMEN"
  },
  {
    "codigo":1196847006,
    "descripcion":"LINFANGIOMA DE HÍGADO"
  },
  {
    "codigo":341001000119105,
    "descripcion":"FIBROSIS SUBRETINIANA DIFUSA DE OJO IZQUIERDO"
  },
  {
    "codigo":312111009,
    "descripcion":"CARCINOMA DE COLON ASCENDENTE"
  },
  {
    "codigo":408580007,
    "descripcion":"OBJETIVO DE LA ACTIVIDAD FÍSICA: EJERCICIO LIVIANO"
  },
  {
    "codigo":211972008,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO SUPERFICIAL DE MUSLO"
  },
  {
    "codigo":277508009,
    "descripcion":"TUMOR DE CÉLULAS GERMINALES DE LA GLÁNDULA PINEAL"
  },
  {
    "codigo":898265008,
    "descripcion":"ANQUILOSIS CONGÉNITA DE ARTICULACIÓN INTERFALÁNGICA PROXIMAL DE DEDO MEDIO"
  },
  {
    "codigo":372142002,
    "descripcion":"CARCINOMA DE PÁNCREAS"
  },
  {
    "codigo":404910002,
    "descripcion":"TEMOR A CAER DURANTE LA MOVILIZACIÓN"
  },
  {
    "codigo":109998009,
    "descripcion":"SÍNDROME MIELODISPLÁSICO CON SIDEROBLASTOS EN ANILLO Y DISPLASIA DE LÍNEA ÚNICA"
  },
  {
    "codigo":9859006,
    "descripcion":"ACANTOSIS NIGRICANS DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":403075009,
    "descripcion":"TIÑA CAUSADA POR MICROSPORUM GYPSEUM"
  },
  {
    "codigo":10964131000119106,
    "descripcion":"LACERACIÓN DE CODO DERECHO"
  },
  {
    "codigo":302936009,
    "descripcion":"ENTESOPATÍA DE MUÑECA Y MANO"
  },
  {
    "codigo":1251373004,
    "descripcion":"DERMATITIS DE CONTACTO DE PIERNA"
  },
  {
    "codigo":301101006,
    "descripcion":"VÁLVULA MITRAL - HALLAZGO"
  },
  {
    "codigo":366637007,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA MANTENER EL EQUILIBRIO AL PARARSE"
  },
  {
    "codigo":399405008,
    "descripcion":"TUMOR QUE INVADE VÍTREO"
  },
  {
    "codigo":233730002,
    "descripcion":"NEUMONITIS LÚPICA"
  },
  {
    "codigo":69890005,
    "descripcion":"INTOXICACIÓN POR TRICLORURO DE NITRÓGENO"
  },
  {
    "codigo":299266006,
    "descripcion":"SIN AMPLITUD ACTIVA DE ABDUCCIÓN DE LA CADERA"
  },
  {
    "codigo":200962007,
    "descripcion":"PSORIASIS ANULAR"
  },
  {
    "codigo":397570008,
    "descripcion":"QUERATITIS ESTROMAL POR HERPES SIMPLE"
  },
  {
    "codigo":788951001,
    "descripcion":"HEMORRAGIA DE SISTEMA DIGESTIVO"
  },
  {
    "codigo":362967002,
    "descripcion":"TRASTORNO DEL SISTEMA OLFATIVO"
  },
  {
    "codigo":364802008,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA DEGLUTIR SEMISÓLIDOS"
  },
  {
    "codigo":4354006,
    "descripcion":"LUXACIÓN EXPUESTA DEL OMÓPLATO"
  },
  {
    "codigo":430338009,
    "descripcion":"LEUCEMIA LINFOCÍTICA CRÓNICA QUIESCENTE"
  },
  {
    "codigo":361132001,
    "descripcion":"ARTERIOSCLEROSIS SENIL"
  },
  {
    "codigo":231895009,
    "descripcion":"ÚLCERA DE CÓRNEA POR PROTOZOOS"
  },
  {
    "codigo":230060001,
    "descripcion":"FUMADOR LEVE DE CIGARRILLOS"
  },
  {
    "codigo":721580001,
    "descripcion":"MIOSARCOMA PRIMARIO DE EPIPLÓN"
  },
  {
    "codigo":719745000,
    "descripcion":"CAPAZ DE RESPONDER A ESTÍMULOS"
  },
  {
    "codigo":262828008,
    "descripcion":"SECCIÓN DE PÁNCREAS"
  },
  {
    "codigo":11838781000119108,
    "descripcion":"LACERACIÓN DE MÚSCULO INTRÍNSECO DE DEDO MEÑIQUE DERECHO"
  },
  {
    "codigo":424833008,
    "descripcion":"INCONTINENCIA POR INESTABILIDAD DEL DETRUSOR"
  },
  {
    "codigo":293761008,
    "descripcion":"ALERGIA A BLEOMICINA"
  },
  {
    "codigo":291926000,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR VITAMINA D"
  },
  {
    "codigo":128086004,
    "descripcion":"TRASTORNO HEMOLÍTICO"
  },
  {
    "codigo":95318007,
    "descripcion":"VÍCTIMA DE TORTURA"
  },
  {
    "codigo":717910009,
    "descripcion":"INSUFICIENCIA OVÁRICA PREMATURA IATROGÉNICA"
  },
  {
    "codigo":191787001,
    "descripcion":"TRASTORNO DE LA IDENTIDAD PSICOSEXUAL"
  },
  {
    "codigo":1240363001,
    "descripcion":"CARCINOMA NEUROENDOCRINO MICROCÍTICO CON METÁSTASIS A OVARIO"
  },
  {
    "codigo":15990231000119104,
    "descripcion":"CATARATA COMPLICADA DE OJO DERECHO"
  },
  {
    "codigo":343511000119104,
    "descripcion":"DEFECTO DE SECTOR DE CAMPO VISUAL DE AMBOS OJOS"
  },
  {
    "codigo":1142059006,
    "descripcion":"TRASTORNO ADRENOGENITAL CAUSADO POR FÁRMACOS"
  },
  {
    "codigo":290091009,
    "descripcion":"HALLAZGO RELACIONADO CON EL COLOR DEL PEZÓN"
  },
  {
    "codigo":26112003,
    "descripcion":"FACTOR PSICOSOMÁTICO EN ENFERMEDAD FÍSICA"
  },
  {
    "codigo":124416007,
    "descripcion":"DEFICIENCIA DE TROPINESTERASA"
  },
  {
    "codigo":286421000,
    "descripcion":"DIFICULTAD PARA ABASTECERSE"
  },
  {
    "codigo":1269461002,
    "descripcion":"SÍNDROME MEDULAR CENTRAL POR FRACTURA ENTRE C5 Y C7"
  },
  {
    "codigo":253653004,
    "descripcion":"CAYADO AÓRTICO IZQUIERDO Y AORTA DESCENDENTE DERECHA"
  },
  {
    "codigo":251818004,
    "descripcion":"ESTADIO 1 DE DESARROLLO DE VELLO PÚBICO DE TANNER"
  },
  {
    "codigo":415658005,
    "descripcion":"CONDUCTA DE ABUSO DE SUSTANCIAS"
  },
  {
    "codigo":10966641000119103,
    "descripcion":"HERIDA PUNZANTE DE PIERNA IZQUIERDA"
  },
  {
    "codigo":219050007,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR ANTIPRURIGINOSO"
  },
  {
    "codigo":284586008,
    "descripcion":"ASTILLA DE MADERA EN LA FRENTE"
  },
  {
    "codigo":20607006,
    "descripcion":"GINGIVOESTOMATITIS"
  },
  {
    "codigo":282751007,
    "descripcion":"LESIÓN DE REGIÓN POSTERIOR DE LA CABEZA"
  },
  {
    "codigo":249983008,
    "descripcion":"SIENTE QUE SE VA A CAER"
  },
  {
    "codigo":117076001,
    "descripcion":"UNIDAD DE HEMODERIVADO COMPATIBILIZADA"
  },
  {
    "codigo":11785841000119105,
    "descripcion":"ABRASIÓN DE PIEL DE REGIÓN DE MUÑECA DERECHA"
  },
  {
    "codigo":1263956003,
    "descripcion":"INSUFICIENCIA RENAL AGUDA POSTERIOR A EMBARAZO MOLAR"
  },
  {
    "codigo":444756000,
    "descripcion":"TRASTORNO DEL METABOLISMO DE LA VALINA"
  },
  {
    "codigo":315519007,
    "descripcion":"NACIDO EN SINGAPUR"
  },
  {
    "codigo":1231188007,
    "descripcion":"OCLUSIÓN DE ARTERIA OFTÁLMICA"
  },
  {
    "codigo":84308008,
    "descripcion":"ESPOLÓN DE LA CRESTA ILÍACA"
  },
  {
    "codigo":739668007,
    "descripcion":"RUPTURA DE ÚTERO DEBIDA A PROCEDIMIENTO OBSTÉTRICO"
  },
  {
    "codigo":279081001,
    "descripcion":"GRUPO DE DISOSTOSIS MÚLTIPLE"
  },
  {
    "codigo":82473003,
    "descripcion":"RADICULITIS"
  },
  {
    "codigo":770601003,
    "descripcion":"CARCINOMA MICROCÍTICO DE OVARIO"
  },
  {
    "codigo":705065000,
    "descripcion":"SÍNDROME NEFRÓTICO INFANTIL"
  },
  {
    "codigo":441086003,
    "descripcion":"CÉLULAS ESCAMOSAS ATÍPICAS DE SIGNIFICACIÓN INDETERMINADA EN EL EXTENDIDO DE PAPANICOLAOU ANAL"
  },
  {
    "codigo":703230006,
    "descripcion":"CÁNCER DE PULMÓN NO MICROCÍTICO SIN MUTACIÓN DEL RECEPTOR DEL FACTOR DE CRECIMIENTO EPIDÉRMICO"
  },
  {
    "codigo":766931003,
    "descripcion":"SÍNDROME DE ARTROGRIPOSIS Y NEUROPATÍA POR HIPOMIELINIZACIÓN"
  },
  {
    "codigo":13267003,
    "descripcion":"TRASTORNO DE LA FUNCIÓN MOTORA GÁSTRICA"
  },
  {
    "codigo":275411007,
    "descripcion":"ESTRECHEZ URETRAL SUBMEATAL"
  },
  {
    "codigo":109736000,
    "descripcion":"FRACASO DE RESTAURACIÓN DENTAL QUE AFECTA LA INTEGRIDAD ANATÓMICA PERIODONTAL"
  },
  {
    "codigo":765096001,
    "descripcion":"QUERATODERMIA PALMOPLANTAR PUNTEADA TIPO 2"
  },
  {
    "codigo":44200002,
    "descripcion":"SIGNO DE ENCOGIMIENTO"
  },
  {
    "codigo":111571009,
    "descripcion":"ATRANSFERRINEMIA CONGÉNITA"
  },
  {
    "codigo":404648005,
    "descripcion":"GLAUCOMA POR DEPÓSITO DE PARTÍCULAS EN EL CRISTALINO"
  },
  {
    "codigo":402813000,
    "descripcion":"CARCINOMA IN SITU DE MUCOSA BUCAL"
  },
  {
    "codigo":271741001,
    "descripcion":"SANGRE EN EL CONDUCTO AUDITIVO"
  },
  {
    "codigo":1254781000,
    "descripcion":"SARCOMA DE EWING DE COSTILLA"
  },
  {
    "codigo":238973003,
    "descripcion":"DELIRIO DE PARASITOSIS"
  },
  {
    "codigo":11814821000119101,
    "descripcion":"RUPTURA TRAUMÁTICA DE PLACA PALMAR DE ARTICULACIÓN DE DEDO ÍNDICE IZQUIERDO"
  },
  {
    "codigo":75133003,
    "descripcion":"GRADO DE AFECTACIÓN: DETERIORO MODERADO EN AMBOS OJOS"
  },
  {
    "codigo":204370002,
    "descripcion":"ESTENOSIS DE INFUNDÍBULO DE VENTRÍCULO DERECHO"
  },
  {
    "codigo":106066004,
    "descripcion":"HALLAZGO EN EL RITMO Y\/O LA FRECUENCIA CARDÍACA"
  },
  {
    "codigo":237138004,
    "descripcion":"FALLA OVÁRICA MENOPÁUSICA"
  },
  {
    "codigo":400978007,
    "descripcion":"CUMPLIMIENTO FARMACOLÓGICO ESCASO"
  },
  {
    "codigo":7762009,
    "descripcion":"PARASPADIAS"
  },
  {
    "codigo":300839008,
    "descripcion":"DIFICULTAD PARA REALIZAR ACTIVIDADES DE MANTENIMIENTO DEL AUTO"
  },
  {
    "codigo":724988000,
    "descripcion":"EPILEPSIA CONCOMITANTE CON TRASTORNO CEREBRAL DEGENERATIVO Y DEBIDA A ÉL"
  },
  {
    "codigo":299004000,
    "descripcion":"AMPLITUD DE PRONACIÓN ACTIVA DE LA MUÑECA NORMAL"
  },
  {
    "codigo":200700005,
    "descripcion":"LINFADENITIS AGUDA DE CARA, CABEZA Y CUELLO"
  },
  {
    "codigo":346021000119106,
    "descripcion":"COROIDITIS FOCAL BILATERAL"
  },
  {
    "codigo":167932008,
    "descripcion":"MÉDULA ÓSEA: AUSENCIA DE CÉLULAS EXTRAÑAS"
  },
  {
    "codigo":428241007,
    "descripcion":"HEMORRAGIA EN VENTRÍCULO DE CEREBRO FETAL"
  },
  {
    "codigo":262566000,
    "descripcion":"HERIDA PROFUNDA POR PUNCIÓN"
  },
  {
    "codigo":723153008,
    "descripcion":"ESTADO MÍNIMAMENTE CONSCIENTE MINUS"
  },
  {
    "codigo":1149137008,
    "descripcion":"INTOXICACIÓN ACCIDENTAL CAUSADA POR OXAZOLIDINA"
  },
  {
    "codigo":721318000,
    "descripcion":"FRACTURA DE PORCIÓN ESCAMOSA DE HUESO OCCIPITAL DEL CRÁNEO"
  },
  {
    "codigo":67793007,
    "descripcion":"ALOEROTISMO"
  },
  {
    "codigo":459174005,
    "descripcion":"ENDOCARDITIS INFECCIOSA EN LOCALIZACIÓN DE COMUNICACIÓN INTERAURICULAR"
  },
  {
    "codigo":197030006,
    "descripcion":"ENTEROCOLITIS ALIMENTARIA"
  },
  {
    "codigo":65958008,
    "descripcion":"HIPO"
  },
  {
    "codigo":295334008,
    "descripcion":"SOBREDOSIS DE COMPUESTO CON BISMUTO"
  },
  {
    "codigo":293499000,
    "descripcion":"REACCIÓN ADVERSA A LA GUANETIDINA"
  },
  {
    "codigo":1145467000,
    "descripcion":"APLASIA DE COSTILLA"
  },
  {
    "codigo":31355000,
    "descripcion":"QUEMADURA PROFUNDA DE TERCER GRADO DE LA MUÑECA"
  },
  {
    "codigo":424571008,
    "descripcion":"PARO CARDÍACO POR AHOGAMIENTO"
  },
  {
    "codigo":160592001,
    "descripcion":"INGESTA DE ALCOHOL POR ENCIMA DE LOS LÍMITES RECOMENDADOS"
  },
  {
    "codigo":95056001,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA PIEL DEL MENTÓN"
  },
  {
    "codigo":783184003,
    "descripcion":"CISTITIS INCRUSTANTE"
  },
  {
    "codigo":1209168005,
    "descripcion":"MIOPATÍA CONGÉNITA POR DESPROPORCIÓN DEL TIPO DE FIBRA DEBIDA A MUTACIÓN DEL GEN DE CADENA PESADA DE BETA MIOSINA"
  },
  {
    "codigo":226128006,
    "descripcion":"DIETA CON BAJO CONTENIDO DE FRUCTOSA"
  },
  {
    "codigo":422736007,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE NERVIO PERIFÉRICO"
  },
  {
    "codigo":319551000119107,
    "descripcion":"ARTRITIS REACTIVA DE ARTICULACIÓN DE RODILLA IZQUIERDA"
  },
  {
    "codigo":93221005,
    "descripcion":"MELANOMA MALIGNO DE PIEL DE CODO"
  },
  {
    "codigo":289829007,
    "descripcion":"CUELLO UTERINO, NORMAL"
  },
  {
    "codigo":850950361000119102,
    "descripcion":"ENDOMETRIOSIS SUPERFICIAL DE OVARIO DERECHO"
  },
  {
    "codigo":191525009,
    "descripcion":"PSICOSIS NO ORGÁNICA"
  },
  {
    "codigo":124154001,
    "descripcion":"DEFICIENCIA DE FORMATO DESHIDROGENASA"
  },
  {
    "codigo":291080005,
    "descripcion":"INTOXICACIÓN POR PRAZEPAM"
  },
  {
    "codigo":58618005,
    "descripcion":"ENFERMEDAD FAMILIAR CON ALMACENAMIENTO DE ESTEROLES (A EXCEPCIÓN DEL COLESTEROL)"
  },
  {
    "codigo":24015000,
    "descripcion":"INTOXICACIÓN POR TYLECODON"
  },
  {
    "codigo":89551006,
    "descripcion":"EXPRESIÓN GÉNICA"
  },
  {
    "codigo":253391007,
    "descripcion":"MALFORMACIÓN EN PARACAÍDAS DE VÁLVULA TRICÚSPIDE"
  },
  {
    "codigo":284324007,
    "descripcion":"CAPAZ DE GOLPEAR OBJETOS ENTRE SÍ"
  },
  {
    "codigo":251556008,
    "descripcion":"CRONODISPERSIÓN DE ONDA F AUMENTADA"
  },
  {
    "codigo":1300132009,
    "descripcion":"SÍNDROME DE CLARK BARAITSER"
  },
  {
    "codigo":448164008,
    "descripcion":"CIEGO EN EL LADO IZQUIERDO"
  },
  {
    "codigo":282489003,
    "descripcion":"CORRE PENDIENTE ARRIBA"
  },
  {
    "codigo":249721004,
    "descripcion":"MOVIMIENTO CORRIGE LA DEFORMIDAD DE LA COLUMNA VERTEBRAL"
  },
  {
    "codigo":1003385006,
    "descripcion":"TRASTORNO DEL NEURODESARROLLO DEBIDO A CONSUMO MATERNO DE ALCOHOL"
  },
  {
    "codigo":315257008,
    "descripcion":"LESIÓN CUTÁNEA PIGMENTADA EXUDATIVA"
  },
  {
    "codigo":1263694000,
    "descripcion":"TRASTORNO FETAL DEBIDO A EMBARAZO DE TRILLIZOS"
  },
  {
    "codigo":84046005,
    "descripcion":"HERNIA RETROCECAL"
  },
  {
    "codigo":1163555005,
    "descripcion":"ESOFAGITIS POR MICOBACTERIAS"
  },
  {
    "codigo":735736000,
    "descripcion":"HERNIA INTRABDOMINAL PRIMARIA"
  },
  {
    "codigo":309752000,
    "descripcion":"HERNIA DE HIATO CON GANGRENA"
  },
  {
    "codigo":322061000119100,
    "descripcion":"OSTEOMIELITIS SUBAGUDA DE MANO DERECHA"
  },
  {
    "codigo":1260024007,
    "descripcion":"CARCINOMA ADENOIDE DE CÉLULAS ESCAMOSAS DE LARINGE"
  },
  {
    "codigo":16077171000119107,
    "descripcion":"DEPENDENCIA DE TABACO CAUSADA POR TABACO MASTICABLE"
  },
  {
    "codigo":209613003,
    "descripcion":"DESGARRO COMPLETO DE DEDO, ARTICULACIÓN METACARPOFALÁNGICA, LIGAMENTO LATERAL RADIAL"
  },
  {
    "codigo":111309008,
    "descripcion":"SÍNDROME DE TRISOMÍA PARCIAL 8Q"
  },
  {
    "codigo":238711000,
    "descripcion":"LENTIGINOSIS ERUPTIVA"
  },
  {
    "codigo":109474009,
    "descripcion":"AMELOGÉNESIS IMPERFECTA, TIPO HIPOMADURACIÓN PIGMENTADA"
  },
  {
    "codigo":699298009,
    "descripcion":"SÍNDROME DE OHDO, VARIANTE DE SAY-BARBER-BIESECKER-YOUNG-SIMPSON"
  },
  {
    "codigo":240546009,
    "descripcion":"EXANTEMA POR VIRUS COXSACKIE"
  },
  {
    "codigo":271479005,
    "descripcion":"NEOPLASIA BENIGNA DE GLÁNDULA HIPÓFISIS Y CONDUCTO CRANEOFARÍNGEO"
  },
  {
    "codigo":402551005,
    "descripcion":"NEVO DE SPITZ CON DISEMINACIÓN INTRAEPIDÉRMICA PAGETOIDE"
  },
  {
    "codigo":369783007,
    "descripcion":"PLEOMORFISMO NUCLEAR DE CARCINOMA DUCTAL IN SITU, GRADO 3: NÚCLEOS MUY PLEOMÓRFICOS, GENERALMENTE CON ERITROCITOS DE DIÁMETROS MAYORES A 2,5, CON ACUMULACIÓN DE CROMATINA Y VARIOS NUCLÉOLOS"
  },
  {
    "codigo":204108000,
    "descripcion":"MICROFTALMÍA SIMPLE"
  },
  {
    "codigo":171340004,
    "descripcion":"EXAMEN ESPECIAL - NO SE DETECTARON ANOMALÍAS"
  },
  {
    "codigo":1187148008,
    "descripcion":"PERIODONTITIS EXACERBADA POR SÍNDROME DE CHÉDIAK-HIGASHI"
  },
  {
    "codigo":169505001,
    "descripcion":"UTILIZA PRESERVATIVO ANTICONCEPTIVO"
  },
  {
    "codigo":890401002,
    "descripcion":"AGENESIA BILATERAL DE PIERNAS Y PIES"
  },
  {
    "codigo":38433004,
    "descripcion":"INSENSIBILIDAD AL DOLOR"
  },
  {
    "codigo":235041006,
    "descripcion":"MÁCULA MELANOCÍTICA BUCAL"
  },
  {
    "codigo":300577008,
    "descripcion":"HALLAZGO RELACIONADO CON UNA LESIÓN"
  },
  {
    "codigo":3830001,
    "descripcion":"ENFISEMA SUBCUTÁNEO"
  },
  {
    "codigo":71201008,
    "descripcion":"SOPLO PANSISTÓLICO"
  },
  {
    "codigo":724726005,
    "descripcion":"ALTERACIONES PERCEPTIVAS CONCOMITANTES CON ABSTINENCIA DE SUSTANCIA PSICOACTIVA Y DEBIDAS A ELLA"
  },
  {
    "codigo":298742007,
    "descripcion":"HALLAZGO RELACIONADO CON EL TAMAÑO DE LA EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":67531005,
    "descripcion":"ESPINA BÍFIDA"
  },
  {
    "codigo":165835005,
    "descripcion":"TÍTULO DE ANTICUERPOS ANTITOXOPLASMA POR ENCIMA DE RANGO DE REFERENCIA"
  },
  {
    "codigo":426144000,
    "descripcion":"REACCIÓN DE PRENDIMIENTO INJERTO"
  },
  {
    "codigo":295591000119105,
    "descripcion":"CALCIFICACIÓN Y OSIFICACIÓN DE MÚSCULO DE MUSLO DEBIDA A QUEMADURA"
  },
  {
    "codigo":296907009,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE ESTRÓGENO"
  },
  {
    "codigo":1179808003,
    "descripcion":"REGISTRADOR DE BUCLE IMPLANTABLE IN SITU"
  },
  {
    "codigo":1343648006,
    "descripcion":"RETINITIS DISEMINADA DE POLO POSTERIOR IZQUIERDO"
  },
  {
    "codigo":65696007,
    "descripcion":"GRANULOMA POR COCCIDIOS"
  },
  {
    "codigo":293237002,
    "descripcion":"REACCIÓN ADVERSA A LA METILTESTOSTERONA"
  },
  {
    "codigo":162165008,
    "descripcion":"SIN SECRECIÓN POR EL PEZÓN"
  },
  {
    "codigo":678721000119102,
    "descripcion":"VISIÓN EN TÚNEL DE OJO DERECHO"
  },
  {
    "codigo":94794003,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA PARED DEL TÓRAX"
  },
  {
    "codigo":1208906004,
    "descripcion":"CONJUNTIVITIS CICATRIZANTE TÓXICA AGUDA"
  },
  {
    "codigo":291402005,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR NALOXONA"
  },
  {
    "codigo":422474003,
    "descripcion":"AUSENCIA PARCIAL DE SEPTUM PELLUCIDUM"
  },
  {
    "codigo":62026008,
    "descripcion":"BLOQUEO DE LA RAMA IZQUIERDA POSTERIOR DEL HAZ DE HIS"
  },
  {
    "codigo":92959002,
    "descripcion":"FORMA ANORMAL CONGÉNITA DE HUESO CIGOMÁTICO"
  },
  {
    "codigo":289567003,
    "descripcion":"PROBLEMA DE SECRECIÓN VAGINAL"
  },
  {
    "codigo":713716005,
    "descripcion":"ESCOLIOSIS IDIOPÁTICA DE COLUMNA VERTEBRAL DORSAL CON DOBLE CURVA"
  },
  {
    "codigo":254964006,
    "descripcion":"MESOADENOMA HIPOFISARIO"
  },
  {
    "codigo":123892007,
    "descripcion":"INTOXICACIÓN POR AMARANTHACEAE"
  },
  {
    "codigo":449737008,
    "descripcion":"PIEL PERILESIONAL PASTOSA"
  },
  {
    "codigo":285897009,
    "descripcion":"DIFICULTAD PARA UTILIZAR UTENSILIOS DE COCINA"
  },
  {
    "codigo":284062002,
    "descripcion":"CONTUSIÓN DE LA REGIÓN INFERIOR DE LA ESPALDA"
  },
  {
    "codigo":447902006,
    "descripcion":"ATRESIA DE VENA CAVA SUPERIOR IZQUIERDA"
  },
  {
    "codigo":1363571007,
    "descripcion":"VIVE EN RESIDENCIA CON ELECTRICIDAD"
  },
  {
    "codigo":249459008,
    "descripcion":"QUISTE SUPRAGLÓTICO"
  },
  {
    "codigo":83784000,
    "descripcion":"TUBERCULOSIS DEL MEDIASTINO"
  },
  {
    "codigo":216691009,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR INSECTICIDAS DE COMPUESTOS ORGANOCLORADOS"
  },
  {
    "codigo":247624005,
    "descripcion":"PENSAMIENTO INUSUALMENTE CREATIVO"
  },
  {
    "codigo":313160006,
    "descripcion":"HIPOACCIÓN DEL RECTO SUPERIOR"
  },
  {
    "codigo":737309000,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE GLÁNDULA SUBMAXILAR"
  },
  {
    "codigo":81949002,
    "descripcion":"ESCALÓN"
  },
  {
    "codigo":278557005,
    "descripcion":"OBTURACIÓN DENTAL CON IONÓMERO DE VIDRIO, PRESENTE"
  },
  {
    "codigo":276722003,
    "descripcion":"HEMORRAGIA INTRACEREBELOSA Y DE FOSA POSTERIOR"
  },
  {
    "codigo":1259762006,
    "descripcion":"GLIOMA ÓPTICO PRIMARIO MALIGNO DEL ADULTO"
  },
  {
    "codigo":211186008,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE HOMBRO Y BRAZO"
  },
  {
    "codigo":735474009,
    "descripcion":"ISQUEMIA DE RIÑÓN"
  },
  {
    "codigo":242119003,
    "descripcion":"LESIÓN DE OCUPANTE DE VEHÍCULO DE MOTOR SIN ACCIDENTE DE TRÁNSITO"
  },
  {
    "codigo":373191003,
    "descripcion":"DÉFICIT EN LA CAPACIDAD PARA HACER USO DEL SANITARIO"
  },
  {
    "codigo":405959005,
    "descripcion":"EQUIPO INTERGRUPAL PARA EL ESTUDIO POSQUIRÚRGICO DE RABDOMIOSARCOMA IIA: TUMOR LOCALIZADO, RESECCIÓN MACROSCÓPICA TOTAL, PERO CON ENFERMEDAD MICROSCÓPICA RESIDUAL"
  },
  {
    "codigo":1290695006,
    "descripcion":"ADENOCARCINOMA APOCRINO METASTÁSICO"
  },
  {
    "codigo":209351005,
    "descripcion":"FRACTURA-SUBLUXACIÓN NO EXPUESTA DE ARTICULACIÓN DE TOBILLO"
  },
  {
    "codigo":305820001,
    "descripcion":"ATENDIDO POR EL SERVICIO DE ENFERMEDADES INFECCIOSAS"
  },
  {
    "codigo":404124002,
    "descripcion":"INFILTRACIÓN LEUCÉMICA DE LA PIEL (LEUCEMIA LINFOBLÁSTICA DE CÉLULAS T)"
  },
  {
    "codigo":895644007,
    "descripcion":"FORMA TRIANGULAR ANORMAL CONGÉNITA DE FALANGE PROXIMAL DE DEDO GORDO"
  },
  {
    "codigo":238449000,
    "descripcion":"AMEBIASIS DE LA PIEL"
  },
  {
    "codigo":402289001,
    "descripcion":"GINGIVOESTOMATITIS IRRITATIVA POR CONTACTO"
  },
  {
    "codigo":41841004,
    "descripcion":"ANEMIA SIDEROBLÁSTICA"
  },
  {
    "codigo":205681004,
    "descripcion":"DISGENESIA GONADAL"
  },
  {
    "codigo":369521009,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA TROMPA DE FALOPIO DERECHA"
  },
  {
    "codigo":236614007,
    "descripcion":"LINFOCELE PERIRRENAL Y PERIURETERAL POSTRASPLANTE"
  },
  {
    "codigo":1119515000,
    "descripcion":"AGOTAMIENTO FATIGABLE DE MÚSCULO DE CUELLO"
  },
  {
    "codigo":365851000,
    "descripcion":"PRUEBA VISUAL - HALLAZGO"
  },
  {
    "codigo":105542008,
    "descripcion":"NO BEBEDOR"
  },
  {
    "codigo":1186886008,
    "descripcion":"MIELOPATÍA POR VENENO DE ARAÑA"
  },
  {
    "codigo":202011001,
    "descripcion":"ARTROPATÍA TRANSITORIA DE LA ARTICULACIÓN TIBIOPERONEA"
  },
  {
    "codigo":300315008,
    "descripcion":"SIN ANO"
  },
  {
    "codigo":298480007,
    "descripcion":"CREPITACIÓN PALPABLE DE LA COLUMNA CERVICAL"
  },
  {
    "codigo":396784007,
    "descripcion":"NÚMERO DE GRUPOS GANGLIONARES PRESENTES EN ESPÉCIMEN, NO SE PUEDE DETERMINAR"
  },
  {
    "codigo":429552008,
    "descripcion":"FRACTURAS MÚLTIPLES NO EXPUESTAS ESTABLES DE LA PELVIS POR COMPRESIÓN LATERAL"
  },
  {
    "codigo":107791000119107,
    "descripcion":"CARCINOMA ADENOESCAMOSO PRIMARIO DE ENDOMETRIO"
  },
  {
    "codigo":788165003,
    "descripcion":"USO INDEBIDO DE MEDICACIÓN"
  },
  {
    "codigo":1148613004,
    "descripcion":"AMPLITUD DE ONDA B DE ELECTRORRETINOGRAMA DE FLASH CON ADAPTACIÓN A OSCURIDAD SUPERNORMAL"
  },
  {
    "codigo":294810001,
    "descripcion":"ALERGIA A LA VASOPRESINA"
  },
  {
    "codigo":130970002,
    "descripcion":"ALTERACIÓN EN LAS CONDUCTAS SALUDABLES"
  },
  {
    "codigo":425882004,
    "descripcion":"SÍNDROME PARALÍTICO COMO EFECTO TARDÍO DE ACCIDENTE CEREBROVASCULAR"
  },
  {
    "codigo":10675471000119109,
    "descripcion":"EXACERBACIÓN SEVERA AGUDA DE ASMA ALÉRGICA SEVERA PERSISTENTE"
  },
  {
    "codigo":161903000,
    "descripcion":"INCAPAZ DE PARARSE"
  },
  {
    "codigo":292975002,
    "descripcion":"REACCIÓN ADVERSA A PENICILINAS ANTIPSEUDOMONAS"
  },
  {
    "codigo":129135003,
    "descripcion":"LESIÓN DE NERVIO DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":61764000,
    "descripcion":"DEFICIENCIA DE HOMOCARNOSINASA"
  },
  {
    "codigo":127300000,
    "descripcion":"LESIÓN TRAUMÁTICA CEREBRAL CON PÉRDIDA MODERADA DE LA CONSCIENCIA"
  },
  {
    "codigo":94532000,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LAS GLÁNDULAS SEBÁCEAS"
  },
  {
    "codigo":291140003,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR TETRABENAZINA"
  },
  {
    "codigo":225604004,
    "descripcion":"LACTANCIA ESTABLECIDA"
  },
  {
    "codigo":28996007,
    "descripcion":"MORTINATO PREMATURO DE SEXO FEMENINO (1000 - 2499 GRAMOS)"
  },
  {
    "codigo":92697000,
    "descripcion":"CARCINOMA IN SITU DE PELVIS RENAL"
  },
  {
    "codigo":780825003,
    "descripcion":"USO DE CATHA EDULIS"
  },
  {
    "codigo":289305007,
    "descripcion":"LATIDO PALPABLE EN EL CORDÓN UMBILICAL A TRAVÉS DE MEMBRANAS INTACTAS"
  },
  {
    "codigo":1336046000,
    "descripcion":"EPISODIO DE USO NOCIVO DE DIURÉTICO"
  },
  {
    "codigo":254702000,
    "descripcion":"CARCINOMA BASOESCAMOSO DE LA PIEL"
  },
  {
    "codigo":713454009,
    "descripcion":"ENDOMETRITIS ATRÓFICA"
  },
  {
    "codigo":1137603007,
    "descripcion":"BERMELLÓN DE LABIO SUPERIOR EN CARPA"
  },
  {
    "codigo":416707008,
    "descripcion":"INFECCIÓN POR VIRUS DE LA ENCEFALITIS DE POWASSAN"
  },
  {
    "codigo":251032001,
    "descripcion":"COLATERALES DE ARTERIA CORONARIA"
  },
  {
    "codigo":283800004,
    "descripcion":"MORDEDURA DE ANIMAL EN EL CUELLO"
  },
  {
    "codigo":414872006,
    "descripcion":"RUPTURA NO TRAUMÁTICA DEL TENDÓN DEL BÍCEPS BRAQUIAL"
  },
  {
    "codigo":773485002,
    "descripcion":"ALERGIA AL ÁCIDO VALPROICO"
  },
  {
    "codigo":247362001,
    "descripcion":"DOLOR CON EL MOVIMIENTO DE LA PARED ABDOMINAL"
  },
  {
    "codigo":312898002,
    "descripcion":"DEGENERACIÓN MACULAR MIÓPICA"
  },
  {
    "codigo":17986004,
    "descripcion":"TOS PERRUNA"
  },
  {
    "codigo":116290004,
    "descripcion":"DOLOR ABDOMINAL AGUDO"
  },
  {
    "codigo":280130008,
    "descripcion":"TRASTORNO DE PARTES BLANDAS DE LA CAVIDAD ABDOMINAL"
  },
  {
    "codigo":1197634009,
    "descripcion":"EQUIPAMIENTO INADECUADO PARA PREPARACIÓN DE ALIMENTOS EN LA VIVIENDA"
  },
  {
    "codigo":737047001,
    "descripcion":"HIPOACUSIA ADQUIRIDA LEVE"
  },
  {
    "codigo":1259500003,
    "descripcion":"CARCINOMA MUCOEPIDERMOIDE PRIMARIO DE GLÁNDULA SUBMANDIBULAR"
  },
  {
    "codigo":47084006,
    "descripcion":"TALASEMIA BETA MÁS HEMOGLOBINA A>2< NORMAL TIPO 1 SILENTE"
  },
  {
    "codigo":733377000,
    "descripcion":"MORDEDURA ABIERTA DE REGIÓN PÉLVICA"
  },
  {
    "codigo":702444009,
    "descripcion":"SÍNDROME LINFOPROLIFERATIVO AUTOINMUNE"
  },
  {
    "codigo":241857002,
    "descripcion":"EFECTO TÓXICO CAUSADO POR DESODORANTE DE AMBIENTES"
  },
  {
    "codigo":307393002,
    "descripcion":"INJERTO ARTERIAL INFECTADO"
  },
  {
    "codigo":683741000119108,
    "descripcion":"NEVO DISPLÁSICO DE PIEL DEL TRONCO"
  },
  {
    "codigo":371094000,
    "descripcion":"DOLOR CÓLICO EN HIPOGASTRIO"
  },
  {
    "codigo":274625009,
    "descripcion":"ACONTECIMIENTO RETRASADO"
  },
  {
    "codigo":174486004,
    "descripcion":"ARRANCARSE LOS OJOS"
  },
  {
    "codigo":403862005,
    "descripcion":"QUERATOSIS SEBORREICA SUPERFICIAL"
  },
  {
    "codigo":16058231000119103,
    "descripcion":"PLEXOPATÍA BRAQUIAL DE MIEMBRO SUPERIOR DERECHO"
  },
  {
    "codigo":240022008,
    "descripcion":"PELLIZCAMIENTO POSTERIOR DE TOBILLO"
  },
  {
    "codigo":76182009,
    "descripcion":"INTOXICACIÓN POR PASPALUM DILATATUM"
  },
  {
    "codigo":698774009,
    "descripcion":"INTERCUSPIDACIÓN ANORMAL"
  },
  {
    "codigo":305558009,
    "descripcion":"BAJO ATENCIÓN DE ENFERMERA ESPECIALIZADA EN REHABILITACIÓN CARDÍACA"
  },
  {
    "codigo":762475005,
    "descripcion":"QUEMADURA COMPLEJA DE TRONCO"
  },
  {
    "codigo":1155691007,
    "descripcion":"ETAPA DE ACCIÓN PARA LA DISPOSICIÓN A MODIFICAR LA CONDUCTA NUTRICIONAL"
  },
  {
    "codigo":35751000175105,
    "descripcion":"ÚLCERA POR PRESIÓN EN CODO, ESTADIO IV"
  },
  {
    "codigo":203584002,
    "descripcion":"QUINTO RAYO CON FLEXIÓN PLANTAR ADQUIRIDA"
  },
  {
    "codigo":269120004,
    "descripcion":"LUXACIÓN NO EXPUESTA ENTRE LA QUINTA Y LA SEXTA VÉRTEBRAS CERVICALES"
  },
  {
    "codigo":1186624006,
    "descripcion":"AMBIENTE CON HUMEDAD"
  },
  {
    "codigo":72512006,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE NARIZ CON INFECCIÓN"
  },
  {
    "codigo":365589000,
    "descripcion":"TÍTULO DE ANTICUERPOS - HALLAZGO"
  },
  {
    "codigo":234517008,
    "descripcion":"REACCIÓN PULMONAR A LA TRANSFUSIÓN"
  },
  {
    "codigo":396522006,
    "descripcion":"MARGEN QUIRÚRGICO LATERAL COMPROMETIDO POR CARCINOMA IN SITU"
  },
  {
    "codigo":298218009,
    "descripcion":"LAXITUD DE ARTICULACIÓN DEL PIE"
  },
  {
    "codigo":394687007,
    "descripcion":"BAJO RIESGO DE SUICIDIO"
  },
  {
    "codigo":165311008,
    "descripcion":"CONDUCTA LEVEMENTE ANORMAL"
  },
  {
    "codigo":294548002,
    "descripcion":"ALERGIA A CEFIXIMA"
  },
  {
    "codigo":65172003,
    "descripcion":"PÉNFIGO"
  },
  {
    "codigo":229012002,
    "descripcion":"PENETRACIÓN VAGINAL"
  },
  {
    "codigo":786068005,
    "descripcion":"ÚLCERA PÉPTICA CON OBSTRUCCIÓN"
  },
  {
    "codigo":1179284005,
    "descripcion":"INMUNODEFICIENCIA GRAVE COMBINADA DEBIDO A DEFICIENCIA DE ENLAZADOR DE ACTIVACIÓN DE LINFOCITOS T"
  },
  {
    "codigo":817001000,
    "descripcion":"USO DE CALZADO INADECUADO"
  },
  {
    "codigo":1144681004,
    "descripcion":"APLASIA DE FALANGE MEDIA DE SEGUNDO DEDO DE PIE"
  },
  {
    "codigo":292713005,
    "descripcion":"REACCIÓN ADVERSA AL GEMEPROST"
  },
  {
    "codigo":128873007,
    "descripcion":"SARNA NODULAR"
  },
  {
    "codigo":15704081000119108,
    "descripcion":"CONTRACTURA MUSCULAR BILATERAL DE PIE"
  },
  {
    "codigo":161641009,
    "descripcion":"CON MAYOR RIESGO DE DIABETES MELLITUS"
  },
  {
    "codigo":716862002,
    "descripcion":"ENFERMEDAD SEMEJANTE AL SÍNDROME DE PROTEUS"
  },
  {
    "codigo":94270002,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE CONDUCTO CÍSTICO"
  },
  {
    "codigo":127038008,
    "descripcion":"HEMOGLOBINOPATÍA HEREDITARIA POR MUTACIONES EN LAS CADENAS DE GLOBINA"
  },
  {
    "codigo":782398009,
    "descripcion":"NÓDULO DEL TEJIDO CELULAR SUBCUTÁNEO DE LA MANO"
  },
  {
    "codigo":715027000,
    "descripcion":"DIFICULTAD PARA CAMINAR POR UN CORREDOR"
  },
  {
    "codigo":289043003,
    "descripcion":"INCAPAZ DE UTILIZAR CUBIERTOS PARA ALIMENTARSE"
  },
  {
    "codigo":290878009,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR MOCLOBEMIDA"
  },
  {
    "codigo":34531000087101,
    "descripcion":"LESIONES TRAUMÁTICAS MÚLTIPLES INTRACRANEALES"
  },
  {
    "codigo":26899006,
    "descripcion":"INFERTILIDAD FEMENINA DE ORIGEN UTERINO"
  },
  {
    "codigo":47331000087103,
    "descripcion":"DISTENSIÓN DE TENDÓN DE CUÁDRICEPS IZQUIERDO"
  },
  {
    "codigo":42211000087104,
    "descripcion":"RUPTURA DE LIGAMENTO DE ARTICULACIÓN DE HOMBRO DERECHO"
  },
  {
    "codigo":254440001,
    "descripcion":"SURCO GINGIVOBUCAL MAXILAR"
  },
  {
    "codigo":25064002,
    "descripcion":"CEFALEA"
  },
  {
    "codigo":1237480002,
    "descripcion":"METÁSTASIS DE CARCINOMA DE COLON SIGMOIDE"
  },
  {
    "codigo":39651000087108,
    "descripcion":"DOLOR OROFACIAL CRÓNICO DEBIDO A TRASTORNO INTRACRANEAL NO VASCULAR"
  },
  {
    "codigo":713192002,
    "descripcion":"OLIGOHIDRAMNIOS DEBIDO A RUPTURA DE MEMBRANAS"
  },
  {
    "codigo":385512006,
    "descripcion":"QUEMADURA DE LA PIEL POR ALQUITRÁN CALIENTE"
  },
  {
    "codigo":44771000087108,
    "descripcion":"OCLUSIÓN DE PORCIÓN MEDIA DE RAMA CIRCUNFLEJA DE ARTERIA CORONARIA IZQUIERDA"
  },
  {
    "codigo":187069002,
    "descripcion":"BLASTOMICOSIS PULMONAR AGUDA"
  },
  {
    "codigo":447378002,
    "descripcion":"POLIOMIELITIS PARALÍTICA AGUDA CAUSADA POR POLIOVIRUS HUMANO 3"
  },
  {
    "codigo":283538005,
    "descripcion":"HERIDA PUNZANTE DE PANTORRILLA"
  },
  {
    "codigo":248935000,
    "descripcion":"HALLAZGO RELACIONADO CON EL CONTENIDO DEL CUELLO UTERINO"
  },
  {
    "codigo":185234009,
    "descripcion":"ATENDIDO EN UN CONSULTORIO PEDIÁTRICO"
  },
  {
    "codigo":445543002,
    "descripcion":"UBICACIÓN INTRACARDÍACA DE CONEXIONES VENOSAS PULMONARES ANÓMALAS CON AURÍCULAS ISOMÉRICAS BILATERALES"
  },
  {
    "codigo":609383005,
    "descripcion":"NEURITIS INTERÓSEA ANTERIOR"
  },
  {
    "codigo":52327008,
    "descripcion":"DESPROPORCIÓN FETAL DEBIDA A MIELOMENINGOCELE FETAL"
  },
  {
    "codigo":247100001,
    "descripcion":"NEOVASCULARIZACIÓN RETINIANA PERIFÉRICA"
  },
  {
    "codigo":1230140003,
    "descripcion":"LESIÓN INFLAMATORIA PERIAPICAL DE IMPLANTE DENTAL"
  },
  {
    "codigo":704017007,
    "descripcion":"FRACTURA EXPUESTA DE CUELLO DE SEGUNDO METACARPIANO"
  },
  {
    "codigo":866022001,
    "descripcion":"CATÉTER INTRAESPINAL IN SITU"
  },
  {
    "codigo":472806007,
    "descripcion":"ENDOCARDITIS COMO COMPLICACIÓN DE PROCEDIMIENTO"
  },
  {
    "codigo":208827000,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN RADIOCARPIANA"
  },
  {
    "codigo":896955002,
    "descripcion":"FORMA DE BALA ANORMAL CONGÉNITA DE FALANGE DISTAL DE QUINTO DEDO DE PIE"
  },
  {
    "codigo":307131005,
    "descripcion":"DESGARRO DE MALLORY-WEISS"
  },
  {
    "codigo":700347006,
    "descripcion":"ECTROPIÓN ESPÁSTICO DE PÁRPADO SUPERIOR"
  },
  {
    "codigo":16034271000119105,
    "descripcion":"HIPERTROFIA DE HUESO DE AMBOS TOBILLOS"
  },
  {
    "codigo":43152001,
    "descripcion":"ENFERMEDAD DEL NÚCLEO CENTRAL"
  },
  {
    "codigo":403600002,
    "descripcion":"SENSACIÓN DE HORMIGUEO CUTÁNEO"
  },
  {
    "codigo":733115009,
    "descripcion":"TRASTORNO CONGÉNITO DE GLICOSILACIÓN TIPO 1Y"
  },
  {
    "codigo":272528004,
    "descripcion":"BIPEDESTACIÓN A HORCAJADAS"
  },
  {
    "codigo":10627551000119107,
    "descripcion":"FORÚNCULO DE PULGAR DERECHO"
  },
  {
    "codigo":303461005,
    "descripcion":"CAPAZ DE MANEJAR PRÓTESIS"
  },
  {
    "codigo":8549006,
    "descripcion":"NEUMONITIS INTERSTICIAL DESCAMATIVA"
  },
  {
    "codigo":237925006,
    "descripcion":"TRIPTOFANEMIA"
  },
  {
    "codigo":301626001,
    "descripcion":"INCAPAZ DE USAR ASCENSOR DE ESCALERAS"
  },
  {
    "codigo":236090001,
    "descripcion":"FILTRACIÓN POR ANASTOMOSIS DE INTESTINO DELGADO"
  },
  {
    "codigo":170554003,
    "descripcion":"ACONSEJADO ACERCA DE GRUPO DE AUTOAYUDA"
  },
  {
    "codigo":365327004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA LIMPIAR LA OLLA PARA COCINAR"
  },
  {
    "codigo":1217295005,
    "descripcion":"INFECCIÓN DE CORAZÓN CAUSADA POR SALMONELLA ENTERICA ENTERICA SEROVARIEDAD TYPHI"
  },
  {
    "codigo":267023007,
    "descripcion":"INGESTIÓN EXCESIVA"
  },
  {
    "codigo":297956000,
    "descripcion":"TURGENCIA CUTÁNEA NORMAL"
  },
  {
    "codigo":363492001,
    "descripcion":"NEOPLASIA MALIGNA DE PERITONEO"
  },
  {
    "codigo":232420002,
    "descripcion":"ADENOIDITIS CRÓNICA"
  },
  {
    "codigo":299791007,
    "descripcion":"OJO QUE SE DESPLAZA EN DIRECCIÓN AL SONIDO, DUDOSO"
  },
  {
    "codigo":396260003,
    "descripcion":"MARGEN QUIRÚRGICO EXOCERVICAL COMPROMETIDO POR NEOPLASIA MALIGNA, DE MANERA FOCAL"
  },
  {
    "codigo":15680121000119106,
    "descripcion":"CONJUNTIVITIS DE OJO DERECHO CAUSADA POR CHLAMYDIA TRACHOMATIS"
  },
  {
    "codigo":3044008,
    "descripcion":"PROLAPSO VÍTREO"
  },
  {
    "codigo":723940009,
    "descripcion":"HIPOHIDROSIS CONCOMITANTE CON TRASTORNO DEL SISTEMA NERVIOSO AUTÓNOMO Y DEBIDA A ÉL"
  },
  {
    "codigo":722105002,
    "descripcion":"SÍNDROME OROFACIAL DIGITAL TIPO 5"
  },
  {
    "codigo":16908921000119107,
    "descripcion":"DERMATOFIBROMA DE PIEL DE PÁRPADO SUPERIOR DERECHO"
  },
  {
    "codigo":230585004,
    "descripcion":"NEUROPATÍA ASOCIADA CON DISPROTEINEMIAS"
  },
  {
    "codigo":296121005,
    "descripcion":"SOBREDOSIS DE LORAZEPAM"
  },
  {
    "codigo":197817006,
    "descripcion":"ADHERENCIAS DE RIÑÓN"
  },
  {
    "codigo":334611000119102,
    "descripcion":"ANILLO DE KAYSER-FLEISCHER DE OJO DERECHO"
  },
  {
    "codigo":64910008,
    "descripcion":"TRASTORNO DE TESTÍCULO"
  },
  {
    "codigo":423523001,
    "descripcion":"INHIBICIÓN DE ENZIMA DE CITOCROMO P450 POR SUSTANCIA"
  },
  {
    "codigo":1144419002,
    "descripcion":"IRIDOCICLITIS SUBAGUDA"
  },
  {
    "codigo":292451006,
    "descripcion":"REACCIÓN ADVERSA A LA NICOTINA"
  },
  {
    "codigo":95843009,
    "descripcion":"HIPOPLASMINOGENEMIA ADQUIRIDA"
  },
  {
    "codigo":94008001,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE PIEL DE TOBILLO"
  },
  {
    "codigo":126776002,
    "descripcion":"NEOPLASIA DE LA CARA INTERNA DE LABIO INFERIOR"
  },
  {
    "codigo":571000124100,
    "descripcion":"REQUIERE EDUCACIÓN ADICIONAL SOBRE DIÁLISIS PERITONEAL"
  },
  {
    "codigo":290616002,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR ESTRAMUSTINA"
  },
  {
    "codigo":440891000124106,
    "descripcion":"INGESTA INADECUADA DE MOLIBDENO"
  },
  {
    "codigo":92173005,
    "descripcion":"NEOPLASIA BENIGNA DE LA COMISURA DE LA LARINGE"
  },
  {
    "codigo":90338005,
    "descripcion":"FRACTURA TRIMALEOLAR EXPUESTA"
  },
  {
    "codigo":416183002,
    "descripcion":"INCLINACIÓN PÉLVICA"
  },
  {
    "codigo":55735004,
    "descripcion":"INFECCIÓN POR VIRUS RESPIRATORIO SINCICIAL"
  },
  {
    "codigo":186807008,
    "descripcion":"LEISHMANIASIS CUTÁNEA DEL DESIERTO ASIÁTICO"
  },
  {
    "codigo":840332001,
    "descripcion":"MATIDEZ SOBRE MASA ABDOMINAL"
  },
  {
    "codigo":283276003,
    "descripcion":"VIDRIO EN LA PLANTA DEL PIE"
  },
  {
    "codigo":15954861000119106,
    "descripcion":"MAMA DERECHA PÉNDULA"
  },
  {
    "codigo":445281006,
    "descripcion":"EDEMA BLANDO CON FÓVEA"
  },
  {
    "codigo":707425008,
    "descripcion":"CARCINOMA ADENOIDE PRIMARIO DE LARINGE, DE CÉLULAS ESCAMOSAS"
  },
  {
    "codigo":281441009,
    "descripcion":"AFLOJAMIENTO DE COMPONENTE GLENOIDEO EN REEMPLAZO TOTAL DE HOMBRO"
  },
  {
    "codigo":312374002,
    "descripcion":"SEUDOANEURISMA FEMORAL POSRADIOLÓGICO"
  },
  {
    "codigo":771126002,
    "descripcion":"INFECCIÓN CAUSADA POR TOXOPLASMA GONDII CONCOMITANTE CON SÍNDROME DE INMUNODEFICIENCIA ADQUIRIDA"
  },
  {
    "codigo":246838007,
    "descripcion":"EXCESO DE GRASA ORBITARIA"
  },
  {
    "codigo":82998009,
    "descripcion":"TRASTORNO BIPOLAR I MANÍACO MODERADO"
  },
  {
    "codigo":1162507002,
    "descripcion":"PERFORACIÓN DE PARED CARDÍACA DEBIDA A PROCEDIMIENTO Y POSTERIOR A ÉL"
  },
  {
    "codigo":117831000119104,
    "descripcion":"LESIÓN DE IRIS"
  },
  {
    "codigo":736523005,
    "descripcion":"CON MAYOR RIESGO DE COMPLICACIÓN DE ANESTESIA"
  },
  {
    "codigo":408843005,
    "descripcion":"PRUEBA PARA CRIBADO PRENATAL DE TALASEMIA EN SANGRE SOLICITADA"
  },
  {
    "codigo":48395006,
    "descripcion":"PARA 2"
  },
  {
    "codigo":212235008,
    "descripcion":"LESIÓN EXPUESTA DEL PLEXO SACRO"
  },
  {
    "codigo":310539009,
    "descripcion":"PESO DE NACIMIENTO MAYOR DE 2,5 KG"
  },
  {
    "codigo":439776006,
    "descripcion":"NEOPLASIA MALIGNA DETECTADA POR EXTENDIDO CERVICAL DE PAPANICOLAOU"
  },
  {
    "codigo":274101000,
    "descripcion":"TROMBOEMBOLIA AÓRTICA"
  },
  {
    "codigo":110261002,
    "descripcion":"CONTUSIÓN OROFARÍNGEA"
  },
  {
    "codigo":77493009,
    "descripcion":"FRACTURA DE PELVIS"
  },
  {
    "codigo":11832391000119109,
    "descripcion":"LACERACIÓN DE VASO SANGUÍNEO DE ÍNDICE IZQUIERDO"
  },
  {
    "codigo":698250005,
    "descripcion":"BLOQUEO CARDÍACO FAMILIAR PROGRESIVO, TIPO IB"
  },
  {
    "codigo":403338006,
    "descripcion":"CAMBIO DE COLORACIÓN DEL PELO POR SUSTANCIA QUÍMICA"
  },
  {
    "codigo":237663000,
    "descripcion":"HIPERPROLACTINEMIA IDIOPÁTICA"
  },
  {
    "codigo":434271002,
    "descripcion":"RECHAZO CRÓNICO DE TRASPLANTE DE PÁNCREAS"
  },
  {
    "codigo":8287004,
    "descripcion":"MASTITIS ESTAFILOCÓCICA"
  },
  {
    "codigo":203060003,
    "descripcion":"CONTRACTURA DEL MÚSCULO TRÍCEPS"
  },
  {
    "codigo":1153332006,
    "descripcion":"GOTA CRÓNICA POLIARTICULAR CAUSADA POR PLOMO"
  },
  {
    "codigo":301364008,
    "descripcion":"DOLOR EN PIEL"
  },
  {
    "codigo":235828008,
    "descripcion":"PSEUDO-OBSTRUCCIÓN INTESTINAL CRÓNICA"
  },
  {
    "codigo":71988008,
    "descripcion":"SÍNDROME DE AASE"
  },
  {
    "codigo":70153002,
    "descripcion":"HEMORROIDES"
  },
  {
    "codigo":6452009,
    "descripcion":"FIEBRE POR GARRAPATAS DE COLORADO"
  },
  {
    "codigo":365065004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA PRESUPONER DURANTE LA CONVERSACIÓN"
  },
  {
    "codigo":233993008,
    "descripcion":"DISECCIÓN DE ARTERIA ESPINAL ANTERIOR"
  },
  {
    "codigo":168457008,
    "descripcion":"ANATOMÍA PATOLÓGICA MACROSCÓPICA - NO SE DETECTARON ANOMALÍAS"
  },
  {
    "codigo":2782002,
    "descripcion":"DISPLASIA TEMPOROMANDIBULAR"
  },
  {
    "codigo":68318002,
    "descripcion":"DESTRUCCIÓN DE PLAQUETAS DISMINUIDA"
  },
  {
    "codigo":102921008,
    "descripcion":"TOXICOFOBIA"
  },
  {
    "codigo":263091001,
    "descripcion":"FRACTURA-LUXACIÓN DE ARTICULACIÓN DE TOBILLO"
  },
  {
    "codigo":721843003,
    "descripcion":"SÍNDROME DE RETRASO DEL CRECIMIENTO, ALOPECIA, PSEUDOANODONCIA Y ATROFIA ÓPTICA"
  },
  {
    "codigo":15960701000119100,
    "descripcion":"ANGINA DE PECHO DEBIDA A ARTERIOSCLEROSIS EN INJERTO-PUENTE DE ARTERIA CORONARIA EN CORAZÓN TRASPLANTADO"
  },
  {
    "codigo":334461000119101,
    "descripcion":"ESTENOSIS DE PUNTO LAGRIMAL DE PÁRPADO DERECHO"
  },
  {
    "codigo":15932541000119102,
    "descripcion":"PROLAPSO DE TROMPA DE FALOPIO IZQUIERDA"
  },
  {
    "codigo":298621000119103,
    "descripcion":"OSTEONECROSIS DE DEDO DEL PIE CAUSADA POR FÁRMACO"
  },
  {
    "codigo":12107901000119103,
    "descripcion":"QUEMADURA DE REGIÓN LUMBAR"
  },
  {
    "codigo":11828861000119105,
    "descripcion":"AMPOLLA DE RODILLA DERECHA, CON INFECCIÓN"
  },
  {
    "codigo":78461000119105,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS METASTÁSICO DE PIEL"
  },
  {
    "codigo":12246141000119105,
    "descripcion":"LINFOCELE DEBIDO A PROCEDIMIENTO Y POSTERIOR A ÉL"
  },
  {
    "codigo":10850941000119106,
    "descripcion":"ASPIRACIÓN DE CONTENIDO GÁSTRICO HACIA LARINGE"
  },
  {
    "codigo":15919741000119109,
    "descripcion":"ANAFILAXIA CAUSADA POR MEDIO DE CONTRASTE"
  },
  {
    "codigo":15927421000119105,
    "descripcion":"SINQUINESIA DE PÁRPADO INFERIOR DERECHO"
  },
  {
    "codigo":294024003,
    "descripcion":"ALERGIA A AGONISTA DE RECEPTOR ALFA-ADRENÉRGICO"
  },
  {
    "codigo":285821000119105,
    "descripcion":"LACERACIÓN MAYOR DE CORAZÓN CONCOMITANTE CON HEMOPERICARDIO"
  },
  {
    "codigo":331901000119107,
    "descripcion":"QUERATOCONJUNTIVITIS LÍMBICA SUPERIOR DE OJO DERECHO"
  },
  {
    "codigo":134781000119106,
    "descripcion":"EMBARAZO DE ALTO RIESGO DEBIDO A ABORTOS ESPONTÁNEOS RECURRENTES"
  },
  {
    "codigo":352381000119106,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE PIEL DE EXTREMIDAD SUPERIOR IZQUIERDA"
  },
  {
    "codigo":423261004,
    "descripcion":"OBLICUIDAD PÉLVICA ADQUIRIDA"
  },
  {
    "codigo":128349005,
    "descripcion":"PALATITIS"
  },
  {
    "codigo":193885005,
    "descripcion":"DEGENERACIONES Y DEPÓSITOS CONJUNTIVALES"
  },
  {
    "codigo":292189006,
    "descripcion":"REACCIÓN ADVERSA A LA AMIFOSTINA"
  },
  {
    "codigo":1142322000,
    "descripcion":"ATROFIA MUSCULAR NO PROGRESIVA"
  },
  {
    "codigo":716338001,
    "descripcion":"SÍNDROME DE PSEUDOHIPERTROFIA MUSCULAR E HIPOTIROIDISMO"
  },
  {
    "codigo":161117005,
    "descripcion":"GUARDERÍA INFANTIL"
  },
  {
    "codigo":95581005,
    "descripcion":"HIDRONEFROSIS BILATERAL"
  },
  {
    "codigo":126514006,
    "descripcion":"NEOPLASIA DE LA PIEL PERIANAL"
  },
  {
    "codigo":290354006,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR CIMETIDINA"
  },
  {
    "codigo":93746009,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL CEREBELO"
  },
  {
    "codigo":91911004,
    "descripcion":"AUSENCIA CONGÉNITA DE HUESO SUPRAOCCIPITAL"
  },
  {
    "codigo":124679004,
    "descripcion":"DEFICIENCIA DE METILASPARTATO MUTASA"
  },
  {
    "codigo":386823006,
    "descripcion":"REACCIÓN ADAPTATIVA DE LA EDAD ADULTA"
  },
  {
    "codigo":288519004,
    "descripcion":"QUEMADURA CON COMPROMISO DE 1% DE LA SUPERFICIE CORPORAL"
  },
  {
    "codigo":286684000,
    "descripcion":"REACCIÓN-FORMACIÓN - MECANISMO DE DEFENSA PSICOLÓGICA"
  },
  {
    "codigo":712668002,
    "descripcion":"ANTÍGENO DE CAMPYLOBACTER POSITIVO"
  },
  {
    "codigo":1236956002,
    "descripcion":"METÁSTASIS DE CARCINOMA DE FRENILLO LABIAL INFERIOR"
  },
  {
    "codigo":1204188007,
    "descripcion":"OCLUSIÓN DE ARTERIA VERTEBRAL EXTRACRANEAL ASINTOMÁTICA"
  },
  {
    "codigo":253916007,
    "descripcion":"MÚSCULO ABERRANTE DE LA EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":55473001,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":284849000,
    "descripcion":"NO LIMPIA SUS PRÓTESIS DENTALES"
  },
  {
    "codigo":15986351000119102,
    "descripcion":"DEGENERACIÓN CORIORRETINIANA CONGÉNITA BILATERAL"
  },
  {
    "codigo":250246001,
    "descripcion":"CÉLULAS DE SPUTNIK"
  },
  {
    "codigo":1003910002,
    "descripcion":"DELECIÓN PROXIMAL DEL BRAZO CORTO DEL CROMOSOMA 8"
  },
  {
    "codigo":283014003,
    "descripcion":"HIPERPLASIA DE APÓFISIS CONDÍLEA MANDIBULAR"
  },
  {
    "codigo":86406008,
    "descripcion":"INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":414086009,
    "descripcion":"EMBOLIA"
  },
  {
    "codigo":248411002,
    "descripcion":"PIGMENTACIÓN ADDISONIANA DE LAS PALMAS"
  },
  {
    "codigo":53638009,
    "descripcion":"ABORTO TERAPÉUTICO"
  },
  {
    "codigo":1296987003,
    "descripcion":"CIERRE DE ÁNGULO AGUDO PRIMARIO DE OJO DERECHO"
  },
  {
    "codigo":1264219008,
    "descripcion":"INFECCIÓN NEONATAL PRECOZ CAUSADA POR BACTERIA ANAEROBIA"
  },
  {
    "codigo":1196848001,
    "descripcion":"LINFANGIOMA DE APÉNDICE"
  },
  {
    "codigo":49968000,
    "descripcion":"TOXICOSIS POR ASPERGILLUS VERSICOLOR"
  },
  {
    "codigo":312112002,
    "descripcion":"CARCINOMA DE COLON TRANSVERSO"
  },
  {
    "codigo":11781961000119100,
    "descripcion":"RUPTURA TRAUMÁTICA DE RODETE COTILOIDEO DERECHO"
  },
  {
    "codigo":80901002,
    "descripcion":"ENDOFLEBITIS DE LA PRENSA DE HERÓFILO"
  },
  {
    "codigo":408581006,
    "descripcion":"META DE LA ACTIVIDAD FÍSICA: EJERCICIO MODERADO"
  },
  {
    "codigo":46298002,
    "descripcion":"ENVENENAMIENTO DEBIDO A PICADURA DE AVISPÓN"
  },
  {
    "codigo":13530005,
    "descripcion":"LOBULACIÓN CONGÉNITA DEL RIÑÓN"
  },
  {
    "codigo":313161000119103,
    "descripcion":"MANO HENDIDA DERECHA"
  },
  {
    "codigo":67401000119103,
    "descripcion":"LESIÓN DE COLON"
  },
  {
    "codigo":898266009,
    "descripcion":"ANQUILOSIS CONGÉNITA DE ARTICULACIÓN INTERFALÁNGICA PROXIMAL DE DEDO ANULAR"
  },
  {
    "codigo":404911003,
    "descripcion":"CAÍDAS RECURRENTES INEXPLICADAS"
  },
  {
    "codigo":60680007,
    "descripcion":"DUPLICACIÓN DEL DUODENO"
  },
  {
    "codigo":372143007,
    "descripcion":"CARCINOMA DE ESTÓMAGO"
  },
  {
    "codigo":208303009,
    "descripcion":"FRACTURA EXPUESTA DE CÚBITO PROXIMAL, CONMINUTA"
  },
  {
    "codigo":302937000,
    "descripcion":"ENTESOPATÍA DE PIERNA Y TOBILLO"
  },
  {
    "codigo":15714121000119107,
    "descripcion":"DEFORMIDAD EN VALGO DE DEDO GORDO IZQUIERDO ADQUIRIDA DEBIDA A METATARSO PRIMUS VARO"
  },
  {
    "codigo":366638002,
    "descripcion":"HALLAZGO RELACIONADO CON AMPLITUD DE INVERSIÓN DE ARTICULACIÓN SUBASTRAGALINA"
  },
  {
    "codigo":1251374005,
    "descripcion":"URTICARIA AGUDA POR PSEUDOALERGIA"
  },
  {
    "codigo":399406009,
    "descripcion":"NIVEL SÉRICO DE MARCADOR TUMORAL DENTRO DE LÍMITES NORMALES"
  },
  {
    "codigo":200963002,
    "descripcion":"PSORIASIS CIRCINADA"
  },
  {
    "codigo":233731003,
    "descripcion":"NEUMONITIS TRAUMÁTICA"
  },
  {
    "codigo":364803003,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA TRAGAR SALIVA"
  },
  {
    "codigo":102659003,
    "descripcion":"NIVEL DE GLUCOSA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":397571007,
    "descripcion":"QUERATITIS ESTROMAL NECROSANTE POR HERPES SIMPLE"
  },
  {
    "codigo":231896005,
    "descripcion":"QUERATITIS POR ACANTHAMOEBA"
  },
  {
    "codigo":362968007,
    "descripcion":"TRASTORNO DEL APARATO REPRODUCTOR"
  },
  {
    "codigo":788952008,
    "descripcion":"FIEBRE HEMORRÁGICA CAUSADA POR VIRUS ALKHURMA"
  },
  {
    "codigo":426669001,
    "descripcion":"ELECTROCARDIOGRAMA: LATIDOS ECTÓPICOS CON CONTRACCIONES VENTRICULARES PREMATURAS UNIFOCALES"
  },
  {
    "codigo":721581002,
    "descripcion":"NEOPLASIA FIBROHISTIOCÍTICA BENIGNA"
  },
  {
    "codigo":295597003,
    "descripcion":"SOBREDOSIS DE FÁRMACO ANTINEOPLÁSICO"
  },
  {
    "codigo":197293003,
    "descripcion":"CIRROSIS NODULAR DIFUSA"
  },
  {
    "codigo":262829000,
    "descripcion":"LACERACIÓN DEL PARÉNQUIMA PANCREÁTICO"
  },
  {
    "codigo":361133006,
    "descripcion":"ARTERIOSCLEROSIS OBLITERANTE"
  },
  {
    "codigo":342141000119102,
    "descripcion":"IRITIS AGUDA DE OJO IZQUIERDO"
  },
  {
    "codigo":293762001,
    "descripcion":"ALERGIA A MITOMICINA"
  },
  {
    "codigo":457602002,
    "descripcion":"OCLUSIÓN DE VENA FEMORAL"
  },
  {
    "codigo":64386003,
    "descripcion":"PATRÓN DE USO NOCIVO DE SEDANTE"
  },
  {
    "codigo":719746004,
    "descripcion":"CAPAZ DE SUBIR Y BAJAR ESCALONES INTERNOS"
  },
  {
    "codigo":1342338008,
    "descripcion":"SEPSIS CAUSADA POR CATÉTER VENOSO CENTRAL IN SITU"
  },
  {
    "codigo":95319004,
    "descripcion":"NÓDULO DE PIEL"
  },
  {
    "codigo":717911008,
    "descripcion":"SÍNDROME BLEFAROQUEILODÓNCICO"
  },
  {
    "codigo":290092002,
    "descripcion":"PEZÓN HIPOPIGMENTADO"
  },
  {
    "codigo":10637591000119100,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN EN GLÚTEO NO ESTADIFICABLE"
  },
  {
    "codigo":58881007,
    "descripcion":"PÓLIPO DEL CUELLO UTERINO, QUE AFECTA EL EMBARAZO"
  },
  {
    "codigo":15634711000119102,
    "descripcion":"MASA DE OVARIO DERECHO"
  },
  {
    "codigo":419329009,
    "descripcion":"VISIÓN A DISTANCIA 6\/45"
  },
  {
    "codigo":1079421000119109,
    "descripcion":"FEOCROMOCITOMA BENIGNO DE GLÁNDULA SUPRARRENAL DERECHA"
  },
  {
    "codigo":253654005,
    "descripcion":"CAYADO AÓRTICO DERECHO Y AORTA DESCENDENTE DERECHA"
  },
  {
    "codigo":1269462009,
    "descripcion":"ADENOMA BENIGNO DE ESTÓMAGO"
  },
  {
    "codigo":415659002,
    "descripcion":"PLAN DE TRATAMIENTO CLÍNICO PARA ABUSO DE SUSTANCIAS, ACORDADO"
  },
  {
    "codigo":87979003,
    "descripcion":"FISURA PALATINA"
  },
  {
    "codigo":22443004,
    "descripcion":"ATAXIA VESTIBULOCEREBELOSA"
  },
  {
    "codigo":284587004,
    "descripcion":"ASTILLA DE MADERA EN LA MEJILLA"
  },
  {
    "codigo":251819007,
    "descripcion":"ESTADIO 2 DE DESARROLLO DE VELLO PÚBICO DE TANNER"
  },
  {
    "codigo":710571007,
    "descripcion":"DISPLASIA RENAL DEBIDA A EXPOSICIÓN FETAL A INHIBIDOR DE ENZIMA CONVERTIDORA DE ANGIOTENSINA"
  },
  {
    "codigo":282752000,
    "descripcion":"LESIÓN TRAUMÁTICA DE REGIÓN OCULAR"
  },
  {
    "codigo":249984002,
    "descripcion":"PIERDE EL EQUILIBRIO CONTINUAMENTE"
  },
  {
    "codigo":55211008,
    "descripcion":"ALTERACIÓN EN EL TRANSPORTE INTESTINAL DE CARBOHIDRATOS A TRAVÉS DE LAS CÉLULAS EPITELIALES"
  },
  {
    "codigo":20608001,
    "descripcion":"DESINCRONIZACIÓN DEL BIORRITMO"
  },
  {
    "codigo":315520001,
    "descripcion":"NACIDO EN ESLOVAQUIA"
  },
  {
    "codigo":18773000,
    "descripcion":"SÍNDROME DE VÓMITO CÍCLICO"
  },
  {
    "codigo":1231189004,
    "descripcion":"IPSIPULSIÓN OCULAR"
  },
  {
    "codigo":248149005,
    "descripcion":"ROSTRO INEXPRESIVO"
  },
  {
    "codigo":1263957007,
    "descripcion":"HEMORRAGIA INTRAVENTRICULAR NO TRAUMÁTICA DE FETO Y\/O NEONATO"
  },
  {
    "codigo":15690161000119102,
    "descripcion":"ARTRITIS DE ARTICULACIÓN DE AMBOS TOBILLOS CAUSADA POR BACTERIA"
  },
  {
    "codigo":705066004,
    "descripcion":"DISECCIÓN DE ARTERIA CARÓTIDA INTERNA"
  },
  {
    "codigo":770602005,
    "descripcion":"CARCINOMA ESCAMOCELULAR DE PÁNCREAS EXOCRINO"
  },
  {
    "codigo":49706007,
    "descripcion":"ACNÉ NEONATAL"
  },
  {
    "codigo":279082008,
    "descripcion":"GRUPO DE DISPLASIAS ACROMESOMÉLICAS"
  },
  {
    "codigo":211711000,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO PROFUNDA DE MEJILLA"
  },
  {
    "codigo":703231005,
    "descripcion":"HIPERALDOSTERONISMO FAMILIAR"
  },
  {
    "codigo":277247007,
    "descripcion":"DOLOR A LA PALPACIÓN EN LARINGE"
  },
  {
    "codigo":275412000,
    "descripcion":"CISTITIS DEL EMBARAZO"
  },
  {
    "codigo":441087007,
    "descripcion":"CÉLULAS ESCAMOSAS ATÍPICAS DE SIGNIFICACIÓN INDETERMINADA EN EL EXTENDIDO DE PAPANICOLAOU CERVICAL"
  },
  {
    "codigo":373716002,
    "descripcion":"FRACTURA NO EXPUESTA CON COMPROMISO ARTICULAR"
  },
  {
    "codigo":111572002,
    "descripcion":"TALASEMIA BETA CERO TIPO NO DELECIÓN"
  },
  {
    "codigo":766932005,
    "descripcion":"HAMARTOMA HIPOTALÁMICO CON CRISIS GELÁSTICAS"
  },
  {
    "codigo":344651000119100,
    "descripcion":"ÚLCERA DE CÓRNEA PERFORADA DE AMBOS OJOS"
  },
  {
    "codigo":240809001,
    "descripcion":"PARAGOMINIASIS EXTRAPULMONAR"
  },
  {
    "codigo":404649002,
    "descripcion":"MIDRIASIS TRAUMÁTICA"
  },
  {
    "codigo":44201003,
    "descripcion":"MENINGITIS CAUSADA POR VIRUS DE LA PAROTIDITIS URLIANA"
  },
  {
    "codigo":11433004,
    "descripcion":"FÍSTULA CONGÉNITA DE ARTERIA CORONARIA"
  },
  {
    "codigo":109737009,
    "descripcion":"CONTORNO GINGIVAL EXCESIVO EN UNA RESTAURACIÓN DENTAL"
  },
  {
    "codigo":271742008,
    "descripcion":"MEMBRANA TIMPÁNICA ABOMBADA"
  },
  {
    "codigo":238974009,
    "descripcion":"DELIRIO DE INFESTACIÓN"
  },
  {
    "codigo":335443002,
    "descripcion":"CANTIDAD NORMAL DE DIENTES"
  },
  {
    "codigo":40531004,
    "descripcion":"DEFORMIDAD DE LA MUÑECA EN VARO ADQUIRIDA"
  },
  {
    "codigo":7763004,
    "descripcion":"DICÉFALO DIPUS TRIBRAQUIO"
  },
  {
    "codigo":237139007,
    "descripcion":"INFERTILIDAD EN LA MUJER POR TRASTORNO OVULATORIO"
  },
  {
    "codigo":106067008,
    "descripcion":"RITMO DEL NODO SINUSAL"
  },
  {
    "codigo":71464000,
    "descripcion":"DIPIGO"
  },
  {
    "codigo":366376004,
    "descripcion":"REFLEJO DE PESTAÑEO- HALLAZGO"
  },
  {
    "codigo":399144008,
    "descripcion":"DIABETES BRONCEADA"
  },
  {
    "codigo":167933003,
    "descripcion":"MÉDULA ÓSEA: LINFOCITOS"
  },
  {
    "codigo":299005004,
    "descripcion":"AMPLITUD DE PRONACIÓN ACTIVA DE LA MUÑECA AUMENTADA"
  },
  {
    "codigo":724989008,
    "descripcion":"EPILEPSIA CONCOMITANTE CON ESCLEROSIS MESIAL TEMPORAL Y DEBIDA A ELLA"
  },
  {
    "codigo":318181000119102,
    "descripcion":"TENDINITIS DE TIBIAL POSTERIOR DERECHO"
  },
  {
    "codigo":723154002,
    "descripcion":"PÉRDIDA POR DERIVACIÓN VENTRICULAR POST-CEREBRAL"
  },
  {
    "codigo":1149138003,
    "descripcion":"INTOXICACIÓN POR OXAZOLIDINA"
  },
  {
    "codigo":65959000,
    "descripcion":"TALASEMIA BETA"
  },
  {
    "codigo":786855003,
    "descripcion":"LINFOCITOSIS MONOCLONAL DE LINFOCITOS B TIPO LEUCEMIA LINFOCÍTICA CRÓNICA"
  },
  {
    "codigo":459175006,
    "descripcion":"ABSCESO DE VÁLVULA AURICULOVENTRICULAR IZQUIERDA (MORFOLÓGICAMENTE NO MITRAL)"
  },
  {
    "codigo":721319008,
    "descripcion":"FRACTURA DE CÓNDILO OCCIPITAL DEL CRÁNEO TIPO I"
  },
  {
    "codigo":162428001,
    "descripcion":"SÍNTOMA: REGIÓN GENITAL"
  },
  {
    "codigo":426407008,
    "descripcion":"FÍSTULA DE ARTICULACIÓN DE CODO"
  },
  {
    "codigo":295335009,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE COMPUESTO CON BISMUTO"
  },
  {
    "codigo":129660004,
    "descripcion":"INTOXICACIÓN CAUSADA POR L-ASPARAGINASA"
  },
  {
    "codigo":1145468005,
    "descripcion":"APLASIA DE HUESO DE SACRO"
  },
  {
    "codigo":31356004,
    "descripcion":"INFERTILIDAD DEBIDA A DESCAMACIÓN DE CÉLULAS GERMINALES"
  },
  {
    "codigo":291665000,
    "descripcion":"HEMORRAGIA HIPOFISARIA POSTPARTO"
  },
  {
    "codigo":293500009,
    "descripcion":"REACCIÓN ADVERSA A INHIBIDOR DE LA ENZIMA CONVERTIDORA DE ANGIOTENSINA"
  },
  {
    "codigo":783185002,
    "descripcion":"COLITIS FOCAL ACTIVA"
  },
  {
    "codigo":226129003,
    "descripcion":"DIETA CON BAJO CONTENIDO DE SACAROSA"
  },
  {
    "codigo":15964901000119107,
    "descripcion":"ALETEO AURICULAR ATÍPICO"
  },
  {
    "codigo":95057005,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA PIEL DE LA OREJA"
  },
  {
    "codigo":160593006,
    "descripcion":"CONSUMO DE ALCOHOL DENTRO DE LÍMITES RAZONABLES"
  },
  {
    "codigo":60454001,
    "descripcion":"ESOFAGITIS CAUSADA POR QUINIDINA"
  },
  {
    "codigo":289830002,
    "descripcion":"PROBLEMA DEL CUELLO UTERINO"
  },
  {
    "codigo":93222003,
    "descripcion":"MELANOMA MALIGNO DE PIEL DE CONDUCTO AUDITIVO EXTERNO"
  },
  {
    "codigo":191526005,
    "descripcion":"TRASTORNOS ESQUIZOFRÉNICOS"
  },
  {
    "codigo":224294005,
    "descripcion":"SIN EDUCACIÓN FORMAL"
  },
  {
    "codigo":124155000,
    "descripcion":"DEFICIENCIA DE ALDEHÍDO DESHIDROGENASA (NAD^+^)"
  },
  {
    "codigo":253392000,
    "descripcion":"AUSENCIA CONGÉNITA DE MÚSCULO PAPILAR DE VÁLVULA TRICÚSPIDE"
  },
  {
    "codigo":347161000119100,
    "descripcion":"DEFECTO ARQUEADO DE CAMPO VISUAL DE AMBOS OJOS"
  },
  {
    "codigo":286160009,
    "descripcion":"CAPAZ DE LIMPIAR EL LAVABO"
  },
  {
    "codigo":22181003,
    "descripcion":"DIPLOACUSIA"
  },
  {
    "codigo":1300133004,
    "descripcion":"SÍNDROME SIMILAR AL DE BOHRING-OPITZ RELACIONADO CON EL GEN KLHL7 (MIEMBRO 7 DE LA FAMILIA TIPO KELCH)"
  },
  {
    "codigo":251557004,
    "descripcion":"TAQUEODISPERSIÓN DE ONDA F AUMENTADA"
  },
  {
    "codigo":774010000,
    "descripcion":"CICATRIZ MACULAR DE OJO IZQUIERDO"
  },
  {
    "codigo":284325008,
    "descripcion":"INCAPAZ DE GOLPEAR OBJETOS ENTRE SÍ"
  },
  {
    "codigo":448165009,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS ORIGINADO EN ÚLCERA CRÓNICA"
  },
  {
    "codigo":315258003,
    "descripcion":"FORMACIÓN DE COSTRA EN LESIÓN CUTÁNEA PIGMENTADA"
  },
  {
    "codigo":101401000119103,
    "descripcion":"GRANULOMA PULMONAR"
  },
  {
    "codigo":249722006,
    "descripcion":"MOVIMIENTO NO CORRIGE LA DEFORMIDAD DE LA COLUMNA VERTEBRAL"
  },
  {
    "codigo":708474007,
    "descripcion":"ORTOQUERATOSIS"
  },
  {
    "codigo":282490007,
    "descripcion":"NO CORRE PENDIENTE ARRIBA"
  },
  {
    "codigo":247887003,
    "descripcion":"INCAPAZ DE RESISTIR PENSAMIENTOS OBSESIVOS"
  },
  {
    "codigo":313423004,
    "descripcion":"CON MAYOR RIESGO DE OSTEOPOROSIS"
  },
  {
    "codigo":1263695004,
    "descripcion":"TRASTORNO NEONATAL PRECOZ DEBIDO A EMBARAZO DE TRILLIZOS"
  },
  {
    "codigo":156077081000119105,
    "descripcion":"INFECCIÓN DE CÓRNEA TRASPLANTADA DE OJO DERECHO"
  },
  {
    "codigo":82212003,
    "descripcion":"EROSIÓN DE LOS DIENTES"
  },
  {
    "codigo":1163556006,
    "descripcion":"AGENESIA DE VÉRTEBRA CERVICAL"
  },
  {
    "codigo":702969000,
    "descripcion":"REACTIVACIÓN DE HEPATITIS C"
  },
  {
    "codigo":47609003,
    "descripcion":"CUERPO EXTRAÑO EN EL ESÓFAGO"
  },
  {
    "codigo":309753005,
    "descripcion":"HERNIA DE HIATO CON OBSTRUCCIÓN"
  },
  {
    "codigo":15748121000119108,
    "descripcion":"MASA DE ARTICULACIÓN DE PIE IZQUIERDO"
  },
  {
    "codigo":735737009,
    "descripcion":"INFECCIÓN PERINATAL CAUSADA POR VIRUS HERPES SIMPLE HUMANO"
  },
  {
    "codigo":111310003,
    "descripcion":"SÍNDROME DEL CROMOSOMA 11 EN ANILLO"
  },
  {
    "codigo":240547000,
    "descripcion":"FARINGITIS LINFONODULAR POR COXSACKIE"
  },
  {
    "codigo":699299001,
    "descripcion":"NEUROFERRITINOPATÍA"
  },
  {
    "codigo":209614009,
    "descripcion":"DESGARRO COMPLETO DE DEDO, ARTICULACIÓN METACARPOFALÁNGICA, LIGAMENTO LATERAL CUBITAL"
  },
  {
    "codigo":109475005,
    "descripcion":"AMELOGÉNESIS IMPERFECTA, TIPO HIPOMADURACIÓN"
  },
  {
    "codigo":369784001,
    "descripcion":"MENOS DE 10 MITOSIS POR 10 CAMPOS DE GRAN AUMENTO (PUNTAJE = 1)"
  },
  {
    "codigo":304248001,
    "descripcion":"INADECUADO PARA UN PUESTO EN PARTICULAR"
  },
  {
    "codigo":402552003,
    "descripcion":"NEVO MELANOCÍTICO COMBINADO"
  },
  {
    "codigo":238712007,
    "descripcion":"LENTIGINOSIS SOLAR"
  },
  {
    "codigo":1187149000,
    "descripcion":"AMILOIDOSIS CARDÍACA HEREDITARIA LOCALIZADA"
  },
  {
    "codigo":171341000,
    "descripcion":"EXAMEN ESPECIAL - ANOMALÍA"
  },
  {
    "codigo":7501002,
    "descripcion":"NIVEL DE ÁCIDO LÁCTICO AUMENTADO"
  },
  {
    "codigo":169506000,
    "descripcion":"UTILIZA PRESERVATIVO ANTICONCEPTIVO CON ESPERMICIDA"
  },
  {
    "codigo":300578003,
    "descripcion":"HALLAZGO RELACIONADO CON LA CANTIDAD DE LESIONES"
  },
  {
    "codigo":235042004,
    "descripcion":"PIGMENTACIÓN POR MELANINA DE LA MUCOSA BUCAL ASOCIADA CON PATOLOGÍA SISTÉMICA"
  },
  {
    "codigo":724727001,
    "descripcion":"CONVULSIÓN CONCOMITANTE CON ABSTINENCIA DE SUSTANCIA PSICOACTIVA Y DEBIDA A ELLA"
  },
  {
    "codigo":298743002,
    "descripcion":"EXTREMIDAD SUPERIOR PEQUEÑA"
  },
  {
    "codigo":890402009,
    "descripcion":"ANOMALÍA CONGÉNITA DE VÁLVULA TRONCAL"
  },
  {
    "codigo":36599006,
    "descripcion":"FIBROSIS PULMONAR CRÓNICA"
  },
  {
    "codigo":1148876001,
    "descripcion":"GLOMERULOPATÍA DEBIDA A HEMATURIA FAMILIAR"
  },
  {
    "codigo":165836006,
    "descripcion":"TOXOPLASMA GONDII NO DETECTADO"
  },
  {
    "codigo":34764007,
    "descripcion":"INTOXICACIÓN POR PARALDEHÍDO"
  },
  {
    "codigo":722892007,
    "descripcion":"FIEBRE DEBIDA A INFECCIÓN"
  },
  {
    "codigo":295073002,
    "descripcion":"ALERGIA A FLOSEQUINÁN"
  },
  {
    "codigo":721057002,
    "descripcion":"SÍNDROME DE INSUFICIENCIA TORÁCICA"
  },
  {
    "codigo":1343649003,
    "descripcion":"RETINITIS DISEMINADA DE POLO POSTERIOR DERECHO"
  },
  {
    "codigo":293238007,
    "descripcion":"REACCIÓN ADVERSA A LA TESTOSTERONA"
  },
  {
    "codigo":291403000,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR NALOXONA"
  },
  {
    "codigo":29259002,
    "descripcion":"HIPERTENSIÓN MALIGNA QUE COMPLICA EL EMBARAZO Y\/O CONSTITUYE UN MOTIVO DE ATENCIÓN DURANTE ESTE PERÍODO"
  },
  {
    "codigo":94795002,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA COROIDES"
  },
  {
    "codigo":1208907008,
    "descripcion":"LINFEDEMA FACIAL DEBIDO A ACNÉ"
  },
  {
    "codigo":677351000119105,
    "descripcion":"CÁMARA ANTERIOR PLANA DE AMBOS OJOS CON HIPOTONÍA"
  },
  {
    "codigo":1010464002,
    "descripcion":"AGENESIA DE HEMISFERIO DERECHO DEL CEREBELO"
  },
  {
    "codigo":92960007,
    "descripcion":"AUSENCIA CONGÉNITA DE VÁLVULA AÓRTICA"
  },
  {
    "codigo":289568008,
    "descripcion":"HALLAZGO RELACIONADO CON EL LÍQUIDO VAGINAL"
  },
  {
    "codigo":60192008,
    "descripcion":"SÍNDROME DEL PTERIGIÓN MÚLTIPLE LETAL"
  },
  {
    "codigo":123893002,
    "descripcion":"INTOXICACIÓN POR POLYGONACEAE"
  },
  {
    "codigo":1086951000119108,
    "descripcion":"HEMORRAGIA GÁSTRICA DEBIDA A ECTASIA VASCULAR DEL ANTRO GÁSTRICO"
  },
  {
    "codigo":254965007,
    "descripcion":"MACROADENOMA HIPOFISARIO"
  },
  {
    "codigo":253130001,
    "descripcion":"MICROCEFALIA SECUNDARIA"
  },
  {
    "codigo":449738003,
    "descripcion":"INFLAMACIÓN DE PIEL PERILESIONAL"
  },
  {
    "codigo":23754003,
    "descripcion":"PIELONEFRITIS LITIÁSICA"
  },
  {
    "codigo":154826009,
    "descripcion":"TROMBOCITOPENIA SECUNDARIA"
  },
  {
    "codigo":447903001,
    "descripcion":"COARTACIÓN DE ARTERIA PULMONAR DERECHA"
  },
  {
    "codigo":54687002,
    "descripcion":"EMBOLIA ARTERIAL"
  },
  {
    "codigo":1363572000,
    "descripcion":"INMUNODEFICIENCIA COMBINADA DEBIDA A HAPLOINSUFICIENCIA DE FOXN1"
  },
  {
    "codigo":413300002,
    "descripcion":"EJERCICIO POR DEBAJO DEL NIVEL RECOMENDADO"
  },
  {
    "codigo":249460003,
    "descripcion":"ESTENOSIS SUPRAGLÓTICA"
  },
  {
    "codigo":216692002,
    "descripcion":"INTOXICACIÓN ACCIDENTAL CAUSADA POR LINDANO"
  },
  {
    "codigo":282228006,
    "descripcion":"CAPAZ DE CAMINAR APOYANDO PRIMERO EL TALÓN Y LUEGO LOS DEDOS"
  },
  {
    "codigo":183924009,
    "descripcion":"DERIVACIÓN REQUERIDA"
  },
  {
    "codigo":83785004,
    "descripcion":"CEGUERA TRANSITORIA"
  },
  {
    "codigo":313161005,
    "descripcion":"DISMINUCIÓN DE LA ACCIÓN DEL RECTO INFERIOR"
  },
  {
    "codigo":278558000,
    "descripcion":"CAÍDA DE OBTURACIÓN DENTAL"
  },
  {
    "codigo":81950002,
    "descripcion":"EDEMA DE LA LENGUA"
  },
  {
    "codigo":409630004,
    "descripcion":"VIREMIA ASINTOMÁTICA"
  },
  {
    "codigo":737310005,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE GLÁNDULA SUBMAXILAR"
  },
  {
    "codigo":1259763001,
    "descripcion":"TUMOR NEUROECTODÉRMICO PRIMITIVO PRIMARIO"
  },
  {
    "codigo":735475005,
    "descripcion":"HIPOCALCIURIA RENAL"
  },
  {
    "codigo":276723008,
    "descripcion":"HIPOPLASIA BILIAR INTRAHEPÁTICA"
  },
  {
    "codigo":405960000,
    "descripcion":"EQUIPO INTERGRUPAL PARA EL ESTUDIO POSQUIRÚRGICO DE RABDOMIOSARCOMA IIB: TUMOR DE DISEMINACIÓN LOCAL (PROPAGACIÓN A GANGLIOS LINFÁTICOS REGIONALES), TOTALMENTE RESECADO"
  },
  {
    "codigo":209352003,
    "descripcion":"FRACTURA-SUBLUXACIÓN EXPUESTA DE ARTICULACIÓN DE TOBILLO"
  },
  {
    "codigo":1290696007,
    "descripcion":"LESIÓN TRAUMÁTICA DE INTESTINO DURANTE PROCEDIMIENTO QUIRÚRGICO"
  },
  {
    "codigo":305821002,
    "descripcion":"VISTO POR EL SERVICIO DE NEFROLOGÍA"
  },
  {
    "codigo":238450000,
    "descripcion":"INFESTACIÓN DE LA PIEL POR PROTOZOOS"
  },
  {
    "codigo":895645008,
    "descripcion":"FORMA TRIANGULAR ANORMAL CONGÉNITA DE FALANGE PROXIMAL DE PULGAR"
  },
  {
    "codigo":369522002,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL OVARIO IZQUIERDO"
  },
  {
    "codigo":402290005,
    "descripcion":"DERMATITIS DE CONTACTO IRRITATIVA DE MANO"
  },
  {
    "codigo":74610006,
    "descripcion":"ERITEMA NUDOSO DEBIDO A TUBERCULOSIS"
  },
  {
    "codigo":9074007,
    "descripcion":"NISTAGMO DE RETRACCIÓN"
  },
  {
    "codigo":105543003,
    "descripcion":"ABSTEMIO POR MOTIVOS PERSONALES"
  },
  {
    "codigo":1186887004,
    "descripcion":"DEMENCIA CAUSADA POR MANGANESO"
  },
  {
    "codigo":236615008,
    "descripcion":"REFLUJO VESICOURETERAL PRIMARIO"
  },
  {
    "codigo":267548000,
    "descripcion":"ADENITIS MESENTÉRICA NO ESPECÍFICA"
  },
  {
    "codigo":1119516004,
    "descripcion":"AGOTAMIENTO FATIGABLE DE MÚSCULO RESPIRATORIO"
  },
  {
    "codigo":365852007,
    "descripcion":"HALLAZGO DE FUNCIÓN RESPIRATORIA"
  },
  {
    "codigo":202012008,
    "descripcion":"ARTROPATÍA TRANSITORIA DE TOBILLO"
  },
  {
    "codigo":300316009,
    "descripcion":"HALLAZGO RELACIONADO CON LA APARIENCIA DEL ANO"
  },
  {
    "codigo":298481006,
    "descripcion":"CREPITACIÓN AUDIBLE DE LA COLUMNA CERVICAL"
  },
  {
    "codigo":724465009,
    "descripcion":"LIQUEN SIMPLE DE GENITALES MASCULINOS"
  },
  {
    "codigo":722630003,
    "descripcion":"HEMORRAGIA TRAUMÁTICA DE SUSTANCIA BLANCA CEREBRAL"
  },
  {
    "codigo":1148614005,
    "descripcion":"ELECTRORRETINOGRAMA DE DESTELLO TENUE CON ADAPTACIÓN A OSCURIDAD ANORMAL"
  },
  {
    "codigo":1734006,
    "descripcion":"FRACTURA DE LA COLUMNA VERTEBRAL CON LESIÓN TRAUMÁTICA DE LA MÉDULA ESPINAL"
  },
  {
    "codigo":165574006,
    "descripcion":"TIEMPO DE TROMBINA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":294811002,
    "descripcion":"ALERGIA A CORTICOTROFINA"
  },
  {
    "codigo":65435003,
    "descripcion":"INTOXICACIÓN CAUSADA POR FÁRMACO ANTIADRENÉRGICO"
  },
  {
    "codigo":130971003,
    "descripcion":"RESPUESTA INFANTIL DESORGANIZADA AL ESTÍMULO AMBIENTAL"
  },
  {
    "codigo":1179547007,
    "descripcion":"EPILEPSIA NEONATAL DEBIDA A ACCIDENTE CEREBROVASCULAR PERINATAL"
  },
  {
    "codigo":1144944001,
    "descripcion":"SÍNDROME DE SUPERPOSICIÓN DE POLIMIOSITIS"
  },
  {
    "codigo":129136002,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":30832001,
    "descripcion":"RUPTURA DEL TENDÓN ROTULIANO"
  },
  {
    "codigo":292976001,
    "descripcion":"REACCIÓN ADVERSA A LA TEMOCILINA"
  },
  {
    "codigo":161904006,
    "descripcion":"SÍNTOMAS INEXPLICABLES QUE CONTINÚAN"
  },
  {
    "codigo":63600008,
    "descripcion":"MERCURIALENTIS"
  },
  {
    "codigo":127301001,
    "descripcion":"LESIÓN TRAUMÁTICA CEREBRAL CON PÉRDIDA PROLONGADA DE LA CONSCIENCIA"
  },
  {
    "codigo":782661001,
    "descripcion":"DOLOR CRÓNICO DE ARTICULACIÓN SACROILÍACA"
  },
  {
    "codigo":225605003,
    "descripcion":"CONTUSIÓN DE PEZÓN"
  },
  {
    "codigo":94533005,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL SEGUNDO HUESO CUNEIFORME DEL TARSO"
  },
  {
    "codigo":717125005,
    "descripcion":"ENVENENAMIENTO CAUSADO POR VENENO DE NOTECHIS SCUTATUS"
  },
  {
    "codigo":191002000,
    "descripcion":"DEFICIENCIA DE COMPLEJO MAYOR DE HISTOCOMPATIBILIDAD DE CLASE II"
  },
  {
    "codigo":92698005,
    "descripcion":"CARCINOMA IN SITU DE LAS VÍAS RESPIRATORIAS"
  },
  {
    "codigo":289306008,
    "descripcion":"LATIDO DE CORDÓN UMBILICAL NO PALPABLE A TRAVÉS DE MEMBRANAS INTACTAS"
  },
  {
    "codigo":90863004,
    "descripcion":"FRACTURA NO EXPUESTA DE OCHO COSTILLAS O MÁS"
  },
  {
    "codigo":254703005,
    "descripcion":"FIBROEPITELIOMA DE PINKUS"
  },
  {
    "codigo":746223006,
    "descripcion":"INFECCIÓN NEONATAL DE CAVIDAD BUCAL CAUSADA POR CANDIDA"
  },
  {
    "codigo":713455005,
    "descripcion":"INFECCIÓN CAUSADA POR GRUPO DE STREPTOCOCCUS MITIS"
  },
  {
    "codigo":1137604001,
    "descripcion":"BERMELLÓN DE LABIO INFERIOR FINO"
  },
  {
    "codigo":1336047009,
    "descripcion":"EPISODIO DE USO NOCIVO DE HIERBA MEDICINAL"
  },
  {
    "codigo":189167009,
    "descripcion":"MENINGIOMA DE MÉDULA ESPINAL"
  },
  {
    "codigo":285636001,
    "descripcion":"NEOPLASIA INTRAEPITELIAL CERVICAL"
  },
  {
    "codigo":56260006,
    "descripcion":"INTERVALO ST PROLONGADO"
  },
  {
    "codigo":283801000,
    "descripcion":"MORDEDURA DE ANIMAL EN LA GARGANTA"
  },
  {
    "codigo":773486001,
    "descripcion":"ALERGIA A DEXTROMETORFANO"
  },
  {
    "codigo":21657009,
    "descripcion":"INTOXICACIÓN POR ADENIUM"
  },
  {
    "codigo":443971004,
    "descripcion":"ARTERIOSCLEROSIS DE ARTERIA DE EXTREMIDAD"
  },
  {
    "codigo":312899005,
    "descripcion":"CICATRIZ MACULAR FIBROVASCULAR"
  },
  {
    "codigo":280131007,
    "descripcion":"TRASTORNO DE PARTES BLANDAS DE LA CABEZA"
  },
  {
    "codigo":737048006,
    "descripcion":"HIPOACUSIA ADQUIRIDA MODERADA"
  },
  {
    "codigo":1259501004,
    "descripcion":"DEMENCIA DEBIDA A KURU"
  },
  {
    "codigo":276461005,
    "descripcion":"EXCORIACIONES POR RASCADO EN LA VULVA"
  },
  {
    "codigo":702445005,
    "descripcion":"ATAXIA ESPÁSTICA AUTOSÓMICA RECESIVA DE CHARLEVOIX-SAGUENAY"
  },
  {
    "codigo":473069007,
    "descripcion":"INFECCIÓN ASOCIADA CON DIÁLISIS PERITONEAL"
  },
  {
    "codigo":405698002,
    "descripcion":"LESIÓN TRAUMÁTICA PROVOCADA POR SUJECIÓN LEGAL CON GRILLOS"
  },
  {
    "codigo":209090003,
    "descripcion":"LUXACIÓN EXPUESTA DE LA COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":897218004,
    "descripcion":"CURVATURA ANORMAL DE FALANGE DE SEGUNDO DEDO DE PIE"
  },
  {
    "codigo":274626005,
    "descripcion":"FRACASO FISIOLÓGICO DEL DESARROLLO"
  },
  {
    "codigo":733378005,
    "descripcion":"MÚLTIPLES HERIDAS ABIERTAS DE ABDOMEN"
  },
  {
    "codigo":241858007,
    "descripcion":"EFECTO TÓXICO CAUSADO POR DESODORANTE DE AMBIENTES SÓLIDO"
  },
  {
    "codigo":307394008,
    "descripcion":"INJERTO AÓRTICO INFECTADO"
  },
  {
    "codigo":403863000,
    "descripcion":"PAPILOMAS BASOCELULARES MÚLTIPLES"
  },
  {
    "codigo":372930006,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM GORDONAE"
  },
  {
    "codigo":240023003,
    "descripcion":"PELLIZCAMIENTO DE HUESO TRIANGULAR DEL TARSO"
  },
  {
    "codigo":78018008,
    "descripcion":"FOCOMELIA COMPLETA DE LA EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":698775005,
    "descripcion":"DISESTESIA DE CARA"
  },
  {
    "codigo":305559001,
    "descripcion":"BAJO ATENCIÓN DE ENFERMERA ESPECIALIZADA EN EL RASTREO DE CONTACTOS"
  },
  {
    "codigo":41580004,
    "descripcion":"DERMATOSIS EXUDATIVA DISCOIDE DISTINTIVA Y LIQUENOIDE CRÓNICA DE SULZBERGER Y GARBE"
  },
  {
    "codigo":762476006,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL SUPERFICIAL DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":269121000,
    "descripcion":"LUXACIÓN NO EXPUESTA ENTRE LA SEXTA Y LA SÉPTIMA VÉRTEBRAS CERVICALES"
  },
  {
    "codigo":72513001,
    "descripcion":"FRACTURA NO EXPUESTA A NIVEL DE D7 - D12 CON LESIÓN TRAUMÁTICA DE LA MÉDULA ESPINAL"
  },
  {
    "codigo":203585001,
    "descripcion":"ANTEPIE DORSIFLEXIONADO ADQUIRIDO"
  },
  {
    "codigo":6977003,
    "descripcion":"INFECCIÓN CAUSADA POR NEOECHINORHYNCHUS"
  },
  {
    "codigo":1186625007,
    "descripcion":"AMBIENTE HÚMEDO"
  },
  {
    "codigo":37910008,
    "descripcion":"HIPERMETABOLISMO"
  },
  {
    "codigo":68843000,
    "descripcion":"ENFERMEDAD CAUSADA POR ARTRÓPODOS"
  },
  {
    "codigo":298219001,
    "descripcion":"LAXITUD DE ARTICULACIÓN SUBASTRAGALINA"
  },
  {
    "codigo":365590009,
    "descripcion":"SEROLOGÍA: ORGANISMO - HALLAZGO"
  },
  {
    "codigo":67592000,
    "descripcion":"INFECCIÓN CAUSADA POR DIPLOGONOPORUS"
  },
  {
    "codigo":165312001,
    "descripcion":"CONDUCTA GRAVEMENTE ANORMAL"
  },
  {
    "codigo":394688002,
    "descripcion":"BAJO RIESGO DE ENFERMEDAD CARDÍACA PRIMARIA"
  },
  {
    "codigo":34240005,
    "descripcion":"INFECCIÓN CAUSADA POR DIPHYLLOBOTHRIUM PACIFICUM"
  },
  {
    "codigo":294549005,
    "descripcion":"ALERGIA A CEFODIZIMA"
  },
  {
    "codigo":1179285006,
    "descripcion":"INMUNODEFICIENCIA COMBINADA DEBIDA A DEFICIENCIA DE MOESINA"
  },
  {
    "codigo":292714004,
    "descripcion":"REACCIÓN ADVERSA A ALPROSTADIL"
  },
  {
    "codigo":15676241000119103,
    "descripcion":"TENDINITIS BILATERAL DE RODILLA"
  },
  {
    "codigo":1144682006,
    "descripcion":"APLASIA DE FALANGE MEDIA DE CUARTO DEDO DE PIE"
  },
  {
    "codigo":817002007,
    "descripcion":"OJO IZQUIERDO CON PERCEPCIÓN DE LUZ SOLAMENTE"
  },
  {
    "codigo":127039000,
    "descripcion":"HEMOGLOBINOPATÍA ADQUIRIDA"
  },
  {
    "codigo":782399001,
    "descripcion":"NÓDULO DEL TEJIDO CELULAR SUBCUTÁNEO DE DEDO DE LA MANO"
  },
  {
    "codigo":94271003,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE COLON DESCENDENTE"
  },
  {
    "codigo":61503006,
    "descripcion":"NEFRITIS AGUDA"
  },
  {
    "codigo":716863007,
    "descripcion":"CITRULINEMIA TIPO II"
  },
  {
    "codigo":192575009,
    "descripcion":"TRASTORNO MIXTO DE LA CAPACIDAD ACADÉMICA"
  },
  {
    "codigo":26900001,
    "descripcion":"ESTENOSIS DEL OSTIUM CORONARIO"
  },
  {
    "codigo":92436004,
    "descripcion":"NEOPLASIA BENIGNA DEL ESÓFAGO TORÁCICO"
  },
  {
    "codigo":715028005,
    "descripcion":"DIFICULTAD PARA CAMINAR EN UNA HABITACIÓN"
  },
  {
    "codigo":289044009,
    "descripcion":"UTILIZA CUBIERTOS PARA ALIMENTARSE"
  },
  {
    "codigo":385513001,
    "descripcion":"QUEMADURA DE LA PIEL POR FUEGOS ARTIFICIALES"
  },
  {
    "codigo":25065001,
    "descripcion":"ENFERMEDAD POR HEMOGLOBINA E"
  },
  {
    "codigo":1237481003,
    "descripcion":"METÁSTASIS DE CARCINOMA DE CUELLO DE ÚTERO"
  },
  {
    "codigo":254441002,
    "descripcion":"CARCINOMA DEL SURCO BUCAL SUPERIOR"
  },
  {
    "codigo":1335785006,
    "descripcion":"ARTRITIS IDIOPÁTICA JUVENIL DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":713193007,
    "descripcion":"CATETERISMO INADVERTIDO DE ARTERIA"
  },
  {
    "codigo":10924881000119108,
    "descripcion":"FRACTURA CERRADA DE CÓNDILO INTERNO DE TIBIA IZQUIERDA"
  },
  {
    "codigo":416446009,
    "descripcion":"FALSA SENSACIÓN DE BIENESTAR"
  },
  {
    "codigo":283539002,
    "descripcion":"HERIDA PUNZANTE DE TOBILLO"
  },
  {
    "codigo":185235005,
    "descripcion":"LUGAR DE ENCUENTRO: CALLE"
  },
  {
    "codigo":1363048000,
    "descripcion":"INTOXICACIÓN ACCIDENTAL CAUSADA POR ANTISÉPTICO Y\/O DESINFECTANTE"
  },
  {
    "codigo":85096001,
    "descripcion":"INFARTO SUPRARRENAL"
  },
  {
    "codigo":314472003,
    "descripcion":"FEV1\/FVC < 70% DE LO PREVISTO"
  },
  {
    "codigo":248936004,
    "descripcion":"PÓLIPO EN EL ORIFICIO CERVICAL"
  },
  {
    "codigo":42941000087108,
    "descripcion":"QUEMADURA DE DEDO MEDIO IZQUIERDO"
  },
  {
    "codigo":19560007,
    "descripcion":"EXOSTOSIS DE CONDUCTO AUDITIVO EXTERNO"
  },
  {
    "codigo":871528009,
    "descripcion":"HERIDA ABIERTA DE MÚLTIPLES SITIOS DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":247101002,
    "descripcion":"GLIOSIS PRERRETINIANA PERIFÉRICA"
  },
  {
    "codigo":441874000,
    "descripcion":"ATENDIDO POR SERVICIO DE CUIDADOS PALIATIVOS"
  },
  {
    "codigo":15950981000119102,
    "descripcion":"MELANOMA MALIGNO DE PIEL DE PIE DERECHO"
  },
  {
    "codigo":15890002,
    "descripcion":"ALBINISMO"
  },
  {
    "codigo":48658001,
    "descripcion":"ÚLCERA PÉPTICA CON HEMORRAGIA PERO SIN OBSTRUCCIÓN"
  },
  {
    "codigo":704018002,
    "descripcion":"ANTICUERPO INMUNOGLOBULINA M CONTRA CITOMEGALOVIRUS NO DETECTADO EN SUERO"
  },
  {
    "codigo":343570008,
    "descripcion":"HEMOCROMATOSIS LATENTE"
  },
  {
    "codigo":278034009,
    "descripcion":"REACCIÓN CUTÁNEA IRRITATIVA"
  },
  {
    "codigo":14055002,
    "descripcion":"HIDROCEFALIA EX VACUO"
  },
  {
    "codigo":472807003,
    "descripcion":"DEFECTO DE TABIQUE VENTRICULAR DEBIDO A ENDOCARDITIS INFECCIOSA Y CONSECUTIVO A ELLA"
  },
  {
    "codigo":79591004,
    "descripcion":"PARÁLISIS ESPÁSTICA POR TRAUMATISMO ESPINAL DEL NACIMIENTO"
  },
  {
    "codigo":440039008,
    "descripcion":"HALLAZGO RELACIONADO CON EL NIVEL DE ALFABETISMO"
  },
  {
    "codigo":700348001,
    "descripcion":"ENTROPIÓN ESPÁSTICO DE PÁRPADO INFERIOR"
  },
  {
    "codigo":307132003,
    "descripcion":"LITIASIS COLEDOCIANA"
  },
  {
    "codigo":733116005,
    "descripcion":"SÍNDROME DE ANIRIDIA, AGENESIA RENAL Y RETRASO PSICOMOTOR"
  },
  {
    "codigo":208828005,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN MEDIOCARPIANA"
  },
  {
    "codigo":239761000,
    "descripcion":"LUXACIÓN PATOLÓGICA DE CODO"
  },
  {
    "codigo":403601003,
    "descripcion":"ÚLCERA NEUROPÁTICA"
  },
  {
    "codigo":878111000000109,
    "descripcion":"NIÑO NO NACIDO COMO MOTIVO DE PREOCUPACIÓN POR LA PROTECCIÓN"
  },
  {
    "codigo":43153006,
    "descripcion":"MIXEDEMA"
  },
  {
    "codigo":272529007,
    "descripcion":"POSTURA ERGUIDA AL CAMINAR"
  },
  {
    "codigo":1255569006,
    "descripcion":"ESTENOSIS DE ORIFICIO DE ARTERIA CORONARIA IZQUIERDA PRINCIPAL"
  },
  {
    "codigo":10385009,
    "descripcion":"INTOXICACIÓN POR DIGOXINA"
  },
  {
    "codigo":303462003,
    "descripcion":"INCAPAZ DE MANEJAR PRÓTESIS"
  },
  {
    "codigo":10681631000119103,
    "descripcion":"MASA DE PIEL DE AMBOS ANTEBRAZOS"
  },
  {
    "codigo":237926007,
    "descripcion":"DEFICIENCIA DE GLUTATIÓN SINTASA SIN 5-OXOPROLINURIA"
  },
  {
    "codigo":236091002,
    "descripcion":"FILTRACIÓN POR ANASTOMOSIS DE INTESTINO GRUESO"
  },
  {
    "codigo":170555002,
    "descripcion":"SE INCORPORÓ A GRUPO DE AUTOAYUDA"
  },
  {
    "codigo":399931004,
    "descripcion":"MIXOMA DÉRMICO DE VAINA NERVIOSA CELULAR"
  },
  {
    "codigo":301627005,
    "descripcion":"UTILIZA ASCENSOR DE ESCALERAS"
  },
  {
    "codigo":6715005,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA CARÓTIDA EXTERNA"
  },
  {
    "codigo":299792000,
    "descripcion":"REFLEJO DE CONGELAMIENTO PRESENTE"
  },
  {
    "codigo":168720001,
    "descripcion":"RADIOGRAFÍA SIMPLE DE PARTES BLANDAS DE CUELLO NORMAL"
  },
  {
    "codigo":267024001,
    "descripcion":"PÉRDIDA ANORMAL DE PESO"
  },
  {
    "codigo":201488005,
    "descripcion":"ARTROPATÍA EN EL SÍNDROME DE BEHCET, DE LA MANO"
  },
  {
    "codigo":1217296006,
    "descripcion":"INFECCIÓN POR SARS-COV-2 EN VACUNADO"
  },
  {
    "codigo":16006431000119106,
    "descripcion":"ARTRITIS VIRAL DE ARTICULACIÓN DE MANO IZQUIERDA"
  },
  {
    "codigo":12238111000119106,
    "descripcion":"INFARTO AGUDO DE MIOCARDIO DE PARED INFEROEXTERNA CON ELEVACIÓN DEL SEGMENTO ST"
  },
  {
    "codigo":365328009,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA LIMPIAR LAS INSTALACIONES SANITARIAS DOMÉSTICAS"
  },
  {
    "codigo":68581004,
    "descripcion":"HIPOGLUCEMIA DE LA NIÑEZ"
  },
  {
    "codigo":396261004,
    "descripcion":"MARGEN QUIRÚRGICO EXOCERVICAL COMPROMETIDO POR NEOPLASIA MALIGNA, DE MANERA DIFUSA"
  },
  {
    "codigo":363493006,
    "descripcion":"NEOPLASIA MALIGNA DE BRONQUIO"
  },
  {
    "codigo":723941008,
    "descripcion":"COMPLICACIÓN DE LA PIEL Y EL TEJIDO SUBCUTÁNEO DESPUÉS DE INSERCIÓN DE MATERIAL DE RELLENO DEBAJO DE LA PIEL"
  },
  {
    "codigo":297957009,
    "descripcion":"PIEL ESTIRADA"
  },
  {
    "codigo":722106001,
    "descripcion":"SÍNDROME OROFACIAL DIGITAL TIPO 8"
  },
  {
    "codigo":230586003,
    "descripcion":"NEUROPATÍA DEBIDA A MIELOMA MÚLTIPLE"
  },
  {
    "codigo":197818001,
    "descripcion":"ADHERENCIAS DE URÉTER"
  },
  {
    "codigo":333241000119103,
    "descripcion":"DEGENERACIÓN DE CÓRNEA PERIFÉRICA DE OJO DERECHO"
  },
  {
    "codigo":296122003,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE LORAZEPAM"
  },
  {
    "codigo":427194007,
    "descripcion":"TENSIÓN MUSCULAR INDUCIDA POR ESTRÉS"
  },
  {
    "codigo":785807007,
    "descripcion":"CARCINOMA DE CÉLULAS DE TRANSICIÓN DE CUERPO UTERINO"
  },
  {
    "codigo":425359009,
    "descripcion":"LESIÓN TRAUMÁTICA CONTUSA"
  },
  {
    "codigo":95844003,
    "descripcion":"DISPLASMINOGENEMIA"
  },
  {
    "codigo":292452004,
    "descripcion":"REACCIÓN ADVERSA A FÁRMACO BLOQUEANTE DE LOS CANALES DEL CALCIO"
  },
  {
    "codigo":142931000119100,
    "descripcion":"NEUMONÍA CAUSADA POR VIRUS INFLUENZA H1N1"
  },
  {
    "codigo":128612007,
    "descripcion":"CONVULSIÓN MOTORA FOCAL"
  },
  {
    "codigo":1144420008,
    "descripcion":"ESCLEROSIS DE CÚSPIDE DE VÁLVULA AÓRTICA"
  },
  {
    "codigo":421689001,
    "descripcion":"ANOMALÍA DEL EPITELIO PIGMENTARIO DE LA RETINA"
  },
  {
    "codigo":126777006,
    "descripcion":"NEOPLASIA DE LA COMISURA DE LOS LABIOS"
  },
  {
    "codigo":288782002,
    "descripcion":"CAPAZ DE COMUNICAR NECESIDADES Y DESEOS"
  },
  {
    "codigo":92174004,
    "descripcion":"NEOPLASIA BENIGNA DE LA CARA LARÍNGEA DE LA EPIGLOTIS"
  },
  {
    "codigo":11310521000119109,
    "descripcion":"FRACTURA NO EXPUESTA DE PRIMERA VÉRTEBRA DORSAL"
  },
  {
    "codigo":254179000,
    "descripcion":"EPIDERMÓLISIS BULLOSA SIMPLE HERPETIFORME"
  },
  {
    "codigo":286947004,
    "descripcion":"VALVULITIS MITRAL REUMÁTICA CRÓNICA"
  },
  {
    "codigo":55736003,
    "descripcion":"TRASTORNO ESQUIZOFRENIFORME, SIN CARACTERÍSTICAS DE BUEN PRONÓSTICO"
  },
  {
    "codigo":1004173000,
    "descripcion":"NIVEL DE ÁCIDO LÁCTICO AUMENTADO EN ORINA"
  },
  {
    "codigo":840333006,
    "descripcion":"COLAPSO DEBIDO A PARO CARDÍACO"
  },
  {
    "codigo":283277007,
    "descripcion":"VIDRIO EN TALÓN"
  },
  {
    "codigo":53901006,
    "descripcion":"INTOXICACIÓN POR PHALARIS"
  },
  {
    "codigo":447117006,
    "descripcion":"TALASEMIA POR HEMOGLOBINA H CONSTANT SPRING"
  },
  {
    "codigo":281442002,
    "descripcion":"AFLOJAMIENTO DE COMPONENTE HUMERAL EN EL REEMPLAZO TOTAL DE HOMBRO"
  },
  {
    "codigo":838498002,
    "descripcion":"CAPAZ DE UTILIZAR GENERADOR DE VOZ"
  },
  {
    "codigo":15927021000119103,
    "descripcion":"LESIÓN DEL PÁRPADO SUPERIOR DERECHO"
  },
  {
    "codigo":82999001,
    "descripcion":"HEMORRAGIA INTRACRANEAL EPIDURAL"
  },
  {
    "codigo":312375001,
    "descripcion":"ÉMBOLO DE ARTERIA DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":707426009,
    "descripcion":"CARCINOMA PAPILAR ESCAMOCELULAR PRIMARIO DE LARINGE"
  },
  {
    "codigo":246839004,
    "descripcion":"HERNIA GRASA ORBITAL"
  },
  {
    "codigo":771127006,
    "descripcion":"INFECCIÓN CAUSADA POR ISOSPORAS CONCOMITANTE CON SÍNDROME DE INMUNODEFICIENCIA ADQUIRIDA"
  },
  {
    "codigo":81164001,
    "descripcion":"ORNITOSIS CON NEUMONÍA"
  },
  {
    "codigo":15628003,
    "descripcion":"GONORREA"
  },
  {
    "codigo":736524004,
    "descripcion":"VULVITIS SUBAGUDA"
  },
  {
    "codigo":689901000119106,
    "descripcion":"CARCINOMA PRIMARIO INDIFERENCIADO DE PARED POSTERIOR DE NASOFARINGE"
  },
  {
    "codigo":1162508007,
    "descripcion":"FUNCIÓN MOTORA"
  },
  {
    "codigo":212236009,
    "descripcion":"LESIONES DE LA RAÍZ NERVIOSA Y DEL PLEXO MEDULAR EN MÚLTIPLES SITIOS"
  },
  {
    "codigo":1258977001,
    "descripcion":"XANTOMA DEBIDO A QUILOMICRONEMIA PRIMARIA"
  },
  {
    "codigo":112097008,
    "descripcion":"COITO TRANQUILO"
  },
  {
    "codigo":274102007,
    "descripcion":"FARINGITIS VESICULAR"
  },
  {
    "codigo":110262009,
    "descripcion":"CONTUSIÓN DE LA REGIÓN PERIORBITARIA"
  },
  {
    "codigo":403339003,
    "descripcion":"CAMBIO POSINFLAMATORIO DE LA COLORACIÓN DEL CABELLO"
  },
  {
    "codigo":75659004,
    "descripcion":"LIPODISTROFIA PARCIAL ADQUIRIDA"
  },
  {
    "codigo":1222539006,
    "descripcion":"TRES COMPLEJOS VENTRICULARES PREMATUROS CONSECUTIVOS"
  },
  {
    "codigo":840456001,
    "descripcion":"COLOBOMA DE AMBAS MÁCULAS"
  },
  {
    "codigo":698251009,
    "descripcion":"BLOQUEO CARDÍACO FAMILIAR PROGRESIVO, TIPO II"
  },
  {
    "codigo":16637831000119106,
    "descripcion":"TRASTORNO DE NERVIOS GENITOFEMORALES BILATERALES"
  },
  {
    "codigo":1351776006,
    "descripcion":"INMUNODEFICIENCIA COMBINADA AUTOSÓMICA RECESIVA DEBIDA A DEFICIENCIA DE WIP"
  },
  {
    "codigo":237664006,
    "descripcion":"HIPERPROLACTINEMIA POR COMPRESIÓN DEL TALLO HIPOFISARIO"
  },
  {
    "codigo":335751000119106,
    "descripcion":"ANOMALÍA VASCULAR DE CONJUNTIVA DERECHA"
  },
  {
    "codigo":235829000,
    "descripcion":"PSEUDO-OBSTRUCCIÓN CRÓNICA DEL INTESTINO DELGADO"
  },
  {
    "codigo":1153333001,
    "descripcion":"ANEMIA PERNICIOSA DEBIDA A ENFERMEDAD AUTOINMUNITARIA"
  },
  {
    "codigo":203061004,
    "descripcion":"CONTRACTURA DEL MÚSCULO BÍCEPS"
  },
  {
    "codigo":301365009,
    "descripcion":"DOLOR DE LA REGIÓN DEL CUELLO Y LA CABEZA"
  },
  {
    "codigo":233994002,
    "descripcion":"DISECCIÓN DE AORTA TORÁCICA"
  },
  {
    "codigo":168458003,
    "descripcion":"ANATOMÍA PATOLÓGICA MACROSCÓPICA: ANORMALIDAD"
  },
  {
    "codigo":365066003,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA ADAPTAR LA CONVERSACIÓN AL CONTEXTO"
  },
  {
    "codigo":10958881000119103,
    "descripcion":"HERIDA ABIERTA DE MANO DERECHA DEBIDA A MORDEDURA"
  },
  {
    "codigo":102922001,
    "descripcion":"TOCOFOBIA"
  },
  {
    "codigo":299530009,
    "descripcion":"AMPLITUD DE INVERSIÓN PASIVA NORMAL DE ARTICULACIÓN SUBASTRAGALINA"
  },
  {
    "codigo":2783007,
    "descripcion":"ÚLCERA GASTROYEYUNAL SIN HEMORRAGIA Y SIN PERFORACIÓN"
  },
  {
    "codigo":363231009,
    "descripcion":"COMPLICACIÓN NEOPLÁSICA DE PROCEDIMIENTO"
  },
  {
    "codigo":295860002,
    "descripcion":"SOBREDOSIS DE DOXEPINA"
  },
  {
    "codigo":164788003,
    "descripcion":"PRUEBA ESPECIAL DEL TRACTO GASTROINTESTINAL NORMAL"
  },
  {
    "codigo":230324004,
    "descripcion":"BLEFAROESPASMO AISLADO"
  },
  {
    "codigo":787380004,
    "descripcion":"METABOLIZADOR LENTO DE LA FAMILIA 3 SUBFAMILIA A MIEMBRO 4 DEL CITOCROMO P450"
  },
  {
    "codigo":724787004,
    "descripcion":"EPILEPSIA DEBIDA A ACCIDENTE CEREBROVASCULAR"
  },
  {
    "codigo":11778081000119106,
    "descripcion":"RUPTURA TRAUMÁTICA DE TENDÓN DE MÚSCULO SUPRAESPINOSO IZQUIERDO"
  },
  {
    "codigo":263092008,
    "descripcion":"FRACTURA-LUXACIÓN DE ARTICULACIÓN DEL PIE"
  },
  {
    "codigo":720009004,
    "descripcion":"SÍNDROME DE DIARREA INTRATABLE CON ATRESIA DE COANAS Y ANOMALÍAS OCULARES"
  },
  {
    "codigo":195721005,
    "descripcion":"BRONQUITIS AGUDA POR HAEMOPHILUS INFLUENZAE"
  },
  {
    "codigo":31881008,
    "descripcion":"NEFROPATÍA CARDIOVASCULAR"
  },
  {
    "codigo":292190002,
    "descripcion":"REACCIÓN ADVERSA A LA ALDESLEUKINA"
  },
  {
    "codigo":95582003,
    "descripcion":"CRISTALIZACIÓN DE RIÑÓN"
  },
  {
    "codigo":128350005,
    "descripcion":"CONJUNTIVITIS BACTERIANA"
  },
  {
    "codigo":192051000,
    "descripcion":"TRASTORNO DE EMANCIPACIÓN EN EL ADOLESCENTE"
  },
  {
    "codigo":718174008,
    "descripcion":"DEGENERACIÓN ESTRIADO-NIGRAL INFANTIL"
  },
  {
    "codigo":93747000,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LAS MENINGES CEREBRALES"
  },
  {
    "codigo":16314711000119100,
    "descripcion":"ENFERMEDAD DE DUPUYTREN DE LA PALMA DE LA MANO DERECHA"
  },
  {
    "codigo":1142323005,
    "descripcion":"ATROFIA PERIFASCICULAR"
  },
  {
    "codigo":58173271000119101,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DEBIDO A EMBOLIA DE AMBAS ARTERIAS CEREBELOSAS"
  },
  {
    "codigo":10677591000119103,
    "descripcion":"HIPERHIDROSIS FOCAL PRIMARIA DE LA CARA"
  },
  {
    "codigo":10631511000119104,
    "descripcion":"ABSCESO DE PIEL DE CADERA DERECHA"
  },
  {
    "codigo":16058711000119104,
    "descripcion":"FALLA DE TRASPLANTE DE CÓRNEA DE OJO DERECHO"
  },
  {
    "codigo":15999831000119106,
    "descripcion":"DEFECTO PUPILAR AFERENTE RELATIVO DE OJO IZQUIERDO"
  },
  {
    "codigo":11798871000119106,
    "descripcion":"LESIÓN TRAUMÁTICA DE ARTERIA ILÍACA DERECHA"
  },
  {
    "codigo":291671000119105,
    "descripcion":"APRAXIA DEBIDA A HEMORRAGIA SUBARACNOIDEA INTRACRANEAL NO TRAUMÁTICA Y POSTERIOR A ELLA"
  },
  {
    "codigo":16040791000119109,
    "descripcion":"ARTRITIS IDIOPÁTICA JUVENIL DE INICIO SISTÉMICO DE MANO DERECHA"
  },
  {
    "codigo":145751000119104,
    "descripcion":"LINFANGIOMIOMATOSIS DE TEJIDO CONJUNTIVO"
  },
  {
    "codigo":122711000119109,
    "descripcion":"CEFALEA HÍPNICA"
  },
  {
    "codigo":16035671000119108,
    "descripcion":"OSTEÓLISIS DE TIBIA IZQUIERDA"
  },
  {
    "codigo":340311000119104,
    "descripcion":"OFTALMOPLEJÍA INTERNUCLEAR DE OJO IZQUIERDO"
  },
  {
    "codigo":16027991000119105,
    "descripcion":"EXOSTOSIS DE MANO IZQUIERDA"
  },
  {
    "codigo":253917003,
    "descripcion":"FALTA DE DIFERENCIACIÓN DE LOS HUESOS DEL ANTEBRAZO"
  },
  {
    "codigo":1204189004,
    "descripcion":"OCLUSIÓN DE ARTERIA VERTEBRAL INTRACRANEAL ASINTOMÁTICA"
  },
  {
    "codigo":286685004,
    "descripcion":"INVERSIÓN - MECANISMO DE DEFENSA PSICOLÓGICA"
  },
  {
    "codigo":368471000119109,
    "descripcion":"ENFERMEDAD RENAL TERMINAL EN DIÁLISIS DEBIDA A DIABETES MELLITUS MEDICAMENTOSA"
  },
  {
    "codigo":712669005,
    "descripcion":"YERSINIA, NO AISLADA"
  },
  {
    "codigo":284850000,
    "descripcion":"DIFICULTAD PARA LIMPIAR SUS PRÓTESIS DENTALES"
  },
  {
    "codigo":1236957006,
    "descripcion":"METÁSTASIS DE CARCINOMA DE FRENILLO LABIAL SUPERIOR"
  },
  {
    "codigo":22706002,
    "descripcion":"INTOXICACIÓN POR DIOXATIONA"
  },
  {
    "codigo":448690007,
    "descripcion":"ALERGIA A INHIBIDOR DE FOSFODIESTERASA 5"
  },
  {
    "codigo":283015002,
    "descripcion":"TRASTORNO DE LA ESTRUCTURA SALIVAL"
  },
  {
    "codigo":1003911003,
    "descripcion":"DELECIÓN PROXIMAL DEL BRAZO CORTO DEL CROMOSOMA 9"
  },
  {
    "codigo":250247005,
    "descripcion":"CÉLULAS EN MORDIDA"
  },
  {
    "codigo":741767008,
    "descripcion":"HEMATOMA NO TRAUMÁTICO DE PIEL Y TEJIDO SUBCUTÁNEO"
  },
  {
    "codigo":20871009,
    "descripcion":"INTOXICACIÓN POR PCP (FENCICLIDINA)"
  },
  {
    "codigo":1264220002,
    "descripcion":"INFECCIÓN FETAL CAUSADA POR BACTERIA ANAEROBIA"
  },
  {
    "codigo":19036004,
    "descripcion":"ESTENOSIS DE VÁLVULA CARDÍACA REUMÁTICA"
  },
  {
    "codigo":16040431000119100,
    "descripcion":"ARTRITIS IDIOPÁTICA JUVENIL DE INICIO SISTÉMICO DE AMBAS MANOS"
  },
  {
    "codigo":312113007,
    "descripcion":"CARCINOMA DE COLON DESCENDENTE"
  },
  {
    "codigo":1196849009,
    "descripcion":"LINFANGIOMA DE CONJUNTIVA"
  },
  {
    "codigo":898267000,
    "descripcion":"ANQUILOSIS CONGÉNITA DE ARTICULACIÓN INTERFALÁNGICA PROXIMAL DE DEDO MEÑIQUE"
  },
  {
    "codigo":80902009,
    "descripcion":"ENFERMEDAD DE HARTNUP"
  },
  {
    "codigo":111835002,
    "descripcion":"INFECCIÓN CAUSADA POR CAMPYLOBACTER FETUS"
  },
  {
    "codigo":211974009,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO PROFUNDA DE DEDO(S) DEL PIE"
  },
  {
    "codigo":208304003,
    "descripcion":"FRACTURA EXPUESTA DE RADIO PROXIMAL, CONMINUTA"
  },
  {
    "codigo":404912005,
    "descripcion":"CAÍDAS INEXPLICADAS"
  },
  {
    "codigo":44464006,
    "descripcion":"ERISIPELA POSTPARTO Y\/O PUERPERAL"
  },
  {
    "codigo":403077001,
    "descripcion":"TIÑA CAUSADA POR MICROSPORUM NANUM"
  },
  {
    "codigo":15686281000119101,
    "descripcion":"ARTRITIS REUMATOIDE DE AMBOS PIES"
  },
  {
    "codigo":366639005,
    "descripcion":"AMPLITUD DE INVERSIÓN PASIVA DE ARTICULACIÓN SUBASTRAGALINA - HALLAZGO"
  },
  {
    "codigo":1251375006,
    "descripcion":"DERMATITIS DE CONTACTO DE PIEL PERIANAL"
  },
  {
    "codigo":71727007,
    "descripcion":"INDURACIÓN DE PULMÓN"
  },
  {
    "codigo":397572000,
    "descripcion":"QUERATOUVEÍTIS POR HERPES SIMPLE"
  },
  {
    "codigo":38959009,
    "descripcion":"METAHEMOGLOBINEMIA"
  },
  {
    "codigo":301103009,
    "descripcion":"VÁLVULA MITRAL NORMAL"
  },
  {
    "codigo":299268007,
    "descripcion":"AMPLITUD DE ABDUCCIÓN PASIVA DE LA CADERA NORMAL"
  },
  {
    "codigo":4356008,
    "descripcion":"RECESIÓN GINGIVAL"
  },
  {
    "codigo":364804009,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA INICIAR EL REFLEJO DE DEGLUCIÓN"
  },
  {
    "codigo":231897001,
    "descripcion":"ÚLCERA CORNEAL INFLAMATORIA"
  },
  {
    "codigo":788953003,
    "descripcion":"PÉRDIDA DE AUDICIÓN HEREDITARIA"
  },
  {
    "codigo":362969004,
    "descripcion":"TRASTORNO DEL SISTEMA ENDOCRINO"
  },
  {
    "codigo":200964008,
    "descripcion":"PSORIASIS DIFUSA"
  },
  {
    "codigo":102660008,
    "descripcion":"NIVEL DE GLUCOSA FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":361134000,
    "descripcion":"ALTERACIÓN DE LA FRECUENCIA CARDÍACA"
  },
  {
    "codigo":2521009,
    "descripcion":"PRUEBA DE RINNE ANORMAL"
  },
  {
    "codigo":262830005,
    "descripcion":"LESIÓN DE CONDUCTO PANCREÁTICO"
  },
  {
    "codigo":295598008,
    "descripcion":"SOBREDOSIS DE FÁRMACO ALQUILANTE"
  },
  {
    "codigo":721582009,
    "descripcion":"NEOPLASIA FIBROHISTIOCÍTICA BENIGNA DE PARTES BLANDAS DE EXTREMIDAD"
  },
  {
    "codigo":197294009,
    "descripcion":"CIRROSIS PORTAL GRASA"
  },
  {
    "codigo":6024006,
    "descripcion":"INTOXICACIÓN CAUSADA POR NITRAZEPAM"
  },
  {
    "codigo":230062009,
    "descripcion":"FUMADOR MODERADO DE CIGARRILLOS"
  },
  {
    "codigo":293763006,
    "descripcion":"ALERGIA A PLICAMICINA"
  },
  {
    "codigo":719747008,
    "descripcion":"CAPAZ DE RECORDAR RUTINAS"
  },
  {
    "codigo":128088003,
    "descripcion":"TRASTORNO EN EL PROCESO DE COAGULACIÓN SANGUÍNEA, CATEGORIZADO POR EL VALOR DE LA PRUEBA DE CRIBADO"
  },
  {
    "codigo":291928004,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR VITAMINA K"
  },
  {
    "codigo":95320005,
    "descripcion":"TRASTORNO DE LA PIEL"
  },
  {
    "codigo":340771000119106,
    "descripcion":"QUISTE EXUDATIVO DE IRIS DE OJO IZQUIERDO"
  },
  {
    "codigo":716077006,
    "descripcion":"TERATOMA DE OVARIO"
  },
  {
    "codigo":290093007,
    "descripcion":"PEZÓN DESPIGMENTADO"
  },
  {
    "codigo":58882000,
    "descripcion":"GLOBO OCULAR QUÍSTICO CONGÉNITO"
  },
  {
    "codigo":419330004,
    "descripcion":"REACCIÓN ADVERSA A FACTOR LIBERADOR DE TIROTROFINA"
  },
  {
    "codigo":124418008,
    "descripcion":"DEFICIENCIA DE COLESTEROL ESTERASA"
  },
  {
    "codigo":286423002,
    "descripcion":"CAPAZ DE ABASTECERSE A SÍ MISMO"
  },
  {
    "codigo":57047004,
    "descripcion":"INTOXICACIÓN POR PHASEOLUS"
  },
  {
    "codigo":1269463004,
    "descripcion":"ADENOMA DE TIPO INTESTINAL BENIGNO DE ESTÓMAGO"
  },
  {
    "codigo":253655006,
    "descripcion":"CAYADO AÓRTICO DERECHO Y AORTA DESCENDENTE IZQUIERDA"
  },
  {
    "codigo":710572000,
    "descripcion":"OBSTRUCCIÓN INTESTINAL FUNCIONAL DEBIDA A PERISTALTISMO DISMINUIDO"
  },
  {
    "codigo":251820001,
    "descripcion":"ESTADIO 3 DE DESARROLLO DE VELLO PÚBICO DE TANNER"
  },
  {
    "codigo":448428002,
    "descripcion":"ADENOMA TUBULOVELLOSO DE RECTO"
  },
  {
    "codigo":1082701000112100,
    "descripcion":"CÁNCER DE MAMA LOCALMENTE AVANZADO"
  },
  {
    "codigo":186284005,
    "descripcion":"MENINGITIS POR PESTE"
  },
  {
    "codigo":415660007,
    "descripcion":"DISMINUCIÓN EN EL ABUSO DE SUSTANCIAS"
  },
  {
    "codigo":249985001,
    "descripcion":"MAL EQUILIBRIO"
  },
  {
    "codigo":315521002,
    "descripcion":"NACIDO EN ESLOVENIA"
  },
  {
    "codigo":446593006,
    "descripcion":"PROLIFERACIÓN OSTEOCONDROMATOSA BIZARRA PAROSTEAL"
  },
  {
    "codigo":248150005,
    "descripcion":"ASPECTO CONSISTENTE CON LA EDAD"
  },
  {
    "codigo":1231190008,
    "descripcion":"PARÁLISIS NUCLEAR DE NERVIO OCULOMOTOR"
  },
  {
    "codigo":770603000,
    "descripcion":"DISPLASIA ESPONDILOEPIMETAFISARIA LIGADA AL CROMOSOMA X"
  },
  {
    "codigo":279083003,
    "descripcion":"MOLESTIA EN BOCA"
  },
  {
    "codigo":705067008,
    "descripcion":"FRACTURA NO EXPUESTA DE FALANGE DISTAL DE SEGUNDO A QUINTO DEDOS DEL PIE"
  },
  {
    "codigo":277248002,
    "descripcion":"TUMEFACCIÓN DE CUERDAS VOCALES"
  },
  {
    "codigo":441088002,
    "descripcion":"CÉLULAS ESCAMOSAS ATÍPICAS EN EXTENDIDO DE PAPANICOLAOU DE CUELLO UTERINO QUE NO PERMITEN EXCLUIR LESIÓN INTRAEPITELIAL ESCAMOSA DE ALTO GRADO"
  },
  {
    "codigo":703232003,
    "descripcion":"HIPERALDOSTERONISMO FAMILIAR TIPO 1"
  },
  {
    "codigo":47872005,
    "descripcion":"HIPOVISCOSIDAD"
  },
  {
    "codigo":16016471000119106,
    "descripcion":"RUPTURA CRÓNICA DE LIGAMENTO LATERAL EXTERNO DE AMBAS RODILLAS"
  },
  {
    "codigo":211712007,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO PROFUNDA DE CUELLO"
  },
  {
    "codigo":766933000,
    "descripcion":"PANUVEÍTIS IDIOPÁTICA"
  },
  {
    "codigo":80640009,
    "descripcion":"ABSCESO PERIRRENAL"
  },
  {
    "codigo":646937841000119100,
    "descripcion":"TELANGIECTASIA DE MÁCULA LÚTEA DE OJO IZQUIERDO"
  },
  {
    "codigo":373717006,
    "descripcion":"MENOPAUSIA PREMATURA"
  },
  {
    "codigo":208042001,
    "descripcion":"FRACTURA VERTEBRAL EXPUESTA CON LESIÓN COMPLETA DE MÉDULA ESPINAL DORSAL, D1-6"
  },
  {
    "codigo":404650002,
    "descripcion":"ESCOTOMA PERICENTRAL"
  },
  {
    "codigo":109738004,
    "descripcion":"MARGEN GINGIVAL CORTO EN UNA RESTAURACIÓN DENTAL"
  },
  {
    "codigo":11838551000119109,
    "descripcion":"LACERACIÓN DE MÚSCULO INTRÍNSECO DE DEDO ANULAR IZQUIERDO"
  },
  {
    "codigo":240810006,
    "descripcion":"LARVA MIGRANS POR PARAGONIMIASIS"
  },
  {
    "codigo":1080561000119103,
    "descripcion":"LEIOMIOSARCOMA PRIMARIO DE RIÑÓN IZQUIERDO"
  },
  {
    "codigo":1254783002,
    "descripcion":"CARCINOMA VERRUGOSO DE TRÁQUEA"
  },
  {
    "codigo":271743003,
    "descripcion":"DESGARRO DE MEMBRANA TIMPÁNICA"
  },
  {
    "codigo":42367004,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DE PIERNA"
  },
  {
    "codigo":402815007,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS"
  },
  {
    "codigo":1285716002,
    "descripcion":"GLAUCOMA DE ÁNGULO CERRADO DE OJO DERECHO CAUSADO POR FÁRMACO"
  },
  {
    "codigo":106068003,
    "descripcion":"RITMO AURICULAR"
  },
  {
    "codigo":40532006,
    "descripcion":"MIOCARDIOPATÍA DILATADA DEBIDA A MIOCARDITIS POR PROTOZOARIOS"
  },
  {
    "codigo":237140009,
    "descripcion":"TRASTORNO OVULATORIO DEL CICLO"
  },
  {
    "codigo":38697006,
    "descripcion":"POLICITEMIA POR TRANSFUSIÓN DE MELLIZO DONANTE"
  },
  {
    "codigo":366377008,
    "descripcion":"PRUEBA DE TENSIÓN DE LA COLUMNA CERVICAL-HALLAZGO"
  },
  {
    "codigo":16782731000119102,
    "descripcion":"MELANOMA IN SITU DE FRENTE"
  },
  {
    "codigo":299006003,
    "descripcion":"AMPLITUD DE PRONACIÓN ACTIVA DE LA MUÑECA DISMINUIDA"
  },
  {
    "codigo":724990004,
    "descripcion":"EPILEPSIA DEBIDA A TRASTORNO INMUNITARIO"
  },
  {
    "codigo":67795000,
    "descripcion":"LEUCOEDEMA DE LA BOCA"
  },
  {
    "codigo":266238009,
    "descripcion":"MIOCARDITIS AISLADA DE FIEDLER"
  },
  {
    "codigo":167934009,
    "descripcion":"MÉDULA ÓSEA: CÉLULAS DE MIELOMA"
  },
  {
    "codigo":1149139006,
    "descripcion":"INTOXICACIÓN POR OXAZOLIDINADIONA"
  },
  {
    "codigo":33192001,
    "descripcion":"FRACTURA NO EXPUESTA DE EXTREMO DISTAL DE RADIO Y CÚBITO"
  },
  {
    "codigo":721320002,
    "descripcion":"FRACTURA DE CÓNDILO OCCIPITAL DEL CRÁNEO TIPO II"
  },
  {
    "codigo":426408003,
    "descripcion":"POSICIÓN SEMI FOWLER"
  },
  {
    "codigo":262568004,
    "descripcion":"HERIDA PUNZANTE PROFUNDA"
  },
  {
    "codigo":295336005,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE COMPUESTO DE BISMUTO"
  },
  {
    "codigo":459176007,
    "descripcion":"ABSCESO DE VÁLVULA AURICULOVENTRICULAR DERECHA (MORFOLÓGICAMENTE NO TRICÚSPIDE)"
  },
  {
    "codigo":1145469002,
    "descripcion":"APLASIA DE OMÓPLATO"
  },
  {
    "codigo":424573006,
    "descripcion":"DIFICULTAD PARA MANTENER RELACIONES"
  },
  {
    "codigo":95058000,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE PIEL DE CODO"
  },
  {
    "codigo":162429009,
    "descripcion":"SÍNTOMA: EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":293501008,
    "descripcion":"REACCIÓN ADVERSA AL CAPTOPRIL"
  },
  {
    "codigo":191527001,
    "descripcion":"ESQUIZOFRENIA SIMPLE"
  },
  {
    "codigo":289831003,
    "descripcion":"TROMPA DE FALOPIO - HALLAZGO"
  },
  {
    "codigo":224295006,
    "descripcion":"SÓLO RECIBIÓ EDUCACIÓN PRIMARIA"
  },
  {
    "codigo":93223008,
    "descripcion":"MELANOMA MALIGNO DE LA PIEL DE LAS CEJAS"
  },
  {
    "codigo":1303804001,
    "descripcion":"ARTRITIS DE ARTICULACIÓN DE MANO"
  },
  {
    "codigo":1172732001,
    "descripcion":"NECROSIS HEPÁTICA SUBMASIVA"
  },
  {
    "codigo":124156004,
    "descripcion":"DEFICIENCIA DE BENZALDEHÍDO DESHIDROGENASA (NADP^+^)"
  },
  {
    "codigo":345791000119100,
    "descripcion":"HIPERMETROPÍA DE AMBOS OJOS"
  },
  {
    "codigo":91388009,
    "descripcion":"PATRÓN DE USO NOCIVO DE SUSTANCIA PSICOACTIVA"
  },
  {
    "codigo":253393005,
    "descripcion":"MÚSCULO PAPILAR DE VÁLVULA TRICÚSPIDE FUSIONADO"
  },
  {
    "codigo":187857006,
    "descripcion":"NEOPLASIA MALIGNA DE CARINA BRONQUIAL"
  },
  {
    "codigo":417233008,
    "descripcion":"IDEACIÓN PARANOIDE"
  },
  {
    "codigo":286161008,
    "descripcion":"INCAPAZ DE LIMPIAR EL LAVABO"
  },
  {
    "codigo":1300134005,
    "descripcion":"REACCIÓN ADVERSA A RETEPLASA"
  },
  {
    "codigo":218790009,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR ALUCINÓGENO"
  },
  {
    "codigo":249723001,
    "descripcion":"DEFORMIDAD DE LA COLUMNA VERTEBRAL QUE NO DISMINUYE CON EL MOVIMIENTO"
  },
  {
    "codigo":1003387003,
    "descripcion":"DEFICIENCIA DE COFACTOR DE MOLIBDENO, GRUPO DE COMPLEMENTACIÓN C"
  },
  {
    "codigo":251558009,
    "descripcion":"FRECUENCIA DISMINUIDA DE LA ONDA F"
  },
  {
    "codigo":284326009,
    "descripcion":"GOLPEA OBJETOS JUNTOS"
  },
  {
    "codigo":315259006,
    "descripcion":"LESIÓN CUTÁNEA PIGMENTADA NO CICATRIZAL"
  },
  {
    "codigo":282491006,
    "descripcion":"DIFICULTAD PARA CORRER PENDIENTE ARRIBA"
  },
  {
    "codigo":1263696003,
    "descripcion":"TRASTORNO FETAL DEBIDO A EMBARAZO GEMELAR"
  },
  {
    "codigo":444496004,
    "descripcion":"ZONA ANARANJADA EN LA ESTIMACIÓN DE PESO PEDIÁTRICO DE BROSELOW LUTEN"
  },
  {
    "codigo":313424005,
    "descripcion":"CON MAYOR RIESGO DE PADECER ENFERMEDAD"
  },
  {
    "codigo":84048006,
    "descripcion":"SÍNDROME DE DEFICIENCIA DE FACTOR MÚLTIPLE FAMILIAR, TIPO I"
  },
  {
    "codigo":12115801000119101,
    "descripcion":"QUEMADURA QUÍMICA DE BRAZO DERECHO"
  },
  {
    "codigo":11788121000119101,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DE DEDO MEÑIQUE DERECHO"
  },
  {
    "codigo":80378000,
    "descripcion":"HEPATOESPLENOMEGALIA NEONATAL"
  },
  {
    "codigo":735738004,
    "descripcion":"LEISHMANIASIS CUTÁNEA LOCALIZADA"
  },
  {
    "codigo":702970004,
    "descripcion":"HÁBITO ALIMENTARIO DESCONOCIDO"
  },
  {
    "codigo":1290959000,
    "descripcion":"RADIOGRAFÍA DE TÓRAX NORMAL"
  },
  {
    "codigo":111311004,
    "descripcion":"SÍNDROME DE TRISOMÍA PARCIAL 20P"
  },
  {
    "codigo":209615005,
    "descripcion":"DESGARRO COMPLETO DE DEDO DE LA MANO, ARTICULACIÓN INTERFALÁNGICA PROXIMAL, LIGAMENTO LATERAL RADIAL"
  },
  {
    "codigo":733903006,
    "descripcion":"RESILIENCIA PSICOLÓGICA"
  },
  {
    "codigo":13007008,
    "descripcion":"PRODUCCIÓN NORMAL DE BASÓFILOS"
  },
  {
    "codigo":240548005,
    "descripcion":"INFECCIÓN MUSCULAR POR COXSACKIE"
  },
  {
    "codigo":11172006,
    "descripcion":"MARCHA DE PASO DOBLE"
  },
  {
    "codigo":109476006,
    "descripcion":"AMELOGÉNESIS IMPERFECTA, TIPO HIPOPLÁSICA"
  },
  {
    "codigo":9337000,
    "descripcion":"LUXACIÓN RECIDIVANTE DE LOCALIZACIONES MÚLTIPLES"
  },
  {
    "codigo":699300009,
    "descripcion":"SÍNDROME OCULOFACIOCARDIODENTAL"
  },
  {
    "codigo":1354660007,
    "descripcion":"CON MAYOR RIESGO DE ENFERMEDAD DE ALZHEIMER"
  },
  {
    "codigo":238713002,
    "descripcion":"VITILIGO OCUPACIONAL"
  },
  {
    "codigo":369785000,
    "descripcion":"10-20 MITOSIS POR 10 CAMPOS DE GRAN AUMENTO (PUNTAJE = 2)"
  },
  {
    "codigo":271481007,
    "descripcion":"HEMANGIOMA DE PIEL Y TEJIDO SUBCUTÁNEO"
  },
  {
    "codigo":319321000119108,
    "descripcion":"LUXACIÓN RECURRENTE DE ARTICULACIÓN DE TOBILLO DERECHO"
  },
  {
    "codigo":1156217009,
    "descripcion":"OBSTRUCCIÓN URETERAL CONGÉNITA"
  },
  {
    "codigo":402553008,
    "descripcion":"NEVOS MELANOCÍTICOS ATÍPICOS MÚLTIPLES"
  },
  {
    "codigo":304249009,
    "descripcion":"RECHAZÓ EMPLEO POR MOTIVOS MÉDICOS"
  },
  {
    "codigo":149811000146104,
    "descripcion":"AMBAS EXTREMIDADES INFERIORES PROPORCIONALMENTE LARGAS"
  },
  {
    "codigo":267811000,
    "descripcion":"TRASTORNO DEL TALLO DEL PELO"
  },
  {
    "codigo":1230344000,
    "descripcion":"SÍNDROME DE MICROFTALMÍA, MICROTIA Y ACINESIA FETAL"
  },
  {
    "codigo":366115004,
    "descripcion":"CONTENIDO DE LA FOSA NASAL ANTERIOR - HALLAZGO"
  },
  {
    "codigo":890403004,
    "descripcion":"AGENESIA BILATERAL DE ANTEBRAZO Y MANO"
  },
  {
    "codigo":202275008,
    "descripcion":"CONTRACTURA EN FLEXIÓN DE MUÑECA"
  },
  {
    "codigo":235043009,
    "descripcion":"PIGMENTACIÓN POR BILIRRUBINA DE LA MUCOSA BUCAL"
  },
  {
    "codigo":167672002,
    "descripcion":"PH FECAL DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":5667009,
    "descripcion":"SÍNDROME DE HUNTER, FORMA LEVE"
  },
  {
    "codigo":169507009,
    "descripcion":"SUSPENDE EL USO DE PRESERVATIVO ANTICONCEPTIVO"
  },
  {
    "codigo":397048000,
    "descripcion":"MARGEN QUIRÚRGICO CIRCUNFERENCIAL COMPROMETIDO POR NEOPLASIA MALIGNA"
  },
  {
    "codigo":724728006,
    "descripcion":"ALTERACIONES PERCEPTIVAS Y CONVULSIONES CONCOMITANTES CON ABSTINENCIA DE SUSTANCIA PSICOACTIVA Y DEBIDAS A ELLA"
  },
  {
    "codigo":298744008,
    "descripcion":"EMACIACIÓN DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":722893002,
    "descripcion":"FASCITIS NECROSANTE POLIMICROBIANA"
  },
  {
    "codigo":34765008,
    "descripcion":"SÍNDROME ANGIOESPÁSTICO OFTALMOAURICULAR"
  },
  {
    "codigo":1179810001,
    "descripcion":"FOLATO EN SANGRE ENTERA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1343650003,
    "descripcion":"RETINITIS DISEMINADA DE POLO POSTERIOR, BILATERAL"
  },
  {
    "codigo":162004,
    "descripcion":"TRASTORNO BIPOLAR I MANÍACO GRAVE SIN SÍNTOMAS PSICÓTICOS"
  },
  {
    "codigo":65698008,
    "descripcion":"FÍSTULA VAGINOPERINEAL"
  },
  {
    "codigo":295074008,
    "descripcion":"ALERGIA A DIAZÓXIDO"
  },
  {
    "codigo":293239004,
    "descripcion":"REACCIÓN ADVERSA AL IMPLANTE DE TESTOSTERONA"
  },
  {
    "codigo":94796001,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL CUERPO CILIAR"
  },
  {
    "codigo":1208908003,
    "descripcion":"PARÁLISIS DE NERVIO TROCLEAR ADQUIRIDA"
  },
  {
    "codigo":29260007,
    "descripcion":"DÉFICIT DE INMUNOGLOBULINA A"
  },
  {
    "codigo":289569000,
    "descripcion":"CONTINÚA GOTEO DE LÍQUIDO AMNIÓTICO"
  },
  {
    "codigo":1010465001,
    "descripcion":"AGENESIA DE HEMISFERIO CEREBELOSO IZQUIERDO"
  },
  {
    "codigo":60193003,
    "descripcion":"HIPOBETALIPOPROTEINEMIA FAMILIAR"
  },
  {
    "codigo":92961006,
    "descripcion":"AUSENCIA CONGÉNITA DE LA VENA ÁCIGOS"
  },
  {
    "codigo":191265009,
    "descripcion":"ANEMIA EN NEOPLASIA"
  },
  {
    "codigo":58358002,
    "descripcion":"ANGIODISPLASIA DE INTESTINO DELGADO"
  },
  {
    "codigo":713718006,
    "descripcion":"LINFOMA NO-HODGKIN INMUNOBLÁSTICO DIFUSO CONCOMITANTE CON INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":123894008,
    "descripcion":"INTOXICACIÓN POR BRASSICACEAE"
  },
  {
    "codigo":254966008,
    "descripcion":"EXTENSIÓN SUPRASELAR DE ADENOMA HIPOFISARIO"
  },
  {
    "codigo":220363002,
    "descripcion":"DÉFICIT DEL SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":253131002,
    "descripcion":"HIDROCEFALIA ASOCIADA CON APARICIÓN TARDÍA DE ESTENOSIS DEL ACUEDUCTO"
  },
  {
    "codigo":16050471000119104,
    "descripcion":"ARTRITIS DE ARTICULACIÓN DE AMBAS REGIONES DE RODILLA DEBIDA A INMUNIZACIÓN Y POSTERIOR A ELLA"
  },
  {
    "codigo":416971003,
    "descripcion":"POSICIÓN DE LITOTOMÍA MODIFICADA - LLOYD DAVIS"
  },
  {
    "codigo":449739006,
    "descripcion":"RUPTURA DE PIEL PERILESIONAL"
  },
  {
    "codigo":285899007,
    "descripcion":"CAPAZ DE MANEJAR SECARROPAS AUTOMÁTICO"
  },
  {
    "codigo":415136009,
    "descripcion":"PONOFOBIA"
  },
  {
    "codigo":773749003,
    "descripcion":"SÍNDROME GENITOPALATOCARDÍACO"
  },
  {
    "codigo":249461004,
    "descripcion":"ATROFIA SUPRAGLÓTICA"
  },
  {
    "codigo":1363573005,
    "descripcion":"SÍNDROME DE RETRASO DEL DESARROLLO NEUROLÓGICO, DISCAPACIDAD INTELECTUAL, ATAXIA Y DIFICULTAD PARA ALIMENTARSE"
  },
  {
    "codigo":413301003,
    "descripcion":"SE SIENTE CON RIESGO DE SER VÍCTIMA DE DELITO EN VECINDARIO"
  },
  {
    "codigo":216693007,
    "descripcion":"ENANISMO HIPOTIROIDEO"
  },
  {
    "codigo":282229003,
    "descripcion":"INCAPAZ DE CAMINAR APOYANDO PRIMERO EL TALÓN Y LUEGO LOS DEDOS"
  },
  {
    "codigo":131521000119101,
    "descripcion":"STENT METÁLICO SIN CUBIERTA EN RAMA DESCENDENTE ANTERIOR DE ARTERIA CORONARIA IZQUIERDA"
  },
  {
    "codigo":313162003,
    "descripcion":"HIPOACCIÓN DEL RECTO INTERNO DEL OJO"
  },
  {
    "codigo":18250007,
    "descripcion":"DISMINUCIÓN EN LA CIRCUNFERENCIA"
  },
  {
    "codigo":409631000,
    "descripcion":"ENFERMEDAD VIRAL AGUDA"
  },
  {
    "codigo":80116000,
    "descripcion":"CALCIFICACIÓN HETEROTÓPICA POSOPERATORIA"
  },
  {
    "codigo":737311009,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE GLÁNDULA SUBLINGUAL"
  },
  {
    "codigo":278559008,
    "descripcion":"INCRUSTACIÓN DENTAL PERDIDA"
  },
  {
    "codigo":735476006,
    "descripcion":"FÍSTULA DE TRACTO GENITOURINARIO"
  },
  {
    "codigo":1259764007,
    "descripcion":"TUMOR NEUROECTODÉRMICO PRIMITIVO SUPRATENTORIAL PRIMARIO"
  },
  {
    "codigo":405961001,
    "descripcion":"EQUIPO INTERGRUPAL PARA EL ESTUDIO POSQUIRÚRGICO DE RABDOMIOSARCOMA IIC: TUMOR DE DISEMINACIÓN LOCAL (PROPAGACIÓN A GANGLIOS LINFÁTICOS REGIONALES), TOTALMENTE RESECADO"
  },
  {
    "codigo":1290697003,
    "descripcion":"POROCARCINOMA ECRINO METASTÁSICO"
  },
  {
    "codigo":404126000,
    "descripcion":"LINFOMA CUTÁNEO PLEOMÓRFICO DE CÉLULAS T GRANDES, CD-30 POSITIVO"
  },
  {
    "codigo":76446006,
    "descripcion":"ENFERMEDAD POR EL VIRUS CHANGUINOLA"
  },
  {
    "codigo":305822009,
    "descripcion":"VISTO POR EL SERVICIO DE NEUROLOGÍA"
  },
  {
    "codigo":238451001,
    "descripcion":"DERMATOSIS PRODUCIDA POR ANIMALES"
  },
  {
    "codigo":1155955003,
    "descripcion":"ATAXIA DEBIDA A XANTOMATOSIS CEREBROTENDINOSA"
  },
  {
    "codigo":895646009,
    "descripcion":"FORMA TRIANGULAR ANORMAL CONGÉNITA DE FALANGE DE PULGAR"
  },
  {
    "codigo":205683001,
    "descripcion":"DISGENESIA OVÁRICA"
  },
  {
    "codigo":369523007,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL OVARIO IZQUIERDO"
  },
  {
    "codigo":402291009,
    "descripcion":"DERMATITIS DE CONTACTO DE MANO"
  },
  {
    "codigo":72776003,
    "descripcion":"GRANULOMA ORBITARIO"
  },
  {
    "codigo":300317000,
    "descripcion":"ANO NO PERMEABLE"
  },
  {
    "codigo":38173001,
    "descripcion":"SIGNO PATOGNOMÓNICO"
  },
  {
    "codigo":1186888009,
    "descripcion":"MIELOPATÍA DEBIDA A INYECCIÓN INTRATECAL DE AGENTE QUIMIOTERAPÉUTICO"
  },
  {
    "codigo":365853002,
    "descripcion":"IMÁGENES - HALLAZGO"
  },
  {
    "codigo":105544009,
    "descripcion":"ABSTEMIO POR MOTIVOS RELIGIOSOS"
  },
  {
    "codigo":202013003,
    "descripcion":"ARTROPATÍA TRANSITORIA DE LA ARTICULACIÓN SUBASTRAGALINA"
  },
  {
    "codigo":236616009,
    "descripcion":"REFLUJO VESICOURETERAL SECUNDARIO"
  },
  {
    "codigo":350811000119108,
    "descripcion":"NEOPLASIA BENIGNA DE BRONQUIO IZQUIERDO"
  },
  {
    "codigo":1119517008,
    "descripcion":"AGOTAMIENTO FATIGABLE DE MÚSCULO DEL HABLA"
  },
  {
    "codigo":678491000119108,
    "descripcion":"CATARATA PRESENIL DE AMBOS OJOS"
  },
  {
    "codigo":3570003,
    "descripcion":"VOLUMEN DE ERITROCITOS SANGUÍNEOS AUMENTADO"
  },
  {
    "codigo":298482004,
    "descripcion":"TEMPERATURA DE LA COLUMNA CERVICAL-HALLAZGO"
  },
  {
    "codigo":724466005,
    "descripcion":"MÁCULA MELANÓTICA DE PENE"
  },
  {
    "codigo":429554009,
    "descripcion":"ARTROPATÍA DE CODO"
  },
  {
    "codigo":722631004,
    "descripcion":"HEMORRAGIA TRAUMÁTICA DE CEREBELO"
  },
  {
    "codigo":788167006,
    "descripcion":"PACIENTE TRATADO CON MEDICACIÓN"
  },
  {
    "codigo":1735007,
    "descripcion":"FRÉMITO CATARIO"
  },
  {
    "codigo":165575007,
    "descripcion":"TIEMPO DE TROMBINA FUERA DE RANGO DE REFERENCIA"
  },
  {
    "codigo":1279687009,
    "descripcion":"FIEBRE RECURRENTE CAUSADA POR BORRELIA HISPANICA"
  },
  {
    "codigo":1148615006,
    "descripcion":"AMPLITUD DE ELECTRORRETINOGRAMA DE DESTELLO TENUE CON ADAPTACIÓN A OSCURIDAD ANORMAL"
  },
  {
    "codigo":360348000,
    "descripcion":"RESISTENCIA HIPOFISARIA A LA HORMONA TIROIDEA"
  },
  {
    "codigo":1144945000,
    "descripcion":"CARCINOMA ANEXIAL DE VULVA"
  },
  {
    "codigo":292977005,
    "descripcion":"REACCIÓN ADVERSA A LA PIPERACILINA"
  },
  {
    "codigo":129137006,
    "descripcion":"LESIÓN TRAUMÁTICA DE RAÍZ NERVIOSA"
  },
  {
    "codigo":30833006,
    "descripcion":"INFLAMACIÓN DE VESTÍBULO DE VULVA"
  },
  {
    "codigo":225606002,
    "descripcion":"MOVIMIENTO ANORMAL"
  },
  {
    "codigo":94534004,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL TABIQUE DE LA NARIZ"
  },
  {
    "codigo":291142006,
    "descripcion":"INTOXICACIÓN POR BENPERIDOL"
  },
  {
    "codigo":127302008,
    "descripcion":"LESIÓN TRAUMÁTICA ENCEFÁLICA SIN PÉRDIDA DE LA CONSCIENCIA"
  },
  {
    "codigo":28998008,
    "descripcion":"HEMORRAGIA RETINIANA"
  },
  {
    "codigo":92699002,
    "descripcion":"CARCINOMA IN SITU DE LA RETINA"
  },
  {
    "codigo":289307004,
    "descripcion":"HALLAZGO RELACIONADO CON LA PULSACIÓN DE CORDÓN UMBILICAL PROLAPSADO"
  },
  {
    "codigo":59931005,
    "descripcion":"INVERSIÓN DE LA ONDA T EN EL ELECTROCARDIOGRAMA"
  },
  {
    "codigo":1303280001,
    "descripcion":"ATAXIA CEREBELOSA ASOCIADA AL GEN PUM1"
  },
  {
    "codigo":1336048004,
    "descripcion":"EPISODIO DE USO NOCIVO DE LAXANTE"
  },
  {
    "codigo":713456006,
    "descripcion":"INFECCIÓN CAUSADA POR ENTEROVIRUS HUMANO 71"
  },
  {
    "codigo":1137605000,
    "descripcion":"BERMELLÓN DE LABIO SUPERIOR FINO"
  },
  {
    "codigo":16026511000119107,
    "descripcion":"TRASTORNO DE NERVIO PERIFÉRICO DE AMBOS MIEMBROS SUPERIORES"
  },
  {
    "codigo":416709006,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA NO EXPUESTA, ARTICULACIÓN INTERFALÁNGICA PROXIMAL DE DEDO DE LA MANO"
  },
  {
    "codigo":134031000119108,
    "descripcion":"HIPERPLASIA ENDOMETRIAL BENIGNA"
  },
  {
    "codigo":87194000,
    "descripcion":"DEFECTOS DEL HAZ DE FIBRAS NERVIOSAS RETINIANAS"
  },
  {
    "codigo":251034000,
    "descripcion":"HALLAZGO RELACIONADO CON LA RAÍZ DE LA AORTA"
  },
  {
    "codigo":283802007,
    "descripcion":"HERIDA POR MORDEDURA DE ANIMAL EN EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":773487005,
    "descripcion":"ALERGIA A DIBROMPROPAMIDINA"
  },
  {
    "codigo":118127007,
    "descripcion":"ESPÉCIMEN LIPIDÉMICO"
  },
  {
    "codigo":280132000,
    "descripcion":"TRASTORNO DE PARTES BLANDAS DEL CUELLO"
  },
  {
    "codigo":247364000,
    "descripcion":"REUMATISMO PSICÓGENO"
  },
  {
    "codigo":6131000179108,
    "descripcion":"EVALUACIÓN MAMOGRÁFICA (CATEGORÍA 4B) - ANOMALÍA SOSPECHOSA, DEBE CONSIDERARSE LA REALIZACIÓN DE UNA BIOPSIA, SOSPECHA MODERADA DE MALIGNIDAD"
  },
  {
    "codigo":1197636006,
    "descripcion":"RADÓN EN LA RESIDENCIA"
  },
  {
    "codigo":737049003,
    "descripcion":"HIPOACUSIA ADQUIRIDA SEVERA"
  },
  {
    "codigo":212761006,
    "descripcion":"INTOXICACIÓN POR PIPACETATO"
  },
  {
    "codigo":909802691000119102,
    "descripcion":"TRASTORNO BILATERAL DE RETINAS CAUSADO POR PENTOSANO POLISULFATO"
  },
  {
    "codigo":704281009,
    "descripcion":"LINFADENOPATÍA DE CABEZA Y CUELLO"
  },
  {
    "codigo":276462003,
    "descripcion":"CICATRIZACIÓN DE LA HORQUILLA VULVAR POSTERIOR"
  },
  {
    "codigo":1259502006,
    "descripcion":"CARCINOMA ADENOIDE QUÍSTICO PRIMARIO DE GLÁNDULA SALIVAL"
  },
  {
    "codigo":702446006,
    "descripcion":"LEUCEMIA MIELOIDE AGUDA QUE INVOLUCRA AL CORE BINDING FACTOR"
  },
  {
    "codigo":733379002,
    "descripcion":"MÚLTIPLES HERIDAS ABIERTAS DE DORSO INFERIOR"
  },
  {
    "codigo":241859004,
    "descripcion":"EFECTO TÓXICO CAUSADO POR DESODORANTE DE AMBIENTES EN AEROSOL"
  },
  {
    "codigo":372931005,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM HAEMOPHILUM"
  },
  {
    "codigo":307395009,
    "descripcion":"INJERTO AORTOILÍACO INFECTADO"
  },
  {
    "codigo":371096003,
    "descripcion":"HIPERTROFIA MAMARIA DEL LACTANTE"
  },
  {
    "codigo":403864006,
    "descripcion":"PAPILOMA BASOCELULAR SÓLIDO TIPO (ACANTÓSICO)"
  },
  {
    "codigo":43416006,
    "descripcion":"FIEBRE DE MUCAMBO"
  },
  {
    "codigo":41581000,
    "descripcion":"HIPERTONICIDAD MUSCULAR"
  },
  {
    "codigo":240024009,
    "descripcion":"LESIÓN DE CÁPSULA ARTICULAR DE REGIÓN DE TOBILLO"
  },
  {
    "codigo":762477002,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO PROFUNDA DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":305560006,
    "descripcion":"BAJO ATENCIÓN DE UNA ENFERMERA ESPECIALIZADA EN CONTINENCIA"
  },
  {
    "codigo":1155693005,
    "descripcion":"ETAPA DE PREPARACIÓN PARA LA DISPOSICIÓN A MODIFICAR LA CONDUCTA NUTRICIONAL"
  },
  {
    "codigo":203586000,
    "descripcion":"PRIMER RAYO DORSIFLEXIONADO ADQUIRIDO"
  },
  {
    "codigo":269122007,
    "descripcion":"LUXACIÓN EXPUESTA DE ARTICULACIÓN ATLANTO-OCCIPITAL"
  },
  {
    "codigo":1186626008,
    "descripcion":"ÚLCERA POR PRESIÓN DE LA PIEL MALEOLAR"
  },
  {
    "codigo":70679005,
    "descripcion":"PRESIÓN VENOSA CENTRAL ANORMAL"
  },
  {
    "codigo":234519006,
    "descripcion":"RECHAZO DE TRASPLANTE DE MÉDULA ÓSEA"
  },
  {
    "codigo":37911007,
    "descripcion":"LACERACIÓN OCULAR CON PROLAPSO Y\/O EXPOSICIÓN DEL TEJIDO INTRAOCULAR"
  },
  {
    "codigo":365591008,
    "descripcion":"TÍTULO DE ANTICUERPO ANTIBACTERIANO - HALLAZGO"
  },
  {
    "codigo":298220007,
    "descripcion":"LAXITUD DE ARTICULACIÓN METATARSOFALÁNGICA"
  },
  {
    "codigo":3308008,
    "descripcion":"GASTRITIS HIPERPLÁSICA - ATRÓFICA"
  },
  {
    "codigo":1344961000,
    "descripcion":"ARTRITIS REACTIVA DE SÍNFISIS PÚBICA"
  },
  {
    "codigo":722369003,
    "descripcion":"SÍNDROME NEFRÓTICO CONGÉNITO DEBIDO A ESCLEROSIS MESANGIAL DIFUSA"
  },
  {
    "codigo":394689005,
    "descripcion":"RIESGO MODERADO DE ENFERMEDAD CARDÍACA PRIMARIA"
  },
  {
    "codigo":296385006,
    "descripcion":"SOBREDOSIS DE ISOPRENALINA"
  },
  {
    "codigo":229014001,
    "descripcion":"PENETRACIÓN VAGINAL CON EL PENE"
  },
  {
    "codigo":425622004,
    "descripcion":"CICATRIZ DE MÁCULA CONSECUTIVA A TRAUMATISMO"
  },
  {
    "codigo":294550005,
    "descripcion":"ALERGIA A CEFPODOXIMA"
  },
  {
    "codigo":16002551000119103,
    "descripcion":"DOLOR DE MIEMBRO SUPERIOR IZQUIERDO CONCOMITANTE CON ISQUEMIA Y DEBIDO A ELLA"
  },
  {
    "codigo":1179286007,
    "descripcion":"INMUNODEFICIENCIA COMBINADA DEBIDO A DEFICIENCIA DE GINS1"
  },
  {
    "codigo":128875000,
    "descripcion":"LINFOMA CUTÁNEO PRIMARIO DE LINFOCITOS T GRANDES, POSITIVOS PARA EL ANTÍGENO CD30"
  },
  {
    "codigo":1144683001,
    "descripcion":"APLASIA DE FALANGE MEDIA DE QUINTO DEDO DE PIE"
  },
  {
    "codigo":817003002,
    "descripcion":"EL OJO NO SE MUEVE HACIA LA IZQUIERDA"
  },
  {
    "codigo":30571006,
    "descripcion":"PIREXIA INDUCIDA POR EL AMBIENTE EN EL RECIÉN NACIDO"
  },
  {
    "codigo":63339007,
    "descripcion":"TRASTORNO DEL CUELLO DEL ÚTERO"
  },
  {
    "codigo":716864001,
    "descripcion":"FIEBRE HEMORRÁGICA CON SÍNDROME RENAL"
  },
  {
    "codigo":290880003,
    "descripcion":"INTOXICACIÓN POR TRIPTÓFANO"
  },
  {
    "codigo":740215071000132100,
    "descripcion":"CAMBIOS CELULARES REACTIVOS EN EL UROTELIO DESPUÉS DE INMUNOTERAPIA INTRAVESICAL CON BACILO DE CALMETTE-GUÉRIN"
  },
  {
    "codigo":94272005,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL DIAFRAGMA"
  },
  {
    "codigo":241843004,
    "descripcion":"EFECTO TÓXICO CAUSADO POR DESESCAMANTE"
  },
  {
    "codigo":127040003,
    "descripcion":"ENFERMEDAD DE LA HEMOGLOBINA SS-CÉLULAS FALCIFORMES"
  },
  {
    "codigo":782400008,
    "descripcion":"NÓDULO DEL TEJIDO CELULAR SUBCUTÁNEO DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":28736004,
    "descripcion":"OSTEOARTROSIS LOCALIZADA PRIMARIA DE SITIOS MÚLTIPLES"
  },
  {
    "codigo":715029002,
    "descripcion":"NO CAMINA EN UNA HABITACIÓN"
  },
  {
    "codigo":8730001000004107,
    "descripcion":"ORGANISMO AISLADO EN CULTIVO DE SANGRE"
  },
  {
    "codigo":13530001000004108,
    "descripcion":"DEBILIDAD DE MANO DERECHA"
  },
  {
    "codigo":289045005,
    "descripcion":"NO UTILIZA CUBIERTOS PARA ALIMENTARSE"
  },
  {
    "codigo":92437008,
    "descripcion":"NEOPLASIA BENIGNA DE TIMO"
  },
  {
    "codigo":1681000119102,
    "descripcion":"ADENOCARCINOMA METASTÁSICO DE GANGLIO LINFÁTICO"
  },
  {
    "codigo":1237482005,
    "descripcion":"METÁSTASIS DE ADENOCARCINOMA PAPILAR EN TIROIDES"
  },
  {
    "codigo":418282006,
    "descripcion":"REACCIÓN ALÉRGICA CAUSADA POR PRODUCTO COSMÉTICO"
  },
  {
    "codigo":385514007,
    "descripcion":"QUEMADURA CUTÁNEA POR CALOR RADIANTE"
  },
  {
    "codigo":57834008,
    "descripcion":"TROMBOSIS DE ARTERIA PULMONAR"
  },
  {
    "codigo":1335786007,
    "descripcion":"ARTRITIS IDIOPÁTICA JUVENIL DE TOBILLO DERECHO"
  },
  {
    "codigo":254442009,
    "descripcion":"CARCINOMA IN SITU DEL SURCO BUCAL SUPERIOR"
  },
  {
    "codigo":285375003,
    "descripcion":"DOLOR DE PENE"
  },
  {
    "codigo":55999004,
    "descripcion":"ENCEFALOCELE"
  },
  {
    "codigo":15648401000119104,
    "descripcion":"ANEURISMA DE ARTERIA CARÓTIDA INTERNA IZQUIERDA"
  },
  {
    "codigo":283540000,
    "descripcion":"HERIDA PUNZANTE DE DEDO DE PIE"
  },
  {
    "codigo":1268415009,
    "descripcion":"PÉRDIDA DE AUDICIÓN NEUROSENSORIAL DE ALTA FRECUENCIA"
  },
  {
    "codigo":86932005,
    "descripcion":"INTOXICACIÓN POR URTICA INCISA"
  },
  {
    "codigo":185236006,
    "descripcion":"ATENDIDO EN LA CASA DEL DOCTOR"
  },
  {
    "codigo":871529001,
    "descripcion":"REACCIÓN ADVERSA A HORMONA"
  },
  {
    "codigo":329361000119107,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DEBIDO A OCLUSIÓN DE ARTERIA CEREBRAL MEDIA DERECHA POR ÉMBOLO"
  },
  {
    "codigo":314473008,
    "descripcion":"FEV1\/FVC > 70% DE LO PREVISTO"
  },
  {
    "codigo":248937008,
    "descripcion":"PRODUCTO DE LA CONCEPCIÓN A NIVEL DEL ORIFICIO DEL CUELLO UTERINO"
  },
  {
    "codigo":443710002,
    "descripcion":"EDEMA DE DORSO DE MANO"
  },
  {
    "codigo":1363049008,
    "descripcion":"INTOXICACIÓN CAUSADA POR ANTISÉPTICO Y\/O DESINFECTANTE"
  },
  {
    "codigo":1230142006,
    "descripcion":"REABSORCIÓN DE RAÍZ DENTAL CAUSADA POR FUERZA ORTODÓNCICA"
  },
  {
    "codigo":247102009,
    "descripcion":"TRACCIÓN RETINIANA"
  },
  {
    "codigo":1162771004,
    "descripcion":"FILTRACIÓN PERIESTOMAL DE GASTROSTOMÍA"
  },
  {
    "codigo":41111000087100,
    "descripcion":"CELULITIS DE DEDO GORDO DE PIE IZQUIERDO"
  },
  {
    "codigo":704019005,
    "descripcion":"ANTICUERPO INMUNOGLOBULINA M CONTRA CITOMEGALOVIRUS DETECTADO EN SUERO"
  },
  {
    "codigo":11771691000119105,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA ANTERIOR DE CODO IZQUIERDO"
  },
  {
    "codigo":43671000087104,
    "descripcion":"CONTUSIÓN DE TALÓN DERECHO"
  },
  {
    "codigo":46231000087108,
    "descripcion":"FRACTURA DE FALANGE DE CUARTO DEDO DE PIE DERECHO"
  },
  {
    "codigo":1259240005,
    "descripcion":"ESTENOSIS DE URETRA BULBAR"
  },
  {
    "codigo":79592006,
    "descripcion":"TALASEMIA BETA MÁS"
  },
  {
    "codigo":472808008,
    "descripcion":"FÍSTULA CARDIOVASCULAR DEBIDA A ENDOCARDITIS"
  },
  {
    "codigo":733117001,
    "descripcion":"SÍNDROME DE RIGIDEZ DE PULGAR, BRAQUIDACTILIA Y DISCAPACIDAD INTELECTUAL"
  },
  {
    "codigo":208829002,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN CARPOMETACARPIANA"
  },
  {
    "codigo":66568003,
    "descripcion":"BLOQUEO DE RAMA DERECHA, HEMIBLOQUEO POSTERIOR COMPLETO Y HEMIBLOQUEO ANTERIOR INCOMPLETO IZQUIERDO"
  },
  {
    "codigo":307133008,
    "descripcion":"DILATACIÓN QUÍSTICA DE CONDUCTO INTRAHEPÁTICO"
  },
  {
    "codigo":272530002,
    "descripcion":"BIPEDESTACIÓN CON UN PIE ADELANTE DE OTRO"
  },
  {
    "codigo":75922002,
    "descripcion":"ANOMALÍA CONGÉNITA DE LOS HUESECILLOS DEL OÍDO"
  },
  {
    "codigo":403602005,
    "descripcion":"SÍNDROME TRÓFICO TRIGEMINAL"
  },
  {
    "codigo":239762007,
    "descripcion":"HIPERLAXITUD ARTICULAR"
  },
  {
    "codigo":303463008,
    "descripcion":"MANEJA PRÓTESIS"
  },
  {
    "codigo":301628000,
    "descripcion":"NO USA ASCENSOR DE ESCALERAS"
  },
  {
    "codigo":170556001,
    "descripcion":"AUTORIZADO A EXENCIÓN DE PRESCRIPCIÓN"
  },
  {
    "codigo":399932006,
    "descripcion":"NEOPLASIA VASCULAR DE BRAZO"
  },
  {
    "codigo":72252007,
    "descripcion":"HIPOPLASIA CONGÉNITA DE LA VENA CARDÍACA"
  },
  {
    "codigo":236092009,
    "descripcion":"HEMORRAGIA DE ANASTOMOSIS GASTROINTESTINAL"
  },
  {
    "codigo":168721002,
    "descripcion":"RADIOGRAFÍA SIMPLE DE PARTES BLANDAS DE CUELLO ANORMAL"
  },
  {
    "codigo":201489002,
    "descripcion":"ARTROPATÍA EN EL SÍNDROME DE BEHCET DE REGIÓN PÉLVICA Y DE MUSLO"
  },
  {
    "codigo":1217297002,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN DE REGIÓN DE TUBEROSIDAD ISQUIÁTICA DE GLÚTEO"
  },
  {
    "codigo":299793005,
    "descripcion":"REFLEJO DE CONGELAMIENTO, AUSENTE"
  },
  {
    "codigo":365329001,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA LIMPIAR LA BAÑERA"
  },
  {
    "codigo":363494000,
    "descripcion":"NEOPLASIA MALIGNA DE MEDIASTINO"
  },
  {
    "codigo":723942001,
    "descripcion":"COMPLICACIÓN DE LA PIEL Y EL TEJIDO SUBCUTÁNEO DESPUÉS DE QUIMIOEXFOLIACIÓN CUTÁNEA"
  },
  {
    "codigo":297958004,
    "descripcion":"ERUPCIÓN RUBELIFORME"
  },
  {
    "codigo":232422005,
    "descripcion":"AMÍGDALA CRÍPTICA"
  },
  {
    "codigo":68582006,
    "descripcion":"INTOXICACIÓN POR CINC"
  },
  {
    "codigo":328891000,
    "descripcion":"OSIFICACIÓN REDUCIDA"
  },
  {
    "codigo":66747002,
    "descripcion":"GLAUCOMA ASOCIADO CON TRASTORNO OCULAR"
  },
  {
    "codigo":33979003,
    "descripcion":"SÍNDROME DE NIEVERGELT"
  },
  {
    "codigo":722107005,
    "descripcion":"SÍNDROME DE ANOMALÍA DE OSIFICACIÓN CON RETRASO DEL DESARROLLO PSICOMOTOR"
  },
  {
    "codigo":230587007,
    "descripcion":"NEUROPATÍA EN MACROGLOBULINEMIA"
  },
  {
    "codigo":296123008,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE LORAZEPAM"
  },
  {
    "codigo":197819009,
    "descripcion":"PERIURETERITIS"
  },
  {
    "codigo":785808002,
    "descripcion":"SÍNDROME DE ANEURISMA Y OSTEOARTROSIS"
  },
  {
    "codigo":427195008,
    "descripcion":"HIPERCALIEMIA CAUSADA POR INHIBIDOR DE LA ENZIMA CONVERTIDORA DE ANGIOTENSINA"
  },
  {
    "codigo":32144005,
    "descripcion":"ANURIA TRAUMÁTICA"
  },
  {
    "codigo":195984007,
    "descripcion":"BRONQUIECTASIA RECURRENTE"
  },
  {
    "codigo":359824007,
    "descripcion":"ANENCEFALIA INCOMPLETA"
  },
  {
    "codigo":128613002,
    "descripcion":"TRASTORNO CONVULSIVO"
  },
  {
    "codigo":95845002,
    "descripcion":"DISPLASMINOGENEMIA HEREDITARIA"
  },
  {
    "codigo":1144421007,
    "descripcion":"PERFORACIÓN DE COLON TRANSVERSO"
  },
  {
    "codigo":423525008,
    "descripcion":"USO INADECUADO DE DISPOSITIVO DE COMUNICACIÓN PARA COMUNICARSE CON RECURSOS COMUNITARIOS"
  },
  {
    "codigo":126778001,
    "descripcion":"NEOPLASIA DE LA LENGUA"
  },
  {
    "codigo":292453009,
    "descripcion":"REACCIÓN ADVERSA A LA LIDOFLAZINA"
  },
  {
    "codigo":290618001,
    "descripcion":"INTOXICACIÓN POR MUSTINA"
  },
  {
    "codigo":94010004,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA PIEL DE LA AXILA"
  },
  {
    "codigo":92175003,
    "descripcion":"NEOPLASIA BENIGNA DE LA LARINGE"
  },
  {
    "codigo":288783007,
    "descripcion":"INCAPAZ DE COMUNICAR NECESIDADES Y DESEOS"
  },
  {
    "codigo":254180002,
    "descripcion":"EPIDERMÓLISIS BULLOSA SIMPLE CON PIGMENTACIÓN MANCHADA"
  },
  {
    "codigo":155876003,
    "descripcion":"RIÑÓN NO FUNCIONANTE"
  },
  {
    "codigo":874937002,
    "descripcion":"LACERACIÓN DE CORTEZA CEREBRAL CON CONMOCIÓN"
  },
  {
    "codigo":840334000,
    "descripcion":"DEFORMIDAD DE TÓRAX DEBIDA A CIFOESCOLIOSIS"
  },
  {
    "codigo":21134002,
    "descripcion":"DISCAPACIDAD"
  },
  {
    "codigo":283278002,
    "descripcion":"ASTILLA DE MADERA A NIVEL SUPERFICIAL"
  },
  {
    "codigo":1004174006,
    "descripcion":"NIVEL DE ARGININOSUCCINATO LIASA AUMENTADO EN ORINA"
  },
  {
    "codigo":707427000,
    "descripcion":"CARCINOMA VERRUGOSO PRIMARIO DE LARINGE"
  },
  {
    "codigo":838499005,
    "descripcion":"CAPAZ DE UTILIZAR PROSODIA EN EL HABLA"
  },
  {
    "codigo":248675005,
    "descripcion":"SOPLO DE EYECCIÓN AÓRTICA"
  },
  {
    "codigo":281443007,
    "descripcion":"AFLOJAMIENTO EN LA HEMIARTROPLASTIA DE LA ARTICULACIÓN DE LA CADERA"
  },
  {
    "codigo":1295416000,
    "descripcion":"ARTRITIS ESTREPTOCÓCICA DE CODO"
  },
  {
    "codigo":246840002,
    "descripcion":"HIPERTROFIA DE MÚSCULO ORBICULAR DEL OJO"
  },
  {
    "codigo":2031000124104,
    "descripcion":"DERIVADO POR MÉDICO ESPECIALISTA"
  },
  {
    "codigo":277773003,
    "descripcion":"POSICIÓN DE RODILLAS"
  },
  {
    "codigo":48397003,
    "descripcion":"ENFERMEDAD POR CRIOAGLUTININAS DEBIDA A NEUMONÍA POR MYCOPLASMA"
  },
  {
    "codigo":310541005,
    "descripcion":"TOXINA A DEL CLOSTRIDIUM DIFFICILE DETECTADA"
  },
  {
    "codigo":15629006,
    "descripcion":"INFECCIÓN CAUSADA POR DIPETALONEMA"
  },
  {
    "codigo":334381000119102,
    "descripcion":"LEUCOCORIA DERECHA"
  },
  {
    "codigo":1258978006,
    "descripcion":"HEMATOMA DISECANTE SUBCUTÁNEO"
  },
  {
    "codigo":110263004,
    "descripcion":"AERODONTALGIA"
  },
  {
    "codigo":863927004,
    "descripcion":"PRUEBA DE FUNCIÓN HEPÁTICA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":403340001,
    "descripcion":"CAMBIO DE LA COLORACIÓN DEL PELO INDUCIDO POR FÁRMACOS"
  },
  {
    "codigo":698252002,
    "descripcion":"RETRASO DE CONDUCCIÓN INTRAVENTRICULAR INESPECÍFICO"
  },
  {
    "codigo":73825003,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DE LA NALGA"
  },
  {
    "codigo":303201005,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE GANGLIOS LINFÁTICOS MÚLTIPLES"
  },
  {
    "codigo":237665007,
    "descripcion":"HIPERPROLACTINEMIA FARMACÓGENA"
  },
  {
    "codigo":170294002,
    "descripcion":"EXAMEN DEL NIÑO A LOS 39 MESES: NORMAL"
  },
  {
    "codigo":301366005,
    "descripcion":"DOLOR DE LA ESTRUCTURA DEL TRONCO"
  },
  {
    "codigo":203062006,
    "descripcion":"CONTRACTURA DE MÚSCULO FLEXOR DE LA MUÑECA"
  },
  {
    "codigo":1153334007,
    "descripcion":"GOTA AGUDA POLIARTICULAR CAUSADA POR PLOMO"
  },
  {
    "codigo":235830005,
    "descripcion":"MEGACOLON FARMACÓGENO"
  },
  {
    "codigo":792886009,
    "descripcion":"DOLOR EN PABELLÓN AURICULAR"
  },
  {
    "codigo":39222009,
    "descripcion":"OTITIS MEDIA ADHESIVA CON ADHERENCIAS ENTRE EL TÍMPANO Y EL PROMONTORIO"
  },
  {
    "codigo":233995001,
    "descripcion":"DISECCIÓN DE AORTA TORÁCICA TIPO I"
  },
  {
    "codigo":399670008,
    "descripcion":"TUMOR QUE INVADE MASIVAMENTE LA COROIDES"
  },
  {
    "codigo":102923006,
    "descripcion":"TERATOFOBIA"
  },
  {
    "codigo":365067007,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA COMUNICARSE CON DIFERENTES PERSONAS"
  },
  {
    "codigo":299531008,
    "descripcion":"AMPLITUD DE INVERSIÓN PASIVA DE ARTICULACIÓN SUBASTRAGALINA AUMENTADA"
  },
  {
    "codigo":10629831000119105,
    "descripcion":"CELULITIS DE AXILA DERECHA"
  },
  {
    "codigo":363232002,
    "descripcion":"SECUELAS NEOPLÁSICAS DE TRASTORNOS"
  },
  {
    "codigo":787381000,
    "descripcion":"METABOLIZADOR INTERMEDIO DE LA FAMILIA 3 SUBFAMILIA A MIEMBRO 4 DEL CITOCROMO P450"
  },
  {
    "codigo":428768008,
    "descripcion":"ARTROPATÍA POR CRISTALES DE CODO"
  },
  {
    "codigo":66485003,
    "descripcion":"CICATRIZ RETINIANA"
  },
  {
    "codigo":263093003,
    "descripcion":"FRACTURA-LUXACIÓN DE ARTICULACIÓN DE DEDO DEL PIE"
  },
  {
    "codigo":721845005,
    "descripcion":"DISOSTOSIS FACIOCRANEAL HIPOMANDIBULAR"
  },
  {
    "codigo":164789006,
    "descripcion":"PRUEBA ESPECIAL DEL TRACTO GASTROINTESTINAL ANORMAL"
  },
  {
    "codigo":230325003,
    "descripcion":"SÍNDROME DE MEIGE"
  },
  {
    "codigo":295861003,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE DOXEPINA"
  },
  {
    "codigo":31882001,
    "descripcion":"FRACTURA NO EXPUESTA A NIVEL DE D1 - D6 CON LESIÓN TRAUMÁTICA DE LA MÉDULA ESPINAL"
  },
  {
    "codigo":294026001,
    "descripcion":"ALERGIA A METARAMINOL"
  },
  {
    "codigo":195722003,
    "descripcion":"BRONQUITIS AGUDA POR MORAXELLA CATARRHALIS"
  },
  {
    "codigo":426933007,
    "descripcion":"INFECCIÓN POR STREPTOCOCCUS AGALACTIAE"
  },
  {
    "codigo":64650008,
    "descripcion":"NOCARDIOSIS CUTÁNEA"
  },
  {
    "codigo":720010009,
    "descripcion":"MICROFTALMÍA CON SÍNDROME DE ATROFIA ENCEFÁLICA"
  },
  {
    "codigo":292191003,
    "descripcion":"REACCIÓN ADVERSA A FACTORES ESTIMULANTES DE COLONIAS"
  },
  {
    "codigo":62815003,
    "descripcion":"LABIO LEPORINO BILATERAL INCOMPLETO"
  },
  {
    "codigo":95583008,
    "descripcion":"SECRECIÓN ECTÓPICA DE RENINA"
  },
  {
    "codigo":128351009,
    "descripcion":"INFECCIÓN OCULAR"
  },
  {
    "codigo":28212002,
    "descripcion":"LIPOFUSCINOSIS INTESTINAL"
  },
  {
    "codigo":718175009,
    "descripcion":"MIOFASCITIS MACROFÁGICA"
  },
  {
    "codigo":1142324004,
    "descripcion":"ATROFIA DE MÚSCULO PERONEO"
  },
  {
    "codigo":93748005,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE VENTRÍCULO CEREBRAL"
  },
  {
    "codigo":783711009,
    "descripcion":"ARTRITIS REACTIVA ADQUIRIDA SEXUALMENTE"
  },
  {
    "codigo":192052007,
    "descripcion":"TRASTORNO DE EMANCIPACIÓN EN EL ADULTO JOVEN"
  },
  {
    "codigo":126516008,
    "descripcion":"NEOPLASIA DE LA PIEL DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":91913001,
    "descripcion":"AUSENCIA CONGÉNITA DEL ASTRÁGALO"
  },
  {
    "codigo":11805691000119100,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA PROXIMAL DE DEDO ANULAR IZQUIERDO"
  },
  {
    "codigo":1074171000119101,
    "descripcion":"CONDROCALCINOSIS DE RODILLA IZQUIERDA"
  },
  {
    "codigo":386825004,
    "descripcion":"REACCIÓN ADAPTATIVA DE LA VEJEZ"
  },
  {
    "codigo":26377005,
    "descripcion":"EVALUACIÓN DE DISCAPACIDAD: 8%"
  },
  {
    "codigo":1236958001,
    "descripcion":"METÁSTASIS DE CARCINOMA DE COMISURA DE LABIOS"
  },
  {
    "codigo":286686003,
    "descripcion":"FANTASÍA ESQUIZOIDE - MECANISMO DE DEFENSA PSICOLÓGICA"
  },
  {
    "codigo":16638971000119103,
    "descripcion":"COMPRESIÓN DE AMBOS NERVIOS OBTURADORES"
  },
  {
    "codigo":712670006,
    "descripcion":"STREPTOCOCCUS BETA HEMOLÍTICO NO AISLADO"
  },
  {
    "codigo":253918008,
    "descripcion":"DUPLICACIÓN DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":57310008,
    "descripcion":"INTOXICACIÓN POR CLONIDINA"
  },
  {
    "codigo":353841000119100,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE CONJUNTIVA DE OJO IZQUIERDO"
  },
  {
    "codigo":15670321000119101,
    "descripcion":"CONTRACTURA CONGÉNITA DE MÚSCULO GEMELO IZQUIERDO"
  },
  {
    "codigo":23601000119102,
    "descripcion":"ABSTINENCIA DE SEDANTE"
  },
  {
    "codigo":11838001000119103,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO INTRÍNSECO DE DEDO ANULAR IZQUIERDO"
  },
  {
    "codigo":16097841000119104,
    "descripcion":"ARTROFIBROSIS DE ARTICULACIÓN DE REGIÓN DE MUÑECA DERECHA"
  },
  {
    "codigo":11779121000119103,
    "descripcion":"RUPTURA TRAUMÁTICA DE MANGUITO ROTADOR DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":15711281000119101,
    "descripcion":"TROMBOSIS VENOSA PROFUNDA AGUDA DE AMBAS EXTREMIDADES SUPERIORES POSTERIOR A BYPASS DE ARTERIA CORONARIA"
  },
  {
    "codigo":448691006,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR INHIBIDOR DE FOSFODIESTERASA 5"
  },
  {
    "codigo":333361000119108,
    "descripcion":"LAGOFTALMÍA PARALÍTICA DE PÁRPADO DERECHO"
  },
  {
    "codigo":302641000119102,
    "descripcion":"ANOMALÍA DE LA DISTANCIA ENTRE LAS ARCADAS DENTALES"
  },
  {
    "codigo":250248000,
    "descripcion":"EQUINOCITOSIS"
  },
  {
    "codigo":1080881000119105,
    "descripcion":"GLIOMA ÓPTICO MALIGNO PRIMARIO DE OJO IZQUIERDO"
  },
  {
    "codigo":292401000119107,
    "descripcion":"TRASTORNO DEL NERVIO OBTURADOR DERECHO"
  },
  {
    "codigo":105521000119109,
    "descripcion":"TRASTORNO DEL SUEÑO MIXTO DE ETIOLOGÍA ORGÁNICA"
  },
  {
    "codigo":16318001000119107,
    "descripcion":"HIPOGAMMAGLOBULINEMIA DEBIDA A MIELOMA MÚLTIPLE"
  },
  {
    "codigo":62001000119106,
    "descripcion":"INCOMPETENCIA DE TEJIDO PUBOCERVICAL"
  },
  {
    "codigo":1264221003,
    "descripcion":"INFECCIÓN NEONATAL PRECOZ CAUSADA POR HONGO"
  },
  {
    "codigo":707165003,
    "descripcion":"NO ESTÁ DE ACUERDO CON EL PLAN DE ATENCIÓN"
  },
  {
    "codigo":248413004,
    "descripcion":"PALMA HEPÁTICA"
  },
  {
    "codigo":1296989000,
    "descripcion":"CIERRE DE ÁNGULO AGUDO PRIMARIO DE AMBOS OJOS"
  },
  {
    "codigo":19037008,
    "descripcion":"ANQUILOBLÉFARON ADQUIRIDO"
  },
  {
    "codigo":182877009,
    "descripcion":"ALTERACIÓN DE LA DOSIS DE FÁRMACO"
  },
  {
    "codigo":312114001,
    "descripcion":"CARCINOMA DE ÁNGULO HEPÁTICO"
  },
  {
    "codigo":82738004,
    "descripcion":"TRASTORNO DE PÁNICO CON AGORAFOBIA, EVITACIÓN AGORAFÓBICA MODERADA Y ATAQUES DE PÁNICO MODERADOS"
  },
  {
    "codigo":1196850009,
    "descripcion":"NEOPLASIA INTRAEPITELIAL GLANDULAR DE BAJO GRADO DE ESTÓMAGO"
  },
  {
    "codigo":1290888000,
    "descripcion":"RABDOMIOSARCOMA EMBRIONARIO ANAPLÁSICO"
  },
  {
    "codigo":211975005,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO PROFUNDA DE PIE"
  },
  {
    "codigo":408583009,
    "descripcion":"ESTADO DE REGISTRO COMPARTIDO"
  },
  {
    "codigo":310421000119106,
    "descripcion":"ESCOLIOSIS IDIOPÁTICA INFANTIL DE COLUMNA VERTEBRAL CERVICAL"
  },
  {
    "codigo":898268005,
    "descripcion":"ANQUILOSIS CONGÉNITA DE ARTICULACIÓN INTERFALÁNGICA PROXIMAL DE DEDO ÍNDICE"
  },
  {
    "codigo":77233005,
    "descripcion":"CONTUSIÓN DE ÓRGANO GENITAL FEMENINO"
  },
  {
    "codigo":44465007,
    "descripcion":"ESGUINCE DE TOBILLO"
  },
  {
    "codigo":697990000,
    "descripcion":"HIPOGEUSIA"
  },
  {
    "codigo":42630001,
    "descripcion":"CÓDIGO DE PROCEDIMIENTO NO ASIGNADO"
  },
  {
    "codigo":75398000,
    "descripcion":"ORIGEN ANÓMALO DE LA ARTERIA CORONARIA"
  },
  {
    "codigo":15957141000119109,
    "descripcion":"CARCINOMA ESCAMOCELULAR METASTÁSICO DE AMBOS PULMONES"
  },
  {
    "codigo":403078006,
    "descripcion":"TIÑA CAUSADA POR TRICHOPHYTON MENTAGROPHYTES VARIANTE ERINACEI"
  },
  {
    "codigo":272006008,
    "descripcion":"SÍNDROME DERMATITIS ARTRITIS GONOCÓCICA"
  },
  {
    "codigo":9862009,
    "descripcion":"EFECTO TÓXICO DEL HIDRÓXIDO DE SODIO"
  },
  {
    "codigo":16012591000119105,
    "descripcion":"EMBOLIA DE ARTERIA POPLÍTEA IZQUIERDA"
  },
  {
    "codigo":204635008,
    "descripcion":"FÍSTULA CONGÉNITA DE GLÁNDULA SALIVAL"
  },
  {
    "codigo":71728002,
    "descripcion":"HÍGADO ACCESORIO"
  },
  {
    "codigo":301104003,
    "descripcion":"VÁLVULA PULMONAR - HALLAZGO"
  },
  {
    "codigo":1251376007,
    "descripcion":"ERUPCIÓN CUTÁNEA PUSTULOSA AGUDA"
  },
  {
    "codigo":366640007,
    "descripcion":"AMPLITUD DE INVERSIÓN ACTIVA DE ARTICULACIÓN SUBASTRAGALINA - HALLAZGO"
  },
  {
    "codigo":168197002,
    "descripcion":"BACTERIAS CULTIVADAS EN ESPÉCIMEN"
  },
  {
    "codigo":299269004,
    "descripcion":"AMPLITUD DE ABDUCCIÓN PASIVA DE LA CADERA AUMENTADA"
  },
  {
    "codigo":364805005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA ESCUPIR"
  },
  {
    "codigo":397573005,
    "descripcion":"QUERATITIS POR HERPES ZÓSTER"
  },
  {
    "codigo":200965009,
    "descripcion":"PSORIASIS EN PLACAS"
  },
  {
    "codigo":37125009,
    "descripcion":"PUPILA DILATADA"
  },
  {
    "codigo":362970003,
    "descripcion":"TRASTORNO DEL SISTEMA HEMOSTÁTICO"
  },
  {
    "codigo":231898006,
    "descripcion":"ULCERACIÓN CORNEAL MARGINAL EN GOTAS"
  },
  {
    "codigo":295599000,
    "descripcion":"SOBREDOSIS DE MITOBRONITOL"
  },
  {
    "codigo":788954009,
    "descripcion":"HIPEROSTOSIS DE CRÁNEO"
  },
  {
    "codigo":68058009,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE CODO SIN INFECCIÓN"
  },
  {
    "codigo":721583004,
    "descripcion":"SÍFILIS CONGÉNITA MUCOCUTÁNEA TEMPRANA"
  },
  {
    "codigo":361135004,
    "descripcion":"FRECUENCIA CARDÍACA ANORMAL"
  },
  {
    "codigo":230063004,
    "descripcion":"FUMADOR EMPEDERNIDO DE CIGARRILLOS"
  },
  {
    "codigo":293764000,
    "descripcion":"ALERGIA A ACLARUBICINA"
  },
  {
    "codigo":262831009,
    "descripcion":"LESIÓN DE GLÁNDULA SUPRARRENAL"
  },
  {
    "codigo":719748003,
    "descripcion":"CAPAZ DE APRENDER HABILIDADES BÁSICAS"
  },
  {
    "codigo":160857001,
    "descripcion":"LOS HIJOS ABANDONAN EL HOGAR"
  },
  {
    "codigo":717913006,
    "descripcion":"SÍNDROME DE MALFORMACIÓN BLEFARONASOFACIAL"
  },
  {
    "codigo":291929007,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR VITAMINA K"
  },
  {
    "codigo":95321009,
    "descripcion":"FISURA DE LA PIEL"
  },
  {
    "codigo":290094001,
    "descripcion":"ALTERACIÓN DE LA COLORACIÓN DEL PEZÓN"
  },
  {
    "codigo":124419000,
    "descripcion":"DEFICIENCIA DE CLOROFILASA"
  },
  {
    "codigo":1142062009,
    "descripcion":"ANEMIA MACROCÍTICA EN EL EMBARAZO"
  },
  {
    "codigo":417496004,
    "descripcion":"INFECCIÓN NEUROINVASIVA POR VIRUS DE LA ENCEFALITIS EQUINA DEL ESTE"
  },
  {
    "codigo":1269464005,
    "descripcion":"PÓLIPO ADENOMATOSO BENIGNO DE ESTÓMAGO"
  },
  {
    "codigo":253656007,
    "descripcion":"CAYADO AÓRTICO QUE DESCIENDE CENTRALMENTE"
  },
  {
    "codigo":286424008,
    "descripcion":"INCAPAZ DE ABASTECERSE A SÍ MISMO"
  },
  {
    "codigo":89816009,
    "descripcion":"MUERTO SIN SIGNOS DE ENFERMEDAD"
  },
  {
    "codigo":251821002,
    "descripcion":"ESTADIO 4 DE DESARROLLO DE VELLO PÚBICO DE TANNER"
  },
  {
    "codigo":415661006,
    "descripcion":"USO DE SUSTANCIAS INAPROPIADO, AUMENTADO"
  },
  {
    "codigo":446594000,
    "descripcion":"INFECCIÓN DE FARINGE CAUSADA POR CHLAMYDIA TRACHOMATIS"
  },
  {
    "codigo":20610004,
    "descripcion":"PARÁLISIS DE CUARTO NERVIO CRANEAL"
  },
  {
    "codigo":282754004,
    "descripcion":"LESIÓN TRAUMÁTICA GINGIVAL"
  },
  {
    "codigo":15631971000119109,
    "descripcion":"QUISTE COMPLEJO DE OVARIO IZQUIERDO"
  },
  {
    "codigo":53378008,
    "descripcion":"SÍNDROME DE PÉRDIDA DE SAL DE LA INFANCIA"
  },
  {
    "codigo":315522009,
    "descripcion":"NACIDO EN LAS ISLAS SALOMÓN"
  },
  {
    "codigo":51543003,
    "descripcion":"AGRANDAMIENTO DE CRESTA ALVEOLAR"
  },
  {
    "codigo":1231191007,
    "descripcion":"OBSTRUCCIÓN DE SISTEMA DE DRENAJE LAGRIMAL"
  },
  {
    "codigo":280919009,
    "descripcion":"TRASTORNOS CUTÁNEOS DE YAWS"
  },
  {
    "codigo":705068003,
    "descripcion":"FRACTURA NO EXPUESTA DE PLACA EPIFISARIA DE DEDOS SEGUNDO A QUINTO DEL PIE"
  },
  {
    "codigo":770604006,
    "descripcion":"SÍNDROME CEREBRAL, CEREBELOSO Y COLOBOMA LIGADO AL CROMOSOMA X"
  },
  {
    "codigo":49708008,
    "descripcion":"ANEMIA ASOCIADA CON INSUFICIENCIA RENAL CRÓNICA"
  },
  {
    "codigo":279084009,
    "descripcion":"MALESTAR TORÁCICO"
  },
  {
    "codigo":277249005,
    "descripcion":"CUERDAS VOCALES ERITEMATOSAS"
  },
  {
    "codigo":80641008,
    "descripcion":"FÍSTULA GASTROINTESTINAL EXTERNA"
  },
  {
    "codigo":111574001,
    "descripcion":"ANEMIA POR DEFICIENCIA DE COBRE"
  },
  {
    "codigo":703233008,
    "descripcion":"HIPERALDOSTERONISMO FAMILIAR TIPO 2"
  },
  {
    "codigo":766934006,
    "descripcion":"HIPOPLASIA AISLADA UNILATERAL DE HEMISFERIO CEREBELOSO"
  },
  {
    "codigo":1079191000119104,
    "descripcion":"CARCINOMA BASOCELULAR PRIMARIO DE MIEMBRO INFERIOR DERECHO"
  },
  {
    "codigo":240811005,
    "descripcion":"PARAGOMINIASIS GENERALIZADA"
  },
  {
    "codigo":208043006,
    "descripcion":"FRACTURA VERTEBRAL EXPUESTA CON LESIÓN ANTERIOR DE MÉDULA ESPINAL DORSAL, D1-6"
  },
  {
    "codigo":109739007,
    "descripcion":"MARGEN GINGIVAL GRUESO EN UNA RESTAURACIÓN DENTAL"
  },
  {
    "codigo":370048007,
    "descripcion":"INVASIÓN TUMORAL NO EVALUABLE"
  },
  {
    "codigo":73301000,
    "descripcion":"REACCIÓN FEBRIL A UNA TRANSFUSIÓN"
  },
  {
    "codigo":402816008,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS DEL ÁREA ANOGENITAL"
  },
  {
    "codigo":1254784008,
    "descripcion":"INSTRUMENTO ENDODÓNCICO FRACTURADO EN CONDUCTO DE RAÍZ DE DIENTE"
  },
  {
    "codigo":269909003,
    "descripcion":"LÍQUIDO SINOVIAL SANGUINOLENTO"
  },
  {
    "codigo":15716401000119101,
    "descripcion":"ENOSTOSIS BILATERAL DE HÚMEROS"
  },
  {
    "codigo":7765006,
    "descripcion":"QUEMADURA EPIDÉRMICA DEL CUERO CABELLUDO"
  },
  {
    "codigo":1285717006,
    "descripcion":"GLAUCOMA DE ÁNGULO CERRADO DE OJO IZQUIERDO CAUSADO POR DROGA"
  },
  {
    "codigo":237141008,
    "descripcion":"DEFECTO DE LA FASE LÚTEA"
  },
  {
    "codigo":724991000,
    "descripcion":"EPILEPSIA CONCOMITANTE CON TRASTORNO DESMIELINIZANTE Y DEBIDA A ÉL"
  },
  {
    "codigo":430079001,
    "descripcion":"SÍNDROME PERIÓDICO ASOCIADO CON CRIOPIRINA"
  },
  {
    "codigo":167935005,
    "descripcion":"MÉDULA ÓSEA: CÉLULAS TUMORALES"
  },
  {
    "codigo":299007007,
    "descripcion":"SIN AMPLITUD ACTIVA DE PRONACIÓN DE MUÑECA"
  },
  {
    "codigo":723156000,
    "descripcion":"DIPLEJÍA FLÁCCIDA DE MIEMBROS SUPERIORES"
  },
  {
    "codigo":1149140008,
    "descripcion":"INTOXICACIÓN ACCIDENTAL CAUSADA POR OXAZOLIDINADIONA"
  },
  {
    "codigo":315441000119107,
    "descripcion":"OSTEOCONDROPATÍA DE MANO DERECHA"
  },
  {
    "codigo":721321003,
    "descripcion":"FRACTURA DE CÓNDILO OCCIPITAL DEL CRÁNEO TIPO III"
  },
  {
    "codigo":459177003,
    "descripcion":"ABSCESO EN LOCALIZACIÓN DE COMUNICACIÓN INTERACURICULAR"
  },
  {
    "codigo":11784241000119107,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE DEDO MEDIO DE MANO DERECHA"
  },
  {
    "codigo":262569007,
    "descripcion":"HERIDA PROFUNDA POR MORDEDURA DE MAMÍFERO"
  },
  {
    "codigo":1145470001,
    "descripcion":"APLASIA DE ESTERNÓN"
  },
  {
    "codigo":293502001,
    "descripcion":"REACCIÓN ADVERSA A LISINOPRIL"
  },
  {
    "codigo":31358003,
    "descripcion":"COPROFILIA"
  },
  {
    "codigo":129662007,
    "descripcion":"NEUROTOXICIDAD CAUSADA POR PROCARBAZINA"
  },
  {
    "codigo":719486008,
    "descripcion":"CAPAZ DE ORGANIZAR LAS PROPIAS PRENDAS DE VESTIR"
  },
  {
    "codigo":783187005,
    "descripcion":"EOSINOFILIA PERITONEAL ASÉPTICA DEBIDA A DIÁLISIS Y POSTERIOR A ELLA"
  },
  {
    "codigo":95059008,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE PIEL DE CONDUCTO AUDITIVO EXTERNO"
  },
  {
    "codigo":420904002,
    "descripcion":"HALLAZGO RELACIONADO CON LA GLÁNDULA LAGRIMAL"
  },
  {
    "codigo":93224002,
    "descripcion":"MELANOMA MALIGNO DE LA PIEL DEL PÁRPADO"
  },
  {
    "codigo":289832005,
    "descripcion":"TROMPA DE FALOPIO, PRESENTE"
  },
  {
    "codigo":224296007,
    "descripcion":"EDUCADO HASTA EL CICLO SUPERIOR DE LA ESCUELA PRIMARIA"
  },
  {
    "codigo":419069000,
    "descripcion":"TURNO NO DISPONIBLE"
  },
  {
    "codigo":124157008,
    "descripcion":"DEFICIENCIA DE BETAÍNA - ALDEHÍDO DESHIDROGENASA"
  },
  {
    "codigo":1081701000119102,
    "descripcion":"SARCOMA PRIMARIO DE PARTES BLANDAS DE CADERA IZQUIERDA"
  },
  {
    "codigo":417234002,
    "descripcion":"TERATOMA SACRO BENIGNO"
  },
  {
    "codigo":56786000,
    "descripcion":"ESTENOSIS DE VÁLVULA PULMONAR"
  },
  {
    "codigo":253394004,
    "descripcion":"MÚSCULO PAPILAR DE VÁLVULA TRICÚSPIDE HIPOPLÁSICO"
  },
  {
    "codigo":286162001,
    "descripcion":"LIMPIA EL LAVABO"
  },
  {
    "codigo":284327000,
    "descripcion":"NO GOLPEA OBJETOS ENTRE SÍ"
  },
  {
    "codigo":251559001,
    "descripcion":"ASIMETRÍA DE LA ONDA F"
  },
  {
    "codigo":1300135006,
    "descripcion":"ALERGIA A RETEPLASA"
  },
  {
    "codigo":54951007,
    "descripcion":"INTOXICACIÓN POR CROTALARIA JUNCEA"
  },
  {
    "codigo":218791008,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR CANNABIS"
  },
  {
    "codigo":315260001,
    "descripcion":"COMPONENTE SUBCUTÁNEO DE LESIÓN CUTÁNEA PIGMENTADA"
  },
  {
    "codigo":20348002,
    "descripcion":"SÍNDROME DE TRISOMÍA DISTAL 14Q"
  },
  {
    "codigo":165512002,
    "descripcion":"RECUENTO DIFERENCIAL DE LEUCOCITOS DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":53116008,
    "descripcion":"OSTEÍTIS CONFLUYENTE DEL PEÑASCO"
  },
  {
    "codigo":1003388008,
    "descripcion":"OLIGODONCIA LIGADA AL CROMOSOMA X"
  },
  {
    "codigo":85884009,
    "descripcion":"PIOURÉTER"
  },
  {
    "codigo":313425006,
    "descripcion":"ÚLCERAS GÁSTRICAS MÚLTIPLES"
  },
  {
    "codigo":1263697007,
    "descripcion":"TRASTORNO NEONATAL PRECOZ DEBIDO A EMBARAZO GEMELAR"
  },
  {
    "codigo":82214002,
    "descripcion":"FIEBRE DE LAS TRINCHERAS"
  },
  {
    "codigo":442662004,
    "descripcion":"COPIAS DE ÁCIDO RIBONUCLEICO DEL VIRUS DE INMUNODEFICIENCIA HUMANA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":213286009,
    "descripcion":"INFECCIÓN POSOPERATORIA DE HERIDA - PROFUNDA"
  },
  {
    "codigo":735739007,
    "descripcion":"INFECCIÓN DE PIEL Y TEJIDO SUBCUTÁNEO CAUSADA POR HONGO"
  },
  {
    "codigo":733904000,
    "descripcion":"FALTA DE RESILIENCIA PSICOLÓGICA"
  },
  {
    "codigo":47611007,
    "descripcion":"INFECCIÓN CAUSADA POR BRAUNIA"
  },
  {
    "codigo":78544004,
    "descripcion":"INSUFICIENCIA RENAL HIPERTENSIVA CRÓNICA"
  },
  {
    "codigo":1290960005,
    "descripcion":"RADIOGRAFÍA DE TÓRAX ANORMAL"
  },
  {
    "codigo":209616006,
    "descripcion":"DESGARRO COMPLETO DE DEDO DE LA MANO, ARTICULACIÓN INTERFALÁNGICA PROXIMAL, LIGAMENTO LATERAL CUBITAL"
  },
  {
    "codigo":111312006,
    "descripcion":"ANOMALÍA DEL CROMOSOMA X"
  },
  {
    "codigo":240549002,
    "descripcion":"SÍNDROME NEONATAL POR VIRUS COXSACKIE"
  },
  {
    "codigo":109477002,
    "descripcion":"AMELOGÉNESIS IMPERFECTA, NEFROCALCINOSIS Y DEFECTO EN LA CONCENTRACIÓN RENAL"
  },
  {
    "codigo":10859161000119101,
    "descripcion":"HERIDA ABIERTA DE PARED TORÁCICA IZQUIERDA DEBIDA A MORDEDURA DE PERRO"
  },
  {
    "codigo":43941006,
    "descripcion":"SEUDOHIPOALDOSTERONISMO, TIPO 1"
  },
  {
    "codigo":699301008,
    "descripcion":"MALFORMACIÓN VENOSA MÚLTIPLE MUCOCUTÁNEA"
  },
  {
    "codigo":271482000,
    "descripcion":"NEOPLASIA DE HÍGADO Y CONDUCTOS BILIARES DE COMPORTAMIENTO INCIERTO"
  },
  {
    "codigo":402554002,
    "descripcion":"NEVOS MELANOCÍTICOS ERUPTIVOS"
  },
  {
    "codigo":369786004,
    "descripcion":"MÁS DE 20 MITOSIS POR 10 CAMPOS DE GRAN AUMENTO (PUNTAJE = 3)"
  },
  {
    "codigo":238714008,
    "descripcion":"ENFERMEDAD DE ANEXO CUTÁNEO"
  },
  {
    "codigo":304250009,
    "descripcion":"ESTADO DE INMUNIZACIÓN"
  },
  {
    "codigo":366116003,
    "descripcion":"HALLAZGO RELACIONADO CON EL TAMAÑO DE LAS ADENOIDES"
  },
  {
    "codigo":169508004,
    "descripcion":"FRACASO DE PRESERVATIVO ANTICONCEPTIVO - EMBARAZO"
  },
  {
    "codigo":890404005,
    "descripcion":"FOCOMELIA COMPLETA BILATERAL DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":235044003,
    "descripcion":"PIGMENTACIÓN POR HIERRO DE LA MUCOSA BUCAL"
  },
  {
    "codigo":267812007,
    "descripcion":"FOLICULITIS SUPERFICIAL"
  },
  {
    "codigo":300580009,
    "descripcion":"LESIÓN ÚNICA"
  },
  {
    "codigo":202276009,
    "descripcion":"CONTRACTURA EN EXTENSIÓN DE LA MUÑECA"
  },
  {
    "codigo":724729003,
    "descripcion":"TRASTORNO PSICÓTICO CAUSADO POR SUSTANCIA PSICOACTIVA"
  },
  {
    "codigo":823033007,
    "descripcion":"INFECCIÓN CAUSADA POR VARESTRONGYLUS"
  },
  {
    "codigo":36601008,
    "descripcion":"DISPLASIA CRANEOMETAFISARIA"
  },
  {
    "codigo":298745009,
    "descripcion":"HIPERTROFIA DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":296910002,
    "descripcion":"SOBREDOSIS DE LIOTIRONINA"
  },
  {
    "codigo":15692441000119109,
    "descripcion":"QUERATITIS LAMINAR DIFUSA DE AMBOS OJOS"
  },
  {
    "codigo":32931001,
    "descripcion":"CALCIFICACIÓN DE LA PLEURA"
  },
  {
    "codigo":1179811002,
    "descripcion":"FOLATO ERITROCÍTICO POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1343651004,
    "descripcion":"RETINITIS DISEMINADA IZQUIERDA"
  },
  {
    "codigo":295075009,
    "descripcion":"ALERGIA A HIDRALAZINA"
  },
  {
    "codigo":293240002,
    "descripcion":"REACCIÓN ADVERSA A LA TESTOSTERONA INTRAMUSCULAR"
  },
  {
    "codigo":63864004,
    "descripcion":"TRASTORNO DE LA FUNCIÓN DE PROTRUSIÓN DE LA LENGUA DEL DUODÉCIMO PAR CRANEAL"
  },
  {
    "codigo":193101001,
    "descripcion":"PARÁLISIS DE MÚLTIPLES NERVIOS CRANEALES EN LA SARCOIDOSIS"
  },
  {
    "codigo":94797005,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA CLAVÍCULA"
  },
  {
    "codigo":1208909006,
    "descripcion":"SÍNDROME DE QT PROLONGADO TIPO 6"
  },
  {
    "codigo":346931000119108,
    "descripcion":"CICATRIZ CORIORRETINIANA DE AMBOS OJOS"
  },
  {
    "codigo":291405007,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR LEVALORFANO"
  },
  {
    "codigo":289570004,
    "descripcion":"FLUJO ESCASO DE LÍQUIDO AMNIÓTICO"
  },
  {
    "codigo":92962004,
    "descripcion":"AUSENCIA CONGÉNITA DE LA ARTERIA CARÓTIDA"
  },
  {
    "codigo":846626006,
    "descripcion":"INFLAMACIÓN DE TRACTO RESPIRATORIO SUPERIOR CAUSADA POR HUMOS"
  },
  {
    "codigo":715554009,
    "descripcion":"NO SE AISLARON BACTERIAS FECALES"
  },
  {
    "codigo":123895009,
    "descripcion":"INTOXICACIÓN POR BUXACEAE"
  },
  {
    "codigo":285900002,
    "descripcion":"INCAPAZ DE MANEJAR SECARROPAS"
  },
  {
    "codigo":449740008,
    "descripcion":"TUMEFACCIÓN DE PIEL PERILESIONAL"
  },
  {
    "codigo":253132009,
    "descripcion":"HIDROCEFALIA EXTERNA"
  },
  {
    "codigo":15967181000119108,
    "descripcion":"SÍNDROME DE ROBO DE ARTERIA SUBCLAVIA DERECHA"
  },
  {
    "codigo":185761008,
    "descripcion":"CONTROL DE DIABETES BORRADO"
  },
  {
    "codigo":216694001,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR CLORDANO"
  },
  {
    "codigo":773750003,
    "descripcion":"SÍNDROME DE CARA PLANA, MICROSTOMÍA Y ANOMALÍAS DE LAS OREJAS"
  },
  {
    "codigo":1363574004,
    "descripcion":"LINFOMA DE LINFOCITOS T INTESTINALES MONOMÓRFICO EPITELIOTRÓFICO"
  },
  {
    "codigo":249462006,
    "descripcion":"EPIGLOTIS INFANTIL"
  },
  {
    "codigo":282230008,
    "descripcion":"CAMINA APOYANDO PRIMERO EL TALÓN Y LUEGO LOS DEDOS"
  },
  {
    "codigo":247627003,
    "descripcion":"FLUJO LENTO DEL PENSAMIENTO"
  },
  {
    "codigo":83787007,
    "descripcion":"PLACENTA GEMELAR MONOCORIÓNICA DIAMNIÓTICA"
  },
  {
    "codigo":313163008,
    "descripcion":"DISMINUCIÓN DE LA ACCIÓN DEL OBLICUO INFERIOR"
  },
  {
    "codigo":737312002,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA NEUROENDOCRINA DE YEYUNO"
  },
  {
    "codigo":49184003,
    "descripcion":"HIPERFONÍA"
  },
  {
    "codigo":278560003,
    "descripcion":"PÉRDIDA DE CORONA DENTAL"
  },
  {
    "codigo":276725001,
    "descripcion":"APNEA RECURRENTE DEL RECIÉN NACIDO"
  },
  {
    "codigo":211189001,
    "descripcion":"ABRASIÓN DE PIEL DE HOMBRO"
  },
  {
    "codigo":735477002,
    "descripcion":"PROLAPSO INCOMPLETO DE PARED ANTERIOR DE LA VAGINA"
  },
  {
    "codigo":1259765008,
    "descripcion":"MEDULOBLASTOMA CLÁSICO PRIMARIO"
  },
  {
    "codigo":1086721000119102,
    "descripcion":"INFECCIÓN DE MÚLTIPLES LOCALIZACIONES POR ECHINOCOCCUS GRANULOSUS"
  },
  {
    "codigo":209354002,
    "descripcion":"FRACTURA-LUXACIÓN NO EXPUESTA DE PIE"
  },
  {
    "codigo":373194006,
    "descripcion":"NO SE REMITIÓ GANGLIO LINFÁTICO"
  },
  {
    "codigo":405962008,
    "descripcion":"EQUIPO INTERGRUPAL PARA EL ESTUDIO POSQUIRÚRGICO DE RABDOMIOSARCOMA IIIA: TUMOR LOCALIZADO O DE DISEMINACIÓN LOCAL, ENFERMEDAD RESIDUAL MACROSCÓPICA LUEGO DE BIOPSIA"
  },
  {
    "codigo":1290698008,
    "descripcion":"CARCINOMA PILOMATRICIAL METASTÁSICO"
  },
  {
    "codigo":76447002,
    "descripcion":"SÍNDROME DE TRISOMÍA PARCIAL 6Q"
  },
  {
    "codigo":305823004,
    "descripcion":"VISTO POR EL SERVICIO DE MEDICINA NUCLEAR"
  },
  {
    "codigo":369524001,
    "descripcion":"TUMOR MALIGNO QUE COMPROMETE EL OVARIO IZQUIERDO POR PROPAGACIÓN DIRECTA DEL ENDOMETRIO"
  },
  {
    "codigo":402292002,
    "descripcion":"ERUPCIÓN LIQUENOIDE FRICCIONAL"
  },
  {
    "codigo":404127009,
    "descripcion":"LINFOMA CUTÁNEO INMUNOBLÁSTICO T, CD-30 POSITIVO"
  },
  {
    "codigo":205684007,
    "descripcion":"FENOTIPO DE TURNER, CARIOTIPO NORMAL"
  },
  {
    "codigo":238452008,
    "descripcion":"GRANULOMA POR PICADURA DE INSECTO"
  },
  {
    "codigo":9076009,
    "descripcion":"BALANITIS CIRCINADA"
  },
  {
    "codigo":236617000,
    "descripcion":"REFLUJO VESICOURETERAL NEUROPÁTICO"
  },
  {
    "codigo":302153001,
    "descripcion":"DISCONFORME EN EL TRABAJO"
  },
  {
    "codigo":105545005,
    "descripcion":"ABSTEMIO POR RAZONES DE SALUD"
  },
  {
    "codigo":103681000119108,
    "descripcion":"ESTRABISMO RESTRICTIVO DEBIDO A ENFERMEDAD DE GRAVES"
  },
  {
    "codigo":1119518003,
    "descripcion":"AGOTAMIENTO FATIGABLE DE MÚSCULO DE DEGLUCIÓN"
  },
  {
    "codigo":365854008,
    "descripcion":"HALLAZGO EN LA HISTORIA CLÍNICA"
  },
  {
    "codigo":396787000,
    "descripcion":"METÁSTASIS TUMORALES A GANGLIOS LINFÁTICOS NO REGIONALES, PRESENTE"
  },
  {
    "codigo":267550008,
    "descripcion":"METAHEMOGLOBINEMIA CONGÉNITA"
  },
  {
    "codigo":202014009,
    "descripcion":"ARTROPATÍA TRANSITORIA DE LA ARTICULACIÓN ASTRAGALONAVICULAR"
  },
  {
    "codigo":724467001,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE LOCALIZACIONES SUPERPUESTAS DE ÓRGANOS URINARIOS"
  },
  {
    "codigo":429555005,
    "descripcion":"ARTRITIS SACRA"
  },
  {
    "codigo":3571004,
    "descripcion":"ANEMIA MEGALOBLÁSTICA POR INSUFICIENCIA PANCREÁTICA"
  },
  {
    "codigo":167411008,
    "descripcion":"ÁCIDO VAINILLILMANDÉLICO EN ORINA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":298483009,
    "descripcion":"COLUMNA CERVICAL CALIENTE AL TACTO"
  },
  {
    "codigo":1279688004,
    "descripcion":"INFECCIÓN CAUSADA POR BORRELIA HISPANICA"
  },
  {
    "codigo":722632006,
    "descripcion":"HEMORRAGIA TRAUMÁTICA DE TRONCO ENCEFÁLICO"
  },
  {
    "codigo":34504007,
    "descripcion":"RETROGNATISMO MANDIBULAR"
  },
  {
    "codigo":130973000,
    "descripcion":"ORGASMO COITAL"
  },
  {
    "codigo":67272008,
    "descripcion":"FORÚNCULO DE LA REGIÓN DEL TRONCO"
  },
  {
    "codigo":1148616007,
    "descripcion":"FRECUENCIA DE ELECTRORRETINOGRAMA DE DESTELLO TENUE CON ADAPTACIÓN A OSCURIDAD ANORMAL"
  },
  {
    "codigo":425885002,
    "descripcion":"PATRÓN DE USO NOCIVO CONTINUO DE FENCICLIDINA"
  },
  {
    "codigo":294813004,
    "descripcion":"ALERGIA A TETRACOSACTRINA"
  },
  {
    "codigo":292978000,
    "descripcion":"REACCIÓN ADVERSA A LA AZLOCILINA"
  },
  {
    "codigo":129138001,
    "descripcion":"TRASTORNO DE LA COLUMNA DORSAL"
  },
  {
    "codigo":1144946004,
    "descripcion":"INCONTINENCIA URINARIA EXTRAURETRAL"
  },
  {
    "codigo":291143001,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR BENPERIDOL"
  },
  {
    "codigo":717127002,
    "descripcion":"SOBREDOSIS DE CAPECITABINA"
  },
  {
    "codigo":127303003,
    "descripcion":"LACERACIÓN DE LA CORTEZA CEREBRAL"
  },
  {
    "codigo":94535003,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE HUESO CORTO DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":225607006,
    "descripcion":"INCAPAZ DE ALZAR LA CABEZA"
  },
  {
    "codigo":92700001,
    "descripcion":"CARCINOMA IN SITU DEL ÁREA RETROMOLAR"
  },
  {
    "codigo":59932003,
    "descripcion":"BORRAMIENTO CERVICAL, 50%"
  },
  {
    "codigo":289308009,
    "descripcion":"LATIDO PRESENTE EN CORDÓN PROCIDENTE"
  },
  {
    "codigo":713457002,
    "descripcion":"GLAUCOMA NEOVASCULAR DEBIDO A DIABETES MELLITUS"
  },
  {
    "codigo":254705003,
    "descripcion":"NEVO DE CÉLULAS BASALES CON COMEDONES"
  },
  {
    "codigo":1336049007,
    "descripcion":"EPISODIO DE USO NOCIVO DE MÚLTIPLES SUSTANCIAS"
  },
  {
    "codigo":89030000,
    "descripcion":"GASTROENTEROPATÍA EOSINOFÍLICA CON ENFERMEDAD DEL COLÁGENO VASCULAR"
  },
  {
    "codigo":1137606004,
    "descripcion":"TEMBLOR DE LABIO"
  },
  {
    "codigo":283803002,
    "descripcion":"MORDEDURA DE ANIMAL EN EL HOMBRO"
  },
  {
    "codigo":21659007,
    "descripcion":"TRASTORNO FUNCIONAL GENERALIZADO"
  },
  {
    "codigo":773488000,
    "descripcion":"INMUNODEFICIENCIA COMBINADA POR DEFICIENCIA DE MALT1"
  },
  {
    "codigo":414875008,
    "descripcion":"DEGENERACIÓN MACULAR SENIL NO EXUDATIVA"
  },
  {
    "codigo":118128002,
    "descripcion":"ESPÉCIMEN HEMOLIZADO"
  },
  {
    "codigo":249200003,
    "descripcion":"ÚTERO ALTO"
  },
  {
    "codigo":19824006,
    "descripcion":"INFECCIÓN DE LA PIEL Y\/O DEL TEJIDO CELULAR SUBCUTÁNEO"
  },
  {
    "codigo":312901001,
    "descripcion":"SÍNDROME VITREOMACULAR POR TRACCIÓN"
  },
  {
    "codigo":1197637002,
    "descripcion":"MONÓXIDO DE CARBONO EN LA VIVIENDA"
  },
  {
    "codigo":351951000119107,
    "descripcion":"NEVO MELANOCÍTICO DE PIEL DE OREJA DERECHA"
  },
  {
    "codigo":83525004,
    "descripcion":"HIPERPLASIA MEGACARIOCÍTICA DE LA MÉDULA ÓSEA"
  },
  {
    "codigo":280133005,
    "descripcion":"TRASTORNO DE PARTES BLANDAS DEL TRONCO"
  },
  {
    "codigo":1230405007,
    "descripcion":"DERRAME PERICÁRDICO POSQUIRÚRGICO"
  },
  {
    "codigo":704282002,
    "descripcion":"FRACTURA POR OSTEOPOROSIS SECUNDARIA DE CÚBITO"
  },
  {
    "codigo":737050003,
    "descripcion":"HIPOACUSIA ADQUIRIDA PROFUNDA"
  },
  {
    "codigo":48922006,
    "descripcion":"ENFERMEDAD POR EL VIRUS RESTAN"
  },
  {
    "codigo":112623001,
    "descripcion":"APARIENCIA MOTEADA"
  },
  {
    "codigo":702447002,
    "descripcion":"SÍNDROME SIMILAR A LA ARTROGRIPOSIS"
  },
  {
    "codigo":79855003,
    "descripcion":"EPIDERMÓLISIS BULLOSA DE LA UNIÓN, CONGÉNITA"
  },
  {
    "codigo":1259503001,
    "descripcion":"DEMENCIA DEBIDA A ENFERMEDAD CREUTZFELDT-JAKOB IATROGÉNICA"
  },
  {
    "codigo":47087004,
    "descripcion":"INFECCIÓN POR ECHINOCOCCUS OLIGARTHRUS"
  },
  {
    "codigo":276463008,
    "descripcion":"DILATACIÓN DE ANO PERMEABLE"
  },
  {
    "codigo":15726441000119105,
    "descripcion":"ANQUILOSIS DE ARTICULACIÓN DE AMBOS PIES"
  },
  {
    "codigo":372932003,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM GENAVENSE"
  },
  {
    "codigo":733380004,
    "descripcion":"MÚLTIPLES HERIDAS ABIERTAS DE REGIÓN PÉLVICA"
  },
  {
    "codigo":307396005,
    "descripcion":"INJERTO AORTOFEMORAL INFECTADO"
  },
  {
    "codigo":209092006,
    "descripcion":"LUXACIÓN VERTEBRAL EXPUESTA CON LESIÓN MEDULAR COMPLETA A NIVEL DORSAL"
  },
  {
    "codigo":10649000,
    "descripcion":"HIPERFUNCIÓN HIPOFISARIA"
  },
  {
    "codigo":45252009,
    "descripcion":"INTOXICACIÓN POR ZIGADENUS"
  },
  {
    "codigo":698777002,
    "descripcion":"LESIÓN EN OJO DE BUEY EN MEMBRANA MUCOSA BUCAL"
  },
  {
    "codigo":240025005,
    "descripcion":"LESIÓN DE PARTES BLANDAS DE LA REGIÓN DEL PIE"
  },
  {
    "codigo":305561005,
    "descripcion":"BAJO ATENCIÓN DE ENFERMERA DE ENLACE PARA DIABETES"
  },
  {
    "codigo":371097007,
    "descripcion":"BLEFAROCONJUNTIVITIS ROSÁCEA"
  },
  {
    "codigo":403865007,
    "descripcion":"PAPILOMA BASOCELULAR TIPO HIPERQUERATÓSICO"
  },
  {
    "codigo":74350000,
    "descripcion":"SÍNDROME DE TRISOMÍA 9 COMPLETA"
  },
  {
    "codigo":1286766002,
    "descripcion":"SEMINOMA PRIMARIO DE TESTÍCULO NO DESCENDIDO"
  },
  {
    "codigo":1155694004,
    "descripcion":"ETAPA DE CONTEMPLACIÓN PARA LA DISPOSICIÓN A MODIFICAR LA CONDUCTA NUTRICIONAL"
  },
  {
    "codigo":41582007,
    "descripcion":"AMIGDALITITS ESTREPTOCÓCICA"
  },
  {
    "codigo":400195000,
    "descripcion":"REACCIÓN DE HIPERSENSIBILIDAD POR CONTACTO"
  },
  {
    "codigo":762478007,
    "descripcion":"QUEMADURA COMPLEJA DE HOMBRO"
  },
  {
    "codigo":269123002,
    "descripcion":"LUXACIÓN EXPUESTA DE LA ARTICULACIÓN ATLOAXOIDEA"
  },
  {
    "codigo":1284931006,
    "descripcion":"RETRACCIÓN SUPRACLAVICULAR"
  },
  {
    "codigo":39747007,
    "descripcion":"ENTERITIS NECROSANTE"
  },
  {
    "codigo":234520000,
    "descripcion":"FRACASO DE TRASPLANTE DE MÉDULA ÓSEA"
  },
  {
    "codigo":365592001,
    "descripcion":"HALLAZGO BACTERIANO EVIDENCIADO POR SEROLOGÍA"
  },
  {
    "codigo":5144008,
    "descripcion":"DIVERTÍCULO POR PULSIÓN ADQUIRIDO DEL ESÓFAGO"
  },
  {
    "codigo":298221006,
    "descripcion":"LAXITUD DE ARTICULACIÓN INTERFALÁNGICA DE DEDO DE PIE"
  },
  {
    "codigo":108701000119102,
    "descripcion":"MIOCARDIOPATÍA DEBIDA A HIPERTENSIÓN"
  },
  {
    "codigo":427458001,
    "descripcion":"SÍNDROME COMPARTIMENTAL NO TRAUMÁTICO POR EJERCICIO"
  },
  {
    "codigo":394690001,
    "descripcion":"ALTO RIESGO DE ENFERMEDAD CARDÍACA PRIMARIA"
  },
  {
    "codigo":1474004,
    "descripcion":"CARDIOPATÍA Y NEFROPATÍA HIPERTENSIVAS QUE COMPLICAN EL PARTO Y\/O CONSTITUYEN UN MOTIVO DE ATENCIÓN DURANTE ESTE PROCEDIMIENTO"
  },
  {
    "codigo":296386007,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE ISOPRENALINA"
  },
  {
    "codigo":229015000,
    "descripcion":"PENETRACIÓN VAGINAL CON LA MANO"
  },
  {
    "codigo":294551009,
    "descripcion":"ALERGIA A CEFTRIAXONA"
  },
  {
    "codigo":292716002,
    "descripcion":"REACCIÓN ADVERSA A LA PROSTAGLANDINA, SERIE F"
  },
  {
    "codigo":425623009,
    "descripcion":"ISQUEMIA LATERAL EN EL ELECTROCARDIOGRAMA"
  },
  {
    "codigo":423788005,
    "descripcion":"CAPAZ DE SENTARSE CON APOYO, INCAPAZ DE SENTARSE SIN APOYO"
  },
  {
    "codigo":1144684007,
    "descripcion":"APLASIA DE FALANGE DE SEGUNDO DEDO DE PIE"
  },
  {
    "codigo":716865000,
    "descripcion":"INFECCIÓN CONGÉNITA CAUSADA POR ENTEROVIRUS"
  },
  {
    "codigo":63340009,
    "descripcion":"ACEFALOQUIRIA"
  },
  {
    "codigo":817004008,
    "descripcion":"OJO IZQUIERDO CON PERCEPCIÓN DE MOVIMIENTO DE LA MANO"
  },
  {
    "codigo":94273000,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA SUPERFICIE DORSAL DE LA LENGUA"
  },
  {
    "codigo":127041004,
    "descripcion":"TALASEMIA - BETA DE CÉLULAS DREPANOCÍTICAS"
  },
  {
    "codigo":290881004,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR TRIPTÓFANO"
  },
  {
    "codigo":782401007,
    "descripcion":"NÓDULO DEL TEJIDO CELULAR SUBCUTÁNEO DEL PIE"
  },
  {
    "codigo":92438003,
    "descripcion":"NEOPLASIA BENIGNA DE CONDUCTO TIROGLOSO"
  },
  {
    "codigo":289046006,
    "descripcion":"DIFICULTAD PARA UTILIZAR CUBIERTOS PARA ALIMENTARSE"
  },
  {
    "codigo":715030007,
    "descripcion":"CAMINA EN UNA HABITACIÓN"
  },
  {
    "codigo":713195000,
    "descripcion":"JAEGER TIPO 15"
  },
  {
    "codigo":1237483000,
    "descripcion":"METÁSTASIS DE CARCINOMA DE LENGUA"
  },
  {
    "codigo":1335787003,
    "descripcion":"ARTRITIS IDIOPÁTICA JUVENIL DE TOBILLO"
  },
  {
    "codigo":254443004,
    "descripcion":"NEOPLASIA BENIGNA DE SURCO VESTIBULAR SUPERIOR"
  },
  {
    "codigo":385515008,
    "descripcion":"QUEMADURA DE LA PIEL POR CHISPAS"
  },
  {
    "codigo":57835009,
    "descripcion":"DEFICIENCIA DE METIONINA ADENOSILTRANSFERASA HEPÁTICA"
  },
  {
    "codigo":25067009,
    "descripcion":"FORMA VARIANTE DE TRANSTIRRETINA, AUTOSÓMICA"
  },
  {
    "codigo":449216004,
    "descripcion":"LINFOMA NO HODGKIN DIFUSO DE PARTES BLANDAS"
  },
  {
    "codigo":88768004,
    "descripcion":"GRADO DE AFECTACIÓN: DETERIORO TOTAL DE AMBOS OJOS"
  },
  {
    "codigo":86933000,
    "descripcion":"BEBEDOR EXCESIVO"
  },
  {
    "codigo":12281000132104,
    "descripcion":"LEUCEMIA MIELOIDE AGUDA RECIDIVANTE"
  },
  {
    "codigo":185237002,
    "descripcion":"ATENDIDO EN CONSULTORIO ESPECIALIZADO EN GASTROSCOPIAS"
  },
  {
    "codigo":187072009,
    "descripcion":"PARACOCCIDIOIDOMICOSIS VISCERAL"
  },
  {
    "codigo":283541001,
    "descripcion":"HERIDA PUNZANTE DE DEDO GORDO"
  },
  {
    "codigo":52330001,
    "descripcion":"MENINGOENCEFALOCELE"
  },
  {
    "codigo":609386002,
    "descripcion":"CON MAYOR RIESGO DE INSUFICIENCIA CARDÍACA"
  },
  {
    "codigo":248938003,
    "descripcion":"PUS EN EL ORIFICIO CERVICAL UTERINO"
  },
  {
    "codigo":1363050008,
    "descripcion":"DERMATITIS POR CONTACTO ALÉRGICA OCUPACIONAL CAUSADA POR ANTISÉPTICO Y\/O DESINFECTANTE"
  },
  {
    "codigo":1230143001,
    "descripcion":"REABSORCIÓN DE PROCESO ALVEOLAR CAUSADA POR FUERZA ORTODÓNCICA"
  },
  {
    "codigo":247103004,
    "descripcion":"HALLAZGO RELACIONADO CON LA RETINA Y LA COROIDES"
  },
  {
    "codigo":704020004,
    "descripcion":"FRACTURA NO EXPUESTA DE HUESO SESAMOIDEO DE PIE"
  },
  {
    "codigo":15702481000119106,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE TENDÓN DE PIERNA IZQUIERDA"
  },
  {
    "codigo":15892005,
    "descripcion":"MUCOPOLISACARIDOSIS, MPS - III - D"
  },
  {
    "codigo":81428007,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DE LA REGIÓN AXILAR"
  },
  {
    "codigo":472809000,
    "descripcion":"BLOQUEO AURICULOVENTRICULAR DEBIDO A ENDOCARDITIS"
  },
  {
    "codigo":1259241009,
    "descripcion":"ESTENOSIS DE URETRA MEMBRANOSA"
  },
  {
    "codigo":307134002,
    "descripcion":"MASA EN FOSA ILÍACA"
  },
  {
    "codigo":733118006,
    "descripcion":"SÍNDROME DE AFALANGIA, HEMIVÉRTEBRA Y DISGENESIA UROGENITAL E INTESTINAL"
  },
  {
    "codigo":403603000,
    "descripcion":"LESIÓN NEUROTRÓFICA DE LA PIEL"
  },
  {
    "codigo":10387001,
    "descripcion":"REACCIÓN AUTOINMUNITARIA MEDICAMENTOSA"
  },
  {
    "codigo":239763002,
    "descripcion":"HIPERLAXITUD ARTICULAR - PARALÍTICA"
  },
  {
    "codigo":272531003,
    "descripcion":"BIPEDESTACIÓN CON BASE DE SUSTENTACIÓN AMPLIA"
  },
  {
    "codigo":34161000087101,
    "descripcion":"MÚLTIPLES LESIONES FACIALES TRAUMÁTICAS"
  },
  {
    "codigo":39281000087103,
    "descripcion":"CUERPO EXTRAÑO EN MUSLO IZQUIERDO"
  },
  {
    "codigo":303464002,
    "descripcion":"NO MANEJA PRÓTESIS"
  },
  {
    "codigo":41841000087107,
    "descripcion":"CELULITIS DE GLÚTEO IZQUIERDO"
  },
  {
    "codigo":46961000087108,
    "descripcion":"FRACTURA DE FALANGE MEDIA DE ÍNDICE DERECHO"
  },
  {
    "codigo":44401000087109,
    "descripcion":"LACERACIÓN COMPLEJA DE REGIÓN PERIORBITARIA DE OJO DERECHO"
  },
  {
    "codigo":237928008,
    "descripcion":"TRASTORNO DEL METABOLISMO DE LA ORNITINA"
  },
  {
    "codigo":399933001,
    "descripcion":"NEOPLASIA INTRAEPITELIAL VULVAR"
  },
  {
    "codigo":236093004,
    "descripcion":"HEMORRAGIA DE ANASTOMOSIS ESOFÁGICA"
  },
  {
    "codigo":170557005,
    "descripcion":"EVALUACIÓN INICIAL DE ENFERMEDAD CRÓNICA"
  },
  {
    "codigo":301629008,
    "descripcion":"DIFICULTAD PARA USAR ELEVADOR DE ESCALERAS"
  },
  {
    "codigo":70418001,
    "descripcion":"ÚLCERA GÁSTRICA AGUDA CON HEMORRAGIA SIN OBSTRUCCIÓN"
  },
  {
    "codigo":398098001,
    "descripcion":"LACERACIÓN DE LARINGE"
  },
  {
    "codigo":299794004,
    "descripcion":"REFLEJO DE CONGELAMIENTO DUDOSO"
  },
  {
    "codigo":365330006,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA LIMPIAR LA DUCHA"
  },
  {
    "codigo":232423000,
    "descripcion":"QUISTE AMIGDALINO DE RETENCIÓN"
  },
  {
    "codigo":37650008,
    "descripcion":"DEGENERACIÓN CEREBELOSA HEREDITARIA"
  },
  {
    "codigo":68583001,
    "descripcion":"DILATACIÓN AURICULAR"
  },
  {
    "codigo":396263001,
    "descripcion":"MARGEN QUIRÚRGICO PROFUNDO COMPROMETIDO POR NEOPLASIA INTRAEPITELIAL"
  },
  {
    "codigo":363495004,
    "descripcion":"NEOPLASIA MALIGNA DE MÚSCULO"
  },
  {
    "codigo":297959007,
    "descripcion":"GRANULACIÓN CUTÁNEA"
  },
  {
    "codigo":10816261000119105,
    "descripcion":"FRACTURA EXPUESTA DE FALANGE MEDIA DE DEDO MEÑIQUE DERECHO"
  },
  {
    "codigo":197820003,
    "descripcion":"DILATACIÓN DE PELVIS RENAL"
  },
  {
    "codigo":1212005,
    "descripcion":"DERMATOMIOSITIS INFANTIL"
  },
  {
    "codigo":1240531000000103,
    "descripcion":"MIOCARDITIS DEBIDA A COVID-19"
  },
  {
    "codigo":785809005,
    "descripcion":"SÍNDROME DE MILLS"
  },
  {
    "codigo":30310000,
    "descripcion":"TRASTORNOS MENTALES ORGÁNICOS INDUCIDOS POR NICOTINA"
  },
  {
    "codigo":195985008,
    "descripcion":"BRONQUIECTASIA POSINFECCIOSA"
  },
  {
    "codigo":95846001,
    "descripcion":"SECUESTRO DE GLÓBULOS ROJOS EN EL BAZO"
  },
  {
    "codigo":292454003,
    "descripcion":"REACCIÓN ADVERSA AL NIFEDIPINO"
  },
  {
    "codigo":128614008,
    "descripcion":"ENFERMEDAD INFECCIOSA CEREBRAL"
  },
  {
    "codigo":94011000,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA PIEL DE LA ESPALDA"
  },
  {
    "codigo":423526009,
    "descripcion":"INFECCIÓN DISEMINADA POR MYCOBACTERIUM FORTUITUM"
  },
  {
    "codigo":419856000,
    "descripcion":"COLORACIÓN ANORMAL DEL PIE"
  },
  {
    "codigo":126779009,
    "descripcion":"NEOPLASIA DE LA BASE DE LA LENGUA"
  },
  {
    "codigo":290619009,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR CLORMETINA"
  },
  {
    "codigo":28475009,
    "descripcion":"DEPRESIÓN MAYOR RECURRENTE GRAVE CON SÍNTOMAS PSICÓTICOS"
  },
  {
    "codigo":92176002,
    "descripcion":"NEOPLASIA BENIGNA DE LA PORCIÓN LATERAL DEL PISO DE LA BOCA"
  },
  {
    "codigo":288784001,
    "descripcion":"EXPRESA NECESIDADES Y DESEOS"
  },
  {
    "codigo":190480009,
    "descripcion":"DEFICIENCIA DE HORMONA FOLICULOESTIMULANTE"
  },
  {
    "codigo":188645002,
    "descripcion":"RETICULOENDOTELIOSIS LEUCÉMICA DE GANGLIOS LINFÁTICOS DE CABEZA, CARA Y CUELLO"
  },
  {
    "codigo":254181003,
    "descripcion":"EPIDERMÓLISIS SIMPLE SUPERFICIAL"
  },
  {
    "codigo":24805007,
    "descripcion":"TROMBOFLEBITIS PORTAL"
  },
  {
    "codigo":10927161000119102,
    "descripcion":"FRACTURA NO EXPUESTA DE DIÁFISIS DE QUINTO HUESO METACARPIANO DE MANO IZQUIERDA"
  },
  {
    "codigo":448954003,
    "descripcion":"NEOPLASIA EPITELIAL MALIGNA DE URETRA"
  },
  {
    "codigo":874938007,
    "descripcion":"HEMORRAGIA SUBDURAL CON HERIDA INTRACRANEAL ABIERTA"
  },
  {
    "codigo":283279005,
    "descripcion":"ASTILLA DE MADERA EN CABEZA Y CUELLO"
  },
  {
    "codigo":1004175007,
    "descripcion":"NIVEL DE ÁCIDO ALFA-AMINOADÍPICO EN ORINA AUMENTADO"
  },
  {
    "codigo":16907321000119105,
    "descripcion":"ECTROPIÓN PARALÍTICO DE PÁRPADO SUPERIOR DERECHO"
  },
  {
    "codigo":838500001,
    "descripcion":"CAPAZ DE CONCENTRARSE"
  },
  {
    "codigo":281444001,
    "descripcion":"AFLOJAMIENTO DE PRÓTESIS DE REEMPLAZO TOTAL DE HOMBRO"
  },
  {
    "codigo":445284003,
    "descripcion":"ANEURISMA DE SENO DE VALSALVA AÓRTICO DESDE SENO NO CORONARIO"
  },
  {
    "codigo":248676006,
    "descripcion":"SOPLO DE EYECCIÓN PULMONAR"
  },
  {
    "codigo":19300006,
    "descripcion":"TRASTORNO BIPOLAR II GRAVE, EPISODIO MÁS RECIENTE DE CARACTERÍSTICAS DEPRESIVAS PROFUNDAS CON SÍNTOMAS PSICÓTICOS, CONGRUENTE CON EL ESTADO DE ÁNIMO"
  },
  {
    "codigo":314212008,
    "descripcion":"DOLOR ABDOMINAL DE CAUSA DESCONOCIDA"
  },
  {
    "codigo":246841003,
    "descripcion":"CANTO EXTERNO - HALLAZGO"
  },
  {
    "codigo":17465007,
    "descripcion":"NEUMATOSIS CISTOIDES INTESTINAL"
  },
  {
    "codigo":312377009,
    "descripcion":"EMBOLIA DE ARTERIA DE MIEMBRO SUPERIOR CONSECUTIVA A PROCEDIMIENTO RADIOLÓGICO"
  },
  {
    "codigo":81166004,
    "descripcion":"ENFERMEDAD POR DEFICIENCIA DE PROPERDINA"
  },
  {
    "codigo":1258979003,
    "descripcion":"PIODERMA GANGRENOSO DEBIDO A TRASTORNO HEMATOLÓGICO"
  },
  {
    "codigo":13795004,
    "descripcion":"HIPERTIROIDISMO NEONATAL"
  },
  {
    "codigo":112099006,
    "descripcion":"SIGNO DE TROUSSEAU"
  },
  {
    "codigo":896696001,
    "descripcion":"INFARTO AGUDO DE MIOCARDIO APICAL CON ELEVACIÓN DEL SEGMENTO ST"
  },
  {
    "codigo":11960004,
    "descripcion":"INTOXICACIÓN POR HELENIUM MICROCEPHALUM"
  },
  {
    "codigo":110264005,
    "descripcion":"EFECTOS DE LA QUIMIOTERAPIA"
  },
  {
    "codigo":863928009,
    "descripcion":"PRESIÓN ARTERIAL PULMONAR AUMENTADA"
  },
  {
    "codigo":440521000124106,
    "descripcion":"INGESTA EXCESIVA DE ÉSTER DE ESTEROL VEGETAL"
  },
  {
    "codigo":403341002,
    "descripcion":"CAMBIO EN EL COLOR DEL PELO, DE ETIOLOGÍA METABÓLICA"
  },
  {
    "codigo":698253007,
    "descripcion":"SÍNDROME DE SENSIBILIDAD A LA LUZ ULTRAVIOLETA"
  },
  {
    "codigo":333011000119108,
    "descripcion":"CORIORRETINITIS FOCAL DE POLO POSTERIOR DE OJO DERECHO"
  },
  {
    "codigo":401331007,
    "descripcion":"FALTA DE CONTROL DE ENFERMEDAD CORONARIA"
  },
  {
    "codigo":1351778007,
    "descripcion":"INMUNODEFICIENCIA COMBINADA AUTOSÓMICA RECESIVA DEBIDA A DEFECTO DE RAMIFICACIÓN DE FILAMENTOS MEDIADA POR ARP2\/3"
  },
  {
    "codigo":237666008,
    "descripcion":"HIPERPROLACTINEMIA FISIOLÓGICA"
  },
  {
    "codigo":203063001,
    "descripcion":"CONTRACTURA DE MÚSCULO EXTENSOR DE LA MUÑECA"
  },
  {
    "codigo":170295001,
    "descripcion":"EXAMEN DEL NIÑO A LOS 39 MESES: ANORMAL - PARA OBSERVACIÓN"
  },
  {
    "codigo":792887000,
    "descripcion":"TUMORACIÓN MAMARIA BLANDA"
  },
  {
    "codigo":301367001,
    "descripcion":"DOLOR EN EL HIPOCONDRIO DERECHO"
  },
  {
    "codigo":432439005,
    "descripcion":"EFECTO INOTRÓPICO NEGATIVO SOBRE EL MIOCARDIO"
  },
  {
    "codigo":399671007,
    "descripcion":"COMPROMISO TUMORAL DE MARGEN DE RESECCIÓN QUIRÚRGICA DE PARÉNQUIMA, NO PUEDE SER EVALUADO"
  },
  {
    "codigo":1153335008,
    "descripcion":"OSTEONECROSIS DE HUESO DEBIDA A APLASIA ERITROCÍTICA ADQUIRIDA"
  },
  {
    "codigo":235831009,
    "descripcion":"MIOPATÍA DE VÍSCERA HUECA"
  },
  {
    "codigo":299532001,
    "descripcion":"AMPLITUD DE INVERSIÓN PASIVA DE ARTICULACIÓN SUBASTRAGALINA DISMINUIDA"
  },
  {
    "codigo":233996000,
    "descripcion":"DISECCIÓN DE AORTA TORÁCICA TIPO II"
  },
  {
    "codigo":365068002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA COMUNICARSE EN DIFERENTES LUGARES"
  },
  {
    "codigo":70156005,
    "descripcion":"ANOMALÍA DEL PAR DE CROMOSOMAS 21"
  },
  {
    "codigo":102924000,
    "descripcion":"PIROFOBIA"
  },
  {
    "codigo":15953261000119105,
    "descripcion":"FISURA BILATERAL DE PEZÓN"
  },
  {
    "codigo":363233007,
    "descripcion":"SÍNDROME NEFRÓTICO POR GLOMERULONEFRITIS"
  },
  {
    "codigo":426934001,
    "descripcion":"MONOPLEJÍA DEL MIEMBRO INFERIOR QUE AFECTA AL LADO NO DOMINANTE"
  },
  {
    "codigo":230326002,
    "descripcion":"DISTONÍA OROFACIAL IDIOPÁTICA"
  },
  {
    "codigo":295862005,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE DOXEPINA"
  },
  {
    "codigo":721846006,
    "descripcion":"SÍNDROME DE HIPOMIELINIZACIÓN, HIPOGONADISMO HIPOGONADOTRÓFICO E HIPODONCIA"
  },
  {
    "codigo":787382007,
    "descripcion":"METABOLIZADOR INTERMEDIO ALTO DE LA FAMILIA 3 SUBFAMILIA A MIEMBRO 4 DEL CITOCROMO P450"
  },
  {
    "codigo":263094009,
    "descripcion":"FRACTURA-SUBLUXACIÓN DE ARTICULACIÓN"
  },
  {
    "codigo":10683911000119104,
    "descripcion":"NÓDULO DEL TEJIDO CELULAR SUBCUTÁNEO DE DEDO DE LA MANO IZQUIERDA"
  },
  {
    "codigo":294027005,
    "descripcion":"ALERGIA A METOXAMINA"
  },
  {
    "codigo":228491005,
    "descripcion":"NO CONSUME RAPÉ"
  },
  {
    "codigo":359563005,
    "descripcion":"RIÑÓN PEQUEÑO DE CAUSA DESCONOCIDA"
  },
  {
    "codigo":720011008,
    "descripcion":"USA DISPOSITIVO ORTOPÉDICO DE APOYO PARA LA MARCHA CUANDO ESTÁ DE PIE SOLO"
  },
  {
    "codigo":128352002,
    "descripcion":"ANOMALÍA ESTRUCTURAL CONGÉNITA DE CÓRNEA"
  },
  {
    "codigo":292192005,
    "descripcion":"REACCIÓN ADVERSA AL MOLGRAMOSTIM"
  },
  {
    "codigo":718176005,
    "descripcion":"DISTROFIA MUSCULAR DE LAS CINTURAS DE LAS EXTREMIDADES TIPO 2C AUTOSÓMICA RECESIVA"
  },
  {
    "codigo":93749002,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL CEREBRO"
  },
  {
    "codigo":1142325003,
    "descripcion":"ATROFIA MUSCULAR DISTAL PROGRESIVA"
  },
  {
    "codigo":126517004,
    "descripcion":"NEOPLASIA DE PIEL DE HOMBRO"
  },
  {
    "codigo":290357004,
    "descripcion":"INTOXICACIÓN POR FAMOTIDINA"
  },
  {
    "codigo":28213007,
    "descripcion":"INTOXICACIÓN POR ÓXIDO NITROSO"
  },
  {
    "codigo":421429008,
    "descripcion":"INFECCIÓN GASTROINTESTINAL CAUSADA POR KLEBSIELLA AEROGENES"
  },
  {
    "codigo":91914007,
    "descripcion":"AUSENCIA CONGÉNITA DEL TARSO"
  },
  {
    "codigo":253919000,
    "descripcion":"DUPLICACIÓN COMPLETA DE LA EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":124682009,
    "descripcion":"DEFICIENCIA DE EPIMERASA"
  },
  {
    "codigo":712671005,
    "descripcion":"ORGANISMO ANAEROBIO NO AISLADO"
  },
  {
    "codigo":1204191007,
    "descripcion":"ENFERMEDAD ARTERIAL OCLUSIVA CRÓNICA ASINTOMÁTICA"
  },
  {
    "codigo":286687007,
    "descripcion":"SUPRESIÓN - MECANISMO DE DEFENSA PSICOLÓGICA"
  },
  {
    "codigo":88244008,
    "descripcion":"ESTENOSIS CONGÉNITA DE LA VENA CAVA"
  },
  {
    "codigo":284852008,
    "descripcion":"CAPAZ DE SONARSE LA NARIZ"
  },
  {
    "codigo":1003913000,
    "descripcion":"DELECIÓN PROXIMAL DEL BRAZO CORTO DEL CROMOSOMA 7"
  },
  {
    "codigo":250249008,
    "descripcion":"ACANTOCITOSIS"
  },
  {
    "codigo":182878004,
    "descripcion":"AUMENTO DE LA MEDICACIÓN"
  },
  {
    "codigo":1264222005,
    "descripcion":"INFECCIÓN FETAL CAUSADA POR HONGO"
  },
  {
    "codigo":51806005,
    "descripcion":"UÑAS EN RAQUETA"
  },
  {
    "codigo":84574007,
    "descripcion":"VÍCTIMA DE INSURRECCIÓN CIVIL"
  },
  {
    "codigo":312115000,
    "descripcion":"CARCINOMA DE ÁNGULO ESPLÉNICO"
  },
  {
    "codigo":288011000119100,
    "descripcion":"PROBLEMA DE CONDUCTA EN LA VIDA ADULTA"
  },
  {
    "codigo":11777291000119101,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO TRÍCEPS BRAQUIAL DERECHO"
  },
  {
    "codigo":147211000119101,
    "descripcion":"TRASTORNO DEL METABOLISMO DE PROTEÍNA PLASMÁTICA"
  },
  {
    "codigo":318731000119102,
    "descripcion":"ARTROSIS DE ARTICULACIÓN DE MUÑECA DERECHA"
  },
  {
    "codigo":49971008,
    "descripcion":"ÁNIMO APREHENSIVO"
  },
  {
    "codigo":496369931000119104,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DEBIDO A TROMBOSIS DE ARTERIA CEREBELOSA DERECHA"
  },
  {
    "codigo":10735371000119106,
    "descripcion":"ECTASIA DE CONDUCTO GALACTÓFORO DE MAMA IZQUIERDA"
  },
  {
    "codigo":103691000119106,
    "descripcion":"ÚLCERA GÁSTRICA CAUSADA POR HELICOBACTER PYLORI"
  },
  {
    "codigo":298251000119108,
    "descripcion":"MIOSITIS OSIFICANTE TRAUMÁTICA DE HOMBRO"
  },
  {
    "codigo":295691000119109,
    "descripcion":"DEPÓSITO DE CALCIO EN BOLSA SEROSA DE MUÑECA"
  },
  {
    "codigo":308491000119109,
    "descripcion":"GRANULOMA POR CUERPO EXTRAÑO DE PARTES BLANDAS DE BRAZO DERECHO"
  },
  {
    "codigo":10947851000119107,
    "descripcion":"HERIDA ABIERTA DE DEDO MEDIO DE MANO IZQUIERDA DEBIDA A MORDEDURA DE ANIMAL"
  },
  {
    "codigo":12081931000119106,
    "descripcion":"QUEMADURA DE REGIÓN DE OJO IZQUIERDO"
  },
  {
    "codigo":11769611000119109,
    "descripcion":"DISTENSIÓN DE MÚSCULO DE BRAZO DERECHO"
  },
  {
    "codigo":124171000119105,
    "descripcion":"MIGRAÑA INTRATABLE CRÓNICA SIN AURA"
  },
  {
    "codigo":321291000119109,
    "descripcion":"ESPONDILÓLISIS DE VÉRTEBRA DORSAL"
  },
  {
    "codigo":898269002,
    "descripcion":"ANQUILOSIS CONGÉNITA DE ARTICULACIÓN INTERFALÁNGICA PROXIMAL DE SEGUNDO DEDO DE PIE"
  },
  {
    "codigo":211976006,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO PROFUNDA DE TOBILLO"
  },
  {
    "codigo":10850261000119102,
    "descripcion":"LACERACIÓN DE PARED TORÁCICA IZQUIERDA"
  },
  {
    "codigo":208306001,
    "descripcion":"FRACTURA EXPUESTA DEL OLÉCRANON, INTRARTICULAR"
  },
  {
    "codigo":110002002,
    "descripcion":"LEUCEMIA MASTOCÍTICA (CLÍNICO)"
  },
  {
    "codigo":372146004,
    "descripcion":"SÍNDROME TORÁCICO AGUDO"
  },
  {
    "codigo":697991001,
    "descripcion":"PARÁLISIS DE ÚVULA"
  },
  {
    "codigo":42631002,
    "descripcion":"LENGUA EN FRESA"
  },
  {
    "codigo":403079003,
    "descripcion":"TIÑA CAUSADA POR TRICHOPHYTON PERSICOLOR"
  },
  {
    "codigo":763527007,
    "descripcion":"SÍNDROME DE MONOSOMÍA 13Q DISTAL"
  },
  {
    "codigo":302940000,
    "descripcion":"ABSCESO DE VAINA TENDINOSA"
  },
  {
    "codigo":38961000,
    "descripcion":"SINUSITIS ESFENOIDAL CRÓNICA"
  },
  {
    "codigo":399409002,
    "descripcion":"PRESENCIA DE METÁSTASIS A DISTANCIA"
  },
  {
    "codigo":1251377003,
    "descripcion":"DERMATITIS DE CONTACTO DE CARA"
  },
  {
    "codigo":301105002,
    "descripcion":"LESIÓN DE VÁLVULA PULMONAR"
  },
  {
    "codigo":366641006,
    "descripcion":"AMPLITUD DE EVERSIÓN DE ARTICULACIÓN SUBASTRAGALINA - HALLAZGO"
  },
  {
    "codigo":299270003,
    "descripcion":"AMPLITUD DE ABDUCCIÓN PASIVA DE LA CADERA DISMINUIDA"
  },
  {
    "codigo":200966005,
    "descripcion":"PSORIASIS GEOGRÁFICA"
  },
  {
    "codigo":364806006,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA CHUPAR"
  },
  {
    "codigo":233734006,
    "descripcion":"MEDIASTINITIS AGUDA"
  },
  {
    "codigo":37126005,
    "descripcion":"MUECA FACIAL"
  },
  {
    "codigo":168198007,
    "descripcion":"SALMONELLA CULTIVADA EN ESPÉCIMEN"
  },
  {
    "codigo":428507003,
    "descripcion":"ESTENOSIS ATEROSCLERÓTICA DE ARTERIA BRAQUIOCEFÁLICA"
  },
  {
    "codigo":362971004,
    "descripcion":"TRASTORNO DEL SISTEMA LINFÁTICO"
  },
  {
    "codigo":788955005,
    "descripcion":"TRASTORNO DEL CONTROL DE LOS IMPULSOS CAUSADO POR COCAÍNA"
  },
  {
    "codigo":2523007,
    "descripcion":"NEUMONÍA POR SALMONELLA"
  },
  {
    "codigo":262832002,
    "descripcion":"HEMATOMA DE GLÁNDULA SUPRARRENAL"
  },
  {
    "codigo":295600002,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE MITOBRONITOL"
  },
  {
    "codigo":361136003,
    "descripcion":"PULSO CARDÍACO NORMAL"
  },
  {
    "codigo":33456005,
    "descripcion":"ANEURISMA DE ARTERIA MEDIASTÍNICA"
  },
  {
    "codigo":721584005,
    "descripcion":"SÍNDROME NEUROECTODÉRMICO DE JOHNSON"
  },
  {
    "codigo":197296006,
    "descripcion":"CIRROSIS PORTAL CAPSULAR"
  },
  {
    "codigo":426672008,
    "descripcion":"SÍNDROME DE LA IRUKANDJI"
  },
  {
    "codigo":230064005,
    "descripcion":"FUMADOR EXCESIVO DE CIGARRILLOS"
  },
  {
    "codigo":293765004,
    "descripcion":"ALERGIA A MITOXANTRONA"
  },
  {
    "codigo":719749006,
    "descripcion":"CAPAZ DE VER CON DISPOSITIVO AUXILIAR"
  },
  {
    "codigo":1075311000119108,
    "descripcion":"DEFORMIDAD DE PIE DERECHO EN FLEXIÓN PLANTAR"
  },
  {
    "codigo":717914000,
    "descripcion":"SÍNDROME DE BLEFAROFIMOSIS, PTOSIS, ESOTROPÍA, SINDACTILIA, BAJA ESTATURA"
  },
  {
    "codigo":29786001,
    "descripcion":"CONJUNTIVITIS POR LISTERIA"
  },
  {
    "codigo":95322002,
    "descripcion":"PIEL EDEMATIZADA"
  },
  {
    "codigo":128090002,
    "descripcion":"TROMBOCITOPENIA GRAVÍDICA BENIGNA"
  },
  {
    "codigo":423002004,
    "descripcion":"CONFUSIÓN CON RESPECTO AL SISTEMA DE VALORES SEXUALES"
  },
  {
    "codigo":338031000119109,
    "descripcion":"VASCULITIS DE RETINA IZQUIERDA"
  },
  {
    "codigo":160858006,
    "descripcion":"NUEVO MIEMBRO EN LA FAMILIA"
  },
  {
    "codigo":290095000,
    "descripcion":"PEZÓN ERITEMATOSO"
  },
  {
    "codigo":879919001,
    "descripcion":"MEGALENCEFALIA BILATERAL"
  },
  {
    "codigo":26116000,
    "descripcion":"INTOXICACIÓN POR CYNANCHUM"
  },
  {
    "codigo":11780361000119106,
    "descripcion":"LACERACIÓN DE MÚSCULO DE PIERNA IZQUIERDA"
  },
  {
    "codigo":188121000,
    "descripcion":"NEOPLASIA MALIGNA DE PIEL DE BRAZO"
  },
  {
    "codigo":11862281000119107,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE DEDO GORDO DE PIE IZQUIERDO"
  },
  {
    "codigo":253657003,
    "descripcion":"CAYADO AÓRTICO CERVICAL"
  },
  {
    "codigo":286425009,
    "descripcion":"SE AUTOABASTECE"
  },
  {
    "codigo":251822009,
    "descripcion":"ESTADIO 5 DE DESARROLLO DE VELLO PÚBICO DE TANNER"
  },
  {
    "codigo":282755003,
    "descripcion":"LESIÓN DE FRENTE"
  },
  {
    "codigo":315523004,
    "descripcion":"NACIDO EN SOMALÍA"
  },
  {
    "codigo":1231192000,
    "descripcion":"PARÁLISIS NUCLEAR DE NERVIO MOTOR OCULAR EXTERNO"
  },
  {
    "codigo":248152002,
    "descripcion":"MUJER"
  },
  {
    "codigo":444760002,
    "descripcion":"OSTEOMIELITIS AGUDA DE VÉRTEBRA"
  },
  {
    "codigo":442925003,
    "descripcion":"CONDROCALCINOSIS DE ARTICULACIÓN DE MUÑECA"
  },
  {
    "codigo":279085005,
    "descripcion":"SENSIBILIDAD AGUDA AL DOLOR"
  },
  {
    "codigo":705069006,
    "descripcion":"EJE LARGO DE CORAZÓN FETAL DESVIADO HACIA LA IZQUIERDA"
  },
  {
    "codigo":16832931000119108,
    "descripcion":"NEVO MELANOCÍTICO DE PIEL DE FRENTE"
  },
  {
    "codigo":80642001,
    "descripcion":"PERISTALTISMO DIGESTIVO AUMENTADO"
  },
  {
    "codigo":703234002,
    "descripcion":"HIPERALDOSTERONISMO FAMILIAR TIPO 3"
  },
  {
    "codigo":277250005,
    "descripcion":"REGIÓN SUPRAGLÓTICA - HALLAZGO"
  },
  {
    "codigo":111575000,
    "descripcion":"ANEMIA POR DEFECTO DE LA MEMBRANA CELULAR ERITROCITARIA"
  },
  {
    "codigo":275415003,
    "descripcion":"CUERPO EXTRAÑO EN URETRA PENIANA"
  },
  {
    "codigo":766935007,
    "descripcion":"LINFOMA PRIMARIO DE HUESO"
  },
  {
    "codigo":765100000,
    "descripcion":"SÍNDROME DE DEPLECIÓN DE ÁCIDO DESOXIRRIBONUCLEICO MITOCONDRIAL RELACIONADO CON LA SUBUNIDAD M2B INDUCIBLE POR RIBONUCLEÓTIDO REDUCTASA REGULADORA TP53"
  },
  {
    "codigo":240812003,
    "descripcion":"GRANULOMA POR PARAGONIMUS"
  },
  {
    "codigo":76972007,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO DE DEDO PULGAR"
  },
  {
    "codigo":42369001,
    "descripcion":"DEGENERACIÓN PALIDOPONTONIGRAL"
  },
  {
    "codigo":75137002,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN DE DEDO DE LA MANO"
  },
  {
    "codigo":109740009,
    "descripcion":"EMERGENCIA DENTAL SOBREPERFILADA"
  },
  {
    "codigo":402817004,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS DEL APARATO UNGUEAL"
  },
  {
    "codigo":271745005,
    "descripcion":"SENO PARANASAL - HALLAZGO"
  },
  {
    "codigo":370049004,
    "descripcion":"AUSENCIA DE INVASIÓN TUMORAL"
  },
  {
    "codigo":238977002,
    "descripcion":"HIPERHIDROSIS DELIRANTE"
  },
  {
    "codigo":206209004,
    "descripcion":"FRACTURA DE CLAVÍCULA POR TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":237142001,
    "descripcion":"SÍNDROME DEL FOLÍCULO LUTEINIZADO NO ROTO"
  },
  {
    "codigo":1254785009,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS ADENOIDE DE TRÁQUEA"
  },
  {
    "codigo":1285718001,
    "descripcion":"GLAUCOMA DE ÁNGULO CERRADO DE AMBOS OJOS CAUSADO POR FÁRMACO"
  },
  {
    "codigo":7766007,
    "descripcion":"ORINA DE ASPECTO TURBIO"
  },
  {
    "codigo":106070007,
    "descripcion":"HALLAZGO DURANTE LA AUSCULTACIÓN CARDÍACA"
  },
  {
    "codigo":400982009,
    "descripcion":"SEGUIMIENTO POR PODOLOGÍA"
  },
  {
    "codigo":592513751000119104,
    "descripcion":"DISTROFIA DE SUPERFICIE POSTERIOR DE CÓRNEA DE AMBOS OJOS"
  },
  {
    "codigo":366379006,
    "descripcion":"EFECTO DEL MOVIMIENTO SOBRE DEFORMIDAD VERTEBRAL - HALLAZGO"
  },
  {
    "codigo":38699009,
    "descripcion":"NEUMONÍA CAUSADA POR HISTOPLASMA CAPSULATUM"
  },
  {
    "codigo":200704001,
    "descripcion":"IMPÉTIGO CONTAGIOSO GIRADO"
  },
  {
    "codigo":724992007,
    "descripcion":"EPILEPSIA CONCOMITANTE CON DEMENCIA Y DEBIDA A ELLA"
  },
  {
    "codigo":723157009,
    "descripcion":"DIPLEJÍA ESPÁSTICA DE MIEMBROS SUPERIORES"
  },
  {
    "codigo":2261009,
    "descripcion":"EMBOLIA GRASA PULMONAR OBSTÉTRICA"
  },
  {
    "codigo":721322005,
    "descripcion":"FRACTURA DE APÓFISIS CONDÍLEA DE LA MANDÍBULA"
  },
  {
    "codigo":295338006,
    "descripcion":"SOBREDOSIS DE SUCRALFATO"
  },
  {
    "codigo":262570008,
    "descripcion":"HERIDA PROFUNDA DEBIDA A MORDEDURA HUMANA"
  },
  {
    "codigo":426008,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE TOBILLO SIN INFECCIÓN"
  },
  {
    "codigo":129663002,
    "descripcion":"NEUROTOXICIDAD CAUSADA POR VINCRISTINA"
  },
  {
    "codigo":1145471002,
    "descripcion":"APLASIA DE TIBIA"
  },
  {
    "codigo":459178008,
    "descripcion":"ENDOCARDITIS INFECCIOSA DE VÁLVULA AURICULOVENTRICULAR COMÚN"
  },
  {
    "codigo":293503006,
    "descripcion":"REACCIÓN ADVERSA A QUINAPRIL"
  },
  {
    "codigo":226132000,
    "descripcion":"DIETA MODIFICADA EN CONTENIDO DE FIBRAS"
  },
  {
    "codigo":195199008,
    "descripcion":"SÍNDROME DE ARTERIA VERTEBROBASILAR"
  },
  {
    "codigo":29524003,
    "descripcion":"ATROFIA DE LA PRÓSTATA"
  },
  {
    "codigo":95060003,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA PIEL DE LAS CEJAS"
  },
  {
    "codigo":289833000,
    "descripcion":"TROMPA DE FALOPIO, AUSENTE"
  },
  {
    "codigo":93225001,
    "descripcion":"MELANOMA MALIGNO DE LA PIEL DE LA CARA"
  },
  {
    "codigo":224297003,
    "descripcion":"EDUCADO HASTA EL NIVEL DE ESCOLARIDAD SECUNDARIA"
  },
  {
    "codigo":715817007,
    "descripcion":"LISENCEFALIA CONCOMITANTE CON HIPOPLASIA CONGÉNITA DE CEREBELO"
  },
  {
    "codigo":1010729007,
    "descripcion":"TROMBOEMBOLIA DE ARTERIA DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":124158003,
    "descripcion":"DEFICIENCIA DE GLICERALDEHÍDO - 3 - FOSFATO DESHIDROGENASA"
  },
  {
    "codigo":419070004,
    "descripcion":"HALLAZGO RELACIONADO CON LAS CARACTERÍSTICAS SEXUALES SECUNDARIAS"
  },
  {
    "codigo":16235531000119103,
    "descripcion":"ECTROPIÓN CICATRIZAL BILATERAL DE PÁRPADOS"
  },
  {
    "codigo":91390005,
    "descripcion":"ENFERMEDAD DE CROHN DEL YEYUNO"
  },
  {
    "codigo":417235001,
    "descripcion":"ROTACIÓN VERTEBRAL"
  },
  {
    "codigo":89555002,
    "descripcion":"EDEMA CARDÍACO"
  },
  {
    "codigo":253395003,
    "descripcion":"DISPLASIA DE VÁLVULA MITRAL"
  },
  {
    "codigo":286163006,
    "descripcion":"NO LIMPIA EL LAVABO"
  },
  {
    "codigo":218792001,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR LISERGIDA"
  },
  {
    "codigo":56787009,
    "descripcion":"CORIORRETINITIS Y COROIDITIS FOCAL PERIFÉRICA"
  },
  {
    "codigo":284328005,
    "descripcion":"DIFICULTAD PARA GOLPEAR OBJETOS ENTRE SÍ"
  },
  {
    "codigo":1300136007,
    "descripcion":"ALERGIA A TENECTEPLASA"
  },
  {
    "codigo":1003389000,
    "descripcion":"DUPLICACIÓN 1Q EN MOSAICO"
  },
  {
    "codigo":413565006,
    "descripcion":"ANEMIA APLÁSICA ASOCIADA CON ALTERACIÓN METABÓLICA"
  },
  {
    "codigo":343051000119108,
    "descripcion":"OJO IZQUIERDO CIEGO, BAJA VISIÓN EN OJO DERECHO"
  },
  {
    "codigo":282493009,
    "descripcion":"CAPAZ DE CORRER PENDIENTE ABAJO"
  },
  {
    "codigo":1263698002,
    "descripcion":"TRASTORNO FETAL DEBIDO A CIRUGÍA PÉLVICA MATERNA PREVIA"
  },
  {
    "codigo":313426007,
    "descripcion":"SÍNDROME DE LA MÁSCARA DE KABUKI"
  },
  {
    "codigo":213287000,
    "descripcion":"INFECCIÓN POSOPERATORIA DE HERIDA - SUPERFICIAL"
  },
  {
    "codigo":247890009,
    "descripcion":"PÉRDIDA DE IDENTIDAD"
  },
  {
    "codigo":1163559004,
    "descripcion":"LESIÓN POR FRICCIÓN DENTAL A CAUSA DE PRÁCTICAS ORALES PERJUDICIALES"
  },
  {
    "codigo":735740009,
    "descripcion":"INFECCIÓN QUE CAUSA TRAQUEÍTIS EN EL RECIÉN NACIDO"
  },
  {
    "codigo":209617002,
    "descripcion":"DESGARRO COMPLETO DE DEDO DE LA MANO, ARTICULACIÓN INTERFALÁNGICA DISTAL, LIGAMENTO LATERAL RADIAL"
  },
  {
    "codigo":699302001,
    "descripcion":"ARTRITIS LUMBAR"
  },
  {
    "codigo":240550002,
    "descripcion":"ENFERMEDAD NEONATAL POR ECHOVIRUS"
  },
  {
    "codigo":207782002,
    "descripcion":"FRACTURA EXPUESTA DE MAXILAR SUPERIOR"
  },
  {
    "codigo":109478007,
    "descripcion":"SÍNDROME AMELOCEREBROHIPOHIDRÓTICO"
  },
  {
    "codigo":402555001,
    "descripcion":"NEVOS MELANOCÍTICOS BENIGNOS MÚLTIPLES"
  },
  {
    "codigo":16018751000119105,
    "descripcion":"DEFORMIDAD CONGÉNITA DE DEDO DE LA MANO IZQUIERDA"
  },
  {
    "codigo":238715009,
    "descripcion":"ANOMALÍA DEL DESARROLLO DE LA UÑA"
  },
  {
    "codigo":40272001,
    "descripcion":"AUSENCIA CONGÉNITA DE SENO CORONARIO"
  },
  {
    "codigo":369787008,
    "descripcion":"0-5 MITOSIS POR 10 CAMPOS DE GRAN AUMENTO (PUNTAJE = 1)"
  },
  {
    "codigo":7504005,
    "descripcion":"TRAUMATISMO DE VULVA DURANTE EL PARTO"
  },
  {
    "codigo":800703961000119100,
    "descripcion":"ATROFIA DE CEREBELO ADQUIRIDA"
  },
  {
    "codigo":202277000,
    "descripcion":"CONTRACTURA EN DESVIACIÓN CUBITAL DE LA MUÑECA"
  },
  {
    "codigo":235045002,
    "descripcion":"PIGMENTACIÓN EXÓGENA DE LA MUCOSA ORAL"
  },
  {
    "codigo":1082841000119101,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE AMBOS LÓBULOS DE LAS OREJAS PERFORADOS"
  },
  {
    "codigo":38437003,
    "descripcion":"ÚTERO ARCUATUS"
  },
  {
    "codigo":890405006,
    "descripcion":"FOCOMELIA COMPLETA BILATERAL DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":366117007,
    "descripcion":"PERMEABILIDAD DE LA VÍA AÉREA NASAL - HALLAZGO"
  },
  {
    "codigo":298746005,
    "descripcion":"EXTREMIDAD SUPERIOR LARGA"
  },
  {
    "codigo":724730008,
    "descripcion":"TRASTORNO OBSESIVOCOMPULSIVO CAUSADO POR SUSTANCIA PSICOACTIVA"
  },
  {
    "codigo":397050008,
    "descripcion":"PREQUERATOCITOS"
  },
  {
    "codigo":296911003,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE LIOTIRONINA"
  },
  {
    "codigo":165839004,
    "descripcion":"FACTOR REUMATOIDE DETECTADO"
  },
  {
    "codigo":395215005,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR BUPROPIÓN"
  },
  {
    "codigo":1148879008,
    "descripcion":"INCONTINENCIA DE ESFUERZO PRIMARIA"
  },
  {
    "codigo":722895009,
    "descripcion":"REACCIÓN CUTÁNEA MEDIADA POR TOXINA ESTAFILOCÓCICA"
  },
  {
    "codigo":295076005,
    "descripcion":"ALERGIA A NICORANDIL"
  },
  {
    "codigo":1343652006,
    "descripcion":"RETINITIS DISEMINADA DERECHA"
  },
  {
    "codigo":1179812009,
    "descripcion":"FOLATO SÉRICO POR ENCIMA DE RANGO DE REFERENCIA"
  },
  {
    "codigo":1145209002,
    "descripcion":"INTOXICACIÓN CAUSADA POR SULFONILUREA"
  },
  {
    "codigo":293241003,
    "descripcion":"REACCIÓN ADVERSA A LA TESTOSTERONA ORAL"
  },
  {
    "codigo":31097004,
    "descripcion":"SÍNDROME SECUNDARIO A POLIOMIELITIS"
  },
  {
    "codigo":719225007,
    "descripcion":"PROMINENCIA ANORMAL DE CLAVÍCULA"
  },
  {
    "codigo":94798000,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL CLÍTORIS"
  },
  {
    "codigo":1208910001,
    "descripcion":"ENDOFTALMITIS BACTERIANA AGUDA POSQUIRÚRGICA"
  },
  {
    "codigo":363400004,
    "descripcion":"NEOPLASIA MALIGNA DE REGIÓN POSCRICOIDEA"
  },
  {
    "codigo":289571000,
    "descripcion":"PÉRDIDA PROFUSA DE LÍQUIDO AMNIÓTICO"
  },
  {
    "codigo":291406008,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR LEVALORFANO"
  },
  {
    "codigo":846627002,
    "descripcion":"INFLAMACIÓN DE TRACTO RESPIRATORIO SUPERIOR CAUSADA POR VAPOR"
  },
  {
    "codigo":193102008,
    "descripcion":"PARÁLISIS DE MÚLTIPLES NERVIOS CRANEALES EN LA NEOPLASIA"
  },
  {
    "codigo":92963009,
    "descripcion":"AUSENCIA CONGÉNITA DE CUERDAS TENDINOSAS"
  },
  {
    "codigo":189432002,
    "descripcion":"NEOPLASIA DE LA CAJA DEL TÍMPANO DE COMPORTAMIENTO INCIERTO"
  },
  {
    "codigo":123896005,
    "descripcion":"INTOXICACIÓN POR CANNABACEAE"
  },
  {
    "codigo":1172472006,
    "descripcion":"ESTRIOL DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":292621000119100,
    "descripcion":"OCLUSIÓN DE ARTERIA VERTEBRAL DERECHA"
  },
  {
    "codigo":416973000,
    "descripcion":"PRESCRIPCIÓN RECOGIDA POR COLEGA"
  },
  {
    "codigo":56525001,
    "descripcion":"NEVO LIPOMATOSO CUTÁNEO SUPERFICIAL"
  },
  {
    "codigo":254968009,
    "descripcion":"NEOPLASIA DE HIPOTÁLAMO"
  },
  {
    "codigo":713720009,
    "descripcion":"PERITONITIS ESCLEROSANTE COMO COMPLICACIÓN DE DIÁLISIS PERITONEAL"
  },
  {
    "codigo":253133004,
    "descripcion":"HIDROCEFALIA CON ANOMALÍA DEL ACUEDUCTO DE SILVIO"
  },
  {
    "codigo":285901003,
    "descripcion":"OPERA SECARROPAS"
  },
  {
    "codigo":449741007,
    "descripcion":"BORDES DE HERIDA, APROXIMADOS"
  },
  {
    "codigo":216695000,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR DICLORODIFENILTRICLOROETANO"
  },
  {
    "codigo":249463001,
    "descripcion":"ABSCESO SUBGLÓTICO"
  },
  {
    "codigo":85623003,
    "descripcion":"TERMORREGULACIÓN INEFICAZ"
  },
  {
    "codigo":282231007,
    "descripcion":"NO CAMINA APOYANDO PRIMERO EL TALÓN Y LUEGO LOS DEDOS"
  },
  {
    "codigo":313164002,
    "descripcion":"DESPLAZAMIENTO MACULAR"
  },
  {
    "codigo":81953000,
    "descripcion":"DOLOR DE PECHO DURANTE EL ESFUERZO"
  },
  {
    "codigo":278561004,
    "descripcion":"PÉRDIDA DE PUENTE DENTAL"
  },
  {
    "codigo":737313007,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA NEUROENDOCRINA DE ÍLEON"
  },
  {
    "codigo":702710003,
    "descripcion":"MUERTO - MUERTE SIN TESTIGOS"
  },
  {
    "codigo":14582003,
    "descripcion":"MICROSTOMÍA"
  },
  {
    "codigo":211190005,
    "descripcion":"ABRASIÓN, REGIÓN ESCAPULAR"
  },
  {
    "codigo":735478007,
    "descripcion":"PROLAPSO COMPLETO DE PARED ANTERIOR DE LA VAGINA"
  },
  {
    "codigo":209355001,
    "descripcion":"FRACTURA-LUXACIÓN NO EXPUESTA DE ARTICULACIÓN SUBASTRAGALINA"
  },
  {
    "codigo":1259766009,
    "descripcion":"TUMOR MALIGNO GLANDULAR PRIMARIO DE VAINA DE NERVIO PERIFÉRICO"
  },
  {
    "codigo":405963003,
    "descripcion":"EQUIPO INTERGRUPAL PARA EL ESTUDIO POSQUIRÚRGICO DE RABDOMIOSARCOMA IIIB: TUMOR LOCALIZADO O DE DISEMINACIÓN LOCAL, ENFERMEDAD RESIDUAL MACROSCÓPICA LUEGO DE RESECCIÓN AMPLIA (MÁS DEL 50% DE CITORREDUCCIÓN)"
  },
  {
    "codigo":274891006,
    "descripcion":"NIVEL ANORMAL DE METALES PESADOS EN SANGRE - HALLAZGO"
  },
  {
    "codigo":404128004,
    "descripcion":"LINFOMA CUTÁNEO DE CÉLULAS T, CD-30 NEGATIVO"
  },
  {
    "codigo":305824005,
    "descripcion":"VISTO POR EL SERVICIO DE CUIDADOS PALIATIVOS"
  },
  {
    "codigo":321601000119100,
    "descripcion":"RUPTURA ESPONTÁNEA DE TENDÓN FLEXOR DE MANO DERECHA"
  },
  {
    "codigo":348071000119106,
    "descripcion":"DEGENERACIÓN POSTERIOR DEL VÍTREO DE OJO DERECHO"
  },
  {
    "codigo":369525000,
    "descripcion":"TUMOR MALIGNO QUE COMPROMETE OVARIO IZQUIERDO POR PROPAGACIÓN DIRECTA DESDE TROMPA DE FALOPIO"
  },
  {
    "codigo":830112009,
    "descripcion":"SENSIBILIDAD PROFUNDA NORMAL"
  },
  {
    "codigo":238453003,
    "descripcion":"MÁCULA CERÚLEA - MANCHA AZUL"
  },
  {
    "codigo":402293007,
    "descripcion":"INTERTRIGO GENITOCRURAL"
  },
  {
    "codigo":1186890005,
    "descripcion":"PROTOPORFIRINA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":105546006,
    "descripcion":"CONSUMIDOR OCASIONAL DE DROGAS"
  },
  {
    "codigo":302154007,
    "descripcion":"ANQUILOSIS DE ARTICULACIÓN DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":890143000,
    "descripcion":"DERMATITIS ALÉRGICA POR CONTACTO CON PRÍMULA"
  },
  {
    "codigo":236618005,
    "descripcion":"REFLUJO VESICOURETERAL OBSTRUCTIVO"
  },
  {
    "codigo":300319002,
    "descripcion":"TONO ANAL NORMAL"
  },
  {
    "codigo":398623004,
    "descripcion":"SÍNDROME MIELODISPLÁSICO CON EXCESO DE BLASTOS"
  },
  {
    "codigo":70943004,
    "descripcion":"SÍNDROME DE ALLEMANN"
  },
  {
    "codigo":1119519006,
    "descripcion":"AGOTAMIENTO MUSCULAR FATIGABLE DE MÚSCULO DE CADERA Y\/O MUSLO"
  },
  {
    "codigo":38175008,
    "descripcion":"SABOR A AJO"
  },
  {
    "codigo":365855009,
    "descripcion":"BIOPSIA - HALLAZGO"
  },
  {
    "codigo":298484003,
    "descripcion":"COLUMNA CERVICAL TIBIA AL TACTO"
  },
  {
    "codigo":396788005,
    "descripcion":"METÁSTASIS TUMORALES A GANGLIOS LINFÁTICOS NO REGIONALES, AUSENTES"
  },
  {
    "codigo":724468006,
    "descripcion":"CARCINOMA UROTELIAL PRIMARIO DE LOCALIZACIONES SUPERPUESTAS DE ÓRGANOS URINARIOS"
  },
  {
    "codigo":15722561000119106,
    "descripcion":"ARTROSIS DE PRIMERAS ARTICULACIONES METATARSOFALÁNGICAS DE AMBOS PIES"
  },
  {
    "codigo":722633001,
    "descripcion":"MÚLTIPLES HEMORRAGIAS TRAUMÁTICAS DE TEJIDO CEREBRAL"
  },
  {
    "codigo":1148617003,
    "descripcion":"ELECTRORRETINOGRAMA CON ADAPTACIÓN A LA LUZ ANORMAL"
  },
  {
    "codigo":1279689007,
    "descripcion":"FIEBRE RECURRENTE CAUSADA POR BORRELIA DUTTONII"
  },
  {
    "codigo":425886001,
    "descripcion":"DISPOSICIÓN PARA MEJORAR LA CAPACIDAD DE CUIDADO DE SÍ MISMO"
  },
  {
    "codigo":65438001,
    "descripcion":"TORTÍCOLIS PSICÓGENO"
  },
  {
    "codigo":294814005,
    "descripcion":"ALERGIA A HORMONA REGULADORA DE LAS GÓNADAS"
  },
  {
    "codigo":130974006,
    "descripcion":"REFLEJO FLEXOR AUMENTADO"
  },
  {
    "codigo":292979008,
    "descripcion":"REACCIÓN ADVERSA A LA TICARCILINA"
  },
  {
    "codigo":129139009,
    "descripcion":"TRASTORNO DE LA COLUMNA LUMBAR"
  },
  {
    "codigo":94536002,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE HUESO CORTO DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":225608001,
    "descripcion":"DIFICULTAD AL ALZAR LA CABEZA"
  },
  {
    "codigo":1144947008,
    "descripcion":"AMENORREA DEBIDA A DEFICIENCIA CONGÉNITA DE HORMONA LIBERADORA DE GONADOTROFINA"
  },
  {
    "codigo":422216007,
    "descripcion":"LUXACIÓN DE CARTÍLAGO ARITENOIDES"
  },
  {
    "codigo":291144007,
    "descripcion":"INTOXICACIÓN INTENCIONAL CON BEMPERIDOL"
  },
  {
    "codigo":127304009,
    "descripcion":"CONTUSIÓN CEREBELOSA"
  },
  {
    "codigo":92701002,
    "descripcion":"CARCINOMA IN SITU DEL LÓBULO INFERIOR DERECHO DEL PULMÓN"
  },
  {
    "codigo":289309001,
    "descripcion":"LATIDO AUSENTE EN CORDÓN PROCIDENTE"
  },
  {
    "codigo":209331006,
    "descripcion":"FRACTURA-SUBLUXACIÓN EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA PROXIMAL"
  },
  {
    "codigo":1336050007,
    "descripcion":"EPISODIO DE USO NOCIVO DE MEDICACIÓN ANALGÉSICA NO PSICOTRÓPICA"
  },
  {
    "codigo":90866007,
    "descripcion":"SÍNDROME DE TRISOMÍA PARCIAL 3Q"
  },
  {
    "codigo":713458007,
    "descripcion":"FALTA DE ACCESO A TRANSPORTE"
  },
  {
    "codigo":449479003,
    "descripcion":"FIJACIÓN ANÓMALA DE TABIQUE INTERAURICULAR"
  },
  {
    "codigo":1137607008,
    "descripcion":"LABIOS FRUNCIDOS"
  },
  {
    "codigo":251036003,
    "descripcion":"DILATACIÓN DE LA RAÍZ AÓRTICA"
  },
  {
    "codigo":16052751000119100,
    "descripcion":"TRASTORNO DE TENDÓN DE AMBOS MUSLOS"
  },
  {
    "codigo":283804008,
    "descripcion":"MORDEDURA DE ANIMAL EN LA AXILA"
  },
  {
    "codigo":52593001,
    "descripcion":"VÁRICES RETINIANAS"
  },
  {
    "codigo":249201004,
    "descripcion":"ÚTERO ELÁSTICO"
  },
  {
    "codigo":118129005,
    "descripcion":"ESPÉCIMEN ICTÉRICO"
  },
  {
    "codigo":183665006,
    "descripcion":"ALTA HOSPITALARIA"
  },
  {
    "codigo":773489008,
    "descripcion":"CRIOHIDROCITOSIS HEREDITARIA CON ESTOMATINA NORMAL"
  },
  {
    "codigo":247366003,
    "descripcion":"DORSALGIA AGUDA CON CIÁTICA"
  },
  {
    "codigo":280134004,
    "descripcion":"TRASTORNO DE PARTES BLANDAS DE EXTREMIDAD"
  },
  {
    "codigo":83526003,
    "descripcion":"INVERSIÓN CRÓNICA DEL ÚTERO"
  },
  {
    "codigo":50758004,
    "descripcion":"NACIMIENTO DE TÉRMINO DE MELLIZOS"
  },
  {
    "codigo":1230406008,
    "descripcion":"ARRITMIA CARDÍACA POSQUIRÚRGICA"
  },
  {
    "codigo":312902008,
    "descripcion":"SEUDOAGUJERO MACULAR"
  },
  {
    "codigo":704283007,
    "descripcion":"FRACTURA POR OSTEOPOROSIS SECUNDARIA DE TIBIA"
  },
  {
    "codigo":473072000,
    "descripcion":"INFECCIÓN ASOCIADA CON DISPOSITIVO NEUROLÓGICO"
  },
  {
    "codigo":212763009,
    "descripcion":"INTOXICACIÓN POR GUAIFENESINA"
  },
  {
    "codigo":276464002,
    "descripcion":"LESIÓN TRAUMÁTICA DEL ANO"
  },
  {
    "codigo":702448007,
    "descripcion":"DISTONÍA 6"
  },
  {
    "codigo":1259504007,
    "descripcion":"ADENOCARCINOMA POLIMORFO DE BAJO GRADO PRIMARIO DE GLÁNDULA SALIVAL"
  },
  {
    "codigo":307397001,
    "descripcion":"INFECCIÓN DE INJERTO FEMOROFEMORAL CRUZADO"
  },
  {
    "codigo":897221002,
    "descripcion":"CURVATURA ANORMAL DE FALANGE DE TERCER DEDO DE PIE"
  },
  {
    "codigo":405701005,
    "descripcion":"LESIÓN TRAUMÁTICA PROVOCADA POR SUJECIÓN LEGAL CON ATADURAS PLÁSTICAS"
  },
  {
    "codigo":241861008,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE NASOFARINGE"
  },
  {
    "codigo":10650000,
    "descripcion":"ENVENENAMIENTO CAUSADO POR KETAMINA"
  },
  {
    "codigo":372933008,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM MALMOENSE"
  },
  {
    "codigo":305562003,
    "descripcion":"BAJO ATENCIÓN DE ENFERMERA ESPECIALISTA EN VÍAS GENITOURINARIAS"
  },
  {
    "codigo":240026006,
    "descripcion":"RUPTURA DE TENDÓN DE LA REGIÓN EL PIE"
  },
  {
    "codigo":403866008,
    "descripcion":"PAPILOMA BASOCELULAR RETICULADO TIPO (ADENOIDE)"
  },
  {
    "codigo":74351001,
    "descripcion":"SÍNDROME DE REYE"
  },
  {
    "codigo":1155695003,
    "descripcion":"ETAPA DE MANTENIMIENTO PARA LA DISPOSICIÓN A MODIFICAR LA CONDUCTA NUTRICIONAL"
  },
  {
    "codigo":762479004,
    "descripcion":"QUEMADURA COMPLEJA DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":860783006,
    "descripcion":"LESIÓN TRAUMÁTICA POR FUERZA NO PENETRANTE NO EXPUESTA DE OJO IZQUIERDO"
  },
  {
    "codigo":269124008,
    "descripcion":"LUXACIÓN EXPUESTA ENTRE LA SEGUNDA Y LA TERCERA VÉRTEBRAS CERVICALES"
  },
  {
    "codigo":267289003,
    "descripcion":"INFECCIÓN DE PEZÓN DE CAUSA OBSTÉTRICA"
  },
  {
    "codigo":365593006,
    "descripcion":"HALLAZGO RELACIONADO CON EL TÍTULO DE ANTICUERPOS ANTIVIRALES"
  },
  {
    "codigo":1119257007,
    "descripcion":"HIPEROSTEOIDOSIS"
  },
  {
    "codigo":36078000,
    "descripcion":"NEUMOPERICARDIO PERINATAL"
  },
  {
    "codigo":701000221104,
    "descripcion":"ENFERMEDAD DE CHAGAS AGUDA CONGÉNITA"
  },
  {
    "codigo":298222004,
    "descripcion":"AMPLITUD DE MOVIMIENTO ARTICULAR ACTIVO REDUCIDO"
  },
  {
    "codigo":3310005,
    "descripcion":"GRANULOMA DE LA PIEL POR CUERPO EXTRAÑO"
  },
  {
    "codigo":724206005,
    "descripcion":"EPIDERMÓLISIS BULLOSA SIMPLE RELACIONADA CON QUERATINA 14"
  },
  {
    "codigo":1475003,
    "descripcion":"HERPES LABIAL"
  },
  {
    "codigo":294552002,
    "descripcion":"ALERGIA A CEFTIBUTENO"
  },
  {
    "codigo":229016004,
    "descripcion":"PENETRACIÓN VAGINAL USANDO LA LENGUA"
  },
  {
    "codigo":1179288008,
    "descripcion":"INMUNODEFICIENCIA COMBINADA DEBIDA A DEFICIENCIA DEL RECEPTOR DE TRANSFERRINA"
  },
  {
    "codigo":423789002,
    "descripcion":"OSTEOMA FACIAL"
  },
  {
    "codigo":292717006,
    "descripcion":"REACCIÓN ADVERSA AL DINOPROST"
  },
  {
    "codigo":1144685008,
    "descripcion":"APLASIA DE FALANGE DE TERCER DEDO DE PIE"
  },
  {
    "codigo":817005009,
    "descripcion":"EL OJO NO SE MUEVE HACIA LA DERECHA"
  },
  {
    "codigo":194413008,
    "descripcion":"PÉRDIDA DE LA AUDICIÓN CONDUCTIVA DEBIDA A TRASTORNO DEL OÍDO EXTERNO"
  },
  {
    "codigo":15973341000119103,
    "descripcion":"DEFORMIDAD CONGÉNITA DE AMBOS CALCÁNEOS"
  },
  {
    "codigo":94274006,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":290882006,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR TRIPTÓFANO"
  },
  {
    "codigo":127042006,
    "descripcion":"TALASEMIA BETA MÁS DE CÉLULAS DREPANOCÍTICAS"
  },
  {
    "codigo":59671002,
    "descripcion":"DERRIENGUE"
  },
  {
    "codigo":92439006,
    "descripcion":"NEOPLASIA BENIGNA DE LA GLÁNDULA TIROIDES"
  },
  {
    "codigo":715031006,
    "descripcion":"INCAPAZ DE CAMINAR EN UNA HABITACIÓN"
  },
  {
    "codigo":713196004,
    "descripcion":"JAEGER TIPO 1+"
  },
  {
    "codigo":254444005,
    "descripcion":"NEOPLASIA DE SURCO GINGIVOBUCAL MANDIBULAR"
  },
  {
    "codigo":1237484006,
    "descripcion":"METÁSTASIS DE CARCINOMA DE COLON"
  },
  {
    "codigo":1335788008,
    "descripcion":"ARTRITIS IDIOPÁTICA JUVENIL DE CODO"
  },
  {
    "codigo":385516009,
    "descripcion":"QUEMADURA DE LA PIEL POR CONTACTO"
  },
  {
    "codigo":416449002,
    "descripcion":"IRIDOCICLITIS CRÓNICA EN NIÑAS PEQUEÑAS"
  },
  {
    "codigo":711361003,
    "descripcion":"TUMOR IRRESECABLE QUIRÚRGICAMENTE"
  },
  {
    "codigo":449217008,
    "descripcion":"LINFOMA NO HODGKIN DIFUSO DE PIEL"
  },
  {
    "codigo":283542008,
    "descripcion":"HERIDA PUNZANTE DE DORSO DE PIE"
  },
  {
    "codigo":609387006,
    "descripcion":"CON ALTO RIESGO DE INSUFICIENCIA CARDÍACA"
  },
  {
    "codigo":1363051007,
    "descripcion":"DERMATITIS ALÉRGICA POR CONTACTO CAUSADA POR ANTISÉPTICO Y\/O DESINFECTANTE"
  },
  {
    "codigo":83264000,
    "descripcion":"PLEURODINIA EPIDÉMICA"
  },
  {
    "codigo":248939006,
    "descripcion":"TAPÓN MUCOSO EN EL ORIFICIO CERVICAL"
  },
  {
    "codigo":48661000,
    "descripcion":"PERITONITIS"
  },
  {
    "codigo":704021000,
    "descripcion":"FRACTURA NO EXPUESTA DE DIÁFISIS DE QUINTO METACARPIANO"
  },
  {
    "codigo":278037002,
    "descripcion":"CELULITIS ESTREPTOCÓCICA"
  },
  {
    "codigo":10949751000119107,
    "descripcion":"HERIDA POR ARMA BLANCA DE ANTEBRAZO IZQUIERDO"
  },
  {
    "codigo":441877007,
    "descripcion":"DISFUNCIÓN DEL SUEÑO CON ALTERACIÓN DE ESTADIO DEL SUEÑO"
  },
  {
    "codigo":46826000,
    "descripcion":"COREA REUMÁTICA"
  },
  {
    "codigo":14058000,
    "descripcion":"ASINCLITISMO"
  },
  {
    "codigo":1259242002,
    "descripcion":"ENFERMEDAD HEREDITARIA DE VON WILLEBRAND"
  },
  {
    "codigo":276202003,
    "descripcion":"INFECCIÓN CAUSADA POR CLOSTRIDIUM TETANI"
  },
  {
    "codigo":472810005,
    "descripcion":"ARRITMIA DEBIDA A VEGETACIÓN DE ENDOCARDITIS INFECCIOSA"
  },
  {
    "codigo":307135001,
    "descripcion":"MASA EN FOSA ILÍACA IZQUIERDA"
  },
  {
    "codigo":16903441000119104,
    "descripcion":"COMPRESIÓN DE AMBOS NERVIOS MEDIANOS A NIVEL DE CODO"
  },
  {
    "codigo":733119003,
    "descripcion":"RHC NEGATIVO"
  },
  {
    "codigo":208831006,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE HUESO SEMILUNAR (PALMAR)"
  },
  {
    "codigo":700351008,
    "descripcion":"TRASTORNO DE HUESO SESAMOIDEO DE PIE"
  },
  {
    "codigo":77759009,
    "descripcion":"ACANTÓLISIS FAMILIAR"
  },
  {
    "codigo":698516000,
    "descripcion":"ÚLCERA CUTÁNEA SUPERFICIAL DE MIEMBRO INFERIOR"
  },
  {
    "codigo":1092881000119105,
    "descripcion":"HEMORRAGIA RECTAL DEBIDA A COLITIS ULCEROSA"
  },
  {
    "codigo":272532005,
    "descripcion":"PARADO CON LOS BRAZOS EN CRUZ"
  },
  {
    "codigo":239764008,
    "descripcion":"HIPERLAXITUD ARTICULAR LUEGO DE REMOCIÓN DE PRÓTESIS"
  },
  {
    "codigo":303465001,
    "descripcion":"DIFICULTAD PARA MANEJAR PRÓTESIS"
  },
  {
    "codigo":237929000,
    "descripcion":"TRASTORNO DEL METABOLISMO DE LA LISINA E HIDROXILISINA"
  },
  {
    "codigo":205161004,
    "descripcion":"AMPUTACIÓN CONGÉNITA DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":170558000,
    "descripcion":"EVALUACIÓN DE SEGUIMIENTO DE ENFERMEDAD CRÓNICA"
  },
  {
    "codigo":8553008,
    "descripcion":"ESOTROPÍA ALTERNANTE NO CONCOMITANTE DISTINTA DEL PATRÓN EN A O V"
  },
  {
    "codigo":236094005,
    "descripcion":"HEMORRAGIA DE ANASTOMOSIS GÁSTRICA"
  },
  {
    "codigo":6718007,
    "descripcion":"DETERMINACIÓN DEL ESTADO DEL PACIENTE, LIGERO AGRAVAMIENTO"
  },
  {
    "codigo":399934007,
    "descripcion":"CARCINOMA BASOCELULAR DE PIEL PREAURICULAR"
  },
  {
    "codigo":39486007,
    "descripcion":"INFECCIÓN CAUSADA POR GEOTRICHUM CANDIDUM"
  },
  {
    "codigo":299795003,
    "descripcion":"REFLEJO DE GALANT PRESENTE"
  },
  {
    "codigo":365331005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA PENSAR EN FORMA ABSTRACTA"
  },
  {
    "codigo":201491005,
    "descripcion":"ARTROPATÍA EN EL SÍNDROME DE BEHCET DE TOBILLO Y\/O PIE"
  },
  {
    "codigo":37651007,
    "descripcion":"ANESTESIA TÁCTIL"
  },
  {
    "codigo":248200007,
    "descripcion":"FACIES DISMÓRFICA"
  },
  {
    "codigo":47691000087105,
    "descripcion":"FRACTURA DE QUINTA COSTILLA IZQUIERDA"
  },
  {
    "codigo":297960002,
    "descripcion":"MASA CUTÁNEA"
  },
  {
    "codigo":363496003,
    "descripcion":"NEOPLASIA MALIGNA DE PARTES BLANDAS DE ABDOMEN"
  },
  {
    "codigo":42571000087108,
    "descripcion":"HERIDA DE PARED TORÁCICA ANTERIOR POR MORDEDURA"
  },
  {
    "codigo":40011000087109,
    "descripcion":"HERIDA PUNZANTE DE BRAZO IZQUIERDO CON CUERPO EXTRAÑO"
  },
  {
    "codigo":232424006,
    "descripcion":"CUERPO EXTRAÑO EN AMÍGDALA PALATINA"
  },
  {
    "codigo":396264007,
    "descripcion":"MARGEN QUIRÚRGICO PROFUNDO NO COMPROMETIDO POR NEOPLASIA INTRAEPITELIAL"
  },
  {
    "codigo":296125001,
    "descripcion":"SOBREDOSIS DE TEMAZEPAM"
  },
  {
    "codigo":197821004,
    "descripcion":"PÓLIPO URETERAL"
  },
  {
    "codigo":230589005,
    "descripcion":"NEUROPATÍA EN CRIOGLOBULINEMIA"
  },
  {
    "codigo":785810000,
    "descripcion":"SINUCLEINOPATÍA"
  },
  {
    "codigo":722109008,
    "descripcion":"OSTEOCRANEOESTENOSIS"
  },
  {
    "codigo":423527000,
    "descripcion":"CUBIERTA DE PISO INSEGURA"
  },
  {
    "codigo":294290009,
    "descripcion":"ALERGIA A TRIENTINA"
  },
  {
    "codigo":292455002,
    "descripcion":"REACCIÓN ADVERSA A LA PRENILAMINA"
  },
  {
    "codigo":194151003,
    "descripcion":"HIALITIS PUNTEADA"
  },
  {
    "codigo":95847005,
    "descripcion":"LESIÓN TRAUMÁTICA MUSCULAR"
  },
  {
    "codigo":1144423005,
    "descripcion":"ESTRANGULAMIENTO DE INTESTINO DELGADO"
  },
  {
    "codigo":15949381000119105,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS INTRAEPIDÉRMICO DE AMBOS MIEMBROS INFERIORES"
  },
  {
    "codigo":290620003,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR MUSTINA"
  },
  {
    "codigo":126780007,
    "descripcion":"NEOPLASIA DE LA SUPERFICIE DORSAL DE LA LENGUA"
  },
  {
    "codigo":94012007,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA PIEL DE LA MAMA"
  },
  {
    "codigo":288785000,
    "descripcion":"NO COMUNICA NECESIDADES Y DESEOS"
  },
  {
    "codigo":1069741000000105,
    "descripcion":"DIFICULTAD PARA ACCEDER AL LUGAR DONDE ESTÁ APARCADO EL AUTOMÓVIL"
  },
  {
    "codigo":92177006,
    "descripcion":"NEOPLASIA BENIGNA DE LA PARED LATERAL DE LA NASOFARINGE"
  },
  {
    "codigo":190481008,
    "descripcion":"LH - DEFICIENCIA DE HORMONA LUTEINIZANTE"
  },
  {
    "codigo":418022001,
    "descripcion":"PLEGAMIENTO DEL IRIS"
  },
  {
    "codigo":874939004,
    "descripcion":"LACERACIÓN CEREBELOSA CON CONMOCIÓN"
  },
  {
    "codigo":1004176008,
    "descripcion":"NIVEL DE ÁCIDO 2-AMINOBUTÍRICO AUMENTADO EN ORINA"
  },
  {
    "codigo":283280008,
    "descripcion":"ASTILLA DE MADERA EN CABEZA"
  },
  {
    "codigo":281445000,
    "descripcion":"AFLOJAMIENTO DE PRÓTESIS DE REEMPLAZO TOTAL DE LA CADERA"
  },
  {
    "codigo":314213003,
    "descripcion":"ABSCESO DE BRODIE DE TIBIA"
  },
  {
    "codigo":445285002,
    "descripcion":"ANEURISMA DE SENO DE VALSALVA AÓRTICO DESDE SENO CORONARIO IZQUIERDO"
  },
  {
    "codigo":248677002,
    "descripcion":"SOPLO DEL FLUJO SISTÓLICO"
  },
  {
    "codigo":707429002,
    "descripcion":"CARCINOMA SUPERPUESTO DE CÉLULAS ESCAMOSAS DE LARINGE"
  },
  {
    "codigo":838501002,
    "descripcion":"SE SIENTA EN LA BACINILLA"
  },
  {
    "codigo":609125008,
    "descripcion":"PÉRDIDA DE LA AUDICIÓN NEUROSENSORIAL ADQUIRIDA"
  },
  {
    "codigo":50234002,
    "descripcion":"PULSO BÍFERO"
  },
  {
    "codigo":1229882003,
    "descripcion":"SÍNDROME DE MICRODELECIÓN 11Q22.2Q22.3"
  },
  {
    "codigo":312378004,
    "descripcion":"ÉMBOLO DE ARTERIA DE MIEMBRO INFERIOR"
  },
  {
    "codigo":246842005,
    "descripcion":"ORFICIOS DE MEIBOMIANOS DILATADOS Y TUMEFACTOS"
  },
  {
    "codigo":212239002,
    "descripcion":"LESIÓN DEL NERVIO SIMPÁTICO CERVICAL"
  },
  {
    "codigo":408847006,
    "descripcion":"RETINOPATÍA POR PREMATUREZ, ETAPA 1 - LÍNEA DE DEMARCACIÓN"
  },
  {
    "codigo":1258980000,
    "descripcion":"ESCLERODERMA POSINFECCIOSA"
  },
  {
    "codigo":11961000,
    "descripcion":"EVALUACIÓN DE DISCAPACIDAD: 30%"
  },
  {
    "codigo":44729001,
    "descripcion":"INFLAMACIÓN CRÓNICA DE ÓRBITA"
  },
  {
    "codigo":863929001,
    "descripcion":"TASA DE FILTRACIÓN GLOMERULAR POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":77497005,
    "descripcion":"SÍNDROME DE TRISOMÍA PARCIAL 3P"
  },
  {
    "codigo":110265006,
    "descripcion":"HEMORRAGIA POSTOPERATORIA"
  },
  {
    "codigo":896697005,
    "descripcion":"INFARTO AGUDO DE MIOCARDIO CON ELEVACIÓN DEL SEGMENTO ST DEL VENTRÍCULO DERECHO"
  },
  {
    "codigo":11773971000119102,
    "descripcion":"CONTUSIÓN DE DEDO ÍNDICE DERECHO"
  },
  {
    "codigo":15732601000119109,
    "descripcion":"ENTROPIÓN CON ECTROPIÓN DE PÁRPADO INFERIOR DERECHO"
  },
  {
    "codigo":42894006,
    "descripcion":"INTOXICACIÓN POR CLORANFENICOL"
  },
  {
    "codigo":403342009,
    "descripcion":"CAMBIO EN EL COLOR DEL PELO, DE ETIOLOGÍA NUTRICIONAL"
  },
  {
    "codigo":237667004,
    "descripcion":"HIPERPROLACTINEMIA POR LACTANCIA"
  },
  {
    "codigo":1351779004,
    "descripcion":"INMUNODEFICIENCIA COMBINADA AUTOSÓMICA DOMINANTE DEBIDA A MUTACIÓN DE STAT5B"
  },
  {
    "codigo":170296000,
    "descripcion":"EXAMEN DEL NIÑO A LOS 39 MESES: ANORMAL - DERIVADO"
  },
  {
    "codigo":235832002,
    "descripcion":"ENTEROPATÍA DIABÉTICA"
  },
  {
    "codigo":39224005,
    "descripcion":"AMEBIASIS AGUDA"
  },
  {
    "codigo":792888005,
    "descripcion":"TUMORACIÓN MAMARIA LISA"
  },
  {
    "codigo":203064007,
    "descripcion":"CONTRACTURA DEL MÚSCULO FLEXOR LARGO DEL PULGAR"
  },
  {
    "codigo":301368006,
    "descripcion":"DOLOR EN EL HIPOCONDRIO IZQUIERDO"
  },
  {
    "codigo":6456007,
    "descripcion":"TAQUICARDIA SUPRAVENTRICULAR"
  },
  {
    "codigo":1153336009,
    "descripcion":"LINFOMA NODAL DE ZONA MARGINAL DE CÉLULAS B PEDIÁTRICO"
  },
  {
    "codigo":102925004,
    "descripcion":"ASTRAPOFOBIA"
  },
  {
    "codigo":37389005,
    "descripcion":"CÓLICO BILIAR"
  },
  {
    "codigo":299533006,
    "descripcion":"SIN AMPLITUD PASIVA DE INVERSIÓN DE ARTICULACIÓN SUBASTRAGALINA"
  },
  {
    "codigo":365069005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA COMUNICARSE EN DIFERENTES OCASIONES"
  },
  {
    "codigo":397837008,
    "descripcion":"NIÑO SOSTENIDO EN REGAZO DE LOS PADRES"
  },
  {
    "codigo":363234001,
    "descripcion":"SÍNDROME NEFRÓTICO POR ENFERMEDAD SISTÉMICA"
  },
  {
    "codigo":428770004,
    "descripcion":"SUBLUXACIÓN DE PRÓTESIS ARTICULAR GLENOHUMERAL"
  },
  {
    "codigo":35554008,
    "descripcion":"DEFICIENCIA ADQUIRIDA DE FACTOR XI"
  },
  {
    "codigo":166626008,
    "descripcion":"FOSFATASA ALCALINA SÉRICA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":33719002,
    "descripcion":"NÓDULO REUMATOIDE SUBCUTÁNEO"
  },
  {
    "codigo":721847002,
    "descripcion":"SÍNDROME DE JOUBERT CON FIBROSIS HEPÁTICA CONGÉNITA"
  },
  {
    "codigo":787383002,
    "descripcion":"METABOLIZADOR NORMAL-LENTO DE LA FAMILIA 3 SUBFAMILIA A MIEMBRO 4 DEL CITOCROMO P450"
  },
  {
    "codigo":263095005,
    "descripcion":"FRACTURA-SUBLUXACIÓN DE LA ARTICULACIÓN SACROILÍACA"
  },
  {
    "codigo":230327006,
    "descripcion":"DISTONÍA OROFACIAL DESDENTADA"
  },
  {
    "codigo":294028000,
    "descripcion":"ALERGIA A NAFAZOLINA"
  },
  {
    "codigo":228492003,
    "descripcion":"NUNCA CONSUMIÓ RAPÉ"
  },
  {
    "codigo":292193000,
    "descripcion":"REACCIÓN ADVERSA AL LENOGRASTIM"
  },
  {
    "codigo":95585001,
    "descripcion":"PARESIA DEL MÚSCULO DETRUSOR"
  },
  {
    "codigo":718177001,
    "descripcion":"DISTROFIA MUSCULAR DE LAS CINTURAS DE LAS EXTREMIDADES TIPO 2F AUTOSÓMICA RECESIVA"
  },
  {
    "codigo":161121003,
    "descripcion":"EDUCACIÓN ADICIONAL"
  },
  {
    "codigo":128353007,
    "descripcion":"ANOMALÍA CONGÉNITA DEL CRISTALINO"
  },
  {
    "codigo":192054008,
    "descripcion":"CHOQUE CULTURAL"
  },
  {
    "codigo":714507001,
    "descripcion":"INFECCIÓN DE ALVÉOLO DENTAL"
  },
  {
    "codigo":290358009,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR FAMOTIDINA"
  },
  {
    "codigo":15980871000119104,
    "descripcion":"BLEFAROFIMOSIS CONGÉNITA DE PÁRPADOS DE AMBOS OJOS"
  },
  {
    "codigo":1204192000,
    "descripcion":"CARDIOMIOPATÍA HIPERTRÓFICA APICAL CON ANEURISMA"
  },
  {
    "codigo":91915008,
    "descripcion":"AUSENCIA CONGÉNITA DEL ARCO DE LA VÉRTEBRA DORSAL"
  },
  {
    "codigo":286688002,
    "descripcion":"SEPARACIÓN - MECANISMO DE DEFENSA PSICOLÓGICA"
  },
  {
    "codigo":712672003,
    "descripcion":"ENTEROCOCCUS RESISTENTE A VANCOMICINA NO AISLADO"
  },
  {
    "codigo":1236960004,
    "descripcion":"METÁSTASIS DE CARCINOMA DE AMÍGDALA LINGUAL"
  },
  {
    "codigo":253920006,
    "descripcion":"HEMIHIPERTROFIA DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":284853003,
    "descripcion":"SE SUENA LA NARIZ"
  },
  {
    "codigo":10957281000119103,
    "descripcion":"HERIDA ABIERTA DE DEDO ANULAR DERECHO DEBIDA A MORDEDURA HUMANA"
  },
  {
    "codigo":1003914006,
    "descripcion":"DELECIÓN PROXIMAL DEL BRAZO CORTO DEL CROMOSOMA 1"
  },
  {
    "codigo":1264223000,
    "descripcion":"INFECCIÓN FETAL CAUSADA POR ESCHERICHIA COLI"
  },
  {
    "codigo":248415006,
    "descripcion":"EXTREMIDADES BLANCAS"
  },
  {
    "codigo":182879007,
    "descripcion":"REDUCCIÓN DE LA MEDICACIÓN"
  },
  {
    "codigo":1231455008,
    "descripcion":"LABIO LEPORINO INCOMPLETO"
  },
  {
    "codigo":1196852001,
    "descripcion":"HEMANGIOMA COROIDEO CIRCUNSCRIPTO"
  },
  {
    "codigo":707167006,
    "descripcion":"NECROSIS HEPÁTICA AGUDA MULTIACINAR"
  },
  {
    "codigo":312116004,
    "descripcion":"INFECCIÓN BACTERIANA DEL SISTEMA NERVIOSO"
  },
  {
    "codigo":17204006,
    "descripcion":"NEUMOPERITONEO"
  },
  {
    "codigo":211977002,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO PROFUNDA DE PIERNA"
  },
  {
    "codigo":441353006,
    "descripcion":"CAPAZ DE ESCRIBIR SU PROPIO NOMBRE"
  },
  {
    "codigo":48137006,
    "descripcion":"INFECCIÓN CAUSADA POR GLOBOCEPHALUS"
  },
  {
    "codigo":13534001,
    "descripcion":"CAMPTOCORMIA"
  },
  {
    "codigo":767198002,
    "descripcion":"ALERGIA A DIETIL ÉTER"
  },
  {
    "codigo":898270001,
    "descripcion":"ANQUILOSIS CONGÉNITA DE ARTICULACIÓN INTERFALÁNGICA PROXIMAL DE TERCER DEDO DE PIE"
  },
  {
    "codigo":864990181000119100,
    "descripcion":"PORTADOR DE SÍNDROME DE USHER TIPO 2"
  },
  {
    "codigo":27621000119100,
    "descripcion":"HIDROPESÍA LABERÍNTICA"
  },
  {
    "codigo":1084901000119102,
    "descripcion":"COLANGITIS CRÓNICA DEBIDA A CÁLCULO DE CONDUCTO BILIAR"
  },
  {
    "codigo":11839461000119101,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO INTRÍNSECO DE PULGAR DERECHO"
  },
  {
    "codigo":135141000119104,
    "descripcion":"QUISTE DE TÚNICA ALBUGÍNEA DE TESTÍCULO"
  },
  {
    "codigo":726499301000119105,
    "descripcion":"INFARTO DE MIOCARDIO DEBIDO A ENFERMEDAD ATEROTROMBÓTICA CORONARIA"
  },
  {
    "codigo":342501000119105,
    "descripcion":"EDEMA DE PÁRPADO INFERIOR IZQUIERDO"
  },
  {
    "codigo":15953381000119105,
    "descripcion":"FISURA DE PEZÓN IZQUIERDO DURANTE LA LACTANCIA"
  },
  {
    "codigo":137701000119106,
    "descripcion":"SEPSIS PRENATAL"
  },
  {
    "codigo":10746341000119109,
    "descripcion":"SÍNDROME DE INMUNODEFICIENCIA ADQUIRIDA QUE COMPLICA EL NACIMIENTO"
  },
  {
    "codigo":15930341000119109,
    "descripcion":"EDEMA DE PAPILA DE OJO IZQUIERDO"
  },
  {
    "codigo":11857381000119109,
    "descripcion":"DISTENSIÓN DE GEMELO DERECHO"
  },
  {
    "codigo":9864005,
    "descripcion":"PLACENTA MULTIPARTITA"
  },
  {
    "codigo":301541000119109,
    "descripcion":"ABSCESO DE BOLSA SEROSA DE MUÑECA DERECHA"
  },
  {
    "codigo":15935461000119108,
    "descripcion":"DEFORMIDAD EN FLEXIÓN DE ARTICULACIÓN DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":697992008,
    "descripcion":"HEMIAGEUSIA"
  },
  {
    "codigo":399100901000119108,
    "descripcion":"FIBROMATOSIS AGRESIVA DE DORSO DE TRONCO"
  },
  {
    "codigo":334821000119108,
    "descripcion":"HIPOPIÓN DE OJO DERECHO"
  },
  {
    "codigo":15950821000119109,
    "descripcion":"MELANOMA MALIGNO DE PIEL DE MAMA IZQUIERDA"
  },
  {
    "codigo":302941001,
    "descripcion":"SEUDOARTROSIS DE FRACTURA"
  },
  {
    "codigo":301106001,
    "descripcion":"VEGETACIONES DE VÁLVULA PULMONAR"
  },
  {
    "codigo":366642004,
    "descripcion":"AMPLITUD DE EVERSIÓN PASIVA DE ARTICULACIÓN SUBASTRAGALINA - HALLAZGO"
  },
  {
    "codigo":1251378008,
    "descripcion":"DERMATITIS IRRITATIVA DE CONTACTO AGUDA DE MANO"
  },
  {
    "codigo":200967001,
    "descripcion":"PSORIASIS GIRADA"
  },
  {
    "codigo":364807002,
    "descripcion":"HALLAZGO RELACIONADO CON EL CONTROL DEL MOVIMIENTO"
  },
  {
    "codigo":397575003,
    "descripcion":"HEPATITIS VIRAL, TIPO G"
  },
  {
    "codigo":170034009,
    "descripcion":"TALLA DEL NIÑO MENOR AL PERCENTILO 3"
  },
  {
    "codigo":168199004,
    "descripcion":"ESPÉCIMEN: SIN BACTERIAS EN CULTIVO"
  },
  {
    "codigo":299271004,
    "descripcion":"SIN AMPLITUD PASIVA DE ABDUCCIÓN DE LA CADERA"
  },
  {
    "codigo":4359001,
    "descripcion":"SÍFILIS CONGÉNITA TEMPRANA (MENOS DE 2 AÑOS)"
  },
  {
    "codigo":362972006,
    "descripcion":"TRASTORNO DEL TRABAJO DE PARTO\/PARTO"
  },
  {
    "codigo":199132007,
    "descripcion":"GLUCOSURIA DURANTE EL EMBARAZO"
  },
  {
    "codigo":788956006,
    "descripcion":"TRASTORNO DEL CONTROL DE LOS IMPULSOS CAUSADO POR SUSTANCIA PSICOACTIVA"
  },
  {
    "codigo":428508008,
    "descripcion":"ABORTO DEBIDO A BRUCELLA ABORTUS"
  },
  {
    "codigo":231900008,
    "descripcion":"ÚLCERA DISTRÓFICA DE LA CÓRNEA"
  },
  {
    "codigo":10632111000119100,
    "descripcion":"ABSCESO DE DEDO DE LA MANO DERECHA"
  },
  {
    "codigo":310191000119101,
    "descripcion":"ARTRITIS GOTOSA DE CODO IZQUIERDO"
  },
  {
    "codigo":1073941000119107,
    "descripcion":"BURSITIS GOTOSA DE HOMBRO DERECHO"
  },
  {
    "codigo":721585006,
    "descripcion":"INFECCIÓN TRANSMISIBLE SEXUALMENTE CAUSADA POR VIRUS HERPES SIMPLE"
  },
  {
    "codigo":262833007,
    "descripcion":"CONTUSIÓN DE GLÁNDULA SUPRARRENAL"
  },
  {
    "codigo":295601003,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE MITOBRONITOL"
  },
  {
    "codigo":361137007,
    "descripcion":"PULSO CARDÍACO IRREGULAR"
  },
  {
    "codigo":230065006,
    "descripcion":"FUMADOR COMPULSIVO"
  },
  {
    "codigo":293766003,
    "descripcion":"ALERGIA A DOXORUBICINA"
  },
  {
    "codigo":719750006,
    "descripcion":"CAPAZ DE COMPRENDER UN IDIOMA"
  },
  {
    "codigo":128091003,
    "descripcion":"PTI (PÚRPURA TROMBOCITOPÉNICA INMUNITARIA) PRIMARIA"
  },
  {
    "codigo":717915004,
    "descripcion":"SÍNDROME DE BLEFAROPTOSIS, MIOPÍA, ECTOPIA DE CRISTALINO"
  },
  {
    "codigo":291931003,
    "descripcion":"INTOXICACIÓN POR EL GRUPO DE VITAMINA B"
  },
  {
    "codigo":95323007,
    "descripcion":"ESCLEREDEMA"
  },
  {
    "codigo":290096004,
    "descripcion":"PEZÓN DE COLOR NORMAL"
  },
  {
    "codigo":1142064005,
    "descripcion":"TAQUICARDIA RECIPROCANTE AURICULOVENTRICULAR ANTIDRÓMICA QUE UTILIZA VÍA ACCESORIA AURICULOVENTRICULAR CON CONDUCCIÓN UNIDIRECCIONAL ANTERÓGRADA"
  },
  {
    "codigo":124421005,
    "descripcion":"DEFICIENCIA DE URONOLACTONASA"
  },
  {
    "codigo":288261009,
    "descripcion":"PRESENTACIÓN ANÓMALA ANTES DEL TRABAJO DE PARTO"
  },
  {
    "codigo":26117009,
    "descripcion":"MIOCARDITIS DIFTÉRICA"
  },
  {
    "codigo":286426005,
    "descripcion":"NO SE ABASTECE A SÍ MISMO"
  },
  {
    "codigo":188122007,
    "descripcion":"NEOPLASIA MALIGNA DE PIEL DE ANTEBRAZO"
  },
  {
    "codigo":253658008,
    "descripcion":"QUINTO ARCO AÓRTICO PERSISTENTE"
  },
  {
    "codigo":710575003,
    "descripcion":"ATAQUE ISQUÉMICO TRANSITORIO DEBIDO A EMBOLIA"
  },
  {
    "codigo":251823004,
    "descripcion":"ESTADIO 6 DE DESARROLLO DE VELLO PÚBICO DE TANNER"
  },
  {
    "codigo":22447003,
    "descripcion":"PRESIÓN VENOSA YUGULAR AUMENTADA"
  },
  {
    "codigo":186287003,
    "descripcion":"PESTE AMBULATORIA"
  },
  {
    "codigo":415663009,
    "descripcion":"ESTADO DE CONTROL DEL ABUSO DE SUSTANCIAS"
  },
  {
    "codigo":282756002,
    "descripcion":"LESIÓN TRAUMÁTICA DE MAXILAR"
  },
  {
    "codigo":446596003,
    "descripcion":"HEMATOMA DE PREPUCIO"
  },
  {
    "codigo":249988004,
    "descripcion":"OSCILACIÓN DE LOS ALREDEDORES"
  },
  {
    "codigo":284591009,
    "descripcion":"ABUSO CRÓNICO DE ALCOHOL"
  },
  {
    "codigo":315524005,
    "descripcion":"NACIDO EN SUDÁFRICA"
  },
  {
    "codigo":1263961001,
    "descripcion":"HEMORRAGIA INTRAVENTRICULAR NO TRAUMÁTICA GRADO 4 DE FETO Y\/O NEONATO"
  },
  {
    "codigo":1231193005,
    "descripcion":"ELECTROOCULOGRAMA NORMAL"
  },
  {
    "codigo":51545005,
    "descripcion":"INFECCIÓN CAUSADA POR ACREMONIUM FALCIFORME"
  },
  {
    "codigo":248153007,
    "descripcion":"VARÓN"
  },
  {
    "codigo":706905005,
    "descripcion":"OBJETIVO NO ALCANZABLE"
  },
  {
    "codigo":49710005,
    "descripcion":"BRADICARDIA SINUSAL"
  },
  {
    "codigo":279086006,
    "descripcion":"SENSIBILIDAD EXCESIVA AL DOLOR"
  },
  {
    "codigo":705070007,
    "descripcion":"EJE LARGO DE CORAZÓN FETAL DESVIADO HACIA LA DERECHA"
  },
  {
    "codigo":703235001,
    "descripcion":"FASCIOLOPSIS BUSKI O FASCIOLA HEPATICA"
  },
  {
    "codigo":46040000,
    "descripcion":"ÚLCERA DE COLON"
  },
  {
    "codigo":78808002,
    "descripcion":"HIPERTENSIÓN ESENCIAL QUE COMPLICA EL EMBARAZO Y\/O CONSTITUYE UN MOTIVO DE ATENCIÓN DURANTE ESTE PERÍODO"
  },
  {
    "codigo":275416002,
    "descripcion":"APLASIA BILATERAL CONGÉNITA DE CONDUCTOS DEFERENTES"
  },
  {
    "codigo":111576004,
    "descripcion":"ESTOMATOCITOSIS ADQUIRIDA"
  },
  {
    "codigo":13272007,
    "descripcion":"SÍNDROME DE MASSHOFF"
  },
  {
    "codigo":404653000,
    "descripcion":"GLIOMA QUIASMÁTICO"
  },
  {
    "codigo":11437003,
    "descripcion":"CONTUSIÓN DEL DORSO"
  },
  {
    "codigo":208045004,
    "descripcion":"FRACTURA VERTEBRAL EXPUESTA CON LESIÓN POSTERIOR DE MÉDULA ESPINAL DORSAL, D1-6"
  },
  {
    "codigo":240813008,
    "descripcion":"INFECCIÓN CUTÁNEA POR TREMATODOS"
  },
  {
    "codigo":109741008,
    "descripcion":"FRACTURA DE RESTAURACIÓN DENTAL"
  },
  {
    "codigo":370050004,
    "descripcion":"AUSENCIA DE INVASIÓN TUMORAL EN TEJIDO ADYACENTE"
  },
  {
    "codigo":1254786005,
    "descripcion":"CARCINOMA FUSOCELULAR DE TRÁQUEA"
  },
  {
    "codigo":271746006,
    "descripcion":"TRANSILUMINACIÓN POSITIVA DE SENO MAXILAR"
  },
  {
    "codigo":238978007,
    "descripcion":"ACENTUACIÓN PATOLÓGICA DE LA IMAGEN CORPORAL"
  },
  {
    "codigo":75138007,
    "descripcion":"ENDOFLEBITIS DEL SENO SAGITAL SUPERIOR"
  },
  {
    "codigo":402818009,
    "descripcion":"CARCINOMA BASOCELULAR DE NARIZ"
  },
  {
    "codigo":9602009,
    "descripcion":"ENFERMEDAD POR EL VIRUS TENSAW"
  },
  {
    "codigo":400983004,
    "descripcion":"COMPRESIÓN DE NERVIO ABDOMINOGENITAL MENOR"
  },
  {
    "codigo":237143006,
    "descripcion":"TROMPA DE FALOPIO OBSTRUIDA"
  },
  {
    "codigo":1285719009,
    "descripcion":"HIPERTENSIÓN OCULAR DEBIDA A TRASTORNO VASCULAR OCULAR"
  },
  {
    "codigo":38700005,
    "descripcion":"PIE DE MADURA CAUSADO POR ACTINOMADURA PELLETIERI"
  },
  {
    "codigo":366380009,
    "descripcion":"COLUMNA CERVICAL, AMPLITUD DE MOVIMIENTO - HALLAZGO"
  },
  {
    "codigo":724993002,
    "descripcion":"ACCIDENTE CEREBROVASCULAR ISQUÉMICO DEBIDO A OCLUSIÓN DE GRAN ARTERIA EXTRACRANEAL"
  },
  {
    "codigo":16834071000119101,
    "descripcion":"OBSTRUCCIÓN COMPLETA DE LA LUZ DEL INTESTINO DELGADO"
  },
  {
    "codigo":299009005,
    "descripcion":"AMPLITUD DE PRONACIÓN PASIVA DE LA MUÑECA NORMAL"
  },
  {
    "codigo":723158004,
    "descripcion":"DIPLEJÍA DE MIEMBROS INFERIORES"
  },
  {
    "codigo":459179000,
    "descripcion":"ABSCESO EN LOCALIZACIÓN DE CONDUCTO ARTERIOSO"
  },
  {
    "codigo":721323000,
    "descripcion":"FRACTURA DE APÓFISIS SUBCONDÍLEA DE LA MANDÍBULA"
  },
  {
    "codigo":295339003,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE SUCRALFATO"
  },
  {
    "codigo":360875003,
    "descripcion":"MUDANZA A UN NUEVO DOMICILIO"
  },
  {
    "codigo":65963007,
    "descripcion":"INFECCIÓN TIROIDEA POR ECHINOCOCCUS GRANULOSUS"
  },
  {
    "codigo":262571007,
    "descripcion":"MORDEDURA PROFUNDA DE PERRO"
  },
  {
    "codigo":293504000,
    "descripcion":"REACCIÓN ADVERSA AL RAMIPRIL"
  },
  {
    "codigo":195200006,
    "descripcion":"SÍNDROME HEMISFÉRICO DE LA ARTERIA CARÓTIDA"
  },
  {
    "codigo":162432007,
    "descripcion":"SÍNTOMA: GENERALIZADO"
  },
  {
    "codigo":129664008,
    "descripcion":"NEUROTOXICIDAD CAUSADA POR VINBLASTINA"
  },
  {
    "codigo":1145472009,
    "descripcion":"APLASIA DE CÚBITO"
  },
  {
    "codigo":95061004,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA PIEL DE LOS PÁRPADOS"
  },
  {
    "codigo":291669006,
    "descripcion":"INTOXICACIÓN POR HIDROXIQUINOLINA"
  },
  {
    "codigo":368151000119108,
    "descripcion":"CATARATA DEBIDA A DIABETES MELLITUS MEDICAMENTOSA"
  },
  {
    "codigo":783189008,
    "descripcion":"DESPLAZAMIENTO LATERAL DE LA PELVIA"
  },
  {
    "codigo":93226000,
    "descripcion":"MELANOMA MALIGNO DE LA PIEL DE DEDO DE LA MANO"
  },
  {
    "codigo":1010730002,
    "descripcion":"TROMBOEMBOLIA DE ARTERIA DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":715818002,
    "descripcion":"LIMPIA LA AGUJA CON LA QUE SE INYECTA DROGAS CON LEJÍA"
  },
  {
    "codigo":16670231000119108,
    "descripcion":"FRACTURA NO EXPUESTA DE APÓFISIS CORONOIDES DE LADO IZQUIERDO DE LA MANDÍBULA"
  },
  {
    "codigo":289834006,
    "descripcion":"HALLAZGO RELACIONADO CON EL OVARIO"
  },
  {
    "codigo":224298008,
    "descripcion":"CONTINUÓ SU EDUCACIÓN HASTA SEXTO AÑO"
  },
  {
    "codigo":1078961000119104,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE LÓBULO SUPERIOR DE PULMÓN DERECHO"
  },
  {
    "codigo":124159006,
    "descripcion":"DEFICIENCIA DE FORMALDEHÍDO DESHIDROGENASA"
  },
  {
    "codigo":286164000,
    "descripcion":"DIFICULTAD PARA LIMPIAR EL LAVABO"
  },
  {
    "codigo":253396002,
    "descripcion":"DISPLASIA DE VALVA MITRAL"
  },
  {
    "codigo":1300137003,
    "descripcion":"REACCIÓN ADVERSA A TENECTEPLASA"
  },
  {
    "codigo":251561005,
    "descripcion":"LATENCIA DE RESPUESTA H AUMENTADO"
  },
  {
    "codigo":446334002,
    "descripcion":"PERFORACIÓN DE GASTROYEYUNOSTOMÍA"
  },
  {
    "codigo":282494003,
    "descripcion":"INCAPAZ DE CORRER PENDIENTE ABAJO"
  },
  {
    "codigo":413566007,
    "descripcion":"ANEMIA APLÁSICA ASOCIADA CON PANCREATITIS"
  },
  {
    "codigo":118654009,
    "descripcion":"TRASTORNO CARACTERIZADO POR LA PRESENCIA DE EDEMA"
  },
  {
    "codigo":249726009,
    "descripcion":"AUSENCIA DE OMÓPLATO"
  },
  {
    "codigo":1003390009,
    "descripcion":"HIPODONCIA LIGADA AL CROMOSOMA X"
  },
  {
    "codigo":313427003,
    "descripcion":"MIELOMA DE CADENAS LIVIANAS LAMBDA"
  },
  {
    "codigo":1263699005,
    "descripcion":"TRASTORNO NEONATAL PRECOZ DEBIDO A CIRUGÍA PÉLVICA MATERNA PREVIA"
  },
  {
    "codigo":442664003,
    "descripcion":"TUMEFACCIÓN DE AMÍGDALA DERECHA"
  },
  {
    "codigo":702973002,
    "descripcion":"NIVEL DE ACTIVIDAD FÍSICA DESCONOCIDO"
  },
  {
    "codigo":315211000119107,
    "descripcion":"OSTEOCONDRITIS DISECANTE DE TOBILLO DERECHO"
  },
  {
    "codigo":47613005,
    "descripcion":"ENFERMEDAD CAUSADA POR SPUMAVIRUS"
  },
  {
    "codigo":80381005,
    "descripcion":"DISFONÍA ESPÁSTICA DE TIPO ADUCTOR EN DISTONÍA"
  },
  {
    "codigo":209618007,
    "descripcion":"DESGARRO COMPLETO DE DEDO DE LA MANO, ARTICULACIÓN INTERFALÁNGICA DISTAL, LIGAMENTO LATERAL CUBITAL"
  },
  {
    "codigo":240551003,
    "descripcion":"ENFERMEDAD DE INCLUSIÓN CITOMEGÁLICA CONGÉNITA CRÓNICA"
  },
  {
    "codigo":109479004,
    "descripcion":"HIPOPLASIA GENERALIZADA DEL ESMALTE DE ETIOLOGÍA DESCONOCIDA"
  },
  {
    "codigo":699303006,
    "descripcion":"VOCALIZACIÓN DISRUPTIVA DEBIDA A ENFERMEDAD CEREBRAL"
  },
  {
    "codigo":402556000,
    "descripcion":"MELANOMA MALIGNO (FASE DE CRECIMIENTO RADIAL)"
  },
  {
    "codigo":304252001,
    "descripcion":"PARA REANIMACIÓN"
  },
  {
    "codigo":9340000,
    "descripcion":"TRASTORNO BIPOLAR I, EPISODIO MANÍACO ÚNICO"
  },
  {
    "codigo":369788003,
    "descripcion":"6-10 MITOSIS POR 10 CAMPOS DE GRAN AUMENTO (PUNTAJE = 2)"
  },
  {
    "codigo":238716005,
    "descripcion":"PTERIGIÓN INVERSO UNGUEAL"
  },
  {
    "codigo":344191000119100,
    "descripcion":"COROIDOPATÍA PUNTEADA INTERNA BILATERAL"
  },
  {
    "codigo":204113001,
    "descripcion":"GLAUCOMA CONGÉNITO"
  },
  {
    "codigo":1081471000119101,
    "descripcion":"NEVO EPIDÉRMICO PILOSO PIGMENTADO DE MIEMBRO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":7505006,
    "descripcion":"LESIÓN TRAUMÁTICA DE VASOS SANGUÍNEOS MÚLTIPLES DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":40273006,
    "descripcion":"GEMINACIÓN DE DIENTES"
  },
  {
    "codigo":300582001,
    "descripcion":"LESIONES MÚLTIPLES"
  },
  {
    "codigo":366118002,
    "descripcion":"POSICIÓN DE LA CUERDA VOCAL EN REPOSO - HALLAZGO"
  },
  {
    "codigo":235046001,
    "descripcion":"PIGMENTACIÓN EXÓGENA SISTÉMICA DE LA MUCOSA BUCAL"
  },
  {
    "codigo":202278005,
    "descripcion":"CONTRACTURA EN DESVIACIÓN RADIAL DE LA MUÑECA"
  },
  {
    "codigo":890406007,
    "descripcion":"CRIPTOFTALMOS COMPLETO"
  },
  {
    "codigo":38438008,
    "descripcion":"PIOESTOMATITIS VEGETANTE"
  },
  {
    "codigo":298747001,
    "descripcion":"DEFORMIDAD DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":724731007,
    "descripcion":"DISFUNCIÓN SEXUAL CAUSADA POR SUSTANCIA PSICOACTIVA"
  },
  {
    "codigo":67536000,
    "descripcion":"ARTROPATÍA ASOCIADA CON UN TRASTORNO NEUROLÓGICO"
  },
  {
    "codigo":165840002,
    "descripcion":"FACTOR REUMATOIDE NO DETECTADO"
  },
  {
    "codigo":296912005,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE LIOTIRONINA"
  },
  {
    "codigo":1279952006,
    "descripcion":"SUSTANCIAS REDUCTORAS DETECTADAS EN ORINA"
  },
  {
    "codigo":1148880006,
    "descripcion":"ANEMIA HEMOLÍTICA NO AUTOINMUNE MEDICAMENTOSA"
  },
  {
    "codigo":295077001,
    "descripcion":"ALERGIA A DIPIRIDAMOL"
  },
  {
    "codigo":165002,
    "descripcion":"CONDUCTA PROPENSA A LOS ACCIDENTES"
  },
  {
    "codigo":1179813004,
    "descripcion":"LACTOSA DENTRO DE RANGO DE REFERENCIA"
  },
  {
    "codigo":63866002,
    "descripcion":"FARINGITIS ATRÓFICA"
  },
  {
    "codigo":293242005,
    "descripcion":"REACCIÓN ADVERSA AL PARCHE DE TESTOSTERONA"
  },
  {
    "codigo":1145210007,
    "descripcion":"INTOXICACIÓN ACCIDENTAL CAUSADA POR HIDROCARBURO HALOGENADO"
  },
  {
    "codigo":719226008,
    "descripcion":"PROMINENCIA ANORMAL DE ACROMION"
  },
  {
    "codigo":1208911002,
    "descripcion":"SÍNDROME DE QT PROLONGADO TIPO 9"
  },
  {
    "codigo":12114201000119104,
    "descripcion":"QUEMADURA QUÍMICA DE ANTEBRAZO IZQUIERDO"
  },
  {
    "codigo":94799008,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL CUERPO COCCÍGEO"
  },
  {
    "codigo":225871009,
    "descripcion":"SOLICITA EUTANASIA"
  },
  {
    "codigo":422479008,
    "descripcion":"CARCINOMA DUCTAL INFILTRANTE DE MAMA, ESTADIO 2"
  },
  {
    "codigo":92964003,
    "descripcion":"AGENESIA DE CLAVÍCULA"
  },
  {
    "codigo":191268006,
    "descripcion":"ANEMIA CRÓNICA"
  },
  {
    "codigo":289572007,
    "descripcion":"NO SE OBSERVA LÍQUIDO AMNIÓTICO EN VAGINA"
  },
  {
    "codigo":254969001,
    "descripcion":"NEOPLASIA MALIGNA DE TRACTO OLFATORIO"
  },
  {
    "codigo":123897001,
    "descripcion":"INTOXICACIÓN POR POLYPODIACEAE"
  },
  {
    "codigo":58361001,
    "descripcion":"LESIÓN TRAUMÁTICA DE VENA TIBIAL POSTERIOR"
  },
  {
    "codigo":386041004,
    "descripcion":"PERIHEPATITIS"
  },
  {
    "codigo":11786521000119107,
    "descripcion":"AMPOLLA DE DEDO MEÑIQUE DE MANO DERECHA, CON INFECCIÓN"
  },
  {
    "codigo":189433007,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE SENO MASTOIDEO"
  },
  {
    "codigo":449742000,
    "descripcion":"HEMORRAGIA DE PIEL PERILESIONAL"
  },
  {
    "codigo":713721008,
    "descripcion":"HIDROTÓRAX COMO COMPLICACIÓN DE DIÁLISIS PERITONEAL"
  },
  {
    "codigo":89294002,
    "descripcion":"FRACTURA EXPUESTA DE HÚMERO"
  },
  {
    "codigo":15718681000119108,
    "descripcion":"TRASTORNO DE ENTESIS DE AMBAS MANOS"
  },
  {
    "codigo":127411000119102,
    "descripcion":"SÍNDROME DE CHOQUE TÓXICO CAUSADO POR STAPHYLOCOCCUS AUREUS SENSIBLE A METICILINA"
  },
  {
    "codigo":285902005,
    "descripcion":"NO MANEJA SECARROPAS AUTOMÁTICO"
  },
  {
    "codigo":416974006,
    "descripcion":"DERIVADO PARA PROGRAMA DE EJERCICIOS"
  },
  {
    "codigo":54691007,
    "descripcion":"OSTEÍTIS NO SUPURATIVA CRÓNICA DE LA MANDÍBULA"
  },
  {
    "codigo":282232000,
    "descripcion":"DIFICULTAD PARA CAMINAR APOYANDO PRIMERO EL TALÓN Y LUEGO LOS DEDOS"
  },
  {
    "codigo":1363576002,
    "descripcion":"MOVIMIENTOS FETALES VISUALIZADOS POR LA MADRE"
  },
  {
    "codigo":216696004,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR DIELDRÍN"
  },
  {
    "codigo":16675251000119106,
    "descripcion":"DOLOR BILATERAL DE TESTÍCULOS"
  },
  {
    "codigo":413304006,
    "descripcion":"INSTALACIONES PARA COCINAR INADECUADAS"
  },
  {
    "codigo":249464007,
    "descripcion":"ÚLCERA SUBGLÓTICA"
  },
  {
    "codigo":56200009,
    "descripcion":"INFECCIÓN CAUSADA POR TRICHURIS GLOBULOSA"
  },
  {
    "codigo":313165001,
    "descripcion":"PÉRDIDA VISUAL FUNCIONAL"
  },
  {
    "codigo":213026003,
    "descripcion":"HIPERTERMIA MALIGNA CAUSADA POR AGENTE ANESTÉSICO"
  },
  {
    "codigo":11760051000119109,
    "descripcion":"LACERACIÓN DE ARTERIA POPLÍTEA DERECHA"
  },
  {
    "codigo":16418006,
    "descripcion":"EMBOLIA DEL SENO BASILAR"
  },
  {
    "codigo":278562006,
    "descripcion":"ENCHAPADO DENTAL DESPRENDIDO"
  },
  {
    "codigo":1259767000,
    "descripcion":"MESOTELIOMA PRIMARIO MALIGNO DE PERICARDIO"
  },
  {
    "codigo":346701000119104,
    "descripcion":"CATARATA NUCLEAR CONGÉNITA DE AMBOS OJOS"
  },
  {
    "codigo":702711004,
    "descripcion":"TRASTORNO MENTAL EN LA MADRE QUE COMPLICA EL EMBARAZO"
  },
  {
    "codigo":735479004,
    "descripcion":"PROLAPSO INCOMPLETO DE PARED POSTERIOR DE LA VAGINA"
  },
  {
    "codigo":80119007,
    "descripcion":"PERICARDITIS SECUNDARIA A UREMIA"
  },
  {
    "codigo":242124000,
    "descripcion":"LESIÓN QUE INVOLUCRA A VEHÍCULO DE TRANSPORTE PESADO DETENIDO"
  },
  {
    "codigo":211191009,
    "descripcion":"ABRASIÓN DE PIEL DE AXILA"
  },
  {
    "codigo":209356000,
    "descripcion":"FRACTURA-LUXACIÓN NO EXPUESTA DE ARTICULACIÓN MEDIOTARSIANA"
  },
  {
    "codigo":1290700004,
    "descripcion":"CARCINOMA LOBULILLAR METASTÁSICO"
  },
  {
    "codigo":405964009,
    "descripcion":"EQUIPO INTERGRUPAL PARA EL ESTUDIO POSQUIRÚRGICO DE RABDOMIOSARCOMA IV: TUMOR PRIMARIO DE CUALQUIER TAMAÑO, CON O SIN COMPROMISO GANGLIONAR REGIONAL, CON METÁSTASIS A DISTANCIA, SIN CONSIDERACIÓN DEL ABORDAJE QUIRÚRGICO AL TUMOR PRIMARIO"
  },
  {
    "codigo":895649002,
    "descripcion":"LIQUEN ESCLEROSO TIPO AMPOLLAR"
  },
  {
    "codigo":830113004,
    "descripcion":"SENSIBILIDAD PROFUNDA AUSENTE"
  },
  {
    "codigo":305825006,
    "descripcion":"VISTO POR EL SERVICIO DE REHABILITACIÓN"
  },
  {
    "codigo":404129007,
    "descripcion":"LINFOMA CUTÁNEO ANAPLÁSICO DE CÉLULAS T GRANDES, CD-30 NEGATIVO"
  },
  {
    "codigo":402294001,
    "descripcion":"RESQUEBRAJAMIENTO DE LABIOS"
  },
  {
    "codigo":369526004,
    "descripcion":"TUMOR MALIGNO QUE COMPROMETE EL OVARIO IZQUIERDO POR PROPAGACIÓN DIRECTA DEL OVARIO DERECHO"
  },
  {
    "codigo":9078005,
    "descripcion":"PÓLIPO DE CUERDA VOCAL"
  },
  {
    "codigo":10642151000119103,
    "descripcion":"NECROSIS DE MÚSCULO DE LA NALGA CONCOMITANTE CON ÚLCERA CRÓNICA DE NALGA Y DEBIDA A ELLA"
  },
  {
    "codigo":41846009,
    "descripcion":"TEMBLOR PASIVO"
  },
  {
    "codigo":236619002,
    "descripcion":"REFLUJO VESICOURETERAL POSQUIRÚRGICO"
  },
  {
    "codigo":205686009,
    "descripcion":"CARIOTIPO 46, X ISO (XQ)"
  },
  {
    "codigo":72779005,
    "descripcion":"FÍSTULA ANORRECTAL"
  },
  {
    "codigo":269387007,
    "descripcion":"LESIÓN TESTICULAR EN EL SÍNDROME DE INSENSIBILIDAD A ANDRÓGENOS"
  },
  {
    "codigo":1119520000,
    "descripcion":"AGOTAMIENTO FATIGABLE DE MÚSCULO DE BRAZO"
  },
  {
    "codigo":1186891009,
    "descripcion":"ACEITE DE SILICONA EN OJO POSTERIOR A VITRECTOMÍA"
  },
  {
    "codigo":365856005,
    "descripcion":"CRIBADO - HALLAZGO"
  },
  {
    "codigo":70944005,
    "descripcion":"INTERCAMBIO AÉREO DETERIORADO"
  },
  {
    "codigo":202016006,
    "descripcion":"ARTROPATÍA TRANSITORIA DE LA PRIMERA ARTICULACIÓN METATARSOFALÁNGICA"
  },
  {
    "codigo":300320008,
    "descripcion":"SIGNO ANAL CON NOMBRE PROPIO"
  },
  {
    "codigo":396789002,
    "descripcion":"METÁSTASIS TUMORALES A GANGLIOS LINFÁTICOS NO REGIONALES, NO APLICABLE"
  },
  {
    "codigo":298485002,
    "descripcion":"COLUMNA CERVICAL FRÍA AL TACTO"
  },
  {
    "codigo":724469003,
    "descripcion":"HIDRONEFROSIS SECUNDARIA CONGÉNITA"
  },
  {
    "codigo":296650002,
    "descripcion":"SOBREDOSIS DE PENICILINA"
  },
  {
    "codigo":1279690003,
    "descripcion":"INFECCIÓN CAUSADA POR BORRELIA DUTTONII"
  },
  {
    "codigo":1345226005,
    "descripcion":"CON MAYOR RIESGO DE ASFIXIA INTRAUTERINA"
  },
  {
    "codigo":11762561000119103,
    "descripcion":"PACIENTE DE RESIDENCIA DE VIDA ASISTIDA Y APOYO"
  },
  {
    "codigo":1148618008,
    "descripcion":"ELECTRORRETINOGRAMA DE CENTELLEO CON ADAPTACIÓN A LA LUZ ANORMAL"
  },
  {
    "codigo":460490009,
    "descripcion":"ENDOCARDITIS INFECCIOSA EN LOCALIZACIÓN DE PARCHE DE COMUNICACIÓN INTERAURICULAR"
  },
  {
    "codigo":34506009,
    "descripcion":"REACCIÓN AUTOINMUNITARIA, ÓRGANO O TIPO DE CÉLULA ESPECÍFICOS"
  },
  {
    "codigo":425887005,
    "descripcion":"MENINGITIS BACTERIANA CAUSADA POR BACTERIAS GRAMNEGATIVAS"
  },
  {
    "codigo":294815006,
    "descripcion":"ALERGIA A GONADORELINA"
  },
  {
    "codigo":130975007,
    "descripcion":"REFLEJO FLEXOR DISMINUIDO"
  },
  {
    "codigo":424052001,
    "descripcion":"CARCINOMATOSIS POR CARCINOMA DE CÉLULAS PEQUEÑAS"
  },
  {
    "codigo":32671009,
    "descripcion":"DIETA PARA HIPERLIPOPROTEINEMIA, TIPO IIA"
  },
  {
    "codigo":292980006,
    "descripcion":"REACCIÓN ADVERSA A LA CARFECILINA"
  },
  {
    "codigo":422217003,
    "descripcion":"DISTROFIA CORNEAL EN PIEL DE COCODRILO"
  },
  {
    "codigo":127305005,
    "descripcion":"CONTUSIÓN DEL TRONCO ENCEFÁLICO"
  },
  {
    "codigo":94537006,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE HOMBRO"
  },
  {
    "codigo":1010206000,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE EXTREMIDAD SUPERIOR IZQUIERDA"
  },
  {
    "codigo":225609009,
    "descripcion":"PIERNAS RÍGIDAS"
  },
  {
    "codigo":59934002,
    "descripcion":"ADENOPATÍA SIFILÍTICA SECUNDARIA"
  },
  {
    "codigo":92702009,
    "descripcion":"CARCINOMA IN SITU DE LÓBULO MEDIO DE PULMÓN DERECHO"
  },
  {
    "codigo":1336051006,
    "descripcion":"EPISODIO DE USO NOCIVO DE OPIOIDE"
  },
  {
    "codigo":25331007,
    "descripcion":"LESIÓN TRAUMÁTICA A NIVEL DE T7 - T12 CON LESIÓN DE LA MÉDULA ESPINAL Y SIN LESIÓN ÓSEA"
  },
  {
    "codigo":254707006,
    "descripcion":"NEOPLASIA MALIGNA CUTÁNEA CON DIFERENCIACIÓN ECRINA"
  },
  {
    "codigo":11818011000119105,
    "descripcion":"ESGUINCE DE LIGAMENTO DE ARTICULACIÓN METACARPOFALÁNGICA DE DEDO MEDIO DE MANO IZQUIERDA"
  },
  {
    "codigo":416712009,
    "descripcion":"NEOPLASIA DE CÉLULAS CLARAS (MESONÉFRICA) DE OVARIO"
  },
  {
    "codigo":16542901000119101,
    "descripcion":"FRACTURA NO EXPUESTA DE METÁFISIS DE EXTREMO DISTAL DE RADIO DERECHO"
  },
  {
    "codigo":87197007,
    "descripcion":"INTOXICACIÓN POR ENDRINA"
  },
  {
    "codigo":283805009,
    "descripcion":"MORDEDURA DE ANIMAL EN EL BRAZO"
  },
  {
    "codigo":773490004,
    "descripcion":"ALERGIA A DIHIDROERGOTAMINA"
  },
  {
    "codigo":249202006,
    "descripcion":"ÚTERO FLÁCCIDO LUEGO DEL PARTO"
  },
  {
    "codigo":183666007,
    "descripcion":"ALTA DE CONSULTORIOS EXTERNOS"
  },
  {
    "codigo":52594007,
    "descripcion":"RASGO DE PERSONALIDAD QUE CAUSA UNA DISFUNCIÓN SOCIAL"
  },
  {
    "codigo":280135003,
    "descripcion":"TRASTORNO DE PARTES BLANDAS DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":1230407004,
    "descripcion":"TAPONAMIENTO CARDÍACO POSQUIRÚRGICO"
  },
  {
    "codigo":312903003,
    "descripcion":"RETINOPATÍA NO PROLIFERATIVA LEVE DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":704284001,
    "descripcion":"FRACTURA POR OSTEOPOROSIS SECUNDARIA DE OMÓPLATO"
  },
  {
    "codigo":276465001,
    "descripcion":"HEMATOMA DEL MARGEN ANAL"
  },
  {
    "codigo":47089001,
    "descripcion":"INFECCIÓN CAUSADA POR THELAZIA CALIFORNIENSIS"
  },
  {
    "codigo":702449004,
    "descripcion":"SÍNDROME DE AUTOINFLAMACIÓN, LIPODISTROFIA Y DERMATOSIS"
  },
  {
    "codigo":1259505008,
    "descripcion":"CARCINOMA PRIMARIO MUCOEPIDERMOIDE DE GLÁNDULA SALIVAL"
  },
  {
    "codigo":1290438001,
    "descripcion":"SÍNDROME DE CORDÓN CENTRAL DE MÉDULA CERVICAL DEBIDO A FRACTURA NO EXPUESTA A NIVEL C1-C4"
  },
  {
    "codigo":241862001,
    "descripcion":"EFECTO TÓXICO CAUSADO POR REPELENTE DE INSECTOS"
  },
  {
    "codigo":307398006,
    "descripcion":"INJERTO ILIOFEMORAL INFECTADO"
  },
  {
    "codigo":897222009,
    "descripcion":"CURVATURA ANORMAL DE FALANGE DE CUARTO DEDO DE PIE"
  },
  {
    "codigo":10651001,
    "descripcion":"SÍNDROME CONDUCTUAL POR LOBULOTOMÍA TEMPORAL"
  },
  {
    "codigo":76187003,
    "descripcion":"INMADUREZ EMOCIONAL"
  },
  {
    "codigo":240027002,
    "descripcion":"BURSITIS DE LA REGIÓN DEL PIE"
  },
  {
    "codigo":371099005,
    "descripcion":"COROIDITIS GENERALIZADA DISEMINADA Y CORIORRETINITIS CON NECROSIS AGUDA"
  },
  {
    "codigo":403867004,
    "descripcion":"PAPILOMA BASOCELULAR DE TIPO CLONAL"
  },
  {
    "codigo":698779004,
    "descripcion":"CLORODONCIA"
  },
  {
    "codigo":860784000,
    "descripcion":"LESIÓN TRAUMÁTICA POR FUERZA NO PENETRANTE NO EXPUESTA DE OJO DERECHO"
  },
  {
    "codigo":762480001,
    "descripcion":"QUEMADURA EPIDÉRMICA DE CADERA"
  },
  {
    "codigo":1186629001,
    "descripcion":"CARCINOMA HEPATOCELULAR FIBROLAMINAR PRIMARIO"
  },
  {
    "codigo":203589007,
    "descripcion":"DEFORMIDAD ADQUIRIDA DEL ANTEPIÉ EN ADUCCIÓN"
  },
  {
    "codigo":365594000,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA RECONOCER A OTRAS PERSONAS"
  },
  {
    "codigo":400197008,
    "descripcion":"NEVO EPIDÉRMICO INFLAMATORIO"
  },
  {
    "codigo":269125009,
    "descripcion":"LUXACIÓN EXPUESTA ENTRE LA TERCERA Y LA CUARTA VÉRTEBRAS CERVICALES"
  },
  {
    "codigo":37914004,
    "descripcion":"ESTRECHEZ DE LA VAGINA"
  },
  {
    "codigo":234522008,
    "descripcion":"RECIDIVA DE UNA ENFERMEDAD EN EL TRASPLANTE DE MÉDULA ÓSEA"
  },
  {
    "codigo":724207001,
    "descripcion":"SÍNDROME DE KLEEFSTRA"
  },
  {
    "codigo":36079008,
    "descripcion":"ORIFICIO DOBLE DE VÁLVULA CARDÍACA"
  },
  {
    "codigo":298223009,
    "descripcion":"AMPLITUD DE MOVIMIENTO ARTICULAR PASIVO REDUCIDO"
  },
  {
    "codigo":722372005,
    "descripcion":"LECHO UNGUEAL AZUL"
  },
  {
    "codigo":67012005,
    "descripcion":"ATRESIA ANTRAL PILÓRICA"
  },
  {
    "codigo":229017008,
    "descripcion":"PENETRACIÓN VAGINAL USANDO UN OBJETO"
  },
  {
    "codigo":292718001,
    "descripcion":"REACCIÓN ADVERSA AL CARBOPROST"
  },
  {
    "codigo":63342001,
    "descripcion":"SIGNO DEL CREPÚSCULO"
  },
  {
    "codigo":194414002,
    "descripcion":"PÉRDIDA DE LA AUDICIÓN CONDUCTIVA DEBIDA A TRASTORNO DE LA MEMBRANA TIMPÁNICA"
  },
  {
    "codigo":817006005,
    "descripcion":"AUSENCIA DE MOVIMIENTO OCULAR HACIA ABAJO"
  },
  {
    "codigo":1144686009,
    "descripcion":"APLASIA DE FALANGE DE CUARTO DEDO DE PIE"
  },
  {
    "codigo":127043001,
    "descripcion":"TALASEMIA - BETA^0^ DE CÉLULAS DREPANOCÍTICAS"
  },
  {
    "codigo":28739006,
    "descripcion":"INTOXICACIÓN POR LOLIUM TEMULENTUM"
  },
  {
    "codigo":1306691007,
    "descripcion":"TRASTORNO POR USO DE SUSTANCIA"
  },
  {
    "codigo":94275007,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE DUODENO"
  },
  {
    "codigo":715032004,
    "descripcion":"CAPAZ DE CAMINAR EN UNA HABITACIÓN"
  },
  {
    "codigo":26904005,
    "descripcion":"EXOSTOSIS SUBUNGUEAL"
  },
  {
    "codigo":420120006,
    "descripcion":"TUMOR DEL ESTROMA GASTROINTESTINAL"
  },
  {
    "codigo":289048007,
    "descripcion":"CAPAZ DE UTILIZAR CUCHILLO Y TENEDOR PARA ALIMENTARSE"
  },
  {
    "codigo":1335789000,
    "descripcion":"ARTRITIS IDIOPÁTICA JUVENIL DE CODO IZQUIERDO"
  },
  {
    "codigo":92440008,
    "descripcion":"NEOPLASIA BENIGNA DE TIBIA"
  },
  {
    "codigo":11849501000119100,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE PARED TORÁCICA IZQUIERDA"
  },
  {
    "codigo":254445006,
    "descripcion":"CARCINOMA DEL SURCO BUCAL INFERIOR"
  },
  {
    "codigo":1237485007,
    "descripcion":"METÁSTASIS DE CARCINOMA DE UNIÓN RECTOSIGMOIDEA"
  },
  {
    "codigo":713197008,
    "descripcion":"PÓLIPO RECTAL RECURRENTE"
  },
  {
    "codigo":449218003,
    "descripcion":"LINFOMA DE COLON SIGMOIDE"
  },
  {
    "codigo":23234003,
    "descripcion":"SOBREMORDIDA VERTICAL"
  },
  {
    "codigo":283543003,
    "descripcion":"HERIDA PUNZANTE DE PLANTA DE PIE"
  },
  {
    "codigo":185239004,
    "descripcion":"ATENDIDO EN UN CONSULTORIO DE CIRUGÍA PLÁSTICA"
  },
  {
    "codigo":85100000,
    "descripcion":"HERIDA ABIERTA DEL GLOBO OCULAR"
  },
  {
    "codigo":609388001,
    "descripcion":"ALTO RIESGO DE INSUFICIENCIA CARDÍACA, ESTADIO A"
  },
  {
    "codigo":445548006,
    "descripcion":"FETO MUERTO EN ÚTERO"
  },
  {
    "codigo":247105006,
    "descripcion":"INFILTRACIÓN DE LA RETINA"
  },
  {
    "codigo":736790000,
    "descripcion":"INTÉRPRETE RESERVADO"
  },
  {
    "codigo":441878002,
    "descripcion":"IMPLANTE ANTICONCEPTIVO SUBCUTÁNEO PALPABLE"
  },
  {
    "codigo":11986871000119103,
    "descripcion":"QUEMADURA EPIDÉRMICA DE BRAZO IZQUIERDO"
  },
  {
    "codigo":48662007,
    "descripcion":"PARAPLEJÍA CEREBRAL"
  },
  {
    "codigo":704022007,
    "descripcion":"FRACTURA NO EXPUESTA DE DIÁFISIS DE CUARTO METACARPIANO"
  },
  {
    "codigo":1259243007,
    "descripcion":"ESTRECHEZ DE URETRA PENIANA"
  },
  {
    "codigo":307136000,
    "descripcion":"FRACTURA ÓSEA, CONSOLIDADA, ANTIGUA"
  },
  {
    "codigo":472811009,
    "descripcion":"ANOMALÍA CARDIOVASCULAR DEBIDA A MIOCARDITIS INFECCIOSA"
  },
  {
    "codigo":700352001,
    "descripcion":"TRASTORNO DE TENDÓN DE MÚSCULO TIBIAL ANTERIOR"
  },
  {
    "codigo":208832004,
    "descripcion":"LUXACIÓN PERISEMILUNAR TRAUMÁTICA EXPUESTA (DORSAL)"
  },
  {
    "codigo":44992005,
    "descripcion":"INTENTO FALLIDO DE ABORTO CON HEMÓLISIS INTRAVASCULAR"
  },
  {
    "codigo":272533000,
    "descripcion":"PARADO A HORCAJADAS"
  },
  {
    "codigo":733120009,
    "descripcion":"RHC POSITIVO"
  },
  {
    "codigo":10389003,
    "descripcion":"ÚLCERA GASTROYEYUNAL AGUDA SIN HEMORRAGIA Y SIN PERFORACIÓN PERO CON OBSTRUCCIÓN"
  },
  {
    "codigo":11796561000119101,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN DE DEDO MEÑIQUE DERECHO"
  },
  {
    "codigo":403605007,
    "descripcion":"ASIMBOLIA CONGÉNITA DEL DOLOR"
  },
  {
    "codigo":303466000,
    "descripcion":"CAPAZ DE COLOCARSE PRÓTESIS"
  },
  {
    "codigo":681911000119108,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE CONDUCTO PANCREÁTICO"
  },
  {
    "codigo":8554002,
    "descripcion":"FIEBRE PURPÚRICA BRASILEÑA"
  },
  {
    "codigo":81000119104,
    "descripcion":"INFECCIÓN POR VIRUS DE INMUNODEFICIENCIA HUMANA SINTOMÁTICA"
  },
  {
    "codigo":301631004,
    "descripcion":"CAPAZ DE UTILIZAR ESCALERA MECÁNICA"
  },
  {
    "codigo":268863005,
    "descripcion":"TUVO CIRCULAR DE CORDÓN ALREDEDOR DEL CUELLO"
  },
  {
    "codigo":236095006,
    "descripcion":"HEMORRAGIA DE ANASTOMOSIS DUODENAL"
  },
  {
    "codigo":203327008,
    "descripcion":"ENFERMEDAD DE PAGET DE COLUMNA VERTEBRAL CERVICAL"
  },
  {
    "codigo":398100001,
    "descripcion":"NEUROPATÍA SENSITIVA Y MOTRIZ HEREDITARIA"
  },
  {
    "codigo":299796002,
    "descripcion":"REFLEJO DE GALANT AUSENTE"
  },
  {
    "codigo":201492003,
    "descripcion":"ARTROPATÍA EN EL SÍNDROME DE BEHCET, DE MÚLTIPLES LOCALIZACIONES"
  },
  {
    "codigo":170559008,
    "descripcion":"NO CONCURRE AL SEGUIMIENTO DE ENFERMEDAD CRÓNICA"
  },
  {
    "codigo":365332003,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA LIMPIAR LA PALANGANA"
  },
  {
    "codigo":1217300007,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN DE REGIÓN DE TUBEROSIDAD ISQUIÁTICA DE GLÚTEO IZQUIERDO"
  },
  {
    "codigo":15728721000119107,
    "descripcion":"TRASTORNO BILATERAL DE CODOS"
  },
  {
    "codigo":297961003,
    "descripcion":"MARCA DE PUNTAPIÉ"
  },
  {
    "codigo":35817006,
    "descripcion":"INTOXICACIÓN POR ARUM MACULATUM"
  },
  {
    "codigo":232425007,
    "descripcion":"HEMORRAGIA AMIGDALINA"
  },
  {
    "codigo":396265008,
    "descripcion":"HALLAZGO RELACIONADO CON EL MARGEN DE RESECCIÓN QUIRÚRGICA PROFUNDA"
  },
  {
    "codigo":363497007,
    "descripcion":"NEOPLASIA MALIGNA DE MENINGES"
  },
  {
    "codigo":429033009,
    "descripcion":"NEOPLASIA MALIGNA DE CEREBRO"
  },
  {
    "codigo":722110003,
    "descripcion":"SÍNDROME DE OSTEOGÉNESIS IMPERFECTA, RETINOPATÍA, CONVULSIONES Y DISCAPACIDAD INTELECTUAL"
  },
  {
    "codigo":230590001,
    "descripcion":"NEUROPATÍA EN LA GAMMAPATÍA MONOCLONAL BENIGNA"
  },
  {
    "codigo":296126000,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE TEMAZEPAM"
  },
  {
    "codigo":1214006,
    "descripcion":"INFECCIÓN CAUSADA POR STRONGYLOIDES"
  },
  {
    "codigo":33982008,
    "descripcion":"HIPERFOSFATASEMIA CON DISCAPACIDAD INTELECTUAL"
  },
  {
    "codigo":425363002,
    "descripcion":"SONRISA"
  },
  {
    "codigo":1179027005,
    "descripcion":"PERFORACIÓN DE ÍLEON TERMINAL"
  },
  {
    "codigo":95848000,
    "descripcion":"TRAUMATISMO CRANEOENCEFÁLICO CON OTORRAGIA"
  },
  {
    "codigo":294291008,
    "descripcion":"ALERGIA A PENICILAMINA"
  },
  {
    "codigo":292456001,
    "descripcion":"REACCIÓN ADVERSA AL ISRADIPINO"
  },
  {
    "codigo":43301000087104,
    "descripcion":"CUERPO EXTRAÑO DE ÓRBITA IZQUIERDA PROPIAMENTE DICHA"
  },
  {
    "codigo":1144424004,
    "descripcion":"HEMIATROFIA DE CORTEZA CEREBELOSA"
  },
  {
    "codigo":38181000087104,
    "descripcion":"HIPOCINESIA DE MIOCARDIO DE REGIÓN ANTEROSEPTAL DE VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":423528005,
    "descripcion":"DISPOSICIÓN INADECUADA DE AGUAS SERVIDAS"
  },
  {
    "codigo":48421000087106,
    "descripcion":"FRACTURA DE SEGUNDO HUESO METATARSIANO DE PIE IZQUIERDO"
  },
  {
    "codigo":30312008,
    "descripcion":"INTOXICACIÓN POR HAPLOPAPPUS HETEROPHYLLUS"
  },
  {
    "codigo":28477001,
    "descripcion":"FIEBRE SINDBIS"
  },
  {
    "codigo":94013002,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA PIEL DE LA NALGA"
  },
  {
    "codigo":40741000087107,
    "descripcion":"QUEMADURA DE QUINTO DEDO DE PIE IZQUIERDO"
  },
  {
    "codigo":126781006,
    "descripcion":"NEOPLASIA DE LA PUNTA DE LA LENGUA"
  },
  {
    "codigo":421693007,
    "descripcion":"CÉLULAS PIGMENTADAS EN VÍTREO"
  },
  {
    "codigo":92178001,
    "descripcion":"NEOPLASIA BENIGNA DE LA PARED LATERAL DE LA OROFARINGE"
  },
  {
    "codigo":419858004,
    "descripcion":"REFLEJO MASIVO PRESENTE"
  },
  {
    "codigo":288786004,
    "descripcion":"DIFICULTAD PARA EXPRESAR NECESIDADES Y DESEOS"
  },
  {
    "codigo":254183000,
    "descripcion":"EPIDERMÓLISIS BULLOSA SIMPLE AUTOSÓMICA RECESIVA MORTAL"
  },
  {
    "codigo":24807004,
    "descripcion":"VÁRICES GÁSTRICAS SANGRANTES"
  },
  {
    "codigo":448956001,
    "descripcion":"CAYADO AÓRTICO Y AORTA DESCENDENTE A LA IZQUIERDA, PRESENTES"
  },
  {
    "codigo":874940002,
    "descripcion":"LACERACIÓN DE TRONCO ENCEFÁLICO CON CONMOCIÓN"
  },
  {
    "codigo":285116001,
    "descripcion":"HALLAZGO RELACIONADO CON LA IDENTIDAD SEXUAL"
  },
  {
    "codigo":711100005,
    "descripcion":"ARTERIA DE CALIBRE PERSISTENTE DE LABIO"
  },
  {
    "codigo":330271000119100,
    "descripcion":"COMPRESIÓN DE NERVIO SAFENO EXTERNO DERECHO"
  },
  {
    "codigo":22972008,
    "descripcion":"ERITEMA POLIMORFO, TIPO DÉRMICO"
  },
  {
    "codigo":10897951000119101,
    "descripcion":"FRACTURA EXPUESTA DE BASE DE PRIMER HUESO METACARPIANO DE MANO DERECHA"
  },
  {
    "codigo":1004177004,
    "descripcion":"NIVEL DE ÁCIDO ASPÁRTICO AUMENTADO EN ORINA"
  },
  {
    "codigo":16058911000119101,
    "descripcion":"DEFECTO DE CAMPO VISUAL PERIFÉRICO DE AMBOS OJOS"
  },
  {
    "codigo":283281007,
    "descripcion":"ASTILLA DE MADERA EN CUELLO"
  },
  {
    "codigo":52070001,
    "descripcion":"MALABSORCIÓN ADQUIRIDA DE MONOSACÁRIDOS"
  },
  {
    "codigo":445286001,
    "descripcion":"ANEURISMA DE SENO DE VALSALVA AÓRTICO DESDE SENO CORONARIO DERECHO"
  },
  {
    "codigo":281446004,
    "descripcion":"AFLOJAMIENTO DE TAZA ACETABULAR EN EL REEMPLAZO TOTAL DE CADERA"
  },
  {
    "codigo":248678007,
    "descripcion":"SOPLO MITRAL TELESISTÓLICO"
  },
  {
    "codigo":246843000,
    "descripcion":"SECRECIÓN DE GLÁNDULA DE MEIBOMIO"
  },
  {
    "codigo":838502009,
    "descripcion":"CAPAZ DE CONTROLAR LA PROPIA COMPRENSIÓN"
  },
  {
    "codigo":314214009,
    "descripcion":"OSTEOMIELITIS CRÓNICA DE TIBIA"
  },
  {
    "codigo":707430007,
    "descripcion":"CARCINOMA SUPERPUESTO DE CÉLULAS ESCAMOSAS DE CARTÍLAGO LARÍNGEO"
  },
  {
    "codigo":17467004,
    "descripcion":"HIPERTROFIA DE LOS CORNETES NASALES"
  },
  {
    "codigo":279611005,
    "descripcion":"CHOQUE DE GUERRA"
  },
  {
    "codigo":1229883008,
    "descripcion":"SÍNDROME DE MICRODUPLICACIÓN 19P13.3"
  },
  {
    "codigo":408848001,
    "descripcion":"RETINOPATÍA POR PREMATUREZ, ETAPA 2 - CRESTA INTRARRETINIANA"
  },
  {
    "codigo":11799071000119105,
    "descripcion":"LESIÓN DE ARTERIA UTERINA IZQUIERDA"
  },
  {
    "codigo":48400007,
    "descripcion":"ENFERMEDAD POR EL VIRUS GUAMA"
  },
  {
    "codigo":112101004,
    "descripcion":"CEFALEA DENTAL"
  },
  {
    "codigo":274106005,
    "descripcion":"PAROTIDITIS NO URLIANA"
  },
  {
    "codigo":44730006,
    "descripcion":"UREMIA"
  },
  {
    "codigo":110266007,
    "descripcion":"PÉRDIDA DE MATERIAL RADIOPACO"
  },
  {
    "codigo":863930006,
    "descripcion":"DEPURACIÓN DE CREATININA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":10953401000119104,
    "descripcion":"HERIDA ABIERTA DE DEDO DE MANO DERECHA DEBIDA A MORDEDURA DE GATO"
  },
  {
    "codigo":403343004,
    "descripcion":"LESIÓN DEL TALLO DEL PELO POR SUSTANCIAS QUÍMICAS DE USO EN PELUQUERÍA"
  },
  {
    "codigo":75663006,
    "descripcion":"DISTROFIA ANULAR DE LA CÓRNEA"
  },
  {
    "codigo":42895007,
    "descripcion":"INFECCIÓN CAUSADA POR CUCULLANUS"
  },
  {
    "codigo":1351780001,
    "descripcion":"INMUNODEFICIENCIA COMBINADA AUTOSÓMICA RECESIVA DEBIDA A MUTACIÓN DE REL"
  },
  {
    "codigo":41060007,
    "descripcion":"CAMBIO PRE-ERUPTIVO DE COLOR DE DIENTE"
  },
  {
    "codigo":1153337000,
    "descripcion":"NEOPLASIA EPIDURAL"
  },
  {
    "codigo":237668009,
    "descripcion":"HIPERPROLACTINEMIA DEL EMBARAZO"
  },
  {
    "codigo":792889002,
    "descripcion":"TUMORACIÓN IRREGULAR DE MAMA"
  },
  {
    "codigo":399673005,
    "descripcion":"MARGEN QUIRÚRGICO PROXIMAL COMPROMETIDO POR LINFOMA"
  },
  {
    "codigo":235833007,
    "descripcion":"ÍLEO POSOPERATORIO"
  },
  {
    "codigo":203065008,
    "descripcion":"CONTRACTURA DE MÚSCULO EXTENSOR DE PULGAR"
  },
  {
    "codigo":170297009,
    "descripcion":"EXAMEN DEL NIÑO A LOS 39 MESES: ANORMAL - EN TRATAMIENTO"
  },
  {
    "codigo":365070006,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA HACER USO RECREATIVO DE LA CONVERSACIÓN"
  },
  {
    "codigo":363235000,
    "descripcion":"TRASTORNO HEREDITARIO DEL SISTEMA NERVIOSO"
  },
  {
    "codigo":166627004,
    "descripcion":"FOSFATASA ALCALINA SÉRICA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":230328001,
    "descripcion":"DISTONÍA OROMANDIBULAR AISLADA"
  },
  {
    "codigo":35555009,
    "descripcion":"TRÁQUEA ACCESORIA"
  },
  {
    "codigo":426936004,
    "descripcion":"LESIÓN POR INHALACIÓN DE HUMO"
  },
  {
    "codigo":263096006,
    "descripcion":"FRACTURA-SUBLUXACIÓN DE LA SÍNFISIS PÚBICA"
  },
  {
    "codigo":295864006,
    "descripcion":"SOBREDOSIS DE IMIPRAMINA"
  },
  {
    "codigo":787384008,
    "descripcion":"METABOLIZADOR NORMAL DE LA FAMILIA 3 SUBFAMILIA A MIEMBRO 4 DEL CITOCROMO P450"
  },
  {
    "codigo":195725001,
    "descripcion":"BRONQUITIS AGUDA POR VIRUS COXACKIE"
  },
  {
    "codigo":359565003,
    "descripcion":"MIOGLOBINURIA POR INGESTA DE ANGUILA"
  },
  {
    "codigo":720013006,
    "descripcion":"DISFUNCIÓN SOMÁTICA DE REGIÓN DE LA CABEZA"
  },
  {
    "codigo":294029008,
    "descripcion":"ALERGIA A NOREPINEFRINA"
  },
  {
    "codigo":95586000,
    "descripcion":"TELANGIECTASIA DE VEJIGA URINARIA"
  },
  {
    "codigo":228493008,
    "descripcion":"EX CONSUMIDOR DE RAPÉ"
  },
  {
    "codigo":161122005,
    "descripcion":"EDUCACIÓN SUPERIOR"
  },
  {
    "codigo":292194006,
    "descripcion":"REACCIÓN ADVERSA AL FILGRASTIM"
  },
  {
    "codigo":126519001,
    "descripcion":"NEOPLASIA DE PIEL DE CODO"
  },
  {
    "codigo":290359001,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR FAMOTIDINA"
  },
  {
    "codigo":93751003,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA COLUMNA VERTEBRAL CERVICAL"
  },
  {
    "codigo":421431004,
    "descripcion":"NOCARDIOSIS CON SÍNDROME DE INMUNODEFICIENCIA ADQUIRIDA"
  },
  {
    "codigo":1142327006,
    "descripcion":"ATROFIA MUSCULAR ESPINAL PROXIMAL"
  },
  {
    "codigo":60983006,
    "descripcion":"FÍSTULA TRAQUEOESOFÁGICA CONGÉNITA"
  },
  {
    "codigo":124684005,
    "descripcion":"DEFICIENCIA DE RACEMASA"
  },
  {
    "codigo":419596007,
    "descripcion":"HEMORRAGIA SUPRACOROIDEA"
  },
  {
    "codigo":1236961000,
    "descripcion":"METÁSTASIS DE CARCINOMA EN PORCIÓN ANTERIOR DE PISO DE BOCA"
  },
  {
    "codigo":91916009,
    "descripcion":"AUSENCIA CONGÉNITA DEL CENTRO DE LA VÉRTEBRA DORSAL"
  },
  {
    "codigo":10818541000119107,
    "descripcion":"FRACTURA ABIERTA DE CAVIDAD GLENOIDEA DERECHA"
  },
  {
    "codigo":384993003,
    "descripcion":"INFARTO VENOSO HEMORRÁGICO PERIVENTRICULAR"
  },
  {
    "codigo":1204193005,
    "descripcion":"ANEURISMA AÓRTICO POR CARDIOPATÍA CONGÉNITA"
  },
  {
    "codigo":286689005,
    "descripcion":"REBELARSE CONTRA EL YO - MECANISMO DE DEFENSA PSICOLÓGICA"
  },
  {
    "codigo":88246005,
    "descripcion":"INTOXICACIÓN POR ANTHOXANTHUM ODORATUM"
  },
  {
    "codigo":219318007,
    "descripcion":"LESIÓN INDETERMINADA RESPECTO DE SU POSIBLE CAUSA ACCIDENTAL O INTENCIONAL, INTOXICACIÓN POR GASES DE USO DOMÉSTICO"
  },
  {
    "codigo":709003000,
    "descripcion":"HETEROTOPÍA DE GLÁNDULA SALIVAL"
  },
  {
    "codigo":284854009,
    "descripcion":"NO SE SUENA LA NARIZ"
  },
  {
    "codigo":446859003,
    "descripcion":"LACERACIÓN DE LECHO UNGUEAL DE DEDO DE PIE"
  },
  {
    "codigo":1003915007,
    "descripcion":"DELECIÓN PROXIMAL DEL BRAZO CORTO DEL CROMOSOMA 3"
  },
  {
    "codigo":1264224006,
    "descripcion":"INFECCIÓN NEONATAL PRECOZ CAUSADA POR ESCHERICHIA COLI"
  },
  {
    "codigo":248416007,
    "descripcion":"EXTREMIDADES AZULES"
  },
  {
    "codigo":1099041000119101,
    "descripcion":"OPACIDAD DE CÓRNEA DE OJO IZQUIERDO"
  },
  {
    "codigo":16909601000119101,
    "descripcion":"DISFUNCIÓN DE GLÁNDULA MEIBOMIO DE PÁRPADO SUPERIOR E INFERIOR DERECHO"
  },
  {
    "codigo":49973006,
    "descripcion":"DEFICIENCIA FAMILIAR DE LIPOPROTEÍNA"
  },
  {
    "codigo":1196853006,
    "descripcion":"CARCINOMA PRIMARIO DE VÍA BILIAR"
  },
  {
    "codigo":312117008,
    "descripcion":"INFECCIÓN BACTERIANA RESPIRATORIA"
  },
  {
    "codigo":82741008,
    "descripcion":"URTICARIA INMUNOLÓGICA AGUDA"
  },
  {
    "codigo":689441000119102,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE ORIFICIO URETERAL"
  },
  {
    "codigo":211978007,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO PROFUNDA DE RODILLA"
  },
  {
    "codigo":46303000,
    "descripcion":"MENINGITIS POR COCCIDIOS"
  },
  {
    "codigo":898271002,
    "descripcion":"ANQUILOSIS CONGÉNITA DE ARTICULACIÓN INTERFALÁNGICA PROXIMAL DE CUARTO DEDO DE PIE"
  },
  {
    "codigo":111839008,
    "descripcion":"INFECCIÓN INTESTINAL CAUSADA POR ESCHERICHIA COLI"
  },
  {
    "codigo":110004001,
    "descripcion":"LEUCEMIA PROMIELOCÍTICA AGUDA, FAB M3"
  },
  {
    "codigo":699828007,
    "descripcion":"PÉRDIDA DE RELACIÓN OCLUSAL CON PRÓTESIS COMPLETA"
  },
  {
    "codigo":403081001,
    "descripcion":"TIÑA CAUSADA POR TRICHOPHYTON SIMII"
  },
  {
    "codigo":697993003,
    "descripcion":"CARCINOMA INDIFERENCIADO DE SENO PARANASAL"
  },
  {
    "codigo":42633004,
    "descripcion":"DIETA BLANDA, ESTADIO 1"
  },
  {
    "codigo":763529005,
    "descripcion":"SÍNDROME DE MONOSOMÍA 7Q36 DISTAL"
  },
  {
    "codigo":1251379000,
    "descripcion":"DERMATITIS DE CONTACTO DE PIE"
  },
  {
    "codigo":302942008,
    "descripcion":"DEFORMIDAD CON FLEXIÓN FIJA DE DEDO DE LA MANO"
  },
  {
    "codigo":16028351000119100,
    "descripcion":"EXOSTOSIS DE PIE IZQUIERDO"
  },
  {
    "codigo":301107005,
    "descripcion":"VÁLVULA PULMONAR NORMAL"
  },
  {
    "codigo":10626751000119101,
    "descripcion":"FORÚNCULO DE RODILLA DERECHA"
  },
  {
    "codigo":673471000119101,
    "descripcion":"EXOSTOSIS DE CINTURA ESCAPULAR"
  },
  {
    "codigo":350911000119102,
    "descripcion":"NEOPLASIA BENIGNA DE PARTES BLANDAS DE EXTREMIDAD INFERIOR IZQUIERDA"
  },
  {
    "codigo":15992511000119105,
    "descripcion":"QUERATITIS INTERSTICIAL DE OJO DERECHO CAUSADA POR VIRUS HERPES SIMPLE"
  },
  {
    "codigo":1083071000119106,
    "descripcion":"INFLAMACIÓN SANGUÍNEA AGUDA DE AMBOS OÍDOS MEDIOS"
  },
  {
    "codigo":1088191000119102,
    "descripcion":"OTITIS MEDIA AGUDA SANGUINOLENTA DE OÍDO MEDIO IZQUIERDO"
  },
  {
    "codigo":11827391000119108,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN DE DEDO DE PIE DERECHO"
  },
  {
    "codigo":66751000119109,
    "descripcion":"PORTADOR DE HEMOGLOBINOPATÍA"
  },
  {
    "codigo":200968006,
    "descripcion":"PSORIASIS INVETERADA"
  },
  {
    "codigo":364808007,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA MAMAR"
  },
  {
    "codigo":233736008,
    "descripcion":"MEDIASTINITIS FIBROSA INFECCIOSA"
  },
  {
    "codigo":362973001,
    "descripcion":"TRASTORNO DEL PUERPERIO"
  },
  {
    "codigo":788957002,
    "descripcion":"TRASTORNO DEL CONTROL DE LOS IMPULSOS CAUSADO POR ESTIMULANTE"
  },
  {
    "codigo":16302271000119108,
    "descripcion":"LESIÓN ÓSEA DE HOMBRO DERECHO"
  },
  {
    "codigo":10900671000119107,
    "descripcion":"HERIDA PENETRANTE DE ÓRBITA DERECHA"
  },
  {
    "codigo":315071000119109,
    "descripcion":"OSTEÍTIS DEFORMANTE DE TIBIA Y PERONÉ"
  },
  {
    "codigo":428509000,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN MÚLTIPLES LOCALIZACIONES"
  },
  {
    "codigo":231901007,
    "descripcion":"ÚLCERA NEUROPÁTICA DE CÓRNEA"
  },
  {
    "codigo":1149405004,
    "descripcion":"SOBREDOSIS DE PROTAMINA"
  },
  {
    "codigo":262834001,
    "descripcion":"LACERACIÓN DE GLÁNDULA SUPRARRENAL"
  },
  {
    "codigo":721586007,
    "descripcion":"FARINGOAMIGDALITIS CAUSADA POR VIRUS HERPES SIMPLE HUMANO"
  },
  {
    "codigo":719751005,
    "descripcion":"CAPAZ DE COMPRENDER INSTRUCCIONES DE MÁS DE TRES PALABRAS"
  },
  {
    "codigo":293767007,
    "descripcion":"ALERGIA A EPIRUBICINA"
  },
  {
    "codigo":424839007,
    "descripcion":"RECURSOS COMUNITARIOS PARA FOMENTAR UNA VIDA SALUDABLE INADECUADOS"
  },
  {
    "codigo":95324001,
    "descripcion":"LESIÓN DE LA PIEL"
  },
  {
    "codigo":457607008,
    "descripcion":"OBSTRUCCIÓN DE VÁLVULA TRICÚSPIDE DEBIDA A NEOPLASIA"
  },
  {
    "codigo":717916003,
    "descripcion":"CARCINOMA NEUROENDOCRINO DE APÉNDICE ILEOCECAL"
  },
  {
    "codigo":128092005,
    "descripcion":"TROMBOCITOPENIA AUTOINMUNITARIA SECUNDARIA"
  },
  {
    "codigo":291932005,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ÁCIDO FÓLICO"
  },
  {
    "codigo":193628007,
    "descripcion":"ANISOMETROPÍA Y ANISEICONIA"
  },
  {
    "codigo":60721002,
    "descripcion":"CUARTO RUIDO AURICULAR NORMAL, R>4<"
  },
  {
    "codigo":11833071000119101,
    "descripcion":"ESGUINCE DE LIGAMENTO TARSOMETATARSIANO DE ARTICULACIÓN DE PIE IZQUIERDO"
  },
  {
    "codigo":290097008,
    "descripcion":"LESIÓN DE PEZÓN"
  },
  {
    "codigo":191793009,
    "descripcion":"DESEO SEXUAL INHIBIDO"
  },
  {
    "codigo":124422003,
    "descripcion":"DEFICIENCIA DE TANASA"
  },
  {
    "codigo":216633071000119103,
    "descripcion":"TRASTORNO ALIMENTARIO PEDIÁTRICO CRÓNICO"
  },
  {
    "codigo":91654007,
    "descripcion":"CONSISTENCIA DE UNA COLONIA BACTERIANA"
  },
  {
    "codigo":286427001,
    "descripcion":"DIFICULTAD PARA ABASTECERSE A SÍ MISMO"
  },
  {
    "codigo":89819002,
    "descripcion":"INSUFICIENCIA CARDÍACA DURANTE UN PROCEDIMIENTO Y\/O COMO CONSECUENCIA DE ÉL"
  },
  {
    "codigo":12242671000119105,
    "descripcion":"QUISTE DE GLÁNDULA PARÓTIDA DERECHA"
  },
  {
    "codigo":284592002,
    "descripcion":"CONDUCTA VOCAL Y VERBAL - HALLAZGO"
  },
  {
    "codigo":282757006,
    "descripcion":"LESIÓN DE MEJILLA"
  },
  {
    "codigo":446597007,
    "descripcion":"FRACTURA DEPRIMIDA NO EXPUESTA DE CRÁNEO"
  },
  {
    "codigo":249989007,
    "descripcion":"SENSACIÓN DE CAÍDA"
  },
  {
    "codigo":84314001,
    "descripcion":"INTOXICACIÓN POR ISOTROPIS"
  },
  {
    "codigo":315525006,
    "descripcion":"NACIDO EN COREA DEL SUR"
  },
  {
    "codigo":1231194004,
    "descripcion":"PERCEPCIÓN VISUAL DE MOVIMIENTO NORMAL"
  },
  {
    "codigo":870746005,
    "descripcion":"ALERGIA A ERGOMETRINA Y\/U OXITOCINA"
  },
  {
    "codigo":706906006,
    "descripcion":"SIN PROGRESO HACIA EL OBJETIVO"
  },
  {
    "codigo":703236000,
    "descripcion":"ESTENOSIS DE VÁLVULA AÓRTICA CON INSUFICIENCIA DE ETIOLOGÍA NO REUMÁTICA"
  },
  {
    "codigo":15108003,
    "descripcion":"DIETA RESTRINGIDA EN FIBRAS"
  },
  {
    "codigo":46041001,
    "descripcion":"SÍNDROME DE MAFFUCCI"
  },
  {
    "codigo":13273002,
    "descripcion":"PUERPERIO, 4 DÍAS"
  },
  {
    "codigo":441092009,
    "descripcion":"LEE LOS LABIOS"
  },
  {
    "codigo":766937004,
    "descripcion":"HIPERTENSIÓN DEBIDA A MUTACIÓN DE GANANCIA DE FUNCIÓN EN EL RECEPTOR DE MINERALOCORTICOIDES"
  },
  {
    "codigo":78809005,
    "descripcion":"PÓLIPO GÁSTRICO"
  },
  {
    "codigo":111577008,
    "descripcion":"ANEMIA POR DEFICIENCIA ENZIMÁTICA"
  },
  {
    "codigo":109742001,
    "descripcion":"ARREGLO DENTAL IRREPARABLE"
  },
  {
    "codigo":240814002,
    "descripcion":"POIQUILORQUIASIS"
  },
  {
    "codigo":404654006,
    "descripcion":"FENÓMENO DE RIDDOCH"
  },
  {
    "codigo":370051000,
    "descripcion":"AUSENCIA DE INVASIÓN TUMORAL PERINEURAL"
  },
  {
    "codigo":402819001,
    "descripcion":"CARCINOMA BASOCELULAR DE PIEL DE LABIO"
  },
  {
    "codigo":271747002,
    "descripcion":"CUERDAS VOCALES ENGROSADAS"
  },
  {
    "codigo":1254787001,
    "descripcion":"CARCINOMA ESCAMOCELULAR PAPILAR DE TRÁQUEA"
  },
  {
    "codigo":238979004,
    "descripcion":"HIPOESQUEMACIA"
  },
  {
    "codigo":44206008,
    "descripcion":"ANEMIA HEMOLÍTICA DE BAJA AFINIDAD TIPO HAPTENO"
  },
  {
    "codigo":269912000,
    "descripcion":"ESPUTO: TUBÉRCULO EN LA TINCIÓN DE ZIEHL-NEELSEN"
  },
  {
    "codigo":206211008,
    "descripcion":"FRACTURA DE HÚMERO POR TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":7768008,
    "descripcion":"FRACASO DE LA DILATACIÓN CERVICAL"
  },
  {
    "codigo":399149003,
    "descripcion":"ACIDEMIA PROPIÓNICA TIPO II"
  },
  {
    "codigo":169773005,
    "descripcion":"ATENCIÓN POSNATAL INICIADA EN EL NACIMIENTO"
  },
  {
    "codigo":366381008,
    "descripcion":"AMPLITUD DE LA FLEXIÓN DE LA COLUMNA CERVICAL - HALLAZGO"
  },
  {
    "codigo":36866003,
    "descripcion":"PARACOCCIDIOIDOMICOSIS MUCOCUTÁNEA - LINFANGÍTICA"
  },
  {
    "codigo":200706004,
    "descripcion":"IMPÉTIGO NEONATAL"
  },
  {
    "codigo":397314005,
    "descripcion":"INTEGRIDAD DEL ESPÉCIMEN DESCONOCIDA"
  },
  {
    "codigo":15931581000119103,
    "descripcion":"QUISTE SEROSO DE OVARIO IZQUIERDO"
  },
  {
    "codigo":167938007,
    "descripcion":"MEGACARIOCITOS EN MÉDULA ÓSEA, NORMALES"
  },
  {
    "codigo":724994008,
    "descripcion":"ACCIDENTE CEREBROVASCULAR ISQUÉMICO DEBIDO A ESTENOSIS DE GRAN ARTERIA EXTRACRANEAL"
  },
  {
    "codigo":284861000119104,
    "descripcion":"ATEROSCLEROSIS DE AMBAS ARTERIAS CARÓTIDAS"
  },
  {
    "codigo":35031005,
    "descripcion":"SÍNDROME DE HANHART"
  },
  {
    "codigo":297175006,
    "descripcion":"ANEURISMA DE LA ARTERIA FEMORAL PROFUNDA"
  },
  {
    "codigo":723159007,
    "descripcion":"MONOPLEJÍA FLÁCCIDA DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":295340001,
    "descripcion":"SOBREDOSIS INTENCIONAL DE SUCRALFATO"
  },
  {
    "codigo":459180002,
    "descripcion":"ANEURISMA DE PARCHE DE DEFECTO DE TABIQUE AURICULOVENTRICULAR"
  },
  {
    "codigo":721324006,
    "descripcion":"FRACTURA DE APÓFISIS CORONOIDES DE LA MANDÍBULA"
  },
  {
    "codigo":1077591000119101,
    "descripcion":"OSTEOMIELITIS CRÓNICA DE TIBIA IZQUIERDA"
  },
  {
    "codigo":1145473004,
    "descripcion":"APLASIA DE VÉRTEBRA"
  },
  {
    "codigo":293505004,
    "descripcion":"REACCIÓN ADVERSA AL CILAZAPRIL"
  },
  {
    "codigo":129665009,
    "descripcion":"NEUROTOXICIDAD CAUSADA POR L-ASPARAGINASA"
  },
  {
    "codigo":95062006,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA PIEL DE LA CARA"
  },
  {
    "codigo":422742006,
    "descripcion":"DIFICULTAD PARA RESOLVER PROBLEMAS SIN CONFLICTOS"
  },
  {
    "codigo":291670007,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR HIDROXIQUINOLINA"
  },
  {
    "codigo":224299000,
    "descripcion":"RECIBIÓ EDUCACIÓN SUPERIOR"
  },
  {
    "codigo":27691002,
    "descripcion":"DETERMINACIÓN DEL ESTADO DE LA ENFERMEDAD: DETENIDA"
  },
  {
    "codigo":715819005,
    "descripcion":"LISENCEFALIA CONCOMITANTE CON HIPOPLASIA CONGÉNITA DE CEREBELO, TIPO B"
  },
  {
    "codigo":191531007,
    "descripcion":"EXACERBACIÓN AGUDA DE ESQUIZOFRENIA CRÓNICA"
  },
  {
    "codigo":289835007,
    "descripcion":"OVARIO PRESENTE"
  },
  {
    "codigo":93227009,
    "descripcion":"MELANOMA MALIGNO DE LA PIEL DEL PIE"
  },
  {
    "codigo":12631000119106,
    "descripcion":"DEFICIENCIA DE INMUNOGLOBULINA G"
  },
  {
    "codigo":187861000,
    "descripcion":"NEOPLASIA MALIGNA DE BRONQUIO DEL LÓBULO SUPERIOR"
  },
  {
    "codigo":253397006,
    "descripcion":"CABALGAMIENTO DE VÁLVULA MITRAL"
  },
  {
    "codigo":15987031000119108,
    "descripcion":"ANIRIDIA CONGÉNITA DE AMBOS OJOS"
  },
  {
    "codigo":218794000,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR MESCALINA"
  },
  {
    "codigo":417237009,
    "descripcion":"AMPOLLA DE PIEL Y\/O MUCOSA"
  },
  {
    "codigo":251562003,
    "descripcion":"ASIMETRÍA DE LA RESPUESTA H"
  },
  {
    "codigo":54954004,
    "descripcion":"ASPARTILGLUCOSAMINURIA"
  },
  {
    "codigo":284330007,
    "descripcion":"CAPAZ DE INSERTAR UN OBJETO DENTRO DE OTRO"
  },
  {
    "codigo":249727000,
    "descripcion":"OMÓPLATO GRANDE"
  },
  {
    "codigo":446335001,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DEL PIE"
  },
  {
    "codigo":282495002,
    "descripcion":"CORRE PENDIENTE ABAJO"
  },
  {
    "codigo":413567003,
    "descripcion":"ANEMIA APLÁSICA ASOCIADA CON EMBARAZO"
  },
  {
    "codigo":1003391008,
    "descripcion":"DELECIÓN DE PORCIÓN MEDIA DEL BRAZO LARGO DE CROMOSOMA 4"
  },
  {
    "codigo":247892001,
    "descripcion":"AUTODESVALORIZACIÓN"
  },
  {
    "codigo":1263700006,
    "descripcion":"TRASTORNO FETAL DEBIDO A CIRUGÍA UTERINA MATERNA PREVIA"
  },
  {
    "codigo":16681000,
    "descripcion":"OTITIS EXTERNA POR CANDIDA"
  },
  {
    "codigo":313428008,
    "descripcion":"SEMINOMA DE CRIPTORQUIDIA UNILATERAL"
  },
  {
    "codigo":442665002,
    "descripcion":"TASA METABÓLICA BASAL FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":11864561000119108,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE PIE DERECHO"
  },
  {
    "codigo":111315008,
    "descripcion":"DEFICIENCIA LONGITUDINAL DE TIBIA Y\/O PERONÉ"
  },
  {
    "codigo":109480001,
    "descripcion":"HIPOPLASIA GENERALIZADA DEL ESMALTE ASOCIADA CON ENFERMEDAD SISTÉMICA"
  },
  {
    "codigo":1354664003,
    "descripcion":"POSICIÓN CORPORAL EN DECÚBITO VENTRAL PARA ALIMENTACIÓN CON SONDA"
  },
  {
    "codigo":240552005,
    "descripcion":"TABES DORSAL JUVENIL"
  },
  {
    "codigo":76712006,
    "descripcion":"TRASTORNO DE ÓRGANO DIGESTIVO"
  },
  {
    "codigo":9341001,
    "descripcion":"EFECTO TARDÍO DE LA FRACTURA DE LA COLUMNA VERTEBRAL Y\/O DEL TRONCO, SIN LESIÓN DE LA MÉDULA ESPINAL"
  },
  {
    "codigo":107645002,
    "descripcion":"HALLAZGO EN EL TAMAÑO"
  },
  {
    "codigo":238717001,
    "descripcion":"UÑAS EN CASCANUECES"
  },
  {
    "codigo":11176009,
    "descripcion":"MIOPERICARDITIS AGUDA"
  },
  {
    "codigo":74877002,
    "descripcion":"ANOMALÍA CONGÉNITA DE LA COLUMNA VERTEBRAL"
  },
  {
    "codigo":304253006,
    "descripcion":"NO REANIMAR"
  },
  {
    "codigo":369789006,
    "descripcion":">11 MITOSIS POR 10 CAMPOS DE GRAN AUMENTO (PUNTAJE = 3)"
  },
  {
    "codigo":42109006,
    "descripcion":"FRACTURAS MÚLTIPLES NO EXPUESTAS DE MIEMBRO INFERIOR CON COSTILLAS Y ESTERNÓN"
  },
  {
    "codigo":402557009,
    "descripcion":"MELANOMA MALIGNO ACROLENTIGINOSO IN SITU"
  },
  {
    "codigo":39944005,
    "descripcion":"FORMA COMBINADA DE CATARATA NO SENIL"
  },
  {
    "codigo":342821000119103,
    "descripcion":"CATARATA POLAR SUBCAPSULAR POSTERIOR CONGÉNITA"
  },
  {
    "codigo":38439000,
    "descripcion":"DUPLICACIÓN CRANEAL"
  },
  {
    "codigo":202279002,
    "descripcion":"CONTRACTURA EN FLEXIÓN DE LA ARTICULACIÓN METACARPOFALÁNGICA"
  },
  {
    "codigo":169511003,
    "descripcion":"SUSPENDE EL USO DEL MÉTODO DEL RITMO"
  },
  {
    "codigo":235047005,
    "descripcion":"PIGMENTACIÓN LOCAL EXÓGENA DE LA MUCOSA ORAL"
  },
  {
    "codigo":366119005,
    "descripcion":"POSICIÓN DE LAS CUERDAS VOCALES DURANTE LA RESPIRACIÓN - HALLAZGO"
  },
  {
    "codigo":71207007,
    "descripcion":"ENTERITIS NO INFECCIOSA"
  },
  {
    "codigo":724732000,
    "descripcion":"TRASTORNO DEL SUEÑO CAUSADO POR SUSTANCIA PSICOACTIVA"
  },
  {
    "codigo":300583006,
    "descripcion":"FLUCTUANTE"
  },
  {
    "codigo":298748006,
    "descripcion":"HALLAZGO RELACIONADO CON LA PROPORCIÓN DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":200444007,
    "descripcion":"GALACTORREA EN EL EMBARAZO Y EL PUERPERIO"
  },
  {
    "codigo":198609003,
    "descripcion":"COMPLICACIÓN DE EMBARAZO, PARTO Y\/O PUERPERIO"
  },
  {
    "codigo":1148881005,
    "descripcion":"GLOMERULOPATÍA DEBIDA A ESCLEROSIS MESANGIAL DIFUSA"
  },
  {
    "codigo":1179814005,
    "descripcion":"MANOHEPTULOSA DENTRO DE RANGO DE REFERENCIA"
  },
  {
    "codigo":293243000,
    "descripcion":"REACCIÓN ADVERSA AL ESTRÓGENO"
  },
  {
    "codigo":162171002,
    "descripcion":"SEXUALMENTE INACTIVO EN LA ACTUALIDAD"
  },
  {
    "codigo":719227004,
    "descripcion":"PÉRDIDA DE GRASA SUBCUTÁNEA QUE RECUBRE A COSTILLA"
  },
  {
    "codigo":225872002,
    "descripcion":"PACIENTE CONSCIENTE DE LOS SENTIMIENTOS DEL CUIDADOR CON RESPECTO A LA MUERTE"
  },
  {
    "codigo":94800007,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL CÓCCIX"
  },
  {
    "codigo":291408009,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR NALORFINA"
  },
  {
    "codigo":289573002,
    "descripcion":"HALLAZGO RELACIONADO CON LA ELIMINACIÓN DEL TAPÓN MUCOSO"
  },
  {
    "codigo":92965002,
    "descripcion":"AUSENCIA CONGÉNITA DEL DUCTUS ARTERIOSO"
  },
  {
    "codigo":846629004,
    "descripcion":"NEUMONITIS CAUSADA POR HUMOS"
  },
  {
    "codigo":60197002,
    "descripcion":"INFECCIÓN CAUSADA POR FIMBRIARIA"
  },
  {
    "codigo":1010469007,
    "descripcion":"ESCLEROSIS DE EPÍFISIS DE FALANGE DISTAL DE DEDO MEDIO CON RADIOPACIDAD AUMENTADA"
  },
  {
    "codigo":254970000,
    "descripcion":"NEOPLASIA BENIGNA DE TRACTO OLFATIVO"
  },
  {
    "codigo":713722001,
    "descripcion":"INFECCIÓN CAUSADA POR CYTOMEGALOVIRUS CONCOMITANTE CON INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":123898006,
    "descripcion":"INTOXICACIÓN POR CHENOPODIACEAE"
  },
  {
    "codigo":285903000,
    "descripcion":"DIFICULTAD PARA MANEJAR SECARROPAS AUTOMÁTICO"
  },
  {
    "codigo":449743005,
    "descripcion":"EPITELIZACIÓN DE HERIDA"
  },
  {
    "codigo":253135006,
    "descripcion":"DEFECTO DE DIVISIÓN TELENCEFÁLICA"
  },
  {
    "codigo":416975007,
    "descripcion":"DEMENCIA DEGENERATIVA PRIMARIA DE TIPO ALZHEIMER, DE INICIO EN LA ETAPA SENIL"
  },
  {
    "codigo":16837721000119105,
    "descripcion":"INFARTO DE MIOCARDIO TIPO 5"
  },
  {
    "codigo":710052000,
    "descripcion":"FRACTURA PATOLÓGICA DE RADIO Y CÚBITO DISTALES"
  },
  {
    "codigo":87460008,
    "descripcion":"EFECTO TÓXICO DEL ALCOHOL AMÍLICO"
  },
  {
    "codigo":1082611000119101,
    "descripcion":"ASCITIS DEBIDA A HEPATITIS ALCOHÓLICA"
  },
  {
    "codigo":1363577006,
    "descripcion":"MOVIMIENTOS FETALES VISUALIZADOS POR PAREJA"
  },
  {
    "codigo":413305007,
    "descripcion":"EQUIPAMIENTO DE SEGURIDAD INADECUADO"
  },
  {
    "codigo":313166000,
    "descripcion":"PÉRDIDA DE LA FUSIÓN VISUAL"
  },
  {
    "codigo":249465008,
    "descripcion":"NECROSIS SUBGLÓTICA"
  },
  {
    "codigo":99571000119102,
    "descripcion":"PAPILOMA DE MAMA"
  },
  {
    "codigo":15690841000119108,
    "descripcion":"ARTRITIS ENTEROPÁTICA DE AMBAS ARTICULACIONES DE RODILLA"
  },
  {
    "codigo":51022005,
    "descripcion":"PROTOPORFIRIA ERITROPOYÉTICA"
  },
  {
    "codigo":247630005,
    "descripcion":"PRESIÓN DEL PENSAMIENTO"
  },
  {
    "codigo":737315000,
    "descripcion":"ENTEROCOLITIS ALÉRGICA CAUSADA POR PROTEÍNA ALIMENTARIA"
  },
  {
    "codigo":157851000146105,
    "descripcion":"TIENE UN HORARIO REGULAR PARA ACOSTARSE"
  },
  {
    "codigo":278563001,
    "descripcion":"CAÍDA DE PERNO MUÑÓN"
  },
  {
    "codigo":735480001,
    "descripcion":"PROLAPSO COMPLETO DE PARED POSTERIOR DE LA VAGINA"
  },
  {
    "codigo":211192002,
    "descripcion":"ABRASIÓN DE PIEL DE BRAZO"
  },
  {
    "codigo":276728004,
    "descripcion":"TUMOR MELANOCÍTICO CUTÁNEO"
  },
  {
    "codigo":1259768005,
    "descripcion":"CÁNCER PULMONAR DE CÉLULAS NO MICROCÍTICAS PRIMARIO NEGATIVO PARA EXPRESIÓN DEL RECEPTOR DE FACTOR DE CRECIMIENTO EPIDÉRMICO"
  },
  {
    "codigo":702712006,
    "descripcion":"CARCINOMA IN SITU DE CONDUCTO HEPÁTICO COMÚN"
  },
  {
    "codigo":1290701000,
    "descripcion":"HERIDA ABIERTA DE CUERO CABELLUDO CAUSADA POR FIJADOR CRANEAL MAYFIELD DURANTE PROCEDIMIENTO QUIRÚRGICO"
  },
  {
    "codigo":45517002,
    "descripcion":"LESIÓN LINFOEPITELIAL BENIGNA DE LA GLÁNDULA SALIVAL"
  },
  {
    "codigo":318861000119101,
    "descripcion":"ARTRITIS REUMATOIDE SEROPOSITIVA DE MANO IZQUIERDA"
  },
  {
    "codigo":405965005,
    "descripcion":"TUMOR RENAL CON INVASIÓN MACROSCÓPICA DE VENA RENAL"
  },
  {
    "codigo":209357009,
    "descripcion":"FRACTURA-LUXACIÓN NO EXPUESTA DE ARTICULACIÓN TARSOMETATARSIANA"
  },
  {
    "codigo":404130002,
    "descripcion":"LINFOMA CUTÁNEO PLEOMÓRFICO DE CÉLULAS T GRANDES, CD-30 NEGATIVO"
  },
  {
    "codigo":830114005,
    "descripcion":"SENSIBILIDAD PROFUNDA DISMINUIDA"
  },
  {
    "codigo":305826007,
    "descripcion":"VISTO POR EL SERVICIO DE REUMATOLOGÍA"
  },
  {
    "codigo":402295000,
    "descripcion":"ECCEMA POSTRAUMÁTICO"
  },
  {
    "codigo":74615001,
    "descripcion":"TAQUICARDIA - BRADICARDIA"
  },
  {
    "codigo":205687000,
    "descripcion":"CARIOTIPO 46, X CON CROMOSOMA SEXUAL ANORMAL EXCEPTO ISO (XQ)"
  },
  {
    "codigo":238455005,
    "descripcion":"DEDO DE FOCA"
  },
  {
    "codigo":369527008,
    "descripcion":"TUMOR MALIGNO QUE COMPROMETE EL OVARIO IZQUIERDO POR PROPAGACIÓN DIRECTA DESDE EL CUELLO UTERINO"
  },
  {
    "codigo":433228003,
    "descripcion":"DEFORMIDAD DE PIE DEBIDA A ARTRITIS REUMATOIDEA"
  },
  {
    "codigo":236620008,
    "descripcion":"CISTITIS INFECCIOSA"
  },
  {
    "codigo":365857001,
    "descripcion":"EXAMEN DEL NIÑO - HALLAZGO"
  },
  {
    "codigo":302156009,
    "descripcion":"ANQUILOSIS DE ARTICULACIÓN DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":1119521001,
    "descripcion":"DEBILIDAD MUSCULAR FATIGABLE AUMENTADA"
  },
  {
    "codigo":202017002,
    "descripcion":"ARTROPATÍA TRANSITORIA DE SEGUNDA A QUINTA ARTICULACIONES METATARSOFALÁNGICAS"
  },
  {
    "codigo":300321007,
    "descripcion":"ANO NORMAL"
  },
  {
    "codigo":298486001,
    "descripcion":"COLUMNA CERVICAL HELADA AL TACTO"
  },
  {
    "codigo":724470002,
    "descripcion":"ESTRECHEZ URETRAL DEBIDA A PROCEDIMIENTO Y POSTERIOR A ÉL"
  },
  {
    "codigo":16021031000119103,
    "descripcion":"BURSITIS GOTOSA BILATERAL DE OLÉCRANON"
  },
  {
    "codigo":198347000,
    "descripcion":"CICATRIZ POSPARTO DEL CUELLO UTERINO"
  },
  {
    "codigo":1739001,
    "descripcion":"FRACTURA DE HUESO OCCIPITAL"
  },
  {
    "codigo":1148619000,
    "descripcion":"MEMBRANA UTERINA RETENIDA SIN HEMORRAGIA"
  },
  {
    "codigo":296651003,
    "descripcion":"SOBREDOSIS DE AMPICILINA"
  },
  {
    "codigo":1279691004,
    "descripcion":"FIEBRE RECURRENTE CAUSADA POR BORRELIA PARKERI"
  },
  {
    "codigo":1345227001,
    "descripcion":"LACERACIÓN DE CLÍTORIS"
  },
  {
    "codigo":722635008,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE PARTE DE LA CABEZA"
  },
  {
    "codigo":20161000119100,
    "descripcion":"RUPTURA DE GLOBO OCULAR SIN PROLAPSO DE TEJIDO INTRAOCULAR"
  },
  {
    "codigo":294816007,
    "descripcion":"ALERGIA A NAFARELINA"
  },
  {
    "codigo":130976008,
    "descripcion":"REFLEJO EXTENSOR AUMENTADO"
  },
  {
    "codigo":11843111000119107,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE NARIZ"
  },
  {
    "codigo":63605003,
    "descripcion":"INFECCIÓN CAUSADA POR NAEGLERIA GRUBERI"
  },
  {
    "codigo":292981005,
    "descripcion":"EFECTO ADVERSO DE MECILINAM"
  },
  {
    "codigo":1144949006,
    "descripcion":"DISFUNCIÓN ERÉCTIL DEBIDA A TRASTORNO VENOSO"
  },
  {
    "codigo":94538001,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE COLON SIGMOIDE"
  },
  {
    "codigo":225610004,
    "descripcion":"RIGIDEZ DE LAS EXTREMIDADES"
  },
  {
    "codigo":782666006,
    "descripcion":"LIQUEN ESCLEROSO DE ANO"
  },
  {
    "codigo":127306006,
    "descripcion":"LACERACIÓN DE CEREBELO"
  },
  {
    "codigo":319061000119100,
    "descripcion":"ARTRITIS REUMATOIDEA SERONEGATIVA DE ARTICULACIÓN DE REGIÓN DEL HOMBRO IZQUIERDO"
  },
  {
    "codigo":59935001,
    "descripcion":"SOPLO CARDÍACO FUNCIONAL"
  },
  {
    "codigo":92703004,
    "descripcion":"CARCINOMA IN SITU DEL LÓBULO SUPERIOR DERECHO DEL PULMÓN"
  },
  {
    "codigo":289311005,
    "descripcion":"CIRCULAR DE CORDÓN UMBILICAL ALREDEDOR DEL CUELLO, CON COMPRESIÓN"
  },
  {
    "codigo":1010207009,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE EXTREMIDAD SUPERIOR DERECHA"
  },
  {
    "codigo":254708001,
    "descripcion":"POROCARCINOMA ECRINO"
  },
  {
    "codigo":1336052004,
    "descripcion":"EPISODIO DE USO NOCIVO DE DIAMORFINA"
  },
  {
    "codigo":56265001,
    "descripcion":"CARDIOPATÍA"
  },
  {
    "codigo":713460009,
    "descripcion":"NEGACIÓN DE LA SEVERIDAD DE LA ENFERMEDAD"
  },
  {
    "codigo":416713004,
    "descripcion":"HERIDA EPITELIAL DE LA CÓRNEA"
  },
  {
    "codigo":1137609006,
    "descripcion":"LÍNEA DE IMPLANTACIÓN ANTERIOR DE CABELLO BAJA"
  },
  {
    "codigo":251038002,
    "descripcion":"ANOMALÍA CONGÉNITA DE LA RAÍZ AÓRTICA"
  },
  {
    "codigo":1332382002,
    "descripcion":"SÍNDROME DE COLOBOMA, OSTEOPETROSIS, MICROFTALMÍA, MACROCEFALIA, ALBINISMO Y SORDERA"
  },
  {
    "codigo":414878005,
    "descripcion":"PRUEBA NORMAL SERUM, HALLAZGO"
  },
  {
    "codigo":283806005,
    "descripcion":"MORDEDURA DE ANIMAL EN EL CODO"
  },
  {
    "codigo":773491000,
    "descripcion":"ALERGIA AL ÁCIDO PAMIDRÓNICO"
  },
  {
    "codigo":249203001,
    "descripcion":"PÉRDIDA DE LA MASA FÚNDICA LUEGO DEL PARTO"
  },
  {
    "codigo":183667003,
    "descripcion":"ALTA DE INTERNACIÓN"
  },
  {
    "codigo":85363005,
    "descripcion":"QUERATINIZACIÓN AUMENTADA"
  },
  {
    "codigo":280136002,
    "descripcion":"TRASTORNO DE PARTES BLANDAS DE MIEMBRO INFERIOR"
  },
  {
    "codigo":247368002,
    "descripcion":"LUMBALGIA DEL COMPARTIMIENTO POSTERIOR"
  },
  {
    "codigo":1197640002,
    "descripcion":"EQUIPAMIENTO INADECUADO PARA DETECCIÓN DE HUMO EN LA VIVIENDA"
  },
  {
    "codigo":214600002,
    "descripcion":"GRANULOMA DE MAJOCCHI"
  },
  {
    "codigo":704285000,
    "descripcion":"FRACTURA POR OSTEOPOROSIS SECUNDARIA DE RADIO"
  },
  {
    "codigo":312904009,
    "descripcion":"RETINOPATÍA NO PROLIFERATIVA MODERADA DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":655081461000119101,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DEBIDO A OCLUSIÓN DE ARTERIA CEREBRAL ANTERIOR DERECHA"
  },
  {
    "codigo":276466000,
    "descripcion":"QUEMADURA EN BLANCO DE TIRO"
  },
  {
    "codigo":79858001,
    "descripcion":"FRACTURA EXPUESTA DE DIÁFISIS DE HUESO DE ANTEBRAZO"
  },
  {
    "codigo":440306002,
    "descripcion":"MÚLTIPLES HERIDAS SUPERFICIALES INFECTADAS"
  },
  {
    "codigo":702450004,
    "descripcion":"SÍNDROME FOXG1"
  },
  {
    "codigo":372935001,
    "descripcion":"INFECCIÓN CAUSADA POR PENICILLIUM"
  },
  {
    "codigo":307399003,
    "descripcion":"INJERTO ILIOPOPLÍTEO INFECTADO"
  },
  {
    "codigo":897223004,
    "descripcion":"CURVATURA ANORMAL DE FALANGE DE QUINTO DEDO DE PIE"
  },
  {
    "codigo":241863006,
    "descripcion":"EFECTO TÓXICO CAUSADO POR EFECTO TÓXICO"
  },
  {
    "codigo":405703008,
    "descripcion":"LESIÓN TRAUMÁTICA PROVOCADA POR SUJECIÓN LEGAL CON LAS MANOS"
  },
  {
    "codigo":1290439009,
    "descripcion":"SÍNDROME DE CORDÓN CENTRAL DE MÉDULA CERVICAL DEBIDO A FRACTURA NO EXPUESTA A NIVEL C5-C7"
  },
  {
    "codigo":371100002,
    "descripcion":"LESIÓN POR EXTRAVASACIÓN"
  },
  {
    "codigo":698780001,
    "descripcion":"QUEMADURA DE CÓRNEA Y SACO CONJUNTIVAL"
  },
  {
    "codigo":305564002,
    "descripcion":"BAJO ATENCIÓN DE ENFERMERA EN EL ÁREA DE ONCOLOGÍA (MARIE CURIE)"
  },
  {
    "codigo":43420005,
    "descripcion":"SÍNDROME DE MONOSOMÍA PARCIAL 9Q"
  },
  {
    "codigo":240028007,
    "descripcion":"ENTESOPATÍA DE LA REGIÓN DEL PIE"
  },
  {
    "codigo":403868009,
    "descripcion":"PAPILOMAS BASOCELULARES ERUPTIVOS"
  },
  {
    "codigo":762481002,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL SUPERFICIAL DE CADERA"
  },
  {
    "codigo":205425003,
    "descripcion":"AGENESIA SACRA"
  },
  {
    "codigo":215688003,
    "descripcion":"LESIÓN EN MEDIO DE TRANSPORTE ACUÁTICO PRODUCIDO POR MAQUINARIA DE CUBIERTA, OCUPANTE DE EMBARCACIÓN PEQUEÑA NO MOTORIZADA LESIONADO"
  },
  {
    "codigo":1155697006,
    "descripcion":"EMBOLIA DE ARTERIA VERTEBRAL IZQUIERDA"
  },
  {
    "codigo":170822000,
    "descripcion":"INYECCIONES DE VITAMINA B12 - EN EL HOGAR"
  },
  {
    "codigo":41585009,
    "descripcion":"ESTRANGULACIÓN DE COLON"
  },
  {
    "codigo":203590003,
    "descripcion":"DEFORMIDAD ADQUIRIDA DEL ANTEPIÉ EN EVERSIÓN"
  },
  {
    "codigo":269126005,
    "descripcion":"LUXACIÓN EXPUESTA ENTRE LA CUARTA Y LA QUINTA VÉRTEBRAS CERVICALES"
  },
  {
    "codigo":1186630006,
    "descripcion":"HEPATOCARCINOMA PRIMARIO"
  },
  {
    "codigo":365595004,
    "descripcion":"VIRUS: SEROLOGÍA - HALLAZGO"
  },
  {
    "codigo":70683005,
    "descripcion":"INFECCIÓN CAUSADA POR CRYPTOSPORIDIUM NASORUM"
  },
  {
    "codigo":267291006,
    "descripcion":"PEZÓN AGRIETADO EN EL EMBARAZO, EL PUERPERIO O LACTANCIA"
  },
  {
    "codigo":298224003,
    "descripcion":"MOVIMIENTO ARTICULAR, AUSENTE"
  },
  {
    "codigo":396528005,
    "descripcion":"COMPROMISO TUMORAL DE MARGEN DE RESECCIÓN QUIRÚRGICA: INDETERMINADO"
  },
  {
    "codigo":724208006,
    "descripcion":"SÍNDROME DE KEUTEL"
  },
  {
    "codigo":10809641000119100,
    "descripcion":"TRASTORNO DE VÁLVULA MITRAL EN LA MADRE QUE COMPLICA EL NACIMIENTO"
  },
  {
    "codigo":427461000,
    "descripcion":"CASI SÍNCOPE"
  },
  {
    "codigo":296389000,
    "descripcion":"SOBREDOSIS DE CLONIDINA"
  },
  {
    "codigo":294554001,
    "descripcion":"ALERGIA A CEFSULODINA"
  },
  {
    "codigo":229018003,
    "descripcion":"PENETRACIÓN ANAL CON EL PENE"
  },
  {
    "codigo":65178004,
    "descripcion":"PELVIS DE DEVENTER"
  },
  {
    "codigo":1144687000,
    "descripcion":"APLASIA DE FALANGE DE QUINTO DEDO DE PIE"
  },
  {
    "codigo":817007001,
    "descripcion":"EL OJO NO SE MUEVE HACIA ARRIBA"
  },
  {
    "codigo":30575002,
    "descripcion":"ANEMIA DE FANCONI"
  },
  {
    "codigo":194415001,
    "descripcion":"PÉRDIDA DE LA AUDICIÓN CONDUCTIVA DEBIDA A TRASTORNO DEL OÍDO MEDIO"
  },
  {
    "codigo":32410009,
    "descripcion":"PEDERASTIA"
  },
  {
    "codigo":1306692000,
    "descripcion":"PATRÓN DE USO NOCIVO DE SUSTANCIA"
  },
  {
    "codigo":292719009,
    "descripcion":"REACCIÓN ADVERSA A LA PROSTAGLANDINA, SERIE I"
  },
  {
    "codigo":716868003,
    "descripcion":"ESPECTRO DE OSTEÓLISIS MULTICÉNTRICA-NODULOSIS-ARTROPATÍA"
  },
  {
    "codigo":421956004,
    "descripcion":"SEMILLAS VÍTREAS"
  },
  {
    "codigo":290884007,
    "descripcion":"INTOXICACIÓN POR VENLAFAXINA"
  },
  {
    "codigo":258116008,
    "descripcion":"BALBUCEO"
  },
  {
    "codigo":28740008,
    "descripcion":"TRIGONOCEFALIA"
  },
  {
    "codigo":127044007,
    "descripcion":"TALASEMIA - DELTA BETA^0^ DE CÉLULAS DREPANOCÍTICAS"
  },
  {
    "codigo":289049004,
    "descripcion":"INCAPAZ DE UTILIZAR CUCHILLO Y TENEDOR PARA ALIMENTARSE"
  },
  {
    "codigo":420121005,
    "descripcion":"PARACOCCIDIOIDOMICOSIS BUCAL"
  },
  {
    "codigo":190745006,
    "descripcion":"GALACTOSEMIA"
  },
  {
    "codigo":92441007,
    "descripcion":"NEOPLASIA BENIGNA DE GANGLIOS LINFÁTICOS TIBIALES"
  },
  {
    "codigo":715033009,
    "descripcion":"CAPAZ DE TOMAR MEDICACIÓN"
  },
  {
    "codigo":2161000221108,
    "descripcion":"ENFERMEDAD DE CHAGAS AGUDA POR OTRAS VÍAS DE TRANSMISIÓN"
  },
  {
    "codigo":57838006,
    "descripcion":"SÍNDROME DE RETINITIS PIGMENTARIA - SORDERA"
  },
  {
    "codigo":254446007,
    "descripcion":"CARCINOMA IN SITU DEL SURCO BUCAL INFERIOR"
  },
  {
    "codigo":1237486008,
    "descripcion":"PALIDEZ CORPORAL GENERALIZADA ANORMAL"
  },
  {
    "codigo":418286009,
    "descripcion":"DESARROLLO ANORMAL DE LAS CARACTERÍSTICAS SEXUALES SECUNDARIAS FEMENINAS"
  },
  {
    "codigo":1335790009,
    "descripcion":"ARTRITIS IDIOPÁTICA JUVENIL DE CODO DERECHO"
  },
  {
    "codigo":449219006,
    "descripcion":"LINFOMA NO HODGKIN FOLICULAR DE NASOFARINGE"
  },
  {
    "codigo":185240002,
    "descripcion":"ATENDIDO EN CONSULTORIO ESPECIALIZADO EN PATOLOGÍA DEL TÓRAX"
  },
  {
    "codigo":840600006,
    "descripcion":"LACTANTE HIPOACTIVO"
  },
  {
    "codigo":283544009,
    "descripcion":"HERIDA PUNZANTE DE TALÓN"
  },
  {
    "codigo":52333004,
    "descripcion":"NEUMOPATÍA DE LOS RECOLECTORES DE HONGOS"
  },
  {
    "codigo":248941007,
    "descripcion":"HALLAZGO RELACIONADO CON EL CUERPO DEL ÚTERO"
  },
  {
    "codigo":609389009,
    "descripcion":"ALTO RIESGO DE INSUFICIENCIA CARDÍACA, ESTADIO B"
  },
  {
    "codigo":247106007,
    "descripcion":"RETINITIS CASEOSA"
  },
  {
    "codigo":704023002,
    "descripcion":"FRACTURA NO EXPUESTA DE DIÁFISIS DE SEGUNDO METACARPIANO"
  },
  {
    "codigo":278039004,
    "descripcion":"HISTOPLASMOSIS CUTÁNEA AFRICANA"
  },
  {
    "codigo":441879005,
    "descripcion":"SIN CONTACTO CON LA FAMILIA"
  },
  {
    "codigo":212503009,
    "descripcion":"INTOXICACIÓN POR ERITROMICINA"
  },
  {
    "codigo":472812002,
    "descripcion":"HEMÓLISIS MECÁNICA DEBIDA A PARCHE PROTÉSICO CARDIOVASCULAR"
  },
  {
    "codigo":1259244001,
    "descripcion":"ESTENOSIS DE URETRA PROSTÁTICA"
  },
  {
    "codigo":1090141000119106,
    "descripcion":"EDENTULISMO PARCIAL CLASE IV DEBIDO A ENFERMEDAD PERIODONTAL"
  },
  {
    "codigo":77761000,
    "descripcion":"AUSENCIA CONGÉNITA DE URÉTER"
  },
  {
    "codigo":44993000,
    "descripcion":"ESTENOSIS REUMÁTICA DE VÁLVULAS MITRAL Y AÓRTICA"
  },
  {
    "codigo":700353006,
    "descripcion":"TRASTORNO DE TENDÓN DE FLEXOR LARGO DEL DEDO GORDO"
  },
  {
    "codigo":307137009,
    "descripcion":"FRACTURA VERTEBRAL ANTERIOR EN CUÑA"
  },
  {
    "codigo":698518004,
    "descripcion":"ABRASIÓN DE DIENTE QUE SE EXTIENDE HASTA LA DENTINA"
  },
  {
    "codigo":272534006,
    "descripcion":"PARADO EN EL AGUA"
  },
  {
    "codigo":403606008,
    "descripcion":"ERITEMA URTICARIANO TÓXICO CAUSADO POR FÁRMACO"
  },
  {
    "codigo":8555001,
    "descripcion":"SÍFILIS DEL PULMÓN"
  },
  {
    "codigo":205163001,
    "descripcion":"DEFICIENCIA TRANSVERSAL DEL BRAZO, NIVEL HUMERAL - CORTA"
  },
  {
    "codigo":29891000175105,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN EN TALÓN IZQUIERDO"
  },
  {
    "codigo":303467009,
    "descripcion":"INCAPAZ DE COLOCARSE PRÓTESIS"
  },
  {
    "codigo":203328003,
    "descripcion":"ENFERMEDAD DE PAGET DE LA COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":268864004,
    "descripcion":"TUVO UN NUDO DE CORDÓN UMBILICAL"
  },
  {
    "codigo":170560003,
    "descripcion":"BUEN CONTROL DE ENFERMEDAD CRÓNICA"
  },
  {
    "codigo":301632006,
    "descripcion":"INCAPAZ DE UTILIZAR ESCALERA MECÁNICA"
  },
  {
    "codigo":236096007,
    "descripcion":"HEMORRAGIA DE ANASTOMOSIS DE INTESTINO DELGADO"
  },
  {
    "codigo":237931009,
    "descripcion":"ACIDEMIA 2-QUETOADÍPICA"
  },
  {
    "codigo":299797006,
    "descripcion":"REFLEJO DE GALANT DE RESULTADO DUDOSO"
  },
  {
    "codigo":1217301006,
    "descripcion":"LINFOMA LINFOBLÁSTICO DE CÉLULAS PRECURSORAS"
  },
  {
    "codigo":365333008,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA LIMPIAR EL INODORO"
  },
  {
    "codigo":363498002,
    "descripcion":"NEOPLASIA MALIGNA DE NERVIO ÓPTICO"
  },
  {
    "codigo":297962005,
    "descripcion":"MARCA DE ZAPATO"
  },
  {
    "codigo":166890005,
    "descripcion":"GLUCEMIA MEDIDA AL AZAR DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":232426008,
    "descripcion":"LARINGITIS SIMPLE AGUDA"
  },
  {
    "codigo":396266009,
    "descripcion":"MARGEN QUIRÚRGICO COMPROMETIDO POR NEOPLASIA INTRAEPITELIAL"
  },
  {
    "codigo":230591002,
    "descripcion":"NEUROPATÍA MOTORA CON BLOQUEO DE CONDUCCIÓN MÚLTIPLE"
  },
  {
    "codigo":427199002,
    "descripcion":"MALFORMACIÓN ARTERIOVENOSA CONGÉNITA DE INTESTINO DELGADO"
  },
  {
    "codigo":33983003,
    "descripcion":"SEDIMENTO BLANDO SOBRE LOS DIENTES"
  },
  {
    "codigo":197823001,
    "descripcion":"MEGALOURÉTER - ADQUIRIDO"
  },
  {
    "codigo":66751000,
    "descripcion":"ENFERMEDAD DE NIEMANN - PICK, TIPO C"
  },
  {
    "codigo":1179028000,
    "descripcion":"AVULSIÓN DE NERVIO ALVEOLAR INFERIOR DEBIDA A OSTEOTOMÍA"
  },
  {
    "codigo":15700881000119107,
    "descripcion":"DISFUNCIÓN DE MÚSCULO OBLICUO INFERIOR DE AMBOS OJOS"
  },
  {
    "codigo":1144425003,
    "descripcion":"ATROFIA DE MÉDULA ESPINAL CERVICAL"
  },
  {
    "codigo":292457005,
    "descripcion":"REACCIÓN ADVERSA AL FELODIPINO"
  },
  {
    "codigo":63081009,
    "descripcion":"INFARTO AGUDO DE MÉDULA ESPINAL"
  },
  {
    "codigo":126782004,
    "descripcion":"NEOPLASIA DE BORDE LATERAL DE LENGUA"
  },
  {
    "codigo":290622006,
    "descripcion":"INTOXICACIÓN POR NITROSOUREA"
  },
  {
    "codigo":94014008,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA PIEL DE LA MEJILLA"
  },
  {
    "codigo":41471000087102,
    "descripcion":"HEMATOMA DE EXTREMIDAD INFERIOR IZQUIERDA"
  },
  {
    "codigo":188648000,
    "descripcion":"RETICULOENDOTELIOSIS LEUCÉMICA DE GANGLIOS LINFÁTICOS DE AXILA Y EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":33791000087105,
    "descripcion":"SE IDENTIFICA COMO GÉNERO NO BINARIO"
  },
  {
    "codigo":46591000087106,
    "descripcion":"ESGUINCE DE LIGAMENTO DE ARTICULACIÓN TIBIOPERONEA PROXIMAL DERECHA"
  },
  {
    "codigo":92179009,
    "descripcion":"NEOPLASIA BENIGNA DE LA PARED LATERAL DE LA VEJIGA"
  },
  {
    "codigo":254557000,
    "descripcion":"CARCINOMA DEL CUERPO DEL ESTÓMAGO"
  },
  {
    "codigo":44031000087108,
    "descripcion":"HERIDA CORTANTE DE PIEL DE PALMA DE MANO DERECHA"
  },
  {
    "codigo":57576007,
    "descripcion":"ÚTERO GRÁVIDO RETROVERTIDO"
  },
  {
    "codigo":416189003,
    "descripcion":"EXOSTOSIS"
  },
  {
    "codigo":22973003,
    "descripcion":"FRACTURA NO EXPUESTA DE COLUMNA VERTEBRAL CON LESIÓN TRAUMÁTICA DE LA MÉDULA ESPINAL"
  },
  {
    "codigo":186813004,
    "descripcion":"ENFERMEDAD DE CHAGAS AGUDA CON COMPROMISO CARDÍACO"
  },
  {
    "codigo":283282000,
    "descripcion":"ASTILLA DE MADERA EN EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":53906001,
    "descripcion":"ENFERMEDAD POR EL VIRUS AINO"
  },
  {
    "codigo":840338002,
    "descripcion":"RUPTURA DE TENDÓN EXTENSOR DE MANO"
  },
  {
    "codigo":1004178009,
    "descripcion":"NIVEL DE ÁCIDO ORGÁNICO COMPLEJO AUMENTADO EN ORINA"
  },
  {
    "codigo":248679004,
    "descripcion":"SOPLO MITRAL HOLOSISTÓLICO"
  },
  {
    "codigo":707431006,
    "descripcion":"HISTIOCITOSIS DE CÉLULAS DE LANGERHANS DE LA ZONA DEL PAÑAL"
  },
  {
    "codigo":50236000,
    "descripcion":"PERMEABILIDAD VASCULAR DISMINUIDA"
  },
  {
    "codigo":19303008,
    "descripcion":"MIOPATÍA POR ALCOHOL"
  },
  {
    "codigo":1295420001,
    "descripcion":"PRESENCIA POSOPERATORIA INTENCIONADA DE NEOPLASIA RESIDUAL POSTERIOR A RESECCIÓN DE NEOPLASIA"
  },
  {
    "codigo":281447008,
    "descripcion":"AFLOJAMIENTO DE TALLO FEMORAL DE REEMPLAZO TOTAL DE CADERA"
  },
  {
    "codigo":312380005,
    "descripcion":"EMBOLIA DE ARTERIA DE MIEMBRO INFERIOR CONSECUTIVA A PROCEDIMIENTO RADIOLÓGICO"
  },
  {
    "codigo":246844006,
    "descripcion":"SECRECIÓN SEROSA INTERMARGINAL"
  },
  {
    "codigo":15633004,
    "descripcion":"EDAD GESTACIONAL, 16 SEMANAS"
  },
  {
    "codigo":766561000000109,
    "descripcion":"MOTIVO DE PREOCUPACIÓN ACERCA DE LA PROTECCIÓN DEL ADULTO"
  },
  {
    "codigo":408849009,
    "descripcion":"RETINOPATÍA POR PREMATUREZ, ETAPA 3 - CRESTA CON PROLIFERACIÓN FIBROVASCULAR EXTRARRETINIANA"
  },
  {
    "codigo":13798002,
    "descripcion":"EDAD GESTACIONAL, 38 SEMANAS"
  },
  {
    "codigo":112102006,
    "descripcion":"NEURALGIA ATÍPICA"
  },
  {
    "codigo":275942009,
    "descripcion":"NUEVA MEDICACIÓN AGREGADA"
  },
  {
    "codigo":110267003,
    "descripcion":"ESTOMATITIS ESTREPTOCÓCICA"
  },
  {
    "codigo":863931005,
    "descripcion":"BILIRRUBINA DIRECTA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":10128002,
    "descripcion":"CONJUNTIVITIS ROSÁCEA"
  },
  {
    "codigo":403344005,
    "descripcion":"LESIÓN DEL TALLO DEL PELO POR DESCOLORACIÓN"
  },
  {
    "codigo":237669001,
    "descripcion":"HIPERSECRECIÓN DE ACTH"
  },
  {
    "codigo":763792009,
    "descripcion":"LEUCONIQUIA TOTAL"
  },
  {
    "codigo":1351781002,
    "descripcion":"INMUNODEFICIENCIA COMBINADA AUTOSÓMICA RECESIVA DEBIDA A MUTACIÓN DE BCL10"
  },
  {
    "codigo":761957004,
    "descripcion":"BURSITIS ESCAPULOTORÁCICA"
  },
  {
    "codigo":41061006,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN TARSOMETATARSIANA"
  },
  {
    "codigo":71994000,
    "descripcion":"PROBLEMA, EXAMEN ANORMAL"
  },
  {
    "codigo":235834001,
    "descripcion":"ÍLEO PRODUCIDO POR INFECCIÓN"
  },
  {
    "codigo":301370002,
    "descripcion":"HALLAZGO RELACIONADO CON LA DIMENSIÓN SENSORIAL DEL DOLOR"
  },
  {
    "codigo":1153338005,
    "descripcion":"OSTEONECROSIS DE HUESO CAUSADA POR ALCOHOL"
  },
  {
    "codigo":792890006,
    "descripcion":"TUMORACIÓN DE COLA MAMARIA AXILAR"
  },
  {
    "codigo":203066009,
    "descripcion":"CONTRACTURA DEL MÚSCULO FLEXOR SUPERFICIAL DE LOS DEDOS DE LA MANO"
  },
  {
    "codigo":299535004,
    "descripcion":"AMPLITUD DE INVERSIÓN ACTIVA NORMAL DE ARTICULACIÓN SUBASTRAGALINA"
  },
  {
    "codigo":365071005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA HABLAR MIENTRAS JUEGA"
  },
  {
    "codigo":397839006,
    "descripcion":"MAL FUNCIONAMIENTO DEL EQUIPAMIENTO"
  },
  {
    "codigo":233999007,
    "descripcion":"DISECCIÓN DE ARTERIA ILÍACA"
  },
  {
    "codigo":102927007,
    "descripcion":"NICTOFOBIA"
  },
  {
    "codigo":363236004,
    "descripcion":"TRASTORNO DE DESARROLLO NEUROLÓGICO DE FETO"
  },
  {
    "codigo":428772007,
    "descripcion":"COMPLICACIÓN DE CIRUGÍA DE IMPLANTE MAMARIO"
  },
  {
    "codigo":789220007,
    "descripcion":"ATROFIA DE MÁCULA LÚTEA"
  },
  {
    "codigo":263097002,
    "descripcion":"FRACTURA-SUBLUXACIÓN DE LA ARTICULACIÓN ESTERNOCLAVICULAR"
  },
  {
    "codigo":721849004,
    "descripcion":"HALLAZGO DE MOHO DEMATIÁCEO NO ESPORULADO"
  },
  {
    "codigo":295865007,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE IMIPRAMINA"
  },
  {
    "codigo":195726000,
    "descripcion":"BRONQUITIS AGUDA POR VIRUS DE LA PARAINFLUENZA"
  },
  {
    "codigo":787385009,
    "descripcion":"METABOLIZADOR RÁPIDO DE LA FAMILIA 3 SUBFAMILIA A MIEMBRO 4 DEL CITOCROMO P450"
  },
  {
    "codigo":66489009,
    "descripcion":"AUSENCIA CONGÉNITA DEL PULMÓN"
  },
  {
    "codigo":230329009,
    "descripcion":"DISTONÍA POSHEMIPLÉJICA"
  },
  {
    "codigo":294030003,
    "descripcion":"ALERGIA A FENILEFRINA"
  },
  {
    "codigo":64654004,
    "descripcion":"HIPERGLICINEMIA"
  },
  {
    "codigo":228494002,
    "descripcion":"CONSUMIDOR DE RAPÉ"
  },
  {
    "codigo":718179003,
    "descripcion":"DISTROFIA MUSCULAR DE LAS CINTURAS DE LAS EXTREMIDADES TIPO 2B AUTOSÓMICA RECESIVA"
  },
  {
    "codigo":292195007,
    "descripcion":"REACCIÓN ADVERSA AL LEVAMISOL"
  },
  {
    "codigo":1142328001,
    "descripcion":"ATROFIA DE MÚSCULO RECTO ANTERIOR"
  },
  {
    "codigo":62819009,
    "descripcion":"CERVICITIS TUBERCULOSA"
  },
  {
    "codigo":95587009,
    "descripcion":"FIBROSIS DE LA VEJIGA"
  },
  {
    "codigo":192056005,
    "descripcion":"REACCIÓN DE ADAPTACIÓN CON AGRESIÓN"
  },
  {
    "codigo":2391000124102,
    "descripcion":"TERCER MOLAR INFERIOR IZQUIERDO PERMANENTE SUPERNUMERARIO"
  },
  {
    "codigo":126520007,
    "descripcion":"NEOPLASIA DE LA PIEL DEL ANTEBRAZO"
  },
  {
    "codigo":91917000,
    "descripcion":"AUSENCIA CONGÉNITA DE LA VÉRTEBRA DORSAL"
  },
  {
    "codigo":3731000119107,
    "descripcion":"HIPERSOMNIA IDIOPÁTICA"
  },
  {
    "codigo":712674002,
    "descripcion":"ENTEROBACTERIACEAE RESISTENTES A CARBAPENEM NO AISLADAS"
  },
  {
    "codigo":1204194004,
    "descripcion":"MIOCARDIOPATÍA HIPERTRÓFICA DE ÁPEX CARDÍACO"
  },
  {
    "codigo":1236962007,
    "descripcion":"METÁSTASIS DE CARCINOMA DE PORCIÓN LATERAL DE PISO DE BOCA"
  },
  {
    "codigo":22711000,
    "descripcion":"ADHERENCIA DE CONDUCTO CÍSTICO"
  },
  {
    "codigo":55479002,
    "descripcion":"CÁLCULO BILIAR DE VESÍCULA IMPACTADO"
  },
  {
    "codigo":219319004,
    "descripcion":"LESIÓN INDETERMINADA RESPECTO DE SU POSIBLE CAUSA ACCIDENTAL O INTENCIONAL, INTOXICACIÓN POR GAS DISTRIBUIDO POR TUBERÍA"
  },
  {
    "codigo":284855005,
    "descripcion":"DIFICULTAD PARA SONARSE LA NARIZ"
  },
  {
    "codigo":250252000,
    "descripcion":"MICROESFEROCITOS OBSERVADOS"
  },
  {
    "codigo":20876004,
    "descripcion":"TRASTORNO DE ANSIEDAD INDUCIDO POR INHALANTES"
  },
  {
    "codigo":53644008,
    "descripcion":"COPROFAGIA"
  },
  {
    "codigo":1003916008,
    "descripcion":"SÍNDROME DE PFEIFFER TIPO 2"
  },
  {
    "codigo":15951661000119107,
    "descripcion":"NEVO DISPLÁSICO DE PIEL DE AMBAS EXTREMIDADES SUPERIORES"
  },
  {
    "codigo":248417003,
    "descripcion":"EXTREMIDADES ROJAS"
  },
  {
    "codigo":1264225007,
    "descripcion":"INFECCIÓN FETAL CAUSADA POR STAPHYLOCOCCUS AUREUS"
  },
  {
    "codigo":1196854000,
    "descripcion":"CARCINOSARCOMA PRIMARIO DE HÍGADO"
  },
  {
    "codigo":182881009,
    "descripcion":"PACIENTE QUE SE AUTOMEDICA"
  },
  {
    "codigo":312118003,
    "descripcion":"INFECCIÓN BACTERIANA DE LA VÍA RESPIRATORIA SUPERIOR"
  },
  {
    "codigo":17206008,
    "descripcion":"FÍSTULA GASTRODUODENAL"
  },
  {
    "codigo":80907003,
    "descripcion":"CONTUSIÓN DE LA REGIÓN ESCAPULAR"
  },
  {
    "codigo":211979004,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO PROFUNDA DE MUSLO"
  },
  {
    "codigo":110005000,
    "descripcion":"LEUCEMIA MIELOMONOCÍTICA AGUDA, FAB M4"
  },
  {
    "codigo":898272009,
    "descripcion":"ANQUILOSIS CONGÉNITA DE ARTICULACIÓN INTERFALÁNGICA PROXIMAL DE QUINTO DEDO DE PIE"
  },
  {
    "codigo":763530000,
    "descripcion":"SÍNDROME DE MONOSOMÍA 9P DISTAL"
  },
  {
    "codigo":11701009,
    "descripcion":"HEMICEFALIA"
  },
  {
    "codigo":208309008,
    "descripcion":"FRACTURA NO EXPUESTA DE RADIO Y CÚBITO, CENTRAL"
  },
  {
    "codigo":1156746003,
    "descripcion":"TROMBOCITOPENIA INMUNITARIA PROTROMBÓTICA INDUCIDA POR VACUNA"
  },
  {
    "codigo":16007111000119109,
    "descripcion":"ARTRITIS GOTOSA DE AMBAS MANOS"
  },
  {
    "codigo":9866007,
    "descripcion":"INFECCIÓN CAUSADA POR TRICHURIS VULPIS"
  },
  {
    "codigo":403082008,
    "descripcion":"TIÑA CAUSADA POR MICROSPORUM VANBREUSEGHEMII"
  },
  {
    "codigo":40799003,
    "descripcion":"BURSITIS SUBACROMIAL"
  },
  {
    "codigo":302943003,
    "descripcion":"NÚMERO ANORMAL DE CÚSPIDES DE VÁLVULA PULMONAR"
  },
  {
    "codigo":401247006,
    "descripcion":"ESTADO DE CONTROL DE CARDIOPATÍA CORONARIA"
  },
  {
    "codigo":301108000,
    "descripcion":"VÁLVULA TRICÚSPIDE - HALLAZGO"
  },
  {
    "codigo":1251380002,
    "descripcion":"EXACERBACIÓN DE DERMATITIS ATÓPICA DEBIDA A EXPOSICIÓN OCUPACIONAL A ALÉRGENO DE CONTACTO"
  },
  {
    "codigo":399412004,
    "descripcion":"HALLAZGO QUE MANIFIESTA INVASIÓN TUMORAL DE LA ESCLERÓTICA"
  },
  {
    "codigo":168201002,
    "descripcion":"BACTERIAS SENSIBLES EN ESPÉCIMEN"
  },
  {
    "codigo":200969003,
    "descripcion":"PSORIASIS RUPIOIDE"
  },
  {
    "codigo":233737004,
    "descripcion":"MEDIASTINITIS FIBROSA FAMILIAR"
  },
  {
    "codigo":364809004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA PRENDERSE AL PECHO PARA MAMAR"
  },
  {
    "codigo":231902000,
    "descripcion":"QUERATOCONJUNTIVITIS EPITELIAL DENDRIFORME"
  },
  {
    "codigo":1149406003,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE PROTAMINA"
  },
  {
    "codigo":2526004,
    "descripcion":"TRASTORNO NO INFLAMATORIO DE LOS ÓRGANOS GENITALES FEMENINOS"
  },
  {
    "codigo":788958007,
    "descripcion":"TRASTORNO DEL CONTROL DE LOS IMPULSOS CAUSADO POR CATINONA SINTÉTICA"
  },
  {
    "codigo":262835000,
    "descripcion":"SECCIÓN DE GLÁNDULA SUPRARRENAL"
  },
  {
    "codigo":295603000,
    "descripcion":"SOBREDOSIS DE BUSULFANO"
  },
  {
    "codigo":721587003,
    "descripcion":"INFECCIÓN DE TRANSMISIÓN SEXUAL CAUSADA POR PAPILOMAVIRUS HUMANO"
  },
  {
    "codigo":15739801000119100,
    "descripcion":"EXCAVACIÓN DE PAPILA ÓPTICA IZQUIERDA DEBIDA A GLAUCOMA DE ÁNGULO ABIERTO DE OJO IZQUIERDO"
  },
  {
    "codigo":12199321000119100,
    "descripcion":"INFECCIÓN ASOCIADA CON PRÓTESIS ARTICULAR DE REGIÓN DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":15747481000119100,
    "descripcion":"MASA DE PARTES BLANDAS DE EXTREMIDAD SUPERIOR IZQUIERDA"
  },
  {
    "codigo":66227006,
    "descripcion":"CONDUCTA COMPLEMENTARIA"
  },
  {
    "codigo":341401000119104,
    "descripcion":"EDEMA CONJUNTIVAL DE OJO IZQUIERDO"
  },
  {
    "codigo":15698841000119105,
    "descripcion":"ÚLCERA DE CÓRNEA DERECHA CAUSADA POR ACANTHAMOEBA"
  },
  {
    "codigo":15703961000119101,
    "descripcion":"CONTRACTURA DE MÚSCULO GEMELO IZQUIERDO DEBIDA A PARÁLISIS"
  },
  {
    "codigo":1076121000119107,
    "descripcion":"ADHERENCIA DE TENDÓN DE MANO IZQUIERDA"
  },
  {
    "codigo":315801000119108,
    "descripcion":"OSTEONECROSIS DE HUESO DE MANDÍBULA CAUSADA POR FÁRMACO"
  },
  {
    "codigo":15634841000119109,
    "descripcion":"PARESTESIA DE EXTREMIDAD INFERIOR IZQUIERDA"
  },
  {
    "codigo":323481000119109,
    "descripcion":"DEFORMIDAD EN VARO ADQUIRIDA DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":1342344007,
    "descripcion":"PLEXOPATÍA LUMBOSACRA DEBIDA A RADIOTERAPIA Y POSTERIOR A ELLA"
  },
  {
    "codigo":95325000,
    "descripcion":"NÓDULO SUBCUTÁNEO"
  },
  {
    "codigo":128093000,
    "descripcion":"TROMBOCITOPENIA ALOINMUNITARIA"
  },
  {
    "codigo":62557001,
    "descripcion":"LEIOMIOMATOSIS PERITONEAL DISEMINADA"
  },
  {
    "codigo":293768002,
    "descripcion":"ALERGIA A IDARUBICINA"
  },
  {
    "codigo":290201000119107,
    "descripcion":"LESIÓN DE NERVIO CIÁTICO IZQUIERDO"
  },
  {
    "codigo":11823001000119108,
    "descripcion":"AMPOLLA DE BRAZO DERECHO CON INFECCIÓN"
  },
  {
    "codigo":291933000,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR ÁCIDO FÓLICO"
  },
  {
    "codigo":717917007,
    "descripcion":"TUMOR NEUROENDOCRINO DE ANO BIEN DIFERENCIADO"
  },
  {
    "codigo":29789008,
    "descripcion":"REACCIÓN LEUCEMOIDE MONOCÍTICA"
  },
  {
    "codigo":1240370001,
    "descripcion":"METÁSTASIS DE CARCINOMA ESCAMOSO EN HÍGADO Y VÍA BILIAR INTRAHEPÁTICA"
  },
  {
    "codigo":423005002,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE CONDUCTO DE GLÁNDULA LAGRIMAL"
  },
  {
    "codigo":290098003,
    "descripcion":"EDEMA DEL PEZÓN"
  },
  {
    "codigo":16746901000119101,
    "descripcion":"RETINOPATÍA NO PROLIFERATIVA SEVERA DE OJO IZQUIERDO DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":1142066007,
    "descripcion":"TAQUICARDIA RECIPROCANTE AURICULOVENTRICULAR ANTIDRÓMICA QUE UTILIZA VÍA ACCESORIA AURICULOFASCICULAR CON CONDUCCIÓN UNIDIRECCIONAL ANTERÓGRADA"
  },
  {
    "codigo":124423008,
    "descripcion":"DEFICIENCIA DE RETINIL - PALMITATO ESTERASA"
  },
  {
    "codigo":253660005,
    "descripcion":"CAYADO AÓRTICO DOBLE CON AMBAS RAMAS PERMEABLES"
  },
  {
    "codigo":186289000,
    "descripcion":"TIÑA NEGRA"
  },
  {
    "codigo":89820008,
    "descripcion":"FRACTURA INTERTROCANTÉREA NO EXPUESTA"
  },
  {
    "codigo":251825006,
    "descripcion":"VELLO AXILAR EN ESTADIO 1 DE TANNER"
  },
  {
    "codigo":284593007,
    "descripcion":"ATAQUE DE GRITOS"
  },
  {
    "codigo":282758001,
    "descripcion":"LESIÓN DE MENTÓN"
  },
  {
    "codigo":249990003,
    "descripcion":"INESTABLE EN BIPEDESTACIÓN"
  },
  {
    "codigo":315526007,
    "descripcion":"NACIDO EN ESPAÑA"
  },
  {
    "codigo":1296731001,
    "descripcion":"ENFERMEDAD KRABBE ATÍPICA DEBIDA A DEFICIENCIA DE SAPOSINA A"
  },
  {
    "codigo":870747001,
    "descripcion":"ALERGIA A CLORHEXIDINA Y\/O NEOMICINA"
  },
  {
    "codigo":1231195003,
    "descripcion":"LAGOFTALMOS PARALÍTICO DE PÁRPADO SUPERIOR"
  },
  {
    "codigo":706907002,
    "descripcion":"CIERTO AVANCE HACIA EL OBJETIVO"
  },
  {
    "codigo":1073711000119105,
    "descripcion":"ARTRITIS REUMATOIDE DE MANO IZQUIERDA"
  },
  {
    "codigo":442928001,
    "descripcion":"CONDROCALCINOSIS DE ARTICULACIÓN DE REGIÓN DE HOMBRO"
  },
  {
    "codigo":80645004,
    "descripcion":"MASTOIDITIS CRÓNICA"
  },
  {
    "codigo":1293061005,
    "descripcion":"RADIOGRAFÍA DE SENO NASAL NORMAL"
  },
  {
    "codigo":441093004,
    "descripcion":"CAPAZ DE RECONOCER EL PROPIO NOMBRE ESCRITO"
  },
  {
    "codigo":47877004,
    "descripcion":"INTOXICACIÓN POR SAPONARIA OFFICINALIS"
  },
  {
    "codigo":703237009,
    "descripcion":"CORYNEBACTERIUM AURIS O TURICELLA OTITIDIS"
  },
  {
    "codigo":275418001,
    "descripcion":"CUELLO UTERINO FISURADO"
  },
  {
    "codigo":439258003,
    "descripcion":"DEFORMIDAD DE DEDO DEL PIE POR BANDA AMNIÓTICA"
  },
  {
    "codigo":373722006,
    "descripcion":"OLOR VAGINAL"
  },
  {
    "codigo":13274008,
    "descripcion":"FIBROSIS PULMONAR ATRÓFICA"
  },
  {
    "codigo":10959561000119104,
    "descripcion":"HERIDA ABIERTA DE MUÑECA DERECHA DEBIDA A MORDEDURA HUMANA"
  },
  {
    "codigo":109743006,
    "descripcion":"RESTAURACIÓN DENTAL QUE YA NO PUEDE REPARARSE"
  },
  {
    "codigo":238980001,
    "descripcion":"ENFERMEDAD SISTÉMICA QUE AFECTA LA PIEL"
  },
  {
    "codigo":75140002,
    "descripcion":"ESPASMO CARPOPEDAL"
  },
  {
    "codigo":76975009,
    "descripcion":"MICROEMBOLIA RETINIANA"
  },
  {
    "codigo":1254788006,
    "descripcion":"CARCINOMA LINFOEPITELIAL DE TRÁQUEA"
  },
  {
    "codigo":271748007,
    "descripcion":"HALLAZGO EN LA LARINGE"
  },
  {
    "codigo":402820007,
    "descripcion":"CARCINOMA BASOCELULAR DE OÍDO"
  },
  {
    "codigo":237145004,
    "descripcion":"INFERTILIDAD NO EXPLICADA"
  },
  {
    "codigo":1285721004,
    "descripcion":"FRACTURA DE CÚBITO DERECHO"
  },
  {
    "codigo":400985006,
    "descripcion":"NECESITA AYUDA CON EL TRABAJO DOMÉSTICO"
  },
  {
    "codigo":73305009,
    "descripcion":"GLOMERULONEFRITIS FIBRILAR"
  },
  {
    "codigo":366382001,
    "descripcion":"AMPLITUD DE FLEXIÓN DE COLUMNA CERVICAL-HALLAZGO"
  },
  {
    "codigo":169774004,
    "descripcion":"ATENCIÓN POSNATAL DENTRO DE LAS 48 HORAS POSTERIORES AL NACIMIENTO"
  },
  {
    "codigo":5934007,
    "descripcion":"AFASIA SUBCORTICAL"
  },
  {
    "codigo":299011001,
    "descripcion":"AMPLITUD DE PRONACIÓN PASIVA DE LA MUÑECA AUMENTADA"
  },
  {
    "codigo":167939004,
    "descripcion":"MEGACARIOCITOS EN MÉDULA ÓSEA, ANORMALES"
  },
  {
    "codigo":397315006,
    "descripcion":"TEJIDO DEL ESPÉCIMEN INTACTO"
  },
  {
    "codigo":36867007,
    "descripcion":"TRASTORNO DE LA FUNCIÓN MOTORA DEL NERVIO GLOSOFARÍNGEO"
  },
  {
    "codigo":200707008,
    "descripcion":"IMPÉTIGO SIMPLE"
  },
  {
    "codigo":723160002,
    "descripcion":"MONOPLEJÍA ESPÁSTICA DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":297176007,
    "descripcion":"ANEURISMA DE ARTERIA VERTEBRAL"
  },
  {
    "codigo":459181003,
    "descripcion":"ANEURISMA DE PARCHE DE DEFECTO DE TABIQUE INTERVENTRICULAR"
  },
  {
    "codigo":262573005,
    "descripcion":"HERIDA POR PERDIGÓN"
  },
  {
    "codigo":721325007,
    "descripcion":"FRACTURA DE RAMA DE LA MANDÍBULA"
  },
  {
    "codigo":37731000119108,
    "descripcion":"HIPERMOVILIDAD URETRAL"
  },
  {
    "codigo":424578002,
    "descripcion":"CRESTA RETINIANA PERIFÉRICA NO QUÍSTICA"
  },
  {
    "codigo":293506003,
    "descripcion":"REACCIÓN ADVERSA AL TRANDOLAPRIL"
  },
  {
    "codigo":129666005,
    "descripcion":"NEUROTOXICIDAD CAUSADA POR METOTREXATO"
  },
  {
    "codigo":1145474005,
    "descripcion":"HIPOPLASIA DE FALANGE DISTAL DE DEDO ÍNDICE"
  },
  {
    "codigo":1076221000119103,
    "descripcion":"BURSITIS SUBROTULIANA DE RODILLA DERECHA"
  },
  {
    "codigo":95063001,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA PIEL DE LOS DEDOS DE LA MANO"
  },
  {
    "codigo":226135003,
    "descripcion":"DIETA CON BAJO CONTENIDO EN POLISACÁRIDO SIN ALMIDÓN"
  },
  {
    "codigo":291671006,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR HIDROXIQUINOLINA"
  },
  {
    "codigo":1340247007,
    "descripcion":"LESIÓN TRAUMÁTICA DE REGIÓN DE COLUMNA VERTEBRAL SACRA"
  },
  {
    "codigo":715820004,
    "descripcion":"LISENCEFALIA CONCOMITANTE CON HIPOPLASIA CONGÉNITA DE CEREBELO, TIPO C"
  },
  {
    "codigo":93228004,
    "descripcion":"MELANOMA MALIGNO DE LA PIEL DEL ANTEBRAZO"
  },
  {
    "codigo":289836008,
    "descripcion":"OVARIO AUSENTE"
  },
  {
    "codigo":224300008,
    "descripcion":"RECIBIÓ EDUCACIÓN UNIVERSITARIA"
  },
  {
    "codigo":124161002,
    "descripcion":"DEFICIENCIA DE ALDEHÍDO OXIDASA"
  },
  {
    "codigo":253398001,
    "descripcion":"DILATACIÓN DE ANILLO DE VÁLVULA MITRAL"
  },
  {
    "codigo":286166003,
    "descripcion":"CAPAZ DE LIMPIAR EL INODORO"
  },
  {
    "codigo":187862007,
    "descripcion":"NEOPLASIA MALIGNA DE LÓBULO SUPERIOR DEL PULMÓN"
  },
  {
    "codigo":218795004,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR PSILOCINA"
  },
  {
    "codigo":22187004,
    "descripcion":"POLÍGAMO"
  },
  {
    "codigo":284331006,
    "descripcion":"INCAPAZ DE INSERTAR UN OBJETO DENTRO DE OTRO"
  },
  {
    "codigo":446336000,
    "descripcion":"FILTRACIÓN DESDE DUODENOSTOMÍA"
  },
  {
    "codigo":251563008,
    "descripcion":"EXAGERACIÓN DE LA RESPUESTA H"
  },
  {
    "codigo":282496001,
    "descripcion":"NO CORRE PENDIENTE ABAJO"
  },
  {
    "codigo":1003392001,
    "descripcion":"DELECIÓN DE PORCIÓN MEDIA DEL BRAZO LARGO DE CROMOSOMA 5"
  },
  {
    "codigo":249728005,
    "descripcion":"HERNIACIÓN DE LOS MÚSCULOS LUMBARES"
  },
  {
    "codigo":313429000,
    "descripcion":"SEMINOMA DE TESTÍCULO DESCENDIDO"
  },
  {
    "codigo":1263701005,
    "descripcion":"TRASTORNO NEONATAL PRECOZ DEBIDO A CIRUGÍA UTERINA MATERNA PREVIA"
  },
  {
    "codigo":247893006,
    "descripcion":"CULPA PATOLÓGICA"
  },
  {
    "codigo":15686961000119102,
    "descripcion":"SINOVITIS DE ARTICULACIÓN DE RODILLA DERECHA"
  },
  {
    "codigo":442666001,
    "descripcion":"NO ES POSIBLE REALIZAR CRIBADO CONFIABLE DEBIDO A PREMATUREZ DEL SUJETO"
  },
  {
    "codigo":82218004,
    "descripcion":"DEPRESIÓN POSTOPERATORIA"
  },
  {
    "codigo":16041111000119109,
    "descripcion":"ARTRITIS IDIOPÁTICA JUVENIL DE INICIO SISTÉMICO DE AMBAS RODILLAS"
  },
  {
    "codigo":286001000119104,
    "descripcion":"LACERACIÓN MENOR DE CORAZÓN CONCOMITANTE CON HEMOPERICARDIO"
  },
  {
    "codigo":1260031006,
    "descripcion":"ADENOCARCINOMA DE CÉLULAS CLARAS DE OROFARINGE"
  },
  {
    "codigo":735743006,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA DE COLUMNA VERTEBRAL DEBIDA A TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":80383008,
    "descripcion":"EMBOLIA DE ARTERIA ILÍACA"
  },
  {
    "codigo":78548001,
    "descripcion":"ENZIMOPATÍA"
  },
  {
    "codigo":702975009,
    "descripcion":"EX CONSUMIDOR DE TABACO"
  },
  {
    "codigo":341451000119100,
    "descripcion":"CATARATA NUCLEAR CONGÉNITA DE OJO IZQUIERDO"
  },
  {
    "codigo":207785000,
    "descripcion":"FRACTURA DE CRÁNEO Y HUESOS FACIALES"
  },
  {
    "codigo":76713001,
    "descripcion":"DIETA PROTEICA"
  },
  {
    "codigo":1354665002,
    "descripcion":"POSICIÓN CORPORAL SUPINA PARA ALIMENTACIÓN POR SONDA"
  },
  {
    "codigo":109481002,
    "descripcion":"HIPOPLASIA GENERALIZADA DEL ESMALTE ASOCIADA CON FLUOROSIS"
  },
  {
    "codigo":699305004,
    "descripcion":"MICRODELECIÓN 1Q21.1"
  },
  {
    "codigo":304254000,
    "descripcion":"RISA INADECUADA"
  },
  {
    "codigo":107646001,
    "descripcion":"HALLAZGO EN LA CONSISTENCIA"
  },
  {
    "codigo":369790002,
    "descripcion":"ESCALA COMBINADA DE NOTTINGHAM, GRADO I: 3-5 PUNTOS"
  },
  {
    "codigo":402558004,
    "descripcion":"MELANOMA MALIGNO (FASE DE CRECIMIENTO VERTICAL)"
  },
  {
    "codigo":10745291000119103,
    "descripcion":"ENFERMEDAD NEOPLÁSICA MALIGNA EN LA MADRE QUE COMPLICA EL NACIMIENTO"
  },
  {
    "codigo":238718006,
    "descripcion":"DISTROFIA UNGUEAL MEDIANA DE HELLER"
  },
  {
    "codigo":40275004,
    "descripcion":"DERMATITIS POR CONTACTO"
  },
  {
    "codigo":235048000,
    "descripcion":"GRANULOMATOSIS BUCOFACIAL"
  },
  {
    "codigo":300584000,
    "descripcion":"COMPRESIBLE"
  },
  {
    "codigo":202280004,
    "descripcion":"CONTRACTURA EN EXTENSIÓN DE LA ARTICULACIÓN METACARPOFALÁNGICA"
  },
  {
    "codigo":366120004,
    "descripcion":"HALLAZGO RELACIONADO CON LA POSICIÓN DE LA TRÁQUEA"
  },
  {
    "codigo":890408008,
    "descripcion":"DIVERTÍCULO CONGÉNITO DE VESÍCULA BILIAR"
  },
  {
    "codigo":298749003,
    "descripcion":"LONGITUD DE LOS BRAZOS PROPORCIONADA"
  },
  {
    "codigo":36605004,
    "descripcion":"COMPLICACIÓN DE INJERTO-PUENTE"
  },
  {
    "codigo":724733005,
    "descripcion":"TRASTORNO DE OPOSICIÓN DESAFIANTE CONCOMITANTE CON IRRITABILIDAD CRÓNICA-ENOJO"
  },
  {
    "codigo":34770001,
    "descripcion":"RALES ATELECTÁSICOS"
  },
  {
    "codigo":1148882003,
    "descripcion":"GLOMERULOPATÍA DEBIDA A ENFERMEDAD FAMILIAR"
  },
  {
    "codigo":296914006,
    "descripcion":"SOBREDOSIS DE DEXTROTIROSINA"
  },
  {
    "codigo":295079003,
    "descripcion":"ALERGIA A TRINITRATO DE GLICERILO"
  },
  {
    "codigo":426151009,
    "descripcion":"ELECTROCARDIOGRAMA: RITMO IDIOVENTRICULAR"
  },
  {
    "codigo":196775009,
    "descripcion":"ÚLCERA GÁSTRICA CURADA QUE DEJA UNA CICATRIZ"
  },
  {
    "codigo":1145212004,
    "descripcion":"INTOXICACIÓN CAUSADA POR HIDROCARBURO HALOGENADO"
  },
  {
    "codigo":293244006,
    "descripcion":"REACCIÓN ADVERSA AL ESTRADIOL"
  },
  {
    "codigo":424316008,
    "descripcion":"QUEMADURA CAUSADA POR LÍQUIDO CALIENTE"
  },
  {
    "codigo":719228009,
    "descripcion":"PÉRDIDA DE GRASA SUBCUTÁNEA QUE RECUBRE A MÚSCULO BÍCEPS"
  },
  {
    "codigo":291409001,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR NALORFINA"
  },
  {
    "codigo":162172009,
    "descripcion":"ACTIVIDAD SEXUAL - DIARIA"
  },
  {
    "codigo":422481005,
    "descripcion":"TUBERCULOSIS CON RESISTENCIA FARMACOLÓGICA EXTREMA"
  },
  {
    "codigo":94801006,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL COLON"
  },
  {
    "codigo":225873007,
    "descripcion":"HALLAZGO RELACIONADO CON EL DUELO Y LA MUERTE"
  },
  {
    "codigo":92966001,
    "descripcion":"AUSENCIA CONGÉNITA DE LA PROTUBERANCIA OCULAR"
  },
  {
    "codigo":60198007,
    "descripcion":"FORÚNCULO DE AXILA"
  },
  {
    "codigo":289574008,
    "descripcion":"ELIMINACIÓN DEL TAPÓN MUCOSO"
  },
  {
    "codigo":846630009,
    "descripcion":"NEUMONITIS CAUSADA POR VAPOR"
  },
  {
    "codigo":189435000,
    "descripcion":"NEOPLASIA DE CELDILLAS AÉREAS MASTOIDEAS DE COMPORTAMIENTO INCIERTO"
  },
  {
    "codigo":123899003,
    "descripcion":"INTOXICACIÓN POR CRASSULACEAE"
  },
  {
    "codigo":89296000,
    "descripcion":"DEFORMIDAD ADQUIRIDA DEL ABDOMEN"
  },
  {
    "codigo":11839231000119105,
    "descripcion":"DISTENSIÓN DE MÚSCULO INTRÍNSECO DE DEDO MEDIO DE MANO DERECHA"
  },
  {
    "codigo":237832001,
    "descripcion":"TUMOR ENDÓCRINO QUE SECRETA LA HORMONA GASTROINTESTINAL"
  },
  {
    "codigo":449744004,
    "descripcion":"INDURACIÓN DE HERIDA"
  },
  {
    "codigo":253136007,
    "descripcion":"HOLOPROSENCEFALIA LOBAR"
  },
  {
    "codigo":16017151000119107,
    "descripcion":"ALTERACIÓN DE DE ASTA POSTERIOR DE MENISCO INTERNO DE RODILLA DERECHA"
  },
  {
    "codigo":15744921000119101,
    "descripcion":"DEFORMIDAD EN CAVO ADQUIRIDA BILATERAL"
  },
  {
    "codigo":1363578001,
    "descripcion":"MOVIMIENTOS FETALES VISUALIZADOS POR PROFESIONAL DE SALUD"
  },
  {
    "codigo":216698003,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR TOXAFENO"
  },
  {
    "codigo":282234004,
    "descripcion":"CAPAZ DE CAMINAR ACARREANDO UN JUGUETE GRANDE"
  },
  {
    "codigo":413306008,
    "descripcion":"DERIVACIÓN INFORMAL - DIRIGIDA A OTRA AGENCIA"
  },
  {
    "codigo":249466009,
    "descripcion":"QUISTE SUBGLÓTICO"
  },
  {
    "codigo":247631009,
    "descripcion":"PENSAMIENTOS PERSISTENTES"
  },
  {
    "codigo":313167009,
    "descripcion":"ESOTROPÍA ACOMODATIVA CONSTANTE"
  },
  {
    "codigo":737316004,
    "descripcion":"COLITIS ALÉRGICA CAUSADA POR PROTEÍNA ALIMENTARIA EN LACTANTES"
  },
  {
    "codigo":409636005,
    "descripcion":"COMPLICACIÓN DE LA VACUNACIÓN ANTIVARIÓLICA"
  },
  {
    "codigo":81956008,
    "descripcion":"QUISTE DEL CUELLO UTERINO"
  },
  {
    "codigo":702713001,
    "descripcion":"PROCTITIS AGUDA"
  },
  {
    "codigo":1081241000119107,
    "descripcion":"ONCOCITOMA DE RIÑÓN DERECHO"
  },
  {
    "codigo":1259769002,
    "descripcion":"GLIOMA MALIGNO PRIMARIO DEL TRONCO ENCEFÁLICO"
  },
  {
    "codigo":735481002,
    "descripcion":"PROLAPSO INCOMPLETO DE LA CÚPULA VAGINAL"
  },
  {
    "codigo":211193007,
    "descripcion":"ABRASIÓN DE PIEL DE REGIÓN CLAVICULAR"
  },
  {
    "codigo":209358004,
    "descripcion":"FRACTURA-LUXACIÓN NO EXPUESTA DE ARTICULACIÓN METATARSOFALÁNGICA, ÚNICA"
  },
  {
    "codigo":405966006,
    "descripcion":"TUMOR RENAL-HALLAZGO"
  },
  {
    "codigo":1290702007,
    "descripcion":"FRACTURA DE CRÁNEO DURANTE PROCEDIMIENTO QUIRÚRGICO CAUSADA POR FIJADOR CRANEAL MAYFIELD"
  },
  {
    "codigo":305827003,
    "descripcion":"VISTO POR EL SERVICIO DE PEDIATRÍA"
  },
  {
    "codigo":1256099004,
    "descripcion":"LESIÓN TRAUMÁTICA DE VASO SANGUÍNEO DE MUSLO"
  },
  {
    "codigo":404131003,
    "descripcion":"LINFOMA CUTÁNEO INMUNOBLÁSTICO T, CD-30 NEGATIVO"
  },
  {
    "codigo":369528003,
    "descripcion":"TUMOR MALIGNO QUE COMPROMETE EL OVARIO IZQUIERDO POR PROPAGACIÓN DIRECTA DEL ÚTERO"
  },
  {
    "codigo":402296004,
    "descripcion":"PITIRIASIS ALBA"
  },
  {
    "codigo":1287032006,
    "descripcion":"NEVO MELANOCÍTICO CONGÉNITO DE PIEL DE PÁRPADO SUPERIOR"
  },
  {
    "codigo":302157000,
    "descripcion":"HALLAZGO EN LA PRESIÓN INTRAOCULAR"
  },
  {
    "codigo":7245003,
    "descripcion":"DISTOCIA FETAL"
  },
  {
    "codigo":433229006,
    "descripcion":"FÍSTULA NEFROCUTÁNEA"
  },
  {
    "codigo":72781007,
    "descripcion":"PRIVACIÓN CULTURAL"
  },
  {
    "codigo":127181000119102,
    "descripcion":"CHOQUE SÉPTICO CONCOMITANTE CON DISFUNCIÓN ORGÁNICA AGUDA CAUSADO POR MENINGOCOCO"
  },
  {
    "codigo":365858006,
    "descripcion":"PRONÓSTICO\/PANORAMA - HALLAZGO"
  },
  {
    "codigo":202018007,
    "descripcion":"ARTROPATÍA TRANSITORIA DE ARTICULACIÓN INTERFALÁNGICA DE DEDO DEL PIE"
  },
  {
    "codigo":724471003,
    "descripcion":"DISFUNCIÓN DEL PISO PÉLVICO FEMENINO"
  },
  {
    "codigo":429559004,
    "descripcion":"ANGINA TÍPICA"
  },
  {
    "codigo":298487005,
    "descripcion":"SIGNO CERVICAL CON NOMBRE PROPIO"
  },
  {
    "codigo":296652005,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE AMPICILINA"
  },
  {
    "codigo":1345228006,
    "descripcion":"LACERACIÓN DE CLÍTORIS DURANTE PARTO VAGINAL"
  },
  {
    "codigo":1279692006,
    "descripcion":"INFECCIÓN CAUSADA POR BORRELIA PARKERI"
  },
  {
    "codigo":294817003,
    "descripcion":"ALERGIA A BUSERELINA"
  },
  {
    "codigo":130977004,
    "descripcion":"REFLEJO DE ESTIRAMIENTO DISMINUIDO"
  },
  {
    "codigo":360353005,
    "descripcion":"HIPERTIROIDISMO POR RESISTENCIA A LA HORMONA TIROIDEA HIPOFISARIA"
  },
  {
    "codigo":424054000,
    "descripcion":"COMPRESIÓN DE NERVIO POR CICATRIZ"
  },
  {
    "codigo":292982003,
    "descripcion":"REACCIÓN ADVERSA A PIVMECILINAM"
  },
  {
    "codigo":346471000119103,
    "descripcion":"PANNUS CORNEAL BILATERAL"
  },
  {
    "codigo":1144950006,
    "descripcion":"VASCULITIS DEBIDA A SÍNDROME DE SJÖGREN"
  },
  {
    "codigo":225611000,
    "descripcion":"INCAPAZ DE MOVER LA CABEZA CUANDO ESTÁ POSTRADO"
  },
  {
    "codigo":29003001,
    "descripcion":"DISFONÍA ESPÁSTICA"
  },
  {
    "codigo":127307002,
    "descripcion":"LACERACIÓN DEL TRONCO ENCEFÁLICO"
  },
  {
    "codigo":782667002,
    "descripcion":"NEVO MELANOCÍTICO DE MIEMBRO SUPERIOR DERECHO"
  },
  {
    "codigo":291147000,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR TRIFLUPERIDOL"
  },
  {
    "codigo":1083751000119104,
    "descripcion":"HERNIA FEMORAL BILATERAL OBSTRUIDA"
  },
  {
    "codigo":191008001,
    "descripcion":"INMUNODEFICIENCIA POR RESPUESTA DEFECTUOSA HEREDITARIA CONTRA EL VIRUS DE EPSTEIN-BARR"
  },
  {
    "codigo":94539009,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA PIEL DEL ABDOMEN"
  },
  {
    "codigo":289312003,
    "descripcion":"CORDÓN UMBILICAL ALREDEDOR DE LAS EXTREMIDADES DEL BEBÉ"
  },
  {
    "codigo":1010208004,
    "descripcion":"HEMATOMA DE BAZO CON HERIDA ABIERTA HACIA CAVIDAD ABDOMINAL"
  },
  {
    "codigo":420384005,
    "descripcion":"ENFERMEDAD DEL SISTEMA HEMATOPOYÉTICO ASOCIADA CON SIDA"
  },
  {
    "codigo":92704005,
    "descripcion":"CARCINOMA IN SITU DEL LIGAMENTO REDONDO DEL ÚTERO"
  },
  {
    "codigo":123637000,
    "descripcion":"DILATACIÓN DE CONDUCTO DE GLÁNDULA SEBÁCEA"
  },
  {
    "codigo":1137610001,
    "descripcion":"LÍNEA CAPILAR ANTERIOR ANORMAL"
  },
  {
    "codigo":1336053009,
    "descripcion":"EPISODIO DE USO NOCIVO DE SUSTANCIA PSICOACTIVA"
  },
  {
    "codigo":254709009,
    "descripcion":"CARCINOMA ECRINO PAPILAR DIGITAL DE PIEL"
  },
  {
    "codigo":283807001,
    "descripcion":"MORDEDURA DE ANIMAL EN EL ANTEBRAZO"
  },
  {
    "codigo":251039005,
    "descripcion":"ARTERIA PULMONAR - HALLAZGO"
  },
  {
    "codigo":1332383007,
    "descripcion":"DETENCIÓN TOTAL DE CRECIMIENTO EPIFISARIO DE TIBIA PROXIMAL"
  },
  {
    "codigo":773492007,
    "descripcion":"ESPASTICIDAD DE INICIO EN LA NIÑEZ CON HIPERGLICINEMIA"
  },
  {
    "codigo":17993000,
    "descripcion":"ARTERITIS PULMONAR"
  },
  {
    "codigo":1197641003,
    "descripcion":"EQUIPAMIENTO INADECUADO PARA DETECCIÓN DE MONÓXIDO DE CARBONO EN LA VIVIENDA"
  },
  {
    "codigo":181833004,
    "descripcion":"CRECIMIENTO FETAL NORMAL"
  },
  {
    "codigo":247369005,
    "descripcion":"DOLOR DE ARTICULACIÓN CIGOAPOFISARIA"
  },
  {
    "codigo":280137006,
    "descripcion":"PIE DIABÉTICO"
  },
  {
    "codigo":312905005,
    "descripcion":"RETINOPATÍA NO PROLIFERATIVA SEVERA DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":704286004,
    "descripcion":"FRACTURA POR OSTEOPOROSIS SECUNDARIA DE HÚMERO"
  },
  {
    "codigo":81694006,
    "descripcion":"SIGNO DEL CAJÓN"
  },
  {
    "codigo":737054007,
    "descripcion":"ALTERACIÓN DE LA ALINEACIÓN DE TOBILLO"
  },
  {
    "codigo":210931000,
    "descripcion":"EFECTO TARDÍO DE HERIDA ABIERTA DE CABEZA, CUELLO Y TRONCO"
  },
  {
    "codigo":48926009,
    "descripcion":"RAQUIALGIA"
  },
  {
    "codigo":1259507000,
    "descripcion":"CARCINOMA ADENOIDE QUÍSTICO PRIMARIO DE OROFARINGE"
  },
  {
    "codigo":473075003,
    "descripcion":"INFLAMACIÓN ASOCIADA CON DISPOSITIVO NEUROLÓGICO"
  },
  {
    "codigo":241864000,
    "descripcion":"EFECTO TÓXICO CAUSADO POR PRODUCTO COSMÉTICO"
  },
  {
    "codigo":372936000,
    "descripcion":"INFECCIÓN CAUSADA POR TALAROMYCES MARNEFFEI"
  },
  {
    "codigo":897224005,
    "descripcion":"CURVATURA ANORMAL DE FALANGE DISTAL DE MANO"
  },
  {
    "codigo":307400005,
    "descripcion":"INJERTO FEMOROPOPLÍTEO INFECTADO"
  },
  {
    "codigo":45256007,
    "descripcion":"SÍNDROME DE CRUVEILHIER - BAUMGARTEN"
  },
  {
    "codigo":733384008,
    "descripcion":"LESIÓN TRAUMÁTICA PRIMARIA DE DUODENO POR EXPLOSIÓN"
  },
  {
    "codigo":403869001,
    "descripcion":"QUERATOSIS EN ESTUCO"
  },
  {
    "codigo":698781002,
    "descripcion":"DEMENCIA ASOCIADA CON ANOXIA CEREBRAL"
  },
  {
    "codigo":371101003,
    "descripcion":"ENFERMEDAD POR REFLUJO GASTROESOFÁGICO CON APNEA"
  },
  {
    "codigo":240029004,
    "descripcion":"LESIÓN DE LIGAMENTOS DE LA REGIÓN DEL PIE"
  },
  {
    "codigo":10653003,
    "descripcion":"HIPERPLASIA MANDIBULAR CONGÉNITA"
  },
  {
    "codigo":10834741000119101,
    "descripcion":"FRACTURA EXPUESTA DE FALANGE DISTAL DE DEDO PULGAR DE MANO DERECHA"
  },
  {
    "codigo":305565001,
    "descripcion":"BAJO ATENCIÓN DE ENFERMERA ESPECIALIZADA EN LINFEDEMA"
  },
  {
    "codigo":1155698001,
    "descripcion":"EMBOLIA DE ARTERIA VERTEBRAL DERECHA"
  },
  {
    "codigo":74354009,
    "descripcion":"HOMOLOGÍA DE SECUENCIA DE ÁCIDOS NUCLEICOS"
  },
  {
    "codigo":72519002,
    "descripcion":"METAPLASIA INTESTINAL GÁSTRICA"
  },
  {
    "codigo":762482009,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL SUPERFICIAL DE MIEMBRO INFERIOR"
  },
  {
    "codigo":269127001,
    "descripcion":"LUXACIÓN EXPUESTA ENTRE LA QUINTA Y LA SEXTA VÉRTEBRAS CERVICALES"
  },
  {
    "codigo":367431005,
    "descripcion":"TRASTORNO DEL ESFÍNTER ESOFÁGICO SUPERIOR"
  },
  {
    "codigo":170823005,
    "descripcion":"INYECCIONES DE VITAMINA B12 - DURANTE CIRUGÍA"
  },
  {
    "codigo":1186631005,
    "descripcion":"CARCINOMA HEPATOCELULAR Y COLANGIOCARCINOMA COMBINADO PRIMARIO"
  },
  {
    "codigo":39751009,
    "descripcion":"EFECTO DE POSICIÓN GENÉTICA"
  },
  {
    "codigo":365596003,
    "descripcion":"TÍTULO DE ANTICUERPOS ANTIFÚNGICOS - HALLAZGO"
  },
  {
    "codigo":5148006,
    "descripcion":"CARDIOPATÍA HIPERTENSIVA CON INSUFICIENCIA CARDÍACA CONGESTIVA"
  },
  {
    "codigo":234524009,
    "descripcion":"DACTILITIS SARCOIDE"
  },
  {
    "codigo":429297003,
    "descripcion":"POLIOMIELITIS AGUDA NO PARALÍTICA CAUSADA POR POLIOVIRUS HUMANO 1"
  },
  {
    "codigo":1478001,
    "descripcion":"OBSTRUCCIÓN DE VASO LINFÁTICO"
  },
  {
    "codigo":1344966005,
    "descripcion":"MELORREOSTOSIS DE REGIÓN DE HOMBRO"
  },
  {
    "codigo":296390009,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE CLONIDINA"
  },
  {
    "codigo":229019006,
    "descripcion":"PENETRACIÓN ANAL CON LA MANO"
  },
  {
    "codigo":65179007,
    "descripcion":"KORO"
  },
  {
    "codigo":194416000,
    "descripcion":"PÉRDIDA DE LA AUDICIÓN CONDUCTIVA DEBIDA A TRASTORNO DEL OÍDO INTERNO"
  },
  {
    "codigo":63344000,
    "descripcion":"INTOXICACIÓN POR AMMI"
  },
  {
    "codigo":292720003,
    "descripcion":"REACCIÓN ADVERSA AL EPOPROSTENOL"
  },
  {
    "codigo":1144688005,
    "descripcion":"APLASIA DE FALANGE DE DEDO GORDO"
  },
  {
    "codigo":132201000119100,
    "descripcion":"TROMBOSIS PROFUNDA CRÓNICA DE VENA ILEOFEMORAL"
  },
  {
    "codigo":817008006,
    "descripcion":"OJO DERECHO CON PERCEPCIÓN DE LUZ SOLAMENTE"
  },
  {
    "codigo":258117004,
    "descripcion":"HIPERALDOSTERONISMO IDIOPÁTICO"
  },
  {
    "codigo":1306693005,
    "descripcion":"EPISODIO DE USO NOCIVO DE SUSTANCIA"
  },
  {
    "codigo":716869006,
    "descripcion":"SUSCEPTIBILIDAD MENDELIANA A ENFERMEDAD POR MICOBACTERIAS DEBIDA A DEFICIENCIA COMPLETA DE IL12RB1"
  },
  {
    "codigo":127045008,
    "descripcion":"ANEMIA DREPANOCÍTICA CON TALASEMIA - ALFA CONCOMITANTE"
  },
  {
    "codigo":290885008,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR VENLAFAXINA"
  },
  {
    "codigo":92442000,
    "descripcion":"NEOPLASIA BENIGNA DEL BORDE DE LA LENGUA"
  },
  {
    "codigo":715034003,
    "descripcion":"INCAPAZ DE TOMAR MEDICACIÓN"
  },
  {
    "codigo":289050004,
    "descripcion":"UTILIZA CUCHILLO Y TENEDOR PARA ALIMENTARSE"
  },
  {
    "codigo":90607003,
    "descripcion":"CICATRIZ CONJUNTIVAL"
  },
  {
    "codigo":254447003,
    "descripcion":"NEOPLASIA BENIGNA DE SURCO GINGIVOBUCAL MANDIBULAR"
  },
  {
    "codigo":1237487004,
    "descripcion":"METÁSTASIS DE CARCINOMA EN BASE DE LENGUA"
  },
  {
    "codigo":88772000,
    "descripcion":"CONDUCCIÓN AXÓNICA ANORMAL"
  },
  {
    "codigo":1335791008,
    "descripcion":"ARTRITIS IDIOPÁTICA JUVENIL DE CADERA"
  },
  {
    "codigo":23236001,
    "descripcion":"INTOXICACIÓN POR INDIGOFERA DOMINII"
  },
  {
    "codigo":449220000,
    "descripcion":"LINFOMA CENTROFOLICULAR DIFUSO"
  },
  {
    "codigo":447385003,
    "descripcion":"DISPOSITIVO BLANDO DE OCLUSIÓN PRESENTE"
  },
  {
    "codigo":185241003,
    "descripcion":"ATENDIDO EN UN CONSULTORIO DE MEDICINA GENERAL"
  },
  {
    "codigo":840601005,
    "descripcion":"ENDOMORFO"
  },
  {
    "codigo":283545005,
    "descripcion":"HERIDA DE ARMA DE FUEGO"
  },
  {
    "codigo":414617007,
    "descripcion":"PÉRDIDA DE PULSO DISTAL"
  },
  {
    "codigo":248942000,
    "descripcion":"ÚTERO AUSENTE"
  },
  {
    "codigo":21401009,
    "descripcion":"INTOXICACIÓN POR GÉNERO GUTIERREZIA"
  },
  {
    "codigo":11820291000119102,
    "descripcion":"LUXACIÓN TRAUMÁTICA POSTERIOR NO EXPUESTA DE ARTICULACIÓN ESCAPULOHUMERAL DERECHA"
  },
  {
    "codigo":773230003,
    "descripcion":"DEFICIENCIA DE QUINASA DEPENDIENTE DE CICLINA 5"
  },
  {
    "codigo":52334005,
    "descripcion":"RODILLA DE MINERO"
  },
  {
    "codigo":85102008,
    "descripcion":"ATAXIA CEREBELOSA"
  },
  {
    "codigo":443715007,
    "descripcion":"PATRÓN DE NEOPLASIA MICROPAPILAR"
  },
  {
    "codigo":278040002,
    "descripcion":"CAÍDA DEL CABELLO"
  },
  {
    "codigo":736792008,
    "descripcion":"CON MAYOR RIESGO DE VIOLENCIA BASADA EN HONOR"
  },
  {
    "codigo":1259245000,
    "descripcion":"LESIÓN DE URETRA"
  },
  {
    "codigo":351491000119107,
    "descripcion":"NEOPLASIA TESTICULAR IZQUIERDA DE COMPORTAMIENTO INCIERTO"
  },
  {
    "codigo":704024008,
    "descripcion":"FRACTURA NO EXPUESTA DE DIÁFISIS DE TERCER METACARPIANO"
  },
  {
    "codigo":14061004,
    "descripcion":"DERENCÉFALO"
  },
  {
    "codigo":472813007,
    "descripcion":"CIERRE ESPONTÁNEO DE FENESTRACIÓN DE TABIQUE INTERAURICULAR CREADA QUIRÚRGICAMENTE DESPUÉS DE OPERACIÓN DE FENESTRACIÓN AURICULAR PREVIA"
  },
  {
    "codigo":46829007,
    "descripcion":"DESPLAZAMIENTO DEL DESARROLLO DEL PLEXO BRAQUIAL"
  },
  {
    "codigo":700354000,
    "descripcion":"TRASTORNO DE TENDÓN PERONEO"
  },
  {
    "codigo":11793821000119102,
    "descripcion":"AMPOLLA TRAUMÁTICA DE PIE IZQUIERDO"
  },
  {
    "codigo":307138004,
    "descripcion":"ESPONDILOLISTESIS A NIVEL DE QUINTA VÉRTEBRA LUMBAR Y PRIMERA VÉRTEBRA SACRA"
  },
  {
    "codigo":679171000119109,
    "descripcion":"DEGENERACIÓN NODULAR DE SALZMANN DE CÓRNEA DE AMBOS OJOS"
  },
  {
    "codigo":1255575002,
    "descripcion":"GLOMERULONEFRITIS PROLIFERATIVA DIFUSA"
  },
  {
    "codigo":403607004,
    "descripcion":"ANGIOEDEMA CAUSADO POR INHIBIDOR DE LA ENZIMA CONVERTIDORA DE ANGIOTENSINA"
  },
  {
    "codigo":272535007,
    "descripcion":"SE PARA LIBREMENTE EN EL AGUA"
  },
  {
    "codigo":303468004,
    "descripcion":"SE COLOCA PRÓTESIS"
  },
  {
    "codigo":205164007,
    "descripcion":"DEFICIENCIA TRANSVERSAL DEL BRAZO, NIVEL HUMERAL - LARGA"
  },
  {
    "codigo":399937000,
    "descripcion":"TRASTORNO DE QUERATINIZACIÓN ADQUIRIDO"
  },
  {
    "codigo":301633001,
    "descripcion":"UTILIZA LAS ESCALERAS MECÁNICAS"
  },
  {
    "codigo":1055297002,
    "descripcion":"GONARTROSIS IZQUIERDA DEBIDA A LESIÓN TRAUMÁTICA Y POSTERIOR A ELLA"
  },
  {
    "codigo":236097003,
    "descripcion":"HEMORRAGIA DE ANASTOMOSIS DE INTESTINO GRUESO"
  },
  {
    "codigo":170561004,
    "descripcion":"MAL CONTROL DE ENFERMEDAD CRÓNICA"
  },
  {
    "codigo":203329006,
    "descripcion":"ENFERMEDAD DE PAGET DE LA COLUMNA VERTEBRAL LUMBAR"
  },
  {
    "codigo":267030001,
    "descripcion":"COLOR AMARILLO O ICTÉRICO"
  },
  {
    "codigo":299798001,
    "descripcion":"REFLEJO DE PRENSIÓN PALMAR PRESENTE"
  },
  {
    "codigo":365334002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA REALIZAR ARREGLOS ELÉCTRICOS DOMÉSTICOS"
  },
  {
    "codigo":70422006,
    "descripcion":"INFARTO SUBENDOCÁRDICO AGUDO"
  },
  {
    "codigo":396267000,
    "descripcion":"HALLAZGO RELACIONADO CON EL MARGEN DE RESECCIÓN QUIRÚRGICA PROXIMAL"
  },
  {
    "codigo":398102009,
    "descripcion":"POLIOMIELITIS AGUDA"
  },
  {
    "codigo":297963000,
    "descripcion":"MARCA DE MORDEDURA HUMANA"
  },
  {
    "codigo":4886009,
    "descripcion":"RECIÉN NACIDO VARÓN PREMATURO"
  },
  {
    "codigo":232427004,
    "descripcion":"LARINGITIS DE VINCENT"
  },
  {
    "codigo":363499005,
    "descripcion":"NEOPLASIA MALIGNA DE BAZO"
  },
  {
    "codigo":166891009,
    "descripcion":"GLUCEMIA MEDIDA AL AZAR POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":35741000175108,
    "descripcion":"ÚLCERA POR PRESIÓN EN CODO, ESTADIO III"
  },
  {
    "codigo":296128004,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE BENZODIAZEPINA"
  },
  {
    "codigo":722112006,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE PABELLÓN AURICULAR"
  },
  {
    "codigo":197824007,
    "descripcion":"HEMATOMA PERIRRENAL"
  },
  {
    "codigo":16027191000119107,
    "descripcion":"QUISTE ÓSEO DE AMBAS CINTURAS ESCAPULARES"
  },
  {
    "codigo":195989002,
    "descripcion":"NEUMOPATÍA PROVOCADA POR INHALACIÓN DE EXTRACTO HIPOFISARIO"
  },
  {
    "codigo":64917006,
    "descripcion":"NEUMONÍA CAUSADA POR EL VIRUS PARAINFLUENZA"
  },
  {
    "codigo":292458000,
    "descripcion":"REACCIÓN ADVERSA AL LACIDIPINO"
  },
  {
    "codigo":425365009,
    "descripcion":"VARIANTES DE MIGRAÑA REFRACTARIA"
  },
  {
    "codigo":1144426002,
    "descripcion":"ATROFIA DIFUSA DE CEREBELO"
  },
  {
    "codigo":128618006,
    "descripcion":"TRASTORNO DE DEDO DE LA MANO"
  },
  {
    "codigo":95850008,
    "descripcion":"FRACTURA DEPRIMIDA DEL CRÁNEO"
  },
  {
    "codigo":290623001,
    "descripcion":"INTOXICACIÓN POR CARMUSTINA"
  },
  {
    "codigo":421695000,
    "descripcion":"PÉRDIDA DE PESO ANORMAL ASOCIADA CON EL SIDA"
  },
  {
    "codigo":26644000,
    "descripcion":"POSICIÓN ACROMIOILÍACA DERECHA POSTERIOR"
  },
  {
    "codigo":94015009,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA PIEL DEL TÓRAX"
  },
  {
    "codigo":126783009,
    "descripcion":"NEOPLASIA DEL BORDE DE LA LENGUA"
  },
  {
    "codigo":288788003,
    "descripcion":"CAPAZ DE COMENTAR EVENTOS"
  },
  {
    "codigo":59412005,
    "descripcion":"CUERPO EXTRAÑO NO MAGNÉTICO RETENIDO EN EL IRIS Y\/O EL CUERPO CILIAR"
  },
  {
    "codigo":92180007,
    "descripcion":"NEOPLASIA BENIGNA DEL LÓBULO INFERIOR IZQUIERDO DEL PULMÓN"
  },
  {
    "codigo":57577003,
    "descripcion":"FRACTURA DE TRES COSTILLAS"
  },
  {
    "codigo":254185007,
    "descripcion":"EPIDERMÓLISIS DISTRÓFICA BULLOSA"
  },
  {
    "codigo":1237225007,
    "descripcion":"SÍNDROME DE EHLERS-DANLOS DERMATOSPARAXIS"
  },
  {
    "codigo":188649008,
    "descripcion":"RETICULOENDOTELIOSIS LEUCÉMICA DE GANGLIOS LINFÁTICOS DE REGIÓN INGUINAL Y EXTREMIDAD INFERIOR"
  },
  {
    "codigo":354001000119109,
    "descripcion":"NEOPLASIA BENIGNA DE HUESO CORTO DE MIEMBRO INFERIOR DERECHO"
  },
  {
    "codigo":681681000119109,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE FONDO GÁSTRICO"
  },
  {
    "codigo":447123001,
    "descripcion":"QUISTE EPIDERMOIDE DE PIEL DE MUSLO"
  },
  {
    "codigo":22974009,
    "descripcion":"ERITROPLASIA DE LA LENGUA"
  },
  {
    "codigo":47321000087100,
    "descripcion":"DISTENSIÓN DE TENDÓN DE MÚSCULO INTERNO DE MUSLO DERECHO"
  },
  {
    "codigo":42201000087101,
    "descripcion":"RUPTURA DE LIGAMENTO DE ARTICULACIÓN DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":283283005,
    "descripcion":"ASTILLA DE MADERA EN HOMBRO"
  },
  {
    "codigo":34521000087103,
    "descripcion":"INFECCIÓN CAUSADA POR ENTEROBACTERIACEAE PRODUCTORA DE CARBAPENEMASA"
  },
  {
    "codigo":44761000087104,
    "descripcion":"OCLUSIÓN DE PORCIÓN DISTAL DE RAMA CIRCUNFLEJA DE ARTERIA CORONARIA IZQUIERDA"
  },
  {
    "codigo":248680001,
    "descripcion":"SOPLO INSPIRATORIO TRICUSPÍDEO HOLOSISTÓLICO"
  },
  {
    "codigo":1297256002,
    "descripcion":"CIERRE DE ÁNGULO AGUDO DE OJO DERECHO DEBIDO A UVEÍTIS"
  },
  {
    "codigo":281448003,
    "descripcion":"AFLOJAMIENTO DE PRÓTESIS DE LA ARTICULACIÓN DE LA RODILLA"
  },
  {
    "codigo":707432004,
    "descripcion":"HISTIOCITOSIS DE CÉLULAS DE LANGERHANS CUTÁNEA"
  },
  {
    "codigo":26841000087104,
    "descripcion":"JUBILADO POR DISCAPACIDAD"
  },
  {
    "codigo":52072009,
    "descripcion":"GOLPE DE CALOR"
  },
  {
    "codigo":246845007,
    "descripcion":"BORDE PALPEBRAL - HALLAZGO"
  },
  {
    "codigo":312381009,
    "descripcion":"TRASTORNO DE VAINA TENDINOSA"
  },
  {
    "codigo":15634005,
    "descripcion":"HIPERQUERATOSIS PALMAR EN LA FRAMBESIA"
  },
  {
    "codigo":212242008,
    "descripcion":"LESIÓN DEL GANGLIO CELÍACO"
  },
  {
    "codigo":112103001,
    "descripcion":"NEURALGIA DE MUÑÓN DE AMPUTACIÓN"
  },
  {
    "codigo":408850009,
    "descripcion":"RETINOPATÍA POR PREMATUREZ, ETAPA 4 - DESPRENDIMIENTO SUBTOTAL DE RETINA"
  },
  {
    "codigo":863932003,
    "descripcion":"FRACCIÓN DE EYECCIÓN DE VENTRÍCULO IZQUIERDO DISMINUIDA"
  },
  {
    "codigo":763793004,
    "descripcion":"ENCEFALITIS LÍMBICA CON ANTICUERPOS CONTRA LA PROTEÍNA SÍMIL 2 ASOCIADA A LA CONTACTINA"
  },
  {
    "codigo":10129005,
    "descripcion":"LESIÓN TRAUMÁTICA DE ARTERIA HUMERAL"
  },
  {
    "codigo":403345006,
    "descripcion":"LESIÓN DEL TALLO DEL PELO POR PERMANENTE"
  },
  {
    "codigo":237670000,
    "descripcion":"HIPERSECRECIÓN DE ACTH QUE NO CAUSA EL SÍNDROME DE CUSHING"
  },
  {
    "codigo":698257008,
    "descripcion":"INFECCIÓN DE LA CAVIDAD BUCAL POR VIRUS COXSACKIE"
  },
  {
    "codigo":10678431000119102,
    "descripcion":"TUMEFACCIÓN LOCALIZADA DEL PIE DERECHO"
  },
  {
    "codigo":73830004,
    "descripcion":"CUERPO EXTRAÑO EN EL PENE"
  },
  {
    "codigo":203067000,
    "descripcion":"CONTRACTURA DEL MÚSCULO FLEXOR PROFUNDO DE LOS DEDOS DE LA MANO"
  },
  {
    "codigo":235835000,
    "descripcion":"ÍLEO PRODUCIDO POR REFLEJO NEURAL"
  },
  {
    "codigo":1153339002,
    "descripcion":"NECROSIS CUTÁNEA DEBIDA A TROMBOCITOPENIA INDUCIDA POR HEPARINA"
  },
  {
    "codigo":399675003,
    "descripcion":"TUMOR QUE PENETRA LA SEROSA CON AUSENCIA DE PERFORACIÓN"
  },
  {
    "codigo":301371003,
    "descripcion":"DOLOR QUE CORROE"
  },
  {
    "codigo":792891005,
    "descripcion":"TUMORACIÓN DURA DE MAMA"
  },
  {
    "codigo":761958009,
    "descripcion":"NEOPLASIA MALIGNA DE VAINA DE NERVIO PERIFÉRICO CON DIFERENCIACIÓN PERINEURAL"
  },
  {
    "codigo":102928002,
    "descripcion":"TEOFOBIA"
  },
  {
    "codigo":299536003,
    "descripcion":"AMPLITUD DE INVERSIÓN ACTIVA DE ARTICULACIÓN SUBASTRAGALINA AUMENTADA"
  },
  {
    "codigo":365072003,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA EMPLEAR DIFERENTES FORMAS DE CONVERSACIÓN"
  },
  {
    "codigo":1217040009,
    "descripcion":"DEGENERACIÓN DE GLÁNDULA EPÍFISIS"
  },
  {
    "codigo":37392009,
    "descripcion":"INTOXICACIÓN POR METILAZINFOS"
  },
  {
    "codigo":234000009,
    "descripcion":"DISECCIÓN DE ARTERIA FEMORAL"
  },
  {
    "codigo":363237008,
    "descripcion":"COMPLICACIÓN NEUROLÓGICA DE PROCEDIMIENTO"
  },
  {
    "codigo":66490000,
    "descripcion":"PARÁLISIS MUSCULAR NEUROLÓGICA"
  },
  {
    "codigo":199397009,
    "descripcion":"DESPROPORCIÓN CEFALOPÉLVICA"
  },
  {
    "codigo":230330004,
    "descripcion":"DISTONÍA OCUPACIONAL"
  },
  {
    "codigo":787386005,
    "descripcion":"METABOLIZADOR ULTRARRÁPIDO DE LA FAMILIA 3 SUBFAMILIA A MIEMBRO 4 DEL CITOCROMO P450"
  },
  {
    "codigo":263098007,
    "descripcion":"FRACTURA-SUBLUXACIÓN DE ARTICULACIÓN DE HOMBRO"
  },
  {
    "codigo":295866008,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE IMIPRAMINA"
  },
  {
    "codigo":720015004,
    "descripcion":"DISFUNCIÓN SOMÁTICA DE REGIÓN ESTERNOCLAVICULAR"
  },
  {
    "codigo":294031004,
    "descripcion":"ALERGIA A XILOMETAZOLINA"
  },
  {
    "codigo":718180000,
    "descripcion":"DISTROFIA MUSCULAR DE LAS CINTURAS DE LAS EXTREMIDADES TIPO 2I AUTOSÓMICA RECESIVA"
  },
  {
    "codigo":195727009,
    "descripcion":"BRONQUITIS AGUDA POR VIRUS SINCICIAL RESPIRATORIO"
  },
  {
    "codigo":783716004,
    "descripcion":"ANEURISMA ADQUIRIDO DE ARTERIA CEREBRAL"
  },
  {
    "codigo":95588004,
    "descripcion":"OBSTRUCCIÓN DE LA URETRA"
  },
  {
    "codigo":292196008,
    "descripcion":"REACCIÓN ADVERSA A FÁRMACO ANTINEOPLÁSICO"
  },
  {
    "codigo":421433001,
    "descripcion":"PULSACIÓN PRECORDIAL"
  },
  {
    "codigo":192057001,
    "descripcion":"REACCIÓN DE ADAPTACIÓN CON CONDUCTA ANTISOCIAL"
  },
  {
    "codigo":93753000,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA MEJILLA"
  },
  {
    "codigo":290361005,
    "descripcion":"INTOXICACIÓN POR NIZATIDINA"
  },
  {
    "codigo":126521006,
    "descripcion":"NEOPLASIA DE LA PIEL DE LA MUÑECA"
  },
  {
    "codigo":15731001000119108,
    "descripcion":"PARÁLISIS TOTAL DE NERVIO OCULOMOTOR IZQUIERDO"
  },
  {
    "codigo":1142329009,
    "descripcion":"ATROFIA DE MÚSCULO DE CINTURA ESCAPULAR"
  },
  {
    "codigo":91918005,
    "descripcion":"AUSENCIA CONGÉNITA DEL TIMO"
  },
  {
    "codigo":303571000119103,
    "descripcion":"PABELLÓN AURICULAR IZQUIERDO EN COLIFLOR ADQUIRIDO"
  },
  {
    "codigo":124686007,
    "descripcion":"DEFICIENCIA DE MUTASA"
  },
  {
    "codigo":24547000,
    "descripcion":"VOLUMEN"
  },
  {
    "codigo":712675001,
    "descripcion":"ANTÍGENO DE CAMPYLOBACTER NEGATIVO"
  },
  {
    "codigo":286691002,
    "descripcion":"ANULACIÓN - MECANISMO DE DEFENSA PSICOLÓGICA"
  },
  {
    "codigo":1204195003,
    "descripcion":"OCLUSIÓN AGUDA DE ARTERIA VISCERAL DEBIDA A TROMBOEMBOLISMO"
  },
  {
    "codigo":1236963002,
    "descripcion":"METÁSTASIS DE CARCINOMA DE PALADAR DURO"
  },
  {
    "codigo":186552002,
    "descripcion":"DERMATITIS VESICULAR HERPÉTICA"
  },
  {
    "codigo":219320005,
    "descripcion":"LESIÓN DE CAUSA ACCIDENTAL O INTENCIONAL INDETERMINADA, INTOXICACIÓN POR GAS LICUADO DISTRIBUIDO EN ENVASES MÓVILES"
  },
  {
    "codigo":11854291000119106,
    "descripcion":"LACERACIÓN DE MÚSCULO INTRÍNSECO DE PIE DERECHO"
  },
  {
    "codigo":671281000124103,
    "descripcion":"INSEGURIDAD FINANCIERA DEBIDA A CARGA DE GASTOS MÉDICOS"
  },
  {
    "codigo":283021003,
    "descripcion":"DIENTE MÓVIL"
  },
  {
    "codigo":1003917004,
    "descripcion":"HIPERPLASIA CONGÉNITA SECUNDARIA DE PULMÓN"
  },
  {
    "codigo":440881000124108,
    "descripcion":"INGESTA INADECUADA DE CROMO"
  },
  {
    "codigo":250253005,
    "descripcion":"CÉLULAS DE PUDDLE"
  },
  {
    "codigo":19042000,
    "descripcion":"PROLAPSO CONGÉNITO DE LA URETRA"
  },
  {
    "codigo":248418008,
    "descripcion":"ASPECTO ICTÉRICO DE LAS EXTREMIDADES"
  },
  {
    "codigo":1264226008,
    "descripcion":"INFECCIÓN NEONATAL PRECOZ CAUSADA POR STAPHYLOCOCCUS AUREUS"
  },
  {
    "codigo":11827821000119104,
    "descripcion":"SUBLUXACIÓN DE ARTICULACIÓN DE CADERA DERECHA"
  },
  {
    "codigo":1196855004,
    "descripcion":"NEOPLASIA INTRAEPITELIAL GLANDULAR DE BAJO GRADO DE INTESTINO GRUESO"
  },
  {
    "codigo":312119006,
    "descripcion":"INFECCIÓN BACTERIANA DE LA VÍA RESPIRATORIA INFERIOR"
  },
  {
    "codigo":769036006,
    "descripcion":"ACROANGIODERMATITIS CUTÁNEA"
  },
  {
    "codigo":10736391000119100,
    "descripcion":"DISPLASIA MAMARIA BENIGNA DE MAMA IZQUIERDA"
  },
  {
    "codigo":80908008,
    "descripcion":"DEFICIENCIA DE ORNITINA CARBAMOILTRANSFERASA"
  },
  {
    "codigo":898273004,
    "descripcion":"ANQUILOSIS CONGÉNITA DE ARTICULACIÓN INTERFALÁNGICA DISTAL DE DEDO ÍNDICE"
  },
  {
    "codigo":110006004,
    "descripcion":"LEUCEMIA PROLINFOCÍTICA"
  },
  {
    "codigo":763531001,
    "descripcion":"DEFICIENCIA FAMILIAR BENIGNA DE COBRE"
  },
  {
    "codigo":403083003,
    "descripcion":"TIÑA CAUSADA POR TRICHOPHYTON SOUDANENSE"
  },
  {
    "codigo":75403004,
    "descripcion":"SARCOIDOSIS CARDÍACA"
  },
  {
    "codigo":139104001,
    "descripcion":"INGESTA EXCESIVA DE LÍQUIDOS"
  },
  {
    "codigo":40800004,
    "descripcion":"FIBROADENOSIS DIFUSA DE LA MAMA"
  },
  {
    "codigo":8032007,
    "descripcion":"ANOMALÍA CONGÉNITA DE CARTÍLAGO TIROIDES"
  },
  {
    "codigo":170037002,
    "descripcion":"TALLA DEL NIÑO ENTRE PERCENTILOS 25 Y 49"
  },
  {
    "codigo":202805003,
    "descripcion":"TRASTORNO SACROILÍACO"
  },
  {
    "codigo":1251381003,
    "descripcion":"EXACERBACIÓN DE DERMATITIS ATÓPICA DEBIDA A EXPOSICIÓN OCUPACIONAL A IRRITANTE DE PIEL"
  },
  {
    "codigo":10900231000119107,
    "descripcion":"ABRASIÓN DE CÓRNEA IZQUIERDA"
  },
  {
    "codigo":301109008,
    "descripcion":"LESIÓN DE VÁLVULA TRICÚSPIDE"
  },
  {
    "codigo":397578001,
    "descripcion":"DISPOSITIVO IN SITU"
  },
  {
    "codigo":200970002,
    "descripcion":"PSORIASIS PALMAR"
  },
  {
    "codigo":299274007,
    "descripcion":"AMPLITUD DE ADUCCIÓN ACTIVA DE LA CADERA NORMAL"
  },
  {
    "codigo":233738009,
    "descripcion":"MEDIASTINITIS FIBROSA CAUSADA POR RADIACIÓN"
  },
  {
    "codigo":364810009,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA MAMAR DE MAMADERA"
  },
  {
    "codigo":168202009,
    "descripcion":"ESPÉCIMEN: BACTERIA NO SENSIBLE"
  },
  {
    "codigo":788959004,
    "descripcion":"BORRELIOSIS OFTÁLMICA DE LYME"
  },
  {
    "codigo":231903005,
    "descripcion":"QUERATOCONJUNTIVITIS LÍMBICA SUPERIOR"
  },
  {
    "codigo":142241000119104,
    "descripcion":"ESCURRIMIENTO FECAL CONCOMITANTE CON INCONTINENCIA FECAL Y DEBIDO A ELLA"
  },
  {
    "codigo":1149407007,
    "descripcion":"SOBREDOSIS INTENCIONAL DE PROTAMINA"
  },
  {
    "codigo":362975008,
    "descripcion":"TRASTORNO DEGENERATIVO"
  },
  {
    "codigo":428511009,
    "descripcion":"EMBARAZO MÚLTIPLE CON UNA PÉRDIDA FETAL"
  },
  {
    "codigo":262836004,
    "descripcion":"FRAGMENTACIÓN DE GLÁNDULA SUPRARRENAL"
  },
  {
    "codigo":295604006,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE BUSULFANO"
  },
  {
    "codigo":197300007,
    "descripcion":"CIRROSIS DEBIDA A FIBROSIS PERIPORTAL HEPÁTICA"
  },
  {
    "codigo":721588008,
    "descripcion":"HEPATITIS CAUSADA POR VIRUS TRANSMISIBLE SEXUALMENTE"
  },
  {
    "codigo":689211000119102,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE PIEL PERIANAL"
  },
  {
    "codigo":1342345008,
    "descripcion":"TRASTORNO DE PLEXO BRAQUIAL CAUSADO POR RADIACIÓN IONIZANTE"
  },
  {
    "codigo":717918002,
    "descripcion":"TUMOR NEUROENDOCRINO DE OÍDO MEDIO"
  },
  {
    "codigo":160862000,
    "descripcion":"ARRESTO DE NOVIO"
  },
  {
    "codigo":95326004,
    "descripcion":"DERMATOSIS TÓXICA"
  },
  {
    "codigo":10955681000119109,
    "descripcion":"HERIDA PUNZANTE DE DEDO ÍNDICE DE MANO IZQUIERDA"
  },
  {
    "codigo":62558006,
    "descripcion":"LESIONES DISCRÓMICAS DE LA PIEL PROVOCADAS POR PINTA"
  },
  {
    "codigo":128094006,
    "descripcion":"RESISTENCIA A LA TRANSFUSIÓN ALOINMUNITARIA DE PLAQUETAS"
  },
  {
    "codigo":1142067003,
    "descripcion":"TAQUICARDIA AURICULAR DE MACRORREENTRADA NO DEPENDIENTE DE ISTMO CAVOTRICUSPÍDEO DE AURÍCULA IZQUIERDA NO MEDIADA POR CICATRIZ"
  },
  {
    "codigo":127091000119100,
    "descripcion":"SEPSIS NEONATAL CAUSADA POR STREPTOCOCCUS DEL GRUPO B"
  },
  {
    "codigo":16907891000119101,
    "descripcion":"NEVO EPIDÉRMICO DE PÁRPADO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":11839091000119102,
    "descripcion":"DISTENSIÓN DE MÚSCULO INTRÍNSECO DE MANO DERECHA"
  },
  {
    "codigo":334451000119103,
    "descripcion":"ESTENOSIS DE SACO LAGRIMAL DERECHO"
  },
  {
    "codigo":109171000119104,
    "descripcion":"EDEMA DE RETINA DEBIDO A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":298611000119105,
    "descripcion":"OSTEONECROSIS DE TIBIA CAUSADA POR FÁRMACO"
  },
  {
    "codigo":342131000119106,
    "descripcion":"CANALICULITIS LAGRIMAL AGUDA DE REGIÓN DE OJO IZQUIERDO"
  },
  {
    "codigo":16065651000119107,
    "descripcion":"GANGRENA DE EXTREMIDAD INFERIOR IZQUIERDA DEBIDA A ATEROSCLEROSIS DE INJERTO-PUENTE AUTÓLOGO"
  },
  {
    "codigo":290931000119108,
    "descripcion":"MONOPLEJÍA DE MIEMBRO INFERIOR DEBIDA A ACCIDENTE CEREBROVASCULAR Y POSTERIOR A ÉL"
  },
  {
    "codigo":331891000119108,
    "descripcion":"SIMBLÉFARON DE OJO DERECHO"
  },
  {
    "codigo":134771000119108,
    "descripcion":"ALTERACIÓN SENSITIVA COMO EFECTO TARDÍO DE ACCIDENTE CEREBROVASCULAR"
  },
  {
    "codigo":151581811000119109,
    "descripcion":"PÓLIPO DE UNIÓN CARDIOESOFÁGICA"
  },
  {
    "codigo":488408691000119104,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DEBIDO A TROMBOSIS DE AMBAS ARTERIAS CEREBELOSAS"
  },
  {
    "codigo":24285001,
    "descripcion":"MELANOSIS DE RIEHL"
  },
  {
    "codigo":1081971000119109,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS INTRAEPIDÉRMICO DE MIEMBRO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":319091000119107,
    "descripcion":"ARTRITIS REUMATOIDEA SERONEGATIVA DE ARTICULACIÓN DE TOBILLO DERECHO"
  },
  {
    "codigo":16674931000119109,
    "descripcion":"FRACTURA EXPUESTA DE PISO DE ÓRBITA IZQUIERDA"
  },
  {
    "codigo":286429003,
    "descripcion":"CAPAZ DE ABASTECER A OTROS"
  },
  {
    "codigo":16091251000119109,
    "descripcion":"ANGIOSARCOMA PRIMARIO DE PIEL DE NARIZ"
  },
  {
    "codigo":89821007,
    "descripcion":"DISCONTINUIDAD DE LOS HUESECILLOS DEL OÍDO"
  },
  {
    "codigo":22450000,
    "descripcion":"HIPERFOSFATURIA"
  },
  {
    "codigo":188125009,
    "descripcion":"NEOPLASIA MALIGNA DE PIEL DE PULGAR"
  },
  {
    "codigo":16745531000119108,
    "descripcion":"RETINOPATÍA NO PROLIFERATIVA LEVE DE OJO IZQUIERDO DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":251826007,
    "descripcion":"VELLO AXILAR EN ESTADIO 2 DE TANNER"
  },
  {
    "codigo":315527003,
    "descripcion":"NACIDO EN SRI LANKA"
  },
  {
    "codigo":249991004,
    "descripcion":"BALANCEO POSTURAL AL PONERSE DE PIE"
  },
  {
    "codigo":335061000119105,
    "descripcion":"CICLITIS HETEROCRÓMICA DE FUCHS DE OJO DERECHO"
  },
  {
    "codigo":282759009,
    "descripcion":"LESIÓN DE REGIÓN POSTERIOR DE CUELLO"
  },
  {
    "codigo":870748006,
    "descripcion":"ALERGIA A DIHIDROERGOCRISTINA Y\/O DIHIDROERGOCORNINA Y\/O DIHIDROERGOCRIPTINA"
  },
  {
    "codigo":444764006,
    "descripcion":"ANTÍGENO CARBOHIDRATO 27-29 POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":706908007,
    "descripcion":"CIERTA DISGRESIÓN ALEJADA DEL OBJETIVO"
  },
  {
    "codigo":16037231000119101,
    "descripcion":"DETENCIÓN DE CRECIMIENTO EPIFISARIO DE AMBOS FÉMURES"
  },
  {
    "codigo":311857007,
    "descripcion":"FRACTURAS NO EXPUESTAS QUE COMPROMETEN REGIONES MÚLTIPLES DE EXTREMIDADES SUPERIORES E INFERIORES"
  },
  {
    "codigo":15110001,
    "descripcion":"CELULITIS DE CONDUCTO DEFERENTE"
  },
  {
    "codigo":1293062003,
    "descripcion":"RADIOGRAFÍA DE SENO NASAL ANORMAL"
  },
  {
    "codigo":703238004,
    "descripcion":"STREPTOCOCCUS ANGINOSUS O STREPTOCOCCUS DYSGALACTIAE SUBESPECIE DYSGALACTIAE"
  },
  {
    "codigo":441094005,
    "descripcion":"CÉLULAS ENDOCERVICALES ATÍPICAS EN EL EXTENDIDO CERVICAL DE PAPANICOLAOU"
  },
  {
    "codigo":242651001,
    "descripcion":"LESIÓN CAUSADA POR UN ANIMAL"
  },
  {
    "codigo":46043003,
    "descripcion":"FRACTURA DE OCHO O MÁS COSTILLAS"
  },
  {
    "codigo":308187004,
    "descripcion":"VENAS VARICOSAS DE VAGINA EN EL PUERPERIO"
  },
  {
    "codigo":111579006,
    "descripcion":"ANEMIA HEMOLÍTICA NO ESFEROCÍTICA HEREDITARIA POR DEFICIENCIA DE GLUTATIÓN SINTETASA"
  },
  {
    "codigo":208048002,
    "descripcion":"FRACTURA VERTEBRAL EXPUESTA CON LESIÓN COMPLETA DE MÉDULA ESPINAL DORSAL, D7-12"
  },
  {
    "codigo":76976005,
    "descripcion":"ATROFIA ÓPTICA"
  },
  {
    "codigo":404656008,
    "descripcion":"DRUSAS CALCIFICADAS DE LA PAPILA ÓPTICA"
  },
  {
    "codigo":238981002,
    "descripcion":"TRASTORNO DE PARTES BLANDAS DEBIDO A DIABETES MELLITUS"
  },
  {
    "codigo":370053002,
    "descripcion":"INVASIÓN TUMORAL EN TEJIDOS ADYACENTES"
  },
  {
    "codigo":75141003,
    "descripcion":"ARTERIA RETINIANA EN HILO DE COBRE"
  },
  {
    "codigo":42373003,
    "descripcion":"INTOXICACIÓN POR HIOSCINA"
  },
  {
    "codigo":402821006,
    "descripcion":"MILARIA CRISTALINA INFANTIL"
  },
  {
    "codigo":206213006,
    "descripcion":"FRACTURA DE FÉMUR DEBIDA A TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":1254789003,
    "descripcion":"CARCINOMA ESCAMOSO DE CÉLULAS CLARAS DE TRÁQUEA"
  },
  {
    "codigo":271749004,
    "descripcion":"AUMENTO AGUDO DE LA FIEBRE"
  },
  {
    "codigo":1285722006,
    "descripcion":"FRACTURA DE EXTREMO DISTAL DE CÚBITO IZQUIERDO"
  },
  {
    "codigo":400986007,
    "descripcion":"NECESITA AYUDA PARA COCINAR"
  },
  {
    "codigo":204378009,
    "descripcion":"ANEURISMA CORONARIO CONGÉNITO"
  },
  {
    "codigo":169775003,
    "descripcion":"ATENCIÓN POSNATAL POSTERIOR A LAS 48 HORAS DESPUÉS DEL NACIMIENTO"
  },
  {
    "codigo":399151004,
    "descripcion":"LATIDO CARDÍACO AUSENTE"
  },
  {
    "codigo":366383006,
    "descripcion":"AMPLITUD DE MOVIMIENTO PASIVO DE FLEXIÓN DE LA COLUMNA CERVICAL - HALLAZGO"
  },
  {
    "codigo":5935008,
    "descripcion":"UTILIZA ANTICONCEPCIÓN ORAL"
  },
  {
    "codigo":36868002,
    "descripcion":"BIORRITMO ANORMAL"
  },
  {
    "codigo":167940002,
    "descripcion":"MEGACARIOCITOS EN MÉDULA ÓSEA, AUMENTADOS"
  },
  {
    "codigo":200708003,
    "descripcion":"IMPÉTIGO FOLICULAR"
  },
  {
    "codigo":724996005,
    "descripcion":"PLEXOPATÍA LUMBOSACRA DEBIDA A VASCULITIS"
  },
  {
    "codigo":299012008,
    "descripcion":"AMPLITUD DE PRONACIÓN PASIVA DE LA MUÑECA DISMINUIDA"
  },
  {
    "codigo":297177003,
    "descripcion":"PÓLIPO DE ESTOMA"
  },
  {
    "codigo":723161003,
    "descripcion":"MONOPLEJÍA FLÁCCIDA DE MIEMBRO INFERIOR"
  },
  {
    "codigo":1149145003,
    "descripcion":"INTOXICACIÓN CAUSADA POR CORTICOSTEROIDE Y\/O DERIVADO DE CORTICOSTEROIDE"
  },
  {
    "codigo":35033008,
    "descripcion":"INFECCIÓN CAUSADA POR ANGIOSTRONGYLUS CANTONENSIS"
  },
  {
    "codigo":67801009,
    "descripcion":"TENOSINOVITIS"
  },
  {
    "codigo":360878001,
    "descripcion":"DEFICIENCIA DE NUCLEOSIDASA DE INOSINA"
  },
  {
    "codigo":65966004,
    "descripcion":"FRACTURA DE ANTEBRAZO"
  },
  {
    "codigo":262574004,
    "descripcion":"HERIDA DE BALA"
  },
  {
    "codigo":459182005,
    "descripcion":"ANEURISMA DE PARCHE DE TRACTO DE SALIDA DE VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":721326008,
    "descripcion":"FRACTURA DE ÁNGULO DE LA MANDÍBULA"
  },
  {
    "codigo":129667001,
    "descripcion":"NEURITIS PERIFÉRICA POR DIFTERIA"
  },
  {
    "codigo":295342009,
    "descripcion":"SOBREDOSIS DE REGALIZ"
  },
  {
    "codigo":1074851000119104,
    "descripcion":"ARTRITIS DE ARTICULACIÓN DE RODILLA IZQUIERDA"
  },
  {
    "codigo":1145475006,
    "descripcion":"HIPOPLASIA DE FALANGE DISTAL DE DEDO MEDIO DE MANO"
  },
  {
    "codigo":293507007,
    "descripcion":"REACCIÓN ADVERSA AL ENALAPRIL"
  },
  {
    "codigo":162435009,
    "descripcion":"EL SÍNTOMA COMENZÓ HACE MINUTOS"
  },
  {
    "codigo":226136002,
    "descripcion":"DIETA MODIFICADA CON ALCOHOL"
  },
  {
    "codigo":1340248002,
    "descripcion":"LESIÓN TRAUMÁTICA DE REGIÓN DE COLUMNA VERTEBRAL COCCÍGEA"
  },
  {
    "codigo":95064007,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA PIEL DEL PIE"
  },
  {
    "codigo":715821000,
    "descripcion":"LISENCEFALIA CONCOMITANTE CON HIPOPLASIA CONGÉNITA DE CEREBELO, TIPO D"
  },
  {
    "codigo":10823331000119107,
    "descripcion":"FRACTURA EXPUESTA DE FALANGE MEDIA DE DEDO MEÑIQUE IZQUIERDO"
  },
  {
    "codigo":289837004,
    "descripcion":"OVARIO PEQUEÑO"
  },
  {
    "codigo":93229007,
    "descripcion":"MELANOMA MALIGNO DE LA PIEL DE LA FRENTE"
  },
  {
    "codigo":224301007,
    "descripcion":"RECIBIÓ EDUCACIÓN POLITÉCNICA"
  },
  {
    "codigo":419074008,
    "descripcion":"DISTROFIA CENTRAL MOTEADA DE FRANÇOIS"
  },
  {
    "codigo":25858008,
    "descripcion":"LIQUEN PLANO ATRÓFICO"
  },
  {
    "codigo":124162009,
    "descripcion":"DEFICIENCIA DE OXOGLUTARATO DESHIDROGENASA (LIPOAMIDA)"
  },
  {
    "codigo":286167007,
    "descripcion":"INCAPAZ DE LIMPIAR EL INODORO"
  },
  {
    "codigo":253399009,
    "descripcion":"VÁLVULA MITRAL CABALGANTE"
  },
  {
    "codigo":251564002,
    "descripcion":"PÉRDIDA DE LA RESPUESTA H"
  },
  {
    "codigo":218796003,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR PSILOCIBINA"
  },
  {
    "codigo":284332004,
    "descripcion":"COLOCA UN OBJETO DENTRO DE OTRO"
  },
  {
    "codigo":118657002,
    "descripcion":"TRASTORNO DE EPIDÍDIMO"
  },
  {
    "codigo":282497005,
    "descripcion":"DIFICULTAD PARA CORRER PENDIENTE ABAJO"
  },
  {
    "codigo":1003393006,
    "descripcion":"DELECIÓN DE PORCIÓN MEDIA DE CROMOSOMA 14"
  },
  {
    "codigo":247894000,
    "descripcion":"AUTOEXALTACIÓN"
  },
  {
    "codigo":446337009,
    "descripcion":"INTOXICACIÓN POR PERÓXIDO DE HIDRÓGENO"
  },
  {
    "codigo":51286002,
    "descripcion":"QUERATITIS FILAMENTOSA"
  },
  {
    "codigo":1263702003,
    "descripcion":"TRASTORNO NEONATAL PRECOZ DEBIDO A ANOMALÍA DE PARTES BLANDAS MATERNAS"
  },
  {
    "codigo":737579002,
    "descripcion":"COLOBOMA CONGÉNITO DE MÁCULA LÚTEA"
  },
  {
    "codigo":770347003,
    "descripcion":"TRANSICIÓN FUERA DEL SISTEMA DE CUIDADOS DE JÓVENES EN HOGARES SUSTITUTOS"
  },
  {
    "codigo":38871000119104,
    "descripcion":"COLECISTITIS CRÓNICA REAGUDIZADA CONCOMITANTE CON CÁLCULO DE VESÍCULA Y CONDUCTO BILIAR Y DEBIDA A ÉL"
  },
  {
    "codigo":14848000,
    "descripcion":"REACCIÓN AUTOINMUNITARIA"
  },
  {
    "codigo":80384002,
    "descripcion":"EPIGLOTITIS"
  },
  {
    "codigo":309760004,
    "descripcion":"CALCIFICACIÓN METASTÁSICA"
  },
  {
    "codigo":702976005,
    "descripcion":"RETRODISCITIS DE ARTICULACIÓN TEMPOROMANDIBULAR"
  },
  {
    "codigo":1260032004,
    "descripcion":"ADENOCARCINOMA DE CÉLULAS CLARAS DE PULMÓN"
  },
  {
    "codigo":111317000,
    "descripcion":"AUSENCIA CONGÉNITA DE LA NARIZ"
  },
  {
    "codigo":45781009,
    "descripcion":"SÍNDROME DE COMPRESIÓN DE NERVIO PERIFÉRICO"
  },
  {
    "codigo":209621009,
    "descripcion":"DESGARRO COMPLETO DE LIGAMENTO DE LA CADERA"
  },
  {
    "codigo":699306003,
    "descripcion":"SÍNDROME DE DELECIÓN CROMOSÓMICA 1P36"
  },
  {
    "codigo":11178005,
    "descripcion":"SECRECIÓN ANORMAL DE GLUCAGÓN"
  },
  {
    "codigo":240554006,
    "descripcion":"TRÍADA DE HUTCHINSON"
  },
  {
    "codigo":109482009,
    "descripcion":"HIPOPLASIA GENERALIZADA DE ESMALTE DENTAL ASOCIADA CON RADIOTERAPIA"
  },
  {
    "codigo":369791003,
    "descripcion":"ESCALA COMBINADA DE NOTTINGHAM, GRADO II: 6-7 PUNTOS"
  },
  {
    "codigo":304255004,
    "descripcion":"RÍE ESPONTÁNEAMENTE"
  },
  {
    "codigo":107647005,
    "descripcion":"HALLAZGO EN EL PESO"
  },
  {
    "codigo":238719003,
    "descripcion":"DISTROFIA DE LAS VEINTE UÑAS"
  },
  {
    "codigo":402559007,
    "descripcion":"MELANOMA MALIGNO CONGÉNITO"
  },
  {
    "codigo":105812000,
    "descripcion":"HALLAZGO RELACIONADO CON EL TIPO DE SUSTANCIA"
  },
  {
    "codigo":9343003,
    "descripcion":"NACIMIENTO DE TÉRMINO DE RECIÉN NACIDO DE SEXO FEMENINO"
  },
  {
    "codigo":40276003,
    "descripcion":"EMBOLIA DE ARTERIA CEREBRAL ANTERIOR"
  },
  {
    "codigo":1187156006,
    "descripcion":"PERIODONTITIS EXACERBADA POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":169513000,
    "descripcion":"UTILIZA COITUS INTERRUPTUS"
  },
  {
    "codigo":366121000,
    "descripcion":"HALLAZGO EN UN REFLEJO PRIMITIVO"
  },
  {
    "codigo":340081000119107,
    "descripcion":"GRANULOMA DE SACO LAGRIMAL IZQUIERDO"
  },
  {
    "codigo":202281000,
    "descripcion":"CONTRACTURA EN FLEXIÓN DE ARTICULACIÓN INTERFALÁNGICA PROXIMAL DE DEDO DE LA MANO"
  },
  {
    "codigo":300585004,
    "descripcion":"CONSISTENCIAS SÓLIDAS"
  },
  {
    "codigo":890409000,
    "descripcion":"LUXACIÓN CONGÉNITA BILATERAL DE HOMBROS"
  },
  {
    "codigo":235049008,
    "descripcion":"LIQUEN PLANO BUCAL"
  },
  {
    "codigo":298750003,
    "descripcion":"HALLAZGO RELACIONADO CON LA SENSIBILIDAD DEL MIEMBRO SUPERIOR"
  },
  {
    "codigo":167678003,
    "descripcion":"SUSTANCIAS REDUCTORAS DETECTADAS EN MATERIA FECAL"
  },
  {
    "codigo":724734004,
    "descripcion":"TRASTORNO DE OPOSICIÓN DESAFIANTE CONCOMITANTE CON IRRITABILIDAD CRÓNICA-ENOJO CON EMOCIONES PROSOCIALES NORMALES"
  },
  {
    "codigo":397054004,
    "descripcion":"EXCENTROCITOSIS"
  },
  {
    "codigo":165843000,
    "descripcion":"PRUEBA DE AGLUTINACIÓN HETERÓFILA: NORMAL"
  },
  {
    "codigo":395219004,
    "descripcion":"DEBILIDAD VISUAL PERCEPTIVA"
  },
  {
    "codigo":296915007,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE TIROXINA"
  },
  {
    "codigo":168000,
    "descripcion":"TIFLOLITIASIS"
  },
  {
    "codigo":1148883008,
    "descripcion":"TRASTORNO DE LOS GLOMÉRULOS DEBIDO A TRASTORNO DE COAGULACIÓN"
  },
  {
    "codigo":65704008,
    "descripcion":"ANOMALÍA CONGÉNITA DE LA VULVA"
  },
  {
    "codigo":719229001,
    "descripcion":"PÉRDIDA DE GRASA SUBCUTÁNEA QUE RECUBRE A MÚSCULO TRÍCEPS"
  },
  {
    "codigo":262312009,
    "descripcion":"SIN EL PISO DE LA BOCA DEPRIMIDO"
  },
  {
    "codigo":162173004,
    "descripcion":"ACTIVIDAD SEXUAL - DOS O TRES VECES POR SEMANA"
  },
  {
    "codigo":293245007,
    "descripcion":"REACCIÓN ADVERSA AL ESTRADIOL ORAL"
  },
  {
    "codigo":1145213009,
    "descripcion":"NEURITIS DEBIDA A DESPLAZAMIENTO DE DISCO INTERVERTEBRAL"
  },
  {
    "codigo":94802004,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA COMISURA LABIAL"
  },
  {
    "codigo":60199004,
    "descripcion":"INTOXICACIÓN POR METADONA"
  },
  {
    "codigo":92967005,
    "descripcion":"AUSENCIA CONGÉNITA DEL TUBÉRCULO GENITAL"
  },
  {
    "codigo":715559004,
    "descripcion":"DEFICIENCIA COMBINADA DE FACTORES V Y VIII"
  },
  {
    "codigo":1010471007,
    "descripcion":"ESCLEROSIS DE EPÍFISIS DE FALANGE DISTAL DE DEDO ANULAR CON RADIOPACIDAD AUMENTADA"
  },
  {
    "codigo":25596000,
    "descripcion":"IDENTIFICACIÓN PRESUNTIVA DE UN CUERPO POR SUS OBJETOS PERSONALES"
  },
  {
    "codigo":289575009,
    "descripcion":"TAPÓN MUCOSO NO ELIMINADO"
  },
  {
    "codigo":27431007,
    "descripcion":"CAMBIOS FIBROQUÍSTICOS DE MAMA"
  },
  {
    "codigo":713724000,
    "descripcion":"HERNIA ABDOMINAL COMO COMPLICACIÓN DE DIÁLISIS PERITONEAL"
  },
  {
    "codigo":254972008,
    "descripcion":"NEOPLASIA MALIGNA DE NERVIO ÓPTICO Y SU VAINA"
  },
  {
    "codigo":123900008,
    "descripcion":"INTOXICACIÓN POR CUCURBITACEAE"
  },
  {
    "codigo":449745003,
    "descripcion":"LECHO DE HERIDA, FIBRINOSO"
  },
  {
    "codigo":23761004,
    "descripcion":"HIPOESPLENISMO"
  },
  {
    "codigo":253137003,
    "descripcion":"HOLOPROSENCEFALIA ALOBULAR"
  },
  {
    "codigo":56529007,
    "descripcion":"ENCEFALITIS ADENOVIRAL"
  },
  {
    "codigo":285905007,
    "descripcion":"CAPAZ DE UTILIZAR ESTUFA ELÉCTRICA"
  },
  {
    "codigo":54694004,
    "descripcion":"CIEGO MÓVIL"
  },
  {
    "codigo":21926007,
    "descripcion":"PELO ANILLADO"
  },
  {
    "codigo":249467000,
    "descripcion":"SANGRADO DE LARINGE"
  },
  {
    "codigo":282235003,
    "descripcion":"INCAPAZ DE CAMINAR CARGANDO UN JUGUETE GRANDE"
  },
  {
    "codigo":413307004,
    "descripcion":"PROBLEMA DE SALUD MENTAL"
  },
  {
    "codigo":342591000119104,
    "descripcion":"LUPUS ERITEMATOSO DISCOIDE DE PÁRPADO SUPERIOR DERECHO"
  },
  {
    "codigo":1363579009,
    "descripcion":"HIPEROSTOSIS CORTICAL DISPLÁSICA"
  },
  {
    "codigo":52859009,
    "descripcion":"QUISTE DE LA BOLSA DE RATHKE"
  },
  {
    "codigo":247632002,
    "descripcion":"PREOCUPACIÓN"
  },
  {
    "codigo":313168004,
    "descripcion":"INTIMIDADO EN LA ESCUELA"
  },
  {
    "codigo":18256001,
    "descripcion":"INTOXICACIÓN POR DICENTRA CANADENSIS"
  },
  {
    "codigo":409637001,
    "descripcion":"AUTOINOCULACIÓN ACCIDENTAL CON VIRUS VACCINIA POSTERIOR A CONTACTO CON SITIO DE VACUNACIÓN ANTIVARIÓLICA"
  },
  {
    "codigo":1079871000119107,
    "descripcion":"NEVO DISPLÁSICO DE PIEL DE MIEMBRO SUPERIOR DERECHO"
  },
  {
    "codigo":737317008,
    "descripcion":"PROCTITIS ALÉRGICA CAUSADA POR PROTEÍNA ALIMENTARIA EN LACTANTES"
  },
  {
    "codigo":442405009,
    "descripcion":"ÚLCERA DE ESTRUCTURA ANORRECTAL"
  },
  {
    "codigo":1259770001,
    "descripcion":"GLIOMA ANAPLÁSICO PRIMARIO DE ENCÉFALO"
  },
  {
    "codigo":702714007,
    "descripcion":"SIALOADENITIS CRÓNICA REAGUDIZADA"
  },
  {
    "codigo":735482009,
    "descripcion":"PROLAPSO COMPLETO DE CÚPULA VAGINAL"
  },
  {
    "codigo":405967002,
    "descripcion":"VENA RENAL NO INVOLUCRADA POR TUMOR RENAL"
  },
  {
    "codigo":45519004,
    "descripcion":"EFECTO TÓXICO DE LA ESTRICNINA"
  },
  {
    "codigo":242127007,
    "descripcion":"LESIÓN AL SUBIR O BAJAR DE AUTOMÓVIL"
  },
  {
    "codigo":209359007,
    "descripcion":"FRACTURA-LUXACIÓN NO EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA DE UN SOLO DEDO DEL PIE"
  },
  {
    "codigo":10916006,
    "descripcion":"INTOXICACIÓN POR PIRIMETAMINA"
  },
  {
    "codigo":305828008,
    "descripcion":"VISTO POR EL SERVICIO DE NEUROLOGÍA PEDIÁTRICA"
  },
  {
    "codigo":1287033001,
    "descripcion":"NEVO MELANOCÍTICO CONGÉNITO DE PIEL DE PÁRPADO INFERIOR"
  },
  {
    "codigo":369529006,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL OVARIO DERECHO"
  },
  {
    "codigo":11784921000119108,
    "descripcion":"AMPOLLA TRAUMÁTICA DE DEDO DE MANO IZQUIERDA"
  },
  {
    "codigo":236622000,
    "descripcion":"CISTITIS CRÓNICA INFECCIOSA"
  },
  {
    "codigo":402297008,
    "descripcion":"PITIRIASIS ALBA LOCALIZADA"
  },
  {
    "codigo":105550004,
    "descripcion":"EX CONSUMIDOR DE SOLVENTES VOLÁTILES"
  },
  {
    "codigo":365859003,
    "descripcion":"FUNCIONAMIENTO DE LA MEMORIA A CORTO PLAZO - HALLAZGO"
  },
  {
    "codigo":1119523003,
    "descripcion":"PRUEBA DE PERCEPCIÓN DE COLORES DE ISHIHARA ANORMAL"
  },
  {
    "codigo":300323005,
    "descripcion":"HÍGADO PALPABLE"
  },
  {
    "codigo":431395004,
    "descripcion":"SÍNDROME QUE INCLUYE ANOMALÍAS VERTEBRALES, ATRESIA ANAL, ANOMALÍAS CARDÍACAS, FÍSTULA TRAQUEOESOFÁGICA, ANOMALÍAS RENALES Y DEFECTOS DE LOS MIEMBROS"
  },
  {
    "codigo":298488000,
    "descripcion":"PRUEBA DE ESFUERZO DE LA COLUMNA CERVICAL POSITIVA"
  },
  {
    "codigo":724472005,
    "descripcion":"CISTOCELE CONCOMITANTE CON PROLAPSO UTEROVAGINAL INCOMPLETO"
  },
  {
    "codigo":296653000,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE AMPICILINA"
  },
  {
    "codigo":1279693001,
    "descripcion":"LUXACIÓN DE ARTICULACIÓN DE DEDO MEÑIQUE"
  },
  {
    "codigo":67277002,
    "descripcion":"ABSCESO URETRAL"
  },
  {
    "codigo":722637000,
    "descripcion":"LACERACIÓN DE CUELLO SIN CUERPO EXTRAÑO"
  },
  {
    "codigo":198349002,
    "descripcion":"ESTENOSIS ADQUIRIDA DE CUELLO DE ÚTERO"
  },
  {
    "codigo":294818008,
    "descripcion":"ALERGIA A GOSERELINA"
  },
  {
    "codigo":130978009,
    "descripcion":"REFLEJO CREMASTÉRICO DISMINUIDO"
  },
  {
    "codigo":1144951005,
    "descripcion":"ESOFAGITIS DEBIDA A SARCOIDOSIS"
  },
  {
    "codigo":63607006,
    "descripcion":"NEUMOMEDIASTINO PERINATAL"
  },
  {
    "codigo":61772003,
    "descripcion":"DEFICIENCIA DE FOSFOGLICERATO MUTASA MUSCULAR"
  },
  {
    "codigo":94540006,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE PIEL DE TOBILLO"
  },
  {
    "codigo":127308007,
    "descripcion":"HEMORRAGIA INTRACRANEAL POSTRAUMÁTICA CON PÉRDIDA DE LA CONSCIENCIA"
  },
  {
    "codigo":782668007,
    "descripcion":"NEOPLASIA BENIGNA DE GLÁNDULA SUPRARRENAL DERECHA"
  },
  {
    "codigo":345101000119107,
    "descripcion":"SÍNDROME DE MÚLTIPLES PUNTOS BLANCOS EVANESCENTES BILATERAL"
  },
  {
    "codigo":92705006,
    "descripcion":"CARCINOMA IN SITU DE LA ESCLERÓTICA"
  },
  {
    "codigo":289313008,
    "descripcion":"SIN CIRCULAR DE CORDÓN ALREDEDOR DEL CUELLO EN EL MOMENTO DEL PARTO"
  },
  {
    "codigo":191009009,
    "descripcion":"SÍNDROME DE HIPERINMUNOGLOBULINA E"
  },
  {
    "codigo":1336054003,
    "descripcion":"EPISODIO DE USO NOCIVO DE ALCOHOL"
  },
  {
    "codigo":25334004,
    "descripcion":"EDEMA SUBCONJUNTIVAL"
  },
  {
    "codigo":123638005,
    "descripcion":"DILATACIÓN DE CONDUCTO DE GLÁNDULA SUDORÍPARA"
  },
  {
    "codigo":254710004,
    "descripcion":"CARCINOMA DE CÉLULAS BASALES CON DIFERENCIACIÓN ECRINA"
  },
  {
    "codigo":1137611002,
    "descripcion":"LÍNEA CAPILAR ANORMAL"
  },
  {
    "codigo":56267009,
    "descripcion":"DEMENCIA MULTINFARTO"
  },
  {
    "codigo":1332384001,
    "descripcion":"SÍNDROME DE TRASTORNO DEL NEURODESARROLLO, DISCAPACIDAD INTELECTUAL SEVERA Y DISMORFIA FACIAL RELACIONADO CON CICLINA K"
  },
  {
    "codigo":283808006,
    "descripcion":"MORDEDURA DE ANIMAL EN LA MUÑECA"
  },
  {
    "codigo":21664006,
    "descripcion":"MENINGITIS CRÓNICA"
  },
  {
    "codigo":183669000,
    "descripcion":"DADO DE ALTA EN EL DÍA"
  },
  {
    "codigo":19829001,
    "descripcion":"TRASTORNO DE PULMÓN"
  },
  {
    "codigo":773493002,
    "descripcion":"SÍNDROME DE MICRODELECIÓN 9Q31.1Q31.3"
  },
  {
    "codigo":52597000,
    "descripcion":"ASPIRACIÓN DE COMPUESTO VEGETAL"
  },
  {
    "codigo":314741003,
    "descripcion":"HIPERSECRECIÓN OVÁRICA"
  },
  {
    "codigo":292161000119101,
    "descripcion":"PARÁLISIS DE NERVIO CIÁTICO POPLÍTEO EXTERNO DERECHO"
  },
  {
    "codigo":15637671000119107,
    "descripcion":"ESOTROPÍA ACOMODATIVA DE OJO IZQUIERDO"
  },
  {
    "codigo":249205008,
    "descripcion":"FRAGMENTOS DE PLACENTA EN EL ÚTERO"
  },
  {
    "codigo":247370006,
    "descripcion":"SÍNDROME DEL CUADRADO LUMBAR"
  },
  {
    "codigo":312906006,
    "descripcion":"RETINOPATÍA PROLIFERATIVA SIN ALTO RIESGO DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":704287008,
    "descripcion":"FRACTURA POR OSTEOPOROSIS SECUNDARIA DE FÉMUR PROXIMAL"
  },
  {
    "codigo":473076002,
    "descripcion":"INFECCIÓN ASOCIADA CON DISPOSITIVO ANTICONCEPTIVO INTRAUTERINO"
  },
  {
    "codigo":276468004,
    "descripcion":"QUEMADURA DE CIGARRILLO"
  },
  {
    "codigo":702452007,
    "descripcion":"NACIMIENTO CUÁDRUPLE"
  },
  {
    "codigo":209097000,
    "descripcion":"LUXACIÓN VERTEBRAL EXPUESTA CON LESIÓN MEDULAR COMPLETA A NIVEL LUMBAR"
  },
  {
    "codigo":241865004,
    "descripcion":"EFECTO TÓXICO CAUSADO POR TINTA"
  },
  {
    "codigo":403870000,
    "descripcion":"QUERATOSIS EN ESTUCO CON LESIONES MÚLTIPLES"
  },
  {
    "codigo":733385009,
    "descripcion":"LESIÓN TRAUMÁTICA PRIMARIA DE RECTO POR EXPLOSIÓN"
  },
  {
    "codigo":307401009,
    "descripcion":"INJERTO FEMORODISTAL INFECTADO"
  },
  {
    "codigo":372937009,
    "descripcion":"ARTRITIS SUPURATIVA BACTERIANA"
  },
  {
    "codigo":43422002,
    "descripcion":"LESIÓN TRAUMÁTICA DE PIE POR APLASTAMIENTO"
  },
  {
    "codigo":371102005,
    "descripcion":"DOLOR ABDOMINAL CÓLICO GENERALIZADO"
  },
  {
    "codigo":305566000,
    "descripcion":"BAJO ATENCIÓN DE ENFERMERA ESPECIALIZADA EN TERAPIA CONDUCTISTA"
  },
  {
    "codigo":240030009,
    "descripcion":"LAXITUD DE LOS LIGAMENTOS DEL PIE"
  },
  {
    "codigo":698782009,
    "descripcion":"MENINGITIS POSTRAUMÁTICA"
  },
  {
    "codigo":41587001,
    "descripcion":"TERCER TRIMESTRE DEL EMBARAZO"
  },
  {
    "codigo":762483004,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO PROFUNDA DE CADERA"
  },
  {
    "codigo":74355005,
    "descripcion":"LESIÓN TRAUMÁTICA DE ESTÓMAGO CON HERIDA ABIERTA HACIA CAVIDAD ABDOMINAL"
  },
  {
    "codigo":205427006,
    "descripcion":"HEMIVÉRTEBRA CERVICAL - ESTABLE"
  },
  {
    "codigo":270963009,
    "descripcion":"AUSENCIA CONGÉNITA DE PULGAR"
  },
  {
    "codigo":1155699009,
    "descripcion":"EMBOLIA DE AMBAS ARTERIAS VERTEBRALES"
  },
  {
    "codigo":170824004,
    "descripcion":"RETICULOCITOSIS LUEGO DE INYECCIONES DE VITAMINA B12"
  },
  {
    "codigo":269128006,
    "descripcion":"LUXACIÓN EXPUESTA ENTRE LA SEXTA Y LA SÉPTIMA VÉRTEBRAS CERVICALES"
  },
  {
    "codigo":400200009,
    "descripcion":"UÑA DE DEDO DEL PIE ENCARNADA"
  },
  {
    "codigo":5149003,
    "descripcion":"TEXTURA ANORMAL DEL PELO"
  },
  {
    "codigo":365597007,
    "descripcion":"HONGOS: SEROLOGÍA - HALLAZGO"
  },
  {
    "codigo":298226001,
    "descripcion":"AMPLITUD DE MOVIMIENTO ARTICULAR ACTIVO AUSENTE"
  },
  {
    "codigo":429298008,
    "descripcion":"ARTRITIS CLIMATÉRICA DE COLUMNA VERTEBRAL"
  },
  {
    "codigo":67015007,
    "descripcion":"MOTILIDAD ANORMAL DEL INTESTINO GRUESO"
  },
  {
    "codigo":722375007,
    "descripcion":"SÍNDROME DE BAMFORTH LAZARUS"
  },
  {
    "codigo":229020000,
    "descripcion":"PENETRACIÓN ANAL CON LENGUA"
  },
  {
    "codigo":296391008,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE CLONIDINA"
  },
  {
    "codigo":34247008,
    "descripcion":"ANEMIA POR DAÑO MECÁNICO"
  },
  {
    "codigo":294556004,
    "descripcion":"ALERGIA A CEFPIROMA"
  },
  {
    "codigo":1479009,
    "descripcion":"TRISOMÍA PARCIAL 20Q"
  },
  {
    "codigo":786076007,
    "descripcion":"EXCAVACIÓN CONGÉNITA DE PAPILA ÓPTICA"
  },
  {
    "codigo":718705001,
    "descripcion":"FUNCIONALMENTE DEPENDIENTE"
  },
  {
    "codigo":1144689002,
    "descripcion":"APLASIA DE FALANGE DE PIE"
  },
  {
    "codigo":817009003,
    "descripcion":"OJO DERECHO CON PERCEPCIÓN DE MOVIMIENTO DE LA MANO"
  },
  {
    "codigo":292721004,
    "descripcion":"REACCIÓN ADVERSA A LOS TERPENOS"
  },
  {
    "codigo":423793008,
    "descripcion":"CARCINOMA MUCOEPIDERMOIDE DE LA GLÁNDULA PARÓTIDA"
  },
  {
    "codigo":194417009,
    "descripcion":"PÉRDIDA DE LA AUDICIÓN CONDUCTIVA, BILATERAL"
  },
  {
    "codigo":321141000119109,
    "descripcion":"PIE HENDIDO DERECHO"
  },
  {
    "codigo":289051000,
    "descripcion":"NO UTILIZA CUCHILLO Y TENEDOR PARA ALIMENTARSE"
  },
  {
    "codigo":94278009,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL ENDOCARDIO"
  },
  {
    "codigo":715035002,
    "descripcion":"TOMA MEDICACIÓN"
  },
  {
    "codigo":290886009,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR VENLAFAXINA"
  },
  {
    "codigo":127046009,
    "descripcion":"RASGO DE CÉLULAS DREPANOCÍTICAS CON TALASEMIA - ALFA CONCOMITANTE"
  },
  {
    "codigo":92443005,
    "descripcion":"NEOPLASIA BENIGNA DE LA LENGUA"
  },
  {
    "codigo":1335792001,
    "descripcion":"ARTRITIS IDIOPÁTICA JUVENIL DE CADERA IZQUIERDA"
  },
  {
    "codigo":677801000119100,
    "descripcion":"ÉMBOLO RETINIANO DE COLESTEROL DE OJO IZQUIERDO"
  },
  {
    "codigo":254448008,
    "descripcion":"NEOPLASIA DE SURCO LABIAL"
  },
  {
    "codigo":1237488009,
    "descripcion":"METÁSTASIS DE CARCINOMA DE PALADAR"
  },
  {
    "codigo":449221001,
    "descripcion":"LINFOMA NO HODGKIN DIFUSO DE SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":88773005,
    "descripcion":"PERICOLITIS"
  },
  {
    "codigo":285381006,
    "descripcion":"EXACERBACIÓN INFECCIOSA AGUDA DE ENFERMEDAD PULMONAR OBSTRUCTIVA CRÓNICA"
  },
  {
    "codigo":711365007,
    "descripcion":"INMUNIZACIÓN DE ALTO RIESGO"
  },
  {
    "codigo":414618002,
    "descripcion":"INFESTACIÓN POR PIOJOS"
  },
  {
    "codigo":447386002,
    "descripcion":"INFECCIÓN DE VULVA CAUSADA POR CHLAMYDIA TRACHOMATIS"
  },
  {
    "codigo":185242005,
    "descripcion":"ATENDIDO EN CONSULTORIO ESPECIALIZADO DE ASMA"
  },
  {
    "codigo":283546006,
    "descripcion":"HERIDA DE PERDIGÓN EN CABEZA Y CUELLO"
  },
  {
    "codigo":17732003,
    "descripcion":"ECTIMA GANGRENOSO"
  },
  {
    "codigo":247108008,
    "descripcion":"HALLAZGO RELACIONADO CON VASO DE LA RETINA"
  },
  {
    "codigo":1162777000,
    "descripcion":"OBSTRUCCIÓN LITIÁSICA DE LA AMPOLLA DE VATER"
  },
  {
    "codigo":212505002,
    "descripcion":"INTOXICACIÓN POR TETRACICLINA"
  },
  {
    "codigo":441881007,
    "descripcion":"FRACTURA POR SOBRECARGA DEL SACRO"
  },
  {
    "codigo":276206000,
    "descripcion":"MICOSIS SUPERFICIAL"
  },
  {
    "codigo":472814001,
    "descripcion":"CIERRE ESPONTÁNEO DE FENESTRACIÓN CREADA QUIRÚRGICAMENTE DE TÚNEL AURICULAR DESPUÉS DE OPERACIÓN DE FENESTRACIÓN AURICULAR PREVIA"
  },
  {
    "codigo":704025009,
    "descripcion":"FRACTURA EXPUESTA DE BASE DE QUINTO METACARPIANO"
  },
  {
    "codigo":1259246004,
    "descripcion":"HEMORRAGIA DE ORIFICIO URETERAL"
  },
  {
    "codigo":700355004,
    "descripcion":"CONSENTIMIENTO OTORGADO PARA CONSULTA DE TELEMEDICINA"
  },
  {
    "codigo":307139007,
    "descripcion":"DESGARRO DEL LIGAMENTO ASTRAGALOPERONEO"
  },
  {
    "codigo":1290179007,
    "descripcion":"OSTEOMIELITIS DE CÚBITO"
  },
  {
    "codigo":10392004,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA AORTA ABDOMINAL"
  },
  {
    "codigo":239768006,
    "descripcion":"CUERPOS RICIFORMES EN LA RODILLA"
  },
  {
    "codigo":272536008,
    "descripcion":"DE PIE EN EL AGUA SOSTENIÉNDOSE DE LA BARANDILLA"
  },
  {
    "codigo":403608009,
    "descripcion":"ENFERMEDAD DEL SUERO POR FÁRMACO"
  },
  {
    "codigo":237933007,
    "descripcion":"DEFICIENCIA DE TRANSCOBALAMINA I"
  },
  {
    "codigo":303469007,
    "descripcion":"NO SE COLOCA PRÓTESIS"
  },
  {
    "codigo":203330001,
    "descripcion":"ENFERMEDAD DE PAGET-SACRO"
  },
  {
    "codigo":170562006,
    "descripcion":"ENFERMEDAD CRÓNICA - PACIENTE NO COOPERADOR"
  },
  {
    "codigo":1055298007,
    "descripcion":"GONARTROSIS DERECHA DEBIDA A LESIÓN TRAUMÁTICA Y POSTERIOR A ELLA"
  },
  {
    "codigo":236098008,
    "descripcion":"DEHISCENCIA DE ANASTOMOSIS GASTROINTESTINAL"
  },
  {
    "codigo":4887000,
    "descripcion":"TIROSINEMIA TIPO 2"
  },
  {
    "codigo":301634007,
    "descripcion":"NO UTILIZA ESCALERA MECÁNICA"
  },
  {
    "codigo":37655003,
    "descripcion":"EFECTO TARDÍO DE LA FRACTURA DE LOS HUESOS DEL CRÁNEO Y\/O DE LA CARA"
  },
  {
    "codigo":365335001,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA HACER LA CAMA"
  },
  {
    "codigo":299799009,
    "descripcion":"REFLEJO DE PRENSIÓN PALMAR AUSENTE"
  },
  {
    "codigo":363500001,
    "descripcion":"CÁNCERES MÚLTIPLES"
  },
  {
    "codigo":166892002,
    "descripcion":"GLUCEMIA MEDIDA AL AZAR POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":396268005,
    "descripcion":"HALLAZGO RELACIONADO CON EL MARGEN DE RESECCIÓN QUIRÚRGICA MUCOSO"
  },
  {
    "codigo":297964006,
    "descripcion":"MARCA DE MORDEDURA PASIONAL"
  },
  {
    "codigo":199660008,
    "descripcion":"RUPTURA PREMATURA DE MEMBRANAS, INICIO DEL TRABAJO DE PARTO DENTRO DE LAS 24 HORAS"
  },
  {
    "codigo":722113001,
    "descripcion":"SÍNDROME DE OSTEOPOROSIS E HIPOPIGMENTACIÓN OCULOCUTÁNEA"
  },
  {
    "codigo":232428009,
    "descripcion":"LARINGITIS MEMBRANOSA AGUDA"
  },
  {
    "codigo":230593004,
    "descripcion":"NEUROPATÍA ANÓXICA"
  },
  {
    "codigo":33985005,
    "descripcion":"HIPERORNITINEMIA"
  },
  {
    "codigo":10674551000119103,
    "descripcion":"QUISTE DE SENO ETMOIDAL"
  },
  {
    "codigo":1177195002,
    "descripcion":"UREMIA POSRENAL"
  },
  {
    "codigo":128619003,
    "descripcion":"TRASTORNO DE DEDO DE PIE"
  },
  {
    "codigo":1144427006,
    "descripcion":"ATROFIA DIFUSA DE CEREBRO"
  },
  {
    "codigo":95851007,
    "descripcion":"FRACTURA DE ÓRBITA"
  },
  {
    "codigo":292459008,
    "descripcion":"REACCIÓN ADVERSA A NIMODIPINO"
  },
  {
    "codigo":126784003,
    "descripcion":"NEOPLASIA DE CARA VENTRAL DE LENGUA"
  },
  {
    "codigo":421696004,
    "descripcion":"NEOPLASIA DE CÉLULAS T PRECURSORAS"
  },
  {
    "codigo":94016005,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA PIEL DEL MENTÓN"
  },
  {
    "codigo":290624007,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR CARMUSTINA"
  },
  {
    "codigo":92181006,
    "descripcion":"NEOPLASIA BENIGNA DEL LÓBULO SUPERIOR IZQUIERDO DEL PULMÓN"
  },
  {
    "codigo":288789006,
    "descripcion":"INCAPAZ DE COMENTAR EVENTOS"
  },
  {
    "codigo":286954005,
    "descripcion":"CARDITIS AGUDA\/SUBAGUDA"
  },
  {
    "codigo":24810006,
    "descripcion":"TUBERCULOSIS ORIFICIAL DE LA BOCA"
  },
  {
    "codigo":874943000,
    "descripcion":"LACERACIÓN DE TRONCO ENCEFÁLICO CON PÉRDIDA DE CONSCIENCIA"
  },
  {
    "codigo":1237226008,
    "descripcion":"SÍNDROME POR ISOTRETINOÍNA"
  },
  {
    "codigo":254186008,
    "descripcion":"EPIDERMÓLISIS DISTRÓFICA LOCALIZADA BULLOSA"
  },
  {
    "codigo":186815006,
    "descripcion":"ENFERMEDAD DE CHAGAS CON COMPROMISO DEL APARATO DIGESTIVO"
  },
  {
    "codigo":711103007,
    "descripcion":"INCONTINENCIA DE MELANINA LABIAL"
  },
  {
    "codigo":15727121000119105,
    "descripcion":"HIPERLAXITUD ARTICULAR DE AMBAS MUÑECAS"
  },
  {
    "codigo":283284004,
    "descripcion":"ASTILLA DE MADERA EN AXILA"
  },
  {
    "codigo":184980005,
    "descripcion":"INFORME DEL SOLICITANTE ENVIADO"
  },
  {
    "codigo":248681002,
    "descripcion":"SOPLO HOLOSISTÓLICO PARAESTERNAL IZQUIERDO"
  },
  {
    "codigo":52073004,
    "descripcion":"OLIGOMENORREA"
  },
  {
    "codigo":281449006,
    "descripcion":"AFLOJAMIENTO EN EL REEMPLAZO UNICONDÍLEO DE RODILLA"
  },
  {
    "codigo":1297257006,
    "descripcion":"CIERRE DE ÁNGULO AGUDO DE OJO IZQUIERDO DEBIDO A UVEÍTIS"
  },
  {
    "codigo":707433009,
    "descripcion":"LINFANGIOLEIOMIOMATOSIS DEBIDA A SÍNDROME DE ESCLEROSIS TUBEROSA"
  },
  {
    "codigo":312382002,
    "descripcion":"QUISTE DE VAINA TENDINOSA"
  },
  {
    "codigo":246846008,
    "descripcion":"PÁRPADOS PEGAJOSOS DEBIDO A SECRECIÓN DE LOS OJOS"
  },
  {
    "codigo":212243003,
    "descripcion":"LESIÓN DEL PLEXO CELÍACO"
  },
  {
    "codigo":37811000087101,
    "descripcion":"ENHYDROBACTER AEROSACCUS O MORAXELLA OSLOENSIS"
  },
  {
    "codigo":42931000087102,
    "descripcion":"QUEMADURA DE DEDO MEÑIQUE IZQUIERDO"
  },
  {
    "codigo":408851008,
    "descripcion":"RETINOPATÍA POR PREMATUREZ, ETAPA 5 - DESPRENDIMIENTO TOTAL DE RETINA"
  },
  {
    "codigo":439784005,
    "descripcion":"FÍSTULA ARTERIOVENOSA CONSTRUIDA QUIRÚRGICAMENTE"
  },
  {
    "codigo":210408006,
    "descripcion":"LESIÓN POR DESOLLAMIENTO DE PARED TORÁCICA"
  },
  {
    "codigo":112104007,
    "descripcion":"DOLOR LOCALIZADO"
  },
  {
    "codigo":110269000,
    "descripcion":"EFECTOS TARDÍOS DE ENCEFALITIS VIRAL"
  },
  {
    "codigo":1258984009,
    "descripcion":"SÍNDROME DE LESIÓN POSCARDÍACA"
  },
  {
    "codigo":79336007,
    "descripcion":"EOSINOFILIA FAMILIAR"
  },
  {
    "codigo":274109003,
    "descripcion":"CISTITIS AGUDA RECURRENTE"
  },
  {
    "codigo":863933008,
    "descripcion":"PERFORACIÓN DE ÚTERO DESPUÉS DE PROCEDIMIENTO"
  },
  {
    "codigo":1222546002,
    "descripcion":"PERIVASCULITIS RETINIANA"
  },
  {
    "codigo":763794005,
    "descripcion":"ENCEFALITIS LÍMBICA CON ANTICUERPOS CONTRA PROTEÍNA 1 INACTIVADA DE GLIOMA RICA EN LEUCINA"
  },
  {
    "codigo":403346007,
    "descripcion":"LESIÓN DEL TALLO DEL PELO POR LAVADOS CON CHAMPÚ"
  },
  {
    "codigo":237671001,
    "descripcion":"HIPERSECRECIÓN DE GONADOTROFINA"
  },
  {
    "codigo":42898009,
    "descripcion":"POLIARTRITIS AGUDA"
  },
  {
    "codigo":1153340000,
    "descripcion":"MIELOPATÍA DEBIDA A DEFICIENCIA DE FOLATO"
  },
  {
    "codigo":399676002,
    "descripcion":"NO SE PUEDE EVALUAR LA EXTENSIÓN DEL COMPROMISO POR LINFOMA DEL MARGEN DE RESECCIÓN QUIRÚRGICA"
  },
  {
    "codigo":235836004,
    "descripcion":"ÍLEO METABÓLICO"
  },
  {
    "codigo":203068005,
    "descripcion":"CONTRACTURA DEL MÚSCULO ADUCTOR DEL PULGAR"
  },
  {
    "codigo":301372005,
    "descripcion":"HALLAZGO RELACIONADO CON LA DIMENSIÓN AFECTIVA DEL DOLOR"
  },
  {
    "codigo":102929005,
    "descripcion":"ANDROFOBIA"
  },
  {
    "codigo":397841007,
    "descripcion":"BRADICARDIA MEDICAMENTOSA"
  },
  {
    "codigo":234001008,
    "descripcion":"DISECCIÓN DE ARTERIA TRASPLANTADA"
  },
  {
    "codigo":299537007,
    "descripcion":"AMPLITUD DE INVERSIÓN ACTIVA DE ARTICULACIÓN SUBASTRAGALINA DISMINUIDA"
  },
  {
    "codigo":1217041008,
    "descripcion":"MACROGENITOSOMÍA PRECOZ DEBIDA A TRASTORNO DE GLÁNDULA PINEAL"
  },
  {
    "codigo":365073008,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA RESPONDER A LA COMUNICACIÓN ESTABLECIDA POR OTROS"
  },
  {
    "codigo":199398004,
    "descripcion":"DESPROPORCIÓN - ANOMALÍA PÉLVICA SIGNIFICATIVA"
  },
  {
    "codigo":428774008,
    "descripcion":"RUPTURA DE MÚSCULO ADUCTOR DE LA CADERA"
  },
  {
    "codigo":66491001,
    "descripcion":"INTOXICACIÓN POR FLUCITOSINA"
  },
  {
    "codigo":263099004,
    "descripcion":"FRACTURA-SUBLUXACIÓN DE LA ARTICULACIÓN ACROMIOCLAVICULAR"
  },
  {
    "codigo":425104003,
    "descripcion":"CONDUCTA SUICIDA"
  },
  {
    "codigo":720016003,
    "descripcion":"DISFUNCIÓN SOMÁTICA DE REGIÓN PÉLVICA"
  },
  {
    "codigo":195728004,
    "descripcion":"BRONQUITIS AGUDA CAUSADA POR RINOVIRUS"
  },
  {
    "codigo":718181001,
    "descripcion":"DIVERTÍCULO CARDÍACO CONGÉNITO"
  },
  {
    "codigo":423269002,
    "descripcion":"ECOGRAFÍA PRENATAL NORMAL Y POSIBLEMENTE DISCREPANTE CON LA FECHA ESTIMADA DE PARTO"
  },
  {
    "codigo":292197004,
    "descripcion":"REACCIÓN ADVERSA A FÁRMACO ALQUILANTE"
  },
  {
    "codigo":193893005,
    "descripcion":"VASCULOPATÍAS Y QUISTES CONJUNTIVALES"
  },
  {
    "codigo":95589007,
    "descripcion":"ÚLCERAS DE LOS ÓRGANOS GENITALES MASCULINOS"
  },
  {
    "codigo":161125007,
    "descripcion":"EDUCACIÓN PARA ADULTOS"
  },
  {
    "codigo":783717008,
    "descripcion":"TRASTORNO CONGÉNITO DE LA GLICOSILACIÓN RELACIONADO CON FOSFOGLUCOMUTASA 1"
  },
  {
    "codigo":290362003,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR NIZATIDINA"
  },
  {
    "codigo":1142330004,
    "descripcion":"ATROFIA MUSCULAR ESPINAL SEGMENTARIA"
  },
  {
    "codigo":126522004,
    "descripcion":"NEOPLASIA DE LA PIEL DE LA MANO"
  },
  {
    "codigo":93754006,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA PARED TORÁCICA"
  },
  {
    "codigo":192058006,
    "descripcion":"REACCIÓN DE ADAPTACIÓN CON DESTRUCTIVIDAD"
  },
  {
    "codigo":10624121000119103,
    "descripcion":"MEIBOMIANITIS DE PÁRPADO SUPERIOR E INFERIOR IZQUIERDO"
  },
  {
    "codigo":91919002,
    "descripcion":"AUSENCIA CONGÉNITA DEL ANILLO TIMPÁNICO"
  },
  {
    "codigo":124687003,
    "descripcion":"DEFICIENCIA DE LIGASA"
  },
  {
    "codigo":712676000,
    "descripcion":"FLORA ANAERÓBICA NORMAL"
  },
  {
    "codigo":1204196002,
    "descripcion":"OCLUSIÓN AGUDA DE ARTERIA VISCERAL DEBIDA A TROMBOSIS"
  },
  {
    "codigo":253924002,
    "descripcion":"ACROSINDACTILIA DEL PULGAR"
  },
  {
    "codigo":24548005,
    "descripcion":"QUISTE DE LA VAGINA"
  },
  {
    "codigo":55481000,
    "descripcion":"TRASTORNO LÍMBICO"
  },
  {
    "codigo":1236964008,
    "descripcion":"METÁSTASIS DE CARCINOMA DE PALADAR BLANDO"
  },
  {
    "codigo":448697005,
    "descripcion":"EDAD DEL SUJETO POR DEBAJO DEL RANGO PARA LA INTERPRETACIÓN CONFIABLE DE LA EVALUACIÓN"
  },
  {
    "codigo":86414002,
    "descripcion":"CONTRACTURA DE ARTICULACIÓN DE LA MANO"
  },
  {
    "codigo":250254004,
    "descripcion":"ERITROCITOS NORMOCRÓMICOS"
  },
  {
    "codigo":1003918009,
    "descripcion":"SÍNDROME DE PFEIFFER TIPO 3"
  },
  {
    "codigo":84579002,
    "descripcion":"ENFERMEDAD VIRÓSICA DE LOS EVERGLADES"
  },
  {
    "codigo":445027003,
    "descripcion":"VENA CAVA SUPERIOR IZQUIERDA PERSISTENTE EN SENO CORONARIO"
  },
  {
    "codigo":1264227004,
    "descripcion":"INFECCIÓN PARASITARIA NEONATAL PRECOZ"
  },
  {
    "codigo":19043005,
    "descripcion":"FORÚNCULO DEL CUERO CABELLUDO"
  },
  {
    "codigo":182883007,
    "descripcion":"DOSIS DE MEDICAMENTO - CAMBIO DE HORARIO"
  },
  {
    "codigo":115512000,
    "descripcion":"PATRÓN DIFUSO DE BANDA DE ANTICUERPOS"
  },
  {
    "codigo":49976003,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN LA REGIÓN DEL DORSO, SIN INFECCIÓN"
  },
  {
    "codigo":1196856003,
    "descripcion":"MESOTELIOMA PLEURAL MALIGNO BIFÁSICO PRIMARIO"
  },
  {
    "codigo":441357007,
    "descripcion":"HALLAZGO RELACIONADO CON LA APTITUD PARA SER DONANTE"
  },
  {
    "codigo":111842002,
    "descripcion":"ENFERMEDAD DEL SALMÓN"
  },
  {
    "codigo":13538003,
    "descripcion":"FÍSTULA DE LABIO"
  },
  {
    "codigo":898274005,
    "descripcion":"ANQUILOSIS CONGÉNITA DE ARTICULACIÓN INTERFALÁNGICA DISTAL DE DEDO MEDIO"
  },
  {
    "codigo":734434007,
    "descripcion":"EPILEPSIA DEPENDIENTE DE PIRIDOXINA"
  },
  {
    "codigo":110007008,
    "descripcion":"LEUCEMIA\/LINFOMA DE LINFOCITOS T DEL ADULTO"
  },
  {
    "codigo":1287820006,
    "descripcion":"ENFERMEDAD RESPIRATORIA CRÓNICA QUE SE ORIGINA EN PERÍODO PERINATAL"
  },
  {
    "codigo":42636007,
    "descripcion":"FRACTURA NO EXPUESTA DE EXTREMO SUPERIOR DE HÚMERO"
  },
  {
    "codigo":763532008,
    "descripcion":"ACILIA NASAL FAMILIAR"
  },
  {
    "codigo":403084009,
    "descripcion":"TIÑA CAUSADA POR TRICHOPHYTON TONSURANS"
  },
  {
    "codigo":301110003,
    "descripcion":"VEGETACIONES DE VÁLVULA TRICÚSPIDE"
  },
  {
    "codigo":38966005,
    "descripcion":"QUEMADURA EPIDÉRMICA DEL CUELLO"
  },
  {
    "codigo":170038007,
    "descripcion":"TALLA DEL NIÑO ENTRE PERCENTILOS 50 Y 74"
  },
  {
    "codigo":233739001,
    "descripcion":"MEDIASTINITIS GRANULOMATOSA"
  },
  {
    "codigo":430347001,
    "descripcion":"DIVERTICULITIS DE CIEGO"
  },
  {
    "codigo":200971003,
    "descripcion":"PSORIASIS PLANTAR"
  },
  {
    "codigo":168203004,
    "descripcion":"ESPÉCIMEN SIN BACTERIAS AISLADAS"
  },
  {
    "codigo":37131007,
    "descripcion":"INTOXICACIÓN POR PLAGUICIDA"
  },
  {
    "codigo":364811008,
    "descripcion":"HALLAZGO EN LA CAPACIDAD DE NUTRICIÓN"
  },
  {
    "codigo":397579009,
    "descripcion":"HALLAZGO RELACIONADO CON DESENCADENANTE ASMÁTICO"
  },
  {
    "codigo":1149408002,
    "descripcion":"SOBREDOSIS DE INHIBIDOR DE LA MONOAMINO OXIDASA"
  },
  {
    "codigo":2528003,
    "descripcion":"VIREMIA"
  },
  {
    "codigo":299275008,
    "descripcion":"AMPLITUD DE ADUCCIÓN ACTIVA DE LA CADERA AUMENTADA"
  },
  {
    "codigo":231904004,
    "descripcion":"QUERATOCONJUNTIVITIS DIFUSA DE ESTROMA"
  },
  {
    "codigo":428512002,
    "descripcion":"MÚLTIPLES FRACTURAS INESTABLES POR CIZALLAMIENTO, VERTICALES, NO EXPUESTAS DE PELVIS"
  },
  {
    "codigo":721589000,
    "descripcion":"INFECCIÓN TRANSMISIBLE SEXUALMENTE CAUSADA POR MOLUSCO CONTAGIOSO"
  },
  {
    "codigo":788960009,
    "descripcion":"TUBERCULOSIS DE PLACENTA"
  },
  {
    "codigo":787125004,
    "descripcion":"TRASTORNO LINFOPROLIFERATIVO GERMINOTRÓFICO CAUSADO POR VIRUS DEL HERPES HUMANO 8"
  },
  {
    "codigo":361141006,
    "descripcion":"ÚLCERAS MÚLTIPLES IDIOPÁTICAS DE INTESTINO DELGADO"
  },
  {
    "codigo":33461007,
    "descripcion":"COMPLICACIÓN DE LA DIÁLISIS PERITONEAL"
  },
  {
    "codigo":197301006,
    "descripcion":"CIRROSIS PORTAL TÓXICA"
  },
  {
    "codigo":262837008,
    "descripcion":"PERFORACIÓN TARDÍA DEL ESTÓMAGO"
  },
  {
    "codigo":719754002,
    "descripcion":"UTILIZA SÍMBOLOS PARA LA COMUNICACIÓN"
  },
  {
    "codigo":295605007,
    "descripcion":"SOBREDOSIS INTENCIONAL DE BUSULFANO"
  },
  {
    "codigo":293770006,
    "descripcion":"ALERGIA A ÓXIDO MERCÚRICO"
  },
  {
    "codigo":717919005,
    "descripcion":"TUMOR NEUROENDOCRINO DE PÁNCREAS BIEN DIFERENCIADO"
  },
  {
    "codigo":160863005,
    "descripcion":"ARRESTO DE NOVIA"
  },
  {
    "codigo":128095007,
    "descripcion":"TRASTORNO DE LA FUNCIÓN PLAQUETARIA ADQUIRIDO"
  },
  {
    "codigo":95327008,
    "descripcion":"DERMATITIS TÓXICA"
  },
  {
    "codigo":687841000119105,
    "descripcion":"RABDOMIOSARCOMA PRIMARIO DE REGIÓN INGUINAL"
  },
  {
    "codigo":110952161000119106,
    "descripcion":"ENDOMETRIOSIS DE NERVIO CIÁTICO"
  },
  {
    "codigo":27956007,
    "descripcion":"INTOXICACIÓN POR COCAÍNA"
  },
  {
    "codigo":288265000,
    "descripcion":"NACIDO DESPUÉS DE PARTO PRECIPITADO"
  },
  {
    "codigo":1240372009,
    "descripcion":"METÁSTASIS DE CARCINOMA DE GLÁNDULA DE MEIBOMIO"
  },
  {
    "codigo":26121002,
    "descripcion":"NEFROPATÍA DE LOS BALCANES"
  },
  {
    "codigo":1142068008,
    "descripcion":"TAQUICARDIA RECIPROCANTE AURICULOVENTRICULAR ANTIDRÓMICA QUE UTILIZA VÍA ACCESORIA CON CONDUCCIÓN UNIDIRECCIONAL ANTERÓGRADA"
  },
  {
    "codigo":714249007,
    "descripcion":"GINGIVITIS LEVE"
  },
  {
    "codigo":417502005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CURVA DE LA PRESIÓN DE ENCLAVAMIENTO DE LA ARTERIA PULMONAR"
  },
  {
    "codigo":57054005,
    "descripcion":"INFARTO AGUDO DE MIOCARDIO"
  },
  {
    "codigo":286430008,
    "descripcion":"INCAPAZ DE ABASTECER A OTROS"
  },
  {
    "codigo":22451001,
    "descripcion":"DISTONÍA DE TORSIÓN IDIOPÁTICA"
  },
  {
    "codigo":251827003,
    "descripcion":"VELLO AXILAR EN ESTADIO 3 DE TANNER"
  },
  {
    "codigo":153421000119100,
    "descripcion":"POLICITEMIA VERA EN REMISIÓN"
  },
  {
    "codigo":284925261000119101,
    "descripcion":"ENDOMETRIOSIS PROFUNDA DE APÉNDICE"
  },
  {
    "codigo":145741000119101,
    "descripcion":"APRAXIA COMO EFECTO TARDÍO DE ENFERMEDAD CEREBROVASCULAR"
  },
  {
    "codigo":11857741000119103,
    "descripcion":"RUPTURA TRAUMÁTICA DE TENDÓN DE MÚSCULO PERONEO DERECHO"
  },
  {
    "codigo":330061000119104,
    "descripcion":"AGRANDAMIENTO DE VENTRÍCULO CEREBRAL ADQUIRIDO"
  },
  {
    "codigo":1075021000119104,
    "descripcion":"GOTA TOFÁCEA CRÓNICA DE PIE IZQUIERDO"
  },
  {
    "codigo":11850061000119101,
    "descripcion":"AMPOLLA DE MAMA IZQUIERDA, CON INFECCIÓN"
  },
  {
    "codigo":15928141000119107,
    "descripcion":"ALTERACIÓN COGNITIVA CONCOMITANTE CON INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA Y DEBIDA A ELLA"
  },
  {
    "codigo":1085261000119108,
    "descripcion":"OBSTRUCCIÓN INTESTINAL DEBIDA A RECTOSIGMOIDITIS ULCEROSA CRÓNICA"
  },
  {
    "codigo":282760004,
    "descripcion":"LESIÓN TRAUMÁTICA DE CLAVÍCULA"
  },
  {
    "codigo":249992006,
    "descripcion":"INESTABLE AL GIRAR"
  },
  {
    "codigo":340301000119102,
    "descripcion":"QUERATITIS INTERSTICIAL DE OJO IZQUIERDO"
  },
  {
    "codigo":446600008,
    "descripcion":"LACERACIÓN DE TENDÓN DE PULGAR"
  },
  {
    "codigo":10849101000119104,
    "descripcion":"CUERPO EXTRAÑO DE SACO CONJUNTIVAL DE OJO IZQUIERDO"
  },
  {
    "codigo":1082701000119105,
    "descripcion":"HEMORRAGIA DUODENAL DEBIDA A ANGIODISPLASIA DE DUODENO"
  },
  {
    "codigo":870749003,
    "descripcion":"DERMATITIS ALÉRGICA POR CONTACTO CAUSADA POR ÁCIDO ÚSNICO"
  },
  {
    "codigo":1092941000119109,
    "descripcion":"HEMORRAGIA GÁSTRICA DEBIDA A GASTRITIS VIRAL"
  },
  {
    "codigo":11857941000119100,
    "descripcion":"RUPTURA TRAUMÁTICA DE TENDÓN ROTULIANO IZQUIERDO"
  },
  {
    "codigo":1231197006,
    "descripcion":"PARÁLISIS DE MIRADA ASCENDENTE"
  },
  {
    "codigo":10901371000119107,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO FACIAL IZQUIERDO"
  },
  {
    "codigo":248157008,
    "descripcion":"MANOS SUCIAS"
  },
  {
    "codigo":49714001,
    "descripcion":"ANOMALÍA CONGÉNITA DE LA VESÍCULA BILIAR"
  },
  {
    "codigo":15953941000119101,
    "descripcion":"INDURACIÓN DE MAMA IZQUIERDA"
  },
  {
    "codigo":444765007,
    "descripcion":"ARTRITIS CAUSADA POR STREPTOCOCCUS SUIS"
  },
  {
    "codigo":770610006,
    "descripcion":"LESIÓN POR QUEMADURA DE DEDO DE LA MANO"
  },
  {
    "codigo":15111002,
    "descripcion":"CÉLULA DE PELGER - HUËT"
  },
  {
    "codigo":211719003,
    "descripcion":"CORROSIÓN DE TERCER GRADO DE LA CABEZA Y EL CUELLO"
  },
  {
    "codigo":703239007,
    "descripcion":"CORYNEBACTERIUM AFERMENTANS O CORYNEBACTERIUM COYLEAE"
  },
  {
    "codigo":275420003,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DE LABIOS VULVARES"
  },
  {
    "codigo":78812008,
    "descripcion":"DESHIDRATACIÓN NEONATAL"
  },
  {
    "codigo":10684591000119101,
    "descripcion":"NÓDULO DEL TEJIDO CELULAR SUBCUTÁNEO DE LA PIERNA DERECHA"
  },
  {
    "codigo":109745004,
    "descripcion":"FRACASO DE LA ESPIGA DENTAL"
  },
  {
    "codigo":11441004,
    "descripcion":"PROSTATISMO"
  },
  {
    "codigo":206214000,
    "descripcion":"FRACTURA DE TIBIA Y\/O PERONÉ POR TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":240817009,
    "descripcion":"HIDÁTIDE POLIQUÍSTICO"
  },
  {
    "codigo":402822004,
    "descripcion":"MILARIA ROJA INFANTIL"
  },
  {
    "codigo":307221000119109,
    "descripcion":"ARTRITIS ENTEROPÁTICA DE RODILLA DERECHA"
  },
  {
    "codigo":271750004,
    "descripcion":"AUMENTO GRADUAL DE LA FIEBRE"
  },
  {
    "codigo":1254790007,
    "descripcion":"CARCINOMA ESCAMOSO BASALOIDE DE TRÁQUEA"
  },
  {
    "codigo":370054008,
    "descripcion":"INVASIÓN TUMORAL POR EXTENSIÓN DIRECTA A OTRAS ESTRUCTURAS"
  },
  {
    "codigo":73307001,
    "descripcion":"SIGNO DE MCBURNEY"
  },
  {
    "codigo":40539002,
    "descripcion":"HIPOTIROIDISMO SECUNDARIO A TERAPIA CON YODO RADIACTIVO"
  },
  {
    "codigo":1285723001,
    "descripcion":"SÍNDROME COMPARTIMENTAL DE ANTEBRAZO"
  },
  {
    "codigo":238982009,
    "descripcion":"DERMOPATÍA DIABÉTICA"
  },
  {
    "codigo":204379001,
    "descripcion":"ESTENOSIS CONGÉNITA DE ARTERIA CORONARIA"
  },
  {
    "codigo":232101009,
    "descripcion":"ESOTROPÍA ACOMODATIVA PURA"
  },
  {
    "codigo":366384000,
    "descripcion":"HALLAZGO RELACIONADO CON LA AMPLITUD DE LA EXTENSIÓN DE LA COLUMNA CERVICAL"
  },
  {
    "codigo":38704001,
    "descripcion":"EFECTO TÓXICO DE GAS DE ÁCIDO CIANHÍDRICO"
  },
  {
    "codigo":16009391000119105,
    "descripcion":"ATEROEMBOLIA DE ARTERIA DE MIEMBRO SUPERIOR DERECHO"
  },
  {
    "codigo":300848003,
    "descripcion":"TUMORACIÓN DE ESTRUCTURA CORPORAL"
  },
  {
    "codigo":12241071000119106,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE MAMA DERECHA"
  },
  {
    "codigo":167941003,
    "descripcion":"MEGACARIOCITOS EN MÉDULA ÓSEA, DISMINUIDOS"
  },
  {
    "codigo":299013003,
    "descripcion":"SIN AMPLITUD PASIVA DE PRONACIÓN DE MUÑECA"
  },
  {
    "codigo":67802002,
    "descripcion":"PRESENTACIÓN FETAL ANÓMALA DISTINTA A LA PÉLVICA, CONVERTIDA EXITOSAMENTE EN PRESENTACIÓN CEFÁLICA"
  },
  {
    "codigo":1149146002,
    "descripcion":"INTOXICACIÓN CAUSADA POR DESOXICORTONA"
  },
  {
    "codigo":723162005,
    "descripcion":"MONOPLEJÍA ESPÁSTICA DE MIEMBRO INFERIOR"
  },
  {
    "codigo":198874006,
    "descripcion":"INTENTO FALLIDO DE ABORTO REALIZADO CON MÉTODOS NO QUIRÚRGICOS, COMPLICADO POR INFECCIÓN DEL TRACTO GENITAL Y PÉLVICA"
  },
  {
    "codigo":15737161000119103,
    "descripcion":"OPACIFICACIÓN DE AMBAS CÁPSULAS POSTERIORES QUE NO OBSTACULIZA LA VISIÓN"
  },
  {
    "codigo":297178008,
    "descripcion":"SEROMA MAMARIO"
  },
  {
    "codigo":459183000,
    "descripcion":"ANEURISMA DE PARCHE DE TRACTO DE SALIDA DEL VENTRÍCULO DERECHO"
  },
  {
    "codigo":262575003,
    "descripcion":"HERIDA DE ESCOPETA"
  },
  {
    "codigo":721327004,
    "descripcion":"FRACTURA DE SÍNFISIS DE LA MANDÍBULA"
  },
  {
    "codigo":295343004,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE REGALIZ"
  },
  {
    "codigo":431005,
    "descripcion":"HIPERTROFIA DEL ESCROTO"
  },
  {
    "codigo":65967008,
    "descripcion":"ABSCESO DE FLANCO"
  },
  {
    "codigo":293508002,
    "descripcion":"REACCIÓN ADVERSA AL FOSINOPRIL"
  },
  {
    "codigo":162436005,
    "descripcion":"EL SÍNTOMA COMENZÓ HACE HORAS"
  },
  {
    "codigo":129668006,
    "descripcion":"ÚLCERA CAUSADA POR TREPONEMA VINCENTII"
  },
  {
    "codigo":1145476007,
    "descripcion":"HIPOPLASIA DE FALANGE DISTAL DE DEDO ANULAR"
  },
  {
    "codigo":424580008,
    "descripcion":"VÓMITO POSTUSÍGENO"
  },
  {
    "codigo":1073481000119106,
    "descripcion":"ARTRITIS INFECCIOSA DE CADERA IZQUIERDA"
  },
  {
    "codigo":226137006,
    "descripcion":"DIETA RESTRINGIDA EN ALCOHOL"
  },
  {
    "codigo":95065008,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA PIEL DEL ANTEBRAZO"
  },
  {
    "codigo":291673009,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR DIIODOHIDROXIQUINOLEÍNA"
  },
  {
    "codigo":93230002,
    "descripcion":"MELANOMA MALIGNO DE PIEL DE INGLE"
  },
  {
    "codigo":420910002,
    "descripcion":"INFECCIÓN ANAL Y RECTAL POR CHLAMYDIA TRACHOMATIS"
  },
  {
    "codigo":224302000,
    "descripcion":"RECIBIÓ EDUCACIÓN SUPERIOR UNIVERSITARIA"
  },
  {
    "codigo":715822007,
    "descripcion":"LISENCEFALIA CONCOMITANTE CON HIPOPLASIA CONGÉNITA DE CEREBELO, TIPO F"
  },
  {
    "codigo":25859000,
    "descripcion":"DEGENERACIÓN DEL MARGEN PUPILAR"
  },
  {
    "codigo":289838009,
    "descripcion":"HALLAZGO RELACIONADO CON LA DISPOSICIÓN DE LOS OVARIOS"
  },
  {
    "codigo":124163004,
    "descripcion":"DEFICIENCIA DE DIHIDROURACILO DESHIDROGENASA (NAD^+^)"
  },
  {
    "codigo":1172739005,
    "descripcion":"ANTÍGENO CARCINOEMBRIONARIO DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":253400002,
    "descripcion":"VÁLVULA MITRAL ANORMAL"
  },
  {
    "codigo":286168002,
    "descripcion":"LIMPIA EL INODORO"
  },
  {
    "codigo":1003394000,
    "descripcion":"DELECIÓN DE PORCIÓN MEDIA DEL BRAZO LARGO DE CROMOSOMA 2"
  },
  {
    "codigo":284333009,
    "descripcion":"DIFICULTAD PARA INSERTAR UN OBJETO DENTRO DE OTRO"
  },
  {
    "codigo":446338004,
    "descripcion":"INTOXICACIÓN POR COMPUESTO CON MANGANESO"
  },
  {
    "codigo":118658007,
    "descripcion":"TRASTORNO DEL CORDÓN ESPERMÁTICO"
  },
  {
    "codigo":444503000,
    "descripcion":"ZONA VERDE EN LA ESTIMACIÓN DE PESO PEDIÁTRICO DE BROSELOW LUTEN"
  },
  {
    "codigo":247895004,
    "descripcion":"ALARDE"
  },
  {
    "codigo":1362007008,
    "descripcion":"TUBERCULOSIS RESPIRATORIA POR RECAÍDA"
  },
  {
    "codigo":442668000,
    "descripcion":"HEMIPLEJÍA DE LADO NO DOMINANTE COMO EFECTO TARDÍO DE ENFERMEDAD CEREBROVASCULAR"
  },
  {
    "codigo":213292003,
    "descripcion":"REACCIÓN AGUDA A SUSTANCIA EXTRAÑA DEJADA DURANTE PROCEDIMIENTO"
  },
  {
    "codigo":737580004,
    "descripcion":"VESTIBULOPATÍA IDIOPÁTICA BILATERAL"
  },
  {
    "codigo":702977001,
    "descripcion":"LINFOMA FOLICULAR NO HODGKIN DIFUSO, SUBTIPO DE CÉLULAS CENTRALES GRADO 2"
  },
  {
    "codigo":735745004,
    "descripcion":"TRAUMATISMO OBSTÉTRICO DE HUESO LARGO"
  },
  {
    "codigo":276993008,
    "descripcion":"HALLAZGO RELACIONADO CON EL POTENCIAL EVOCADO"
  },
  {
    "codigo":1260033009,
    "descripcion":"ADENOCARCINOMA DE CÉLULAS CLARAS DE TRÁQUEA"
  },
  {
    "codigo":209622002,
    "descripcion":"DESGARRO COMPLETO DE LIGAMENTO ILIOFEMORAL"
  },
  {
    "codigo":111318005,
    "descripcion":"MALFORMACIÓN ADENOMATOIDE QUÍSTICA CONGÉNITA DEL PULMÓN"
  },
  {
    "codigo":1075991000119103,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE TENDÓN EXTENSOR DE PIE DERECHO"
  },
  {
    "codigo":11179002,
    "descripcion":"GLUCOGENOSIS TIPO IV"
  },
  {
    "codigo":371627004,
    "descripcion":"ANGIOEDEMA AGRAVADO POR INHIBIDOR DE LA ENZIMA CONVERTIDORA DE ANGIOTENSINA"
  },
  {
    "codigo":109483004,
    "descripcion":"HIPOPLASIA GENERALIZADA DEL ESMALTE ASOCIADA CON LA INGESTA DE DROGAS"
  },
  {
    "codigo":699307007,
    "descripcion":"SÍNDROME DE DELECIÓN CROMOSÓMICA 16P11.2"
  },
  {
    "codigo":107648000,
    "descripcion":"HALLAZGO EN LA TRANSLUCIDEZ"
  },
  {
    "codigo":207787008,
    "descripcion":"FRACTURA DE PISO DE ÓRBITA"
  },
  {
    "codigo":76715008,
    "descripcion":"ENFERMEDAD DE ADDISON POR AUTOINMUNIDAD"
  },
  {
    "codigo":240555007,
    "descripcion":"SÍFILIS ADQUIRIDA"
  },
  {
    "codigo":402560002,
    "descripcion":"MELANOMA MALIGNO METASTÁSICO MATERNOFETAL"
  },
  {
    "codigo":369792005,
    "descripcion":"ESCALA COMBINADA DE NOTTINGHAM, GRADO III: 8-9 PUNTOS"
  },
  {
    "codigo":11781041000119100,
    "descripcion":"AMPOLLA TRAUMÁTICA DE CODO IZQUIERDO"
  },
  {
    "codigo":271488001,
    "descripcion":"ENFERMEDAD INFLAMATORIA PÉLVICA POR MICOPLASMA"
  },
  {
    "codigo":433493000,
    "descripcion":"DISTONÍA DE TORSIÓN ADQUIRIDA"
  },
  {
    "codigo":42112009,
    "descripcion":"INCONTINENCIA URINARIA DE ORIGEN NO ORGÁNICO"
  },
  {
    "codigo":9344009,
    "descripcion":"FRACTURA EXPUESTA DEL EXTREMO SUPERIOR DE TIBIA Y PERONÉ"
  },
  {
    "codigo":40277007,
    "descripcion":"DELIRIO SISTEMATIZADO"
  },
  {
    "codigo":300586003,
    "descripcion":"CONSISTENCIAS LÍQUIDAS"
  },
  {
    "codigo":890410005,
    "descripcion":"LUXACIÓN ARTICULAR CONGÉNITA"
  },
  {
    "codigo":366122007,
    "descripcion":"HALLAZGO RELACIONADO CON MOVIMIENTO DE TRÁQUEA"
  },
  {
    "codigo":235050008,
    "descripcion":"REACCIÓN LIQUENOIDE BUCAL"
  },
  {
    "codigo":202282007,
    "descripcion":"CONTRACTURA EN FLEXIÓN DE ARTICULACIÓN INTERFALÁNGICA DISTAL DE DEDO DE LA MANO"
  },
  {
    "codigo":724735003,
    "descripcion":"TRASTORNO DE OPOSICIÓN DESAFIANTE SIN IRRITABILIDAD CRÓNICA-ENOJO"
  },
  {
    "codigo":298751004,
    "descripcion":"DOLOR A LA PALPACIÓN EN EL MIEMBRO SUPERIOR"
  },
  {
    "codigo":269459004,
    "descripcion":"NEOPLASIA MALIGNA DE CURVATURA MENOR DE ESTÓMAGO"
  },
  {
    "codigo":36607007,
    "descripcion":"EQUINOSTOMIASIS"
  },
  {
    "codigo":15713201000119105,
    "descripcion":"INFARTO AGUDO DE MIOCARDIO DE PARED POSTEROBASAL CON ELEVACIÓN DEL SEGMENTO ST"
  },
  {
    "codigo":1148884002,
    "descripcion":"GLOMERULOPATÍA DEBIDA A DEFICIENCIA DEL SISTEMA DEL COMPLEMENTO"
  },
  {
    "codigo":2004005,
    "descripcion":"PRESIÓN ARTERIAL NORMAL"
  },
  {
    "codigo":165844006,
    "descripcion":"PRUEBA DE AGLUTINACIÓN HETERÓFILA: ANORMAL"
  },
  {
    "codigo":395220005,
    "descripcion":"HIPERTROFIA DE GLÁNDULA SEBÁCEA"
  },
  {
    "codigo":722900008,
    "descripcion":"PARÁLISIS DE ERB DUCHENNE CON NEUROPRAXIA DEBIDA A TRAUMATISMO OBSTÉTRICO POR TRACCIÓN"
  },
  {
    "codigo":296916008,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE TIROXINA"
  },
  {
    "codigo":32937002,
    "descripcion":"CRISIS"
  },
  {
    "codigo":11862961000119106,
    "descripcion":"ABRASIÓN DE PIEL DE DEDOS SEGUNDO A QUINTO DE PIE IZQUIERDO"
  },
  {
    "codigo":65705009,
    "descripcion":"QUISTE PORENCEFÁLICO"
  },
  {
    "codigo":63870005,
    "descripcion":"ABSCESO DE OMBLIGO"
  },
  {
    "codigo":162174005,
    "descripcion":"ACTIVIDAD SEXUAL - SEMANALMENTE"
  },
  {
    "codigo":194942007,
    "descripcion":"MIOCARDITIS AGUDA ASOCIADA CON OTRO TRASTORNO"
  },
  {
    "codigo":225875000,
    "descripcion":"PENSAMIENTOS SOBRE LA MUERTE"
  },
  {
    "codigo":293246008,
    "descripcion":"REACCIÓN ADVERSA AL IMPLANTE DE ESTRADIOL"
  },
  {
    "codigo":422483008,
    "descripcion":"PATRÓN DE DESCANSO QUE ALTERA LA VIDA FAMILIAR"
  },
  {
    "codigo":92968000,
    "descripcion":"AUSENCIA CONGÉNITA DE GÓNADAS"
  },
  {
    "codigo":94803009,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL COLÉDOCO"
  },
  {
    "codigo":289576005,
    "descripcion":"LOQUIOS PRESENTES"
  },
  {
    "codigo":420648005,
    "descripcion":"FILTRACIÓN DE CATÉTER URINARIO"
  },
  {
    "codigo":11810021000119100,
    "descripcion":"ABRASIÓN DE PIEL DE PIERNA IZQUIERDA"
  },
  {
    "codigo":16889061000119100,
    "descripcion":"ESTENOSIS CONGÉNITA DE AMBOS CONDUCTOS AUDITIVOS EXTERNOS"
  },
  {
    "codigo":715560009,
    "descripcion":"ALETEO AURICULAR NEONATAL IDIOPÁTICO"
  },
  {
    "codigo":254973003,
    "descripcion":"ASTROCITOMA MALIGNO DEL NERVIO ÓPTICO"
  },
  {
    "codigo":713725004,
    "descripcion":"ALERGIA A NEVIRAPINA"
  },
  {
    "codigo":123901007,
    "descripcion":"INTOXICACIÓN POR CUPRESSACEAE"
  },
  {
    "codigo":449746002,
    "descripcion":"ESCARA DE HERIDA"
  },
  {
    "codigo":56530002,
    "descripcion":"OPACIDAD CENTRAL DE LA CÓRNEA"
  },
  {
    "codigo":89298004,
    "descripcion":"INTOXICACIÓN POR PIMELEA"
  },
  {
    "codigo":253138008,
    "descripcion":"HOLOPROSENCEFALIA SEMILOBULAR"
  },
  {
    "codigo":285906008,
    "descripcion":"INCAPAZ DE UTILIZAR ESTUFA ELÉCTRICA"
  },
  {
    "codigo":185767007,
    "descripcion":"INCUMPLIMIENTO DEL SEGUIMIENTO GERIÁTRICO"
  },
  {
    "codigo":446076000,
    "descripcion":"TUMOR DE ESTROMA EXTRAGASTROINTESTINAL DE PERITONEO"
  },
  {
    "codigo":282236002,
    "descripcion":"CAMINA LLEVANDO UN JUGUETE GRANDE"
  },
  {
    "codigo":1363580007,
    "descripcion":"MOVIMIENTOS FETALES PERCIBIDOS POR LA MADRE"
  },
  {
    "codigo":216700007,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR INSECTICIDAS DE COMPUESTOS ORGANOFOSFORADOS"
  },
  {
    "codigo":247633007,
    "descripcion":"PREOCUPACIÓN CON COMPENSACIÓN"
  },
  {
    "codigo":737318003,
    "descripcion":"HEMORRAGIA TARDÍA DEBIDA A ABORTO ESPONTÁNEO Y POSTERIOR A ÉL"
  },
  {
    "codigo":341221000119109,
    "descripcion":"PANNUS CORNEAL DE OJO IZQUIERDO"
  },
  {
    "codigo":442406005,
    "descripcion":"DEPENDENCIA DE ESTIMULANTES"
  },
  {
    "codigo":1259771002,
    "descripcion":"TUMOR MALIGNO MIXTO PRIMARIO DE GLÁNDULA SALIVAL"
  },
  {
    "codigo":735483004,
    "descripcion":"INCONTINENCIA DE ESFUERZO CONCOMITANTE CON PROLAPSO DE ÓRGANO PÉLVICO Y DEBIDA A ÉL"
  },
  {
    "codigo":702715008,
    "descripcion":"PROSTATITIS CRÓNICA REAGUDIZADA"
  },
  {
    "codigo":209360002,
    "descripcion":"FRACTURA-LUXACIÓN NO EXPUESTA, MÚLTIPLES ARTICULACIONES METATARSOFALÁNGICAS"
  },
  {
    "codigo":405968007,
    "descripcion":"FASCIA DE GEROTA NO AFECTADA POR TUMOR RENAL"
  },
  {
    "codigo":305829000,
    "descripcion":"VISTO POR EL SERVICIO DE ONCOLOGÍA PEDIÁTRICA"
  },
  {
    "codigo":699045001,
    "descripcion":"FRACTURA NO EXPUESTA DE SENO FRONTAL"
  },
  {
    "codigo":404133000,
    "descripcion":"LINFOMA SUBCUTÁNEO PANICULÍTICO DE CÉLULAS T"
  },
  {
    "codigo":830117003,
    "descripcion":"DISTENSIÓN DE VENAS DE PARED ABDOMINAL LATERAL"
  },
  {
    "codigo":15689241000119101,
    "descripcion":"ARTRITIS DE AMBOS TOBILLOS CAUSADA POR STREPTOCOCCUS PNEUMONIAE"
  },
  {
    "codigo":369530001,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL OVARIO DERECHO"
  },
  {
    "codigo":402298003,
    "descripcion":"PITIRIASIS ALBA DIFUSA"
  },
  {
    "codigo":238458007,
    "descripcion":"DERMATOSIS POR FRICCIÓN"
  },
  {
    "codigo":236623005,
    "descripcion":"CISTITIS NO INFECCIOSA"
  },
  {
    "codigo":72783005,
    "descripcion":"INFECCIÓN CAUSADA POR STRONGYLOIDES FULLEBORNI"
  },
  {
    "codigo":431396003,
    "descripcion":"CARCINOMA DE MAMA NEGATIVO PARA FACTOR DE CRECIMIENTO EPIDÉRMICO HUMANO 2"
  },
  {
    "codigo":300324004,
    "descripcion":"HALLAZGO RELACIONADO CON LA APARIENCIA DEL HÍGADO"
  },
  {
    "codigo":343731000119100,
    "descripcion":"RETINOPATÍA POR PREMATUREZ ETAPA 5, BILATERAL"
  },
  {
    "codigo":3577000,
    "descripcion":"DEGENERACIÓN RETINIANA EN ENCAJE"
  },
  {
    "codigo":890148009,
    "descripcion":"DERMATITIS POR CONTACTO CAUSADA POR URUSHIOL"
  },
  {
    "codigo":1119524009,
    "descripcion":"FIJACIÓN VISUAL ANORMAL"
  },
  {
    "codigo":724473000,
    "descripcion":"RECTOCELE CONCOMITANTE CON PROLAPSO UTEROVAGINAL INCOMPLETO"
  },
  {
    "codigo":298489008,
    "descripcion":"PRUEBA DE ESFUERZO DE LA COLUMNA CERVICAL NEGATIVA"
  },
  {
    "codigo":429561008,
    "descripcion":"HIPOTENSIÓN INDUCIDA POR ESFUERZO"
  },
  {
    "codigo":1081011000119102,
    "descripcion":"MELANOMA MALIGNO DE RETINA DE OJO DERECHO"
  },
  {
    "codigo":722638005,
    "descripcion":"LACERACIÓN DE CUELLO CON CUERPO EXTRAÑO"
  },
  {
    "codigo":165582006,
    "descripcion":"RAZÓN INTERNACIONAL NORMALIZADA EN RANGO DE REFERENCIA"
  },
  {
    "codigo":1742007,
    "descripcion":"HIPEREROTISMO FEMENINO"
  },
  {
    "codigo":1179555000,
    "descripcion":"PÉRDIDA DE AUDICIÓN NEUROSENSORIAL FETAL"
  },
  {
    "codigo":130979001,
    "descripcion":"ALTERACIÓN DEL ESTADO DE COMODIDAD"
  },
  {
    "codigo":294819000,
    "descripcion":"ALERGIA A TRIPTORELINA"
  },
  {
    "codigo":67278007,
    "descripcion":"ESTENOSIS CONGÉNITA DE VÁLVULA PULMONAR"
  },
  {
    "codigo":65443008,
    "descripcion":"NEFROPATÍA HIPERTENSIVA MALIGNA"
  },
  {
    "codigo":129144002,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA FARINGE POR APLASTAMIENTO"
  },
  {
    "codigo":1144952003,
    "descripcion":"DISFUNCIÓN ERÉCTIL DEBIDA A LESIÓN TRAUMÁTICA"
  },
  {
    "codigo":424056003,
    "descripcion":"DIFICULTAD PARA REALIZAR LA RUTINA HABITUAL DEBIDO AL USO DE SUSTANCIAS"
  },
  {
    "codigo":225613002,
    "descripcion":"CONSCIENCIA SEXUAL AUMENTADA"
  },
  {
    "codigo":127309004,
    "descripcion":"HEMORRAGIA INTRACRANEAL POSTRAUMÁTICA CON PÉRDIDA BREVE DE LA CONSCIENCIA"
  },
  {
    "codigo":782669004,
    "descripcion":"SÍNDROME DE MICRODUPLICACIÓN 10Q22.3Q23.3"
  },
  {
    "codigo":192845009,
    "descripcion":"ENCEFALOPATÍA MIOCLÓNICA"
  },
  {
    "codigo":1010210002,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE EXTREMIDAD INFERIOR IZQUIERDA"
  },
  {
    "codigo":191010004,
    "descripcion":"INMUNODEFICIENCIA COMÚN VARIABLE"
  },
  {
    "codigo":92706007,
    "descripcion":"CARCINOMA IN SITU DE ESCROTO"
  },
  {
    "codigo":254711000,
    "descripcion":"CARCINOMA ECRINO ADENOIDE QUÍSTICO DE PIEL"
  },
  {
    "codigo":1336055002,
    "descripcion":"EPISODIO DE USO NOCIVO DE ANFETAMINA Y\/O DERIVADO DE ANFETAMINA"
  },
  {
    "codigo":123639002,
    "descripcion":"CIERRE DEL PORO DE LAS GLÁNDULAS SUDORÍPARAS"
  },
  {
    "codigo":25335003,
    "descripcion":"FÍSTULA GASTROYEYUNOCOLÓNICA"
  },
  {
    "codigo":58103005,
    "descripcion":"FÍSTULA PERIANAL"
  },
  {
    "codigo":56268004,
    "descripcion":"HEMORRAGIA FETAL EN GEMELOS UNIDOS"
  },
  {
    "codigo":416716007,
    "descripcion":"PRUEBA DE HEAF GRADO 1-2"
  },
  {
    "codigo":1332385000,
    "descripcion":"SÍNDROME DE ANEMIA APLÁSICA, DISCAPACIDAD INTELECTUAL, ENANISMO"
  },
  {
    "codigo":1137612009,
    "descripcion":"LÍNEA CAPILAR POSTERIOR ANORMAL"
  },
  {
    "codigo":283809003,
    "descripcion":"MORDEDURA DE ANIMAL EN LA MANO"
  },
  {
    "codigo":447649007,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE VAGINA"
  },
  {
    "codigo":16019431000119102,
    "descripcion":"ATEROSCLEROSIS DE INJERTO-PUENTE DE EXTREMIDAD SUPERIOR DERECHA"
  },
  {
    "codigo":85366002,
    "descripcion":"QUISTE EN EL CUERPO CILIAR"
  },
  {
    "codigo":183670004,
    "descripcion":"DADO DE ALTA DE HOSPITAL PRIVADO"
  },
  {
    "codigo":773494008,
    "descripcion":"SÍNDROME DE MICRODELECIÓN 14Q24.1Q24.3"
  },
  {
    "codigo":249206009,
    "descripcion":"FRAGMENTOS DE PLACENTA EN EL ORIFICIO CERVICAL"
  },
  {
    "codigo":1197643000,
    "descripcion":"EQUIPAMIENTO INADECUADO PARA EXTINCIÓN DE FUEGO EN EL HOGAR"
  },
  {
    "codigo":83531001,
    "descripcion":"TRASTORNO ÓSEO DE LA FUNCIÓN DE SOPORTE DE PESO"
  },
  {
    "codigo":312907002,
    "descripcion":"RETINOPATÍA PROLIFERATIVA DE ALTO RIESGO DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":704288003,
    "descripcion":"FRACTURA POR OSTEOPOROSIS SECUNDARIA DE MANO"
  },
  {
    "codigo":442144009,
    "descripcion":"METAL PESADO EN ESPÉCIMEN TISULAR POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1259509002,
    "descripcion":"CARCINOMA INDIFERENCIADO PRIMARIO DE NASOFARINGE"
  },
  {
    "codigo":702453002,
    "descripcion":"NACIMIENTO QUÍNTUPLE"
  },
  {
    "codigo":473077006,
    "descripcion":"ALERGIA A TERIPARATIDA"
  },
  {
    "codigo":307402002,
    "descripcion":"INJERTO AXILOFEMORAL INFECTADO"
  },
  {
    "codigo":241866003,
    "descripcion":"EFECTO TÓXICO CAUSADO POR TONALIZADOR DE FOTOCOPIADORA"
  },
  {
    "codigo":372938004,
    "descripcion":"ARTRITIS SUPURATIVA AGUDA CAUSADA POR BACTERIAS"
  },
  {
    "codigo":209098005,
    "descripcion":"LUXACIÓN VERTEBRAL EXPUESTA CON LESIÓN MEDULAR ANTERIOR A NIVEL LUMBAR"
  },
  {
    "codigo":733386005,
    "descripcion":"LESIÓN TRAUMÁTICA DE ÓRGANO URINARIO"
  },
  {
    "codigo":897226007,
    "descripcion":"CURVATURA ANORMAL DE FALANGE DISTAL DE SEGUNDO DEDO DE PIE"
  },
  {
    "codigo":371103000,
    "descripcion":"EPIGLOTITIS GRANULOMATOSA"
  },
  {
    "codigo":403871001,
    "descripcion":"CUERNO CUTÁNEO"
  },
  {
    "codigo":1083521000119104,
    "descripcion":"DERMATITIS DE AMBOS CONDUCTOS AUDITIVOS EXTERNOS"
  },
  {
    "codigo":698783004,
    "descripcion":"SÍNDROME MEDULAR ANTERIOR DEBIDO A LESIÓN TRAUMÁTICA A NIVEL DE VÉRTEBRAS DORSALES 7 A 12"
  },
  {
    "codigo":240031008,
    "descripcion":"LESIÓN DE LA CÁPSULA ARTICULAR DE LA REGIÓN DEL PIE"
  },
  {
    "codigo":15911041000119105,
    "descripcion":"RETINOPATÍA DE OJO IZQUIERDO CAUSADA POR TAMOXIFENO"
  },
  {
    "codigo":205428001,
    "descripcion":"HEMIVÉRTEBRA CERVICAL - INESTABLE"
  },
  {
    "codigo":305567009,
    "descripcion":"BAJO ATENCIÓN DE ENFERMERA ESPECIALIZADA EN PSICOTERAPIA"
  },
  {
    "codigo":762484005,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO PROFUNDA DE MIEMBRO INFERIOR"
  },
  {
    "codigo":15665281000119106,
    "descripcion":"OPACIDAD CONGÉNITA BILATERAL DE VÍTREO OCULAR"
  },
  {
    "codigo":269129003,
    "descripcion":"LUXACIÓN NO EXPUESTA DEL SACRO"
  },
  {
    "codigo":170825003,
    "descripcion":"DEFICIENCIA DE VITAMINA B12 - CRITERIOS DIAGNÓSTICOS DUDOSOS"
  },
  {
    "codigo":400201008,
    "descripcion":"PITIRIASIS CAPITIS"
  },
  {
    "codigo":365598002,
    "descripcion":"TÍTULO DE ANTICUERPOS CONTRA PARÁSITOS - HALLAZGO"
  },
  {
    "codigo":346241000119109,
    "descripcion":"COROIDITIS DISEMINADA DE AMBOS OJOS"
  },
  {
    "codigo":234526006,
    "descripcion":"SARCOIDOSIS OCULAR"
  },
  {
    "codigo":298227005,
    "descripcion":"AMPLITUD DE MOVIMIENTO ARTICULAR PASIVO AUSENTE"
  },
  {
    "codigo":36083008,
    "descripcion":"SÍNDROME DE DISFUNCIÓN SINUSAL"
  },
  {
    "codigo":722376008,
    "descripcion":"SÍNDROME DE PTERIGIÓN POPLITEO AUTOSÓMICO RECESIVO"
  },
  {
    "codigo":229021001,
    "descripcion":"PENETRACIÓN ANAL CON UN OBJETO"
  },
  {
    "codigo":786077003,
    "descripcion":"ESPONDILITIS ANQUILOSANTE CONCOMITANTE CON UVEÍTIS ANTERIOR"
  },
  {
    "codigo":1179293006,
    "descripcion":"SÍNDROME DE ERITROQUERATODERMIA Y MIOCARDIOPATÍA"
  },
  {
    "codigo":294557008,
    "descripcion":"ALERGIA A CEFAMICINA"
  },
  {
    "codigo":423794002,
    "descripcion":"RELACIÓN EMOCIONAL CON LA PAREJA, ABUSIVA"
  },
  {
    "codigo":1144690006,
    "descripcion":"APLASIA DE FALANGE PROXIMAL DE DEDO DE PIE"
  },
  {
    "codigo":127047000,
    "descripcion":"ENFERMEDAD DE LEPORE POR HEMOGLOBINA DE CÉLULAS DREPANOCÍTICAS"
  },
  {
    "codigo":94279001,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL ENDOCÉRVIX"
  },
  {
    "codigo":389191003,
    "descripcion":"DISPLASIA OSTEOPLÁSICA"
  },
  {
    "codigo":28743005,
    "descripcion":"TOS PRODUCTIVA"
  },
  {
    "codigo":716871006,
    "descripcion":"INMUNODEFICIENCIA COMBINADA SEVERA DEBIDA A DEFICIENCIA DE SUBUNIDAD CATALÍTICA DE PROTEÍNA CINASA DEPENDIENTE DEL ÁCIDO DESOXIRRIBONUCLEICO"
  },
  {
    "codigo":715036001,
    "descripcion":"NO TOMA MEDICACIÓN"
  },
  {
    "codigo":92444004,
    "descripcion":"NEOPLASIA BENIGNA DE LA FOSA AMIGDALINA"
  },
  {
    "codigo":289052007,
    "descripcion":"DIFICULTAD PARA UTILIZAR CUCHILLO Y TENEDOR PARA ALIMENTARSE"
  },
  {
    "codigo":254449000,
    "descripcion":"NEOPLASIA DE SURCO LABIAL MAXILAR"
  },
  {
    "codigo":1237489001,
    "descripcion":"METÁSTASIS DE CARCINOMA DE AMÍGDALA"
  },
  {
    "codigo":26908008,
    "descripcion":"FRACTURA BIMALEOLAR EXPUESTA"
  },
  {
    "codigo":1086031000119101,
    "descripcion":"HEMORRAGIA DUODENAL DEBIDA A MALFORMACIÓN VASCULAR DE DIEULAFOY DE DUODENO"
  },
  {
    "codigo":1335793006,
    "descripcion":"ARTRITIS IDIOPÁTICA JUVENIL DE CADERA DERECHA"
  },
  {
    "codigo":23238000,
    "descripcion":"AGAMMAGLOBULINEMIA VARIABLE COMÚN"
  },
  {
    "codigo":713201008,
    "descripcion":"CON MAYOR RIESGO DE MUTILACIÓN GENITAL FEMENINA"
  },
  {
    "codigo":416454006,
    "descripcion":"CONJUNTIVITIS RELACIONADA CON EL USO DE LENTES DE CONTACTO"
  },
  {
    "codigo":711366008,
    "descripcion":"LESIÓN TRAUMÁTICA DE BAZO DURANTE INTERVENCIÓN QUIRÚRGICA"
  },
  {
    "codigo":185243000,
    "descripcion":"ATENDIDO EN CONSULTORIO ESPECIALIZADO EN COLONOSCOPIAS"
  },
  {
    "codigo":283547002,
    "descripcion":"HERIDA DE PERDIGÓN EN CABEZA"
  },
  {
    "codigo":449222008,
    "descripcion":"LINFOMA NO HODGKIN FOLICULAR DE ESTÓMAGO"
  },
  {
    "codigo":871536000,
    "descripcion":"ANEURISMA DE AORTA PARARRENAL"
  },
  {
    "codigo":840603008,
    "descripcion":"SOLO CAPAZ DE CONTAR DEDOS DE LA MANO A TRAVÉS DE AGUJERO ESTENOPEICO CON EL OJO IZQUIERDO"
  },
  {
    "codigo":247109000,
    "descripcion":"HALLAZGO RELACIONADO CON LA ARTERIA DE LA RETINA"
  },
  {
    "codigo":15723241000119102,
    "descripcion":"ARTROSIS SECUNDARIA DE AMBAS MUÑECAS"
  },
  {
    "codigo":278042005,
    "descripcion":"TERATOMA MALIGNO DE MEDIASTINO"
  },
  {
    "codigo":704026005,
    "descripcion":"FRACTURA EXPUESTA DE BASE DE CUARTO METACARPIANO"
  },
  {
    "codigo":472815000,
    "descripcion":"PRESBIFAGIA"
  },
  {
    "codigo":15898009,
    "descripcion":"TERCER PERÍODO DEL TRABAJO DE PARTO"
  },
  {
    "codigo":736794009,
    "descripcion":"CAPAZ DE SECAR LA PARTE INFERIOR DEL CUERPO"
  },
  {
    "codigo":734959006,
    "descripcion":"ÉMBOLO DE ARTERIA CEREBELOSA IZQUIERDA"
  },
  {
    "codigo":1259247008,
    "descripcion":"HEMORRAGIA DE LECHO PROSTÁTICO"
  },
  {
    "codigo":733124000,
    "descripcion":"NEOVASCULARIZACIÓN COROIDEA MIÓPICA"
  },
  {
    "codigo":210671008,
    "descripcion":"SECCIÓN TOTAL, TENDÓN DEL CUÁDRICEPS"
  },
  {
    "codigo":208836001,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA NO EXPUESTA DE MUÑECA"
  },
  {
    "codigo":6121000179106,
    "descripcion":"EVALUACIÓN MAMOGRÁFICA (CATEGORÍA 4A) - ANOMALÍA SOSPECHOSA, DEBE CONSIDERARSE LA REALIZACIÓN DE UNA BIOPSIA, BAJA SOSPECHA DE MALIGNIDAD"
  },
  {
    "codigo":403609001,
    "descripcion":"SÍNDROME DE STEVENS-JOHNSON MEDICAMENTOSO"
  },
  {
    "codigo":307140009,
    "descripcion":"INFARTO AGUDO DE MIOCARDIO SIN ONDA Q"
  },
  {
    "codigo":272537004,
    "descripcion":"DE PIE EN EL AGUA MIRANDO HACIA EL COSTADO"
  },
  {
    "codigo":1255577005,
    "descripcion":"GLOMERULONEFRITIS RECURRENTE POSTERIOR A TRASPLANTE DE RIÑÓN"
  },
  {
    "codigo":237934001,
    "descripcion":"DEFICIENCIA DE TRANSCOBALAMINA II"
  },
  {
    "codigo":11791081000119109,
    "descripcion":"CONTUSIÓN DE RODILLA IZQUIERDA"
  },
  {
    "codigo":41326006,
    "descripcion":"GALACTOSEMIA CLÁSICA HETEROCIGOTA"
  },
  {
    "codigo":236099000,
    "descripcion":"DEHISCENCIA DE ANASTOMOSIS ESOFÁGICA"
  },
  {
    "codigo":303470008,
    "descripcion":"DIFICULTAD PARA COLOCARSE PRÓTESIS"
  },
  {
    "codigo":203331002,
    "descripcion":"ENFERMEDAD DE PAGET DEL CÓCCIX"
  },
  {
    "codigo":399939002,
    "descripcion":"HIRSUTISMO"
  },
  {
    "codigo":170563001,
    "descripcion":"ENFERMEDAD CRÓNICA - EFECTOS COLATERALES DE FÁRMACOS"
  },
  {
    "codigo":39491008,
    "descripcion":"PATRONES DE SEXUALIDAD ALTERADOS"
  },
  {
    "codigo":301635008,
    "descripcion":"DIFICULTAD PARA UTILIZAR ESCALERA MECÁNICA"
  },
  {
    "codigo":365336000,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA PONER LA MESA"
  },
  {
    "codigo":299800008,
    "descripcion":"REFLEJO DE PRENSIÓN PALMAR DUDOSO"
  },
  {
    "codigo":267032009,
    "descripcion":"CANSADO TODO EL TIEMPO"
  },
  {
    "codigo":232429001,
    "descripcion":"LARINGITIS SUBGLÓTICA AGUDA"
  },
  {
    "codigo":363501002,
    "descripcion":"NEOPLASIA MALIGNA DE CARA"
  },
  {
    "codigo":68589002,
    "descripcion":"POSICIÓN COITAL CON PENETRACIÓN DESDE ATRÁS"
  },
  {
    "codigo":3053001,
    "descripcion":"INTOXICACIÓN POR NITROGLICERINA"
  },
  {
    "codigo":396269002,
    "descripcion":"HALLAZGO RELACIONADO CON EL MARGEN DE RESECCIÓN QUIRÚRGICA DISTAL"
  },
  {
    "codigo":199661007,
    "descripcion":"RUPTURA PREMATURA DE MEMBRANAS, TRABAJO DE PARTO RETRASADO POR TRATAMIENTO"
  },
  {
    "codigo":351261000119101,
    "descripcion":"NEOPLASIA BENIGNA DE HUESO CORTO DE MIEMBRO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":296130002,
    "descripcion":"SOBREDOSIS DE CARBAMATO"
  },
  {
    "codigo":230594005,
    "descripcion":"ENFERMEDAD CRÍTICA CON POLINEUROPATÍA"
  },
  {
    "codigo":722114007,
    "descripcion":"SÍNDROME DE DISPLASIA ESCLEROSANTE DE HUESO, ICTIOSIS, INSUFICIENCIA OVÁRICA PREMATURA"
  },
  {
    "codigo":1179031004,
    "descripcion":"INFECCIÓN DE INTESTINO CAUSADA POR SALMONELLA GRUPO O:4"
  },
  {
    "codigo":95852000,
    "descripcion":"FRACTURA METAFISARIA DE HUESO DE LA EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":1144428001,
    "descripcion":"ATROFIA DE CORTEZA DE LÓBULO FRONTAL"
  },
  {
    "codigo":292460003,
    "descripcion":"REACCIÓN ADVERSA AL AMLODIPINO"
  },
  {
    "codigo":678941000119106,
    "descripcion":"DEPÓSITO BILATERAL EN CÓRNEAS DEBIDO A TRASTORNO METABÓLICO"
  },
  {
    "codigo":194156008,
    "descripcion":"SÍNDROME VÍTREO LUEGO DE CIRUGÍA DE CATARATA"
  },
  {
    "codigo":94017001,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA PIEL DE LA OREJA"
  },
  {
    "codigo":126785002,
    "descripcion":"NEOPLASIA DE LOS DOS TERCIOS ANTERIORES DE LA LENGUA"
  },
  {
    "codigo":567981000005100,
    "descripcion":"ECOGRAFÍA PRENATAL DE SEGUNDO TRIMESTRE DESEADA"
  },
  {
    "codigo":290625008,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR CARMUSTINA"
  },
  {
    "codigo":288790002,
    "descripcion":"REALIZA COMENTARIOS ACERCA DE EVENTOS"
  },
  {
    "codigo":26646003,
    "descripcion":"FRACTURA EXPUESTA DE HUESO CUBOIDES DEL PIE"
  },
  {
    "codigo":12203191000119103,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DE PIE IZQUIERDO"
  },
  {
    "codigo":124950009,
    "descripcion":"DEFICIENCIA DE INMUNOGLOBULINA"
  },
  {
    "codigo":1204459002,
    "descripcion":"LESIÓN PULMONAR CON SEPSIS"
  },
  {
    "codigo":254187004,
    "descripcion":"EPIDERMÓLISIS BULLOSA DISTRÓFICA LOCALIZADA RECESIVA"
  },
  {
    "codigo":88512005,
    "descripcion":"TRASTORNO DE LA TOLERANCIA A LA GLUCOSA ASOCIADO CON ANOMALÍA EN EL RECEPTOR DE INSULINA"
  },
  {
    "codigo":186816007,
    "descripcion":"ENFERMEDAD DE CHAGAS AGUDA CON COMPROMISO DEL SISTEMA NERVIOSO"
  },
  {
    "codigo":283285003,
    "descripcion":"ASTILLA DE MADERA EN BRAZO"
  },
  {
    "codigo":184981009,
    "descripcion":"EXAMEN E INFORME DEL SOLICITANTE ENVIADOS"
  },
  {
    "codigo":1297258001,
    "descripcion":"CIERRE DE ÁNGULO AGUDO DE AMBOS OJOS DEBIDO A UVEÍTIS"
  },
  {
    "codigo":707434003,
    "descripcion":"FIBROSIS PULMONAR DEBIDA A SÍNDROME DE HERMANSKY-PUDLAK"
  },
  {
    "codigo":445290004,
    "descripcion":"TENDINITIS DEL EXTENSOR LARGO DEL PULGAR"
  },
  {
    "codigo":1231722004,
    "descripcion":"INFLAMACIÓN PALPEBRAL"
  },
  {
    "codigo":281450006,
    "descripcion":"AFLOJAMIENTO DE PRÓTESIS DE REEMPLAZO TOTAL DE RODILLA"
  },
  {
    "codigo":248682009,
    "descripcion":"SOPLO AÓRTICO DIASTÓLICO"
  },
  {
    "codigo":17471001,
    "descripcion":"POLIORQUIDIA"
  },
  {
    "codigo":50239007,
    "descripcion":"VAGABUNDEO"
  },
  {
    "codigo":312383007,
    "descripcion":"AORTITIS INFECCIOSA"
  },
  {
    "codigo":310548004,
    "descripcion":"BEBÉ PREMATURO 26-28 SEMANAS"
  },
  {
    "codigo":212244009,
    "descripcion":"LESIÓN DE LOS NERVIOS SIMPÁTICOS DORSALES"
  },
  {
    "codigo":79337003,
    "descripcion":"REACCIÓN ANAFILÁCTICA A UNA TRANSFUSIÓN"
  },
  {
    "codigo":439785006,
    "descripcion":"FÍSTULA ARTERIOVENOSA BRAQUIOBASÍLICA CONSTRUIDA QUIRÚRGICAMENTE"
  },
  {
    "codigo":112105008,
    "descripcion":"PAROSMIA"
  },
  {
    "codigo":896702001,
    "descripcion":"FORMA DELGADA ANORMAL CONGÉNITA DE FALANGE DISTAL DE DEDO DE MANO"
  },
  {
    "codigo":863934002,
    "descripcion":"ERITEMA EN LUGAR DE IMPLANTE"
  },
  {
    "codigo":44734002,
    "descripcion":"CONSISTENCIA DE UNA COLONIA BACTERIANA, FRÁGIL"
  },
  {
    "codigo":110270004,
    "descripcion":"SECUELA DE INFECCIÓN CAUSADA POR POLIOVIRUS HUMANO"
  },
  {
    "codigo":700094005,
    "descripcion":"INTOLERANCIA A LA LECHE"
  },
  {
    "codigo":403347003,
    "descripcion":"ACNÉ VULGAR SUPERFICIAL"
  },
  {
    "codigo":353771000119104,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE CUERPO CILIAR DERECHO"
  },
  {
    "codigo":763795006,
    "descripcion":"SÍNDROME DE SOBRECRECIMIENTO DE MALAN"
  },
  {
    "codigo":75667007,
    "descripcion":"BOCIO LINGUAL"
  },
  {
    "codigo":41101000087102,
    "descripcion":"CELULITIS DE CUARTO DEDO DE PIE DERECHO"
  },
  {
    "codigo":46221000087106,
    "descripcion":"FRACTURA DE FALANGE DE TERCER DEDO DE PIE IZQUIERDO"
  },
  {
    "codigo":43661000087108,
    "descripcion":"CONTUSIÓN DE TALÓN IZQUIERDO"
  },
  {
    "codigo":761960006,
    "descripcion":"HARDWARE ORTOPÉDICO IN SITU"
  },
  {
    "codigo":237672008,
    "descripcion":"HIPERSECRECIÓN DE LH"
  },
  {
    "codigo":1153341001,
    "descripcion":"SÍNDROME HIPEREOSINOFÍLICO MIELOPROLIFERATIVO"
  },
  {
    "codigo":270440008,
    "descripcion":"CONTROL DE HIPERTENSIÓN REALIZADO"
  },
  {
    "codigo":301373000,
    "descripcion":"CANSANCIO CON DOLOR"
  },
  {
    "codigo":235837008,
    "descripcion":"ÍLEO MEDICAMENTOSO"
  },
  {
    "codigo":6461009,
    "descripcion":"CÁLCULO AMIGDALINO"
  },
  {
    "codigo":1217042001,
    "descripcion":"DEGENERACIÓN DE TIROIDES"
  },
  {
    "codigo":234002001,
    "descripcion":"CONTUSIÓN ARTERIAL"
  },
  {
    "codigo":365074002,
    "descripcion":"COMPONENTE P 100 DEL PATRÓN DE POTENCIALES EVOCADOS VISUALES - HALLAZGO"
  },
  {
    "codigo":37394005,
    "descripcion":"DEFENSA ANORMAL DEL HUÉSPED"
  },
  {
    "codigo":299538002,
    "descripcion":"SIN AMPLITUD ACTIVA DE INVERSIÓN DE ARTICULACIÓN SUBASTRAGALINA"
  },
  {
    "codigo":102930000,
    "descripcion":"GINEFOBIA"
  },
  {
    "codigo":428775009,
    "descripcion":"GRANULOMA ESPERMATOGÉNICO"
  },
  {
    "codigo":33724004,
    "descripcion":"ABSCESO DE LA TÚNICA VAGINAL"
  },
  {
    "codigo":230332007,
    "descripcion":"DISTONÍA DIURNA"
  },
  {
    "codigo":263100007,
    "descripcion":"FRACTURA-SUBLUXACIÓN DE ARTICULACIÓN DE CODO"
  },
  {
    "codigo":294033001,
    "descripcion":"ALERGIA A AGONISTA DE RECEPTOR ADRENÉRGICO BETA 2"
  },
  {
    "codigo":295868009,
    "descripcion":"SOBREDOSIS DE IPRINDOL"
  },
  {
    "codigo":195729007,
    "descripcion":"BRONQUITIS AGUDA POR ECHOVIRUS"
  },
  {
    "codigo":359569009,
    "descripcion":"SÍNDROME DE HAFF"
  },
  {
    "codigo":423270001,
    "descripcion":"PAPILA LAGRIMAL ECTÓPICA"
  },
  {
    "codigo":95590003,
    "descripcion":"PRURITO DE LOS ÓRGANOS GENITALES MASCULINOS"
  },
  {
    "codigo":193894004,
    "descripcion":"HIPEREMIA CONJUNTIVAL"
  },
  {
    "codigo":783718003,
    "descripcion":"DISOMÍA UNIPARENTAL DE CROMOSOMA X PATERNO"
  },
  {
    "codigo":1142331000,
    "descripcion":"ATROFIA DE MÚSCULO RECTO SUPERIOR"
  },
  {
    "codigo":718182008,
    "descripcion":"FORMA GENÉTICA DE DEFICIENCIA COMBINADA DE HORMONAS HIPOFISARIAS"
  },
  {
    "codigo":161126008,
    "descripcion":"INGRESO PRECOZ A LA ESCUELA POR RAZONES SOCIALES"
  },
  {
    "codigo":292198009,
    "descripcion":"REACCIÓN ADVERSA AL MITOBRONITOL"
  },
  {
    "codigo":28219006,
    "descripcion":"INTOXICACIÓN POR RANUNCULUS"
  },
  {
    "codigo":93755007,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE COROIDES"
  },
  {
    "codigo":290363008,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR NIZATIDINA"
  },
  {
    "codigo":126523009,
    "descripcion":"NEOPLASIA DE LA PIEL DE LOS DEDOS DE LA MANO"
  },
  {
    "codigo":124688008,
    "descripcion":"DEFICIENCIA DE TIROSINA - ARNT LIGASA"
  },
  {
    "codigo":91920008,
    "descripcion":"AUSENCIA CONGÉNITA DEL VÓMER"
  },
  {
    "codigo":253925001,
    "descripcion":"ACROSINDACTILIA DE LOS DEDOS DE LAS MANOS"
  },
  {
    "codigo":1204197006,
    "descripcion":"OCLUSIÓN AGUDA DE ARTERIA FEMORAL SUPERFICIAL DEBIDA A TROMBOEMBOLISMO"
  },
  {
    "codigo":448698000,
    "descripcion":"EDAD DEL SUJETO POR ENCIMA DEL RANGO PARA LA INTERPRETACIÓN CONFIABLE DE LA EVALUACIÓN"
  },
  {
    "codigo":90085009,
    "descripcion":"VÁRICES DEL TABIQUE NASAL CON ÚLCERA"
  },
  {
    "codigo":55482007,
    "descripcion":"MIOCARDITIS GRANULOMATOSA DIFUSA AISLADA"
  },
  {
    "codigo":1003919001,
    "descripcion":"ESTENOSIS ADQUIRIDA DE VÁLVULA AURICULOVENTRICULAR COMÚN POSTERIOR A PROCEDIMIENTO"
  },
  {
    "codigo":182884001,
    "descripcion":"ADHERENCIA AL ESQUEMA TERAPÉUTICO"
  },
  {
    "codigo":19044004,
    "descripcion":"FIEBRE ESPIRILAR"
  },
  {
    "codigo":248420006,
    "descripcion":"EXTREMIDADES CALIENTES"
  },
  {
    "codigo":1264228009,
    "descripcion":"INFECCIÓN PARASITARIA FETAL"
  },
  {
    "codigo":17209001,
    "descripcion":"COITO INVERSO"
  },
  {
    "codigo":279353003,
    "descripcion":"DERMATITIS CORAL"
  },
  {
    "codigo":402739005,
    "descripcion":"ENFERMEDAD ARTIFICIAL DE PIEL INFLIGIDA POR OTROS"
  },
  {
    "codigo":115513005,
    "descripcion":"PATRÓN RESTRINGIDO DE BANDA DE ANTICUERPOS"
  },
  {
    "codigo":312121001,
    "descripcion":"ENFERMEDAD INFECCIOSA BACTERIANA GASTROINTESTINAL"
  },
  {
    "codigo":1196857007,
    "descripcion":"NEOPLASIA INTRAEPITELIAL GLANDULAR DE BAJO GRADO DE INTESTINO DELGADO"
  },
  {
    "codigo":10923961000119108,
    "descripcion":"FRACTURA NO EXPUESTA DE BASE DE QUINTO HUESO METACARPIANO DE MANO DERECHA"
  },
  {
    "codigo":48142003,
    "descripcion":"ABSCESO VÍTREO"
  },
  {
    "codigo":1162254004,
    "descripcion":"GRUPO SANGUÍNEO FETAL RH NEGATIVO"
  },
  {
    "codigo":80910005,
    "descripcion":"SENSIBILIDAD ANORMAL DE LA PIEL"
  },
  {
    "codigo":310286009,
    "descripcion":"ANTICUERPO ANTI- JO - 1 DETECTADO"
  },
  {
    "codigo":15374009,
    "descripcion":"GLAUCOMA AFÁQUICO"
  },
  {
    "codigo":767203005,
    "descripcion":"ALERGIA A ÁCIDO CROMOGLÍCICO"
  },
  {
    "codigo":898275006,
    "descripcion":"ANQUILOSIS CONGÉNITA DE ARTICULACIÓN INTERFALÁNGICA DISTAL DE DEDO ANULAR"
  },
  {
    "codigo":111843007,
    "descripcion":"GASTROENTERITIS VIRAL"
  },
  {
    "codigo":734435008,
    "descripcion":"PESO CORPORAL ANORMAL PARA LA EDAD"
  },
  {
    "codigo":2021000124102,
    "descripcion":"DERIVADO POR MÉDICO DE ATENCIÓN PRIMARIA"
  },
  {
    "codigo":208312006,
    "descripcion":"FRACTURA EXPUESTA DE DIÁFISIS MEDIA DE CÚBITO Y RADIO"
  },
  {
    "codigo":763533003,
    "descripcion":"NEUROPATÍA MOTORA DISTAL HEREDITARIA TIPO JERASH"
  },
  {
    "codigo":403085005,
    "descripcion":"TIÑA CAUSADA POR TRICHOPHYTON VERRUCOSUM"
  },
  {
    "codigo":302946006,
    "descripcion":"ANEURISMA DE FÍSTULA ARTERIOVENOSA"
  },
  {
    "codigo":40802007,
    "descripcion":"LEUCODISTROFIA METACROMÁTICA, TIPO CONGÉNITA"
  },
  {
    "codigo":204642008,
    "descripcion":"PÓLIPO FARÍNGEO CONGÉNITO"
  },
  {
    "codigo":8034008,
    "descripcion":"ERECCIÓN DE PENE DOLOROSA"
  },
  {
    "codigo":399415002,
    "descripcion":"DIFERENCIACIÓN HISTOLÓGICA DE BAJO GRADO"
  },
  {
    "codigo":1251383000,
    "descripcion":"EXACERBACIÓN DE DERMATITIS ATÓPICA DEBIDA A EXPOSICIÓN A ALÉRGENO DE CONTACTO"
  },
  {
    "codigo":170039004,
    "descripcion":"TALLA DEL NIÑO ENTRE PERCENTILOS 75 Y 89"
  },
  {
    "codigo":366647005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA PARARSE SOLO"
  },
  {
    "codigo":301111004,
    "descripcion":"VÁLVULA TRICÚSPIDE NORMAL"
  },
  {
    "codigo":401250009,
    "descripcion":"PRIMERA CARTA DE CONVOCATORIA PARA MONITOREO DE CARDIOPATÍA CORONARIA"
  },
  {
    "codigo":15950061000119105,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE PIEL DE MAMA DERECHA"
  },
  {
    "codigo":364812001,
    "descripcion":"HALLAZGO DE LA CAPACIDAD DE ALIMENTARSE"
  },
  {
    "codigo":4364002,
    "descripcion":"ESTRUCTURA DE LAS ASOCIACIONES"
  },
  {
    "codigo":233740004,
    "descripcion":"MEDIASTINITIS GRANULOMATOSA INFECCIOSA"
  },
  {
    "codigo":200972005,
    "descripcion":"PSORIASIS PUNTEADA"
  },
  {
    "codigo":430348006,
    "descripcion":"INFECCIÓN LOCALIZADA DE PIEL Y\/O TEJIDO CELULAR SUBCUTÁNEO"
  },
  {
    "codigo":168204005,
    "descripcion":"SALMONELLA NO AISLADA"
  },
  {
    "codigo":11827591000119100,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA DE SEGUNDO A QUINTO DEDOS DE PIE DERECHO"
  },
  {
    "codigo":299276009,
    "descripcion":"ESCLERODERMIA LIMITADA"
  },
  {
    "codigo":231905003,
    "descripcion":"QUERATOCONJUNTIVITIS NUDOSA"
  },
  {
    "codigo":788961008,
    "descripcion":"GONORREA DE PENE"
  },
  {
    "codigo":262838003,
    "descripcion":"HEMATOMA DE ESTÓMAGO"
  },
  {
    "codigo":66230004,
    "descripcion":"RITMO RECÍPROCO"
  },
  {
    "codigo":12237191000119103,
    "descripcion":"CLAUDICACIÓN INTERMITENTE DE MIEMBRO INFERIOR DERECHO CONCOMITANTE CON ATEROSCLEROSIS Y DEBIDA A ELLA"
  },
  {
    "codigo":361142004,
    "descripcion":"ULCERACIONES DIFUSAS DEL YEYUNO Y\/O EL ÍLEON"
  },
  {
    "codigo":426678007,
    "descripcion":"CONTENIDO GASTROINTESTINAL EN LA VÍA AÉREA SUPERIOR"
  },
  {
    "codigo":721590009,
    "descripcion":"INFECCIÓN DE REGIÓN ANOGENITAL CAUSADA POR MOLUSCO CONTAGIOSO"
  },
  {
    "codigo":719755001,
    "descripcion":"CONJUNTIVITIS DEL ADULTO CAUSADA POR NEISSERIA GONORRHOEAE"
  },
  {
    "codigo":293771005,
    "descripcion":"ALERGIA A METOTREXATO"
  },
  {
    "codigo":95328003,
    "descripcion":"ERUPCIONES VESICULOSAS DE LA PIEL DE LA REGIÓN TEMPORAL"
  },
  {
    "codigo":717920004,
    "descripcion":"SÍNDROME DE CEGUERA, ESCOLIOSIS, ARACNODACTILIA"
  },
  {
    "codigo":160864004,
    "descripcion":"ADOPCIÓN DE UN NIÑO"
  },
  {
    "codigo":128096008,
    "descripcion":"TRASTORNO DE LA FUNCIÓN PLAQUETARIA HEREDITARIO"
  },
  {
    "codigo":1142069000,
    "descripcion":"TAQUICARDIA AURICULAR DE MACRORREENTRADA NO DEPENDIENTE DE ISTMO CAVOTRICUSPÍDEO DE AURÍCULA IZQUIERDA MEDIADA POR CICATRIZ"
  },
  {
    "codigo":93493001,
    "descripcion":"ENFERMEDAD DE HODGKIN, PREDOMINIO LINFOCÍTICO-HISTIOCÍTICO, DE GANGLIOS LINFÁTICOS INTRABDOMINALES"
  },
  {
    "codigo":290101004,
    "descripcion":"TUMEFACCIÓN DEL PEZÓN"
  },
  {
    "codigo":124426000,
    "descripcion":"DEFICIENCIA DE SUCCINIL - COA HIDROLASA"
  },
  {
    "codigo":58890000,
    "descripcion":"BRONCONEUMONÍA POR ADENOVIRUS"
  },
  {
    "codigo":288266004,
    "descripcion":"NACIDO LUEGO DE TRABAJO DE PARTO INDUCIDO"
  },
  {
    "codigo":384735004,
    "descripcion":"PLEOMORFISMO NUCLEAR: NÚCLEOS PEQUEÑOS, REGULARES (PUNTAJE = 1)"
  },
  {
    "codigo":286431007,
    "descripcion":"ABASTECE A OTROS"
  },
  {
    "codigo":253663007,
    "descripcion":"ANILLO VASCULAR CON CAYADO AÓRTICO IZQUIERDO"
  },
  {
    "codigo":284596004,
    "descripcion":"HABLA INCOHERENTE"
  },
  {
    "codigo":282761000,
    "descripcion":"LESIÓN TRAUMÁTICA EN UÑA DE PULGAR"
  },
  {
    "codigo":315529000,
    "descripcion":"NACIDO EN SANTA LUCÍA"
  },
  {
    "codigo":10873531000119101,
    "descripcion":"HERIDA ABIERTA DE OÍDO DERECHO"
  },
  {
    "codigo":1003657004,
    "descripcion":"GLAUCOMA CONGÉNITO DE OJO IZQUIERDO"
  },
  {
    "codigo":11774651000119102,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE PULGAR IZQUIERDO CON INFECCIÓN"
  },
  {
    "codigo":1231198001,
    "descripcion":"LAGOFTALMOS PARALÍTICO DE PÁRPADO INFERIOR"
  },
  {
    "codigo":870750003,
    "descripcion":"REACCIÓN ADVERSA A HIPOGLUCEMIANTE SULFONILUREICO"
  },
  {
    "codigo":248158003,
    "descripcion":"UÑAS SUCIAS"
  },
  {
    "codigo":705075002,
    "descripcion":"CAPAZ DE VER"
  },
  {
    "codigo":16028711000119100,
    "descripcion":"EXOSTOSIS DE CALCÁNEO DERECHO"
  },
  {
    "codigo":348711000119100,
    "descripcion":"PAPILOMA DE PÁRPADO IZQUIERDO"
  },
  {
    "codigo":16046631000119100,
    "descripcion":"ENFERMEDAD POR DEPÓSITO DE HIDROXIAPATITA DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":15911000119103,
    "descripcion":"NEFRITIS TUBULOINTERSTICIAL PRIMARIA"
  },
  {
    "codigo":10645031000119104,
    "descripcion":"ÚLCERA VARICOSA DE TOBILLO DERECHO"
  },
  {
    "codigo":11832871000119104,
    "descripcion":"ESGUINCE DE LIGAMENTO DE ARTICULACIÓN DE DEDO GORDO DE PIE DERECHO"
  },
  {
    "codigo":10627111000119104,
    "descripcion":"FORÚNCULO DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":16033831000119105,
    "descripcion":"HIPERTROFIA DE HUESO DE MANO DERECHA"
  },
  {
    "codigo":195953191000119108,
    "descripcion":"PORTADOR DE MUCOLIPIDOSIS TIPO IV"
  },
  {
    "codigo":305191000119109,
    "descripcion":"HIPERLORDOSIS CONGÉNITA DE COLUMNA DORSAL Y LUMBAR"
  },
  {
    "codigo":125991000119108,
    "descripcion":"QUISTE PARAMEATAL URETRAL"
  },
  {
    "codigo":323111000119109,
    "descripcion":"LONGITUD DESIGUAL DE EXTREMIDADES INFERIORES DEBIDA A ACORTAMIENTO ADQUIRIDO DE PERONÉ DERECHO"
  },
  {
    "codigo":10675751000119107,
    "descripcion":"ASMA PERSISTENTE SEVERA NO CONTROLADA"
  },
  {
    "codigo":277256004,
    "descripcion":"ERITEMA SUPRAGLÓTICO"
  },
  {
    "codigo":16320551000119109,
    "descripcion":"SANGRADO POR TRACTO GENITAL FEMENINO CONCOMITANTE CON EMBARAZO"
  },
  {
    "codigo":734173003,
    "descripcion":"SÍNDROME DE ANOMALÍAS ESQUELÉTICAS, CUTIS LAXO, CRANEOESTENOSIS, GENITALES AMBIGUOS, RETARDO Y ANOMALÍAS FACIALES"
  },
  {
    "codigo":275421004,
    "descripcion":"ABORTO ESPONTÁNEO CON SANGRADO INTENSO"
  },
  {
    "codigo":703240009,
    "descripcion":"PSEUDOMONAS FLUORESCENS O PSEUDOMONAS PUTIDA"
  },
  {
    "codigo":10629671000119109,
    "descripcion":"SINUSITIS MAXILAR AGUDA RECURRENTE"
  },
  {
    "codigo":13277001,
    "descripcion":"ACNÉ QUÍSTICA"
  },
  {
    "codigo":111581008,
    "descripcion":"ANEMIA CAUSADA POR AGENTE FÍSICO"
  },
  {
    "codigo":46045005,
    "descripcion":"INFECCIÓN CAUSADA POR BAYLISASCARIS COLUMNARIS"
  },
  {
    "codigo":109746003,
    "descripcion":"CONCUSIÓN DENTAL"
  },
  {
    "codigo":142011000119109,
    "descripcion":"ENFERMEDAD DE ALZHEIMER CON DELIRIO"
  },
  {
    "codigo":240818004,
    "descripcion":"INFECCIÓN POR TAENIA SOLIUM"
  },
  {
    "codigo":765106006,
    "descripcion":"SEPSIS NEONATAL DE COMIENZO TEMPRANO"
  },
  {
    "codigo":11442006,
    "descripcion":"NEUROPATÍA SENSITIVA HEREDITARIA"
  },
  {
    "codigo":75143000,
    "descripcion":"ENCEFALITIS TÓXICA CAUSADA POR TALIO"
  },
  {
    "codigo":404658009,
    "descripcion":"PAPILOFLEBITIS"
  },
  {
    "codigo":271751000,
    "descripcion":"FIEBRE CONTINUA"
  },
  {
    "codigo":238983004,
    "descripcion":"SÍNDROME DE LA PIEL GRUESA DIABÉTICA"
  },
  {
    "codigo":206215004,
    "descripcion":"FRACTURA DE CRÁNEO POR TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":304519006,
    "descripcion":"TRASTORNO DE PRÓTESIS ESOFÁGICA"
  },
  {
    "codigo":106076001,
    "descripcion":"HALLAZGO EN LA PIEL"
  },
  {
    "codigo":370055009,
    "descripcion":"INVASIÓN TUMORAL EN UN BRONQUIO"
  },
  {
    "codigo":402823009,
    "descripcion":"MILARIA INFANTIL PROFUNDA"
  },
  {
    "codigo":15981551000119100,
    "descripcion":"ENTROPIÓN MECÁNICO DE AMBOS PÁRPADOS INFERIORES"
  },
  {
    "codigo":1285724007,
    "descripcion":"FRACTURA DE EXTREMO DISTAL DE RADIO IZQUIERDO"
  },
  {
    "codigo":7772007,
    "descripcion":"HEMOCROMATOSIS ERITROPOYÉTICA"
  },
  {
    "codigo":399153001,
    "descripcion":"VÉRTIGO"
  },
  {
    "codigo":688981000119107,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE ENCÍA INFERIOR"
  },
  {
    "codigo":366385004,
    "descripcion":"AMPLITUD DEL MOVIMIENTO ACTIVO DE EXTENSIÓN DE LA COLUMNA CERVICAL - HALLAZGO"
  },
  {
    "codigo":300849006,
    "descripcion":"MASA DE ESTRUCTURA OCULAR"
  },
  {
    "codigo":71473008,
    "descripcion":"AMNIOS NUDOSO"
  },
  {
    "codigo":724998006,
    "descripcion":"POLINEUROPATÍA CONCOMITANTE CON TRASTORNO SISTÉMICO DEL TEJIDO CONJUNTIVO Y DEBIDA A ÉL"
  },
  {
    "codigo":397318008,
    "descripcion":"ENDOMETRIOSIS EXTRAOVÁRICA"
  },
  {
    "codigo":723163000,
    "descripcion":"EPIDERMÓLISIS BULLOSA SIMPLE BASAL"
  },
  {
    "codigo":1149147006,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR DESOXICORTICOSTERONA"
  },
  {
    "codigo":198875007,
    "descripcion":"INTENTO FALLIDO DE ABORTO REALIZADO CON MÉTODOS NO QUIRÚRGICOS, COMPLICADO POR HEMORRAGIA TARDÍA O EXCESIVA"
  },
  {
    "codigo":262576002,
    "descripcion":"TRAUMATISMO CRANEOENCEFÁLICO POR APLASTAMIENTO"
  },
  {
    "codigo":65968003,
    "descripcion":"ÁNTRAX DEL PERINEO"
  },
  {
    "codigo":295344005,
    "descripcion":"SOBREDOSIS INTENCIONAL DE REGALIZ"
  },
  {
    "codigo":459184006,
    "descripcion":"PERICARDITIS CONSTRICTIVA INFECCIOSA"
  },
  {
    "codigo":721328009,
    "descripcion":"LESIÓN TRAUMÁTICA DE VASO INTRACRANEAL"
  },
  {
    "codigo":195205001,
    "descripcion":"ISQUEMIA CEREBRAL INMINENTE"
  },
  {
    "codigo":162437001,
    "descripcion":"EL SÍNTOMA COMENZÓ HACE DÍAS"
  },
  {
    "codigo":1145477003,
    "descripcion":"HIPOPLASIA DE FALANGE DISTAL DE DEDO MEÑIQUE"
  },
  {
    "codigo":293509005,
    "descripcion":"REACCIÓN ADVERSA AL PERINDOPRIL"
  },
  {
    "codigo":129669003,
    "descripcion":"COLIBACILOSIS GRAVÍDICA"
  },
  {
    "codigo":226138001,
    "descripcion":"DIETA SIN ALCOHOL"
  },
  {
    "codigo":29530003,
    "descripcion":"GRANULOMA FÚNGICO"
  },
  {
    "codigo":291674003,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR DIYODOHIDROXIQUINOLINA"
  },
  {
    "codigo":193370005,
    "descripcion":"RETINOPATÍA PROLIFERATIVA POR DREPANOCITOSIS"
  },
  {
    "codigo":783194008,
    "descripcion":"DIÁTESIS HEMORRÁGICA DEBIDA A DEFICIENCIA DE LA SÍNTESIS DE TROMBOXANO"
  },
  {
    "codigo":95066009,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA PIEL DE LA FRENTE"
  },
  {
    "codigo":10957961000119104,
    "descripcion":"HERIDA ABIERTA DE SEGUNDO A QUINTO DEDOS DE PIE DERECHO"
  },
  {
    "codigo":1141807004,
    "descripcion":"FORMACIÓN DE COSTRA EN PIEL DE PÁRPADO"
  },
  {
    "codigo":419076005,
    "descripcion":"REACCIÓN ALÉRGICA"
  },
  {
    "codigo":124164005,
    "descripcion":"DEFICIENCIA DE GALACTONOLACTONA DESHIDROGENASA"
  },
  {
    "codigo":1172740007,
    "descripcion":"ANTÍGENO CARCINOEMBRIONARIO NO DETECTADO"
  },
  {
    "codigo":1303812009,
    "descripcion":"ARTRITIS DE ARTICULACIÓN DE PIE"
  },
  {
    "codigo":253401003,
    "descripcion":"AUSENCIA DE VALVAS DE VÁLVULA MITRAL"
  },
  {
    "codigo":89561004,
    "descripcion":"HIPOEMOTIVIDAD"
  },
  {
    "codigo":286169005,
    "descripcion":"NO LIMPIA EL INODORO"
  },
  {
    "codigo":15709321000119108,
    "descripcion":"INFESTACIÓN PARASITARIA DE PÁRPADO IZQUIERDO"
  },
  {
    "codigo":251566000,
    "descripcion":"BLOQUEO DE CONDUCCIÓN DE NERVIO MOTOR"
  },
  {
    "codigo":187865009,
    "descripcion":"NEOPLASIA MALIGNA DE BRONQUIO DEL LÓBULO MEDIO"
  },
  {
    "codigo":448174006,
    "descripcion":"DURACIÓN EXCESIVAMENTE PROLONGADA DE TRATAMIENTO FARMACOLÓGICO"
  },
  {
    "codigo":1003395004,
    "descripcion":"DISOMÍA UNIPARENTAL MATERNA DEL CROMOSOMA 7"
  },
  {
    "codigo":249731006,
    "descripcion":"ASIMETRÍA DEL PLIEGUE GLÚTEO"
  },
  {
    "codigo":446339007,
    "descripcion":"DEHISCENCIA DE HERIDA DE LAPAROTOMÍA"
  },
  {
    "codigo":282499008,
    "descripcion":"CAPAZ DE SUBIR UNA COLINA CORRIENDO"
  },
  {
    "codigo":313432002,
    "descripcion":"SOMNOLENCIA POSICTAL"
  },
  {
    "codigo":1362008003,
    "descripcion":"TUBERCULOSIS RESPIRATORIA POR REINFECCIÓN"
  },
  {
    "codigo":247896003,
    "descripcion":"INTENTA MOSTRAR SUPERIORIDAD"
  },
  {
    "codigo":444504006,
    "descripcion":"ZONA BLANCA EN LA ESTIMACIÓN DE PESO PEDIÁTRICO DE BROSELOW LUTEN"
  },
  {
    "codigo":770349000,
    "descripcion":"SEPSIS VIRAL"
  },
  {
    "codigo":737581000,
    "descripcion":"SINOSTOSIS TIBIOPERONEA"
  },
  {
    "codigo":49453006,
    "descripcion":"HERNIACIÓN CEREBRAL"
  },
  {
    "codigo":213293008,
    "descripcion":"PERITONITIS ASÉPTICA"
  },
  {
    "codigo":16685009,
    "descripcion":"HIPOCORTISOLISMO SECUNDARIO A OTRO TRASTORNO"
  },
  {
    "codigo":735746003,
    "descripcion":"ACIDEMIA METABÓLICA EN EL RECIÉN NACIDO"
  },
  {
    "codigo":1260034003,
    "descripcion":"ADENOCARCINOMA BASOCELULAR DE OROFARINGE"
  },
  {
    "codigo":309762007,
    "descripcion":"LUPUS ERITEMATOSO SISTÉMICO CON PERICARDITIS"
  },
  {
    "codigo":111319002,
    "descripcion":"TRONCO ARTERIOSO, TIPO IV DE EDWARDS"
  },
  {
    "codigo":307927003,
    "descripcion":"PACIENTE REGISTRADO"
  },
  {
    "codigo":699308002,
    "descripcion":"MICRODELECIÓN CROMOSÓMICA 15Q24"
  },
  {
    "codigo":207788003,
    "descripcion":"FRACTURA DE HUESOS MALAR Y MAXILAR"
  },
  {
    "codigo":109484005,
    "descripcion":"HIPOPLASIA LOCALIZADA DEL ESMALTE DE ETIOLOGÍA DESCONOCIDA"
  },
  {
    "codigo":240556008,
    "descripcion":"SÍFILIS EXTRAGENITAL PRIMARIA"
  },
  {
    "codigo":371628009,
    "descripcion":"PORFIRINOPATÍA"
  },
  {
    "codigo":402561003,
    "descripcion":"MELANOMA MALIGNO DE PARTES BLANDAS"
  },
  {
    "codigo":42113004,
    "descripcion":"INFECCIÓN CAUSADA POR FASCIOLOIDES MAGNA"
  },
  {
    "codigo":9345005,
    "descripcion":"DEMENCIA DIALÍTICA"
  },
  {
    "codigo":1078301000112109,
    "descripcion":"HIPERTENSIÓN CON INTOLERANCIA A MÚLTIPLES FÁRMACOS"
  },
  {
    "codigo":40278002,
    "descripcion":"FRUCTOSURIA BENIGNA ESENCIAL"
  },
  {
    "codigo":204118005,
    "descripcion":"QUERATOGLOBO CONGÉNITO"
  },
  {
    "codigo":366123002,
    "descripcion":"HALLAZGO EN EL REFLEJO TUSIVO"
  },
  {
    "codigo":267819003,
    "descripcion":"TRASTORNO ADQUIRIDO DEL COLOR DE PIEL"
  },
  {
    "codigo":202283002,
    "descripcion":"CONTRACTURA EN FLEXIÓN DE LA CADERA"
  },
  {
    "codigo":235051007,
    "descripcion":"REACCIÓN LIQUENOIDE BUCAL FARMACÓGENA"
  },
  {
    "codigo":10632791000119105,
    "descripcion":"ABSCESO DE ANTEBRAZO IZQUIERDO"
  },
  {
    "codigo":890411009,
    "descripcion":"LUXACIÓN CONGÉNITA BILATERAL DE RÓTULA"
  },
  {
    "codigo":724736002,
    "descripcion":"TRASTORNO DE OPOSICIÓN DESAFIANTE CONCOMITANTE SIN IRRITABILIDAD CRÓNICA-ENOJO CON EMOCIONES PROSOCIALES LIMITADAS"
  },
  {
    "codigo":1148885001,
    "descripcion":"GLOMERULOPATÍA DEBIDA A SÍNDROME DE MIOCLONÍA DE ACCIÓN - INSUFICIENCIA RENAL"
  },
  {
    "codigo":722901007,
    "descripcion":"PARÁLISIS DE ERB DUCHENNE CON NEUROMA DEBIDO A TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":427989008,
    "descripcion":"INSUFICIENCIA CRONOTRÓPICA"
  },
  {
    "codigo":194943002,
    "descripcion":"MIOCARDITIS ASÉPTICA AGUDA DEL RECIÉN NACIDO"
  },
  {
    "codigo":1145215002,
    "descripcion":"RADICULITIS DEBIDA A DESPLAZAMIENTO DE DISCO INTERVERTEBRAL"
  },
  {
    "codigo":120561000119104,
    "descripcion":"FIBROMIXOMA DE HUESO MAXILAR SUPERIOR"
  },
  {
    "codigo":293247004,
    "descripcion":"REACCIÓN ADVERSA AL ESTRADIOL TÓPICO"
  },
  {
    "codigo":31103006,
    "descripcion":"FRACTURA EXPUESTA DEL PRIMER HUESO METATARSIANO"
  },
  {
    "codigo":162175006,
    "descripcion":"ACTIVIDAD SEXUAL - DOS A TRES VECES POR MES"
  },
  {
    "codigo":29268000,
    "descripcion":"HIPERSENSIBILIDAD POR CONTACTO"
  },
  {
    "codigo":63871009,
    "descripcion":"PROLAPSO UTERINO DE TERCER GRADO"
  },
  {
    "codigo":94804003,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA CONJUNTIVA"
  },
  {
    "codigo":225876004,
    "descripcion":"DESEO DE MORIR"
  },
  {
    "codigo":191273000,
    "descripcion":"REACCIÓN LEUCEMOIDE DEL RECIÉN NACIDO"
  },
  {
    "codigo":289577001,
    "descripcion":"DISMINUCIÓN DE LOS LOQUIOS"
  },
  {
    "codigo":1010473005,
    "descripcion":"ESCLEROSIS DE EPÍFISIS DE FALANGE DISTAL DE DEDO MEÑIQUE CON RADIOPACIDAD AUMENTADA"
  },
  {
    "codigo":27433005,
    "descripcion":"ANESTESIA SEXUAL"
  },
  {
    "codigo":123902000,
    "descripcion":"INTOXICACIÓN POR CYCADACEAE"
  },
  {
    "codigo":715561008,
    "descripcion":"CARCINOMA PAPILAR DE CÉLULAS RENALES HEREDITARIO"
  },
  {
    "codigo":92969008,
    "descripcion":"AUSENCIA CONGÉNITA DE VÁLVULA MITRAL"
  },
  {
    "codigo":713726003,
    "descripcion":"RESISTENCIA FARMACOLÓGICA A AGENTE ANTIVIRAL"
  },
  {
    "codigo":25598004,
    "descripcion":"APENDICITIS RETROCECAL"
  },
  {
    "codigo":253139000,
    "descripcion":"AGENESIA DEL CUERPO CALLOSO CON LIPOMA"
  },
  {
    "codigo":254974009,
    "descripcion":"NEOPLASIA MALIGNA DE VAINA DE NERVIO ÓPTICO"
  },
  {
    "codigo":416979001,
    "descripcion":"PRESCRIPCIÓN RECOGIDA POR EL PACIENTE"
  },
  {
    "codigo":56531003,
    "descripcion":"ULEGIRIA"
  },
  {
    "codigo":285907004,
    "descripcion":"USA CALEFACTOR"
  },
  {
    "codigo":339851000119104,
    "descripcion":"ECTROPIÓN CICATRIZAL DE PÁRPADO INFERIOR IZQUIERDO"
  },
  {
    "codigo":449747006,
    "descripcion":"HALLAZGO RELACIONADO CON BORDES DE HERIDAS"
  },
  {
    "codigo":21928008,
    "descripcion":"GLAUCOMA SECUNDARIO DE ÁNGULO ABIERTO"
  },
  {
    "codigo":413309001,
    "descripcion":"NINGÚN MIEMBRO ADULTO DE LA FAMILIA LEE Y ESCRIBE EN INGLÉS"
  },
  {
    "codigo":249469002,
    "descripcion":"FALTA DE INTERÉS POR LA COMIDA"
  },
  {
    "codigo":16068491000119107,
    "descripcion":"ARTRITIS GOTOSA DE AMBAS RODILLAS"
  },
  {
    "codigo":1363581006,
    "descripcion":"MOVIMIENTOS FETALES PERCIBIDOS POR LA PAREJA"
  },
  {
    "codigo":282237006,
    "descripcion":"NO CAMINA CARGANDO UN JUGUETE GRANDE"
  },
  {
    "codigo":18258000,
    "descripcion":"ESTERILIDAD NORMOESPERMATOGÉNICA"
  },
  {
    "codigo":247634001,
    "descripcion":"PREOCUPACIÓN POR LITIGACIÓN"
  },
  {
    "codigo":216701006,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR DEMETÓN"
  },
  {
    "codigo":313170008,
    "descripcion":"COLONOSCOPIA NORMAL"
  },
  {
    "codigo":51026008,
    "descripcion":"INTOXICACIÓN POR TRIANTHEMA"
  },
  {
    "codigo":211196004,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE HOMBRO Y\/O BRAZO, INFECTADA"
  },
  {
    "codigo":735484005,
    "descripcion":"SENSACIÓN VESICAL AUSENTE DEBIDA A PROLAPSO DE ÓRGANO PÉLVICO"
  },
  {
    "codigo":1259772009,
    "descripcion":"NEOPLASIA PRIMARIA MALIGNA DE ENCÍA Y LUGARES CONTIGUOS"
  },
  {
    "codigo":702716009,
    "descripcion":"ENDOMETRITIS CRÓNICA REAGUDIZADA"
  },
  {
    "codigo":209361003,
    "descripcion":"FRACTURA-LUXACIÓN NO EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA DE MÚLTIPLES DEDOS DEL PIE"
  },
  {
    "codigo":405969004,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA DE VASO RENAL CON COMPROMISO TUMORAL"
  },
  {
    "codigo":274897005,
    "descripcion":"EPITELIOMA INTRAEPIDÉRMICO DE JADASSOHN"
  },
  {
    "codigo":699046000,
    "descripcion":"DOLOR CRANEOFACIAL"
  },
  {
    "codigo":305830005,
    "descripcion":"ATENDIDO POR EL SERVICIO DE NEONATOLOGÍA"
  },
  {
    "codigo":404134006,
    "descripcion":"LINFOMA MALIGNO SISTÉMICO DE CÉLULAS T GRANDES ANAPLÁSICAS"
  },
  {
    "codigo":369531002,
    "descripcion":"TUMOR MALIGNO QUE COMPROMETE EL OVARIO DERECHO POR PROPAGACIÓN DIRECTA DEL ENDOMETRIO"
  },
  {
    "codigo":41851003,
    "descripcion":"BRONCORREA"
  },
  {
    "codigo":238459004,
    "descripcion":"QUERATOMA PLANTAR INTRATABLE"
  },
  {
    "codigo":9083002,
    "descripcion":"PEDOFILIA, SEXO OPUESTO"
  },
  {
    "codigo":402299006,
    "descripcion":"PAPULOERITRODERMIA DE OFUJI"
  },
  {
    "codigo":7248001,
    "descripcion":"INTOXICACIÓN CAUSADA POR SALICILATO"
  },
  {
    "codigo":236624004,
    "descripcion":"CISTITIS AGUDA - CULTIVO NEGATIVO"
  },
  {
    "codigo":342361000119100,
    "descripcion":"HIPERTRICOSIS DE PÁRPADO INFERIOR IZQUIERDO"
  },
  {
    "codigo":16015551000119107,
    "descripcion":"OSTEOPATÍA DE AMBOS PIES POSTERIOR A POLIOMIELITIS"
  },
  {
    "codigo":300325003,
    "descripcion":"HÍGADO PEQUEÑO"
  },
  {
    "codigo":1079641000119101,
    "descripcion":"CONDROSARCOMA PRIMARIO DE OMÓPLATO DERECHO"
  },
  {
    "codigo":365861007,
    "descripcion":"HALLAZGO RELACIONADO CON EL ESTADO INMUNOLÓGICO"
  },
  {
    "codigo":5413009,
    "descripcion":"DISFUNCIÓN SEXUAL MASCULINA"
  },
  {
    "codigo":396794002,
    "descripcion":"TUMOR VIABLE PRESENTE EN ESPÉCIMEN"
  },
  {
    "codigo":429562001,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE MÚLTIPLES SITIOS"
  },
  {
    "codigo":298490004,
    "descripcion":"HALLAZGO RELACIONADO CON MEDICIONES CERVICALES"
  },
  {
    "codigo":724474006,
    "descripcion":"CISTOCELE Y RECTOCELE CONCOMITANTE CON PROLAPSO UTEROVAGINAL INCOMPLETO"
  },
  {
    "codigo":165583001,
    "descripcion":"RAZÓN INTERNACIONAL NORMALIZADA FUERA DE RANGO DE REFERENCIA"
  },
  {
    "codigo":722639002,
    "descripcion":"HERIDA PUNZANTE DE CUELLO SIN CUERPO EXTRAÑO"
  },
  {
    "codigo":67279004,
    "descripcion":"LESIÓN TRAUMÁTICA DEL NERVIO MEDIANO"
  },
  {
    "codigo":296655007,
    "descripcion":"SOBREDOSIS DE AMOXICILINA"
  },
  {
    "codigo":1279695008,
    "descripcion":"FIEBRE RECURRENTE CAUSADA POR BORRELIA PERSICA"
  },
  {
    "codigo":130980003,
    "descripcion":"SENSIBILIDAD VIBRATORIA DISMINUIDA"
  },
  {
    "codigo":294820006,
    "descripcion":"ALERGIA A GONADOTROFINA"
  },
  {
    "codigo":425892007,
    "descripcion":"SÍNDROME DE FALLA DEL BARORREFLEJO"
  },
  {
    "codigo":1144953008,
    "descripcion":"VASCULITIS DEBIDA A NEOPLASIA MALIGNA"
  },
  {
    "codigo":325753009,
    "descripcion":"MUTACIÓN POR DESPLAZAMIENTO DEL MARCO DE LECTURA"
  },
  {
    "codigo":291150002,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR HALOPERIDOL"
  },
  {
    "codigo":94542003,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA PIEL DE LA AXILA"
  },
  {
    "codigo":782670003,
    "descripcion":"PARAPLEJÍA ESPÁSTICA AUTOSÓMICA DOMINANTE TIPO 3"
  },
  {
    "codigo":27651000146102,
    "descripcion":"DISECCIÓN DE AORTA DESCENDENTE"
  },
  {
    "codigo":191011000,
    "descripcion":"INMUNODEFICIENCIA COMÚN VARIABLE, CON PREDOMINIO DE ANOMALÍAS EN EL RECUENTO Y LAS FUNCIONES DE LINFOCITOS B"
  },
  {
    "codigo":127310009,
    "descripcion":"HEMORRAGIA INTRACRANEAL POSTRAUMÁTICA CON PÉRDIDA MODERADA DE LA CONSCIENCIA"
  },
  {
    "codigo":289315001,
    "descripcion":"CORDÓN UMBILICAL NORMAL"
  },
  {
    "codigo":1010211003,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE EXTREMIDAD INFERIOR DERECHA"
  },
  {
    "codigo":420387003,
    "descripcion":"EXTENSIÓN TUMORAL EXTRAPROSTÁTICA PRESENTE, NO LOCALIZADA"
  },
  {
    "codigo":92707003,
    "descripcion":"CARCINOMA IN SITU DE LAS GLÁNDULAS SEBÁCEAS"
  },
  {
    "codigo":225614008,
    "descripcion":"AFLICCIÓN INESPERADA"
  },
  {
    "codigo":123640000,
    "descripcion":"SEQUEDAD DE LAS MEMBRANAS MUCOSAS"
  },
  {
    "codigo":1336056001,
    "descripcion":"EPISODIO DE USO NOCIVO DE METANFETAMINA"
  },
  {
    "codigo":189176002,
    "descripcion":"ENFERMEDAD INFECCIOSA DEL SISTEMA GENITOURINARIO"
  },
  {
    "codigo":25336002,
    "descripcion":"ÚTERO PARVICOLLIS"
  },
  {
    "codigo":254712007,
    "descripcion":"CARCINOMA ANEXIAL MICROQUÍSTICO"
  },
  {
    "codigo":416717003,
    "descripcion":"ATENDIDO EN CONSULTORIO ESPECIALIZADO EN INSUFICIENCIA CARDÍACA"
  },
  {
    "codigo":1137613004,
    "descripcion":"LÍNEA CAPILAR ANTERIOR ALTA"
  },
  {
    "codigo":23501004,
    "descripcion":"DEFICIENCIA DE ARGINASA"
  },
  {
    "codigo":56269007,
    "descripcion":"ÁNTRAX DE CONDUCTO DEFERENTE"
  },
  {
    "codigo":1332386004,
    "descripcion":"TROMBOSIS DE ARTERIAS CEREBRALES ANTERIORES BILATERALES"
  },
  {
    "codigo":251042004,
    "descripcion":"ENFERMEDAD DE ARTERIA PULMONAR PERIFÉRICA"
  },
  {
    "codigo":249207000,
    "descripcion":"MEMBRANAS EN ORIFICIO CERVICAL EXTERNO"
  },
  {
    "codigo":183671000,
    "descripcion":"RETIRADO DE LA LISTA DE ESPERA"
  },
  {
    "codigo":283810008,
    "descripcion":"MORDEDURA DE ANIMAL EN EL DORSO DE LA MANO"
  },
  {
    "codigo":773495009,
    "descripcion":"ATAXIA EPISÓDICA CON HABLA INCOMPRENSIBLE"
  },
  {
    "codigo":1230412003,
    "descripcion":"HIPOACUSIA PROFUNDA"
  },
  {
    "codigo":443980004,
    "descripcion":"SEPSIS NEUTROPÉNICA"
  },
  {
    "codigo":50764006,
    "descripcion":"VÓMITO POR ENFERMEDAD ORGÁNICA DURANTE EL EMBARAZO"
  },
  {
    "codigo":672551000119100,
    "descripcion":"AFASIA DEBIDA A ACCIDENTE CEREBROVASCULAR HEMORRÁGICO Y POSTERIOR A ÉL"
  },
  {
    "codigo":17996008,
    "descripcion":"NEUMOCONIOSIS CAUSADA POR POLVO INORGÁNICO"
  },
  {
    "codigo":737057000,
    "descripcion":"OSTEOARTROSIS DE TOBILLO IZQUIERDO O DE ARTICULACIÓN DE PIE"
  },
  {
    "codigo":312908007,
    "descripcion":"RETINOPATÍA PROLIFERATIVA INACTIVA DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":442145005,
    "descripcion":"DERMATITIS ATÓPICA CAUSADA POR CASPA ANIMAL"
  },
  {
    "codigo":704289006,
    "descripcion":"FRACTURA POR OSTEOPOROSIS SECUNDARIA DE PIE"
  },
  {
    "codigo":473078001,
    "descripcion":"ALERGIA A RALOXIFENO"
  },
  {
    "codigo":440310004,
    "descripcion":"FILTRACIÓN DE LÍQUIDO PARA DIÁLISIS PERITONEAL EN LA CAVIDAD PLEURAL"
  },
  {
    "codigo":99111000119103,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE TRACTO INTESTINAL"
  },
  {
    "codigo":112630007,
    "descripcion":"FACIES ANORMAL"
  },
  {
    "codigo":276470008,
    "descripcion":"MARCA CUTÁNEA"
  },
  {
    "codigo":733387001,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE TODO EL PENE"
  },
  {
    "codigo":1259510007,
    "descripcion":"CARCINOMA PRIMARIO DE ÓRGANO GENITAL"
  },
  {
    "codigo":10666791000119104,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN DE PIERNA IZQUEIRDA ESTADIO IV"
  },
  {
    "codigo":702454008,
    "descripcion":"NACIMIENTO SÉXTUPLE"
  },
  {
    "codigo":372939007,
    "descripcion":"ARTRITIS SUPURATIVA"
  },
  {
    "codigo":241867007,
    "descripcion":"EFECTO TÓXICO CAUSADO POR LÍQUIDO CORRECTOR"
  },
  {
    "codigo":43424001,
    "descripcion":"TÉTANOS NEONATAL"
  },
  {
    "codigo":307403007,
    "descripcion":"FÍSTULA AORTOYEYUNAL"
  },
  {
    "codigo":1290443008,
    "descripcion":"MALFORMACIÓN UTERINA ADQUIRIDA"
  },
  {
    "codigo":305568004,
    "descripcion":"BAJO ATENCIÓN DE ENFERMERA ESPECIALIZADA EN EL MANEJO DEL DOLOR"
  },
  {
    "codigo":15991591000119106,
    "descripcion":"IRIDOCICLITIS DE OJO IZQUIERDO CAUSADA POR MYCOBACTERIUM TUBERCULOSIS"
  },
  {
    "codigo":371104006,
    "descripcion":"SÍNDROME DE PIE-MANO EN ANEMIA DREPANOCÍTICA"
  },
  {
    "codigo":15719361000119100,
    "descripcion":"OSTEÍTIS DEFORMANTE BILATERAL DE FÉMURES"
  },
  {
    "codigo":403872008,
    "descripcion":"QUERATOSIS POR HIDROCARBUROS"
  },
  {
    "codigo":860789005,
    "descripcion":"TRASTORNO DE ANASTOMOSIS DE VÍA BILIAR"
  },
  {
    "codigo":762485006,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO DE CADERA"
  },
  {
    "codigo":344871000119108,
    "descripcion":"ATROFIA DE AMBAS ÓRBITAS"
  },
  {
    "codigo":11787201000119102,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE DEDO ANULAR IZQUIERDO"
  },
  {
    "codigo":400202001,
    "descripcion":"TRASTORNO DE PIEL DE MIEMBRO INFERIOR"
  },
  {
    "codigo":367434002,
    "descripcion":"ENFERMEDAD POR ERYSIPELOTHRIX"
  },
  {
    "codigo":205429009,
    "descripcion":"HEMIVÉRTEBRA DORSAL - ESTABLE"
  },
  {
    "codigo":234527002,
    "descripcion":"SARCOIDOSIS DE LA GLÁNDULA LAGRIMAL Y PARÓTIDA"
  },
  {
    "codigo":365599005,
    "descripcion":"PARÁSITOS: SEROLOGÍA - HALLAZGO"
  },
  {
    "codigo":298228000,
    "descripcion":"AMPLITUD DE MOVIMIENTO ARTICULAR, NORMAL"
  },
  {
    "codigo":724212000,
    "descripcion":"DEDO DE PIE EN MARTILLO CONGÉNITO"
  },
  {
    "codigo":36084002,
    "descripcion":"INTOXICACIÓN POR GELSEMIO SEMPERVIRENS"
  },
  {
    "codigo":396532004,
    "descripcion":"ESTADIO I: TUMOR CIRCUNSCRIPTO A LA GLÁNDULA, 5 CM O MENOS (CARCINOMA CORTICAL SUPRARRENAL)"
  },
  {
    "codigo":429300008,
    "descripcion":"GASTRITIS POR CITOMEGALOVIRUS"
  },
  {
    "codigo":394697003,
    "descripcion":"MOVIMIENTOS EXTRAPIRAMIDALES"
  },
  {
    "codigo":722377004,
    "descripcion":"SÍNDROME DE PARAGANGLIOMA Y SARCOMA DE ESTROMA GÁSTRICO"
  },
  {
    "codigo":296393006,
    "descripcion":"SOBREDOSIS DE FÁRMACO ANTICOLINÉRGICO"
  },
  {
    "codigo":1179294000,
    "descripcion":"SÍNDROME DE NEUROPATÍA MOTORA DISTAL AXONAL, MIOPATÍA MIOFIBRILAR AUTOSÓMICO DOMINANTE"
  },
  {
    "codigo":291931000119102,
    "descripcion":"TRASTORNO DE NERVIO CIÁTICO DERECHO"
  },
  {
    "codigo":425630003,
    "descripcion":"DERMATITIS IRRITATIVA AGUDA POR CONTACTO"
  },
  {
    "codigo":294558003,
    "descripcion":"ALERGIA A CEFOXITINA"
  },
  {
    "codigo":786078008,
    "descripcion":"EXCAVACIÓN ADQUIRIDA DE PAPILA ÓPTICA"
  },
  {
    "codigo":292723001,
    "descripcion":"REACCIÓN ADVERSA A ANTÍDOTO"
  },
  {
    "codigo":229022008,
    "descripcion":"RELACIÓN SEXUAL SIN PENETRACIÓN"
  },
  {
    "codigo":1144691005,
    "descripcion":"APLASIA DE FALANGE PROXIMAL DE SEGUNDO DEDO DE PIE"
  },
  {
    "codigo":194419007,
    "descripcion":"PÉRDIDA DE LA AUDICIÓN CONDUCTIVA COMBINADA"
  },
  {
    "codigo":94280003,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE GLÁNDULA ENDOCRINA"
  },
  {
    "codigo":290888005,
    "descripcion":"INTOXICACIÓN POR INHIBIDOR SELECTIVO DE LA RECAPTACIÓN DE SEROTONINA"
  },
  {
    "codigo":127048005,
    "descripcion":"ENFERMEDAD ÁRABE POR HEMOGLOBINA O DE CÉLULAS DREPANOCÍTICAS"
  },
  {
    "codigo":190749000,
    "descripcion":"MALABSORCIÓN DE GLUCOSA-GALACTOSA"
  },
  {
    "codigo":92445003,
    "descripcion":"NEOPLASIA BENIGNA DEL PILAR AMIGDALINO"
  },
  {
    "codigo":715037005,
    "descripcion":"DIFICULTAD PARA TOMAR MEDICACIÓN"
  },
  {
    "codigo":385522000,
    "descripcion":"CONTRACTURA EN FLEXIÓN"
  },
  {
    "codigo":1335794000,
    "descripcion":"ARTRITIS IDIOPÁTICA JUVENIL DE RODILLA"
  },
  {
    "codigo":713202001,
    "descripcion":"MORTINATO ANTES DEL PARTO"
  },
  {
    "codigo":254450000,
    "descripcion":"CARCINOMA DEL SURCO LABIAL SUPERIOR"
  },
  {
    "codigo":90610005,
    "descripcion":"FIBROSIS PULMONAR INTERSTICIAL EN BEBÉS PREMATUROS"
  },
  {
    "codigo":418290006,
    "descripcion":"PRURITO"
  },
  {
    "codigo":1237490005,
    "descripcion":"METÁSTASIS DE CARCINOMA DE ÓRGANO GENITAL"
  },
  {
    "codigo":449223003,
    "descripcion":"NEOPLASIA MALIGNA DE ALVÉOLO DE MAXILAR SUPERIOR"
  },
  {
    "codigo":840604002,
    "descripcion":"SOLO CAPAZ DE CONTAR DEDOS DE LA MANO A TRAVÉS DE AGUJERO ESTENOPEICO CON EL OJO DERECHO"
  },
  {
    "codigo":349084003,
    "descripcion":"GUSTO DESAGRADABLE EN LA BOCA"
  },
  {
    "codigo":347381000119106,
    "descripcion":"GLAUCOMA DE ÁNGULO AGUDO DE AMBOS OJOS"
  },
  {
    "codigo":185244006,
    "descripcion":"ATENDIDO EN UN CONSULTORIO PROCTOLÓGICO"
  },
  {
    "codigo":283548007,
    "descripcion":"HERIDA DE PERDIGÓN EN CUERO CABELLUDO"
  },
  {
    "codigo":707697002,
    "descripcion":"CARCINOMA PRIMARIO DE CÉLULAS ESCAMOSAS DE CARA HIPOFARÍNGEA DE PLIEGUE ARIEPIGLÓTICO"
  },
  {
    "codigo":19569008,
    "descripcion":"HIPEREMESIS GRAVÍDICA LEVE"
  },
  {
    "codigo":312646002,
    "descripcion":"QUEMADURA DE LA PIEL DE LA REGIÓN OCULAR"
  },
  {
    "codigo":320911000119103,
    "descripcion":"QUISTE ÓSEO SOLITARIO DE REGIÓN DE ARTICULACIÓN DE TOBILLO DERECHO"
  },
  {
    "codigo":278043000,
    "descripcion":"SEMINOMA MALIGNO DE MEDIASTINO"
  },
  {
    "codigo":15899001,
    "descripcion":"SECRECIÓN PANCREÁTICA AUMENTADA"
  },
  {
    "codigo":443718009,
    "descripcion":"ENFERMEDAD CELÍACA DETECTADA POR CRIBADO DE AUTOANTICUERPOS"
  },
  {
    "codigo":704027001,
    "descripcion":"FRACTURA EXPUESTA DE BASE DE SEGUNDO METACARPIANO"
  },
  {
    "codigo":734960001,
    "descripcion":"ÉMBOLO DE ARTERIA CEREBELOSA DERECHA"
  },
  {
    "codigo":210672001,
    "descripcion":"SECCIÓN TOTAL, TENDÓN FEMORAL DE LA CORVA"
  },
  {
    "codigo":1259248003,
    "descripcion":"CALCIFICACIÓN DE PRÓSTATA"
  },
  {
    "codigo":472816004,
    "descripcion":"URETERITIS EOSINOFÍLICA"
  },
  {
    "codigo":44997004,
    "descripcion":"MIOPATÍA DE CODORNICES DE LESBOS"
  },
  {
    "codigo":733125004,
    "descripcion":"BLOQUEO AURICULOVENTRICULAR COMPLETO ADQUIRIDO"
  },
  {
    "codigo":75930001,
    "descripcion":"QUISTE ANEURISMÁTICO DE MANDÍBULA"
  },
  {
    "codigo":10394003,
    "descripcion":"ATAXIA DE FRIEDREICH"
  },
  {
    "codigo":403610006,
    "descripcion":"ERUPCIÓN FIJA NO PIGMENTADA POR FÁRMACO"
  },
  {
    "codigo":43162008,
    "descripcion":"DIENTE ECTÓPICO"
  },
  {
    "codigo":698522009,
    "descripcion":"ABRASIÓN DE DIENTE QUE SE EXTIENDE HASTA LA PULPA"
  },
  {
    "codigo":41327002,
    "descripcion":"INVESTIGACIÓN POLICIAL"
  },
  {
    "codigo":272538009,
    "descripcion":"DE PIE EN EL AGUA CON LA BARANDILLA A UN LADO"
  },
  {
    "codigo":303471007,
    "descripcion":"CAPAZ DE RETIRAR PRÓTESIS"
  },
  {
    "codigo":399940000,
    "descripcion":"HAMARTOMA MUSCULAR"
  },
  {
    "codigo":268868001,
    "descripcion":"RECIÉN NACIDO MUY PREMATURO"
  },
  {
    "codigo":6724001,
    "descripcion":"PÁNCREAS ECTÓPICO EN EL DUODENO"
  },
  {
    "codigo":170564007,
    "descripcion":"ENFERMEDAD CRÓNICA - TRATAMIENTO MODIFICADO"
  },
  {
    "codigo":236100008,
    "descripcion":"DEHISCENCIA DE ANASTOMOSIS GÁSTRICA"
  },
  {
    "codigo":203332009,
    "descripcion":"ENFERMEDAD DE PAGET DE LA CLAVÍCULA"
  },
  {
    "codigo":37657006,
    "descripcion":"TRASTORNO DEL ESÓFAGO"
  },
  {
    "codigo":429038000,
    "descripcion":"APARICIÓN DE DOLOR DURANTE EL SUEÑO"
  },
  {
    "codigo":70425008,
    "descripcion":"SIGNO DE PISKACEK"
  },
  {
    "codigo":199662000,
    "descripcion":"RUPTURA PREMATURA DE MEMBRANAS, INICIO DEL TRABAJO DE PARTO LUEGO DE 24 HORAS"
  },
  {
    "codigo":201497009,
    "descripcion":"ARTRITIS REACTIVA DE ARTICULACIÓN DE REGIÓN DE HOMBRO DEBIDA A DISENTERÍA Y POSTERIOR A ELLA"
  },
  {
    "codigo":396270001,
    "descripcion":"HALLAZGO RELACIONADO CON EL MARGEN DE RESECCIÓN QUIRÚRGICA DE EPIPLÓN"
  },
  {
    "codigo":365337009,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA ORDENAR LA CASA"
  },
  {
    "codigo":232430006,
    "descripcion":"LARINGOTRAQUEOBRONQUITIS ALÉRGICA RECURRENTE"
  },
  {
    "codigo":297966008,
    "descripcion":"MARCA DE SUTURA"
  },
  {
    "codigo":363502009,
    "descripcion":"NEOPLASIA MALIGNA DE AXILA"
  },
  {
    "codigo":427203002,
    "descripcion":"NO PUEDE DETERMINARSE LA LOCALIZACIÓN DEL TUMOR"
  },
  {
    "codigo":296131003,
    "descripcion":"SOBREDOSIS DE MEPROBAMATO"
  },
  {
    "codigo":230595006,
    "descripcion":"NEUROPATÍA INFECCIOSA"
  },
  {
    "codigo":11818691000119105,
    "descripcion":"ESGUINCE DE LIGAMENTO DE ARTICULACIÓN INTERFALÁNGICA DE DEDO ÍNDICE DERECHO"
  },
  {
    "codigo":64920003,
    "descripcion":"EDAD GESTACIONAL, 31 SEMANAS"
  },
  {
    "codigo":677571000119107,
    "descripcion":"DESGARRO EN HERRADURA DE RETINA DE OJO IZQUIERDO SIN DESPRENDIMIENTO"
  },
  {
    "codigo":292461004,
    "descripcion":"REACCIÓN ADVERSA AL DILTIAZEM"
  },
  {
    "codigo":95853005,
    "descripcion":"FRACTURA METAFISARIA DE HUESO DE LA EXTREMIDAD INFERIOR"
  },
  {
    "codigo":1177197005,
    "descripcion":"HEMORRAGIA PREPARTO CON COAGULACIÓN INTRAVASCULAR DISEMINADA"
  },
  {
    "codigo":1144429009,
    "descripcion":"ATROFIA DE CORTEZA DE LÓBULOS FRONTALES Y TEMPORALES"
  },
  {
    "codigo":61250001,
    "descripcion":"NECROSIS HEPÁTICA DE LA ZONA MEDIA"
  },
  {
    "codigo":423533009,
    "descripcion":"INSUFICIENCIA RENAL AGUDA DEBIDA A ISQUEMIA"
  },
  {
    "codigo":126786001,
    "descripcion":"NEOPLASIA DE LA ZONA DE UNIÓN DE LA LENGUA"
  },
  {
    "codigo":94018006,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE PIEL DE CODO"
  },
  {
    "codigo":288791003,
    "descripcion":"NO COMENTA EVENTOS"
  },
  {
    "codigo":92183009,
    "descripcion":"NEOPLASIA BENIGNA DE LA CURVATURA MENOR DEL ESTÓMAGO"
  },
  {
    "codigo":1204460007,
    "descripcion":"DISFUNCIÓN MIOCÁRDICA SÉPTICA"
  },
  {
    "codigo":1237228009,
    "descripcion":"SÍNDROME DE CEGUERA NOCTURNA, ANOMALÍAS ESQUELÉTICAS Y DISMORFIA"
  },
  {
    "codigo":254188009,
    "descripcion":"EPIDERMÓLISIS DISTRÓFICA GENERALIZADA BULLOSA"
  },
  {
    "codigo":86678000,
    "descripcion":"ESTACIÓN NORMAL"
  },
  {
    "codigo":283286002,
    "descripcion":"ASTILLA DE MADERA EN CODO"
  },
  {
    "codigo":840342004,
    "descripcion":"TATUAJE DE CLORURO DE METILROSANILINIO"
  },
  {
    "codigo":707435002,
    "descripcion":"HIPERPLASIA DE CÉLULAS NEUROENDOCRINAS DE LA LACTANCIA"
  },
  {
    "codigo":248683004,
    "descripcion":"SOPLO PULMONAR DIASTÓLICO"
  },
  {
    "codigo":281451005,
    "descripcion":"AFLOJAMIENTO DE COMPONENTE FEMORAL EN REEMPLAZO TOTAL DE RODILLA"
  },
  {
    "codigo":19307009,
    "descripcion":"TROMBOCITOPENIA INMUNITARIA INDUCIDA POR FÁRMACOS"
  },
  {
    "codigo":1297259009,
    "descripcion":"CIERRE DE ÁNGULO AGUDO DE OJO DERECHO DEBIDO A MALFORMACIÓN CONGÉNITA DE ÁNGULO DE CÁMARA ANTERIOR DE OJO DERECHO"
  },
  {
    "codigo":30251000175108,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN EN CODO IZQUIERDO"
  },
  {
    "codigo":12271000132101,
    "descripcion":"INFECCIÓN MATERNA CAUSADA POR STREPTOCOCCUS AGALACTIAE"
  },
  {
    "codigo":249608004,
    "descripcion":"PRÓSTATA PEQUEÑA"
  },
  {
    "codigo":13802001,
    "descripcion":"ABSCESO DE LA AXILA"
  },
  {
    "codigo":439786007,
    "descripcion":"FÍSTULA ARTERIOVENOSA BRAQUIOCEFÁLICA CONSTRUIDA QUIRÚRGICAMENTE"
  },
  {
    "codigo":110271000,
    "descripcion":"ENFERMEDAD CAUSADA POR CIRCOVIRIDAE"
  },
  {
    "codigo":863935001,
    "descripcion":"TUMEFACCIÓN EN LUGAR DE INFUSIÓN"
  },
  {
    "codigo":77503002,
    "descripcion":"ENFERMEDAD POR VIRUS DE MARBURG"
  },
  {
    "codigo":210410008,
    "descripcion":"HERIDA ABIERTA DE LA PARED ANTERIOR DEL TÓRAX"
  },
  {
    "codigo":1089681000119104,
    "descripcion":"PERFORACIÓN TOTAL DE LA MEMBRANA TIMPÁNICA IZQUIERDA"
  },
  {
    "codigo":896703006,
    "descripcion":"FORMA DELGADA ANORMAL CONGÉNITA DE HUESO DE ANTEBRAZO"
  },
  {
    "codigo":700095006,
    "descripcion":"INTOLERANCIA AL TRIGO"
  },
  {
    "codigo":763796007,
    "descripcion":"LEUCEMIA MIELOIDE AGUDA MEGACARIOBLÁSTICA CON T(1;22)(P13;Q13)"
  },
  {
    "codigo":10132008,
    "descripcion":"QUEMADURAS DE SITIOS MÚLTIPLES"
  },
  {
    "codigo":403348008,
    "descripcion":"ACNÉ VULGAR INFLAMATORIO SUPERFICIAL"
  },
  {
    "codigo":335977000,
    "descripcion":"TUMEFACCIÓN DEL PENE"
  },
  {
    "codigo":237673003,
    "descripcion":"HIPERSECRECIÓN DE FSH"
  },
  {
    "codigo":204905003,
    "descripcion":"APLASIA CONGÉNITA DE LIGAMENTO REDONDO"
  },
  {
    "codigo":8297008,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN DEDO DEL PIE, SIN INFECCIÓN"
  },
  {
    "codigo":203070001,
    "descripcion":"CONTRACTURA DE MÚSCULO PSOAS ILÍACO"
  },
  {
    "codigo":235838003,
    "descripcion":"SÍNDROME DEL INTESTINO IRRITABLE, VARIANTE DE LA INFANCIA"
  },
  {
    "codigo":1153342008,
    "descripcion":"PSEUDOPOLICITEMIA DEBIDA A PÉRDIDA AGUDA DE VOLUMEN PLASMÁTICO"
  },
  {
    "codigo":365075001,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA EMPLEAR LA AUTOEXPRESIÓN"
  },
  {
    "codigo":102931001,
    "descripcion":"MIEDO A UN ATAQUE CARDÍACO"
  },
  {
    "codigo":39271000087100,
    "descripcion":"CONTUSIÓN DE DORSO DE MANO IZQUIERDA"
  },
  {
    "codigo":54631000087101,
    "descripcion":"STAPHYLOCOCCUS HAEMOLYTICUS O STAPHYLOCOCCUS LUGDUNENSIS"
  },
  {
    "codigo":234003006,
    "descripcion":"HEMORRAGIA ARTERIAL"
  },
  {
    "codigo":41831000087101,
    "descripcion":"CELULITIS DE PABELLÓN AURICULAR DERECHO"
  },
  {
    "codigo":1217043006,
    "descripcion":"MACROGENITOSOMÍA PRECOZ MASCULINA"
  },
  {
    "codigo":46951000087105,
    "descripcion":"FRACTURA DE FALANGE MEDIA DE ANULAR IZQUIERDO"
  },
  {
    "codigo":44391000087106,
    "descripcion":"LACERACIÓN COMPLEJA DE REGIÓN PERIORBITARIA DE OJO IZQUIERDO"
  },
  {
    "codigo":428776005,
    "descripcion":"TRASTORNO DE ARTICULACIÓN DE TOBILLO"
  },
  {
    "codigo":68328006,
    "descripcion":"ENFISEMA CENTROACINAR"
  },
  {
    "codigo":35560008,
    "descripcion":"ÚLCERA DUODENAL CON HEMORRAGIA PERO SIN OBSTRUCCIÓN"
  },
  {
    "codigo":295869001,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE IPRINDOL"
  },
  {
    "codigo":230333002,
    "descripcion":"ACATISIA MEDICAMENTOSA"
  },
  {
    "codigo":263101006,
    "descripcion":"FRACTURA-SUBLUXACIÓN DE LA ARTICULACIÓN RADIOCUBITAL SUPERIOR"
  },
  {
    "codigo":299461000119102,
    "descripcion":"NÓDULO REUMATOIDEO DE RODILLA"
  },
  {
    "codigo":292199001,
    "descripcion":"REACCIÓN ADVERSA AL BUSULFANO"
  },
  {
    "codigo":423271002,
    "descripcion":"INFECCIÓN CAUSADA POR STREPTOCOCCUS DEL GRUPO G"
  },
  {
    "codigo":718183003,
    "descripcion":"DISHORMONOGÉNESIS TIROIDEA FAMILIAR"
  },
  {
    "codigo":95591004,
    "descripcion":"LEUCOPLAQUIA DE LOS ÓRGANOS GENITALES MASCULINOS"
  },
  {
    "codigo":161127004,
    "descripcion":"INGRESO PRECOZ A LA ESCUELA POR RAZONES MÉDICAS"
  },
  {
    "codigo":783719006,
    "descripcion":"OBESIDAD DEBIDA A DEFICIENCIA DE SIM1"
  },
  {
    "codigo":126524003,
    "descripcion":"NEOPLASIA DE LA PIEL DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":1240521000000100,
    "descripcion":"OTITIS MEDIA DEBIDA A COVID-19"
  },
  {
    "codigo":1142332007,
    "descripcion":"ATROFIA DE MÚSCULO TENAR"
  },
  {
    "codigo":124689000,
    "descripcion":"DEFICIENCIA DE TRIPTÓFANO - ARNT LIGASA"
  },
  {
    "codigo":93756008,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE CUERPO CILIAR"
  },
  {
    "codigo":91921007,
    "descripcion":"AUSENCIA CONGÉNITA DE HUESO CIGOMÁTICO"
  },
  {
    "codigo":253926000,
    "descripcion":"FOCOMELIA DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":1204198001,
    "descripcion":"OCLUSIÓN AGUDA DE ARTERIA FEMORAL SUPERFICIAL DEBIDA A TROMBOSIS"
  },
  {
    "codigo":712678004,
    "descripcion":"BETA LACTAMASA POSITIVA"
  },
  {
    "codigo":1236966005,
    "descripcion":"METÁSTASIS DE CARCINOMA DE SURCO BUCAL SUPERIOR"
  },
  {
    "codigo":286694005,
    "descripcion":"TIENDE A SER TÍMIDO"
  },
  {
    "codigo":384998007,
    "descripcion":"INVASIÓN DE GRASA PERIPROSTÁTICA POR TUMOR NO IDENTIFICADO"
  },
  {
    "codigo":55483002,
    "descripcion":"ÚLCERA GÁSTRICA CRÓNICA PERFORADA Y CON OBSTRUCCIÓN"
  },
  {
    "codigo":250256002,
    "descripcion":"CRIOAGLUTININAS DETECTADAS"
  },
  {
    "codigo":283024006,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE CABEZA Y CUELLO"
  },
  {
    "codigo":1003920007,
    "descripcion":"SÍNDROME DE CABELLO QUEBRADIZO DE SABINAS"
  },
  {
    "codigo":84581000,
    "descripcion":"ENFERMEDAD DE LA CLOACA"
  },
  {
    "codigo":1264229001,
    "descripcion":"PARO CARDIORRESPIRATORIO FETAL"
  },
  {
    "codigo":182885000,
    "descripcion":"MEDICACIÓN SATISFACTORIA"
  },
  {
    "codigo":53648006,
    "descripcion":"ENFERMEDAD CAUSADA POR ENTEROVIRUS"
  },
  {
    "codigo":15729401000119100,
    "descripcion":"LUXACIÓN DE HOMBRO DERECHO DEBIDA A DISPLASIA CONGÉNITA"
  },
  {
    "codigo":248421005,
    "descripcion":"PIES CALIENTES"
  },
  {
    "codigo":709008009,
    "descripcion":"CUMPLE CON EL RÉGIMEN TERAPÉUTICO"
  },
  {
    "codigo":11987551000119108,
    "descripcion":"QUEMADURA EPIDÉRMICA DE ANTEBRAZO DERECHO"
  },
  {
    "codigo":1196858002,
    "descripcion":"ADENOMA DE VÍA BILIAR INTRAHEPÁTICA"
  },
  {
    "codigo":312122008,
    "descripcion":"INFECCIÓN BACTERIANA DEL APARATO CARDIOVASCULAR"
  },
  {
    "codigo":310287000,
    "descripcion":"ANTICUERPO ANTI- JO - 1 NO DETECTADO"
  },
  {
    "codigo":1259784006,
    "descripcion":"NEOPLASIA PRIMARIA MALIGNA MELANÓTICA DE VAINA DE NERVIO PERIFÉRICO"
  },
  {
    "codigo":1162255003,
    "descripcion":"GRUPO SANGUÍNEO FETAL RH POSITIVO"
  },
  {
    "codigo":95539004,
    "descripcion":"ESTENOSIS DEL ÍLEON"
  },
  {
    "codigo":898276007,
    "descripcion":"ANQUILOSIS CONGÉNITA DE ARTICULACIÓN INTERFALÁNGICA DISTAL DE DEDO MEÑIQUE"
  },
  {
    "codigo":403086006,
    "descripcion":"TIÑA CAUSADA POR TRICHOPHYTON VIOLACEUM"
  },
  {
    "codigo":763534009,
    "descripcion":"EPILEPSIA REFLEJA POR AGUA CALIENTE"
  },
  {
    "codigo":366648000,
    "descripcion":"HALLAZGO RELACIONADO CON LA COLORACIÓN DE ARTICULACIÓN DE DEDO DE PIE"
  },
  {
    "codigo":399416001,
    "descripcion":"NO SE PUEDE VALORAR LA EXTENSIÓN DEL COMPROMISO DEL MARGEN DE RESECCIÓN QUIRÚRGICA POR CARCINOMA DUCTAL IN SITU"
  },
  {
    "codigo":170040002,
    "descripcion":"TALLA DEL NIÑO ENTRE PERCENTILOS 90 Y 96"
  },
  {
    "codigo":716296001,
    "descripcion":"PERFORACIÓN DE RESTAURACIÓN DENTAL"
  },
  {
    "codigo":401251008,
    "descripcion":"CONTROL DE CARDIOPATÍA CORONARIA - SEGUNDA CARTA DE CONVOCATORIA"
  },
  {
    "codigo":301112006,
    "descripcion":"HALLAZGO RELACIONADO CON EL RITMO CARDÍACO"
  },
  {
    "codigo":440511000124103,
    "descripcion":"INGESTA EXCESIVA DE ÉSTER DE ESTANOL VEGETAL"
  },
  {
    "codigo":200973000,
    "descripcion":"PSORIASIS PUSTULOSA"
  },
  {
    "codigo":233741000,
    "descripcion":"MEDIASTINITIS GRANULOMATOSA FARMACÓGENA"
  },
  {
    "codigo":38968006,
    "descripcion":"INTOXICACIÓN CAUSADA POR ALCALOIDE DEL CORNEZUELO DE CENTENO"
  },
  {
    "codigo":430349003,
    "descripcion":"HEMORRAGIA GASTROINTESTINAL ALTA ASOCIADA CON ESTADO DE HIPERCOAGULABILIDAD"
  },
  {
    "codigo":299277000,
    "descripcion":"AMPLITUD DE ADUCCIÓN ACTIVA DE LA CADERA DISMINUIDA"
  },
  {
    "codigo":16905261000119100,
    "descripcion":"MELANOMA MALIGNO DE PIEL DE PÁRPADO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":364813006,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA LLEVARSE EL ALIMENTO A LA BOCA"
  },
  {
    "codigo":37133005,
    "descripcion":"PIELITIS TUBERCULOSA"
  },
  {
    "codigo":1149410000,
    "descripcion":"SOBREDOSIS DE ÉTER DIETÍLICO"
  },
  {
    "codigo":788962001,
    "descripcion":"INFECCIÓN DE LA VÍA URINARIA CAUSADA POR HERPES SIMPLE"
  },
  {
    "codigo":301971000119109,
    "descripcion":"CAPSULITIS ADHESIVA DE HOMBRO DERECHO"
  },
  {
    "codigo":166370007,
    "descripcion":"NIVELES DE GONADOTROFINAS DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":35298007,
    "descripcion":"ESTREÑIMIENTO COLÓNICO"
  },
  {
    "codigo":295607004,
    "descripcion":"SOBREDOSIS DE TREOSULFANO"
  },
  {
    "codigo":426679004,
    "descripcion":"FRACTURA POR AVULSIÓN NO EXPUESTA DE ESPINA ILÍACA ANTEROINFERIOR DE LA PELVIS"
  },
  {
    "codigo":262839006,
    "descripcion":"CONTUSIÓN DE ESTÓMAGO"
  },
  {
    "codigo":719756000,
    "descripcion":"MACRÓFAGOS CARGADOS CON HEMOSIDERINA OBSERVADOS"
  },
  {
    "codigo":197303009,
    "descripcion":"CIRROSIS PORTAL BACTERIANA"
  },
  {
    "codigo":721591008,
    "descripcion":"ULCERACIÓN DE VULVA Y VAGINA"
  },
  {
    "codigo":293772003,
    "descripcion":"ALERGIA A MERCAPTOPURINA"
  },
  {
    "codigo":685101000119106,
    "descripcion":"HEMOGLOBINA E-BETA + TALASEMIA"
  },
  {
    "codigo":457612009,
    "descripcion":"TROMBOSIS DE VÁLVULA TRICÚSPIDE"
  },
  {
    "codigo":160865003,
    "descripcion":"PEDIDO DE ADOPCIÓN DE UN NIÑO"
  },
  {
    "codigo":95329006,
    "descripcion":"ENFERMEDAD AUTOINMUNITARIA DE LA PIEL"
  },
  {
    "codigo":1142070004,
    "descripcion":"INFECCIÓN NEONATAL DE OMBLIGO CAUSADA POR MÚLTIPLES MICROBIOS"
  },
  {
    "codigo":93494007,
    "descripcion":"ENFERMEDAD DE HODGKIN, PREDOMINIO LINFOCÍTICO - HISTIOCÍTICO, DE GANGLIOS LINFÁTICOS INTRAPÉLVICOS"
  },
  {
    "codigo":26123004,
    "descripcion":"INFECCIÓN CAUSADA POR METORCHIS"
  },
  {
    "codigo":714251006,
    "descripcion":"LEUCEMIA LINFOBLÁSTICA AGUDA DE PRECURSORES DE LINFOCITOS B NEGATIVA PARA CROMOSOMA FILADELFIA"
  },
  {
    "codigo":15649991000119105,
    "descripcion":"GANGRENA DE MIEMBRO INFERIOR IZQUIERDO DEBIDA A ATEROSCLEROSIS"
  },
  {
    "codigo":124427009,
    "descripcion":"DEFICIENCIA DE 3 - HIDROXISOBUTIRILO COA HIDROLASA"
  },
  {
    "codigo":286432000,
    "descripcion":"NO ABASTECE A OTROS"
  },
  {
    "codigo":384736003,
    "descripcion":"GRADO NUCLEAR - HALLAZGO"
  },
  {
    "codigo":24288004,
    "descripcion":"CELULITIS DE TOBILLO"
  },
  {
    "codigo":253664001,
    "descripcion":"ANILLO VASCULAR CON CAYADO AÓRTICO DERECHO"
  },
  {
    "codigo":10734791000119107,
    "descripcion":"CAMBIO FIBROQUÍSTICO DE MAMA DERECHA"
  },
  {
    "codigo":284597008,
    "descripcion":"EXCESIVAMENTE AFECTUOSO"
  },
  {
    "codigo":315530005,
    "descripcion":"NACIDO EN SAN VICENTE"
  },
  {
    "codigo":413834006,
    "descripcion":"ENFERMEDAD CRÓNICA DE LA FUNCIÓN INMUNOLÓGICA"
  },
  {
    "codigo":249994007,
    "descripcion":"SE ENCOGE HASTA EL PISO"
  },
  {
    "codigo":51551000,
    "descripcion":"HEMORROIDES SANGRANTES"
  },
  {
    "codigo":282762007,
    "descripcion":"LESIÓN UNGUEAL DE LOS DEDOS DE LA MANO"
  },
  {
    "codigo":1263967002,
    "descripcion":"SOBREPRÓTESIS APOYADA SOBRE IMPLANTE IN SITU"
  },
  {
    "codigo":444767004,
    "descripcion":"NIÑO DE PRIMERA INFANCIA CAPRICHOSO"
  },
  {
    "codigo":1231199009,
    "descripcion":"FRACTURA DE PORCIÓN ORBITARIA DE HUESO CIGOMÁTICO"
  },
  {
    "codigo":705076001,
    "descripcion":"FRACTURA NO EXPUESTA DE PLACA EPIFISARIA DE HÚMERO DISTAL"
  },
  {
    "codigo":770612003,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DE PIEL DE DEDO DE LA MANO"
  },
  {
    "codigo":15705441000119107,
    "descripcion":"CONCRECIÓN EN CONJUNTIVA DE AMBOS PÁRPADOS INFERIORES"
  },
  {
    "codigo":15113004,
    "descripcion":"INFECCIÓN CAUSADA POR HAEMONCHUS"
  },
  {
    "codigo":277257008,
    "descripcion":"TUMEFACCIÓN SUPRAGLÓTICA"
  },
  {
    "codigo":703241008,
    "descripcion":"ENTEROMONAS HOMINIS O RETORTAMONAS INTESTINALIS"
  },
  {
    "codigo":766942007,
    "descripcion":"OBSTRUCCIÓN COMPLETA DE COLON"
  },
  {
    "codigo":404659001,
    "descripcion":"NEUROPATÍA ÓPTICA ANTERIOR ISQUÉMICA"
  },
  {
    "codigo":11443001,
    "descripcion":"APRAXIA ACINÉTICA"
  },
  {
    "codigo":765107002,
    "descripcion":"SEPSIS NEONATAL DE COMIENZO TARDÍO"
  },
  {
    "codigo":352001000119100,
    "descripcion":"MELANOMA MALIGNO DE PIEL DE MIEMBRO INFERIOR DERECHO"
  },
  {
    "codigo":318721000119100,
    "descripcion":"ARTROSIS DE ARTICULACIÓN DE REGIÓN DE HOMBRO DERECHO"
  },
  {
    "codigo":15671041000119100,
    "descripcion":"GENU RECURVATUM CONGÉNITO IZQUIERDO"
  },
  {
    "codigo":10753281000119103,
    "descripcion":"RUPTURA PREMATURA DE MEMBRANAS EN EMBARAZO A TÉRMINO CON MOMENTO DE COMIENZO DEL TRABAJO DE PARTO DESCONOCIDO"
  },
  {
    "codigo":304520000,
    "descripcion":"BLOQUEO DE PRÓTESIS ESOFÁGICA"
  },
  {
    "codigo":349441000119103,
    "descripcion":"COLOBOMA ADQUIRIDO DE DISCO ÓPTICO"
  },
  {
    "codigo":479737601000119105,
    "descripcion":"MELANOMA MALIGNO PRIMARIO DE MEMBRANA MUCOSA DE FARINGE"
  },
  {
    "codigo":308481000119106,
    "descripcion":"GRANULOMA POR CUERPO EXTRAÑO DE PARTES BLANDAS DE MUSLO DERECHO"
  },
  {
    "codigo":298241000119106,
    "descripcion":"MIOSITIS OSIFICANTE TRAUMÁTICA DE PIERNA"
  },
  {
    "codigo":15709441000119109,
    "descripcion":"HIPOPIGMENTACIÓN DE PÁRPADO DERECHO Y DE ÁREA PERIOCULAR DERECHA"
  },
  {
    "codigo":11795201000119108,
    "descripcion":"LESIÓN TRAUMÁTICA DE VENA SUBCLAVIA DERECHA"
  },
  {
    "codigo":238984005,
    "descripcion":"RUBEOSIS FACIAL DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":42376006,
    "descripcion":"ENCEFALOCELE OCCIPITAL"
  },
  {
    "codigo":341761000119109,
    "descripcion":"ESCOTOMA CENTROCECAL DE OJO IZQUIERDO"
  },
  {
    "codigo":40541001,
    "descripcion":"EDEMA AGUDO DE PULMÓN"
  },
  {
    "codigo":7773002,
    "descripcion":"DIFTERIA CONJUNTIVAL"
  },
  {
    "codigo":336641000119108,
    "descripcion":"PROTRUSIÓN DE LENTE INTRAOCULAR"
  },
  {
    "codigo":106077005,
    "descripcion":"HALLAZGO EN EL SISTEMA TEGUMENTARIO"
  },
  {
    "codigo":370056005,
    "descripcion":"INVASIÓN TUMORAL EN BRONQUIO, IN SITU"
  },
  {
    "codigo":271752007,
    "descripcion":"FIEBRE EN ESCALERA"
  },
  {
    "codigo":366386003,
    "descripcion":"AMPLITUD DE MOVIMIENTO PASIVO DE EXTENSIÓN DE LA COLUMNA CERVICAL - HALLAZGO"
  },
  {
    "codigo":300850006,
    "descripcion":"TUMORACIÓN DE ESTRUCTURA DEL OÍDO"
  },
  {
    "codigo":724999003,
    "descripcion":"HIPOPLASIA AISLADA DE NERVIO ÓPTICO"
  },
  {
    "codigo":309683008,
    "descripcion":"POCILGA"
  },
  {
    "codigo":299015005,
    "descripcion":"ARTICULACIÓN DE MUÑECA INESTABLE"
  },
  {
    "codigo":428252001,
    "descripcion":"VAGINITIS EN EL EMBARAZO"
  },
  {
    "codigo":1149148001,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR DESOXICORTICOSTERONA"
  },
  {
    "codigo":2268003,
    "descripcion":"VÍCTIMA DE AGRESIÓN HOMOSEXUAL"
  },
  {
    "codigo":723164006,
    "descripcion":"CARCINOMA IN SITU DE PIEL DE PENE"
  },
  {
    "codigo":198876008,
    "descripcion":"INTENTO FALLIDO DE ABORTO REALIZADO CON MÉTODOS NO QUIRÚRGICOS, COMPLICADO POR EMBOLIA"
  },
  {
    "codigo":721329001,
    "descripcion":"LESIÓN TRAUMÁTICA CERRADA DE GLOBO OCULAR"
  },
  {
    "codigo":10874671000119101,
    "descripcion":"HERIDA ABIERTA DE PÁRPADO IZQUIERDO"
  },
  {
    "codigo":262577006,
    "descripcion":"LESIÓN POR DESOLLAMIENTO"
  },
  {
    "codigo":459185007,
    "descripcion":"CIERRE ESPONTÁNEO DE COMUNICACIÓN INTERAURICULAR ADQUIRIDA"
  },
  {
    "codigo":195206000,
    "descripcion":"ISQUEMIA CEREBRAL INTERMITENTE"
  },
  {
    "codigo":424582000,
    "descripcion":"SOBRECARGA DE ESTRÉS"
  },
  {
    "codigo":129670002,
    "descripcion":"CERVICITIS HERPÉTICA"
  },
  {
    "codigo":10628911000119103,
    "descripcion":"GASTROENTERITIS CAUSADA POR VIRUS DE LA GRIPE A"
  },
  {
    "codigo":162438006,
    "descripcion":"EL SÍNTOMA COMENZÓ HACE SEMANAS"
  },
  {
    "codigo":422747000,
    "descripcion":"INFECCIÓN DE LA VÍA URINARIA SUPERIOR"
  },
  {
    "codigo":1145478008,
    "descripcion":"HIPOPLASIA CONGÉNITA DE FALANGE MEDIA DE DEDO ÍNDICE"
  },
  {
    "codigo":95067000,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE PIEL DE INGLE"
  },
  {
    "codigo":160603005,
    "descripcion":"FUMADOR LEVE DE CIGARRILLOS (1-9 CIGARRILLOS POR DÍA)"
  },
  {
    "codigo":226139009,
    "descripcion":"DIETA MODIFICADA EN VITAMINAS"
  },
  {
    "codigo":783195009,
    "descripcion":"TUMOR EPITELIAL BENIGNO DE GLÁNDULA SALIVAL"
  },
  {
    "codigo":289840004,
    "descripcion":"LESIÓN DE OVARIO"
  },
  {
    "codigo":93232005,
    "descripcion":"HIPERFLEXIÓN CONGÉNITA DE MIEMBRO"
  },
  {
    "codigo":60464005,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO SEVERO DE ÓRGANOS ABDOMINALES CON HERIDA ABIERTA HACIA CAVIDAD"
  },
  {
    "codigo":27696007,
    "descripcion":"NUDO VERDADERO DEL CORDÓN UMBILICAL"
  },
  {
    "codigo":715824008,
    "descripcion":"ATAXIA ESPINOCEREBELOSA TIPO 28"
  },
  {
    "codigo":713989000,
    "descripcion":"CAPAZ DE ABSTENERSE DE BEBER"
  },
  {
    "codigo":224304004,
    "descripcion":"NO RECIBE EDUCACIÓN"
  },
  {
    "codigo":124165006,
    "descripcion":"DEFICIENCIA DE SUCCINATO DESHIDROGENASA"
  },
  {
    "codigo":417242001,
    "descripcion":"DISFUNCIÓN SOMÁTICA DE COSTILLA"
  },
  {
    "codigo":58629009,
    "descripcion":"MIOCARDIOPATÍA DILATADA SECUNDARIA A AMILOIDOSIS"
  },
  {
    "codigo":253402005,
    "descripcion":"DOBLE ORIFICIO DE VÁLVULA MITRAL"
  },
  {
    "codigo":286170006,
    "descripcion":"DIFICULTAD PARA LIMPIAR EL INODORO"
  },
  {
    "codigo":284335002,
    "descripcion":"CAPAZ DE COLOCAR UN OBJETO SOBRE OTRO"
  },
  {
    "codigo":218799005,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR CAFEÍNA"
  },
  {
    "codigo":448175007,
    "descripcion":"ADMINISTRACIÓN DE MEDICACIÓN EXCESIVAMENTE RÁPIDA"
  },
  {
    "codigo":85892000,
    "descripcion":"PROMISCUIDAD"
  },
  {
    "codigo":54959009,
    "descripcion":"ATELECTASIA PERINATAL"
  },
  {
    "codigo":251567009,
    "descripcion":"DESCARGA REPETITIVA CON UN SOLO ESTÍMULO"
  },
  {
    "codigo":53124003,
    "descripcion":"PROLINURIA"
  },
  {
    "codigo":249732004,
    "descripcion":"PELVIS INCLINADA"
  },
  {
    "codigo":282500004,
    "descripcion":"INCAPAZ DE SUBIR UNA COLINA CORRIENDO"
  },
  {
    "codigo":335971000119100,
    "descripcion":"UVEÍTIS ANTERIOR CRÓNICA DE OJO DERECHO"
  },
  {
    "codigo":1073251000119100,
    "descripcion":"ARTRITIS DE CODO IZQUIERDO CAUSADA POR BACTERIAS"
  },
  {
    "codigo":708484008,
    "descripcion":"LESIÓN VESICOEROSIVA"
  },
  {
    "codigo":446340009,
    "descripcion":"INFECCIÓN DE SITIO DE SALIDA DE CATÉTER"
  },
  {
    "codigo":1003396003,
    "descripcion":"DELECIÓN DE PORCIÓN MEDIA DE CROMOSOMA 13"
  },
  {
    "codigo":20356004,
    "descripcion":"INTOXICACIÓN POR SORGO VULGARE"
  },
  {
    "codigo":444505007,
    "descripcion":"ZONA AMARILLA EN LA ESTIMACIÓN DE PESO PEDIÁTRICO DE BROSELOW LUTEN"
  },
  {
    "codigo":247897007,
    "descripcion":"INTENTA PROMOVER LA OMNIPOTENCIA"
  },
  {
    "codigo":49454000,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE FLANCO CON INFECCIÓN"
  },
  {
    "codigo":213294002,
    "descripcion":"PERITONITIS QUÍMICA"
  },
  {
    "codigo":16686005,
    "descripcion":"EFECTO TÓXICO DEL ÁCIDO CIANHÍDRICO"
  },
  {
    "codigo":737582007,
    "descripcion":"SÍNDROME DE HEMIPARKINSONISMO Y HEMIATROFIA"
  },
  {
    "codigo":276995001,
    "descripcion":"HALLAZGO RELACIONADO CON EL POTENCIAL EVOCADO VISUAL"
  },
  {
    "codigo":442670009,
    "descripcion":"MICROORGANISMO MÓVIL"
  },
  {
    "codigo":702979003,
    "descripcion":"NUNCA CONSUMIÓ TABACO"
  },
  {
    "codigo":1260035002,
    "descripcion":"CARCINOMA DE SENO ETMOIDAL"
  },
  {
    "codigo":735747007,
    "descripcion":"TRAQUEOBRONCOMALACIA NEONATAL"
  },
  {
    "codigo":80387009,
    "descripcion":"ENFERMEDAD DE ROGER"
  },
  {
    "codigo":439000005,
    "descripcion":"HIPERFIBRINOGENEMIA"
  },
  {
    "codigo":12105981000119100,
    "descripcion":"QUEMADURA DE BRAZO DERECHO"
  },
  {
    "codigo":371629001,
    "descripcion":"LUXACIÓN CONGÉNITA DE CODO"
  },
  {
    "codigo":240557004,
    "descripcion":"SÍFILIS SECUNDARIA"
  },
  {
    "codigo":109485006,
    "descripcion":"HIPOPLASIA LOCALIZADA DEL ESMALTE ASOCIADA CON TRAUMATISMO LOCALIZADO"
  },
  {
    "codigo":764845008,
    "descripcion":"ADENOCARCINOMA DE CONDUCTO ANAL"
  },
  {
    "codigo":238722001,
    "descripcion":"HEMORRAGIA SUBUNGUEAL"
  },
  {
    "codigo":402562005,
    "descripcion":"MELANOMA MALIGNO TIPO ANIMAL"
  },
  {
    "codigo":9346006,
    "descripcion":"CAPACIDAD VITAL NORMAL"
  },
  {
    "codigo":107650008,
    "descripcion":"HALLAZGO RELACIONADO CON EL COLOR"
  },
  {
    "codigo":74882009,
    "descripcion":"INTOXICACIÓN POR FENITOÍNA"
  },
  {
    "codigo":235052000,
    "descripcion":"HEMANGIOMA SENIL DE LABIO"
  },
  {
    "codigo":15956221000119105,
    "descripcion":"ADENOCARCINOMA METASTÁSICO DE PULMÓN DERECHO"
  },
  {
    "codigo":890412002,
    "descripcion":"DACRIOCELE BILATERAL"
  },
  {
    "codigo":300588002,
    "descripcion":"INDENTABLE"
  },
  {
    "codigo":366124008,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA TOSER"
  },
  {
    "codigo":298753001,
    "descripcion":"ENTUMECIMIENTO DE LOS MIEMBROS SUPERIORES"
  },
  {
    "codigo":202284008,
    "descripcion":"CONTRACTURA EN EXTENSIÓN DE LA CADERA"
  },
  {
    "codigo":11860221000119107,
    "descripcion":"ESGUINCE DE LIGAMENTO LATERAL INTERNO DE RODILLA IZQUIERDA"
  },
  {
    "codigo":3841004,
    "descripcion":"AMPOLLA DE LA MEJILLA, CON INFECCIÓN"
  },
  {
    "codigo":724737006,
    "descripcion":"TRASTORNO DE OPOSICIÓN DESAFIANTE SIN IRRITABILIDAD CRÓNICA-ENOJO CON EMOCIONES PROSOCIALES NORMALES"
  },
  {
    "codigo":722902000,
    "descripcion":"CEFALOHEMATOMA DEFORMANTE DE SCHULLER"
  },
  {
    "codigo":1148886000,
    "descripcion":"NECROSIS TESTICULAR DEBIDA A TORSIÓN"
  },
  {
    "codigo":34774005,
    "descripcion":"AUSENCIA CONGÉNITA DE BRONQUIOS"
  },
  {
    "codigo":360619001,
    "descripcion":"DEFICIENCIA DE BUTIRILCOLINESTERASA"
  },
  {
    "codigo":32939004,
    "descripcion":"HAMBRE MÓRBIDA"
  },
  {
    "codigo":171008,
    "descripcion":"LESIÓN TRAUMÁTICA DE COLON DERECHO SIN HERIDA ABIERTA HACIA CAVIDAD ABDOMINAL"
  },
  {
    "codigo":1145216001,
    "descripcion":"NEURITIS BRAQUIAL DEBIDA A DESPLAZAMIENTO DE DISCO INTERVERTEBRAL CERVICAL"
  },
  {
    "codigo":719232003,
    "descripcion":"DIFICULTAD PARA CAMINAR"
  },
  {
    "codigo":338481000119100,
    "descripcion":"GLAUCOMA POR PSEUDOEXFOLIACIÓN DE OJO IZQUIERDO"
  },
  {
    "codigo":162176007,
    "descripcion":"ACTIVIDAD SEXUAL - MENSUAL"
  },
  {
    "codigo":194944008,
    "descripcion":"MIOCARDITIS AGUDA - VIRUS COXSACKIE"
  },
  {
    "codigo":422485001,
    "descripcion":"MIOTONÍA DURANTE EL CIERRE OCULAR"
  },
  {
    "codigo":94805002,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE PARTES BLANDAS"
  },
  {
    "codigo":293248009,
    "descripcion":"REACCIÓN ADVERSA A SULFATO DE ESTRONA PIPERAZINA"
  },
  {
    "codigo":15739441000119101,
    "descripcion":"GLAUCOMA DE OJO DERECHO DEBIDO A LESIÓN TRAUMÁTICA DE GLOBO OCULAR DERECHO Y POSTERIOR A ELLA"
  },
  {
    "codigo":1144584004,
    "descripcion":"TERMORREGULACIÓN NORMAL"
  },
  {
    "codigo":846634000,
    "descripcion":"AFECCIÓN RESPIRATORIA CRÓNICA CAUSADA POR HUMOS"
  },
  {
    "codigo":715562001,
    "descripcion":"RETINOPATÍA PUNTEADA ALBESCENTE"
  },
  {
    "codigo":11833751000119108,
    "descripcion":"ESGUINCE DE LIGAMENTO PERONEOASTRAGALINO DE TOBILLO DERECHO"
  },
  {
    "codigo":289578006,
    "descripcion":"LOQUIOS AUSENTES"
  },
  {
    "codigo":92970009,
    "descripcion":"AUSENCIA CONGÉNITA DEL CORNETE NASAL"
  },
  {
    "codigo":254975005,
    "descripcion":"MENINGIOMA MALIGNO DE LA VAINA DEL NERVIO ÓPTICO"
  },
  {
    "codigo":123903005,
    "descripcion":"INTOXICACIÓN POR THYMELAEACEAE"
  },
  {
    "codigo":713727007,
    "descripcion":"HEMOPERITONEO COMO COMPLICACIÓN DE DIÁISIS PERITONEAL"
  },
  {
    "codigo":418815008,
    "descripcion":"ALERGIA A CARNE ROJA"
  },
  {
    "codigo":449748001,
    "descripcion":"BORDES DE HERIDA ADHERIDOS"
  },
  {
    "codigo":25599007,
    "descripcion":"INTOXICACIÓN POR ETOSUXIMIDA"
  },
  {
    "codigo":253140003,
    "descripcion":"AGENESIA PARCIAL DEL CUERPO CALLOSO"
  },
  {
    "codigo":187604008,
    "descripcion":"NEOPLASIA MALIGNA DE LABIO INFERIOR, EXTERNA"
  },
  {
    "codigo":285908009,
    "descripcion":"NO UTILIZA ESTUFA ELÉCTRICA"
  },
  {
    "codigo":1075761000119107,
    "descripcion":"ATROFIA MUSCULAR DE PIE IZQUIERDO"
  },
  {
    "codigo":249470001,
    "descripcion":"NO PUEDE VER LA COMIDA"
  },
  {
    "codigo":282238001,
    "descripcion":"DIFICULTAD PARA CAMINAR CARGANDO UN JUGUETE GRANDE"
  },
  {
    "codigo":447913009,
    "descripcion":"DEFECTO DE SENO CORONARIO COMPLETAMENTE DESTECHADO EN AURÍCULA IZQUIERDA"
  },
  {
    "codigo":1363582004,
    "descripcion":"MOVIMIENTOS FETALES PALPADOS POR PROFESIONAL DE SALUD"
  },
  {
    "codigo":216702004,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR DIAZINÓN"
  },
  {
    "codigo":247635000,
    "descripcion":"PREOCUPACIÓN SEXUAL"
  },
  {
    "codigo":85630009,
    "descripcion":"CRANEÓPAGO OCCIPITAL"
  },
  {
    "codigo":16424000,
    "descripcion":"SÍNDROME DE GLUCAGONOMA"
  },
  {
    "codigo":737320000,
    "descripcion":"HEMORRAGIA TARDÍA DEBIDA A EMBARAZO MOLAR Y POSTERIOR A ÉL"
  },
  {
    "codigo":18259008,
    "descripcion":"ANOMALÍA ELECTROENCEFALOGRÁFICA SIN CONVULSIÓN"
  },
  {
    "codigo":344104004,
    "descripcion":"HEMIANOPSIA HETERÓNIMA"
  },
  {
    "codigo":278568005,
    "descripcion":"ALTERACIÓN DE LA COLORACIÓN DE OBTURACIÓN DENTAL"
  },
  {
    "codigo":442408006,
    "descripcion":"ALERGIA A IMIPENEM"
  },
  {
    "codigo":702717000,
    "descripcion":"CERVICITIS CRÓNICA REAGUDIZADA"
  },
  {
    "codigo":1259773004,
    "descripcion":"ASTROCITOMA ANAPLÁSICO PRIMARIO DE MÉDULA ESPINAL"
  },
  {
    "codigo":735485006,
    "descripcion":"SENSACIÓN DE VEJIGA URINARIA DISMINUIDA CONCOMITANTE CON PROLAPSO DE ÓRGANO PÉLVICO Y DEBIDA A ÉL"
  },
  {
    "codigo":14589007,
    "descripcion":"FACOANAFILAXIA"
  },
  {
    "codigo":733650000,
    "descripcion":"SÍNDROME DE NEFRONOPTISIS FAMILIAR DEL ADULTO CON CUADRIPARESIA ESPÁSTICA"
  },
  {
    "codigo":211197008,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE HOMBRO"
  },
  {
    "codigo":274898000,
    "descripcion":"TRICOEPITELIOMA"
  },
  {
    "codigo":405970003,
    "descripcion":"ESTADIO V DEL GRUPO NACIONAL PARA EL ESTUDIO DEL TUMOR DE WILMS"
  },
  {
    "codigo":209362005,
    "descripcion":"FRACTURA-LUXACIÓN EXPUESTA DE PIE"
  },
  {
    "codigo":373202006,
    "descripcion":"COMPROMISO TUMORAL EN MARGEN DE RESECCIÓN QUIRÚRGICA (RADIAL) PROFUNDA, PRESENTE (COLON\/RECTO)"
  },
  {
    "codigo":830119000,
    "descripcion":"ATAXIA DE AMBOS MIEMBROS INFERIORES"
  },
  {
    "codigo":404135007,
    "descripcion":"LINFOMA MALIGNO ANGIOCÉNTRICO DE LINFOCITOS T Y LINFOCITOS CITOLÍTICOS NATURALES QUE COMPROMETE PIEL"
  },
  {
    "codigo":305831009,
    "descripcion":"ATENDIDO POR SERVICIO DE HEMOTERAPIA"
  },
  {
    "codigo":402300003,
    "descripcion":"ERITRODERMIA DE ETIOLOGÍA DESCONOCIDA"
  },
  {
    "codigo":41852005,
    "descripcion":"PILOTO EN ACCIDENTE AÉREO"
  },
  {
    "codigo":1287036009,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE CADERA DERECHA POSTERIOR A REMOCIÓN DE PRÓTESIS"
  },
  {
    "codigo":238460009,
    "descripcion":"CUERNO VASCULAR"
  },
  {
    "codigo":236625003,
    "descripcion":"CISTITIS RECURRENTE - CULTIVO NEGATIVO"
  },
  {
    "codigo":369532009,
    "descripcion":"TUMOR MALIGNO QUE COMPROMETE EL OVARIO DERECHO POR PROPAGACIÓN DIRECTA DESDE TROMPA DE FALOPIO"
  },
  {
    "codigo":40017005,
    "descripcion":"SÍNDROME COSTOCLAVICULAR"
  },
  {
    "codigo":302161006,
    "descripcion":"URTICARIA IDIOPÁTICA AGUDA"
  },
  {
    "codigo":365862000,
    "descripcion":"HALLAZGO RELACIONADO CON EL ESTADO DE INMUNIDAD PARA LA RUBÉOLA"
  },
  {
    "codigo":300326002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CONSISTENCIA DEL HÍGADO"
  },
  {
    "codigo":5414003,
    "descripcion":"QUEMADURA DE CUALQUIER GRADO QUE COMPROMETE 80-89 PORCIENTO DE LA SUPERFICIE DEL CUERPO"
  },
  {
    "codigo":398630005,
    "descripcion":"CITRULINURIA"
  },
  {
    "codigo":1119526006,
    "descripcion":"COMPORTAMIENTO VISUAL DEFICIENTE PARA LA EDAD"
  },
  {
    "codigo":169254007,
    "descripcion":"ECOGRAFÍA NORMAL"
  },
  {
    "codigo":396795001,
    "descripcion":"TUMOR NO VIABLE PRESENTE EN ESPÉCIMEN"
  },
  {
    "codigo":36347008,
    "descripcion":"ÚLCERA TRÓFICA CRÓNICA DE LA EXTREMIDAD INFERIOR"
  },
  {
    "codigo":722640000,
    "descripcion":"HERIDA PUNZANTE DE CUELLO CON CUERPO EXTRAÑO"
  },
  {
    "codigo":1744008,
    "descripcion":"FUSIÓN DE DIENTES"
  },
  {
    "codigo":1279696009,
    "descripcion":"INFECCIÓN CAUSADA POR BORRELIA PERSICA"
  },
  {
    "codigo":296656008,
    "descripcion":"SOBREDOSIS DE CLOXACILINA"
  },
  {
    "codigo":130981004,
    "descripcion":"HORMONAS ESTEROIDEAS ANORMALES"
  },
  {
    "codigo":294821005,
    "descripcion":"ALERGIA A LEUPRORELINA"
  },
  {
    "codigo":196517008,
    "descripcion":"SIALECTASIA PAROTÍDEA"
  },
  {
    "codigo":1144954002,
    "descripcion":"DISFUNCIÓN ERÉCTIL DEBIDA A FIBROSIS DE CUERPO CAVERNOSO"
  },
  {
    "codigo":340991000119109,
    "descripcion":"CICATRIZ CORIORRETINIANA DISEMINADA DE OJO IZQUIERDO"
  },
  {
    "codigo":29007000,
    "descripcion":"INFECCIÓN CAUSADA POR AMPHIMERUS ELONGATUS"
  },
  {
    "codigo":94543008,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA PIEL DE LA ESPALDA"
  },
  {
    "codigo":127311008,
    "descripcion":"HEMORRAGIA INTRACRANEAL POSTRAUMÁTICA CON PÉRDIDA PROLONGADA DE LA CONSCIENCIA Y POSTERIOR RECUPERACIÓN DEL NIVEL DE CONSCIENCIA PREEXISTENTE"
  },
  {
    "codigo":11783321000119105,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN DE CADERA DERECHA"
  },
  {
    "codigo":27172003,
    "descripcion":"SIMBIOSIS TRIVALENTE"
  },
  {
    "codigo":225615009,
    "descripcion":"DUELO REPENTINO"
  },
  {
    "codigo":1010212005,
    "descripcion":"DISPLASIA CONGÉNITA DE CADERA IZQUIERDA"
  },
  {
    "codigo":191012007,
    "descripcion":"INMUNODEFICIENCIA COMÚN VARIABLE, CON PREDOMINIO DE TRASTORNOS DE LA INMUNORREGULACIÓN DE LINFOCITOS T"
  },
  {
    "codigo":1303289000,
    "descripcion":"LIPOMA ESPINAL DE CONO EXTRAMEDULAR"
  },
  {
    "codigo":92708008,
    "descripcion":"CARCINOMA IN SITU DE COLON SIGMOIDE"
  },
  {
    "codigo":123641001,
    "descripcion":"OCLUSIÓN DE LA ARTERIA CORONARIA IZQUIERDA"
  },
  {
    "codigo":715300008,
    "descripcion":"SOBREDOSIS DE DISULFIRAM"
  },
  {
    "codigo":254713002,
    "descripcion":"CARCINOMA MUCOEPIDERMOIDE DE PIEL"
  },
  {
    "codigo":1336057005,
    "descripcion":"EPISODIO DE USO NOCIVO DE ANTIDEPRESIVO"
  },
  {
    "codigo":1137614005,
    "descripcion":"LÍNEA DE IMPLANTACIÓN POSTERIOR DE CABELLO BAJA"
  },
  {
    "codigo":449486006,
    "descripcion":"CONDUCTO VENOSO AUSENTE CON CONEXIÓN DIRECTA DE VENA UMBILICAL A VENA RENAL"
  },
  {
    "codigo":23502006,
    "descripcion":"ENFERMEDAD DE LYME"
  },
  {
    "codigo":416718008,
    "descripcion":"DERMATITIS PARPEBRAL POR HERPES ZÓSTER"
  },
  {
    "codigo":56270008,
    "descripcion":"NÓDULOS DE SURFEADOR"
  },
  {
    "codigo":414883002,
    "descripcion":"CANTIDAD DE DÍAS CONSECUTIVOS CON VELOCIDAD DE FLUJO ESPIRATORIO PICO MENOR DE 80%"
  },
  {
    "codigo":87203005,
    "descripcion":"TRASTORNO BIPOLAR I, EPISODIO MÁS RECIENTE DEPRESIVO DE INICIO EN EL PERÍODO POSTPARTO"
  },
  {
    "codigo":283811007,
    "descripcion":"MORDEDURA DE ANIMAL EN LA PALMA DE LA MANO"
  },
  {
    "codigo":1332387008,
    "descripcion":"SÍNDROME CARDIO-UROGENITAL"
  },
  {
    "codigo":251043009,
    "descripcion":"PODAMIENTO DE ARTERIA PULMONAR PERIFÉRICA"
  },
  {
    "codigo":52600004,
    "descripcion":"TRASTORNO DE LA OSMOLALIDAD"
  },
  {
    "codigo":773496005,
    "descripcion":"ALERGIA A DROSTANOLONA"
  },
  {
    "codigo":312909004,
    "descripcion":"RETINOPATÍA PROLIFERATIVA CON NEOVASCULARIZACIÓN DEL IRIS DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":1197645007,
    "descripcion":"FALTA DE LAVAMANOS FUNCIONAL EN LA VIVIENDA"
  },
  {
    "codigo":247373008,
    "descripcion":"DOLOR DE TOBILLO"
  },
  {
    "codigo":704290002,
    "descripcion":"FRACTURA POR OSTEOPOROSIS SECUNDARIA DE PERONÉ"
  },
  {
    "codigo":737058005,
    "descripcion":"CÁNCER COLORRECTAL CON ELEVADA INESTABILIDAD DE MICROSATÉLITE"
  },
  {
    "codigo":440311000,
    "descripcion":"CATÉTER URINARIO SUPRAPÚBICO IN SITU"
  },
  {
    "codigo":79863002,
    "descripcion":"INTENSIDAD AUMENTADA DEL PRIMER RUIDO CARDÍACO, R>1<"
  },
  {
    "codigo":112631006,
    "descripcion":"ESPÉCIMEN INSATISFACTORIO PARA EL DIAGNÓSTICO"
  },
  {
    "codigo":276471007,
    "descripcion":"MARCA DE LOS DEDOS POR APRETÓN"
  },
  {
    "codigo":1259511006,
    "descripcion":"DEMENCIA DEBIDA A ENFERMEDAD DE WILSON"
  },
  {
    "codigo":473079009,
    "descripcion":"INFLAMACIÓN ASOCIADA CON DISPOSITIVO ANTICONCEPTIVO INTRAUTERINO RETENIDO"
  },
  {
    "codigo":309239009,
    "descripcion":"HALLAZGOS CITOLÓGICOS LIMÍTROFES"
  },
  {
    "codigo":307404001,
    "descripcion":"FÍSTULA AORTOCOLÓNICA"
  },
  {
    "codigo":78028004,
    "descripcion":"CONTUSIÓN DEL TRONCO ENCEFÁLICO CON HERIDA INTRACRANEAL ABIERTA Y CONMOCIÓN"
  },
  {
    "codigo":438476003,
    "descripcion":"PÚRPURA TROMBOCITOPÉNICA TROMBÓTICA AUTOINMUNITARIA"
  },
  {
    "codigo":733388006,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE PARTE DEL PENE"
  },
  {
    "codigo":372940009,
    "descripcion":"ARTRITIS SUPURATIVA AGUDA"
  },
  {
    "codigo":403873003,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS INTRAEPIDÉRMICO DE CUERO CABELLUDO"
  },
  {
    "codigo":240033006,
    "descripcion":"BURSITIS RETROCALCÁNEA"
  },
  {
    "codigo":371105007,
    "descripcion":"HIPOXIA DURANTE LA ALIMENTACIÓN EN EL RECIÉN NACIDO"
  },
  {
    "codigo":305569007,
    "descripcion":"BAJO ATENCIÓN DE ENFERMERA PEDIÁTRICA"
  },
  {
    "codigo":860790001,
    "descripcion":"DEHISCENCIA DE ANASTOMOSIS DE MEMBRANA MUCOSA DE BRONQUIO"
  },
  {
    "codigo":205430004,
    "descripcion":"HEMIVÉRTEBRA DORSAL - INESTABLE"
  },
  {
    "codigo":41590007,
    "descripcion":"POLINEUROPATÍA AMILOIDE FAMILIAR, TIPO JUDÍA"
  },
  {
    "codigo":39755000,
    "descripcion":"ÚLCERA DE CURLING"
  },
  {
    "codigo":762486007,
    "descripcion":"QUEMADURA PROFUNDA DE TERCER GRADO DE CADERA"
  },
  {
    "codigo":301899003,
    "descripcion":"DISECCIÓN DE AORTA PROXIMAL"
  },
  {
    "codigo":72523005,
    "descripcion":"ICTIOSIS LIGADA AL SEXO"
  },
  {
    "codigo":203595008,
    "descripcion":"TORSIÓN TIBIAL INTERNA ADQUIRIDA"
  },
  {
    "codigo":5152006,
    "descripcion":"ILUSIÓN"
  },
  {
    "codigo":234528007,
    "descripcion":"SARCOIDOSIS NASOFARÍNGEA"
  },
  {
    "codigo":365600008,
    "descripcion":"NIVEL DE FACTOR REUMATOIDEO"
  },
  {
    "codigo":429301007,
    "descripcion":"ANQUILOSIS DE ARTICULACIÓN DEL PIE"
  },
  {
    "codigo":298229008,
    "descripcion":"AMPLITUD DE MOVIMIENTO ARTICULAR ACTIVO NORMAL"
  },
  {
    "codigo":396533009,
    "descripcion":"ESTADIO II: TUMOR CIRCUNSCRIPTO A LA GLÁNDULA, MAYOR A 5 CM (CARCINOMA CORTICAL SUPRARRENAL)"
  },
  {
    "codigo":296394000,
    "descripcion":"SOBREDOSIS DE HIOSCINA"
  },
  {
    "codigo":1482004,
    "descripcion":"QUISTE DE LA GLÁNDULA DE MEIBOMIO"
  },
  {
    "codigo":34250006,
    "descripcion":"PENFIGOIDE BENIGNO DE MEMBRANAS MUCOSAS"
  },
  {
    "codigo":722378009,
    "descripcion":"SÍNDROME DE CATARATA CONGÉNITA CON SORDERA E HIPOGONADISMO"
  },
  {
    "codigo":229023003,
    "descripcion":"MASTURBACIÓN MUTUA"
  },
  {
    "codigo":1179295004,
    "descripcion":"DISTROFIA MUSCULAR DE CINTURAS AUTOSÓMICA RECESIVA TIPO 2X"
  },
  {
    "codigo":294559006,
    "descripcion":"ALERGIA A FOSFOMICINA"
  },
  {
    "codigo":1144692003,
    "descripcion":"APLASIA DE FALANGE PROXIMAL DE CUARTO DEDO DE PIE"
  },
  {
    "codigo":1083291000119100,
    "descripcion":"PERICONDRITIS CRÓNICA BILATERAL"
  },
  {
    "codigo":292724007,
    "descripcion":"REACCIÓN ADVERSA A LA IPECACUANA"
  },
  {
    "codigo":389193000,
    "descripcion":"DISPLASIA OSTEOPLÁSICA, TIPO I"
  },
  {
    "codigo":421961002,
    "descripcion":"REACCIÓN DE HIPERSENSIBILIDAD"
  },
  {
    "codigo":127049002,
    "descripcion":"ANEMIA HEMOLÍTICA AUTOINMUNITARIA PRIMARIA (IDIOPÁTICA)"
  },
  {
    "codigo":290889002,
    "descripcion":"INTOXICACIÓN POR SERTRALINA"
  },
  {
    "codigo":94281004,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL ENDOMETRIO"
  },
  {
    "codigo":715038000,
    "descripcion":"CAPAZ DE LLORAR"
  },
  {
    "codigo":92446002,
    "descripcion":"NEOPLASIA BENIGNA DE LA TRÁQUEA"
  },
  {
    "codigo":878878007,
    "descripcion":"MALFORMACIÓN CONGÉNITA CAUSADA POR ÁCIDO VALPROICO"
  },
  {
    "codigo":59678008,
    "descripcion":"SIGNO DE POPEYE"
  },
  {
    "codigo":289054008,
    "descripcion":"CAPAZ DE UTILIZAR TENEDOR PARA ALIMENTARSE"
  },
  {
    "codigo":254451001,
    "descripcion":"CARCINOMA IN SITU DEL SURCO LABIAL SUPERIOR"
  },
  {
    "codigo":188915003,
    "descripcion":"NEOPLASIA BENIGNA DEL PALADAR ÓSEO"
  },
  {
    "codigo":1335795004,
    "descripcion":"ARTRITIS IDIOPÁTICA JUVENIL DE RODILLA IZQUIERDA"
  },
  {
    "codigo":418291005,
    "descripcion":"HERIDA OCULAR REZUMANTE"
  },
  {
    "codigo":713203006,
    "descripcion":"LESIÓN TRAUMÁTICA DE HÍGADO DURANTE PROCEDIMIENTO QUIRÚRGICO"
  },
  {
    "codigo":187080002,
    "descripcion":"ABSCESO FEOMICÓTICO DE CEREBRO"
  },
  {
    "codigo":285384003,
    "descripcion":"DETERIORO GENERAL DE LA SALUD"
  },
  {
    "codigo":88776002,
    "descripcion":"DEFICIENCIA HEREDITARIA DE FACTOR V"
  },
  {
    "codigo":414621000,
    "descripcion":"ABERRACIÓN VISUAL DE BAJO ORDEN"
  },
  {
    "codigo":449224009,
    "descripcion":"NEOPLASIA MALIGNA DE MEDIASTINO ANTERIOR"
  },
  {
    "codigo":86941000,
    "descripcion":"SÍNDROME DE MALABSORCIÓN DE ÁCIDOS BILIARES, TIPO I"
  },
  {
    "codigo":711368009,
    "descripcion":"PÓLIPO DE ÁNGULO ESPLÉNICO DEL COLON"
  },
  {
    "codigo":283549004,
    "descripcion":"HERIDA DE PERDIGÓN EN CARA"
  },
  {
    "codigo":185245007,
    "descripcion":"ATENDIDO EN UN CONSULTORIO GASTROENTEROLÓGICO"
  },
  {
    "codigo":412786000,
    "descripcion":"ESCASO CONTACTO VISUAL"
  },
  {
    "codigo":447389009,
    "descripcion":"LEIOMIOSARCOMA DE ÚTERO"
  },
  {
    "codigo":445554007,
    "descripcion":"ASIMETRÍA CONGÉNITA DE AMÍGDALAS"
  },
  {
    "codigo":443719001,
    "descripcion":"LEIOMIOSARCOMA"
  },
  {
    "codigo":83271005,
    "descripcion":"LARINGOTRAQUEÍTIS CRÓNICA"
  },
  {
    "codigo":319541000119105,
    "descripcion":"ARTRITIS REACTIVA DE ARTICULACIÓN DE CADERA IZQUIERDA"
  },
  {
    "codigo":247111009,
    "descripcion":"ARTERIAS RETINIANAS IRREGULARES"
  },
  {
    "codigo":704028006,
    "descripcion":"FRACTURA NO EXPUESTA EN MARTILLO DE FALANGE DISTAL DE DEDO ÍNDICE"
  },
  {
    "codigo":278044006,
    "descripcion":"NEUROMA MALIGNO DE MEDIASTINO"
  },
  {
    "codigo":46833000,
    "descripcion":"INTOXICACIÓN POR ROMULEA"
  },
  {
    "codigo":15900006,
    "descripcion":"INFECCIÓN CAUSADA POR SCHISTOSOMATIUM DOUTHITTI"
  },
  {
    "codigo":734961002,
    "descripcion":"ÉMBOLO DE ARTERIA CEREBRAL POSTERIOR IZQUIERDA"
  },
  {
    "codigo":15966261000119107,
    "descripcion":"DISPLASIA FIBROMUSCULAR DE PARED DE ARTERIA RENAL IZQUIERDA"
  },
  {
    "codigo":210673006,
    "descripcion":"SECCIÓN PARCIAL, TENDÓN DEL CUÁDRICEPS"
  },
  {
    "codigo":208838000,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA NO EXPUESTA DE LA ARTICULACIÓN RADIOCUBITAL DISTAL"
  },
  {
    "codigo":733126003,
    "descripcion":"OCLUSIÓN AGUDA DE ARTERIA DE MIEMBRO SUPERIOR CAUSADA POR TROMBOEMBOLIA"
  },
  {
    "codigo":272539001,
    "descripcion":"INCLINADO DE PIE EN EL AGUA CERCA DEL BORDE"
  },
  {
    "codigo":44998009,
    "descripcion":"CAMBIOS DEL SEGMENTO ST VENTRICULAR DERECHO"
  },
  {
    "codigo":698523004,
    "descripcion":"ABRASIÓN DE DIENTE LIMITADA AL ESMALTE"
  },
  {
    "codigo":303472000,
    "descripcion":"INCAPAZ DE RETIRAR PRÓTESIS"
  },
  {
    "codigo":301637000,
    "descripcion":"CAPAZ DE SUBIRSE Y BAJARSE DE LOS MUEBLES"
  },
  {
    "codigo":203333004,
    "descripcion":"ENFERMEDAD DE PAGET DEL OMÓPLATO"
  },
  {
    "codigo":39493006,
    "descripcion":"INTOXICACIÓN POR ASCLEPIAS FRUCTICOSA"
  },
  {
    "codigo":236101007,
    "descripcion":"DEHISCENCIA DE ANASTOMOSIS DUODENAL"
  },
  {
    "codigo":299802000,
    "descripcion":"REFLEJO GLABELAR PRESENTE"
  },
  {
    "codigo":170565008,
    "descripcion":"ENFERMEDAD CRÓNICA - CONTROL DE CUMPLIMIENTO DE TERAPIA FARMACOLÓGICA"
  },
  {
    "codigo":292958008,
    "descripcion":"REACCIÓN ADVERSA A LA FENETICILINA"
  },
  {
    "codigo":365338004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA REALIZAR ACTIVIDADES DE SEGURIDAD DOMÉSTICA"
  },
  {
    "codigo":396271002,
    "descripcion":"HALLAZGO RELACIONADO CON EL MARGEN QUIRÚRGICO PERIMETRAL"
  },
  {
    "codigo":348521000119104,
    "descripcion":"DEGENERACIÓN POSTERIOR DEL VÍTREO DE OJO IZQUIERDO"
  },
  {
    "codigo":363503004,
    "descripcion":"NEOPLASIA MALIGNA DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":68591005,
    "descripcion":"HIPOPLASIA CONGÉNITA DEL PÁNCREAS"
  },
  {
    "codigo":296132005,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE MEPROBAMATO"
  },
  {
    "codigo":230596007,
    "descripcion":"POLINEUROPATÍA DIFTÉRICA"
  },
  {
    "codigo":425369003,
    "descripcion":"INSUFICIENCIA RENAL CRÓNICA PROGRESIVA"
  },
  {
    "codigo":64921004,
    "descripcion":"INTOXICACIÓN CAUSADA POR FENOBARBITAL"
  },
  {
    "codigo":691000221104,
    "descripcion":"ENFERMEDAD DE CHAGAS EN EL EMBARAZO"
  },
  {
    "codigo":423534003,
    "descripcion":"DESARROLLO DEL LENGUAJE - INTENTA REPETIR SONIDOS DEL HABLA"
  },
  {
    "codigo":1144430004,
    "descripcion":"ATROFIA CEREBRAL GLOBAL"
  },
  {
    "codigo":718446005,
    "descripcion":"DIFICULTAD CON LA VENTILACIÓN POR MÁSCARA Y LA INTUBACIÓN TRAQUEAL"
  },
  {
    "codigo":292462006,
    "descripcion":"REACCIÓN ADVERSA AL NICARDIPINO"
  },
  {
    "codigo":290627000,
    "descripcion":"INTOXICACIÓN POR LOMUSTINA"
  },
  {
    "codigo":61251002,
    "descripcion":"HIPERQUERATOSIS PLANTAR EN LA FRAMBESIA"
  },
  {
    "codigo":94019003,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE PIEL DE CONDUCTO AUDITIVO EXTERNO"
  },
  {
    "codigo":126787005,
    "descripcion":"NEOPLASIA DE GLÁNDULA SALIVAL MAYOR"
  },
  {
    "codigo":92184003,
    "descripcion":"NEOPLASIA BENIGNA DE AMÍGDALA LINGUAL"
  },
  {
    "codigo":288792005,
    "descripcion":"DIFICULTAD PARA COMENTAR EVENTOS"
  },
  {
    "codigo":254189001,
    "descripcion":"EPIDERMÓLISIS BULLOSA BENIGNA DISTRÓFICA RECESIVA GENERALIZADA"
  },
  {
    "codigo":1204461006,
    "descripcion":"LESIÓN GASTROINTESTINAL CON SEPSIS"
  },
  {
    "codigo":24813008,
    "descripcion":"COMPLICACIÓN GASTROINTESTINAL"
  },
  {
    "codigo":55746001,
    "descripcion":"ÚLCERA PÉPTICA CRÓNICA CON HEMORRAGIA Y PERFORACIÓN PERO SIN OBSTRUCCIÓN"
  },
  {
    "codigo":448962006,
    "descripcion":"UTILIZA DISPOSITIVO INTRAUTERINO DE COBRE COMO MÉTODO ANTICONCEPTIVO"
  },
  {
    "codigo":22978007,
    "descripcion":"MANEJO DE UN HOGAR QUE ATRAVIESA UNA SITUACIÓN DE ALTERACIÓN, CRÓNICO"
  },
  {
    "codigo":21143006,
    "descripcion":"PETEQUIAS CALCÁNEAS"
  },
  {
    "codigo":283287006,
    "descripcion":"ASTILLA DE MADERA EN ANTEBRAZO"
  },
  {
    "codigo":840343009,
    "descripcion":"TATUAJE IATROGÉNICO"
  },
  {
    "codigo":707436001,
    "descripcion":"CAPILARITIS PULMONAR AISLADA"
  },
  {
    "codigo":281452003,
    "descripcion":"AFLOJAMIENTO DE COMPONENTE TIBIAL DE REEMPLAZO TOTAL DE RODILLA"
  },
  {
    "codigo":1297260004,
    "descripcion":"CIERRE DE ÁNGULO AGUDO DE OJO IZQUIERDO DEBIDO A MALFORMACIÓN CONGÉNITA DE ÁNGULO DE CÁMARA ANTERIOR DE OJO IZQUIERDO"
  },
  {
    "codigo":248684005,
    "descripcion":"SOPLO MITRAL MESODIASTÓLICO"
  },
  {
    "codigo":12065591000119100,
    "descripcion":"QUEMADURA DE OÍDO IZQUIERDO"
  },
  {
    "codigo":312385000,
    "descripcion":"SERVICIO DE GUARDERÍA Y CUIDADO DE NIÑOS EN CASAS DE FAMILIA"
  },
  {
    "codigo":246849001,
    "descripcion":"FALTA DE PRODUCCIÓN DE LÁGRIMAS"
  },
  {
    "codigo":441622000,
    "descripcion":"CATARATA PRESENIL"
  },
  {
    "codigo":212246006,
    "descripcion":"LESIÓN DEL NERVIO INTERCOSTAL"
  },
  {
    "codigo":112107000,
    "descripcion":"TRASTORNO PRIMARIO DEL SENTIDO DEL GUSTO DE LOS SABORES AMARGOS"
  },
  {
    "codigo":277782009,
    "descripcion":"RECURRENCIA PERITONEAL MALIGNA LOCAL"
  },
  {
    "codigo":1258987002,
    "descripcion":"ESCOLIOSIS DEGENERATIVA DE COLUMNA VERTEBRAL DE ADULTO"
  },
  {
    "codigo":15638008,
    "descripcion":"AMUSIA MOTORA"
  },
  {
    "codigo":210411007,
    "descripcion":"HERIDAS ABIERTAS MÚLTIPLES DE LA PARED TORÁCICA"
  },
  {
    "codigo":274112000,
    "descripcion":"ABSCESO EN LOS GENITALES MASCULINOS"
  },
  {
    "codigo":896704000,
    "descripcion":"FORMA DELGADA ANORMAL CONGÉNITA DE DIÁFISIS DE HÚMERO"
  },
  {
    "codigo":403349000,
    "descripcion":"ACNÉ VULGAR INFLAMATORIO Y COMEDÓNICO MIXTO SUPERFICIAL"
  },
  {
    "codigo":763797003,
    "descripcion":"SÍNDROME DE AGENESIA DE CUERPO CALLOSO Y GENITALES ANORMALES"
  },
  {
    "codigo":978253001000132109,
    "descripcion":"ENTEROSCOPIA DE INTESTINO DELGADO NORMAL"
  },
  {
    "codigo":270442000,
    "descripcion":"CONTROL DE ASMA REALIZADO"
  },
  {
    "codigo":8298003,
    "descripcion":"VAINA ARTERIOLAR"
  },
  {
    "codigo":678711000119109,
    "descripcion":"VISIÓN EN TÚNEL DE OJO IZQUIERDO"
  },
  {
    "codigo":237674009,
    "descripcion":"HIPERPLASIA HIPOFISARIA ANTERIOR"
  },
  {
    "codigo":203071002,
    "descripcion":"CONTRACTURA DE MÚSCULO RECTO FEMORAL"
  },
  {
    "codigo":1153343003,
    "descripcion":"PSEUDOPOLICITEMIA DEBIDA A PÉRDIDA CRÓNICA DE VOLUMEN PLASMÁTICO"
  },
  {
    "codigo":235839006,
    "descripcion":"SÍNDROME DEL INTESTINO IRRITABLE, VARIANTE DE LA INFANCIA CON DIARREA"
  },
  {
    "codigo":301375007,
    "descripcion":"ENFERMEDAD Y DOLOR"
  },
  {
    "codigo":234004000,
    "descripcion":"HEMORRAGIA DE ARTERIA TRASPLANTADA"
  },
  {
    "codigo":201236001,
    "descripcion":"SEBORREA CORPORAL"
  },
  {
    "codigo":365076000,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA HACERSE ENTENDER"
  },
  {
    "codigo":1217044000,
    "descripcion":"DIABETES MELLITUS RESISTENTE A CETOSIS"
  },
  {
    "codigo":37396007,
    "descripcion":"FORÚNCULO DE CARA"
  },
  {
    "codigo":102932008,
    "descripcion":"MIEDO A PADECER HIPERTENSIÓN"
  },
  {
    "codigo":428777001,
    "descripcion":"OBSTRUCCIÓN BILATERAL DE LAS TROMPAS DE FALOPIO"
  },
  {
    "codigo":295870000,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE IPRINDOL"
  },
  {
    "codigo":263102004,
    "descripcion":"FRACTURA-SUBLUXACIÓN DE MUÑECA"
  },
  {
    "codigo":230334008,
    "descripcion":"TIC MEDICAMENTOSO"
  },
  {
    "codigo":164798009,
    "descripcion":"CISTOMETRÍA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":720019005,
    "descripcion":"DISFUNCIÓN SOMÁTICA DE REGIÓN PÚBICA"
  },
  {
    "codigo":50241000087101,
    "descripcion":"PRESENCIA DE RESIDUOS DE ALIMENTOS EN LUMEN DE INTESTINO GRUESO"
  },
  {
    "codigo":228499007,
    "descripcion":"HALLAZGO RELACIONADO CON EL CONSUMO DE TABACO HÚMEDO"
  },
  {
    "codigo":42561000087104,
    "descripcion":"HERIDA CORTANTE DE PIEL DE DORSO INFERIOR"
  },
  {
    "codigo":294035008,
    "descripcion":"ALERGIA A PIRBUTEROL"
  },
  {
    "codigo":292200003,
    "descripcion":"REACCIÓN ADVERSA AL TREOSULFANO"
  },
  {
    "codigo":40001000087107,
    "descripcion":"HERIDA PUNZANTE DE DEDO ANULAR DERECHO CON CUERPO EXTRAÑO"
  },
  {
    "codigo":47681000087108,
    "descripcion":"FRACTURA DE OCTAVA COSTILLA IZQUIERDA"
  },
  {
    "codigo":421437000,
    "descripcion":"COMA HIPOGLUCÉMICO DEBIDO A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":718184009,
    "descripcion":"DEFORMIDAD POR ROTACIÓN DE COLUMNA VERTEBRAL"
  },
  {
    "codigo":126525002,
    "descripcion":"NEOPLASIA DE LA PIEL DE LA CADERA"
  },
  {
    "codigo":161128009,
    "descripcion":"PROBLEMAS DE CONDUCTA EN LA ESCUELA"
  },
  {
    "codigo":93757004,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE CLAVÍCULA"
  },
  {
    "codigo":60989005,
    "descripcion":"TROMBOEMBOLIA DE LAS ARTERIAS RENALES"
  },
  {
    "codigo":1142333002,
    "descripcion":"ATROFIA DE MÚSCULO TIBIAL ANTERIOR"
  },
  {
    "codigo":192061007,
    "descripcion":"SÍNDROME DEL CAMPO DE CONCENTRACIÓN"
  },
  {
    "codigo":91922000,
    "descripcion":"AUSENCIA CONGÉNITA DE LA MANDÍBULA"
  },
  {
    "codigo":290365001,
    "descripcion":"INTOXICACIÓN POR RANITIDINA"
  },
  {
    "codigo":59154002,
    "descripcion":"PANCREATITIS SUBAGUDA"
  },
  {
    "codigo":714514004,
    "descripcion":"ENFERMEDAD GINGIVAL CAUSADA POR USO DE ANTICONCEPTIVO ORAL"
  },
  {
    "codigo":124690009,
    "descripcion":"DEFICIENCIA DE TREONINA - ARNT LIGASA"
  },
  {
    "codigo":1236967001,
    "descripcion":"METÁSTASIS DE CARCINOMA DE SURCO BUCAL INFERIOR"
  },
  {
    "codigo":286695006,
    "descripcion":"TIENDE A NO SER TÍMIDO"
  },
  {
    "codigo":712679007,
    "descripcion":"BETA LACTAMASA NEGATIVA"
  },
  {
    "codigo":252092000,
    "descripcion":"PERMEABILIDAD DE VASO DISTAL DISMINUIDA"
  },
  {
    "codigo":1204199009,
    "descripcion":"LINFADENITIS OCCIPITAL AGUDA"
  },
  {
    "codigo":219324001,
    "descripcion":"LESIÓN ACCIDENTAL O DELIBERADA NO DETERMINADA, INTOXICACIÓN POR GASES DE COMBUSTIÓN VEHICULAR"
  },
  {
    "codigo":22716005,
    "descripcion":"TRASTORNO DE LAS PLAQUETAS"
  },
  {
    "codigo":1003921006,
    "descripcion":"ESCLEROCÓRNEA BILATERAL"
  },
  {
    "codigo":283025007,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE CABEZA"
  },
  {
    "codigo":20881008,
    "descripcion":"INTOXICACIÓN POR PRACTOLOL"
  },
  {
    "codigo":1296998002,
    "descripcion":"SOSPECHA DE CIERRE DE ÁNGULO PRIMARIO DE OJO DERECHO"
  },
  {
    "codigo":248422003,
    "descripcion":"MANOS CALIENTES"
  },
  {
    "codigo":312123003,
    "descripcion":"INFECCIÓN BACTERIANA DEL APARATO GENITOURINARIO"
  },
  {
    "codigo":17211005,
    "descripcion":"OMÓPLATO ALADO"
  },
  {
    "codigo":1196859005,
    "descripcion":"HEMANGIOMA BENIGNO DE DUODENO"
  },
  {
    "codigo":1162256002,
    "descripcion":"HIDROCEFALIA POSINFECCIOSA"
  },
  {
    "codigo":310288005,
    "descripcion":"ANTICUERPO CONTRA ANTÍGENO NUCLEAR EXTRAÍBLE NEGATIVO"
  },
  {
    "codigo":703504006,
    "descripcion":"ERITRODERMIA ICTIOSIFORME RETICULAR CONGÉNITA"
  },
  {
    "codigo":16711071000119107,
    "descripcion":"NEOVASCULARIZACIÓN DE RETINA DEBIDA A OCLUSIÓN DE VENA CENTRAL RETINIANA DE OJO IZQUIERDO"
  },
  {
    "codigo":79077003,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE ESPALDA CON INFECCIÓN"
  },
  {
    "codigo":898277003,
    "descripcion":"ANQUILOSIS CONGÉNITA DE ARTICULACIÓN METACARPOFALÁNGICA DE DEDO ÍNDICE"
  },
  {
    "codigo":42639000,
    "descripcion":"HIPOVITAMINOSIS A CON QUERATOMALACIA"
  },
  {
    "codigo":403087002,
    "descripcion":"TIÑA CAUSADA POR TRICHOPHYTON YAOUNDEI"
  },
  {
    "codigo":763535005,
    "descripcion":"FALANGE SUPERNUMERARIA"
  },
  {
    "codigo":15701561000119105,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE TENDONES DE AMBOS MÚSCULOS CUÁDRICEPS"
  },
  {
    "codigo":401252001,
    "descripcion":"CONTROL DE CARDIOPATÍA CORONARIA - TERCERA CARTA DE CONVOCATORIA"
  },
  {
    "codigo":363589331000119100,
    "descripcion":"FRACTURA NO EXPUESTA DE PARED SUPERIOR DE ÓRBITA IZQUIERDA"
  },
  {
    "codigo":302948007,
    "descripcion":"GLÁNDULA SALIVAL O CONDUCTO SALIVAL ACCESORIO"
  },
  {
    "codigo":301113001,
    "descripcion":"HALLAZGO RELACIONADO CON LA FRECUENCIA CARDÍACA"
  },
  {
    "codigo":204644009,
    "descripcion":"RÁNULA CONGÉNITA"
  },
  {
    "codigo":170041003,
    "descripcion":"TALLA DEL NIÑO MAYOR AL PERCENTILO 97"
  },
  {
    "codigo":1251385007,
    "descripcion":"TRASTORNO DE PIGMENTACIÓN DE PIEL POSTERIOR A CIRUGÍA PLÁSTICA"
  },
  {
    "codigo":366649008,
    "descripcion":"HALLAZGO RELACIONADO CON ESPESOR DE PIEL"
  },
  {
    "codigo":364814000,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA COLOCARSE ALIMENTOS EN LA BOCA"
  },
  {
    "codigo":202809009,
    "descripcion":"HIPERMOVILIDAD DEL CÓCCIX"
  },
  {
    "codigo":299278005,
    "descripcion":"SIN AMPLITUD ACTIVA DE ADUCCIÓN DE LA CADERA"
  },
  {
    "codigo":200974006,
    "descripcion":"PSORIASIS UNIVERSAL"
  },
  {
    "codigo":233742007,
    "descripcion":"GRANULOMA HIALINIZANTE PULMONAR"
  },
  {
    "codigo":1149411001,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE ÉTER DIETÍLICO"
  },
  {
    "codigo":199139003,
    "descripcion":"EDEMA Y PROTEINURIA INDUCIDOS POR EL EMBARAZO SIN HIPERTENSIÓN"
  },
  {
    "codigo":35299004,
    "descripcion":"AUSENCIA DE PRÓDROMO"
  },
  {
    "codigo":683731000119104,
    "descripcion":"NEVO DISPLÁSICO DE PIEL DE CUERO CABELLUDO"
  },
  {
    "codigo":231907006,
    "descripcion":"QUERATITIS DISCIFORME"
  },
  {
    "codigo":788963006,
    "descripcion":"UVEÍTIS INTERMEDIA DEBIDA A ENFERMEDAD INFECCIOSA"
  },
  {
    "codigo":166371006,
    "descripcion":"NIVELES DE GONADOTROFINAS POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":68067009,
    "descripcion":"SÍNDROME DE CRIGLER - NAJJAR, TIPO II"
  },
  {
    "codigo":787128002,
    "descripcion":"METABOLIZADOR LENTO DE LA SUBUNIDAD 1 DEL COMPLEJO VITAMINA K-EPÓXIDO REDUCTASA"
  },
  {
    "codigo":721592001,
    "descripcion":"VULVITIS CAUSADA POR SUSTANCIA QUÍMICA"
  },
  {
    "codigo":262840008,
    "descripcion":"DESGARRO DE LA CAPA SEROSA DEL ESTÓMAGO"
  },
  {
    "codigo":295608009,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE TREOSULFANO"
  },
  {
    "codigo":195469007,
    "descripcion":"PÓLIPO FIBROSO DEL ANO"
  },
  {
    "codigo":293773008,
    "descripcion":"ALERGIA A TIOGUANINA"
  },
  {
    "codigo":95330001,
    "descripcion":"DERMATOSIS LINEAL POR IGA"
  },
  {
    "codigo":160866002,
    "descripcion":"UN NIÑO PROPIO HA SIDO ADOPTADO"
  },
  {
    "codigo":1142071000,
    "descripcion":"SOBRECARGA DE HIERRO NEONATAL"
  },
  {
    "codigo":290103001,
    "descripcion":"SANGRADO POR PEZÓN"
  },
  {
    "codigo":291938009,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR AGENTE ELECTROLÍTICO"
  },
  {
    "codigo":128098009,
    "descripcion":"SÍNDROME DE SCOTT"
  },
  {
    "codigo":93495008,
    "descripcion":"ENFERMEDAD DE HODGKIN, PREDOMINIO LINFOCÍTICO - HISTIOCÍTICO, DE GANGLIOS LINFÁTICOS INTRATORÁCICOS"
  },
  {
    "codigo":419340001,
    "descripcion":"MIOSIS INTRAOPERATORIA"
  },
  {
    "codigo":714252004,
    "descripcion":"SÍNDROME DE DOLOR CRÓNICO POSTERIOR A MASTECTOMÍA"
  },
  {
    "codigo":386572005,
    "descripcion":"SÍNCOPE PSICÓGENO"
  },
  {
    "codigo":124428004,
    "descripcion":"DEFICIENCIA DE HIDROXIMETILGLUTARILO - COA HIDROLASA"
  },
  {
    "codigo":1269473002,
    "descripcion":"CAMPYLOBACTER JEJUNI O CAMPYLOBACTER COLI HIPURATO NEGATIVAS"
  },
  {
    "codigo":286433005,
    "descripcion":"DIFICULTAD PARA ABASTECER A OTROS"
  },
  {
    "codigo":417505007,
    "descripcion":"MOVIMIENTO DE LAS COSTILLAS EN DIRECCIÓN CEFÁLICA DURANTE LA RESPIRACIÓN"
  },
  {
    "codigo":10625031000119102,
    "descripcion":"BRONCONEUMONÍA CAUSADA POR BACTERIAS ANAERÓBICAS"
  },
  {
    "codigo":384737007,
    "descripcion":"PLEOMORFISMO NUCLEAR: AUMENTO MODERADO DE TAMAÑO, ETC. (PUNTAJE = 2)"
  },
  {
    "codigo":284598003,
    "descripcion":"EVACUAR EN PÚBLICO"
  },
  {
    "codigo":55222007,
    "descripcion":"DOLOR A LA PALPACIÓN DE MAMA"
  },
  {
    "codigo":448438007,
    "descripcion":"ALERGIA A CISATRACURIO"
  },
  {
    "codigo":282763002,
    "descripcion":"LESIÓN DE NUDILLO"
  },
  {
    "codigo":303111000119104,
    "descripcion":"BURSITIS DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":53387004,
    "descripcion":"MIOPATÍA HEREDITARIA ASOCIADA CON HIDROCEFALIA"
  },
  {
    "codigo":741515006,
    "descripcion":"HERNIA FEMORAL IZQUIERDA RECURRENTE OBSTRUIDA CON GANGRENA"
  },
  {
    "codigo":413835007,
    "descripcion":"ENFERMEDAD CRÓNICA DE ESTRUCTURA INMUNOLÓGICA"
  },
  {
    "codigo":249995008,
    "descripcion":"SE AFLOJAN LAS PIERNAS - CAÍDA"
  },
  {
    "codigo":706912001,
    "descripcion":"COMPLICACIÓN DE LA ATENCIÓN DE LA SALUD"
  },
  {
    "codigo":248160001,
    "descripcion":"DESVESTIDO"
  },
  {
    "codigo":16031751000119105,
    "descripcion":"NECROSIS AVASCULAR DE HUESO DE AMBOS PIES"
  },
  {
    "codigo":315531009,
    "descripcion":"NACIDO EN SUDÁN"
  },
  {
    "codigo":84320000,
    "descripcion":"FRACTURA EXPUESTA DE SECCIÓN MEDIOCERVICAL DE FÉMUR"
  },
  {
    "codigo":870752006,
    "descripcion":"HALLAZGO RELACIONADO CON CONOCIMIENTOS SOBRE LA SALUD"
  },
  {
    "codigo":1231200007,
    "descripcion":"PARÁLISIS DE LA MIRADA HACIA ABAJO"
  },
  {
    "codigo":1263968007,
    "descripcion":"CORONA DENTAL APOYADA SOBRE IMPLANTE IN SITU"
  },
  {
    "codigo":444768009,
    "descripcion":"ÚLCERA CRÓNICA DE REGIÓN SACRA"
  },
  {
    "codigo":705077005,
    "descripcion":"FRACTURA NO EXPUESTA DE PLACA EPIFISARIA DE HUESO METATARSIANO"
  },
  {
    "codigo":279093005,
    "descripcion":"DOLOR CÓLICO"
  },
  {
    "codigo":770613008,
    "descripcion":"QUEMADURA DE TERCER GRADO DE PIEL Y TEJIDO CELULAR SUBCUTÁNEO DE DEDO DE LA MANO"
  },
  {
    "codigo":703242001,
    "descripcion":"DELFTIA ACIDOVORANS O COMAMONAS TESTOSTERONI"
  },
  {
    "codigo":1293066000,
    "descripcion":"LIPOSARCOMA SIMILAR A LIPOMA"
  },
  {
    "codigo":277258003,
    "descripcion":"REGIÓN SUBGLÓTICA - HALLAZGO"
  },
  {
    "codigo":1260298008,
    "descripcion":"DEPRESIÓN POSTERIOR A MENOPAUSIA"
  },
  {
    "codigo":441098008,
    "descripcion":"CÉLULAS ENDOCERVICALES ATÍPICAS EN EL EXTENDIDO VAGINAL DE PAPANICOLAOU"
  },
  {
    "codigo":766943002,
    "descripcion":"OBSTRUCCIÓN COMPLETA DE INTESTINO"
  },
  {
    "codigo":736010008,
    "descripcion":"BAJO ATENCIÓN DE CIRUJANO PODIÁTRICO"
  },
  {
    "codigo":78815005,
    "descripcion":"NEFROPATÍA TUBULOINTERSTICIAL HEREDITARIA"
  },
  {
    "codigo":111583006,
    "descripcion":"LEUCOCITOSIS"
  },
  {
    "codigo":240820001,
    "descripcion":"FILARIASIS LINFÁTICA"
  },
  {
    "codigo":109748002,
    "descripcion":"CORONA PARTIDA"
  },
  {
    "codigo":16906401000119106,
    "descripcion":"QUISTE DERMOIDE DE PÁRPADO SUPERIOR DERECHO"
  },
  {
    "codigo":404660006,
    "descripcion":"NEUROPATÍA ÓPTICA COMPRESIVA, ETAPA AGUDA"
  },
  {
    "codigo":765108007,
    "descripcion":"PEDOFILIA DIRIGIDA A NIÑAS"
  },
  {
    "codigo":370057001,
    "descripcion":"INVASIÓN TUMORAL DE BRONQUIO"
  },
  {
    "codigo":402825002,
    "descripcion":"QUISTES RETROAURICULARES (HIDRADENITIS)"
  },
  {
    "codigo":271753002,
    "descripcion":"FIEBRE IRREGULAR"
  },
  {
    "codigo":238985006,
    "descripcion":"PIODERMA GANGRENOSO AMPOLLAR"
  },
  {
    "codigo":75145007,
    "descripcion":"ESTENOSIS DE LA ARTERIA AORTA"
  },
  {
    "codigo":763273008,
    "descripcion":"TRISOMÍA DISTAL 4Q"
  },
  {
    "codigo":40542008,
    "descripcion":"AMPOLLA DE LA CADERA, SIN INFECCIÓN"
  },
  {
    "codigo":400990009,
    "descripcion":"ERUPCIÓN QUE SE BLANQUEA CON PRESIÓN"
  },
  {
    "codigo":73310008,
    "descripcion":"SORDERA DE CONDUCCIÓN AÉREA"
  },
  {
    "codigo":5939002,
    "descripcion":"INTENTO FALLIDO DE ABORTO COMPLICADO POR TRASTORNO METABÓLICO"
  },
  {
    "codigo":1074651000119100,
    "descripcion":"ARTRITIS DE ARTICULACIÓN GLENOHUMERAL IZQUIERDA"
  },
  {
    "codigo":1084891000119101,
    "descripcion":"COLANGITIS DEBIDA A CÁLCULO DE CONDUCTO BILIAR CON OBSTRUCCIÓN"
  },
  {
    "codigo":306651000119101,
    "descripcion":"GOTA DE RODILLA CAUSADA POR FÁRMACO"
  },
  {
    "codigo":342491000119103,
    "descripcion":"EDEMA DE PÁRPADO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":1079771000119104,
    "descripcion":"DERMATOFIBROMA DE MIEMBRO SUPERIOR DERECHO"
  },
  {
    "codigo":14811000119105,
    "descripcion":"AUMENTO ANORMAL DE LA TALLA CORPORAL"
  },
  {
    "codigo":688091000119106,
    "descripcion":"SARCOMA PRIMARIO DE TRONCO"
  },
  {
    "codigo":11056091000119105,
    "descripcion":"INFECCIÓN RECURRENTE DE NALGA POR HERPES SIMPLE"
  },
  {
    "codigo":300851005,
    "descripcion":"MASA DE ESTRUCTURA RESPIRATORIA"
  },
  {
    "codigo":366387007,
    "descripcion":"HALLAZGO EN EL REFLEJO FARÍNGEO NAUSEOSO"
  },
  {
    "codigo":11854811000119103,
    "descripcion":"AMPOLLA BUCAL, CON INFECCIÓN"
  },
  {
    "codigo":337371000119109,
    "descripcion":"DEFORMIDAD DE ÓRBITA DE OJO IZQUIERDO DEBIDA A LESIÓN TRAUMÁTICA"
  },
  {
    "codigo":299016006,
    "descripcion":"ARTICULACIÓN DE LA MUÑECA ESTABLE"
  },
  {
    "codigo":1092571000119109,
    "descripcion":"SEPSIS CAUSADA POR CHROMOBACTERIUM"
  },
  {
    "codigo":397320006,
    "descripcion":"TRASTORNO DEL OMBLIGO"
  },
  {
    "codigo":725000003,
    "descripcion":"HIPOTENSIÓN INTRACRANEAL SECUNDARIA"
  },
  {
    "codigo":329691000119107,
    "descripcion":"COMPRESIÓN DE NERVIO PERIFÉRICO DE MIEMBRO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":10897371000119109,
    "descripcion":"HERIDA ABIERTA DE GENITALES EXTERNOS MASCULINOS"
  },
  {
    "codigo":352731000119109,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE NERVIOS PERIFÉRICOS DE EXTREMIDAD INFERIOR IZQUIERDA"
  },
  {
    "codigo":723165007,
    "descripcion":"NEOPLASIA SPITZOIDE DE POTENCIAL MALIGNO INCIERTO"
  },
  {
    "codigo":67805000,
    "descripcion":"HIPERALDOSTERONISMO SECUNDARIO"
  },
  {
    "codigo":721330006,
    "descripcion":"LESIÓN TRAUMÁTICA DIFUSA DE CEREBRO"
  },
  {
    "codigo":229810006,
    "descripcion":"CALLOSIDAD APICAL"
  },
  {
    "codigo":459186008,
    "descripcion":"CIERRE ESPONTÁNEO DE COMUNICACIÓN INTERAURICULAR RESIDUAL"
  },
  {
    "codigo":293511001,
    "descripcion":"REACCIÓN ADVERSA A TRIMETAFÁN"
  },
  {
    "codigo":1145479000,
    "descripcion":"HIPOPLASIA CONGÉNITA DE FALANGE MEDIA DE DEDO MEDIO"
  },
  {
    "codigo":162439003,
    "descripcion":"EL SÍNTOMA COMENZÓ HACE MESES"
  },
  {
    "codigo":31367003,
    "descripcion":"ENCEFALOMIELITIS POSTVACUNAL"
  },
  {
    "codigo":424583005,
    "descripcion":"EMPUJE LINGUAL"
  },
  {
    "codigo":295346007,
    "descripcion":"SOBREDOSIS DE MISOPROSTOL"
  },
  {
    "codigo":129671003,
    "descripcion":"INFECCIÓN POR ECHOVIRUS HUMANO"
  },
  {
    "codigo":291676001,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR RIFAMPICINA"
  },
  {
    "codigo":160604004,
    "descripcion":"FUMADOR MODERADO DE CIGARRILLOS (10-19 CIGARRILLOS POR DÍA)"
  },
  {
    "codigo":95068005,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA PIEL DE LA MANO"
  },
  {
    "codigo":226140006,
    "descripcion":"DIETA RICA EN VITAMINAS"
  },
  {
    "codigo":420913000,
    "descripcion":"CLASIFICACIÓN DE LA ASOCIACIÓN CARDIOLÓGICA DE NUEVA YORK - CLASE III"
  },
  {
    "codigo":1141809001,
    "descripcion":"DECOLORACIÓN DE PIEL DE PÁRPADO"
  },
  {
    "codigo":289841000,
    "descripcion":"HALLAZGO RELACIONADO CON LA SENSIBILIDAD DEL OVARIO"
  },
  {
    "codigo":27697003,
    "descripcion":"CÁLCULO DE CONDUCTO HEPÁTICO SIN OBSTRUCCIÓN"
  },
  {
    "codigo":224305003,
    "descripcion":"CONCURRE A LA ESCUELA"
  },
  {
    "codigo":715825009,
    "descripcion":"ATAXIA ESPINOCEREBELOSA TIPO 29"
  },
  {
    "codigo":25862002,
    "descripcion":"ACTIVIDAD GLANDULAR SEBÁCEA DISMINUIDA"
  },
  {
    "codigo":688751000119103,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE BORDE DE LA LENGUA"
  },
  {
    "codigo":124166007,
    "descripcion":"DEFICIENCIA DE BUTIRIL-COA DESHIDROGENASA"
  },
  {
    "codigo":253403000,
    "descripcion":"DESPLAZAMIENTO DESCENDENTE DE VÁLVULA MITRAL SEMEJANTE A LA ANOMALÍA DE EBSTEIN"
  },
  {
    "codigo":16007791000119104,
    "descripcion":"TROMBOSIS DE ARTERIA CUBITAL DERECHA"
  },
  {
    "codigo":10682991000119104,
    "descripcion":"TUMEFACCIÓN DEL TEJIDO CELULAR SUBCUTÁNEO DE DEDO DEL PIE DERECHO"
  },
  {
    "codigo":56795008,
    "descripcion":"POLINEURITIS CRANEAL"
  },
  {
    "codigo":255027009,
    "descripcion":"RETINOMA"
  },
  {
    "codigo":284336001,
    "descripcion":"INCAPAZ DE COLOCAR UN OBJETO SOBRE OTRO"
  },
  {
    "codigo":87728001,
    "descripcion":"VULVOVAGINITIS CÍCLICA"
  },
  {
    "codigo":448176008,
    "descripcion":"UTILIZA MENOS MEDICACIÓN QUE LA PRESCRITA"
  },
  {
    "codigo":282501000,
    "descripcion":"SUBE UNA COLINA CORRIENDO"
  },
  {
    "codigo":1003397007,
    "descripcion":"ATRESIA INTESTINAL MÚLTIPLE"
  },
  {
    "codigo":11311881000119102,
    "descripcion":"FRACTURA EXPUESTA DE PRIMERA VÉRTEBRA LUMBAR"
  },
  {
    "codigo":313434001,
    "descripcion":"HEMIPLEJÍA RESIDUAL"
  },
  {
    "codigo":247898002,
    "descripcion":"SENTIMIENTOS DE SUPERIORIDAD"
  },
  {
    "codigo":249733009,
    "descripcion":"HUESO PÉLVICO GRANDE"
  },
  {
    "codigo":51290000,
    "descripcion":"COLITIS POR DESVIACIÓN"
  },
  {
    "codigo":15735561000119103,
    "descripcion":"TRASTORNO DE EPITELIO CORNEAL DE AMBOS OJOS CAUSADO POR VIRUS HERPES SIMPLE HUMANO"
  },
  {
    "codigo":16687001,
    "descripcion":"NUDOSIDADES DE LOS NUDILLOS"
  },
  {
    "codigo":770351001,
    "descripcion":"QUEMADURA PROFUNDA DE TERCER GRADO DE GLÚTEO"
  },
  {
    "codigo":49455004,
    "descripcion":"POLINEUROPATÍA DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":702980000,
    "descripcion":"PATRÓN DE SUEÑO DESCONOCIDO"
  },
  {
    "codigo":14852000,
    "descripcion":"MIRINGITIS"
  },
  {
    "codigo":735748002,
    "descripcion":"HEMÓLISIS NEONATAL CONCOMITANTE CON INFECCIÓN BACTERIANA SISTÉMICA Y DEBIDA A ELLA"
  },
  {
    "codigo":1260036001,
    "descripcion":"CARCINOMA DE SENO FRONTAL"
  },
  {
    "codigo":80388004,
    "descripcion":"GONORREA CRÓNICA DE LAS VÍAS GENITOURINARIAS SUPERIORES"
  },
  {
    "codigo":113156005,
    "descripcion":"AISLAMIENTO SENSITIVO"
  },
  {
    "codigo":307929000,
    "descripcion":"SITUACIÓN DEL CERTIFICADO DE DEFUNCIÓN"
  },
  {
    "codigo":209625000,
    "descripcion":"DESGARRO COMPLETO DE LIGAMENTO DE LA RODILLA"
  },
  {
    "codigo":111321007,
    "descripcion":"CAYADO AÓRTICO DERECHO"
  },
  {
    "codigo":699310000,
    "descripcion":"SÍNDROME DE DELECIÓN 22Q13.3"
  },
  {
    "codigo":439001009,
    "descripcion":"TROMBOFILIA ADQUIRIDA"
  },
  {
    "codigo":109486007,
    "descripcion":"HIPOPLASIA LOCALIZADA DEL ESMALTE ASOCIADA CON INFECCIÓN LOCAL"
  },
  {
    "codigo":402563000,
    "descripcion":"MELANOMA MALIGNO METASTÁSICO CON HIPERMELANOSIS DIFUSA"
  },
  {
    "codigo":240558009,
    "descripcion":"SIFÍLIDE MACULAR"
  },
  {
    "codigo":764846009,
    "descripcion":"ADENOCARCINOMA DE PENE"
  },
  {
    "codigo":74883004,
    "descripcion":"ANEURISMA DE AORTA TORÁCICA SIN RUPTURA"
  },
  {
    "codigo":11776931000119105,
    "descripcion":"LACERACIÓN DE TENDÓN DE PORCIÓN LARGA DE BÍCEPS BRAQUIAL IZQUIERDO"
  },
  {
    "codigo":235053005,
    "descripcion":"ENFERMEDAD INFECCIOSA DE LA MUCOSA ORAL"
  },
  {
    "codigo":890413007,
    "descripcion":"LUXACIÓN CONGÉNITA BILATERAL DE CODO"
  },
  {
    "codigo":202285009,
    "descripcion":"CONTRACTURA EN ABDUCCIÓN DE LA CADERA"
  },
  {
    "codigo":366125009,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD DE TOSER VOLUNTARIAMENTE"
  },
  {
    "codigo":167682001,
    "descripcion":"CROMATOGRAFÍA DE AZÚCARES EN MATERIA FECAL DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":724738001,
    "descripcion":"TRASTORNO DE CONDUCTA DISOCIAL DE COMIENZO EN LA INFANCIA CON EMOCIONES PROSOCIALES LIMITADAS"
  },
  {
    "codigo":298754007,
    "descripcion":"HALLAZGO RELACIONADO CON MEDICIONES DE LA EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":296919001,
    "descripcion":"SOBREDOSIS DE HORMONA ANTIDIURÉTICA"
  },
  {
    "codigo":722903005,
    "descripcion":"LESIÓN DE GENITALES EXTERNOS DEBIDA A TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":1148887009,
    "descripcion":"GLOMERULOPATÍA DEBIDA A SÍNDROME DE ALPORT"
  },
  {
    "codigo":32940002,
    "descripcion":"ÚLCERA FAGEDÉNICA TROPICAL"
  },
  {
    "codigo":293249001,
    "descripcion":"REACCIÓN ADVERSA AL QUINESTRADOL"
  },
  {
    "codigo":162177003,
    "descripcion":"MEJORÍA EN LA VIDA SEXUAL"
  },
  {
    "codigo":1145217005,
    "descripcion":"RADICULITIS DEBIDA A DESPLAZAMIENTO DE DISCO INTERVERTEBRAL CERVICAL"
  },
  {
    "codigo":194945009,
    "descripcion":"MIOCARDITIS AGUDA - DIFTÉRICA"
  },
  {
    "codigo":94806001,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA CÓRNEA"
  },
  {
    "codigo":782934004,
    "descripcion":"DIÁTESIS HEMORRÁGICA DEBIDA A DEFECTO DE RECEPTOR DE COLÁGENO"
  },
  {
    "codigo":289579003,
    "descripcion":"CESE DE LOS LOQUIOS"
  },
  {
    "codigo":846635004,
    "descripcion":"AFECCIÓN RESPIRATORIA CRÓNICA CAUSADA POR VAPOR"
  },
  {
    "codigo":60203004,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE ENCÍA CON INFECCIÓN"
  },
  {
    "codigo":92971008,
    "descripcion":"AUSENCIA CONGÉNITA DEL TABIQUE NASAL"
  },
  {
    "codigo":713728002,
    "descripcion":"RESISTENCIA FARMACOLÓGICA A AGENTE ANTIBACTERIANO"
  },
  {
    "codigo":123904004,
    "descripcion":"INTOXICACIÓN POR DICHAPETALACEAE"
  },
  {
    "codigo":254976006,
    "descripcion":"GLIOMA DEL NERVIO ÓPTICO"
  },
  {
    "codigo":11779441000119100,
    "descripcion":"AMPOLLA DE CODO IZQUIERDO, CON INFECCIÓN"
  },
  {
    "codigo":285909001,
    "descripcion":"DIFICULTAD PARA UTILIZAR ESTUFA ELÉCTRICA"
  },
  {
    "codigo":416981004,
    "descripcion":"RETROLISTESIS"
  },
  {
    "codigo":15983831000119108,
    "descripcion":"ANOMALÍA ESTRUCTURAL CONGÉNITA BILATERAL DE ÓRBITAS PROPIAMENTE DICHAS"
  },
  {
    "codigo":449749009,
    "descripcion":"BORDE DE HERIDA IMPRECISO"
  },
  {
    "codigo":54698001,
    "descripcion":"ANEMIA MEGALOBLÁSTICA POR SÍNDROME DE ZOLLINGER - ELLISON"
  },
  {
    "codigo":447914003,
    "descripcion":"ANOMALÍA TOTAL DEL RETORNO VENOSO PULMONAR DE TIPO INTRACARDÍACO"
  },
  {
    "codigo":310641000119103,
    "descripcion":"MIOSITIS INFECCIOSA DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":10960241000119104,
    "descripcion":"HERIDA ABIERTA DE ANTEBRAZO DERECHO"
  },
  {
    "codigo":11861361000119104,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN DE TOBILLO DERECHO"
  },
  {
    "codigo":446079007,
    "descripcion":"SÍNDROME DEL DESEMBARCO"
  },
  {
    "codigo":313172000,
    "descripcion":"COLONOSCOPIA ANORMAL"
  },
  {
    "codigo":1363583009,
    "descripcion":"HIPEROSTOSIS CORTICAL DISPLÁSICA TIPO KOZLOWSKI TSURUTA"
  },
  {
    "codigo":216703009,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR DICLORVOS"
  },
  {
    "codigo":18260003,
    "descripcion":"PSICOSIS POSTPARTO"
  },
  {
    "codigo":247636004,
    "descripcion":"PREOCUPACIÓN POR EL ASPECTO"
  },
  {
    "codigo":737321001,
    "descripcion":"HEMORRAGIA EXCESIVA DEBIDA A EMBARAZO MOLAR Y POSTERIOR A ÉL"
  },
  {
    "codigo":409641002,
    "descripcion":"VIRUELA HEMORRÁGICA"
  },
  {
    "codigo":1163305003,
    "descripcion":"PETROSITIS APICAL"
  },
  {
    "codigo":278569002,
    "descripcion":"CORONA DENTAL DE COLOR INCORRECTO"
  },
  {
    "codigo":51028009,
    "descripcion":"PRESENCIA ANORMAL DE PENTOSA"
  },
  {
    "codigo":440574002,
    "descripcion":"RESPUESTA ANORMAL A LA ESTIMULACIÓN NERVIOSA"
  },
  {
    "codigo":211198003,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE REGIÓN ESCAPULAR DE ESPALDA"
  },
  {
    "codigo":702718005,
    "descripcion":"NEFRITIS TUBULOINTERSTICIAL CRÓNICA REAGUDIZADA"
  },
  {
    "codigo":1259774005,
    "descripcion":"ADAMANTINOMA PRIMARIO DE FÉMUR"
  },
  {
    "codigo":80126007,
    "descripcion":"SÍNDROME DE PLUMMER - VINSON"
  },
  {
    "codigo":735486007,
    "descripcion":"INFECCIÓN DEL TRACTO GENITAL DEBIDA Y CONSECUTIVA A EMBARAZO CON DESENLACE DE ABORTO"
  },
  {
    "codigo":733651001,
    "descripcion":"HIPERPLASIA DE CÉLULAS DE LEYDIG DE OVARIO"
  },
  {
    "codigo":373203001,
    "descripcion":"COMPROMISO TUMORAL EN MARGEN DE RESECCIÓN QUIRÚRGICA (RADIAL) PROFUNDA, AUSENTE (COLON\/RECTO)"
  },
  {
    "codigo":209363000,
    "descripcion":"FRACTURA-LUXACIÓN EXPUESTA DE ARTICULACIÓN SUBASTRAGALINA"
  },
  {
    "codigo":405971004,
    "descripcion":"HALLAZGO RELACIONADO CON EL ESTADIO DEL GRUPO NACIONAL PARA EL ESTUDIO DEL TUMOR DE WILMS"
  },
  {
    "codigo":897491008,
    "descripcion":"INGESTA INADECUADA DE PROTEÍNA Y\/O DERIVADO PROTEICO"
  },
  {
    "codigo":274899008,
    "descripcion":"TRICOFOLICULOMA"
  },
  {
    "codigo":305832002,
    "descripcion":"ATENDIDO POR SERVICIO DE ANÁLISIS COMPLEMENTARIOS"
  },
  {
    "codigo":10920005,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE LABIO CON INFECCIÓN"
  },
  {
    "codigo":830120006,
    "descripcion":"ATAXIA DE AMBOS MIEMBROS SUPERIORES"
  },
  {
    "codigo":404136008,
    "descripcion":"LEUCEMIA AGRESIVA DE CÉLULAS NK QUE COMPROMETE PIEL"
  },
  {
    "codigo":74621002,
    "descripcion":"SÍNDROME DEL VÓMITO EPIDÉMICO"
  },
  {
    "codigo":369533004,
    "descripcion":"TUMOR MALIGNO QUE COMPROMETE EL OVARIO DERECHO POR PROPAGACIÓN DIRECTA DEL OVARIO IZQUIERDO"
  },
  {
    "codigo":402301004,
    "descripcion":"ECCEMA CONSTITUCIONAL AGUDO"
  },
  {
    "codigo":238461008,
    "descripcion":"HELOMA MILIAR"
  },
  {
    "codigo":205693008,
    "descripcion":"XY, FENOTIPO FEMENINO"
  },
  {
    "codigo":302162004,
    "descripcion":"URTICARIA IDIOPÁTICA CRÓNICA"
  },
  {
    "codigo":433234005,
    "descripcion":"HIPERPLASIA DE PRÓSTATA"
  },
  {
    "codigo":365863005,
    "descripcion":"HALLAZGO RELACIONADO CON EL ESTADO PARA HEPATITIS B"
  },
  {
    "codigo":300327006,
    "descripcion":"HÍGADO BLANDO"
  },
  {
    "codigo":69116000,
    "descripcion":"ENFERMEDAD DE MOYAMOYA"
  },
  {
    "codigo":396796000,
    "descripcion":"SIN TUMOR PRESENTE EN ESPÉCIMEN"
  },
  {
    "codigo":169255008,
    "descripcion":"ECOGRAFÍA ANORMAL"
  },
  {
    "codigo":36348003,
    "descripcion":"HIPERPARATIROIDISMO PRIMARIO"
  },
  {
    "codigo":313151000119100,
    "descripcion":"MANO HENDIDA IZQUIERDA"
  },
  {
    "codigo":298492007,
    "descripcion":"DEFORMIDAD DE LA COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":724476008,
    "descripcion":"RECTOCELE CONCOMITANTE CON PROLAPSO UTEROVAGINAL COMPLETO"
  },
  {
    "codigo":198353000,
    "descripcion":"ELONGACIÓN HIPERTRÓFICA DEL CUELLO UTERINO"
  },
  {
    "codigo":722641001,
    "descripcion":"FRACTURA POR ESTALLIDO INESTABLE DE PRIMERA VÉRTEBRA CERVICAL"
  },
  {
    "codigo":296657004,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE CLOXACILINA"
  },
  {
    "codigo":339621000119108,
    "descripcion":"DRUSAS DE MÁCULA IZQUIERDA"
  },
  {
    "codigo":360358001,
    "descripcion":"HIPERTIROIDISMO POR PRODUCCIÓN EXCESIVA DE TIROTROFINA"
  },
  {
    "codigo":34513009,
    "descripcion":"MIOPATÍA DE CUERPO DE CEBRA"
  },
  {
    "codigo":196518003,
    "descripcion":"SIALECTASIA SUBMANDIBULAR"
  },
  {
    "codigo":130982006,
    "descripcion":"TRASTORNO DE HORMONA POLIPEPTÍDICA"
  },
  {
    "codigo":1144955001,
    "descripcion":"VASCULITIS DEBIDA A TRASTORNO MIELOPROLIFERATIVO"
  },
  {
    "codigo":16041791000119104,
    "descripcion":"ARTRITIS IDIOPÁTICA JUVENIL DE AMBAS RODILLAS"
  },
  {
    "codigo":127312001,
    "descripcion":"HEMORRAGIA INTRACRANEAL POSTRAUMÁTICA CON PÉRDIDA PROLONGADA DE LA CONSCIENCIA, SIN RECUPERACIÓN DEL NIVEL DE CONSCIENCIA PREEXISTENTE"
  },
  {
    "codigo":94544002,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE PIEL DE MAMA"
  },
  {
    "codigo":291152005,
    "descripcion":"INTOXICACIÓN POR DROPERIDOL"
  },
  {
    "codigo":782672006,
    "descripcion":"GERMINOMA EXTRAGONADAL"
  },
  {
    "codigo":1010213000,
    "descripcion":"DISPLASIA CONGÉNITA DE CADERA DERECHA"
  },
  {
    "codigo":92709000,
    "descripcion":"CARCINOMA IN SITU DE LA PIEL DEL ABDOMEN"
  },
  {
    "codigo":191013002,
    "descripcion":"INMUNODEFICIENCIA COMÚN VARIABLE, CON AUTOANTICUERPOS ANTILINFOCITOS B O T"
  },
  {
    "codigo":715301007,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE DISULFIRAM"
  },
  {
    "codigo":1336058000,
    "descripcion":"EPISODIO DE USO NOCIVO DE COCAÍNA"
  },
  {
    "codigo":289317009,
    "descripcion":"DEFICIENCIA DE LOS GRÁNULOS GRANULOCITARIOS"
  },
  {
    "codigo":27173008,
    "descripcion":"COALICIONES TARSIANAS"
  },
  {
    "codigo":156410002,
    "descripcion":"SICOSIS DE BARBA"
  },
  {
    "codigo":123642008,
    "descripcion":"OCLUSIÓN DE LA ARTERIA CORONARIA DERECHA"
  },
  {
    "codigo":1303290009,
    "descripcion":"LIPOMA DE FILUM TERMINALE TRANSICIONAL AISLADO"
  },
  {
    "codigo":254714008,
    "descripcion":"CARCINOMA ECRINO MUCINOSO DE PIEL"
  },
  {
    "codigo":449487002,
    "descripcion":"NEOPLASIA EPITELIAL MALIGNA DE MANDÍBULA"
  },
  {
    "codigo":1268687001,
    "descripcion":"TIEMPO DE TRASLADO A DESTINO PERCIBIDO COMO ACEPTABLE"
  },
  {
    "codigo":1137615006,
    "descripcion":"LÍNEA CAPILAR FRONTAL PUNTIAGUDA"
  },
  {
    "codigo":56271007,
    "descripcion":"SÍNDROME DE HIPOTERMIA - SUDOR"
  },
  {
    "codigo":283812000,
    "descripcion":"MORDEDURA DE ANIMAL EN DEDO DE LA MANO"
  },
  {
    "codigo":251044003,
    "descripcion":"ESCASEZ DE LA RAMIFICACIÓN ARTERIAL PULMONAR PERIFÉRICA"
  },
  {
    "codigo":1332388003,
    "descripcion":"ENFERMEDAD DE ALEXANDER TIPO II"
  },
  {
    "codigo":773497001,
    "descripcion":"SÍNDROME DE AGENESIA PARCIAL DEL CUERPO CALLOSO, HIPOPLASIA DEL VERMIS CEREBELOSO CON QUISTES DE LA FOSA POSTERIOR"
  },
  {
    "codigo":183673002,
    "descripcion":"ALTA HOSPITALARIA DENTRO DE LAS 6 HORAS POSTERIORES AL PARTO"
  },
  {
    "codigo":19833008,
    "descripcion":"ESTENOSIS NODULAR CALCIFICADA DE VÁLVULA AÓRTICA"
  },
  {
    "codigo":1079411000119102,
    "descripcion":"FEOCROMOCITOMA BENIGNO DE GLÁNDULA SUPRARRENAL IZQUIERDA"
  },
  {
    "codigo":1230414002,
    "descripcion":"SÍNDROME DE NEUROTOXICIDAD ASOCIADO A CÉLULAS EFECTORAS INMUNITARIAS"
  },
  {
    "codigo":50766008,
    "descripcion":"CIRCULACIÓN COLATERAL DISMINUIDA"
  },
  {
    "codigo":312910009,
    "descripcion":"HEMORRAGIA DEL VÍTREO DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":737059002,
    "descripcion":"ALTERACIÓN DE LA ALINEACIÓN DE ARTICULACIÓN SACROILÍACA"
  },
  {
    "codigo":704291003,
    "descripcion":"FRACTURA POR OSTEOPOROSIS SECUNDARIA DE FÉMUR"
  },
  {
    "codigo":442147002,
    "descripcion":"ESTUDIO POR IMÁGENES DEL TÓRAX, ANORMAL"
  },
  {
    "codigo":1197646008,
    "descripcion":"AUSENCIA DE INODORO FUNCIONAL EN LA VIVIENDA"
  },
  {
    "codigo":276472000,
    "descripcion":"MARCA DEL PIE"
  },
  {
    "codigo":407544005,
    "descripcion":"OBSTRUCCIÓN DE ESTOMA CON MATERIA FECAL"
  },
  {
    "codigo":307405000,
    "descripcion":"PARÁLISIS DE NERVIO HIPOGLOSO"
  },
  {
    "codigo":897229000,
    "descripcion":"CURVATURA ANORMAL DE FALANGE DISTAL DE TERCER DEDO DE PIE"
  },
  {
    "codigo":733389003,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE TESTÍCULO COMPLETO"
  },
  {
    "codigo":241869005,
    "descripcion":"EFECTO TÓXICO CAUSADO POR PINTURA"
  },
  {
    "codigo":372941008,
    "descripcion":"ARTRITIS PIÓGENA DE LA CADERA"
  },
  {
    "codigo":209101009,
    "descripcion":"SÍNDROME MEDULAR POSTERIOR DE MÉDULA LUMBAR DEBIDO A LUXACIÓN VERTEBRAL EXPUESTA DE COLUMNA LUMBAR"
  },
  {
    "codigo":45261009,
    "descripcion":"CONJUNTIVITIS VIRAL"
  },
  {
    "codigo":169992002,
    "descripcion":"AMAMANTADO A LOS 9 MESES"
  },
  {
    "codigo":371106008,
    "descripcion":"TROMBOCITOPENIA MATERNA IDIOPÁTICA"
  },
  {
    "codigo":403874009,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS INTRAEPIDÉRMICO DE CARA"
  },
  {
    "codigo":860791002,
    "descripcion":"DERRAME PLEURAL DEBIDO A ENFERMEDAD NEOPLÁSICA"
  },
  {
    "codigo":762487003,
    "descripcion":"QUEMADURA COMPLEJA DE MIEMBRO INFERIOR"
  },
  {
    "codigo":205431000,
    "descripcion":"HEMIVÉRTEBRA LUMBAR - ESTABLE"
  },
  {
    "codigo":305570008,
    "descripcion":"BAJO ATENCIÓN DE ENFERMERA ESPECIALIZADA EN PSIQUIATRÍA"
  },
  {
    "codigo":41591006,
    "descripcion":"ALTERACIÓN DE LA FORMA DEL PENSAMIENTO"
  },
  {
    "codigo":400204000,
    "descripcion":"XANTOGRANULOMA JUVENIL ERUPTIVO MÚLTIPLE"
  },
  {
    "codigo":203596009,
    "descripcion":"TORSIÓN TIBIAL EXTERNA ADQUIRIDA"
  },
  {
    "codigo":5153001,
    "descripcion":"ANO ECTÓPICO"
  },
  {
    "codigo":234529004,
    "descripcion":"POLIMIOSITIS SARCOIDE AGUDA"
  },
  {
    "codigo":365601007,
    "descripcion":"RECUENTO DE EOSINÓFILOS - HALLAZGO"
  },
  {
    "codigo":396534003,
    "descripcion":"ESTADIO III: EXTENSIÓN EXTRAGLANDULAR DE TUMOR SIN COMPROMISO DE OTRO ÓRGANO (CARCINOMA CORTICAL SUPRARRENAL)"
  },
  {
    "codigo":298230003,
    "descripcion":"AMPLITUD DE MOVIMIENTO ARTICULAR PASIVO NORMAL"
  },
  {
    "codigo":68854005,
    "descripcion":"FRACTURA NO EXPUESTA DE CABEZA DE RADIO"
  },
  {
    "codigo":722379001,
    "descripcion":"SÍNDROME DE CATARATA CONGÉNITA CON HIPERTRICOSIS Y DISCAPACIDAD INTELECTUAL"
  },
  {
    "codigo":296395004,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE HIOSCINA"
  },
  {
    "codigo":1179296003,
    "descripcion":"SÍNDROME COLOBOMATOSO DE MACROFTALMIA CON MICROCÓRNEA"
  },
  {
    "codigo":16837031000119106,
    "descripcion":"TUMORACIÓN DE REGIÓN SUBAREOLAR DE MAMA DERECHA"
  },
  {
    "codigo":817013005,
    "descripcion":"DEDO DE PIE DERECHO AMPUTADO"
  },
  {
    "codigo":292725008,
    "descripcion":"REACCIÓN ADVERSA AL CARBÓN ACTIVADO"
  },
  {
    "codigo":1144693008,
    "descripcion":"APLASIA DE FALANGE PROXIMAL DE QUINTO DEDO DE PIE"
  },
  {
    "codigo":127050002,
    "descripcion":"ANEMIA HEMOLÍTICA AUTOINMUNITARIA SECUNDARIA"
  },
  {
    "codigo":423797009,
    "descripcion":"PROVISIÓN INADECUADA DE ATENCIÓN SANITARIA"
  },
  {
    "codigo":344641000119102,
    "descripcion":"SINEQUIAS PERIFÉRICAS ANTERIORES DE AMBOS OJOS"
  },
  {
    "codigo":94282006,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL EPICARDIO"
  },
  {
    "codigo":290890006,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR SERTRALINA"
  },
  {
    "codigo":190751001,
    "descripcion":"INTOLERANCIA PRIMARIA A LA LACTOSA"
  },
  {
    "codigo":92447006,
    "descripcion":"NEOPLASIA BENIGNA DE LOS GANGLIOS LINFÁTICOS TRAQUEOBRONQUIALES"
  },
  {
    "codigo":715039008,
    "descripcion":"INCAPAZ DE LLORAR"
  },
  {
    "codigo":713204000,
    "descripcion":"HIDROPESÍA NEONATAL NO INMUNITARIA"
  },
  {
    "codigo":289055009,
    "descripcion":"INCAPAZ DE UTILIZAR TENEDOR PARA ALIMENTARSE"
  },
  {
    "codigo":1335796003,
    "descripcion":"ARTRITIS IDIOPÁTICA JUVENIL DE RODILLA DERECHA"
  },
  {
    "codigo":1237492002,
    "descripcion":"METÁSTASIS DE CARCINOMA DE ENDOCÉRVIX"
  },
  {
    "codigo":254452008,
    "descripcion":"NEOPLASIA BENIGNA DE SURCO LABIAL SUPERIOR"
  },
  {
    "codigo":56009001,
    "descripcion":"CONJUNTIVITIS DE INCLUSIÓN DEL ADULTO"
  },
  {
    "codigo":285385002,
    "descripcion":"DOLOR EN HEMITÓRAX IZQUIERDO"
  },
  {
    "codigo":187081003,
    "descripcion":"ABSCESO Y QUISTE FEOMICÓTICO SUBCUTÁNEO"
  },
  {
    "codigo":1081921000119108,
    "descripcion":"CARCINOMA MICROCÍTICO PRIMARIO DE LÓBULO SUPERIOR DE PULMÓN DERECHO"
  },
  {
    "codigo":447390000,
    "descripcion":"ADENOSARCOMA DE ÚTERO"
  },
  {
    "codigo":1137353009,
    "descripcion":"INFECCIÓN CAUSADA POR CITROBACTER"
  },
  {
    "codigo":283550004,
    "descripcion":"HERIDA DE PERDIGÓN EN FRENTE"
  },
  {
    "codigo":414622007,
    "descripcion":"ABERRACIÓN DEL FRENTE DE ONDA DE BAJO ORDEN"
  },
  {
    "codigo":185246008,
    "descripcion":"ATENDIDO EN UN CONSULTORIO HEMATOLÓGICO"
  },
  {
    "codigo":609395005,
    "descripcion":"LESIÓN DE PLEXO NERVIOSO SOMÁTICO"
  },
  {
    "codigo":248947006,
    "descripcion":"NIVEL DE DESCENSO DEL PROLAPSO UTERINO"
  },
  {
    "codigo":314483007,
    "descripcion":"HEMORRAGIA PRIMARIA POSAMIGDALECTOMÍA"
  },
  {
    "codigo":412787009,
    "descripcion":"RETARDO MENTAL, CARDIOPATÍA CONGÉNITA, BLEFAROFIMOSIS, BLEFAROPTOSIS Y DIENTES HIPOPLÁSICOS"
  },
  {
    "codigo":247112002,
    "descripcion":"ARTERIAS RETINIANAS ENFUNDADAS"
  },
  {
    "codigo":441885003,
    "descripcion":"LESIÓN TRAUMÁTICA DE TENDÓN EXTENSOR DE MANO"
  },
  {
    "codigo":81437007,
    "descripcion":"RITMO AURICULAR NORMAL"
  },
  {
    "codigo":210674000,
    "descripcion":"SECCIÓN PARCIAL, TENDÓN FEMORAL DE LA CORVA"
  },
  {
    "codigo":212509008,
    "descripcion":"INTOXICACIÓN POR RIFAMPICINA"
  },
  {
    "codigo":1259250006,
    "descripcion":"FIMOSIS RECURRENTE"
  },
  {
    "codigo":14066009,
    "descripcion":"COLITIS NO INFECCIOSA"
  },
  {
    "codigo":733127007,
    "descripcion":"OCLUSIÓN AGUDA DE ARTERIA DE MIEMBRO SUPERIOR CAUSADA POR TROMBO"
  },
  {
    "codigo":208839008,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA NO EXPUESTA DE LA ARTICULACIÓN RADIOCARPIANA"
  },
  {
    "codigo":10396001,
    "descripcion":"DIETA PARA RADIACIÓN"
  },
  {
    "codigo":272540004,
    "descripcion":"INCLINADO DE PIE EN EL AGUA ALEJADO DEL BORDE"
  },
  {
    "codigo":698524005,
    "descripcion":"ABRASIÓN GENERALIZADA DE DIENTE"
  },
  {
    "codigo":101391000119100,
    "descripcion":"CONDROBLASTOMA BENIGNO DE HUESO"
  },
  {
    "codigo":43164009,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA VENA INTERCOSTAL"
  },
  {
    "codigo":10750991000119101,
    "descripcion":"QUISTE DE OVARIO EN EL EMBARAZO"
  },
  {
    "codigo":303473005,
    "descripcion":"REMUEVE PRÓTESIS"
  },
  {
    "codigo":236102000,
    "descripcion":"DEHISCENCIA DE ANASTOMOSIS DE INTESTINO DELGADO"
  },
  {
    "codigo":72262000,
    "descripcion":"METABOLOPATÍA CONGÉNITA DEL GLUTATIÓN"
  },
  {
    "codigo":347151000119102,
    "descripcion":"ARCO SENIL DE AMBOS OJOS"
  },
  {
    "codigo":237937008,
    "descripcion":"DEFICIENCIA DE COBALAMINA E"
  },
  {
    "codigo":203334005,
    "descripcion":"ENFERMEDAD DE PAGET DE HÚMERO"
  },
  {
    "codigo":301638005,
    "descripcion":"INCAPAZ DE SUBIRSE Y BAJARSE DE LOS MUEBLES"
  },
  {
    "codigo":170566009,
    "descripcion":"ENFERMEDAD CRÓNICA - TRATAMIENTO INICIADO"
  },
  {
    "codigo":365339007,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA CERRAR LA CASA EN FORMA SEGURA"
  },
  {
    "codigo":232432003,
    "descripcion":"EPIGLOTITIS Y SUPRAGLOTITIS AGUDA DEL NIÑO"
  },
  {
    "codigo":429040005,
    "descripcion":"ÚLCERA"
  },
  {
    "codigo":363504005,
    "descripcion":"NEOPLASIA MALIGNA DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":722117000,
    "descripcion":"SÍNDROME DE OSTEOESCLEROSIS, RETRASO DEL DESARROLLO Y CRANEOSINOSTOSIS"
  },
  {
    "codigo":297968009,
    "descripcion":"PIEL SANGRANTE"
  },
  {
    "codigo":296133000,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE MEPROBAMATO"
  },
  {
    "codigo":230597003,
    "descripcion":"NEURALGIA INTERCOSTAL POSHERPÉTICA"
  },
  {
    "codigo":294298002,
    "descripcion":"ALERGIA A GLICINA"
  },
  {
    "codigo":1179034007,
    "descripcion":"INFECCIÓN DE INTESTINO CAUSADA POR SALMONELLA GRUPO D"
  },
  {
    "codigo":1144431000,
    "descripcion":"ATROFIA DE HIPOCAMPO"
  },
  {
    "codigo":718447001,
    "descripcion":"INTUBACIÓN DIFÍCIL"
  },
  {
    "codigo":423535002,
    "descripcion":"CARCINOMA BASOCELULAR DE LA PARED TORÁCICA"
  },
  {
    "codigo":95855003,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE DEDO DE LA MANO"
  },
  {
    "codigo":292463001,
    "descripcion":"REACCIÓN ADVERSA AL VERAPAMILO"
  },
  {
    "codigo":12199081000119104,
    "descripcion":"SUBLUXACIÓN DE PRÓTESIS DE CADERA IZQUIERDA"
  },
  {
    "codigo":126788000,
    "descripcion":"NEOPLASIA DE LA GLÁNDULA PARÓTIDA"
  },
  {
    "codigo":290628005,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR LOMUSTINA"
  },
  {
    "codigo":94020009,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA PIEL DE LA CEJA"
  },
  {
    "codigo":92185002,
    "descripcion":"NEOPLASIA BENIGNA DE LABIO"
  },
  {
    "codigo":26649005,
    "descripcion":"ÚLCERA CRÓNICA DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":11763011000119102,
    "descripcion":"LACERACIÓN DEL TENDÓN DE AQUILES IZQUIERDO"
  },
  {
    "codigo":24814002,
    "descripcion":"FACIES DE ALFARERO"
  },
  {
    "codigo":1204462004,
    "descripcion":"INSUFICIENCIA VENTRICULAR IZQUIERDA CON SEPSIS"
  },
  {
    "codigo":254190005,
    "descripcion":"DERMATOSIS BULLOSA NEONATAL TRANSITORIA"
  },
  {
    "codigo":876782006,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN EN PIEL DE MÚLTIPLES SITIOS TOPOGRÁFICOS"
  },
  {
    "codigo":416195002,
    "descripcion":"INFECCIÓN DE LA RETINA POR VIRUS DE EPSTEIN-BARR"
  },
  {
    "codigo":10861891000119105,
    "descripcion":"HERIDA POR DISPARO DE ARMA DE FUEGO DE MUSLO DERECHO"
  },
  {
    "codigo":283288001,
    "descripcion":"ASTILLA DE MADERA EN MUÑECA"
  },
  {
    "codigo":250520004,
    "descripcion":"HALLAZGO EN PRUEBA DE ALIMENTOS LÁCTEOS"
  },
  {
    "codigo":86680006,
    "descripcion":"BULLA ENFISEMATOSA ROTA DEL PULMÓN"
  },
  {
    "codigo":1297261000,
    "descripcion":"CIERRE DE ÁNGULO AGUDO DE AMBOS OJOS DEBIDO A MALFORMACIÓN CONGÉNITA DE ÁNGULO DE CÁMARA ANTERIOR DE AMBOS OJOS"
  },
  {
    "codigo":1231725002,
    "descripcion":"EDEMA DE DISCO ÓPTICO DE AMBOS OJOS DEBIDO A PRESIÓN INTRACRANEANA POR ENCIMA DE RANGO DE REFERENCIA"
  },
  {
    "codigo":707437005,
    "descripcion":"CAPILARITIS PULMONAR"
  },
  {
    "codigo":248685006,
    "descripcion":"SOPLO TRICUSPÍDEO MESODIASTÓLICO"
  },
  {
    "codigo":19309007,
    "descripcion":"GLAUCOMA DE ÁNGULO ABIERTO DEBIDO A TRASTORNO VASCULAR"
  },
  {
    "codigo":281453008,
    "descripcion":"INFECCIÓN ÓSEA ASOCIADA CON ALAMBRE PARA HUESO"
  },
  {
    "codigo":246850001,
    "descripcion":"PRODUCCIÓN DE LÁGRIMAS ESCASA"
  },
  {
    "codigo":609133009,
    "descripcion":"LONGITUD CERVICAL CORTA EN EL EMBARAZO"
  },
  {
    "codigo":50242001,
    "descripcion":"TIÑA DE LA BARBA POR MICROSPORUM GYPSEUM"
  },
  {
    "codigo":312386004,
    "descripcion":"SERVICIO DE NIÑERA"
  },
  {
    "codigo":15639000,
    "descripcion":"DEPRESIÓN MAYOR MODERADA, UN SOLO EPISODIO"
  },
  {
    "codigo":212247002,
    "descripcion":"LESIÓN DE LA RAMA CUTÁNEA LATERAL D12"
  },
  {
    "codigo":277783004,
    "descripcion":"PERITONITIS ASOCIADA A DERIVACIÓN VENTRICULOPERITONEAL"
  },
  {
    "codigo":408855004,
    "descripcion":"ELECCIÓN MATERNA"
  },
  {
    "codigo":48407005,
    "descripcion":"FRACTURA DE LE FORT"
  },
  {
    "codigo":210412000,
    "descripcion":"HERIDA ABIERTA DE LA PARED POSTERIOR DEL TÓRAX"
  },
  {
    "codigo":767468001,
    "descripcion":"ALERGIA A ARVEJAS"
  },
  {
    "codigo":79340003,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE REGIÓN INTERESCAPULAR CON INFECCIÓN"
  },
  {
    "codigo":112108005,
    "descripcion":"AMASADO DE PÍLDORAS"
  },
  {
    "codigo":700097003,
    "descripcion":"FRACTURA DE HUESO DE LA REGIÓN DE LA CADERA"
  },
  {
    "codigo":896705004,
    "descripcion":"FORMA DELGADA ANORMAL CONGÉNITA DE HÚMERO"
  },
  {
    "codigo":403350000,
    "descripcion":"ACNÉ FULMINANTE CON ERITEMA NUDOSO"
  },
  {
    "codigo":77505009,
    "descripcion":"FRACTURA EXPUESTA DEL SEGUNDO HUESO METATARSIANO"
  },
  {
    "codigo":1157014003,
    "descripcion":"DOLOR A LA DESCOMPRESIÓN DEL CUADRANTE SUPERIOR IZQUIERDO DEL ABDOMEN"
  },
  {
    "codigo":763798008,
    "descripcion":"SÍNDROME DE MICROCEFALIA Y NEUROPATÍA AXÓNICA MOTRIZ Y SENSITIVA COMPLEJA"
  },
  {
    "codigo":237675005,
    "descripcion":"HIPERPLASIA SOMATOTRÓFICA"
  },
  {
    "codigo":204907006,
    "descripcion":"APLASIA CONGÉNITA DE ESCROTO"
  },
  {
    "codigo":6464001,
    "descripcion":"INFECCIÓN CAUSADA POR PROSTHOGONIMUS MACRORCHIS"
  },
  {
    "codigo":72000004,
    "descripcion":"HIPOVITAMINOSIS A"
  },
  {
    "codigo":168469000,
    "descripcion":"EXTENDIDO DE CÚPULA VAGINAL, NEGATIVO"
  },
  {
    "codigo":203072009,
    "descripcion":"CONTRACTURA DE MÚSCULOS ADUCTORES DE LA CADERA"
  },
  {
    "codigo":1153344009,
    "descripcion":"MASTOCITOSIS CUTÁNEA NODULAR PSEUDOXANTOMATOSA"
  },
  {
    "codigo":397845003,
    "descripcion":"ROSÁCEA GRANULOMATOSA"
  },
  {
    "codigo":102933003,
    "descripcion":"HABLA EN ESPEJO"
  },
  {
    "codigo":201237005,
    "descripcion":"SEBORREA FACIAL"
  },
  {
    "codigo":1217045004,
    "descripcion":"MACROGENITOSOMÍA"
  },
  {
    "codigo":234005004,
    "descripcion":"RUPTURA DE ARTERIA VERTEBRAL"
  },
  {
    "codigo":299541006,
    "descripcion":"AMPLITUD DE EVERSIÓN PASIVA DE ARTICULACIÓN SUBASTRAGALINA NORMAL"
  },
  {
    "codigo":365077009,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA COMUNICAR ALGO SOBRE SÍ MISMO"
  },
  {
    "codigo":428778006,
    "descripcion":"TRASTORNO DEL DISCO INTERVERTEBRAL DE LA COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":426943005,
    "descripcion":"TRASTORNO DE HIPERSOMNIA RELACIONADO CON LA MENSTRUACIÓN"
  },
  {
    "codigo":33727006,
    "descripcion":"LESIÓN POR FRICCIÓN CAUSADA POR DENTÍFRICO"
  },
  {
    "codigo":230335009,
    "descripcion":"TRASTORNO DE TIC FACIAL"
  },
  {
    "codigo":263103009,
    "descripcion":"FRACTURA-SUBLUXACIÓN DE LA ARTICULACIÓN RADIOCUBITAL DISTAL"
  },
  {
    "codigo":31892009,
    "descripcion":"HEMOTÓRAX"
  },
  {
    "codigo":95593001,
    "descripcion":"ABSCESO DE TESTÍCULO"
  },
  {
    "codigo":161129001,
    "descripcion":"DIFICULTADES DEL APRENDIZAJE"
  },
  {
    "codigo":294036009,
    "descripcion":"ALERGIA A SALMETEROL"
  },
  {
    "codigo":30057005,
    "descripcion":"POLIOENCEFALOPATÍA"
  },
  {
    "codigo":292201004,
    "descripcion":"REACCIÓN ADVERSA A TIOTEPA"
  },
  {
    "codigo":290366000,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR RANITIDINA"
  },
  {
    "codigo":126526001,
    "descripcion":"NEOPLASIA DE PIEL DE MUSLO"
  },
  {
    "codigo":1142334008,
    "descripcion":"ATROFIA DE FIBRA DE MÚSCULO ESQUELÉTICO TIPO I"
  },
  {
    "codigo":419603000,
    "descripcion":"QUISTE EPIDERMOIDE CUTÁNEO"
  },
  {
    "codigo":38171000087101,
    "descripcion":"HIPOCINESIA DE MIOCARDIO DE REGIÓN ANTEROLATERAL DE VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":40731000087101,
    "descripcion":"QUEMADURA DE TODOS LOS DEDOS DE PIE DERECHO"
  },
  {
    "codigo":43291000087103,
    "descripcion":"CUERPO EXTRAÑO DE OJO IZQUIERDO"
  },
  {
    "codigo":124691008,
    "descripcion":"DEFICIENCIA DE LEUCINA - ARNT LIGASA"
  },
  {
    "codigo":57320003,
    "descripcion":"AUMENTO DE LA CAPACIDAD DE FIJACIÓN DEL AGUA EN EL ESTRATO CÓRNEO"
  },
  {
    "codigo":385000004,
    "descripcion":"INVASIÓN DE VESÍCULA SEMINAL POR TUMOR NO IDENTIFICADO"
  },
  {
    "codigo":712680005,
    "descripcion":"ANTÍGENO LEUCOCÍTICO HUMANO B27 DETECTADO"
  },
  {
    "codigo":1236968006,
    "descripcion":"METÁSTASIS DE CARCINOMA DE SURCO LABIAL SUPERIOR"
  },
  {
    "codigo":1204200007,
    "descripcion":"INSUFICIENCIA VENTRICULAR IZQUIERDA CON FRACCIÓN DE EYECCIÓN NORMAL DEBIDA A VALVULOPATÍA"
  },
  {
    "codigo":24552005,
    "descripcion":"CUERPO LÚTEO RETENIDO"
  },
  {
    "codigo":286696007,
    "descripcion":"NIVEL ALTO DE NEUROTISMO"
  },
  {
    "codigo":252093005,
    "descripcion":"VASOS DISTALES OCLUIDOS"
  },
  {
    "codigo":53650003,
    "descripcion":"ROSÁCEA, TIPO HIPERPLÁSICA GLANDULAR"
  },
  {
    "codigo":1003922004,
    "descripcion":"SÍNDROME DE ROTHMUND THOMSON TIPO 1"
  },
  {
    "codigo":283026008,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE LA REGIÓN DE LA OREJA"
  },
  {
    "codigo":1296999005,
    "descripcion":"SOSPECHA DE CIERRE DE ÁNGULO PRIMARIO DE OJO IZQUIERDO"
  },
  {
    "codigo":248423008,
    "descripcion":"PRIVACIÓN DE MANOS Y PIES"
  },
  {
    "codigo":1196860000,
    "descripcion":"MEDULOBLASTOMA ANAPLÁSICO DE CÉLULAS GRANDES PRIMARIO DE ENCÉFALO"
  },
  {
    "codigo":246588005,
    "descripcion":"RESPUESTA EXTENSORA PLANTAR BILATERAL"
  },
  {
    "codigo":410428008,
    "descripcion":"NIVEL MUY BAJO DE HIGIENE PERSONAL"
  },
  {
    "codigo":312124009,
    "descripcion":"INFECCIÓN BACTERIANA DEL APARATO URINARIO"
  },
  {
    "codigo":310289002,
    "descripcion":"ANTICUERPO CONTRA ANTÍGENO NUCLEAR EXTRAÍBLE POSITIVO"
  },
  {
    "codigo":48145001,
    "descripcion":"OBSTRUCCIÓN DE TROMPA DE EUSTAQUIO"
  },
  {
    "codigo":277521002,
    "descripcion":"PÉRDIDA DE MOTIVACIÓN"
  },
  {
    "codigo":210150004,
    "descripcion":"LESIÓN CERRADA DE PÁNCREAS"
  },
  {
    "codigo":898278008,
    "descripcion":"ANQUILOSIS CONGÉNITA DE ARTICULACIÓN METACARPOFALÁNGICA DE DEDO MEDIO"
  },
  {
    "codigo":42640003,
    "descripcion":"APENDICITIS SUPURATIVA"
  },
  {
    "codigo":763536006,
    "descripcion":"SÍNDROME DE POLIPOSIS HIPERPLÁSICA"
  },
  {
    "codigo":9872007,
    "descripcion":"TRANSLUCIDEZ NORMAL"
  },
  {
    "codigo":75408008,
    "descripcion":"ÁNIMO ENOJADO"
  },
  {
    "codigo":277171005,
    "descripcion":"VESÍCULAS EN EL CONDUCTO AUDITIVO"
  },
  {
    "codigo":73573004,
    "descripcion":"ANOMALÍA CONGÉNITA DEL SISTEMA MUSCULOESQUELÉTICO"
  },
  {
    "codigo":302949004,
    "descripcion":"FÍSTULA BRONCOESOFÁGICA CONGÉNITA SIN ATRESIA"
  },
  {
    "codigo":1351525006,
    "descripcion":"EN QUIMIOPROFILAXIS POR TUBERCULOSIS INACTIVA"
  },
  {
    "codigo":401253006,
    "descripcion":"CONTROL DE CARDIOPATÍA CORONARIA - CONVOCATORIA VERBAL"
  },
  {
    "codigo":399418000,
    "descripcion":"INVASIÓN TUMORAL DE ESCLERÓTICA QUE NO PUEDE SER DETERMINADA"
  },
  {
    "codigo":38970002,
    "descripcion":"SÍNDROME DE DOAN - WRIGHT"
  },
  {
    "codigo":301114007,
    "descripcion":"HALLAZGO RELACIONADO CON LA REGULARIDAD EN EL RITMO CARDÍACO"
  },
  {
    "codigo":1251386008,
    "descripcion":"TRASTORNO DE PIEL DEBIDO A DIABETES MELLITUS"
  },
  {
    "codigo":233743002,
    "descripcion":"SARCOIDOSIS DE LOS GANGLIOS LINFÁTICOS DEL MEDIASTINO"
  },
  {
    "codigo":682361000119104,
    "descripcion":"ANGIOSARCOMA PRIMARIO DE CUELLO"
  },
  {
    "codigo":364815004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA EMPLEAR LAS MANOS PARA ALIMENTARSE"
  },
  {
    "codigo":200975007,
    "descripcion":"PSORIASIS VULGAR"
  },
  {
    "codigo":788964000,
    "descripcion":"INFESTACIÓN DE LARINGE CAUSADA POR LARVAS DE DIPTERA"
  },
  {
    "codigo":11823481000119105,
    "descripcion":"AMPOLLA TRAUMÁTICA DE HOMBRO DERECHO"
  },
  {
    "codigo":231908001,
    "descripcion":"QUERATOPATÍA POR LÍPIDOS"
  },
  {
    "codigo":1149412008,
    "descripcion":"SOBREDOSIS INTENCIONAL DE ÉTER DIETÍLICO"
  },
  {
    "codigo":2532009,
    "descripcion":"RUPTURA COROIDEA"
  },
  {
    "codigo":197305002,
    "descripcion":"CIRROSIS PORTAL SIFILÍTICA"
  },
  {
    "codigo":295609001,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE TREOSULFANO"
  },
  {
    "codigo":787129005,
    "descripcion":"METABOLIZADOR INTERMEDIO DE LA SUBUNIDAD 1 DEL COMPLEJO VITAMINA K-EPÓXIDO REDUCTASA"
  },
  {
    "codigo":721593006,
    "descripcion":"INFECCIÓN DE GLÁNDULA DE BARTOLINO"
  },
  {
    "codigo":262841007,
    "descripcion":"LACERACIÓN DE ESTÓMAGO"
  },
  {
    "codigo":293774002,
    "descripcion":"ALERGIA A PENTOSTATINA"
  },
  {
    "codigo":424846003,
    "descripcion":"DEFICIENCIA DE ENZIMA CYP3A DEL CITOCROMO P450"
  },
  {
    "codigo":719758004,
    "descripcion":"REQUIERE REGISTRO DE INFORMACIÓN ASISTENCIAL EN DISPOSITIVO PERSONAL DE REGISTRO DE AUDIO"
  },
  {
    "codigo":15673721000119109,
    "descripcion":"GRANULOMA DE PARTES BLANDAS DE AMBOS BRAZOS POR CUERPO EXTRAÑO"
  },
  {
    "codigo":326542006,
    "descripcion":"ATELECTASIA TRAUMÁTICA"
  },
  {
    "codigo":354681000119109,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE HUESO DE MIEMBRO INFERIOR DERECHO"
  },
  {
    "codigo":195470008,
    "descripcion":"TUMOR BENIGNO RECTAL"
  },
  {
    "codigo":128099001,
    "descripcion":"DEFECTO EN EL ALMACENAMIENTO DE PLAQUETAS"
  },
  {
    "codigo":291939001,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR AGENTE ELECTROLÍTICO"
  },
  {
    "codigo":64398008,
    "descripcion":"ÚLCERA PÉPTICA CON HEMORRAGIA Y OBSTRUCCIÓN"
  },
  {
    "codigo":716088000,
    "descripcion":"SÍNDROME DE HAMARTOMA FOLICULAR CON ALOPECIA Y FIBROSIS QUÍSTICA"
  },
  {
    "codigo":1240376007,
    "descripcion":"TRASTORNO NEONATAL PRECOZ DEBIDO A LESIÓN DE PLACENTA POSTERIOR A INDUCCIÓN QUIRÚRGICA"
  },
  {
    "codigo":60728008,
    "descripcion":"ABDOMEN DISTENDIDO"
  },
  {
    "codigo":290104007,
    "descripcion":"SANGRADO DE LA SUPERFICIE DEL PEZÓN"
  },
  {
    "codigo":441971000124107,
    "descripcion":"DESNUTRICIÓN RELACIONADA CON ENFERMEDAD CRÓNICA"
  },
  {
    "codigo":26125006,
    "descripcion":"NEUROPATÍA ÓPTICA TÓXICA"
  },
  {
    "codigo":124429007,
    "descripcion":"DEFICIENCIA DE HIDROXIACILGLUTATIÓN HIDROLASA"
  },
  {
    "codigo":714253009,
    "descripcion":"GRANULOMA HEPÁTICO"
  },
  {
    "codigo":384738002,
    "descripcion":"PLEOMORFISMO NUCLEAR: VARIACIÓN ACENTUADA DE TAMAÑO, NUCLÉOLOS, CROMATINA GRUESA, ETC. (PUNTAJE = 3)"
  },
  {
    "codigo":57058008,
    "descripcion":"ÚTERO BICORNE UNICERVICAL"
  },
  {
    "codigo":219063001,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR FÁRMACOS LIPOTRÓPICOS"
  },
  {
    "codigo":22455005,
    "descripcion":"RETINITIS POR CITOMEGALOVIRUS"
  },
  {
    "codigo":284599006,
    "descripcion":"DEFECAR EN PÚBLICO"
  },
  {
    "codigo":87991007,
    "descripcion":"TRASTORNO DE LA IDENTIDAD SEXUAL"
  },
  {
    "codigo":315532002,
    "descripcion":"NACIDO EN SURINAM"
  },
  {
    "codigo":739681000,
    "descripcion":"TRASTORNO OCULAR DEBIDO A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":53388009,
    "descripcion":"SÍNTOMA PATOGNOMÓNICO"
  },
  {
    "codigo":84321001,
    "descripcion":"CIERRE EPIFISARIO RETRASADO"
  },
  {
    "codigo":282764008,
    "descripcion":"LESIÓN TRAUMÁTICA DEL CÓCCIX"
  },
  {
    "codigo":248161002,
    "descripcion":"VESTIDO INADECUADAMENTE"
  },
  {
    "codigo":444769001,
    "descripcion":"AMENORREA ANOVULATORIA"
  },
  {
    "codigo":1231201006,
    "descripcion":"ATAXIA ÓPTICA"
  },
  {
    "codigo":706913006,
    "descripcion":"VENAS VARICOSAS DE MIEMBRO INFERIOR CONCOMITANTES CON EDEMA"
  },
  {
    "codigo":705078000,
    "descripcion":"FRACTURA NO EXPUESTA DE PLACA EPIFISARIA DE FALANGE DE PULGAR"
  },
  {
    "codigo":16950007,
    "descripcion":"LACERACIÓN PERINEAL DE CUARTO GRADO QUE COMPROMETE LA MUCOSA ANAL"
  },
  {
    "codigo":311862008,
    "descripcion":"FRACTURA CERRADA QUE COMPROMETE EL TÓRAX CON LA REGIÓN LUMBAR Y LA PELVIS Y MIEMBROS"
  },
  {
    "codigo":441099000,
    "descripcion":"CÉLULAS ESCAMOSAS ATÍPICAS DE SIGNIFICACIÓN INDETERMINADA EN EL EXTENDIDO DE PAPANICOLAOU VAGINAL"
  },
  {
    "codigo":277259006,
    "descripcion":"ERITEMA SUBGLÓTICO"
  },
  {
    "codigo":703243006,
    "descripcion":"ANEURISMA ADQUIRIDO DE ARTERIA PULMONAR"
  },
  {
    "codigo":111584000,
    "descripcion":"DISGENESIA RETICULAR"
  },
  {
    "codigo":80651009,
    "descripcion":"SÍNDROME DE AICARDI"
  },
  {
    "codigo":13280000,
    "descripcion":"SÍNDROME DE HIPOPLASIA FEMORAL Y FACIES INUSUAL"
  },
  {
    "codigo":15115006,
    "descripcion":"ÚLCERA DUODENAL CON HEMORRAGIA Y PERFORACIÓN PERO SIN OBSTRUCCIÓN"
  },
  {
    "codigo":736011007,
    "descripcion":"ATENDIDO POR CIRUJANO PODÓLOGO"
  },
  {
    "codigo":766944008,
    "descripcion":"OBSTRUCCIÓN COMPLETA DE CONDUCTO PANCREÁTICO"
  },
  {
    "codigo":240821002,
    "descripcion":"FILARIASIS BANCROFTIANA TEMPRANA"
  },
  {
    "codigo":765109004,
    "descripcion":"PEDOFILIA DIRIGIDA A NIÑOS"
  },
  {
    "codigo":109749005,
    "descripcion":"RAÍZ PARTIDA"
  },
  {
    "codigo":250390009,
    "descripcion":"TIPO ANTIGÉNICO DUFFY"
  },
  {
    "codigo":371893007,
    "descripcion":"LESIÓN POR REESTENOSIS DE LA ARTERIA CORONARIA"
  },
  {
    "codigo":402826001,
    "descripcion":"HIDRADENITIS AXILAR SUPURATIVA"
  },
  {
    "codigo":763274002,
    "descripcion":"SÍNDROME DE TRISOMÍA DISTAL 5Q"
  },
  {
    "codigo":370058006,
    "descripcion":"INVASIÓN TUMORAL LIMITADA A LA MUCOSA Y SUBMUCOSA"
  },
  {
    "codigo":238986007,
    "descripcion":"ENFERMEDAD DERMATOLÓGICA DEBIDA A QUÍMICOS"
  },
  {
    "codigo":304522008,
    "descripcion":"VENA PULMONAR - HALLAZGO"
  },
  {
    "codigo":204383001,
    "descripcion":"BLOQUEO AURICULOVENTRICULAR COMPLETO DE ORIGEN CONGÉNITO"
  },
  {
    "codigo":271754008,
    "descripcion":"DESCENSO RÁPIDO DE LA FIEBRE"
  },
  {
    "codigo":400991008,
    "descripcion":"ERUPCIÓN QUE NO DESAPARECE A LA VITROPRESIÓN"
  },
  {
    "codigo":366388002,
    "descripcion":"AMPLITUD DE LA FLEXIÓN LATERAL DERECHA DE LA COLUMNA CERVICAL - HALLAZGO"
  },
  {
    "codigo":300852003,
    "descripcion":"MASA DE ESTRUCTURA CARDIOVASCULAR"
  },
  {
    "codigo":38708003,
    "descripcion":"COLESTEATOMA DEL PLIEGUE EPITIMPÁNICO"
  },
  {
    "codigo":299017002,
    "descripcion":"ARTICULACIÓN DE LA MUÑECA DOLOROSA A LA PALPACIÓN"
  },
  {
    "codigo":266249003,
    "descripcion":"HIPERTROFIA VENTRICULAR"
  },
  {
    "codigo":725001004,
    "descripcion":"SIRINGOMIELIA IDIOPÁTICA"
  },
  {
    "codigo":11854971000119101,
    "descripcion":"AMPOLLA TRAUMÁTICA DE MAMA DERECHA"
  },
  {
    "codigo":67806004,
    "descripcion":"INTOXICACIÓN POR FAGOPYRUM ESCULENTUM"
  },
  {
    "codigo":723166008,
    "descripcion":"ERUPCIÓN ERITEMATOSA AGUDA DE PIEL"
  },
  {
    "codigo":295347003,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE MISOPROSTOL"
  },
  {
    "codigo":335541000119100,
    "descripcion":"EDEMA MACULAR CISTOIDE DE OJO DERECHO DEBIDO A CIRUGÍA DE CATARATA Y POSTERIOR A ELLA"
  },
  {
    "codigo":721331005,
    "descripcion":"LESIÓN TRAUMÁTICA DIFUSA DE CEREBELO"
  },
  {
    "codigo":133301000119102,
    "descripcion":"TRASTORNO CEREBRAL DEGENERATIVO CAUSADO POR ALCOHOL"
  },
  {
    "codigo":1077941000119102,
    "descripcion":"OSTEÓLISIS DE PORCIÓN DISTAL DE CLAVÍCULA IZQUIERDA"
  },
  {
    "codigo":48821000119104,
    "descripcion":"ALERGIA A FRUTO SECO"
  },
  {
    "codigo":262579009,
    "descripcion":"LESIÓN DEL PULGAR POR AVULSIÓN ANULAR"
  },
  {
    "codigo":15928501000119104,
    "descripcion":"INFECCIÓN DE PEZÓN DERECHO DURANTE LA LACTANCIA"
  },
  {
    "codigo":92341000119107,
    "descripcion":"DEBILIDAD DE EXTREMIDADES COMO SECUELA DE ACCIDENTE CEREBROVASCULAR"
  },
  {
    "codigo":343221000119108,
    "descripcion":"DESPRENDIMIENTO BILATERAL DE RETINA POR TRACCIÓN"
  },
  {
    "codigo":330421000119102,
    "descripcion":"HEMIPARESIA ATÁXICA LACUNAR DE LADO DERECHO NO DOMINANTE"
  },
  {
    "codigo":299701000119107,
    "descripcion":"QUISTE ÓSEO SOLITARIO DE REGIÓN DE HOMBRO"
  },
  {
    "codigo":162440001,
    "descripcion":"EL SÍNTOMA COMENZÓ HACE AÑOS"
  },
  {
    "codigo":31368008,
    "descripcion":"ENFERMEDAD DE LA ORINA EN JARABE DE ARCE SENSIBLE A TIAMINA"
  },
  {
    "codigo":293512008,
    "descripcion":"REACCIÓN ADVERSA A LA METIROSINA"
  },
  {
    "codigo":95069002,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA PIEL DE LA CADERA"
  },
  {
    "codigo":1145480002,
    "descripcion":"HIPOPLASIA CONGÉNITA DE FALANGE MEDIA DE DEDO ANULAR"
  },
  {
    "codigo":15951541000119107,
    "descripcion":"NEOPLASIA BENIGNA DE AMBOS MIEMBROS SUPERIORES"
  },
  {
    "codigo":291677005,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR RIFAMPICINA"
  },
  {
    "codigo":129672005,
    "descripcion":"CANDIDIASIS LOCALIZADA"
  },
  {
    "codigo":226141005,
    "descripcion":"DIETA RICA EN VITAMINAS HIDROSOLUBLES"
  },
  {
    "codigo":160605003,
    "descripcion":"FUMADOR EMPEDERNIDO DE CIGARRILLOS (20-39 CIGARRILLOS POR DÍA)"
  },
  {
    "codigo":224306002,
    "descripcion":"CONCURRE A LA ESCUELA PRIMARIA"
  },
  {
    "codigo":715826005,
    "descripcion":"ATAXIA ESPINOCEREBELOSA TIPO 31"
  },
  {
    "codigo":93234006,
    "descripcion":"HIPERTROFIA CONGÉNITA DE VÁLVULA MITRAL"
  },
  {
    "codigo":60466007,
    "descripcion":"FLUJO AÉREO ANORMAL"
  },
  {
    "codigo":289842007,
    "descripcion":"DOLOR A LA PALPACIÓN EN OVARIO"
  },
  {
    "codigo":91399006,
    "descripcion":"LESIÓN TRAUMÁTICA DE LAS VENAS GÁSTRICAS"
  },
  {
    "codigo":15979951000119100,
    "descripcion":"ALTERACIÓN DE AMBAS ARTICULACIONES TEMPOROMANDIBULARES"
  },
  {
    "codigo":253404006,
    "descripcion":"VALVA ANTERIOR DE VÁLVULA MITRAL ADHERIDA AL TABIQUE"
  },
  {
    "codigo":11828501000119107,
    "descripcion":"LACERACIÓN DE MÚSCULO CUÁDRICEPS FEMORAL IZQUIERDO"
  },
  {
    "codigo":448177004,
    "descripcion":"INTERACCIÓN FARMACOLÓGICA ADVERSA"
  },
  {
    "codigo":710321005,
    "descripcion":"ESPECIE DE NECATOR O ESPECIE DE ANCYLOSTOMA"
  },
  {
    "codigo":284337005,
    "descripcion":"COLOCA UN OBJETO SOBRE OTRO"
  },
  {
    "codigo":22193007,
    "descripcion":"ARTROSIS DE ARTICULACIÓN DE MANO"
  },
  {
    "codigo":1300145008,
    "descripcion":"DISPLASIA CONGÉNITA DE ARTICULACIÓN DE PIE IZQUIERDO"
  },
  {
    "codigo":1003398002,
    "descripcion":"FÍSTULA ANORRECTAL CONGÉNITA DEBIDA A MALFORMACIÓN ANORRECTAL INTERMEDIA"
  },
  {
    "codigo":20358003,
    "descripcion":"ARTRITIS PIÓGENA DE TOBILLO"
  },
  {
    "codigo":249734003,
    "descripcion":"HUESO PÉLVICO PEQUEÑO"
  },
  {
    "codigo":282502007,
    "descripcion":"NO SUBE UNA COLINA CORRIENDO"
  },
  {
    "codigo":18523001,
    "descripcion":"DESNUDEZ"
  },
  {
    "codigo":51291001,
    "descripcion":"RESULTADO NEGATIVO PARA PRESENCIA DE TUMOR RESIDUAL"
  },
  {
    "codigo":247899005,
    "descripcion":"SENTIMIENTOS DE OMNIPOTENCIA"
  },
  {
    "codigo":409904000,
    "descripcion":"ENFERMEDAD CAUSADA POR RICKETTSIALES"
  },
  {
    "codigo":1163568002,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA SUPERPUESTA DE COLON"
  },
  {
    "codigo":278832007,
    "descripcion":"GRUPO DE DISPLASIAS CON HUESOS TORCIDOS"
  },
  {
    "codigo":702981001,
    "descripcion":"REALIZA ELONGACIÓN DE BAJO IMPACTO"
  },
  {
    "codigo":333231000119107,
    "descripcion":"OPACIDAD PERIFÉRICA DE CÓRNEA DERECHA"
  },
  {
    "codigo":735749005,
    "descripcion":"MIELOMENINGOCELE CONCOMITANTE CON HIDROCEFALIA"
  },
  {
    "codigo":1260037005,
    "descripcion":"CARCINOMA ADENOESCAMOSO DE LARINGE"
  },
  {
    "codigo":111322000,
    "descripcion":"ANOMALÍA CONGÉNITA DE LAS VENAS PULMONARES"
  },
  {
    "codigo":309765009,
    "descripcion":"DOLOR ASOCIADO CON PRÓTESIS ARTICULAR DE CADERA"
  },
  {
    "codigo":209626004,
    "descripcion":"DESGARRO COMPLETO DEL LIGAMENTO LATERAL EXTERNO DE LA RODILLA"
  },
  {
    "codigo":764847000,
    "descripcion":"ADENOSARCOMA DE CUELLO UTERINO"
  },
  {
    "codigo":699311001,
    "descripcion":"SÍNDROME DE DUPLICACIÓN 22Q11.2"
  },
  {
    "codigo":76719002,
    "descripcion":"VETEADO DE ESMALTE DENTAL"
  },
  {
    "codigo":109487003,
    "descripcion":"HIPOCALCIFICACIÓN DE ESMALTE"
  },
  {
    "codigo":371631005,
    "descripcion":"TRASTORNO DE PÁNICO"
  },
  {
    "codigo":107652000,
    "descripcion":"HALLAZGO EN LA DISTRIBUCIÓN"
  },
  {
    "codigo":402564006,
    "descripcion":"MELANOMAS MALIGNOS PRIMARIOS MÚLTIPLES"
  },
  {
    "codigo":42116007,
    "descripcion":"PROLAPSO DE LA BÓVEDA VAGINAL POSHISTERECTOMÍA"
  },
  {
    "codigo":171353001,
    "descripcion":"APTO PARA CONDUCIR"
  },
  {
    "codigo":7513007,
    "descripcion":"MORFEA GENERALIZADA"
  },
  {
    "codigo":398894000,
    "descripcion":"SENSIBILIDAD DEL PIE A PINCHAZO CON ALFILER - ANORMAL"
  },
  {
    "codigo":890414001,
    "descripcion":"CRIPTOFTALMOS BILATERAL"
  },
  {
    "codigo":235054004,
    "descripcion":"ENFERMEDAD VIRAL DE LA MUCOSA ORAL"
  },
  {
    "codigo":202286005,
    "descripcion":"CONTRACTURA EN ADUCCIÓN DE LA CADERA"
  },
  {
    "codigo":366126005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD DE EXTERIORIZAR EL ESPUTO"
  },
  {
    "codigo":167683006,
    "descripcion":"GLUCOSA DETECTADA EN ESPÉCIMEN DE MATERIA FECAL ANALIZADO MEDIANTE CROMATOGRAFÍA"
  },
  {
    "codigo":67544000,
    "descripcion":"REACCIÓN LOCAL DESFAVORABLE A LA PRUEBA CUTÁNEA"
  },
  {
    "codigo":724739009,
    "descripcion":"TRASTORNO DE CONDUCTA DISOCIAL DE COMIENZO EN LA INFANCIA CON EMOCIONES PROSOCIALES NORMALES"
  },
  {
    "codigo":1148888004,
    "descripcion":"GLOMERULOESCLEROSIS NODULAR DEBIDA A ENFERMEDAD POR DEPÓSITO DE CADENAS PESADAS"
  },
  {
    "codigo":722904004,
    "descripcion":"FRACTURA DE CRÁNEO DEPRIMIDA DEBIDA A TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":296920007,
    "descripcion":"SOBREDOSIS DE HORMONA CORTICOTRÓFICA"
  },
  {
    "codigo":196781001,
    "descripcion":"APENDICITIS AGUDA CON PERITONITIS"
  },
  {
    "codigo":721069005,
    "descripcion":"SÍNDROME DE QUINTO METACARPIANO CORTO Y RESISTENCIA A LA INSULINA"
  },
  {
    "codigo":293250001,
    "descripcion":"REACCIÓN ADVERSA AL QUINESTROL"
  },
  {
    "codigo":194946005,
    "descripcion":"MIOCARDITIS AGUDA - GRIPAL"
  },
  {
    "codigo":129032061000119103,
    "descripcion":"ESTADO DE HIPERCOAGULABILIDAD DEBIDO A FIBRILACIÓN AURICULAR"
  },
  {
    "codigo":782935003,
    "descripcion":"SÍNDROME DE TEMBLOR, NISTAGMO, ÚLCERA DUODENAL"
  },
  {
    "codigo":94807005,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE NERVIO CRANEAL"
  },
  {
    "codigo":29271008,
    "descripcion":"CAMPTODACTILIA"
  },
  {
    "codigo":715564000,
    "descripcion":"COREOATETOSIS DISTÓNICA PAROXÍSTICA CON ATAXIA EPISÓDICA Y ESPASTICIDAD"
  },
  {
    "codigo":289580000,
    "descripcion":"LOQUIOS ABUNDANTES"
  },
  {
    "codigo":92972001,
    "descripcion":"MONOFTALMÍA"
  },
  {
    "codigo":254977002,
    "descripcion":"NEOPLASIA BENIGNA DE NERVIO ÓPTICO Y SU VAINA"
  },
  {
    "codigo":123905003,
    "descripcion":"INTOXICACIÓN POR SCROPHULARIACEAE"
  },
  {
    "codigo":8061000119107,
    "descripcion":"DISFUNCIÓN ERÉCTIL DEBIDA A TRASTORNO DE VASO SANGUÍNEO"
  },
  {
    "codigo":713729005,
    "descripcion":"INFECCIÓN CAUSADA POR COCCIDIA CONCOMITANTE CON INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":189441007,
    "descripcion":"NEOPLASIA DE ÓRGANOS GENITOURINARIOS DE COMPORTAMIENTO INCIERTO"
  },
  {
    "codigo":25601009,
    "descripcion":"ERITROCITOSIS POR AUTOTRANSFUSIÓN"
  },
  {
    "codigo":187606005,
    "descripcion":"NEOPLASIA MALIGNA DE MEMBRANA MUCOSA DE LABIO SUPERIOR"
  },
  {
    "codigo":253142006,
    "descripcion":"ATROFIA DEL CUERPO CALLOSO"
  },
  {
    "codigo":89302007,
    "descripcion":"LLANTO POR DISTRÉS NO ESPECÍFICO"
  },
  {
    "codigo":449750009,
    "descripcion":"BORDE DE HERIDA AGUDO"
  },
  {
    "codigo":23766009,
    "descripcion":"PROBLEMA BÁSICO PARA EL APRENDIZAJE DE LA LECTURA"
  },
  {
    "codigo":284075002,
    "descripcion":"SANGRADO VAGINAL EN GOTAS DURANTE EL EMBARAZO"
  },
  {
    "codigo":415147002,
    "descripcion":"NEUROPATÍA ÓPTICA ISQUÉMICA POSTERIOR"
  },
  {
    "codigo":447915002,
    "descripcion":"ANOMALÍA DE EBSTEIN DE VÁLVULA TRICÚSPIDE IZQUIERDA CON CONEXIONES AURICULOVENTRICULARES DISCORDANTES"
  },
  {
    "codigo":85632001,
    "descripcion":"ABORTO ESPONTÁNEO CON LACERACIÓN DE VAGINA"
  },
  {
    "codigo":1363584003,
    "descripcion":"HIPEROSTOSIS CORTICAL DISPLÁSICA TIPO AL-GAZALI"
  },
  {
    "codigo":216704003,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR MALATIÓN"
  },
  {
    "codigo":282240006,
    "descripcion":"CAPAZ DE CAMINAR HACIA ATRÁS ARRASTRANDO UN JUGUETE GRANDE"
  },
  {
    "codigo":249472009,
    "descripcion":"SIEMPRE CON HAMBRE"
  },
  {
    "codigo":247637008,
    "descripcion":"PREOCUPACIÓN POR EL TAMAÑO DEL CUERPO"
  },
  {
    "codigo":1263445009,
    "descripcion":"CEMENTOMA GIGANTIFORME FAMILIAR DE MANDÍBULA"
  },
  {
    "codigo":278570001,
    "descripcion":"CORONA DENTAL VOLUMINOSA"
  },
  {
    "codigo":16426003,
    "descripcion":"FUNCIÓN CORPORAL GENERAL DESCONOCIDA"
  },
  {
    "codigo":1228842003,
    "descripcion":"PLASMOCITOSIS CUTÁNEA PRIMARIA"
  },
  {
    "codigo":737322008,
    "descripcion":"HEMORRAGIA TARDÍA DEBIDA A EMBARAZO ECTÓPICO Y POSTERIOR A ÉL"
  },
  {
    "codigo":409642009,
    "descripcion":"ERUPCIÓN CON LESIONES EN EL MISMO NIVEL DE EVOLUCIÓN"
  },
  {
    "codigo":735487003,
    "descripcion":"INFECCIÓN PÉLVICA DEBIDA A EMBARAZO CON DESENLACE ABORTIVO Y POSTERIOR A ÉL"
  },
  {
    "codigo":211199006,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE AXILA"
  },
  {
    "codigo":1259775006,
    "descripcion":"MEDULOEPITELIOMA PRIMARIO MALIGNO DE CUERPO CILIAR"
  },
  {
    "codigo":78292000,
    "descripcion":"FRACTURA DE DIÁFISIS DE HUESO METACARPIANO"
  },
  {
    "codigo":274900003,
    "descripcion":"TRICOLEMOMA"
  },
  {
    "codigo":405972006,
    "descripcion":"ESTADIO IV DEL GRUPO NACIONAL PARA EL ESTUDIO DEL TUMOR DE WILMS"
  },
  {
    "codigo":209364006,
    "descripcion":"FRACTURA-LUXACIÓN EXPUESTA DE ARTICULACIÓN MEDIOTARSIANA"
  },
  {
    "codigo":733652008,
    "descripcion":"HIPERPLASIA DE CÉLULAS DE LEYDIG DE TESTÍCULO"
  },
  {
    "codigo":43689004,
    "descripcion":"DESVIACIÓN CUBITAL DE LA MUÑECA"
  },
  {
    "codigo":830121005,
    "descripcion":"SISTEMA NERVIOSO CENTRAL NORMAL"
  },
  {
    "codigo":404137004,
    "descripcion":"LINFOMA LINFOBLÁSTICO DE PRECURSORES DE CÉLULAS B CON COMPROMISO CUTÁNEO"
  },
  {
    "codigo":305833007,
    "descripcion":"ATENDIDO POR SERVICIO DE BIOQUÍMICA CLÍNICA"
  },
  {
    "codigo":699049007,
    "descripcion":"ACROSINDACTILIA DE DEDO DE PIE"
  },
  {
    "codigo":238462001,
    "descripcion":"CALLO DE DURLACHER"
  },
  {
    "codigo":369534005,
    "descripcion":"TUMOR MALIGNO QUE COMPROMETE EL OVARIO DERECHO POR PROPAGACIÓN DIRECTA DEL CUELLO UTERINO"
  },
  {
    "codigo":402302006,
    "descripcion":"ECCEMA CONSTITUCIONAL CRÓNICO"
  },
  {
    "codigo":74622009,
    "descripcion":"PALADAR DURO CORTO CONGÉNITO"
  },
  {
    "codigo":300328001,
    "descripcion":"HÍGADO DE CONSISTENCIA FIRME"
  },
  {
    "codigo":302163009,
    "descripcion":"URTICARIA MICROPAPULOSA IDIOPÁTICA"
  },
  {
    "codigo":398632002,
    "descripcion":"SENSACIÓN VIBRATORIA ALTERADA DEL PIE"
  },
  {
    "codigo":365864004,
    "descripcion":"HALLAZGO RELACIONADO CON EL ESTADO PARA HEPATITIS A"
  },
  {
    "codigo":1119528007,
    "descripcion":"VISIÓN BORROSA TRANSITORIA"
  },
  {
    "codigo":298493002,
    "descripcion":"CIFOSIS DE LA COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":429565004,
    "descripcion":"TUMOR CEREBRAL DE CÉLULAS GERMINALES"
  },
  {
    "codigo":724477004,
    "descripcion":"CISTOCELE Y RECTOCELE CONCOMITANTE CON PROLAPSO UTEROVAGINAL COMPLETO"
  },
  {
    "codigo":36349006,
    "descripcion":"DOLOR URENTE"
  },
  {
    "codigo":1279698005,
    "descripcion":"FIEBRE RECURRENTE CAUSADA POR BORRELIA CAUCASICA"
  },
  {
    "codigo":722642008,
    "descripcion":"LACERACIÓN MAYOR DE ARTERIA CARÓTIDA"
  },
  {
    "codigo":130983001,
    "descripcion":"CON MAYOR RIESGO DE DISREFLEXIA AUTÓNOMA"
  },
  {
    "codigo":296658009,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE CLOXACILINA"
  },
  {
    "codigo":196519006,
    "descripcion":"SIALECTASIA SUBLINGUAL"
  },
  {
    "codigo":294823008,
    "descripcion":"ALERGIA A OXITOCINA"
  },
  {
    "codigo":65447009,
    "descripcion":"PERICARDITIS DEBIDA A MONONUCLEOSIS INFECCIOSA"
  },
  {
    "codigo":1144956000,
    "descripcion":"VASCULITIS DEBIDA A ENFERMEDAD INFLAMATORIA INTESTINAL"
  },
  {
    "codigo":30844003,
    "descripcion":"INTOXICACIÓN POR VERATRUM"
  },
  {
    "codigo":12108261000119106,
    "descripcion":"QUEMADURA QUÍMICA DE VAGINA"
  },
  {
    "codigo":291153000,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR DROPERIDOL"
  },
  {
    "codigo":94545001,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE PIEL DE GLÚTEO"
  },
  {
    "codigo":29009002,
    "descripcion":"INFECCIÓN CAUSADA POR NOSEMA APIS"
  },
  {
    "codigo":782673001,
    "descripcion":"MONOSOMÍA DISTAL 4Q"
  },
  {
    "codigo":127313006,
    "descripcion":"LESIÓN TRAUMÁTICA DE CONDUCTO BILIAR"
  },
  {
    "codigo":715302000,
    "descripcion":"SOBREDOSIS INTENCIONAL DE DISULFIRAM"
  },
  {
    "codigo":61777009,
    "descripcion":"ENFERMEDAD POR HEMOGLOBINA C - F"
  },
  {
    "codigo":27174002,
    "descripcion":"PIELITIS"
  },
  {
    "codigo":289318004,
    "descripcion":"MUÑÓN UMBILICAL QUE NO CICATRIZA"
  },
  {
    "codigo":92710005,
    "descripcion":"CARCINOMA IN SITU DE PIEL DE TOBILLO"
  },
  {
    "codigo":123643003,
    "descripcion":"ATRESIA ADQUIRIDA DE VÁLVULA PULMONAR"
  },
  {
    "codigo":1336059008,
    "descripcion":"EPISODIO DE USO NOCIVO DE COCAÍNA INTRAVENOSA"
  },
  {
    "codigo":56272000,
    "descripcion":"TROMBOSIS VENOSA PROFUNDA EN PUERPERIO"
  },
  {
    "codigo":254715009,
    "descripcion":"TUMOR BENIGNO DE PIEL CON DIFERENCIACIÓN ECRINA"
  },
  {
    "codigo":189179009,
    "descripcion":"CRANEOFARINGIOMA"
  },
  {
    "codigo":89040002,
    "descripcion":"QUEMADURA PROFUNDA DE TERCER GRADO DEL DORSO DE LA MANO"
  },
  {
    "codigo":11836031000119106,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN TARSOMETATARSIANA DE PIE DERECHO"
  },
  {
    "codigo":123571004,
    "descripcion":"ANOMALÍA CONGÉNITA DE HUESO METACARPIANO"
  },
  {
    "codigo":1137616007,
    "descripcion":"LÍNEA CAPILAR POSTERIOR ALTA"
  },
  {
    "codigo":21669001,
    "descripcion":"AMENORREA DISPONDERAL"
  },
  {
    "codigo":251045002,
    "descripcion":"ARTERIA PULMONAR PERIFÉRICA CON ANEURISMA ARTERIOVENOSO"
  },
  {
    "codigo":283813005,
    "descripcion":"MORDEDURA DE ANIMAL EN EL PULGAR"
  },
  {
    "codigo":871802002,
    "descripcion":"TUMOR PILAR DE CUERO CABELLUDO"
  },
  {
    "codigo":773498006,
    "descripcion":"SÍNDROME DE ATAXIA CEREBELOSA, EPILEPSIA Y DISCAPACIDAD INTELECTUAL AUTOSÓMICO RECESIVO DEBIDO A DEFICIENCIA DE TUD"
  },
  {
    "codigo":1197647004,
    "descripcion":"AMIANTO EN VIVIENDA"
  },
  {
    "codigo":116303008,
    "descripcion":"HALLAZGO RELACIONADO CON LA COLUMNA DORSAL"
  },
  {
    "codigo":280143008,
    "descripcion":"REMANENTE VENOSO"
  },
  {
    "codigo":312911008,
    "descripcion":"EDEMA MACULAR CLÍNICAMENTE SIGNIFICATIVO"
  },
  {
    "codigo":704292005,
    "descripcion":"FRACTURA POR OSTEOPOROSIS SECUNDARIA DE CLAVÍCULA"
  },
  {
    "codigo":210937001,
    "descripcion":"TRASTORNO DEBIDO A QUEMADURA DE MUÑECA Y MANO Y POSTERIOR A ELLA"
  },
  {
    "codigo":276473005,
    "descripcion":"SÍNDROME DEL BEBÉ SACUDIDO"
  },
  {
    "codigo":407545006,
    "descripcion":"PROTUBERANCIA EN EL ESTOMA"
  },
  {
    "codigo":372942001,
    "descripcion":"INFECCIÓN CAUSADA POR PENICILLIUM BACILLOSPORUM"
  },
  {
    "codigo":209102002,
    "descripcion":"LUXACIÓN VERTEBRAL EXPUESTA CON LESIÓN DE LA COLA DE CABALLO"
  },
  {
    "codigo":1259513009,
    "descripcion":"DEMENCIA DEBIDA A ENFERMEDAD DE WHIPPLE"
  },
  {
    "codigo":307406004,
    "descripcion":"PIE CON NECROSIS ISQUÉMICA"
  },
  {
    "codigo":897230005,
    "descripcion":"CURVATURA ANORMAL DE FALANGE DISTAL DE CUARTO DEDO DE PIE"
  },
  {
    "codigo":241870006,
    "descripcion":"EFECTO TÓXICO CAUSADO POR PINTURA EN AEROSOL"
  },
  {
    "codigo":733390007,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE TODO EL ESCROTO"
  },
  {
    "codigo":371107004,
    "descripcion":"CRISIS CONVULSIVAS QUE COMPLICAN HEMORRAGIA INTRACRANEAL EN EL RECIÉN NACIDO"
  },
  {
    "codigo":403875005,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS INTRAEPIDÉRMICO DE FRENTE"
  },
  {
    "codigo":305571007,
    "descripcion":"BAJO ATENCIÓN DE ENFERMERA ESPECIALIZADA EN ONCOLOGÍA"
  },
  {
    "codigo":43427008,
    "descripcion":"TEJIDO GLIAL ECTÓPICO"
  },
  {
    "codigo":205432007,
    "descripcion":"HEMIVÉRTEBRA LUMBAR - INESTABLE"
  },
  {
    "codigo":203597000,
    "descripcion":"INESTABILIDAD CRÓNICA DE RODILLA"
  },
  {
    "codigo":860792009,
    "descripcion":"DERRAME PLEURAL DEBIDO A ENFERMEDAD NEOPLÁSICA MALIGNA"
  },
  {
    "codigo":762488008,
    "descripcion":"QUEMADURA COMPLEJA DE CADERA"
  },
  {
    "codigo":301901007,
    "descripcion":"CAPAZ DE LEVANTAR LA CABEZA"
  },
  {
    "codigo":365602000,
    "descripcion":"NIVEL DE CÉLULAS DEL LUPUS ERITEMATOSO - HALLAZGO"
  },
  {
    "codigo":1119266006,
    "descripcion":"ADHERENCIA VITREOMACULAR"
  },
  {
    "codigo":234530009,
    "descripcion":"MIOPATÍA SARCOIDE CRÓNICA"
  },
  {
    "codigo":396535002,
    "descripcion":"ESTADIO IV: METÁSTASIS A DISTANCIA O EXTENSIÓN HACIA OTROS ÓRGANOS (CARCINOMA CORTICAL SUPRARRENAL)"
  },
  {
    "codigo":298231004,
    "descripcion":"ARTICULACIÓN TEMPOROMANDIBULAR RÍGIDA"
  },
  {
    "codigo":722380003,
    "descripcion":"SÍNDROME DE CATARATA CONGÉNITA CON DISCAPACIDAD INTELECTUAL E HIPOGONADISMO HIPOGONADOTRÓFICO"
  },
  {
    "codigo":296396003,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE HIOSCINA"
  },
  {
    "codigo":1080551000119100,
    "descripcion":"LEIOMIOSARCOMA PRIMARIO DE REGIÓN DE CADERA IZQUIERDA"
  },
  {
    "codigo":165324008,
    "descripcion":"RESULTADO DE BIOPSIA, NORMAL"
  },
  {
    "codigo":294561002,
    "descripcion":"ALERGIA A CLINDAMICINA"
  },
  {
    "codigo":1179297007,
    "descripcion":"DISTROFIA MUSCULAR DE CINTURAS ASOCIADA A LIMS2"
  },
  {
    "codigo":15989991000119102,
    "descripcion":"ESTRÍAS ANGIOIDES DE COROIDES DE AMBOS OJOS"
  },
  {
    "codigo":1144694002,
    "descripcion":"APLASIA DE FALANGE PROXIMAL DE DEDO GORDO"
  },
  {
    "codigo":817014004,
    "descripcion":"ANTEPIE IZQUIERDO AMPUTADO"
  },
  {
    "codigo":423798004,
    "descripcion":"FALTA DE REFRIGERACIÓN EN EL HOGAR"
  },
  {
    "codigo":292726009,
    "descripcion":"REACCIÓN ADVERSA AL NITRITO DE SODIO"
  },
  {
    "codigo":94283001,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE EPIDÍDIMO"
  },
  {
    "codigo":290891005,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR SERTRALINA"
  },
  {
    "codigo":389195007,
    "descripcion":"DISPLASIA OSTEODISPLÁSICA, TIPO II"
  },
  {
    "codigo":1306699009,
    "descripcion":"RETINOPATÍA PROLIFERATIVA DEBIDA A DIABETES MELLITUS EN TRATAMIENTO, ESTABLE"
  },
  {
    "codigo":92448001,
    "descripcion":"NEOPLASIA BENIGNA DE COLON TRANSVERSO"
  },
  {
    "codigo":715040005,
    "descripcion":"LLORA"
  },
  {
    "codigo":289056005,
    "descripcion":"UTILIZA TENEDOR PARA ALIMENTARSE"
  },
  {
    "codigo":385525003,
    "descripcion":"HERNIA DE LITTRÉ"
  },
  {
    "codigo":254453003,
    "descripcion":"NEOPLASIA DE SURCO LABIAL INFERIOR"
  },
  {
    "codigo":188917006,
    "descripcion":"NEOPLASIA BENIGNA DE HUESO LAGRIMAL"
  },
  {
    "codigo":1335797007,
    "descripcion":"ARTRITIS IDIOPÁTICA JUVENIL DE REGIÓN DE MUÑECA"
  },
  {
    "codigo":90613007,
    "descripcion":"ENCOPRESIS SIN ESTREÑIMIENTO NI INCONTINENCIA POR REBOSAMIENTO"
  },
  {
    "codigo":285386001,
    "descripcion":"DOLOR EN HEMITÓRAX DERECHO"
  },
  {
    "codigo":23242002,
    "descripcion":"POSICIÓN GENUPECTORAL"
  },
  {
    "codigo":10966401000119102,
    "descripcion":"HERIDA ABIERTA DE MUSLO IZQUIERDO DEBIDA A MORDEDURA HUMANA"
  },
  {
    "codigo":1237493007,
    "descripcion":"METÁSTASIS DE CARCINOMA DE EXOCÉRVIX"
  },
  {
    "codigo":283551000,
    "descripcion":"HERIDA DE PERDIGÓN EN REGIÓN OCULAR"
  },
  {
    "codigo":185247004,
    "descripcion":"ATENDIDO EN UN CONSULTORIO DE NEUROCIRUGÍA"
  },
  {
    "codigo":314484001,
    "descripcion":"HEMORRAGIA SECUNDARIA POSAMIGDALECTOMÍA"
  },
  {
    "codigo":609396006,
    "descripcion":"DISPOSICIÓN DE HIPERSENSIBILIDAD NO ALÉRGICA"
  },
  {
    "codigo":85108007,
    "descripcion":"CATARRO TUBOTIMPÁNICO AGUDO"
  },
  {
    "codigo":871540009,
    "descripcion":"MIELOFIBROSIS DEBIDA A POLICITEMIA VERA Y POSTERIOR A ELLA"
  },
  {
    "codigo":11785601000119107,
    "descripcion":"ABRASIÓN DE PIEL DE DEDO ÍNDICE IZQUIERDO"
  },
  {
    "codigo":247113007,
    "descripcion":"CAMBIOS EN LOS CRUCES ARTERIOVENOSOS DE LA RETINA"
  },
  {
    "codigo":441886002,
    "descripcion":"LESIÓN TRAUMÁTICA DE LIGAMENTO DE MANO"
  },
  {
    "codigo":15902003,
    "descripcion":"ÚLCERA GÁSTRICA CON HEMORRAGIA"
  },
  {
    "codigo":81438002,
    "descripcion":"ANOMALÍA DEL CROMOSOMA Y"
  },
  {
    "codigo":310814007,
    "descripcion":"DIFICULTADES DEL HABLA"
  },
  {
    "codigo":704030008,
    "descripcion":"FRACTURA NO EXPUESTA EN MARTILLO DE FALANGE DISTAL DE DEDO MEÑIQUE"
  },
  {
    "codigo":278046008,
    "descripcion":"SARCOMA DE VEJIGA URINARIA"
  },
  {
    "codigo":734963004,
    "descripcion":"ÉMBOLO DE ARTERIA CEREBRAL POSTERIOR DERECHA"
  },
  {
    "codigo":1259251005,
    "descripcion":"CARCINOMA MUCOEPIDERMOIDE PRIMARIO DE PIEL"
  },
  {
    "codigo":46835007,
    "descripcion":"ENCANDILAMIENTO"
  },
  {
    "codigo":700360000,
    "descripcion":"INGESTA EXCESIVA DE NUTRIENTES PREVISTA"
  },
  {
    "codigo":733128002,
    "descripcion":"OBSTRUCCIÓN DE VENA CAVA SUPERIOR CON CUERPO EXTRAÑO"
  },
  {
    "codigo":208840005,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA NO EXPUESTA DE LA ARTICULACIÓN MEDIOCARPIANA"
  },
  {
    "codigo":77768006,
    "descripcion":"HEMORRAGIA INTRACRANEAL TRAUMÁTICA CON HERIDA INTRACRANEAL ABIERTA"
  },
  {
    "codigo":1083061000119100,
    "descripcion":"OTITIS MEDIA AGUDA SUPURATIVA RECIDIVANTE BILATERAL CON RUPTURA ESPONTÁNEA DE LAS MEMBRANAS TIMPÁNICAS"
  },
  {
    "codigo":272541000,
    "descripcion":"POSICIÓN SEMIARRODILLADA"
  },
  {
    "codigo":12232008,
    "descripcion":"ANEURISMA SIFILÍTICO DE LA AORTA"
  },
  {
    "codigo":75933004,
    "descripcion":"AMENAZA DE ABORTO EN EL SEGUNDO TRIMESTRE"
  },
  {
    "codigo":698525006,
    "descripcion":"ABRASIÓN LOCALIZADA DE DIENTE"
  },
  {
    "codigo":205170001,
    "descripcion":"HIPOPLASIA DE RADIO"
  },
  {
    "codigo":237938003,
    "descripcion":"DEFICIENCIA DE COBALAMINA G"
  },
  {
    "codigo":303474004,
    "descripcion":"NO REMUEVE PRÓTESIS"
  },
  {
    "codigo":170567000,
    "descripcion":"ENFERMEDAD CRÓNICA - TRATAMIENTO SUSPENDIDO"
  },
  {
    "codigo":301639002,
    "descripcion":"SE SUBE Y SE BAJA DE LOS MUEBLES"
  },
  {
    "codigo":1153607003,
    "descripcion":"OCLUSIÓN DE ARTERIA COMUNICANTE POSTERIOR DERECHA"
  },
  {
    "codigo":399943003,
    "descripcion":"AMPOLLA TRAUMÁTICA DE MIEMBRO INFERIOR"
  },
  {
    "codigo":236103005,
    "descripcion":"DEHISCENCIA DE ANASTOMOSIS DE INTESTINO GRUESO"
  },
  {
    "codigo":203335006,
    "descripcion":"ENFERMEDAD DE PAGET DEL RADIO"
  },
  {
    "codigo":201500003,
    "descripcion":"ARTROPATÍA REACTIVA DE ARTICULACIÓN DE MANO DEBIDO A DISENTERÍA Y POSTERIOR A ELLA"
  },
  {
    "codigo":37660004,
    "descripcion":"ABSCESO SUBDURAL"
  },
  {
    "codigo":299804004,
    "descripcion":"REFLEJO GLABELAR AUSENTE"
  },
  {
    "codigo":267036007,
    "descripcion":"DISNEA"
  },
  {
    "codigo":365340009,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA ABRIR LA CASA CUANDO ESTÁ CERRADA"
  },
  {
    "codigo":430876009,
    "descripcion":"DIVERTICULITIS DE RECTOSIGMOIDES"
  },
  {
    "codigo":319311000119101,
    "descripcion":"LUXACIÓN RECURRENTE DE ARTICULACIÓN DE REGIÓN DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":363505006,
    "descripcion":"NEOPLASIA MALIGNA DE CAVIDAD BUCAL"
  },
  {
    "codigo":232433008,
    "descripcion":"EPIGLOTITIS Y SUPRAEPIGLOTITIS AGUDA DEL ADULTO"
  },
  {
    "codigo":722118005,
    "descripcion":"SÍNDROME NEFRÓTICO CONGÉNITO DEBIDO A INFECCIÓN CONGÉNITA"
  },
  {
    "codigo":66758006,
    "descripcion":"ACRODISOSTOSIS"
  },
  {
    "codigo":33990008,
    "descripcion":"TEJIDO ECTÓPICO DE LA GLÁNDULA PARÓTIDA"
  },
  {
    "codigo":230598008,
    "descripcion":"NEUROPATÍA CAUSADA POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":294299005,
    "descripcion":"ALERGIA A LÍQUIDO DE DIÁLISIS"
  },
  {
    "codigo":95856002,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE LA MANO"
  },
  {
    "codigo":63088003,
    "descripcion":"ASMA EXTRÍNSECA SIN ESTADO DE MAL ASMÁTICO"
  },
  {
    "codigo":718448006,
    "descripcion":"INTUBACIÓN TRAQUEAL INESPERADAMENTE DIFÍCIL"
  },
  {
    "codigo":292464007,
    "descripcion":"OBESIDAD CONSTITUCIONAL"
  },
  {
    "codigo":1144432007,
    "descripcion":"ATROFIA DE HIPOTÁLAMO"
  },
  {
    "codigo":290629002,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR LOMUSTINA"
  },
  {
    "codigo":61253004,
    "descripcion":"EROSIÓN DEL CUELLO UTERINO"
  },
  {
    "codigo":126789008,
    "descripcion":"NEOPLASIA DE LA GLÁNDULA SUBMAXILAR"
  },
  {
    "codigo":92186001,
    "descripcion":"NEOPLASIA BENIGNA DE HÍGADO"
  },
  {
    "codigo":94021008,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA PIEL DEL PÁRPADO"
  },
  {
    "codigo":26650005,
    "descripcion":"TRAQUEÍTIS AGUDA"
  },
  {
    "codigo":288794006,
    "descripcion":"CAPAZ DE HACER PREGUNTAS"
  },
  {
    "codigo":286959000,
    "descripcion":"EMBOLIA ARTERIAL PERIFÉRICA"
  },
  {
    "codigo":1204463009,
    "descripcion":"ENCEFALOPATÍA SÉPTICA"
  },
  {
    "codigo":254191009,
    "descripcion":"EPIDERMÓLISIS BULLOSA LOCALIZADA DE LA ZONA DE UNIÓN"
  },
  {
    "codigo":53913001,
    "descripcion":"ENDOMETRIOSIS EN UNA CICATRIZ CUTÁNEA"
  },
  {
    "codigo":283289009,
    "descripcion":"ASTILLA DE MADERA EN MANO"
  },
  {
    "codigo":281454002,
    "descripcion":"AFLOJAMIENTO DE ALAMBRE"
  },
  {
    "codigo":248686007,
    "descripcion":"SOPLO DEL FLUJO TRICUSPÍDEO DIASTÓLICO"
  },
  {
    "codigo":445294008,
    "descripcion":"ORIFICIO AURICULOVENTRICULAR COMÚN EN VENTRÍCULO CON DOBLE TRACTO DE ENTRADA"
  },
  {
    "codigo":1085571000119104,
    "descripcion":"EDENTULISMO COMPLETO DE CLASE IV DEBIDO A ENFERMEDAD PERIODONTAL"
  },
  {
    "codigo":1229891004,
    "descripcion":"SÍNDROME DE MICRODELECIÓN 20Q11.2"
  },
  {
    "codigo":48408000,
    "descripcion":"MORFOLOGÍA DE UNA COLONIA BACTERIANA, BORDE ONDULADO"
  },
  {
    "codigo":212248007,
    "descripcion":"LESIÓN DEL NERVIO ILIOLUMBAR"
  },
  {
    "codigo":112109002,
    "descripcion":"TEMBLOR SENIL"
  },
  {
    "codigo":15640861000119102,
    "descripcion":"ANILLO DE ÓXICO CORNEAL IZQUIERDO"
  },
  {
    "codigo":767469009,
    "descripcion":"ALERGIA A SEMILLA DE AMAPOLA"
  },
  {
    "codigo":896706003,
    "descripcion":"FORMA DELGADA ANORMAL CONGÉNITA DE HUESO LARGO"
  },
  {
    "codigo":208578003,
    "descripcion":"FRACTURA NO EXPUESTA DE EPÍFISIS DISTAL DE FÉMUR"
  },
  {
    "codigo":77506005,
    "descripcion":"INFECCIÓN CAUSADA POR TRYPANOSOMA CRUZI"
  },
  {
    "codigo":403351001,
    "descripcion":"ACNÉ OLEOSO"
  },
  {
    "codigo":1157015002,
    "descripcion":"DOLOR A LA DESCOMPRESIÓN DEL CUADRANTE INFERIOR IZQUIERDO DEL ABDOMEN"
  },
  {
    "codigo":1255319004,
    "descripcion":"SÍNDROME AUTOSÓMICO DOMINANTE DE DISCAPACIDAD INTELECTUAL, ANOMALÍAS CRANEOFACIALES Y DEFECTOS CARDÍACOS"
  },
  {
    "codigo":204908001,
    "descripcion":"APLASIA DE PENE"
  },
  {
    "codigo":237676006,
    "descripcion":"HIPERPLASIA LACTOTRÓFICA"
  },
  {
    "codigo":203073004,
    "descripcion":"CONTRACTURA DE MÚSCULOS ABDUCTORES DE LA CADERA"
  },
  {
    "codigo":301377004,
    "descripcion":"CASTIGO CON DOLOR"
  },
  {
    "codigo":235841007,
    "descripcion":"DOLOR ABDOMINAL CRÓNICO INESPECÍFICO"
  },
  {
    "codigo":201238000,
    "descripcion":"SEBORREA NASAL"
  },
  {
    "codigo":170305009,
    "descripcion":"EXAMEN DEL NIÑO A LAS 8 SEMANAS: NORMAL"
  },
  {
    "codigo":397846002,
    "descripcion":"PROBLEMA CON EL RESPIRADOR DEL PACIENTE"
  },
  {
    "codigo":70166002,
    "descripcion":"AMPOLLA DE LA CARA, CON INFECCIÓN"
  },
  {
    "codigo":1217046003,
    "descripcion":"NECROSIS AVASCULAR DE GLÁNDULA HIPÓFISIS"
  },
  {
    "codigo":234006003,
    "descripcion":"RUPTURA DE ARTERIA CARÓTIDA"
  },
  {
    "codigo":299542004,
    "descripcion":"AMPLITUD DE EVERSIÓN PASIVA DE ARTICULACIÓN SUBASTRAGALINA AUMENTADA"
  },
  {
    "codigo":365078004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA EXPRESAR PENSAMIENTOS"
  },
  {
    "codigo":37398008,
    "descripcion":"ORINA DIABÉTICA"
  },
  {
    "codigo":102934009,
    "descripcion":"EMBOLOLALIA"
  },
  {
    "codigo":1172616005,
    "descripcion":"PRUEBA DE FUNCIÓN HIPOFISARIA POR ENCIMA DE RANGO DE REFERENCIA"
  },
  {
    "codigo":428779003,
    "descripcion":"ARTROPATÍA DE RODILLA ASOCIADA CON TRASTORNO NEUROLÓGICO"
  },
  {
    "codigo":124040006,
    "descripcion":"LIPOPROTEÍNA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":168470004,
    "descripcion":"EXTENDIDO DE CÚPULA VAGINAL - INADECUADA"
  },
  {
    "codigo":35563005,
    "descripcion":"DIVERTÍCULO ADQUIRIDO DEL ESÓFAGO"
  },
  {
    "codigo":164800002,
    "descripcion":"CISTOMETRÍA FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":29881000175107,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN DE TALÓN DERECHO GRADO 4"
  },
  {
    "codigo":263104003,
    "descripcion":"FRACTURA-SUBLUXACIÓN DE LA ARTICULACIÓN RADIOCARPIANA"
  },
  {
    "codigo":230336005,
    "descripcion":"TRASTORNO DE TIC VOCAL"
  },
  {
    "codigo":15669841000119100,
    "descripcion":"RETROVERSIÓN CONGÉNITA DE FÉMUR DERECHO"
  },
  {
    "codigo":64661000,
    "descripcion":"PULSO FILIFORME"
  },
  {
    "codigo":294037000,
    "descripcion":"ALERGIA A SALBUTAMOL"
  },
  {
    "codigo":295872008,
    "descripcion":"SOBREDOSIS DE LOFEPRAMINA"
  },
  {
    "codigo":1088081000119101,
    "descripcion":"OTITIS EXTERNA NO INFECCIOSA AGUDA DE CONDUCTO AUDITIVO EXTERNO IZQUIERDO"
  },
  {
    "codigo":228501004,
    "descripcion":"NO USA TABACO EN POLVO HÚMEDO"
  },
  {
    "codigo":130197005,
    "descripcion":"DEFICIENCIA DE CONDROITINASA"
  },
  {
    "codigo":643996241000119101,
    "descripcion":"ENDOMETRIOSIS SUPERFICIAL DE OVARIOS BILATERAL"
  },
  {
    "codigo":423274005,
    "descripcion":"CARCINOMA DE OVARIO, ESTADIO 4"
  },
  {
    "codigo":718186006,
    "descripcion":"DEFORMIDAD POR ROTACIÓN DE COLUMNA VERTEBRAL CERVICAL"
  },
  {
    "codigo":161130006,
    "descripcion":"PROBLEMAS RELACIONADOS CON LA EDUCACIÓN SEXUAL"
  },
  {
    "codigo":783722008,
    "descripcion":"MIOPATÍA Y DIABETES MELLITUS"
  },
  {
    "codigo":93759001,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL CUERPO COCCÍGEO"
  },
  {
    "codigo":292202006,
    "descripcion":"REACCIÓN ADVERSA A UN DERIVADO DE MOSTAZA NITROGENADA"
  },
  {
    "codigo":192063005,
    "descripcion":"REACCIÓN DE ADAPTACIÓN CON SÍNTOMAS FÍSICOS"
  },
  {
    "codigo":126527005,
    "descripcion":"NEOPLASIA DE LA PIEL DEL HUECO POPLÍTEO"
  },
  {
    "codigo":350801000119105,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE CORTEZA SUPRARRENAL IZQUIERDA"
  },
  {
    "codigo":1142335009,
    "descripcion":"ATROFIA DE FIBRA DE MÚSCULO ESQUELÉTICO TIPO II"
  },
  {
    "codigo":124692001,
    "descripcion":"DEFICIENCIA DE ISOLEUCINA - ARNT LIGASA"
  },
  {
    "codigo":290367009,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR RANITIDINA"
  },
  {
    "codigo":91924004,
    "descripcion":"GINGIVITIS ALÉRGICA"
  },
  {
    "codigo":385001000,
    "descripcion":"INVASIÓN PERINEURAL POR TUMOR NO IDENTIFICADO"
  },
  {
    "codigo":1236969003,
    "descripcion":"METÁSTASIS DE CARCINOMA DE SURCO LABIAL INFERIOR"
  },
  {
    "codigo":286697003,
    "descripcion":"NIVEL MODERADO DE NEUROTISMO"
  },
  {
    "codigo":1204201006,
    "descripcion":"LINFADENITIS PÉLVICA AGUDA"
  },
  {
    "codigo":253929007,
    "descripcion":"HIPOPLASIA DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":283027004,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE LA NARIZ"
  },
  {
    "codigo":53651004,
    "descripcion":"FOLICULITIS PUSTULOSA"
  },
  {
    "codigo":1003923009,
    "descripcion":"SÍNDROME DE ROTHMUND THOMSON TIPO 2"
  },
  {
    "codigo":41461000087106,
    "descripcion":"HERIDA PUNZANTE DE ANTEBRAZO DERECHO CON CUERPO EXTRAÑO"
  },
  {
    "codigo":1264232003,
    "descripcion":"COAGULACIÓN INTRAVASCULAR DISEMINADA POSTERIOR A EMBARAZO MOLAR"
  },
  {
    "codigo":44021000087106,
    "descripcion":"HERIDA CORTANTE DE PIEL DE PALMA DE MANO IZQUIERDA"
  },
  {
    "codigo":46581000087109,
    "descripcion":"FRACTURA DE DIÁFISIS DE TIBIA DERECHA"
  },
  {
    "codigo":561885931000119106,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN DE TEJIDO PROFUNDO DE TALÓN DERECHO"
  },
  {
    "codigo":38901000087109,
    "descripcion":"DIPLOMA UNIVERSITARIO OBTENIDO"
  },
  {
    "codigo":410429000,
    "descripcion":"PARO CARDÍACO"
  },
  {
    "codigo":1196861001,
    "descripcion":"HEMANGIOMA BENIGNO DE ESÓFAGO"
  },
  {
    "codigo":246589002,
    "descripcion":"RESPUESTA PLANTAR EQUÍVOCA"
  },
  {
    "codigo":11848581000119101,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE PÁRPADO IZQUIERDO"
  },
  {
    "codigo":1297000008,
    "descripcion":"SOSPECHA DE CIERRE DE ÁNGULO DE AMBOS OJOS"
  },
  {
    "codigo":312125005,
    "descripcion":"INFECCIÓN BACTERIANA DEL APARATO GENITAL"
  },
  {
    "codigo":49981007,
    "descripcion":"EFECTO TÓXICO DE LA GASOLINA"
  },
  {
    "codigo":48146000,
    "descripcion":"HIPERTENSIÓN ARTERIAL DIASTÓLICA"
  },
  {
    "codigo":961792901000119102,
    "descripcion":"TROMBOFLEBITIS DE VENA PERONEA IZQUIERDA"
  },
  {
    "codigo":80914001,
    "descripcion":"ANAPLASIA DEL CUELLO UTERINO"
  },
  {
    "codigo":310290006,
    "descripcion":"ANTICUERPOS CONTRA MÚSCULO LISO DETECTADOS"
  },
  {
    "codigo":441362008,
    "descripcion":"DIFICULTAD PARA LA LECTURA DE LABIOS"
  },
  {
    "codigo":898279000,
    "descripcion":"ANQUILOSIS CONGÉNITA DE ARTICULACIÓN METACARPOFALÁNGICA DE DEDO ANULAR"
  },
  {
    "codigo":277522009,
    "descripcion":"TUMOR FIBROSO SOLITARIO DE MENINGES"
  },
  {
    "codigo":46311005,
    "descripcion":"LACERACIÓN PERINEAL QUE COMPROMETE EL PLIEGUE MUCOMEMBRANOSO DE LA COMISURA POSTERIOR DE LA VULVA"
  },
  {
    "codigo":206481000,
    "descripcion":"TRASTORNOS ENDOCRINOS Y METABÓLICOS PERINATALES"
  },
  {
    "codigo":16000031000119101,
    "descripcion":"TRASTORNO DE ESCLERÓTICA DE OJO IZQUIERDO"
  },
  {
    "codigo":403089004,
    "descripcion":"TIÑA NEGRA CAUSADA POR PHAEOANNELLOMYCES WERNECKII"
  },
  {
    "codigo":1156753007,
    "descripcion":"INTOXICACIÓN CAUSADA POR HUMOS DE FORMALINA"
  },
  {
    "codigo":401254000,
    "descripcion":"CONTROL DE CARDIOPATÍA CORONARIA - CANCELADO"
  },
  {
    "codigo":40806005,
    "descripcion":"DESREALIZACIÓN"
  },
  {
    "codigo":1251387004,
    "descripcion":"OCLUSIÓN DE MICROVASCULATURA DE PIEL DEBIDA A TROMBO PLAQUETARIO ASOCIADO A HEMOGLOBINA PAROXÍSTICA NOCTURNA"
  },
  {
    "codigo":366651007,
    "descripcion":"ELASTICIDAD CUTÁNEA - HALLAZGO"
  },
  {
    "codigo":301115008,
    "descripcion":"HALLAZGO DEL SISTEMA DE CONDUCCIÓN CARDÍACO"
  },
  {
    "codigo":399419008,
    "descripcion":"NINGÚN ÓRGANO Y\/O TEJIDO, SALVO TROMPA DE FALOPIO, COMPROMETIDO MACROSCÓPICAMENTE POR TUMOR"
  },
  {
    "codigo":364816003,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA COMER CON LOS DEDOS"
  },
  {
    "codigo":299280004,
    "descripcion":"AMPLITUD DE ADUCCIÓN PASIVA DE LA CADERA NORMAL"
  },
  {
    "codigo":233744008,
    "descripcion":"SARCOIDOSIS DE GANGLIO LINFÁTICO HILIAR"
  },
  {
    "codigo":168208008,
    "descripcion":"VIRUS IDENTIFICADO EN ESPÉCIMEN"
  },
  {
    "codigo":199141002,
    "descripcion":"EDEMA GESTACIONAL CON PROTEINURIA"
  },
  {
    "codigo":788965004,
    "descripcion":"LESIÓN TRAUMÁTICA DE CONDUCTO HEPÁTICO"
  },
  {
    "codigo":35301006,
    "descripcion":"TRAQUEOBRONQUITIS AGUDA"
  },
  {
    "codigo":680991000119108,
    "descripcion":"ATROFIA BILATERAL DE NERVIOS ÓPTICOS DESPUÉS DE INFLAMACIÓN"
  },
  {
    "codigo":787130000,
    "descripcion":"METABOLIZADOR INTERMEDIO-RÁPIDO DE LA SUBUNIDAD 1 DEL COMPLEJO VITAMINA K-EPÓXIDO REDUCTASA"
  },
  {
    "codigo":231909009,
    "descripcion":"QUERATOPATÍA INFECCIOSA DEL CRISTALINO"
  },
  {
    "codigo":33466002,
    "descripcion":"ALETEO OCULAR"
  },
  {
    "codigo":262842000,
    "descripcion":"SECCIÓN DE ESTÓMAGO"
  },
  {
    "codigo":721594000,
    "descripcion":"CARCINOMA PAPILAR IN SITU DE MAMA"
  },
  {
    "codigo":166373009,
    "descripcion":"NIVEL DE HORMONA LUTEINIZANTE DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":361146001,
    "descripcion":"PAPILA RENAL PEQUEÑA CONGÉNITA"
  },
  {
    "codigo":64399000,
    "descripcion":"INTOXICACIÓN POR KARWINSKIA HUMBOLDTIANA"
  },
  {
    "codigo":293775001,
    "descripcion":"ALERGIA A CITARABINA"
  },
  {
    "codigo":160868001,
    "descripcion":"ALOJAMIENTO DE UN NIÑO EN HOGAR SUSTITUTO"
  },
  {
    "codigo":62564004,
    "descripcion":"CONMOCIÓN CON PÉRDIDA DE LA CONSCIENCIA"
  },
  {
    "codigo":29796005,
    "descripcion":"INFECCIÓN CAUSADA POR PASSALURUS"
  },
  {
    "codigo":95332009,
    "descripcion":"ERUPCIÓN DEL LUPUS ERITEMATOSO SISTÉMICO"
  },
  {
    "codigo":128100009,
    "descripcion":"DEFICIENCIA MIXTA DE GRÁNULOS ALFA Y LISOSOMAS"
  },
  {
    "codigo":1240377003,
    "descripcion":"TRASTORNO NEONATAL PRECOZ DEBIDO A ANOMALÍA DE PLACENTA"
  },
  {
    "codigo":716089008,
    "descripcion":"SÍNDROME DE ANOMALÍAS CRANEOFACIALES, DIGITALES Y GENITALES"
  },
  {
    "codigo":124430002,
    "descripcion":"DEFICIENCIA DE GLUTATIÓN TIOLESTERASA"
  },
  {
    "codigo":714254003,
    "descripcion":"ORGANOMEGALIA ABDOMINAL"
  },
  {
    "codigo":91662004,
    "descripcion":"BLEFARITIS ULCEROSA"
  },
  {
    "codigo":15727801000119109,
    "descripcion":"ADHERENCIA DE ARTICULACIÓN TEMPOROMANDIBULAR IZQUIERDA"
  },
  {
    "codigo":288270007,
    "descripcion":"LACTANTE POSTÉRMINO - MÁS DE 42 SEMANAS"
  },
  {
    "codigo":419342009,
    "descripcion":"ALERGIA A LA AVENA"
  },
  {
    "codigo":145298771000119104,
    "descripcion":"NEOPLASIA CARCINOIDE MALIGNA DE PULMÓN IZQUIERDO"
  },
  {
    "codigo":417507004,
    "descripcion":"PRUEBA DE HEAF, GRADO 1"
  },
  {
    "codigo":286435003,
    "descripcion":"CAPAZ DE PLANIFICAR LAS COMIDAS"
  },
  {
    "codigo":24291004,
    "descripcion":"DILATACIÓN CONGÉNITA DE COLON"
  },
  {
    "codigo":253667008,
    "descripcion":"ARTERIA BRAQUIOCEFÁLICA RETROESOFÁGICA ABERRANTE"
  },
  {
    "codigo":1269475009,
    "descripcion":"RUPTURA DE DISPOSITIVO INTRAUTERINO ANTICONCEPTIVO"
  },
  {
    "codigo":2381000124100,
    "descripcion":"INCISIVO LATERAL INFERIOR IZQUIERDO PERMANENTE SUPERNUMERARIO"
  },
  {
    "codigo":249997000,
    "descripcion":"CAE COMO UN TRONCO"
  },
  {
    "codigo":284600009,
    "descripcion":"ORINAR EN PÚBLICO"
  },
  {
    "codigo":445261000124106,
    "descripcion":"NUTRICIÓN ALTERADA"
  },
  {
    "codigo":86157004,
    "descripcion":"NEUMOPATÍA LABORAL"
  },
  {
    "codigo":413837004,
    "descripcion":"CONJUNTIVITIS FOLICULAR CRÓNICA CAUSADA POR FÁRMACO"
  },
  {
    "codigo":315533007,
    "descripcion":"NACIDO EN SWAZILANDIA"
  },
  {
    "codigo":706914000,
    "descripcion":"CAMBIOS CELULARES COMPATIBLES CON CYTOMEGALOVIRUS"
  },
  {
    "codigo":1263970003,
    "descripcion":"HEMATOMA CEREBRAL FETAL"
  },
  {
    "codigo":1231202004,
    "descripcion":"NEURITIS ÓPTICA DEBIDA A ENFERMEDAD DESMIELINIZANTE DEL SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":11769171000119109,
    "descripcion":"LACERACIÓN DE TENDÓN DEL ANTEBRAZO DERECHO"
  },
  {
    "codigo":248162009,
    "descripcion":"VESTIDO INAPROPIADAMENTE"
  },
  {
    "codigo":770615001,
    "descripcion":"QUEMADURA PROFUNDA DE ESPESOR PARCIAL DE PIEL DE DEDO DE LA MANO"
  },
  {
    "codigo":279095003,
    "descripcion":"DOLOR INTENSO"
  },
  {
    "codigo":705079008,
    "descripcion":"FRACTURA NO EXPUESTA DE PLACA EPIFISARIA DE FALANGE DE DEDO GRANDE DEL PIE"
  },
  {
    "codigo":277260001,
    "descripcion":"TUMEFACCIÓN SUBGLÓTICA"
  },
  {
    "codigo":703244000,
    "descripcion":"ESTENOSIS ADQUIRIDA DE ARTERIA PULMONAR IZQUIERDA"
  },
  {
    "codigo":1293068004,
    "descripcion":"ADAMANTINOMA SIMILAR A DISPLASIA OSTEOFIBROSA"
  },
  {
    "codigo":1671000119100,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS METASTÁSICO DE GANGLIO LINFÁTICO"
  },
  {
    "codigo":47884007,
    "descripcion":"INTOXICACIÓN POR DATURA STRAMONIUM"
  },
  {
    "codigo":111585004,
    "descripcion":"NEUTROPENIA ASOCIADA CON ENFERMEDAD AUTOINMUNITARIA"
  },
  {
    "codigo":46049004,
    "descripcion":"RETICULOCITOSIS"
  },
  {
    "codigo":275425008,
    "descripcion":"PRODUCTOS RETENIDOS DESPUÉS DE ABORTO ESPONTÁNEO"
  },
  {
    "codigo":766945009,
    "descripcion":"OBSTRUCCIÓN COMPLETA DE VENA PORTA HEPÁTICA"
  },
  {
    "codigo":371894001,
    "descripcion":"LESIÓN EN BIFURCACIÓN DE ARTERIA CORONARIA"
  },
  {
    "codigo":109750005,
    "descripcion":"ABFRACCIÓN"
  },
  {
    "codigo":240822009,
    "descripcion":"FIEBRE FILARIÁSICA BANCROFTIANA"
  },
  {
    "codigo":1254795002,
    "descripcion":"SÍNDROME DE ABSTINENCIA DE SUSTANCIAS"
  },
  {
    "codigo":304523003,
    "descripcion":"CONGESTIÓN VENOSA PULMONAR"
  },
  {
    "codigo":75147004,
    "descripcion":"RIGIDEZ EXTRAPIRAMIDAL"
  },
  {
    "codigo":402827005,
    "descripcion":"HIDRADENITIS ANOGENITAL SUPURATIVA"
  },
  {
    "codigo":1348360000,
    "descripcion":"ARTRITIS DE RODILLA DEBIDA A GOTA"
  },
  {
    "codigo":370059003,
    "descripcion":"INVASIÓN TUMORAL EN LA SUBMUCOSA"
  },
  {
    "codigo":765110009,
    "descripcion":"EXCITACIÓN SEXUAL POR EXPOSICIÓN DE GENITALES A PERSONA SIN CONSENTIMIENTO"
  },
  {
    "codigo":763275001,
    "descripcion":"TRISOMÍA DISTAL 6Q"
  },
  {
    "codigo":271755009,
    "descripcion":"DESCENSO GRADUAL DE LA FIEBRE"
  },
  {
    "codigo":1351264005,
    "descripcion":"FRÉMITO DENTAL"
  },
  {
    "codigo":204384007,
    "descripcion":"BLOQUEO AURICULOVENTRICULAR INCOMPLETO DE ORIGEN CONGÉNITO"
  },
  {
    "codigo":40544009,
    "descripcion":"TOLERANCIA AL ESTRÉS AUMENTADA"
  },
  {
    "codigo":366389005,
    "descripcion":"AMPLITUD DEL MOVIMIENTO ACTIVO DE FLEXIÓN LATERAL HACIA LA DERECHA DE LA COLUMNA CERVICAL - HALLAZGO"
  },
  {
    "codigo":300853008,
    "descripcion":"MASA DE ESTRUCTURA LINFORRETICULAR"
  },
  {
    "codigo":36874002,
    "descripcion":"POLICITEMIA POR ESTRÉS"
  },
  {
    "codigo":266250003,
    "descripcion":"RUPTURA DEL MÚSCULO PAPILAR MITRAL"
  },
  {
    "codigo":397322003,
    "descripcion":"MARGEN QUIRÚRGICO PROXIMAL DE VÍAS BILIARES COMPROMETIDO POR NEOPLASIA MALIGNA"
  },
  {
    "codigo":725002006,
    "descripcion":"LESIÓN TRAUMÁTICA DE VASO EXTRACRANEAL DE LA CABEZA"
  },
  {
    "codigo":299018007,
    "descripcion":"ARTICULACIÓN DE LA MUÑECA DOLOROSA AL MOVIMIENTO"
  },
  {
    "codigo":428255004,
    "descripcion":"NEFRITIS TUBULOINTERSTICIAL"
  },
  {
    "codigo":723167004,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE PARTE DE MAMA"
  },
  {
    "codigo":229812003,
    "descripcion":"CALLO SUBUNGUEAL"
  },
  {
    "codigo":721332003,
    "descripcion":"LESIÓN TRAUMÁTICA DIFUSA DE TRONCO ENCEFÁLICO"
  },
  {
    "codigo":262580007,
    "descripcion":"LESIÓN DE DEDO DE LA MANO POR AVULSIÓN ANULAR"
  },
  {
    "codigo":129673000,
    "descripcion":"ACTIVIDAD DE LA ENFERMEDAD LUEGO DEL TRATAMIENTO, NO EVALUADA"
  },
  {
    "codigo":295348008,
    "descripcion":"SOBREDOSIS INTENCIONAL DE MISOPROSTOL"
  },
  {
    "codigo":299784009,
    "descripcion":"REFLEJO DE OJOS DE MUÑECA HORIZONTAL AUSENTE"
  },
  {
    "codigo":1145481003,
    "descripcion":"HIPOPLASIA CONGÉNITA DE FALANGE MEDIA DE DEDO MEÑIQUE"
  },
  {
    "codigo":293513003,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR LOSARTÁN"
  },
  {
    "codigo":195209007,
    "descripcion":"SÍNDROME DE ARTERIA CEREBRAL MEDIA"
  },
  {
    "codigo":95070001,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA PIEL DE LA RODILLA"
  },
  {
    "codigo":422750002,
    "descripcion":"DIFICULTAD DEL CUIDADOR PARA PROVEER EXPERIENCIAS DE APRENDIZAJE COGNITIVO"
  },
  {
    "codigo":226142003,
    "descripcion":"DIETA RICA EN VITAMINA B1"
  },
  {
    "codigo":15703841000119109,
    "descripcion":"CONTRACTURA DE AMBOS MÚSCULOS GEMELOS DEBIDA A PARÁLISIS"
  },
  {
    "codigo":1209182005,
    "descripcion":"PRESENTACIÓN FETAL CEFÁLICA"
  },
  {
    "codigo":783198006,
    "descripcion":"NEUROPATÍA SENSITIVA Y AUTONÓMICA HEREDITARIA DEBIDA A REPETICIÓN DE LA HÉLICE BETA DE TECTONINA CON 2 MUTACIONES"
  },
  {
    "codigo":160606002,
    "descripcion":"FUMADOR EXCESIVO DE CIGARRILLOS (MÁS DE 40 CIGARRILLOS POR DÍA)"
  },
  {
    "codigo":715827001,
    "descripcion":"DISTONÍA AUTOSÓMICA RECESIVA SENSIBLE A DOPA"
  },
  {
    "codigo":1076111000119100,
    "descripcion":"ADHERENCIA DE TENDÓN DE MANO DERECHA"
  },
  {
    "codigo":104758671000119101,
    "descripcion":"TROMBOSIS VENOSA PROFUNDA CRÓNICA DURANTE EMBARAZO"
  },
  {
    "codigo":16021391000119101,
    "descripcion":"BURSITIS DE PIE IZQUIERDO"
  },
  {
    "codigo":10678671000119101,
    "descripcion":"TUMEFACCIÓN LOCALIZADA DE EXTREMIDAD INFERIOR DERECHA"
  },
  {
    "codigo":15980431000119104,
    "descripcion":"TRASTORNO DEL DISCO ARTICULAR DE LA ARTICULACIÓN TEMPOROMANDIBULAR IZQUIERDA"
  },
  {
    "codigo":34191000119104,
    "descripcion":"INFARTO CEREBRAL DEBIDO A OCLUSIÓN DE ARTERIA VERTEBRAL"
  },
  {
    "codigo":333711000119106,
    "descripcion":"MIOPATÍA DE MÚSCULO EXTRAOCULAR DE OJO DERECHO"
  },
  {
    "codigo":679311000119103,
    "descripcion":"HEMORRAGIA DE SUSTANCIA PROPIA DE CÓRNEA DE OJO DERECHO"
  },
  {
    "codigo":10676111000119102,
    "descripcion":"ASMA PERSISTENTE LEVE CONTROLADA CONCOMITANTE CON RINITIS ALÉRGICA"
  },
  {
    "codigo":1073551000119103,
    "descripcion":"ARTRITIS INFECCIOSA DE PIE DERECHO"
  },
  {
    "codigo":1088911000119108,
    "descripcion":"HEMOTÍMPANO DE LA CAVIDAD TIMPÁNICA IZQUIERDA"
  },
  {
    "codigo":315791000119107,
    "descripcion":"OSTEONECROSIS DEL CARPO CAUSADA POR FÁRMACO"
  },
  {
    "codigo":124168008,
    "descripcion":"DEFICIENCIA DE ALANINA DESHIDROGENASA"
  },
  {
    "codigo":290191000119109,
    "descripcion":"LESIÓN DE NERVIO RADIAL DERECHO"
  },
  {
    "codigo":16271000119108,
    "descripcion":"PIELONEFRITIS EN EL EMBARAZO"
  },
  {
    "codigo":12204431000119109,
    "descripcion":"INFECCIÓN ASOCIADA CON PRÓTESIS ARTICULAR DE CODO DERECHO"
  },
  {
    "codigo":24029004,
    "descripcion":"CONTINENCIA FECAL"
  },
  {
    "codigo":16023951000119109,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DEBIDO A OCLUSIÓN DE ARTERIA COROIDEA ANTERIOR IZQUIERDA"
  },
  {
    "codigo":16046991000119109,
    "descripcion":"ENFERMEDAD POR DEPÓSITO DE HIDROXIAPATITA DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":56797000,
    "descripcion":"HIPERTRICOSIS CONGÉNITA"
  },
  {
    "codigo":286173008,
    "descripcion":"CAPAZ DE HACER LA CAMA"
  },
  {
    "codigo":187869003,
    "descripcion":"NEOPLASIA MALIGNA DE BRONQUIO DEL LÓBULO INFERIOR"
  },
  {
    "codigo":331861000119101,
    "descripcion":"PARÁLISIS DE NERVIO OCULOMOTOR DERECHO"
  },
  {
    "codigo":710322003,
    "descripcion":"ESPECIE DE ABIOTROPHIA O ESPECIE DE GRANULICATELLA"
  },
  {
    "codigo":87730004,
    "descripcion":"SÍNDROME DE PÉRDIDA CAPILAR"
  },
  {
    "codigo":253405007,
    "descripcion":"TEJIDO ACCESORIO SOBRE VALVA MITRAL"
  },
  {
    "codigo":284338000,
    "descripcion":"NO COLOCA UN OBJETO SOBRE OTRO"
  },
  {
    "codigo":448178009,
    "descripcion":"INTERACCIÓN FARMACOLÓGICA ADVERSA CON FÁRMACO"
  },
  {
    "codigo":1300146009,
    "descripcion":"DISPLASIA CONGÉNITA DE ARTICULACIÓN DE PIE DERECHO"
  },
  {
    "codigo":282503002,
    "descripcion":"DIFICULTAD PARA SUBIR UNA COLINA CORRIENDO"
  },
  {
    "codigo":1003399005,
    "descripcion":"ANOMALÍA CONGÉNITA DE LA PRIMERA HENDIDURA BRANQUIAL"
  },
  {
    "codigo":247900000,
    "descripcion":"CONCIENCIA DE DISCAPACIDAD"
  },
  {
    "codigo":51292008,
    "descripcion":"SÍNDROME HEPATORRENAL"
  },
  {
    "codigo":278833002,
    "descripcion":"DISPLASIA CRANEOMETADIAFISIARIA"
  },
  {
    "codigo":770353003,
    "descripcion":"QUEMADURAS PROFUNDAS DE TERCER GRADO DE MÚLTIPLES SITIOS DEL TRONCO"
  },
  {
    "codigo":1260038000,
    "descripcion":"CARCINOMA ADENOESCAMOSO DE TRÁQUEA"
  },
  {
    "codigo":737585009,
    "descripcion":"ABULIA"
  },
  {
    "codigo":4181000119109,
    "descripcion":"PIELONEFRITIS DEBIDA A OBSTRUCCIÓN DE VÍA URINARIA"
  },
  {
    "codigo":16034031000119103,
    "descripcion":"HIPERTROFIA DE HUESO DE CÚBITO DERECHO"
  },
  {
    "codigo":735750005,
    "descripcion":"TRASTORNO PSICÓTICO CON SÍNTOMAS ESQUIZOFRENIFORMES CAUSADO POR COCAÍNA"
  },
  {
    "codigo":13019000,
    "descripcion":"LUXACIÓN EXPUESTA POSTERIOR DEL EXTREMO PROXIMAL DE LA TIBIA"
  },
  {
    "codigo":111323005,
    "descripcion":"RETORNO VENOSO PULMONAR TOTAL ANÓMALO"
  },
  {
    "codigo":209627008,
    "descripcion":"DESGARRO COMPLETO DE LIGAMENTO LATERAL INTERNO DE LA RODILLA"
  },
  {
    "codigo":1354672001,
    "descripcion":"FRACTURA EXPUESTA DE CALCÁNEO DERECHO"
  },
  {
    "codigo":371632003,
    "descripcion":"COMA"
  },
  {
    "codigo":240560006,
    "descripcion":"ERUPCIÓN SIFILÍTICA PAPULAR"
  },
  {
    "codigo":109488008,
    "descripcion":"HIPOMINERALIZACIÓN LOCALIZADA DEL ESMALTE DE ETIOLOGÍA DESCONOCIDA"
  },
  {
    "codigo":699312008,
    "descripcion":"RUPTURA DE TENDÓN DE TIBIAL POSTERIOR"
  },
  {
    "codigo":238725004,
    "descripcion":"ALOPECIA NO CICATRIZAL"
  },
  {
    "codigo":74885006,
    "descripcion":"ARTROSIS INTERFALÁNGICA"
  },
  {
    "codigo":402565007,
    "descripcion":"INFECCIÓN CUTÁNEA POR VIRUS DEL HERPES HUMANO 7"
  },
  {
    "codigo":890415000,
    "descripcion":"QUISTE VÍTREO CONGÉNITO"
  },
  {
    "codigo":366127001,
    "descripcion":"ASPECTO DEL MOVIMIENTO TORÁCICO - HALLAZGO"
  },
  {
    "codigo":202287001,
    "descripcion":"CONTRACTURA EN ROTACIÓN INTERNA DE LA CADERA"
  },
  {
    "codigo":235055003,
    "descripcion":"INFECCIÓN ORAL POR HERPES SIMPLE"
  },
  {
    "codigo":71215005,
    "descripcion":"HIDROHEPATOSIS"
  },
  {
    "codigo":167684000,
    "descripcion":"GALACTOSA DETECTADA EN ESPÉCIMEN DE MATERIA FECAL ANALIZADO MEDIANTE CROMATOGRAFÍA"
  },
  {
    "codigo":724740006,
    "descripcion":"TRASTORNO DE CONDUCTA ANTISOCIAL DE COMIENZO EN LA ADOLESCENCIA"
  },
  {
    "codigo":298756009,
    "descripcion":"HALLAZGO RELACIONADO CON HUESO DE LA EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":722905003,
    "descripcion":"LACERACIÓN INTRACRANEAL DEBIDA A TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":198617006,
    "descripcion":"PARTO DE FETO VIABLE EN EMBARAZO ABDOMINAL"
  },
  {
    "codigo":296921006,
    "descripcion":"SOBREDOSIS DE AGENTE REGULADOR DEL CALCIO"
  },
  {
    "codigo":1343662004,
    "descripcion":"RETINITIS DISEMINADA BILATERAL"
  },
  {
    "codigo":32942005,
    "descripcion":"TROMBASTENIA DE GLANZMANN"
  },
  {
    "codigo":65710008,
    "descripcion":"FALLA RESPIRATORIA AGUDA"
  },
  {
    "codigo":194947001,
    "descripcion":"MIOCARDITIS AGUDA SIFILÍTICA"
  },
  {
    "codigo":293251002,
    "descripcion":"REACCIÓN ADVERSA AL DIENESTROL"
  },
  {
    "codigo":94808000,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE CONDUCTO CRANEOFARÍNGEO"
  },
  {
    "codigo":29272001,
    "descripcion":"ENFERMEDAD GRANULOMATOSA CRÓNICA, TIPO I"
  },
  {
    "codigo":1145219008,
    "descripcion":"NEURITIS BRAQUIAL DEBIDA A RUPTURA DE DISCO INTERVERTEBRAL CERVICAL"
  },
  {
    "codigo":420653000,
    "descripcion":"BAJO ANESTESIA GENERAL"
  },
  {
    "codigo":289581001,
    "descripcion":"LOQUIOS ESCASOS"
  },
  {
    "codigo":715565004,
    "descripcion":"ARTROGRIPOSIS LETAL CONCOMITANTE CON ENFERMEDAD DE LAS CÉLULAS DEL ASTA ANTERIOR"
  },
  {
    "codigo":1010477006,
    "descripcion":"AGENESIA DE FALANGE MEDIA DE DEDO ÍNDICE"
  },
  {
    "codigo":11803171000119108,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN METACARPOFALÁNGICA DE DEDO DE MANO DERECHA"
  },
  {
    "codigo":92973006,
    "descripcion":"AUSENCIA CONGÉNITA DE TROMPA DE FALOPIO"
  },
  {
    "codigo":713730000,
    "descripcion":"INFECCIÓN CAUSADA POR VIRUS HERPES SIMPLE CONCOMITANTE CON INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":123906002,
    "descripcion":"INTOXICACIÓN POR ZAMIACEAE"
  },
  {
    "codigo":418818005,
    "descripcion":"SÍNDROME DE BRUGADA"
  },
  {
    "codigo":254978007,
    "descripcion":"MENINGIOMA DE LA VAINA DEL NERVIO ÓPTICO"
  },
  {
    "codigo":253143001,
    "descripcion":"AUSENCIA DE SEPTUM PELLUCIDUM"
  },
  {
    "codigo":285911005,
    "descripcion":"CAPAZ DE UTILIZAR INSTALACIONES PARA LA HIGIENE"
  },
  {
    "codigo":449751008,
    "descripcion":"BORDE DE HERIDA ARROLLADO"
  },
  {
    "codigo":447916001,
    "descripcion":"VENA CAVA INFERIOR EN AURÍCULA DERECHA"
  },
  {
    "codigo":284076001,
    "descripcion":"TRAYECTO FISTULOSO PERINEAL"
  },
  {
    "codigo":415148007,
    "descripcion":"HERNIA PERINEAL POSTERIOR"
  },
  {
    "codigo":216705002,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR METILPARATIÓN"
  },
  {
    "codigo":11995991000119101,
    "descripcion":"HEMATOMA DE MUÑÓN DE AMPUTACIÓN DE EXTREMIDAD INFERIOR DERECHA"
  },
  {
    "codigo":249473004,
    "descripcion":"APETITO ALTERADO"
  },
  {
    "codigo":282241005,
    "descripcion":"INCAPAZ DE CAMINAR HACIA ATRÁS ARRASTRANDO UN JUGUETE GRANDE"
  },
  {
    "codigo":11832151000119102,
    "descripcion":"LESIÓN TRAUMÁTICA DE VASO SANGUÍNEO DE DEDO DE MANO IZQUIERDA"
  },
  {
    "codigo":446081009,
    "descripcion":"SÍNDROME DE SOBRECRECIMIENTO BACTERIANO DE INTESTINO DELGADO"
  },
  {
    "codigo":247638003,
    "descripcion":"PREOCUPACIÓN POR UNA CARACTERÍSTICA CORPORAL ESPECÍFICA"
  },
  {
    "codigo":117591000119103,
    "descripcion":"FRECUENCIA URINARIA DURANTE EMBARAZO"
  },
  {
    "codigo":51030006,
    "descripcion":"CELULITIS DE LABIO"
  },
  {
    "codigo":737323003,
    "descripcion":"HEMORRAGIA EXCESIVA DEBIDA A EMBARAZO ECTÓPICO Y POSTERIOR A ÉL"
  },
  {
    "codigo":16427007,
    "descripcion":"TALASEMIA DELTA"
  },
  {
    "codigo":1228843008,
    "descripcion":"PENFIGOIDE ANTI-P200"
  },
  {
    "codigo":1259776007,
    "descripcion":"CÁNCER PULMONAR DE CÉLULAS NO MICROCÍTICAS PRIMARIO POSITIVO PARA EXPRESIÓN DEL RECEPTOR DE FACTOR DE CRECIMIENTO EPIDÉRMICO"
  },
  {
    "codigo":735488008,
    "descripcion":"INFECCIÓN PÉLVICA DEBIDA A EMBARAZO ECTÓPICO Y POSTERIOR A ÉL"
  },
  {
    "codigo":405973001,
    "descripcion":"ESTADIO III DEL GRUPO NACIONAL PARA EL ESTUDIO DEL TUMOR DE WILMS"
  },
  {
    "codigo":16665431000119107,
    "descripcion":"FRACTURA EXPUESTA DE PARED INTERNA DE ÓRBITA IZQUIERDA"
  },
  {
    "codigo":211200009,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE BRAZO"
  },
  {
    "codigo":274901004,
    "descripcion":"PILOMATRICOMA"
  },
  {
    "codigo":209365007,
    "descripcion":"FRACTURA-LUXACIÓN EXPUESTA DE ARTICULACIÓN TARSOMETATARSIANA"
  },
  {
    "codigo":305834001,
    "descripcion":"VISTO POR EL SERVICIO DE PATOLOGÍA GENERAL"
  },
  {
    "codigo":830122003,
    "descripcion":"MÚSCULO CUADRADO CRURAL NORMAL"
  },
  {
    "codigo":240298005,
    "descripcion":"TAQUICARDIA FETAL"
  },
  {
    "codigo":699050007,
    "descripcion":"CÁLCULO DE VESÍCULA BILIAR CON COLECISTITIS AGUDA Y CRÓNICA"
  },
  {
    "codigo":1354410008,
    "descripcion":"DISTENSIÓN DE TENDÓN Y\/O MÚSCULO SUBESCAPULAR"
  },
  {
    "codigo":402303001,
    "descripcion":"ECCEMA GENERALIZADO"
  },
  {
    "codigo":404138009,
    "descripcion":"LINFOMA PEQUEÑO LINFOCÍTICO DE CÉLULAS B QUE COMPROMETE PIEL"
  },
  {
    "codigo":238463006,
    "descripcion":"NÓDULO DE RODILLA"
  },
  {
    "codigo":369535006,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL LIGAMENTO ANCHO IZQUIERDO"
  },
  {
    "codigo":236628001,
    "descripcion":"CISTITIS AGUDA POR RADIACIÓN"
  },
  {
    "codigo":1074161000119107,
    "descripcion":"CONDROCALCINOSIS DE RODILLA DERECHA"
  },
  {
    "codigo":365865003,
    "descripcion":"HALLAZGO RELACIONADO CON EL ESTADO PARA HEPATITIS C"
  },
  {
    "codigo":70953003,
    "descripcion":"PRODUCCIÓN DISMINUIDA TRANSITORIA DE HORMONA TIROIDEA"
  },
  {
    "codigo":1119529004,
    "descripcion":"VISIÓN BORROSA TRANSITORIA DE UN OJO"
  },
  {
    "codigo":5417005,
    "descripcion":"INTOXICACIÓN POR COLCHICUM AUTUMNALE"
  },
  {
    "codigo":300329009,
    "descripcion":"HÍGADO IRREGULAR"
  },
  {
    "codigo":36350006,
    "descripcion":"CONSISTENCIA ANORMALMENTE BLANDA"
  },
  {
    "codigo":298494008,
    "descripcion":"ESCOLIOSIS DORSAL"
  },
  {
    "codigo":724478009,
    "descripcion":"RUPTURA TRAUMÁTICA DE MÚSCULO DEL PISO PÉLVICO"
  },
  {
    "codigo":34515002,
    "descripcion":"VÍCTIMA DE CONTIENDA INTERNACIONAL"
  },
  {
    "codigo":722643003,
    "descripcion":"LACERACIÓN MAYOR DE ARTERIA VERTEBRAL"
  },
  {
    "codigo":1279699002,
    "descripcion":"INFECCIÓN CAUSADA POR BORRELIA CAUCASICA"
  },
  {
    "codigo":820947007,
    "descripcion":"HEMORRAGIA DE LA TERCERA FASE DEBIDA A RETENCIÓN DE PLACENTA"
  },
  {
    "codigo":425896005,
    "descripcion":"LIMITACIÓN SEVERA DE LA PROTRUSIÓN DE LA MANDÍBULA"
  },
  {
    "codigo":130984007,
    "descripcion":"TRASTORNO EN LA SENSIBILIDAD TÁCTIL"
  },
  {
    "codigo":32680009,
    "descripcion":"SÍNDROME DE NOTHNAGEL"
  },
  {
    "codigo":127314000,
    "descripcion":"HERIDA ABIERTA DE LA PARED TORÁCICA"
  },
  {
    "codigo":161917009,
    "descripcion":"RECURRENCIA DEL PROBLEMA"
  },
  {
    "codigo":1144957009,
    "descripcion":"VASCULITIS DEBIDA A TRASTORNO LINFOPROLIFERATIVO"
  },
  {
    "codigo":94546000,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA PIEL DE LA MEJILLA"
  },
  {
    "codigo":61778004,
    "descripcion":"CALCINOSIS TUMORAL"
  },
  {
    "codigo":291154006,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR DROPERIDOL"
  },
  {
    "codigo":782674007,
    "descripcion":"SÍNDROME DE MONOSOMÍA DISTAL 7P"
  },
  {
    "codigo":289319007,
    "descripcion":"MUÑÓN UMBILICAL LIMPIO"
  },
  {
    "codigo":1010215007,
    "descripcion":"SUBLUXACIÓN CONGÉNITA DE CADERA IZQUIERDA"
  },
  {
    "codigo":1336060003,
    "descripcion":"EPISODIO DE USO NOCIVO DE DIAMORFINA INTRAVENOSA"
  },
  {
    "codigo":254716005,
    "descripcion":"HIDROCISTOMA ECRINO"
  },
  {
    "codigo":189180007,
    "descripcion":"NEOPLASIA BENIGNA DE SILLA TURCA"
  },
  {
    "codigo":123644009,
    "descripcion":"SÍNDROME DE GINANDROMORFISMO"
  },
  {
    "codigo":1268689003,
    "descripcion":"CAPAZ DE PAGAR SERVICIOS PÚBLICOS EN VIVIENDA"
  },
  {
    "codigo":15986111000119101,
    "descripcion":"COLOBOMA CONGÉNITO DE AMBAS PAPILAS ÓPTICAS"
  },
  {
    "codigo":56273005,
    "descripcion":"FUNCIÓN MUSCULAR ANORMAL"
  },
  {
    "codigo":416721005,
    "descripcion":"DISMINUCIÓN DEL PARPADEO"
  },
  {
    "codigo":251046001,
    "descripcion":"ESTENOSIS MÚLTIPLES DE ARTERIA PULMONAR PERIFÉRICA"
  },
  {
    "codigo":447654003,
    "descripcion":"TERATOMA BENIGNO DE RETROPERITONEO"
  },
  {
    "codigo":283814004,
    "descripcion":"MORDEDURA DE ANIMAL EN EL TRONCO"
  },
  {
    "codigo":339391000119103,
    "descripcion":"EXOTROPÍA MONOCULAR DE OJO IZQUIERDO CON ESTRABISMO CON PATRÓN EN V"
  },
  {
    "codigo":52603002,
    "descripcion":"FRACTURA NO EXPUESTA DE MIEMBRO INFERIOR"
  },
  {
    "codigo":773499003,
    "descripcion":"ALERGIA A ÁCIDO ETIDRÓNICO"
  },
  {
    "codigo":249211006,
    "descripcion":"HALLAZGO RELACIONADO CON LOS LOQUIOS"
  },
  {
    "codigo":312912001,
    "descripcion":"EDEMA DE MÁCULA DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":116304002,
    "descripcion":"HALLAZGO EN LA COLUMNA SACRA"
  },
  {
    "codigo":280144002,
    "descripcion":"VENA DESCENDENTE PERSISTENTE"
  },
  {
    "codigo":83536006,
    "descripcion":"ESTENOSIS DEL CUELLO UTERINO"
  },
  {
    "codigo":704293000,
    "descripcion":"FRACTURA POR OSTEOPOROSIS SECUNDARIA DE TOBILLO"
  },
  {
    "codigo":15713881000119101,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE AMBAS REGIONES DE LA CADERA"
  },
  {
    "codigo":1259514003,
    "descripcion":"CARCINOMA PRIMARIO DE ENDOCÉRVIX"
  },
  {
    "codigo":473082004,
    "descripcion":"INFECCIÓN E INFLAMACIÓN ASOCIADAS CON DISPOSITIVO ANTICONCEPTIVO INTRAUTERINO RETENIDO"
  },
  {
    "codigo":79866005,
    "descripcion":"ESQUIZOFRENIA PARANOIDE SUBCRÓNICA"
  },
  {
    "codigo":407546007,
    "descripcion":"OBSERVACIÓN DEL ASPECTO DEL ESTOMA"
  },
  {
    "codigo":78031003,
    "descripcion":"INSUFICIENCIA VALVULAR AÓRTICA REUMÁTICA"
  },
  {
    "codigo":438479005,
    "descripcion":"LESIÓN TRAUMÁTICA DE LIGAMENTO DE LA RODILLA"
  },
  {
    "codigo":733391006,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA PARCIAL DE TESTÍCULOS"
  },
  {
    "codigo":241871005,
    "descripcion":"EFECTO TÓXICO CAUSADO POR PINTURA LÍQUIDA"
  },
  {
    "codigo":307407008,
    "descripcion":"MANO ISQUÉMICA"
  },
  {
    "codigo":45263007,
    "descripcion":"ESPOROTRICOSIS PULMONAR"
  },
  {
    "codigo":372943006,
    "descripcion":"INFECCIÓN CAUSADA POR PENICILLIUM BERTAI"
  },
  {
    "codigo":240036003,
    "descripcion":"TENOSINOVITIS DE LOS DEDOS DE LA MANO"
  },
  {
    "codigo":897231009,
    "descripcion":"CURVATURA ANORMAL DE FALANGE DISTAL DE QUINTO DEDO DE PIE"
  },
  {
    "codigo":305572000,
    "descripcion":"BAJO ATENCIÓN DE ENFERMERA ESPECIALIZADA EN REUMATOLOGÍA"
  },
  {
    "codigo":403876006,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS INTRAEPIDÉRMICO DE OÍDO"
  },
  {
    "codigo":762489000,
    "descripcion":"COMPLICACIÓN AGUDA DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":371108009,
    "descripcion":"NO INMUNE A LA VARICELA"
  },
  {
    "codigo":209333009,
    "descripcion":"FRACTURA-SUBLUXACIÓN EXPUESTA DE MÚLTIPLES DEDOS"
  },
  {
    "codigo":301902000,
    "descripcion":"LEVANTA LA CABEZA"
  },
  {
    "codigo":74361008,
    "descripcion":"GASTRITIS TÓXICA"
  },
  {
    "codigo":400206003,
    "descripcion":"HAMARTOMA TEGUMENTARIO"
  },
  {
    "codigo":269134004,
    "descripcion":"ESGUINCE DE CODO Y ANTEBRAZO"
  },
  {
    "codigo":203598005,
    "descripcion":"DEFORMIDAD EN FLEXIÓN"
  },
  {
    "codigo":6990005,
    "descripcion":"FRACTURA DE DIÁFISIS DE TIBIA"
  },
  {
    "codigo":70691001,
    "descripcion":"AGORAFOBIA"
  },
  {
    "codigo":726051002,
    "descripcion":"MIOTONÍA CONGÉNITA"
  },
  {
    "codigo":365603005,
    "descripcion":"NIVELES HEMATÍNICOS EN SANGRE-HALLAZGO"
  },
  {
    "codigo":234531008,
    "descripcion":"SARCOIDE OROFACIAL"
  },
  {
    "codigo":298232006,
    "descripcion":"RIGIDEZ ARTICULAR DE LA COLUMNA VERTEBRAL"
  },
  {
    "codigo":787917002,
    "descripcion":"LEVADURA NO ESPECIE DE CANDIDA Y NO CRYPTOCOCCUS NEOFORMANS DETECTADA"
  },
  {
    "codigo":427469003,
    "descripcion":"TRASTORNO ALIMENTARIO EN REMISIÓN"
  },
  {
    "codigo":722381004,
    "descripcion":"SÍNDROME DE CATARATA CONGÉNITA, NEFROPATÍA Y ENCEFALOPATÍA"
  },
  {
    "codigo":34253008,
    "descripcion":"MIOPATÍA EN LA ENFERMEDAD DE ADDISON"
  },
  {
    "codigo":165325009,
    "descripcion":"RESULTADO DE BIOPSIA, ANORMAL"
  },
  {
    "codigo":1179298002,
    "descripcion":"CONDUCTO ARTERIOSO PERSISTENTE FAMILIAR"
  },
  {
    "codigo":1079181000119102,
    "descripcion":"CARCINOMA BASOCELULAR PRIMARIO DE PIEL DE CADERA DERECHA"
  },
  {
    "codigo":229026006,
    "descripcion":"COMPARTIR JUGUETES SEXUALES"
  },
  {
    "codigo":292727000,
    "descripcion":"REACCIÓN ADVERSA AL TIOSULFATO DE SODIO"
  },
  {
    "codigo":294562009,
    "descripcion":"ALERGIA A LINCOMICINA"
  },
  {
    "codigo":1144695001,
    "descripcion":"APLASIA DE FALANGE DISTAL DE TERCER DEDO DE PIE"
  },
  {
    "codigo":817015003,
    "descripcion":"ANTEPIE DERECHO AMPUTADO"
  },
  {
    "codigo":391031004,
    "descripcion":"DENSITOMETRÍA ÓSEA PENDIENTE"
  },
  {
    "codigo":127052005,
    "descripcion":"ANEMIA HEMOLÍTICA CALIENTE AUTOINMUNITARIA SECUNDARIA"
  },
  {
    "codigo":1306700005,
    "descripcion":"RETINOPATÍA PROLIFERATIVA BILATERAL DEBIDA A DIABETES MELLITUS EN TRATAMIENTO, ESTABLE"
  },
  {
    "codigo":94284007,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA EPIGLOTIS"
  },
  {
    "codigo":289057001,
    "descripcion":"NO UTILIZA TENEDOR PARA ALIMENTARSE"
  },
  {
    "codigo":328814631000119101,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE TENDÓN DE AQUILES IZQUIERDO"
  },
  {
    "codigo":715041009,
    "descripcion":"NO LLORA"
  },
  {
    "codigo":1335798002,
    "descripcion":"ARTRITIS IDIOPÁTICA JUVENIL DE REGIÓN DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":385526002,
    "descripcion":"QUEMADURA DE LA PIEL POR VAPOR"
  },
  {
    "codigo":92449009,
    "descripcion":"NEOPLASIA BENIGNA DEL TRAPECIO"
  },
  {
    "codigo":1237494001,
    "descripcion":"METÁSTASIS DE CARCINOMA DE CONDUCTO EXTRAHEPÁTICO"
  },
  {
    "codigo":254454009,
    "descripcion":"CARCINOMA DEL SURCO LABIAL INFERIOR"
  },
  {
    "codigo":1137355002,
    "descripcion":"NÓDULO TIROIDEO HIPERPLÁSICO"
  },
  {
    "codigo":15634471000119104,
    "descripcion":"DOLOR DE AMBAS PANTORRILAS"
  },
  {
    "codigo":285387005,
    "descripcion":"DOLOR ABDOMINAL EN EL LADO IZQUIERDO"
  },
  {
    "codigo":840608004,
    "descripcion":"OCLUSIÓN DE RAMA DESCENDENTE ANTERIOR DE ARTERIA CORONARIA IZQUIERDA"
  },
  {
    "codigo":15689921000119100,
    "descripcion":"ARTRITIS DE AMBAS RODILLAS CAUSADA POR STAPHYLOCOCCUS"
  },
  {
    "codigo":283552007,
    "descripcion":"HERIDA DE PERDIGÓN EN REGIÓN AURICULAR"
  },
  {
    "codigo":314485000,
    "descripcion":"TRASTORNO DEL DRENAJE LAGRIMAL"
  },
  {
    "codigo":54176009,
    "descripcion":"QUISTE CONGÉNITO DEL CANAL DE NUCK"
  },
  {
    "codigo":185248009,
    "descripcion":"ATENDIDO EN UN CONSULTORIO ESPECIALIZADO EN DOLOR"
  },
  {
    "codigo":281717005,
    "descripcion":"DEGENERACIÓN ARTERIOVASCULAR"
  },
  {
    "codigo":871541008,
    "descripcion":"MIELOFIBROSIS DEBIDA A TROMBOCITEMIA ESENCIAL Y POSTERIOR A ELLA"
  },
  {
    "codigo":247114001,
    "descripcion":"DISTENSIÓN DE VENA DETRÁS DE CRUCE ARTERIOVENOSO"
  },
  {
    "codigo":1162783002,
    "descripcion":"AUSENCIA DE DIENTES"
  },
  {
    "codigo":441887006,
    "descripcion":"MONOPLEJÍA DE MIEMBRO INFERIOR COMO EFECTO TARDÍO DE ENFERMEDAD CEREBROVASCULAR"
  },
  {
    "codigo":472820000,
    "descripcion":"CONEXIÓN VENTRICULOARTERIAL ANORMAL CON ORIGEN HABITUAL DE CORONARIA IZQ. EN SENO AÓRTICO HACIA LA DER. DE SENO AÓRTICO NO ENFRENTADO Y ORIGEN HABITUAL DE CORONARIA DERECHA EN SENO AÓRTICO HACIA LA IZQ. DE SENO AÓRTICO NO ENFRENTADO"
  },
  {
    "codigo":1259252003,
    "descripcion":"FACTOR DE RETENCIÓN DE PLACA DENTAL EN DIENTE"
  },
  {
    "codigo":734964005,
    "descripcion":"ÉMBOLO DE ARTERIA CEREBRAL MEDIA IZQUIERDA"
  },
  {
    "codigo":79604008,
    "descripcion":"TRASTORNO DE LA MAMA"
  },
  {
    "codigo":700361001,
    "descripcion":"INGESTA DE NUTRIENTES INADECUADA PREVISTA"
  },
  {
    "codigo":733129005,
    "descripcion":"VENAS VARICOSAS DE MIEMBRO INFERIOR CON REFLUJO NO TRONCAL"
  },
  {
    "codigo":403614002,
    "descripcion":"PÚRPURA POR ANOMALÍA DE LA COAGULACIÓN DE ORIGEN MEDICAMENTOSO"
  },
  {
    "codigo":75934005,
    "descripcion":"ENFERMEDAD METABÓLICA"
  },
  {
    "codigo":43166006,
    "descripcion":"INTOXICACIÓN POR PROSOPIS GLANDULOSA"
  },
  {
    "codigo":698526007,
    "descripcion":"APENDICOVESICOSTOMÍA PRESENTE"
  },
  {
    "codigo":272542007,
    "descripcion":"SENTADO SOBRE SUS RODILLAS"
  },
  {
    "codigo":8563000,
    "descripcion":"CRISIS COLINÉRGICA"
  },
  {
    "codigo":205171002,
    "descripcion":"AUSENCIA PARCIAL DEL RADIO"
  },
  {
    "codigo":303475003,
    "descripcion":"DIFICULTAD PARA RETIRAR PRÓTESIS"
  },
  {
    "codigo":344411000119103,
    "descripcion":"CORIORRETINITIS DE POLO POSTERIOR DISEMINADA DE AMBOS OJOS"
  },
  {
    "codigo":237939006,
    "descripcion":"HIPERGLICINEMIA NO CETÓSICA"
  },
  {
    "codigo":301640000,
    "descripcion":"NO SE SUBE NI SE BAJA DE LOS MUEBLES"
  },
  {
    "codigo":236104004,
    "descripcion":"ESTENOSIS DE ANASTOMOSIS GASTROINTESTINAL"
  },
  {
    "codigo":170568005,
    "descripcion":"ENFERMEDAD CRÓNICA - RESISTENCIA A LOS FÁRMACOS"
  },
  {
    "codigo":203336007,
    "descripcion":"ENFERMEDAD DE PAGET DEL CÚBITO"
  },
  {
    "codigo":398109000,
    "descripcion":"ESTADO DE NOTIFICACIÓN QUIRÚRGICA"
  },
  {
    "codigo":1153608008,
    "descripcion":"OCLUSIÓN DE ARTERIA COMUNICANTE POSTERIOR IZQUIERDA"
  },
  {
    "codigo":430877000,
    "descripcion":"DIVERTICULITIS DE RECTO"
  },
  {
    "codigo":299805003,
    "descripcion":"REFLEJO MASETÉRICO BRUSCO"
  },
  {
    "codigo":297970000,
    "descripcion":"SECRECIÓN CUTÁNEA"
  },
  {
    "codigo":365341008,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA REALIZAR ACTIVIDADES DE LA VIDA COMUNITARIA"
  },
  {
    "codigo":232434002,
    "descripcion":"LARINGITIS MICÓTICA CRÓNICA"
  },
  {
    "codigo":283059006,
    "descripcion":"ABRASIÓN DE PIEL DE MANO"
  },
  {
    "codigo":363506007,
    "descripcion":"NEOPLASIA MALIGNA DE SENOS PARANASALES"
  },
  {
    "codigo":230599000,
    "descripcion":"NEUROPATÍA ISQUÉMICA"
  },
  {
    "codigo":427207001,
    "descripcion":"SÍNDROME ABDOMINAL COMPARTIMENTAL"
  },
  {
    "codigo":722119002,
    "descripcion":"GLOMERULONEFRITIS MEMBRANOSA IDIOPÁTICA"
  },
  {
    "codigo":425372005,
    "descripcion":"OBJETIVOS PERSONALES INCONGRUENTES"
  },
  {
    "codigo":1144433002,
    "descripcion":"ATROFIA DE CORTEZA DE LÓBULO OCCIPITAL"
  },
  {
    "codigo":718449003,
    "descripcion":"INTUBACIÓN TRAQUEAL DIFÍCIL ESPERADA"
  },
  {
    "codigo":292465008,
    "descripcion":"REACCIÓN ADVERSA A FÁRMACO PARASIMPATICOMIMÉTICO"
  },
  {
    "codigo":94022001,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA PIEL DE LA CARA"
  },
  {
    "codigo":126790004,
    "descripcion":"NEOPLASIA DE LA GLÁNDULA SUBLINGUAL"
  },
  {
    "codigo":72181000119109,
    "descripcion":"ENDOCARDITIS DEBIDA A LUPUS ERITEMATOSO SISTÉMICO"
  },
  {
    "codigo":288795007,
    "descripcion":"INCAPAZ DE HACER PREGUNTAS"
  },
  {
    "codigo":24816000,
    "descripcion":"ESPUTO HERRUMBROSO"
  },
  {
    "codigo":254192002,
    "descripcion":"EPIDERMÓLISIS BULLOSA INVERSA DE LA ZONA DE UNIÓN"
  },
  {
    "codigo":1204464003,
    "descripcion":"HEMORRAGIA GASTROINTESTINAL CON SEPSIS"
  },
  {
    "codigo":90352007,
    "descripcion":"ABUSOS DESHONESTOS"
  },
  {
    "codigo":283290000,
    "descripcion":"ASTILLA DE MADERA EN EL DORSO DE LA MANO"
  },
  {
    "codigo":448965008,
    "descripcion":"VENA CAVA INFERIOR CONECTADA A AURÍCULAS DERECHA E IZQUIERDA"
  },
  {
    "codigo":250522007,
    "descripcion":"PRUEBA DEL ANILLO PARA BRUCELLA: APROBADA"
  },
  {
    "codigo":52079000,
    "descripcion":"INFECCIÓN CONGÉNITA POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":281455001,
    "descripcion":"PROMINENCIA DEL ALAMBRE"
  },
  {
    "codigo":1264495000,
    "descripcion":"CARCINOMA DE MAMA METASTÁSICO"
  },
  {
    "codigo":248687003,
    "descripcion":"SOPLO MITRAL PRESISTÓLICO"
  },
  {
    "codigo":19311003,
    "descripcion":"COLITIS COLAGENOSA"
  },
  {
    "codigo":1231727005,
    "descripcion":"NEUROPATÍA ÓPTICA POSVACUNACIÓN"
  },
  {
    "codigo":346921000119105,
    "descripcion":"CORIORRETINITIS BILATERAL"
  },
  {
    "codigo":410692006,
    "descripcion":"UVEÍTIS ANTERIOR"
  },
  {
    "codigo":443460007,
    "descripcion":"MULTIGRÁVIDA DE EDAD AVANZADA"
  },
  {
    "codigo":1295428008,
    "descripcion":"PRESENCIA DE NEOPLASIA RESIDUAL NO INTENCIONAL POSTOPERATORIA POSTERIOR A RESECCIÓN DE NEOPLASIA"
  },
  {
    "codigo":246852009,
    "descripcion":"ACUMULACIÓN DE LÁGRIMAS"
  },
  {
    "codigo":1162521000,
    "descripcion":"FRACTURA DE DIENTES"
  },
  {
    "codigo":212249004,
    "descripcion":"LESIÓN DE NERVIO ILIOHIPOGÁSTRICO"
  },
  {
    "codigo":277785006,
    "descripcion":"URTICARIA ANGIOEDEMATOSA INDUCIDA POR PENICILINA"
  },
  {
    "codigo":408857007,
    "descripcion":"AUTISMO INFANTIL"
  },
  {
    "codigo":48409008,
    "descripcion":"RALES CREPITANTES"
  },
  {
    "codigo":13806003,
    "descripcion":"ANOMALÍA CONGÉNITA DE LA URETRA"
  },
  {
    "codigo":767470005,
    "descripcion":"ALERGIA A FENOGRECO"
  },
  {
    "codigo":79342006,
    "descripcion":"ECTROPIÓN DEL CUELLO UTERINO"
  },
  {
    "codigo":112110007,
    "descripcion":"ESCALA DEL COMA DE GLASGOW, 4"
  },
  {
    "codigo":1258990008,
    "descripcion":"ESPONDILOLISTESIS ESPONDILOLÍTICA"
  },
  {
    "codigo":77507001,
    "descripcion":"PÉRDIDA DE LA AUDICIÓN CONDUCTIVA Y NEUROSENSORIAL COMBINADAS"
  },
  {
    "codigo":208579006,
    "descripcion":"FRACTURA NO EXPUESTA DE FÉMUR DISTAL, CÓNDILO INTERNO"
  },
  {
    "codigo":896707007,
    "descripcion":"FORMA DELGADA ANORMAL CONGÉNITA DE METACARPIANO"
  },
  {
    "codigo":1157016001,
    "descripcion":"DOLOR A LA DESCOMPRESIÓN DEL CUADRANTE INFERIOR DERECHO DEL ABDOMEN"
  },
  {
    "codigo":403352008,
    "descripcion":"ACNÉ POR ALQUITRÁN"
  },
  {
    "codigo":73837001,
    "descripcion":"INTENTO FALLIDO DE ABORTO CON INSUFICIENCIA Y\/O PARO CARDÍACO"
  },
  {
    "codigo":237677002,
    "descripcion":"HIPERPLASIA GONADOTRÓFICA"
  },
  {
    "codigo":270445003,
    "descripcion":"CONTROL DE DIABETES REALIZADO"
  },
  {
    "codigo":8301004,
    "descripcion":"SÍNDROME DE REGRESIÓN CAUDAL"
  },
  {
    "codigo":235842000,
    "descripcion":"ISQUEMIA MESENTÉRICA OCLUSIVA"
  },
  {
    "codigo":39234001,
    "descripcion":"EFECTO TÓXICO DEL CIANURO DE SODIO"
  },
  {
    "codigo":41069008,
    "descripcion":"SÍNDROME DE LANGER - GIEDION"
  },
  {
    "codigo":1251650003,
    "descripcion":"PAREJA VIOLENTA"
  },
  {
    "codigo":203074005,
    "descripcion":"CONTRACTURA DE (LOS) MÚSCULO(S) FEMORAL(ES) DE LA CORVA"
  },
  {
    "codigo":170306005,
    "descripcion":"EXAMEN DEL NIÑO A LAS 8 SEMANAS: ANORMAL - PARA OBSERVACIÓN"
  },
  {
    "codigo":1153346006,
    "descripcion":"LINFOMA NO HODGKIN MALIGNO PRIMARIO DE TRACTO UVEAL"
  },
  {
    "codigo":168471000,
    "descripcion":"EXTENDIDO DE CÚPULA VAGINAL: ATRÓFICO"
  },
  {
    "codigo":102935005,
    "descripcion":"HABLA EXPLOSIVA"
  },
  {
    "codigo":397847006,
    "descripcion":"DUELO FAMILIAR"
  },
  {
    "codigo":1217047007,
    "descripcion":"ATROFIA DE GLÁNDULAS ENDOCRINAS MÚLTIPLES"
  },
  {
    "codigo":789228000,
    "descripcion":"ANOMALÍA CONGÉNITA DE PORCIÓN ANTERIOR DEL CUELLO"
  },
  {
    "codigo":234007007,
    "descripcion":"RUPTURA DE ARTERIA ESPINAL ANTERIOR"
  },
  {
    "codigo":299543009,
    "descripcion":"AMPLITUD DE EVERSIÓN PASIVA DE ARTICULACIÓN SUBASTRAGALINA DISMINUIDA"
  },
  {
    "codigo":365079007,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA COMUNICAR SENTIMIENTOS"
  },
  {
    "codigo":230337001,
    "descripcion":"TRASTORNO DE TIC MOTOR"
  },
  {
    "codigo":263105002,
    "descripcion":"FRACTURA-SUBLUXACIÓN DE LA ARTICULACIÓN DE LA MANO"
  },
  {
    "codigo":295873003,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE LOFEPRAMINA"
  },
  {
    "codigo":961007,
    "descripcion":"ERITEMA NUDOSO AGUDO"
  },
  {
    "codigo":31894005,
    "descripcion":"EFECTO TÓXICO DEL BROMOBENCILCIANURO"
  },
  {
    "codigo":294038005,
    "descripcion":"ALERGIA A BAMBUTEROL"
  },
  {
    "codigo":64662007,
    "descripcion":"INFARTO PULMONAR"
  },
  {
    "codigo":62827000,
    "descripcion":"ARTERITIS CORONARIA"
  },
  {
    "codigo":228502006,
    "descripcion":"NUNCA HA USADO TABACO EN POLVO HÚMEDO"
  },
  {
    "codigo":718187002,
    "descripcion":"DEFORMIDAD POR ROTACIÓN DE COLUMNA VERTEBRAL LUMBAR"
  },
  {
    "codigo":783723003,
    "descripcion":"DISTROFIA ÓSEA ESCLEROSANTE MIXTA CON MANIFESTACIÓN EXTRAESQUELÉTICA"
  },
  {
    "codigo":292203001,
    "descripcion":"REACCIÓN ADVERSA AL CLORAMBUCILO"
  },
  {
    "codigo":161131005,
    "descripcion":"ABANDONO ESCOLAR POR VOLUNTAD PROPIA"
  },
  {
    "codigo":35731000175102,
    "descripcion":"ÚLCERA POR PRESIÓN EN CODO, ESTADIO II"
  },
  {
    "codigo":95595008,
    "descripcion":"ÚLCERAS DE LOS ÓRGANOS GENITALES FEMENINOS"
  },
  {
    "codigo":126528000,
    "descripcion":"NEOPLASIA DE LA PIEL DE LA RODILLA"
  },
  {
    "codigo":30059008,
    "descripcion":"TRASTORNO DE PÁNICO CON AGORAFOBIA, EVITACIÓN AGORAFÓBICA GRAVE Y ATAQUES DE PÁNICO MODERADOS"
  },
  {
    "codigo":192064004,
    "descripcion":"MUTISMO ELECTIVO POR REACCIÓN DE ADAPTACIÓN"
  },
  {
    "codigo":1142336005,
    "descripcion":"ATROFIA DE MÚSCULO ESCAPULAR"
  },
  {
    "codigo":93760006,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL CÓCCIX"
  },
  {
    "codigo":69384002,
    "descripcion":"INTOXICACIÓN POR AVENA SATIVA"
  },
  {
    "codigo":28224009,
    "descripcion":"INTOXICACIÓN POR CLOXACILINA"
  },
  {
    "codigo":349431000119107,
    "descripcion":"ESTENOSIS ADQUIRIDA DE AMBOS CONDUCTOS NASOLAGRIMALES"
  },
  {
    "codigo":91925003,
    "descripcion":"RINITIS ALÉRGICA CAUSADA POR ANIMALES"
  },
  {
    "codigo":124693006,
    "descripcion":"DEFICIENCIA DE LISINA - ARNT LIGASA"
  },
  {
    "codigo":26389007,
    "descripcion":"BOCIO MULTINODULAR TÓXICO"
  },
  {
    "codigo":1204202004,
    "descripcion":"OCLUSIÓN DE ARTERIA CEREBRAL POR INFECCIÓN"
  },
  {
    "codigo":286698008,
    "descripcion":"NIVEL BAJO DE NEUROTISMO"
  },
  {
    "codigo":22719003,
    "descripcion":"ACATISIA AGUDA CAUSADA POR NEUROLÉPTICOS"
  },
  {
    "codigo":284863006,
    "descripcion":"CAPAZ DE LAVARSE EL PELO"
  },
  {
    "codigo":709012003,
    "descripcion":"ESTADO DE CONSCIENCIA MÍNIMA"
  },
  {
    "codigo":283028009,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE LA MEJILLA"
  },
  {
    "codigo":182889006,
    "descripcion":"ANALGÉSICOS SOLICITADOS"
  },
  {
    "codigo":1297001007,
    "descripcion":"CIERRE DE ÁNGULO AGUDO DE OJO DERECHO"
  },
  {
    "codigo":1264233008,
    "descripcion":"COAGULACIÓN INTRAVASCULAR DISEMINADA POSTERIOR A EMBARAZO ECTÓPICO"
  },
  {
    "codigo":49982000,
    "descripcion":"TAQUICARDIA AURICULAR MULTIFOCAL"
  },
  {
    "codigo":17214002,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE VÉRTEBRA LUMBAR"
  },
  {
    "codigo":51817006,
    "descripcion":"INFECCIÓN CAUSADA POR ACANTHAMOEBA CASTELLANI"
  },
  {
    "codigo":410430005,
    "descripcion":"PARO CARDIORRESPIRATORIO"
  },
  {
    "codigo":312126006,
    "descripcion":"INFECCIÓN BACTERIANA DEL SISTEMA MUSCULOESQUELÉTICO"
  },
  {
    "codigo":1196862008,
    "descripcion":"NEOPLASIA DE CÉLULAS GRANULARES DE ESÓFAGO"
  },
  {
    "codigo":80915000,
    "descripcion":"INTOXICACIÓN POR TRIFOLIUM REPENS"
  },
  {
    "codigo":277523004,
    "descripcion":"LESIÓN MELANOCÍTICA PRIMARIA DE MENINGES"
  },
  {
    "codigo":310291005,
    "descripcion":"ANTICUERPOS CONTRA MÚSCULO LISO NO DETECTADOS"
  },
  {
    "codigo":42191000087103,
    "descripcion":"HERIDA CORTANTE DE PIERNA DERECHA"
  },
  {
    "codigo":39631000087104,
    "descripcion":"DOLOR DENTAL CRÓNICO"
  },
  {
    "codigo":26831000087105,
    "descripcion":"JUBILADO POR EDAD"
  },
  {
    "codigo":898280002,
    "descripcion":"ANQUILOSIS CONGÉNITA DE ARTICULACIÓN METACARPOFALÁNGICA DE DEDO MEÑIQUE"
  },
  {
    "codigo":47311000087108,
    "descripcion":"DISTENSIÓN DE TENDÓN DE MÚSCULO INTERNO DE MUSLO IZQUIERDO"
  },
  {
    "codigo":110013004,
    "descripcion":"NEOPLASIA SUPERPUESTA MALIGNA DE AMÍGDALAS"
  },
  {
    "codigo":698002002,
    "descripcion":"PÉRDIDA DEL GUSTO EN LOS DOS TERCIOS ANTERIORES DE LA LENGUA"
  },
  {
    "codigo":403090008,
    "descripcion":"TIÑA NEGRA CAUSADA POR STENELLA ARAGUATA"
  },
  {
    "codigo":40807001,
    "descripcion":"JUEGO SEXUAL ENTRE HERMANO Y HERMANA"
  },
  {
    "codigo":204647002,
    "descripcion":"ECTROPIÓN CONGÉNITO DE LABIO"
  },
  {
    "codigo":366652000,
    "descripcion":"HALLAZGO RELACIONADO CON LA FORMA DE LA UÑA"
  },
  {
    "codigo":6204001,
    "descripcion":"EPILEPSIA MIOCLÓNICA JUVENIL"
  },
  {
    "codigo":399420002,
    "descripcion":"INVASIÓN TUMORAL DE ESCLERÓTICA, AUSENTE"
  },
  {
    "codigo":38972005,
    "descripcion":"LESIÓN TRAUMÁTICA DE COLON SIGMOIDE SIN HERIDA ABIERTA HACIA CAVIDAD ABDOMINAL"
  },
  {
    "codigo":10837701000119106,
    "descripcion":"FRACTURA ABIERTA DE TERCER HUESO METATARSIANO DE PIE IZQUIERDO"
  },
  {
    "codigo":202812007,
    "descripcion":"ANQUILOSIS ATLANTO-OCCIPITAL"
  },
  {
    "codigo":168209000,
    "descripcion":"ESPÉCIMEN SIN VIRUS IDENTIFICADO"
  },
  {
    "codigo":1251388009,
    "descripcion":"TRASTORNO DE PIEL CAUSADO POR INHIBIDOR DE RECEPTOR DE FACTOR DE CRECIMIENTO EPIDÉRMICO"
  },
  {
    "codigo":762161000000103,
    "descripcion":"MANEJA SUS PROPIAS FINANZAS MEDIANTE BANCA ELECTRÓNICA"
  },
  {
    "codigo":299281000,
    "descripcion":"AMPLITUD DE ADUCCIÓN PASIVA DE LA CADERA AUMENTADA"
  },
  {
    "codigo":200977004,
    "descripcion":"PSORIASIS ERITRODÉRMICA"
  },
  {
    "codigo":364817007,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA COMER CON LA MANO IZQUIERDA"
  },
  {
    "codigo":461286001,
    "descripcion":"ANOMALÍA ADQUIRIDA DE VENA CAVA SUPERIOR"
  },
  {
    "codigo":788966003,
    "descripcion":"REACCIÓN CUTÁNEA A PICADURA DE INSECTO"
  },
  {
    "codigo":166374003,
    "descripcion":"NIVEL DE HORMONA LUTEINIZANTE FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":2534005,
    "descripcion":"AUSENCIA CONGÉNITA DE LA VENA CAVA"
  },
  {
    "codigo":68070008,
    "descripcion":"RASGOS PUBERALES DE CRUZAMIENTO SEXUAL"
  },
  {
    "codigo":787131001,
    "descripcion":"METABOLIZADOR NORMAL DE LA SUBUNIDAD 1 DEL COMPLEJO VITAMINA K-EPÓXIDO REDUCTASA"
  },
  {
    "codigo":721595004,
    "descripcion":"CARCINOMA PAPILAR INTRAQUÍSTICO PRIMARIO DE MAMA"
  },
  {
    "codigo":262843005,
    "descripcion":"HEMATOMA DUODENAL"
  },
  {
    "codigo":295611005,
    "descripcion":"SOBREDOSIS DE TIOTEPA"
  },
  {
    "codigo":361147005,
    "descripcion":"HIPOPLASIA CONGÉNITA DE PAPILA RENAL"
  },
  {
    "codigo":293776000,
    "descripcion":"ALERGIA A FLUOROURACILO"
  },
  {
    "codigo":424848002,
    "descripcion":"CONSUMIDOR DE DROGAS CON FINES RECREATIVOS"
  },
  {
    "codigo":291941000,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR CLOFIBRATO"
  },
  {
    "codigo":95333004,
    "descripcion":"FOLICULITIS PUSTULOSA EOSINOFÍLICA"
  },
  {
    "codigo":128101008,
    "descripcion":"DEFICIENCIA DE FACTOR V PLAQUETARIO (FACTOR V QUEBEC)"
  },
  {
    "codigo":716090004,
    "descripcion":"SÍNDROME DE BAJA ESTATURA CON ANOMALÍAS CRANEOFACIALES E HIPOPLASIA GENITAL"
  },
  {
    "codigo":283528000,
    "descripcion":"HERIDA PUNZANTE DE PERINEO"
  },
  {
    "codigo":58895005,
    "descripcion":"CONVULSIÓN CENTRAL"
  },
  {
    "codigo":188132000,
    "descripcion":"NEOPLASIA MALIGNA DE PIEL DE LA REGIÓN DE LA FOSA POPLÍTEA"
  },
  {
    "codigo":286436002,
    "descripcion":"INCAPAZ DE PLANIFICAR LAS COMIDAS"
  },
  {
    "codigo":253668003,
    "descripcion":"AISLAMIENTO DE ARTERIA SUBCLAVIA"
  },
  {
    "codigo":1269476005,
    "descripcion":"CON MAYOR RIESGO DE COMPLICACIÓN DURANTE TRABAJO DE PARTO Y PARTO"
  },
  {
    "codigo":384740007,
    "descripcion":"HALLAZGO RELACIONADO CON EL GRADO"
  },
  {
    "codigo":87993005,
    "descripcion":"IDENTIFICACIÓN PRESUNTIVA DE UN CUERPO POR RECONOCIMIENTO DE LA FAMILIA"
  },
  {
    "codigo":284601008,
    "descripcion":"DESVESTIRSE EN PÚBLICO"
  },
  {
    "codigo":315534001,
    "descripcion":"NACIDO EN SUECIA"
  },
  {
    "codigo":118926004,
    "descripcion":"TRASTORNO DE LA VÍA BILIAR"
  },
  {
    "codigo":282766005,
    "descripcion":"LESIÓN LUMBAR"
  },
  {
    "codigo":413838009,
    "descripcion":"CARDIOPATÍA ISQUÉMICA CRÓNICA"
  },
  {
    "codigo":1263971004,
    "descripcion":"HEMATOMA INTRACEREBRAL NEONATAL PRECOZ"
  },
  {
    "codigo":1231203009,
    "descripcion":"OFTALMOPLEJÍA DEBIDA A NEUROPATÍA"
  },
  {
    "codigo":705080006,
    "descripcion":"FRACTURA NO EXPUESTA DE PLACA EPIFISARIA DE TIBIA DISTAL"
  },
  {
    "codigo":5671000124104,
    "descripcion":"ESQUEMA OCLUSAL MÍNIMAMENTE COMPROMETIDO"
  },
  {
    "codigo":311864009,
    "descripcion":"FRACTURA EXPUESTA QUE COMPROMETE TÓRAX, REGIÓN LUMBAR, PELVIS Y EXTREMIDADES"
  },
  {
    "codigo":440871000124105,
    "descripcion":"INGESTA INADECUADA DE MANGANESO"
  },
  {
    "codigo":703245004,
    "descripcion":"ESTENOSIS ADQUIRIDA DE ARTERIA PULMONAR DERECHA"
  },
  {
    "codigo":441101007,
    "descripcion":"DEFICIENCIA HETEROCIGOTA DE PROTEÍNA C"
  },
  {
    "codigo":46050004,
    "descripcion":"SORDERA DE CONDUCCIÓN ÓSEA"
  },
  {
    "codigo":766946005,
    "descripcion":"OBSTRUCCIÓN DISTAL COMPLETA DE AMBAS TROMPAS DE FALOPIO"
  },
  {
    "codigo":78818007,
    "descripcion":"SENSIBILIDAD CUTÁNEA DISMINUIDA"
  },
  {
    "codigo":371895000,
    "descripcion":"LESIÓN INCRIMINADA DE ARTERIA CORONARIA"
  },
  {
    "codigo":275426009,
    "descripcion":"DESPROPORCIÓN PÉLVICA"
  },
  {
    "codigo":13282008,
    "descripcion":"OPACIDAD CORNEAL CONGÉNITA QUE INTERFIERE CON LA VISIÓN"
  },
  {
    "codigo":240823004,
    "descripcion":"ABSCESO FILARIÁSICO BANCROFTIANO"
  },
  {
    "codigo":404663008,
    "descripcion":"RETINOPATÍA PARANEOPLÁSICA"
  },
  {
    "codigo":402828000,
    "descripcion":"HIDRADENITIS VULVAR SUPURATIVA"
  },
  {
    "codigo":763276000,
    "descripcion":"SÍNDROME DE TRISOMÍA DISTAL 7P"
  },
  {
    "codigo":109751009,
    "descripcion":"FRACTURA DE CORONA DENTAL, ESMALTE SOLAMENTE"
  },
  {
    "codigo":765111008,
    "descripcion":"EXCITACIÓN SEXUAL POR EXPOSICIÓN DE GENITALES A PERSONA POSPÚBER SIN CONSENTIMIENTO"
  },
  {
    "codigo":1287564005,
    "descripcion":"TUMOR NEUROENDOCRINO BIEN DIFERENCIADO DE TIMO"
  },
  {
    "codigo":271756005,
    "descripcion":"ERUPCIÓN MACULAR"
  },
  {
    "codigo":16357831000119100,
    "descripcion":"ADENOMA DE AMBAS GLÁNDULAS SUPRARRENALES"
  },
  {
    "codigo":238988008,
    "descripcion":"ERUPCIÓN PSORIASIFORME POR FÁRMACOS"
  },
  {
    "codigo":75148009,
    "descripcion":"PROBLEMA OCUPACIONAL"
  },
  {
    "codigo":304524009,
    "descripcion":"QUERATOSIS ACTÍNICA BOWENOIDE"
  },
  {
    "codigo":370060008,
    "descripcion":"TUMOR QUE INVADE LA CAPA MUSCULAR PROPIA"
  },
  {
    "codigo":366390001,
    "descripcion":"AMPLITUD DE MOVIMIENTO PASIVO DE FLEXIÓN LATERAL HACIA LA DERECHA DE LA COLUMNA CERVICAL - HALLAZGO"
  },
  {
    "codigo":300854002,
    "descripcion":"MASA DE CAVIDAD ORAL"
  },
  {
    "codigo":4107000,
    "descripcion":"SÍNDROME DE INFERTILIDAD MASCULINA"
  },
  {
    "codigo":725003001,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO DE LA CABEZA"
  },
  {
    "codigo":167947004,
    "descripcion":"EXAMEN DE LÍQUIDO PLEURAL, NORMAL"
  },
  {
    "codigo":299019004,
    "descripcion":"CREPITACIÓN DE ARTICULACIÓN DE MUÑECA"
  },
  {
    "codigo":69643006,
    "descripcion":"ABSCESO DE PÁNCREAS"
  },
  {
    "codigo":397323008,
    "descripcion":"MARGEN QUIRÚRGICO DISTAL DE VÍAS BILIARES COMPROMETIDO POR NEOPLASIA MALIGNA"
  },
  {
    "codigo":428256003,
    "descripcion":"FRACTURA DE CÓNDILO TIBIAL"
  },
  {
    "codigo":723168009,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE MAMA COMPLETA"
  },
  {
    "codigo":360885002,
    "descripcion":"CAMBIO DE DOMICILIO"
  },
  {
    "codigo":262581006,
    "descripcion":"QUEMADURA EN LA CABEZA"
  },
  {
    "codigo":721333008,
    "descripcion":"LESIÓN POR APLASTAMIENTO DE CEREBRO"
  },
  {
    "codigo":437009,
    "descripcion":"COMPOSICIÓN ANORMAL DE LA ORINA"
  },
  {
    "codigo":195210002,
    "descripcion":"SÍNDROME DE ARTERIA CEREBRAL ANTERIOR"
  },
  {
    "codigo":229813008,
    "descripcion":"CALLO NEUROVASCULAR"
  },
  {
    "codigo":1145482005,
    "descripcion":"HIPOPLASIA CONGÉNITA DE FALANGE DE DEDO ÍNDICE"
  },
  {
    "codigo":95071002,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA PIEL DE LA PIERNA"
  },
  {
    "codigo":783199003,
    "descripcion":"NEUTROPENIA CONGÉNITA SEVERA AUTOSÓMICA RECESIVA DEBIDA A DEFICIENCIA DE JAGN1"
  },
  {
    "codigo":291679008,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ISONIAZIDA"
  },
  {
    "codigo":224308001,
    "descripcion":"CONCURRE A LA ESCUELA SECUNDARIA"
  },
  {
    "codigo":226143008,
    "descripcion":"DIETA RICA EN VITAMINA B2"
  },
  {
    "codigo":1010740004,
    "descripcion":"DISPLASIA CORTICAL FOCAL CON DISTORSIÓN ESTRUCTURAL ANÓMALA DE CAPAS DE CORTEZA CEREBRAL BLUMCKE TIPO III"
  },
  {
    "codigo":715828006,
    "descripcion":"PROBÓSCIDE LATERAL"
  },
  {
    "codigo":93236008,
    "descripcion":"HIPOPLASIA CONGÉNITA DE HUESO ALIESFENOIDAL"
  },
  {
    "codigo":124169000,
    "descripcion":"DEFICIENCIA DE GLUTAMATO DESHIDROGENASA"
  },
  {
    "codigo":1269214001,
    "descripcion":"ESTADO TÓXICO DEBIDO A DILATACIÓN DE COLON"
  },
  {
    "codigo":187870002,
    "descripcion":"NEOPLASIA MALIGNA DE LÓBULO INFERIOR DEL PULMÓN"
  },
  {
    "codigo":286174002,
    "descripcion":"INCAPAZ DE HACER LA CAMA"
  },
  {
    "codigo":253406008,
    "descripcion":"ANOMALÍA DE CUERDA TENDINOSA DE VÁLVULA MITRAL"
  },
  {
    "codigo":448179001,
    "descripcion":"ANEURISMA DE VENA CAVA SUPERIOR DERECHA"
  },
  {
    "codigo":1300147000,
    "descripcion":"DISPLASIA CONGÉNITA DE ARTICULACIÓN DE AMBOS PIES"
  },
  {
    "codigo":11798121000119100,
    "descripcion":"LESIÓN TRAUMÁTICA DE PARED POSTERIOR DEL TÓRAX"
  },
  {
    "codigo":1079401000119100,
    "descripcion":"NEOPLASIA BENIGNA DE PIEL DE MIEMBRO INFERIOR DERECHO"
  },
  {
    "codigo":1087081000119102,
    "descripcion":"HEMORRAGIA GÁSTRICA CAUSADA POR HELICOBACTER PYLORI"
  },
  {
    "codigo":296041000119103,
    "descripcion":"COXA MAGNA"
  },
  {
    "codigo":710323008,
    "descripcion":"ESPECIE DE FASCIOLOPSIS O FASCIOLA"
  },
  {
    "codigo":15714921000119105,
    "descripcion":"OSTEOFITO DE AMBOS CARPOS"
  },
  {
    "codigo":15740521000119104,
    "descripcion":"CONTRACCIÓN DE CAVIDAD ORBITARIA IZQUIERDA"
  },
  {
    "codigo":15668841000119107,
    "descripcion":"DEFORMIDAD CONGÉNITA DE ARTICULACIÓN DE RODILLA DERECHA"
  },
  {
    "codigo":104041000119108,
    "descripcion":"SINUSITIS FÚNGICA"
  },
  {
    "codigo":298601000119107,
    "descripcion":"OSTEONECROSIS DE HUESO DE HOMBRO CAUSADA POR FÁRMACO"
  },
  {
    "codigo":342121000119108,
    "descripcion":"EPITELIOPATÍA PIGMENTARIA PLACOIDE MULTIFOCAL AGUDA DE OJO IZQUIERDO"
  },
  {
    "codigo":32361000119104,
    "descripcion":"HEMANGIOMA CONGÉNITO"
  },
  {
    "codigo":15702121000119104,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE TENDÓN DE CUÁDRICEPS DERECHO"
  },
  {
    "codigo":15684201000119104,
    "descripcion":"PERIOSTITIS DE PIERNA IZQUIERDA"
  },
  {
    "codigo":15748201000119108,
    "descripcion":"MASA BILATERAL DE ARTICULACIONES DE REGIONES DE HOMBRO"
  },
  {
    "codigo":10879081000119107,
    "descripcion":"HEMATOMA TRAUMÁTICO DE ÓRBITA DERECHA"
  },
  {
    "codigo":11311721000119107,
    "descripcion":"FRACTURA PATOLÓGICA DE VÉRTEBRA SACRA EN SITIO DE NEOPLASIA"
  },
  {
    "codigo":1089641000119109,
    "descripcion":"ABSCESO SUBPERIÓSTICO DE LA APÓFISIS MASTOIDEA IZQUIERDA"
  },
  {
    "codigo":293481000119109,
    "descripcion":"TROMBOSIS AGUDA DE VENA ILÍACA DERECHA"
  },
  {
    "codigo":10898171000119108,
    "descripcion":"HERIDA ABIERTA DE ANO"
  },
  {
    "codigo":1296477009,
    "descripcion":"HIPERTENSIÓN OCULAR DE OJO DERECHO CAUSADA POR CORTICOIDES"
  },
  {
    "codigo":82226007,
    "descripcion":"BLOQUEO INTRAVENTRICULAR DIFUSO"
  },
  {
    "codigo":278834008,
    "descripcion":"OSTEÓLISIS MULTICÉNTRICA IDIOPÁTICA"
  },
  {
    "codigo":309767001,
    "descripcion":"DOLOR ASOCIADO CON PRÓTESIS ARTICULAR DE RODILLA"
  },
  {
    "codigo":211463006,
    "descripcion":"CUERPO EXTRAÑO EN HERIDA CUTÁNEA"
  },
  {
    "codigo":1260039008,
    "descripcion":"CARCINOMA ADENOESCAMOSO DE OROFARINGE"
  },
  {
    "codigo":735751009,
    "descripcion":"LESIÓN TRAUMÁTICA DE PLEXO MESENTÉRICO SUPERIOR"
  },
  {
    "codigo":209628003,
    "descripcion":"DESGARRO COMPLETO DEL LIGAMENTO CRUZADO POSTERIOR DE LA RODILLA"
  },
  {
    "codigo":111324004,
    "descripcion":"AUSENCIA CONGÉNITA DE MAMA"
  },
  {
    "codigo":109489000,
    "descripcion":"HIPOMINERALIZACIÓN LOCALIZADA DEL ESMALTE ASOCIADA CON TRAUMATISMO LOCALIZADO"
  },
  {
    "codigo":764849002,
    "descripcion":"AMILOIDOSIS CUTÁNEA DISCRÓMICA"
  },
  {
    "codigo":240561005,
    "descripcion":"CORONA VENERIS"
  },
  {
    "codigo":371633008,
    "descripcion":"CADÁVER AL QUE SE LE PRACTICÓ UNA AUTOPSIA"
  },
  {
    "codigo":15950741000119109,
    "descripcion":"MELANOMA MALIGNO DE PIEL DE AMBAS CADERAS"
  },
  {
    "codigo":16006191000119103,
    "descripcion":"TROMBOFLEBITIS DE VENA SUPERFICIAL DE MIEMBRO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":11631000202106,
    "descripcion":"VISIÓN SIN CAMBIOS"
  },
  {
    "codigo":1252699002,
    "descripcion":"ENVENENAMIENTO POR ÁCIDO 4-CLOROBENZOICO"
  },
  {
    "codigo":16415791000119104,
    "descripcion":"MIASTENIA GRAVIS EN REMISIÓN"
  },
  {
    "codigo":40283005,
    "descripcion":"TROMBOFLEBITIS DE LAS VENAS SUPERFICIALES DE LA EXTREMIDAD INFERIOR"
  },
  {
    "codigo":235056002,
    "descripcion":"INFECCIÓN PRIMARIA BUCAL POR HERPES SIMPLE"
  },
  {
    "codigo":890416004,
    "descripcion":"CLINODACTILIA CONGÉNITA DE LOS DEDOS DE AMBAS MANOS"
  },
  {
    "codigo":366128006,
    "descripcion":"HALLAZGO RELACIONADO CON LA SIMETRÍA DE MOVIMIENTO TORÁCICO"
  },
  {
    "codigo":202288006,
    "descripcion":"CONTRACTURA EN ROTACIÓN EXTERNA DE LA CADERA"
  },
  {
    "codigo":298757000,
    "descripcion":"HALLAZGO RELACIONADO CON LA ESTRUCTURA DEL OMÓPLATO"
  },
  {
    "codigo":167685004,
    "descripcion":"FRUCTOSA DETECTADA EN ESPÉCIMEN DE MATERIA FECAL ANALIZADO MEDIANTE CROMATOGRAFÍA"
  },
  {
    "codigo":69381005,
    "descripcion":"MACRODACTILIA DE DEDOS DE LA MANO"
  },
  {
    "codigo":724741005,
    "descripcion":"TRASTORNO DE CONDUCTA ANTISOCIAL DE COMIENZO EN LA ADOLESCENCIA CON EMOCIONES PROSOCIALES LIMITADAS"
  },
  {
    "codigo":3845008,
    "descripcion":"DUPLICACIÓN CONGÉNITA DEL INTESTINO"
  },
  {
    "codigo":165850001,
    "descripcion":"FACTOR ANTINUCLEAR POSITIVO"
  },
  {
    "codigo":722906002,
    "descripcion":"HEMORRAGIA INTRACRANEAL DEBIDA A TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":175004,
    "descripcion":"NEURALGIA DE NERVIO SUPRAORBITARIO"
  },
  {
    "codigo":333001000119105,
    "descripcion":"COROIDITIS FOCAL DE POLO POSTERIOR DE OJO DERECHO"
  },
  {
    "codigo":1145220002,
    "descripcion":"RADICULITIS DEBIDA A RUPTURA DE DISCO INTERVERTEBRAL CERVICAL"
  },
  {
    "codigo":194948006,
    "descripcion":"MIOCARDITIS AGUDA - TOXOPLASMOSIS"
  },
  {
    "codigo":11775331000119100,
    "descripcion":"CONTUSIÓN DE MUÑECA DERECHA"
  },
  {
    "codigo":782937006,
    "descripcion":"ANOMALÍAS DE TENDONES EXTENSORES DE DEDOS DE LAS MANOS"
  },
  {
    "codigo":92974000,
    "descripcion":"AUSENCIA CONGÉNITA DEL MÚSCULO PAPILAR"
  },
  {
    "codigo":27438001,
    "descripcion":"PIOCOLPOS"
  },
  {
    "codigo":846638002,
    "descripcion":"BRONQUITIS CAUSADA POR PARTÍCULAS SÓLIDAS CALIENTES TRANSITORIAMENTE SUSPENDIDAS EN EL AIRE"
  },
  {
    "codigo":1010478001,
    "descripcion":"AGENESIA DE FALANGE MEDIA DE DEDO MAYOR"
  },
  {
    "codigo":62041008,
    "descripcion":"INTOXICACIÓN POR PORTULACA OLERACEA"
  },
  {
    "codigo":94809008,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE HUESO CUBOIDES"
  },
  {
    "codigo":289582008,
    "descripcion":"MÍNIMA CANTIDAD DE LOQUIOS"
  },
  {
    "codigo":713731001,
    "descripcion":"PIREXIA DE ORIGEN DESCONOCIDO CONCOMITANTE CON INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":254979004,
    "descripcion":"MELANOCITOMA DE LA CABEZA DEL NERVIO ÓPTICO"
  },
  {
    "codigo":123907006,
    "descripcion":"INTOXICACIÓN POR EQUISETACEAE"
  },
  {
    "codigo":449752001,
    "descripcion":"SOCAVAMIENTO DE HERIDA"
  },
  {
    "codigo":285912003,
    "descripcion":"INCAPAZ DE UTILIZAR INSTALACIONES PARA LA HIGIENE"
  },
  {
    "codigo":187608006,
    "descripcion":"NEOPLASIA MALIGNA DE FRENILLO DE LABIO SUPERIOR"
  },
  {
    "codigo":253144007,
    "descripcion":"QUISTE DEL SEPTUM PELLUCIDUM"
  },
  {
    "codigo":415149004,
    "descripcion":"SANGRADO POSCOITAL EN LA POSMENOPAUSIA"
  },
  {
    "codigo":284077005,
    "descripcion":"FÍSTULA PERINEAL"
  },
  {
    "codigo":447917005,
    "descripcion":"HÍGADO EN POSICIÓN CENTRAL"
  },
  {
    "codigo":185773008,
    "descripcion":"CONTROL GERIÁTRICO BORRADO"
  },
  {
    "codigo":1363586001,
    "descripcion":"BRAQUIDACTILIA PREAXIAL DE DÍGITOS, DEDOS DE MANO MEMBRANOSOS"
  },
  {
    "codigo":315010001,
    "descripcion":"OBSERVACIÓN RELACIONADA CON REACCIÓN EN CADENA DE LA POLIMERASA"
  },
  {
    "codigo":87469009,
    "descripcion":"SIGNOS ELECTROCARDIOGRÁFICOS DE HIPERTROFIA AURICULAR IZQUIERDA"
  },
  {
    "codigo":282242003,
    "descripcion":"CAMINA HACIA ATRÁS ARRASTRANDO UN JUGUETE GRANDE"
  },
  {
    "codigo":52866005,
    "descripcion":"DELIRIO POR INTOXICACIÓN CON OPIÁCEOS"
  },
  {
    "codigo":413314002,
    "descripcion":"PACIENTE NO REGISTRADO CON EL ODONTÓLOGO"
  },
  {
    "codigo":216706001,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR PARATIÓN"
  },
  {
    "codigo":11842811000119106,
    "descripcion":"TRANSECCIÓN COMPLETA DE ARTERIA CARÓTIDA DERECHA"
  },
  {
    "codigo":83799000,
    "descripcion":"TRANSPOSICIÓN CORREGIDA DE LOS GRANDES VASOS"
  },
  {
    "codigo":442412000,
    "descripcion":"COBALTO EN ESPÉCIMEN DE SANGRE FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1228844002,
    "descripcion":"SÍNDROME DE MICRODELECIÓN 1P35.2"
  },
  {
    "codigo":735489000,
    "descripcion":"INFECCIÓN DEL TRACTO GENITAL DEBIDA A EMBARAZO ECTÓPICO Y POSTERIOR A ÉL"
  },
  {
    "codigo":737324009,
    "descripcion":"EMBOLIA POSTERIOR A EMBARAZO ECTÓPICO Y DEBIDA A ÉL"
  },
  {
    "codigo":278572009,
    "descripcion":"CORONA DENTAL MUY ANCHA"
  },
  {
    "codigo":1259777003,
    "descripcion":"ESPIRADENOMA ECRINO PRIMARIO MALIGNO DE PIEL"
  },
  {
    "codigo":307670000,
    "descripcion":"NISTAGMO CONGÉNITO CON ANOMALÍA SENSITIVA"
  },
  {
    "codigo":440577009,
    "descripcion":"MÓRULAS EN LEUCOCITOS"
  },
  {
    "codigo":274902006,
    "descripcion":"CARCINOMA HEPATOCELULAR Y COLANGIOCARCINOMA COMBINADOS"
  },
  {
    "codigo":405974007,
    "descripcion":"ESTADIO II DEL GRUPO NACIONAL PARA EL ESTUDIO DEL TUMOR DE WILMS"
  },
  {
    "codigo":305835000,
    "descripcion":"VISTO POR EL SERVICIO DE HEMATOLOGÍA"
  },
  {
    "codigo":404139001,
    "descripcion":"INFILTRACIÓN LEUCÉMICA DE PIEL EN LA TRICOLEUCEMIA"
  },
  {
    "codigo":240299002,
    "descripcion":"BRADICARDIA FETAL"
  },
  {
    "codigo":209366008,
    "descripcion":"FRACTURA-LUXACIÓN EXPUESTA DE ARTICULACIÓN METATARSOFALÁNGICA, ÚNICA"
  },
  {
    "codigo":699051006,
    "descripcion":"HIPOSPADIAS SUBCORONAL MASCULINO"
  },
  {
    "codigo":830123008,
    "descripcion":"ESTADO MENTAL NORMAL"
  },
  {
    "codigo":1287040000,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE CADERA POSTERIOR A REMOCIÓN DE PRÓTESIS"
  },
  {
    "codigo":402304007,
    "descripcion":"URTICARIA ALÉRGICA DE CONTACTO"
  },
  {
    "codigo":369536007,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL LIGAMENTO ANCHO DERECHO"
  },
  {
    "codigo":302165002,
    "descripcion":"URTICARIA POR FRÍO IDIOPÁTICA"
  },
  {
    "codigo":433237003,
    "descripcion":"COLESTASIS EN EL RECIÉN NACIDO"
  },
  {
    "codigo":7253006,
    "descripcion":"CELULITIS PERIURETRAL"
  },
  {
    "codigo":309041000119102,
    "descripcion":"TENDINITIS CALCIFICANTE DE REGIÓN DE MUÑECA DERECHA"
  },
  {
    "codigo":236629009,
    "descripcion":"CISTITIS CRÓNICA POR RADIACIÓN"
  },
  {
    "codigo":365866002,
    "descripcion":"HALLAZGO RELACIONADO CON EL ESTADO PARA EL VIH"
  },
  {
    "codigo":72789009,
    "descripcion":"PSEUDOTUMOR ORBITARIO INFLAMATORIO"
  },
  {
    "codigo":300330004,
    "descripcion":"HÍGADO LISO"
  },
  {
    "codigo":890154005,
    "descripcion":"DERMATITIS ALÉRGICA POR CONTACTO CON URUSHIOL DE HIEDRA VENENOSA"
  },
  {
    "codigo":724479001,
    "descripcion":"INCONTINENCIA URINARIA CONCOMITANTE CON PROLAPSO DE ÓRGANO GENITAL FEMENINO Y DEBIDA A ÉL"
  },
  {
    "codigo":1119530009,
    "descripcion":"FIJACIÓN VISUAL INESTABLE"
  },
  {
    "codigo":36351005,
    "descripcion":"DEFICIENCIA DE ANTITROMBINA III"
  },
  {
    "codigo":298495009,
    "descripcion":"CIFOESCOLIOSIS DE LA COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":820948002,
    "descripcion":"COLOR NORMAL DE PIEL SOBRE LESIÓN"
  },
  {
    "codigo":1279700001,
    "descripcion":"LUXACIÓN DE ARTICULACIÓN DE DEDO ÍNDICE DE MANO"
  },
  {
    "codigo":460500001,
    "descripcion":"MIOCARDIOPATÍA MITOCONDRIAL HISTIOCITOIDE DEBIDA A DEFICIENCIA DE CITOCROMO AA3"
  },
  {
    "codigo":67284005,
    "descripcion":"EPIFISITIS JUVENIL"
  },
  {
    "codigo":1748006,
    "descripcion":"TROMBOFLEBITIS DE LA VENA FEMORAL PROFUNDA"
  },
  {
    "codigo":296660006,
    "descripcion":"SOBREDOSIS DE CARBENICILINA"
  },
  {
    "codigo":360361000,
    "descripcion":"HIPERTIROIDISMO POR SECRECIÓN INAPROPIADA DE TIROTROFINA"
  },
  {
    "codigo":196521001,
    "descripcion":"ESTENOSIS DE CONDUCTO PAROTÍDEO"
  },
  {
    "codigo":294825001,
    "descripcion":"ALERGIA A SOMATOTROFINA"
  },
  {
    "codigo":720809000,
    "descripcion":"DISECCIÓN DE ARTERIA CARÓTIDA EXTERNA"
  },
  {
    "codigo":10958641000119107,
    "descripcion":"HERIDA PUNZANTE DE MANO IZQUIERDA"
  },
  {
    "codigo":11777841000119108,
    "descripcion":"RUPTURA TRAUMÁTICA DE TENDÓN DE MÚSCULO DELTOIDES DERECHO"
  },
  {
    "codigo":130985008,
    "descripcion":"PERCEPCIÓN SENSITIVA ALTERADA"
  },
  {
    "codigo":30846001,
    "descripcion":"SOPLO ARTERIAL"
  },
  {
    "codigo":292990003,
    "descripcion":"REACCIÓN ADVERSA A LAS POLIMIXINAS"
  },
  {
    "codigo":127315004,
    "descripcion":"HERIDA TRAUMATOPNÉICA DE TÓRAX"
  },
  {
    "codigo":782675008,
    "descripcion":"MIOPATÍA DISTAL CON COMIENZO EN MÚSCULO TIBIAL ANTERIOR"
  },
  {
    "codigo":289320001,
    "descripcion":"MUÑÓN UMBILICAL CASI DESPRENDIDO"
  },
  {
    "codigo":94547009,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA PIEL DEL TÓRAX"
  },
  {
    "codigo":92712002,
    "descripcion":"CARCINOMA IN SITU DE LA PIEL DE LA AXILA"
  },
  {
    "codigo":254717001,
    "descripcion":"SIRINGOCISTADENOMA"
  },
  {
    "codigo":1336061004,
    "descripcion":"EPISODIO DE USO NOCIVO DE ALUCINÓGENO"
  },
  {
    "codigo":123645005,
    "descripcion":"ALTERACIÓN DE UN GRUPO DE CROMOSOMAS"
  },
  {
    "codigo":25341005,
    "descripcion":"ESTENOSIS DE URÉTER"
  },
  {
    "codigo":711634005,
    "descripcion":"FORMA INCOMPLETA DE RAÍZ DENTAL"
  },
  {
    "codigo":1268690007,
    "descripcion":"CAPAZ DE PAGAR CUIDADOS DE UN ADULTO DEPENDIENTE"
  },
  {
    "codigo":449490008,
    "descripcion":"DEFECTO DEL TABIQUE AURICULOVENTRICULAR CON INSUFICIENCIA DE VÁLVULA AURICULOVENTRICULAR A TRAVÉS DE COMISURA SEPTAL DERECHA"
  },
  {
    "codigo":23506009,
    "descripcion":"FLORA NORMAL"
  },
  {
    "codigo":447655002,
    "descripcion":"QUISTE NEOPLÁSICO BENIGO DE CEREBRO"
  },
  {
    "codigo":283815003,
    "descripcion":"MORDEDURA DE ANIMAL EN LA ESPALDA"
  },
  {
    "codigo":251047005,
    "descripcion":"DILATACIÓN DE ARTERIA PULMONAR"
  },
  {
    "codigo":183676005,
    "descripcion":"FALLECIDO EN EL HOSPITAL"
  },
  {
    "codigo":773500007,
    "descripcion":"ALERGIA A EMEPRONIO"
  },
  {
    "codigo":52604008,
    "descripcion":"DEFICIENCIA DE ESTEROIDE 21 - MONOOXIGENASA, TIPO VIRILIZANTE SIMPLE"
  },
  {
    "codigo":116305001,
    "descripcion":"HALLAZGO RELACIONADO CON EL CÓCCIX"
  },
  {
    "codigo":312913006,
    "descripcion":"MACULOPATÍA ISQUÉMICA"
  },
  {
    "codigo":48934003,
    "descripcion":"ÁNTRAX DE LA REGIÓN DEL FLANCO"
  },
  {
    "codigo":442150004,
    "descripcion":"CON MAYOR RIESGO DE TROMBOEMBOLIA VENOSA DEBIDO A INMOVILIZACIÓN PROLONGADA"
  },
  {
    "codigo":704294006,
    "descripcion":"CON MAYOR RIESGO DE ESTADO DE ÁNIMO DEPRIMIDO DURANTE PUERPERIO"
  },
  {
    "codigo":1259515002,
    "descripcion":"TRASTORNO DE SISTEMA NERVIOSO DEBIDO A PUNCIÓN LUMBAR Y POSTERIOR A ELLA"
  },
  {
    "codigo":407547003,
    "descripcion":"FILTRACIÓN EN EL SELLO DEL ESTOMA"
  },
  {
    "codigo":276475003,
    "descripcion":"AVULSIÓN DE VENA - LESIÓN TRAUMÁTICA"
  },
  {
    "codigo":767995003,
    "descripcion":"HERNIA FEMORAL DERECHA OBSTRUIDA CON GANGRENA"
  },
  {
    "codigo":47099006,
    "descripcion":"ASTIGMATISMO IRREGULAR"
  },
  {
    "codigo":372944000,
    "descripcion":"INFECCIÓN CAUSADA POR PENICILLIUM VERRUCOSUM"
  },
  {
    "codigo":473083009,
    "descripcion":"INFECCIÓN ASOCIADA CON DISPOSITIVO VASCULAR"
  },
  {
    "codigo":307408003,
    "descripcion":"DEDO DEL PIE ISQUÉMICO"
  },
  {
    "codigo":733392004,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE PARTE DEL ESCROTO"
  },
  {
    "codigo":241872003,
    "descripcion":"EFECTO TÓXICO CAUSADO POR PINTURA SÓLIDA"
  },
  {
    "codigo":274640006,
    "descripcion":"FIEBRE CON ESCALOFRÍOS"
  },
  {
    "codigo":12496007,
    "descripcion":"HETEROCROMÍA DEL PELO"
  },
  {
    "codigo":438480008,
    "descripcion":"LESIÓN TRAUMÁTICA DE LECHO UNGUEAL DE DEDO DE LA MANO"
  },
  {
    "codigo":371109001,
    "descripcion":"SISTEMA NERVIOSO AUTÓNOMO INMADURO"
  },
  {
    "codigo":403877002,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS INTRAEPIDÉRMICO DE MANO"
  },
  {
    "codigo":305573005,
    "descripcion":"BAJO ATENCIÓN DE ENFERMERA ESPECIALIZADA EN ESTOMAS"
  },
  {
    "codigo":240037007,
    "descripcion":"LESIÓN DE TENDÓN"
  },
  {
    "codigo":10661008,
    "descripcion":"HERNIA DE OVARIO"
  },
  {
    "codigo":15686041000119102,
    "descripcion":"ARTROSIS DE ARTICULACIÓN TEMPOROMANDIBULAR DERECHA"
  },
  {
    "codigo":8826001,
    "descripcion":"PERCEPCIÓN VISUAL SIMULTÁNEA SIN FUSIÓN"
  },
  {
    "codigo":170831000,
    "descripcion":"EFECTO ADVERSO DE FÁRMACO HEMATOLÓGICO"
  },
  {
    "codigo":762490009,
    "descripcion":"BAJO PESO EN LA LACTANCIA"
  },
  {
    "codigo":11999641000119104,
    "descripcion":"QUEMADURA DE TERCER GRADO DE REGIÓN DE HOMBRO DERECHO"
  },
  {
    "codigo":301903005,
    "descripcion":"INCAPAZ DE LEVANTAR LA CABEZA"
  },
  {
    "codigo":72527006,
    "descripcion":"MIOCARDITIS CAUSADA POR FÁRMACO"
  },
  {
    "codigo":1186639007,
    "descripcion":"ÚLCERA POR PRESIÓN EN REGIÓN LUMBAR"
  },
  {
    "codigo":234532001,
    "descripcion":"INMUNODEFICIENCIA"
  },
  {
    "codigo":365604004,
    "descripcion":"HALLAZGO RELATIVO AL NIVEL DE VITAMINA B12"
  },
  {
    "codigo":201764007,
    "descripcion":"ARTRITIS REUMATOIDE DE COLUMNA VERTEBRAL CERVICAL"
  },
  {
    "codigo":5156009,
    "descripcion":"ENROLLAMIENTO DE LA PIEL"
  },
  {
    "codigo":3321001,
    "descripcion":"ABSCESO RENAL"
  },
  {
    "codigo":429305003,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO"
  },
  {
    "codigo":1486001,
    "descripcion":"CONGESTIÓN ORBITARIA"
  },
  {
    "codigo":296398002,
    "descripcion":"SOBREDOSIS DE ATROPINA"
  },
  {
    "codigo":165326005,
    "descripcion":"ESPÉCIMEN DE BIOPSIA INSUFICIENTE"
  },
  {
    "codigo":722382006,
    "descripcion":"SÍNDROME DE CATARATA Y MICROCÓRNEA"
  },
  {
    "codigo":787918007,
    "descripcion":"LEVADURA NO CANDIDA ALBICANS Y NO CRYPTOCOCCUS NEOFORMANS DETECTADA"
  },
  {
    "codigo":340531000119104,
    "descripcion":"HEMORRAGIA INTRAOCULAR DE OJO IZQUIERDO"
  },
  {
    "codigo":294563004,
    "descripcion":"ALERGIA A ÁCIDO MANDÉLICO"
  },
  {
    "codigo":1179299005,
    "descripcion":"DISPLASIA ESQUELÉTICA LETAL ASOCIADA A NEK9"
  },
  {
    "codigo":1144696000,
    "descripcion":"HIPOPLASIA DE FALANGE DISTAL DE TERCER DEDO DE PIE"
  },
  {
    "codigo":817016002,
    "descripcion":"DEDO DE PIE IZQUIERDO AMPUTADO"
  },
  {
    "codigo":194424005,
    "descripcion":"HIPOACUSIA NEUROSENSORIAL BILATERAL"
  },
  {
    "codigo":391032006,
    "descripcion":"EVIDENCIA RADIOLÓGICA DE MINERALIZACIÓN ÓSEA INSUFICIENTE"
  },
  {
    "codigo":423800006,
    "descripcion":"VISIÓN A DISTANCIA 20\/100"
  },
  {
    "codigo":127053000,
    "descripcion":"ENFERMEDAD POSINFECCIOSA POR CRIOAGLUTININAS"
  },
  {
    "codigo":718712005,
    "descripcion":"SÍNDROME DE GLICOPROTEÍNAS DEFICIENTES EN CARBOHIDRATOS TIPO 1M"
  },
  {
    "codigo":61517002,
    "descripcion":"RETINITIS Y RETINOCOROIDITIS METASTÁSICAS DISEMINADAS"
  },
  {
    "codigo":94285008,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LOS GANGLIOS LINFÁTICOS EPITROCLEARES"
  },
  {
    "codigo":290893008,
    "descripcion":"INTOXICACIÓN POR PAROXETINA"
  },
  {
    "codigo":715042002,
    "descripcion":"DIFICULTAD PARA LLORAR"
  },
  {
    "codigo":28749009,
    "descripcion":"ICTIOPARASITISMO CAUSADO POR VANDELLIA CIRRHOSA"
  },
  {
    "codigo":289058006,
    "descripcion":"DIFICULTAD PARA UTILIZAR TENEDOR PARA ALIMENTARSE"
  },
  {
    "codigo":1237495000,
    "descripcion":"METÁSTASIS DE CARCINOMA DE GLOTIS"
  },
  {
    "codigo":1335799005,
    "descripcion":"ARTRITIS IDIOPÁTICA JUVENIL DE REGIÓN DE MUÑECA DERECHA"
  },
  {
    "codigo":385527006,
    "descripcion":"QUEMADURA DE LA PIEL POR AGUA CALIENTE"
  },
  {
    "codigo":254455005,
    "descripcion":"CARCINOMA IN SITU DEL SURCO LABIAL INFERIOR"
  },
  {
    "codigo":285388000,
    "descripcion":"DOLOR ABDOMINAL EN EL LADO DERECHO"
  },
  {
    "codigo":1137356001,
    "descripcion":"HEMATOMA INTRAMUSCULAR NO TRAUMÁTICO"
  },
  {
    "codigo":187084006,
    "descripcion":"ASPERGILOSIS AMIGDALINA"
  },
  {
    "codigo":449228007,
    "descripcion":"HIPOPLASIA DE ANILLO DE VÁLVULA AURICULOVENTRICULAR IZQUIERDA EN VENTRÍCULO CON DOBLE TRACTO DE ENTRADA"
  },
  {
    "codigo":711372008,
    "descripcion":"POSICIÓN DE ÓRGANO TORACOABDOMINAL NORMAL"
  },
  {
    "codigo":185249001,
    "descripcion":"ATENDIDO EN CONSULTORIO ESPECIALIZADO EN PATOLOGÍA DE PRÓSTATA"
  },
  {
    "codigo":283553002,
    "descripcion":"HERIDA DE PERDIGÓN EN NARIZ"
  },
  {
    "codigo":21409006,
    "descripcion":"ENTESOPATÍA DE TOBILLO Y\/O TARSO"
  },
  {
    "codigo":840609007,
    "descripcion":"INFARTO AGUDO DE MIOCARDIO CON ELEVACIÓN DEL SEGMENTO ST DEBIDO A OCLUSIÓN DE RAMA DESCENDENTE ANTERIOR DE ARTERIA CORONARIA IZQUIERDA"
  },
  {
    "codigo":314486004,
    "descripcion":"FIMOSIS DE LA CÁPSULA DEL CRISTALINO"
  },
  {
    "codigo":445558005,
    "descripcion":"MASA POLIQUÍSTICA DE ANEXOS UTERINOS"
  },
  {
    "codigo":609398007,
    "descripcion":"HIPERSENSIBILIDAD NO ALÉRGICA A FÁRMACO O MEDICAMENTO"
  },
  {
    "codigo":247115000,
    "descripcion":"VENA DE LA RETINA - HALLAZGO"
  },
  {
    "codigo":1363062007,
    "descripcion":"ATRESIA INTESTINAL MÚLTIPLE AISLADA"
  },
  {
    "codigo":83275001,
    "descripcion":"TRASTORNO DE VISIÓN BINOCULAR"
  },
  {
    "codigo":248950009,
    "descripcion":"ÚTERO ANTEFLEXO"
  },
  {
    "codigo":441888001,
    "descripcion":"NIVEL DE ENZIMA EN ESPÉCIMEN DE SUERO POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":48672005,
    "descripcion":"TROMPAS DE FALOPIO ACCESORIAS"
  },
  {
    "codigo":278048009,
    "descripcion":"REFLEJO TÓNICO CERVICAL SIMÉTRICO - HALLAZGO"
  },
  {
    "codigo":734965006,
    "descripcion":"ÉMBOLO DE ARTERIA CEREBRAL MEDIA DERECHA"
  },
  {
    "codigo":210677007,
    "descripcion":"LESIÓN POR DESOLLAMIENTO DE CADERA"
  },
  {
    "codigo":440053008,
    "descripcion":"HALLAZGO RELACIONADO CON EL NIVEL DE CAPACIDAD ARITMÉTICA"
  },
  {
    "codigo":208842002,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA NO EXPUESTA DE LA ARTICULACIÓN CARPOMETACARPIANA"
  },
  {
    "codigo":700362008,
    "descripcion":"EL PACIENTE SOLICITA MANEJO MÉDICO SIN UTILIZACIÓN DE SANGRE"
  },
  {
    "codigo":403615001,
    "descripcion":"PÚRPURA POR DAÑO CAPILAR POR FÁRMACO"
  },
  {
    "codigo":272543002,
    "descripcion":"ARRODILLADO EN PRONO"
  },
  {
    "codigo":239775007,
    "descripcion":"HEMARTROSIS TRAUMÁTICA"
  },
  {
    "codigo":10399008,
    "descripcion":"HIPOCLOREMIA"
  },
  {
    "codigo":74100001,
    "descripcion":"ANOMALÍA VASCULAR DE LA CONJUNTIVA"
  },
  {
    "codigo":762228008,
    "descripcion":"TRASTORNO CARDIOVASCULAR CONGÉNITO"
  },
  {
    "codigo":1153609000,
    "descripcion":"LESIÓN TRAUMÁTICA DE DORSO DE TRONCO"
  },
  {
    "codigo":1055305002,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE EXTREMIDAD INFERIOR IZQUIERDA A TRAVÉS DE LA RODILLA"
  },
  {
    "codigo":203337003,
    "descripcion":"ENFERMEDAD DE PAGET DE HUESO CARPIANO"
  },
  {
    "codigo":236105003,
    "descripcion":"ESTENOSIS DE ANASTOMOSIS ESOFÁGICA"
  },
  {
    "codigo":399945005,
    "descripcion":"SEUDOTUMOR SUPERFICIAL DE CASTLEMAN QUE INVOLUCRA PIEL"
  },
  {
    "codigo":6729006,
    "descripcion":"ANEURISMA ARTERIOVENOSO CEREBRAL - RETINIANO"
  },
  {
    "codigo":301641001,
    "descripcion":"DIFICULTAD PARA SUBIRSE Y BAJARSE DE LOS MUEBLES"
  },
  {
    "codigo":237940008,
    "descripcion":"TRASTORNO DEL METABOLISMO DE LOS AMINOÁCIDOS BETA Y OMEGA"
  },
  {
    "codigo":365342001,
    "descripcion":"ESTILO COGNITIVO - HALLAZGO"
  },
  {
    "codigo":299806002,
    "descripcion":"REFLEJO MASETÉRICO DISMINUIDO"
  },
  {
    "codigo":15744001000119109,
    "descripcion":"MASA DE AMBAS ARTICULACIONES DE CADERA"
  },
  {
    "codigo":267038008,
    "descripcion":"EDEMA"
  },
  {
    "codigo":297971001,
    "descripcion":"HALLAZGO RELACIONADO CON LA SENSIBILIDAD CUTÁNEA"
  },
  {
    "codigo":232435001,
    "descripcion":"DEGENERACIÓN POLIPOIDE DE CUERDA VOCAL"
  },
  {
    "codigo":35827000,
    "descripcion":"TRASTORNO DE CONVERSIÓN RECURRENTE"
  },
  {
    "codigo":363507003,
    "descripcion":"NEOPLASIA MALIGNA DE FARINGE"
  },
  {
    "codigo":3059002,
    "descripcion":"LINFANGITIS AGUDA DE MUSLO"
  },
  {
    "codigo":396275006,
    "descripcion":"ARTROSIS"
  },
  {
    "codigo":230600002,
    "descripcion":"NEUROPATÍA EN LA ENFERMEDAD OCLUSIVA ARTERIOESCLERÓTICA"
  },
  {
    "codigo":722120008,
    "descripcion":"GLOMERULONEFRITIS MEMBRANOSA CAUSADA POR FÁRMACO"
  },
  {
    "codigo":66760008,
    "descripcion":"NEURITIS ÓPTICA"
  },
  {
    "codigo":296136008,
    "descripcion":"SOBREDOSIS DE HIDRATO DE CLORAL"
  },
  {
    "codigo":359837005,
    "descripcion":"NEUROPATÍA CUBITAL"
  },
  {
    "codigo":64925008,
    "descripcion":"RODILLA VARA ADQUIRIDA"
  },
  {
    "codigo":95858001,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE DEDO DE PIE"
  },
  {
    "codigo":63090002,
    "descripcion":"REACCIÓN DE CUERPO EXTRAÑO CAUSADA POR SUSTANCIA ACEITOSA"
  },
  {
    "codigo":1144434008,
    "descripcion":"ATROFIA DE CORTEZA DE LÓBULO PARIETAL"
  },
  {
    "codigo":126791000,
    "descripcion":"NEOPLASIA DE CONDUCTO DE GLÁNDULA SALIVAL"
  },
  {
    "codigo":28487002,
    "descripcion":"HALLAZGO RELACIONADO CON LA POSICIÓN DEL FETO"
  },
  {
    "codigo":292466009,
    "descripcion":"REACCIÓN ADVERSA A LA PILOCARPINA"
  },
  {
    "codigo":94023006,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA PIEL DE DEDO DE LA MANO"
  },
  {
    "codigo":92188000,
    "descripcion":"NEOPLASIA BENIGNA DE HUESO LARGO DE LA EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":26652002,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE CUERO CABELLUDO CON INFECCIÓN"
  },
  {
    "codigo":15992271000119100,
    "descripcion":"QUERATITIS DE OJO DERECHO DEBIDA A HERPES ZÓSTER"
  },
  {
    "codigo":288796008,
    "descripcion":"REALIZA PREGUNTAS"
  },
  {
    "codigo":190492009,
    "descripcion":"SÍNDROME DIENCEFÁLICO SECUNDARIO A TUMOR"
  },
  {
    "codigo":419868009,
    "descripcion":"ENCEFALITIS CAUSADA POR RICKETTSIA"
  },
  {
    "codigo":254193007,
    "descripcion":"EPIDERMÓLISIS BULLOSA PROGRESIVA DE LA ZONA DE UNIÓN (NEUROTRÓFICA)"
  },
  {
    "codigo":345551000119102,
    "descripcion":"QUERATOCONJUNTIVITIS DE AMBOS OJOS"
  },
  {
    "codigo":24817009,
    "descripcion":"LABERINTITIS SUPURATIVA"
  },
  {
    "codigo":10939701000119109,
    "descripcion":"HERIDA POR DISPARO DE ARMA DE FUEGO DE REGIÓN DE HOMBRO DERECHO"
  },
  {
    "codigo":88518009,
    "descripcion":"ENFERMEDAD DE WILSON"
  },
  {
    "codigo":448966009,
    "descripcion":"HIPOPLASIA DE PORCIÓN TRABECULAR DE VENTRÍCULO DERECHO"
  },
  {
    "codigo":250523002,
    "descripcion":"PRUEBA DEL ANILLO PARA BRUCELLA: REPROBADA"
  },
  {
    "codigo":283291001,
    "descripcion":"ASTILLA DE MADERA EN LA PALMA DE LA MANO"
  },
  {
    "codigo":840347005,
    "descripcion":"TATUAJE OCUPACIONAL"
  },
  {
    "codigo":281456000,
    "descripcion":"ARQUEAMIENTO DE DISPOSITIVO DE FIJACIÓN DE HUESO"
  },
  {
    "codigo":1082831000119105,
    "descripcion":"ESTENOSIS ADQUIRIDA DE AMBOS CONDUCTOS AUDITIVOS EXTERNOS"
  },
  {
    "codigo":1231728000,
    "descripcion":"DESPRENDIMIENTO DE RETINA DEBIDO A MIOPÍA ALTA PROGRESIVA DEGENERATIVA"
  },
  {
    "codigo":707440005,
    "descripcion":"BRONCOESPASMO INDUCIDO POR EJERCICIO"
  },
  {
    "codigo":445296005,
    "descripcion":"UBICACIÓN INFRACARDÍACA DE CONEXIONES VENOSAS PULMONARES ANÓMALAS EN EL SISTEMA PORTA"
  },
  {
    "codigo":248688008,
    "descripcion":"SOPLO TRICUSPÍDEO PRESISTÓLICO"
  },
  {
    "codigo":771141002,
    "descripcion":"EPILEPSIA PARCIAL BENIGNA DE LA LACTANCIA CON CONVULSIONES SECUNDARIAMENTE GENERALIZADAS"
  },
  {
    "codigo":443461006,
    "descripcion":"FILTRACIÓN DE CONDUCTO DESDE AURÍCULA DERECHA A ARTERIA PULMONAR"
  },
  {
    "codigo":15720041000119102,
    "descripcion":"TRASTORNO DE CARTÍLAGO ARTICULAR DE TOBILLO DERECHO"
  },
  {
    "codigo":12115561000119102,
    "descripcion":"QUEMADURA QUÍMICA DE PIERNA DERECHA"
  },
  {
    "codigo":408858002,
    "descripcion":"PSICOSIS INFANTIL"
  },
  {
    "codigo":1258991007,
    "descripcion":"QUEMADURA CAUSADA POR INCENDIO FORESTAL"
  },
  {
    "codigo":46575009,
    "descripcion":"FLEXIÓN DISMINUIDA"
  },
  {
    "codigo":896708002,
    "descripcion":"FORMA DELGADA ANORMAL CONGÉNITA DE FALANGE MEDIA DE DEDO DE MANO"
  },
  {
    "codigo":274116002,
    "descripcion":"HERPES EN EL EMBARAZO"
  },
  {
    "codigo":110276005,
    "descripcion":"MICOSIS PROFUNDA"
  },
  {
    "codigo":11787881000119106,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DE DEDO ÍNDICE DERECHO"
  },
  {
    "codigo":208580009,
    "descripcion":"FRACTURA NO EXPUESTA DE FÉMUR DISTAL, CÓNDILO EXTERNO"
  },
  {
    "codigo":10137002,
    "descripcion":"QUEMADURA EPIDÉRMICA DEL MENTÓN"
  },
  {
    "codigo":733491005,
    "descripcion":"COMPLEJO DE CARNEY"
  },
  {
    "codigo":319081000119109,
    "descripcion":"ARTRITIS REUMATOIDEA SERONEGATIVA DE MÚLTIPLES ARTICULACIONES"
  },
  {
    "codigo":237678007,
    "descripcion":"HIPERPLASIA TIROTRÓFICA"
  },
  {
    "codigo":39235000,
    "descripcion":"ABSCESO DE CONDUCTO DEFERENTE"
  },
  {
    "codigo":170307001,
    "descripcion":"EXAMEN DEL NIÑO A LAS 8 SEMANAS: ANORMAL - DERIVADO"
  },
  {
    "codigo":1153347002,
    "descripcion":"LINFOMA NO HODGKIN MALIGNO PRIMARIO DE TRACTO VITREORRETINIANO"
  },
  {
    "codigo":235843005,
    "descripcion":"ISQUEMIA MESENTÉRICA NO OCLUSIVA"
  },
  {
    "codigo":203075006,
    "descripcion":"CONTRACTURA DEL MÚSCULO CUÁDRICEPS"
  },
  {
    "codigo":399683009,
    "descripcion":"MARGEN ANTERIOR DE TUMOR LOCALIZADO EN EL ECUADOR ANTERIOR DEL GLOBO OCULAR"
  },
  {
    "codigo":234008002,
    "descripcion":"RUPTURA DE ARTERIA TRASPLANTADA"
  },
  {
    "codigo":1217048002,
    "descripcion":"ATROFIA DE CORTEZA SUPRARRENAL"
  },
  {
    "codigo":430616003,
    "descripcion":"ABSCESO DE VÁLVULA MITRAL"
  },
  {
    "codigo":201240005,
    "descripcion":"SEBORREA POSENCEFALÍTICA"
  },
  {
    "codigo":102936006,
    "descripcion":"HABLA SILÁBICA"
  },
  {
    "codigo":168472007,
    "descripcion":"EXTENDIDO DE CÚPULA VAGINAL, ANORMAL"
  },
  {
    "codigo":299544003,
    "descripcion":"SIN AMPLITUD PASIVA DE EVERSIÓN DE ARTICULACIÓN SUBASTRAGALINA"
  },
  {
    "codigo":428781001,
    "descripcion":"TROMBOSIS VENOSA PROFUNDA ASOCIADA CON INJERTO DE PUENTE EN ARTERIA CORONARIA"
  },
  {
    "codigo":365080005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA DIRIGIR LA ATENCIÓN"
  },
  {
    "codigo":68333005,
    "descripcion":"NEUMOPATÍA DE LOS PELETEROS"
  },
  {
    "codigo":962000,
    "descripcion":"EVALUACIÓN DE DISCAPACIDAD: 6%"
  },
  {
    "codigo":789229008,
    "descripcion":"HERIDA INFECTADA DE PÁRPADO DEBIDA A PICADURA DE INSECTO NO VENENOSO"
  },
  {
    "codigo":263106001,
    "descripcion":"FRACTURA-SUBLUXACIÓN DE LA ARTICULACIÓN MEDIOCARPIANA"
  },
  {
    "codigo":1085341000119103,
    "descripcion":"FISURA DE PALADAR BLANDO Y FISURA BILATERAL DE LABIO"
  },
  {
    "codigo":230338006,
    "descripcion":"TRASTORNO DE TIC GESTURAL"
  },
  {
    "codigo":228503001,
    "descripcion":"EX-CONSUMIDOR DE TABACO EN POLVO HÚMEDO"
  },
  {
    "codigo":294039002,
    "descripcion":"ALERGIA A FENOTEROL"
  },
  {
    "codigo":10833821000119104,
    "descripcion":"FRACTURA ABIERTA DE CUARTO HUESO METATARSIANO DE PIE IZQUIERDO"
  },
  {
    "codigo":425111004,
    "descripcion":"SIN INGRESOS"
  },
  {
    "codigo":295874009,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE LOFEPRAMINA"
  },
  {
    "codigo":30060003,
    "descripcion":"FRACTURA DE DUVERNEY"
  },
  {
    "codigo":161132003,
    "descripcion":"OBLIGADO A ABANDONAR LA ESCUELA"
  },
  {
    "codigo":62828005,
    "descripcion":"DESCENSO DEL DIAFRAGMA"
  },
  {
    "codigo":718188007,
    "descripcion":"SÍNDROME DE DUPLICACIÓN-DELECIÓN INVERTIDA 8P"
  },
  {
    "codigo":292204007,
    "descripcion":"REACCIÓN ADVERSA A LA CICLOFOSFAMIDA"
  },
  {
    "codigo":783724009,
    "descripcion":"ESPINA BÍFIDA FETAL"
  },
  {
    "codigo":305672009,
    "descripcion":"ATENDIDO POR UN GASTROENTERÓLOGO"
  },
  {
    "codigo":192065003,
    "descripcion":"HOSPITALISMO"
  },
  {
    "codigo":93761005,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE COLON"
  },
  {
    "codigo":290369007,
    "descripcion":"INTOXICACIÓN POR INHIBIDOR DE LA BOMBA DE PROTONES"
  },
  {
    "codigo":124694000,
    "descripcion":"DEFICIENCIA DE ALANINA - ARNT LIGASA"
  },
  {
    "codigo":597961000005105,
    "descripcion":"PUERPERIO NORMAL"
  },
  {
    "codigo":91926002,
    "descripcion":"RINITIS ALÉRGICA CAUSADA POR POLEN DE GRAMÍNEAS"
  },
  {
    "codigo":59158004,
    "descripcion":"INFECCIÓN CAUSADA POR OESOPHAGOSTOMUM STEPHANOSTOMUM"
  },
  {
    "codigo":419606008,
    "descripcion":"EXPRESA VERBALMENTE LOS MÉTODOS DE AUTOAJUSTE DE LA DOSIS DE MEDICACIÓN"
  },
  {
    "codigo":385003002,
    "descripcion":"MARGEN APICAL DE RESECCIÓN QUIRÚRGICA AFECTADO POR NEOPLASIA MALIGNA"
  },
  {
    "codigo":90091006,
    "descripcion":"ATAQUES DE RETENCIÓN VOLUNTARIA DE LA RESPIRACIÓN"
  },
  {
    "codigo":284864000,
    "descripcion":"INCAPAZ DE LAVARSE EL PELO"
  },
  {
    "codigo":1204203009,
    "descripcion":"INSUFICIENCIA VENTRICULAR IZQUIERDA CON FRACCIÓN DE EYECCIÓN NORMAL DEBIDA A ARTERIOSCLEROSIS CORONARIA"
  },
  {
    "codigo":283029001,
    "descripcion":"LESIÓN SUPERFICIAL DE LA GARGANTA"
  },
  {
    "codigo":321591000119107,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE TENDÓN FLEXOR DE ANTEBRAZO DERECHO"
  },
  {
    "codigo":1297002000,
    "descripcion":"CIERRE DE ÁNGULO AGUDO DE OJO IZQUIERDO"
  },
  {
    "codigo":608874000,
    "descripcion":"SÍNDROME DE EATON LAMBERT CON NEOPLASIA MALIGNA SUBYACENTE"
  },
  {
    "codigo":182890002,
    "descripcion":"EL PACIENTE SOLICITA UN TRATAMIENTO ALTERNATIVO"
  },
  {
    "codigo":1264234002,
    "descripcion":"HEMÓLISIS INTRAVASCULAR POSTERIOR A EMBARAZO MOLAR"
  },
  {
    "codigo":446869009,
    "descripcion":"LACERACIÓN SUPERFICIAL DE RODILLA"
  },
  {
    "codigo":246591005,
    "descripcion":"RESPUESTA PLANTAR BILATERAL EQUÍVOCA"
  },
  {
    "codigo":410431009,
    "descripcion":"INSUFICIENCIA CARDIORRESPIRATORIA"
  },
  {
    "codigo":82751009,
    "descripcion":"TRISOMÍA PARCIAL 7P"
  },
  {
    "codigo":310292003,
    "descripcion":"ANTICUERPOS CONTRA MÚSCULO LISO DÉBILMENTE DETECTADOS"
  },
  {
    "codigo":703508009,
    "descripcion":"SÍNDROME DE MICROTIA, AUSENCIA DE RÓTULAS, MICROGNATIA"
  },
  {
    "codigo":898281003,
    "descripcion":"ANQUILOSIS CONGÉNITA DE ARTICULACIÓN METATARSOFALÁNGICA DE CUARTO DEDO DE PIE"
  },
  {
    "codigo":111849006,
    "descripcion":"BRONQUITIS POR ADENOVIRUS"
  },
  {
    "codigo":480837841000119108,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN DE TEJIDO PROFUNDO DE CODO IZQUIERDO"
  },
  {
    "codigo":77246000,
    "descripcion":"OLOR CORPORAL A FRUTA DULCE"
  },
  {
    "codigo":404926001,
    "descripcion":"POSICIÓN DE SEDESTACIÓN SIN APOYO"
  },
  {
    "codigo":110014005,
    "descripcion":"DECAPITACIÓN"
  },
  {
    "codigo":208318005,
    "descripcion":"FRACTURA NO EXPUESTA DE CÚBITO, EPÍFISIS INFERIOR"
  },
  {
    "codigo":1156755000,
    "descripcion":"INTOXICACIÓN CAUSADA POR SUSTANCIA GASEOSA"
  },
  {
    "codigo":42643001,
    "descripcion":"TRASTORNO DE VEJIGA URINARIA"
  },
  {
    "codigo":678251000119104,
    "descripcion":"QUISTE DE IMPLANTACIÓN BILATERAL EN CÁMARAS OCULARES ANTERIORES"
  },
  {
    "codigo":37801000087103,
    "descripcion":"TAQUIFAGIA"
  },
  {
    "codigo":403091007,
    "descripcion":"PIEDRA CAUSADA POR TRICHOSPORON BEIGELII"
  },
  {
    "codigo":75411009,
    "descripcion":"INTOXICACIÓN POR WEDELIA ASPERRIMA"
  },
  {
    "codigo":42921000087104,
    "descripcion":"QUEMADURA DE DEDO ÍNDICE IZQUIERDO"
  },
  {
    "codigo":11819371000119105,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN RADIOCARPIANA IZQUIERDA"
  },
  {
    "codigo":40361000087109,
    "descripcion":"HERIDA DE OÍDO EXTERNO DERECHO POR MORDEDURA"
  },
  {
    "codigo":302952007,
    "descripcion":"FÍSTULA CONGÉNITA DEL RECTO Y EL ANO"
  },
  {
    "codigo":202813002,
    "descripcion":"ANQUILOSIS ATLOAXOIDEA"
  },
  {
    "codigo":366653005,
    "descripcion":"HALLAZGO RELACIONADO CON EL ESPESOR DE LAS UÑAS"
  },
  {
    "codigo":364818002,
    "descripcion":"CONTROL DEL TRONCO-HALLAZGO"
  },
  {
    "codigo":233746005,
    "descripcion":"RUPTURA TRAUMÁTICA DEL DIAFRAGMA"
  },
  {
    "codigo":299282007,
    "descripcion":"AMPLITUD DE ADUCCIÓN PASIVA DE LA CADERA DISMINUIDA"
  },
  {
    "codigo":231911000,
    "descripcion":"VASCULARIZACIÓN CORNEAL SUPERFICIAL"
  },
  {
    "codigo":69906007,
    "descripcion":"DEPRANIDOTENIOSIS"
  },
  {
    "codigo":78341000119104,
    "descripcion":"FIMOSIS IATROGÉNICA"
  },
  {
    "codigo":428519006,
    "descripcion":"DEFECTO VENTILATORIO MIXTO, OBSTRUCTIVO Y RESTRICTIVO"
  },
  {
    "codigo":788967007,
    "descripcion":"DEGENERACIÓN MACULAR RELACIONADA CON LA EDAD INTERMEDIA"
  },
  {
    "codigo":361148000,
    "descripcion":"INTOXICACIÓN POR ANSIOLÍTICOS"
  },
  {
    "codigo":35303009,
    "descripcion":"HIPERTENSIÓN ESENCIAL BENIGNA QUE COMPLICA EL PUERPERIO Y\/O CONSTITUYE UN MOTIVO DE ATENCIÓN DURANTE ESTE PERÍODO"
  },
  {
    "codigo":295612003,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE TIOTEPA"
  },
  {
    "codigo":721596003,
    "descripcion":"CARCINOMA PAPILAR SÓLIDO IN SITU DE MAMA"
  },
  {
    "codigo":787132008,
    "descripcion":"METABOLIZADOR NORMAL-LENTO DE LA SUBUNIDAD 1 DEL COMPLEJO VITAMINA K-EPÓXIDO REDUCTASA"
  },
  {
    "codigo":457617003,
    "descripcion":"PERFORACIÓN DE VALVA DE VÁLVULA TRICÚSPIDE"
  },
  {
    "codigo":424849005,
    "descripcion":"SARCOMA PRIMARIO DE LA LENGUA"
  },
  {
    "codigo":293777009,
    "descripcion":"ALERGIA A ETOPÓSIDO"
  },
  {
    "codigo":193638002,
    "descripcion":"AMBLIOPÍA POR DEPRIVACIÓN DE ESTÍMULO"
  },
  {
    "codigo":128102001,
    "descripcion":"DEFECTO PLAQUETARIO FAMILIAR DE RECEPTOR ALFA>2< ADRENÉRGICO"
  },
  {
    "codigo":95334005,
    "descripcion":"ICTIOSIS SENIL"
  },
  {
    "codigo":160870005,
    "descripcion":"NIÑO EN GUARDA"
  },
  {
    "codigo":291942007,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR CLOFIBRATO"
  },
  {
    "codigo":716091000,
    "descripcion":"SÍNDROME DE HOLOPROSENCEFALIA Y POLIDACTILIA POSTAXIAL"
  },
  {
    "codigo":1240379000,
    "descripcion":"TRASTORNO NEONATAL PRECOZ DEBIDO A HEMORRAGIA MATERNOFETAL"
  },
  {
    "codigo":1142075009,
    "descripcion":"HIPERBILIRRUBINEMIA NEONATAL DEBIDA A INFECCIÓN VIRAL"
  },
  {
    "codigo":124432005,
    "descripcion":"DEFICIENCIA DE FOSFOSERINA FOSFATASA"
  },
  {
    "codigo":1269477001,
    "descripcion":"CON MAYOR RIESGO DE INFERTILIDAD FEMENINA"
  },
  {
    "codigo":417509001,
    "descripcion":"DISFUNCIÓN VISCERAL"
  },
  {
    "codigo":188133005,
    "descripcion":"NEOPLASIA MALIGNA DE PIEL DE LA PIERNA"
  },
  {
    "codigo":384741006,
    "descripcion":"NO ES POSIBLE DETERMINAR EL ESTADIO"
  },
  {
    "codigo":286437006,
    "descripcion":"PLANIFICA LAS COMIDAS"
  },
  {
    "codigo":253669006,
    "descripcion":"ORIGEN ANÓMALO DE CONDUCTO ARTERIOSO EN ARTERIA SUBCLAVIA"
  },
  {
    "codigo":284602001,
    "descripcion":"MOSTRARSE EN PÚBLICO"
  },
  {
    "codigo":415674000,
    "descripcion":"EL MARGEN QUIRÚRGICO DEL CONDUCTO BILIAR ES EL MARGEN NO AFECTADO MÁS CERCANO A LA NEOPLASIA MALIGNA"
  },
  {
    "codigo":87994004,
    "descripcion":"XEROCITOSIS"
  },
  {
    "codigo":353081000119103,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE RETINA DE OJO IZQUIERDO"
  },
  {
    "codigo":315535000,
    "descripcion":"NACIDO EN SUIZA"
  },
  {
    "codigo":413839001,
    "descripcion":"ENFERMEDAD PULMONAR CRÓNICA"
  },
  {
    "codigo":282767001,
    "descripcion":"LESIÓN TRAUMÁTICA DE DORSO DE TÓRAX"
  },
  {
    "codigo":1231204003,
    "descripcion":"OFTALMOPLEJÍA DEBIDA A SÍNDROME DE GUILLAIN-BARRÉ Y POSTERIOR A ÉL"
  },
  {
    "codigo":248164005,
    "descripcion":"ROPA SUCIA"
  },
  {
    "codigo":1263972006,
    "descripcion":"HEMORRAGIA INTRACRANEAL SUBDURAL FETAL"
  },
  {
    "codigo":84324009,
    "descripcion":"COLOR DE UNA COLONIA BACTERIANA"
  },
  {
    "codigo":705081005,
    "descripcion":"FRACTURA NO EXPUESTA DE PLACA EPIFISARIA DE FALANGE DE DEDO DE LA MANO"
  },
  {
    "codigo":279097006,
    "descripcion":"DOLOR LANCINANTE"
  },
  {
    "codigo":11821881000119108,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN DE LA REGIÓN DE MUÑECA DERECHA"
  },
  {
    "codigo":1090361000119108,
    "descripcion":"HEMORRAGIA GÁSTRICA DEBIDA A GASTRITIS PILÓRICA"
  },
  {
    "codigo":80654001,
    "descripcion":"PERITONITIS GRANULOMATOSA"
  },
  {
    "codigo":703246003,
    "descripcion":"OBSTRUCCIÓN ADQUIRIDA DE VENA PULMONAR"
  },
  {
    "codigo":736014004,
    "descripcion":"PRIVILEGIO MÉDICO"
  },
  {
    "codigo":766947001,
    "descripcion":"OBSTRUCCIÓN PROXIMAL COMPLETA DE AMBAS TROMPAS DE FALOPIO"
  },
  {
    "codigo":111587007,
    "descripcion":"INMUNODEFICIENCIA COMBINADA SEVERA POR AUSENCIA DEL RECEPTOR DE INTERLEUCINA 2"
  },
  {
    "codigo":44216000,
    "descripcion":"PRODUCTOS DE LA CONCEPCIÓN RETENIDOS, LUEGO DE PARTO CON HEMORRAGIA"
  },
  {
    "codigo":765112001,
    "descripcion":"EXCITACIÓN SEXUAL POR EXPOSICIÓN DE GENITALES A PERSONA PREPÚBER SIN CONSENTIMIENTO"
  },
  {
    "codigo":404664002,
    "descripcion":"GLIOMA ÓPTICO MALIGNO"
  },
  {
    "codigo":109752002,
    "descripcion":"FRACTURA DE CORONA DENTAL, ESMALTE Y DENTINA, SIN EXPOSICIÓN DE LA PULPA"
  },
  {
    "codigo":208056004,
    "descripcion":"FRACTURA VERTEBRAL NO EXPUESTA CON LESIÓN MEDULAR TOTAL A NIVEL LUMBAR"
  },
  {
    "codigo":240824005,
    "descripcion":"FILARIASIS OBSTRUCTIVA CRÓNICA POR BANCROFTLIAN"
  },
  {
    "codigo":238989000,
    "descripcion":"ERUPCIÓN MEDICAMENTOSA PITIRIASIFORME"
  },
  {
    "codigo":206221000,
    "descripcion":"LUXACIÓN VERTEBRAL POR TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":271757001,
    "descripcion":"ERUPCIÓN PAPULOSA"
  },
  {
    "codigo":304525005,
    "descripcion":"ÚTERO VACÍO"
  },
  {
    "codigo":10976211000119108,
    "descripcion":"HERIDA PENETRANTE DE OJO IZQUIERDO PROPIAMENTE DICHO"
  },
  {
    "codigo":370061007,
    "descripcion":"INVASIÓN TUMORAL DE CAPA MUSCULAR"
  },
  {
    "codigo":763277009,
    "descripcion":"TRISOMÍA DISTAL 8Q"
  },
  {
    "codigo":302690004,
    "descripcion":"ENCOPRESIS"
  },
  {
    "codigo":826978004,
    "descripcion":"CARCINOMA DUCTAL SÓLIDO IN SITU DE MAMA"
  },
  {
    "codigo":40546006,
    "descripcion":"DIETA HIPOSÓDICA, 90 MILIEQUIVALENTES"
  },
  {
    "codigo":300855001,
    "descripcion":"MASA DE ESTRUCTURA DIGESTIVA"
  },
  {
    "codigo":366391002,
    "descripcion":"HALLAZGO RELACIONADO CON LA AMPLITUD DE LA FLEXIÓN LATERAL IZQUIERDA DE LA COLUMNA CERVICAL"
  },
  {
    "codigo":169783009,
    "descripcion":"EXAMEN POSNATAL: HALLAZGO DE PROBLEMA MENOR"
  },
  {
    "codigo":397324002,
    "descripcion":"GLÁNDULA SUPRARRENAL NO COMPROMETIDA POR TUMOR RENAL"
  },
  {
    "codigo":299020005,
    "descripcion":"CREPITACIÓN PALPABLE DE ARTICULACIÓN DE MUÑECA"
  },
  {
    "codigo":266252006,
    "descripcion":"DISFUNCIÓN DEL MÚSCULO PAPILAR MITRAL"
  },
  {
    "codigo":725004007,
    "descripcion":"LESIÓN TRAUMÁTICA DE TENDÓN DE LA CABEZA"
  },
  {
    "codigo":167948009,
    "descripcion":"EXAMEN DE LÍQUIDO PLEURAL, ANORMAL"
  },
  {
    "codigo":723169001,
    "descripcion":"RETINOPATÍA DE BASE DEBIDA A ALTERACIÓN DE LA REGULACIÓN DE LA GLUCOSA"
  },
  {
    "codigo":67809006,
    "descripcion":"FUNCIÓN REPRODUCTIVA FEMENINA ANORMAL"
  },
  {
    "codigo":428257007,
    "descripcion":"FRACTURA DE PLATILLO TIBIAL"
  },
  {
    "codigo":295350000,
    "descripcion":"SOBREDOSIS DE ANTAGONISTAS DEL RECEPTOR H2"
  },
  {
    "codigo":229814002,
    "descripcion":"CALLO INTERDIGITAL"
  },
  {
    "codigo":65974003,
    "descripcion":"PERIOSTITIS ORBITARIA"
  },
  {
    "codigo":262582004,
    "descripcion":"QUEMADURA DE CARA"
  },
  {
    "codigo":721334002,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA COMPLETA DE OÍDO EXTERNO"
  },
  {
    "codigo":197046003,
    "descripcion":"INVAGINACIÓN GASTRODUODENAL"
  },
  {
    "codigo":1145483000,
    "descripcion":"HIPOPLASIA CONGÉNITA DE FALANGE DE DEDO MEDIO"
  },
  {
    "codigo":195211003,
    "descripcion":"SÍNDROME DE ARTERIA CEREBRAL POSTERIOR"
  },
  {
    "codigo":162443004,
    "descripcion":"EL SÍNTOMA DURA SEGUNDOS"
  },
  {
    "codigo":293515005,
    "descripcion":"REACCIÓN ADVERSA A AGENTE INOTRÓPICO CARDÍACO"
  },
  {
    "codigo":424587006,
    "descripcion":"RECIBIÓ EDUCACIÓN ESPECIAL EN LA INFANCIA"
  },
  {
    "codigo":129675007,
    "descripcion":"VÍCTIMA DE UN ACCIDENTE AUTOMOVILÍSTICO, CON UN SOLO VEHÍCULO INVOLUCRADO"
  },
  {
    "codigo":783200000,
    "descripcion":"NEUTROPENIA CONGÉNITA SEVERA AUTOSÓMICA RECESIVA DEBIDA A DEFICIENCIA DE RECEPTOR 2 DE MOTIVO C-X-C DE QUIMIOCINA"
  },
  {
    "codigo":226144002,
    "descripcion":"DIETA RICA EN NIACINA"
  },
  {
    "codigo":291680006,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR ISONIAZIDA"
  },
  {
    "codigo":1010741000,
    "descripcion":"DISPLASIA CORTICAL FOCAL CON DISTORSIÓN ESTRUCTURAL ANÓMALA DE CAPAS DE CORTEZA CEREBRAL EN LÓBULO TEMPORAL CON ATROFIA DE HIPOCAMPO BLUMCKE TIPO IIIA"
  },
  {
    "codigo":95072009,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE PIEL DE LABIO"
  },
  {
    "codigo":715829003,
    "descripcion":"SÍNDROME DE FASE DEL SUEÑO AVANZADA FAMILIAR"
  },
  {
    "codigo":93237004,
    "descripcion":"HIPOPLASIA CONGÉNITA DE VÁLVULA AÓRTICA"
  },
  {
    "codigo":289845009,
    "descripcion":"DOLOR A LA MOVILIZACIÓN DEL OVARIO"
  },
  {
    "codigo":224309009,
    "descripcion":"ASISTE A ESCUELA DE SEIS AÑOS (SISTEMA EDUCATIVO BRITÁNICO)"
  },
  {
    "codigo":124170004,
    "descripcion":"DEFICIENCIA DE D - ASPARTATO OXIDASA"
  },
  {
    "codigo":11797921000119103,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO ESQUELÉTICO DE PARED TORÁCICA"
  },
  {
    "codigo":419082008,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR ACEITE"
  },
  {
    "codigo":58634008,
    "descripcion":"EVALUACIÓN DE DISCAPACIDAD: ALTERACIÓN CLASE 9"
  },
  {
    "codigo":286175001,
    "descripcion":"HACE LA CAMA"
  },
  {
    "codigo":253407004,
    "descripcion":"ANOMALÍA EN ARCADA DE CUERDAS TENDINOSAS DE VÁLVULA MITRAL"
  },
  {
    "codigo":251572000,
    "descripcion":"DISMINUCIÓN DE LA AMPLITUD A BAJA FRECUENCIA (2-3 HZ)"
  },
  {
    "codigo":710324002,
    "descripcion":"ACINETOBACTER LWOFFII O ACINETOBACTER JUNII"
  },
  {
    "codigo":448180003,
    "descripcion":"ANEURISMA DE VENA SISTÉMICA"
  },
  {
    "codigo":302651000119100,
    "descripcion":"PELLIZCAMIENTO ANTERIOR DE PARTES BLANDAS SOBRE LOS DIENTES"
  },
  {
    "codigo":413577001,
    "descripcion":"SÍNDROME DE ABERTURA DE SALIDA TORÁCICA ARTERIAL DEBIDO A COSTILLA CERVICAL"
  },
  {
    "codigo":20361002,
    "descripcion":"ALTERACIÓN DEL BIENESTAR: DOLOR"
  },
  {
    "codigo":85897006,
    "descripcion":"HEMÓLISIS DE UNA COLONIA BACTERIANA, BETA"
  },
  {
    "codigo":11771451000119102,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE CODO IZQUIERDO"
  },
  {
    "codigo":282505009,
    "descripcion":"CAPAZ DE CORRER BARRANCA ABAJO"
  },
  {
    "codigo":84062004,
    "descripcion":"OSTEOCONDROSIS JUVENIL DE HUESO SEMILUNAR DEL CARPO"
  },
  {
    "codigo":1296478004,
    "descripcion":"HIPERTENSIÓN OCULAR DE OJO IZQUIERDO CAUSADA POR ACEITE DE SILICONA"
  },
  {
    "codigo":247902008,
    "descripcion":"QUIETUD"
  },
  {
    "codigo":18526009,
    "descripcion":"TRASTORNO DEL APÉNDICE ILEOCECAL"
  },
  {
    "codigo":51294009,
    "descripcion":"ACIDOSIS METABÓLICA, BRECHA ANIÓNICA AUMENTADA, ACUMULACIÓN DE ÁCIDOS ORGÁNICOS"
  },
  {
    "codigo":368451000119100,
    "descripcion":"ENFERMEDAD RENAL CRÓNICA ESTADIO 4 DEBIDA A DIABETES MELLITUS MEDICAMENTOSA"
  },
  {
    "codigo":678211000119100,
    "descripcion":"RUBEOSIS DEL IRIS DEL OJO DERECHO"
  },
  {
    "codigo":10692931000119102,
    "descripcion":"ÚLCERA CUTÁNEA DEBIDA A VENAS VARICOSAS"
  },
  {
    "codigo":11773251000119102,
    "descripcion":"RUPTURA TRAUMÁTICA DE LIGAMENTO RADIAL COLATERAL DE CODO IZQUIERDO"
  },
  {
    "codigo":724003651000119103,
    "descripcion":"GLIOMA MALIGNO PRIMARIO DE TÁLAMO"
  },
  {
    "codigo":340291000119103,
    "descripcion":"IRIDODIÁLISIS DE OJO IZQUIERDO"
  },
  {
    "codigo":1085251000119106,
    "descripcion":"FÍSTULA DE INTESTINO GRUESO DEBIDA A RECTOSIGMOIDITIS ULCEROSA CRÓNICA"
  },
  {
    "codigo":15864131000119107,
    "descripcion":"ANOMALÍA CONGÉNITA DE OÍDO IZQUIERDO"
  },
  {
    "codigo":15912771000119108,
    "descripcion":"ECTROPIÓN SENIL DE AMBOS PÁRPADOS"
  },
  {
    "codigo":307011000119108,
    "descripcion":"INFRALLENADO ENDODÓNCICO"
  },
  {
    "codigo":309768006,
    "descripcion":"DOLOR CAUSADO POR PRÓTESIS ARTICULAR DE HOMBRO"
  },
  {
    "codigo":16419651000119103,
    "descripcion":"DEPENDENCIA DE VENTILACIÓN CON PRESIÓN POSITIVA BIFÁSICA EN LA VÍA AÉREA DEBIDA A SÍNDROME DE APNEA DEL SUEÑO DE CAUSA CENTRAL"
  },
  {
    "codigo":213299007,
    "descripcion":"DOLOR POSOPERATORIO"
  },
  {
    "codigo":122691000119106,
    "descripcion":"CONDROCALCINOSIS DE ARTICULACIÓN DE LA CADERA DEBIDA A TRASTORNO DEL METABOLISMO DEL CALCIO"
  },
  {
    "codigo":11801411000119105,
    "descripcion":"LESIÓN TRAUMÁTICA DE RIÑÓN DERECHO"
  },
  {
    "codigo":16903491000119107,
    "descripcion":"MENINGIOMA ATÍPICO DE MÉDULA ESPINAL"
  },
  {
    "codigo":12400341000119100,
    "descripcion":"DOLOR CRÓNICO POSTERIOR A ARTROPLASTIA TOTAL DE RODILLA DERECHA"
  },
  {
    "codigo":111325003,
    "descripcion":"DIENTES DE HORNER"
  },
  {
    "codigo":209629006,
    "descripcion":"DESGARRO COMPLETO DE LIGAMENTO CRUZADO ANTERIOR DE LA RODILLA"
  },
  {
    "codigo":76722000,
    "descripcion":"RUPTURA FAMILIAR SIN DIVORCIO"
  },
  {
    "codigo":371634002,
    "descripcion":"CADÁVER AL QUE SE LE HAN PRACTICADO NO MENOS DE TRES AUTOPSIAS"
  },
  {
    "codigo":240562003,
    "descripcion":"ERUPCIÓN SIFILÍTICA PUSTULOSA"
  },
  {
    "codigo":764850002,
    "descripcion":"ENFERMEDAD DE CHARCOT-MARIE-TOOTH AUTOSÓMICA DOMINANTE TIPO 2A2"
  },
  {
    "codigo":43954004,
    "descripcion":"SACUDIR DE CABEZA"
  },
  {
    "codigo":207794006,
    "descripcion":"FRACTURA NO EXPUESTA DE ALVÉOLO"
  },
  {
    "codigo":699314009,
    "descripcion":"MIGRAÑA CON AURA VISUAL PERSISTENTE"
  },
  {
    "codigo":109490009,
    "descripcion":"HIPOMINERALIZACIÓN LOCALIZADA DEL ESMALTE ASOCIADA CON INFECCIÓN LOCALIZADA"
  },
  {
    "codigo":16824021000119104,
    "descripcion":"NEOPLASIA NEUROENDOCRINA MALIGNA PRIMARIA DE ÚTERO"
  },
  {
    "codigo":202289003,
    "descripcion":"CONTRACTURA EN FLEXIÓN DE LA RODILLA"
  },
  {
    "codigo":235057006,
    "descripcion":"INFECCIÓN BUCAL RECURRENTE POR HERPES SIMPLE"
  },
  {
    "codigo":169521006,
    "descripcion":"PREPARADOS ANTICONCEPTIVOS DE LIBERACIÓN LENTA - SIN PROBLEMAS"
  },
  {
    "codigo":890417008,
    "descripcion":"COLOBOMA PALPEBRAL CONGÉNITO BILATERAL"
  },
  {
    "codigo":167686003,
    "descripcion":"SACAROSA DETECTADA EN ESPÉCIMEN DE MATERIA FECAL ANALIZADO MEDIANTE CROMATOGRAFÍA"
  },
  {
    "codigo":16905941000119109,
    "descripcion":"CARCINOMA DE CÉLULAS DE MERKEL PRIMARIO DE PIEL DE PÁRPADO SUPERIOR DERECHO"
  },
  {
    "codigo":298758005,
    "descripcion":"HALLAZGO RELACIONADO CON EL TAMAÑO DEL OMÓPLATO"
  },
  {
    "codigo":3951000119103,
    "descripcion":"APOFISITIS DE EPITRÓCLEA HUMERAL DEBIDA A USO EXCESIVO"
  },
  {
    "codigo":724742003,
    "descripcion":"TRASTORNO DE CONDUCTA ANTISOCIAL DE COMIENZO EN LA ADOLESCENCIA CON EMOCIONES PROSOCIALES NORMALES"
  },
  {
    "codigo":397062007,
    "descripcion":"ANILLOS DE CABOT"
  },
  {
    "codigo":36614009,
    "descripcion":"PARA 8"
  },
  {
    "codigo":165851002,
    "descripcion":"FACTOR ANTINUCLEAR NEGATIVO"
  },
  {
    "codigo":1148891004,
    "descripcion":"MASTOCITOSIS CUTÁNEA AMPOLLAR DIFUSA"
  },
  {
    "codigo":722907006,
    "descripcion":"CONTUSIÓN DE CEREBELO DEBIDA A TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":65712000,
    "descripcion":"SIN CONFIRMACIÓN MICROSCÓPICA: TUMOR CLÍNICAMENTE BENIGNO"
  },
  {
    "codigo":721072003,
    "descripcion":"SÍNDROME DE BAJA ESTATURA, DEFECTO HIPOFISARIO Y DEL CEREBELO Y SILLA TURCA PEQUEÑA"
  },
  {
    "codigo":1343664003,
    "descripcion":"EPILEPSIA DE LÓBULO TEMPORAL MESIAL"
  },
  {
    "codigo":194949003,
    "descripcion":"MIOCARDITIS AGUDA - TUBERCULOSA"
  },
  {
    "codigo":293253004,
    "descripcion":"REACCIÓN ADVERSA AL FOSFESTROL"
  },
  {
    "codigo":162181003,
    "descripcion":"MOLESTIA VAGINAL"
  },
  {
    "codigo":193114000,
    "descripcion":"SÍNDROME DE LA EXTREMIDAD FANTASMA"
  },
  {
    "codigo":62042001,
    "descripcion":"FUSIÓN ESPLENOGONADAL"
  },
  {
    "codigo":94810003,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE CONDUCTO CÍSTICO"
  },
  {
    "codigo":289583003,
    "descripcion":"LOQUIOS ACUOSOS"
  },
  {
    "codigo":92975004,
    "descripcion":"AUSENCIA CONGÉNITA DE LA PAPILA RENAL"
  },
  {
    "codigo":846639005,
    "descripcion":"BRONQUITIS CAUSADA POR VAPOR"
  },
  {
    "codigo":25604001,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO CIÁTICO POPLÍTEO EXTERNO"
  },
  {
    "codigo":123908001,
    "descripcion":"INTOXICACIÓN POR GERANIÁCEAS"
  },
  {
    "codigo":1010479009,
    "descripcion":"AGENESIA DE FALANGE MEDIA DE DEDO ANULAR"
  },
  {
    "codigo":713732008,
    "descripcion":"INFECCIÓN CAUSADA POR ASPERGILLUS CONCOMITANTE CON INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":449753006,
    "descripcion":"PUNTO DE PRESIÓN CUTÁNEA"
  },
  {
    "codigo":447918000,
    "descripcion":"HÍGADO EN EL LADO DERECHO"
  },
  {
    "codigo":284078000,
    "descripcion":"ERUPCIÓN PURPÚRICA"
  },
  {
    "codigo":285913008,
    "descripcion":"UTILIZA INSTALACIONES PARA LAVAR"
  },
  {
    "codigo":185774002,
    "descripcion":"CONTROL GERIÁTRICO REALIZADO"
  },
  {
    "codigo":415150004,
    "descripcion":"DIETA PROGRESIVA POSQUIRÚRGICA"
  },
  {
    "codigo":282243008,
    "descripcion":"NO CAMINA HACIA ATRÁS ARRASTRANDO UN JUGUETE GRANDE"
  },
  {
    "codigo":83800001,
    "descripcion":"DESDOBLAMIENTO INVERTIDO DEL PRIMER RUIDO CARDÍACO, R>1<"
  },
  {
    "codigo":444248002,
    "descripcion":"UVEÍTIS CRÓNICA"
  },
  {
    "codigo":247640008,
    "descripcion":"INCAPACIDAD DE PENSAR CLARAMENTE"
  },
  {
    "codigo":278573004,
    "descripcion":"CORONA DENTAL MUY ESTRECHA"
  },
  {
    "codigo":442413005,
    "descripcion":"MONOPLEJÍA TRANSITORIA"
  },
  {
    "codigo":737325005,
    "descripcion":"EMBOLIA POSTERIOR A EMBARAZO MOLAR Y DEBIDA A ÉL"
  },
  {
    "codigo":16429005,
    "descripcion":"LARVA MIGRATORIA CUTÁNEA CAUSADA POR ANCYLOSTOMA BRAZILIENSE"
  },
  {
    "codigo":47362003,
    "descripcion":"TRASTORNO DEL MOVIMIENTO INDUCIDO POR MEDICAMENTO"
  },
  {
    "codigo":1259778008,
    "descripcion":"SIRINGOMA CONDROIDE PRIMARIO MALIGNO DE PIEL"
  },
  {
    "codigo":735490009,
    "descripcion":"INFECCIÓN DEL TRACTO GENITAL DEBIDA A EMBARAZO MOLAR Y POSTERIOR A ÉL"
  },
  {
    "codigo":307671001,
    "descripcion":"NISTAGMO CONGÉNITO SIN ANOMALÍA SENSITIVA"
  },
  {
    "codigo":274903001,
    "descripcion":"CILINDROMA DÉRMICO ECRINO"
  },
  {
    "codigo":276738009,
    "descripcion":"CARCINOMA PRIMARIO DE CÉLULAS EN ANILLO DE SELLO DE LA PIEL"
  },
  {
    "codigo":209367004,
    "descripcion":"FRACTURA-LUXACIÓN EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA DE UN SOLO DEDO DEL PIE"
  },
  {
    "codigo":405975008,
    "descripcion":"ESTADIO I DEL GRUPO NACIONAL PARA EL ESTUDIO DEL TUMOR DE WILMS"
  },
  {
    "codigo":45527008,
    "descripcion":"ARTICULACIÓN DE CADERA INESTABLE"
  },
  {
    "codigo":830124002,
    "descripcion":"ELEVACIÓN DE PIERNA DERECHA EXTENDIDA DISMINUIDA"
  },
  {
    "codigo":43692000,
    "descripcion":"INFECCIÓN AGUDA DE LAS VÍAS RESPIRATORIAS SUPERIORES POR INFLUENZA"
  },
  {
    "codigo":305836004,
    "descripcion":"VISTO EN EL SERVICIO DE MICROBIOLOGÍA MÉDICA"
  },
  {
    "codigo":240300005,
    "descripcion":"PROBLEMA CON LA LACTANCIA ARTIFICIAL DEL RECIÉN NACIDO"
  },
  {
    "codigo":404140004,
    "descripcion":"LINFOMA CUTÁNEO PRIMARIO DE CÉLULAS B DE LA ZONA MARGINAL"
  },
  {
    "codigo":369537003,
    "descripcion":"TUMOR MALIGNO QUE COMPROMETE EL LIGAMENTO ANCHO IZQUIERDO POR PROPAGACIÓN DIRECTA DEL OVARIO"
  },
  {
    "codigo":402305008,
    "descripcion":"URTICARIA DE CONTACTO NO INMUNOLÓGICA"
  },
  {
    "codigo":302166001,
    "descripcion":"URTICARIA POR FRÍO CON AGLUTININAS"
  },
  {
    "codigo":236630004,
    "descripcion":"CISTITIS QUÍMICA"
  },
  {
    "codigo":334141000119109,
    "descripcion":"ECTROPIÓN MECÁNICO DE PÁRPADO INFERIOR DERECHO"
  },
  {
    "codigo":300331000,
    "descripcion":"LESIÓN DE HÍGADO"
  },
  {
    "codigo":365867006,
    "descripcion":"HALLAZGO RELACIONADO CON EL ESTADO LEGAL DEL PACIENTE"
  },
  {
    "codigo":1119531008,
    "descripcion":"PREFERENCIA DE MIRADA"
  },
  {
    "codigo":724480003,
    "descripcion":"TRASTORNO FUNCIONAL DE VEJIGA URINARIA DEBIDO A PROLAPSO DE ÓRGANO GENITAL FEMENINO"
  },
  {
    "codigo":16583281000119101,
    "descripcion":"ARTROSIS DE TOBILLO IZQUIERDO DEBIDA A TRAUMATISMO"
  },
  {
    "codigo":820949005,
    "descripcion":"PIEL CALIENTE SOBRE LESIÓN"
  },
  {
    "codigo":427733005,
    "descripcion":"PIEL FRESCA"
  },
  {
    "codigo":722645005,
    "descripcion":"LACERACIÓN MAYOR DE VENA YUGULAR EXTERNA"
  },
  {
    "codigo":294826000,
    "descripcion":"ALERGIA A OCTREOTIDA"
  },
  {
    "codigo":296661005,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE CARBENICILINA"
  },
  {
    "codigo":196522008,
    "descripcion":"ESTENOSIS DE CONDUCTO SUBMANDIBULAR"
  },
  {
    "codigo":292991004,
    "descripcion":"REACCIÓN ADVERSA A LA COLISTINA"
  },
  {
    "codigo":1144959007,
    "descripcion":"ULCERACIÓN DE ESCROTO DEBIDA A ENFERMEDAD DE BEHCET"
  },
  {
    "codigo":127316003,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA ARTERIA CÓLICA DERECHA"
  },
  {
    "codigo":94548004,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA PIEL DEL MENTÓN"
  },
  {
    "codigo":61780005,
    "descripcion":"EFECTO TÓXICO DEL FORATO"
  },
  {
    "codigo":291156008,
    "descripcion":"INTOXICACIÓN POR DIFENILBUTILPIPERIDINA"
  },
  {
    "codigo":782676009,
    "descripcion":"TRISOMÍA DISTAL 18Q"
  },
  {
    "codigo":289321002,
    "descripcion":"MUÑÓN UMBILICAL ADHERIDO"
  },
  {
    "codigo":1010217004,
    "descripcion":"SUBLUXACIÓN CONGÉNITA DE CADERA DERECHA"
  },
  {
    "codigo":92713007,
    "descripcion":"CARCINOMA IN SITU DE LA PIEL DE LA ESPALDA"
  },
  {
    "codigo":1336062006,
    "descripcion":"EPISODIO DE USO NOCIVO DE CANNABIS"
  },
  {
    "codigo":123646006,
    "descripcion":"ALTERACIONES CROMOSÓMICAS DEL GRUPO A"
  },
  {
    "codigo":254718006,
    "descripcion":"TUMOR DE LOS CONDUCTOS DÉRMICOS ECRINOS"
  },
  {
    "codigo":711635006,
    "descripcion":"TEJIDO PERIAPICAL NORMAL"
  },
  {
    "codigo":447656001,
    "descripcion":"LINFOMA DE PÍLORO"
  },
  {
    "codigo":283816002,
    "descripcion":"MORDEDURA DE ANIMAL EN EL TÓRAX"
  },
  {
    "codigo":773501006,
    "descripcion":"EPIDERMÓLISIS BULLOSA SIMPLE DEBIDA A DEFICIENCIA DE BP230"
  },
  {
    "codigo":11805451000119108,
    "descripcion":"SUBLUXACIÓN DE ARTICULACIÓN INTERFALÁNGICA PROXIMAL DE DEDO MEDIO DE MANO DERECHA"
  },
  {
    "codigo":116306000,
    "descripcion":"HALLAZGO RELACIONADO CON LA COLUMNA LUMBAR"
  },
  {
    "codigo":249213009,
    "descripcion":"HALLAZGO RELACIONADO CON LA CONSISTENCIA DE LOS LOQUIOS"
  },
  {
    "codigo":50770000,
    "descripcion":"ABORTO ESPONTÁNEO CON SÍNDROME DE DESFIBRINACIÓN"
  },
  {
    "codigo":312914000,
    "descripcion":"MASA TELANGIECTÁSICA RETINIANA PERIFÉRICA"
  },
  {
    "codigo":310181000119104,
    "descripcion":"ARTRITIS GOTOSA DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":81703003,
    "descripcion":"MASTICA TABACO"
  },
  {
    "codigo":704295007,
    "descripcion":"CON MAYOR RIESGO DE ESTADO DE ÁNIMO DEPRIMIDO"
  },
  {
    "codigo":1259516001,
    "descripcion":"CARCINOMA PRIMARIO DE EXOCÉRVIX"
  },
  {
    "codigo":309244002,
    "descripcion":"AUSENCIA DE RÓTULA"
  },
  {
    "codigo":473084003,
    "descripcion":"INFECCIÓN ASOCIADA CON IMPLANTE VASCULAR"
  },
  {
    "codigo":47100003,
    "descripcion":"ANEMIA DEL PREMATURO"
  },
  {
    "codigo":767996002,
    "descripcion":"HERNIA FEMORAL IZQUIERDA OBSTRUIDA CON GANGRENA"
  },
  {
    "codigo":407548008,
    "descripcion":"FILTRACIÓN DE BOLSA DE OSTOMÍA"
  },
  {
    "codigo":45265000,
    "descripcion":"POIQUILODERMIA DE CIVATTE"
  },
  {
    "codigo":307409006,
    "descripcion":"DEDO DE LA MANO ISQUÉMICO"
  },
  {
    "codigo":438481007,
    "descripcion":"SÍNDROME POSOPERATORIO DE MÉDULA ESPINAL ANCLADA"
  },
  {
    "codigo":241873008,
    "descripcion":"EFECTO TÓXICO CAUSADO POR BETÚN"
  },
  {
    "codigo":733393009,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA TOTAL DE VULVA"
  },
  {
    "codigo":240038002,
    "descripcion":"INFECCIÓN DE LA VAINA TENDINOSA"
  },
  {
    "codigo":10662001,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN LA REGIÓN DE LA CARA, CON INFECCIÓN"
  },
  {
    "codigo":305574004,
    "descripcion":"BAJO ATENCIÓN DE ENFERMERA EXTRAHOSPITALARIA"
  },
  {
    "codigo":16667711000119102,
    "descripcion":"FRACTURA NO EXPUESTA DE ARCO CIGOMÁTICO IZQUIERDO"
  },
  {
    "codigo":371110006,
    "descripcion":"INMADUREZ OCULAR"
  },
  {
    "codigo":403878007,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS INTRAEPIDÉRMICO DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":1286779006,
    "descripcion":"CONJUNTIVITIS CAUSADA POR MYCOBACTERIUM TUBERCULOSIS"
  },
  {
    "codigo":762491008,
    "descripcion":"BAJO PESO EN LA INFANCIA"
  },
  {
    "codigo":205435009,
    "descripcion":"ESPONDILOSINDESIS DE LA COLUMNA VERTEBRAL TOTAL CONGÉNITA"
  },
  {
    "codigo":301904004,
    "descripcion":"HALLAZGO RELACIONADO CON OBSERVACIÓN GENERAL DEL OJO"
  },
  {
    "codigo":300069000,
    "descripcion":"FUSIÓN DE VULVA"
  },
  {
    "codigo":1186640009,
    "descripcion":"ÚLCERA POR PRESIÓN DE REGIÓN DORSAL DE LA ESPALDA"
  },
  {
    "codigo":365605003,
    "descripcion":"HALLAZGO EN LA MEDICIÓN CORPORAL"
  },
  {
    "codigo":70693003,
    "descripcion":"CON MAYOR RIESGO DE ALTERACIÓN EN INTEGRIDAD DE PIEL"
  },
  {
    "codigo":234533006,
    "descripcion":"AGAMMAGLOBULINEMIA LIGADA AL CROMOSOMA X CON DEFICIENCIA DE HORMONA DE CRECIMIENTO"
  },
  {
    "codigo":37925008,
    "descripcion":"MIOCARDITIS INTERSTICIAL"
  },
  {
    "codigo":429306002,
    "descripcion":"NEOPLASIA BENIGNA DEL ESPACIO INTRADURAL DE LA MÉDULA ESPINAL"
  },
  {
    "codigo":119871000119109,
    "descripcion":"INFECCIÓN CAUSADA POR ABIOTROPHIA"
  },
  {
    "codigo":298234007,
    "descripcion":"COLUMNA CERVICAL RÍGIDA"
  },
  {
    "codigo":789754007,
    "descripcion":"TENDINITIS DE TENDÓN DE MANGUITO ROTADOR"
  },
  {
    "codigo":722383001,
    "descripcion":"SÍNDROME DE CATEL MANZKE"
  },
  {
    "codigo":34255001,
    "descripcion":"ÚLCERA GINGIVAL SUPERFICIAL"
  },
  {
    "codigo":787919004,
    "descripcion":"LEVADURA NO CRYPTOCOCCUS NEOFORMANS DETECTADA"
  },
  {
    "codigo":296399005,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE ATROPINA"
  },
  {
    "codigo":1076441000119105,
    "descripcion":"BURSITIS RETROCALCÁNEA DE PIE IZQUIERDO"
  },
  {
    "codigo":67023009,
    "descripcion":"LINFOCITOSIS"
  },
  {
    "codigo":1179300002,
    "descripcion":"ENFERMEDAD BENTA"
  },
  {
    "codigo":65188003,
    "descripcion":"VENOESPASMO"
  },
  {
    "codigo":294564005,
    "descripcion":"ALERGIA A MONOBACTAM"
  },
  {
    "codigo":16641241000119106,
    "descripcion":"NEURITIS ILIOINGUINAL BILATERAL"
  },
  {
    "codigo":718713000,
    "descripcion":"SÍNDROME DE MIOCARDIOPATÍA HIPERTRÓFICA CON HIPOTONÍA Y ACIDOSIS LÁCTICA"
  },
  {
    "codigo":292729002,
    "descripcion":"REACCIÓN ADVERSA A ANTICUERPOS ESPECÍFICOS ANTIDIGOXINA"
  },
  {
    "codigo":1144697009,
    "descripcion":"APLASIA DE FALANGE MEDIA DE TERCER DEDO DE PIE"
  },
  {
    "codigo":290894002,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR PAROXETINA"
  },
  {
    "codigo":127054006,
    "descripcion":"ENFERMEDAD POR CRIOAGLUTININAS DEBIDA A INFECCIÓN POR VIRUS DE EPSTEIN-BARR Y POSTERIOR A ELLA"
  },
  {
    "codigo":421966007,
    "descripcion":"COMA NO CETÓSICO NI HIPEROSMOLAR DEBIDO A DIABETES MELLITUS"
  },
  {
    "codigo":782414008,
    "descripcion":"INTOLERANCIA AL GLICEROL"
  },
  {
    "codigo":94286009,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL ESÓFAGO"
  },
  {
    "codigo":16671000146104,
    "descripcion":"NECESITA AYUDA PARA ACTIVIDADES DE CUIDADO BUCAL"
  },
  {
    "codigo":190755005,
    "descripcion":"SACAROSURIA"
  },
  {
    "codigo":715043007,
    "descripcion":"NO LIMPIA AGUJAS"
  },
  {
    "codigo":92451008,
    "descripcion":"NEOPLASIA BENIGNA DEL NERVIO TRIGÉMINO"
  },
  {
    "codigo":385528001,
    "descripcion":"QUEMADURA DE LA PIEL POR ACEITE CALIENTE"
  },
  {
    "codigo":90616004,
    "descripcion":"ALCALOSIS RESPIRATORIA CRÓNICA"
  },
  {
    "codigo":1237496004,
    "descripcion":"METÁSTASIS DE CARCINOMA DE SUBGLOTIS"
  },
  {
    "codigo":254456006,
    "descripcion":"NEOPLASIA BENIGNA DE SURCO LABIAL INFERIOR"
  },
  {
    "codigo":711373003,
    "descripcion":"HALLAZGO RELACIONADO CON ÓRGANO TORACOABDOMINAL"
  },
  {
    "codigo":1268429005,
    "descripcion":"PÉRDIDA DE AUDICIÓN CONDUCTIVA DE ALTA FRECUENCIA"
  },
  {
    "codigo":1137357005,
    "descripcion":"COMA HEPÁTICO DEBIDO A HEPATITIS D"
  },
  {
    "codigo":285389008,
    "descripcion":"DOLOR TORÁCICO SUPERIOR"
  },
  {
    "codigo":185250001,
    "descripcion":"ATENDIDO EN CONSULTORIO ESPECIALIZADO EN TRASTORNOS RENALES"
  },
  {
    "codigo":56013008,
    "descripcion":"DUPLICACIÓN CONGÉNITA DE VÍA BILIAR"
  },
  {
    "codigo":414626005,
    "descripcion":"LINFANGIOMA DE ÓRBITA"
  },
  {
    "codigo":283554008,
    "descripcion":"HERIDA DE PERDIGÓN EN MEJILLA"
  },
  {
    "codigo":707703001,
    "descripcion":"CARCINOMA PRIMARIO DE CÉLULAS ESCAMOSAS DE REGIÓN POSCRICOIDEA"
  },
  {
    "codigo":447394009,
    "descripcion":"FRACTURA SUPRACONDÍLEA CONMINUTA NO EXPUESTA DE FÉMUR"
  },
  {
    "codigo":609399004,
    "descripcion":"CON MAYOR RIESGO DE CARIES DENTAL"
  },
  {
    "codigo":83276000,
    "descripcion":"LESIÓN TRAUMÁTICA DE ÚTERO CON HERIDA ABIERTA HACIA CAVIDAD ABDOMINAL"
  },
  {
    "codigo":278049001,
    "descripcion":"REFLEJO TÓNICO CERVICAL ASIMÉTRICO - HALLAZGO"
  },
  {
    "codigo":1078951000119101,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE LÓBULO MEDIO DEL PULMÓN DERECHO"
  },
  {
    "codigo":1162785009,
    "descripcion":"INFARTO HEMORRÁGICO"
  },
  {
    "codigo":14070001,
    "descripcion":"DEMENCIA MULTINFARTO CON DEPRESIÓN"
  },
  {
    "codigo":210678002,
    "descripcion":"LESIÓN POR DESOLLAMIENTO DE MUSLO"
  },
  {
    "codigo":15932941000119109,
    "descripcion":"OBSTRUCCIÓN PARCIAL DE AMBAS TROMPAS UTERINAS"
  },
  {
    "codigo":472822008,
    "descripcion":"FIEBRE EXANTEMÁTICA DEL LEJANO ORIENTE"
  },
  {
    "codigo":733131001,
    "descripcion":"INFECCIÓN DE SISTEMA MUSCULOESQUELÉTICO CAUSADA POR NEISSERIA GONORRHOEAE"
  },
  {
    "codigo":208843007,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA NO EXPUESTA DE HUESO SEMILUNAR (PALMAR)"
  },
  {
    "codigo":403616000,
    "descripcion":"VASCULITIS LINFOCÍTICA MEDICAMENTOSA"
  },
  {
    "codigo":11784001000119100,
    "descripcion":"HERIDA INFECTADA DE MUSLO IZQUIERDO DEBIDA A PICADURA DE INSECTO NO VENENOSO"
  },
  {
    "codigo":272544008,
    "descripcion":"POSICIÓN SEMIARRODILLADA INCLINADA HACIA ADELANTE"
  },
  {
    "codigo":698528008,
    "descripcion":"ATENDIDO EN CONSULTORIO ESPECIALIZADO EN MEDICINA NUCLEAR"
  },
  {
    "codigo":237941007,
    "descripcion":"DEFICIENCIA DE ÁCIDO GAMMA-AMINOBUTÍRICO TRANSAMINASA"
  },
  {
    "codigo":1055306001,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE EXTREMIDAD INFERIOR DERECHA A TRAVÉS DE LA RODILLA"
  },
  {
    "codigo":236106002,
    "descripcion":"ESTENOSIS ANASTOMÓTICA GÁSTRICA"
  },
  {
    "codigo":1153610005,
    "descripcion":"LESIÓN TRAUMÁTICA DE DORSO DE CUELLO Y TRONCO"
  },
  {
    "codigo":399946006,
    "descripcion":"ENFERMEDAD DE CROHN DE PIEL"
  },
  {
    "codigo":267039000,
    "descripcion":"TUMEFACCIÓN DE TOBILLO"
  },
  {
    "codigo":203338008,
    "descripcion":"ENFERMEDAD DE PAGET DE METACARPIANO"
  },
  {
    "codigo":430879002,
    "descripcion":"DOLOR AURICULAR POSTERIOR"
  },
  {
    "codigo":201503001,
    "descripcion":"ARTRITIS REACTIVA DE ARTICULACIÓN DE TOBILLO Y\/O PIE DEBIDA A DISENTERÍA Y POSTERIOR A ELLA"
  },
  {
    "codigo":1350218008,
    "descripcion":"INMUNODEFICIENCIA COMBINADA AUTOSÓMICA DOMINANTE DEBIDA A DEFICIENCIA DEL GEN AIOLOS"
  },
  {
    "codigo":365343006,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA UTILIZAR COMODIDADES LOCALES"
  },
  {
    "codigo":299807006,
    "descripcion":"REFLEJO MASETÉRICO NORMAL"
  },
  {
    "codigo":232436000,
    "descripcion":"EDEMA DE REINKE"
  },
  {
    "codigo":363508008,
    "descripcion":"NEOPLASIA MALIGNA DE INTESTINO"
  },
  {
    "codigo":230601003,
    "descripcion":"NEUROPATÍA EN TROMBOANGEÍTIS OBLITERANTE"
  },
  {
    "codigo":296137004,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE HIDRATO DE CLORAL"
  },
  {
    "codigo":315201000119109,
    "descripcion":"OSTEOCONDRITIS DISECANTE DE REGIÓN DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":16836571000119103,
    "descripcion":"EMBARAZO TUBARIO ROTO DE TROMPA DE FALOPIO IZQUIERDA"
  },
  {
    "codigo":94024000,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA PIEL DEL PIE"
  },
  {
    "codigo":1144435009,
    "descripcion":"VÁRICES VENOSAS DE PERINEO EN EL EMBARAZO"
  },
  {
    "codigo":95859009,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DEL PIE"
  },
  {
    "codigo":421704003,
    "descripcion":"CLASIFICACIÓN DE LA ASOCIACIÓN CARDIOLÓGICA DE NUEVA YORK - CLASE II"
  },
  {
    "codigo":290632004,
    "descripcion":"INTOXICACIÓN POR DACARBAZINA"
  },
  {
    "codigo":126792007,
    "descripcion":"NEOPLASIA DE LA ENCÍA"
  },
  {
    "codigo":28488007,
    "descripcion":"HIPERQUERATOSIS LENTICULAR PERSISTENTE"
  },
  {
    "codigo":288797004,
    "descripcion":"NO HACE PREGUNTAS"
  },
  {
    "codigo":92189008,
    "descripcion":"NEOPLASIA BENIGNA DE LA ENCÍA INFERIOR"
  },
  {
    "codigo":1204466001,
    "descripcion":"GASTRITIS CON SEPSIS"
  },
  {
    "codigo":254194001,
    "descripcion":"EPIDERMÓLISIS BULLOSA DE LA UNIÓN GENERALIZADA"
  },
  {
    "codigo":11812981000119103,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE ÓRGANO GENITAL FEMENINO"
  },
  {
    "codigo":344181000119103,
    "descripcion":"QUERATITIS PUNTEADA BILATERAL"
  },
  {
    "codigo":90354008,
    "descripcion":"COMPLICACIÓN POR LA COLOCACIÓN DE UN DISPOSITIVO INTERNO"
  },
  {
    "codigo":448967000,
    "descripcion":"OSTEOCONDRITIS DISECANTE DE HUESO DEL TARSO"
  },
  {
    "codigo":840348000,
    "descripcion":"TIRAS DE COLLIER"
  },
  {
    "codigo":86684002,
    "descripcion":"BRADIPNEA"
  },
  {
    "codigo":1004188005,
    "descripcion":"NIVEL DE ÁCIDO 3-HIDROXIDICARBOXÍLICO EN ORINA AUMENTADO"
  },
  {
    "codigo":19313000,
    "descripcion":"PERMEABILIDAD VASCULAR AUMENTADA"
  },
  {
    "codigo":248689000,
    "descripcion":"SOPLO DE LA DERIVACIÓN"
  },
  {
    "codigo":84849002,
    "descripcion":"TIÑA DEL CUERPO"
  },
  {
    "codigo":289416004,
    "descripcion":"FONTANELA ANTERIOR PALPABLE EN LA REGIÓN CENTRAL"
  },
  {
    "codigo":1231729008,
    "descripcion":"QUISTE EPITELIAL ORBITARIO"
  },
  {
    "codigo":281457009,
    "descripcion":"RUPTURA DE DISPOSITIVO DE FIJACIÓN ÓSEO"
  },
  {
    "codigo":707441009,
    "descripcion":"ENFERMEDAD PULMONAR INDUCIDA POR LECHE EN EL LACTANTE"
  },
  {
    "codigo":83014000,
    "descripcion":"PLACA DE MACCALLUM"
  },
  {
    "codigo":1264497008,
    "descripcion":"CARCINOMA DUCTAL INFILTRANTE DE MAMA METASTÁSICO"
  },
  {
    "codigo":246854005,
    "descripcion":"HALLAZGO RELACIONADO CON LA VÍA DE DRENAJE LAGRIMAL"
  },
  {
    "codigo":279622009,
    "descripcion":"ANSIEDAD RELACIONADA CON EL DESEMPEÑO"
  },
  {
    "codigo":1162523002,
    "descripcion":"ENFERMEDAD POR DEPÓSITO DE HIDROXIAPATITA DE CADERA"
  },
  {
    "codigo":277787003,
    "descripcion":"HIPOPIGMENTACIÓN POSINFLAMATORIA"
  },
  {
    "codigo":408859005,
    "descripcion":"MUCOSA ATRÓFICA DE ÓRGANO DEL APARATO DIGESTIVO"
  },
  {
    "codigo":110277001,
    "descripcion":"CANDIDIASIS HIPERPLÁSICA"
  },
  {
    "codigo":896709005,
    "descripcion":"FORMA DELGADA ANORMAL CONGÉNITA DE FALANGE PROXIMAL DE DEDO DE MANO"
  },
  {
    "codigo":44741008,
    "descripcion":"COWPERITIS"
  },
  {
    "codigo":1157018000,
    "descripcion":"CONCENTRACIÓN DE OXÍGENO EN SANGRE POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1255322002,
    "descripcion":"SÍNDROME DE CONTRACTURAS CONGÉNITAS DE CARA Y DE EXTREMIDADES, HIPOTONÍA Y RETRASO DEL DESARROLLO"
  },
  {
    "codigo":208581008,
    "descripcion":"FRACTURA NO EXPUESTA DE FÉMUR DISTAL, BICONDÍLEA (FRACTURA EN T-Y)"
  },
  {
    "codigo":10138007,
    "descripcion":"HIPERPLASIA DE MÉDULA ÓSEA"
  },
  {
    "codigo":403354009,
    "descripcion":"ACNÉ POR MALA HIDRATACIÓN"
  },
  {
    "codigo":763802009,
    "descripcion":"EPILEPSIA INDUCIDA POR LA MICCIÓN"
  },
  {
    "codigo":6111000179101,
    "descripcion":"EVALUACIÓN MAMOGRÁFICA (CATEGORÍA 6) - NEOPLASIA MALIGNA CONOCIDA, COMPROBADA POR BIOPSIA"
  },
  {
    "codigo":41071008,
    "descripcion":"EFECTO TÓXICO DEL HIERRO"
  },
  {
    "codigo":235844004,
    "descripcion":"ISQUEMIA SEGMENTARIA FOCAL DEL INTESTINO DELGADO"
  },
  {
    "codigo":15692201000119106,
    "descripcion":"ARTRITIS DE AMBAS ARTICULACIONES MEDIOTARSIANAS"
  },
  {
    "codigo":170308006,
    "descripcion":"EXAMEN DEL NIÑO A LAS 8 SEMANAS: ANORMAL - EN TRATAMIENTO"
  },
  {
    "codigo":268612007,
    "descripcion":"TRASTORNOS PSICÓTICOS ORGÁNICOS, SENILES Y PRESENILES"
  },
  {
    "codigo":203076007,
    "descripcion":"CONTRACTURA DEL TENDÓN DE AQUILES"
  },
  {
    "codigo":1153348007,
    "descripcion":"LINFOMA PRIMARIO CON DERRAME DEBIDO A INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":102937002,
    "descripcion":"MIMACIÓN"
  },
  {
    "codigo":1217049005,
    "descripcion":"ABSCESO DE GLÁNDULA SUPRARRENAL"
  },
  {
    "codigo":234009005,
    "descripcion":"LACERACIÓN ARTERIAL"
  },
  {
    "codigo":430617007,
    "descripcion":"SEPARADO LEGALMENTE CON DECRETO INTERLOCUTORIO"
  },
  {
    "codigo":365081009,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA COMUNICAR INTENCIONES"
  },
  {
    "codigo":363246002,
    "descripcion":"ENFERMEDAD RELACIONADA CON UNA CARENCIA NUTRICIONAL"
  },
  {
    "codigo":789230003,
    "descripcion":"HERIDA INFECTADA DE AMBOS PÁRPADOS DEBIDA A PICADURA DE INSECTO NO VENENOSO"
  },
  {
    "codigo":4633009,
    "descripcion":"INTOXICACIÓN POR HYMENOXYS RICHARDSONII"
  },
  {
    "codigo":428782008,
    "descripcion":"HEMOTÓRAX POSQUIRÚRGICO"
  },
  {
    "codigo":230339003,
    "descripcion":"TEMBLOR DE CABEZA AISLADO"
  },
  {
    "codigo":66499004,
    "descripcion":"CATARATA CORTICAL CONGÉNITA"
  },
  {
    "codigo":346691000119104,
    "descripcion":"CATARATA POLAR SUBCAPSULAR POSTERIOR CONGÉNITA DE AMBOS OJOS"
  },
  {
    "codigo":294040000,
    "descripcion":"ALERGIA A ORCIPRENALINA"
  },
  {
    "codigo":674371000119105,
    "descripcion":"DEBILIDAD DE MÚSCULO FACIAL DEBIDA A ACCIDENTE CEREBROVASCULAR HEMORRÁGICO Y POSTERIOR A ÉL"
  },
  {
    "codigo":1083971000119105,
    "descripcion":"PERFORACIÓN DE BORDE DE AMBAS MEMBRANAS TIMPÁNICAS"
  },
  {
    "codigo":228504007,
    "descripcion":"CONSUMIDOR DE TABACO EN POLVO HÚMEDO"
  },
  {
    "codigo":720024008,
    "descripcion":"DISFUNCIÓN SOMÁTICA DE MIEMBRO INFERIOR"
  },
  {
    "codigo":193901000,
    "descripcion":"QUISTE CONJUNTIVAL"
  },
  {
    "codigo":95597000,
    "descripcion":"LEUCOPLAQUIA DE LOS ÓRGANOS GENITALES FEMENINOS"
  },
  {
    "codigo":64664008,
    "descripcion":"ATROFIA DE VESÍCULA BILIAR"
  },
  {
    "codigo":718189004,
    "descripcion":"SÍNDROME DE CROMOSOMA 8 RECOMBINANTE"
  },
  {
    "codigo":161133008,
    "descripcion":"ESCASA ASISTENCIA ESCOLAR"
  },
  {
    "codigo":292205008,
    "descripcion":"REACCIÓN ADVERSA AL ETOGLÚCIDO"
  },
  {
    "codigo":126530003,
    "descripcion":"NEOPLASIA DE PIEL DE TOBILLO"
  },
  {
    "codigo":290370008,
    "descripcion":"INTOXICACIÓN POR OMEPRAZOL"
  },
  {
    "codigo":124695004,
    "descripcion":"DEFICIENCIA DE VALINA - ARNT LIGASA"
  },
  {
    "codigo":419607004,
    "descripcion":"VISIÓN A DISTANCIA 6\/7,5"
  },
  {
    "codigo":288535006,
    "descripcion":"HALLAZGO RELACIONADO CON LA RISA"
  },
  {
    "codigo":91927006,
    "descripcion":"RINITIS ALÉRGICA CAUSADA POR POLEN DE ÁRBOLES"
  },
  {
    "codigo":1204204003,
    "descripcion":"INSUFICIENCIA VENTRICULAR IZQUIERDA CON FRACCIÓN DE EYECCIÓN NORMAL DEBIDA A MIOCARDITIS"
  },
  {
    "codigo":90092004,
    "descripcion":"REACCIÓN DE HIPERSENSIBILIDAD MEDIADA POR ANTICUERPOS"
  },
  {
    "codigo":253932005,
    "descripcion":"BRAQUISINDACTILIA DE PULGAR"
  },
  {
    "codigo":286700004,
    "descripcion":"NIVEL ALTO DE PSICOTICISMO"
  },
  {
    "codigo":385004008,
    "descripcion":"MARGEN ANTERIOR DE RESECCIÓN QUIRÚRGICA AFECTADO POR NEOPLASIA MALIGNA"
  },
  {
    "codigo":186561002,
    "descripcion":"MENINGITIS CAUSADA POR VIRUS DE SARAMPIÓN"
  },
  {
    "codigo":55489003,
    "descripcion":"MENINGOENCEFALITIS EOSINOFÍLICA"
  },
  {
    "codigo":448705004,
    "descripcion":"ESCLEROSIS MESIAL TEMPORAL"
  },
  {
    "codigo":284865004,
    "descripcion":"SE LAVA EL PELO"
  },
  {
    "codigo":252097006,
    "descripcion":"HIPERSENSIBILIDAD - HALLAZGO"
  },
  {
    "codigo":22721008,
    "descripcion":"EFECTO TÓXICO DE LA AFLATOXINA"
  },
  {
    "codigo":709014002,
    "descripcion":"CUMPLIMIENTO DE LA DIETA PRESCRIPTA"
  },
  {
    "codigo":283030006,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE LA AXILA"
  },
  {
    "codigo":250262007,
    "descripcion":"PRUEBA DE SUERO ACIDIFICADO POSITIVA"
  },
  {
    "codigo":1264235001,
    "descripcion":"HEMÓLISIS INTRAVASCULAR POSTERIOR A EMBARAZO ECTÓPICO"
  },
  {
    "codigo":86422009,
    "descripcion":"MESENTERITIS RETRÁCTIL"
  },
  {
    "codigo":182891003,
    "descripcion":"EL PACIENTE NO ENTENDIÓ LAS INSTRUCCIONES DEL TRATAMIENTO"
  },
  {
    "codigo":17216000,
    "descripcion":"DISNEA, CLASE FUNCIONAL I"
  },
  {
    "codigo":51819009,
    "descripcion":"SÍNDROME DE TRISOMÍA PARCIAL 17P"
  },
  {
    "codigo":246592003,
    "descripcion":"AUSENCIA DE LA RESPUESTA PLANTAR"
  },
  {
    "codigo":49984004,
    "descripcion":"SÍNDROME FG"
  },
  {
    "codigo":312128007,
    "descripcion":"INFECCIÓN BACTERIANA BUCAL"
  },
  {
    "codigo":1162261000,
    "descripcion":"NECROSIS DE LÓBULO TEMPORAL CAUSADA POR RADIACIÓN IONIZANTE"
  },
  {
    "codigo":1196864009,
    "descripcion":"HEMANGIOBLASTOMA DE RETINA"
  },
  {
    "codigo":48149007,
    "descripcion":"EXANGUINACIÓN"
  },
  {
    "codigo":310293008,
    "descripcion":"ANTICUERPOS ANTIMITOCONDRIALES NO DETECTADOS"
  },
  {
    "codigo":898282005,
    "descripcion":"ANQUILOSIS CONGÉNITA DE ARTICULACIÓN METATARSOFALÁNGICA DE SEGUNDO DEDO DE PIE"
  },
  {
    "codigo":111850006,
    "descripcion":"MENINGITIS ADENOVIRAL"
  },
  {
    "codigo":404927005,
    "descripcion":"POSICIÓN DE BIPEDESTACIÓN SIN APOYO"
  },
  {
    "codigo":110015006,
    "descripcion":"LESIÓN TRAUMÁTICA DE PENE"
  },
  {
    "codigo":403092000,
    "descripcion":"ONICOMICOSIS CAUSADA POR ESPECIES DE ACREMONIUM"
  },
  {
    "codigo":698004001,
    "descripcion":"RESORCIÓN EXTERNA NO APICAL DE RAÍZ DE DIENTE"
  },
  {
    "codigo":1086481000119105,
    "descripcion":"PERFORACIÓN DE INTESTINO DELGADO CONCOMITANTE CON HEMORRAGIA DEBIDA A DIVERTICULITIS"
  },
  {
    "codigo":42644007,
    "descripcion":"POSICIÓN BÁSICA DE COITO"
  },
  {
    "codigo":1351529000,
    "descripcion":"MACULOPATÍA EN CÚPULA DE OJO DERECHO"
  },
  {
    "codigo":8041002,
    "descripcion":"ÚLCERA URETRAL"
  },
  {
    "codigo":302953002,
    "descripcion":"AGENESIA DE VESÍCULA BILIAR"
  },
  {
    "codigo":366654004,
    "descripcion":"HALLAZGO RELACIONADO CON LA FORTALEZA DE LAS UÑAS"
  },
  {
    "codigo":71742005,
    "descripcion":"PELVIS CIFORRAQUÍTICA"
  },
  {
    "codigo":301118005,
    "descripcion":"HALLAZGO RELACIONADO CON EL INTERVALO TU"
  },
  {
    "codigo":1251390005,
    "descripcion":"OCLUSIÓN DE MICROVASCULATURA DE PIEL DEBIDO A TROMBO PLAQUETARIO ASOCIADO A TRASTORNO MIELOPROLIFERATIVO"
  },
  {
    "codigo":202814008,
    "descripcion":"ANQUILOSIS DE LA COLUMNA VERTEBRAL CERVICAL"
  },
  {
    "codigo":233747001,
    "descripcion":"TRIQUINOSIS DE DIAFRAGMA"
  },
  {
    "codigo":299283002,
    "descripcion":"SIN AMPLITUD PASIVA DE ADUCCIÓN DE LA CADERA"
  },
  {
    "codigo":399422005,
    "descripcion":"ADENOMA DE INTESTINO DELGADO"
  },
  {
    "codigo":364819005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA COMER CON LA MANO DERECHA"
  },
  {
    "codigo":46211000087103,
    "descripcion":"FRACTURA DE FALANGE DE SEGUNDO DEDO DE PIE IZQUIERDO"
  },
  {
    "codigo":68072000,
    "descripcion":"PANCREATITIS HEREDITARIA"
  },
  {
    "codigo":43651000087105,
    "descripcion":"CONTUSIÓN DE FLANCO DERECHO"
  },
  {
    "codigo":788968002,
    "descripcion":"QUISTE INTERNO DE GLÁNDULA DE MEIBOMIO"
  },
  {
    "codigo":35304003,
    "descripcion":"TAPONAMIENTO CARDÍACO"
  },
  {
    "codigo":166376001,
    "descripcion":"NIVEL DE HORMONA FOLICULOESTIMULANTE DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":41091000087107,
    "descripcion":"CELULITIS DE CUARTO DEDO DE PIE IZQUIERDO"
  },
  {
    "codigo":16270661000119100,
    "descripcion":"AUSENCIA DE SENSACIÓN POR TRASTORNO DE CONVERSIÓN"
  },
  {
    "codigo":231912007,
    "descripcion":"PIGMENTACIÓN MELÁNICA DE LA CÓRNEA"
  },
  {
    "codigo":362984008,
    "descripcion":"ANOMALÍA DE PAR CROMOSÓMICO"
  },
  {
    "codigo":787133003,
    "descripcion":"METABOLIZADOR RÁPIDO DE LA SUBUNIDAD 1 DEL COMPLEJO VITAMINA K-EPÓXIDO REDUCTASA"
  },
  {
    "codigo":262845003,
    "descripcion":"CONTUSIÓN DUODENAL"
  },
  {
    "codigo":701003,
    "descripcion":"OSTEOCONDRITIS VERTEBRAL DEL ADULTO"
  },
  {
    "codigo":721597007,
    "descripcion":"ADENOMA TUBULAR DE MAMA"
  },
  {
    "codigo":361149008,
    "descripcion":"INTOXICACIÓN POR SEDANTES"
  },
  {
    "codigo":785298001,
    "descripcion":"ENFERMEDAD MUSCULAR-OCULAR-ENCEFÁLICA CON LEUCODISTROFIA MULTIQUÍSTICA BILATERAL"
  },
  {
    "codigo":295613008,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE TIOTEPA"
  },
  {
    "codigo":293778004,
    "descripcion":"ALERGIA A AMSACRINA"
  },
  {
    "codigo":195474004,
    "descripcion":"VÁRICES ESOFÁGICAS ASOCIADAS CON OTRO TRASTORNO"
  },
  {
    "codigo":128103006,
    "descripcion":"DEFECTO AISLADO EN LA AGREGACIÓN DE COLÁGENO"
  },
  {
    "codigo":212616001,
    "descripcion":"INTOXICACIÓN CON PARAMETADIONA"
  },
  {
    "codigo":160871009,
    "descripcion":"NIÑO EN HOGAR SUSTITUTO"
  },
  {
    "codigo":1240380002,
    "descripcion":"TRASTORNO NEONATAL PRECOZ DEBIDO A LESIÓN DE PLACENTA POSTERIOR A AMNIOCENTESIS"
  },
  {
    "codigo":60732002,
    "descripcion":"DEFECTO SEPTAL AURICULAR CON DEFECTO DE LA ALMOHADILLA ENDOCÁRDICA, TIPO PARCIAL"
  },
  {
    "codigo":1142076005,
    "descripcion":"HIPERBILIRRUBINEMIA NEONATAL DEBIDA A ENFERMEDAD METABÓLICA"
  },
  {
    "codigo":290108005,
    "descripcion":"SECRECIÓN POR PEZÓN LÍMPIDA"
  },
  {
    "codigo":716092007,
    "descripcion":"SÍNDROME DE HIPOPLASIA RADIAL Y PULGAR TRIFALÁNGICO CON HIPOSPADIAS Y DIASTEMA MAXILAR"
  },
  {
    "codigo":124433000,
    "descripcion":"DEFICIENCIA DE FOSFATIDATO FOSFATASA"
  },
  {
    "codigo":93500006,
    "descripcion":"PARAGRANULOMA DE HODGKIN DE BAZO"
  },
  {
    "codigo":288273009,
    "descripcion":"SUFRIMIENTO FETAL, ANTES DEL TRABAJO DE PARTO"
  },
  {
    "codigo":286438001,
    "descripcion":"NO PLANIFICA LAS COMIDAS"
  },
  {
    "codigo":1269478006,
    "descripcion":"CON MAYOR RIESGO DE INFERTILIDAD MASCULINA"
  },
  {
    "codigo":24294007,
    "descripcion":"INTOXICACIÓN POR SPHENOSCIADIUM CAPITELLATUM"
  },
  {
    "codigo":253670007,
    "descripcion":"CONDUCTO ARTERIOSO DESDE DIVERTÍCULO AÓRTICO RETROESOFÁGICO"
  },
  {
    "codigo":1088991000119104,
    "descripcion":"FÍSTULA DE LA ESTRUCTURA DEL LABERINTO IZQUIERDO"
  },
  {
    "codigo":415675004,
    "descripcion":"EL MARGEN QUIRÚRGICO CIRCUNFERENCIAL ES EL MARGEN NO AFECTADO MÁS CERCANO A LA NEOPLASIA MALIGNA"
  },
  {
    "codigo":284603006,
    "descripcion":"CONDUCTA DE APEGO"
  },
  {
    "codigo":53392002,
    "descripcion":"ANOMALÍA DEL PAR DE CROMOSOMAS 16"
  },
  {
    "codigo":118928003,
    "descripcion":"TRASTORNO DE LA PARED ABDOMINAL"
  },
  {
    "codigo":315536004,
    "descripcion":"NACIDO EN SIRIA"
  },
  {
    "codigo":282768006,
    "descripcion":"LESIÓN DE LA REGIÓN ANTERIOR DEL TÓRAX"
  },
  {
    "codigo":86160006,
    "descripcion":"EFLUVIO ANÁGENO"
  },
  {
    "codigo":1263973001,
    "descripcion":"HEMORRAGIA INTRACRANEANA SUBDURAL NEONATAL PRECOZ"
  },
  {
    "codigo":18789002,
    "descripcion":"TRIPTOFANURIA"
  },
  {
    "codigo":84325005,
    "descripcion":"INTOXICACIÓN POR TETRACLORVINFOS"
  },
  {
    "codigo":248165006,
    "descripcion":"VESTIDO ADECUADAMENTE"
  },
  {
    "codigo":706917007,
    "descripcion":"CLOSTRIDIUM PERFRINGENS NO AISLADO"
  },
  {
    "codigo":279098001,
    "descripcion":"DOLOR CONSTRICTIVO"
  },
  {
    "codigo":705082003,
    "descripcion":"FRACTURA NO EXPUESTA DE PLACA EPIFISARIA DE PERONÉ DISTAL"
  },
  {
    "codigo":717704000,
    "descripcion":"AUSENCIA CONGÉNITA DE AMBAS TROMPAS DE FALOPIO"
  },
  {
    "codigo":408335007,
    "descripcion":"HEPATITIS AUTOINMUNITARIA"
  },
  {
    "codigo":1293071007,
    "descripcion":"NEUROFIBROMA CELULAR"
  },
  {
    "codigo":111588002,
    "descripcion":"TROMBOCITOPENIA INDUCIDA POR HEPARINA CON TROMBOSIS"
  },
  {
    "codigo":766948006,
    "descripcion":"OBSTRUCCIÓN DE VENA CAVA SUPERIOR DEBIDA A NEOPLASIA"
  },
  {
    "codigo":109753007,
    "descripcion":"FRACTURA DE CORONA DENTAL, ESMALTE Y DENTINA, CON EXPOSICIÓN DE LA PULPA"
  },
  {
    "codigo":208057008,
    "descripcion":"FRACTURA VERTEBRAL NO EXPUESTA CON LESIÓN MEDULAR ANTERIOR A NIVEL LUMBAR"
  },
  {
    "codigo":75150001,
    "descripcion":"NEFROPATÍA EN EL EMBARAZO Y\/O PUERPERIO SIN HIPERTENSIÓN"
  },
  {
    "codigo":370062000,
    "descripcion":"INVASIÓN TUMORAL QUE PENETRA EN LA CAPA SEROSA"
  },
  {
    "codigo":763278004,
    "descripcion":"SÍNDROME DE DISMORFISMO FACIAL, FISURA DE PALADAR Y PIEL LAXA"
  },
  {
    "codigo":271758006,
    "descripcion":"NÓDULO EN PIEL O MUCOSA"
  },
  {
    "codigo":237155000,
    "descripcion":"TRASTORNO DE VULVA EN EMBARAZO, PARTO Y\/O PUERPERIO"
  },
  {
    "codigo":238990009,
    "descripcion":"ECCEMA MEDICAMENTOSO"
  },
  {
    "codigo":1351267003,
    "descripcion":"INMUNODEFICIENCIA VARIABLE COMÚN AUTOSÓMICA RECESIVA DEBIDA A DEFICIENCIA DE CD81"
  },
  {
    "codigo":1285731006,
    "descripcion":"HIPERTENSIÓN OCULAR DEBIDA A DESPRENDIMIENTO DE RETINA"
  },
  {
    "codigo":300856000,
    "descripcion":"MASA DE ESTRUCTURA GENITOURINARIA"
  },
  {
    "codigo":169784003,
    "descripcion":"EXAMEN POSNATAL: NORMAL"
  },
  {
    "codigo":71480005,
    "descripcion":"INTOXICACIÓN POR PIRETROIDES"
  },
  {
    "codigo":38712009,
    "descripcion":"ESTENOSIS DE LA VESÍCULA BILIAR"
  },
  {
    "codigo":366392009,
    "descripcion":"AMPLITUD DEL MOVIMIENTO ACTIVO DE FLEXIÓN LATERAL DE LA COLUMNA CERVICAL - HALLAZGO"
  },
  {
    "codigo":266253001,
    "descripcion":"OCLUSIÓN DE ARTERIA PRECEREBRAL"
  },
  {
    "codigo":725005008,
    "descripcion":"LESIÓN TRAUMÁTICA DE FASCIA DE LA CABEZA"
  },
  {
    "codigo":299021009,
    "descripcion":"CREPITACIÓN AUDIBLE DE ARTICULACIÓN DE MUÑECA"
  },
  {
    "codigo":723170000,
    "descripcion":"DESVIACIÓN OBLICUA ALTERNANTE DE LA MIRADA"
  },
  {
    "codigo":428258002,
    "descripcion":"FRACTURA EXPUESTA DE HUESO DEL TARSO"
  },
  {
    "codigo":721335001,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA PARCIAL DE OÍDO EXTERNO"
  },
  {
    "codigo":295351001,
    "descripcion":"SOBREDOSIS DE CIMETIDINA"
  },
  {
    "codigo":360887005,
    "descripcion":"DEFICIENCIA DE NAD + NUCLEOSIDASA"
  },
  {
    "codigo":197047007,
    "descripcion":"INVAGINACIÓN YEYUNOGÁSTRICA"
  },
  {
    "codigo":719500002,
    "descripcion":"ABANDONÓ EL ÁMBITO ASISTENCIAL DESPUÉS DE RECHAZAR EL TRATAMIENTO"
  },
  {
    "codigo":162444005,
    "descripcion":"EL SÍNTOMA DURA MINUTOS"
  },
  {
    "codigo":195212005,
    "descripcion":"SÍNDROME DE ACCIDENTE VASCULAR DEL TRONCO ENCEFÁLICO"
  },
  {
    "codigo":1145484006,
    "descripcion":"HIPOPLASIA CONGÉNITA DE FALANGE DE DEDO ANULAR"
  },
  {
    "codigo":129676008,
    "descripcion":"DEPENDENCIA FÍSICA FUNCIONAL"
  },
  {
    "codigo":783201001,
    "descripcion":"NEUTROPENIA CONGÉNITA SEVERA AUTOSÓMICA RECESIVA DEBIDA A DEFICIENCIA DE CSF3R"
  },
  {
    "codigo":62305002,
    "descripcion":"TRASTORNO DEL LENGUAJE"
  },
  {
    "codigo":64140006,
    "descripcion":"INTOXICACIÓN POR TOXICODENDRON DIVERSILOBUM"
  },
  {
    "codigo":95073004,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA PIEL DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":226145001,
    "descripcion":"DIETA RICA EN VITAMINA C"
  },
  {
    "codigo":354221000119108,
    "descripcion":"NEOPLASIA BENIGNA DE BRONQUIO DERECHO"
  },
  {
    "codigo":191542003,
    "descripcion":"ESQUIZOFRENIA CATATÓNICA"
  },
  {
    "codigo":224310004,
    "descripcion":"CONCURRE A LA UNIVERSIDAD"
  },
  {
    "codigo":289846005,
    "descripcion":"HALLAZGO RELACIONADO CON MEDICIONES DEL OVARIO"
  },
  {
    "codigo":715830008,
    "descripcion":"HIPERINSULINISMO INDUCIDO POR EJERCICIO"
  },
  {
    "codigo":124171000,
    "descripcion":"DEFICIENCIA DE L-AMINOÁCIDO OXIDASA"
  },
  {
    "codigo":420918009,
    "descripcion":"MONONEUROPATÍA DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":286176000,
    "descripcion":"NO HACE LA CAMA"
  },
  {
    "codigo":58635009,
    "descripcion":"SEQUEDAD VULVOVAGINAL"
  },
  {
    "codigo":89568005,
    "descripcion":"REQUERIMIENTO METABÓLICO NORMAL"
  },
  {
    "codigo":16302151000119106,
    "descripcion":"LESIÓN DE HUESO DE PIERNA DERECHA"
  },
  {
    "codigo":710325001,
    "descripcion":"ESPECIE DE CITROBACTER O ENTEROBACTER CLOACAE"
  },
  {
    "codigo":253408009,
    "descripcion":"CUERDAS TENDINOSAS DE VÁLVULA MITRAL EXCESIVAMENTE CORTAS"
  },
  {
    "codigo":448181004,
    "descripcion":"RETORNO VENOSO CORONARIO ANÓMALO"
  },
  {
    "codigo":251573005,
    "descripcion":"INCREMENTO DE LA AMPLITUD A ELEVADA FRECUENCIA (20-50 HZ)"
  },
  {
    "codigo":249738000,
    "descripcion":"AUSENCIA DE HUESO DEL BRAZO"
  },
  {
    "codigo":85898001,
    "descripcion":"MIOCARDIOPATÍA"
  },
  {
    "codigo":301281000119102,
    "descripcion":"TRASTORNO REPETITIVO DEL MOVIMIENTO DE PIERNA DERECHA"
  },
  {
    "codigo":284341009,
    "descripcion":"CAPAZ DE TAPAR UN RECIPIENTE"
  },
  {
    "codigo":282506005,
    "descripcion":"INCAPAZ DE BAJAR UNA COLINA CORRIENDO"
  },
  {
    "codigo":1003402006,
    "descripcion":"DISOMÍA UNIPARENTAL MATERNA DEL CROMOSOMA 15"
  },
  {
    "codigo":247903003,
    "descripcion":"VIGILANCIA INMÓVIL"
  },
  {
    "codigo":1362015006,
    "descripcion":"INFANCIA FELIZ"
  },
  {
    "codigo":1296479007,
    "descripcion":"HIPERTENSIÓN OCULAR BILATERAL CAUSADA POR CORTICOIDES"
  },
  {
    "codigo":84063009,
    "descripcion":"SORDERA TRAUMÁTICA, LABORAL"
  },
  {
    "codigo":442676003,
    "descripcion":"HEMIPLEJÍA DE LADO DOMINANTE COMO EFECTO TARDÍO DE ENFERMEDAD CEREBROVASCULAR"
  },
  {
    "codigo":278836005,
    "descripcion":"CASADO EN SEGUNDAS NUPCIAS"
  },
  {
    "codigo":770356006,
    "descripcion":"QUEMADURA PROFUNDA DE TERCER GRADO DE LABIOS SUPERIOR E INFERIOR"
  },
  {
    "codigo":82228008,
    "descripcion":"FARINGITIS ESTAFILOCÓCICA"
  },
  {
    "codigo":735753007,
    "descripcion":"LESIÓN TRAUMÁTICA DE PORCIÓN ABDOMINOPÉLVICA DE SISTEMA NERVIOSO SIMPÁTICO"
  },
  {
    "codigo":1260041009,
    "descripcion":"TATUAJE DE MUCOSA DE PALADAR DURO"
  },
  {
    "codigo":111326002,
    "descripcion":"MORDIDA EN CRUZ POSTERIOR"
  },
  {
    "codigo":439006004,
    "descripcion":"HIPERHOMOCISTEINEMIA HEREDITARIA"
  },
  {
    "codigo":371635001,
    "descripcion":"CADÁVER AL QUE SE LE HAN PRACTICADO DOS AUTOPSIAS"
  },
  {
    "codigo":11187001,
    "descripcion":"HEMÓLISIS DE UNA COLONIA BACTERIANA, ALFA PRIMARIA"
  },
  {
    "codigo":1088541000119100,
    "descripcion":"INFLAMACIÓN CRÓNICA DE PORCIÓN PETROSA DE HUESO TEMPORAL IZQUIERDO"
  },
  {
    "codigo":341021000119101,
    "descripcion":"QUERATITIS INTERSTICIAL DIFUSA DE OJO IZQUIERDO"
  },
  {
    "codigo":10760221000119101,
    "descripcion":"PROLAPSO UTERINO EN EL EMBARAZO"
  },
  {
    "codigo":10954781000119103,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO AXILAR IZQUIERDO"
  },
  {
    "codigo":11812381000119104,
    "descripcion":"LESIÓN TRAUMÁTICA PRIMARIA DE COLON DESCENDENTE POR EXPLOSIÓN"
  },
  {
    "codigo":541000119105,
    "descripcion":"HIPERTENSIÓN QUE COMPLICA EMBARAZO, PARTO Y PUERPERIO, PREPARTO"
  },
  {
    "codigo":323101000119106,
    "descripcion":"LONGITUD DESIGUAL DE EXTREMIDAD INFERIOR DEBIDA A ACORTAMIENTO ADQUIRIDO DE FÉMUR DERECHO"
  },
  {
    "codigo":11858461000119106,
    "descripcion":"LESIÓN TRAUMÁTICA DE ARTERIA TIBIAL POSTERIOR DERECHA"
  },
  {
    "codigo":240563008,
    "descripcion":"ULCERACIÓN SIFILÍTICA DE LA MUCOSA"
  },
  {
    "codigo":10808861000119105,
    "descripcion":"SUFRIMIENTO MATERNO DURANTE EL NACIMIENTO"
  },
  {
    "codigo":699315005,
    "descripcion":"ENFERMEDAD DE ALMACENAMIENTO DE LÍPIDOS NEUTROS CON MIOPATÍA"
  },
  {
    "codigo":51741000119105,
    "descripcion":"DOLOR DE TOBILLO, AGUDO"
  },
  {
    "codigo":1075741000119108,
    "descripcion":"CONTRACTURA DE MÚSCULO DE PIE IZQUIERDO"
  },
  {
    "codigo":338461000119109,
    "descripcion":"PSEUDOEDEMA DE PAPILA DE OJO IZQUIERDO"
  },
  {
    "codigo":15954461000119108,
    "descripcion":"CICATRIZ RADIAL DE MAMA IZQUIERDA"
  },
  {
    "codigo":15964701000119109,
    "descripcion":"CORAZÓN PULMONAR AGUDO CONCOMITANTE CON ÉMBOLO EN SILLA DE MONTAR DE ARTERIA PULMONAR Y DEBIDO A ÉL"
  },
  {
    "codigo":10834461000119108,
    "descripcion":"FRACTURA EXPUESTA EN MARTILLO DE FALANGE DISTAL DE DEDO ÍNDICE DE MANO DERECHA"
  },
  {
    "codigo":1085981000119109,
    "descripcion":"CARIES DENTAL SOBRE SUPERFICIE LISA LIMITADA AL ESMALTE"
  },
  {
    "codigo":235058001,
    "descripcion":"INFECCIÓN INTRABUCAL POR HERPES SIMPLE"
  },
  {
    "codigo":38450002,
    "descripcion":"LACERACIÓN PERINEAL QUE COMPROMETE MÚSCULOS VAGINALES"
  },
  {
    "codigo":169522004,
    "descripcion":"PREPARADOS ANTICONCEPTIVOS DE LIBERACIÓN LENTA - PROBLEMAS"
  },
  {
    "codigo":15649301000119103,
    "descripcion":"ANEURISMA DE ARTERIA POPLÍTEA DERECHA"
  },
  {
    "codigo":202290007,
    "descripcion":"CONTRACTURA EN EQUINO DE TOBILLO"
  },
  {
    "codigo":366130008,
    "descripcion":"HALLAZGO EN LA EXPANSIÓN TORÁCICA"
  },
  {
    "codigo":298759002,
    "descripcion":"OMÓPLATO PEQUEÑO"
  },
  {
    "codigo":397063002,
    "descripcion":"PUNTILLADO BASÓFILO, ERITROCITOS"
  },
  {
    "codigo":167687007,
    "descripcion":"LACTOSA DETECTADA EN ESPÉCIMEN DE MATERIA FECAL POR CROMATOGRAFÍA"
  },
  {
    "codigo":724743008,
    "descripcion":"SADISMO SEXUAL COERCITIVO"
  },
  {
    "codigo":722908001,
    "descripcion":"CONTUSIÓN DE CEREBRO DEBIDA A TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":2012002,
    "descripcion":"FRACTURA DE HUESO SEMILUNAR DE LA MUÑECA"
  },
  {
    "codigo":198620003,
    "descripcion":"EMBARAZO TUBÁRICO ROTO"
  },
  {
    "codigo":296924003,
    "descripcion":"SOBREDOSIS DE SUSTITUTOS PLASMÁTICOS"
  },
  {
    "codigo":16032431000119100,
    "descripcion":"NECROSIS AVASCULAR DE HUESO DE AMBAS REGIONES DE CODO"
  },
  {
    "codigo":426161002,
    "descripcion":"HIPERLIPEMIA INDUCIDA POR SUSTANCIAS QUÍMICAS"
  },
  {
    "codigo":177007,
    "descripcion":"INTOXICACIÓN POR LAS LARVAS DE LA MOSCA DE SIERRA"
  },
  {
    "codigo":721073008,
    "descripcion":"SÍNDROME DE BAJA ESTATURA CON PTERIGIÓN CERVICAL Y CARDIOPATÍA CONGÉNITA"
  },
  {
    "codigo":31110000,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA VENA OVÁRICA"
  },
  {
    "codigo":194950003,
    "descripcion":"MIOCARDITIS MENINGOCÓCICA AGUDA"
  },
  {
    "codigo":719238004,
    "descripcion":"TIENE ENFERMERA CLAVE PARA LA ATENCIÓN EN EL FINAL DE LA VIDA"
  },
  {
    "codigo":1145222005,
    "descripcion":"NEURITIS DEBIDA A RUPTURA DE DISCO INTERVERTEBRAL"
  },
  {
    "codigo":162182005,
    "descripcion":"DIURESIS"
  },
  {
    "codigo":168649391000119103,
    "descripcion":"ÚLCERA VENOSA EN REGIÓN MEDIA DE PIE IZQUIERDO"
  },
  {
    "codigo":293254005,
    "descripcion":"REACCIÓN ADVERSA AL MESTRANOL"
  },
  {
    "codigo":422491004,
    "descripcion":"LA VIVIENDA TIENE CABLES EXPUESTOS"
  },
  {
    "codigo":94811004,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE COLON DESCENDENTE"
  },
  {
    "codigo":10625711000119105,
    "descripcion":"BRONCONEUMONÍA CAUSADA POR STREPTOCOCCUS PNEUMONIAE"
  },
  {
    "codigo":715568002,
    "descripcion":"SÍNDROME DE DISPLASIA GNATODIAFISARIA"
  },
  {
    "codigo":92976003,
    "descripcion":"AUSENCIA CONGÉNITA DE VÁLVULA TRICÚSPIDE"
  },
  {
    "codigo":846640007,
    "descripcion":"AFECCIÓN RESPIRATORIA CAUSADA POR PARTÍCULAS SÓLIDAS CALIENTES TRANSITORIAMENTE SUSPENDIDAS EN EL AIRE"
  },
  {
    "codigo":1010480007,
    "descripcion":"AGENESIA DE FALANGE MEDIA DE DEDO MEÑIQUE"
  },
  {
    "codigo":289584009,
    "descripcion":"LOQUIOS ESPESOS"
  },
  {
    "codigo":713733003,
    "descripcion":"INFECCIÓN CAUSADA POR VIRUS HERPES ZÓSTER CONCOMITANTE CON INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":189445003,
    "descripcion":"BAJO PESO PARA LA EDAD GESTACIONAL, SIN MENCIÓN DE DESNUTRICIÓN FETAL"
  },
  {
    "codigo":449754000,
    "descripcion":"PUNTO DE PRESIÓN CUTÁNEA SOBRE PROMINENCIA ÓSEA"
  },
  {
    "codigo":123909009,
    "descripcion":"INTOXICACIÓN POR MYRTACEAE"
  },
  {
    "codigo":285914002,
    "descripcion":"NO UTILIZA INSTALACIONES PARA LA HIGIENE"
  },
  {
    "codigo":253146009,
    "descripcion":"TRASTORNO DE LA MIGRACIÓN Y DIFERENCIACIÓN NEURONAL"
  },
  {
    "codigo":216708000,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR FORATO"
  },
  {
    "codigo":447919008,
    "descripcion":"CONEXIÓN AURICULOVENTRICULAR UNIVENTRICULAR CON CONEXIÓN AURICULOVENTRICULAR DEL LADO DERECHO AUSENTE"
  },
  {
    "codigo":282244002,
    "descripcion":"DIFICULTAD PARA CAMINAR HACIA ATRÁS ARRASTRANDO UN JUGUETE GRANDE"
  },
  {
    "codigo":85636003,
    "descripcion":"CONTUSIÓN DE BRAZO"
  },
  {
    "codigo":52868006,
    "descripcion":"SÍNDROME OROFACIODIGITAL"
  },
  {
    "codigo":20100009,
    "descripcion":"FRACTURA NO EXPUESTA DE SECCIÓN INTRACAPSULAR DE FÉMUR"
  },
  {
    "codigo":10926921000119107,
    "descripcion":"FRACTURA NO EXPUESTA DE DIÁFISIS DE SEGUNDO HUESO METACARPIANO DE MANO IZQUIERDA"
  },
  {
    "codigo":1263449003,
    "descripcion":"ENCEFALOCELE AISLADO"
  },
  {
    "codigo":313177006,
    "descripcion":"ESTUDIO DE VENTILACIÓN-PERFUSIÓN NORMAL"
  },
  {
    "codigo":247641007,
    "descripcion":"PERPLEJO"
  },
  {
    "codigo":18265008,
    "descripcion":"EXOFTALMÍA"
  },
  {
    "codigo":81966000,
    "descripcion":"FRACTURA EXPUESTA DE RADIO Y CÚBITO"
  },
  {
    "codigo":16430000,
    "descripcion":"FASE PSICOSEXUAL ORAL"
  },
  {
    "codigo":770094004,
    "descripcion":"NEUROPATÍA DE PLEXO RADICULAR CERVICAL DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":278574005,
    "descripcion":"CORONA DENTAL MUY OSCURA"
  },
  {
    "codigo":49198006,
    "descripcion":"TORSIÓN DEL CORDÓN ESPERMÁTICO"
  },
  {
    "codigo":1259779000,
    "descripcion":"FIBROHISTIOCITOMA PRIMARIO MALIGNO DE PIEL"
  },
  {
    "codigo":276739001,
    "descripcion":"NEOPLASIA CUTÁNEA CON DIFERENCIACIÓN PILOSA"
  },
  {
    "codigo":735491008,
    "descripcion":"INFECCIÓN PÉLVICA DEBIDA A EMBARAZO MOLAR Y POSTERIOR A ÉL"
  },
  {
    "codigo":307672008,
    "descripcion":"MIOCLONÍA OCULOPALATINA"
  },
  {
    "codigo":830125001,
    "descripcion":"ELEVACIÓN DE PIERNA IZQUIERDA EXTENDIDA DISMINUIDA"
  },
  {
    "codigo":209368009,
    "descripcion":"FRACTURA-LUXACIÓN EXPUESTA DE MÚLTIPLES ARTICULACIONES METATARSOFALÁNGICAS"
  },
  {
    "codigo":404141000,
    "descripcion":"INMUNOCITOMA CUTÁNEO PRIMARIO"
  },
  {
    "codigo":1354413005,
    "descripcion":"DISTENSIÓN DE MÚSCULO Y\/O TENDÓN DE TRÍCEPS BRAQUIAL"
  },
  {
    "codigo":305837008,
    "descripcion":"VISTO POR EL SERVICIO DE NEUROPATOLOGÍA"
  },
  {
    "codigo":240301009,
    "descripcion":"PROBLEMA DEL AMAMANTAMIENTO EN EL RECIÉN NACIDO"
  },
  {
    "codigo":762754001,
    "descripcion":"DERMATITIS ALÉRGICA POR CONTACTO CAUSADA POR PERFUME"
  },
  {
    "codigo":238466003,
    "descripcion":"CALLO DIFUSO"
  },
  {
    "codigo":205698004,
    "descripcion":"SÍNDROME DE KLINEFELTER, VARÓN CON CARIOTIPO 46,XX"
  },
  {
    "codigo":9090007,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE TESTÍCULO SIN INFECCIÓN"
  },
  {
    "codigo":40023000,
    "descripcion":"FALLO DE VÁLVULA MITRAL REUMÁTICA"
  },
  {
    "codigo":236631000,
    "descripcion":"LEUCOPLASIA DE VEJIGA URINARIA"
  },
  {
    "codigo":402306009,
    "descripcion":"ALERGIA A ALUMINIO"
  },
  {
    "codigo":302167005,
    "descripcion":"URTICARIA POR FRÍO CON CRIOGLOBULINAS"
  },
  {
    "codigo":1119532001,
    "descripcion":"EVALUACIÓN DE MEJOR AGUDEZA VISUAL CORREGIDA ANORMAL"
  },
  {
    "codigo":300332007,
    "descripcion":"MASA HEPÁTICA"
  },
  {
    "codigo":298497001,
    "descripcion":"DEFORMIDAD DE VÉRTEBRA DORSAL"
  },
  {
    "codigo":11857021000119107,
    "descripcion":"HEMATOMA SUBUNGUEAL DE DEDO GORDO DE PIE IZQUIERDO"
  },
  {
    "codigo":724481004,
    "descripcion":"DISFUNCIÓN SEXUAL CONCOMITANTE CON PROLAPSO DE ÓRGANO GENITAL FEMENINO Y DEBIDA A ÉL"
  },
  {
    "codigo":15953021000119108,
    "descripcion":"CARCINOMA IN SITU DE AMBAS MAMAS"
  },
  {
    "codigo":167425009,
    "descripcion":"ELECTRÓLITOS EN ORINA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":3585009,
    "descripcion":"PARPADEO"
  },
  {
    "codigo":296662003,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE CARBENICILINA"
  },
  {
    "codigo":820950005,
    "descripcion":"PIEL FRÍA SOBRE LESIÓN"
  },
  {
    "codigo":130987000,
    "descripcion":"CONFUSIÓN AGUDA"
  },
  {
    "codigo":196523003,
    "descripcion":"ESTENOSIS DE CONDUCTO SUBLINGUAL"
  },
  {
    "codigo":1099031000119105,
    "descripcion":"OPACIDAD DE CÓRNEA DE AMBOS OJOS"
  },
  {
    "codigo":292992006,
    "descripcion":"REACCIÓN ADVERSA A LA POLIMIXINA B"
  },
  {
    "codigo":291157004,
    "descripcion":"INTOXICACIÓN POR PIMOZIDA"
  },
  {
    "codigo":94549007,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA PIEL DE LA OREJA"
  },
  {
    "codigo":127317007,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA ARTERIA CÓLICA MEDIA"
  },
  {
    "codigo":92714001,
    "descripcion":"CARCINOMA IN SITU DE PIEL DE MAMA"
  },
  {
    "codigo":191018006,
    "descripcion":"DEFECTO DE LA FUNCIÓN DE ANTÍGENO-1 DEL LINFOCITO"
  },
  {
    "codigo":289322009,
    "descripcion":"MUÑÓN UMBILICAL NO SEPARADO"
  },
  {
    "codigo":1336063001,
    "descripcion":"EPISODIO DE USO NOCIVO DE FENCICLIDINA"
  },
  {
    "codigo":123647002,
    "descripcion":"ALTERACIONES CROMOSÓMICAS DEL GRUPO B"
  },
  {
    "codigo":780842009,
    "descripcion":"ARTERIA CORONARIA CON TRAYECTO AORTOPULMONAR"
  },
  {
    "codigo":25343008,
    "descripcion":"OSTEOARTROSIS LOCALIZADA SECUNDARIA DE LA REGIÓN PÉLVICA"
  },
  {
    "codigo":449492000,
    "descripcion":"AURÍCULA IZQUIERDA DIVIDIDA CON DESEMBOCADURA DE TODAS LAS VENAS PULMONARES EN LA CÁMARA PROXIMAL Y LUEGO EN LA AURÍCULA IZQUIERDA CON COMUNICACIÓN ADICIONAL DE LA CÁMARA VENOSA PULMONAR CON LA AURÍCULA DERECHA"
  },
  {
    "codigo":56276002,
    "descripcion":"TROMBOSIS DEL TRONCO DE LA ARTERIA CORONARIA IZQUIERDA"
  },
  {
    "codigo":285652003,
    "descripcion":"LESIÓN EN LA COROIDES"
  },
  {
    "codigo":23508005,
    "descripcion":"INCOORDINACIÓN UTERINA, PRIMER GRADO"
  },
  {
    "codigo":711636007,
    "descripcion":"PULPA DE DIENTE NORMAL"
  },
  {
    "codigo":54441004,
    "descripcion":"FRACTURA DE DIÁFISIS DE FÉMUR"
  },
  {
    "codigo":283817006,
    "descripcion":"MORDEDURA DE ANIMAL EN EL ABDOMEN"
  },
  {
    "codigo":443987001,
    "descripcion":"PATRÓN DE NEOPLASIA CRIBIFORME"
  },
  {
    "codigo":312915004,
    "descripcion":"INFARTO DE CAPA DE FIBRA NERVIOSA"
  },
  {
    "codigo":116307009,
    "descripcion":"HALLAZGO RELACIONADO CON EL MIEMBRO SUPERIOR"
  },
  {
    "codigo":18003009,
    "descripcion":"TRASTORNO DE LA IDENTIDAD SEXUAL EN LA VIDA ADULTA"
  },
  {
    "codigo":704296008,
    "descripcion":"CON MAYOR RIESGO DE ALTERACIÓN DE LA FUNCIÓN DEL SISTEMA RESPIRATORIO"
  },
  {
    "codigo":407549000,
    "descripcion":"PIEL PERIESTOMAL IRRITADA"
  },
  {
    "codigo":81704009,
    "descripcion":"ESPRUE"
  },
  {
    "codigo":309245001,
    "descripcion":"ADENOCARCINOMA DE ÚTERO"
  },
  {
    "codigo":14333004,
    "descripcion":"NEUTROPENIA NEONATAL ALOINMUNITARIA"
  },
  {
    "codigo":1259517005,
    "descripcion":"DEMENCIA DEBIDA A LUPUS ERITEMATOSO SISTÉMICO"
  },
  {
    "codigo":276477006,
    "descripcion":"HALLAZGO RELACIONADO CON LA MENOPAUSIA"
  },
  {
    "codigo":438482000,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DE MÚLTIPLES SITIOS DE LA MANO"
  },
  {
    "codigo":307410001,
    "descripcion":"RETRACCIÓN DE COLOSTOMÍA"
  },
  {
    "codigo":241874002,
    "descripcion":"EFECTO TÓXICO CAUSADO POR PINTURA DE ACABADO ESPECIAL"
  },
  {
    "codigo":733394003,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA PARCIAL DE VULVA"
  },
  {
    "codigo":372946003,
    "descripcion":"INFECCIÓN CAUSADA POR PENICILLIUM CITREOVIRIDE"
  },
  {
    "codigo":10850021000119104,
    "descripcion":"LACERACIÓN DE MAMA DERECHA"
  },
  {
    "codigo":403879004,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS INTRAEPIDÉRMICO DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":371111005,
    "descripcion":"INMUNE CONTRA SARAMPIÓN"
  },
  {
    "codigo":240039005,
    "descripcion":"TENOSINOVITIS GONOCÓCICA"
  },
  {
    "codigo":305575003,
    "descripcion":"BAJO ATENCIÓN DE ENFERMERA PSIQUIÁTRICA COMUNITARIA"
  },
  {
    "codigo":762492001,
    "descripcion":"BAJO PESO EN LA ADOLESCENCIA"
  },
  {
    "codigo":205436005,
    "descripcion":"ESPONDILOSINDESIS DE LA COLUMNA VERTEBRAL PARCIAL CONGÉNITA - EQUILIBRADA"
  },
  {
    "codigo":860796007,
    "descripcion":"CALCINOSIS TUMORAL HIPERFOSFATÉMICA FAMILIAR"
  },
  {
    "codigo":203601000,
    "descripcion":"DIFERENCIA ADQUIRIDA EN LA LONGITUD DE LAS PIERNAS"
  },
  {
    "codigo":1286780009,
    "descripcion":"EPISCLERITIS CAUSADA POR MYCOBACTERIUM TUBERCULOSIS"
  },
  {
    "codigo":301905003,
    "descripcion":"LESIÓN DE OJO"
  },
  {
    "codigo":236369004,
    "descripcion":"ACIDEMIA RENAL"
  },
  {
    "codigo":400209005,
    "descripcion":"LESIÓN TRAUMÁTICA POR FUERZA CAUSANTE"
  },
  {
    "codigo":1186641008,
    "descripcion":"ÚLCERA POR PRESIÓN EN REGIÓN CERVICAL DORSAL"
  },
  {
    "codigo":234534000,
    "descripcion":"AGAMMAGLOBULINEMIA AUTOSÓMICA CON AUSENCIA DE CÉLULAS B"
  },
  {
    "codigo":365606002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA RECONOCER CARAS"
  },
  {
    "codigo":5158005,
    "descripcion":"SÍNDROME DE GILLES DE LA TOURETTE"
  },
  {
    "codigo":15984511000119103,
    "descripcion":"ALTERACIÓN BILATERAL DE LA AUDICIÓN CONCOMITANTE CON MALFORMACIÓN CONGÉNITA DEL OÍDO Y DEBIDA A ELLA"
  },
  {
    "codigo":68859000,
    "descripcion":"ESPONDILOSIS SIN MIELOPATÍA"
  },
  {
    "codigo":70694009,
    "descripcion":"SÍNDROME DE WOLFRAM"
  },
  {
    "codigo":201766009,
    "descripcion":"ARTRITIS REUMATOIDE DE HOMBRO"
  },
  {
    "codigo":3323003,
    "descripcion":"LEUCOPLASIA DEL PENE"
  },
  {
    "codigo":298235008,
    "descripcion":"COLUMNA DORSAL RÍGIDA"
  },
  {
    "codigo":1488000,
    "descripcion":"NÁUSEAS Y VÓMITOS POSTOPERATORIOS"
  },
  {
    "codigo":296400003,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE ATROPINA"
  },
  {
    "codigo":1344976008,
    "descripcion":"NISTAGMO DEBIDO A VÉRTIGO POSICIONAL PAROXÍSTICO BENIGNO"
  },
  {
    "codigo":394704008,
    "descripcion":"ANTECEDENTES LABORALES"
  },
  {
    "codigo":1179301003,
    "descripcion":"SÍNDROME DE DISCAPACIDAD INTELECTUAL ASOCIADO AL GEN DYRK1A"
  },
  {
    "codigo":294565006,
    "descripcion":"ALERGIA A AZTREONAM"
  },
  {
    "codigo":65189006,
    "descripcion":"HEMORRAGIA EXTRADURAL TRAUMÁTICA CON HERIDA INTRACRANEAL ABIERTA"
  },
  {
    "codigo":1144698004,
    "descripcion":"HIPOPLASIA CONGÉNITA DE FALANGE MEDIA DE TERCER DEDO DE PIE"
  },
  {
    "codigo":718714006,
    "descripcion":"SÍNDROME DE SORDERA E HIPOGONADISMO"
  },
  {
    "codigo":194426007,
    "descripcion":"PÉRDIDA DE LA AUDICIÓN PERCEPTIVA COMBINADA"
  },
  {
    "codigo":292730007,
    "descripcion":"REACCIÓN ADVERSA A MESNA"
  },
  {
    "codigo":389199001,
    "descripcion":"DISPLASIA DE COLE - CARPENTER"
  },
  {
    "codigo":94287000,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE HUESO ETMOIDES"
  },
  {
    "codigo":290895001,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR PAROXETINA"
  },
  {
    "codigo":127055007,
    "descripcion":"ENFERMEDAD CRÓNICA POR CRIOAGLUTININAS"
  },
  {
    "codigo":782415009,
    "descripcion":"INTOLERANCIA A LA LACTOSA"
  },
  {
    "codigo":92452001,
    "descripcion":"NEOPLASIA BENIGNA DEL TRÍGONO VESICAL"
  },
  {
    "codigo":11862041000119106,
    "descripcion":"RUPTURA TRAUMÁTICA DE LIGAMENTO CRUZADO DE ARTICULACIÓN DE RODILLA IZQUIERDA"
  },
  {
    "codigo":59684006,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DE DORSO DE LA MANO"
  },
  {
    "codigo":254457002,
    "descripcion":"CARCINOMA DE LA REGIÓN RETROMOLAR"
  },
  {
    "codigo":1237497008,
    "descripcion":"METÁSTASIS DE CARCINOMA DE SUPRAGLOTIS"
  },
  {
    "codigo":385529009,
    "descripcion":"QUEMADURA DE LA PIEL POR BEBIDA CALIENTE"
  },
  {
    "codigo":416462003,
    "descripcion":"HERIDA"
  },
  {
    "codigo":88782004,
    "descripcion":"MIOCARDITIS CAUSADA POR RADIACIÓN"
  },
  {
    "codigo":414627001,
    "descripcion":"HALLAZGO RELACIONADO CON LINFOCITOS"
  },
  {
    "codigo":711374009,
    "descripcion":"POSICIÓN ANORMAL DE ÓRGANO TORACOABDOMINAL"
  },
  {
    "codigo":185251002,
    "descripcion":"ATENDIDO EN CONSULTORIO ESPECIALIZADO EN ELECTROMIOGRAFÍA"
  },
  {
    "codigo":447395005,
    "descripcion":"FRACTURA NO EXPUESTA DE PERONÉ"
  },
  {
    "codigo":248952001,
    "descripcion":"SECRECIÓN DE LOS GENITALES FEMENINOS"
  },
  {
    "codigo":283555009,
    "descripcion":"HERIDA DE PERDIGÓN EN BOCA"
  },
  {
    "codigo":609400006,
    "descripcion":"CON BAJO RIESGO DE CARIES DENTALES"
  },
  {
    "codigo":707704007,
    "descripcion":"CARCINOMA PRIMARIO DE CÉLULAS ESCAMOSAS DE SENO PIRIFORME"
  },
  {
    "codigo":11809101000119101,
    "descripcion":"HERIDA DE MUSLO IZQUIERDO DEBIDA A PICADURA DE INSECTO NO VENENOSO"
  },
  {
    "codigo":17741008,
    "descripcion":"AMIGDALITIS AGUDA"
  },
  {
    "codigo":247117008,
    "descripcion":"DILATACIÓN DE LAS VENAS DE LA RETINA"
  },
  {
    "codigo":278050001,
    "descripcion":"SARCOMA DE MAMA"
  },
  {
    "codigo":1162786005,
    "descripcion":"ISOENZIMA ÓSEA DE FOSFATASA ALCALINA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":79607001,
    "descripcion":"FIBROSIS HEPÁTICA CONGÉNITA"
  },
  {
    "codigo":472823003,
    "descripcion":"CECOURETEROCELE"
  },
  {
    "codigo":208844001,
    "descripcion":"SUBLUXACIÓN PERISEMILUNAR TRAUMÁTICA NO EXPUESTA (DORSAL)"
  },
  {
    "codigo":45004005,
    "descripcion":"HIPOHIDROSIS"
  },
  {
    "codigo":313831000119100,
    "descripcion":"ATROFIA DE MÚSCULO DE MUSLO IZQUIERDO"
  },
  {
    "codigo":733132008,
    "descripcion":"CONDILOMAS ACUMINADOS EXTRAGENITALES"
  },
  {
    "codigo":700364009,
    "descripcion":"TRASTORNO DEL DESARROLLO NEUROLÓGICO"
  },
  {
    "codigo":698529000,
    "descripcion":"ATENDIDO EN CONSULTORIO ESPECIALIZADO EN FIBROSIS QUÍSTICA"
  },
  {
    "codigo":75937003,
    "descripcion":"AUSENCIA CONGÉNITA DEL ANO"
  },
  {
    "codigo":239777004,
    "descripcion":"ARTRITIS PIÓGENA DE LA RODILLA"
  },
  {
    "codigo":41334000,
    "descripcion":"ANGINA DE PECHO, CLASE II"
  },
  {
    "codigo":272545009,
    "descripcion":"ARRODILLADO SOBRE DOS PUNTOS"
  },
  {
    "codigo":20616005,
    "descripcion":"FASE PSICOSEXUAL ANORMAL"
  },
  {
    "codigo":16697831000119103,
    "descripcion":"SÍNDROME DE ACTIVACIÓN IDIOPÁTICA DE MASTOCITOS"
  },
  {
    "codigo":205174005,
    "descripcion":"PULGAR HIPOPLÁSICO-BLAUTH 1"
  },
  {
    "codigo":203339000,
    "descripcion":"ENFERMEDAD DE PAGET DE FALANGE DE DEDO DE LA MANO O PULGAR"
  },
  {
    "codigo":74102009,
    "descripcion":"LEUCONIQUIA PUNTEADA"
  },
  {
    "codigo":399947002,
    "descripcion":"NEVO PIGMENTADO CON ESTATURA CORTA PROGEROIDE"
  },
  {
    "codigo":236107006,
    "descripcion":"ESTENOSIS DE ANASTOMOSIS DE DUODENO"
  },
  {
    "codigo":365344000,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA REALIZAR ACTIVIDADES ASOCIADAS CON VIAJES"
  },
  {
    "codigo":299808001,
    "descripcion":"REFLEJO MASETÉRICO TARDÍO"
  },
  {
    "codigo":1153611009,
    "descripcion":"EMBOLIA DE ARTERIA CEREBRAL ANTERIOR IZQUIERDA"
  },
  {
    "codigo":4896000,
    "descripcion":"HEPATITIS TÓXICA AGUDA"
  },
  {
    "codigo":70432004,
    "descripcion":"QUEMADURA EPIDÉRMICA DE BRAZO"
  },
  {
    "codigo":201504007,
    "descripcion":"ARTRITIS REACTIVA DE ARTICULACIÓN DE MÚLTIPLES LOCALIZACIONES DEBIDA A DISENTERÍA Y POSTERIOR A ELLA"
  },
  {
    "codigo":363509000,
    "descripcion":"NEOPLASIA MALIGNA DE INTESTINO DELGADO"
  },
  {
    "codigo":789493002,
    "descripcion":"GRANO EN PIEL"
  },
  {
    "codigo":722122000,
    "descripcion":"SÍNDROME DE CRECIMIENTO EXCESIVO, MACROCEFALIA, DISMORFISMO FACIAL"
  },
  {
    "codigo":232437009,
    "descripcion":"EDEMA ANGIONEURÓTICO DE LARINGE"
  },
  {
    "codigo":33994004,
    "descripcion":"ACINESIA"
  },
  {
    "codigo":230602005,
    "descripcion":"INFARTO POR EMBOLIA DE TRONCO NERVIOSO"
  },
  {
    "codigo":294303000,
    "descripcion":"METAHEMOGLOBINURIA ADQUIRIDA"
  },
  {
    "codigo":296138009,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE HIDRATO DE CLORAL"
  },
  {
    "codigo":95860004,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":63092005,
    "descripcion":"REACCIÓN INMEDIATA A LA PRUEBA CUTÁNEA"
  },
  {
    "codigo":292468005,
    "descripcion":"REACCIÓN ADVERSA A LA METACOLINA"
  },
  {
    "codigo":1144436005,
    "descripcion":"ATROFIA DE PROTUBERANCIA Y CEREBELO"
  },
  {
    "codigo":126793002,
    "descripcion":"NEOPLASIA DE LA ENCÍA SUPERIOR"
  },
  {
    "codigo":421705002,
    "descripcion":"POSIMAGEN"
  },
  {
    "codigo":94025004,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA PIEL DEL ANTEBRAZO"
  },
  {
    "codigo":290633009,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR DACARBAZINA"
  },
  {
    "codigo":124958002,
    "descripcion":"ERITROPOYESIS EXTRAMEDULAR"
  },
  {
    "codigo":288798009,
    "descripcion":"DIFICULTAD PARA HACER PREGUNTAS"
  },
  {
    "codigo":418035005,
    "descripcion":"PRODUCCIÓN EXCESIVA DE LÁGRIMAS"
  },
  {
    "codigo":1204467005,
    "descripcion":"ULCERACIÓN GASTROINTESTINAL DEBIDA A SEPSIS"
  },
  {
    "codigo":286963007,
    "descripcion":"HIPOTENSIÓN CRÓNICA IDIOPÁTICA"
  },
  {
    "codigo":342811000119105,
    "descripcion":"DERMATITIS ALÉRGICA POR CONTACTO DE PÁRPADO IZQUIERDO"
  },
  {
    "codigo":448968005,
    "descripcion":"QUINTO ARCO AÓRTICO PERSISTENTE CON ATRESIA DE CUARTO ARCO"
  },
  {
    "codigo":416200006,
    "descripcion":"RESONANCIA MAGNÉTICA DE ABDOMEN: ANORMAL"
  },
  {
    "codigo":1004189002,
    "descripcion":"NIVEL DE AMINOÁCIDO NEUTRO AUMENTADO EN ORINA"
  },
  {
    "codigo":283293003,
    "descripcion":"ASTILLA DE MADERA EN DEDO DE LA MANO"
  },
  {
    "codigo":250525009,
    "descripcion":"PRUEBA DEL AZUL DE METILENO: APROBADA"
  },
  {
    "codigo":707442002,
    "descripcion":"PROTEINOSIS ALVEOLAR PULMONAR CONGÉNITA"
  },
  {
    "codigo":281458004,
    "descripcion":"RUPTURA DE ALAMBRE"
  },
  {
    "codigo":1297266005,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE SEGUNDO DEDO DE PIE"
  },
  {
    "codigo":445298006,
    "descripcion":"ORIFICIO AÓRTICO ANTERIOR CON RESPECTO A ORIFICIO PULMONAR"
  },
  {
    "codigo":248690009,
    "descripcion":"SONIDOS CARDÍACOS AGREGADOS"
  },
  {
    "codigo":312391003,
    "descripcion":"GASES EN SANGRE FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":83015004,
    "descripcion":"SÍNDROME DE SAETHRE - CHOTZEN"
  },
  {
    "codigo":771143004,
    "descripcion":"NEUROPATÍA SENSITIVOMOTORA HEREDITARIA TIPO 5"
  },
  {
    "codigo":246855006,
    "descripcion":"PUNTO LAGRIMAL - HALLAZGO"
  },
  {
    "codigo":1229895008,
    "descripcion":"SÍNDROME DE MICRODELECIÓN 8Q24.3"
  },
  {
    "codigo":48412006,
    "descripcion":"MATERNIDAD INEFICAZ"
  },
  {
    "codigo":210417006,
    "descripcion":"LESIÓN POR DESOLLAMIENTO DE ESPALDA"
  },
  {
    "codigo":767473007,
    "descripcion":"ALERGIA A UREA"
  },
  {
    "codigo":896710000,
    "descripcion":"FORMA DELGADA ANORMAL CONGÉNITA DE RADIO"
  },
  {
    "codigo":274118001,
    "descripcion":"ENFERMEDAD VENÉREA EN EL EMBARAZO"
  },
  {
    "codigo":208582001,
    "descripcion":"FRACTURA NO EXPUESTA DE FÉMUR DISTAL, CONMINUTA\/INTRARTICULAR"
  },
  {
    "codigo":16018511000119103,
    "descripcion":"ALTERACIÓN DE LA ALINEACIÓN DE LA RÓTULA IZQUIERDA"
  },
  {
    "codigo":110278006,
    "descripcion":"ENFERMEDAD ACTIVA LUEGO DE LA TERAPIA"
  },
  {
    "codigo":763803004,
    "descripcion":"SÍNDROME DE MORVAN"
  },
  {
    "codigo":10139004,
    "descripcion":"DIFICULTAD PARA ADAPTARSE A LA SITUACIÓN LABORAL"
  },
  {
    "codigo":403355005,
    "descripcion":"COMEDÓN POLIPOROSO"
  },
  {
    "codigo":1255323007,
    "descripcion":"ATAXIA ESPÁSTICA Y DISARTRIA POR DEFICIENCIA DE GLUTAMINASA"
  },
  {
    "codigo":237680001,
    "descripcion":"HIPERPLASIA CORTICOTRÓFICA"
  },
  {
    "codigo":8304007,
    "descripcion":"OTITIS MEDIA AGUDA SEROMUCINOSA"
  },
  {
    "codigo":204912007,
    "descripcion":"HIPOPLASIA DE ESCROTO"
  },
  {
    "codigo":203077003,
    "descripcion":"CONTRACTURA DEL MÚSCULO TIBIAL ANTERIOR"
  },
  {
    "codigo":235845003,
    "descripcion":"COLITIS ISQUÉMICA TRANSITORIA"
  },
  {
    "codigo":1153349004,
    "descripcion":"POLICITEMIA FAMILIAR PRIMARIA DEBIDA A MUTACIÓN DEL RECEPTOR DE ERITROPOYETINA"
  },
  {
    "codigo":15746281000119101,
    "descripcion":"INESTABILIDAD DE ARTICULACIÓN DE AMBAS MANOS"
  },
  {
    "codigo":234010000,
    "descripcion":"PERFORACIÓN DE ARTERIA CORONARIA"
  },
  {
    "codigo":299546001,
    "descripcion":"AMPLITUD DE EVERSIÓN ACTIVA DE ARTICULACIÓN SUBASTRAGALINA NORMAL"
  },
  {
    "codigo":365082002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA COMUNICAR NECESIDADES Y DESEOS"
  },
  {
    "codigo":430618002,
    "descripcion":"PAREJA DOMÉSTICA"
  },
  {
    "codigo":1217050005,
    "descripcion":"REGULACIÓN ANORMAL DE CARBOHIDRATO"
  },
  {
    "codigo":102938007,
    "descripcion":"DIFICULTAD PARA ESCRIBIR"
  },
  {
    "codigo":428783003,
    "descripcion":"OSTEOMIELITIS CAUSADA POR STAPHYLOCOCCUS AUREUS"
  },
  {
    "codigo":264943005,
    "descripcion":"AGUDEZA VISUAL DE PROYECCIÓN DE LA LUZ - PROYECCIÓN INEXACTA"
  },
  {
    "codigo":363247006,
    "descripcion":"ENFERMEDAD RELACIONADA CON LA OBESIDAD"
  },
  {
    "codigo":35567006,
    "descripcion":"PSEUDOPUBERTAD ISOSEXUAL PRECOZ"
  },
  {
    "codigo":263108000,
    "descripcion":"FRACTURA-SUBLUXACIÓN SEMILUNAR"
  },
  {
    "codigo":230340001,
    "descripcion":"TEMBLOR FACIAL AISLADO"
  },
  {
    "codigo":426948001,
    "descripcion":"ANEURISMA DE AORTA DESCENDENTE"
  },
  {
    "codigo":15664361000119105,
    "descripcion":"NEVO CISTOIDE DE CONJUNTIVAS DE AMBOS OJOS"
  },
  {
    "codigo":294041001,
    "descripcion":"ALERGIA A REPROTEROL"
  },
  {
    "codigo":195737004,
    "descripcion":"BRONQUIOLITIS EXUDATIVA AGUDA"
  },
  {
    "codigo":64665009,
    "descripcion":"FRACTURA NO EXPUESTA DE CALCÁNEO"
  },
  {
    "codigo":95598005,
    "descripcion":"QUISTE OVÁRICO ROTO"
  },
  {
    "codigo":783726006,
    "descripcion":"HIDROCEFALIA FETAL"
  },
  {
    "codigo":318851000119103,
    "descripcion":"ARTRITIS REUMATOIDEA SEROPOSITIVA DE ARTICULACIÓN DE CODO IZQUIERDO"
  },
  {
    "codigo":423278008,
    "descripcion":"LENTIGO MALIGNO DE PIEL DE PÁRPADO"
  },
  {
    "codigo":292206009,
    "descripcion":"REACCIÓN ADVERSA A LA IFOSFAMIDA"
  },
  {
    "codigo":126531004,
    "descripcion":"NEOPLASIA DE LA PIEL DEL PIE"
  },
  {
    "codigo":290371007,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR OMEPRAZOL"
  },
  {
    "codigo":93763008,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL COLÉDOCO"
  },
  {
    "codigo":91928001,
    "descripcion":"RINITIS ALÉRGICA CAUSADA POR POLEN DE HIERBAS"
  },
  {
    "codigo":124696003,
    "descripcion":"DEFICIENCIA DE METIONINA - ARNT LIGASA"
  },
  {
    "codigo":253933000,
    "descripcion":"MACRODACTILIA DE PULGAR"
  },
  {
    "codigo":286701000,
    "descripcion":"NIVEL MODERADO DE PSICOTICISMO"
  },
  {
    "codigo":1204205002,
    "descripcion":"TAQUICARDIA VENTRICULAR DE TRACTO DE SALIDA IZQUIERDO"
  },
  {
    "codigo":24557004,
    "descripcion":"ABSCESO DE INTESTINO"
  },
  {
    "codigo":57325008,
    "descripcion":"ISOINMUNIZACIÓN"
  },
  {
    "codigo":22722001,
    "descripcion":"NEUROPATÍA PERIFÉRICA IDIOPÁTICA"
  },
  {
    "codigo":90093009,
    "descripcion":"ACIDURIA ORÓTICA HEREDITARIA, TIPO 2"
  },
  {
    "codigo":385005009,
    "descripcion":"MARGEN LATERAL DE RESECCIÓN QUIRÚRGICA AFECTADO POR NEOPLASIA MALIGNA"
  },
  {
    "codigo":55490007,
    "descripcion":"ESTRIDOR LARÍNGEO CONGÉNITO"
  },
  {
    "codigo":186562009,
    "descripcion":"TRASTORNO INTESTINAL DEBIDO A SARAMPIÓN"
  },
  {
    "codigo":250263002,
    "descripcion":"PRUEBA DE SUERO ACIDIFICADO NEGATIVA"
  },
  {
    "codigo":86423004,
    "descripcion":"PÓLIPO DE LA LARINGE"
  },
  {
    "codigo":283031005,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DEL BRAZO"
  },
  {
    "codigo":1264236000,
    "descripcion":"INFECCIÓN URINARIA POSTERIOR A EMBARAZO MOLAR"
  },
  {
    "codigo":1297004004,
    "descripcion":"CIERRE DE ÁNGULO AGUDO BILATERAL"
  },
  {
    "codigo":10669751000119101,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN EN REGIÓN COCCÍGEA DE ESPALDA NO ESTADIFICABLE"
  },
  {
    "codigo":312129004,
    "descripcion":"INFECCIÓN BACTERIANA DEL APARATO DIGESTIVO"
  },
  {
    "codigo":1196865005,
    "descripcion":"SCHWANNOMA DE PIEL"
  },
  {
    "codigo":443201006,
    "descripcion":"INFLAMACIÓN DE COROIDES CAUSADA POR PNEUMOCYSTIS JIROVECI"
  },
  {
    "codigo":15912631000119102,
    "descripcion":"FRACTURA NO EXPUESTA DE TROCÁNTER DE FÉMUR DERECHO"
  },
  {
    "codigo":310294002,
    "descripcion":"ANTICUERPOS ANTIMITOCONDRIALES DETECTADOS"
  },
  {
    "codigo":277526007,
    "descripcion":"MELANOSIS DIFUSA DE MENINGES"
  },
  {
    "codigo":898283000,
    "descripcion":"ANQUILOSIS CONGÉNITA DE ARTICULACIÓN METATARSOFALÁNGICA DE TERCER DEDO DE PIE"
  },
  {
    "codigo":15382009,
    "descripcion":"INTOXICACIÓN POR TIOURACILO"
  },
  {
    "codigo":1162262007,
    "descripcion":"ÚLCERA DE LABIO INFERIOR"
  },
  {
    "codigo":275691001,
    "descripcion":"ATENDIDO EN DOMICILIO GERIÁTRICO"
  },
  {
    "codigo":111851005,
    "descripcion":"ENCEFALITIS ADENOVIRAL SUBAGUDA"
  },
  {
    "codigo":13547006,
    "descripcion":"INTOXICACIÓN POR RHODODENDRON"
  },
  {
    "codigo":44480001,
    "descripcion":"PIE PLANO FLEXIBLE ADQUIRIDO"
  },
  {
    "codigo":210155009,
    "descripcion":"LESIÓN TRAUMÁTICA DE CABEZA DE PÁNCREAS CON HERIDA ABIERTA HACIA CAVIDAD ABDOMINAL"
  },
  {
    "codigo":30241000175106,
    "descripcion":"ÚLCERA POR PRESIÓN EN CODO DERECHO, ESTADIO IV"
  },
  {
    "codigo":110016007,
    "descripcion":"RUPTURA DE CUERPO CAVERNOSO DE PENE"
  },
  {
    "codigo":698005000,
    "descripcion":"ANGULACIÓN DE RAÍZ DE DIENTE"
  },
  {
    "codigo":403093005,
    "descripcion":"ONICOMICOSIS CAUSADA POR ASPERGILLUS"
  },
  {
    "codigo":1351530005,
    "descripcion":"MACULOPATÍA EN CÚPULA DE OJO IZQUIERDO"
  },
  {
    "codigo":302954008,
    "descripcion":"QUISTE EMBRIONARIO DE TROMPA DE FALOPIO"
  },
  {
    "codigo":301119002,
    "descripcion":"HALLAZGO AUSENTE EN EL ELECTROCARDIOGRAMA"
  },
  {
    "codigo":366655003,
    "descripcion":"HALLAZGO RELACIONADO CON EL COLOR DE LAS UÑAS"
  },
  {
    "codigo":16705361000119104,
    "descripcion":"NEOPLASIA DE RIÑÓN IZQUIERDO"
  },
  {
    "codigo":397588000,
    "descripcion":"DEMUESTRA CONOCIMIENTO DE RESPUESTAS ESPERADAS PARA UN PROCEDIMIENTO OPERATIVO"
  },
  {
    "codigo":202815009,
    "descripcion":"ANQUILOSIS CERVICODORSAL"
  },
  {
    "codigo":6207008,
    "descripcion":"INFECCIÓN CAUSADA POR THYSANIEZIA"
  },
  {
    "codigo":364820004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD DE UTILIZAR CUBIERTOS PARA ALIMENTARSE"
  },
  {
    "codigo":321361000119106,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE TENDÓN EXTENSOR DE ANTEBRAZO IZQUIERDO"
  },
  {
    "codigo":233748006,
    "descripcion":"NEUMOCONIOSIS SIMPLE"
  },
  {
    "codigo":231913002,
    "descripcion":"PIGMENTACIÓN HEMÁTICA DE LA CÓRNEA"
  },
  {
    "codigo":11790161000119107,
    "descripcion":"LESIÓN TRAUMÁTICA DE DEDO DE MANO DERECHA"
  },
  {
    "codigo":788969005,
    "descripcion":"HIPOTENSIÓN INTRACRANEANA DEBIDA A PUNCIÓN LUMBAR Y POSTERIOR A ELLA"
  },
  {
    "codigo":166377005,
    "descripcion":"NIVEL DE HORMONA FOLICULOESTIMULANTE FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":362985009,
    "descripcion":"ACTIVACIÓN E INACTIVACIÓN MEDIADAS POR ANTICUERPOS"
  },
  {
    "codigo":262846002,
    "descripcion":"RUPTURA DUODENAL"
  },
  {
    "codigo":721598002,
    "descripcion":"ADENOMA LACTANTE DE MAMA"
  },
  {
    "codigo":197310003,
    "descripcion":"CIRROSIS BILIAR EN LOS NIÑOS"
  },
  {
    "codigo":787134009,
    "descripcion":"METABOLIZADOR ULTRARRÁPIDO DE LA SUBUNIDAD 1 DEL COMPLEJO VITAMINA K-EPÓXIDO REDUCTASA"
  },
  {
    "codigo":293779007,
    "descripcion":"ALERGIA A CARBOPLATINO"
  },
  {
    "codigo":41821000087103,
    "descripcion":"CELULITIS DE PABELLÓN AURICULAR IZQUIERDO"
  },
  {
    "codigo":785299009,
    "descripcion":"LISENCEFALIA EN EMPEDRADO SIN COMPROMISO MUSCULAR U OCULAR"
  },
  {
    "codigo":46941000087107,
    "descripcion":"FRACTURA DE FALANGE MEDIA DE DEDO MEDIO IZQUIERDO"
  },
  {
    "codigo":29800004,
    "descripcion":"PERMEABILIDAD CAPILAR DISMINUIDA"
  },
  {
    "codigo":44381000087109,
    "descripcion":"CONTUSIÓN DE MÚSCULO DORSAL ANCHO DERECHO"
  },
  {
    "codigo":39261000087109,
    "descripcion":"CONTUSIÓN DE GLÚTEO DERECHO"
  },
  {
    "codigo":95336007,
    "descripcion":"LIPODERMATOSCLEROSIS LOCALIZADA"
  },
  {
    "codigo":291944008,
    "descripcion":"INTOXICACIÓN POR DISOPIRAMIDA"
  },
  {
    "codigo":1142077001,
    "descripcion":"HIPERBILIRRUBINEMIA NEONATAL CAUSADA POR SUSTANCIA TRANSMITIDA POR LA MADRE"
  },
  {
    "codigo":290109002,
    "descripcion":"SECRECIÓN SEROSA POR PEZÓN"
  },
  {
    "codigo":1240381003,
    "descripcion":"TRASTORNO NEONATAL PRECOZ DEBIDO A PLACENTA GRANDE"
  },
  {
    "codigo":60733007,
    "descripcion":"HIPOTIROIDISMO SECUNDARIO A AMILOIDOSIS"
  },
  {
    "codigo":288274003,
    "descripcion":"SUFRIMIENTO FETAL, DURANTE EL TRABAJO DE PARTO"
  },
  {
    "codigo":124434006,
    "descripcion":"DEFICIENCIA DE 5' - NUCLEOTIDASA"
  },
  {
    "codigo":188135003,
    "descripcion":"NEOPLASIA MALIGNA DE PIEL DEL TALÓN"
  },
  {
    "codigo":284604000,
    "descripcion":"CONDUCTA PARA LOGRAR PROXIMIDAD"
  },
  {
    "codigo":286439009,
    "descripcion":"DIFICULTAD PARA PLANIFICAR LAS COMIDAS"
  },
  {
    "codigo":415676003,
    "descripcion":"EL MARGEN QUIRÚRGICO DISTAL ES EL MARGEN NO AFECTADO MÁS CERCANO A LA NEOPLASIA MALIGNA"
  },
  {
    "codigo":282769003,
    "descripcion":"LESIÓN DE REGIÓN LATERAL DEL TÓRAX"
  },
  {
    "codigo":20625004,
    "descripcion":"OBSTRUCCIÓN OCASIONADA POR LA POSICIÓN DEL FETO AL INICIO DEL TRABAJO DE PARTO"
  },
  {
    "codigo":118929006,
    "descripcion":"TRASTORNO DE LA AXILA"
  },
  {
    "codigo":315537008,
    "descripcion":"NACIDO EN TAIWÁN"
  },
  {
    "codigo":1231206001,
    "descripcion":"MENINGOENCEFALOCELE ORBITARIO"
  },
  {
    "codigo":706918002,
    "descripcion":"STAPHYLOCOCCUS AUREUS NO AISLADO"
  },
  {
    "codigo":84326006,
    "descripcion":"FOTOTOXICIDAD"
  },
  {
    "codigo":248166007,
    "descripcion":"VESTIDO ELEGANTEMENTE"
  },
  {
    "codigo":1263974007,
    "descripcion":"HEMORRAGIA FETAL NO TRAUMÁTICA DE ESPACIO SUBARACNOIDEO DE CEREBRO"
  },
  {
    "codigo":49723003,
    "descripcion":"INVAGINACIÓN DEL INTESTINO"
  },
  {
    "codigo":770619007,
    "descripcion":"MEMBRANA ESOFÁGICA SUPERIOR CONGÉNITA"
  },
  {
    "codigo":705083008,
    "descripcion":"SENSACIÓN DE IRRITACIÓN EN EL GLOBO OCULAR"
  },
  {
    "codigo":1293072000,
    "descripcion":"MESENQUIMOMA FIBROCARTILAGINOSO"
  },
  {
    "codigo":11792671000119105,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE DEDO DE LA MANO IZQUIERDA"
  },
  {
    "codigo":275429002,
    "descripcion":"PARTO TARDÍO DEL SEGUNDO GEMELAR"
  },
  {
    "codigo":15698361000119101,
    "descripcion":"OSTEÍTIS DE MITAD IZQUIERDA DE PELVIS"
  },
  {
    "codigo":766949003,
    "descripcion":"OBSTRUCCIÓN DE VENA CAVA SUPERIOR"
  },
  {
    "codigo":13285005,
    "descripcion":"CISTITIS QUÍSTICA"
  },
  {
    "codigo":111589005,
    "descripcion":"DISFIBRINOGENEMIA"
  },
  {
    "codigo":404666000,
    "descripcion":"OSCURECIMIENTO VISUAL"
  },
  {
    "codigo":109754001,
    "descripcion":"FRACTURA DE CORONA Y RAÍZ DE DIENTE"
  },
  {
    "codigo":240826007,
    "descripcion":"FILARIASIS AGUDA DE MALASIA"
  },
  {
    "codigo":206223002,
    "descripcion":"LACERACIÓN DE MÉDULA ESPINAL DEBIDA A TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":271759003,
    "descripcion":"ERUPCIÓN BULLOSA"
  },
  {
    "codigo":402831004,
    "descripcion":"TELANGIECTASIA POR VASODILATACIÓN PROLONGADA"
  },
  {
    "codigo":370063005,
    "descripcion":"INVASIÓN TUMORAL EN EL PARÉNQUIMA PULMONAR"
  },
  {
    "codigo":1156495004,
    "descripcion":"SARCOMA DE CÉLULAS DENDRÍTICAS"
  },
  {
    "codigo":763279007,
    "descripcion":"SÍNDROME DE DISMORFISMO FACIAL, HIPOACUSIA DE CONDUCCIÓN Y DEFECTO CARDÍACO"
  },
  {
    "codigo":238991008,
    "descripcion":"ERUPCIÓN SEMEJANTE A ECCEMA SEBORREICO"
  },
  {
    "codigo":7780000,
    "descripcion":"FÍSTULA DUODENAL"
  },
  {
    "codigo":73316002,
    "descripcion":"FRACTURA DE HUESO GRANDE DE LA MUÑECA"
  },
  {
    "codigo":237156004,
    "descripcion":"PERINEO RÍGIDO EN EL EMBARAZO, PARTO Y\/O PUERPERIO"
  },
  {
    "codigo":1351268008,
    "descripcion":"INMUNODEFICIENCIA VARIABLE COMÚN DEBIDA A DEFICIENCIA DE TACI"
  },
  {
    "codigo":366393004,
    "descripcion":"AMPLITUD DE MOVIMIENTO PASIVO DE FLEXIÓN LATERAL DE LA COLUMNA CERVICAL - HALLAZGO"
  },
  {
    "codigo":1090131000119102,
    "descripcion":"EDENTULISMO PARCIAL CLASE III DEBIDO A ENFERMEDAD PERIODONTAL"
  },
  {
    "codigo":300857009,
    "descripcion":"MASA DE ESTRUCTURA DE VÍAS URINARIAS"
  },
  {
    "codigo":69646003,
    "descripcion":"OCENA"
  },
  {
    "codigo":266254007,
    "descripcion":"OCLUSIÓN DE ARTERIA CARÓTIDA"
  },
  {
    "codigo":200718008,
    "descripcion":"PIODERMIA ULCEROSA TROPICAL"
  },
  {
    "codigo":725006009,
    "descripcion":"DISTENSIÓN DE MÚSCULO DE LA CABEZA"
  },
  {
    "codigo":723171001,
    "descripcion":"AUSENCIA ADQUIRIDA DE CUELLO UTERINO Y ÚTERO"
  },
  {
    "codigo":1149155004,
    "descripcion":"NIVEL DE AGITACIÓN DISMINUIDO"
  },
  {
    "codigo":428259005,
    "descripcion":"SÍNDROME DE LA MÉDULA ESPINAL ANCLADA ADQUIRIDO"
  },
  {
    "codigo":721336000,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA COMPLETA DE NARIZ"
  },
  {
    "codigo":65976001,
    "descripcion":"DISOSTOSIS CLEIDOCRANEAL"
  },
  {
    "codigo":440501000124101,
    "descripcion":"INGESTA EXCESIVA DE ADITIVO ALIMENTARIO NO NUTRITIVO"
  },
  {
    "codigo":195213000,
    "descripcion":"SÍNDROME DE ACCIDENTE VASCULAR CEREBELOSO"
  },
  {
    "codigo":295352008,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE CIMETIDINA"
  },
  {
    "codigo":31373002,
    "descripcion":"ESQUIZOFRENIA DESORGANIZADA EN REMISIÓN"
  },
  {
    "codigo":719501003,
    "descripcion":"FALLA DE ULTRAFILTRACIÓN"
  },
  {
    "codigo":293517002,
    "descripcion":"REACCIÓN ADVERSA A LA DIGOXINA"
  },
  {
    "codigo":181000124108,
    "descripcion":"VIRUS INFLUENZA A PRESENTE"
  },
  {
    "codigo":162445006,
    "descripcion":"EL SÍNTOMA DURA HORAS"
  },
  {
    "codigo":1145485007,
    "descripcion":"HIPOPLASIA CONGÉNITA DE FALANGE DE DEDO MEÑIQUE"
  },
  {
    "codigo":440009,
    "descripcion":"HIPERFENILALANINEMIA PERSISTENTE"
  },
  {
    "codigo":226146000,
    "descripcion":"DIETA RICA EN VITAMINA B6"
  },
  {
    "codigo":291682003,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ETAMBUTOL"
  },
  {
    "codigo":95074005,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA PIEL DEL CUELLO"
  },
  {
    "codigo":29538005,
    "descripcion":"CRISIS GLAUCOMATOCICLÍTICA"
  },
  {
    "codigo":783202008,
    "descripcion":"POLICITEMIA SECUNDARIA AUTOSÓMICA DOMINANTE"
  },
  {
    "codigo":93239001,
    "descripcion":"HIPOPLASIA CONGÉNITA DE ARCO DE VÉRTEBRA CERVICAL"
  },
  {
    "codigo":289847001,
    "descripcion":"OVARIO NORMAL"
  },
  {
    "codigo":224311000,
    "descripcion":"CONCURRE A INSTITUCIÓN DE EDUCACIÓN SUPERIOR"
  },
  {
    "codigo":1303820006,
    "descripcion":"ARTRITIS DE ARTICULACIÓN SACROILÍACA"
  },
  {
    "codigo":124172007,
    "descripcion":"DEFICIENCIA DE D - AMINOÁCIDO OXIDASA"
  },
  {
    "codigo":253409001,
    "descripcion":"CUERDAS TENDINOSAS DE VÁLVULA MITRAL EXCESIVAMENTE LARGAS"
  },
  {
    "codigo":417249005,
    "descripcion":"RESONANCIA MAGNÉTICA DE TÓRAX, NORMAL"
  },
  {
    "codigo":24033006,
    "descripcion":"RIGIDEZ DIFUSA"
  },
  {
    "codigo":710326000,
    "descripcion":"ESPECIE DE CELLULOMONAS O ESPECIE DE MICROBACTERIUM"
  },
  {
    "codigo":286177009,
    "descripcion":"DIFICULTAD PARA HACER LA CAMA"
  },
  {
    "codigo":284342002,
    "descripcion":"INCAPAZ DE PONERLE LA TAPA A UN RECIPIENTE"
  },
  {
    "codigo":251574004,
    "descripcion":"POTENCIACIÓN POSACTIVACIÓN (TETÁNICA)"
  },
  {
    "codigo":448182006,
    "descripcion":"DEFECTO DEL TABIQUE AURICULOVENTRICULAR CON COMPONENTE VENTRICULAR Y CORTOCIRCUITO INTERCORDAL POR DEBAJO DE VÁLVULA EN PUENTE INFERIOR"
  },
  {
    "codigo":282507001,
    "descripcion":"BAJA UNA COLINA CORRIENDO"
  },
  {
    "codigo":1003403001,
    "descripcion":"DISOMÍA UNIPARENTAL MATERNA DEL CROMOSOMA 11"
  },
  {
    "codigo":249739008,
    "descripcion":"BRAZO CORTO"
  },
  {
    "codigo":444512003,
    "descripcion":"PORTA UNA JERINGA PRECARGADA TIPO LAPICERA CON EPINEFRINA"
  },
  {
    "codigo":1296480005,
    "descripcion":"HIPOGLUCEMIA HIPERINSULINÉMICA FAMILIAR"
  },
  {
    "codigo":1362016007,
    "descripcion":"SOBREEXTENSIÓN DE MATERIAL DE RELLENO ENDODÓNCICO"
  },
  {
    "codigo":247904009,
    "descripcion":"COMIENZO DE MOVIMIENTO RETARDADO"
  },
  {
    "codigo":16028551000119107,
    "descripcion":"EXOSTOSIS DE PERONÉ IZQUIERDO"
  },
  {
    "codigo":737589003,
    "descripcion":"ÁCIDO DESOXIRRIBONUCLEICO DE BORDETELLA PERTUSSIS NO DETECTADO"
  },
  {
    "codigo":278837001,
    "descripcion":"RECIÉN CASADO"
  },
  {
    "codigo":113162000,
    "descripcion":"SIMBIOSIS DIÁDICA"
  },
  {
    "codigo":14858001,
    "descripcion":"ENOFTALMOS POR PROCEDIMIENTO QUIRÚRGICO"
  },
  {
    "codigo":277002002,
    "descripcion":"DEFECTO DE BASTONES"
  },
  {
    "codigo":735754001,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO PERIFÉRICO DEL ABDOMEN"
  },
  {
    "codigo":1260042002,
    "descripcion":"CARCINOMA ADENOESCAMOSO DE PULMÓN"
  },
  {
    "codigo":702986006,
    "descripcion":"SHEWANELLA ALGAE O SHEWANELLA PUTREFACIENS"
  },
  {
    "codigo":80394007,
    "descripcion":"HIPERGLUCEMIA"
  },
  {
    "codigo":16288341000119100,
    "descripcion":"DISECCIÓN DE ARTERIA FEMORAL IZQUIERDA"
  },
  {
    "codigo":111327006,
    "descripcion":"ANOMALÍA CONGÉNITA DE LA GLÁNDULA SALIVAL"
  },
  {
    "codigo":371636000,
    "descripcion":"ESTADO DEL CUERPO, DESCONOCIDO"
  },
  {
    "codigo":109492001,
    "descripcion":"DISPLASIA DE LA DENTINA"
  },
  {
    "codigo":439007008,
    "descripcion":"PÚRPURA TROMBÓTICA TROMBOCITOPÉNICA ADQUIRIDA"
  },
  {
    "codigo":43956002,
    "descripcion":"AMPOLLA DE CODO CON INFECCIÓN"
  },
  {
    "codigo":240564002,
    "descripcion":"NEUROSÍFILIS SECUNDARIA"
  },
  {
    "codigo":683041000119105,
    "descripcion":"CARCINOMA PRIMARIO EX ADENOMA PLEOMÓRFICO DE GLÁNDULA SUBMAXILAR"
  },
  {
    "codigo":699316006,
    "descripcion":"SÍNDROME DE MYHRE"
  },
  {
    "codigo":402569001,
    "descripcion":"ECCEMA VESICULAR CRÓNICO DE MANOS Y PIES"
  },
  {
    "codigo":38451003,
    "descripcion":"DISTIMIA PRIMARIA DE INICIO TEMPRANO"
  },
  {
    "codigo":16003831000119100,
    "descripcion":"ARTROPATÍA DE MANGUITO ROTADOR DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":10679031000119101,
    "descripcion":"TUMEFACCIÓN LOCALIZADA DE LA MANO DERECHA"
  },
  {
    "codigo":890419006,
    "descripcion":"SINDACTILIA CON FUSIÓN DE HUESOS DE DEDOS DE LA MANO BILATERAL"
  },
  {
    "codigo":339191000119100,
    "descripcion":"OFTALMÍA NODOSA IZQUIERDA"
  },
  {
    "codigo":298231000119102,
    "descripcion":"MIOSITIS OSIFICANTE TRAUMÁTICA DE MANO"
  },
  {
    "codigo":169523009,
    "descripcion":"PREPARADOS ANTICONCEPTIVOS DE LIBERACIÓN LENTA - SUSPENSIÓN DEL USO"
  },
  {
    "codigo":16055031000119100,
    "descripcion":"ASTIGMATISMO DE OJO DERECHO DESPUÉS DE PROCEDIMIENTO QUIRÚRGICO"
  },
  {
    "codigo":10630391000119107,
    "descripcion":"LINFANGITIS AGUDA DE AXILA DERECHA"
  },
  {
    "codigo":16026871000119101,
    "descripcion":"TRASTORNO DE NERVIO SUPRAESCAPULAR IZQUIERDO"
  },
  {
    "codigo":366131007,
    "descripcion":"HALLAZGO RELACIONADO CON RESONANCIA TORÁCICA A LA PERCUSIÓN"
  },
  {
    "codigo":16894711000119103,
    "descripcion":"DEFICIENCIA DE INMUNOGLOBULINA G POR MIELOMA MÚLTIPLE"
  },
  {
    "codigo":308471000119108,
    "descripcion":"GRANULOMA POR CUERPO EXTRAÑO DE PARTES BLANDAS DE HOMBRO DERECHO"
  },
  {
    "codigo":16016631000119106,
    "descripcion":"RUPTURA DEGENERATIVA DE MENISCO EXTERNO DE RODILLA IZQUIERDA"
  },
  {
    "codigo":83191000119105,
    "descripcion":"INCIDENTALOMA DE GLÁNDULA TIROIDES"
  },
  {
    "codigo":36616006,
    "descripcion":"LINFANGITIS AGUDA DE INGLE"
  },
  {
    "codigo":34781003,
    "descripcion":"SÍNDROME DE LA ARTERIA VERTEBRAL"
  },
  {
    "codigo":318711000119107,
    "descripcion":"ARTROSIS DE ARTICULACIÓN DE MANO DERECHA"
  },
  {
    "codigo":15980791000119108,
    "descripcion":"ANOMALÍA ESTRUCTURAL CONGÉNITA DE PÁRPADO IZQUIERDO"
  },
  {
    "codigo":16636151000119109,
    "descripcion":"LESIÓN BILATERAL DE NERVIOS TIBIALES"
  },
  {
    "codigo":1148893001,
    "descripcion":"ANEMIA HEMOLÍTICA DEBIDA A DEFICIENCIA DE GLICERALDEHÍDO - 3 - FOSFATO DESHIDROGENASA"
  },
  {
    "codigo":722909009,
    "descripcion":"HEMORRAGIA TRAUMÁTICA DE ESPACIO EPIDURAL INTRACRANEAL DEBIDA A TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":721074002,
    "descripcion":"BAJA ESTATURA DEBIDA A DEFICIENCIA PRIMARIA DE SUBUNIDAD ÁCIDO-LÁBIL"
  },
  {
    "codigo":1343666001,
    "descripcion":"ATELECTASIA DE MEMBRANA TIMPÁNICA DEBIDA A INFLAMACIÓN CRÓNICA DE OÍDO MEDIO SUPURATIVA"
  },
  {
    "codigo":1145223000,
    "descripcion":"RADICULITIS DEBIDA A RUPTURA DE DISCO INTERVERTEBRAL LUMBAR"
  },
  {
    "codigo":424327005,
    "descripcion":"ACTINOMICOSIS DE AMÍGDALA"
  },
  {
    "codigo":293255006,
    "descripcion":"REACCIÓN ADVERSA AL ETINILESTRADIOL"
  },
  {
    "codigo":719239007,
    "descripcion":"TIENE MÉDICO GENERAL PARA LA ATENCIÓN EN EL FINAL DE LA VIDA"
  },
  {
    "codigo":193116003,
    "descripcion":"SÍNDROME DEL MIEMBRO FANTASMA SIN DOLOR"
  },
  {
    "codigo":94812006,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL DIAFRAGMA"
  },
  {
    "codigo":782940006,
    "descripcion":"SÍNDROME DE DOBROW"
  },
  {
    "codigo":289585005,
    "descripcion":"LOQUIOS NORMALES"
  },
  {
    "codigo":846641006,
    "descripcion":"AFECCIÓN RESPIRATORIA CAUSADA POR VAPOR"
  },
  {
    "codigo":92977007,
    "descripcion":"AUSENCIA CONGÉNITA DE LA ARTERIA SUBCLAVIA"
  },
  {
    "codigo":1010481006,
    "descripcion":"ESCLEROSIS DE EPÍFISIS DE FALANGE MEDIA DE DEDO ÍNDICE CON RADIOPACIDAD AUMENTADA"
  },
  {
    "codigo":123910004,
    "descripcion":"INTOXICACIÓN POR RUBIACEAE"
  },
  {
    "codigo":25606004,
    "descripcion":"SÍNDROME DE EHLERS-DANLOS, DEFICIENCIA DE HIDROXILISINA"
  },
  {
    "codigo":58374007,
    "descripcion":"TUBERCULOSIS DIFUSA AGUDA"
  },
  {
    "codigo":253147000,
    "descripcion":"LISENCEFALIA TIPO 1"
  },
  {
    "codigo":285915001,
    "descripcion":"DIFICULTAD PARA UTILIZAR INSTALACIONES PARA LA HIGIENE"
  },
  {
    "codigo":254982009,
    "descripcion":"NEOPLASIA DE NERVIO ESPINAL Y SU VAINA"
  },
  {
    "codigo":713734009,
    "descripcion":"INFECCIÓN CAUSADA POR DERMATOFITO CONCOMITANTE CON INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":449755004,
    "descripcion":"PUNTO DE PRESIÓN CUTÁNEA RELACIONADA CON DISPOSITIVO"
  },
  {
    "codigo":11826671000119104,
    "descripcion":"DISTENSIÓN DE MÚSCULO DE LA MANO IZQUIERDA"
  },
  {
    "codigo":1268955002,
    "descripcion":"TUMOR DE TRITÓN MALIGNO PRIMARIO"
  },
  {
    "codigo":249477003,
    "descripcion":"SED AUMENTADA"
  },
  {
    "codigo":1363589008,
    "descripcion":"CRANEOSINOSTOSIS BICORONAL Y SAGITAL NO SINDRÓMICA"
  },
  {
    "codigo":413317009,
    "descripcion":"PROBLEMA EN EL ROL PARENTAL"
  },
  {
    "codigo":313178001,
    "descripcion":"GESTACIÓN DE MENOS DE 24 SEMANAS"
  },
  {
    "codigo":216709008,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR FOSDRINA"
  },
  {
    "codigo":1263450003,
    "descripcion":"TUMOR MALIGNO DE CÉLULAS GERMINALES NO DISGERMINOMATOSO DE OVARIO"
  },
  {
    "codigo":15732361000119103,
    "descripcion":"ENTROPIÓN MECÁNICO BILATERAL"
  },
  {
    "codigo":737327002,
    "descripcion":"INSUFICIENCIA RENAL POSTERIOR A EMBARAZO MOLAR"
  },
  {
    "codigo":770095003,
    "descripcion":"PARÁLISIS DE NERVIO CRANEAL DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":278575006,
    "descripcion":"CORONA DENTAL MUY CLARA"
  },
  {
    "codigo":735492001,
    "descripcion":"TRABAJO DE PARTO OBSTRUIDO DEBIDO A DISTOCIA DE HOMBRO"
  },
  {
    "codigo":81967009,
    "descripcion":"INTOXICACIÓN POR NARTECIUM OSSIFRAGUM"
  },
  {
    "codigo":1259780002,
    "descripcion":"HISTIOCITOMA FIBROSO MALIGNO SUPERFICIAL CUTÁNEO PRIMARIO"
  },
  {
    "codigo":440580005,
    "descripcion":"ATENDIDO EN CONSULTORIO ESPECIALIZADO EN MEDICINA FETAL"
  },
  {
    "codigo":209369001,
    "descripcion":"FRACTURA-LUXACIÓN EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA DE MÚLTIPLES DEDOS DEL PIE"
  },
  {
    "codigo":733657002,
    "descripcion":"DIVERTICULOSIS DE COLON"
  },
  {
    "codigo":307673003,
    "descripcion":"NISTAGMO VESTIBULAR PERIFÉRICO"
  },
  {
    "codigo":76462000,
    "descripcion":"POLINEUROPATÍA POSTHERPÉTICA"
  },
  {
    "codigo":830126000,
    "descripcion":"ELEVACIÓN NORMAL DE AMBOS MIEMBROS INFERIORES EXTENDIDOS"
  },
  {
    "codigo":12761008,
    "descripcion":"DERMATITIS FOTOALÉRGICA AGUDA"
  },
  {
    "codigo":1256110003,
    "descripcion":"TIENE ACCESO A INFORMACIÓN COMPRENSIBLE SOBRE DECISIONES RELACIONADAS CON LA SALUD"
  },
  {
    "codigo":371374003,
    "descripcion":"PRODUCTOS DE LA CONCEPCIÓN RETENIDOS"
  },
  {
    "codigo":305838003,
    "descripcion":"VISTO POR PROFESIONAL RELACIONADO CON LA MEDICINA - SERVICIO"
  },
  {
    "codigo":240302002,
    "descripcion":"ERITRODERMIA NEONATAL"
  },
  {
    "codigo":404142007,
    "descripcion":"PLASMOCITOMA CUTÁNEO PRIMARIO"
  },
  {
    "codigo":762755000,
    "descripcion":"DERMATITIS ALÉRGICA POR CONTACTO CAUSADA POR CALZADO"
  },
  {
    "codigo":402307000,
    "descripcion":"PSORIASIS CRÓNICA EN PLACAS GRANDES"
  },
  {
    "codigo":369539000,
    "descripcion":"TUMOR MALIGNO QUE COMPROMETE EL LIGAMENTO ANCHO DERECHO POR PROPAGACIÓN DIRECTA DEL OVARIO"
  },
  {
    "codigo":74627003,
    "descripcion":"COMPLICACIÓN DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":43694004,
    "descripcion":"ÚLCERA GÁSTRICA AGUDA CON PERFORACIÓN Y OBSTRUCCIÓN"
  },
  {
    "codigo":9091006,
    "descripcion":"IRIDOCICLITIS GONOCÓCICA"
  },
  {
    "codigo":238467007,
    "descripcion":"CALLO POR COMPRESIÓN"
  },
  {
    "codigo":302168000,
    "descripcion":"INFLAMACIÓN DEL INTESTINO GRUESO"
  },
  {
    "codigo":205699007,
    "descripcion":"SÍNDROME DE KLINEFELTER, XXYY"
  },
  {
    "codigo":236632007,
    "descripcion":"TRASTORNO FUNCIONAL DE VEJIGA URINARIA"
  },
  {
    "codigo":300333002,
    "descripcion":"HALLAZGO RELACIONADO CON LA SENSIBILIDAD HEPÁTICA"
  },
  {
    "codigo":11829181000119101,
    "descripcion":"AMPOLLA TRAUMÁTICA DE PIERNA DERECHA"
  },
  {
    "codigo":38189003,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN REGIÓN DE TOBILLO CON INFECCIÓN"
  },
  {
    "codigo":169261006,
    "descripcion":"TERMOGRAFÍA ANORMAL"
  },
  {
    "codigo":1119533006,
    "descripcion":"PRUEBA DE AGUDEZA VISUAL CON AGUJERO ESTENOPEICO ANORMAL"
  },
  {
    "codigo":398637008,
    "descripcion":"RETINA NORMAL"
  },
  {
    "codigo":365869009,
    "descripcion":"EJECUCIÓN DE MEMORIA VERBAL DE CORTO PLAZO - HALLAZGO"
  },
  {
    "codigo":304931000119109,
    "descripcion":"AUSENCIA CONGÉNITA DE ANTEBRAZO Y MANO IZQUIERDA"
  },
  {
    "codigo":3586005,
    "descripcion":"FUGA PSICÓGENA"
  },
  {
    "codigo":298498006,
    "descripcion":"DEFORMIDAD DE ARTICULACIÓN DE LA COLUMNA DORSAL"
  },
  {
    "codigo":167426005,
    "descripcion":"ELECTRÓLITOS EN ORINA FUERA DE RANGO DE REFERENCIA"
  },
  {
    "codigo":724482006,
    "descripcion":"INCAPACIDAD PARA TENER RELACIONES SEXUALES VAGINALES CONCOMITANTE CON BLOQUEO VAGINAL Y DEBIDA A ÉL"
  },
  {
    "codigo":429570006,
    "descripcion":"HISTIOCITOMA FIBROSO ATÍPICO DE PARTES BLANDAS"
  },
  {
    "codigo":1148631003,
    "descripcion":"RABDOMIÓLISIS PAROXÍSTICA"
  },
  {
    "codigo":720812002,
    "descripcion":"SÍNDROME DE CRANEOSINOSTOSIS, ANOMALÍA ANAL Y POROQUERATOSIS"
  },
  {
    "codigo":294828004,
    "descripcion":"ALERGIA A HORMONA TIROTRÓFICA"
  },
  {
    "codigo":130988005,
    "descripcion":"CONFUSIÓN CRÓNICA"
  },
  {
    "codigo":292993001,
    "descripcion":"EFECTO ADVERSO DEL CARBAPENEM"
  },
  {
    "codigo":1144961003,
    "descripcion":"NECROSIS TUBULAR AGUDA TÓXICA"
  },
  {
    "codigo":61782002,
    "descripcion":"PAECILOMICOSIS"
  },
  {
    "codigo":29014003,
    "descripcion":"FRACTURA EXPUESTA DE HUESO DEL CARPO"
  },
  {
    "codigo":127318002,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA ARTERIA PANCREATICODUODENAL INFERIOR"
  },
  {
    "codigo":94550007,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE PIEL DE CODO"
  },
  {
    "codigo":92715000,
    "descripcion":"CARCINOMA IN SITU DE LA PIEL DE LOS GLÚTEOS"
  },
  {
    "codigo":291158009,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR PIMOZIDA"
  },
  {
    "codigo":42760000,
    "descripcion":"FRACTURA EXPUESTA DE DIÁFISIS DE CÚBITO"
  },
  {
    "codigo":289323004,
    "descripcion":"EXUDACIÓN DEL MUÑÓN UMBILICAL"
  },
  {
    "codigo":780843004,
    "descripcion":"ECCEMA CRÓNICO DE PIE"
  },
  {
    "codigo":420395004,
    "descripcion":"ENDOCARDITIS AGUDA CON SIDA"
  },
  {
    "codigo":27179007,
    "descripcion":"ALTERACIÓN EN EL CUMPLIMIENTO DE ROLES"
  },
  {
    "codigo":90880000,
    "descripcion":"BIORRITMO CIRCASEPTANO ANORMAL"
  },
  {
    "codigo":10655831000119106,
    "descripcion":"ÚLCERA ISQUÉMICA ATEROSCLERÓTICA DE TALÓN DERECHO"
  },
  {
    "codigo":58112007,
    "descripcion":"MANOSIDOSIS, TIPO II"
  },
  {
    "codigo":123648007,
    "descripcion":"ALTERACIONES CROMOSÓMICAS DE LOS GRUPOS C Y X"
  },
  {
    "codigo":254720009,
    "descripcion":"TUMOR ECRINO MIXTO"
  },
  {
    "codigo":1336064007,
    "descripcion":"EPISODIO DE USO NOCIVO DE KETAMINA"
  },
  {
    "codigo":449493005,
    "descripcion":"LOCALIZACIÓN SUPRACARDÍACA DE CONEXIÓN VENOSA PULMONAR ANÓMALA A VENA VERTICAL EN EL LADO DERECHO"
  },
  {
    "codigo":56277006,
    "descripcion":"INTOXICACIÓN POR NALED"
  },
  {
    "codigo":447658000,
    "descripcion":"LINFOMA DE FONDO DEL ESTÓMAGO"
  },
  {
    "codigo":283818001,
    "descripcion":"MORDEDURA DE ANIMAL EN LA REGIÓN PÉLVICA"
  },
  {
    "codigo":85375000,
    "descripcion":"TIÑA FÁVICA"
  },
  {
    "codigo":249215002,
    "descripcion":"OLOR DE LOQUIOS"
  },
  {
    "codigo":10957041000119104,
    "descripcion":"HERIDA ABIERTA DE DEDO MEDIO DE MANO IZQUIERDA DEBIDA A MORDEDURA HUMANA"
  },
  {
    "codigo":16527601000119105,
    "descripcion":"CARCINOMA NO MICROCÍTICO PRIMARIO DE PULMÓN DERECHO"
  },
  {
    "codigo":773503009,
    "descripcion":"EPIDERMÓLISIS BULLOSA SIMPLE DEBIDA A DEFICIENCIA DE EXOFILINA 5"
  },
  {
    "codigo":312916003,
    "descripcion":"ISQUEMIA COROIDEA"
  },
  {
    "codigo":116308004,
    "descripcion":"HALLAZGO RELACIONADO CON REGIÓN DE HOMBRO"
  },
  {
    "codigo":16091531000119100,
    "descripcion":"PLIEGUE DE EPICANTO DE AMBOS OJOS"
  },
  {
    "codigo":295304003,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE ÁCIDO TIAPROFÉNICO"
  },
  {
    "codigo":704297004,
    "descripcion":"CON MAYOR RIESGO DE ALTERACIÓN DE LA FUNCIÓN DEL SISTEMA NERVIOSO"
  },
  {
    "codigo":48937005,
    "descripcion":"TRASTORNO BIPOLAR II, EPISODIO MÁS RECIENTE DE CARACTERÍSTICAS HIPOMANÍACAS"
  },
  {
    "codigo":407550000,
    "descripcion":"OBSERVACIÓN DE LA PIEL QUE RODEA AL ESTOMA"
  },
  {
    "codigo":309246000,
    "descripcion":"ARTROSIS DE ARTICULACIÓN DEL PIE"
  },
  {
    "codigo":79870002,
    "descripcion":"FUNCIÓN EXCRETORA DISMINUIDA"
  },
  {
    "codigo":473086001,
    "descripcion":"INFLAMACIÓN ASOCIADA CON IMPLANTE CARDÍACO"
  },
  {
    "codigo":702462000,
    "descripcion":"HIPOSPADIAS DE ESCROTO"
  },
  {
    "codigo":1259518000,
    "descripcion":"CARCINOMA PRIMARIO DE VÍA BILIAR EXTRAHEPÁTICA"
  },
  {
    "codigo":210942009,
    "descripcion":"EFECTO TARDÍO DE LESIÓN DEL SISTEMA NERVIOSO"
  },
  {
    "codigo":307411002,
    "descripcion":"RETRACCIÓN DE ILEOSTOMÍA"
  },
  {
    "codigo":733395002,
    "descripcion":"MÚLTIPLES LESIONES TRAUMÁTICAS SUPERFICIALES DE REGIÓN DEL HOMBRO"
  },
  {
    "codigo":438483005,
    "descripcion":"TROMBOFLEBITIS DE VENA SUBCLAVIA"
  },
  {
    "codigo":372947007,
    "descripcion":"SOMNOLENCIA EXCESIVA"
  },
  {
    "codigo":45267008,
    "descripcion":"QUEMADURA PROFUNDA DE TERCER GRADO DEL DORSO"
  },
  {
    "codigo":403880001,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS INTRAEPIDÉRMICO DE TRONCO"
  },
  {
    "codigo":371112003,
    "descripcion":"INMUNE CONTRA PAROTIDITIS URLIANA"
  },
  {
    "codigo":240040007,
    "descripcion":"PANICULITIS INFECCIOSA"
  },
  {
    "codigo":205437001,
    "descripcion":"ESPONDILOSINDESIS PARCIAL CONGÉNITA - INESTABLE"
  },
  {
    "codigo":860797003,
    "descripcion":"EDEMA GENERALIZADO DEBIDO A SOBRECARGA DE LÍQUIDOS"
  },
  {
    "codigo":762493006,
    "descripcion":"EMACIACIÓN DE CAUSA NUTRICIONAL EN LA LACTANCIA"
  },
  {
    "codigo":1286781008,
    "descripcion":"DISTENSIÓN DE TENDÓN DE MÚSCULO GLÚTEO"
  },
  {
    "codigo":400210000,
    "descripcion":"HEMANGIOMA"
  },
  {
    "codigo":8829008,
    "descripcion":"DEFICIENCIA AISLADA DE LUTROPINA"
  },
  {
    "codigo":269138001,
    "descripcion":"DISTENSIÓN DE TENDÓN DE MÚSCULOS GEMELOS"
  },
  {
    "codigo":203602007,
    "descripcion":"DESIGUALDAD ADQUIRIDA DE LA LONGITUD DE LOS BRAZOS"
  },
  {
    "codigo":201767000,
    "descripcion":"ARTRITIS REUMATOIDE DE LA ARTICULACIÓN ESTERNOCLAVICULAR"
  },
  {
    "codigo":234535004,
    "descripcion":"DISFUNCIÓN SELECTIVA DE INMUNOGLOBULINAS"
  },
  {
    "codigo":365607006,
    "descripcion":"NIVEL SÉRICO DE VITAMINA B12 - HALLAZGO"
  },
  {
    "codigo":298236009,
    "descripcion":"COLUMNA LUMBAR RÍGIDA"
  },
  {
    "codigo":1073701000119107,
    "descripcion":"ARTRITIS REUMATOIDE DE PIE IZQUIERDO"
  },
  {
    "codigo":722385008,
    "descripcion":"SÍNDROME DE DISGENESIA CEREBRAL, NEUROPATÍA, ICTIOSIS Y QUERATODERMIA PALMOPLANTAR"
  },
  {
    "codigo":1489008,
    "descripcion":"ORZUELO EXTERNO"
  },
  {
    "codigo":32422007,
    "descripcion":"DESCUIDO UNILATERAL"
  },
  {
    "codigo":294566007,
    "descripcion":"ALERGIA A NITROIMIDAZOL"
  },
  {
    "codigo":292731006,
    "descripcion":"REACCIÓN ADVERSA A ANTAGONISTA BENZODIAZEPÍNICO"
  },
  {
    "codigo":718715007,
    "descripcion":"SÍNDROME DE ACANTOSIS NIGRICANS Y RESISTENCIA A LA INSULINA CON CALAMBRES MUSCULARES Y AUMENTO DE TAMAÑO DE PARTES ACRAS"
  },
  {
    "codigo":1144699007,
    "descripcion":"HIPOPLASIA CONGÉNITA DE FALANGE DE TERCER DEDO DE PIE"
  },
  {
    "codigo":10631871000119105,
    "descripcion":"ONIQUIA DE PULGAR DERECHO"
  },
  {
    "codigo":94288005,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE SENO ETMOIDAL"
  },
  {
    "codigo":715045000,
    "descripcion":"CAPAZ DE OBTENER MEDICACIÓN"
  },
  {
    "codigo":127056008,
    "descripcion":"ENFERMEDAD CRÓNICA POR CRIOAGLUTININAS ASOCIADA CON NEOPLASIA DE LINFOCITOS B"
  },
  {
    "codigo":15684441000119101,
    "descripcion":"PERIOSTITIS BILATERAL DE TOBILLOS"
  },
  {
    "codigo":92453006,
    "descripcion":"NEOPLASIA BENIGNA DEL NERVIO TROCLEAR"
  },
  {
    "codigo":59685007,
    "descripcion":"SOPLO CONTINUO"
  },
  {
    "codigo":289061007,
    "descripcion":"CAPAZ DE UTILIZAR LA CUCHARA PARA ALIMENTARSE"
  },
  {
    "codigo":1237498003,
    "descripcion":"METÁSTASIS DE CARCINOMA DE PENE"
  },
  {
    "codigo":25082004,
    "descripcion":"TEMBLOR DURANTE EL DESCANSO"
  },
  {
    "codigo":10877631000119109,
    "descripcion":"HERIDA ABIERTA DE RODILLA IZQUIERDA"
  },
  {
    "codigo":385530004,
    "descripcion":"QUEMADURA DE LA PIEL POR ALIMENTO"
  },
  {
    "codigo":254458007,
    "descripcion":"NEOPLASIA DE ARCO GLOSOPALATINO"
  },
  {
    "codigo":285391000,
    "descripcion":"DISTENSIÓN DE MÚSCULO DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":711375005,
    "descripcion":"MORFOLOGÍA ANORMAL DE ÓRGANO TORACOABDOMINAL"
  },
  {
    "codigo":416463008,
    "descripcion":"OPACIFICACIÓN INTRALENTICULAR DE LENTE INTRAOCULAR"
  },
  {
    "codigo":23247008,
    "descripcion":"COCCIDIOIDOMICOSIS EXTRAPULMONAR PRIMARIA"
  },
  {
    "codigo":283556005,
    "descripcion":"HERIDA DE PERDIGÓN EN LABIO"
  },
  {
    "codigo":447396006,
    "descripcion":"LESIÓN DE CEREBRO POR CONMOCIÓN"
  },
  {
    "codigo":185252009,
    "descripcion":"ATENDIDO EN UN CONSULTORIO ORTOPÉDICO"
  },
  {
    "codigo":21412009,
    "descripcion":"ANEMIA SIDEROBLÁSTICA REFRACTARIA A PIRIDOXINA LIGADA AL CROMOSOMA X"
  },
  {
    "codigo":871545004,
    "descripcion":"FRACTURA EXPUESTA DE CÓNDILO TIBIAL"
  },
  {
    "codigo":609401005,
    "descripcion":"CON RIESGO MODERADO DE CARIES DENTALES"
  },
  {
    "codigo":248953006,
    "descripcion":"SECRECIÓN DE LA VULVA"
  },
  {
    "codigo":19577007,
    "descripcion":"HIPOCUPREMIA"
  },
  {
    "codigo":707705008,
    "descripcion":"CARCINOMA NO QUERATINIZANTE DE NASOFARINGE"
  },
  {
    "codigo":247118003,
    "descripcion":"VENAS RETINIANAS ARROSARIADAS"
  },
  {
    "codigo":42601000087104,
    "descripcion":"HERIDA DE ESCROTO POR MORDEDURA"
  },
  {
    "codigo":50510006,
    "descripcion":"PÁPULAS PEDIAS PIEZOGÉNICAS DOLOROSAS"
  },
  {
    "codigo":441891001,
    "descripcion":"CISTOCELE LATERAL"
  },
  {
    "codigo":278051002,
    "descripcion":"LINFOMA MALIGNO DE LA GLÁNDULA TIROIDES"
  },
  {
    "codigo":1162787001,
    "descripcion":"ISOENZIMA ÓSEA DE FOSFATASA ALCALINA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1076211000119105,
    "descripcion":"BURSITIS SUPRARROTULIANA DE RODILLA DERECHA"
  },
  {
    "codigo":15907009,
    "descripcion":"INFECCIÓN CAUSADA POR CRYPTOSPORIDIUM PARVUM"
  },
  {
    "codigo":16067571000119106,
    "descripcion":"NEOPLASIA NEUROENDOCRINA BIEN DIFERENCIADA METASTÁSICA EN HUESO"
  },
  {
    "codigo":733133003,
    "descripcion":"HEMORRAGIA DEBIDA A RECUPERACIÓN DE ÓVULOS"
  },
  {
    "codigo":403618004,
    "descripcion":"RUBEFACCIÓN DE ORIGEN MEDICAMENTOSO"
  },
  {
    "codigo":75938008,
    "descripcion":"DOLOR DEL TUBO DIGESTIVO POR INSUFICIENCIA VASCULAR"
  },
  {
    "codigo":239778009,
    "descripcion":"ARTRITIS PIÓGENA DE LA MUÑECA"
  },
  {
    "codigo":8567004,
    "descripcion":"EFECTO TÓXICO DEL NÍQUEL"
  },
  {
    "codigo":205175006,
    "descripcion":"PULGAR HIPOPLÁSICO-BLAUTH 2"
  },
  {
    "codigo":236108001,
    "descripcion":"ESTENOSIS DE ANASTOMOSIS DE INTESTINO DELGADO"
  },
  {
    "codigo":1153612002,
    "descripcion":"EMBOLIA DE ARTERIA CEREBRAL ANTERIOR DERECHA"
  },
  {
    "codigo":203340003,
    "descripcion":"ENFERMEDAD DE PAGET DE LA PELVIS"
  },
  {
    "codigo":430881000,
    "descripcion":"SANGRADO DEL SEGUNDO TRIMESTRE DEL EMBARAZO"
  },
  {
    "codigo":301644009,
    "descripcion":"CAPAZ DE SENTARSE Y LEVANTARSE DE UNA SILLA"
  },
  {
    "codigo":267041004,
    "descripcion":"TUMEFACCIÓN ALREDEDOR DE LOS OJOS"
  },
  {
    "codigo":365345004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA VIAJAR A PIE"
  },
  {
    "codigo":168737008,
    "descripcion":"RADIOGRAFÍA SIMPLE DE PARTES BLANDAS DE TÓRAX NORMAL"
  },
  {
    "codigo":299809009,
    "descripcion":"REFLEJO CORNEAL ACTIVO"
  },
  {
    "codigo":232438004,
    "descripcion":"EDEMA LARÍNGEO POSTERIOR A RADIOTERAPIA"
  },
  {
    "codigo":199670005,
    "descripcion":"RUPTURA ARTIFICIAL DE MEMBRANAS, PROLONGADA"
  },
  {
    "codigo":16014631000119103,
    "descripcion":"TROMBOFLEBITIS DE MIEMBRO INFERIOR IZQUIERDO"
  },
  {
    "codigo":363510005,
    "descripcion":"NEOPLASIA MALIGNA DE INTESTINO GRUESO"
  },
  {
    "codigo":230603000,
    "descripcion":"HEMORRAGIA EN TRONCO NERVIOSO"
  },
  {
    "codigo":297974009,
    "descripcion":"DOLOR A LA MOVILIZACIÓN DE LA PIEL"
  },
  {
    "codigo":11836711000119103,
    "descripcion":"SUBLUXACIÓN DE ARTICULACIÓN DE PIE IZQUIERDO"
  },
  {
    "codigo":789494008,
    "descripcion":"SENSIBILIZACIÓN CENTRAL"
  },
  {
    "codigo":33995003,
    "descripcion":"MEGACOLON ADQUIRIDO"
  },
  {
    "codigo":367911000119105,
    "descripcion":"ESTRECHEZ DE URETRA BULBAR CONSECUTIVA A PROCEDIMIENTO"
  },
  {
    "codigo":785824001,
    "descripcion":"NEOPLASIA NEUROENDOCRINA DE VESÍCULA BILIAR"
  },
  {
    "codigo":16833831000119106,
    "descripcion":"MASTOCITOSIS CUTÁNEA CONGÉNITA"
  },
  {
    "codigo":95861000,
    "descripcion":"VÉRTIGO PRECEDIDO POR TRAUMATISMO CRANEOENCEFÁLICO"
  },
  {
    "codigo":1144437001,
    "descripcion":"ATROFIA DE CORTEZA DE RIÑÓN"
  },
  {
    "codigo":292469002,
    "descripcion":"REACCIÓN ADVERSA A FÁRMACO PARASIMPATICOMIMÉTICO ANTICOLINESTERASA"
  },
  {
    "codigo":63093000,
    "descripcion":"AMPOLLA DE TOBILLO, SIN INFECCIÓN"
  },
  {
    "codigo":425376008,
    "descripcion":"CARCINOMA ESCAMOCELULAR DEL PULMÓN, TNM ESTADIO 4"
  },
  {
    "codigo":341441000119102,
    "descripcion":"CATARATA POLAR SUBCAPSULAR POSTERIOR CONGÉNITA DE OJO IZQUIERDO"
  },
  {
    "codigo":421706001,
    "descripcion":"CEGUERA CON SIDA (SÍNDROME DE INMUNODEFICIENCIA ADQUIRIDA)"
  },
  {
    "codigo":94026003,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA PIEL DE LA FRENTE"
  },
  {
    "codigo":290634003,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR DACARBAZINA"
  },
  {
    "codigo":28490008,
    "descripcion":"CHORRO DE ORINA ENTRECORTADO"
  },
  {
    "codigo":92191000,
    "descripcion":"NEOPLASIA BENIGNA DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":126794008,
    "descripcion":"NEOPLASIA DE LA ENCÍA INFERIOR"
  },
  {
    "codigo":124959005,
    "descripcion":"MIELOPOYESIS EXTRAMEDULAR"
  },
  {
    "codigo":1204468000,
    "descripcion":"INSUFICIENCIA DE VENTRÍCULO DERECHO CON SEPSIS"
  },
  {
    "codigo":286964001,
    "descripcion":"ENFERMEDAD RESPIRATORIA POR RADIACIÓN"
  },
  {
    "codigo":59423009,
    "descripcion":"ATRESIA DE LA NASOFARINGE"
  },
  {
    "codigo":254196004,
    "descripcion":"EPIDERMÓLISIS BULLOSA DE LA ZONA DE UNIÓN MITIGADA"
  },
  {
    "codigo":15742401000119106,
    "descripcion":"APOFISITIS DE EPITRÓCLEA DE AMBOS CODOS DEBIDA A TRASTORNO REPETITIVO DEL MOVIMIENTO"
  },
  {
    "codigo":418036006,
    "descripcion":"FRAGMENTO NUCLEAR DEL CRISTALINO EN LA CÁMARA ANTERIOR"
  },
  {
    "codigo":57588009,
    "descripcion":"TRASTORNO DEL SUEÑO INDUCIDO POR SEDANTE, HIPNÓTICO Y\/O ANSIOLÍTICO"
  },
  {
    "codigo":186825001,
    "descripcion":"BARTONELOSIS SISTÉMICA"
  },
  {
    "codigo":16561601000119108,
    "descripcion":"LUXACIÓN CERRADA DE ARTICULACIÓN TEMPOROMANDIBULAR DERECHA"
  },
  {
    "codigo":414366001,
    "descripcion":"HALLAZGO RELACIONADO CON LA DESTRUCCIÓN DE GRANULOCITOS"
  },
  {
    "codigo":250526005,
    "descripcion":"PRUEBA DEL AZUL DE METILENO: FALLIDA"
  },
  {
    "codigo":52083000,
    "descripcion":"HIPERINSUFLACIÓN LOBULAR INFANTIL DEL PULMÓN"
  },
  {
    "codigo":840350008,
    "descripcion":"BRONQUIOLITIS OBLITERATIVA CRÓNICA CAUSADA POR VAPORES QUÍMICOS"
  },
  {
    "codigo":283294009,
    "descripcion":"ASTILLA DE MADERA EN EL PULGAR"
  },
  {
    "codigo":1297267001,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE TERCER DEDO DE PIE"
  },
  {
    "codigo":445299003,
    "descripcion":"DEFECTO DEL TABIQUE AURICULOVENTRICULAR CON DESEQUILIBRIO VENTRICULAR CONSISTENTE EN VENTRÍCULO DERECHO DOMINANTE Y VENTRÍCULO IZQUIERDO HIPOPLÁSICO"
  },
  {
    "codigo":1264499006,
    "descripcion":"CARCINOMA DUCTAL INFILTRANTE DE PÁNCREAS METASTÁSICO"
  },
  {
    "codigo":281459007,
    "descripcion":"ARQUEAMIENTO DE DISPOSITIVO DE FIJACIÓN DE LA COLUMNA"
  },
  {
    "codigo":707443007,
    "descripcion":"PROTEINOSIS ALVEOLAR PULMONAR AUTOINMUNITARIA"
  },
  {
    "codigo":17480001,
    "descripcion":"ATRESIA DE PUPILA"
  },
  {
    "codigo":248691008,
    "descripcion":"CHASQUIDO DE APERTURA PREMATURO"
  },
  {
    "codigo":1197128003,
    "descripcion":"TRASTORNO PERINATAL DEBIDO A DESPRENDIMIENTO PLACENTARIO"
  },
  {
    "codigo":771144005,
    "descripcion":"NEUROPATÍA SENSITIVOMOTORA HEREDITARIA CON ACRODISTROFIA"
  },
  {
    "codigo":246856007,
    "descripcion":"PUNTO LAGRIMAL INFLAMADO"
  },
  {
    "codigo":48413001,
    "descripcion":"COLECISTITIS HEMORRÁGICA AGUDA"
  },
  {
    "codigo":212253002,
    "descripcion":"LESIÓN NO EXPUESTA, NERVIO AXILAR"
  },
  {
    "codigo":308722001,
    "descripcion":"PACIENTE REQUERIDO DE CONCURRIR"
  },
  {
    "codigo":1162525009,
    "descripcion":"ENFERMEDAD POR DEPÓSITO DE HIDROXIAPATITA DE RODILLA"
  },
  {
    "codigo":112114003,
    "descripcion":"REQUERIMIENTO HORMONAL"
  },
  {
    "codigo":767474001,
    "descripcion":"ALERGIA A ÁCIDO SALICÍLICO"
  },
  {
    "codigo":46578006,
    "descripcion":"RADICULITIS LUMBOSACRA"
  },
  {
    "codigo":110279003,
    "descripcion":"ENFERMEDAD INACTIVA LUEGO DE LA TERAPIA"
  },
  {
    "codigo":44743006,
    "descripcion":"INFECCIÓN ARTICULAR GONOCÓCICA"
  },
  {
    "codigo":11975007,
    "descripcion":"VASODILATACIÓN PAROXÍSTICA"
  },
  {
    "codigo":274119009,
    "descripcion":"RUBÉOLA EN EL EMBARAZO"
  },
  {
    "codigo":42908004,
    "descripcion":"ATELECTASIA PRIMARIA, EN EL PERÍODO PERINATAL"
  },
  {
    "codigo":10665871000119100,
    "descripcion":"ÚLCERA ISQUÉMICA ATEROSCLERÓTICA DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":403356006,
    "descripcion":"COMEDONES MÚLTIPLES EN PAPEL DE LIJA"
  },
  {
    "codigo":399686001,
    "descripcion":"TAMAÑO TUMORAL Y COMPONENTE INVASIVO, NO PUEDE SER DETERMINADO"
  },
  {
    "codigo":235846002,
    "descripcion":"INFARTO DEL INTESTINO DELGADO"
  },
  {
    "codigo":1153350004,
    "descripcion":"POLICITEMIA POR MUTACIÓN DE PHD2"
  },
  {
    "codigo":72006005,
    "descripcion":"EPISTÓTONOS"
  },
  {
    "codigo":1081231000119103,
    "descripcion":"ONCOCITOMA DE RIÑÓN IZQUIERDO"
  },
  {
    "codigo":203078008,
    "descripcion":"CONTRACTURA DEL MÚSCULO TIBIAL POSTERIOR"
  },
  {
    "codigo":234011001,
    "descripcion":"PERFORACIÓN DE LA AORTA TORÁCICA"
  },
  {
    "codigo":102939004,
    "descripcion":"HIPERMIMIA"
  },
  {
    "codigo":299547005,
    "descripcion":"AMPLITUD DE EVERSIÓN ACTIVA DE ARTICULACIÓN SUBASTRAGALINA AUMENTADA"
  },
  {
    "codigo":365083007,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA COMENTAR EVENTOS"
  },
  {
    "codigo":1217051009,
    "descripcion":"DEFICIENCIA AISLADA DE HORMONA HIPOFISARIA"
  },
  {
    "codigo":264944004,
    "descripcion":"AGUDEZA VISUAL DE PERCEPCIÓN DE LA LUZ - PROYECCIÓN PRECISA"
  },
  {
    "codigo":15718441000119100,
    "descripcion":"OS ACROMIALE BILATERAL"
  },
  {
    "codigo":230341002,
    "descripcion":"TEMBLOR VOCAL AISLADO"
  },
  {
    "codigo":965003,
    "descripcion":"AMBLIOPÍA TÓXICA"
  },
  {
    "codigo":71721000119101,
    "descripcion":"SÍNDROME NEFRÓTICO DEBIDO A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":295877002,
    "descripcion":"SOBREDOSIS DE NORTRIPTILINA"
  },
  {
    "codigo":263109008,
    "descripcion":"FRACTURA-SUBLUXACIÓN DE LA ARTICULACIÓN PERISEMILUNAR"
  },
  {
    "codigo":318191000009109,
    "descripcion":"HEPATITIS BACTERIANA"
  },
  {
    "codigo":423279000,
    "descripcion":"MIGRAÑA REFRACTARIA SIN AURA"
  },
  {
    "codigo":292207000,
    "descripcion":"REACCIÓN ADVERSA AL MELFALÁN"
  },
  {
    "codigo":95599002,
    "descripcion":"HEMORRAGIA DE QUISTE LUTEÍNICO"
  },
  {
    "codigo":294042008,
    "descripcion":"ALERGIA A RIMITEROL"
  },
  {
    "codigo":31898008,
    "descripcion":"ENFISEMA PARASEPTAL"
  },
  {
    "codigo":290372000,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR OMEPRAZOL"
  },
  {
    "codigo":93764002,
    "descripcion":"NEOPLASIA PRIMARIA MALIGNA DE CONJUNTIVA DEL OJO"
  },
  {
    "codigo":126532006,
    "descripcion":"NEOPLASIA DE PIEL DE DEDO DE PIE"
  },
  {
    "codigo":124697007,
    "descripcion":"DEFICIENCIA DE SERINA - ARNT LIGASA"
  },
  {
    "codigo":11786281000119108,
    "descripcion":"AMPOLLA DE DEDO MEÑIQUE DE MANO IZQUIERDA, CON INFECCIÓN"
  },
  {
    "codigo":1204206001,
    "descripcion":"INSUFICIENCIA VENTRICULAR IZQUIERDA CON FRACCIÓN DE EYECCIÓN NORMAL DEBIDA A MIOCARDIOPATÍA"
  },
  {
    "codigo":385006005,
    "descripcion":"MARGEN POSTERIOR DE RESECCIÓN QUIRÚRGICA AFECTADO POR NEOPLASIA MALIGNA"
  },
  {
    "codigo":253934006,
    "descripcion":"PULGAR DEL QUE VIAJA A DEDO"
  },
  {
    "codigo":286702007,
    "descripcion":"NIVEL BAJO DE PSICOTICISMO"
  },
  {
    "codigo":122862008,
    "descripcion":"ABSCESO DE BOLSA SEROSA"
  },
  {
    "codigo":448707007,
    "descripcion":"NEOPLASIA DE PARED ABDOMINAL"
  },
  {
    "codigo":284867007,
    "descripcion":"NO SE LAVA EL PELO"
  },
  {
    "codigo":252099009,
    "descripcion":"REACCIÓN PAPULAR"
  },
  {
    "codigo":20888002,
    "descripcion":"HIPERPLASIA NEUTROFÍLICA DE LA MÉDULA ÓSEA"
  },
  {
    "codigo":283032003,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE CODO"
  },
  {
    "codigo":182893000,
    "descripcion":"OLVIDÓ TRAER LA MEDICACIÓN"
  },
  {
    "codigo":250264008,
    "descripcion":"CIANURO ASCORBATO DETECTADO MEDIANTE CRIBADO"
  },
  {
    "codigo":84589003,
    "descripcion":"PIGODÍDIMO"
  },
  {
    "codigo":1083741000119101,
    "descripcion":"OBSTRUCCIÓN EXTRÍNSECA DE LUZ DE PORCIÓN CARTILAGINOSA DE AMBAS TROMPAS FARINGOTIMPÁNICAS"
  },
  {
    "codigo":248429007,
    "descripcion":"SE PERCIBE FRÍO EL TRONCO"
  },
  {
    "codigo":1264237009,
    "descripcion":"INFECCIÓN URINARIA POSTERIOR A EMBARAZO ECTÓPICO"
  },
  {
    "codigo":49986002,
    "descripcion":"DOLOR DE ORIGEN CENTRAL"
  },
  {
    "codigo":246594002,
    "descripcion":"AUSENCIA BILATERAL DE LA RESPUESTA PLANTAR"
  },
  {
    "codigo":310295001,
    "descripcion":"ANTICUERPOS ANTIMITOCONDRIALES DÉBILMENTE DETECTADOS"
  },
  {
    "codigo":1162263002,
    "descripcion":"DEFICIENCIA DE COMPONENTE 8 DEL COMPLEMENTO"
  },
  {
    "codigo":277527003,
    "descripcion":"MELANOCITOMA DE MENINGES"
  },
  {
    "codigo":48151006,
    "descripcion":"PERIORQUITIS FIBROMATOSA"
  },
  {
    "codigo":111852003,
    "descripcion":"VACCINIA"
  },
  {
    "codigo":210156005,
    "descripcion":"LESIÓN TRAUMÁTICA DE CUERPO DE PÁNCREAS CON HERIDA ABIERTA HACIA CAVIDAD"
  },
  {
    "codigo":898284006,
    "descripcion":"ANQUILOSIS CONGÉNITA DE ARTICULACIÓN METATARSOFALÁNGICA DE QUINTO DEDO DE PIE"
  },
  {
    "codigo":11815261000119106,
    "descripcion":"RUPTURA TRAUMÁTICA DE LIGAMENTO COLATERAL DE ARTICULACIÓN DE MEÑIQUE DERECHO"
  },
  {
    "codigo":734444009,
    "descripcion":"COCOS GRAMPOSITIVOS EN CADENAS, ACÚMULOS Y PARES"
  },
  {
    "codigo":110017003,
    "descripcion":"FRACTURA NO EXPUESTA DE TRÍPODE CIGOMÁTICO"
  },
  {
    "codigo":698006004,
    "descripcion":"PULPALGIA"
  },
  {
    "codigo":403094004,
    "descripcion":"ONICOMICOSIS CAUSADA POR BOTRYODIPLODIA THEOBROMAE"
  },
  {
    "codigo":10832221000119109,
    "descripcion":"FRACTURA EXPUESTA DE ESPINA INTERCONDÍLEA DE TIBIA DERECHA"
  },
  {
    "codigo":972900701000119109,
    "descripcion":"ÚLCERA VENOSA DE DEDO DE PIE IZQUIERDO"
  },
  {
    "codigo":346461000119109,
    "descripcion":"ESTAFILOMA CORNEAL BILATERAL DE OJOS"
  },
  {
    "codigo":302955009,
    "descripcion":"CONTRACTURA CONGÉNITA EN EXTENSIÓN DE LA RODILLA"
  },
  {
    "codigo":1251392002,
    "descripcion":"DERMATITIS ATÓPICA LIQUENIFICADA EN INFANCIA"
  },
  {
    "codigo":366656002,
    "descripcion":"LANUGO - HALLAZGO"
  },
  {
    "codigo":5371000175108,
    "descripcion":"INCAPAZ DE COSTEAR GLUCÓMETRO"
  },
  {
    "codigo":319991000119106,
    "descripcion":"NÓDULO REUMATOIDEO DE MUÑECA DERECHA"
  },
  {
    "codigo":202816005,
    "descripcion":"ANQUILOSIS DE LA COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":13790001000004101,
    "descripcion":"BACTERIEMIA CAUSADA POR STAPHYLOCOCCUS AUREUS RESISTENTE A METICILINA"
  },
  {
    "codigo":38976008,
    "descripcion":"PESTE NEUMÓNICA"
  },
  {
    "codigo":301120008,
    "descripcion":"HALLAZGO PRESENTE EN EL ELECTROCARDIOGRAMA"
  },
  {
    "codigo":24990001000004105,
    "descripcion":"FRACTURA DE MASTOIDES"
  },
  {
    "codigo":69909000,
    "descripcion":"ECLAMPSIA SOBREAGREGADA A HIPERTENSIÓN PREEXISTENTE"
  },
  {
    "codigo":14110001000004108,
    "descripcion":"MUCOCELE DE SENO MAXILAR"
  },
  {
    "codigo":4373005,
    "descripcion":"UÑAS HIPOCRÁTICAS"
  },
  {
    "codigo":200981004,
    "descripcion":"PARAPSORIASIS ATRÓFICA"
  },
  {
    "codigo":233749003,
    "descripcion":"NEUMOCONIOSIS COMPLICADA"
  },
  {
    "codigo":364821000,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA COMER CON CUCHILLO Y TENEDOR"
  },
  {
    "codigo":10910001000004108,
    "descripcion":"ABSCESO DE PANTORRILLA"
  },
  {
    "codigo":788970006,
    "descripcion":"BLEFAROCONJUNTIVITIS IRRITANTE POR CONTACTO"
  },
  {
    "codigo":703000,
    "descripcion":"ADHERENCIAS CONGÉNITAS DE LA LENGUA"
  },
  {
    "codigo":328383001,
    "descripcion":"ENFERMEDAD HEPÁTICA CRÓNICA"
  },
  {
    "codigo":428522008,
    "descripcion":"ANOMALÍA CONGÉNITA DEL TRACTO UROGENITAL MASCULINO"
  },
  {
    "codigo":2538008,
    "descripcion":"CETOSIS"
  },
  {
    "codigo":295615001,
    "descripcion":"SOBREDOSIS DE DERIVADO NITROGENADO DE MOSTAZA"
  },
  {
    "codigo":361151007,
    "descripcion":"DELIRIO POR ABSTINENCIA DE SEDANTES"
  },
  {
    "codigo":785300001,
    "descripcion":"ATAXIA CEREBELOSA NO PROGRESIVA AUTOSÓMICA RECESIVA DE COMIENZO EN LA LACTANCIA"
  },
  {
    "codigo":64404003,
    "descripcion":"OSTEOGÉNESIS IMPERFECTA CON ESCLERÓTICAS AZULES Y DIENTES NORMALES"
  },
  {
    "codigo":293780005,
    "descripcion":"ALERGIA A CISPLATINO"
  },
  {
    "codigo":15694481000119107,
    "descripcion":"OSTEOMIELITIS DE AMBAS MANOS"
  },
  {
    "codigo":95337003,
    "descripcion":"LIPODERMATOSCLEROSIS EXTENSA"
  },
  {
    "codigo":128105004,
    "descripcion":"TRASTORNO DE VON WILLEBRAND"
  },
  {
    "codigo":160873007,
    "descripcion":"REGISTRO DE MALTRATO INFANTIL - ELIMINADO"
  },
  {
    "codigo":291945009,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR DISOPIRAMIDA"
  },
  {
    "codigo":27966004,
    "descripcion":"PRODUCCIÓN NORMAL DE PLAQUETAS"
  },
  {
    "codigo":1240382005,
    "descripcion":"TRASTORNO NEONATAL PRECOZ DEBIDO A TRANSFUSIÓN MATERNOFETAL"
  },
  {
    "codigo":1142078006,
    "descripcion":"HIPERBILIRRUBINEMIA NEONATAL DEBIDA A INFECCIÓN BACTERIANA"
  },
  {
    "codigo":290110007,
    "descripcion":"SECRECIÓN SEROSANGUINOLENTA POR PEZÓN"
  },
  {
    "codigo":716094008,
    "descripcion":"SÍNDROME DE HIPOPLASIA PERONEA-CUBITAL Y ANOMALÍAS RENALES"
  },
  {
    "codigo":421182009,
    "descripcion":"ATAXIA EPISÓDICA TIPO 1"
  },
  {
    "codigo":58899004,
    "descripcion":"SIN EVIDENCIA DE NEOPLASIAS"
  },
  {
    "codigo":42551000087102,
    "descripcion":"HERIDA PUNZANTE DE TESTÍCULO"
  },
  {
    "codigo":124435007,
    "descripcion":"DEFICIENCIA DE 3' - NUCLEOTIDASA"
  },
  {
    "codigo":348971000119105,
    "descripcion":"PSEUDOESTRABISMO CONGÉNITO"
  },
  {
    "codigo":39991000087105,
    "descripcion":"HERIDA PUNZANTE DE DEDO ÍNDICE DERECHO CON CUERPO EXTRAÑO"
  },
  {
    "codigo":47671000087106,
    "descripcion":"DISTENSIÓN DE MÚSCULO SUBESCAPULAR DE HOMBRO DERECHO"
  },
  {
    "codigo":253672004,
    "descripcion":"ESTENOSIS AÓRTICA PREDUCTAL"
  },
  {
    "codigo":284605004,
    "descripcion":"CONDUCTA PEGAJOSA"
  },
  {
    "codigo":250002000,
    "descripcion":"FATIGA RÁPIDA DE LA MARCHA"
  },
  {
    "codigo":118930001,
    "descripcion":"TRASTORNO FACIAL"
  },
  {
    "codigo":282770002,
    "descripcion":"LESIÓN DE COSTILLAS"
  },
  {
    "codigo":315538003,
    "descripcion":"NACIDO EN TAJIKISTÁN"
  },
  {
    "codigo":446610004,
    "descripcion":"BACTERIA AISLADA PERO SIN IDENTIFICACIÓN POSTERIOR"
  },
  {
    "codigo":413842007,
    "descripcion":"LEUCEMIA MIELOIDE CRÓNICA EN CRISIS BLÁSTICA LINFOIDE"
  },
  {
    "codigo":84327002,
    "descripcion":"ATROFIA ADQUIRIDA DEL ÚTERO"
  },
  {
    "codigo":706919005,
    "descripcion":"BACILLUS CEREUS NO AISLADO"
  },
  {
    "codigo":1069721000000103,
    "descripcion":"DIFICULTAD PARA ACCEDER A PROPIO HOGAR"
  },
  {
    "codigo":790681000000104,
    "descripcion":"CUIDADO DE RELEVO DISPONIBLE"
  },
  {
    "codigo":15121005,
    "descripcion":"ELIPTOCITOSIS HEREDITARIA POR DEFICIENCIA DE GLUCOFORINA C"
  },
  {
    "codigo":322501000119108,
    "descripcion":"INFLAMACIÓN DE BOLSA SEROSA DE MÚSCULO SEMIMEMBRANOSO DE RODILLA DERECHA"
  },
  {
    "codigo":111590001,
    "descripcion":"TRASTORNO DEL SISTEMA LINFOIDE"
  },
  {
    "codigo":766950003,
    "descripcion":"OBSTRUCCIÓN DE VENA FEMORAL"
  },
  {
    "codigo":1356774005,
    "descripcion":"PUPILA SIMPATOPARÉTICA CAUSADA POR FÁRMACO"
  },
  {
    "codigo":13286006,
    "descripcion":"CUERPO EXTRAÑO EN LA UNIÓN RECTOSIGMOIDEA"
  },
  {
    "codigo":275430007,
    "descripcion":"DESGARRO DE MÚSCULO VAGINAL"
  },
  {
    "codigo":109755000,
    "descripcion":"FRACTURA DE LA CÚSPIDE DENTAL DURANTE LA CARGA MASTICATORIA"
  },
  {
    "codigo":132191000119103,
    "descripcion":"TROMBOSIS VENOSA PROFUNDA CRÓNICA DE VENA FEMORAL"
  },
  {
    "codigo":240827003,
    "descripcion":"FIEBRE FILARIÁSICA DE MALASIA"
  },
  {
    "codigo":208059006,
    "descripcion":"FRACTURA VERTEBRAL NO EXPUESTA CON LESIÓN POSTERIOR DE MÉDULA ESPINAL LUMBAR"
  },
  {
    "codigo":44219007,
    "descripcion":"PSEUDOEXFOLIACIÓN DE CÁPSULA DEL CRISTALINO"
  },
  {
    "codigo":238992001,
    "descripcion":"ERITRODERMIA CAUSADA POR FÁRMACO"
  },
  {
    "codigo":404667009,
    "descripcion":"ÉMBOLO RETINIANO"
  },
  {
    "codigo":370064004,
    "descripcion":"INVASIÓN TUMORAL EN EL ESTROMA"
  },
  {
    "codigo":763280005,
    "descripcion":"SÍNDROME DE ENCEFALOPATÍA, MIOCARDIOPATÍA HIPERTRÓFICA Y ENFERMEDAD TUBULAR RENAL"
  },
  {
    "codigo":402832006,
    "descripcion":"TELANGIECTASIA POR HIPERTENSIÓN VENOSA"
  },
  {
    "codigo":1254800007,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS DE PARED LATERAL DE OROFARINGE"
  },
  {
    "codigo":1287568008,
    "descripcion":"BLEFARITIS POR ROSÁCEA"
  },
  {
    "codigo":206224008,
    "descripcion":"RUPTURA DE LA MÉDULA ESPINAL POR TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":304528007,
    "descripcion":"RECHAZO DEL ALIMENTO EN EL LACTANTE"
  },
  {
    "codigo":271760008,
    "descripcion":"PÚSTULA"
  },
  {
    "codigo":300858004,
    "descripcion":"MASA DE ESTRUCTURA GENITAL MASCULINA"
  },
  {
    "codigo":366394005,
    "descripcion":"AMPLITUD DE LA ROTACIÓN DERECHA DE LA COLUMNA CERVICAL - HALLAZGO"
  },
  {
    "codigo":5946006,
    "descripcion":"DERIVACIÓN PORTOSISTÉMICA ADQUIRIDA"
  },
  {
    "codigo":725007000,
    "descripcion":"DISTENSIÓN DE FASCIA DE LA CABEZA"
  },
  {
    "codigo":167951002,
    "descripcion":"LÍQUIDO PLEURAL LÍMPIDO"
  },
  {
    "codigo":299023007,
    "descripcion":"ARTICULACIÓN DE LA MUÑECA ERITEMATOSA"
  },
  {
    "codigo":103304001,
    "descripcion":"VÉRTIGO ASOCIADO CON CAMBIO RECIENTE DE ANTEOJOS"
  },
  {
    "codigo":69647007,
    "descripcion":"LÁGRIMAS ROJAS"
  },
  {
    "codigo":428260000,
    "descripcion":"INFECCIÓN CAUSADA POR STREPTOCOCCUS EQUINUS"
  },
  {
    "codigo":1149156003,
    "descripcion":"NIVEL DE ANSIEDAD DISMINUIDO"
  },
  {
    "codigo":723172008,
    "descripcion":"AUSENCIA ADQUIRIDA DE AMBOS OVARIOS"
  },
  {
    "codigo":297188009,
    "descripcion":"HEMOTÓRAX COAGULADO"
  },
  {
    "codigo":262585002,
    "descripcion":"QUEMADURA EPIDÉRMICA DE PIEL DE DEDO DE LA MANO"
  },
  {
    "codigo":295353003,
    "descripcion":"SOBREDOSIS INTENCIONAL DE CIMETIDINA"
  },
  {
    "codigo":197049005,
    "descripcion":"INVAGINACIÓN ILEOCECAL"
  },
  {
    "codigo":33209009,
    "descripcion":"POLINEUROPATÍA PROGRESIVA IDIOPÁTICA"
  },
  {
    "codigo":721337009,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA PARCIAL DE NARIZ"
  },
  {
    "codigo":162446007,
    "descripcion":"EL SÍNTOMA DURA DÍAS"
  },
  {
    "codigo":1145486008,
    "descripcion":"HIPOPLASIA CONGÉNITA DE FALANGE PROXIMAL DE DEDO ÍNDICE"
  },
  {
    "codigo":293518007,
    "descripcion":"REACCIÓN ADVERSA A LA DIGITOXINA"
  },
  {
    "codigo":783203003,
    "descripcion":"SÍNDROME DE ATAXIA CON DEGENERACIÓN TAPETORRETINIANA"
  },
  {
    "codigo":193379006,
    "descripcion":"CONGESTIÓN VENOSA RETINIANA"
  },
  {
    "codigo":95075006,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA PIEL DE LA NARIZ"
  },
  {
    "codigo":291683008,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR ETAMBUTOL"
  },
  {
    "codigo":226147009,
    "descripcion":"DIETA RICA EN VITAMINA B12"
  },
  {
    "codigo":93240004,
    "descripcion":"HIPOPLASIA CONGÉNITA DEL ARCO DE LA VÉRTEBRA LUMBAR"
  },
  {
    "codigo":289848006,
    "descripcion":"PROBLEMA OVÁRICO"
  },
  {
    "codigo":420920007,
    "descripcion":"NEUROPATÍA ÓPTICA POR DEFICIENCIA DE VITAMINA B12"
  },
  {
    "codigo":11849261000119101,
    "descripcion":"HERIDA DE MAMA IZQUIERDA DEBIDA A PICADURA DE INSECTO NO VENENOSO"
  },
  {
    "codigo":1269218003,
    "descripcion":"CICATRIZ POSTERIOR A FOTOCOAGULACIÓN CON RAYO LÁSER"
  },
  {
    "codigo":417250005,
    "descripcion":"APLASIA GRANULOCÍTICA DE MÉDULA ÓSEA"
  },
  {
    "codigo":253410006,
    "descripcion":"ANOMALÍA DEL MÚSCULO PAPILAR MITRAL"
  },
  {
    "codigo":15863341000119103,
    "descripcion":"GLIOMA DE AMBOS NERVIOS ÓPTICOS"
  },
  {
    "codigo":54967001,
    "descripcion":"RIÑÓN DOBLE"
  },
  {
    "codigo":448183001,
    "descripcion":"DEFECTO DEL TABIQUE AURICULOVENTRICULAR CON COMPONENTE VENTRICULAR Y CORTOCIRCUITO INTERCORDAL POR DEBAJO DE VÁLVULA EN PUENTE SUPERIOR"
  },
  {
    "codigo":251575003,
    "descripcion":"AGOTAMIENTO POSACTIVACIÓN (TETÁNICA)"
  },
  {
    "codigo":22199006,
    "descripcion":"SÍNDROME UÑA-RÓTULA"
  },
  {
    "codigo":284343007,
    "descripcion":"COLOCA LA TAPA A UN ENVASE"
  },
  {
    "codigo":710327009,
    "descripcion":"ESPECIE DE BACTEROIDES O ESPECIE DE PREVOTELLA"
  },
  {
    "codigo":85900004,
    "descripcion":"PROBANDO"
  },
  {
    "codigo":20364005,
    "descripcion":"PARACUSIA"
  },
  {
    "codigo":53132006,
    "descripcion":"SÍNDROME DE ZOLLINGER - ELLISON"
  },
  {
    "codigo":249740005,
    "descripcion":"ACORTAMIENTO PROXIMAL DE BRAZO"
  },
  {
    "codigo":282508006,
    "descripcion":"NO BAJA UNA COLINA CORRIENDO"
  },
  {
    "codigo":11986631000119100,
    "descripcion":"QUEMADURA EPIDÉRMICA DE PALMA IZQUIERDA"
  },
  {
    "codigo":84065002,
    "descripcion":"UTILIZA MÉTODO ANTICONCEPTIVO DE TEMPERATURA BASAL"
  },
  {
    "codigo":1362017003,
    "descripcion":"LIPOPROTEÍNA (A) DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":247905005,
    "descripcion":"FALTA DE MOVIMIENTO ESPONTÁNEO"
  },
  {
    "codigo":16694003,
    "descripcion":"ÚLCERA GÁSTRICA CON HEMORRAGIA PERO SIN OBSTRUCCIÓN"
  },
  {
    "codigo":278838006,
    "descripcion":"EXCARCELADO"
  },
  {
    "codigo":735755000,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO PERIFÉRICO DE REGIÓN LUMBAR"
  },
  {
    "codigo":702987002,
    "descripcion":"STREPTOCOCCUS SANGUINIS O STREPTOCOCCUS GORDONII"
  },
  {
    "codigo":1260043007,
    "descripcion":"TATUAJE DE MUCOSA DE PALADAR BLANDO"
  },
  {
    "codigo":277003007,
    "descripcion":"DEFECTO DE CONOS"
  },
  {
    "codigo":211467007,
    "descripcion":"LESIONES SUPERFICIALES MÚLTIPLES EN ABDOMEN, REGIÓN LUMBAR Y PELVIS"
  },
  {
    "codigo":111328001,
    "descripcion":"DIVERTÍCULO CONGÉNITO DE LA FARINGE"
  },
  {
    "codigo":78560000,
    "descripcion":"CONDUCTO HEPÁTICO ACCESORIO"
  },
  {
    "codigo":240565001,
    "descripcion":"NEUROSÍFILIS SECUNDARIA ASINTOMÁTICA"
  },
  {
    "codigo":209632009,
    "descripcion":"DESGARRO COMPLETO DE LIGAMENTO DE TOBILLO Y\/O PIE"
  },
  {
    "codigo":11189003,
    "descripcion":"INFESTACIÓN CAUSADA POR ACARUS"
  },
  {
    "codigo":699317002,
    "descripcion":"NEOPLASIA MALIGNA PARATESTICULAR"
  },
  {
    "codigo":109493006,
    "descripcion":"DISPLASIA DE LA DENTINA, TIPO I"
  },
  {
    "codigo":43957006,
    "descripcion":"POSICIÓN FRONTOILÍACA IZQUIERDA TRANSVERSA"
  },
  {
    "codigo":371637009,
    "descripcion":"CUERPO EXAMINADO POR AUTORIDAD MEDICOLEGAL"
  },
  {
    "codigo":763018002,
    "descripcion":"INFECCIÓN ASINTOMÁTICA POR VIRUS DEL NILO OCCIDENTAL"
  },
  {
    "codigo":15728481000119104,
    "descripcion":"ARTROPATÍA DE ARTICULACIONES DE AMBAS MANOS"
  },
  {
    "codigo":40287006,
    "descripcion":"REACCIÓN A LA PUNCIÓN LUMBAR"
  },
  {
    "codigo":204127006,
    "descripcion":"CATARATA CORTICAL Y ZONULAR"
  },
  {
    "codigo":398900000,
    "descripcion":"LENTIGO SIMPLE"
  },
  {
    "codigo":366132000,
    "descripcion":"REFLEJO DE MORO - HALLAZGO"
  },
  {
    "codigo":73055006,
    "descripcion":"MELANOMA VULVAR, ESTADIO V DE LA FIGO"
  },
  {
    "codigo":169524003,
    "descripcion":"FRACASO DE PREPARADOS ANTICONCEPTIVOS DE LIBERACIÓN LENTA"
  },
  {
    "codigo":202292004,
    "descripcion":"CONTRACTURA EN FLEXIÓN DE LA ARTICULACIÓN METATARSOFALÁNGICA"
  },
  {
    "codigo":71220005,
    "descripcion":"FRACTURA EXPUESTA DEL PUBIS"
  },
  {
    "codigo":69385001,
    "descripcion":"HEMATOMA DE LA VULVA"
  },
  {
    "codigo":36617002,
    "descripcion":"REACCIÓN HEMOLÍTICA INMEDIATA A UNA TRANSFUSIÓN"
  },
  {
    "codigo":724745001,
    "descripcion":"PARAFILIA QUE IMPLICA UN COMPORTAMIENTO SOLITARIO O QUE INVOLUCRA A INDIVIDUOS QUE OTORGAN SU CONSENTIMIENTO"
  },
  {
    "codigo":167689005,
    "descripcion":"RIBOSA DETECTADA EN ESPÉCIMEN DE MATERIA FECAL ANALIZADO MEDIANTE CROMATOGRAFÍA"
  },
  {
    "codigo":298761006,
    "descripcion":"HALLAZGO RELACIONADO CON LA ESTRUCTURA DE LA CLAVÍCULA"
  },
  {
    "codigo":296926001,
    "descripcion":"SOBREDOSIS DE HEPARINA"
  },
  {
    "codigo":722910004,
    "descripcion":"LESIÓN DE ÓRGANO ABDOMINAL DEBIDA A TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":34782005,
    "descripcion":"HERENCIA CROMOSÓMICA"
  },
  {
    "codigo":1148894007,
    "descripcion":"TROMBOSIS VENOSA POSTERIOR A FERTILIZACIÓN ASISTIDA"
  },
  {
    "codigo":721075001,
    "descripcion":"SÍNDROME DE TARSO CORTO CON AUSENCIA DE PESTAÑAS INFERIORES"
  },
  {
    "codigo":15697361000119100,
    "descripcion":"ABSCESO SUBPERIÓSTICO DE ÓRBITA DE OJO DERECHO"
  },
  {
    "codigo":15684561000119101,
    "descripcion":"PERIOSTITIS DE TOBILLO DERECHO"
  },
  {
    "codigo":11865041000119102,
    "descripcion":"LESIÓN TRAUMÁTICA DE EXTREMIDAD INFERIOR DERECHA"
  },
  {
    "codigo":15633361000119103,
    "descripcion":"CIÁTICA BILATERAL"
  },
  {
    "codigo":11824081000119103,
    "descripcion":"CONTUSIÓN DE REGIÓN AXILAR IZQUIERDA"
  },
  {
    "codigo":1079761000119105,
    "descripcion":"DERMATOFIBROMA DE MIEMBRO INFERIOR IZQUIERDO"
  },
  {
    "codigo":15725521000119105,
    "descripcion":"TRASTORNO DE AMBAS ARTICULACIONES SACROILÍACAS"
  },
  {
    "codigo":314321000119107,
    "descripcion":"MIOSITIS OSIFICANTE TRAUMÁTICA DE BRAZO DERECHO"
  },
  {
    "codigo":295091007,
    "descripcion":"ALERGIA A TETRANITRATO DE PENTAERITRITILO"
  },
  {
    "codigo":298961000119102,
    "descripcion":"GOTA DE MUÑECA DEBIDA A DISFUNCIÓN RENAL"
  },
  {
    "codigo":342481000119101,
    "descripcion":"EDEMA DE PÁRPADO DERECHO"
  },
  {
    "codigo":301521000119103,
    "descripcion":"ABSCESO DE BOLSA SEROSA DE RODILLA DERECHA"
  },
  {
    "codigo":91601000119109,
    "descripcion":"SECUELA DE ACCIDENTE CEREBROVASCULAR TROMBÓTICO"
  },
  {
    "codigo":15748561000119106,
    "descripcion":"RIGIDEZ DE MÚSCULO GEMELO IZQUIERDO"
  },
  {
    "codigo":112081000119108,
    "descripcion":"EXAMEN OCULAR CENTRADO EN EL PROBLEMA, NORMAL"
  },
  {
    "codigo":719240009,
    "descripcion":"TIENE TRABAJADOR CLAVE PARA LA ATENCIÓN EN EL FINAL DE LA VIDA"
  },
  {
    "codigo":1145224006,
    "descripcion":"NEURITIS DEBIDA A RUPTURA DE DISCO INTERVERTEBRAL LUMBAR"
  },
  {
    "codigo":329681000119109,
    "descripcion":"COMPRESIÓN DE NERVIO PERIFÉRICO DE MIEMBRO SUPERIOR DERECHO"
  },
  {
    "codigo":782941005,
    "descripcion":"SÍNDROME DE RICHIERI COSTA-DA SILVA"
  },
  {
    "codigo":10760341000119101,
    "descripcion":"RETRACCIÓN DE PEZÓN EN EMBARAZO"
  },
  {
    "codigo":94813001,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA SUPERFICIE DORSAL DE LA LENGUA"
  },
  {
    "codigo":31112008,
    "descripcion":"MENINGOENCEFALITIS TUBERCULOSA"
  },
  {
    "codigo":92978002,
    "descripcion":"AUSENCIA CONGÉNITA DE LA GLÁNDULA TIROIDES"
  },
  {
    "codigo":846642004,
    "descripcion":"AFECCIÓN RESPIRATORIA CAUSADA POR VAPOR Y HUMOS QUÍMICOS"
  },
  {
    "codigo":60210005,
    "descripcion":"EDEMA AMPOLLAR VESICAL"
  },
  {
    "codigo":289586006,
    "descripcion":"LOQUIOS ANORMALES"
  },
  {
    "codigo":1010482004,
    "descripcion":"ESCLEROSIS DE EPÍFISIS DE FALANGE MEDIA DE DEDO MEDIO CON RADIOPACIDAD AUMENTADA"
  },
  {
    "codigo":123911000,
    "descripcion":"INTOXICACIÓN POR FAGÁCEAS"
  },
  {
    "codigo":420658009,
    "descripcion":"RADICULITIS ASOCIADA CON SIDA (SÍNDROME DE INMUNODEFICIENCIA ADQUIRIDA)"
  },
  {
    "codigo":254983004,
    "descripcion":"NEOPLASIA MALIGNA DE NERVIO ESPINAL Y SU VAINA"
  },
  {
    "codigo":1268956001,
    "descripcion":"ENFERMEDAD DE PAGET EXTRAMAMARIA PRIMARIA DE PIEL"
  },
  {
    "codigo":449756003,
    "descripcion":"SECRECIÓN SEROSANGUINOLENTA DE HERIDA"
  },
  {
    "codigo":253148005,
    "descripcion":"SÍNDROME DE MILLER DIEKER"
  },
  {
    "codigo":23772009,
    "descripcion":"DISFONÍA DEL SÍNDROME DE GILLES DE LA TOURETTE"
  },
  {
    "codigo":710065009,
    "descripcion":"PUNTAJE DE CHILD-PUGH CLASE A"
  },
  {
    "codigo":85638002,
    "descripcion":"RINORREA DE LÍQUIDO CEFALORRAQUÍDEO"
  },
  {
    "codigo":315014005,
    "descripcion":"ATENDIDO EN CONSULTORIO ESPECIALIZADO EN DOLOR TORÁCICO DE ACCESO RÁPIDO"
  },
  {
    "codigo":249478008,
    "descripcion":"SED DISMINUIDA"
  },
  {
    "codigo":247643005,
    "descripcion":"PENSAMIENTOS RUIDOSOS"
  },
  {
    "codigo":313179009,
    "descripcion":"EDAD DE GESTACIÓN, 24 SEMANAS"
  },
  {
    "codigo":770096002,
    "descripcion":"DISFUNCIÓN ERÉCTIL DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":442416002,
    "descripcion":"HIPERSOMNIA IDIOPÁTICA ASOCIADA CON PERÍODO DE SUEÑO PROLONGADO"
  },
  {
    "codigo":278576007,
    "descripcion":"ENCHAPADO DENTAL CON TONO INCORRECTO"
  },
  {
    "codigo":409648008,
    "descripcion":"LINFADENITIS TORÁCICA HEMORRÁGICA"
  },
  {
    "codigo":1259781003,
    "descripcion":"FIBROHISTIOCITOMA MALIGNO DE CÉLULAS GIGANTES PRIMARIO DE PIEL"
  },
  {
    "codigo":735493006,
    "descripcion":"PERFORACIÓN NEONATAL DE INTESTINO CAUSADA POR FÁRMACO"
  },
  {
    "codigo":209370000,
    "descripcion":"FRACTURA-SUBLUXACIÓN NO EXPUESTA DE PIE"
  },
  {
    "codigo":371375002,
    "descripcion":"SECUNDINAS RETENIDAS"
  },
  {
    "codigo":699055002,
    "descripcion":"PELVIS RENAL PROMINENTE"
  },
  {
    "codigo":404143002,
    "descripcion":"LINFOMA CUTÁNEO PRIMARIO DE CÉLULAS B DE LA ZONA CENTROFOLICULAR"
  },
  {
    "codigo":305839006,
    "descripcion":"VISTO POR SERVICIO DE ARTETERAPIAS"
  },
  {
    "codigo":240303007,
    "descripcion":"PANICULITIS DEL RECIÉN NACIDO"
  },
  {
    "codigo":9092004,
    "descripcion":"HIPERPLASIA PARATIROIDEA"
  },
  {
    "codigo":402308005,
    "descripcion":"PSORIASIS CRÓNICA EN PEQUEÑAS PLACAS"
  },
  {
    "codigo":205700008,
    "descripcion":"SÍNDROME DE KLINEFELTER, MOSAICO XY\/XXY"
  },
  {
    "codigo":1186905006,
    "descripcion":"TIROXINA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":302169008,
    "descripcion":"BRIDAS DEL INTESTINO GRUESO"
  },
  {
    "codigo":1119534000,
    "descripcion":"PRUEBA DE AGUDEZA VISUAL NO CORREGIDA, ANORMAL"
  },
  {
    "codigo":365870005,
    "descripcion":"HALLAZGO RELACIONADO CON EL ESTADO DE REANIMACIÓN"
  },
  {
    "codigo":70958007,
    "descripcion":"HIPERPLASIA DE CÉLULAS PLASMÁTICAS DE LA MÉDULA ÓSEA"
  },
  {
    "codigo":38190007,
    "descripcion":"ALUCINACIONES EXTRACAMPINAS"
  },
  {
    "codigo":36355001,
    "descripcion":"ABSORCIÓN INTESTINAL ANORMAL"
  },
  {
    "codigo":724483001,
    "descripcion":"PREOCUPACIÓN POR LA IMAGEN CORPORAL RELACIONADA CON EL EMBARAZO"
  },
  {
    "codigo":298499003,
    "descripcion":"LESIÓN DE COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":429571005,
    "descripcion":"TRASTORNO DISOCIATIVO RELACIONADO CON EL SUEÑO"
  },
  {
    "codigo":296664002,
    "descripcion":"SOBREDOSIS DE FLUCLOXACILINA"
  },
  {
    "codigo":130989002,
    "descripcion":"PRIVACIÓN DE SUEÑO"
  },
  {
    "codigo":10818301000119101,
    "descripcion":"FRACTURA EXPUESTA DE FALANGE DISTAL DE DEDO ANULAR IZQUIERDO"
  },
  {
    "codigo":720813007,
    "descripcion":"SÍNDROME DE CRANEOSINOSTOSIS CON MALFORMACIÓN DE DANDY-WALKER E HIDROCEFALIA"
  },
  {
    "codigo":294829007,
    "descripcion":"ALERGIA A PROTIRELINA"
  },
  {
    "codigo":129154003,
    "descripcion":"NEOPLASIA HEMATOLÓGICA"
  },
  {
    "codigo":63618006,
    "descripcion":"INFESTACIÓN CAUSADA POR PULEX IRRITANS"
  },
  {
    "codigo":292994007,
    "descripcion":"REACCIÓN ADVERSA A CEFALOSPORINA"
  },
  {
    "codigo":291159001,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR PIMOZIDA"
  },
  {
    "codigo":782679002,
    "descripcion":"PARÁLISIS CONGÉNITA FAMILIAR DE NERVIO PATÉTICO"
  },
  {
    "codigo":260226009,
    "descripcion":"COMIDA RICA EN PROTEÍNAS"
  },
  {
    "codigo":127319005,
    "descripcion":"ANEMIA CAUSADA POR DESTRUCCIÓN ALOINMUNITARIA DE ERITROCITOS TRANSFUNDIDOS"
  },
  {
    "codigo":225623006,
    "descripcion":"RASGO DE LA PERSONALIDAD: TIMIDEZ - HALLAZGO"
  },
  {
    "codigo":94551006,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE PIEL DE CONDUCTO AUDITIVO EXTERNO"
  },
  {
    "codigo":59948002,
    "descripcion":"TÓRAX TIMPÁNICO A LA PERCUSIÓN"
  },
  {
    "codigo":92716004,
    "descripcion":"CARCINOMA IN SITU DE LA PIEL DE LA MEJILLA"
  },
  {
    "codigo":289324005,
    "descripcion":"HALLAZGO RELACIONADO CON EL COLOR DEL MUÑÓN DEL CORDÓN UMBILICAL"
  },
  {
    "codigo":780844005,
    "descripcion":"LEUCEMIA MIELOIDE AGUDA CON INV(3)(Q21Q26.2) O T(3;3)(Q21;Q26.2); RPN1-EVI1"
  },
  {
    "codigo":25345001,
    "descripcion":"PERFORACIÓN DE LA VESÍCULA BILIAR"
  },
  {
    "codigo":123649004,
    "descripcion":"ALTERACIONES CROMOSÓMICAS DEL GRUPO D"
  },
  {
    "codigo":418561004,
    "descripcion":"ALERGIA A POLEN DE AMBROSÍA"
  },
  {
    "codigo":1303297007,
    "descripcion":"VESTIDO ADECUADAMENTE CON ZAPATOS"
  },
  {
    "codigo":1336065008,
    "descripcion":"EPISODIO DE USO NOCIVO DE METANOL"
  },
  {
    "codigo":285654002,
    "descripcion":"LESIÓN DE CUERPO VÍTREO"
  },
  {
    "codigo":449494004,
    "descripcion":"LOCALIZACIÓN SUPRACARDÍACA DE CONEXIÓN VENOSA PULMONAR ANÓMALA A VENA CAVA SUPERIOR DERECHA"
  },
  {
    "codigo":711638008,
    "descripcion":"PULPITIS IRREVERSIBLE SINTOMÁTICA"
  },
  {
    "codigo":283819009,
    "descripcion":"MORDEDURA DE ANIMAL EN EL PERINEO"
  },
  {
    "codigo":10627991000119106,
    "descripcion":"CARBUNCO DE RODILLA IZQUIERDA"
  },
  {
    "codigo":116309007,
    "descripcion":"REGIÓN DE CODO - HALLAZGO"
  },
  {
    "codigo":312917007,
    "descripcion":"DISTROFIA DE CONOS"
  },
  {
    "codigo":247381009,
    "descripcion":"DOLOR EN EL MUÑÓN DE AMPUTACIÓN DE UNA EXTREMIDAD"
  },
  {
    "codigo":16170002,
    "descripcion":"ALEXIA MUSICAL"
  },
  {
    "codigo":704298009,
    "descripcion":"CON MAYOR RIESGO DE ALTERACIÓN DE LA FUNCIÓN CARDÍACA"
  },
  {
    "codigo":79871003,
    "descripcion":"INFECCIÓN CAUSADA POR HISTRICHIS"
  },
  {
    "codigo":702463005,
    "descripcion":"SÍNDROME PARALÍTICO DE DOS EXTREMIDADES"
  },
  {
    "codigo":241876000,
    "descripcion":"EFECTO TÓXICO CAUSADO POR PINTURA ANTIVANDÁLICA"
  },
  {
    "codigo":733396001,
    "descripcion":"MÚLTIPLES LESIONES TRAUMÁTICAS SUPERFICIALES DE BRAZO"
  },
  {
    "codigo":372948002,
    "descripcion":"INFECCIÓN CAUSADA POR PENICILLIUM CITRINUM"
  },
  {
    "codigo":1259519008,
    "descripcion":"DEMENCIA DEBIDA A PANENCEFALITIS ESCLEROSANTE SUBAGUDA"
  },
  {
    "codigo":10820811000119100,
    "descripcion":"FRACTURA EXPUESTA DE BASE DE QUINTO HUESO METACARPIANO DE MANO DERECHA"
  },
  {
    "codigo":403881002,
    "descripcion":"ENFERMEDAD DE BOWEN, ATRÓFICA"
  },
  {
    "codigo":43433004,
    "descripcion":"MODIFICACIÓN DEL ASPECTO DE LAS UÑAS"
  },
  {
    "codigo":10665004,
    "descripcion":"PANCREATITIS POR VIRUS DE LA PAROTIDITIS URLIANA"
  },
  {
    "codigo":240041006,
    "descripcion":"NÓDULO POR FIEBRE REUMÁTICA"
  },
  {
    "codigo":76201007,
    "descripcion":"PTOSIS MECÁNICA"
  },
  {
    "codigo":371113008,
    "descripcion":"INMUNE CONTRA VARICELA"
  },
  {
    "codigo":762494000,
    "descripcion":"EMACIACIÓN DE CAUSA NUTRICIONAL EN LA INFANCIA"
  },
  {
    "codigo":305577006,
    "descripcion":"BAJO ATENCIÓN DE ENFERMERA LABORAL"
  },
  {
    "codigo":205438006,
    "descripcion":"ESPONDILOSINDESIS PARCIAL CONGÉNITA CON HEMIVÉRTEBRA - ESTABLE"
  },
  {
    "codigo":860798008,
    "descripcion":"GLAUCOMA DEBIDO A DIABETES MELLITUS"
  },
  {
    "codigo":400211001,
    "descripcion":"LINFEDEMA HEREDITARIO Y UÑAS AMARILLAS"
  },
  {
    "codigo":6995000,
    "descripcion":"FRACASO DE LA LACTANCIA"
  },
  {
    "codigo":39763004,
    "descripcion":"TOLERANCIA ANORMAL A LA GLUCOSA EN LA MADRE, QUE COMPLICA EL EMBARAZO, EL PARTO Y\/O EL PUERPERIO"
  },
  {
    "codigo":11803851000119105,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA PROXIMAL DE DEDO MEDIO DERECHO"
  },
  {
    "codigo":365608001,
    "descripcion":"NIVEL DE ÁCIDO FÓLICO - HALLAZGO"
  },
  {
    "codigo":201768005,
    "descripcion":"ARTRITIS REUMATOIDE DE LA ARTICULACIÓN ACROMIOCLAVICULAR"
  },
  {
    "codigo":298237000,
    "descripcion":"ARTICULACIÓN METACARPOFALÁNGICA RÍGIDA"
  },
  {
    "codigo":335051000119108,
    "descripcion":"CORIORRETINITIS DISEMINADA GENERALIZADA DE OJO DERECHO"
  },
  {
    "codigo":396541009,
    "descripcion":"MARGEN QUIRÚRGICO COMPROMETIDO POR CARCINOMA\/ADENOMA IN SITU"
  },
  {
    "codigo":15955301000119103,
    "descripcion":"SEMINOMA PRIMARIO DE AMBOS TESTÍCULOS DESCENDIDOS"
  },
  {
    "codigo":722386009,
    "descripcion":"SÍNDROME DE ENFERMEDAD CELÍACA CON EPILEPSIA Y CALCIFICACIÓN CEREBRAL"
  },
  {
    "codigo":294567003,
    "descripcion":"ALERGIA A METRONIDAZOL"
  },
  {
    "codigo":65191003,
    "descripcion":"DISFAGIA PERMANENTE DE BAJO GRADO"
  },
  {
    "codigo":308581000119105,
    "descripcion":"SINDACTILIA DE DEDOS DE PIE DERECHO"
  },
  {
    "codigo":30588004,
    "descripcion":"COLITIS ISQUÉMICA"
  },
  {
    "codigo":62821000119106,
    "descripcion":"ANOMALÍA DE OÍDO FETAL"
  },
  {
    "codigo":292732004,
    "descripcion":"REACCIÓN ADVERSA A FLUMAZENIL"
  },
  {
    "codigo":718716008,
    "descripcion":"ANEMIA HEMOLÍTICA AUTOINMUNITARIA DE TIPO MIXTO"
  },
  {
    "codigo":94289002,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE TROMPA DE EUSTAQUIO"
  },
  {
    "codigo":127057004,
    "descripcion":"HEMOGLOBINURIA PAROXÍSTICA INDUCIDA POR FRÍO"
  },
  {
    "codigo":389201004,
    "descripcion":"HIPERPARATIROIDISMO NEONATAL TRANSITORIO"
  },
  {
    "codigo":92454000,
    "descripcion":"NEOPLASIA BENIGNA DE TRONCO"
  },
  {
    "codigo":290897009,
    "descripcion":"INTOXICACIÓN POR NEFAZODONA"
  },
  {
    "codigo":289062000,
    "descripcion":"INCAPAZ DE UTILIZAR LA CUCHARA PARA ALIMENTARSE"
  },
  {
    "codigo":26918003,
    "descripcion":"COLANGITIS ASCENDENTE"
  },
  {
    "codigo":715046004,
    "descripcion":"INCAPAZ DE OBTENER MEDICACIÓN"
  },
  {
    "codigo":11832831000119102,
    "descripcion":"ESGUINCE DE ARTICULACIÓN INTERFALÁNGICA DE SEGUNDO A QUINTO DEDOS DE PIE IZQUIERDO"
  },
  {
    "codigo":420134006,
    "descripcion":"PROPENSIÓN A EXPERIMENTAR REACCIONES ADVERSAS"
  },
  {
    "codigo":59686008,
    "descripcion":"ACIDOSIS METABÓLICA CAUSADA POR INGESTIÓN DE ETILENGLICOL"
  },
  {
    "codigo":713211001,
    "descripcion":"PERIODONTITIS DEBIDA A FRACTURA DE RAÍZ DE DIENTE"
  },
  {
    "codigo":385531000,
    "descripcion":"QUEMADURA DE LA PIEL POR GRASA"
  },
  {
    "codigo":254459004,
    "descripcion":"NEOPLASIA MALIGNA DE ARCO GLOSOPALATINO"
  },
  {
    "codigo":449232001,
    "descripcion":"HIPOPLASIA DE CAYADO AÓRTICO ENTRE ARTERIAS CARÓTIDAS"
  },
  {
    "codigo":711376006,
    "descripcion":"MORFOLOGÍA DE ÓRGANO TORACOABDOMINAL NORMAL"
  },
  {
    "codigo":283557001,
    "descripcion":"HERIDA DE PERDIGÓN EN CUELLO"
  },
  {
    "codigo":16010751000119107,
    "descripcion":"ARTRITIS GOTOSA DE AMBOS DEDOS GORDOS"
  },
  {
    "codigo":185253004,
    "descripcion":"ATENDIDO EN CONSULTORIO ESPECIALIZADO EN CIRUGÍA ORAL"
  },
  {
    "codigo":248954000,
    "descripcion":"SECRECIÓN DE LA GLÁNDULA DE BARTOLINO"
  },
  {
    "codigo":609402003,
    "descripcion":"CON ALTO RIESGO DE CARIES DENTAL"
  },
  {
    "codigo":1363066005,
    "descripcion":"METABOLIZADOR POBRE DE FAMILIA 2 SUBFAMILIA C MIEMBRO 9 *5\/*6 DE CITOCROMO P450"
  },
  {
    "codigo":312655004,
    "descripcion":"HERIDA POR MORDEDURA DE LA BOCA"
  },
  {
    "codigo":247119006,
    "descripcion":"VENAS RETINIANAS ENFUNDADAS"
  },
  {
    "codigo":11314841000119105,
    "descripcion":"FRACTURA POR OSTEOPOROSIS SECUNDARIA"
  },
  {
    "codigo":15908004,
    "descripcion":"FIEBRE DE LOS TRABAJADORES DEL CINC"
  },
  {
    "codigo":441892008,
    "descripcion":"HEMIPLEJÍA ESPÁSTICA DE LADO DOMINANTE"
  },
  {
    "codigo":278052009,
    "descripcion":"LINFOMA MALIGNO DE LA MAMA"
  },
  {
    "codigo":208846004,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA EXPUESTA DE MUÑECA"
  },
  {
    "codigo":700366006,
    "descripcion":"ORZUELO INTERNO DE PÁRPADO SUPERIOR"
  },
  {
    "codigo":12238007,
    "descripcion":"ANEMIA MEGALOBLÁSTICA POR GASTRECTOMÍA"
  },
  {
    "codigo":272547001,
    "descripcion":"SENTADO A LO LARGO"
  },
  {
    "codigo":239779001,
    "descripcion":"ARTRITIS PIÓGENA DE CODO"
  },
  {
    "codigo":733134009,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE GLÁNDULA PARAURETRAL"
  },
  {
    "codigo":403619007,
    "descripcion":"RUBEFACCIÓN POR NITRITOS"
  },
  {
    "codigo":237944004,
    "descripcion":"VALINOSIS"
  },
  {
    "codigo":15931341000119100,
    "descripcion":"RUPTURA DE QUISTE DE AMBOS OVARIOS"
  },
  {
    "codigo":205176007,
    "descripcion":"PULGAR HIPOPLÁSICO-BLAUTH 3"
  },
  {
    "codigo":39501002,
    "descripcion":"CICATRIZ COROIDEA POSTRAUMÁTICA"
  },
  {
    "codigo":6733004,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE PABELLÓN AURICULAR SIN INFECCIÓN"
  },
  {
    "codigo":301645005,
    "descripcion":"INCAPAZ DE SENTARSE Y LEVANTARSE DE UNA SILLA"
  },
  {
    "codigo":398114001,
    "descripcion":"SÍNDROME DE EHLERS-DANLOS"
  },
  {
    "codigo":236109009,
    "descripcion":"ESTENOSIS DE ANASTOMOSIS DE INTESTINO GRUESO"
  },
  {
    "codigo":168738003,
    "descripcion":"RADIOGRAFÍA SIMPLE DE PARTES BLANDAS DE TÓRAX ANORMAL"
  },
  {
    "codigo":299810004,
    "descripcion":"REFLEJO CORNEAL NORMAL"
  },
  {
    "codigo":365346003,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA USAR MEDIO DE TRANSPORTE"
  },
  {
    "codigo":267042006,
    "descripcion":"VENAS PROMINENTES"
  },
  {
    "codigo":297975005,
    "descripcion":"HALLAZGO RELACIONADO CON EL OLOR DE LA PIEL"
  },
  {
    "codigo":232439007,
    "descripcion":"POLICONDRITIS RECIDIVANTE DE LARINGE"
  },
  {
    "codigo":427212000,
    "descripcion":"ELECTROCARDIOGRAMA: LATIDOS ECTÓPICOS CON CONTRACCIÓN AURICULAR PREMATURA"
  },
  {
    "codigo":197836001,
    "descripcion":"FIBROSIS PANMURAL DE VEJIGA URINARIA"
  },
  {
    "codigo":33996002,
    "descripcion":"INTOXICACIÓN POR CLORPIRIFOS"
  },
  {
    "codigo":296140004,
    "descripcion":"SOBREDOSIS DE DICLORALFENAZONA"
  },
  {
    "codigo":230604006,
    "descripcion":"PARÁLISIS POR TORNIQUETE"
  },
  {
    "codigo":1179041001,
    "descripcion":"MASA EN LABIO"
  },
  {
    "codigo":196001008,
    "descripcion":"ENFERMEDAD PULMONAR OBSTRUCTIVA CRÓNICA CON INFECCIÓN AGUDA DE LAS VÍAS RESPIRATORIAS INFERIORES"
  },
  {
    "codigo":32161008,
    "descripcion":"FÍSTULA GASTROINTESTINAL INTERNA"
  },
  {
    "codigo":292470001,
    "descripcion":"REACCIÓN ADVERSA A LA FISOSTIGMINA"
  },
  {
    "codigo":1144438006,
    "descripcion":"ATROFIA DE TRACTO ESPINOCEREBELOSO"
  },
  {
    "codigo":1077351000119104,
    "descripcion":"OSTEOMIELITIS AGUDA DE PIE DERECHO"
  },
  {
    "codigo":94027007,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE PIEL DE INGLE"
  },
  {
    "codigo":124960000,
    "descripcion":"MEGACARIOCITOPOYESIS EXTRAMEDULAR"
  },
  {
    "codigo":126795009,
    "descripcion":"NEOPLASIA DE LA MUCOSA GINGIVAL"
  },
  {
    "codigo":288800002,
    "descripcion":"CAPAZ DE EMPLEAR EL HUMOR"
  },
  {
    "codigo":15986791000119106,
    "descripcion":"ANOMALÍA CONGÉNITA DE AMBAS RETINAS"
  },
  {
    "codigo":876789002,
    "descripcion":"CUERPO EXTRAÑO SUPERFICIAL CON INFECCIÓN"
  },
  {
    "codigo":186826000,
    "descripcion":"BARTONELOSIS CUTÁNEA Y MUCOCUTÁNEA"
  },
  {
    "codigo":254197008,
    "descripcion":"EPIDERMÓLISIS BULLOSA CICATRIZAL DE LA ZONA DE UNIÓN DERMOEPIDÉRMICA"
  },
  {
    "codigo":416202003,
    "descripcion":"BAJO ATENCIÓN DE ENFERMERA ESPECIALIZADA EN DISPEPSIA"
  },
  {
    "codigo":88522004,
    "descripcion":"DOLOR UMBILICAL"
  },
  {
    "codigo":11782401000119103,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN DE RODILLA IZQUIERDA"
  },
  {
    "codigo":285130006,
    "descripcion":"MASTICAR PELO"
  },
  {
    "codigo":22986007,
    "descripcion":"CORTE Y EMPALME TRANSCRIPCIONAL DE ÁCIDO RIBONUCLEICO"
  },
  {
    "codigo":67841000119103,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA MICROCÍTICA DE PULMÓN, ESTADIO TNM 4"
  },
  {
    "codigo":250527001,
    "descripcion":"PRUEBA DE FOSFATASA - HALLAZGO"
  },
  {
    "codigo":283295005,
    "descripcion":"ASTILLA DE MADERA DEBAJO DE LA UÑA DE DEDO DE LA MANO"
  },
  {
    "codigo":840351007,
    "descripcion":"BRONQUIOLITIS OBLITERATIVA CRÓNICA CAUSADA POR VAPOR"
  },
  {
    "codigo":15714561000119105,
    "descripcion":"DEFORMIDAD ADQUIRIDA BILATERAL DE COSTILLAS"
  },
  {
    "codigo":248692001,
    "descripcion":"CLIC MESOSISTÓLICO"
  },
  {
    "codigo":707444001,
    "descripcion":"ASMA NO COMPLICADA"
  },
  {
    "codigo":281460002,
    "descripcion":"ARQUEAMIENTO DE FIJADOR EXTERNO"
  },
  {
    "codigo":1264500002,
    "descripcion":"CARCINOMA DUCTAL INFILTRANTE DE PRÓSTATA METASTÁSICO"
  },
  {
    "codigo":313601000119106,
    "descripcion":"MONOARTRITIS DE CODO IZQUIERDO"
  },
  {
    "codigo":1231732006,
    "descripcion":"MASTOCITOSIS SISTÉMICA LATENTE"
  },
  {
    "codigo":1297268006,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE DEDO ÍNDICE"
  },
  {
    "codigo":246857003,
    "descripcion":"PUNTO LAGRIMAL INFERIOR-HALLAZGO"
  },
  {
    "codigo":771145006,
    "descripcion":"PÉNFIGO HERPETIFORME"
  },
  {
    "codigo":83017007,
    "descripcion":"MENARCA TARDÍA"
  },
  {
    "codigo":81182003,
    "descripcion":"ENFERMEDAD POR VIRUS CHANDIPURA"
  },
  {
    "codigo":441630004,
    "descripcion":"AFASIA COMO EFECTO TARDÍO DE ENFERMEDAD CEREBROVASCULAR"
  },
  {
    "codigo":212254008,
    "descripcion":"LESIÓN EXPUESTA, NERVIO AXILAR"
  },
  {
    "codigo":767475000,
    "descripcion":"ALERGIA A VITAMINA B12 Y\/O DERIVADO DE VITAMINA B12"
  },
  {
    "codigo":46579003,
    "descripcion":"INTOXICACIÓN POR ESPECIE DE AMARANTO"
  },
  {
    "codigo":110280000,
    "descripcion":"EFECTO DE UN FÁRMACO"
  },
  {
    "codigo":44744000,
    "descripcion":"HIPERTIROIDISMO SECUNDARIO A MOLA HIDATIFORME"
  },
  {
    "codigo":274120003,
    "descripcion":"ENFERMEDAD TIROIDEA EN EL EMBARAZO"
  },
  {
    "codigo":403357002,
    "descripcion":"COMEDÓN GIGANTE"
  },
  {
    "codigo":1157021003,
    "descripcion":"PRESIÓN DE OXÍGENO EN SANGRE DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1079861000119101,
    "descripcion":"NEVO DISPLÁSICO DE PIEL DE MIEMBRO INFERIOR IZQUIERDO"
  },
  {
    "codigo":342581000119102,
    "descripcion":"DISTROFIA DE EPITELIO PIGMENTARIO DE LA RETINA"
  },
  {
    "codigo":203079000,
    "descripcion":"CONTRACTURA DE LOS MÚSCULOS FLEXORES LARGOS DE LOS DEDOS DEL PIE"
  },
  {
    "codigo":1153351000,
    "descripcion":"ARTRITIS GOTOSA CRÓNICA POLIARTICULAR PRIMARIA"
  },
  {
    "codigo":237682009,
    "descripcion":"PANHIPOPITUITARISMO - ANTERIOR Y POSTERIOR"
  },
  {
    "codigo":72007001,
    "descripcion":"DUODENITIS"
  },
  {
    "codigo":235847006,
    "descripcion":"INFARTO DEL INTESTINO GRUESO"
  },
  {
    "codigo":6471006,
    "descripcion":"IDEACIÓN SUICIDA"
  },
  {
    "codigo":299548000,
    "descripcion":"AMPLITUD DE EVERSIÓN ACTIVA DE ARTICULACIÓN SUBASTRAGALINA DISMINUIDA"
  },
  {
    "codigo":365084001,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA HACER PREGUNTAS"
  },
  {
    "codigo":1217052002,
    "descripcion":"TOLERANCIA A CARBOHIDRATOS ALTERADA"
  },
  {
    "codigo":102940002,
    "descripcion":"REACCIÓN ESQUIZOFRÉNICA"
  },
  {
    "codigo":37404003,
    "descripcion":"FALLA EN LA ROTACIÓN DEL COLON"
  },
  {
    "codigo":168476005,
    "descripcion":"CITOLOGÍA DEL ESPUTO"
  },
  {
    "codigo":234012008,
    "descripcion":"FÍSTULA ARTERIOVENOSA TRAUMÁTICA"
  },
  {
    "codigo":297713002,
    "descripcion":"VENAS VARICOSAS DE EXTREMIDAD INFERIOR SIN ÚLCERA Y SIN INFLAMACIÓN"
  },
  {
    "codigo":721862000,
    "descripcion":"SÍNDROME DE JOUBERT CON DEFECTO OCULORRENAL"
  },
  {
    "codigo":263110003,
    "descripcion":"FRACTURA-SUBLUXACIÓN DE DEDO DE LA MANO"
  },
  {
    "codigo":295878007,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE NORTRIPTILINA"
  },
  {
    "codigo":720027001,
    "descripcion":"DISFUNCIÓN SOMÁTICA DE REGIÓN DE LA ESPALDA"
  },
  {
    "codigo":64667001,
    "descripcion":"NEUMONÍA INTERSTICIAL"
  },
  {
    "codigo":294043003,
    "descripcion":"ALERGIA A RITODRINA"
  },
  {
    "codigo":195739001,
    "descripcion":"BRONQUIOLITIS AGUDA CAUSADA POR VIRUS SINCICIAL RESPIRATORIO"
  },
  {
    "codigo":425115008,
    "descripcion":"TALLA EN RELACIÓN CON EL ESTÁNDAR DE CRECIMIENTO \/ EDAD, ANORMAL"
  },
  {
    "codigo":718192000,
    "descripcion":"GLOMERULONEFRITIS FIBRILAR NO AMILOIDE"
  },
  {
    "codigo":423280002,
    "descripcion":"MELANOMA MALIGNO DE LA PIEL DEL CANTO OCULAR"
  },
  {
    "codigo":95600004,
    "descripcion":"ENTROPIÓN DEL CUELLO UTERINO"
  },
  {
    "codigo":292208005,
    "descripcion":"REACCIÓN ADVERSA A LA ESTRAMUSTINA"
  },
  {
    "codigo":193904008,
    "descripcion":"INFECCIÓN FILÁRICA DE LA CONJUNTIVA"
  },
  {
    "codigo":126533001,
    "descripcion":"TRASTORNO CON MINERALIZACIÓN OSTEOIDE ANORMAL"
  },
  {
    "codigo":421445005,
    "descripcion":"INFECCIÓN CAUSADA POR MANNHEIMIA HAEMOLYTICA"
  },
  {
    "codigo":192069009,
    "descripcion":"TRASTORNOS MENTALES NO PSICÓTICOS ESPECÍFICOS LUEGO DE LESIÓN CEREBRAL ORGÁNICA"
  },
  {
    "codigo":124698002,
    "descripcion":"DEFICIENCIA DE ACETATO - COA LIGASA"
  },
  {
    "codigo":300723007,
    "descripcion":"DIFICULTAD PARA REALIZAR ACTIVIDADES RELACIONADAS CON LAS COMPRAS"
  },
  {
    "codigo":714522006,
    "descripcion":"ENFERMEDAD GINGIVAL ALÉRGICA"
  },
  {
    "codigo":26394007,
    "descripcion":"ESCALA DEL COMA DE GLASGOW, 3"
  },
  {
    "codigo":24559001,
    "descripcion":"QUERATODERMIA MUTILANTE"
  },
  {
    "codigo":286703002,
    "descripcion":"RASGO DE LA PERSONALIDAD: PREDISPOSICIÓN A SOBRESALTARSE - HALLAZGO"
  },
  {
    "codigo":122863003,
    "descripcion":"SEPARACIÓN EPIFISARIA"
  },
  {
    "codigo":385007001,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA DE CUELLO VESICAL AFECTADO POR NEOPLASIA MALIGNA"
  },
  {
    "codigo":1236975007,
    "descripcion":"ARRESTO CONDUCTUAL"
  },
  {
    "codigo":22724000,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA URETRA"
  },
  {
    "codigo":252100001,
    "descripcion":"REACCIÓN VESICULAR"
  },
  {
    "codigo":448708002,
    "descripcion":"NEOPLASIA DEL APARATO RESPIRATORIO"
  },
  {
    "codigo":284868002,
    "descripcion":"DIFICULTAD PARA LAVARSE EL PELO"
  },
  {
    "codigo":283033008,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DEL ANTEBRAZO"
  },
  {
    "codigo":250265009,
    "descripcion":"CIANURO ASCORBATO NO DETECTADO MEDIANTE CRIBADO"
  },
  {
    "codigo":345091000119102,
    "descripcion":"ÚLCERA DE CÓRNEA MICÓTICA DE AMBOS OJOS"
  },
  {
    "codigo":1003929008,
    "descripcion":"DELECIÓN PROXIMAL DEL BRAZO LARGO DEL CROMOSOMA 11"
  },
  {
    "codigo":1264238004,
    "descripcion":"DAÑO DE LIGAMENTO ANCHO DE ÚTERO POSTERIOR A EMBARAZO MOLAR"
  },
  {
    "codigo":182894006,
    "descripcion":"PRESCRIPCIÓN NO RETIRADA"
  },
  {
    "codigo":84590007,
    "descripcion":"ENFERMEDAD DE LA NEURONA MOTORA INFERIOR"
  },
  {
    "codigo":82755000,
    "descripcion":"QUISTE DE INCLUSIÓN GERMINAL DEL OVARIO"
  },
  {
    "codigo":246595001,
    "descripcion":"RAÍZ DE NERVIO ESPINAL - HALLAZGO"
  },
  {
    "codigo":1082371000119104,
    "descripcion":"MORFOLOGÍA DENTAL ANORMAL"
  },
  {
    "codigo":312131008,
    "descripcion":"INFECCIÓN VIRAL DEL APARATO DIGESTIVO"
  },
  {
    "codigo":443203009,
    "descripcion":"HALLAZGO RELACIONADO CON LA EVALUACIÓN DE AUTOMEDICACIÓN"
  },
  {
    "codigo":310296000,
    "descripcion":"ANTICUERPOS ANTICÉLULAS PARIETALES NO DETECTADOS"
  },
  {
    "codigo":48152004,
    "descripcion":"EFECTO TÓXICO DE TETRAETILO DE PLOMO"
  },
  {
    "codigo":15384005,
    "descripcion":"ESTÍMULO ERÓTICO"
  },
  {
    "codigo":1162264008,
    "descripcion":"LINFOMA MALIGNO DEL TRACTO UVEAL"
  },
  {
    "codigo":210157001,
    "descripcion":"LESIÓN TRAUMÁTICA DE COLA DE PÁNCREAS CON HERIDA ABIERTA HACIA CAVIDAD ABDOMINAL"
  },
  {
    "codigo":767213002,
    "descripcion":"PIE CAVO VALGO"
  },
  {
    "codigo":734445005,
    "descripcion":"BACILO GRAMPOSITIVO EN CADENA"
  },
  {
    "codigo":898285007,
    "descripcion":"ANQUILOSIS CONGÉNITA DE FALANGE DE MANO"
  },
  {
    "codigo":208322000,
    "descripcion":"FRACTURA NO EXPUESTA DE GALEAZZI"
  },
  {
    "codigo":13549009,
    "descripcion":"INFECCIÓN CAUSADA POR HETEROBILHARZIA"
  },
  {
    "codigo":77250007,
    "descripcion":"PROTEINURIA ESENCIAL"
  },
  {
    "codigo":110018008,
    "descripcion":"FRACTURA EXPUESTA DEL TRÍPODE CIGOMÁTICO"
  },
  {
    "codigo":403095003,
    "descripcion":"ONICOMICOSIS CAUSADA POR CURVULARIA LUNATA"
  },
  {
    "codigo":302956005,
    "descripcion":"DEFICIENCIA TRANSVERSA DE LA MANO"
  },
  {
    "codigo":204652007,
    "descripcion":"FÍSTULA ESOFÁGICA CONGÉNITA"
  },
  {
    "codigo":202817001,
    "descripcion":"ANQUILOSIS DORSOLUMBAR"
  },
  {
    "codigo":366657006,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA PARARSE EN UNA PIERNA"
  },
  {
    "codigo":301121007,
    "descripcion":"PERFUSIÓN MIOCÁRDICA NORMAL"
  },
  {
    "codigo":233750003,
    "descripcion":"NEUMOCONIOSIS POR ERIONITA"
  },
  {
    "codigo":4374004,
    "descripcion":"ANOMALÍA CONGÉNITA DE VÁLVULA TRICÚSPIDE"
  },
  {
    "codigo":299286005,
    "descripcion":"AMPLITUD DE ROTACIÓN INTERNA ACTIVA DE ARTICULACIÓN DE CADERA, NORMAL"
  },
  {
    "codigo":200982006,
    "descripcion":"PARAPSORIASIS HERPETIFORME"
  },
  {
    "codigo":364822007,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA COMER CON TENEDOR"
  },
  {
    "codigo":292151000119103,
    "descripcion":"NEUROPATÍA DE NERVIO CIÁTICO POPLÍTEO EXTERNO IZQUIERDO EN CABEZA DE PERONÉ"
  },
  {
    "codigo":788971005,
    "descripcion":"DERMATITIS IRRITANTE POR CONTACTO DE OÍDO EXTERNO"
  },
  {
    "codigo":166379008,
    "descripcion":"NIVEL DE PROLACTINA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":231915009,
    "descripcion":"INFILTRACIÓN HEMÁTICA DE LA CÓRNEA"
  },
  {
    "codigo":262848001,
    "descripcion":"PERFORACIÓN TARDÍA DE DUODENO"
  },
  {
    "codigo":295616000,
    "descripcion":"SOBREDOSIS DE CLORAMBUCILO"
  },
  {
    "codigo":721600008,
    "descripcion":"FIBROMATOSIS AGRESIVA DE MAMA"
  },
  {
    "codigo":785301002,
    "descripcion":"ATAXIA ESPINOCEREBELOSA LENTAMENTE PROGRESIVA AUTOSÓMICA RECESIVA DE COMIENZO EN LA INFANCIA"
  },
  {
    "codigo":293781009,
    "descripcion":"ALERGIA A HIDROXIUREA"
  },
  {
    "codigo":128106003,
    "descripcion":"ENFERMEDAD DE VON WILLEBRAND HEREDITARIA TIPO 1"
  },
  {
    "codigo":423018005,
    "descripcion":"EROSIÓN DE TUMOR ESOFÁGICO HACIA TRÁQUEA"
  },
  {
    "codigo":291946005,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR DISOPIRAMIDA"
  },
  {
    "codigo":60735000,
    "descripcion":"LAGOFTALMOS"
  },
  {
    "codigo":95338008,
    "descripcion":"CARÚNCULA LAGRIMAL CILIADA"
  },
  {
    "codigo":1240383000,
    "descripcion":"TRASTORNO NEONATAL PRECOZ DEBIDO A EDEMA DE PLACENTA"
  },
  {
    "codigo":1142079003,
    "descripcion":"LESIÓN TRAUMÁTICA NEONATAL POR EXTRAVASACIÓN"
  },
  {
    "codigo":290111006,
    "descripcion":"SECRECIÓN PURULENTA POR PEZÓN"
  },
  {
    "codigo":288276001,
    "descripcion":"HEMORRAGIA CEREBRAL FETAL"
  },
  {
    "codigo":26132002,
    "descripcion":"DEFICIENCIA DE 5 - OXOPROLINASA"
  },
  {
    "codigo":321131000119100,
    "descripcion":"PIE HENDIDO IZQUIERDO"
  },
  {
    "codigo":124436008,
    "descripcion":"DEFICIENCIA DE FOSFOADENILATO 3' - NUCLEOTIDASA"
  },
  {
    "codigo":24297000,
    "descripcion":"XIFÓPAGO"
  },
  {
    "codigo":15666641000119107,
    "descripcion":"HUESO ACCESORIO DE TARSO DE PIE DERECHO"
  },
  {
    "codigo":286441005,
    "descripcion":"CAPAZ DE OBTENER ALIMENTO"
  },
  {
    "codigo":347601000119108,
    "descripcion":"FORMA COMBINADA DE CATARATA SENIL DE AMBOS OJOS"
  },
  {
    "codigo":22462001,
    "descripcion":"ENDOCARDITIS INFECCIOSA CRÓNICA"
  },
  {
    "codigo":415678002,
    "descripcion":"EL MARGEN QUIRÚRGICO MESENTÉRICO ES EL MARGEN NO AFECTADO MÁS CERCANO A LA NEOPLASIA MALIGNA"
  },
  {
    "codigo":284606003,
    "descripcion":"CONDUCTA PATERNALISTA"
  },
  {
    "codigo":253673009,
    "descripcion":"INTERRUPCIÓN DE LA AORTA PREDUCTAL"
  },
  {
    "codigo":446611000,
    "descripcion":"PIE CALIENTE"
  },
  {
    "codigo":448446008,
    "descripcion":"LIPOMA PEDUNCULADO"
  },
  {
    "codigo":118931002,
    "descripcion":"TRASTORNO DEL FLANCO"
  },
  {
    "codigo":282771003,
    "descripcion":"LESIÓN PÉLVICA"
  },
  {
    "codigo":48401000087100,
    "descripcion":"FRACTURA DE HUESO TEMPORAL DERECHO"
  },
  {
    "codigo":250003005,
    "descripcion":"TRASTORNO SENSORIOMOTRIZ PERIFÉRICO DE LA MARCHA"
  },
  {
    "codigo":43281000087100,
    "descripcion":"ABRASIÓN DE ANEXOS OCULARES DE OJO IZQUIERDO"
  },
  {
    "codigo":87048000,
    "descripcion":"FIEBRE DE KUNJIN"
  },
  {
    "codigo":413843002,
    "descripcion":"LEUCEMIA MIELOIDE CRÓNICA EN CRISIS BLÁSTICA MIELOIDE"
  },
  {
    "codigo":38161000087105,
    "descripcion":"HIPOCINESIA DE MIOCARDIO DE REGIÓN ANTERIOR DE VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":315539006,
    "descripcion":"NACIDO EN TANZANIA"
  },
  {
    "codigo":18792003,
    "descripcion":"FÍSTULA TRAQUEOESOFÁGICA CONGÉNITA TIPO H"
  },
  {
    "codigo":706920004,
    "descripcion":"AEROMONAS, NO AISLADAS"
  },
  {
    "codigo":1231208000,
    "descripcion":"DESPLAZAMIENTO MEDIAL DE OJO"
  },
  {
    "codigo":1296744006,
    "descripcion":"IRIS EN MESETA DE OJO IZQUIERDO"
  },
  {
    "codigo":84328007,
    "descripcion":"ESTEREOTIPIA"
  },
  {
    "codigo":1263976009,
    "descripcion":"HEMORRAGIA NEONATAL PRECOZ NO TRAUMÁTICA DE ESPACIO SUBARACNOIDEO CEREBRAL"
  },
  {
    "codigo":442941002,
    "descripcion":"CONDROCALCINOSIS DE ARTICULACIÓN DE TOBILLO Y\/O PIE"
  },
  {
    "codigo":16957005,
    "descripcion":"FÍSTULA DE LA VESÍCULA BILIAR"
  },
  {
    "codigo":111591002,
    "descripcion":"HIPERTROFIA ADENOIDEA"
  },
  {
    "codigo":766951004,
    "descripcion":"OBSTRUCCIÓN ADQUIRIDA DE VENA FEMORAL"
  },
  {
    "codigo":275431006,
    "descripcion":"DESGARRO DEL ESFÍNTER ANAL"
  },
  {
    "codigo":208060001,
    "descripcion":"FRACTURA VERTEBRAL NO EXPUESTA CON LESIÓN DE LA COLA DE CABALLO"
  },
  {
    "codigo":109756004,
    "descripcion":"FRACTURA DENTAL HORIZONTAL"
  },
  {
    "codigo":404668004,
    "descripcion":"ÉMBOLO DE RETINA CALCIFICADO"
  },
  {
    "codigo":240828008,
    "descripcion":"ABSCESO FILARIÁSICO AGUDO DE MALASIA"
  },
  {
    "codigo":402833001,
    "descripcion":"TELANGIECTASIAS SOLARES"
  },
  {
    "codigo":370065003,
    "descripcion":"INVASIÓN TUMORAL EN LAS ESTRUCTURAS PARATESTICULARES"
  },
  {
    "codigo":677791000119101,
    "descripcion":"OCLUSIÓN DE RAMA DERECHA DE ARTERIA DE LA RETINA"
  },
  {
    "codigo":304529004,
    "descripcion":"FIBROSIS DEL APÉNDICE ILEOCECAL"
  },
  {
    "codigo":238993006,
    "descripcion":"ERITEMA DE PARTES ACRAS"
  },
  {
    "codigo":271761007,
    "descripcion":"PIEL ESCAMOSA"
  },
  {
    "codigo":42385006,
    "descripcion":"GALACTOCELE"
  },
  {
    "codigo":9617008,
    "descripcion":"DIETA PARA HIPERLIPOPROTEINEMIA, TIPO I"
  },
  {
    "codigo":1254801006,
    "descripcion":"CARCINOMA ESCAMOSO BASALOIDE DE OROFARINGE"
  },
  {
    "codigo":366395006,
    "descripcion":"AMPLITUD DEL MOVIMIENTO ACTIVO DE ROTACIÓN HACIA LA DERECHA DE LA COLUMNA CERVICAL - HALLAZGO"
  },
  {
    "codigo":300859007,
    "descripcion":"MASA DE ESTRUCTURA GENITAL FEMENINA"
  },
  {
    "codigo":299024001,
    "descripcion":"HALLAZGO RELACIONADO CON TEMPERATURA DE ARTICULACIÓN DE MUÑECA"
  },
  {
    "codigo":36880005,
    "descripcion":"VENTILACIÓN VOLUNTARIA MÁXIMA AUMENTADA"
  },
  {
    "codigo":725008005,
    "descripcion":"DISTENSIÓN DE TENDÓN DE LA CABEZA"
  },
  {
    "codigo":297189001,
    "descripcion":"PROLAPSO DE COLOSTOMÍA"
  },
  {
    "codigo":167952009,
    "descripcion":"LÍQUIDO PLEURAL OPACO"
  },
  {
    "codigo":723173003,
    "descripcion":"CARCINOSARCOMA DE ANEXOS UTERINOS"
  },
  {
    "codigo":35045004,
    "descripcion":"MICROTIA"
  },
  {
    "codigo":65978000,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA PARED TORÁCICA"
  },
  {
    "codigo":442001,
    "descripcion":"INSUFICIENCIA HIPOFISARIA SECUNDARIA"
  },
  {
    "codigo":721338004,
    "descripcion":"LACERACIÓN DE MÚSCULO DE LA CABEZA"
  },
  {
    "codigo":197050005,
    "descripcion":"INVAGINACIÓN CRÓNICA"
  },
  {
    "codigo":360890004,
    "descripcion":"EX FUMADOR INTOLERANTE"
  },
  {
    "codigo":129679001,
    "descripcion":"RESULTADO DE TOMOGRAFÍA AXIAL COMPUTARIZADA, ANORMAL"
  },
  {
    "codigo":162447003,
    "descripcion":"EL SÍNTOMA DURA SEMANAS"
  },
  {
    "codigo":1145487004,
    "descripcion":"HIPOPLASIA CONGÉNITA DE FALANGE PROXIMAL DE DEDO MEDIO"
  },
  {
    "codigo":293519004,
    "descripcion":"REACCIÓN ADVERSA AL LANATÓSIDO C"
  },
  {
    "codigo":64143008,
    "descripcion":"ÚLCERA DE LABIO"
  },
  {
    "codigo":226148004,
    "descripcion":"DIETA RICA EN ÁCIDO FÓLICO"
  },
  {
    "codigo":95076007,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA PIEL DEL PERINEO"
  },
  {
    "codigo":93241000,
    "descripcion":"HIPOPLASIA CONGÉNITA DE ARCO DE VÉRTEBRA SACRA"
  },
  {
    "codigo":783204009,
    "descripcion":"SÍNDROME DE ANQUILOBLÉFARON FILIFORME CONGÉNITO CON FISURA DE PALADAR"
  },
  {
    "codigo":160612007,
    "descripcion":"CONTINÚA INTENTANDO DEJAR DE FUMAR"
  },
  {
    "codigo":289849003,
    "descripcion":"PERINEO FEMENINO - HALLAZGO"
  },
  {
    "codigo":224313002,
    "descripcion":"CAMBIOS FRECUENTES DE ESCUELA"
  },
  {
    "codigo":715833005,
    "descripcion":"J16"
  },
  {
    "codigo":1303822003,
    "descripcion":"SACROILEÍTIS DE ARTICULACIÓN SACROILÍACA DERECHA"
  },
  {
    "codigo":58638006,
    "descripcion":"PSEUDOPORENCEFALIA"
  },
  {
    "codigo":124174008,
    "descripcion":"DEFICIENCIA DE PIRIDOXAMINA - FOSFATO OXIDASA"
  },
  {
    "codigo":89571002,
    "descripcion":"DIETA PARA LACTANTES PREMATUROS: VITAMINA E A LOS 10 DÍAS Y HIERRO A LAS 3 SEMANAS"
  },
  {
    "codigo":253411005,
    "descripcion":"MÚSCULO PAPILAR MITRAL AUSENTE"
  },
  {
    "codigo":286179007,
    "descripcion":"CAPAZ DE PONER LA MESA"
  },
  {
    "codigo":284344001,
    "descripcion":"NO LE PONE LA TAPA A UN RECIPIENTE"
  },
  {
    "codigo":218808002,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR LOBELINA"
  },
  {
    "codigo":710328004,
    "descripcion":"ACINETOBACTER BEREZINIAE O ACINETOBACTER GUILLOUIAE"
  },
  {
    "codigo":448184007,
    "descripcion":"DEFECTO DEL TABIQUE AURICULOVENTRICULAR CON COMPONENTE VENTRICULAR Y CORTOCIRCUITO POR DEBAJO DE LENGUA CONECTORA CON ORIFICIOS SEPARADOS"
  },
  {
    "codigo":85901000,
    "descripcion":"MEGACALICOSIS"
  },
  {
    "codigo":282509003,
    "descripcion":"DIFICULTAD PARA BAJAR UNA COLINA CORRIENDO"
  },
  {
    "codigo":10946771000119108,
    "descripcion":"AVULSIÓN DE UNIDAD UNGUEAL DE DEDO MEÑIQUE DERECHO"
  },
  {
    "codigo":1003405008,
    "descripcion":"DISOMÍA UNIPARENTAL MATERNA DEL CROMOSOMA 14"
  },
  {
    "codigo":249741009,
    "descripcion":"ACORTAMIENTO DE LA SECCIÓN MEDIA DEL BRAZO"
  },
  {
    "codigo":247906006,
    "descripcion":"LOS BRAZOS NO SE BALANCEAN AL CAMINAR"
  },
  {
    "codigo":18530007,
    "descripcion":"ENFERMEDAD DEL MAR"
  },
  {
    "codigo":16695002,
    "descripcion":"FRACTURA EXPUESTA A NIVEL DE T1 - T6 CON LESIÓN TRAUMÁTICA DE LA MÉDULA ESPINAL"
  },
  {
    "codigo":1260044001,
    "descripcion":"TATUAJE DE PISO DE BOCA"
  },
  {
    "codigo":211468002,
    "descripcion":"LESIONES SUPERFICIALES QUE COMPROMETEN MÚLTIPLES REGIONES CORPORALES"
  },
  {
    "codigo":277004001,
    "descripcion":"DEFECTO MIXTO DE CONOS Y BASTONES"
  },
  {
    "codigo":735756004,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO PERIFÉRICO DE LA PELVIS"
  },
  {
    "codigo":82231009,
    "descripcion":"INVERSIÓN DEL PEZÓN"
  },
  {
    "codigo":113164004,
    "descripcion":"CONDUCTA ANTISOCIAL EN LA INFANCIA O ADOLESCENCIA"
  },
  {
    "codigo":702988007,
    "descripcion":"PREVOTELLA NIGRESCENS O PREVOTELLA INTERMEDIA"
  },
  {
    "codigo":78561001,
    "descripcion":"AMPOLLA DEL PIE, CON INFECCIÓN"
  },
  {
    "codigo":13025001,
    "descripcion":"PSEUDOPOLIPOSIS DE COLON"
  },
  {
    "codigo":209633004,
    "descripcion":"RUPTURA DE LIGAMENTO DE TOBILLO"
  },
  {
    "codigo":240566000,
    "descripcion":"NEUROSÍFILIS GOMATOSA"
  },
  {
    "codigo":109494000,
    "descripcion":"DISPLASIA DE LA DENTINA, TIPO II"
  },
  {
    "codigo":111329009,
    "descripcion":"RECTO PROLAPSADO CONGÉNITO"
  },
  {
    "codigo":371638004,
    "descripcion":"CUERPO FALLECIDO RECIENTEMENTE Y BIEN PRESERVADO"
  },
  {
    "codigo":16054791000119103,
    "descripcion":"ESOTROPÍA INFANTIL BILATERAL"
  },
  {
    "codigo":764854006,
    "descripcion":"ENLENTECIMIENTO DE LA VELOCIDAD DE CONDUCCIÓN NERVIOSA AUTOSÓMICA DOMINANTE"
  },
  {
    "codigo":699318007,
    "descripcion":"TUMOR NEUROECTODÉRMICO PRIMITIVO SUPRATENTORIAL"
  },
  {
    "codigo":1156235000,
    "descripcion":"FIBRINÓGENO DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":238731001,
    "descripcion":"SEUDOPELADA DE BROCQ"
  },
  {
    "codigo":207798009,
    "descripcion":"FRACTURA EXPUESTA DE ALVÉOLO"
  },
  {
    "codigo":7520000,
    "descripcion":"FIEBRE DE ORIGEN DESCONOCIDO"
  },
  {
    "codigo":204128001,
    "descripcion":"CATARATA LAMELAR CONGÉNITA"
  },
  {
    "codigo":38453000,
    "descripcion":"HEMORRAGIA CEREBRAL DEBIDA A ANOXIA O HIPOXIA DURANTE EL PARTO"
  },
  {
    "codigo":1285472009,
    "descripcion":"AMPOLLA FILTRANTE FUNCIONAL"
  },
  {
    "codigo":235061000,
    "descripcion":"ENFERMEDAD BACTERIANA DE LA MUCOSA ORAL"
  },
  {
    "codigo":366133005,
    "descripcion":"HALLAZGO RELACIONADO CON MATIDEZ HEPÁTICA A LA PERCUSIÓN TORÁCICA"
  },
  {
    "codigo":724746000,
    "descripcion":"DELIRIO DEBIDO A MÚLTIPLES FACTORES ETIOLÓGICOS"
  },
  {
    "codigo":202293009,
    "descripcion":"CONTRACTURA EN EXTENSIÓN DE LA ARTICULACIÓN METATARSOFALÁNGICA"
  },
  {
    "codigo":167690001,
    "descripcion":"TRISACÁRIDO DETECTADO EN ESPÉCIMEN DE MATERIA FECAL ESTUDIADO MEDIANTE CROMATOGRAFÍA"
  },
  {
    "codigo":15864481000119102,
    "descripcion":"DEFORMIDAD CONGÉNITA DE DEDOS DE AMBOS PIES"
  },
  {
    "codigo":298762004,
    "descripcion":"HALLAZGO RELACIONADO CON EL TAMAÑO DE LA CLAVÍCULA"
  },
  {
    "codigo":397066005,
    "descripcion":"CRISTALES DE HEMOGLOBINA SC"
  },
  {
    "codigo":722911000,
    "descripcion":"INESTABILIDAD RESPIRATORIA DE LA PREMATUREZ"
  },
  {
    "codigo":427999003,
    "descripcion":"INFECCIÓN CAUSADA POR BRUCELLA MELITENSIS"
  },
  {
    "codigo":1279967005,
    "descripcion":"COMPRESIÓN DE NERVIO PERIFÉRICO DE MANO"
  },
  {
    "codigo":296927005,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE HEPARINA"
  },
  {
    "codigo":721076000,
    "descripcion":"SÍNDROME DE SIEGLER BREWER"
  },
  {
    "codigo":1343668000,
    "descripcion":"HERNIA EPIGÁSTRICA RECURRENTE"
  },
  {
    "codigo":1148895008,
    "descripcion":"ANEMIA HEMOLÍTICA DEBIDA A DEFICIENCIA DE ENOLASA EN LOS GLÓBULOS ROJOS"
  },
  {
    "codigo":67551009,
    "descripcion":"TERCER RUIDO CARDÍACO ANORMAL, R>3<"
  },
  {
    "codigo":391561002,
    "descripcion":"SUBPOBLACIONES DE CÉLULAS T"
  },
  {
    "codigo":293257003,
    "descripcion":"REACCIÓN ADVERSA A LOS ESTRÓGENOS CONJUGADOS"
  },
  {
    "codigo":1145225007,
    "descripcion":"NEURITIS DEBIDA A RUPTURA DE DISCO INTERVERTEBRAL CERVICAL"
  },
  {
    "codigo":424329008,
    "descripcion":"HALLAZGO RELACIONADO CON EL DRENAJE CUTÁNEO"
  },
  {
    "codigo":193118002,
    "descripcion":"COMPRESIONES DE RAÍCES NERVIOSAS Y PLEXOS NERVIOSOS EN LA NEOPLASIA"
  },
  {
    "codigo":782942003,
    "descripcion":"SÍNDROME DE DIVERTÍCULOS DE CÁLICES RENALES Y SORDERA"
  },
  {
    "codigo":1339998004,
    "descripcion":"COMPRESIÓN DE NERVIO SAFENO EXTERNO"
  },
  {
    "codigo":94814007,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":130731000119100,
    "descripcion":"TRASTORNO DE ARTICULACIÓN DE VÉRTEBRA LUMBOSACRA"
  },
  {
    "codigo":681131000119101,
    "descripcion":"NEVO CISTOIDE DE CONJUNTIVA DE OJO DERECHO"
  },
  {
    "codigo":345771000119101,
    "descripcion":"TRASTORNO DE AMBAS RETINAS CONCOMITANTE CON HIPERTENSIÓN Y DEBIDO A ELLA"
  },
  {
    "codigo":66731000119103,
    "descripcion":"PORTADOR DE DISTROFIA MUSCULAR DE DUCHENNE"
  },
  {
    "codigo":350891000119104,
    "descripcion":"NEOPLASIA BENIGNA DE PARTES BLANDAS DE EXTREMIDAD INFERIOR DERECHA"
  },
  {
    "codigo":60211009,
    "descripcion":"CONTUSIÓN DEL FLANCO"
  },
  {
    "codigo":43691000119105,
    "descripcion":"LESIÓN VASCULAR DE PÁRPADO"
  },
  {
    "codigo":138841771000119103,
    "descripcion":"CANDIDIASIS CRÓNICA DE VAGINA DURANTE EL EMBARAZO"
  },
  {
    "codigo":1077931000119106,
    "descripcion":"OSTEÓLISIS DE PORCIÓN DISTAL DE CLAVÍCULA DERECHA"
  },
  {
    "codigo":335531000119109,
    "descripcion":"DEGENERACIÓN MACULAR CISTOIDE DE RETINA DERECHA"
  },
  {
    "codigo":387891008,
    "descripcion":"NEOPLASIA DE NERVIO VESTIBULOCOCLEAR"
  },
  {
    "codigo":128171000119104,
    "descripcion":"FÍSTULA CAROTIDEOCAVERNOSA ESPONTÁNEA"
  },
  {
    "codigo":171000119107,
    "descripcion":"OBESIDAD MATERNA QUE COMPLICA EL EMBARAZO, EL PARTO Y EL PUERPERIO, PREPARTO"
  },
  {
    "codigo":330411000119109,
    "descripcion":"HEMIPARESIA ATÁXICA LACUNAR DE LADO IZQUIERDO NO DOMINANTE"
  },
  {
    "codigo":304811000119105,
    "descripcion":"DETENCIÓN TOTAL DE CRECIMIENTO EPIFISARIO DE TIBIA DISTAL IZQUIERDA"
  },
  {
    "codigo":123912007,
    "descripcion":"INTOXICACIÓN POR PORTULACACEAE"
  },
  {
    "codigo":11842731000119108,
    "descripcion":"DISTENSIÓN DE MÚSCULO DEL PIE DERECHO"
  },
  {
    "codigo":254984005,
    "descripcion":"TUMOR BENIGNO DE NERVIO ESPINAL Y SU VAINA"
  },
  {
    "codigo":253149002,
    "descripcion":"LISENCEFALIA TIPO 2"
  },
  {
    "codigo":449757007,
    "descripcion":"SECRECIÓN VISCOSA DE HERIDA"
  },
  {
    "codigo":1268957005,
    "descripcion":"PINEOBLASTOMA PRIMARIO"
  },
  {
    "codigo":285917009,
    "descripcion":"CAPAZ DE LLENAR LA BAÑERA"
  },
  {
    "codigo":187613005,
    "descripcion":"NEOPLASIA MALIGNA DE LABIO INFERIOR, CARA BUCAL"
  },
  {
    "codigo":710066005,
    "descripcion":"PUNTAJE DE CHILD-PUGH CLASE B"
  },
  {
    "codigo":249479000,
    "descripcion":"POCA SED"
  },
  {
    "codigo":216711004,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR CARBAMATOS"
  },
  {
    "codigo":413319007,
    "descripcion":"NO CONCURRE EN REITERADAS OPORTUNIDADES"
  },
  {
    "codigo":51036000,
    "descripcion":"APENDICITIS AGUDA CON ABSCESO PERITONEAL"
  },
  {
    "codigo":247644004,
    "descripcion":"ECO DEL PENSAMIENTO"
  },
  {
    "codigo":18268005,
    "descripcion":"AMPOLLA DE HOMBRO, SIN INFECCIÓN"
  },
  {
    "codigo":313180007,
    "descripcion":"GESTACIÓN MAYOR DE 24 SEMANAS"
  },
  {
    "codigo":278577003,
    "descripcion":"ENCHAPADO DENTAL EXCESIVAMENTE VOLUMINOSO"
  },
  {
    "codigo":737329004,
    "descripcion":"DAÑO DE ÓRGANOS Y TEJIDOS PÉLVICOS DESPUÉS DE EMBARAZO ECTÓPICO"
  },
  {
    "codigo":770097006,
    "descripcion":"EDEMA DE MÁCULA CLÍNICAMENTE SIGNIFICATIVO DEBIDO A DIABETES MELLITUS"
  },
  {
    "codigo":1228849007,
    "descripcion":"MIOPATÍA CON CUERPOS DE POLIGLUCOSANO TIPO 2"
  },
  {
    "codigo":735494000,
    "descripcion":"TRAUMATISMO OBSTÉTRICO DE TÓRAX"
  },
  {
    "codigo":1259782005,
    "descripcion":"FIBROHISTIOCITOMA MALIGNO INFLAMATORIO PRIMARIO DE PIEL"
  },
  {
    "codigo":209371001,
    "descripcion":"FRACTURA-SUBLUXACIÓN NO EXPUESTA DE ARTICULACIÓN SUBASTRAGALINA"
  },
  {
    "codigo":307675005,
    "descripcion":"NISTAGMO VESTIBULAR CENTRAL"
  },
  {
    "codigo":12763006,
    "descripcion":"PRESIÓN ARTERIAL BAJA"
  },
  {
    "codigo":699056001,
    "descripcion":"TELANGIECTASIA DE PIEL DE LA CARA"
  },
  {
    "codigo":43696002,
    "descripcion":"HEMORRAGIA CAPILAR"
  },
  {
    "codigo":1354416002,
    "descripcion":"INMUNODEFICIENCIA COMBINADA VARIABLE AUTOSÓMICA DOMINANTE DEBIDA A MUTACIÓN DE NFKB1"
  },
  {
    "codigo":830128004,
    "descripcion":"VISIÓN CERCANA NORMAL"
  },
  {
    "codigo":305840008,
    "descripcion":"VISTO POR SERVICIO DE TERAPIA CON ARTES PLÁSTICAS"
  },
  {
    "codigo":404144008,
    "descripcion":"LINFOMA CUTÁNEO PRIMARIO DIFUSO DE GRANDES CÉLULAS B"
  },
  {
    "codigo":402309002,
    "descripcion":"PSORIASIS CRÓNICA CON PATRÓN EN GOTAS"
  },
  {
    "codigo":369541004,
    "descripcion":"NEOPLASIA MALIGNA QUE COMPROMETE TROMPA DE FALOPIO IZQUIERDA POR PROPAGACIÓN DIRECTA DESDE VAGINA"
  },
  {
    "codigo":238469005,
    "descripcion":"ALOPECIA POR FRICCIÓN"
  },
  {
    "codigo":762757008,
    "descripcion":"DERMATITIS ALÉRGICA POR CONTACTO CAUSADA POR VESTIMENTA"
  },
  {
    "codigo":1186906007,
    "descripcion":"ÁCIDO ÚRICO DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":236634008,
    "descripcion":"DISFUNCIÓN DE MÚSCULO DE VEJIGA URINARIA - HIPOACTIVO"
  },
  {
    "codigo":40026008,
    "descripcion":"ESTENOSIS ADQUIRIDA DE CUELLO DE VEJIGA URINARIA"
  },
  {
    "codigo":202031002,
    "descripcion":"ARTRITIS GENERALIZADA"
  },
  {
    "codigo":1119535004,
    "descripcion":"AGUDEZA VISUAL LEVEMENTE DISMINUIDA"
  },
  {
    "codigo":365871009,
    "descripcion":"HALLAZGO RELACIONADO CON EL CONOCIMIENTO DEL DIAGNÓSTICO"
  },
  {
    "codigo":300335009,
    "descripcion":"HALLAZGO RELACIONADO CON LA PULSACIÓN DEL HÍGADO"
  },
  {
    "codigo":298500007,
    "descripcion":"COLUMNA DORSAL TUMEFACTA"
  },
  {
    "codigo":67289000,
    "descripcion":"MORDIDA ABIERTA ANTERIOR"
  },
  {
    "codigo":263897001,
    "descripcion":"SENSACIÓN DE TENSIÓN"
  },
  {
    "codigo":296665001,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE FLUCLOXACILINA"
  },
  {
    "codigo":460505006,
    "descripcion":"OBSTRUCCIÓN DE CONDUCTO DE AURÍCULA DERECHA DESPUÉS DE PROCEDIMIENTO PREVIO DE CONEXIÓN CAVOPULMONAR TOTAL"
  },
  {
    "codigo":1279705006,
    "descripcion":"OBSTRUCCIÓN COMPLETA DE EXTREMO DISTAL DE TROMPA UTERINA"
  },
  {
    "codigo":294830002,
    "descripcion":"ALERGIA A TIROTROFINA"
  },
  {
    "codigo":65454003,
    "descripcion":"INFERTILIDAD FEMENINA ASOCIADA CON ANOMALÍA UTERINA CONGÉNITA"
  },
  {
    "codigo":1343406005,
    "descripcion":"ECOGRAFÍA DE PLACENTA NORMAL"
  },
  {
    "codigo":130990006,
    "descripcion":"AFASIA TRANSCORTICAL"
  },
  {
    "codigo":1144963000,
    "descripcion":"ENFERMEDAD DE INJERTO VERSUS HUÉSPED CRÓNICA REAGUDIZADA"
  },
  {
    "codigo":161923004,
    "descripcion":"TOS PRODUCTIVA - ESPUTO CLARO"
  },
  {
    "codigo":292995008,
    "descripcion":"REACCIÓN ADVERSA A CEFALOSPORINA DE PRIMERA GENERACIÓN"
  },
  {
    "codigo":225624000,
    "descripcion":"ATAQUE DE PÁNICO"
  },
  {
    "codigo":782680004,
    "descripcion":"GANGLIOCITOMA DE SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":94552004,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA PIEL DE LAS CEJAS"
  },
  {
    "codigo":15951421000119100,
    "descripcion":"MELANOMA IN SITU DE PIEL DE MAMA DERECHA"
  },
  {
    "codigo":289325006,
    "descripcion":"ERITEMA CUTÁNEO ALREDEDOR DEL MUÑÓN UMBILICAL"
  },
  {
    "codigo":92717008,
    "descripcion":"CARCINOMA IN SITU DE LA PIEL DEL TÓRAX"
  },
  {
    "codigo":254722001,
    "descripcion":"EPITELIOMA ECRINO"
  },
  {
    "codigo":25346000,
    "descripcion":"INTOXICACIÓN POR SOLANUM TUBEROSUM"
  },
  {
    "codigo":123650004,
    "descripcion":"ALTERACIONES CROMOSÓMICAS DEL GRUPO E"
  },
  {
    "codigo":711639000,
    "descripcion":"PULPITIS IRREVERSIBLE ASINTOMÁTICA"
  },
  {
    "codigo":1336066009,
    "descripcion":"EPISODIO DE USO NOCIVO DE NUEVA SUSTANCIA PSICOACTIVA"
  },
  {
    "codigo":449495003,
    "descripcion":"CONEXIÓN VENOSA PULMONAR ANÓMALA DE LOCALIZACIÓN INFRACARDÍACA A CONDUCTO VENOSO PERMEABLE"
  },
  {
    "codigo":23511006,
    "descripcion":"INFECCIÓN MENINGOCÓCICA"
  },
  {
    "codigo":251052000,
    "descripcion":"MIOCARDIO - HALLAZGO"
  },
  {
    "codigo":416727009,
    "descripcion":"LEE IDIOMA FARSI"
  },
  {
    "codigo":447660003,
    "descripcion":"VENA BRAQUIOCEFÁLICA RETROAÓRTICA"
  },
  {
    "codigo":283820003,
    "descripcion":"MORDEDURA DE ANIMAL EN LOS GENITALES"
  },
  {
    "codigo":773505002,
    "descripcion":"ALERGIA A PROPAMIDINA"
  },
  {
    "codigo":249217005,
    "descripcion":"HEMATOMA VULVAR DEBIDO AL TRABAJO DE PARTO"
  },
  {
    "codigo":85377008,
    "descripcion":"RALES LATENTES"
  },
  {
    "codigo":116310002,
    "descripcion":"HALLAZGO RELACIONADO CON LA REGIÓN DEL CARPO"
  },
  {
    "codigo":247382002,
    "descripcion":"DOLOR DE LA VÍA URINARIA"
  },
  {
    "codigo":312918002,
    "descripcion":"DISTROFIA COROIDEA"
  },
  {
    "codigo":704299001,
    "descripcion":"CONFLICTO CON CREENCIAS RELACIONADAS CON LA SALUD"
  },
  {
    "codigo":224392006,
    "descripcion":"BUENA ACEPTACIÓN DE LA AUTORIDAD EN EL TRABAJO"
  },
  {
    "codigo":16171003,
    "descripcion":"ATETOSIS DOBLE"
  },
  {
    "codigo":473088000,
    "descripcion":"INFLAMACIÓN ASOCIADA CON DISPOSITIVO"
  },
  {
    "codigo":442155009,
    "descripcion":"HEMIPLEJÍA DE LADO DOMINANTE"
  },
  {
    "codigo":1259520002,
    "descripcion":"CARCINOMA PRIMARIO DE GLOTIS"
  },
  {
    "codigo":309248004,
    "descripcion":"PÓLIPO DE VEJIGA URINARIA"
  },
  {
    "codigo":702464004,
    "descripcion":"SÍNDROME PARALÍTICO DE TRES EXTREMIDADES"
  },
  {
    "codigo":14336007,
    "descripcion":"ANEURISMA ROTO DE AORTA ABDOMINAL"
  },
  {
    "codigo":407552008,
    "descripcion":"EPICANTO ANCHO"
  },
  {
    "codigo":276480007,
    "descripcion":"OSTEOCONDRITIS DE METATARSO"
  },
  {
    "codigo":405717004,
    "descripcion":"MÉDULA ÓSEA CON DISPLASIA MIELOIDE"
  },
  {
    "codigo":733397005,
    "descripcion":"LACERACIÓN DE REGIÓN DEL HOMBRO CON CUERPO EXTRAÑO"
  },
  {
    "codigo":45269006,
    "descripcion":"ALEUCIA TÓXICA ALIMENTARIA"
  },
  {
    "codigo":372949005,
    "descripcion":"INFECCIÓN CAUSADA POR PENICILLIUM COMMUNE"
  },
  {
    "codigo":241877009,
    "descripcion":"EFECTO TÓXICO CAUSADO POR PINTURA ANTIGRAFITTI"
  },
  {
    "codigo":371114002,
    "descripcion":"CRISIS CONVULSIVA QUE COMPLICA HEMORRAGIA INTRACRANEAL"
  },
  {
    "codigo":305578001,
    "descripcion":"BAJO ATENCIÓN DE ENFERMERA DE ATENCIÓN PRIMARIA"
  },
  {
    "codigo":240042004,
    "descripcion":"TOFO"
  },
  {
    "codigo":860799000,
    "descripcion":"ENCEFALOPATÍA DEBIDA A DEFICIENCIA DE FOLATO"
  },
  {
    "codigo":403882009,
    "descripcion":"ENFERMEDAD DE BOWEN, VERRUGOSA"
  },
  {
    "codigo":205439003,
    "descripcion":"ESPONDILOSINDESIS PARCIAL CONGÉNITA CON HEMIVÉRTEBRA - INESTABLE"
  },
  {
    "codigo":926335004,
    "descripcion":"RUPTURA DE MANGUITO ROTADOR DE HOMBRO"
  },
  {
    "codigo":762495004,
    "descripcion":"EMACIACIÓN DE CAUSA NUTRICIONAL EN LA ADOLESCENCIA"
  },
  {
    "codigo":41599008,
    "descripcion":"INTOXICACIÓN POR DELPHINIUM"
  },
  {
    "codigo":6996004,
    "descripcion":"AUSENCIA CONGÉNITA DE VÁLVULA PULMONAR"
  },
  {
    "codigo":201769002,
    "descripcion":"ARTRITIS REUMATOIDE DE CODO"
  },
  {
    "codigo":10737521000119108,
    "descripcion":"CISTOADENOCARCINOMA MUCINOSO PRIMARIO DE OVARIO DERECHO"
  },
  {
    "codigo":307211000119102,
    "descripcion":"ARTRITIS ENTEROPÁTICA DE CADERA DERECHA"
  },
  {
    "codigo":735703051000119102,
    "descripcion":"CUERPO EXTRAÑO MAGNÉTICO RETENIDO EN CRISTALINO DE OJO IZQUIERDO"
  },
  {
    "codigo":396542002,
    "descripcion":"MARGEN QUIRÚRGICO NO COMPROMETIDO POR CARCINOMA\/ADENOMA IN SITU"
  },
  {
    "codigo":365609009,
    "descripcion":"NIVEL DE FOLATOS EN SANGRE - HALLAZGO"
  },
  {
    "codigo":11310961000119109,
    "descripcion":"FRACTURA NO EXPUESTA DE CUARTA VÉRTEBRA LUMBAR"
  },
  {
    "codigo":789758005,
    "descripcion":"DISTENSIÓN DE MANGUITO ROTADOR DE HOMBRO"
  },
  {
    "codigo":298238005,
    "descripcion":"ARTICULACIÓN DE DEDO DE LA MANO RÍGIDA"
  },
  {
    "codigo":296403001,
    "descripcion":"SOBREDOSIS DE ACETILCISTEÍNA"
  },
  {
    "codigo":427475007,
    "descripcion":"DOLOR IRRADIADO LA REGIÓN LUMBAR"
  },
  {
    "codigo":690341000119100,
    "descripcion":"DÉFICIT COGNITIVO DEBIDO A ACCIDENTE CEREBROVASCULAR EMBÓLICO Y POSTERIOR A ÉL"
  },
  {
    "codigo":294568008,
    "descripcion":"ALERGIA A TINIDAZOL"
  },
  {
    "codigo":391037000,
    "descripcion":"ATENDIDO EN CONSULTORIO ESPECIALIZADO EN OSTEOPOROSIS"
  },
  {
    "codigo":194429000,
    "descripcion":"PÉRDIDA DE LA AUDICIÓN MIXTA DE CONDUCCIÓN Y SENSORIAL, BILATERAL"
  },
  {
    "codigo":718717004,
    "descripcion":"SÍNDROME DE INMUNODEFICIENCIA PRIMARIA DEBIDO A DEFICIENCIA DE P14"
  },
  {
    "codigo":1144701007,
    "descripcion":"APLASIA DE FALANGE PROXIMAL DE TERCER DEDO DE PIE"
  },
  {
    "codigo":323666000,
    "descripcion":"ANEMIA DEBIDA A ALTERACIÓN INTRÍNSECA DEL ERITROCITO"
  },
  {
    "codigo":258130003,
    "descripcion":"VOZ TRANQUILIZANTE"
  },
  {
    "codigo":290898004,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR NEFAZODONA"
  },
  {
    "codigo":1208402005,
    "descripcion":"INFECCIÓN INTRABDOMINAL POSTERIOR A PROCEDIMIENTO QUIRÚRGICO"
  },
  {
    "codigo":94290006,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE EXOCÉRVIX"
  },
  {
    "codigo":127058009,
    "descripcion":"HEMOGLOBINURIA PAROXÍSTICA INDUCIDA POR FRÍO ASOCIADA CON SÍFILIS TERCIARIA"
  },
  {
    "codigo":92455004,
    "descripcion":"NEOPLASIA BENIGNA DEL CÚBITO"
  },
  {
    "codigo":289063005,
    "descripcion":"UTILIZA CUCHARA PARA ALIMENTARSE"
  },
  {
    "codigo":715047008,
    "descripcion":"OBTIENE MEDICACIÓN"
  },
  {
    "codigo":16746661000119106,
    "descripcion":"RETINOPATÍA DIABÉTICA NO PROLIFERATIVA BILATERAL POR DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":15982911000119100,
    "descripcion":"OTITIS EXTERNA DE CONDUCTO AUDITIVO EXTERNO IZQUIERDO CAUSADO POR VIRUS DEL HERPES SIMPLE HUMANO"
  },
  {
    "codigo":187089001,
    "descripcion":"ACTINOMICETOMA"
  },
  {
    "codigo":285393002,
    "descripcion":"ESFUERZO MUSCULAR DE LAS EXTREMIDADES SUPERIORES"
  },
  {
    "codigo":416465001,
    "descripcion":"RESONANCIA MAGNÉTICA DE TÓRAX, ANORMAL"
  },
  {
    "codigo":254460009,
    "descripcion":"CARCINOMA IN SITU DEL PILAR ANTERIOR DE FAUCES"
  },
  {
    "codigo":1332134000,
    "descripcion":"MASTOCITOSIS CUTÁNEA MACULOPAPULAR"
  },
  {
    "codigo":185254005,
    "descripcion":"ATENDIDO EN UN CONSULTORIO ORTOPÉDICO PEDIÁTRICO"
  },
  {
    "codigo":283558006,
    "descripcion":"HERIDA DE PERDIGÓN EN GARGANTA"
  },
  {
    "codigo":1363067001,
    "descripcion":"METABOLIZADOR POBRE DE FAMILIA 2 SUBFAMILIA C MIEMBRO 9 *6\/*6 DE CITOCROMO P450"
  },
  {
    "codigo":10658111000119104,
    "descripcion":"ÚLCERA NEUROPÁTICA DE TALÓN DERECHO"
  },
  {
    "codigo":183419004,
    "descripcion":"TRABAJADOR SOCIAL DE LA SALUD INVOLUCRADO"
  },
  {
    "codigo":19579005,
    "descripcion":"OSTEOCONDRITIS JUVENIL"
  },
  {
    "codigo":247120000,
    "descripcion":"ASAS VENOSAS RETINIANAS"
  },
  {
    "codigo":609403008,
    "descripcion":"CON RIESGO EXTREMO DE CARIES DENTALES"
  },
  {
    "codigo":212517000,
    "descripcion":"INTOXICACIÓN POR COMPUESTO DE ANTIMONIO"
  },
  {
    "codigo":81445002,
    "descripcion":"ADHERENCIA DIAFRAGMÁTICA"
  },
  {
    "codigo":11778521000119101,
    "descripcion":"DISTENSIÓN DE MÚSCULO Y\/O TENDÓN SUPRAESPINOSO DERECHO"
  },
  {
    "codigo":700367002,
    "descripcion":"ORZUELO EXTERNO DE PÁRPADO INFERIOR"
  },
  {
    "codigo":45007003,
    "descripcion":"HIPOTENSIÓN ARTERIAL"
  },
  {
    "codigo":733135005,
    "descripcion":"CARCINOMA UROTELIAL PRIMARIO DE GLÁNDULA PARAURETRAL"
  },
  {
    "codigo":77775007,
    "descripcion":"COLOR NORMAL"
  },
  {
    "codigo":15710681000119105,
    "descripcion":"DISECCIÓN DE ARTERIA VERTEBRAL DERECHA"
  },
  {
    "codigo":403620001,
    "descripcion":"ERITRODERMIA CAUSADA POR VANCOMICINA"
  },
  {
    "codigo":698532002,
    "descripcion":"REQUERIMIENTO DE EQUIPAMIENTO"
  },
  {
    "codigo":239780003,
    "descripcion":"ARTRITIS VIRAL"
  },
  {
    "codigo":272548006,
    "descripcion":"SENTADO EN ALTURA"
  },
  {
    "codigo":8569001,
    "descripcion":"SINCÉFALO"
  },
  {
    "codigo":237945003,
    "descripcion":"DEFICIENCIA COMPLETA DE METILMALONIL-COA MUTASA"
  },
  {
    "codigo":205177003,
    "descripcion":"PULGAR HIPOPLÁSICO-BLAUTH 4"
  },
  {
    "codigo":41337007,
    "descripcion":"MELLIZOS SIAMESES"
  },
  {
    "codigo":236110004,
    "descripcion":"NECROSIS DE ANASTOMOSIS GASTROINTESTINAL"
  },
  {
    "codigo":72270005,
    "descripcion":"NEUMOCONIOSIS FIBROSANTE"
  },
  {
    "codigo":203342006,
    "descripcion":"ENFERMEDAD DE PAGET DE FÉMUR"
  },
  {
    "codigo":301646006,
    "descripcion":"SE SIENTA Y SE LEVANTA DE UNA SILLA"
  },
  {
    "codigo":398115000,
    "descripcion":"EQUIPO MÉDICO MAL CONECTADO"
  },
  {
    "codigo":267043001,
    "descripcion":"VENAS PROMINENTES DE LA PIERNA"
  },
  {
    "codigo":39502009,
    "descripcion":"AMILOIDE AURICULAR AISLADO"
  },
  {
    "codigo":299811000,
    "descripcion":"REFLEJO CORNEAL TARDÍO"
  },
  {
    "codigo":365347007,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA USAR MEDIO DE TRANSPORTE PÚBLICO"
  },
  {
    "codigo":396280002,
    "descripcion":"SIN ÓRGANO ADICIONAL PRESENTE EN ESPÉCIMEN QUIRÚRGICO"
  },
  {
    "codigo":68600005,
    "descripcion":"HEMOGLOBINURIA"
  },
  {
    "codigo":297976006,
    "descripcion":"HALLAZGO RELACIONADO CON LA TEMPERATURA DE LA PIEL"
  },
  {
    "codigo":296141000,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE DICLORALFENAZONA"
  },
  {
    "codigo":232440009,
    "descripcion":"ESTENOSIS LARÍNGEA ADQUIRIDA"
  },
  {
    "codigo":1075981000119101,
    "descripcion":"RUPTURA DE QUISTE SINOVIAL DE RODILLA IZQUIERDA"
  },
  {
    "codigo":722125003,
    "descripcion":"ESTOMATOCITOSIS HEREDITARIA SOBREHIDRATADA"
  },
  {
    "codigo":427213005,
    "descripcion":"VASCULITIS AUTOINMUNITARIA"
  },
  {
    "codigo":33997006,
    "descripcion":"ANEURISMA DE ARTERIA GASTRODUODENAL"
  },
  {
    "codigo":230605007,
    "descripcion":"MONONEURITIS MÚLTIPLE POR ENFERMEDAD DE LYME"
  },
  {
    "codigo":197837005,
    "descripcion":"CISTITIS SUBMUCOSA"
  },
  {
    "codigo":32162001,
    "descripcion":"HEMIPLEJÍA FACIAL"
  },
  {
    "codigo":165069007,
    "descripcion":"REGISTRO DE TEMPERATURA: ANOVULATORIO"
  },
  {
    "codigo":294306008,
    "descripcion":"ALERGIA A DIMETIL-ÉTER PROPANO"
  },
  {
    "codigo":95863002,
    "descripcion":"EXPOSICIÓN A LA RADIACIÓN EN EL AMBIENTE LABORAL"
  },
  {
    "codigo":1144439003,
    "descripcion":"ATROFIA DE CORTEZA DE LÓBULO TEMPORAL"
  },
  {
    "codigo":338701000119104,
    "descripcion":"PINGUÉCULA DE OJO IZQUIERDO"
  },
  {
    "codigo":292471002,
    "descripcion":"REACCIÓN ADVERSA AL DEMECARIO"
  },
  {
    "codigo":421708000,
    "descripcion":"ARTRITIS SÉPTICA ASOCIADA CON SIDA (SÍNDROME DE INMUNODEFICIENCIA ADQUIRIDA)"
  },
  {
    "codigo":94028002,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA PIEL DE LA MANO"
  },
  {
    "codigo":126796005,
    "descripcion":"NEOPLASIA DE MUCOSA DE CRESTA ALVEOLAR"
  },
  {
    "codigo":16040871000119100,
    "descripcion":"ARTRITIS IDIOPÁTICA JUVENIL DE INICIO SISTÉMICO DE AMBAS CADERAS"
  },
  {
    "codigo":124961001,
    "descripcion":"RETICULOCITOPENIA"
  },
  {
    "codigo":92193002,
    "descripcion":"NEOPLASIA BENIGNA DEL TERCIO INFERIOR DEL ESÓFAGO"
  },
  {
    "codigo":288801003,
    "descripcion":"INCAPAZ DE EMPLEAR EL HUMOR"
  },
  {
    "codigo":712950002,
    "descripcion":"REACCIÓN ADVERSA A GLUTETIMIDA"
  },
  {
    "codigo":876790006,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE TOBILLO CON INFECCIÓN"
  },
  {
    "codigo":188662007,
    "descripcion":"MASTOCITOMA MALIGNO DE GANGLIOS LINFÁTICOS DE CABEZA Y CUELLO"
  },
  {
    "codigo":285131005,
    "descripcion":"HÁBITO DE TIRARSE DEL PELO"
  },
  {
    "codigo":283296006,
    "descripcion":"ASTILLA DE MADERA DEBAJO DE LA UÑA DEL PULGAR"
  },
  {
    "codigo":250528006,
    "descripcion":"PRUEBA DE LA FOSFATASA: APROBADA"
  },
  {
    "codigo":707445000,
    "descripcion":"EXACERBACIÓN DE ASMA LEVE PERSISTENTE"
  },
  {
    "codigo":53920008,
    "descripcion":"INFECCIÓN CAUSADA POR SPIROCERCA ARCTICA"
  },
  {
    "codigo":281461003,
    "descripcion":"ARQUEAMIENTO DE CLAVO INTRAMEDULAR"
  },
  {
    "codigo":1264501003,
    "descripcion":"CISTADENOCARCINOMA PAPILAR DE RIÑÓN METASTÁSICO"
  },
  {
    "codigo":1297269003,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE DEDO MEDIO DE MANO"
  },
  {
    "codigo":248693006,
    "descripcion":"NEUTROPENIA CRÓNICA IDIOPÁTICA"
  },
  {
    "codigo":314229006,
    "descripcion":"PRESENCIA DE CHAPERONA"
  },
  {
    "codigo":1295434001,
    "descripcion":"RADIOGRAFÍA DE BARRIDO DE ESQUELETO COMPLETO NORMAL"
  },
  {
    "codigo":771146007,
    "descripcion":"SÍNDROME DE HOLOPROSENCEFALIA CON DISGENESIA CAUDAL"
  },
  {
    "codigo":408863003,
    "descripcion":"CON MAYOR RIESGO DE EVENTO CARDÍACO ISQUÉMICO AGUDO"
  },
  {
    "codigo":277791008,
    "descripcion":"PÚRPURA SIMPLE"
  },
  {
    "codigo":212255009,
    "descripcion":"LESIÓN NO EXPUESTA, NERVIO MEDIANO"
  },
  {
    "codigo":274121004,
    "descripcion":"ENFERMEDAD CARDÍACA EN EL EMBARAZO"
  },
  {
    "codigo":341211000119102,
    "descripcion":"ESTAFILOMA CORNEAL DE OJO IZQUIERDO"
  },
  {
    "codigo":698270004,
    "descripcion":"ARRITMIA CARDÍACA ASOCIADA CON TRASTORNO GENÉTICO"
  },
  {
    "codigo":403358007,
    "descripcion":"MACROCOMEDÓN (ACNÉ)"
  },
  {
    "codigo":41075004,
    "descripcion":"INFECCIÓN MICÓTICA DEL CEREBRO"
  },
  {
    "codigo":237683004,
    "descripcion":"PANHIPOPITUITARISMO LIGADO AL CROMOSOMA X"
  },
  {
    "codigo":73843004,
    "descripcion":"ENFERMEDAD DE COBALAMINA A"
  },
  {
    "codigo":235848001,
    "descripcion":"GANGRENA MESENTÉRICA"
  },
  {
    "codigo":203080002,
    "descripcion":"CONTRACTURA DE MÚSCULOS EXTENSORES LARGOS DE DEDOS DEL PIE"
  },
  {
    "codigo":1153352007,
    "descripcion":"POLICITEMIA POR MUTACIÓN DE HIF2A"
  },
  {
    "codigo":365085000,
    "descripcion":"HALLAZGO RELACIONADO CON EL COMPONENTE DE CENTELLEO DEL POTENCIAL EVOCADO VISUAL"
  },
  {
    "codigo":168477001,
    "descripcion":"CITOLOGÍA DE ESPUTO POSITIVA"
  },
  {
    "codigo":430621000,
    "descripcion":"NEOPLASIA MALIGNA DEL TRACTO RESPIRATORIO INFERIOR"
  },
  {
    "codigo":102941003,
    "descripcion":"ALETIA"
  },
  {
    "codigo":234013003,
    "descripcion":"AVULSIÓN ARTERIAL"
  },
  {
    "codigo":4637005,
    "descripcion":"COLESTASIS INTRAHEPÁTICA"
  },
  {
    "codigo":1217053007,
    "descripcion":"INFLAMACIÓN DE GLÁNDULA SUPRARRENAL"
  },
  {
    "codigo":299549008,
    "descripcion":"SIN AMPLITUD ACTIVA DE EVERSIÓN DE ARTICULACIÓN SUBASTRAGALINA"
  },
  {
    "codigo":166642001,
    "descripcion":"ENZIMAS HEPÁTICAS DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":70173007,
    "descripcion":"SÍNDROME DE MONOSOMÍA PARCIAL 5P"
  },
  {
    "codigo":428786006,
    "descripcion":"TUMEFACCIÓN CUTÁNEA SUPERFICIAL LOCALIZADA"
  },
  {
    "codigo":263111004,
    "descripcion":"FRACTURA-SUBLUXACIÓN DEL PULGAR"
  },
  {
    "codigo":295879004,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE NORTRIPTILINA"
  },
  {
    "codigo":720028006,
    "descripcion":"DISFUNCIÓN SOMÁTICA DE REGIÓN ACROMIOCLAVICULAR"
  },
  {
    "codigo":64668006,
    "descripcion":"LEUCOCITO SENSIBILIZADO"
  },
  {
    "codigo":95601000,
    "descripcion":"OBSTRUCCIÓN DEL HIMEN"
  },
  {
    "codigo":294044009,
    "descripcion":"ALERGIA A TERBUTALINA"
  },
  {
    "codigo":292209002,
    "descripcion":"REACCIÓN ADVERSA A LA MUSTINA"
  },
  {
    "codigo":783729004,
    "descripcion":"DISPLASIA FIBROMUSCULAR DE PARED DE ARTERIA"
  },
  {
    "codigo":718193005,
    "descripcion":"RESISTENCIA PERIFÉRICA A HORMONA TIROIDEA"
  },
  {
    "codigo":93766000,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE CÓRNEA"
  },
  {
    "codigo":290374004,
    "descripcion":"INTOXICACIÓN POR LANSOPRAZOL"
  },
  {
    "codigo":126534007,
    "descripcion":"POLINEUROPATÍA SENSITIVOMOTORA MIXTA DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":91931000,
    "descripcion":"ALERGIA A ERITROMICINA"
  },
  {
    "codigo":124699005,
    "descripcion":"DEFICIENCIA DE ÁCIDO GRASO - COA DE CADENA LARGA LIGASA"
  },
  {
    "codigo":16016911000119106,
    "descripcion":"ARTRITIS VIRAL DE ARTICULACIÓN DE RODILLA DERECHA"
  },
  {
    "codigo":1081001000119100,
    "descripcion":"MELANOMA MALIGNO DE CONJUNTIVA DE OJO DERECHO"
  },
  {
    "codigo":385008006,
    "descripcion":"MARGEN POSTEROLATERAL (PAQUETE VASCULONERVIOSO) DE RESECCIÓN QUIRÚRGICA AFECTADO POR NEOPLASIA MALIGNA"
  },
  {
    "codigo":1236976008,
    "descripcion":"INVERSIÓN UTERINA PUERPERAL"
  },
  {
    "codigo":122864009,
    "descripcion":"ABSCESO DE TENDÓN"
  },
  {
    "codigo":253936008,
    "descripcion":"HIPOPLASIA DEL PULGAR"
  },
  {
    "codigo":286704008,
    "descripcion":"PREDISPUESTO A SOBRESALTARSE"
  },
  {
    "codigo":448709005,
    "descripcion":"LINFOMA NO HODGKIN DE ESTÓMAGO"
  },
  {
    "codigo":283034002,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE LA MANO"
  },
  {
    "codigo":1003930003,
    "descripcion":"DELECIÓN PROXIMAL DEL BRAZO LARGO DEL CROMOSOMA 12"
  },
  {
    "codigo":709018004,
    "descripcion":"INFECCIÓN CAUSADA POR LARVAS DE TRICHINELLA"
  },
  {
    "codigo":250266005,
    "descripcion":"PRUEBA DE HEMÓLISIS EN SACAROSA, POSITIVA"
  },
  {
    "codigo":343721000119103,
    "descripcion":"RETINOSQUISIS BILATERAL"
  },
  {
    "codigo":86426007,
    "descripcion":"TRASTORNO HEREDITARIO AUTOSÓMICO DOMINANTE, PENETRANCIA COMPLETA"
  },
  {
    "codigo":445039006,
    "descripcion":"MASA DE ANEXOS UTERINOS"
  },
  {
    "codigo":1264239007,
    "descripcion":"DAÑO DE LIGAMENTO ANCHO DE ÚTERO POSTERIOR A EMBARAZO ECTÓPICO"
  },
  {
    "codigo":246596000,
    "descripcion":"RAÍZ DE NERVIO CIÁTICO - HALLAZGO"
  },
  {
    "codigo":707183006,
    "descripcion":"ENFERMEDAD GINGIVAL DEBIDA A TRASTORNO GENÉTICO"
  },
  {
    "codigo":312132001,
    "descripcion":"INFECCIÓN OCULAR VIRAL"
  },
  {
    "codigo":1196868007,
    "descripcion":"GLIONEUROMA DE CUERPO CILIAR"
  },
  {
    "codigo":277529000,
    "descripcion":"ALUCINACIONES AUDITIVAS VERBALES DE SEGUNDA PERSONA"
  },
  {
    "codigo":15385006,
    "descripcion":"FRACTURA NO EXPUESTA DE MALÉOLO INTERNO"
  },
  {
    "codigo":48153009,
    "descripcion":"PERIMETRITIS AGUDA"
  },
  {
    "codigo":310297009,
    "descripcion":"ANTICUERPOS ANTICÉLULAS PARIETALES DETECTADOS"
  },
  {
    "codigo":1162265009,
    "descripcion":"GLOMERULONEFRITIS EXUDATIVA AGUDA"
  },
  {
    "codigo":734446006,
    "descripcion":"BACILOS GRAMPOSITIVOS EN EMPALIZADA"
  },
  {
    "codigo":767214008,
    "descripcion":"PIE CAVO VARO"
  },
  {
    "codigo":275694009,
    "descripcion":"EL PACIENTE NO CONCURRE AL SEGUIMIENTO"
  },
  {
    "codigo":110019000,
    "descripcion":"FRACTURA NO EXPUESTA DE PORCIÓN ORBITARIA DE HUESO CIGOMÁTICO"
  },
  {
    "codigo":208323005,
    "descripcion":"FRACTURA PALMAR DE BARTON NO EXPUESTA"
  },
  {
    "codigo":1156760001,
    "descripcion":"EQUIMOSIS POSAURICULAR"
  },
  {
    "codigo":403096002,
    "descripcion":"ONICOMICOSIS CAUSADA POR FUSARIUM"
  },
  {
    "codigo":698008003,
    "descripcion":"NEUMOPARÓTIDA"
  },
  {
    "codigo":302957001,
    "descripcion":"DETENCIÓN DE CRECIMIENTO TRANSVERSO DE RAYOS SEGUNDO A QUINTO DE METACARPO"
  },
  {
    "codigo":301122000,
    "descripcion":"LESIÓN MIOCÁRDICA"
  },
  {
    "codigo":366658001,
    "descripcion":"HALLAZGO RELACIONADO CON EL COLOR DE PELO"
  },
  {
    "codigo":1251394001,
    "descripcion":"HIPERQUERATOSIS DE ANTEPIÉ"
  },
  {
    "codigo":6210001,
    "descripcion":"DILATACIÓN DE VENTRÍCULO CARDÍACO"
  },
  {
    "codigo":202818006,
    "descripcion":"ANQUILOSIS DE LA COLUMNA VERTEBRAL LUMBAR"
  },
  {
    "codigo":397591000,
    "descripcion":"RETRASO DE LA DERIVACIÓN - PERDIÓ LA DERIVACIÓN"
  },
  {
    "codigo":266519001,
    "descripcion":"INSUFICIENCIA VASCULAR AGUDA DEL TRACTO GASTROINTESTINAL"
  },
  {
    "codigo":38978009,
    "descripcion":"QUEMADURA DEL CUERO CABELLUDO"
  },
  {
    "codigo":71746008,
    "descripcion":"PERIOSTITIS CRÓNICA DE LA MANDÍBULA"
  },
  {
    "codigo":364823002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA COMER CON CUCHARA"
  },
  {
    "codigo":200983001,
    "descripcion":"PITIRIASIS LIQUENOIDE"
  },
  {
    "codigo":233751004,
    "descripcion":"NEUMOCONIOSIS POR METALES"
  },
  {
    "codigo":299287001,
    "descripcion":"AMPLITUD DE ROTACIÓN INTERNA ACTIVA DE ARTICULACIÓN DE CADERA, AUMENTADA"
  },
  {
    "codigo":35308000,
    "descripcion":"INFERTILIDAD FEMENINA SECUNDARIA A NO IMPLANTACIÓN"
  },
  {
    "codigo":69911009,
    "descripcion":"SÍNDROME DEL OVARIO RESIDUAL"
  },
  {
    "codigo":68076002,
    "descripcion":"FRACTURA EXPUESTA DE HUESO ESCAFOIDES DE MUÑECA"
  },
  {
    "codigo":788972003,
    "descripcion":"LEUCEMIA MIELOMONOCÍTICA JUVENIL EN REMISIÓN"
  },
  {
    "codigo":231916005,
    "descripcion":"HEMORRAGIA INTRACORNEAL"
  },
  {
    "codigo":346231000119100,
    "descripcion":"PTERIGIÓN DOBLE BILATERAL"
  },
  {
    "codigo":721601007,
    "descripcion":"FIBROADENOMAS MÚLTIPLES DE MAMA"
  },
  {
    "codigo":262849009,
    "descripcion":"DESGARRO DE LA CAPA SEROSA DE DUODENO"
  },
  {
    "codigo":293782002,
    "descripcion":"ALERGIA A PROCARBAZINA"
  },
  {
    "codigo":457622003,
    "descripcion":"RUPTURA DE MÚSCULO PAPILAR DE VÁLVULA TRICÚSPIDE"
  },
  {
    "codigo":295617009,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE CLORAMBUCILO"
  },
  {
    "codigo":95339000,
    "descripcion":"DISTIQUIASIS"
  },
  {
    "codigo":785302009,
    "descripcion":"ATAXIA CEREBELOSA AUTOSÓMICA RECESIVA DE COMIENZO EN LA VIDA ADULTA"
  },
  {
    "codigo":128107007,
    "descripcion":"ENFERMEDAD DE VON WILLEBRAND HEREDITARIA TIPO 2"
  },
  {
    "codigo":717931007,
    "descripcion":"DELGADEZ LEVE EN LA VIDA ADULTA"
  },
  {
    "codigo":290112004,
    "descripcion":"SECRECIÓN LECHOSA POR PEZÓN"
  },
  {
    "codigo":716096005,
    "descripcion":"SÍNDROME DE HIPOSPADIAS Y DISCAPACIDAD INTELECTUAL TIPO GOLDBLATT"
  },
  {
    "codigo":1240384006,
    "descripcion":"TRASTORNO NEONATAL PRECOZ DEBIDO A INFARTO DE PLACENTA"
  },
  {
    "codigo":29871000175109,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN DE TALÓN DERECHO GRADO 3"
  },
  {
    "codigo":124437004,
    "descripcion":"DEFICIENCIA DE GLUCOSA - 6 - FOSFATASA"
  },
  {
    "codigo":91669008,
    "descripcion":"ABSCESO PERIRRECTAL"
  },
  {
    "codigo":58901008,
    "descripcion":"EXCITACIÓN"
  },
  {
    "codigo":16703761000119102,
    "descripcion":"DÉFICIT DE MEMORIA DEBIDO A ACCIDENTE CEREBROVASCULAR ISQUÉMICO Y POSTERIOR A ÉL"
  },
  {
    "codigo":286442003,
    "descripcion":"INCAPAZ DE OBTENER ALIMENTO"
  },
  {
    "codigo":188138001,
    "descripcion":"NEOPLASIA MALIGNA DE PIEL DEL DEDO GORDO"
  },
  {
    "codigo":253674003,
    "descripcion":"HIPOPLASIA DE AORTA PREDUCTAL"
  },
  {
    "codigo":448447004,
    "descripcion":"LINFOMA NO HODGKIN DE PIEL"
  },
  {
    "codigo":415679005,
    "descripcion":"EL MARGEN QUIRÚRGICO DE EPIPLÓN ES EL MARGEN NO AFECTADO MÁS PRÓXIMO A LA NEOPLASIA MALIGNA"
  },
  {
    "codigo":251839006,
    "descripcion":"HALLAZGO RELACIONADO CON EL BALANCE DE LÍQUIDOS"
  },
  {
    "codigo":284607007,
    "descripcion":"HALLAZGO RELACIONADO CON CONDUCTAS AGRESIVAS"
  },
  {
    "codigo":15720721000119105,
    "descripcion":"LUXACIÓN PATOLÓGICA DE AMBAS CADERAS"
  },
  {
    "codigo":250004004,
    "descripcion":"TRASTORNO MUSCULOESQUELÉTICO PERIFÉRICO DE LA MARCHA"
  },
  {
    "codigo":282772005,
    "descripcion":"LESIÓN TRAUMÁTICA GENITAL"
  },
  {
    "codigo":53396004,
    "descripcion":"IMPÉTIGO DE BOCKHART"
  },
  {
    "codigo":446612007,
    "descripcion":"HONGO AISLADO PERO SIN IDENTIFICACIÓN POSTERIOR"
  },
  {
    "codigo":248169000,
    "descripcion":"PERFIL FACIAL NORMAL"
  },
  {
    "codigo":118932009,
    "descripcion":"TRASTORNO DEL PIE"
  },
  {
    "codigo":1263977000,
    "descripcion":"HEMORRAGIA FETAL INTRAVENTRICULAR NO TRAUMÁTICA"
  },
  {
    "codigo":413844008,
    "descripcion":"ISQUEMIA MIOCÁRDICA CRÓNICA"
  },
  {
    "codigo":706921000,
    "descripcion":"LISTERIA, NO AISLADA"
  },
  {
    "codigo":315540008,
    "descripcion":"NACIDO EN TAILANDIA"
  },
  {
    "codigo":1296745007,
    "descripcion":"IRIS EN MESETA DE OJO DERECHO"
  },
  {
    "codigo":705086000,
    "descripcion":"CONOCIMIENTO DEFICIENTE SOBRE ANALGESIA CONTROLADA POR EL PACIENTE"
  },
  {
    "codigo":82494000,
    "descripcion":"TRASTORNO DE PÁNICO SIN AGORAFOBIA CON ATAQUES DE PÁNICO EN REMISIÓN TOTAL"
  },
  {
    "codigo":1231209008,
    "descripcion":"MENINGOCELE ORBITARIO CONGÉNITO"
  },
  {
    "codigo":442942009,
    "descripcion":"CONDROCALCINOSIS DE ARTICULACIÓN DE RODILLA"
  },
  {
    "codigo":770622009,
    "descripcion":"EPILEPSIA FOCAL BENIGNA DEL LACTANTE CON ESPIGAS Y ONDAS EN LÍNEA MEDIA DURANTE EL SUEÑO"
  },
  {
    "codigo":1293075003,
    "descripcion":"TUMOR FIBROSO SOLITARIO VARIEDAD LIPOMATOSA"
  },
  {
    "codigo":80659006,
    "descripcion":"TRASTORNO DE LA PIEL Y\/O DEL TEJIDO CELULAR SUBCUTÁNEO"
  },
  {
    "codigo":44011000087103,
    "descripcion":"CORTE EN PIEL DE DEDO ANULAR DE MANO DERECHA"
  },
  {
    "codigo":15123008,
    "descripcion":"NEFROPATÍA AMILOIDE FAMILIAR CON URTICARIA Y SORDERA"
  },
  {
    "codigo":703251009,
    "descripcion":"INFARTO AGUDO DE PARED INFERIOR DE MIOCARDIO CON COMPROMISO DE VENTRÍCULO DERECHO"
  },
  {
    "codigo":46571000087107,
    "descripcion":"FRACTURA DE DIÁFISIS DE TIBIA IZQUIERDA"
  },
  {
    "codigo":41451000087108,
    "descripcion":"HERIDA PUNZANTE DE ANTEBRAZO IZQUIERDO CON CUERPO EXTRAÑO"
  },
  {
    "codigo":240829000,
    "descripcion":"FILARIASIS CRÓNICA DE MALASIA"
  },
  {
    "codigo":44221002,
    "descripcion":"POLIARTRITIS IDIOPÁTICA"
  },
  {
    "codigo":348741000119101,
    "descripcion":"INFILTRADO CORNEAL DE OJO IZQUIERDO POSTERIOR A QUERATOPLASTIA PENETRANTE"
  },
  {
    "codigo":404669007,
    "descripcion":"ÉMBOLO DE PLAQUETAS Y FIBRINA EN LA RETINA"
  },
  {
    "codigo":271762000,
    "descripcion":"TÚNELES CUTÁNEOS"
  },
  {
    "codigo":109757008,
    "descripcion":"FRACTURA HORIZONTAL DEL TERCIO MEDIO DE LA RAÍZ DENTAL"
  },
  {
    "codigo":370066002,
    "descripcion":"INVASIÓN TUMORAL EN LA ALBUGÍNEA"
  },
  {
    "codigo":206226005,
    "descripcion":"PARÁLISIS DEL PLEXO BRAQUIAL POR TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":42386007,
    "descripcion":"CRIPTOCOCOSIS"
  },
  {
    "codigo":402834007,
    "descripcion":"TELANGIECTASIAS DE LOS PLIEGUES UNGUEALES"
  },
  {
    "codigo":304530009,
    "descripcion":"ASPECTO CÓMODO"
  },
  {
    "codigo":204391005,
    "descripcion":"HIPOPLASIA DE VENA CARDÍACA"
  },
  {
    "codigo":300860002,
    "descripcion":"MASA DE ESTRUCTURA ENDOCRINA"
  },
  {
    "codigo":399164003,
    "descripcion":"HIPERVENTILACIÓN ACIDÓTICA"
  },
  {
    "codigo":366396007,
    "descripcion":"AMPLITUD DE MOVIMIENTO PASIVO DE ROTACIÓN HACIA LA DERECHA DE LA COLUMNA CERVICAL - HALLAZGO"
  },
  {
    "codigo":266257000,
    "descripcion":"ATAQUE ISQUÉMICO TRANSITORIO"
  },
  {
    "codigo":725009002,
    "descripcion":"DOLOR DE CUELLO CONCOMITANTE CON RIGIDEZ POSTERIOR A LESIÓN TRAUMÁTICA CERVICAL POR LATIGAZO"
  },
  {
    "codigo":167953004,
    "descripcion":"LÍQUIDO PLEURAL PURULENTO"
  },
  {
    "codigo":200721005,
    "descripcion":"GRANULOMA PIÓGENO PROGRESIVO"
  },
  {
    "codigo":10834501000119108,
    "descripcion":"FRACTURA EXPUESTA DE FALANGE DISTAL DE DEDO ÍNDICE DERECHO"
  },
  {
    "codigo":4113009,
    "descripcion":"HIDROCEFALIA DETENIDA"
  },
  {
    "codigo":430097009,
    "descripcion":"CONSTIPACIÓN DEBIDA A ESPASMO COLÓNICO"
  },
  {
    "codigo":35046003,
    "descripcion":"TRASTORNO DE LA LACTANCIA"
  },
  {
    "codigo":297190005,
    "descripcion":"PROLAPSO DE ILEOSTOMÍA"
  },
  {
    "codigo":33211000,
    "descripcion":"COMPLICACIÓN DE LA ANESTESIA"
  },
  {
    "codigo":723174009,
    "descripcion":"NEOPLASIA CONDROGÉNICA DE HUESO Y CARTÍLAGO ARTICULAR DE MIEMBRO"
  },
  {
    "codigo":295355005,
    "descripcion":"SOBREDOSIS DE FAMOTIDINA"
  },
  {
    "codigo":443006,
    "descripcion":"CISTOCELE QUE AFECTA AL EMBARAZO"
  },
  {
    "codigo":721339007,
    "descripcion":"LACERACIÓN DE TENDÓN DE LA CABEZA"
  },
  {
    "codigo":197051009,
    "descripcion":"INVAGINACIÓN COMPUESTA"
  },
  {
    "codigo":64144002,
    "descripcion":"ERUPCIÓN PRURIGINOSA"
  },
  {
    "codigo":129680003,
    "descripcion":"GAMMAGRAFÍA ANORMAL"
  },
  {
    "codigo":293520005,
    "descripcion":"REACCIÓN ADVERSA A LA MEDIGOXINA"
  },
  {
    "codigo":195216008,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DEL HEMISFERIO CEREBRAL IZQUIERDO"
  },
  {
    "codigo":162448008,
    "descripcion":"EL SÍNTOMA DURA MESES"
  },
  {
    "codigo":1145488009,
    "descripcion":"HIPOPLASIA CONGÉNITA DE FALANGE PROXIMAL DE DEDO ANULAR"
  },
  {
    "codigo":95077003,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA PIEL DEL HUECO POPLÍTEO"
  },
  {
    "codigo":291685001,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR CICLOSERINA"
  },
  {
    "codigo":783205005,
    "descripcion":"ALOPECIA Y DEFICIENCIA DE ANTICUERPOS"
  },
  {
    "codigo":160613002,
    "descripcion":"CONSUMO DE TABACO ADMITIDO POCO CONFIABLE"
  },
  {
    "codigo":226149007,
    "descripcion":"DIETA RICA EN VITAMINAS LIPOSOLUBLES"
  },
  {
    "codigo":62309008,
    "descripcion":"INTOXICACIÓN POR HELICHRYSUM ARGYOSPHAERUM"
  },
  {
    "codigo":420922004,
    "descripcion":"SIGNO CARDÍACO CON NOMBRE PROPIO"
  },
  {
    "codigo":715834004,
    "descripcion":"DUODENITIS AGUDA"
  },
  {
    "codigo":93242007,
    "descripcion":"HIPOPLASIA CONGÉNITA DEL ARCO DE LA VÉRTEBRA DORSAL"
  },
  {
    "codigo":58639003,
    "descripcion":"SÍNDROME DE DOAN - WISEMAN"
  },
  {
    "codigo":1303823008,
    "descripcion":"SACROILEÍTIS DE ARTICULACIÓN SACROILÍACA IZQUIERDA"
  },
  {
    "codigo":124175009,
    "descripcion":"DEFICIENCIA DE AMINAOXIDASA (CONTENIDO DE COBRE)"
  },
  {
    "codigo":253412003,
    "descripcion":"MÚSCULOS PAPILARES MITRALES FUSIONADOS"
  },
  {
    "codigo":286180005,
    "descripcion":"INCAPAZ DE PONER LA MESA"
  },
  {
    "codigo":284345000,
    "descripcion":"DIFICULTAD PARA PONERLE LA TAPA A UN RECIPIENTE"
  },
  {
    "codigo":710329007,
    "descripcion":"ESPECIE DE STREPTOCOCCUS O ESPECIE DE ENTEROCOCCUS"
  },
  {
    "codigo":448185008,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE ESTRUCTURA TORÁCICA"
  },
  {
    "codigo":678931000119102,
    "descripcion":"HUSO DE KRUKENBERG EN OJO DERECHO"
  },
  {
    "codigo":249742002,
    "descripcion":"ACORTAMIENTO DISTAL DE BRAZO"
  },
  {
    "codigo":708494003,
    "descripcion":"DEFICIENCIA DE CRESTA ALVEOLAR"
  },
  {
    "codigo":1362019000,
    "descripcion":"DISTENSIÓN MUSCULAR"
  },
  {
    "codigo":1003406009,
    "descripcion":"NEVO MELANOCÍTICO CONGÉNITO DE TAMAÑO INTERMEDIO"
  },
  {
    "codigo":11820051000119104,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN RADIOCUBITAL DISTAL DERECHA"
  },
  {
    "codigo":1296483007,
    "descripcion":"HIPERTENSIÓN OCULAR DE OJO DERECHO DEBIDA A DESPRENDIMIENTO DE RETINA"
  },
  {
    "codigo":82232002,
    "descripcion":"INFESTACIÓN CAUSADA POR ACARAPIS"
  },
  {
    "codigo":2371000124103,
    "descripcion":"SEGUNDO MOLAR INFERIOR IZQUIERDO PERMANENTE SUPERNUMERARIO"
  },
  {
    "codigo":309773000,
    "descripcion":"COMPLICACIÓN DE GASTROSTOMÍA"
  },
  {
    "codigo":277005000,
    "descripcion":"REDUCCIÓN SELECTIVA DE LA ONDA B"
  },
  {
    "codigo":580931000124104,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN DE EXTREMIDAD INFERIOR DERECHA"
  },
  {
    "codigo":1260045000,
    "descripcion":"CISTADENOCARCINOMA DE OROFARINGE"
  },
  {
    "codigo":702989004,
    "descripcion":"SHIGELLA BOYDII O SHIGELLA FLEXNERI"
  },
  {
    "codigo":105491000119107,
    "descripcion":"HIPOSOMNIA PRIMARIA"
  },
  {
    "codigo":11793581000119101,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO DE TOBILLO IZQUIERDO, CON INFECCIÓN"
  },
  {
    "codigo":113165003,
    "descripcion":"VIVIR EN UN DÚPLEX"
  },
  {
    "codigo":13026000,
    "descripcion":"ESTENOSIS ISQUÉMICA DE INTESTINO"
  },
  {
    "codigo":735757008,
    "descripcion":"GANGLIONEUROBLASTOMA PRIMARIO DE CEREBRO"
  },
  {
    "codigo":49464009,
    "descripcion":"SIGMOIDITIS DIETÉTICA"
  },
  {
    "codigo":111330004,
    "descripcion":"FÍSTULA RECTOVAGINAL CONGÉNITA"
  },
  {
    "codigo":209634005,
    "descripcion":"RUPTURA DE LIGAMENTO DELTOIDEO DE TOBILLO"
  },
  {
    "codigo":699319004,
    "descripcion":"INFECCIÓN DE ESPACIO MASTICADOR"
  },
  {
    "codigo":109495004,
    "descripcion":"MORDIDA CRUZADA"
  },
  {
    "codigo":764855007,
    "descripcion":"LEUCEMIA MIELOIDE AGUDA CON MUTACIÓN SOMÁTICA CCAAT\/POTENCIADOR DE LA PROTEÍNA DE UNIÓN ALFA"
  },
  {
    "codigo":43959009,
    "descripcion":"CATARATA DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":240567009,
    "descripcion":"ENFERMEDAD SIFILÍTICA DE LA ARTERIA CORONARIA"
  },
  {
    "codigo":402572008,
    "descripcion":"ECCEMA DISCOIDE DE MANOS"
  },
  {
    "codigo":7521001,
    "descripcion":"ENFERMEDAD RELACIONADA CON VITAMINAS"
  },
  {
    "codigo":238732008,
    "descripcion":"FOLICULITIS EN PENACHO"
  },
  {
    "codigo":1187169005,
    "descripcion":"SALICILATO POR DEBAJO DE RANGO TERAPÉUTICO"
  },
  {
    "codigo":202294003,
    "descripcion":"CONTRACTURA EN FLEXIÓN DE ARTICULACIÓN INTERFALÁNGICA DE DEDO DEL PIE"
  },
  {
    "codigo":366134004,
    "descripcion":"HALLAZGO RELACIONADO CON MATIDEZ DIAFRAGMÁTICA A LA PERCUSIÓN"
  },
  {
    "codigo":235062007,
    "descripcion":"SÍFILIS BUCAL"
  },
  {
    "codigo":890422008,
    "descripcion":"ESPINA BÍFIDA ABIERTA DE COLUMNA VERTEBRAL CERVICOTORÁCICA CON HIDROCEFALIA"
  },
  {
    "codigo":397067001,
    "descripcion":"CRISTALES DE HEMOGLOBINA C"
  },
  {
    "codigo":36619004,
    "descripcion":"DUPLICACIÓN CONGÉNITA DE CONDUCTO CÍSTICO"
  },
  {
    "codigo":296928000,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE HEPARINA"
  },
  {
    "codigo":724747009,
    "descripcion":"TRASTORNO AMNÉSICO CAUSADO POR MÚLTIPLES FACTORES ETIOLÓGICOS"
  },
  {
    "codigo":298763009,
    "descripcion":"CLAVÍCULA PEQUEÑA"
  },
  {
    "codigo":722912007,
    "descripcion":"HIPOPLASIA PULMONAR CONGÉNITA DEBIDA A RUPTURA PROLONGADA Y PREMATURA DE MEMBRANAS"
  },
  {
    "codigo":1148896009,
    "descripcion":"DEFICIENCIA DE VITAMINA D DEBIDA A ENFERMEDAD RENAL CRÓNICA"
  },
  {
    "codigo":428000009,
    "descripcion":"FRACTURAS MÚLTIPLES NO EXPUESTAS INESTABLES DE LA PELVIS POR COMPRESIÓN LATERAL"
  },
  {
    "codigo":246536003,
    "descripcion":"CRISIS EPILÉPTICA COGNITIVA"
  },
  {
    "codigo":196789004,
    "descripcion":"HIPERPLASIA DE APÉNDICE ILEOCECAL"
  },
  {
    "codigo":426165006,
    "descripcion":"INFECCIÓN GENITOURINARIA AGUDA POR CLAMIDIA"
  },
  {
    "codigo":181007,
    "descripcion":"BRONCONEUMONÍA HEMORRÁGICA"
  },
  {
    "codigo":293258008,
    "descripcion":"REACCIÓN ADVERSA DE DIETILESTILBESTROL"
  },
  {
    "codigo":31114009,
    "descripcion":"LUGAR DE ORDEN FAMILIAR: HERMANO MAYOR DE SEXO FEMENINO O MASCULINO"
  },
  {
    "codigo":291423004,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR FLUCITOSINA"
  },
  {
    "codigo":193119005,
    "descripcion":"COMPRESIONES DE RAÍCES NERVIOSAS Y PLEXOS NERVIOSOS EN DISCOPATÍAS INTERVERTEBRALES"
  },
  {
    "codigo":717407006,
    "descripcion":"DEFICIENCIA CONGÉNITA DE INHIBIDOR DEL ACTIVADOR DEL PLASMINÓGENO TIPO 1"
  },
  {
    "codigo":225887007,
    "descripcion":"APTO PARA UN PUESTO EN PARTICULAR"
  },
  {
    "codigo":94815008,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE DUODENO"
  },
  {
    "codigo":11822561000119105,
    "descripcion":"AMPOLLA TRAUMÁTICA DE AXILA IZQUIERDA"
  },
  {
    "codigo":353761000119105,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE CÓRNEA DE OJO IZQUIERDO"
  },
  {
    "codigo":1010484003,
    "descripcion":"ESCLEROSIS DE EPÍFISIS DE FALANGE MEDIA DE DEDO MEÑIQUE CON RADIOPACIDAD AUMENTADA"
  },
  {
    "codigo":289588007,
    "descripcion":"COÁGULOS SANGUÍNEOS EN LA VAGINA"
  },
  {
    "codigo":92980008,
    "descripcion":"FENESTRACIÓN CONGÉNITA DE HUESO ALIESFENOIDAL"
  },
  {
    "codigo":123913002,
    "descripcion":"INTOXICACIÓN POR AIZOACEAE"
  },
  {
    "codigo":1268958000,
    "descripcion":"TUMOR NEUROECTODÉRMICO PRIMITIVO PRIMARIO DE CUERPO DE ÚTERO"
  },
  {
    "codigo":253150002,
    "descripcion":"HETEROTOPÍA NEURONAL"
  },
  {
    "codigo":187614004,
    "descripcion":"NEOPLASIA MALIGNA DE FRENILLO DE LABIO INFERIOR"
  },
  {
    "codigo":285918004,
    "descripcion":"INCAPAZ DE LLENAR LA BAÑERA"
  },
  {
    "codigo":447923000,
    "descripcion":"TABIQUE INTERVENTRICULAR CARDÍACO DELGADO"
  },
  {
    "codigo":710067001,
    "descripcion":"PUNTAJE DE CHILD-PUGH CLASE C"
  },
  {
    "codigo":1073541000119100,
    "descripcion":"ARTRITIS INFECCIOSA DE TOBILLO DERECHO"
  },
  {
    "codigo":141701000119101,
    "descripcion":"LESIÓN DE BAZO"
  },
  {
    "codigo":16466821000119102,
    "descripcion":"MELORREOSTOSIS DE COLUMNA VERTEBRAL"
  },
  {
    "codigo":292741000119101,
    "descripcion":"COMPRESIÓN DE NERVIO CUBITAL IZQUIERDO"
  },
  {
    "codigo":10760581000119104,
    "descripcion":"DOLOR EN LIGAMENTO REDONDO DEL ÚTERO DURANTE EL EMBARAZO"
  },
  {
    "codigo":134021000119105,
    "descripcion":"VÓMITO DE MATERIA FECAL"
  },
  {
    "codigo":1083781000119106,
    "descripcion":"OTITIS EXTERNA HEMORRÁGICA BILATERAL"
  },
  {
    "codigo":679301000119101,
    "descripcion":"HEMORRAGIA DE SUSTANCIA PROPIA DE CÓRNEA DE OJO IZQUIERDO"
  },
  {
    "codigo":297861000119108,
    "descripcion":"MIOSITIS INTERSTICIAL DE ANTEBRAZO"
  },
  {
    "codigo":346501000119109,
    "descripcion":"VASO FANTASMA BILATERAL DE CÓRNEAS"
  },
  {
    "codigo":16840581000119101,
    "descripcion":"OBSTRUCCIÓN INTESTINAL COMPLETA POSPROCEDIMIENTO"
  },
  {
    "codigo":1088901000119105,
    "descripcion":"OTITIS EXTERNA HEMORRÁGICA DE CONDUCTO AUDITIVO EXTERNO IZQUIERDO"
  },
  {
    "codigo":1076101000119103,
    "descripcion":"QUISTE SINOVIAL DE PIE IZQUIERDO"
  },
  {
    "codigo":413320001,
    "descripcion":"PROBLEMA DE SALUD FÍSICA"
  },
  {
    "codigo":10847621000119105,
    "descripcion":"CUERPO EXTRAÑO EN OÍDO DERECHO"
  },
  {
    "codigo":249480002,
    "descripcion":"INGESTA HÍDRICA AUMENTADA"
  },
  {
    "codigo":1086341000119107,
    "descripcion":"ABSCESO DE COLON SIGMOIDE CONCOMITANTE CON DIVERTICULITIS Y DEBIDO A ELLA"
  },
  {
    "codigo":126341000119108,
    "descripcion":"LESIÓN ESCAMOSA INTRAEPITELIAL DE ALTO GRADO EN EXTENDIDO DE PAPANICOLAOU VAGINAL"
  },
  {
    "codigo":216712006,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ALDICARB"
  },
  {
    "codigo":315016007,
    "descripcion":"CON MAYOR RIESGO DE ENFERMEDAD CORONARIA"
  },
  {
    "codigo":18269002,
    "descripcion":"OBSTRUCCIÓN DUODENAL CONGÉNITA"
  },
  {
    "codigo":770098001,
    "descripcion":"PARÁLISIS DE NERVIO CRANEAL DEBIDO A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":51037009,
    "descripcion":"FRACTURA DE RÓTULA"
  },
  {
    "codigo":1359922003,
    "descripcion":"TRISMO POSTERIOR A PROCEDIMIENTO ODONTOLÓGICO"
  },
  {
    "codigo":278578008,
    "descripcion":"ENCHAPADO DENTAL EXCESIVAMENTE ANCHO"
  },
  {
    "codigo":737330009,
    "descripcion":"DAÑO DE ÓRGANOS Y TEJIDOS PÉLVICOS DESPUÉS DE EMBARAZO MOLAR"
  },
  {
    "codigo":1259783000,
    "descripcion":"TUMOR MALIGNO EPITELIOIDE PRIMARIO DE VAINA NERVIOSA"
  },
  {
    "codigo":735495004,
    "descripcion":"HEMORRAGIA PULMONAR PERINATAL DEBIDA A LESIÓN TRAUMÁTICA"
  },
  {
    "codigo":440583007,
    "descripcion":"ORIENTACIÓN SEXUAL DESCONOCIDA"
  },
  {
    "codigo":47367009,
    "descripcion":"INSUFICIENCIA PANCREÁTICA EXOCRINA"
  },
  {
    "codigo":405980004,
    "descripcion":"COMPROMISO TUMORAL DE LOS MÁRGENES DE RESECCIÓN QUIRÚRGICA LATERALES (MUCOSA\/PARED) - NO PUEDE EVALUARSE"
  },
  {
    "codigo":274908005,
    "descripcion":"DELECIÓN CON REORDENAMIENTO COMPLEJO"
  },
  {
    "codigo":307676006,
    "descripcion":"NISTAGMO VESTIBULAR CENTRAL DE RITMO LENTO"
  },
  {
    "codigo":240305000,
    "descripcion":"TROMBOCITOPENIA ALOINMUNITARIA NEONATAL"
  },
  {
    "codigo":209372008,
    "descripcion":"FRACTURA-SUBLUXACIÓN NO EXPUESTA DE ARTICULACIÓN MEDIOTARSIANA"
  },
  {
    "codigo":43697006,
    "descripcion":"EDAD GESTACIONAL, 37 SEMANAS"
  },
  {
    "codigo":830129007,
    "descripcion":"CAMPO VISUAL NORMAL"
  },
  {
    "codigo":305841007,
    "descripcion":"VISTO EN EL SERVICIO DE DANZATERAPIA"
  },
  {
    "codigo":238470006,
    "descripcion":"FRICCIÓN PRODUCIDA POR PELUCA"
  },
  {
    "codigo":402310007,
    "descripcion":"PSORIASIS CRÓNICA EN PLACA ESTABLE"
  },
  {
    "codigo":1186907003,
    "descripcion":"HIPOFISITIS XANTOGRANULOMATOSA"
  },
  {
    "codigo":7259005,
    "descripcion":"MUCOPOLISACARIDOSIS, MPS - IV - A"
  },
  {
    "codigo":10678191000119105,
    "descripcion":"TUMEFACCIÓN LOCALIZADA DE AMBAS PIERNAS"
  },
  {
    "codigo":103728001,
    "descripcion":"TUMOR EN EL OÍDO MEDIO VISIBLE EN LA OTOSCOPIA"
  },
  {
    "codigo":365872002,
    "descripcion":"ÍNDICE DE MORBILIDAD - HALLAZGO"
  },
  {
    "codigo":236635009,
    "descripcion":"ARREFLEXIA DEL MÚSCULO DETRUSOR URINARIO"
  },
  {
    "codigo":1119536003,
    "descripcion":"DISMINUCIÓN PROGRESIVA DE AGUDEZA VISUAL"
  },
  {
    "codigo":300336005,
    "descripcion":"HALLAZGO RELACIONADO CON LAS MEDIDAS DEL HÍGADO"
  },
  {
    "codigo":398640008,
    "descripcion":"ARTRITIS REUMATOIDE CON PNEUMOCONIOSIS"
  },
  {
    "codigo":208136003,
    "descripcion":"FRACTURA DE COSTILLAS POR TOS"
  },
  {
    "codigo":3589003,
    "descripcion":"PERICARDITIS SIFILÍTICA"
  },
  {
    "codigo":11307081000119101,
    "descripcion":"FRACTURA NO EXPUESTA DE LA COLUMNA ANTERIOR DE ACETÁBULO DERECHO"
  },
  {
    "codigo":298501006,
    "descripcion":"TUMEFACCIÓN ÓSEA DE COLUMNA DORSAL"
  },
  {
    "codigo":724485008,
    "descripcion":"PROTEINURIA GESTACIONAL SIN HIPERTENSIÓN"
  },
  {
    "codigo":296666000,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE FLUCLOXACILINA"
  },
  {
    "codigo":720815000,
    "descripcion":"SÍNDROME DE CAPRA DEMARCO"
  },
  {
    "codigo":1343407001,
    "descripcion":"ECOGRAFÍA DE PLACENTA ANORMAL"
  },
  {
    "codigo":65455002,
    "descripcion":"ENCEFALOCELE NASAL"
  },
  {
    "codigo":30852000,
    "descripcion":"DIETA GENERAL PARA UN NIÑO"
  },
  {
    "codigo":129156001,
    "descripcion":"LUXACIÓN TRAUMÁTICA DE ARTICULACIÓN"
  },
  {
    "codigo":161924005,
    "descripcion":"TOS PRODUCTIVA - ESPUTO VERDE"
  },
  {
    "codigo":1144964006,
    "descripcion":"MICROANGIOPATÍA TROMBÓTICA INTRAVASCULAR AGUDA"
  },
  {
    "codigo":424068007,
    "descripcion":"ESTADOS CONFLICTIVOS DE DUELO ENTRE LOS MIEMBROS DE LA FAMILIA"
  },
  {
    "codigo":127321000,
    "descripcion":"TRASTORNO AGUDO DEL APARATO DIGESTIVO"
  },
  {
    "codigo":422233000,
    "descripcion":"VASOS RETINIANOS COLATERALES"
  },
  {
    "codigo":63620009,
    "descripcion":"INTOXICACIÓN POR OXYTENIA ACEROSA"
  },
  {
    "codigo":292996009,
    "descripcion":"REACCIÓN ADVERSA AL CEFADROXILO"
  },
  {
    "codigo":225625004,
    "descripcion":"MIEDO A CAMINAR"
  },
  {
    "codigo":291161005,
    "descripcion":"INTOXICACIÓN POR FLUSPIRILENO"
  },
  {
    "codigo":94553009,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA PIEL DE LOS PÁRPADOS"
  },
  {
    "codigo":27182002,
    "descripcion":"ESGUINCE DEL LIGAMENTO ACROMIOCLAVICULAR"
  },
  {
    "codigo":92718003,
    "descripcion":"CARCINOMA IN SITU DE LA PIEL DEL MENTÓN"
  },
  {
    "codigo":289326007,
    "descripcion":"PIEL ROSADA ALREDEDOR DEL MUÑÓN UMBILICAL"
  },
  {
    "codigo":1336067000,
    "descripcion":"EPISODIO DE USO NOCIVO DE SEDANTE"
  },
  {
    "codigo":123651000,
    "descripcion":"ALTERACIONES CROMOSÓMICAS DEL GRUPO F"
  },
  {
    "codigo":1303299005,
    "descripcion":"VESTIDO ADECUADAMENTE SIN ZAPATOS"
  },
  {
    "codigo":254723006,
    "descripcion":"NEOPLASIA DE PIEL CON DIFERENCIACIÓN APOCRINA"
  },
  {
    "codigo":711640003,
    "descripcion":"PULPITIS REVERSIBLE ASINTOMÁTICA"
  },
  {
    "codigo":23512004,
    "descripcion":"ATRESIA DE CONDUCTO SALIVAL"
  },
  {
    "codigo":447661004,
    "descripcion":"DIVERTÍCULO DE SENO CORONARIO"
  },
  {
    "codigo":283821004,
    "descripcion":"MORDEDURA DE ANIMAL EN LA INGLE"
  },
  {
    "codigo":249218000,
    "descripcion":"HEMATOMA VULVAR POSPARTO"
  },
  {
    "codigo":113021000119102,
    "descripcion":"ARTROSIS DE AMBAS MUÑECAS"
  },
  {
    "codigo":116311003,
    "descripcion":"HALLAZGO RELACIONADO CON LA REGIÓN DE LA MANO"
  },
  {
    "codigo":704300009,
    "descripcion":"PROBLEMA DE SEGURIDAD AMBIENTAL"
  },
  {
    "codigo":702465003,
    "descripcion":"SÍNDROME PARALÍTICO EN AMBOS LADOS DEL CUERPO"
  },
  {
    "codigo":768001004,
    "descripcion":"HERNIA CRURAL BILATERAL"
  },
  {
    "codigo":1259521003,
    "descripcion":"CARCINOMA PRIMARIO DE SUBGLOTIS"
  },
  {
    "codigo":276481006,
    "descripcion":"OSTEOCONDRITIS DE METACARPIANO"
  },
  {
    "codigo":309249007,
    "descripcion":"DEBILIDAD DE MÚSCULO DE LA PANTORRILLA"
  },
  {
    "codigo":733398000,
    "descripcion":"LACERACIÓN DE BRAZO CON CUERPO EXTRAÑO"
  },
  {
    "codigo":686461000119108,
    "descripcion":"GLIOMA MALIGNO PRIMARIO DE LÓBULO TEMPORAL"
  },
  {
    "codigo":274646000,
    "descripcion":"IRRITABILIDAD E IRA"
  },
  {
    "codigo":1290454003,
    "descripcion":"RADIOGRAFÍA DE DEDO DE PIE ANORMAL"
  },
  {
    "codigo":241878004,
    "descripcion":"EFECTO TÓXICO CAUSADO POR PINTURA ANTI-INCRUSTACIÓN"
  },
  {
    "codigo":372950005,
    "descripcion":"INFECCIÓN CAUSADA POR PENICILLIUM CRUSTACEUM"
  },
  {
    "codigo":371115001,
    "descripcion":"CRISIS CONVULSIVA QUE COMPLICA UNA INFECCIÓN"
  },
  {
    "codigo":403883004,
    "descripcion":"ENFERMEDAD DE BOWEN, PSORIASIFORME"
  },
  {
    "codigo":860800001,
    "descripcion":"ERITEMA MULTIFORME DEBIDO A INFECCIÓN FÚNGICA SISTÉMICA"
  },
  {
    "codigo":240043009,
    "descripcion":"INFECCIÓN DEL ESPACIO PALMAR"
  },
  {
    "codigo":762496003,
    "descripcion":"DESNUTRICIÓN AGUDA EN LA LACTANCIA"
  },
  {
    "codigo":926336003,
    "descripcion":"RUPTURA UTERINA POSPARTO"
  },
  {
    "codigo":8832006,
    "descripcion":"TUBERCULOSIS ORIFICIAL DEL ANO"
  },
  {
    "codigo":236373001,
    "descripcion":"PIELONEFRITIS ENFISEMATOSA"
  },
  {
    "codigo":72533002,
    "descripcion":"COLECISTITIS GANGRENOSA AGUDA"
  },
  {
    "codigo":400213003,
    "descripcion":"AMPOLLA DE PIEL CON INFECCIÓN"
  },
  {
    "codigo":15979031000119107,
    "descripcion":"TIMPANOESCLEROSIS BILATERAL"
  },
  {
    "codigo":12266161000119102,
    "descripcion":"CALCIFICACIÓN MAMOGRÁFICA DE MAMA DERECHA"
  },
  {
    "codigo":201770001,
    "descripcion":"ARTRITIS REUMATOIDE DE LA ARTICULACIÓN RADIOCUBITAL DISTAL"
  },
  {
    "codigo":365610004,
    "descripcion":"NIVELES DE FERROCINÉTICA - HALLAZGO"
  },
  {
    "codigo":3327002,
    "descripcion":"NISTAGMO EN SACUDIDAS"
  },
  {
    "codigo":298239002,
    "descripcion":"ARTICULACIÓN DEL PULGAR RÍGIDA"
  },
  {
    "codigo":199935005,
    "descripcion":"DESGARRO PERINEAL DE CUARTO GRADO DURANTE EL PARTO CON PROBLEMA POSNATAL"
  },
  {
    "codigo":68863007,
    "descripcion":"MENINGITIS SIFILÍTICA AGUDA"
  },
  {
    "codigo":134399007,
    "descripcion":"TROMBOSIS VENOSA PROFUNDA DE LA PIERNA RELACIONADA CON LOS VUELOS"
  },
  {
    "codigo":198100003,
    "descripcion":"MASTITIS AGUDA NO PUERPERAL"
  },
  {
    "codigo":142001000119106,
    "descripcion":"ENFERMEDAD DE ALZHEIMER CON ESTADO DE ÁNIMO DEPRIMIDO"
  },
  {
    "codigo":1492007,
    "descripcion":"ANOMALÍA CONGÉNITA DE INTESTINO GRUESO"
  },
  {
    "codigo":294569000,
    "descripcion":"ALERGIA A NIMORAZOL"
  },
  {
    "codigo":296404007,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE ACETILCISTEÍNA"
  },
  {
    "codigo":1144702000,
    "descripcion":"HIPOPLASIA CONGÉNITA DE FALANGE PROXIMAL DE TERCER DEDO DE PIE"
  },
  {
    "codigo":32425009,
    "descripcion":"BLOQUEO DE RAMA DERECHA, HEMIBLOQUEO ANTERIOR Y HEMIBLOQUEO POSTERIOR IZQUIERDO"
  },
  {
    "codigo":292734003,
    "descripcion":"REACCIÓN ADVERSA A LA PRALIDOXIMA"
  },
  {
    "codigo":389203001,
    "descripcion":"NEVO ESPONJOSO BLANCO DE MUCOSA"
  },
  {
    "codigo":718718009,
    "descripcion":"SÍNDROME DE DISFUNCIÓN DE CONOS CON MIOPÍA LIGADO AL CROMOSOMA X"
  },
  {
    "codigo":28755004,
    "descripcion":"POTENCIAL ASINCRÓNICO DE DESCARGA MUSCULAR"
  },
  {
    "codigo":94291005,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LAS VÍAS BILIARES EXTRAHEPÁTICAS"
  },
  {
    "codigo":290899007,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR NEFAZODONA"
  },
  {
    "codigo":715048003,
    "descripcion":"NO OBTIENE MEDICACIÓN"
  },
  {
    "codigo":289064004,
    "descripcion":"NO UTILIZA LA CUCHARA PARA ALIMENTARSE"
  },
  {
    "codigo":92456003,
    "descripcion":"NEOPLASIA BENIGNA DE TESTÍCULO RETENIDO"
  },
  {
    "codigo":190760009,
    "descripcion":"TRASTORNOS DEL METABOLISMO DEL PIRUVATO Y DE LA GLUCONEOGÉNESIS"
  },
  {
    "codigo":188925008,
    "descripcion":"NEOPLASIA BENIGNA DE VÉRTEBRA CERVICAL"
  },
  {
    "codigo":56018004,
    "descripcion":"SIBILANCIAS"
  },
  {
    "codigo":285394008,
    "descripcion":"DISTENSIÓN DE MÚSCULO DEL TRONCO"
  },
  {
    "codigo":283559003,
    "descripcion":"HERIDA DE PERDIGÓN EN MIEMBRO SUPERIOR"
  },
  {
    "codigo":447399004,
    "descripcion":"ABSCESO TUBERCULOSO DE CUELLO"
  },
  {
    "codigo":185255006,
    "descripcion":"ATENDIDO EN UN CONSULTORIO ENDOCRINOLÓGICO"
  },
  {
    "codigo":85116003,
    "descripcion":"ABORTO ESPONTÁNEO EN EL SEGUNDO TRIMESTRE"
  },
  {
    "codigo":247121001,
    "descripcion":"OCLUSIÓN DE RAMA MACULAR DE VENA RETINIANA"
  },
  {
    "codigo":443729008,
    "descripcion":"FINALIZACIÓN DE ENSAYO CLÍNICO"
  },
  {
    "codigo":310822000,
    "descripcion":"CAPAZ DE DEDUCIR EL SIGNIFICADO"
  },
  {
    "codigo":50513008,
    "descripcion":"ATRESIA DE BRONQUIOS"
  },
  {
    "codigo":212518005,
    "descripcion":"INTOXICACIÓN POR COMPUESTO DE BISMUTO"
  },
  {
    "codigo":10630271000119103,
    "descripcion":"LINFANGITIS AGUDA DE PIE IZQUIERDO"
  },
  {
    "codigo":1162790007,
    "descripcion":"ISOENZIMA HEPÁTICA DE FOSFATASA ALCALINA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":866043000,
    "descripcion":"NEURALGIA DE DECIMOSEGUNDO NERVIO DORSAL"
  },
  {
    "codigo":276219001,
    "descripcion":"INFARTO CEREBRAL OCCIPITAL"
  },
  {
    "codigo":472827002,
    "descripcion":"PAPILOMATOSIS RESPIRATORIA RECURRENTE"
  },
  {
    "codigo":441894009,
    "descripcion":"MONOPLEJÍA DE MIEMBRO INFERIOR NO DOMINANTE COMO EFECTO TARDÍO DE ACCIDENTE CEREBROVASCULAR"
  },
  {
    "codigo":278054005,
    "descripcion":"CARCINOMA LOBULILLAR DE MAMA"
  },
  {
    "codigo":440059007,
    "descripcion":"FIBRILACIÓN AURICULAR PERSISTENTE"
  },
  {
    "codigo":308351000119105,
    "descripcion":"GRANULOMA POR CUERPO EXTRAÑO DE PARTES BLANDAS DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":16036991000119105,
    "descripcion":"DETENCIÓN PARCIAL DE CRECIMIENTO EPIFISARIO DE AMBOS FÉMURES DISTALES"
  },
  {
    "codigo":208848003,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA EXPUESTA DE LA ARTICULACIÓN RADIOCUBITAL DISTAL"
  },
  {
    "codigo":733136006,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE URETRA"
  },
  {
    "codigo":700368007,
    "descripcion":"ORZUELO INTERNO DE PÁRPADO INFERIOR"
  },
  {
    "codigo":403621002,
    "descripcion":"PANICULITIS MEDICAMENTOSA"
  },
  {
    "codigo":272549003,
    "descripcion":"SENTADO DE LADO"
  },
  {
    "codigo":239781004,
    "descripcion":"ARTRITIS CAUSADA POR ESPIROQUETAS"
  },
  {
    "codigo":698533007,
    "descripcion":"REQUIERE DISPOSITIVO ORTODÓNCICO REMOVIBLE SUPERIOR"
  },
  {
    "codigo":557174041000119102,
    "descripcion":"TUMOR NEUROENDOCRINO BIEN DIFERENCIADO GRADO 2 DE PULMÓN IZQUIERDO"
  },
  {
    "codigo":237946002,
    "descripcion":"DEFICIENCIA PARCIAL DE METILMALONIL-COA MUTASA"
  },
  {
    "codigo":236111000,
    "descripcion":"NECROSIS DE ANASTOMOSIS ESOFÁGICA"
  },
  {
    "codigo":203343001,
    "descripcion":"ENFERMEDAD DE PAGET DE LA RÓTULA"
  },
  {
    "codigo":399951000,
    "descripcion":"AMPOLLA TRAUMÁTICA DE ESCROTO"
  },
  {
    "codigo":205178008,
    "descripcion":"PULGAR HIPOPLÁSICO-BLAUTH 5"
  },
  {
    "codigo":1055311004,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA A LA ALTURA DE CODO DERECHO"
  },
  {
    "codigo":301647002,
    "descripcion":"NO SE SIENTA NI SE LEVANTA DE UNA SILLA"
  },
  {
    "codigo":170575006,
    "descripcion":"EFECTOS COLATERALES DE FÁRMACOS CARDIOLÓGICOS"
  },
  {
    "codigo":4900002,
    "descripcion":"ENFERMEDAD ENDOCRINA RELACIONADA CON LA PUBERTAD"
  },
  {
    "codigo":365348002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA USAR MEDIO DE TRANSPORTE PRIVADO"
  },
  {
    "codigo":37668006,
    "descripcion":"SÍNDROME Y\/O ENFERMEDAD SUBCLÍNICA"
  },
  {
    "codigo":267044007,
    "descripcion":"ALTERACIÓN DE LA TOLERANCIA AL EJERCICIO"
  },
  {
    "codigo":299812007,
    "descripcion":"REFLEJO DE PARPADEO PRESENTE"
  },
  {
    "codigo":297977002,
    "descripcion":"TEMPERATURA CUTÁNEA NORMAL"
  },
  {
    "codigo":232441008,
    "descripcion":"PARÁLISIS CONGÉNITA DE LAS CUERDAS VOCALES"
  },
  {
    "codigo":68601009,
    "descripcion":"CÁLCULO DE CONDUCTO CÍSTICO SIN OBSTRUCCIÓN"
  },
  {
    "codigo":296142007,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE DICLORALFENAZONA"
  },
  {
    "codigo":230606008,
    "descripcion":"NEUROPATÍA ISQUÉMICA POR ROBO ARTERIAL"
  },
  {
    "codigo":165070008,
    "descripcion":"REGISTRO DE TEMPERATURA: OVULATORIO"
  },
  {
    "codigo":392611002,
    "descripcion":"HALLAZGO RELACIONADO CON LA PRESENCIA DE GAS EN EL TRACTO GASTROINTESTINAL"
  },
  {
    "codigo":30328003,
    "descripcion":"MIOENDOCARDITIS AGUDA"
  },
  {
    "codigo":194168004,
    "descripcion":"PUPILA DE ARGYLL ROBERTSON NO SIFILÍTICA"
  },
  {
    "codigo":95864008,
    "descripcion":"EFECTOS DE LA EXPOSICIÓN A TEMPERATURAS EXTREMAS"
  },
  {
    "codigo":126797001,
    "descripcion":"NEOPLASIA DE LA BOCA"
  },
  {
    "codigo":292472009,
    "descripcion":"REACCIÓN ADVERSA A LA DISTIGMINA"
  },
  {
    "codigo":94029005,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA PIEL DE LA CADERA"
  },
  {
    "codigo":290637005,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR DACTINOMICINA"
  },
  {
    "codigo":61261009,
    "descripcion":"ANEMIA HEMOLÍTICA"
  },
  {
    "codigo":59426001,
    "descripcion":"QUEMADURA DE LA VAGINA"
  },
  {
    "codigo":288802005,
    "descripcion":"UTILIZA EL HUMOR"
  },
  {
    "codigo":124962008,
    "descripcion":"SIDEROCITOFAGOCITOSIS"
  },
  {
    "codigo":92194008,
    "descripcion":"NEOPLASIA BENIGNA DE LA COLUMNA VERTEBRAL LUMBAR"
  },
  {
    "codigo":90359003,
    "descripcion":"INTOXICACIÓN POR MARISCOS CAUSADA POR GONYAULAX TAMARENSIS"
  },
  {
    "codigo":876791005,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE CODO CON INFECCIÓN"
  },
  {
    "codigo":254199006,
    "descripcion":"LINFEDEMA HEREDITARIO"
  },
  {
    "codigo":286967008,
    "descripcion":"APENDICITIS AGUDA PERFORADA"
  },
  {
    "codigo":57591009,
    "descripcion":"RESPIRACIÓN DIAFRAGMÁTICA"
  },
  {
    "codigo":55756002,
    "descripcion":"COMPLICACIÓN DE LA ANASTOMOSIS INTERNA Y\/O DE LA DERIVACIÓN DEL TRACTO URINARIO, INCLUIDA AQUELLA QUE COMPROMETE AL TRACTO INTESTINAL"
  },
  {
    "codigo":283297002,
    "descripcion":"ASTILLA DE MADERA EN EL TRONCO"
  },
  {
    "codigo":250529003,
    "descripcion":"PRUEBA DE LA FOSFATASA: FALLIDA"
  },
  {
    "codigo":709281006,
    "descripcion":"ENFERMEDAD DEL MÚSCULO ONDULANTE"
  },
  {
    "codigo":248694000,
    "descripcion":"RUIDO DE VÁLVULA PROTÉSICA"
  },
  {
    "codigo":1297270002,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE DEDO ANULAR"
  },
  {
    "codigo":707446004,
    "descripcion":"EXACERBACIÓN DE ASMA MODERADA PERSISTENTE"
  },
  {
    "codigo":281462005,
    "descripcion":"ARQUEAMIENTO DE TORNILLO"
  },
  {
    "codigo":1264502005,
    "descripcion":"ADENOCARCINOMA MUCINOSO DE TRACTO GASTROINTESTINAL METASTÁSICO"
  },
  {
    "codigo":1295435000,
    "descripcion":"RADIOGRAFÍA DE BARRIDO DE ESQUELETO COMPLETO ANORMAL"
  },
  {
    "codigo":771147003,
    "descripcion":"ARRINENCEFALIA AISLADA"
  },
  {
    "codigo":312395007,
    "descripcion":"NIVEL DE SALICILATO DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":212256005,
    "descripcion":"CONTUSIÓN, NERVIO MEDIANO, RAMA SENSITIVA PALMAR"
  },
  {
    "codigo":275957002,
    "descripcion":"PÉRDIDA DEL JUICIO PARA MANEJAR"
  },
  {
    "codigo":16013031000119107,
    "descripcion":"TROMBOSIS DE ARTERIA FEMORAL DERECHA"
  },
  {
    "codigo":339841000119101,
    "descripcion":"ENTROPIÓN CICATRIZAL DE PÁRPADO INFERIOR IZQUIERDO"
  },
  {
    "codigo":11835111000119107,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA DE PULGAR IZQUIERDO"
  },
  {
    "codigo":439797007,
    "descripcion":"FÍSTULA ARTERIOVENOSA CUBITAL-CEFÁLICA CONSTRUIDA QUIRÚRGICAMENTE"
  },
  {
    "codigo":274122006,
    "descripcion":"ÚTERO GRÁVIDO - RETROVERTIDO"
  },
  {
    "codigo":110282008,
    "descripcion":"LESIÓN MEDICAMENTOSA"
  },
  {
    "codigo":698271000,
    "descripcion":"CANALOPATÍA CARDÍACA"
  },
  {
    "codigo":403359004,
    "descripcion":"ACNÉ NODULAR"
  },
  {
    "codigo":1077121000119105,
    "descripcion":"QUISTE ÓSEO DEL PERONÉ IZQUIERDO"
  },
  {
    "codigo":237684005,
    "descripcion":"SÍNDROME DE SHEEHAN"
  },
  {
    "codigo":10907521000119106,
    "descripcion":"HERIDA POR DISPARO DE ARMA DE FUEGO DE BRAZO IZQUIERDO"
  },
  {
    "codigo":303220007,
    "descripcion":"HALLAZGO RELACIONADO CON EL LLANTO"
  },
  {
    "codigo":268617001,
    "descripcion":"EPISODIO ESQUIZOFRÉNICO AGUDO"
  },
  {
    "codigo":1153353002,
    "descripcion":"ANEMIA POR DEFICIENCIA DE VITAMINA B12 POSTERIOR A GASTRECTOMÍA TOTAL"
  },
  {
    "codigo":203081003,
    "descripcion":"CONTRACTURA DE MÚSCULO INTRÍNSECO DEL PIE"
  },
  {
    "codigo":94081000119107,
    "descripcion":"SÍNDROME DE ROBO ISQUÉMICO"
  },
  {
    "codigo":1217054001,
    "descripcion":"TRASTORNO ADRENOGENITAL IDIOPÁTICO"
  },
  {
    "codigo":235849009,
    "descripcion":"GANGRENA DEL INTESTINO DELGADO"
  },
  {
    "codigo":365086004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA EMPLEAR EL HUMOR"
  },
  {
    "codigo":102942005,
    "descripcion":"FUNCIONAMIENTO INTELECTUAL FRONTERIZO"
  },
  {
    "codigo":234014009,
    "descripcion":"LESIÓN LOCAL POR FRÍO"
  },
  {
    "codigo":166643006,
    "descripcion":"ENZIMAS HEPÁTICAS FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":363251008,
    "descripcion":"OTOESCLEROSIS DEL OÍDO MEDIO"
  },
  {
    "codigo":35571009,
    "descripcion":"COLANGIOLITIS"
  },
  {
    "codigo":230344005,
    "descripcion":"MIOCLONÍA POSANÓXICA"
  },
  {
    "codigo":313371000119106,
    "descripcion":"ARTROFITO EN ARTICULACIÓN DE REGIÓN DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":263112006,
    "descripcion":"FRACTURA-SUBLUXACIÓN DE LA ARTICULACIÓN DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":33736005,
    "descripcion":"DEPRESIÓN MAYOR GRAVE CON SÍNTOMAS PSICÓTICOS, CONGRUENTE CON EL ESTADO DE ÁNIMO"
  },
  {
    "codigo":228509002,
    "descripcion":"HALLAZGO RELACIONADO CON LA MASTICACIÓN DE TABACO"
  },
  {
    "codigo":229811005,
    "descripcion":"CALLOSIDAD EN EL PIE"
  },
  {
    "codigo":204981000119101,
    "descripcion":"MIOCARDIOPATÍA DEBIDA A INFECCIÓN VIRAL"
  },
  {
    "codigo":294045005,
    "descripcion":"ALERGIA A TULOBUTEROL"
  },
  {
    "codigo":161138004,
    "descripcion":"PROBLEMAS DE ALFABETISMO"
  },
  {
    "codigo":718194004,
    "descripcion":"HIPOTIROIDISMO DEBIDO A MUTACIÓN EN EL FACTOR DE TRANSCRIPCIÓN DE DESARROLLO HIPOFISARIO"
  },
  {
    "codigo":95602007,
    "descripcion":"GALACTOFORITIS"
  },
  {
    "codigo":292210007,
    "descripcion":"REACCIÓN ADVERSA A LA NITROSOUREA"
  },
  {
    "codigo":783730009,
    "descripcion":"DISPLASIA FIBROMUSCULAR DE PARED DE ARTERIA RENAL"
  },
  {
    "codigo":290375003,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR LANSOPRAZOL"
  },
  {
    "codigo":15933621000119104,
    "descripcion":"QUISTE DE TROMPA DE FALOPIO DERECHA"
  },
  {
    "codigo":126535008,
    "descripcion":"POLINEUROPATÍA MOTORA DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":192071009,
    "descripcion":"ALTERACIÓN LEVE DE LA MEMORIA"
  },
  {
    "codigo":93767009,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE NERVIO CRANEAL"
  },
  {
    "codigo":419612003,
    "descripcion":"PACIENTE PREPARADO PARA LA ANESTESIA"
  },
  {
    "codigo":190236006,
    "descripcion":"BOCIO NODULAR NO TÓXICO"
  },
  {
    "codigo":91932007,
    "descripcion":"ALERGIA A FRUTA"
  },
  {
    "codigo":124700006,
    "descripcion":"DEFICIENCIA DE SUCCINATO - COA LIGASA (FORMADOR DE GDP)"
  },
  {
    "codigo":253937004,
    "descripcion":"ANOMALÍA CONGÉNITA DE MIEMBRO INFERIOR Y CINTURA PÉLVICA"
  },
  {
    "codigo":1204209008,
    "descripcion":"RETENCIÓN INAPROPIADA DE ESTÍMULO POR DESFIBRILADOR CARDIOVERSOR IMPLANTABLE"
  },
  {
    "codigo":448710000,
    "descripcion":"SARCOMA DE HUESO"
  },
  {
    "codigo":286705009,
    "descripcion":"BAJA PREDISPOSICIÓN AL SOBRESALTO"
  },
  {
    "codigo":342351000119102,
    "descripcion":"HIPERTRICOSIS DE PÁRPADO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":219334005,
    "descripcion":"LESIÓN POR ARMAS DE FUEGO Y EXPLOSIVOS, CON PROPÓSITO DESCONOCIDO"
  },
  {
    "codigo":284870006,
    "descripcion":"CAPAZ DE CORTARSE LAS UÑAS"
  },
  {
    "codigo":250267001,
    "descripcion":"PRUEBA DE HEMÓLISIS EN SACAROSA, NEGATIVA"
  },
  {
    "codigo":283035001,
    "descripcion":"LESIÓN SUPERFICIAL DE DORSO DE LA MANO"
  },
  {
    "codigo":1003931004,
    "descripcion":"DELECIÓN PROXIMAL DEL BRAZO LARGO DEL CROMOSOMA 10"
  },
  {
    "codigo":1079631000119105,
    "descripcion":"CONDROSARCOMA PRIMARIO DE HUESO DE EXTREMIDAD INFERIOR DERECHA"
  },
  {
    "codigo":248432005,
    "descripcion":"FASE ASCENDENTE DE LA FIEBRE"
  },
  {
    "codigo":10965481000119100,
    "descripcion":"HERIDA PUNZANTE DE CADERA DERECHA"
  },
  {
    "codigo":11784681000119100,
    "descripcion":"AMPOLLA TRAUMÁTICA DE DEDO GORDO DE PIE DERECHO"
  },
  {
    "codigo":1264240009,
    "descripcion":"DAÑO DE TEJIDO PERIURETRAL POSTERIOR A EMBARAZO MOLAR"
  },
  {
    "codigo":17221002,
    "descripcion":"ELEVACIÓN DE UNA COLONIA BACTERIANA, PLANA"
  },
  {
    "codigo":1196869004,
    "descripcion":"DEFECTO DE GEN DE ENSAMBLAJE DE COMPLEJO IV DE CADENA RESPIRATORIA MITOCONDRIAL"
  },
  {
    "codigo":312133006,
    "descripcion":"INFECCIÓN VIRAL DEL APARATO RESPIRATORIO"
  },
  {
    "codigo":246597009,
    "descripcion":"DORSIFLEXIÓN DE TOBILLO QUE LIMITA LA ELEVACIÓN DE PIERNA EXTENDIDA"
  },
  {
    "codigo":310298004,
    "descripcion":"ANTICUERPOS ANTICÉLULAS PARIETALES DÉBILMENTE DETECTADOS"
  },
  {
    "codigo":277530005,
    "descripcion":"MELANOMA MALIGNO DE MENINGES"
  },
  {
    "codigo":1162266005,
    "descripcion":"GLOMERULONEFRITIS EXUDATIVA"
  },
  {
    "codigo":15386007,
    "descripcion":"ESTENOSIS DE VASO PULMONAR"
  },
  {
    "codigo":734447002,
    "descripcion":"DIPLOCOCO INTRACELULAR GRAMNEGATIVO"
  },
  {
    "codigo":210159003,
    "descripcion":"LESIÓN TRAUMÁTICA DE APÉNDICE ILEOCECAL CON HERIDA ABIERTA HACIA CAVIDAD ABDOMINAL"
  },
  {
    "codigo":46319007,
    "descripcion":"BLOQUEO DE RAMA DERECHA Y BLOQUEO DE LA RAMA IZQUIERDA POSTERIOR DEL HAZ DE HIS"
  },
  {
    "codigo":77252004,
    "descripcion":"PITIRIASIS ROSADA"
  },
  {
    "codigo":307080002,
    "descripcion":"CARÁCTER EXCESIVAMENTE SUMISO"
  },
  {
    "codigo":110020006,
    "descripcion":"FRACTURA EXPUESTA DE PORCIÓN ORBITARIA DE HUESO CIGOMÁTICO"
  },
  {
    "codigo":208324004,
    "descripcion":"FRACTURA DORSAL DE BARTON NO EXPUESTA"
  },
  {
    "codigo":1156761002,
    "descripcion":"PARÁLISIS SUPRANUCLEAR PROGRESIVA-AFASIA PROGRESIVA NO FLUIDA"
  },
  {
    "codigo":42649002,
    "descripcion":"SÍNDROME DE RILEY-SHWACHMAN"
  },
  {
    "codigo":206489003,
    "descripcion":"HIPERNATREMIA NEONATAL TRANSITORIA"
  },
  {
    "codigo":302958006,
    "descripcion":"AGENESIA DE MÚLTIPLES DEDOS DEL PIE"
  },
  {
    "codigo":1251395000,
    "descripcion":"LESIÓN TRAUMÁTICA DE PIEL CAUSADA POR ANTHOZOA"
  },
  {
    "codigo":6211002,
    "descripcion":"POLIARTRITIS ASOCIADA CON OTRO TRASTORNO"
  },
  {
    "codigo":202819003,
    "descripcion":"INESTABILIDAD ATLANTO-OCCIPITAL"
  },
  {
    "codigo":301123005,
    "descripcion":"HALLAZGO PERICÁRDICO"
  },
  {
    "codigo":366659009,
    "descripcion":"HALLAZGO RELACIONADO CON EL CRECIMIENTO DEL VELLO SEXUAL SECUNDARIO"
  },
  {
    "codigo":168216004,
    "descripcion":"HONGO AISLADO EN ESPÉCIMEN"
  },
  {
    "codigo":299288006,
    "descripcion":"AMPLITUD DE ROTACIÓN INTERNA ACTIVA DE ARTICULACIÓN DE CADERA, DISMINUIDA"
  },
  {
    "codigo":266520007,
    "descripcion":"INSUFICIENCIA VASCULAR CRÓNICA DEL TRACTO GASTROINTESTINAL"
  },
  {
    "codigo":200984007,
    "descripcion":"PARAPSORIASIS PAPULOSA"
  },
  {
    "codigo":364824008,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA UTILIZAR UN UTENSILIO PARA ALIMENTARSE"
  },
  {
    "codigo":461293002,
    "descripcion":"ANOMALÍA ADQUIRIDA DE VENA YUGULAR"
  },
  {
    "codigo":362989003,
    "descripcion":"DISFUNCIÓN AUDITIVA"
  },
  {
    "codigo":2541004,
    "descripcion":"COMPULSIÓN POR COMPRAR"
  },
  {
    "codigo":231917001,
    "descripcion":"PIGMENTO MELÁNICO DE LA CÓRNEA"
  },
  {
    "codigo":99101000119101,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE TROMPA DE FALOPIO"
  },
  {
    "codigo":788973008,
    "descripcion":"LACERACIÓN DE PULGAR CON CUERPO EXTRAÑO"
  },
  {
    "codigo":672541000119102,
    "descripcion":"AFAQUIA DEBIDA A ACCIDENTE CEREBROVASCULAR ISQUÉMICO Y POSTERIOR A ÉL"
  },
  {
    "codigo":721602000,
    "descripcion":"CARCINOMA EMBRIONARIO PRIMARIO DE TESTÍCULO"
  },
  {
    "codigo":295618004,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE CLORAMBUCILO"
  },
  {
    "codigo":424855000,
    "descripcion":"NO BUSCA ATENCIÓN POR SÍNTOMAS QUE REQUIEREN EVALUACIÓN"
  },
  {
    "codigo":262850009,
    "descripcion":"LACERACIÓN DE DUODENO"
  },
  {
    "codigo":785303004,
    "descripcion":"SÍNDROME DE ANOMALÍAS CONGÉNITAS MÚLTIPLES, HIPOTONÍA Y CONVULSIONES"
  },
  {
    "codigo":719767004,
    "descripcion":"ANTICUERPO CONTRA VIRUS DE LA INMUNODEFICIENCIA HUMANA TIPO 2 INDETERMINADO"
  },
  {
    "codigo":293783007,
    "descripcion":"ALERGIA A RAZOXANO"
  },
  {
    "codigo":717932000,
    "descripcion":"DELGADEZ MODERADA EN LA VIDA ADULTA"
  },
  {
    "codigo":128108002,
    "descripcion":"ENFERMEDAD DE VON WILLEBRAND HEREDITARIA TIPO 3"
  },
  {
    "codigo":95340003,
    "descripcion":"INFECCIÓN DEL LECHO DE LA UÑA"
  },
  {
    "codigo":160876004,
    "descripcion":"NIÑO ASISTE A ESCUELA ESPECIAL"
  },
  {
    "codigo":291948006,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR QUINIDINA"
  },
  {
    "codigo":29804008,
    "descripcion":"DIFERENCIAS VENTILATORIAS REGIONALES POR PRESIÓN PLEURAL"
  },
  {
    "codigo":716097001,
    "descripcion":"SÍNDROME DE ICTIOSIS-MEJILLAS-CEJAS"
  },
  {
    "codigo":879937000,
    "descripcion":"DEFICIENCIA DE ALFA-N-ACETILGALACTOSAMINIDASA TIPO 1"
  },
  {
    "codigo":1240385007,
    "descripcion":"TRASTORNO NEONATAL PRECOZ DEBIDO A SÍNDROME DE TRANSFUSIÓN PLACENTARIA"
  },
  {
    "codigo":10640311000119102,
    "descripcion":"ÚLCERA NEUROPÁTICA DE MUSLO DERECHO"
  },
  {
    "codigo":290113009,
    "descripcion":"SECRECIÓN SANGUINOLENTA POR PEZÓN"
  },
  {
    "codigo":60737008,
    "descripcion":"SOBRECARGA DE HIERRO"
  },
  {
    "codigo":1082141000119108,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE LÓBULO SUPERIOR DE PULMÓN IZQUIERDO"
  },
  {
    "codigo":124438009,
    "descripcion":"DEFICIENCIA DE GLUCOSA - 1 - FOSFATASA"
  },
  {
    "codigo":253675002,
    "descripcion":"COARTACIÓN AÓRTICA YUXTADUCTAL"
  },
  {
    "codigo":35721000175100,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN EN CODO ESTADIO I"
  },
  {
    "codigo":22464000,
    "descripcion":"INFESTACIÓN CAUSADA POR DEMODEX CATI"
  },
  {
    "codigo":89835009,
    "descripcion":"ATROFIA DE HÍGADO"
  },
  {
    "codigo":286443008,
    "descripcion":"OBTIENE LOS ALIMENTOS"
  },
  {
    "codigo":291921000119100,
    "descripcion":"TRASTORNO DE NERVIO CIÁTICO IZQUIERDO"
  },
  {
    "codigo":282773000,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA RÓTULA"
  },
  {
    "codigo":415680008,
    "descripcion":"EL MARGEN QUIRÚRGICO PANCREÁTICO ES EL MARGEN NO AFECTADO MÁS PRÓXIMO A LA NEOPLASIA MALIGNA"
  },
  {
    "codigo":446613002,
    "descripcion":"VIRUS AISLADO PERO SIN IDENTIFICACIÓN POSTERIOR"
  },
  {
    "codigo":250005003,
    "descripcion":"MARCHA INTERRUMPIDA"
  },
  {
    "codigo":118933004,
    "descripcion":"TRASTORNO DE LA MANO"
  },
  {
    "codigo":448448009,
    "descripcion":"NEVO MELANOCÍTICO DE PIEL DEL MUSLO"
  },
  {
    "codigo":53397008,
    "descripcion":"BILIURIA"
  },
  {
    "codigo":1231210003,
    "descripcion":"ESTRABISMO MECÁNICO DEBIDO A TRASTORNO DE MÚSCULO ESQUELÉTICO CAUSADO POR ANESTÉSICO LOCAL"
  },
  {
    "codigo":248170004,
    "descripcion":"PERFIL FACIAL CÓNCAVO"
  },
  {
    "codigo":1263978005,
    "descripcion":"HEMORRAGIA INTRAVENTRICULAR NO TRAUMÁTICA NEONATAL PRECOZ"
  },
  {
    "codigo":706922007,
    "descripcion":"FRACTURA DE HUESO COMPLICADA"
  },
  {
    "codigo":1296746008,
    "descripcion":"IRIS EN MESETA DE AMBOS OJOS"
  },
  {
    "codigo":49727002,
    "descripcion":"TOS"
  },
  {
    "codigo":770623004,
    "descripcion":"EPILEPSIA BENIGNA DEL LÓBULO OCCIPITAL"
  },
  {
    "codigo":82495004,
    "descripcion":"TUBERCULOSIS DE GANGLIOS LINFÁTICOS MEDIASTÍNICOS"
  },
  {
    "codigo":16959008,
    "descripcion":"INTOXICACIÓN POR ETILAZINFOS"
  },
  {
    "codigo":80660001,
    "descripcion":"SÍNDROME DE MAURIAC"
  },
  {
    "codigo":705087009,
    "descripcion":"FRACTURA EXPUESTA DE FALANGE DE SEGUNDO A QUINTO DEDOS DEL PIE"
  },
  {
    "codigo":1293076002,
    "descripcion":"TUMOR FIBROSO SOLITARIO RICO EN CÉLULAS GIGANTES"
  },
  {
    "codigo":408340004,
    "descripcion":"INGESTA DIETÉTICA ELEVADA - PESCADO GRASO"
  },
  {
    "codigo":703252002,
    "descripcion":"INFARTO AGUDO DE PARED ANTERIOR DE MIOCARDIO CON COMPROMISO DE VENTRÍCULO DERECHO"
  },
  {
    "codigo":13289004,
    "descripcion":"HEMORRAGIA INTRACRANEAL POSTRAUMÁTICA CON HERIDA INTRACRANEAL ABIERTA Y CON PÉRDIDA DE LA CONSCIENCIA"
  },
  {
    "codigo":111593004,
    "descripcion":"FRACTURA NO EXPUESTA DE LA BÓVEDA CRANEAL CON HEMORRAGIA INTRACRANEAL"
  },
  {
    "codigo":275433009,
    "descripcion":"LINFANGITIS DE MAMA DE CAUSA OBSTÉTRICA"
  },
  {
    "codigo":109758003,
    "descripcion":"FRACTURA HORIZONTAL DEL TERCIO CERVICAL DE LA RAÍZ DENTAL"
  },
  {
    "codigo":11454006,
    "descripcion":"INTENTO FALLIDO DE ABORTO CON EMBOLIA DE LÍQUIDO AMNIÓTICO"
  },
  {
    "codigo":404670008,
    "descripcion":"ÉMBOLO DE COLESTEROL EN LA RETINA"
  },
  {
    "codigo":238995004,
    "descripcion":"ERUPCIÓN ACNEIFORME POR FÁRMACOS"
  },
  {
    "codigo":39621000087101,
    "descripcion":"LUXACIÓN DE ARTICULACIÓN PERISEMILUNAR DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":370067006,
    "descripcion":"INVASIÓN TUMORAL EN GANGLIO LINFÁTICO MEDIASTÍNICO, SIN EXTENSIÓN EXTRACAPSULAR"
  },
  {
    "codigo":9619006,
    "descripcion":"FIEBRE ASÉPTICA"
  },
  {
    "codigo":402835008,
    "descripcion":"ARAÑAS VASCULARES, SECUNDARIAS"
  },
  {
    "codigo":42181000087100,
    "descripcion":"HERIDA CORTANTE DE PIERNA IZQUIERDA"
  },
  {
    "codigo":47301000087106,
    "descripcion":"DISTENSIÓN DE MÚSCULO CUÁDRICEPS FEMORAL IZQUIERDO"
  },
  {
    "codigo":73320003,
    "descripcion":"HEMÓLISIS"
  },
  {
    "codigo":271763005,
    "descripcion":"COMEDÓN ABIERTO"
  },
  {
    "codigo":1254803009,
    "descripcion":"CARCINOMA ESCAMOCELULAR PAPILAR DE OROFARINGE"
  },
  {
    "codigo":71485000,
    "descripcion":"MACRODONCIA"
  },
  {
    "codigo":399165002,
    "descripcion":"SÍNDROME DE ARDOR BUCAL"
  },
  {
    "codigo":300861003,
    "descripcion":"MASA DE ESTRUCTURA MUSCULOESQUELÉTICA"
  },
  {
    "codigo":366397003,
    "descripcion":"AMPLITUD DE LA ROTACIÓN IZQUIERDA DE LA COLUMNA CERVICAL - HALLAZGO"
  },
  {
    "codigo":320901000119101,
    "descripcion":"QUISTE ÓSEO SOLITARIO DE RADIO IZQUIERDO"
  },
  {
    "codigo":5949004,
    "descripcion":"LUXACIÓN EXPUESTA DE ARTICULACIÓN DEL TARSO"
  },
  {
    "codigo":200722003,
    "descripcion":"GRANULOMA PIÓGENO"
  },
  {
    "codigo":299026004,
    "descripcion":"ARTICULACIÓN DE LA MUÑECA CALIENTE AL TACTO"
  },
  {
    "codigo":167954005,
    "descripcion":"LÍQUIDO PLEURAL SANGUINOLENTO"
  },
  {
    "codigo":725010007,
    "descripcion":"DOLOR DE CUELLO CONCOMITANTE CON DOLOR A LA PALPACIÓN POSTERIOR A LESIÓN TRAUMÁTICA CERVICAL POR LATIGAZO"
  },
  {
    "codigo":773768000,
    "descripcion":"SÍNDROME DE EMERY-NELSON"
  },
  {
    "codigo":1149159005,
    "descripcion":"NIVEL DE MIEDO DISMINUIDO"
  },
  {
    "codigo":297191009,
    "descripcion":"CICATRIZACIÓN DE ESTOMA"
  },
  {
    "codigo":197052002,
    "descripcion":"INVAGINACIÓN MÚLTIPLE"
  },
  {
    "codigo":295356006,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE FAMOTIDINA"
  },
  {
    "codigo":360892007,
    "descripcion":"DEFICIENCIA DE NADASA"
  },
  {
    "codigo":162449000,
    "descripcion":"EL SÍNTOMA ES CONTINUO"
  },
  {
    "codigo":721340009,
    "descripcion":"LACERACIÓN DE FASCIA DE LA CABEZA"
  },
  {
    "codigo":1145489001,
    "descripcion":"HIPOPLASIA CONGÉNITA DE FALANGE PROXIMAL DE DEDO MEÑIQUE"
  },
  {
    "codigo":195217004,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DEL HEMISFERIO CEREBRAL DERECHO"
  },
  {
    "codigo":129681004,
    "descripcion":"HALLAZGO AMBIENTAL"
  },
  {
    "codigo":291686000,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR CICLOSERINA"
  },
  {
    "codigo":293521009,
    "descripcion":"REACCIÓN ADVERSA A LA OUABAÍNA"
  },
  {
    "codigo":226150007,
    "descripcion":"DIETA RICA EN VITAMINA A"
  },
  {
    "codigo":29542008,
    "descripcion":"ESPASMO UTERINO"
  },
  {
    "codigo":95078008,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA PIEL DEL CUERO CABELLUDO"
  },
  {
    "codigo":160614008,
    "descripcion":"CONSUMO DE TABACO DESCONOCIDO"
  },
  {
    "codigo":715835003,
    "descripcion":"DISTENSIÓN DE LIGAMENTO PERIODONTAL"
  },
  {
    "codigo":93243002,
    "descripcion":"HIPOPLASIA CONGÉNITA DE HUESO BASIOCCIPITAL"
  },
  {
    "codigo":289851004,
    "descripcion":"ELASTICIDAD PERINEAL"
  },
  {
    "codigo":422758009,
    "descripcion":"CARCINOMA DE MEATO NASAL"
  },
  {
    "codigo":60475009,
    "descripcion":"ANOMALÍA CONGÉNITA DE UNA EXTREMIDAD"
  },
  {
    "codigo":1303824002,
    "descripcion":"SACROILEÍTIS BILATERAL"
  },
  {
    "codigo":191547009,
    "descripcion":"EXACERBACIÓN AGUDA DE ESQUIZOFRENIA CATATÓNICA SUBCRÓNICA"
  },
  {
    "codigo":224315009,
    "descripcion":"EDUCADO EN ESCUELA CONVENCIONAL"
  },
  {
    "codigo":124176005,
    "descripcion":"DEFICIENCIA DE PIRROLINA - 2 - CARBOXILATO REDUCTASA"
  },
  {
    "codigo":11845151000119107,
    "descripcion":"FÍSTULA CAROTIDEOCAVERNOSA IZQUIERDA TRAUMÁTICA"
  },
  {
    "codigo":56805008,
    "descripcion":"BOCIO ENDÉMICO"
  },
  {
    "codigo":253413008,
    "descripcion":"MÚSCULO PAPILAR MITRAL HIPOPLÁSICO"
  },
  {
    "codigo":710330002,
    "descripcion":"ACINETOBACTER JUNII O ACINETOBACTER JOHNSONII"
  },
  {
    "codigo":54970002,
    "descripcion":"DIETA RESTRINGIDA EN MONOAMINAS"
  },
  {
    "codigo":284346004,
    "descripcion":"LESIÓN TRAUMÁTICA DE ESTRUCTURA DE CAVIDAD CORPORAL"
  },
  {
    "codigo":286181009,
    "descripcion":"PONE LA MESA"
  },
  {
    "codigo":1003407000,
    "descripcion":"SÍNDROME DE MARFAN TIPO 1"
  },
  {
    "codigo":448186009,
    "descripcion":"DEFORMIDAD DE ESTRUCTURA TORÁCICA"
  },
  {
    "codigo":413583003,
    "descripcion":"ENDOFTALMITIS POR ASPERGILLUS"
  },
  {
    "codigo":249743007,
    "descripcion":"BRAZOS CORTOS PROPORCIONADOS"
  },
  {
    "codigo":446351009,
    "descripcion":"CICATRIZ DE REGIÓN SUBMANDIBULAR"
  },
  {
    "codigo":1296484001,
    "descripcion":"HIPERTENSIÓN OCULAR DE OJO IZQUIERDO DEBIDA A DESPRENDIMIENTO DE RETINA"
  },
  {
    "codigo":1362020006,
    "descripcion":"SÍNDROME DE HIPERINMUNOGLOBULINA M TIPO 3"
  },
  {
    "codigo":247908007,
    "descripcion":"RETORCIMIENTO"
  },
  {
    "codigo":49465005,
    "descripcion":"ANGIOMA SERPIGINOSO"
  },
  {
    "codigo":770361008,
    "descripcion":"HEMORRAGIA DE CUERPO VÍTREO DEL OJO DERECHO DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":213305009,
    "descripcion":"EMBOLIA GASEOSA QUE COMPLICA TRATAMIENTO ENDOVENOSO"
  },
  {
    "codigo":735758003,
    "descripcion":"DERMATITIS IRRITATIVA POR CONTACTO CAUSADA POR FRICCIÓN"
  },
  {
    "codigo":1260046004,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS DE SENO ETMOIDAL"
  },
  {
    "codigo":211470006,
    "descripcion":"LESIONES SUPERFICIALES QUE COMPROMETEN MÚLTIPLES REGIONES DE MIEMBROS SUPERIORES E MIEMBROS INFERIORES"
  },
  {
    "codigo":702990008,
    "descripcion":"NEISSERIA SICCA O NEISSERIA SUBFLAVA"
  },
  {
    "codigo":111331000,
    "descripcion":"DILATACIÓN CONGÉNITA DE VÍA BILIAR LOBULAR INTRAHEPÁTICA"
  },
  {
    "codigo":439011002,
    "descripcion":"INTOXICACIÓN AUTOINFLIGIDA INTENCIONAL CAUSADA POR ANALGÉSICO"
  },
  {
    "codigo":209635006,
    "descripcion":"RUPTURA DE LIGAMENTO EXTERNO DE TOBILLO"
  },
  {
    "codigo":45795007,
    "descripcion":"MELANOSIS OCULAR"
  },
  {
    "codigo":207800002,
    "descripcion":"FRACTURA EXPUESTA DE PALADAR"
  },
  {
    "codigo":109496003,
    "descripcion":"MORDIDA EN CRUZ POSTERIOR INVERSA, UN SOLO DIENTE"
  },
  {
    "codigo":240568004,
    "descripcion":"SÍFILIS MENINGOVASCULAR - ETAPA CUATERNARIA"
  },
  {
    "codigo":699320005,
    "descripcion":"NEOPLASIA DE CÓNDILO MANDIBULAR"
  },
  {
    "codigo":440861000124103,
    "descripcion":"INGESTA INADECUADA DE SELENIO"
  },
  {
    "codigo":764856008,
    "descripcion":"CARCINOMA DE CÉLULAS RENALES ASOCIADO CON ENFERMEDAD QUÍSTICA ADQUIRIDA"
  },
  {
    "codigo":371640009,
    "descripcion":"CUERPO CON PARTES FALTANTES"
  },
  {
    "codigo":5661000124106,
    "descripcion":"MELANOSIS DEL FUMADOR"
  },
  {
    "codigo":238733003,
    "descripcion":"DERMATOSIS PUSTULOSA EROSIVA DEL CUERO CABELLUDO"
  },
  {
    "codigo":894093007,
    "descripcion":"MEMBRANA ANTROPILÓRICA CONGÉNITA COMPLETA"
  },
  {
    "codigo":40290000,
    "descripcion":"TEMBLOR CONTINUO"
  },
  {
    "codigo":271501007,
    "descripcion":"INFECCIÓN CAUSADA POR ECHINOSTOMA ILOCANUM"
  },
  {
    "codigo":1187170006,
    "descripcion":"NEUROPATÍA PERIFÉRICA DEBIDA A SOBREPESO"
  },
  {
    "codigo":7522008,
    "descripcion":"TUBÉRCULO IMPAR PERSISTENTE"
  },
  {
    "codigo":202295002,
    "descripcion":"CONTRACTURA EN EXTENSIÓN DE ARTICULACIÓN INTERFALÁNGICA DE DEDO DEL PIE"
  },
  {
    "codigo":366135003,
    "descripcion":"HALLAZGO RELACIONADO CON RUIDOS RESPIRATORIOS"
  },
  {
    "codigo":890423003,
    "descripcion":"GLAUCOMA INFANTIL SECUNDARIO POSTERIOR A CIRUGÍA DE CATARATA CONGÉNITA"
  },
  {
    "codigo":398903003,
    "descripcion":"HISTIOCITOMA FIBROSO MALIGNO PLEOMÓRFICO CUTÁNEO"
  },
  {
    "codigo":298764003,
    "descripcion":"CLAVÍCULA DELGADA"
  },
  {
    "codigo":724748004,
    "descripcion":"INSOMNIO CRÓNICO"
  },
  {
    "codigo":1281804006,
    "descripcion":"TRASTORNO DE ALIMENTACIÓN PEDIÁTRICA"
  },
  {
    "codigo":397068006,
    "descripcion":"MEROZOÍTO DE PLASMODIUM EN ERITROCITO"
  },
  {
    "codigo":1148897000,
    "descripcion":"ENFERMEDAD POR HEMOGLOBINA PAKSÉ"
  },
  {
    "codigo":722913002,
    "descripcion":"HIPOPLASIA PULMONAR CONGÉNITA DEBIDA A LESIÓN OCUPANTE DEL ESPACIO PULMONAR"
  },
  {
    "codigo":67553007,
    "descripcion":"INTOXICACIÓN POR DIMETOATO"
  },
  {
    "codigo":65718001,
    "descripcion":"MIOCARDITIS ADENOVIRAL"
  },
  {
    "codigo":295094004,
    "descripcion":"ALERGIA A PENTOXIFILINA"
  },
  {
    "codigo":22481000122100,
    "descripcion":"ALERGIA A POLEN DE ARTEMISA VULGARIS"
  },
  {
    "codigo":225888002,
    "descripcion":"NO APTO PARA VOLVER AL TRABAJO"
  },
  {
    "codigo":193120004,
    "descripcion":"COMPRESIONES DE RAÍCES NERVIOSAS Y PLEXOS NERVIOSOS EN LA ESPONDILOSIS"
  },
  {
    "codigo":291424005,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR FLUCITOSINA"
  },
  {
    "codigo":1010485002,
    "descripcion":"ESCLEROSIS DE EPÍFISIS DE FALANGE PROXIMAL DE DEDO ÍNDICE CON RADIOPACIDAD AUMENTADA"
  },
  {
    "codigo":846645002,
    "descripcion":"TENOSINOVITIS DE CODO"
  },
  {
    "codigo":289589004,
    "descripcion":"SANGRE ALTERADA EN VAGINA"
  },
  {
    "codigo":92981007,
    "descripcion":"CLAVÍCULA TORCIDA CONGÉNITA"
  },
  {
    "codigo":352391000119109,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE PIEL DE OREJA IZQUIERDA"
  },
  {
    "codigo":91146006,
    "descripcion":"QUEMADURA DE PRIMER GRADO DEL DORSO DE LA MANO"
  },
  {
    "codigo":254986007,
    "descripcion":"NEOPLASIA MALIGNA DE NERVIO PERIFÉRICO"
  },
  {
    "codigo":123914008,
    "descripcion":"INTOXICACIÓN POR LOGANIACEAE"
  },
  {
    "codigo":253151003,
    "descripcion":"HETEROTOPÍA NODULAR"
  },
  {
    "codigo":449759005,
    "descripcion":"COMPLICACIÓN DE TRASTORNO HIPERTENSIVO SISTÉMICO"
  },
  {
    "codigo":416991005,
    "descripcion":"OBSTRUCCIÓN DE SALIDA DE VEJIGA URINARIA"
  },
  {
    "codigo":285919007,
    "descripcion":"LLENA LA BAÑERA"
  },
  {
    "codigo":1268959008,
    "descripcion":"TUMOR NEUROECTODÉRMICO PRIMITIVO PRIMARIO DE CUELLO DE ÚTERO"
  },
  {
    "codigo":87476004,
    "descripcion":"CONVULSIÓN NEONATAL"
  },
  {
    "codigo":447924006,
    "descripcion":"TORTUOSIDAD DE ARTERIA PULMONAR"
  },
  {
    "codigo":710068006,
    "descripcion":"BEBÉ PREMATURO, 32-36 SEMANAS"
  },
  {
    "codigo":216713001,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR CARBARILO"
  },
  {
    "codigo":413321002,
    "descripcion":"PROBLEMA MANEJABLE"
  },
  {
    "codigo":249481003,
    "descripcion":"INGESTA INSUFICIENTE DE LÍQUIDOS - HALLAZGO"
  },
  {
    "codigo":85641006,
    "descripcion":"HEMIANENCEFALIA"
  },
  {
    "codigo":773769008,
    "descripcion":"SÍNDROME DE ATAXIA, FOTOSENSIBILIDAD Y TALLA BAJA"
  },
  {
    "codigo":247646002,
    "descripcion":"DIRECCIÓN DEL PENSAMIENTO"
  },
  {
    "codigo":313182004,
    "descripcion":"TRASTORNO POR ESTRÉS POSTRAUMÁTICO CRÓNICO"
  },
  {
    "codigo":51038004,
    "descripcion":"OBSTRUCCIÓN CONGÉNITA DE CONDUCTO BILIAR"
  },
  {
    "codigo":278579000,
    "descripcion":"ENCHAPADO DENTAL EXCESIVAMENTE REDUCIDO"
  },
  {
    "codigo":11768251000119104,
    "descripcion":"LACERACIÓN DE MÚSCULO CRURAL ANTERIOR DE PIERNA IZQUIERDA"
  },
  {
    "codigo":1089631000119100,
    "descripcion":"ACÚFENOS SUBJETIVO DEL OÍDO IZQUIERDO"
  },
  {
    "codigo":10676831000119101,
    "descripcion":"INSUFICIENCIA RESPIRATORIA HIPOXÉMICA"
  },
  {
    "codigo":10681951000119102,
    "descripcion":"MASA DE TEJIDO SUBCUTÁNEO DE DEDO DE AMBOS PIES"
  },
  {
    "codigo":1631000119103,
    "descripcion":"PORTADOR DE STREPTOCOCCUS DEL GRUPO B"
  },
  {
    "codigo":737331008,
    "descripcion":"TRASTORNO DE VENA POSTERIOR A ABORTO ESPONTÁNEO"
  },
  {
    "codigo":16057951000119104,
    "descripcion":"TRASTORNO DE NERVIO FACIAL IZQUIERDO"
  },
  {
    "codigo":11826271000119101,
    "descripcion":"RUPTURA TRAUMÁTICA DE TENDÓN DE MÚSCULO ADUCTOR DE ARTICULACIÓN DE CADERA IZQUIERDA"
  },
  {
    "codigo":735496003,
    "descripcion":"HIPOGLUCEMIA NEONATAL TRANSITORIA DEBIDA A HIPERINSULINEMIA"
  },
  {
    "codigo":336991000119108,
    "descripcion":"DEGENERACIÓN VÍTREA DEL OJO IZQUIERDO"
  },
  {
    "codigo":15978591000119109,
    "descripcion":"MIELOPATÍA CERVICODORSAL DEBIDO A TRASTORNO DE DISCO INTERVERTEBRAL CERVICODORSAL"
  },
  {
    "codigo":344671000119109,
    "descripcion":"CICLOPLEJÍA DE AMBOS OJOS"
  },
  {
    "codigo":10948191000119107,
    "descripcion":"HERIDA ABIERTA DE PULGAR DERECHO DEBIDA A MORDEDURA DE PERRO"
  },
  {
    "codigo":1084511000119108,
    "descripcion":"OBSTRUCCIÓN INTESTINAL DEBIDA A HERNIA INGUINAL RECURRENTE IRREDUCTIBLE"
  },
  {
    "codigo":10628191000119109,
    "descripcion":"ÁNTRAX DE EXTREMIDAD INFERIOR DERECHA"
  },
  {
    "codigo":16040031000119108,
    "descripcion":"GOTA TOFÁCEA CRÓNICA DE AMBOS CODOS"
  },
  {
    "codigo":242141003,
    "descripcion":"LESIÓN POR MOVIMIENTO DE PARTE DEL VEHÍCULO DE MOTOR TODO TERRENO AL SUBIR O BAJAR"
  },
  {
    "codigo":10633311000119108,
    "descripcion":"CELULITIS DE RODILLA DERECHA"
  },
  {
    "codigo":16019551000119109,
    "descripcion":"SINOVITIS TRANSITORIA DE ARTICULACIONES DE AMBAS MANOS"
  },
  {
    "codigo":1290717006,
    "descripcion":"DESPLAZAMIENTO DE ELECTRODO DE DISPOSITIVO NEUROLÓGICO IMPLANTADO"
  },
  {
    "codigo":15864251000119108,
    "descripcion":"ATRESIA CONGÉNITA DE OÍDO EXTERNO IZQUIERDO"
  },
  {
    "codigo":699058000,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO DE LA CINTURA PÉLVICA"
  },
  {
    "codigo":10930001,
    "descripcion":"ATRESIA CONGÉNITA DE ARTERIA PULMONAR"
  },
  {
    "codigo":830130002,
    "descripcion":"CICATRIZACIÓN DE HERIDA SATISFACTORIA"
  },
  {
    "codigo":307677002,
    "descripcion":"NISTAGMO VESTIBULAR CENTRAL DE RITMO RÁPIDO"
  },
  {
    "codigo":240306004,
    "descripcion":"ACIDOSIS FETAL"
  },
  {
    "codigo":305842000,
    "descripcion":"VISTO EN EL SERVICIO DE DRAMATERAPIA"
  },
  {
    "codigo":1287047002,
    "descripcion":"ASTILLA DE MADERA EN CABEZA Y\/O CUELLO"
  },
  {
    "codigo":9095002,
    "descripcion":"ADIASPIROMICOSIS CAUSADA POR EMMONSIA CRESCENS"
  },
  {
    "codigo":238471005,
    "descripcion":"DERMATITIS POR FRICCIÓN EN EL NIÑO"
  },
  {
    "codigo":402311006,
    "descripcion":"PSORIASIS EN PLACA QUE SE EXTIENDE ACTIVAMENTE"
  },
  {
    "codigo":41863008,
    "descripcion":"BLOQUEO DE RAMA DERECHA, HEMIBLOQUEO ANTERIOR Y HEMIBLOQUEO POSTERIOR IZQUIERDO INCOMPLETO"
  },
  {
    "codigo":74631009,
    "descripcion":"AMPOLLA DE DEDO DE LA MANO, CON INFECCIÓN"
  },
  {
    "codigo":1186908008,
    "descripcion":"UROPORFIRINA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":300337001,
    "descripcion":"HÍGADO NORMAL"
  },
  {
    "codigo":40028009,
    "descripcion":"HIPERPLASIA CONGÉNITA DE VÍA BILIAR INTRAHEPÁTICA"
  },
  {
    "codigo":365873007,
    "descripcion":"GÉNERO - HALLAZGO"
  },
  {
    "codigo":5425007,
    "descripcion":"CAMBIOS DEGENERATIVOS DEL ÁNGULO DE LA CÁMARA OCULAR ANTERIOR"
  },
  {
    "codigo":1119537007,
    "descripcion":"AGUDEZA VISUAL DE PERCEPCIÓN DE LA LUZ SIN PROYECCIÓN"
  },
  {
    "codigo":298502004,
    "descripcion":"TUMEFACCIÓN DE PARTES BLANDAS DE LA COLUMNA DORSAL"
  },
  {
    "codigo":36358004,
    "descripcion":"CONDUCCIÓN CARDÍACA ANORMAL"
  },
  {
    "codigo":3590007,
    "descripcion":"FÍSTULA ENTEROENTÉRICA"
  },
  {
    "codigo":722651000,
    "descripcion":"FRACTURA DE ANILLO PÉLVICO CON RUPTURA INCOMPLETA DE ARCO POSTERIOR"
  },
  {
    "codigo":724486009,
    "descripcion":"COMPLICACIÓN VENOSA DEL EMBARAZO"
  },
  {
    "codigo":167430008,
    "descripcion":"URATOS EN ORINA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1279707003,
    "descripcion":"LESIÓN DE RAÍZ DE NERVIO VERTEBRAL CERVICAL"
  },
  {
    "codigo":751000119104,
    "descripcion":"ENFERMEDAD RENAL CRÓNICA EN ESTADIO 1 DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":1755008,
    "descripcion":"INFARTO ANTIGUO DE MIOCARDIO"
  },
  {
    "codigo":720816004,
    "descripcion":"SÍNDROME DE CRANEOSINOSTOSIS Y CALCIFICACIÓN INTRACRANEAL"
  },
  {
    "codigo":292997000,
    "descripcion":"REACCIÓN ADVERSA A LA CEFALEXINA"
  },
  {
    "codigo":260229002,
    "descripcion":"COMIDA ESTÁNDAR"
  },
  {
    "codigo":129157005,
    "descripcion":"LUXACIÓN TRAUMÁTICA DE ARTICULACIÓN DE MANO"
  },
  {
    "codigo":161925006,
    "descripcion":"TOS PRODUCTIVA - ESPUTO AMARILLO"
  },
  {
    "codigo":1144965007,
    "descripcion":"ENTEROCELE CONCOMITANTE CON PROLAPSO UTEROVAGINAL COMPLETO"
  },
  {
    "codigo":94554003,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA PIEL DE LA CARA"
  },
  {
    "codigo":291162003,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR FLUSPIRILENO"
  },
  {
    "codigo":225626003,
    "descripcion":"MIEDO A MOVILIZARSE"
  },
  {
    "codigo":289327003,
    "descripcion":"MUÑÓN UMBILICAL NEGRO"
  },
  {
    "codigo":92719006,
    "descripcion":"CARCINOMA IN SITU DE LA PIEL DE LA OREJA"
  },
  {
    "codigo":27183007,
    "descripcion":"ANOMALÍA DEL PAR DE CROMOSOMAS 14"
  },
  {
    "codigo":254724000,
    "descripcion":"TUMOR BENIGNO DE PIEL CON DIFERENCIACIÓN APOCRINA"
  },
  {
    "codigo":1336068005,
    "descripcion":"EPISODIO DE USO NOCIVO DE CANNABINOIDE SINTÉTICO"
  },
  {
    "codigo":123652007,
    "descripcion":"ALTERACIONES CROMOSÓMICAS DE LOS GRUPOS G E Y"
  },
  {
    "codigo":685091000119101,
    "descripcion":"HEMOGLOBINA D-BETA 0 TALASEMIA"
  },
  {
    "codigo":711641004,
    "descripcion":"PULPITIS REVERSIBLE SINTOMÁTICA"
  },
  {
    "codigo":1268697005,
    "descripcion":"ADENOSARCOMA PRIMARIO DE CUERPO UTERINO"
  },
  {
    "codigo":449497006,
    "descripcion":"SARCOMA DE PERITONEO PÉLVICO"
  },
  {
    "codigo":416729007,
    "descripcion":"NEUTROPENIA CON SÍNDROME DE INMUNODEFICIENCIA ADQUIRIDA"
  },
  {
    "codigo":23513009,
    "descripcion":"INFECCIÓN POR HERPESVIRUS"
  },
  {
    "codigo":251054004,
    "descripcion":"DEFECTO EN LA PERFUSIÓN MIOCÁRDICA"
  },
  {
    "codigo":16276361000119109,
    "descripcion":"DEMENCIA VASCULAR SIN TRASTORNO DE CONDUCTA"
  },
  {
    "codigo":447662006,
    "descripcion":"AORTA DESCENDENTE A LA IZQUIERDA DE LA COLUMNA VERTEBRAL Y VENA CAVA INFERIOR A LA DERECHA"
  },
  {
    "codigo":283822006,
    "descripcion":"HERIDA POR MORDEDURA DE ANIMAL EN EXTREMIDAD INFERIOR"
  },
  {
    "codigo":19843006,
    "descripcion":"CICATRIZ HIPERTRÓFICA"
  },
  {
    "codigo":85379006,
    "descripcion":"HÁLITO DE CEBOLLA"
  },
  {
    "codigo":249219008,
    "descripcion":"DESGARRO GENITAL COMO CONSECUENCIA DEL PARTO"
  },
  {
    "codigo":247384001,
    "descripcion":"TRASTORNO DOLOROSO DE CAUSA NEUROLÓGICA"
  },
  {
    "codigo":312920004,
    "descripcion":"EDEMA MACULAR CISTOIDEO POSQUIRÚRGICO"
  },
  {
    "codigo":116312005,
    "descripcion":"HALLAZGO RELACIONADO CON EXTREMIDAD INFERIOR"
  },
  {
    "codigo":50776006,
    "descripcion":"ENCEFALOMIELITIS ALÉRGICA"
  },
  {
    "codigo":704301008,
    "descripcion":"CONFLICTO DE CREENCIAS CULTURALES"
  },
  {
    "codigo":702466002,
    "descripcion":"AMENORREA NORMOGONADOTRÓFICA"
  },
  {
    "codigo":473090004,
    "descripcion":"INFLAMACIÓN ASOCIADA CON IMPLANTE"
  },
  {
    "codigo":1259522005,
    "descripcion":"DEMENCIA DEBIDA A VARIANTE DE ENFERMEDAD DE CREUTZFELDT-JAKOB"
  },
  {
    "codigo":47106009,
    "descripcion":"PSEUDOEYACULACIÓN"
  },
  {
    "codigo":1290455002,
    "descripcion":"RADIOGRAFÍA DE DEDO DE PIE NORMAL"
  },
  {
    "codigo":897239006,
    "descripcion":"CURVATURA ANORMAL DE FALANGE DISTAL DE PRIMER DEDO DE PIE"
  },
  {
    "codigo":241879007,
    "descripcion":"EFECTO TÓXICO CAUSADO POR REMOVEDOR DE PINTURA"
  },
  {
    "codigo":733399008,
    "descripcion":"HERIDA PUNZANTE DE REGIÓN DEL HOMBRO CON CUERPO EXTRAÑO"
  },
  {
    "codigo":371116000,
    "descripcion":"HIDROCEFALIA POSHEMORRÁGICA"
  },
  {
    "codigo":274647009,
    "descripcion":"INQUIETUD Y AGITACIÓN"
  },
  {
    "codigo":240044003,
    "descripcion":"FIBROSITIS Y FASCITIS NODULAR"
  },
  {
    "codigo":372951009,
    "descripcion":"INFECCIÓN CAUSADA POR PENICILLIUM CYCLOPIUM"
  },
  {
    "codigo":403884005,
    "descripcion":"ENFERMEDAD DE BOWEN, PIGMENTADA"
  },
  {
    "codigo":76204004,
    "descripcion":"ERECCIÓN DEL CLÍTORIS DOLOROSA"
  },
  {
    "codigo":305580007,
    "descripcion":"BAJO ATENCIÓN DE AUXILIAR DE ENFERMERÍA"
  },
  {
    "codigo":860801002,
    "descripcion":"ERITEMA NUDOSO DEBIDO A INFECCIÓN FÚNGICA SISTÉMICA"
  },
  {
    "codigo":74369005,
    "descripcion":"ABORTO ESPONTÁNEO CON PERFORACIÓN DEL CUELLO DEL ÚTERO"
  },
  {
    "codigo":762497007,
    "descripcion":"DESNUTRICIÓN AGUDA EN LA INFANCIA"
  },
  {
    "codigo":269142003,
    "descripcion":"RUPTURA DEL LIGAMENTO CORACOACROMIAL"
  },
  {
    "codigo":301910004,
    "descripcion":"HALLAZGO RELACIONADO CON LA SENSIBILIDAD OCULAR"
  },
  {
    "codigo":6998003,
    "descripcion":"HIPOADUCCIÓN DE LAS CUERDAS VOCALES"
  },
  {
    "codigo":290355007,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR CIMETIDINA"
  },
  {
    "codigo":236374007,
    "descripcion":"NEFRITIS INTERSTICIAL INFECCIOSA CRÓNICA"
  },
  {
    "codigo":365611000,
    "descripcion":"NIVEL DE HEMOGLOBINA CORPUSCULAR MEDIA - HALLAZGO"
  },
  {
    "codigo":201771002,
    "descripcion":"ARTRITIS REUMATOIDE DE LA ARTICULACIÓN DE LA MUÑECA"
  },
  {
    "codigo":234539005,
    "descripcion":"DEFICIENCIA DE CADENA PESADA DE INMUNOGLOBULINA"
  },
  {
    "codigo":298240000,
    "descripcion":"ARTICULACIÓN SACROILÍACA RÍGIDA"
  },
  {
    "codigo":396544001,
    "descripcion":"DEHISCENCIA DE HERIDA DE CESÁREA"
  },
  {
    "codigo":724224007,
    "descripcion":"SÍNDROME DE QUERATODERMIA PALMOPLANTAR CON CLINODACTILIA"
  },
  {
    "codigo":722389002,
    "descripcion":"SÍNDROME CONGÉNITO DE PARÁLISIS FACIAL HEREDITARIA CON PÉRDIDA DE AUDICIÓN VARIABLE"
  },
  {
    "codigo":1493002,
    "descripcion":"ENDOFTALMITIS AGUDA"
  },
  {
    "codigo":10626391000119107,
    "descripcion":"CARBUNCO DE PULGAR DE MANO IZQUIERDA"
  },
  {
    "codigo":296405008,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE ACETILCISTEÍNA"
  },
  {
    "codigo":294570004,
    "descripcion":"ALERGIA A SULFALOXATO DE CALCIO"
  },
  {
    "codigo":65194006,
    "descripcion":"CEGUERA NOCTURNA"
  },
  {
    "codigo":425642008,
    "descripcion":"MONOPLEJÍA DEL MIEMBRO INFERIOR DOMINANTE COMO EFECTO TARDÍO DE ACCIDENTE CEREBROVASCULAR"
  },
  {
    "codigo":718719001,
    "descripcion":"SÍNDROME DE LISENCEFALIA TIPO 3 FAMILIAR CON SECUENCIA DE ACINESIA FETAL"
  },
  {
    "codigo":292735002,
    "descripcion":"REACCIÓN ADVERSA A ANTÍDOTO DE QUEMADURA POR ÁCIDO FLUORHÍDRICO"
  },
  {
    "codigo":1144703005,
    "descripcion":"APLASIA DE DEDO GORDO"
  },
  {
    "codigo":423807009,
    "descripcion":"LEIOMIOSARCOMA PRIMARIO"
  },
  {
    "codigo":94292003,
    "descripcion":"NEOPLASIA MALIGNA SECUNDARIA DEL OJO"
  },
  {
    "codigo":28756003,
    "descripcion":"FÍSTULA GASTROCÓLICA"
  },
  {
    "codigo":127060006,
    "descripcion":"ANEMIA HEMOLÍTICA INMUNITARIA MEDICAMENTOSA, TIPO HAPTENO"
  },
  {
    "codigo":878889000,
    "descripcion":"HIPERPIGMENTACIÓN CRIBIFORME Y ZOSTERIFORME PROGRESIVA"
  },
  {
    "codigo":289065003,
    "descripcion":"DIFICULTAD PARA UTILIZAR CUCHARA PARA ALIMENTARSE"
  },
  {
    "codigo":92457007,
    "descripcion":"NEOPLASIA BENIGNA DE LA ENCÍA SUPERIOR"
  },
  {
    "codigo":254462001,
    "descripcion":"CARCINOMA DE LA GLÁNDULA PARÓTIDA"
  },
  {
    "codigo":713214009,
    "descripcion":"PERIODONTITIS DEBIDA A TRAUMATISMO OCLUSAL"
  },
  {
    "codigo":188926009,
    "descripcion":"NEOPLASIA BENIGNA DE VÉRTEBRA DORSAL"
  },
  {
    "codigo":711379004,
    "descripcion":"ENFERMEDAD INTERSTICIAL PULMONAR DEBIDA A ENFERMEDAD DEL TEJIDO CONJUNTIVO"
  },
  {
    "codigo":56019007,
    "descripcion":"ENFERMEDAD SISTÉMICA"
  },
  {
    "codigo":87691000119105,
    "descripcion":"ESTADO: MEDIDAS DE COMODIDAD SOLAMENTE"
  },
  {
    "codigo":187091009,
    "descripcion":"CRIPTOCOCOSIS SISTÉMICA"
  },
  {
    "codigo":285395009,
    "descripcion":"DISTENSIÓN DE MÚSCULO DE LA PANTORRILLA"
  },
  {
    "codigo":11857701000119100,
    "descripcion":"RUPTURA DE TENDÓN DE AQUILES IZQUIERDO"
  },
  {
    "codigo":314493000,
    "descripcion":"UVEÍTIS POSQUIRÚRGICA"
  },
  {
    "codigo":609405001,
    "descripcion":"CONDICIÓN DE HIPERSENSIBILIDAD NO ALÉRGICA"
  },
  {
    "codigo":283560008,
    "descripcion":"HERIDA DE PERDIGÓN EN HOMBRO"
  },
  {
    "codigo":1363069003,
    "descripcion":"METABOLIZADOR POBRE DE FAMILIA 2 SUBFAMILIA C MIEMBRO 9 *6\/*8 DE CITOCROMO P450"
  },
  {
    "codigo":306981000119101,
    "descripcion":"DERRAME ARTICULAR DE LA REGIÓN DEL HOMBRO DERECHO"
  },
  {
    "codigo":15953701000119101,
    "descripcion":"ABSCESO NO PUERPERAL DE ARÉOLA DERECHA"
  },
  {
    "codigo":54184008,
    "descripcion":"DEGENERACIÓN RETINIANA RETICULAR SENIL"
  },
  {
    "codigo":83282002,
    "descripcion":"ENFERMEDAD RELACIONADA CON EL MEDIO NATURAL"
  },
  {
    "codigo":310823005,
    "descripcion":"INCAPAZ DE DEDUCIR EL SIGNIFICADO"
  },
  {
    "codigo":278055006,
    "descripcion":"TUMOR MALIGNO DE TESTÍCULO DE CÉLULAS DE LEYDIG"
  },
  {
    "codigo":1162791006,
    "descripcion":"ISOENZIMA HEPÁTICA DE FOSFATASA ALCALINA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1259260002,
    "descripcion":"CARCINOMA MUCINOSO ECRINO PRIMARIO DE PIEL"
  },
  {
    "codigo":866044006,
    "descripcion":"MICOSIS DEBIDA A INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":276220007,
    "descripcion":"SÍNDROME DE FOVILLE"
  },
  {
    "codigo":472828007,
    "descripcion":"TRASTORNO DE VÁLVULA AURICULOVENTRICULAR (MORFOLÓGICAMENTE NO MITRAL NI TRICÚSPIDE)"
  },
  {
    "codigo":733137002,
    "descripcion":"ESTADIO 1 DE INSUFICIENCIA RENAL AGUDA"
  },
  {
    "codigo":700369004,
    "descripcion":"ANOMALÍA VASCULAR CONGÉNITA DE PÁRPADO INFERIOR"
  },
  {
    "codigo":208849006,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA EXPUESTA DE LA ARTICULACIÓN RADIOCARPIANA"
  },
  {
    "codigo":698534001,
    "descripcion":"REQUIERE RETENEDOR ORTODÓNCICO SUPERIOR"
  },
  {
    "codigo":272550003,
    "descripcion":"SENTADO A HORCAJADAS"
  },
  {
    "codigo":16009151000119103,
    "descripcion":"DISPLASIA CONGÉNITA DE AMBAS EXTREMIDADES SUPERIORES"
  },
  {
    "codigo":239782006,
    "descripcion":"ARTRITIS POR INFECCIÓN PARASITARIA"
  },
  {
    "codigo":10406007,
    "descripcion":"SÍNDROME DE LESCH - NYHAN"
  },
  {
    "codigo":205179000,
    "descripcion":"AGENESIA DE CÚBITO"
  },
  {
    "codigo":403622009,
    "descripcion":"PSEUDOLINFOMA DE LINFOCITOS B CAUSADO POR FÁRMACO"
  },
  {
    "codigo":74107003,
    "descripcion":"ACROMEGALIA"
  },
  {
    "codigo":10684351000119104,
    "descripcion":"NÓDULO DEL TEJIDO CELULAR SUBCUTÁNEO DE EXTREMIDAD SUPERIOR DERECHA"
  },
  {
    "codigo":72272002,
    "descripcion":"MASTOCITOSIS BENIGNA"
  },
  {
    "codigo":1055312006,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA A LA ALTURA DE CODO IZQUIERDO"
  },
  {
    "codigo":203344007,
    "descripcion":"ENFERMEDAD DE PAGET DE TIBIA"
  },
  {
    "codigo":236112007,
    "descripcion":"NECROSIS DE ANASTOMOSIS GÁSTRICA"
  },
  {
    "codigo":301648007,
    "descripcion":"DIFICULTAD PARA SENTARSE Y LEVANTARSE DE UNA SILLA"
  },
  {
    "codigo":299813002,
    "descripcion":"REFLEJO DE PARPADEO AUSENTE"
  },
  {
    "codigo":70437005,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA REGIÓN INTERESCAPULAR"
  },
  {
    "codigo":365349005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA MANEJAR UN AUTO"
  },
  {
    "codigo":267045008,
    "descripcion":"SÍNTOMA GASTROINTESTINAL"
  },
  {
    "codigo":232442001,
    "descripcion":"PARÁLISIS CONGÉNITA DE ABDUCTOR DE LA LARINGE"
  },
  {
    "codigo":398117008,
    "descripcion":"LESIÓN POR CAÍDA"
  },
  {
    "codigo":363514001,
    "descripcion":"NEOPLASIA MALIGNA DE ÓRGANO GENITAL FEMENINO"
  },
  {
    "codigo":68602002,
    "descripcion":"FIBROSIS ENDOMIOCÁRDICA PRIMARIA (MIOCARDIOPATÍA)"
  },
  {
    "codigo":1073241000119102,
    "descripcion":"ARTRITIS DE CODO DERECHO CAUSADA POR BACTERIAS"
  },
  {
    "codigo":297978007,
    "descripcion":"HALLAZGO RELACIONADO CON LA SUDORACIÓN"
  },
  {
    "codigo":230607004,
    "descripcion":"NEUROPATÍA PROVOCADA POR SUSTANCIA QUÍMICA"
  },
  {
    "codigo":722127006,
    "descripcion":"DISPLASIA DE PACMAN"
  },
  {
    "codigo":66767006,
    "descripcion":"ÚLCERA DUODENAL AGUDA CON HEMORRAGIA PERO SIN OBSTRUCCIÓN"
  },
  {
    "codigo":165071007,
    "descripcion":"REGISTRO DE TEMPERATURA: POSIBLE OVULACIÓN"
  },
  {
    "codigo":359844001,
    "descripcion":"ABSCESO PIÓGENO INFRATENTORIAL EXTRADURAL"
  },
  {
    "codigo":392612009,
    "descripcion":"TINCIÓN DE CÓRNEA CON FLUORESCEÍNA"
  },
  {
    "codigo":1144441002,
    "descripcion":"APLASIA DE UNIDAD UNGUEAL"
  },
  {
    "codigo":292473004,
    "descripcion":"REACCIÓN ADVERSA AL ECOTIOPATO"
  },
  {
    "codigo":94030000,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA PIEL DE LA RODILLA"
  },
  {
    "codigo":95865009,
    "descripcion":"EXPOSICIÓN A TEMPERATURAS EXTREMAS EN EL AMBIENTE LABORAL"
  },
  {
    "codigo":290638000,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR DACTINOMICINA"
  },
  {
    "codigo":421710003,
    "descripcion":"CANDIDIASIS ORAL ASOCIADA CON SIDA (SÍNDROME DE INMUNODEFICIENCIA ADQUIRIDA)"
  },
  {
    "codigo":126798006,
    "descripcion":"NEOPLASIA DE GLÁNDULA SALIVAL MENOR"
  },
  {
    "codigo":288803000,
    "descripcion":"NO EMPLEA EL HUMOR"
  },
  {
    "codigo":12269811000119104,
    "descripcion":"QUEMADURA QUÍMICA DE ESPESOR TOTAL DE ANTEBRAZO IZQUIERDO"
  },
  {
    "codigo":418040002,
    "descripcion":"ANGIOMA DE CÉLULAS LITORALES"
  },
  {
    "codigo":876792003,
    "descripcion":"REACCIÓN ADVERSA A AMOXICILINA Y\/O ÁCIDO CLAVULÁNICO"
  },
  {
    "codigo":450808003,
    "descripcion":"BATROCEFALIA"
  },
  {
    "codigo":416205001,
    "descripcion":"INFECCIÓN CAUSADA POR BARTONELLA PEROMYSCI"
  },
  {
    "codigo":285133008,
    "descripcion":"HÁBITO DE RETORCERSE EL PELO"
  },
  {
    "codigo":447138000,
    "descripcion":"FRACTURA NO EXPUESTA DE HUESO DEL TARSO"
  },
  {
    "codigo":709282004,
    "descripcion":"DEFICIENCIA DE AMINOACILASA 1"
  },
  {
    "codigo":283298007,
    "descripcion":"ASTILLA DE MADERA EN ESPALDA"
  },
  {
    "codigo":250530008,
    "descripcion":"LÍQUIDO SINOVIAL - HALLAZGO"
  },
  {
    "codigo":281463000,
    "descripcion":"ARQUEAMIENTO DE PLACA"
  },
  {
    "codigo":314231002,
    "descripcion":"CHAPERONA PRESENTE"
  },
  {
    "codigo":119181000119104,
    "descripcion":"HIPOTIROXINEMIA DEL PREMATURO"
  },
  {
    "codigo":52087004,
    "descripcion":"LESIÓN TRAUMÁTICA DE RECTO SIN HERIDA ABIERTA HACIA CAVIDAD ABDOMINAL"
  },
  {
    "codigo":248695004,
    "descripcion":"CLIC DE APERTURA DE VÁLVULA PROTÉSICA"
  },
  {
    "codigo":1297271003,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE DEDO MEÑIQUE"
  },
  {
    "codigo":609143007,
    "descripcion":"SÍNDROME DE APÓFISIS ESTILOIDES ELONGADA"
  },
  {
    "codigo":1231735008,
    "descripcion":"MASTOCITOSIS MEDULAR AISLADA"
  },
  {
    "codigo":84855007,
    "descripcion":"DERMATITIS VESICULAR ACANTOLÍTICA"
  },
  {
    "codigo":707447008,
    "descripcion":"EXACERBACIÓN DE ASMA SEVERA PERSISTENTE"
  },
  {
    "codigo":838519006,
    "descripcion":"SOBREDOSIS DE METILENDIOXIMETANFETAMINA"
  },
  {
    "codigo":83020004,
    "descripcion":"MOTILIDAD GÁSTRICA AUMENTADA"
  },
  {
    "codigo":246860005,
    "descripcion":"ORIFICIO LAGRIMAL SUPERIOR - HALLAZGO"
  },
  {
    "codigo":17484005,
    "descripcion":"SACRALIZACIÓN DE VÉRTEBRA LUMBAR"
  },
  {
    "codigo":771148008,
    "descripcion":"SÍNDROME DE MICROFTALMÍA COLOBOMATOSA, MICROCEFALIA, DISCAPACIDAD INTELECTUAL Y BAJA ESTATURA LIGADO AL CROMOSOMA X"
  },
  {
    "codigo":212257001,
    "descripcion":"CONTUSIÓN, NERVIO MEDIANO, RAMA MOTRIZ"
  },
  {
    "codigo":15649002,
    "descripcion":"INTOXICACIÓN CAUSADA POR ANTICOLINESTERASA"
  },
  {
    "codigo":277793006,
    "descripcion":"ERITEMA ANULAR FAMILIAR"
  },
  {
    "codigo":1258998001,
    "descripcion":"LACTANCIA MATERNA PARCIAL"
  },
  {
    "codigo":439798002,
    "descripcion":"FÍSTULA ARTERIOVENOSA BRAQUIOBASÍLICA TRANSPUESTA"
  },
  {
    "codigo":767478003,
    "descripcion":"ALERGIA A TIAMINA"
  },
  {
    "codigo":338471000119103,
    "descripcion":"CONJUNTIVITIS PSEUDOMEMBRANOSA DE OJO IZQUIERDO"
  },
  {
    "codigo":210422006,
    "descripcion":"LESIÓN POR DESOLLAMIENTO DE NALGA"
  },
  {
    "codigo":110283003,
    "descripcion":"EMBOLIA MEDICAMENTOSA"
  },
  {
    "codigo":700107006,
    "descripcion":"SÍNDROME DE BARTTER, TIPO PRENATAL 1"
  },
  {
    "codigo":208587007,
    "descripcion":"FRACTURA EXPUESTA DE EPÍFISIS DISTAL DE FÉMUR"
  },
  {
    "codigo":1075751000119105,
    "descripcion":"ATROFIA MUSCULAR DE PIE DERECHO"
  },
  {
    "codigo":75680005,
    "descripcion":"TENDINITIS DEL PSOAS"
  },
  {
    "codigo":698272007,
    "descripcion":"SÍNDROME DE INTERVALO QT CORTO"
  },
  {
    "codigo":403360009,
    "descripcion":"CICATRIZ ATRÓFICA POR ACNÉ"
  },
  {
    "codigo":73845006,
    "descripcion":"IDENTIFICACIÓN DE UN CUERPO POR LAS HUELLAS DIGITALES"
  },
  {
    "codigo":237685006,
    "descripcion":"HIPOPITUITARISMO PARCIAL"
  },
  {
    "codigo":203082005,
    "descripcion":"FIBROMIALGIA"
  },
  {
    "codigo":1217055000,
    "descripcion":"DEGENERACIÓN DE GLÁNDULA SUPRARRENAL"
  },
  {
    "codigo":301386009,
    "descripcion":"DOLOR A LA PALPACIÓN EN ESTRUCTURA CORPORAL"
  },
  {
    "codigo":102943000,
    "descripcion":"CAMBIO DE PERSONALIDAD"
  },
  {
    "codigo":11780801000119104,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO ESQUELÉTICO DE HOMBRO DERECHO"
  },
  {
    "codigo":1153354008,
    "descripcion":"LINFOMA MALIGNO DE DUODENO"
  },
  {
    "codigo":299551007,
    "descripcion":"ARTICULACIÓN SUBASTRAGALINA INESTABLE"
  },
  {
    "codigo":365087008,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA SALUDAR"
  },
  {
    "codigo":4639008,
    "descripcion":"MUERMO"
  },
  {
    "codigo":33737001,
    "descripcion":"FRACTURA DE COSTILLA"
  },
  {
    "codigo":263113001,
    "descripcion":"FRACTURA-SUBLUXACIÓN DE LA ARTICULACIÓN DE LA RODILLA"
  },
  {
    "codigo":295881002,
    "descripcion":"SOBREDOSIS DE PROTRIPTILINA"
  },
  {
    "codigo":230345006,
    "descripcion":"MIOCLONÍA POSENCEFALÍTICA"
  },
  {
    "codigo":15712961000119108,
    "descripcion":"INFARTO AGUDO DE PARED ANTEROSEPTAL DE MIOCARDIO CON ELEVACIÓN DEL SEGMENTO ST"
  },
  {
    "codigo":195742007,
    "descripcion":"INFECCIÓN AGUDA DEL APARATO RESPIRATORIO INFERIOR"
  },
  {
    "codigo":95603002,
    "descripcion":"SUPRESIÓN DE LA SECRECIÓN DE LECHE"
  },
  {
    "codigo":783731008,
    "descripcion":"DISPLASIA FIBROMUSCULAR DE PARED DE ARTERIA CARÓTIDA"
  },
  {
    "codigo":192072002,
    "descripcion":"ALTERACIÓN ORGÁNICA DE LA MEMORIA"
  },
  {
    "codigo":290376002,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR LANSOPRAZOL"
  },
  {
    "codigo":93768004,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE CONDUCTO CRANEOFARÍNGEO"
  },
  {
    "codigo":190237002,
    "descripcion":"BOCIO UNINODULAR NO TÓXICO"
  },
  {
    "codigo":124701005,
    "descripcion":"DEFICIENCIA DE SUCCINATO - COA LIGASA (FORMADOR DE ADP)"
  },
  {
    "codigo":59165007,
    "descripcion":"ESCLERITIS REUMATOIDE"
  },
  {
    "codigo":90098000,
    "descripcion":"INFECCIÓN CAUSADA POR POLYMORPHUS"
  },
  {
    "codigo":1204210003,
    "descripcion":"INFLAMACIÓN DE VÁLVULA AÓRTICA"
  },
  {
    "codigo":286706005,
    "descripcion":"RASGO DE LA PERSONALIDAD: TOLERANCIA AL ABURRIMIENTO - HALLAZGO"
  },
  {
    "codigo":448711001,
    "descripcion":"SARCOMA DE DORSO"
  },
  {
    "codigo":252103004,
    "descripcion":"SUSCEPTIBILIDAD PARA TUBERCULOSIS"
  },
  {
    "codigo":284871005,
    "descripcion":"INCAPAZ DE CORTARSE LAS UÑAS"
  },
  {
    "codigo":219335006,
    "descripcion":"LESIÓN POR PISTOLA, CON PROPÓSITO DESCONOCIDO"
  },
  {
    "codigo":11809781000119105,
    "descripcion":"HERIDA DE PIERNA IZQUIERDA DEBIDA A PICADURA DE INSECTO NO VENENOSO"
  },
  {
    "codigo":283036000,
    "descripcion":"LESIÓN SUPERFICIAL DE LA PALMA DE LA MANO"
  },
  {
    "codigo":340981000119106,
    "descripcion":"CORIORRETINITIS DISEMINADA DE OJO IZQUIERDO"
  },
  {
    "codigo":10636431000119100,
    "descripcion":"ÚLCERA CRÓNICA DE PIE DERECHO"
  },
  {
    "codigo":53660007,
    "descripcion":"ESTOMATITIS VESICULAR POR VIRUS NEW JERSEY"
  },
  {
    "codigo":1003932006,
    "descripcion":"DELECIÓN PROXIMAL DEL CROMOSOMA 21"
  },
  {
    "codigo":248433000,
    "descripcion":"FASE DE MESETA DE LA FIEBRE"
  },
  {
    "codigo":1078261000119107,
    "descripcion":"AUSENCIA CONGÉNITA DE MANO DERECHA"
  },
  {
    "codigo":19057007,
    "descripcion":"ESTADO ANGINOSO"
  },
  {
    "codigo":312134000,
    "descripcion":"INFECCIÓN VIRAL DE LA VÍA RESPIRATORIA INFERIOR"
  },
  {
    "codigo":1264241008,
    "descripcion":"DAÑO DE TEJIDO PERIURETRAL POSTERIOR A EMBARAZO ECTÓPICO"
  },
  {
    "codigo":1196870003,
    "descripcion":"DEFECTO DE GEN DE SUBUNIDAD ESTRUCTURAL DE COMPLEJO II DE CADENA RESPIRATORIA MITOCONDRIAL"
  },
  {
    "codigo":246598004,
    "descripcion":"SIGNO DE ELONGACIÓN CIÁTICA"
  },
  {
    "codigo":17222009,
    "descripcion":"FRACTURA NO EXPUESTA DE EXTREMO DISTAL DE RADIO"
  },
  {
    "codigo":111856000,
    "descripcion":"OTITIS EXTERNA POR VIRUS DEL HERPES SIMPLE"
  },
  {
    "codigo":210160008,
    "descripcion":"LESIÓN ABIERTA DE PÁNCREAS"
  },
  {
    "codigo":208325003,
    "descripcion":"FRACTURA NO EXPUESTA DE APÓFISIS ESTILOIDES DE RADIO"
  },
  {
    "codigo":110021005,
    "descripcion":"FRACTURA NO EXPUESTA DE CRESTA ALVEOLAR DE MAXILAR SUPERIOR"
  },
  {
    "codigo":403098001,
    "descripcion":"ONICOMICOSIS CAUSADA POR PSEUDEUROTIUM OVALE"
  },
  {
    "codigo":698010001,
    "descripcion":"LEUCOPLASIA ORAL VERRUGOSA PROLIFERATIVA"
  },
  {
    "codigo":75418003,
    "descripcion":"INFECCIÓN CAUSADA POR PLATYNOSOMUM FASTOSUM"
  },
  {
    "codigo":206490007,
    "descripcion":"HIPONATREMIA NEONATAL TRANSITORIA"
  },
  {
    "codigo":73583000,
    "descripcion":"EPICONDILITIS DE HÚMERO"
  },
  {
    "codigo":1255066009,
    "descripcion":"PERCEPCIÓN ALTERADA DEBIDA A SÍNDROME DE ABSTINENCIA DE ALCOHOL"
  },
  {
    "codigo":302959003,
    "descripcion":"DUPLICACIÓN DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":366660004,
    "descripcion":"PATRÓN DE DISTRIBUCIÓN DEL CRECIMIENTO DEL PELO - HALLAZGO"
  },
  {
    "codigo":233753001,
    "descripcion":"BERILIOSIS SUBAGUDA"
  },
  {
    "codigo":202820009,
    "descripcion":"INESTABILIDAD ATLANTOAXOIDEA"
  },
  {
    "codigo":37145001,
    "descripcion":"DISFUNCIÓN DEL SISTEMA NERVIOSO CENTRAL EN EL RECIÉN NACIDO"
  },
  {
    "codigo":6212009,
    "descripcion":"ABSCESO SUBFRÉNICO POSTOPERATORIO"
  },
  {
    "codigo":299289003,
    "descripcion":"SIN AMPLITUD DE ROTACIÓN INTERNA ACTIVA DE ARTICULACIÓN DE CADERA"
  },
  {
    "codigo":69913007,
    "descripcion":"EFECTO TARDÍO DE UNA LESIÓN TRAUMÁTICA TORÁCICA INTERNA"
  },
  {
    "codigo":200985008,
    "descripcion":"PARAPSORIASIS VARIOLIFORME"
  },
  {
    "codigo":364825009,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA CORTAR LA COMIDA"
  },
  {
    "codigo":788974002,
    "descripcion":"BORRELIOSIS DE LYME CUTÁNEA TARDÍA"
  },
  {
    "codigo":166382003,
    "descripcion":"NIVELES DE GONADOTROFINAS POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":168217008,
    "descripcion":"LEVADURA AISLADA EN ESPÉCIMEN"
  },
  {
    "codigo":723438005,
    "descripcion":"DISPOSITIVO DE ASISTENCIA ENTRE VENTRÍCULO IZQUIERDO Y AORTA IN SITU"
  },
  {
    "codigo":231918006,
    "descripcion":"CALCOSIS DE LA CÓRNEA"
  },
  {
    "codigo":362990007,
    "descripcion":"COMPLICACIÓN EN EL SISTEMA AUDITIVO POR UN PROCEDIMIENTO"
  },
  {
    "codigo":721603005,
    "descripcion":"CORIOCARCINOMA PRIMARIO DE TESTÍCULO"
  },
  {
    "codigo":262851008,
    "descripcion":"SECCIÓN DUODENAL"
  },
  {
    "codigo":293784001,
    "descripcion":"ALERGIA A CRISANTASPASA"
  },
  {
    "codigo":785304005,
    "descripcion":"PARAPLEJÍA ESPÁSTICA AUTOSÓMICA RECESIVA TIPO 24"
  },
  {
    "codigo":291949003,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR QUINIDINA"
  },
  {
    "codigo":95341004,
    "descripcion":"HIPERTROFIA DE UÑA DE DEDO DE PIE"
  },
  {
    "codigo":717933005,
    "descripcion":"DELGADEZ SEVERA EN LA VIDA ADULTA"
  },
  {
    "codigo":62573007,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE LA MANO, CON INFECCIÓN"
  },
  {
    "codigo":60738003,
    "descripcion":"MIOPATÍA SECUNDARIA"
  },
  {
    "codigo":343491000119109,
    "descripcion":"DESPRENDIMIENTO SEROSO DE COROIDES DE AMBOS OJOS"
  },
  {
    "codigo":879938005,
    "descripcion":"TRASTORNO DEL DESARROLLO SEXUAL 46,XY POR EXPOSICIÓN A QUÍMICO AMBIENTAL"
  },
  {
    "codigo":716098006,
    "descripcion":"ARQUEAMIENTO CONGÉNITO DE HUESO LARGO"
  },
  {
    "codigo":27970007,
    "descripcion":"QUISTE MESENTÉRICO"
  },
  {
    "codigo":1142082008,
    "descripcion":"TAQUICARDIA ECTÓPICA IDIOPÁTICA DE LA UNIÓN AURICULOVENTRICULAR"
  },
  {
    "codigo":124439001,
    "descripcion":"DEFICIENCIA DE FRUCTOSA - BIFOSFATASA"
  },
  {
    "codigo":1240386008,
    "descripcion":"TRASTORNO NEONATAL PRECOZ DEBIDO A PLACENTITIS"
  },
  {
    "codigo":26135000,
    "descripcion":"ENCEFALITIS SIFILÍTICA"
  },
  {
    "codigo":58903006,
    "descripcion":"PRESENTACIÓN PODÁLICA, UN PIE"
  },
  {
    "codigo":253676001,
    "descripcion":"ESTENOSIS AÓRTICA POSDUCTAL"
  },
  {
    "codigo":286444002,
    "descripcion":"NO OBTIENE ALIMENTO"
  },
  {
    "codigo":284609005,
    "descripcion":"CAPAZ DE CONTROLAR LA AGRESIÓN"
  },
  {
    "codigo":415681007,
    "descripcion":"EL MARGEN QUIRÚRGICO PROXIMAL ES EL MARGEN NO AFECTADO MÁS CERCANO A LA NEOPLASIA MALIGNA"
  },
  {
    "codigo":86166000,
    "descripcion":"ALOPECIA UNIVERSAL"
  },
  {
    "codigo":315542000,
    "descripcion":"NACIDO EN LOS PAÍSES BAJOS"
  },
  {
    "codigo":250006002,
    "descripcion":"RETOMA LA MARCHA INTERRUMPIDA ESPONTÁNEAMENTE"
  },
  {
    "codigo":118934005,
    "descripcion":"TRASTORNO DE LA CABEZA"
  },
  {
    "codigo":282774006,
    "descripcion":"LESIÓN DE ESPINILLA"
  },
  {
    "codigo":446614008,
    "descripcion":"PARÁSITO AISLADO PERO SIN IDENTIFICACIÓN POSTERIOR"
  },
  {
    "codigo":248171000,
    "descripcion":"PERFIL FACIAL CONVEXO"
  },
  {
    "codigo":1263979002,
    "descripcion":"SEPSIS POSTERIOR A EMBARAZO MOLAR"
  },
  {
    "codigo":706923002,
    "descripcion":"FIBRILACIÓN AURICULAR PERSISTENTE DE LARGA DATA"
  },
  {
    "codigo":444779004,
    "descripcion":"HALLAZGO DE HELICOBACTER PYLORI EN PRUEBA DE MATERIA FECAL"
  },
  {
    "codigo":1231211004,
    "descripcion":"ESTRABISMO MECÁNICO DEBIDO A TRASTORNO DE POLEA ORBITARIA"
  },
  {
    "codigo":705088004,
    "descripcion":"FRACTURA EXPUESTA DE SEGUNDA FALANGE DE SEGUNDO A QUINTO DEDOS DEL PIE"
  },
  {
    "codigo":5731000175109,
    "descripcion":"INCAPAZ DE COSTEAR BALANZA"
  },
  {
    "codigo":770624005,
    "descripcion":"EPILEPSIA PARCIAL BENIGNA DE LA LACTANCIA CON CONVULSIONES PARCIALES COMPLEJAS"
  },
  {
    "codigo":408341000,
    "descripcion":"ATENDIDO POR ENFERMERA ESPECIALISTA EN VIABILIDAD TISULAR"
  },
  {
    "codigo":703253007,
    "descripcion":"INFARTO AGUDO DE PARED INFERIOR DE MIOCARDIO CON ELEVACIÓN DEL SEGMENTO ST Y COMPROMISO DE VENTRÍCULO DERECHO"
  },
  {
    "codigo":275434003,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DURANTE EL PUERPERIO"
  },
  {
    "codigo":13290008,
    "descripcion":"ANEURISMA DE ARTERIA ILÍACA"
  },
  {
    "codigo":406506008,
    "descripcion":"TRASTORNO DE HIPERACTIVIDAD CON DÉFICIT DE ATENCIÓN"
  },
  {
    "codigo":439274008,
    "descripcion":"DEFICIENCIA HEREDITARIA DE PROTEÍNA C"
  },
  {
    "codigo":44223004,
    "descripcion":"RUPTURA PREMATURA DE MEMBRANAS"
  },
  {
    "codigo":208063004,
    "descripcion":"FRACTURA VERTEBRAL EXPUESTA CON LESIÓN COMPLETA DE MÉDULA ESPINAL LUMBAR"
  },
  {
    "codigo":109759006,
    "descripcion":"FRACTURA HORIZONTAL DEL TERCIO APICAL DE LA RAÍZ DENTAL"
  },
  {
    "codigo":76991007,
    "descripcion":"CONDUCTA ASOCIAL"
  },
  {
    "codigo":11455007,
    "descripcion":"LIPOIDOSIS"
  },
  {
    "codigo":240831009,
    "descripcion":"FILARIASIS DE TIMOR AGUDA"
  },
  {
    "codigo":370068001,
    "descripcion":"INVASIÓN TUMORAL EN GANGLIO LINFÁTICO MEDIASTÍNICO, CON EXTENSIÓN EXTRACAPSULAR"
  },
  {
    "codigo":238996003,
    "descripcion":"PUSTULODERMIA TÓXICA FARMACÓGENA"
  },
  {
    "codigo":271764004,
    "descripcion":"PLACA EN PIEL O MUCOSA"
  },
  {
    "codigo":206228006,
    "descripcion":"LESIÓN OBSTÉTRICA DEL PLEXO EN FORMA COMPLETA"
  },
  {
    "codigo":402836009,
    "descripcion":"ARAÑAS VASCULARES ASOCIADAS A EMBARAZO"
  },
  {
    "codigo":319531000119101,
    "descripcion":"ARTRITIS REACTIVA DE ARTICULACIÓN DE MANO IZQUIERDA"
  },
  {
    "codigo":1285737005,
    "descripcion":"CARCINOMA PRIMARIO DE CÉLULAS ESCAMOSAS DE PIEL DE PIE"
  },
  {
    "codigo":106089007,
    "descripcion":"HALLAZGO RELACIONADO CON EL METABOLISMO"
  },
  {
    "codigo":834127761000119108,
    "descripcion":"ESPONDILOARTRITIS AXIAL NO RADIOGRÁFICA DE REGIÓN CERVICAL"
  },
  {
    "codigo":300862005,
    "descripcion":"MASA DE UNA REGIÓN DEL CUERPO"
  },
  {
    "codigo":366398008,
    "descripcion":"REFLEJO CILIOESPINAL - HALLAZGO"
  },
  {
    "codigo":725011006,
    "descripcion":"DOLOR DE CUELLO CONCOMITANTE CON DÉFICIT NEUROLÓGICO POSTERIOR A LESIÓN TRAUMÁTICA CERVICAL POR LATIGAZO"
  },
  {
    "codigo":430099007,
    "descripcion":"RETRASO EN EL DESARROLLO DE LA MOTRICIDAD GRUESA"
  },
  {
    "codigo":1149160000,
    "descripcion":"NIVEL DE FATIGA DISMINUIDO"
  },
  {
    "codigo":69651009,
    "descripcion":"LINFANGITIS AGUDA DE FLANCO"
  },
  {
    "codigo":297192002,
    "descripcion":"FÍSTULA ESCROTAL"
  },
  {
    "codigo":40351000087106,
    "descripcion":"DISTENSIÓN DE TENDÓN DE MÚSCULO DE MITAD DERECHA DE PARED ANTERIOR DE TÓRAX"
  },
  {
    "codigo":299027008,
    "descripcion":"ARTICULACIÓN DE LA MUÑECA TIBIA AL TACTO"
  },
  {
    "codigo":42911000087107,
    "descripcion":"HERIDA DE EXTREMIDAD INFERIOR DERECHA POR MORDEDURA"
  },
  {
    "codigo":428264009,
    "descripcion":"MARCHA DOLOROSA"
  },
  {
    "codigo":15638571000119107,
    "descripcion":"BURSITIS PRERROTULIANA DE AMBAS RODILLAS"
  },
  {
    "codigo":295357002,
    "descripcion":"SOBREDOSIS INTENCIONAL DE FAMOTIDINA"
  },
  {
    "codigo":197053007,
    "descripcion":"INVAGINACIÓN RETRÓGRADA"
  },
  {
    "codigo":721341008,
    "descripcion":"HERIDA ABIERTA DE CUELLO POR MORDEDURA"
  },
  {
    "codigo":64146000,
    "descripcion":"DERMATOSIS PIGMENTARIA PROGRESIVA DE SCHAMBERG"
  },
  {
    "codigo":293522002,
    "descripcion":"REACCIÓN ADVERSA A FÁRMACO INHIBIDOR DE LA FOSFODIESTERASA"
  },
  {
    "codigo":31378006,
    "descripcion":"PROBLEMA CON PADRES ANCIANOS"
  },
  {
    "codigo":129682006,
    "descripcion":"HALLAZGO EN EL AMBIENTE PERSONAL"
  },
  {
    "codigo":95079000,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE PIEL DE HOMBRO"
  },
  {
    "codigo":62311004,
    "descripcion":"MANOSIDOSIS, TIPO I"
  },
  {
    "codigo":226151006,
    "descripcion":"DIETA RICA EN BETACAROTENO"
  },
  {
    "codigo":191548004,
    "descripcion":"EXACERBACIÓN AGUDA DE ESQUIZOFRENIA CATATÓNICA CRÓNICA"
  },
  {
    "codigo":60476005,
    "descripcion":"SOBREMORDIDA PROFUNDA"
  },
  {
    "codigo":289852006,
    "descripcion":"PERINEO NO ELÁSTICO"
  },
  {
    "codigo":93244008,
    "descripcion":"HIPOPLASIA CONGÉNITA DE HUESO BASIESFENOIDAL"
  },
  {
    "codigo":124177001,
    "descripcion":"DEFICIENCIA DE PIRROLINA-5-CARBOXILATO REDUCTASA"
  },
  {
    "codigo":417254001,
    "descripcion":"CRIPTOCOCOSIS OCULAR"
  },
  {
    "codigo":253414002,
    "descripcion":"DEFECTO SEPTAL AURICULOVENTRICULAR Y UNIÓN AURICULOVENTRICULAR COMÚN"
  },
  {
    "codigo":286182002,
    "descripcion":"NO PONE LA MESA"
  },
  {
    "codigo":87739003,
    "descripcion":"NO FUMADOR TOLERANTE"
  },
  {
    "codigo":22203006,
    "descripcion":"INFESTACIÓN CAUSADA POR DEMODEX FOLLICULORUM"
  },
  {
    "codigo":1085791000119105,
    "descripcion":"HEMORRAGIA RECTAL DEBIDA A ENFERMEDAD DE CROHN DE INTESTINO GRUESO"
  },
  {
    "codigo":249744001,
    "descripcion":"BRAZO GRANDE"
  },
  {
    "codigo":446352002,
    "descripcion":"QUERATOSIS SEBORREICA DE CUERO CABELLUDO"
  },
  {
    "codigo":1003408005,
    "descripcion":"DISTROFIA CORNEAL CONGÉNITA"
  },
  {
    "codigo":85904008,
    "descripcion":"FIEBRE PARATIFOIDEA"
  },
  {
    "codigo":1296485000,
    "descripcion":"HIPERTENSIÓN OCULAR BILATERAL DEBIDA A DESPRENDIMIENTO DE RETINA"
  },
  {
    "codigo":11790841000119101,
    "descripcion":"CONTUSIÓN DE MUSLO IZQUIERDO"
  },
  {
    "codigo":1362021005,
    "descripcion":"DEFICIENCIA CRÓNICA DE ESFINGOMIELINASA ÁCIDA NEUROVISCERAL"
  },
  {
    "codigo":16698000,
    "descripcion":"ABSCESO AGUDO DE LA MAMA"
  },
  {
    "codigo":770362001,
    "descripcion":"HEMORRAGIA DE CUERPO VÍTREO DEL OJO IZQUIERDO DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":213306005,
    "descripcion":"EMBOLIA GASEOSA DEBIDA A CIRUGÍA"
  },
  {
    "codigo":735759006,
    "descripcion":"DERMATITIS IRRITATIVA POR CONTACTO CAUSADA POR SUDOR"
  },
  {
    "codigo":309775007,
    "descripcion":"INSUFICIENCIA RESPIRATORIA LUEGO DE PROCEDIMIENTO"
  },
  {
    "codigo":1260047008,
    "descripcion":"TATUAJE DE MUCOSA DE LABIO INFERIOR"
  },
  {
    "codigo":702991007,
    "descripcion":"ENTEROCOCCUS DURANS O ENTEROCOCCUS HIRAE"
  },
  {
    "codigo":277007008,
    "descripcion":"ONDAS A Y B REDUCIDAS"
  },
  {
    "codigo":13028004,
    "descripcion":"FUNCIÓN ANORMAL DEL SISTEMA NERVIOSO"
  },
  {
    "codigo":111332007,
    "descripcion":"PSEUDOHERMAFRODITISMO MASCULINO"
  },
  {
    "codigo":439012009,
    "descripcion":"CATÉTER VENOSO CENTRAL TUNELIZADO IN SITU"
  },
  {
    "codigo":764857004,
    "descripcion":"SÍNDROME DE HEMIMELIA TIBIAL, POLISINDACTILIA Y PULGAR TRIFALÁNGICO"
  },
  {
    "codigo":240569007,
    "descripcion":"POLINEUROPATÍA SIFILÍTICA"
  },
  {
    "codigo":109497007,
    "descripcion":"MORDIDA EN CRUZ POSTERIOR INVERSA, DIENTES MÚLTIPLES"
  },
  {
    "codigo":11193009,
    "descripcion":"SABOR METÁLICO"
  },
  {
    "codigo":15723001000119109,
    "descripcion":"ARTROSIS SECUNDARIA DE AMBOS TOBILLOS"
  },
  {
    "codigo":40291001,
    "descripcion":"SÍNDROME DE MIETENS"
  },
  {
    "codigo":238734009,
    "descripcion":"TRASTORNO DEL CICLO DEL PELO"
  },
  {
    "codigo":7523003,
    "descripcion":"LESIÓN TRAUMÁTICA DE MUSLO"
  },
  {
    "codigo":1187171005,
    "descripcion":"TRASTORNO CONGÉNITO DE LA GLICOSILACIÓN SLC39A8"
  },
  {
    "codigo":1285475006,
    "descripcion":"NEOVASCULARIZACIÓN DE OJO"
  },
  {
    "codigo":366136002,
    "descripcion":"HALLAZGO EN LA RESONANCIA VOCAL"
  },
  {
    "codigo":235064008,
    "descripcion":"GOMA SIFILÍTICA DE LA CAVIDAD BUCAL"
  },
  {
    "codigo":890424009,
    "descripcion":"HIPERPLASIA CONGÉNITA SECUNDARIA BILATERAL DE PULMÓN"
  },
  {
    "codigo":298765002,
    "descripcion":"HALLAZGO RELACIONADO CON LA DISPOSICIÓN DE LA CLAVÍCULA"
  },
  {
    "codigo":397069003,
    "descripcion":"MICROGAMETOCITO PLASMODIAL EN ERITROCITO"
  },
  {
    "codigo":1281805007,
    "descripcion":"PIERCING EN OÍDO EXTERNO DERECHO"
  },
  {
    "codigo":724749007,
    "descripcion":"HIPERSOMNIA INDUCIDA POR EL COMPORTAMIENTO"
  },
  {
    "codigo":296930003,
    "descripcion":"SOBREDOSIS DE CUMARINA"
  },
  {
    "codigo":722914008,
    "descripcion":"APNEA NEONATAL CENTRAL"
  },
  {
    "codigo":198626009,
    "descripcion":"EMBARAZO MESENTÉRICO"
  },
  {
    "codigo":32951002,
    "descripcion":"FEMINIZACIÓN MASCULINA"
  },
  {
    "codigo":295095003,
    "descripcion":"ALERGIA A CICLANDELATO"
  },
  {
    "codigo":426167003,
    "descripcion":"MONOPLEJÍA DEL MIEMBRO INFERIOR QUE AFECTA AL LADO DOMINANTE"
  },
  {
    "codigo":183005,
    "descripcion":"PANCITOPENIA AUTOINMUNITARIA"
  },
  {
    "codigo":360631004,
    "descripcion":"DEFICIENCIA DE ESTERASA II (INESPECÍFICA) DE COLINA"
  },
  {
    "codigo":196791007,
    "descripcion":"CÓLICO APENDICULAR"
  },
  {
    "codigo":34786008,
    "descripcion":"PROCTITIS POR CANDIDA"
  },
  {
    "codigo":264162009,
    "descripcion":"BANDA MUSCULAR POSTEROMEDIAL"
  },
  {
    "codigo":293260005,
    "descripcion":"REACCIÓN ADVERSA AL CLOMIFENO"
  },
  {
    "codigo":31116006,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE TOBILLO CON INFECCIÓN"
  },
  {
    "codigo":678701000119106,
    "descripcion":"VISIÓN EN TÚNEL DE AMBOS OJOS"
  },
  {
    "codigo":422497000,
    "descripcion":"VISIÓN A DISTANCIA 20\/20"
  },
  {
    "codigo":782945001,
    "descripcion":"SÍNDROME DE OFTALMOPLEJÍA, DISCAPACIDAD INTELECTUAL Y LENGUA ESCROTAL"
  },
  {
    "codigo":194956009,
    "descripcion":"MIOCARDITIS SÉPTICA - NEUMOCÓCICA"
  },
  {
    "codigo":11793351000119101,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN DE DEDO DE PIE DERECHO"
  },
  {
    "codigo":225889005,
    "descripcion":"NO APTO FÍSICAMENTE PARA VOLVER AL TRABAJO"
  },
  {
    "codigo":92982000,
    "descripcion":"HÚMERO CURVADO CONGÉNITO"
  },
  {
    "codigo":846646001,
    "descripcion":"LIPOGRANULOMA DE PIEL CAUSADO POR ACEITE MINERAL"
  },
  {
    "codigo":1010486001,
    "descripcion":"ESCLEROSIS DE EPÍFISIS DE FALANGE PROXIMAL DE DEDO MAYOR CON RADIOPACIDAD AUMENTADA"
  },
  {
    "codigo":715574002,
    "descripcion":"SÍNDROME DE ATROFIA CORTICAL POSTERIOR"
  },
  {
    "codigo":420662003,
    "descripcion":"COMA DEBIDO A DIABETES MELLITUS"
  },
  {
    "codigo":60214001,
    "descripcion":"FRACTURA EXPUESTA DE HUESO ILÍACO"
  },
  {
    "codigo":289590008,
    "descripcion":"HALLAZGO RELACIONADO CON EL TONO DE LA VAGINA"
  },
  {
    "codigo":254987003,
    "descripcion":"CARCINOMA ADENOIDE QUÍSTICO DE GLÁNDULA LAGRIMAL"
  },
  {
    "codigo":713739004,
    "descripcion":"NEOPLASIA DE NERVIO ESPINAL LUMBAR"
  },
  {
    "codigo":449760000,
    "descripcion":"COSTRA DE BORDE DE HERIDA"
  },
  {
    "codigo":123915009,
    "descripcion":"INTOXICACIÓN POR MALVACEAE"
  },
  {
    "codigo":285920001,
    "descripcion":"NO LLENA LA BAÑERA"
  },
  {
    "codigo":416992003,
    "descripcion":"PRUEBA DE HEAF GRADO 2"
  },
  {
    "codigo":89312000,
    "descripcion":"INFECCIÓN CAUSADA POR NEOASCARIS VITULORUM"
  },
  {
    "codigo":253152005,
    "descripcion":"HETEROTOPÍA LAMINAR"
  },
  {
    "codigo":1268960003,
    "descripcion":"ASTROBLASTOMA PRIMARIO DE SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":447925007,
    "descripcion":"HIPOPERFUSIÓN DE ARTERIA PULMONAR IZQUIERDA DEBIDA A FLUJO PREFERENCIAL HACIA ARTERIA PULMONAR DERECHA"
  },
  {
    "codigo":21941007,
    "descripcion":"DIETA CON 30 GRAMOS DE GRASA"
  },
  {
    "codigo":216714007,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR PROPOXUR"
  },
  {
    "codigo":315018008,
    "descripcion":"CRISIS DE MAREOS"
  },
  {
    "codigo":413322009,
    "descripcion":"PROBLEMA RESUELTO"
  },
  {
    "codigo":773770009,
    "descripcion":"SÍNDROME DE ANQUILOBLÉFARON FILIFORME CONGÉNITO CON ANO IMPERFORADO"
  },
  {
    "codigo":247647006,
    "descripcion":"DIRECCIÓN ESTABLE DEL PENSAMIENTO"
  },
  {
    "codigo":737332001,
    "descripcion":"TRASTORNO DE VENA POSTERIOR A EMBARAZO ECTÓPICO"
  },
  {
    "codigo":278580002,
    "descripcion":"ENCHAPADO DENTAL EXCESIVAMENTE OSCURO"
  },
  {
    "codigo":735497007,
    "descripcion":"HIPOGLUCEMIA NEONATAL TRANSITORIA IATROGÉNICA"
  },
  {
    "codigo":1259785007,
    "descripcion":"NEOPLASIA PRIMARIA MALIGNA DE CÉLULAS GRANULOSAS"
  },
  {
    "codigo":45534005,
    "descripcion":"GLOSITIS"
  },
  {
    "codigo":1090811000119103,
    "descripcion":"OTITIS MEDIA SEROSA ALÉRGICA AGUDA DE OÍDO MEDIO DERECHO"
  },
  {
    "codigo":405982007,
    "descripcion":"COMPROMISO TUMORAL DE LOS MÁRGENES DE RESECCIÓN QUIRÚRGICA MESENTÉRICOS - NO PUEDE EVALUARSE"
  },
  {
    "codigo":307678007,
    "descripcion":"NISTAGMO VESTIBULAR CENTRAL ROTATORIO"
  },
  {
    "codigo":209374009,
    "descripcion":"FRACTURA-SUBLUXACIÓN NO EXPUESTA DE ARTICULACIÓN METATARSOFALÁNGICA, ÚNICA"
  },
  {
    "codigo":830131003,
    "descripcion":"ÚLCERA DE PIE DERECHO CURADA"
  },
  {
    "codigo":15667001000119100,
    "descripcion":"ARQUEAMIENTO CONGÉNITO DE FÉMUR DERECHO"
  },
  {
    "codigo":11780921000119100,
    "descripcion":"LESIÓN TRAUMÁTICA DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":305208121000119100,
    "descripcion":"ENDOMETRIOSIS PROFUNDA DE INTESTINO DELGADO"
  },
  {
    "codigo":15746361000119101,
    "descripcion":"MASA DE OJO IZQUIERDO"
  },
  {
    "codigo":240307008,
    "descripcion":"HIPOCALCEMIA NEONATAL TARDÍA"
  },
  {
    "codigo":15679801000119105,
    "descripcion":"SÍNDROME DE UVEÍTIS-GLAUCOMA-HIFEMA DE AMBOS OJOS"
  },
  {
    "codigo":330041000119103,
    "descripcion":"QUISTE PORENCEFÁLICO CONGÉNITO"
  },
  {
    "codigo":16908601000119107,
    "descripcion":"PAPILOMA DE PIEL DE PÁRPADO INFERIOR IZQUIERDO"
  },
  {
    "codigo":805616441000119104,
    "descripcion":"HEMORRAGIA DE ESTOMA DE ILEOSTOMÍA"
  },
  {
    "codigo":307001000119105,
    "descripcion":"SOBRELLENADO ENDODÓNCICO"
  },
  {
    "codigo":964190521000119101,
    "descripcion":"PORTADOR DE ENFERMEDAD DE NIEMANN-PICK TIPO A"
  },
  {
    "codigo":238472003,
    "descripcion":"ECCEMA POR FRICCIÓN"
  },
  {
    "codigo":153008441000119109,
    "descripcion":"CATÉTER DE DRENAJE EXTERNO DE LÍQUIDO VENTRICULAR INTRACRANEAL IN SITU"
  },
  {
    "codigo":1287048007,
    "descripcion":"VIDRIO EN CABEZA Y\/O CUELLO"
  },
  {
    "codigo":1085241000119109,
    "descripcion":"COMPLICACIÓN DEBIDA A RECTOSIGMOIDITIS ULCEROSA CRÓNICA"
  },
  {
    "codigo":1075001000119108,
    "descripcion":"GOTA TOFÁCEA CRÓNICA DE PIE DERECHO"
  },
  {
    "codigo":236637001,
    "descripcion":"VEJIGA URINARIA DESCENTRALIZADA"
  },
  {
    "codigo":122681000119108,
    "descripcion":"DEHISCENCIA DE HERIDA DE INCISIÓN QUIRÚRGICA EXTERNA"
  },
  {
    "codigo":1186909000,
    "descripcion":"ÁCIDO VAINILLILMANDÉLICO DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":302173006,
    "descripcion":"PROVISIÓN DE SERVICIO VOLUNTARIO"
  },
  {
    "codigo":365874001,
    "descripcion":"REFLEJO DEL PARACAIDISTA - HALLAZGO"
  },
  {
    "codigo":1119538002,
    "descripcion":"PRUEBA DE AGUDEZA VISUAL ANORMAL"
  },
  {
    "codigo":38194003,
    "descripcion":"ANTÍGENO DE GRUPO SANGUÍNEO E^I^"
  },
  {
    "codigo":300338006,
    "descripcion":"PROBLEMA HEPÁTICO"
  },
  {
    "codigo":726322006,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO INTRÍNSECO DE PIE"
  },
  {
    "codigo":3591006,
    "descripcion":"ACIDOSIS METABÓLICA, BRECHA ANIÓNICA NORMAL, PÉRDIDAS DE BICARBONATO"
  },
  {
    "codigo":167431007,
    "descripcion":"URATOS EN ORINA FUERA DE RANGO DE REFERENCIA"
  },
  {
    "codigo":298503009,
    "descripcion":"COLUMNA VERTEBRAL DORSAL INFLAMADA"
  },
  {
    "codigo":296668004,
    "descripcion":"SOBREDOSIS DEL GRUPO DE LA CEFALOSPORINA"
  },
  {
    "codigo":427740006,
    "descripcion":"LUXACIÓN ANTERIOR DE ARTICULACIÓN ESTERNOCLAVICULAR"
  },
  {
    "codigo":722652007,
    "descripcion":"FRACTURA DE ANILLO PÉLVICO CON RUPTURA COMPLETA DE ARCO POSTERIOR"
  },
  {
    "codigo":294833000,
    "descripcion":"ALERGIA A BIFOSFONATO"
  },
  {
    "codigo":15973781000119107,
    "descripcion":"MASA DE PIEL DE AMBOS PULGARES"
  },
  {
    "codigo":1343409003,
    "descripcion":"HISTEROSALPINGOGRAFÍA FLUOROSCÓPICA CON CONTRASTE NORMAL"
  },
  {
    "codigo":360369003,
    "descripcion":"DEFICIENCIA DE HOLOCARBOXILASA SINTETASA"
  },
  {
    "codigo":65457005,
    "descripcion":"FIBROELASTOSIS ENDOCÁRDICA"
  },
  {
    "codigo":130993008,
    "descripcion":"CAPACIDAD DE ADAPTACIÓN DE LA PRESIÓN INTRACRANEAL DISMINUIDA"
  },
  {
    "codigo":720817008,
    "descripcion":"CRANEOSINOSTOSIS TIPO BOSTON"
  },
  {
    "codigo":292998005,
    "descripcion":"REACCIÓN ADVERSA A LA CEFALOTINA"
  },
  {
    "codigo":1144966008,
    "descripcion":"ENCEFALITIS CAUSADA POR VIRUS DEL HERPES SIMPLE TIPO 1"
  },
  {
    "codigo":192859002,
    "descripcion":"FRAGMENTOS DE DISTONÍA DE TORSIÓN"
  },
  {
    "codigo":94555002,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA PIEL DE LOS DEDOS DE LA MANO"
  },
  {
    "codigo":225627007,
    "descripcion":"MIEDO A DESCONECTARSE DEL RESPIRADOR"
  },
  {
    "codigo":92720000,
    "descripcion":"CARCINOMA IN SITU DE PIEL DE CODO"
  },
  {
    "codigo":291163008,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR FLUSPIRILENO"
  },
  {
    "codigo":322096003,
    "descripcion":"SECUESTRO PLAQUETARIO"
  },
  {
    "codigo":11824841000119100,
    "descripcion":"CONTUSIÓN DE HOMBRO DERECHO"
  },
  {
    "codigo":10923721000119100,
    "descripcion":"FRACTURA NO EXPUESTA DE BASE DE SEGUNDO HUESO METACARPIANO DE MANO DERECHA"
  },
  {
    "codigo":289328008,
    "descripcion":"OLOR DEL MUÑÓN DEL CORDÓN UMBILICAL - HALLAZGO"
  },
  {
    "codigo":1336069002,
    "descripcion":"EPISODIO DE USO NOCIVO DE CATINONA SINTÉTICA"
  },
  {
    "codigo":10950191000119107,
    "descripcion":"HERIDA POR DISPARO DE ARMA DE FUEGO DE MANO DERECHA"
  },
  {
    "codigo":254725004,
    "descripcion":"CISTADENOMA APOCRINO"
  },
  {
    "codigo":25349007,
    "descripcion":"HEMORRAGIA DIGESTIVA ALTA CRÓNICA"
  },
  {
    "codigo":1268698000,
    "descripcion":"CARCINOMA SÓLIDO PSEUDOPAPILAR PRIMARIO DE PÁNCREAS"
  },
  {
    "codigo":683721000119102,
    "descripcion":"NEVO DISPLÁSICO DE PIEL DEL CUELLO"
  },
  {
    "codigo":283823001,
    "descripcion":"MORDEDURA DE ANIMAL EN EL GLÚTEO"
  },
  {
    "codigo":447663001,
    "descripcion":"CONFLUENCIA VENOSA PULMONAR ALEJADA DE LA AURÍCULA IZQUIERDA"
  },
  {
    "codigo":251055003,
    "descripcion":"DEFECTO DE LA PERFUSIÓN MIOCÁRDICA REVERSIBLE"
  },
  {
    "codigo":12398281000119105,
    "descripcion":"ABSTINENCIA DE METANFETAMINA"
  },
  {
    "codigo":249220002,
    "descripcion":"DESGARRO VAGINAL COMO CONSECUENCIA DEL PARTO"
  },
  {
    "codigo":116313000,
    "descripcion":"HALLAZGO RELACIONADO CON LA REGIÓN DE LA CADERA"
  },
  {
    "codigo":247385000,
    "descripcion":"NEURALGIA DE NERVIO FEMOROCUTÁNEO EXTERNO"
  },
  {
    "codigo":312921000,
    "descripcion":"EDEMA MACULAR CISTOIDEO AUTOSÓMICO DOMINANTE"
  },
  {
    "codigo":15675081000119107,
    "descripcion":"TENDINITIS DE AMBOS MÚSCULOS SUPRAESPINOSOS"
  },
  {
    "codigo":704302001,
    "descripcion":"FALTA DE CONTROL DE SÍNTOMA"
  },
  {
    "codigo":473091000,
    "descripcion":"INFLAMACIÓN ASOCIADA CON CATÉTER INTERNO EN LA VÍA URINARIA"
  },
  {
    "codigo":1259523000,
    "descripcion":"CARCINOMA PRIMARIO DE SUPRAGLOTIS"
  },
  {
    "codigo":309251006,
    "descripcion":"CAPAZ DE LEER"
  },
  {
    "codigo":702467006,
    "descripcion":"NEOPLASIA MALIGNA DE VEJIGA URINARIA AUMENTADA"
  },
  {
    "codigo":733400001,
    "descripcion":"HERIDA PUNZANTE DE BRAZO CON CUERPO EXTRAÑO"
  },
  {
    "codigo":372952002,
    "descripcion":"INFECCIÓN CAUSADA POR PENICILLIUM EXPANSUM"
  },
  {
    "codigo":241880005,
    "descripcion":"EFECTO TÓXICO CAUSADO POR JABÓN GRANULADO"
  },
  {
    "codigo":405720007,
    "descripcion":"BRONQUITIS ALÉRGICA"
  },
  {
    "codigo":897240008,
    "descripcion":"CURVATURA ANORMAL DE FALANGE DISTAL DE DEDO PULGAR"
  },
  {
    "codigo":209112009,
    "descripcion":"LUXACIÓN EXPUESTA DE SACRO"
  },
  {
    "codigo":329571000119107,
    "descripcion":"OCLUSIÓN DE ARTERIA CEREBRAL POSTERIOR IZQUIERDA"
  },
  {
    "codigo":43437003,
    "descripcion":"FISURA SUBMUCOSA DEL PALADAR DURO"
  },
  {
    "codigo":403885006,
    "descripcion":"ENFERMEDAD DE BOWEN, PAGETOIDE"
  },
  {
    "codigo":305581006,
    "descripcion":"BAJO ATENCIÓN DE ENFERMERA DE ESCUELA"
  },
  {
    "codigo":371117009,
    "descripcion":"ICTERICIA POSQUIRÚRGICA"
  },
  {
    "codigo":762498002,
    "descripcion":"DESNUTRICIÓN AGUDA EN LA ADOLESCENCIA"
  },
  {
    "codigo":41602003,
    "descripcion":"INTOXICACIÓN CAUSADA POR TIOBARBITÚRICO"
  },
  {
    "codigo":74370006,
    "descripcion":"MICROMELIA"
  },
  {
    "codigo":301911000,
    "descripcion":"HALLAZGO RELACIONADO CON LA HUMEDAD OCULAR"
  },
  {
    "codigo":860802009,
    "descripcion":"HIDROCEFALIA EX VACUO DEBIDA A INFECCIÓN"
  },
  {
    "codigo":170839003,
    "descripcion":"TRASTORNO ALÉRGICO - CAMBIO EN LOS SÍNTOMAS"
  },
  {
    "codigo":236375008,
    "descripcion":"PIELITIS ENFISEMATOSA"
  },
  {
    "codigo":72535009,
    "descripcion":"COSTILLA CERVICAL"
  },
  {
    "codigo":365612007,
    "descripcion":"CONCENTRACIÓN DE HEMOGLOBINA CORPUSCULAR MEDIA - HALLAZGO"
  },
  {
    "codigo":234540007,
    "descripcion":"DEFICIENCIA SELECTIVA DE INMUNOGLOBULINA E"
  },
  {
    "codigo":298241001,
    "descripcion":"ARTICULACIÓN DEL PIE RÍGIDA"
  },
  {
    "codigo":201772009,
    "descripcion":"ARTRITIS REUMATOIDE DE LA ARTICULACIÓN METACARPOFALÁNGICA"
  },
  {
    "codigo":134401001,
    "descripcion":"DISFUNCIÓN SISTÓLICA DEL VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":396545000,
    "descripcion":"MARGEN QUIRÚRGICO DEL COLÉDOCO COMPROMETIDO POR CARCINOMA IN SITU"
  },
  {
    "codigo":724225008,
    "descripcion":"EPIDERMÓLISIS BULLOSA DE LA ZONA DE UNIÓN NO DE TIPO HERLITZ"
  },
  {
    "codigo":34262005,
    "descripcion":"LACERACIÓN PERINEAL DE CUARTO GRADO QUE COMPROMETE LA MUCOSA RECTAL"
  },
  {
    "codigo":722390006,
    "descripcion":"SÍNDROME SIMILAR A INFECCIÓN INTRAUTERINA CONGÉNITA"
  },
  {
    "codigo":11827351000119103,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA DE SEGUNDO A QUINTO DEDOS DE PIE DERECHO"
  },
  {
    "codigo":294571000,
    "descripcion":"ALERGIA A FTALILSULFATIAZOL"
  },
  {
    "codigo":198102006,
    "descripcion":"MASTITIS SUBAGUDA NO PUERPERAL"
  },
  {
    "codigo":394710008,
    "descripcion":"PRIMER INFARTO DE MIOCARDIO"
  },
  {
    "codigo":391040000,
    "descripcion":"CON MAYOR RIESGO DE FRACTURA POR OSTEOPOROSIS"
  },
  {
    "codigo":292736001,
    "descripcion":"REACCIÓN ADVERSA A ANTAGONISTA DE OPIOIDE"
  },
  {
    "codigo":1144704004,
    "descripcion":"HIPOPLASIA CONGÉNITA DE DEDO GORDO"
  },
  {
    "codigo":30592006,
    "descripcion":"BRAQUIMETATARSIA"
  },
  {
    "codigo":718720007,
    "descripcion":"SÍNDROME DE LISENCEFALIA TIPO 3 CON DISPLASIA DE HUESOS METACARPIANOS"
  },
  {
    "codigo":421973002,
    "descripcion":"LÍNEA DE PIGMENTACIÓN CORNEAL FÉRRICA ANTERIOR A AMPOLLA FILTRANTE"
  },
  {
    "codigo":290901003,
    "descripcion":"INTOXICACIÓN POR CITALOPRAM"
  },
  {
    "codigo":127061005,
    "descripcion":"ANEMIA HEMOLÍTICA AUTOINMUNITARIA, CATEGORIZADA POR TIPO DE ANTICUERPO Y\/O POR EL COMPLEMENTO"
  },
  {
    "codigo":94293008,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA CARA"
  },
  {
    "codigo":235699006,
    "descripcion":"MEGADUODENO"
  },
  {
    "codigo":188927000,
    "descripcion":"NEOPLASIA BENIGNA DE VÉRTEBRA LUMBAR"
  },
  {
    "codigo":26922008,
    "descripcion":"INTOXICACIÓN POR CESTRUM"
  },
  {
    "codigo":221695002,
    "descripcion":"BURSITIS AQUÍLEA"
  },
  {
    "codigo":90623003,
    "descripcion":"ALUMINOSIS PULMONAR"
  },
  {
    "codigo":713215005,
    "descripcion":"LESIÓN TRAUMÁTICA DE ESÓFAGO DURANTE PROCEDIMIENTO QUIRÚRGICO"
  },
  {
    "codigo":254463006,
    "descripcion":"TUMOR MIXTO DE PARÓTIDA"
  },
  {
    "codigo":56020001,
    "descripcion":"PELOTEO ROTULIANO"
  },
  {
    "codigo":332081000119107,
    "descripcion":"COROIDITIS SERPIGINOSA DE OJO DERECHO"
  },
  {
    "codigo":283561007,
    "descripcion":"HERIDA DE PERDIGÓN EN AXILA"
  },
  {
    "codigo":609406000,
    "descripcion":"REACCIÓN DE HIPERSENSIBILIDAD NO ALÉRGICA"
  },
  {
    "codigo":54185009,
    "descripcion":"ESCALA DEL COMA DE GLASGOW, 13"
  },
  {
    "codigo":1363070002,
    "descripcion":"METABOLIZADOR POBRE DE FAMILIA 2 SUBFAMILIA C MIEMBRO 9 *6\/*11 DE CITOCROMO P450"
  },
  {
    "codigo":15733041000119109,
    "descripcion":"RETINOSQUISIS PLANA DE AMBOS OJOS"
  },
  {
    "codigo":838183371000119103,
    "descripcion":"RETINOPATÍA NO PROLIFERATIVA DE OJO DERECHO DEBIDA A ANEMIA DREPANOCÍTICA"
  },
  {
    "codigo":314494006,
    "descripcion":"DESPRENDIMIENTO DE RETINA SEUDOFÁQUICO"
  },
  {
    "codigo":247123003,
    "descripcion":"TORTUOSIDAD ARTERIAL DE LA RETINA"
  },
  {
    "codigo":771411008,
    "descripcion":"LESIÓN TRAUMÁTICA DE PIE DERECHO"
  },
  {
    "codigo":1162792004,
    "descripcion":"ISOENZIMA HEPÁTICA DE FOSFATASA ALCALINA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":688741000119100,
    "descripcion":"CARCINOMA PRIMARIO DE CÉLULAS ESCAMOSAS DE CUERPO DE PENE"
  },
  {
    "codigo":278056007,
    "descripcion":"CUELLO UTERINO NO BORRADO"
  },
  {
    "codigo":833277003,
    "descripcion":"DISFUNCIÓN SOMÁTICA PRIMARIA"
  },
  {
    "codigo":472829004,
    "descripcion":"TRASTORNO DE PRÓTESIS DE VÁLVULA AURICULOVENTRICULAR (MORFOLÓGICAMENTE NO MITRAL NI TRICÚSPIDE)"
  },
  {
    "codigo":14077003,
    "descripcion":"PICA"
  },
  {
    "codigo":276221006,
    "descripcion":"SÍNDROME DE MILLARD-GUBLER"
  },
  {
    "codigo":866045007,
    "descripcion":"MIELITIS DEBIDA A INFECCIÓN POR ACTINOMYCES"
  },
  {
    "codigo":1290194006,
    "descripcion":"SEROCONVERSIÓN"
  },
  {
    "codigo":733138007,
    "descripcion":"ESTADIO 2 DE INSUFICIENCIA RENAL AGUDA"
  },
  {
    "codigo":698535000,
    "descripcion":"REQUIERE DISPOSITIVO DE ORTODONCIA SUPERIOR FIJO"
  },
  {
    "codigo":239783001,
    "descripcion":"ARTRITIS POSINFECCIOSA"
  },
  {
    "codigo":208850006,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA EXPUESTA DE LA ARTICULACIÓN MEDIOCARPIANA"
  },
  {
    "codigo":272551004,
    "descripcion":"SENTADO CON RODILLAS FLEXIONADAS Y ELEVADAS"
  },
  {
    "codigo":403623004,
    "descripcion":"PSEUDOLINFOMA DE CÉLULAS T CAUSADO POR FÁRMACO"
  },
  {
    "codigo":205180002,
    "descripcion":"DEFECTO PARCIAL DEL CÚBITO"
  },
  {
    "codigo":236113002,
    "descripcion":"NECROSIS DE ANASTOMOSIS DUODENAL"
  },
  {
    "codigo":170577003,
    "descripcion":"BUEN CONTROL DE LA HIPERTENSIÓN ARTERIAL"
  },
  {
    "codigo":203345008,
    "descripcion":"ENFERMEDAD DE PAGET DEL PERONÉ"
  },
  {
    "codigo":430886005,
    "descripcion":"TRASTORNO DE VÉRTEBRA"
  },
  {
    "codigo":365350005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA ANDAR EN MOTO"
  },
  {
    "codigo":299814008,
    "descripcion":"REFLEJO DE PESTAÑEO PRESENTE"
  },
  {
    "codigo":363515000,
    "descripcion":"NEOPLASIA MALIGNA DE ÓRGANOS GENITALES MASCULINOS"
  },
  {
    "codigo":297979004,
    "descripcion":"SIGNO CON NOMBRE PROPIO DE LA PIEL"
  },
  {
    "codigo":3067005,
    "descripcion":"ANTÍGENO DE GRUPO SANGUÍNEO C^U^"
  },
  {
    "codigo":232443006,
    "descripcion":"PARÁLISIS DEL MÚSCULO ADUCTOR DE LA LARINGE CONGÉNITA"
  },
  {
    "codigo":68603007,
    "descripcion":"PRESIÓN DEL PULSO ARTERIAL ANORMAL"
  },
  {
    "codigo":427216002,
    "descripcion":"ESPINA BÍFIDA ABIERTA DE LA COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":34000006,
    "descripcion":"ENFERMEDAD DE CROHN"
  },
  {
    "codigo":197299004,
    "descripcion":"CIRROSIS PORTAL PIGMENTARIA"
  },
  {
    "codigo":230608009,
    "descripcion":"NEUROPATÍA PROVOCADA POR SUSTANCIA ORGÁNICA"
  },
  {
    "codigo":334591000119107,
    "descripcion":"QUERATOCONJUNTIVITIS DE OJO DERECHO"
  },
  {
    "codigo":30330001,
    "descripcion":"MIOSITIS PURULENTA"
  },
  {
    "codigo":292474005,
    "descripcion":"REACCIÓN ADVERSA AL EDROFONIO"
  },
  {
    "codigo":1144442009,
    "descripcion":"HIPOPLASIA CONGÉNITA DE UNIDAD UNGUEAL"
  },
  {
    "codigo":126799003,
    "descripcion":"NEOPLASIA DEL PISO DE LA BOCA"
  },
  {
    "codigo":26660001,
    "descripcion":"DILATACIÓN DE LA AORTA"
  },
  {
    "codigo":92196005,
    "descripcion":"NEOPLASIA BENIGNA DE PULMÓN"
  },
  {
    "codigo":449843004,
    "descripcion":"PRÓTESIS DE VÁLVULA CARDÍACA BIOLÓGICA IN SITU"
  },
  {
    "codigo":288804006,
    "descripcion":"DIFICULTAD PARA EMPLEAR EL HUMOR"
  },
  {
    "codigo":10957721000119107,
    "descripcion":"LACERACIÓN DEL PULGAR IZQUIERDO"
  },
  {
    "codigo":24825006,
    "descripcion":"SÍNDROME DE HIPOVENTILACIÓN ALVEOLAR CENTRAL"
  },
  {
    "codigo":57593007,
    "descripcion":"ABSCESO DE CUERPO CAVERNOSO"
  },
  {
    "codigo":876793008,
    "descripcion":"REACCIÓN ADVERSA A AMPICILINA Y\/O FLUCLOXACILINA"
  },
  {
    "codigo":55758001,
    "descripcion":"OJOS QUE SE CANSAN CON FACILIDAD"
  },
  {
    "codigo":15709081000119109,
    "descripcion":"LUXACIÓN RECURRENTE DE AMBAS ARTICULACIONES DE MANOS"
  },
  {
    "codigo":22990009,
    "descripcion":"TUBERCULOSIS CRÓNICA"
  },
  {
    "codigo":283299004,
    "descripcion":"ASTILLA DE MADERA EN TÓRAX"
  },
  {
    "codigo":447139008,
    "descripcion":"FRACTURA NO EXPUESTA DE TIBIA"
  },
  {
    "codigo":838520000,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE METILENDIOXIMETANFETAMINA"
  },
  {
    "codigo":445304002,
    "descripcion":"TUMOR TENOSINOVIAL DE CÉLULAS GIGANTES DIFUSO DE ARTICULACIÓN DE CADERA"
  },
  {
    "codigo":248696003,
    "descripcion":"CLIC DE CIERRE DE VÁLVULA PROTÉSICA"
  },
  {
    "codigo":707448003,
    "descripcion":"GRIPE CAUSADA POR VIRUS INFLUENZA A SUBTIPO H7N9"
  },
  {
    "codigo":1297272005,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE CUARTO DEDO DE PIE"
  },
  {
    "codigo":281464006,
    "descripcion":"HEMATOMA SUBCONDRAL"
  },
  {
    "codigo":771149000,
    "descripcion":"SÍNDROME DE FIBROSIS HEPÁTICA, QUISTE RENAL Y DISCAPACIDAD INTELECTUAL"
  },
  {
    "codigo":312397004,
    "descripcion":"PRUEBAS DE FUNCIÓN TIROIDEA: NORMALES"
  },
  {
    "codigo":50253007,
    "descripcion":"HEMOGLOBINURIA PAROXÍSTICA SECUNDARIA INDUCIDA POR FRÍO"
  },
  {
    "codigo":277794000,
    "descripcion":"ERITEMA ANULAR NEONATAL"
  },
  {
    "codigo":337101000119102,
    "descripcion":"BLEFARITIS ULCEROSA DE PÁRPADO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":212258006,
    "descripcion":"LESIÓN ABIERTA DE NERVIO MEDIANO"
  },
  {
    "codigo":79351003,
    "descripcion":"CONDUCTA HOSTIL"
  },
  {
    "codigo":767479006,
    "descripcion":"ALERGIA A PIRIDOXINA"
  },
  {
    "codigo":372428000,
    "descripcion":"ORIENTACIÓN ESPACIAL DEL ESPÉCIMEN, DESCONOCIDA"
  },
  {
    "codigo":1258999009,
    "descripcion":"LACTANCIA MATERNA EXCLUSIVA"
  },
  {
    "codigo":208588002,
    "descripcion":"FRACTURA EXPUESTA DE FÉMUR DISTAL, CÓNDILO INTERNO"
  },
  {
    "codigo":11980003,
    "descripcion":"QUEMADURA DEL PIE"
  },
  {
    "codigo":16639181000119106,
    "descripcion":"COMPRESIÓN DE AMBOS NERVIOS PERONEOS PROFUNDOS"
  },
  {
    "codigo":274124007,
    "descripcion":"GRAN MULTÍPARA EN TRABAJO DE PARTO"
  },
  {
    "codigo":110284009,
    "descripcion":"PIGMENTACIÓN MEDICAMENTOSA"
  },
  {
    "codigo":1157025007,
    "descripcion":"CUERPO EXTRAÑO INFECTADO"
  },
  {
    "codigo":403361008,
    "descripcion":"CICATRIZ DE ACNÉ EN PICAHIELO"
  },
  {
    "codigo":301387000,
    "descripcion":"DOLOR A LA PALPACIÓN EN ESTRUCTURA OCULAR"
  },
  {
    "codigo":399691000,
    "descripcion":"DISPLASIA DE VÍAS BILIARES EXTRAHEPÁTICAS"
  },
  {
    "codigo":6475002,
    "descripcion":"DEMENCIA DEGENERATIVA PRIMARIA TIPO ALZHEIMER, DE INICIO EN LA EDAD PRESENIL, NO COMPLICADA"
  },
  {
    "codigo":268619003,
    "descripcion":"TRASTORNO MANÍACO, EPISODIO ÚNICO"
  },
  {
    "codigo":792907004,
    "descripcion":"ADENOCARCINOMA DE CONDUCTO PANCREÁTICO"
  },
  {
    "codigo":72011007,
    "descripcion":"ESTENOSIS AÓRTICA REUMÁTICA"
  },
  {
    "codigo":235851008,
    "descripcion":"INFARTO HEMORRÁGICO DEL INTESTINO"
  },
  {
    "codigo":299552000,
    "descripcion":"ARTICULACIÓN SUBASTRAGALINA ESTABLE"
  },
  {
    "codigo":1153355009,
    "descripcion":"LINFOMA MALIGNO DE ESÓFAGO"
  },
  {
    "codigo":365088003,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA IMITAR FORMAS DE COMUNICACIÓN"
  },
  {
    "codigo":397856003,
    "descripcion":"SÍNDROME RELACIONADO CON LUPUS ERITEMATOSO SISTÉMICO"
  },
  {
    "codigo":70176004,
    "descripcion":"CUERPO EXTRAÑO EN EL RECTO"
  },
  {
    "codigo":234016006,
    "descripcion":"INFECCIÓN DE ARTERIA"
  },
  {
    "codigo":15685121000119100,
    "descripcion":"EPITELIOPATÍA CORNEAL DE OJO IZQUIERDO CAUSADA POR VIRUS VARICELA ZÓSTER"
  },
  {
    "codigo":461557000,
    "descripcion":"ATRESIA CONGÉNITA DE CAYADO AÓRTICO"
  },
  {
    "codigo":166645004,
    "descripcion":"NIVEL DE ALANINA AMINOTRANSFERASA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":2805007,
    "descripcion":"INTOXICACIÓN POR FOSMET"
  },
  {
    "codigo":230346007,
    "descripcion":"MIOCLONÍA MEDICAMENTOSA"
  },
  {
    "codigo":263114007,
    "descripcion":"FRACTURA-SUBLUXACIÓN DE LA ARTICULACIÓN FEMOROPATELAR"
  },
  {
    "codigo":295882009,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE PROTRIPTILINA"
  },
  {
    "codigo":294047002,
    "descripcion":"ALERGIA A DOBUTAMINA"
  },
  {
    "codigo":228511006,
    "descripcion":"NO MASTICA TABACO"
  },
  {
    "codigo":11998721000119105,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO DE PIE DERECHO"
  },
  {
    "codigo":718196002,
    "descripcion":"SÍNDROME TROMBOCITOPÉNICO DE TALASEMIA BETA LIGADO AL CROMOSOMA X"
  },
  {
    "codigo":292212004,
    "descripcion":"REACCIÓN ADVERSA A LA CARMUSTINA"
  },
  {
    "codigo":423284006,
    "descripcion":"CARCINOMA ESCAMOCELULAR DE LA PIEL DEL CUELLO"
  },
  {
    "codigo":95604008,
    "descripcion":"ÚLCERA DEL PEZÓN"
  },
  {
    "codigo":126537000,
    "descripcion":"NEOPLASIA ÓSEA"
  },
  {
    "codigo":161140009,
    "descripcion":"INGLÉS COMO SEGUNDO IDIOMA"
  },
  {
    "codigo":192073007,
    "descripcion":"CAMBIO DE PERSONALIDAD"
  },
  {
    "codigo":93769007,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE HUESO CUBOIDES"
  },
  {
    "codigo":124702003,
    "descripcion":"DEFICIENCIA DE GLUTARATO - COA LIGASA"
  },
  {
    "codigo":91934008,
    "descripcion":"ALERGIA A FRUTO SECO O ALIMENTO CON FRUTOS SECOS"
  },
  {
    "codigo":714526009,
    "descripcion":"PROFUNDIDAD DEL VESTÍBULO MAXILAR DISMINUIDA"
  },
  {
    "codigo":253939001,
    "descripcion":"DUPLICACIÓN DE TODA LA EXTREMIDAD INFERIOR"
  },
  {
    "codigo":286707001,
    "descripcion":"TIENDE A TOLERAR EL ABURRIMIENTO"
  },
  {
    "codigo":90099008,
    "descripcion":"LEUCOENCEFALOPATÍA SUBCORTICAL"
  },
  {
    "codigo":22728002,
    "descripcion":"ANQUILOSTOMIASIS CAUSADA POR ANQUILOSTOMA BRAZILIENSE"
  },
  {
    "codigo":284872003,
    "descripcion":"SE CORTA LAS UÑAS"
  },
  {
    "codigo":88264003,
    "descripcion":"INFECCIÓN CAUSADA POR LARVAS DE TRICHINELLA SPIRALIS"
  },
  {
    "codigo":252104005,
    "descripcion":"DOSIS PARALIZANTE 20"
  },
  {
    "codigo":16697141000119100,
    "descripcion":"MALFORMACIÓN CONGÉNITA DE AMBAS VENAS RENALES"
  },
  {
    "codigo":219336007,
    "descripcion":"LESIÓN POR ESCOPETA, CON PROPÓSITO DESCONOCIDO"
  },
  {
    "codigo":448712008,
    "descripcion":"SARCOMA DE FÉMUR"
  },
  {
    "codigo":1003933001,
    "descripcion":"DELECIÓN PROXIMAL DEL BRAZO LARGO DEL CROMOSOMA 1"
  },
  {
    "codigo":283037009,
    "descripcion":"LESIÓN SUPERFICIAL DE LA REGIÓN PÉLVICA"
  },
  {
    "codigo":19058002,
    "descripcion":"ESPLENOMEGALIA CONGESTIVA"
  },
  {
    "codigo":248434006,
    "descripcion":"FASE DE CAÍDA DE LA FIEBRE"
  },
  {
    "codigo":312135004,
    "descripcion":"INFECCIÓN VIRAL DEL APARATO CARDIOVASCULAR"
  },
  {
    "codigo":1196871004,
    "descripcion":"DEFECTO DE GEN DE ENSAMBLAJE DE COMPLEJO III DE CADENA RESPIRATORIA MITOCONDRIAL"
  },
  {
    "codigo":246599007,
    "descripcion":"SIGNO DE CUERDA DE ARCO"
  },
  {
    "codigo":277532002,
    "descripcion":"MELANOSIS MENÍNGEA"
  },
  {
    "codigo":16015311000119101,
    "descripcion":"ARTRITIS REACTIVA DE ARTICULACIÓN DE AMBOS TOBILLOS"
  },
  {
    "codigo":13553006,
    "descripcion":"LUXACIÓN DE SMITH"
  },
  {
    "codigo":208326002,
    "descripcion":"FRACTURA NO EXPUESTA DEL RADIO DISTAL, INTRARTICULAR EN T"
  },
  {
    "codigo":110022003,
    "descripcion":"FRACTURA HORIZONTAL DE MAXILAR NO EXPUESTA"
  },
  {
    "codigo":698011002,
    "descripcion":"CARCINOMA ESCAMOCELULAR QUERATINIZANTE DE RINOFARINGE"
  },
  {
    "codigo":1156763004,
    "descripcion":"PARÁLISIS SUPRANUCLEAR PROGRESIVA-SÍNDROME CORTICOBASAL"
  },
  {
    "codigo":75419006,
    "descripcion":"OBSTRUCCIÓN PARCIAL CRÓNICA DEL ASA AFERENTE"
  },
  {
    "codigo":206491006,
    "descripcion":"HIPERCALIEMIA NEONATAL TRANSITORIA"
  },
  {
    "codigo":366661000,
    "descripcion":"HALLAZGO DE LAS CARACTERÍSTICAS DEL PELO"
  },
  {
    "codigo":302960008,
    "descripcion":"MOSAICISMO 45, X; 46, XX"
  },
  {
    "codigo":38981004,
    "descripcion":"INFECCIÓN CAUSADA POR PARANOPLOCEPHALA"
  },
  {
    "codigo":202821008,
    "descripcion":"INESTABILIDAD DE LA COLUMNA VERTEBRAL CERVICAL"
  },
  {
    "codigo":69914001,
    "descripcion":"ESTRECHEZ DEL ANO"
  },
  {
    "codigo":1251397008,
    "descripcion":"EFLUVIO ANÁGENO TÓXICO"
  },
  {
    "codigo":168218003,
    "descripcion":"HONGO NO AISLADO EN ESPÉCIMEN"
  },
  {
    "codigo":364826005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA AMAMANTAR"
  },
  {
    "codigo":233754007,
    "descripcion":"NEUMOCONIOSIS POR CERIO"
  },
  {
    "codigo":788975001,
    "descripcion":"SÍFILIS TARDÍA DE PIEL"
  },
  {
    "codigo":723439002,
    "descripcion":"MIOPATÍA DE LOS NATIVOS NORTEAMERICANOS"
  },
  {
    "codigo":231919003,
    "descripcion":"SIDEROSIS DE CÓRNEA"
  },
  {
    "codigo":362991006,
    "descripcion":"TRASTORNO HEREDITARIO DEL SISTEMA AUDITIVO"
  },
  {
    "codigo":262852001,
    "descripcion":"HEMATOMA DE INTESTINO DELGADO"
  },
  {
    "codigo":426692001,
    "descripcion":"INTOXICACIÓN POR ETILENGLICOL"
  },
  {
    "codigo":295620001,
    "descripcion":"SOBREDOSIS DE CICLOFOSFAMIDA"
  },
  {
    "codigo":721604004,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE LOCALIZACIONES SUPERPUESTAS DE ÓRGANO GENITAL MASCULINO"
  },
  {
    "codigo":66244005,
    "descripcion":"DIFERENCIAS VENTILATORIAS REGIONALES POR DISTENSIBILIDAD DESIGUAL"
  },
  {
    "codigo":293785000,
    "descripcion":"ALERGIA A PACLITAXEL"
  },
  {
    "codigo":197316009,
    "descripcion":"FIBROSIS PORTAL SIN CIRROSIS"
  },
  {
    "codigo":785305006,
    "descripcion":"PARAPLEJÍA ESPÁSTICA AUTOSÓMICA DOMINANTE TIPO 8"
  },
  {
    "codigo":160878003,
    "descripcion":"DISPUTA POR PATERNIDAD"
  },
  {
    "codigo":717934004,
    "descripcion":"OSTEOMALACIA DEBIDA A DEFICIENCIA DE VITAMINA D"
  },
  {
    "codigo":95342006,
    "descripcion":"FOTONICÓLISIS"
  },
  {
    "codigo":290115002,
    "descripcion":"SECRECIÓN VERDE POR PEZÓN"
  },
  {
    "codigo":716099003,
    "descripcion":"SÍNDROME DE DEFORMIDAD DE PIERNA POR AUSENCIA Y CATARATAS CONGÉNITAS"
  },
  {
    "codigo":1240387004,
    "descripcion":"TRASTORNO NEONATAL PRECOZ DEBIDO A RUPTURA DE SENO MARGINAL DE PLACENTA"
  },
  {
    "codigo":1142083003,
    "descripcion":"ANEMIA HEMOLÍTICA DEL EMBARAZO"
  },
  {
    "codigo":191811004,
    "descripcion":"ALCOHOLISMO CRÓNICO CONTINUO"
  },
  {
    "codigo":421187003,
    "descripcion":"RECHAZO DE TRASPLANTE AUTÓLOGO DE EPITELIO CORNEAL"
  },
  {
    "codigo":27971006,
    "descripcion":"DEGENERACIÓN MARGINAL DE TERRIEN DE LA CÓRNEA"
  },
  {
    "codigo":124440004,
    "descripcion":"DEFICIENCIA DE BIFOSFOGLICERATO FOSFATASA"
  },
  {
    "codigo":1304088005,
    "descripcion":"NECROSIS DE PÁNCREAS ENCAPSULADA"
  },
  {
    "codigo":386584007,
    "descripcion":"HIPOFUNCIÓN DE CORTEZA ADRENAL"
  },
  {
    "codigo":286445001,
    "descripcion":"DIFICULTAD PARA OBTENER ALIMENTO"
  },
  {
    "codigo":253677005,
    "descripcion":"INTERRUPCIÓN DE LA AORTA POSDUCTAL"
  },
  {
    "codigo":284610000,
    "descripcion":"CAPAZ DE CANALIZAR LA AGRESIÓN"
  },
  {
    "codigo":448450001,
    "descripcion":"SARCOMA DE EPIPLÓN"
  },
  {
    "codigo":417517009,
    "descripcion":"ANEMIA DREPANOCÍTICA\/ENFERMEDAD POR HEMOGLOBINA C CON CRISIS"
  },
  {
    "codigo":55234004,
    "descripcion":"MENINGOENCEFALOMIELITIS PIOGRANULOMATOSA"
  },
  {
    "codigo":413847001,
    "descripcion":"LEUCEMIA MIELOIDE CRÓNICA EN FASE CRÓNICA"
  },
  {
    "codigo":315543005,
    "descripcion":"NACIDO EN TOGO"
  },
  {
    "codigo":118935006,
    "descripcion":"TRASTORNO DE LA CADERA"
  },
  {
    "codigo":250007006,
    "descripcion":"USO DE MANIOBRAS SECUNDARIAS PARA SUPERAR LA MARCHA INTERRUMPIDA - HALLAZGO"
  },
  {
    "codigo":18796000,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA ARTERIA RENAL"
  },
  {
    "codigo":446615009,
    "descripcion":"FILTRACIÓN DE BILIS DESDE LECHO VESICULAR"
  },
  {
    "codigo":282775007,
    "descripcion":"LESIÓN DE PANTORRILLA"
  },
  {
    "codigo":444780001,
    "descripcion":"GLUCOSA EN ESPÉCIMEN DE SANGRE POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1263980004,
    "descripcion":"HEMORRAGIA CEREBELOSA FETAL NO TRAUMÁTICA"
  },
  {
    "codigo":1231212006,
    "descripcion":"PARÁLISIS DE LA MIRADA CONJUGADA VERTICAL"
  },
  {
    "codigo":248172007,
    "descripcion":"SIMETRÍA FACIAL"
  },
  {
    "codigo":1081911000119101,
    "descripcion":"CARCINOMA MICROCÍTICO PRIMARIO DE LÓBULO MEDIO DE PULMÓN DERECHO"
  },
  {
    "codigo":770625006,
    "descripcion":"SÍNDROME DE INMUNODEFICIENCIA COMBINADA CON ANOMALÍAS FACIO-ÓCULO-ESQUELÉTICAS"
  },
  {
    "codigo":115265008,
    "descripcion":"CRISTAL URINARIO, FOSFATO"
  },
  {
    "codigo":703254001,
    "descripcion":"PSEUDOHIPOALDOSTERONISMO TIPO 2A"
  },
  {
    "codigo":567961000005108,
    "descripcion":"ECOGRAFÍA PRENATAL DE PRIMER TRIMESTRE DESEADA"
  },
  {
    "codigo":766955008,
    "descripcion":"OBSTRUCCIÓN DE VENA"
  },
  {
    "codigo":109760001,
    "descripcion":"FRACTURA DE LA BIFURCACIÓN DE LA RAÍZ DENTAL"
  },
  {
    "codigo":240832002,
    "descripcion":"FIEBRE FILARIÁSICA DE TIMOR"
  },
  {
    "codigo":208064005,
    "descripcion":"FRACTURA VERTEBRAL EXPUESTA CON LESIÓN ANTERIOR DE MÉDULA ESPINAL LUMBAR"
  },
  {
    "codigo":344631000119106,
    "descripcion":"CICATRIZ CORIORRETINIANA PERIFÉRICA DE AMBOS OJOS"
  },
  {
    "codigo":402837000,
    "descripcion":"ARAÑAS VASCULARES ASOCIADAS A ENFERMEDAD HEPÁTICA"
  },
  {
    "codigo":450312003,
    "descripcion":"COARTACIÓN DE AORTA ENTRE ARTERIAS SUBCLAVIA Y CARÓTIDA PRIMITIVA"
  },
  {
    "codigo":271765003,
    "descripcion":"COSTRA CUTÁNEA"
  },
  {
    "codigo":1287573002,
    "descripcion":"TUMOR CARCINOIDE DE BRONQUIO"
  },
  {
    "codigo":1254805002,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS DE PARED POSTERIOR DE OROFARINGE"
  },
  {
    "codigo":304533006,
    "descripcion":"ESCASO SOSTÉN URETRAL"
  },
  {
    "codigo":238997007,
    "descripcion":"REACCIÓN ICTIOSIFORME FARMACÓGENA"
  },
  {
    "codigo":1285738000,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE HUESO DE PIE"
  },
  {
    "codigo":370069009,
    "descripcion":"AUSENCIA DE RESPUESTA LINFOCÍTICA PERITUMORAL"
  },
  {
    "codigo":204394002,
    "descripcion":"ANOMALÍA CONGÉNITA DEL MIOCARDIO"
  },
  {
    "codigo":73322006,
    "descripcion":"DISNEA, CLASE IV"
  },
  {
    "codigo":1351274008,
    "descripcion":"FORMA SINTOMÁTICA DE MIOPATÍA CENTRONUCLEAR LIGADA AL CROMOSOMA X EN MUJERES PORTADORAS"
  },
  {
    "codigo":366399000,
    "descripcion":"AMPLITUD DEL MOVIMIENTO ACTIVO DE ROTACIÓN HACIA LA IZQUIERDA DE LA COLUMNA CERVICAL - HALLAZGO"
  },
  {
    "codigo":300863000,
    "descripcion":"MASA EN LA AXILA"
  },
  {
    "codigo":200724002,
    "descripcion":"GRANULOMA UMBILICAL"
  },
  {
    "codigo":299028003,
    "descripcion":"ARTICULACIÓN DE LA MUÑECA FRÍA AL TACTO"
  },
  {
    "codigo":725012004,
    "descripcion":"SÍNDROME MEDULAR CERVICAL INCOMPLETO"
  },
  {
    "codigo":397332005,
    "descripcion":"RUPTURA DEL TEJIDO DEL ESPÉCIMEN"
  },
  {
    "codigo":1149161001,
    "descripcion":"NIVEL DE CONFLICTO PARA LA TOMA DE DECISIONES DISMINUIDO"
  },
  {
    "codigo":723177002,
    "descripcion":"ÚLCERA RECURRENTE DE CAVIDAD BUCAL"
  },
  {
    "codigo":67817003,
    "descripcion":"SÍNDROME DE SORDERA - FIMBRIA TORTI"
  },
  {
    "codigo":297193007,
    "descripcion":"GANGLIÓN DE LA MANO"
  },
  {
    "codigo":197054001,
    "descripcion":"INVAGINACIÓN SECUNDARIA"
  },
  {
    "codigo":721342001,
    "descripcion":"FRACTURA DE ARCO POSTERIOR DE PRIMERA VÉRTEBRA CERVICAL"
  },
  {
    "codigo":786878009,
    "descripcion":"FÍSTULA DE ANO"
  },
  {
    "codigo":129683001,
    "descripcion":"HALLAZGO RELACIONADO CON LAS CONDICIONES SANITARIAS"
  },
  {
    "codigo":46201000087100,
    "descripcion":"FRACTURA DE FALANGE DE QUINTO DEDO DE PIE IZQUIERDO"
  },
  {
    "codigo":424595005,
    "descripcion":"FLUJO LIBRE DE LÍQUIDO CEFALORRAQUÍDEO"
  },
  {
    "codigo":293523007,
    "descripcion":"REACCIÓN ADVERSA A LA ENOXIMONA"
  },
  {
    "codigo":1145491009,
    "descripcion":"HIPOPLASIA CONGÉNITA DE DEDO ÍNDICE"
  },
  {
    "codigo":95080002,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA PIEL DE LA REGIÓN TEMPORAL"
  },
  {
    "codigo":43641000087107,
    "descripcion":"CONTUSIÓN DE FLANCO IZQUIERDO"
  },
  {
    "codigo":41081000087105,
    "descripcion":"CELULITIS DE QUINTO DEDO DE PIE DERECHO"
  },
  {
    "codigo":160616005,
    "descripcion":"INTENTA DEJAR DE FUMAR"
  },
  {
    "codigo":226152004,
    "descripcion":"DIETA RICA EN VITAMINA D"
  },
  {
    "codigo":289853001,
    "descripcion":"PERINEO EN OJAL"
  },
  {
    "codigo":224317001,
    "descripcion":"COMPLETAMENTE INTEGRADO A LA ESCOLARIDAD CONVENCIONAL"
  },
  {
    "codigo":715837006,
    "descripcion":"DEFORMIDAD MUCOGINGIVAL SOBRE CRESTA ALVEOLAR DESDENTADA"
  },
  {
    "codigo":126013009,
    "descripcion":"DEBILIDAD MUSCULAR SUBJETIVA"
  },
  {
    "codigo":93245009,
    "descripcion":"HIPOPLASIA CONGÉNITA DE VEJIGA URINARIA"
  },
  {
    "codigo":124178006,
    "descripcion":"DEFICIENCIA DE DIHIDROFOLATO REDUCTASA"
  },
  {
    "codigo":253415001,
    "descripcion":"DEFECTO DE TABIQUE AURICULOVENTRICULAR - COMPONENTE VENTRICULAR ÚNICO"
  },
  {
    "codigo":1269223003,
    "descripcion":"UVEÍTIS PARANEOPLÁSICA"
  },
  {
    "codigo":347141000119104,
    "descripcion":"DEPÓSITO DE PLATA EN CÓRNEA DE AMBOS OJOS"
  },
  {
    "codigo":286183007,
    "descripcion":"DIFICULTAD PARA PONER LA MESA"
  },
  {
    "codigo":10832901000119106,
    "descripcion":"FRACTURA EXPUESTA DE PRIMER HUESO METACARPIANO DE MANO IZQUIERDA"
  },
  {
    "codigo":413585005,
    "descripcion":"ASPIRACIÓN A TRACTO RESPIRATORIO"
  },
  {
    "codigo":282513005,
    "descripcion":"INCAPAZ DE SUBIR ESCALONES CORRIENDO"
  },
  {
    "codigo":85905009,
    "descripcion":"MANIOBRA DE GOWER"
  },
  {
    "codigo":1362022003,
    "descripcion":"SÍNDROME DE HIPOPLASIA PONTOCEREBELOSA, HIPOTONÍA E INSUFICIENCIA RESPIRATORIA LETAL"
  },
  {
    "codigo":18534003,
    "descripcion":"INFECCIÓN CAUSADA POR ACROTHECA AQUASPERSA"
  },
  {
    "codigo":1088021000119100,
    "descripcion":"INFLAMACIÓN AGUDA DE TROMPA FARINGOTIMPÁNICA IZQUIERDA"
  },
  {
    "codigo":84070009,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN LA REGIÓN DE LA AXILA, CON INFECCIÓN"
  },
  {
    "codigo":1263718009,
    "descripcion":"TRASTORNO FETAL DEBIDO A POLIHIDRAMNIOS AGUDO"
  },
  {
    "codigo":247910009,
    "descripcion":"INQUIETUD"
  },
  {
    "codigo":1163579007,
    "descripcion":"DEFORMIDAD CONGÉNITA DE HUESO DE ANTEBRAZO"
  },
  {
    "codigo":702992000,
    "descripcion":"CHRYSEOBACTERIUM INDOLOGENES O BREVUNDIMONAS VESICULARIS"
  },
  {
    "codigo":735760001,
    "descripcion":"DERMATITIS IRRITATIVA POR CONTACTO CAUSADA POR LÍQUIDO CORPORAL"
  },
  {
    "codigo":277008003,
    "descripcion":"RESPUESTA ELECTRORRETINOGRÁFICA"
  },
  {
    "codigo":47632004,
    "descripcion":"PORFIRIA SECUNDARIA"
  },
  {
    "codigo":1260048003,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS DE SENO FRONTAL"
  },
  {
    "codigo":309776008,
    "descripcion":"SÍNDROME DE COSTELLO"
  },
  {
    "codigo":209637003,
    "descripcion":"DESGARRO TOTAL DE LIGAMENTO DEL PIE"
  },
  {
    "codigo":439013004,
    "descripcion":"ESTRECHEZ DE ANASTOMOSIS INTESTINAL"
  },
  {
    "codigo":371642001,
    "descripcion":"CUERPO DESCOMPUESTO"
  },
  {
    "codigo":699322002,
    "descripcion":"CÁLCULO DE MATRIZ RENAL"
  },
  {
    "codigo":11194003,
    "descripcion":"ANOMALÍA CONGÉNITA DEL ANO"
  },
  {
    "codigo":76730004,
    "descripcion":"LESIÓN TRAUMÁTICA DE CONDUCTO BILIAR SIN HERIDA ABIERTA HACIA CAVIDAD ABDOMINAL"
  },
  {
    "codigo":109498002,
    "descripcion":"DIENTE EN BUCOVERSIÓN"
  },
  {
    "codigo":764858009,
    "descripcion":"AGAMMAGLOBULINEMIA AISLADA"
  },
  {
    "codigo":9359003,
    "descripcion":"HERNIA INGUINAL BILATERAL CON GANGRENA Y OBSTRUCCIÓN"
  },
  {
    "codigo":74895004,
    "descripcion":"PERFORACIÓN DE LA CÓRNEA"
  },
  {
    "codigo":271503005,
    "descripcion":"EMPIEMA PLEURAL CON FÍSTULA"
  },
  {
    "codigo":402575005,
    "descripcion":"COMPLICACIÓN DE EPIDERMORREACCIÓN"
  },
  {
    "codigo":238735005,
    "descripcion":"SÍNDROME DE PELO ANÁGENO SUELTO"
  },
  {
    "codigo":15695161000119106,
    "descripcion":"OSTEOMIELITIS DE AMBOS FÉMURES"
  },
  {
    "codigo":10753491000119101,
    "descripcion":"DIABETES MELLITUS GESTACIONAL EN EL MOMENTO DEL NACIMIENTO"
  },
  {
    "codigo":300601003,
    "descripcion":"CAPAZ DE UTILIZAR LAS COMODIDADES LOCALES"
  },
  {
    "codigo":890425005,
    "descripcion":"SINFALANGISMO PROXIMAL BILATERAL DE MANO"
  },
  {
    "codigo":366137006,
    "descripcion":"HALLAZGO RELACIONADO CON RUIDOS EXTRACARDÍACOS"
  },
  {
    "codigo":5689008,
    "descripcion":"PERIODONTITIS CRÓNICA"
  },
  {
    "codigo":298766001,
    "descripcion":"LESIÓN DE CLAVÍCULA"
  },
  {
    "codigo":235065009,
    "descripcion":"ÚLCERA SIFILÍTICA BUCAL EN HUELLA DE CARACOL"
  },
  {
    "codigo":69390003,
    "descripcion":"HAMARTOMA VASCULAR DE LA PIEL"
  },
  {
    "codigo":36622002,
    "descripcion":"TRASTORNO LEVE DEL ESTADO DE ÁNIMO"
  },
  {
    "codigo":397070002,
    "descripcion":"MACROGAMETOCITO DE PLASMODIUM EN ERITROCITO"
  },
  {
    "codigo":1281806008,
    "descripcion":"PIERCING EN OÍDO EXTERNO IZQUIERDO"
  },
  {
    "codigo":198627000,
    "descripcion":"EMBARAZO ANGULAR"
  },
  {
    "codigo":1148899002,
    "descripcion":"ENFERMEDAD POR HEMOGLOBINA SEAL ROCK"
  },
  {
    "codigo":296931004,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE CUMARINA"
  },
  {
    "codigo":1279971008,
    "descripcion":"MUTACIÓN HETEROCIGOTA DE GEN NFKBIA DETECTADA"
  },
  {
    "codigo":722915009,
    "descripcion":"APNEA DEL RECIÉN NACIDO DEBIDA A LESIÓN TRAUMÁTICA NEUROLÓGICA"
  },
  {
    "codigo":295096002,
    "descripcion":"ALERGIA A NICOFURANOSA"
  },
  {
    "codigo":65720003,
    "descripcion":"ANILLO DE SOEMMERRING"
  },
  {
    "codigo":184004,
    "descripcion":"ARRITMIA POR ABSTINENCIA"
  },
  {
    "codigo":296243009,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE PERFENAZINA"
  },
  {
    "codigo":194957000,
    "descripcion":"MIOCARDITIS SÉPTICA - ESTAFILOCÓCICA"
  },
  {
    "codigo":31117002,
    "descripcion":"SIGNO DE PELLIZCAMIENTO"
  },
  {
    "codigo":2001000124107,
    "descripcion":"DERIVADO POR PAGADOR"
  },
  {
    "codigo":63885004,
    "descripcion":"PANICULITIS QUE AFECTA LA REGIÓN SACRA"
  },
  {
    "codigo":782946000,
    "descripcion":"SÍNDROME GASTROCUTÁNEO"
  },
  {
    "codigo":293261009,
    "descripcion":"REACCIÓN ADVERSA A LA ERGOLINA"
  },
  {
    "codigo":225890001,
    "descripcion":"NO SE ENCUENTRA EN CONDICIONES MENTALES ADECUADAS PARA VOLVER AL TRABAJO"
  },
  {
    "codigo":422498005,
    "descripcion":"INFECCIÓN NEUROINVASIVA POR VIRUS DE LA ENCEFALITIS EQUINA OCCIDENTAL"
  },
  {
    "codigo":94818005,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL ENDOCARDIO"
  },
  {
    "codigo":291426007,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR GRISEOFULVINA"
  },
  {
    "codigo":191287000,
    "descripcion":"TRASTORNO HEMORRÁGICO POR ANTICOAGULANTES CIRCULANTES"
  },
  {
    "codigo":715575001,
    "descripcion":"ARTROGRIPOSIS DISTAL TIPO 4"
  },
  {
    "codigo":92983005,
    "descripcion":"HUESO HIOIDES CURVADO CONGÉNITO"
  },
  {
    "codigo":1010487005,
    "descripcion":"ESCLEROSIS DE EPÍFISIS DE FALANGE PROXIMAL DE DEDO ANULAR CON RADIOPACIDAD AUMENTADA"
  },
  {
    "codigo":289591007,
    "descripcion":"VAGINA LAXA"
  },
  {
    "codigo":27447009,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN LA REGIÓN DE LA INGLE, SIN INFECCIÓN"
  },
  {
    "codigo":123916005,
    "descripcion":"INTOXICACIÓN POR ARALIACEAE"
  },
  {
    "codigo":253153000,
    "descripcion":"DISPLASIA CORTICAL"
  },
  {
    "codigo":449761001,
    "descripcion":"SECRECIÓN SEROPURULENTA DE HERIDA"
  },
  {
    "codigo":254988008,
    "descripcion":"ADENOCARCINOMA DE GLÁNDULA LAGRIMAL"
  },
  {
    "codigo":285921002,
    "descripcion":"DIFICULTAD PARA LLENAR LA BAÑERA"
  },
  {
    "codigo":1268961004,
    "descripcion":"ASTROCITOMA DIFUSO PRIMARIO DE CEREBRO"
  },
  {
    "codigo":416993008,
    "descripcion":"CONSUMO DE DROGAS COMPULSIVO E INCONTROLABLE"
  },
  {
    "codigo":21942000,
    "descripcion":"CONSTRICCIÓN DE BRONQUIOLOS"
  },
  {
    "codigo":710070002,
    "descripcion":"ESPÉCIMEN INSATISFACTORIO PARA EVALUACIÓN DEBIDO A RUPTURA DE ENVASE"
  },
  {
    "codigo":315019000,
    "descripcion":"MENINGITIS ASÉPTICA DEBIDA A INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":249483000,
    "descripcion":"FORMA DE DEGLUTIR - CONTACTO DE LA LENGUA CON EL LABIO"
  },
  {
    "codigo":447926008,
    "descripcion":"HIPOPERFUSIÓN DE ARTERIA PULMONAR DERECHA DEBIDA A FLUJO PREFERENCIAL HACIA ARTERIA PULMONAR IZQUIERDA"
  },
  {
    "codigo":446091003,
    "descripcion":"LUXACIÓN TRAUMÁTICA DE ARTICULACIÓN INTERFALÁNGICA DE DEDO DE LA MANO"
  },
  {
    "codigo":773771008,
    "descripcion":"MIOPÍA AISLADA RARA"
  },
  {
    "codigo":247648001,
    "descripcion":"PÉRDIDA DE LA DIRECCIÓN DEL PENSAMIENTO"
  },
  {
    "codigo":352161000119100,
    "descripcion":"MELANOMA IN SITU DE EXTREMIDAD SUPERIOR DERECHA"
  },
  {
    "codigo":1359925001,
    "descripcion":"GINGIVITIS LOCALIZADA DEBIDA A PLACA DENTAL CON TEJIDO PERIODONTAL INTACTO"
  },
  {
    "codigo":51040009,
    "descripcion":"INTOXICACIÓN POR TALIO"
  },
  {
    "codigo":278581003,
    "descripcion":"ENCHAPADO DENTAL EXCESIVAMENTE CLARO"
  },
  {
    "codigo":442421004,
    "descripcion":"ARTERIOSCLEROSIS DE INJERTO-PUENTE ARTERIAL EN ARTERIA CORONARIA"
  },
  {
    "codigo":737333006,
    "descripcion":"TRASTORNO DE VENA POSTERIOR A EMBARAZO MOLAR"
  },
  {
    "codigo":735498002,
    "descripcion":"TRASTORNO PERINATAL DE TEGUMENTO"
  },
  {
    "codigo":80138003,
    "descripcion":"SÍNDROME DE ISAACS"
  },
  {
    "codigo":440586004,
    "descripcion":"RECIBIÓ ENTRENAMIENTO VOCACIONAL"
  },
  {
    "codigo":5299007,
    "descripcion":"ESTAFILOMA ANULAR"
  },
  {
    "codigo":243978007,
    "descripcion":"LESIÓN TRAUMÁTICA HEPÁTICA"
  },
  {
    "codigo":242143000,
    "descripcion":"LESIÓN DE CONDUCTOR DE MOTOCICLETA DE PASEO FUERA DE CAMINO PÚBLICO"
  },
  {
    "codigo":1259786008,
    "descripcion":"TUMOR RABDOIDE EXTRARRENAL PRIMARIO"
  },
  {
    "codigo":405983002,
    "descripcion":"HALLAZGO RELACIONADO CON EL MARGEN DE RESECCIÓN QUIRÚRGICA MESENTÉRICO"
  },
  {
    "codigo":307679004,
    "descripcion":"NISTAGMO EN VAIVÉN PARCIAL"
  },
  {
    "codigo":209375005,
    "descripcion":"FRACTURA-SUBLUXACIÓN NO EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA DE UN SOLO DEDO DEL PIE"
  },
  {
    "codigo":1290719009,
    "descripcion":"ARTRITIS INFECCIOSA DE ARTICULACIÓN DE REGIÓN DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":1354420003,
    "descripcion":"INMUNODEFICIENCIA COMBINADA VARIABLE AUTOSÓMICA DOMINANTE DEBIDA A MUTACIÓN DE IRF2BP2"
  },
  {
    "codigo":699060003,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIOS SUPERFICIALES DEL CUELLO"
  },
  {
    "codigo":830132005,
    "descripcion":"ÚLCERA DE PIE IZQUIERDO CURADA"
  },
  {
    "codigo":371380006,
    "descripcion":"FILTRACIÓN DE LÍQUIDO AMNIÓTICO"
  },
  {
    "codigo":305844004,
    "descripcion":"VISTO EN EL SERVICIO DE LUDOTERAPIA"
  },
  {
    "codigo":205705003,
    "descripcion":"CROMOSOMA SEXUAL ADICIONAL"
  },
  {
    "codigo":1287049004,
    "descripcion":"CUERPO EXTRAÑO METÁLICO EN CABEZA Y\/O CUELLO"
  },
  {
    "codigo":9097005,
    "descripcion":"ESTIGMA"
  },
  {
    "codigo":238473008,
    "descripcion":"ECCEMA PALMAR POR FRICCIÓN"
  },
  {
    "codigo":269406001,
    "descripcion":"INFECCIÓN DE HERIDA POSTRAUMÁTICA"
  },
  {
    "codigo":402313009,
    "descripcion":"EXACERBACIÓN DE PSORIASIS CON PLACAS PREEXISTENTES CON CARACTERÍSTICAS DE PSORIASIS EN GOTAS"
  },
  {
    "codigo":302174000,
    "descripcion":"ANOMALÍA CONGÉNITA DEL IRIS Y CUERPO CILIAR"
  },
  {
    "codigo":236638006,
    "descripcion":"SENSACIÓN ANORMAL EN VEJIGA URINARIA"
  },
  {
    "codigo":7262008,
    "descripcion":"AUMENTO HORMONAL"
  },
  {
    "codigo":726323001,
    "descripcion":"LESIÓN TRAUMÁTICA DE FASCIA DE MÚSCULO INTRÍNSECO DEL PIE"
  },
  {
    "codigo":365875000,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA RECORDAR DIRECCIONES AL AZAR A LOS CINCO MINUTOS"
  },
  {
    "codigo":300339003,
    "descripcion":"HALLAZGO RELACIONADO CON LA VÍA BILIAR"
  },
  {
    "codigo":333331000119100,
    "descripcion":"ENDOFTALMITIS DE OJO DERECHO CAUSADA POR PARÁSITO"
  },
  {
    "codigo":16064531000119101,
    "descripcion":"HAMARTOMA CONGÉNITO DE IRIS"
  },
  {
    "codigo":323091000119101,
    "descripcion":"LONGITUD DESIGUAL DE EXTREMIDAD SUPERIOR DEBIDA A ACORTAMIENTO ADQUIRIDO DE CÚBITO IZQUIERDO"
  },
  {
    "codigo":85011000119101,
    "descripcion":"DOLOR EN PELVIS MASCULINA"
  },
  {
    "codigo":12268051000119102,
    "descripcion":"SÍNDROME COMPARTIMENTAL TRAUMÁTICO DE MIEMBRO SUPERIOR DERECHO"
  },
  {
    "codigo":346131000119105,
    "descripcion":"ATROFIA ESENCIAL DE IRIS DE AMBOS OJOS"
  },
  {
    "codigo":335891000119106,
    "descripcion":"LAGOFTALMOS CICATRIZAL DERECHO"
  },
  {
    "codigo":12214291000119107,
    "descripcion":"INFECCIÓN DE FÉMUR IZQUIERDO ASOCIADA CON DISPOSITIVO DE FIJACIÓN INTERNA"
  },
  {
    "codigo":328211000119107,
    "descripcion":"DACTILITIS DE DEDO DE LA MANO"
  },
  {
    "codigo":12247571000119109,
    "descripcion":"DOLOR ARTICULAR DE AMBOS PIES"
  },
  {
    "codigo":12065811000119106,
    "descripcion":"TRASTORNO DEBIDO A CREACIÓN DE FÍSTULA ARTERIOVENOSA QUIRÚRGICA"
  },
  {
    "codigo":305171000119108,
    "descripcion":"HIPERLORDOSIS CONGÉNITA DE COLUMNA VERTEBRAL LUMBOSACRA"
  },
  {
    "codigo":1088531000119109,
    "descripcion":"OTITIS MEDIA CRÓNICA DEL OÍDO IZQUIERDO LUEGO DE LA INSERCIÓN DE DISPOSITIVO DE VENTILACIÓN TIMPÁNICA"
  },
  {
    "codigo":724488005,
    "descripcion":"PARTO PRETÉRMINO POSTERIOR A INDUCCIÓN DEL TRABAJO DE PARTO"
  },
  {
    "codigo":298504003,
    "descripcion":"HALLAZGO RELACIONADO CON EL MOVIMIENTO DE LA COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":722653002,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÉDULA ESPINAL LUMBAR"
  },
  {
    "codigo":338451000119107,
    "descripcion":"PSEUDOPTERIGIÓN DE OJO IZQUIERDO"
  },
  {
    "codigo":292371000119109,
    "descripcion":"NEURITIS ILIOINGUINAL IZQUIERDA"
  },
  {
    "codigo":296669007,
    "descripcion":"SOBREDOSIS DE CEFALOSPORINA DE PRIMERA GENERACIÓN"
  },
  {
    "codigo":130994002,
    "descripcion":"ALTERACIÓN DEL SISTEMA ENDOCRINO"
  },
  {
    "codigo":720818003,
    "descripcion":"CRANEOSINOSTOSIS TIPO FILADELFIA"
  },
  {
    "codigo":1343410008,
    "descripcion":"HISTEROSALPINGOGRAFÍA FLUOROSCÓPICA CON CONTRASTE ANORMAL"
  },
  {
    "codigo":292999002,
    "descripcion":"REACCIÓN ADVERSA A LA CEFAZOLINA"
  },
  {
    "codigo":1144967004,
    "descripcion":"ADHERENCIAS DE FONDO DE SACO DE DOUGLAS DEBIDAS A ENDOMETRIOSIS"
  },
  {
    "codigo":94556001,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA PIEL DEL PIE"
  },
  {
    "codigo":225628002,
    "descripcion":"MIEDO A SER DEJADO SOLO DURANTE UN PERÍODO DE DEPENDENCIA"
  },
  {
    "codigo":10676591000119100,
    "descripcion":"ASMA PERSISTENTE MODERADA CONTROLADA CONCOMITANTE CON RINITIS ALÉRGICA"
  },
  {
    "codigo":127324008,
    "descripcion":"TRASTORNO MIOCLÓNICO"
  },
  {
    "codigo":289329000,
    "descripcion":"MUÑÓN UMBILICAL CON MAL OLOR"
  },
  {
    "codigo":1336070001,
    "descripcion":"EPISODIO DE USO NOCIVO DE HORMONA ESTEROIDE"
  },
  {
    "codigo":254726003,
    "descripcion":"TUMOR MALIGNO DE PIEL CON DIFERENCIACIÓN APOCRINA"
  },
  {
    "codigo":90886006,
    "descripcion":"MIASIS RECTAL"
  },
  {
    "codigo":25350007,
    "descripcion":"INFECCIÓN CAUSADA POR TRYPANOSOMA SIMIAE"
  },
  {
    "codigo":123654008,
    "descripcion":"ANOMALÍA CONGÉNITA DEL APARATO RESPIRATORIO INFERIOR"
  },
  {
    "codigo":416731003,
    "descripcion":"ARRASTRE DE LA PIEL"
  },
  {
    "codigo":1091951000119104,
    "descripcion":"OTITIS MEDIA DERECHA"
  },
  {
    "codigo":1268699008,
    "descripcion":"CARCINOMA PILOMATRICIAL PRIMARIO DE PIEL"
  },
  {
    "codigo":251056002,
    "descripcion":"DEFECTO DE LA PERFUSIÓN MIOCÁRDICA PARCIALMENTE REVERSIBLE"
  },
  {
    "codigo":354671000119106,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE HUESO DE MIEMBRO SUPERIOR DERECHO"
  },
  {
    "codigo":54448005,
    "descripcion":"INFECCIÓN CAUSADA POR ASPICULURIS"
  },
  {
    "codigo":283824007,
    "descripcion":"MORDEDURA DE ANIMAL EN LA CADERA"
  },
  {
    "codigo":447664007,
    "descripcion":"CONEXIÓN VENOSA PULMONAR ANÓMALA PARCIAL DE PARTE DEL PULMÓN IZQUIERDO"
  },
  {
    "codigo":314757003,
    "descripcion":"PENFIGOIDE CICATRIZAL OCULAR"
  },
  {
    "codigo":19845004,
    "descripcion":"HIPERPLASIA SENIL DE LAS GLÁNDULAS SEBÁCEAS"
  },
  {
    "codigo":52613005,
    "descripcion":"SUDORACIÓN EXCESIVA"
  },
  {
    "codigo":249221003,
    "descripcion":"DESGARRO LABIAL"
  },
  {
    "codigo":247386004,
    "descripcion":"NEURALGIA DE NERVIO OBTURADOR"
  },
  {
    "codigo":116314006,
    "descripcion":"HALLAZGO RELACIONADO CON LA REGIÓN DE LA RODILLA"
  },
  {
    "codigo":312922007,
    "descripcion":"EDEMA MACULAR CISTOIDEO RELACIONADO CON UVEÍTIS"
  },
  {
    "codigo":83546008,
    "descripcion":"ANOMALÍA CONGÉNITA DE GLÁNDULA MAMARIA"
  },
  {
    "codigo":1197658008,
    "descripcion":"ANGIOMAS ARACNIFORMES DE PIEL"
  },
  {
    "codigo":1163055001,
    "descripcion":"ENCEFALITIS POR VIRUS MACHUPO"
  },
  {
    "codigo":442159003,
    "descripcion":"PANCOLITIS ULCEROSA CRÓNICA"
  },
  {
    "codigo":704303006,
    "descripcion":"PROBLEMA CON LA CONTINUIDAD DE LA ATENCIÓN"
  },
  {
    "codigo":81711008,
    "descripcion":"ANEMIA HEMOLÍTICA CAUSADA POR FÁRMACOS"
  },
  {
    "codigo":276484003,
    "descripcion":"ESCURRIMIENTO"
  },
  {
    "codigo":309252004,
    "descripcion":"INCAPAZ DE LEER"
  },
  {
    "codigo":15729161000119106,
    "descripcion":"LUXACIÓN DE TOBILLO IZQUIERDO DEBIDA A DISPLASIA CONGÉNITA"
  },
  {
    "codigo":1259524006,
    "descripcion":"DEMENCIA DEBIDA A TRIPANOSOMIASIS"
  },
  {
    "codigo":473092007,
    "descripcion":"INFECCIÓN E INFLAMACIÓN ASOCIADAS CON CATÉTER INTERNO EN LA VÍA URINARIA"
  },
  {
    "codigo":733401002,
    "descripcion":"MORDEDURA ABIERTA EN REGIÓN DEL HOMBRO"
  },
  {
    "codigo":307417003,
    "descripcion":"PSICOSIS CICLOIDE"
  },
  {
    "codigo":11770531000119101,
    "descripcion":"SUBLUXACIÓN ANTERIOR DE CABEZA DE RADIO IZQUIERDO"
  },
  {
    "codigo":897241007,
    "descripcion":"CURVATURA ANORMAL DE FALANGE DISTAL DE PIE"
  },
  {
    "codigo":372953007,
    "descripcion":"INFECCIÓN CAUSADA POR PENICILLIUM FREQUENTANS"
  },
  {
    "codigo":241881009,
    "descripcion":"EFECTO TÓXICO CAUSADO POR RESTAURADOR DE PINCELES"
  },
  {
    "codigo":240046001,
    "descripcion":"DISTROFIA MUSCULAR CON DISTRIBUCIÓN PREDOMINANTE EN CINTURAS PROXIMALES DE EXTREMIDADES"
  },
  {
    "codigo":371118004,
    "descripcion":"ANOMALÍA CONGÉNITA DE LA FUNCIÓN ENDOCRINA GONADAL"
  },
  {
    "codigo":305582004,
    "descripcion":"BAJO ATENCIÓN DE ENFERMERA DE ENLACE"
  },
  {
    "codigo":403886007,
    "descripcion":"ENFERMEDAD DE BOWEN, CLONAL"
  },
  {
    "codigo":860803004,
    "descripcion":"HIDROCEFALIA DEBIDA A TUBERCULOSIS DE ENCÉFALO"
  },
  {
    "codigo":762499005,
    "descripcion":"RETRASO DE CRECIMIENTO DE CAUSA NUTRICIONAL EN LA LACTANCIA"
  },
  {
    "codigo":1286787007,
    "descripcion":"HIPERTENSIÓN OCULAR DEBIDA A PRESIÓN VENOSA EPIESCLERAL AUMENTADA"
  },
  {
    "codigo":170840001,
    "descripcion":"EFECTO COLATERAL DE FÁRMACO PARA LA ALERGIA"
  },
  {
    "codigo":269144002,
    "descripcion":"CONTUSIÓN Y LACERACIÓN DE CEREBRO"
  },
  {
    "codigo":301912007,
    "descripcion":"HALLAZGO RELACIONADO CON LA APARIENCIA PALPEBRAL"
  },
  {
    "codigo":7000009,
    "descripcion":"MUERTE FETAL POR ABORTO ESPONTÁNEO"
  },
  {
    "codigo":236376009,
    "descripcion":"QUISTE RENAL INFECTADO"
  },
  {
    "codigo":201773004,
    "descripcion":"ARTRITIS REUMATOIDE DE LA ARTICULACIÓN INTERFALÁNGICA PROXIMAL DE DEDO DE LA MANO"
  },
  {
    "codigo":70701004,
    "descripcion":"AMBLIOPÍA ALCOHÓLICA"
  },
  {
    "codigo":234541006,
    "descripcion":"DEFICIENCIA SELECTIVA DE INMUNOGLOBULINA D"
  },
  {
    "codigo":10761021000119102,
    "descripcion":"ABUSO SEXUAL QUE COMPLICA EL NACIMIENTO"
  },
  {
    "codigo":789762004,
    "descripcion":"CONJUGACIÓN TARDÍA DE BILIRRUBINA"
  },
  {
    "codigo":396546004,
    "descripcion":"MARGEN QUIRÚRGICO DEL COLÉDOCO NO COMPROMETIDO POR CARCINOMA IN SITU"
  },
  {
    "codigo":134402008,
    "descripcion":"PÓLIPO DE COLESTEROL DE LA VESÍCULA BILIAR"
  },
  {
    "codigo":298242008,
    "descripcion":"ARTICULACIÓN SUBASTRAGALINA RÍGIDA"
  },
  {
    "codigo":724226009,
    "descripcion":"SÍNDROME DE OSTEOPETROSIS INFANTIL CON DISPLASIA NEUROAXONAL"
  },
  {
    "codigo":296407000,
    "descripcion":"SOBREDOSIS DE ESTIMULANTE RESPIRATORIO"
  },
  {
    "codigo":198103001,
    "descripcion":"MASTITIS CRÓNICA NO PUERPERAL"
  },
  {
    "codigo":722391005,
    "descripcion":"ERITRODERMIA CONGÉNITA LETAL"
  },
  {
    "codigo":294572007,
    "descripcion":"ALERGIA A SULFALENO"
  },
  {
    "codigo":30593001,
    "descripcion":"COMPLICACIÓN TEMPRANA"
  },
  {
    "codigo":1144705003,
    "descripcion":"HIPOPLASIA CONGÉNITA DE FALANGE DE DEDO GORDO"
  },
  {
    "codigo":724531005,
    "descripcion":"ÚLCERA DE DUODENO CAUSADA POR RADIACIÓN IONIZANTE"
  },
  {
    "codigo":292737005,
    "descripcion":"REACCIÓN ADVERSA A LA NALTREXONA"
  },
  {
    "codigo":718721006,
    "descripcion":"ANALBUMINEMIA CONGÉNITA"
  },
  {
    "codigo":94294002,
    "descripcion":"NEOPLASIA MALIGNA SECUNDARIA DEL NERVIO FACIAL"
  },
  {
    "codigo":127062003,
    "descripcion":"ERITROCITOSIS"
  },
  {
    "codigo":290902005,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR CITALOPRAM"
  },
  {
    "codigo":92459005,
    "descripcion":"NEOPLASIA BENIGA DEL MIEMBRO SUPERIOR"
  },
  {
    "codigo":715051005,
    "descripcion":"INFECCIÓN CAUSADA POR ARMILLIFER GRANDIS"
  },
  {
    "codigo":289067006,
    "descripcion":"CAPAZ DE UTILIZAR DISPOSITIVO PARA LA ALIMENTACIÓN"
  },
  {
    "codigo":16059351000119106,
    "descripcion":"DEFECTO DEL CAMPO VISUAL CON ESCALÓN NASAL DE OJO DERECHO"
  },
  {
    "codigo":418304008,
    "descripcion":"INSUFICIENCIA CARDÍACA DIASTÓLICA"
  },
  {
    "codigo":285397001,
    "descripcion":"SENSACIÓN DE OPRESIÓN DEL BRAZO"
  },
  {
    "codigo":187093007,
    "descripcion":"CRIPTOCOCOSIS HEPÁTICA"
  },
  {
    "codigo":283562000,
    "descripcion":"HERIDA DE PERDIGÓN EN BRAZO"
  },
  {
    "codigo":447402003,
    "descripcion":"INFECCIÓN VAGINAL CAUSADA POR CHLAMYDIA TRACHOMATIS"
  },
  {
    "codigo":707711006,
    "descripcion":"LINFANGIECTASIA PULMONAR PRIMARIA CONGÉNITA"
  },
  {
    "codigo":312660000,
    "descripcion":"EFECTO TARDÍO DE FRACTURA DE VÉRTEBRA CERVICAL"
  },
  {
    "codigo":609407009,
    "descripcion":"REACCIÓN DE HIPERSENSIBILIDAD INMUNITARIA POR MECANISMO"
  },
  {
    "codigo":83284001,
    "descripcion":"MELANOMA, NIVEL 1 DE CLARK"
  },
  {
    "codigo":871551009,
    "descripcion":"REACCIÓN ADVERSA A AGENTE BLOQUEANTE NEUROMUSCULAR"
  },
  {
    "codigo":443732006,
    "descripcion":"INSATISFACCIÓN CON LA IMAGEN CORPORAL"
  },
  {
    "codigo":247124009,
    "descripcion":"MACROANEURISMA RETINIANO"
  },
  {
    "codigo":441897002,
    "descripcion":"CINC EN ESPÉCIMEN DE SANGRE FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":310825003,
    "descripcion":"DIFICULTAD PARA DEDUCIR EL SIGNIFICADO"
  },
  {
    "codigo":278057003,
    "descripcion":"TUMOR DE TESTÍCULO DE CÉLULAS DE SERTOLI"
  },
  {
    "codigo":1162793009,
    "descripcion":"FOSFATASA ALCALINA INTESTINAL DENTRO DE RANGO DE REFERENCIA"
  },
  {
    "codigo":276222004,
    "descripcion":"SÍNDROME DEL TOPE DE LA BASILAR"
  },
  {
    "codigo":15705201000119109,
    "descripcion":"CONDROCALCINOSIS DE AMBAS MANOS"
  },
  {
    "codigo":866046008,
    "descripcion":"PENFIGOIDE DE MEMBRANA MUCOSA DE PENE"
  },
  {
    "codigo":833278008,
    "descripcion":"SOSPECHA DE GLAUCOMA"
  },
  {
    "codigo":472830009,
    "descripcion":"TRASTORNO DE PRÓTESIS DE VÁLVULA AURICULOVENTRICULAR DERECHA (MORFOLÓGICAMENTE NO TRICÚSPIDE)"
  },
  {
    "codigo":733139004,
    "descripcion":"ESTADIO 3 DE INSUFICIENCIA RENAL AGUDA"
  },
  {
    "codigo":208851005,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA EXPUESTA DE LA ARTICULACIÓN CARPOMETACARPIANA"
  },
  {
    "codigo":698536004,
    "descripcion":"REQUIERE DISPOSITIVO OCLUSAL BLANDO"
  },
  {
    "codigo":403624005,
    "descripcion":"ERUPCIÓN POR HALÓGENO"
  },
  {
    "codigo":272552006,
    "descripcion":"POSICIÓN: SENTADO A HORCAJADAS"
  },
  {
    "codigo":145194251000119106,
    "descripcion":"CARCINOMA BASOCELULAR DE PIE DERECHO"
  },
  {
    "codigo":75944007,
    "descripcion":"TIEMPO DE VIDA DE LAS PLAQUETAS DISMINUIDO"
  },
  {
    "codigo":43176009,
    "descripcion":"HIPOPLASIA CONGÉNITA DE VÁLVULA TRICÚSPIDE"
  },
  {
    "codigo":303485002,
    "descripcion":"CAPAZ DE ACORDONARSE EL CALZADO"
  },
  {
    "codigo":41341006,
    "descripcion":"ESTENOSIS DE CONDUCTO RAQUÍDEO EN REGIÓN DORSAL"
  },
  {
    "codigo":72274001,
    "descripcion":"TRASTORNO DE LA RAÍZ DE NERVIO"
  },
  {
    "codigo":301650004,
    "descripcion":"CAPAZ DE SENTARSE EN UNA SILLA"
  },
  {
    "codigo":6738008,
    "descripcion":"INFERTILIDAD FEMENINA"
  },
  {
    "codigo":430887001,
    "descripcion":"DISFUNCIÓN DEL ESFÍNTER DE ODDI"
  },
  {
    "codigo":236114008,
    "descripcion":"NECROSIS DE ANASTOMOSIS DEL INTESTINO DELGADO"
  },
  {
    "codigo":203346009,
    "descripcion":"ENFERMEDAD DE PAGET DEL CALCÁNEO"
  },
  {
    "codigo":170578008,
    "descripcion":"MAL CONTROL DE LA HIPERTENSIÓN ARTERIAL"
  },
  {
    "codigo":399954008,
    "descripcion":"CARCINOMA BASOCELULAR DE LÓBULO DE LA OREJA"
  },
  {
    "codigo":398119006,
    "descripcion":"RECUPERACIÓN TARDÍA DE ANESTESIA GENERAL"
  },
  {
    "codigo":232444000,
    "descripcion":"PARÁLISIS ADQUIRIDA DE CUERDA VOCAL"
  },
  {
    "codigo":297980001,
    "descripcion":"OBSERVACIONES POSTERIORES A PROCEDIMIENTOS CUTÁNEOS"
  },
  {
    "codigo":299815009,
    "descripcion":"REFLEJO DE PESTAÑEO AUSENTE"
  },
  {
    "codigo":429052003,
    "descripcion":"TRASTORNO DE CARTÍLAGO ARTICULAR DE LA MUÑECA"
  },
  {
    "codigo":363516004,
    "descripcion":"NEOPLASIA MALIGNA DE PENE"
  },
  {
    "codigo":365351009,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA ANDAR EN BICICLETA"
  },
  {
    "codigo":60991000119100,
    "descripcion":"CEGUERA DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":230609001,
    "descripcion":"NEUROPATÍA PROVOCADA POR METAL PESADO"
  },
  {
    "codigo":333221000119109,
    "descripcion":"CORIORRETINITIS DISEMINADA PERIFÉRICA DE OJO DERECHO"
  },
  {
    "codigo":95867001,
    "descripcion":"EXPOSICIÓN AL CALOR"
  },
  {
    "codigo":292475006,
    "descripcion":"REACCIÓN ADVERSA A LA PIRIDOSTIGMINA"
  },
  {
    "codigo":61264001,
    "descripcion":"DÉFICIT EN EL AUTOCONTROL DEL DOLOR, AGUDO"
  },
  {
    "codigo":290640005,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR BLEOMICINA"
  },
  {
    "codigo":15681241000119100,
    "descripcion":"DERMATITIS BILATERAL DE PÁRPADOS CAUSADA POR VIRUS HERPES SIMPLE"
  },
  {
    "codigo":94032008,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA PIEL DE LOS LABIOS"
  },
  {
    "codigo":92197001,
    "descripcion":"NEOPLASIA BENIGNA DE GANGLIO LINFÁTICO"
  },
  {
    "codigo":419877002,
    "descripcion":"CLASE III DEL CENTRO DE PREVENCIÓN Y CONTROL DE ENFERMEDADES\/CONTAMINADO"
  },
  {
    "codigo":190501008,
    "descripcion":"SÍNDROME DE CUSHING IDIOPÁTICO"
  },
  {
    "codigo":876794002,
    "descripcion":"ASTILLA EN ANO CON INFECCIÓN"
  },
  {
    "codigo":246967871000119109,
    "descripcion":"DEDO EN GARRA ADQUIRIDO DE PIE IZQUIERDO"
  },
  {
    "codigo":16910041000119103,
    "descripcion":"LAGOFTALMÍA DE AMBOS PÁRPADOS SUPERIORES E INFERIORES INFERIORES, BILATERAL"
  },
  {
    "codigo":286970007,
    "descripcion":"HERNIA CRURAL COMPLICADA"
  },
  {
    "codigo":88527005,
    "descripcion":"EMBOLIA DE PENE"
  },
  {
    "codigo":448975006,
    "descripcion":"TÚNEL AORTOVENTRICULAR IZQUIERDO CON ANEURISMA EXTRACARDÍACO DE PARED AÓRTICA"
  },
  {
    "codigo":55759009,
    "descripcion":"PESO ESPECÍFICO POR ENCIMA DE RANGO DE REFERENCIA"
  },
  {
    "codigo":53924004,
    "descripcion":"AMPOLLA DE AXILA, SIN INFECCIÓN"
  },
  {
    "codigo":335731000119100,
    "descripcion":"CONJUNTIVOCALASIA DE OJO DERECHO"
  },
  {
    "codigo":283300007,
    "descripcion":"ASTILLA DE MADERA EN MAMA"
  },
  {
    "codigo":1231737000,
    "descripcion":"SÍNDROME DE EPILEPSIA ROLÁNDICA, DISTONIA PAROXÍSTICA INDUCIDA POR EJERCICIO Y CALAMBRE DE ESCRITOR"
  },
  {
    "codigo":445305001,
    "descripcion":"HEMANGIOMA CAVERNOSO DE PIEL"
  },
  {
    "codigo":52089001,
    "descripcion":"ARTERITIS"
  },
  {
    "codigo":838521001,
    "descripcion":"SOBREDOSIS INTENCIONAL DE METILENDIOXIMETANFETAMINA"
  },
  {
    "codigo":84857004,
    "descripcion":"HERNIA DE NÚCLEO PULPOSO DE DISCO INTERVERTEBRAL"
  },
  {
    "codigo":10929881000119107,
    "descripcion":"FRACTURA NO EXPUESTA DE METÁFISIS DE CUARTO METATARSIANO DE PIE DERECHO"
  },
  {
    "codigo":707449006,
    "descripcion":"NEUMONITIS LIPOIDE EXÓGENA"
  },
  {
    "codigo":248697007,
    "descripcion":"RUIDO DE VÁLVULA PROTÉSICA AMORTIGUADO"
  },
  {
    "codigo":281465007,
    "descripcion":"APOFISITIS POR TRACCIÓN"
  },
  {
    "codigo":1264505007,
    "descripcion":"CARBUNCO DE URETRA"
  },
  {
    "codigo":246862002,
    "descripcion":"CANALÍCULO LAGRIMAL-HALLAZGO"
  },
  {
    "codigo":689881000119109,
    "descripcion":"CARCINOMA PRIMARIO INDIFERENCIADO DE PARED LATERAL DE NASOFARINGE"
  },
  {
    "codigo":310563001,
    "descripcion":"ENFERMEDAD DE LYME NO DETECTADA POR ANÁLISIS INMUNOABSORBENTE LIGADO A ENZIMAS"
  },
  {
    "codigo":212259003,
    "descripcion":"LESIÓN ABIERTA DE RAMA SENSITIVA PALMAR DE NERVIO MEDIANO"
  },
  {
    "codigo":27631000146108,
    "descripcion":"DISECCIÓN DE CAYADO AÓRTICO"
  },
  {
    "codigo":11804531000119104,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA DISTAL DE DEDO DE MANO DERECHA"
  },
  {
    "codigo":1162531007,
    "descripcion":"LEUCEMIA MIELOIDE AGUDA EN REMISIÓN TOTAL"
  },
  {
    "codigo":8051000119105,
    "descripcion":"SÍNDROME DE ABERTURA DE SALIDA TORÁCICA ARTERIAL"
  },
  {
    "codigo":13816006,
    "descripcion":"CONJUNTIVITIS PARASITARIA"
  },
  {
    "codigo":110285005,
    "descripcion":"ÚLCERA MEDICAMENTOSA"
  },
  {
    "codigo":208589005,
    "descripcion":"FRACTURA EXPUESTA DE FÉMUR DISTAL, CÓNDILO EXTERNO"
  },
  {
    "codigo":274125008,
    "descripcion":"PRIMÍPARA AÑOSA EN TRABAJO DE PARTO"
  },
  {
    "codigo":305058001,
    "descripcion":"ESTADO DEL ENCUENTRO CON EL PACIENTE"
  },
  {
    "codigo":700109009,
    "descripcion":"SÍNDROME DE BARTTER, TIPO PRENATAL 2"
  },
  {
    "codigo":403362001,
    "descripcion":"CICATRIZ HIPERTRÓFICA POR ACNÉ"
  },
  {
    "codigo":75682002,
    "descripcion":"DIABETES MELLITUS CAUSADA POR ANTICUERPOS ANTI-RECEPTOR DE INSULINA"
  },
  {
    "codigo":372429008,
    "descripcion":"COMPROMISO TUMORAL EN MARGEN DE RESECCIÓN QUIRÚRGICA PROFUNDA, PRESENTE"
  },
  {
    "codigo":11859981000119102,
    "descripcion":"ESGUINCE DE LIGAMENTO CRUZADO ANTERIOR DE RODILLA IZQUIERDA"
  },
  {
    "codigo":204919003,
    "descripcion":"PLACA DE LA PINTA ERITEMATOSA"
  },
  {
    "codigo":270455004,
    "descripcion":"PACIENTE EN ESTUDIO DE ENFERMEDAD CARDÍACA"
  },
  {
    "codigo":237687003,
    "descripcion":"DEFICIENCIA AISLADA DE SOMATOTROFINA AUTOSÓMICA DOMINANTE"
  },
  {
    "codigo":235852001,
    "descripcion":"INFARTO TRANSMURAL DEL INTESTINO"
  },
  {
    "codigo":39244004,
    "descripcion":"PERICARDITIS SECUNDARIA A MIXEDEMA"
  },
  {
    "codigo":301388005,
    "descripcion":"DOLOR A LA PALPACIÓN EN ESTRUCTURA ÓTICA"
  },
  {
    "codigo":1153356005,
    "descripcion":"LINFOMA DE ANO"
  },
  {
    "codigo":399692007,
    "descripcion":"TUMOR QUE PENETRA SEROSA, PERFORACIÓN PRESENTE"
  },
  {
    "codigo":792908009,
    "descripcion":"PROLIFERACIÓN ANGIOMATOSA DE RETINA"
  },
  {
    "codigo":234017002,
    "descripcion":"ANEURISMA SIFILÍTICO"
  },
  {
    "codigo":12105741000119107,
    "descripcion":"QUEMADURA DE MANO DERECHA"
  },
  {
    "codigo":11833511000119101,
    "descripcion":"ESGUINCE DE LIGAMENTO CALCANEOPERONEO DE TOBILLO DERECHO"
  },
  {
    "codigo":299553005,
    "descripcion":"ARTICULACIÓN SUBASTRAGALINA DOLOROSA A LA PALPACIÓN"
  },
  {
    "codigo":365089006,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA IMITAR GESTOS"
  },
  {
    "codigo":102945007,
    "descripcion":"CONDUCTA SEXUAL NORMAL"
  },
  {
    "codigo":1217057008,
    "descripcion":"DEFICIENCIA DE GLÁNDULAS ENDOCRINAS MÚLTIPLES"
  },
  {
    "codigo":4641009,
    "descripcion":"CARDIOPATÍA POR MIXEDEMA"
  },
  {
    "codigo":166646003,
    "descripcion":"NIVEL DE ALANINA AMINOTRANSFERASA FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":2806008,
    "descripcion":"TRASTORNO DEL DESARROLLO PSICOMOTOR"
  },
  {
    "codigo":230347003,
    "descripcion":"MIOCLONÍA DEL CORDÓN SEGMENTARIO"
  },
  {
    "codigo":787403004,
    "descripcion":"METABOLIZADOR NORMAL-LENTO DE LA FAMILIA 3 SUBFAMILIA A MIEMBRO 5 DEL CITOCROMO P450"
  },
  {
    "codigo":164811005,
    "descripcion":"PRUEBA ESPECIAL EN LA MUJER - NORMAL"
  },
  {
    "codigo":197579006,
    "descripcion":"GLOMERULONEFRITIS PROLIFERATIVA AGUDA"
  },
  {
    "codigo":295883004,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE PROTRIPTILINA"
  },
  {
    "codigo":263115008,
    "descripcion":"FRACTURA-SUBLUXACIÓN DE ARTICULACIÓN DE TOBILLO"
  },
  {
    "codigo":392352004,
    "descripcion":"GLAUCOMA POR RECESIÓN DE ÁNGULO"
  },
  {
    "codigo":64672005,
    "descripcion":"LESIÓN TRAUMÁTICA DEL TRONCO BRAQUIOCEFÁLICO"
  },
  {
    "codigo":228512004,
    "descripcion":"NUNCA MASTICÓ TABACO"
  },
  {
    "codigo":294048007,
    "descripcion":"ALERGIA A DOPEXAMINA"
  },
  {
    "codigo":30069002,
    "descripcion":"ESPASMO DE ACOMODACIÓN"
  },
  {
    "codigo":62837005,
    "descripcion":"CELULITIS DE LA MANO"
  },
  {
    "codigo":783733006,
    "descripcion":"DISPLASIA FIBROMUSCULAR DE PARED DE AMBAS ARTERIAS CARÓTIDAS"
  },
  {
    "codigo":1268488004,
    "descripcion":"CARCINOMA PRIMARIO DE ESTÓMAGO DEBIDO A ENFERMEDAD POR VIRUS EPSTEIN - BARR"
  },
  {
    "codigo":290378001,
    "descripcion":"INTOXICACIÓN POR CARBENOXOLONA"
  },
  {
    "codigo":95605009,
    "descripcion":"SÍNDROME HELLP"
  },
  {
    "codigo":292213009,
    "descripcion":"REACCIÓN ADVERSA A LA LOMUSTINA"
  },
  {
    "codigo":126538005,
    "descripcion":"NEOPLASIA DE HUESO DEL CRÁNEO"
  },
  {
    "codigo":716362006,
    "descripcion":"ENFERMEDAD GINGIVAL CONCOMITANTE CON DIABETES MELLITUS"
  },
  {
    "codigo":714527000,
    "descripcion":"PROFUNDIDAD DEL VESTÍBULO MANDIBULAR DISMINUIDA"
  },
  {
    "codigo":93770008,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE CONDUCTO CÍSTICO"
  },
  {
    "codigo":26399002,
    "descripcion":"ALBINISMO OCULAR"
  },
  {
    "codigo":124703008,
    "descripcion":"DEFICIENCIA DE COLATO - COA LIGASA"
  },
  {
    "codigo":1075521000119105,
    "descripcion":"HIPERLAXITUD ARTICULAR DE PIE IZQUIERDO"
  },
  {
    "codigo":91935009,
    "descripcion":"ALERGIA A MANÍ"
  },
  {
    "codigo":253940004,
    "descripcion":"DUPLICACIÓN DE FÉMUR"
  },
  {
    "codigo":57332004,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DE HOMBRO"
  },
  {
    "codigo":1204212006,
    "descripcion":"OCLUSIÓN AGUDA DE ARTERIA BRAQUIAL DEBIDA A TROMBOSIS"
  },
  {
    "codigo":286708006,
    "descripcion":"TIENDE A NO TOLERAR EL ABURRIMIENTO"
  },
  {
    "codigo":448713003,
    "descripcion":"CATÉTER INTRAVENOSO IN SITU"
  },
  {
    "codigo":219337003,
    "descripcion":"LESIÓN POR RIFLE DE CAZA, CON PROPÓSITO DESCONOCIDO"
  },
  {
    "codigo":284873008,
    "descripcion":"NO SE CORTA LAS UÑAS"
  },
  {
    "codigo":283038004,
    "descripcion":"LESIÓN SUPERFICIAL DE LOS GENITALES FEMENINOS"
  },
  {
    "codigo":1003934007,
    "descripcion":"DELECIÓN PROXIMAL DEL CROMOSOMA 14"
  },
  {
    "codigo":84595002,
    "descripcion":"FRACTURAS MÚLTIPLES EXPUESTAS DEL EXTREMO SUPERIOR DEL CÚBITO"
  },
  {
    "codigo":15630811000119104,
    "descripcion":"UVEÍTIS DEL OJO IZQUIERDO"
  },
  {
    "codigo":248435007,
    "descripcion":"FIEBRE PROLONGADA"
  },
  {
    "codigo":836424002,
    "descripcion":"LUXACIÓN DE ARTICULACIÓN DE PIE"
  },
  {
    "codigo":312136003,
    "descripcion":"INFECCIÓN VIRAL DEL SISTEMA MUSCULOESQUELÉTICO"
  },
  {
    "codigo":1196872006,
    "descripcion":"DEFECTO DE GEN DE SUBUNIDAD ESTRUCTURAL DE COMPLEJO I DE CADENA RESPIRATORIA MITOCONDRIAL"
  },
  {
    "codigo":310301000,
    "descripcion":"ESTADO DE LA MANIFESTACIÓN DE LA VOLUNTAD"
  },
  {
    "codigo":441373001,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE CABEZA Y\/O CUELLO SIN INFECCIÓN"
  },
  {
    "codigo":277533007,
    "descripcion":"ALUCINACIONES AUDITIVAS VERBALES EN TERCERA PERSONA"
  },
  {
    "codigo":12245621000119102,
    "descripcion":"INSUFICIENCIA RENAL AGUDA POSTERIOR A PROCEDIMIENTO"
  },
  {
    "codigo":15932021000119102,
    "descripcion":"TORSIÓN DE OVARIO IZQUIERDO"
  },
  {
    "codigo":77255002,
    "descripcion":"INFARTO TROMBÓTICO"
  },
  {
    "codigo":110023008,
    "descripcion":"FRACTURA PIRAMIDAL DE MAXILAR SUPERIOR NO EXPUESTA"
  },
  {
    "codigo":403100001,
    "descripcion":"ONICOMICOSIS CAUSADA POR SCOPULARIOPSIS BREVICAULIS"
  },
  {
    "codigo":206492004,
    "descripcion":"HIPOCALIEMIA NEONATAL TRANSITORIA"
  },
  {
    "codigo":1156764005,
    "descripcion":"PARÁLISIS SUPRANUCLEAR PROGRESIVA-PARKINSONIMO"
  },
  {
    "codigo":8049000,
    "descripcion":"INTOXICACIÓN POR LANTANA CÁMARA"
  },
  {
    "codigo":302961007,
    "descripcion":"HIPOPLASIA ESPLÉNICA HEREDITARIA"
  },
  {
    "codigo":202822001,
    "descripcion":"INESTABILIDAD CERVICODORSAL"
  },
  {
    "codigo":301126002,
    "descripcion":"HALLAZGO RELACIONADO CON LOS RUIDOS CARDÍACOS"
  },
  {
    "codigo":6214005,
    "descripcion":"SECRECIÓN NORMAL DEL INTESTINO DELGADO"
  },
  {
    "codigo":38982006,
    "descripcion":"ESOFAGOCELE ADQUIRIDO"
  },
  {
    "codigo":399430006,
    "descripcion":"LINFOMA CIRCUNSCRIPTO A MUCOSA Y\/O SUBMUCOSA"
  },
  {
    "codigo":366662007,
    "descripcion":"HALLAZGO RELACIONADO CON LA TEXTURA DEL PELO"
  },
  {
    "codigo":364827001,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA UBICAR AL BEBÉ PARA AMAMANTARLO"
  },
  {
    "codigo":299291006,
    "descripcion":"AMPLITUD DE ROTACIÓN INTERNA PASIVA DE ARTICULACIÓN DE CADERA, NORMAL"
  },
  {
    "codigo":723440000,
    "descripcion":"SÍNDROME NEFROGÉNICO DE ANTIDIURESIS INADECUADA"
  },
  {
    "codigo":788976000,
    "descripcion":"PARÁLISIS DE PLOMO"
  },
  {
    "codigo":233755008,
    "descripcion":"NEUMOCONIOSIS POR NÍQUEL"
  },
  {
    "codigo":362992004,
    "descripcion":"TRASTORNO AUTOINMUNITARIO DEL TEJIDO CONJUNTIVO"
  },
  {
    "codigo":231920009,
    "descripcion":"PIGMENTACIÓN DE CÓRNEA DE CAUSA MEDICAMENTOSA"
  },
  {
    "codigo":1230088003,
    "descripcion":"PATRÓN DE USO NOCIVO DE ANFETAMINA Y\/O DERIVADO DE ANFETAMINA SIN DEPENDENCIA"
  },
  {
    "codigo":295621002,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE CICLOFOSFAMIDA"
  },
  {
    "codigo":721605003,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE LOCALIZACIONES SUPERPUESTAS DE SENOS ACCESORIOS"
  },
  {
    "codigo":262853006,
    "descripcion":"CONTUSIÓN DE INTESTINO DELGADO"
  },
  {
    "codigo":424858003,
    "descripcion":"RIESGO DE VIOLENCIA EN EL AMBIENTE"
  },
  {
    "codigo":293786004,
    "descripcion":"ALERGIA A FLUDARABINA"
  },
  {
    "codigo":31642005,
    "descripcion":"GINGIVITIS AGUDA"
  },
  {
    "codigo":228250006,
    "descripcion":"COMPOSICIÓN ANORMAL DE LA MATERIA FECAL"
  },
  {
    "codigo":785306007,
    "descripcion":"LISENCEFALIA CONCOMITANTE CON HIPOPLASIA CEREBELOSA CONGÉNITA TIPO E"
  },
  {
    "codigo":95343001,
    "descripcion":"ÚLCERA CUTÁNEA POR ISQUEMIA DEBIDA A HIPERTENSIÓN ARTERIAL"
  },
  {
    "codigo":717935003,
    "descripcion":"DIÁTESIS HEMORRÁGICA DIFUSA DE COMIENZO TEMPRANO SECUNDARIA A ENFERMEDAD HEMORRÁGICA DEL FETO Y EL RECIÉN NACIDO POR DEFICIENCIA DE VITAMINA K"
  },
  {
    "codigo":291951004,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR PROCAINAMIDA"
  },
  {
    "codigo":423023005,
    "descripcion":"NEUROPATÍA POR COMPRESIÓN DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":290116001,
    "descripcion":"HALLAZGO RELACIONADO CON LA SENSIBILIDAD DEL PEZÓN"
  },
  {
    "codigo":27972004,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE LA REGIÓN INTERESCAPULAR, CON INFECCIÓN"
  },
  {
    "codigo":11783081000119106,
    "descripcion":"LUXACIÓN TRAUMÁTICA POSTERIOR NO EXPUESTA DE CADERA DERECHA"
  },
  {
    "codigo":191812006,
    "descripcion":"ALCOHOLISMO CRÓNICO EPISÓDICO"
  },
  {
    "codigo":124441000,
    "descripcion":"DEFICIENCIA DE FOSFOPROTEÍNA FOSFATASA"
  },
  {
    "codigo":1142084009,
    "descripcion":"SÍNDROME HIPERNICTEMERAL"
  },
  {
    "codigo":1240388009,
    "descripcion":"TRASTORNO NEONATAL PRECOZ DEBIDO A SÍNDROME DE TRANSFUSIÓN FETO-FETAL"
  },
  {
    "codigo":15715241000119108,
    "descripcion":"HIPOPLASIA ADQUIRIDA DE HUESO CIGOMÁTICO DERECHO"
  },
  {
    "codigo":386585008,
    "descripcion":"TRASTORNO FUNCIONAL"
  },
  {
    "codigo":253678000,
    "descripcion":"COARTACIÓN DE LA AORTA TORÁCICA"
  },
  {
    "codigo":24302002,
    "descripcion":"PLEURESÍA NEUMOCÓCICA CON DERRAME"
  },
  {
    "codigo":26137008,
    "descripcion":"INFECCIÓN CAUSADA POR COTUGNIA"
  },
  {
    "codigo":284611001,
    "descripcion":"INCAPAZ DE CONTROLAR LA AGRESIÓN"
  },
  {
    "codigo":219075006,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR VACUNA BACTERIANA"
  },
  {
    "codigo":250008001,
    "descripcion":"MARCHA DE AMPUTADO"
  },
  {
    "codigo":315544004,
    "descripcion":"NACIDO EN TONGA"
  },
  {
    "codigo":118936007,
    "descripcion":"TRASTORNO DE LA REGIÓN INGUINAL"
  },
  {
    "codigo":1263981000,
    "descripcion":"HEMORRAGIA FETAL NO TRAUMÁTICA DE FOSA POSTERIOR"
  },
  {
    "codigo":282776008,
    "descripcion":"LESIÓN DE DEDO DEL PIE"
  },
  {
    "codigo":870765002,
    "descripcion":"ERUPCIÓN ACNEIFORME DEBIDA A COMPUESTO DE YODO"
  },
  {
    "codigo":248173002,
    "descripcion":"SIMETRÍA MANDIBULAR"
  },
  {
    "codigo":84333006,
    "descripcion":"GLAUCOMA FACOGÉNICO"
  },
  {
    "codigo":1080541000119102,
    "descripcion":"LEIOMIOSARCOMA PRIMARIO DE EXTREMIDAD SUPERIOR IZQUIERDA"
  },
  {
    "codigo":705090003,
    "descripcion":"FRACTURA NO EXPUESTA DE APÓFISIS DE FÉMUR"
  },
  {
    "codigo":16235741000119103,
    "descripcion":"ENTROPIÓN CICATRIZAL DE AMBOS PÁRPADOS SUPERIORES"
  },
  {
    "codigo":16962006,
    "descripcion":"SENSACIÓN DE SER ODIADO"
  },
  {
    "codigo":770626007,
    "descripcion":"SÍNDROME DE HORNER CONGÉNITO"
  },
  {
    "codigo":442946007,
    "descripcion":"SÍNDROME DE INTERVALO QT PROLONGADO ADQUIRIDO"
  },
  {
    "codigo":736023001,
    "descripcion":"ZONA GRIS DEL CÁLCULO DE PESO PEDIÁTRICO DE BROSELOW LUTEN"
  },
  {
    "codigo":408343002,
    "descripcion":"INDICACIÓN PARA CADA MEDICAMENTO VERIFICADA"
  },
  {
    "codigo":47895001,
    "descripcion":"ENFISEMA CONGÉNITO"
  },
  {
    "codigo":275436001,
    "descripcion":"GLÁNDULA PARATIROIDES AUSENTE"
  },
  {
    "codigo":209900006,
    "descripcion":"LACERACIÓN DEL ROMBENCÉFALO CON HERIDA INTRACRANEAL ABIERTA"
  },
  {
    "codigo":766956009,
    "descripcion":"OBSTRUCCIÓN DE URÉTER"
  },
  {
    "codigo":109761002,
    "descripcion":"FRACTURAS RADICULARES MÚLTIPLES"
  },
  {
    "codigo":240833007,
    "descripcion":"ABSCESO FILARIÁSICO AGUDO DE TIMOR"
  },
  {
    "codigo":304534000,
    "descripcion":"LLANTO"
  },
  {
    "codigo":1254806001,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS TIPO FUSOCELULAR DE OROFARINGE"
  },
  {
    "codigo":238998002,
    "descripcion":"HIPERMELANOSIS FARMACÓGENA"
  },
  {
    "codigo":271766002,
    "descripcion":"TRACTO FISTULOSO DE PIEL"
  },
  {
    "codigo":370070005,
    "descripcion":"INVASIÓN TUMORAL EN PARED MUSCULAR Y\/O CAPA SUBSEROSA"
  },
  {
    "codigo":204395001,
    "descripcion":"ANEURISMA CARDÍACO CONGÉNITO"
  },
  {
    "codigo":30231000175100,
    "descripcion":"ÚLCERA POR PRESIÓN EN CODO DERECHO, ESTADIO III"
  },
  {
    "codigo":1285739008,
    "descripcion":"HIPERTENSIÓN OCULAR DEBIDA A HEMORRAGIA INTRAOCULAR"
  },
  {
    "codigo":300864006,
    "descripcion":"HALLAZGO RELACIONADO CON EL IMPULSO DE LA TUMORACIÓN CON LA TOS"
  },
  {
    "codigo":366400007,
    "descripcion":"AMPLITUD DE MOVIMIENTO PASIVO DE ROTACIÓN HACIA LA IZQUIERDA DE LA COLUMNA CERVICAL - HALLAZGO"
  },
  {
    "codigo":38720006,
    "descripcion":"EMBARAZO DE SEPTILLIZOS"
  },
  {
    "codigo":167957003,
    "descripcion":"DENSIDAD DE LÍQUIDO PLEURAL DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":266261006,
    "descripcion":"FENÓMENO DE RAYNAUD"
  },
  {
    "codigo":299029006,
    "descripcion":"ARTICULACIÓN DE LA MUÑECA HELADA AL TACTO"
  },
  {
    "codigo":297194001,
    "descripcion":"GANGLIÓN DEL PIE"
  },
  {
    "codigo":725013009,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO DEL CUELLO"
  },
  {
    "codigo":721343006,
    "descripcion":"FRACTURA DE MASA LATERAL DE PRIMERA VÉRTEBRA CERVICAL"
  },
  {
    "codigo":447007,
    "descripcion":"ENTRENADOR EN ACCIDENTE DURANTE ACTIVIDAD DEPORTIVA"
  },
  {
    "codigo":293524001,
    "descripcion":"REACCIÓN ADVERSA A LA MILRINONA"
  },
  {
    "codigo":1145492002,
    "descripcion":"HIPOPLASIA CONGÉNITA DE DEDO MEDIO DE MANO"
  },
  {
    "codigo":15691281000119106,
    "descripcion":"ARTRITIS REUMATOIDEA SERONEGATIVA DE ARTICULACIÓN DE AMBAS REGIONES DE HOMBRO"
  },
  {
    "codigo":10858001000119106,
    "descripcion":"LACERACIÓN DE MITAD IZQUIERDA DE PARED POSTERIOR DE TÓRAX"
  },
  {
    "codigo":162452008,
    "descripcion":"PRESENTA EL SÍNTOMA CADA POCOS MINUTOS"
  },
  {
    "codigo":160617001,
    "descripcion":"DEJÓ DE FUMAR"
  },
  {
    "codigo":95081003,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE PIEL DE MUSLO"
  },
  {
    "codigo":422761005,
    "descripcion":"DIFICULTAD PARA MANEJAR EL ESTRÉS"
  },
  {
    "codigo":164513451000119102,
    "descripcion":"ENDOMETRIOSIS SUPERFICIAL DE DIAFRAGMA"
  },
  {
    "codigo":715838001,
    "descripcion":"DEFORMIDAD MUCOGINGIVAL SOBRE CRESTA ALVEOLAR DESDENTADA DEBIDA A FALTA DE ENCÍA QUERATINIZADA"
  },
  {
    "codigo":1083051000119102,
    "descripcion":"OTITIS MEDIA AGUDA SEROSA RECIDIVANTE DE AMBOS OÍDOS MEDIOS"
  },
  {
    "codigo":226153009,
    "descripcion":"DIETA RICA EN VITAMINA E"
  },
  {
    "codigo":93246005,
    "descripcion":"HIPOPLASIA CONGÉNITA DEL CALCÁNEO"
  },
  {
    "codigo":224318006,
    "descripcion":"PARCIALMENTE INTEGRADO A LA ESCOLARIDAD CONVENCIONAL"
  },
  {
    "codigo":289854007,
    "descripcion":"PERINEO INTACTO"
  },
  {
    "codigo":1141822009,
    "descripcion":"COMPOSICIÓN DE INGESTA NUTRICIONAL DE PROTEÍNA Y\/O DERIVADO PROTEICO INCOMPATIBLE CON EL REQUERIMIENTO"
  },
  {
    "codigo":25875002,
    "descripcion":"FÓRMULA HIPOALERGÉNICA PARA LACTANTES"
  },
  {
    "codigo":124179003,
    "descripcion":"DEFICIENCIA DE METILENOTETRAHIDROFOLATO DESHIDROGENASA (NADP^+^)"
  },
  {
    "codigo":46931000087101,
    "descripcion":"FRACTURA DE FALANGE MEDIA DE MEÑIQUE IZQUIERDO"
  },
  {
    "codigo":91411007,
    "descripcion":"ANEMIA HEMOLÍTICA AUTOINMUNITARIA CAUSADA POR INMUNOGLOBULINA A"
  },
  {
    "codigo":253416000,
    "descripcion":"DEFECTO SEPTAL AURICULOVENTRICULAR COMPLETO: COMPONENTES AURICULAR Y VENTRICULAR"
  },
  {
    "codigo":41811000087106,
    "descripcion":"CELULITIS DE BRAZO DERECHO"
  },
  {
    "codigo":44371000087107,
    "descripcion":"CONTUSIÓN DE MÚSCULO DORSAL ANCHO IZQUIERDO"
  },
  {
    "codigo":39251000087106,
    "descripcion":"CONTUSIÓN DE GLÚTEO IZQUIERDO"
  },
  {
    "codigo":89576007,
    "descripcion":"DEGENERACIÓN PALIDONIGROESPINAL"
  },
  {
    "codigo":1269224009,
    "descripcion":"SÍNDROME DE CRANEOSINOSTOSIS, MICRORRETROGNATIA Y DISCAPACIDAD INTELECTUAL GRAVE"
  },
  {
    "codigo":218813003,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR LEVALORFANO"
  },
  {
    "codigo":1201853009,
    "descripcion":"AEROFAGIA FUNCIONAL INFANTIL"
  },
  {
    "codigo":446354001,
    "descripcion":"INTOXICACIÓN CAUSADO POR ASBESTO"
  },
  {
    "codigo":249746004,
    "descripcion":"ANGULACIÓN DEL BRAZO"
  },
  {
    "codigo":282514004,
    "descripcion":"SUBE ESCALONES CORRIENDO"
  },
  {
    "codigo":53138005,
    "descripcion":"DELIRIO INCONGRUENTE CON EL ESTADO DE ÁNIMO"
  },
  {
    "codigo":1003410007,
    "descripcion":"DUPLICACIÓN DE PORCIÓN MEDIA DE BRAZO LARGO DE CROMOSOMA 5"
  },
  {
    "codigo":247911008,
    "descripcion":"MOVIMIENTO CONSTANTE"
  },
  {
    "codigo":82236004,
    "descripcion":"RAQUITISMO HIPOFOSFATÉMICO FAMILIAR LIGADO AL CROMOSOMA X, REFRACTARIO A VITAMINA D"
  },
  {
    "codigo":442684004,
    "descripcion":"ESTUDIO POR IMÁGENES DEL HÍGADO, ANORMAL"
  },
  {
    "codigo":213308006,
    "descripcion":"FLEBITIS POSTERIOR A INFUSIÓN"
  },
  {
    "codigo":49468007,
    "descripcion":"TRASTORNO BIPOLAR I DEPRESIVO"
  },
  {
    "codigo":735761002,
    "descripcion":"ENSANCHAMIENTO DE CICATRIZ CUTÁNEA POSTERIOR A PROCEDIMIENTO QUIRÚRGICO"
  },
  {
    "codigo":309777004,
    "descripcion":"PESTAÑA ENCARNADA DEL PÁRPADO INFERIOR"
  },
  {
    "codigo":702993005,
    "descripcion":"MYCOBACTERIUM SENEGALENSE O MYCOBACTERIUM CONCEPTIONENSE"
  },
  {
    "codigo":1260049006,
    "descripcion":"TATUAJE DE MUCOSA DE LABIO SUPERIOR"
  },
  {
    "codigo":733926004,
    "descripcion":"GANGLIONEUROBLASTOMA DE SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":111334008,
    "descripcion":"QUISTE EMBRIONARIO DE EPOÓFORO"
  },
  {
    "codigo":45798009,
    "descripcion":"CARDIOESPASMO CONGÉNITO"
  },
  {
    "codigo":209638008,
    "descripcion":"DESGARRO COMPLETO DE LIGAMENTO DE ARTICULACIÓN MEDIOTARSIANA"
  },
  {
    "codigo":764859001,
    "descripcion":"MIOPATÍA DISTAL DE INICIO TEMPRANO DE LAING"
  },
  {
    "codigo":11843551000119104,
    "descripcion":"HERIDA DE PABELLÓN AURICULAR DERECHO DEBIDA A PICADURA DE INSECTO NO VENENOSO"
  },
  {
    "codigo":109499005,
    "descripcion":"DIENTE EN LINGUOVERSIÓN"
  },
  {
    "codigo":240571007,
    "descripcion":"INFECCIÓN GONOCÓCICA NEONATAL"
  },
  {
    "codigo":699323007,
    "descripcion":"PÓLIPO ESOFAGOGÁSTRICO INFLAMATORIO"
  },
  {
    "codigo":402576006,
    "descripcion":"REACCIÓN LIQUENOIDE POR CONTACTO ALÉRGICO"
  },
  {
    "codigo":238736006,
    "descripcion":"CLASTOTRIX"
  },
  {
    "codigo":9360008,
    "descripcion":"HIPERAMONEMIA"
  },
  {
    "codigo":202298000,
    "descripcion":"ANQUILOSIS ARTICULAR DE REGIÓN DE HOMBRO"
  },
  {
    "codigo":169530003,
    "descripcion":"UTILIZA ESPONJA ANTICONCEPTIVA"
  },
  {
    "codigo":71226004,
    "descripcion":"ANEURISMA DE ARTERIA GASTROEPIPLOICA"
  },
  {
    "codigo":235066005,
    "descripcion":"LESIÓN BUCAL CONCOMITANTE CON TRÍADA DE ARTRITIS REACTIVA"
  },
  {
    "codigo":431674004,
    "descripcion":"HEMATOMA Y CONTUSIÓN HEPÁTICA"
  },
  {
    "codigo":300602005,
    "descripcion":"INCAPAZ DE UTILIZAR LAS COMODIDADES LOCALES"
  },
  {
    "codigo":16021471000119109,
    "descripcion":"BURSITIS SUBDELTOIDEA DE AMBOS HOMBROS"
  },
  {
    "codigo":397071003,
    "descripcion":"INCLUSIÓN PALÚDICA EN ERITROCITO"
  },
  {
    "codigo":1281807004,
    "descripcion":"PIERCING EN OÍDO EXTERNO"
  },
  {
    "codigo":298767005,
    "descripcion":"HALLAZGO RELACIONADO CON ARTICULACIÓN DE HOMBRO"
  },
  {
    "codigo":724751006,
    "descripcion":"TRASTORNO DEL CRONOGRAMA DE SUEÑO-VIGILIA DEBIDO A DESAJUSTE HORARIO"
  },
  {
    "codigo":3855007,
    "descripcion":"TRASTORNO DEL PÁNCREAS"
  },
  {
    "codigo":1085561000119105,
    "descripcion":"EDENTULISMO COMPLETO DE CLASE III DEBIDO A ENFERMEDAD PERIODONTAL"
  },
  {
    "codigo":722916005,
    "descripcion":"HIPOTONÍA NEONATAL DE HIPOFARINGE"
  },
  {
    "codigo":296932006,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE CUMARINA"
  },
  {
    "codigo":1148900007,
    "descripcion":"ENTEROCELE VAGINAL DEBIDO A PROLAPSO UTEROVAGINAL INCOMPLETO"
  },
  {
    "codigo":321811000119101,
    "descripcion":"RIGIDEZ DE ARTICULACIÓN DE CODO DERECHO"
  },
  {
    "codigo":293262002,
    "descripcion":"REACCIÓN ADVERSA A LA CABERGOLINA"
  },
  {
    "codigo":194958005,
    "descripcion":"MIOCARDITIS SÉPTICA - ESTREPTOCÓCICA"
  },
  {
    "codigo":1145230006,
    "descripcion":"VELOCIDAD DE CRECIMIENTO DE PELO LENTA"
  },
  {
    "codigo":424334007,
    "descripcion":"NEOPLASIA MALIGNA DE MÉDULA ESPINAL, INTRAMEDULAR"
  },
  {
    "codigo":94819002,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL ENDOCÉRVIX"
  },
  {
    "codigo":291427003,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR GRISEOFULVINA"
  },
  {
    "codigo":225891002,
    "descripcion":"APTO PARA TRABAJAR CON LIMITACIONES"
  },
  {
    "codigo":1010488000,
    "descripcion":"ESCLEROSIS DE EPÍFISIS DE FALANGE PROXIMAL DE DEDO MEÑIQUE CON RADIOPACIDAD AUMENTADA"
  },
  {
    "codigo":715576000,
    "descripcion":"DISPLASIA ECTODÉRMICA CON DIENTES AL NACER, TIPO TUMPENNY"
  },
  {
    "codigo":289592000,
    "descripcion":"LAXITUD DEL FONDO DE SACO VAGINAL"
  },
  {
    "codigo":92984004,
    "descripcion":"ILION ARQUEADO CONGÉNITO"
  },
  {
    "codigo":191288005,
    "descripcion":"TRASTORNO HEMORRÁGICO POR ANTITROMBINEMIA"
  },
  {
    "codigo":60216004,
    "descripcion":"ENFERMEDAD DE GRAVES CON CRISIS TIROTÓXICA"
  },
  {
    "codigo":58381000,
    "descripcion":"HIPERESPLENISMO"
  },
  {
    "codigo":123917001,
    "descripcion":"INTOXICACIÓN POR IRIDACEAE"
  },
  {
    "codigo":254989000,
    "descripcion":"CARCINOMA EN ADENOMA PLEOMORFO DE GLÁNDULA LAGRIMAL"
  },
  {
    "codigo":713741003,
    "descripcion":"NEOPLASIA DE ARTICULACIÓN ATLANTOAXOIDEA CERVICAL"
  },
  {
    "codigo":25613004,
    "descripcion":"BIFURCACIÓN INTERMALEOLAR"
  },
  {
    "codigo":440491000124109,
    "descripcion":"INGESTA EXCESIVA DE CAFEÍNA"
  },
  {
    "codigo":91149004,
    "descripcion":"SÍNDROME DE OBSERVACIÓN DE LA CADERA"
  },
  {
    "codigo":416994002,
    "descripcion":"MANCHA POR HISTOPLASMOSIS OCULAR"
  },
  {
    "codigo":253154006,
    "descripcion":"DISPLASIA CORTICAL LOCALIZADA"
  },
  {
    "codigo":1268962006,
    "descripcion":"POLIEMBRIOMA PRIMARIO"
  },
  {
    "codigo":449762008,
    "descripcion":"SECRECIÓN SANGUINOLENTA POR HERIDA"
  },
  {
    "codigo":54711002,
    "descripcion":"AGRANDAMIENTO GINGIVAL"
  },
  {
    "codigo":447927004,
    "descripcion":"DILATACIÓN SACULAR DE VENA CAVA SUPERIOR IZQUIERDA"
  },
  {
    "codigo":773772001,
    "descripcion":"DISCAPACIDAD INTELECTUAL RARA NO SINDRÓMICA"
  },
  {
    "codigo":1363596005,
    "descripcion":"CRANEOSINOSTOSIS METÓPICA Y SAGITAL NO SINDRÓMICA"
  },
  {
    "codigo":18273004,
    "descripcion":"ENFERMEDAD POR HEMOGLOBINA INESTABLE"
  },
  {
    "codigo":737334000,
    "descripcion":"TRASTORNO CAUSADO POR USO DE CANABINOIDE SINTÉTICO"
  },
  {
    "codigo":1359926000,
    "descripcion":"GINGIVITIS GENERALIZADA CON TEJIDO PERIODONTAL REDUCIDO Y PERIODONTITIS ESTABLE"
  },
  {
    "codigo":51041008,
    "descripcion":"QUEMADURA DE CUALQUIER GRADO QUE COMPROMETE 60-69 PORCIENTO DE LA SUPERFICIE DEL CUERPO"
  },
  {
    "codigo":278582005,
    "descripcion":"PUENTE DENTAL DE COLOR INCORRECTO"
  },
  {
    "codigo":49206006,
    "descripcion":"VÓMITO HABITUAL"
  },
  {
    "codigo":1259787004,
    "descripcion":"GLIOMA ÓPTICO PRIMARIO MALIGNO"
  },
  {
    "codigo":735499005,
    "descripcion":"DILATACIÓN DE TRACTO GASTROINTESTINAL"
  },
  {
    "codigo":47371007,
    "descripcion":"ATROFIA DEL ESCROTO"
  },
  {
    "codigo":307680001,
    "descripcion":"NISTAGMO ABDUCTOR"
  },
  {
    "codigo":1290720003,
    "descripcion":"ARTRITIS INFECCIOSA DE ARTICULACIÓN DE REGIÓN DE HOMBRO DERECHO"
  },
  {
    "codigo":45536007,
    "descripcion":"INTOXICACIÓN CAUSADA POR FÁRMACO SIMPATICOMIMÉTICO"
  },
  {
    "codigo":830133000,
    "descripcion":"RETINA DE OJO IZQUIERDO COMPLETAMENTE EVALUABLE"
  },
  {
    "codigo":405984008,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA MESENTÉRICO NO COMPROMETIDO POR NEOPLASIA MALIGNA"
  },
  {
    "codigo":15997511000119107,
    "descripcion":"ISQUEMIA DE RETINA DE AMBOS OJOS"
  },
  {
    "codigo":305845003,
    "descripcion":"ATENDIDO POR SERVICIO DE AUDIOLOGÍA"
  },
  {
    "codigo":699061004,
    "descripcion":"LESIÓN TRAUMÁTICA DE CARA Y CUELLO"
  },
  {
    "codigo":238474002,
    "descripcion":"IRRITACIÓN DE PIEL"
  },
  {
    "codigo":402314003,
    "descripcion":"PSORIASIS DE VULVA"
  },
  {
    "codigo":205706002,
    "descripcion":"MOSAICISMO DE CROMOSOMA SEXUAL"
  },
  {
    "codigo":236639003,
    "descripcion":"HIPERSENSIBILIDAD DE VEJIGA URINARIA"
  },
  {
    "codigo":70964000,
    "descripcion":"HEMOGLOBINURIA POSPARTO"
  },
  {
    "codigo":38196001,
    "descripcion":"DEFECTO AISLADO DE SOMATOTROFINA TIPO LARON"
  },
  {
    "codigo":300340001,
    "descripcion":"VESÍCULA BILIAR PRESENTE"
  },
  {
    "codigo":365876004,
    "descripcion":"EXAMEN MICROSCÓPICO DE ORINA: CÉLULAS EPITELIALES PRESENTES"
  },
  {
    "codigo":726324007,
    "descripcion":"LESIÓN TRAUMÁTICA DE TENDÓN DE MÚSCULO INTRÍNSECO DE PIE"
  },
  {
    "codigo":724489002,
    "descripcion":"PARTO PRETÉRMINO POSTERIOR A OPERACIÓN CESÁREA"
  },
  {
    "codigo":324946811000119102,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN DE TEJIDO PROFUNDO DE TOBILLO DERECHO"
  },
  {
    "codigo":460510005,
    "descripcion":"ORIGEN ANÓMALO DE ARTERIAS CORONARIAS EN SENO AÓRTICO ANTERIOR"
  },
  {
    "codigo":722654008,
    "descripcion":"LESIÓN TRAUMÁTICA INCOMPLETA DE MÉDULA ESPINAL SACRA"
  },
  {
    "codigo":296670008,
    "descripcion":"SOBREDOSIS DE CEFADROXILO"
  },
  {
    "codigo":360371003,
    "descripcion":"EDEMA AGUDO DE PULMÓN DE CAUSA CARDÍACA"
  },
  {
    "codigo":11810541000119100,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO DE CADERA DERECHA"
  },
  {
    "codigo":98541000119101,
    "descripcion":"MIELITIS POR HERPES ZOSTER"
  },
  {
    "codigo":10760941000119102,
    "descripcion":"MALTRATO PSICOLÓGICO QUE COMPLICA EL NACIMIENTO"
  },
  {
    "codigo":903729901000119103,
    "descripcion":"INFECCIÓN AGUDA DE VÍAS RESPIRATORIAS SUPERIORES CAUSADA POR VIRUS SINCICIAL RESPIRATORIO"
  },
  {
    "codigo":308461000119102,
    "descripcion":"GRANULOMA POR CUERPO EXTRAÑO DE PARTES BLANDAS DE PIERNA DERECHA"
  },
  {
    "codigo":10830061000119105,
    "descripcion":"FRACTURA EXPUESTA DE PIERNA IZQUIERDA"
  },
  {
    "codigo":16528621000119102,
    "descripcion":"RUPTURA DE TABIQUE INTERVENTRICULAR POSTERIOR A INFARTO AGUDO DE MIOCARDIO"
  },
  {
    "codigo":49901000119105,
    "descripcion":"LESIÓN DE PÁRPADO SUPERIOR"
  },
  {
    "codigo":11828461000119107,
    "descripcion":"LACERACIÓN DE TENDÓN DE CUÁDRICEPS IZQUIERDO"
  },
  {
    "codigo":1076461000119109,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE ESTRUCTURA MUSCULAR O TENDINOSA DE MANGUITO ROTADOR DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":318701000119109,
    "descripcion":"ARTROSIS DE CODO DERECHO"
  },
  {
    "codigo":349421000119109,
    "descripcion":"ESTENOSIS ADQUIRIDA DE CONDUCTO NASOLAGRIMAL IZQUIERDO"
  },
  {
    "codigo":341741000119105,
    "descripcion":"CALCOSIS DE OJO IZQUIERDO"
  },
  {
    "codigo":323821000119107,
    "descripcion":"OSIFICACIÓN HETEROTÓPICA DEBIDA A TRASTORNO NEUROLÓGICO"
  },
  {
    "codigo":16467181000119109,
    "descripcion":"MELORREOSTOSIS DE HUESO DE MANO DERECHA"
  },
  {
    "codigo":679661000119107,
    "descripcion":"ENDOFTALMITIS BILATERAL DEBIDA A CIRUGÍA Y POSTERIOR A ELLA"
  },
  {
    "codigo":10686701000119108,
    "descripcion":"MELANOMA MALIGNO DE PIEL DE MANO DERECHA"
  },
  {
    "codigo":291165001,
    "descripcion":"INTOXICACIÓN POR LEVOMEPROMAZINA"
  },
  {
    "codigo":334061000119109,
    "descripcion":"BLEFARITIS ULCEROSA DE PÁRPADO INFERIOR DERECHO"
  },
  {
    "codigo":94557005,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA PIEL DEL ANTEBRAZO"
  },
  {
    "codigo":225629005,
    "descripcion":"MIEDO A SER DEJADO SOLO"
  },
  {
    "codigo":127325009,
    "descripcion":"HALLAZGO RELACIONADO CON UN PROCEDIMIENTO"
  },
  {
    "codigo":1144968009,
    "descripcion":"ENCEFALITIS CAUSADA POR VIRUS DEL HERPES SIMPLE TIPO 2"
  },
  {
    "codigo":289330005,
    "descripcion":"LESIÓN DE MUÑÓN UMBILICAL"
  },
  {
    "codigo":715314008,
    "descripcion":"ARTROGRIPOSIS DISTAL TIPO 1"
  },
  {
    "codigo":92722008,
    "descripcion":"CARCINOMA IN SITU DE LA PIEL DE LAS CEJAS"
  },
  {
    "codigo":1336071002,
    "descripcion":"EPISODIO DE USO NOCIVO DE ESTIMULANTE"
  },
  {
    "codigo":254727007,
    "descripcion":"ENFERMEDAD DE PAGET CUTÁNEA EXTRAMAMARIA"
  },
  {
    "codigo":680981000119105,
    "descripcion":"DEPÓSITO EN CÓRNEA DE OJO DERECHO DEBIDO A TRASTORNO METABÓLICO"
  },
  {
    "codigo":123655009,
    "descripcion":"ESTRUCTURA ACCESORIA DE LAS VÍAS RESPIRATORIAS INFERIORES"
  },
  {
    "codigo":711644007,
    "descripcion":"ENDOFTALMITIS CAUSADA POR ACANTHAMOEBA"
  },
  {
    "codigo":1268700009,
    "descripcion":"SEMINOMA ESPERMATOCÍTICO PRIMARIO DE TESTÍCULO"
  },
  {
    "codigo":251057006,
    "descripcion":"DEFECTO DE LA PERFUSIÓN MIOCÁRDICA REPARADO"
  },
  {
    "codigo":283825008,
    "descripcion":"MORDEDURA DE ANIMAL EN EL MUSLO"
  },
  {
    "codigo":447665008,
    "descripcion":"COMUNICACIÓN INTERAURICULAR A TRAVÉS DE ORIFICIO DE SENO CORONARIO"
  },
  {
    "codigo":314758008,
    "descripcion":"QUERATOCONO POSTERIOR"
  },
  {
    "codigo":1197659000,
    "descripcion":"SÍNDROME DE DOLOR EN EPIGASTRIO PRIMARIO CRÓNICO"
  },
  {
    "codigo":11251000202104,
    "descripcion":"CAPAZ DE MANEJAR RIESGO DE INFECCIÓN"
  },
  {
    "codigo":312923002,
    "descripcion":"CORIORRETINOPATÍA SEROSA CENTRAL, CRÓNICA"
  },
  {
    "codigo":83547004,
    "descripcion":"SUDOR FRÍO"
  },
  {
    "codigo":116315007,
    "descripcion":"HALLAZGO RELACIONADO CON REGIÓN DE TOBILLO"
  },
  {
    "codigo":704304000,
    "descripcion":"ALTERACIÓN DEL DESARROLLO INFANTIL"
  },
  {
    "codigo":247387008,
    "descripcion":"CRURALGIA"
  },
  {
    "codigo":48944001,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO SEVERO DE LOS ÓRGANOS ABDOMINALES"
  },
  {
    "codigo":81712001,
    "descripcion":"COITO DOLOROSO FEMENINO"
  },
  {
    "codigo":1163056000,
    "descripcion":"ENCEFALITIS POR VIRUS MOKOLA"
  },
  {
    "codigo":79877004,
    "descripcion":"ESTENOSIS DE BRONQUIO"
  },
  {
    "codigo":1259525007,
    "descripcion":"CARCINOMA PRIMARIO DE PENE"
  },
  {
    "codigo":735237008,
    "descripcion":"HÁBITO DE HIGIENE DE LA CAVIDAD BUCAL PERJUDICIAL"
  },
  {
    "codigo":309253009,
    "descripcion":"DIFICULTAD PARA LEER"
  },
  {
    "codigo":241882002,
    "descripcion":"EFECTO TÓXICO CAUSADO POR REMOVEDOR DE PAPEL"
  },
  {
    "codigo":702469009,
    "descripcion":"RESPONSABILIDAD PARENTAL EXCLUSIVAMENTE A CARGO DEL PADRE"
  },
  {
    "codigo":405722004,
    "descripcion":"ATROFIA RETINIANA"
  },
  {
    "codigo":897242000,
    "descripcion":"CURVATURA ANORMAL DE FALANGE DE DEDO GORDO"
  },
  {
    "codigo":372954001,
    "descripcion":"INFECCIÓN CAUSADA POR PENICILLIUM GLAUCUM"
  },
  {
    "codigo":274650007,
    "descripcion":"CONDUCTA EXTRAÑA E INEXPLICABLE"
  },
  {
    "codigo":307418008,
    "descripcion":"ENTERITIS Y COLITIS NO INFECCIOSAS"
  },
  {
    "codigo":733402009,
    "descripcion":"MORDEDURA ABIERTA DE BRAZO"
  },
  {
    "codigo":174511002,
    "descripcion":"PERICARDITIS FIBRINOSA AGUDA"
  },
  {
    "codigo":403887003,
    "descripcion":"ENFERMEDAD DE BOWEN, DE CÉLULAS CLARAS"
  },
  {
    "codigo":10671005,
    "descripcion":"AMPOLLA DE LA REGIÓN ESCAPULAR, CON INFECCIÓN"
  },
  {
    "codigo":240047005,
    "descripcion":"DISTROFIA MUSCULAR LIGADA AL X CON DISTRIBUCIÓN EN LA CINTURA DE EXTREMIDAD"
  },
  {
    "codigo":762500001,
    "descripcion":"RETRASO DE CRECIMIENTO DE CAUSA NUTRICIONAL EN LA INFANCIA"
  },
  {
    "codigo":305583009,
    "descripcion":"BAJO ATENCIÓN DE ENFERMERA PRACTICANTE"
  },
  {
    "codigo":74372003,
    "descripcion":"GONORREA DE LA FARINGE"
  },
  {
    "codigo":860804005,
    "descripcion":"EPILEPSIA DEBIDA A ENCEFALITIS INFECCIOSA"
  },
  {
    "codigo":236377000,
    "descripcion":"INFECCIÓN FÚNGICA DEL RIÑÓN"
  },
  {
    "codigo":301913002,
    "descripcion":"LESIÓN DE PÁRPADO"
  },
  {
    "codigo":5166001,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA VENA YUGULAR EXTERNA"
  },
  {
    "codigo":37934003,
    "descripcion":"MIOPATÍA POR ALMACENAMIENTO MITOCONDRIAL DE GLUCÓGENO Y LÍPIDOS"
  },
  {
    "codigo":234542004,
    "descripcion":"DEFICIENCIA SELECTIVA DE INMUNOGLOBULINA M E INMUNOGLOBULINA A"
  },
  {
    "codigo":201774005,
    "descripcion":"ARTRITIS REUMATOIDE DE LA ARTICULACIÓN INTERFALÁNGICA DISTAL DE DEDO DE LA MANO"
  },
  {
    "codigo":300078006,
    "descripcion":"TRAYECTO FISTULOSO PERIANAL"
  },
  {
    "codigo":15701321000119109,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE TENDÓN AMBOS HOMBROS"
  },
  {
    "codigo":724227000,
    "descripcion":"ATAXIA CEREBELOSA INFANTIL"
  },
  {
    "codigo":365614008,
    "descripcion":"VARIANTE DE HEMOGLOBINA - HALLAZGO"
  },
  {
    "codigo":298243003,
    "descripcion":"ARTICULACIÓN METATARSOFALÁNGICA RÍGIDA"
  },
  {
    "codigo":394712000,
    "descripcion":"PRUEBA DE LEUCOCITOS URINARIOS: +"
  },
  {
    "codigo":396547008,
    "descripcion":"MARGEN QUIRÚRGICO DEL CONDUCTO PANCREÁTICO NO COMPROMETIDO POR CARCINOMA IN SITU"
  },
  {
    "codigo":3331008,
    "descripcion":"FRACTURA EXPUESTA DE CUELLO DE HUESO METACARPIANO"
  },
  {
    "codigo":427480003,
    "descripcion":"OBSTRUCCIÓN DE VÍA AÉREA CAUSADA POR SANGRE"
  },
  {
    "codigo":722392003,
    "descripcion":"DIARREA CONGÉNITA CON MALA ABSORCIÓN DEBIDA A ESCASEZ DE CÉLULAS ENTEROENDOCRINAS"
  },
  {
    "codigo":296408005,
    "descripcion":"SOBREDOSIS DE NIQUETAMIDA"
  },
  {
    "codigo":198104007,
    "descripcion":"ABSCESO MAMARIO AGUDO NO PUERPERAL"
  },
  {
    "codigo":294573002,
    "descripcion":"ALERGIA A SULFADIAZINA"
  },
  {
    "codigo":292738000,
    "descripcion":"REACCIÓN ADVERSA A LA NALOXONA"
  },
  {
    "codigo":423810002,
    "descripcion":"TENDINITIS DE MUÑECA"
  },
  {
    "codigo":1144706002,
    "descripcion":"HIPOPLASIA CONGÉNITA DE FALANGE PROXIMAL DE DEDO GORDO"
  },
  {
    "codigo":389207000,
    "descripcion":"DISPLASIA ESCLEROSANTE MIXTA DE HUESO"
  },
  {
    "codigo":63362009,
    "descripcion":"TRASTORNO DE LA VÍA ÓPTICA ASOCIADO CON TRASTORNO VASCULAR"
  },
  {
    "codigo":94295001,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE TROMPA DE FALOPIO"
  },
  {
    "codigo":290903000,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR CITALOPRAM"
  },
  {
    "codigo":190764000,
    "descripcion":"PENTOSURIA ESENCIAL"
  },
  {
    "codigo":289068001,
    "descripcion":"INCAPAZ DE UTILIZAR AYUDA PARA ALIMENTARSE"
  },
  {
    "codigo":59692002,
    "descripcion":"ESCLEROSIS PIRIFORME DEL ILION"
  },
  {
    "codigo":127063008,
    "descripcion":"ERITROCITOSIS POR CARDIOPATÍA CIANÓTICA CONGÉNITA"
  },
  {
    "codigo":420140004,
    "descripcion":"ALERGIA A ALCOHOL ETÍLICO"
  },
  {
    "codigo":254465004,
    "descripcion":"CARCINOMA DE GLÁNDULA SUBMAXILAR"
  },
  {
    "codigo":187094001,
    "descripcion":"CRIPTOCOCOSIS CEREBRAL"
  },
  {
    "codigo":285398006,
    "descripcion":"LACERACIÓN DE LA PIEL DEL PENE"
  },
  {
    "codigo":21419000,
    "descripcion":"FRACTURA NO EXPUESTA DE EPITRÓCLEA DE HÚMERO"
  },
  {
    "codigo":711382009,
    "descripcion":"INCAPAZ DE REALIZAR ESPIROMETRÍA"
  },
  {
    "codigo":283563005,
    "descripcion":"HERIDA DE PERDIGÓN EN CODO"
  },
  {
    "codigo":85120004,
    "descripcion":"INFECCIÓN CAUSADA POR PHILOMETROIDES"
  },
  {
    "codigo":312661001,
    "descripcion":"EFECTO TARDÍO DE FRACTURA DE VÉRTEBRA DORSAL"
  },
  {
    "codigo":247125005,
    "descripcion":"VASOS ANASTOMÓTICOS RETINIANOS"
  },
  {
    "codigo":310826002,
    "descripcion":"TRASTORNO DE LA CONVERSACIÓN"
  },
  {
    "codigo":1162794003,
    "descripcion":"FOSFATASA ALCALINA INTESTINAL POR ENCIMA DE RANGO DE REFERENCIA"
  },
  {
    "codigo":278058008,
    "descripcion":"BORRAMIENTO PARCIAL DE CUELLO UTERINO"
  },
  {
    "codigo":46847001,
    "descripcion":"EDEMA PULMONAR CRÓNICO"
  },
  {
    "codigo":79615003,
    "descripcion":"FÍSTULA DUODENAL INTERNA"
  },
  {
    "codigo":866047004,
    "descripcion":"MONONEUROPATÍA MÚLTIPLE DEBIDA A VASCULITIS ASOCIADA A ANTICUERPOS CITOPLASMÁTICOS ANTINUCLEARES PERINUCLEARES ANTINEUTRÓFILOS"
  },
  {
    "codigo":472831008,
    "descripcion":"TRASTORNO DE PRÓTESIS DE VÁLVULA TRICÚSPIDE"
  },
  {
    "codigo":15677361000119105,
    "descripcion":"MIOSITIS DE AMBOS ANTEBRAZOS"
  },
  {
    "codigo":733140002,
    "descripcion":"MAL FUNCIONAMIENTO DE SEGMENTO AFERENTE DE BOLSILLO URINARIO CONTINENTE"
  },
  {
    "codigo":208852003,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA EXPUESTA DE HUESO SEMILUNAR (PALMAR)"
  },
  {
    "codigo":700372006,
    "descripcion":"INFECCIÓN DE LA VÍA URINARIA ASOCIADA CON CATÉTER"
  },
  {
    "codigo":272553001,
    "descripcion":"SENTADO A HORCAJADAS CON BASE DE SUSTENTACIÓN AMPLIA"
  },
  {
    "codigo":403625006,
    "descripcion":"URTICARIA SOLAR MEDICAMENTOSA"
  },
  {
    "codigo":698537008,
    "descripcion":"REQUIERE DISPOSITIVO ORTODÓNCICO REMOVIBLE"
  },
  {
    "codigo":303486001,
    "descripcion":"INCAPAZ DE ATARSE LOS CORDONES"
  },
  {
    "codigo":242056005,
    "descripcion":"LESIÓN ACCIDENTAL"
  },
  {
    "codigo":72275000,
    "descripcion":"POLICONDRITIS RECIDIVANTE"
  },
  {
    "codigo":203347000,
    "descripcion":"ENFERMEDAD DE PAGET DEL ASTRÁGALO"
  },
  {
    "codigo":170579000,
    "descripcion":"HIPERTENSIÓN ARTERIAL: NO CONCURRE A LOS CONTROLES"
  },
  {
    "codigo":301651000,
    "descripcion":"INCAPAZ DE SENTARSE EN UNA SILLA"
  },
  {
    "codigo":237950009,
    "descripcion":"ACIDURIA 3-METAGLUTACÓNICA"
  },
  {
    "codigo":236115009,
    "descripcion":"NECROSIS DE ANASTOMOSIS DEL INTESTINO GRUESO"
  },
  {
    "codigo":365352002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA ORGANIZAR UN VIAJE"
  },
  {
    "codigo":399955009,
    "descripcion":"QUERATODERMIA PALMOPLANTAR DIFUSA DE THOST-UNNA"
  },
  {
    "codigo":267048005,
    "descripcion":"SÍNTOMAS DEGLUTORIOS"
  },
  {
    "codigo":299816005,
    "descripcion":"REFLEJO NAUSEOSO POSITIVO"
  },
  {
    "codigo":430888006,
    "descripcion":"DISTROFIA DE CÓRNEA ANTERIOR"
  },
  {
    "codigo":68605000,
    "descripcion":"ENFERMEDAD INFECCIOSA RELACIONADA CON INMUNOSUPRESIÓN"
  },
  {
    "codigo":1217320008,
    "descripcion":"TENOPERIOSTITIS"
  },
  {
    "codigo":297981002,
    "descripcion":"HALLAZGO RELACIONADO CON MEDICIONES CUTÁNEAS"
  },
  {
    "codigo":232445004,
    "descripcion":"CAMBIO SEUDOQUÍSTICO DE LA CUERDA VOCAL"
  },
  {
    "codigo":396285007,
    "descripcion":"BRONCONEUMONÍA"
  },
  {
    "codigo":363517008,
    "descripcion":"NEOPLASIA MALIGNA DE TRACTO URINARIO PROPIAMENTE DICHO"
  },
  {
    "codigo":230610006,
    "descripcion":"NEUROPATÍA POR PLOMO"
  },
  {
    "codigo":425383001,
    "descripcion":"ALTERACIÓN DE LA CREENCIA ESPIRITUAL"
  },
  {
    "codigo":1144444005,
    "descripcion":"APLASIA DE PLIEGUE PALMAR"
  },
  {
    "codigo":95868006,
    "descripcion":"AGOTAMIENTO POR CALOR"
  },
  {
    "codigo":292476007,
    "descripcion":"REACCIÓN ADVERSA A LA NEOSTIGMINA"
  },
  {
    "codigo":30332009,
    "descripcion":"CRECIMIENTO Y DESARROLLO ALTERADOS: HABILIDADES PARA EL CUIDADO PERSONAL"
  },
  {
    "codigo":94033003,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA PIEL DEL MIEMBRO INFERIOR"
  },
  {
    "codigo":190502001,
    "descripcion":"HIPERCORTISOLISMO DEPENDIENTE DE LA HIPÓFISIS"
  },
  {
    "codigo":290641009,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR BLEOMICINA"
  },
  {
    "codigo":15952101000119109,
    "descripcion":"TUMEFACCIÓN DE AMBAS GLÁNDULAS PARÓTIDAS"
  },
  {
    "codigo":92198006,
    "descripcion":"NEOPLASIA BENIGNA DE LOS GANGLIOS LINFÁTICOS DE LA CARA"
  },
  {
    "codigo":288806008,
    "descripcion":"CAPAZ DE SALUDAR"
  },
  {
    "codigo":876795001,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE MUÑECA CON INFECCIÓN"
  },
  {
    "codigo":712955007,
    "descripcion":"LESIÓN TRAUMÁTICA CAUSADA POR ESTADO GRAVITACIONAL ANORMAL"
  },
  {
    "codigo":285136000,
    "descripcion":"ACUCHILLAR A OTRA PERSONA CON OBJETO FILOSO"
  },
  {
    "codigo":55760004,
    "descripcion":"INFECCIÓN CAUSADA POR SHIGELLA DEL GRUPO C"
  },
  {
    "codigo":10682751000119106,
    "descripcion":"TUMORACIÓN DE LA PIEL DE EXTREMIDAD INFERIOR DERECHA"
  },
  {
    "codigo":709285002,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE PLEXO LUMBOSACRO"
  },
  {
    "codigo":283301006,
    "descripcion":"ASTILLA DE MADERA EN ABDOMEN"
  },
  {
    "codigo":445306000,
    "descripcion":"FISURA DE CRESTA ALVEOLAR"
  },
  {
    "codigo":707450006,
    "descripcion":"INSUFICIENCIA PANCREÁTICA DEBIDA A FIBROSIS QUÍSTICA DEL PÁNCREAS"
  },
  {
    "codigo":1264506008,
    "descripcion":"HEMATOMA POSOPERATORIO DE PELVIS FEMENINA"
  },
  {
    "codigo":312399001,
    "descripcion":"PRUEBAS DE FUNCIÓN TIROIDEA: ANORMALES"
  },
  {
    "codigo":281466008,
    "descripcion":"TRASTORNO DE CURACIÓN DE FRACTURA"
  },
  {
    "codigo":410703004,
    "descripcion":"CONGELAMIENTO SUPERFICIAL"
  },
  {
    "codigo":246863007,
    "descripcion":"CANALÍCULO LAGRIMAL DIVIDIDO"
  },
  {
    "codigo":277796003,
    "descripcion":"ENFERMEDAD DE LA PIEL GRANULOMATOSA LAXA"
  },
  {
    "codigo":441636005,
    "descripcion":"MIOTONÍA CAUSADA POR FÁRMACO"
  },
  {
    "codigo":11311641000119106,
    "descripcion":"FRACTURA OSTEOPORÓTICA DE VÉRTEBRA SACRA"
  },
  {
    "codigo":310564007,
    "descripcion":"ENFERMEDAD DE LYME NO DETECTADA POR PRUEBA DE INMUNOTRANSFERENCIA"
  },
  {
    "codigo":212260008,
    "descripcion":"LESIÓN ABIERTA DE RAMA MOTORA DE NERVIO MEDIANO"
  },
  {
    "codigo":208590001,
    "descripcion":"FRACTURA EXPUESTA DE FÉMUR DISTAL, BICONDÍLEA (FRACTURA EN T-Y)"
  },
  {
    "codigo":372430003,
    "descripcion":"COMPROMISO TUMORAL FOCAL EN MARGEN DE RESECCIÓN QUIRÚRGICA PROFUNDA, PRESENTE"
  },
  {
    "codigo":110286006,
    "descripcion":"AUTOABUSO"
  },
  {
    "codigo":403363006,
    "descripcion":"CICATRICES DE ACNÉ ATRÓFICAS E HIPERTRÓFICAS COMBINADAS"
  },
  {
    "codigo":698275009,
    "descripcion":"EXPOSICIÓN EXCESIVA DE TEJIDO GINGIVAL AL SONREIR"
  },
  {
    "codigo":270456003,
    "descripcion":"DATOS CONFIDENCIALES DEL PACIENTE: GUARDADOS"
  },
  {
    "codigo":237688008,
    "descripcion":"DEFICIENCIA IDIOPÁTICA DE SOMATOTROFINA"
  },
  {
    "codigo":432461000,
    "descripcion":"ANOMALÍA CONGÉNITA DE VASO SANGUÍNEO RENAL"
  },
  {
    "codigo":301389002,
    "descripcion":"DOLOR A LA PALPACIÓN EN ESTRUCTURA RESPIRATORIA"
  },
  {
    "codigo":204920009,
    "descripcion":"QUISTE DE HIDÁTIDE DE MORGAGNI"
  },
  {
    "codigo":1351800009,
    "descripcion":"INMUNODEFICIENCIA COMBINADA AUTOSÓMICA RECESIVA DEBIDA A MUTACIÓN DE CHUK"
  },
  {
    "codigo":41080008,
    "descripcion":"FRAMBESIAS CUTÁNEAS (MENOS DE 5 AÑOS)"
  },
  {
    "codigo":235853006,
    "descripcion":"ANGIODISPLASIA DEL INTESTINO"
  },
  {
    "codigo":1153357001,
    "descripcion":"LINFOMA DE APÉNDICE"
  },
  {
    "codigo":268621008,
    "descripcion":"EPISODIOS DEPRESIVOS MAYORES RECURRENTES"
  },
  {
    "codigo":6477005,
    "descripcion":"ROTACIÓN ANÓMALA DE COLON"
  },
  {
    "codigo":397858002,
    "descripcion":"PROBLEMA O VACIAMIENTO DEL VAPORIZADOR"
  },
  {
    "codigo":1217058003,
    "descripcion":"HIPERTROFIA DE GLÁNDULA SUPRARRENAL"
  },
  {
    "codigo":365090002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA IMITAR PALABRAS"
  },
  {
    "codigo":299554004,
    "descripcion":"ARTICULACIÓN SUBASTRAGALINA DOLOROSA A LA MOVILIZACIÓN"
  },
  {
    "codigo":201250006,
    "descripcion":"ÚLCERA ISQUÉMICA DE PIE DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":102946008,
    "descripcion":"CONDUCTA SEXUAL ANORMAL"
  },
  {
    "codigo":2807004,
    "descripcion":"ÚLCERA GASTROYEYUNAL CRÓNICA CON PERFORACIÓN"
  },
  {
    "codigo":164812003,
    "descripcion":"PRUEBA ESPECIAL EN LA MUJER - ANORMAL"
  },
  {
    "codigo":787404005,
    "descripcion":"METABOLIZADOR INTERMEDIO-ALTO DE LA FAMILIA 3 SUBFAMILIA A MIEMBRO 5 DEL CITOCROMO P450"
  },
  {
    "codigo":230348008,
    "descripcion":"MIOCLONÍA PALATINOTIMPÁNICA"
  },
  {
    "codigo":197580009,
    "descripcion":"NEFRITIS AGUDA CON LESIONES DE GLOMERULITIS NECROSANTE"
  },
  {
    "codigo":263116009,
    "descripcion":"FRACTURA-SUBLUXACIÓN DE LA ARTICULACIÓN DEL PIE"
  },
  {
    "codigo":336871000119102,
    "descripcion":"RUPTURA MECÁNICA DE LENTE INTRAOCULAR"
  },
  {
    "codigo":783734000,
    "descripcion":"SÍNDROME DE DEPLECIÓN DE ÁCIDO DESOXIRRIBONUCLEICO MITOCONDRIAL, FORMA HEPATOCEREBRAL DEBIDA A DEFICIENCIA DE DESOXIGUANOSINA CINASA"
  },
  {
    "codigo":62838000,
    "descripcion":"ÚLCERA GASTROYEYUNAL CRÓNICA CON HEMORRAGIA"
  },
  {
    "codigo":228513009,
    "descripcion":"EX MASTICADOR DE TABACO"
  },
  {
    "codigo":95606005,
    "descripcion":"EXPOSICIÓN MATERNA A DROGAS"
  },
  {
    "codigo":716363001,
    "descripcion":"CON MAYOR RIESGO DE FRACTURA DE DIENTE"
  },
  {
    "codigo":126539002,
    "descripcion":"NEOPLASIA DE HUESO FRONTAL"
  },
  {
    "codigo":61003004,
    "descripcion":"EPIDERMÓLISIS BULLOSA"
  },
  {
    "codigo":93771007,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE COLON DESCENDENTE"
  },
  {
    "codigo":419616000,
    "descripcion":"DAÑO HEPATOCELULAR"
  },
  {
    "codigo":290379009,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR CARBENOXOLONA"
  },
  {
    "codigo":124704002,
    "descripcion":"DEFICIENCIA DE GLUTAMATO - AMONÍACO LIGASA"
  },
  {
    "codigo":91936005,
    "descripcion":"ALERGIA A PENICILINA"
  },
  {
    "codigo":253941000,
    "descripcion":"DUPLICACIÓN DE TIBIA"
  },
  {
    "codigo":1204213001,
    "descripcion":"OCLUSIÓN AGUDA DE ARTERIA FEMORAL COMÚN DEBIDA A TROMBOEMBOLISMO"
  },
  {
    "codigo":712693000,
    "descripcion":"J3"
  },
  {
    "codigo":286709003,
    "descripcion":"RASGO DE LA PERSONALIDAD: NIVEL DE ANSIEDAD - HALLAZGO"
  },
  {
    "codigo":1236981004,
    "descripcion":"MOVILIDAD NORMAL DE DIENTE"
  },
  {
    "codigo":10904551000119108,
    "descripcion":"LACERACIÓN DE NALGA IZQUIERDA"
  },
  {
    "codigo":284874002,
    "descripcion":"DIFICULTAD PARA CORTARSE LAS UÑAS"
  },
  {
    "codigo":186570004,
    "descripcion":"SORDERA POR RUBÉOLA"
  },
  {
    "codigo":11779201000119103,
    "descripcion":"RUPTURA TRAUMÁTICA DE RODETE GLENOIDEO IZQUIERDO"
  },
  {
    "codigo":219338008,
    "descripcion":"LESIÓN POR ARMA DE FUEGO DE USO MILITAR, CON PROPÓSITO DESCONOCIDO"
  },
  {
    "codigo":250271003,
    "descripcion":"HALLAZGO RELACIONADO CON LOS LEUCOCITOS"
  },
  {
    "codigo":283039007,
    "descripcion":"LESIÓN SUPERFICIAL EN LA INGLE"
  },
  {
    "codigo":1003935008,
    "descripcion":"DELECIÓN PROXIMAL DEL CROMOSOMA 15"
  },
  {
    "codigo":10960001000119106,
    "descripcion":"HERIDA PUNZANTE DE ANTEBRAZO DERECHO"
  },
  {
    "codigo":248436008,
    "descripcion":"FIEBRE LIGERAMENTE REMITENTE"
  },
  {
    "codigo":1196873001,
    "descripcion":"DEFECTO DE GEN DE ENSAMBLAJE DE COMPLEJO II DE CADENA RESPIRATORIA MITOCONDRIAL"
  },
  {
    "codigo":11861121000119107,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":312137007,
    "descripcion":"INFECCIÓN VIRAL DEL OÍDO"
  },
  {
    "codigo":246601009,
    "descripcion":"RAÍZ DE NERVIO FEMORAL - HALLAZGO"
  },
  {
    "codigo":310302007,
    "descripcion":"MANIFESTACIÓN DE LA VOLUNTAD DISCUTIDA CON EL PACIENTE"
  },
  {
    "codigo":13555004,
    "descripcion":"SÍNDROME DEL CROMOSOMA 22 EN ANILLO"
  },
  {
    "codigo":308467007,
    "descripcion":"ATENDIDO EN ESTABLECIMIENTO"
  },
  {
    "codigo":110024002,
    "descripcion":"FRACTURA NO EXPUESTA COMPLETA DE MAXILAR SUPERIOR"
  },
  {
    "codigo":42653000,
    "descripcion":"CALCIFICACIÓN PERICÁRDICA"
  },
  {
    "codigo":404936009,
    "descripcion":"BASE DE SUSTENTACIÓN ANCHA"
  },
  {
    "codigo":403101002,
    "descripcion":"ONICOMICOSIS CAUSADA POR SCYTALIDIUM HYALINUM"
  },
  {
    "codigo":339381000119101,
    "descripcion":"ÚLCERA DE MOOREN DE CÓRNEA IZQUIERDA"
  },
  {
    "codigo":698013004,
    "descripcion":"OSTEOMA DE PERIOSTIO"
  },
  {
    "codigo":1156765006,
    "descripcion":"OLIGOARTRITIS IDIOPÁTICA JUVENIL NEGATIVA PARA ANTICUERPOS ANTINUCLEARES DE INICIO PERSISTENTE"
  },
  {
    "codigo":206493009,
    "descripcion":"TRASTORNOS DEL EQUILIBRIO DEL SODIO EN EL RECIÉN NACIDO"
  },
  {
    "codigo":204658006,
    "descripcion":"AUSENCIA CONGÉNITA DE ESÓFAGO CON FÍSTULA TRAQUEOESOFÁGICA"
  },
  {
    "codigo":366663002,
    "descripcion":"HALLAZGO RELACIONADO CON LA MUCOSA NASAL"
  },
  {
    "codigo":71751002,
    "descripcion":"INTOLERANCIA A LA PROTEÍNA LISINÚRICA, TIPO 2"
  },
  {
    "codigo":202823006,
    "descripcion":"INESTABILIDAD DE LA COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":6215006,
    "descripcion":"COLANGITIS AGUDA"
  },
  {
    "codigo":1251399006,
    "descripcion":"ALOPECIA POR DEFICIENCIA DE HIERRO"
  },
  {
    "codigo":301127006,
    "descripcion":"HALLAZGO RELACIONADO CON EL PRIMER RUIDO CARDÍACO"
  },
  {
    "codigo":69916004,
    "descripcion":"FRACTURA DE BASE DE PULGAR"
  },
  {
    "codigo":397596005,
    "descripcion":"PLANIFICACIÓN DE LA ATENCIÓN COHERENTE CON EL NIVEL DE FUNCIONAMIENTO Y CAPACIDAD DEL PACIENTE DURANTE EL PERÍODO PERIOPERATORIO"
  },
  {
    "codigo":364828006,
    "descripcion":"DIETA CUMPLIDA - HALLAZGO"
  },
  {
    "codigo":299292004,
    "descripcion":"AMPLITUD DE ROTACIÓN INTERNA PASIVA DE ARTICULACIÓN DE CADERA, AUMENTADA"
  },
  {
    "codigo":723441001,
    "descripcion":"ATAXIA CEREBELOSA NO PROGRESIVA CON DISCAPACIDAD INTELECTUAL"
  },
  {
    "codigo":233756009,
    "descripcion":"NEUMOCONIOSIS POR TORIO"
  },
  {
    "codigo":262854000,
    "descripcion":"DESGARRO SEROSO DEL INTESTINO DELGADO"
  },
  {
    "codigo":788977009,
    "descripcion":"FILTRACIÓN POR HERIDA DESPUÉS DE PROCEDIMIENTO QUIRÚRGICO"
  },
  {
    "codigo":231921008,
    "descripcion":"EDEMA CORNEAL FÁQUICO"
  },
  {
    "codigo":362993009,
    "descripcion":"INMUNODEFICIENCIA COMBINADA SEVERA AUTOSÓMICA RECESIVA"
  },
  {
    "codigo":10962511000119102,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO PERÓNEO DERECHO"
  },
  {
    "codigo":721606002,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE LESIÓN SUPERPUESTA DE SENOS ACCESORIOS"
  },
  {
    "codigo":66246007,
    "descripcion":"FRACTURA EXPUESTA DE DIÁFISIS DE RADIO"
  },
  {
    "codigo":295622009,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE CICLOFOSFAMIDA"
  },
  {
    "codigo":785307003,
    "descripcion":"LISENCEFALIA CONCOMITANTE CON HIPOPLASIA CEREBELOSA CONGÉNITA TIPO A"
  },
  {
    "codigo":293787008,
    "descripcion":"ALERGIA A AMINOGLUTETIMIDA"
  },
  {
    "codigo":717936002,
    "descripcion":"ENFERMEDAD HEMORRÁGICA DEL RECIÉN NACIDO DEBIDA A DEFICIENCIA DE VITAMINA K DE COMIENZO CLÁSICO"
  },
  {
    "codigo":291952006,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR PROCAINAMIDA"
  },
  {
    "codigo":95344007,
    "descripcion":"ÚLCERA DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":1240389001,
    "descripcion":"TRASTORNO NEONATAL PRECOZ DEBIDO A PLACENTA PEQUEÑA"
  },
  {
    "codigo":191813001,
    "descripcion":"ALCOHOLISMO CRÓNICO EN REMISIÓN"
  },
  {
    "codigo":1142085005,
    "descripcion":"VARICELA PERINATAL DISEMINADA"
  },
  {
    "codigo":93509007,
    "descripcion":"ENFERMEDAD DE HODGKIN, CELULARIDAD MIXTA DEL BAZO"
  },
  {
    "codigo":288282003,
    "descripcion":"FRACTURA DE LARINGE\/TRÁQUEA"
  },
  {
    "codigo":124442007,
    "descripcion":"DEFICIENCIA DE FOSFORILASA FOSFATASA"
  },
  {
    "codigo":126856000,
    "descripcion":"NEOPLASIA DE CONDUCTO CÍSTICO"
  },
  {
    "codigo":253679008,
    "descripcion":"COARTACIÓN DE AORTA ABDOMINAL"
  },
  {
    "codigo":286447009,
    "descripcion":"CAPAZ DE MANEJAR RECIPIENTES DE ALIMENTO"
  },
  {
    "codigo":55236002,
    "descripcion":"HIPOFOSFATASIA INFANTIL"
  },
  {
    "codigo":1079171000119100,
    "descripcion":"CARCINOMA BASOCELULAR PRIMARIO DE PÁRPADO DERECHO"
  },
  {
    "codigo":219076007,
    "descripcion":"REACCIÓN ADVERSA A VACUNA CONTRA LA TUBERCULOSIS"
  },
  {
    "codigo":284612008,
    "descripcion":"DIFICULTAD PARA CONTROLAR LA AGRESIÓN"
  },
  {
    "codigo":446617001,
    "descripcion":"DISTORSIÓN VISUAL DE LA PERCEPCIÓN DE LA FORMA"
  },
  {
    "codigo":118937003,
    "descripcion":"TRASTORNO DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":282777004,
    "descripcion":"LESIÓN TRAUMÁTICA DE DEDO GORDO DE PIE"
  },
  {
    "codigo":671000221100,
    "descripcion":"ABORTO ASOCIADO A LA INFECCIÓN POR ZIKV"
  },
  {
    "codigo":315545003,
    "descripcion":"NACIDO EN TRINIDAD Y TOBAGO"
  },
  {
    "codigo":250009009,
    "descripcion":"MARCHA CON PRÓTESIS DE MIEMBRO"
  },
  {
    "codigo":117102002,
    "descripcion":"UNIDAD DE HEMODERIVADO RESERVADA"
  },
  {
    "codigo":870766001,
    "descripcion":"ERUPCIÓN ACNEIFORME DEBIDA A COMPUESTO DE BROMO"
  },
  {
    "codigo":1263982007,
    "descripcion":"HEMORRAGIA DE FOSA POSTERIOR NO TRAUMÁTICA NEONATAL PRECOZ"
  },
  {
    "codigo":248174008,
    "descripcion":"LABIO - HALLAZGO"
  },
  {
    "codigo":770627003,
    "descripcion":"MIOPATÍA MIOFIBRILAR ASOCIADA CON DESMINA"
  },
  {
    "codigo":705091004,
    "descripcion":"FRACTURA NO EXPUESTA DE PLACA EPIFISARIA DE FÉMUR DISTAL"
  },
  {
    "codigo":15128004,
    "descripcion":"DIFERENCIAS VENTILATORIAS REGIONALES POR TAMAÑO DESIGUAL DE LOS BRONQUIOS"
  },
  {
    "codigo":736024007,
    "descripcion":"PANCITOPENIA CAUSADA POR MEDICACIÓN"
  },
  {
    "codigo":408344008,
    "descripcion":"PRESCRIPCIÓN DE GENÉRICO VERIFICADA"
  },
  {
    "codigo":766957000,
    "descripcion":"OBSTRUCCIÓN DE VENA ILÍACA"
  },
  {
    "codigo":768792007,
    "descripcion":"CATARATA DE OJO DERECHO DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":111597003,
    "descripcion":"HEMORRAGIA INTRACRANEAL CONCOMITANTE CON FRACTURA EXPUESTA DE LA BÓVEDA CRANEAL Y DEBIDA A ELLA"
  },
  {
    "codigo":441112007,
    "descripcion":"CAPAZ DE CONTAR HASTA 10"
  },
  {
    "codigo":275437005,
    "descripcion":"HIPERFUNCIÓN ADRENOCORTICAL"
  },
  {
    "codigo":46061007,
    "descripcion":"FENÓMENO DE BELL"
  },
  {
    "codigo":240834001,
    "descripcion":"FILARIASIS CRÓNICA POR BRUGIA TIMORI"
  },
  {
    "codigo":208066007,
    "descripcion":"FRACTURA VERTEBRAL EXPUESTA CON LESIÓN POSTERIOR DE MÉDULA ESPINAL LUMBAR"
  },
  {
    "codigo":44226007,
    "descripcion":"AGRESIÓN DEFENSIVA"
  },
  {
    "codigo":109762009,
    "descripcion":"FRACTURA VERTICAL DE LA RAÍZ DENTAL"
  },
  {
    "codigo":402839002,
    "descripcion":"ANGIOQUERATOMA ADQUIRIDO"
  },
  {
    "codigo":11458009,
    "descripcion":"ANSIEDAD ANTICIPATORIA, LEVE"
  },
  {
    "codigo":304535004,
    "descripcion":"CARACTERÍSTICAS DE PARKINSONISMO"
  },
  {
    "codigo":238999005,
    "descripcion":"HIPOMELANOSIS FARMACÓGENA"
  },
  {
    "codigo":271767006,
    "descripcion":"DESCAMACIÓN CUTÁNEA"
  },
  {
    "codigo":370071009,
    "descripcion":"INVASIÓN TUMORAL EN LA SUPRAGLOTIS"
  },
  {
    "codigo":1351276005,
    "descripcion":"HIPERALDOSTERONISMO FAMILIAR TIPO 4"
  },
  {
    "codigo":1285740005,
    "descripcion":"HIPERTENSIÓN OCULAR DEBIDA A SÍNDROME SISTÉMICO"
  },
  {
    "codigo":169793002,
    "descripcion":"PRUEBA TRIPLE PENDIENTE"
  },
  {
    "codigo":366401006,
    "descripcion":"AMPLITUD DE RETRACCIÓN DE LA COLUMNA CERVICAL - HALLAZGO"
  },
  {
    "codigo":300865007,
    "descripcion":"IMPULSO TUSÍGENO DE LA MASA, PRESENTE"
  },
  {
    "codigo":333633007,
    "descripcion":"APRAXIA TRANSCORTICAL"
  },
  {
    "codigo":299030001,
    "descripcion":"SIGNO CON NOMBRE PROPIO DE LA MUÑECA"
  },
  {
    "codigo":725014003,
    "descripcion":"LESIÓN TRAUMÁTICA DE FASCIA DE CUELLO"
  },
  {
    "codigo":266262004,
    "descripcion":"ÉMBOLO Y TROMBOSIS ARTERIAL"
  },
  {
    "codigo":297195000,
    "descripcion":"MACRODACTILIA DE MANO"
  },
  {
    "codigo":167958008,
    "descripcion":"DENSIDAD DE LÍQUIDO PLEURAL POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":721344000,
    "descripcion":"FRACTURA DE APÓFISIS ODONTOIDES DEL AXIS TIPO I"
  },
  {
    "codigo":65984002,
    "descripcion":"SALPINGITIS FOLICULAR"
  },
  {
    "codigo":197056004,
    "descripcion":"PSEUDO-OBSTRUCCIÓN DEL TRACTO GASTROINTESTINAL"
  },
  {
    "codigo":1081681000119100,
    "descripcion":"RABDOMIOSARCOMA PRIMARIO DE REGIÓN DE HOMBRO DERECHO"
  },
  {
    "codigo":10421000132103,
    "descripcion":"HEMORRAGIA QUE REQUIERE TRANSFUSIÓN"
  },
  {
    "codigo":295360009,
    "descripcion":"SOBREDOSIS DE NIZATIDINA"
  },
  {
    "codigo":162453003,
    "descripcion":"PRESENTA EL SÍNTOMA HORARIAMENTE"
  },
  {
    "codigo":16017591000119108,
    "descripcion":"ALTERACIÓN DE LA ALINEACIÓN DEL ASTA ANTERIOR DEL MENISCO EXTERNO DE LA RODILLA DERECHA"
  },
  {
    "codigo":129685008,
    "descripcion":"HALLAZGO RELACIONADO CON LAS CONDICIONES DE SEGURIDAD DEL VECINDARIO\/ LUGAR DE TRABAJO"
  },
  {
    "codigo":1145493007,
    "descripcion":"HIPOPLASIA CONGÉNITA DE DEDO ANULAR"
  },
  {
    "codigo":226154003,
    "descripcion":"DIETA RICA EN VITAMINA ANTIOXIDANTE"
  },
  {
    "codigo":95082005,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE PIEL DE DEDO DE PIE"
  },
  {
    "codigo":93247001,
    "descripcion":"HIPOPLASIA CONGÉNITA DEL VENTRÍCULO CARDÍACO"
  },
  {
    "codigo":224319003,
    "descripcion":"EN CLASE ESPECIAL EN LA ESCUELA REGULAR"
  },
  {
    "codigo":1141823004,
    "descripcion":"COMPOSICIÓN DE INGESTA NUTRICIONAL DE GRASA Y ACEITE INCOMPATIBLE CON EL REQUERIMIENTO"
  },
  {
    "codigo":124180000,
    "descripcion":"DEFICIENCIA DE NICOTINATO DESHIDROGENASA"
  },
  {
    "codigo":715839009,
    "descripcion":"DEFORMIDAD MUCOGINGIVAL SOBRE CRESTA ALVEOLAR DESDENTADA DEBIDA A DISMINUCIÓN DE LA PROFUNDIDAD VESTIBULAR"
  },
  {
    "codigo":289855008,
    "descripcion":"LESIÓN DE PERINEO FEMENINO"
  },
  {
    "codigo":286185000,
    "descripcion":"CAPAZ DE ORDENAR LA CASA"
  },
  {
    "codigo":56809002,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE MUSLO SIN INFECCIÓN"
  },
  {
    "codigo":317931000119101,
    "descripcion":"ENFERMEDAD PULMONAR DEBIDA A ANGEÍTIS GRANULOMATOSA"
  },
  {
    "codigo":1269225005,
    "descripcion":"SÍNDROME URÉMICO HEMOLÍTICO CON DEFICIENCIA DE DGKE"
  },
  {
    "codigo":253417009,
    "descripcion":"DEFECTO DEL TABIQUE AURICULOVENTRICULAR - COMPONENTE VENTRICULAR"
  },
  {
    "codigo":218814009,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR NALORFINA"
  },
  {
    "codigo":413587002,
    "descripcion":"MIELOMA QUIESCENTE"
  },
  {
    "codigo":282515003,
    "descripcion":"NO SUBE ESCALONES CORRIENDO"
  },
  {
    "codigo":42541000087100,
    "descripcion":"HERIDA PUNZANTE DE PENE"
  },
  {
    "codigo":47661000087102,
    "descripcion":"DISTENSIÓN DE MÚSCULO SUBESCAPULAR DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":1003411006,
    "descripcion":"DUPLICACIÓN DE PORCIÓN MEDIA DE BRAZO LARGO DE CROMOSOMA 7"
  },
  {
    "codigo":247912001,
    "descripcion":"ACCIONES INCOMPLETAS"
  },
  {
    "codigo":1362024002,
    "descripcion":"TRASTORNO DE SANGRADO ASOCIADO A ISOFORMAS CORTAS DEL FACTOR V"
  },
  {
    "codigo":39981000087108,
    "descripcion":"HERIDA PUNZANTE DE DEDO MEDIO DE MANO IZQUIERDA CON CUERPO EXTRAÑO"
  },
  {
    "codigo":72171000119106,
    "descripcion":"SOPLO CARDÍACO DURANTE EMBARAZO"
  },
  {
    "codigo":1263720007,
    "descripcion":"TRASTORNO FETAL DEBIDO A ANOMALÍA CORIÓNICA"
  },
  {
    "codigo":213309003,
    "descripcion":"TROMBOEMBOLIA POSTERIOR A INFUSIÓN"
  },
  {
    "codigo":442685003,
    "descripcion":"ESTEATOHEPATITIS ASOCIADA A DISFUNCIÓN METABÓLICA"
  },
  {
    "codigo":1163581009,
    "descripcion":"NÓDULO DE PALADAR BLANDO"
  },
  {
    "codigo":277010001,
    "descripcion":"EPISODIO INEXPLICADO DE DISFUNCIÓN DEL TRASPLANTE RENAL"
  },
  {
    "codigo":702994004,
    "descripcion":"PROVIDENCIA ALCALIFACIENS O PROVIDENCIA RUSTIGIANII"
  },
  {
    "codigo":1260050006,
    "descripcion":"COLANGIOCARCINOMA DE CONDUCTO BILIAR INTRAHEPÁTICO"
  },
  {
    "codigo":209639000,
    "descripcion":"DESGARRO COMPLETO DE LIGAMENTO TARSOMETATARSIANO"
  },
  {
    "codigo":735762009,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE PARED ANTERIOR DEL TÓRAX"
  },
  {
    "codigo":309778009,
    "descripcion":"PESTAÑA ENCARNADA DEL PÁRPADO SUPERIOR"
  },
  {
    "codigo":371644000,
    "descripcion":"CUERPO DESCOMPUESTO SIN INMERSIÓN"
  },
  {
    "codigo":111335009,
    "descripcion":"AUSENCIA CONGÉNITA DE LA VULVA"
  },
  {
    "codigo":109500001,
    "descripcion":"MALA OCLUSIÓN, CLASE I DE ANGLE"
  },
  {
    "codigo":764860006,
    "descripcion":"ACIDURIA 3-METILGLUTACÓNICA TIPO 7"
  },
  {
    "codigo":238737002,
    "descripcion":"TRICOMALACIA"
  },
  {
    "codigo":9361007,
    "descripcion":"PROLAPSO DE TROMPA DE FALOPIO"
  },
  {
    "codigo":1187174002,
    "descripcion":"TRASTORNO CONGÉNITO DE LA GLICOSILACIÓN CCDC115"
  },
  {
    "codigo":73062002,
    "descripcion":"ADHERENCIAS DE LA VAGINA"
  },
  {
    "codigo":346911000119103,
    "descripcion":"DEGENERACIÓN DE COROIDES DE AMBOS OJOS"
  },
  {
    "codigo":300603000,
    "descripcion":"UTILIZA COMODIDADES LOCALES"
  },
  {
    "codigo":204134008,
    "descripcion":"COLOBOMA DEL CRISTALINO"
  },
  {
    "codigo":890427002,
    "descripcion":"HIPERPLASIA CONGÉNITA PRIMARIA BILATERAL DE PULMÓN"
  },
  {
    "codigo":235067001,
    "descripcion":"TUBERCULOSIS BUCAL"
  },
  {
    "codigo":169531004,
    "descripcion":"UTILIZA ESPONJA ANTICONCEPTIVA CON ESPERMICIDA"
  },
  {
    "codigo":298768000,
    "descripcion":"TUMEFACCIÓN DE ARTICULACIÓN DE HOMBRO"
  },
  {
    "codigo":366139009,
    "descripcion":"HALLAZGO RELACIONADO CON LA FACILIDAD DE LA RESPIRACIÓN"
  },
  {
    "codigo":1084191000119105,
    "descripcion":"ACÚFENO PULSÁTIL OBJETIVO DE AMBOS OÍDOS"
  },
  {
    "codigo":724752004,
    "descripcion":"SÍNDROME HIPNAGÓGICO DE LA CABEZA EXPLOSIVA"
  },
  {
    "codigo":397072005,
    "descripcion":"INCLUSIÓN BABÉSICA EN ERITROCITO"
  },
  {
    "codigo":69392006,
    "descripcion":"TRASTORNO DEPRESIVO MAYOR, UN SOLO EPISODIO CON SÍNTOMAS CATATÓNICOS"
  },
  {
    "codigo":722917001,
    "descripcion":"QUISTE CONGÉNITO DE PLIEGUE ARIEPIGLÓTICO"
  },
  {
    "codigo":34789001,
    "descripcion":"DOLOR EN CÓCCIX"
  },
  {
    "codigo":1148901006,
    "descripcion":"CARCINOMA ESCAMOCELULAR DE GENITAL MASCULINO"
  },
  {
    "codigo":788453008,
    "descripcion":"HIPERMOVILIDAD DE ARTICULACIÓN"
  },
  {
    "codigo":295098001,
    "descripcion":"ALERGIA A ISOXSUPRINA"
  },
  {
    "codigo":721082002,
    "descripcion":"SÍNDROME DE DACRIOCISTITIS Y OSTEOPOIQUILOSIS"
  },
  {
    "codigo":15639481000119102,
    "descripcion":"CATARATA SUBCAPSULAR POSTERIOR DE AMBOS OJOS"
  },
  {
    "codigo":1145231005,
    "descripcion":"PELO ANÁGENO ARRANCADO FÁCILMENTE"
  },
  {
    "codigo":293263007,
    "descripcion":"REACCIÓN ADVERSA A LA QUINAGOLIDA"
  },
  {
    "codigo":1340004001,
    "descripcion":"FRACTURA DE FALANGE DE SEGUNDO A CUARTO DEDOS DE PIE"
  },
  {
    "codigo":62052002,
    "descripcion":"HIPERTIROIDISMO CAUSADO POR AMIODARONA"
  },
  {
    "codigo":29284004,
    "descripcion":"ESTADO DE CRIOPRESERVACIÓN"
  },
  {
    "codigo":1208932005,
    "descripcion":"MACULOPATÍA TÓXICA DE AMBOS OJOS CAUSADA POR FÁRMACO ANTIPALÚDICO"
  },
  {
    "codigo":94820008,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE GLÁNDULA ENDOCRINA"
  },
  {
    "codigo":191289002,
    "descripcion":"TRASTORNO HEMORRÁGICO DEBIDO A HIPERHEPARINEMIA"
  },
  {
    "codigo":92985003,
    "descripcion":"ISQUION ARQUEADO CONGÉNITO"
  },
  {
    "codigo":10861651000119101,
    "descripcion":"HERIDA POR DISPARO DE ARMA DE FUEGO DE REGIÓN DE CADERA DERECHA"
  },
  {
    "codigo":289593005,
    "descripcion":"HALLAZGO RELACIONADO CON LA SENSIBILIDAD VAGINAL"
  },
  {
    "codigo":60217008,
    "descripcion":"ICTERICIA HEMOLÍTICA"
  },
  {
    "codigo":715577009,
    "descripcion":"COLELITIASIS ASOCIADA CON FOSFOLÍPIDOS BAJOS"
  },
  {
    "codigo":1010489008,
    "descripcion":"AGENESIA DE PLIEGUE CUTÁNEO INTERFALÁNGICO DISTAL"
  },
  {
    "codigo":713742005,
    "descripcion":"ANTICUERPO CONTRA VIRUS DE INMUNODEFICIENCIA HUMANA DETECTADO"
  },
  {
    "codigo":123918006,
    "descripcion":"INTOXICACIÓN POR CLUSIACEAE"
  },
  {
    "codigo":416995001,
    "descripcion":"MÉDULA ÓSEA HIPOCELULAR"
  },
  {
    "codigo":254990009,
    "descripcion":"TUMOR MUCOEPIDERMOIDE DE GLÁNDULA LAGRIMAL"
  },
  {
    "codigo":449763003,
    "descripcion":"GINGIVITIS POR CUERPO EXTRAÑO"
  },
  {
    "codigo":285923004,
    "descripcion":"CAPAZ DE LLENAR EL LAVABO"
  },
  {
    "codigo":710072005,
    "descripcion":"TRÍADA DE LA MUJER ATLETA"
  },
  {
    "codigo":50056009,
    "descripcion":"INTOLERANCIA A LA PROTEÍNA LISINÚRICA, TIPO 1"
  },
  {
    "codigo":447928009,
    "descripcion":"DOBLE CAYADO AÓRTICO CON ARCOS BALANCEADOS"
  },
  {
    "codigo":413325006,
    "descripcion":"ÁREA DE JUEGOS SEGURA"
  },
  {
    "codigo":773773006,
    "descripcion":"ESCOLIOSIS POR ACRODISPLASIA"
  },
  {
    "codigo":444258003,
    "descripcion":"COMPRESIÓN DE INTESTINO EN AGUJERO EPIPLOICO"
  },
  {
    "codigo":278583000,
    "descripcion":"PUENTE DENTAL MUY VOLUMINOSO"
  },
  {
    "codigo":247650009,
    "descripcion":"PLANIFICACIÓN DE SUICIDIO"
  },
  {
    "codigo":737335004,
    "descripcion":"INTOXICACIÓN CON CANABINOIDE SINTÉTICO"
  },
  {
    "codigo":47372000,
    "descripcion":"TRASTORNO DE ADAPTACIÓN, CON ANSIEDAD"
  },
  {
    "codigo":473356001,
    "descripcion":"ANOMALÍA ADQUIRIDA DE VENA SISTÉMICA"
  },
  {
    "codigo":702732007,
    "descripcion":"AUTISMO DE ALTO FUNCIONAMIENTO"
  },
  {
    "codigo":1259788009,
    "descripcion":"MESOTELIOMA PRIMARIO MALIGNO DE PERITONEO PARIETAL"
  },
  {
    "codigo":307681002,
    "descripcion":"MOVIMIENTOS OCULARES ESPONTÁNEOS ANORMALES"
  },
  {
    "codigo":322951000119101,
    "descripcion":"DEDO ÍNDICE DERECHO EN GATILLO ADQUIRIDO"
  },
  {
    "codigo":209377002,
    "descripcion":"FRACTURA-SUBLUXACIÓN NO EXPUESTA DE ARTICULACIÓN METATARSOFALÁNGICA, MÚLTIPLE"
  },
  {
    "codigo":1290721004,
    "descripcion":"ARTRITIS INFECCIOSA DE ARTICULACIÓN GLENOHUMERAL IZQUIERDA"
  },
  {
    "codigo":897505006,
    "descripcion":"EMBRIOFETOPATÍA CAUSADA POR INFECCIÓN"
  },
  {
    "codigo":78305006,
    "descripcion":"TUBÉRCULO PARAMOLAR"
  },
  {
    "codigo":240310001,
    "descripcion":"QUEJIDO EN EL LACTANTE"
  },
  {
    "codigo":305846002,
    "descripcion":"ATENDIDO POR EL SERVICIO DE PODOLOGÍA"
  },
  {
    "codigo":405985009,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA MESENTÉRICO COMPROMETIDO POR NEOPLASIA MALIGNA"
  },
  {
    "codigo":10934005,
    "descripcion":"CRIOFIBRINOGENEMIA"
  },
  {
    "codigo":830134006,
    "descripcion":"RETINA DE OJO DERECHO COMPLETAMENTE EVALUABLE"
  },
  {
    "codigo":699062006,
    "descripcion":"LESIÓN TRAUMÁTICA DE HOMBRO Y BRAZO"
  },
  {
    "codigo":369547000,
    "descripcion":"NEOPLASIA MALIGNA QUE COMPROMETE TROMPA DE FALOPIO DERECHA POR PROPAGACIÓN DIRECTA DESDE ENDOMETRIO"
  },
  {
    "codigo":1354422006,
    "descripcion":"OCLUSIÓN DE HEMIVENA RETINIANA SUPERIOR"
  },
  {
    "codigo":402315002,
    "descripcion":"PSORIASIS DE PENE"
  },
  {
    "codigo":205707006,
    "descripcion":"MOSAICO XO\/XY"
  },
  {
    "codigo":105568001,
    "descripcion":"EN PRISIÓN"
  },
  {
    "codigo":41867009,
    "descripcion":"INTERRUPCIÓN TOTAL DE LA ESPERMATOGENIA"
  },
  {
    "codigo":302176003,
    "descripcion":"NÓDULO DE OSLER DEL PIE"
  },
  {
    "codigo":236640001,
    "descripcion":"HIPOSENSIBILIDAD DE VEJIGA URINARIA"
  },
  {
    "codigo":171104008,
    "descripcion":"CRIBADO DESEADO"
  },
  {
    "codigo":300341002,
    "descripcion":"VESÍCULA BILIAR AUSENTE"
  },
  {
    "codigo":1119541006,
    "descripcion":"CONSTRICCIÓN LEVE DE CAMPO VISUAL PERIFÉRICO"
  },
  {
    "codigo":16051591000119108,
    "descripcion":"ARTROPATÍA DE RODILLA DERECHA DEBIDA A SÍNDROME DE BEHCET"
  },
  {
    "codigo":365877008,
    "descripcion":"EXAMEN MICROSCÓPICO DE ORINA: LEUCOCITOS POLIMORFONUCLEARES PRESENTES"
  },
  {
    "codigo":726325008,
    "descripcion":"DISTENSIÓN DE MÚSCULO INTRÍNSECO DE PIE"
  },
  {
    "codigo":396810002,
    "descripcion":"MARGEN QUIRÚRGICO DISTAL DEL PÁNCREAS COMPROMETIDO POR NEOPLASIA MALIGNA"
  },
  {
    "codigo":724490006,
    "descripcion":"HEMORRAGIA INTRAPARTO CONCOMITANTE CON TRABAJO DE PARTO OBSTRUIDO CON RUPTURA UTERINA Y DEBIDA A ELLA"
  },
  {
    "codigo":67295004,
    "descripcion":"PELO GRASO"
  },
  {
    "codigo":34527004,
    "descripcion":"HIPOFONÍA"
  },
  {
    "codigo":296671007,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE CEFADROXILO"
  },
  {
    "codigo":427743008,
    "descripcion":"CUERPO EXTRAÑO DE METAL EN FARINGE"
  },
  {
    "codigo":720820000,
    "descripcion":"SÍNDROME DE FOTOSENSIBILIDAD CUTÁNEA Y COLITIS LETAL"
  },
  {
    "codigo":722655009,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO RADIAL AL NIVEL DEL BRAZO"
  },
  {
    "codigo":65460003,
    "descripcion":"GLAUCOMA INTERMITENTE DE CIERRE DE ÁNGULO"
  },
  {
    "codigo":425908001,
    "descripcion":"DOLOR IRRADIADO A LA REGIÓN TORÁCICA, LADO DERECHO"
  },
  {
    "codigo":1144969001,
    "descripcion":"ADHERENCIAS DE ANEXOS UTERINOS DEBIDAS A ENDOMETRIOSIS"
  },
  {
    "codigo":293001002,
    "descripcion":"REACCIÓN ADVERSA AL LATAMOXEF"
  },
  {
    "codigo":129161004,
    "descripcion":"LUXACIÓN TRAUMÁTICA DE LA ARTICULACIÓN LUMBOSACRA"
  },
  {
    "codigo":30857006,
    "descripcion":"INTOXICACIÓN CAUSADA POR BARBITAL"
  },
  {
    "codigo":94558000,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA PIEL DE LA FRENTE"
  },
  {
    "codigo":260233009,
    "descripcion":"COMBINACIÓN DE POSICIONES"
  },
  {
    "codigo":291166000,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR LEVOMEPROMAZINA"
  },
  {
    "codigo":225630000,
    "descripcion":"MIEDO AL DENTISTA"
  },
  {
    "codigo":420403001,
    "descripcion":"NEUMOCISTOSIS CON SÍNDROME DE INMUNODEFICIENCIA ADQUIRIDA"
  },
  {
    "codigo":92723003,
    "descripcion":"CARCINOMA IN SITU DE LA PIEL DE LOS PÁRPADOS"
  },
  {
    "codigo":16037831000119100,
    "descripcion":"OSTEOCONDROPATÍA DE CÚBITO IZQUIERDO"
  },
  {
    "codigo":314311000119100,
    "descripcion":"MIOSITIS OSIFICANTE TRAUMÁTICA DE MUSLO DERECHO"
  },
  {
    "codigo":10759111000119102,
    "descripcion":"HEPATITIS VIRAL EN LA MADRE QUE COMPLICA EL NACIMIENTO"
  },
  {
    "codigo":337351000119100,
    "descripcion":"BLEFARITIS ULCEROSA DE PÁRPADO IZQUIERDO"
  },
  {
    "codigo":10636231000119104,
    "descripcion":"ÚLCERA CRÓNICA DE REGIÓN MEDIA DEL PIE"
  },
  {
    "codigo":132551000119104,
    "descripcion":"TROMBOSIS CRÓNICA DE VENA SUBCLAVIA"
  },
  {
    "codigo":10631111000119106,
    "descripcion":"LINFANGITIS AGUDA DE EXTREMIDAD INFERIOR IZQUIERDA"
  },
  {
    "codigo":342471000119104,
    "descripcion":"EDEMA DE PÁRPADO INFERIOR DERECHO"
  },
  {
    "codigo":334791000119100,
    "descripcion":"QUISTE IDIOPÁTICO DE IRIS DERECHO"
  },
  {
    "codigo":16058311000119100,
    "descripcion":"TRASTORNO DE PLEXO LUMBOSACRO IZQUIERDO"
  },
  {
    "codigo":10674631000119108,
    "descripcion":"QUISTE DE SENO ESFENOIDAL"
  },
  {
    "codigo":11839431000119109,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO INTRÍNSECO DE MANO DERECHA"
  },
  {
    "codigo":301511000119105,
    "descripcion":"ABSCESO DE BOLSA SEROSA DE CADERA DERECHA"
  },
  {
    "codigo":83911000119104,
    "descripcion":"OBESIDAD SEVERA"
  },
  {
    "codigo":329671000119106,
    "descripcion":"HEMORRAGIA SUBARACNOIDEA TRAUMÁTICA CON PÉRDIDA DE CONSCIENCIA"
  },
  {
    "codigo":10682311000119109,
    "descripcion":"TUMORACIÓN DE LA PIEL DE LA EXTREMIDAD INFERIOR IZQUIERDA"
  },
  {
    "codigo":58120009,
    "descripcion":"SUSTITUCIÓN ARTICULATORIA COMPENSATORIA"
  },
  {
    "codigo":285661003,
    "descripcion":"LESIÓN DE LA APÓFISIS MASTOIDES"
  },
  {
    "codigo":10738631000119109,
    "descripcion":"HIPERPLASIA DE CONDUCTO GALACTÓFORO DE MAMA IZQUIERDA"
  },
  {
    "codigo":1336072009,
    "descripcion":"EPISODIO DE USO NOCIVO DE INHALANTE VOLÁTIL"
  },
  {
    "codigo":11820731000119107,
    "descripcion":"INESTABILIDAD MULTIDIRECCIONAL DE ARTICULACIÓN ESCAPULOHUMERAL IZQUIERDA"
  },
  {
    "codigo":711645008,
    "descripcion":"ÚLCERA DE CÓRNEA CAUSADA POR ACANTHAMOEBA"
  },
  {
    "codigo":1268701008,
    "descripcion":"GLIOSARCOMA PRIMARIO DE SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":283826009,
    "descripcion":"MORDEDURA DE ANIMAL EN LA RODILLA"
  },
  {
    "codigo":447666009,
    "descripcion":"AURÍCULA IZQUIERDA DIVIDIDA CON DESEMBOCADURA DE TODAS LAS VENAS PULMONARES EN LA CÁMARA PROXIMAL Y LUEGO EN LA AURÍCULA IZQUIERDA"
  },
  {
    "codigo":247388003,
    "descripcion":"NEURALGIA SEGMENTARIA PERIFÉRICA"
  },
  {
    "codigo":1197660005,
    "descripcion":"ESTENOSIS DE INTESTINO GRUESO DEBIDA A DIVERTICULITIS"
  },
  {
    "codigo":312924008,
    "descripcion":"CORIORRETINOPATÍA SEROSA CENTRAL, INACTIVA"
  },
  {
    "codigo":116316008,
    "descripcion":"HALLAZGO RELACIONADO CON LA REGIÓN DEL PIE"
  },
  {
    "codigo":10948591000119101,
    "descripcion":"HERIDA POR ARMA BLANCA DE MANO IZQUIERDA"
  },
  {
    "codigo":704305004,
    "descripcion":"ALTERACIÓN DEL VÍNCULO ENTRE CUIDADOR Y NIÑO"
  },
  {
    "codigo":1163057009,
    "descripcion":"ENCEFALITIS POR VIRUS LASSA"
  },
  {
    "codigo":309254003,
    "descripcion":"CELULITIS DE LA PIEL DEL DORSO"
  },
  {
    "codigo":702470005,
    "descripcion":"LA PERSONA A CARGO DEL CUIDADO TIENE RESPONSABILIDAD PARENTAL EXCLUSIVA"
  },
  {
    "codigo":473094008,
    "descripcion":"INFLAMACIÓN ASOCIADA CON DISPOSITIVO GENITOURINARIO"
  },
  {
    "codigo":768006009,
    "descripcion":"HEPATITIS C CRÓNICA CAUSADA POR GENOTIPO 3 DE VIRUS HEPATITIS C"
  },
  {
    "codigo":372955000,
    "descripcion":"INFECCIÓN CAUSADA POR PENICILLIUM GRISEOFULVUM"
  },
  {
    "codigo":1259526008,
    "descripcion":"CARCINOMA PRIMARIO DE HUESOS PÉLVICOS, SACRO Y CÓCCIX"
  },
  {
    "codigo":733403004,
    "descripcion":"FRACTURAS MÚLTIPLES DE CLAVÍCULA"
  },
  {
    "codigo":897243005,
    "descripcion":"CURVATURA ANORMAL DE FALANGE MEDIA DE DEDO DE MANO"
  },
  {
    "codigo":274651006,
    "descripcion":"DESCONFIANZA Y EVASIVIDAD MARCADAS"
  },
  {
    "codigo":241883007,
    "descripcion":"EFECTO TÓXICO CAUSADO POR RELLENO"
  },
  {
    "codigo":240048000,
    "descripcion":"DISTROFIA MUSCULAR LIGADA AL X CON DISTROFINA ANORMAL"
  },
  {
    "codigo":371120001,
    "descripcion":"PARÁLISIS ESPINAL CUADRIPLÉJICA"
  },
  {
    "codigo":305584003,
    "descripcion":"BAJO ATENCIÓN DE ENFERMERA DE UNIDAD MÓVIL"
  },
  {
    "codigo":8837000,
    "descripcion":"DELIRIO POR ANFETAMINAS"
  },
  {
    "codigo":403888008,
    "descripcion":"CARCINOMAS ESCAMOSOS INTRAEPIDÉRMICOS MÚLTIPLES"
  },
  {
    "codigo":762501002,
    "descripcion":"RETRASO DE CRECIMIENTO DE CAUSA NUTRICIONAL EN LA ADOLESCENCIA"
  },
  {
    "codigo":1155717003,
    "descripcion":"CRISIS NO CONVULSIVA"
  },
  {
    "codigo":15673481000119101,
    "descripcion":"NÓDULO REUMATOIDEO DE TEJIDO CELULAR SUBCUTÁNEO DE AMBOS PIES"
  },
  {
    "codigo":1286789005,
    "descripcion":"PRESIÓN VENOSA EPIESCLERAL POR ENCIMA DE RANGO DE REFERENCIA"
  },
  {
    "codigo":860805006,
    "descripcion":"ENCEFALOMIELITIS CAUSADA POR NEISSERIA MENINGITIDIS"
  },
  {
    "codigo":1186650005,
    "descripcion":"DERMATITIS IRRITATIVA POR CONTACTO DEBIDA A FÍSTULA"
  },
  {
    "codigo":236378005,
    "descripcion":"PIELONEFRITIS POR CANDIDA"
  },
  {
    "codigo":301914008,
    "descripcion":"HALLAZGO RELACIONADO CON MEDICIONES DEL PÁRPADO"
  },
  {
    "codigo":201775006,
    "descripcion":"ARTRITIS REUMATOIDE DE LA CADERA"
  },
  {
    "codigo":234543009,
    "descripcion":"DEFICIENCIA DE INMUNOGLOBULINA DE CADENA LIVIANA"
  },
  {
    "codigo":365615009,
    "descripcion":"VOLUMEN CORPUSCULAR MEDIO - HALLAZGO"
  },
  {
    "codigo":396548003,
    "descripcion":"MARGEN QUIRÚRGICO DE CONDUCTO PANCREÁTICO COMPROMETIDO POR CARCINOMA IN SITU"
  },
  {
    "codigo":724228005,
    "descripcion":"SÍNDROME DE CALCIFICACIÓN COROIDOCEREBRAL INFANTIL"
  },
  {
    "codigo":298244009,
    "descripcion":"ARTICULACIÓN INTERFALÁNGICA DE DEDO DEL PIE RÍGIDA"
  },
  {
    "codigo":296409002,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE NIQUETAMIDA"
  },
  {
    "codigo":394713005,
    "descripcion":"PRUEBA DE LEUCOCITOS URINARIOS: ++"
  },
  {
    "codigo":198105008,
    "descripcion":"ABSCESO MAMARIO CRÓNICO NO PUERPERAL"
  },
  {
    "codigo":294574008,
    "descripcion":"ALERGIA A SULFADIMETOXINA"
  },
  {
    "codigo":65198009,
    "descripcion":"TROMBOSIS ARTERIAL"
  },
  {
    "codigo":63363004,
    "descripcion":"SÍNDROME DE LA VENA CAVA SUPERIOR"
  },
  {
    "codigo":1144707006,
    "descripcion":"HIPOPLASIA CONGÉNITA DE FALANGE PROXIMAL DE PIE"
  },
  {
    "codigo":30595008,
    "descripcion":"LEISHMANIASIS CUTÁNEA NECROSANTE AGUDA"
  },
  {
    "codigo":292739008,
    "descripcion":"REACCIÓN ADVERSA A PROTAMINA"
  },
  {
    "codigo":94296000,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE CUERDA VOCAL FALSA"
  },
  {
    "codigo":92461001,
    "descripcion":"NEOPLASIA BENIGNA DE LAS VÍAS RESPIRATORIAS SUPERIORES"
  },
  {
    "codigo":59693007,
    "descripcion":"MANO PLANA"
  },
  {
    "codigo":715053008,
    "descripcion":"DERMATOSIS CAUSADA POR ÁCARO DE LAS PLANTAS"
  },
  {
    "codigo":11852221000119102,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE DEDO GORDO DE PIE DERECHO"
  },
  {
    "codigo":289069009,
    "descripcion":"USA UTENSILIOS PARA ALIMENTARSE"
  },
  {
    "codigo":254466003,
    "descripcion":"CARCINOMA DE LA GLÁNDULA SUBLINGUAL"
  },
  {
    "codigo":713218007,
    "descripcion":"ENFERMEDAD GINGIVAL DEBIDA A PUBERTAD"
  },
  {
    "codigo":285399003,
    "descripcion":"LACERACIÓN DEL PREPUCIO"
  },
  {
    "codigo":449239005,
    "descripcion":"CATÉTER VENOSO CENTRAL IN SITU"
  },
  {
    "codigo":447404002,
    "descripcion":"CUERPO EXTRAÑO SUPERFICIAL"
  },
  {
    "codigo":283564004,
    "descripcion":"HERIDA DE PERDIGÓN EN ANTEBRAZO"
  },
  {
    "codigo":21420006,
    "descripcion":"ALCALOSIS"
  },
  {
    "codigo":52353000,
    "descripcion":"OTITIS MEDIA AGUDA MUCOIDE"
  },
  {
    "codigo":85121000,
    "descripcion":"ESTIMULACIÓN MANUAL DEL CLÍTORIS"
  },
  {
    "codigo":19585003,
    "descripcion":"ESTADO POSOPERATORIO"
  },
  {
    "codigo":314497004,
    "descripcion":"INFILTRADO CORNEAL RELACIONADO CON LENTES DE CONTACTO"
  },
  {
    "codigo":16003671000119101,
    "descripcion":"TENDINITIS DE MANGUITO ROTADOR IZQUIERDO"
  },
  {
    "codigo":609409007,
    "descripcion":"REACCIÓN DE HIPERSENSIBILIDAD NO ALÉRGICA CAUSADA POR SULFITO"
  },
  {
    "codigo":707713009,
    "descripcion":"LINFANGIECTASIA PULMONAR SECUNDARIA CONGÉNITA"
  },
  {
    "codigo":247126006,
    "descripcion":"DILATACIÓN ARTERIOVENOSA RETINIANA"
  },
  {
    "codigo":312662008,
    "descripcion":"EFECTO TARDÍO DE FRACTURA DE VÉRTEBRA LUMBAR"
  },
  {
    "codigo":1162795002,
    "descripcion":"FOSFATASA ALCALINA INTESTINAL POR DEBAJO DE RANGO DE REFERENCIA"
  },
  {
    "codigo":212523005,
    "descripcion":"INTOXICACIÓN POR QUINIOFÓN"
  },
  {
    "codigo":310827006,
    "descripcion":"TRASTORNO SOCIOLINGÜÍSTICO"
  },
  {
    "codigo":472832001,
    "descripcion":"TRASTORNO DE PRÓTESIS DE VÁLVULA MITRAL"
  },
  {
    "codigo":14080002,
    "descripcion":"EMBARAZO EXTRAMATRIMONIAL"
  },
  {
    "codigo":15731441000119100,
    "descripcion":"PAPILEDEMA DE OJO IZQUIERDO DEBIDO A PRESIÓN INTRAOCULAR POR DEBAJO DE RANGO DE REFERENCIA"
  },
  {
    "codigo":866048009,
    "descripcion":"NEOPLASIA QUÍSTICA MUCINOSA CON CARCINOMA INVASIVO DE PÁNCREAS"
  },
  {
    "codigo":733141003,
    "descripcion":"MAL FUNCIONAMIENTO DE SEGMENTO EFERENTE DE BOLSILLO URINARIO CONTINENTE"
  },
  {
    "codigo":12245007,
    "descripcion":"FÍSTULA INTESTINOVAGINAL"
  },
  {
    "codigo":208853008,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA EXPUESTA PERISEMILUNAR (DORSAL)"
  },
  {
    "codigo":11799281000119102,
    "descripcion":"LACERACIÓN DE ARTERIA ESPLÉNICA"
  },
  {
    "codigo":698538003,
    "descripcion":"REQUIERE RETENEDOR ORTODÓNCICO"
  },
  {
    "codigo":272554007,
    "descripcion":"ENCARAMADO"
  },
  {
    "codigo":205183000,
    "descripcion":"DETENCIÓN TRANSVERSAL A NIVEL DEL CARPO"
  },
  {
    "codigo":403626007,
    "descripcion":"PELAGRA CAUSADA POR FÁRMACO"
  },
  {
    "codigo":303487005,
    "descripcion":"SE ATA LOS CORDONES DE LOS ZAPATOS"
  },
  {
    "codigo":762239006,
    "descripcion":"DOLOR MIOFASCIAL CON IRRADIACIÓN"
  },
  {
    "codigo":237951008,
    "descripcion":"ACIDURIA 3-METILGLUTACÓNICA TIPO 1"
  },
  {
    "codigo":170580002,
    "descripcion":"PACIENTE CARDÍACO: CRITERIO DIAGNÓSTICO DUDOSO"
  },
  {
    "codigo":6740003,
    "descripcion":"FIBROADENOSIS QUÍSTICA DE LA MAMA"
  },
  {
    "codigo":236116005,
    "descripcion":"FUNCIONAMIENTO DEFECTUOSO DE ILEOSTOMÍA"
  },
  {
    "codigo":399956005,
    "descripcion":"NEOPLASIA MELANOCÍTICA"
  },
  {
    "codigo":301652007,
    "descripcion":"SE SIENTA EN UNA SILLA"
  },
  {
    "codigo":299817001,
    "descripcion":"REFLEJO VESTIBULOCULAR PRESENTE"
  },
  {
    "codigo":430889003,
    "descripcion":"OSTEONECROSIS DE HUESO DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":11854731000119101,
    "descripcion":"AMPOLLA TRAUMÁTICA DE OÍDO DERECHO"
  },
  {
    "codigo":365353007,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA RESISTIR PENSAMIENTOS"
  },
  {
    "codigo":70441009,
    "descripcion":"SÍNDROME DEL PERINEO DESCENDENTE"
  },
  {
    "codigo":429054002,
    "descripcion":"TRASTORNO RELACIONADO CON TRASPLANTE"
  },
  {
    "codigo":232446003,
    "descripcion":"HEMATOMA DE CUERDA VOCAL"
  },
  {
    "codigo":199678003,
    "descripcion":"INFECCIÓN DE CAVIDAD AMNIÓTICA CON PROBLEMA PRENATAL"
  },
  {
    "codigo":363518003,
    "descripcion":"NEOPLASIA MALIGNA DE RIÑÓN"
  },
  {
    "codigo":396286008,
    "descripcion":"BRONCONEUMONÍA BILATERAL"
  },
  {
    "codigo":297982009,
    "descripcion":"PROBLEMA CUTÁNEO"
  },
  {
    "codigo":165075003,
    "descripcion":"PRUEBA DE FUNCIÓN CARDÍACA, NORMAL"
  },
  {
    "codigo":230611005,
    "descripcion":"NEUROPATÍA CAUSADA POR TOXINA BACTERIANA"
  },
  {
    "codigo":64936001,
    "descripcion":"SÍNDROME DE LÖFFLER"
  },
  {
    "codigo":32168002,
    "descripcion":"INFECCIÓN CAUSADA POR FRENKELIA"
  },
  {
    "codigo":425384007,
    "descripcion":"SARCOIDOSIS CON GLOMERULONEFRITIS"
  },
  {
    "codigo":95869003,
    "descripcion":"EFECTO ADVERSO DE DISPOSITIVO PROTÉSICO"
  },
  {
    "codigo":292477003,
    "descripcion":"REACCIÓN ADVERSA AL BETANECOL"
  },
  {
    "codigo":1144445006,
    "descripcion":"HIPOPLASIA CONGÉNITA DE PLIEGUE PALMAR"
  },
  {
    "codigo":687141000119103,
    "descripcion":"NEUROFIBROMA DE PELVIS"
  },
  {
    "codigo":126802007,
    "descripcion":"NEOPLASIA DE MUCOSA YUGAL"
  },
  {
    "codigo":94034009,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA PIEL DEL CUELLO"
  },
  {
    "codigo":92199003,
    "descripcion":"NEOPLASIA BENIGNA DE GANGLIOS LINFÁTICOS DE LA CABEZA"
  },
  {
    "codigo":288807004,
    "descripcion":"INCAPAZ DE SALUDAR"
  },
  {
    "codigo":876796000,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE REGIÓN INTERESCAPULAR CON INFECCIÓN"
  },
  {
    "codigo":286972004,
    "descripcion":"HERNIA DIAFRAGMÁTICA COMPLICADA"
  },
  {
    "codigo":188668006,
    "descripcion":"SARCOMA MALIGNO DE MASTOCITOS DE BAZO"
  },
  {
    "codigo":418044006,
    "descripcion":"INFARTO DE MIOCARDIO EN FASE DE RECUPERACIÓN"
  },
  {
    "codigo":186833000,
    "descripcion":"SÍFILIS CONGÉNITA INICIAL - LATENTE"
  },
  {
    "codigo":416209007,
    "descripcion":"SINOVITIS"
  },
  {
    "codigo":840358001,
    "descripcion":"PESO CORPORAL ELEVADO"
  },
  {
    "codigo":53926002,
    "descripcion":"BRONQUITIS PLÁSTICA"
  },
  {
    "codigo":285137009,
    "descripcion":"MORDERSE LOS DEDOS DE LA MANO"
  },
  {
    "codigo":250534004,
    "descripcion":"ESPESAMIENTO DE LÍQUIDO SINOVIAL"
  },
  {
    "codigo":283302004,
    "descripcion":"ASTILLA DE MADERA EN PERINEO"
  },
  {
    "codigo":838523003,
    "descripcion":"INTOXICACIÓN CAUSADA POR METILENDIOXIMETANFETAMINA"
  },
  {
    "codigo":15979711000119104,
    "descripcion":"DESPLAZAMIENTO DE MENISCO DE AMBAS ARTICULACIONES TEMPOROMANDIBULARES"
  },
  {
    "codigo":248699005,
    "descripcion":"SOPLOS EXOCÁRDICOS"
  },
  {
    "codigo":707451005,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE PULMÓN"
  },
  {
    "codigo":445307009,
    "descripcion":"ESPINA BÍFIDA DE LA REGIÓN SACRA"
  },
  {
    "codigo":312400008,
    "descripcion":"TRAQUEOBRONQUITIS INFECCIOSA AGUDA"
  },
  {
    "codigo":475387071000119107,
    "descripcion":"DISTENSIÓN DE MÚSCULO INTRÍNSECO DE DEDO ÍNDICE"
  },
  {
    "codigo":277797007,
    "descripcion":"PIEL FINA"
  },
  {
    "codigo":212261007,
    "descripcion":"CONTUSIÓN, NERVIO CUBITAL"
  },
  {
    "codigo":332991000119109,
    "descripcion":"RETINITIS FOCAL DE POLO POSTERIOR DE OJO DERECHO"
  },
  {
    "codigo":46586006,
    "descripcion":"ALOPECIA AREATA DIFUSA"
  },
  {
    "codigo":274127000,
    "descripcion":"PARTO ANORMAL"
  },
  {
    "codigo":700111000,
    "descripcion":"SÍNDROME DE BARTTER, TIPO 3"
  },
  {
    "codigo":110287002,
    "descripcion":"DISCREPANCIA"
  },
  {
    "codigo":210426009,
    "descripcion":"HERIDA ABIERTA DEL PENE"
  },
  {
    "codigo":372431004,
    "descripcion":"COMPROMISO TUMORAL MULTIFOCAL EN MARGEN DE RESECCIÓN QUIRÚRGICA PROFUNDA, PRESENTE"
  },
  {
    "codigo":208591002,
    "descripcion":"FRACTURA EXPUESTA DE FÉMUR DISTAL, CONMINUTA\/INTRARTICULAR"
  },
  {
    "codigo":403364000,
    "descripcion":"ACNÉ MACULAR"
  },
  {
    "codigo":77519009,
    "descripcion":"COMPLICACIÓN DE PROCEDIMIENTO DE MEDICINA PREVENTIVA"
  },
  {
    "codigo":305060004,
    "descripcion":"ESTADOS DE ATENCIÓN DEL PACIENTE"
  },
  {
    "codigo":237689000,
    "descripcion":"DISFUNCIÓN DE LA NEUROSECRECIÓN DE LA HORMONA DEL CRECIMIENTO"
  },
  {
    "codigo":10956121000119108,
    "descripcion":"HERIDA ABIERTA DE DEDO ÍNDICE DERECHO DEBIDA A MORDEDURA"
  },
  {
    "codigo":204921008,
    "descripcion":"QUISTE DE CONDUCTO MESONÉFRICO"
  },
  {
    "codigo":1351801008,
    "descripcion":"INMUNODEFICIENCIA COMBINADA DEBIDA A MUTACIÓN DE IKZF2"
  },
  {
    "codigo":268622001,
    "descripcion":"PSICOSIS PARANOIDE CRÓNICA"
  },
  {
    "codigo":72014004,
    "descripcion":"DUPLICACIÓN FETAL ANORMAL"
  },
  {
    "codigo":301390006,
    "descripcion":"DOLOR A LA PALPACIÓN EN ESTRUCTURA CARDIOVASCULAR"
  },
  {
    "codigo":1153358006,
    "descripcion":"SÍNDROME DEL LINFOCITO PASAJERO POSTERIOR A TRASPLANTE DE ÓRGANO"
  },
  {
    "codigo":203086008,
    "descripcion":"EXCITACIÓN MUSCULAR INAPROPIADA"
  },
  {
    "codigo":365091003,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA ADMINISTRAR EL TIEMPO"
  },
  {
    "codigo":234019004,
    "descripcion":"VASCULITIS SISTÉMICA SECUNDARIA"
  },
  {
    "codigo":397859005,
    "descripcion":"PROBLEMA CON VAPORIZADOR DE ANESTESIA"
  },
  {
    "codigo":201251005,
    "descripcion":"ÚLCERA NEUROPÁTICA DE PIE DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":1217059006,
    "descripcion":"CALCIFICACIÓN DE GLÁNDULA PINEAL"
  },
  {
    "codigo":299555003,
    "descripcion":"CREPITACIÓN DE ARTICULACIÓN SUBASTRAGALINA"
  },
  {
    "codigo":102947004,
    "descripcion":"CONDUCTA SEXUAL DE ALTO RIESGO"
  },
  {
    "codigo":166648002,
    "descripcion":"NIVEL DE GAMMAGLUTAMIL TRANSFERASA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":199416003,
    "descripcion":"DESPROPORCIÓN FETOPÉLVICA"
  },
  {
    "codigo":230349000,
    "descripcion":"MIOCLONÍA DE MÚSCULO HIOIDEO"
  },
  {
    "codigo":263117000,
    "descripcion":"FRACTURA-SUBLUXACIÓN DE LA ARTICULACIÓN INTERFALÁNGICA DEL DEDO DEL PIE"
  },
  {
    "codigo":2808009,
    "descripcion":"INFECCIÓN CAUSADA POR PROSTHENORCHIS ELEGANS"
  },
  {
    "codigo":787405006,
    "descripcion":"METABOLIZADOR RÁPIDO DE LA FAMILIA 3 SUBFAMILIA A MIEMBRO 5 DEL CITOCROMO P450"
  },
  {
    "codigo":426957007,
    "descripcion":"ABSCESO DE PALADAR DURO"
  },
  {
    "codigo":295885006,
    "descripcion":"SOBREDOSIS DE TRIMIPRAMINA"
  },
  {
    "codigo":228514003,
    "descripcion":"MASTICA TAPÓN DE TABACO"
  },
  {
    "codigo":294050004,
    "descripcion":"ALERGIA A ISOPRENALINA"
  },
  {
    "codigo":31906004,
    "descripcion":"EFECTO TÓXICO DEL ÁCIDO SULFÚRICO"
  },
  {
    "codigo":95607001,
    "descripcion":"CONSUMO DE DROGAS POR PARTE DE LA MADRE"
  },
  {
    "codigo":292215002,
    "descripcion":"REACCIÓN ADVERSA A LA DACARBAZINA"
  },
  {
    "codigo":783735004,
    "descripcion":"DISOMÍA UNIPARENTAL DE CROMOSOMA X MATERNO"
  },
  {
    "codigo":126540000,
    "descripcion":"NEOPLASIA DE HUESO PARIETAL"
  },
  {
    "codigo":93772000,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL DIAFRAGMA"
  },
  {
    "codigo":716364007,
    "descripcion":"CARIES DE BORDE CERVICAL DE DIENTE"
  },
  {
    "codigo":290380007,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR CARBENOXOLONA"
  },
  {
    "codigo":91937001,
    "descripcion":"ALERGIA A ALIMENTO DE ORIGEN MARINO"
  },
  {
    "codigo":421452007,
    "descripcion":"HIPERFORIA"
  },
  {
    "codigo":190241003,
    "descripcion":"BOCIO TÓXICO DIFUSO SIN CRISIS"
  },
  {
    "codigo":288545008,
    "descripcion":"MUESTRA EMOCIÓN"
  },
  {
    "codigo":24566000,
    "descripcion":"ESOTROPÍA ALTERNANTE CON PATRÓN V"
  },
  {
    "codigo":712694006,
    "descripcion":"J5"
  },
  {
    "codigo":1204214007,
    "descripcion":"OCLUSIÓN AGUDA DE ARTERIA BRAQUIAL DEBIDA A TROMBOEMBOLISMO"
  },
  {
    "codigo":253942007,
    "descripcion":"DUPLICACIÓN DEL PERONÉ"
  },
  {
    "codigo":286710008,
    "descripcion":"CARÁCTER ANSIOSO"
  },
  {
    "codigo":53664003,
    "descripcion":"ESPONDILITIS GONOCÓCICA"
  },
  {
    "codigo":309031000119106,
    "descripcion":"TENDINITIS CALCIFICANTE DE RODILLA DERECHA"
  },
  {
    "codigo":20896007,
    "descripcion":"PÉRDIDA PARCIAL DE LOS HUESECILLOS DEL OÍDO"
  },
  {
    "codigo":283040009,
    "descripcion":"LESIÓN SUPERFICIAL DE LA RODILLA"
  },
  {
    "codigo":1003936009,
    "descripcion":"HIPERPLASIA PULMONAR CONGÉNITA PRIMARIA"
  },
  {
    "codigo":248437004,
    "descripcion":"FIEBRE PALÚDICA"
  },
  {
    "codigo":246602002,
    "descripcion":"IRRITACIÓN RADICULAR DE ORIGEN NO ORGÁNICO"
  },
  {
    "codigo":443210003,
    "descripcion":"TROMBOSIS VENOSA PROFUNDA DE VENA PERONEA"
  },
  {
    "codigo":10876711000119109,
    "descripcion":"HERIDA ABIERTA DE REGIÓN DE CADERA IZQUIERDA"
  },
  {
    "codigo":285875007,
    "descripcion":"INCAPAZ DE USAR LA COCINA"
  },
  {
    "codigo":17226007,
    "descripcion":"TRASTORNO DE ADAPTACIÓN"
  },
  {
    "codigo":1196874007,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE VÍA BILIAR"
  },
  {
    "codigo":770890009,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR PROTEÍNA DE LA COAGULACIÓN"
  },
  {
    "codigo":310303002,
    "descripcion":"MANIFESTACIÓN DE LA VOLUNTAD DISCUTIDA CON UN FAMILIAR"
  },
  {
    "codigo":769055006,
    "descripcion":"EFECTO TARDÍO DE LESIÓN INTERNA A LOS ÓRGANOS INTRAABDOMINALES Y PÉLVICOS"
  },
  {
    "codigo":36801000119105,
    "descripcion":"CONTINUACIÓN DE EMBARAZO TRIPLE DESPUÉS DE ABORTO ESPONTÁNEO DE UN FETO O MÁS"
  },
  {
    "codigo":275700003,
    "descripcion":"VÁRICES DE LA PIERNA CON ECCEMA"
  },
  {
    "codigo":404937000,
    "descripcion":"BASE DE SUSTENTACIÓN ESTRECHA"
  },
  {
    "codigo":110025001,
    "descripcion":"FRACTURA EXPUESTA DE CRESTA ALVEOLAR DE MAXILAR SUPERIOR"
  },
  {
    "codigo":206494003,
    "descripcion":"TRASTORNOS DEL EQUILIBRIO DEL POTASIO EN EL RECIÉN NACIDO"
  },
  {
    "codigo":698014005,
    "descripcion":"DISTENSIÓN DE MÚSCULO DEL MENTÓN"
  },
  {
    "codigo":272030005,
    "descripcion":"SÍNTOMA DE SÍNCOPE"
  },
  {
    "codigo":1156766007,
    "descripcion":"OLIGOARTRITIS IDIOPÁTICA JUVENIL POSITIVA PARA ANTICUERPOS ANTINUCLEARES DE INICIO PERSISTENTE"
  },
  {
    "codigo":403102009,
    "descripcion":"ONICOMICOSIS CAUSADA POR ONYCHOCOLA CANADENSIS"
  },
  {
    "codigo":204659003,
    "descripcion":"ATRESIA ESOFÁGICA CON FÍSTULA TRAQUEOESOFÁGICA"
  },
  {
    "codigo":202824000,
    "descripcion":"INESTABILIDAD DE LA COLUMNA VERTEBRAL LUMBAR"
  },
  {
    "codigo":301128001,
    "descripcion":"HALLAZGO RELACIONADO CON EL SEGUNDO RUIDO CARDÍACO"
  },
  {
    "codigo":399432003,
    "descripcion":"ADENOMA DE INTESTINO GRUESO"
  },
  {
    "codigo":1251400004,
    "descripcion":"ALOPECIA DEBIDA A TRASTORNO DE GLÁNDULA TIROIDES"
  },
  {
    "codigo":233757000,
    "descripcion":"NEUMOCONIOSIS POR CIRCONIO"
  },
  {
    "codigo":397597001,
    "descripcion":"HALLAZGO RELACIONADO CON LA ATENCIÓN DURANTE EL PARTO"
  },
  {
    "codigo":364829003,
    "descripcion":"TEZ - HALLAZGO"
  },
  {
    "codigo":15958261000119101,
    "descripcion":"ADENOCARCINOMA METASTÁSICO DE RIÑÓN DERECHO"
  },
  {
    "codigo":4381006,
    "descripcion":"PARAFASIA VERBAL"
  },
  {
    "codigo":231922001,
    "descripcion":"EDEMA CORNEAL SEUDOFÁQUICO"
  },
  {
    "codigo":299293009,
    "descripcion":"AMPLITUD DE ROTACIÓN INTERNA PASIVA DE ARTICULACIÓN DE CADERA, DISMINUIDA"
  },
  {
    "codigo":788978004,
    "descripcion":"LIPODISTROFIA LOCALIZADA"
  },
  {
    "codigo":10823771000119109,
    "descripcion":"FRACTURA EXPUESTA DE FALANGE PROXIMAL DE DEDO ANULAR DE MANO IZQUIERDA"
  },
  {
    "codigo":461298006,
    "descripcion":"ANOMALÍA ADQUIRIDA DE VÁLVULA AURICULOVENTRICULAR IZQUIERDA (MORFOLÓGICAMENTE NO MITRAL)"
  },
  {
    "codigo":723442008,
    "descripcion":"SÍNDROME DE FALTA DE ERUPCIÓN DENTAL, HIPOPLASIA MAXILAR Y GENU VALGO"
  },
  {
    "codigo":199154009,
    "descripcion":"SÍFILIS MATERNA DURANTE EL EMBARAZO, PARTO Y PUERPERIO"
  },
  {
    "codigo":428530009,
    "descripcion":"SITOSTEROLEMIA HETEROCIGOTA"
  },
  {
    "codigo":262855004,
    "descripcion":"LACERACIÓN DE INTESTINO DELGADO"
  },
  {
    "codigo":721607006,
    "descripcion":"CARCINOMA INDIFERENCIADO PRIMARIO DE OROFARINGE"
  },
  {
    "codigo":424860001,
    "descripcion":"BAJOS INGRESOS"
  },
  {
    "codigo":293788003,
    "descripcion":"ALERGIA A ANTAGONISTA DE RECEPTOR ESTROGÉNICO"
  },
  {
    "codigo":64412006,
    "descripcion":"HECES ROJAS"
  },
  {
    "codigo":785308008,
    "descripcion":"HEMOFILIA ADQUIRIDA"
  },
  {
    "codigo":128113003,
    "descripcion":"ENFERMEDAD DE VON WILLEBRAND HEREDITARIA TIPO 1B"
  },
  {
    "codigo":717937006,
    "descripcion":"DIÁTESIS HEMORRÁGICA DIFUSA DE COMIENZO TARDÍO SECUNDARIA A ENFERMEDAD HEMORRÁGICA DEL FETO Y EL RECIÉN NACIDO POR DEFICIENCIA DE VITAMINA K"
  },
  {
    "codigo":95345008,
    "descripcion":"ÚLCERA DEL PIE"
  },
  {
    "codigo":60742000,
    "descripcion":"CONFLICTO DE EVITACIÓN - EVITACIÓN"
  },
  {
    "codigo":290118000,
    "descripcion":"PEZÓN NORMAL"
  },
  {
    "codigo":716102003,
    "descripcion":"DISTENSIÓN DE MÚSCULO DE MANO"
  },
  {
    "codigo":12108021000119109,
    "descripcion":"QUEMADURA QUÍMICA DE TRACTO GASTROINTESTINAL"
  },
  {
    "codigo":160881008,
    "descripcion":"INFANCIA TRANSCURRIDA EN UNA INSTITUCIÓN"
  },
  {
    "codigo":1142086006,
    "descripcion":"TAQUICARDIA ECTÓPICA DE LA UNIÓN AURICULOVENTRICULAR CONGÉNITA"
  },
  {
    "codigo":124443002,
    "descripcion":"DEFICIENCIA DE NUCLEOTIDASA"
  },
  {
    "codigo":16669071000119104,
    "descripcion":"FRACTURA NO EXPUESTA DE ÓRBITA IZQUIERDA"
  },
  {
    "codigo":189979005,
    "descripcion":"LEUCODISTROFIA DE CÉLULAS GLOBOIDEAS DE INICIO TEMPRANO"
  },
  {
    "codigo":286448004,
    "descripcion":"INCAPAZ DE MANEJAR RECIPIENTES DE ALIMENTO"
  },
  {
    "codigo":253680006,
    "descripcion":"HIPOPLASIA POSDUCTAL DE AORTA"
  },
  {
    "codigo":284613003,
    "descripcion":"MUESTRAS DE AGRESIÓN"
  },
  {
    "codigo":448453004,
    "descripcion":"ARTRITIS INFECCIOSA DE ARTICULACIÓN INTERFALÁNGICA DISTAL DE DEDO DE MANO"
  },
  {
    "codigo":315546002,
    "descripcion":"NACIDO EN TÚNEZ"
  },
  {
    "codigo":250010004,
    "descripcion":"HALLAZGO EN LA MARCHA CON ACCESORIO ORTOPÉDICO"
  },
  {
    "codigo":118938008,
    "descripcion":"TRASTORNO DE LA BOCA"
  },
  {
    "codigo":282778009,
    "descripcion":"LESIÓN TRAUMÁTICA DE UÑA DE DEDO GORDO DE PIE"
  },
  {
    "codigo":1263983002,
    "descripcion":"HEMORRAGIA CEREBELAR NO TRAUMÁTICA NEONATAL PRECOZ"
  },
  {
    "codigo":1296751002,
    "descripcion":"HIPERTENSIÓN OCULAR PRIMARIA DE OJO DERECHO"
  },
  {
    "codigo":870767005,
    "descripcion":"ESGUINCE DE LIGAMENTO RADIOCARPIANO PALMAR"
  },
  {
    "codigo":280943007,
    "descripcion":"CONFUSIÓN DISOCIATIVA"
  },
  {
    "codigo":1231215008,
    "descripcion":"APRAXIA OCULOMOTORA ADQUIRIDA DE TIPO FRONTOPARIETAL"
  },
  {
    "codigo":82500001,
    "descripcion":"ENFERMEDAD DE WOLMAN"
  },
  {
    "codigo":705092006,
    "descripcion":"FRACTURA NO EXPUESTA DE PLACA EPIFISARIA DE TIBIA PROXIMAL"
  },
  {
    "codigo":16964007,
    "descripcion":"TALASEMIA POR PERSISTENCIA HEREDITARIA DE HEMOGLOBINA FETAL"
  },
  {
    "codigo":770628008,
    "descripcion":"MELANOCITOSIS LEPTOMENÍNGEA DIFUSA"
  },
  {
    "codigo":768793002,
    "descripcion":"CATARATA DE OJO IZQUIERDO DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":441113002,
    "descripcion":"CAPAZ DE ESCRIBIR ORACIONES SIMPLES"
  },
  {
    "codigo":408345009,
    "descripcion":"NECESIDAD FARMACOLÓGICA NO SATISFECHA - IDENTIFICADA"
  },
  {
    "codigo":209902003,
    "descripcion":"LACERACIÓN DEL ROMBENCÉFALO CON HERIDA INTRACRANEAL ABIERTA, SIN PÉRDIDA DE LA CONSCIENCIA"
  },
  {
    "codigo":1356782005,
    "descripcion":"INMUNODEFICIENCIA VARIABLE COMÚN AUTOSÓMICA RECESIVA DEBIDA A DEFICIENCIA DE RAC2"
  },
  {
    "codigo":240835000,
    "descripcion":"FILARIASIS SUBCUTÁNEA"
  },
  {
    "codigo":208067003,
    "descripcion":"FRACTURA VERTEBRAL EXPUESTA CON LESIÓN DE LA COLA DE CABALLO"
  },
  {
    "codigo":109763004,
    "descripcion":"HIPERPLASIA ADENOMATOIDE DE LA GLÁNDULA SALIVAL MENOR"
  },
  {
    "codigo":44227003,
    "descripcion":"MARCHA DE PASO DOBLE INTERMITENTE"
  },
  {
    "codigo":404675003,
    "descripcion":"APLANAMIENTO DE LA CÁMARA ANTERIOR DEL OJO"
  },
  {
    "codigo":402840000,
    "descripcion":"ANGIOQUERATOMA PAPULAR SOLITARIO"
  },
  {
    "codigo":271768001,
    "descripcion":"UÑAS CON ESTRÍAS"
  },
  {
    "codigo":1287576005,
    "descripcion":"CARIES DENTAL PRIMARIA QUE SE EXTIENDE HASTA LA MITAD EXTERNA DEL ESMALTE"
  },
  {
    "codigo":239000007,
    "descripcion":"SEUDOPORFIRIA MEDICAMENTOSA"
  },
  {
    "codigo":1351277001,
    "descripcion":"SÍNDROME DE CUSHING DEBIDO A ADENOMA ADRENOCORTICAL PRODUCTOR DE CORTISOL"
  },
  {
    "codigo":10963651000119108,
    "descripcion":"LACERACIÓN DE DEDO MEDIO DE LA MANO DERECHA"
  },
  {
    "codigo":204397009,
    "descripcion":"CORAZÓN TRILOCULAR"
  },
  {
    "codigo":366402004,
    "descripcion":"AMPLITUD DE RETRACCIÓN ACTIVA DE LA COLUMNA CERVICAL - HALLAZGO"
  },
  {
    "codigo":300866008,
    "descripcion":"IMPULSO TUSÍGENO DE LA MASA, AUSENTE"
  },
  {
    "codigo":169794008,
    "descripcion":"PRUEBA DOBLE DESEADA"
  },
  {
    "codigo":725015002,
    "descripcion":"LESIÓN TRAUMÁTICA DE TENDÓN DEL CUELLO"
  },
  {
    "codigo":167959000,
    "descripcion":"DENSIDAD DE LÍQUIDO PLEURAL POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":399170009,
    "descripcion":"HEMOCROMATOSIS PRIMARIA"
  },
  {
    "codigo":200727009,
    "descripcion":"INFECCIÓN DEL CUERO CABELLUDO"
  },
  {
    "codigo":266263009,
    "descripcion":"EMBOLIA Y TROMBOSIS DE LA AORTA ABDOMINAL"
  },
  {
    "codigo":2284002,
    "descripcion":"EXOFTALMÍA PULSÁTIL"
  },
  {
    "codigo":297196004,
    "descripcion":"ANEURISMA DE ARTERIA SUPRARRENAL"
  },
  {
    "codigo":428268007,
    "descripcion":"HEMATOMA EPIDURAL"
  },
  {
    "codigo":33217001,
    "descripcion":"CAROTENODERMIA"
  },
  {
    "codigo":721345004,
    "descripcion":"FRACTURA DE APÓFISIS ODONTOIDES DEL AXIS TIPO II"
  },
  {
    "codigo":41821000119108,
    "descripcion":"DISTENSIÓN DE MÚSCULO INTERCOSTAL"
  },
  {
    "codigo":10664951000119102,
    "descripcion":"ÚLCERA ISQUÉMICA ATEROSCLERÓTICA DE TOBILLO DERECHO"
  },
  {
    "codigo":295361008,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE NIZATIDINA"
  },
  {
    "codigo":1145494001,
    "descripcion":"HIPOPLASIA CONGÉNITA DE MEÑIQUE"
  },
  {
    "codigo":343031000119102,
    "descripcion":"OJO DERECHO CIEGO, BAJA VISIÓN EN OJO IZQUIERDO"
  },
  {
    "codigo":719510006,
    "descripcion":"ENFERMEDAD DE CHARCOT-MARIE-TOOTH TIPO 2F AUTOSÓMICA DOMINANTE"
  },
  {
    "codigo":64150007,
    "descripcion":"ENDOCERVICITIS CON EROSIÓN"
  },
  {
    "codigo":31382008,
    "descripcion":"SÍNDROME DEL AGUJERO YUGULAR"
  },
  {
    "codigo":129686009,
    "descripcion":"HALLAZGO RELACIONADO CON LA COMUNICACIÓN CON RECURSOS COMUNITARIOS"
  },
  {
    "codigo":162454009,
    "descripcion":"PRESENTA EL SÍNTOMA CADA POCAS HORAS"
  },
  {
    "codigo":226155002,
    "descripcion":"DIETA MODIFICADA EN CONTENIDO DE MINERALES"
  },
  {
    "codigo":95083000,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA PIEL DEL TRONCO"
  },
  {
    "codigo":160619003,
    "descripcion":"ARMA SUS PROPIOS CIGARRILLOS"
  },
  {
    "codigo":193387007,
    "descripcion":"EDEMA MACULAR CISTOIDEO"
  },
  {
    "codigo":62315008,
    "descripcion":"DIARREA"
  },
  {
    "codigo":27712000,
    "descripcion":"HIPERVITAMINOSIS D"
  },
  {
    "codigo":783211008,
    "descripcion":"LINFOCITOSIS MONOCLONAL DE LINFOCITOS B NO-LEUCEMIA LINFOCÍTICA CRÓNICA"
  },
  {
    "codigo":1141824005,
    "descripcion":"DEFECACIÓN NORMAL"
  },
  {
    "codigo":93248006,
    "descripcion":"HIPOPLASIA CONGÉNITA DE CARPO"
  },
  {
    "codigo":715840006,
    "descripcion":"PÉNFIGO VULGAR DE MEMBRANA MUCOSA GINGIVAL"
  },
  {
    "codigo":29120001000004103,
    "descripcion":"FRACTURA DE PEDÍCULO DE QUINTA VÉRTEBRA CERVICAL"
  },
  {
    "codigo":289856009,
    "descripcion":"ARAÑAZO DE PERINEO FEMENINO"
  },
  {
    "codigo":7360001000004106,
    "descripcion":"FRACTURA FACIAL DEBIDA A ACCIDENTE AUTOMOVILÍSTICO"
  },
  {
    "codigo":124181001,
    "descripcion":"DEFICIENCIA DE SARCOSINA OXIDASA"
  },
  {
    "codigo":11785361000119101,
    "descripcion":"AMPOLLA TRAUMÁTICA DE MANO IZQUIERDA"
  },
  {
    "codigo":16000001000004109,
    "descripcion":"FRACTURA DE PULGAR DEBIDA A HERIDA POR ARMA DE FUEGO"
  },
  {
    "codigo":8960001000004106,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN DE REGIÓN DE TUBEROSIDAD ISQUIÁTICA DE GLÚTEO DERECHO"
  },
  {
    "codigo":224320009,
    "descripcion":"EDUCADO EN ESCUELA PARA NECESIDADES ESPECIALES"
  },
  {
    "codigo":316561000119102,
    "descripcion":"OSTEOFITO DE CODO IZQUIERDO"
  },
  {
    "codigo":24042004,
    "descripcion":"HIPERTENSIÓN CRÓNICA QUE COMPLICA EL PUERPERIO Y\/O CONSTITUYE UN MOTIVO DE ATENCIÓN DURANTE ESTE PERÍODO"
  },
  {
    "codigo":286186004,
    "descripcion":"INCAPAZ DE ORDENAR LA CASA"
  },
  {
    "codigo":1269226006,
    "descripcion":"SÍNDROME DE DISPLASIA ESPONDILOMETAFISARIA Y DISTROFIA CORNEAL"
  },
  {
    "codigo":253418004,
    "descripcion":"DEFECTO DEL TABIQUE AURICULOVENTRICULAR - COMPONENTE VENTRICULAR DEBAJO DE VALVA SUPERIOR EN PUENTE"
  },
  {
    "codigo":22207007,
    "descripcion":"ENTERITIS PROLIFERATIVA CRÓNICA"
  },
  {
    "codigo":282516002,
    "descripcion":"DIFICULTAD PARA SUBIR ESCALONES CORRIENDO"
  },
  {
    "codigo":1003412004,
    "descripcion":"DUPLICACIÓN DE PORCIÓN MEDIA DE BRAZO LARGO DE CROMOSOMA 2"
  },
  {
    "codigo":15717521000119106,
    "descripcion":"OSTEOCONDRITIS DISECANTE DE AMBAS RODILLAS"
  },
  {
    "codigo":126251000119100,
    "descripcion":"ÁCIDO DESOXIRRIBONUCLEICO DE VIRUS PAPILOMA HUMANO DETECTADO, ALTO RIESGO EN MUESTRA VAGINAL"
  },
  {
    "codigo":413588007,
    "descripcion":"CON MAYOR RIESGO DE DUELO DISFUNCIONAL"
  },
  {
    "codigo":20372007,
    "descripcion":"TUBERCULOSIS DE LA PRÓSTATA"
  },
  {
    "codigo":315284009,
    "descripcion":"MASA DE GLÁNDULA PARÓTIDA"
  },
  {
    "codigo":1362025001,
    "descripcion":"PARTICIPA DE ACTIVIDADES DEPORTIVAS ACUÁTICAS"
  },
  {
    "codigo":1263721006,
    "descripcion":"TRASTORNO FETAL DEBIDO A AMNIONITIS"
  },
  {
    "codigo":247913006,
    "descripcion":"MOVIMIENTO SIN PROPÓSITO"
  },
  {
    "codigo":10966161000119108,
    "descripcion":"HERIDA POR ARMA BLANCA DE MUSLO DERECHO"
  },
  {
    "codigo":16702001,
    "descripcion":"CERTIFICADO DE INGRESO HOSPITALARIO DENEGADO"
  },
  {
    "codigo":442686002,
    "descripcion":"HALLAZGO RELACIONADO CON MEDICIÓN POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":461619006,
    "descripcion":"OBSTRUCCIÓN ADQUIRIDA DE LUZ DE CAYADO AÓRTICO ENTRE ARTERIA SUBCLAVIA Y ARTERIA CARÓTIDA PRIMITIVA"
  },
  {
    "codigo":213310008,
    "descripcion":"TROMBOFLEBITIS POSTERIOR A INFUSIÓN"
  },
  {
    "codigo":309779001,
    "descripcion":"MEIBOMIANITIS"
  },
  {
    "codigo":277011002,
    "descripcion":"ENFERMEDAD PREEXISTENTE EN EL TRASPLANTE RENAL"
  },
  {
    "codigo":702995003,
    "descripcion":"STAPHYLOCOCCUS SAPROPHYTICUS O STAPHYLOCOCCUS HOMINIS"
  },
  {
    "codigo":735763004,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE PARED TORÁCICA POSTERIOR"
  },
  {
    "codigo":1260051005,
    "descripcion":"CICATRIZ DE MUCOSA DE PALADAR BLANDO"
  },
  {
    "codigo":61191000087101,
    "descripcion":"LOMENTOSPORIOSIS"
  },
  {
    "codigo":48391000087103,
    "descripcion":"FRACTURA DE ESCAFOIDES DE MANO DERECHA"
  },
  {
    "codigo":43271000087102,
    "descripcion":"HERIDA PUNZANTE DE DEDO DE PIE DERECHO CON CUERPO EXTRAÑO"
  },
  {
    "codigo":40711000087106,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE DEDO ANULAR DERECHO"
  },
  {
    "codigo":209640003,
    "descripcion":"DESGARRO COMPLETO DE LIGAMENTO METATARSOFALÁNGICO"
  },
  {
    "codigo":38151000087107,
    "descripcion":"ACINESIA DE SEGMENTO INFEROSEPTAL MEDIO DE VENTRÍCULO CARDÍACO IZQUIERDO"
  },
  {
    "codigo":111336005,
    "descripcion":"CURVATURA LATERAL CONGÉNITA DEL PENE"
  },
  {
    "codigo":109501002,
    "descripcion":"MALA OCLUSIÓN, CLASE II DE ANGLE"
  },
  {
    "codigo":371645004,
    "descripcion":"CUERPO PARCIALMENTE ESQUELETIZADO"
  },
  {
    "codigo":11197005,
    "descripcion":"HIDROMIELIA"
  },
  {
    "codigo":764861005,
    "descripcion":"DISCAPACIDAD INTELECTUAL TIPO BIRK-BAREL"
  },
  {
    "codigo":240573005,
    "descripcion":"ABSCESO GONOCÓCICO DE LA GLÁNDULA DE BARTOLINO"
  },
  {
    "codigo":1187175001,
    "descripcion":"AMINOFILINA EN SUERO DENTRO DEL RANGO TERAPÉUTICO"
  },
  {
    "codigo":73063007,
    "descripcion":"DOLOR TIPO CÓLICO"
  },
  {
    "codigo":366140006,
    "descripcion":"HALLAZGO RELACIONADO CON EL MÉTODO RESPIRATORIO"
  },
  {
    "codigo":235068006,
    "descripcion":"ENFERMEDAD MICÓTICA DE LA MUCOSA ORAL"
  },
  {
    "codigo":300604006,
    "descripcion":"NO UTILIZA LAS COMODIDADES LOCALES"
  },
  {
    "codigo":169532006,
    "descripcion":"SUSPENDIÓ EL USO DE ESPONJA ANTICONCEPTIVA"
  },
  {
    "codigo":890428007,
    "descripcion":"HIPOPLASIA CONGÉNITA PRIMARIA BILATERAL DE PULMÓN"
  },
  {
    "codigo":1111401000000105,
    "descripcion":"GLAUCOMA DE ÁNGULO ABIERTO DEBIDO A NEOVASCULARIZACIÓN"
  },
  {
    "codigo":397073000,
    "descripcion":"MACROCITOSIS, ERITROCITOS"
  },
  {
    "codigo":298769008,
    "descripcion":"TUMEFACCIÓN ÓSEA DE HOMBRO"
  },
  {
    "codigo":724753009,
    "descripcion":"ALUCINACIONES AISLADAS RECURRENTES RELACIONADAS CON EL SUEÑO"
  },
  {
    "codigo":788454002,
    "descripcion":"ESTENOSIS DE AMBAS ARTERIAS VERTEBRALES"
  },
  {
    "codigo":1148902004,
    "descripcion":"INCONTINENCIA DE ESFUERZO POSQUIRÚRGICA"
  },
  {
    "codigo":34790005,
    "descripcion":"ENFERMEDAD TUBOTIMPÁNICA CRÓNICA CON PERFORACIÓN ANTERIOR DEL TÍMPANO"
  },
  {
    "codigo":722918006,
    "descripcion":"PARÁLISIS ADQUIRIDA DE CUERDA VOCAL EN EL RECIÉN NACIDO"
  },
  {
    "codigo":296934007,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE WARFARINA"
  },
  {
    "codigo":721083007,
    "descripcion":"SÍNDROME DE LINFEDEMA E HIPOPARATIROIDISMO"
  },
  {
    "codigo":295099009,
    "descripcion":"ALERGIA A NAFTIDROFURILO"
  },
  {
    "codigo":319071000119106,
    "descripcion":"ARTRITIS REUMATOIDEA SERONEGATIVA DE ARTICULACIÓN DE REGIÓN DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":1208933000,
    "descripcion":"LEUCODISTROFIA 4H"
  },
  {
    "codigo":1340005000,
    "descripcion":"FRACTURA DE EPÍFISIS DISTAL DE FÉMUR"
  },
  {
    "codigo":291429000,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR AMFOTERICINA B"
  },
  {
    "codigo":225893004,
    "descripcion":"APTO PARA VOLVER A TRABAJAR CON RESTRICCIONES"
  },
  {
    "codigo":422501005,
    "descripcion":"CAPACIDAD PARA COMPRENDER ANORMAL"
  },
  {
    "codigo":782949007,
    "descripcion":"SÍNDROME DE DISMORFISMO FACIAL, ANOREXIA, CAQUEXIA Y ANOMALÍAS OCULARES Y CUTÁNEAS"
  },
  {
    "codigo":94821007,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL ENDOMETRIO"
  },
  {
    "codigo":92986002,
    "descripcion":"PUBIS ARQUEADO CONGÉNITO"
  },
  {
    "codigo":1010490004,
    "descripcion":"AGENESIA DE PLIEGUE CUTÁNEO INTERFALÁNGICO"
  },
  {
    "codigo":289594004,
    "descripcion":"DOLOR A LA PALPACIÓN EN VAGINA"
  },
  {
    "codigo":191290006,
    "descripcion":"TRASTORNO HEMORRÁGICO DEBIDO A ANTI - FACTOR VIIIA AUMENTADO"
  },
  {
    "codigo":123919003,
    "descripcion":"INTOXICACIÓN POR CONVOLVULACEAE"
  },
  {
    "codigo":353295004,
    "descripcion":"ENFERMEDAD DE GRAVES"
  },
  {
    "codigo":15693561000119104,
    "descripcion":"QUERATITIS DE OJO DERECHO CAUSADA POR BACTERIA"
  },
  {
    "codigo":285924005,
    "descripcion":"INCAPAZ DE LLENAR EL LAVABO"
  },
  {
    "codigo":16076691000119100,
    "descripcion":"DEPENDENCIA EPISÓDICA DE MÚLTIPLES SUSTANCIAS"
  },
  {
    "codigo":1268964007,
    "descripcion":"OLIGODENDROGLIOMA ANAPLÁSICO PRIMARIO DE SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":253156008,
    "descripcion":"DISPLASIA CORTICAL CON HEMIMEGALENCEFALIA"
  },
  {
    "codigo":449764009,
    "descripcion":"GINGIVITIS GRANULOMATOSA POR CUERPO EXTRAÑO"
  },
  {
    "codigo":185785000,
    "descripcion":"CONTROL DE ESTRÉS BORRADO"
  },
  {
    "codigo":447929001,
    "descripcion":"DOBLE CAYADO AÓRTICO CON ARCO IZQUIERDO DOMINANTE"
  },
  {
    "codigo":773774000,
    "descripcion":"CARCINOMA NEUROENDOCRINO DE ALTO GRADO DEL CUERPO DEL ÚTERO"
  },
  {
    "codigo":216718005,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR INSECTICIDA DE COMPUESTO DE QUEROSÉN"
  },
  {
    "codigo":249486008,
    "descripcion":"INCAPAZ DE DEGLUTIR"
  },
  {
    "codigo":444259006,
    "descripcion":"COMPRESIÓN DE INTESTINO EN LIGAMENTO GASTROESPLÉNICO"
  },
  {
    "codigo":247651008,
    "descripcion":"PENSAMIENTOS OBSCENOS"
  },
  {
    "codigo":16440002,
    "descripcion":"VALVULOPATÍA MITRAL Y AÓRTICA REUMÁTICA"
  },
  {
    "codigo":737336003,
    "descripcion":"PATRÓN DE USO NOCIVO DE CANABINOIDE SINTÉTICO"
  },
  {
    "codigo":441951000124102,
    "descripcion":"DESNUTRICIÓN RELACIONADA CON INANICIÓN"
  },
  {
    "codigo":278584006,
    "descripcion":"PUENTE DENTAL DEMASIADO ANCHO"
  },
  {
    "codigo":409656006,
    "descripcion":"ESOFAGITIS AGUDA"
  },
  {
    "codigo":1259789001,
    "descripcion":"HISTIOCITOMA FIBROSO MALIGNO PLEOMÓRFICO CUTÁNEO PRIMARIO"
  },
  {
    "codigo":735501002,
    "descripcion":"QUEMADURA EPIDÉRMICA DE PERINEO"
  },
  {
    "codigo":1085331000119107,
    "descripcion":"FISURA DE PALADAR Y FISURA DE LABIO BILATERAL"
  },
  {
    "codigo":80141007,
    "descripcion":"HEMOGLOBINOPATÍA"
  },
  {
    "codigo":405986005,
    "descripcion":"DIFERENCIACIÓN HISTOLÓGICA DE GRADO INTERMEDIO"
  },
  {
    "codigo":12770006,
    "descripcion":"CARDIOPATÍA CONGÉNITA CIANÓTICA"
  },
  {
    "codigo":78306007,
    "descripcion":"PARÁLISIS ESPINAL EPIDURAL ASCENDENTE"
  },
  {
    "codigo":209378007,
    "descripcion":"FRACTURA-SUBLUXACIÓN NO EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA DE MÚLTIPLES DEDOS DEL PIE"
  },
  {
    "codigo":699063001,
    "descripcion":"LESIÓN TRAUMÁTICA DE CADERA Y MUSLO"
  },
  {
    "codigo":1354423001,
    "descripcion":"OCLUSIÓN DE VENA NASAL SUPERIOR DE RETINA"
  },
  {
    "codigo":1290722006,
    "descripcion":"ARTRITIS INFECCIOSA DE ARTICULACIÓN GLENOHUMERAL DERECHA"
  },
  {
    "codigo":404151004,
    "descripcion":"INFILTRACIÓN LEUCÉMICA DE PIEL EN LEUCEMIA MIELOIDE"
  },
  {
    "codigo":305847006,
    "descripcion":"ATENDIDO POR EL SERVICIO EXTRAHOSPITALARIO DE PODOLOGÍA"
  },
  {
    "codigo":830135007,
    "descripcion":"RETINA DE OJO DERECHO PARCIALMENTE EVALUABLE"
  },
  {
    "codigo":238476000,
    "descripcion":"GRANULOMA EOSINOFÍLICO DE HUESO"
  },
  {
    "codigo":402316001,
    "descripcion":"PSORIASIS DE PIEL PERIANAL"
  },
  {
    "codigo":205708001,
    "descripcion":"MOSAICO XO\/XX"
  },
  {
    "codigo":369548005,
    "descripcion":"NEOPLASIA MALIGNA QUE COMPROMETE TROMPA DE FALOPIO DERECHA POR PROPAGACIÓN DIRECTA DESDE TROMPA DE FALOPIO IZQUIERDA"
  },
  {
    "codigo":236641002,
    "descripcion":"AUSENCIA DE SENSACIÓN EN VEJIGA URINARIA"
  },
  {
    "codigo":7265005,
    "descripcion":"GLUCOGENOSIS TIPO I"
  },
  {
    "codigo":302177007,
    "descripcion":"SUBSIDIO SOLICITADO"
  },
  {
    "codigo":171105009,
    "descripcion":"CONVOCATORIA PARA CRIBADO - NO RESPONDIDA"
  },
  {
    "codigo":365878003,
    "descripcion":"EXAMEN MICROSCÓPICO DE ORINA: LINFOCITOS PRESENTES"
  },
  {
    "codigo":1119542004,
    "descripcion":"CONSTRICCIÓN MODERADA DE CAMPO VISUAL PERIFÉRICO"
  },
  {
    "codigo":5430006,
    "descripcion":"ANEMIA MEGALOBLÁSTICA POR NUTRICIÓN PARENTERAL TOTAL"
  },
  {
    "codigo":267574006,
    "descripcion":"ENFERMEDADES DEL SISTEMA NERVIOSO Y ÓRGANOS DE LOS SENTIDOS"
  },
  {
    "codigo":36363000,
    "descripcion":"MUCOCELE DE BRONQUIO"
  },
  {
    "codigo":726326009,
    "descripcion":"DISTENSIÓN DE FASCIA DE MÚSCULO INTRÍNSECO DEL PIE"
  },
  {
    "codigo":300342009,
    "descripcion":"NO SE VISUALIZA VESÍCULA BILIAR"
  },
  {
    "codigo":396811003,
    "descripcion":"MARGEN QUIRÚRGICO DEL COLÉDOCO COMPROMETIDO POR NEOPLASIA MALIGNA"
  },
  {
    "codigo":724491005,
    "descripcion":"FÍSTULA VESICOVAGINAL CON COMPROMISO DEL MECANISMO DE CONTINENCIA URINARIA POSTERIOR A PARTO NORMAL"
  },
  {
    "codigo":296672000,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE CEFADROXILO"
  },
  {
    "codigo":69131009,
    "descripcion":"ATAXIA ESPINAL"
  },
  {
    "codigo":427744002,
    "descripcion":"HEMANGIOENDOTELIOMA DEL HÍGADO"
  },
  {
    "codigo":16023751000119106,
    "descripcion":"OCLUSIÓN DE ARTERIA COROIDEA ANTERIOR IZQUIERDA"
  },
  {
    "codigo":22881000119100,
    "descripcion":"CUADRIPLEJÍA CON CUADRIPARESIA"
  },
  {
    "codigo":360373000,
    "descripcion":"HOMOCISTINURIA TIPO III SENSIBLE A VITAMINA B12"
  },
  {
    "codigo":720821001,
    "descripcion":"SIGNO DE ABSTINENCIA"
  },
  {
    "codigo":788192009,
    "descripcion":"FRACTURAS DE MÚLTIPLES HUESOS"
  },
  {
    "codigo":34528009,
    "descripcion":"HIPERTRIGLICERIDEMIA FAMILIAR"
  },
  {
    "codigo":295111000119108,
    "descripcion":"SÍNDROME NEFRÓTICO CONCOMITANTE CON LUPUS ERITEMATOSO SISTÉMICO Y DEBIDO A ÉL"
  },
  {
    "codigo":1144970000,
    "descripcion":"TRASTORNO ARTICULAR DEBIDO A LUPUS ERITEMATOSO SISTÉMICO"
  },
  {
    "codigo":130997009,
    "descripcion":"HORMONA PROTEICA ANORMAL"
  },
  {
    "codigo":30858001,
    "descripcion":"LACERACIÓN CEREBELOSA CON HERIDA INTRACRANEAL ABIERTA"
  },
  {
    "codigo":15669601000119103,
    "descripcion":"BRAQUIDACTILIA DE DEDO DE MANO DERECHA"
  },
  {
    "codigo":129162006,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN LUMBOSACRA"
  },
  {
    "codigo":293002009,
    "descripcion":"REACCIÓN ADVERSA A CEFALOSPORINA DE SEGUNDA GENERACIÓN"
  },
  {
    "codigo":225631001,
    "descripcion":"MIEDO A NO CUMPLIR CON EL TRATAMIENTO"
  },
  {
    "codigo":16898401000119104,
    "descripcion":"FRACTURA NO EXPUESTA EN MARTILLO DE FALANGE DISTAL DE DEDO MEDIO DE MANO DERECHA"
  },
  {
    "codigo":1010228000,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE PIE IZQUIERDO"
  },
  {
    "codigo":94559008,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE PIEL DE INGLE"
  },
  {
    "codigo":289332002,
    "descripcion":"BASE DEL MUÑÓN UMBILICAL INFLAMADA"
  },
  {
    "codigo":291167009,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR LEVOMEPROMAZINA"
  },
  {
    "codigo":715316005,
    "descripcion":"ARTROGRIPOSIS MÚLTIPLE CONGÉNITA NEUROGÉNICA"
  },
  {
    "codigo":92724009,
    "descripcion":"CARCINOMA IN SITU DE LA PIEL DE LA CARA"
  },
  {
    "codigo":123657001,
    "descripcion":"ESTENOSIS CONGÉNITA DE UNA VÁLVULA CARDÍACA"
  },
  {
    "codigo":1336073004,
    "descripcion":"CEFALEA CRÓNICA DEBIDA A CRANEOTOMÍA Y POSTERIOR A ELLA"
  },
  {
    "codigo":254729005,
    "descripcion":"APUDOMA CUTÁNEO"
  },
  {
    "codigo":1268702001,
    "descripcion":"CARCINOMA PRIMARIO DE PLEXO COROIDEO"
  },
  {
    "codigo":283827000,
    "descripcion":"MORDEDURA DE ANIMAL EN LA PIERNA"
  },
  {
    "codigo":711646009,
    "descripcion":"EPITELIOPATÍA CORNEAL CAUSADA POR VIRUS HERPES SIMPLE"
  },
  {
    "codigo":447667000,
    "descripcion":"AURÍCULA IZQUIERDA DIVIDIDA CON DESEMBOCADURA DE TODAS LAS VENAS PULMONARES EN LA CÁMARA PROXIMAL SIN COMUNICACIÓN CON LA AURÍCULA IZQUIERDA"
  },
  {
    "codigo":15718561000119100,
    "descripcion":"ENTESOPATÍA DE DEDO DE MANO IZQUIERDA"
  },
  {
    "codigo":66721000119101,
    "descripcion":"PORTADOR DE ENFERMEDAD DE VON WILLEBRAND"
  },
  {
    "codigo":189486241000119100,
    "descripcion":"INFECCIÓN ASINTOMÁTICA POR SARS-COV-2"
  },
  {
    "codigo":143521000119103,
    "descripcion":"HEMORRAGIA CEREBRAL INTRAPARENQUIMATOSA NO TRAUMÁTICA"
  },
  {
    "codigo":413954721000119104,
    "descripcion":"LACERACIÓN DE VASO SANGUÍNEO DE MEÑIQUE"
  },
  {
    "codigo":1085601000119105,
    "descripcion":"EDENTULISMO COMPLETO DE CLASE II DEBIDO A TRAUMATISMO"
  },
  {
    "codigo":11799201000119105,
    "descripcion":"LACERACIÓN DE ARTERIA MESENTÉRICA SUPERIOR"
  },
  {
    "codigo":12208801000119106,
    "descripcion":"OSTEÓLISIS DE HUESO ADYACENTE A PRÓTESIS DE ARTICULACIÓN DE CADERA DERECHA"
  },
  {
    "codigo":335521000119106,
    "descripcion":"DACRIOADENITIS DE OJO DERECHO"
  },
  {
    "codigo":1077921000119108,
    "descripcion":"ENFERMEDAD DE PAGET DE PIE IZQUIERDO"
  },
  {
    "codigo":86553761000119103,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DEBIDO A OCLUSIÓN DE AMBAS ARTERIAS CEREBRALES POSTERIORES"
  },
  {
    "codigo":15708321000119104,
    "descripcion":"TROMBOSIS VENOSA PROFUNDA AGUDA DE AMBAS EXTREMIDADES SUPERIORES POSTERIOR A PROCEDIMIENTO"
  },
  {
    "codigo":151201000119107,
    "descripcion":"ALERGIA A VENENO DE INSECTO"
  },
  {
    "codigo":314760005,
    "descripcion":"FALLA DE INJERTO CORNEAL"
  },
  {
    "codigo":759869601000119107,
    "descripcion":"ENDOMETRIOSIS SUPERFICIAL DE INTESTINO DELGADO"
  },
  {
    "codigo":15716001000119107,
    "descripcion":"ENOSTOSIS DE ASTRÁGALO IZQUIERDO"
  },
  {
    "codigo":11996321000119107,
    "descripcion":"NECROSIS DE MUÑÓN DE AMPUTACIÓN DE MIEMBRO INFERIOR DERECHO"
  },
  {
    "codigo":15685281000119108,
    "descripcion":"QUERATITIS INTERSTICIAL DE OJO DERECHO CAUSADA POR VIRUS HERPES ZÓSTER"
  },
  {
    "codigo":247389006,
    "descripcion":"NEURALGIA DE NERVIO INTERCOSTAL"
  },
  {
    "codigo":83549001,
    "descripcion":"OBSERVACIÓN DEL ACTO SEXUAL DE LOS PADRES"
  },
  {
    "codigo":78331000119108,
    "descripcion":"EXCESO DE PREPUCIO DESPUÉS DE LA CIRCUNCISIÓN"
  },
  {
    "codigo":1197661009,
    "descripcion":"VÁRICES ESOFÁGICAS SANGRANTES POR ESQUISTOSOMIASIS"
  },
  {
    "codigo":312925009,
    "descripcion":"DISTROFIA MACULAR DE CAROLINA DEL NORTE"
  },
  {
    "codigo":704306003,
    "descripcion":"CON MAYOR RIESGO DE BRADICARDIA"
  },
  {
    "codigo":1163058004,
    "descripcion":"ENCEFALITIS POR VIRUS DE LA CORIOMENINGITIS LINFOCÍTICA"
  },
  {
    "codigo":210951001,
    "descripcion":"EFECTO TARDÍO DE LESIÓN DE VASO DE TÓRAX, ABDOMEN Y PELVIS"
  },
  {
    "codigo":14343001,
    "descripcion":"PIELITIS AGUDA CON NECROSIS MEDULAR RENAL"
  },
  {
    "codigo":79879001,
    "descripcion":"HALITOSIS"
  },
  {
    "codigo":309255002,
    "descripcion":"ARTICULACIÓN DE CHARCOT DEL PIE"
  },
  {
    "codigo":47111006,
    "descripcion":"PÉRDIDA DE LA AUDICIÓN CONDUCTIVA A NIVEL DEL OÍDO EXTERNO"
  },
  {
    "codigo":473095009,
    "descripcion":"INFLAMACIÓN ASOCIADA CON IMPLANTE MUSCULOESQUELÉTICO"
  },
  {
    "codigo":241884001,
    "descripcion":"EFECTO TÓXICO CAUSADO POR REMOVEDOR DE GRAFITTI"
  },
  {
    "codigo":372956004,
    "descripcion":"INFECCIÓN CAUSADA POR PENICILLIUM ISLANDICUM"
  },
  {
    "codigo":733404005,
    "descripcion":"FRACTURAS MÚLTIPLES DE OMÓPLATO"
  },
  {
    "codigo":897244004,
    "descripcion":"CURVATURA ANORMAL DE FALANGE MEDIA DE SEGUNDO DEDO DE PIE"
  },
  {
    "codigo":78044008,
    "descripcion":"MALFORMACIÓN ATLANTOOCCIPITAL"
  },
  {
    "codigo":438492008,
    "descripcion":"TRASTORNO TROMBOCITOPÉNICO HEREDITARIO"
  },
  {
    "codigo":371121002,
    "descripcion":"ACCIDENTE CEREBROVASCULAR NEONATAL"
  },
  {
    "codigo":403889000,
    "descripcion":"CARCINOMA VERRUGOSO DE CAVIDAD BUCAL"
  },
  {
    "codigo":305585002,
    "descripcion":"BAJO ATENCIÓN DE ENFERMERA DE ESTUDIO EXPERIMENTAL"
  },
  {
    "codigo":240049008,
    "descripcion":"DISTROFIA MUSCULAR INTERMEDIA LIGADA AL CROMOSOMA X"
  },
  {
    "codigo":926342004,
    "descripcion":"ESTATURA BAJA CONGÉNITA DESPROPORCIONADA LETAL CON EXTREMIDADES CORTAS"
  },
  {
    "codigo":8838005,
    "descripcion":"LINFANGITIS AGUDA"
  },
  {
    "codigo":860806007,
    "descripcion":"EPILEPSIA DEBIDA A MENINGITIS INFECCIOSA"
  },
  {
    "codigo":1155718008,
    "descripcion":"DESGARRO DE FRENILLO DE LABIO SUPERIOR"
  },
  {
    "codigo":762502009,
    "descripcion":"TRASTORNO DEL DESARROLLO DEL LENGUAJE CONCOMITANTE CON ALTERACIÓN DEL LENGUAJE"
  },
  {
    "codigo":236379002,
    "descripcion":"PIELONEFRITIS OBSTRUCTIVA CRÓNICA"
  },
  {
    "codigo":5168000,
    "descripcion":"CHANCRO ESPOROTRICÓTICO"
  },
  {
    "codigo":37936001,
    "descripcion":"SÍNDROME DE GRADENIGO"
  },
  {
    "codigo":398384001,
    "descripcion":"INTOXICACIÓN ALIMENTARIA POR STAPHYLOCOCCUS AUREUS"
  },
  {
    "codigo":1186651009,
    "descripcion":"DERMATITIS IRRITATIVA POR CONTACTO DEBIDA A FÍSTULA MUCOSA"
  },
  {
    "codigo":234544003,
    "descripcion":"DEFICIENCIA DE SUBCLASE DE INMUNOGLOBULINA"
  },
  {
    "codigo":70704007,
    "descripcion":"ESGUINCE DE MUÑECA"
  },
  {
    "codigo":201776007,
    "descripcion":"ARTRITIS REUMATOIDE DE LA ARTICULACIÓN SACROILÍACA"
  },
  {
    "codigo":724229002,
    "descripcion":"APNEA DE LA LACTANCIA"
  },
  {
    "codigo":93875005,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE MIEMBRO INFERIOR"
  },
  {
    "codigo":298245005,
    "descripcion":"ARTICULACIÓN ESTABLE"
  },
  {
    "codigo":394714004,
    "descripcion":"PRUEBA DE LEUCOCITOS URINARIOS: +++"
  },
  {
    "codigo":427482006,
    "descripcion":"VEJIGA URINARIA NEUROGÉNICA FLÁCIDA"
  },
  {
    "codigo":296410007,
    "descripcion":"SOBREDOSIS INTENCIONAL DE NIQUETAMIDA"
  },
  {
    "codigo":198106009,
    "descripcion":"ABSCESO SUBAREOLAR CRÓNICO NO PUERPERAL"
  },
  {
    "codigo":1144708001,
    "descripcion":"HIPOPLASIA DE FALANGE DISTAL DE DEDO DE PIE"
  },
  {
    "codigo":294575009,
    "descripcion":"ALERGIA A SULFADIMIDINA"
  },
  {
    "codigo":292740005,
    "descripcion":"REACCIÓN ADVERSA A ANTÍDOTOS CONTRA PLAGUICIDAS"
  },
  {
    "codigo":423812005,
    "descripcion":"SARCOMA DE CABEZA Y\/O CUELLO"
  },
  {
    "codigo":30596009,
    "descripcion":"ACINESTESIA"
  },
  {
    "codigo":127065001,
    "descripcion":"ERITROCITOSIS FAMILIAR POR DEFICIENCIA DE DIFOSFOGLICERATO MUTASA"
  },
  {
    "codigo":290905007,
    "descripcion":"INTOXICACIÓN POR FLUOXETINA"
  },
  {
    "codigo":11768931000119102,
    "descripcion":"RUPTURA TRAUMÁTICA DE TENDÓN DE ANTEBRAZO DERECHO"
  },
  {
    "codigo":715054002,
    "descripcion":"INFESTACIÓN CAUSADA POR ORNITHODOROS"
  },
  {
    "codigo":289070005,
    "descripcion":"NO UTILIZA AYUDA PARA ALIMENTARSE"
  },
  {
    "codigo":92462008,
    "descripcion":"NEOPLASIA BENIGNA DEL TERCIO SUPERIOR DEL ESÓFAGO"
  },
  {
    "codigo":188931006,
    "descripcion":"NEOPLASIA BENIGNA DEL MANUBRIO ESTERNAL"
  },
  {
    "codigo":254467007,
    "descripcion":"NEOPLASIA DE OÍDO, NARIZ Y GARGANTA"
  },
  {
    "codigo":711384005,
    "descripcion":"DISMINUCIÓN DE EDEMA PERIFÉRICO"
  },
  {
    "codigo":447405001,
    "descripcion":"QUEMADURA POR FRICCIÓN DE MANO"
  },
  {
    "codigo":283565003,
    "descripcion":"HERIDA DE PERDIGÓN EN MUÑECA"
  },
  {
    "codigo":871554001,
    "descripcion":"REACCIÓN ANAFILACTOIDE INDUCIDA POR HEMODERIVADO"
  },
  {
    "codigo":609410002,
    "descripcion":"NECROSIS DE SITIO ANATÓMICO"
  },
  {
    "codigo":248962008,
    "descripcion":"CICLO MENSTRUAL PREMATURO"
  },
  {
    "codigo":314498009,
    "descripcion":"CONJUNTIVITIS PAPILAR GIGANTE RELACIONADA CON LENTES DE CONTACTO"
  },
  {
    "codigo":247127002,
    "descripcion":"DERIVACIÓN ARTERIOVENOSA RETINIANA"
  },
  {
    "codigo":83287008,
    "descripcion":"CAPACIDAD RESIDUAL FUNCIONAL AUMENTADA"
  },
  {
    "codigo":310828001,
    "descripcion":"TRASTORNO DEL DISCURSO"
  },
  {
    "codigo":443735008,
    "descripcion":"TRASTORNO DEL APRENDIZAJE NO VERBAL"
  },
  {
    "codigo":1162796001,
    "descripcion":"FOSFATASA ALCALINA PLACENTARIA DENTRO DE RANGO DE REFERENCIA"
  },
  {
    "codigo":278060005,
    "descripcion":"CARCINOMA ENDOMETRIOIDE DE PRÓSTATA"
  },
  {
    "codigo":1193729000,
    "descripcion":"ENTERITIS ACTINOMICÓTICA DE INTESTINO DELGADO"
  },
  {
    "codigo":866049001,
    "descripcion":"ENFERMEDAD DE BEHÇET MUCOCUTÁNEA"
  },
  {
    "codigo":235671000112105,
    "descripcion":"CÉLULAS ESCAMOSAS ATÍPICAS DE SIGNIFICADO INCIERTO EN EXTENDIDO DE PAPANICOLAOU CON DETECCIÓN DE ÁCIDO DESOXIRRIBONUCLEICO DE PAPILOMAVIRUS HUMANO"
  },
  {
    "codigo":46849003,
    "descripcion":"PSEUDODEMENCIA"
  },
  {
    "codigo":472833006,
    "descripcion":"TRASTORNO DE PRÓTESIS DE VÁLVULA PULMONAR"
  },
  {
    "codigo":16057751000119102,
    "descripcion":"PARÁLISIS FACIAL IZQUIERDA DE GRADO III DE HOUSE-BRACKMANN"
  },
  {
    "codigo":45014001,
    "descripcion":"FÍSTULA DE LA PRÓSTATA"
  },
  {
    "codigo":733142005,
    "descripcion":"SEPSIS POSTERIOR A TRABAJO DE PARTO OBSTRUIDO"
  },
  {
    "codigo":77782006,
    "descripcion":"NARIZ EN SILLA DE MONTAR SIFILÍTICA"
  },
  {
    "codigo":700374007,
    "descripcion":"ELECTROFORESIS DE HEMOGLOBINA NORMAL"
  },
  {
    "codigo":12246008,
    "descripcion":"ENFERMEDAD DE GAUCHER, NEURONOPÁTICA AGUDA"
  },
  {
    "codigo":239787000,
    "descripcion":"ARTRITIS REACTIVA POSTUBERCULOSA"
  },
  {
    "codigo":403627003,
    "descripcion":"PIGMENTACIÓN NO MELÁNICA CAUSADA POR FÁRMACO"
  },
  {
    "codigo":698539006,
    "descripcion":"REQUIERE DISPOSITIVO DE ORTODONCIA INFERIOR REMOVIBLE"
  },
  {
    "codigo":272555008,
    "descripcion":"SENTARSE A HORCAJADAS EN UN CABALLO"
  },
  {
    "codigo":303488000,
    "descripcion":"NO SE ATA LOS CORDONES"
  },
  {
    "codigo":237952001,
    "descripcion":"ACIDURIA 3-METILGLUTACÓNICA CON ACTIVIDAD NORMAL DE 3-METILGLUTACONIL-COA HIDRATASA"
  },
  {
    "codigo":205184006,
    "descripcion":"AMPUTACIÓN CONGÉNITA METACARPIANA DEL PRIMER RAYO"
  },
  {
    "codigo":236117001,
    "descripcion":"RETRACCIÓN DE ESTOMA"
  },
  {
    "codigo":399957001,
    "descripcion":"ENFERMEDAD ARTERIAL PERIFÉRICA OCLUSIVA"
  },
  {
    "codigo":203349002,
    "descripcion":"ENFERMEDAD DE PAGET DE METATARSIANO"
  },
  {
    "codigo":301653002,
    "descripcion":"NO SE SIENTA EN UNA SILLA"
  },
  {
    "codigo":365354001,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD DE REALIZAR ACTIVIDADES RELACIONADAS CON EL USO DE MEDIOS DE TRANSPORTE"
  },
  {
    "codigo":103210004,
    "descripcion":"PRODUCCIÓN DE MEGACARIOCITOS NORMAL"
  },
  {
    "codigo":299818006,
    "descripcion":"REFLEJO VESTIBULOCULAR AUSENTE"
  },
  {
    "codigo":55475008,
    "descripcion":"SÍNDROME DE LOWN - GANONG - LEVINE"
  },
  {
    "codigo":297983004,
    "descripcion":"HALLAZGO RELACIONADO CON EL ASPECTO DE LAS UÑAS"
  },
  {
    "codigo":232447007,
    "descripcion":"MEMBRANA LARÍNGEA ADQUIRIDA"
  },
  {
    "codigo":3071008,
    "descripcion":"MUJER VIUDA"
  },
  {
    "codigo":165076002,
    "descripcion":"PRUEBA DE FUNCIÓN CARDÍACA, ANORMAL"
  },
  {
    "codigo":230612003,
    "descripcion":"DAÑO TÓXICO NERVIOSO LOCAL"
  },
  {
    "codigo":34004002,
    "descripcion":"SIDEROSILICOSIS"
  },
  {
    "codigo":15703601000119106,
    "descripcion":"TRASTORNO DE TENDÓN DE AMBOS HOMBROS"
  },
  {
    "codigo":296148006,
    "descripcion":"SOBREDOSIS DE BUSPIRONA"
  },
  {
    "codigo":722132007,
    "descripcion":"SÍNDROME DE HIPOPLASIA PULMONAR, AGONADISMO, DEXTROCARDIA Y HERNIA DIAFRAGMÁTICA"
  },
  {
    "codigo":63102001,
    "descripcion":"ALTERACIÓN VISUAL"
  },
  {
    "codigo":95870002,
    "descripcion":"FRACASO DE VACUNACIÓN"
  },
  {
    "codigo":1144446007,
    "descripcion":"APLASIA DE PULGAR"
  },
  {
    "codigo":292478008,
    "descripcion":"REACCIÓN ADVERSA AL CARBACOL"
  },
  {
    "codigo":126803002,
    "descripcion":"NEOPLASIA DEL VESTÍBULO DE LA BOCA"
  },
  {
    "codigo":94035005,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA PIEL DE LA NARIZ"
  },
  {
    "codigo":290643007,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR MITOMICINA"
  },
  {
    "codigo":61267008,
    "descripcion":"NEOVASCULARIZACIÓN RETINIANA"
  },
  {
    "codigo":92200000,
    "descripcion":"NEOPLASIA BENIGNA DE GANGLIOS LINFÁTICOS DE MIEMBRO INFERIOR"
  },
  {
    "codigo":26664005,
    "descripcion":"ESCLEROMALACIA PERFORANTE"
  },
  {
    "codigo":24829000,
    "descripcion":"COLITIS ULCEROSA EOSINOFÍLICA"
  },
  {
    "codigo":288808009,
    "descripcion":"SALUDA"
  },
  {
    "codigo":90365003,
    "descripcion":"QUISTE DERMOIDE DE LA BOCA"
  },
  {
    "codigo":188669003,
    "descripcion":"MASTOCITOMA MALIGNO DE GANGLIOS LINFÁTICOS DE MÚLTIPLES LOCALIZACIONES"
  },
  {
    "codigo":876797009,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE BRAZO CON INFECCIÓN"
  },
  {
    "codigo":416210002,
    "descripcion":"CONTRANUTACIÓN"
  },
  {
    "codigo":285138004,
    "descripcion":"SE MUERDE SUS PROPIOS DEDOS DE LOS PIES"
  },
  {
    "codigo":250535003,
    "descripcion":"RODILLA EN TORMENTA DE NIEVE"
  },
  {
    "codigo":414375004,
    "descripcion":"LEUCOPLASIA VELLOSA LINGUAL"
  },
  {
    "codigo":709287005,
    "descripcion":"NEOPLASIA DE ESTROMA GASTROINTESTINAL DE DUODENO"
  },
  {
    "codigo":86695008,
    "descripcion":"FENÓMENO DE LA DEGENERACIÓN AXÓNICA CENTRÍPETA (\"DYING BACK\")"
  },
  {
    "codigo":283303009,
    "descripcion":"ASTILLA DE MADERA EN LOS GENITALES"
  },
  {
    "codigo":707452003,
    "descripcion":"ADENOCARCINOMA MUCINOSO PRIMARIO DE PULMÓN"
  },
  {
    "codigo":445308004,
    "descripcion":"MALFORMACIÓN DE MÉDULA ESPINAL DIVIDIDA"
  },
  {
    "codigo":17489000,
    "descripcion":"ALTURA CORPORAL NORMAL PARA LA EDAD"
  },
  {
    "codigo":838524009,
    "descripcion":"INTOXICACIÓN ACCIDENTAL CAUSADA POR METILENDIOXIMETANFETAMINA"
  },
  {
    "codigo":331621000119107,
    "descripcion":"RETRACCIÓN ANORMAL DE PÁRPADO SUPERIOR DERECHO"
  },
  {
    "codigo":212262000,
    "descripcion":"TRAUMATISMO CERRADO DEL NERVIO CUBITAL, RAMA DORSAL SENSITIVA"
  },
  {
    "codigo":50257008,
    "descripcion":"PERFORACIÓN DE COLON"
  },
  {
    "codigo":277798002,
    "descripcion":"ESTRÍA DEL ADOLESCENTE"
  },
  {
    "codigo":210427000,
    "descripcion":"LESIÓN POR DESOLLAMIENTO DE PENE"
  },
  {
    "codigo":79355007,
    "descripcion":"CARDIOPATÍA HIPERTENSIVA EN EL CONTEXTO OBSTÉTRICO"
  },
  {
    "codigo":863952002,
    "descripcion":"DISPOSITIVO COLOCADO EN LUGAR INCORRECTO"
  },
  {
    "codigo":274128005,
    "descripcion":"PARTO EN PRESENTACIÓN DE BREGMA"
  },
  {
    "codigo":372432006,
    "descripcion":"COMPROMISO TUMORAL EN MARGEN LATERAL INFERIOR DE RESECCIÓN QUIRÚRGICA, PRESENTE"
  },
  {
    "codigo":110288007,
    "descripcion":"DOLOR ARTICULAR A LA PALPACIÓN"
  },
  {
    "codigo":700112007,
    "descripcion":"SÍNDROME DE BARTTER, TIPO 4"
  },
  {
    "codigo":403365004,
    "descripcion":"ROSÁCEA AGRAVADA POR EXPOSICIÓN AL SOL"
  },
  {
    "codigo":1351802001,
    "descripcion":"INMUNODEFICIENCIA COMBINADA AUTOSÓMICA RECESIVA DEBIDA A MUTACIÓN DE ITPKB"
  },
  {
    "codigo":204922001,
    "descripcion":"QUISTE HIDATÍDICO DE MORGAGNI - MASCULINO"
  },
  {
    "codigo":432463002,
    "descripcion":"ARTROPATÍA DE CADERA ASOCIADA CON TRASTORNO NEUROLÓGICO"
  },
  {
    "codigo":1153359003,
    "descripcion":"HIPERPLASIA LINFOIDE DE BAZO"
  },
  {
    "codigo":203087004,
    "descripcion":"INFECCIÓN DEL ESPACIO TENAR PALMAR"
  },
  {
    "codigo":301391005,
    "descripcion":"DOLOR A LA PALPACIÓN EN ESTRUCTURA LINFORRETICULAR"
  },
  {
    "codigo":235855004,
    "descripcion":"HEMORROIDES INTERNA-EXTERNA"
  },
  {
    "codigo":6479008,
    "descripcion":"ALBINISMO PARCIAL"
  },
  {
    "codigo":1217060001,
    "descripcion":"TRASTORNO ADRENOGENITAL IATROGÉNICO"
  },
  {
    "codigo":299556002,
    "descripcion":"CREPITACIÓN PALPABLE DE ARTICULACIÓN SUBASTRAGALINA"
  },
  {
    "codigo":201252003,
    "descripcion":"ÚLCERA DIABÉTICA MIXTA DEL PIE"
  },
  {
    "codigo":399695009,
    "descripcion":"NO SE PUEDE EVALUAR LA EXTENSIÓN DEL COMPROMISO DEL MARGEN DE RESECCIÓN QUIRÚRGICA POR NEOPLASIA MALIGNA"
  },
  {
    "codigo":365092005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA MOVILIZARSE"
  },
  {
    "codigo":234020005,
    "descripcion":"VASCULITIS CAUSADA POR FÁRMACO"
  },
  {
    "codigo":334131000119100,
    "descripcion":"ENTROPIÓN MECÁNICO DE PÁRPADO INFERIOR DERECHO"
  },
  {
    "codigo":68345001,
    "descripcion":"APRAXIA"
  },
  {
    "codigo":16908441000119107,
    "descripcion":"CARCINOMA SEBÁCEO DE PIEL DE PÁRPADO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":102948009,
    "descripcion":"INHIBICIÓN SEXUAL"
  },
  {
    "codigo":166649005,
    "descripcion":"NIVEL DE GAMMAGLUTAMIL TRANSFERASA FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":230350000,
    "descripcion":"SÍNDROME DE OPSOCLONÍA-MIOCLONÍA"
  },
  {
    "codigo":11802931000119102,
    "descripcion":"ESGUINCE DE LIGAMENTO DE ARTICULACIÓN INTERCARPIANA DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":426958002,
    "descripcion":"SÍNDROME DEL FOLÍCULO VACÍO"
  },
  {
    "codigo":197582001,
    "descripcion":"GLOMERULONEFRITIS AGUDA ASOCIADA CON OTRO TRASTORNO"
  },
  {
    "codigo":66510004,
    "descripcion":"ANOMALÍA CONGÉNITA DEL MIEMBRO SUPERIOR"
  },
  {
    "codigo":263118005,
    "descripcion":"DERRAME ARTICULAR TRAUMÁTICO"
  },
  {
    "codigo":35577008,
    "descripcion":"HOLOACARDIO ACÉFALO"
  },
  {
    "codigo":787406007,
    "descripcion":"METABOLIZADOR ULTRARRÁPIDO DE LA FAMILIA 3 SUBFAMILIA A MIEMBRO 5 DEL CITOCROMO P450"
  },
  {
    "codigo":295886007,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE TRIMIPRAMINA"
  },
  {
    "codigo":228515002,
    "descripcion":"MASTICA ROLLO DE TABACO"
  },
  {
    "codigo":292216001,
    "descripcion":"REACCIÓN ADVERSA A UN ANTIBIÓTICO CITOTÓXICO"
  },
  {
    "codigo":783736003,
    "descripcion":"MELANOMA MALIGNO DE MEMBRANA MUCOSA"
  },
  {
    "codigo":95608006,
    "descripcion":"NECROSIS DE PLACENTA"
  },
  {
    "codigo":324984006,
    "descripcion":"PROTEINURIA RELACIONADA CON LA DIETA"
  },
  {
    "codigo":718200007,
    "descripcion":"LINFOMA PULMONAR PRIMARIO"
  },
  {
    "codigo":126541001,
    "descripcion":"NEOPLASIA DE HUESO TEMPORAL"
  },
  {
    "codigo":30072009,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE REGIÓN ESCAPULAR SIN INFECCIÓN"
  },
  {
    "codigo":93773005,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA SUPERFICIE DORSAL DE LA LENGUA"
  },
  {
    "codigo":124706000,
    "descripcion":"GLUTATIÓN SINTASA - DEFICIENCIA"
  },
  {
    "codigo":190242005,
    "descripcion":"BOCIO TÓXICO DIFUSO CON CRISIS"
  },
  {
    "codigo":91938006,
    "descripcion":"ALERGIA A FRUTILLA"
  },
  {
    "codigo":253943002,
    "descripcion":"DUPLICACIÓN DE HUESO DEL TARSO"
  },
  {
    "codigo":385015003,
    "descripcion":"PROPAGACIÓN EXTRAPROSTÁTICA DE TUMOR PRESENTE, UNIFOCAL"
  },
  {
    "codigo":712695007,
    "descripcion":"J7"
  },
  {
    "codigo":1204215008,
    "descripcion":"OCLUSIÓN AGUDA DE ARTERIA AXILAR POR TROMBOEMBOLISMO"
  },
  {
    "codigo":286711007,
    "descripcion":"CARÁCTER EXCESIVAMENTE ANSIOSO"
  },
  {
    "codigo":284876000,
    "descripcion":"CAPAZ DE CORTARSE LAS UÑAS DE LOS PIES"
  },
  {
    "codigo":219340003,
    "descripcion":"LESIÓN POR EXPLOSIVO, CON PROPÓSITO DESCONOCIDO"
  },
  {
    "codigo":1003937000,
    "descripcion":"DELECIÓN PROXIMAL DEL CROMOSOMA 13"
  },
  {
    "codigo":15954381000119107,
    "descripcion":"LESIÓN DE PEZÓN DERECHO"
  },
  {
    "codigo":20897003,
    "descripcion":"ATROFIA DE LA MAMA"
  },
  {
    "codigo":86433007,
    "descripcion":"DIETA PARA LACTANTES DE 0 A 12 MESES: LECHE HUMANA, VITAMINA D Y C, FLÚOR Y HIERRO"
  },
  {
    "codigo":283041008,
    "descripcion":"LESIÓN SUPERFICIAL DE PIERNA"
  },
  {
    "codigo":84598000,
    "descripcion":"POLISINDACTILIA"
  },
  {
    "codigo":707190001,
    "descripcion":"CONDICIÓN DE DIENTE PILAR, IDEAL"
  },
  {
    "codigo":1264246003,
    "descripcion":"CICATRIZ DE REGIÓN SUPERIOR DE MUCOSA YUGAL DERECHA"
  },
  {
    "codigo":248438009,
    "descripcion":"FIEBRE COTIDIANA"
  },
  {
    "codigo":770891008,
    "descripcion":"ALERGIA A PROTEÍNA DE LA COAGULACIÓN"
  },
  {
    "codigo":1196875008,
    "descripcion":"CISTOADENOMA ACINAR PANCREÁTICO"
  },
  {
    "codigo":48160003,
    "descripcion":"PROTEINURIA LORDÓTICA"
  },
  {
    "codigo":12241511000119106,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE CABEZA LARGA DE TENDÓN DE BÍCEPS BRAQUIAL DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":13557007,
    "descripcion":"INFESTACIÓN CAUSADA POR CHINCHES"
  },
  {
    "codigo":110026000,
    "descripcion":"FRACTURA MAXILAR HORIZONTAL EXPUESTA"
  },
  {
    "codigo":699850008,
    "descripcion":"UROLITIASIS POR INDINAVIR"
  },
  {
    "codigo":1156767003,
    "descripcion":"OSTEOFITO DE VÉRTEBRA DEBIDO A DEGENERACIÓN DE DISCO INTERVERTEBRAL"
  },
  {
    "codigo":403103004,
    "descripcion":"ONICOMICOSIS CAUSADA POR MOHO"
  },
  {
    "codigo":698015006,
    "descripcion":"PIERCING DE LA REGIÓN BUCAL"
  },
  {
    "codigo":42655007,
    "descripcion":"PARÁLISIS BILATERAL COMPLETA DE LAS CUERDAS VOCALES"
  },
  {
    "codigo":302964004,
    "descripcion":"LUXACIÓN DE ARTICULACIÓN TEMPOROMANDIBULAR"
  },
  {
    "codigo":1251401000,
    "descripcion":"DERMATOSIS NEUTROFÍLICA AGUDA FEBRIL CLÁSICA"
  },
  {
    "codigo":399433008,
    "descripcion":"ESTROMA PROSTÁTICO COMPROMETIDO POR EXTENSIÓN DIRECTA DE NEOPLASIA MALIGNA"
  },
  {
    "codigo":366665009,
    "descripcion":"HALLAZGO DE LA RESPUESTA DE SENSIBILIDAD POR CONTACTO"
  },
  {
    "codigo":299294003,
    "descripcion":"SIN AMPLITUD DE ROTACIÓN INTERNA PASIVA DE ARTICULACIÓN DE CADERA"
  },
  {
    "codigo":233758005,
    "descripcion":"NEUMOCONIOSIS POR MICA"
  },
  {
    "codigo":397598006,
    "descripcion":"DEMUESTRA CONOCIMIENTO DE LOS REQUERIMIENTOS NUTRICIONALES RELACIONADOS CON PROCEDIMIENTOS QUIRÚRGICOS"
  },
  {
    "codigo":200990006,
    "descripcion":"PARAPSORIASIS RETIFORME"
  },
  {
    "codigo":364830008,
    "descripcion":"HALLAZGO RELACIONADO CON LA POSICIÓN Y LA POSTURA DEL CUERPO"
  },
  {
    "codigo":723443003,
    "descripcion":"SÍNDROME DE INMUNODEFICIENCIA DE NEUTRÓFILOS"
  },
  {
    "codigo":231923006,
    "descripcion":"EDEMA CORNEAL AFÁQUICO"
  },
  {
    "codigo":788979007,
    "descripcion":"QUISTE PILONIDAL MALIGNO"
  },
  {
    "codigo":721608001,
    "descripcion":"ENFERMEDAD DE HIRSCHSPRUNG DE REGIÓN RECTOSIGMOIDE"
  },
  {
    "codigo":262856003,
    "descripcion":"PERFORACIÓN TARDÍA DE INTESTINO DELGADO"
  },
  {
    "codigo":426696003,
    "descripcion":"NEUMONÍA DEL LÓBULO DE LA LÍNGULA"
  },
  {
    "codigo":295624005,
    "descripcion":"SOBREDOSIS DE ETOGLÚCIDO"
  },
  {
    "codigo":293789006,
    "descripcion":"ALERGIA A TRILOSTANO"
  },
  {
    "codigo":12106651000119108,
    "descripcion":"QUEMADURA DE HOMBRO DERECHO"
  },
  {
    "codigo":160882001,
    "descripcion":"EL NIÑO VIVE CON ABUELOS"
  },
  {
    "codigo":717938001,
    "descripcion":"NEUROPATÍA ÓPTICA DEBIDA A DEFICIENCIA DE FOLATO"
  },
  {
    "codigo":62578003,
    "descripcion":"DEFECTO CONGÉNITO DE LA ABSORCIÓN DE FOLATOS"
  },
  {
    "codigo":291954007,
    "descripcion":"INTOXICACIÓN POR AMIODARONA"
  },
  {
    "codigo":95346009,
    "descripcion":"ÚLCERA MUCOCUTÁNEA"
  },
  {
    "codigo":1142087002,
    "descripcion":"ANEMIA MEGALOBLÁSTICA CONGÉNITA DEBIDA A DEFICIENCIA DE TRANSCOBALAMINA II"
  },
  {
    "codigo":128114009,
    "descripcion":"ENFERMEDAD DE VON WILLEBRAND HEREDITARIA TIPO 1C"
  },
  {
    "codigo":60743005,
    "descripcion":"DEFICIENCIA DE PURINA - NUCLEÓSIDO FOSFORILASA"
  },
  {
    "codigo":421191008,
    "descripcion":"PÁRPADO ASIÁTICO"
  },
  {
    "codigo":716103008,
    "descripcion":"HERIDA ABIERTA DE MANO DEBIDA A MORDEDURA DE GATO"
  },
  {
    "codigo":290119008,
    "descripcion":"PROBLEMA DEL PEZÓN"
  },
  {
    "codigo":124444008,
    "descripcion":"DEFICIENCIA DE GLICEROFOSFOCOLINA FOSFODIESTERASA"
  },
  {
    "codigo":253681005,
    "descripcion":"CAYADO AÓRTICO INTERRUMPIDO DISTAL A LA ARTERIA SUBCLAVIA IZQUIERDA"
  },
  {
    "codigo":286449007,
    "descripcion":"MANEJA ENVASES DE COMIDA"
  },
  {
    "codigo":15930421000119108,
    "descripcion":"LESIÓN DE OVARIO IZQUIERDO"
  },
  {
    "codigo":448454005,
    "descripcion":"ARTRITIS INFECCIOSA DE PRIMERA ARTICULACIÓN METATARSOFALÁNGICA"
  },
  {
    "codigo":118939000,
    "descripcion":"TRASTORNO DEL CUELLO"
  },
  {
    "codigo":250011000,
    "descripcion":"BALANCEO A TRAVÉS DE MARCHA DE TRES APOYOS"
  },
  {
    "codigo":282779001,
    "descripcion":"LESIÓN TRAUMÁTICA DE QUINTO DEDO DE PIE"
  },
  {
    "codigo":284614009,
    "descripcion":"CONDUCTA AMENAZANTE"
  },
  {
    "codigo":413851004,
    "descripcion":"UVEÍTIS ANTERIOR PRODUCIDA POR CIDOFOVIR"
  },
  {
    "codigo":315547006,
    "descripcion":"NACIDO EN TURQUÍA"
  },
  {
    "codigo":870768000,
    "descripcion":"ESGUINCE DE LIGAMENTO DE COMPLEJO CARPIANO CUBITAL"
  },
  {
    "codigo":117104001,
    "descripcion":"UNIDAD DE HEMODERIVADO DISPONIBLE EN INVENTARIO"
  },
  {
    "codigo":51568001,
    "descripcion":"VÉRTIGO DEL TRONCO ENCEFÁLICO"
  },
  {
    "codigo":248176005,
    "descripcion":"LABIO INFERIOR CAÍDO"
  },
  {
    "codigo":1263984008,
    "descripcion":"HEMORRAGIA FETAL INTRACEREBRAL NO TRAUMÁTICA"
  },
  {
    "codigo":1296752009,
    "descripcion":"HIPERTENSIÓN OCULAR PRIMARIA OJO IZQUIERDO"
  },
  {
    "codigo":705093001,
    "descripcion":"FRACTURA EXPUESTA DE APÓFISIS DE FÉMUR"
  },
  {
    "codigo":1231216009,
    "descripcion":"APRAXIA OCULOMOTORA ADQUIRIDA DE TIPO FRONTAL"
  },
  {
    "codigo":770629000,
    "descripcion":"SÍNDROME DE MICRODELECIÓN 17P13.1 DISTAL"
  },
  {
    "codigo":703258003,
    "descripcion":"ESTENOSIS ADQUIRIDA DE TRONCO DE ARTERIA PULMONAR"
  },
  {
    "codigo":441114008,
    "descripcion":"CÉLULAS ESCAMOSAS ATÍPICAS EN EXTENDIDO DE PAPANICOLAOU ANAL QUE NO PERMITEN EXCLUIR LESIÓN INTRAEPITELIAL ESCAMOSA DE ALTO GRADO"
  },
  {
    "codigo":768794008,
    "descripcion":"CATARATAS BILATERALES DEBIDAS A DIABETES MELLITUS"
  },
  {
    "codigo":766959002,
    "descripcion":"OBSTRUCCIÓN DE SENO CORONARIO"
  },
  {
    "codigo":66921000119104,
    "descripcion":"PORTADOR DE ATAXIA ESPINOCEREBELOSA"
  },
  {
    "codigo":404676002,
    "descripcion":"NISTAGMO DE BRUNS"
  },
  {
    "codigo":240836004,
    "descripcion":"ONCODERMATITIS"
  },
  {
    "codigo":109764005,
    "descripcion":"SIALOADENITIS AGUDA"
  },
  {
    "codigo":699588004,
    "descripcion":"LIPOMA INTRACORTICAL"
  },
  {
    "codigo":402841001,
    "descripcion":"ANGIOQUERATOMA VULVAR"
  },
  {
    "codigo":206233005,
    "descripcion":"LESIÓN OBSTÉTRICA DEL NERVIO FRÉNICO"
  },
  {
    "codigo":239001006,
    "descripcion":"GENODERMATOSIS"
  },
  {
    "codigo":42393006,
    "descripcion":"ACIDEMIA METILMALÓNICA"
  },
  {
    "codigo":2131000221102,
    "descripcion":"ENVENENAMIENTO CAUSADO POR VENENO DE SERPIENTE YARARÁ"
  },
  {
    "codigo":401006003,
    "descripcion":"STENT TRAQUEAL IN SITU"
  },
  {
    "codigo":204398004,
    "descripcion":"QUISTE EPICÁRDICO CONGÉNITO"
  },
  {
    "codigo":11863401000119109,
    "descripcion":"CONTUSIÓN DE DEDO GORDO DEL PIE DERECHO"
  },
  {
    "codigo":300867004,
    "descripcion":"MOVIMIENTO DE LA MASA CON LA RESPIRACIÓN - HALLAZGO"
  },
  {
    "codigo":366403009,
    "descripcion":"AMPLITUD DE PROTRACCIÓN DE LA COLUMNA CERVICAL - HALLAZGO"
  },
  {
    "codigo":4120002,
    "descripcion":"BRONQUIOLITIS"
  },
  {
    "codigo":725016001,
    "descripcion":"DISTENSIÓN DE FASCIA DEL CUELLO"
  },
  {
    "codigo":299032009,
    "descripcion":"MANO PEQUEÑA"
  },
  {
    "codigo":40451000119107,
    "descripcion":"DESARROLLO INADECUADO DE ENDOMETRIO"
  },
  {
    "codigo":445363005,
    "descripcion":"CONEXIONES AURICULOVENTRICULARES CONCORDANTES"
  },
  {
    "codigo":341661000119101,
    "descripcion":"RUPTURA DE COROIDES DE OJO IZQUIERDO"
  },
  {
    "codigo":65986000,
    "descripcion":"SÍNDROME FETAL POR AMINOPTERINA"
  },
  {
    "codigo":297197008,
    "descripcion":"CUERDA TENDINOSA TRICUSPÍDEA ROTA"
  },
  {
    "codigo":295362001,
    "descripcion":"SOBREDOSIS INTENCIONAL DE NIZATIDINA"
  },
  {
    "codigo":721346003,
    "descripcion":"FRACTURA DE APÓFISIS ODONTOIDES DEL AXIS TIPO III"
  },
  {
    "codigo":197058003,
    "descripcion":"VÓLVULO DE INTESTINO DELGADO"
  },
  {
    "codigo":450005,
    "descripcion":"ESTOMATITIS ULCERATIVA"
  },
  {
    "codigo":426434006,
    "descripcion":"ISQUEMIA ANTERIOR EN EL ELECTROCARDIOGRAMA"
  },
  {
    "codigo":1078941000119103,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE BRONQUIO PRINCIPAL DERECHO"
  },
  {
    "codigo":129687000,
    "descripcion":"HALLAZGO RELACIONADO CON EL CAMPO DE LA MEDICINA ALTERNATIVA"
  },
  {
    "codigo":1145495000,
    "descripcion":"HIPOPLASIA CONGÉNITA DE HUESO DE MANO"
  },
  {
    "codigo":31383003,
    "descripcion":"NEOPLASIA DE VAGINA QUE AFECTA EL EMBARAZO"
  },
  {
    "codigo":162455005,
    "descripcion":"PRESENTA EL SÍNTOMA DIARIAMENTE"
  },
  {
    "codigo":64151006,
    "descripcion":"ESOFAGOMALACIA"
  },
  {
    "codigo":719511005,
    "descripcion":"ENFERMEDAD DE CHARCOT-MARIE-TOOTH TIPO 2G AUTOSÓMICA DOMINANTE"
  },
  {
    "codigo":226156001,
    "descripcion":"DIETA RICA EN MINERALES"
  },
  {
    "codigo":95084006,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA PIEL DEL OMBLIGO"
  },
  {
    "codigo":291692006,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ETIONAMIDA"
  },
  {
    "codigo":289857000,
    "descripcion":"ERUPCIÓN DE PERINEO FEMENINO"
  },
  {
    "codigo":160620009,
    "descripcion":"EX FUMADOR DE PIPA"
  },
  {
    "codigo":93249003,
    "descripcion":"HIPOPLASIA CONGÉNITA DEL CEREBRO"
  },
  {
    "codigo":27713005,
    "descripcion":"ARTROPATÍA ASOCIADA CON ACROMEGALIA"
  },
  {
    "codigo":1141825006,
    "descripcion":"COMPOSICIÓN DE INGESTA NUTRICIONAL DE AMINOÁCIDOS INCOMPATIBLE CON EL REQUERIMIENTO"
  },
  {
    "codigo":10637111000119102,
    "descripcion":"ÚLCERA POR PRESIÓN EN NALGA ESTADIO III"
  },
  {
    "codigo":25878000,
    "descripcion":"ANEURISMA DE ARTERIA HEPÁTICA"
  },
  {
    "codigo":224321008,
    "descripcion":"EDUCADO EN ESCUELA SEGREGACIONISTA"
  },
  {
    "codigo":243863351000119103,
    "descripcion":"FRACTURA NO EXPUESTA DE PARED EXTERNA DE ÓRBITA DERECHA"
  },
  {
    "codigo":89579000,
    "descripcion":"DEFICIENCIA DE TETRAHIDROFOLATO METILTRANSFERASA"
  },
  {
    "codigo":124182008,
    "descripcion":"DEFICIENCIA DE N - METIL - L - AMINOÁCIDO OXIDASA"
  },
  {
    "codigo":697907008,
    "descripcion":"HIPERTENSIÓN DE ARTERIA PULMONAR ASOCIADA CON ESQUISTOSOMIASIS"
  },
  {
    "codigo":29861000175101,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN DE TALÓN DERECHO GRADO 2"
  },
  {
    "codigo":56811006,
    "descripcion":"SEUDOHIPOFOSFATASIA"
  },
  {
    "codigo":253419007,
    "descripcion":"DEFECTO DEL TABIQUE AURICULOVENTRICULAR CON COMPONENTE VENTRICULAR DEBAJO DE PUENTE DE VALVA SUPERIOR Y CUERDAS TENDINOSAS EN LA CRESTA DEL TABIQUE VENTRICULAR"
  },
  {
    "codigo":286187008,
    "descripcion":"ORDENA LA CASA"
  },
  {
    "codigo":22208002,
    "descripcion":"GINGIVITIS DESCAMATIVA"
  },
  {
    "codigo":413589004,
    "descripcion":"MAYOR RIESGO DE INCENDIO QUIRÚRGICO"
  },
  {
    "codigo":247914000,
    "descripcion":"HIPERACTIVIDAD SIN PROPÓSITO"
  },
  {
    "codigo":1362026000,
    "descripcion":"LINFOMA NODAL DE LINFOCITOS T AYUDANTES FOLICULARES, TIPO FOLICULAR"
  },
  {
    "codigo":1003413009,
    "descripcion":"DUPLICACIÓN DE PORCIÓN MEDIA DE BRAZO LARGO DE CROMOSOMA 4"
  },
  {
    "codigo":1263722004,
    "descripcion":"TRASTORNO FETAL DEBIDO A SÍNDROME DE ANILLOS DE CONSTRICCIÓN"
  },
  {
    "codigo":16754641000119104,
    "descripcion":"SANGRADO UTERINO ANORMAL POR NEOPLASIA MALIGNA PRIMARIA DE ENDOMETRIO"
  },
  {
    "codigo":211476000,
    "descripcion":"CONTUSIÓN DE LA GARGANTA"
  },
  {
    "codigo":702996002,
    "descripcion":"STAPHYLOCOCCUS WARNERI O STAPHYLOCOCCUS PASTEURI"
  },
  {
    "codigo":1260052003,
    "descripcion":"CICATRIZ DE MUCOSA DE PALADAR DURO"
  },
  {
    "codigo":309780003,
    "descripcion":"DESGARRO ANTIGUO DEL MENISCO INTERNO"
  },
  {
    "codigo":735764005,
    "descripcion":"LACERACIÓN DE TÓRAX SIN CUERPO EXTRAÑO"
  },
  {
    "codigo":111337001,
    "descripcion":"SÍNDROME DE DYKE-DAVIDOFF-MASSON"
  },
  {
    "codigo":78569004,
    "descripcion":"SÍNDROME DE WALLENBERG"
  },
  {
    "codigo":209641004,
    "descripcion":"DESGARRO COMPLETO DE LIGAMENTO INTERFALÁNGICO (DE DEDO DEL PIE)"
  },
  {
    "codigo":371646003,
    "descripcion":"CUERPO EMBALSAMADO"
  },
  {
    "codigo":699326004,
    "descripcion":"PUNCIÓN ACCIDENTAL DE PLEURA"
  },
  {
    "codigo":240574004,
    "descripcion":"SKENITIS GONOCÓCICA"
  },
  {
    "codigo":109502009,
    "descripcion":"MALA OCLUSIÓN, CLASE II DE ANGLE, DIVISIÓN 1"
  },
  {
    "codigo":42131003,
    "descripcion":"CICLO MENSTRUAL ANORMAL"
  },
  {
    "codigo":402579004,
    "descripcion":"DERMATITIS IRRITATIVA POR CONTACTO CAUSADA POR PLANTA"
  },
  {
    "codigo":9363005,
    "descripcion":"DERRAME ARTICULAR DE LA REGIÓN PÉLVICA"
  },
  {
    "codigo":238739004,
    "descripcion":"ALOTRIQUIA CIRCUNSCRIPTA SIMÉTRICA"
  },
  {
    "codigo":46561000087103,
    "descripcion":"FRACTURA DE OMÓPLATO DERECHO"
  },
  {
    "codigo":44001000087100,
    "descripcion":"HERIDA CORTANTE DE PIEL DE DEDO ANULAR IZQUIERDO"
  },
  {
    "codigo":73064001,
    "descripcion":"HIPERSECRECIÓN DE TIROTROFINA"
  },
  {
    "codigo":41441000087105,
    "descripcion":"HEMATOMA DE MANO DERECHA"
  },
  {
    "codigo":38881000087106,
    "descripcion":"TÍTULO DE MAESTRÍA OBTENIDO"
  },
  {
    "codigo":1187176000,
    "descripcion":"AMINOFILINA EN SUERO POR ENCIMA DEL RANGO TERAPÉUTICO"
  },
  {
    "codigo":40296006,
    "descripcion":"RESPIRACIÓN MENINGÍTICA"
  },
  {
    "codigo":169533001,
    "descripcion":"FRACASO DE ESPONJA ANTICONCEPTIVA"
  },
  {
    "codigo":235069003,
    "descripcion":"CANDIDIASIS SEUDOMEMBRANOSA AGUDA BUCAL"
  },
  {
    "codigo":398909004,
    "descripcion":"ROSÁCEA"
  },
  {
    "codigo":366141005,
    "descripcion":"HALLAZGO RELACIONADO CON VÍA DE RESPIRACIÓN"
  },
  {
    "codigo":890429004,
    "descripcion":"POLIDACTILIA PREAXIAL BILATERAL DE DEDO GORDO"
  },
  {
    "codigo":300605007,
    "descripcion":"DIFICULTAD PARA UTILIZAR LAS COMODIDADES LOCALES"
  },
  {
    "codigo":1281810006,
    "descripcion":"SÍNDROME DE HORNER"
  },
  {
    "codigo":298770009,
    "descripcion":"TUMEFACCIÓN DE PARTES BLANDAS DE ARTICULACIÓN DE HOMBRO"
  },
  {
    "codigo":788455001,
    "descripcion":"OCLUSIÓN BILATERAL DE ARTERIAS PONTINAS"
  },
  {
    "codigo":722919003,
    "descripcion":"INSUFICIENCIA CARDÍACA NEONATAL DEBIDA A DISMINUCIÓN DEL GASTO DEL VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":428007007,
    "descripcion":"DISFUNCIÓN ERÉCTIL DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":188001,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA ARTERIA INTERCOSTAL"
  },
  {
    "codigo":721084001,
    "descripcion":"SÍNDROME DE SORDERA, CEGUERA E HIPOPIGMENTACIÓN TIPO YEMENITA"
  },
  {
    "codigo":1343676003,
    "descripcion":"FALTA DE CONOCIMIENTO DE A QUIÉN CONTACTAR EN CASO DE EMERGENCIA MÉDICA"
  },
  {
    "codigo":295100001,
    "descripcion":"ALERGIA A ALCOHOL NICOTINÍLICO"
  },
  {
    "codigo":1148903009,
    "descripcion":"TRASTORNO SECUNDARIO DE LOS GLOMÉRULOS"
  },
  {
    "codigo":293265000,
    "descripcion":"REACCIÓN ADVERSA A LA LIOTIRONINA"
  },
  {
    "codigo":719249005,
    "descripcion":"ATAXIA ESPINOCEREBELOSA TIPO 17"
  },
  {
    "codigo":94822000,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL EPICARDIO"
  },
  {
    "codigo":1145233008,
    "descripcion":"PELO CANOSO PLATEADO"
  },
  {
    "codigo":29286002,
    "descripcion":"SECUENCIA ANORMAL DE ÁCIDOS NUCLEICOS"
  },
  {
    "codigo":16019871000119102,
    "descripcion":"SINOVITIS TRANSITORIA DE ARTICULACIÓN DE AMBAS MUÑECAS"
  },
  {
    "codigo":291430005,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR AMFOTERICINA B"
  },
  {
    "codigo":1208934006,
    "descripcion":"SÍNDROME DE SAGLIKER"
  },
  {
    "codigo":1010491000,
    "descripcion":"AGENESIA DE FALANGE PROXIMAL DE DEDO PULGAR"
  },
  {
    "codigo":191291005,
    "descripcion":"TRASTORNO HEMORRÁGICO POR AUMENTO DE ANTI-9A"
  },
  {
    "codigo":92987006,
    "descripcion":"RADIO ARQUEADO CONGÉNITO"
  },
  {
    "codigo":27451006,
    "descripcion":"INFECCIÓN CAUSADA POR TRITRICHOMONAS"
  },
  {
    "codigo":254992001,
    "descripcion":"ADENOMA PLEOMORFO DE GLÁNDULA LAGRIMAL"
  },
  {
    "codigo":25616007,
    "descripcion":"ARTROPATÍA AGUDA"
  },
  {
    "codigo":123920009,
    "descripcion":"INTOXICACIÓN POR JUGLANDACEAE"
  },
  {
    "codigo":449765005,
    "descripcion":"OSTEOMA ENDOSTEAL"
  },
  {
    "codigo":285925006,
    "descripcion":"LLENA EL LAVABO"
  },
  {
    "codigo":1268965008,
    "descripcion":"EPENDIMOMA ANAPLÁSICO PRIMARIO DE SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":416997009,
    "descripcion":"DISFUNCIÓN SOMÁTICA DE CODO"
  },
  {
    "codigo":21946002,
    "descripcion":"ESTAFILOMA ANTERIOR LOCALIZADO"
  },
  {
    "codigo":185786004,
    "descripcion":"CONTROL DE ESTRÉS REALIZADO"
  },
  {
    "codigo":447930006,
    "descripcion":"DOBLE CAYADO AÓRTICO CON ARCO DERECHO DOMINANTE"
  },
  {
    "codigo":52879001,
    "descripcion":"AUSENCIA CONGÉNITA DE GLOTIS"
  },
  {
    "codigo":249487004,
    "descripcion":"INCAPAZ DE INICIAR LA DEGLUCIÓN"
  },
  {
    "codigo":773775004,
    "descripcion":"CARCINOMA NEUROENDOCRINO DE ALTO GRADO DEL CUELLO DEL ÚTERO"
  },
  {
    "codigo":51044000,
    "descripcion":"CATARATA SECUNDARIA POSTERIOR A EXTRACCIÓN DE CATARATA QUE NO DIFICULTA LA VISIÓN"
  },
  {
    "codigo":247652001,
    "descripcion":"PENSAMIENTOS SEXUALES OBSCENOS"
  },
  {
    "codigo":1263460007,
    "descripcion":"SÍNDROME DE BIRT HOGG DUBÉ"
  },
  {
    "codigo":18276007,
    "descripcion":"FRACTURAS MÚLTIPLES EXPUESTAS DE AMBAS EXTREMIDADES SUPERIORES"
  },
  {
    "codigo":409657002,
    "descripcion":"ESOFAGITIS CRÓNICA"
  },
  {
    "codigo":1228857005,
    "descripcion":"EPILEPSIA MIOCLÓNICA PROGRESIVA TIPO 9"
  },
  {
    "codigo":737337007,
    "descripcion":"DEPENDENCIA DE CANABINOIDE SINTÉTICO"
  },
  {
    "codigo":473358000,
    "descripcion":"TOLERA LÍQUIDOS POR VÍA ORAL"
  },
  {
    "codigo":80142000,
    "descripcion":"PERFORACIÓN DEL TABIQUE NASAL"
  },
  {
    "codigo":309518001,
    "descripcion":"TROMBO VENTRICULAR DERECHO"
  },
  {
    "codigo":278585007,
    "descripcion":"PUENTE DENTAL DEMASIADO ESTRECHO"
  },
  {
    "codigo":47374004,
    "descripcion":"SÍNDROME DEL TÚNEL TARSIANO"
  },
  {
    "codigo":1259790005,
    "descripcion":"ENFERMEDAD DE PAGET PERIANAL PRIMARIA"
  },
  {
    "codigo":276750003,
    "descripcion":"NEOPLASIA MALIGNA DE PIEL CON DIFERENCIACIÓN PILAR"
  },
  {
    "codigo":405987001,
    "descripcion":"METÁSTASIS TUMORAL A GANGLIOS LINFÁTICOS NO REGIONALES, NO PUEDEN SER EVALUADAS"
  },
  {
    "codigo":1290723001,
    "descripcion":"ARTRITIS REACTIVA DE ARTICULACIÓN DE REGIÓN DE MUÑECA"
  },
  {
    "codigo":735502009,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL SUPERFICIAL DE PERINEO"
  },
  {
    "codigo":307683004,
    "descripcion":"MOVIMIENTOS SACÁDICOS INAPROPIADOS"
  },
  {
    "codigo":209379004,
    "descripcion":"FRACTURA-SUBLUXACIÓN EXPUESTA DE PIE"
  },
  {
    "codigo":897507003,
    "descripcion":"TRISOMÍA DISTAL 9P"
  },
  {
    "codigo":305848001,
    "descripcion":"ATENDIDO POR EL SERVICIO HOSPITALARIO DE PODOLOGÍA"
  },
  {
    "codigo":10969811000119106,
    "descripcion":"HERIDA ABIERTA DE MUSLO IZQUIERDO DEBIDA A MORDEDURA DE PERRO"
  },
  {
    "codigo":404152006,
    "descripcion":"INFILTRACIÓN LEUCÉMICA DE PIEL EN LEUCEMIA MIELOIDE AGUDA"
  },
  {
    "codigo":1354424007,
    "descripcion":"OCLUSIÓN DE VENA TEMPORAL SUPERIOR DE RETINA"
  },
  {
    "codigo":830136008,
    "descripcion":"RETINA DE OJO IZQUIERDO PARCIALMENTE EVALUABLE"
  },
  {
    "codigo":240312009,
    "descripcion":"LESIÓN CEREBRAL POR TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":369549002,
    "descripcion":"NEOPLASIA MALIGNA QUE COMPROMETE TROMPA DE FALOPIO DERECHA POR PROPAGACIÓN DIRECTA DESDE OVARIO"
  },
  {
    "codigo":2361000124105,
    "descripcion":"CANINO SUPERIOR IZQUIERDO DECIDUO SUPERNUMERARIO"
  },
  {
    "codigo":402317005,
    "descripcion":"PSORIASIS GENERALIZADA"
  },
  {
    "codigo":41869007,
    "descripcion":"INFECCIÓN CAUSADA POR TRIAENOPHORUS"
  },
  {
    "codigo":205709009,
    "descripcion":"MOSAICO XY\/XXY"
  },
  {
    "codigo":302178002,
    "descripcion":"RESULTADOS DE LA SOLICITUD DE SUBSIDIOS: EN ESPERA"
  },
  {
    "codigo":7266006,
    "descripcion":"PLACENTA PREVIA TOTAL CON HEMORRAGIA INTRAPARTO"
  },
  {
    "codigo":726327000,
    "descripcion":"DISTENSIÓN DE TENDÓN DE MÚSCULO INTRÍNSECO DE PIE"
  },
  {
    "codigo":236642009,
    "descripcion":"DISTENSIÓN ANORMAL DE VEJIGA URINARIA"
  },
  {
    "codigo":300343004,
    "descripcion":"HALLAZGO RELACIONADO CON EL ASPECTO DE LA VESÍCULA BILIAR"
  },
  {
    "codigo":365879006,
    "descripcion":"EXAMEN MICROSCÓPICO DE ORINA: PIOCITOS PRESENTES"
  },
  {
    "codigo":70967007,
    "descripcion":"SORDERA DISOCIATIVA"
  },
  {
    "codigo":298508000,
    "descripcion":"AMPLITUD DE FLEXIÓN ACTIVA NORMAL DE LA COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":1119543009,
    "descripcion":"DEFECTO PROGRESIVO DE CAMPO VISUAL"
  },
  {
    "codigo":724492003,
    "descripcion":"FÍSTULA VESICOVAGINAL CON COMPROMISO DEL MECANISMO DE CONTINENCIA URINARIA DEBIDO A TRABAJO DE PARTO OBSTRUIDO Y POSTERIOR A ÉL"
  },
  {
    "codigo":396812005,
    "descripcion":"MARGEN QUIRÚRGICO PROXIMAL DEL PÁNCREAS COMPROMETIDO POR NEOPLASIA MALIGNA"
  },
  {
    "codigo":427745001,
    "descripcion":"PERCEPCIÓN ERRÓNEA DEL ESTADO DEL SUEÑO"
  },
  {
    "codigo":1761006,
    "descripcion":"CIRROSIS BILIAR"
  },
  {
    "codigo":720822008,
    "descripcion":"SÍNTOMA DE ABSTINENCIA"
  },
  {
    "codigo":294838009,
    "descripcion":"ALERGIA A HORMONA REGULADORA DEL CALCIO"
  },
  {
    "codigo":1144971001,
    "descripcion":"ÚLCERA DE INTESTINO DELGADO DEBIDA A SÍNDROME DE BEHCET"
  },
  {
    "codigo":129163001,
    "descripcion":"LUXACIÓN EXPUESTA DE ARTICULACIÓN LUMBOSACRA"
  },
  {
    "codigo":293003004,
    "descripcion":"REACCIÓN ADVERSA AL CEFACLOR"
  },
  {
    "codigo":63627007,
    "descripcion":"ABSCESO ESPINAL EPIDURAL"
  },
  {
    "codigo":94560003,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA PIEL DE LA MANO"
  },
  {
    "codigo":422240004,
    "descripcion":"DEFICIENCIA DE HORMONA LIBERADORA DE GONADOTROFINAS"
  },
  {
    "codigo":127328006,
    "descripcion":"AUSENCIA CONGÉNITA DE HUESO"
  },
  {
    "codigo":225632008,
    "descripcion":"MIEDO A LOS ASCENSORES"
  },
  {
    "codigo":715317001,
    "descripcion":"MIOPATÍA MIOTÓNICA PROXIMAL"
  },
  {
    "codigo":92725005,
    "descripcion":"CARCINOMA IN SITU DE LA PIEL DE LOS DEDOS DE LA MANO"
  },
  {
    "codigo":289333007,
    "descripcion":"CONTUSIÓN DE CORDÓN UMBILICAL"
  },
  {
    "codigo":387637008,
    "descripcion":"DERRAME ARTICULAR"
  },
  {
    "codigo":59957008,
    "descripcion":"ENFERMEDAD DE GRAVES NEONATAL"
  },
  {
    "codigo":58122001,
    "descripcion":"INFESTACIÓN CAUSADA POR RHINOESTRUS"
  },
  {
    "codigo":1010229008,
    "descripcion":"HIPOACUSIA NEURAL DE OÍDO IZQUIERDO"
  },
  {
    "codigo":10671111000119109,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN EN TOBILLO IZQUIERDO NO ESTADIFICABLE"
  },
  {
    "codigo":254730000,
    "descripcion":"MELANOMA MALIGNO CUTÁNEO SUPERFICIAL DISEMINADO"
  },
  {
    "codigo":123658006,
    "descripcion":"HENDIDURA CONGÉNITA DE UNA VÁLVULA CARDÍACA"
  },
  {
    "codigo":713482002,
    "descripcion":"OSTEOARTROSIS DE ARTICULACIÓN CIGOAPOFISARIA DE COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":1303306008,
    "descripcion":"ELEGIBLE PARA SUBSIDIO"
  },
  {
    "codigo":449503003,
    "descripcion":"DISMINUCIÓN ESPONTÁNEA DEL TAMAÑO DE DEFECTO DEL TABIQUE INTERVENTRICULAR DEBIDO A PROLAPSO DE CÚSPIDE DE VÁLVULA AÓRTICA"
  },
  {
    "codigo":11791521000119104,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DE MUÑECA DERECHA"
  },
  {
    "codigo":56287005,
    "descripcion":"ENFERMEDAD DE CROHN DEL DUODENO"
  },
  {
    "codigo":1268703006,
    "descripcion":"TUMOR NEUROECTODÉRMICO PERIFÉRICO PRIMARIO"
  },
  {
    "codigo":447668005,
    "descripcion":"ARTERIAS PULMONARES DISCONTINUAS"
  },
  {
    "codigo":283828005,
    "descripcion":"MORDEDURA DE ANIMAL EN LA ESPINILLA"
  },
  {
    "codigo":445832003,
    "descripcion":"QUEMADURA QUÍMICA DE PÁRPADO"
  },
  {
    "codigo":19849005,
    "descripcion":"ASMA DE LOS EMPAQUETADORES DE CARNE"
  },
  {
    "codigo":1197662002,
    "descripcion":"ESTENOSIS DE ESÓFAGO INFERIOR DEBIDA A ENFERMEDAD EROSIVA POR REFLUJO GASTROESOFÁGICO"
  },
  {
    "codigo":247390002,
    "descripcion":"PARÁLISIS DEL NERVIO CIÁTICO"
  },
  {
    "codigo":312926005,
    "descripcion":"DRUSA DE LÁMINA BASAL"
  },
  {
    "codigo":11817851000119100,
    "descripcion":"ESGUINCE DE LIGAMENTO DE PULGAR DERECHO"
  },
  {
    "codigo":310651000119101,
    "descripcion":"MIOSITIS INFECCIOSA DE MUSLO IZQUIERDO"
  },
  {
    "codigo":679291000119102,
    "descripcion":"HEMORRAGIA BILATERAL DE SUSTANCIA PROPIA DE CÓRNEAS"
  },
  {
    "codigo":704307007,
    "descripcion":"CON MAYOR RIESGO DE COMPLICACIÓN DE ESTOMA"
  },
  {
    "codigo":10970491000119102,
    "descripcion":"HERIDA ABIERTA DE PIERNA DERECHA DEBIDA A MORDEDURA DE ANIMAL"
  },
  {
    "codigo":292731000119105,
    "descripcion":"COMPRESIÓN DE NERVIO CUBITAL DERECHO"
  },
  {
    "codigo":309256001,
    "descripcion":"PIE HELADO AL TACTO"
  },
  {
    "codigo":80251000119104,
    "descripcion":"NIVEL DE COMPLEMENTO POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":11131000119108,
    "descripcion":"ANOMALÍA OCULAR"
  },
  {
    "codigo":10947451000119109,
    "descripcion":"HERIDA ABIERTA DE DEDO ANULAR DE MANO IZQUIERDA DEBIDA A MORDEDURA DE PERRO"
  },
  {
    "codigo":6011000119108,
    "descripcion":"ARTRITIS TRANSITORIA"
  },
  {
    "codigo":1073531000119109,
    "descripcion":"ARTRITIS INFECCIOSA DE PIE IZQUIERDO"
  },
  {
    "codigo":1076091000119108,
    "descripcion":"QUISTE SINOVIAL DE PIE DERECHO"
  },
  {
    "codigo":407560009,
    "descripcion":"CON MAYOR RIESGO DE ENFERMEDAD DE TRANSMISIÓN SEXUAL"
  },
  {
    "codigo":290171000119108,
    "descripcion":"LESIÓN DE NERVIO PLANTAR DERECHO"
  },
  {
    "codigo":209117003,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN ESTERNOCLAVICULAR"
  },
  {
    "codigo":1091451000119109,
    "descripcion":"CONDRITIS DEL OÍDO EXTERNO DERECHO"
  },
  {
    "codigo":241885000,
    "descripcion":"EFECTO TÓXICO CAUSADO POR SOLVENTE DE PINTURAS"
  },
  {
    "codigo":136571000119109,
    "descripcion":"CÓLICO EN EL ADULTO"
  },
  {
    "codigo":897245003,
    "descripcion":"CURVATURA ANORMAL DE FALANGE MEDIA DE TERCER DEDO DE PIE"
  },
  {
    "codigo":1259528009,
    "descripcion":"CARCINOMA PRIMARIO DE BRONQUIO PRINCIPAL"
  },
  {
    "codigo":274653009,
    "descripcion":"PREOCUPACIÓN E INQUIETUD INAPROPIADA POR EVENTOS ESTRESANTES"
  },
  {
    "codigo":305586001,
    "descripcion":"BAJO ATENCIÓN DE OBSTÉTRICA"
  },
  {
    "codigo":733405006,
    "descripcion":"FRACTURA DE CUELLO QUIRÚRGICO DE HÚMERO"
  },
  {
    "codigo":43442006,
    "descripcion":"HIDROARTROSIS EN LA FRAMBESIA"
  },
  {
    "codigo":1155719000,
    "descripcion":"OBSTRUCCIÓN DE VÁLVULA MITRAL REUMÁTICA"
  },
  {
    "codigo":403890009,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS DE LA VULVA POR LIQUEN ESCLEROSO"
  },
  {
    "codigo":371122009,
    "descripcion":"ANOMALÍA CONGÉNITA DE LA FUNCIÓN ENDOCRINA TESTICULAR"
  },
  {
    "codigo":860807003,
    "descripcion":"NEUROPATÍA AUTONÓMICA HEREDITARIA"
  },
  {
    "codigo":762503004,
    "descripcion":"TRASTORNO CAUSADO POR CATINONA SINTÉTICA"
  },
  {
    "codigo":240050008,
    "descripcion":"PORTADORA FEMENINA MANIFIESTA DE DISTROFIA MUSCULAR LIGADA AL CROMOSOMA X"
  },
  {
    "codigo":926343009,
    "descripcion":"ESTATURA BAJA CONGÉNITA DESPROPORCIONADA LETAL CON TRONCO CORTO"
  },
  {
    "codigo":1186652002,
    "descripcion":"SÍNDROME DE ENFERMEDAD INFLAMATORIA INTESTINAL E INFECCIÓN SINOPULMONAR RECURRENTE"
  },
  {
    "codigo":236380004,
    "descripcion":"SÍNDROME NEFRÓTICO SENSIBLE A LOS ESTEROIDES"
  },
  {
    "codigo":301916005,
    "descripcion":"HALLAZGO RELACIONADO CON MEDICIONES DE HENDIDURA PALPEBRAL"
  },
  {
    "codigo":39772007,
    "descripcion":"PÓLIPO RECTAL"
  },
  {
    "codigo":1119281000,
    "descripcion":"NEURORRETINITIS SUBAGUDA UNILATERAL DIFUSA"
  },
  {
    "codigo":365617001,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA RECONOCER CARAS VISUALMENTE"
  },
  {
    "codigo":201777003,
    "descripcion":"ARTRITIS REUMATOIDE DE LA RODILLA"
  },
  {
    "codigo":70705008,
    "descripcion":"GLÁNDULA SALIVAL ACCESORIA"
  },
  {
    "codigo":36102002,
    "descripcion":"SÍNDROME DE WATERHOUSE-FRIDERICHSEN"
  },
  {
    "codigo":679381000119109,
    "descripcion":"CICATRIZ DE CONJUNTIVA DE AMBOS OJOS"
  },
  {
    "codigo":134406006,
    "descripcion":"TABAQUISMO DISMINUIDO"
  },
  {
    "codigo":68870007,
    "descripcion":"ANEMIA DISERITROPOYÉTICA CONGÉNITA, TIPO II"
  },
  {
    "codigo":198107000,
    "descripcion":"ABSCESO RETROMAMARIO"
  },
  {
    "codigo":1499003,
    "descripcion":"TRASTORNO BIPOLAR I, UN SOLO EPISODIO MANÍACO DE INICIO EN EL PERÍODO POSTPARTO"
  },
  {
    "codigo":294576005,
    "descripcion":"ALERGIA A SULFAFURAZOL"
  },
  {
    "codigo":261808007,
    "descripcion":"HEMORRAGIA CEREBRAL NEONATAL"
  },
  {
    "codigo":194437008,
    "descripcion":"TRASTORNO PARA INICIAR Y MANTENER EL SUEÑO"
  },
  {
    "codigo":61530001,
    "descripcion":"NEOPLASIA ENDOCRINA MÚLTIPLE, TIPO 2B"
  },
  {
    "codigo":1144709009,
    "descripcion":"APLASIA DE FALANGE DISTAL DE SEGUNDO DEDO DE PIE"
  },
  {
    "codigo":127066000,
    "descripcion":"POLICITEMIA VERA FAMILIAR"
  },
  {
    "codigo":225370004,
    "descripcion":"UTILIZA MÉTODO ANTICONCEPTIVO DE BARRERA"
  },
  {
    "codigo":94298004,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LOS ÓRGANOS GENITALES FEMENINOS"
  },
  {
    "codigo":12203631000119109,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DE BRAZO IZQUIERDO"
  },
  {
    "codigo":59695000,
    "descripcion":"CONSTRICCIÓN BILATERAL DEL CAMPO VISUAL"
  },
  {
    "codigo":715055001,
    "descripcion":"ENFERMEDAD CAUSADA POR LEPORIPOXVIRUS"
  },
  {
    "codigo":420143002,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA SUPERIOR AFECTADO POR CARCINOMA DUCTAL IN SITU"
  },
  {
    "codigo":92463003,
    "descripcion":"NEOPLASIA BENIGNA DEL URACO"
  },
  {
    "codigo":290906008,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR FLUOXETINA"
  },
  {
    "codigo":289071009,
    "descripcion":"DIFICULTAD PARA UTILIZAR AYUDA PARA ALIMENTARSE"
  },
  {
    "codigo":254468002,
    "descripcion":"NEOPLASIA DE TROMPA DE EUSTAQUIO"
  },
  {
    "codigo":188932004,
    "descripcion":"NEOPLASIA BENIGNA DEL CUERPO ESTERNAL"
  },
  {
    "codigo":90628007,
    "descripcion":"ÚLCERA GÁSTRICA AGUDA PERFORADA PERO SIN OBSTRUCCIÓN"
  },
  {
    "codigo":354211000119101,
    "descripcion":"NEOPLASIA BENIGNA DE CUERPO CILIAR DE OJO DERECHO"
  },
  {
    "codigo":416473005,
    "descripcion":"QUERATITIS ULCERATIVA PERIFÉRICA"
  },
  {
    "codigo":447406000,
    "descripcion":"QUEMADURA POR FRICCIÓN DE CUELLO"
  },
  {
    "codigo":23257009,
    "descripcion":"INFECCIÓN CAUSADA POR PARAGONIMUS WESTERMANII"
  },
  {
    "codigo":185262002,
    "descripcion":"ATENDIDO EN UN CONSULTORIO DE CIRUGÍA GENERAL"
  },
  {
    "codigo":283566002,
    "descripcion":"HERIDA DE PERDIGÓN EN MANO"
  },
  {
    "codigo":840622004,
    "descripcion":"PIERCING EN LENGUA CON TACHUELA"
  },
  {
    "codigo":314499001,
    "descripcion":"IRRITACIÓN OCULAR RELACIONADA CON LENTES DE CONTACTO"
  },
  {
    "codigo":1091491000119104,
    "descripcion":"GRANULACIÓN DE CAVIDAD MASTOIDEA DERECHA"
  },
  {
    "codigo":248963003,
    "descripcion":"CICLO MENSTRUAL LARGO"
  },
  {
    "codigo":138389411000119105,
    "descripcion":"BRONQUITIS AGUDA POR COVID-19"
  },
  {
    "codigo":445571008,
    "descripcion":"ISOBUTIRILGLICINURIA"
  },
  {
    "codigo":1162797005,
    "descripcion":"FOSFATASA ALCALINA PLACENTARIA POR ENCIMA DE RANGO DE REFERENCIA"
  },
  {
    "codigo":472834000,
    "descripcion":"TRASTORNO DE PRÓTESIS DE VÁLVULA TRONCAL"
  },
  {
    "codigo":276226001,
    "descripcion":"DISFUNCIÓN DEL APARATO GASTROINTESTINAL EN SU TOTALIDAD"
  },
  {
    "codigo":866050001,
    "descripcion":"NEOPLASIA DE CÉLULAS GERMINATIVAS MIXTAS DE SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":1081201000112100,
    "descripcion":"ESTENOSIS DE ÁRBOL TRAQUEOBRONQUIAL"
  },
  {
    "codigo":403628008,
    "descripcion":"PIGMENTACIÓN (NO MELÁNICA) CAUSADA POR MEDICAMENTO DE APLICACIÓN TÓPICA"
  },
  {
    "codigo":698540008,
    "descripcion":"REQUIERE RETENEDOR ORTODÓNCICO INFERIOR"
  },
  {
    "codigo":41345002,
    "descripcion":"RAQUITISMO"
  },
  {
    "codigo":272556009,
    "descripcion":"SENTARSE DE COSTADO EN UN CABALLO"
  },
  {
    "codigo":237953006,
    "descripcion":"DEFICIENCIA DE LA 2-METILACETOACETIL-COA TIOLASA MITOCONDRIAL - ESTIMULADA POR POTASIO"
  },
  {
    "codigo":61000119108,
    "descripcion":"RINITIS IRRITATIVA"
  },
  {
    "codigo":303489008,
    "descripcion":"DIFICULTAD PARA ATARSE LOS CORDONES"
  },
  {
    "codigo":203350002,
    "descripcion":"ENFERMEDAD DE PAGET DE FALANGE DE DEDO DEL PIE"
  },
  {
    "codigo":432726005,
    "descripcion":"HIRSUTISMO FAMILIAR"
  },
  {
    "codigo":39510005,
    "descripcion":"ARTROPATÍA NEUROGÉNICA OSIFICANTE"
  },
  {
    "codigo":103211000,
    "descripcion":"PRODUCCIÓN ANORMAL DE MEGACARIOCITOS"
  },
  {
    "codigo":365355000,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA REALIZAR EJERCICIOS DE SEGURIDAD VIAL"
  },
  {
    "codigo":301654008,
    "descripcion":"DIFICULTAD PARA SENTARSE EN UNA SILLA"
  },
  {
    "codigo":299819003,
    "descripcion":"REFLEJO AUROPALPEBRAL PRESENTE"
  },
  {
    "codigo":4907004,
    "descripcion":"FALTA DE RETRACCIÓN DEL ÚTERO"
  },
  {
    "codigo":267051003,
    "descripcion":"HEMATEMESIS - SANGRE FRESCA"
  },
  {
    "codigo":430891006,
    "descripcion":"NECROSIS AVASCULAR DE HUESO DE LA MANO"
  },
  {
    "codigo":398123003,
    "descripcion":"HIPERGLUCEMIA DE REBOTE"
  },
  {
    "codigo":3072001,
    "descripcion":"HIPOPITUITARISMO INDUCIDO POR HORMONAS"
  },
  {
    "codigo":232448002,
    "descripcion":"ARQUEAMIENTO DE CUERDA VOCAL"
  },
  {
    "codigo":297984005,
    "descripcion":"HALLAZGO RELACIONADO CON EL ESTADO DE LIMPIEZA DE LAS UÑAS"
  },
  {
    "codigo":197845000,
    "descripcion":"CISTITIS ASOCIADA CON OTRO TRASTORNO"
  },
  {
    "codigo":296149003,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE BUSPIRONA"
  },
  {
    "codigo":230613008,
    "descripcion":"NEUROPATÍA POR INYECCIÓN"
  },
  {
    "codigo":785834005,
    "descripcion":"ABSCESO DEBIDO A PERITONITIS"
  },
  {
    "codigo":292479000,
    "descripcion":"REACCIÓN ADVERSA A FÁRMACO SIMPATICOMIMÉTICO"
  },
  {
    "codigo":1144447003,
    "descripcion":"APLASIA DE FALANGE DISTAL DE DEDO ÍNDICE"
  },
  {
    "codigo":194175003,
    "descripcion":"RESPUESTA OPTOCINÉTICA ANORMAL"
  },
  {
    "codigo":63103006,
    "descripcion":"XANTOMATOSIS"
  },
  {
    "codigo":28500000,
    "descripcion":"INFECCIÓN CAUSADA POR COLLYRICULUM"
  },
  {
    "codigo":290644001,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR MITOMICINA"
  },
  {
    "codigo":94036006,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA PIEL PERINEAL"
  },
  {
    "codigo":126804008,
    "descripcion":"NEOPLASIA DEL ÁREA RETROMOLAR"
  },
  {
    "codigo":92201001,
    "descripcion":"NEOPLASIA BENIGNA DE LOS GANGLIOS LINFÁTICOS DE SITIOS MÚLTIPLES"
  },
  {
    "codigo":419881002,
    "descripcion":"LAXITUD ZONULAR"
  },
  {
    "codigo":288809001,
    "descripcion":"NO SALUDA"
  },
  {
    "codigo":26665006,
    "descripcion":"TRASTORNO DE LA PERSONALIDAD ANTISOCIAL"
  },
  {
    "codigo":254206003,
    "descripcion":"NEVO VASCULAR CONGÉNITO"
  },
  {
    "codigo":876798004,
    "descripcion":"REACCIÓN ADVERSA A SULFAMETOXAZOL Y\/O TRIMETOPRIMA"
  },
  {
    "codigo":88531004,
    "descripcion":"HIPERTROFIA RENAL"
  },
  {
    "codigo":53928001,
    "descripcion":"COLECISTITIS ALITIÁSICA CRÓNICA"
  },
  {
    "codigo":250536002,
    "descripcion":"SINOVITIS POR ALMIDÓN"
  },
  {
    "codigo":283304003,
    "descripcion":"ASTILLA DE MADERA EN EXTREMIDAD INFERIOR"
  },
  {
    "codigo":414376003,
    "descripcion":"LEUCOPLASIA VELLOSA DE LA LENGUA ASOCIADA CON ENFERMEDAD POR VIH"
  },
  {
    "codigo":253363004,
    "descripcion":"ANOMALÍA DEL TABIQUE INTERAURICULAR"
  },
  {
    "codigo":281469001,
    "descripcion":"CONSOLIDACIÓN DEFECTUOSA DE FRACTURA CON ACORTAMIENTO"
  },
  {
    "codigo":19325002,
    "descripcion":"BRONQUIECTASIA POR TRACCIÓN"
  },
  {
    "codigo":1297277004,
    "descripcion":"CELULITIS DE DEDO ÍNDICE"
  },
  {
    "codigo":248701005,
    "descripcion":"SOPLO CARDIORRESPIRATORIO"
  },
  {
    "codigo":445309007,
    "descripcion":"BLOQUEO TRIFASCICULAR EN ELECTROCARDIOGRAMA"
  },
  {
    "codigo":707453008,
    "descripcion":"CARCINOMA PRIMARIO DE CÉLULAS ESCAMOSAS DE PULMÓN, VARIANTE DE CÉLULAS CLARAS"
  },
  {
    "codigo":115794002,
    "descripcion":"FENOTIPO DE GRUPO SANGUÍNEO P"
  },
  {
    "codigo":246866004,
    "descripcion":"CANALÍCULO LAGRIMAL INFLAMADO CON CÁLCULO"
  },
  {
    "codigo":310567000,
    "descripcion":"ENFERMEDAD DE LYME DETECTADA POR ANÁLISIS INMUNOABSORBENTE LIGADO A ENZIMAS"
  },
  {
    "codigo":441639003,
    "descripcion":"HALLAZGO NORMAL EN EL EXAMEN DE MÉDULA ÓSEA"
  },
  {
    "codigo":212263005,
    "descripcion":"CONTUSIÓN, NERVIO CUBITAL, RAMA SENSITIVA PALMAR"
  },
  {
    "codigo":372433001,
    "descripcion":"COMPROMISO TUMORAL EN MARGEN LATERAL IZQUIERDO DE RESECCIÓN QUIRÚRGICA, PRESENTE"
  },
  {
    "codigo":274129002,
    "descripcion":"PARTO EN PRESENTACIÓN DE CARA"
  },
  {
    "codigo":110289004,
    "descripcion":"RESPIRACIÓN BUCAL OBLIGATORIA"
  },
  {
    "codigo":863953007,
    "descripcion":"ANEMIA POR SENSIBILIDAD A PRIMAQUINA"
  },
  {
    "codigo":403366003,
    "descripcion":"ROSÁCEA EXTRAFACIAL"
  },
  {
    "codigo":270459005,
    "descripcion":"PACIENTE EN LISTA DE ESPERA"
  },
  {
    "codigo":204923006,
    "descripcion":"QUISTE HIDATÍDICO DE MORGAGNI - FEMENINO"
  },
  {
    "codigo":268624000,
    "descripcion":"REACCIÓN PARANOIDE AGUDA"
  },
  {
    "codigo":39248001,
    "descripcion":"INTOXICACIÓN POR GÉNERO GOSSYPIUM"
  },
  {
    "codigo":237691008,
    "descripcion":"DEFICIENCIA PSICOSOCIAL DE SOMATOTROFINA"
  },
  {
    "codigo":235856003,
    "descripcion":"ENFERMEDAD DEL HÍGADO"
  },
  {
    "codigo":301392003,
    "descripcion":"DOLOR A LA PALPACIÓN EN ESTRUCTURA DE LA CAVIDAD BUCAL"
  },
  {
    "codigo":72016002,
    "descripcion":"INTOXICACIÓN POR MELILOTUS ALBA"
  },
  {
    "codigo":332761000119100,
    "descripcion":"ENDOFTALMITIS PURULENTA DERECHA"
  },
  {
    "codigo":4645000,
    "descripcion":"AMILOIDOSIS CEREBRAL SENIL"
  },
  {
    "codigo":365093000,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA SUPERAR OBSTÁCULOS"
  },
  {
    "codigo":1217061002,
    "descripcion":"GLUCOPENIA"
  },
  {
    "codigo":203088009,
    "descripcion":"INFECCIÓN DEL ESPACIO MEDIOPALMAR PALMAR"
  },
  {
    "codigo":102949001,
    "descripcion":"MASTURBACIÓN EXCESIVA"
  },
  {
    "codigo":299557006,
    "descripcion":"CREPITACIÓN AUDIBLE DE ARTICULACIÓN SUBASTRAGALINA"
  },
  {
    "codigo":234021009,
    "descripcion":"NECROSIS QUÍSTICA DE LA MEDIA"
  },
  {
    "codigo":428794004,
    "descripcion":"FÍSTULA"
  },
  {
    "codigo":461562004,
    "descripcion":"ATRESIA DE CAYADO AÓRTICO CON CORDÓN FIBROSO"
  },
  {
    "codigo":975000,
    "descripcion":"AGENESIA ANORRECTAL"
  },
  {
    "codigo":164815001,
    "descripcion":"PRUEBA POSCOITAL ANORMAL"
  },
  {
    "codigo":787407003,
    "descripcion":"SÍNDROME DE MUENKE"
  },
  {
    "codigo":295887003,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE TRIMIPRAMINA"
  },
  {
    "codigo":197583006,
    "descripcion":"NEFRITIS EXUDATIVA AGUDA"
  },
  {
    "codigo":228516001,
    "descripcion":"MASTICA HOJAS DE TABACO"
  },
  {
    "codigo":31908003,
    "descripcion":"SEQUEDAD DE LA VAGINA"
  },
  {
    "codigo":425124004,
    "descripcion":"INHIBICIÓN FARMACOLÓGICA DE ENZIMA CYP2C9 DEL CITOCROMO P450"
  },
  {
    "codigo":95609003,
    "descripcion":"LUPUS ERITEMATOSO NEONATAL"
  },
  {
    "codigo":292217005,
    "descripcion":"REACCIÓN ADVERSA A LA DACTINOMICINA"
  },
  {
    "codigo":783737007,
    "descripcion":"SÍNDROME DE ENFERMEDAD DE HIRSCHSPRUNG Y GANGLIONEUROBLASTOMA"
  },
  {
    "codigo":28238002,
    "descripcion":"ESGUINCE DE ARTICULACIÓN CONDROCOSTAL SIN LESIÓN TRAUMÁTICA DEL ESTERNÓN"
  },
  {
    "codigo":290382004,
    "descripcion":"INTOXICACIÓN POR PIRENZEPINA"
  },
  {
    "codigo":126542008,
    "descripcion":"NEOPLASIA DE HUESO OCCIPITAL"
  },
  {
    "codigo":716366009,
    "descripcion":"REQUIERE PROVISIÓN CONTINUA DE OXÍGENO EN EL DOMICILIO"
  },
  {
    "codigo":421454008,
    "descripcion":"INFECCIÓN GASTROINTESTINAL ASOCIADA CON SIDA"
  },
  {
    "codigo":91939003,
    "descripcion":"ALERGIA A SULFONAMIDA"
  },
  {
    "codigo":419619007,
    "descripcion":"ALERGIA A PAPA"
  },
  {
    "codigo":286712000,
    "descripcion":"CARÁCTER MIEDOSO"
  },
  {
    "codigo":124707009,
    "descripcion":"DEFICIENCIA DE FOSFOPANTOTENATO - CISTEÍNA LIGASA"
  },
  {
    "codigo":385016002,
    "descripcion":"PROPAGACIÓN EXTRAPROSTÁTICA TUMORAL MULTIFOCAL, PRESENTE"
  },
  {
    "codigo":24568004,
    "descripcion":"INTOXICACIÓN POR PRUNUS CAROLINIANA"
  },
  {
    "codigo":1263539004,
    "descripcion":"AMIOTROFIA MONOMÉLICA BENIGNA DE MIEMBRO INFERIOR"
  },
  {
    "codigo":253944008,
    "descripcion":"DUPLICACIÓN COMPLETA DEL PIE"
  },
  {
    "codigo":1204216009,
    "descripcion":"OCLUSIÓN AGUDA DE ARTERIA AXILAR POR TROMBOSIS"
  },
  {
    "codigo":448717002,
    "descripcion":"DECLINACIÓN DEL PUNTAJE DE LA ESCALA DE DEPRESIÓN POSNATAL DE EDIMBURGO"
  },
  {
    "codigo":88269008,
    "descripcion":"SÍNDROME TALÁMICO"
  },
  {
    "codigo":283042001,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE DEDO GORDO DE PIE"
  },
  {
    "codigo":284877009,
    "descripcion":"INCAPAZ DE CORTARSE LAS UÑAS DE LOS PIES"
  },
  {
    "codigo":414114004,
    "descripcion":"QUISTE EPITELIAL"
  },
  {
    "codigo":250274006,
    "descripcion":"ANORMALIDAD DE LOS NEUTRÓFILOS"
  },
  {
    "codigo":248439001,
    "descripcion":"FIEBRE COTIDIANA DOBLE"
  },
  {
    "codigo":51831006,
    "descripcion":"SEPSIS LUEGO DE INFUSIÓN, INYECCIÓN, TRANSFUSIÓN Y\/O VACUNACIÓN"
  },
  {
    "codigo":1264247007,
    "descripcion":"CICATRIZ DE MUCOSA YUGAL DERECHA"
  },
  {
    "codigo":246604001,
    "descripcion":"CAPAZ DE SENTARSE DERECHO CON LAS CADERAS FLEXIONADAS Y LAS RODILLAS EXTENDIDAS"
  },
  {
    "codigo":441377000,
    "descripcion":"PRUEBA DE ESTRÉS CON TALIO ANORMAL"
  },
  {
    "codigo":1196876009,
    "descripcion":"CARCINOMA PRIMARIO DE CÉLULAS ACINARES DE GLÁNDULA PARÓTIDA"
  },
  {
    "codigo":277537008,
    "descripcion":"PANCREATITIS AGUDA POSTERIOR A COLANGIOPANCREATOGRAFÍA RETRÓGRADA ENDOSCÓPICA"
  },
  {
    "codigo":310305009,
    "descripcion":"MANIFESTACIÓN DE LA VOLUNTAD ACTIVA (COPIA EN HISTORIA CLÍNICA)"
  },
  {
    "codigo":77259008,
    "descripcion":"SEGUNDO ESTADIO DEL TRABAJO DE PARTO PROLONGADO"
  },
  {
    "codigo":110027009,
    "descripcion":"FRACTURA MAXILAR PIRAMIDAL EXPUESTA"
  },
  {
    "codigo":403104005,
    "descripcion":"ONICOMICOSIS SUBUNGUEAL DISTAL Y LATERAL"
  },
  {
    "codigo":89511000119106,
    "descripcion":"HIGROMA SUBDURAL"
  },
  {
    "codigo":698016007,
    "descripcion":"BAZO PALPABLE POR DEBAJO DEL REBORDE COSTAL"
  },
  {
    "codigo":1156768008,
    "descripcion":"OVARIOLEUCODISTROFIA"
  },
  {
    "codigo":73589001,
    "descripcion":"PROLAPSO DE DISCO INTERVERTEBRAL"
  },
  {
    "codigo":302965003,
    "descripcion":"LACERACIÓN DE GLÁNDULA TIROIDEA"
  },
  {
    "codigo":401269004,
    "descripcion":"MIEDO DE CAERSE"
  },
  {
    "codigo":399434002,
    "descripcion":"NO SE PUEDE VALORAR INVASIÓN TUMORAL PLEURAL"
  },
  {
    "codigo":301130004,
    "descripcion":"SOPLO DEL DEFECTO DEL TABIQUE AURICULAR"
  },
  {
    "codigo":366666005,
    "descripcion":"SENSIBILIDAD A LA RESPUESTA SARCOIDEA - HALLAZGO"
  },
  {
    "codigo":335271000119109,
    "descripcion":"EPÍFORA DE OJO DERECHO DEBIDA A PRODUCCIÓN EXCESIVA DE LÁGRIMAS"
  },
  {
    "codigo":1251402007,
    "descripcion":"LIPOMATOSIS INFILTRANTE FACIAL CONGÉNITA"
  },
  {
    "codigo":235594008,
    "descripcion":"DISFUNCIÓN INTESTINAL"
  },
  {
    "codigo":268362009,
    "descripcion":"PRUEBA AUDITIVA\/VESTIBULAR NORMAL"
  },
  {
    "codigo":233759002,
    "descripcion":"NEUMOCONIOSIS POR POLVO MINERAL MIXTO"
  },
  {
    "codigo":168223003,
    "descripcion":"NO SE AÍSLAN PARÁSITOS"
  },
  {
    "codigo":16637351000119109,
    "descripcion":"TRASTORNO DE AMBOS NERVIOS PERONEOS PROFUNDOS"
  },
  {
    "codigo":37151006,
    "descripcion":"ERITROMELALGIA"
  },
  {
    "codigo":364831007,
    "descripcion":"FUENTE DE PROVISIÓN DE ALIMENTOS - HALLAZGO"
  },
  {
    "codigo":11777601000119105,
    "descripcion":"DISTENSIÓN DE CABEZA LARGA DE MÚSCULO Y\/O TENDÓN DE BÍCEPS BRAQUIAL DERECHO"
  },
  {
    "codigo":362996001,
    "descripcion":"MORDEDURA EN LA AXILA"
  },
  {
    "codigo":231924000,
    "descripcion":"ARCO CORNEAL"
  },
  {
    "codigo":788980005,
    "descripcion":"MENINGITIS CAUSADA POR TRYPANOSOMA BRUCEI GAMBIENSE"
  },
  {
    "codigo":723444009,
    "descripcion":"TRASTORNO SIMILAR AL SÍNDROME DE NOONAN CON PELO ANÁGENO CADUCO"
  },
  {
    "codigo":292232003,
    "descripcion":"REACCIÓN ADVERSA A LA PENTOSTATINA"
  },
  {
    "codigo":295625006,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE ETOGLÚCIDO"
  },
  {
    "codigo":197321007,
    "descripcion":"ESTEATOSIS HEPÁTICA"
  },
  {
    "codigo":262857007,
    "descripcion":"SECCIÓN DE INTESTINO DELGADO"
  },
  {
    "codigo":721609009,
    "descripcion":"ENFERMEDAD DE HIRSCHSPRUNG CON AGANGLIONOSIS EXTENSA"
  },
  {
    "codigo":293790002,
    "descripcion":"ALERGIA A TAMOXIFENO"
  },
  {
    "codigo":95347000,
    "descripcion":"ESFACELACIÓN DE PIEL"
  },
  {
    "codigo":31646008,
    "descripcion":"ENCEFALITIS POR VIRUS DE LA PAROTIDITIS URLIANA"
  },
  {
    "codigo":128115005,
    "descripcion":"PSEUDOENFERMEDAD DE VON WILLEBRAND"
  },
  {
    "codigo":291955008,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR AMIODARONA"
  },
  {
    "codigo":717939009,
    "descripcion":"ANENCEFALIA SIN RAQUISQUISIS"
  },
  {
    "codigo":290120002,
    "descripcion":"INFLAMACIÓN DE LA GLÁNDULA DE MONTGOMERY"
  },
  {
    "codigo":716104002,
    "descripcion":"HERIDA ABIERTA DE MANO DEBIDA A MORDEDURA DE PERRO"
  },
  {
    "codigo":1240392002,
    "descripcion":"TRASTORNO NEONATAL PRECOZ DEBIDO A DISFUNCIÓN DE PLACENTA"
  },
  {
    "codigo":353821005,
    "descripcion":"ESTASIS GÁSTRICA IDIOPÁTICA"
  },
  {
    "codigo":26141007,
    "descripcion":"INFRADESNIVEL DEL ST"
  },
  {
    "codigo":124445009,
    "descripcion":"DEFICIENCIA DE FOSFOLIPASA C"
  },
  {
    "codigo":253682003,
    "descripcion":"CAYADO AÓRTICO INTERRUMPIDO ENTRE ARTERIAS SUBCLAVIA IZQUIERDA Y CARÓTIDA PRIMITIVA IZQUIERDA"
  },
  {
    "codigo":286450007,
    "descripcion":"NO MANEJA RECIPIENTES DE ALIMENTO"
  },
  {
    "codigo":89842009,
    "descripcion":"ESFACELACIÓN DE INJERTO"
  },
  {
    "codigo":22471005,
    "descripcion":"AGENESIA CEREBELOSA HEMISFÉRICA"
  },
  {
    "codigo":186311005,
    "descripcion":"MELIOIDOSIS AGUDA Y FULMINANTE"
  },
  {
    "codigo":284615005,
    "descripcion":"CONDUCTA FÍSICAMENTE AMENAZANTE"
  },
  {
    "codigo":315548001,
    "descripcion":"NACIDO EN TURKMENISTÁN"
  },
  {
    "codigo":118940003,
    "descripcion":"TRASTORNO DEL SISTEMA NERVIOSO"
  },
  {
    "codigo":282780003,
    "descripcion":"LESIÓN DE TALÓN"
  },
  {
    "codigo":429107004,
    "descripcion":"HALLADO CAMINANDO"
  },
  {
    "codigo":250012007,
    "descripcion":"BALANCEO PARA LA MARCHA DE TRES PUNTOS DE APOYO"
  },
  {
    "codigo":117105000,
    "descripcion":"UNIDAD DE HEMODERIVADO EN CUARENTENA"
  },
  {
    "codigo":1231217000,
    "descripcion":"ESTRABISMO MECÁNICO DEBIDO A ADHESIÓN DE MÚSCULO EXTRAOCULAR"
  },
  {
    "codigo":248177001,
    "descripcion":"LABIOS LLENOS"
  },
  {
    "codigo":280945000,
    "descripcion":"SÍNDROME DE DESREALIZACIÓN"
  },
  {
    "codigo":446620009,
    "descripcion":"LACERACIÓN SUPERFICIAL DE HOMBRO"
  },
  {
    "codigo":20636006,
    "descripcion":"HETEROFORIA VERTICAL"
  },
  {
    "codigo":444785006,
    "descripcion":"INFECCIÓN DE HUESO DE LA CINTURA ESCAPULAR"
  },
  {
    "codigo":413852006,
    "descripcion":"TUBERCULOSIS RESISTENTE A CIPROFLOXACINO"
  },
  {
    "codigo":49734000,
    "descripcion":"TRASTORNO DEL NERVIO INTERMEDIO"
  },
  {
    "codigo":1263985009,
    "descripcion":"HEMORRAGIA INTRACEREBRAL NO TRAUMÁTICA NEONATAL PRECOZ"
  },
  {
    "codigo":770630005,
    "descripcion":"NEUROPATÍA MOTORA HEREDITARIA DISTAL TIPO 1"
  },
  {
    "codigo":408347001,
    "descripcion":"INTERACCIONES FARMACOLÓGICAS IDENTIFICADAS - FÁRMACO REEMPLAZADO"
  },
  {
    "codigo":16966009,
    "descripcion":"HIPOGLUCEMIA SIMULADA"
  },
  {
    "codigo":80667003,
    "descripcion":"PELVIS JUVENIL"
  },
  {
    "codigo":703259006,
    "descripcion":"INSUFICIENCIA DE VÁLVULA MITRAL DEBIDA A MIOCARDIOPATÍA"
  },
  {
    "codigo":10633231000119105,
    "descripcion":"CELULITIS DE PIE DERECHO"
  },
  {
    "codigo":441115009,
    "descripcion":"CÉLULAS ESCAMOSAS ATÍPICAS EN EXTENDIDO DE PAPANICOLAOU VAGINAL QUE NO PERMITEN EXCLUIR LESIÓN INTRAEPITELIAL ESCAMOSA DE ALTO GRADO"
  },
  {
    "codigo":1293083009,
    "descripcion":"FIBROMA PLEURAL"
  },
  {
    "codigo":766960007,
    "descripcion":"OBSTRUCCIÓN DE VENA CAVA INFERIOR"
  },
  {
    "codigo":15685801000119101,
    "descripcion":"RETINITIS DE OJO DERECHO"
  },
  {
    "codigo":11461005,
    "descripcion":"AMIGDALITIS ESTAFILOCÓCICA"
  },
  {
    "codigo":404677006,
    "descripcion":"NISTAGMO ELÍPTICO"
  },
  {
    "codigo":109765006,
    "descripcion":"SIALOADENITIS INFECCIOSA DE GLÁNDULA SALIVAL MAYOR"
  },
  {
    "codigo":42394000,
    "descripcion":"DESNUDEZ DOMÉSTICA"
  },
  {
    "codigo":206234004,
    "descripcion":"LESIÓN DE NERVIO CRANEAL POR TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":271770005,
    "descripcion":"HEMORRAGIAS SUBUNGUEALES EN ASTILLAS"
  },
  {
    "codigo":9626006,
    "descripcion":"DOLOR MECÁNICO"
  },
  {
    "codigo":402842008,
    "descripcion":"ANGIOQUERATOMA ACRO PSEUDOLINFOMATOSO INFANTIL"
  },
  {
    "codigo":269935002,
    "descripcion":"NO SE CULTIVAN MICROORGANISMOS EN EL ESPÉCIMEN"
  },
  {
    "codigo":1351279003,
    "descripcion":"ESTENOSIS ESOFÁGICA CONGÉNITA NO SINDRÓMICA"
  },
  {
    "codigo":401007007,
    "descripcion":"SE FROTA LOS OJOS EN EXCESO"
  },
  {
    "codigo":204399007,
    "descripcion":"HEMICARDIA"
  },
  {
    "codigo":399172001,
    "descripcion":"TIÑA DE REGIÓN PERINEAL"
  },
  {
    "codigo":366404003,
    "descripcion":"AMPLITUD DE PROTRACCIÓN ACTIVA DE LA COLUMNA CERVICAL - HALLAZGO"
  },
  {
    "codigo":300868009,
    "descripcion":"LA MASA SE MUEVE CON LA RESPIRACIÓN"
  },
  {
    "codigo":268100009,
    "descripcion":"RUPTURA DE TENDÓN DE LA MUÑECA"
  },
  {
    "codigo":299033004,
    "descripcion":"DEFORMIDAD DE LA MANO"
  },
  {
    "codigo":725017005,
    "descripcion":"LACERACIÓN DE MÚSCULO DEL CUELLO"
  },
  {
    "codigo":788718000,
    "descripcion":"IRITIS CONCOMITANTE CON ENFERMEDAD INFLAMATORIA DEL INTESTINO"
  },
  {
    "codigo":1077571000119102,
    "descripcion":"OSTEOMIELITIS CRÓNICA DE TIBIA DERECHA"
  },
  {
    "codigo":395502002,
    "descripcion":"NEOPLASIA DE NERVIO ÓPTICO Y SU VAINA"
  },
  {
    "codigo":723182009,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE CAVIDAD NASAL"
  },
  {
    "codigo":253832006,
    "descripcion":"HIPOPLASIA DE ÚTERO Y CUELLO UTERINO"
  },
  {
    "codigo":197059006,
    "descripcion":"VÓLVULO ILEOCECAL"
  },
  {
    "codigo":721347007,
    "descripcion":"FRACTURA DE TERCERA VÉRTEBRA CERVICAL"
  },
  {
    "codigo":262595009,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA"
  },
  {
    "codigo":424600001,
    "descripcion":"CARCINOMA DE OVARIO, ESTADIO 1"
  },
  {
    "codigo":293528003,
    "descripcion":"REACCIÓN ADVERSA A ALCALOIDE DEL CORNEZUELO"
  },
  {
    "codigo":719512003,
    "descripcion":"ENFERMEDAD DE CHARCOT-MARIE-TOOTH TIPO 2K AUTOSÓMICA DOMINANTE"
  },
  {
    "codigo":129688005,
    "descripcion":"ALTERACIÓN DEL CAMPO ENERGÉTICO"
  },
  {
    "codigo":162456006,
    "descripcion":"PRESENTA EL SÍNTOMA CADA POCOS DÍAS"
  },
  {
    "codigo":31384009,
    "descripcion":"POLIMIOSITIS"
  },
  {
    "codigo":291693001,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR ETIONAMIDA"
  },
  {
    "codigo":29549004,
    "descripcion":"OPERÓN RARN"
  },
  {
    "codigo":95085007,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA PIEL DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":16206301000119102,
    "descripcion":"TRASTORNO DE AMBOS NERVIOS CUBITALES"
  },
  {
    "codigo":224322001,
    "descripcion":"EDUCADO EN UNA ESCUELA REGULAR Y PARA NECESIDADES ESPECIALES"
  },
  {
    "codigo":160621008,
    "descripcion":"EX FUMADOR DE CIGARRO"
  },
  {
    "codigo":93250003,
    "descripcion":"HIPOPLASIA CONGÉNITA DE LA CLAVÍCULA"
  },
  {
    "codigo":715842003,
    "descripcion":"TEJIDO PERIODONTAL NORMAL CON PÉRDIDA DE INSERCIÓN"
  },
  {
    "codigo":289858005,
    "descripcion":"DESCAMACIÓN DE PERINEO FEMENINO"
  },
  {
    "codigo":313821000119103,
    "descripcion":"ATROFIA DE MÚSCULO DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":191554003,
    "descripcion":"EXACERBACIÓN AGUDA DE ESQUIZOFRENIA PARANOIDE SUBCRÓNICA"
  },
  {
    "codigo":58647003,
    "descripcion":"TRASTORNO GRAVE DEL ESTADO DE ÁNIMO CON SÍNTOMAS PSICÓTICOS, CONGRUENTE CON EL ESTADO DE ÁNIMO"
  },
  {
    "codigo":124183003,
    "descripcion":"DEFICIENCIA DE NAD (P)^+^ TRANSHIDROGENASA"
  },
  {
    "codigo":253420001,
    "descripcion":"DEFECTO DEL TABIQUE AURICULOVENTRICULAR CON COMPONENTE VENTRICULAR DEBAJO DE PUENTE DE VALVA SUPERIOR Y CUERDAS TENDINOSAS A MÚSCULO PAPILAR EN EL LADO VENTRICULAR DERECHO DEL TABIQUE"
  },
  {
    "codigo":89580002,
    "descripcion":"CIRROSIS CRIPTÓGENA"
  },
  {
    "codigo":286188003,
    "descripcion":"NO ORDENA LA CASA"
  },
  {
    "codigo":187884007,
    "descripcion":"NEOPLASIA MALIGNA DE PERICARDIO"
  },
  {
    "codigo":15960541000119107,
    "descripcion":"ANGINA INESTABLE DEBIDA A ARTERIOESCLEROSIS DE INJERTO-PUENTE AUTÓLOGO DE VENA EN ARTERIA CORONARIA"
  },
  {
    "codigo":22209005,
    "descripcion":"ESPASMO MUSCULAR PARAVERTEBRAL"
  },
  {
    "codigo":1003414003,
    "descripcion":"DUPLICACIÓN DE PORCIÓN MEDIA DE CROMOSOMA 14"
  },
  {
    "codigo":446358003,
    "descripcion":"HIPERTROFIA DE AURÍCULA DERECHA"
  },
  {
    "codigo":249750006,
    "descripcion":"AUSENCIA DE MANO"
  },
  {
    "codigo":315286006,
    "descripcion":"PRÓTESIS OCULAR INESTABLE"
  },
  {
    "codigo":413590008,
    "descripcion":"CON MAYOR RIESGO DE INFECCIÓN ASOCIADA CON ATENCIÓN SANITARIA"
  },
  {
    "codigo":16671351000119104,
    "descripcion":"FRACTURA NO EXPUESTA DE MANDÍBULA IZQUIERDA"
  },
  {
    "codigo":247915004,
    "descripcion":"ACTIVIDAD MOTRIZ DESTRUCTIVA"
  },
  {
    "codigo":1263723009,
    "descripcion":"TRASTORNO FETAL DEBIDO A CORIOAMNIONITIS"
  },
  {
    "codigo":442688001,
    "descripcion":"HALLAZGO RELACIONADO CON DIFERENCIA EN LA DEFINICIÓN DEL BORDE EN COMPARACIÓN CON EXAMEN RADIOLÓGICO PREVIO"
  },
  {
    "codigo":16015991000119106,
    "descripcion":"ARTRITIS DE ARTICULACIÓN SUBASTRAGALINA DERECHA"
  },
  {
    "codigo":49472006,
    "descripcion":"ANEMIA MEGALOBLÁSTICA POR DÉFICIT DE VITAMINA B12"
  },
  {
    "codigo":80405004,
    "descripcion":"ESTADO HIPERINMUNITARIO"
  },
  {
    "codigo":309781004,
    "descripcion":"DESGARRO ANTIGUO DEL MENISCO EXTERNO"
  },
  {
    "codigo":702997006,
    "descripcion":"GEOTRICHUM CANDIDUM O GEOTRICHUM KLEBAHNII"
  },
  {
    "codigo":735765006,
    "descripcion":"HERIDA PUNZANTE DE TÓRAX SIN CUERPO EXTRAÑO"
  },
  {
    "codigo":1260053008,
    "descripcion":"CICATRIZ DE PIEL DE MENTÓN"
  },
  {
    "codigo":1080081000119103,
    "descripcion":"SARCOMA DE EWING PRIMARIO DE OMÓPLATO DERECHO"
  },
  {
    "codigo":111338006,
    "descripcion":"AGENESIA DE NERVIO"
  },
  {
    "codigo":240575003,
    "descripcion":"INFECCIÓN GONOCÓCICA DE LAS GLÁNDULAS DE TYSON"
  },
  {
    "codigo":1264008003,
    "descripcion":"HIPERPLASIA MIOMETRIAL"
  },
  {
    "codigo":342801000119107,
    "descripcion":"DERMATITIS ALÉRGICA POR CONTACTO DE PÁRPADO INFERIOR IZQUIERDO"
  },
  {
    "codigo":1187177009,
    "descripcion":"AMINOFILINA EN SUERO POR DEBAJO DEL RANGO TERAPÉUTICO"
  },
  {
    "codigo":235070002,
    "descripcion":"CANDIDIASIS ATRÓFICA BUCAL AGUDA"
  },
  {
    "codigo":366142003,
    "descripcion":"REFLEJO PALMAR - HALLAZGO"
  },
  {
    "codigo":890430009,
    "descripcion":"AGENESIA COMPLETA DE VERMIS"
  },
  {
    "codigo":724755002,
    "descripcion":"SÍNTOMAS POSITIVOS CONCOMITANTES CON TRASTORNO PSICÓTICO PRIMARIO Y DEBIDOS A ÉL"
  },
  {
    "codigo":298771008,
    "descripcion":"ARTICULACIÓN DE HOMBRO - TUMEFACCIÓN SINOVIAL"
  },
  {
    "codigo":15635371000119105,
    "descripcion":"BEBÉ PREMATURO, 33 SEMANAS"
  },
  {
    "codigo":428008002,
    "descripcion":"INFERTILIDAD FEMENINA DEBIDA A EDAD MATERNA AVANZADA"
  },
  {
    "codigo":1279976003,
    "descripcion":"COMPRESIÓN DE NERVIO OBTURADOR"
  },
  {
    "codigo":1148904003,
    "descripcion":"SEMINOMA ESPERMATOCÍTICO DE TESTÍCULO"
  },
  {
    "codigo":39611000087109,
    "descripcion":"LUXACIÓN TRAUMÁTICA DE ARTICULACIÓN PERISEMILUNAR DE MUÑECA DERECHA"
  },
  {
    "codigo":721085000,
    "descripcion":"SÍNDROME DE SORDERA, HIPOPLASIA DEL ESMALTE DENTAL Y DEFECTO UNGUEAL"
  },
  {
    "codigo":722920009,
    "descripcion":"SOPLO CARDÍACO INOCENTE NEONATAL"
  },
  {
    "codigo":426173002,
    "descripcion":"VARIABILIDAD ACENTUADA DE LA FRECUENCIA CARDÍACA FETAL"
  },
  {
    "codigo":1343677007,
    "descripcion":"MONONEUROPATÍA DE EXTREMIDAD SUPERIOR IZQUIERDA"
  },
  {
    "codigo":63890001,
    "descripcion":"OSTEOGÉNESIS IMPERFECTA CON ESCLERÓTICAS AZULES Y DENTINOGÉNESIS IMPERFECTA"
  },
  {
    "codigo":293266004,
    "descripcion":"REACCIÓN ADVERSA A LA TIROXINA"
  },
  {
    "codigo":424338005,
    "descripcion":"RETINOPATÍA POR HIDROCLOROQUINA"
  },
  {
    "codigo":719250005,
    "descripcion":"ATAXIA ESPINOCEREBELOSA TIPO 18"
  },
  {
    "codigo":10939461000119104,
    "descripcion":"HERIDA PUNZANTE DE REGIÓN DE HOMBRO DERECHO"
  },
  {
    "codigo":94823005,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE EPIDÍDIMO"
  },
  {
    "codigo":782951006,
    "descripcion":"SÍNDROME DE DISPLASIA TORÁCICA E HIDROCEFALIA"
  },
  {
    "codigo":1208935007,
    "descripcion":"POLIMICROGIRIA DEBIDA A MUTACIÓN EN GEN TUBB2B"
  },
  {
    "codigo":60220000,
    "descripcion":"AUSENCIA PARCIAL CONGÉNITA DE UNA EXTREMIDAD"
  },
  {
    "codigo":92988001,
    "descripcion":"COSTILLA TORCIDA CONGÉNITA"
  },
  {
    "codigo":289596002,
    "descripcion":"BARESTESIA EN VAGINA"
  },
  {
    "codigo":191292003,
    "descripcion":"TRASTORNO HEMORRÁGICO POR AUMENTO DE ANTI-10A"
  },
  {
    "codigo":1010492007,
    "descripcion":"AGENESIA DE PLIEGUE CUTÁNEO INTERFALÁNGICO DISTAL DE DEDO ANULAR"
  },
  {
    "codigo":386065001,
    "descripcion":"TRASTORNO RELACIONADO CON LA VITAMINA C"
  },
  {
    "codigo":25617003,
    "descripcion":"OBSTRUCCIÓN DUODENAL CONGÉNITA POR ROTACIÓN ANÓMALA DEL INTESTINO"
  },
  {
    "codigo":254993006,
    "descripcion":"LIPOSARCOMA DE ÓRBITA"
  },
  {
    "codigo":713745007,
    "descripcion":"REACTIVO PARA ANTICUERPOS ANTI-VIRUS DE LA INMUNODEFICIENCIA HUMANA Y ANTÍGENO P24"
  },
  {
    "codigo":123921008,
    "descripcion":"INTOXICACIÓN POR ZYGOPHYLLACEAE"
  },
  {
    "codigo":89318001,
    "descripcion":"ÚTERO PROLAPSADO CONGÉNITO"
  },
  {
    "codigo":416998004,
    "descripcion":"DISFUNCIÓN SOMÁTICA DE LIGAMENTO"
  },
  {
    "codigo":187622006,
    "descripcion":"NEOPLASIA MALIGNA DE MEMBRANA MUCOSA DE LABIO"
  },
  {
    "codigo":285926007,
    "descripcion":"NO LLENA EL LAVABO"
  },
  {
    "codigo":253158009,
    "descripcion":"HIDRANENCEFALIA CON VASCULOPATÍA PROLIFERATIVA"
  },
  {
    "codigo":1268966009,
    "descripcion":"GLIOMATOSIS CEREBRAL PRIMARIA"
  },
  {
    "codigo":447931005,
    "descripcion":"SEPSIS CLÍNICA"
  },
  {
    "codigo":85648000,
    "descripcion":"HIPOSMOLARIDAD"
  },
  {
    "codigo":318841000119100,
    "descripcion":"ARTRITIS REUMATOIDEA SEROPOSITIVA DE ARTICULACIÓN DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":413328008,
    "descripcion":"TRANSFERENCIA FUERA DEL ÁREA"
  },
  {
    "codigo":249488009,
    "descripcion":"ARCADAS"
  },
  {
    "codigo":446096008,
    "descripcion":"RINITIS ALÉRGICA PERENNE"
  },
  {
    "codigo":216720008,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR HERBICIDAS"
  },
  {
    "codigo":247653006,
    "descripcion":"PENSAMIENTOS AUTOMÁTICOS NEGATIVOS"
  },
  {
    "codigo":1263461006,
    "descripcion":"DISTIQUIASIS AISLADA CONGÉNITA"
  },
  {
    "codigo":1228858000,
    "descripcion":"OSTEOCONDRODISPLASIA LETAL COMPLEJA"
  },
  {
    "codigo":83813007,
    "descripcion":"DIETA PARA ALIMENTACIÓN POR SONDA NASOGÁSTRICA"
  },
  {
    "codigo":737338002,
    "descripcion":"ABSTINENCIA DE CANABINOIDE SINTÉTICO"
  },
  {
    "codigo":11787641000119102,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE DEDO DE MANO DERECHA CON INFECCIÓN"
  },
  {
    "codigo":16442005,
    "descripcion":"LEONTIASIS ÓSEA"
  },
  {
    "codigo":409658007,
    "descripcion":"QUISTE PROSTÁTICO"
  },
  {
    "codigo":278586008,
    "descripcion":"PUENTE DENTAL MUY CLARO"
  },
  {
    "codigo":14607001,
    "descripcion":"INTOXICACIÓN POR ETAMBUTOL"
  },
  {
    "codigo":47375003,
    "descripcion":"INFECCIÓN LOCALIZADA POR SALMONELLA"
  },
  {
    "codigo":735503004,
    "descripcion":"QUEMADURA PROFUNDA DE ESPESOR PARCIAL DE PERINEO"
  },
  {
    "codigo":211215005,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN EL HOMBRO"
  },
  {
    "codigo":276751004,
    "descripcion":"MELANOMA AMELANÓTICO MALIGNO DE LA PIEL"
  },
  {
    "codigo":473359008,
    "descripcion":"TROMBO DE AURÍCULA DERECHA"
  },
  {
    "codigo":309519009,
    "descripcion":"TROMBO VENTRICULAR IZQUIERDO"
  },
  {
    "codigo":1259791009,
    "descripcion":"ENFERMEDAD DE PAGET INVASIVA PRIMARIA DE VULVA"
  },
  {
    "codigo":12772003,
    "descripcion":"VISIÓN PERIFÉRICA ANORMAL"
  },
  {
    "codigo":209380001,
    "descripcion":"FRACTURA-SUBLUXACIÓN EXPUESTA DE ARTICULACIÓN SUBASTRAGALINA"
  },
  {
    "codigo":307684005,
    "descripcion":"PULSOS SACÁDICOS"
  },
  {
    "codigo":405988006,
    "descripcion":"EXTENSIÓN DEL COMPROMISO LINFOMATOSO NO ESPECIFICADA"
  },
  {
    "codigo":1290724007,
    "descripcion":"ARTRITIS REACTIVA DE ARTICULACIÓN RADIOCARPIANA"
  },
  {
    "codigo":78308008,
    "descripcion":"DETERMINACIÓN DEL RESULTADO: COMPLICACIÓN EVITABLE DERIVADA DE UN ERROR EN EL CRITERIO"
  },
  {
    "codigo":404153001,
    "descripcion":"INFILTRACIÓN LEUCÉMICA DE PIEL EN LEUCEMIA MIELOIDE CRÓNICA"
  },
  {
    "codigo":830137004,
    "descripcion":"DOLOR DEBIDO A AGRANDAMIENTO DEL BAZO"
  },
  {
    "codigo":402318000,
    "descripcion":"PSORIASIS AGRAVADA POR ACCIÓN DE LA LUZ"
  },
  {
    "codigo":305849009,
    "descripcion":"VISTO POR EL SERVICIO DE NUTRICIÓN"
  },
  {
    "codigo":369550002,
    "descripcion":"NEOPLASIA MALIGNA QUE COMPROMETE TROMPA DE FALOPIO DERECHA POR PROPAGACIÓN DIRECTA DESDE CUELLO UTERINO"
  },
  {
    "codigo":1354425008,
    "descripcion":"OCLUSIÓN DE HEMIVENA RETINIANA INFERIOR"
  },
  {
    "codigo":205710004,
    "descripcion":"MOSAICO CON XXXXY"
  },
  {
    "codigo":41870008,
    "descripcion":"LACERACIÓN DE LA CORTEZA CEREBRAL CON HERIDA INTRACRANEAL ABIERTA Y PÉRDIDA DE CONSCIENCIA"
  },
  {
    "codigo":7267002,
    "descripcion":"CARÁCTER NARCISISTA"
  },
  {
    "codigo":429576000,
    "descripcion":"CAPTACIÓN ANORMAL DE MARCADOR EXTRACARDÍACO"
  },
  {
    "codigo":236643004,
    "descripcion":"VEJIGA URINARIA ALTAMENTE DISTENSIBLE"
  },
  {
    "codigo":302179005,
    "descripcion":"SOLICITUD DE SUBSIDIO RECHAZADA"
  },
  {
    "codigo":431416001,
    "descripcion":"DOLOR MENSTRUAL"
  },
  {
    "codigo":105571009,
    "descripcion":"PROBLEMA ESPIRITUAL"
  },
  {
    "codigo":5432003,
    "descripcion":"TRANSPOSICIÓN DE APÉNDICE ILEOCECAL"
  },
  {
    "codigo":440851000124100,
    "descripcion":"INGESTA INADECUADA DE YODO"
  },
  {
    "codigo":726328005,
    "descripcion":"LACERACIÓN DE MÚSCULO INTRÍNSECO DE PIE"
  },
  {
    "codigo":300344005,
    "descripcion":"VESÍCULA BILIAR AGRANDADA"
  },
  {
    "codigo":1119544003,
    "descripcion":"CONSTRICCIÓN SEVERA DE CAMPO VISUAL PERIFÉRICO"
  },
  {
    "codigo":267576008,
    "descripcion":"ENCEFALITIS, MIELITIS Y ENCEFALOMIELITIS"
  },
  {
    "codigo":396813000,
    "descripcion":"MARGEN QUIRÚRGICO DEL PROCESO UNCIFORME DEL PÁNCREAS COMPROMETIDO POR NEOPLASIA MALIGNA"
  },
  {
    "codigo":724493008,
    "descripcion":"FÍSTULA VESICOVAGINAL CON COMPROMISO DEL MECANISMO DE CONTINENCIA URINARIA POSTERIOR A PROCEDIMIENTO OBSTÉTRICO"
  },
  {
    "codigo":427746000,
    "descripcion":"TUMORACIÓN EN REGIÓN DE HOMBRO"
  },
  {
    "codigo":298509008,
    "descripcion":"AMPLITUD DE FLEXIÓN ACTIVA DE LA COLUMNA VERTEBRAL DORSAL, AUMENTADA"
  },
  {
    "codigo":296674004,
    "descripcion":"SOBREDOSIS DE CEFALEXINA"
  },
  {
    "codigo":722658006,
    "descripcion":"MENINGITIS POSTERIOR A PROCEDIMIENTO"
  },
  {
    "codigo":34530006,
    "descripcion":"INTENTO FALLIDO DE ABORTO CON DESEQUILIBRIO ELECTROLÍTICO"
  },
  {
    "codigo":294839001,
    "descripcion":"ALERGIA A CALCITONINA"
  },
  {
    "codigo":720823003,
    "descripcion":"VÍCTIMA DE NEGLIGENCIA EN LA LACTANCIA"
  },
  {
    "codigo":32695006,
    "descripcion":"INTOXICACIÓN POR ÁCIDO ARSANÍLICO"
  },
  {
    "codigo":360375007,
    "descripcion":"GASTRITIS LINFOCÍTICA"
  },
  {
    "codigo":161932002,
    "descripcion":"TOS MATUTINA"
  },
  {
    "codigo":63628002,
    "descripcion":"INTOXICACIÓN CAUSADA POR ACETAZOLAMIDA"
  },
  {
    "codigo":293004005,
    "descripcion":"REACCIÓN ADVERSA A LA CEFUROXIMA"
  },
  {
    "codigo":129164007,
    "descripcion":"LUXACIÓN TRAUMÁTICA DE LA ARTICULACIÓN SACROCOCCÍGEA"
  },
  {
    "codigo":1144972008,
    "descripcion":"NEFRITIS TUBULOINTERSTICIAL AGUDA DEBIDA A TRASTORNO DE LA FUNCIÓN INMUNOLÓGICA"
  },
  {
    "codigo":782689003,
    "descripcion":"PSEUDOARTROSIS CONGÉNITA DE MIEMBRO"
  },
  {
    "codigo":127329003,
    "descripcion":"ANOMALÍA CONGÉNITA DEL APARATO VISUAL"
  },
  {
    "codigo":94561004,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA PIEL DE LA CADERA"
  },
  {
    "codigo":225633003,
    "descripcion":"MIEDO A LAS TORMENTAS"
  },
  {
    "codigo":291169007,
    "descripcion":"INTOXICACIÓN POR PERICIAZINA"
  },
  {
    "codigo":289334001,
    "descripcion":"HALLAZGO RELACIONADO CON EL PINZAMIENTO DE CORDÓN UMBILICAL"
  },
  {
    "codigo":387638003,
    "descripcion":"TUMEFACCIÓN ARTICULAR DOLOROSA"
  },
  {
    "codigo":1010230003,
    "descripcion":"HIPOACUSIA NEURAL DE OÍDO DERECHO"
  },
  {
    "codigo":715318006,
    "descripcion":"SÍNDROME DE EHLERS-DANLOS, TIPO CLÁSICO"
  },
  {
    "codigo":92726006,
    "descripcion":"CARCINOMA IN SITU DE LA PIEL DEL PIE"
  },
  {
    "codigo":254731001,
    "descripcion":"MELANOMA MALIGNO NODULAR DE LA PIEL"
  },
  {
    "codigo":123659003,
    "descripcion":"ROTACIÓN PATOLÓGICA CONGÉNITA DEL CORAZÓN"
  },
  {
    "codigo":58123006,
    "descripcion":"INTENTO FALLIDO DE ABORTO CON EMBOLIA PULMONAR"
  },
  {
    "codigo":713483007,
    "descripcion":"RETICULOSARCOMA CONCOMITANTE CON INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":90891007,
    "descripcion":"ENTEROCOLITIS ISQUÉMICA"
  },
  {
    "codigo":1268704000,
    "descripcion":"MESOTELIOMA MALIGNO PRIMARIO DE PLEURA"
  },
  {
    "codigo":23520002,
    "descripcion":"PRESIÓN VENOSA DISMINUIDA"
  },
  {
    "codigo":251061000,
    "descripcion":"NECROSIS MIOCÁRDICA"
  },
  {
    "codigo":449504009,
    "descripcion":"SEPSIS DEBIDA A STREPTOCOCCUS PYOGENES"
  },
  {
    "codigo":283829002,
    "descripcion":"MORDEDURA DE ANIMAL EN LA PANTORRILLA"
  },
  {
    "codigo":447669002,
    "descripcion":"HIPOPLASIA DE CORAZÓN IZQUIERDO SIN ESTENOSIS VALVULAR INTRÍNSECA Y SIN ATRESIA"
  },
  {
    "codigo":19850005,
    "descripcion":"ÚLCERA GÁSTRICA AGUDA PERFORADA"
  },
  {
    "codigo":312927001,
    "descripcion":"RETINOPATÍA CRISTALINA DE BIETTI"
  },
  {
    "codigo":83551002,
    "descripcion":"HALOS VISUALES"
  },
  {
    "codigo":247391003,
    "descripcion":"NEURALGIA DE NERVIO DE PERINEO"
  },
  {
    "codigo":280159008,
    "descripcion":"OSTEOGÉNESIS IMPERFECTA TIPO IV A"
  },
  {
    "codigo":704308002,
    "descripcion":"DIFICULTAD EN EL MANEJO DE DIÁLISIS PERITONEAL"
  },
  {
    "codigo":1163060002,
    "descripcion":"ENCEFALITIS POR VIRUS DE LOS MURCIÉLAGOS DE LAGOS"
  },
  {
    "codigo":442164004,
    "descripcion":"APNEA DEL SUEÑO DE CAUSA ORGÁNICA"
  },
  {
    "codigo":1259529001,
    "descripcion":"DEMENCIA DEBIDA A ENFERMEDAD DE CREUTZFELDT-JAKOB ESPORÁDICA"
  },
  {
    "codigo":210953003,
    "descripcion":"SECUELAS POR LESIÓN CRANEOENCEFÁLICA SUPERFICIAL"
  },
  {
    "codigo":309257005,
    "descripcion":"PÉRDIDA DE PESO EXCESIVA"
  },
  {
    "codigo":14345008,
    "descripcion":"CONFLICTO ENTRE PADRES E HIJOS"
  },
  {
    "codigo":897246002,
    "descripcion":"CURVATURA ANORMAL DE FALANGE MEDIA DE CUARTO DEDO DE PIE"
  },
  {
    "codigo":274654003,
    "descripcion":"VERBORRAGIA Y DETALLES CIRCUNSTANCIALES QUE ENMASCARAN EL MOTIVO DE CONSULTA"
  },
  {
    "codigo":241886004,
    "descripcion":"EFECTO TÓXICO CAUSADO POR LÍQUIDO ANTIHUMEDAD"
  },
  {
    "codigo":78046005,
    "descripcion":"MIOCARDITIS CAUSADA POR VIRUS INFLUENZA"
  },
  {
    "codigo":372958003,
    "descripcion":"INFECCIÓN CAUSADA POR PENICILLIUM MYCETOMAGENUM"
  },
  {
    "codigo":733406007,
    "descripcion":"FRACTURA DE TUBEROSIDAD MAYOR DE HÚMERO"
  },
  {
    "codigo":76211000,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA VENA ILÍACA"
  },
  {
    "codigo":10675001,
    "descripcion":"FRECUENCIA NORMAL DEL PULSO"
  },
  {
    "codigo":209118008,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN ESTERNOCLAVICULAR, ANTERIOR"
  },
  {
    "codigo":15935061000119100,
    "descripcion":"SUPERPOSICIÓN ADQUIRIDA DE DEDOS DE PIE IZQUIERDO"
  },
  {
    "codigo":371123004,
    "descripcion":"ABRASIÓN CONJUNTIVAL INFECTADA"
  },
  {
    "codigo":1092181000119102,
    "descripcion":"CUERPO EXTRAÑO RETENIDO EN OÍDO MEDIO DERECHO"
  },
  {
    "codigo":298581000119103,
    "descripcion":"OSTEONECROSIS DE HUESO DE MANO CAUSADA POR FÁRMACO"
  },
  {
    "codigo":116821000119104,
    "descripcion":"LINFOMA NO-HODGKIN DEL SISTEMA NERVIOSO CENTRAL CON METÁSTASIS A GANGLIO LINFÁTICO DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":8840000,
    "descripcion":"FRACTURA NO EXPUESTA A NIVEL DE C1 - C4 CON LESIÓN TRAUMÁTICA DE LA MÉDULA ESPINAL"
  },
  {
    "codigo":1087061000119106,
    "descripcion":"NEUMONÍA GONOCÓCICA"
  },
  {
    "codigo":16370261000119105,
    "descripcion":"TRASTORNO DEBIDO A TRASPLANTE DE CÉLULAS MADRE Y POSTERIOR A ÉL"
  },
  {
    "codigo":698803006,
    "descripcion":"CEFALEA POR USO EXCESIVO DE MEDICAMENTOS"
  },
  {
    "codigo":762504005,
    "descripcion":"PATRÓN DE USO NOCIVO DE CATINONA SINTÉTICA"
  },
  {
    "codigo":16265301000119106,
    "descripcion":"TRASTORNO DEPRESIVO MAYOR RECURRENTE CONCOMITANTE CON ANSIEDAD EN REMISIÓN COMPLETA"
  },
  {
    "codigo":15960661000119107,
    "descripcion":"ANGINA INESTABLE CONCOMITANTE CON ARTERIOESCLEROSIS DE INJERTO PUENTE DE ARTERIA CORONARIA Y DEBIDA A ELLA"
  },
  {
    "codigo":403891008,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS DEL CUERO CABELLUDO"
  },
  {
    "codigo":63061000119104,
    "descripcion":"FISURA DE LABIO FETAL"
  },
  {
    "codigo":308821000119109,
    "descripcion":"GOTA DE RODILLA DEBIDA A DISFUNCIÓN RENAL"
  },
  {
    "codigo":98901000119106,
    "descripcion":"MUCOSITIS ULCEROSA NO DEBIDA A TRATAMIENTO ANTINEOPLÁSICO"
  },
  {
    "codigo":16470101000119107,
    "descripcion":"INCONTINENCIA URINARIA DEBIDA A ACCIDENTE CEREBROVASCULAR Y POSTERIOR A ÉL"
  },
  {
    "codigo":301917001,
    "descripcion":"GLOBO OCULAR PRESENTE"
  },
  {
    "codigo":10850901000119109,
    "descripcion":"ASPIRACIÓN DE CONTENIDO GÁSTRICO HACIA NASOFARINGE"
  },
  {
    "codigo":7005004,
    "descripcion":"INTOXICACIÓN POR CICUTA"
  },
  {
    "codigo":432989008,
    "descripcion":"REACCIÓN ALÉRGICA CAUSADA POR TINTA DE TATUAJE"
  },
  {
    "codigo":234546001,
    "descripcion":"DEFICIENCIA DE INMUNOGLOBULINA G2"
  },
  {
    "codigo":365618006,
    "descripcion":"HEMATÓCRITO, NIVEL DE ERITROCITOS SEDIMENTADOS - HALLAZGO"
  },
  {
    "codigo":201778008,
    "descripcion":"ARTRITIS REUMATOIDE DE LA ARTICULACIÓN TIBIOPERONEA"
  },
  {
    "codigo":134407002,
    "descripcion":"DORSALGIA CRÓNICA"
  },
  {
    "codigo":298247002,
    "descripcion":"ARTICULACIÓN SACROILÍACA ESTABLE"
  },
  {
    "codigo":198108005,
    "descripcion":"INFECCIÓN DE LA MAMA"
  },
  {
    "codigo":787932009,
    "descripcion":"TRASTORNO DE RAMA GÁSTRICA DE NERVIO VAGO"
  },
  {
    "codigo":294577001,
    "descripcion":"ALERGIA A SULFAGUANIDINA"
  },
  {
    "codigo":34268009,
    "descripcion":"FRACTURA NO EXPUESTA DE MALÉOLO EXTERNO"
  },
  {
    "codigo":196273001,
    "descripcion":"DIENTE SUPLEMENTARIO"
  },
  {
    "codigo":292742002,
    "descripcion":"REACCIÓN ADVERSA AL POLVO DE BENTONITA"
  },
  {
    "codigo":1144710004,
    "descripcion":"HIPOPLASIA DE FALANGE DISTAL DE SEGUNDO DEDO DE PIE"
  },
  {
    "codigo":225371000,
    "descripcion":"UTILIZA ANTICONCEPCIÓN NATURAL"
  },
  {
    "codigo":94299007,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LOS GANGLIOS LINFÁTICOS FEMORALES"
  },
  {
    "codigo":127067009,
    "descripcion":"NEUTROFILIA POR ESTRÉS"
  },
  {
    "codigo":1090121000119100,
    "descripcion":"EDENTULISMO PARCIAL CLASE II DEBIDO A ENFERMEDAD PERIODONTAL"
  },
  {
    "codigo":1237509001,
    "descripcion":"SÍNDROME DE DESCAMACIÓN CUTÁNEA, LEUCONIQUIA, QUERATOSIS PUNCTATA ACRAL, QUEILITIS Y ALMOHADILLAS DE NUDILLOS"
  },
  {
    "codigo":25093002,
    "descripcion":"ENFERMEDAD OCULAR DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":92464009,
    "descripcion":"NEOPLASIA BENIGNA DE URÉTER"
  },
  {
    "codigo":254469005,
    "descripcion":"NEOPLASIA DE CAVIDAD TIMPÁNICA"
  },
  {
    "codigo":188933009,
    "descripcion":"NEOPLASIA BENIGNA DE LA APÓFISIS XIFOIDES"
  },
  {
    "codigo":16026031000119109,
    "descripcion":"MALFORMACIÓN ARTERIOVENOSA CONGÉNITA DE MIEMBRO INFERIOR DERECHO"
  },
  {
    "codigo":56026007,
    "descripcion":"PUERPERIO TARDÍO"
  },
  {
    "codigo":283567006,
    "descripcion":"HERIDA DE PERDIGÓN EN DORSO DE LA MANO"
  },
  {
    "codigo":185263007,
    "descripcion":"ATENDIDO EN UN CONSULTORIO GERIÁTRICO"
  },
  {
    "codigo":840623009,
    "descripcion":"CICATRIZ DE PIEL DEBIDA A INFECCIÓN SUPURATIVA"
  },
  {
    "codigo":414639009,
    "descripcion":"HALO PERIMACULAR"
  },
  {
    "codigo":19588001,
    "descripcion":"ERITROCITOSIS POR HIPOXEMIA TISULAR"
  },
  {
    "codigo":443737000,
    "descripcion":"RESPIRADOR CERVICAL TOTAL LUEGO DE LARINGECTOMÍA"
  },
  {
    "codigo":771417007,
    "descripcion":"DISFUNCIÓN COGNITIVA LUEGO DE PROCEDIMIENTO QUIRÚRGICO"
  },
  {
    "codigo":736814000,
    "descripcion":"CONSENTIMIENTO OTORGADO PARA PARTICIPACIÓN EN ESTUDIO DE OBSERVACIÓN"
  },
  {
    "codigo":1162798000,
    "descripcion":"FOSFATASA ALCALINA PLACENTARIA POR DEBAJO DE RANGO DE REFERENCIA"
  },
  {
    "codigo":866051002,
    "descripcion":"ENFERMEDAD DE LA NEURONA MOTORA DEBIDA A INTOXICACIÓN POR PLOMO"
  },
  {
    "codigo":472835004,
    "descripcion":"CALCIFICACIÓN DE VÁLVULA TRICÚSPIDE"
  },
  {
    "codigo":276227005,
    "descripcion":"CHOQUE REFRACTARIO"
  },
  {
    "codigo":1193731009,
    "descripcion":"INFLAMACIÓN DE INTESTINO CAUSADA POR ACTINOMYCES"
  },
  {
    "codigo":79619009,
    "descripcion":"ESTENOSIS DE VÁLVULA MITRAL"
  },
  {
    "codigo":733144006,
    "descripcion":"NEOPLASIA EPITELIAL MALIGNA DE BRONQUIO"
  },
  {
    "codigo":272557000,
    "descripcion":"SENTADO SOBRE BANQUITO EN EL AGUA"
  },
  {
    "codigo":700376009,
    "descripcion":"RUPTURA AGUDA DE TENDÓN DE AQUILES"
  },
  {
    "codigo":239789002,
    "descripcion":"ARTROPATÍA POSINMUNIZACIÓN"
  },
  {
    "codigo":403629000,
    "descripcion":"PENFIGOIDE BULLOSO MEDICAMENTOSO"
  },
  {
    "codigo":698541007,
    "descripcion":"REQUIERE DISPOSITIVO DE ORTODONCIA INFERIOR FIJO"
  },
  {
    "codigo":237954000,
    "descripcion":"DEFICIENCIA DE 2-METILACETOACETIL-COA TIOLASA MITOCONDRIAL- NO ESTIMULADA POR POTASIO"
  },
  {
    "codigo":203351003,
    "descripcion":"ENFERMEDAD DE PAGET DEL CRÁNEO"
  },
  {
    "codigo":236119003,
    "descripcion":"ESTENOSIS DE UN ESTOMA"
  },
  {
    "codigo":399959003,
    "descripcion":"SÍNDROME DE ENVEJECIMIENTO PREMATURO"
  },
  {
    "codigo":1153623003,
    "descripcion":"NEUROPATÍA METABÓLICA"
  },
  {
    "codigo":365356004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA CRUZAR LA CALLE"
  },
  {
    "codigo":430892004,
    "descripcion":"RUPTURA DE LIGAMENTO ESCAFOSEMILUNAR DE LA MUÑECA"
  },
  {
    "codigo":103212007,
    "descripcion":"PRODUCCIÓN DE MEGACARIOCITOS AUMENTADA"
  },
  {
    "codigo":299820009,
    "descripcion":"REFLEJO AUROPALPEBRAL AUSENTE"
  },
  {
    "codigo":683031000119101,
    "descripcion":"CARCINOMA PRIMARIO EX ADENOMA PLEOMÓRFICO DE GLÁNDULA SALIVAL"
  },
  {
    "codigo":232449005,
    "descripcion":"ATROFIA POSMENOPÁUSICA DE CUERDA VOCAL"
  },
  {
    "codigo":297985006,
    "descripcion":"HALLAZGO RELACIONADO CON EL COLOR DEL LECHO UNGUEAL"
  },
  {
    "codigo":3073006,
    "descripcion":"SÍNDROME DE RUVALCABA"
  },
  {
    "codigo":68609006,
    "descripcion":"TRICORREXIS"
  },
  {
    "codigo":66774001,
    "descripcion":"INTOXICACIÓN POR CUCUMIS"
  },
  {
    "codigo":230614002,
    "descripcion":"LESIÓN DE LA COLA DE CABALLO"
  },
  {
    "codigo":296150003,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE BUSPIRONA"
  },
  {
    "codigo":32171005,
    "descripcion":"INTOXICACIÓN POR PHYTOLACCA AMERICANA"
  },
  {
    "codigo":785835006,
    "descripcion":"PERITONITIS DEBIDA A ABSCESO"
  },
  {
    "codigo":292480002,
    "descripcion":"REACCIÓN ADVERSA AL CLORHIDRATO DE ISOETARINA"
  },
  {
    "codigo":423552003,
    "descripcion":"IRIDOTOMÍA PERIFÉRICA PERMEABLE"
  },
  {
    "codigo":95872005,
    "descripcion":"INTOXICACIÓN POR MONÓXIDO DE CARBONO DEL ESCAPE DE LOS VEHÍCULOS DE MOTOR"
  },
  {
    "codigo":15729841000119100,
    "descripcion":"NÓDULOS DE HEBERDEN BILATERALES"
  },
  {
    "codigo":30336007,
    "descripcion":"ESQUIZOFRENIA RESIDUAL CRÓNICA CON EXACERBACIONES AGUDAS"
  },
  {
    "codigo":1144448008,
    "descripcion":"APLASIA DE FALANGE DISTAL DE DEDO MEDIO"
  },
  {
    "codigo":11987991000119107,
    "descripcion":"QUEMADURA EPIDÉRMICA DE MUÑECA DERECHA"
  },
  {
    "codigo":94037002,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA PIEL DEL HUECO POPLÍTEO"
  },
  {
    "codigo":126805009,
    "descripcion":"NEOPLASIA DEL PALADAR"
  },
  {
    "codigo":782165009,
    "descripcion":"ENOSTOSIS DE PELVIS IZQUIERDA"
  },
  {
    "codigo":288810006,
    "descripcion":"DIFICULTAD PARA SALUDAR"
  },
  {
    "codigo":59434007,
    "descripcion":"INTOXICACIÓN POR ASCLEPIAS"
  },
  {
    "codigo":92202008,
    "descripcion":"NEOPLASIA BENIGNA DE LOS GANGLIOS LINFÁTICOS DEL CUELLO"
  },
  {
    "codigo":876799007,
    "descripcion":"REACCIÓN ADVERSA A BENSERAZIDA Y\/O LEVODOPA"
  },
  {
    "codigo":254207007,
    "descripcion":"NEVO VASCULAR RETICULADO"
  },
  {
    "codigo":22996003,
    "descripcion":"INFARTO ESPLÉNICO"
  },
  {
    "codigo":416212005,
    "descripcion":"INFECCIÓN CAUSADA POR TOXASCARIS"
  },
  {
    "codigo":283305002,
    "descripcion":"ASTILLA DE MADERA EN GLÚTEO"
  },
  {
    "codigo":250537006,
    "descripcion":"HISTOPATOLOGÍA - HALLAZGO"
  },
  {
    "codigo":414377007,
    "descripcion":"SIGNO DE HAMMAN"
  },
  {
    "codigo":709289008,
    "descripcion":"NEOPLASIA DE VÉRTEBRA"
  },
  {
    "codigo":772990001,
    "descripcion":"TIENE INSTRUMENTOS QUIRÚRGICOS EN CUARENTENA"
  },
  {
    "codigo":53929009,
    "descripcion":"MASA DE ESCROTO"
  },
  {
    "codigo":445310002,
    "descripcion":"OBSTRUCCIÓN DEL TRACTO DE SALIDA DEL VENTRÍCULO IZQUIERDO POR DIAFRAGMA"
  },
  {
    "codigo":248702003,
    "descripcion":"NEUMOTÓRAX CON CHASQUIDO"
  },
  {
    "codigo":707454002,
    "descripcion":"CARCINOMA BASALOIDE PRIMARIO DE CÉLULAS ESCAMOSAS DE PULMÓN"
  },
  {
    "codigo":838526006,
    "descripcion":"INTOXICACIÓN INTENCIONAL CAUSADA POR METILENDIOXIMETANFETAMINA"
  },
  {
    "codigo":1297278009,
    "descripcion":"CELULITIS DE DEDO MEDIO DE MANO"
  },
  {
    "codigo":115795001,
    "descripcion":"FENOTIPO P>1<"
  },
  {
    "codigo":17491008,
    "descripcion":"FACTOR PSICOSOMÁTICO EN UNA ENFERMEDAD FÍSICA, COMPONENTE PSICOLÓGICO MENOR"
  },
  {
    "codigo":441640001,
    "descripcion":"PRESENTACIÓN CEFÁLICA DE VÉRTICE CON TUMOR SEROSANGUÍNEO DEL CUERO CABELLUDO"
  },
  {
    "codigo":246867008,
    "descripcion":"SACO LAGRIMAL - HALLAZGO"
  },
  {
    "codigo":212264004,
    "descripcion":"LESIÓN CERRADA DE RAMA MOTORA PROFUNDA DE NERVIO CUBITAL"
  },
  {
    "codigo":310568005,
    "descripcion":"ENFERMEDAD DE LYME DETECTADA POR PRUEBA DE INMUNOTRANSFERENCIA"
  },
  {
    "codigo":12400101000119100,
    "descripcion":"TRAUMATISMO ACÚSTICO EXPLOSIVO DE OÍDO DERECHO"
  },
  {
    "codigo":48424004,
    "descripcion":"CONTUSIÓN DE PULMÓN SIN HERIDA ABIERTA HACIA TÓRAX"
  },
  {
    "codigo":15656008,
    "descripcion":"DIAGNÓSTICO MORFOLÓGICO DIFERIDO"
  },
  {
    "codigo":210429002,
    "descripcion":"HERIDA ABIERTA DEL ESCROTO Y LOS TESTÍCULOS"
  },
  {
    "codigo":863954001,
    "descripcion":"CARDIOTOXICIDAD"
  },
  {
    "codigo":685541000119103,
    "descripcion":"CARCINOMA DE CÉLULAS GRANDES PRIMARIO DE BRONQUIO PRINCIPAL"
  },
  {
    "codigo":77522006,
    "descripcion":"EPIESCLERITIS REUMATOIDE"
  },
  {
    "codigo":372434007,
    "descripcion":"MARGEN LATERAL DERECHO DE RESECCIÓN QUIRÚRGICA, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":763815000,
    "descripcion":"SÍNDROME OCULOAURICULAR TIPO SCHORDERET"
  },
  {
    "codigo":110290008,
    "descripcion":"RESPIRACIÓN BUCAL DEBIDA A OBSTRUCCIÓN NASAL"
  },
  {
    "codigo":698279003,
    "descripcion":"DISTONÍA-PARKINSONISMO LIGADA AL CROMOSOMA X"
  },
  {
    "codigo":1255335006,
    "descripcion":"SÍNDROME DE DISCAPACIDAD INTELECTUAL, TALLA BAJA, SOBREPESO LIGADO AL CROMOSOMA X"
  },
  {
    "codigo":403367007,
    "descripcion":"DERMATITIS PERIBUCAL CON DERMATITIS PERIOCULAR"
  },
  {
    "codigo":204924000,
    "descripcion":"QUISTE DE CONDUCTO DE WOLFF - MASCULINO"
  },
  {
    "codigo":237692001,
    "descripcion":"DEFICIENCIA DE ACTH"
  },
  {
    "codigo":1351804000,
    "descripcion":"INMUNODEFICIENCIA COMBINADA AUTOSÓMICA RECESIVA DEBIDA A MUTACIÓN DE PAX1"
  },
  {
    "codigo":203089001,
    "descripcion":"INFECCIÓN DEL ESPACIO HIPOTENAR PALMAR"
  },
  {
    "codigo":10735231000119101,
    "descripcion":"ADENOSIS ESCLEROSANTE DE MAMA IZQUIERDA"
  },
  {
    "codigo":6481005,
    "descripcion":"DIPLEJÍA"
  },
  {
    "codigo":1153361007,
    "descripcion":"OSTEOMALACIA DEL ADULTO DEBIDA A ENFERMEDAD HEPÁTICA"
  },
  {
    "codigo":301393008,
    "descripcion":"DOLOR A LA PALPACIÓN EN ESTRUCTURA DIGESTIVA"
  },
  {
    "codigo":299558001,
    "descripcion":"HALLAZGO RELACIONADO CON LOS HUESOS DEL PIE"
  },
  {
    "codigo":39249009,
    "descripcion":"PLACENTITIS"
  },
  {
    "codigo":102950001,
    "descripcion":"RELACIÓN SEXUAL ABUSIVA"
  },
  {
    "codigo":365094006,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA EVITAR OBSTÁCULOS EN UN CAMINO"
  },
  {
    "codigo":1217062009,
    "descripcion":"AMENORREA HIPERHORMONAL"
  },
  {
    "codigo":428795003,
    "descripcion":"ANAFILAXIA CAUSADA POR VEGETALES"
  },
  {
    "codigo":164816000,
    "descripcion":"PRUEBA POSCOITAL NORMAL"
  },
  {
    "codigo":197584000,
    "descripcion":"NEFRITIS FOCAL AGUDA"
  },
  {
    "codigo":166651009,
    "descripcion":"NIVEL DE 5 - NUCLEOTIDASA SÉRICA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":15705881000119100,
    "descripcion":"DEPÓSITO DE CALCIO EN BOLSA SEROSA DE AMBOS CODOS"
  },
  {
    "codigo":230352008,
    "descripcion":"ENCEFALOPATÍA POR DEFICIENCIA VITAMÍNICA"
  },
  {
    "codigo":787408008,
    "descripcion":"SÍNDROME DE OSTEOPATÍA ESTRIADA, DERMOPATÍA PIGMENTARIA Y MECHÓN BLANCO"
  },
  {
    "codigo":15978111000119107,
    "descripcion":"HEMANGIOMA CAPILAR BILATERAL DE REGIONES ORBITARIAS"
  },
  {
    "codigo":228517005,
    "descripcion":"MASTICA TABACO CORTADO FINO"
  },
  {
    "codigo":292218000,
    "descripcion":"REACCIÓN ADVERSA A LA BLEOMICINA"
  },
  {
    "codigo":783738002,
    "descripcion":"SÍNDROME DE DEFECTO CARDÍACO, HAMARTOMA DE LENGUA Y POLISINDACTILIA"
  },
  {
    "codigo":30074005,
    "descripcion":"OBSTRUCCIÓN POR ESTRANGULACIÓN DEL INTESTINO"
  },
  {
    "codigo":95610008,
    "descripcion":"DAÑO CEREBRAL CONGÉNITO"
  },
  {
    "codigo":126543003,
    "descripcion":"NEOPLASIA DE HUESO ESFENOIDES"
  },
  {
    "codigo":61007003,
    "descripcion":"SEPARACIÓN DE LA SÍNFISIS DEL PUBIS DURANTE EL PARTO"
  },
  {
    "codigo":93775003,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE DUODENO"
  },
  {
    "codigo":192079006,
    "descripcion":"DEPRESIÓN POSVIRAL"
  },
  {
    "codigo":421455009,
    "descripcion":"ATAXIA EPISÓDICA"
  },
  {
    "codigo":290383009,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR PIRENZEPINA"
  },
  {
    "codigo":91940001,
    "descripcion":"ALERGIA A NUEZ"
  },
  {
    "codigo":124708004,
    "descripcion":"DEFICIENCIA DE FOSFORRIBOSILAMINOIMIDAZOL - SUCCINOCARBOXAMIDA SINTASA"
  },
  {
    "codigo":288548005,
    "descripcion":"CAPAZ DE REALIZAR ACTIVIDADES DE LAVADO Y SECADO DE SÍ MISMO"
  },
  {
    "codigo":190244006,
    "descripcion":"BOCIO UNINODULAR TÓXICO SIN CRISIS"
  },
  {
    "codigo":1204217000,
    "descripcion":"OCLUSIÓN ARTERIAL AGUDA POR TROMBOEMBOLISMO"
  },
  {
    "codigo":59172008,
    "descripcion":"ACNÉ PUSTULOSA"
  },
  {
    "codigo":712697004,
    "descripcion":"J9"
  },
  {
    "codigo":57337005,
    "descripcion":"ESTEATOPIGIA"
  },
  {
    "codigo":385017006,
    "descripcion":"PROPAGACIÓN EXTRAPROSTÁTICA TUMORAL INDETERMINADA"
  },
  {
    "codigo":286713005,
    "descripcion":"CARÁCTER CALMO"
  },
  {
    "codigo":253945009,
    "descripcion":"CRECIMIENTO EXCESIVO PARCIAL DE LA EXTREMIDAD INFERIOR"
  },
  {
    "codigo":284878004,
    "descripcion":"SE CORTA LAS UÑAS DE LOS PIES"
  },
  {
    "codigo":219342006,
    "descripcion":"LESIÓN POR INSTRUMENTO FILOSO, CON PROPÓSITO DESCONOCIDO"
  },
  {
    "codigo":1003939002,
    "descripcion":"POLIDACTILIA BILATERAL DE DEDO ÍNDICE"
  },
  {
    "codigo":709027003,
    "descripcion":"HALLAZGO RELACIONADO CON LA UBICACIÓN Y MAGNITUD DE REGIÓN EDÉNTULA DE LA CAVIDAD BUCAL"
  },
  {
    "codigo":283043006,
    "descripcion":"LESIÓN SUPERFICIAL DE QUINTO DEDO DEL PIE"
  },
  {
    "codigo":250275007,
    "descripcion":"HIPERSEGMENTACIÓN"
  },
  {
    "codigo":182904002,
    "descripcion":"FARMACOTERAPIA DESCONOCIDA"
  },
  {
    "codigo":1264248002,
    "descripcion":"CICATRIZ DE REGIÓN INFERIOR DE MUCOSA YUGAL IZQUIERDA"
  },
  {
    "codigo":248440004,
    "descripcion":"FIEBRE TERCIANA"
  },
  {
    "codigo":246605000,
    "descripcion":"NERVIO PERIFÉRICO - HALLAZGO"
  },
  {
    "codigo":707192009,
    "descripcion":"CONDICIÓN DE DIENTE PILAR, MÍNIMAMENTE COMPROMETIDA"
  },
  {
    "codigo":1295181006,
    "descripcion":"SÍNDROME AUTOINFLAMATORIO MULTIGÉNICO COMPLEJO"
  },
  {
    "codigo":703522009,
    "descripcion":"ENFERMEDAD DE GANGLIOS BASALES SENSIBLE A BIOTINA-TIAMINA"
  },
  {
    "codigo":699852000,
    "descripcion":"MIOBLASTOMA DE CÉLULAS GRANULARES DE LENGUA"
  },
  {
    "codigo":77260003,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE LA MEJILLA, SIN INFECCIÓN"
  },
  {
    "codigo":110028004,
    "descripcion":"FRACTURA MAXILAR EXPUESTA COMPLETA"
  },
  {
    "codigo":1156769000,
    "descripcion":"OSTEONECROSIS DE HUESO CAUSADA POR GLUCOCORTICOIDE"
  },
  {
    "codigo":698017003,
    "descripcion":"AL CUIDADO DE CABEZA DE FAMILIA DE SEXO MASCULINO"
  },
  {
    "codigo":9889004,
    "descripcion":"TIÑA DE LA BARBA POR TRICHOPHYTON VIOLACEUM"
  },
  {
    "codigo":403105006,
    "descripcion":"ONICOMICOSIS SUBUNGUEAL PROXIMAL"
  },
  {
    "codigo":1208883006,
    "descripcion":"DEBILIDAD DE TERCER NERVIO CRANEAL ADQUIRIDA"
  },
  {
    "codigo":302966002,
    "descripcion":"AMPOLLA TRAUMÁTICA DE PÁRPADO"
  },
  {
    "codigo":73590005,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO PERIFÉRICO"
  },
  {
    "codigo":366667001,
    "descripcion":"HALLAZGO EN LA REACCIÓN CUTÁNEA"
  },
  {
    "codigo":1251403002,
    "descripcion":"URTICARIA CRÓNICA DEBIDA A PSEUDOALERGIA"
  },
  {
    "codigo":268363004,
    "descripcion":"PRUEBA AUDITIVA\/VESTIBULAR ANORMAL"
  },
  {
    "codigo":364832000,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD DE REALIZAR GRANDES MOVIMIENTOS"
  },
  {
    "codigo":235595009,
    "descripcion":"ENFERMEDAD POR REFLUJO GASTROESOFÁGICO"
  },
  {
    "codigo":233760007,
    "descripcion":"SILICOSIS AGUDA"
  },
  {
    "codigo":231925004,
    "descripcion":"ARCO JUVENIL"
  },
  {
    "codigo":264693006,
    "descripcion":"TRASTORNO EL NERVIO VESTIBULAR"
  },
  {
    "codigo":10629351000119108,
    "descripcion":"MIOCARDITIS CAUSADA POR VIRUS INFLUENZA A"
  },
  {
    "codigo":788981009,
    "descripcion":"MENINGITIS CAUSADA POR TRYPANOSOMA BRUCEI RHODESIENSE"
  },
  {
    "codigo":262858002,
    "descripcion":"HEMATOMA DE APÉNDICE"
  },
  {
    "codigo":714002,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE DEDO DE PIE CON INFECCIÓN"
  },
  {
    "codigo":295626007,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE ETOGLÚCIDO"
  },
  {
    "codigo":293791003,
    "descripcion":"ALERGIA A FORMESTANO"
  },
  {
    "codigo":424863004,
    "descripcion":"LESIÓN TRAUMÁTICA CONTUSA DEL ABDOMEN"
  },
  {
    "codigo":31647004,
    "descripcion":"SIGNO DE GAENSLEN"
  },
  {
    "codigo":95348005,
    "descripcion":"CAMBIOS POSINFLAMATORIOS EN LA PIGMENTACIÓN DE LA PIEL"
  },
  {
    "codigo":128116006,
    "descripcion":"ENFERMEDAD INFECCIOSA DEL SISTEMA NERVIOSO"
  },
  {
    "codigo":717940006,
    "descripcion":"SÍNDROME DE NARIZ BÍFIDA, ANOMALÍA ANORRECTAL, ANOMALÍA RENAL"
  },
  {
    "codigo":291956009,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR AMIODARONA"
  },
  {
    "codigo":11831681000119107,
    "descripcion":"LESIÓN TRAUMÁTICA DE VASO SANGUÍNEO DE PULGAR DERECHO"
  },
  {
    "codigo":60745003,
    "descripcion":"DETERMINACIÓN DEL ESTADO DEL PACIENTE, MODERADA MEJORÍA"
  },
  {
    "codigo":1142089004,
    "descripcion":"HEMATOPOYESIS DÉRMICA EXTRAMEDULAR CONGÉNITA"
  },
  {
    "codigo":27977005,
    "descripcion":"PULSO VENOSO YUGULAR NORMAL"
  },
  {
    "codigo":290121003,
    "descripcion":"CONDUCTO GALACTÓFORO PALPABLE"
  },
  {
    "codigo":716105001,
    "descripcion":"QUERATODERMIA PALMOPLANTAR DIFUSA AUTOSÓMICA DOMINANTE TIPO NORRBOTTEN"
  },
  {
    "codigo":89843004,
    "descripcion":"QUEMADURA PROFUNDA DE TERCER GRADO DE MAMA"
  },
  {
    "codigo":417523004,
    "descripcion":"PÉRDIDA DE INTERÉS POR UNA ACTIVIDAD QUE ANTERIORMENTE DISFRUTABA"
  },
  {
    "codigo":286451006,
    "descripcion":"DIFICULTAD PARA MANEJAR RECIPIENTES DE ALIMENTO"
  },
  {
    "codigo":253683008,
    "descripcion":"CAYADO AÓRTICO INTERRUMPIDO ENTRE LAS ARTERIAS CARÓTIDA PRIMITIVA IZQUIERDA Y TRONCO BRAQUIOCEFÁLICO"
  },
  {
    "codigo":186312003,
    "descripcion":"MELIOIDOSIS CRÓNICA Y SUBAGUDA"
  },
  {
    "codigo":11805211000119106,
    "descripcion":"SUBLUXACIÓN DE ARTICULACIÓN INTERFALÁNGICA PROXIMAL DE DEDO MEÑIQUE DE MANO IZQUIERDA"
  },
  {
    "codigo":284616006,
    "descripcion":"CONDUCTA VERBALMENTE AMENAZANTE"
  },
  {
    "codigo":250013002,
    "descripcion":"MARCHA DE PIERNA RÍGIDA"
  },
  {
    "codigo":118941004,
    "descripcion":"TRASTORNO DE LOS ANEXOS OCULARES"
  },
  {
    "codigo":282781004,
    "descripcion":"LESIÓN TRAUMÁTICA DEL TÍMPANO"
  },
  {
    "codigo":15956661000119102,
    "descripcion":"CARCINOMA MICROCÍTICO METASTÁSICO DE PULMÓN DERECHO"
  },
  {
    "codigo":315549009,
    "descripcion":"NACIDO EN TUVALU"
  },
  {
    "codigo":84338002,
    "descripcion":"LACERACIÓN CARDÍACA CON PENETRACIÓN DE LAS CÁMARAS CARDÍACAS"
  },
  {
    "codigo":117106004,
    "descripcion":"UNIDAD DE HEMODERIVADO RECLAMADA"
  },
  {
    "codigo":280946004,
    "descripcion":"NEUROSIS OCUPACIONAL"
  },
  {
    "codigo":1296754005,
    "descripcion":"HIPERTENSIÓN OCULAR PRIMARIA DE AMBOS OJOS"
  },
  {
    "codigo":444786007,
    "descripcion":"INFECCIÓN DE HUESO DE RADIO Y\/O CÚBITO"
  },
  {
    "codigo":705095008,
    "descripcion":"ELEVACIÓN INFERIOR DERECHA DEL SEGMENTO ST"
  },
  {
    "codigo":770631009,
    "descripcion":"HIPOTIROIDISMO CONGÉNITO TRANSITORIO DE ORIGEN GENÉTICO"
  },
  {
    "codigo":1293084003,
    "descripcion":"TUMOR FIBROSO SOLITARIO DE PLEURA"
  },
  {
    "codigo":15132005,
    "descripcion":"DEFICIENCIA ADQUIRIDA DE FACTOR XII"
  },
  {
    "codigo":408348006,
    "descripcion":"CANTIDADES EQUIVALENTES PARA TODA LA MEDICACIÓN VERIFICADAS"
  },
  {
    "codigo":111601003,
    "descripcion":"HEMORRAGIA INTRACRANEAL CONCOMITANTE CON FRACTURA NO EXPUESTA DE BASE DE CRÁNEO Y DEBIDA A ELLA"
  },
  {
    "codigo":11834191000119102,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN METACARPOFALÁNGICA DE PULGAR DERECHO"
  },
  {
    "codigo":404678001,
    "descripcion":"INFECCIÓN CAUSADA POR STAPHYLOCOCCUS AUREUS RESISTENTE A GLUCOPÉPTIDOS"
  },
  {
    "codigo":275441009,
    "descripcion":"INFECCIÓN BACTERIANA SUPERFICIAL DE PIEL"
  },
  {
    "codigo":240838003,
    "descripcion":"NÓDULO SUBCUTÁNEO POR ONCHOCERCA"
  },
  {
    "codigo":109766007,
    "descripcion":"SIALOADENITIS DE LA GLÁNDULA SALIVAL MENOR"
  },
  {
    "codigo":306374007,
    "descripcion":"VISTO EN EL SERVICIO DE ORTODONCIA"
  },
  {
    "codigo":206235003,
    "descripcion":"LESIÓN DE NERVIO PERIFÉRICO POR TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":402843003,
    "descripcion":"LAGO VENOSO"
  },
  {
    "codigo":42395004,
    "descripcion":"INTOXICACIÓN POR CLOROTIAZIDA"
  },
  {
    "codigo":1156507003,
    "descripcion":"SOBREDOSIS INTENCIONAL DE AGONISTA DE RECEPTOR OPIOIDE"
  },
  {
    "codigo":16667471000119104,
    "descripcion":"FRACTURA NO EXPUESTA DE ARCO CIGOMÁTICO DERECHO"
  },
  {
    "codigo":7792000,
    "descripcion":"PLACENTA PREVIA SIN HEMORRAGIA"
  },
  {
    "codigo":271771009,
    "descripcion":"TUMEFACCIÓN ARTICULAR"
  },
  {
    "codigo":401008002,
    "descripcion":"DIFICULTAD PARA ESCUCHAR CON SONIDOS DE FONDO"
  },
  {
    "codigo":73328005,
    "descripcion":"INFECCIÓN CAUSADA POR DIROFILARIA"
  },
  {
    "codigo":300869001,
    "descripcion":"LA MASA NO SE MUEVE CON LA RESPIRACIÓN"
  },
  {
    "codigo":366405002,
    "descripcion":"COLUMNA DORSAL, AMPLITUD DE MOVIMIENTO - HALLAZGO"
  },
  {
    "codigo":169797001,
    "descripcion":"CRIBADO PARA SÍNDROME DE DOWN - SANGRE ENVIADA"
  },
  {
    "codigo":38725001,
    "descripcion":"ANQUILOSTOMIASIS CAUSADA POR ANQUILOSTOMA CEYLONICUM"
  },
  {
    "codigo":167962002,
    "descripcion":"PROTEÍNAS EN LÍQUIDO PLEURAL DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":299034005,
    "descripcion":"MANO EN GARRA"
  },
  {
    "codigo":35055000,
    "descripcion":"QUERATOPATÍA EN BANDA"
  },
  {
    "codigo":723183004,
    "descripcion":"AGANGLIONOSIS DE INTESTINO GRUESO"
  },
  {
    "codigo":297199006,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE OPIÁCEO"
  },
  {
    "codigo":295364000,
    "descripcion":"SOBREDOSIS DE RANITIDINA"
  },
  {
    "codigo":197060001,
    "descripcion":"VÓLVULO DE COLON SIGMOIDE"
  },
  {
    "codigo":452002,
    "descripcion":"AMPOLLA INGUINAL SIN INFECCIÓN"
  },
  {
    "codigo":721348002,
    "descripcion":"FRACTURA DE CUARTA VÉRTEBRA CERVICAL"
  },
  {
    "codigo":262596005,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE PULPEJO DE DEDO DE LA MANO"
  },
  {
    "codigo":360900008,
    "descripcion":"EX FUMADOR AGRESIVO"
  },
  {
    "codigo":129689002,
    "descripcion":"CON MAYOR RIESGO DE PROBLEMA NUTRICIONAL"
  },
  {
    "codigo":424601002,
    "descripcion":"SEUDOCIESIS FISIOLÓGICO"
  },
  {
    "codigo":162457002,
    "descripcion":"PRESENTA EL SÍNTOMA SEMANALMENTE"
  },
  {
    "codigo":293529006,
    "descripcion":"REACCIÓN ADVERSA AL MESILATO DE DIHIDROERGOTAMINA"
  },
  {
    "codigo":422766000,
    "descripcion":"ÁREA DE JUEGOS INSEGURA"
  },
  {
    "codigo":719513008,
    "descripcion":"ENFERMEDAD DE CHARCOT-MARIE-TOOTH TIPO 2L AUTOSÓMICA DOMINANTE"
  },
  {
    "codigo":64153009,
    "descripcion":"ESTENOSIS DE CONDUCTO ANAL"
  },
  {
    "codigo":95086008,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA PIEL DE LA MUÑECA"
  },
  {
    "codigo":191555002,
    "descripcion":"EXACERBACIÓN AGUDA DE ESQUIZOFRENIA PARANOIDE CRÓNICA"
  },
  {
    "codigo":1141827003,
    "descripcion":"DEGLUCIÓN NORMAL"
  },
  {
    "codigo":289859002,
    "descripcion":"LIQUENIFICACIÓN DEL PERINEO FEMENINO"
  },
  {
    "codigo":715843008,
    "descripcion":"PERIODONTITIS AGUDA LOCALIZADA LEVE"
  },
  {
    "codigo":419096002,
    "descripcion":"ANILLO DE FLEISHER"
  },
  {
    "codigo":58648008,
    "descripcion":"GAMMAPATÍA MONOCLONAL BENIGNA"
  },
  {
    "codigo":124184009,
    "descripcion":"DEFICIENCIA DE CITOCROMO - B>5< REDUCTASA"
  },
  {
    "codigo":253421002,
    "descripcion":"DEFECTO DEL TABIQUE AURICULOVENTRICULAR CON COMPONENTE VENTRICULAR DEBAJO DE PUENTE DE VALVA SUPERIOR QUE FLOTA LIBREMENTE Y CUERDAS TENDINOSAS A MÚSCULO PAPILAR EN PARED LIBRE DE VENTRÍCULO DERECHO"
  },
  {
    "codigo":89581003,
    "descripcion":"LUXACIÓN EXPUESTA DE LA RÓTULA"
  },
  {
    "codigo":286189006,
    "descripcion":"DIFICULTAD PARA ORDENAR LA CASA"
  },
  {
    "codigo":448194002,
    "descripcion":"NIVEL CRÍTICO DE COLONIZACIÓN DE HERIDA"
  },
  {
    "codigo":285981000119103,
    "descripcion":"INFARTO AGUDO DE MIOCARDIO CON ELEVACIÓN DE SEGMENTO ST QUE AFECTA A ARTERIA CORONARIA DESCENDENTE ANTERIOR IZQUIERDA"
  },
  {
    "codigo":1003415002,
    "descripcion":"DUPLICACIÓN DE PORCIÓN MEDIA DE BRAZO LARGO DE CROMOSOMA 1"
  },
  {
    "codigo":249751005,
    "descripcion":"AUSENCIA DE HUESO DE LA MANO"
  },
  {
    "codigo":446359006,
    "descripcion":"LACERACIÓN PROFUNDA DE PIE"
  },
  {
    "codigo":85911007,
    "descripcion":"INFESTACIÓN CAUSADA POR CHORIOPTES BOVIS"
  },
  {
    "codigo":282519009,
    "descripcion":"INCAPAZ DE BAJAR ESCALONES CORRIENDO"
  },
  {
    "codigo":247916003,
    "descripcion":"ACTIVIDAD MOTRIZ VIOLENTA"
  },
  {
    "codigo":1263724003,
    "descripcion":"TRASTORNO FETAL DEBIDO A POLIHIDRAMNIOS CRÓNICO"
  },
  {
    "codigo":278849000,
    "descripcion":"ATROFIA CEREBRAL"
  },
  {
    "codigo":49473001,
    "descripcion":"MANCHA ROJO CEREZA"
  },
  {
    "codigo":213313005,
    "descripcion":"INFECCIÓN POSTERIOR A INFUSIÓN"
  },
  {
    "codigo":83507006,
    "descripcion":"HALLAZGO RELACIONADO CON EL CONTENIDO DEL PENSAMIENTO"
  },
  {
    "codigo":442689009,
    "descripcion":"MICROORGANISMO INMÓVIL"
  },
  {
    "codigo":1260054002,
    "descripcion":"CICATRIZ DE PIEL DE LABIO INFERIOR"
  },
  {
    "codigo":80406003,
    "descripcion":"LUXACIÓN PATOLÓGICA DE ARTICULACIÓN"
  },
  {
    "codigo":702998001,
    "descripcion":"WEEKSELLA VIROSA O EMPEDOBACTER BREVIS"
  },
  {
    "codigo":14870002,
    "descripcion":"ACONDROGÉNESIS, TIPO IB"
  },
  {
    "codigo":735766007,
    "descripcion":"ESGUINCE DE LIGAMENTO ESTERNOCOSTAL"
  },
  {
    "codigo":45803000,
    "descripcion":"REGIÓN DE PROMOCIÓN GENÉTICA"
  },
  {
    "codigo":111339003,
    "descripcion":"ANOMALÍA CONGÉNITA DEL OÍDO CON COMPROMISO DE LA CAPACIDAD AUDITIVA"
  },
  {
    "codigo":15988151000119104,
    "descripcion":"ANOMALÍA CONGÉNITA DE ESCLERÓTICA IZQUIERDA"
  },
  {
    "codigo":371648002,
    "descripcion":"CUERPO MOMIFICADO"
  },
  {
    "codigo":240576002,
    "descripcion":"INFECCIÓN GONOCÓCICA DE LA GLÁNDULA DE COWPER"
  },
  {
    "codigo":699328003,
    "descripcion":"SÍNDROME EPILEPSIA MIOCLÓNICA, MIOPATÍA Y ATAXIA SENSITIVA"
  },
  {
    "codigo":109504005,
    "descripcion":"MALA OCLUSIÓN, CLASE III DE ANGLE"
  },
  {
    "codigo":402581002,
    "descripcion":"DERMATITIS IRRITATIVA POR CONTACTO CAUSADA POR MADERA"
  },
  {
    "codigo":238741003,
    "descripcion":"TRASTORNO DEL FOLÍCULO PILOSO"
  },
  {
    "codigo":1187178004,
    "descripcion":"ANHIDROSIS AISLADA GENERALIZADA CON GLÁNDULAS SUDORÍPARAS NORMALES"
  },
  {
    "codigo":314961000119103,
    "descripcion":"ENFERMEDAD DE PAGET DE MÚLTIPLES VÉRTEBRAS"
  },
  {
    "codigo":204138006,
    "descripcion":"CATARATA AZUL CONGÉNITA"
  },
  {
    "codigo":15634001000119103,
    "descripcion":"ECOGRAFÍA DE CEREBRO ANORMAL"
  },
  {
    "codigo":7530009,
    "descripcion":"ENANISMO ASEXUAL"
  },
  {
    "codigo":235071003,
    "descripcion":"CANDIDIASIS ERITEMATOSA BUCAL"
  },
  {
    "codigo":300607004,
    "descripcion":"CAPAZ DE REALIZAR ACTIVIDADES RELACIONADAS CON LOS VIAJES"
  },
  {
    "codigo":366143008,
    "descripcion":"HALLAZGO RELACIONADO CON PATRÓN RESPIRATORIO"
  },
  {
    "codigo":724756001,
    "descripcion":"SÍNTOMAS NEGATIVOS CONCOMITANTES CON TRASTORNO PSICÓTICO PRIMARIO Y DEBIDOS A ÉL"
  },
  {
    "codigo":169535008,
    "descripcion":"UTILIZA MÉTODO SINTOTÉRMICO COMO ANTICONCEPTIVO"
  },
  {
    "codigo":1281812003,
    "descripcion":"NEOPLASIA MALIGNA DE MAMA EN REMISIÓN PARCIAL"
  },
  {
    "codigo":298772001,
    "descripcion":"DEFORMIDAD DE ARTICULACIÓN DE HOMBRO"
  },
  {
    "codigo":890431008,
    "descripcion":"RUPTURA ESPONTÁNEA COMPLETA DE CORDÓN UMBILICAL FETAL"
  },
  {
    "codigo":165865000,
    "descripcion":"ANTICUERPOS CONTRA GLÁNDULAS SUPRARRENALES DETECTADOS"
  },
  {
    "codigo":722921008,
    "descripcion":"HEMORRAGIA ESPLÉNICA NEONATAL"
  },
  {
    "codigo":1343678002,
    "descripcion":"MONONEUROPATÍA DE EXTREMIDAD SUPERIOR DERECHA"
  },
  {
    "codigo":721086004,
    "descripcion":"SÍNDROME DE SORDERA, ANOMALÍA GENITAL, SINOSTOSIS METACARPIANA Y METATARSIANA"
  },
  {
    "codigo":426174008,
    "descripcion":"TRASTORNO DE ESTRÉS CRÓNICO"
  },
  {
    "codigo":295102009,
    "descripcion":"ALERGIA A MOXISILITA"
  },
  {
    "codigo":32958008,
    "descripcion":"MICROGNATISMO CONGÉNITO"
  },
  {
    "codigo":60821000087100,
    "descripcion":"INFECCIÓN CAUSADA POR EXSEROHILUM ROSTRATUM"
  },
  {
    "codigo":719251009,
    "descripcion":"ATAXIA ESPINOCEREBELOSA TIPO 19"
  },
  {
    "codigo":422504002,
    "descripcion":"ACCIDENTE CEREBROVASCULAR ISQUÉMICO"
  },
  {
    "codigo":42901000087105,
    "descripcion":"HERIDA DE REGIÓN DE RODILLA DERECHA POR MORDEDURA"
  },
  {
    "codigo":40341000087108,
    "descripcion":"DISTENSIÓN DE TENDÓN DE REGIÓN DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":291432002,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR NISTATINA"
  },
  {
    "codigo":94824004,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA EPIGLOTIS"
  },
  {
    "codigo":225896007,
    "descripcion":"DISCAPACIDAD SENSITIVA MÚLTIPLE"
  },
  {
    "codigo":1208936008,
    "descripcion":"SÍNDROME DE ICTIOSIS CONGÉNITA, DISCAPACIDAD INTELECTUAL Y CUADRIPLEJÍA ESPÁSTICA"
  },
  {
    "codigo":1010493002,
    "descripcion":"ESCLEROSIS DE EPÍFISIS DE PRIMER HUESO METACARPIANO CON RADIOPACIDAD AUMENTADA"
  },
  {
    "codigo":1081221000119101,
    "descripcion":"NEUROBLASTOMA OLFATORIO DERECHO MALIGNO PRIMARIO"
  },
  {
    "codigo":289597006,
    "descripcion":"HALLAZGO RELACIONADO CON LA HUMEDAD VAGINAL"
  },
  {
    "codigo":191293008,
    "descripcion":"TRASTORNO HEMORRÁGICO POR AUMENTO DE ANTI-11A"
  },
  {
    "codigo":386066000,
    "descripcion":"TRASTORNO RELACIONADO CON LA VITAMINA B"
  },
  {
    "codigo":254994000,
    "descripcion":"RABDOMIOSARCOMA DE ÓRBITA"
  },
  {
    "codigo":123922001,
    "descripcion":"INTOXICACIÓN POR ERICACEAE"
  },
  {
    "codigo":92989009,
    "descripcion":"OMÓPLATO ARQUEADO CONGÉNITO"
  },
  {
    "codigo":25618008,
    "descripcion":"SÍNTOMA PSICOLÓGICO"
  },
  {
    "codigo":253159001,
    "descripcion":"ESQUIZOENCEFALIA"
  },
  {
    "codigo":285927003,
    "descripcion":"DIFICULTAD PARA LLENAR EL LAVABO"
  },
  {
    "codigo":11812741000119105,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DE MUÑECA Y MANO DERECHAS"
  },
  {
    "codigo":447932003,
    "descripcion":"CONEXIONES VENTRICULOARTERIALES CON DOBLE TRACTO DE SALIDA"
  },
  {
    "codigo":413329000,
    "descripcion":"TRATADO POR CONSUMO DE DROGAS EN LOS ÚLTIMOS 12 MESES"
  },
  {
    "codigo":249489001,
    "descripcion":"ATRAGANTAMIENTO"
  },
  {
    "codigo":315025001,
    "descripcion":"ANGINA DE PECHO REFRACTARIA"
  },
  {
    "codigo":85649008,
    "descripcion":"ANEMIA MEGALOBLÁSTICA POR DEFICIENCIA DE ÁCIDO FÓLICO"
  },
  {
    "codigo":16046111000119102,
    "descripcion":"REUMATISMO PALINDRÓMICO BILATERAL DE RODILLAS"
  },
  {
    "codigo":278587004,
    "descripcion":"PUENTE DENTAL MUY OSCURO"
  },
  {
    "codigo":737339005,
    "descripcion":"DELIRIO CAUSADO POR CANABINOIDE SINTÉTICO"
  },
  {
    "codigo":1228859008,
    "descripcion":"MALFORMACIÓN LINFÁTICA QUÍSTICA MIXTA"
  },
  {
    "codigo":1259792002,
    "descripcion":"NEOPLASIA PRIMARIA MALIGNA DE CÉLULAS DE LEYDIG DE TESTÍCULO"
  },
  {
    "codigo":309520003,
    "descripcion":"NEUROPATÍA SENSITIVA SIMÉTRICA"
  },
  {
    "codigo":473360003,
    "descripcion":"TROMBO DE AURÍCULA IZQUIERDA"
  },
  {
    "codigo":735504005,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO DE PERINEO"
  },
  {
    "codigo":276752006,
    "descripcion":"REMANENTE EMBRIOLÓGICO"
  },
  {
    "codigo":317471000119106,
    "descripcion":"DETENCIÓN PARCIAL DE CRECIMIENTO EPIFISARIO DE TIBIA DISTAL DERECHA"
  },
  {
    "codigo":897509000,
    "descripcion":"TRISOMÍA DISTAL 8P"
  },
  {
    "codigo":242149001,
    "descripcion":"LESIÓN DE CICLISTA FUERA DE AUTOPISTA PÚBLICA"
  },
  {
    "codigo":209381002,
    "descripcion":"FRACTURA-SUBLUXACIÓN EXPUESTA DE ARTICULACIÓN MEDIOTARSIANA"
  },
  {
    "codigo":274917005,
    "descripcion":"INTOXICACIÓN POR GAS DE ESCAPE EN AERONAVE"
  },
  {
    "codigo":307685006,
    "descripcion":"MICROALETEO OCULAR"
  },
  {
    "codigo":109242000,
    "descripcion":"ABSCESO DE LA REGIÓN PERIORBITARIA"
  },
  {
    "codigo":76474001,
    "descripcion":"ENCEFALITIS NECROSANTE AGUDA HERPÉTICA"
  },
  {
    "codigo":1290725008,
    "descripcion":"ADAMANTINOMA DESDIFERENCIADO MALIGNO DE HUESO"
  },
  {
    "codigo":240314005,
    "descripcion":"LESIÓN ESQUELÉTICA POR TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":404154007,
    "descripcion":"INFILTRACIÓN LEUCÉMICA DE PIEL EN LEUCEMIA MONOCÍTICA"
  },
  {
    "codigo":830138009,
    "descripcion":"FETO VIABLE"
  },
  {
    "codigo":1354426009,
    "descripcion":"OCLUSIÓN DE VENA NASAL INFERIOR DE RETINA"
  },
  {
    "codigo":305850009,
    "descripcion":"ATENDIDO POR SERVICIO DE NUTRICIÓN EXTRAHOSPITALARIO"
  },
  {
    "codigo":369551003,
    "descripcion":"NEOPLASIA MALIGNA QUE COMPROMETE TROMPA DE FALOPIO DERECHA POR PROPAGACIÓN DIRECTA DESDE ÚTERO"
  },
  {
    "codigo":402319008,
    "descripcion":"PSORIASIS DEL MARGEN DEL CUERO CABELLUDO"
  },
  {
    "codigo":955314361000119105,
    "descripcion":"LACERACIÓN DE MÚSCULO INTRÍNSECO DE DEDO ÍNDICE"
  },
  {
    "codigo":105572002,
    "descripcion":"FUERZA ESPIRITUAL"
  },
  {
    "codigo":15691961000119105,
    "descripcion":"ARTRITIS REUMATOIDEA SEROPOSITIVA DE ARTICULACIÓN DE AMBOS TOBILLOS"
  },
  {
    "codigo":236644005,
    "descripcion":"TRASTORNO FUNCIONAL DE CUELLO DE VEJIGA URINARIA Y DE MECANISMO ESFINTERIANO"
  },
  {
    "codigo":171108006,
    "descripcion":"CRIBADO NO NECESARIO"
  },
  {
    "codigo":72804009,
    "descripcion":"INTOXICACIÓN POR TIOCARBAMATO"
  },
  {
    "codigo":1119545002,
    "descripcion":"NARIZ DE ASPECTO BULBOSO"
  },
  {
    "codigo":726329002,
    "descripcion":"LACERACIÓN DE FASCIA DE MÚSCULO INTRÍNSECO DEL PIE"
  },
  {
    "codigo":38201005,
    "descripcion":"INFECCIÓN CAUSADA POR SCHISTOSOMA MATTHEII"
  },
  {
    "codigo":300345006,
    "descripcion":"VESÍCULA BILIAR PEQUEÑA"
  },
  {
    "codigo":890169006,
    "descripcion":"DERMATITIS ALÉRGICA POR CONTACTO CON URUSHIOL DE TOXICODENDRON VERNIX"
  },
  {
    "codigo":69134001,
    "descripcion":"DEGENERACIÓN RETINIANA EN EMPEDRADO"
  },
  {
    "codigo":724494002,
    "descripcion":"FÍSTULA VESICOVAGINAL CON COMPROMISO DEL MECANISMO DE CONTINENCIA URINARIA POSTERIOR A PROCEDIMIENTO DE INTERRUPCIÓN DEL EMBARAZO"
  },
  {
    "codigo":298510003,
    "descripcion":"AMPLITUD DE FLEXIÓN ACTIVA DE LA COLUMNA VERTEBRAL DORSAL, DISMINUIDA"
  },
  {
    "codigo":396814006,
    "descripcion":"MARGEN QUIRÚRGICO POSTERIOR DEL PÁNCREAS RETROPERITONEAL COMPROMETIDO POR NEOPLASIA MALIGNA"
  },
  {
    "codigo":296675003,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE CEFALEXINA"
  },
  {
    "codigo":67299005,
    "descripcion":"SIGNO DE AUSPITZ"
  },
  {
    "codigo":1083731000119105,
    "descripcion":"PERICONDRITIS BILATERAL"
  },
  {
    "codigo":1763009,
    "descripcion":"QUERATITIS INTERSTICIAL"
  },
  {
    "codigo":294840004,
    "descripcion":"ALERGIA A SALCATONINA"
  },
  {
    "codigo":360376008,
    "descripcion":"DEFECTOS FUNCIONALES DE METIONINA SINTETASA"
  },
  {
    "codigo":720824009,
    "descripcion":"VÍCTIMA DE NEGLIGENCIA INFANTIL"
  },
  {
    "codigo":1144973003,
    "descripcion":"TRASTORNO RENAL DEBIDO A LUPUS ERITEMATOSO SISTÉMICO"
  },
  {
    "codigo":293005006,
    "descripcion":"REACCIÓN ADVERSA AL CEFAMANDOL"
  },
  {
    "codigo":161933007,
    "descripcion":"TOS VESPERTINA"
  },
  {
    "codigo":129165008,
    "descripcion":"LUXACIÓN ARTICULAR TRAUMÁTICA DE VÉRTEBRA DORSAL"
  },
  {
    "codigo":61794006,
    "descripcion":"LABERINTITIS CIRCUNSCRIPTA"
  },
  {
    "codigo":782690007,
    "descripcion":"SÍNDROME DE GEMIGNANI"
  },
  {
    "codigo":29026008,
    "descripcion":"PERITONITIS SUBFRÉNICA"
  },
  {
    "codigo":289335000,
    "descripcion":"CLIP DE CORDÓN UMBILICAL SEGURO"
  },
  {
    "codigo":94562006,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA PIEL DE LA RODILLA"
  },
  {
    "codigo":291170008,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR PERICIAZINA"
  },
  {
    "codigo":225634009,
    "descripcion":"ATERRADO"
  },
  {
    "codigo":422242007,
    "descripcion":"EPITELIO CORNEAL LAXO"
  },
  {
    "codigo":92727002,
    "descripcion":"CARCINOMA IN SITU DE LA PIEL DEL ANTEBRAZO"
  },
  {
    "codigo":713484001,
    "descripcion":"TRASTORNO DEL SISTEMA RESPIRATORIO CONCOMITANTE CON INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":1137633000,
    "descripcion":"GLAUCOMA SECUNDARIO DE ÁNGULO CERRADO CAUSADO POR SÍNDROME ENDOTELIAL IRIDOCORNEAL"
  },
  {
    "codigo":1303308009,
    "descripcion":"HALLAZGO RELACIONADO CON ELEGIBILIDAD PARA BENEFICIO"
  },
  {
    "codigo":254732008,
    "descripcion":"MELANOMA MALIGNO LENTIGINOSO ACRAL DE LA PIEL"
  },
  {
    "codigo":89057003,
    "descripcion":"LEUCOPLASIA DE ESÓFAGO"
  },
  {
    "codigo":1268705004,
    "descripcion":"TUMOR PRIMARIO MALIGNO DE CORDÓN SEXUAL DE OVARIO"
  },
  {
    "codigo":418572009,
    "descripcion":"DEPÓSITOS DE CIPROFLOXACINO EN LA CÓRNEA"
  },
  {
    "codigo":449505005,
    "descripcion":"SEPSIS CAUSADA POR STAPHYLOCOCCUS COAGULASA NEGATIVO"
  },
  {
    "codigo":123660008,
    "descripcion":"ROTACIÓN DEL CORAZÓN HACIA LA DERECHA"
  },
  {
    "codigo":447670001,
    "descripcion":"DEFECTO DEL TABIQUE INTERVENTRICULAR CON MALA ALINEACIÓN ANTERIOR DEL TABIQUE CORRESPONDIENTE AL TRACTO DE SALIDA Y CABALGAMIENTO DE VÁLVULA PULMONAR"
  },
  {
    "codigo":1332406002,
    "descripcion":"DELIRIO DE TRANSMISIÓN DE PENSAMIENTO"
  },
  {
    "codigo":251062007,
    "descripcion":"HALLAZGO RELACIONADO CON UNA DERIVACIÓN CARDIOVASCULAR"
  },
  {
    "codigo":283830007,
    "descripcion":"MORDEDURA DE ANIMAL EN EL TOBILLO"
  },
  {
    "codigo":707979007,
    "descripcion":"EXACERBACIÓN SEVERA AGUDA DE ASMA SEVERA PERSISTENTE"
  },
  {
    "codigo":52619009,
    "descripcion":"PSEUDO-OBSTRUCCIÓN CRÓNICA PRIMARIA DEL ESÓFAGO"
  },
  {
    "codigo":1197664001,
    "descripcion":"HIPERTENSIÓN PORTAL SECUNDARIA"
  },
  {
    "codigo":247392005,
    "descripcion":"NEURALGIA DE NERVIO ILIOHIPOGÁSTRICO"
  },
  {
    "codigo":444000005,
    "descripcion":"ESTATURA BAJA PARA LA EDAD"
  },
  {
    "codigo":1163061003,
    "descripcion":"ENCEFALITIS POR VIRUS LINFOTRÓPICO DE CÉLULAS T HUMANAS TIPO 1"
  },
  {
    "codigo":704309005,
    "descripcion":"DIFICULTAD EN EL MANEJO DEL CUIDADO DE NEFROSTOMÍA"
  },
  {
    "codigo":81717007,
    "descripcion":"EFECTO TÓXICO DEL PROPANO"
  },
  {
    "codigo":473098006,
    "descripcion":"INFLAMACIÓN ASOCIADA CON DISPOSITIVO DE FIJACIÓN INTERNA"
  },
  {
    "codigo":768010007,
    "descripcion":"MORDIDA CRUZADA POSTERIOR BILATERAL"
  },
  {
    "codigo":209119000,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN ESTERNOCLAVICULAR, POSTERIOR"
  },
  {
    "codigo":210954009,
    "descripcion":"SECUELAS DE HERIDA ABIERTA EN LA CABEZA"
  },
  {
    "codigo":1259530006,
    "descripcion":"CARCINOMA PRIMARIO DE PIEL DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":733407003,
    "descripcion":"FRACTURA DE TUBEROSIDAD MENOR DE HÚMERO"
  },
  {
    "codigo":438495005,
    "descripcion":"PERITONITIS BILIAR POSTCOLECISTECTOMÍA"
  },
  {
    "codigo":372959006,
    "descripcion":"INFECCIÓN CAUSADA POR PENICILLIUM OXALICUM"
  },
  {
    "codigo":897247006,
    "descripcion":"CURVATURA ANORMAL DE FALANGE MEDIA DE QUINTO DEDO DE PIE"
  },
  {
    "codigo":241887008,
    "descripcion":"EFECTO TÓXICO CAUSADO POR SELLADOR"
  },
  {
    "codigo":403892001,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS DE LA PIEL DE LA CARA"
  },
  {
    "codigo":307423008,
    "descripcion":"PERITONITIS PÉLVICA GONOCÓCICA"
  },
  {
    "codigo":305588000,
    "descripcion":"BAJO ATENCIÓN DE OBSTÉTRICA HOSPITALARIA"
  },
  {
    "codigo":371124005,
    "descripcion":"ABRASIÓN CORNEAL INFECTADA"
  },
  {
    "codigo":880008002,
    "descripcion":"ANOMALÍA ADQUIRIDA DE VENTRÍCULO CARDÍACO IZQUIERDO"
  },
  {
    "codigo":860809000,
    "descripcion":"NEUROPATÍA AUTONÓMICA SENSITIVA HEREDITARIA TIPO IIA"
  },
  {
    "codigo":8841001,
    "descripcion":"INFECCIÓN CAUSADA POR SCHISTOSOMA CHESTERMANI"
  },
  {
    "codigo":322491000119101,
    "descripcion":"INFLAMACIÓN DE BOLSA SEROSA DE MÚSCULO SEMIMEMBRANOSO DE RODILLA IZQUIERDA"
  },
  {
    "codigo":1155721005,
    "descripcion":"OBSTRUCCIÓN AÓRTICA REUMÁTICA"
  },
  {
    "codigo":762505006,
    "descripcion":"DEPENDENCIA DE CATINONA SINTÉTICA"
  },
  {
    "codigo":1186654001,
    "descripcion":"SÍNDROME DE DESREGULACIÓN INMUNITARIA, ENFERMEDAD INFLAMATORIA INTESTINAL, ARTRITIS, INFECCIONES RECURRENTES Y LINFOPENIA"
  },
  {
    "codigo":7006003,
    "descripcion":"MOVIMIENTOS TORPES"
  },
  {
    "codigo":432990004,
    "descripcion":"FÍSTULA ANOVESTIBULAR"
  },
  {
    "codigo":301918006,
    "descripcion":"HALLAZGO RELACIONADO CON LA APARIENCIA DEL GLOBO OCULAR"
  },
  {
    "codigo":236382007,
    "descripcion":"SÍNDROME NEFRÓTICO DEPENDIENTE DE ESTEROIDES"
  },
  {
    "codigo":201779000,
    "descripcion":"ARTRITIS REUMATOIDE DE TOBILLO"
  },
  {
    "codigo":300083003,
    "descripcion":"OÍDO EXTERNO - HALLAZGO"
  },
  {
    "codigo":337711000119100,
    "descripcion":"DESPRENDIMIENTO SEROSO DE RETINA DE OJO IZQUIERDO"
  },
  {
    "codigo":15989551000119101,
    "descripcion":"FLICTÉNULA DE OJO DERECHO"
  },
  {
    "codigo":15999791000119100,
    "descripcion":"DEFECTO PUPILAR AFERENTE RELATIVO DE OJO DERECHO"
  },
  {
    "codigo":16667951000119103,
    "descripcion":"FRACTURA NO EXPUESTA DE PORCIÓN ORBITARIA DE HUESO CIGOMÁTICO DERECHO"
  },
  {
    "codigo":16058671000119103,
    "descripcion":"RECHAZO DE TRASPLANTE DE CÓRNEA DE OJO IZQUIERDO"
  },
  {
    "codigo":16035631000119105,
    "descripcion":"OSTEÓLISIS DE PIE IZQUIERDO"
  },
  {
    "codigo":10682671000119106,
    "descripcion":"TUMORACIÓN DE LA PIEL DEL ANTEBRAZO DERECHO"
  },
  {
    "codigo":16030511000119107,
    "descripcion":"OSTEOMIELITIS SUBAGUDA DE PIE IZQUIERDO"
  },
  {
    "codigo":11798831000119108,
    "descripcion":"TRANSECCIÓN COMPLETA DE AORTA ABDOMINAL"
  },
  {
    "codigo":10674991000119104,
    "descripcion":"ASMA ALÉRGICA INTERMITENTE"
  },
  {
    "codigo":234547005,
    "descripcion":"DEFICIENCIA COMBINADA DE INMUNOGLOBULINAS G2 Y G4"
  },
  {
    "codigo":10631471000119108,
    "descripcion":"ABSCESO DE PIEL DE TOBILLO DERECHO"
  },
  {
    "codigo":291631000119107,
    "descripcion":"AFASIA DEBIDA A HEMORRAGIA SUBARACNOIDEA NO TRAUMÁTICA Y POSTERIOR A ELLA"
  },
  {
    "codigo":724232004,
    "descripcion":"SENSACIÓN DE ESTAR CALIENTE"
  },
  {
    "codigo":298248007,
    "descripcion":"DEBILIDAD DEL MOVIMIENTO ARTICULAR"
  },
  {
    "codigo":335151000119107,
    "descripcion":"PTOSIS DE PÁRPADO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":15981871000119107,
    "descripcion":"TRASTORNO DE PIEL DE PÁRPADO IZQUIERDO"
  },
  {
    "codigo":15986991000119108,
    "descripcion":"ANIRIDIA CONGÉNITA DE OJO IZQUIERDO"
  },
  {
    "codigo":394717006,
    "descripcion":"PRUEBA DE LEUCOCITOS EN ORINA NEGATIVA"
  },
  {
    "codigo":427485008,
    "descripcion":"ASISTOLIA ELECTROCARDIOGRÁFICA"
  },
  {
    "codigo":296413009,
    "descripcion":"SOBREDOSIS DE CLORFENAMINA"
  },
  {
    "codigo":294578006,
    "descripcion":"ALERGIA A SULFACARBAMIDA"
  },
  {
    "codigo":1144711000,
    "descripcion":"HIPOPLASIA DE FALANGE DISTAL DE CUARTO DEDO DE PIE"
  },
  {
    "codigo":194439006,
    "descripcion":"TRASTORNO DE SOMNOLENCIA EXCESIVA"
  },
  {
    "codigo":292743007,
    "descripcion":"REACCIÓN ADVERSA A AGENTE QUELANTE"
  },
  {
    "codigo":1208412003,
    "descripcion":"ESCLEROSIS LATERAL AMIOTRÓFICA TIPO 10"
  },
  {
    "codigo":127068004,
    "descripcion":"SÍNDROME HISTIOCÍTICO"
  },
  {
    "codigo":94300004,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE FÉMUR"
  },
  {
    "codigo":679151000119100,
    "descripcion":"EROSIÓN DE CÓRNEA DE OJO IZQUIERDO"
  },
  {
    "codigo":290908009,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR FLUOXETINA"
  },
  {
    "codigo":26929004,
    "descripcion":"ENFERMEDAD DE ALZHEIMER"
  },
  {
    "codigo":92465005,
    "descripcion":"NEOPLASIA BENIGNA DEL ORIFICIO URETERAL DE LA VEJIGA"
  },
  {
    "codigo":289073007,
    "descripcion":"CAPAZ DE CORTAR LOS ALIMENTOS"
  },
  {
    "codigo":715057009,
    "descripcion":"TRASTORNO DE DISCO INTERVERTEBRAL LUMBOSACRO"
  },
  {
    "codigo":713222002,
    "descripcion":"COMPLICACIÓN DEBIDA A ANESTESIA DURANTE PROCEDIMIENTO QUIRÚRGICO"
  },
  {
    "codigo":188934003,
    "descripcion":"NEOPLASIA BENIGNA DE CARTÍLAGO COSTAL"
  },
  {
    "codigo":254470006,
    "descripcion":"NEOPLASIA BENIGNA DE CAVIDAD TIMPÁNICA"
  },
  {
    "codigo":25094008,
    "descripcion":"AGNOSIA TÁCTIL"
  },
  {
    "codigo":90630009,
    "descripcion":"LESIÓN TRAUMÁTICA DEL NERVIO ESPINAL"
  },
  {
    "codigo":711387003,
    "descripcion":"DETERIORO DE LA CAPACIDAD PARA CAMINAR"
  },
  {
    "codigo":23259007,
    "descripcion":"LINFANGITIS AGUDA DE TALÓN"
  },
  {
    "codigo":185264001,
    "descripcion":"ATENDIDO EN CONSULTORIO ESPECIALIZADO EN HIPERTENSIÓN"
  },
  {
    "codigo":283568001,
    "descripcion":"HERIDA DE PERDIGÓN EN PALMA DE LA MANO"
  },
  {
    "codigo":840624003,
    "descripcion":"PALADAR BLANDO Y BASE DE ÚVULA VISIBLES"
  },
  {
    "codigo":447408004,
    "descripcion":"ÚLCERA DE ANASTOMOSIS"
  },
  {
    "codigo":54192004,
    "descripcion":"ESPÉCIMEN ENMASCARADO POR MATERIAL EXTRAÑO"
  },
  {
    "codigo":414640006,
    "descripcion":"PRINCIPAL IDIOMA HABLADO: FINLANDÉS"
  },
  {
    "codigo":351471000119106,
    "descripcion":"CARCINOMA DE CÉLULAS DE MERKEL PRIMARIO DE PIEL DE MAMA"
  },
  {
    "codigo":52357004,
    "descripcion":"QUISTE DE RETINA"
  },
  {
    "codigo":248965005,
    "descripcion":"HALLAZGO RELACIONADO CON LA REGULARIDAD DEL CICLO MENSTRUAL"
  },
  {
    "codigo":771418002,
    "descripcion":"DELIRIO LUEGO DE PROCEDIMIENTO QUIRÚRGICO"
  },
  {
    "codigo":312666006,
    "descripcion":"ENDOMETRIO NORMAL"
  },
  {
    "codigo":247130009,
    "descripcion":"HALLAZGO MICROVASCULAR DE LA RETINA"
  },
  {
    "codigo":50522009,
    "descripcion":"TERCER RUIDO CARDÍACO NORMAL, R>3<"
  },
  {
    "codigo":278063007,
    "descripcion":"MENOPAUSIA POSTERIOR A LA HISTERECTOMÍA"
  },
  {
    "codigo":1162799008,
    "descripcion":"LEIOMIOMATOSIS HEREDITARIA Y CARCINOMA DE CÉLULAS RENALES"
  },
  {
    "codigo":1193732002,
    "descripcion":"ENTERITIS ENTEROBACTERIANA DE INTESTINO DELGADO"
  },
  {
    "codigo":472836003,
    "descripcion":"SACO VITELINO AUSENTE"
  },
  {
    "codigo":700377000,
    "descripcion":"RUPTURA CRÓNICA DE TENDÓN DE AQUILES"
  },
  {
    "codigo":866052009,
    "descripcion":"CARCINOMA DUCTAL-NEUROENDOCRINO MIXTO DE PÁNCREAS"
  },
  {
    "codigo":767748008,
    "descripcion":"OBSTRUCCIÓN CONCOMITANTE CON HERNIA INGUINAL BILATERAL Y DEBIDA A ELLA"
  },
  {
    "codigo":1290201004,
    "descripcion":"QUEMADURA QUÍMICA DE ESPESOR TOTAL DE ANTEBRAZO"
  },
  {
    "codigo":733145007,
    "descripcion":"OBSTRUCCIÓN INTESTINAL NEONATAL"
  },
  {
    "codigo":698542000,
    "descripcion":"REQUIERE DISPOSITIVO OCLUSAL DURO"
  },
  {
    "codigo":208857009,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE DÍGITO"
  },
  {
    "codigo":75950002,
    "descripcion":"BRAQUIMETACARPIA"
  },
  {
    "codigo":403630005,
    "descripcion":"PÉNFIGO VULGAR MEDICAMENTOSO"
  },
  {
    "codigo":239790006,
    "descripcion":"ARTRITIS POSDERIVACIÓN INTESTINAL"
  },
  {
    "codigo":205187004,
    "descripcion":"DETENCIÓN TRANSVERSA A NIVEL DEL PRIMER RAYO FALÁNGICO"
  },
  {
    "codigo":8579004,
    "descripcion":"VÓMITO EN CHORRO"
  },
  {
    "codigo":237955004,
    "descripcion":"DEFICIENCIA CITOSÓLICA DE ACETOACETIL-COA TIOLASA"
  },
  {
    "codigo":203352005,
    "descripcion":"ENFERMEDAD DE PAGET DE LOCALIZACIONES MÚLTIPLES"
  },
  {
    "codigo":432728006,
    "descripcion":"INFECCIÓN DE PIEL DE CUELLO"
  },
  {
    "codigo":6744007,
    "descripcion":"ESPASMO DOLOROSO DE VEJIGA URINARIA"
  },
  {
    "codigo":399960008,
    "descripcion":"HAMARTOMA CONGÉNITO"
  },
  {
    "codigo":236120009,
    "descripcion":"ISQUEMIA DE ESTOMA"
  },
  {
    "codigo":103213002,
    "descripcion":"PRODUCCIÓN DE MEGACARIOCITOS DISMINUIDA"
  },
  {
    "codigo":72280009,
    "descripcion":"ACROMOTRIQUIA"
  },
  {
    "codigo":681661000119100,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE CÚPULA DE VEJIGA URINARIA"
  },
  {
    "codigo":201517005,
    "descripcion":"ARTRITIS SERONEGATIVA SECUNDARIA A ENFERMEDAD DE WHIPPLE"
  },
  {
    "codigo":301656005,
    "descripcion":"CAPAZ DE LEVANTARSE DE UNA SILLA"
  },
  {
    "codigo":365357008,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA USAR LA SENDA PEATONAL"
  },
  {
    "codigo":68610001,
    "descripcion":"NISTAGMO LATENTE"
  },
  {
    "codigo":430893009,
    "descripcion":"TRASTORNO DEL SUEÑO RELACIONADO CON MOVIMIENTOS RÍTMICOS"
  },
  {
    "codigo":168749009,
    "descripcion":"MAMOGRAFÍA NORMAL"
  },
  {
    "codigo":429058004,
    "descripcion":"NUEVA ANOMALÍA DE LA MOTILIDAD PARIETAL DEL VENTRÍCULO IZQUIERDO EN COMPARACIÓN CON ESTUDIO PREVIO"
  },
  {
    "codigo":232450005,
    "descripcion":"SULCUS VOCALIS DE CUERDA VOCAL"
  },
  {
    "codigo":297986007,
    "descripcion":"HALLAZGO RELACIONADO CON EL CRECIMIENTO DE LAS UÑAS"
  },
  {
    "codigo":1239002,
    "descripcion":"ANTEVERSIÓN CONGÉNITA DE FÉMUR"
  },
  {
    "codigo":294316000,
    "descripcion":"ALERGIA A ACEITE DE OLIVA"
  },
  {
    "codigo":1091261000119105,
    "descripcion":"DERMATITIS DE CONDUCTO AUDITIVO EXTERNO DERECHO"
  },
  {
    "codigo":1144449000,
    "descripcion":"APLASIA DE FALANGE DISTAL DE DEDO ANULAR"
  },
  {
    "codigo":95873000,
    "descripcion":"INTOXICACIÓN POR MONÓXIDO DE CARBONO DE CALDERAS Y\/O ESTUFAS DEFECTUOSAS"
  },
  {
    "codigo":30337003,
    "descripcion":"LEUCOMA ADHERENTE"
  },
  {
    "codigo":194177006,
    "descripcion":"OPSOCLONÍA"
  },
  {
    "codigo":290646004,
    "descripcion":"INTOXICACIÓN POR PLICAMICINA"
  },
  {
    "codigo":782166005,
    "descripcion":"ENOSTOSIS DE PELVIS DERECHA"
  },
  {
    "codigo":126806005,
    "descripcion":"NEOPLASIA DE LA BÓVEDA DEL PALADAR"
  },
  {
    "codigo":94038007,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA PIEL DEL CUERO CABELLUDO"
  },
  {
    "codigo":28502008,
    "descripcion":"DESNERVACIÓN SENSITIVA"
  },
  {
    "codigo":92203003,
    "descripcion":"NEOPLASIA BENIGNA DE LOS GANGLIOS LINFÁTICOS DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":190507007,
    "descripcion":"HIPERALDOSTERONISMO PRIMARIO"
  },
  {
    "codigo":254208002,
    "descripcion":"NEVO SANGUÍNEO"
  },
  {
    "codigo":188672005,
    "descripcion":"LINFOMA NO HODGKINIANO FOLICULAR MIXTO, DE CÉLULAS GRANDES Y DE CÉLULAS PEQUEÑAS CLIVADAS"
  },
  {
    "codigo":876800006,
    "descripcion":"REACCIÓN ADVERSA A CARBIDOPA Y\/O LEVODOPA"
  },
  {
    "codigo":418048009,
    "descripcion":"PLIEGUE CUTÁNEO DEL LÓBULO DE LA OREJA"
  },
  {
    "codigo":448981003,
    "descripcion":"GANGRENA DE NALGA"
  },
  {
    "codigo":283306001,
    "descripcion":"ASTILLA DE MADERA EN CADERA"
  },
  {
    "codigo":55765009,
    "descripcion":"DIETA PARA HIPERLIPOPROTEINEMIA, TIPO V"
  },
  {
    "codigo":250538001,
    "descripcion":"DISCARIOSIS EN EL EXTENDIDO CERVICAL"
  },
  {
    "codigo":447146004,
    "descripcion":"VERRUGA VULGAR DE PIEL DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":53930004,
    "descripcion":"DERMATITIS DE CONTACTO CAUSADA POR AMBROSÍA"
  },
  {
    "codigo":21162009,
    "descripcion":"MAREO DEL ESPACIO EXTERIOR"
  },
  {
    "codigo":838527002,
    "descripcion":"DEPENDENCIA DE ANFETAMINA Y\/O DERIVADO DE ANFETAMINA"
  },
  {
    "codigo":707455001,
    "descripcion":"CARCINOMA PAPILAR ESCAMOCELULAR PRIMARIO DE PULMÓN"
  },
  {
    "codigo":445311003,
    "descripcion":"FRACTURA EXPUESTA DE TIBIA Y PERONÉ DISTALES"
  },
  {
    "codigo":115796000,
    "descripcion":"FENOTIPO P>1<^K^"
  },
  {
    "codigo":246868003,
    "descripcion":"SECRECIÓN DE SACO LAGRIMAL"
  },
  {
    "codigo":83028006,
    "descripcion":"AUSENCIA CONGÉNITA PARCIAL DEL TRACTO ALIMENTARIO"
  },
  {
    "codigo":81193001,
    "descripcion":"LESIÓN TRAUMÁTICA DE ÓRGANO PÉLVICO CON HERIDA ABIERTA HACIA CAVIDAD ABDOMINAL"
  },
  {
    "codigo":310569002,
    "descripcion":"ELISA PARA ENFERMEDAD DE LYME DUDOSA"
  },
  {
    "codigo":212265003,
    "descripcion":"LESIÓN ABIERTA DE NERVIO CUBITAL"
  },
  {
    "codigo":210430007,
    "descripcion":"HERIDA ABIERTA EN EL ESCROTO"
  },
  {
    "codigo":863955000,
    "descripcion":"MOVILIDAD DE MIEMBRO INYECTADO DISMINUIDA"
  },
  {
    "codigo":274131006,
    "descripcion":"MASTITIS OBSTÉTRICA"
  },
  {
    "codigo":110291007,
    "descripcion":"RESPIRACIÓN BUCAL CRÓNICA"
  },
  {
    "codigo":372435008,
    "descripcion":"MARGEN LATERAL SUPERIOR DE RESECCIÓN QUIRÚRGICA, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":403368002,
    "descripcion":"MANCHAS DE FORDYCE EN LOS LABIOS"
  },
  {
    "codigo":1255336007,
    "descripcion":"FRACTURA EXPUESTA DE FALANGES DE MÚLTIPLES DEDOS DE PIE"
  },
  {
    "codigo":10152009,
    "descripcion":"ESTADO POSTPARTO, 4 SEMANAS"
  },
  {
    "codigo":73853003,
    "descripcion":"EFECTO TÓXICO DEL HIDRÓXIDO DE POTASIO"
  },
  {
    "codigo":204925004,
    "descripcion":"QUISTE DE CONDUCTO MESONÉFRICO FEMENINO"
  },
  {
    "codigo":8317005,
    "descripcion":"CON MAYOR RIESGO DE FUNCIÓN PARENTAL DEFICIENTE"
  },
  {
    "codigo":237693006,
    "descripcion":"DEFICIENCIA IDIOPÁTICA DE ADRENOCORTICOTROFINA"
  },
  {
    "codigo":1153362000,
    "descripcion":"OSTEOMALACIA DEL ADULTO DEBIDA A TRASTORNO ENDOCRINO"
  },
  {
    "codigo":301394002,
    "descripcion":"DOLOR GENITOURINARIO A LA PALPACIÓN"
  },
  {
    "codigo":235858002,
    "descripcion":"HEPATITIS REACTIVA NO ESPECÍFICA"
  },
  {
    "codigo":102951002,
    "descripcion":"RELACIÓN SEXUAL ABUSIVA CON LA PAREJA"
  },
  {
    "codigo":397863003,
    "descripcion":"PACIENTE QUE SE DEJÓ SIN ATENDER"
  },
  {
    "codigo":1217063004,
    "descripcion":"SUPRESIÓN DE GLÁNDULA SUPRARRENAL"
  },
  {
    "codigo":365095007,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA SORTEAR ESQUINAS"
  },
  {
    "codigo":299559009,
    "descripcion":"HUESO PEQUEÑO EN PIE"
  },
  {
    "codigo":166652002,
    "descripcion":"NIVEL DE 5 - NUCLEOTIDASA SÉRICA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":35580009,
    "descripcion":"MORDIDA ABIERTA"
  },
  {
    "codigo":230353003,
    "descripcion":"ESCLEROSIS LAMINAR DE MOREL"
  },
  {
    "codigo":197585004,
    "descripcion":"NEFRITIS DIFUSA AGUDA"
  },
  {
    "codigo":721873007,
    "descripcion":"SÍNDROME DE JOUBERT CON DEFECTO OROFACIODIGITAL"
  },
  {
    "codigo":263121007,
    "descripcion":"LESIÓN DEL MENISCO DE LA ARTICULACIÓN TEMPOROMANDIBULAR"
  },
  {
    "codigo":228518000,
    "descripcion":"MASTICA PRODUCTOS QUE CONTIENEN TABACO"
  },
  {
    "codigo":15976741000119109,
    "descripcion":"NÓDULO DE TEJIDO CELULAR SUBCUTÁNEO DE AMBOS PULGARES"
  },
  {
    "codigo":64678009,
    "descripcion":"SÍNDROME DE AMENORREA - GALACTORREA"
  },
  {
    "codigo":783739005,
    "descripcion":"EPILEPSIA DE LÓBULO TEMPORAL FAMILIAR"
  },
  {
    "codigo":95611007,
    "descripcion":"HIPOVENTILACIÓN NEONATAL"
  },
  {
    "codigo":161147007,
    "descripcion":"HABLA BIEN INGLÉS"
  },
  {
    "codigo":290384003,
    "descripcion":"INTOXICACIÓN INTENCIONAL CON PIRENZEPINA"
  },
  {
    "codigo":192080009,
    "descripcion":"DEPRESIÓN CRÓNICA"
  },
  {
    "codigo":91941002,
    "descripcion":"ANAFILAXIA ALIMENTARIA"
  },
  {
    "codigo":303551000119107,
    "descripcion":"DEPÓSITO DE CALCIO EN BOLSA SEROSA DE RODILLA DERECHA"
  },
  {
    "codigo":126544009,
    "descripcion":"NEOPLASIA DE HUESO ETMOIDES"
  },
  {
    "codigo":288549002,
    "descripcion":"INCAPAZ DE REALIZAR ACTIVIDADES DE LAVADO Y SECADO DE SÍ MISMO"
  },
  {
    "codigo":124709007,
    "descripcion":"DEFICIENCIA DE FOSFORRIBOSILFORMILGLICINAMIDINA CICLO - LIGASA"
  },
  {
    "codigo":31321000119102,
    "descripcion":"DIABETES MELLITUS TIPO 1 SIN RETINOPATÍA"
  },
  {
    "codigo":10625471000119108,
    "descripcion":"BRONCONEUMONÍA CAUSADA POR PROTEUS MIRABILIS"
  },
  {
    "codigo":286714004,
    "descripcion":"RASGO DE LA PERSONALIDAD: CALIDEZ EMOCIONAL - HALLAZGO"
  },
  {
    "codigo":253946005,
    "descripcion":"CRECIMIENTO INSUFICIENTE PARCIAL DE LA EXTREMIDAD INFERIOR"
  },
  {
    "codigo":1204218005,
    "descripcion":"OCLUSIÓN ARTERIAL AGUDA POR TROMBOSIS"
  },
  {
    "codigo":219343001,
    "descripcion":"LESIÓN POR INSTRUMENTO CORTANTE, CON PROPÓSITO DESCONOCIDO"
  },
  {
    "codigo":1236986009,
    "descripcion":"ÚLCERA VARICOSA DE PIERNA"
  },
  {
    "codigo":448719004,
    "descripcion":"INFECCIÓN POSOPERATORIA DE VÍA AÉREA INFERIOR"
  },
  {
    "codigo":284879007,
    "descripcion":"NO SE CORTA LAS UÑAS DE LOS PIES"
  },
  {
    "codigo":283044000,
    "descripcion":"LESIÓN SUPERFICIAL DEL DORSO DEL PIE"
  },
  {
    "codigo":414116002,
    "descripcion":"PERLA PALATINA DE EPSTEIN"
  },
  {
    "codigo":20900005,
    "descripcion":"ENANISMO ASEXUAL NO FAMILIAR"
  },
  {
    "codigo":764808002,
    "descripcion":"HERNIA CRURAL IZQUIERDA IRREDUCTIBLE"
  },
  {
    "codigo":16906841000119106,
    "descripcion":"NEOPLASIA BENIGNA DE PIEL DE PÁRPADO SUPERIOR DERECHO"
  },
  {
    "codigo":250276008,
    "descripcion":"FORMA SEUDO PELGER-HUET"
  },
  {
    "codigo":248441000,
    "descripcion":"FIEBRE TERCIANA MALIGNA"
  },
  {
    "codigo":707193004,
    "descripcion":"CONDICIÓN DE DIENTE PILAR, SEVERAMENTE COMPROMETIDA, 3 SEXTANTES"
  },
  {
    "codigo":19065005,
    "descripcion":"FIEBRE DE LASSA"
  },
  {
    "codigo":1264249005,
    "descripcion":"CICATRIZ DE REGIÓN INFERIOR DE MUCOSA YUGAL DERECHA"
  },
  {
    "codigo":15678041000119108,
    "descripcion":"COROIDITIS DE OJO IZQUIERDO CAUSADA POR TOXOPLASMA GONDII"
  },
  {
    "codigo":246606004,
    "descripcion":"NERVIO CUBITAL - HALLAZGO"
  },
  {
    "codigo":17230005,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE UNA EXTREMIDAD"
  },
  {
    "codigo":1196878005,
    "descripcion":"ADENOMA DE VESÍCULA BILIAR"
  },
  {
    "codigo":48163001,
    "descripcion":"TRIPARESIA"
  },
  {
    "codigo":703523004,
    "descripcion":"ESPONDILOENCONDRODISPLASIA CON DESREGULACIÓN INMUNITARIA"
  },
  {
    "codigo":79096004,
    "descripcion":"MIOCARDITIS CAUSADA POR AGENTE FÍSICO"
  },
  {
    "codigo":111864006,
    "descripcion":"FIEBRE DE CHIKUNGUNYA"
  },
  {
    "codigo":15952781000119100,
    "descripcion":"NEOPLASIA BENIGNA DE AMBAS MAMAS"
  },
  {
    "codigo":46328008,
    "descripcion":"LESIÓN TRAUMÁTICA DE URÉTER SIN HERIDA ABIERTA HACIA CAVIDAD ABDOMINAL"
  },
  {
    "codigo":404941001,
    "descripcion":"LIMITACIÓN DE LA MOVILIDAD ARTICULAR CON PATRÓN CAPSULAR"
  },
  {
    "codigo":699853005,
    "descripcion":"DIENTE LABIAL ECTÓPICO"
  },
  {
    "codigo":110029007,
    "descripcion":"LUXACIÓN TRAUMÁTICA DE HUESO SEMILUNAR"
  },
  {
    "codigo":1156770004,
    "descripcion":"PSEUDO-OBSTRUCCIÓN INTESTINAL, NEURONAL"
  },
  {
    "codigo":1255074005,
    "descripcion":"ADENOCARCINOMA DE SENO FRONTAL"
  },
  {
    "codigo":75426006,
    "descripcion":"NEUMONÍA POR ASPIRACIÓN CAUSADA POR REGURGITACIÓN DE ALIMENTOS"
  },
  {
    "codigo":42658009,
    "descripcion":"TRASTORNO DEL SISTEMA NERVIOSO PERIFÉRICO"
  },
  {
    "codigo":235596005,
    "descripcion":"ESTENOSIS PÉPTICA DEL ESÓFAGO"
  },
  {
    "codigo":366668006,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA MANTENER EL EQUILIBRIO AL INCLINARSE"
  },
  {
    "codigo":301132007,
    "descripcion":"RUIDOS CARDÍACOS NORMALES"
  },
  {
    "codigo":1251404008,
    "descripcion":"CONTRACTURA CICATRIZAL CUTÁNEA POSQUIRÚRGICA"
  },
  {
    "codigo":69921001,
    "descripcion":"BRONCOLITIASIS"
  },
  {
    "codigo":364833005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA MOVERSE"
  },
  {
    "codigo":233761006,
    "descripcion":"SILICOSIS SUBAGUDA"
  },
  {
    "codigo":299297005,
    "descripcion":"AMPLITUD DE ROTACIÓN EXTERNA ACTIVA DE ARTICULACIÓN DE CADERA, NORMAL"
  },
  {
    "codigo":362998000,
    "descripcion":"ANOMALÍA DE HENDIDURA BRANQUIAL"
  },
  {
    "codigo":200993008,
    "descripcion":"PITIRIASIS FOLICULAR"
  },
  {
    "codigo":788982002,
    "descripcion":"MESOTELIOMA DE HÍGADO"
  },
  {
    "codigo":231926003,
    "descripcion":"DISTROFIA NEBULOSA DE LA CÓRNEA DE FRANCOIS"
  },
  {
    "codigo":723446006,
    "descripcion":"POLIDACTILIA DE DEDO ÍNDICE"
  },
  {
    "codigo":721611000,
    "descripcion":"ESOFAGITIS NEONATAL"
  },
  {
    "codigo":715001,
    "descripcion":"RUPTURA ATRAUMÁTICA DE LA URETRA"
  },
  {
    "codigo":66251001,
    "descripcion":"CONFIGURACIÓN DE PROTEÍNAS"
  },
  {
    "codigo":262859005,
    "descripcion":"CONTUSIÓN DE APÉNDICE ILEOCECAL"
  },
  {
    "codigo":293792005,
    "descripcion":"ALERGIA A ALCALOIDE DE LA VINCA"
  },
  {
    "codigo":457632005,
    "descripcion":"OBSTRUCCIÓN DE VÁLVULA MITRAL DEBIDA A NEOPLASIA"
  },
  {
    "codigo":31648009,
    "descripcion":"TRASTORNO DE CONDUCTA NO SOCIALIZADA NO AGRESIVO"
  },
  {
    "codigo":128117002,
    "descripcion":"ENFERMEDAD INFECCIOSA DEL SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":717941005,
    "descripcion":"HIPERLAXITUD CUTÁNEA CORPORAL DEBIDA A DEFICIENCIA DE FACTOR DE COAGULACIÓN DEPENDIENTE DE LA VITAMINA K"
  },
  {
    "codigo":16008231000119108,
    "descripcion":"ARTRITIS REACTIVA DE ARTICULACIÓN DE AMBAS REGIONES DE MUÑECA"
  },
  {
    "codigo":716106000,
    "descripcion":"COMPLEJO MIEMBROS-PARED CORPORAL"
  },
  {
    "codigo":290122005,
    "descripcion":"HALLAZGO RELACIONADO CON LA LACTANCIA"
  },
  {
    "codigo":1142090008,
    "descripcion":"TAQUICARDIA DE MACRORREENTRADA DEPENDIENTE DEL ISTMO CAVOTRICUSPÍDEO EN SENTIDO HORARIO"
  },
  {
    "codigo":58911001,
    "descripcion":"MIOCARDIOPATÍA DILATADA SECUNDARIA A GLUCOGENOSIS"
  },
  {
    "codigo":105651008,
    "descripcion":"ENFERMEDAD CAUSADA POR HAEMOGREGARINIDAE"
  },
  {
    "codigo":24308003,
    "descripcion":"DEFICIENCIA DE CISTATIONINA BETA - SINTASA"
  },
  {
    "codigo":335041000119106,
    "descripcion":"COROIDITIS DISEMINADA GENERALIZADA DE OJO DERECHO"
  },
  {
    "codigo":284617002,
    "descripcion":"INCITACIÓN"
  },
  {
    "codigo":1003678001,
    "descripcion":"CARDIOPATÍA POR TIROTOXICOSIS"
  },
  {
    "codigo":53406005,
    "descripcion":"OSTEOCONDROSIS VERTEBRAL JUVENIL"
  },
  {
    "codigo":118942006,
    "descripcion":"TRASTORNO DEL PERITONEO PÉLVICO"
  },
  {
    "codigo":282782006,
    "descripcion":"LESIÓN TRAUMÁTICA DE ESCROTO"
  },
  {
    "codigo":250014008,
    "descripcion":"MARCHA DE RODILLA RÍGIDA"
  },
  {
    "codigo":1263987001,
    "descripcion":"HEMORRAGIA INTRACEREBRAL NEONATAL PRECOZ"
  },
  {
    "codigo":1231219002,
    "descripcion":"DISFUNCIÓN DE PERCEPCIÓN VISUAL DEL MOVIMIENTO"
  },
  {
    "codigo":248179003,
    "descripcion":"LABIOS QUE HABITUALMENTE SE MANTIENEN JUNTOS"
  },
  {
    "codigo":315550009,
    "descripcion":"NACIDO EN ESTADOS UNIDOS DE AMÉRICA"
  },
  {
    "codigo":117107008,
    "descripcion":"ESTADO DE UNIDAD DE HEMODERIVADO NO CONTABILIZADO"
  },
  {
    "codigo":280947008,
    "descripcion":"FOBIA A EXÁMENES"
  },
  {
    "codigo":49736003,
    "descripcion":"PERIOSTOSIS SIN OSTEOMIELITIS"
  },
  {
    "codigo":15133000,
    "descripcion":"INFECCIÓN CAUSADA POR VAMPIROLEPIS"
  },
  {
    "codigo":768797001,
    "descripcion":"IRITIS DE OJO DERECHO DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":703261002,
    "descripcion":"MANNHEIMIA HAEMOLYTICA O BIBERSTEINIA TREHALOSI"
  },
  {
    "codigo":211741003,
    "descripcion":"FISIOLÓGICAMENTE JOVEN PARA LA EDAD"
  },
  {
    "codigo":408349003,
    "descripcion":"EFICACIA DE TODA LA MEDICACIÓN, VERIFICADA"
  },
  {
    "codigo":441117001,
    "descripcion":"NEOPLASIA NEGATIVA PARA RECEPTORES ESTROGÉNICOS"
  },
  {
    "codigo":308571000119107,
    "descripcion":"SINDACTILIA DE DEDOS DE PIE IZQUIERDO"
  },
  {
    "codigo":705096009,
    "descripcion":"INVERSIÓN PROFUNDA, SIMÉTRICA, ANTERIOR DE ONDA T"
  },
  {
    "codigo":208071000,
    "descripcion":"FRACTURA NO EXPUESTA DE SACRO CON LESIÓN COMPLETA DE COLA DE CABALLO"
  },
  {
    "codigo":240839006,
    "descripcion":"DESPIGMENTACIÓN POR ONCHOCERCA"
  },
  {
    "codigo":306375008,
    "descripcion":"VISTO EN EL SERVICIO DE ODONTOLOGÍA PEDIÁTRICA"
  },
  {
    "codigo":44231009,
    "descripcion":"DEFICIENCIA DE COLESTEROL MONOOXIGENASA (CLIVAJE DE LA CADENA LATERAL)"
  },
  {
    "codigo":76999009,
    "descripcion":"INFECCIÓN CAUSADA POR BRUGIA MALAYI"
  },
  {
    "codigo":75164001,
    "descripcion":"PSEUDOHERMAFRODITISMO"
  },
  {
    "codigo":1254812006,
    "descripcion":"DEPENDENCIA DE SUSTANCIAS"
  },
  {
    "codigo":402844009,
    "descripcion":"VÁRICES ABDOMINALES"
  },
  {
    "codigo":401009005,
    "descripcion":"DIFICULTAD PARA ESCUCHAR SUSURROS"
  },
  {
    "codigo":7793005,
    "descripcion":"TRASTORNO DE VÍA URINARIA INFERIOR"
  },
  {
    "codigo":399174000,
    "descripcion":"PACIENTE DIO CONSENTIMIENTO EN ENSAYO CLÍNICO"
  },
  {
    "codigo":366406001,
    "descripcion":"AMPLITUD DE LA FLEXIÓN DE COLUMNA DORSAL - HALLAZGO"
  },
  {
    "codigo":200731003,
    "descripcion":"INFLAMACIÓN DE CICATRIZ"
  },
  {
    "codigo":36891003,
    "descripcion":"ENFERMEDAD DE HARTNUP, TIPO YEYUNAL\/RENAL"
  },
  {
    "codigo":299035006,
    "descripcion":"DESVIACIÓN RADIAL DE LA MANO"
  },
  {
    "codigo":167963007,
    "descripcion":"PROTEÍNAS EN LÍQUIDO PLEURAL POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":262597001,
    "descripcion":"ASTILLA EN LA PIEL"
  },
  {
    "codigo":337551000119107,
    "descripcion":"HEMORRAGIA SUBCONJUNTIVAL DE OJO IZQUIERDO"
  },
  {
    "codigo":297200009,
    "descripcion":"SOBREDOSIS DE ANTIDEPRESIVO TRICÍCLICO"
  },
  {
    "codigo":426437004,
    "descripcion":"FIBROSIS PULMONAR FAMILIAR IDIOPÁTICA"
  },
  {
    "codigo":721349005,
    "descripcion":"FRACTURA DE QUINTA VÉRTEBRA CERVICAL"
  },
  {
    "codigo":295365004,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE RANITIDINA"
  },
  {
    "codigo":15984271000119108,
    "descripcion":"TUBERCULOSIS DE AMBOS OÍDOS"
  },
  {
    "codigo":293530001,
    "descripcion":"REACCIÓN ADVERSA A LA ERGOMETRINA"
  },
  {
    "codigo":719514002,
    "descripcion":"ENFERMEDAD DE CHARCOT-MARIE-TOOTH TIPO 2M AUTOSÓMICA DOMINANTE"
  },
  {
    "codigo":1145498003,
    "descripcion":"HIPOPLASIA CONGÉNITA DE PRIMER HUESO METACARPIANO"
  },
  {
    "codigo":129690006,
    "descripcion":"CON MAYOR RIESGO DE ALTERACIÓN EN EVACUACIÓN"
  },
  {
    "codigo":162458007,
    "descripcion":"PRESENTA EL SÍNTOMA MENSUALMENTE"
  },
  {
    "codigo":29551000,
    "descripcion":"ANEMIA CAUSADA POR OXÍGENO"
  },
  {
    "codigo":62319002,
    "descripcion":"MASTITIS DE CÉLULAS PLASMÁTICAS"
  },
  {
    "codigo":95087004,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA PIEL"
  },
  {
    "codigo":311081000119105,
    "descripcion":"MIOSITIS INTERSTICIAL DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":226159008,
    "descripcion":"DIETA RICA EN FOSFATO"
  },
  {
    "codigo":291695008,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ÁCIDO PARAAMINOSALICÍLICO"
  },
  {
    "codigo":11861801000119106,
    "descripcion":"RUPTURA DE LIGAMENTO CRUZADO ANTERIOR DE RODILLA IZQUIERDA"
  },
  {
    "codigo":420932006,
    "descripcion":"ATAXIA EPISÓDICA DEL TIPO 2"
  },
  {
    "codigo":289860007,
    "descripcion":"ERITEMA DE PERINEO FEMENINO"
  },
  {
    "codigo":93252006,
    "descripcion":"HIPOPLASIA CONGÉNITA DE EPIDÍDIMO"
  },
  {
    "codigo":60484009,
    "descripcion":"PRONÓSTICO CONDICIONAL"
  },
  {
    "codigo":11779881000119107,
    "descripcion":"HERIDA DE ANTEBRAZO IZQUIERDO DEBIDA A PICADURA DE INSECTO NO VENENOSO"
  },
  {
    "codigo":25881005,
    "descripcion":"ERITROCITOSIS CAUSADA POR BAJA PRESIÓN ATMOSFÉRICA"
  },
  {
    "codigo":419097006,
    "descripcion":"ENFERMEDAD DE DANON"
  },
  {
    "codigo":124185005,
    "descripcion":"DEFICIENCIA DE NADPH - FERRIHEMOPROTEÍNA REDUCTASA"
  },
  {
    "codigo":56814003,
    "descripcion":"CABALGAMIENTO DE LOS DEDOS"
  },
  {
    "codigo":417262009,
    "descripcion":"FLEXIÓN BILATERAL DEL SACRO"
  },
  {
    "codigo":253422009,
    "descripcion":"DEFECTO DEL TABIQUE AURICULOVENTRICULAR - COMPONENTE VENTRICULAR DEBAJO DE VALVA INFERIOR EN PUENTE"
  },
  {
    "codigo":1003416001,
    "descripcion":"DUPLICACIÓN DE PORCIÓN MEDIA DE CROMOSOMA 13"
  },
  {
    "codigo":446360001,
    "descripcion":"LACERACIÓN PROFUNDA DE TOBILLO"
  },
  {
    "codigo":249752003,
    "descripcion":"MANO GRANDE"
  },
  {
    "codigo":282520003,
    "descripcion":"BAJA ESCALONES CORRIENDO"
  },
  {
    "codigo":20376005,
    "descripcion":"ENFERMEDAD NEOPLÁSICA BENIGNA"
  },
  {
    "codigo":11808861000119100,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE REGIÓN DE CADERA IZQUIERDA"
  },
  {
    "codigo":315288007,
    "descripcion":"RETINOPATÍA HERPÉTICA NECROSANTE"
  },
  {
    "codigo":708504008,
    "descripcion":"OSTEOSARCOMA PERIÓSTICO DE MANDÍBULA"
  },
  {
    "codigo":1362029007,
    "descripcion":"CONDUCTO PULPAR FURCAL DE DIENTE"
  },
  {
    "codigo":247917007,
    "descripcion":"CATATONÍA"
  },
  {
    "codigo":213314004,
    "descripcion":"INFECCIÓN POSTERIOR A INYECCIÓN"
  },
  {
    "codigo":340061000119103,
    "descripcion":"ESTENOSIS DE PUNTO LAGRIMAL DE PÁRPADO IZQUIERDO"
  },
  {
    "codigo":1260055001,
    "descripcion":"CICATRIZ DE LENGUA"
  },
  {
    "codigo":735767003,
    "descripcion":"LACERACIÓN DE VASO SANGUÍNEO INTERCOSTAL"
  },
  {
    "codigo":47639008,
    "descripcion":"QUISTE PILONIDAL"
  },
  {
    "codigo":702999009,
    "descripcion":"MYCOBACTERIUM XENOPI O MYCOBACTERIUM CELATUM"
  },
  {
    "codigo":78572006,
    "descripcion":"DISPLASIA NEUROECTODÉRMICA"
  },
  {
    "codigo":13036008,
    "descripcion":"COMPLICACIÓN POR LA COLOCACIÓN DE UN DISPOSITIVO ELECTRÓNICO INTERNO"
  },
  {
    "codigo":371649005,
    "descripcion":"RESTOS DE CUERPO CREMADO"
  },
  {
    "codigo":240577006,
    "descripcion":"INFECCIÓN GONOCÓCICA DE LA GLÁNDULA DE LITTRE"
  },
  {
    "codigo":109505006,
    "descripcion":"APIÑAMIENTO DENTAL DEBIDO A DIENTES SUPERNUMERARIOS"
  },
  {
    "codigo":9366002,
    "descripcion":"MIOCLONÍA PALATINA"
  },
  {
    "codigo":1156246002,
    "descripcion":"TELANGIECTASIA RETINIANA PERIFÉRICA ADQUIRIDA"
  },
  {
    "codigo":238742005,
    "descripcion":"ACNÉ QUELOIDAL"
  },
  {
    "codigo":42134006,
    "descripcion":"DISTORSIÓN DE LA IMAGEN VISUAL"
  },
  {
    "codigo":74902008,
    "descripcion":"INTOXICACIÓN POR OLEANDOMICINA"
  },
  {
    "codigo":402582009,
    "descripcion":"DERMATITIS IRRITATIVA POR CONTACTO CAUSADA POR SOLVENTE"
  },
  {
    "codigo":204139003,
    "descripcion":"CATARATA MEMBRANOSA CONGÉNITA"
  },
  {
    "codigo":73067008,
    "descripcion":"ANEURISMA AÓRTICO ROTO"
  },
  {
    "codigo":398912001,
    "descripcion":"PÉRDIDA DE COLOR"
  },
  {
    "codigo":366144002,
    "descripcion":"HALLAZGO EN EL RITMO RESPIRATORIO"
  },
  {
    "codigo":890432001,
    "descripcion":"SÍNDROME DE COCKAYNE TIPO 3"
  },
  {
    "codigo":235072005,
    "descripcion":"CANDIDIASIS HIPERPLÁSICA CRÓNICA"
  },
  {
    "codigo":69397000,
    "descripcion":"BLEFAROCONJUNTIVITIS ANGULAR"
  },
  {
    "codigo":300608009,
    "descripcion":"INCAPAZ DE REALIZAR ACTIVIDADES RELACIONADAS CON LOS VIAJES"
  },
  {
    "codigo":169536009,
    "descripcion":"SUSPENDE EL USO DE MÉTODO SINTOTÉRMICO ANTICONCEPTIVO"
  },
  {
    "codigo":67831000119107,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA MICROCÍTICA DE PULMÓN, ESTADIO TNM 3"
  },
  {
    "codigo":724757005,
    "descripcion":"SÍNTOMAS DEPRESIVOS DEBIDOS A TRASTORNO PSICÓTICO PRIMARIO"
  },
  {
    "codigo":36629006,
    "descripcion":"LEGALMENTE CASADO"
  },
  {
    "codigo":266005008,
    "descripcion":"INFECCIÓN CAUSADA POR ERYSIPELOTHRIX RHUSIOPATHIAE"
  },
  {
    "codigo":722922001,
    "descripcion":"EPISTAXIS NEONATAL"
  },
  {
    "codigo":1279978002,
    "descripcion":"COMPRESIÓN DE NERVIO MUSCULOCUTÁNEO"
  },
  {
    "codigo":1148906001,
    "descripcion":"LEUCEMIA MIELOIDE AGUDA CON TRANSLOCACIÓN T(8;21)(Q22;Q22) RUNX1-RUNX1T1"
  },
  {
    "codigo":1281813008,
    "descripcion":"DESPRENDIMIENTO PARCIAL DE RETINA CON ROTURA ÚNICA DE RETINA"
  },
  {
    "codigo":65727000,
    "descripcion":"EMBARAZO INTRAUTERINO"
  },
  {
    "codigo":295103004,
    "descripcion":"ALERGIA A BETAHISTINA"
  },
  {
    "codigo":1343679005,
    "descripcion":"ARTRITIS DE ARTICULACIÓN DE REGIÓN DE MUÑECA DEBIDA A INMUNIZACIÓN Y POSTERIOR A ELLA"
  },
  {
    "codigo":721087008,
    "descripcion":"SÍNDROME DE SORDERA Y DISCAPACIDAD INTELECTUAL, TIPO MARTIN PROBST"
  },
  {
    "codigo":16097681000119105,
    "descripcion":"ARTROFIBROSIS DE ARTICULACIÓN DE MANO IZQUIERDA"
  },
  {
    "codigo":31124001,
    "descripcion":"XANTOGRANULOMA RETROPERITONEAL"
  },
  {
    "codigo":194964003,
    "descripcion":"MANCHAS DE LECHE PERICÁRDICAS"
  },
  {
    "codigo":719252002,
    "descripcion":"ATAXIA ESPINOCEREBELOSA TIPO 27"
  },
  {
    "codigo":15688081000119106,
    "descripcion":"CAPSULITIS DE ARTICULACIÓN METATARSOFALÁNGICA DE PIE DERECHO"
  },
  {
    "codigo":342571000119100,
    "descripcion":"DERMATITIS ECCEMATOSA DE PÁRPADO IZQUIERDO"
  },
  {
    "codigo":293268003,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR HORMONA ANTIDIURÉTICA"
  },
  {
    "codigo":424340000,
    "descripcion":"COMA HEPÁTICO DEBIDO A HEPATITIS B CRÓNICA"
  },
  {
    "codigo":225897003,
    "descripcion":"SONRÍE ESPONTÁNEAMENTE"
  },
  {
    "codigo":193129003,
    "descripcion":"COMPRESIÓN DE NERVIO MEDIANO A NIVEL DEL ANTEBRAZO"
  },
  {
    "codigo":94825003,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL ESÓFAGO"
  },
  {
    "codigo":1208937004,
    "descripcion":"SÍNDROME DE DEPLECIÓN DE ADN MITOCONDRIAL, FORMA ENCEFALOMIOPÁTICA CON ANOMALÍAS CRANEOFACIALES VARIABLES"
  },
  {
    "codigo":11837841000119108,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO INTRÍNSECO DE DEDO ÍNDICE IZQUIERDO"
  },
  {
    "codigo":291433007,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR NISTATINA"
  },
  {
    "codigo":289598001,
    "descripcion":"VAGINA HÚMEDA"
  },
  {
    "codigo":1010494008,
    "descripcion":"AGENESIA DE PLIEGUE CUTÁNEO INTERFALÁNGICO PROXIMAL"
  },
  {
    "codigo":713747004,
    "descripcion":"NEOPLASIA DE NERVIO ESPINAL SACRO"
  },
  {
    "codigo":254995004,
    "descripcion":"HEMANGIOPERICITOMA MALIGNO DE ÓRBITA"
  },
  {
    "codigo":123923006,
    "descripcion":"INTOXICACIÓN POR RHAMNACEAE"
  },
  {
    "codigo":46191000087102,
    "descripcion":"FRACTURA DE FALANGE DE CUARTO DEDO DE PIE IZQUIERDO"
  },
  {
    "codigo":91155009,
    "descripcion":"ABSCESO CRÓNICO DEL FONDO DE SACO DE DOUGLAS"
  },
  {
    "codigo":386067009,
    "descripcion":"TRASTORNO RELACIONADO CON LA VITAMINA B12"
  },
  {
    "codigo":208659005,
    "descripcion":"FRACTURA EXPUESTA DE TOBILLO, MALÉOLO EXTERNO, INFERIOR"
  },
  {
    "codigo":41071000087108,
    "descripcion":"CELULITIS DE QUINTO DEDO DE PIE IZQUIERDO"
  },
  {
    "codigo":253160006,
    "descripcion":"COLPOCEFALIA"
  },
  {
    "codigo":449768007,
    "descripcion":"GINGIVITIS LIQUENOIDE POR CUERPO EXTRAÑO"
  },
  {
    "codigo":315026000,
    "descripcion":"ISQUEMIA MIOCÁRDICA TRANSITORIA"
  },
  {
    "codigo":21949009,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA DE DEDO DEL PIE"
  },
  {
    "codigo":447933008,
    "descripcion":"COMUNICACIÓN INTERAURICULAR NO FENESTRADA EN LA FOSA OVAL"
  },
  {
    "codigo":413330005,
    "descripcion":"VÍCTIMA DE OPRESIÓN EN EL PAÍS DE ORIGEN"
  },
  {
    "codigo":249490005,
    "descripcion":"SALIDA DEL ALIMENTO POR LA NARIZ"
  },
  {
    "codigo":247655004,
    "descripcion":"PENSAMIENTOS DESINHIBIDOS"
  },
  {
    "codigo":51047007,
    "descripcion":"FUNCIÓN VESICULAR ANORMAL"
  },
  {
    "codigo":1263463009,
    "descripcion":"DISPLASIA RIZOMÉLICA"
  },
  {
    "codigo":1228860003,
    "descripcion":"DISPLASIA ESPONDILOEPIFISARIA TIPO STANESCU"
  },
  {
    "codigo":737340007,
    "descripcion":"TRASTORNO PSICÓTICO CAUSADO POR CANABINOIDE SINTÉTICO"
  },
  {
    "codigo":409660009,
    "descripcion":"NEOPLASIA BENIGNA DE NERVIO PERIFÉRICO"
  },
  {
    "codigo":211217002,
    "descripcion":"PICADURA DE INSECTO, NO VENENOSO, EN LA AXILA"
  },
  {
    "codigo":786483005,
    "descripcion":"HIPERACTIVIDAD NEUROGÉNICA DE DETRUSOR"
  },
  {
    "codigo":309521004,
    "descripcion":"ENTUMECIMIENTO DE MANO"
  },
  {
    "codigo":278588009,
    "descripcion":"EMPASTE DENTAL FRACTURADO"
  },
  {
    "codigo":735505006,
    "descripcion":"QUEMADURA PROFUNDA DE TERCER GRADO DE PERINEO"
  },
  {
    "codigo":1259793007,
    "descripcion":"FIBROEPITELIOMA PRIMARIO DE PINKUS"
  },
  {
    "codigo":12774002,
    "descripcion":"MORFOLOGÍA DE COLONIA BACTERIANA, BORDE COMPLETO"
  },
  {
    "codigo":897510005,
    "descripcion":"TRISOMÍA DISTAL 3Q"
  },
  {
    "codigo":307686007,
    "descripcion":"ONDAS CUADRADAS OCULARES"
  },
  {
    "codigo":1354427000,
    "descripcion":"OCLUSIÓN DE VENA TEMPORAL INFERIOR DE RETINA"
  },
  {
    "codigo":830139001,
    "descripcion":"EDEMA DE ABDOMEN"
  },
  {
    "codigo":209382009,
    "descripcion":"FRACTURA-SUBLUXACIÓN EXPUESTA DE ARTICULACIÓN TARSOMETATARSIANA"
  },
  {
    "codigo":109243005,
    "descripcion":"ABSCESO DE LA REGIÓN SUBTEMPORAL"
  },
  {
    "codigo":240315006,
    "descripcion":"FRACTURA DE NARIZ POR TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":43707008,
    "descripcion":"ANEMIA CAUSADA POR CALOR"
  },
  {
    "codigo":404155008,
    "descripcion":"SARCOMA GRANULOCÍTICO QUE AFECTA PIEL"
  },
  {
    "codigo":402320002,
    "descripcion":"PSORIASIS DE CARA"
  },
  {
    "codigo":305851008,
    "descripcion":"ATENDIDO POR SERVICIO DE NUTRICIÓN HOSPITALARIO"
  },
  {
    "codigo":238480005,
    "descripcion":"PALMA NEGRA"
  },
  {
    "codigo":369552005,
    "descripcion":"NEOPLASIA MALIGNA QUE COMPROMETE TROMPA DE FALOPIO DERECHA POR PROPAGACIÓN DIRECTA DESDE VAGINA"
  },
  {
    "codigo":345081000119100,
    "descripcion":"PTOSIS MIÓGENA DE AMBOS OJOS"
  },
  {
    "codigo":171109003,
    "descripcion":"CRIBADO - NO SE DETECTARON ANOMALÍAS"
  },
  {
    "codigo":236645006,
    "descripcion":"OBSTRUCCIÓN DE TRACTO DE SALIDA DE VEJIGA URINARIA"
  },
  {
    "codigo":105573007,
    "descripcion":"DEBILIDAD ESPIRITUAL"
  },
  {
    "codigo":15746041000119102,
    "descripcion":"INESTABILIDAD DE ARTICULACIÓN DE AMBOS CODOS"
  },
  {
    "codigo":1119546001,
    "descripcion":"NARIZ GRANDE CON FORMA DE PICO"
  },
  {
    "codigo":16018271000119108,
    "descripcion":"INESTABILIDAD DE ARTICULACIÓN DE AMBOS PIES"
  },
  {
    "codigo":890170007,
    "descripcion":"DERMATITIS ALÉRGICA POR CONTACTO CON AMBROSÍA"
  },
  {
    "codigo":300346007,
    "descripcion":"LESIÓN DE VESÍCULA BILIAR"
  },
  {
    "codigo":726330007,
    "descripcion":"LACERACIÓN DE TENDÓN DE MÚSCULO INTRÍNSECO DEL PIE"
  },
  {
    "codigo":298511004,
    "descripcion":"SIN AMPLITUD DE FLEXIÓN ACTIVA DE LA COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":296676002,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE CEFALEXINA"
  },
  {
    "codigo":1345252004,
    "descripcion":"RADIOGRAFÍA SIMPLE DE SISTEMA GENITOURINARIO ANORMAL"
  },
  {
    "codigo":318611000119100,
    "descripcion":"BURSITIS PRERROTULIANA DE RODILLA DERECHA"
  },
  {
    "codigo":294841000,
    "descripcion":"ALERGIA A CALCITONINA PORCINA"
  },
  {
    "codigo":131001005,
    "descripcion":"HORMONA LIBERADORA DE CORTICOTROFINA ANORMAL"
  },
  {
    "codigo":720825005,
    "descripcion":"LEUCOENCEFALOPATÍA QUÍSTICA SIN MEGALENCEFALIA"
  },
  {
    "codigo":196537007,
    "descripcion":"INFLAMACIÓN SUPURATIVA DE PARTES BLANDAS DE LA BOCA"
  },
  {
    "codigo":424078005,
    "descripcion":"ADENOCARCINOMA DE PULMÓN, ESTADIO I"
  },
  {
    "codigo":293006007,
    "descripcion":"REACCIÓN ADVERSA A CEFALOSPORINA DE TERCERA GENERACIÓN"
  },
  {
    "codigo":129166009,
    "descripcion":"LUXACIÓN ARTICULAR TRAUMÁTICA DE VÉRTEBRA LUMBAR"
  },
  {
    "codigo":1144974009,
    "descripcion":"SÍNDROME ANTISINTETASA DEBIDO A POLIMIOSITIS"
  },
  {
    "codigo":717155003,
    "descripcion":"COLESTASIS INTRAHEPÁTICA NEONATAL DEBIDA A DEFICIENCIA DE CITRINA"
  },
  {
    "codigo":225635005,
    "descripcion":"ANSIEDAD ACERCA DEL TRATAMIENTO"
  },
  {
    "codigo":782691006,
    "descripcion":"DISOMÍA UNIPARENTAL MATERNA DE CROMOSOMA 21"
  },
  {
    "codigo":291171007,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR PERICIAZINA"
  },
  {
    "codigo":289336004,
    "descripcion":"CLIP DEL CORDÓN UMBILICAL: DEBE SER RETIRADO"
  },
  {
    "codigo":92728007,
    "descripcion":"CARCINOMA IN SITU DE LA PIEL DE LA FRENTE"
  },
  {
    "codigo":1303309001,
    "descripcion":"NO APTO PARA BENEFICIO"
  },
  {
    "codigo":1991000124105,
    "descripcion":"AUTODERIVADO"
  },
  {
    "codigo":189197001,
    "descripcion":"HEMANGIOMA DE ESTRUCTURA INTRABDOMINAL"
  },
  {
    "codigo":254733003,
    "descripcion":"MELANOMA MALIGNO ORIGINADO EN UN NEVO INTRADÉRMICO"
  },
  {
    "codigo":123661007,
    "descripcion":"VENA LEVOAURICULOCARDINAL"
  },
  {
    "codigo":1268706003,
    "descripcion":"TUMOR DE CÉLULAS DE LA GRANULOSA MALIGNO PRIMARIO DE OVARIO"
  },
  {
    "codigo":89058008,
    "descripcion":"TIMPANOESCLEROSIS QUE COMPROMETE A LA MEMBRANA TIMPÁNICA, A LOS HUESECILLOS DEL OÍDO Y AL OÍDO MEDIO"
  },
  {
    "codigo":447671002,
    "descripcion":"DEFECTO DEL TABIQUE INTERVENTRICULAR CON MALA ALINEACIÓN POSTERIOR DEL TABIQUE CORRESPONDIENTE AL TRACTO DE SALIDA Y CABALGAMIENTO DE VÁLVULA AÓRTICA"
  },
  {
    "codigo":283831006,
    "descripcion":"MORDEDURA DE ANIMAL EN EL PIE"
  },
  {
    "codigo":314764001,
    "descripcion":"TRASTORNO DE LICUEFACCIÓN CORNEAL"
  },
  {
    "codigo":52620003,
    "descripcion":"ATROFIA URETRAL"
  },
  {
    "codigo":707980005,
    "descripcion":"EXACERBACIÓN SEVERA AGUDA DE ASMA MODERADA PERSISTENTE"
  },
  {
    "codigo":247393000,
    "descripcion":"NEURALGIA DE NERVIO ILIOINGUINAL"
  },
  {
    "codigo":1197665000,
    "descripcion":"ENTEROLITO DE INTESTINO GRUESO"
  },
  {
    "codigo":312929003,
    "descripcion":"RETINOPATÍA EXTERNA OCULTA ZONAL AGUDA"
  },
  {
    "codigo":83553004,
    "descripcion":"RASGO DE PERSONALIDAD QUE CAUSA UNA DISFUNCIÓN LABORAL"
  },
  {
    "codigo":347591000119101,
    "descripcion":"CATARATA CORTICAL SENIL DE AMBOS OJOS"
  },
  {
    "codigo":1163062005,
    "descripcion":"ENCEFALITIS POR VIRUS LINFOTRÓPICO DE CÉLULAS T HUMANAS TIPO 2"
  },
  {
    "codigo":16182006,
    "descripcion":"ENFERMEDAD CAUSADA POR PNEUMOVIRUS"
  },
  {
    "codigo":276491000,
    "descripcion":"DERIVADO POR MIEMBRO DEL EQUIPO DE ATENCIÓN PRIMARIA DE LA SALUD"
  },
  {
    "codigo":79883001,
    "descripcion":"QUISTE DE OVARIO"
  },
  {
    "codigo":10751431000119104,
    "descripcion":"INFECCIÓN DEL TRACTO URINARIO DEBIDA A EMBARAZO ECTÓPICO"
  },
  {
    "codigo":210955005,
    "descripcion":"SECUELAS DE LESIÓN DE OJO Y ÓRBITA OCULAR"
  },
  {
    "codigo":768011006,
    "descripcion":"EFECTO TARDÍO DE INTENTO DE HOMICIDIO"
  },
  {
    "codigo":1259531005,
    "descripcion":"DEMENCIA DEBIDA A ENCEFALOPATÍA HIPERTENSIVA"
  },
  {
    "codigo":897248001,
    "descripcion":"CURVATURA ANORMAL DE FALANGE MEDIA DE PIE"
  },
  {
    "codigo":307424002,
    "descripcion":"CELULITIS DEL ANO O EL RECTO"
  },
  {
    "codigo":241888003,
    "descripcion":"ANTIHONGOS QUE CAUSA EFECTOS TÓXICOS"
  },
  {
    "codigo":372960001,
    "descripcion":"INFECCIÓN CAUSADA POR PENICILLIUM PALITANS"
  },
  {
    "codigo":209120006,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DEL CARTÍLAGO LARÍNGEO"
  },
  {
    "codigo":78048006,
    "descripcion":"CANDIDIASIS"
  },
  {
    "codigo":733408008,
    "descripcion":"FRACTURA DE CÓNDILO EXTERNO DE HÚMERO"
  },
  {
    "codigo":45280006,
    "descripcion":"ASPECTO DE LA SUPERFICIE DE UNA COLONIA BACTERIANA, BRILLANTE"
  },
  {
    "codigo":240053005,
    "descripcion":"MIOPATÍA HEREDITARIA LIMITADA A LA MUJER"
  },
  {
    "codigo":403893006,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS DE LA FRENTE"
  },
  {
    "codigo":371125006,
    "descripcion":"HIPERTENSIÓN ESENCIAL LÁBIL"
  },
  {
    "codigo":305589008,
    "descripcion":"BAJO ATENCIÓN DE PSICOTERAPEUTA"
  },
  {
    "codigo":860810005,
    "descripcion":"NEUROPATÍA AUTONÓMICA SENSITIVA HEREDITARIA TIPO IIB"
  },
  {
    "codigo":762506007,
    "descripcion":"DELIRIO CAUSADO POR CATINONA SINTÉTICA"
  },
  {
    "codigo":432991000,
    "descripcion":"SÍNDROME INTERMEDIO"
  },
  {
    "codigo":236383002,
    "descripcion":"ESCLEROSIS MESANGIAL FAMILIAR"
  },
  {
    "codigo":301919003,
    "descripcion":"EXOFTALMÍA PRESENTE"
  },
  {
    "codigo":72543004,
    "descripcion":"FETO MUERTO INMADURO, SEXO INDETERMINADO (500 - 999 GRAMOS)"
  },
  {
    "codigo":269151006,
    "descripcion":"LESIÓN INTERNA DE TÓRAX, ABDOMEN Y PELVIS"
  },
  {
    "codigo":234548000,
    "descripcion":"DEFICIENCIA DE INMUNOGLOBULINA G3"
  },
  {
    "codigo":201780002,
    "descripcion":"ARTRITIS REUMATOIDE DE LA ARTICULACIÓN SUBASTRAGALINA"
  },
  {
    "codigo":300084009,
    "descripcion":"OÍDO PRESENTE"
  },
  {
    "codigo":365620009,
    "descripcion":"EDAD MADURATIVA DE LOS GLÓBULOS ROJOS - HALLAZGO"
  },
  {
    "codigo":298249004,
    "descripcion":"HALLAZGO RELACIONADO CON LA SENSIBILIDAD ARTICULAR"
  },
  {
    "codigo":34270000,
    "descripcion":"ABORTO ESPONTÁNEO COMPLICADO POR CHOQUE"
  },
  {
    "codigo":724233009,
    "descripcion":"SENSACIÓN DE ESTAR FRÍO"
  },
  {
    "codigo":396553008,
    "descripcion":"TUMOR SOBREELEVADO"
  },
  {
    "codigo":296414003,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE CLORFENAMINA"
  },
  {
    "codigo":12199521000119109,
    "descripcion":"FALLA MECÁNICA DE PRÓTESIS ARTICULAR DE RODILLA IZQUIERDA"
  },
  {
    "codigo":11789921000119109,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE DEDO ANULAR IZQUIERDO"
  },
  {
    "codigo":67038005,
    "descripcion":"PROCTITIS ULCEROSA INESPECÍFICA"
  },
  {
    "codigo":294579003,
    "descripcion":"ALERGIA A MAFENIDA"
  },
  {
    "codigo":11837961000119100,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO INTRÍNSECO DE DEDO ANULAR DERECHO"
  },
  {
    "codigo":635116041000119100,
    "descripcion":"HEMANGIONA CAVERNOSO DE CEREBRO ESPORÁDICO"
  },
  {
    "codigo":90121000119102,
    "descripcion":"EDENTULISMO PARCIAL CLASE IV"
  },
  {
    "codigo":305161000119102,
    "descripcion":"HIPERLORDOSIS CONGÉNITA DE COLUMNA LUMBAR"
  },
  {
    "codigo":521000119104,
    "descripcion":"CISTITIS AGUDA EN EL EMBARAZO, PREPARTO"
  },
  {
    "codigo":15747081000119105,
    "descripcion":"LESIÓN DE CANTO IZQUIERDO"
  },
  {
    "codigo":784264002,
    "descripcion":"PORTADOR DE ENTEROBACTERIACEAE PRODUCTORAS DE BETA-LACTAMASA DE ESPECTRO AMPLIADO"
  },
  {
    "codigo":1083401000119107,
    "descripcion":"OTITIS MEDIA CRÓNICA DE AMBOS OÍDOS LUEGO DE LA INSERCIÓN DE DISPOSITIVO DE VENTILACIÓN TIMPÁNICA"
  },
  {
    "codigo":335881000119108,
    "descripcion":"DEGENERACIÓN DE CUERPO CILIAR DE OJO DERECHO"
  },
  {
    "codigo":15713801000119109,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE CADERA DERECHA"
  },
  {
    "codigo":15724041000119109,
    "descripcion":"ENTESOPATÍA DE AMBOS TOBILLOS"
  },
  {
    "codigo":1144712007,
    "descripcion":"HIPOPLASIA DE FALANGE DISTAL DE QUINTO DEDO DE PIE"
  },
  {
    "codigo":292744001,
    "descripcion":"REACCIÓN ADVERSA AL DIMERCAPROL"
  },
  {
    "codigo":323081000119104,
    "descripcion":"LONGITUD DESIGUAL DE EXTREMIDAD INFERIOR DEBIDA A ACORTAMIENTO ADQUIRIDO DE TIBIA IZQUIERDA"
  },
  {
    "codigo":15716361000119105,
    "descripcion":"ENOSTOSIS DE AMBOS FÉMURES"
  },
  {
    "codigo":15711241000119106,
    "descripcion":"TROMBOSIS AGUDA DE VENA PROFUNDA DE MIEMBRO INFERIOR DERECHO POSTERIOR A PROCEDIMIENTO"
  },
  {
    "codigo":888996361000119108,
    "descripcion":"DERMATITIS POR CONTACTO CAUSADA POR MEDICACIÓN"
  },
  {
    "codigo":15688201000119108,
    "descripcion":"CAPSULITIS DE ARTICULACIÓN METATARSOFALÁNGICA DE AMBOS PIES"
  },
  {
    "codigo":15677961000119109,
    "descripcion":"CORIORRETINITIS DE OJO IZQUIERDO CAUSADA POR CITOMEGALOVIRUS HUMANO BETA 5"
  },
  {
    "codigo":94301000,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL PERONÉ"
  },
  {
    "codigo":1208413008,
    "descripcion":"MIOPATÍA CONGÉNITA POR DESPROPORCIÓN DEL TIPO DE FIBRA DEBIDA A MUTACIÓN DE ACTA1 (ALFA ACTINA 1)"
  },
  {
    "codigo":532502421000119102,
    "descripcion":"MELANOMA IN SITU DE PIEL DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":289074001,
    "descripcion":"INCAPAZ DE CORTAR LOS ALIMENTOS"
  },
  {
    "codigo":59698003,
    "descripcion":"TRASTORNO DE LA CONJUNTIVA"
  },
  {
    "codigo":715058004,
    "descripcion":"INTOXICACIÓN CAUSADA POR NOREPINEFRINA"
  },
  {
    "codigo":420146005,
    "descripcion":"DEGENERACIÓN CEREBRAL ASOCIADA CON LIPIDOSIS GENERALIZADA"
  },
  {
    "codigo":92466006,
    "descripcion":"NEOPLASIA BENIGNA DE LA URETRA"
  },
  {
    "codigo":677781000119104,
    "descripcion":"OCLUSIÓN DE RAMA IZQUIERDA DE ARTERIA DE LA RETINA"
  },
  {
    "codigo":1087381000119104,
    "descripcion":"HERNIA PARAESOFÁGICA INCARCERADA"
  },
  {
    "codigo":1335815005,
    "descripcion":"HEMORRAGIA EXCESIVA DEBIDA A TRASTORNO DE COAGULACIÓN"
  },
  {
    "codigo":1237511005,
    "descripcion":"ENFERMEDAD DE TEJIDO CONECTIVO ASOCIADA AL GEN EMILIN-1"
  },
  {
    "codigo":254471005,
    "descripcion":"NEOPLASIA DE SENO MASTOIDEO"
  },
  {
    "codigo":90631008,
    "descripcion":"ESGUINCE DE LIGAMENTO SACROCOCCÍGEO"
  },
  {
    "codigo":57863006,
    "descripcion":"DEFICIENCIA DE FOSFATASA ÁCIDA"
  },
  {
    "codigo":23260002,
    "descripcion":"FIBROADENOSIS DE MAMA"
  },
  {
    "codigo":449244003,
    "descripcion":"MOVILIDAD ANORMAL DEL TABIQUE INTERVENTRICULAR"
  },
  {
    "codigo":187100003,
    "descripcion":"MUCORMICOSIS RINOCEREBRAL"
  },
  {
    "codigo":185265000,
    "descripcion":"ATENDIDO EN CONSULTORIO ESPECIALIZADO EN EMERGENCIAS"
  },
  {
    "codigo":840625002,
    "descripcion":"ÚTERO GRÁVIDO DE TAMAÑO CORRESPONDIENTE A 12-16 SEMANAS"
  },
  {
    "codigo":16052271000119102,
    "descripcion":"TENDINITIS DE AMBOS CODOS"
  },
  {
    "codigo":283569009,
    "descripcion":"HERIDA DE PERDIGÓN EN DEDO DE LA MANO"
  },
  {
    "codigo":248966006,
    "descripcion":"MENSTRUACIONES PROLONGADAS"
  },
  {
    "codigo":17755000,
    "descripcion":"MEGADUODENO ADQUIRIDO"
  },
  {
    "codigo":1363078009,
    "descripcion":"ASTILLA EN DEDO DE PIE"
  },
  {
    "codigo":312667002,
    "descripcion":"FONDO DE SACO DE DOUGLAS NORMAL"
  },
  {
    "codigo":83291003,
    "descripcion":"CORAZÓN PULMONAR"
  },
  {
    "codigo":771419005,
    "descripcion":"DELIRIO HIPERACTIVO LUEGO DE PROCEDIMIENTO QUIRÚRGICO"
  },
  {
    "codigo":281864001,
    "descripcion":"HEMATOMA INTRACRANEAL SUBDURAL NO TRAUMÁTICO"
  },
  {
    "codigo":247131008,
    "descripcion":"DEPÓSITOS DE LÍPIDOS EN RETINA"
  },
  {
    "codigo":323631000119106,
    "descripcion":"TUMOR TENOSINOVIAL DE CÉLULAS GIGANTES DIFUSO DE ARTICULACIÓN GLENOHUMERAL IZQUIERDA"
  },
  {
    "codigo":409136006,
    "descripcion":"ALERGIA A LEGUMBRES"
  },
  {
    "codigo":1162800007,
    "descripcion":"ÉSTER DE COLESTEROL DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":48688005,
    "descripcion":"EDAD GESTACIONAL, 26 SEMANAS"
  },
  {
    "codigo":866053004,
    "descripcion":"VARIANTE INTERHEMISFÉRICA MEDIA DE HOLOPROSENCEFALIA"
  },
  {
    "codigo":833285007,
    "descripcion":"CORDOMA DE COLUMNA VERTEBRAL LUMBAR"
  },
  {
    "codigo":11055151000119108,
    "descripcion":"ARTRITIS REUMATOIDE SEROPOSITIVA DE MÚLTIPLES ARTICULACIONES"
  },
  {
    "codigo":12250001,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE CODO CON INFECCIÓN"
  },
  {
    "codigo":1193733007,
    "descripcion":"ENTERITIS INTESTINAL ENTEROBACTERIANA"
  },
  {
    "codigo":11792431000119109,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN DE DEDO ANULAR IZQUIERDO"
  },
  {
    "codigo":700378005,
    "descripcion":"ENFERMEDAD RENAL CRÓNICA EN ESTADIO 3A"
  },
  {
    "codigo":733146008,
    "descripcion":"DISMOTILIDAD ESOFÁGICA DEBIDA A ENFERMEDAD SISTÉMICA"
  },
  {
    "codigo":272559002,
    "descripcion":"POSICIÓN SUPINA Y CON UN CUARTO DE GIRO HACIA LA DERECHA - PIE DE LA CAMA ELEVADO 35 CM"
  },
  {
    "codigo":698543005,
    "descripcion":"REQUIERE DISPOSITIVO DE ORTODONCIA FIJO"
  },
  {
    "codigo":239791005,
    "descripcion":"ARTRITIS REUMATOIDE SEROPOSITIVA"
  },
  {
    "codigo":215693000,
    "descripcion":"LESIÓN EN MEDIO DE TRANSPORTE ACUÁTICO PRODUCIDO POR MAQUINARIA DE CUBIERTA, NADADOR LESIONADO"
  },
  {
    "codigo":41348000,
    "descripcion":"ENFERMEDAD POR VIRUS PIRY"
  },
  {
    "codigo":403631009,
    "descripcion":"PÉNFIGO FOLIÁCEO MEDICAMENTOSO"
  },
  {
    "codigo":74116004,
    "descripcion":"DEGENERACIÓN MUSCULAR NUTRICIONAL"
  },
  {
    "codigo":762244004,
    "descripcion":"MAREO POSTERIOR A EXTENSIÓN DEL CUELLO"
  },
  {
    "codigo":205188009,
    "descripcion":"DETENCIÓN DEL CRECIMIENTO TRANSVERSO A NIVEL FALÁNGICO DEL SEGUNDO RAYO"
  },
  {
    "codigo":301657001,
    "descripcion":"INCAPAZ DE LEVANTARSE DE UNA SILLA"
  },
  {
    "codigo":39513007,
    "descripcion":"ATRESIA CONGÉNITA DE CONDUCTO DEFERENTE"
  },
  {
    "codigo":236121008,
    "descripcion":"NECROSIS DE ESTOMA"
  },
  {
    "codigo":299822001,
    "descripcion":"RESPUESTA MOTORA A LA PRESIÓN PROFUNDA DE LA GLABELA, PRESENTE"
  },
  {
    "codigo":680291000119102,
    "descripcion":"CICLITIS HETEROCRÓMICA DE FUCHS DE AMBOS OJOS"
  },
  {
    "codigo":365358003,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA MANEJAR ACTIVIDADES FINANCIERAS PERSONALES"
  },
  {
    "codigo":430894003,
    "descripcion":"DISTENSIÓN MUSCULAR DE LA PARED TORÁCICA"
  },
  {
    "codigo":398126006,
    "descripcion":"CEFALEA MUSCULAR"
  },
  {
    "codigo":168750009,
    "descripcion":"MAMOGRAFÍA ANORMAL"
  },
  {
    "codigo":297987003,
    "descripcion":"CRECIMIENTO DE LA UÑA NORMAL"
  },
  {
    "codigo":789507005,
    "descripcion":"CICATRIZACIÓN TARDÍA DE HERIDA"
  },
  {
    "codigo":429059007,
    "descripcion":"HEMATOMA DE CUERO CABELLUDO OCCIPITAL"
  },
  {
    "codigo":230616000,
    "descripcion":"LESIÓN EN LA RAÍZ NERVIOSA VERTEBRAL"
  },
  {
    "codigo":1240000,
    "descripcion":"DECÚBITO VENTRAL"
  },
  {
    "codigo":232451009,
    "descripcion":"BRIDA MUCOSA DE LA CUERDA VOCAL"
  },
  {
    "codigo":197848003,
    "descripcion":"CISTITIS GONOCÓCICA"
  },
  {
    "codigo":296152006,
    "descripcion":"SOBREDOSIS DE CLORMETIAZOL"
  },
  {
    "codigo":425389002,
    "descripcion":"ESTADO DE DESEMPEÑO ECOG - GRADO 0"
  },
  {
    "codigo":1144450000,
    "descripcion":"APLASIA DE FALANGE DISTAL DE DEDO MEÑIQUE"
  },
  {
    "codigo":294317009,
    "descripcion":"ALERGIA A ACEITE DE MANÍ"
  },
  {
    "codigo":292482005,
    "descripcion":"REACCIÓN ADVERSA A LA PSEUDOEFEDRINA"
  },
  {
    "codigo":259714005,
    "descripcion":"GRANULACIÓN TÓXICA"
  },
  {
    "codigo":95874006,
    "descripcion":"INTOXICACIÓN POR MONÓXIDO DE CARBONO EMANADO POR EL FUEGO"
  },
  {
    "codigo":782167001,
    "descripcion":"SÍNDROME DE STEWART-MOREL-MORGAGNI"
  },
  {
    "codigo":126807001,
    "descripcion":"NEOPLASIA DEL VELO DEL PALADAR"
  },
  {
    "codigo":94039004,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE PIEL DE HOMBRO"
  },
  {
    "codigo":290647008,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR PLICAMICINA"
  },
  {
    "codigo":288812003,
    "descripcion":"CAPAZ DE IMITAR FORMAS DE COMUNICACIÓN"
  },
  {
    "codigo":419884005,
    "descripcion":"REACCIÓN ALÉRGICA CAUSADA POR PICADURA DE PULGA"
  },
  {
    "codigo":124972006,
    "descripcion":"ALTERACIÓN DE MATERIAL GENÉTICO"
  },
  {
    "codigo":92204009,
    "descripcion":"NEOPLASIA BENIGNA DE BRONQUIO PRINCIPAL"
  },
  {
    "codigo":876801005,
    "descripcion":"REACCIÓN ADVERSA A DIMETIL SULFÓXIDO Y\/O IDOXURIDINA"
  },
  {
    "codigo":254209005,
    "descripcion":"HEMANGIOMA MIXTO"
  },
  {
    "codigo":285142001,
    "descripcion":"ESCALDARSE"
  },
  {
    "codigo":448982005,
    "descripcion":"OBSTRUCCIÓN COMPLETA ADQUIRIDA DEL FLUJO DE SALIDA AÓRTICO"
  },
  {
    "codigo":416214006,
    "descripcion":"ANEMIA DREPANOCÍTICA-ENFERMEDAD POR HEMOGLOBINA D SIN CRISIS"
  },
  {
    "codigo":283307005,
    "descripcion":"ASTILLA DE MADERA EN LA INGLE"
  },
  {
    "codigo":707456000,
    "descripcion":"CARCINOMA PRIMARIO INDIFERENCIADO DE PULMÓN"
  },
  {
    "codigo":52096004,
    "descripcion":"INFECCIÓN CAUSADA POR PROSTHENORCHIS"
  },
  {
    "codigo":838528007,
    "descripcion":"TRASTORNO DEL ESTADO DE ÁNIMO CON SÍNTOMAS MANÍACOS CAUSADO POR ANFETAMINA Y\/O DERIVADO DE ANFETAMINA"
  },
  {
    "codigo":772992009,
    "descripcion":"CARCINOMA PRIMARIO DIFERENCIADO DE GLÁNDULA TIROIDES"
  },
  {
    "codigo":83029003,
    "descripcion":"CLONO DE MUÑECA"
  },
  {
    "codigo":246869006,
    "descripcion":"SUPERFICIE OCULAR - HALLAZGO"
  },
  {
    "codigo":277802001,
    "descripcion":"NOTALGIA PARESTÉSICA"
  },
  {
    "codigo":212266002,
    "descripcion":"LESIÓN ABIERTA DE RAMA SENSITIVA DORSAL DE NERVIO CUBITAL"
  },
  {
    "codigo":310570001,
    "descripcion":"PRUEBA DE INMUNOTRANSFERENCIA PARA ENFERMEDAD DE LYME, DUDOSA"
  },
  {
    "codigo":115797009,
    "descripcion":"FENOTIPO P>2<^K^"
  },
  {
    "codigo":769322006,
    "descripcion":"CUERPOS ELEMENTALES DE VIRUS INTRACELULARES DETECTADOS"
  },
  {
    "codigo":210431006,
    "descripcion":"HERIDA ABIERTA DE TESTÍCULO"
  },
  {
    "codigo":110292000,
    "descripcion":"DIFICULTAD PARA COMER"
  },
  {
    "codigo":208596007,
    "descripcion":"FRACTURA NO EXPUESTA TRANSVERSAL DE RÓTULA"
  },
  {
    "codigo":698281001,
    "descripcion":"HIPERPLASIA ÓSEA SUBPONTINA DE MANDÍBULA"
  },
  {
    "codigo":1255337003,
    "descripcion":"FRACTURA EXPUESTA DE MÚLTIPLES FALANGES DE DEDO DE PIE"
  },
  {
    "codigo":10153004,
    "descripcion":"FIBRINOGENÓLISIS SISTÉMICA"
  },
  {
    "codigo":403369005,
    "descripcion":"MANCHAS DE FORDYCE EN LA MUCOSA YUGAL"
  },
  {
    "codigo":75689006,
    "descripcion":"DERRAME PLEURAL ASOCIADO CON HEPATOPATÍA"
  },
  {
    "codigo":237694000,
    "descripcion":"SUPRESIÓN DE ESTEROIDES POR SECRECIÓN DE ACTH"
  },
  {
    "codigo":301395001,
    "descripcion":"DOLOR A LA PALPACIÓN EN LAS VÍAS URINARIAS"
  },
  {
    "codigo":399699003,
    "descripcion":"TUMOR QUE MICROSCÓPICAMENTE SÓLO COMPROMETE TROMPA DE FALOPIO"
  },
  {
    "codigo":235859005,
    "descripcion":"TRASTORNO HEPÁTICO POR INFECCIÓN"
  },
  {
    "codigo":1153363005,
    "descripcion":"GOTA AGUDA CAUSADA POR PLOMO"
  },
  {
    "codigo":6483008,
    "descripcion":"ALBINISMO OCULOCUTÁNEO TIROSINASA NEGATIVO"
  },
  {
    "codigo":234024001,
    "descripcion":"SÍNDROME DE ROBO ARTERIAL"
  },
  {
    "codigo":971000119105,
    "descripcion":"TELANGIECTASIA DE MIEMBRO"
  },
  {
    "codigo":299560004,
    "descripcion":"HUESO LARGO EN PIE"
  },
  {
    "codigo":1217064005,
    "descripcion":"GANGRENA DE TIROIDES"
  },
  {
    "codigo":365096008,
    "descripcion":"PATRÓN DE ELECTROOCULOGRAMA - HALLAZGO"
  },
  {
    "codigo":363261001,
    "descripcion":"COMPLICACIÓN VASCULAR PERIFÉRICA DE PROCEDIMIENTO"
  },
  {
    "codigo":397864009,
    "descripcion":"BEBÉ GOLPEADO"
  },
  {
    "codigo":102952009,
    "descripcion":"RELACIÓN SEXUAL ABUSIVA CON LA ESPOSA"
  },
  {
    "codigo":428797006,
    "descripcion":"FRACTURA OSTEOCONDRAL NO EXPUESTA DE TIBIA PROXIMAL"
  },
  {
    "codigo":68349007,
    "descripcion":"DAÑO DEL ÁCIDO DESOXIRRIBONUCLEICO"
  },
  {
    "codigo":263122000,
    "descripcion":"LESIÓN DE RODETE GLENOIDEO DE ARTICULACIÓN DE HOMBRO"
  },
  {
    "codigo":721874001,
    "descripcion":"SÍNDROME DE JUBERG HAYWARD"
  },
  {
    "codigo":166653007,
    "descripcion":"NIVEL DE 5 - NUCLEOTIDASA SÉRICA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":978003,
    "descripcion":"ECCEMA INFANTIL CRÓNICO"
  },
  {
    "codigo":787410005,
    "descripcion":"SÍNDROME DE POLIPOSIS HEREDITARIA MIXTA"
  },
  {
    "codigo":302181000119103,
    "descripcion":"QUISTE ÓSEO ANEURISMÁTICO DE MANO IZQUIERDA"
  },
  {
    "codigo":426962008,
    "descripcion":"FRACTURA NO EXPUESTA DEL ACETÁBULO CON LUXACIÓN DE CADERA"
  },
  {
    "codigo":230354009,
    "descripcion":"ENCEFALOPATÍA MEDICAMENTOSA"
  },
  {
    "codigo":295890009,
    "descripcion":"SOBREDOSIS DE FENELZINA"
  },
  {
    "codigo":425127006,
    "descripcion":"CARCINOMA EX ADENOMA PLEOMORFO DE GLÁNDULA PARÓTIDA"
  },
  {
    "codigo":95612000,
    "descripcion":"ACIDOSIS RESPIRATORIA NEONATAL"
  },
  {
    "codigo":294055009,
    "descripcion":"ALERGIA A METILDOPA"
  },
  {
    "codigo":161148002,
    "descripcion":"HABLA ESCASO INGLÉS"
  },
  {
    "codigo":292220002,
    "descripcion":"REACCIÓN ADVERSA A LA MITOMICINA"
  },
  {
    "codigo":783740007,
    "descripcion":"HIPERINSULINISMO FOCAL RESISTENTE A DIAZÓXIDO DEBIDO A DEFICIENCIA DE RECEPTOR 1 DE SULFONILUREA"
  },
  {
    "codigo":126545005,
    "descripcion":"NEOPLASIA DE HUESO DE LA CARA"
  },
  {
    "codigo":124710002,
    "descripcion":"DEFICIENCIA DE FORMATO - TETRAHIDROFOLATO LIGASA"
  },
  {
    "codigo":288550002,
    "descripcion":"REALIZA ACTIVIDADES DE LAVADO Y SECADO DE SÍ MISMO"
  },
  {
    "codigo":1236987000,
    "descripcion":"INFLAMACIÓN DE MARGEN LIBRE DE PÁRPADO ANTERIOR"
  },
  {
    "codigo":253947001,
    "descripcion":"ARQUEAMIENTO CONGÉNITO DE PIERNA"
  },
  {
    "codigo":1204219002,
    "descripcion":"OCLUSIÓN TROMBOEMBÓLICA AGUDA DE BIFURCACIÓN AÓRTICA"
  },
  {
    "codigo":59174009,
    "descripcion":"FETICHISMO"
  },
  {
    "codigo":712699001,
    "descripcion":"JAEGER TIPO 11"
  },
  {
    "codigo":286715003,
    "descripcion":"CARÁCTER EMOCIONALMENTE CÁLIDO"
  },
  {
    "codigo":57339008,
    "descripcion":"HEPATITIS LOBULILLAR CRÓNICA"
  },
  {
    "codigo":448720005,
    "descripcion":"ACCESO VENOSO CENTRAL INSERTADO POR VÍA PERIFÉRICA PERMEABLE"
  },
  {
    "codigo":284880005,
    "descripcion":"DIFICULTAD PARA CORTARSE LAS UÑAS DE LOS PIES"
  },
  {
    "codigo":219344007,
    "descripcion":"LESIÓN POR INSTRUMENTO PUNZANTE, CON PROPÓSITO DESCONOCIDO"
  },
  {
    "codigo":710864009,
    "descripcion":"DISECCIÓN DE ARTERIA"
  },
  {
    "codigo":250277004,
    "descripcion":"NEUTRÓFILO EN ANILLO"
  },
  {
    "codigo":1264250005,
    "descripcion":"CICATRIZ DE REGIÓN SUPERIOR DE MUCOSA YUGAL IZQUIERDA"
  },
  {
    "codigo":707194005,
    "descripcion":"CONDICIÓN DE DIENTE PILAR, MODERADAMENTE COMPROMETIDA, 1 O 2 SEXTANTES"
  },
  {
    "codigo":248442007,
    "descripcion":"FIEBRE CUARTANA"
  },
  {
    "codigo":1196879002,
    "descripcion":"CÁNCER DE OVARIO FAMILIAR"
  },
  {
    "codigo":17231009,
    "descripcion":"SÍNDROME FETAL POR VALPROATO"
  },
  {
    "codigo":80932001,
    "descripcion":"MANEJO DE UN HOGAR QUE ATRAVIESA UNA SITUACIÓN DE ALTERACIÓN, SEVERO"
  },
  {
    "codigo":16305561000119106,
    "descripcion":"ESTRÉS POR RELACIÓN CON CÓNYUGE O PAREJA ÍNTIMA"
  },
  {
    "codigo":703524005,
    "descripcion":"ATROFIA DE MÚSCULOS ESPINALES CON EPILEPSIA MIOCLÓNICA PROGRESIVA"
  },
  {
    "codigo":15732121000119106,
    "descripcion":"QUISTE SEBÁCEO DE PÁRPADO IZQUIERDO"
  },
  {
    "codigo":277540008,
    "descripcion":"FÍSTULA DEL MUÑÓN DUODENAL"
  },
  {
    "codigo":242937003,
    "descripcion":"EFECTOS TARDÍOS DE UN ASALTO"
  },
  {
    "codigo":767225004,
    "descripcion":"DESPLAZAMIENTO DE CATÉTER BALÓN URINARIO EN LA URETRA DEBIDO A INSERCIÓN CATÉTER URETRAL"
  },
  {
    "codigo":111865007,
    "descripcion":"ENFERMEDAD CAUSADA POR FLAVIVIRUS"
  },
  {
    "codigo":44494000,
    "descripcion":"ESPONDILOLISTESIS, GRADO 1"
  },
  {
    "codigo":110030002,
    "descripcion":"CONMOCIÓN CEREBRAL"
  },
  {
    "codigo":698019000,
    "descripcion":"PÓLIPO BENIGNO DE COLON"
  },
  {
    "codigo":403107003,
    "descripcion":"ONICOMICOSIS DISTRÓFICA TOTAL"
  },
  {
    "codigo":302968001,
    "descripcion":"EMBOLIA GASEOSA ARTERIAL"
  },
  {
    "codigo":11773491000119106,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE PULGAR IZQUIERDO"
  },
  {
    "codigo":401272006,
    "descripcion":"BAJO ATENCIÓN DE EQUIPO DE SALUD MENTAL"
  },
  {
    "codigo":235597001,
    "descripcion":"ESÓFAGO DE BARRET CON ESOFAGITIS"
  },
  {
    "codigo":301133002,
    "descripcion":"HALLAZGO RELACIONADO CON LA PALPACIÓN CARDÍACA"
  },
  {
    "codigo":366669003,
    "descripcion":"DOSIS MÍNIMA DE LA PRUEBA DE FOTOSENSIBILIDAD - HALLAZGO"
  },
  {
    "codigo":299298000,
    "descripcion":"AMPLITUD DE ROTACIÓN EXTERNA ACTIVA DE ARTICULACIÓN DE CADERA, AUMENTADA"
  },
  {
    "codigo":4386001,
    "descripcion":"BRONCOESPASMO"
  },
  {
    "codigo":1251405009,
    "descripcion":"URTICARIA CRÓNICA DEBIDA A ENFERMEDAD INFECCIOSA"
  },
  {
    "codigo":200994002,
    "descripcion":"PITIRIASIS ESTREPTOGENES"
  },
  {
    "codigo":364834004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA CORRER"
  },
  {
    "codigo":233762004,
    "descripcion":"NEUMOCONIOSIS CRÓNICA"
  },
  {
    "codigo":11828941000119102,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE PIEL DE RODILLA DERECHA"
  },
  {
    "codigo":35319002,
    "descripcion":"HETEROFORIA NO CONCOMITANTE"
  },
  {
    "codigo":687821000119104,
    "descripcion":"RABDOMIOSARCOMA PRIMARIO DE CABEZA"
  },
  {
    "codigo":231927007,
    "descripcion":"ESTEATODEGENERACIÓN DE CÓRNEA"
  },
  {
    "codigo":362999008,
    "descripcion":"COMPLICACIÓN CARDÍACA POR PROCEDIMIENTO"
  },
  {
    "codigo":788983007,
    "descripcion":"TRASTORNO DEL ESTADO DE ÁNIMO CAUSADO POR CANNABIS"
  },
  {
    "codigo":262860000,
    "descripcion":"DESGARRO DE CAPA SEROSA DE APÉNDICE ILEOCECAL"
  },
  {
    "codigo":197324004,
    "descripcion":"ABSCESO HEPÁTICO Y SECUELAS DE HEPATOPATÍA CRÓNICA"
  },
  {
    "codigo":721612007,
    "descripcion":"ESOFAGITIS EOSINOFÍLICA NEONATAL"
  },
  {
    "codigo":293793000,
    "descripcion":"ALERGIA A VINBLASTINA"
  },
  {
    "codigo":31649001,
    "descripcion":"PRESENCIA ANORMAL DE GLUCOSA"
  },
  {
    "codigo":64417000,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DEL PENE"
  },
  {
    "codigo":295628008,
    "descripcion":"SOBREDOSIS DE IFOSFAMIDA"
  },
  {
    "codigo":95350002,
    "descripcion":"ESCLEREMA"
  },
  {
    "codigo":717942003,
    "descripcion":"ENFERMEDAD DEL TRANSPORTE VESICULAR CEREBRAL DE DOPAMINA-SEROTONINA"
  },
  {
    "codigo":291958005,
    "descripcion":"INTOXICACIÓN POR DIURÉTICOS TIAZÍDICOS"
  },
  {
    "codigo":290123000,
    "descripcion":"HALLAZGO RELACIONADO CON EL PATRÓN DE LA FUNCIÓN MAMARIA"
  },
  {
    "codigo":191819002,
    "descripcion":"FARMACODEPENDENCIA DE OPIÁCEOS CONTINUA"
  },
  {
    "codigo":716107009,
    "descripcion":"SÍNDROME DE PARKINSONISMO DE COMIENZO TEMPRANO Y DISCAPACIDAD INTELECTUAL"
  },
  {
    "codigo":124448006,
    "descripcion":"DEFICIENCIA DE GLUCOSULFATASA"
  },
  {
    "codigo":307201000119100,
    "descripcion":"ARTRITIS ENTEROPÁTICA DE MANO DERECHA"
  },
  {
    "codigo":1173024006,
    "descripcion":"CRISIS DE AUSENCIA TÍPICA"
  },
  {
    "codigo":253685001,
    "descripcion":"CONDUCTO ARTERIOSO PERMEABLE - CIERRE TARDÍO"
  },
  {
    "codigo":333671000119107,
    "descripcion":"QUERATOCONJUNTIVITIS NEUROTRÓFICA DE OJO DERECHO"
  },
  {
    "codigo":1269493005,
    "descripcion":"RESORCIÓN DE DIENTE CAUSADA POR BACTERIA"
  },
  {
    "codigo":417525006,
    "descripcion":"IMAGEN DE RESONANCIA MAGNÉTICA DE COLUMNA VERTEBRAL CERVICAL ANORMAL"
  },
  {
    "codigo":415690000,
    "descripcion":"SUDORACIÓN"
  },
  {
    "codigo":286453009,
    "descripcion":"CAPAZ DE PREPARAR ALIMENTO PARA COMER"
  },
  {
    "codigo":219082005,
    "descripcion":"REACCIÓN ADVERSA A VACUNA CONTRA EL CÓLERA"
  },
  {
    "codigo":284618007,
    "descripcion":"BURLARSE"
  },
  {
    "codigo":282783001,
    "descripcion":"LESIÓN TRAUMÁTICA DE LENGUA"
  },
  {
    "codigo":86175003,
    "descripcion":"LESIÓN TRAUMÁTICA DEL CORAZÓN"
  },
  {
    "codigo":20639004,
    "descripcion":"CANDIDIASIS DEL ESÓFAGO"
  },
  {
    "codigo":248180000,
    "descripcion":"LÍNEA LABIAL"
  },
  {
    "codigo":250015009,
    "descripcion":"MARCHA ARTRÍTICA"
  },
  {
    "codigo":1003679009,
    "descripcion":"INFECCIÓN DOBLE POR VIRUS DE LA INMUNODEFICIENCIA HUMANA 1 Y VIRUS DE LA INMUNODEFICIENCIA HUMANA 2 SEGÚN LA CLASIFICACIÓN DE INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA DE LOS CENTROS PARA EL CONTROL Y PREVENCIÓN DE ENFERMEDADES"
  },
  {
    "codigo":117108003,
    "descripcion":"UNIDAD DE HEMODERIVADO REPROCESADA"
  },
  {
    "codigo":280948003,
    "descripcion":"SENTIDO DE IDENTIDAD, NORMAL"
  },
  {
    "codigo":315551008,
    "descripcion":"NACIDO EN UGANDA"
  },
  {
    "codigo":1263988006,
    "descripcion":"HEMORRAGIA NEONATAL PRECOZ"
  },
  {
    "codigo":705097000,
    "descripcion":"ALERGIA A SUERO"
  },
  {
    "codigo":10956801000119107,
    "descripcion":"HERIDA ABIERTA DE DEDO MEDIO DE MANO DERECHA"
  },
  {
    "codigo":408350003,
    "descripcion":"PACIENTE NO AUTOMEDICADO"
  },
  {
    "codigo":80670004,
    "descripcion":"ASPECTO EXTRAÑO"
  },
  {
    "codigo":768798006,
    "descripcion":"IRITIS DE OJO IZQUIERDO DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":441118006,
    "descripcion":"NEOPLASIA NEGATIVA PARA RECEPTORES DE PROGESTERONA"
  },
  {
    "codigo":111603000,
    "descripcion":"FRACTURA NO EXPUESTA DE LA BASE DEL CRÁNEO CON LESIÓN TRAUMÁTICA INTRACRANEAL"
  },
  {
    "codigo":703262009,
    "descripcion":"RHODOTORULA GLUTINIS O RHODOTORULA MUCILAGINOSA"
  },
  {
    "codigo":275443007,
    "descripcion":"AMPOLLA TRAUMÁTICA DE ESCROTO, INFECTADA"
  },
  {
    "codigo":240840008,
    "descripcion":"LIQUENIFICACIÓN POR ONCHOCERCA"
  },
  {
    "codigo":109768008,
    "descripcion":"SIALOADENITIS OBSTRUCTIVA DE GLÁNDULA SALIVAL MAYOR"
  },
  {
    "codigo":306376009,
    "descripcion":"VISTO EN EL SERVICIO DE ODONTOLOGÍA RESTAURATIVA"
  },
  {
    "codigo":402845005,
    "descripcion":"CUTIS MARMÓREO FISIOLÓGICO"
  },
  {
    "codigo":269938000,
    "descripcion":"PARÁSITO DETECTADO EN ESPÉCIMEN MEDIANTE EXAMEN MICROSCÓPICO DIRECTO"
  },
  {
    "codigo":401010000,
    "descripcion":"PACIENTE PREOCUPADO POR LA VISIÓN"
  },
  {
    "codigo":237170004,
    "descripcion":"ANORMALIDAD VAGINAL EN EL EMBARAZO, PARTO Y PUERPERIO"
  },
  {
    "codigo":7794004,
    "descripcion":"TRASTORNO DE TICS MOTORES CRÓNICOS"
  },
  {
    "codigo":106098005,
    "descripcion":"HALLAZGO RELACIONADO CON EL APARATO URINARIO"
  },
  {
    "codigo":204402008,
    "descripcion":"FUSIÓN DE CÚSPIDES DE VÁLVULA MITRAL"
  },
  {
    "codigo":366407005,
    "descripcion":"AMPLITUD DEL MOVIMIENTO ACTIVO DE FLEXIÓN DE LA COLUMNA DORSAL - HALLAZGO"
  },
  {
    "codigo":38727009,
    "descripcion":"TIROIDITIS SUBAGUDA"
  },
  {
    "codigo":167964001,
    "descripcion":"ALBÚMINA EN LÍQUIDO PLEURAL POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":4124006,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN LA REGIÓN DE LA VAGINA, CON INFECCIÓN"
  },
  {
    "codigo":299036007,
    "descripcion":"CUADRATURA DE LA MANO"
  },
  {
    "codigo":395505000,
    "descripcion":"NEOPLASIA DEL NERVIO ÓPTICO"
  },
  {
    "codigo":10877391000119101,
    "descripcion":"HERIDA ABIERTA DE PIERNA DERECHA"
  },
  {
    "codigo":360902000,
    "descripcion":"DEFICIENCIA DE AMINOPEPTIDASA DE LEUCINA"
  },
  {
    "codigo":35057008,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN REGIÓN DE PENE CON INFECCIÓN"
  },
  {
    "codigo":297201008,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE ANTIDEPRESIVO TRICÍCLICO"
  },
  {
    "codigo":721350005,
    "descripcion":"FRACTURA DE SEXTA VÉRTEBRA CERVICAL"
  },
  {
    "codigo":262598006,
    "descripcion":"CUERPO EXTRAÑO INTRACRANEAL"
  },
  {
    "codigo":719515001,
    "descripcion":"ENFERMEDAD DE CHARCOT-MARIE-TOOTH TIPO 2N AUTOSÓMICA DOMINANTE"
  },
  {
    "codigo":293531002,
    "descripcion":"REACCIÓN ADVERSA A FÁRMACO VASODILATADOR"
  },
  {
    "codigo":162459004,
    "descripcion":"PRESENTA EL SÍNTOMA ANUALMENTE"
  },
  {
    "codigo":129691005,
    "descripcion":"CON MAYOR RIESGO DE ESTREÑIMIENTO"
  },
  {
    "codigo":1145499006,
    "descripcion":"HIPOPLASIA CONGÉNITA DE SEGUNDO HUESO METACARPIANO"
  },
  {
    "codigo":226160003,
    "descripcion":"DIETA RICA EN MAGNESIO"
  },
  {
    "codigo":422768004,
    "descripcion":"SIN RESPUESTA"
  },
  {
    "codigo":1141829000,
    "descripcion":"SIGNO DE LA MEDIALUNA AÉREA"
  },
  {
    "codigo":93253001,
    "descripcion":"HIPOPLASIA CONGÉNITA DE HUESO EXOCCIPITAL"
  },
  {
    "codigo":291696009,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR ÁCIDO PARAAMINOSALICÍLICO"
  },
  {
    "codigo":95088009,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL INTESTINO DELGADO"
  },
  {
    "codigo":224325004,
    "descripcion":"ASISTENCIA ESCOLAR: BUENA"
  },
  {
    "codigo":60485005,
    "descripcion":"PLEUROBRONCONEUMONÍA"
  },
  {
    "codigo":27717006,
    "descripcion":"ABSCESO DE ESCROTO"
  },
  {
    "codigo":289861006,
    "descripcion":"HIPERQUERATOSIS DEL PERINEO FEMENINO"
  },
  {
    "codigo":58650000,
    "descripcion":"INFECCIÓN CAUSADA POR SCHISTOSOMA INDICUM"
  },
  {
    "codigo":124186006,
    "descripcion":"DEFICIENCIA DE NAPH CITOCROMO - C>2< REDUCTASA"
  },
  {
    "codigo":253423004,
    "descripcion":"TABIQUE INTERAURICULAR MAL ALINEADO"
  },
  {
    "codigo":128264007,
    "descripcion":"DISMINUCIÓN DE LA TOLERANCIA A LA GLUCOSA CON HIPERINSULINISMO"
  },
  {
    "codigo":251588000,
    "descripcion":"ELECTRODIAGNÓSTICO OFTALMOLÓGICO - HALLAZGO"
  },
  {
    "codigo":1269231008,
    "descripcion":"DEFICIENCIA DE LIPOIL TRANSFERASA 2"
  },
  {
    "codigo":20377001,
    "descripcion":"FRACTURA EXPUESTA A NIVEL DE C5 - C7 CON LESIÓN INCOMPLETA DE LA MÉDULA ESPINAL"
  },
  {
    "codigo":446361002,
    "descripcion":"LACERACIÓN PROFUNDA DE DEDO DE LA MANO"
  },
  {
    "codigo":11997801000119107,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DE HOMBRO DERECHO"
  },
  {
    "codigo":282521004,
    "descripcion":"NO BAJA ESCALONES CORRIENDO"
  },
  {
    "codigo":1003417005,
    "descripcion":"DELECIÓN DE PORCIÓN MEDIA DEL BRAZO CORTO DE CROMOSOMA 1"
  },
  {
    "codigo":1263726001,
    "descripcion":"TRASTORNO FETAL DEBIDO A INSUFICIENCIA CERVICOUTERINA"
  },
  {
    "codigo":247918002,
    "descripcion":"ASIMIENTO FORZADO"
  },
  {
    "codigo":278851001,
    "descripcion":"SECRECIÓN RECTAL"
  },
  {
    "codigo":442691001,
    "descripcion":"HALLAZGO RELACIONADO CON DIFERENCIA EN LA SUSTANCIA EN COMPARACIÓN CON EXAMEN RADIOLÓGICO PREVIO"
  },
  {
    "codigo":213315003,
    "descripcion":"INFECCIÓN POSTERIOR A TRANSFUSIÓN"
  },
  {
    "codigo":338691000119104,
    "descripcion":"PINGUECULITIS DE OJO IZQUIERDO"
  },
  {
    "codigo":1260056000,
    "descripcion":"CARCINOMA ESCAMOSO DE CÉLULAS CLARAS DE PULMÓN"
  },
  {
    "codigo":703000005,
    "descripcion":"PSEUDOMONAS STUTZERI O PSEUDOMONAS MENDOCINA"
  },
  {
    "codigo":66461000119100,
    "descripcion":"PORTADOR DE HIPERLIPIDEMIA COMBINADA FAMILIAR"
  },
  {
    "codigo":309784007,
    "descripcion":"OBSTRUCCIÓN DE STENT URETERAL"
  },
  {
    "codigo":735768008,
    "descripcion":"CONTUSIÓN CARDÍACA CONCOMITANTE CON HEMOPERICARDIO"
  },
  {
    "codigo":111341002,
    "descripcion":"CEFALODIPROSOPO"
  },
  {
    "codigo":439021005,
    "descripcion":"ATENDIDO EN CENTRO DE ANTICOAGULACIÓN DE LA COMUNIDAD"
  },
  {
    "codigo":209645008,
    "descripcion":"DESGARRO COMPLETO DE LIGAMENTO MANDIBULAR"
  },
  {
    "codigo":240578001,
    "descripcion":"ABSCESO DE GLÁNDULA DE LITTRÉ POR GONOCOCOS"
  },
  {
    "codigo":43970002,
    "descripcion":"ESTENOSIS CONGÉNITA DE VAGINA QUE AFECTA EL EMBARAZO"
  },
  {
    "codigo":371650005,
    "descripcion":"CUERPO ESQUELETIZADO"
  },
  {
    "codigo":109506007,
    "descripcion":"PROXIMIDAD ANORMAL DE LAS RAÍCES ENTRE DIENTES ADYACENTES"
  },
  {
    "codigo":271511000,
    "descripcion":"INMUNE A HEPATITIS B"
  },
  {
    "codigo":238743000,
    "descripcion":"ACNÉ JUVENIL"
  },
  {
    "codigo":73068003,
    "descripcion":"FORMA VARIANTE DE GLOBULINA LIGADORA DE TIROXINA LIGADA AL CROMOSOMA X"
  },
  {
    "codigo":1187180005,
    "descripcion":"CONCENTRACIÓN DE OXÍGENO EN SANGRE ARTERIAL DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":11836471000119100,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN INTERTARSIANA DE PIE IZQUIERDO"
  },
  {
    "codigo":235073000,
    "descripcion":"CANDIDIASIS MUCOCUTÁNEA CRÓNICA FAMILIAR"
  },
  {
    "codigo":366145001,
    "descripcion":"HALLAZGO RELACIONADO CON LA PROFUNDIDAD DE LA RESPIRACIÓN"
  },
  {
    "codigo":300609001,
    "descripcion":"REALIZA ACTIVIDADES RELACIONADAS CON LOS VIAJES"
  },
  {
    "codigo":169537000,
    "descripcion":"ANTICONCEPCIÓN SINTOTÉRMICA - PROBLEMAS"
  },
  {
    "codigo":38465001,
    "descripcion":"GRADO DE AFECTACIÓN: DETERIORO CASI TOTAL DE AMBOS OJOS"
  },
  {
    "codigo":890433006,
    "descripcion":"SÍNDROME DE COCKAYNE TIPO 1"
  },
  {
    "codigo":724758000,
    "descripcion":"SÍNTOMAS MANÍACOS CONCOMITANTES CON TRASTORNO PSICÓTICO PRIMARIO Y DEBIDOS A ÉL"
  },
  {
    "codigo":36630001,
    "descripcion":"DOLOR PROFUNDO"
  },
  {
    "codigo":1281814002,
    "descripcion":"CIERRE VELOFARÍNGEO INCOMPLETO ADQUIRIDO LIMÍTROFE DEBIDO A ANOMALÍA ANATÓMICA"
  },
  {
    "codigo":69398005,
    "descripcion":"INTOXICACIÓN POR VICIA"
  },
  {
    "codigo":296939002,
    "descripcion":"SOBREDOSIS DE SULFATO FERROSO"
  },
  {
    "codigo":722923006,
    "descripcion":"HIPERBILIRRUBINEMIA NEONATAL POSTERIOR A NUTRICIÓN PARENTERAL TOTAL"
  },
  {
    "codigo":30221000175103,
    "descripcion":"ÚLCERA POR PRESIÓN EN CODO DERECHO, ESTADIO II"
  },
  {
    "codigo":721088003,
    "descripcion":"SÍNDROME DE RETRASO DEL DESARROLLO, EPILEPSIA, DIABETES NEONATAL"
  },
  {
    "codigo":22541000175109,
    "descripcion":"CON MAYOR RIESGO DE BARRERA IDIOMÁTICA"
  },
  {
    "codigo":15742161000119100,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE AMBAS PIERNAS"
  },
  {
    "codigo":1343680008,
    "descripcion":"ARTRITIS DE ARTICULACIÓN DE RODILLA DEBIDA A INMUNIZACIÓN Y POSTERIOR A ELLA"
  },
  {
    "codigo":192008,
    "descripcion":"HEPATOMEGALIA SIFILÍTICA CONGÉNITA"
  },
  {
    "codigo":194965002,
    "descripcion":"FIBROSIS PERICÁRDICA"
  },
  {
    "codigo":293269006,
    "descripcion":"REACCIÓN ADVERSA A LA DESMOPRESINA"
  },
  {
    "codigo":719253007,
    "descripcion":"ATAXIA ESPINOCEREBELOSA TIPO 30"
  },
  {
    "codigo":16561361000119102,
    "descripcion":"FRACTURA ABIERTA DE HUESO CIGOMÁTICO DERECHO"
  },
  {
    "codigo":94826002,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE HUESO ETMOIDES"
  },
  {
    "codigo":62058003,
    "descripcion":"ESTÓMAGO EN RELOJ DE ARENA CONGÉNITO"
  },
  {
    "codigo":193130008,
    "descripcion":"LESIÓN DE NERVIO INTERÓSEO ANTERIOR"
  },
  {
    "codigo":92991001,
    "descripcion":"CÚBITO ARQUEADO CONGÉNITO"
  },
  {
    "codigo":123924000,
    "descripcion":"INTOXICACIÓN POR VERBENACEAE"
  },
  {
    "codigo":1010495009,
    "descripcion":"ESCLEROSIS DE EPÍFISIS DE FALANGE DISTAL DE PULGAR CON RADIOPACIDAD AUMENTADA"
  },
  {
    "codigo":289599009,
    "descripcion":"HALLAZGO RELACIONADO CON PULSACIÓN VAGINAL"
  },
  {
    "codigo":254996003,
    "descripcion":"HISTIOCITOMA FIBROSO MALIGNO DE ÓRBITA"
  },
  {
    "codigo":386068004,
    "descripcion":"TRASTORNO RELACIONADO CON LA VITAMINA D"
  },
  {
    "codigo":91156005,
    "descripcion":"INFECCIÓN CAUSADA POR BAYLISASCARIS"
  },
  {
    "codigo":285929000,
    "descripcion":"CAPAZ DE VACIAR LA BAÑERA"
  },
  {
    "codigo":449769004,
    "descripcion":"SÍNDROME DEL MENTÓN ENTUMECIDO"
  },
  {
    "codigo":89321004,
    "descripcion":"FENÓMENO DE KÖBNER"
  },
  {
    "codigo":447934002,
    "descripcion":"MIOCARDIOPATÍA NO COMPACTADA DE VENTRÍCULO DERECHO"
  },
  {
    "codigo":87486003,
    "descripcion":"AFASIA"
  },
  {
    "codigo":68971000119104,
    "descripcion":"DESFIBRILADOR CARDIOVERSOR BIVENTRICULAR IMPLANTABLE AUTOMÁTICO IN SITU"
  },
  {
    "codigo":216723005,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR CLORATO"
  },
  {
    "codigo":44361000087103,
    "descripcion":"CONTUSIÓN DE RÓTULA DERECHA"
  },
  {
    "codigo":46921000087103,
    "descripcion":"FRACTURA DE FALANGE MEDIA DE ÍNDICE IZQUIERDO"
  },
  {
    "codigo":249491009,
    "descripcion":"SALIDA DE BEBIDA POR LA NARIZ"
  },
  {
    "codigo":315027009,
    "descripcion":"DEFECTO CONGÉNITO DE CONDUCCIÓN"
  },
  {
    "codigo":51048002,
    "descripcion":"DERMATITIS POLIMORFA POR LUZ SOLAR, TIPO ERITEMATOSA DIFUSA"
  },
  {
    "codigo":39241000087108,
    "descripcion":"RADICULOPATÍA CRÓNICA DOLOROSA"
  },
  {
    "codigo":41801000087109,
    "descripcion":"CELULITIS DE BRAZO IZQUIERDO"
  },
  {
    "codigo":1359933000,
    "descripcion":"RADIX ENTOMOLARIS"
  },
  {
    "codigo":278589001,
    "descripcion":"INCRUSTACIÓN DENTAL FRACTURADA"
  },
  {
    "codigo":1228861004,
    "descripcion":"LINFANGIOMATOSIS KAPOSIFORME"
  },
  {
    "codigo":81981006,
    "descripcion":"MENINGITIS ENDOTELIOLEUCOCÍTICA MULTIRRECIDIVANTE BENIGNA"
  },
  {
    "codigo":737341006,
    "descripcion":"TRASTORNO DE ANSIEDAD CAUSADO POR CANABINOIDE SINTÉTICO"
  },
  {
    "codigo":409661008,
    "descripcion":"NEOPLASIA BENIGNA DE NERVIO AUTÓNOMO"
  },
  {
    "codigo":47378001,
    "descripcion":"TIROIDITIS VIRAL"
  },
  {
    "codigo":1259794001,
    "descripcion":"TUMOR DE PANCOAST PRIMARIO"
  },
  {
    "codigo":309522006,
    "descripcion":"DOLOR A LA PALPACIÓN EN EL CUELLO"
  },
  {
    "codigo":735506007,
    "descripcion":"QUEMADURA COMPLEJA DE PERINEO"
  },
  {
    "codigo":473362006,
    "descripcion":"ESTENOSIS CONGÉNITA DE ARTERIA CORONARIA DISTAL"
  },
  {
    "codigo":211218007,
    "descripcion":"PICADURA DE INSECTO, NO VENENOSO, EN EL BRAZO"
  },
  {
    "codigo":307687003,
    "descripcion":"MACROONDAS CUADRADAS OCULARES"
  },
  {
    "codigo":209383004,
    "descripcion":"FRACTURA-SUBLUXACIÓN EXPUESTA DE ARTICULACIÓN METATARSOFALÁNGICA, ÚNICA"
  },
  {
    "codigo":405991006,
    "descripcion":"INTEGRIDAD DEL ESPÉCIMEN - NO APLICABLE"
  },
  {
    "codigo":78311009,
    "descripcion":"DEFECTO DEL TRANSPORTE DE HISTIDINA"
  },
  {
    "codigo":305852001,
    "descripcion":"VISTO POR EL SERVICIO DE TERAPIA OCUPACIONAL"
  },
  {
    "codigo":897511009,
    "descripcion":"TRISOMÍA DISTAL 7Q"
  },
  {
    "codigo":109244004,
    "descripcion":"ABSCESO DE ESPACIO SUBMENTONIANO"
  },
  {
    "codigo":699068005,
    "descripcion":"INTOXICACIÓN POR HORMONA TIROIDEA"
  },
  {
    "codigo":830140004,
    "descripcion":"HONGO OBSERVADO EN EL EXAMEN CON MICROSCOPIO ELECTRÓNICO"
  },
  {
    "codigo":240316007,
    "descripcion":"LESIÓN LARÍNGEA POR TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":15990431000119100,
    "descripcion":"DEPÓSITOS RETINIANOS DE AMBOS OJOS"
  },
  {
    "codigo":404156009,
    "descripcion":"INFILTRACIÓN LEUCÉMICA DE PIEL"
  },
  {
    "codigo":402321003,
    "descripcion":"PSORIASIS NO PUSTULOSA DE MANO"
  },
  {
    "codigo":1080991000119101,
    "descripcion":"MELANOMA MALIGNO DE CUERPO CILIAR DE OJO DERECHO"
  },
  {
    "codigo":9105005,
    "descripcion":"DEFICIENCIA DE AMP DESAMINASA MUSCULAR"
  },
  {
    "codigo":302182000,
    "descripcion":"HALLAZGO RELACIONADO CON MEDICIONES DE LOS TESTÍCULOS"
  },
  {
    "codigo":238481009,
    "descripcion":"CUELLO DEL VIOLINISTA"
  },
  {
    "codigo":236646007,
    "descripcion":"HIPERPLASIA PROSTÁTICA BENIGNA CON OBSTRUCCIÓN DEL FLUJO DE SALIDA"
  },
  {
    "codigo":300347003,
    "descripcion":"HALLAZGO RELACIONADO CON LA SENSIBILIDAD DE LA VESÍCULA BILIAR"
  },
  {
    "codigo":1119547005,
    "descripcion":"NARIZ CON FORMA DE PERA"
  },
  {
    "codigo":726331006,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO DEL TRONCO"
  },
  {
    "codigo":890171006,
    "descripcion":"DIABETES MELLITUS PROPENSA A LA CETOSIS"
  },
  {
    "codigo":724496000,
    "descripcion":"HEMORRAGIA POSPARTO CONCOMITANTE CON RUPTURA UTERINA DESPUÉS DE TRABAJO DE PARTO OBSTRUIDO Y DEBIDA A ELLA"
  },
  {
    "codigo":34533008,
    "descripcion":"CATARATA POLAR SUBCAPSULAR POSTERIOR"
  },
  {
    "codigo":1345253009,
    "descripcion":"RADIOGRAFÍA SIMPLE DE SISTEMA GENITOURINARIO NORMAL"
  },
  {
    "codigo":196538002,
    "descripcion":"CELULITIS DEL PISO DE LA BOCA"
  },
  {
    "codigo":773905531000119106,
    "descripcion":"ATRAPAMIENTO DE MÚSCULO RECTO INFERIOR DE OJO DERECHO"
  },
  {
    "codigo":131002003,
    "descripcion":"NIVEL DE FACTOR LIBERADOR DE CORTICOTROFINA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":460517008,
    "descripcion":"ORIGEN ANÓMALO DE ARTERIAS CORONARIAS EN AMBOS SENOS AÓRTICOS DE VÁLVULA BICÚSPIDE"
  },
  {
    "codigo":720826006,
    "descripcion":"DISPLASIA METATARSIANA TIPO CHECA"
  },
  {
    "codigo":425914008,
    "descripcion":"REACCIÓN DE AJUSTE A TRATAMIENTO MÉDICO"
  },
  {
    "codigo":360378009,
    "descripcion":"DEFICIENCIA DE HOMOGENTISATO 1,2-DIOXIGENASA"
  },
  {
    "codigo":293007003,
    "descripcion":"REACCIÓN ADVERSA A LA CEFOTAXIMA"
  },
  {
    "codigo":1144975005,
    "descripcion":"GLOMERULOPATÍA DEBIDA A PÚRPURA TROMBOCITOPÉNICA TROMBÓTICA"
  },
  {
    "codigo":127332000,
    "descripcion":"NEOPLASIA FETAL"
  },
  {
    "codigo":260239008,
    "descripcion":"VOZ EN VIVO"
  },
  {
    "codigo":717156002,
    "descripcion":"SÍNDROME DE ATRESIA BILIAR CON MALFORMACIÓN ESPLÉNICA"
  },
  {
    "codigo":782692004,
    "descripcion":"DISOMÍA UNIPARENTAL MATERNA DE CROMOSOMA 22"
  },
  {
    "codigo":225636006,
    "descripcion":"ANSIEDAD ACERCA DE LA DEPENDENCIA OBLIGADA"
  },
  {
    "codigo":94564007,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA PIEL DE LOS LABIOS"
  },
  {
    "codigo":29028009,
    "descripcion":"CRISIS TIROTÓXICA"
  },
  {
    "codigo":1010233001,
    "descripcion":"OTALGIA IZQUIERDA"
  },
  {
    "codigo":11786041000119107,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO DE MANO IZQUIERDA"
  },
  {
    "codigo":92729004,
    "descripcion":"CARCINOMA IN SITU DE PIEL DE INGLE"
  },
  {
    "codigo":123662000,
    "descripcion":"MESENTERIO DORSAL PERSISTENTE"
  },
  {
    "codigo":25358000,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL SIN INFECCIÓN"
  },
  {
    "codigo":289337008,
    "descripcion":"CLIP DE CORDÓN UMBILICAL COLOCADO"
  },
  {
    "codigo":58126003,
    "descripcion":"INFECCIÓN DE HERIDA POSTOPERATORIA"
  },
  {
    "codigo":254734009,
    "descripcion":"MELANOMA MALIGNO ORIGINADO EN UN NEVO CONGÉNITO"
  },
  {
    "codigo":1268707007,
    "descripcion":"DISGERMINOMA MALIGNO PRIMARIO DE OVARIO"
  },
  {
    "codigo":87224000,
    "descripcion":"OCLUSIÓN TRANSITORIA DE LA ARTERIA RETINIANA"
  },
  {
    "codigo":1332408001,
    "descripcion":"DELIRIO DE ELIMINACIÓN DE PENSAMIENTO"
  },
  {
    "codigo":283832004,
    "descripcion":"MORDEDURA DE ANIMAL EN DEDO DEL PIE"
  },
  {
    "codigo":314765000,
    "descripcion":"TRASTORNO REUMATOIDE DE FUSIÓN CORNEAL"
  },
  {
    "codigo":249229001,
    "descripcion":"HALLAZGO RELACIONADO CON EL MUÑÓN UMBILICAL"
  },
  {
    "codigo":440481000124106,
    "descripcion":"INGESTA EXCESIVA DE BETA GLUCANO"
  },
  {
    "codigo":448161000124107,
    "descripcion":"DISTENSIÓN DE MÚSCULO DE BRAZO"
  },
  {
    "codigo":447672009,
    "descripcion":"DEFECTO DEL TABIQUE INTERVENTRICULAR CON MALA ALINEACIÓN POSTERIOR DEL TABIQUE CORRESPONDIENTE AL TRACTO DE SALIDA Y CABALGAMIENTO DE VÁLVULA PULMONAR"
  },
  {
    "codigo":707981009,
    "descripcion":"EXACERBACIÓN SEVERA AGUDA DE ASMA LEVE PERSISTENTE"
  },
  {
    "codigo":1197666004,
    "descripcion":"PERFORACIÓN ESPONTÁNEA DE INTESTINO GRUESO"
  },
  {
    "codigo":312930008,
    "descripcion":"CORIORRETINITIS SARCOIDE"
  },
  {
    "codigo":1163063000,
    "descripcion":"ENCEFALITIS POR VIRUS DEL HERPES HUMANO 8"
  },
  {
    "codigo":48951005,
    "descripcion":"ENFERMEDAD AMPOLLAR DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":1259532003,
    "descripcion":"CARCINOMA PRIMARIO DE PIEL DE TRONCO"
  },
  {
    "codigo":768012004,
    "descripcion":"SOBREMORDIDA PROFUNDA CON DESTRUCCIÓN DE PARTES BLANDAS"
  },
  {
    "codigo":702476004,
    "descripcion":"SÍNDROME MIELODISPLÁSICO RELACIONADO CON TRATAMIENTO"
  },
  {
    "codigo":473100006,
    "descripcion":"INFLAMACIÓN ASOCIADA CON DISPOSITIVO VASCULAR"
  },
  {
    "codigo":276492007,
    "descripcion":"ATENDIDO POR MIEMBRO DEL EQUIPO DE ATENCIÓN PRIMARIA DE LA SALUD"
  },
  {
    "codigo":733409000,
    "descripcion":"FRACTURA DE EPITRÓCLEA DE HÚMERO"
  },
  {
    "codigo":307425001,
    "descripcion":"CELULITIS PERIANAL"
  },
  {
    "codigo":79884007,
    "descripcion":"POSICIÓN FRONTOILÍACA DERECHA POSTERIOR"
  },
  {
    "codigo":209121005,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN COSTOVERTEBRAL"
  },
  {
    "codigo":241889006,
    "descripcion":"PRODUCTOS AUTOMOTRICES QUE CAUSAN EFECTOS TÓXICOS"
  },
  {
    "codigo":274657005,
    "descripcion":"CAMBIO EN LA VOZ"
  },
  {
    "codigo":405729008,
    "descripcion":"ENTERORRAGIA"
  },
  {
    "codigo":897249009,
    "descripcion":"CURVATURA ANORMAL DE FALANGE DE MANO"
  },
  {
    "codigo":403894000,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS DE LA PIEL DE LA OREJA"
  },
  {
    "codigo":45281005,
    "descripcion":"ATEROSCLEROSIS DE ARTERIA RENAL"
  },
  {
    "codigo":1290465008,
    "descripcion":"ESTADO DE HIPOCOAGULABILIDAD"
  },
  {
    "codigo":305590004,
    "descripcion":"BAJO ATENCIÓN DE PROFESIONAL AUXILIAR DE LA MEDICINA"
  },
  {
    "codigo":11815021000119109,
    "descripcion":"RUPTURA TRAUMÁTICA DE LIGAMENTO DE ARTICULACIÓN DE DEDO ÍNDICE DERECHO"
  },
  {
    "codigo":371126007,
    "descripcion":"OBSTRUCCIÓN DE SENO PARANASAL"
  },
  {
    "codigo":240054004,
    "descripcion":"DISTROFIA MUSCULAR AUTOSÓMICA RECESIVA CON DISTRIBUCIÓN EN LA CINTURA DE EXTREMIDAD"
  },
  {
    "codigo":762507003,
    "descripcion":"TRASTORNO PSICÓTICO CAUSADO POR CATINONA SINTÉTICA"
  },
  {
    "codigo":11861000122107,
    "descripcion":"ALERGIA A PANTOPRAZOL"
  },
  {
    "codigo":1155723008,
    "descripcion":"ANOMALÍA CONGÉNITA DE VASO SANGUÍNEO DE COLUMNA VERTEBRAL"
  },
  {
    "codigo":860811009,
    "descripcion":"NEUROPATÍA AUTONÓMICA SENSITIVA HEREDITARIA TIPO ID"
  },
  {
    "codigo":1186656004,
    "descripcion":"DEFICIENCIA CONGÉNITA DE NERVIO COCLEAR"
  },
  {
    "codigo":72544005,
    "descripcion":"EDAD GESTACIONAL, 25 SEMANAS"
  },
  {
    "codigo":432992007,
    "descripcion":"ABSCESO BACTERIANO DE VÁLVULA AÓRTICA"
  },
  {
    "codigo":236384008,
    "descripcion":"SÍNDROME NEFRÓTICO CONGÉNITO CON GLOMERULOSCLEROSIS FOCAL"
  },
  {
    "codigo":301920009,
    "descripcion":"ENOFTALMOS: PRESENTE"
  },
  {
    "codigo":170848008,
    "descripcion":"TRASTORNO REUMATOLÓGICO - ARTICULACIONES AFECTADAS"
  },
  {
    "codigo":201781003,
    "descripcion":"ARTRITIS REUMATOIDE DE LA ARTICULACIÓN ASTRAGALONAVICULAR"
  },
  {
    "codigo":300085005,
    "descripcion":"HALLAZGO RELACIONADO CON LA APARIENCIA DEL PABELLÓN AURICULAR"
  },
  {
    "codigo":267317007,
    "descripcion":"TUBERCULOSIS DURANTE EL EMBARAZO"
  },
  {
    "codigo":234549008,
    "descripcion":"DEFICIENCIA DE INMUNOGLOBULINA G4"
  },
  {
    "codigo":37941009,
    "descripcion":"TRASTORNO DE RUMIACIÓN"
  },
  {
    "codigo":396554002,
    "descripcion":"TUMOR PLANO"
  },
  {
    "codigo":365621008,
    "descripcion":"HALLAZGO RELACIONADO CON LA FORMA DE LOS GLÓBULOS ROJOS"
  },
  {
    "codigo":427487000,
    "descripcion":"ALERGIA A VENENO DE ARÁCNIDO"
  },
  {
    "codigo":296415002,
    "descripcion":"SOBREDOSIS INTENCIONAL DE CLORFENAMINA"
  },
  {
    "codigo":292745000,
    "descripcion":"REACCIÓN ADVERSA A LA DESFERRIOXAMINA"
  },
  {
    "codigo":1144713002,
    "descripcion":"HIPOPLASIA DE FALANGE DISTAL DE DEDO GORDO"
  },
  {
    "codigo":782430000,
    "descripcion":"INESTABILIDAD DE ARTICULACIÓN RADIOCUBITAL DISTAL"
  },
  {
    "codigo":1208414002,
    "descripcion":"MIOPATÍA CONGÉNITA POR DESPROPORCIÓN DEL TIPO DE FIBRA RECESIVA AUTOSÓMICA DEBIDA A MUTACIÓN DE ACTA1 (ACTINA ALFA 1)"
  },
  {
    "codigo":389214003,
    "descripcion":"DISPLASIA DIAFISARIA Y ANEMIA"
  },
  {
    "codigo":28766006,
    "descripcion":"HEPATITIS VIRAL POSTRANSFUSIÓN"
  },
  {
    "codigo":290910006,
    "descripcion":"INTOXICACIÓN POR FLUVOXAMINA"
  },
  {
    "codigo":258142008,
    "descripcion":"PRONUNCIA SU PROPIO NOMBRE"
  },
  {
    "codigo":127070008,
    "descripcion":"TRASTORNO HISTIOCÍTICO MALIGNO"
  },
  {
    "codigo":92467002,
    "descripcion":"NEOPLASIA BENIGNA DEL CUELLO DE LA VEJIGA"
  },
  {
    "codigo":94302007,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL PRIMER HUESO CUNEIFORME DEL TARSO"
  },
  {
    "codigo":323811000119100,
    "descripcion":"CARPOPTOSIS DE MUÑECA DERECHA"
  },
  {
    "codigo":878899005,
    "descripcion":"INGESTA INADECUADA DE FIBRA VEGETAL"
  },
  {
    "codigo":117776611000119102,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DEBIDO A OCLUSIÓN DE ARTERIA COMUNICANTE POSTERIOR IZQUIERDA"
  },
  {
    "codigo":290531000119102,
    "descripcion":"CEFALEA TENSIONAL CRÓNICA INTRATABLE"
  },
  {
    "codigo":308451000119104,
    "descripcion":"GRANULOMA POR CUERPO EXTRAÑO DE PARTES BLANDAS DE LA MANO DERECHA"
  },
  {
    "codigo":90632001,
    "descripcion":"INTOXICACIÓN AGUDA POR COBRE"
  },
  {
    "codigo":1073891000119106,
    "descripcion":"DEFORMIDAD PIE IZQUIERDO CONCOMITANTE CON ARTRITIS REUMATOIDE Y DEBIDA A ELLA"
  },
  {
    "codigo":254472003,
    "descripcion":"NEOPLASIA BENIGNA DE SENO MASTOIDEO"
  },
  {
    "codigo":1076451000119107,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE ESTRUCTURA MUSCULAR O TENDINOSA DE MANGUITO ROTADOR DE HOMBRO DERECHO"
  },
  {
    "codigo":894362851000119109,
    "descripcion":"ENFERMEDAD CAUSADA POR CORONAVIRUS 2 DEL SÍNDROME RESPIRATORIO AGUDO SEVERO DURANTE EMBARAZO"
  },
  {
    "codigo":10812131000119108,
    "descripcion":"DESNUTRICIÓN EN LA MADRE QUE COMPLICA EL NACIMIENTO"
  },
  {
    "codigo":1237512003,
    "descripcion":"SÍNDROME DE TALLA BAJA, RETRASO DEL DESARROLLO Y DEFECTOS CARDÍACOS CONGÉNITOS"
  },
  {
    "codigo":711389000,
    "descripcion":"EMPEORAMIENTO DE LA TOLERANCIA AL EJERCICIO"
  },
  {
    "codigo":88797001,
    "descripcion":"COMPLICACIÓN DE PROCEDIMIENTO QUIRÚRGICO"
  },
  {
    "codigo":49891000119106,
    "descripcion":"LESIÓN DE PÁRPADO INFERIOR"
  },
  {
    "codigo":318691000119109,
    "descripcion":"ARTROSIS DE ARTICULACIÓN DE TOBILLO Y PIE DERECHOS"
  },
  {
    "codigo":187101004,
    "descripcion":"MUCORMICOSIS GASTROINTESTINAL"
  },
  {
    "codigo":939595491000119108,
    "descripcion":"MELANOMA MALIGNO DE PIEL DE ANTEBRAZO DERECHO"
  },
  {
    "codigo":416477006,
    "descripcion":"HIPERTIROIDISMO RESUELTO"
  },
  {
    "codigo":11817531000119108,
    "descripcion":"ESGUINCE DE LIGAMENTO DE DEDO MEÑIQUE IZQUIERDO"
  },
  {
    "codigo":21426000,
    "descripcion":"TRASTORNO DE LA MEMBRANA TIMPÁNICA"
  },
  {
    "codigo":840626001,
    "descripcion":"ÚTERO GRÁVIDO DE TAMAÑO CORRESPONDIENTE A 16-20 SEMANAS"
  },
  {
    "codigo":185266004,
    "descripcion":"ATENDIDO EN UN CONSULTORIO DE ATENCIÓN POSTNATAL"
  },
  {
    "codigo":283570005,
    "descripcion":"HERIDA DE PERDIGÓN EN PULGAR"
  },
  {
    "codigo":184891000119109,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE INTESTINO DELGADO"
  },
  {
    "codigo":1363079001,
    "descripcion":"ASTILLA EN DEDO DE PIE CON INFECCIÓN"
  },
  {
    "codigo":248967002,
    "descripcion":"CICLOS MENSTRUALES CORTOS"
  },
  {
    "codigo":216199005,
    "descripcion":"LESIÓN POR MAQUINARIA EN AERONAVE, SIN ACCIDENTE DE AERONAVE"
  },
  {
    "codigo":247132001,
    "descripcion":"HEMORRAGIA EN LLAMA DE LA RETINA"
  },
  {
    "codigo":771420004,
    "descripcion":"DELIRIO HIPOACTIVO LUEGO DE PROCEDIMIENTO QUIRÚRGICO"
  },
  {
    "codigo":312668007,
    "descripcion":"FRECUENCIA CARDÍACA FETAL ANORMAL"
  },
  {
    "codigo":278065000,
    "descripcion":"SÍNDROME DE PANCOAST"
  },
  {
    "codigo":48689002,
    "descripcion":"QUEMADURA DE ESTRUCTURA GENITAL MASCULINA"
  },
  {
    "codigo":441905004,
    "descripcion":"ESTUDIO POR IMÁGENES DE LA GLÁNDULA TIROIDES, ANORMAL"
  },
  {
    "codigo":1162801006,
    "descripcion":"TRIPSINÓGENO INMUNORREACTIVO DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":243462001,
    "descripcion":"CONJUNTIVITIS MUCOPURULENTA"
  },
  {
    "codigo":276230003,
    "descripcion":"ENFERMEDAD SISTÉMICA SEVERA INDUCIDA POR EMACIACIÓN DE MÚSCULOS RESPIRATORIOS"
  },
  {
    "codigo":700379002,
    "descripcion":"ENFERMEDAD RENAL CRÓNICA EN ESTADIO 3B"
  },
  {
    "codigo":733147004,
    "descripcion":"INFECCIÓN PARASITARIA QUE PRODUCE ÚLCERA DE ESÓFAGO"
  },
  {
    "codigo":45019006,
    "descripcion":"SÍNDROME DE BARD - PIC"
  },
  {
    "codigo":208859007,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN METACARPOFALÁNGICA"
  },
  {
    "codigo":403632002,
    "descripcion":"EPIDERMÓLISIS BULLOSA ADQUIRIDA MEDICAMENTOSA"
  },
  {
    "codigo":239792003,
    "descripcion":"ARTRITIS REUMATOIDEA SERONEGATIVA"
  },
  {
    "codigo":698544004,
    "descripcion":"REQUIERE DISPOSITIVO DE ORTODONCIA FUNCIONAL"
  },
  {
    "codigo":10416004,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO DE PIERNA"
  },
  {
    "codigo":678921000119100,
    "descripcion":"HUSO DE KRUKENBERG EN OJO IZQUIERDO"
  },
  {
    "codigo":272560007,
    "descripcion":"POSICIÓN SUPINA Y CON UN CUARTO DE GIRO HACIA LA IZQUIERDA - PIE DE LA CAMA ELEVADO 35 CM"
  },
  {
    "codigo":205189001,
    "descripcion":"DETENCIÓN DEL CRECIMIENTO TRANSVERSO A NIVEL FALÁNGICO DEL TERCER RAYO"
  },
  {
    "codigo":303493002,
    "descripcion":"CAPAZ DE PONERSE DE COSTADO EN LA CAMA"
  },
  {
    "codigo":237957007,
    "descripcion":"ACIDURIA 3-HIDROXIISOBUTÍRICA"
  },
  {
    "codigo":41349008,
    "descripcion":"HIPERPLASIA PAPILAR DEL PALADAR"
  },
  {
    "codigo":236122001,
    "descripcion":"DESPRENDIMIENTO DE ESTOMA"
  },
  {
    "codigo":74117008,
    "descripcion":"PROSTATORREA"
  },
  {
    "codigo":301658006,
    "descripcion":"SE LEVANTA DE UNA SILLA"
  },
  {
    "codigo":365359006,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA MANEJAR DINERO"
  },
  {
    "codigo":267055007,
    "descripcion":"MATERIA FECAL NEGRA"
  },
  {
    "codigo":299823006,
    "descripcion":"RESPUESTA MOTORA A LA PRESIÓN PROFUNDA DE LA GLABELA, AUSENTE"
  },
  {
    "codigo":232452002,
    "descripcion":"QUISTE EPIDERMOIDE DE CUERDA VOCAL"
  },
  {
    "codigo":15670281000119106,
    "descripcion":"CONTRACTURA CONGÉNITA DE MÚSCULO GEMELO DERECHO"
  },
  {
    "codigo":297988008,
    "descripcion":"UÑA NORMAL"
  },
  {
    "codigo":296153001,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE CLORMETIAZOL"
  },
  {
    "codigo":197849006,
    "descripcion":"CISTITIS MONILIÁSICA"
  },
  {
    "codigo":427225008,
    "descripcion":"ATONÍA DE ESÓFAGO"
  },
  {
    "codigo":230617009,
    "descripcion":"NEUROPATÍA DEL PLEXO LUMBOSACRO"
  },
  {
    "codigo":32174002,
    "descripcion":"TRASTORNO DE LA VOZ POR CONFLICTO PSICOSEXUAL"
  },
  {
    "codigo":294318004,
    "descripcion":"ALERGIA A ACEITE DE RICINO"
  },
  {
    "codigo":425390006,
    "descripcion":"DEMENCIA ASOCIADA CON ENFERMEDAD DE PARKINSON"
  },
  {
    "codigo":292483000,
    "descripcion":"REACCIÓN ADVERSA A AGONISTA DE RECEPTOR ALFA-ADRENÉRGICO"
  },
  {
    "codigo":1144451001,
    "descripcion":"APLASIA DE FALANGE PROXIMAL DE DEDO ÍNDICE"
  },
  {
    "codigo":390787006,
    "descripcion":"CICATRIZ RADIAL DE MAMA"
  },
  {
    "codigo":259715006,
    "descripcion":"CUERPO DE DÖHLE"
  },
  {
    "codigo":194179009,
    "descripcion":"HEMORRAGIA RETROBULBAR"
  },
  {
    "codigo":94040002,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA PIEL DE LA REGIÓN TEMPORAL"
  },
  {
    "codigo":290648003,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR PLICAMICINA"
  },
  {
    "codigo":126808006,
    "descripcion":"NEOPLASIA DE LA ÚVULA"
  },
  {
    "codigo":28504009,
    "descripcion":"INTOXICACIÓN POR MEPROBAMATO"
  },
  {
    "codigo":92205005,
    "descripcion":"NEOPLASIA BENIGNA DE GLÁNDULA SALIVAL MAYOR"
  },
  {
    "codigo":419885006,
    "descripcion":"REACCIÓN ADVERSA A ANTIBIÓTICOS BETALACTÁMICOS"
  },
  {
    "codigo":160931000119108,
    "descripcion":"NIVEL DE ASPARTATO TRANSAMINASA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":288813008,
    "descripcion":"INCAPAZ DE IMITAR FORMAS DE COMUNICACIÓN"
  },
  {
    "codigo":57602001,
    "descripcion":"DENTÍCULOS"
  },
  {
    "codigo":876802003,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DEL MUSLO CON INFECCIÓN"
  },
  {
    "codigo":11849021000119103,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE MAMA IZQUIERDA"
  },
  {
    "codigo":188674006,
    "descripcion":"LINFOMA MALIGNO DIFUSO - CÉLULAS PEQUEÑAS NO CLIVADAS"
  },
  {
    "codigo":448983000,
    "descripcion":"NEOPLASIA BENIGNA DE PARTES BLANDAS DEL BRAZO"
  },
  {
    "codigo":22999005,
    "descripcion":"AMPOLLA DE MUSLO, CON INFECCIÓN"
  },
  {
    "codigo":283308000,
    "descripcion":"ASTILLA DE MADERA EN EL MUSLO"
  },
  {
    "codigo":185004005,
    "descripcion":"INFORME MÉDICO RECIBIDO"
  },
  {
    "codigo":414380008,
    "descripcion":"HAWKINSINURIA"
  },
  {
    "codigo":838529004,
    "descripcion":"TRASTORNO DEL ESTADO DE ÁNIMO CON SÍNTOMAS MANÍACOS Y DEPRESIVOS MIXTOS CAUSADO POR ANFETAMINA Y\/O DERIVADO DE ANFETAMINA"
  },
  {
    "codigo":1297281004,
    "descripcion":"CELULITIS DE DEDO ANULAR"
  },
  {
    "codigo":707457009,
    "descripcion":"CARCINOMA PRIMARIO DE CÉLULAS FUSIFORMES DE PULMÓN"
  },
  {
    "codigo":443478002,
    "descripcion":"BLOQUEO CARDÍACO CAUSADO POR FÁRMACO"
  },
  {
    "codigo":115798004,
    "descripcion":"FENOTIPO LANDSTEINER - WIENER"
  },
  {
    "codigo":246870007,
    "descripcion":"HALLAZGO RELACIONADO CON LA PELÍCULA LAGRIMAL"
  },
  {
    "codigo":15659001,
    "descripcion":"INFECCIÓN CAUSADA POR PSEUDOTERRANOVA"
  },
  {
    "codigo":212267006,
    "descripcion":"LESIÓN ABIERTA DE RAMA SENSITIVA PALMAR DE NERVIO CUBITAL"
  },
  {
    "codigo":210432004,
    "descripcion":"LESIÓN POR DESOLLAMIENTO DE ESCROTO"
  },
  {
    "codigo":11796081000119101,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN METACARPOFALÁNGICA DE DEDO ÍNDICE IZQUIERDO"
  },
  {
    "codigo":208597003,
    "descripcion":"FRACTURA NO EXPUESTA DE RÓTULA, POLO PROXIMAL"
  },
  {
    "codigo":863957008,
    "descripcion":"NECROSIS CRÓNICA DE HÍGADO"
  },
  {
    "codigo":403370006,
    "descripcion":"MANCHAS DE FORDYCE EN EL PENE"
  },
  {
    "codigo":237695004,
    "descripcion":"DEFICIENCIA IDIOPÁTICA DE HORMONA TIROESTIMULANTE"
  },
  {
    "codigo":301396000,
    "descripcion":"DOLOR A LA PALPACIÓN DE ESTRUCTURA GENITAL MASCULINA"
  },
  {
    "codigo":1153364004,
    "descripcion":"GOTA AGUDA CAUSADA POR FÁRMACO"
  },
  {
    "codigo":299561000,
    "descripcion":"DEFORMIDAD DE HUESO EN PIE"
  },
  {
    "codigo":234025000,
    "descripcion":"SÍNDROME DE ROBO ARTERIAL DE LA MANO"
  },
  {
    "codigo":365097004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA SORTEAR EL CORDÓN DE LA ACERA"
  },
  {
    "codigo":70185004,
    "descripcion":"RESPIRACIÓN APNÉUSTICA"
  },
  {
    "codigo":1217065006,
    "descripcion":"VIRILIZACIÓN FEMENINA DEBIDA A HIPERFUNCIÓN DE GLÁNDULA SUPRARRENAL"
  },
  {
    "codigo":15728241000119108,
    "descripcion":"FÍSTULA DE ARTICULACIÓN DE AMBOS PIES"
  },
  {
    "codigo":102953004,
    "descripcion":"RELACIÓN SEXUAL ABUSIVA CON EL ESPOSO"
  },
  {
    "codigo":428798001,
    "descripcion":"FRACTURA NO EXPUESTA DE PLATILLO TIBIAL"
  },
  {
    "codigo":789246006,
    "descripcion":"INGESTA EXCESIVA DE EDULCORANTE INTENSO"
  },
  {
    "codigo":721875000,
    "descripcion":"SÍNDROME DE JUBERG MARSIDI"
  },
  {
    "codigo":230355005,
    "descripcion":"ENCEFALOPATÍA CAUSADA POR METALES PESADOS"
  },
  {
    "codigo":263123005,
    "descripcion":"DESGARRO EN ASA DE BALDE DEL MENISCO INTERNO DE LA RODILLA"
  },
  {
    "codigo":164819007,
    "descripcion":"PRUEBA DE INFERTILIDAD FEMENINA, NORMAL"
  },
  {
    "codigo":295891008,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE FENELZINA"
  },
  {
    "codigo":787411009,
    "descripcion":"SÍNDROME DE MONOSOMÍA 22"
  },
  {
    "codigo":162984005,
    "descripcion":"SISTEMA CARDIOVASCULAR EXAMINADO - NO SE DETECTARON ANOMALÍAS"
  },
  {
    "codigo":30077003,
    "descripcion":"TRASTORNO SOMATOMORFO POR DOLOR"
  },
  {
    "codigo":292221003,
    "descripcion":"REACCIÓN ADVERSA A LA PLICAMICINA"
  },
  {
    "codigo":95613005,
    "descripcion":"ALCALOSIS RESPIRATORIA NEONATAL"
  },
  {
    "codigo":783741006,
    "descripcion":"HIPERINSULINISMO FOCAL RESISTENTE A DIAZÓXIDO DEBIDO A DEFICIENCIA DE KIR6.2"
  },
  {
    "codigo":290386001,
    "descripcion":"INTOXICACIÓN POR ÁCIDO 5-AMINOSALICÍLICO"
  },
  {
    "codigo":93778001,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL ENDOCARDIO"
  },
  {
    "codigo":192082001,
    "descripcion":"TRASTORNO DE CONDUCTA ANTISOCIAL AGRESIVA"
  },
  {
    "codigo":126546006,
    "descripcion":"NEOPLASIA DE HUESO CIGOMÁTICO"
  },
  {
    "codigo":124711003,
    "descripcion":"DEFICIENCIA DE ARGININOSUCCINATO SINTASA"
  },
  {
    "codigo":91943004,
    "descripcion":"DOLOR DE ARTICULACIÓN TEMPOROMANDIBULAR"
  },
  {
    "codigo":288551003,
    "descripcion":"NO REALIZA ACTIVIDADES DE LAVADO Y SECADO DE SÍ MISMO"
  },
  {
    "codigo":190247004,
    "descripcion":"BOCIO TÓXICO MULTINODULAR SIN CRISIS"
  },
  {
    "codigo":712700000,
    "descripcion":"JAEGER TIPO 13"
  },
  {
    "codigo":286716002,
    "descripcion":"CARÁCTER EMOCIONALMENTE FRÍO"
  },
  {
    "codigo":1236988005,
    "descripcion":"BLEFARITIS ANTERIOR DE PÁRPADO SUPERIOR"
  },
  {
    "codigo":1204220008,
    "descripcion":"OCLUSIÓN TROMBÓTICA AGUDA DE BIFURCACIÓN AÓRTICA"
  },
  {
    "codigo":88273006,
    "descripcion":"HIPOTIROIDISMO IATROGÉNICO"
  },
  {
    "codigo":448721009,
    "descripcion":"TRAYECTO ANORMAL DE CAYADO AÓRTICO Y AORTA DESCENDIENTE"
  },
  {
    "codigo":283046003,
    "descripcion":"LESIÓN SUPERFICIAL DE LA PLANTA DEL PIEL"
  },
  {
    "codigo":250278009,
    "descripcion":"MACROPOLICITOSIS"
  },
  {
    "codigo":248443002,
    "descripcion":"FIEBRE HEPÁTICA INTERMITENTE"
  },
  {
    "codigo":1297019003,
    "descripcion":"CIERRE DE ÁNGULO SECUNDARIO DE OJO DERECHO"
  },
  {
    "codigo":707195006,
    "descripcion":"CONDICIÓN DE DIENTE PILAR, SEVERAMENTE COMPROMETIDA, 4 SEXTANTES O MÁS"
  },
  {
    "codigo":1264251009,
    "descripcion":"CICATRIZ DE PIEL DE MEJILLA IZQUIERDA"
  },
  {
    "codigo":246608003,
    "descripcion":"MOVILIDAD EXCESIVA DE NERVIO CUBITAL EN CODO"
  },
  {
    "codigo":770896003,
    "descripcion":"SÍNDROME DE PREDISPOSICIÓN A CARCINOMA DE CÉLULAS RENALES Y MELANOMA ASOCIADO A MITF"
  },
  {
    "codigo":82768008,
    "descripcion":"INTOXICACIÓN POR MESCALINA"
  },
  {
    "codigo":703525006,
    "descripcion":"DISPLASIA ECTODÉRMICA ANHIDRÓTICA CON DEFICIENCIA INMUNITARIA"
  },
  {
    "codigo":48165008,
    "descripcion":"MIOGLOBINURIA"
  },
  {
    "codigo":212005009,
    "descripcion":"QUEMADURA Y CORROSIÓN DE CADERA Y EXTREMIDAD INFERIOR, EXCEPTO TOBILLO Y PIE"
  },
  {
    "codigo":15704281000119102,
    "descripcion":"ATROFIA MUSCULAR BILATERAL DE BRAZO"
  },
  {
    "codigo":242938008,
    "descripcion":"LESIÓN POR INTERVENCIÓN LEGAL, GOLPEADO CON UN BASTÓN"
  },
  {
    "codigo":111866008,
    "descripcion":"ENFERMEDAD POR VIRUS BUSSUQUARA"
  },
  {
    "codigo":699855003,
    "descripcion":"CONTRACTURA MIOSTÁTICA DE MÚSCULO DE LA MASTICACIÓN"
  },
  {
    "codigo":1156772007,
    "descripcion":"PERINEUROMA ESCLEROSANTE DE NERVIO PERIFÉRICO"
  },
  {
    "codigo":403108008,
    "descripcion":"ONICÓLISIS POR INFECCIÓN MICÓTICA UNGUEAL"
  },
  {
    "codigo":1351545003,
    "descripcion":"FALTA DE PERFUSIÓN DE CAPILARES PERIFOVEALES"
  },
  {
    "codigo":202830000,
    "descripcion":"SUBLUXACIÓN ATLOAXOIDEA RECURRENTE CON MIELOPATÍA"
  },
  {
    "codigo":302969009,
    "descripcion":"DESPRENDIMIENTO DE PRÓTESIS ARTICULAR"
  },
  {
    "codigo":366670002,
    "descripcion":"SENSIBILIDAD A LA RESPUESTA INFECCIOSA - HALLAZGO"
  },
  {
    "codigo":170062002,
    "descripcion":"PERÍMETRO CEFÁLICO INFANTIL IGUAL A PERCENTIL 3"
  },
  {
    "codigo":399438004,
    "descripcion":"COMPROMISO TUMORAL DEL MARGEN QUIRÚRGICO DEL CORDÓN ESPERMÁTICO, NO PUEDE SER EVALUADO"
  },
  {
    "codigo":1251406005,
    "descripcion":"DERMATITIS ATÓPICA PRURIGINOSA EN INFANCIA"
  },
  {
    "codigo":235598006,
    "descripcion":"ESOFAGITIS NO ASOCIADA A REFLUJO"
  },
  {
    "codigo":364835003,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA CORRER EN TERRENO PLANO"
  },
  {
    "codigo":299299008,
    "descripcion":"AMPLITUD DE ROTACIÓN EXTERNA ACTIVA DE ARTICULACIÓN DE CADERA, DISMINUIDA"
  },
  {
    "codigo":788984001,
    "descripcion":"DISTROFIA UNGUEAL ECCEMATOSA"
  },
  {
    "codigo":231928002,
    "descripcion":"AMILOIDOSIS CORNEAL"
  },
  {
    "codigo":233763009,
    "descripcion":"SILICOTUBERCULOSIS"
  },
  {
    "codigo":686451000119106,
    "descripcion":"GLIOMA MALIGNO PRIMARIO DE LÓBULO PARIETAL"
  },
  {
    "codigo":723448007,
    "descripcion":"SÍNDROME DE CARDIOPATÍA POLIVALVULAR"
  },
  {
    "codigo":295629000,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE IFOSFAMIDA"
  },
  {
    "codigo":262861001,
    "descripcion":"PERFORACIÓN TARDÍA DE APÉNDICE ILEOCECAL"
  },
  {
    "codigo":721613002,
    "descripcion":"PERFORACIÓN INTRAUTERINA DE INTESTINO FETAL"
  },
  {
    "codigo":10818061000119102,
    "descripcion":"FRACTURA EXPUESTA DE LA FALANGE MEDIA DEL DEDO MEDIO DE LA MANO DERECHA"
  },
  {
    "codigo":113011000119109,
    "descripcion":"ARTROSIS DE ARTICULACIÓN DE AMBAS MANOS"
  },
  {
    "codigo":64418005,
    "descripcion":"ESCOTOMA PARACENTRAL"
  },
  {
    "codigo":293794006,
    "descripcion":"ALERGIA A VINCRISTINA"
  },
  {
    "codigo":423031000,
    "descripcion":"FENÓMENO MIOTÓNICO DURANTE EL CALENTAMIENTO - DESCENSO RETRASADO DEL PÁRPADO SUPERIOR"
  },
  {
    "codigo":291959002,
    "descripcion":"INTOXICACIÓN POR BENDROFLUAZIDA"
  },
  {
    "codigo":95351003,
    "descripcion":"TRASTORNO DE MEMBRANA MUCOSA"
  },
  {
    "codigo":128119004,
    "descripcion":"INFECCIÓN BACTERIANA DEL SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":62583006,
    "descripcion":"FLEGMASIA ALBA DOLENS EN PUERPERIO"
  },
  {
    "codigo":160887007,
    "descripcion":"NIÑO EN REGISTRO DE PROTECCIÓN"
  },
  {
    "codigo":1142092000,
    "descripcion":"OSTEOCONDROPATÍA SIFILÍTICA CONGÉNITA TARDÍA"
  },
  {
    "codigo":717943008,
    "descripcion":"SÍNDROME DE MALFORMACIÓN CEREBRAL, CARDIOPATÍA CONGÉNITA, POLIDACTILIA POSTAXIAL"
  },
  {
    "codigo":34739009,
    "descripcion":"MASTOCITOSIS CUTÁNEA, DEL ADULTO"
  },
  {
    "codigo":716108004,
    "descripcion":"SÍNDROME DE MACROCEFALIA CON PARAPLEJÍA ESPÁSTICA Y DISMORFISMO"
  },
  {
    "codigo":290124006,
    "descripcion":"HALLAZGO RELACIONADO CON EL VOLUMEN DE LA LACTANCIA"
  },
  {
    "codigo":191820008,
    "descripcion":"FARMACODEPENDENCIA DE OPIÁCEOS EPISÓDICA"
  },
  {
    "codigo":58913003,
    "descripcion":"INTOXICACIÓN POR CASSIA"
  },
  {
    "codigo":24310001,
    "descripcion":"EFECTO TÓXICO DEL ANHÍDRIDO SULFUROSO"
  },
  {
    "codigo":286454003,
    "descripcion":"INCAPAZ DE PREPARAR ALIMENTO PARA COMER"
  },
  {
    "codigo":1169355000,
    "descripcion":"SÍNDROME DE MALFORMACIONES CEREBRALES, ANOMALÍAS MUSCULOESQUELÉTICAS, DISMORFIA FACIAL Y DISCAPACIDAD INTELECTUAL"
  },
  {
    "codigo":22475001,
    "descripcion":"ABSCESO DE LA PIEL, CON LINFANGITIS DE DEDO"
  },
  {
    "codigo":219083000,
    "descripcion":"REACCIÓN ADVERSA A VACUNA CONTRA LA PESTE"
  },
  {
    "codigo":284619004,
    "descripcion":"CRUELDAD HACIA LAS PERSONAS"
  },
  {
    "codigo":315552001,
    "descripcion":"NACIDO EN UCRANIA"
  },
  {
    "codigo":250016005,
    "descripcion":"MARCHA EN CUCLILLAS"
  },
  {
    "codigo":118944007,
    "descripcion":"TRASTORNO DE HOMBRO"
  },
  {
    "codigo":1003680007,
    "descripcion":"CLASIFICACIÓN DE INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA DE LOS CENTROS PARA EL CONTROL Y PREVENCIÓN DE ENFERMEDADES TIPO INDIFERENCIADO"
  },
  {
    "codigo":18805001,
    "descripcion":"DIARREA SECRETORA CONGÉNITA CON PÉRDIDA DE SODIO"
  },
  {
    "codigo":248181001,
    "descripcion":"LABIOS SECOS"
  },
  {
    "codigo":117109006,
    "descripcion":"UNIDAD DE HEMODERIVADO RECHAZADA, NO INGRESADA AL INVENTARIO"
  },
  {
    "codigo":280949006,
    "descripcion":"EROTOMANÍA"
  },
  {
    "codigo":1231221007,
    "descripcion":"DESPLAZAMIENTO INFERIOR DE GLOBO OCULAR"
  },
  {
    "codigo":141991000119109,
    "descripcion":"ENFERMEDAD DE ALZHEIMER CON IDEAS DELIRANTES"
  },
  {
    "codigo":47903000,
    "descripcion":"HIPOVITAMINOSIS B"
  },
  {
    "codigo":16909121000119104,
    "descripcion":"HIDROCISTOMA APOCRINO DE PÁRPADO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":408351004,
    "descripcion":"INTERACCIONES MEDICAMENTOSAS CONSIDERADAS COMO NUEVOS FÁRMACOS AGREGADOS"
  },
  {
    "codigo":703263004,
    "descripcion":"CANDIDA SAKE O CANDIDA FAMATA O YARROWIA LIPOLYTICA"
  },
  {
    "codigo":768799003,
    "descripcion":"IRITIS DIABÉTICA BILATERAL"
  },
  {
    "codigo":15135007,
    "descripcion":"TRANSPOSICIÓN CONGÉNITA DE ESTÓMAGO"
  },
  {
    "codigo":13300001,
    "descripcion":"EQUILIBRIO DE ENLACE GENÉTICO"
  },
  {
    "codigo":275444001,
    "descripcion":"AMPOLLA TRAUMÁTICA DEL TALÓN, INFECTADA"
  },
  {
    "codigo":308212008,
    "descripcion":"AMPOLLA DUODENAL DEFORMADA"
  },
  {
    "codigo":109769000,
    "descripcion":"SIALOMETAPLASIA NECROSANTE"
  },
  {
    "codigo":306377000,
    "descripcion":"ATENDIDO POR SERVICIO DE CIRUGÍA GENERAL GASTROINTESTINAL"
  },
  {
    "codigo":334811000119101,
    "descripcion":"QUISTE IDIOPÁTICO DE CUERPO CILIAR DE OJO DERECHO"
  },
  {
    "codigo":404681006,
    "descripcion":"INFECCIÓN CAUSADA POR STAPHYLOCCOCUS AUREUS RESISTENTE A VANCOMICINA"
  },
  {
    "codigo":240841007,
    "descripcion":"SOWDA"
  },
  {
    "codigo":15680321000119108,
    "descripcion":"CONJUNTIVITIS FOLICULAR AGUDA BILATERAL POR ADENOVIRUS"
  },
  {
    "codigo":206238001,
    "descripcion":"EDEMA CEREBRAL POR TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":271774001,
    "descripcion":"MÚLTIPLES ANOMALÍAS ÓSEAS"
  },
  {
    "codigo":239006001,
    "descripcion":"DISPLASIA ECTODÉRMICA CON DEFECTO DE PELO-DIENTES-UÑAS-SUDOR"
  },
  {
    "codigo":304542004,
    "descripcion":"DOLOR ABDOMINAL INESPECÍFICO"
  },
  {
    "codigo":402846006,
    "descripcion":"CUTIS MARMÓREO NEONATAL"
  },
  {
    "codigo":237171000,
    "descripcion":"ESTENOSIS VAGINAL EN EL EMBARAZO, PARTO Y PUERPERIO"
  },
  {
    "codigo":73331006,
    "descripcion":"HEMIMIELIA"
  },
  {
    "codigo":269939008,
    "descripcion":"HONGO DETECTADO EN ESPÉCIMEN POR EXAMEN MICROSCÓPICO DIRECTO"
  },
  {
    "codigo":366408000,
    "descripcion":"AMPLITUD DE MOVIMIENTO PASIVO DE FLEXIÓN DE LA COLUMNA DORSAL - HALLAZGO"
  },
  {
    "codigo":399176003,
    "descripcion":"QUISTE DE CÚPULA AZUL"
  },
  {
    "codigo":300872008,
    "descripcion":"TUMEFACCIÓN DE ESTRUCTURA ANATÓMICA"
  },
  {
    "codigo":299037003,
    "descripcion":"TUMEFACCIÓN DE LA MANO"
  },
  {
    "codigo":11803611000119108,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA PROXIMAL DE DEDO MEÑIQUE IZQUIERDO"
  },
  {
    "codigo":262599003,
    "descripcion":"CUERPO EXTRAÑO EN LA VÍA RESPIRATORIA"
  },
  {
    "codigo":197063004,
    "descripcion":"ENTEROLITO"
  },
  {
    "codigo":15955061000119104,
    "descripcion":"PTOSIS DE AMBAS MAMAS"
  },
  {
    "codigo":295367007,
    "descripcion":"SOBREDOSIS INTENCIONAL DE RANITIDINA"
  },
  {
    "codigo":719516000,
    "descripcion":"DISTONÍA FOCAL AUTOSÓMICA DOMINANTE TIPO DYT25"
  },
  {
    "codigo":721351009,
    "descripcion":"FRACTURA DE SÉPTIMA VÉRTEBRA CERVICAL"
  },
  {
    "codigo":64156001,
    "descripcion":"TROMBOFLEBITIS"
  },
  {
    "codigo":129692003,
    "descripcion":"CON MAYOR RIESGO DE INCONTINENCIA DE URGENCIA"
  },
  {
    "codigo":1145500002,
    "descripcion":"HIPOPLASIA CONGÉNITA DE TERCER HUESO METACARPIANO"
  },
  {
    "codigo":95089001,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL VELO DEL PALADAR"
  },
  {
    "codigo":29553002,
    "descripcion":"DIENTES CON FORMA DE CLAVIJA"
  },
  {
    "codigo":12242191000119101,
    "descripcion":"SÍNDROME DE LA ABERTURA DE SALIDA TORÁCICA DERECHO"
  },
  {
    "codigo":226161004,
    "descripcion":"DIETA RICA EN HIERRO"
  },
  {
    "codigo":27718001,
    "descripcion":"ENFERMEDAD DE LA ORINA EN JARABE DE ARCE"
  },
  {
    "codigo":289862004,
    "descripcion":"PÚRPURA DE PERINEO FEMENINO"
  },
  {
    "codigo":1141830005,
    "descripcion":"SIGNO DE ARCHIBALD"
  },
  {
    "codigo":93254007,
    "descripcion":"HIPOPLASIA CONGÉNITA DE LA PROTUBERANCIA OCULAR"
  },
  {
    "codigo":124187002,
    "descripcion":"DEFICIENCIA DE CISTINA REDUCTASA (NADH)"
  },
  {
    "codigo":1303835007,
    "descripcion":"ARTRITIS DE ARTICULACIÓN DE REGIÓN DE HOMBRO"
  },
  {
    "codigo":419099009,
    "descripcion":"MUERTO"
  },
  {
    "codigo":91419009,
    "descripcion":"FRACTURA NO EXPUESTA DE ANTEBRAZO"
  },
  {
    "codigo":417264005,
    "descripcion":"QUERATOACANTOMA DE PIEL"
  },
  {
    "codigo":286192005,
    "descripcion":"CAPAZ DE CERRAR LA CASA EN FORMA SEGURA"
  },
  {
    "codigo":54981004,
    "descripcion":"INFLAMACIÓN MUSCULAR"
  },
  {
    "codigo":1201861004,
    "descripcion":"ENFERMEDAD DE LOS CUERPOS CENTRALES AUTOSÓMICA DOMINANTE"
  },
  {
    "codigo":251589008,
    "descripcion":"HALLAZGO ELECTRORRETINOGRÁFICO"
  },
  {
    "codigo":1003418000,
    "descripcion":"DELECIÓN DE PORCIÓN MEDIA DEL BRAZO LARGO DE CROMOSOMA 1"
  },
  {
    "codigo":249754002,
    "descripcion":"CAMBIO EN EL TAMAÑO DEL GUANTE - HALLAZGO"
  },
  {
    "codigo":282522006,
    "descripcion":"DIFICULTAD PARA BAJAR ESCALONES CORRIENDO"
  },
  {
    "codigo":53146006,
    "descripcion":"OBESIDAD HIPOTIROIDEA"
  },
  {
    "codigo":1263727005,
    "descripcion":"TRASTORNO FETAL DEBIDO A OLIGOAMNIOS"
  },
  {
    "codigo":82244004,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN REGIÓN DE CODO, SIN INFECCIÓN"
  },
  {
    "codigo":278852008,
    "descripcion":"PSICOSIS EPILÉPTICA PARANOIDE ALUCINATORIA"
  },
  {
    "codigo":442692008,
    "descripcion":"ATRAPAMIENTO DE INTESTINO EN FRACTURA PÉLVICA"
  },
  {
    "codigo":342553006,
    "descripcion":"HIPERLISINEMIA PERIÓDICA CON HIPERAMONEMIA"
  },
  {
    "codigo":337321000119108,
    "descripcion":"BLEFARITIS DE PÁRPADO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":309785008,
    "descripcion":"DESPLAZAMIENTO DE SONDA DE NEFROSTOMÍA"
  },
  {
    "codigo":47641009,
    "descripcion":"ACIDURIA ORÓTICA"
  },
  {
    "codigo":703001009,
    "descripcion":"STREPTOCOCCUS MITIS O STREPTOCOCCUS ORALIS"
  },
  {
    "codigo":439022003,
    "descripcion":"LESIÓN TRAUMÁTICA POR AGRESIÓN"
  },
  {
    "codigo":1260057009,
    "descripcion":"ADENOCARCINOMA MUCINOSO DE PULMÓN"
  },
  {
    "codigo":661000221109,
    "descripcion":"VIH EXPUESTO PERINATAL"
  },
  {
    "codigo":78574007,
    "descripcion":"HIPOTIROIDISMO SECUNDARIO A SARCOIDOSIS"
  },
  {
    "codigo":45806008,
    "descripcion":"DEFORMIDAD DE REDUCCIÓN DE LA EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":209646009,
    "descripcion":"DESGARRO COMPLETO DE LIGAMENTO DE LA REGIÓN TIROIDEA"
  },
  {
    "codigo":699331002,
    "descripcion":"TUMOR DE CÉLULAS GRANULOSAS DE NEUROHIPÓFISIS"
  },
  {
    "codigo":109507003,
    "descripcion":"PROTRUSIÓN DE DIENTE"
  },
  {
    "codigo":111342009,
    "descripcion":"FÍSTULA GASTROINTESTINAL EXTERNA DE ALTA PRODUCCIÓN"
  },
  {
    "codigo":76739003,
    "descripcion":"INFECCIÓN CAUSADA POR RAILLIETINA"
  },
  {
    "codigo":9368001,
    "descripcion":"ARRUGAS PERIORALES"
  },
  {
    "codigo":240579009,
    "descripcion":"ABSCESO GONOCÓCICO DE GLÁNDULA PARAURETRAL"
  },
  {
    "codigo":304280004,
    "descripcion":"CONSTRICCIÓN CUTÁNEA"
  },
  {
    "codigo":402584005,
    "descripcion":"DERMATITIS IRRITATIVA POR CONTACTO DE ORIGEN OCUPACIONAL"
  },
  {
    "codigo":15931101000119100,
    "descripcion":"QUISTE DE CUERPO LÚTEO DE OVARIO DERECHO"
  },
  {
    "codigo":238744006,
    "descripcion":"ACNÉ CON COMEDONES"
  },
  {
    "codigo":42136008,
    "descripcion":"FIEBRE HÉCTICA"
  },
  {
    "codigo":366146000,
    "descripcion":"POSTURA PARA RESPIRAR - HALLAZGO"
  },
  {
    "codigo":890434000,
    "descripcion":"SÍNDROME DE COCKAYNE TIPO 2"
  },
  {
    "codigo":1187181009,
    "descripcion":"CONCENTRACIÓN DE OXÍGENO EN SANGRE ARTERIAL POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":169538005,
    "descripcion":"ANTICONCEPCIÓN SINTOTÉRMICA - SIN PROBLEMAS"
  },
  {
    "codigo":300610006,
    "descripcion":"NO REALIZA ACTIVIDADES RELACIONADAS CON LOS VIAJES"
  },
  {
    "codigo":120541000119103,
    "descripcion":"DIENTES MOTEADOS"
  },
  {
    "codigo":1281815001,
    "descripcion":"DESPRENDIMIENTO PARCIAL DE RETINA CON MÚLTIPLES ROTURAS DE RETINA"
  },
  {
    "codigo":36631002,
    "descripcion":"HEPATONFALOCELE"
  },
  {
    "codigo":167703002,
    "descripcion":"LCR: EXAMEN NORMAL"
  },
  {
    "codigo":724759008,
    "descripcion":"SÍNTOMA PSICOMOTOR CONCOMITANTE CON TRASTORNO PSICÓTICO Y DEBIDO A ÉL"
  },
  {
    "codigo":296940000,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE SULFATO FERROSO"
  },
  {
    "codigo":1148908000,
    "descripcion":"HIDRONEFROSIS ADQUIRIDA DEBIDA A OBSTRUCCIÓN DE MEATO URETERAL"
  },
  {
    "codigo":67564005,
    "descripcion":"DESEQUILIBRIO SOCIAL"
  },
  {
    "codigo":2028007,
    "descripcion":"ERITEMA INDURADO"
  },
  {
    "codigo":426177001,
    "descripcion":"ELECTROCARDIOGRAMA: BRADICARDIA SINUSAL"
  },
  {
    "codigo":193003,
    "descripcion":"NEFROPATÍA HIPERTENSIVA BENIGNA"
  },
  {
    "codigo":721089006,
    "descripcion":"SÍNDROME DE DENTINOGÉNESIS IMPERFECTA, BAJA ESTATURA, PÉRDIDA DE LA AUDICIÓN Y DISCAPACIDAD INTELECTUAL"
  },
  {
    "codigo":719254001,
    "descripcion":"ATAXIA ESPINOCEREBELOSA TIPO 32"
  },
  {
    "codigo":1145238004,
    "descripcion":"DESPLAZAMIENTO DE DISCO INTERVERTEBRAL LUMBAR"
  },
  {
    "codigo":293270007,
    "descripcion":"REACCIÓN ADVERSA A LA LIPRESINA"
  },
  {
    "codigo":225899000,
    "descripcion":"CRISTALINO ARTIFICIAL EN POSICIÓN"
  },
  {
    "codigo":1208939001,
    "descripcion":"EPILEPSIA MIOCLÓNICA PROGRESIVA TIPO 7"
  },
  {
    "codigo":29291001,
    "descripcion":"GLUCOGENOSIS TIPO VI"
  },
  {
    "codigo":291435000,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR TRICOMICINA"
  },
  {
    "codigo":94827006,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE SENO ETMOIDAL"
  },
  {
    "codigo":191296000,
    "descripcion":"DEFICIENCIA DE FACTOR DE LA COAGULACIÓN POR HEPATOPATÍA"
  },
  {
    "codigo":339831000119105,
    "descripcion":"LAGOFTALMOS CICATRIZAL INFERIOR IZQUIERDO"
  },
  {
    "codigo":1010496005,
    "descripcion":"AUSENCIA CONGÉNITA DE UNIDAD UNGUEAL EN MEÑIQUE"
  },
  {
    "codigo":289600007,
    "descripcion":"HALLAZGO RELACIONADO CON LA TEMPERATURA DE LA VAGINA"
  },
  {
    "codigo":92992008,
    "descripcion":"ANOMALÍA CONGÉNITA DE HUESO ALIESFENOIDAL"
  },
  {
    "codigo":418837001,
    "descripcion":"EXPRESA VERBALMENTE EL DIAGNÓSTICO Y LA GRAVEDAD DE UNA ENFERMEDAD CRÓNICA"
  },
  {
    "codigo":123925004,
    "descripcion":"INTOXICACIÓN POR LINACEAE"
  },
  {
    "codigo":386069007,
    "descripcion":"TRASTORNO RELACIONADO CON LA VITAMINA D2"
  },
  {
    "codigo":254997007,
    "descripcion":"HEMANGIOMA CAPILAR DE ÓRBITA"
  },
  {
    "codigo":1268970001,
    "descripcion":"DEPENDENCIA DE SILLA DE RUEDAS MOTORIZADA"
  },
  {
    "codigo":417002002,
    "descripcion":"ROTACIÓN ANTERIOR DE HUESO ILÍACO"
  },
  {
    "codigo":253162003,
    "descripcion":"QUISTE ARACNOIDEO CEREBRAL"
  },
  {
    "codigo":449770003,
    "descripcion":"QUISTE ODONTÓGENO BOTRIOIDE"
  },
  {
    "codigo":285930005,
    "descripcion":"INCAPAZ DE VACIAR LA BAÑERA"
  },
  {
    "codigo":89322006,
    "descripcion":"URTICARIA MEDICAMENTOSA"
  },
  {
    "codigo":15986551000119109,
    "descripcion":"HIPERTROFIA CONGÉNITA DE EPITELIO PIGMENTARIO DE LA RETINA DE AMBOS OJOS"
  },
  {
    "codigo":23786008,
    "descripcion":"HIPERTENSIÓN MALIGNA QUE COMPLICA EL PUERPERIO Y\/O CONSTITUYE UN MOTIVO DE ATENCIÓN DURANTE ESTE PERÍODO"
  },
  {
    "codigo":447935001,
    "descripcion":"MIOCARDIOPATÍA NO COMPACTADA EN VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":185791003,
    "descripcion":"INCUMPLIMIENTO CON EL CONTROL DE CESE DEL TABAQUISMO"
  },
  {
    "codigo":284095008,
    "descripcion":"CAPAZ DE TREPAR"
  },
  {
    "codigo":413332002,
    "descripcion":"SIN ACCESO A SERVICIOS"
  },
  {
    "codigo":249492002,
    "descripcion":"ASPIRACIÓN DE ALIMENTO"
  },
  {
    "codigo":216724004,
    "descripcion":"INTOXICACIÓN INVOLUNTARIA POR DIQUAT"
  },
  {
    "codigo":1263465002,
    "descripcion":"NEOPLASIA MALIGNA DE PARTES BLANDAS DE DEDO DE MANO"
  },
  {
    "codigo":247657007,
    "descripcion":"MALA COMPRENSIÓN DE LOS CONCEPTOS ABSTRACTOS"
  },
  {
    "codigo":83817008,
    "descripcion":"ALCALOSIS DE ALTURA"
  },
  {
    "codigo":409662001,
    "descripcion":"INFECCIÓN EN ENTEROSTOMÍA"
  },
  {
    "codigo":737342004,
    "descripcion":"TRASTORNO DEL SUEÑO CAUSADO POR CANABINOIDE SINTÉTICO"
  },
  {
    "codigo":770110005,
    "descripcion":"CONSOLIDACIÓN TARDÍA DE FRACTURA DE PIE"
  },
  {
    "codigo":11782161000119109,
    "descripcion":"ESGUINCE DE CADERA IZQUIERDA"
  },
  {
    "codigo":15714321000119109,
    "descripcion":"DEDO DE PIE EN MARTILLO ADQUIRIDO BILATERAL"
  },
  {
    "codigo":1259795000,
    "descripcion":"ENFERMEDAD DE PAGET PRIMARIA DE VULVA"
  },
  {
    "codigo":309523001,
    "descripcion":"CRISTALINO ARTIFICIAL PRESENTE"
  },
  {
    "codigo":278590005,
    "descripcion":"CORONA DENTAL FRACTURADA"
  },
  {
    "codigo":735507003,
    "descripcion":"QUEMADURA COMPLEJA DE GENITALES"
  },
  {
    "codigo":47651000087100,
    "descripcion":"FRACTURA DE DIÁFISIS DE PERONÉ DERECHO"
  },
  {
    "codigo":1359934006,
    "descripcion":"RADIX PARAMOLARIS"
  },
  {
    "codigo":12776000,
    "descripcion":"CUERPO EXTRAÑO EN EL COLON"
  },
  {
    "codigo":42531000087106,
    "descripcion":"CONTUSIÓN DE REGIÓN PÚBICA"
  },
  {
    "codigo":39971000087106,
    "descripcion":"HERIDA PUNZANTE DE DEDO ÍNDICE DE MANO IZQUIERDA CON CUERPO EXTRAÑO"
  },
  {
    "codigo":209384005,
    "descripcion":"FRACTURA-SUBLUXACIÓN EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA DE UN SOLO DEDO DEL PIE"
  },
  {
    "codigo":830141000,
    "descripcion":"PARÁSITO OBSERVADO EN EL EXAMEN CON MICROSCOPIO ELECTRÓNICO"
  },
  {
    "codigo":307688008,
    "descripcion":"OSCILACIONES DE ONDAS CUADRADAS DEL OJO"
  },
  {
    "codigo":404157000,
    "descripcion":"INFILTRACIÓN CUTÁNEA ESPECÍFICA DE ENFERMEDAD DE HODGKIN"
  },
  {
    "codigo":109245003,
    "descripcion":"CELULITIS DE LA REGIÓN PERIORBITARIA"
  },
  {
    "codigo":240317003,
    "descripcion":"LESIÓN RENAL POR TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":305853006,
    "descripcion":"ATENDIDO POR SERVICIO COMUNITARIO DE TERAPIA OCUPACIONAL"
  },
  {
    "codigo":371389007,
    "descripcion":"INCONGRUENCIA DE ESCOTADURA TROCLEAR"
  },
  {
    "codigo":238482002,
    "descripcion":"DEDO (DEL PIE) DEL CORREDOR"
  },
  {
    "codigo":402322005,
    "descripcion":"PSORIASIS HIPERTRÓFICA PALMAR"
  },
  {
    "codigo":1287058006,
    "descripcion":"ARTROSIS SECUNDARIA DE ARTICULACIÓN DE RODILLA"
  },
  {
    "codigo":72807002,
    "descripcion":"POLISEROSITIS TUBERCULOSA"
  },
  {
    "codigo":342341000119104,
    "descripcion":"HIPERTRICOSIS DE PÁRPADO DERECHO"
  },
  {
    "codigo":236647003,
    "descripcion":"ESTENOSIS URETRAL"
  },
  {
    "codigo":302183005,
    "descripcion":"HALLAZGO RELACIONADO CON LAS VÍAS RESPIRATORIAS LUEGO DE UN PROCEDIMIENTO"
  },
  {
    "codigo":171111007,
    "descripcion":"DETECCIÓN SELECTIVA, AÚN SIN RESULTADOS"
  },
  {
    "codigo":365884000,
    "descripcion":"MARCHA DE ATAXIA CEREBELOSA"
  },
  {
    "codigo":726332004,
    "descripcion":"LESIÓN TRAUMÁTICA DE FASCIA DE MÚSCULO DEL TRONCO"
  },
  {
    "codigo":1072261000000100,
    "descripcion":"NO DESPLAZA OBJETOS POR EL HOGAR"
  },
  {
    "codigo":890172004,
    "descripcion":"LINFANGITIS AGUDA DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":300348008,
    "descripcion":"DOLOR A LA PALPACIÓN EN VESÍCULA BILIAR"
  },
  {
    "codigo":298513001,
    "descripcion":"AMPLITUD DE FLEXIÓN PASIVA DE LA COLUMNA VERTEBRAL DORSAL, NORMAL"
  },
  {
    "codigo":1079621000119107,
    "descripcion":"CONDROSARCOMA PRIMARIO DE HUESO DE MANO DERECHA"
  },
  {
    "codigo":36369001,
    "descripcion":"MONOSOMÍA PARCIAL 1P"
  },
  {
    "codigo":722662000,
    "descripcion":"LACERACIÓN DE CABEZA SIN CUERPO EXTRAÑO"
  },
  {
    "codigo":724497009,
    "descripcion":"ENFERMEDAD DEL SISTEMA CIRCULATORIO QUE COMPLICA EL EMBARAZO, EL PARTO Y EL PUERPERIO"
  },
  {
    "codigo":296678001,
    "descripcion":"SOBREDOSIS DE CEFALOTINA"
  },
  {
    "codigo":1345254003,
    "descripcion":"FLUOROSCOPIA DE SISTEMA GENITOURINARIO NORMAL"
  },
  {
    "codigo":67302005,
    "descripcion":"ESTADIO V1"
  },
  {
    "codigo":65467000,
    "descripcion":"QUEMADURA EPIDÉRMICA DE ANTEBRAZO"
  },
  {
    "codigo":720827002,
    "descripcion":"SÍNDROME DE DISFUNCIONES MITOCONDRIALES MÚLTIPLES"
  },
  {
    "codigo":131003008,
    "descripcion":"NIVEL DE FACTOR LIBERADOR DE CORTICOTROFINA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1144976006,
    "descripcion":"PROSTATITIS ASINTOMÁTICA"
  },
  {
    "codigo":293008008,
    "descripcion":"REACCIÓN ADVERSA A LA CEFTAZIDIMA"
  },
  {
    "codigo":225637002,
    "descripcion":"ANSIEDAD ACERCA DE LA PÉRDIDA DE CONTROL"
  },
  {
    "codigo":717157006,
    "descripcion":"TRISOMÍA 10P"
  },
  {
    "codigo":94565008,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA PIEL DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":289338003,
    "descripcion":"SIN PINZAMIENTO EN CORDÓN UMBILICAL"
  },
  {
    "codigo":27194006,
    "descripcion":"EDEMA CORNEAL"
  },
  {
    "codigo":1010234007,
    "descripcion":"OTALGIA DERECHA"
  },
  {
    "codigo":59962009,
    "descripcion":"FRACTURAS MÚLTIPLES NO EXPUESTAS DE PELVIS CON ALTERACIÓN DE CÍRCULO PÉLVICO"
  },
  {
    "codigo":92730009,
    "descripcion":"CARCINOMA IN SITU DE LA PIEL DE LA MANO"
  },
  {
    "codigo":713487008,
    "descripcion":"LEUCOENCEFALOPATÍA MULTIFOCAL PROGRESIVA CONCOMITANTE CON INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":23524006,
    "descripcion":"TAQUIFILAXIA"
  },
  {
    "codigo":56292007,
    "descripcion":"MOTILIDAD NORMAL DEL INTESTINO DELGADO"
  },
  {
    "codigo":285668009,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA CAVIDAD NASAL"
  },
  {
    "codigo":87225004,
    "descripcion":"FRACTURA EXPUESTA DEL ESTERNÓN"
  },
  {
    "codigo":447673004,
    "descripcion":"VENTRÍCULO DERECHO A LA IZQUIERDA DEL VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":19854001,
    "descripcion":"INTOXICACIÓN POR PAVETTA"
  },
  {
    "codigo":283833009,
    "descripcion":"MORDEDURA DE ANIMAL EN EL DEDO GORDO"
  },
  {
    "codigo":1332409009,
    "descripcion":"DELIRIO DE INTRODUCCIÓN DE PENSAMIENTO"
  },
  {
    "codigo":314766004,
    "descripcion":"CATARATA MIXTA"
  },
  {
    "codigo":773518005,
    "descripcion":"ALERGIA A FENILPROPANOLAMINA"
  },
  {
    "codigo":249230006,
    "descripcion":"HALLAZGO DE LOS GENITALES MASCULINOS"
  },
  {
    "codigo":344851000119104,
    "descripcion":"QUISTE ORBITARIO BILATERAL"
  },
  {
    "codigo":1082131000119104,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE PIEL DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":247395007,
    "descripcion":"NEURALGIA DE NERVIO GENITOCRURAL"
  },
  {
    "codigo":444003007,
    "descripcion":"TRASTORNO DE ARTICULACIÓN DE REGIÓN DE HOMBRO"
  },
  {
    "codigo":312931007,
    "descripcion":"COROIDITIS IDIOPÁTICA"
  },
  {
    "codigo":442168001,
    "descripcion":"RETRASO DEL DESARROLLO FÍSICO"
  },
  {
    "codigo":1197667008,
    "descripcion":"MALABSORCIÓN SECUNDARIA DE ÁCIDOS BILIARES"
  },
  {
    "codigo":1163064006,
    "descripcion":"ENCEFALITIS POR VIRUS HANTAAN"
  },
  {
    "codigo":210957002,
    "descripcion":"SECUELAS DE HERIDA ABIERTA DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":47117005,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DEL BRAZO, CON INFECCIÓN"
  },
  {
    "codigo":473101005,
    "descripcion":"INFLAMACIÓN ASOCIADA CON IMPLANTE VASCULAR"
  },
  {
    "codigo":307426000,
    "descripcion":"CISTITIS INFECCIOSA AGUDA"
  },
  {
    "codigo":1259533008,
    "descripcion":"CARCINOMA PRIMARIO DE PIEL DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":241890002,
    "descripcion":"EFECTO TÓXICO CAUSADO POR LIMPIAVIDRIOS"
  },
  {
    "codigo":209122003,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN COSTOCONDRAL"
  },
  {
    "codigo":45282003,
    "descripcion":"INFECCIÓN CAUSADA POR CARYOSPORA"
  },
  {
    "codigo":733410005,
    "descripcion":"FRACTURAS MÚLTIPLES DE HÚMERO"
  },
  {
    "codigo":305591000,
    "descripcion":"BAJO ATENCIÓN DE TERAPEUTA ESPECIALIZADO EN BELLAS ARTES"
  },
  {
    "codigo":372962009,
    "descripcion":"INFECCIÓN CAUSADA POR PENICILLIUM PUBERULUM"
  },
  {
    "codigo":371127003,
    "descripcion":"SINUSITIS OBSTRUCTIVA"
  },
  {
    "codigo":403895004,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS DEL PIE"
  },
  {
    "codigo":240055003,
    "descripcion":"DISTROFIA MUSCULAR AUTOSÓMICA RECESIVA CON GLICOPROTEÍNA ASOCIADA A DISTROFINA ANORMAL"
  },
  {
    "codigo":10679007,
    "descripcion":"INFECCIÓN CAUSADA POR GIARDIA LAMBLIA"
  },
  {
    "codigo":860812002,
    "descripcion":"NEUROPATÍA AUTONÓMICA SENSITIVA HEREDITARIA TIPO IE"
  },
  {
    "codigo":1155724002,
    "descripcion":"TIEMPO DE TROMBINA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":762508008,
    "descripcion":"TRASTORNO PSICÓTICO CON ALUCINACIONES CAUSADO POR CATINONA SINTÉTICA"
  },
  {
    "codigo":170849000,
    "descripcion":"CAMBIO EN LOS SÍNTOMAS REUMATOLÓGICOS"
  },
  {
    "codigo":432993002,
    "descripcion":"AUSENCIA CONGÉNITA DE MÚSCULO CUÁDRICEPS"
  },
  {
    "codigo":5174000,
    "descripcion":"INTOXICACIÓN POR FLUOROACETAMIDA DE SODIO"
  },
  {
    "codigo":236385009,
    "descripcion":"SÍNDROME DE DRASH"
  },
  {
    "codigo":301921008,
    "descripcion":"POSICIÓN OCULAR NORMAL"
  },
  {
    "codigo":365622001,
    "descripcion":"TAMAÑO DE LOS ERITROCITOS - HALLAZGO"
  },
  {
    "codigo":298251000,
    "descripcion":"ARTICULACIÓN SACROILÍACA DOLOROSA A LA PALPACIÓN"
  },
  {
    "codigo":234550008,
    "descripcion":"DEFICIENCIA DE INMUNOGLOBULINA IGG1"
  },
  {
    "codigo":396555001,
    "descripcion":"TUMOR NO PIGMENTADO"
  },
  {
    "codigo":724235002,
    "descripcion":"SENSACIÓN DE ARDOR EN LA NARIZ"
  },
  {
    "codigo":167179007,
    "descripcion":"PRUEBAS DE FUNCIÓN RENAL DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":427488005,
    "descripcion":"FENÓMENO DE ENCENDIDO - APAGADO"
  },
  {
    "codigo":720565000,
    "descripcion":"SÍNDROME DE BOHRING OPITZ"
  },
  {
    "codigo":34272008,
    "descripcion":"OLIGOMENORREA SECUNDARIA"
  },
  {
    "codigo":425653002,
    "descripcion":"DISPOSICIÓN PARA MEJORAR LA DIURESIS"
  },
  {
    "codigo":347361000119102,
    "descripcion":"CONJUNTIVITIS AGUDA DE AMBOS OJOS CAUSADA POR SUSTANCIA QUÍMICA"
  },
  {
    "codigo":292746004,
    "descripcion":"REACCIÓN ADVERSA A EDETATO"
  },
  {
    "codigo":1144714008,
    "descripcion":"HIPOPLASIA CONGÉNITA DE FALANGE MEDIA DE PIE"
  },
  {
    "codigo":1208415001,
    "descripcion":"MIOPATÍA CONGÉNITA POR DESPROPORCIÓN DEL TIPO DE FIBRA DOMINANTE AUTOSÓMICA DEBIDA A MUTACIÓN DE ACTA1 (ACTINA ALFA 1)"
  },
  {
    "codigo":94303002,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL FLANCO"
  },
  {
    "codigo":421983003,
    "descripcion":"GASTROENTERITIS NO INFECCIOSA ASOCIADA CON SIDA"
  },
  {
    "codigo":290911005,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR FLUVOXAMINA"
  },
  {
    "codigo":127071007,
    "descripcion":"TRASTORNO INMUNOPROLIFERATIVO"
  },
  {
    "codigo":15748321000119105,
    "descripcion":"MASA DE ARTICULACIÓN DE TOBILLO DERECHO"
  },
  {
    "codigo":715060002,
    "descripcion":"FÓRMULA INFANTIL A BASE DE AMINOÁCIDOS"
  },
  {
    "codigo":289076004,
    "descripcion":"CORTA ALIMENTOS"
  },
  {
    "codigo":92468007,
    "descripcion":"NEOPLASIA BENIGNA DEL APARATO URINARIO"
  },
  {
    "codigo":713225000,
    "descripcion":"ENFERMEDAD GINGIVAL DEBIDA A LUPUS ERITEMATOSO"
  },
  {
    "codigo":188937005,
    "descripcion":"NEOPLASIA BENIGNA DE OMÓPLATO Y DE LOS HUESOS LARGOS DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":1084641000119108,
    "descripcion":"ABSCESO SUBPERIÓSTICO DE AMBAS MASTOIDES"
  },
  {
    "codigo":254473008,
    "descripcion":"NEOPLASIA DEL ESQUELETO NASAL, ÓSEO Y CARTILAGINOSO"
  },
  {
    "codigo":1237513008,
    "descripcion":"DISPLASIA METAFISARIA OSTEOSCLERÓTICA"
  },
  {
    "codigo":15953341000119100,
    "descripcion":"FISURA DE PEZÓN DERECHO DURANTE LA LACTANCIA"
  },
  {
    "codigo":298941000119101,
    "descripcion":"GOTA DE HOMBRO DEBIDA A DISFUNCIÓN RENAL"
  },
  {
    "codigo":337341000119102,
    "descripcion":"ECTROPIÓN SENIL DE PÁRPADO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":314301000119103,
    "descripcion":"MIOSITIS OSIFICANTE TRAUMÁTICA DE HOMBRO DERECHO"
  },
  {
    "codigo":414643008,
    "descripcion":"INFERTILIDAD MASCULINA POR ANTICUERPOS CONTRA LOS ESPERMATOZOIDES"
  },
  {
    "codigo":16915901000119105,
    "descripcion":"OSTEÓLISIS DE VÉRTEBRA DORSAL"
  },
  {
    "codigo":319421000119103,
    "descripcion":"LUXACIÓN RECURRENTE DE ARTICULACIÓN DE REGIÓN DE MUÑECA DERECHA"
  },
  {
    "codigo":688061000119104,
    "descripcion":"SARCOMA PRIMARIO DE PERINEO"
  },
  {
    "codigo":342461000119105,
    "descripcion":"EDEMA DE PÁRPADO SUPERIOR DERECHO"
  },
  {
    "codigo":16644541000119106,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DEBIDO A OCLUSIÓN DE AMBAS ARTERIAS CARÓTIDAS"
  },
  {
    "codigo":11798461000119103,
    "descripcion":"HEMATOMA TRAUMÁTICO DE RIÑÓN IZQUIERDO"
  },
  {
    "codigo":12400061000119103,
    "descripcion":"TRAUMATISMO ACÚSTICO EXPLOSIVO DE OÍDO IZQUIERDO"
  },
  {
    "codigo":1363080003,
    "descripcion":"ASTILLA EN PIE CON INFECCIÓN"
  },
  {
    "codigo":301501000119107,
    "descripcion":"ABSCESO DE BOLSA SEROSA DE MANO DERECHA"
  },
  {
    "codigo":1089981000119106,
    "descripcion":"LESIÓN DE MUCOSA BUCAL"
  },
  {
    "codigo":306621000119109,
    "descripcion":"GOTA DE CODO CAUSADA POR FÁRMACO"
  },
  {
    "codigo":11304381000119108,
    "descripcion":"FRACTURA NO EXPUESTA DE HUESO TEMPORAL"
  },
  {
    "codigo":16206781000119109,
    "descripcion":"MERALGIA PARESTÉSICA DE AMBOS MIEMBROS INFERIORES"
  },
  {
    "codigo":248968007,
    "descripcion":"HALLAZGO RELACIONADO CON EL PATRÓN DEL CICLO MENSTRUAL"
  },
  {
    "codigo":247133006,
    "descripcion":"HEMORRAGIA PUNTIFORME DE RETINA"
  },
  {
    "codigo":771421000,
    "descripcion":"DELIRIO MIXTO HIPERACTIVO HIPOACTIVO POSTQUIRÚRGICO"
  },
  {
    "codigo":1162802004,
    "descripcion":"AMILASA (PANCREÁTICA) EN SUERO POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1193735000,
    "descripcion":"ENTERITIS POR STAPHYLOCOCCUS AUREUS METICILINORRESISTENTE"
  },
  {
    "codigo":276231004,
    "descripcion":"PULMÓN POSPERFUSIÓN"
  },
  {
    "codigo":833287004,
    "descripcion":"PROTRUSIÓN DE SUTURA"
  },
  {
    "codigo":210695005,
    "descripcion":"SECCIÓN TOTAL, TENDÓN ROTULIANO"
  },
  {
    "codigo":14087004,
    "descripcion":"ESTOMATOCITOSIS HEREDITARIA"
  },
  {
    "codigo":46855008,
    "descripcion":"AFASIA COMPLETA"
  },
  {
    "codigo":45020000,
    "descripcion":"ECTROPIÓN MECÁNICO"
  },
  {
    "codigo":208860002,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA"
  },
  {
    "codigo":866055006,
    "descripcion":"MIELITIS CAUSADA POR ENTEROVIRUS"
  },
  {
    "codigo":700380004,
    "descripcion":"TENDINOPATÍA INSERCIONAL DE TENDÓN DE AQUILES"
  },
  {
    "codigo":77788005,
    "descripcion":"ACROPARESTESIA VASOMOTORA"
  },
  {
    "codigo":12252009,
    "descripcion":"AUSENCIA CONGÉNITA DEL ESTERNÓN"
  },
  {
    "codigo":1157297002,
    "descripcion":"EXAMEN GINECOLÓGICO NORMAL"
  },
  {
    "codigo":733148009,
    "descripcion":"DUODENITIS CAUSADA POR TROPHERYMA WHIPPLEI"
  },
  {
    "codigo":272561006,
    "descripcion":"POSICIÓN SUPINA - PIE DE LA CAMA ELEVADO 45 CM"
  },
  {
    "codigo":403633007,
    "descripcion":"ENFERMEDAD LINEAL POR IGA INDUCIDA POR FÁRMACOS"
  },
  {
    "codigo":205190005,
    "descripcion":"DETENCIÓN DE CRECIMIENTO TRANSVERSAL A NIVEL DE CUARTO RAYO FALÁNGICO"
  },
  {
    "codigo":95283007,
    "descripcion":"ARCO DE LA VÉRTEBRA LUMBAR SUPERNUMERARIO"
  },
  {
    "codigo":677551000119103,
    "descripcion":"AGUJERO REDONDO DE LA RETINA DE OJO DERECHO"
  },
  {
    "codigo":41350008,
    "descripcion":"TIEMPO DE VIDA DE LOS GRANULOCITOS DISMINUIDO"
  },
  {
    "codigo":303494008,
    "descripcion":"INCAPAZ DE PONERSE DE COSTADO EN LA CAMA"
  },
  {
    "codigo":301659003,
    "descripcion":"NO SE LEVANTA DE UNA SILLA"
  },
  {
    "codigo":399963005,
    "descripcion":"ABRASIÓN"
  },
  {
    "codigo":236123006,
    "descripcion":"ABSCESO PERIESTOMAL"
  },
  {
    "codigo":203355007,
    "descripcion":"OSTEÍTIS DEFORMANTE ASOCIADA CON OTRO TRASTORNO"
  },
  {
    "codigo":299824000,
    "descripcion":"REFLEJO TRICIPITAL PRESENTA SÓLO CON SENSIBILIZACIÓN"
  },
  {
    "codigo":365360001,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA USAR UNA CUENTA FINANCIERA"
  },
  {
    "codigo":297989000,
    "descripcion":"PROBLEMA UNGUEAL"
  },
  {
    "codigo":267056008,
    "descripcion":"MATERIA FECAL PÁLIDA"
  },
  {
    "codigo":723973002,
    "descripcion":"SIRENOMELIA"
  },
  {
    "codigo":429061003,
    "descripcion":"LESIÓN TRAUMÁTICA POR IMPACTO DE SUJETO EN MOVIMIENTO CONTRA OBJETO DETENIDO"
  },
  {
    "codigo":232453007,
    "descripcion":"QUISTE MUCOSO DE CUERDA VOCAL"
  },
  {
    "codigo":165082004,
    "descripcion":"PRUEBA DE TOLERANCIA AL EJERCICIO - NORMAL"
  },
  {
    "codigo":230618004,
    "descripcion":"LESIÓN DEL PLEXO SIMPÁTICO ABDOMINAL"
  },
  {
    "codigo":197850006,
    "descripcion":"CISTITIS TRICOMONIÁSICA"
  },
  {
    "codigo":296154007,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE CLORMETIAZOL"
  },
  {
    "codigo":390788001,
    "descripcion":"LESIÓN ESCLEROSANTE DE MAMA COMPLEJA"
  },
  {
    "codigo":292484006,
    "descripcion":"REACCIÓN ADVERSA AL TARTRATO DE OXEDRINA"
  },
  {
    "codigo":716633000,
    "descripcion":"UTILIZA MARCO VISUAL CON INTÉRPRETE DE LENGUAJE DE SIGNOS"
  },
  {
    "codigo":1144452008,
    "descripcion":"APLASIA DE FALANGE PROXIMAL DE DEDO MEDIO DE MANO"
  },
  {
    "codigo":126809003,
    "descripcion":"NEOPLASIA DE LA OROFARINGE"
  },
  {
    "codigo":10946531000119101,
    "descripcion":"AVULSIÓN DE UNIDAD UNGUEAL DE DEDO ÍNDICE IZQUIERDO"
  },
  {
    "codigo":94041003,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE PIEL DE MUSLO"
  },
  {
    "codigo":288814002,
    "descripcion":"IMITA FORMAS DE EXPRESIÓN"
  },
  {
    "codigo":450819000,
    "descripcion":"CON DIETA ABSOLUTA"
  },
  {
    "codigo":254211001,
    "descripcion":"NEVO EN MANCHA DE VINO DE OPORTO"
  },
  {
    "codigo":418051002,
    "descripcion":"ALERGIA A LA CEREZA"
  },
  {
    "codigo":188675007,
    "descripcion":"LINFOMA DE CÉLULAS CLIVADAS PEQUEÑAS"
  },
  {
    "codigo":876803008,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE CUERO CABELLUDO CON INFECCIÓN"
  },
  {
    "codigo":285144000,
    "descripcion":"SUCCIÓN DE LA MANO"
  },
  {
    "codigo":133091000119105,
    "descripcion":"TRASTORNO BIPOLAR I DE CICLOS RÁPIDOS"
  },
  {
    "codigo":55768006,
    "descripcion":"LEUCODERMIA SIFILÍTICA"
  },
  {
    "codigo":53933002,
    "descripcion":"LESIÓN TRAUMÁTICA DEL NERVIO FACIAL"
  },
  {
    "codigo":21165006,
    "descripcion":"MELANOMA, NIVEL 3 DE CLARK"
  },
  {
    "codigo":84866000,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE LA MEJILLA, CON INFECCIÓN"
  },
  {
    "codigo":840365009,
    "descripcion":"PLACENTA CIRCUNMARGINADA"
  },
  {
    "codigo":283309008,
    "descripcion":"ASTILLA DE MADERA EN LA RODILLA"
  },
  {
    "codigo":707458004,
    "descripcion":"CARCINOMA PLEOMÓRFICO PRIMARIO DE PULMÓN"
  },
  {
    "codigo":1231746006,
    "descripcion":"AGENESIA AISLADA DEL VERMIS CEREBELOSO"
  },
  {
    "codigo":838530009,
    "descripcion":"TRASTORNO DEL ESTADO DE ÁNIMO CON SÍNTOMAS DEPRESIVOS CAUSADO POR ANFETAMINA Y\/O DERIVADO DE ANFETAMINA"
  },
  {
    "codigo":50263004,
    "descripcion":"HEMATOMA FETAL Y\/O NEONATAL DE VULVA COMO MANIFESTACIÓN DE TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":246871006,
    "descripcion":"MANCHAS DE BITOT"
  },
  {
    "codigo":115799007,
    "descripcion":"FENOTIPO NULO LANDSTEINER - WIENER"
  },
  {
    "codigo":277804000,
    "descripcion":"SÍNDROME DE BABOON"
  },
  {
    "codigo":212268001,
    "descripcion":"LESIÓN ABIERTA DE RAMA MOTORA PROFUNDA DE NERVIO CUBITAL"
  },
  {
    "codigo":81196009,
    "descripcion":"NEUROMA DEL MUÑÓN DE UNA AMPUTACIÓN"
  },
  {
    "codigo":274134003,
    "descripcion":"LEUCOPLASIA"
  },
  {
    "codigo":44758003,
    "descripcion":"PULPITIS HIPERPLÁSICA CRÓNICA"
  },
  {
    "codigo":110294004,
    "descripcion":"ERUPCIÓN DENTAL ACTIVA"
  },
  {
    "codigo":208598008,
    "descripcion":"FRACTURA NO EXPUESTA DE RÓTULA, POLO DISTAL"
  },
  {
    "codigo":403371005,
    "descripcion":"MANCHAS DE FORDYCE EN LA VULVA"
  },
  {
    "codigo":10155006,
    "descripcion":"LUXACIÓN CONGÉNITA BILATERAL DE LA CADERA"
  },
  {
    "codigo":237696003,
    "descripcion":"DEFICIENCIA DE VASOPRESINA FAMILIAR"
  },
  {
    "codigo":73856006,
    "descripcion":"PIEL LAXA CON OSTEODISTROFIA"
  },
  {
    "codigo":235861001,
    "descripcion":"ABSCESO GONOCÓCICO"
  },
  {
    "codigo":6485001,
    "descripcion":"OTITIS MEDIA CRÓNICA MUCOSANGUINOLENTA"
  },
  {
    "codigo":399701003,
    "descripcion":"EVALUACIÓN LIMITADA POR CALIDAD DE IMAGEN EN ESTÉREO"
  },
  {
    "codigo":1153365003,
    "descripcion":"LORDOSIS DEBIDA A EPIFISIOPATÍA"
  },
  {
    "codigo":301397009,
    "descripcion":"DOLOR A LA PALPACIÓN DE ESTRUCTURA GENITAL FEMENINA"
  },
  {
    "codigo":234026004,
    "descripcion":"SÍNDROME DE ROBO ARTERIAL DEL MIEMBRO SUPERIOR"
  },
  {
    "codigo":102954005,
    "descripcion":"UTILIZA PÍLDORA DEL DÍA SIGUIENTE COMO MÉTODO ANTICONCEPTIVO"
  },
  {
    "codigo":37418005,
    "descripcion":"FRACTURAS MÚLTIPLES DE LOS HUESOS DE LA MANO"
  },
  {
    "codigo":299562007,
    "descripcion":"SIGNO CON NOMBRE PROPIO DEL PIE"
  },
  {
    "codigo":1217066007,
    "descripcion":"ESCLEROSIS GLANDULAR MÚLTIPLE"
  },
  {
    "codigo":2815001,
    "descripcion":"PIROMANÍA SEXUAL"
  },
  {
    "codigo":365098009,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA MOVILIZARSE EN ESPACIOS CERRADOS"
  },
  {
    "codigo":461567005,
    "descripcion":"ATRESIA DE CAYADO AÓRTICO CON CORDÓN FIBROSO DISTAL A ARTERIA SUBCLAVIA"
  },
  {
    "codigo":164820001,
    "descripcion":"PRUEBA DE INFERTILIDAD FEMENINA, ANORMAL"
  },
  {
    "codigo":787412002,
    "descripcion":"DEFICIENCIA DE ACIL-COENZIMA A DESHIDROGENASA DE CADENA CORTA"
  },
  {
    "codigo":295892001,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE FENELZINA"
  },
  {
    "codigo":263124004,
    "descripcion":"LESIÓN DE LA PLACA PALMAR DE LA ARTICULACIÓN DEL PULGAR"
  },
  {
    "codigo":721876004,
    "descripcion":"SUSCEPTIBILIDAD MENDELIANA A ENFERMEDAD POR MICOBACTERIAS DEBIDA A DEFICIENCIA COMPLETA DE RECEPTOR 2 DE INTERFERÓN GAMMA"
  },
  {
    "codigo":428799009,
    "descripcion":"SUBLUXACIÓN ROTATORIA DE ARTICULACIÓN ATLANTOAXOIDEA"
  },
  {
    "codigo":294057001,
    "descripcion":"ALERGIA A APRACLONIDINA"
  },
  {
    "codigo":426964009,
    "descripcion":"CÁNCER PULMONAR NO MICROCÍTICO, POSITIVO PARA EXPRESIÓN DEL RECEPTOR DE FACTOR DE CRECIMIENTO EPIDÉRMICO"
  },
  {
    "codigo":64681004,
    "descripcion":"ÁNTRAX DE TOBILLO"
  },
  {
    "codigo":423294001,
    "descripcion":"SÍNDROME DE HIPEREOSINOFILIA IDIOPÁTICA"
  },
  {
    "codigo":425129009,
    "descripcion":"DIFICULTAD DEL CUIDADOR PARA INTERPRETAR LA COMUNICACIÓN VERBAL"
  },
  {
    "codigo":783742004,
    "descripcion":"SÍNDROME DE HIPOACUSIA DE CONDUCCIÓN Y MALFORMACIÓN DEL OÍDO EXTERNO"
  },
  {
    "codigo":95614004,
    "descripcion":"FALLA CIRCULATORIA NEONATAL"
  },
  {
    "codigo":292222005,
    "descripcion":"REACCIÓN ADVERSA A LA ACLARRUBICINA"
  },
  {
    "codigo":126547002,
    "descripcion":"NEOPLASIA DE HUESO PALATINO"
  },
  {
    "codigo":290387005,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ÁCIDO 5-AMINOSALICÍLICO"
  },
  {
    "codigo":192083006,
    "descripcion":"BROTE DE AGRESIÓN"
  },
  {
    "codigo":61011009,
    "descripcion":"OSTEOMIELITIS BACTERIANA"
  },
  {
    "codigo":26408002,
    "descripcion":"TRAQUEOCELE CONGÉNITO"
  },
  {
    "codigo":93779009,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE ENDOCÉRVIX"
  },
  {
    "codigo":91944005,
    "descripcion":"ARTRITIS DE LA ARTICULACIÓN TEMPOROMANDIBULAR"
  },
  {
    "codigo":288552005,
    "descripcion":"DIFICULTAD PARA REALIZAR ACTIVIDADES DE LAVADO Y SECADO DE SÍ MISMO"
  },
  {
    "codigo":59176006,
    "descripcion":"GRUPO DE VOZ RONCA DE TONO BAJO"
  },
  {
    "codigo":124712005,
    "descripcion":"DEFICIENCIA DE FOSFORRIBOSILAMINA - GLICINA LIGASA"
  },
  {
    "codigo":1236989002,
    "descripcion":"INFLAMACIÓN DE MARGEN LIBRE ANTERIOR DE PÁRPADO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":741000119101,
    "descripcion":"ENFERMEDAD RENAL CRÓNICA EN ESTADIO 2 DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":90109004,
    "descripcion":"INFECCIÓN CAUSADA POR ANOPLOCEPHALA"
  },
  {
    "codigo":286717006,
    "descripcion":"CARÁCTER EMOCIONALMENTE EMBOTADO"
  },
  {
    "codigo":1204221007,
    "descripcion":"LINFADENITIS RETROPERITONEAL AGUDA"
  },
  {
    "codigo":15975141000119102,
    "descripcion":"QUISTE DE MENISCO DE AMBAS RODILLAS"
  },
  {
    "codigo":57341009,
    "descripcion":"PERITONITIS MECONIAL"
  },
  {
    "codigo":448722002,
    "descripcion":"ANOMALÍA DE AORTA ABDOMINAL"
  },
  {
    "codigo":284882002,
    "descripcion":"CAPAZ DE CORTARSE LAS UÑAS DE LAS MANOS"
  },
  {
    "codigo":12206821000119103,
    "descripcion":"SUBLUXACIÓN DE PRÓTESIS DE ARTICULACIÓN DE RODILLA DERECHA"
  },
  {
    "codigo":219346009,
    "descripcion":"LESIÓN POR CAÍDA DE ALTURA, CON PROPÓSITO DESCONOCIDO"
  },
  {
    "codigo":184743006,
    "descripcion":"CERTIFICADO DE ENFERMEDAD PRIVADO, SIN HONORARIOS"
  },
  {
    "codigo":283047007,
    "descripcion":"LESIÓN SUPERFICIAL DE TALÓN"
  },
  {
    "codigo":446887007,
    "descripcion":"TUMOR DE ESTROMA ENDOMETRIAL"
  },
  {
    "codigo":709031009,
    "descripcion":"NEOPLASIA MALIGNA DE PARED SUPERIOR DE NASOFARINGE"
  },
  {
    "codigo":1264252002,
    "descripcion":"CICATRIZ DE PIEL DE MEJILLA DERECHA"
  },
  {
    "codigo":707196007,
    "descripcion":"MELANONIQUIA LONGITUDINAL"
  },
  {
    "codigo":82769000,
    "descripcion":"NECROSIS DE OVARIO"
  },
  {
    "codigo":1297020009,
    "descripcion":"CIERRE DE ÁNGULO SECUNDARIO DE OJO IZQUIERDO"
  },
  {
    "codigo":1196881000,
    "descripcion":"CARCINOMA EMBRIONARIO PRIMARIO DE HÍGADO"
  },
  {
    "codigo":248444008,
    "descripcion":"FIEBRE BIFÁSICA"
  },
  {
    "codigo":246609006,
    "descripcion":"ENGROSAMIENTO PALPABLE DE NERVIO CUBITAL EN CODO"
  },
  {
    "codigo":50001009,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DEL CUELLO"
  },
  {
    "codigo":212006005,
    "descripcion":"QUEMADURA DE PRIMER GRADO POR AGENTE CORROSIVO DE CADERA Y EXTREMIDAD INFERIOR, EXCEPTO TOBILLO Y PIE"
  },
  {
    "codigo":703526007,
    "descripcion":"LIPOFUSCINOSIS NEURONAL CEROIDEA 8"
  },
  {
    "codigo":242939000,
    "descripcion":"LESIÓN POR INTERVENCIÓN LEGAL, GOLPEADO CON UN LÁTIGO"
  },
  {
    "codigo":472315005,
    "descripcion":"MIOCARDIOPATÍA MITOCONDRIAL"
  },
  {
    "codigo":79099006,
    "descripcion":"COLITIS DE ORIGEN PRESUNTAMENTE INFECCIOSO"
  },
  {
    "codigo":699856002,
    "descripcion":"PRÓTESIS DENTAL PARCIAL REMOVIBLE ANTIESTÉTICA"
  },
  {
    "codigo":110032005,
    "descripcion":"LACERACIÓN PERIORBITARIA SIMPLE"
  },
  {
    "codigo":208336005,
    "descripcion":"FRACTURA EXPUESTA DE CÚBITO, APÓFISIS ESTILOIDES"
  },
  {
    "codigo":403109000,
    "descripcion":"ONICOMICOSIS ENDONIX"
  },
  {
    "codigo":9893005,
    "descripcion":"INMUNODEFICIENCIA CON TIMOMA"
  },
  {
    "codigo":698021005,
    "descripcion":"EPILEPSIA HIPERMOTRIZ FAMILIAR RELACIONADA CON EL SUEÑO"
  },
  {
    "codigo":15676441000119102,
    "descripcion":"TENDINITIS DE TENDÓN FLEXOR DE MANO DERECHA"
  },
  {
    "codigo":73594001,
    "descripcion":"PINTA, LESIÓN AVANZADA"
  },
  {
    "codigo":202831001,
    "descripcion":"FRACTURA VERTEBRAL POR SOBRECARGA"
  },
  {
    "codigo":235599003,
    "descripcion":"ESOFAGITIS EOSINOFÍLICA"
  },
  {
    "codigo":685081000119104,
    "descripcion":"HEMOGLOBINA D-BETA + TALASEMIA"
  },
  {
    "codigo":170063007,
    "descripcion":"PERÍMETRO CEFÁLICO DEL NIÑO = PERCENTILOS 3 A 9"
  },
  {
    "codigo":299300000,
    "descripcion":"SIN AMPLITUD DE ROTACIÓN EXTERNA ACTIVA DE ARTICULACIÓN DE CADERA"
  },
  {
    "codigo":37156001,
    "descripcion":"TRASTORNO DEL MAXILAR SUPERIOR E INFERIOR"
  },
  {
    "codigo":364836002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA CORRER PENDIENTE ARRIBA"
  },
  {
    "codigo":233764003,
    "descripcion":"NEUMOCONIOSIS POR WOLLASTONITA"
  },
  {
    "codigo":301135009,
    "descripcion":"CHOQUE DE LA PUNTA INTENSO"
  },
  {
    "codigo":788985000,
    "descripcion":"TRASTORNO CUTÁNEO GRANULOMATOSO NECROBIÓTICO"
  },
  {
    "codigo":397604009,
    "descripcion":"MOTIVO DEL RETRASO DE LA DERIVACIÓN"
  },
  {
    "codigo":461305001,
    "descripcion":"ANOMALÍA ADQUIRIDA DE VÁLVULA AURICULOVENTRICULAR DERECHA (MORFOLÓGICAMENTE NO TRICÚSPIDE)"
  },
  {
    "codigo":723449004,
    "descripcion":"SÍNDROME DE MICROCORIA Y NEFROSIS CONGÉNITA"
  },
  {
    "codigo":231929005,
    "descripcion":"DEGENERACIÓN EPITELIAL DE LA CÓRNEA"
  },
  {
    "codigo":428537007,
    "descripcion":"RUPTURA DE CUÁDRICEPS PROXIMAL"
  },
  {
    "codigo":199161008,
    "descripcion":"GONORREA MATERNA DURANTE EL EMBARAZO, PARTO Y PUERPERIO"
  },
  {
    "codigo":197326002,
    "descripcion":"ABSCESO HEPÁTICO POR PIEMIA PORTAL"
  },
  {
    "codigo":426702003,
    "descripcion":"DOLOR EN LA PELVIS FEMENINA"
  },
  {
    "codigo":718004,
    "descripcion":"BRONQUIOLITIS AGUDA CON OBSTRUCCIÓN"
  },
  {
    "codigo":295630005,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE IFOSFAMIDA"
  },
  {
    "codigo":721614008,
    "descripcion":"PERFORACIÓN INTRAUTERINA DE ESTÓMAGO FETAL"
  },
  {
    "codigo":262862008,
    "descripcion":"LACERACIÓN DE APÉNDICE ILEOCECAL"
  },
  {
    "codigo":424867003,
    "descripcion":"HERIDA DE SALIDA DE DISPARO DE ARMA DE FUEGO"
  },
  {
    "codigo":1144328000,
    "descripcion":"ATROFIA DE FÓVEA CENTRAL"
  },
  {
    "codigo":293795007,
    "descripcion":"ALERGIA A VINDESINA"
  },
  {
    "codigo":717944002,
    "descripcion":"SÍNDROME BRANQUIGÉNICO CON SORDERA"
  },
  {
    "codigo":95352005,
    "descripcion":"TUMEFACCIÓN DE MEMBRANA MUCOSA"
  },
  {
    "codigo":128120005,
    "descripcion":"INFECCIÓN FÚNGICA DEL SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":291960007,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR BENDROFLUMETIAZIDA"
  },
  {
    "codigo":423032007,
    "descripcion":"INFILTRACIÓN LEUCÉMICA DE ÓRBITA"
  },
  {
    "codigo":781645001,
    "descripcion":"LESIÓN DE PIEL POR TRAUMATISMO"
  },
  {
    "codigo":1142093005,
    "descripcion":"TAQUICARDIA AURICULAR DE MACRORREENTRADA NO DEPENDIENTE DE ISTMO CAVOTRICUSPÍDEO DE AURÍCULA IZQUIERDA"
  },
  {
    "codigo":191821007,
    "descripcion":"FARMACODEPENDENCIA DE OPIÁCEOS EN REMISIÓN"
  },
  {
    "codigo":290125007,
    "descripcion":"FLUJO INSUFICIENTE DE LECHE"
  },
  {
    "codigo":26146002,
    "descripcion":"TRANSPOSICIÓN COMPLETA DE LOS GRANDES VASOS"
  },
  {
    "codigo":124450003,
    "descripcion":"DEFICIENCIA DE DESOXIRRIBONUCLEASA I"
  },
  {
    "codigo":1304098004,
    "descripcion":"NEOVASCULARIZACIÓN DE ÁNGULO IRIDOCORNEAL DE OJO DERECHO"
  },
  {
    "codigo":255522009,
    "descripcion":"NEUROMIOPATÍA"
  },
  {
    "codigo":286455002,
    "descripcion":"PREPARA ALIMENTOS PARA COMER"
  },
  {
    "codigo":24311002,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM SMEGMATIS"
  },
  {
    "codigo":253687009,
    "descripcion":"ORIGEN ANÓMALO DE CONDUCTO ARTERIOSO"
  },
  {
    "codigo":1169356004,
    "descripcion":"SÍNDROME DE ENCEFALOPATÍA PROGRESIVA, HIPOACUSIA, HIPOPLASIA DE LA PROTUBERANCIA Y ATROFIA CEREBRAL DE INICIO TEMPRANO"
  },
  {
    "codigo":140621000119106,
    "descripcion":"TRASTORNO DE LA MEMORIA CONCOMITANTE CON DAÑO CEREBRAL ORGÁNICO Y DEBIDO A ÉL"
  },
  {
    "codigo":687591000119100,
    "descripcion":"PLASMOCITOMA EN REMISIÓN"
  },
  {
    "codigo":219084006,
    "descripcion":"REACCIÓN ADVERSA A VACUNA ANTITETÁNICA"
  },
  {
    "codigo":415692008,
    "descripcion":"TUMEFACCIÓN DE LA PRIMERA ARTICULACIÓN METATARSOFALÁNGICA DEL DEDO GORDO"
  },
  {
    "codigo":284620005,
    "descripcion":"CRUELDAD HACIA LOS ANIMALES"
  },
  {
    "codigo":15951181000119107,
    "descripcion":"NEOPLASIA BENIGNA DE PIEL DE MAMA DERECHA"
  },
  {
    "codigo":1003681006,
    "descripcion":"CLASIFICACIÓN DE INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA DE LOS CENTROS PARA EL CONTROL Y PREVENCIÓN DE ENFERMEDADES ETAPA 0"
  },
  {
    "codigo":315553006,
    "descripcion":"NACIDO EN EMIRATOS ÁRABES UNIDOS"
  },
  {
    "codigo":118945008,
    "descripcion":"TRASTORNO DEL CRÁNEO"
  },
  {
    "codigo":117110001,
    "descripcion":"UNIDAD DE HEMODERIVADO DEVUELTA LUEGO DE HABER SIDO ENTREGADA"
  },
  {
    "codigo":282785008,
    "descripcion":"SÍNDROME MEDULAR ANTERIOR"
  },
  {
    "codigo":1231222000,
    "descripcion":"LAGOFTALMOS MECÁNICO DE PÁRPADO SUPERIOR"
  },
  {
    "codigo":1263990007,
    "descripcion":"HEMORRAGIA INTRACRANEAL FETAL NO TRAUMÁTICA"
  },
  {
    "codigo":1296758008,
    "descripcion":"POLIURIA RELACIONADA CON VASOPRESINA"
  },
  {
    "codigo":248182008,
    "descripcion":"LABIOS FISURADOS"
  },
  {
    "codigo":703264005,
    "descripcion":"OSTEOPOROSIS SECUNDARIA"
  },
  {
    "codigo":408352006,
    "descripcion":"FORMULACIÓN DE MEDICAMENTO ADECUADA"
  },
  {
    "codigo":5761000119100,
    "descripcion":"TAQUICARDIA SUPRAVENTRICULAR PAROXÍSTICA NO SOSTENIDA"
  },
  {
    "codigo":275445000,
    "descripcion":"UÑAS LARGAS"
  },
  {
    "codigo":13301002,
    "descripcion":"CELULITIS DE LA RODILLA"
  },
  {
    "codigo":308213003,
    "descripcion":"ERUPCIÓN BULLOSA DE LA FARINGE"
  },
  {
    "codigo":111605007,
    "descripcion":"HEMORRAGIA INTRACRANEAL CONCOMITANTE CON FRACTURA EXPUESTA DE BASE DE CRÁNEO Y DEBIDA A ELLA"
  },
  {
    "codigo":240842000,
    "descripcion":"ONCOCERCOSIS OCULAR"
  },
  {
    "codigo":109770004,
    "descripcion":"ANOMALÍA ADQUIRIDA DE LA MUCOSA ORAL"
  },
  {
    "codigo":306378005,
    "descripcion":"ATENDIDO POR SERVICIO DE CIRUGÍA DEL TRACTO GASTROINTESTINAL SUPERIOR"
  },
  {
    "codigo":271775000,
    "descripcion":"MOVIMIENTO ANORMAL EN EL HUESO"
  },
  {
    "codigo":402847002,
    "descripcion":"MALFORMACIÓN ARTERIOVENOSA ADQUIRIDA DE LA PIEL"
  },
  {
    "codigo":42399005,
    "descripcion":"SÍNDROME DE INSUFICIENCIA RENAL"
  },
  {
    "codigo":239007005,
    "descripcion":"DISPLASIA ECTODÉRMICA HIPOHIDRÓTICA LIGADA AL X"
  },
  {
    "codigo":1254815008,
    "descripcion":"DEPENDENCIA DE RUXOLITINIB"
  },
  {
    "codigo":304543009,
    "descripcion":"CÁLCULO RADIOTRANSPARENTE DE VÍAS URINARIAS"
  },
  {
    "codigo":9631008,
    "descripcion":"ESPONDILITIS ANQUILOSANTE"
  },
  {
    "codigo":106100005,
    "descripcion":"HALLAZGO EN LAS VÍAS URINARIAS INFERIORES"
  },
  {
    "codigo":38729007,
    "descripcion":"NEUMOPATÍA POR GORGOJO DE TRIGO"
  },
  {
    "codigo":366409008,
    "descripcion":"RESPUESTA MOTRIZ A LA COMPRESIÓN PROFUNDA EN LA GLABELA - HALLAZGO"
  },
  {
    "codigo":10737281000119109,
    "descripcion":"TERATOMA QUÍSTICO MADURO DEL OVARIO DERECHO"
  },
  {
    "codigo":36894006,
    "descripcion":"FÍSTULA CUTÁNEO - GENITAL FEMENINA"
  },
  {
    "codigo":299038008,
    "descripcion":"HALLAZGO RELACIONADO CON LA PROPORCIÓN DE LA MANO"
  },
  {
    "codigo":306971000119104,
    "descripcion":"DERRAME DE ARTICULACIÓN DE RODILLA DERECHA"
  },
  {
    "codigo":395507008,
    "descripcion":"LACTANTE PREMATURO"
  },
  {
    "codigo":262600000,
    "descripcion":"CUERPO EXTRAÑO EN BRONQUIO PRINCIPAL DERECHO"
  },
  {
    "codigo":721352002,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA DE ARTICULACIÓN ATLANTO-OCCIPITAL"
  },
  {
    "codigo":1145501003,
    "descripcion":"HIPOPLASIA CONGÉNITA DE CUARTO HUESO METACARPIANO"
  },
  {
    "codigo":293533004,
    "descripcion":"REACCIÓN ADVERSA AL MINOXIDIL"
  },
  {
    "codigo":162461008,
    "descripcion":"VELOCIDAD DE APARICIÓN DEL SÍNTOMA"
  },
  {
    "codigo":129693008,
    "descripcion":"CON MAYOR RIESGO DE DESEQUILIBRIO HÍDRICO"
  },
  {
    "codigo":195229008,
    "descripcion":"TROMBOSIS NO PIÓGENA DE SENO VENOSO"
  },
  {
    "codigo":719517009,
    "descripcion":"ATROFIA ÓPTICA AUTOSÓMICA DOMINANTE Y CATARATA"
  },
  {
    "codigo":291698005,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR SULFONA"
  },
  {
    "codigo":95090005,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE PARTES BLANDAS DEL ABDOMEN"
  },
  {
    "codigo":226162006,
    "descripcion":"DIETA CON ALTO CONTENIDO DE MINERALES ANTIOXIDANTES"
  },
  {
    "codigo":422770008,
    "descripcion":"CANALICULITIS LAGRIMAL CAUSADA POR ACTINOMYCES ISRAELII"
  },
  {
    "codigo":224327007,
    "descripcion":"APROBÓ LOS EXÁMENES"
  },
  {
    "codigo":93255008,
    "descripcion":"HIPOPLASIA CONGÉNITA DE FÉMUR"
  },
  {
    "codigo":419100001,
    "descripcion":"INFECCIÓN DE PIE DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":27719009,
    "descripcion":"HEMORRAGIA GASTROINTESTINAL AGUDA"
  },
  {
    "codigo":289863009,
    "descripcion":"PERINEO EDEMATIZADO"
  },
  {
    "codigo":191559008,
    "descripcion":"ESQUIZOFRENIA LATENTE"
  },
  {
    "codigo":15927221000119106,
    "descripcion":"LESIÓN DE PÁRPADO IZQUIERDO"
  },
  {
    "codigo":124188007,
    "descripcion":"DEFICIENCIA DE GLUTATIÓN REDUCTASA (NAD (P)H)"
  },
  {
    "codigo":286193000,
    "descripcion":"INCAPAZ DE CERRAR LA CASA EN FORMA SEGURA"
  },
  {
    "codigo":1269233006,
    "descripcion":"SÍNDROME DE LISENCEFALIA POSTERIOR, PUENTE APLANADO Y DEFECTO CRUZADO DE LÍNEA MEDIA MEDULAR"
  },
  {
    "codigo":253425006,
    "descripcion":"AURÍCULA DERECHA CON DOBLE TRACTO DE SALIDA"
  },
  {
    "codigo":251590004,
    "descripcion":"PATRÓN ELECTRORRETINOGRÁFICO - HALLAZGO"
  },
  {
    "codigo":1201862006,
    "descripcion":"ENFERMEDAD DEL NÚCLEO CENTRAL AUTOSÓMICA RECESIVA"
  },
  {
    "codigo":249755001,
    "descripcion":"MANO EN TRIDENTE"
  },
  {
    "codigo":85915003,
    "descripcion":"LARINGOTRAQUEOBRONQUITIS"
  },
  {
    "codigo":1263728000,
    "descripcion":"TRASTORNO FETAL DEBIDO A POLIHIDRAMNIOS"
  },
  {
    "codigo":1003419008,
    "descripcion":"DELECIÓN DE PORCIÓN MEDIA DEL BRAZO LARGO DE CROMOSOMA 7"
  },
  {
    "codigo":247920004,
    "descripcion":"INMÓVIL EN UNA POSICIÓN"
  },
  {
    "codigo":1073231000119106,
    "descripcion":"ARTRITIS DE HOMBRO IZQUIERDO CAUSADA POR BACTERIAS"
  },
  {
    "codigo":182384005,
    "descripcion":"TIÑA CAUSADA POR TRICHOPHYTON CONCENTRICUM"
  },
  {
    "codigo":278853003,
    "descripcion":"TRASTORNO PSICÓTICO AGUDO TIPO ESQUIZOFRÉNICO"
  },
  {
    "codigo":442693003,
    "descripcion":"ATEROSCLEROSIS DE INJERTO-PUENTE DE VENA AUTÓLOGA DE MIEMBRO"
  },
  {
    "codigo":82245003,
    "descripcion":"ENFERMEDAD DE COBALAMINA B"
  },
  {
    "codigo":213317006,
    "descripcion":"INFECCIÓN POSTERIOR A INMUNIZACIÓN"
  },
  {
    "codigo":1163589006,
    "descripcion":"ÚLCERA PREPILÓRICA CON HEMORRAGIA"
  },
  {
    "codigo":309481000119102,
    "descripcion":"NECROSIS AVASCULAR DE HUESO DEL CARPO DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":80410000,
    "descripcion":"INFECCIÓN CAUSADA POR DIROFILARIA IMMITIS"
  },
  {
    "codigo":703002002,
    "descripcion":"NEISSERIA WEAVERI O NEISSERIA ELONGATA"
  },
  {
    "codigo":1260058004,
    "descripcion":"ADENOCARCINOMA MUCINOSO DE OROFARINGE"
  },
  {
    "codigo":209647000,
    "descripcion":"DESGARRO COMPLETO DE LIGAMENTO COSTAL"
  },
  {
    "codigo":111343004,
    "descripcion":"EROSIÓN DENTAL OCUPACIONAL"
  },
  {
    "codigo":43972005,
    "descripcion":"OPACIDAD TRAUMÁTICA LOCALIZADA"
  },
  {
    "codigo":240580007,
    "descripcion":"FÍSTULA GONOCÓCICA DE PENE"
  },
  {
    "codigo":304281000,
    "descripcion":"INCAPAZ DE CONTROLAR LA POSTURA"
  },
  {
    "codigo":699332009,
    "descripcion":"SECUESTRO DE DISCO INTERVERTEBRAL"
  },
  {
    "codigo":109508008,
    "descripcion":"DIENTE PARCIALMENTE IMPACTADO"
  },
  {
    "codigo":238745007,
    "descripcion":"ACNÉ NODULOQUÍSTICA"
  },
  {
    "codigo":1187182002,
    "descripcion":"PRESIÓN PARCIAL DE DIÓXIDO DE CARBONO ARTERIAL DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":204142009,
    "descripcion":"ANOMALÍAS DE LA CÁMARA OCULAR ANTERIOR"
  },
  {
    "codigo":202307002,
    "descripcion":"ANQUILOSIS DE ARTICULACIÓN DE CODO"
  },
  {
    "codigo":169539002,
    "descripcion":"FRACASO DEL MÉTODO DE ANTICONCEPCIÓN SINTOTÉRMICA"
  },
  {
    "codigo":890435004,
    "descripcion":"FENILCETONURIA CLÁSICA CON DEFICIENCIA PARCIAL DE FENILALANINA HIDROXILASA"
  },
  {
    "codigo":300611005,
    "descripcion":"DIFICULTAD PARA REALIZAR ACTIVIDADES RELACIONADAS CON LOS VIAJES"
  },
  {
    "codigo":235075007,
    "descripcion":"NEOPLASIA DE CAVIDAD BUCAL"
  },
  {
    "codigo":1281816000,
    "descripcion":"CIERRE VELOFARÍNGEO INCOMPLETO ADQUIRIDO LIMÍTROFE"
  },
  {
    "codigo":366147009,
    "descripcion":"MEDICIONES RESPIRATORIAS - HALLAZGO"
  },
  {
    "codigo":724760003,
    "descripcion":"ALTERACIÓN COGNITIVA CONCOMITANTE CON TRASTORNO PSICÓTICO PRIMARIO Y DEBIDA A ÉL"
  },
  {
    "codigo":298776003,
    "descripcion":"AMPLITUD DE FLEXIÓN ACTIVA DE HOMBRO NORMAL"
  },
  {
    "codigo":167704008,
    "descripcion":"LCR: EXAMEN ANORMAL"
  },
  {
    "codigo":296941001,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE SULFATO FERROSO"
  },
  {
    "codigo":722925004,
    "descripcion":"NEUTROPENIA NEONATAL TRANSITORIA DEBIDA A INFECCIÓN VIRAL CONGÉNITA"
  },
  {
    "codigo":1343682000,
    "descripcion":"TUMOR NEUROENDOCRINO BIEN DIFERENCIADO CON METÁSTASIS A PULMÓN"
  },
  {
    "codigo":1148909008,
    "descripcion":"HIDRONEFROSIS ADQUIRIDA DEBIDA A OBSTRUCCIÓN URETERAL"
  },
  {
    "codigo":721090002,
    "descripcion":"DERMATOSTEÓLISIS, TIPO KIRGUISA"
  },
  {
    "codigo":295106007,
    "descripcion":"ALERGIA A ETANOLAMINA"
  },
  {
    "codigo":719255000,
    "descripcion":"ATAXIA ESPINOCEREBELOSA TIPO 34"
  },
  {
    "codigo":360642008,
    "descripcion":"DEFICIENCIA DE METILESTERASA DE PECTINA"
  },
  {
    "codigo":293271006,
    "descripcion":"REACCIÓN ADVERSA A LA TERLIPRESINA"
  },
  {
    "codigo":1145239007,
    "descripcion":"NEURITIS DEBIDA A DESPLAZAMIENTO DE DISCO INTERVERTEBRAL LUMBAR"
  },
  {
    "codigo":94828001,
    "descripcion":"NEOPLASIA DE TROMPA DE EUSTAQUIO DE COMPORTAMIENTO INCIERTO"
  },
  {
    "codigo":291436004,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR TRICOMICINA"
  },
  {
    "codigo":422508004,
    "descripcion":"SIRINGOMA DE PÁRPADO"
  },
  {
    "codigo":1340012009,
    "descripcion":"TRASTORNO CAUSADO POR RADIACIÓN"
  },
  {
    "codigo":1010497001,
    "descripcion":"AUSENCIA CONGÉNITA DE UNIDAD UNGUEAL EN DEDO DE MANO"
  },
  {
    "codigo":60225005,
    "descripcion":"INTOXICACIÓN POR AGROSTEMMA"
  },
  {
    "codigo":289601006,
    "descripcion":"VAGINA TIBIA"
  },
  {
    "codigo":16040631000119102,
    "descripcion":"ARTRITIS IDIOPÁTICA JUVENIL DE INICIO SISTÉMICO DE ARTICULACIÓN DE REGIÓN DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":191297009,
    "descripcion":"DEFICIENCIA DE FACTOR DE LA COAGULACIÓN POR DEFICIENCIA DE VITAMINA K"
  },
  {
    "codigo":254998002,
    "descripcion":"HEMANGIOMA CAVERNOSOS DE ÓRBITA"
  },
  {
    "codigo":123926003,
    "descripcion":"INTOXICACIÓN POR LAMIACEAE"
  },
  {
    "codigo":25622003,
    "descripcion":"DÉFICIT DE REDES DE CONTENCIÓN"
  },
  {
    "codigo":91158006,
    "descripcion":"ANOMALÍA CONGÉNITA DE PÁRPADO"
  },
  {
    "codigo":386070008,
    "descripcion":"DEFICIENCIA DE VITAMINA D2"
  },
  {
    "codigo":89323001,
    "descripcion":"ANGINA DE PECHO, CLASE IV"
  },
  {
    "codigo":1268971002,
    "descripcion":"TOMOSÍNTESIS DIGITAL DE MAMA ANORMAL"
  },
  {
    "codigo":449771004,
    "descripcion":"ODONTOMA DILATADO"
  },
  {
    "codigo":253163008,
    "descripcion":"QUISTE ARACNOIDEO ESPINAL"
  },
  {
    "codigo":21952001,
    "descripcion":"CISTINURIA, TIPO 2"
  },
  {
    "codigo":285931009,
    "descripcion":"VACÍA LA BAÑERA"
  },
  {
    "codigo":251328004,
    "descripcion":"PERMEABILIDAD DE FÍSTULA ORAL INFLAMATORIA"
  },
  {
    "codigo":284096009,
    "descripcion":"INCAPAZ DE TREPAR"
  },
  {
    "codigo":20117002,
    "descripcion":"INTOXICACIÓN POR MITOMICINA"
  },
  {
    "codigo":1363605005,
    "descripcion":"TENDINITIS DE ANTEBRAZO"
  },
  {
    "codigo":249493007,
    "descripcion":"REGURGITACIÓN FISIOLÓGICA"
  },
  {
    "codigo":1263466001,
    "descripcion":"NEOPLASIA MALIGNA DE PARTES BLANDAS DE DEDO DE PIE"
  },
  {
    "codigo":247658002,
    "descripcion":"PENSAMIENTO CREATIVO"
  },
  {
    "codigo":16447004,
    "descripcion":"ESTENOSIS DE CONDUCTO DEFERENTE"
  },
  {
    "codigo":409663006,
    "descripcion":"ASMA, VARIANTE TUSIVA"
  },
  {
    "codigo":737343009,
    "descripcion":"TRASTORNO SECUNDARIO DEL NEURODESARROLLO"
  },
  {
    "codigo":770111009,
    "descripcion":"TROMBOFLEBITIS DE ARCO VENOSO DORSAL DE PIE"
  },
  {
    "codigo":278591009,
    "descripcion":"ENCHAPADO DENTAL FRACTURADO"
  },
  {
    "codigo":1259796004,
    "descripcion":"ENFERMEDAD DE PAGET PRIMARIA DE CANAL ANAL"
  },
  {
    "codigo":211220005,
    "descripcion":"PICADURA DE INSECTO, NO VENENOSO, EN EL HOMBRO Y BRAZO, INFECTADA"
  },
  {
    "codigo":13291000119100,
    "descripcion":"PROLAPSO DE DISCO INTERVERTEBRAL LUMBAR SIN RADICULOPATÍA"
  },
  {
    "codigo":309524007,
    "descripcion":"MASA DEL TRONCO"
  },
  {
    "codigo":473364007,
    "descripcion":"ESTENOSIS ADQUIRIDA DE VENA CAVA INFERIOR"
  },
  {
    "codigo":307689000,
    "descripcion":"OSCILACIONES MACROSACÁDICAS"
  },
  {
    "codigo":735508008,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL SUPERFICIAL DE MANO"
  },
  {
    "codigo":209385006,
    "descripcion":"FRACTURA-SUBLUXACIÓN EXPUESTA DE MÚLTIPLES ARTICULACIONES METATARSOFALÁNGICAS"
  },
  {
    "codigo":305854000,
    "descripcion":"ATENDIDO POR SERVICIO DE TERAPIA OCUPACIONAL DEL DEPARTAMENTO DE SERVICIOS SOCIALES"
  },
  {
    "codigo":405993009,
    "descripcion":"COMPROMISO TUMORAL DE LOS MÁRGENES DE RESECCIÓN QUIRÚRGICA DE MUCOSA - NO PUEDE EVALUARSE"
  },
  {
    "codigo":109246002,
    "descripcion":"CELULITIS DEL ESPACIO SUBMENTONIANO"
  },
  {
    "codigo":12777009,
    "descripcion":"ESOFAGITIS CAUSADA POR TETRACICLINA"
  },
  {
    "codigo":404158005,
    "descripcion":"REACCIÓN CUTÁNEA INESPECÍFICA EN LA ENFERMEDAD DE HODGKIN"
  },
  {
    "codigo":830142007,
    "descripcion":"VIRUS OBSERVADO EN EL EXAMEN CON MICROSCOPIO ELECTRÓNICO"
  },
  {
    "codigo":402323000,
    "descripcion":"PSORIASIS HIPERTRÓFICA PALMOPLANTAR"
  },
  {
    "codigo":1287059003,
    "descripcion":"INFECCIÓN DE PIEL NEONATAL CAUSADA POR CANDIDA"
  },
  {
    "codigo":48381000087100,
    "descripcion":"FRACTURA DE RÓTULA DERECHA"
  },
  {
    "codigo":238483007,
    "descripcion":"DERMATITIS DEL PEZÓN DEL ATLETA"
  },
  {
    "codigo":171112000,
    "descripcion":"CRIBADO PENDIENTE"
  },
  {
    "codigo":1078251000119105,
    "descripcion":"AUSENCIA CONGÉNITA DE ANTEBRAZO Y MANO DERECHA"
  },
  {
    "codigo":43261000087106,
    "descripcion":"HERIDA PUNZANTE DE DEDO DE PIE IZQUIERDO CON CUERPO EXTRAÑO"
  },
  {
    "codigo":35581000087103,
    "descripcion":"ISQUEMIA DE MIOCARDIO POSTERIOR"
  },
  {
    "codigo":61181000087103,
    "descripcion":"INFECCIÓN DE PIEL CAUSADA POR BALAMUTHIA"
  },
  {
    "codigo":38141000087109,
    "descripcion":"ACINESIA DE SEGMENTO INFEROLATERAL MEDIO DE VENTRÍCULO CARDÍACO IZQUIERDO"
  },
  {
    "codigo":7272006,
    "descripcion":"LINFANGITIS AGUDA DEL CUERO CABELLUDO"
  },
  {
    "codigo":40701000087109,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE DEDO ÍNDICE DERECHO"
  },
  {
    "codigo":236648008,
    "descripcion":"RETENCIÓN AGUDA DE ORINA"
  },
  {
    "codigo":38205001,
    "descripcion":"DIARREA DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":267581004,
    "descripcion":"EPILEPSIA MIOCLÓNICA PROGRESIVA"
  },
  {
    "codigo":365885004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA RECORDAR UN NÚMERO DE CINCO DÍGITOS A LOS CINCO MINUTOS"
  },
  {
    "codigo":340971000119108,
    "descripcion":"COROIDITIS DISEMINADA IZQUIERDA"
  },
  {
    "codigo":1119549008,
    "descripcion":"ALA DE NARIZ APLANADA"
  },
  {
    "codigo":726333009,
    "descripcion":"LESIÓN TRAUMÁTICA DE TENDÓN DE MÚSCULO DEL TRONCO"
  },
  {
    "codigo":724498004,
    "descripcion":"NEUMONÍA CAUSADA POR CHLAMYDIA PNEUMONIAE"
  },
  {
    "codigo":298514007,
    "descripcion":"AMPLITUD DE FLEXIÓN PASIVA DE LA COLUMNA VERTEBRAL DORSAL, AUMENTADA"
  },
  {
    "codigo":1148647001,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR AGONISTA DE RECEPTOR OPIOIDE"
  },
  {
    "codigo":1345255002,
    "descripcion":"FLUOROSCOPIA DE SISTEMA GENITOURINARIO ANORMAL"
  },
  {
    "codigo":1767005,
    "descripcion":"SÍNDROME DE FISHER"
  },
  {
    "codigo":722663005,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE MAMA"
  },
  {
    "codigo":296679009,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE CEFALOTINA"
  },
  {
    "codigo":131004002,
    "descripcion":"SOMATOTROPINA HUMANA ANORMAL"
  },
  {
    "codigo":360380003,
    "descripcion":"BALANOPOSTITIS POR CANDIDA"
  },
  {
    "codigo":32700004,
    "descripcion":"INFECCIÓN CAUSADA POR OSTERTAGIA OSTERTAGI"
  },
  {
    "codigo":16206981000119106,
    "descripcion":"COMPRESIÓN DE AMBOS NERVIOS ILIOINGUINALES"
  },
  {
    "codigo":294844008,
    "descripcion":"ALERGIA A EPOETINA ALFA"
  },
  {
    "codigo":293009000,
    "descripcion":"REACCIÓN ADVERSA A LA CEFTIZOXIMA"
  },
  {
    "codigo":1144977002,
    "descripcion":"DERMATOMIOSITIS HIPOMIOPÁTICA JUVENIL"
  },
  {
    "codigo":1111391000000107,
    "descripcion":"GLAUCOMA DE ÁNGULO ABIERTO DEBIDO A TRAUMATISMO OCULAR Y POSTERIOR A ÉL"
  },
  {
    "codigo":717158001,
    "descripcion":"DELECIÓN PARCIAL DE CROMOSOMA Y"
  },
  {
    "codigo":30865009,
    "descripcion":"FILARIASIS POR MANSONELLA OZZARDI"
  },
  {
    "codigo":782694003,
    "descripcion":"MONOSOMÍA NO DISTAL"
  },
  {
    "codigo":127334004,
    "descripcion":"DERMATOPATÍA AGUDA"
  },
  {
    "codigo":16698501000119109,
    "descripcion":"QUISTE DE OVARIO DERECHO DURANTE EMBARAZO"
  },
  {
    "codigo":291174004,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR FLUFENAZINA"
  },
  {
    "codigo":225638007,
    "descripcion":"ANSIEDAD ACERCA DE REANUDAR LAS RELACIONES SEXUALES"
  },
  {
    "codigo":94566009,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA PIEL DEL CUELLO"
  },
  {
    "codigo":289339006,
    "descripcion":"BUENA VARIABILIDAD DE LA FRECUENCIA CARDÍACA FETAL BASAL"
  },
  {
    "codigo":27195007,
    "descripcion":"SÍNDROME CEREBRAL CRÓNICO NO PSICÓTICO"
  },
  {
    "codigo":92731008,
    "descripcion":"CARCINOMA IN SITU DE LA PIEL DE LA CADERA"
  },
  {
    "codigo":1010235008,
    "descripcion":"DOLOR DE MAMA IZQUIERDA"
  },
  {
    "codigo":90896002,
    "descripcion":"ENFERMEDAD RELACIONADA CON EL MEDIO INSTITUCIONAL"
  },
  {
    "codigo":1336080002,
    "descripcion":"RUPTURA TRAUMÁTICA DE LIGAMENTO LATERAL DE ARTICULACIÓN DE DEDO ANULAR"
  },
  {
    "codigo":713488003,
    "descripcion":"DEMENCIA PRESENIL CONCOMITANTE CON INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":254736006,
    "descripcion":"TUMOR FIBROSO DE LA PIEL"
  },
  {
    "codigo":15744441000119101,
    "descripcion":"DEFORMIDAD DE AMBAS MANOS DEBIDA A ARTRITIS REUMATOIDE"
  },
  {
    "codigo":283834003,
    "descripcion":"MORDEDURA DE ANIMAL EN EL DORSO DEL PIE"
  },
  {
    "codigo":447674005,
    "descripcion":"ISOMERISMO DE BRONQUIO DERECHO"
  },
  {
    "codigo":216463005,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR HEROÍNA"
  },
  {
    "codigo":312932000,
    "descripcion":"RETINITIS IDIOPÁTICA"
  },
  {
    "codigo":444004001,
    "descripcion":"TRASTORNO DE PIEL CAUSADO POR TINTA DE TATUAJE"
  },
  {
    "codigo":1197668003,
    "descripcion":"HERNIA SECUNDARIA DE ABDOMEN"
  },
  {
    "codigo":16782931000119100,
    "descripcion":"CARCINOMA DE CÉLULAS DE MERKEL PRIMARIO DE PIEL DE MEJILLA"
  },
  {
    "codigo":247396008,
    "descripcion":"NEURALGIA DE NERVIO TESTICULAR"
  },
  {
    "codigo":1163065007,
    "descripcion":"ENCEFALITIS POR BETAHERPESVIRUS HUMANO 7"
  },
  {
    "codigo":407566003,
    "descripcion":"PACIENTE CON TRATAMIENTO EN DOSIS MÁXIMA TOLERADA"
  },
  {
    "codigo":210958007,
    "descripcion":"TRASTORNO DEBIDO A FRACTURA AL NIVEL DE MUÑECA Y\/O MANO Y POSTERIOR A ELLA"
  },
  {
    "codigo":79886009,
    "descripcion":"TRASTORNO DEL METABOLISMO DEL COBRE"
  },
  {
    "codigo":241891003,
    "descripcion":"EFECTO TÓXICO CAUSADO POR AGENTE REPARADOR DE ESCAPES DE AUTOMÓVILES"
  },
  {
    "codigo":372963004,
    "descripcion":"INFECCIÓN CAUSADA POR PENICILLIUM PURPUROGERUM"
  },
  {
    "codigo":471267005,
    "descripcion":"TRAYECTO NO INTRAMURAL DE ARTERIA CORONARIA NORMAL"
  },
  {
    "codigo":274659008,
    "descripcion":"SEMICOMA"
  },
  {
    "codigo":45283008,
    "descripcion":"DISTROFIA CORNEAL GRANULAR"
  },
  {
    "codigo":307427009,
    "descripcion":"PICADURA DE AVISPÓN"
  },
  {
    "codigo":403896003,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS DE LA MANO"
  },
  {
    "codigo":733411009,
    "descripcion":"LUXACIÓN TRAUMÁTICA DE ARTICULACIÓN ACROMIOCLAVICULAR"
  },
  {
    "codigo":10680005,
    "descripcion":"DEFECTO EN EL RECEPTOR DE INSULINA"
  },
  {
    "codigo":305592007,
    "descripcion":"BAJO ATENCIÓN DE TERAPEUTA ESPECIALIZADO EN ARTESANÍAS"
  },
  {
    "codigo":371128008,
    "descripcion":"LESIÓN OCUPACIONAL"
  },
  {
    "codigo":762509000,
    "descripcion":"TRASTORNO PSICÓTICO CON IDEAS DELIRANTES CAUSADO POR CATINONA SINTÉTICA"
  },
  {
    "codigo":1155725001,
    "descripcion":"TIEMPO DE TROMBINA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":441941000124104,
    "descripcion":"ACEPTACIÓN LIMITADA DE ALIMENTOS"
  },
  {
    "codigo":860813007,
    "descripcion":"NEUROPATÍA AUTONÓMICA SENSITIVA HEREDITARIA TIPO IA"
  },
  {
    "codigo":170850000,
    "descripcion":"EFECTOS COLATERALES DE FÁRMACO ANTIRREUMÁTICO"
  },
  {
    "codigo":74381009,
    "descripcion":"PERICARDITIS FAMILIAR"
  },
  {
    "codigo":301922001,
    "descripcion":"HALLAZGO RELACIONADO CON EL TAMAÑO DEL GLOBO OCULAR"
  },
  {
    "codigo":39778006,
    "descripcion":"REACCIÓN HEMOLÍTICA A UNA TRANSFUSIÓN"
  },
  {
    "codigo":432994008,
    "descripcion":"CONSTIPACIÓN DEBIDA A INTESTINO NEUROGÉNICO"
  },
  {
    "codigo":201783000,
    "descripcion":"ARTRITIS REUMATOIDEA DE LA PRIMERA ARTICULACIÓN METATARSOFALÁNGICA"
  },
  {
    "codigo":300087002,
    "descripcion":"OREJAS NORMOIMPLANTADAS"
  },
  {
    "codigo":365623006,
    "descripcion":"COLOR DE LOS ERITROCITOS - HALLAZGO"
  },
  {
    "codigo":234551007,
    "descripcion":"DEFICIENCIA DE INMUNOGLOBULINA A1"
  },
  {
    "codigo":396556000,
    "descripcion":"TUMOR PIGMENTADO"
  },
  {
    "codigo":37943007,
    "descripcion":"EMBOLIA DE MÚLTIPLES ARTERIAS PRECEREBRALES BILATERALES"
  },
  {
    "codigo":167180005,
    "descripcion":"PRUEBAS DE FUNCIÓN RENAL FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":722401001,
    "descripcion":"SÍNDROME VIRAL DE FIEBRE SEVERA CON TROMBOCITOPENIA"
  },
  {
    "codigo":34273003,
    "descripcion":"CARDIOPATÍA HIPERTENSIVA QUE COMPLICA EL PUERPERIO Y\/O CONSTITUYE UN MOTIVO DE ATENCIÓN DURANTE ESTE PERÍODO"
  },
  {
    "codigo":100231000119101,
    "descripcion":"QUISTE PERICÁRDICO ADQUIRIDO"
  },
  {
    "codigo":296417005,
    "descripcion":"SOBREDOSIS DE DIFENHIDRAMINA"
  },
  {
    "codigo":1083271000119101,
    "descripcion":"OTITIS MEDIA SUPURATIVA CRÓNICA ATICOANTRAL BILATERAL"
  },
  {
    "codigo":12060551000119102,
    "descripcion":"POSICIÓN ANÓMALA DE FILTRO DE VENA CAVA INFERIOR"
  },
  {
    "codigo":198113009,
    "descripcion":"HIPERTROFIA MAMARIA PUBERAL"
  },
  {
    "codigo":196278005,
    "descripcion":"HIPOPLASIA DEL ESMALTE DENTAL, PRENATAL"
  },
  {
    "codigo":294582008,
    "descripcion":"ALERGIA A SULFACETAMIDA"
  },
  {
    "codigo":423819001,
    "descripcion":"INHIBICIÓN FARMACOLÓGICA DE ENZIMA CYP3A DEL CITOCROMO P450"
  },
  {
    "codigo":63371000,
    "descripcion":"INFECCIÓN POR STREPTOCARA"
  },
  {
    "codigo":15992711000119104,
    "descripcion":"NEURORRETINITIS DE AMBOS OJOS"
  },
  {
    "codigo":458422009,
    "descripcion":"ROTACIÓN ANÓMALA DE INTESTINO CON VÓLVULO DE INTESTINO MEDIO"
  },
  {
    "codigo":1208416000,
    "descripcion":"MIOPATÍA CONGÉNITA POR DESPROPORCIÓN DEL TIPO DE FIBRA DEBIDA A MUTACIÓN DE TPM3 (TROPOMIOSINA 3)"
  },
  {
    "codigo":389216001,
    "descripcion":"ESTENOSIS MEDULAR DIAFISARIA CON MALIGNIDAD ÓSEA"
  },
  {
    "codigo":292747008,
    "descripcion":"REACCIÓN ADVERSA AL EDETATO DE DICOBALTO"
  },
  {
    "codigo":1144715009,
    "descripcion":"HIPOPLASIA CONGÉNITA DE FALANGE MEDIA DE SEGUNDO DEDO DE PIE"
  },
  {
    "codigo":290912003,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR FLUVOXAMINA"
  },
  {
    "codigo":61536007,
    "descripcion":"DEGENERACIÓN RETINIANA PERIFÉRICA"
  },
  {
    "codigo":782432008,
    "descripcion":"HIDROCEFALIA NEONATAL ADQUIRIDA"
  },
  {
    "codigo":878901001,
    "descripcion":"INGESTA EXCESIVA DE PROTEÍNA Y\/O DERIVADO PROTEICO"
  },
  {
    "codigo":94304008,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL PISO DE LA BOCA"
  },
  {
    "codigo":715061003,
    "descripcion":"INFECCIÓN CAUSADA POR MADURELLA MYCETOMATIS"
  },
  {
    "codigo":92469004,
    "descripcion":"NEOPLASIA BENIGNA DE LOS ANEXOS UTERINOS"
  },
  {
    "codigo":156170000,
    "descripcion":"CICATRIZ UTERINA POR CIRUGÍA PREVIA"
  },
  {
    "codigo":289077008,
    "descripcion":"NO CORTA LOS ALIMENTOS"
  },
  {
    "codigo":1237514002,
    "descripcion":"SÍNDROME DE MIOPATÍA MITOCONDRIAL, ATAXIA CEREBELOSA Y RETINOPATÍA PIGMENTARIA"
  },
  {
    "codigo":254474002,
    "descripcion":"NEOPLASIA MALIGNA DE ESQUELETO NASAL"
  },
  {
    "codigo":190773008,
    "descripcion":"HIPERBETALIPOPROTEINEMIA"
  },
  {
    "codigo":319521000119104,
    "descripcion":"ARTRITIS REACTIVA DE ARTICULACIÓN DE CODO IZQUIERDO"
  },
  {
    "codigo":699784000,
    "descripcion":"CARA DOLICOCEFÁLICA"
  },
  {
    "codigo":840628000,
    "descripcion":"ÚTERO GRÁVIDO DE TAMAÑO CORRESPONDIENTE A 24-28 SEMANAS"
  },
  {
    "codigo":416479009,
    "descripcion":"DROGADICTO QUE SOLÍA INYECTARSE"
  },
  {
    "codigo":283572002,
    "descripcion":"HERIDA DE PERDIGÓN EN ESPALDA"
  },
  {
    "codigo":185268003,
    "descripcion":"ATENDIDO EN CONSULTORIO ESPECIALIZADO EN TRASTORNOS DE FERTILIDAD"
  },
  {
    "codigo":609417004,
    "descripcion":"ANENCEFALIA FETAL"
  },
  {
    "codigo":1363081004,
    "descripcion":"ASTILLA EN TOBILLO CON INFECCIÓN"
  },
  {
    "codigo":248969004,
    "descripcion":"SANGRADO EN GOTAS PREVIO A LA MENSTRUACIÓN"
  },
  {
    "codigo":216201007,
    "descripcion":"LESIÓN POR MAQUINARIA EN AERONAVE, SIN ACCIDENTE DE AERONAVE, VIAJERO EN AERONAVE MILITAR LESIONADO"
  },
  {
    "codigo":247134000,
    "descripcion":"HEMORRAGIA CONFLUENTE DE RETINA"
  },
  {
    "codigo":83294006,
    "descripcion":"HEMATOMA DEL LIGAMENTO ANCHO"
  },
  {
    "codigo":350871000119100,
    "descripcion":"NEOPLASIA LIPOMATOSA BENIGNA DE PIEL Y\/O DEL TEJIDO CELULAR SUBCUTÁNEO DE EXTREMIDAD SUPERIOR IZQUIERDA"
  },
  {
    "codigo":12367511000119101,
    "descripcion":"PARAPLEJÍA DEBIDA A ACCIDENTE CEREBROVASCULAR Y POSTERIOR A ÉL"
  },
  {
    "codigo":16028311000119101,
    "descripcion":"EXOSTOSIS DE CÚBITO IZQUIERDO"
  },
  {
    "codigo":1085591000119103,
    "descripcion":"EDENTULISMO COMPLETO DE CLASE I DEBIDO A TRAUMATISMO"
  },
  {
    "codigo":16018071000119103,
    "descripcion":"OSTEOPATÍA DE PERONÉ IZQUIERDO POSTERIOR A POLIOMIELITIS"
  },
  {
    "codigo":1077911000119101,
    "descripcion":"ENFERMEDAD DE PAGET DE PIE DERECHO"
  },
  {
    "codigo":291991000119103,
    "descripcion":"TRASTORNO DE NERVIO GENITOCRURAL DERECHO"
  },
  {
    "codigo":10626711000119102,
    "descripcion":"FORÚNCULO DE RODILLA IZQUIERDA"
  },
  {
    "codigo":12236951000119108,
    "descripcion":"CLAUDICACIÓN INTERMITENTE DE AMBOS MIEMBROS INFERIORES CONCOMITANTE CON ATEROSCLEROSIS Y DEBIDA A ELLA"
  },
  {
    "codigo":16033431000119108,
    "descripcion":"HIPERTROFIA ÓSEA DE CLAVÍCULA IZQUIERDA"
  },
  {
    "codigo":289431000119109,
    "descripcion":"NIÑO VÍCTIMA DE MALTRATO"
  },
  {
    "codigo":472840007,
    "descripcion":"INSUFICIENCIA DE VÁLVULA TRICÚSPIDE FETAL"
  },
  {
    "codigo":700381000,
    "descripcion":"TENDINOPATÍA NO INSERCIONAL DE TENDÓN DE AQUILES"
  },
  {
    "codigo":33431000119109,
    "descripcion":"LESIÓN DE OROFARINGE"
  },
  {
    "codigo":276232006,
    "descripcion":"LESIÓN POR REPERFUSIÓN ISQUÉMICA"
  },
  {
    "codigo":833288009,
    "descripcion":"TUMEFACCIÓN DE AMBOS LÓBULOS DE GLÁNDULA TIROIDES"
  },
  {
    "codigo":733149001,
    "descripcion":"ÍLEO OBSTRUCTIVO DE INTESTINO DELGADO CON IMPACTACIÓN"
  },
  {
    "codigo":123031000119109,
    "descripcion":"INFECCIÓN CAUSADA POR YATAPOXVIRUS"
  },
  {
    "codigo":11829911000119109,
    "descripcion":"HEMATOMA DE PIERNA IZQUIERDA"
  },
  {
    "codigo":45021001,
    "descripcion":"MENINGITIS POR CANDIDA"
  },
  {
    "codigo":208861003,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA DISTAL"
  },
  {
    "codigo":403634001,
    "descripcion":"FASCITIS EOSINOFÍLICA CAUSADA POR L-TRIPTÓFANO"
  },
  {
    "codigo":272562004,
    "descripcion":"ACOSTADO BOCA ABAJO CON UNA ALMOHADA DEBAJO DE LA CADERA"
  },
  {
    "codigo":237959005,
    "descripcion":"TRIMETILAMINURIA"
  },
  {
    "codigo":762247006,
    "descripcion":"FIBRILACIÓN AURICULAR PREEXCITADA"
  },
  {
    "codigo":74119006,
    "descripcion":"INTOXICACIÓN CAUSADA POR SAL DE ORO"
  },
  {
    "codigo":236124000,
    "descripcion":"COMPLICACIÓN DE PIEL PERIOSTOMAL"
  },
  {
    "codigo":72284000,
    "descripcion":"REACCIÓN A UNA TRANSFUSIÓN POR REACCIÓN DE LAS PROTEÍNAS DEL SUERO"
  },
  {
    "codigo":205191009,
    "descripcion":"DETENCIÓN DE CRECIMIENTO TRANSVERSO A NIVEL FALÁNGICO DE QUINTO RAYO"
  },
  {
    "codigo":303495009,
    "descripcion":"SE COLOCA DE COSTADO EN LA CAMA"
  },
  {
    "codigo":399964004,
    "descripcion":"REUMATISMO FIBROBLÁSTICO"
  },
  {
    "codigo":203356008,
    "descripcion":"OSTEÍTIS DEFORMANTE EN NEOPLASIA"
  },
  {
    "codigo":301660008,
    "descripcion":"DIFICULTAD PARA LEVANTARSE DE UNA SILLA"
  },
  {
    "codigo":365361002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA HACER CHEQUES"
  },
  {
    "codigo":299825004,
    "descripcion":"REFLEJO TRICIPITAL DISMINUIDO"
  },
  {
    "codigo":70449006,
    "descripcion":"AMAUROSIS"
  },
  {
    "codigo":232454001,
    "descripcion":"PLACA CICATRIZAL DE LA MUCOSA DE CUERDA VOCAL"
  },
  {
    "codigo":789510003,
    "descripcion":"PÉRDIDA DE LONGITUD DE ARCADA DENTAL"
  },
  {
    "codigo":35846004,
    "descripcion":"TRASTORNO BIPOLAR II MODERADO, EPISODIO MÁS RECIENTE DE CARACTERÍSTICAS DEPRESIVAS PROFUNDAS"
  },
  {
    "codigo":723974008,
    "descripcion":"POLISOMÍA"
  },
  {
    "codigo":297990009,
    "descripcion":"PELO PRESENTE"
  },
  {
    "codigo":722139003,
    "descripcion":"GLOMERULOSCLEROSIS SEGMENTARIA FOCAL CAUSADA POR LITIO"
  },
  {
    "codigo":66779006,
    "descripcion":"INDURACIÓN DE LA MAMA"
  },
  {
    "codigo":230619007,
    "descripcion":"CONTUSIÓN DEL NERVIO PERIFÉRICO"
  },
  {
    "codigo":294320001,
    "descripcion":"ALERGIA A GLICEROL"
  },
  {
    "codigo":425392003,
    "descripcion":"DIRECTIVAS ANTICIPADAS EN VIGENCIA"
  },
  {
    "codigo":1144453003,
    "descripcion":"APLASIA DE FALANGE PROXIMAL DE DEDO ANULAR"
  },
  {
    "codigo":95877004,
    "descripcion":"SÍNDROME DE LA GUERRA DEL GOLFO"
  },
  {
    "codigo":292485007,
    "descripcion":"REACCIÓN ADVERSA AL METARAMINOL"
  },
  {
    "codigo":390789009,
    "descripcion":"RETRASO DE LA CABEZA"
  },
  {
    "codigo":61274003,
    "descripcion":"ENFERMEDAD INFECCIOSA OPORTUNISTA"
  },
  {
    "codigo":94042005,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE PIEL DE DEDO DE PIE"
  },
  {
    "codigo":126810008,
    "descripcion":"NEOPLASIA DE LA FOSA AMIGDALINA"
  },
  {
    "codigo":288815001,
    "descripcion":"NO IMITA FORMAS DE COMUNICACIÓN"
  },
  {
    "codigo":92207002,
    "descripcion":"NEOPLASIA BENIGNA DE LOS ÓRGANOS GENITALES MASCULINOS"
  },
  {
    "codigo":419887003,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR SANGRE O HEMODERIVADO"
  },
  {
    "codigo":124975008,
    "descripcion":"MUTACIÓN SOMÁTICA"
  },
  {
    "codigo":876804002,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE CUELLO CON INFECCIÓN"
  },
  {
    "codigo":1237252002,
    "descripcion":"TRASTORNO FETAL DEBIDO A HEMORRAGIA MATERNOFETAL"
  },
  {
    "codigo":24836004,
    "descripcion":"VOLUMEN PLASMÁTICO AUMENTADO"
  },
  {
    "codigo":188676008,
    "descripcion":"LINFOMA MALIGNO DE CÉLULAS MIXTAS PEQUEÑAS Y GRANDES"
  },
  {
    "codigo":285145004,
    "descripcion":"ACATISIA"
  },
  {
    "codigo":23001005,
    "descripcion":"ESTENOSIS Y\/O ESTRECHEZ DEL CUELLO UTERINO, QUE AFECTA EL EMBARAZO"
  },
  {
    "codigo":250542003,
    "descripcion":"LECITINA DETECTADA EN LÍQUIDO AMNIÓTICO"
  },
  {
    "codigo":283310003,
    "descripcion":"ASTILLA DE MADERA EN PIERNA"
  },
  {
    "codigo":447150006,
    "descripcion":"QUEMADURA POR FRICCIÓN DE CUERO CABELLUDO"
  },
  {
    "codigo":185006007,
    "descripcion":"INFORME MÉDICO RECIBIDO DEL HOSPITAL"
  },
  {
    "codigo":1297283001,
    "descripcion":"CELULITIS DE DEDO MEÑIQUE"
  },
  {
    "codigo":52099006,
    "descripcion":"PULSO PARADÓJICO"
  },
  {
    "codigo":248707009,
    "descripcion":"ESTALLIDO DE VASO SANGUÍNEO"
  },
  {
    "codigo":17496003,
    "descripcion":"TRASTORNO ORGÁNICO DE ANSIEDAD"
  },
  {
    "codigo":246872004,
    "descripcion":"QUERATINIZACIÓN DE SUPERFICIE OCULAR"
  },
  {
    "codigo":115800006,
    "descripcion":"FENOTIPO DE GRUPO SANGUÍNEO MNS"
  },
  {
    "codigo":277805004,
    "descripcion":"REACCIÓN A LA LUZ PERSISTENTE INDUCIDA POR DROGAS"
  },
  {
    "codigo":212269009,
    "descripcion":"LESIÓN DEL NERVIO CUBITAL A NIVEL DE LA MUÑECA Y LA MANO"
  },
  {
    "codigo":48429009,
    "descripcion":"DOLOR SOMÁTICO"
  },
  {
    "codigo":79362003,
    "descripcion":"SINCONDROSIS ISQUIOPÚBICA DE VAN NECK"
  },
  {
    "codigo":77527000,
    "descripcion":"SÍNDROME DE TRISOMÍA PARCIAL 9P"
  },
  {
    "codigo":403372003,
    "descripcion":"MILIARIA APOCRINA DE AXILA"
  },
  {
    "codigo":1255340003,
    "descripcion":"FRACTURA NO EXPUESTA DE MÚLTIPLES FALANGES DE DEDOS DE MANO"
  },
  {
    "codigo":237697007,
    "descripcion":"DEFICIENCIA DE OXITOCINA"
  },
  {
    "codigo":1153366002,
    "descripcion":"PSEUDOTUMOR INFLAMATORIO DE BAZO"
  },
  {
    "codigo":301398004,
    "descripcion":"DOLOR A LA PALPACIÓN EN ESTRUCTURA ENDOCRINA"
  },
  {
    "codigo":72022006,
    "descripcion":"HIPERTENSIÓN ESENCIAL EN EL CONTEXTO OBSTÉTRICO"
  },
  {
    "codigo":235862008,
    "descripcion":"HEPATITIS INFECCIOSA"
  },
  {
    "codigo":365099001,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA ENTRAR Y SALIR DE LA DUCHA"
  },
  {
    "codigo":299563002,
    "descripcion":"CLIC DE MULDERS PRESENTE"
  },
  {
    "codigo":1217067003,
    "descripcion":"FIBROSIS DE GLÁNDULA SUPRARRENAL"
  },
  {
    "codigo":102955006,
    "descripcion":"FRACASO DEL MÉTODO ANTICONCEPTIVO"
  },
  {
    "codigo":234027008,
    "descripcion":"SÍNDROME DE ROBO ARTERIAL DEL MIEMBRO INFERIOR"
  },
  {
    "codigo":2816000,
    "descripcion":"MIOCARDIOPATÍA DILATADA DEBIDA A DISTROFIA MIOTÓNICA"
  },
  {
    "codigo":68352004,
    "descripcion":"GLÁNDULA SUPRARRENAL ACCESORIA"
  },
  {
    "codigo":66517001,
    "descripcion":"FRACTURA NO EXPUESTA DE CUERPO DE MAXILAR INFERIOR"
  },
  {
    "codigo":230357002,
    "descripcion":"ENCEFALOPATÍA POR URATO"
  },
  {
    "codigo":263125003,
    "descripcion":"LESIÓN DE LA PLACA PALMAR DE ARTICULACIÓN DE DEDO"
  },
  {
    "codigo":1090801000119101,
    "descripcion":"OTITIS MEDIA AGUDA SANGUINOLENTA DE OÍDO MEDIO DERECHO"
  },
  {
    "codigo":426965005,
    "descripcion":"ÚLCERA AFTOSA DE LA CAVIDAD BUCAL"
  },
  {
    "codigo":197589005,
    "descripcion":"SÍNDROME NEFRÓTICO CON GLOMERULONEFRITIS PROLIFERATIVA"
  },
  {
    "codigo":787413007,
    "descripcion":"NARIZ BÍFIDA"
  },
  {
    "codigo":981008,
    "descripcion":"PROCTITIS HEMORRÁGICA"
  },
  {
    "codigo":721877008,
    "descripcion":"SUSCEPTIBILIDAD MENDELIANA A ENFERMEDAD POR MICOBACTERIAS DEBIDA A DEFICIENCIA COMPLETA DE SUBUNIDAD BETA DE INTERLEUCINA 12"
  },
  {
    "codigo":294058006,
    "descripcion":"ALERGIA A CLONIDINA"
  },
  {
    "codigo":292223000,
    "descripcion":"REACCIÓN ADVERSA A LA MITOXANTRONA"
  },
  {
    "codigo":423295000,
    "descripcion":"CARCINOMA ESCAMOCELULAR DEL PULMÓN, TNM ESTADIO 1"
  },
  {
    "codigo":290388000,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR ÁCIDO 5-AMINOSALICÍLICO"
  },
  {
    "codigo":783743009,
    "descripcion":"INMUNODEFICIENCIA COMBINADA CON GRANULOMATOSIS"
  },
  {
    "codigo":61012002,
    "descripcion":"MIOCARDITIS REUMÁTICA CRÓNICA"
  },
  {
    "codigo":28244003,
    "descripcion":"EVERSIÓN DEL PUNTO LAGRIMAL"
  },
  {
    "codigo":126548007,
    "descripcion":"NEOPLASIA DE HUESO PROPIO DE LA NARIZ"
  },
  {
    "codigo":421460008,
    "descripcion":"RETINOPATÍA ASOCIADA CON SIDA (SÍNDROME DE INMUNODEFICIENCIA ADQUIRIDA)"
  },
  {
    "codigo":124713000,
    "descripcion":"DEFICIENCIA DE NAD^+^ SINTASA (HIDROLIZANTE DE GLUTAMINA)"
  },
  {
    "codigo":26409005,
    "descripcion":"ANEMIA DISERITROPOYÉTICA CONGÉNITA, TIPO III"
  },
  {
    "codigo":91945006,
    "descripcion":"TRASTORNO DEL DISCO ARTICULAR DE LA ARTICULACIÓN TEMPOROMANDIBULAR"
  },
  {
    "codigo":1204222000,
    "descripcion":"INFARTO AGUDO DE MIOCARDIO DE VENTRÍCULO DERECHO SIN ELEVACIÓN DE SEGMENTO ST"
  },
  {
    "codigo":286718001,
    "descripcion":"CARÁCTER AFECTUOSO"
  },
  {
    "codigo":1236990006,
    "descripcion":"BLEFARITIS ANTERIOR DE PÁRPADO SUPERIOR DERECHO"
  },
  {
    "codigo":712702008,
    "descripcion":"HERIDA DE GLOBO OCULAR DEBIDA A CUERPO EXTRAÑO PENETRANTE"
  },
  {
    "codigo":219347000,
    "descripcion":"LESIÓN DE CAUSA ACCIDENTAL O INTENCIONAL INDETERMINADA, CAÍDA DESDE ESTABLECIMIENTO RESIDENCIAL"
  },
  {
    "codigo":88275004,
    "descripcion":"DEGLUCIÓN AUSENTE"
  },
  {
    "codigo":448723007,
    "descripcion":"ANEURISMA DE SENO DE VALSALVA AÓRTICO CON RUPTURA EN AURÍCULA IZQUIERDA"
  },
  {
    "codigo":184744000,
    "descripcion":"CERTIFICADO DE ENFERMEDAD PRIVADO, GRATUITO"
  },
  {
    "codigo":284883007,
    "descripcion":"INCAPAZ DE CORTARSE LAS UÑAS DE LAS MANOS"
  },
  {
    "codigo":250280003,
    "descripcion":"ANOMALÍA DE ALIUS-GRIGNASCHI"
  },
  {
    "codigo":707197003,
    "descripcion":"MELANONIQUIA TRANSVERSAL"
  },
  {
    "codigo":445053006,
    "descripcion":"DISFUNCIÓN DEL SISTEMA VESTIBULAR"
  },
  {
    "codigo":1264253007,
    "descripcion":"CICATRIZ DE MUCOSA YUGAL IZQUIERDA"
  },
  {
    "codigo":1297021008,
    "descripcion":"CIERRE DE ÁNGULO SECUNDARIO DE AMBOS OJOS"
  },
  {
    "codigo":246610001,
    "descripcion":"NERVIO MEDIANO - HALLAZGO"
  },
  {
    "codigo":17234001,
    "descripcion":"QUISTE ALANTOIDEO"
  },
  {
    "codigo":770898002,
    "descripcion":"SÍNDROME DE ATAXIA CEREBELOSA, EPILEPSIA Y DISCAPACIDAD INTELECTUAL AUTOSÓMICO RECESIVO DEBIDO A DEFICIENCIA DE OXIDORREDUCTASA QUE CONTIENE DOMINIOS WW"
  },
  {
    "codigo":82770004,
    "descripcion":"ABSCESO DE LABIO"
  },
  {
    "codigo":215677009,
    "descripcion":"HIPOTIROIDISMO CONGÉNITO CON GLÁNDULA TIROIDES ECTÓPICA"
  },
  {
    "codigo":248445009,
    "descripcion":"FIEBRE, VARIACIÓN DIURNA"
  },
  {
    "codigo":443218005,
    "descripcion":"DISPOSITIVO DE TELECOMUNICACIONES PARA SORDOS INSTALADO EN EL HOGAR"
  },
  {
    "codigo":48167000,
    "descripcion":"AMNESIA"
  },
  {
    "codigo":1162279001,
    "descripcion":"CIFOSIS DEBIDA A INFECCIÓN Y POSTERIOR A ELLA"
  },
  {
    "codigo":212007001,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO POR AGENTE CORROSIVO DE CADERA Y MIEMBRO INFERIOR, EXCEPTO TOBILLO Y PIE"
  },
  {
    "codigo":703527003,
    "descripcion":"SÍNDROME DE AGOTAMIENTO DE ÁCIDO DESOXIRRIBONUCLEICO MITOCONDRIAL RELACIONADO CON TK2, FORMA MIOPÁTICA"
  },
  {
    "codigo":80935004,
    "descripcion":"HEMIPLEJÍA FLÁCCIDA"
  },
  {
    "codigo":277543005,
    "descripcion":"TRASTORNO MALIGNO DE LOS LEUCOCITOS"
  },
  {
    "codigo":242940003,
    "descripcion":"LESIÓN POR INTERVENCIÓN LEGAL, GOLPEADO CON UNA FUSTA"
  },
  {
    "codigo":472316006,
    "descripcion":"MIOCARDIOPATÍA MITOCONDRIAL HIPERTRÓFICA"
  },
  {
    "codigo":110033000,
    "descripcion":"LACERACIÓN PERIORBITARIA SIMPLE CONTAMINADA"
  },
  {
    "codigo":111868009,
    "descripcion":"RUBÉOLA CON COMPLICACIONES NEUROLÓGICAS"
  },
  {
    "codigo":208337001,
    "descripcion":"FRACTURA EXPUESTA DE CÚBITO, EPÍFISIS INFERIOR"
  },
  {
    "codigo":699857006,
    "descripcion":"PRÓTESIS DENTAL COMPLETA NO ESTÉTICA"
  },
  {
    "codigo":10677951000119102,
    "descripcion":"TUMEFACCIÓN LOCALIZADA DE ANTEBRAZO"
  },
  {
    "codigo":77265008,
    "descripcion":"FORÚNCULO DE DEDO DE PIE"
  },
  {
    "codigo":1287846005,
    "descripcion":"CONDROMALACIA DE ARTICULACIÓN DE MANO"
  },
  {
    "codigo":403110005,
    "descripcion":"COCCIDIOIDOMICOSIS CUTÁNEA DISEMINADA"
  },
  {
    "codigo":73595000,
    "descripcion":"ESTRÉS"
  },
  {
    "codigo":1156774008,
    "descripcion":"POLIARTRITIS JUVENIL POSITIVA PARA ANTICUERPOS ANTIPÉPTIDO CÍCLICO CITRULINADO Y POSITIVA PARA FACTOR REUMATOIDE"
  },
  {
    "codigo":204667006,
    "descripcion":"DIVERTÍCULO ESOFÁGICO CONGÉNITO"
  },
  {
    "codigo":235600000,
    "descripcion":"ESOFAGITIS INFECCIOSA"
  },
  {
    "codigo":302971009,
    "descripcion":"TRASTORNO DE ANASTOMOSIS GASTROINTESTINAL"
  },
  {
    "codigo":6224002,
    "descripcion":"RESISTENCIA HORMONAL DISMINUIDA"
  },
  {
    "codigo":401275008,
    "descripcion":"ESCALA DE DISNEA DE BORG: 0, NADA"
  },
  {
    "codigo":71760005,
    "descripcion":"NEURALGIA CERVICO - OCCIPITAL"
  },
  {
    "codigo":301136005,
    "descripcion":"LATIDO DEL VÉRTICE DÉBIL"
  },
  {
    "codigo":1251408006,
    "descripcion":"DERMATITIS ATÓPICA IMPETIGINIZADA EN LA INFANCIA"
  },
  {
    "codigo":15730521000119100,
    "descripcion":"ESOTROPÍA POR DEPRIVACIÓN SENSITIVA DE OJO IZQUIERDO"
  },
  {
    "codigo":329561000119101,
    "descripcion":"OCLUSIÓN DE ARTERIA CEREBRAL POSTERIOR DERECHA"
  },
  {
    "codigo":11306841000119101,
    "descripcion":"FRACTURAS MÚLTIPLES NO EXPUESTAS DE LA PELVIS POR COMPRESIÓN ANTEROPOSTERIOR CON ANILLO PÉLVICO ESTABLE"
  },
  {
    "codigo":364837006,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA CORRER PENDIENTE ABAJO"
  },
  {
    "codigo":15648601000119102,
    "descripcion":"ATEROSCLEROSIS DE ARTERIA DE MIEMBRO SUPERIOR DERECHO"
  },
  {
    "codigo":231930000,
    "descripcion":"DISTROFIA CORNEAL DE REIS-BUCKLERS"
  },
  {
    "codigo":723450004,
    "descripcion":"ATROFIA RETINOCOROIDEA PARAVENOSA PIGMENTADA"
  },
  {
    "codigo":788986004,
    "descripcion":"ENTEROCOLITIS NECROSANTE DEL RECIÉN NACIDO, ESTADIO 1A DE LA CLASIFICACIÓN DE BELL"
  },
  {
    "codigo":2554006,
    "descripcion":"PERICARDITIS SUPURATIVA AGUDA"
  },
  {
    "codigo":683711000119109,
    "descripcion":"NEVO DISPLÁSICO DE PIEL DE LABIO"
  },
  {
    "codigo":262863003,
    "descripcion":"SECCIÓN DE APÉNDICE ILEOCECAL"
  },
  {
    "codigo":66255005,
    "descripcion":"ERECCIÓN DE PENE DISMINUIDA"
  },
  {
    "codigo":197327006,
    "descripcion":"ABSCESO HEPÁTICO POS COLANGITIS"
  },
  {
    "codigo":1342372000,
    "descripcion":"SÍNDROME DE HIPER-IGE AUTOSÓMICO RECESIVO POR DEFICIENCIA DE ZNF341"
  },
  {
    "codigo":721615009,
    "descripcion":"DIARREA NEONATAL NO INFECCIOSA"
  },
  {
    "codigo":95353000,
    "descripcion":"EDEMA DE LA MEMBRANA MUCOSA"
  },
  {
    "codigo":717945001,
    "descripcion":"SÍNDROME DE ANOMALÍA CEREBRAL, DISCAPACIDAD INTELECTUAL SEVERA, DISPLASIA ECTODÉRMICA, DEFORMIDAD ESQUELÉTICA, ANOMALÍA AURICULAR, DISPLASIA RENAL"
  },
  {
    "codigo":293796008,
    "descripcion":"ALERGIA A DIMETILSULFÓXIDO"
  },
  {
    "codigo":62585004,
    "descripcion":"TRASTORNO DEGENERATIVO DEL GLOBO OCULAR"
  },
  {
    "codigo":160889005,
    "descripcion":"NIÑO EXCLUIDO DEL REGISTRO DE PROTECCIÓN"
  },
  {
    "codigo":291961006,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR BENDROFLUAZIDA"
  },
  {
    "codigo":128121009,
    "descripcion":"TRASTORNO DEL TRONCO"
  },
  {
    "codigo":716110002,
    "descripcion":"SÍNDROME DE DEFECTO DE MIEMBRO SUPERIOR CON ANOMALÍAS OCULARES Y AUDITIVAS"
  },
  {
    "codigo":27982003,
    "descripcion":"SÍNDROME DE BROWN - SÉQUARD"
  },
  {
    "codigo":290126008,
    "descripcion":"HALLAZGO RELACIONADO CON MEDICIONES DE LA SECRECIÓN LÁCTEA"
  },
  {
    "codigo":60750009,
    "descripcion":"ENFERMEDAD DEL TERCER NERVIO CRANEAL"
  },
  {
    "codigo":93518009,
    "descripcion":"ENFERMEDAD DE HODGKIN, ESCLEROSIS NODULAR DEL BAZO"
  },
  {
    "codigo":124451004,
    "descripcion":"DEFICIENCIA DE DESOXIRRIBONUCLEASA II"
  },
  {
    "codigo":419363006,
    "descripcion":"REFLEJO SUPRARROTULIANO NORMAL"
  },
  {
    "codigo":1304099007,
    "descripcion":"NEOVASCULARIZACIÓN DE ÁNGULO IRIDOCORNEAL DE OJO IZQUIERDO"
  },
  {
    "codigo":26147006,
    "descripcion":"CROMHIDROSIS"
  },
  {
    "codigo":286456001,
    "descripcion":"NO PREPARA ALIMENTO PARA COMER"
  },
  {
    "codigo":253688004,
    "descripcion":"COLATERALES A ARTERIAS PULMONARES"
  },
  {
    "codigo":417528008,
    "descripcion":"CONSENTIMIENTO PARA LA CARGA EN REGISTRO ELECTRÓNICO COMPARTIDO, OTORGADO"
  },
  {
    "codigo":219085007,
    "descripcion":"REACCIÓN ADVERSA A VACUNA ANTIDIFTÉRICA"
  },
  {
    "codigo":315554000,
    "descripcion":"NACIDO EN URUGUAY"
  },
  {
    "codigo":186317009,
    "descripcion":"ARTERITIS CEREBRAL LISTÉRICA"
  },
  {
    "codigo":1003682004,
    "descripcion":"CLASIFICACIÓN DE INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA DE LOS CENTROS PARA EL CONTROL Y PREVENCIÓN DE ENFERMEDADES ETAPA 1"
  },
  {
    "codigo":11771891000119109,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA POSTERIOR DE ARTICULACIÓN DE CODO DERECHO"
  },
  {
    "codigo":250018006,
    "descripcion":"MARCHA EN PUNTAS DE PIES"
  },
  {
    "codigo":51575000,
    "descripcion":"APETITO ALIMENTARIO ANORMAL"
  },
  {
    "codigo":118946009,
    "descripcion":"TRASTORNO DEL TÓRAX"
  },
  {
    "codigo":117111002,
    "descripcion":"UNIDAD DE HEMODERIVADO PARA INSPECCIÓN E INCLUSIÓN EN EL INVENTARIO"
  },
  {
    "codigo":248183003,
    "descripcion":"INCLINACIÓN ANTERIOR"
  },
  {
    "codigo":282786009,
    "descripcion":"SÍNDROME DE CORDÓN ESPINAL POSTERIOR"
  },
  {
    "codigo":1231223005,
    "descripcion":"QUISTE EN CÁMARA ANTERIOR CAUSADO POR PARÁSITO"
  },
  {
    "codigo":1263991006,
    "descripcion":"HEMORRAGIA INTRACRANEANA NO TRAUMÁTICA NEONATAL PRECOZ"
  },
  {
    "codigo":444791008,
    "descripcion":"PUEDE CONCURRIR A TURNO ANTE NOTIFICACIÓN A CORTO PLAZO"
  },
  {
    "codigo":213580002,
    "descripcion":"GRANULOMA TUBERCULOIDE CASEOSO"
  },
  {
    "codigo":408353001,
    "descripcion":"FORMULACIÓN DE MEDICAMENTO INADECUADA"
  },
  {
    "codigo":16972009,
    "descripcion":"ANEURISMA CONGÉNITO DE LA AORTA"
  },
  {
    "codigo":721459005,
    "descripcion":"SÍNDROME DEL CORDÓN ANTERIOR DE MÉDULA ESPINAL AL NIVEL DEL CUARTO SEGMENTO DORSAL"
  },
  {
    "codigo":15137004,
    "descripcion":"PULSO RADIAL NORMAL"
  },
  {
    "codigo":703265006,
    "descripcion":"MALFORMACIÓN ARTERIOVENOSA DE LA CARA"
  },
  {
    "codigo":1260321008,
    "descripcion":"CEFALEA DEBIDA A NEOPLASIA INTRACRANEAL"
  },
  {
    "codigo":275446004,
    "descripcion":"SÍNDROME DE HEMATOMA DOLOROSO"
  },
  {
    "codigo":109771000,
    "descripcion":"ERITEMA DE MUCOSA ORAL"
  },
  {
    "codigo":371915000,
    "descripcion":"ENFERMEDAD DIFUSA DE LA ARTERIA CORONARIA"
  },
  {
    "codigo":306379002,
    "descripcion":"VISTO EN EL SERVICIO DE CIRUGÍA COLORRECTAL"
  },
  {
    "codigo":240843005,
    "descripcion":"TUMEFACCIÓN DE CALABAR"
  },
  {
    "codigo":304544003,
    "descripcion":"TORSIÓN INTERMITENTE DE TESTÍCULO"
  },
  {
    "codigo":271776004,
    "descripcion":"CREPITACIÓN DE PARTES BLANDAS"
  },
  {
    "codigo":402848007,
    "descripcion":"PÚRPURA POR CONTACTO CON ROPA"
  },
  {
    "codigo":399178002,
    "descripcion":"RESPUESTA TERAPÉUTICA ESTÁTICA"
  },
  {
    "codigo":366410003,
    "descripcion":"AMPLITUD DE EXTENSIÓN DE COLUMNA DORSAL - HALLAZGO"
  },
  {
    "codigo":10899751000119109,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO TROCLEAR DERECHO"
  },
  {
    "codigo":299039000,
    "descripcion":"MANOS ASIMÉTRICAS"
  },
  {
    "codigo":300874009,
    "descripcion":"TUMEFACCIÓN DE OÍDO"
  },
  {
    "codigo":4127004,
    "descripcion":"OBSTRUCCIÓN PROSTÁTICA"
  },
  {
    "codigo":305601000119105,
    "descripcion":"COXA MAGNA DE FÉMUR DERECHO"
  },
  {
    "codigo":723188008,
    "descripcion":"INSUFICIENCIA RENAL"
  },
  {
    "codigo":262601001,
    "descripcion":"CUERPO EXTRAÑO EN BRONQUIO PRINCIPAL IZQUIERDO"
  },
  {
    "codigo":33225004,
    "descripcion":"ANOMALÍA ANORRECTAL"
  },
  {
    "codigo":295369005,
    "descripcion":"SOBREDOSIS INTENCIONAL DE ANTAGONISTAS H2"
  },
  {
    "codigo":721353007,
    "descripcion":"LUXACIÓN TRAUMÁTICA COMPLETA DE ARTICULACIÓN ATLANTO-OCCIPITAL"
  },
  {
    "codigo":162462001,
    "descripcion":"SÍNTOMA QUE COMENZÓ GRADUALMENTE"
  },
  {
    "codigo":129694002,
    "descripcion":"CON MAYOR RIESGO DE SÍNDROME DE INACTIVIDAD"
  },
  {
    "codigo":195230003,
    "descripcion":"INFARTO CEREBRAL POR TROMBOSIS VENOSA CEREBRAL, NO PIÓGENO"
  },
  {
    "codigo":719518004,
    "descripcion":"QUERATODERMIA PALMOPLANTAR AUTOSÓMICA DOMINANTE Y ALOPECIA CONGÉNITA"
  },
  {
    "codigo":1145502005,
    "descripcion":"HIPOPLASIA CONGÉNITA DE QUINTO HUESO METACARPIANO"
  },
  {
    "codigo":226163001,
    "descripcion":"DIETA CON BAJO CONTENIDO DE MINERALES"
  },
  {
    "codigo":291699002,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR SULFONA"
  },
  {
    "codigo":422771007,
    "descripcion":"PREFERENCIA MANUAL VARIABLE"
  },
  {
    "codigo":29555009,
    "descripcion":"TRASTORNO DE LA RETINA"
  },
  {
    "codigo":1141832002,
    "descripcion":"INFILTRACIÓN EOSINOFÍLICA DE MIOCARDIO"
  },
  {
    "codigo":95091009,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE PARTES BLANDAS DE LA AXILA"
  },
  {
    "codigo":224328002,
    "descripcion":"CALIFICACIONES NO APROBADAS"
  },
  {
    "codigo":289864003,
    "descripcion":"PERINEO LEVEMENTE EDEMATIZADO"
  },
  {
    "codigo":93256009,
    "descripcion":"HIPOPLASIA CONGÉNITA DEL PERONÉ"
  },
  {
    "codigo":419101002,
    "descripcion":"ALERGIA A SEMILLA"
  },
  {
    "codigo":16745051000119107,
    "descripcion":"RETINOPATÍA DIABÉTICA NO PROLIFERATIVA DE OJO DERECHO DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":124189004,
    "descripcion":"DEFICIENCIA DE NADH DESHIDROGENASA (UBIQUINONA)"
  },
  {
    "codigo":1269234000,
    "descripcion":"PREDISPOSICIÓN A INFECCIÓN VIRAL GRAVE POR DEFICIENCIA DEL FACTOR DE REGULACIÓN DEL INTERFERÓN 7"
  },
  {
    "codigo":688731000119109,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE CUELLO DE VEJIGA URINARIA"
  },
  {
    "codigo":286194006,
    "descripcion":"CIERRA LA CASA EN FORMA SEGURA"
  },
  {
    "codigo":253426007,
    "descripcion":"AURÍCULA IZQUIERDA CON DOBLE TRACTO DE SALIDA"
  },
  {
    "codigo":1201863001,
    "descripcion":"ESCLEROSIS LATERAL AMIOTRÓFICA TIPO 1"
  },
  {
    "codigo":413596002,
    "descripcion":"FENOTIPO DE LIPOPROTEÍNA ATEROGÉNICA"
  },
  {
    "codigo":1003420002,
    "descripcion":"DELECIÓN DE PORCIÓN MEDIA DEL BRAZO LARGO DE CROMOSOMA 9"
  },
  {
    "codigo":708508006,
    "descripcion":"GINGIVOESTOMATITIS NECROSANTE"
  },
  {
    "codigo":53148007,
    "descripcion":"DEDOS DEL PIE HIPOCRÁTICOS"
  },
  {
    "codigo":247921000,
    "descripcion":"CUMPLIMIENTO AUTOMÁTICO"
  },
  {
    "codigo":1362033000,
    "descripcion":"ATRAPAMIENTO DE MÚSCULO RECTO INFERIOR"
  },
  {
    "codigo":282524007,
    "descripcion":"CAPAZ DE SUBIR ESCALERAS CORRIENDO"
  },
  {
    "codigo":1263729008,
    "descripcion":"TRASTORNO FETAL DEBIDO A RUPTURA PREMATURA DE MEMBRANAS"
  },
  {
    "codigo":16036751000119103,
    "descripcion":"DETENCIÓN DE CRECIMIENTO EPIFISARIO DE HÚMERO DERECHO"
  },
  {
    "codigo":735771000,
    "descripcion":"LACERACIÓN DE CORAZÓN SIN HEMOPERICARDIO"
  },
  {
    "codigo":80411001,
    "descripcion":"FRACTURA EXPUESTA DE COLLES"
  },
  {
    "codigo":703003007,
    "descripcion":"CITROBACTER FREUNDII O CITROBACTER YOUNGAE"
  },
  {
    "codigo":211483007,
    "descripcion":"CONTUSIÓN DE GLOBO OCULAR"
  },
  {
    "codigo":1260059007,
    "descripcion":"CARCINOMA BRONQUIOLOALVEOLAR MUCINOSO DE PULMÓN"
  },
  {
    "codigo":766704005,
    "descripcion":"PERICARDITIS RECURRENTE IDIOPÁTICA"
  },
  {
    "codigo":209648005,
    "descripcion":"DESGARRO COMPLETO DE LIGAMENTO DE ARTICULACIÓN CONDROCOSTAL"
  },
  {
    "codigo":109509000,
    "descripcion":"DIENTE IMPACTADO EN PARTES BLANDAS"
  },
  {
    "codigo":240581006,
    "descripcion":"INFECCIÓN GONOCÓCICA PÉLVICA EN LA MUJER"
  },
  {
    "codigo":764869007,
    "descripcion":"PROCEDIMIENTO QUIRÚRGICO CANCELADO ANTES DEL COMIENZO DE LA ANESTESIA"
  },
  {
    "codigo":107674006,
    "descripcion":"HALLAZGO CITOLÓGICO"
  },
  {
    "codigo":402586007,
    "descripcion":"CUADRO ECCEMATOSO SECUNDARIO"
  },
  {
    "codigo":204143004,
    "descripcion":"ANOMALÍAS DE LA FORMA Y EL TAMAÑO DE LA CÓRNEA"
  },
  {
    "codigo":1187183007,
    "descripcion":"PRESIÓN PARCIAL DE DIÓXIDO DE CARBONO ARTERIAL POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":890436003,
    "descripcion":"FENILCETONURIA CLÁSICA CON DEFICIENCIA TOTAL DE FENILALANINA HIDROXILASA"
  },
  {
    "codigo":366148004,
    "descripcion":"VOLUMEN RESPIRATORIO - HALLAZGO"
  },
  {
    "codigo":35881000119106,
    "descripcion":"IRITIS SECUNDARIA NO INFECCIOSA"
  },
  {
    "codigo":202308007,
    "descripcion":"ANQUILOSIS DE LA ARTICULACIÓN RADIOCUBITAL SUPERIOR"
  },
  {
    "codigo":235076008,
    "descripcion":"TRASTORNO DE LA PRÓTESIS DENTAL"
  },
  {
    "codigo":11805891000119101,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA PROXIMAL DE DEDO ANULAR DERECHO"
  },
  {
    "codigo":724761004,
    "descripcion":"ENFERMEDAD DE PARKINSON ESPORÁDICA"
  },
  {
    "codigo":298777007,
    "descripcion":"AMPLITUD DE FLEXIÓN ACTIVA DE HOMBRO AUMENTADA"
  },
  {
    "codigo":1281817009,
    "descripcion":"DEFECTO VELOFARÍNGEO DEBIDO A FISURA PALATINA"
  },
  {
    "codigo":722926003,
    "descripcion":"NEUTROPENIA NEONATAL TRANSITORIA DEBIDA A SEPSIS BACTERIANA NEONATAL"
  },
  {
    "codigo":34798003,
    "descripcion":"LESIÓN TRAUMÁTICA DE HÍGADO SIN HERIDA ABIERTA HACIA CAVIDAD ABDOMINAL"
  },
  {
    "codigo":1148910003,
    "descripcion":"HEMOGLOBINA C-BETA TALASEMIA"
  },
  {
    "codigo":428014009,
    "descripcion":"SITOSTEROLEMIA HOMOCIGOTA"
  },
  {
    "codigo":721091003,
    "descripcion":"DERMO-ODONTO DISPLASIA"
  },
  {
    "codigo":1343683005,
    "descripcion":"ALTERACIÓN CRÓNICA DE ASTA ANTERIOR DE MENISCO EXTERNO"
  },
  {
    "codigo":719256004,
    "descripcion":"SÍNDROME DE CUELLO ALADO CON DISCAPACIDAD INTELECTUAL Y ANOMALÍA DIGITAL"
  },
  {
    "codigo":162200009,
    "descripcion":"PÉRDIDA TEMPORAL DE MEMORIA"
  },
  {
    "codigo":424344009,
    "descripcion":"ALMACENAMIENTO INADECUADO DE LOS ALIMENTOS"
  },
  {
    "codigo":1145240009,
    "descripcion":"RADICULITIS DEBIDA A DESPLAZAMIENTO DE DISCO INTERVERTEBRAL LUMBAR"
  },
  {
    "codigo":337091000119107,
    "descripcion":"XANTOMA DE PÁRPADO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":782957005,
    "descripcion":"ICTIOSIS"
  },
  {
    "codigo":225901009,
    "descripcion":"CAPAZ DE CONTROLAR LA CONDUCTA"
  },
  {
    "codigo":94829009,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL HOCICO DE TENCA"
  },
  {
    "codigo":289602004,
    "descripcion":"HALLAZGO RELACIONADO CON MEDIDAS DE LA VAGINA"
  },
  {
    "codigo":191298004,
    "descripcion":"DEFICIENCIA ADQUIRIDA DE FACTOR II"
  },
  {
    "codigo":1010498006,
    "descripcion":"AGENESIA DE LÚNULA"
  },
  {
    "codigo":92994009,
    "descripcion":"ANOMALÍA CONGÉNITA DE LA VENA ÁCIGOS"
  },
  {
    "codigo":1172503002,
    "descripcion":"ESTRONA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":418839003,
    "descripcion":"SÍNDROME DE NEFRITIS TUBULOINTERSTICIAL Y UVEÍTIS"
  },
  {
    "codigo":254999005,
    "descripcion":"TUMOR FIBROSO SOLITARIO DE ÓRBITA"
  },
  {
    "codigo":386071007,
    "descripcion":"TRASTORNO RELACIONADO CON LA VITAMINA D3"
  },
  {
    "codigo":25623008,
    "descripcion":"HABLA APROSÓDICA"
  },
  {
    "codigo":123927007,
    "descripcion":"INTOXICACIÓN POR MELIACEAE"
  },
  {
    "codigo":253164002,
    "descripcion":"QUISTE ARACNOIDEO ESPINAL INTRADURAL"
  },
  {
    "codigo":285932002,
    "descripcion":"NO VACÍA LA BAÑERA"
  },
  {
    "codigo":449772006,
    "descripcion":"CICATRIZ FIBROSA PERIAPICAL"
  },
  {
    "codigo":284097000,
    "descripcion":"TREPA"
  },
  {
    "codigo":56556009,
    "descripcion":"DERMATOSIS SENSIBLE AL CINC"
  },
  {
    "codigo":1268972009,
    "descripcion":"TOMOSÍNTESIS DIGITAL DE MAMA NORMAL"
  },
  {
    "codigo":447937009,
    "descripcion":"ANOMALÍA CONGÉNITA DE CÚSPIDE DE VÁLVULA AÓRTICA"
  },
  {
    "codigo":216726002,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR PARAQUAT"
  },
  {
    "codigo":16012791000119103,
    "descripcion":"TROMBOSIS DE ARTERIA DE EXTREMIDAD INFERIOR DERECHA"
  },
  {
    "codigo":1363606006,
    "descripcion":"TENDINITIS DE CODO"
  },
  {
    "codigo":18283000,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE LA NARIZ"
  },
  {
    "codigo":1263467005,
    "descripcion":"NEOPLASIA MALIGNA DE PARTES BLANDAS DE MANO"
  },
  {
    "codigo":280427006,
    "descripcion":"SÍNTOMA PSICÓTICO PRESENTE"
  },
  {
    "codigo":29851000175103,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN DE TALÓN DERECHO GRADO 1"
  },
  {
    "codigo":409664000,
    "descripcion":"NEUMONÍA CAUSADA POR BACTERIAS ANAEROBIAS"
  },
  {
    "codigo":51051009,
    "descripcion":"AMPOLLA DE BRAZO, SIN INFECCIÓN"
  },
  {
    "codigo":11834871000119105,
    "descripcion":"SUBLUXACIÓN DE ARTICULACIÓN CARPOMETACARPIANA DERECHA"
  },
  {
    "codigo":737344003,
    "descripcion":"HIPOACUSIA DE CONDUCCIÓN CONGÉNITA"
  },
  {
    "codigo":770112002,
    "descripcion":"FLEBITIS DEL ARCO VENOSO DORSAL DEL PIE"
  },
  {
    "codigo":278592002,
    "descripcion":"PUENTE DENTAL FRACTURADO"
  },
  {
    "codigo":735509000,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL PROFUNDA DE MANO"
  },
  {
    "codigo":13730001000004107,
    "descripcion":"TROMBOSIS DE VENA DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":15970001000004108,
    "descripcion":"FRACTURA PERIPROTÉSICA DE FÉMUR PROXIMAL"
  },
  {
    "codigo":440597004,
    "descripcion":"OBSTRUCCIÓN DE CATÉTER PARA DIÁLISIS PERITONEAL POR FORMACIÓN DE FIBRINA"
  },
  {
    "codigo":47381006,
    "descripcion":"TIBIA EN SABLE"
  },
  {
    "codigo":309525008,
    "descripcion":"MASA EN EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":78314001,
    "descripcion":"OSTEOGÉNESIS IMPERFECTA"
  },
  {
    "codigo":473365008,
    "descripcion":"DISFUNCIÓN DE VENTRÍCULO DERECHO DEL CORAZÓN"
  },
  {
    "codigo":405994003,
    "descripcion":"PRESENCIA DE TEJIDO FETAL EN EL ESPÉCIMEN, NO PUEDE SER DETERMINADA"
  },
  {
    "codigo":1259797008,
    "descripcion":"ENFERMEDAD DE PAGET PRIMARIA DE PIEL DE ESCROTO"
  },
  {
    "codigo":80149009,
    "descripcion":"ESTIMULACIÓN MANUAL DEL PENE"
  },
  {
    "codigo":209386007,
    "descripcion":"FRACTURA-SUBLUXACIÓN EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA DE MÚLTIPLES DEDOS DEL PIE"
  },
  {
    "codigo":307690009,
    "descripcion":"MOVIMIENTOS OCULARES ESPONTÁNEOS EN EL COMA"
  },
  {
    "codigo":830143002,
    "descripcion":"BACTERIAS OBSERVADAS EN EL EXAMEN CON MICROSCOPIO ELECTRÓNICO"
  },
  {
    "codigo":404159002,
    "descripcion":"HIPERMELANOSIS POR ENFERMEDAD DE HODGKIN"
  },
  {
    "codigo":305855004,
    "descripcion":"ATENDIDO POR SERVICIO DE TERAPIA OCUPACIONAL HOSPITALARIO"
  },
  {
    "codigo":339601000119104,
    "descripcion":"COROIDITIS FOCAL MACULAR IZQUIERDA"
  },
  {
    "codigo":109247006,
    "descripcion":"CELULITIS DE LA FOSA INFRATEMPORAL"
  },
  {
    "codigo":238484001,
    "descripcion":"DEDO DEL PIE DE TENISTA"
  },
  {
    "codigo":74644004,
    "descripcion":"INFLUENZA CON ENCEFALOPATÍA"
  },
  {
    "codigo":402324006,
    "descripcion":"PSORIASIS NO PUSTULOSA DE MANOS Y PIES"
  },
  {
    "codigo":236649000,
    "descripcion":"RETENCIÓN URINARIA CRÓNICA REAGUDIZADA"
  },
  {
    "codigo":1287060008,
    "descripcion":"HEMORRAGIA INTRAVENTRICULAR NO TRAUMÁTICA GRADO 2 DURANTE PERÍODO NEONATAL TEMPRANO"
  },
  {
    "codigo":105577008,
    "descripcion":"EN BANCARROTA"
  },
  {
    "codigo":38206000,
    "descripcion":"EXCEPCIONALMENTE GRANDE AL NACER"
  },
  {
    "codigo":70974002,
    "descripcion":"AUSENCIA CONGÉNITA DE COSTILLA"
  },
  {
    "codigo":726334003,
    "descripcion":"DACRIOCELE CONGÉNITO"
  },
  {
    "codigo":365886003,
    "descripcion":"EJECUCIÓN DE MEMORIA VISUAL DE CORTO PLAZO - HALLAZGO"
  },
  {
    "codigo":1119550008,
    "descripcion":"ALA NASAL GRUESA"
  },
  {
    "codigo":202046009,
    "descripcion":"ARTRITIS SECUNDARIA A NEOPLASIA MALIGNA"
  },
  {
    "codigo":724499007,
    "descripcion":"NEUMONITIS EOSINOFÍLICA AGUDA IDIOPÁTICA"
  },
  {
    "codigo":41431000087104,
    "descripcion":"HEMATOMA DE MANO IZQUIERDA"
  },
  {
    "codigo":1345256001,
    "descripcion":"TC DE SISTEMA GENITOURINARIO NORMAL"
  },
  {
    "codigo":298515008,
    "descripcion":"AMPLITUD DE FLEXIÓN PASIVA DE LA COLUMNA VERTEBRAL DORSAL, DISMINUIDA"
  },
  {
    "codigo":43991000087107,
    "descripcion":"CORTE EN PIEL DE MANO DERECHA"
  },
  {
    "codigo":722664004,
    "descripcion":"CARCINOMA IN SITU DE ANEXOS OCULARES"
  },
  {
    "codigo":296680007,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE CEFALOTINA"
  },
  {
    "codigo":131005001,
    "descripcion":"NIVEL DE HORMONA DE CRECIMIENTO HUMANA POR ENCIMA DE RANGO DE REFERENCIA"
  },
  {
    "codigo":294845009,
    "descripcion":"ALERGIA A EPOETINA BETA"
  },
  {
    "codigo":293010005,
    "descripcion":"REACCIÓN ADVERSA A LA CEFIXIMA"
  },
  {
    "codigo":1144978007,
    "descripcion":"UVEÍTIS ANTERIOR DEBIDA A SARCOIDOSIS"
  },
  {
    "codigo":94567000,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA PIEL DE LA NARIZ"
  },
  {
    "codigo":782695002,
    "descripcion":"DISTONÍA PRIMARIA TIPO DYT17"
  },
  {
    "codigo":127335003,
    "descripcion":"TRASTORNO AGUDO DE LOS ÓRGANOS GENITALES FEMENINOS"
  },
  {
    "codigo":225639004,
    "descripcion":"PREOCUPADO ACERCA DE NO PODER HACER FRENTE A LA CRIANZA DE UN BEBÉ"
  },
  {
    "codigo":192871008,
    "descripcion":"ATAXIA CEREBELOSA DE APARICIÓN TEMPRANA CON MIOCLONÍA"
  },
  {
    "codigo":717159009,
    "descripcion":"HALLAZGO RELACIONADO CON LA PRESENCIA DE CÉLULAS DE LEVADURAS Y ELEMENTOS FÚNGICOS"
  },
  {
    "codigo":92732001,
    "descripcion":"CARCINOMA IN SITU DE LA PIEL DE LA RODILLA"
  },
  {
    "codigo":15933381000119106,
    "descripcion":"ANOMALÍA CONGÉNITA DE TROMPA DE FALOPIO IZQUIERDA"
  },
  {
    "codigo":289340008,
    "descripcion":"VARIABILIDAD BASAL ESCASA DE LA FRECUENCIA CARDÍACA FETAL"
  },
  {
    "codigo":1010236009,
    "descripcion":"HIPOACUSIA CONDUCTIVA DE OÍDO DERECHO"
  },
  {
    "codigo":254737002,
    "descripcion":"FASCITIS PROLIFERATIVA"
  },
  {
    "codigo":1336081003,
    "descripcion":"CRISIS SITUACIONAL"
  },
  {
    "codigo":342111000119101,
    "descripcion":"LEUCOMA ADHERENTE DE OJO IZQUIERDO"
  },
  {
    "codigo":123665003,
    "descripcion":"ÚTERO BÍFIDO CON VAGINA TABICADA"
  },
  {
    "codigo":713489006,
    "descripcion":"POLINEUROPATÍA CONCOMITANTE CON INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":1268710000,
    "descripcion":"ADAMANTINOMA PRIMARIO DE HUESO LARGO"
  },
  {
    "codigo":285670000,
    "descripcion":"HERIDA ABIERTA DE LA PIEL DE LA NARIZ"
  },
  {
    "codigo":1079391000119102,
    "descripcion":"NEOPLASIA BENIGNA DE PIEL DE PÁRPADO DERECHO"
  },
  {
    "codigo":56294008,
    "descripcion":"DEPENDENCIA DE NICOTINA"
  },
  {
    "codigo":283835002,
    "descripcion":"MORDEDURA DE ANIMAL EN LA PLANTA DEL PIE"
  },
  {
    "codigo":15988831000119104,
    "descripcion":"CONJUNTIVITIS NEONATAL DE OJO IZQUIERDO CAUSADA POR NEISSERIA GONORRHOEAE"
  },
  {
    "codigo":447675006,
    "descripcion":"CIERRE ESPONTÁNEO DE DEFECTO DE TABIQUE INTERVENTRICULAR DEBIDO A REACCIÓN FIBROMUSCULAR"
  },
  {
    "codigo":87227007,
    "descripcion":"DEPRESIÓN CEREBRAL EN EL RECIÉN NACIDO"
  },
  {
    "codigo":249232003,
    "descripcion":"HALLAZGO RELACIONADO CON EL ESCROTO"
  },
  {
    "codigo":216464004,
    "descripcion":"INTOXICACIÓN ACCIDENTAL CAUSADA POR METADONA"
  },
  {
    "codigo":314768003,
    "descripcion":"SIN CONSENTIMIENTO PARA INMUNIZACIÓN CONTRA DTP"
  },
  {
    "codigo":312933005,
    "descripcion":"NECROSIS RETINIANA EXTERNA PROGRESIVA"
  },
  {
    "codigo":1197669006,
    "descripcion":"PSEUDOQUISTE DE PÁNCREAS DEBIDO A PANCREATITIS AGUDA"
  },
  {
    "codigo":1259535001,
    "descripcion":"CARCINOMA PRIMARIO DE VESÍCULA BILIAR"
  },
  {
    "codigo":409178361000119104,
    "descripcion":"MELANOMA MALIGNO DE PIEL DE REGIÓN DE CODO IZQUIERDO"
  },
  {
    "codigo":702479006,
    "descripcion":"CON ALTO RIESGO DE INFECCIÓN TRANSMITIDA SEXUALMENTE"
  },
  {
    "codigo":407567007,
    "descripcion":"PACIENTE CON TRATAMIENTO ANTIHIPERTENSIVO EN DOSIS MÁXIMA TOLERADA"
  },
  {
    "codigo":471268000,
    "descripcion":"SÍNDROME DE AORTA MEDIA"
  },
  {
    "codigo":897252001,
    "descripcion":"CURVATURA ANORMAL DE FALANGE PROXIMAL DE SEGUNDO DEDO DE PIE"
  },
  {
    "codigo":733412002,
    "descripcion":"LUXACIÓN TRAUMÁTICA DE ARTICULACIÓN ESTERNOCLAVICULAR"
  },
  {
    "codigo":274660003,
    "descripcion":"LENTITUD Y RESPUESTA ESCASA"
  },
  {
    "codigo":241892005,
    "descripcion":"EFECTO TÓXICO CAUSADO POR LUBRICANTE"
  },
  {
    "codigo":12516006,
    "descripcion":"SECRECIÓN NORMAL DE BILIS"
  },
  {
    "codigo":372964005,
    "descripcion":"INFECCIÓN CAUSADA POR PENICILLIUM ROQUEFORTE"
  },
  {
    "codigo":371129000,
    "descripcion":"PARÁLISIS POR TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":43449002,
    "descripcion":"DEFECTO EN LA PROTEÓLISIS DE TIROGLOBULINA"
  },
  {
    "codigo":305593002,
    "descripcion":"BAJO ATENCIÓN DE UN TERAPEUTA ESPECIALISTA EN DANZA"
  },
  {
    "codigo":403897007,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":11784441000119108,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE DEDO MEDIO DE MANO IZQUIERDA"
  },
  {
    "codigo":860814001,
    "descripcion":"NEUROPATÍA AUTONÓMICA SENSITIVA HEREDITARIA TIPO IC"
  },
  {
    "codigo":1155726000,
    "descripcion":"TIEMPO DE TROMBOPLASTINA PARCIAL POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":762510005,
    "descripcion":"TRASTORNO PSICÓTICO CON SÍNTOMAS ESQUIZOFRENIFORMES CAUSADO POR CATINONA SINTÉTICA"
  },
  {
    "codigo":41614006,
    "descripcion":"ANEMIA HIPOPLÁSICA"
  },
  {
    "codigo":7011001,
    "descripcion":"ALUCINACIONES"
  },
  {
    "codigo":72547003,
    "descripcion":"COLITIS DIETÉTICA"
  },
  {
    "codigo":301923006,
    "descripcion":"HALLAZGO RELACIONADO CON MEDICIONES DEL GLOBO OCULAR"
  },
  {
    "codigo":234552000,
    "descripcion":"DEFICIENCIA DE INMUNOGLOBULINA A2"
  },
  {
    "codigo":432995009,
    "descripcion":"TRASTORNO CARDIOVASCULAR FETAL"
  },
  {
    "codigo":365624000,
    "descripcion":"NIVEL DEL ÍNDICE DE COLOR - HALLAZGO"
  },
  {
    "codigo":201784006,
    "descripcion":"ARTRITIS REUMATOIDE DE ARTICULACIÓN METATARSOFALÁNGICA DE SEGUNDO A QUINTO DEDOS"
  },
  {
    "codigo":300088007,
    "descripcion":"PABELLONES AURICULARES ASIMÉTRICOS"
  },
  {
    "codigo":298253002,
    "descripcion":"DOLOR DE ARTICULACIÓN CIGOAPOFISIARIA CERVICAL"
  },
  {
    "codigo":2351000124108,
    "descripcion":"INCISIVO CENTRAL SUPERIOR IZQUIERDO DECIDUO SUPERNUMERARIO"
  },
  {
    "codigo":296418000,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE DIFENHIDRAMINA"
  },
  {
    "codigo":427490006,
    "descripcion":"ANEURISMA DE AORTA SUPRACELÍACA"
  },
  {
    "codigo":67042008,
    "descripcion":"INTENTO FALLIDO DE ABORTO COMPLICADO POR CHOQUE"
  },
  {
    "codigo":65207000,
    "descripcion":"LOCURA"
  },
  {
    "codigo":196279002,
    "descripcion":"HIPOPLASIA DEL ESMALTE DENTAL, NEONATAL"
  },
  {
    "codigo":1081901000119104,
    "descripcion":"CARCINOMA MICROCÍTICO PRIMARIO DE BRONQUIO PRINCIPAL DERECHO"
  },
  {
    "codigo":720567008,
    "descripcion":"SÍNDROME DE BOSLEY SALIH ALORAINY"
  },
  {
    "codigo":292748003,
    "descripcion":"REACCIÓN ADVERSA A CALCIOEDETATO SÓDICO"
  },
  {
    "codigo":784268004,
    "descripcion":"DEFORMIDAD DE LA CADERA EN LIMPIAPARABRISAS"
  },
  {
    "codigo":1144716005,
    "descripcion":"HIPOPLASIA CONGÉNITA DE FALANGE MEDIA DE CUARTO DEDO DE PIE"
  },
  {
    "codigo":28769004,
    "descripcion":"OSTEOMIELITIS DE TOBILLO Y\/O PIE"
  },
  {
    "codigo":344621000119108,
    "descripcion":"DEGENERACIÓN PERIFÉRICA DE CÓRNEAS DE AMBOS OJOS"
  },
  {
    "codigo":1208417009,
    "descripcion":"MIOPATÍA CONGÉNITA POR DESPROPORCIÓN DEL TIPO DE FIBRA AUTOSÓMICA RECESIVA DEBIDA A MUTACIÓN DE TPM3"
  },
  {
    "codigo":94305009,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL PIE"
  },
  {
    "codigo":420150003,
    "descripcion":"MOVIMIENTO OCULAR HACIA ARRIBA LIMITADO"
  },
  {
    "codigo":59702004,
    "descripcion":"ACIDOSIS COMPENSADA"
  },
  {
    "codigo":92470003,
    "descripcion":"NEOPLASIA BENIGNA DEL ÚTERO"
  },
  {
    "codigo":15637191000119103,
    "descripcion":"TENDINITIS CALCIFICANTE DE AMBOS HOMBROS"
  },
  {
    "codigo":289078003,
    "descripcion":"DIFICULTAD PARA CORTAR LOS ALIMENTOS"
  },
  {
    "codigo":190774002,
    "descripcion":"HIPERLIPIDEMIA, GRUPO A"
  },
  {
    "codigo":1237515001,
    "descripcion":"LEUCODISTROFIA DEBIDA A DEFICIENCIA DE CERAMIDASA ALCALINA 3"
  },
  {
    "codigo":254475001,
    "descripcion":"NEOPLASIA BENIGNA DEL ESQUELETO NASAL"
  },
  {
    "codigo":715062005,
    "descripcion":"INFECCIÓN CAUSADA POR OESOPHAGOSTOMUM RADIATUM"
  },
  {
    "codigo":449248000,
    "descripcion":"CARCINOMA NASOFARÍNGEO"
  },
  {
    "codigo":188939008,
    "descripcion":"NEOPLASIA BENIGNA DE HÚMERO"
  },
  {
    "codigo":1137376007,
    "descripcion":"PRURITO DE PARTES BLANDAS BUCALES"
  },
  {
    "codigo":709557000,
    "descripcion":"PERIODONTITIS CONCOMITANTE CON TRASTORNO HEMATOLÓGICO"
  },
  {
    "codigo":416480007,
    "descripcion":"EXTENDIDO CERVICAL - RECONVOCATORIA SUSPENDIDA"
  },
  {
    "codigo":16046791000119107,
    "descripcion":"ENFERMEDAD POR DEPÓSITO DE HIDROXIAPATITA DE PIE DERECHO"
  },
  {
    "codigo":185269006,
    "descripcion":"ATENDIDO EN UN CONSULTORIO DE QUIROPODIA"
  },
  {
    "codigo":283573007,
    "descripcion":"HERIDA DE PERDIGÓN EN TÓRAX"
  },
  {
    "codigo":216202000,
    "descripcion":"LESIÓN POR MAQUINARIA EN AERONAVE, SIN ACCIDENTE DE AERONAVE, TRIPULACIÓN DE AERONAVE COMERCIAL EN TRANSPORTE POR TIERRA Y MAR LESIONADO"
  },
  {
    "codigo":840629008,
    "descripcion":"ÚTERO GRÁVIDO DE TAMAÑO CORRESPONDIENTE A 28-32 SEMANAS"
  },
  {
    "codigo":248970003,
    "descripcion":"HALLAZGO DE LA CANTIDAD DE PÉRDIDA DE SANGRE DURANTE EL PERÍODO MENSTRUAL"
  },
  {
    "codigo":183434005,
    "descripcion":"NIÑO PARA ADOPCIÓN"
  },
  {
    "codigo":1363082006,
    "descripcion":"ASTILLA EN PIERNA"
  },
  {
    "codigo":247135004,
    "descripcion":"LESIÓN MICROVASCULAR RETINAL"
  },
  {
    "codigo":17759006,
    "descripcion":"ESTENOSIS AÓRTICA REUMÁTICA CON INSUFICIENCIA"
  },
  {
    "codigo":1162804003,
    "descripcion":"DEFICIENCIA DE PRECALICREÍNA CONGÉNITA HEREDITARIA"
  },
  {
    "codigo":278068003,
    "descripcion":"VESÍCULA HERPÉTICA EN VAGINA"
  },
  {
    "codigo":833289001,
    "descripcion":"DOLOR A LA PALPACIÓN DE TABAQUERA ANATÓMICA"
  },
  {
    "codigo":210697002,
    "descripcion":"SECCIÓN PARCIAL, TENDÓN ROTULIANO"
  },
  {
    "codigo":866057003,
    "descripcion":"MIELITIS CAUSADA POR VIRUS DENGUE"
  },
  {
    "codigo":472841006,
    "descripcion":"ESTENOSIS DE VÁLVULA TRICÚSPIDE FETAL"
  },
  {
    "codigo":15911931000119102,
    "descripcion":"FRACTURA EXPUESTA DE CABEZA DE FÉMUR IZQUIERDO"
  },
  {
    "codigo":733150001,
    "descripcion":"DIVERTICULITIS DE INTESTINO DELGADO CON PERFORACIÓN Y ABSCESO"
  },
  {
    "codigo":1193737008,
    "descripcion":"ENTERITIS POR MYCOBACTERIUM"
  },
  {
    "codigo":208862005,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA PROXIMAL"
  },
  {
    "codigo":700382007,
    "descripcion":"INESTABILIDAD CRÓNICA DE TOBILLO"
  },
  {
    "codigo":403635000,
    "descripcion":"DERMATOMIOSITIS MEDICAMENTOSA"
  },
  {
    "codigo":305521000119100,
    "descripcion":"CONTRACTURA DE ARTICULACIÓN DE CODO DERECHO"
  },
  {
    "codigo":105841000119101,
    "descripcion":"INMUNIDAD CONTRA SARAMPIÓN DETERMINADA POR SEROLOGÍA"
  },
  {
    "codigo":674161000119102,
    "descripcion":"MONOPLEJÍA DE MIEMBRO SUPERIOR DEBIDA A ACCIDENTE CEREBROVASCULAR ISQUÉMICO Y POSTERIOR A ÉL"
  },
  {
    "codigo":146801000119103,
    "descripcion":"LEIOMIOMA"
  },
  {
    "codigo":237960000,
    "descripcion":"ACIDURIA D-2(OH) GLUTÁRICA"
  },
  {
    "codigo":15747441000119105,
    "descripcion":"MASA DE MÚSCULO DE EXTREMIDAD INFERIOR DERECHA"
  },
  {
    "codigo":828066161000119106,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DEBIDO A TROMBOSIS DE ARTERIA CEREBRAL ANTERIOR DERECHA"
  },
  {
    "codigo":15742321000119107,
    "descripcion":"SÍNDROME DE CONDUCTO DEL TARSO DE TOBILLO DERECHO"
  },
  {
    "codigo":41352000,
    "descripcion":"GRANULOMATOSIS DISCIFORME Y PROGRESIVA"
  },
  {
    "codigo":10973041000119109,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO DIGITAL DE DEDO ÍNDICE IZQUIERDO"
  },
  {
    "codigo":16098161000119109,
    "descripcion":"ARTROFIBROSIS DE CODO DERECHO"
  },
  {
    "codigo":183524721000119106,
    "descripcion":"SENSACIÓN DE CUERPO EXTRAÑO EN OJO IZQUIERDO"
  },
  {
    "codigo":1088881000119108,
    "descripcion":"GRANULACIÓN DE CAVIDAD MASTOIDEA IZQUIERDA"
  },
  {
    "codigo":87921000119104,
    "descripcion":"PARÁLISIS DE NERVIO CRANEAL DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":6749002,
    "descripcion":"EFECTO TÓXICO DEL ALCOHOL PROPÍLICO"
  },
  {
    "codigo":366961000119106,
    "descripcion":"ALBINISMO CONCOMITANTE CON TRASTORNO HEMATOLÓGICO"
  },
  {
    "codigo":21361000119109,
    "descripcion":"NEUROPATÍA PERIFÉRICA PARANEOPLÁSICA"
  },
  {
    "codigo":432733005,
    "descripcion":"ARTROSIS AGUDA DE REGIÓN DE HOMBRO"
  },
  {
    "codigo":203357004,
    "descripcion":"OSTEOARTROPATÍA HIPERTRÓFICA"
  },
  {
    "codigo":236125004,
    "descripcion":"DERMATITIS PERIESTOMAL"
  },
  {
    "codigo":170589001,
    "descripcion":"SIN REGISTRO DE LECTURA DE PRESIÓN ARTERIAL"
  },
  {
    "codigo":347131000119108,
    "descripcion":"ASTIGMATISMO DE AMBOS OJOS"
  },
  {
    "codigo":299826003,
    "descripcion":"REFLEJO TRICIPITAL NORMAL"
  },
  {
    "codigo":1217330004,
    "descripcion":"ALTERACIÓN EN INTEGRIDAD DE MEMBRANA MUCOSA ORAL"
  },
  {
    "codigo":70450006,
    "descripcion":"TEJIDO GÁSTRICO ECTÓPICO"
  },
  {
    "codigo":232455000,
    "descripcion":"TELANGIECTASIA DE CUERDA VOCAL"
  },
  {
    "codigo":267058009,
    "descripcion":"HECES QUE FLOTAN"
  },
  {
    "codigo":365362009,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA USAR UNA TARJETA DE CRÉDITO"
  },
  {
    "codigo":429063000,
    "descripcion":"VIVE EN BUNGALOW"
  },
  {
    "codigo":789511004,
    "descripcion":"PÉRDIDA DE LONGITUD DE ARCADA DENTAL DEBIDA A AUSENCIA CONGÉNITA DE DIENTES"
  },
  {
    "codigo":297991008,
    "descripcion":"PELO AUSENTE"
  },
  {
    "codigo":230620001,
    "descripcion":"SECCIÓN PARCIAL DE NERVIO PERIFÉRICO"
  },
  {
    "codigo":723975009,
    "descripcion":"NÁUSEAS Y VÓMITOS POSTERIORES A ADMINISTRACIÓN DE AGENTE ANESTÉSICO"
  },
  {
    "codigo":165084003,
    "descripcion":"PRUEBA DE TOLERANCIA AL EJERCICIO - ANORMAL"
  },
  {
    "codigo":35847008,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DE MUÑECA"
  },
  {
    "codigo":906902831000119100,
    "descripcion":"PORTADOR DE SÍNDROME DE USHER TIPO 3"
  },
  {
    "codigo":296156009,
    "descripcion":"SOBREDOSIS DE NEUROLÉPTICO"
  },
  {
    "codigo":196017002,
    "descripcion":"NEUMOCONIOSIS ASOCIADA CON TUBERCULOSIS"
  },
  {
    "codigo":66780009,
    "descripcion":"INTOXICACIÓN POR CEFALOTINA"
  },
  {
    "codigo":425393008,
    "descripcion":"PODER NOTARIAL REVOCABLE PARA LA ATENCIÓN MÉDICA"
  },
  {
    "codigo":63110000,
    "descripcion":"EDAD GESTACIONAL, 7 SEMANAS"
  },
  {
    "codigo":784006008,
    "descripcion":"DISPLASIA ESPONDILOMETAFISARIA"
  },
  {
    "codigo":94043000,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA PIEL DEL TRONCO"
  },
  {
    "codigo":292486008,
    "descripcion":"REACCIÓN ADVERSA A LA METOXAMINA"
  },
  {
    "codigo":95878009,
    "descripcion":"INTOXICACIÓN AMNÉSICA POR MARISCOS"
  },
  {
    "codigo":1144454009,
    "descripcion":"APLASIA DE FALANGE PROXIMAL DE DEDO MEÑIQUE"
  },
  {
    "codigo":290651005,
    "descripcion":"INTOXICACIÓN POR ACLARRUBICINA"
  },
  {
    "codigo":716635007,
    "descripcion":"TRASTORNO COGNITIVO DE LA COMUNICACIÓN"
  },
  {
    "codigo":126811007,
    "descripcion":"NEOPLASIA DEL PILAR AMIGDALINO"
  },
  {
    "codigo":288816000,
    "descripcion":"DIFICULTAD PARA IMITAR FORMAS DE COMUNICACIÓN"
  },
  {
    "codigo":92208007,
    "descripcion":"NEOPLASIA BENIGNA DE LA MANDÍBULA"
  },
  {
    "codigo":190512008,
    "descripcion":"SÍNDROME ADRENOGENITAL ADQUIRIDO"
  },
  {
    "codigo":124976009,
    "descripcion":"MUTACIÓN TERMOSENSIBLE"
  },
  {
    "codigo":876805001,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE CADERA CON INFECCIÓN"
  },
  {
    "codigo":57605004,
    "descripcion":"ESTADIO D DE DUKES MODIFICADO"
  },
  {
    "codigo":1237253007,
    "descripcion":"TRASTORNO FETAL DEBIDO A TRANSFUSIÓN MATERNOFETAL"
  },
  {
    "codigo":285146003,
    "descripcion":"HÁBITO DE MORDERSE LOS DEDOS DE LA MANO"
  },
  {
    "codigo":88538005,
    "descripcion":"DEGENERACIÓN CALCÁREA DE LA CÓRNEA"
  },
  {
    "codigo":186842007,
    "descripcion":"OCULOPATÍA SIFILÍTICA CONGÉNITA TARDÍA"
  },
  {
    "codigo":448986008,
    "descripcion":"NEOPLASIA BENIGNA DE PARTES BLANDAS DE LA MANDÍBULA"
  },
  {
    "codigo":185007003,
    "descripcion":"FORMULARIO DE SEGURO RECIBIDO"
  },
  {
    "codigo":283311004,
    "descripcion":"ASTILLA DE MADERA EN LA ESPINILLA"
  },
  {
    "codigo":250543008,
    "descripcion":"ESFINGOMIELINA DETECTADA EN LÍQUIDO AMNIÓTICO"
  },
  {
    "codigo":707460002,
    "descripcion":"CARCINOMA PSEUDOSARCOMATOSO PRIMARIO DE PULMÓN"
  },
  {
    "codigo":248708004,
    "descripcion":"VASO SANGUÍNEO FRÁGIL"
  },
  {
    "codigo":281476006,
    "descripcion":"DEFORMIDAD EN FLEXIÓN FIJA ADQUIRIDA DE ARTICULACIÓN DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":323171000119101,
    "descripcion":"ARTROSIS DE CADERA DERECHA DEBIDA A DISPLASIA"
  },
  {
    "codigo":115801005,
    "descripcion":"FENOTIPO M^K^M^K^"
  },
  {
    "codigo":246873009,
    "descripcion":"QUERATINIZACIÓN DE LÍNEA INTERMARGINAL"
  },
  {
    "codigo":15662003,
    "descripcion":"DEMENCIA SENIL"
  },
  {
    "codigo":212270005,
    "descripcion":"LESIÓN TRAUMÁTICA CERRADA DE NERVIO RADIAL"
  },
  {
    "codigo":441646007,
    "descripcion":"PORTADOR DE MUTACIÓN GENÉTICA DE ENFERMEDAD DE TAY SACHS"
  },
  {
    "codigo":439811001,
    "descripcion":"ATENDIDO POR TRIPULACIÓN DE AMBULANCIA"
  },
  {
    "codigo":208600002,
    "descripcion":"FRACTURA NO EXPUESTA VERTICAL DE RÓTULA"
  },
  {
    "codigo":77528005,
    "descripcion":"COLELITIASIS CON OBSTRUCCIÓN"
  },
  {
    "codigo":763821001,
    "descripcion":"SÍNDROME DE PORENCEFALIA, HIPOPLASIA DE CEREBELO Y MALFORMACIONES INTERNAS"
  },
  {
    "codigo":370605002,
    "descripcion":"COLLAR EPIDÉRMICO"
  },
  {
    "codigo":42925002,
    "descripcion":"TRASTORNO DEPRESIVO MAYOR, UN SOLO EPISODIO CON SÍNTOMAS ATÍPICOS"
  },
  {
    "codigo":1255341004,
    "descripcion":"FRACTURA CONMINUTA NO EXPUESTA DE FALANGE DE DEDO DE MANO"
  },
  {
    "codigo":698285005,
    "descripcion":"MELANOMA MALIGNO DE SENO ETMOIDAL"
  },
  {
    "codigo":139394000,
    "descripcion":"NOCTURIA"
  },
  {
    "codigo":403373008,
    "descripcion":"MILIARIA APOCRINA DE VULVA"
  },
  {
    "codigo":237698002,
    "descripcion":"HIPOPITUITARISMO IATROGÉNICO"
  },
  {
    "codigo":203095000,
    "descripcion":"ESPASMO DE LOS MÚSCULOS DEL DORSO"
  },
  {
    "codigo":235863003,
    "descripcion":"HEPATITIS GONOCÓCICA"
  },
  {
    "codigo":1153367006,
    "descripcion":"NEOPLASIA OSTEOGÉNICA BENIGNA DE HUESO"
  },
  {
    "codigo":301399007,
    "descripcion":"DOLOR MUSCULOESQUELÉTICO A LA PALPACIÓN"
  },
  {
    "codigo":234028003,
    "descripcion":"SÍNDROME DE ROBO ARTERIAL CEREBRAL"
  },
  {
    "codigo":679831000119100,
    "descripcion":"SUBLUXACIÓN ANTERIOR DE CRISTALINO DERECHO"
  },
  {
    "codigo":102956007,
    "descripcion":"RELACIÓN SEXUAL NO CONSUMADA"
  },
  {
    "codigo":299564008,
    "descripcion":"CLIC DE MULDER AUSENTE"
  },
  {
    "codigo":1217068008,
    "descripcion":"DIABETES MELLITUS TIPO 1 FULMINANTE"
  },
  {
    "codigo":365100009,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA ENTRAR EN LA DUCHA"
  },
  {
    "codigo":397868007,
    "descripcion":"COLEDOCOCELE"
  },
  {
    "codigo":35585004,
    "descripcion":"ENDOMETRITIS TUBERCULOSA"
  },
  {
    "codigo":363265005,
    "descripcion":"INMUNODEFICIENCIA HUMORAL PREDOMINANTE"
  },
  {
    "codigo":352151000119102,
    "descripcion":"MELANOMA MALIGNO DE PIEL DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":199425009,
    "descripcion":"DESPROPORCIÓN HIDROCEFÁLICA"
  },
  {
    "codigo":263126002,
    "descripcion":"LESIÓN DE LIGAMENTOS"
  },
  {
    "codigo":721878003,
    "descripcion":"MICROFTALMÍA CON ANOMALÍA CEREBRAL Y DIGITAL"
  },
  {
    "codigo":787414001,
    "descripcion":"OLIGODONCIA"
  },
  {
    "codigo":295894000,
    "descripcion":"SOBREDOSIS DE IPRONIAZIDA"
  },
  {
    "codigo":197590001,
    "descripcion":"SÍNDROME NEFRÓTICO CON GLOMERULONEFRITIS MEMBRANOSA"
  },
  {
    "codigo":230358007,
    "descripcion":"ENCEFALOPATÍA HIPONATRÉMICA"
  },
  {
    "codigo":425131000,
    "descripcion":"TENSIÓN NERVIOSA"
  },
  {
    "codigo":228523000,
    "descripcion":"EXPUESTO AL TABACO EN EL TRABAJO"
  },
  {
    "codigo":294059003,
    "descripcion":"ALERGIA A LOFEXIDINA"
  },
  {
    "codigo":31915006,
    "descripcion":"DESVIACIÓN CONGÉNITA DE URÉTER"
  },
  {
    "codigo":95616002,
    "descripcion":"ATAQUE APNEICO NEONATAL"
  },
  {
    "codigo":30080002,
    "descripcion":"IRIDOCICLITIS SIFILÍTICA SECUNDARIA"
  },
  {
    "codigo":423296004,
    "descripcion":"HALLAZGO RELACIONADO CON LA RESPUESTA A ESTÍMULOS VISUALES"
  },
  {
    "codigo":292224006,
    "descripcion":"REACCIÓN ADVERSA A LA DOXORUBICINA"
  },
  {
    "codigo":10755991000119107,
    "descripcion":"SOPLO CARDÍACO POSPARTO"
  },
  {
    "codigo":126549004,
    "descripcion":"NEOPLASIA DEL VÓMER"
  },
  {
    "codigo":192085004,
    "descripcion":"REACCIÓN DE IRA"
  },
  {
    "codigo":93781006,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE ENDOMETRIO"
  },
  {
    "codigo":11794481000119102,
    "descripcion":"LACERACIÓN DE MÚSCULO PECTORAL DERECHO"
  },
  {
    "codigo":124714006,
    "descripcion":"DEFICIENCIA DE GMP SINTASA (HIDROLIZANTE DE GLUTAMINA)"
  },
  {
    "codigo":59178007,
    "descripcion":"ENFERMEDAD DE MENKES DEL PELO ENCRESPADO"
  },
  {
    "codigo":91946007,
    "descripcion":"AUSENCIA CONGÉNITA DE LA BOCA"
  },
  {
    "codigo":1236991005,
    "descripcion":"INFLAMACIÓN DE MARGEN LIBRE ANTERIOR DE PÁRPADO INFERIOR"
  },
  {
    "codigo":286719009,
    "descripcion":"RASGO DE LA PERSONALIDAD: NIVEL DE SOCIABILIDAD - HALLAZGO"
  },
  {
    "codigo":448724001,
    "descripcion":"ANEURISMA DE SENO DE VALSALVA AÓRTICO CON RUPTURA EN VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":284884001,
    "descripcion":"SE CORTA LAS UÑAS DE LAS MANOS"
  },
  {
    "codigo":184745004,
    "descripcion":"CERTIFICADO DE ENFERMEDAD PRIVADO, CON CARGO"
  },
  {
    "codigo":283049005,
    "descripcion":"ABRASIÓN DE CABEZA"
  },
  {
    "codigo":250281004,
    "descripcion":"VACUOLIZACIÓN CITOPLASMÁTICA"
  },
  {
    "codigo":445054000,
    "descripcion":"EDEMA BLANDO SIN FÓVEA"
  },
  {
    "codigo":1264254001,
    "descripcion":"ANQUILOSIS DE ARTICULACIÓN INCUDOMALEOLAR"
  },
  {
    "codigo":1297022001,
    "descripcion":"CIERRE DE ÁNGULO DE OJO DERECHO DEBIDO A SÍNDROME ENDOTELIAL IRIDOCORNEAL"
  },
  {
    "codigo":248446005,
    "descripcion":"FIEBRE DIURNA INVERSA"
  },
  {
    "codigo":707198008,
    "descripcion":"SENO CORONARIO INTACTO"
  },
  {
    "codigo":17235000,
    "descripcion":"ESFEROCITOSIS"
  },
  {
    "codigo":246611002,
    "descripcion":"COMPRESIÓN DE NERVIO MEDIANO"
  },
  {
    "codigo":1196883002,
    "descripcion":"MESOTELIOMA PLEURAL MALIGNO EPITELIOIDE PRIMARIO"
  },
  {
    "codigo":15400003,
    "descripcion":"EMBOLIA GASEOSA OBSTÉTRICA"
  },
  {
    "codigo":80936003,
    "descripcion":"ALESQUERIOSIS"
  },
  {
    "codigo":1162280003,
    "descripcion":"RABDOMIOSARCOMA PRIMARIO DEL ISTMO DEL CUERPO UTERINO"
  },
  {
    "codigo":212008006,
    "descripcion":"QUEMADURA DE TERCER GRADO POR AGENTE CORROSIVO DE CADERA Y EXTREMIDAD INFERIOR, EXCEPTO TOBILLO Y PIE"
  },
  {
    "codigo":703528008,
    "descripcion":"SÍNDROME DE CUTIS GYRATA DE BEARE-STEVENSON"
  },
  {
    "codigo":472317002,
    "descripcion":"MIOCARDIOPATÍA MITOCONDRIAL HISTIOCITOIDE"
  },
  {
    "codigo":699858001,
    "descripcion":"INFECCIÓN DE ESPACIO INFRAORBITARIO"
  },
  {
    "codigo":11730002,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DE LA CADERA"
  },
  {
    "codigo":682341000119103,
    "descripcion":"ANGIOSARCOMA PRIMARIO DE REGIÓN INGUINAL"
  },
  {
    "codigo":110034006,
    "descripcion":"LACERACIÓN PERIORBITARIA COMPLEJA"
  },
  {
    "codigo":75431008,
    "descripcion":"SOPLO CARDÍACO ORGÁNICO"
  },
  {
    "codigo":403111009,
    "descripcion":"ESPOROTRICOSIS CUTÁNEA FIJA"
  },
  {
    "codigo":302972002,
    "descripcion":"REACCIÓN URTICARIANA POSTRANSFUSIONAL"
  },
  {
    "codigo":268369000,
    "descripcion":"PRUEBA URINARIA ESPECIAL NORMAL"
  },
  {
    "codigo":366673000,
    "descripcion":"AMPLITUD DE MOVIMIENTO DE ARTICULACIÓN DE DEDO DE LA MANO - HALLAZGO"
  },
  {
    "codigo":170065000,
    "descripcion":"PERÍMETRO CEFÁLICO DEL NIÑO = PERCENTILOS 25 A 49"
  },
  {
    "codigo":202833003,
    "descripcion":"REUMATISMO, EXCLUIDA LA REGIÓN DORSAL"
  },
  {
    "codigo":301137001,
    "descripcion":"LATIDO DEL VÉRTICE DE CARACTERÍSTICA NORMAL"
  },
  {
    "codigo":1251409003,
    "descripcion":"DERMATITIS ECCEMATOSA ATÓPICA NUMULAR EN LA INFANCIA"
  },
  {
    "codigo":235601001,
    "descripcion":"ESOFAGITIS BACTERIANA"
  },
  {
    "codigo":38993008,
    "descripcion":"SÍNDROME TRICO-DENTO-ÓSEO"
  },
  {
    "codigo":233766001,
    "descripcion":"HIPOXIA ASOCIADA A DIÁLISIS"
  },
  {
    "codigo":364838001,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA SUBIR UNA COLINA CORRIENDO"
  },
  {
    "codigo":725286002,
    "descripcion":"DEFICIENCIA DE 3-HIDROXI-3-METILGLUTARIL-COENZIMA A SINTASA"
  },
  {
    "codigo":4390004,
    "descripcion":"NEFROPATÍA POR LITIO"
  },
  {
    "codigo":723451000,
    "descripcion":"SÍNDROME DE PELO RETORCIDO Y ONICODISPLASIA"
  },
  {
    "codigo":231931001,
    "descripcion":"DISTROFIA DEL ESTROMA CORNEAL"
  },
  {
    "codigo":168230009,
    "descripcion":"NO SE OBSERVARON MICROORGANISMOS POR MICROSCOPIA DIRECTA EN ESPÉCIMEN"
  },
  {
    "codigo":299302008,
    "descripcion":"AMPLITUD DE ROTACIÓN EXTERNA PASIVA DE ARTICULACIÓN DE CADERA, NORMAL"
  },
  {
    "codigo":428539005,
    "descripcion":"DISTENSIÓN DE TRÍCEPS BRAQUIAL"
  },
  {
    "codigo":35323005,
    "descripcion":"ATROFIA SEGMENTARIA DEL IRIS"
  },
  {
    "codigo":788987008,
    "descripcion":"ENTEROCOLITIS NECROSANTE DEL RECIÉN NACIDO, ESTADIO 1B DE LA CLASIFICACIÓN DE BELL"
  },
  {
    "codigo":197328001,
    "descripcion":"ABSCESO HEPÁTICO A TRAVÉS DE ARTERIA HEPÁTICA"
  },
  {
    "codigo":426704002,
    "descripcion":"VARIABILIDAD MODERADA DE LA FRECUENCIA CARDÍACA FETAL"
  },
  {
    "codigo":295632002,
    "descripcion":"SOBREDOSIS DE MELFALÁN"
  },
  {
    "codigo":721616005,
    "descripcion":"GINGIVITIS ULCEROSA NECROSANTE CRÓNICA"
  },
  {
    "codigo":262864009,
    "descripcion":"LESIÓN DE CIEGO"
  },
  {
    "codigo":457637004,
    "descripcion":"TROMBOSIS DE VÁLVULA MITRAL"
  },
  {
    "codigo":717946000,
    "descripcion":"ANEMIA MEGALOBLÁSTICA DEBIDA A DEFICIENCIA DE VITAMINA B12 SECUNDARIA A ENFERMEDAD INTESTINAL"
  },
  {
    "codigo":29818001,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN METACARPOFALÁNGICA DE DEDO DE LA MANO"
  },
  {
    "codigo":95354006,
    "descripcion":"VESÍCULA MUCOSA"
  },
  {
    "codigo":153941000119100,
    "descripcion":"INSUFICIENCIA CARDÍACA SISTÓLICA Y DIASTÓLICA COMBINADA CRÓNICA"
  },
  {
    "codigo":716111003,
    "descripcion":"SÍNDROME DE ANOMALÍAS DE LOS CONDUCTOS DE MÜLLER Y DE LOS MIEMBROS"
  },
  {
    "codigo":1142095003,
    "descripcion":"SÍFILIS CONGÉNITA TARDÍA DE SISTEMA CARDIOVASCULAR"
  },
  {
    "codigo":1304100004,
    "descripcion":"NEOVASCULARIZACIÓN DE ÁNGULO IRIDOCORNEAL DE AMBOS OJOS"
  },
  {
    "codigo":124452006,
    "descripcion":"DEFICIENCIA DE ALFA - AMILASA"
  },
  {
    "codigo":24313004,
    "descripcion":"INTOXICACIÓN POR SALSOLA"
  },
  {
    "codigo":286457005,
    "descripcion":"DIFICULTAD PARA PREPARAR ALIMENTO PARA COMER"
  },
  {
    "codigo":1269497006,
    "descripcion":"ÁCIDO DESOXIRRIBONUCLEICO DE VIRUS PAPILOMA HUMANO DE ALTO RIESGO DETECTADO"
  },
  {
    "codigo":253689007,
    "descripcion":"ARTERIA COLATERAL AORTOPULMONAR PRINCIPAL"
  },
  {
    "codigo":1169358003,
    "descripcion":"SÍNDROME DE NEURONAS MULTINUCLEADAS, ANHIDRAMNIOS, DISPLASIA RENAL, HIPOPLASIA CEREBELOSA E HIDRANENCEFALIA"
  },
  {
    "codigo":15702681000119109,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE TENDÓN EXTENSOR DE REGIÓN DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":186318004,
    "descripcion":"ENDOCARDITIS LISTÉRICA"
  },
  {
    "codigo":118947000,
    "descripcion":"TRASTORNO DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":282787000,
    "descripcion":"SÍNDROME DE CORDÓN ESPINAL CENTRAL"
  },
  {
    "codigo":250019003,
    "descripcion":"MARCHA CON LOS DEDOS DEL PIE HACIA ADENTRO"
  },
  {
    "codigo":315555004,
    "descripcion":"NACIDO EN UZBEKISTÁN"
  },
  {
    "codigo":444792001,
    "descripcion":"INESTABILIDAD DE ARTICULACIÓN DE PELVIS"
  },
  {
    "codigo":1003683009,
    "descripcion":"CLASIFICACIÓN DE INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA DE LOS CENTROS PARA EL CONTROL Y PREVENCIÓN DE ENFERMEDADES ETAPA 2"
  },
  {
    "codigo":15649741000119100,
    "descripcion":"ANEURISMA DE ARTERIA BRAQUIAL DERECHA"
  },
  {
    "codigo":117112009,
    "descripcion":"ESTADO DE UNA UNIDAD DE HEMODERIVADO"
  },
  {
    "codigo":248184009,
    "descripcion":"CARA ABOTAGADA"
  },
  {
    "codigo":16973004,
    "descripcion":"COJERA"
  },
  {
    "codigo":1260322001,
    "descripcion":"ENFERMEDAD DE SUSTANCIA BLANCA DEBIDA A MICROGLIOMA"
  },
  {
    "codigo":703266007,
    "descripcion":"SÍNDROME METAMÉRICO ARTERIOVENOSO CEREBROFACIAL"
  },
  {
    "codigo":47906008,
    "descripcion":"GLUTATIONEMIA"
  },
  {
    "codigo":111607004,
    "descripcion":"FRACTURA EXPUESTA DE LA BASE DEL CRÁNEO CON LESIÓN TRAUMÁTICA INTRACRANEAL"
  },
  {
    "codigo":404684003,
    "descripcion":"HALLAZGO CLÍNICO"
  },
  {
    "codigo":11468004,
    "descripcion":"EDEMA POSOPERATORIO DE PULMÓN"
  },
  {
    "codigo":240844004,
    "descripcion":"LINFADENOPATÍA POR LOA LOA"
  },
  {
    "codigo":16032871000119100,
    "descripcion":"NECROSIS AVASCULAR DE CÓNDILO EXTERNO DE AMBOS FÉMURES"
  },
  {
    "codigo":109772007,
    "descripcion":"ERITEMA DE MUCOSA DE VESTÍBULO DE BOCA"
  },
  {
    "codigo":306380004,
    "descripcion":"VISTO POR EL SERVICIO DE CIRUGÍA TORÁCICA"
  },
  {
    "codigo":10816461000119106,
    "descripcion":"FRACTURA EXPUESTA DE FALANGE DE DEDO MEÑIQUE DERECHO"
  },
  {
    "codigo":304545002,
    "descripcion":"ADENOCARCINOMA DE ÍLEON"
  },
  {
    "codigo":140391000119101,
    "descripcion":"ÚLCERA DE DEDO DE PIE DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":402849004,
    "descripcion":"PÚRPURA POR PRESIÓN INTRAVASCULAR AUMENTADA"
  },
  {
    "codigo":206241005,
    "descripcion":"LESIÓN OCULAR POR TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":9633006,
    "descripcion":"QUERATOPATÍA COLICUATIVA DISCRETA"
  },
  {
    "codigo":75169006,
    "descripcion":"INFECCIÓN CAUSADA POR OESOPHAGOSTOMUM APIOSTOMUM"
  },
  {
    "codigo":271777008,
    "descripcion":"PIOSPERMIA"
  },
  {
    "codigo":239009008,
    "descripcion":"DISPLASIA ECTODÉRMICA DE ROSELLI-GULINETTI"
  },
  {
    "codigo":106102002,
    "descripcion":"PRODUCTO URINARIO ANORMAL"
  },
  {
    "codigo":431947002,
    "descripcion":"LESIÓN DE SACRO DEBIDA A TRAUMATISMO"
  },
  {
    "codigo":366411004,
    "descripcion":"AMPLITUD DEL MOVIMIENTO ACTIVO DE EXTENSIÓN DE LA COLUMNA DORSAL - HALLAZGO"
  },
  {
    "codigo":300875005,
    "descripcion":"TUMEFACCIÓN DE ESTRUCTURA RESPIRATORIA"
  },
  {
    "codigo":5963005,
    "descripcion":"ENFERMEDAD DE GAUCHER NEURONOPÁTICA SUBAGUDA"
  },
  {
    "codigo":266272001,
    "descripcion":"VENA VARICOSA DE VULVA DE CAUSA NO OBSTÉTRICA"
  },
  {
    "codigo":167968003,
    "descripcion":"MICROSCOPIA DE LÍQUIDO PLEURAL - NO SE DETECTARON ANOMALÍAS"
  },
  {
    "codigo":299040003,
    "descripcion":"MANOS SIMÉTRICAS"
  },
  {
    "codigo":69664005,
    "descripcion":"TEJIDO NOTOCORDAL HETEROTÓPICO"
  },
  {
    "codigo":15678721000119100,
    "descripcion":"IRIDOCICLITIS BILATERAL POR VIRUS DEL HERPES SIMPLE HUMANO"
  },
  {
    "codigo":723189000,
    "descripcion":"INSUFICIENCIA RENAL AGUDA"
  },
  {
    "codigo":198901003,
    "descripcion":"FETO MACERADO"
  },
  {
    "codigo":16907521000119101,
    "descripcion":"ECTROPIÓN PARALÍTICO DE PÁRPADO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":687361000119101,
    "descripcion":"OLIGODENDROGLIOMA PRIMARIO DE LÓBULO TEMPORAL"
  },
  {
    "codigo":721354001,
    "descripcion":"LUXACIÓN TRAUMÁTICA COMPLETA DE ARTICULACIÓN ATLANTOAXOIDEA"
  },
  {
    "codigo":1145503000,
    "descripcion":"HIPOPLASIA DE FALANGE DISTAL DE MANO"
  },
  {
    "codigo":262602008,
    "descripcion":"CUERPO EXTRAÑO EN MUCOSA BUCAL"
  },
  {
    "codigo":162463006,
    "descripcion":"SÍNTOMA QUE COMENZÓ ABRUPTAMENTE"
  },
  {
    "codigo":293535006,
    "descripcion":"REACCIÓN ADVERSA A FLOSEQUINÁN"
  },
  {
    "codigo":719519007,
    "descripcion":"SÍNDROME DE EXOFTALMÍA BENIGNA"
  },
  {
    "codigo":95092002,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE PARTES BLANDAS DE NALGA"
  },
  {
    "codigo":160628002,
    "descripcion":"INTENSIDAD DE EJERCICIO FÍSICO"
  },
  {
    "codigo":226164007,
    "descripcion":"DIETA CON MUY BAJO CONTENIDO EN SODIO"
  },
  {
    "codigo":1141833007,
    "descripcion":"SÍNTOMA NEUROLÓGICO BULBAR"
  },
  {
    "codigo":715849007,
    "descripcion":"INFECCIÓN CAUSADA POR CRYPTOCOCCUS GATTI"
  },
  {
    "codigo":333211000119102,
    "descripcion":"COROIDITIS DISEMINADA PERIFÉRICA DE OJO DERECHO"
  },
  {
    "codigo":124190008,
    "descripcion":"DEFICIENCIA DE MONODEHIDROASCORBATO REDUCTASA (NADH)"
  },
  {
    "codigo":253427003,
    "descripcion":"ANOMALÍA DE VÁLVULA AURICULOVENTRICULAR (NO MITRAL, NO TRICÚSPIDE)"
  },
  {
    "codigo":1269235004,
    "descripcion":"HALITOSIS EXTRAORAL AUTOSÓMICA RECESIVA"
  },
  {
    "codigo":56819008,
    "descripcion":"ENDOCARDITIS"
  },
  {
    "codigo":1003421003,
    "descripcion":"QUISTE VITELINO INTRABDOMINAL"
  },
  {
    "codigo":446365006,
    "descripcion":"LACERACIÓN PROFUNDA DE CADERA"
  },
  {
    "codigo":282525008,
    "descripcion":"INCAPAZ DE SUBIR ESCALERAS CORRIENDO"
  },
  {
    "codigo":249757009,
    "descripcion":"DESVIACIÓN CUBITAL DE LA MANO"
  },
  {
    "codigo":18546004,
    "descripcion":"ESTENOSIS CONGÉNITA DE VÁLVULA AÓRTICA"
  },
  {
    "codigo":1362034006,
    "descripcion":"ATRAPAMIENTO DE MÚSCULO RECTO EXTERNO"
  },
  {
    "codigo":247922007,
    "descripcion":"MOVIMIENTO DE ALETEO DE LAS MANOS"
  },
  {
    "codigo":16711001,
    "descripcion":"DERRAME ARTICULAR DE LA MANO"
  },
  {
    "codigo":278855005,
    "descripcion":"DEGENERACIÓN DEL LÓBULO FRONTAL"
  },
  {
    "codigo":703004001,
    "descripcion":"VIBRIO FLUVIALIS O VIBRIO FURNISSII"
  },
  {
    "codigo":1260060002,
    "descripcion":"ADENOCARCINOMA MUCINOSO DE TRÁQUEA"
  },
  {
    "codigo":737607009,
    "descripcion":"BURSITIS INFRARROTULIANA DE RODILLA IZQUIERDA"
  },
  {
    "codigo":15953461000119106,
    "descripcion":"INVERSIÓN DE PEZÓN DERECHO"
  },
  {
    "codigo":735772007,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE REGIÓN LUMBAR"
  },
  {
    "codigo":209649002,
    "descripcion":"DESGARRO COMPLETO DE LIGAMENTO DE CARTÍLAGO COSTAL"
  },
  {
    "codigo":766705006,
    "descripcion":"INMUNODEFICIENCIA DEBIDA A DEFICIENCIA DE FICOLINA 3"
  },
  {
    "codigo":111345006,
    "descripcion":"HIPERTROFIA GINGIVAL CAUSADA POR DIFENILHIDANTOÍNA"
  },
  {
    "codigo":16698581000119101,
    "descripcion":"QUISTE DE AMBOS OVARIOS DURANTE EMBARAZO"
  },
  {
    "codigo":371654001,
    "descripcion":"CUERPO NO RECLAMADO"
  },
  {
    "codigo":240582004,
    "descripcion":"SINOVITIS GONOCÓCICA"
  },
  {
    "codigo":109510005,
    "descripcion":"DIENTE PARCIALMENTE IMPACTADO EN HUESO"
  },
  {
    "codigo":10684111000119103,
    "descripcion":"NÓDULO DEL TEJIDO CELULAR SUBCUTÁNEO DE LA PIERNA IZQUIERDA"
  },
  {
    "codigo":116431000119103,
    "descripcion":"POLIARTRITIS INFECCIOSA CAUSADA POR BACTERIAS"
  },
  {
    "codigo":764870008,
    "descripcion":"PROCEDIMIENTO QUIRÚRGICO CANCELADO ANTES DE LA INDUCCIÓN DE LA ANESTESIA"
  },
  {
    "codigo":76742009,
    "descripcion":"METRORRAGIA POSTMENOPÁUSICA"
  },
  {
    "codigo":402587003,
    "descripcion":"DERMATITIS OCUPACIONAL"
  },
  {
    "codigo":1187184001,
    "descripcion":"PRESIÓN PARCIAL DE DIÓXIDO DE CARBONO ARTERIAL POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":689871000119106,
    "descripcion":"CARCINOMA PRIMARIO INDIFERENCIADO DE PARED ANTERIOR DE NASOFARINGE"
  },
  {
    "codigo":5701003,
    "descripcion":"LINFOMA ESTADIO IIE"
  },
  {
    "codigo":235077004,
    "descripcion":"FALLA DE LA PRÓTESIS DENTAL"
  },
  {
    "codigo":202309004,
    "descripcion":"ANQUILOSIS DE LA ARTICULACIÓN RADIOCUBITAL INFERIOR"
  },
  {
    "codigo":366149007,
    "descripcion":"VOLUMEN PULMONAR DINÁMICO - HALLAZGO"
  },
  {
    "codigo":300613008,
    "descripcion":"CAPAZ DE TRASLADARSE A PIE"
  },
  {
    "codigo":890437007,
    "descripcion":"CONDRODISPLASIA PUNCTATA DEBIDA A ENFERMEDAD AUTOINMUNITARIA MATERNA"
  },
  {
    "codigo":298778002,
    "descripcion":"AMPLITUD DE FLEXIÓN ACTIVA DE HOMBRO DISMINUIDA"
  },
  {
    "codigo":724762006,
    "descripcion":"PARKINSONISMO DEBIDO A TRAUMATISMO CEFÁLICO Y DEBIDO A ÉL"
  },
  {
    "codigo":296943003,
    "descripcion":"SOBREDOSIS DE COMPUESTOS YODADOS"
  },
  {
    "codigo":1148911004,
    "descripcion":"ARTROPATÍA GOTOSA DEBIDA A DREPANOCITOSIS HETEROCIGÓTICA DOBLE"
  },
  {
    "codigo":428015005,
    "descripcion":"INFECCIÓN DE ESTRUCTURA GENITAL POR CHLAMYDIA TRACHOMATIS"
  },
  {
    "codigo":1279983005,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE DEDO GORDO CON INFECCIÓN"
  },
  {
    "codigo":722927007,
    "descripcion":"HIPERGLUCEMIA NEONATAL DEBIDA A DEFICIENCIA DE INSULINA"
  },
  {
    "codigo":1343684004,
    "descripcion":"ALTERACIÓN CRÓNICA DE ASTA ANTERIOR DE MENISCO EXTERNO DE RODILLA IZQUIERDA"
  },
  {
    "codigo":721092005,
    "descripcion":"SÍNDROME DE MALFORMACIÓN DEL DESARROLLO, SORDERA Y DISTONÍA"
  },
  {
    "codigo":295108008,
    "descripcion":"ALERGIA A ESTREPTOQUINASA"
  },
  {
    "codigo":8041000119108,
    "descripcion":"ARCO JUVENIL CONGÉNITO"
  },
  {
    "codigo":1145241008,
    "descripcion":"DESPLAZAMIENTO DE DISCO INTERVERTEBRAL"
  },
  {
    "codigo":719257008,
    "descripcion":"LATOSTEROLOSIS"
  },
  {
    "codigo":225902002,
    "descripcion":"INCAPAZ DE CONTROLAR LA CONDUCTA"
  },
  {
    "codigo":291438003,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR IDOXURIDINA"
  },
  {
    "codigo":193134004,
    "descripcion":"COMPRESIÓN DE NERVIO CUBITAL A NIVEL DE LA MUÑECA"
  },
  {
    "codigo":94830004,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LAS VÍAS BILIARES EXTRAHEPÁTICAS"
  },
  {
    "codigo":420675003,
    "descripcion":"PARÁLISIS SUPRANUCLEAR DE LA MIRADA"
  },
  {
    "codigo":1010499003,
    "descripcion":"AGENESIA DE HUESO METACARPIANO Y DEDO [COMO UN TODO]"
  },
  {
    "codigo":92995005,
    "descripcion":"ANOMALÍA CONGÉNITA DE HUESO BASIOCCIPITAL"
  },
  {
    "codigo":386072000,
    "descripcion":"DEFICIENCIA DE VITAMINA D3"
  },
  {
    "codigo":289603009,
    "descripcion":"HALLAZGO RELACIONADO CON DISPOSITIVO EN VAGINA"
  },
  {
    "codigo":123928002,
    "descripcion":"INTOXICACIÓN POR MELIANTHACEAE"
  },
  {
    "codigo":58392004,
    "descripcion":"OSTEOCONDRITIS SIFILÍTICA CONGÉNITA"
  },
  {
    "codigo":255000005,
    "descripcion":"NEUROFIBROMA DE ÓRBITA"
  },
  {
    "codigo":56557000,
    "descripcion":"FIBROSITIS"
  },
  {
    "codigo":449773001,
    "descripcion":"GLOSITIS INTERSTICIAL"
  },
  {
    "codigo":1172504008,
    "descripcion":"GLUCAGÓN DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":253165001,
    "descripcion":"QUISTE ARACNOIDEO ESPINAL EXTRADURAL"
  },
  {
    "codigo":285933007,
    "descripcion":"DIFICULTAD PARA VACIAR LA BAÑERA"
  },
  {
    "codigo":21954000,
    "descripcion":"HERPES ZÓSTER AURICULAR"
  },
  {
    "codigo":251330002,
    "descripcion":"CARIES ACTIVA"
  },
  {
    "codigo":447938004,
    "descripcion":"ANOMALÍA CONGÉNITA DE VENA CARDÍACA"
  },
  {
    "codigo":284098005,
    "descripcion":"NO TREPA"
  },
  {
    "codigo":52887000,
    "descripcion":"TEMBLOR SATURNINO"
  },
  {
    "codigo":249495000,
    "descripcion":"DESEO CONSTANTE DE DEGLUTIR"
  },
  {
    "codigo":1263468000,
    "descripcion":"NEOPLASIA MALIGNA DE PARTES BLANDAS DE PIE"
  },
  {
    "codigo":280428001,
    "descripcion":"SÍNTOMAS PSICÓTICOS AUSENTES"
  },
  {
    "codigo":737345002,
    "descripcion":"INFECCIÓN DE INTESTINO GRUESO"
  },
  {
    "codigo":409665004,
    "descripcion":"NEUMONÍA CAUSADA POR BACTERIAS AERÓBICAS"
  },
  {
    "codigo":278593007,
    "descripcion":"OBTURACIÓN DENTAL: SUPERFICIE ÁSPERA"
  },
  {
    "codigo":442433009,
    "descripcion":"ANASARCA"
  },
  {
    "codigo":1259798003,
    "descripcion":"OLIGODENDROGLIOMA PRIMARIO DE TELENCÉFALO"
  },
  {
    "codigo":47382004,
    "descripcion":"DERMATOFITOSIS"
  },
  {
    "codigo":1075511000119103,
    "descripcion":"HIPERLAXITUD ARTICULAR DE PIE DERECHO"
  },
  {
    "codigo":735510005,
    "descripcion":"QUEMADURA COMPLEJA DE MUÑECA"
  },
  {
    "codigo":309526009,
    "descripcion":"MASA EN LA MANO"
  },
  {
    "codigo":12779007,
    "descripcion":"ULCERACIÓN TRAUMÁTICA DE LA LENGUA"
  },
  {
    "codigo":307691008,
    "descripcion":"BAMBOLEO OCULAR INVERSO"
  },
  {
    "codigo":109248001,
    "descripcion":"INFLAMACIÓN RELACIONADA CON LA PERFORACIÓN VOLUNTARIA DE ALGUNA PARTE DEL CUERPO PARA INSERTAR PENDIENTES, AROS U OTROS ORNAMENTOS"
  },
  {
    "codigo":305856003,
    "descripcion":"VISTO EN EL SERVICIO DE OPTOMETRÍA"
  },
  {
    "codigo":1354432004,
    "descripcion":"DISTENSIÓN DE CABEZA LARGA DE MÚSCULO Y\/O TENDÓN DE BÍCEPS BRAQUIAL"
  },
  {
    "codigo":11780561000119100,
    "descripcion":"LESIÓN TRAUMÁTICA DE BRAZO DERECHO"
  },
  {
    "codigo":404160007,
    "descripcion":"HISTIOCITOSIS DE CÉLULAS DE LANGERHANS - TIPO HASHIMOTO-PRITZKER"
  },
  {
    "codigo":830144008,
    "descripcion":"VIGILANTE"
  },
  {
    "codigo":142016009,
    "descripcion":"ELECTROCARDIOGRAMA MEJORADO EN COMPARACIÓN CON ESTUDIO PREVIO"
  },
  {
    "codigo":1155989002,
    "descripcion":"REACCIÓN ANAFILACTOIDE CAUSADA POR COMPUESTO ORGANOFOSFORADO"
  },
  {
    "codigo":74645003,
    "descripcion":"INFECCIÓN CAUSADA POR FILICOLLIS"
  },
  {
    "codigo":9109004,
    "descripcion":"ALELOS GENÉTICOS"
  },
  {
    "codigo":15712721000119100,
    "descripcion":"VÁRICES EN RETINA DE OJO IZQUIERDO"
  },
  {
    "codigo":205717001,
    "descripcion":"INFECCIÓN CAUSADA POR BORRELIA TURICATAE"
  },
  {
    "codigo":1287061007,
    "descripcion":"HEMORRAGIA INTRAVENTRICULAR NO TRAUMÁTICA GRADO 2 DURANTE PERÍODO INTRAPARTO FETAL"
  },
  {
    "codigo":236650000,
    "descripcion":"RETENCIÓN CRÓNICA DE ORINA"
  },
  {
    "codigo":402325007,
    "descripcion":"PSORIASIS EXACERBADA FARMACOLÓGICAMENTE"
  },
  {
    "codigo":300351001,
    "descripcion":"SIGNO CON NOMBRE PROPIO DE LA VESÍCULA"
  },
  {
    "codigo":726335002,
    "descripcion":"UNIÓN AURICULOVENTRICULAR COMÚN"
  },
  {
    "codigo":1119551007,
    "descripcion":"LONGITUD DE DORSO DE NARIZ AUMENTADA"
  },
  {
    "codigo":365887007,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA REPRODUCIR FIGURAS GEOMÉTRICAS EN CINCO MINUTOS"
  },
  {
    "codigo":724500003,
    "descripcion":"NEUMONITIS EOSINOFÍLICA CRÓNICA IDIOPÁTICA"
  },
  {
    "codigo":298516009,
    "descripcion":"SIN AMPLITUD DE FLEXIÓN PASIVA DE LA COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":1148649003,
    "descripcion":"INTOXICACIÓN CAUSADA POR AGONISTA DE RECEPTOR OPIOIDE"
  },
  {
    "codigo":722665003,
    "descripcion":"MELANOMA MALIGNO PRIMARIO DE CÓRNEA"
  },
  {
    "codigo":1345257005,
    "descripcion":"TC DE SISTEMA GENITOURINARIO ANORMAL"
  },
  {
    "codigo":198377006,
    "descripcion":"TRASTORNOS VULVARES Y\/O PERINEALES NO INFLAMATORIOS"
  },
  {
    "codigo":67305007,
    "descripcion":"MIOCLONÍA ESENCIAL FAMILIAR"
  },
  {
    "codigo":131006000,
    "descripcion":"NIVEL DE HORMONA DE CRECIMIENTO HUMANA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1769008,
    "descripcion":"TORACODÍDIMO"
  },
  {
    "codigo":196542004,
    "descripcion":"ANGINA DE LUDWIG"
  },
  {
    "codigo":367211000119103,
    "descripcion":"DERMATOSIS INFLAMATORIA DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":720830009,
    "descripcion":"LIPOFUSCINOSIS CEROIDE NEURONAL DEBIDA A DEFICIENCIA DE CATEPSINA D"
  },
  {
    "codigo":1144979004,
    "descripcion":"GLOMERULOPATÍA DEBIDA A SÍNDROME URÉMICO HEMOLÍTICO"
  },
  {
    "codigo":161939006,
    "descripcion":"DISNEA CON ESFUERZO MODERADO"
  },
  {
    "codigo":782696001,
    "descripcion":"SÍNDROME DE ATAXIA MITOCONDRIAL RECESIVA"
  },
  {
    "codigo":127336002,
    "descripcion":"OSTEOPATÍA AGUDA"
  },
  {
    "codigo":39601000087107,
    "descripcion":"LUXACIÓN TRAUMÁTICA DE ARTICULACIÓN PERISEMILUNAR DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":291176002,
    "descripcion":"INTOXICACIÓN POR TIETILPERAZINA"
  },
  {
    "codigo":44721000087109,
    "descripcion":"NEOPLASIA MALIGNA DE MAMA EN REMISIÓN COMPLETA"
  },
  {
    "codigo":225640002,
    "descripcion":"PREOCUPADO ACERCA DE LA POSIBILIDAD DE SER UN MAL PADRE"
  },
  {
    "codigo":94568005,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA PIEL DEL PERINEO"
  },
  {
    "codigo":1010237000,
    "descripcion":"DOLOR DE MAMA DERECHA"
  },
  {
    "codigo":293011009,
    "descripcion":"REACCIÓN ADVERSA A LA CEFODIZIMA"
  },
  {
    "codigo":713490002,
    "descripcion":"INFECCIÓN CAUSADA POR PNEUMOCYSTIS CONCOMITANTE CON INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":123666002,
    "descripcion":"ÚTERO RUDIMENTARIO EN EL HOMBRE"
  },
  {
    "codigo":1336082005,
    "descripcion":"ALIMENTACIÓN EXCLUSIVA CON MAMADERA"
  },
  {
    "codigo":25362006,
    "descripcion":"ENFERMEDAD POR ALMACENAMIENTO DE ÁCIDO FITÁNICO"
  },
  {
    "codigo":254738007,
    "descripcion":"FASCITIS INTRAVASCULAR"
  },
  {
    "codigo":285671001,
    "descripcion":"LESIÓN TRAUMÁTICA DE NASOFARINGE"
  },
  {
    "codigo":1268711001,
    "descripcion":"HEPATOBLASTOMA PRIMARIO DE HÍGADO"
  },
  {
    "codigo":340741000119104,
    "descripcion":"QUERATITIS FILAMENTOSA DE OJO IZQUIERDO"
  },
  {
    "codigo":23527004,
    "descripcion":"INTOXICACIÓN POR CANNABIS"
  },
  {
    "codigo":21692001,
    "descripcion":"DIVERTÍCULO DE APÉNDICE ILEOCECAL"
  },
  {
    "codigo":87228002,
    "descripcion":"DESCOMPENSACIÓN"
  },
  {
    "codigo":283836001,
    "descripcion":"MORDEDURA DE ANIMAL EN EL TALÓN"
  },
  {
    "codigo":10963871000119100,
    "descripcion":"LACERACIÓN DE PIERNA IZQUIERDA"
  },
  {
    "codigo":707985000,
    "descripcion":"SIALOSQUESIS"
  },
  {
    "codigo":314769006,
    "descripcion":"SIN CONSENTIMIENTO PARA INMUNIZACIÓN CONTRA TÉTANOS Y DIFTERIA"
  },
  {
    "codigo":249233008,
    "descripcion":"ESCROTO AUSENTE"
  },
  {
    "codigo":312934004,
    "descripcion":"CORIORRETINITIS SIFILÍTICA"
  },
  {
    "codigo":11809541000119109,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE REGIÓN DE RODILLA IZQUIERDA"
  },
  {
    "codigo":1197670007,
    "descripcion":"PSEUDOQUISTE DE PÁNCREAS DEBIDO A PANCREATITIS CRÓNICA"
  },
  {
    "codigo":83558008,
    "descripcion":"QUISTE EN LA CÁMARA ANTERIOR"
  },
  {
    "codigo":247398009,
    "descripcion":"DOLOR NEUROPÁTICO"
  },
  {
    "codigo":1259536000,
    "descripcion":"EXTRAVASACIÓN DE LÍQUIDO CEFALORRAQUÍDEO DEBIDA A TRAUMATISMO CRANEOENCEFÁLICO Y POSTERIOR A ÉL"
  },
  {
    "codigo":407568002,
    "descripcion":"PACIENTE CON TRATAMIENTO HIPOLIPEMIANTE EN DOSIS MÁXIMA TOLERADA"
  },
  {
    "codigo":473104002,
    "descripcion":"REACCIÓN ALÉRGICA CAUSADA POR TINTURA PARA EL CABELLO"
  },
  {
    "codigo":79888005,
    "descripcion":"POSICIÓN SACROILÍACA ANTERIOR"
  },
  {
    "codigo":276496005,
    "descripcion":"HERIDA ABIERTA DE UÑA DE DEDO DEL PIE"
  },
  {
    "codigo":241893000,
    "descripcion":"EFECTO TÓXICO CAUSADO POR REMOVEDOR DE ÓXIDO"
  },
  {
    "codigo":209125001,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DEL ESTERNÓN"
  },
  {
    "codigo":405733001,
    "descripcion":"HIPOCALCEMIA DE FINAL DE GESTACIÓN Y\/O LACTANCIA"
  },
  {
    "codigo":702480009,
    "descripcion":"CON BAJO RIESGO DE INFECCIÓN POR TRANSMISIÓN SEXUAL"
  },
  {
    "codigo":210960009,
    "descripcion":"TRASTORNO DEBIDO A LESIÓN TRAUMÁTICA DE MÚSCULO Y TENDÓN DE MIEMBRO SUPERIOR Y POSTERIOR A ELLA"
  },
  {
    "codigo":733413007,
    "descripcion":"LUXACIÓN TRAUMÁTICA DE ARTICULACIÓN ESCAPULOTORÁCICA"
  },
  {
    "codigo":471269008,
    "descripcion":"CURVA DE SPEE APLANADA"
  },
  {
    "codigo":240058001,
    "descripcion":"DISTROFIA MUSCULAR TIPO REUNION-INDIANA AMISH"
  },
  {
    "codigo":403898002,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS DE LA PIEL DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":371130005,
    "descripcion":"SECRECIÓN ECTÓPICA PARANEOPLÁSICA DE ADRENOCORTICOTROFINA"
  },
  {
    "codigo":860815000,
    "descripcion":"EPILEPSIA DEBIDA A INFECCIÓN NEONATAL DEL SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":1085371000119105,
    "descripcion":"POLINEUROPATÍA DEBIDA A MONONUCLEOSIS POR CITOMEGALOVIRUS"
  },
  {
    "codigo":8847002,
    "descripcion":"ESPONDILOSIS"
  },
  {
    "codigo":305594008,
    "descripcion":"BAJO ATENCIÓN DE TERAPEUTA ESPECIALISTA EN ARTE DRAMÁTICO"
  },
  {
    "codigo":205455005,
    "descripcion":"DEFECTO DE SEGMENTACIÓN DE LA COLUMNA VERTEBRAL"
  },
  {
    "codigo":74383007,
    "descripcion":"ESGUINCE DE LIGAMENTO TIBIOPERONEO DISTAL"
  },
  {
    "codigo":301924000,
    "descripcion":"GLOBO OCULAR NORMAL"
  },
  {
    "codigo":762511009,
    "descripcion":"TRASTORNO DEL ESTADO DE ÁNIMO CAUSADO POR CATINONA SINTÉTICA"
  },
  {
    "codigo":367460001,
    "descripcion":"ENANISMO PITUITARIO"
  },
  {
    "codigo":1155727009,
    "descripcion":"DILATACIÓN CONGÉNITA DE COLÉDOCO"
  },
  {
    "codigo":343251000119100,
    "descripcion":"OFTALMOPLEJÍA TOTAL DE AMBOS OJOS"
  },
  {
    "codigo":300089004,
    "descripcion":"PABELLONES AURICULARES SIMÉTRICOS"
  },
  {
    "codigo":365625004,
    "descripcion":"RECUENTO DE ERITROCITOS - HALLAZGO"
  },
  {
    "codigo":234553005,
    "descripcion":"DEFICIENCIA MOLECULAR ASOCIADA A INMUNOGLOBULINA"
  },
  {
    "codigo":5177007,
    "descripcion":"HALLAZGO RELACIONADO CON EL EJE ELECTROCARDIOGRÁFICO"
  },
  {
    "codigo":724238000,
    "descripcion":"HALLAZGO RELACIONADO CON LA VELOCIDAD DE LA MARCHA"
  },
  {
    "codigo":70713009,
    "descripcion":"CONFLICTO EXTRAPSÍQUICO"
  },
  {
    "codigo":36110001,
    "descripcion":"ANOMALÍA CONGÉNITA DE LA ARTERIA PULMONAR"
  },
  {
    "codigo":167182002,
    "descripcion":"DEPURACIÓN DE CREATININA-FILTRACIÓN GLOMERULAR DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":201785007,
    "descripcion":"ARTRITIS REUMATOIDE DE ARTICULACIÓN INTERFALÁNGICA DE DEDO DEL PIE"
  },
  {
    "codigo":298254008,
    "descripcion":"DOLOR DE ARTICULACIÓN CIGOAPOFISARIA DORSAL"
  },
  {
    "codigo":198115002,
    "descripcion":"GALACTORREA DE CAUSA NO OBSTÉTRICA"
  },
  {
    "codigo":296419008,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE DIFENHIDRAMINA"
  },
  {
    "codigo":720568003,
    "descripcion":"SÍNDROME DE BRAQUIDACTILIA E HIPERTENSIÓN ARTERIAL"
  },
  {
    "codigo":425656005,
    "descripcion":"QUEMADURA CAUSADA POR RADIACIÓN"
  },
  {
    "codigo":521000124101,
    "descripcion":"EXCLUSIÓN DE MEDICIÓN DE DESEMPEÑO POR MOTIVOS SISTÉMICOS"
  },
  {
    "codigo":440841000124102,
    "descripcion":"INGESTA INADECUADA DE COBRE"
  },
  {
    "codigo":65208005,
    "descripcion":"ÁNTRAX DE MUSLO"
  },
  {
    "codigo":294584009,
    "descripcion":"ALERGIA A CLOMOCICLINA"
  },
  {
    "codigo":1144717001,
    "descripcion":"HIPOPLASIA CONGÉNITA DE FALANGE MEDIA DE QUINTO DEDO DE PIE"
  },
  {
    "codigo":1080531000119106,
    "descripcion":"CARCINOMA DE CÉLULAS GRANDES PRIMARIO DE LÓBULO SUPERIOR DE PULMÓN DERECHO"
  },
  {
    "codigo":428041000124106,
    "descripcion":"FUMADOR OCASIONAL DE TABACO"
  },
  {
    "codigo":292749006,
    "descripcion":"REACCIÓN ADVERSA AL EDETATO TRISÓDICO"
  },
  {
    "codigo":30605009,
    "descripcion":"DEPRESIÓN MAYOR EN REMISIÓN PARCIAL"
  },
  {
    "codigo":28770003,
    "descripcion":"POLIQUISTOSIS RENAL, TIPO INFANTIL"
  },
  {
    "codigo":127074004,
    "descripcion":"LINFADENOPATÍA SUPERFICIAL"
  },
  {
    "codigo":1208418004,
    "descripcion":"MIOPATÍA CONGÉNITA POR DESPROPORCIÓN DEL TIPO DE FIBRA DOMINANTE AUTOSÓMICA DEBIDA A MUTACIÓN DE TPM3"
  },
  {
    "codigo":421986006,
    "descripcion":"PROTEINURIA PERSISTENTE DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":94306005,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL ANTEBRAZO"
  },
  {
    "codigo":715063000,
    "descripcion":"INTOXICACIÓN ACCIDENTAL CAUSADA POR ÁCIDO 2,4,5-TRICLOROFENOXIACÉTICO"
  },
  {
    "codigo":26935004,
    "descripcion":"TUBERCULOSIS DE LA GLÁNDULA TIROIDES"
  },
  {
    "codigo":92471004,
    "descripcion":"NEOPLASIA BENIGNA DEL TRACTO UVEAL"
  },
  {
    "codigo":1237516000,
    "descripcion":"METÁSTASIS DE CARCINOMA DE LÓBULO INFERIOR DE PULMÓN"
  },
  {
    "codigo":254476000,
    "descripcion":"NEOPLASIA DE PARED NASAL LATERAL"
  },
  {
    "codigo":713228003,
    "descripcion":"REACCIÓN ADVERSA A ADITIVO DE LA GOMA DE MASCAR"
  },
  {
    "codigo":88801000,
    "descripcion":"LUXACIÓN PATOLÓGICA DE LA REGIÓN PÉLVICA"
  },
  {
    "codigo":1137377003,
    "descripcion":"MIOCARDIOPATÍA DEBIDA A HIPERTIROIDISMO"
  },
  {
    "codigo":416481006,
    "descripcion":"TOXOPLASMOSIS OCULAR"
  },
  {
    "codigo":16838151000119102,
    "descripcion":"DIARREA RECURRENTE CAUSADA POR CLOSTRIDIUM DIFFICILE"
  },
  {
    "codigo":283574001,
    "descripcion":"HERIDA DE PERDIGÓN EN MAMA"
  },
  {
    "codigo":21430002,
    "descripcion":"MIOCARDIOPATÍA DILATADA DEBIDA A ARTRITIS REUMATOIDE"
  },
  {
    "codigo":840630003,
    "descripcion":"ÚTERO GRÁVIDO DE TAMAÑO CORRESPONDIENTE A 32-34 SEMANAS"
  },
  {
    "codigo":185270007,
    "descripcion":"ATENDIDO EN UN CONSULTORIO ONCOLÓGICO"
  },
  {
    "codigo":1363083001,
    "descripcion":"ASTILLA EN EXTREMIDAD INFERIOR"
  },
  {
    "codigo":17760001,
    "descripcion":"ANOMALÍA DEL PAR DE CROMOSOMAS 13"
  },
  {
    "codigo":247136003,
    "descripcion":"ANOMALÍA MICROVASCULAR INTRARRETINIANA"
  },
  {
    "codigo":50528008,
    "descripcion":"SÍFILIS DE HUESO"
  },
  {
    "codigo":1162805002,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE VALPROATO"
  },
  {
    "codigo":212533002,
    "descripcion":"INTOXICACIÓN POR ÁCIDO PARAMINOSALICÍLICO"
  },
  {
    "codigo":278069006,
    "descripcion":"DOLOR A LA PALPACIÓN EN FONDO DE SACO VAGINAL"
  },
  {
    "codigo":1193738003,
    "descripcion":"INFLAMACIÓN INTESTINAL POR MYCOBACTERIUM"
  },
  {
    "codigo":472842004,
    "descripcion":"INSUFICIENCIA DE VÁLVULA MITRAL FETAL"
  },
  {
    "codigo":15664801000119103,
    "descripcion":"TUMOR TENOSINOVIAL DIFUSO DE CÉLULAS GIGANTES DE PIE IZQUIERDO"
  },
  {
    "codigo":734986006,
    "descripcion":"SÍNDROME DE DOLOR REGIONAL COMPLEJO DE MIEMBRO INFERIOR"
  },
  {
    "codigo":833290005,
    "descripcion":"DOLOR A LA DESCOMPRESIÓN DE REGIÓN UMBILICAL"
  },
  {
    "codigo":210698007,
    "descripcion":"SECCIÓN PARCIAL DEL TENDÓN CALCÁNEO (TENDÓN DE AQUILES)"
  },
  {
    "codigo":767754009,
    "descripcion":"QUISTE DE TESTÍCULO"
  },
  {
    "codigo":700383002,
    "descripcion":"INESTABILIDAD AGUDA DE TOBILLO"
  },
  {
    "codigo":79626009,
    "descripcion":"FRACTURA NO EXPUESTA DE ASTRÁGALO"
  },
  {
    "codigo":866058008,
    "descripcion":"MIELITIS CAUSADA POR ECHOVIRUS HUMANO"
  },
  {
    "codigo":272564003,
    "descripcion":"INCLINADO EN UN CABALLO"
  },
  {
    "codigo":403636004,
    "descripcion":"ESTOMATITIS DEBIDA A TRATAMIENTO CITOTÓXICO"
  },
  {
    "codigo":319291000119100,
    "descripcion":"LUXACIÓN RECURRENTE DE REGIÓN ARTICULAR DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":765747004,
    "descripcion":"ENFERMEDAD DE CHARCOT-MARIE-TOOTH AUTOSÓMICA DOMINANTE INTERMEDIA TIPO D"
  },
  {
    "codigo":237961001,
    "descripcion":"ACIDURIA L-2-HIDROXIGLUTÁRICA"
  },
  {
    "codigo":345761000119107,
    "descripcion":"HIPOPIÓN DE AMBOS OJOS"
  },
  {
    "codigo":301662000,
    "descripcion":"CAPAZ DE ACOSTARSE Y LEVANTARSE DE UNA CAMA"
  },
  {
    "codigo":762249009,
    "descripcion":"EROSIÓN DE BOLSILLO PARA MARCAPASOS DEBIDA A IMPLANTE DE MARCAPASOS CARDÍACO Y POSTERIOR A ÉL"
  },
  {
    "codigo":399966002,
    "descripcion":"NEOPLASIA IN SITU DE VULVA"
  },
  {
    "codigo":236126003,
    "descripcion":"FÍSTULA PERIESTOMAL"
  },
  {
    "codigo":432734004,
    "descripcion":"ASIMETRÍA CONGÉNITA DE MAMAS"
  },
  {
    "codigo":267059001,
    "descripcion":"GUSANOS EN MATERIA FECAL"
  },
  {
    "codigo":1153630009,
    "descripcion":"EMBOLIA DE ARTERIA CARÓTIDA IZQUIERDA"
  },
  {
    "codigo":15638331000119104,
    "descripcion":"NEOPLASIA BENIGNA DE AMBAS COROIDES"
  },
  {
    "codigo":11808331000119100,
    "descripcion":"LACERACIÓN DE COLON TRANSVERSO"
  },
  {
    "codigo":1092171000119100,
    "descripcion":"OTALGIA DE OÍDO DERECHO, DERIVADA"
  },
  {
    "codigo":10861131000119100,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO FEMORAL IZQUIERDO"
  },
  {
    "codigo":63051000119101,
    "descripcion":"PIE ZAMBO FETAL"
  },
  {
    "codigo":398131008,
    "descripcion":"PACIENTE EN POSICIÓN LATERAL PARA INTUBACIÓN"
  },
  {
    "codigo":11048011000119103,
    "descripcion":"SÍNDROME DE HIPEREMESIS POR CANNABIS CONCOMITANTE CON DEPENDENCIA DE CANNABIS Y DEBIDO A ELLA"
  },
  {
    "codigo":116811000119106,
    "descripcion":"LINFOMA NO-HODGKIN DE SISTEMA NERVIOSO CENTRAL CON METÁSTASIS A GANGLIO LINFÁTICO DE MIEMBRO INFERIOR"
  },
  {
    "codigo":339531000119107,
    "descripcion":"ÚLCERA MARGINAL DE CÓRNEA IZQUIERDA"
  },
  {
    "codigo":16705611000119108,
    "descripcion":"DISECCIÓN DE ARTERIA BRAQUIAL IZQUIERDA"
  },
  {
    "codigo":1087051000119109,
    "descripcion":"OSTEOMIELITIS GONOCÓCICA"
  },
  {
    "codigo":313931000119109,
    "descripcion":"ATROFIA DE MÚSCULO DE BRAZO DERECHO"
  },
  {
    "codigo":308811000119102,
    "descripcion":"GOTA DE CADERA DEBIDA DE DISFUNCIÓN RENAL"
  },
  {
    "codigo":297992001,
    "descripcion":"HALLAZGO RELACIONADO CON EL ASPECTO DEL PELO"
  },
  {
    "codigo":15919691000119107,
    "descripcion":"ANAFILAXIA CAUSADA POR SULFONAMIDAS"
  },
  {
    "codigo":342091000119109,
    "descripcion":"ECTROPIÓN SENIL DE PÁRPADO IZQUIERDO"
  },
  {
    "codigo":789512006,
    "descripcion":"PÉRDIDA DE LONGITUD DE ARCADA DENTAL DEBIDA A CARIES DENTAL"
  },
  {
    "codigo":104011000119109,
    "descripcion":"HERPES SIMPLE GENITAL EN LA MADRE QUE COMPLICA EL EMBARAZO"
  },
  {
    "codigo":723976005,
    "descripcion":"FIBROMATOSIS"
  },
  {
    "codigo":93771000119109,
    "descripcion":"DIAGNÓSTICO DIFERIDO"
  },
  {
    "codigo":230621002,
    "descripcion":"SECCIÓN TOTAL DE NERVIO PERIFÉRICO"
  },
  {
    "codigo":197853008,
    "descripcion":"CISTITIS RECURRENTE"
  },
  {
    "codigo":292821000119101,
    "descripcion":"COMPRESIÓN DE NERVIO MEDIANO IZQUIERDO A LA ALTURA DEL CODO"
  },
  {
    "codigo":425394002,
    "descripcion":"TESTAMENTO SOBRE EL CUIDADO DE LA SALUD ACTIVO"
  },
  {
    "codigo":427229002,
    "descripcion":"PATRÓN DE USO EPISÓDICO NOCIVO DE INHALANTE VOLÁTIL"
  },
  {
    "codigo":95879001,
    "descripcion":"INTOXICACIÓN DIARREICA POR MARISCOS"
  },
  {
    "codigo":292487004,
    "descripcion":"REACCIÓN ADVERSA A NAFAZOLINA"
  },
  {
    "codigo":1144455005,
    "descripcion":"APLASIA DE DEDO ÍNDICE"
  },
  {
    "codigo":126812000,
    "descripcion":"NEOPLASIA DE LA VALÉCULA"
  },
  {
    "codigo":718471008,
    "descripcion":"PENFIGOIDE DE MEMBRANA MUCOSA GINGIVAL"
  },
  {
    "codigo":290652003,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ACLARUBICINA"
  },
  {
    "codigo":94044006,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA PIEL DEL OMBLIGO"
  },
  {
    "codigo":716636008,
    "descripcion":"DEFICIENCIA LONGITUDINAL DE PARTE DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":124977000,
    "descripcion":"DELECIÓN DE BASE DE NUCLEÓTIDO"
  },
  {
    "codigo":419889000,
    "descripcion":"NEOPLASIA DEL SISTEMA DE DRENAJE LAGRIMAL"
  },
  {
    "codigo":92209004,
    "descripcion":"NEOPLASIA BENIGNA DE LAS CELDILLAS AÉREAS MASTOIDEAS"
  },
  {
    "codigo":876806000,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE HOMBRO CON INFECCIÓN"
  },
  {
    "codigo":1237254001,
    "descripcion":"RUPTURA DE SENO MARGINAL DE PLACENTA"
  },
  {
    "codigo":90374001,
    "descripcion":"PIE PLANO ESPÁSTICO ADQUIRIDO"
  },
  {
    "codigo":15913071000119102,
    "descripcion":"PLIEGUE GLÚTEO ANORMAL"
  },
  {
    "codigo":418054005,
    "descripcion":"DISTROFIA CORNEAL MACULAR TIPO I"
  },
  {
    "codigo":254214009,
    "descripcion":"TRASTORNO HEREDADO DE LA QUERATINIZACIÓN"
  },
  {
    "codigo":416219001,
    "descripcion":"ROTACIÓN INTERNA DE HUESO INNOMINADO"
  },
  {
    "codigo":88539002,
    "descripcion":"DISFUNCIÓN DEL MÚSCULO CRICOFARÍNGEO"
  },
  {
    "codigo":285147007,
    "descripcion":"HÁBITO DE MORDERSE LA MANO"
  },
  {
    "codigo":86704005,
    "descripcion":"FRACTURA DE FOSA ANTERIOR"
  },
  {
    "codigo":283312006,
    "descripcion":"ASTILLA DE MADERA EN PANTORRILLA"
  },
  {
    "codigo":185008008,
    "descripcion":"INFORMES MÉDICOS ENVIADOS"
  },
  {
    "codigo":1231749004,
    "descripcion":"MIOSITIS DE SOLAPAMIENTO DE INICIO EN EL ADULTO"
  },
  {
    "codigo":248709007,
    "descripcion":"VASO SANGUÍNEO DURO"
  },
  {
    "codigo":443482000,
    "descripcion":"URGENCIA HIPERTENSIVA"
  },
  {
    "codigo":1085551000119108,
    "descripcion":"EDENTULISMO COMPLETO DE CLASE II DEBIDO A ENFERMEDAD PERIODONTAL"
  },
  {
    "codigo":246874003,
    "descripcion":"QUERATINIZACIÓN CONJUNTIVAL"
  },
  {
    "codigo":115802003,
    "descripcion":"FENOTIPO U"
  },
  {
    "codigo":769327000,
    "descripcion":"CÉLULAS EN DIVISIÓN DEL DOMINIO BACTERIA PRESENTES"
  },
  {
    "codigo":11790601000119104,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE MANO IZQUIERDA"
  },
  {
    "codigo":277807007,
    "descripcion":"SÍNDROME DE CURRY - HALL"
  },
  {
    "codigo":15663008,
    "descripcion":"PLACENTA PREVIA OCLUSIVA TOTAL"
  },
  {
    "codigo":212271009,
    "descripcion":"LESIÓN TRAUMÁTICA CERRADA DE RAMA SENSITIVA DE NERVIO RADIAL"
  },
  {
    "codigo":308740002,
    "descripcion":"ÚLCERA DEL PRIMER DEDO DEL PIE"
  },
  {
    "codigo":372441001,
    "descripcion":"CRISIS CONVULSIVAS QUE COMPLICAN UNA INFECCIÓN EN EL RECIÉN NACIDO"
  },
  {
    "codigo":274137005,
    "descripcion":"LESIÓN DE DISCO LUMBAR"
  },
  {
    "codigo":896729006,
    "descripcion":"FORMA DELGADA ANORMAL CONGÉNITA DE DIÁFISIS DE HUESO LARGO"
  },
  {
    "codigo":403374002,
    "descripcion":"TRANSPIRACIÓN EMOCIONAL QUE AFECTA LAS PALMAS DE LAS MANOS Y LAS PLANTAS DE LOS PIES"
  },
  {
    "codigo":75694006,
    "descripcion":"PANCREATITIS"
  },
  {
    "codigo":698286006,
    "descripcion":"MELANOMA MALIGNO DE PALADAR"
  },
  {
    "codigo":237699005,
    "descripcion":"HIPOPITUITARISMO POSTRAUMÁTICO"
  },
  {
    "codigo":301400000,
    "descripcion":"DOLOR A LA PALPACIÓN EN REGIÓN CORPORAL"
  },
  {
    "codigo":1153368001,
    "descripcion":"DEFORMIDAD CIFÓTICA DE COLUMNA VERTEBRAL DEBIDA A EPIFISIOPATÍA"
  },
  {
    "codigo":1217069000,
    "descripcion":"HIPOALDOSTERONISMO HIPERRENINÉMICO FAMILIAR TIPO 1B"
  },
  {
    "codigo":235864009,
    "descripcion":"HEPATITIS B AGUDA CON HEPATITIS D"
  },
  {
    "codigo":102957003,
    "descripcion":"HALLAZGO NEUROLÓGICO"
  },
  {
    "codigo":397869004,
    "descripcion":"TRAUMATISMO DENTAL"
  },
  {
    "codigo":70189005,
    "descripcion":"PERICARDITIS VIRAL"
  },
  {
    "codigo":201261003,
    "descripcion":"URTICARIA CAUSADA POR FRÍO Y CALOR"
  },
  {
    "codigo":234029006,
    "descripcion":"SÍNDROME DE ROBO ARTERIAL CORONARIO"
  },
  {
    "codigo":365101008,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA SALIR DE LA DUCHA"
  },
  {
    "codigo":299565009,
    "descripcion":"SIGNO DE LUZ DE DÍA EN DEDOS DE LOS PIES"
  },
  {
    "codigo":68354003,
    "descripcion":"PSEUDOOFTALMOPLEJÍA"
  },
  {
    "codigo":2818004,
    "descripcion":"ANOMALÍA VASCULAR CONGÉNITA DEL OJO"
  },
  {
    "codigo":35586003,
    "descripcion":"PIEDRA BLANCA"
  },
  {
    "codigo":197591002,
    "descripcion":"SÍNDROME NEFRÓTICO CON GLOMERULONEFRITIS MEMBRANOPROLIFERATIVA"
  },
  {
    "codigo":230359004,
    "descripcion":"ENCEFALOPATÍA SECUNDARIA A AMILOIDE"
  },
  {
    "codigo":295895004,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE IPRONIAZIDA"
  },
  {
    "codigo":721879006,
    "descripcion":"SÍNDROME DE MICROFTALMÍA CON DEFECTO CUTÁNEO LINEAL"
  },
  {
    "codigo":1088061000119105,
    "descripcion":"OTITIS MEDIA MUCOIDE AGUDA DE OÍDO IZQUIERDO"
  },
  {
    "codigo":350781000119106,
    "descripcion":"NEOPLASIA BENIGNA DE CUERPO CILIAR DE OJO IZQUIERDO"
  },
  {
    "codigo":228524006,
    "descripcion":"EXPUESTO AL TABACO EN CASA"
  },
  {
    "codigo":294060008,
    "descripcion":"ALERGIA A DIPIVEFRINA"
  },
  {
    "codigo":95617006,
    "descripcion":"CIANOSIS NEONATAL"
  },
  {
    "codigo":292225007,
    "descripcion":"REACCIÓN ADVERSA A EPIRUBICINA"
  },
  {
    "codigo":61014001,
    "descripcion":"LACERACIÓN QUE SE EXTIENDE HACIA PARÉNQUIMA DE BAZO SIN HERIDA ABIERTA HACIA CAVIDAD ABDOMINAL"
  },
  {
    "codigo":93782004,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL EPICARDIO"
  },
  {
    "codigo":12202711000119103,
    "descripcion":"FRACTURA DE HUESO ADYACENTE A PRÓTESIS DE ARTICULACIÓN DE MUÑECA DERECHA"
  },
  {
    "codigo":126550004,
    "descripcion":"NEOPLASIA DEL MAXILAR SUPERIOR"
  },
  {
    "codigo":716374005,
    "descripcion":"ANAFILAXIA CAUSADA POR DIÓXIDO DE AZUFRE"
  },
  {
    "codigo":10646231000119103,
    "descripcion":"ÚLCERA VARICOSA DE MUSLO DERECHO"
  },
  {
    "codigo":290390004,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR HIDRÓXIDO DE ALUMINIO"
  },
  {
    "codigo":91947003,
    "descripcion":"INFECCIÓN ASINTOMÁTICA POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":419627003,
    "descripcion":"REFLEJO ROJO DISMINUIDO"
  },
  {
    "codigo":124715007,
    "descripcion":"DEFICIENCIA DE FOSFORRIBOSILFORMILGLICINAMIDA SINTASA"
  },
  {
    "codigo":324311000119105,
    "descripcion":"ARTROPATÍA DEBIDA A TRASTORNO ENDOCRINO"
  },
  {
    "codigo":90112001,
    "descripcion":"INTOXICACIÓN POR ADENIA"
  },
  {
    "codigo":286720003,
    "descripcion":"CARÁCTER SOCIABLE"
  },
  {
    "codigo":1236992003,
    "descripcion":"INFLAMACIÓN DE MARGEN LIBRE ANTERIOR DE PÁRPADO INFERIOR IZQUIERDO"
  },
  {
    "codigo":448725000,
    "descripcion":"CONTINUIDAD ENTRE VÁLVULA AÓRTICA Y VÁLVULA MITRAL"
  },
  {
    "codigo":284885000,
    "descripcion":"NO SE CORTA LAS UÑAS DE LAS MANOS"
  },
  {
    "codigo":219349002,
    "descripcion":"LESIÓN DE CAUSA ACCIDENTAL O INTENCIONAL INDETERMINADA, CAÍDA DESDE UN SITIO NATURAL"
  },
  {
    "codigo":22741003,
    "descripcion":"ENFERMEDAD NO INFLAMATORIA DE LA VAGINA"
  },
  {
    "codigo":88277007,
    "descripcion":"QUEMADURA PROFUNDA DE TERCER GRADO DE LOS ÓRGANOS GENITALES MASCULINOS"
  },
  {
    "codigo":446890001,
    "descripcion":"RETORNO VENOSO PULMONAR OBSTRUIDO A NIVEL DEL ORIFICIO DEL SENO CORONARIO"
  },
  {
    "codigo":283050005,
    "descripcion":"ABRASIÓN DE LA REGIÓN OCULAR"
  },
  {
    "codigo":250282006,
    "descripcion":"APÉNDICE NUCLEAR EN PALILLO DE TAMBOR"
  },
  {
    "codigo":1264255000,
    "descripcion":"INTERRUPCIÓN COMPLETA INDUCIDA DE EMBARAZO"
  },
  {
    "codigo":248447001,
    "descripcion":"FIEBRE DEFERVESCENTE"
  },
  {
    "codigo":445055004,
    "descripcion":"TEJIDO CELULAR SUBCUTÁNEO GOMOSO"
  },
  {
    "codigo":1297023006,
    "descripcion":"CIERRE DE ÁNGULO DE OJO IZQUIERDO DEBIDO A SÍNDROME ENDOTELIAL IRIDOCORNEAL"
  },
  {
    "codigo":312148000,
    "descripcion":"INFECCIÓN ÓTICA POR HONGOS"
  },
  {
    "codigo":770900000,
    "descripcion":"SÍNDROME DE ONFALOCELE FAMILIAR CON DISMORFIA FACIAL"
  },
  {
    "codigo":50004001,
    "descripcion":"NINGÚN TIPO DE SUSTANCIA IDENTIFICADO"
  },
  {
    "codigo":769065000,
    "descripcion":"LEUCODISTROFIA RELACIONADA CON TUBULINA BETA 4A CLASE IVA"
  },
  {
    "codigo":1196884008,
    "descripcion":"NEOPLASIA EPITELIAL BENIGNA DE ESTÓMAGO"
  },
  {
    "codigo":48169002,
    "descripcion":"PERFORACIÓN CON ENFERMEDAD DIVERTICULAR DEL COLON"
  },
  {
    "codigo":212009003,
    "descripcion":"CORROSIÓN DE TOBILLO Y PIE"
  },
  {
    "codigo":1162281004,
    "descripcion":"LORDOSIS CAUSADA POR RADIACIÓN"
  },
  {
    "codigo":277545003,
    "descripcion":"LEUCEMIA LINFOCÍTICA CRÓNICA DE CÉLULAS T"
  },
  {
    "codigo":15698801000119108,
    "descripcion":"ÚLCERA CORNEAL DE AMBOS OJOS CAUSADA POR ACANTHAMOEBA"
  },
  {
    "codigo":46334001,
    "descripcion":"EFECTO TÓXICO DEL ÓXIDO DE NITRÓGENO"
  },
  {
    "codigo":79102006,
    "descripcion":"INTOXICACIÓN POR INULA CONYZA"
  },
  {
    "codigo":472318007,
    "descripcion":"MIOCARDIOPATÍA MITOCONDRIAL HIPERTRÓFICA ASOCIADA CON CATARATAS Y ACIDOSIS LÁCTICA"
  },
  {
    "codigo":11731003,
    "descripcion":"PTERIGIÓN CERVICAL"
  },
  {
    "codigo":110035007,
    "descripcion":"LACERACIÓN PERIORBITARIA COMPLEJA CONTAMINADA"
  },
  {
    "codigo":699859009,
    "descripcion":"CONTRACTURA MIOFIBRÓTICA DE MÚSCULO DE LA MASTICACIÓN"
  },
  {
    "codigo":403112002,
    "descripcion":"MICETOMA CAUSADO POR ACREMONIUM"
  },
  {
    "codigo":9896002,
    "descripcion":"PELVIS ESPINOSA"
  },
  {
    "codigo":1287848006,
    "descripcion":"ONICOMADESIS DEBIDA A ENFERMEDAD MANO, PIE, BOCA Y POSTERIOR A ELLA"
  },
  {
    "codigo":272040008,
    "descripcion":"SIBILANCIA - SÍNTOMA"
  },
  {
    "codigo":237437004,
    "descripcion":"ABSCESO INTRAMAMARIO"
  },
  {
    "codigo":399442001,
    "descripcion":"NO SE PUEDE VALORAR LA INVASIÓN TUMORAL DEL PARÉNQUIMA PULMONAR"
  },
  {
    "codigo":268370004,
    "descripcion":"PRUEBA URINARIA ESPECIAL ANORMAL"
  },
  {
    "codigo":170066004,
    "descripcion":"PERÍMETRO CEFÁLICO DEL NIÑO = PERCENTILOS 50 A 74"
  },
  {
    "codigo":366674006,
    "descripcion":"HALLAZGO RELACIONADO CON LA AMPLITUD DE LA FLEXIÓN DE DEDO DE LA MANO"
  },
  {
    "codigo":301138006,
    "descripcion":"LATIDO DEL VÉRTICE EN POSICIÓN NORMAL"
  },
  {
    "codigo":235602008,
    "descripcion":"ESOFAGITIS FÚNGICA"
  },
  {
    "codigo":1251410008,
    "descripcion":"DERMATITIS ATÓPICA DE PLIEGUES EN LA INFANCIA"
  },
  {
    "codigo":397607002,
    "descripcion":"PLAN DE CUIDADOS PREQUIRÚRGICOS DE ACUERDO CON EL SISTEMA DE VALORES, HÁBITOS DE VIDA, ETNICIDAD Y CULTURA DEL PACIENTE"
  },
  {
    "codigo":299303003,
    "descripcion":"AMPLITUD DE ROTACIÓN EXTERNA PASIVA DE ARTICULACIÓN DE CADERA, AUMENTADA"
  },
  {
    "codigo":233767005,
    "descripcion":"SARCOIDOSIS PULMONAR, ESTADIO 1"
  },
  {
    "codigo":725287006,
    "descripcion":"EMBRIOPATÍA CAUSADA POR RETINOIDE"
  },
  {
    "codigo":200999007,
    "descripcion":"LIQUEN PLANO ACTÍNICO"
  },
  {
    "codigo":363004000,
    "descripcion":"SECUELA CARDIOVASCULAR DE TRASTORNOS"
  },
  {
    "codigo":364839009,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA BAJAR UNA COLINA CORRIENDO"
  },
  {
    "codigo":788988003,
    "descripcion":"ENTEROCOLITIS NECROSANTE DEL RECIÉN NACIDO, ESTADIO 2A DE LA CLASIFICACIÓN DE BELL"
  },
  {
    "codigo":723452007,
    "descripcion":"SÍNDROME DE POLINEUROPATÍA, HIPOACUSIA, ATAXIA, RETINITIS PIGMENTOSA Y CATARATAS"
  },
  {
    "codigo":2556008,
    "descripcion":"ENFERMEDAD PERIODONTAL"
  },
  {
    "codigo":721617001,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE TERCIO INFERIOR DE ESÓFAGO DEBIDO A ESÓFAGO DE BARRETT"
  },
  {
    "codigo":68092007,
    "descripcion":"ORIGEN ANÓMALO DE LA ARTERIA PULMONAR"
  },
  {
    "codigo":66257002,
    "descripcion":"FASE PSICOSEXUAL"
  },
  {
    "codigo":262865005,
    "descripcion":"HEMATOMA CECAL"
  },
  {
    "codigo":33489005,
    "descripcion":"DIETA PARA ENFERMEDAD RENAL"
  },
  {
    "codigo":295633007,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE MELFALÁN"
  },
  {
    "codigo":197329009,
    "descripcion":"ABSCESO HEPÁTICO A TRAVÉS DEL OMBLIGO"
  },
  {
    "codigo":293798009,
    "descripcion":"ALERGIA A CICLOSPORINA"
  },
  {
    "codigo":95355007,
    "descripcion":"HIPERPLASIA DE LA MEMBRANA MUCOSA"
  },
  {
    "codigo":128123007,
    "descripcion":"TRASTORNO DEL SISTEMA NERVIOSO PERIFÉRICO AUTÓNOMO"
  },
  {
    "codigo":193659009,
    "descripcion":"SUPRESIÓN DE LA VISIÓN BIOCULAR"
  },
  {
    "codigo":717947009,
    "descripcion":"DEFICIENCIA DE VITAMINA B12 CAUSADA POR FÁRMACO"
  },
  {
    "codigo":1142096002,
    "descripcion":"LACERACIÓN DE CUERO CABELLUDO DEBIDA A TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":291963009,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR CLOROTIAZIDA"
  },
  {
    "codigo":716112005,
    "descripcion":"SÍNDROME DE MICROCEFALIA CON SORDERA Y DISCAPACIDAD INTELECTUAL"
  },
  {
    "codigo":782036441000119100,
    "descripcion":"ENDOMETRIOSIS DE ABDOMEN"
  },
  {
    "codigo":93520007,
    "descripcion":"ENFERMEDAD DE HODGKIN DE LOS GANGLIOS LINFÁTICOS INTRABDOMINALES"
  },
  {
    "codigo":124453001,
    "descripcion":"DEFICIENCIA DE BETA - AMILASA"
  },
  {
    "codigo":253690003,
    "descripcion":"ARTERIA COLATERAL QUE DERIVA EL FLUJO SISTÉMICO HACIA LA CIRCULACIÓN PULMONAR"
  },
  {
    "codigo":11824601000119103,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE HOMBRO DERECHO"
  },
  {
    "codigo":1169359006,
    "descripcion":"SÍNDROME DE TALLA ALTA, DISCAPACIDAD INTELECTUAL Y ANOMALÍAS RENALES"
  },
  {
    "codigo":186319007,
    "descripcion":"LISTERIOSIS OCULOGLANDULAR"
  },
  {
    "codigo":284623007,
    "descripcion":"ATACAR FEROZMENTE A OTRA PERSONA"
  },
  {
    "codigo":446628002,
    "descripcion":"VALVA DE VÁLVULA TRICÚSPIDE GELATINOSA"
  },
  {
    "codigo":1003684003,
    "descripcion":"CLASIFICACIÓN DE INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA DE LOS CENTROS PARA EL CONTROL Y PREVENCIÓN DE ENFERMEDADES ETAPA 3"
  },
  {
    "codigo":315556003,
    "descripcion":"NACIDO EN VANUATÚ"
  },
  {
    "codigo":282788005,
    "descripcion":"LESIÓN POR TRACCIÓN DEL PLEXO BRAQUIAL"
  },
  {
    "codigo":118948005,
    "descripcion":"TRASTORNO DEL ABDOMEN"
  },
  {
    "codigo":250020009,
    "descripcion":"MARCHA MIOPÁTICA"
  },
  {
    "codigo":1231225003,
    "descripcion":"QUERATITIS NEUROTRÓFICA POSQUIRÚRGICA"
  },
  {
    "codigo":117113004,
    "descripcion":"CONFIGURACIÓN DEL SOPLO CARDÍACO, VARIABLE"
  },
  {
    "codigo":248185005,
    "descripcion":"RASGOS TOSCOS"
  },
  {
    "codigo":51577008,
    "descripcion":"SÍNDROME DE WILSON - MIKITY"
  },
  {
    "codigo":82510005,
    "descripcion":"VÉRTIGO POSTRAUMÁTICO"
  },
  {
    "codigo":15139001,
    "descripcion":"SÍNDROME DE HIDROCEFALIA CEREBRAL CRÓNICA"
  },
  {
    "codigo":703267003,
    "descripcion":"SÍNDROME METAMÉRICO ARTERIOVENOSO CEREBROFACIAL TIPO 1"
  },
  {
    "codigo":1260323006,
    "descripcion":"CEFALEA DEBIDA A HEMORRAGIA SUBARACNOIDEA ESPONTÁNEA"
  },
  {
    "codigo":275448003,
    "descripcion":"DERMATITIS PERIANAL"
  },
  {
    "codigo":306381000,
    "descripcion":"ATENDIDO POR SERVICIO DE CIRUGÍA CARDÍACA"
  },
  {
    "codigo":404685002,
    "descripcion":"MIORRITMIA OCULOMASTICATORIA"
  },
  {
    "codigo":109773002,
    "descripcion":"EDEMA DEL VESTÍBULO DE LA BOCA"
  },
  {
    "codigo":240845003,
    "descripcion":"LOIASIS CEREBRAL"
  },
  {
    "codigo":9634000,
    "descripcion":"LUXACIÓN CONGÉNITA DE LA CABEZA RADIAL"
  },
  {
    "codigo":44237008,
    "descripcion":"LUXACIÓN EXPUESTA DEL CÓCCIX"
  },
  {
    "codigo":271778003,
    "descripcion":"CÁLCULO DE VEJIGA URINARIA DE OXALATO"
  },
  {
    "codigo":206242003,
    "descripcion":"HEMATOMA SUBCAPSULAR HEPÁTICO POR TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":1254818005,
    "descripcion":"DEPENDENCIA DE INHIBIDOR SELECTIVO DE RECAPTACIÓN DE SEROTONINA"
  },
  {
    "codigo":239010003,
    "descripcion":"DISPLASIA ECTODÉRMICA CON SORDERA, ALOPECIA, ONICODISPLASIA E HIPOHIDROSIS"
  },
  {
    "codigo":42402006,
    "descripcion":"SÍNDROME DE KARTAGENER"
  },
  {
    "codigo":402850004,
    "descripcion":"PÚRPURA POR VÓMITOS Y TOS PROLONGADOS"
  },
  {
    "codigo":15949581000119103,
    "descripcion":"CARCINOMA PRIMARIO DE CÉLULAS ESCAMOSAS DE PIEL DE AMBOS HOMBROS"
  },
  {
    "codigo":204407002,
    "descripcion":"BANDAS ANÓMALAS DEL CORAZÓN"
  },
  {
    "codigo":73335002,
    "descripcion":"NÁUSEAS Y VÓMITOS AUMENTADOS"
  },
  {
    "codigo":1651000119109,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE PÁNCREAS"
  },
  {
    "codigo":5964004,
    "descripcion":"TRASTORNO DEL RECTO"
  },
  {
    "codigo":300876006,
    "descripcion":"TUMEFACCIÓN DE ESTRUCTURA CARDIOVASCULAR"
  },
  {
    "codigo":366412006,
    "descripcion":"AMPLITUD DE MOVIMIENTO PASIVO DE EXTENSIÓN DE LA COLUMNA DORSAL - HALLAZGO"
  },
  {
    "codigo":4129001,
    "descripcion":"PUPILA DE ARGYLL - ROBERTSON"
  },
  {
    "codigo":10762151000119101,
    "descripcion":"ADHERENCIA VITREOMACULAR DE OJO IZQUIERDO"
  },
  {
    "codigo":299041004,
    "descripcion":"HALLAZGO RELACIONADO CON EL MOVIMIENTO DE LA MANO"
  },
  {
    "codigo":266273006,
    "descripcion":"TRASTORNOS LINFÁTICOS NO INFECCIOSOS"
  },
  {
    "codigo":167969006,
    "descripcion":"CELULARIDAD EN LÍQUIDO PLEURAL POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":297206003,
    "descripcion":"URETRA CORTA"
  },
  {
    "codigo":721355000,
    "descripcion":"LUXACIÓN TRAUMÁTICA DE SEGUNDA Y TERCERA VÉRTEBRAS CERVICALES"
  },
  {
    "codigo":723190009,
    "descripcion":"INSUFICIENCIA RENAL CRÓNICA"
  },
  {
    "codigo":262603003,
    "descripcion":"CUERPO EXTRAÑO GINGIVAL"
  },
  {
    "codigo":295371005,
    "descripcion":"SOBREDOSIS DE INHIBIDOR DE LA BOMBA DE PROTONES"
  },
  {
    "codigo":129696000,
    "descripcion":"CON MAYOR RIESGO DE RESPUESTA ALÉRGICA A LÁTEX"
  },
  {
    "codigo":719520001,
    "descripcion":"DISTROFIA MACULAR ANULAR CONCÉNTRICA BENIGNA"
  },
  {
    "codigo":195232006,
    "descripcion":"OCLUSIÓN Y ESTENOSIS DE ARTERIA CEREBRAL MEDIA"
  },
  {
    "codigo":1145504006,
    "descripcion":"HIPOPLASIA DE FALANGE DISTAL DE PULGAR"
  },
  {
    "codigo":293536007,
    "descripcion":"REACCIÓN ADVERSA AL DIAZÓXIDO"
  },
  {
    "codigo":291701002,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR AGENTE PLAGUICIDA"
  },
  {
    "codigo":422773005,
    "descripcion":"INESTABILIDAD HEMODINÁMICA"
  },
  {
    "codigo":160629005,
    "descripcion":"IMPOSIBILIDAD FÍSICA PARA REALIZAR EJERCICIO"
  },
  {
    "codigo":95093007,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE PARTES BLANDAS DE LA CARA"
  },
  {
    "codigo":226165008,
    "descripcion":"DIETA CON BAJO CONTENIDO EN FOSFATO"
  },
  {
    "codigo":1141834001,
    "descripcion":"RECUENTO DE EOSINÓFILOS AUMENTADO EN LÍQUIDO ASCÍTICO"
  },
  {
    "codigo":781386002,
    "descripcion":"DEFICIENCIA DE NUDT15"
  },
  {
    "codigo":289866001,
    "descripcion":"PERINEO MUY EDEMATIZADO"
  },
  {
    "codigo":224330000,
    "descripcion":"INVOLUCRADO EN ACTIVIDAD CRIMINAL"
  },
  {
    "codigo":93258005,
    "descripcion":"HIPOPLASIA CONGÉNITA DE HUESO FRONTAL"
  },
  {
    "codigo":420938005,
    "descripcion":"ENDOCARDITIS SUBAGUDA CON SIDA"
  },
  {
    "codigo":11718721000119103,
    "descripcion":"LAGOFTALMOS BILATERAL DE PÁRPADO SUPERIOR"
  },
  {
    "codigo":124191007,
    "descripcion":"DEFICIENCIA DE AZOBENCENO REDUCTASA"
  },
  {
    "codigo":24052000,
    "descripcion":"HIPERCALCEMIA SECUNDARIA A INMOVILIZACIÓN"
  },
  {
    "codigo":25887009,
    "descripcion":"SIGMOIDITIS ALÉRGICA"
  },
  {
    "codigo":1269236003,
    "descripcion":"SÍNDROME DE HIPOMAGNESEMIA PRIMARIA, EPILEPSIA REFRACTARIA Y DISCAPACIDAD INTELECTUAL"
  },
  {
    "codigo":417268008,
    "descripcion":"AMAMANTADO A LOS 4 MESES"
  },
  {
    "codigo":286196008,
    "descripcion":"NO CIERRA LA CASA EN FORMA SEGURA"
  },
  {
    "codigo":253428008,
    "descripcion":"ANOMALÍA DE VÁLVULA AURICULOVENTRICULAR COMÚN EN DEFECTO DEL TABIQUE AURICULOVENTRICULAR"
  },
  {
    "codigo":1300169007,
    "descripcion":"ECTOMORFO"
  },
  {
    "codigo":448201009,
    "descripcion":"CIERRE ESPONTÁNEO DE DEFECTO DE TABIQUE INTERVENTRICULAR DEBIDO A TEJIDO ACCESORIO DE VÁLVULA AURICULOVENTRICULAR"
  },
  {
    "codigo":249758004,
    "descripcion":"TENDONES PROMINENTES EN LA PALMA DE LA MANO"
  },
  {
    "codigo":1003422005,
    "descripcion":"HIPOPLASIA DE NERVIO ÓPTICO DEBIDA A MALFORMACIÓN DEL SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":11774171000119103,
    "descripcion":"CONTUSIÓN DE DEDO ANULAR IZQUIERDO"
  },
  {
    "codigo":708510008,
    "descripcion":"VISUALIZACIÓN DE INCISIVO MAXILAR MÍNIMA"
  },
  {
    "codigo":282526009,
    "descripcion":"SUBE ESCALERAS CORRIENDO"
  },
  {
    "codigo":247923002,
    "descripcion":"MOVIMIENTO DE ALETEO DE LOS BRAZOS"
  },
  {
    "codigo":870515008,
    "descripcion":"REACCIÓN ADVERSA A MACROGOL"
  },
  {
    "codigo":82248001,
    "descripcion":"ÁNIMO EUTÍMICO"
  },
  {
    "codigo":213320003,
    "descripcion":"CHOQUE ANAFILÁCTICO CAUSADO POR SUERO"
  },
  {
    "codigo":737608004,
    "descripcion":"BURSITIS INFRARROTULIANA DE RODILLA DERECHA"
  },
  {
    "codigo":442696006,
    "descripcion":"GRIPE CAUSADA POR VIRUS INFLUENZA A SUBTIPO H1N1"
  },
  {
    "codigo":703005000,
    "descripcion":"MICROCOCCUS LUTEUS O MICROCOCCUS LYLAE"
  },
  {
    "codigo":309789002,
    "descripcion":"ENCEFALITIS CAUSADA POR VIRUS INFLUENZA"
  },
  {
    "codigo":735773002,
    "descripcion":"LACERACIÓN DE ABDOMEN SIN CUERPO EXTRAÑO"
  },
  {
    "codigo":1260061003,
    "descripcion":"CARCINOMA MUCOEPIDERMOIDE DE OROFARINGE"
  },
  {
    "codigo":78578005,
    "descripcion":"ERITROCITOSIS POR NEUMOPATÍA"
  },
  {
    "codigo":766706007,
    "descripcion":"MIOPATÍA INFLAMATORIA CON ABUNDANTES MACRÓFAGOS"
  },
  {
    "codigo":764871007,
    "descripcion":"PROCEDIMIENTO QUIRÚRGICO CANCELADO DESPUÉS DE LA INDUCCIÓN DE LA ANESTESIA"
  },
  {
    "codigo":109511009,
    "descripcion":"DIENTE COMPLETAMENTE IMPACTADO EN HUESO"
  },
  {
    "codigo":1156252001,
    "descripcion":"DESCALZO"
  },
  {
    "codigo":240583009,
    "descripcion":"LESIÓN CUTÁNEA GONOCÓCICA"
  },
  {
    "codigo":42140004,
    "descripcion":"HERNIA INGUINAL BILATERAL RECURRENTE OBSTRUIDA CON GANGRENA"
  },
  {
    "codigo":74908007,
    "descripcion":"AUSENCIA CONGÉNITA DE LA VENA CAVA INFERIOR"
  },
  {
    "codigo":402588008,
    "descripcion":"PREDISPOSICIÓN CONSTITUCIONAL COMO COFACTOR EN ECCEMA"
  },
  {
    "codigo":238748009,
    "descripcion":"HIPERPLASIA SEBÁCEA"
  },
  {
    "codigo":15981071000119101,
    "descripcion":"ECTROPIÓN MECÁNICO DE AMBOS PÁRPADOS SUPERIORES"
  },
  {
    "codigo":204145006,
    "descripcion":"CÓRNEA PLANA"
  },
  {
    "codigo":73073009,
    "descripcion":"ELIPTOCITOSIS HEREDITARIA POR DEFECTO DE ESPECTRINA BETA EN AUTOASOCIACIÓN"
  },
  {
    "codigo":890438002,
    "descripcion":"BRAQUIDACTILIA TIPO A3"
  },
  {
    "codigo":300614002,
    "descripcion":"INCAPAZ DE TRASLADARSE A PIE"
  },
  {
    "codigo":366150007,
    "descripcion":"VOLUMEN DE ESPIRACIÓN FORZADA - HALLAZGO"
  },
  {
    "codigo":724763001,
    "descripcion":"PARKINSONISMO DEBIDO A LESIÓN DE MASA DE CEREBRO"
  },
  {
    "codigo":202310009,
    "descripcion":"ANQUILOSIS DE LA ARTICULACIÓN DE LA MUÑECA"
  },
  {
    "codigo":167707001,
    "descripcion":"ASPECTO DEL LCR (LÍQUIDO CEFALORRAQUÍDEO) LÍMPIDO"
  },
  {
    "codigo":397083001,
    "descripcion":"MARGEN QUIRÚRGICO PANCREÁTICO COMPROMETIDO POR NEOPLASIA MALIGNA"
  },
  {
    "codigo":298779005,
    "descripcion":"SIN AMPLITUD DE MOVIMIENTO ACTIVO DE FLEXIÓN DE HOMBRO"
  },
  {
    "codigo":69403006,
    "descripcion":"AFONÍA POR CONVERSIÓN"
  },
  {
    "codigo":2032001,
    "descripcion":"EDEMA CEREBRAL"
  },
  {
    "codigo":722928002,
    "descripcion":"ENFERMEDAD METABÓLICA ÓSEA DEL PREMATURO"
  },
  {
    "codigo":1279984004,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE DEDO ANULAR CON INFECCIÓN"
  },
  {
    "codigo":1148912006,
    "descripcion":"AZOOSPERMIA POSTVASECTOMÍA"
  },
  {
    "codigo":428016006,
    "descripcion":"CONTUSIÓN DE COSTILLA"
  },
  {
    "codigo":721093000,
    "descripcion":"ENFERMEDAD LINFOPROLIFERATIVA AUTOINMUNITARIA DE DIANZANI"
  },
  {
    "codigo":295109000,
    "descripcion":"ALERGIA A UROCINASA"
  },
  {
    "codigo":296944009,
    "descripcion":"SOBREDOSIS DE YODURO"
  },
  {
    "codigo":15708841000119100,
    "descripcion":"LUXACIÓN RECURRENTE DE ARTICULACIONES DE AMBAS REGIONES DE MUÑECA"
  },
  {
    "codigo":1343685003,
    "descripcion":"ALTERACIÓN CRÓNICA DE ASTA ANTERIOR DE MENISCO EXTERNO DE RODILLA DERECHA"
  },
  {
    "codigo":327877008,
    "descripcion":"OSIFICACIÓN INCOMPLETA"
  },
  {
    "codigo":1145242001,
    "descripcion":"RUPTURA DE DISCO INTERVERTEBRAL CERVICAL"
  },
  {
    "codigo":293274003,
    "descripcion":"REACCIÓN ADVERSA A LAS CORTICOTROFINAS"
  },
  {
    "codigo":719258003,
    "descripcion":"PICNOACONDROGÉNESIS"
  },
  {
    "codigo":94831000,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL OJO"
  },
  {
    "codigo":194970009,
    "descripcion":"DERRAME PERICÁRDICO - NO INFLAMATORIO"
  },
  {
    "codigo":10957481000119104,
    "descripcion":"HERIDA PUNZANTE DE PULGAR DERECHO"
  },
  {
    "codigo":291439006,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR IDOXURIDINA"
  },
  {
    "codigo":225903007,
    "descripcion":"DIFICULTAD PARA CONTROLAR LA CONDUCTA"
  },
  {
    "codigo":27460003,
    "descripcion":"SÍFILIS PRIMARIA DE MAMA"
  },
  {
    "codigo":846660004,
    "descripcion":"ENFERMEDAD INFECCIOSA CRÓNICA DE SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":289604003,
    "descripcion":"APÓSITO VAGINAL - HALLAZGO"
  },
  {
    "codigo":92996006,
    "descripcion":"ANOMALÍA CONGÉNITA DE HUESO BASIESFENOIDAL"
  },
  {
    "codigo":1010500007,
    "descripcion":"AGENESIA DE HUESO METATARSIANO Y DEDO GORDO [COMO UN TODO]"
  },
  {
    "codigo":418841002,
    "descripcion":"TUBO OROTRAQUEAL PRESENTE"
  },
  {
    "codigo":123929005,
    "descripcion":"INTOXICACIÓN POR GENTIANAS"
  },
  {
    "codigo":386073005,
    "descripcion":"DEFICIENCIA DE VITAMINA K1"
  },
  {
    "codigo":253166000,
    "descripcion":"MENINGOCELE LATERAL"
  },
  {
    "codigo":1172505009,
    "descripcion":"HORMONA SOMATOTRÓFICA HUMANA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":255001009,
    "descripcion":"SCHWANNOMA ORBITARIO"
  },
  {
    "codigo":417006004,
    "descripcion":"SÍNDROME DE PERFUSIÓN ARTERIAL INVERSA EN GEMELOS"
  },
  {
    "codigo":56558005,
    "descripcion":"HIPOTRICOSIS CONGÉNITA"
  },
  {
    "codigo":449774007,
    "descripcion":"DIENTE INVAGINADO RADICULAR"
  },
  {
    "codigo":710083001,
    "descripcion":"HALLAZGO RELACIONADO CON LA ALTURA ÓSEA DE MANDÍBULA EDÉNTULA"
  },
  {
    "codigo":284099002,
    "descripcion":"DIFICULTAD PARA TREPAR"
  },
  {
    "codigo":251331003,
    "descripcion":"PERIOSTITIS ALVEOLAR"
  },
  {
    "codigo":184437571000119104,
    "descripcion":"ANOMALÍA ESTRUCTURAL CONGÉNITA DE CUERPO CILIAR"
  },
  {
    "codigo":21955004,
    "descripcion":"CERVICITIS TRICOMONIÁSICA"
  },
  {
    "codigo":447939007,
    "descripcion":"CONEXIÓN VENOSA PULMONAR ANÓMALA PARCIAL DE TODO EL PULMÓN IZQUIERDO"
  },
  {
    "codigo":54723008,
    "descripcion":"ESTADO DE TENSIÓN ERÓTICA"
  },
  {
    "codigo":415171009,
    "descripcion":"OBSERVACIONES SOBRE PRESCRIPCIÓN"
  },
  {
    "codigo":216728001,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR FUNGICIDA"
  },
  {
    "codigo":249496004,
    "descripcion":"HALLAZGO EN EL REFLUJO ESOFÁGICO"
  },
  {
    "codigo":708248004,
    "descripcion":"ENFERMEDAD HEPÁTICA TERMINAL"
  },
  {
    "codigo":247661001,
    "descripcion":"CRÉDULO"
  },
  {
    "codigo":51053007,
    "descripcion":"ENFERMEDAD POR HEMOGLOBINA C"
  },
  {
    "codigo":1263469008,
    "descripcion":"NEOPLASIA MALIGNA DE PARTES BLANDAS DE PULGAR"
  },
  {
    "codigo":737346001,
    "descripcion":"ERITEMA DE PERINEO CAUSADO POR TOXINA ESTREPTOCÓCICA"
  },
  {
    "codigo":49218002,
    "descripcion":"DOLOR EN REGIÓN DE CADERA"
  },
  {
    "codigo":81986001,
    "descripcion":"OSTEODISTROFIA RENAL FIBROSA SECUNDARIA"
  },
  {
    "codigo":280429009,
    "descripcion":"SÍNDROME SOMÁTICO PRESENTE"
  },
  {
    "codigo":278594001,
    "descripcion":"SUPERFICIE DE INCRUSTACIÓN DENTAL RUGOSA"
  },
  {
    "codigo":409666003,
    "descripcion":"FRACTURA PATOLÓGICA DE CUELLO DE FÉMUR"
  },
  {
    "codigo":309527000,
    "descripcion":"MASA DE LA EXTREMIDAD INFERIOR"
  },
  {
    "codigo":473367000,
    "descripcion":"QUISTE PERICÁRDICO A LO LARGO DEL ÁNGULO CARDIOFRÉNICO DERECHO"
  },
  {
    "codigo":1259799006,
    "descripcion":"GLUCAGONOMA MALIGNO PRIMARIO DE PÁNCREAS"
  },
  {
    "codigo":307692001,
    "descripcion":"BAILOTEO OCULAR INVERTIDO"
  },
  {
    "codigo":735511009,
    "descripcion":"QUEMADURA COMPLEJA DE MANO"
  },
  {
    "codigo":438764004,
    "descripcion":"NEUMONÍA POR ASPIRACIÓN POSTERIOR A PROCEDIMIENTO QUIRÚRGICO"
  },
  {
    "codigo":404161006,
    "descripcion":"RETICULOHISTIOCITOSIS CUTÁNEA"
  },
  {
    "codigo":305857007,
    "descripcion":"ATENDIDO POR ORTÓPTICO - SERVICIO"
  },
  {
    "codigo":1074141000119108,
    "descripcion":"CONDROCALCINOSIS DE CADERA DERECHA"
  },
  {
    "codigo":830145009,
    "descripcion":"COLAPSO DEBIDO A ASFIXIA"
  },
  {
    "codigo":109249009,
    "descripcion":"INFLAMACIÓN RELACIONADA CON EL TATUAJE DELIBERADO DE ALGUNA PARTE DEL CUERPO"
  },
  {
    "codigo":1354433009,
    "descripcion":"HERIDA ABIERTA DE PARED POSTERIOR DE TÓRAX DEBIDA A MORDEDURA DE PERRO"
  },
  {
    "codigo":238486004,
    "descripcion":"DEDO DE GRAMILLA"
  },
  {
    "codigo":41878001,
    "descripcion":"SIMBRAQUIDACTILIA DE LOS DEDOS DE LA MANO"
  },
  {
    "codigo":336861000119108,
    "descripcion":"OBSTRUCCIÓN MECÁNICA DE LENTE INTRAOCULAR"
  },
  {
    "codigo":1155990006,
    "descripcion":"REACCIÓN ANAFILACTOIDE CAUSADA POR AGENTE PARASIMPATICOMIMÉTICO"
  },
  {
    "codigo":402326008,
    "descripcion":"PSORIASIS AGUDA PUSTULAR GENERALIZADA DE NOVO"
  },
  {
    "codigo":205718006,
    "descripcion":"QUIMERA 46 XX; 46 XY"
  },
  {
    "codigo":236651001,
    "descripcion":"RETENCIÓN DE ORINA POR COÁGULO"
  },
  {
    "codigo":310391000119104,
    "descripcion":"SÍNDROME DE FRICCIÓN DE LA BANDELETA ILIOTIBIAL DE REGIÓN DE RODILLA DERECHA"
  },
  {
    "codigo":70976000,
    "descripcion":"EPIGLOTITIS VIRAL"
  },
  {
    "codigo":365888002,
    "descripcion":"EJECUCIÓN DE MEMORIA DE LARGO PLAZO - HALLAZGO"
  },
  {
    "codigo":398656003,
    "descripcion":"TRASTORNO HIPOMELANÓTICO ADQUIRIDO"
  },
  {
    "codigo":429589006,
    "descripcion":"DISFUNCIÓN VENTRICULAR IZQUIERDA CARDÍACA"
  },
  {
    "codigo":722666002,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE APARATO LAGRIMAL"
  },
  {
    "codigo":296682004,
    "descripcion":"SOBREDOSIS DE CEFAZOLINA"
  },
  {
    "codigo":294847001,
    "descripcion":"ALERGIA A GELATINA"
  },
  {
    "codigo":425919003,
    "descripcion":"TRASTORNO MENTAL ORGÁNICO CRÓNICO"
  },
  {
    "codigo":120081000119104,
    "descripcion":"SENSACIÓN DE CUERPO EXTRAÑO EN FAUCES"
  },
  {
    "codigo":282803008,
    "descripcion":"LESIÓN DE GANGLIO ÓTICO"
  },
  {
    "codigo":720831008,
    "descripcion":"DEFICIENCIA DE CATEPSINA D"
  },
  {
    "codigo":131007009,
    "descripcion":"PROLACTINA ANORMAL"
  },
  {
    "codigo":1144980001,
    "descripcion":"ANAFILAXIA POSTPRANDIAL INDUCIDA POR EJERCICIO"
  },
  {
    "codigo":293012002,
    "descripcion":"REACCIÓN ADVERSA A LA CEFPODOXIMA"
  },
  {
    "codigo":161940008,
    "descripcion":"DISNEA CON ESFUERZO LEVE"
  },
  {
    "codigo":94569002,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA PIEL DEL HUECO POPLÍTEO"
  },
  {
    "codigo":225641003,
    "descripcion":"PREOCUPADA ACERCA DE LA POSIBILIDAD DE SER UNA MALA MADRE"
  },
  {
    "codigo":782697005,
    "descripcion":"CARCINOMA PSEUDOPAPILAR SÓLIDO DE PÁNCREAS"
  },
  {
    "codigo":127337006,
    "descripcion":"CARDIOPATÍA AGUDA"
  },
  {
    "codigo":291177006,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR TIETILPERAZINA"
  },
  {
    "codigo":289342000,
    "descripcion":"TRAZADO CARDIOTOCOGRÁFICO NORMAL"
  },
  {
    "codigo":92734000,
    "descripcion":"CARCINOMA IN SITU DE LA PIEL DE LOS LABIOS"
  },
  {
    "codigo":1010238005,
    "descripcion":"HIPOACUSIA CONDUCTIVA DE OÍDO IZQUIERDO"
  },
  {
    "codigo":418579000,
    "descripcion":"REACCIÓN ALÉRGICA CAUSADA POR COLOFONIA"
  },
  {
    "codigo":25363001,
    "descripcion":"FALTA DE DISYUNCIÓN GENÉTICA"
  },
  {
    "codigo":713491003,
    "descripcion":"SÍNDROME CEREBRAL ORGÁNICO CONCOMITANTE CON INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":254739004,
    "descripcion":"ELASTOFIBROMA CUTÁNEO"
  },
  {
    "codigo":37771000087101,
    "descripcion":"COÁGULOS SANGUÍNEOS EN ORINA"
  },
  {
    "codigo":123667006,
    "descripcion":"CORION MADURO ANORMAL"
  },
  {
    "codigo":40331000087102,
    "descripcion":"DISTENSIÓN DE TENDÓN DE DEDO PULGAR DERECHO"
  },
  {
    "codigo":48011000087106,
    "descripcion":"FRACTURA DE DIÁFISIS DE CÚBITO DERECHO"
  },
  {
    "codigo":60811000087108,
    "descripcion":"INFECCIÓN CAUSADA POR CRONOBACTER"
  },
  {
    "codigo":42891000087109,
    "descripcion":"HERIDA DE MAMA DERECHA POR MORDEDURA"
  },
  {
    "codigo":1268712008,
    "descripcion":"MESOTELIOMA MALIGNO PRIMARIO DE PERITONEO"
  },
  {
    "codigo":283837005,
    "descripcion":"HERIDA POR MORDEDURA DE PEZ"
  },
  {
    "codigo":16696901000119102,
    "descripcion":"ENTERITIS ISQUÉMICA DIFUSA AGUDA"
  },
  {
    "codigo":216466002,
    "descripcion":"INTOXICACIÓN ACCIDENTAL CAUSADA POR CODEÍNA"
  },
  {
    "codigo":707986004,
    "descripcion":"PENFIGOIDE DE MEMBRANA MUCOSA CON COMPROMISO ESOFÁGICO"
  },
  {
    "codigo":1076651000119109,
    "descripcion":"TENDINITIS DE ADUCTOR DE LA CADERA IZQUIERDO"
  },
  {
    "codigo":247399001,
    "descripcion":"DOLOR SEUDOTALÁMICO"
  },
  {
    "codigo":312935003,
    "descripcion":"HEMANGIOMA CAPILAR DE RETINA"
  },
  {
    "codigo":48956000,
    "descripcion":"FRACTURA EXPUESTA DE VÉRTEBRA LUMBAR CON LESIÓN TRAUMÁTICA DE LA MÉDULA ESPINAL"
  },
  {
    "codigo":1163068009,
    "descripcion":"ENCEFALITIS POR VESICULOVIRUS"
  },
  {
    "codigo":440337002,
    "descripcion":"TRANSITORIAMENTE INCAPAZ DE REALIZAR ACTIVIDADES LABORALES POR AFECCIÓN MÉDICA"
  },
  {
    "codigo":968361541000119107,
    "descripcion":"SOFOCO CAUSADO POR INHIBIDOR DE AROMATASA"
  },
  {
    "codigo":407569005,
    "descripcion":"PACIENTE CON TRATAMIENTO ANTIDIABÉTICO EN DOSIS MÁXIMA TOLERADA"
  },
  {
    "codigo":210961008,
    "descripcion":"SECUELAS POR LESIÓN OCASIONADA POR APLASTAMIENTO Y AMPUTACIÓN TRAUMÁTICA DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":209126000,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE LA PELVIS"
  },
  {
    "codigo":897254000,
    "descripcion":"CURVATURA ANORMAL DE FALANGE PROXIMAL DE TERCER DEDO DE PIE"
  },
  {
    "codigo":1259537009,
    "descripcion":"CARCINOMA PRIMARIO DE CUERDA VOCAL"
  },
  {
    "codigo":274662006,
    "descripcion":"PARÁLISIS TRANSITORIA DE MIEMBRO"
  },
  {
    "codigo":241894006,
    "descripcion":"EFECTO TÓXICO CAUSADO POR DETERGENTE O CERA PARA LIMPIAR AUTOMÓVILES"
  },
  {
    "codigo":372966007,
    "descripcion":"INFECCIÓN CAUSADA POR PENICILLIUM RUGULOSUM"
  },
  {
    "codigo":78054007,
    "descripcion":"ÚLCERA DUODENAL POSTBULBAR"
  },
  {
    "codigo":471270009,
    "descripcion":"CURVA DE SPEE INVERTIDA"
  },
  {
    "codigo":403899005,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS DE LA PIEL DEL TRONCO"
  },
  {
    "codigo":305595009,
    "descripcion":"BAJO ATENCIÓN DE MUSICOTERAPEUTA"
  },
  {
    "codigo":762512002,
    "descripcion":"TRASTORNO DEL ESTADO DE ÁNIMO CON SÍNTOMAS DEPRESIVOS CAUSADO POR CATINONA SINTÉTICA"
  },
  {
    "codigo":860816004,
    "descripcion":"CELULITIS EN LUGAR DE INYECCIÓN"
  },
  {
    "codigo":205456006,
    "descripcion":"HIPOPLASIA DE LA COLUMNA VERTEBRAL"
  },
  {
    "codigo":7013003,
    "descripcion":"RESPIRACIÓN EN SALVAS"
  },
  {
    "codigo":301925004,
    "descripcion":"LESIÓN DE PLIEGUE SEMILUNAR"
  },
  {
    "codigo":444128991000119108,
    "descripcion":"ÚLCERA VENOSA DE TALÓN IZQUIERDO"
  },
  {
    "codigo":365626003,
    "descripcion":"HALLAZGO RELACIONADO CON LA MORFOLOGÍA LEUCOCITARIA"
  },
  {
    "codigo":234554004,
    "descripcion":"DEFICIENCIA DE PIEZA SECRETORIA"
  },
  {
    "codigo":218521311000119109,
    "descripcion":"PORTADOR DE SÍNDROME DE USHER TIPO 1F"
  },
  {
    "codigo":267322007,
    "descripcion":"EMBARAZO CON PROBLEMA ORTOPÉDICO"
  },
  {
    "codigo":300090008,
    "descripcion":"HALLAZGO RELACIONADO CON EL OLOR DEL OÍDO"
  },
  {
    "codigo":1119290007,
    "descripcion":"POROQUERATOSIS LINEAL SISTEMATIZADA"
  },
  {
    "codigo":396559007,
    "descripcion":"TUMOR NECRÓTICO"
  },
  {
    "codigo":167183007,
    "descripcion":"DEPURACIÓN DE CREATININA-FILTRACIÓN GLOMERULAR FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":298255009,
    "descripcion":"DOLOR EN EL MOVIMIENTO ARTICULAR"
  },
  {
    "codigo":198116001,
    "descripcion":"SIGNOS Y SÍNTOMAS MAMARIOS"
  },
  {
    "codigo":427492003,
    "descripcion":"CÁNCER DE PRÓSTATA REFRACTARIO A LAS HORMONAS"
  },
  {
    "codigo":1079161000119106,
    "descripcion":"CARCINOMA BASOCELULAR PRIMARIO DE PABELLÓN AURICULAR DERECHO"
  },
  {
    "codigo":34276006,
    "descripcion":"PULSO FEMORAL NORMAL"
  },
  {
    "codigo":425657001,
    "descripcion":"MIELOMA OSTEOESCLERÓTICO"
  },
  {
    "codigo":65209002,
    "descripcion":"BASOFILIA"
  },
  {
    "codigo":294585005,
    "descripcion":"ALERGIA A DOXICICLINA"
  },
  {
    "codigo":720569006,
    "descripcion":"BRAQUIDACTILIA TIPO A2"
  },
  {
    "codigo":1144718006,
    "descripcion":"HIPOPLASIA CONGÉNITA DE FALANGE DE SEGUNDO DEDO DE PIE"
  },
  {
    "codigo":292750006,
    "descripcion":"REACCIÓN ADVERSA AL EDETATO DISÓDICO"
  },
  {
    "codigo":61539000,
    "descripcion":"RUIDOS INTESTINALES NORMALES"
  },
  {
    "codigo":290915001,
    "descripcion":"INTOXICACIÓN POR MAPROTILINA"
  },
  {
    "codigo":94307001,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL PREPUCIO"
  },
  {
    "codigo":127075003,
    "descripcion":"LINFADENOPATÍA PROFUNDA"
  },
  {
    "codigo":192611004,
    "descripcion":"TRASTORNO DE ANSIEDAD FÓBICA DE LA INFANCIA"
  },
  {
    "codigo":1208419007,
    "descripcion":"HALLAZGO DE PRESENCIA DE SUSTANCIA"
  },
  {
    "codigo":92472006,
    "descripcion":"NEOPLASIA BENIGNA DE LA ÚVULA"
  },
  {
    "codigo":715064006,
    "descripcion":"INTOXICACIÓN ACCIDENTAL CAUSADA POR ÁCIDO 2,4-DICLOROFENOXIACÉTICO"
  },
  {
    "codigo":289080009,
    "descripcion":"CAPAZ DE AMAMANTAR"
  },
  {
    "codigo":418317006,
    "descripcion":"TALLA SUPERIOR AL PROMEDIO"
  },
  {
    "codigo":713229006,
    "descripcion":"ENFERMEDAD GINGIVAL DEBIDA A ERITEMA MULTIFORME"
  },
  {
    "codigo":254477009,
    "descripcion":"NEOPLASIA DE CORNETE NASAL INFERIOR"
  },
  {
    "codigo":1237517009,
    "descripcion":"METÁSTASIS DE CARCINOMA DE HUESOS PÉLVICOS, SACRO Y CÓCCIX"
  },
  {
    "codigo":56034001,
    "descripcion":"EXHIBICIONISMO COMPULSIVO"
  },
  {
    "codigo":416482004,
    "descripcion":"GASTROENTERITIS DE ORIGEN ALIMENTARIO"
  },
  {
    "codigo":1137378008,
    "descripcion":"HIPOTIROIDISMO DEBIDO A RADIOTERAPIA Y POSTERIOR A ELLA"
  },
  {
    "codigo":449250008,
    "descripcion":"ARTRITIS INFECCIOSA DE ARTICULACIÓN INTERFALÁNGICA PROXIMAL DE DEDO DE MANO"
  },
  {
    "codigo":283575000,
    "descripcion":"HERIDA DE PERDIGÓN EN ABDOMEN"
  },
  {
    "codigo":187106009,
    "descripcion":"PENICILOSIS"
  },
  {
    "codigo":840631004,
    "descripcion":"ÚTERO GRÁVIDO DE TAMAÑO CORRESPONDIENTE A 34-36 SEMANAS"
  },
  {
    "codigo":185271006,
    "descripcion":"ATENDIDO EN CONSULTORIO ESPECIALIZADO EN PATOLOGÍA MAMARIA"
  },
  {
    "codigo":447415007,
    "descripcion":"QUISTE DEL RAFE MEDIO DEL PENE"
  },
  {
    "codigo":314508003,
    "descripcion":"PTOSIS MIÓGENA CONGÉNITA"
  },
  {
    "codigo":216204004,
    "descripcion":"LESIÓN POR MAQUINARIA EN AERONAVE, SIN ACCIDENTE DE AERONAVE, VIAJERO EN AERONAVE COMERCIAL EN TRANSPORTE DESDE TIERRA Y MAR AL AIRE LESIONADO"
  },
  {
    "codigo":707724006,
    "descripcion":"NIVEL DE ENZIMAS HEPÁTICAS POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1363084007,
    "descripcion":"ASTILLA EN PIERNA CON INFECCIÓN"
  },
  {
    "codigo":445580008,
    "descripcion":"CROMOSOMA ESTRUCTURALMENTE ANORMAL NO IDENTIFICADO ADICIONAL FAMILIAR"
  },
  {
    "codigo":50529000,
    "descripcion":"INTOXICACIÓN CAUSADA POR ACETOHEXAMIDA"
  },
  {
    "codigo":247137007,
    "descripcion":"ANASTOMOSIS MICROVASCULAR RETINIANA"
  },
  {
    "codigo":441910000,
    "descripcion":"HIPOVENTILACIÓN ALVEOLAR NO OBSTRUCTIVA IDIOPÁTICA RELACIONADA CON EL SUEÑO"
  },
  {
    "codigo":1162806001,
    "descripcion":"SOBREDOSIS INTENCIONAL DE VALPROATO"
  },
  {
    "codigo":48694002,
    "descripcion":"ANSIEDAD"
  },
  {
    "codigo":1081671000119103,
    "descripcion":"RABDOMIOSARCOMA PRIMARIO DE EXTREMIDAD INFERIOR DERECHA"
  },
  {
    "codigo":344391000119103,
    "descripcion":"CORIORRETINITIS FOCAL DE POLO POSTERIOR DE AMBOS OJOS"
  },
  {
    "codigo":866059000,
    "descripcion":"MIELITIS CAUSADA POR VIRUS COXSACKIE HUMANO DEL GRUPO A"
  },
  {
    "codigo":734987002,
    "descripcion":"SÍNDROME DE DOLOR REGIONAL COMPLEJO DE PIE"
  },
  {
    "codigo":1193739006,
    "descripcion":"ENTERITIS POR MYCOBACTERIUM NO TUBERCULOSIS"
  },
  {
    "codigo":472843009,
    "descripcion":"ESTENOSIS DE VÁLVULA MITRAL FETAL"
  },
  {
    "codigo":833291009,
    "descripcion":"CÁLCULO DE OXALATO DE CALCIO DE RIÑÓN"
  },
  {
    "codigo":14091009,
    "descripcion":"SÍNDROME DE TRISOMÍA PARCIAL 12P"
  },
  {
    "codigo":208864006,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE MÚLTIPLES DÍGITOS"
  },
  {
    "codigo":272565002,
    "descripcion":"POSICIÓN SUPINA CON LAS RODILLAS INCLINADAS"
  },
  {
    "codigo":403637008,
    "descripcion":"INFLAMACIÓN CUTÁNEA DEBIDA A TRATAMIENTO CITOTÓXICO"
  },
  {
    "codigo":15991111000119109,
    "descripcion":"PARS PLANITIS BILATERAL"
  },
  {
    "codigo":303498006,
    "descripcion":"DIFICULTAD PARA PONERSE DE COSTADO EN LA CAMA"
  },
  {
    "codigo":762250009,
    "descripcion":"ANOMALÍA CONGÉNITA DE VASO DE GRAN CALIBRE"
  },
  {
    "codigo":301663005,
    "descripcion":"INCAPAZ DE ACOSTARSE Y LEVANTARSE DE UNA CAMA"
  },
  {
    "codigo":399967006,
    "descripcion":"NEOPLASIA DE ESTÓMAGO DE COMPORTAMIENTO INCIERTO"
  },
  {
    "codigo":236127007,
    "descripcion":"FÍSTULA INTERNA DE ESTOMA"
  },
  {
    "codigo":1055327006,
    "descripcion":"HIPOPLASIA CONGÉNITA DE DIENTE DECIDUO"
  },
  {
    "codigo":1153631008,
    "descripcion":"EMBOLIA DE ARTERIA CARÓTIDA DERECHA"
  },
  {
    "codigo":299828002,
    "descripcion":"REFLEJO TRICIPITAL RETARDADO"
  },
  {
    "codigo":70452003,
    "descripcion":"ANOMALÍA DEL PAR DE CROMOSOMAS 22"
  },
  {
    "codigo":365364005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA RESISTIR PENSAMIENTOS PELIGROSOS"
  },
  {
    "codigo":267060006,
    "descripcion":"SÍNTOMA DE DIARREA"
  },
  {
    "codigo":1217332007,
    "descripcion":"TRISTEZA CRÓNICA"
  },
  {
    "codigo":789513001,
    "descripcion":"PÉRDIDA DE LONGITUD DE ARCADA DENTAL DEBIDA A PÉRDIDA DE DIENTES PERMANENTES"
  },
  {
    "codigo":723977001,
    "descripcion":"RECUPERACIÓN DE NEUTRÓFILOS"
  },
  {
    "codigo":166921001,
    "descripcion":"GLUCOSA EN SANGRE DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":297993006,
    "descripcion":"PELO BLANCO"
  },
  {
    "codigo":232457008,
    "descripcion":"PAPILOMATOSIS LARÍNGEA"
  },
  {
    "codigo":296158005,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE SULPIRIDA"
  },
  {
    "codigo":34014006,
    "descripcion":"ENFERMEDAD VIRAL"
  },
  {
    "codigo":230622009,
    "descripcion":"LESIÓN DEL NERVIO PERIFÉRICO POR TRACCIÓN"
  },
  {
    "codigo":425395001,
    "descripcion":"TESTAMENTO VITAL ACTIVO"
  },
  {
    "codigo":30728000,
    "descripcion":"PENDELLUFT"
  },
  {
    "codigo":196019004,
    "descripcion":"BRONQUITIS Y NEUMONITIS CAUSADAS POR VAPORES QUÍMICOS"
  },
  {
    "codigo":344015141000119100,
    "descripcion":"ISQUEMIA AGUDA DE COLON DEBIDA A TROMBOSIS DE VENA MESENTÉRICA"
  },
  {
    "codigo":112421000119102,
    "descripcion":"DESHIDRATACIÓN CAUSADA POR RADIACIÓN"
  },
  {
    "codigo":337701000119103,
    "descripcion":"DESPRENDIMIENTO SEROSO DEL EPITELIO PIGMENTARIO RETINIANO DEL OJO IZQUIERDO"
  },
  {
    "codigo":32179007,
    "descripcion":"FORÚNCULO DEL TABIQUE NASAL"
  },
  {
    "codigo":1085221000119103,
    "descripcion":"HEMORRAGIA RECTAL DEBIDA A PROCTITIS ULCEROSA CRÓNICA"
  },
  {
    "codigo":15935781000119106,
    "descripcion":"DEFORMIDAD CONGÉNITA DE CLAVÍCULA DERECHA"
  },
  {
    "codigo":84261000119106,
    "descripcion":"OTITIS MEDIA AGUDA PERSISTENTE"
  },
  {
    "codigo":15966501000119108,
    "descripcion":"DISECCIÓN DE ARTERIA RENAL DERECHA"
  },
  {
    "codigo":792255781000119102,
    "descripcion":"FIBROMATOSIS AGRESIVA DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":117541000119106,
    "descripcion":"INCONTINENCIA URINARIA DEBIDA A HIPERTROFIA PROSTÁTICA BENIGNA"
  },
  {
    "codigo":95880003,
    "descripcion":"INFECCIÓN DE PARTES BLANDAS"
  },
  {
    "codigo":1092901000119107,
    "descripcion":"QUISTE MUCOSO DE LABIO SUPERIOR"
  },
  {
    "codigo":11995941000119109,
    "descripcion":"HEMATOMA DE MUÑÓN DE AMPUTACIÓN DE EXTREMIDAD SUPERIOR DERECHA"
  },
  {
    "codigo":291621000119109,
    "descripcion":"DÉFICIT COGNITIVO DEBIDO A HEMORRAGIA SUBARACNOIDEA NO TRAUMÁTICA Y POSTERIOR A ELLA"
  },
  {
    "codigo":325657381000119109,
    "descripcion":"HEMATOMA TRAUMÁTICO DE RETROPERITONEO"
  },
  {
    "codigo":292488009,
    "descripcion":"REACCIÓN ADVERSA A LA NORADRENALINA"
  },
  {
    "codigo":17701000119108,
    "descripcion":"VEJIGA URINARIA NEUROPÁTICA NO DISTENSIBLE"
  },
  {
    "codigo":421725003,
    "descripcion":"COMA HIPOGLUCÉMICO EN DIABETES MELLITUS"
  },
  {
    "codigo":1144456006,
    "descripcion":"APLASIA DE DEDO MEDIO DE MANO"
  },
  {
    "codigo":290653008,
    "descripcion":"HIPOPITUITARISMO POSPARTO"
  },
  {
    "codigo":346901000119101,
    "descripcion":"DESPRENDIMIENTO DE COROIDES DE AMBOS OJOS"
  },
  {
    "codigo":126813005,
    "descripcion":"NEOPLASIA DE LA CARA ANTERIOR DE LA EPIGLOTIS"
  },
  {
    "codigo":94045007,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA PIEL DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":288818004,
    "descripcion":"CAPAZ DE IMITAR GESTOS"
  },
  {
    "codigo":124978005,
    "descripcion":"ALTERACIÓN EN LA DIVISIÓN CELULAR"
  },
  {
    "codigo":11815701000119102,
    "descripcion":"RUPTURA TRAUMÁTICA DE PLACA PALMAR DE ARTICULACIÓN DE DEDO MEDIO DE MANO DERECHA"
  },
  {
    "codigo":1237255000,
    "descripcion":"TRASTORNO FETAL DEBIDO A ANOMALÍA PLACENTARIA"
  },
  {
    "codigo":92210009,
    "descripcion":"NEOPLASIA BENIGNA DEL MAXILAR SUPERIOR"
  },
  {
    "codigo":254215005,
    "descripcion":"ERITROQUERATODERMIA"
  },
  {
    "codigo":57607007,
    "descripcion":"ASMA OCUPACIONAL"
  },
  {
    "codigo":88540000,
    "descripcion":"DEFICIENCIA DE FACTOR XI, TIPO I"
  },
  {
    "codigo":876807009,
    "descripcion":"CUERPO EXTRAÑO EN MEMBRANA MUCOSA GINGIVAL CON INFECCIÓN"
  },
  {
    "codigo":23004002,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE MAMA, CON INFECCIÓN"
  },
  {
    "codigo":185009000,
    "descripcion":"INFORME MÉDICO ENVIADO"
  },
  {
    "codigo":448988009,
    "descripcion":"NEOPLASIA EPITELIAL MALIGNA DE NARIZ"
  },
  {
    "codigo":283313001,
    "descripcion":"ASTILLA DE MADERA EN TOBILLO"
  },
  {
    "codigo":1084181000119107,
    "descripcion":"OTITIS MEDIA NO SUPURATIVA BILATERAL"
  },
  {
    "codigo":248710002,
    "descripcion":"VASO SANGUÍNEO PROMINENTE"
  },
  {
    "codigo":1264518004,
    "descripcion":"REQUIERE COBERTURA ANTIBIÓTICA PARA PROCEDIMIENTO DENTAL"
  },
  {
    "codigo":52102006,
    "descripcion":"ENOFTALMOS POR TRAUMATISMO"
  },
  {
    "codigo":19334007,
    "descripcion":"CONVULSIÓN POR ESTRÉS"
  },
  {
    "codigo":281478007,
    "descripcion":"DEFORMIDAD ADQUIRIDA FIJA EN FLEXIÓN DE HOMBRO"
  },
  {
    "codigo":246875002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CONJUNTIVA"
  },
  {
    "codigo":50267003,
    "descripcion":"AGRANDAMIENTO CONGÉNITO DE LA NASOFARINGE"
  },
  {
    "codigo":83035003,
    "descripcion":"QUILOTÓRAX"
  },
  {
    "codigo":443483005,
    "descripcion":"HÁBITOS HIGIÉNICOS DE SUEÑO INADECUADOS"
  },
  {
    "codigo":115803008,
    "descripcion":"FENOTIPO EN (A - )"
  },
  {
    "codigo":212272002,
    "descripcion":"LESIÓN TRAUMÁTICA ABIERTA DE NERVIO RADIAL"
  },
  {
    "codigo":769328005,
    "descripcion":"CÉLULA TALLO DEL DOMINIO BACTERIA PRESENTE"
  },
  {
    "codigo":79365001,
    "descripcion":"ESTRÉS DISMINUIDO"
  },
  {
    "codigo":110298001,
    "descripcion":"HIGIENE BUCAL-HALLAZGO"
  },
  {
    "codigo":208602005,
    "descripcion":"FRACTURA EXPUESTA DE RÓTULA, TRANSVERSAL"
  },
  {
    "codigo":403375001,
    "descripcion":"HIPERHIDROSIS PALMOPLANTAR"
  },
  {
    "codigo":698287002,
    "descripcion":"MELANOMA MALIGNO DE ENCÍA"
  },
  {
    "codigo":1255343001,
    "descripcion":"RUPTURA TRAUMÁTICA DE LIGAMENTO SEMILUNOPIRAMIDAL"
  },
  {
    "codigo":130121000119104,
    "descripcion":"DEMENCIA DEBIDA A SÍNDROME DE RETT"
  },
  {
    "codigo":42927005,
    "descripcion":"NEFROSIS COLÉMICA"
  },
  {
    "codigo":75695007,
    "descripcion":"PERISTALTISMO INVERTIDO"
  },
  {
    "codigo":237700006,
    "descripcion":"HIPOPITUITARISMO POR SOBRECARGA DE HIERRO"
  },
  {
    "codigo":432473000,
    "descripcion":"PELLIZCAMIENTO FEMOROACETABULAR"
  },
  {
    "codigo":301401001,
    "descripcion":"DOLOR A LA PALPACIÓN EN LA REGIÓN DE LA CABEZA Y EL CUELLO"
  },
  {
    "codigo":73860009,
    "descripcion":"QUERIÓN CAUSADO POR TRICHOPHYTON"
  },
  {
    "codigo":268633003,
    "descripcion":"TRASTORNO DE PERSONALIDAD INTROVERTIDA"
  },
  {
    "codigo":235865005,
    "descripcion":"SOBREINFECCIÓN DE PORTADOR DE HEPATITIS B CON HEPATITIS D"
  },
  {
    "codigo":70190001,
    "descripcion":"ADHERENCIA PERITONEAL"
  },
  {
    "codigo":4654002,
    "descripcion":"ALTERACIÓN DE LA COLORACIÓN DENTAL POSERUPTIVA"
  },
  {
    "codigo":1153369009,
    "descripcion":"ESPONDILOARTRITIS AXIAL CON COMPROMISO ARTICULAR PERIFÉRICO"
  },
  {
    "codigo":1217070004,
    "descripcion":"OSTEODISTROFIA RENAL POR HIPERPARATIROIDISMO"
  },
  {
    "codigo":299566005,
    "descripcion":"HALLAZGO RELACIONADO CON LA ESTRUCTURA MUSCULOESQUELÉTICA DE DEDO DEL PIE"
  },
  {
    "codigo":365102001,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA ENTRAR Y SALIR DE LA BAÑERA"
  },
  {
    "codigo":234030001,
    "descripcion":"SÍNDROME DE ROBO ARTERIAL INVERSO"
  },
  {
    "codigo":102958008,
    "descripcion":"HIPERPOLARIZACIÓN DE LAS NEURONAS Y DE LAS FIBRAS NERVIOSAS"
  },
  {
    "codigo":789251000,
    "descripcion":"ALERGIA A INHIBIDOR DE ACETILCOLINESTERASA"
  },
  {
    "codigo":11818211000119104,
    "descripcion":"ESGUINCE DE LIGAMENTO DE ARTICULACIÓN METACARPOFALÁNGICA DE DEDO MEDIO DE MANO DERECHA"
  },
  {
    "codigo":2819007,
    "descripcion":"INTOXICACIÓN POR SULFATO DE MAGNESIO"
  },
  {
    "codigo":984000,
    "descripcion":"CELULITIS PERIRRECTAL"
  },
  {
    "codigo":263128001,
    "descripcion":"ESGUINCE DE LIGAMENTO DE CODO"
  },
  {
    "codigo":295896003,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE IPRONIAZIDA"
  },
  {
    "codigo":721880009,
    "descripcion":"SÍNDROME DE MICROGASTRIA CONGÉNITA CON DEFECTO DE REDUCCIÓN DE MIEMBRO"
  },
  {
    "codigo":66520009,
    "descripcion":"HIRSUTISMO FEMENINO"
  },
  {
    "codigo":294061007,
    "descripcion":"ALERGIA A DOPAMINA"
  },
  {
    "codigo":228525007,
    "descripcion":"EXPUESTO AL TABACO EN LUGARES PÚBLICOS"
  },
  {
    "codigo":95618001,
    "descripcion":"DEPRESIÓN RESPIRATORIA NEONATAL"
  },
  {
    "codigo":107771000119106,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE CÉLULAS CLARAS DE ENDOMETRIO"
  },
  {
    "codigo":718210003,
    "descripcion":"DEFICIENCIA DE MONOAMINO OXIDASA A"
  },
  {
    "codigo":193922006,
    "descripcion":"INFESTACIÓN PARASITARIA DEL PÁRPADO"
  },
  {
    "codigo":126551000,
    "descripcion":"NEOPLASIA DE LA MANDÍBULA"
  },
  {
    "codigo":290391000,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR HIDRÓXIDO DE ALUMINIO"
  },
  {
    "codigo":292226008,
    "descripcion":"REACCIÓN ADVERSA A LA IDARUBICINA"
  },
  {
    "codigo":93783009,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE EPIDÍDIMO"
  },
  {
    "codigo":91948008,
    "descripcion":"INFECCIÓN ASINTOMÁTICA POR VIRUS DE LA INMUNODEFICIENCIA HUMANA DURANTE EL EMBARAZO"
  },
  {
    "codigo":253953001,
    "descripcion":"CADERA LUXABLE"
  },
  {
    "codigo":286721004,
    "descripcion":"CARÁCTER ALTAMENTE SOCIABLE"
  },
  {
    "codigo":1236993008,
    "descripcion":"INFLAMACIÓN DE MARGEN LIBRE ANTERIOR DE PÁRPADO INFERIOR DERECHO"
  },
  {
    "codigo":88278002,
    "descripcion":"DISGRAFÍA"
  },
  {
    "codigo":448726004,
    "descripcion":"TRAYECTO PARALELO DE AORTA Y ARTERIA PULMONAR"
  },
  {
    "codigo":284886004,
    "descripcion":"DIFICULTAD PARA CORTARSE LAS UÑAS DE LAS MANOS"
  },
  {
    "codigo":55510008,
    "descripcion":"AURÍCULA ACCESORIA"
  },
  {
    "codigo":250283001,
    "descripcion":"BACTERIAS CITOPLASMÁTICAS PRESENTES"
  },
  {
    "codigo":86443005,
    "descripcion":"DIENTES DE HUTCHINSON"
  },
  {
    "codigo":16270871000119105,
    "descripcion":"BULIMIA NERVIOSA EN REMISIÓN TOTAL"
  },
  {
    "codigo":283051009,
    "descripcion":"ABRASIÓN DE PIEL DE OREJA"
  },
  {
    "codigo":707200002,
    "descripcion":"AORTA DESCENDENTE ANTERIOR Y DEL MISMO LADO QUE LA VENA ÁCIGOS CON AUSENCIA DE VENA CAVA INFERIOR"
  },
  {
    "codigo":1297024000,
    "descripcion":"CIERRE DE ÁNGULO DE AMBOS OJOS DEBIDO A SÍNDROME ENDOTELIAL IRIDOCORNEAL"
  },
  {
    "codigo":19072006,
    "descripcion":"CONTROL DE LA LIBIDO"
  },
  {
    "codigo":770901001,
    "descripcion":"SÍNDROME DE DISCAPACIDAD INTELECTUAL, DISFUNCIÓN MOTRIZ Y CONTRACTURA DE MÚLTIPLES ARTICULACIONES, AUTOSÓMICO RECESIVO"
  },
  {
    "codigo":312149008,
    "descripcion":"INFECCIÓN MICÓTICA DEL APARATO RESPIRATORIO"
  },
  {
    "codigo":1196885009,
    "descripcion":"ADENOMA DE AMPOLLA DE VATER TIPO INTESTINAL"
  },
  {
    "codigo":703530005,
    "descripcion":"MIOPATÍA DE BRODY"
  },
  {
    "codigo":15402006,
    "descripcion":"LITIASIS DEL PÁNCREAS"
  },
  {
    "codigo":1162282006,
    "descripcion":"RABDOMIOSARCOMA PRIMARIO DE MIOMETRIO DE CUERPO UTERINO"
  },
  {
    "codigo":212010008,
    "descripcion":"CORROSIÓN DE PRIMER GRADO DE TOBILLO Y PIE"
  },
  {
    "codigo":79103001,
    "descripcion":"INTOXICACIÓN POR PASPALUM"
  },
  {
    "codigo":13567002,
    "descripcion":"EFECTOS DE LA PRESIÓN AÉREA OCASIONADA POR UNA EXPLOSIÓN"
  },
  {
    "codigo":210175000,
    "descripcion":"LACERACIÓN MODERADA DE HÍGADO CON HERIDA ABIERTA HACIA CAVIDAD"
  },
  {
    "codigo":472319004,
    "descripcion":"MIOCARDIOPATÍA MITOCONDRIAL INFANTIL FATAL"
  },
  {
    "codigo":699860004,
    "descripcion":"SOPORTE MÍNIMO DE CRESTA ALVEOLAR DE MAXILAR SUPERIOR PARA PRÓTESIS DENTAL"
  },
  {
    "codigo":110036008,
    "descripcion":"AVULSIÓN DE LA REGIÓN PERIORBITARIA"
  },
  {
    "codigo":1156777001,
    "descripcion":"POLIARTRITIS JUVENIL NEGATIVA PARA ANTICUERPOS ANTIPÉPTIDO CÍCLICO CITRULINADO Y POSITIVA PARA FACTOR REUMATOIDE"
  },
  {
    "codigo":75433006,
    "descripcion":"INTOXICACIÓN POR MEDICAGO"
  },
  {
    "codigo":403113007,
    "descripcion":"MICETOMA CAUSADO POR CURVULARIA LUNATA"
  },
  {
    "codigo":204670005,
    "descripcion":"ESPASMO PILÓRICO CONGÉNITO"
  },
  {
    "codigo":401278005,
    "descripcion":"TARDE PARA LA CITA"
  },
  {
    "codigo":237438009,
    "descripcion":"ABSCESO MAMARIO SUBAREOLAR"
  },
  {
    "codigo":301139003,
    "descripcion":"HALLAZGO RELACIONADO CON ARTERIA SISTÉMICA"
  },
  {
    "codigo":235603003,
    "descripcion":"ESOFAGITIS VIRAL"
  },
  {
    "codigo":432211007,
    "descripcion":"HEMATOMA CALCIFICADO DE LA CABEZA"
  },
  {
    "codigo":1251411007,
    "descripcion":"DERMATITIS ATÓPICA ERITEMATOSA GENERALIZADA EN LA INFANCIA"
  },
  {
    "codigo":170067008,
    "descripcion":"PERÍMETRO CEFÁLICO DEL NIÑO = PERCENTILOS 75 A 89"
  },
  {
    "codigo":233768000,
    "descripcion":"SARCOIDOSIS PULMONAR, ESTADIO 2"
  },
  {
    "codigo":37160003,
    "descripcion":"PÍNTIDE"
  },
  {
    "codigo":366675007,
    "descripcion":"AMPLITUD DE MOVIMIENTO DE FLEXIÓN ACTIVA DE DEDO DE LA MANO - HALLAZGO"
  },
  {
    "codigo":364840006,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA SUBIR ESCALONES CORRIENDO"
  },
  {
    "codigo":397608007,
    "descripcion":"HALLAZGO RELACIONADO CON LA PLANIFICACIÓN DE LA ATENCIÓN"
  },
  {
    "codigo":201000006,
    "descripcion":"LIQUEN PLANO ANULAR"
  },
  {
    "codigo":299304009,
    "descripcion":"AMPLITUD DE ROTACIÓN EXTERNA PASIVA DE ARTICULACIÓN DE CADERA, DISMINUIDA"
  },
  {
    "codigo":723453002,
    "descripcion":"SÍNDROME DE PTERIGIÓN, ANOMALÍA CARDÍACA, HERENCIA AUTOSÓMICA RECESIVA, DEFECTO VERTEBRAL, ANOMALÍA AURICULAR Y DEFECTO RADIAL"
  },
  {
    "codigo":231933003,
    "descripcion":"DISTROFIA CORNEANA DE LATTICE, FORMA AISLADA"
  },
  {
    "codigo":363005004,
    "descripcion":"TRASTORNO HEREDITARIO DEL APARATO CARDIOVASCULAR"
  },
  {
    "codigo":788989006,
    "descripcion":"ENTEROCOLITIS NECROSANTE DEL RECIÉN NACIDO, ESTADIO 2B DE LA CLASIFICACIÓN DE BELL"
  },
  {
    "codigo":33490001,
    "descripcion":"INTENTO FALLIDO DE ABORTO CON EMBOLIA GRASA"
  },
  {
    "codigo":295634001,
    "descripcion":"SOBREDOSIS INTENCIONAL DE MELFALÁN"
  },
  {
    "codigo":197330004,
    "descripcion":"ABSCESO HEPÁTICO POR PROPAGACIÓN DIRECTA"
  },
  {
    "codigo":787154005,
    "descripcion":"METABOLIZADOR NORMAL BAJO DE LA FAMILIA 2 SUBFAMILIA C MIEMBRO 9 DEL CITOCROMO P450"
  },
  {
    "codigo":262866006,
    "descripcion":"CONTUSIÓN DE CIEGO"
  },
  {
    "codigo":721618006,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE TERCIO SUPERIOR DE ESÓFAGO"
  },
  {
    "codigo":293799001,
    "descripcion":"ALERGIA A AZATIOPRINA"
  },
  {
    "codigo":64423005,
    "descripcion":"MOTIVACIÓN NORMAL"
  },
  {
    "codigo":128124001,
    "descripcion":"ANOMALÍA CONGÉNITA DEL SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":195495009,
    "descripcion":"QUILOCELE NO FILARIÁSICO"
  },
  {
    "codigo":62588002,
    "descripcion":"AUSENCIA CONGÉNITA DE EXTREMIDAD"
  },
  {
    "codigo":717948004,
    "descripcion":"ANEMIA POR DEFICIENCIA ADQUIRIDA DE HIERRO DEBIDA A AUMENTO DEL REQUERIMIENTO DE HIERRO"
  },
  {
    "codigo":291964003,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR CLOROTIAZIDA"
  },
  {
    "codigo":95356008,
    "descripcion":"ÚLCERA DE MEMBRANA MUCOSA"
  },
  {
    "codigo":1142097006,
    "descripcion":"PROTEINURIA GESTACIONAL INTERMITENTE"
  },
  {
    "codigo":93521006,
    "descripcion":"ENFERMEDAD DE HODGKIN DE LOS GANGLIOS LINFÁTICOS INTRAPÉLVICOS"
  },
  {
    "codigo":1091711000119103,
    "descripcion":"COLESTEATOMA DEL OÍDO MEDIO DERECHO"
  },
  {
    "codigo":124454007,
    "descripcion":"DEFICIENCIA DE GLUCANO 1, 4 - ALFA - GLUCOSIDASA"
  },
  {
    "codigo":714278008,
    "descripcion":"HEMORRAGIA ANASTOMÓTICA YEYUNAL"
  },
  {
    "codigo":26150009,
    "descripcion":"MIGRAÑA DE LA MITAD INFERIOR"
  },
  {
    "codigo":16001151000119104,
    "descripcion":"DESPLAZAMIENTO DE OJO DERECHO"
  },
  {
    "codigo":253691004,
    "descripcion":"ESTENOSIS DE ARTERIA COLATERAL QUE DERIVA EL FLUJO SISTÉMICO HACIA LA CIRCULACIÓN PULMONAR"
  },
  {
    "codigo":24315006,
    "descripcion":"TRASTORNO FACTICIO CON SÍNTOMAS FÍSICOS Y PSICOLÓGICOS COMBINADOS"
  },
  {
    "codigo":226167000,
    "descripcion":"DIETA CON BAJO CONTENIDO DE HIERRO"
  },
  {
    "codigo":354431000119105,
    "descripcion":"LIPOMA DE CABEZA"
  },
  {
    "codigo":88016001,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE CADERA SIN INFECCIÓN"
  },
  {
    "codigo":417531009,
    "descripcion":"DESEO VEHEMENTE EXCESIVO DE DROGAS"
  },
  {
    "codigo":1269499009,
    "descripcion":"ÁCIDO DESOXIRRIBONUCLEICO DE VIRUS PAPILOMA HUMANO DE ALTO RIESGO NO DETECTADO"
  },
  {
    "codigo":1169360001,
    "descripcion":"NEUROPATÍA ÓPTICA INFLAMATORIA RECURRENTE CRÓNICA"
  },
  {
    "codigo":286459008,
    "descripcion":"CAPAZ DE LAVAR LOS ALIMENTOS"
  },
  {
    "codigo":284624001,
    "descripcion":"GOLPEAR A OTRA PERSONA"
  },
  {
    "codigo":219088009,
    "descripcion":"REACCIÓN ADVERSA A VACUNA ANTI-MENINGOCÓCICA"
  },
  {
    "codigo":282789002,
    "descripcion":"LESIÓN TÉRMICA DE NERVIO PERIFÉRICO"
  },
  {
    "codigo":1003685002,
    "descripcion":"CLASIFICACIÓN DE INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA DE LOS CENTROS PARA EL CONTROL Y PREVENCIÓN DE ENFERMEDADES ETAPA DESCONOCIDA"
  },
  {
    "codigo":315557007,
    "descripcion":"NACIDO EN CIUDAD DEL VATICANO"
  },
  {
    "codigo":250021008,
    "descripcion":"MARCHA REBOTANTE"
  },
  {
    "codigo":444794000,
    "descripcion":"NECROSIS CORTICAL RENAL AGUDA"
  },
  {
    "codigo":1231226002,
    "descripcion":"NEUROPATÍA ÓPTICA ISQUÉMICA POSTERIOR NO ARTERÍTICA"
  },
  {
    "codigo":117114005,
    "descripcion":"SOPLO CARDÍACO, ALTO"
  },
  {
    "codigo":248186006,
    "descripcion":"ASPECTO DEMACRADO"
  },
  {
    "codigo":705103007,
    "descripcion":"FRACTURA NO EXPUESTA DE ESCAFOIDES DE LA MUÑECA CON LUXACIÓN DE ARTICULACIÓN PERISEMILUNAR"
  },
  {
    "codigo":441124000,
    "descripcion":"MASA DE LA PARED TORÁCICA"
  },
  {
    "codigo":1260324000,
    "descripcion":"ENFERMEDAD DE SUSTANCIA BLANCA DEBIDA A SÍNDROME ANTIFOSFOLÍPIDO"
  },
  {
    "codigo":80676005,
    "descripcion":"HEMÓLISIS DE UNA COLONIA BACTERIANA, ALFA"
  },
  {
    "codigo":703268008,
    "descripcion":"SÍNDROME METAMÉRICO ARTERIOVENOSO CEREBROFACIAL TIPO 3"
  },
  {
    "codigo":408356009,
    "descripcion":"EFECTOS FARMACOLÓGICOS COLATERALES VERIFICADOS"
  },
  {
    "codigo":111609001,
    "descripcion":"FRACTURA EXPUESTA DE HUESOS FACIALES"
  },
  {
    "codigo":768804008,
    "descripcion":"CONSCIENCIA ACCIDENTAL DURANTE ANESTESIA GENERAL"
  },
  {
    "codigo":46073007,
    "descripcion":"DECIDUOMATOSIS"
  },
  {
    "codigo":766969008,
    "descripcion":"CON MAYOR RIESGO DE RADICALIZACIÓN"
  },
  {
    "codigo":404686001,
    "descripcion":"MOVIMIENTOS SACÁDICOS LENTOS"
  },
  {
    "codigo":15728921000119109,
    "descripcion":"ARTROPATÍA DE TOBILLO IZQUIERDO POR SÍNDROME DE BEHCET"
  },
  {
    "codigo":208078006,
    "descripcion":"LESIÓN COMPLETA DE LA COLA DE CABALLO CONCOMITANTE CON FRACTURA EXPUESTA DE SACRO Y DEBIDA A ELLA"
  },
  {
    "codigo":402851000,
    "descripcion":"PÚRPURA NEONATAL FULMINANTE DEBIDA A DEFICIENCIA HOMOCIGOTA DE PROTEÍNA C"
  },
  {
    "codigo":109774008,
    "descripcion":"ESTOMATITIS URÉMICA"
  },
  {
    "codigo":1156515000,
    "descripcion":"SOBREDOSIS DE ANTIBACTERIANO QUINOLÓNICO"
  },
  {
    "codigo":9635004,
    "descripcion":"ACIDOSIS METABÓLICA TARDÍA DEL RECIÉN NACIDO"
  },
  {
    "codigo":239011004,
    "descripcion":"SÍNDROME DE BASAN"
  },
  {
    "codigo":271779006,
    "descripcion":"CÁLCULO DE VEJIGA URINARIA DE ÁCIDO ÚRICO"
  },
  {
    "codigo":206243008,
    "descripcion":"HEMATOMA TESTICULAR POR TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":106104001,
    "descripcion":"HALLAZGO EN EL APARATO REPRODUCTOR FEMENINO"
  },
  {
    "codigo":40568001,
    "descripcion":"TRASTORNO DEPRESIVO BREVE RECURRENTE"
  },
  {
    "codigo":366413001,
    "descripcion":"AMPLITUD DE LA FLEXIÓN LATERAL DERECHA DE LA COLUMNA DORSAL - HALLAZGO"
  },
  {
    "codigo":300877002,
    "descripcion":"TUMEFACCIÓN DE ESTRUCTURA LINFORRETICULAR"
  },
  {
    "codigo":5965003,
    "descripcion":"LESIÓN TRAUMÁTICA DE TOBILLO EN SUPINACIÓN-EVERSIÓN, GRADO 3"
  },
  {
    "codigo":299042006,
    "descripcion":"DEBILIDAD DE LA MANO"
  },
  {
    "codigo":167970007,
    "descripcion":"LÍQUIDO PLEURAL: ERITROCITOS PRESENTES"
  },
  {
    "codigo":198903000,
    "descripcion":"PLACENTA PREVIA CON HEMORRAGIA"
  },
  {
    "codigo":725026008,
    "descripcion":"DEFICIENCIA DE GLUCÓGENO SINTASA HEPÁTICA"
  },
  {
    "codigo":36898009,
    "descripcion":"FRIABILIDAD"
  },
  {
    "codigo":297207007,
    "descripcion":"HIPERPLASIA DE CUELLO UTERINO"
  },
  {
    "codigo":2295008,
    "descripcion":"FRACTURA NO EXPUESTA DE EXTREMO PROXIMAL DE ANTEBRAZO"
  },
  {
    "codigo":460001,
    "descripcion":"METAPLASIA ESCAMOSA DE LA GLÁNDULA PROSTÁTICA"
  },
  {
    "codigo":10760781000119105,
    "descripcion":"QUINTILLIZOS, TODOS NACIDOS VIVOS"
  },
  {
    "codigo":295372003,
    "descripcion":"SOBREDOSIS DE OMEPRAZOL"
  },
  {
    "codigo":721356004,
    "descripcion":"LUXACIÓN TRAUMÁTICA DE TERCERA Y CUARTA VÉRTEBRAS CERVICALES"
  },
  {
    "codigo":195233001,
    "descripcion":"OCLUSIÓN Y ESTENOSIS DE ARTERIA CEREBRAL ANTERIOR"
  },
  {
    "codigo":719521002,
    "descripcion":"TORTÍCOLIS PAROXÍSTICO BENIGNO DE LA LACTANCIA"
  },
  {
    "codigo":262604009,
    "descripcion":"CUERPO EXTRAÑO OROFARÍNGEO"
  },
  {
    "codigo":162465004,
    "descripcion":"GRAVEDAD DEL SÍNTOMA"
  },
  {
    "codigo":64161004,
    "descripcion":"TRASTORNO PSICÓGENO DE LA VOZ"
  },
  {
    "codigo":330471000119101,
    "descripcion":"ESCOLIOSIS NEUROMUSCULAR CONCOMITANTE CON PARÁLISIS CEREBRAL Y DEBIDA A ELLA"
  },
  {
    "codigo":1145505007,
    "descripcion":"HIPOPLASIA CONGÉNITA DE FALANGE MEDIA DE DEDO DE MANO"
  },
  {
    "codigo":293537003,
    "descripcion":"REACCIÓN ADVERSA A LA HIDRALAZINA"
  },
  {
    "codigo":129697009,
    "descripcion":"CON MAYOR RIESGO DE DISFUNCIÓN PSICOSOCIAL"
  },
  {
    "codigo":95094001,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE PARTES BLANDAS DE LA CABEZA"
  },
  {
    "codigo":160630000,
    "descripcion":"EVITA HASTA LOS EJERCICIOS FÍSICOS MÁS LIVIANOS"
  },
  {
    "codigo":168072004,
    "descripcion":"CÁLCULO: CARBOAPATITA"
  },
  {
    "codigo":1141835000,
    "descripcion":"COSTILLA CON ASPECTO DE PERCHA"
  },
  {
    "codigo":224331001,
    "descripcion":"INVOLUCRADO CON LA POLICÍA"
  },
  {
    "codigo":420939002,
    "descripcion":"ESTRABISMO CON PATRÓN EN Y"
  },
  {
    "codigo":93259002,
    "descripcion":"HIPOPLASIA CONGÉNITA DE LA VESÍCULA BILIAR"
  },
  {
    "codigo":226166009,
    "descripcion":"DIETA CON BAJO CONTENIDO DE MAGNESIO"
  },
  {
    "codigo":781387006,
    "descripcion":"DISTENSIÓN DE TENDÓN DEL PULGAR"
  },
  {
    "codigo":124192000,
    "descripcion":"DEFICIENCIA DE NAD (P)H DESHIDROGENASA (QUINONA)"
  },
  {
    "codigo":417269000,
    "descripcion":"ABDUCCIÓN DEL PUBIS"
  },
  {
    "codigo":253429000,
    "descripcion":"ATRESIA DE VÁLVULA AURICULOVENTRICULAR COMÚN"
  },
  {
    "codigo":16059111000119107,
    "descripcion":"ESCOTOMA DE OJO DERECHO"
  },
  {
    "codigo":286197004,
    "descripcion":"DIFICULTAD PARA CERRAR LA CASA EN FORMA SEGURA"
  },
  {
    "codigo":1269237007,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DEBIDO A TROMBOSIS DE ARTERIA CEREBRAL ANTERIOR"
  },
  {
    "codigo":448202002,
    "descripcion":"ISOMERISMO DE BRONQUIO IZQUIERDO"
  },
  {
    "codigo":22218007,
    "descripcion":"SÍNDROME OBSTRUCTIVO DE LAS VÍAS URINARIAS INFERIORES"
  },
  {
    "codigo":282527000,
    "descripcion":"NO SUBE ESCALERAS CORRIENDO"
  },
  {
    "codigo":54986009,
    "descripcion":"COMPROMISO DE CASAMIENTO"
  },
  {
    "codigo":1003423000,
    "descripcion":"LUXACIÓN DE LA ARTICULACIÓN DEL YUNQUE CON EL ESTRIBO"
  },
  {
    "codigo":315295003,
    "descripcion":"ANEURISMA AÓRTICO ABDOMINAL RECURRENTE"
  },
  {
    "codigo":446367003,
    "descripcion":"LACERACIÓN PROFUNDA DE RODILLA"
  },
  {
    "codigo":85919009,
    "descripcion":"TRASTORNO DEL INTESTINO"
  },
  {
    "codigo":1362036008,
    "descripcion":"PROTEÍNA EN LÍQUIDO CEFALORRAQUÍDEO POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":870516009,
    "descripcion":"REACCIÓN ADVERSA A GLICOL"
  },
  {
    "codigo":278857002,
    "descripcion":"DEMENCIA DE TIPO FRONTAL"
  },
  {
    "codigo":247924008,
    "descripcion":"GIROS REPETITIVOS DE TODO EL CUERPO"
  },
  {
    "codigo":49481000,
    "descripcion":"DELIRIO POSCONVULSIVO"
  },
  {
    "codigo":442697002,
    "descripcion":"HALLAZGO RELACIONADO CON DIFERENCIA EN LA PROXIMIDAD ESPACIAL EN COMPARACIÓN CON EXAMEN RADIOLÓGICO PREVIO"
  },
  {
    "codigo":31771000119102,
    "descripcion":"HIPERSOMNIA DIURNA"
  },
  {
    "codigo":211486004,
    "descripcion":"CONTUSIÓN DE PARED ABDOMINAL ANTERIOR"
  },
  {
    "codigo":703006004,
    "descripcion":"PASTEURELLA HAEMOLYTICA O RODENTIBACTER PNEUMOTROPICUS"
  },
  {
    "codigo":1260062005,
    "descripcion":"CARCINOMA MUCOEPIDERMOIDE DE PULMÓN"
  },
  {
    "codigo":735774008,
    "descripcion":"LACERACIÓN DE REGIÓN LUMBAR SIN CUERPO EXTRAÑO"
  },
  {
    "codigo":733939000,
    "descripcion":"CARIES DENTAL ACTIVA PRIMARIA QUE SE EXTIENDE HASTA LA MITAD EXTERNA DEL ESMALTE"
  },
  {
    "codigo":111347003,
    "descripcion":"EXOSTOSIS DE MANDÍBULA"
  },
  {
    "codigo":209651003,
    "descripcion":"RUPTURA COMPLETA DE LIGAMENTO DEL ESTERNÓN"
  },
  {
    "codigo":766707003,
    "descripcion":"SÍNDROME DE PREDISPOSICIÓN HEREDITARIA AL CÁNCER DEBIDO A MUTACIÓN BIALÉLICA DE BRCA2"
  },
  {
    "codigo":109512002,
    "descripcion":"DIENTE IMPACTADO COMPLICADO"
  },
  {
    "codigo":240584003,
    "descripcion":"CELULITIS GONOCÓCICA"
  },
  {
    "codigo":76744005,
    "descripcion":"DEFICIENCIA LONGITUDINAL DEL PERONÉ"
  },
  {
    "codigo":402589000,
    "descripcion":"PÚRPURA DE CONTACTO"
  },
  {
    "codigo":238749001,
    "descripcion":"MILIA ERUPTIVA MÚLTIPLE"
  },
  {
    "codigo":42141000,
    "descripcion":"DESGASTE PROXIMAL DE LOS DIENTES"
  },
  {
    "codigo":7538002,
    "descripcion":"COLESTASIS INTRAHEPÁTICA CAUSADA POR FÁRMACO"
  },
  {
    "codigo":5703000,
    "descripcion":"TRASTORNO BIPOLAR EN REMISIÓN PARCIAL"
  },
  {
    "codigo":235079001,
    "descripcion":"ANOMALÍA DEL TAMAÑO DEL MAXILAR"
  },
  {
    "codigo":1252722008,
    "descripcion":"LESIÓN PRIMARIA DE PULPA DE DIENTE CON LESIÓN SECUNDARIA DE TEJIDO PERIODONTAL"
  },
  {
    "codigo":300615001,
    "descripcion":"VIAJA A PIE"
  },
  {
    "codigo":890439005,
    "descripcion":"BRAQUIDACTILIA TIPO D"
  },
  {
    "codigo":366151006,
    "descripcion":"CAPACIDAD VITAL FORZADA - HALLAZGO"
  },
  {
    "codigo":202311008,
    "descripcion":"ANQUILOSIS DE LA PRIMERA ARTICULACIÓN CARPOMETACARPIANA"
  },
  {
    "codigo":1281820001,
    "descripcion":"HALLAZGO RELACIONADO CON NIVEL DE RIESGO"
  },
  {
    "codigo":332981000119106,
    "descripcion":"ESCLERITIS POSTERIOR DE OJO DERECHO"
  },
  {
    "codigo":167708006,
    "descripcion":"ASPECTO DEL LÍQUIDO CEFALORRAQUÍDEO: SANGUINOLENTO"
  },
  {
    "codigo":724764007,
    "descripcion":"COREA CONCOMITANTE CON AFECCIÓN SIMILAR A LA ENFERMEDAD DE HUNTINGTON Y DEBIDA A ELLA"
  },
  {
    "codigo":67569000,
    "descripcion":"DISPLASIA BRONCOPULMONAR DEL RECIÉN NACIDO"
  },
  {
    "codigo":1148913001,
    "descripcion":"MENORRAGIA DEBIDA A TRASTORNO DE COAGULACIÓN"
  },
  {
    "codigo":428017002,
    "descripcion":"CONDILOMA ACUMINADO DE VULVA DURANTE EL EMBARAZO"
  },
  {
    "codigo":1279985003,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE PULGAR CON INFECCIÓN"
  },
  {
    "codigo":397084007,
    "descripcion":"MARGEN QUIRÚRGICO PANCREÁTICO NO COMPROMETIDO POR NEOPLASIA MALIGNA"
  },
  {
    "codigo":722929005,
    "descripcion":"ACCIDENTE CEREBROVASCULAR ARTERIAL ISQUÉMICO PERINATAL DE FETO Y\/O RECIÉN NACIDO"
  },
  {
    "codigo":296945005,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE YODURO"
  },
  {
    "codigo":788465007,
    "descripcion":"TRASTORNO REPETITIVO DEL MOVIMIENTO"
  },
  {
    "codigo":34801009,
    "descripcion":"EMBARAZO ECTÓPICO"
  },
  {
    "codigo":1343686002,
    "descripcion":"ALTERACIÓN CRÓNICA DE ASTA POSTERIOR DE MENISCO INTERNO"
  },
  {
    "codigo":295110005,
    "descripcion":"ALERGIA A ALTEPLASA"
  },
  {
    "codigo":721094006,
    "descripcion":"DIAFANOESPONDILODISOSTOSIS"
  },
  {
    "codigo":198007,
    "descripcion":"ENFERMEDAD CAUSADA POR FILOVIRIDAE"
  },
  {
    "codigo":293275002,
    "descripcion":"REACCIÓN ADVERSA A LA TETRACOSACTRINA"
  },
  {
    "codigo":1145243006,
    "descripcion":"RUPTURA DE DISCO INTERVERTEBRAL LUMBAR"
  },
  {
    "codigo":422512005,
    "descripcion":"ESTADO DE DESEMPEÑO ECOG - GRADO 1"
  },
  {
    "codigo":16909801000119100,
    "descripcion":"LAGOFTALMÍA PARALÍTICA DE PÁRPADOS SUPERIOR E INFERIOR DE AMBOS OJOS"
  },
  {
    "codigo":94832007,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA CARA"
  },
  {
    "codigo":191301000,
    "descripcion":"PORTADOR DE HEMOFILIA"
  },
  {
    "codigo":1208944008,
    "descripcion":"TRASTORNO NEONATAL TEMPRANO DEBIDO A DESPRENDIMIENTO DE PLACENTA"
  },
  {
    "codigo":289605002,
    "descripcion":"HALLAZGO RELACIONADO CON LA PRESENCIA DE LÍQUIDO AMNIÓTICO EN APÓSITO VAGINAL"
  },
  {
    "codigo":92997002,
    "descripcion":"ANOMALÍA CONGÉNITA DE LA ARTERIA CARÓTIDA"
  },
  {
    "codigo":1010501006,
    "descripcion":"ESCLEROSIS DE EPÍFISIS DE FALANGE PROXIMAL DE PULGAR CON RADIOPACIDAD AUMENTADA"
  },
  {
    "codigo":91162000,
    "descripcion":"NECROSIS HEPÁTICA DEL EMBARAZO"
  },
  {
    "codigo":123930000,
    "descripcion":"INTOXICACIÓN POR MYOPORACEAE"
  },
  {
    "codigo":25626000,
    "descripcion":"ENFERMEDAD INFECCIOSA CUTÁNEA CAUSADA POR MICOBACTERIA"
  },
  {
    "codigo":386074004,
    "descripcion":"TRASTORNO RELACIONADO CON LA VITAMINA K"
  },
  {
    "codigo":1172506005,
    "descripcion":"INSULINA DENTRO DE RANGO DE REFERENCIA"
  },
  {
    "codigo":89327000,
    "descripcion":"INTERACCIÓN HEMO - HEMO AUMENTADA"
  },
  {
    "codigo":418842009,
    "descripcion":"TRASTORNO DE LA CAVIDAD VÍTREA"
  },
  {
    "codigo":285935000,
    "descripcion":"CAPAZ DE VACIAR EL LAVABO"
  },
  {
    "codigo":187631006,
    "descripcion":"NEOPLASIA MALIGNA DE LA CARA DORSAL DE LA BASE DE LA LENGUA"
  },
  {
    "codigo":449775008,
    "descripcion":"EXOSTOSIS SOLITARIA"
  },
  {
    "codigo":253167009,
    "descripcion":"MICRODISGENESIA"
  },
  {
    "codigo":1099241000119105,
    "descripcion":"ENDOFTALMITIS AGUDA DE AMBOS OJOS"
  },
  {
    "codigo":415172002,
    "descripcion":"MELANOSIS ADQUIRIDA PRIMARIA"
  },
  {
    "codigo":251332005,
    "descripcion":"CARIES INACTIVA"
  },
  {
    "codigo":7811000119100,
    "descripcion":"CARCINOMA ESCAMOSO INTRAEPIDÉRMICO DE ANO"
  },
  {
    "codigo":710084007,
    "descripcion":"ALTURA DE HUESO MANDIBULAR EDÉNTULO TIPO I"
  },
  {
    "codigo":315033000,
    "descripcion":"SEUDOANEURISMA DE ARTERIA HEPÁTICA"
  },
  {
    "codigo":447940009,
    "descripcion":"PULMÓN IZQUIERDO BILOBULADO"
  },
  {
    "codigo":249497008,
    "descripcion":"SÍNTOMA DE VÓMITO"
  },
  {
    "codigo":216729009,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR MERCURIO ORGÁNICO"
  },
  {
    "codigo":20121009,
    "descripcion":"FRACTURA NO EXPUESTA DE SIETE COSTILLAS"
  },
  {
    "codigo":280430004,
    "descripcion":"SÍNDROME SOMÁTICO AUSENTE"
  },
  {
    "codigo":247662008,
    "descripcion":"SUGESTIONABLE"
  },
  {
    "codigo":278595000,
    "descripcion":"CORONA DENTAL CON SUPERFICIE RUGOSA"
  },
  {
    "codigo":81987005,
    "descripcion":"ALCALOSIS HIPOCALIÉMICA FAMILIAR, TIPO GULLNER"
  },
  {
    "codigo":737347005,
    "descripcion":"PORTADOR DE ENTAMOEBA"
  },
  {
    "codigo":409667007,
    "descripcion":"FRACTURA PATOLÓGICA DE FÉMUR"
  },
  {
    "codigo":178456000,
    "descripcion":"ENANISMO ATELIÓTICO SIN INSULINOPENIA"
  },
  {
    "codigo":735512002,
    "descripcion":"QUEMADURA COMPLEJA DE PIE"
  },
  {
    "codigo":47384003,
    "descripcion":"ESPRUE TROPICAL"
  },
  {
    "codigo":309528005,
    "descripcion":"MASA LUMBAR"
  },
  {
    "codigo":473368005,
    "descripcion":"QUISTE PERICÁRDICO A LO LARGO DEL ÁNGULO CARDIOFRÉNICO IZQUIERDO"
  },
  {
    "codigo":12105501000119100,
    "descripcion":"QUEMADURA DE DORSO DE MANO DERECHA"
  },
  {
    "codigo":209389000,
    "descripcion":"FRACTURA-LUXACIÓN NO EXPUESTA DEL ESTERNÓN"
  },
  {
    "codigo":16637571000119106,
    "descripcion":"TRASTORNO DE AMBOS NERVIOS CIÁTICOS POPLÍTEOS EXTERNOS A NIVEL DE CABEZA DE PERONÉ"
  },
  {
    "codigo":45549002,
    "descripcion":"LIGADURA UMBILICAL CORREDIZA CON HEMORRAGIA"
  },
  {
    "codigo":1259800005,
    "descripcion":"GASTRINOMA MALIGNO PRIMARIO DE PÁNCREAS"
  },
  {
    "codigo":405997005,
    "descripcion":"NO SE PUEDE DETERMINAR LA PRESENCIA DE ANOMALÍA FETAL EN EL ESPÉCIMEN"
  },
  {
    "codigo":307693006,
    "descripcion":"MIOCLONÍA VERTICAL"
  },
  {
    "codigo":78317008,
    "descripcion":"SÍNDROME XXXY"
  },
  {
    "codigo":305858002,
    "descripcion":"ATENDIDO POR SERVICIO DE ORTÓTICA"
  },
  {
    "codigo":240322003,
    "descripcion":"TRASTORNO FETAL DEBIDO A INSUFICIENCIA PLACENTARIA"
  },
  {
    "codigo":404162004,
    "descripcion":"RETICULOHISTIOCITOMA SOLITARIO"
  },
  {
    "codigo":830146005,
    "descripcion":"MOVIMIENTO PASIVO DE ARTICULACIÓN MAYOR QUE EL MOVIMIENTO ACTIVO"
  },
  {
    "codigo":142018005,
    "descripcion":"ELECTROCARDIOGRAMA SIN MODIFICACIONES EN COMPARACIÓN CON ESTUDIO PREVIO"
  },
  {
    "codigo":109250009,
    "descripcion":"DERMATOSIS AMPOLLAR CRÓNICA DE LA INFANCIA"
  },
  {
    "codigo":369559001,
    "descripcion":"TUMOR MALIGNO QUE COMPROMETE EL OVARIO IZQUIERDO POR PROPAGACIÓN DIRECTA DE LA VAGINA"
  },
  {
    "codigo":402327004,
    "descripcion":"BROTE PUSTULAR GENERALIZADO AGUDO DE PLACA DE PSORIASIS PREEXISTENTE"
  },
  {
    "codigo":1287063005,
    "descripcion":"HEMORRAGIA INTRAVENTRICULAR NO TRAUMÁTICA GRADO 2 DURANTE PERÍODO NEONATAL"
  },
  {
    "codigo":1155991005,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LEPTOMENINGES"
  },
  {
    "codigo":238487008,
    "descripcion":"VERRUGA DEL MÚSICO"
  },
  {
    "codigo":302188001,
    "descripcion":"SABOR DESAGRADABLE EN LA BOCA"
  },
  {
    "codigo":9111008,
    "descripcion":"GLUCOGLICINURIA"
  },
  {
    "codigo":236652008,
    "descripcion":"RETENCIÓN DE ORINA POSOPERATORIA"
  },
  {
    "codigo":365889005,
    "descripcion":"PERCENTILO DE LA ALTURA DEL NIÑO - HALLAZGO"
  },
  {
    "codigo":1119553005,
    "descripcion":"BASE NASAL ESTRECHA"
  },
  {
    "codigo":309021000119108,
    "descripcion":"TENDINITIS CALCIFICANTE DE CADERA DERECHA"
  },
  {
    "codigo":5441008,
    "descripcion":"TIÑA DE LA CABEZA"
  },
  {
    "codigo":567941000005109,
    "descripcion":"EMBARAZO CON CERTEZA DE FECHAS"
  },
  {
    "codigo":67307004,
    "descripcion":"CIRCULACIÓN COLATERAL AUMENTADA"
  },
  {
    "codigo":1148651004,
    "descripcion":"INTOXICACIÓN CAUSADA POR AGENTE MINERALOCORTICOIDE"
  },
  {
    "codigo":1771008,
    "descripcion":"TRASTORNO EN LA BIOSÍNTESIS DE INSULINA"
  },
  {
    "codigo":296683009,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE CEFAZOLINA"
  },
  {
    "codigo":131008004,
    "descripcion":"NIVEL DE PROLACTINA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":11833271000119106,
    "descripcion":"ESGUINCE DE PIE DERECHO"
  },
  {
    "codigo":16011191000119106,
    "descripcion":"NECROSIS AVASCULAR DE AMBOS ASTRÁGALOS"
  },
  {
    "codigo":360384007,
    "descripcion":"OBSTRUCCIÓN ESPERMÁTICA"
  },
  {
    "codigo":194709000,
    "descripcion":"MIOCARDITIS REUMÁTICA AGUDA"
  },
  {
    "codigo":63637002,
    "descripcion":"INTENTO FALLIDO DE ABORTO CON LACERACIÓN DE LIGAMENTO ANCHO"
  },
  {
    "codigo":1144981002,
    "descripcion":"ÚLCERA DE ESTÓMAGO DEBIDA A PÚRPURA DE HENOCH-SCHÖNLEIN"
  },
  {
    "codigo":161941007,
    "descripcion":"DISNEA EN REPOSO"
  },
  {
    "codigo":192874000,
    "descripcion":"ATAXIA CEREBELOSA ASOCIADA CON OTRO TRASTORNO"
  },
  {
    "codigo":127338001,
    "descripcion":"TRASTORNO DE LA PIEL Y\/O DEL TEJIDO CELULAR SUBCUTÁNEO DE LOS FLANCOS"
  },
  {
    "codigo":94570001,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA PIEL DEL CUERO CABELLUDO"
  },
  {
    "codigo":782698000,
    "descripcion":"ATRESIA CONGÉNITA DE ORIFICIO DE ARTERIA CORONARIA"
  },
  {
    "codigo":15738961000119102,
    "descripcion":"GLAUCOMA DE OJO IZQUIERDO DEBIDO A ANOMALÍA CONGÉNITA DE IRIS"
  },
  {
    "codigo":225642005,
    "descripcion":"ANSIEDAD RELACIONADA CON NO PODER CUMPLIR CON EL ROL DE PADRES"
  },
  {
    "codigo":61802005,
    "descripcion":"CRIOFIBRINOGENEMIA PRIMARIA"
  },
  {
    "codigo":291178001,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR TIETILPERAZINA"
  },
  {
    "codigo":293013007,
    "descripcion":"REACCIÓN ADVERSA A LA CEFTRIAXONA"
  },
  {
    "codigo":338001000119102,
    "descripcion":"RETINOPATÍA POR PREMATUREZ DEL OJO IZQUIERDO ETAPA 1 - LÍNEA DE DEMARCACIÓN"
  },
  {
    "codigo":59967003,
    "descripcion":"LARINGOTRAQUEÍTIS AGUDA CON OBSTRUCCIÓN"
  },
  {
    "codigo":92735004,
    "descripcion":"CARCINOMA IN SITU DE LA PIEL DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":289343005,
    "descripcion":"PROBLEMA EN EL TRAZADO CARDIOTOCOGRÁFICO"
  },
  {
    "codigo":254740002,
    "descripcion":"BALANOPOSTITIS ULCERATIVA"
  },
  {
    "codigo":90900004,
    "descripcion":"DERMATITIS GANGRENOSA INFANTIL"
  },
  {
    "codigo":1075281000119106,
    "descripcion":"DEFORMIDAD EN VARO ADQUIRIDA DE ARTICULACIÓN DE REGIÓN DE MUÑECA DERECHA"
  },
  {
    "codigo":228147004,
    "descripcion":"DEFICIENCIA DE LA MOTRICIDAD GRUESA"
  },
  {
    "codigo":25364007,
    "descripcion":"HABITUACIÓN VULVOCLITORÍDEA HETEROMANIPULATORIA"
  },
  {
    "codigo":285673003,
    "descripcion":"CAPAZ DE CARGAR PESO"
  },
  {
    "codigo":449513006,
    "descripcion":"CONEXIÓN VENOSA PULMONAR ANÓMALA DE TIPO MIXTO CON UNA CONFLUENCIA VENOSA PULMONAR"
  },
  {
    "codigo":283838000,
    "descripcion":"HERIDA POR MORDEDURA DE REPTIL"
  },
  {
    "codigo":38501000087102,
    "descripcion":"HIPOCINESIA DE MIOCARDIO DE REGIÓN SEPTAL DE VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":216467006,
    "descripcion":"INTOXICACIÓN ACCIDENTAL CAUSADA POR MEPERIDINA"
  },
  {
    "codigo":46181000087104,
    "descripcion":"FRACTURA DE ASTRÁGALO IZQUIERDO"
  },
  {
    "codigo":50792001,
    "descripcion":"ÚLCERA CORNEAL SUPERFICIAL"
  },
  {
    "codigo":312936002,
    "descripcion":"TRASTORNO MENTAL ORGÁNICO INDUCIDO POR ANSIOLÍTICO"
  },
  {
    "codigo":41061000087104,
    "descripcion":"SUBLUXACIÓN DE ARTICULACIÓN FEMORORROTULIANA IZQUIERDA"
  },
  {
    "codigo":1197672004,
    "descripcion":"DISMOTILIDAD DE INTESTINO DELGADO INDUCIDA POR FÁRMACO"
  },
  {
    "codigo":247400008,
    "descripcion":"BRAZOS Y DEDOS DE LA MANO DOLORIDOS"
  },
  {
    "codigo":366981000119102,
    "descripcion":"AZOOSPERMIA CAUSADA POR RADIACIÓN"
  },
  {
    "codigo":473106000,
    "descripcion":"DIFICULTAD EN EL AJUSTE DE DISPOSITIVO ANTICONCEPTIVO INTRAUTERINO"
  },
  {
    "codigo":210962001,
    "descripcion":"SECUELAS OCASIONADAS POR LESIONES EN LAS EXTREMIDADES INFERIORES"
  },
  {
    "codigo":702482001,
    "descripcion":"CEPA PANDÉMICA DE VIRUS INFLUENZA A H1N1 2009 PRESENTE"
  },
  {
    "codigo":1259538004,
    "descripcion":"EXTRAVASACIÓN DE LÍQUIDO CEFALORRAQUÍDEO CRANEAL DEBIDA A PUNCIÓN LUMBAR Y POSTERIOR A ELLA"
  },
  {
    "codigo":407570006,
    "descripcion":"PACIENTE CON TRATAMIENTO ANTICONVULSIVANTE EN DOSIS MÁXIMA TOLERADA"
  },
  {
    "codigo":79890006,
    "descripcion":"PÉRDIDA DEL APETITO"
  },
  {
    "codigo":274663001,
    "descripcion":"DOLOR AGUDO"
  },
  {
    "codigo":735250009,
    "descripcion":"FALTA DE OPORTUNIDAD PARA PRIVACIDAD"
  },
  {
    "codigo":12519004,
    "descripcion":"ESGUINCE DE LIGAMENTO SACROILÍACO"
  },
  {
    "codigo":241895007,
    "descripcion":"EFECTO TÓXICO CAUSADO POR LÍQUIDO DE FRENOS"
  },
  {
    "codigo":405735008,
    "descripcion":"DEFORMIDAD DE OMÓPLATO"
  },
  {
    "codigo":403900000,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS, TIPO FUSOCELULAR"
  },
  {
    "codigo":78055008,
    "descripcion":"APLASTAMIENTO DE TÓRAX CON HERIDA ABIERTA HACIA LA CAVIDAD TORÁCICA"
  },
  {
    "codigo":209127009,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN ESTERNOCLAVICULAR"
  },
  {
    "codigo":371132002,
    "descripcion":"HERNIA HIATAL CON REFLUJO GASTROESOFÁGICO"
  },
  {
    "codigo":240060004,
    "descripcion":"DISTROFIA MUSCULAR CONGÉNITA DE TIPO OCCIDENTAL"
  },
  {
    "codigo":305596005,
    "descripcion":"BAJO ATENCIÓN DE LUDOTERAPEUTA"
  },
  {
    "codigo":471271008,
    "descripcion":"CURVA DE SPEE PROFUNDA"
  },
  {
    "codigo":76220009,
    "descripcion":"TRASTORNO MIXTO DEL EQUILIBRIO ÁCIDO - BASE"
  },
  {
    "codigo":8849004,
    "descripcion":"DEFICIENCIA DE GALACTOSA EPIMERASA"
  },
  {
    "codigo":762513007,
    "descripcion":"TRASTORNO DEL ESTADO DE ÁNIMO CON SÍNTOMAS MANÍACOS CAUSADO POR CATINONA SINTÉTICA"
  },
  {
    "codigo":860817008,
    "descripcion":"INESTABILIDAD DE COLUMNA VERTEBRAL DE CAUSA IATROGÉNICA"
  },
  {
    "codigo":72550000,
    "descripcion":"EPIDIDIMITIS CON ABSCESO"
  },
  {
    "codigo":301926003,
    "descripcion":"CONJUNTIVA NORMAL"
  },
  {
    "codigo":52872005,
    "descripcion":"INFECCIÓN CAUSADA POR VAHLKAMPFIA"
  },
  {
    "codigo":367462009,
    "descripcion":"SÍNDROME DEL PRIMER Y SEGUNDO ARCOS BRANQUIALES"
  },
  {
    "codigo":7014009,
    "descripcion":"PÚRPURA MECÁNICA"
  },
  {
    "codigo":234555003,
    "descripcion":"GLUCOSILACIÓN DEFECTUOSA DE INMUNOGLOBULINAS"
  },
  {
    "codigo":15987231000119104,
    "descripcion":"MICROFTALMÍA DE OJO IZQUIERDO"
  },
  {
    "codigo":365627007,
    "descripcion":"EDAD DE LOS GLÓBULOS BLANCOS- HALLAZGO"
  },
  {
    "codigo":300091007,
    "descripcion":"OÍDO OLOROSO"
  },
  {
    "codigo":396560002,
    "descripcion":"TUMOR HEMORRÁGICO"
  },
  {
    "codigo":3344003,
    "descripcion":"LABERINTITIS TÓXICA"
  },
  {
    "codigo":298256005,
    "descripcion":"ARTICULACIÓN TIBIA AL TACTO"
  },
  {
    "codigo":296421003,
    "descripcion":"SOBREDOSIS DE DIFENILPIRALINA"
  },
  {
    "codigo":11864761000119101,
    "descripcion":"LACERACIÓN DE MÚSCULO CRURAL POSTERIOR DE PIERNA IZQUIERDA"
  },
  {
    "codigo":67045005,
    "descripcion":"QUISTE LINFOEPITELIAL DE LA BOCA"
  },
  {
    "codigo":1077791000119108,
    "descripcion":"OSTEOMIELITIS DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":32442003,
    "descripcion":"HIPERVOLEMIA POR EXCESO PRIMARIO DE HORMONAS"
  },
  {
    "codigo":340511000119109,
    "descripcion":"DESPRENDIMIENTO HEMORRÁGICO DE COROIDES IZQUIERDA"
  },
  {
    "codigo":294586006,
    "descripcion":"ALERGIA A LIMECICLINA"
  },
  {
    "codigo":720570007,
    "descripcion":"BRAQUIDACTILIA TIPO A5"
  },
  {
    "codigo":1144719003,
    "descripcion":"HIPOPLASIA CONGÉNITA DE FALANGE DE CUARTO DEDO DE PIE"
  },
  {
    "codigo":292751005,
    "descripcion":"REACCIÓN ADVERSA A TRIENTINA"
  },
  {
    "codigo":290916000,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR MAPROTILINA"
  },
  {
    "codigo":63375009,
    "descripcion":"ABSCESO DE BRODIE"
  },
  {
    "codigo":127076002,
    "descripcion":"LINFADENOPATÍA OCCIPITAL"
  },
  {
    "codigo":94308006,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE HUESO FRONTAL"
  },
  {
    "codigo":92473001,
    "descripcion":"NEOPLASIA BENIGNA DE LA VAGINA"
  },
  {
    "codigo":715065007,
    "descripcion":"INFECCIÓN CAUSADA POR BARTONELLA TALPAE"
  },
  {
    "codigo":289081008,
    "descripcion":"INCAPAZ DE AMAMANTAR"
  },
  {
    "codigo":25102003,
    "descripcion":"HEPATITIS VIRAL AGUDA TIPO A"
  },
  {
    "codigo":1237518004,
    "descripcion":"METÁSTASIS DE CARCINOMA DE BRONQUIO PRINCIPAL"
  },
  {
    "codigo":254478004,
    "descripcion":"NEOPLASIA MALIGNA DE CORNETE NASAL INFERIOR"
  },
  {
    "codigo":1137379000,
    "descripcion":"HIPOTONÍA APENDICULAR"
  },
  {
    "codigo":56035000,
    "descripcion":"INFECCIÓN CAUSADA POR CYTAUXZOON"
  },
  {
    "codigo":88803002,
    "descripcion":"HIPERCORTISOLISMO SECUNDARIO A ADENOMA HIPOFISARIO"
  },
  {
    "codigo":23267004,
    "descripcion":"ACROMÍA DE LA PIEL"
  },
  {
    "codigo":416483009,
    "descripcion":"LEPRA PAUCIBACILAR"
  },
  {
    "codigo":185272004,
    "descripcion":"ATENDIDO EN UN CONSULTORIO DE PSICOGERIATRÍA"
  },
  {
    "codigo":283576004,
    "descripcion":"HERIDA DE PERDIGÓN EN REGIÓN PÉLVICA"
  },
  {
    "codigo":840632006,
    "descripcion":"ÚTERO GRÁVIDO DE TAMAÑO CORRESPONDIENTE A 36-38 SEMANAS"
  },
  {
    "codigo":611261000124102,
    "descripcion":"LAVABO FUNCIONANTE EN RESIDENCIA"
  },
  {
    "codigo":447416008,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE CONDUCTO BILIAR DISTAL"
  },
  {
    "codigo":621501000124105,
    "descripcion":"ACCESO LIMITADO A LA ASISTENCIA SANITARIA DEBIDO A FALTA DE TIEMPO"
  },
  {
    "codigo":19597002,
    "descripcion":"DISFAGIA INTERMITENTE"
  },
  {
    "codigo":1981000124107,
    "descripcion":"TRANSICIÓN DE LA ATENCIÓN EN CUIDADOS PALIATIVOS A ATENCIÓN PROLONGADA"
  },
  {
    "codigo":871565006,
    "descripcion":"REACCIÓN ADVERSA A PIPACETATO"
  },
  {
    "codigo":314509006,
    "descripcion":"PTOSIS MIÓGENA ADQUIRIDA"
  },
  {
    "codigo":1363085008,
    "descripcion":"ASTILLA EN EXTREMIDAD INFERIOR CON INFECCIÓN"
  },
  {
    "codigo":442291006,
    "descripcion":"MEMBRANA TIMPÁNICA PARCIALMENTE VISIBLE"
  },
  {
    "codigo":247138002,
    "descripcion":"MANCHAS RETINIANAS"
  },
  {
    "codigo":81463002,
    "descripcion":"ZOOFILIA"
  },
  {
    "codigo":310839003,
    "descripcion":"SIN CONSENTIMIENTO PARA LA PRIMERA DOSIS DE VACUNA MMR"
  },
  {
    "codigo":704055002,
    "descripcion":"NEFROPATÍA CAUSADA POR AMFOTERICINA"
  },
  {
    "codigo":1162807005,
    "descripcion":"DEFICIENCIA ADQUIRIDA DE PRECALICREÍNA"
  },
  {
    "codigo":833292002,
    "descripcion":"CÁLCULO DE OXALATO DE CALCIO DE VEJIGA URINARIA"
  },
  {
    "codigo":472844003,
    "descripcion":"INSUFICIENCIA DE VÁLVULA PULMONAR FETAL"
  },
  {
    "codigo":866060005,
    "descripcion":"MIELITIS CAUSADA POR CYTOMEGALOVIRUS"
  },
  {
    "codigo":46860007,
    "descripcion":"ESGUINCE DE LIGAMENTO DE ARTICULACIÓN CRICOTIROIDEA"
  },
  {
    "codigo":734988007,
    "descripcion":"SÍNDROME DE DOLOR REGIONAL COMPLEJO DE RODILLA"
  },
  {
    "codigo":1193740008,
    "descripcion":"INFLAMACIÓN INTESTINAL POR MYCOBACTERIUM NO TUBERCULOSIS"
  },
  {
    "codigo":276236009,
    "descripcion":"COMENTARIOS ACERCA DE LOS PROPIOS PENSAMIENTOS"
  },
  {
    "codigo":274401005,
    "descripcion":"CÁLCULO RENAL DE ÁCIDO ÚRICO"
  },
  {
    "codigo":272566001,
    "descripcion":"DECÚBITO LATERAL CON PIERNAS FLEXIONADAS"
  },
  {
    "codigo":700385009,
    "descripcion":"DEFECTO OSTEOCONDRAL DE ASTRÁGALO"
  },
  {
    "codigo":403638003,
    "descripcion":"ERITEMA ACRO DEBIDO A TRATAMIENTO CITOTÓXICO"
  },
  {
    "codigo":237963003,
    "descripcion":"TRASTORNO DEL METABOLISMO DE LA GALACTOSA"
  },
  {
    "codigo":74123003,
    "descripcion":"OTALGIA OTOGÉNICA"
  },
  {
    "codigo":8587003,
    "descripcion":"DIVERTÍCULO CONGÉNITO DE COLON"
  },
  {
    "codigo":762251008,
    "descripcion":"VENTRÍCULO DERECHO CON DOBLE TRACTO DE SALIDA Y DEFECTO DEL TABIQUE INTERVENTRICULAR SUBAÓRTICO O DOBLEMENTE COMPROMETIDO SIN ESTENOSIS PULMONAR - TIPO DEFECTO DE TABIQUE INTERVENTRICULAR"
  },
  {
    "codigo":1153632001,
    "descripcion":"EMBOLIA DE AMBAS ARTERIAS CEREBRALES MEDIAS"
  },
  {
    "codigo":236128002,
    "descripcion":"FÍSTULA EXTERNA DE ESTOMA"
  },
  {
    "codigo":301664004,
    "descripcion":"SE ACUESTA Y SE LEVANTA DE LA CAMA"
  },
  {
    "codigo":6752005,
    "descripcion":"INFECCIÓN CAUSADA POR SCHISTOSOMA SPINDALE"
  },
  {
    "codigo":430901004,
    "descripcion":"TRASTORNO CARDÍACO FETAL"
  },
  {
    "codigo":299829005,
    "descripcion":"REFLEJO TRICIPITAL INVERTIDO"
  },
  {
    "codigo":365365006,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA REALIZAR COMPRAS"
  },
  {
    "codigo":168757007,
    "descripcion":"RADIOGRAFÍA SIMPLE DE ABDOMEN EN BIPEDESTACIÓN ANORMAL"
  },
  {
    "codigo":297994000,
    "descripcion":"PELO GRIS"
  },
  {
    "codigo":398133006,
    "descripcion":"PERSONAL DE RELEVO NO DISPONIBLE"
  },
  {
    "codigo":126241000119102,
    "descripcion":"ÁCIDO DESOXIRRIBONUCLEICO DE VIRUS PAPILOMA HUMANO DETECTADO, ALTO RIESGO EN MUESTRA ANAL"
  },
  {
    "codigo":232458003,
    "descripcion":"SARCOIDOSIS LARÍNGEA"
  },
  {
    "codigo":35850006,
    "descripcion":"ÚTERO INFANTIL"
  },
  {
    "codigo":68618008,
    "descripcion":"SÍNDROME DE RETT"
  },
  {
    "codigo":166922008,
    "descripcion":"GLUCOSA EN SANGRE FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":296159002,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE SULPIRIDA"
  },
  {
    "codigo":230623004,
    "descripcion":"LESIÓN DE NERVIO PERIFÉRICO POR APLASTAMIENTO"
  },
  {
    "codigo":66783006,
    "descripcion":"SÍNDROME DEL PTERIGIÓN POPLÍTEO"
  },
  {
    "codigo":34015007,
    "descripcion":"ASMA DE LOS PANADEROS"
  },
  {
    "codigo":425396000,
    "descripcion":"MANIFESTACIÓN DE LA VOLUNTAD ACTIVA VERIFICADA POR LA FAMILIA"
  },
  {
    "codigo":15691041000119105,
    "descripcion":"ARTRITIS ENTEROPÁTICA BILATERAL DE PIES"
  },
  {
    "codigo":64948003,
    "descripcion":"INTOXICACIÓN POR FADOGIA HOMBLEI"
  },
  {
    "codigo":294324005,
    "descripcion":"ALERGIA A PARAFINA"
  },
  {
    "codigo":196020005,
    "descripcion":"BRONQUITIS AGUDA CAUSADA POR VAPORES QUÍMICOS"
  },
  {
    "codigo":16674081000119106,
    "descripcion":"ESGUINCE DE LIGAMENTO DE ARTICULACIÓN TEMPOROMANDIBULAR DERECHA"
  },
  {
    "codigo":292489001,
    "descripcion":"REACCIÓN ADVERSA A LA FENILEFRINA"
  },
  {
    "codigo":1144457002,
    "descripcion":"APLASIA DE DEDO ANULAR"
  },
  {
    "codigo":423561003,
    "descripcion":"INFECCIÓN POR STAPHYLOCOCCUS AUREUS METICILINORRESISTENTE ADQUIRIDA EN LA COMUNIDAD"
  },
  {
    "codigo":95881004,
    "descripcion":"MICETOMA DE PIE"
  },
  {
    "codigo":290654002,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR ACLARRUBICINA"
  },
  {
    "codigo":126814004,
    "descripcion":"NEOPLASIA DE LA ZONA DE UNIÓN DE LA EPIGLOTIS"
  },
  {
    "codigo":94046008,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA PIEL DE LA MUÑECA"
  },
  {
    "codigo":716638009,
    "descripcion":"DEFICIENCIA LONGITUDINAL DE PARTE DE MIEMBRO"
  },
  {
    "codigo":124979002,
    "descripcion":"ALTERACIÓN EN LA MITOSIS"
  },
  {
    "codigo":59443003,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN MUSLO, CON INFECCIÓN"
  },
  {
    "codigo":16046591000119100,
    "descripcion":"ENFERMEDAD POR DEPÓSITO DE HIDROXIAPATITA DE CODO IZQUIERDO"
  },
  {
    "codigo":12204031000119101,
    "descripcion":"ACCIDENTE CEREBROVASCULAR POSTERIOR A PROCEDIMIENTO CARDÍACO"
  },
  {
    "codigo":15997951000119102,
    "descripcion":"OCLUSIÓN VASCULAR DE RETINA DE OJO DERECHO"
  },
  {
    "codigo":330751000119103,
    "descripcion":"SÍNDROME DE NERVIO INTERÓSEO POSTERIOR DERECHO"
  },
  {
    "codigo":16000511000119103,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DEBIDO A OCLUSIÓN DE ARTERIA CEREBRAL MEDIA IZQUIERDA"
  },
  {
    "codigo":16028671000119104,
    "descripcion":"EXOSTOSIS DE HOMBRO DERECHO"
  },
  {
    "codigo":16041471000119106,
    "descripcion":"ARTRITIS IDIOPÁTICA JUVENIL DE INICIO SISTÉMICO DE CADERA IZQUIERDA"
  },
  {
    "codigo":10627071000119106,
    "descripcion":"FORÚNCULO DE PIE DERECHO"
  },
  {
    "codigo":90376004,
    "descripcion":"PULSO POPLÍTEO ANORMAL"
  },
  {
    "codigo":90111000119109,
    "descripcion":"EDENTULISMO PARCIAL CLASE III"
  },
  {
    "codigo":84991000119105,
    "descripcion":"TRASTORNO DEL MOVIMIENTO RELACIONADO CON EL SUEÑO"
  },
  {
    "codigo":418056007,
    "descripcion":"SÍNDROME DE INFUSIÓN POSTERIOR"
  },
  {
    "codigo":123391000119106,
    "descripcion":"CUADRIPLEJÍA FUNCIONAL"
  },
  {
    "codigo":673791000119108,
    "descripcion":"DEFORMIDAD CONGÉNITA DE PARTE BLANDA"
  },
  {
    "codigo":1237256004,
    "descripcion":"TRASTORNO FETAL DEBIDO A LESIÓN DE PLACENTA POSTERIOR A INDUCCIÓN QUIRÚRGICA"
  },
  {
    "codigo":16018431000119109,
    "descripcion":"PARESIA DE EXTREMIDAD INFERIOR DERECHA"
  },
  {
    "codigo":3071000119108,
    "descripcion":"COCCIDIOIDOMICOSIS AGUDA"
  },
  {
    "codigo":285149005,
    "descripcion":"ELIMINAR FLATULENCIAS EN PÚBLICO"
  },
  {
    "codigo":254216006,
    "descripcion":"ERITROQUERATÓLISIS HEREDITARIA"
  },
  {
    "codigo":448989001,
    "descripcion":"NEOPLASIA EPITELIAL MALIGNA DE CEREBRO"
  },
  {
    "codigo":15965781000119102,
    "descripcion":"ENDOMETRIOSIS EN LIGAMENTO REDONDO DERECHO"
  },
  {
    "codigo":345531000119108,
    "descripcion":"QUERATOCONO DE AMBAS CÓRNEAS"
  },
  {
    "codigo":283314007,
    "descripcion":"ASTILLA DE MADERA EN EL PIE"
  },
  {
    "codigo":1231751000,
    "descripcion":"NEURORRETINITIS IDIOPÁTICA RECURRENTE"
  },
  {
    "codigo":281479004,
    "descripcion":"DEFORMIDAD ADQUIRIDA FIJA EN FLEXIÓN DE MUÑECA"
  },
  {
    "codigo":838535004,
    "descripcion":"ESTENOSIS DE VÁLVULA TRICÚSPIDE LEVE"
  },
  {
    "codigo":1264519007,
    "descripcion":"REQUIERE COBERTURA ANTIBIÓTICA PARA PROCEDIMIENTO QUIRÚRGICO"
  },
  {
    "codigo":84871007,
    "descripcion":"VALVULITIS REUMÁTICA AGUDA"
  },
  {
    "codigo":246876001,
    "descripcion":"HALLAZGO DE LA CONJUNTIVA BULBAR"
  },
  {
    "codigo":19335008,
    "descripcion":"CÁLCULO DE CONDUCTO CÍSTICO CON COLECISTITIS AGUDA"
  },
  {
    "codigo":115804002,
    "descripcion":"FENOTIPO EN (A - ) (FIN)"
  },
  {
    "codigo":443484004,
    "descripcion":"NECESIDAD DE SUEÑO DISMINUIDA"
  },
  {
    "codigo":1197148005,
    "descripcion":"SÍNDROME DE SANJAD SAKATI"
  },
  {
    "codigo":279644004,
    "descripcion":"REACCIÓN DE DUELO NORMAL ANTE EVENTO DE LA VIDA"
  },
  {
    "codigo":310577003,
    "descripcion":"ESTADO DE INMUNIZACIÓN ANTINEUMOCÓCICA"
  },
  {
    "codigo":16840431000119101,
    "descripcion":"OBSTRUCCIÓN INTESTINAL PARCIAL POR ADHERENCIAS PERITONEALES"
  },
  {
    "codigo":212273007,
    "descripcion":"LESIÓN TRAUMÁTICA ABIERTA DE RAMA SENSITIVA DE NERVIO RADIAL"
  },
  {
    "codigo":468409941000119108,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN DE TEJIDO PROFUNDO DE REGIÓN SACRA"
  },
  {
    "codigo":292591000119102,
    "descripcion":"NEUROMA DE EXTREMIDAD INFERIOR IZQUIERDA POSTERIOR A CIRUGÍA"
  },
  {
    "codigo":79366000,
    "descripcion":"LESIÓN TRAUMÁTICA DEL PLEXO MESENTÉRICO INFERIOR"
  },
  {
    "codigo":210438000,
    "descripcion":"HERIDA ABIERTA EN LA VULVA"
  },
  {
    "codigo":308742005,
    "descripcion":"CONVULSIÓN INDUCIDA POR ABSTINENCIA ALCOHÓLICA"
  },
  {
    "codigo":15918101000119100,
    "descripcion":"FRACTURA NO EXPUESTA DE BORDE ALVEOLAR DE MANDÍBULA DERECHA"
  },
  {
    "codigo":208603000,
    "descripcion":"FRACTURA EXPUESTA DE RÓTULA, POLO PROXIMAL"
  },
  {
    "codigo":372443003,
    "descripcion":"MARGEN PROXIMAL DE RESECCIÓN QUIRÚRGICA ANAL, SIN COMPROMISO TUMORAL"
  },
  {
    "codigo":403376000,
    "descripcion":"HIPERHIDROSIS ASIMÉTRICA"
  },
  {
    "codigo":274139008,
    "descripcion":"SÍNDROME DEL HOMBRE"
  },
  {
    "codigo":110299009,
    "descripcion":"HIGIENE ORAL DEFICIENTE"
  },
  {
    "codigo":11843311000119105,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE OÍDO IZQUIERDO"
  },
  {
    "codigo":1255344007,
    "descripcion":"RUPTURA TRAUMÁTICA DE COMPLEJO FIBROCARTILAGINOSO TRIANGULAR DE REGIÓN DE MUÑECA"
  },
  {
    "codigo":698288007,
    "descripcion":"MELANOMA MALIGNO DE SENO MAXILAR"
  },
  {
    "codigo":204933003,
    "descripcion":"PENE ENCAPUCHADO"
  },
  {
    "codigo":270469004,
    "descripcion":"VIVE EN ALOJAMIENTO CON ENCARGADO"
  },
  {
    "codigo":237701005,
    "descripcion":"APOPLEJÍA HIPOFISARIA"
  },
  {
    "codigo":8325007,
    "descripcion":"INTOXICACIÓN POR MERCAPTOPURINA"
  },
  {
    "codigo":73861008,
    "descripcion":"PÓLIPO DUODENAL"
  },
  {
    "codigo":1153370005,
    "descripcion":"BURSITIS MICÓTICA"
  },
  {
    "codigo":235866006,
    "descripcion":"HEPATITIS C AGUDA"
  },
  {
    "codigo":301402008,
    "descripcion":"DOLOR A LA PALPACIÓN EN ESTRUCTURA DEL TRONCO"
  },
  {
    "codigo":268634009,
    "descripcion":"TRASTORNO PSICONEURÓTICO DE LA PERSONALIDAD"
  },
  {
    "codigo":399706008,
    "descripcion":"OVARIO IZQUIERDO COMPROMETIDO POR TUMOR"
  },
  {
    "codigo":299567001,
    "descripcion":"DEFORMIDAD DE DEDO DEL PIE"
  },
  {
    "codigo":397871004,
    "descripcion":"INVERSIÓN INCOMPLETA DE BLOQUEO NEUROMUSCULAR"
  },
  {
    "codigo":1217071000,
    "descripcion":"PSEUDOHERMAFRODITISMO FEMENINO DEBIDO A HIPERPLASIA SUPRARRENAL CONGÉNITA"
  },
  {
    "codigo":365103006,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA ENTRAR EN LA BAÑERA"
  },
  {
    "codigo":461572001,
    "descripcion":"ATRESIA DE CAYADO AÓRTICO CON CORDÓN FIBROSO ENTRE ARTERIA SUBCLAVIA Y ARTERIA CARÓTIDA PRIMITIVA"
  },
  {
    "codigo":723716009,
    "descripcion":"EPIDERMÓLISIS BULLOSA DISTRÓFICA GENERALIZADA RECESIVA SEVERA"
  },
  {
    "codigo":197593004,
    "descripcion":"SÍNDROME NEFRÓTICO, ANOMALÍA GLOMERULAR MENOR"
  },
  {
    "codigo":164825006,
    "descripcion":"PRUEBA ESPECIAL EN EL HOMBRE - NORMAL"
  },
  {
    "codigo":66521008,
    "descripcion":"DEFICIENCIA DE CEREBRÓSIDO - SULFATASA"
  },
  {
    "codigo":263129009,
    "descripcion":"ESGUINCE DE LIGAMENTO DE DEDO DE LA MANO"
  },
  {
    "codigo":294062000,
    "descripcion":"ALERGIA A EFEDRINA"
  },
  {
    "codigo":721881008,
    "descripcion":"SÍNDROME DE MICRODUPLICACIÓN XP11.22P11.23"
  },
  {
    "codigo":718211004,
    "descripcion":"SÍNDROME DE EHLERS-DANLOS, TIPO CIFOESCOLIÓTICO"
  },
  {
    "codigo":292227004,
    "descripcion":"EFECTO ADVERSO DE ANTIMETABOLITO"
  },
  {
    "codigo":62851005,
    "descripcion":"IMPACTACIÓN DEL INTESTINO"
  },
  {
    "codigo":28248000,
    "descripcion":"TROMBOSIS DE ARTERIA CORONARIA DESCENDENTE ANTERIOR IZQUIERDA"
  },
  {
    "codigo":95619009,
    "descripcion":"INSUFICIENCIA RESPIRATORIA NEONATAL"
  },
  {
    "codigo":93784003,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA EPIGLOTIS"
  },
  {
    "codigo":716376007,
    "descripcion":"RUBOR Y SUDORACIÓN ANORMALES"
  },
  {
    "codigo":126552007,
    "descripcion":"NEOPLASIA DE LA COLUMNA VERTEBRAL"
  },
  {
    "codigo":91949000,
    "descripcion":"GINGIVITIS SENIL ATRÓFICA"
  },
  {
    "codigo":26413003,
    "descripcion":"MOTIVACIÓN DISMINUIDA"
  },
  {
    "codigo":90114000,
    "descripcion":"FRACTURA NO EXPUESTA DE HUESO GRANDE DE LA MUÑECA"
  },
  {
    "codigo":365491006,
    "descripcion":"HALLAZGO RELACIONADO CON LA DISPOSICIÓN DEL CUIDADOR PARA PROVEER ASISTENCIA"
  },
  {
    "codigo":1236994002,
    "descripcion":"BLEFARITIS ANTERIOR DE PÁRPADO INFERIOR IZQUIERDO CAUSADA POR ESTAFILOCOCOS"
  },
  {
    "codigo":57346004,
    "descripcion":"EFECTO TÓXICO DE ACEITE FUSEL"
  },
  {
    "codigo":286722006,
    "descripcion":"CARÁCTER GREGARIO"
  },
  {
    "codigo":253954007,
    "descripcion":"CADERA SUBLUXABLE"
  },
  {
    "codigo":22743000,
    "descripcion":"ONICOMADESIS"
  },
  {
    "codigo":448727008,
    "descripcion":"ANOMALÍA TOTAL DEL RETORNO VENOSO PULMONAR DE TIPO MIXTO"
  },
  {
    "codigo":184748002,
    "descripcion":"SOLICITUD DE PASAPORTE - HONORARIOS NO PAGADOS"
  },
  {
    "codigo":20908003,
    "descripcion":"HEMORRAGIA CEREBRAL SUBCORTICAL"
  },
  {
    "codigo":283052002,
    "descripcion":"ABRASIÓN DE PIEL DE NARIZ"
  },
  {
    "codigo":86444004,
    "descripcion":"ENFERMEDAD DE NIEMANN - PICK, TIPO C, FORMA AGUDA"
  },
  {
    "codigo":113141000112102,
    "descripcion":"TRASTORNO DE MÁCULA CAUSADO POR PENTOSANO POLISULFATO DE SODIO"
  },
  {
    "codigo":250284007,
    "descripcion":"ANOMALÍA LINFOCÍTICA"
  },
  {
    "codigo":707201003,
    "descripcion":"FÍSTULA LATERAL DE PALADAR BLANDO"
  },
  {
    "codigo":248449003,
    "descripcion":"FIEBRE CENTRAL"
  },
  {
    "codigo":15997271000119102,
    "descripcion":"PLIEGUE COROIDEO DE AMBOS OJOS"
  },
  {
    "codigo":1231489009,
    "descripcion":"DESVIACIÓN DE LÍNEA MEDIA DE ARCO DENTAL MAXILAR"
  },
  {
    "codigo":246614005,
    "descripcion":"CIERRE OCULAR EN RESPUESTA A LA LUZ SÚBITA"
  },
  {
    "codigo":1196886005,
    "descripcion":"NEOPLASIA DE ESTROMA GASTROINTESTINAL BENIGNA DE DUODENO"
  },
  {
    "codigo":312150008,
    "descripcion":"INFECCIÓN MICÓTICA DEL APARATO CARDIOVASCULAR"
  },
  {
    "codigo":770902008,
    "descripcion":"MONOSOMÍA DISTAL 12P"
  },
  {
    "codigo":1162283001,
    "descripcion":"INESTABILIDAD DE ARTICULACIÓN DE LA COLUMNA VERTEBRAL DEBIDA A LESIÓN TRAUMÁTICA Y POSTERIOR A ELLA"
  },
  {
    "codigo":277547006,
    "descripcion":"HIPOSMOLALIDAD"
  },
  {
    "codigo":212011007,
    "descripcion":"CORROSIÓN DE SEGUNDO GRADO DE TOBILLO Y PIE"
  },
  {
    "codigo":703531009,
    "descripcion":"SÍNDROME DE BROOKE-SPIEGLER"
  },
  {
    "codigo":472320005,
    "descripcion":"MIOCARDIOPATÍA Y MIOPATÍA MITOCONDRIALES HEREDADAS POR VÍA MATERNA"
  },
  {
    "codigo":13568007,
    "descripcion":"DUPLICACIÓN CONGÉNITA DE ESTÓMAGO"
  },
  {
    "codigo":699861000,
    "descripcion":"ARTRITIS INFLAMATORIA GRANULOMATOSA FAMILIAR, CON DERMATITIS Y UVEÍTIS"
  },
  {
    "codigo":111872008,
    "descripcion":"ENCEFALITIS SECUNDARIA A SARAMPIÓN"
  },
  {
    "codigo":77269002,
    "descripcion":"SÍNDROME DE TRISOMÍA 16 COMPLETA"
  },
  {
    "codigo":208341002,
    "descripcion":"FRACTURA EXPUESTA DE GALEAZZI"
  },
  {
    "codigo":110037004,
    "descripcion":"LACERACIÓN SIMPLE DE LA MEJILLA"
  },
  {
    "codigo":42666000,
    "descripcion":"ANOMALÍA CONGÉNITA DEL CARTÍLAGO TRAQUEAL"
  },
  {
    "codigo":403114001,
    "descripcion":"MICETOMA CAUSADO POR DERMATOFITO"
  },
  {
    "codigo":206506005,
    "descripcion":"ALTERACIÓN METABÓLICA TRANSITORIA EN LACTANTE DE MADRE DIABÉTICA PREVIA"
  },
  {
    "codigo":1156778006,
    "descripcion":"POLIARTRITIS JUVENIL NEGATIVA PARA ANTICUERPOS ANTIPÉPTIDO CÍCLICO CITRULINADO Y PARA FACTOR REUMATOIDE"
  },
  {
    "codigo":237439001,
    "descripcion":"ABSCESO DE PEZÓN"
  },
  {
    "codigo":401279002,
    "descripcion":"ESCALA DE DISNEA DE BORG: 1 - MUY LEVE"
  },
  {
    "codigo":1251412000,
    "descripcion":"URTICARIA AGUDA DEBIDA A ENFERMEDAD INFECCIOSA"
  },
  {
    "codigo":301140001,
    "descripcion":"HALLAZGO RELACIONADO CON LA PRESIÓN ARTERIAL SISTÉMICA"
  },
  {
    "codigo":399444000,
    "descripcion":"TUMOR QUE INVADE CRISTALINO"
  },
  {
    "codigo":170068003,
    "descripcion":"PERÍMETRO CEFÁLICO DEL NIÑO = PERCENTILOS 90 A 96"
  },
  {
    "codigo":442760001,
    "descripcion":"TROMBOFILIA DEBIDA A TRATAMIENTO CON AGENTE ANTINEOPLÁSICO"
  },
  {
    "codigo":204671009,
    "descripcion":"ESTENOSIS PILÓRICA CONGÉNITA"
  },
  {
    "codigo":366676008,
    "descripcion":"AMPLITUD DE MOVIMIENTO DE FLEXIÓN PASIVA DE DEDO DE LA MANO - HALLAZGO"
  },
  {
    "codigo":235604009,
    "descripcion":"ESOFAGITIS POR PROTOZOOS"
  },
  {
    "codigo":69929004,
    "descripcion":"INTOXICACIÓN POR CHELIDONIUM MAJUS"
  },
  {
    "codigo":364841005,
    "descripcion":"POSTURA DEL TRONCO - HALLAZGO"
  },
  {
    "codigo":299305005,
    "descripcion":"SIN AMPLITUD DE ROTACIÓN EXTERNA PASIVA DE ARTICULACIÓN DE CADERA"
  },
  {
    "codigo":430377007,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE TENDÓN TIBIAL POSTERIOR"
  },
  {
    "codigo":233769008,
    "descripcion":"SARCOIDOSIS PULMONAR, ESTADIO 3"
  },
  {
    "codigo":725289009,
    "descripcion":"5-AMINO-4-IMIDAZOL CARBOXAMIDA RIBOSIDURIA"
  },
  {
    "codigo":788990002,
    "descripcion":"ENTEROCOLITIS NECROSANTE DEL RECIÉN NACIDO, ESTADIO 3A DE LA CLASIFICACIÓN DE BELL"
  },
  {
    "codigo":201001005,
    "descripcion":"LIQUEN PLANO OBTUSO"
  },
  {
    "codigo":723454008,
    "descripcion":"SOBREACTIVIDAD DE FOSFORRIBOSILPIROFOSFATO SINTETASA"
  },
  {
    "codigo":1149438008,
    "descripcion":"DISTORSIÓN DEL PENSAMIENTO DISMINUIDA"
  },
  {
    "codigo":231934009,
    "descripcion":"DISTROFIA CORNEAL PRE-DESCEMET"
  },
  {
    "codigo":262867002,
    "descripcion":"DESGARRO SEROSO DE CIEGO"
  },
  {
    "codigo":66259004,
    "descripcion":"HEMATOCELE MASCULINO"
  },
  {
    "codigo":68094008,
    "descripcion":"HIPOPLASIA CONGÉNITA DE VÍA BILIAR"
  },
  {
    "codigo":33491002,
    "descripcion":"ANEMIA HEMOLÍTICA AUTOINMUNITARIA CAUSADA POR INMUNOGLOBULINA A MÁS COMPLEMENTO"
  },
  {
    "codigo":721619003,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE TERCIO MEDIO DE ESÓFAGO"
  },
  {
    "codigo":128125000,
    "descripcion":"LESIÓN TRAUMÁTICA DE LOS BRONQUIOS"
  },
  {
    "codigo":95357004,
    "descripcion":"ANESTESIA DE LA MEMBRANA MUCOSA"
  },
  {
    "codigo":717949007,
    "descripcion":"OSTEOPENIA NEONATAL"
  },
  {
    "codigo":27986000,
    "descripcion":"ANEURISMA ARTERIOVENOSO PULMONAR CONGÉNITO"
  },
  {
    "codigo":1142098001,
    "descripcion":"TAQUICARDIA ECTÓPICA DE LA UNIÓN AURICULOVENTRICULAR POSQUIRÚRGICA"
  },
  {
    "codigo":421202000,
    "descripcion":"ASTIGMATISMO A FAVOR DE LA REGLA"
  },
  {
    "codigo":93522004,
    "descripcion":"ENFERMEDAD DE HODGKIN DE LOS GANGLIOS LINFÁTICOS INTRATORÁCICOS"
  },
  {
    "codigo":714279000,
    "descripcion":"MIELOPATÍA CAUSADA POR VIRUS LINFOTRÓPICO DE CÉLULAS T HUMANO TIPO 1"
  },
  {
    "codigo":124455008,
    "descripcion":"DEFICIENCIA DE CELULASA"
  },
  {
    "codigo":26151008,
    "descripcion":"ENFERMEDAD DE GRAVES CON ACROPAQUIA Y CRISIS TIROTÓXICA"
  },
  {
    "codigo":417532002,
    "descripcion":"ALERGIA A PESCADO"
  },
  {
    "codigo":286460003,
    "descripcion":"INCAPAZ DE LAVAR LOS ALIMENTOS"
  },
  {
    "codigo":450300002,
    "descripcion":"ORIGEN ANÓMALO DE ARTERIA CORONARIA DERECHA EN ARTERIA PULMONAR"
  },
  {
    "codigo":253692006,
    "descripcion":"ARTERIA COLATERAL BRONCOPULMONAR"
  },
  {
    "codigo":448465000,
    "descripcion":"LINFOMA NO HODGKIN DIFUSO DE TESTÍCULO"
  },
  {
    "codigo":284625000,
    "descripcion":"GOLPEAR A OTRA PERSONA CON UN OBJETO"
  },
  {
    "codigo":1169361002,
    "descripcion":"ENCEFALITIS LÍMBICA POR ANTICUERPOS ANTI NEUREXINA 3"
  },
  {
    "codigo":353061000119107,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE RETINA DE OJO DERECHO"
  },
  {
    "codigo":251857007,
    "descripcion":"EQUILIBRIO HÍDRICO POSITIVO"
  },
  {
    "codigo":446630000,
    "descripcion":"APROXIMACIÓN INCOMPLETA DE VALVA DE VÁLVULA TRICÚSPIDE"
  },
  {
    "codigo":315558002,
    "descripcion":"NACIDO EN VENEZUELA"
  },
  {
    "codigo":282790006,
    "descripcion":"LESIÓN QUÍMICA DE NERVIO PERIFÉRICO"
  },
  {
    "codigo":280955001,
    "descripcion":"MELASMA INDUCIDA POR FÁRMACOS"
  },
  {
    "codigo":1263995002,
    "descripcion":"PANCREATITIS CRÓNICA DEBIDA A CÁLCULO DE VESÍCULA BILIAR"
  },
  {
    "codigo":248187002,
    "descripcion":"CARA ENVEJECIDA"
  },
  {
    "codigo":117115006,
    "descripcion":"SOPLO CARDÍACO, MEDIO"
  },
  {
    "codigo":1231227006,
    "descripcion":"NEURORRETINITIS POSINFECCIOSA"
  },
  {
    "codigo":51579006,
    "descripcion":"COROIDITIS Y CORIORRETINITIS DISEMINADA, POLO POSTERIOR"
  },
  {
    "codigo":705104001,
    "descripcion":"FRACTURA NO EXPUESTA DE PARED ANTERIOR DE ACETÁBULO"
  },
  {
    "codigo":82512002,
    "descripcion":"AMPOLLA DEL DORSO, CON INFECCIÓN"
  },
  {
    "codigo":408357000,
    "descripcion":"EFECTO COLATERAL DE MEDICAMENTO - ACEPTABLE PARA EL PACIENTE"
  },
  {
    "codigo":211749001,
    "descripcion":"CORROSIÓN DE LA CABEZA Y EL CUELLO"
  },
  {
    "codigo":703269000,
    "descripcion":"HEMANGIOMA GIGANTE INFANTIL"
  },
  {
    "codigo":1293093002,
    "descripcion":"CARCINOMA ESCAMOSO PSEUDOVASCULAR"
  },
  {
    "codigo":1260325004,
    "descripcion":"TEMOR A CÁNCER DE SISTEMA NEUROLÓGICO"
  },
  {
    "codigo":277285005,
    "descripcion":"DOLOR TALÁMICO"
  },
  {
    "codigo":275450006,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DE MUÑECA Y MANO CON AMPOLLA"
  },
  {
    "codigo":13306007,
    "descripcion":"ACIDEMIA PIPECÓLICA"
  },
  {
    "codigo":765135003,
    "descripcion":"PAQUIDERMIA PLEGADA DE CUERO CABELLUDO PRIMARIA ESENCIAL"
  },
  {
    "codigo":404687005,
    "descripcion":"NEUROMIOTONÍA OCULAR"
  },
  {
    "codigo":240847006,
    "descripcion":"ÚLCERA POR DRACÚNCULO"
  },
  {
    "codigo":109775009,
    "descripcion":"ESTOMATITIS POR CONTACTO"
  },
  {
    "codigo":206244002,
    "descripcion":"HEMATOMA VULVAR DEBIDO A TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":239012006,
    "descripcion":"DISPLASIA ECTODÉRMICA TIPO GREITHER"
  },
  {
    "codigo":402852007,
    "descripcion":"PÚRPURA HIPERGLOBULINÉMICA"
  },
  {
    "codigo":1254820008,
    "descripcion":"INESTABILIDAD DE PRÓTESIS DE ARTICULACIÓN DE RODILLA"
  },
  {
    "codigo":271780009,
    "descripcion":"CÁLCULO DE FOSFATO DE VEJIGA URINARIA"
  },
  {
    "codigo":401017002,
    "descripcion":"OBSERVACIÓN RELACIONADA CON LA CONDUCTA SEGURA"
  },
  {
    "codigo":204409004,
    "descripcion":"BANDAS VENTRICULARES ANÓMALAS"
  },
  {
    "codigo":1092851000119103,
    "descripcion":"COMPLICACIÓN DEBIDA A COLITIS ULCEROSA"
  },
  {
    "codigo":202574006,
    "descripcion":"OSTEOCONDROMATOSIS SINOVIAL"
  },
  {
    "codigo":300878007,
    "descripcion":"TUMEFACCIÓN DE ESTRUCTURA DE LA CAVIDAD BUCAL"
  },
  {
    "codigo":366414007,
    "descripcion":"AMPLITUD DEL MOVIMIENTO ACTIVO DE FLEXIÓN LATERAL HACIA LA DERECHA DE LA COLUMNA DORSAL - HALLAZGO"
  },
  {
    "codigo":299043001,
    "descripcion":"HALLAZGO RELACIONADO CON HUESO DE LA MANO"
  },
  {
    "codigo":725027004,
    "descripcion":"DEFICIENCIA DE SINTASA DE GLUCÓGENO MUSCULAR Y CARDÍACA"
  },
  {
    "codigo":167971006,
    "descripcion":"LÍQUIDO PLEURAL: SE OBSERVAN LINFOCITOS"
  },
  {
    "codigo":297208002,
    "descripcion":"QUEJIDO ESPIRATORIO"
  },
  {
    "codigo":35064005,
    "descripcion":"HECES OSCURAS"
  },
  {
    "codigo":67832005,
    "descripcion":"SINUSITIS ETMOIDAL AGUDA"
  },
  {
    "codigo":65997000,
    "descripcion":"PLIEGUE CONGÉNITO DEL SEGMENTO POSTERIOR DEL OJO"
  },
  {
    "codigo":788728009,
    "descripcion":"HEMATOMA DE HERIDA QUIRÚRGICA POSTERIOR A OPERACIÓN CESÁREA"
  },
  {
    "codigo":2296009,
    "descripcion":"TOXICIDAD POR HIERRO DEXTRAN"
  },
  {
    "codigo":262605005,
    "descripcion":"CUERPO EXTRAÑO EN FOSA PIRIFORME"
  },
  {
    "codigo":721357008,
    "descripcion":"LUXACIÓN TRAUMÁTICA DE CUARTA Y QUINTA VÉRTEBRAS CERVICALES"
  },
  {
    "codigo":295373008,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE OMEPRAZOL"
  },
  {
    "codigo":162466003,
    "descripcion":"SÍNTOMA BANAL"
  },
  {
    "codigo":129698004,
    "descripcion":"CON MAYOR RIESGO DE SOLEDAD"
  },
  {
    "codigo":15975821000119103,
    "descripcion":"NEOPLASIA ÓSEA BENIGNA BILATERAL DE MANO"
  },
  {
    "codigo":64162006,
    "descripcion":"SÍNDROME DE MALFORMACIÓN MÚLTIPLE CON HALLAZGOS CEREBRALES Y\/O NEUROMUSCULARES INUSUALES"
  },
  {
    "codigo":195234007,
    "descripcion":"OCLUSIÓN Y ESTENOSIS DE ARTERIA CEREBRAL POSTERIOR"
  },
  {
    "codigo":1145506008,
    "descripcion":"HIPOPLASIA CONGÉNITA DE FALANGE DE DEDO DE MANO"
  },
  {
    "codigo":719522009,
    "descripcion":"INFECCIÓN DEL TRACTO RESPIRATORIO SUPERIOR CAUSADA POR CANDIDA CONCOMITANTE CON INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":95095000,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE PARTES BLANDAS DE LA CADERA"
  },
  {
    "codigo":422775003,
    "descripcion":"MALFORMACIÓN DENTAL"
  },
  {
    "codigo":291703004,
    "descripcion":"INTOXICACIÓN INTENCIONAL CON PRODUCTO PLAGUICIDA"
  },
  {
    "codigo":160631001,
    "descripcion":"DISFRUTA EL EJERCICIO FÍSICO LIVIANO"
  },
  {
    "codigo":62327006,
    "descripcion":"SIGNO DE ORDEÑO"
  },
  {
    "codigo":293538008,
    "descripcion":"REACCIÓN ADVERSA A NICORANDIL"
  },
  {
    "codigo":60492000,
    "descripcion":"TRASTORNO DE LIGAMENTO"
  },
  {
    "codigo":289868000,
    "descripcion":"HALLAZGO RELACIONADO CON LA HIGIENE PERINEAL FEMENINA"
  },
  {
    "codigo":288691009,
    "descripcion":"ADAPTA LA CONVERSACIÓN AL CONTEXTO"
  },
  {
    "codigo":1141836004,
    "descripcion":"SIGNO DE RETRACCIÓN DE PÁRPADO DE COLLIER"
  },
  {
    "codigo":715852004,
    "descripcion":"INFECCIÓN DEL TRACTO GASTROINTESTINAL"
  },
  {
    "codigo":93260007,
    "descripcion":"HIPOPLASIA CONGÉNITA DEL TUBÉRCULO GENITAL"
  },
  {
    "codigo":224332008,
    "descripcion":"ESPOSA ARRESTADA"
  },
  {
    "codigo":124193005,
    "descripcion":"DEFICIENCIA DE URATO OXIDASA"
  },
  {
    "codigo":1269238002,
    "descripcion":"TROMBOSIS DE ARTERIA CEREBRAL ANTERIOR"
  },
  {
    "codigo":708512000,
    "descripcion":"ENFERMEDAD GINGIVAL DEBIDA A DESNUTRICIÓN"
  },
  {
    "codigo":315296002,
    "descripcion":"HERIDA OCULAR PENETRANTE"
  },
  {
    "codigo":85920003,
    "descripcion":"ESTREÑIMIENTO DEBIDO A OBSTRUCCIÓN DE LA SALIDA"
  },
  {
    "codigo":249760002,
    "descripcion":"YEMAS DE DEDOS DE LA MANO AUSENTES"
  },
  {
    "codigo":282528005,
    "descripcion":"DIFICULTAD PARA SUBIR ESCALERAS CORRIENDO"
  },
  {
    "codigo":1003424006,
    "descripcion":"CATARATA TIPO HUTTERITE"
  },
  {
    "codigo":446368008,
    "descripcion":"LACERACIÓN PROFUNDA DE MIEMBRO INFERIOR"
  },
  {
    "codigo":870517000,
    "descripcion":"FIBROSIS PERIPORTAL"
  },
  {
    "codigo":15677121000119102,
    "descripcion":"MIOSITIS DE MANO IZQUIERDA"
  },
  {
    "codigo":247925009,
    "descripcion":"GIROS REPETITIVOS DE OBJETOS"
  },
  {
    "codigo":49482007,
    "descripcion":"PELVIS PSEUDOOSTEOMALÁCICA"
  },
  {
    "codigo":1260063000,
    "descripcion":"CARCINOMA MUCOEPIDERMOIDE DE HIPOFARINGE"
  },
  {
    "codigo":16714009,
    "descripcion":"ABORTO ESPONTÁNEO CON LACERACIÓN DE INTESTINO"
  },
  {
    "codigo":703007008,
    "descripcion":"NOCARDIA ABSCESSUS O NOCARDIA ARTHRITIDIS"
  },
  {
    "codigo":12236481000119105,
    "descripcion":"BURSITIS DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":735775009,
    "descripcion":"LACERACIÓN DE PELVIS SIN CUERPO EXTRAÑO"
  },
  {
    "codigo":45812003,
    "descripcion":"MALABSORCIÓN FAMILIAR DE METIONINA"
  },
  {
    "codigo":78580004,
    "descripcion":"ORQUITIS PAROTÍDEA"
  },
  {
    "codigo":209652005,
    "descripcion":"RUPTURA COMPLETA DE LIGAMENTO ESTERNOCLAVICULAR"
  },
  {
    "codigo":733940003,
    "descripcion":"CARIES DENTAL ACTIVA PRIMARIA QUE SE EXTIENDE HASTA LA MITAD INTERNA DEL ESMALTE"
  },
  {
    "codigo":111348008,
    "descripcion":"QUEILITIS POR CONTACTO"
  },
  {
    "codigo":13044008,
    "descripcion":"AFASIA ASOCIATIVA"
  },
  {
    "codigo":240585002,
    "descripcion":"ÚLCERA ANOGENITAL CHANCROIDE"
  },
  {
    "codigo":766708008,
    "descripcion":"ISOCROMOSOMÍA YP"
  },
  {
    "codigo":43977004,
    "descripcion":"DEGENERACIÓN CORTICOESTRIADA-ESPINAL"
  },
  {
    "codigo":764873005,
    "descripcion":"ASPIRACIÓN PULMONAR PERIOPERATORIA"
  },
  {
    "codigo":109513007,
    "descripcion":"ASIMETRÍA MANDIBULAR CONGÉNITA"
  },
  {
    "codigo":1156254000,
    "descripcion":"COMPOSICIÓN DE INGESTA NUTRICIONAL INCOMPATIBLE CON EL REQUERIMIENTO"
  },
  {
    "codigo":238750001,
    "descripcion":"ENROJECIMIENTO DE CARA DEBIDO A ROSÁCEA"
  },
  {
    "codigo":11209007,
    "descripcion":"ENREDO DE CORDÓN SIN COMPRESIÓN"
  },
  {
    "codigo":11800411000119103,
    "descripcion":"LACERACIÓN DE VENA RENAL DERECHA"
  },
  {
    "codigo":1252723003,
    "descripcion":"LESIÓN PRIMARIA DE TEJIDO PERIODONTAL CON LESIÓN SECUNDARIA DE PULPA DE DIENTE"
  },
  {
    "codigo":40307005,
    "descripcion":"TRASTORNO PRIMARIO DEL SENTIDO DEL GUSTO DE LOS SABORES ÁCIDOS"
  },
  {
    "codigo":365960007,
    "descripcion":"ORIENTACIÓN DE LA RELACIÓN SEXUAL - HALLAZGO"
  },
  {
    "codigo":300616000,
    "descripcion":"NO SE TRASLADA A PIE"
  },
  {
    "codigo":235080003,
    "descripcion":"ANOMALÍA DEL TAMAÑO DE MAXILAR SUPERIOR E INFERIOR"
  },
  {
    "codigo":366152004,
    "descripcion":"CAPACIDAD VITAL - HALLAZGO"
  },
  {
    "codigo":169544009,
    "descripcion":"FALLA DE PÍLDORA ANTICONCEPTIVA POSCOITAL"
  },
  {
    "codigo":36637003,
    "descripcion":"TEMBLOR INTERMITENTE"
  },
  {
    "codigo":167709003,
    "descripcion":"ASPECTO DEL LCR: XANTOCRÓMICO"
  },
  {
    "codigo":12265461000119101,
    "descripcion":"ENDOMETRIOSIS DE AMBOS OVARIOS"
  },
  {
    "codigo":298781007,
    "descripcion":"AMPLITUD DE FLEXIÓN PASIVA DE HOMBRO NORMAL"
  },
  {
    "codigo":722930000,
    "descripcion":"TROMBOSIS NEONATAL DE SENO VENOSO CEREBRAL"
  },
  {
    "codigo":724765008,
    "descripcion":"COREA CONCOMITANTE CON DEGENERACIÓN DENTADORRUBROPALIDOLUISIANA Y DEBIDA A ELLA"
  },
  {
    "codigo":397085008,
    "descripcion":"MARGEN QUIRÚRGICO PANCREÁTICO COMPROMETIDO POR TUMOR, NO APLICABLE"
  },
  {
    "codigo":11718491000119109,
    "descripcion":"RETRACCIÓN ANORMAL DE AMBOS PÁRPADOS INFERIORES"
  },
  {
    "codigo":296946006,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE YODURO"
  },
  {
    "codigo":1148914007,
    "descripcion":"ANEMIA SIDEROBLÁSTICA AUTOSÓMICA DOMINANTE"
  },
  {
    "codigo":788466008,
    "descripcion":"TRASTORNO REPETITIVO DEL MOVIMIENTO DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":428018007,
    "descripcion":"FRACTURA INTRAARTICULAR EXPUESTA DE CALCÁNEO, EN LENGÜETA"
  },
  {
    "codigo":426183003,
    "descripcion":"BLOQUEO AURICULOVENTRICULAR TIPO II DE MOBITZ ELECTROCARDIOGRÁFICO"
  },
  {
    "codigo":199004,
    "descripcion":"HIPOGALACTIA"
  },
  {
    "codigo":196807006,
    "descripcion":"HERNIA INGUINAL OBSTRUIDA"
  },
  {
    "codigo":721095007,
    "descripcion":"SÍNDROME DE DEFECTO DIAFRAGMÁTICO, DEFICIENCIA DE MIEMBROS Y DEFECTO DE LA CALOTA CRANEAL"
  },
  {
    "codigo":1145244000,
    "descripcion":"RADICULITIS DEBIDA A RUPTURA DE DISCO INTERVERTEBRAL"
  },
  {
    "codigo":295111009,
    "descripcion":"ALERGIA A ANISTREPLASA"
  },
  {
    "codigo":162204000,
    "descripcion":"INSOMNIO TARDÍO"
  },
  {
    "codigo":293276001,
    "descripcion":"REACCIÓN ADVERSA A LA HORMONA REGULADORA DE LAS GONADOTROFINAS"
  },
  {
    "codigo":1343687006,
    "descripcion":"ALTERACIÓN CRÓNICA DE ASTA POSTERIOR DE MENISCO INTERNO DE RODILLA IZQUIERDA"
  },
  {
    "codigo":63900005,
    "descripcion":"SÍNDROME DE ALAJOUANINE"
  },
  {
    "codigo":688271000119100,
    "descripcion":"SÍNDROME DE SÉZARY DE GANGLIOS LINFÁTICOS INGUINALES"
  },
  {
    "codigo":424348007,
    "descripcion":"DIFICULTAD PARA VER OBJETOS DISTANTES"
  },
  {
    "codigo":225905000,
    "descripcion":"CAPAZ DE PREVENIR UNA CONDUCTA INDESEABLE"
  },
  {
    "codigo":29297002,
    "descripcion":"SEDIMENTOS CRISTALINOS EN EL VÍTREO"
  },
  {
    "codigo":94833002,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL NERVIO FACIAL"
  },
  {
    "codigo":193137006,
    "descripcion":"LESIÓN DE NERVIO RADIAL"
  },
  {
    "codigo":291441007,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR PIRIMETAMINA"
  },
  {
    "codigo":289606001,
    "descripcion":"APÓSITO MATERNO HUMEDECIDO CON LÍQUIDO AMNIÓTICO"
  },
  {
    "codigo":1208945009,
    "descripcion":"TRASTORNO FETAL DEBIDO A DESPRENDIMIENTO DE PLACENTA"
  },
  {
    "codigo":1010502004,
    "descripcion":"AGENESIA DE FALANGE DE DEDO PULGAR"
  },
  {
    "codigo":92998007,
    "descripcion":"ANOMALÍA CONGÉNITA DE LA VÉRTEBRA CAUDAL"
  },
  {
    "codigo":781126009,
    "descripcion":"PUNCIÓN ACCIDENTAL DE ARTERIA"
  },
  {
    "codigo":123931001,
    "descripcion":"INTOXICACIÓN POR CACTACEAE"
  },
  {
    "codigo":12238991000119104,
    "descripcion":"TRASTORNO DE BOLSA SEROSA DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":386075003,
    "descripcion":"TRASTORNO RELACIONADO CON LA VITAMINA K1"
  },
  {
    "codigo":10682511000119104,
    "descripcion":"TUMEFACCIÓN DEL TEJIDO CELULAR SUBCUTÁNEO DE DEDO DEL PIE IZQUIERDO"
  },
  {
    "codigo":255003007,
    "descripcion":"CARCINOMA ESCAMOSO DE CONJUNTIVA"
  },
  {
    "codigo":285936004,
    "descripcion":"INCAPAZ DE VACIAR EL LAVABO"
  },
  {
    "codigo":253168004,
    "descripcion":"MEGALENCEFALIA FAMILIAR"
  },
  {
    "codigo":251333000,
    "descripcion":"SUSCEPTIBILIDAD A LA CARIES"
  },
  {
    "codigo":449776009,
    "descripcion":"GLOSITIS SIFILÍTICA"
  },
  {
    "codigo":16007311000119107,
    "descripcion":"FUSIÓN ANORMAL CONGÉNITA DE HUESOS DE CARPO DERECHO"
  },
  {
    "codigo":114831000119107,
    "descripcion":"HIPERLIPIDEMIA CAUSADA POR ESTEROIDE"
  },
  {
    "codigo":710085008,
    "descripcion":"ALTURA DE HUESO MANDIBULAR EDÉNTULO TIPO II"
  },
  {
    "codigo":85658001,
    "descripcion":"VIRUELA DEL BÚFALO"
  },
  {
    "codigo":447941008,
    "descripcion":"DEFECTO RESIDUAL DE TABIQUE INTERVENTRICULAR"
  },
  {
    "codigo":216730004,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR PENTACLOROFENOL"
  },
  {
    "codigo":334121000119103,
    "descripcion":"LAGOFTALMOS MECÁNICO DE PÁRPADO INFERIOR DERECHO"
  },
  {
    "codigo":52890006,
    "descripcion":"PERITONITIS GENERALIZADA AGUDA"
  },
  {
    "codigo":444271000,
    "descripcion":"RESISTENCIA A ERITROPOYETINA EN ANEMIA DE ENFERMEDAD RENAL CRÓNICA"
  },
  {
    "codigo":247663003,
    "descripcion":"ORIENTADO"
  },
  {
    "codigo":409668002,
    "descripcion":"FOTOFOBIA"
  },
  {
    "codigo":49220004,
    "descripcion":"INSUFICIENCIA RENAL HIPERTENSIVA"
  },
  {
    "codigo":278596004,
    "descripcion":"SUPERFICIE DE ENCHAPADO DENTAL ÁSPERA"
  },
  {
    "codigo":309529002,
    "descripcion":"MASA EN PULMÓN"
  },
  {
    "codigo":11311401000119107,
    "descripcion":"FRACTURA PATOLÓGICA DE VÉRTEBRA DORSAL DEBIDA A ENFERMEDAD NEOPLÁSICA"
  },
  {
    "codigo":702745006,
    "descripcion":"FALLA DE ADHESIVO DE RESTAURACIÓN DENTAL"
  },
  {
    "codigo":735513007,
    "descripcion":"QUEMADURA COMPLEJA DE TOBILLO"
  },
  {
    "codigo":405998000,
    "descripcion":"ANOMALÍA FETAL EN EL ESPÉCIMEN, AUSENTE"
  },
  {
    "codigo":307694000,
    "descripcion":"MIRADA EN PING - PONG"
  },
  {
    "codigo":10737961000119108,
    "descripcion":"CARCINOMA INDIFERENCIADO DE OVARIO DERECHO"
  },
  {
    "codigo":1259801009,
    "descripcion":"NEOPLASIA PRIMARIA DE ESTROMA GASTROINTESTINAL DE LOCALIZACIONES SUPERPUESTAS DE INTESTINO DELGADO"
  },
  {
    "codigo":209390009,
    "descripcion":"FRACTURA-LUXACIÓN NO EXPUESTA DE LA PELVIS"
  },
  {
    "codigo":305859005,
    "descripcion":"ATENDIDO POR SERVICIO DE ADAPTACIÓN QUIRÚRGICA"
  },
  {
    "codigo":43715006,
    "descripcion":"INERCIA UTERINA SECUNDARIA"
  },
  {
    "codigo":109251008,
    "descripcion":"PRURITO SOLAR DE LOS CODOS"
  },
  {
    "codigo":9112001,
    "descripcion":"CONVULSIÓN DEL PUERPERIO"
  },
  {
    "codigo":404163009,
    "descripcion":"XANTOMATOSIS PLANA NORMOLIPÉMICA DIFUSA"
  },
  {
    "codigo":238488003,
    "descripcion":"DERMATOSIS RELACIONADA CON AMPUTACIÓN"
  },
  {
    "codigo":1287064004,
    "descripcion":"HEMORRAGIA INTRAVENTRICULAR NO TRAUMÁTICA GRADO 3 DURANTE PERÍODO NEONATAL TEMPRANO"
  },
  {
    "codigo":205720009,
    "descripcion":"CROMOSOMA X FRÁGIL"
  },
  {
    "codigo":236653003,
    "descripcion":"DISINERGIA DE TRACTO DE SALIDA DE VEJIGA URINARIA"
  },
  {
    "codigo":16747101000119101,
    "descripcion":"RETINOPATÍA NO PROLIFERATIVA SEVERA BILATERAL DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":72813006,
    "descripcion":"REACCIÓN A TRANSFUSIÓN CAUSADA POR ANTICUERPO PLAQUETARIO"
  },
  {
    "codigo":726338000,
    "descripcion":"TRISOMÍA PARCIAL DE CROMOSOMA 1"
  },
  {
    "codigo":365890001,
    "descripcion":"DESEMPEÑO DE LA MEMORIA SEMÁNTICA - HALLAZGO"
  },
  {
    "codigo":70978004,
    "descripcion":"SITUS INVERSUS TORÁCICO"
  },
  {
    "codigo":1119554004,
    "descripcion":"DORSO NASAL ESTRECHO"
  },
  {
    "codigo":300354009,
    "descripcion":"HALLAZGO RELACIONADO CON MEDICIONES DE LA VESÍCULA BILIAR"
  },
  {
    "codigo":298519002,
    "descripcion":"AMPLITUD DE EXTENSIÓN ACTIVA NORMAL DE LA COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":722668001,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE ANEXOS OCULARES"
  },
  {
    "codigo":296684003,
    "descripcion":"SOBREDOSIS INTENCIONAL DE CEFAZOLINA"
  },
  {
    "codigo":263916005,
    "descripcion":"CONDUCTA INCIERTA"
  },
  {
    "codigo":198380007,
    "descripcion":"LEUCOPLASIA DE VULVA"
  },
  {
    "codigo":34540009,
    "descripcion":"EXTREMIDAD INESTABLE"
  },
  {
    "codigo":460524009,
    "descripcion":"ORIGEN ANÓMALO DE ARTERIA CORONARIA DERECHA EN ARTERIA CORONARIA DESCENDENTE ANTERIOR IZQUIERDA"
  },
  {
    "codigo":131009007,
    "descripcion":"NIVEL DE PROLACTINA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":293014001,
    "descripcion":"REACCIÓN ADVERSA AL CEFTIBUTENO"
  },
  {
    "codigo":260246004,
    "descripcion":"HALLAZGO RELACIONADO CON LA AGUDEZA VISUAL"
  },
  {
    "codigo":225643000,
    "descripcion":"ANSIEDAD ACERCA DE COMETER ERRORES"
  },
  {
    "codigo":1144982009,
    "descripcion":"ADHERENCIAS DELGADAS DE ANEXOS UTERINOS DEBIDAS A ENDOMETRIOSIS"
  },
  {
    "codigo":94571002,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE PIEL DE HOMBRO"
  },
  {
    "codigo":336631000119104,
    "descripcion":"GLAUCOMA ABSOLUTO DE OJO DERECHO"
  },
  {
    "codigo":782699008,
    "descripcion":"ESTENOSIS CONGÉNITA DE ORIFICIO DE ARTERIA CORONARIA"
  },
  {
    "codigo":127339009,
    "descripcion":"TRASTORNO METABÓLICO AGUDO"
  },
  {
    "codigo":30211000175107,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN EN CODO DERECHO ESTADIO I"
  },
  {
    "codigo":289344004,
    "descripcion":"FETO, PRESENTE"
  },
  {
    "codigo":92736003,
    "descripcion":"CARCINOMA IN SITU DE LA PIEL DEL CUELLO"
  },
  {
    "codigo":15983351000119106,
    "descripcion":"POSICIÓN ANÓMALA CONGÉNITA DE OÍDO EXTERNO DERECHO"
  },
  {
    "codigo":59968008,
    "descripcion":"TRICOBEZOAR INTESTINAL"
  },
  {
    "codigo":11778961000119101,
    "descripcion":"SUBLUXACIÓN DE CABEZA DE RADIO IZQUIERDO"
  },
  {
    "codigo":1336085007,
    "descripcion":"TRASTORNO POR USO DE ALCOHOL"
  },
  {
    "codigo":449514000,
    "descripcion":"CONEXIÓN VENOSA PULMONAR ANÓMALA DE LOCALIZACIÓN INTRACARDÍCA EN LÍNEA MEDIA CON AURÍCULAS ISOMÉRICAS"
  },
  {
    "codigo":123669009,
    "descripcion":"HIPERTROFIA SEUDOLIPOMATOSA DEL PÁNCREAS"
  },
  {
    "codigo":285674009,
    "descripcion":"INCAPAZ DE CARGAR PESO"
  },
  {
    "codigo":1268714009,
    "descripcion":"NEFLOBLASTOMA PRIMARIO"
  },
  {
    "codigo":21695004,
    "descripcion":"EVALUACIÓN DE DISCAPACIDAD: 98%"
  },
  {
    "codigo":283839008,
    "descripcion":"GOTA INTERCRÍTICA"
  },
  {
    "codigo":249236000,
    "descripcion":"HALLAZGO TESTICULAR"
  },
  {
    "codigo":216468001,
    "descripcion":"INTOXICACIÓN ACCIDENTAL CAUSADA POR MORFINA"
  },
  {
    "codigo":10959761000119106,
    "descripcion":"HERIDA PUNZANTE DE CODO DERECHO"
  },
  {
    "codigo":312937006,
    "descripcion":"HEMANGIOMA CAVERNOSO DE RETINA"
  },
  {
    "codigo":50793006,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DE MANO"
  },
  {
    "codigo":116329008,
    "descripcion":"HALLAZGO RELACIONADO CON EL MODO DE ANDAR"
  },
  {
    "codigo":1197673009,
    "descripcion":"DISMOTILIDAD DE INTESTINO DELGADO DEBIDA A ENFERMEDAD SISTÉMICA"
  },
  {
    "codigo":83561009,
    "descripcion":"ESTENOSIS DE CONDUCTO RAQUÍDEO EN REGIÓN CERVICAL"
  },
  {
    "codigo":1163070000,
    "descripcion":"ENCEFALITIS CAUSADA POR RETROVIRIDAE"
  },
  {
    "codigo":247401007,
    "descripcion":"UMBRAL DISMINUIDO PARA EL DOLOR"
  },
  {
    "codigo":442174001,
    "descripcion":"LITIO EN ESPÉCIMEN DE SANGRE FUERA DEL RANGO TERAPÉUTICO"
  },
  {
    "codigo":47123000,
    "descripcion":"RUPTURA DE LOS LIGAMENTOS CRUZADOS"
  },
  {
    "codigo":54591000087101,
    "descripcion":"MORAXELLA LACUNATA O MORAXELLA OVIS"
  },
  {
    "codigo":39231000087102,
    "descripcion":"POLINEUROPATÍA CRÓNICA DOLOROSA"
  },
  {
    "codigo":210963006,
    "descripcion":"SECUELAS POR HERIDA ABIERTA EN LOS MIEMBROS INFERIORES"
  },
  {
    "codigo":44351000087101,
    "descripcion":"CONTUSIÓN DE RÓTULA IZQUIERDA"
  },
  {
    "codigo":471272001,
    "descripcion":"NEUMONÍA CAVITARIA"
  },
  {
    "codigo":1259539007,
    "descripcion":"CARCINOMA PRIMARIO DE PÁNCREAS"
  },
  {
    "codigo":46911000087106,
    "descripcion":"FRACTURA DE FALANGE DISTAL DE DEDO MEDIO DERECHO"
  },
  {
    "codigo":733416004,
    "descripcion":"SÍNDROME DE EXOSTOSIS, ANETODERMIA Y BRAQUIDACTILIA TIPO E"
  },
  {
    "codigo":438504004,
    "descripcion":"SÍNDROME DE MICROFTALMÍA DE LENZ"
  },
  {
    "codigo":209128004,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE LA ARTICULACIÓN ESTERNOCLAVICULAR, ANTERIOR"
  },
  {
    "codigo":274664007,
    "descripcion":"DOLOR TORÁCICO AL RESPIRAR"
  },
  {
    "codigo":240061000,
    "descripcion":"DISTROFIA MUSCULAR CONGÉNITA CON ARTROGRIPOSIS MÚLTIPLE CONGÉNITA"
  },
  {
    "codigo":241896008,
    "descripcion":"EFECTO TÓXICO CAUSADO POR ANTICONGELANTE"
  },
  {
    "codigo":372968008,
    "descripcion":"INFECCIÓN CAUSADA POR PENICILLIUM SPINULOSUM"
  },
  {
    "codigo":698813003,
    "descripcion":"PERFIL FACIAL RECTO"
  },
  {
    "codigo":897256003,
    "descripcion":"CURVATURA ANORMAL DE FALANGE PROXIMAL DE CUARTO DEDO DE PIE"
  },
  {
    "codigo":305597001,
    "descripcion":"BAJO ATENCIÓN DE AUDIÓLOGO"
  },
  {
    "codigo":12520005,
    "descripcion":"INFECCIÓN CAUSADA POR PARAFILAROIDES"
  },
  {
    "codigo":403901001,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS, TIPO ACANTOLÍTICO"
  },
  {
    "codigo":762514001,
    "descripcion":"TRASTORNO DEL ESTADO DE ÁNIMO CON SÍNTOMAS DEPRESIVOS Y MANÍACOS MIXTOS CAUSADO POR CATINONA SINTÉTICA"
  },
  {
    "codigo":1076421000119104,
    "descripcion":"BURSITIS RETROCALCÁNEA DE PIE DERECHO"
  },
  {
    "codigo":301927007,
    "descripcion":"PATRÓN DE COLORACIÓN EPITELIAL CORNEAL IRREGULAR"
  },
  {
    "codigo":269159008,
    "descripcion":"LESIÓN DE ÓRGANO PÉLVICO"
  },
  {
    "codigo":300092000,
    "descripcion":"LESIÓN DE OÍDO EXTERNO"
  },
  {
    "codigo":365628002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA RECONOCER A PERSONAS CONOCIDAS"
  },
  {
    "codigo":234556002,
    "descripcion":"DEFICIENCIA DE ANTICUERPO ESPECÍFICO"
  },
  {
    "codigo":37948003,
    "descripcion":"LARINGOTRAQUEÍTIS AGUDA SIN OBSTRUCCIÓN"
  },
  {
    "codigo":298257001,
    "descripcion":"ARTICULACIÓN HELADA"
  },
  {
    "codigo":3345002,
    "descripcion":"OSTEOPOROSIS IDIOPÁTICA"
  },
  {
    "codigo":396561003,
    "descripcion":"PIGMENTACIÓN TUMORAL, DIFUSA"
  },
  {
    "codigo":789777007,
    "descripcion":"DISPLASIA ESQUELÉTICA DE MIEMBROS CORTOS CON INMUNODEFICIENCIA COMBINADA SEVERA"
  },
  {
    "codigo":134417007,
    "descripcion":"ESTADO DE ÁNIMO NORMAL"
  },
  {
    "codigo":296422005,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE DIFENILPIRALINA"
  },
  {
    "codigo":394726009,
    "descripcion":"QUERATOSIS SEBORREICA"
  },
  {
    "codigo":294587002,
    "descripcion":"ALERGIA A MINOCICLINA"
  },
  {
    "codigo":425659003,
    "descripcion":"NEUROPATÍA VASCULÍTICA"
  },
  {
    "codigo":458427003,
    "descripcion":"BRONQUIO EN PUENTE"
  },
  {
    "codigo":720571006,
    "descripcion":"BRAQUIDACTILIA TIPO A7"
  },
  {
    "codigo":292752003,
    "descripcion":"REACCIÓN ADVERSA A LA PENICILAMINA"
  },
  {
    "codigo":423824003,
    "descripcion":"VIVIENDA ESTRUCTURALMENTE INADECUADA"
  },
  {
    "codigo":1144720009,
    "descripcion":"HIPOPLASIA CONGÉNITA DE FALANGE DE QUINTO DEDO DE PIE"
  },
  {
    "codigo":28773001,
    "descripcion":"TROMBOSIS DE VASOS DEL CORDÓN UMBILICAL"
  },
  {
    "codigo":94309003,
    "descripcion":"NEOPLASIA MALIGNA SECUNDARIA DEL LÓBULO FRONTAL"
  },
  {
    "codigo":258149004,
    "descripcion":"HALLAZGO EN LA DEGLUCIÓN"
  },
  {
    "codigo":16041311000119107,
    "descripcion":"ARTRITIS IDIOPÁTICA JUVENIL DE INICIO SISTÉMICO DE AMBOS TOBILLOS"
  },
  {
    "codigo":127077006,
    "descripcion":"LINFADENOPATÍA AURICULAR POSTERIOR"
  },
  {
    "codigo":290917009,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR MAPROTILINA"
  },
  {
    "codigo":26938002,
    "descripcion":"FRACTURA INTERTROCANTÉREA EXPUESTA"
  },
  {
    "codigo":92474007,
    "descripcion":"NEOPLASIA BENIGNA DEL NERVIO VAGO"
  },
  {
    "codigo":715066008,
    "descripcion":"INTOXICACIÓN CAUSADA POR BENZOTIODIAZINA"
  },
  {
    "codigo":57871005,
    "descripcion":"ÚLCERA PÉPTICA CRÓNICA CON PERFORACIÓN Y OBSTRUCCIÓN"
  },
  {
    "codigo":188943007,
    "descripcion":"NEOPLASIA BENIGNA DE HUESOS DE LA MANO"
  },
  {
    "codigo":254479007,
    "descripcion":"NEOPLASIA BENIGNA DE CORNETE NASAL INFERIOR"
  },
  {
    "codigo":1237519007,
    "descripcion":"METÁSTASIS DE CARCINOMA DE PIEL DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":416484003,
    "descripcion":"DREPANOCITOSIS-ENFERMEDAD DE LA HEMOGLOBINA E CON CRISIS HEMOLÍTICA"
  },
  {
    "codigo":23268009,
    "descripcion":"SIMULACIÓN DE ENFERMEDAD"
  },
  {
    "codigo":11836921000119107,
    "descripcion":"AMPOLLA DE PIERNA DERECHA, CON INFECCIÓN"
  },
  {
    "codigo":840633001,
    "descripcion":"ÚTERO GRÁVIDO DE TAMAÑO CORRESPONDIENTE AL TÉRMINO"
  },
  {
    "codigo":54201005,
    "descripcion":"INFESTACIÓN CAUSADA POR CEPHENEMYIA"
  },
  {
    "codigo":283577008,
    "descripcion":"HERIDA DE PERDIGÓN EN PERINEO"
  },
  {
    "codigo":314510001,
    "descripcion":"ECTROPIÓN PARALÍTICO"
  },
  {
    "codigo":185273009,
    "descripcion":"ATENDIDO EN UN CONSULTORIO HOMEOPÁTICO"
  },
  {
    "codigo":341651000119103,
    "descripcion":"COROIDITIS DE OJO IZQUIERDO"
  },
  {
    "codigo":11892371000119103,
    "descripcion":"RUPTURA DE MANGUITO ROTADOR DE HOMBRO DERECHO"
  },
  {
    "codigo":871566007,
    "descripcion":"REACCIÓN ADVERSA A ANTAGONISTA DE RECEPTOR ADRENÉRGICO"
  },
  {
    "codigo":19598007,
    "descripcion":"EPILEPSIA GENERALIZADA"
  },
  {
    "codigo":1363086009,
    "descripcion":"ASTILLA EN MUSLO"
  },
  {
    "codigo":247139005,
    "descripcion":"DEPÓSITOS PUNTIFORMES DE LA RETINA"
  },
  {
    "codigo":1162808000,
    "descripcion":"ENFERMEDAD FAMILIAR POR DEPÓSITO DE CRISTALES DE PIROFOSFATO DE CALCIO DIHIDRATO"
  },
  {
    "codigo":50531009,
    "descripcion":"FRACTURA EXPUESTA DE MIEMBRO INFERIOR"
  },
  {
    "codigo":704056001,
    "descripcion":"FRACTURA POR ESTRÉS DE CÚBITO"
  },
  {
    "codigo":310840001,
    "descripcion":"SIN CONSENTIMIENTO PARA LA SEGUNDA DOSIS DE VACUNA ANTISARAMPIONOSA, ANTIPAROTIDITIS URLIANA Y ANTIRRUBEÓLICA"
  },
  {
    "codigo":278072004,
    "descripcion":"LOQUIOS ROJOS"
  },
  {
    "codigo":441912008,
    "descripcion":"LESIÓN TRAUMÁTICA DE RODETE GLENOIDEO SUPERIOR DE ARTICULACIÓN DE HOMBRO"
  },
  {
    "codigo":276237000,
    "descripcion":"COMENTARIOS ACERCA DE LA PROPIA LECTURA"
  },
  {
    "codigo":472845002,
    "descripcion":"ESTENOSIS DE VÁLVULA PULMONAR FETAL"
  },
  {
    "codigo":1259277002,
    "descripcion":"ESGUINCE DE LIGAMENTO DE ARTICULACIÓN DE DEDO GORDO DE PIE"
  },
  {
    "codigo":440471000124108,
    "descripcion":"INGESTA INADECUADA DE PROTEÍNA DE SOJA"
  },
  {
    "codigo":734989004,
    "descripcion":"SÍNDROME DE DOLOR REGIONAL COMPLEJO DE MANO"
  },
  {
    "codigo":210701004,
    "descripcion":"LESIÓN POR DESOLLAMIENTO DE RODILLA"
  },
  {
    "codigo":833293007,
    "descripcion":"CÁLCULO RENAL DE CISTINA"
  },
  {
    "codigo":1078931000119107,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE LÓBULO INFERIOR DE PULMÓN DERECHO"
  },
  {
    "codigo":866061009,
    "descripcion":"MIELITIS CAUSADA POR COCCIDIOIDES"
  },
  {
    "codigo":1193741007,
    "descripcion":"ENTERITIS POR SHIGELLA BOYDII"
  },
  {
    "codigo":700386005,
    "descripcion":"DEFECTO OSTEOCONDRAL DE TIBIA DISTAL"
  },
  {
    "codigo":733154005,
    "descripcion":"INFECCIÓN PARASITARIA DE INTESTINO DELGADO CAUSADA POR CYSTOISOSPORA BELLI"
  },
  {
    "codigo":208866008,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE DEDO"
  },
  {
    "codigo":10423003,
    "descripcion":"SIGNO DE BRAUN VON FERNWALD"
  },
  {
    "codigo":15634221000119104,
    "descripcion":"TOMOGRAFÍA COMPUTARIZADA DE PELVIS ANORMAL"
  },
  {
    "codigo":272567005,
    "descripcion":"DECÚBITO LATERAL CON PIERNAS SEMIFLEXIONADAS"
  },
  {
    "codigo":403639006,
    "descripcion":"METAPLASIA SIRINGOESCAMOSA DEBIDA A TRATAMIENTO CITOTÓXICO"
  },
  {
    "codigo":239799007,
    "descripcion":"ARTRITIS CRÓNICA JUVENIL POLIARTICULAR DE INICIO TEMPRANO"
  },
  {
    "codigo":1157303009,
    "descripcion":"REQUIERE SEGUIMIENTO"
  },
  {
    "codigo":762252001,
    "descripcion":"TRONCO ARTERIAL COMÚN CON PREDOMINIO AÓRTICO"
  },
  {
    "codigo":237964009,
    "descripcion":"DEFICIENCIA DE LA GLUCÓGENO SINTETASA"
  },
  {
    "codigo":39521001,
    "descripcion":"INTOXICACIÓN POR GLÓBULOS ROJOS CENTRIFUGADOS"
  },
  {
    "codigo":301665003,
    "descripcion":"NO SE ACUESTA NI SE LEVANTA DE UNA CAMA"
  },
  {
    "codigo":236129005,
    "descripcion":"SANGRADO DE ESTOMA"
  },
  {
    "codigo":1153633006,
    "descripcion":"EMBOLIA DE AMBAS ARTERIAS CEREBRALES POSTERIORES"
  },
  {
    "codigo":170593007,
    "descripcion":"CONTROL DE ANGINA"
  },
  {
    "codigo":299830000,
    "descripcion":"REFLEJO BICIPITAL SÓLO PRESENTE CON REFUERZO"
  },
  {
    "codigo":399969009,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE VASO SANGUÍNEO DE BRAZO"
  },
  {
    "codigo":365366007,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA REALIZAR ACTIVIDADES TELEFÓNICAS"
  },
  {
    "codigo":297995004,
    "descripcion":"PELO RUBIO"
  },
  {
    "codigo":429067004,
    "descripcion":"HALLAZGO RELACIONADO CON LA SENSIBILIDAD DE GANGLIOS LINFÁTICOS"
  },
  {
    "codigo":232459006,
    "descripcion":"AMILOIDOSIS LARÍNGEA"
  },
  {
    "codigo":789515008,
    "descripcion":"PÉRDIDA DE LONGITUD DE ARCADA DENTAL DEBIDA A PÉRDIDA DE DIENTES PRIMARIOS"
  },
  {
    "codigo":427232004,
    "descripcion":"HEMIDISTONÍA"
  },
  {
    "codigo":230624005,
    "descripcion":"LESIÓN DE NERVIO PERIFÉRICO POR CHOQUE ELÉCTRICO"
  },
  {
    "codigo":15745121000119100,
    "descripcion":"INESTABILIDAD DE AMBAS ARTICULACIONES FEMORORROTULIANAS"
  },
  {
    "codigo":718474000,
    "descripcion":"ANTÍGENO DE GIARDIA NO DETECTADO"
  },
  {
    "codigo":196021009,
    "descripcion":"NEUMONITIS AGUDA CAUSADA POR VAPORES QUÍMICOS"
  },
  {
    "codigo":425397009,
    "descripcion":"MANIFESTACIÓN DE LA VOLUNTAD ACTIVA VERIFICADA POR PROFESIONAL DE LA SALUD"
  },
  {
    "codigo":292490005,
    "descripcion":"REACCIÓN ADVERSA A LA XILOMETAZOLINA"
  },
  {
    "codigo":95882006,
    "descripcion":"INFECCIÓN BACTERIANA DEL OÍDO"
  },
  {
    "codigo":784010006,
    "descripcion":"TRASTORNO DEL ESPECTRO DEL SÍNDROME OTOPALATODIGITAL"
  },
  {
    "codigo":423562005,
    "descripcion":"CARECE DE LA SUPERVISIÓN NECESARIA"
  },
  {
    "codigo":1144458007,
    "descripcion":"APLASIA DE DEDO MEÑIQUE"
  },
  {
    "codigo":126815003,
    "descripcion":"NEOPLASIA DE LA PARED LATERAL DE LA OROFARINGE"
  },
  {
    "codigo":94047004,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA CUTÁNEA"
  },
  {
    "codigo":288820001,
    "descripcion":"IMITA GESTOS"
  },
  {
    "codigo":92212001,
    "descripcion":"NEOPLASIA BENIGNA DEL DIVERTÍCULO DE MECKEL"
  },
  {
    "codigo":124980004,
    "descripcion":"ACTIVIDAD DE MITOSIS CELULAR AUMENTADA"
  },
  {
    "codigo":286985001,
    "descripcion":"ENDOMETRITIS, EXCEPTO EN CUELLO DE ÚTERO"
  },
  {
    "codigo":254217002,
    "descripcion":"DERMATOSIS ACANTOLÍTICA HEREDITARIA"
  },
  {
    "codigo":344161000119107,
    "descripcion":"DEGENERACIÓN DE MARGEN PUPILAR DE AMBOS OJOS"
  },
  {
    "codigo":24841007,
    "descripcion":"FALLO CARDIORRESPIRATORIO DURANTE UN PROCEDIMIENTO Y\/O COMO CONSECUENCIA DE ÉL"
  },
  {
    "codigo":1237257008,
    "descripcion":"TRASTORNO FETAL DEBIDO A LESIÓN DE PLACENTA POSTERIOR A AMNIOCENTESIS"
  },
  {
    "codigo":23006000,
    "descripcion":"HIPOPIGMENTACIÓN DE LA PIEL"
  },
  {
    "codigo":876809007,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE REGIÓN ESCAPULAR CON INFECCIÓN"
  },
  {
    "codigo":90377008,
    "descripcion":"SIALECTASIA"
  },
  {
    "codigo":1081441000119108,
    "descripcion":"NEOPLASIA FILODES LIMÍTROFE DE MAMA DERECHA"
  },
  {
    "codigo":186846005,
    "descripcion":"SÍFILIS SINTOMÁTICA INICIAL"
  },
  {
    "codigo":448990005,
    "descripcion":"NEOPLASIA EPITELIAL MALIGNA DE CAVIDAD NASAL"
  },
  {
    "codigo":285150005,
    "descripcion":"ERUCTAR EN PÚBLICO"
  },
  {
    "codigo":86707003,
    "descripcion":"ENFERMEDAD POR EL VIRUS MOKOLA"
  },
  {
    "codigo":39641000119100,
    "descripcion":"QUERATITIS RELACIONADA CON LENTE DE CONTACTO NO RESUELTA"
  },
  {
    "codigo":321241000119101,
    "descripcion":"ESPONDILÓLISIS DE VÉRTEBRAS CERVICALES Y DORSALES"
  },
  {
    "codigo":308441000119101,
    "descripcion":"GRANULOMA POR CUERPO EXTRAÑO DE PARTES BLANDAS DE ANTEBRAZO DERECHO"
  },
  {
    "codigo":10743001000119103,
    "descripcion":"TRASTORNO DE ANSIEDAD EN LA MADRE QUE COMPLICA EL NACIMIENTO"
  },
  {
    "codigo":349401000119100,
    "descripcion":"ESTENOSIS ADQUIRIDA DE CONDUCTO NASOLAGRIMAL DERECHO"
  },
  {
    "codigo":15729881000119105,
    "descripcion":"NÓDULOS DE HEBERDEN DE ARTICULACIONES INTERFALÁNGICAS DISTALES DE MANO DERECHA"
  },
  {
    "codigo":334041000119105,
    "descripcion":"LUXACIÓN ESPONTÁNEA DE OJO DERECHO"
  },
  {
    "codigo":15735001000119106,
    "descripcion":"PSEUDOQUISTE DE RETINA DE OJO IZQUIERDO"
  },
  {
    "codigo":339161000119107,
    "descripcion":"DRUSAS DE PAPILA ÓPTICA IZQUIERDA"
  },
  {
    "codigo":539503321000119109,
    "descripcion":"FIBROMATOSIS AGRESIVA DE REGIÓN INTRABDOMINAL"
  },
  {
    "codigo":12217561000119107,
    "descripcion":"FRACTURA ÓSEA ADYACENTE A PRÓTESIS DE CODO IZQUIERDO"
  },
  {
    "codigo":344281000119105,
    "descripcion":"ATROFIA PRIMARIA DE AMBAS GLÁNDULAS LAGRIMALES"
  },
  {
    "codigo":85721000119105,
    "descripcion":"APNEA DEL SUEÑO CENTRAL DEBIDA A RESPIRACIÓN PERIÓDICA"
  },
  {
    "codigo":1073881000119108,
    "descripcion":"DEFORMIDAD PIE DERECHO CONCOMITANTE CON ARTRITIS REUMATOIDE Y DEBIDA A ELLA"
  },
  {
    "codigo":1197149002,
    "descripcion":"TRASTORNO DEL MOVIMIENTO PSICÓGENO"
  },
  {
    "codigo":351961000119109,
    "descripcion":"MELANOMA MALIGNO DE PIEL DE MIEMBRO SUPERIOR DERECHO"
  },
  {
    "codigo":226521000119108,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE NASOFARINGE"
  },
  {
    "codigo":246877005,
    "descripcion":"DEGENERACIÓN CONJUNTIVAL BULBAR"
  },
  {
    "codigo":16705241000119109,
    "descripcion":"NEUROMA BILATERAL DE EXTREMIDADES INFERIORES POSTERIOR A CIRUGÍA"
  },
  {
    "codigo":707464006,
    "descripcion":"CARCINOMA MIOEPITELIAL PRIMARIO DE PULMÓN"
  },
  {
    "codigo":277810000,
    "descripcion":"SÍNDROME TRICODENTAL"
  },
  {
    "codigo":212274001,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO RADIAL A NIVEL DE LA MUÑECA Y DE LA MANO"
  },
  {
    "codigo":115805001,
    "descripcion":"FENOTIPO EN (A - ) (UK)"
  },
  {
    "codigo":81202007,
    "descripcion":"FUNCIÓN MUSCULAR AUSENTE"
  },
  {
    "codigo":79367009,
    "descripcion":"DIETA PARA DIABETES INFANTIL"
  },
  {
    "codigo":274140005,
    "descripcion":"TENDINITIS SUBESCAPULAR"
  },
  {
    "codigo":346671000119100,
    "descripcion":"QUISTE CONJUNTIVAL DE AMBOS OJOS"
  },
  {
    "codigo":208604006,
    "descripcion":"FRACTURA EXPUESTA DE RÓTULA, POLO DISTAL"
  },
  {
    "codigo":372444009,
    "descripcion":"MARGEN PROXIMAL DE RESECCIÓN QUIRÚRGICA ANAL, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":15937941000119107,
    "descripcion":"MELANOMA IN SITU DE PIEL DE AMBOS OÍDOS"
  },
  {
    "codigo":1083951000119101,
    "descripcion":"INFLAMACIÓN BILATERAL DE ESTRUCTURAS LABERÍNTICAS"
  },
  {
    "codigo":698289004,
    "descripcion":"FUMADOR DE NARGUILE"
  },
  {
    "codigo":75697004,
    "descripcion":"NACIMIENTO DE TÉRMINO DE GEMELOS MONOCIGÓTICOS, AMBOS MUERTOS"
  },
  {
    "codigo":15993391000119102,
    "descripcion":"RETINITIS DE AMBOS OJOS DEBIDA A SÍFILIS SECUNDARIA"
  },
  {
    "codigo":73862001,
    "descripcion":"COMPLICACIÓN RELACIONADA CON CATÉTER"
  },
  {
    "codigo":403377009,
    "descripcion":"HIPERHIDROSIS POR CAUSALGIA"
  },
  {
    "codigo":237702003,
    "descripcion":"HEMORRAGIA HIPOFISARIA"
  },
  {
    "codigo":8326008,
    "descripcion":"OTITIS MEDIA AGUDA MUCOIDE ALÉRGICA"
  },
  {
    "codigo":235867002,
    "descripcion":"HEPATITIS E AGUDA"
  },
  {
    "codigo":301403003,
    "descripcion":"DOLOR A LA PALPACIÓN EN REGIÓN DE EPIGASTRIO"
  },
  {
    "codigo":365104000,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA SALIR DE LA BAÑERA"
  },
  {
    "codigo":299568006,
    "descripcion":"DEFORMIDAD EN FLEXIÓN DE DEDO DEL PIE"
  },
  {
    "codigo":1217072007,
    "descripcion":"ESCLEROSIS SUPRARRENAL"
  },
  {
    "codigo":234032009,
    "descripcion":"TRASTORNO VASOMOTOR ARTERIAL"
  },
  {
    "codigo":721882001,
    "descripcion":"SÍNDROME DE SINOSTOSIS RADIOCUBITAL CON TROMBOCITOPENIA AMEGACARIOCÍTICA"
  },
  {
    "codigo":66522001,
    "descripcion":"OBSTRUCCIÓN DE CONDUCTO SALIVAL"
  },
  {
    "codigo":675451000119106,
    "descripcion":"HEBRAS VÍTREAS DE AMBOS OJOS"
  },
  {
    "codigo":263130004,
    "descripcion":"ESGUINCE DE LIGAMENTO DEL PULGAR"
  },
  {
    "codigo":295898002,
    "descripcion":"SOBREDOSIS DE ISOCARBOXAZIDA"
  },
  {
    "codigo":197594005,
    "descripcion":"SÍNDROME NEFRÓTICO, LESIONES GLOMERULARES FOCALES Y SEGMENTARIAS"
  },
  {
    "codigo":164826007,
    "descripcion":"PRUEBA ESPECIAL EN EL HOMBRE - ANORMAL"
  },
  {
    "codigo":33754009,
    "descripcion":"COXA VALGA CONGÉNITA"
  },
  {
    "codigo":195759002,
    "descripcion":"PÓLIPO DE SENO FRONTAL"
  },
  {
    "codigo":294063005,
    "descripcion":"ALERGIA A OXIMETAZOLINA"
  },
  {
    "codigo":95620003,
    "descripcion":"TROMBOFLEBITIS DEL RECIÉN NACIDO"
  },
  {
    "codigo":161156004,
    "descripcion":"DIFICULTAD CON EL LENGUAJE"
  },
  {
    "codigo":718212006,
    "descripcion":"ENCEFALOMIOCARDIOPATÍA MITOCONDRIAL DEBIDA A MUTACIÓN DE LA PROTEÍNA TRANSMEMBRANARIA 70"
  },
  {
    "codigo":292228009,
    "descripcion":"REACCIÓN ADVERSA AL ÓXIDO MERCÚRICO"
  },
  {
    "codigo":126553002,
    "descripcion":"NEOPLASIA DE LA COLUMNA VERTEBRAL CERVICAL"
  },
  {
    "codigo":290393002,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR TRISILICATO DE MAGNESIO"
  },
  {
    "codigo":28249008,
    "descripcion":"JAMAIS VU"
  },
  {
    "codigo":91950000,
    "descripcion":"ATROFIA DE CRESTA ALVEOLAR DESDENTADA"
  },
  {
    "codigo":124718009,
    "descripcion":"DEFICIENCIA DE PROPIONILO - COA CARBOXILASA"
  },
  {
    "codigo":1236995001,
    "descripcion":"BLEFARITIS ANTERIOR DE PÁRPADO SUPERIOR IZQUIERDO CAUSADO POR ESTAFILOCOCOS"
  },
  {
    "codigo":286723001,
    "descripcion":"TIENDE A EVITAR INTERACCIONES SOCIALES GRUPALES"
  },
  {
    "codigo":253955008,
    "descripcion":"DEFORMIDAD CONGÉNITA DE PIE Y TOBILLO"
  },
  {
    "codigo":448728003,
    "descripcion":"LOCALIZACIÓN SUPRACARDÍACA DE CONEXIÓN ANÓMALA DE VENA PULMONAR"
  },
  {
    "codigo":284888003,
    "descripcion":"CAPAZ DE RASURARSE"
  },
  {
    "codigo":219352005,
    "descripcion":"LESIÓN ACCIDENTAL O DELIBERADA NO DETERMINADA, POR SALTAR O COLOCARSE DELANTE DE UN OBJETO EN MOVIMIENTO"
  },
  {
    "codigo":88280008,
    "descripcion":"CONCRECIÓN GÁSTRICA"
  },
  {
    "codigo":184749005,
    "descripcion":"SOLICITUD DE PASAPORTE - HONORARIOS PAGADOS"
  },
  {
    "codigo":283053007,
    "descripcion":"ABRASIÓN DE LA MEJILLA"
  },
  {
    "codigo":1231490000,
    "descripcion":"DESVIACIÓN DE LÍNEA MEDIA DE ARCO DENTAL MAXILAR HACIA LA IZQUIERDA"
  },
  {
    "codigo":445058002,
    "descripcion":"INFLAMACIÓN DE BRONQUIOS CAUSADA POR ASPERGILLUS"
  },
  {
    "codigo":248450003,
    "descripcion":"FIEBRE POSOPERATORIA"
  },
  {
    "codigo":1264258003,
    "descripcion":"CARCINOMA PAPILAR DE CÉLULAS ESCAMOSAS METASTÁSICO"
  },
  {
    "codigo":836439001,
    "descripcion":"DEPENDENCIA DE NICOTINA EN REMISIÓN"
  },
  {
    "codigo":1196887001,
    "descripcion":"NEOPLASIA PAPILAR INTRAQUÍSTICA CON NEOPLASIA INTRAEPITELIAL DE BAJO GRADO DE VESÍCULA BILIAR"
  },
  {
    "codigo":770903003,
    "descripcion":"SÍNDROME DE ENFERMEDAD POSTORGÁSMICA"
  },
  {
    "codigo":246615006,
    "descripcion":"CIERRE OCULAR EN RESPUESTA A LA LUZ BRILLANTE DIRECTA"
  },
  {
    "codigo":312151007,
    "descripcion":"INFECCIÓN MICÓTICA DEL SISTEMA MUSCULOESQUELÉTICO"
  },
  {
    "codigo":212012000,
    "descripcion":"CORROSIÓN DE TERCER GRADO DE TOBILLO Y PIE"
  },
  {
    "codigo":703532002,
    "descripcion":"MIOPATÍA EN GORRA"
  },
  {
    "codigo":1162284007,
    "descripcion":"RABDOMIOSARCOMA PRIMARIO DE ENDOMETRIO DE CUERPO UTERINO"
  },
  {
    "codigo":472321009,
    "descripcion":"CONTINUIDAD DEL EMBARAZO DESPUÉS DE LA MUERTE INTRAUTERINA DE UN FETO GEMELAR CON RETENCIÓN DEL FETO MUERTO"
  },
  {
    "codigo":699862007,
    "descripcion":"HALLAZGO RELACIONADO CON EL MAXILAR SUPERIOR"
  },
  {
    "codigo":403115000,
    "descripcion":"MICETOMA CAUSADO POR EXOPHIALA JEANSELMEI"
  },
  {
    "codigo":110038009,
    "descripcion":"LACERACIÓN SIMPLE CONTAMINADA DE LA MEJILLA"
  },
  {
    "codigo":208342009,
    "descripcion":"FRACTURA EXPUESTA PALMAR DE BARTON"
  },
  {
    "codigo":1156779003,
    "descripcion":"POLIARTRITIS JUVENIL POSITIVA PARA ANTICUERPOS ANTIPÉPTIDO CÍCLICO CITRULINADO Y NEGATIVA PARA FACTOR REUMATOIDE"
  },
  {
    "codigo":44502009,
    "descripcion":"INFECCIÓN CAUSADA POR BESNOITIA"
  },
  {
    "codigo":9899009,
    "descripcion":"EMBARAZO OVÁRICO"
  },
  {
    "codigo":237440004,
    "descripcion":"MASTITIS SUBAREOLAR"
  },
  {
    "codigo":401280004,
    "descripcion":"ESCALA DE DISNEA DE BORG: 2 - LEVE"
  },
  {
    "codigo":301141002,
    "descripcion":"HALLAZGO RELACIONADO CON LA PRESIÓN ARTERIAL PULMONAR"
  },
  {
    "codigo":366677004,
    "descripcion":"HALLAZGO RELACIONADO CON LA AMPLITUD DE LA EXTENSIÓN DE DEDO DE LA MANO"
  },
  {
    "codigo":235605005,
    "descripcion":"ESOFAGITIS POR RADIACIÓN"
  },
  {
    "codigo":170069006,
    "descripcion":"PERÍMETRO CEFÁLICO INFANTIL = > PERCENTILO 97"
  },
  {
    "codigo":1251413005,
    "descripcion":"CICATRIZ DE PIEL POSTERIOR A CIRUGÍA PLÁSTICA"
  },
  {
    "codigo":725290000,
    "descripcion":"INMUNODEFICIENCIA COMBINADA DEBIDA A DEFICIENCIA PARCIAL DEL GEN 1 DE RECOMBINACIÓN-ACTIVACIÓN"
  },
  {
    "codigo":364842003,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA BAJAR ESCALONES CORRIENDO"
  },
  {
    "codigo":201002003,
    "descripcion":"LIQUEN PLANO ACTIVO SUBAGUDO"
  },
  {
    "codigo":299306006,
    "descripcion":"ARTICULACIÓN DE CADERA ESTABLE"
  },
  {
    "codigo":1149439000,
    "descripcion":"PERIODONTITIS LOCALIZADA ESTADIO 1 GRADO C SEGÚN LA CLASIFICACIÓN DE LAS ENFERMEDADES Y ALTERACIONES PERIODONTALES Y PERIIMPLANTARIAS DE 2017 DE LA ACADEMIA ESTADOUNIDENSE DE PERIODONTOLOGÍA Y LA FEDERACIÓN EUROPEA DE PERIODONTOLOGÍA"
  },
  {
    "codigo":233770009,
    "descripcion":"SARCOIDOSIS PULMONAR, ESTADIO 4"
  },
  {
    "codigo":788991003,
    "descripcion":"ENTEROCOLITIS NECROSANTE DEL RECIÉN NACIDO, ESTADIO 3B DE BELL"
  },
  {
    "codigo":68095009,
    "descripcion":"ESTRIDOR SIBILANTE"
  },
  {
    "codigo":428543009,
    "descripcion":"MALFORMACIÓN VASCULAR CONGÉNITA DE LABIO"
  },
  {
    "codigo":723455009,
    "descripcion":"FACOMATOSIS PIGMENTOQUERATÓSICA"
  },
  {
    "codigo":295636004,
    "descripcion":"SOBREDOSIS DE ESTRAMUSTINA"
  },
  {
    "codigo":1088971000119100,
    "descripcion":"QUERATOSIS OBTURATRIZ DE CONDUCTO AUDITIVO EXTERNO IZQUIERDO"
  },
  {
    "codigo":262868007,
    "descripcion":"PERFORACIÓN TARDÍA DEL CIEGO"
  },
  {
    "codigo":195497001,
    "descripcion":"QUISTE QUILOSO"
  },
  {
    "codigo":721620009,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE TERCIO INFERIOR DE ESÓFAGO"
  },
  {
    "codigo":128126004,
    "descripcion":"LESIÓN TRAUMÁTICA DEL SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":11820491000119103,
    "descripcion":"SUBLUXACIÓN ANTERIOR DE ARTICULACIÓN GLENOHUMERAL IZQUIERDA"
  },
  {
    "codigo":423038006,
    "descripcion":"ADENOCARCINOMA POLIMORFO DE BAJO GRADO DE MALIGNIDAD DE GLÁNDULA SALIVAL"
  },
  {
    "codigo":717950007,
    "descripcion":"AUSENCIA ADQUIRIDA DE ÚTERO"
  },
  {
    "codigo":193662007,
    "descripcion":"APRAXIA OCULOMOTRIZ"
  },
  {
    "codigo":95358009,
    "descripcion":"PARESTESIA DE LA MEMBRANA MUCOSA"
  },
  {
    "codigo":1142099009,
    "descripcion":"SÍFILIS SECUNDARIA DE MEMBRANA SINOVIAL"
  },
  {
    "codigo":879955009,
    "descripcion":"INFARTO DE MIOCARDIO SIN LESIONES CORONARIAS OBSTRUCTIVAS"
  },
  {
    "codigo":26152001,
    "descripcion":"INFECCIÓN CAUSADA POR ICHTHYOPHTHIRIUS"
  },
  {
    "codigo":124456009,
    "descripcion":"DEFICIENCIA DE ENDO - 1, 3 (4) - BETA - GLUCANASA"
  },
  {
    "codigo":253693001,
    "descripcion":"ANOMALÍAS CONGÉNITAS DE LAS RAMAS AÓRTICAS TORÁCICAS"
  },
  {
    "codigo":450301003,
    "descripcion":"ORIGEN ANÓMALO DE ARTERIA CORONARIA IZQUIERDA ANTERIOR EN ARTERIA PULMONAR"
  },
  {
    "codigo":286461004,
    "descripcion":"LAVA LOS ALIMENTOS"
  },
  {
    "codigo":188157005,
    "descripcion":"NEOPLASIA MALIGNA DE LOCALIZACIONES SUPERPUESTAS DE MAMA"
  },
  {
    "codigo":251858002,
    "descripcion":"BALANCE HÍDRICO NEGATIVO"
  },
  {
    "codigo":22482002,
    "descripcion":"BRONQUIOLITIS OBLITERANTE SUBAGUDA"
  },
  {
    "codigo":284626004,
    "descripcion":"DAR UN PUÑETAZO A OTRA PERSONA"
  },
  {
    "codigo":1169362009,
    "descripcion":"SÍNDROME DE SOBRECRECIMIENTO CON TRANSLOCACIÓN 2Q37"
  },
  {
    "codigo":12367461000119104,
    "descripcion":"ARTROSIS DE AMBAS ARTICULACIONES ROTULOFEMORALES"
  },
  {
    "codigo":315559005,
    "descripcion":"NACIDO EN VIETNAM"
  },
  {
    "codigo":250023006,
    "descripcion":"MARCHA VACILANTE"
  },
  {
    "codigo":817968741000119105,
    "descripcion":"SITUS INVERSUS DE PAPILA ÓPTICA"
  },
  {
    "codigo":1231228001,
    "descripcion":"QUERATITIS NEUROTRÓFICA POSTERIOR A QUERATITIS DENDRÍTICA POR VIRUS HERPES SIMPLE"
  },
  {
    "codigo":117116007,
    "descripcion":"SOPLO CARDÍACO, BAJO"
  },
  {
    "codigo":248188007,
    "descripcion":"CARA DE ASPECTO AFLIGIDO"
  },
  {
    "codigo":705105000,
    "descripcion":"AMPLIFICACIÓN DE GEN DE FACTOR DE CRECIMIENTO EPIDÉRMICO HUMANO 2 NO DETECTADA"
  },
  {
    "codigo":51580009,
    "descripcion":"INTOXICACIÓN POR LAUREL DE MONTAÑA"
  },
  {
    "codigo":211750001,
    "descripcion":"CORROSIÓN DE PRIMER GRADO DE LA CABEZA Y EL CUELLO"
  },
  {
    "codigo":703270004,
    "descripcion":"HEMANGIOMA INFANTIL DE LOCALIZACIÓN INUSUAL"
  },
  {
    "codigo":408358005,
    "descripcion":"SIN INTERACCIONES MEDICAMENTOSAS SIGNIFICATIVAS"
  },
  {
    "codigo":277286006,
    "descripcion":"DOLOR DE ORIGEN CENTRAL CRÓNICO POSTERIOR A ACCIDENTE CEREBROVASCULAR"
  },
  {
    "codigo":111611005,
    "descripcion":"HEMORRAGIA INTRACRANEAL CONCOMITANTE CON FRACTURA CERRADA DE CRÁNEO Y DEBIDA A ELLA"
  },
  {
    "codigo":240848001,
    "descripcion":"FILARIASIS DE CAVIDADES SEROSAS"
  },
  {
    "codigo":765136002,
    "descripcion":"LINFOMA CUTÁNEO PRIMARIO DE LINFOCITOS T CITOTÓXICOS EPIDERMOTRÓFICO AGRESIVO, CD8 POSITIVO"
  },
  {
    "codigo":109776005,
    "descripcion":"ESTOMATITIS MEDICAMENTOSA"
  },
  {
    "codigo":206245001,
    "descripcion":"RUPTURA HEPÁTICA DEBIDA A TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":402853002,
    "descripcion":"PÚRPURA CRIOFIBRINOGENÉMICA"
  },
  {
    "codigo":239013001,
    "descripcion":"ANONIQUIA CON PIGMENTACIÓN FLEXURAL BIZARRA"
  },
  {
    "codigo":1254821007,
    "descripcion":"INESTABILIDAD DE PRÓTESIS DE ARTICULACIÓN DE CADERA"
  },
  {
    "codigo":1156517008,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE ANTIBACTERIANO QUINOLÓNICO"
  },
  {
    "codigo":1091481000119102,
    "descripcion":"OBSTRUCCIÓN EXTRÍNSECA DE TROMPA DE EUSTAQUIO DERECHA"
  },
  {
    "codigo":106106004,
    "descripcion":"HALLAZGO EN EL APARATO REPRODUCTOR MASCULINO"
  },
  {
    "codigo":16027391000119109,
    "descripcion":"QUISTE ÓSEO DE AMBAS TIBIAS"
  },
  {
    "codigo":354201000119104,
    "descripcion":"NEOPLASIA BENIGNA DE CONJUNTIVA DERECHA"
  },
  {
    "codigo":300879004,
    "descripcion":"TUMEFACCIÓN DE GLÁNDULA SALIVAL"
  },
  {
    "codigo":399183005,
    "descripcion":"IMPÉTIGO BULLOSO"
  },
  {
    "codigo":5967006,
    "descripcion":"PERSISTENCIA HEREDITARIA DE HEMOGLOBINA FETAL A>GAMMA< BETA^+^ Y TALASEMIA BETA^0^ EN CIS"
  },
  {
    "codigo":202575007,
    "descripcion":"OSTEOCONDROMATOSIS SINOVIAL DE HOMBRO"
  },
  {
    "codigo":15673241000119105,
    "descripcion":"NÓDULO REUMATOIDEO DE TEJIDO CELULAR SUBCUTÁNEO DE AMBAS RODILLAS"
  },
  {
    "codigo":366415008,
    "descripcion":"AMPLITUD DE MOVIMIENTO PASIVO DE FLEXIÓN LATERAL HACIA LA DERECHA DE LA COLUMNA DORSAL - HALLAZGO"
  },
  {
    "codigo":167972004,
    "descripcion":"LÍQUIDO PLEURAL: SE OBSERVAN PIOCITOS"
  },
  {
    "codigo":299044007,
    "descripcion":"HALLAZGO RELACIONADO CON LA FUNCIÓN DE LA MANO"
  },
  {
    "codigo":428281000,
    "descripcion":"NEOPLASIA MALIGNA DE HUESO"
  },
  {
    "codigo":725028009,
    "descripcion":"TRASTORNO CONGÉNITO DE LA GLICOSILACIÓN POR ALTERACIÓN DE MANOSIL OLIGOSACÁRIDO GLUCOSIDASA"
  },
  {
    "codigo":69668008,
    "descripcion":"PALUDISMO INDUCIDO EN FORMA TERAPÉUTICA"
  },
  {
    "codigo":297209005,
    "descripcion":"RUIDO INTESTINAL TIMPÁNICO"
  },
  {
    "codigo":35065006,
    "descripcion":"PSEUDOBSTRUCCIÓN CRÓNICA PRIMARIA DEL COLON"
  },
  {
    "codigo":786894002,
    "descripcion":"NEOPLASIA FIBROMATOSA BENIGNA DE PIEL"
  },
  {
    "codigo":721358003,
    "descripcion":"LUXACIÓN TRAUMÁTICA DE QUINTA Y SEXTA VÉRTEBRAS CERVICALES"
  },
  {
    "codigo":295374002,
    "descripcion":"SOBREDOSIS INTENCIONAL DE OMEPRAZOL"
  },
  {
    "codigo":262606006,
    "descripcion":"CUERPO EXTRAÑO EN ESÓFAGO CERVICAL"
  },
  {
    "codigo":293539000,
    "descripcion":"REACCIÓN ADVERSA AL DIPIRIDAMOL"
  },
  {
    "codigo":1145507004,
    "descripcion":"HIPOPLASIA CONGÉNITA DE FALANGE DE PULGAR"
  },
  {
    "codigo":129699007,
    "descripcion":"CON MAYOR RIESGO DE TRASTORNO DEL VÍNCULO ENTRE PADRE Y LACTANTE O NIÑO"
  },
  {
    "codigo":195235008,
    "descripcion":"OCLUSIÓN Y ESTENOSIS DE ARTERIAS CEREBELOSAS"
  },
  {
    "codigo":1209208002,
    "descripcion":"PALIDEZ FACIAL"
  },
  {
    "codigo":95096004,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE PARTES BLANDAS DE LA REGIÓN INGUINAL"
  },
  {
    "codigo":193400007,
    "descripcion":"DISTROFIAS RETINIANAS HEREDITARIAS EN LAS LIPIDOSIS"
  },
  {
    "codigo":160632008,
    "descripcion":"DISFRUTA EL EJERCICIO FÍSICO MODERADO"
  },
  {
    "codigo":224333003,
    "descripcion":"ESPOSO ARRESTADO"
  },
  {
    "codigo":11851981000119101,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DE DEDO GORDO DEL PIE DERECHO"
  },
  {
    "codigo":93261006,
    "descripcion":"HIPOPLASIA CONGÉNITA DE GÓNADA"
  },
  {
    "codigo":191565008,
    "descripcion":"ESQUIZOFRENIA LATENTE EN REMISIÓN"
  },
  {
    "codigo":289869008,
    "descripcion":"PERINEO LIMPIO"
  },
  {
    "codigo":1141837008,
    "descripcion":"INFILTRADO EOSINOFÍLICO DE VEJIGA"
  },
  {
    "codigo":27725008,
    "descripcion":"INTOXICACIÓN POR ERYTHROPHLEUM"
  },
  {
    "codigo":124194004,
    "descripcion":"DEFICIENCIA DE NITRATO REDUCTASA"
  },
  {
    "codigo":56823000,
    "descripcion":"REMANENTE TIROIDEO CERVICAL"
  },
  {
    "codigo":286199001,
    "descripcion":"CAPAZ DE ABRIR LA CASA CUANDO ESTÁ CERRADA"
  },
  {
    "codigo":1269239005,
    "descripcion":"TROMBOSIS DE ARTERIA CEREBRAL ANTERIOR IZQUIERDA"
  },
  {
    "codigo":253431009,
    "descripcion":"HIPOPLASIA DE VÁLVULA AURICULOVENTRICULAR COMÚN"
  },
  {
    "codigo":22220005,
    "descripcion":"INCONTINENCIA DE ESFUERZO"
  },
  {
    "codigo":137421000119106,
    "descripcion":"ENFERMEDAD DE GRAVES EN REMISIÓN"
  },
  {
    "codigo":87756006,
    "descripcion":"ÚLCERA DUODENAL AGUDA CON HEMORRAGIA Y OBSTRUCCIÓN"
  },
  {
    "codigo":53153002,
    "descripcion":"EFECTO TÓXICO DE LA PARAFINA"
  },
  {
    "codigo":249761003,
    "descripcion":"DEDO DE LA MANO GRANDE"
  },
  {
    "codigo":20385005,
    "descripcion":"TRASTORNO PSICÓTICO CON DELIRIO INDUCIDO POR OPIOIDE"
  },
  {
    "codigo":315297006,
    "descripcion":"PTOSIS DISGENÉTICA CONGÉNITA"
  },
  {
    "codigo":1003425007,
    "descripcion":"GLAUCOMA POR SÍNDROME DE LOWE"
  },
  {
    "codigo":234035006,
    "descripcion":"SÍNDROME DE MARFAN QUE AFECTA LA PIEL"
  },
  {
    "codigo":16003431000119102,
    "descripcion":"TRASTORNO DE LIGAMENTOS DE ARTICULACIONES DE AMBAS REGIONES DE HOMBROS"
  },
  {
    "codigo":51318005,
    "descripcion":"SECRECIÓN GÁSTRICA ANORMAL"
  },
  {
    "codigo":247926005,
    "descripcion":"TOQUE REPETITIVO DE OBJETOS"
  },
  {
    "codigo":213323001,
    "descripcion":"RASH SÉRICO"
  },
  {
    "codigo":49483002,
    "descripcion":"TRASTORNO DEL MEDIASTINO"
  },
  {
    "codigo":10678631000119104,
    "descripcion":"TUMEFACCIÓN LOCALIZADA DE LA PIERNA DERECHA"
  },
  {
    "codigo":703008003,
    "descripcion":"PREVOTELLA ORIS O PREVOTELLA BUCCAE"
  },
  {
    "codigo":47648003,
    "descripcion":"FRACTURAS MÚLTIPLES EXPUESTAS DE LA EXTREMIDAD SUPERIOR Y EL ESTERNÓN"
  },
  {
    "codigo":735776005,
    "descripcion":"LACERACIÓN DE ABDOMEN CON CUERPO EXTRAÑO"
  },
  {
    "codigo":80416006,
    "descripcion":"DISOCIACIÓN DEL MOVIMIENTO DE LA PARED TORÁCICA"
  },
  {
    "codigo":1260064006,
    "descripcion":"CISTADENOCARCINOMA MUCINOSO DE TRÁQUEA"
  },
  {
    "codigo":209653000,
    "descripcion":"DESGARRO COMPLETO DE LIGAMENTO CONDROESTERNAL"
  },
  {
    "codigo":766709000,
    "descripcion":"HIPOPLASIA AISLADA DEL VERMIS CEREBELOSO"
  },
  {
    "codigo":733941004,
    "descripcion":"CARIES DENTAL ACTIVA PRIMARIA QUE SE EXTIENDE HASTA EL TERCIO EXTERNO DE LA DENTINA"
  },
  {
    "codigo":13045009,
    "descripcion":"ANISOCORIA"
  },
  {
    "codigo":109514001,
    "descripcion":"ASIMETRÍA MAXILAR CONGÉNITA"
  },
  {
    "codigo":240586001,
    "descripcion":"ÚLCERA EXTRAGENITAL CHANCROIDE"
  },
  {
    "codigo":1354698007,
    "descripcion":"ATURDIMIENTO POSTURAL"
  },
  {
    "codigo":9375000,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DEL CUELLO, CON INFECCIÓN"
  },
  {
    "codigo":304287001,
    "descripcion":"SENSACIÓN DE TENSIÓN EN SUTURAS"
  },
  {
    "codigo":238751002,
    "descripcion":"DERMATITIS PERIBUCAL"
  },
  {
    "codigo":1156255004,
    "descripcion":"COMPOSICIÓN DE INGESTA NUTRICIONAL DE CARBOHIDRATOS INCOMPATIBLE CON EL REQUERIMIENTO"
  },
  {
    "codigo":74911008,
    "descripcion":"DISQUERATOSIS CONGÉNITA"
  },
  {
    "codigo":40308000,
    "descripcion":"OSTEOPENIA INDUCIDA POR ESTEROIDES"
  },
  {
    "codigo":269684007,
    "descripcion":"LESIÓN POR MAQUINARIA EN AERONAVE"
  },
  {
    "codigo":204148008,
    "descripcion":"OPACIDAD CORNEAL CONGÉNITA CON DEFICIENCIA VISUAL"
  },
  {
    "codigo":235081004,
    "descripcion":"MACROGNATIA"
  },
  {
    "codigo":169545005,
    "descripcion":"FALLA DE DISPOSITIVO INTRAUTERINO POSCOITAL"
  },
  {
    "codigo":202313006,
    "descripcion":"ANQUILOSIS DE LA ARTICULACIÓN METACARPOFALÁNGICA"
  },
  {
    "codigo":298782000,
    "descripcion":"AMPLITUD DE FLEXIÓN PASIVA DE HOMBRO AUMENTADA"
  },
  {
    "codigo":366153009,
    "descripcion":"REFLEJO PALMOMENTONIANO - HALLAZGO"
  },
  {
    "codigo":167710008,
    "descripcion":"ASPECTO DEL LCR (LÍQUIDO CEFALORRAQUÍDEO) TURBIO"
  },
  {
    "codigo":722931001,
    "descripcion":"COMPRESIÓN CEREBRAL NEONATAL"
  },
  {
    "codigo":724766009,
    "descripcion":"COREA CONCOMITANTE CON ENFERMEDAD DE WILSON Y DEBIDA A ELLA"
  },
  {
    "codigo":788467004,
    "descripcion":"TRASTORNO REPETITIVO DEL MOVIMIENTO DE AMBOS HOMBROS"
  },
  {
    "codigo":428019004,
    "descripcion":"FRACTURA EXPUESTA DE HUESO DE ARTICULACIÓN DE LA RODILLA"
  },
  {
    "codigo":10871451000119105,
    "descripcion":"CISTADENOMA MUCINOSO DE OVARIO DERECHO"
  },
  {
    "codigo":1343688001,
    "descripcion":"ALTERACIÓN CRÓNICA DE ASTA POSTERIOR DE MENISCO INTERNO DE RODILLA DERECHA"
  },
  {
    "codigo":295112002,
    "descripcion":"ALERGIA A BROMELINAS"
  },
  {
    "codigo":1148915008,
    "descripcion":"GLOMERULOPATÍA DEBIDA A ENFERMEDAD DE MEMBRANA BASAL DELGADA"
  },
  {
    "codigo":721096008,
    "descripcion":"QUERATODERMIA PALMOPLANTAR DIFUSA Y ACROCIANOSIS"
  },
  {
    "codigo":1145245004,
    "descripcion":"CARCINOMA DE GLÁNDULA DE MEIBOMIO"
  },
  {
    "codigo":293277005,
    "descripcion":"REACCIÓN ADVERSA A LA GONADORELINA"
  },
  {
    "codigo":291442000,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR PIRIMETAMINA"
  },
  {
    "codigo":193138001,
    "descripcion":"LESIÓN DE RAMA SENSITIVA DEL NERVIO RADIAL"
  },
  {
    "codigo":63901009,
    "descripcion":"DOLOR TESTICULAR"
  },
  {
    "codigo":16907061000119102,
    "descripcion":"NEVO MELANOCÍTICO DE PÁRPADO INFERIOR DERECHO"
  },
  {
    "codigo":225906004,
    "descripcion":"INCAPAZ DE PREVENIR LA CONDUCTA INDESEABLE"
  },
  {
    "codigo":1208946005,
    "descripcion":"TRASTORNO NEONATAL TEMPRANO DEBIDO A HEMORRAGIA PLACENTARIA"
  },
  {
    "codigo":29298007,
    "descripcion":"CONTUSIÓN DE LA PLANTA DEL PIE"
  },
  {
    "codigo":1340018008,
    "descripcion":"TROMBOSIS CON SÍNDROME DE TROMBOCITOPENIA POSTERIOR A VACUNACIÓN CON VACUNA CON VECTOR DE ADENOVIRUS NO REPLICANTE CONTRA COVID-19"
  },
  {
    "codigo":781127000,
    "descripcion":"PUNCIÓN ACCIDENTAL DE ÓRGANO DURANTE PROCEDIMIENTO"
  },
  {
    "codigo":94834008,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE TROMPA DE FALOPIO"
  },
  {
    "codigo":92999004,
    "descripcion":"ANOMALÍA CONGÉNITA DE UNA VÉRTEBRA CERVICAL"
  },
  {
    "codigo":289607005,
    "descripcion":"APÓSITO MATERNO MOJADO CON LÍQUIDO AMNIÓTICO"
  },
  {
    "codigo":255004001,
    "descripcion":"MELANOMA MALIGNO DE CONJUNTIVA"
  },
  {
    "codigo":386076002,
    "descripcion":"TRASTORNO RELACIONADO CON LA VITAMINA K2"
  },
  {
    "codigo":1010503009,
    "descripcion":"AUSENCIA CONGÉNITA DE UNIDAD UNGUEAL EN PULGAR"
  },
  {
    "codigo":91164004,
    "descripcion":"INTOXICACIÓN POR BIFENILO POLIBROMADO"
  },
  {
    "codigo":449777000,
    "descripcion":"OSTEOPETROSIS INFANTIL TRANSITORIA"
  },
  {
    "codigo":123932008,
    "descripcion":"INTOXICACIÓN POR OXALIDACEAE"
  },
  {
    "codigo":15979471000119101,
    "descripcion":"HIPOPLASIA CONGÉNITA DE HUESO CIGOMÁTICO IZQUIERDO"
  },
  {
    "codigo":417009006,
    "descripcion":"PUNTO DOLOROSO A LA PALPACIÓN"
  },
  {
    "codigo":253169007,
    "descripcion":"MEGALENCEFALIA ESPORÁDICA"
  },
  {
    "codigo":332751000119102,
    "descripcion":"RECESIÓN DEL ÁNGULO DE CÁMARA DEL OJO DERECHO"
  },
  {
    "codigo":447942001,
    "descripcion":"CIERRE ESPONTÁNEO DE DEFECTO DE TABIQUE INTERVENTRICULAR DEBIDO A TEJIDO DE TABIQUE MEMBRANOSO"
  },
  {
    "codigo":285937008,
    "descripcion":"VACÍA EL LAVABO"
  },
  {
    "codigo":187633009,
    "descripcion":"NEOPLASIA MALIGNA DE LA CARA DORSAL DE LA LENGUA"
  },
  {
    "codigo":56561006,
    "descripcion":"AMENORREA PATOLÓGICA"
  },
  {
    "codigo":415174001,
    "descripcion":"MELANOSIS ADQUIRIDA PRIMARIA DE LA CONJUNTIVA CON ATIPÍA"
  },
  {
    "codigo":251334006,
    "descripcion":"NO SUSCEPTIBLE A LA CARIES"
  },
  {
    "codigo":218566006,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR FITOMENADIONA"
  },
  {
    "codigo":185798009,
    "descripcion":"CONTROL DEL CESE DEL TABAQUISMO ANULADO"
  },
  {
    "codigo":710086009,
    "descripcion":"ALTURA DE HUESO MANDIBULAR EDÉNTULO TIPO III"
  },
  {
    "codigo":10900431000119106,
    "descripcion":"LACERACIÓN DEL GLOBO OCULAR DERECHO"
  },
  {
    "codigo":1359941000,
    "descripcion":"HALLAZGO RELACIONADO CON DISPOSICIÓN DE BACTERIAS"
  },
  {
    "codigo":83824009,
    "descripcion":"AGNOSIA TOPOGRÁFICA"
  },
  {
    "codigo":247664009,
    "descripcion":"PERDERSE"
  },
  {
    "codigo":442437005,
    "descripcion":"FALLA EN LA OSTEOINTEGRACIÓN DE IMPLANTE DENTAL"
  },
  {
    "codigo":737349008,
    "descripcion":"DIFICULTAD CON EL MANEJO DE LA PROPIA VIDA"
  },
  {
    "codigo":735514001,
    "descripcion":"INFECCIÓN DE INTESTINO CAUSADA POR VIBRIO"
  },
  {
    "codigo":278597008,
    "descripcion":"PUENTE DENTAL CON SUPERFICIE RUGOSA"
  },
  {
    "codigo":1259802002,
    "descripcion":"NEOPLASIA PRIMARIA DE ESTROMA GASTROINTESTINAL DE LOCALIZACIONES SUPERPUESTAS DE ESTÓMAGO"
  },
  {
    "codigo":309530007,
    "descripcion":"MASA HILIAR"
  },
  {
    "codigo":307695004,
    "descripcion":"MOVIMIENTOS MONOCULARES EN EL COMA"
  },
  {
    "codigo":405999008,
    "descripcion":"ANOMALÍA FETAL EN EL ESPÉCIMEN, PRESENTE"
  },
  {
    "codigo":109252001,
    "descripcion":"PRURITO ESTIVAL BRAQUIORRADIAL"
  },
  {
    "codigo":209391008,
    "descripcion":"FRACTURA-LUXACIÓN ANTERIOR NO EXPUESTA DE ARTICULACIÓN ESTERNOCLAVICULAR"
  },
  {
    "codigo":404164003,
    "descripcion":"XANTOGRANULOMA NECROBIÓTICO"
  },
  {
    "codigo":305860000,
    "descripcion":"ATENDIDO POR SERVICIO DE FISIOTERAPIA EXTRAHOSPITALARIO"
  },
  {
    "codigo":10948005,
    "descripcion":"ESPONDILOSIS DORSAL CON MIELOPATÍA"
  },
  {
    "codigo":402329001,
    "descripcion":"PSORIASIS DE APARICIÓN TEMPRANA DE TIPO 1"
  },
  {
    "codigo":1287065003,
    "descripcion":"HEMORRAGIA INTRAVENTRICULAR NO TRAUMÁTICA GRADO 3 DURANTE PERÍODO INTRAPARTO FETAL"
  },
  {
    "codigo":10955881000119108,
    "descripcion":"HERIDA PUNZANTE DE DEDO ÍNDICE DE MANO DERECHA"
  },
  {
    "codigo":40046003,
    "descripcion":"FÍSTULA ENTEROVESICAL"
  },
  {
    "codigo":236654009,
    "descripcion":"DISINERGIA DE CUELLO VESICAL"
  },
  {
    "codigo":365891002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA RECORDAR SU CUMPLEAÑOS"
  },
  {
    "codigo":1119555003,
    "descripcion":"TABIQUE NASAL ESTRECHO"
  },
  {
    "codigo":300355005,
    "descripcion":"VESÍCULA BILIAR NORMAL"
  },
  {
    "codigo":726339008,
    "descripcion":"TRISOMÍA PARCIAL DE BRAZO CORTO DE CROMOSOMA 1"
  },
  {
    "codigo":36376006,
    "descripcion":"AUSENCIA CONGÉNITA DEL ESÓFAGO"
  },
  {
    "codigo":298520008,
    "descripcion":"AMPLITUD DE EXTENSIÓN ACTIVA DE LA COLUMNA VERTEBRAL DORSAL, AUMENTADA"
  },
  {
    "codigo":1148653001,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR HORMONA PARATIROIDEA Y\/O DERIVADO DE HORMONA PARATIROIDEA"
  },
  {
    "codigo":196546001,
    "descripcion":"QUISTE DE PARTES BLANDAS DE LA BOCA"
  },
  {
    "codigo":131010002,
    "descripcion":"CORTICOTROFINA ANORMAL"
  },
  {
    "codigo":722669009,
    "descripcion":"LESIÓN LINFOEPITELIAL BENIGNA DE GLÁNDULA LAGRIMAL"
  },
  {
    "codigo":335261000119103,
    "descripcion":"EPÍFORA DE OJO DERECHO DEBIDA A TRASTORNO DEL DRENAJE LAGRIMAL"
  },
  {
    "codigo":293015000,
    "descripcion":"REACCIÓN ADVERSA A LA CEFSULODINA"
  },
  {
    "codigo":424087001,
    "descripcion":"ECTOPIA CONGÉNITA DEL ORIFICIO LAGRIMAL"
  },
  {
    "codigo":1144983004,
    "descripcion":"ULCERACIÓN DE REGIÓN ANOGENITAL DEBIDA A ENFERMEDAD DE BEHCET"
  },
  {
    "codigo":29036000,
    "descripcion":"PULSO TRIGEMINADO"
  },
  {
    "codigo":260247008,
    "descripcion":"VISIÓN CERCANA - HALLAZGO"
  },
  {
    "codigo":192876003,
    "descripcion":"DEGENERACIÓN CEREBELOSA POR MIXEDEMA"
  },
  {
    "codigo":61804006,
    "descripcion":"ALVEOLITIS DE MANDÍBULA"
  },
  {
    "codigo":225644006,
    "descripcion":"ANSIEDAD ACERCA DE LA IMAGEN CORPORAL ALTERADA"
  },
  {
    "codigo":94572009,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA PIEL DE LA REGIÓN TEMPORAL"
  },
  {
    "codigo":289345003,
    "descripcion":"FETO, AUSENTE"
  },
  {
    "codigo":27201004,
    "descripcion":"ACROSTEÓLISIS"
  },
  {
    "codigo":308791000119101,
    "descripcion":"GOTA DE CODO DEBIDA A DISFUNCIÓN RENAL"
  },
  {
    "codigo":92737007,
    "descripcion":"CARCINOMA IN SITU DE LA PIEL DE LA NARIZ"
  },
  {
    "codigo":16037431000119102,
    "descripcion":"DETENCIÓN DE CRECIMIENTO EPIFISARIO DE AMBOS ANTEBRAZOS"
  },
  {
    "codigo":416747001,
    "descripcion":"DISFUNCIÓN DE COSTILLA EN POSICIÓN DE EXHALACIÓN"
  },
  {
    "codigo":285675005,
    "descripcion":"CARGA PESO"
  },
  {
    "codigo":1268715005,
    "descripcion":"HISTIOCITOMA FIBROSO MALIGNO PRIMARIO"
  },
  {
    "codigo":283840005,
    "descripcion":"HERIDA POR MORDEDURA DE SERPIENTE"
  },
  {
    "codigo":87232008,
    "descripcion":"HIPERTIROIDISMO SECUNDARIO A NÓDULO TIROIDEO ECTÓPICO"
  },
  {
    "codigo":707989006,
    "descripcion":"GINGIVOESTOMATITIS POR CONTACTO"
  },
  {
    "codigo":247402000,
    "descripcion":"BAJA TOLERANCIA AL DOLOR"
  },
  {
    "codigo":216469009,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR OPIO"
  },
  {
    "codigo":1197674003,
    "descripcion":"ALTERACIÓN PIGMENTARIA DE MUCOSA ORAL"
  },
  {
    "codigo":442175000,
    "descripcion":"MATIDEZ CARDÍACA A LA PERCUSIÓN AUMENTADA"
  },
  {
    "codigo":1163071001,
    "descripcion":"ENCEFALITIS POR VIRUS DE LA FIEBRE DEL VALLE DEL RIFT"
  },
  {
    "codigo":276500007,
    "descripcion":"ÉMBOLO MESENTÉRICO"
  },
  {
    "codigo":405737000,
    "descripcion":"FARINGITIS"
  },
  {
    "codigo":1259540009,
    "descripcion":"EXTRAVASACIÓN DE LÍQUIDO CEFALORRAQUÍDEO CRANEAL DEBIDA A SÍNDROME DE LA SILLA TURCA VACÍA"
  },
  {
    "codigo":372969000,
    "descripcion":"INFECCIÓN CAUSADA POR PENICILLIUM SUBERI"
  },
  {
    "codigo":438505003,
    "descripcion":"DISTENSIÓN DE MÚSCULO TRAPECIO"
  },
  {
    "codigo":241897004,
    "descripcion":"PRODUCTO PARA JARDINERÍA QUE CAUSA EFECTOS TÓXICOS"
  },
  {
    "codigo":471273006,
    "descripcion":"RECANALIZACIÓN ESPONTÁNEA DE VENA SISTÉMICA"
  },
  {
    "codigo":209129007,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN ESTERNOCLAVICULAR, POSTERIOR"
  },
  {
    "codigo":733417008,
    "descripcion":"SÍNDROME DE DISMORFISMO FACIAL, MACROCEFALIA, MIOPÍA Y MALFORMACIÓN DE DANDY-WALKER"
  },
  {
    "codigo":10823531000119102,
    "descripcion":"FRACTURA EXPUESTA EN MARTILLO DE FALANGE DISTAL DE DEDO MEDIO DE MANO IZQUIERDA"
  },
  {
    "codigo":274665008,
    "descripcion":"DOLOR CRÓNICO INTRATABLE"
  },
  {
    "codigo":897257007,
    "descripcion":"CURVATURA ANORMAL DE FALANGE PROXIMAL DE QUINTO DEDO DE PIE"
  },
  {
    "codigo":371134001,
    "descripcion":"LINFOMA MALIGNO DE CÉLULAS GRANDES, POLIMORFO, INMUNOBLÁSTICO"
  },
  {
    "codigo":305598006,
    "descripcion":"BAJO ATENCIÓN DE TÉCNICO EN AUDIOLOGÍA"
  },
  {
    "codigo":240062007,
    "descripcion":"DISTROFIA MUSCULAR HIPOTÓNICA-ESCLERÓTICA CONGÉNITA"
  },
  {
    "codigo":762515000,
    "descripcion":"TRASTORNO DE ANSIEDAD CAUSADO POR CATINONA SINTÉTICA"
  },
  {
    "codigo":8851000,
    "descripcion":"PELVIS DE NAGELE"
  },
  {
    "codigo":403902008,
    "descripcion":"CARCINOMA DE CÉLULAS ADENOESCAMOSAS"
  },
  {
    "codigo":860819006,
    "descripcion":"PÓLIPO FIBROEPITELIAL DE PÁRPADO"
  },
  {
    "codigo":47641000087103,
    "descripcion":"FRACTURA DE DIÁFISIS DE PERONÉ IZQUIERDO"
  },
  {
    "codigo":74387008,
    "descripcion":"TUBERCULOSIS DE LOS GANGLIOS LINFÁTICOS HILIARES"
  },
  {
    "codigo":39961000087102,
    "descripcion":"HERIDA PUNZANTE DE DEDO PULGAR IZQUIERDO CON CUERPO EXTRAÑO"
  },
  {
    "codigo":301928002,
    "descripcion":"PATRÓN DE COLORACIÓN EPITELIAL CORNEAL CENTRAL"
  },
  {
    "codigo":269160003,
    "descripcion":"LESIÓN CERRADA DE VEJIGA URINARIA"
  },
  {
    "codigo":236392004,
    "descripcion":"GLOMERULONEFRITIS RÁPIDAMENTE PROGRESIVA"
  },
  {
    "codigo":42521000087109,
    "descripcion":"HEMATOMA DE DORSO DE TRONCO"
  },
  {
    "codigo":72552008,
    "descripcion":"PROBLEMA DE ALIMENTACIÓN EN EL RECIÉN NACIDO"
  },
  {
    "codigo":201789001,
    "descripcion":"NÓDULO REUMATOIDE"
  },
  {
    "codigo":39784009,
    "descripcion":"HEMOSIDEROSIS SECUNDARIA"
  },
  {
    "codigo":365629005,
    "descripcion":"GRANULARIDAD LEUCOCÍTICA - HALLAZGO"
  },
  {
    "codigo":234557006,
    "descripcion":"DEFICIENCIA DE ANTICUERPOS ANTIPOLISACÁRIDOS"
  },
  {
    "codigo":5181007,
    "descripcion":"TRASTORNO DEL METABOLISMO DEL TRIPTÓFANO"
  },
  {
    "codigo":300093005,
    "descripcion":"PABELLÓN AURICULAR DE TAMAÑO NORMAL"
  },
  {
    "codigo":134418002,
    "descripcion":"NIVEL DE INTERÉS - NORMAL"
  },
  {
    "codigo":396562005,
    "descripcion":"PIGMENTACIÓN TUMORAL, EN PARCHES\/FOCAL"
  },
  {
    "codigo":298258006,
    "descripcion":"ARTICULACIÓN FRÍA"
  },
  {
    "codigo":36114005,
    "descripcion":"SÍNDROME DE DISOCIACIÓN FENOTIPO - CARIOTIPO SEXUAL"
  },
  {
    "codigo":394727000,
    "descripcion":"MELANOACANTOMA"
  },
  {
    "codigo":296423000,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE DIFENILPIRALINA"
  },
  {
    "codigo":15958021000119103,
    "descripcion":"SARCOMA PRIMARIO DE RIÑÓN IZQUIERDO"
  },
  {
    "codigo":720572004,
    "descripcion":"BRAQUIDACTILIA CON SINDACTILIA TIPO ZHAO"
  },
  {
    "codigo":294588007,
    "descripcion":"ALERGIA A OXITETRACICLINA"
  },
  {
    "codigo":1144721008,
    "descripcion":"HIPOPLASIA CONGÉNITA DE FALANGE DE DEDO DE PIE"
  },
  {
    "codigo":127078001,
    "descripcion":"LINFADENOPATÍA AURICULAR ANTERIOR"
  },
  {
    "codigo":94310008,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE SENO FRONTAL"
  },
  {
    "codigo":715067004,
    "descripcion":"LEISHMANIASIS CUTÁNEA ULCEROSA DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":59707005,
    "descripcion":"ABSCESO DE LA FARINGE"
  },
  {
    "codigo":289083006,
    "descripcion":"NO AMAMANTA"
  },
  {
    "codigo":92475008,
    "descripcion":"NEOPLASIA BENIGNA DE LA VALÉCULA"
  },
  {
    "codigo":188944001,
    "descripcion":"NEOPLASIA BENIGNA DE ESCAFOIDES"
  },
  {
    "codigo":1237520001,
    "descripcion":"METÁSTASIS DE CARCINOMA DE PIEL DE TRONCO"
  },
  {
    "codigo":254480005,
    "descripcion":"NEOPLASIA DE CORNETE NASAL MEDIO"
  },
  {
    "codigo":15741241000119100,
    "descripcion":"GANGLIÓN BILATERAL DE CARAS PALMARES DE MUÑECAS"
  },
  {
    "codigo":713232009,
    "descripcion":"SEGUNDA ETAPA DEL TRABAJO DE PARTO PROLONGADA DEBIDA A ESCASO ESFUERZO MATERNO"
  },
  {
    "codigo":416485002,
    "descripcion":"QUERATOCONJUNTIVITIS SECA POR ENFERMEDAD DE INJERTO VERSUS HUÉSPED"
  },
  {
    "codigo":340281000119101,
    "descripcion":"IRIDOSQUISIS IZQUIERDA"
  },
  {
    "codigo":23269001,
    "descripcion":"DREPANOCITOSIS HETEROCIGÓTICA DOBLE"
  },
  {
    "codigo":449253005,
    "descripcion":"NEOPLASIA EPITELIAL MALIGNA DE HIPOTÁLAMO"
  },
  {
    "codigo":88805009,
    "descripcion":"INSUFICIENCIA CARDÍACA CONGESTIVA CRÓNICA"
  },
  {
    "codigo":185274003,
    "descripcion":"ATENDIDO EN CONSULTORIO ESPECIALIZADO EN RADIOTERAPIA"
  },
  {
    "codigo":283578003,
    "descripcion":"HERIDA DE PERDIGÓN EN GENITALES"
  },
  {
    "codigo":840634007,
    "descripcion":"REFLEJO PUPILAR CONSENSUAL AUSENTE"
  },
  {
    "codigo":1363087000,
    "descripcion":"ASTILLA EN MUSLO CON INFECCIÓN"
  },
  {
    "codigo":447418009,
    "descripcion":"LACERACIÓN DE ARTERIA DIGITAL DE MANO"
  },
  {
    "codigo":871567003,
    "descripcion":"REACCIÓN ADVERSA A ÁCIDO BENZOICO, ÁCIDO MÁLICO Y\/O ÉSTER DE ÁCIDO SALICÍLICO"
  },
  {
    "codigo":216207006,
    "descripcion":"LESIÓN POR MAQUINARIA EN AERONAVE, SIN ACCIDENTE DE AERONAVE, PARACAIDISTA LESIONADO"
  },
  {
    "codigo":52367009,
    "descripcion":"MANCHADO DENTAL POSERUPTIVO MEDICAMENTOSO"
  },
  {
    "codigo":50532002,
    "descripcion":"NOESIS"
  },
  {
    "codigo":247140007,
    "descripcion":"DEPÓSITOS VITELIFORMES DE LA RETINA"
  },
  {
    "codigo":310841002,
    "descripcion":"EXTENDIDO CERVICAL - INFLAMACIÓN LEVE"
  },
  {
    "codigo":441913003,
    "descripcion":"AFONÍA"
  },
  {
    "codigo":704057005,
    "descripcion":"FRACTURA POR ESTRÉS DE FALANGE DE DEDO DEL PIE"
  },
  {
    "codigo":1077561000119108,
    "descripcion":"OSTEOMIELITIS CRÓNICA DE FÉMUR IZQUIERDO"
  },
  {
    "codigo":1193742000,
    "descripcion":"INFLAMACIÓN INTESTINAL POR SHIGELLA BOYDII"
  },
  {
    "codigo":736825009,
    "descripcion":"LESIÓN INFLAMATORIA, DE COLOR ROJO, DE PARTE INTERNA DE LA BOCA CAUSADA POR FÁRMACO"
  },
  {
    "codigo":472846001,
    "descripcion":"INSUFICIENCIA DE VÁLVULA AÓRTICA FETAL"
  },
  {
    "codigo":278073009,
    "descripcion":"TRAZADO CARDIOTOCOGRÁFICO INSATISFACTORIO"
  },
  {
    "codigo":14094001,
    "descripcion":"HIPEREMESIS GRAVÍDICA"
  },
  {
    "codigo":866062002,
    "descripcion":"MIELITIS CAUSADA POR COENURUS CEREBRALIS"
  },
  {
    "codigo":210702006,
    "descripcion":"LESIÓN POR DESOLLAMIENTO DE PIERNA"
  },
  {
    "codigo":1259278007,
    "descripcion":"ESGUINCE DE LIGAMENTO DE ARTICULACIÓN DE SEGUNDO A QUINTO DEDOS DE PIE"
  },
  {
    "codigo":734990008,
    "descripcion":"HIPEROXALURIA PRIMARIA TIPO III"
  },
  {
    "codigo":307171000,
    "descripcion":"FRACTURA-LUXACIÓN DE ARTICULACIÓN CARPOMETACARPIANA"
  },
  {
    "codigo":276238005,
    "descripcion":"COMENTARIOS ACERCA DE LA PROPIA ESCRITURA"
  },
  {
    "codigo":15632851000119104,
    "descripcion":"ATROFIA ÓPTICA DEL OJO IZQUIERDO"
  },
  {
    "codigo":733155006,
    "descripcion":"ENTERITIS ALÉRGICA MEDIADA POR INMUNOGLOBULINA E"
  },
  {
    "codigo":272568000,
    "descripcion":"POSICIÓN DE PUENTE"
  },
  {
    "codigo":313811000119105,
    "descripcion":"ATROFIA DE MÚSCULO DE PIERNA IZQUIERDA"
  },
  {
    "codigo":10963411000119105,
    "descripcion":"LACERACIÓN DE DEDO MEÑIQUE IZQUIERDO"
  },
  {
    "codigo":239800006,
    "descripcion":"ARTRITIS CRÓNICA JUVENIL POLIARTICULAR DE INICIO TARDÍO"
  },
  {
    "codigo":403640008,
    "descripcion":"HIDRADENITIS ECRINA NEUTROFÍLICA DEBIDA A TRATAMIENTO CITOTÓXICO"
  },
  {
    "codigo":430961000124105,
    "descripcion":"QUEILITIS DEBIDA A LUPUS ERITEMATOSO"
  },
  {
    "codigo":237965005,
    "descripcion":"DEFECTO DEL TRANSPORTE DE FOSFATO"
  },
  {
    "codigo":762253006,
    "descripcion":"TRONCO ARTERIAL COMÚN CON PREDOMINIO PULMONAR CONCOMITANTE CON CAYADO AÓRTICO INTERRUMPIDO"
  },
  {
    "codigo":236130000,
    "descripcion":"GRANULOMA DE ESTOMA"
  },
  {
    "codigo":1153634000,
    "descripcion":"EMBOLIA DE AMBAS ARTERIAS CEREBRALES ANTERIORES"
  },
  {
    "codigo":301666002,
    "descripcion":"DIFICULTAD PARA ACOSTARSE Y LEVANTARSE DE UNA CAMA"
  },
  {
    "codigo":170594001,
    "descripcion":"CONTROL DE ANGINA - BUENO"
  },
  {
    "codigo":399970005,
    "descripcion":"XANTOMA DISEMINADO"
  },
  {
    "codigo":37687000,
    "descripcion":"AUSENCIA CONGÉNITA DEL CUELLO UTERINO"
  },
  {
    "codigo":299831001,
    "descripcion":"REFLEJO BICIPITAL DISMINUIDO"
  },
  {
    "codigo":430903001,
    "descripcion":"AVULSIÓN DE UÑA DE DEDO DEL PIE"
  },
  {
    "codigo":365367003,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA USAR EL TELÉFONO"
  },
  {
    "codigo":448648001,
    "descripcion":"PULMONES BILATERALMENTE TRILOBULADOS DEBIDO A ISOMERISMO DEL PULMÓN DERECHO"
  },
  {
    "codigo":232460001,
    "descripcion":"GRANULOMATOSIS CON POLIANGEÍTIS DE LARINGE"
  },
  {
    "codigo":35852003,
    "descripcion":"GANGLIÓN DE APONEUROSIS"
  },
  {
    "codigo":297996003,
    "descripcion":"PELO CASTAÑO"
  },
  {
    "codigo":230625006,
    "descripcion":"LESIÓN DE NERVIO PERIFÉRICO POR FRÍO"
  },
  {
    "codigo":296161006,
    "descripcion":"SOBREDOSIS DE LOXAPINA"
  },
  {
    "codigo":15989511000119102,
    "descripcion":"FLICTÉNULAS DE AMBOS OJOS"
  },
  {
    "codigo":95883001,
    "descripcion":"MENINGITIS BACTERIANA"
  },
  {
    "codigo":1144459004,
    "descripcion":"APLASIA DE DEDO DE MANO"
  },
  {
    "codigo":63115005,
    "descripcion":"HIPOTIROIDISMO DEBIDO A ESCLERODERMIA"
  },
  {
    "codigo":290656000,
    "descripcion":"INTOXICACIÓN POR MITOXANTRONA"
  },
  {
    "codigo":292491009,
    "descripcion":"REACCIÓN ADVERSA A AGONISTA DE RECEPTOR BETA-ADRENÉRGICO"
  },
  {
    "codigo":126816002,
    "descripcion":"NEOPLASIA DE LA PARED POSTERIOR DE LA OROFARINGE"
  },
  {
    "codigo":342791000119106,
    "descripcion":"DERMATITIS ALÉRGICA POR CONTACTO DE PÁRPADO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":124981000,
    "descripcion":"ACTIVIDAD MITÓTICA CELULAR DISMINUIDA"
  },
  {
    "codigo":26677001,
    "descripcion":"ALTERACIÓN DEL PATRÓN DEL SUEÑO"
  },
  {
    "codigo":288821002,
    "descripcion":"NO IMITA GESTOS"
  },
  {
    "codigo":94048009,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL INTESTINO DELGADO"
  },
  {
    "codigo":419893006,
    "descripcion":"QUISTE EPIDERMOIDE"
  },
  {
    "codigo":92213006,
    "descripcion":"NEOPLASIA BENIGNA DE GANGLIOS LINFÁTICOS MEDIASTÍNICOS"
  },
  {
    "codigo":876810002,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE LA ESPALDA CON INFECCIÓN"
  },
  {
    "codigo":1237258003,
    "descripcion":"TRASTORNO FETAL DEBIDO A DEFICIENCIA DE FUNCIÓN PLACENTARIA"
  },
  {
    "codigo":254218007,
    "descripcion":"QUERATOSIS FOLICULAR HEREDITARIA"
  },
  {
    "codigo":186847001,
    "descripcion":"SÍFILIS GENITAL PRIMARIA"
  },
  {
    "codigo":16782241000119104,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE PIEL DE MANO IZQUIERDA"
  },
  {
    "codigo":285151009,
    "descripcion":"ROBO A RESIDENTES BECARIOS"
  },
  {
    "codigo":185012002,
    "descripcion":"INFORME DE PENSIONES DE GUERRA ENVIADO"
  },
  {
    "codigo":248713000,
    "descripcion":"AORTA ABDOMINAL - HALLAZGO"
  },
  {
    "codigo":19337000,
    "descripcion":"BORRAMIENTO CERVICAL COMPLETO"
  },
  {
    "codigo":1297289002,
    "descripcion":"DETENCIÓN TOTAL DE CRECIMIENTO EPIFISARIO DE TIBIA DISTAL"
  },
  {
    "codigo":283316009,
    "descripcion":"ASTILLA DE MADERA EN EL DEDO GORDO DEL PIE"
  },
  {
    "codigo":84873005,
    "descripcion":"MALFORMACIÓN ARTERIOVENOSA DURAL"
  },
  {
    "codigo":838537007,
    "descripcion":"ESTENOSIS SEVERA DE VÁLVULA TRICÚSPIDE"
  },
  {
    "codigo":246878000,
    "descripcion":"LESIÓN FOCAL DE CONJUNTIVA BULBAR"
  },
  {
    "codigo":707465007,
    "descripcion":"CARCINOMA MUCOEPIDERMOIDE PRIMARIO DE PULMÓN"
  },
  {
    "codigo":1197150002,
    "descripcion":"ENFERMEDAD HEPÁTICA POR RECURRENCIA DEL VIRUS DE LA HEPATITIS C POSTERIOR A TRASPLANTE DE HÍGADO"
  },
  {
    "codigo":50270004,
    "descripcion":"MIOCARDIOPATÍA DILATADA DEBIDA A ATAXIA DE FRIEDREICH"
  },
  {
    "codigo":16290721000119109,
    "descripcion":"VÍCTIMA DE TRATA DE PERSONAS EN ADOLESCENCIA"
  },
  {
    "codigo":11785121000119109,
    "descripcion":"AMPOLLA TRAUMÁTICA DE DEDO DE MANO DERECHA"
  },
  {
    "codigo":212275000,
    "descripcion":"CONTUSIÓN, NERVIO MUSCULOCUTÁNEO"
  },
  {
    "codigo":310579000,
    "descripcion":"PRUEBA DE SANGRE PARA CRIBADO DE SÍNDROME DE DOWN: NORMAL"
  },
  {
    "codigo":703795004,
    "descripcion":"ANGIOEDEMA DEBIDO A TRASTORNO DEL METABOLISMO DE LA QUININA"
  },
  {
    "codigo":16624051000119100,
    "descripcion":"HEMATOMA INTRAMURAL DE AORTA TORÁCICA"
  },
  {
    "codigo":16091571000119102,
    "descripcion":"PLIEGUE DE EPICANTO DE OJO DERECHO"
  },
  {
    "codigo":1079731000119102,
    "descripcion":"DERMATOFIBROMA DE MIEMBRO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":759556531000119104,
    "descripcion":"SOFOCO CAUSADO POR TAMOXIFENO"
  },
  {
    "codigo":314291000119104,
    "descripcion":"MIOSITIS OSIFICANTE TRAUMÁTICA DE PIERNA DERECHA"
  },
  {
    "codigo":337331000119106,
    "descripcion":"ENTROPIÓN SENIL DE PÁRPADO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":16662451000119106,
    "descripcion":"DISECCIÓN DE ARTERIA RADIAL DERECHA"
  },
  {
    "codigo":306611000119102,
    "descripcion":"GOTA DE TOBILLO Y\/O PIE CAUSADA POR FÁRMACO"
  },
  {
    "codigo":690611000119105,
    "descripcion":"DISFUNCIÓN ORGÁNICA AGUDA DEBIDA A SÍNDROME DE RESPUESTA INFLAMATORIA SISTÉMICA"
  },
  {
    "codigo":50611000119105,
    "descripcion":"VÉRTIGO NO LABERÍNTICO"
  },
  {
    "codigo":1089971000119108,
    "descripcion":"QUISTE DE ESTRUCTURA DE PARTE INTERNA DE LA CAVIDAD ORAL"
  },
  {
    "codigo":343121331000119105,
    "descripcion":"POLIURIA NOCTURNA"
  },
  {
    "codigo":1259016008,
    "descripcion":"RUPTURA DE ÚTERO POR TRABAJO DE PARTO OBSTRUIDO"
  },
  {
    "codigo":368051000119109,
    "descripcion":"HIPERGLUCEMIA DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":15648691000119108,
    "descripcion":"ATEROSCLEROSIS DE ARTERIA DE MIEMBRO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":342451000119108,
    "descripcion":"FILARIASIS LINFÁTICA DE PÁRPADO IZQUIERDO"
  },
  {
    "codigo":12266931000119108,
    "descripcion":"INFECCIÓN DE DISPOSITIVO DE FIJACIÓN INTERNA VERTEBRAL"
  },
  {
    "codigo":470749006,
    "descripcion":"ANOMALÍA ADQUIRIDA DE VENA CAVA INFERIOR"
  },
  {
    "codigo":372445005,
    "descripcion":"MARGEN DISTAL DE RESECCIÓN QUIRÚRGICA ANAL, SIN COMPROMISO TUMORAL"
  },
  {
    "codigo":208605007,
    "descripcion":"FRACTURA EXPUESTA DE RÓTULA, VERTICAL"
  },
  {
    "codigo":274141009,
    "descripcion":"CONTRACTURA DE TENDÓN"
  },
  {
    "codigo":42930003,
    "descripcion":"ERROR CONGÉNITO DEL METABOLISMO DE LOS AMINOÁCIDOS"
  },
  {
    "codigo":403378004,
    "descripcion":"HIPERHIDROSIS COMPENSATORIA"
  },
  {
    "codigo":698290008,
    "descripcion":"DEFICIENCIA DE CREATINA LIGADA AL CROMOSOMA X"
  },
  {
    "codigo":73863006,
    "descripcion":"FALLA DE INJERTO DEBIDA A NECROSIS TUBULAR AGUDA"
  },
  {
    "codigo":237703008,
    "descripcion":"FIBROSIS HIPOFISARIA"
  },
  {
    "codigo":39260000,
    "descripcion":"TAQUICARDIA DEL NÓDULO AURICULOVENTRICULAR NO PAROXÍSTICA"
  },
  {
    "codigo":1153372002,
    "descripcion":"INFLAMACIÓN DE DISCO INTERVERTEBRAL CAUSADA POR HONGOS"
  },
  {
    "codigo":301404009,
    "descripcion":"DOLOR A LA PALPACIÓN EN REGIÓN DE HIPOCONDRIO DERECHO"
  },
  {
    "codigo":1217073002,
    "descripcion":"EDEMA DE GLÁNDULA SUPRARRENAL"
  },
  {
    "codigo":299569003,
    "descripcion":"DEFORMIDAD EN VALGO DE DEDO DEL PIE"
  },
  {
    "codigo":234033004,
    "descripcion":"SÍNDROME DE VIBRACIÓN"
  },
  {
    "codigo":365105004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA SENTARSE Y LEVANTARSE DEL INODORO"
  },
  {
    "codigo":42035005,
    "descripcion":"BISEXUAL"
  },
  {
    "codigo":430641005,
    "descripcion":"PLACER NOTABLEMENTE DISMINUIDO"
  },
  {
    "codigo":102961009,
    "descripcion":"POTENCIAL EVOCADO NORMAL"
  },
  {
    "codigo":166662009,
    "descripcion":"ENZIMAS CARDÍACAS DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":295899005,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE ISOCARBOXAZIDA"
  },
  {
    "codigo":721883006,
    "descripcion":"SÍNDROME DE SINOSTOSIS RADIOCUBITAL CON RETRASO DEL DESARROLLO E HIPOTONÍA"
  },
  {
    "codigo":987007,
    "descripcion":"CELULITIS DE LA REGIÓN TEMPORAL"
  },
  {
    "codigo":230363006,
    "descripcion":"DEGENERACIÓN NEURONAL PROGRESIVA DE NIÑEZ"
  },
  {
    "codigo":197595006,
    "descripcion":"SÍNDROME NEFRÓTICO, GLOMERULONEFRITIS MEMBRANOSA DIFUSA"
  },
  {
    "codigo":294064004,
    "descripcion":"ALERGIA A XAMOTEROL"
  },
  {
    "codigo":31920006,
    "descripcion":"NEUMONÍA HEMORRÁGICA POR VARICELA"
  },
  {
    "codigo":15693321000119100,
    "descripcion":"QUERATITIS GONOCÓCICA IZQUIERDA"
  },
  {
    "codigo":718213001,
    "descripcion":"POLINEUROPATÍA ASOCIADA CON ANTICUERPOS INMUNOGLOBULINA M MONOCLONALES CONTRA GLICOPROTEÍNA ASOCIADA A LA MIELINA"
  },
  {
    "codigo":292229001,
    "descripcion":"REACCIÓN ADVERSA AL METOTREXATO"
  },
  {
    "codigo":95621004,
    "descripcion":"HEMORRAGIA DEL TRACTO RESPIRATORIO DEL RECIÉN NACIDO"
  },
  {
    "codigo":30085007,
    "descripcion":"METATARSALGIA DE MORTON"
  },
  {
    "codigo":62853008,
    "descripcion":"NEFRITIS TUBULOINTERSTICIAL MEDIADA POR ANTICUERPOS ANTI - MEMBRANA BASAL GLOMERULAR"
  },
  {
    "codigo":93786001,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE HUESO ETMOIDES"
  },
  {
    "codigo":61018003,
    "descripcion":"FÍSTULA DE LA PIEL"
  },
  {
    "codigo":292361000119103,
    "descripcion":"NEURITIS ILIOINGUINAL DERECHA"
  },
  {
    "codigo":126554008,
    "descripcion":"NEOPLASIA DE LA COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":91951001,
    "descripcion":"ATROFIA DE LA GLÁNDULA LAGRIMAL"
  },
  {
    "codigo":716378008,
    "descripcion":"INMUNODEFICIENCIA COMBINADA DEBIDA A DEFICIENCIA DE PROTEÍNA CINASA 70 ASOCIADA A LA CADENA ZETA"
  },
  {
    "codigo":290394008,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR TRISILICATO DE MAGNESIO"
  },
  {
    "codigo":190255006,
    "descripcion":"TIROTOXICOSIS DEBIDA A NÓDULO TIROIDEO ECTÓPICO SIN CRISIS TIROIDEA"
  },
  {
    "codigo":1236996000,
    "descripcion":"BLEFARITIS ANTERIOR DE PÁRPADO SUPERIOR DERECHO CAUSADA POR ESTAFILOCOCOS"
  },
  {
    "codigo":90116003,
    "descripcion":"CONTRACTURA DE ARTICULACIÓN DE REGIÓN DE HOMBRO"
  },
  {
    "codigo":57348003,
    "descripcion":"OBSTRUCCIÓN DE LA VENA PORTA"
  },
  {
    "codigo":286724007,
    "descripcion":"TIENDE A EVITAR UNA A UNA LAS INTERACCIONES SOCIALES"
  },
  {
    "codigo":219353000,
    "descripcion":"LESIÓN ACCIDENTAL O DELIBERADA NO DETERMINADA, POR SALTAR DELANTE DE UN OBJETO EN MOVIMIENTO"
  },
  {
    "codigo":448729006,
    "descripcion":"VÁLVULA AURICULOVENTRICULAR COMÚN EN CORAZÓN FUNCIONALMENTE UNIVENTRICULAR"
  },
  {
    "codigo":88281007,
    "descripcion":"ATROFIA DEL PÁNCREAS"
  },
  {
    "codigo":22745007,
    "descripcion":"DIETA RESTRINGIDA EN PURINAS"
  },
  {
    "codigo":284889006,
    "descripcion":"INCAPAZ DE RASURARSE"
  },
  {
    "codigo":250286009,
    "descripcion":"LINFOCITOS PLASMOCITOIDES"
  },
  {
    "codigo":1231491001,
    "descripcion":"DESVIACIÓN DE LÍNEA MEDIA DE ARCO DENTAL MAXILAR HACIA LA DERECHA"
  },
  {
    "codigo":445059005,
    "descripcion":"MENINGITIS CAUSADA POR BACTERIAS ANAERÓBICAS"
  },
  {
    "codigo":313987006,
    "descripcion":"SEGUIMIENTO DE RETINOPATÍA"
  },
  {
    "codigo":838275008,
    "descripcion":"ESTENOSIS DE ARTERIA CEREBRAL"
  },
  {
    "codigo":50008003,
    "descripcion":"PERFORACIÓN TRAUMÁTICA DEL INTESTINO GRUESO"
  },
  {
    "codigo":1196888006,
    "descripcion":"NEOPLASIA GLANDULAR INTRAEPITELIAL DE INTESTINO GRUESO DE ALTO GRADO"
  },
  {
    "codigo":246616007,
    "descripcion":"GIRO DE LA CABEZA HACIA LA FUENTE LUMÍNICA"
  },
  {
    "codigo":80941006,
    "descripcion":"SARCOIDOSIS SUBCUTÁNEA"
  },
  {
    "codigo":703533007,
    "descripcion":"SÍNDROME DE MALFORMACIÓN ARTERIOVENOSA CAPILAR"
  },
  {
    "codigo":15405008,
    "descripcion":"EYACULACIÓN TARDÍA"
  },
  {
    "codigo":1085091000119108,
    "descripcion":"COMA HEPÁTICO DEBIDO A INSUFICIENCIA HEPÁTICA CRÓNICA"
  },
  {
    "codigo":472322002,
    "descripcion":"TRASTORNO DE MIOCARDIO FETAL"
  },
  {
    "codigo":13570003,
    "descripcion":"TENOSINOVITIS TUBERCULOSA"
  },
  {
    "codigo":277549009,
    "descripcion":"SÍNDROME CRÓNICO DE LEUCEMIA PROLINFOCÍTICA LINFOCÍTICA"
  },
  {
    "codigo":765399000,
    "descripcion":"EXCITACIÓN SEXUAL POR EXPOSICIÓN DE GENITALES A PERSONAS PREPÚBERES Y POSPÚBERES SIN CONSENTIMIENTO"
  },
  {
    "codigo":110039001,
    "descripcion":"LACERACIÓN COMPLEJA DE LA MEJILLA"
  },
  {
    "codigo":208343004,
    "descripcion":"FRACTURA EXPUESTA DORSAL DE BARTON"
  },
  {
    "codigo":1156780000,
    "descripcion":"PERINEUROMA RETICULAR DE NERVIO PERIFÉRICO"
  },
  {
    "codigo":403116004,
    "descripcion":"MICETOMA CAUSADO POR FUSARIUM"
  },
  {
    "codigo":1255084006,
    "descripcion":"ADENOCARCINOMA DE SENO ESFENOIDAL"
  },
  {
    "codigo":237441000,
    "descripcion":"MASTITIS NEONATAL"
  },
  {
    "codigo":401281000,
    "descripcion":"ESCALA DE DISNEA DE BORG: 3 - MODERADA"
  },
  {
    "codigo":321341000119107,
    "descripcion":"ESPONDILOSIS DE COLUMNA VERTEBRAL DORSOLUMBAR"
  },
  {
    "codigo":38998004,
    "descripcion":"BRAQUIFALANGIA"
  },
  {
    "codigo":1251414004,
    "descripcion":"DERMATITIS ATÓPICA DE PLIEGUES DEL ADULTO"
  },
  {
    "codigo":235606006,
    "descripcion":"ESOFAGITIS POR SONDA NASOGÁSTRICA"
  },
  {
    "codigo":725291001,
    "descripcion":"DEFECTO DEL RECEPTOR PURINÉRGICO P2Y ACOPLADO A LA PROTEÍNA G 12"
  },
  {
    "codigo":299307002,
    "descripcion":"ARTICULACIÓN DE LA CADERA DOLOROSA A LA PALPACIÓN"
  },
  {
    "codigo":301142009,
    "descripcion":"PARED ARTERIAL DELGADA"
  },
  {
    "codigo":366678009,
    "descripcion":"AMPLITUD DE MOVIMIENTO ACTIVO DE EXTENSIÓN DE DEDO DE LA MANO - HALLAZGO"
  },
  {
    "codigo":364843008,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA SUBIR ESCALERAS CORRIENDO"
  },
  {
    "codigo":233771008,
    "descripcion":"SARCOIDOSIS ENDOBRONQUIAL"
  },
  {
    "codigo":363008002,
    "descripcion":"REACCIÓN CITOTÓXICA MEDIADA POR CÉLULAS"
  },
  {
    "codigo":428544003,
    "descripcion":"ABSCESO DE BULBO RAQUÍDEO"
  },
  {
    "codigo":1149440003,
    "descripcion":"PERIODONTITIS LOCALIZADA ESTADIO 2 GRADO A SEGÚN LA CLASIFICACIÓN DE LAS ENFERMEDADES Y ALTERACIONES PERIODONTALES Y PERIIMPLANTARIAS DE 2017 DE LA ACADEMIA ESTADOUNIDENSE DE PERIODONTOLOGÍA Y LA FEDERACIÓN EUROPEA DE PERIODONTOLOGÍA"
  },
  {
    "codigo":461312005,
    "descripcion":"COMUNICACIÓN INTERAURICULAR ADQUIRIDA"
  },
  {
    "codigo":2560006,
    "descripcion":"SINDACTILIA DE DEDOS DE LA MANO CON FUSIÓN ÓSEA"
  },
  {
    "codigo":69931008,
    "descripcion":"ENFERMEDAD POR EL VIRUS GERMISTAN"
  },
  {
    "codigo":262869004,
    "descripcion":"LACERACIÓN DE CIEGO"
  },
  {
    "codigo":295637008,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE ESTRAMUSTINA"
  },
  {
    "codigo":721621008,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE LOCALIZACIONES SUPERPUESTAS DE ESÓFAGO"
  },
  {
    "codigo":293802005,
    "descripcion":"ALERGIA A MAZINDOL"
  },
  {
    "codigo":195498006,
    "descripcion":"FÍSTULA DE GANGLIO LINFÁTICO"
  },
  {
    "codigo":719786007,
    "descripcion":"VIRUS HERPES SIMPLE TIPOS I O II NO DETECTADO CON REACCIÓN EN CADENA DE POLIMERASA"
  },
  {
    "codigo":31658008,
    "descripcion":"ESQUIZOFRENIA PARANOIDE CRÓNICA"
  },
  {
    "codigo":95359001,
    "descripcion":"ENTUMECIMIENTO DE MEMBRANA MUCOSA"
  },
  {
    "codigo":457642007,
    "descripcion":"OBSTRUCCIÓN DE VÁLVULA PULMONAR DEBIDA A NEOPLASIA"
  },
  {
    "codigo":62591002,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN LA REGIÓN DE LA PARED ABDOMINAL, SIN INFECCIÓN"
  },
  {
    "codigo":160895006,
    "descripcion":"DEJÓ DE TRABAJAR"
  },
  {
    "codigo":128127008,
    "descripcion":"TRASTORNO DEL SISTEMA VISUAL"
  },
  {
    "codigo":1142100001,
    "descripcion":"DISFUNCIÓN NEUROLÓGICA DEBIDA A FÍSTULA OBSTÉTRICA"
  },
  {
    "codigo":421204004,
    "descripcion":"INFECCIÓN POR BLASTOCYSTIS HOMINIS"
  },
  {
    "codigo":879956005,
    "descripcion":"LEIOMIOMA CUTÁNEO SOLITARIO"
  },
  {
    "codigo":678001000119108,
    "descripcion":"CUERPO HIALINO DE RETINA DE OJO IZQUIERDO"
  },
  {
    "codigo":58921009,
    "descripcion":"DERMATITIS DIFUSA"
  },
  {
    "codigo":10999921000119109,
    "descripcion":"PRÓTESIS MAMARIA DERECHA IN SITU"
  },
  {
    "codigo":450302005,
    "descripcion":"ORIGEN ANÓMALO DE ARTERIA CORONARIA DESCENDENTE ANTERIOR IZQUIERDA EN ARTERIA PULMONAR"
  },
  {
    "codigo":286462006,
    "descripcion":"NO LAVA LOS ALIMENTOS"
  },
  {
    "codigo":1169363004,
    "descripcion":"SÍNDROME DE SOBRECRECIMIENTO, DEFECTO DE MODELADO METAFISARIO Y DISPLASIA ESPONDILAR"
  },
  {
    "codigo":251859005,
    "descripcion":"HALLAZGO DE DIÁLISIS"
  },
  {
    "codigo":250024000,
    "descripcion":"MARCHA NEUROPÁTICA PERIFÉRICA"
  },
  {
    "codigo":315560000,
    "descripcion":"NACIDO EN GALES"
  },
  {
    "codigo":284627008,
    "descripcion":"DARLE UNA CACHETADA A OTRA PERSONA"
  },
  {
    "codigo":282792003,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO SIMPÁTICO"
  },
  {
    "codigo":118952005,
    "descripcion":"HALLAZGO ARTICULAR"
  },
  {
    "codigo":446632008,
    "descripcion":"DOS VÁLVULAS AURICULOVENTRICULARES PRESENTES"
  },
  {
    "codigo":117117003,
    "descripcion":"SOPLO CARDÍACO, FRECUENCIA PURA"
  },
  {
    "codigo":248189004,
    "descripcion":"CARA PLETÓRICA"
  },
  {
    "codigo":770642000,
    "descripcion":"ONICOMICOSIS DE UÑA DE DEDO DE LA MANO"
  },
  {
    "codigo":49746001,
    "descripcion":"INGURGITACIÓN MAMARIA"
  },
  {
    "codigo":311890007,
    "descripcion":"APLASTAMIENTO OSTEOPORÓTICO DE VÉRTEBRA LUMBAR"
  },
  {
    "codigo":703271000,
    "descripcion":"HEMANGIOMA DE HÍGADO INFANTIL"
  },
  {
    "codigo":211751002,
    "descripcion":"CORROSIÓN DE SEGUNDO GRADO DE CABEZA Y CUELLO"
  },
  {
    "codigo":1260327007,
    "descripcion":"MIGRAÑA HEMIPLÉJICA FAMILIAR TIPO 3"
  },
  {
    "codigo":1293095009,
    "descripcion":"POROCARCINOMA IN SITU"
  },
  {
    "codigo":109777001,
    "descripcion":"ESTOMATITIS AREATA MIGRANS"
  },
  {
    "codigo":765137006,
    "descripcion":"ACIDEMIA METILMALÓNICA DEBIDA A DEFICIENCIA DE METILMALONIL-COENZIMA A EPIMERASA"
  },
  {
    "codigo":44241007,
    "descripcion":"ESTENOSIS VALVULAR CARDÍACA"
  },
  {
    "codigo":1254822000,
    "descripcion":"INESTABILIDAD DE PRÓTESIS DE ARTICULACIÓN GLENOHUMERAL"
  },
  {
    "codigo":271782001,
    "descripcion":"SOMNOLENCIA"
  },
  {
    "codigo":404689008,
    "descripcion":"HEMIPLEJÍA ALTERNANTE"
  },
  {
    "codigo":9638002,
    "descripcion":"SÍNDROME HIPOGLOSO - PIRAMIDAL"
  },
  {
    "codigo":1156518003,
    "descripcion":"SOBREDOSIS INTENCIONAL DE ANTIBACTERIANO QUINOLÓNICO"
  },
  {
    "codigo":240849009,
    "descripcion":"MANSONELIASIS"
  },
  {
    "codigo":239014007,
    "descripcion":"DISPLASIA TRICO-ONICODENTAL"
  },
  {
    "codigo":402854008,
    "descripcion":"PÚRPURA DISPROTEINÉMICA"
  },
  {
    "codigo":237179003,
    "descripcion":"VAGINA TABICADA DURANTE EL EMBARAZO, PARTO Y PUERPERIO"
  },
  {
    "codigo":300880001,
    "descripcion":"TUMEFACCIÓN DE ESTRUCTURA GENITOURINARIA"
  },
  {
    "codigo":5968001,
    "descripcion":"FUSIÓN CONGÉNITA DE LA ARTICULACIÓN SACROILÍACA"
  },
  {
    "codigo":40571009,
    "descripcion":"DELIRIO POR INTOXICACIÓN CON ALUCINÓGENOS"
  },
  {
    "codigo":202576008,
    "descripcion":"OSTEOCONDROMATOSIS SINOVIAL DE ARTICULACIÓN ESTERNOCLAVICULAR"
  },
  {
    "codigo":725029001,
    "descripcion":"SÍNDROME DE DISPLASIA FRONTONASAL CON ALOPECIA Y ANOMALÍAS GENITALES"
  },
  {
    "codigo":366416009,
    "descripcion":"AMPLITUD DE LA FLEXIÓN LATERAL IZQUIERDA DE COLUMNA DORSAL - HALLAZGO"
  },
  {
    "codigo":1090111000119107,
    "descripcion":"EDENTULISMO PARCIAL CLASE I DEBIDO A ENFERMEDAD PERIODONTAL"
  },
  {
    "codigo":680511000119108,
    "descripcion":"SÍNDROME ENDOTELIAL IRIDOCORNEAL DE OJO IZQUIERDO"
  },
  {
    "codigo":297210000,
    "descripcion":"PULSOS PERIFÉRICOS NO PALPABLES"
  },
  {
    "codigo":167973009,
    "descripcion":"LÍQUIDO PLEURAL: CÉLULAS MALIGNAS, PRESENTES"
  },
  {
    "codigo":262607002,
    "descripcion":"CUERPO EXTRAÑO EN PARTE MEDIA DEL ESÓFAGO"
  },
  {
    "codigo":721359006,
    "descripcion":"LUXACIÓN TRAUMÁTICA DE SEXTA Y SÉPTIMA VÉRTEBRAS CERVICALES"
  },
  {
    "codigo":162468002,
    "descripcion":"SÍNTOMA LEVE"
  },
  {
    "codigo":293540003,
    "descripcion":"REACCIÓN ADVERSA A FÁRMACO VASODILATADOR A BASE DE NITRATO"
  },
  {
    "codigo":129700008,
    "descripcion":"PROVEEDOR DE ATENCIÓN MÉDICA CON MAYOR RIESGO DE TENSIÓN EMOCIONAL POR SU ROL"
  },
  {
    "codigo":195236009,
    "descripcion":"OCLUSIÓN Y ESTENOSIS DE ARTERIAS CEREBRALES MÚLTIPLES Y BILATERALES"
  },
  {
    "codigo":1145508009,
    "descripcion":"HIPOPLASIA CONGÉNITA DE FALANGE PROXIMAL DE MANO"
  },
  {
    "codigo":160633003,
    "descripcion":"DISFRUTA EL EJERCICIO FÍSICO INTENSO"
  },
  {
    "codigo":15727321000119107,
    "descripcion":"HIPERLAXITUD ARTICULAR DE AMBAS CADERAS"
  },
  {
    "codigo":838536003,
    "descripcion":"ESTENOSIS MODERADA DE VÁLVULA TRICÚSPIDE"
  },
  {
    "codigo":422777006,
    "descripcion":"INDUCCIÓN FARMACOLÓGICA DE ENZIMA CYP2C19 DEL CITOCROMO P450"
  },
  {
    "codigo":95097008,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE PARTES BLANDAS DE LA EXTREMIDAD INFERIOR"
  },
  {
    "codigo":1141838003,
    "descripcion":"SIGNO DE DIAFRAGMA CONTINUO"
  },
  {
    "codigo":93262004,
    "descripcion":"HIPOPLASIA CONGÉNITA DEL CORAZÓN"
  },
  {
    "codigo":289870009,
    "descripcion":"PERINEO SUCIO"
  },
  {
    "codigo":224334009,
    "descripcion":"AMIGO ARRESTADO"
  },
  {
    "codigo":253432002,
    "descripcion":"DISPLASIA DE VÁLVULA COMÚN AURICULOVENTRICULAR"
  },
  {
    "codigo":286200003,
    "descripcion":"INCAPAZ DE ABRIR LA CASA CUANDO ESTÁ CERRADA"
  },
  {
    "codigo":1269240007,
    "descripcion":"TROMBOSIS DE ARTERIA CEREBRAL ANTERIOR DERECHA"
  },
  {
    "codigo":710349003,
    "descripcion":"NEUROPATÍA PERIFÉRICA DE MIEMBRO SUPERIOR DEBIDA A TRASTORNO METABÓLICO"
  },
  {
    "codigo":315298001,
    "descripcion":"EXPOSICIÓN CORNEAL"
  },
  {
    "codigo":249762005,
    "descripcion":"ENGROSAMIENTO DE LA VAINA TENDINOSA DEL TENDÓN FLEXOR DE DEDO DE LA MANO"
  },
  {
    "codigo":85922006,
    "descripcion":"FRACTURA DE HUESO GANCHOSO DE LA MUÑECA"
  },
  {
    "codigo":184226007,
    "descripcion":"DETALLES DE EDAD\/SEXO EN LA COMPUTADORA"
  },
  {
    "codigo":282530007,
    "descripcion":"CAPAZ DE BAJAR ESCALERAS CORRIENDO"
  },
  {
    "codigo":247927001,
    "descripcion":"MOVIMIENTOS TORSIONALES COMPLEJOS REPETITIVOS"
  },
  {
    "codigo":51319002,
    "descripcion":"ENFERMEDAD DE CADENA LIVIANA"
  },
  {
    "codigo":1003426008,
    "descripcion":"ENFERMEDAD GLOMERULAR DEBIDA A ENFERMEDAD DE FABRY"
  },
  {
    "codigo":84087006,
    "descripcion":"PÉRDIDA DE SANGRE FETAL PROVENIENTE DE LA PLACENTA"
  },
  {
    "codigo":442700003,
    "descripcion":"HALLAZGO RELACIONADO CON DIFERENCIA EN LA TEXTURA EN COMPARACIÓN CON EXAMEN RADIOLÓGICO PREVIO"
  },
  {
    "codigo":735777001,
    "descripcion":"LACERACIÓN DE REGIÓN LUMBAR CON CUERPO EXTRAÑO"
  },
  {
    "codigo":278860009,
    "descripcion":"LUMBALGIA CRÓNICA"
  },
  {
    "codigo":703009006,
    "descripcion":"CAMPYLOBACTER JEJUNI O CAMPYLOBACTER COLI"
  },
  {
    "codigo":1260065007,
    "descripcion":"CISTADENOCARCINOMA MUCINOSO DE PULMÓN"
  },
  {
    "codigo":111350000,
    "descripcion":"EROSIÓN GÁSTRICA AGUDA ASOCIADA A LA INGESTA DE DROGAS"
  },
  {
    "codigo":45814002,
    "descripcion":"SÍNDROME DE BIRNBAUM"
  },
  {
    "codigo":439030002,
    "descripcion":"CABALGAMIENTO ALTO DE LA PRÓSTATA"
  },
  {
    "codigo":766710005,
    "descripcion":"DISPLASIA CORTICAL FOCAL AISLADA"
  },
  {
    "codigo":209654006,
    "descripcion":"DESGARRO COMPLETO DE LIGAMENTO DEL CARTÍLAGO XIFOIDES"
  },
  {
    "codigo":328871000119103,
    "descripcion":"INFECCIÓN LOCALIZADA ASOCIADA CON CATÉTER VENOSO CENTRAL"
  },
  {
    "codigo":109515000,
    "descripcion":"RETROGNATISMO CONGÉNITO"
  },
  {
    "codigo":733942006,
    "descripcion":"CARIES DENTAL ACTIVA PRIMARIA QUE SE EXTIENDE HASTA EL TERCIO MEDIO DE LA DENTINA"
  },
  {
    "codigo":240587005,
    "descripcion":"INFECCIÓN LATENTE CHANCROIDE"
  },
  {
    "codigo":74912001,
    "descripcion":"ENFERMEDAD POR HEMOGLOBINA M"
  },
  {
    "codigo":1156256003,
    "descripcion":"REACCIÓN ADVERSA A VACUNA CONTRA COVID-19"
  },
  {
    "codigo":304288006,
    "descripcion":"SENSACIÓN IRRITATIVA EN LA LÍNEA DE SUTURA"
  },
  {
    "codigo":15703361000119100,
    "descripcion":"DEDO DE LA MANO EN GATILLO ADQUIRIDO, AMBOS DEDOS ÍNDICES"
  },
  {
    "codigo":204149000,
    "descripcion":"OPACIDAD CORNEAL CONGÉNITA SIN DEFICIENCIA VISUAL"
  },
  {
    "codigo":238752009,
    "descripcion":"ACNÉ EN RACIMOS"
  },
  {
    "codigo":10624321000119101,
    "descripcion":"BLEFARITIS DE PÁRPADOS SUPERIOR E INFERIOR IZQUIERDOS"
  },
  {
    "codigo":1252725005,
    "descripcion":"NIVEL DE ENOLASA NEUROESPECÍFICA POR DEBAJO DE RANGO DE REFERENCIA"
  },
  {
    "codigo":269685008,
    "descripcion":"LESIÓN POR HÉLICE GIRATORIA DE AERONAVE"
  },
  {
    "codigo":202314000,
    "descripcion":"ANQUILOSIS DE ARTICULACIÓN INTERFALÁNGICA PROXIMAL"
  },
  {
    "codigo":366154003,
    "descripcion":"HALLAZGO RELACIONADO CON EL FLUJO RESPIRATORIO"
  },
  {
    "codigo":300618004,
    "descripcion":"DIFICULTAD PARA TRASLADARSE A PIE"
  },
  {
    "codigo":235082006,
    "descripcion":"ASIMETRÍA DE MANDÍBULA"
  },
  {
    "codigo":397087000,
    "descripcion":"MARGEN QUIRÚRGICO DE VÍAS BILIARES CON COMPROMISO TUMORAL, NO APLICABLE"
  },
  {
    "codigo":298783005,
    "descripcion":"AMPLITUD DE FLEXIÓN PASIVA DE HOMBRO DISMINUIDA"
  },
  {
    "codigo":2036003,
    "descripcion":"DEFICIENCIA ADQUIRIDA DE FACTOR VII"
  },
  {
    "codigo":428020005,
    "descripcion":"FRACTURA OSTEOCONDRAL NO EXPUESTA DE RÓTULA"
  },
  {
    "codigo":296948007,
    "descripcion":"SOBREDOSIS DE VITAMINA"
  },
  {
    "codigo":722932008,
    "descripcion":"DERMATOSIS NEONATAL CAUSADA POR ANTICUERPO MATERNO"
  },
  {
    "codigo":788468009,
    "descripcion":"TRASTORNO REPETITIVO DEL MOVIMIENTO DE LA MANO IZQUIERDA"
  },
  {
    "codigo":1148916009,
    "descripcion":"ISQUEMIA TESTICULAR REVERSIBLE DEBIDA A TORSIÓN DE TESTÍCULO"
  },
  {
    "codigo":295113007,
    "descripcion":"ALERGIA A DESOXIRRIBONUCLEASA"
  },
  {
    "codigo":293278000,
    "descripcion":"REACCIÓN ADVERSA A LA NAFARELINA"
  },
  {
    "codigo":1343689009,
    "descripcion":"ALTERACIÓN CRÓNICA DE ASTA POSTERIOR DE MENISCO EXTERNO"
  },
  {
    "codigo":196809009,
    "descripcion":"HERNIA INGUINAL IRREDUCTIBLE"
  },
  {
    "codigo":1208947001,
    "descripcion":"TRASTORNO FETAL DEBIDO A HEMORRAGIA PLACENTARIA"
  },
  {
    "codigo":62067003,
    "descripcion":"SÍNDROME DE CORAZÓN IZQUIERDO HIPOPLÁSICO"
  },
  {
    "codigo":289608000,
    "descripcion":"APÓSITO DE MATERNIDAD EMPAPADO CON LÍQUIDO AMNIÓTICO"
  },
  {
    "codigo":193139009,
    "descripcion":"LESIÓN DE NERVIO INTERÓSEO POSTERIOR"
  },
  {
    "codigo":225907008,
    "descripcion":"DIFICULTAD PARA PREVENIR LA CONDUCTA INDESEABLE"
  },
  {
    "codigo":1010504003,
    "descripcion":"ESCLEROSIS DE EPÍFISIS DE FALANGE DE PULGAR CON RADIOPACIDAD AUMENTADA"
  },
  {
    "codigo":94835009,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE CUERDA VOCAL FALSA"
  },
  {
    "codigo":60232001,
    "descripcion":"HENDIDURA DE VALVA DE VÁLVULA TRICÚSPIDE"
  },
  {
    "codigo":331381000119100,
    "descripcion":"DEGENERACIÓN VÍTREA DEL OJO DERECHO"
  },
  {
    "codigo":255005000,
    "descripcion":"PAPILOMA DE CONJUNTIVA"
  },
  {
    "codigo":123933003,
    "descripcion":"INTOXICACIÓN POR PHYTOLACCACEAE"
  },
  {
    "codigo":1172509003,
    "descripcion":"MELANOTROPINA DENTRO DE RANGO DE REFERENCIA"
  },
  {
    "codigo":10817141000119101,
    "descripcion":"FRACTURA EXPUESTA DE EXTREMO SUPERIOR DE TIBIA DERECHA"
  },
  {
    "codigo":386077006,
    "descripcion":"DEFICIENCIA DE VITAMINA K2"
  },
  {
    "codigo":25629007,
    "descripcion":"TUBERCULOSIS AGUDA"
  },
  {
    "codigo":23794001,
    "descripcion":"LINFADENOPATÍA PARATRAQUEAL"
  },
  {
    "codigo":285938003,
    "descripcion":"NO VACÍA EL LAVABO"
  },
  {
    "codigo":187634003,
    "descripcion":"NEOPLASIA MALIGNA DE DORSO DE PORCIÓN ANTERIOR DE LENGUA"
  },
  {
    "codigo":710087000,
    "descripcion":"ALTURA DE HUESO MANDIBULAR EDÉNTULO TIPO IV"
  },
  {
    "codigo":185799001,
    "descripcion":"CONTROL DEL CESE DEL HÁBITO DE FUMAR REALIZADO"
  },
  {
    "codigo":253170008,
    "descripcion":"HEMIMEGALENCEFALIA"
  },
  {
    "codigo":415175000,
    "descripcion":"MELANOSIS ADQUIRIDA PRIMARIA DE LA CONJUNTIVA SIN ATIPÍA"
  },
  {
    "codigo":21959005,
    "descripcion":"FAMILIA MONOPARENTAL"
  },
  {
    "codigo":447943006,
    "descripcion":"VENTRÍCULO DERECHO TRIPARTITO"
  },
  {
    "codigo":284103007,
    "descripcion":"CAPAZ DE CONTROLAR LA POSTURA"
  },
  {
    "codigo":249500002,
    "descripcion":"VÓMITO SIN ESFUERZO"
  },
  {
    "codigo":10626831000119100,
    "descripcion":"FORÚNCULO DEL MUSLO DERECHO"
  },
  {
    "codigo":216732007,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR RODENTICIDAS"
  },
  {
    "codigo":315036008,
    "descripcion":"MELANOMA IN SITU DEL DORSO DE LA MANO"
  },
  {
    "codigo":16033551000119101,
    "descripcion":"HIPERTROFIA DE HUESO DE AMBAS TIBIAS"
  },
  {
    "codigo":247665005,
    "descripcion":"PERDERSE DENTRO DE LA CASA"
  },
  {
    "codigo":51057008,
    "descripcion":"ULERITEMA DE LAS MEJILLAS"
  },
  {
    "codigo":311366001,
    "descripcion":"SÍNDROME DE KIMMELSTIEL-WILSON"
  },
  {
    "codigo":442438000,
    "descripcion":"GRIPE CAUSADA POR VIRUS INFLUENZA A"
  },
  {
    "codigo":278598003,
    "descripcion":"FILTRACIÓN EN OBTURACIÓN DENTAL"
  },
  {
    "codigo":81990004,
    "descripcion":"COR BILOCULARE"
  },
  {
    "codigo":1359942007,
    "descripcion":"BACTERIAS EN CADENA"
  },
  {
    "codigo":737350008,
    "descripcion":"NECESIDAD DE ASISTENCIA CON LA COMUNICACIÓN"
  },
  {
    "codigo":304911000119104,
    "descripcion":"DETENCIÓN TOTAL DE CRECIMIENTO EPIFISARIO DE TIBIA PROXIMAL DERECHA"
  },
  {
    "codigo":309531006,
    "descripcion":"MASA DE RODILLA"
  },
  {
    "codigo":1259803007,
    "descripcion":"CÁNCER GÁSTRICO HER2-POSITIVO PRIMARIO"
  },
  {
    "codigo":78320000,
    "descripcion":"VÁLVULA CARDÍACA CUADRICÚSPIDE"
  },
  {
    "codigo":209392001,
    "descripcion":"FRACTURA-LUXACIÓN POSTERIOR NO EXPUESTA DE ARTICULACIÓN ESTERNOCLAVICULAR"
  },
  {
    "codigo":14619009,
    "descripcion":"FORIA"
  },
  {
    "codigo":307696003,
    "descripcion":"MOVIMIENTOS OCULARES ESPONTÁNEOS ASOCIADOS A PÉRDIDA DE LA AGUDEZA VISUAL"
  },
  {
    "codigo":305861001,
    "descripcion":"ATENDIDO POR SERVICIO DE FISIOTERAPIA HOSPITALARIO"
  },
  {
    "codigo":404165002,
    "descripcion":"XANTOGRANULOMA NECROBIÓTICO CON PARAPROTEINEMIA"
  },
  {
    "codigo":10928041000119101,
    "descripcion":"FRACTURA NO EXPUESTA DE CUELLO DE METACARPIANO DE MANO IZQUIERDA"
  },
  {
    "codigo":109253006,
    "descripcion":"QUISTE TRIQUILÉMICO PROLIFERATIVO DEL CUERO CABELLUDO"
  },
  {
    "codigo":238490002,
    "descripcion":"DERMATOSIS POR PRESIÓN"
  },
  {
    "codigo":1287066002,
    "descripcion":"HEMORRAGIA INTRAVENTRICULAR NO TRAUMÁTICA GRADO 3 DURANTE PERÍODO FETAL"
  },
  {
    "codigo":304026004,
    "descripcion":"ÚLCERA VARICOSA DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":402330006,
    "descripcion":"APARICIÓN DE PSORIASIS EN LA LACTANCIA (< 1 AÑO)"
  },
  {
    "codigo":74650009,
    "descripcion":"SECUENCIA DE OBSTRUCCIÓN LINFÁTICA YUGULAR"
  },
  {
    "codigo":72815004,
    "descripcion":"CISTITIS GLANDULAR"
  },
  {
    "codigo":236655005,
    "descripcion":"DISINERGIA DETRUSOR-ESFÍNTER"
  },
  {
    "codigo":40047007,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE LA SEXTA VÉRTEBRA CERVICAL"
  },
  {
    "codigo":398660000,
    "descripcion":"NEVO SPILUS"
  },
  {
    "codigo":5444000,
    "descripcion":"DELIRIO POR INTOXICACIÓN POR SEDANTES, HIPNÓTICOS Y\/O ANSIOLÍTICOS"
  },
  {
    "codigo":1119556002,
    "descripcion":"TABIQUE NASAL PROMINENTE"
  },
  {
    "codigo":38212005,
    "descripcion":"VENTILACIÓN VOLUNTARIA MÁXIMA DISMINUIDA"
  },
  {
    "codigo":890180006,
    "descripcion":"SÍNDROME DE BLEFAROFIMOSIS, EPICANTO INVERSO, PTOSIS PLUS"
  },
  {
    "codigo":300356006,
    "descripcion":"PROBLEMA DE LA VESÍCULA BILIAR"
  },
  {
    "codigo":726340005,
    "descripcion":"TRISOMÍA PARCIAL DE CROMOSOMA 2"
  },
  {
    "codigo":365892009,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA RECORDAR SU EDAD"
  },
  {
    "codigo":10901571000119101,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO VAGO DERECHO"
  },
  {
    "codigo":298521007,
    "descripcion":"AMPLITUD DE EXTENSIÓN ACTIVA DE LA COLUMNA VERTEBRAL DORSAL, DISMINUIDA"
  },
  {
    "codigo":427758000,
    "descripcion":"PÉRDIDA DE LÍQUIDO CEFALORRAQUÍDEO POR LA BOCA"
  },
  {
    "codigo":10737731000119102,
    "descripcion":"TUMOR MALIGNO DE CORDÓN GERMINAL DE OVARIO IZQUIERDO"
  },
  {
    "codigo":296686001,
    "descripcion":"SOBREDOSIS DE CEFRADINA"
  },
  {
    "codigo":722670005,
    "descripcion":"CARCINOMA PRIMARIO DE TIMO"
  },
  {
    "codigo":1148654007,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR HORMONA PARATIROIDEA Y\/O DERIVADO DE HORMONA PARATIROIDEA"
  },
  {
    "codigo":1071171000119104,
    "descripcion":"ARTROSIS SECUNDARIA DE CADERA"
  },
  {
    "codigo":294851004,
    "descripcion":"ALERGIA A AGENTE PERFLUOROQUÍMICO"
  },
  {
    "codigo":131011003,
    "descripcion":"NIVEL DE CORTICOTROFINA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":260248003,
    "descripcion":"J1"
  },
  {
    "codigo":293016004,
    "descripcion":"REACCIÓN ADVERSA A CEFALOSPORINA DE CUARTA GENERACIÓN"
  },
  {
    "codigo":1144984005,
    "descripcion":"AZOOSPERMIA POR ANORQUIDIA"
  },
  {
    "codigo":333891000119107,
    "descripcion":"PTOSIS MECÁNICA DE PÁRPADO SUPERIOR DERECHO"
  },
  {
    "codigo":94573004,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE PIEL DE MUSLO"
  },
  {
    "codigo":127341005,
    "descripcion":"TRASTORNO AGUDO DEL SISTEMA NERVIOSO"
  },
  {
    "codigo":291181006,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR CLORPROMAZINA"
  },
  {
    "codigo":192877007,
    "descripcion":"DEGENERACIÓN CEREBELOSA PARANEOPLÁSICA"
  },
  {
    "codigo":225645007,
    "descripcion":"MIEDO A ORINARSE EN PÚBLICO"
  },
  {
    "codigo":289346002,
    "descripcion":"FETO, NO VISUALIZADO"
  },
  {
    "codigo":92738002,
    "descripcion":"CARCINOMA IN SITU DE LA PIEL DEL PERINEO"
  },
  {
    "codigo":11858141000119103,
    "descripcion":"DISTENSIÓN DE MÚSCULO CRURAL ANTERIOR DE PIERNA DERECHA"
  },
  {
    "codigo":58135005,
    "descripcion":"DUPLICACIÓN CONGÉNITA DEL CUELLO UTERINO"
  },
  {
    "codigo":123671009,
    "descripcion":"CITOMEGALIA DE LA GLÁNDULA SUPRARRENAL"
  },
  {
    "codigo":449516003,
    "descripcion":"CONEXIONES SEPARADAS DE VENA HEPÁTICA Y VENA CAVA INFERIOR AL CORAZÓN"
  },
  {
    "codigo":285676006,
    "descripcion":"NO CARGA PESO"
  },
  {
    "codigo":1268716006,
    "descripcion":"MEDULOBLASTOMA PRIMARIO"
  },
  {
    "codigo":416748006,
    "descripcion":"INTOXICACIÓN ALUCINÓGENA POR PESCADO"
  },
  {
    "codigo":1137644008,
    "descripcion":"LEIOMIOSARCOMA DE FONDO GÁSTRICO"
  },
  {
    "codigo":12241271000119101,
    "descripcion":"FASCITIS PLANTAR DE PIE IZQUIERDO"
  },
  {
    "codigo":447681003,
    "descripcion":"CONTINUIDAD ENTRE VÁLVULA MITRAL Y VÁLVULA PULMONAR"
  },
  {
    "codigo":283841009,
    "descripcion":"LESIÓN POR DESOLLAMIENTO DE CABEZA Y CUELLO"
  },
  {
    "codigo":707990002,
    "descripcion":"FALLA DE OSTEOINTEGRACIÓN DE IMPLANTE DENTAL DEBIDA A TRAUMATISMO OCLUSAL ASOCIADO A MAL DISEÑO DE PRÓTESIS"
  },
  {
    "codigo":1363350003,
    "descripcion":"REACCIÓN ADVERSA A AGENTE ANTISÉPTICO DE AMIDINA"
  },
  {
    "codigo":314774003,
    "descripcion":"ATENDIDO EN CONSULTORIO DE ACCESO ABIERTO"
  },
  {
    "codigo":118166004,
    "descripcion":"IRIDODONESIS"
  },
  {
    "codigo":249238004,
    "descripcion":"TESTÍCULOS EN ESCROTO"
  },
  {
    "codigo":1197675002,
    "descripcion":"DUODENITIS POR VASCULITIS"
  },
  {
    "codigo":247403005,
    "descripcion":"BAJO UMBRAL DE DOLOR"
  },
  {
    "codigo":83563007,
    "descripcion":"HEMOSIDEROSIS RENAL"
  },
  {
    "codigo":16192003,
    "descripcion":"SUPEROVULACIÓN"
  },
  {
    "codigo":442176004,
    "descripcion":"DISFUNCIÓN DEL SUEÑO CON ALTERACIÓN DEL DESPERTAR"
  },
  {
    "codigo":1163072008,
    "descripcion":"ENCEFALITIS POR PARECHOVIRUS HUMANO"
  },
  {
    "codigo":14357004,
    "descripcion":"NEUROPATÍA ÓPTICA ISQUÉMICA"
  },
  {
    "codigo":210965004,
    "descripcion":"TRASTORNO DEBIDO LESIÓN TRAUMÁTICA DE MÚSCULO Y TENDÓN DE MIEMBRO INFERIOR Y POSTERIOR A ELLA"
  },
  {
    "codigo":47125007,
    "descripcion":"TRASTORNO DE LA TRÁQUEA"
  },
  {
    "codigo":79893008,
    "descripcion":"ERUPCIÓN VESICULOSA DE LA PIEL"
  },
  {
    "codigo":471274000,
    "descripcion":"ARTERIA COLATERAL QUE DERIVA EL FLUJO SISTÉMICO HACIA LA CIRCULACIÓN PULMONAR Y CONTRIBUYE A LA IRRIGACIÓN PULMONAR DOBLE"
  },
  {
    "codigo":438506002,
    "descripcion":"DOLOR ABDOMINAL VISCERAL"
  },
  {
    "codigo":209130002,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE CARTÍLAGO LARÍNGEO"
  },
  {
    "codigo":733418003,
    "descripcion":"SÍNDROME DE JOUBERT CON DISTROFIA TORÁCICA ASFIXIANTE DE JEUNE"
  },
  {
    "codigo":1290474005,
    "descripcion":"RADIOGRAFÍA DE DEDO DE MANO NORMAL"
  },
  {
    "codigo":372970004,
    "descripcion":"INFECCIÓN CAUSADA POR PENICILLIUM VERRUCULOSUM"
  },
  {
    "codigo":897258002,
    "descripcion":"CURVATURA ANORMAL DE FALANGE PROXIMAL DE DEDO GORDO"
  },
  {
    "codigo":371135000,
    "descripcion":"RETRASO EN LA APLICACIÓN DE QUIMIOTERAPIA"
  },
  {
    "codigo":241898009,
    "descripcion":"EFECTO TÓXICO CAUSADO POR FERTILIZANTE VEGETAL"
  },
  {
    "codigo":240063002,
    "descripcion":"DISTROFIA MUSCULAR CONGÉNITA TIPO EICHSFELD"
  },
  {
    "codigo":305599003,
    "descripcion":"BAJO ATENCIÓN DE PODÓLOGO"
  },
  {
    "codigo":403903003,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS EN ANILLO DE SELLO"
  },
  {
    "codigo":860820000,
    "descripcion":"HIPOPLASIA DE SENOS CRANEALES"
  },
  {
    "codigo":762516004,
    "descripcion":"TRASTORNO OBSESIVO COMPULSIVO CAUSADO POR CATINONA SINTÉTICA"
  },
  {
    "codigo":1155732005,
    "descripcion":"DISPLASIA RENAL QUÍSTICA"
  },
  {
    "codigo":1286804005,
    "descripcion":"HIPERTENSIÓN OCULAR DEBIDA A ANOMALÍA DE SEGMENTO ANTERIOR"
  },
  {
    "codigo":41620007,
    "descripcion":"ANOMALÍA CONGÉNITA DE LA GLÁNDULA LAGRIMAL"
  },
  {
    "codigo":205460009,
    "descripcion":"COSTILLA ACCESORIA"
  },
  {
    "codigo":39785005,
    "descripcion":"TRASTORNO DE LA CIRCULACIÓN PULMONAR"
  },
  {
    "codigo":301929005,
    "descripcion":"PATRÓN DE TINCIÓN PERIFÉRICA DEL EPITELIO CORNEAL"
  },
  {
    "codigo":726078000,
    "descripcion":"SÍNDROME DE BLAU ESPORÁDICO"
  },
  {
    "codigo":70718000,
    "descripcion":"ÚLCERA VULVAR AGUDA"
  },
  {
    "codigo":365630000,
    "descripcion":"CANTIDAD DE LEUCOCITOS - HALLAZGO"
  },
  {
    "codigo":1119294003,
    "descripcion":"CEFALEA UNILATERAL DEL LADO IZQUIERDO"
  },
  {
    "codigo":234558001,
    "descripcion":"DEFICIENCIA DE ANTICUERPO ANTIPOLISACÁRIDO DE HAEMOPHILUS INFLUENZAE TIPO B"
  },
  {
    "codigo":336401000119109,
    "descripcion":"LUXACIÓN ANTERIOR DE CRISTALINO DERECHO"
  },
  {
    "codigo":16638481000119109,
    "descripcion":"COMPRESIÓN DE NERVIO PERIFÉRICO DE AMBAS MANOS"
  },
  {
    "codigo":236393009,
    "descripcion":"GLOMERULONEFRITIS ENDOCAPILAR"
  },
  {
    "codigo":396563000,
    "descripcion":"PIGMENTACIÓN TUMORAL, NO DETERMINADA"
  },
  {
    "codigo":298259003,
    "descripcion":"SIGNO ARTICULAR CON NOMBRE PROPIO"
  },
  {
    "codigo":35571000087100,
    "descripcion":"ISQUEMIA MIOCÁRDICO POSTEROLATERAL"
  },
  {
    "codigo":134419005,
    "descripcion":"CONCENTRACIÓN NORMAL"
  },
  {
    "codigo":48371000087102,
    "descripcion":"FRACTURA DE HUESO PARIETAL DERECHO"
  },
  {
    "codigo":38131000087103,
    "descripcion":"ACINESIA DE SEGMENTO INFERIOR MEDIO DE VENTRÍCULO CARDÍACO IZQUIERDO"
  },
  {
    "codigo":43251000087108,
    "descripcion":"HERIDA PUNZANTE DE MUÑECA DERECHA CON CUERPO EXTRAÑO"
  },
  {
    "codigo":394728005,
    "descripcion":"QUERATOSIS FOLICULAR INVERTIDA"
  },
  {
    "codigo":1512006,
    "descripcion":"ESTRECHEZ CONGÉNITA DE VÍA BILIAR"
  },
  {
    "codigo":720573009,
    "descripcion":"SÍNDROME DE BRAQUIMORFISMO CON ONICODISPLASIA Y DISFALANGISMO"
  },
  {
    "codigo":292754002,
    "descripcion":"REACCIÓN ADVERSA A MEDICAMENTOS HOMEOPÁTICOS"
  },
  {
    "codigo":94311007,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL FONDO DEL ESTÓMAGO"
  },
  {
    "codigo":290919007,
    "descripcion":"INTOXICACIÓN POR MIANSERINA"
  },
  {
    "codigo":289084000,
    "descripcion":"DIFICULTAD PARA AMAMANTAR"
  },
  {
    "codigo":127079009,
    "descripcion":"LINFADENOPATÍA AURICULAR INFERIOR"
  },
  {
    "codigo":59708000,
    "descripcion":"DISPLASIA EPIFISARIA MÚLTIPLE"
  },
  {
    "codigo":26940007,
    "descripcion":"SOBREDEPENDENCIA DE LOS PADRES"
  },
  {
    "codigo":188945000,
    "descripcion":"NEOPLASIA BENIGNA DE HUESO SEMILUNAR"
  },
  {
    "codigo":715068009,
    "descripcion":"SEROMA"
  },
  {
    "codigo":92476009,
    "descripcion":"NEOPLASIA BENIGNA DE CONDUCTO DEFERENTE"
  },
  {
    "codigo":1237521002,
    "descripcion":"METÁSTASIS DE CARCINOMA DE PIEL DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":57873008,
    "descripcion":"NEFROPATÍA HIPERTENSIVA QUE COMPLICA EL PUERPERIO Y\/O CONSTITUYE UN MOTIVO DE ATENCIÓN DURANTE ESTE PERÍODO"
  },
  {
    "codigo":254481009,
    "descripcion":"NEOPLASIA MALIGNA DE CORNETE NASAL MEDIO"
  },
  {
    "codigo":56038003,
    "descripcion":"ENFERMEDAD INFECCIOSA ESTAFILOCÓCICA"
  },
  {
    "codigo":449254004,
    "descripcion":"NEOPLASIA EPITELIAL MALIGNA DE FARINGE"
  },
  {
    "codigo":338911000119103,
    "descripcion":"CICLOPLEJÍA DE OJO IZQUIERDO"
  },
  {
    "codigo":447419001,
    "descripcion":"LACERACIÓN SUPERFICIAL DE TOBILLO"
  },
  {
    "codigo":185275002,
    "descripcion":"ATENDIDO EN UN CONSULTORIO DE REHABILITACIÓN"
  },
  {
    "codigo":283579006,
    "descripcion":"HERIDA DE PERDIGÓN EN INGLE"
  },
  {
    "codigo":54203008,
    "descripcion":"BRONCOMALACIA"
  },
  {
    "codigo":840635008,
    "descripcion":"EXCITABILIDAD EMOCIONAL DISMINUIDA"
  },
  {
    "codigo":85136002,
    "descripcion":"SURCOS LONGITUDINALES UNGUEALES"
  },
  {
    "codigo":216208001,
    "descripcion":"LESIÓN POR MAQUINARIA EN AERONAVE, SIN ACCIDENTE DE AERONAVE, MIEMBRO DEL PERSONAL DE TIERRA O EMPLEADO DE LÍNEA AÉREA LESIONADO"
  },
  {
    "codigo":52368004,
    "descripcion":"LENGUA ESCROTAL"
  },
  {
    "codigo":1363088005,
    "descripcion":"ASTILLA EN RODILLA"
  },
  {
    "codigo":314512009,
    "descripcion":"HEMANGIOMA DE PÁRPADO"
  },
  {
    "codigo":247141006,
    "descripcion":"DEPÓSITOS DE PIGMENTO RETINIANO"
  },
  {
    "codigo":704058000,
    "descripcion":"FRACTURA POR ESTRÉS DE OMÓPLATO"
  },
  {
    "codigo":15930003,
    "descripcion":"CUERPO EXTRAÑO RETENIDO EN EL OÍDO MEDIO"
  },
  {
    "codigo":278074003,
    "descripcion":"REACTIVIDAD REDUCIDA"
  },
  {
    "codigo":736826005,
    "descripcion":"IMPACTACIÓN DE DIENTE EN MUCOSA BUCAL"
  },
  {
    "codigo":1076191000119109,
    "descripcion":"BURSITIS DE PATA DE GANSO DE RODILLA DERECHA"
  },
  {
    "codigo":833295000,
    "descripcion":"CORDOMA DE COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":441914009,
    "descripcion":"ESTUDIO POR IMÁGENES DE LA CABEZA, ANORMAL"
  },
  {
    "codigo":210703001,
    "descripcion":"LESIÓN POR DESOLLAMIENTO DE TOBILLO"
  },
  {
    "codigo":310842009,
    "descripcion":"EXTENDIDO CERVICAL - INFLAMACIÓN MODERADA"
  },
  {
    "codigo":472847005,
    "descripcion":"ESTENOSIS DE VÁLVULA AÓRTICA FETAL"
  },
  {
    "codigo":79631006,
    "descripcion":"CRISIS DE AUSENCIA"
  },
  {
    "codigo":866063007,
    "descripcion":"MIELITIS CAUSADA POR MYCOPLASMA PNEUMONIAE"
  },
  {
    "codigo":1193743005,
    "descripcion":"ENTERITIS POR SHIGELLA DYSENTERIAE"
  },
  {
    "codigo":307172007,
    "descripcion":"FRACTURA-LUXACIÓN DE ARTICULACIÓN RADIOCUBITAL DISTAL"
  },
  {
    "codigo":403641007,
    "descripcion":"PSEUDOESCLERODERMIA DEBIDA A TRATAMIENTO CITOTÓXICO"
  },
  {
    "codigo":272569008,
    "descripcion":"DECÚBITO LATERAL CON MESA CON MESA ARTICULADA"
  },
  {
    "codigo":43193009,
    "descripcion":"IRITIS GOTOSA"
  },
  {
    "codigo":762254000,
    "descripcion":"DISPLASIA CONGÉNITA DE VÁLVULA TRICÚSPIDE"
  },
  {
    "codigo":237966006,
    "descripcion":"DEFECTO DEL TRANSPORTE DE GLUCOSA"
  },
  {
    "codigo":170595000,
    "descripcion":"CONTROL DE ANGINA - MALO"
  },
  {
    "codigo":236131001,
    "descripcion":"OBSTRUCCIÓN DE ESTOMA"
  },
  {
    "codigo":203363008,
    "descripcion":"OSTEOCONDROSIS VERTEBRAL DE CALVÉ"
  },
  {
    "codigo":399971009,
    "descripcion":"EPIDERMÓLISIS BULLOSA DE LA ZONA DE UNIÓN"
  },
  {
    "codigo":4920001,
    "descripcion":"DEFICIENCIA DE ACETIL - COA CARBOXILASA"
  },
  {
    "codigo":267064002,
    "descripcion":"RETENCIÓN DE ORINA"
  },
  {
    "codigo":398136003,
    "descripcion":"MENINGITIS CAUSADA POR VIRUS DE CORIOMENINGITIS LINFOCÍTICA"
  },
  {
    "codigo":37688005,
    "descripcion":"CLONORQUIASIS CON CIRROSIS BILIAR"
  },
  {
    "codigo":430904007,
    "descripcion":"INVAGINACIÓN BASILAR CRANEAL"
  },
  {
    "codigo":299832008,
    "descripcion":"REFLEJO BICIPITAL NORMAL"
  },
  {
    "codigo":365368008,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD DE PARTICIPAR EN ACTIVIDADES DE OCIO"
  },
  {
    "codigo":232461002,
    "descripcion":"LARINGE HENDIDA CONGÉNITA"
  },
  {
    "codigo":429069001,
    "descripcion":"REQUIERE VACUNACIÓN CONTRA BACILLUS CALMETTE-GUERIN"
  },
  {
    "codigo":441931000124109,
    "descripcion":"INGESTA EXCESIVA DE MINERALES"
  },
  {
    "codigo":297997007,
    "descripcion":"PELO ROJO"
  },
  {
    "codigo":296162004,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE LOXAPINA"
  },
  {
    "codigo":230626007,
    "descripcion":"LESIÓN DE NERVIO PERIFÉRICO POR VIBRACIÓN"
  },
  {
    "codigo":785847000,
    "descripcion":"PROLAPSO ARRITMOGÉNICO BIVALVAR DE VÁLVULA MITRAL"
  },
  {
    "codigo":294327003,
    "descripcion":"ALERGIA A PARAFINA LÍQUIDA"
  },
  {
    "codigo":292492002,
    "descripcion":"REACCIÓN ADVERSA A FÁRMACOS ESTIMULANTES SELECTIVOS DE ADRENORRECEPTOR BETA-2"
  },
  {
    "codigo":718476003,
    "descripcion":"CITORREDUCCIÓN ÓPTIMA QUE REQUIRIÓ MÚLTIPLES PROCEDIMIENTOS RADICALES"
  },
  {
    "codigo":314951000119100,
    "descripcion":"OSTEÍTIS DEFORMANTE DE HÚMERO DERECHO"
  },
  {
    "codigo":95884007,
    "descripcion":"INFECCIÓN ESTAFILOCÓCICA DEL OJO"
  },
  {
    "codigo":1144460009,
    "descripcion":"APLASIA DE PRIMER HUESO METACARPIANO"
  },
  {
    "codigo":94049001,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL PALADAR BLANDO"
  },
  {
    "codigo":61281005,
    "descripcion":"ESPUTO CON SANGRE"
  },
  {
    "codigo":126817006,
    "descripcion":"NEOPLASIA DEL ESÓFAGO"
  },
  {
    "codigo":92214000,
    "descripcion":"NEOPLASIA BENIGNA DEL MEDIASTINO"
  },
  {
    "codigo":290657009,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR MITOXANTRONA"
  },
  {
    "codigo":124982007,
    "descripcion":"DETENCIÓN DE LA MITOSIS"
  },
  {
    "codigo":288822009,
    "descripcion":"DIFICULTAD PARA IMITAR GESTOS"
  },
  {
    "codigo":876811003,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE GLÚTEO CON INFECCIÓN"
  },
  {
    "codigo":254219004,
    "descripcion":"COMEDONES DISQUERATÓSICOS FAMILIARES"
  },
  {
    "codigo":1237259006,
    "descripcion":"TRASTORNO FETAL DEBIDO A SÍNDROME DE TRANSFUSIÓN FETO-FETAL"
  },
  {
    "codigo":448992002,
    "descripcion":"NEOPLASIA EPITELIAL MALIGNA DE APÉNDICE"
  },
  {
    "codigo":416224003,
    "descripcion":"CONSENTIMIENTO DEL PACIENTE PARA TRANSFERENCIA DE INFORMACIÓN RELACIONADA CON ENTREGAS REPETIDAS, OTORGADO"
  },
  {
    "codigo":23008004,
    "descripcion":"ARTRITIS INFECCIOSA SUBAGUDA"
  },
  {
    "codigo":285152002,
    "descripcion":"ARRANCARSE LA VAGINA"
  },
  {
    "codigo":283317000,
    "descripcion":"ASTILLA DE MADERA EN EL DORSO DEL PIE"
  },
  {
    "codigo":21173002,
    "descripcion":"ADENOMA BENIGNO DE LA PRÓSTATA"
  },
  {
    "codigo":447157009,
    "descripcion":"QUEMADURA EPIDÉRMICA DE CARA"
  },
  {
    "codigo":1331893009,
    "descripcion":"GLAUCOMA NEOVASCULAR DE ÁNGULO CERRADO DE OJO DERECHO"
  },
  {
    "codigo":838538002,
    "descripcion":"ESTENOSIS DE VÁLVULA PULMONAR LEVE"
  },
  {
    "codigo":445322004,
    "descripcion":"VARIANTE DE MIGRAÑA CON CEFALEA"
  },
  {
    "codigo":1297290006,
    "descripcion":"DETENCIÓN DE CRECIMIENTO EPIFISARIO DE ANTEBRAZO"
  },
  {
    "codigo":248714006,
    "descripcion":"SOPLO AÓRTICO ABDOMINAL"
  },
  {
    "codigo":707466008,
    "descripcion":"CARCINOMA QUÍSTICO ADENOIDE PRIMARIO DE PULMÓN"
  },
  {
    "codigo":281482009,
    "descripcion":"DEFORMIDAD VARA ADQUIRIDA DE ARTICULACIÓN DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":1197151003,
    "descripcion":"ATROFIA ÓPTICA AUTOSÓMICA RECESIVA AISLADA"
  },
  {
    "codigo":443487006,
    "descripcion":"LINFOMA DE CÉLULAS DEL MANTO"
  },
  {
    "codigo":246879008,
    "descripcion":"QUISTE DE CONJUNTIVA BULBAR"
  },
  {
    "codigo":310580002,
    "descripcion":"PRUEBA DE SANGRE PARA CRIBADO DE SÍNDROME DE DOWN: ANORMAL"
  },
  {
    "codigo":212276004,
    "descripcion":"LESIÓN ABIERTA DE NERVIO MUSCULOCUTÁNEO"
  },
  {
    "codigo":48436005,
    "descripcion":"DEFECTO DE ARTICULACIÓN DEL HABLA DEBIDO A PÉRDIDA DE AUDICIÓN CONDUCTIVA"
  },
  {
    "codigo":277812008,
    "descripcion":"ELASTOMA JUVENIL"
  },
  {
    "codigo":767497003,
    "descripcion":"METAHEMOGLOBINEMIA CONGÉNITA AUTOSÓMICA RECESIVA"
  },
  {
    "codigo":1259017004,
    "descripcion":"DEPENDENCIA DE SUSTANCIA DURANTE PUERPERIO"
  },
  {
    "codigo":79369007,
    "descripcion":"COMPLICACIÓN DEL PÁNCREAS TRASPLANTADO"
  },
  {
    "codigo":210441009,
    "descripcion":"HERIDA ABIERTA DE LABIO MENOR VULVAR"
  },
  {
    "codigo":274142002,
    "descripcion":"CONTRACTURA DE DUPUYTREN DE DEDO DE MANO"
  },
  {
    "codigo":896734005,
    "descripcion":"FORMA DE CONO ANORMAL CONGÉNITA DE EPÍFISIS DE FALANGE DE DEDO DE MANO"
  },
  {
    "codigo":470750006,
    "descripcion":"FALLA DE CRECIMIENTO DE VENTRÍCULO CARDÍACO DERECHO FETAL"
  },
  {
    "codigo":372446006,
    "descripcion":"MARGEN DISTAL DE RESECCIÓN QUIRÚRGICA ANAL, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":110302009,
    "descripcion":"DIENTES APRETADOS"
  },
  {
    "codigo":763827002,
    "descripcion":"EPILEPSIA INDUCIDA POR ORGASMO"
  },
  {
    "codigo":15954061000119100,
    "descripcion":"HEMATOMA NO TRAUMÁTICO DE MAMA IZQUIERDA"
  },
  {
    "codigo":1085581000119101,
    "descripcion":"EDENTULISMO COMPLETO DEBIDO A TRAUMATISMO"
  },
  {
    "codigo":15749261000119102,
    "descripcion":"INESTABILIDAD DE ARTICULACIÓN SACROILÍACA IZQUIERDA"
  },
  {
    "codigo":43661000119103,
    "descripcion":"DEFECTO SECTORIAL Y\/O ARQUEADO DE CAMPO VISUAL"
  },
  {
    "codigo":348301000119104,
    "descripcion":"INFILTRADO DE CÓRNEA DE OJO DERECHO POSTERIOR A QUERATOMILEUSIS IN SITU ASISTIDA CON LÁSER DE OJO DERECHO"
  },
  {
    "codigo":335501000119102,
    "descripcion":"DACRIOLITO DE OJO DERECHO"
  },
  {
    "codigo":12239501000119106,
    "descripcion":"GLAUCOMA DE OJO DERECHO"
  },
  {
    "codigo":141000119100,
    "descripcion":"SOMNOLENCIA DIURNA"
  },
  {
    "codigo":15639181000119108,
    "descripcion":"EDEMA DE LA MÁCULA RETINIANA DE OJO IZQUIERDO"
  },
  {
    "codigo":10749581000119100,
    "descripcion":"TRASTORNO DE LA COAGULACIÓN SANGUÍNEA QUE COMPLICA EL NACIMIENTO"
  },
  {
    "codigo":698291007,
    "descripcion":"PARAPLEJÍA AGUDA"
  },
  {
    "codigo":333493901000119105,
    "descripcion":"DIFICULTAD PARA COMPRENDER LA INFORMACIÓN DE SALUD"
  },
  {
    "codigo":237704002,
    "descripcion":"FIBROSIS HIPOFISARIA CON FIBROSIS DE LA LÍNEA MEDIA"
  },
  {
    "codigo":12403341000119108,
    "descripcion":"INESTABILIDAD DE PRÓTESIS DE ARTICULACIÓN DE CADERA DERECHA"
  },
  {
    "codigo":1083021000119105,
    "descripcion":"INFECCIÓN AGUDA DE PABELLÓN AURICULAR DE AMBAS OREJAS"
  },
  {
    "codigo":15974541000119108,
    "descripcion":"LIPOMAS BILATERALES DE MIEMBROS SUPERIORES"
  },
  {
    "codigo":1090701000119108,
    "descripcion":"OTITIS EXTERNA NO INFECCIOSA AGUDA DE CONDUCTO AUDITIVO EXTERNO DERECHO"
  },
  {
    "codigo":301405005,
    "descripcion":"DOLOR A LA PALPACIÓN EN REGIÓN DE HIPOCONDRIO IZQUIERDO"
  },
  {
    "codigo":16238221000119109,
    "descripcion":"TRASTORNO DEPRESIVO CAUSADO POR METANFETAMINA"
  },
  {
    "codigo":1153373007,
    "descripcion":"ARTRITIS GOTOSA MONOARTICULAR CRÓNICA PRIMARIA"
  },
  {
    "codigo":235869004,
    "descripcion":"HEPATITIS B VIRAL CRÓNICA CON HEPATITIS D"
  },
  {
    "codigo":268637002,
    "descripcion":"DISFUNCIÓN PSICOSEXUAL"
  },
  {
    "codigo":102962002,
    "descripcion":"POTENCIAL EVOCADO ANORMAL"
  },
  {
    "codigo":37426002,
    "descripcion":"LARINGITIS ULCEROSA"
  },
  {
    "codigo":299570002,
    "descripcion":"DEFORMIDAD EN VARO DE DEDO DEL PIE"
  },
  {
    "codigo":234034005,
    "descripcion":"DEDO BLANCO INDUCIDO POR VIBRACIÓN"
  },
  {
    "codigo":365106003,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD DE IR AL BAÑO"
  },
  {
    "codigo":1081211000119108,
    "descripcion":"NEUROBLASTOMA OLFATORIO MALIGNO PRIMARIO IZQUIERDO"
  },
  {
    "codigo":1217074008,
    "descripcion":"PSEUDOHERMAFRODITISMO DEBIDO A HIPERPLASIA SUPRARRENAL CONGÉNITA"
  },
  {
    "codigo":166663004,
    "descripcion":"ENZIMAS CARDÍACAS FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":68359008,
    "descripcion":"HEMIVÉRTEBRA CONGÉNITA"
  },
  {
    "codigo":230364000,
    "descripcion":"DEGENERACIÓN NEURONAL PROGRESIVA SIN CIRROSIS HEPÁTICA"
  },
  {
    "codigo":295900000,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE ISOCARBOXAZIDA"
  },
  {
    "codigo":789255009,
    "descripcion":"REACCIÓN ADVERSA A REACTIVADOR DE ACETILCOLINESTERASA"
  },
  {
    "codigo":197596007,
    "descripcion":"SÍNDROME NEFRÓTICO, GLOMERULONEFRITIS PROLIFERATIVA MESANGIAL DIFUSA"
  },
  {
    "codigo":95622006,
    "descripcion":"VIRILISMO FETAL"
  },
  {
    "codigo":718214007,
    "descripcion":"SÍNDROME MITOCONDRIAL DE ENCEFALOMIOPATÍA NEUROGASTROINTESTINAL"
  },
  {
    "codigo":716379000,
    "descripcion":"HÍGADO GRASO AGUDO DEL EMBARAZO"
  },
  {
    "codigo":292230006,
    "descripcion":"REACCIÓN ADVERSA A LA MERCAPTOPURINA"
  },
  {
    "codigo":192091002,
    "descripcion":"AUSENTISMO ESCOLAR INJUSTIFICADO DEL NIÑO SOCIALIZADO"
  },
  {
    "codigo":16019631000119104,
    "descripcion":"SINOVITIS TRANSITORIA BILATERAL DE PIES"
  },
  {
    "codigo":93787005,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE SENO ETMOIDAL"
  },
  {
    "codigo":126555009,
    "descripcion":"NEOPLASIA DE LA COLUMNA VERTEBRAL LUMBAR"
  },
  {
    "codigo":290395009,
    "descripcion":"INTOXICACIÓN POR LOPERAMIDA"
  },
  {
    "codigo":190256007,
    "descripcion":"TIROTOXICOSIS DEBIDA A NÓDULO TIROIDEO ECTÓPICO CON CRISIS TIROIDEA"
  },
  {
    "codigo":91952008,
    "descripcion":"ENFERMEDAD DE LAS AZORES"
  },
  {
    "codigo":90117007,
    "descripcion":"FIBROSIS TUBERCULOSA DEL PULMÓN"
  },
  {
    "codigo":286725008,
    "descripcion":"RASGO DE LA PERSONALIDAD: COOPERACIÓN Y CUMPLIMIENTO - HALLAZGO"
  },
  {
    "codigo":448730001,
    "descripcion":"NEOPLASIA BENIGNA DE PARTES BLANDAS DE ANTEBRAZO"
  },
  {
    "codigo":284890002,
    "descripcion":"SE RASURA"
  },
  {
    "codigo":1236997009,
    "descripcion":"BLEFARITIS ANTERIOR DE PÁRPADO INFERIOR DERECHO CAUSADA POR ESTAFILOCOCOS"
  },
  {
    "codigo":219354006,
    "descripcion":"LESIÓN ACCIDENTAL O DELIBERADA NO DETERMINADA, POR COLOCARSE DELANTE DE UN OBJETO EN MOVIMIENTO"
  },
  {
    "codigo":414127000,
    "descripcion":"ERITROCITOSIS POR POLICITEMIA VERA"
  },
  {
    "codigo":283055000,
    "descripcion":"ABRASIÓN DE PIEL DE CUELLO"
  },
  {
    "codigo":445060000,
    "descripcion":"SE FUE EN CONTRA DEL CONSEJO MÉDICO"
  },
  {
    "codigo":346441000119105,
    "descripcion":"ÚLCERA CORNEAL DE HIPOPIÓN DE AMBOS OJOS"
  },
  {
    "codigo":1231492008,
    "descripcion":"DESVIACIÓN SEVERA DE LÍNEA MEDIA DE ARCO DENTAL MAXILAR HACIA LA IZQUIERDA"
  },
  {
    "codigo":838276009,
    "descripcion":"COMPLEJO DE ESCLEROSIS LATERAL AMIOTRÓFICA, PARKINSONISMO Y DEMENCIA"
  },
  {
    "codigo":1295193002,
    "descripcion":"INTERFERONOPATÍA TIPO I"
  },
  {
    "codigo":246617003,
    "descripcion":"MIRADA FIJA ANTE UNA FUENTE DE LUZ DIFUSA"
  },
  {
    "codigo":19076009,
    "descripcion":"SÍNDROME DEL EDIFICIO ENFERMO"
  },
  {
    "codigo":312153005,
    "descripcion":"INFECCIÓN GASTROINTESTINAL DE ORIGEN MICÓTICO"
  },
  {
    "codigo":770905005,
    "descripcion":"SÍNDROME DE MICRODELECIÓN 7Q11.23 DISTAL"
  },
  {
    "codigo":18761000119108,
    "descripcion":"MONOPLEJÍA DE BRAZO DE LADO DOMINANTE COMO SECUELA DE ENFERMEDAD CEREBROVASCULAR"
  },
  {
    "codigo":1083721000119107,
    "descripcion":"TRASTORNO DE AMBOS OÍDOS EXTERNOS"
  },
  {
    "codigo":703534001,
    "descripcion":"CONDUCTO ARTERIOSO PERMEABLE CON DISMORFISMO FACIAL Y QUINTOS DEDOS ANORMALES"
  },
  {
    "codigo":1196889003,
    "descripcion":"NEOPLASIA EPITELIAL BENIGNA DE INTESTINO DELGADO"
  },
  {
    "codigo":769070007,
    "descripcion":"LEVADURA DETECTADA"
  },
  {
    "codigo":15406009,
    "descripcion":"ABSCESO RETROMAMARIO ASOCIADO CON EL PARTO"
  },
  {
    "codigo":277550009,
    "descripcion":"SÍNDROME DE RICHTER"
  },
  {
    "codigo":1162286009,
    "descripcion":"RABDOMIOSARCOMA PRIMARIO DE FONDO UTERINO"
  },
  {
    "codigo":472323007,
    "descripcion":"MIOCARDIOPATÍA FETAL"
  },
  {
    "codigo":319971000119105,
    "descripcion":"NÓDULO REUMATOIDEO DE TEJIDO CELULAR SUBCUTÁNEO DE RODILLA DERECHA"
  },
  {
    "codigo":860680001,
    "descripcion":"EMBOLIA PULMONAR DEBIDA A EMBARAZO ECTÓPICO Y POSTERIOR A ÉL"
  },
  {
    "codigo":110040004,
    "descripcion":"LACERACIÓN COMPLEJA CONTAMINADA DE MEJILLA"
  },
  {
    "codigo":208344005,
    "descripcion":"FRACTURA EXPUESTA DE LA APÓFISIS ESTILOIDES DEL RADIO"
  },
  {
    "codigo":44504005,
    "descripcion":"FRACTURA EXPUESTA DE HUESO GRANDE DE LA MUÑECA"
  },
  {
    "codigo":765400007,
    "descripcion":"PROBLEMA DE RELACIÓN SEXUAL DEBIDO A CONFUSIÓN RELACIONADA CON LA ORIENTACIÓN SEXUAL"
  },
  {
    "codigo":699864008,
    "descripcion":"HALLAZGO RELACIONADO CON CRESTA ALVEOLAR MAXILAR RESIDUAL"
  },
  {
    "codigo":9901000,
    "descripcion":"HIPERTENSIÓN ESENCIAL QUE COMPLICA EL PUERPERIO Y\/O CONSTITUYE UN MOTIVO DE ATENCIÓN DURANTE ESTE PERÍODO"
  },
  {
    "codigo":1255085007,
    "descripcion":"ADENOCARCINOMA DE TRÁQUEA"
  },
  {
    "codigo":698029007,
    "descripcion":"EXCESO MAXILAR VERTICAL"
  },
  {
    "codigo":403117008,
    "descripcion":"MICETOMA CAUSADO POR LEPTOSPHAERIA SENEGALENSIS"
  },
  {
    "codigo":42669007,
    "descripcion":"HIPONATREMIA CON AUMENTO DE VOLUMEN DEL LÍQUIDO EXTRACELULAR"
  },
  {
    "codigo":8066003,
    "descripcion":"ESTADO CRONOBIOLÓGICO NORMAL"
  },
  {
    "codigo":401282007,
    "descripcion":"ESCALA DE DISNEA DE BORG: 4 - ALGO SEVERA"
  },
  {
    "codigo":366679001,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA MANTENER EL EQUILIBRIO AL ALCANZAR ALGO"
  },
  {
    "codigo":235607002,
    "descripcion":"ESOFAGITIS DE CROHN"
  },
  {
    "codigo":1251415003,
    "descripcion":"TELANGIECTASIA CAUSADA POR FÁRMACO"
  },
  {
    "codigo":301143004,
    "descripcion":"PARED ARTERIAL NORMAL"
  },
  {
    "codigo":233772001,
    "descripcion":"CALCIFICACIÓN PULMONAR SARCOIDE"
  },
  {
    "codigo":364844002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA BAJAR ESCALERAS CORRIENDO"
  },
  {
    "codigo":268375009,
    "descripcion":"MANTOUX: NEGATIVA"
  },
  {
    "codigo":299308007,
    "descripcion":"ARTICULACIÓN DE LA CADERA DOLOROSA AL MOVIMIENTO"
  },
  {
    "codigo":131000112104,
    "descripcion":"BLASTOMYCES DERMATITIDIS O BLASTOMYCES GILCHRISTII"
  },
  {
    "codigo":68097001,
    "descripcion":"DIETA HIPERCALÓRICA"
  },
  {
    "codigo":231937002,
    "descripcion":"QUERATOGLOBO ADQUIRIDO"
  },
  {
    "codigo":235651000112104,
    "descripcion":"LESIÓN ESCAMOSA INTRAEPITELIAL DE BAJO GRADO EN EXTENDIDO VAGINAL DE PAPANICOLAOU CON ÁCIDO DESOXIRRIBONUCLEICO DE PAPILOMAVIRUS HUMANO DETECTADO"
  },
  {
    "codigo":1149441004,
    "descripcion":"PERIODONTITIS LOCALIZADA ESTADIO 2 GRADO B SEGÚN LA CLASIFICACIÓN DE LAS ENFERMEDADES Y ALTERACIONES PERIODONTALES Y PERIIMPLANTARIAS DE 2017 DE LA ACADEMIA ESTADOUNIDENSE DE PERIODONTOLOGÍA Y LA FEDERACIÓN EUROPEA DE PERIODONTOLOGÍA"
  },
  {
    "codigo":363009005,
    "descripcion":"DEFICIENCIA DE UN COMPONENTE DEL COMPLEMENTO"
  },
  {
    "codigo":66262001,
    "descripcion":"ELIPTOCITOSIS HEREDITARIA POR INTERACCIÓN ESPECTRINA - ANQUIRINA BETA"
  },
  {
    "codigo":721622001,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE TERCIO SUPERIOR DE ESÓFAGO"
  },
  {
    "codigo":262870003,
    "descripcion":"HEMATOMA COLÓNICO"
  },
  {
    "codigo":295638003,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE ESTRAMUSTINA"
  },
  {
    "codigo":33494005,
    "descripcion":"TALIPES CALCÁNEO"
  },
  {
    "codigo":293803000,
    "descripcion":"ALERGIA A FENTERMINA"
  },
  {
    "codigo":31659000,
    "descripcion":"INFECCIÓN CAUSADA POR SPIROMETRA LARVAE"
  },
  {
    "codigo":195499003,
    "descripcion":"FÍSTULA DE VASOS LINFÁTICOS"
  },
  {
    "codigo":719787003,
    "descripcion":"PRESCRIPCIÓN DE ATENCIÓN COMPARTIDA DE FÁRMACO PARA LA DEMENCIA"
  },
  {
    "codigo":1086231000119105,
    "descripcion":"PERFORACIÓN DE DUODENO DEBIDA A DIVERTICULITIS"
  },
  {
    "codigo":128128003,
    "descripcion":"TRASTORNO DE LA CORTEZA CEREBRAL"
  },
  {
    "codigo":717952004,
    "descripcion":"HIDRONEFROSIS ADQUIRIDA DEBIDA A OBSTRUCCIÓN DE UNIÓN URETEROPÉLVICA"
  },
  {
    "codigo":95360006,
    "descripcion":"ARDOR EN MEMBRANA MUCOSA"
  },
  {
    "codigo":29824007,
    "descripcion":"INTOXICACIÓN POR ATROPA BELLADONNA"
  },
  {
    "codigo":879957001,
    "descripcion":"LEIOMIOMA UTERINO SOLITARIO"
  },
  {
    "codigo":1142101002,
    "descripcion":"INFECCIÓN PERINATAL ESTAFILOCÓCICA"
  },
  {
    "codigo":15723441000119101,
    "descripcion":"GANGLIÓN BILATERAL DE VAINA TENDINOSA DE MANOS"
  },
  {
    "codigo":716117004,
    "descripcion":"PERIODONTITIS DEBIDA A FACTOR ANATÓMICO DENTAL"
  },
  {
    "codigo":290133008,
    "descripcion":"INTOXICACIÓN CAUSADA POR ANALGÉSICO NO OPIOIDE"
  },
  {
    "codigo":1173034002,
    "descripcion":"DEFECTO COMBINADO DE LA FOSFORILACIÓN OXIDATIVA TIPO 26"
  },
  {
    "codigo":124458005,
    "descripcion":"DEFICIENCIA DE DEXTRANASA"
  },
  {
    "codigo":450303000,
    "descripcion":"DERRAME PERICÁRDICO CONGÉNITO"
  },
  {
    "codigo":286463001,
    "descripcion":"DIFICULTAD PARA LAVAR LOS ALIMENTOS"
  },
  {
    "codigo":322481000119104,
    "descripcion":"ESCOLIOSIS TORACÓGENA DORSOLUMBAR"
  },
  {
    "codigo":253695008,
    "descripcion":"ANOMALÍA DE RAMA DEL CAYADO AÓRTICO"
  },
  {
    "codigo":22484001,
    "descripcion":"ESTIMULACIÓN ORAL DEL CLÍTORIS"
  },
  {
    "codigo":284628003,
    "descripcion":"DAR TOPETAZOS CON LA CABEZA A OTRA PERSONA"
  },
  {
    "codigo":448468003,
    "descripcion":"LINFOMA NO HODGKIN DIFUSO DE CAVIDAD BUCAL"
  },
  {
    "codigo":1169364005,
    "descripcion":"OSTEOPOROSIS PRIMARIA ASOCIADA A PROTEÍNA RELACIONADA CON EL RECEPTOR DE LIPOPROTEÍNA DE BAJA DENSIDAD 5"
  },
  {
    "codigo":118953000,
    "descripcion":"HALLAZGO ÓSEO"
  },
  {
    "codigo":315561001,
    "descripcion":"NACIDO EN SAMOA OCCIDENTAL"
  },
  {
    "codigo":446633003,
    "descripcion":"VALVA DE VÁLVULA TRICÚSPIDE ENGROSADA"
  },
  {
    "codigo":53417006,
    "descripcion":"TRASTORNO DE CARTÍLAGO ARTICULAR"
  },
  {
    "codigo":282793008,
    "descripcion":"LESIÓN TRAUMÁTICA GANGLIONAR SIMPÁTICA"
  },
  {
    "codigo":117118008,
    "descripcion":"SOPLO CARDÍACO, IMPURO"
  },
  {
    "codigo":16979000,
    "descripcion":"CUELLO FEMORAL VALGO ADQUIRIDO"
  },
  {
    "codigo":248190008,
    "descripcion":"CARA DE ASPECTO ENFERMIZO"
  },
  {
    "codigo":132171000119104,
    "descripcion":"TROMBOSIS VENOSA PROFUNDA CRÓNICA DE MUSLO"
  },
  {
    "codigo":770643005,
    "descripcion":"EPILEPSIA DEL LÓBULO TEMPORAL MESIAL CON ESCLEROSIS DEL HIPOCAMPO"
  },
  {
    "codigo":49747005,
    "descripcion":"FRACTURA NO EXPUESTA DE VÉRTEBRA LUMBAR CON LESIÓN TRAUMÁTICA DE MÉDULA ESPINAL"
  },
  {
    "codigo":311891006,
    "descripcion":"APLASTAMIENTO OSTEOPORÓTICO DE VÉRTEBRA DORSAL"
  },
  {
    "codigo":1260328002,
    "descripcion":"DEPÓSITO EN MÚLTIPLES SISTEMAS DE PROTEÍNA TAU FAMILIAR"
  },
  {
    "codigo":703272007,
    "descripcion":"INSUFICIENCIA CARDÍACA CON FRACCIÓN DE EYECCIÓN DISMINUIDA"
  },
  {
    "codigo":275453008,
    "descripcion":"CUERPO EXTRAÑO EN DEDO DE LA MANO"
  },
  {
    "codigo":765138001,
    "descripcion":"DEFECTO DE NACIMIENTO DEBIDO A HIPERTERMIA MATERNA"
  },
  {
    "codigo":111613008,
    "descripcion":"LESIÓN TRAUMÁTICA INTRACRANEAL CONCOMITANTE CON FRACTURA DE CRÁNEO CERRADA"
  },
  {
    "codigo":679141000119102,
    "descripcion":"EROSIÓN CORNEAL BILATERAL"
  },
  {
    "codigo":404690004,
    "descripcion":"PARÁLISIS DE RAMA SUPERIOR DEL TRIGÉMINO"
  },
  {
    "codigo":109778006,
    "descripcion":"AFTA DE BEDNAR"
  },
  {
    "codigo":271783006,
    "descripcion":"SEMICONSCIENTE"
  },
  {
    "codigo":239015008,
    "descripcion":"DISPLASIA ECTODÉRMICA CON DEFECTOS DEL PELO-DIENTES-UÑAS"
  },
  {
    "codigo":402855009,
    "descripcion":"VASCULITIS URTICARIANA NO COMPLEMENTÉMICA"
  },
  {
    "codigo":73340005,
    "descripcion":"INTOXICACIÓN POR CICLOFOSFAMIDA"
  },
  {
    "codigo":366417000,
    "descripcion":"AMPLITUD DEL MOVIMIENTO ACTIVO DE FLEXIÓN LATERAL HACIA LA IZQUIERDA DE LA COLUMNA DORSAL - HALLAZGO"
  },
  {
    "codigo":431953002,
    "descripcion":"RECHAZO CRÓNICO DE TRASPLANTE DE MÉDULA ÓSEA"
  },
  {
    "codigo":300881002,
    "descripcion":"TUMEFACCIÓN DE ESTRUCTURA UROLÓGICA"
  },
  {
    "codigo":202577004,
    "descripcion":"OSTEOCONDROMATOSIS SINOVIAL DE ARTICULACIÓN ACROMIOCLAVICULAR"
  },
  {
    "codigo":10837221000119107,
    "descripcion":"FRACTURA EXPUESTA DE SEGUNDO HUESO METACARPIANO DE MANO IZQUIERDA"
  },
  {
    "codigo":5969009,
    "descripcion":"DIABETES MELLITUS ASOCIADA CON SÍNDROMES GENÉTICOS"
  },
  {
    "codigo":36902003,
    "descripcion":"FÍSTULA DE LA APÓFISIS MASTOIDEA"
  },
  {
    "codigo":1088741000119109,
    "descripcion":"TRASTORNO DE TROMPA DE EUSTAQUIO IZQUIERDA"
  },
  {
    "codigo":725030006,
    "descripcion":"SÍNDROME DE ESCAFOCEFALIA FAMILIAR TIPO MCGILLIVRAY"
  },
  {
    "codigo":264443002,
    "descripcion":"CATARATA DE MORGAGNI"
  },
  {
    "codigo":295376000,
    "descripcion":"SOBREDOSIS DE LANSOPRAZOL"
  },
  {
    "codigo":721360001,
    "descripcion":"LUXACIÓN TRAUMÁTICA DE SÉPTIMA VÉRTEBRA CERVICAL Y PRIMERA VÉRTEBRA DORSAL"
  },
  {
    "codigo":262608007,
    "descripcion":"CUERPO EXTRAÑO EN CARDIAS"
  },
  {
    "codigo":1145509001,
    "descripcion":"HIPOPLASIA CONGÉNITA DE FALANGE PROXIMAL DE DEDO PULGAR"
  },
  {
    "codigo":162469005,
    "descripcion":"SÍNTOMA MODERADO"
  },
  {
    "codigo":129701007,
    "descripcion":"CON MAYOR RIESGO DE SUFRIMIENTO ESPIRITUAL"
  },
  {
    "codigo":64165008,
    "descripcion":"TRASTORNO DE EVITACIÓN EN LA NIÑEZ"
  },
  {
    "codigo":422778001,
    "descripcion":"MENISCO LAGRIMAL ALTO"
  },
  {
    "codigo":95098003,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE PARTES BLANDAS DEL CUELLO"
  },
  {
    "codigo":62330004,
    "descripcion":"FUNCIÓN MUSCULAR DISMINUIDA"
  },
  {
    "codigo":191567000,
    "descripcion":"ESQUIZOFRENIA ESQUIZOAFECTIVA"
  },
  {
    "codigo":160634009,
    "descripcion":"ATLETA DE COMPETICIÓN"
  },
  {
    "codigo":224335005,
    "descripcion":"AYUDA A LA POLICÍA EN SUS INVESTIGACIONES"
  },
  {
    "codigo":1141839006,
    "descripcion":"INFILTRACIÓN EOSINOFÍLICA DE DERMIS"
  },
  {
    "codigo":289871008,
    "descripcion":"HALLAZGO RELACIONADO CON LA HUMEDAD DEL PERINEO FEMENINO"
  },
  {
    "codigo":91428005,
    "descripcion":"INFECCIÓN POR HAEMOPHILUS INFLUENZAE"
  },
  {
    "codigo":58660009,
    "descripcion":"MANO CONTRAHECHA ADQUIRIDA"
  },
  {
    "codigo":286201004,
    "descripcion":"ABRE LA CASA UNA VEZ CERRADA"
  },
  {
    "codigo":24057006,
    "descripcion":"AFASIA COMBINADA"
  },
  {
    "codigo":253433007,
    "descripcion":"INSUFICIENCIA DE VÁLVULA AURICULOVENTRICULAR COMÚN"
  },
  {
    "codigo":681651000119102,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE COLON DESCENDENTE"
  },
  {
    "codigo":54990006,
    "descripcion":"INTOXICACIÓN POR SOLANUM"
  },
  {
    "codigo":249763000,
    "descripcion":"CALCINOSIS DE LOS DEDOS DE LA MANO"
  },
  {
    "codigo":184227003,
    "descripcion":"CONVOCATORIA\/RECONVOCATORIA POR COMPUTADORA"
  },
  {
    "codigo":1003427004,
    "descripcion":"GENOCONDROMATOSIS TIPO 1"
  },
  {
    "codigo":708515003,
    "descripcion":"OBSTRUCCIÓN ADQUIRIDA DE LA VÍA URINARIA"
  },
  {
    "codigo":282531006,
    "descripcion":"INCAPAZ DE BAJAR ESCALERAS CORRIENDO"
  },
  {
    "codigo":413603009,
    "descripcion":"ANEMIA HEMOLÍTICA AUTOINMUNITARIA"
  },
  {
    "codigo":1362040004,
    "descripcion":"ATRAPAMIENTO DE MÚSCULO OBLICUO SUPERIOR"
  },
  {
    "codigo":247928006,
    "descripcion":"MOVIMIENTOS TORSIONALES COMPLEJOS REPETITIVOS DE LOS DEDOS DE LAS MANOS"
  },
  {
    "codigo":737613000,
    "descripcion":"CONSCIENCIA ACCIDENTAL BAJO ANESTESIA GENERAL DURANTE INDUCCIÓN O INTUBACIÓN"
  },
  {
    "codigo":442701004,
    "descripcion":"ATEROSCLEROSIS DE INJERTO-PUENTE BIOLÓGICO, NO AUTÓLOGO, DE MIEMBRO"
  },
  {
    "codigo":213325008,
    "descripcion":"URTICARIA CAUSADA POR SUERO"
  },
  {
    "codigo":703010001,
    "descripcion":"ESCHERICHIA COLI O HAFNIA ALVEI"
  },
  {
    "codigo":309794002,
    "descripcion":"HALLAZGO RELACIONADO CON SUSTANCIAS CORPORALES"
  },
  {
    "codigo":735778006,
    "descripcion":"LACERACIÓN DE PELVIS CON CUERPO EXTRAÑO"
  },
  {
    "codigo":47650006,
    "descripcion":"REACCIÓN DE INJERTO VERSUS HUÉSPED"
  },
  {
    "codigo":1260066008,
    "descripcion":"ADENOCARCINOMA PAPILAR DE TRÁQUEA"
  },
  {
    "codigo":45815001,
    "descripcion":"HERNIA DE BÉCLARD"
  },
  {
    "codigo":440866009,
    "descripcion":"ENFERMEDAD GRAVE POR DEFICIENCIA HEREDITARIA DE FACTOR IX CON INHIBIDORES"
  },
  {
    "codigo":13047001,
    "descripcion":"FRACTURA EXPUESTA DE LA BASE DE HUESO METACARPIANO, DIFERENTE AL PRIMER METACARPIANO"
  },
  {
    "codigo":733943001,
    "descripcion":"CARIES DENTAL ACTIVA PRIMARIA QUE SE EXTIENDE HASTA EL TERCIO INTERNO DE LA DENTINA"
  },
  {
    "codigo":766711009,
    "descripcion":"HIPEROSTOSIS ESTERNOCOSTOCLAVICULAR AISLADA"
  },
  {
    "codigo":1354700003,
    "descripcion":"RAQUITISMO DEBIDO A PREMATUREZ"
  },
  {
    "codigo":109516004,
    "descripcion":"MACROGENIA"
  },
  {
    "codigo":238753004,
    "descripcion":"TRASTORNO DE GLÁNDULA APOCRINA"
  },
  {
    "codigo":9377008,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN LA REGIÓN DEL ANTEBRAZO, SIN INFECCIÓN"
  },
  {
    "codigo":235083001,
    "descripcion":"ASIMETRÍA DE MAXILAR SUPERIOR"
  },
  {
    "codigo":366155002,
    "descripcion":"VELOCIDAD DE FLUJO PICO - HALLAZGO"
  },
  {
    "codigo":202315004,
    "descripcion":"ANQUILOSIS DE ARTICULACIÓN INTERFALÁNGICA DISTAL"
  },
  {
    "codigo":167712000,
    "descripcion":"PRESIÓN DE LÍQUIDO CEFALORRAQUÍDEO: NORMAL"
  },
  {
    "codigo":69408002,
    "descripcion":"SÍNDROME DE GORLIN"
  },
  {
    "codigo":298784004,
    "descripcion":"SIN AMPLITUD PASIVA DE FLEXIÓN DE HOMBRO"
  },
  {
    "codigo":788469001,
    "descripcion":"TRASTORNO REPETITIVO DEL MOVIMIENTO DEL ANTEBRAZO DERECHO"
  },
  {
    "codigo":67573002,
    "descripcion":"QUEMADURA DE SITIOS MÚLTIPLES DE LA EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":722933003,
    "descripcion":"VÓMITO BILIOSO DEL RECIÉN NACIDO"
  },
  {
    "codigo":296949004,
    "descripcion":"SOBREDOSIS DE VITAMINA A"
  },
  {
    "codigo":1343690000,
    "descripcion":"ALTERACIÓN CRÓNICA DE ASTA POSTERIOR DE MENISCO EXTERNO DE RODILLA IZQUIERDA"
  },
  {
    "codigo":295114001,
    "descripcion":"ALERGIA A HIALURONIDASA"
  },
  {
    "codigo":63903007,
    "descripcion":"LESIÓN INCOMPLETA DE LA MÉDULA ESPINAL A NIVEL DE T7 - T12 SIN LESIÓN TRAUMÁTICA ÓSEA"
  },
  {
    "codigo":293279008,
    "descripcion":"REACCIÓN ADVERSA A LA BUSERELINA"
  },
  {
    "codigo":291444004,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR CLOROQUINA"
  },
  {
    "codigo":782964007,
    "descripcion":"ENFERMEDAD GENÉTICA"
  },
  {
    "codigo":715593000,
    "descripcion":"INFECCIÓN DE CAVIDAD NASAL CAUSADA POR CANDIDA"
  },
  {
    "codigo":781129002,
    "descripcion":"PUNCIÓN ACCIDENTAL DE DURAMADRE DURANTE LA ANESTESIA"
  },
  {
    "codigo":1010505002,
    "descripcion":"ESCLEROSIS DE EPÍFISIS DE FALANGE DE DEDO ÍNDICE CON RADIOPACIDAD AUMENTADA"
  },
  {
    "codigo":93001004,
    "descripcion":"ANOMALÍA CONGÉNITA DE EPIDÍDIMO"
  },
  {
    "codigo":58398000,
    "descripcion":"DERMATITIS DE LA UNIÓN DERMOEPIDÉRMICA"
  },
  {
    "codigo":330011000119102,
    "descripcion":"EDEMA CEREBRAL NO TRAUMÁTICO"
  },
  {
    "codigo":289609008,
    "descripcion":"VAGINA NORMAL"
  },
  {
    "codigo":255006004,
    "descripcion":"NEVO DE CONJUNTIVA"
  },
  {
    "codigo":1172510008,
    "descripcion":"NOREPINEFRINA DENTRO DE RANGO DE REFERENCIA"
  },
  {
    "codigo":1303582008,
    "descripcion":"SÍNDROME DE AFAQUIA, IRIS HIPOPLÁSICO, MICROFTALMÍA Y MICROCÓRNEA CONGÉNITA"
  },
  {
    "codigo":23795000,
    "descripcion":"SOPLO PRESISTÓLICO"
  },
  {
    "codigo":123934009,
    "descripcion":"INTOXICACIÓN POR PINACEAE"
  },
  {
    "codigo":187635002,
    "descripcion":"NEOPLASIA MALIGNA DE LA LÍNEA MEDIA DE LA LENGUA"
  },
  {
    "codigo":285939006,
    "descripcion":"DIFICULTAD PARA VACIAR EL LAVABO"
  },
  {
    "codigo":253171007,
    "descripcion":"DISGENESIA DEL CEREBELO"
  },
  {
    "codigo":415176004,
    "descripcion":"GLAUCOMA CONGÉNITO PRIMARIO"
  },
  {
    "codigo":710088005,
    "descripcion":"MALA OCLUSIÓN DE CÚSPIDES CLASE I"
  },
  {
    "codigo":218568007,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR FÁRMACOS FIBRINOLÍTICOS"
  },
  {
    "codigo":413341007,
    "descripcion":"BRADICARDIA NEONATAL"
  },
  {
    "codigo":1263474000,
    "descripcion":"NEOPLASIA MALIGNA DE PARTES BLANDAS DE AXILA"
  },
  {
    "codigo":247666006,
    "descripcion":"HALLADO VAGABUNDEANDO POR LAS CALLES"
  },
  {
    "codigo":81991000,
    "descripcion":"INTOXICACIÓN POR DEXTROMETORFANO"
  },
  {
    "codigo":1228871002,
    "descripcion":"SÍNDROME DE NEURODEGENERACIÓN PROGRESIVA CON FOTOSENSIBILIDAD ASOCIADO AL GEN PCNA"
  },
  {
    "codigo":49223002,
    "descripcion":"INTOXICACIÓN POR ZIERIA ARBORESCENS"
  },
  {
    "codigo":1359943002,
    "descripcion":"BACTERIAS EN ACÚMULOS"
  },
  {
    "codigo":409671005,
    "descripcion":"SÍNDROME DE SHOCK POR DENGUE"
  },
  {
    "codigo":278599006,
    "descripcion":"CORONA DENTAL QUE FILTRA"
  },
  {
    "codigo":737351007,
    "descripcion":"DIFICULTAD CON LAS TAREAS DOMÉSTICAS"
  },
  {
    "codigo":303541000119105,
    "descripcion":"DEPÓSITO DE CALCIO EN BOLSA SEROSA DE CADERA DERECHA"
  },
  {
    "codigo":442439008,
    "descripcion":"ATEROSCLEROSIS DE INJERTO-PUENTE DE MIEMBRO"
  },
  {
    "codigo":1259804001,
    "descripcion":"CORDOMA PRIMARIO DE COLUMNA VERTEBRAL"
  },
  {
    "codigo":309532004,
    "descripcion":"MASA EN LA ESPALDA"
  },
  {
    "codigo":735516004,
    "descripcion":"INFECCIÓN DE SISTEMA GENITOURINARIO CAUSADA POR NEISSERIA GONORRHOEAE"
  },
  {
    "codigo":274929001,
    "descripcion":"EFECTOS DE LA EXPOSICIÓN EXCESIVA A RADIACIÓN ELECTROMAGNÉTICA"
  },
  {
    "codigo":473372009,
    "descripcion":"CALCIFICACIÓN DE VÁLVULA MITRAL"
  },
  {
    "codigo":12237391000119101,
    "descripcion":"ANEURISMA DE ARTERIA DE MIEMBRO INFERIOR DERECHO"
  },
  {
    "codigo":307697007,
    "descripcion":"MOVIMIENTOS OCULARES ESPONTÁNEOS ASOCIADOS CON PÉRDIDA VISUAL MONOCULAR"
  },
  {
    "codigo":109254000,
    "descripcion":"ERUPCIÓN LIQUENOIDE MEDICAMENTOSA"
  },
  {
    "codigo":10950002,
    "descripcion":"HEMATOMA VULVAR DURANTE EL PARTO"
  },
  {
    "codigo":830150003,
    "descripcion":"MELANOMA MALIGNO CON MUTACIÓN DEL PROTO-ONCOGÉN B-RAF, SERINA\/TREONINA CINASA V600E"
  },
  {
    "codigo":305862008,
    "descripcion":"VISTO EN EL SERVICIO DEL HABLA Y DEL LENGUAJE"
  },
  {
    "codigo":238491003,
    "descripcion":"LESIÓN DE PIEL POR YESO DE PARÍS"
  },
  {
    "codigo":9115004,
    "descripcion":"PELO ENCARNADO"
  },
  {
    "codigo":402331005,
    "descripcion":"APARICIÓN DE PSORIASIS EN LA INFANCIA (1-10 AÑOS)"
  },
  {
    "codigo":1287067006,
    "descripcion":"HEMORRAGIA INTRAVENTRICULAR NO TRAUMÁTICA GRADO 3 DURANTE PERÍODO NEONATAL"
  },
  {
    "codigo":236656006,
    "descripcion":"DISINERGIA DEL MÚSCULO DETRUSOR URINARIO Y DE CUELLO VESICAL"
  },
  {
    "codigo":300357002,
    "descripcion":"HALLAZGO RELACIONADO CON EL PÁNCREAS"
  },
  {
    "codigo":10680911000119107,
    "descripcion":"NÓDULO DE PIEL DE PIE DERECHO"
  },
  {
    "codigo":365893004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA RECORDAR EL DÍA DE LA SEMANA"
  },
  {
    "codigo":890181005,
    "descripcion":"PODOCONIOSIS"
  },
  {
    "codigo":1119557006,
    "descripcion":"VÉRTICE DE NARIZ PROMINENTE"
  },
  {
    "codigo":298522000,
    "descripcion":"SIN AMPLITUD DE EXTENSIÓN ACTIVA DE LA COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":726341009,
    "descripcion":"TRISOMÍA PARCIAL DE CROMOSOMA 3"
  },
  {
    "codigo":332521000119102,
    "descripcion":"DESPRENDIMIENTO DE RETINA DE OJO DERECHO DEBIDO A DESGARRO DE RETINA"
  },
  {
    "codigo":167450007,
    "descripcion":"PROTEÍNAS EN ORINA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":724506009,
    "descripcion":"APNEA CENTRAL DEL SUEÑO CONCOMITANTE CON RESPIRACIÓN DE CHEYNE-STOKES"
  },
  {
    "codigo":394991004,
    "descripcion":"EXACERBACIÓN DE ARTROSIS"
  },
  {
    "codigo":34543006,
    "descripcion":"CERVICITIS CRÓNICA CON EROSIÓN"
  },
  {
    "codigo":196548000,
    "descripcion":"QUISTE EPIDERMOIDE DE LA BOCA"
  },
  {
    "codigo":1148655008,
    "descripcion":"INTOXICACIÓN CAUSADA POR HORMONA PARATIROIDEA Y\/O DERIVADO DE HORMONA PARATIROIDEA"
  },
  {
    "codigo":722671009,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE MENINGES"
  },
  {
    "codigo":360388005,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE ARTICULACIÓN DE DEDO DE LA MANO"
  },
  {
    "codigo":131012005,
    "descripcion":"NIVEL DE CORTICOTROFINA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":65476007,
    "descripcion":"TAMAÑO ANORMAL"
  },
  {
    "codigo":30873000,
    "descripcion":"FÍSTULA ESOFÁGICA"
  },
  {
    "codigo":260249006,
    "descripcion":"J10"
  },
  {
    "codigo":293017008,
    "descripcion":"REACCIÓN ADVERSA A LA CEFPIROMA"
  },
  {
    "codigo":2111000221105,
    "descripcion":"ENVENENAMIENTO POR PHONEUTRIA"
  },
  {
    "codigo":127342003,
    "descripcion":"TRASTORNO AGUDO DE LOS ÓRGANOS GENITALES MASCULINOS"
  },
  {
    "codigo":94574005,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE PIEL DE DEDO DE PIE"
  },
  {
    "codigo":59971000,
    "descripcion":"DETERMINACIÓN DEL RESULTADO: INSATISFACTORIO PARA EL PACIENTE"
  },
  {
    "codigo":27203001,
    "descripcion":"PERISTALTISMO DIGESTIVO DISMINUIDO"
  },
  {
    "codigo":61806008,
    "descripcion":"INTOXICACIÓN POR PHYLLANTHUS ABNORMIS"
  },
  {
    "codigo":225646008,
    "descripcion":"MIEDO A PERDER EL CONTROL DE ESFÍNTERES EN PÚBLICO"
  },
  {
    "codigo":92739005,
    "descripcion":"CARCINOMA IN SITU DE LA PIEL DEL HUECO POPLÍTEO"
  },
  {
    "codigo":123672002,
    "descripcion":"BAROTRAUMA PULMONAR"
  },
  {
    "codigo":58136006,
    "descripcion":"TRASTORNO NUTRICIONAL POR DESEQUILIBRIO CALCIO - FÓSFORO"
  },
  {
    "codigo":254744006,
    "descripcion":"PÁPULAS FIBROSAS DE LA CARA"
  },
  {
    "codigo":713496008,
    "descripcion":"ANEMIA CAUSADA POR ZIDOVUDINA"
  },
  {
    "codigo":1336088009,
    "descripcion":"OSTEOCONDROPATÍA DE MANO"
  },
  {
    "codigo":1268717002,
    "descripcion":"OLIGODENDROGLIOMA PRIMARIO"
  },
  {
    "codigo":89069006,
    "descripcion":"HABITUACIÓN VULVOCLITORÍDEA"
  },
  {
    "codigo":283842002,
    "descripcion":"LESIÓN POR DESOLLAMIENTO DE LA CABEZA"
  },
  {
    "codigo":21698002,
    "descripcion":"FRACTURA EXPUESTA DE FALANGE DE DEDO DE LA MANO"
  },
  {
    "codigo":10847261000119103,
    "descripcion":"HERIDA ABIERTA DE PIE IZQUIERDO DEBIDA A MORDEDURA DE PERRO"
  },
  {
    "codigo":447682005,
    "descripcion":"DISCONTINUIDAD ENTRE VÁLVULA AÓRTICA Y VÁLVULA MITRAL"
  },
  {
    "codigo":85399000,
    "descripcion":"GRANULOPOYESIS INEFICAZ"
  },
  {
    "codigo":314775002,
    "descripcion":"VISTO POR TÉCNICO ESPECIALISTA EN MARCAPASOS CARDÍACOS"
  },
  {
    "codigo":282007005,
    "descripcion":"LESIÓN GASTROINTESTINAL Y DIGESTIVA"
  },
  {
    "codigo":413079006,
    "descripcion":"PCR PARA CHLAMYDIA POSITIVA"
  },
  {
    "codigo":249239007,
    "descripcion":"AUSENCIA DE TESTÍCULO EN ESCROTO"
  },
  {
    "codigo":1197676001,
    "descripcion":"DUODENITIS POR ENFERMEDAD CELÍACA"
  },
  {
    "codigo":18028001,
    "descripcion":"COLANGITIS SECUNDARIA"
  },
  {
    "codigo":216471009,
    "descripcion":"INTOXICACIÓN ACCIDENTAL CAUSADA POR SALICILATOS"
  },
  {
    "codigo":247404004,
    "descripcion":"ALODINIA"
  },
  {
    "codigo":312940006,
    "descripcion":"RETINOPATÍA ASOCIADA CON CARCINOMA"
  },
  {
    "codigo":1163073003,
    "descripcion":"ENCEFALITIS POR VIRUS SINCICIAL RESPIRATORIO HUMANO"
  },
  {
    "codigo":10656951000119102,
    "descripcion":"ÚLCERA NEUROPÁTICA DE PIE DERECHO"
  },
  {
    "codigo":1259542001,
    "descripcion":"EXTRAVASACIÓN DE LÍQUIDO CEFALORRAQUÍDEO CRANEAL DEBIDA A HIDROCEFALIA"
  },
  {
    "codigo":442177008,
    "descripcion":"INFECCIÓN CAUSADA POR VIRUS HERPES HUMANO 6"
  },
  {
    "codigo":210966003,
    "descripcion":"SECUELAS POR LESIÓN OCASIONADA POR APLASTAMIENTO Y AMPUTACIÓN TRAUMÁTICA DE MIEMBRO INFERIOR"
  },
  {
    "codigo":274667000,
    "descripcion":"DOLOR MANDIBULAR"
  },
  {
    "codigo":241899001,
    "descripcion":"EFECTO TÓXICO CAUSADO POR PRODUCTO NUTRITIVO PARA FLORES"
  },
  {
    "codigo":372971000,
    "descripcion":"INFECCIÓN CAUSADA POR PENICILLIUM VIRIDICATUM"
  },
  {
    "codigo":209131003,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN COSTOVERTEBRAL"
  },
  {
    "codigo":471275004,
    "descripcion":"COMUNICACIÓN INTERAURICULAR CONSTRUIDA QUIRÚRGICAMENTE"
  },
  {
    "codigo":897259005,
    "descripcion":"CURVATURA ANORMAL DE FALANGE PROXIMAL DE DEDO PULGAR"
  },
  {
    "codigo":733419006,
    "descripcion":"SÍNDROME DE DISOSTOSIS METAFISARIA, DISCAPACIDAD INTELECTUAL Y SORDERA DE CONDUCCIÓN"
  },
  {
    "codigo":1290475006,
    "descripcion":"RADIOGRAFÍA DE DEDO DE MANO ANORMAL"
  },
  {
    "codigo":76224000,
    "descripcion":"NEFROSIS HEMOGLOBINÚRICA"
  },
  {
    "codigo":438507006,
    "descripcion":"EL NIÑO VIVE CON ADULTO NO EMPARENTADO"
  },
  {
    "codigo":305600000,
    "descripcion":"BAJO ATENCIÓN DE PODÓLOGO EXTRAHOSPITALARIO"
  },
  {
    "codigo":371136004,
    "descripcion":"TRASTORNO DEL DESARROLLO DENTARIO"
  },
  {
    "codigo":698816006,
    "descripcion":"OCLUSIÓN CRÓNICA DE ARTERIA DE EXTREMIDAD"
  },
  {
    "codigo":240064008,
    "descripcion":"DISTROFIA MUSCULAR TIPO HUTTERITE"
  },
  {
    "codigo":403904009,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS VERRUGOSO"
  },
  {
    "codigo":308561000119101,
    "descripcion":"SINDACTILIA DE DEDOS DE LOS PIES BILATERAL"
  },
  {
    "codigo":1286805006,
    "descripcion":"TRASTORNO FETAL DEBIDO A PARTO PRECIPITADO"
  },
  {
    "codigo":205461008,
    "descripcion":"ESTERNÓN DEFORMADO"
  },
  {
    "codigo":762517008,
    "descripcion":"DISFUNCIÓN SEXUAL CAUSADA POR CATINONA SINTÉTICA"
  },
  {
    "codigo":301930000,
    "descripcion":"PATRÓN DE TINCIÓN DE EPITELIO CORNEAL COMPLETO"
  },
  {
    "codigo":236394003,
    "descripcion":"GLOMERULONEFRITIS ENDOCAPILAR IDIOPÁTICA"
  },
  {
    "codigo":367466007,
    "descripcion":"IRRITACIÓN CUTÁNEA"
  },
  {
    "codigo":365631001,
    "descripcion":"RECUENTO DE MONOCITOS - HALLAZGO"
  },
  {
    "codigo":1119295002,
    "descripcion":"CEFALEA UNILATERAL DEL LADO DERECHO"
  },
  {
    "codigo":300095003,
    "descripcion":"PABELLÓN AURICULAR DE FORMA NORMAL"
  },
  {
    "codigo":15709521000119104,
    "descripcion":"HIPOPIGMENTACIÓN DE PÁRPADO INFERIOR IZQUIERDO Y DE ÁREA PERIOCULAR IZQUIERDA"
  },
  {
    "codigo":726079008,
    "descripcion":"HIPERCAROTINEMIA Y DEFICIENCIA DE VITAMINA A HEREDITARIA"
  },
  {
    "codigo":201791009,
    "descripcion":"EXACERBACIÓN DE ARTRITIS REUMATOIDE"
  },
  {
    "codigo":234559009,
    "descripcion":"DEFICIENCIA DE ANTICUERPO ANTIPOLISACÁRIDO NEUMOCÓCICO"
  },
  {
    "codigo":396564006,
    "descripcion":"PIGMENTACIÓN TUMORAL, NO SE PUEDE DETERMINAR"
  },
  {
    "codigo":47923004,
    "descripcion":"INTOXICACIÓN POR PRIMIDONA"
  },
  {
    "codigo":298260008,
    "descripcion":"DISCRIMINACIÓN ESTÁTICA DE DOS PUNTOS PRESENTE"
  },
  {
    "codigo":67049004,
    "descripcion":"RAQUITISMO DEPENDIENTE DE VITAMINA D TIPO 1"
  },
  {
    "codigo":296425007,
    "descripcion":"SOBREDOSIS DE TONZILAMINA"
  },
  {
    "codigo":720574003,
    "descripcion":"BRAQUITELEFALANGIA, DISMORFISMO FACIAL Y SÍNDROME DE KALLMANN"
  },
  {
    "codigo":196286005,
    "descripcion":"DENTINOGÉNESIS IMPERFECTA"
  },
  {
    "codigo":294590008,
    "descripcion":"ALERGIA A CLORTETRACICLINA"
  },
  {
    "codigo":391059003,
    "descripcion":"ABSORCIOMETRÍA DUAL DE RAYOS X DE HUESO DE ANTEBRAZO NORMAL"
  },
  {
    "codigo":38861000087100,
    "descripcion":"TÍTULO DE GRADO ALCANZADO"
  },
  {
    "codigo":10701000087104,
    "descripcion":"ARRITMIA DURANTE CIRUGÍA"
  },
  {
    "codigo":94312000,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA VESÍCULA BILIAR"
  },
  {
    "codigo":290920001,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR MIANSERINA"
  },
  {
    "codigo":43981000087105,
    "descripcion":"HERIDA CORTANTE DE PIEL DE MANO IZQUIERDA"
  },
  {
    "codigo":46541000087104,
    "descripcion":"FRACTURA DE CALCÁNEO DERECHO"
  },
  {
    "codigo":127080007,
    "descripcion":"LINFADENOPATÍA PAROTÍDEA"
  },
  {
    "codigo":420157000,
    "descripcion":"HALLAZGO RELACIONADO CON EL REFLEJO MASIVO"
  },
  {
    "codigo":715069001,
    "descripcion":"NEUMONITIS POR ASPIRACIÓN FETAL"
  },
  {
    "codigo":192616009,
    "descripcion":"TRASTORNO DEL FUNCIONAMIENTO SOCIAL DURANTE LA INFANCIA O LA ADOLESCENCIA"
  },
  {
    "codigo":61544007,
    "descripcion":"INTOXICACIÓN POR FLUNIXINA"
  },
  {
    "codigo":26941006,
    "descripcion":"INTELIGENCIA PROMEDIO (C.I.....)"
  },
  {
    "codigo":25106000,
    "descripcion":"INFARTO INMINENTE"
  },
  {
    "codigo":254482002,
    "descripcion":"NEOPLASIA BENIGNA DE CORNETE NASAL MEDIO"
  },
  {
    "codigo":188946004,
    "descripcion":"NEOPLASIA BENIGNA DE HUESO PIRAMIDAL"
  },
  {
    "codigo":1137383000,
    "descripcion":"MIOTONÍA DEBIDA A EXPOSICIÓN AL FRÍO"
  },
  {
    "codigo":1237522009,
    "descripcion":"METÁSTASIS DE CARCINOMA DE VESÍCULA BILIAR"
  },
  {
    "codigo":300467008,
    "descripcion":"HALLAZGO RELACIONADO CON EL ASPECTO DE LA URETRA"
  },
  {
    "codigo":56039006,
    "descripcion":"QUISTE DE RETINA SECUNDARIO"
  },
  {
    "codigo":185276001,
    "descripcion":"ATENDIDO EN EL DEPARTAMENTO DE FISIOTERAPIA"
  },
  {
    "codigo":871569000,
    "descripcion":"REACCIÓN ADVERSA A PORACTANT ALFA"
  },
  {
    "codigo":283580009,
    "descripcion":"HERIDA DE PERDIGÓN EN MIEMBRO INFERIOR"
  },
  {
    "codigo":1363089002,
    "descripcion":"ASTILLA EN RODILLA CON INFECCIÓN"
  },
  {
    "codigo":840636009,
    "descripcion":"EXCITABILIDAD EMOCIONAL AUMENTADA"
  },
  {
    "codigo":247142004,
    "descripcion":"PIGMENTO DE RETINA AGRUPADO"
  },
  {
    "codigo":1230182004,
    "descripcion":"ISQUEMIA AGUDA DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":736827001,
    "descripcion":"IMPACTACIÓN DE DIENTE EN PALADAR"
  },
  {
    "codigo":278075002,
    "descripcion":"PATRÓN DE LA FRECUENCIA CARDÍACA FETAL BASAL, NORMAL"
  },
  {
    "codigo":472848000,
    "descripcion":"INSUFICIENCIA DE VÁLVULA AURICULOVENTRICULAR DERECHA (MORFOLÓGICAMENTE NO TRICÚSPIDE) FETAL"
  },
  {
    "codigo":704059008,
    "descripcion":"FRACTURA POR ESTRÉS DE RADIO"
  },
  {
    "codigo":866064001,
    "descripcion":"MIELITIS CAUSADA POR ASPERGILLUS"
  },
  {
    "codigo":276240000,
    "descripcion":"COMENTARIOS ACERCA DE LAS PROPIAS ACCIONES"
  },
  {
    "codigo":14096004,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN LA REGIÓN ESCAPULAR, CON INFECCIÓN"
  },
  {
    "codigo":1193744004,
    "descripcion":"INFLAMACIÓN INTESTINAL POR SHIGELLA DYSENTERIAE"
  },
  {
    "codigo":210704007,
    "descripcion":"DAÑO MULTITISULAR SEVERO DE PIERNA"
  },
  {
    "codigo":208869001,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN METACARPOFALÁNGICA"
  },
  {
    "codigo":307173002,
    "descripcion":"FRACTURA-LUXACIÓN DE ARTICULACIÓN METACARPOFALÁNGICA"
  },
  {
    "codigo":10632991000119107,
    "descripcion":"CELULITIS DE MUSLO DERECHO"
  },
  {
    "codigo":733157003,
    "descripcion":"ENFERMEDAD DE CROHN DEL APÉNDICE ILEOCECAL"
  },
  {
    "codigo":403642000,
    "descripcion":"ULCERACIÓN CUTÁNEA DEBIDA A TRATAMIENTO CITOTÓXICO"
  },
  {
    "codigo":1157306001,
    "descripcion":"EMBRIÓN PRESENTE EN ÚTERO"
  },
  {
    "codigo":77797009,
    "descripcion":"DISTROFIA CORNEAL HEREDITARIA"
  },
  {
    "codigo":239802003,
    "descripcion":"ARTRITIS PSORIÁSICA JUVENIL"
  },
  {
    "codigo":75962003,
    "descripcion":"TRASTORNO DEL NERVIO OFTÁLMICO"
  },
  {
    "codigo":272570009,
    "descripcion":"DECÚBITO LATERAL DERECHO CON CARA ROTADA EN 45 GRADOS Y ALMOHADAS DEBAJO DE LOS HOMBROS"
  },
  {
    "codigo":762255004,
    "descripcion":"TROMBO DE CÁMARA CARDÍACA"
  },
  {
    "codigo":41359009,
    "descripcion":"LUXACIÓN NO EXPUESTA ANTERIOR DE EXTREMO PROXIMAL DE TIBIA"
  },
  {
    "codigo":399972002,
    "descripcion":"NEOPLASIA VASCULAR BENIGNA DE BRAZO"
  },
  {
    "codigo":301668001,
    "descripcion":"CAPAZ DE ACOSTARSE EN UNA CAMA"
  },
  {
    "codigo":170596004,
    "descripcion":"CONTROL DE ANGINA - MEJORÍA"
  },
  {
    "codigo":236132008,
    "descripcion":"VÁRICES DE ESTOMA"
  },
  {
    "codigo":72292009,
    "descripcion":"ANOMALÍA CONGÉNITA DE LA LARINGE"
  },
  {
    "codigo":365369000,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA USAR INSTALACIONES RECREATIVAS PÚBLICAS"
  },
  {
    "codigo":4921002,
    "descripcion":"INFECCIÓN CAUSADA POR BASIDIOBOLUS"
  },
  {
    "codigo":299833003,
    "descripcion":"REFLEJO BICIPITAL VIVO"
  },
  {
    "codigo":39524009,
    "descripcion":"DERMATITIS POR CERCARIAS DE LOS MAMÍFEROS DE AGUA DULCE"
  },
  {
    "codigo":103225004,
    "descripcion":"ANTÍGENO DE GRUPO SANGUÍNEO P>2<"
  },
  {
    "codigo":398137007,
    "descripcion":"HALLAZGO RELACIONADO CON EL NIVEL DE CREATINA CINASA"
  },
  {
    "codigo":430905008,
    "descripcion":"RUPTURA DE PRÓTESIS ARTICULAR DE HOMBRO"
  },
  {
    "codigo":297998002,
    "descripcion":"PELO NEGRO"
  },
  {
    "codigo":11999161000119109,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO DE BRAZO IZQUIERDO"
  },
  {
    "codigo":94291000119103,
    "descripcion":"ADENOCARCINOMA MUCINOSO DE TRACTO GASTROINTESTINAL"
  },
  {
    "codigo":166926006,
    "descripcion":"PRUEBA DE TOLERANCIA A LA GLUCOSA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":230627003,
    "descripcion":"NEUROPATÍA POR COMPRESIÓN DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":722147003,
    "descripcion":"GLOMERULOSCLEROSIS SEGMENTARIA FOCAL DEBIDA A DREPANOCITOSIS"
  },
  {
    "codigo":296163009,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE LOXAPINA"
  },
  {
    "codigo":294328008,
    "descripcion":"ALERGIA A SILICONA"
  },
  {
    "codigo":2341000124106,
    "descripcion":"SEGUNDO MOLAR SUPERIOR DERECHO DECIDUO SUPERNUMERARIO"
  },
  {
    "codigo":580901000124107,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN DE EXTREMIDAD INFERIOR IZQUIERDA"
  },
  {
    "codigo":292493007,
    "descripcion":"REACCIÓN ADVERSA AL PIRBUTEROL"
  },
  {
    "codigo":95885008,
    "descripcion":"FARINGITIS MICOPLASMÁTICA"
  },
  {
    "codigo":126818001,
    "descripcion":"NEOPLASIA DEL ESÓFAGO CERVICAL"
  },
  {
    "codigo":94050001,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE PARTES BLANDAS DEL ABDOMEN"
  },
  {
    "codigo":61282003,
    "descripcion":"SIGNO DE BEEVOR"
  },
  {
    "codigo":290658004,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR MITOXANTRONA"
  },
  {
    "codigo":1144461008,
    "descripcion":"APLASIA DE SEGUNDO METACARPIANO"
  },
  {
    "codigo":124983002,
    "descripcion":"ALTERACIÓN CITOCINÉTICA"
  },
  {
    "codigo":26679003,
    "descripcion":"INTOXICACIÓN CAUSADA POR ÁCIDO AMINOCAPROICO"
  },
  {
    "codigo":92215004,
    "descripcion":"NEOPLASIA BENIGNA DE LOS GANGLIOS LINFÁTICOS MESENTÉRICOS"
  },
  {
    "codigo":254220005,
    "descripcion":"CUTIS LAXA HEREDITARIA"
  },
  {
    "codigo":876812005,
    "descripcion":"CUERPO EXTRAÑO SUPERFICIAL EN VULVA CON INFECCIÓN"
  },
  {
    "codigo":55777004,
    "descripcion":"INFECCIÓN CAUSADA POR CYLICOCYCLUS"
  },
  {
    "codigo":448993007,
    "descripcion":"NEOPLASIA EPITELIAL MALIGNA DE PULMÓN"
  },
  {
    "codigo":414390000,
    "descripcion":"MUCOSA DUODENAL HEMORRÁGICA"
  },
  {
    "codigo":1331894003,
    "descripcion":"GLAUCOMA NEOVASCULAR DE ÁNGULO CERRADO DE OJO IZQUIERDO"
  },
  {
    "codigo":67821000119109,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA MICROCÍTICA DE PULMÓN, ESTADIO TNM 2"
  },
  {
    "codigo":283318005,
    "descripcion":"ASTILLA DE MADERA EN LA PLANTA DEL PIE"
  },
  {
    "codigo":707467004,
    "descripcion":"CARCINOMA PRIMARIO DE PULMÓN, TIPO GLÁNDULA SALIVAL"
  },
  {
    "codigo":838539005,
    "descripcion":"ESTENOSIS MODERADA DE VÁLVULA PULMONAR"
  },
  {
    "codigo":248715007,
    "descripcion":"LATIDO AÓRTICO EN ABDOMEN"
  },
  {
    "codigo":410720000,
    "descripcion":"DOLOR CLASIFICADO SEGÚN LA CALIDAD DE LA SENSACIÓN"
  },
  {
    "codigo":443488001,
    "descripcion":"NEOPLASIA MALIGNA ANORRECTAL"
  },
  {
    "codigo":445323009,
    "descripcion":"ABSCESO PERIAURICULAR"
  },
  {
    "codigo":1197152005,
    "descripcion":"NEUROPATÍA MOTORA DISTAL HEREDITARIA TIPO 5"
  },
  {
    "codigo":246880006,
    "descripcion":"QUISTE CONJUNTIVAL TRANSPARENTE"
  },
  {
    "codigo":1079841000119100,
    "descripcion":"NEVO DISPLÁSICO DE PIEL DE OÍDO EXTERNO IZQUIERDO"
  },
  {
    "codigo":277813003,
    "descripcion":"HALLAZGO DE LA IMAGEN CORPORAL"
  },
  {
    "codigo":212277008,
    "descripcion":"LESIÓN DEL NERVIO SENSORIAL CUTÁNEO DEL MIEMBRO SUPERIOR"
  },
  {
    "codigo":767498008,
    "descripcion":"METAHEMOGLOBINEMIA CONGÉNITA AUTOSÓMICA RECESIVA TIPO II"
  },
  {
    "codigo":77535002,
    "descripcion":"FLEBITIS DE LA VENA FEMORAL PROFUNDA"
  },
  {
    "codigo":372447002,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA RADIAL PROFUNDA DE ANO, SIN COMPROMISO TUMORAL"
  },
  {
    "codigo":110303004,
    "descripcion":"MOTILIDAD DENTAL ANORMAL"
  },
  {
    "codigo":470751005,
    "descripcion":"FALLA DE CRECIMIENTO DE VENTRÍCULO CARDÍACO IZQUIERDO FETAL"
  },
  {
    "codigo":896735006,
    "descripcion":"FORMA DE CONO ANORMAL CONGÉNITA DE EPÍFISIS DE FALANGE DE DEDO ÍNDICE"
  },
  {
    "codigo":11999007,
    "descripcion":"TUBERCULOSIS INACTIVA"
  },
  {
    "codigo":698292000,
    "descripcion":"PARAPLEJÍA CRÓNICA"
  },
  {
    "codigo":75700000,
    "descripcion":"COLITIS ISQUÉMICA AGUDA"
  },
  {
    "codigo":10164001,
    "descripcion":"PARASÍSTOLE"
  },
  {
    "codigo":1222580004,
    "descripcion":"HEPATITIS CAUSADA POR TOXOPLASMA GONDII"
  },
  {
    "codigo":403380005,
    "descripcion":"HIPERHIDROSIS CRANEOFACIAL"
  },
  {
    "codigo":342561000119106,
    "descripcion":"DERMATITIS ECCEMATOSA DE PÁRPADO INFERIOR IZQUIERDO"
  },
  {
    "codigo":763828007,
    "descripcion":"SÍNDROME DE ODONTO-ONICODISPLASIA CON ALOPECIA"
  },
  {
    "codigo":237705001,
    "descripcion":"HIPOFISITIS"
  },
  {
    "codigo":1153374001,
    "descripcion":"MIELOFIBROSIS MEDICAMENTOSA"
  },
  {
    "codigo":301406006,
    "descripcion":"DOLOR A LA PALPACIÓN DE REGIÓN CENTRAL DE ABDOMEN"
  },
  {
    "codigo":203102006,
    "descripcion":"REUMATISMO MUSCULAR"
  },
  {
    "codigo":792926007,
    "descripcion":"RIÑÓN DE ARMANNI-EBSTEIN DEBIDO A DIABETES MELLITUS"
  },
  {
    "codigo":6494007,
    "descripcion":"TEXTURA NORMAL DEL PELO"
  },
  {
    "codigo":299571003,
    "descripcion":"DEDO DEL PIE ENROSCADO - HALLAZGO"
  },
  {
    "codigo":12242791000119100,
    "descripcion":"DOLOR A LA PALPACIÓN DE ARTICULACIÓN TEMPOROMANDIBULAR IZQUIERDA"
  },
  {
    "codigo":10627431000119100,
    "descripcion":"FORÚNCULO DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":300391000119102,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE MUSLO DERECHO"
  },
  {
    "codigo":16320871000119102,
    "descripcion":"DEGENERACIÓN MACULAR MIÓPICA DEL OJO IZQUIERDO"
  },
  {
    "codigo":16046951000119104,
    "descripcion":"ENFERMEDAD POR DEPÓSITO DE HIDROXIAPATITA DE HOMBRO DERECHO"
  },
  {
    "codigo":70195006,
    "descripcion":"ANOMALÍA CONGÉNITA DE LA VENA CAVA SUPERIOR"
  },
  {
    "codigo":351591000119106,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE SISTEMA NERVIOSO AUTÓNOMO"
  },
  {
    "codigo":16052071000119107,
    "descripcion":"DESGARRO TENDINOSO NO TRAUMÁTICO DE MÚSCULO TRÍCEPS BRAQUIAL IZQUIERDO"
  },
  {
    "codigo":16023911000119108,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DEBIDO A OCLUSIÓN DE ARTERIA CARÓTIDA DERECHA"
  },
  {
    "codigo":323431000119108,
    "descripcion":"DEFORMIDAD EN VALGO ADQUIRIDA DE TOBILLO DERECHO"
  },
  {
    "codigo":16034151000119108,
    "descripcion":"HIPERTROFIA DE HUESO DE TIBIA IZQUIERDA"
  },
  {
    "codigo":310631000119107,
    "descripcion":"MIOSITIS INFECCIOSA DE PIERNA IZQUIERDA"
  },
  {
    "codigo":10632551000119108,
    "descripcion":"ABSCESO DE PIE DERECHO"
  },
  {
    "codigo":15875431000119108,
    "descripcion":"DEFORMIDAD EN VARO DE LA TIBIA DERECHA"
  },
  {
    "codigo":16039271000119109,
    "descripcion":"CONDROMALACIA DE ARTICULACIÓN DE MANO DERECHA"
  },
  {
    "codigo":15634791000119106,
    "descripcion":"PARESTESIA DE EXTREMIDAD INFERIOR DERECHA"
  },
  {
    "codigo":1076071000119107,
    "descripcion":"QUISTE SINOVIAL DE VAINA TENDINOSA DE MANO DERECHA"
  },
  {
    "codigo":10676071000119109,
    "descripcion":"ASMA PERSISTENTE LEVE CONTROLADA"
  },
  {
    "codigo":133991000119109,
    "descripcion":"TRASTORNO DE LA FLUIDEZ COMO SECUELA DE ENFERMEDAD CEREBROVASCULAR"
  },
  {
    "codigo":723720008,
    "descripcion":"SÍNDROME DE INVERSIÓN SEXUAL Y DISGENESIA RENAL, SUPRARRENAL Y PULMONAR"
  },
  {
    "codigo":230365004,
    "descripcion":"DISTROFIA NEUROAXONAL"
  },
  {
    "codigo":263133002,
    "descripcion":"ESGUINCE DE LIGAMENTO LATERAL DE ARTICULACIÓN DE TOBILLO"
  },
  {
    "codigo":197597003,
    "descripcion":"SÍNDROME NEFRÓTICO, GLOMERULONEFRITIS PROLIFERATIVA ENDOCAPILAR DIFUSA"
  },
  {
    "codigo":31922003,
    "descripcion":"DERMATITIS EXFOLIATIVA CRÓNICA GENERALIZADA"
  },
  {
    "codigo":95623001,
    "descripcion":"TRASTORNO NEONATAL DE LA COAGULACIÓN"
  },
  {
    "codigo":423303001,
    "descripcion":"DIFICULTAD PARA OIR SONIDOS DE ALTA FRECUENCIA"
  },
  {
    "codigo":292231005,
    "descripcion":"REACCIÓN ADVERSA A LA TIOGUANINA"
  },
  {
    "codigo":93788000,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE TROMPA DE EUSTAQUIO"
  },
  {
    "codigo":421468001,
    "descripcion":"TRASTORNO DEL SISTEMA NERVIOSO DEBIDO A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":716380002,
    "descripcion":"AFASIA PROGRESIVA LOGOPÉNICA"
  },
  {
    "codigo":10939221000119105,
    "descripcion":"HERIDA POR ARMA BLANCA DE BRAZO DERECHO"
  },
  {
    "codigo":718215008,
    "descripcion":"SÍNDROME DE GRAHAM LITTLE PICCARDI LASSUEUR"
  },
  {
    "codigo":126556005,
    "descripcion":"NEOPLASIA DEL SACRO"
  },
  {
    "codigo":15936341000119106,
    "descripcion":"NECESIDAD DE ASISTENCIA PARA CUIDADO PERSONAL"
  },
  {
    "codigo":16837461000119106,
    "descripcion":"NEOVASCULARIZACIÓN DE COROIDES DE OJO DERECHO DEBIDA A MIOPÍA DEGENERATIVA"
  },
  {
    "codigo":290396005,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR LOPERAMIDA"
  },
  {
    "codigo":192092009,
    "descripcion":"DELINCUENCIA GRUPAL"
  },
  {
    "codigo":91953003,
    "descripcion":"ENFERMEDAD DE LAS AZORES, TIPO I"
  },
  {
    "codigo":124721006,
    "descripcion":"DEFICIENCIA DE ÁCIDO - AMONÍACO LIGASA"
  },
  {
    "codigo":1236998004,
    "descripcion":"INFLAMACIÓN SEBORREICA DE BORDE ANTERIOR DE PÁRPADO SUPERIOR"
  },
  {
    "codigo":253958005,
    "descripcion":"METATARSO EN VALGO CONGÉNITO"
  },
  {
    "codigo":345071000119103,
    "descripcion":"TRASTORNO DE MÚSCULOS EXTRAOCULARES DE AMBOS OJOS"
  },
  {
    "codigo":286726009,
    "descripcion":"RASGO DE LA PERSONALIDAD: SENSIBILIDAD EMPÁTICA - HALLAZGO"
  },
  {
    "codigo":448731002,
    "descripcion":"NEOPLASIA BENIGNA DE PARTES BLANDAS DE LA RODILLA"
  },
  {
    "codigo":15991791000119104,
    "descripcion":"IRITIS DE OJO IZQUIERDO CAUSADA POR VIRUS HERPES ZÓSTER"
  },
  {
    "codigo":284891003,
    "descripcion":"NO SE RASURA"
  },
  {
    "codigo":86448001,
    "descripcion":"ANEMIA POR DEFICIENCIA DE VITAMINA B>6<"
  },
  {
    "codigo":184752002,
    "descripcion":"CERTIFICADO DE LICENCIA POR ENFERMEDAD DE LAS FUERZAS: ARANCEL IMPAGO"
  },
  {
    "codigo":446896007,
    "descripcion":"LACERACIÓN DE LABIO INFERIOR"
  },
  {
    "codigo":51845000,
    "descripcion":"POSICIÓN ANATÓMICA"
  },
  {
    "codigo":11787401000119101,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE DEDO ANULAR IZQUIERDO CON INFECCIÓN"
  },
  {
    "codigo":1231493003,
    "descripcion":"DESVIACIÓN SEVERA DE LÍNEA MEDIA DE ARCO DENTAL MAXILAR HACIA LA DERECHA"
  },
  {
    "codigo":312154004,
    "descripcion":"TRASTORNO INFECCIOSO MUSCULOESQUELÉTICO"
  },
  {
    "codigo":318601000119103,
    "descripcion":"BURSITIS PRERROTULIANA DE RODILLA IZQUIERDA"
  },
  {
    "codigo":1196890007,
    "descripcion":"NEOPLASIA GLANDULAR INTRAEPITELIAL DE INTESTINO DELGADO DE ALTO GRADO"
  },
  {
    "codigo":246618008,
    "descripcion":"PARPADEO DEFENSIVO"
  },
  {
    "codigo":703535000,
    "descripcion":"SÍNDROME DE MOWAT-WILSON"
  },
  {
    "codigo":343087000,
    "descripcion":"SORDERA PARCIAL"
  },
  {
    "codigo":441391006,
    "descripcion":"FÍSTULA ARTERIOVENOSA RADIOCEFÁLICA CONSTRUIDA QUIRÚRGICAMENTE EN LA TABAQUERA ANATÓMICA"
  },
  {
    "codigo":769071006,
    "descripcion":"LEVADURA DE ESPECIE NO CANDIDA ALBICANS DETECTADA"
  },
  {
    "codigo":277551008,
    "descripcion":"LINFOMA ESPLÉNICO CON TRICOLEUCOCITOS"
  },
  {
    "codigo":472324001,
    "descripcion":"MIOCARDIOPATÍA HIPERTRÓFICA FETAL"
  },
  {
    "codigo":300936002,
    "descripcion":"ENFERMEDAD TERMINAL"
  },
  {
    "codigo":15719561000119106,
    "descripcion":"MENISCO DISCOIDE CONGÉNITO DE AMBAS RODILLAS"
  },
  {
    "codigo":110041000,
    "descripcion":"AVULSIÓN DE LA MEJILLA"
  },
  {
    "codigo":210180009,
    "descripcion":"LESIÓN CERRADA DEL BAZO"
  },
  {
    "codigo":765401006,
    "descripcion":"SÍNDROME DE AGOTAMIENTO DE ÁCIDO DESOXIRRIBONUCLEICO MITOCONDRIAL, FORNA ENCEFALOMIOPÁTICA"
  },
  {
    "codigo":208345006,
    "descripcion":"FRACTURA EXPUESTA DE RADIO DISTAL, INTRARTICULAR EN T"
  },
  {
    "codigo":698030002,
    "descripcion":"ANOMALÍA DE LA CRESTA ALVEOLAR DEL MAXILAR SUPERIOR"
  },
  {
    "codigo":403118003,
    "descripcion":"MICETOMA CAUSADO POR MADURELLA GRISEA"
  },
  {
    "codigo":206510008,
    "descripcion":"TROMBOCITOPENIA NEONATAL TRANSITORIA DEBIDA A EXSANGUINOTRANSFUSIÓN"
  },
  {
    "codigo":370350009,
    "descripcion":"COLONOSCOPIA DE RESULTADO DUDOSO"
  },
  {
    "codigo":237443002,
    "descripcion":"MASTITIS URLIANA"
  },
  {
    "codigo":40835002,
    "descripcion":"VÓMITO EN BORRA DE CAFÉ"
  },
  {
    "codigo":1255086008,
    "descripcion":"CARCINOMA DIFERENCIADO DE TIROIDES"
  },
  {
    "codigo":1251416002,
    "descripcion":"REACCIÓN FOTOTÓXICA CAUSADA POR PERFUME"
  },
  {
    "codigo":366680003,
    "descripcion":"AMPLITUD DE MOVIMIENTO PASIVO DE EXTENSIÓN DE DEDO DE LA MANO - HALLAZGO"
  },
  {
    "codigo":268376005,
    "descripcion":"MANTOUX: POSITIVA"
  },
  {
    "codigo":235608007,
    "descripcion":"ÚLCERA EOSINOFÍLICA DE ESÓFAGO"
  },
  {
    "codigo":364845001,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA COMENZAR A CORRER"
  },
  {
    "codigo":11842851000119107,
    "descripcion":"TRANSECCIÓN COMPLETA DE ARTERIA CARÓTIDA IZQUIERDA"
  },
  {
    "codigo":4397001,
    "descripcion":"OBSTRUCCIÓN DUODENAL CONGÉNITA PARCIAL"
  },
  {
    "codigo":299309004,
    "descripcion":"CREPITACIÓN DE ARTICULACIÓN DE CADERA"
  },
  {
    "codigo":233773006,
    "descripcion":"TRASTORNO FEBRIL INDUCIDO POR INHALACIÓN DE PRODUCTOS TÓXICOS"
  },
  {
    "codigo":363010000,
    "descripcion":"COMPLICACIÓN DE PROCEDIMIENTO DE CRIOTERAPIA"
  },
  {
    "codigo":2562003,
    "descripcion":"INTOXICACIÓN POR ATHANASIA TRIFURCATA"
  },
  {
    "codigo":292131000119109,
    "descripcion":"TRASTORNO DE NERVIO PERONEO SUPERFICIAL IZQUIERDO"
  },
  {
    "codigo":19901000119103,
    "descripcion":"EDEMA CONCOMITANTE CON DEFICIENCIA NUTRICIONAL Y DEBIDO A ELLA"
  },
  {
    "codigo":788994006,
    "descripcion":"PSEUDOARTROSIS POSTERIOR A ARTRODESIS"
  },
  {
    "codigo":231938007,
    "descripcion":"DEGENERACIÓN CORNEAL MARGINAL PELÚCIDA"
  },
  {
    "codigo":1149442006,
    "descripcion":"PERIODONTITIS LOCALIZADA ESTADIO 2 GRADO C SEGÚN LA CLASIFICACIÓN DE LAS ENFERMEDADES Y ALTERACIONES PERIODONTALES Y PERIIMPLANTARIAS DE 2017 DE LA ACADEMIA ESTADOUNIDENSE DE PERIODONTOLOGÍA Y LA FEDERACIÓN EUROPEA DE PERIODONTOLOGÍA"
  },
  {
    "codigo":426711003,
    "descripcion":"REACCIÓN NITRITOIDE"
  },
  {
    "codigo":262871004,
    "descripcion":"CONTUSIÓN DE COLON"
  },
  {
    "codigo":185267008,
    "descripcion":"ATENDIDO EN UN CONSULTORIO DE CIRUGÍA TORÁCICA"
  },
  {
    "codigo":347581000119104,
    "descripcion":"CATARATA SENIL HIPERMADURA DE AMBOS OJOS"
  },
  {
    "codigo":721623006,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE TERCIO MEDIO DE ESÓFAGO"
  },
  {
    "codigo":33495006,
    "descripcion":"ESTENOSIS DEL MEATO URETRAL"
  },
  {
    "codigo":293804006,
    "descripcion":"ALERGIA A DEXFENFLURAMINA"
  },
  {
    "codigo":195500007,
    "descripcion":"INFARTO DE GANGLIO LINFÁTICO"
  },
  {
    "codigo":1342380007,
    "descripcion":"LIBERACIÓN EMOCIONAL INTENSA Y APREMIANTE"
  },
  {
    "codigo":95361005,
    "descripcion":"ENFERMEDAD INFLAMATORIA DE LAS MEMBRANAS MUCOSAS"
  },
  {
    "codigo":128129006,
    "descripcion":"TRASTORNO ARTERIAL DEL CUELLO"
  },
  {
    "codigo":93526001,
    "descripcion":"ENFERMEDAD DE HODGKIN DE GANGLIOS LINFÁTICOS DE LOCALIZACIONES MÚLTIPLES"
  },
  {
    "codigo":290134002,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR PARACETAMOL"
  },
  {
    "codigo":1173035001,
    "descripcion":"DEFECTO COMBINADO DE LA FOSFORILACIÓN OXIDATIVA TIPO 25"
  },
  {
    "codigo":1142102009,
    "descripcion":"INFECCIÓN PERINATAL ESTREPTOCÓCICA"
  },
  {
    "codigo":124459002,
    "descripcion":"DEFICIENCIA DE POLIGALACTURONASA"
  },
  {
    "codigo":26155004,
    "descripcion":"TEJIDO ÓSEO ECTÓPICO"
  },
  {
    "codigo":321111000119105,
    "descripcion":"ESTENOSIS DE CONDUCTO VERTEBRAL DE REGIÓN TORACOLUMBAR DE COLUMNA VERTEBRAL"
  },
  {
    "codigo":57088004,
    "descripcion":"ENFERMEDAD RENAL MICROQUÍSTICA"
  },
  {
    "codigo":450304006,
    "descripcion":"COARTACIÓN DE AORTA ABDOMINAL SUPRARRENAL"
  },
  {
    "codigo":253696009,
    "descripcion":"ORIGEN DISTAL DEL TRONCO BRAQUIOCEFÁLICO"
  },
  {
    "codigo":1169365006,
    "descripcion":"QUERATODERMIA PALMOPLANTAR ACUAGÉNICA"
  },
  {
    "codigo":284629006,
    "descripcion":"PRENDERSE DE OTRA PERSONA"
  },
  {
    "codigo":282794002,
    "descripcion":"LESIÓN TRAUMÁTICA DE PLEXO SIMPÁTICO"
  },
  {
    "codigo":118954006,
    "descripcion":"HALLAZGO EN EL CARTÍLAGO"
  },
  {
    "codigo":117119000,
    "descripcion":"CUALIDAD DEL SOPLO CARDÍACO, FUERTE"
  },
  {
    "codigo":446634009,
    "descripcion":"CONEXIONES VENOSAS SISTÉMICAS NORMALES"
  },
  {
    "codigo":315562008,
    "descripcion":"NACIDO EN YUGOSLAVIA"
  },
  {
    "codigo":248191007,
    "descripcion":"EXCESO DE LA PIEL FACIAL AL ESTIRARLA"
  },
  {
    "codigo":49748000,
    "descripcion":"DEFICIENCIA DE SUCCINATO-SEMIALDEHÍDO DESHIDROGENASA"
  },
  {
    "codigo":442964000,
    "descripcion":"SÍNDROME DEL CONO MEDULAR"
  },
  {
    "codigo":1263999008,
    "descripcion":"CARCINOMA DE CÉLULAS RENALES CON TRANSLOCACIÓN DE LA FAMILIA MIT METASTÁSICO"
  },
  {
    "codigo":280959007,
    "descripcion":"NEOPLASIA MALIGNA DE ESTRUCTURA DE DRENAJE LAGRIMAL"
  },
  {
    "codigo":703273002,
    "descripcion":"INSUFICIENCIA CARDÍACA CON FRACCIÓN DE EYECCIÓN DISMINUIDA DEBIDA A ENFERMEDAD CORONARIA"
  },
  {
    "codigo":1260329005,
    "descripcion":"MIGRAÑA HEMIPLÉJICA FAMILIAR TIPO 1"
  },
  {
    "codigo":408361006,
    "descripcion":"CONTROL DE TODA LA MEDICACIÓN VERIFICADO"
  },
  {
    "codigo":677771000119102,
    "descripcion":"OCLUSIÓN BILATERAL DE RAMAS DE ARTERIAS RETINIANAS"
  },
  {
    "codigo":275454002,
    "descripcion":"CUERPO EXTRAÑO EN PULGAR"
  },
  {
    "codigo":13310005,
    "descripcion":"TABOPARÁLISIS"
  },
  {
    "codigo":404691000,
    "descripcion":"PUPILA EN FORMA DE RENACUAJO"
  },
  {
    "codigo":109779003,
    "descripcion":"ABSCESO DE ESPACIO VESTIBULAR DE LA BOCA"
  },
  {
    "codigo":44243005,
    "descripcion":"INFESTACIÓN CAUSADA POR CHRYSOMYA"
  },
  {
    "codigo":240851008,
    "descripcion":"DIROFILARIASIS SUBCUTÁNEA"
  },
  {
    "codigo":304552000,
    "descripcion":"INFECCIÓN CAUSADA POR PHYSALOPTERA MORDENS"
  },
  {
    "codigo":1254824004,
    "descripcion":"INCUMPLIMIENTO EN GENERAL"
  },
  {
    "codigo":402856005,
    "descripcion":"EDEMA HEMORRÁGICO AGUDO DE LA INFANCIA"
  },
  {
    "codigo":206248004,
    "descripcion":"GLAUCOMA DEBIDO A TRAUMATISMO OBSTÉTRICO DE OJO Y POSTERIOR A ÉL"
  },
  {
    "codigo":366418005,
    "descripcion":"AMPLITUD DE MOVIMIENTO PASIVO DE FLEXIÓN LATERAL HACIA LA IZQUIERDA DE LA COLUMNA DORSAL - HALLAZGO"
  },
  {
    "codigo":299047000,
    "descripcion":"HALLAZGO RELACIONADO CON MEDICIONES DE LA MANO"
  },
  {
    "codigo":300882009,
    "descripcion":"TUMEFACCIÓN DE ESTRUCTURA GENITAL MASCULINA"
  },
  {
    "codigo":167975002,
    "descripcion":"DETERMINACIÓN DEL TIPO DE LÍQUIDO PLEURAL"
  },
  {
    "codigo":202578009,
    "descripcion":"OSTEOCONDROMATOSIS SINOVIAL DE CODO"
  },
  {
    "codigo":4135001,
    "descripcion":"SÍNDROME DE MONOSOMÍA PARCIAL 11P"
  },
  {
    "codigo":725031005,
    "descripcion":"HIPOMAGNESEMIA PRIMARIA FAMILIAR CON NORMOCALCIURIA Y NORMOCALCEMIA"
  },
  {
    "codigo":15970341000119106,
    "descripcion":"HEMORROIDE INTERNA SANGRANTE GRADO IV"
  },
  {
    "codigo":11874341000119106,
    "descripcion":"FRACTURA OSTEOPORÓTICA DE COSTILLA IZQUIERDA"
  },
  {
    "codigo":721361002,
    "descripcion":"LUXACIÓN TRAUMÁTICA DE MÚLTIPLES VÉRTEBRAS CERVICALES"
  },
  {
    "codigo":262609004,
    "descripcion":"CUERPO EXTRAÑO EN ÍLEON TERMINAL"
  },
  {
    "codigo":129702000,
    "descripcion":"CON MAYOR RIESGO DE DISFUNCIÓN NEUROVASCULAR PERIFÉRICA"
  },
  {
    "codigo":295377009,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE LANSOPRAZOL"
  },
  {
    "codigo":162470006,
    "descripcion":"SÍNTOMA GRAVE"
  },
  {
    "codigo":1145510006,
    "descripcion":"APLASIA DE FALANGE MEDIA DE DEDO ÍNDICE"
  },
  {
    "codigo":293542006,
    "descripcion":"REACCIÓN ADVERSA AL TRINITRATO DE GLICERILO"
  },
  {
    "codigo":64166009,
    "descripcion":"BURSITIS SUBROTULIANA"
  },
  {
    "codigo":160635005,
    "descripcion":"INTENSIDAD DE EJERCICIO FÍSICO, DESCONOCIDO"
  },
  {
    "codigo":95099006,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE PARTES BLANDAS DE LA PELVIS"
  },
  {
    "codigo":289872001,
    "descripcion":"PERINEO HÚMEDO"
  },
  {
    "codigo":93264003,
    "descripcion":"HIPOPLASIA CONGÉNITA DE HÚMERO"
  },
  {
    "codigo":224336006,
    "descripcion":"LIBERADO BAJO FIANZA"
  },
  {
    "codigo":1141840008,
    "descripcion":"INFILTRACIÓN EOSINOFÍLICA DE VESÍCULA BILIAR"
  },
  {
    "codigo":124197006,
    "descripcion":"DEFICIENCIA DE GLUTATIÓN - HOMOCISTINA TRANSHIDROGENASA"
  },
  {
    "codigo":89594001,
    "descripcion":"INTOXICACIÓN POR TRACHYANDRA"
  },
  {
    "codigo":253434001,
    "descripcion":"VÁLVULA AURICULOVENTRICULAR COMÚN LIMITADA A UN VENTRÍCULO"
  },
  {
    "codigo":286202006,
    "descripcion":"NO ABRE LA CASA CUANDO ESTÁ CERRADA"
  },
  {
    "codigo":251599003,
    "descripcion":"OSCILACIÓN RÁPIDA EN EL ELECTROOCULOGRAMA"
  },
  {
    "codigo":708516002,
    "descripcion":"MUCOSITIS ULCEROSA NECROSANTE"
  },
  {
    "codigo":282532004,
    "descripcion":"BAJA ESCALERAS CORRIENDO"
  },
  {
    "codigo":53156005,
    "descripcion":"DIARREA POSCOLECISTECTOMÍA"
  },
  {
    "codigo":249764006,
    "descripcion":"DEDO DE LA MANO QUE SE DESVÍA DE LA LINEA DE LA MANO"
  },
  {
    "codigo":1296505000,
    "descripcion":"ABSCESO DE PIEL PRERROTULIANA"
  },
  {
    "codigo":184228008,
    "descripcion":"NUEVA PRESCRIPCIÓN - COMPUTARIZADA"
  },
  {
    "codigo":1263737000,
    "descripcion":"PROLAPSO DE ÚTERO CON RECTOCELE"
  },
  {
    "codigo":1362041000,
    "descripcion":"ATRAPAMIENTO DE MÚSCULO RECTO SUPERIOR"
  },
  {
    "codigo":247929003,
    "descripcion":"MOVIMIENTOS TORSIONALES REPETITIVOS COMPLEJOS DE LAS EXTREMIDADES"
  },
  {
    "codigo":1003428009,
    "descripcion":"GLAUCOMA POR ANOMALÍA OCULAR CONGÉNITA"
  },
  {
    "codigo":352601000119108,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE TESTÍCULO NO DESCENDIDO DERECHO"
  },
  {
    "codigo":224136004,
    "descripcion":"VIVE CON UN HIJO"
  },
  {
    "codigo":278862001,
    "descripcion":"LUMBALGIA AGUDA"
  },
  {
    "codigo":84089009,
    "descripcion":"HERNIA HIATAL"
  },
  {
    "codigo":442702006,
    "descripcion":"RADIOGRAFÍA SIMPLE DEL SISTEMA MUSCULOESQUELÉTICO ANORMAL"
  },
  {
    "codigo":737614006,
    "descripcion":"CONSCIENCIA ACCIDENTAL DURANTE MANTENIMIENTO DE ANESTESIA GENERAL"
  },
  {
    "codigo":440867000,
    "descripcion":"ENFERMEDAD MODERADA POR DEFICIENCIA HEREDITARIA DE FACTOR IX CON INHIBIDORES"
  },
  {
    "codigo":703011002,
    "descripcion":"GEMELLA MORBILLORUM O STREPTOCOCCUS AGALACTIAE O STREPTOCOCCUS ACIDOMINIMUS"
  },
  {
    "codigo":735779003,
    "descripcion":"HERIDA PUNZANTE DE ABDOMEN SIN CUERPO EXTRAÑO"
  },
  {
    "codigo":1260067004,
    "descripcion":"ADENOCARCINOMA PAPILAR DE OROFARINGE"
  },
  {
    "codigo":45816000,
    "descripcion":"PIELONEFRITIS"
  },
  {
    "codigo":439032005,
    "descripcion":"CONCENTRACIÓN DE PROTEÍNA DE LA CADENA NEURONAL AD7C EN LÍQUIDO CEFALORRAQUÍDEO POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":13048006,
    "descripcion":"LINFOMA ORBITARIO"
  },
  {
    "codigo":733944007,
    "descripcion":"CARIES DENTAL ACTIVA SECUNDARIA QUE SE EXTIENDE HASTA LA MITAD EXTERNA DEL ESMALTE"
  },
  {
    "codigo":111352008,
    "descripcion":"FORMACIÓN TRICOBEZOAR CRÓNICA"
  },
  {
    "codigo":78584008,
    "descripcion":"DESPRENDIMIENTO COROIDEO SEROSO"
  },
  {
    "codigo":240589008,
    "descripcion":"INFECCIÓN POR CHLAMYDIA TRACHOMATIS"
  },
  {
    "codigo":109517008,
    "descripcion":"HIPERPLASIA MANDIBULAR HORIZONTAL CONGÉNITA"
  },
  {
    "codigo":238754005,
    "descripcion":"HIDRADENITIS ECRINA NEUTROFÍLICA"
  },
  {
    "codigo":1187191003,
    "descripcion":"PARAPLEJÍA ESPÁSTICA AUTOSÓMICA RECESIVA TIPO 74"
  },
  {
    "codigo":366156001,
    "descripcion":"HALLAZGO RELACIONADO CON LA VELOCIDAD DE FLUJO ESPIRATORIO PICO"
  },
  {
    "codigo":235084007,
    "descripcion":"SÍNDROME DE LA CARA LARGA"
  },
  {
    "codigo":169548007,
    "descripcion":"FRACASO DE LA VASECTOMÍA"
  },
  {
    "codigo":5708009,
    "descripcion":"FRACTURA EXPUESTA DE ARCO CIGOMÁTICO"
  },
  {
    "codigo":724769002,
    "descripcion":"ATAXIA CONCOMITANTE CON ENFERMEDAD POR ALMACENAMIENTO DE ÁCIDO FITÁNICO Y DEBIDA A ELLA"
  },
  {
    "codigo":167713005,
    "descripcion":"PRESIÓN DE LÍQUIDO CEFALORRAQUÍDEO: ELEVADA"
  },
  {
    "codigo":788470000,
    "descripcion":"TRASTORNO REPETITIVO DEL MOVIMIENTO DE ANTEBRAZO IZQUIERDO"
  },
  {
    "codigo":165878000,
    "descripcion":"TÍTULO DE AUTOANTICUERPOS NEGATIVO"
  },
  {
    "codigo":1279990000,
    "descripcion":"CRISIS EPILÉPTICA DE INICIO NO MOTOR CON CONCIENCIA PRESERVADA DE INICIO FOCAL"
  },
  {
    "codigo":296950004,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE VITAMINA A"
  },
  {
    "codigo":1148918005,
    "descripcion":"ARTROPATÍA GOTOSA DEBIDA A RASGO DREPANOCÍTICO"
  },
  {
    "codigo":295115000,
    "descripcion":"ALERGIA A ESTREPTOQUINASA ESTREPTODORNASA"
  },
  {
    "codigo":722934009,
    "descripcion":"DIFICULTAD PARA MAMAR EN EL PERÍODO NEONATAL"
  },
  {
    "codigo":426187002,
    "descripcion":"MIOCLONÍA DEL MÚSCULO ESTAPEDIO"
  },
  {
    "codigo":721099001,
    "descripcion":"ENFERMEDAD CON CORPÚSCULOS DE POLIGLUCOSANO DEL ADULTO"
  },
  {
    "codigo":1343691001,
    "descripcion":"ALTERACIÓN CRÓNICA DE ASTA POSTERIOR DE MENISCO EXTERNO DE RODILLA DERECHA"
  },
  {
    "codigo":162208002,
    "descripcion":"LENGUAJE INCOHERENTE"
  },
  {
    "codigo":293280006,
    "descripcion":"REACCIÓN ADVERSA A LA GOSERELINA"
  },
  {
    "codigo":94837001,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LOS ÓRGANOS GENITALES FEMENINOS"
  },
  {
    "codigo":291445003,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR CLOROQUINA"
  },
  {
    "codigo":422517004,
    "descripcion":"HABILIDADES DE COMUNICACIÓN INTERPERSONAL INADECUADAS"
  },
  {
    "codigo":193141005,
    "descripcion":"MONONEURITIS MÚLTIPLE DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":225909006,
    "descripcion":"CAPAZ DE SALIR ADELANTE"
  },
  {
    "codigo":15919911000119108,
    "descripcion":"REACCIÓN ALÉRGICA CAUSADA POR ANALGÉSICO"
  },
  {
    "codigo":60234000,
    "descripcion":"INSUFICIENCIA VALVULAR AÓRTICA"
  },
  {
    "codigo":1010506001,
    "descripcion":"ESCLEROSIS DE EPÍFISIS DE FALANGE DE DEDO MEDIO CON RADIOPACIDAD AUMENTADA"
  },
  {
    "codigo":1208949003,
    "descripcion":"ECOGRAFÍA ANORMAL DE PULMÓN"
  },
  {
    "codigo":289610003,
    "descripcion":"PROBLEMA VAGINAL"
  },
  {
    "codigo":10677031000119109,
    "descripcion":"ÚLCERA NEUROPÁTICA DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":191306005,
    "descripcion":"VASCULITIS POR INMUNOGLOBULINA A"
  },
  {
    "codigo":93002006,
    "descripcion":"ANOMALÍA CONGÉNITA DE HUESO EXOCCIPITAL"
  },
  {
    "codigo":15729601000119103,
    "descripcion":"ARTROPATÍA DE HOMBRO DERECHO"
  },
  {
    "codigo":781130007,
    "descripcion":"PUNCIÓN ACCIDENTAL DE UN VASO SANGUÍNEO DURANTE UN PROCEDIMIENTO"
  },
  {
    "codigo":123935005,
    "descripcion":"INTOXICACIÓN POR BERBERIDACEAE"
  },
  {
    "codigo":1172511007,
    "descripcion":"NORADRENALINA EN ORINA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":255007008,
    "descripcion":"ENFERMEDAD DE BOWEN DE CÓRNEA"
  },
  {
    "codigo":253172000,
    "descripcion":"AGENESIA DE CEREBELO"
  },
  {
    "codigo":449780004,
    "descripcion":"ENFERMEDAD DE RIGA-FEDE"
  },
  {
    "codigo":284105000,
    "descripcion":"CONTROLA LA POSICIÓN"
  },
  {
    "codigo":710089002,
    "descripcion":"MALA OCLUSIÓN DE CÚSPIDES CLASE II"
  },
  {
    "codigo":415177008,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE OÍDO, NARIZ Y\/O GARGANTA"
  },
  {
    "codigo":413342000,
    "descripcion":"TAQUICARDIA NEONATAL"
  },
  {
    "codigo":249502005,
    "descripcion":"MALESTAR POR VIAJAR EN TREN"
  },
  {
    "codigo":216734008,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ESCILA Y\/O DERIVADO DE ESCILA"
  },
  {
    "codigo":247667002,
    "descripcion":"DELIRIO DE GRANDEZA"
  },
  {
    "codigo":313203003,
    "descripcion":"PRUEBA DE AUDICIÓN ANORMAL"
  },
  {
    "codigo":1263475004,
    "descripcion":"NEOPLASIA MALIGNA DE PARTES BLANDAS DE GLÚTEO"
  },
  {
    "codigo":737352000,
    "descripcion":"DIFICULTAD CON LA REALIZACIÓN DE ACTIVIDADES LABORALES"
  },
  {
    "codigo":11770971000119105,
    "descripcion":"ESGUINCE DE LIGAMENTO CUBITAL COLATERAL DE ARTICULACIÓN DE CODO DERECHO"
  },
  {
    "codigo":1259805000,
    "descripcion":"NEOPLASIA PRIMARIA MALIGNA DE VAINA DE NERVIO PERIFÉRICO DE MUCOSA GINGIVAL"
  },
  {
    "codigo":278600009,
    "descripcion":"ENCHAPADO DENTAL QUE FILTRA"
  },
  {
    "codigo":1359944008,
    "descripcion":"BACTERIAS ENCAPSULADAS"
  },
  {
    "codigo":49224008,
    "descripcion":"LÓBULO DE LA OREJA SUPERNUMERARIO"
  },
  {
    "codigo":473373004,
    "descripcion":"CALCIFICACIÓN DE ANILLO DE VÁLVULA AÓRTICA"
  },
  {
    "codigo":14621004,
    "descripcion":"DUELO ANTICIPATORIO"
  },
  {
    "codigo":735517008,
    "descripcion":"MIOSITIS CAUSADA POR MYCOBACTERIUM TUBERCULOSIS"
  },
  {
    "codigo":209394000,
    "descripcion":"FRACTURA-LUXACIÓN EXPUESTA DEL ESTERNÓN"
  },
  {
    "codigo":307698002,
    "descripcion":"SIGNOS DE NISTAGMO"
  },
  {
    "codigo":406002002,
    "descripcion":"HAPLOTIPO CDE"
  },
  {
    "codigo":10951003,
    "descripcion":"PRONACIÓN DEL PIE"
  },
  {
    "codigo":109255004,
    "descripcion":"MUCOSITIS LUEGO DE UN TRATAMIENTO"
  },
  {
    "codigo":404167005,
    "descripcion":"MALACOPLAQUIA (COMPROMISO CUTÁNEO)"
  },
  {
    "codigo":305863003,
    "descripcion":"ATENDIDO POR SERVICIO EXTRAHOSPITALARIO DE FONOAUDIOLOGÍA"
  },
  {
    "codigo":16905461000119104,
    "descripcion":"CARCINOMA BASOCELULAR PRIMARIO DE PÁRPADO INFERIOR DERECHO"
  },
  {
    "codigo":1155996000,
    "descripcion":"SOBREDOSIS DE FENOTIAZINA Y\/O DERIVADO DE FENOTIAZINA"
  },
  {
    "codigo":830151004,
    "descripcion":"CÁNCER DE PULMÓN NO MICROCÍTICO POSITIVO PARA ONCOGÉN DE FUSIÓN CINASA DEL LINFOMA ANAPLÁSICO"
  },
  {
    "codigo":41884003,
    "descripcion":"PÓLIPO CARDÍACO"
  },
  {
    "codigo":9116003,
    "descripcion":"SHIN - BYUNG"
  },
  {
    "codigo":238492005,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN CON GANGRENA"
  },
  {
    "codigo":402332003,
    "descripcion":"APARICIÓN DE PSORIASIS EN LA ADOLESCENCIA (10-20 AÑOS)"
  },
  {
    "codigo":236657002,
    "descripcion":"VACIADO DISFUNCIONAL"
  },
  {
    "codigo":1119558001,
    "descripcion":"COLUMELA NASAL CORTA"
  },
  {
    "codigo":726342002,
    "descripcion":"TRISOMÍA PARCIAL DE CROMOSOMA 4"
  },
  {
    "codigo":365894005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA RECORDAR LA FECHA DEL DÍA"
  },
  {
    "codigo":267590006,
    "descripcion":"SÍNDROME DE COLA DE CABALLO, CON VEJIGA NEUROGÉNICA"
  },
  {
    "codigo":300358007,
    "descripcion":"HALLAZGO FUNCIONAL DEL TRACTO GASTROINTESTINAL"
  },
  {
    "codigo":724507000,
    "descripcion":"APNEA CENTRAL DEL SUEÑO SIN RESPIRACIÓN DE CHEYNE-STOKES"
  },
  {
    "codigo":3611003,
    "descripcion":"INTOXICACIÓN POR DEMETÓN"
  },
  {
    "codigo":167451006,
    "descripcion":"PROTEÍNAS EN ORINA FUERA DE RANGO DE REFERENCIA"
  },
  {
    "codigo":296688000,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE CEFRADINA"
  },
  {
    "codigo":722672002,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE BASE DE LA LENGUA"
  },
  {
    "codigo":1776003,
    "descripcion":"ACIDOSIS TUBULAR RENAL"
  },
  {
    "codigo":67312003,
    "descripcion":"PORFIRIA ERITROPOYÉTICA"
  },
  {
    "codigo":131013000,
    "descripcion":"HORMONA ESTIMULANTE DE LOS MELANOCITOS ANORMAL"
  },
  {
    "codigo":15977871000119107,
    "descripcion":"MELANOMA MALIGNO DE AMBAS RETINAS"
  },
  {
    "codigo":32709003,
    "descripcion":"ADICCIÓN"
  },
  {
    "codigo":16606761000119102,
    "descripcion":"DISECCIÓN DE ARTERIA DE EXTREMIDAD INFERIOR IZQUIERDA"
  },
  {
    "codigo":331151000119109,
    "descripcion":"COROIDITIS SIFILÍTICA"
  },
  {
    "codigo":63642005,
    "descripcion":"RALES CREPITANTES SUPERFICIALES"
  },
  {
    "codigo":30874006,
    "descripcion":"GASTROPATÍA PILÓRICA HIPERTRÓFICA CRÓNICA"
  },
  {
    "codigo":1144986007,
    "descripcion":"SARCOIDOSIS ANULAR"
  },
  {
    "codigo":260250006,
    "descripcion":"J12"
  },
  {
    "codigo":225647004,
    "descripcion":"CONDUCTA DE EVITACIÓN DE CONFLICTO"
  },
  {
    "codigo":94575006,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA PIEL DEL TRONCO"
  },
  {
    "codigo":127343008,
    "descripcion":"OCULOPATÍA AGUDA"
  },
  {
    "codigo":291183009,
    "descripcion":"INTOXICACIÓN POR PIPOTIAZINA"
  },
  {
    "codigo":92740007,
    "descripcion":"CARCINOMA IN SITU DE LA PIEL DEL CUERO CABELLUDO"
  },
  {
    "codigo":1336089001,
    "descripcion":"SARCOMA DE EWING PRIMARIO DE HUESO DE MANO"
  },
  {
    "codigo":713497004,
    "descripcion":"CANDIDIASIS DE LA CAVIDAD BUCAL CONCOMITANTE CON INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":254745007,
    "descripcion":"PÁPULA FIBROSA DE LA NARIZ"
  },
  {
    "codigo":56302003,
    "descripcion":"ESTADO TÓXICO"
  },
  {
    "codigo":15705641000119109,
    "descripcion":"DEPÓSITO DE CALCIO EN BOLSA SEROSA DE AMBAS CADERAS"
  },
  {
    "codigo":1268718007,
    "descripcion":"TIMOMA PRIMARIO MALIGNO"
  },
  {
    "codigo":447683000,
    "descripcion":"DISCONTINUIDAD ENTRE VÁLVULA MITRAL Y VÁLVULA PULMONAR"
  },
  {
    "codigo":414915002,
    "descripcion":"OBESO"
  },
  {
    "codigo":87235005,
    "descripcion":"SÍNDROME DE DESEQUILIBRIO DIALÍTICO"
  },
  {
    "codigo":283843007,
    "descripcion":"LESIÓN POR DESOLLAMIENTO DE CUELLO"
  },
  {
    "codigo":445848002,
    "descripcion":"QUEMADURA PROFUNDA DE TERCER GRADO DE LABIO"
  },
  {
    "codigo":216472002,
    "descripcion":"INTOXICACIÓN ACCIDENTAL CAUSADA POR ASPIRINA"
  },
  {
    "codigo":687811000119106,
    "descripcion":"RABDOMIOSARCOMA PRIMARIO DE CARA"
  },
  {
    "codigo":871832005,
    "descripcion":"LATIDOS AURICULARES ECTÓPICOS MULTIFOCALES"
  },
  {
    "codigo":413080009,
    "descripcion":"CLAMIDIA NO DETECTADA POR REACCIÓN EN CADENA DE POLIMERASA"
  },
  {
    "codigo":249240009,
    "descripcion":"TESTÍCULO FUERA DE LUGAR"
  },
  {
    "codigo":247405003,
    "descripcion":"DOLOR EN LA REGIÓN ANESTESIADA"
  },
  {
    "codigo":333661000119101,
    "descripcion":"DEGENERACIÓN NODULAR DE LA CÓRNEA DERECHA"
  },
  {
    "codigo":1197677005,
    "descripcion":"ÍLEO PARALÍTICO DE INTESTINO DELGADO"
  },
  {
    "codigo":312941005,
    "descripcion":"RETINOPATÍA ASOCIADA CON MELANOMA"
  },
  {
    "codigo":50797007,
    "descripcion":"PESTE BUBÓNICA"
  },
  {
    "codigo":181869007,
    "descripcion":"PARO CARDIORRESPIRATORIO NEONATAL"
  },
  {
    "codigo":81730008,
    "descripcion":"ESTADO SEXUAL ANORMAL"
  },
  {
    "codigo":1163074009,
    "descripcion":"ENCEFALITIS CAUSADA POR PARAMYXOVIRIDAE"
  },
  {
    "codigo":1259543006,
    "descripcion":"CARCINOMA PRIMARIO DE COSTILLAS Y\/O ESTERNÓN Y\/O CLAVÍCULA"
  },
  {
    "codigo":210967007,
    "descripcion":"SECUELA OCASIONADA POR FRACTURA DE FÉMUR"
  },
  {
    "codigo":438508001,
    "descripcion":"VIRUS PRESENTE"
  },
  {
    "codigo":12524001,
    "descripcion":"INFECCIÓN CAUSADA POR COENUROSIS CEREBRALIS"
  },
  {
    "codigo":471276003,
    "descripcion":"ARTERIA CORONARIA IZQUIERDA ÚNICA QUE IRRIGA A TODO EL CORAZÓN CON LA DISTRIBUCIÓN HABITUAL DE LA ARTERIA CORONARIA DERECHA DERIVADA DE LA ARTERIA CORONARIA IZQUIERDA DISTAL"
  },
  {
    "codigo":274668005,
    "descripcion":"DOLOR TORÁCICO NO CARDÍACO"
  },
  {
    "codigo":209132005,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN COSTOCONDRAL"
  },
  {
    "codigo":241900006,
    "descripcion":"EFECTO TÓXICO CAUSADO POR BRILLO FOLIAR"
  },
  {
    "codigo":372972007,
    "descripcion":"INFECCIÓN POR ASPERGILLUS MONTEVIDENSIS"
  },
  {
    "codigo":305601001,
    "descripcion":"BAJO ATENCIÓN DE PODÓLOGO HOSPITALARIO"
  },
  {
    "codigo":698817002,
    "descripcion":"DEHISCENCIA DE HERIDA ABDOMINAL POSOPERATORIA"
  },
  {
    "codigo":76225004,
    "descripcion":"ÁNTRAX DE LA NALGA"
  },
  {
    "codigo":403905005,
    "descripcion":"CARCINOMAS MÚLTIPLES DE CÉLULAS ESCAMOSAS"
  },
  {
    "codigo":371137008,
    "descripcion":"HALLAZGO RELACIONADO CON LA AGUDEZA AUDITIVA"
  },
  {
    "codigo":240065009,
    "descripcion":"DISTROFIA MUSCULA AUTOSÓMICA RECESIVA DE INICIO EN LA EDAD ADULTA CON DISTROFINA NORMAL"
  },
  {
    "codigo":74390002,
    "descripcion":"PATRÓN DE WOLFF-PARKINSON-WHITE"
  },
  {
    "codigo":762518003,
    "descripcion":"TRASTORNO DEL SUEÑO CAUSADO POR CATINONA SINTÉTICA"
  },
  {
    "codigo":307191000119103,
    "descripcion":"ARTRITIS ENTEROPÁTICA DE ARTICULACIÓN DE PIE DERECHO"
  },
  {
    "codigo":1286806007,
    "descripcion":"TRASTORNO NEONATAL PRECOZ DEBIDO A PARTO PRECIPITADO"
  },
  {
    "codigo":860822008,
    "descripcion":"ENCEFALITIS CAUSADA POR NOCARDIA"
  },
  {
    "codigo":269163001,
    "descripcion":"HERIDA ABIERTA DE CABEZA, CUELLO Y TRONCO"
  },
  {
    "codigo":236395002,
    "descripcion":"GLOMERULONEFRITIS POSINFECCIOSA"
  },
  {
    "codigo":367467003,
    "descripcion":"AUSENCIA DE FUNCIÓN DE LA VESÍCULA"
  },
  {
    "codigo":170859004,
    "descripcion":"CAMBIO EN LOS SÍNTOMAS CUTÁNEOS"
  },
  {
    "codigo":12103671000119105,
    "descripcion":"CONGELAMIENTO DE PIE DERECHO"
  },
  {
    "codigo":300096002,
    "descripcion":"LESIÓN DE PABELLÓN AURICULAR"
  },
  {
    "codigo":37952003,
    "descripcion":"APNEA PRIMARIA"
  },
  {
    "codigo":234560004,
    "descripcion":"DEFICIENCIA DE ANTICUERPOS ANTIPOLISACÁRIDO A DEL MENINGOCOCO"
  },
  {
    "codigo":70720002,
    "descripcion":"DISTORSIÓN SECUENCIAL DE LA IMAGEN RELACIONADA CON DIETILAMIDA DEL ÁCIDO LISÉRGICO (\"TRAILING PHENOMENON\")"
  },
  {
    "codigo":365632008,
    "descripcion":"RECUENTO DE PLAQUETAS - HALLAZGO"
  },
  {
    "codigo":134421000,
    "descripcion":"FRACTURA PATOLÓGICA DE HUESO EN SITIO DE NEOPLASIA METASTÁSICA"
  },
  {
    "codigo":298261007,
    "descripcion":"AUSENCIA DE DISCRIMINACIÓN ESTÁTICA DE DOS PUNTOS"
  },
  {
    "codigo":396565007,
    "descripcion":"ULCERACIÓN TUMORAL AUSENTE"
  },
  {
    "codigo":10629111000119109,
    "descripcion":"LINFADENITIS AGUDA DE GANGLIOS LINFÁTICOS INGUINALES"
  },
  {
    "codigo":296426008,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE TONZILAMINA"
  },
  {
    "codigo":722410009,
    "descripcion":"DISFUNCIÓN SOMÁTICA DE REGIÓN LUMBOSACRA"
  },
  {
    "codigo":720575002,
    "descripcion":"SÍNDROME DE BRADDOCK"
  },
  {
    "codigo":34282009,
    "descripcion":"TRASTORNO DEL TEJIDO PERIAPICAL DE LOS DIENTES"
  },
  {
    "codigo":65215002,
    "descripcion":"ESOTROPÍA MONOCULAR CON PATRÓN V"
  },
  {
    "codigo":196287001,
    "descripcion":"ODONTOGÉNESIS IMPERFECTA"
  },
  {
    "codigo":294591007,
    "descripcion":"ALERGIA A DEMECLOCICLINA"
  },
  {
    "codigo":292756000,
    "descripcion":"REACCIÓN ADVERSA A MEDICAMENTOS A BASE DE HIERBAS"
  },
  {
    "codigo":690321000119106,
    "descripcion":"AFAQUIA DEBIDA A ACCIDENTE CEREBROVASCULAR EMBÓLICO Y POSTERIOR A ÉL"
  },
  {
    "codigo":391060008,
    "descripcion":"RESULTADO DE ABSORCIOMETRÍA DUAL POR RAYOS X DE HUESO DE ANTEBRAZO, OSTEOPOROSIS"
  },
  {
    "codigo":15681681000119107,
    "descripcion":"ENDOFTALMITIS DE AMBOS OJOS"
  },
  {
    "codigo":290921002,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR MIANSERINA"
  },
  {
    "codigo":94313005,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL TRACTO GASTROINTESTINAL"
  },
  {
    "codigo":127081006,
    "descripcion":"LINFADENOPATÍA FACIAL"
  },
  {
    "codigo":715070000,
    "descripcion":"SEPSIS CAUSADA POR PEPTOSTREPTOCOCCUS"
  },
  {
    "codigo":289086003,
    "descripcion":"CAPAZ DE COLOCAR AL BEBÉ AL PECHO PARA AMAMANTARLO"
  },
  {
    "codigo":92478005,
    "descripcion":"NEOPLASIA BENIGNA DE BORDE BERMELLÓN DE LABIO"
  },
  {
    "codigo":418323001,
    "descripcion":"QUISTE QUERATINIZANTE DE LA PIEL"
  },
  {
    "codigo":746003004,
    "descripcion":"BAJO ATENCIÓN DE SERVICIO PENITENCIARIO"
  },
  {
    "codigo":44711000087101,
    "descripcion":"KLEBSIELLA PNEUMONIAE O KLEBSIELLA VARIICOLA"
  },
  {
    "codigo":1237523004,
    "descripcion":"METÁSTASIS DE CARCINOMA EN CUERDA VOCAL"
  },
  {
    "codigo":254483007,
    "descripcion":"TUMOR DEL BORDE POSTERIOR DEL TABIQUE NASAL Y LAS COANAS"
  },
  {
    "codigo":188947008,
    "descripcion":"NEOPLASIA BENIGNA DE HUESO PISIFORME"
  },
  {
    "codigo":25107009,
    "descripcion":"REPETICIÓN VERBAL"
  },
  {
    "codigo":39591000087104,
    "descripcion":"DISTENSIÓN DE TENDÓN DE MÚSCULO ISQUIOTIBIAL IZQUIERDO"
  },
  {
    "codigo":416488000,
    "descripcion":"RESONANCIA MAGNÉTICA DE COLUMNA VERTEBRAL CERVICAL, NORMAL"
  },
  {
    "codigo":42151000087108,
    "descripcion":"CONTUSIÓN MANDIBULAR DERECHA"
  },
  {
    "codigo":54951000087102,
    "descripcion":"RUPTURA DE OBJETOS"
  },
  {
    "codigo":1137384006,
    "descripcion":"HIPOTONÍA EPISÓDICA"
  },
  {
    "codigo":23272008,
    "descripcion":"HIPOCERULOPLASMINEMIA FAMILIAR"
  },
  {
    "codigo":54205001,
    "descripcion":"INTOXICACIÓN POR CROTALARIA DURA"
  },
  {
    "codigo":309701000119101,
    "descripcion":"GOTA PRIMARIA CRÓNICA DE MANO, SIN TOFO"
  },
  {
    "codigo":21437004,
    "descripcion":"INFECCIÓN CAUSADA POR STELLANTCHASMUS FALCATUS"
  },
  {
    "codigo":1332157006,
    "descripcion":"EPILEPSIA INFANTIL AUTOLIMITADA"
  },
  {
    "codigo":283581008,
    "descripcion":"HERIDA DE PERDIGÓN EN GLÚTEO"
  },
  {
    "codigo":414653009,
    "descripcion":"NEOPLASIA DE CÉLULAS MASTOCITARIAS"
  },
  {
    "codigo":871570004,
    "descripcion":"REACCIÓN ADVERSA A BROMHEXINA"
  },
  {
    "codigo":248978005,
    "descripcion":"SANGRADO DEL INTROITO VAGINAL"
  },
  {
    "codigo":1363090006,
    "descripcion":"ASTILLA EN INGLE"
  },
  {
    "codigo":314514005,
    "descripcion":"NEUROFIBROMA DE PÁRPADO"
  },
  {
    "codigo":1197415001,
    "descripcion":"SUSCEPTIBILIDAD A INFECCIÓN DEBIDA A DEFICIENCIA DE TIROSINA CINASA 2"
  },
  {
    "codigo":278076001,
    "descripcion":"PATRÓN SINUSOIDAL DE LA FRECUENCIA CARDÍACA FETAL"
  },
  {
    "codigo":247143009,
    "descripcion":"HALLAZGO RELACIONADO CON LA MÁCULA"
  },
  {
    "codigo":704060003,
    "descripcion":"FRACTURA POR ESTRÉS DE RAMA DEL PUBIS"
  },
  {
    "codigo":736828006,
    "descripcion":"CAPAZ DE TRAGAR UNA DIETA MODIFICADA"
  },
  {
    "codigo":866065000,
    "descripcion":"MIELITIS CAUSADA POR SCHISTOSOMA MANSONI"
  },
  {
    "codigo":276241001,
    "descripcion":"MIEDO A LAS ALTURAS"
  },
  {
    "codigo":16667231000119101,
    "descripcion":"FRACTURA ABIERTA DE RAMA DE MITAD DERECHA DE MANDÍBULA"
  },
  {
    "codigo":1193745003,
    "descripcion":"ENTERITIS POR SHIGELLA FLEXNERI"
  },
  {
    "codigo":210705008,
    "descripcion":"DAÑO MULTITISULAR MASIVO DE PIERNA"
  },
  {
    "codigo":79633009,
    "descripcion":"HEMIPLEJÍA ESPÁSTICA"
  },
  {
    "codigo":12262002,
    "descripcion":"SUEÑO INTRANQUILO"
  },
  {
    "codigo":472849008,
    "descripcion":"ESTENOSIS DE VÁLVULA AURICULOVENTRICULAR DERECHA FETAL (MORFOLÓGICAMENTE NO TRICÚSPIDE)"
  },
  {
    "codigo":208870000,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA DE DEDO DE LA MANO"
  },
  {
    "codigo":16011871000119103,
    "descripcion":"TROMBOFLEBITIS DE AMBAS VENAS POPLÍTEAS"
  },
  {
    "codigo":833297008,
    "descripcion":"SÓLO CAPAZ DE PERCIBIR LA LUZ A TRAVÉS DE AGUJERO ESTENOPEICO CON EL OJO IZQUIERDO"
  },
  {
    "codigo":733158008,
    "descripcion":"DIVERTÍCULO DE APÉNDICE ADQUIRIDO"
  },
  {
    "codigo":45030009,
    "descripcion":"TRASTORNO DE LOS MOVIMIENTOS OCULARES"
  },
  {
    "codigo":43195002,
    "descripcion":"CAMBIOS DE TENNEY - PARKER DE LA PLACENTA"
  },
  {
    "codigo":764091001,
    "descripcion":"FISURA DE LABIO DERECHA"
  },
  {
    "codigo":403643005,
    "descripcion":"ULCERACIÓN CUTÁNEA POR METOTREXATO"
  },
  {
    "codigo":239803008,
    "descripcion":"ARTRITIS PSORIÁSICA JUVENIL CON PSORIASIS"
  },
  {
    "codigo":272571008,
    "descripcion":"DECÚBITO LATERAL IZQUIERDO CON CARA ROTADA 45 GRADOS"
  },
  {
    "codigo":762256003,
    "descripcion":"TROMBOSIS DE VENA ILÍACA"
  },
  {
    "codigo":11833951000119106,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN PERISEMILUNAR DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":338681000119102,
    "descripcion":"PIGMENTACIÓN DE SUPERFICIE POSTERIOR DE CÓRNEA DE OJO IZQUIERDO"
  },
  {
    "codigo":170597008,
    "descripcion":"CONTROL DE ANGINA - DESMEJORÍA"
  },
  {
    "codigo":365370004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD DE REALIZAR ACTIVIDADES DE JARDINERÍA"
  },
  {
    "codigo":299834009,
    "descripcion":"REFLEJO BICIPITAL TARDÍO"
  },
  {
    "codigo":4922009,
    "descripcion":"INFESTACIÓN CAUSADA POR SIMULIIDAE"
  },
  {
    "codigo":430906009,
    "descripcion":"DISTENSIÓN DE MÚSCULO RECTO FEMORAL"
  },
  {
    "codigo":166927002,
    "descripcion":"PRUEBA DE TOLERANCIA A LA GLUCOSA, ALTERADA"
  },
  {
    "codigo":297999005,
    "descripcion":"HALLAZGO RELACIONADO CON EL CRECIMIENTO DEL PELO"
  },
  {
    "codigo":1075961000119105,
    "descripcion":"TENOSINOVITIS DE PIE DERECHO"
  },
  {
    "codigo":34020007,
    "descripcion":"NEUMONÍA CAUSADA POR STREPTOCOCCUS"
  },
  {
    "codigo":294329000,
    "descripcion":"ALERGIA A DIMETICONA"
  },
  {
    "codigo":32185000,
    "descripcion":"POSICIÓN EN DECÚBITO LATERAL"
  },
  {
    "codigo":230628008,
    "descripcion":"SÍNDROME DEL PRONADOR"
  },
  {
    "codigo":1471841000168107,
    "descripcion":"INSEGURIDAD LABORAL"
  },
  {
    "codigo":10824441000119107,
    "descripcion":"FRACTURA ABIERTA DE BASE DE CUARTO HUESO METACARPIANO DE MANO DERECHA"
  },
  {
    "codigo":292494001,
    "descripcion":"REACCIÓN ADVERSA AL SALMETEROL"
  },
  {
    "codigo":1144462001,
    "descripcion":"APLASIA DE TERCER METACARPIANO"
  },
  {
    "codigo":390798007,
    "descripcion":"ASMA - HALLAZGO"
  },
  {
    "codigo":421731000,
    "descripcion":"NEUROPATÍA ÓPTICA HIPERTENSIVA"
  },
  {
    "codigo":95886009,
    "descripcion":"TRAQUEOBRONQUITIS MICOPLASMÁTICA"
  },
  {
    "codigo":94051002,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE PARTES BLANDAS DE LA AXILA"
  },
  {
    "codigo":26680000,
    "descripcion":"SIGNO DE FROMENT"
  },
  {
    "codigo":126819009,
    "descripcion":"NEOPLASIA DEL ESÓFAGO TORÁCICO"
  },
  {
    "codigo":288824005,
    "descripcion":"CAPAZ DE IMITAR PALABRAS"
  },
  {
    "codigo":876813000,
    "descripcion":"CUERPO EXTRAÑO EN MUCOSA DE LA VAGINA CON INFECCIÓN"
  },
  {
    "codigo":440831000124107,
    "descripcion":"INGESTA INADECUADA DE FLUORURO"
  },
  {
    "codigo":511000124109,
    "descripcion":"EXCLUSIÓN DE MEDICIÓN DE DESEMPEÑO POR MOTIVOS DEL PACIENTE"
  },
  {
    "codigo":90381008,
    "descripcion":"POSICIÓN OCCIPITOILÍACA ANTERIOR"
  },
  {
    "codigo":418061009,
    "descripcion":"PLIEGUES DE MUSLO ASIMÉTRICOS"
  },
  {
    "codigo":254221009,
    "descripcion":"CUTIS LAXO NEONATAL CON FENOTIPO MARFANOIDE"
  },
  {
    "codigo":186850003,
    "descripcion":"SÍFILIS SECUNDARIA DE PIEL Y MUCOSAS"
  },
  {
    "codigo":448994001,
    "descripcion":"NEOPLASIA EPITELIAL MALIGNA DE RECTO SUPERIOR"
  },
  {
    "codigo":1003443006,
    "descripcion":"ESTENOSIS CONGÉNITA DEL ORIFICIO URETRAL EXTERNO MASCULINO"
  },
  {
    "codigo":414391001,
    "descripcion":"MUCOSA HEMORRÁGICA DEL ESTÓMAGO"
  },
  {
    "codigo":283319002,
    "descripcion":"ASTILLA DE MADERA EN EL TALÓN"
  },
  {
    "codigo":15932461000119104,
    "descripcion":"TORSIÓN DE TROMPA DE FALOPIO IZQUIERDO"
  },
  {
    "codigo":1331895002,
    "descripcion":"GLAUCOMA NEOVASCULAR DE ÁNGULO CERRADO BILATERAL"
  },
  {
    "codigo":84876002,
    "descripcion":"FUNCIÓN ANAL ANORMAL"
  },
  {
    "codigo":281484005,
    "descripcion":"DEFORMIDAD VALGA ADQUIRIDA DE ARTICULACIÓN DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":838540007,
    "descripcion":"ESTENOSIS SEVERA DE VÁLVULA PULMONAR"
  },
  {
    "codigo":1197153000,
    "descripcion":"MIOPATÍA NEMALÍNICA TÍPICA"
  },
  {
    "codigo":410721001,
    "descripcion":"AMPOLLA FILTRANTE NO FUNCIONANTE"
  },
  {
    "codigo":248716008,
    "descripcion":"LATIDO AÓRTICO TRANSMITIDO EN ABDOMEN"
  },
  {
    "codigo":707468009,
    "descripcion":"CARCINOMA BRONQUIOLOALVEOLAR MUCINOSO Y NO MUCINOSO MIXTO PRIMARIO DE PULMÓN"
  },
  {
    "codigo":246881005,
    "descripcion":"NEVO CISTOIDE CONJUNTIVAL"
  },
  {
    "codigo":15987911000119102,
    "descripcion":"COLOBOMA CONGÉNITO DE CRISTALINO IZQUIERDO"
  },
  {
    "codigo":212278003,
    "descripcion":"CONTUSIÓN, NERVIO DIGITAL COMÚN"
  },
  {
    "codigo":341191000119103,
    "descripcion":"ÚLCERA CORNEAL DE HIPOPIÓN DE OJO IZQUIERDO"
  },
  {
    "codigo":15670008,
    "descripcion":"INTOXICACIÓN POR ESTROBANO"
  },
  {
    "codigo":767499000,
    "descripcion":"METAHEMOGLOBINEMIA CONGÉNITA AUTOSÓMICA RECESIVA TIPO I"
  },
  {
    "codigo":112139007,
    "descripcion":"ACEPTACIÓN DE INJERTO"
  },
  {
    "codigo":274144001,
    "descripcion":"OSTEÍTIS"
  },
  {
    "codigo":470752003,
    "descripcion":"PROGRESIÓN DE OBSTRUCCIÓN AL TRACTO DE SALIDA DEL VENTRÍCULO DERECHO FETAL"
  },
  {
    "codigo":110304005,
    "descripcion":"INCLINACIÓN DENTAL"
  },
  {
    "codigo":896736007,
    "descripcion":"FORMA DE CONO ANORMAL CONGÉNITA DE EPÍFISIS DE FALANGE DE DEDO MEDIO"
  },
  {
    "codigo":10165000,
    "descripcion":"HIPERQUERATOSIS SUBUNGUEAL"
  },
  {
    "codigo":1222581000,
    "descripcion":"CARCINOMA UROTELIAL DE VÍAS URINARIAS RICO EN LÍPIDOS"
  },
  {
    "codigo":372448007,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA RADIAL PROFUNDA DE ANO, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":11783521000119101,
    "descripcion":"AMPOLLA DE REGIÓN DE MUÑECA IZQUIERDA, CON INFECCIÓN"
  },
  {
    "codigo":763829004,
    "descripcion":"MIOPATÍA OCULOFARINGODISTAL"
  },
  {
    "codigo":698293005,
    "descripcion":"PARÁLISIS FLÁCIDA AGUDA"
  },
  {
    "codigo":15715681000119101,
    "descripcion":"SECUESTRO DE HUESO CIGOMÁTICO DERECHO"
  },
  {
    "codigo":237706000,
    "descripcion":"HIPOFISITIS AUTOINMUNITARIA"
  },
  {
    "codigo":236653921000119103,
    "descripcion":"ÚLCERA VENOSA DE PIERNA DERECHA"
  },
  {
    "codigo":8330006,
    "descripcion":"DELIRIO DE INFIDELIDAD"
  },
  {
    "codigo":204938007,
    "descripcion":"AGENESIA Y DISGENESIA RENAL"
  },
  {
    "codigo":1153375000,
    "descripcion":"GOTA AGUDA MONOARTICULAR PRIMARIA"
  },
  {
    "codigo":432479001,
    "descripcion":"MAL FUNCIONAMIENTO MECÁNICO DE DESFIBRILADOR CARDIOVERSOR IMPLANTABLE AUTOMÁTICO BIVENTRICULAR"
  },
  {
    "codigo":235871004,
    "descripcion":"PORTADOR DE HEPATITIS B"
  },
  {
    "codigo":399711005,
    "descripcion":"CONFIGURACIÓN TUMORAL ENDOFÍTICA"
  },
  {
    "codigo":168500000,
    "descripcion":"RESULTADO DE RADIOLOGÍA: NORMAL"
  },
  {
    "codigo":102964001,
    "descripcion":"POTENCIAL EVOCADO CEREBRAL NORMAL"
  },
  {
    "codigo":365108002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA LEVANTARSE DEL INODORO"
  },
  {
    "codigo":1217076005,
    "descripcion":"BAJA ESTATURA DE CAUSA PSICOSOCIAL"
  },
  {
    "codigo":234036007,
    "descripcion":"TROMBOFLEBITIS SUPERFICIAL DE LA VENA CEFÁLICA"
  },
  {
    "codigo":201268009,
    "descripcion":"URTICARIA GEOGRÁFICA"
  },
  {
    "codigo":789257001,
    "descripcion":"DESACELERACIONES TEMPRANAS Y TARDÍAS DEL LATIDO CARDÍACO FETAL"
  },
  {
    "codigo":68361004,
    "descripcion":"ANEMIA TARDÍA POR ISOINMUNIZACIÓN"
  },
  {
    "codigo":2825006,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE ENCÍA SIN INFECCIÓN"
  },
  {
    "codigo":723721007,
    "descripcion":"SÍNDROME DE HIPOACUSIA NEUROSENSORIAL, ENCANECIMIENTO PRECOZ Y TEMBLOR ESENCIAL"
  },
  {
    "codigo":461577007,
    "descripcion":"ATRESIA DE CAYADO AÓRTICO CON CORDÓN FIBROSO ENTRE ARTERIA CARÓTIDA PRIMITIVA IZQUIERDA Y ARTERIA CARÓTIDA PRIMITIVA DERECHA"
  },
  {
    "codigo":230366003,
    "descripcion":"DISTROFIA NEUROAXONAL INFANTIL Y JUVENIL TARDÍAS"
  },
  {
    "codigo":263134008,
    "descripcion":"RUPTURA DE LIGAMENTO"
  },
  {
    "codigo":295902008,
    "descripcion":"SOBREDOSIS DE TRANILCIPROMINA"
  },
  {
    "codigo":197598008,
    "descripcion":"SÍNDROME NEFRÓTICO, GLOMERULONEFRITIS MESANGIOCAPILAR DIFUSA"
  },
  {
    "codigo":12200001000119100,
    "descripcion":"POSICIÓN ANÓMALA DE PRÓTESIS DE ARTICULACIÓN DE CADERA IZQUIERDA"
  },
  {
    "codigo":308801000119100,
    "descripcion":"GOTA DE MANO DEBIDA A DISFUNCIÓN RENAL"
  },
  {
    "codigo":15709761000119102,
    "descripcion":"HIPERPIGMENTACIÓN DE PÁRPADO IZQUIERDO Y DE ÁREA PERIOCULAR IZQUIERDA"
  },
  {
    "codigo":331841000119100,
    "descripcion":"OFTALMOPLEJÍA TOTAL DE OJO DERECHO"
  },
  {
    "codigo":15740481000119104,
    "descripcion":"CONTRACCIÓN BILATERAL DE CAVIDADES ORBITARIAS"
  },
  {
    "codigo":34881000119105,
    "descripcion":"ENFERMEDAD VASCULAR PERIFÉRICA ASOCIADA CON OTRO TRASTORNO"
  },
  {
    "codigo":15668801000119105,
    "descripcion":"DEFORMIDAD CONGÉNITA DE MANO DERECHA"
  },
  {
    "codigo":15732801000119105,
    "descripcion":"HIPOTRICOSIS BILATERAL DE PÁRPADOS"
  },
  {
    "codigo":237121000119100,
    "descripcion":"CELULITIS URETRAL"
  },
  {
    "codigo":339521000119109,
    "descripcion":"ECTROPIÓN MECÁNICO DE PÁRPADO IZQUIERDO"
  },
  {
    "codigo":15663681000119109,
    "descripcion":"CONJUNTIVITIS HEMORRÁGICA AGUDA DE OJO IZQUIERDO"
  },
  {
    "codigo":367681000119106,
    "descripcion":"TRASTORNO DEL METABOLISMO DE CUERPOS CETÓNICOS"
  },
  {
    "codigo":352321000119107,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE PARTES BLANDAS DE EXTREMIDAD INFERIOR IZQUIERDA"
  },
  {
    "codigo":16779841000119104,
    "descripcion":"SÍNDROME GENITOURINARIO DE LA MENOPAUSIA"
  },
  {
    "codigo":298561000119107,
    "descripcion":"OSTEONECROSIS DE FALANGE DE DEDO DE MANO CAUSADA POR FÁRMACO"
  },
  {
    "codigo":16907841000119109,
    "descripcion":"NEVO EPIDÉRMICO DE PÁRPADO INFERIOR IZQUIERDO"
  },
  {
    "codigo":139841000119108,
    "descripcion":"ANAFILAXIA CAUSADA POR PRUEBA DE ALERGIA CUTÁNEA"
  },
  {
    "codigo":95624007,
    "descripcion":"LINFOCITOPENIA NEONATAL"
  },
  {
    "codigo":718216009,
    "descripcion":"DEFECTO PARCIAL DE CONDUCTO AURICULOVENTRICULAR"
  },
  {
    "codigo":126557001,
    "descripcion":"NEOPLASIA DEL CÓCCIX"
  },
  {
    "codigo":16836091000119107,
    "descripcion":"TUMORACIÓN DE REGIÓN SUBAREOLAR DE MAMA IZQUIERDA"
  },
  {
    "codigo":11838971000119107,
    "descripcion":"DISTENSIÓN DE MÚSCULO INTRÍNSECO DE DEDO MEDIO DE MANO IZQUIERDA"
  },
  {
    "codigo":288251000119107,
    "descripcion":"TEMOR A LAS LESIONES TRAUMÁTICAS"
  },
  {
    "codigo":93789008,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL EXOCÉRVIX"
  },
  {
    "codigo":716381003,
    "descripcion":"SÍNDROME DE MICRODELECIÓN 8P23.1"
  },
  {
    "codigo":286727000,
    "descripcion":"CARÁCTER COOPERATIVO"
  },
  {
    "codigo":91954009,
    "descripcion":"ENFERMEDAD DE LAS AZORES, TIPO II"
  },
  {
    "codigo":253959002,
    "descripcion":"HIPOPLASIA DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":1080981000119104,
    "descripcion":"MELANOMA MALIGNO DE COROIDES DERECHA"
  },
  {
    "codigo":1236999007,
    "descripcion":"INFLAMACIÓN SEBORREICA DE BORDE ANTERIOR DE PÁRPADO SUPERIOR DERECHO"
  },
  {
    "codigo":55516002,
    "descripcion":"TRASTORNO BIPOLAR I, EPISODIO MÁS RECIENTE MANÍACO DE INICIO EN EL PERÍODO POSTPARTO"
  },
  {
    "codigo":88284004,
    "descripcion":"EVALUACIÓN DE DISCAPACIDAD: 50%"
  },
  {
    "codigo":284892005,
    "descripcion":"DIFICULTAD PARA RASURARSE"
  },
  {
    "codigo":219356008,
    "descripcion":"LESIÓN POR QUEMADURAS O FUEGO, DE INTENCIONALIDAD DESCONOCIDA"
  },
  {
    "codigo":448732009,
    "descripcion":"NEOPLASIA BENIGNA DE PARTES BLANDAS DE LA PIERNA"
  },
  {
    "codigo":446897003,
    "descripcion":"LACERACIÓN DE PIEL DE LA REGIÓN PERIOCULAR"
  },
  {
    "codigo":20913004,
    "descripcion":"FÍSTULA URETROVESICOVAGINAL"
  },
  {
    "codigo":184753007,
    "descripcion":"CERTIFICADO DE LICENCIA POR ENFERMEDAD DE LAS FUERZAS: RECIBO ENTREGADO"
  },
  {
    "codigo":283057008,
    "descripcion":"ABRASIÓN DE PIEL DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":86449009,
    "descripcion":"LUXACIÓN DE NELATON"
  },
  {
    "codigo":248454007,
    "descripcion":"HIPERTERMIA ENDOCRINA"
  },
  {
    "codigo":246619000,
    "descripcion":"MOVIMIENTO DE LA CABEZA PARA MIRAR ALREDEDOR"
  },
  {
    "codigo":281222009,
    "descripcion":"MENINGOCELE POSOPERATORIO"
  },
  {
    "codigo":770907002,
    "descripcion":"SÍNDROME DE KAGAMI OGATA"
  },
  {
    "codigo":82779003,
    "descripcion":"CIERRE TARDÍO DE LA FONTANELA"
  },
  {
    "codigo":312155003,
    "descripcion":"INFECCIÓN GENITAL"
  },
  {
    "codigo":1196891006,
    "descripcion":"NEOPLASIA GLANDULAR INTRAEPITELIAL DE DUODENO DE ALTO GRADO"
  },
  {
    "codigo":703536004,
    "descripcion":"LEUCOENCEFALOPATÍA MEGAENCEFÁLICA CON QUISTES SUBCORTICALES"
  },
  {
    "codigo":769072004,
    "descripcion":"LEVADURA NO PERTENECIENTE A LAS ESPECIES CANDIDA ALBICANS NI CRYPTOCOCCUS DETECTADA"
  },
  {
    "codigo":472325000,
    "descripcion":"MIOCARDIOPATÍA HIPERTRÓFICA FETAL DEBIDA A SÍNDROME DE TRANSFUSIÓN INTERGEMELAR"
  },
  {
    "codigo":46341007,
    "descripcion":"COLECISTITIS GLANDULAR PROLIFERANTE"
  },
  {
    "codigo":77274005,
    "descripcion":"POLIURIA RELACIONADA A VASOPRESINA IDIOPÁTICA"
  },
  {
    "codigo":699866005,
    "descripcion":"PARÁLISIS BULBAR PROGRESIVA CON SORDERA NEUROSENSORIAL"
  },
  {
    "codigo":10858441000119103,
    "descripcion":"HERIDA ABIERTA DE MITAD POSTERIOR DERECHA DE PARED TORÁCICA DEBIDA A MORDEDURA DE PERRO"
  },
  {
    "codigo":110042007,
    "descripcion":"LACERACIÓN SIMPLE DE LA REGIÓN CIGOMÁTICA DE LA MEJILLA"
  },
  {
    "codigo":1156783003,
    "descripcion":"LEIOMIOSARCOMA DE RECTO"
  },
  {
    "codigo":403119006,
    "descripcion":"MICETOMA CAUSADO POR MADURELLA MYCETOMATIS"
  },
  {
    "codigo":206511007,
    "descripcion":"TROMBOCITOPENIA NEONATAL TRANSITORIA DEBIDA A TROMBOCITOPENIA MATERNA IDIOPÁTICA"
  },
  {
    "codigo":370351008,
    "descripcion":"HALLAZGO ENDOSCÓPICO"
  },
  {
    "codigo":204676004,
    "descripcion":"MUCOSA GÁSTRICA ECTÓPICA"
  },
  {
    "codigo":237444008,
    "descripcion":"MASTITIS GRANULOMATOSA"
  },
  {
    "codigo":401284008,
    "descripcion":"ESCALA DE DISNEA DE BORG: 5 - SEVERA"
  },
  {
    "codigo":202841003,
    "descripcion":"TENDINITIS DEL SUPRAESPINOSO"
  },
  {
    "codigo":366681004,
    "descripcion":"HALLAZGO RELACIONADO CON LA AMPLITUD DE LA ABDUCCIÓN DE DEDO DE LA MANO"
  },
  {
    "codigo":235609004,
    "descripcion":"ÚLCERA ESOFÁGICA INFECCIOSA"
  },
  {
    "codigo":301145006,
    "descripcion":"HALLAZGO RELACIONADO CON EL PULSO PERIFÉRICO"
  },
  {
    "codigo":1251417006,
    "descripcion":"UÑAS PUNTEADAS DEBIDO A ALOPECIA AREATA"
  },
  {
    "codigo":233774000,
    "descripcion":"FIEBRE POR HUMIDIFICADOR"
  },
  {
    "codigo":364846000,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA DETENER LA CARRERA"
  },
  {
    "codigo":299310009,
    "descripcion":"CREPITACIÓN PALPABLE DE ARTICULACIÓN DE CADERA"
  },
  {
    "codigo":1149443001,
    "descripcion":"PERIODONTITIS LOCALIZADA ESTADIO 3 GRADO A SEGÚN LA CLASIFICACIÓN DE LAS ENFERMEDADES Y ALTERACIONES PERIODONTALES Y PERIIMPLANTARIAS DE 2017 DE LA ACADEMIA ESTADOUNIDENSE DE PERIODONTOLOGÍA Y LA FEDERACIÓN EUROPEA DE PERIODONTOLOGÍA"
  },
  {
    "codigo":68099003,
    "descripcion":"INTOXICACIÓN POR CODEÍNA"
  },
  {
    "codigo":231939004,
    "descripcion":"LESIÓN TRAUMÁTICA CORNEAL"
  },
  {
    "codigo":788995007,
    "descripcion":"GLAUCOMA DE ÁNGULO ABIERTO PRIMARIO CON PRESIÓN NORMAL"
  },
  {
    "codigo":66264000,
    "descripcion":"PARÁLISIS DE TODD"
  },
  {
    "codigo":346211000119105,
    "descripcion":"ENOFTALMOS BILATERAL"
  },
  {
    "codigo":10750051000119105,
    "descripcion":"INFECCIÓN POR CHLAMYDIA TRACHOMATIS EN LA MADRE QUE COMPLICA EL NACIMIENTO"
  },
  {
    "codigo":721624000,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE LESIÓN SUPERPUESTA DE ESÓFAGO"
  },
  {
    "codigo":262872006,
    "descripcion":"DESGARRO SEROSO DE COLON"
  },
  {
    "codigo":295640008,
    "descripcion":"SOBREDOSIS DE MUSTINA"
  },
  {
    "codigo":719789000,
    "descripcion":"ANTICUERPO ANTI-VIRUS DE INMUNODEFICIENCIA HUMANA TIPO 2 DETECTADO Y REACTIVIDAD CRUZADA CON ANTICUERPO ANTI-VIRUS DE INMUNODEFICIENCIA HUMANA TIPO 1"
  },
  {
    "codigo":195501006,
    "descripcion":"INFARTO DE VASO LINFÁTICO"
  },
  {
    "codigo":293805007,
    "descripcion":"ALERGIA A ANFEPRAMONA"
  },
  {
    "codigo":128130001,
    "descripcion":"TRASTORNO DE LA REGIÓN DE LA MUÑECA"
  },
  {
    "codigo":191831000,
    "descripcion":"DEPENDENCIA DE LA COCAÍNA, CONTINUA"
  },
  {
    "codigo":29826009,
    "descripcion":"INTOXICACIÓN POR DIMPILATO"
  },
  {
    "codigo":291970009,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR FUROSEMIDA"
  },
  {
    "codigo":290135001,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR PARACETAMOL"
  },
  {
    "codigo":1142103004,
    "descripcion":"TAQUICARDIA RECIPROCANTE AURICULOVENTRICULAR ANTIDRÓMICA QUE UTILIZA VÍA ACCESORIA NODOFASCICULAR CON CONDUCCIÓN UNIDIRECCIONAL ANTERÓGRADA"
  },
  {
    "codigo":93527005,
    "descripcion":"ENFERMEDAD DE HODGKIN DEL BAZO"
  },
  {
    "codigo":160898008,
    "descripcion":"RETIRADO POR RAZONES MÉDICAS"
  },
  {
    "codigo":1173036000,
    "descripcion":"DEFECTO COMBINADO DE LA FOSFORILACIÓN OXIDATIVA TIPO 23"
  },
  {
    "codigo":11843991000119100,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE PABELLÓN AURICULAR IZQUIERDO"
  },
  {
    "codigo":124460007,
    "descripcion":"DEFICIENCIA DE LISOZIMA"
  },
  {
    "codigo":253697000,
    "descripcion":"AISLAMIENTO DE RAMA DEL CAYADO AÓRTICO"
  },
  {
    "codigo":10942871000119101,
    "descripcion":"LESIÓN TRAUMÁTICA DE GLOBO OCULAR DERECHO"
  },
  {
    "codigo":24321005,
    "descripcion":"MENINGITIS FÚNGICA"
  },
  {
    "codigo":57089007,
    "descripcion":"BRONQUIOLITIS POR VIRUS RESPIRATORIO SINCICIAL"
  },
  {
    "codigo":450305007,
    "descripcion":"COARTACIÓN DE AORTA ABDOMINAL INFRARRENAL"
  },
  {
    "codigo":219094001,
    "descripcion":"REACCIÓN ADVERSA A COMPONENTE DE VACUNA CONTRA EL TIFUS"
  },
  {
    "codigo":286465008,
    "descripcion":"CAPAZ DE CORTAR ALIMENTOS"
  },
  {
    "codigo":284630001,
    "descripcion":"EMPUJAR A OTRA PERSONA"
  },
  {
    "codigo":22486004,
    "descripcion":"TRICORREXIS NUDOSA"
  },
  {
    "codigo":1169366007,
    "descripcion":"FIEBRE PERIÓDICA DEPENDIENTE DEL CICLO MENSTRUAL"
  },
  {
    "codigo":186326007,
    "descripcion":"ADENITIS MESENTÉRICA POR PASTEURELLA"
  },
  {
    "codigo":282795001,
    "descripcion":"LESIÓN DE TRONCO SIMPÁTICO"
  },
  {
    "codigo":448470007,
    "descripcion":"ARTERIAS PULMONARES CONFLUENTES"
  },
  {
    "codigo":315563003,
    "descripcion":"NACIDO EN ZAIRE"
  },
  {
    "codigo":250027007,
    "descripcion":"MARCHA DE TRASTORNO SENSITIVO PERIFÉRICO"
  },
  {
    "codigo":248192000,
    "descripcion":"DAÑO DE LA PIEL DEL ROSTRO POR ACCIÓN DEL SOL"
  },
  {
    "codigo":53419009,
    "descripcion":"CIRCULAR DEL CORDÓN"
  },
  {
    "codigo":84352000,
    "descripcion":"ÚLCERA DE LA VESÍCULA SEMINAL"
  },
  {
    "codigo":280960002,
    "descripcion":"NEOPLASIA BENIGNA DE ESTRUCTURA DE DRENAJE LAGRIMAL"
  },
  {
    "codigo":1264000005,
    "descripcion":"CICATRIZ OCULAR DEBIDA A CIRUGÍA FILTRANTE DE GLAUCOMA Y POSTERIOR A ELLA"
  },
  {
    "codigo":117120006,
    "descripcion":"CALIDAD DEL SOPLO CARDÍACO, MUSICAL"
  },
  {
    "codigo":1231232007,
    "descripcion":"UVEÍTIS INTERMEDIA ASOCIADA CON ESCLEROSIS MÚLTIPLE"
  },
  {
    "codigo":732330391000119107,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DEBIDO A EMBOLIA DE AMBAS ARTERIAS VERTEBRALES"
  },
  {
    "codigo":1260330000,
    "descripcion":"MIGRAÑA HEMIPLÉJICA FAMILIAR TIPO 2"
  },
  {
    "codigo":47914002,
    "descripcion":"MOTIVACIÓN ANORMAL"
  },
  {
    "codigo":408362004,
    "descripcion":"CONTROL DE MEDICACIÓN ACTUALIZADO"
  },
  {
    "codigo":1293098006,
    "descripcion":"CARCINOMA MIOEPITELIAL"
  },
  {
    "codigo":703274008,
    "descripcion":"INSUFICIENCIA CARDÍACA CON FRACCIÓN DE EYECCIÓN DISMINUIDA DEBIDA A MIOCARDITIS"
  },
  {
    "codigo":111615001,
    "descripcion":"FRACTURA DE CRÁNEO EXPUESTA CON HEMORRAGIA INTRACRANEAL"
  },
  {
    "codigo":109780000,
    "descripcion":"ABSCESO DE ESPACIO CANINO DE LA BOCA"
  },
  {
    "codigo":184881000119106,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE UNIÓN RECTOSIGMOIDE"
  },
  {
    "codigo":765140006,
    "descripcion":"SÍNDROME DE DUPLICACIÓN 8P23.1"
  },
  {
    "codigo":404692007,
    "descripcion":"CORECTOPIA MESENCEFÁLICA"
  },
  {
    "codigo":402857001,
    "descripcion":"INFECCIÓN CUTÁNEA POR VIRUS DEL HERPES HUMANO 8"
  },
  {
    "codigo":1254825003,
    "descripcion":"NEOPLASIA MESENQUIMATOSA PRIMARIA MALIGNA DE ANO"
  },
  {
    "codigo":1287593005,
    "descripcion":"LEUCEMIA LINFOBLÁSTICA\/LINFOMA LINFOBLÁSTICO TEMPRANO DE CÉLULAS T PRECURSORAS"
  },
  {
    "codigo":206249007,
    "descripcion":"HEMORRAGIA SUBCONJUNTIVAL POR TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":1086001000119108,
    "descripcion":"CARIES DENTAL SOBRE SUPERFICIE LISA QUE PENETRA HASTA LA PULPA"
  },
  {
    "codigo":347221000119101,
    "descripcion":"BLEFAROCONJUNTIVITIS ANGULAR DE AMBOS OJOS"
  },
  {
    "codigo":73342002,
    "descripcion":"OBSTRUCCIÓN DE LA TRÁQUEA"
  },
  {
    "codigo":7806002,
    "descripcion":"XERODERMIA PIGMENTOSA NO NEUROLÓGICA"
  },
  {
    "codigo":1003912005,
    "descripcion":"DELECIÓN PROXIMAL DEL BRAZO CORTO DEL CROMOSOMA 6"
  },
  {
    "codigo":202579001,
    "descripcion":"OSTEOCONDROMATOSIS SINOVIAL DE ARTICULACIÓN RADIOCUBITAL DISTAL"
  },
  {
    "codigo":366419002,
    "descripcion":"AMPLITUD DE LA ROTACIÓN DERECHA DE COLUMNA DORSAL - HALLAZGO"
  },
  {
    "codigo":38739001,
    "descripcion":"TROMBOSIS DE LA VENA HEPÁTICA"
  },
  {
    "codigo":300883004,
    "descripcion":"TUMEFACCIÓN DE EPIDÍDIMO"
  },
  {
    "codigo":268115005,
    "descripcion":"CUERPO EXTRAÑO DEJADO EN CODO"
  },
  {
    "codigo":399187006,
    "descripcion":"HEMOCROMATOSIS"
  },
  {
    "codigo":4136000,
    "descripcion":"MACRODACTILIA DE DEDO DEL PIE"
  },
  {
    "codigo":167976001,
    "descripcion":"LÍQUIDO PLEURAL: TRASUDADO"
  },
  {
    "codigo":299048005,
    "descripcion":"SIGNO CON NOMBRE PROPIO DE LA MANO"
  },
  {
    "codigo":200744008,
    "descripcion":"PARONIQUIA CRÓNICA"
  },
  {
    "codigo":15887051000119108,
    "descripcion":"BEBÉ PREMATURO, 25 SEMANAS"
  },
  {
    "codigo":2301009,
    "descripcion":"FACTOR PSICOSOMÁTICO EN UNA ENFERMEDAD FÍSICA, COMPONENTE PSICOLÓGICO DE GRADO DESCONOCIDO"
  },
  {
    "codigo":426450003,
    "descripcion":"SOBREDOSIS INTENCIONAL DE CLORPROTIXENO"
  },
  {
    "codigo":295378004,
    "descripcion":"SOBREDOSIS INTENCIONAL DE LANSOPRAZOL"
  },
  {
    "codigo":66002008,
    "descripcion":"HIPERLISINEMIA PERSISTENTE"
  },
  {
    "codigo":721362009,
    "descripcion":"LESIÓN COMPLETA DE MÉDULA ESPINAL CERVICAL"
  },
  {
    "codigo":262610009,
    "descripcion":"CUERPO EXTRAÑO UMBILICAL"
  },
  {
    "codigo":195239002,
    "descripcion":"EFECTOS TARDÍOS DE LA ENFERMEDAD CEREBROVASCULAR"
  },
  {
    "codigo":293543001,
    "descripcion":"REACCIÓN ADVERSA AL TRINITRATO DE GLICERILO POR VÍA ORAL"
  },
  {
    "codigo":162471005,
    "descripcion":"SÍNTOMA MUY GRAVE"
  },
  {
    "codigo":129703005,
    "descripcion":"CON MAYOR RIESGO DE LESIÓN POSTURAL PERIOPERATORIA"
  },
  {
    "codigo":1145511005,
    "descripcion":"APLASIA DE FALANGE MEDIA DE DEDO MEDIO DE MANO"
  },
  {
    "codigo":31399009,
    "descripcion":"ABSCESO DE CUERO CABELLUDO"
  },
  {
    "codigo":95100003,
    "descripcion":"NEOPLASIA DE PARTES BLANDAS DEL PERINEO DE COMPORTAMIENTO INCIERTO"
  },
  {
    "codigo":160636006,
    "descripcion":"EJERCICIO AERÓBICO, NINGUNA VEZ POR SEMANA"
  },
  {
    "codigo":62332007,
    "descripcion":"CISTINOSIS NEFROPÁTICA INFANTIL"
  },
  {
    "codigo":226172009,
    "descripcion":"DIETA RICA EN CROMO"
  },
  {
    "codigo":93265002,
    "descripcion":"HIPOPLASIA CONGÉNITA DE HUESO HIOIDES"
  },
  {
    "codigo":191569002,
    "descripcion":"ESQUIZOFRENIA ESQUIZOAFECTIVA SUBCRÓNICA"
  },
  {
    "codigo":27729002,
    "descripcion":"ATRESIA PILÓRICA"
  },
  {
    "codigo":420945005,
    "descripcion":"HISTOPLASMOSIS ASOCIADA CON SIDA"
  },
  {
    "codigo":289873006,
    "descripcion":"PERINEO SECO"
  },
  {
    "codigo":1141841007,
    "descripcion":"SIGNO DE DARIER"
  },
  {
    "codigo":224337002,
    "descripcion":"ACTÚA COMO TESTIGO POLICIAL"
  },
  {
    "codigo":124198001,
    "descripcion":"DEFICIENCIA DE SULFITO REDUCTASA"
  },
  {
    "codigo":253435000,
    "descripcion":"DILATACIÓN DE ANILLO DE VÁLVULA AURICULOVENTRICULAR COMÚN"
  },
  {
    "codigo":286203001,
    "descripcion":"DIFICULTAD PARA ABRIR LA CASA CUANDO ESTÁ CERRADA"
  },
  {
    "codigo":1088511000119104,
    "descripcion":"OTITIS EXTERNA CRÓNICA DE CONDUCTO AUDITIVO EXTERNO IZQUIERDO"
  },
  {
    "codigo":92211008,
    "descripcion":"NEOPLASIA BENIGNA DE SENO MAXILAR"
  },
  {
    "codigo":712072191000119105,
    "descripcion":"INFECCIÓN DE CÓRNEA TRASPLANTADA DE OJO IZQUIERDO"
  },
  {
    "codigo":24059009,
    "descripcion":"ATAXIA CEREBELOSA AGUDA CAUSADA POR VARICELA"
  },
  {
    "codigo":1269243009,
    "descripcion":"TROMBOSIS DE AMBAS ARTERIAS CARÓTIDAS"
  },
  {
    "codigo":448208003,
    "descripcion":"COMUNICACIÓN INTERAURICULAR NO RESTRICTIVA"
  },
  {
    "codigo":184229000,
    "descripcion":"RESUMEN DE NOTAS EN COMPUTADORA"
  },
  {
    "codigo":1003429001,
    "descripcion":"DISPLASIA CORTICAL FOCAL TIPO IIA"
  },
  {
    "codigo":678911000119107,
    "descripcion":"HUSO DE KRUKENBERG BILATERAL"
  },
  {
    "codigo":708517006,
    "descripcion":"DIVERGENCIA DE RAÍZ DE DIENTE"
  },
  {
    "codigo":249765007,
    "descripcion":"DEDO DE LA MANO CORTO"
  },
  {
    "codigo":15725721000119102,
    "descripcion":"SÍNDROME DE IMPACTO CUBITAL DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":282533009,
    "descripcion":"NO BAJA ESCALERAS CORRIENDO"
  },
  {
    "codigo":1296506004,
    "descripcion":"ABSCESO DE BOLSA SEROSA PRERROTULIANA"
  },
  {
    "codigo":1263738005,
    "descripcion":"PROLAPSO DE ÚTERO CON ENTEROCELE"
  },
  {
    "codigo":351231000119109,
    "descripcion":"NEOPLASIA BENIGNA DE HUESO LARGO DE MIEMBRO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":247930008,
    "descripcion":"MOVIMIENTOS TORSIONALES COMPLEJOS REPETITIVOS DE TODO EL CUERPO"
  },
  {
    "codigo":442703001,
    "descripcion":"PRUEBA DE ASPIRACIÓN NEGATIVA PARA AIRE DURANTE PROCEDIMIENTO"
  },
  {
    "codigo":737615007,
    "descripcion":"CONSCIENCIA ACCIDENTAL BAJO ANESTESIA GENERAL DURANTE EMERGENCIA O EXTUBACIÓN"
  },
  {
    "codigo":735780000,
    "descripcion":"HERIDA PUNZANTE DE REGIÓN LUMBAR SIN CUERPO EXTRAÑO"
  },
  {
    "codigo":277028004,
    "descripcion":"ANOMALÍA DIFUSA DE LA CONDUCCIÓN NERVIOSA MOTORA"
  },
  {
    "codigo":80420005,
    "descripcion":"MONOPLEJÍA DE MIEMBRO INFERIOR"
  },
  {
    "codigo":211492005,
    "descripcion":"CONTUSIÓN DEL CÓCCIX"
  },
  {
    "codigo":440868005,
    "descripcion":"ENFERMEDAD LEVE POR DEFICIENCIA HEREDITARIA DE FACTOR IX CON INHIBIDORES"
  },
  {
    "codigo":439033000,
    "descripcion":"CONCENTRACIÓN URINARIA DE PROTEÍNA DE LA CADENA NEURONAL AD7C POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":703012009,
    "descripcion":"CITROBACTER WERKMANII O CITROBACTER YOUNGAE"
  },
  {
    "codigo":1260068009,
    "descripcion":"ADENOCARCINOMA PAPILAR DE PULMÓN"
  },
  {
    "codigo":111353003,
    "descripcion":"ÚLCERA PÉPTICA AGUDA CON HEMORRAGIA Y PERFORACIÓN"
  },
  {
    "codigo":209657004,
    "descripcion":"SECCIÓN EXPUESTA DE LIGAMENTO DE HOMBRO"
  },
  {
    "codigo":14884007,
    "descripcion":"OLIGOMENORREA PRIMARIA"
  },
  {
    "codigo":733945008,
    "descripcion":"CARIES DENTAL ACTIVA SECUNDARIA QUE SE EXTIENDE HASTA LA MITAD INTERNA DEL ESMALTE"
  },
  {
    "codigo":109518003,
    "descripcion":"HIPERPLASIA MANDIBULAR VERTICAL CONGÉNITA"
  },
  {
    "codigo":240590004,
    "descripcion":"INFECCIÓN POR CLAMIDIA EN EL RECIÉN NACIDO"
  },
  {
    "codigo":43982006,
    "descripcion":"DEGENERACIÓN SOLAR"
  },
  {
    "codigo":40312006,
    "descripcion":"PERICARDITIS SECUNDARIA A TUMOR CON METÁSTASIS EN EL PERICARDIO"
  },
  {
    "codigo":204152008,
    "descripcion":"ANOMALÍA DE AXENFELD"
  },
  {
    "codigo":300621002,
    "descripcion":"CAPAZ DE VIAJAR EN TRANSPORTE PÚBLICO"
  },
  {
    "codigo":366157005,
    "descripcion":"HALLAZGO EN LA MEDICIÓN CARDIOVASCULAR"
  },
  {
    "codigo":202317007,
    "descripcion":"ANQUILOSIS ROTULIANA"
  },
  {
    "codigo":235085008,
    "descripcion":"RELACIÓN INCISAL"
  },
  {
    "codigo":398925009,
    "descripcion":"TRASTORNO DE NERVIO MOTOR OCULAR EXTERNO"
  },
  {
    "codigo":724770001,
    "descripcion":"ATAXIA CONCOMITANTE CON ABETALIPOPROTEINEMIA Y DEBIDA A ELLA"
  },
  {
    "codigo":167714004,
    "descripcion":"PRESIÓN DE LÍQUIDO CEFALORRAQUÍDEO: BAJA"
  },
  {
    "codigo":296951000,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE VITAMINA A"
  },
  {
    "codigo":788471001,
    "descripcion":"TRASTORNO REPETITIVO DEL MOVIMIENTO DEL HOMBRO IZQUIERDO"
  },
  {
    "codigo":1279991001,
    "descripcion":"CRISIS EPILÉPTICA DE INICIO NO MOTOR CON ALTERACIÓN DE CONCIENCIA DE INICIO FOCAL"
  },
  {
    "codigo":1148919002,
    "descripcion":"GLOMERULOPATÍA DEBIDA A DREPANOCITOSIS HETEROCIGÓTICA DOBLE"
  },
  {
    "codigo":198647008,
    "descripcion":"INSUFICIENCIA RENAL DEBIDA A ABORTO ESPONTÁNEO INCOMPLETO Y POSTERIOR A ÉL"
  },
  {
    "codigo":165879008,
    "descripcion":"TÍTULO DE AUTOANTICUERPOS POSITIVO"
  },
  {
    "codigo":295116004,
    "descripcion":"ALERGIA A QUIMOTRIPSINA"
  },
  {
    "codigo":65740005,
    "descripcion":"VOLUMEN ESPIRATORIO FORZADO AUMENTADO"
  },
  {
    "codigo":196812007,
    "descripcion":"HERNIA INGUINAL IRREDUCTIBLE BILATERAL"
  },
  {
    "codigo":721100009,
    "descripcion":"TRASTORNO CONGÉNITO DE LA GLICOSILACIÓN POR ALTERACIÓN DE COG5"
  },
  {
    "codigo":424353002,
    "descripcion":"OPACIDAD CORNEAL CAUSADA POR HERPES ZÓSTER"
  },
  {
    "codigo":31137003,
    "descripcion":"SÍFILIS TEMPRANA, LATENTE, SEROLOGÍA POSITIVA, LÍQUIDO CEFALORRAQUÍDEO NEGATIVO, MENOS DE 2 AÑOS DESPUÉS DE LA INFECCIÓN"
  },
  {
    "codigo":293281005,
    "descripcion":"REACCIÓN ADVERSA A LA TRIPTORELINA"
  },
  {
    "codigo":1091021000119108,
    "descripcion":"INFLAMACIÓN CRÓNICA DE TROMPA FARINGOTIMPÁNICA DERECHA"
  },
  {
    "codigo":16711271000119102,
    "descripcion":"EDEMA DE MÁCULA RETINIANA DEBIDO A OCLUSIÓN DE VENA CENTRAL DE LA RETINA IZQUIERDA"
  },
  {
    "codigo":1340022003,
    "descripcion":"TRASTORNO DE LIGAMENTO DE REGIÓN DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":94838006,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE FÉMUR"
  },
  {
    "codigo":93003001,
    "descripcion":"ANOMALÍA CONGÉNITA DE LOS HUESOS DE LA CABEZA FETAL"
  },
  {
    "codigo":846667001,
    "descripcion":"OCLUSIÓN DE RAMA DIAGONAL DE RAMA DESCENDENTE ANTERIOR DE ARTERIA CORONARIA IZQUIERDA"
  },
  {
    "codigo":289611004,
    "descripcion":"HIMEN NO OBSERVADO"
  },
  {
    "codigo":1010507005,
    "descripcion":"ESCLEROSIS DE EPÍFISIS DE FALANGE DE DEDO ANULAR CON RADIOPACIDAD AUMENTADA"
  },
  {
    "codigo":1172512000,
    "descripcion":"OXITOCINA DENTRO DE RANGO DE REFERENCIA"
  },
  {
    "codigo":420683009,
    "descripcion":"TRASTORNO DEL SISTEMA NERVIOSO DEBIDO A DIABETES MELLITUS RELACIONADA CON DESNUTRICIÓN"
  },
  {
    "codigo":255008003,
    "descripcion":"CARCINOMA ESCAMOSO DE CÓRNEA"
  },
  {
    "codigo":123936006,
    "descripcion":"INTOXICACIÓN POR ROSACEAE"
  },
  {
    "codigo":386080007,
    "descripcion":"DEFICIENCIA DE VITAMINA B6"
  },
  {
    "codigo":449781000,
    "descripcion":"DENSIDAD ÓSEA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":187637005,
    "descripcion":"NEOPLASIA MALIGNA DE LA PUNTA Y EL BORDE LATERAL DE LA LENGUA"
  },
  {
    "codigo":285941007,
    "descripcion":"CAPAZ DE MANEJAR LOS CONTROLES DE LA DUCHA"
  },
  {
    "codigo":284106004,
    "descripcion":"NO CONTROLA LA POSICIÓN"
  },
  {
    "codigo":185802005,
    "descripcion":"CONCURRE AL CONTROL DE SALUD DE LA MUJER"
  },
  {
    "codigo":710090006,
    "descripcion":"MALA OCLUSIÓN DE CÚSPIDES CLASE III"
  },
  {
    "codigo":249503000,
    "descripcion":"RUIDOS ABDOMINALES"
  },
  {
    "codigo":52895001,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE VAGINA CON INFECCIÓN"
  },
  {
    "codigo":413343005,
    "descripcion":"INCONTINENCIA URINARIA MIXTA"
  },
  {
    "codigo":51060001,
    "descripcion":"DIPROSOPO TETROFTALMO"
  },
  {
    "codigo":216735009,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR TALIO"
  },
  {
    "codigo":1263476003,
    "descripcion":"NEOPLASIA MALIGNA DE PARTES BLANDAS DE MIEMBRO INFERIOR"
  },
  {
    "codigo":10950401000119106,
    "descripcion":"HERIDA PUNZANTE DE FARINGE"
  },
  {
    "codigo":247668007,
    "descripcion":"DELIRIO DE CAPACIDAD GRANDIOSA"
  },
  {
    "codigo":870260008,
    "descripcion":"TRASTORNO GENERALIZADO DEL DESARROLLO CON ALTERACIÓN ACENTUADA DEL LENGUAJE FUNCIONAL CON PÉRDIDA DE HABILIDADES ADQUIRIDAS PREVIAMENTE"
  },
  {
    "codigo":16457003,
    "descripcion":"EVALUACIÓN DE DISCAPACIDAD: 65%"
  },
  {
    "codigo":737353005,
    "descripcion":"DIFICULTAD CON LA PARTICIPACIÓN COMUNITARIA"
  },
  {
    "codigo":278601008,
    "descripcion":"PUENTE DENTAL QUE FILTRA"
  },
  {
    "codigo":1359945009,
    "descripcion":"BACTERIAS EN AGRUPACIÓN AISLADA"
  },
  {
    "codigo":409673008,
    "descripcion":"NIVEL DE ALANINA AMINOTRANSFERASA (TRANSAMINASA GLUTÁMICO PIRÚVICA SÉRICA) POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":735518003,
    "descripcion":"INFECCIÓN DE SISTEMA DIGESTIVO CAUSADA POR MYCOBACTERIUM TUBERCULOSIS"
  },
  {
    "codigo":309534003,
    "descripcion":"ALTURA NORMAL"
  },
  {
    "codigo":473374005,
    "descripcion":"PERFORACIÓN DE VALVA DE VÁLVULA MITRAL"
  },
  {
    "codigo":1259806004,
    "descripcion":"NEFROBLASTOMA PRIMARIO DE RIÑÓN DERECHO"
  },
  {
    "codigo":897523003,
    "descripcion":"PULGAR TRIFALÁNGICO BILATERAL"
  },
  {
    "codigo":209395004,
    "descripcion":"FRACTURA-LUXACIÓN EXPUESTA DE LA PELVIS"
  },
  {
    "codigo":307699005,
    "descripcion":"NISTAGMO PRESENTE"
  },
  {
    "codigo":406003007,
    "descripcion":"HAPLOTIPO CDE"
  },
  {
    "codigo":404168000,
    "descripcion":"HISTIOCITOSIS DE CÉLULAS NO DETERMINADAS"
  },
  {
    "codigo":438771009,
    "descripcion":"LESIÓN TRAUMÁTICA DE LECHO UNGUEAL DE PULGAR"
  },
  {
    "codigo":238493000,
    "descripcion":"SEUDOFOLICULITIS"
  },
  {
    "codigo":305864009,
    "descripcion":"ATENDIDO POR SERVICIO HOSPITALARIO DE FONOAUDIOLOGÍA"
  },
  {
    "codigo":41885002,
    "descripcion":"GOLPE PERICÁRDICO"
  },
  {
    "codigo":74653006,
    "descripcion":"ENFERMEDAD DE COBALAMINA C"
  },
  {
    "codigo":402333008,
    "descripcion":"APARICIÓN DE PSORIASIS EN LA ADULTEZ TEMPRANA (20-40 AÑOS)"
  },
  {
    "codigo":1155997009,
    "descripcion":"SOBREDOSIS DE SUSTANCIA CON ESTRUCTURA DE AMINOGLUCÓSIDO Y MECANISMO DE ACCIÓN ANTIBACTERIANO"
  },
  {
    "codigo":300359004,
    "descripcion":"HALLAZGO RELACIONADO CON EL VÓMITO"
  },
  {
    "codigo":365895006,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA RECORDAR EL MES DEL AÑO"
  },
  {
    "codigo":38215007,
    "descripcion":"SÍNDROME OCULODENTODIGITAL"
  },
  {
    "codigo":890183008,
    "descripcion":"LINFEDEMA POR PODOCONIOSIS"
  },
  {
    "codigo":1119559009,
    "descripcion":"PUENTE NASAL CORTO"
  },
  {
    "codigo":726343007,
    "descripcion":"TRISOMÍA PARCIAL DE CROMOSOMA 5"
  },
  {
    "codigo":15648821000119105,
    "descripcion":"ATEROSCLEROSIS DE ARTERIA RENAL IZQUIERDA"
  },
  {
    "codigo":724508005,
    "descripcion":"HIPOVENTILACIÓN CENTRAL DE COMIENZO TARDÍO CONCOMITANTE CON DISFUNCIÓN HIPOTALÁMICA Y DEBIDA A ELLA"
  },
  {
    "codigo":1148657000,
    "descripcion":"AMPLITUD DE ELECTRORRETINOGRAMA DE CENTELLEO CON ADAPTACIÓN A LA LUZ ANORMAL"
  },
  {
    "codigo":198385002,
    "descripcion":"LACERACIÓN ANTIGUA O CICATRIZ DE LA VULVA"
  },
  {
    "codigo":303311000119101,
    "descripcion":"MIOSITIS OSIFICANTE DE MÚSCULO DE MANO IZQUIERDA DEBIDA A QUEMADURA"
  },
  {
    "codigo":1279729004,
    "descripcion":"COREA DEBIDA A TRAUMATISMO CRANEOENCEFÁLICO"
  },
  {
    "codigo":1777007,
    "descripcion":"DISOCIACIÓN MOLECULAR AUMENTADA"
  },
  {
    "codigo":296689008,
    "descripcion":"SOBREDOSIS INTENCIONAL DE CEFRADINA"
  },
  {
    "codigo":722673007,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE AMÍGDALA LINGUAL"
  },
  {
    "codigo":131014006,
    "descripcion":"NIVEL DE HORMONA ESTIMULANTE DE LOS MELANOCITOS POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":294854007,
    "descripcion":"ALERGIA A SOLUCIÓN DE ALBÚMINA"
  },
  {
    "codigo":63643000,
    "descripcion":"ALTERACIÓN DE RODILLA"
  },
  {
    "codigo":129179000,
    "descripcion":"SÍNDROME PIRIFORME"
  },
  {
    "codigo":1144987003,
    "descripcion":"AMENORREA DEBIDA A TRASTORNO HIPOFISARIO"
  },
  {
    "codigo":260251005,
    "descripcion":"J14"
  },
  {
    "codigo":161947006,
    "descripcion":"TOS Y SIBILANCIA NOCTURNAS"
  },
  {
    "codigo":293019006,
    "descripcion":"REACCIÓN ADVERSA A LA CEFAMICINA"
  },
  {
    "codigo":424091006,
    "descripcion":"COLANGIOADENOMA"
  },
  {
    "codigo":127344002,
    "descripcion":"OTOPATÍA AGUDA"
  },
  {
    "codigo":291184003,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR PIPOTIAZINA"
  },
  {
    "codigo":10625231000119106,
    "descripcion":"BRONCONEUMONÍA CAUSADA POR HAEMOPHILUS INFLUENZAE"
  },
  {
    "codigo":94576007,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA PIEL DEL OMBLIGO"
  },
  {
    "codigo":61808009,
    "descripcion":"NEOPLASIA ENDOCRINA MÚLTIPLE, TIPO 2"
  },
  {
    "codigo":422256009,
    "descripcion":"CUENTA DEDOS - DISTANCIA VISUAL"
  },
  {
    "codigo":31081000119101,
    "descripcion":"DEMENCIA PRESENIL CON IDEAS DELIRANTES"
  },
  {
    "codigo":225648009,
    "descripcion":"OPTIMISTA"
  },
  {
    "codigo":92741006,
    "descripcion":"CARCINOMA IN SITU DE PIEL DE HOMBRO"
  },
  {
    "codigo":289349009,
    "descripcion":"PELOTEO DE LA PRESENTACIÓN"
  },
  {
    "codigo":90906005,
    "descripcion":"HALLAZGO RELACIONADO CON REFLEJO OCULOVESTIBULAR"
  },
  {
    "codigo":15677801000119103,
    "descripcion":"CORIORRETINITIS DE OJO DERECHO DEBIDA A SÍFILIS SECUNDARIA"
  },
  {
    "codigo":713498009,
    "descripcion":"TRASTORNO DEL RITMO CIRCADIANO DE SUEÑO, TIPO CAMBIO DE TURNO DE TRABAJO"
  },
  {
    "codigo":416751004,
    "descripcion":"DISMINUCIÓN DEL ABUSO DE DROGAS"
  },
  {
    "codigo":1268719004,
    "descripcion":"ASTROCITOMA ANAPLÁSICO PRIMARIO DE SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":414916001,
    "descripcion":"OBESIDAD"
  },
  {
    "codigo":283844001,
    "descripcion":"LESIÓN POR DESOLLAMIENTO DE MUÑECA"
  },
  {
    "codigo":113001000119106,
    "descripcion":"ARTROSIS DE ARTICULACIÓN DE DEDO DE AMBAS MANOS"
  },
  {
    "codigo":447684006,
    "descripcion":"SEPSIS CAUSADA POR ERYSIPELOTHRIX"
  },
  {
    "codigo":445849005,
    "descripcion":"OBSTRUCCIÓN DE CONDUCTO AUDITIVO EXTERNO"
  },
  {
    "codigo":19865006,
    "descripcion":"ALUCINACIONES FUNCIONALES"
  },
  {
    "codigo":16906601000119108,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE PÁRPADO INFERIOR IZQUIERDO"
  },
  {
    "codigo":1197678000,
    "descripcion":"DUODENITIS POR VASCULITIS POR INMUNOGLOBULINA A"
  },
  {
    "codigo":247406002,
    "descripcion":"UMBRAL DE DOLOR AUMENTADO"
  },
  {
    "codigo":312942003,
    "descripcion":"NEUROPATÍA ÓPTICA HEREDITARIA"
  },
  {
    "codigo":686441000119109,
    "descripcion":"GLIOMA MALIGNO PRIMARIO DE LÓBULO OCCIPITAL"
  },
  {
    "codigo":16195001,
    "descripcion":"TETANIA HIPOCALCÉMICA PARATIROIDEA"
  },
  {
    "codigo":1163075005,
    "descripcion":"ENDOCARDITIS INFECCIOSA SUBAGUDA DE LADO IZQUIERDO DEL CORAZÓN"
  },
  {
    "codigo":86531000119105,
    "descripcion":"DEPÓSITOS ANORMALES DE LÍPIDOS"
  },
  {
    "codigo":1259544000,
    "descripcion":"CARCINOMA BASOCELULAR PRIMARIO - ADENOIDE"
  },
  {
    "codigo":4611000119106,
    "descripcion":"INSUFICIENCIA VASCULAR DE RIÑÓN"
  },
  {
    "codigo":473112005,
    "descripcion":"EXTRAVASACIÓN DE CATÉTER DE TENCKHOFF"
  },
  {
    "codigo":440344006,
    "descripcion":"RECIBIÓ EDUCACIÓN DE POSGRADO"
  },
  {
    "codigo":897261001,
    "descripcion":"CURVATURA ANORMAL DE FALANGE PROXIMAL DE PIE"
  },
  {
    "codigo":372973002,
    "descripcion":"INFECCIÓN CAUSADA POR ASPERGILLUS AWAMORI"
  },
  {
    "codigo":241901005,
    "descripcion":"EFECTO TÓXICO CAUSADO POR COMPUESTO ENRAIZANTE"
  },
  {
    "codigo":78061006,
    "descripcion":"HOMBRE VIUDO"
  },
  {
    "codigo":471277007,
    "descripcion":"ARTERIA CORONARIA DERECHA ÚNICA QUE IRRIGA A TODO EL CORAZÓN CON LA DISTRIBUCIÓN HABITUAL DE LA ARTERIA CORONARIA IZQUIERDA DERIVADA DE LA ARTERIA CORONARIA DERECHA DISTAL"
  },
  {
    "codigo":438509009,
    "descripcion":"RIGIDEZ EN EL CUADRANTE INFERIOR DERECHO DEL ABDOMEN"
  },
  {
    "codigo":403906006,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS METASTÁSICO"
  },
  {
    "codigo":698818007,
    "descripcion":"FRAGMENTOS DE CATARATA EN EL OJO DESPUÉS DE CIRUGÍA DE CATARATAS"
  },
  {
    "codigo":305602008,
    "descripcion":"BAJO ATENCIÓN DE NUTRICIONISTA"
  },
  {
    "codigo":1286807003,
    "descripcion":"NEOPLASIA GERMINAL NO SEMINOMATOSA PRIMARIA DE TESTÍCULO NO DESCENDIDO"
  },
  {
    "codigo":762519006,
    "descripcion":"PERFORACIÓN DE AURÍCULA DERECHA DEBIDA A PROCEDIMIENTO Y POSTERIOR ÉL"
  },
  {
    "codigo":72556006,
    "descripcion":"LESIÓN TRAUMÁTICA DEL NERVIO TRIGÉMINO"
  },
  {
    "codigo":39788007,
    "descripcion":"SÍNDROME DE ECTRODACTILIA - DISPLASIA ECTODÉRMICA - QUEILOSQUISIS"
  },
  {
    "codigo":367468008,
    "descripcion":"ATRESIA DE NARINAS"
  },
  {
    "codigo":301932008,
    "descripcion":"HALLAZGO RELACIONADO CON EL ASPECTO DE LA CÁMARA ANTERIOR"
  },
  {
    "codigo":234561000,
    "descripcion":"DEFICIENCIA DE ANTICUERPOS ANTIPOLISACÁRIDO C DEL MENINGOCOCO"
  },
  {
    "codigo":269164007,
    "descripcion":"LACERACIÓN DE PÁRPADO Y SISTEMA DE DRENAJE LAGRIMAL"
  },
  {
    "codigo":365633003,
    "descripcion":"MORFOLOGÍA DE LAS PLAQUETAS - HALLAZGO"
  },
  {
    "codigo":726081005,
    "descripcion":"RAQUITISMO HIPOFOSFATÉMICO HEREDITARIO CON HIPERCALCIURIA"
  },
  {
    "codigo":300097006,
    "descripcion":"AMPOLLA EN PABELLÓN AURICULAR"
  },
  {
    "codigo":1119297005,
    "descripcion":"QUERATODERMIA TILÓSICA PALMAR PROGRESIVA"
  },
  {
    "codigo":298262000,
    "descripcion":"HALLAZGO RELACIONADO CON MEDICIONES ARTICULARES"
  },
  {
    "codigo":16007991000119102,
    "descripcion":"OSTEOMIELITIS DE AMBOS CÚBITOS"
  },
  {
    "codigo":170860009,
    "descripcion":"EFECTOS COLATERALES DE FÁRMACO DE EMPLEO DERMATOLÓGICO"
  },
  {
    "codigo":198123000,
    "descripcion":"HEMATOMA MAMARIO DE CAUSA NO TRAUMÁTICA"
  },
  {
    "codigo":36118008,
    "descripcion":"NEUMOTÓRAX"
  },
  {
    "codigo":296427004,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE TONZILAMINA"
  },
  {
    "codigo":34283004,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE DEDO DE PIE SIN INFECCIÓN"
  },
  {
    "codigo":722411008,
    "descripcion":"DISFUNCIÓN SOMÁTICA DE REGIÓN DEL TRONCO"
  },
  {
    "codigo":720576001,
    "descripcion":"CALCIFICACIÓN CEREBRAL TIPO RAJAB"
  },
  {
    "codigo":458432002,
    "descripcion":"SÍNDROME DE TORTUOSIDAD ARTERIAL"
  },
  {
    "codigo":294592000,
    "descripcion":"ALERGIA A TETRACICLINA"
  },
  {
    "codigo":1515008,
    "descripcion":"ENFERMEDAD DE GORHAM"
  },
  {
    "codigo":11312081000119100,
    "descripcion":"FRACTURA POR ESTRÉS DE VÉRTEBRA OCCIPITO-ATLANTO-AXIAL"
  },
  {
    "codigo":1179328008,
    "descripcion":"DEFORMIDAD EN VARO DE CADERA"
  },
  {
    "codigo":391061007,
    "descripcion":"RESULTADO DE ABSORCIOMETRÍA DUAL POR RAYOS X DE HUESO DE ANTEBRAZO, OSTEOPENIA"
  },
  {
    "codigo":423829008,
    "descripcion":"ENFERMEDAD DE PAGET DE LA VULVA, INVASIVA"
  },
  {
    "codigo":127082004,
    "descripcion":"LINFADENOPATÍA SUBMAXILAR"
  },
  {
    "codigo":28778005,
    "descripcion":"PARÁLISIS DEL NERVIO FRÉNICO COMO MANIFESTACIÓN DE TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":94314004,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA MUCOSA GINGIVAL"
  },
  {
    "codigo":715071001,
    "descripcion":"SEPSIS CAUSADA POR ESTREPTOCOCO ANAEROBIO"
  },
  {
    "codigo":92479002,
    "descripcion":"NEOPLASIA BENIGNA DE BORDE BERMELLÓN DE LABIO INFERIOR"
  },
  {
    "codigo":334801000119104,
    "descripcion":"EDEMA CORNEAL IDIOPÁTICO DE OJO DERECHO"
  },
  {
    "codigo":289087007,
    "descripcion":"INCAPAZ DE COLOCAR AL BEBÉ AL PECHO PARA AMAMANTARLO"
  },
  {
    "codigo":254484001,
    "descripcion":"NEOPLASIA MALIGNA DE MARGEN POSTERIOR DE TABIQUE NASAL Y\/O COANAS"
  },
  {
    "codigo":1072081000119106,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE TENDÓN FLEXOR DE REGIÓN DE MUÑECA"
  },
  {
    "codigo":1237524005,
    "descripcion":"METÁSTASIS DE CARCINOMA DE PÁNCREAS"
  },
  {
    "codigo":713236007,
    "descripcion":"ENFERMEDAD GINGIVAL ALÉRGICA POR CONTACTO CON MATERIAL DENTAL DE ACRÍLICO"
  },
  {
    "codigo":449257006,
    "descripcion":"HEMANGIOMA DE PARED ABDOMINAL"
  },
  {
    "codigo":1137385007,
    "descripcion":"HIPOTONÍA FACIAL"
  },
  {
    "codigo":56041007,
    "descripcion":"HIPOTIROIDISMO POR DEFECTO EN LA SÍNTESIS DE HORMONA TIROIDEA"
  },
  {
    "codigo":1332158001,
    "descripcion":"EPILEPSIA CON CARACTERÍSTICAS AUDITIVAS"
  },
  {
    "codigo":283582001,
    "descripcion":"HERIDA DE PERDIGÓN EN CADERA"
  },
  {
    "codigo":185278000,
    "descripcion":"ATENDIDO POR UN MÉDICO DE ATENCIÓN PRIMARIA"
  },
  {
    "codigo":840638005,
    "descripcion":"CÁLCULO CORALIFORME DE FOSFATO"
  },
  {
    "codigo":216211000,
    "descripcion":"LESIÓN POR PROPULSOR A HÉLICE DE AERONAVE, SIN ACCIDENTE DE AERONAVE"
  },
  {
    "codigo":248979002,
    "descripcion":"SANGRADO DEL HIMEN"
  },
  {
    "codigo":19603004,
    "descripcion":"GANGRENA DEL ESCROTO"
  },
  {
    "codigo":1363091005,
    "descripcion":"ASTILLA EN INGLE CON INFECCIÓN"
  },
  {
    "codigo":50561000087102,
    "descripcion":"ENTEROBACTERALES PRODUCTORAS DE BETALACTAMASA DE AMPLIO ESPECTRO NO AISLADAS"
  },
  {
    "codigo":314515006,
    "descripcion":"PAPILOMA DE PÁRPADO"
  },
  {
    "codigo":83304000,
    "descripcion":"COREA DE DUBINI"
  },
  {
    "codigo":1197416000,
    "descripcion":"OFTALMOPATÍA EUTIROIDEA DE GRAVES"
  },
  {
    "codigo":11777131000119105,
    "descripcion":"LACERACIÓN DE MÚSCULO TRÍCEPS BRAQUIAL DERECHO"
  },
  {
    "codigo":42881000087107,
    "descripcion":"HERIDA DE EXTREMIDAD INFERIOR IZQUIERDA POR MORDEDURA"
  },
  {
    "codigo":35201000087107,
    "descripcion":"LEVADURA DE ESPECIE NO CANDIDA DETECTADA"
  },
  {
    "codigo":247144003,
    "descripcion":"REFLEJO DE LA FÓVEA AUSENTE"
  },
  {
    "codigo":40321000087104,
    "descripcion":"DISTENSIÓN DE TENDÓN DE MÚSCULO ISQUIOTIBIAL DERECHO"
  },
  {
    "codigo":60801000087106,
    "descripcion":"INFECCIÓN CAUSADA POR BACILLUS THURINGIENSIS"
  },
  {
    "codigo":48001000087109,
    "descripcion":"FRACTURA DE DIÁFISIS DE RADIO DERECHO"
  },
  {
    "codigo":45441000087108,
    "descripcion":"HERIDA PUNZANTE DE PANTORRILLA DERECHA"
  },
  {
    "codigo":704061004,
    "descripcion":"FRACTURA POR ESTRÉS DE CÓNDILO EXTERNO DE FÉMUR"
  },
  {
    "codigo":46866001,
    "descripcion":"FRACTURA DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":1193746002,
    "descripcion":"INFLAMACIÓN INTESTINAL POR SHIGELLA FLEXNERI"
  },
  {
    "codigo":833298003,
    "descripcion":"SÓLO CAPAZ DE PERCIBIR LA LUZ A TRAVÉS DE AGUJERO ESTENOPEICO CON EL OJO DERECHO"
  },
  {
    "codigo":866066004,
    "descripcion":"MIELITIS CAUSADA POR BORRELIA BURGDORFERI"
  },
  {
    "codigo":691461000119103,
    "descripcion":"ATROFIA CEREBRAL ADQUIRIDA"
  },
  {
    "codigo":472850008,
    "descripcion":"INSUFICIENCIA DE VÁLVULA AURICULOVENTRICULAR IZQUIERDA (MORFOLÓGICAMENTE NO MITRAL) FETAL"
  },
  {
    "codigo":208871001,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA DISTAL DE DEDO DE LA MANO"
  },
  {
    "codigo":276242008,
    "descripcion":"MIEDO AL AGUA"
  },
  {
    "codigo":896999006,
    "descripcion":"AGENESIA CONGÉNITA DE VAGINA"
  },
  {
    "codigo":12263007,
    "descripcion":"RESPUESTA DE HIPERSENSIBILIDAD TIPO 1"
  },
  {
    "codigo":272572001,
    "descripcion":"DECÚBITO LATERAL - PIE DE LA CAMA ELEVADO 45 CM"
  },
  {
    "codigo":75964002,
    "descripcion":"HERNIA DE CLOQUET"
  },
  {
    "codigo":698556003,
    "descripcion":"HEMATOMA TRAUMÁTICO DE PARED ABDOMINAL"
  },
  {
    "codigo":403644004,
    "descripcion":"REACCIÓN DE RECUERDO DE LA RADIACIÓN DEBIDA A TRATAMIENTO CITOTÓXICO"
  },
  {
    "codigo":207036003,
    "descripcion":"ENFERMEDAD DE CASTLEMAN"
  },
  {
    "codigo":764092008,
    "descripcion":"FISURA DE LABIO IZQUIERDA"
  },
  {
    "codigo":41361000,
    "descripcion":"INFESTACIÓN CAUSADA POR GASTEROPHILUS PECORUM"
  },
  {
    "codigo":337311000119101,
    "descripcion":"BLEFAROCALASIA DE PÁRPADO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":762257007,
    "descripcion":"INFECCIÓN DISEMINADA CAUSADA POR NEISSERIA GONORRHOEAE"
  },
  {
    "codigo":9631000119102,
    "descripcion":"HIPERSENSIBILIDAD DE SENO CAROTÍDEO"
  },
  {
    "codigo":399974001,
    "descripcion":"DISPLASIA ECTODÉRMICA CON DEFECTO DE DIENTE-UÑA-SUDORACIÓN"
  },
  {
    "codigo":1153638002,
    "descripcion":"OCLUSIÓN DE AMBAS ARTERIAS CEREBELOSAS"
  },
  {
    "codigo":72294005,
    "descripcion":"ALASTRIM"
  },
  {
    "codigo":39526006,
    "descripcion":"PREPUCIO REDUNDANTE"
  },
  {
    "codigo":301670005,
    "descripcion":"INCAPAZ DE ACOSTARSE EN UNA CAMA"
  },
  {
    "codigo":430907000,
    "descripcion":"FRACTURA POR SOBRECARGA DE LA PELVIS"
  },
  {
    "codigo":236134009,
    "descripcion":"UBICACIÓN POCO SATISFACTORIA DEL ESTOMA"
  },
  {
    "codigo":365371000,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA INVOLUCRARSE EN UN PASATIEMPOS"
  },
  {
    "codigo":299835005,
    "descripcion":"REFLEJO BICIPITAL INVERTIDO"
  },
  {
    "codigo":267067009,
    "descripcion":"DOLOR LUMBAR - RENAL"
  },
  {
    "codigo":298000004,
    "descripcion":"PÉRDIDA DEL PELO DEL CUERO CABELLUDO"
  },
  {
    "codigo":396304007,
    "descripcion":"MARGEN QUIRÚRGICO DISTAL COMPROMETIDO POR CARCINOMA IN SITU"
  },
  {
    "codigo":722149000,
    "descripcion":"ENFERMEDAD RENAL CRÓNICA DEBIDA A RESECCIÓN DE NEOPLASIA DE RIÑÓN Y POSTERIOR A ELLA"
  },
  {
    "codigo":230629000,
    "descripcion":"COMPRESIÓN DE APÓFISIS SUPRACONDÍLEA"
  },
  {
    "codigo":296165002,
    "descripcion":"SOBREDOSIS DE CLOZAPINA"
  },
  {
    "codigo":10904991000119107,
    "descripcion":"LACERACIÓN DE PARED ABDOMINAL"
  },
  {
    "codigo":197861003,
    "descripcion":"FÍSTULA VESICOSIGMOIDEA"
  },
  {
    "codigo":66789005,
    "descripcion":"ICTERICIA HEPATOCELULAR"
  },
  {
    "codigo":34021006,
    "descripcion":"ÚLCERA DUODENAL CRÓNICA CON HEMORRAGIA Y OBSTRUCCIÓN"
  },
  {
    "codigo":166928007,
    "descripcion":"PRUEBA DE TOLERANCIA A LA GLUCOSA INDICATIVA DE DIABETES MELLITUS"
  },
  {
    "codigo":10861691000119106,
    "descripcion":"HERIDA POR DISPARO DE ARMA DE FUEGO DE REGIÓN DE CADERA IZQUIERDA"
  },
  {
    "codigo":64954002,
    "descripcion":"AVULSIÓN DEL CARTÍLAGO SINFISIAL INTERNO DURANTE EL PARTO"
  },
  {
    "codigo":196026004,
    "descripcion":"ENFISEMA CRÓNICO CAUSADO POR PARTÍCULAS DE SUSTANCIAS QUÍMICAS CALIENTES TRANSITORIAMENTE SUSPENDIDAS EN EL AIRE"
  },
  {
    "codigo":294330005,
    "descripcion":"ALERGIA A ALCOHOL DE LANOLINA"
  },
  {
    "codigo":11779641000119103,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE DEDOS SEGUNDO A QUINTO DE PIE DERECHO"
  },
  {
    "codigo":95887000,
    "descripcion":"FIEBRE MICOPLASMÁTICA SECUNDARIA A UN ABORTO"
  },
  {
    "codigo":292495000,
    "descripcion":"REACCIÓN ADVERSA AL SALBUTAMOL"
  },
  {
    "codigo":63119004,
    "descripcion":"SÍNDROME DE WEAVER"
  },
  {
    "codigo":1144463006,
    "descripcion":"APLASIA DE CUARTO HUESO METACARPIANO"
  },
  {
    "codigo":11861561000119105,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO CRURAL ANTERIOR DE PIERNA DERECHA"
  },
  {
    "codigo":290660002,
    "descripcion":"INTOXICACIÓN POR DOXORUBICINA"
  },
  {
    "codigo":126820003,
    "descripcion":"NEOPLASIA DEL ESÓFAGO ABDOMINAL"
  },
  {
    "codigo":26681001,
    "descripcion":"ENDOMETRIOSIS DE LA PELVIS"
  },
  {
    "codigo":94052009,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE PARTES BLANDAS DE NALGA"
  },
  {
    "codigo":443699005,
    "descripcion":"UTILIZA DOS BASTONES"
  },
  {
    "codigo":288825006,
    "descripcion":"INCAPAZ DE IMITAR PALABRAS"
  },
  {
    "codigo":92217007,
    "descripcion":"NEOPLASIA BENIGNA DE HUESO DEL METATARSO"
  },
  {
    "codigo":254222002,
    "descripcion":"CUTIS LAXO RECESIVO, TIPO I"
  },
  {
    "codigo":448995000,
    "descripcion":"LINFOMA NO HODGKIN FOLICULAR DE SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":57614009,
    "descripcion":"ANEURISMA DE ARTERIA PANCREATICODUODENAL"
  },
  {
    "codigo":88547002,
    "descripcion":"LINGUATULIASIS"
  },
  {
    "codigo":23011003,
    "descripcion":"AFASIA GLOBAL"
  },
  {
    "codigo":53944005,
    "descripcion":"URETROCELE FEMENINO SIN PROLAPSO UTERINO"
  },
  {
    "codigo":283320008,
    "descripcion":"ASTILLA DE MADERA DEBAJO DE LA UÑA DE DEDO DEL PIE"
  },
  {
    "codigo":1231757001,
    "descripcion":"PERINEURITIS ÓPTICA IDIOPÁTICA"
  },
  {
    "codigo":707469001,
    "descripcion":"CARCINOMA BRONQUIOLOALVEOLAR NO MUCINOSO PRIMARIO DE PULMÓN"
  },
  {
    "codigo":19341001,
    "descripcion":"PALUDISMO POR PLASMODIUM OVALE"
  },
  {
    "codigo":248717004,
    "descripcion":"LATIDO AÓRTICO EXPANSIVO DE ABDOMEN"
  },
  {
    "codigo":838541006,
    "descripcion":"INSUFICIENCIA DE VÁLVULA PULMONAR LEVE"
  },
  {
    "codigo":443490000,
    "descripcion":"COMPRESIÓN DE NERVIO PLANTAR"
  },
  {
    "codigo":246882003,
    "descripcion":"FOLÍCULOS DE LA CONJUNTIVA BULBAR"
  },
  {
    "codigo":1197154006,
    "descripcion":"MIOPATÍA NEMALÍNICA DE INICIO EN LA INFANCIA"
  },
  {
    "codigo":312418006,
    "descripcion":"INFECCIÓN PARASITARIA DEL OJO"
  },
  {
    "codigo":410722008,
    "descripcion":"AMPOLLA FILTRANTE ACCIDENTAL"
  },
  {
    "codigo":212279006,
    "descripcion":"CONTUSIÓN, NERVIO DIGITAL EN DEDO DE LA MANO"
  },
  {
    "codigo":15671007,
    "descripcion":"ENCEFALOCELE DE ÓRBITA"
  },
  {
    "codigo":79372000,
    "descripcion":"DERMATITIS POLIMORFA POR LUZ SOLAR, TIPO PAPULOVESICULOSA"
  },
  {
    "codigo":46604003,
    "descripcion":"INTOXICACIÓN CAUSADA POR ACETILCOLINA"
  },
  {
    "codigo":863969000,
    "descripcion":"REACCIÓN ADVERSA A ORO Y\/O COMPUESTO DE ORO"
  },
  {
    "codigo":112140009,
    "descripcion":"RECHAZO CELULAR MODERADO DE INJERTO"
  },
  {
    "codigo":767500009,
    "descripcion":"PROTRUSIÓN DE LABIO INFERIOR"
  },
  {
    "codigo":896737003,
    "descripcion":"FORMA DE CONO ANORMAL CONGÉNITA DE EPÍFISIS DE FALANGE DE DEDO ANULAR"
  },
  {
    "codigo":470753008,
    "descripcion":"PROGRESIÓN DE OBSTRUCCIÓN DEL TRACTO DE SALIDA DEL VENTRÍCULO IZQUIERDO FETAL"
  },
  {
    "codigo":403382002,
    "descripcion":"LINFEDEMA PALPEBRAL"
  },
  {
    "codigo":698294004,
    "descripcion":"APENDICITIS AGUDA CON PERITONITIS LOCALIZADA"
  },
  {
    "codigo":23181000122104,
    "descripcion":"ALERGIA A MANGO"
  },
  {
    "codigo":763830009,
    "descripcion":"DISOSTOSIS OCULOMAXILOFACIAL"
  },
  {
    "codigo":75702008,
    "descripcion":"BRUCELOSIS"
  },
  {
    "codigo":73867007,
    "descripcion":"DEPRESIÓN MAYOR GRAVE CON SÍNTOMAS PSICÓTICOS"
  },
  {
    "codigo":270475008,
    "descripcion":"SE PONE AZUL"
  },
  {
    "codigo":237707009,
    "descripcion":"HIPOFISITIS LINFOCÍTICA DEL EMBARAZO"
  },
  {
    "codigo":432480003,
    "descripcion":"CANDIDEMIA ASOCIADA CON VÍA INTRAVASCULAR"
  },
  {
    "codigo":1153376004,
    "descripcion":"GOTA CRÓNICA MONOARTICULAR CAUSADA POR PLOMO"
  },
  {
    "codigo":235872006,
    "descripcion":"PORTADOR DE HEPATITIS C"
  },
  {
    "codigo":203104007,
    "descripcion":"FIBROSITIS DEL CUELLO"
  },
  {
    "codigo":102965000,
    "descripcion":"POTENCIAL EVOCADO CEREBRAL ANORMAL"
  },
  {
    "codigo":201269001,
    "descripcion":"URTICARIA MENSTRUAL"
  },
  {
    "codigo":299573000,
    "descripcion":"LESIÓN DE DEDO DE PIE"
  },
  {
    "codigo":4661003,
    "descripcion":"CÁLCULO DE VÍA BILIAR CON OBSTRUCCIÓN"
  },
  {
    "codigo":168501001,
    "descripcion":"RESULTADO DE RADIOLOGÍA: ANORMAL"
  },
  {
    "codigo":234037003,
    "descripcion":"TROMBOFLEBITIS SUPERFICIAL DE VENA BASÍLICA"
  },
  {
    "codigo":365109005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA TRASLADARSE APOYÁNDOSE EN LOS MUEBLES"
  },
  {
    "codigo":1217077001,
    "descripcion":"COMA INSULÍNICO INDUCIDO POR FÁRMACO EN SUJETO NO DIABÉTICO"
  },
  {
    "codigo":723722000,
    "descripcion":"AUSENCIA DE MIEMBRO INFERIOR"
  },
  {
    "codigo":37429009,
    "descripcion":"HIPOTIROIDISMO HIPOTALÁMICO"
  },
  {
    "codigo":789258006,
    "descripcion":"DESACELERACIONES VARIABLES DE LA FRECUENCIA CARDÍACA FETAL"
  },
  {
    "codigo":197599000,
    "descripcion":"SÍNDROME NEFRÓTICO, ENFERMEDAD DE DEPÓSITOS DENSOS"
  },
  {
    "codigo":991002,
    "descripcion":"INTERVALO QRS ANCHO"
  },
  {
    "codigo":295903003,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE TRANILCIPROMINA"
  },
  {
    "codigo":721887007,
    "descripcion":"SÍNDROME DE HIPOTONÍA INFANTIL PORTORRIQUEÑA"
  },
  {
    "codigo":230367007,
    "descripcion":"LEUCODISTROFIA NEUROAXONAL"
  },
  {
    "codigo":263135009,
    "descripcion":"RUPTURA DE LIGAMENTO DE HOMBRO"
  },
  {
    "codigo":426975008,
    "descripcion":"ELECTROCARDIOGRAMA: ACTIVIDAD ELÉCTRICA SIN PULSO"
  },
  {
    "codigo":11837601000119105,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE RODILLA DERECHA"
  },
  {
    "codigo":1079611000119100,
    "descripcion":"CONDROSARCOMA PRIMARIO DE HUESO DE PIE DERECHO"
  },
  {
    "codigo":718217000,
    "descripcion":"VASCULITIS LEUCOCITOCLÁSTICA CUTÁNEA"
  },
  {
    "codigo":662911291000119101,
    "descripcion":"SENSACIÓN DE CUERPO EXTRAÑO EN OJO DERECHO"
  },
  {
    "codigo":423305008,
    "descripcion":"DESARROLLO DEL LENGUAJE - CAPAZ DE DECIR ESPONTÁNEAMENTE UNA O DOS PALABRAS"
  },
  {
    "codigo":95625008,
    "descripcion":"ÍLEO PARALÍTICO DEL RECIÉN NACIDO"
  },
  {
    "codigo":292233008,
    "descripcion":"REACCIÓN ADVERSA A LA CITARABINA"
  },
  {
    "codigo":126558006,
    "descripcion":"NEOPLASIA DE COSTILLA"
  },
  {
    "codigo":290398006,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR LOPERAMIDA"
  },
  {
    "codigo":419635000,
    "descripcion":"HALLAZGO RELACIONADO CON HERIDA QUIRÚRGICA"
  },
  {
    "codigo":79131000119100,
    "descripcion":"LESIÓN DE RIÑÓN"
  },
  {
    "codigo":16066331000119101,
    "descripcion":"DOLOR DURANTE REPOSO DE MIEMBRO SUPERIOR IZQUIERDO DEBIDO A ATEROESCLEROSIS"
  },
  {
    "codigo":678171000119102,
    "descripcion":"HIFEMA DE OJO IZQUIERDO"
  },
  {
    "codigo":15638811000119102,
    "descripcion":"APOFISITIS CALCÁNEA BILATERAL"
  },
  {
    "codigo":309531000119104,
    "descripcion":"NECROSIS AVASCULAR DE HUESO DE MANO IZQUIERDA"
  },
  {
    "codigo":15628571000119105,
    "descripcion":"FUNDUS FLAVIMACULATUS DE OJO IZQUIERDO"
  },
  {
    "codigo":16862491000119106,
    "descripcion":"ABSCESO DE PIEL DURANTE EMBARAZO"
  },
  {
    "codigo":350586651000119105,
    "descripcion":"INSUFICIENCIA RESPIRATORIA CRÓNICA DEBIDA A ENFERMEDAD NEUROMUSCULAR"
  },
  {
    "codigo":16475931000119105,
    "descripcion":"PAPILOMATOSIS TRAQUEAL"
  },
  {
    "codigo":15912731000119105,
    "descripcion":"ENTROPIÓN SENIL DE AMBOS PÁRPADOS"
  },
  {
    "codigo":57352003,
    "descripcion":"AMPOLLA DE LA VAGINA, SIN INFECCIÓN"
  },
  {
    "codigo":10751771000119107,
    "descripcion":"DESPRENDIMIENTO DE PLACENTA DEBIDO A AFIBRINOGENEMIA"
  },
  {
    "codigo":16836891000119104,
    "descripcion":"EMBARAZO ECTÓPICO EN TROMPA DE FALOPIO DERECHA"
  },
  {
    "codigo":124723009,
    "descripcion":"DEFICIENCIA DE ÁCIDO - AMINOÁCIDO LIGASA"
  },
  {
    "codigo":74011000119107,
    "descripcion":"ANASARCA RENAL"
  },
  {
    "codigo":10754331000119108,
    "descripcion":"EMBOLIA GASEOSA DURANTE EL NACIMIENTO"
  },
  {
    "codigo":340251000119108,
    "descripcion":"NEUROPATÍA ÓPTICA ISQUÉMICA DE OJO IZQUIERDO"
  },
  {
    "codigo":16698651000119109,
    "descripcion":"HEMATURIA MICROSCÓPICA ASINTOMÁTICA"
  },
  {
    "codigo":219357004,
    "descripcion":"LESIÓN POR ESCALDADURA, CON PROPÓSITO DESCONOCIDO"
  },
  {
    "codigo":342331000119108,
    "descripcion":"HIPERTRICOSIS DE PÁRPADO INFERIOR DERECHO"
  },
  {
    "codigo":16863701000119102,
    "descripcion":"SÍNDROME DE NERVIO INTERÓSEO ANTERIOR DE EXTREMIDADES SUPERIORES BILATERALES"
  },
  {
    "codigo":283058003,
    "descripcion":"ABRASIÓN DE PIEL DE MUÑECA"
  },
  {
    "codigo":315826004,
    "descripcion":"NEUROSÍFILIS TABÉTICA"
  },
  {
    "codigo":445063003,
    "descripcion":"OSTEOMIELITIS CRÓNICA DE VÉRTEBRA"
  },
  {
    "codigo":707207004,
    "descripcion":"INTERRUPCIÓN INDUCIDA DEL EMBARAZO INCOMPLETA"
  },
  {
    "codigo":281223004,
    "descripcion":"MENINGOCELE TRAUMÁTICO"
  },
  {
    "codigo":1231495005,
    "descripcion":"DESVIACIÓN MODERADA DE LÍNEA MEDIA DE ARCO DENTAL MAXILAR HACIA LA IZQUIERDA"
  },
  {
    "codigo":215687008,
    "descripcion":"LESIÓN EN MEDIO DE TRANSPORTE ACUÁTICO PRODUCIDO POR MAQUINARIA DE CUBIERTA"
  },
  {
    "codigo":51847008,
    "descripcion":"ÚLCERA DUODENAL AGUDA CON HEMORRAGIA Y PERFORACIÓN PERO SIN OBSTRUCCIÓN"
  },
  {
    "codigo":1295196005,
    "descripcion":"TUMOR DE CÉLULAS GIGANTES MALIGNO DE HUESO"
  },
  {
    "codigo":770908007,
    "descripcion":"SÍNDROME 49,XXXYY"
  },
  {
    "codigo":1162289002,
    "descripcion":"CIFOSIS DEBIDA A LESIÓN TRAUMÁTICA Y POSTERIOR A ELLA"
  },
  {
    "codigo":16018031000119101,
    "descripcion":"TRASTORNO DE TIBIAS BILATERALES POSTERIOR A POLIOMIELITIS"
  },
  {
    "codigo":48177003,
    "descripcion":"INTOXICACIÓN POR DICENTRA CUCULLARIA"
  },
  {
    "codigo":703537008,
    "descripcion":"LEUCOENCEFALOPATÍA CON COMPROMISO DE TRONCO ENCEFÁLICO Y MÉDULA ESPINAL Y ELEVACIÓN DE LACTATO"
  },
  {
    "codigo":769073009,
    "descripcion":"LEVADURA DE ESPECIE NO CANDIDA Y NO CRYPTOCOCCUS DETECTADA"
  },
  {
    "codigo":472326004,
    "descripcion":"MIOCARDIOPATÍA HIPERTRÓFICA FETAL ASOCIADA CON ENFERMEDAD RENAL"
  },
  {
    "codigo":111878007,
    "descripcion":"MENINGITIS CAUSADA POR VIRUS COXSACKIE HUMANO"
  },
  {
    "codigo":11739001,
    "descripcion":"DIETA CON ALTO CONTENIDO DE RESIDUO"
  },
  {
    "codigo":699867001,
    "descripcion":"SÍNDROME DEL RAYO RADIAL DE DUANE"
  },
  {
    "codigo":110043002,
    "descripcion":"LACERACIÓN SIMPLE CONTAMINADA DE LA REGIÓN CIGOMÁTICA DE LA MEJILLA"
  },
  {
    "codigo":206512000,
    "descripcion":"TROMBOCITOPENIA NEONATAL TRANSITORIA DEBIDA A ISOINMUNIZACIÓN"
  },
  {
    "codigo":370352001,
    "descripcion":"HALLAZGO RELACIONADO CON CRIBADO PRENATAL"
  },
  {
    "codigo":765403009,
    "descripcion":"FORMA ENCEFALOMIOPÁTICA DEL SÍNDROME DE DEPLECIÓN DE ÁCIDO DESOXIRRIBONUCLEICO MITOCONDRIAL RELACIONADO CON EL GEN F-BOX Y PROTEÍNA REPETITIVA RICA EN LEUCINA 4"
  },
  {
    "codigo":403120000,
    "descripcion":"MICETOMA CAUSADO POR NEOTESTUDINA ROSATII"
  },
  {
    "codigo":698032005,
    "descripcion":"RÁNULA HUNDIDA"
  },
  {
    "codigo":9904008,
    "descripcion":"ANOMALÍA CONGÉNITA DEL APARATO CARDIOVASCULAR"
  },
  {
    "codigo":1156784009,
    "descripcion":"ENFERMEDAD DE CASTLEMAN LOCALIZADA"
  },
  {
    "codigo":344841000119101,
    "descripcion":"DEFORMIDAD DE AMBAS ÓRBITAS PROPIAMENTE DICHAS DEBIDA A ENFERMEDAD ÓSEA"
  },
  {
    "codigo":15745801000119101,
    "descripcion":"CARPOPTOSIS DE AMBAS MUÑECAS"
  },
  {
    "codigo":1082121000119102,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE BRONQUIO PRINCIPAL IZQUIERDO"
  },
  {
    "codigo":1251418001,
    "descripcion":"NECROSIS PARCIAL DE COLGAJO CUTÁNEO"
  },
  {
    "codigo":237445009,
    "descripcion":"TUBERCULOSIS MAMARIA"
  },
  {
    "codigo":202842005,
    "descripcion":"DESGARRO PARCIAL DE MANGUITO DE LOS ROTADORES"
  },
  {
    "codigo":366682006,
    "descripcion":"AMPLITUD DE MOVIMIENTO ACTIVO DE ABDUCCIÓN DE DEDO DE LA MANO - HALLAZGO"
  },
  {
    "codigo":301146007,
    "descripcion":"PULSO PERIFÉRICO PALPABLE"
  },
  {
    "codigo":6234006,
    "descripcion":"LACERACIÓN PERINEAL DE SEGUNDO GRADO"
  },
  {
    "codigo":235610009,
    "descripcion":"ÚLCERA BACTERIANA DE ESÓFAGO"
  },
  {
    "codigo":4399003,
    "descripcion":"PANCREATITIS HEMORRÁGICA AGUDA"
  },
  {
    "codigo":233775004,
    "descripcion":"MICOTOXICOSIS PULMONAR"
  },
  {
    "codigo":725295005,
    "descripcion":"PUBERTAD PRECOZ FAMILIAR LIMITADA A LOS VARONES"
  },
  {
    "codigo":299311008,
    "descripcion":"CREPITACIÓN AUDIBLE DE ARTICULACIÓN DE CADERA"
  },
  {
    "codigo":364847009,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA EVITAR OBSTÁCULOS AL CORRER"
  },
  {
    "codigo":231940002,
    "descripcion":"LESIÓN DE LA CÓRNEA POR CONMOCIÓN"
  },
  {
    "codigo":1149444007,
    "descripcion":"PERIODONTITIS LOCALIZADA ESTADIO 3 GRADO B SEGÚN LA CLASIFICACIÓN DE LAS ENFERMEDADES Y ALTERACIONES PERIODONTALES Y PERIIMPLANTARIAS DE 2017 DE LA ACADEMIA ESTADOUNIDENSE DE PERIODONTOLOGÍA Y LA FEDERACIÓN EUROPEA DE PERIODONTOLOGÍA"
  },
  {
    "codigo":363012008,
    "descripcion":"COMPLICACIÓN DE PROCEDIMIENTO DE HIDROTERAPIA"
  },
  {
    "codigo":788996008,
    "descripcion":"OBESIDAD EN LA ADOLESCENCIA"
  },
  {
    "codigo":262873001,
    "descripcion":"LACERACIÓN DE COLON"
  },
  {
    "codigo":66265004,
    "descripcion":"CEMENTITIS"
  },
  {
    "codigo":721625004,
    "descripcion":"CARCINOMA NEUROENDOCRINO PRIMARIO DE ESÓFAGO"
  },
  {
    "codigo":295641007,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE MUSTINA"
  },
  {
    "codigo":195502004,
    "descripcion":"RUPTURA DE GANGLIO LINFÁTICO"
  },
  {
    "codigo":293806008,
    "descripcion":"ALERGIA A FENFLURAMINA"
  },
  {
    "codigo":719790009,
    "descripcion":"AMPLIFICACIÓN DE ÁCIDO NUCLEICO NO DETECTADA"
  },
  {
    "codigo":128131002,
    "descripcion":"TRASTORNO DEL BRAZO"
  },
  {
    "codigo":717955002,
    "descripcion":"ADHERENCIAS DE FIMBRIAS DE TROMPA DE FALOPIO"
  },
  {
    "codigo":160899000,
    "descripcion":"DESEMPLEADO RECIENTEMENTE"
  },
  {
    "codigo":291971008,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR FUROSEMIDA"
  },
  {
    "codigo":27992006,
    "descripcion":"INTOXICACIÓN POR CLORFENVINFOS"
  },
  {
    "codigo":191832007,
    "descripcion":"DEPENDENCIA DE LA COCAÍNA, EPISÓDICA"
  },
  {
    "codigo":58925000,
    "descripcion":"GRADO DE GLEASON: 9"
  },
  {
    "codigo":124461006,
    "descripcion":"DEFICIENCIA DE SIALIDASA"
  },
  {
    "codigo":253698005,
    "descripcion":"AISLAMIENTO DE TRONCO BRAQUIOCEFÁLICO"
  },
  {
    "codigo":219095000,
    "descripcion":"REACCIÓN ADVERSA A VACUNA CONTRA LA FIEBRE AMARILLA"
  },
  {
    "codigo":286466009,
    "descripcion":"INCAPAZ DE CORTAR ALIMENTOS"
  },
  {
    "codigo":284631002,
    "descripcion":"MORDER A OTRA PERSONA"
  },
  {
    "codigo":1169367003,
    "descripcion":"ATEROSCLEROSIS MULTIFOCAL"
  },
  {
    "codigo":186327003,
    "descripcion":"INFECCIÓN SEPTICÉMICA POR PASTEURELLA (MORDIDA DE PERRO O GATO)"
  },
  {
    "codigo":450306008,
    "descripcion":"ARTERIA COLATERAL MAYOR QUE DERIVA EL FLUJO SISTÉMICO HACIA LA CIRCULACIÓN PULMONAR QUE IRRIGA AMBOS PULMONES"
  },
  {
    "codigo":448471006,
    "descripcion":"ANOMALÍA CONGÉNITA DE AORTA ASCENDENTE"
  },
  {
    "codigo":282796000,
    "descripcion":"LESIÓN DE GANGLIO PARASIMPÁTICO"
  },
  {
    "codigo":86188000,
    "descripcion":"KURU"
  },
  {
    "codigo":315564009,
    "descripcion":"NACIDO EN ZAMBIA"
  },
  {
    "codigo":1231233002,
    "descripcion":"MIOCLONO PARANEOPLÁSICO"
  },
  {
    "codigo":117121005,
    "descripcion":"CALIDAD DEL SOPLO CARDÍACO, SUSURRO"
  },
  {
    "codigo":84353005,
    "descripcion":"ENFERMEDAD PULMONAR POR MICOBACTERIAS"
  },
  {
    "codigo":11760701000119108,
    "descripcion":"ESGUINCE DE RODILLA IZQUIERDA"
  },
  {
    "codigo":444801008,
    "descripcion":"INFECCIÓN ASOCIADA CON DESFIBRILADOR IMPLANTABLE PARA TERAPIA DE RESINCRONIZACIÓN CARDÍACA"
  },
  {
    "codigo":1264001009,
    "descripcion":"MICROANGIOPATÍA TROMBÓTICA DE NOVO POSTERIOR A TRASPLANTE RENAL"
  },
  {
    "codigo":1260331001,
    "descripcion":"DISTONÍA DEBIDA A TRASTORNO DE SISTEMA NERVIOSO PERIFÉRICO"
  },
  {
    "codigo":80683003,
    "descripcion":"RETENCIÓN DE PIGMENTO BILIAR"
  },
  {
    "codigo":1084631000119104,
    "descripcion":"ACÚFENOS SUBJETIVO BILATERAL"
  },
  {
    "codigo":275456000,
    "descripcion":"LACERACIÓN DEL PISO DE LA BOCA"
  },
  {
    "codigo":408363009,
    "descripcion":"EL PACIENTE COMPRENDE LA RAZÓN PARA TOMAR TODA LA MEDICACIÓN"
  },
  {
    "codigo":703275009,
    "descripcion":"INSUFICIENCIA CARDÍACA CON FRACCIÓN DE EYECCIÓN DISMINUIDA DEBIDA A MIOCARDIOPATÍA"
  },
  {
    "codigo":766976003,
    "descripcion":"SÍNDROME DE AGENESIA DE VÁLVULA PULMONAR, TETRALOGÍA DE FALLOT Y AUSENCIA DE CONDUCTO ARTERIOSO"
  },
  {
    "codigo":1356800005,
    "descripcion":"DAÑO DE LIGAMENTO DE CINTURA PÉLVICA DURANTE PARTO VAGINAL"
  },
  {
    "codigo":109781001,
    "descripcion":"ABSCESO DE ESPACIO MASETÉRICO DE LA BOCA"
  },
  {
    "codigo":404693002,
    "descripcion":"ANISOCORIA FISIOLÓGICA"
  },
  {
    "codigo":46080009,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE PARED ABDOMINAL CON INFECCIÓN"
  },
  {
    "codigo":11789681000119101,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO DE DEDO MEDIO DE MANO DERECHA"
  },
  {
    "codigo":765141005,
    "descripcion":"HISTIOCITOSIS NODULAR PROGRESIVA"
  },
  {
    "codigo":75955007,
    "descripcion":"HEMORROIDES TROMBOSADAS"
  },
  {
    "codigo":320881000119103,
    "descripcion":"QUISTE ÓSEO SOLITARIO DE REGIÓN DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":206250007,
    "descripcion":"TORTÍCOLIS POR TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":827007000,
    "descripcion":"FALTA DE POTENCIA EN MÚSCULO ESQUELÉTICO"
  },
  {
    "codigo":239018005,
    "descripcion":"SÍNDROME DE SCHOEPF-SCHULZ-PASSAGE"
  },
  {
    "codigo":106111002,
    "descripcion":"SIGNO CLÍNICO RELACIONADO CON EL EMBARAZO"
  },
  {
    "codigo":15721841000119104,
    "descripcion":"CONTRACTURA DE ARTICULACIÓN DE DEDO DE AMBAS MANOS DEBIDA A CICATRIZ"
  },
  {
    "codigo":5972002,
    "descripcion":"DIFICULTAD PARA INICIAR LA MICCIÓN"
  },
  {
    "codigo":202580003,
    "descripcion":"OSTEOCONDROMATOSIS SINOVIAL DE LA MUÑECA"
  },
  {
    "codigo":300884005,
    "descripcion":"TUMEFACCIÓN DE ESTRUCTURA GENITAL FEMENINA"
  },
  {
    "codigo":366420008,
    "descripcion":"HALLAZGO EN EL REFLEJO PERIFÉRICO"
  },
  {
    "codigo":36905001,
    "descripcion":"TRASTORNO SECUNDARIO DEL SENTIDO DEL GUSTO DE LOS SABORES AMARGOS"
  },
  {
    "codigo":299049002,
    "descripcion":"PRUEBA DE FINKELSTEIN POSITIVA"
  },
  {
    "codigo":15639921000119107,
    "descripcion":"CALAMBRE DE MÚSCULO DE AMBAS EXTREMIDADES INFERIORES"
  },
  {
    "codigo":167977005,
    "descripcion":"LÍQUIDO PLEURAL: EXUDADO"
  },
  {
    "codigo":725033008,
    "descripcion":"HIPOMAGNESEMIA PRIMARIA FAMILIAR CON HIPERCALCIURIA Y NEFROCALCINOSIS SIN COMPROMISO OCULAR SEVERO"
  },
  {
    "codigo":67838009,
    "descripcion":"INFECCIÓN CAUSADA POR PYRENOCHAETA ROMEROI"
  },
  {
    "codigo":467003,
    "descripcion":"LACERACIÓN ANTIGUA DE MÚSCULOS DEL PISO PÉLVICO"
  },
  {
    "codigo":426451004,
    "descripcion":"HIPERSOMNIA RECURRENTE"
  },
  {
    "codigo":721363004,
    "descripcion":"LESIÓN COMPLETA DE MÉDULA ESPINAL AL NIVEL DEL PRIMER SEGMENTO CERVICAL"
  },
  {
    "codigo":262611008,
    "descripcion":"CUERPO EXTRAÑO EN LAS VÍAS URINARIAS"
  },
  {
    "codigo":195240000,
    "descripcion":"SECUELAS DE HEMORRAGIA SUBARACNOIDEA"
  },
  {
    "codigo":1145512003,
    "descripcion":"APLASIA DE FALANGE MEDIA DE DEDO ANULAR"
  },
  {
    "codigo":129704004,
    "descripcion":"CON MAYOR RIESGO DE RETRASO DE DESARROLLO"
  },
  {
    "codigo":64168005,
    "descripcion":"GLOMERULONEFRITIS AGUDA IDIOPÁTICA CON SEMILUNAS, TIPO I"
  },
  {
    "codigo":677541000119100,
    "descripcion":"AGUJERO REDONDO DE LA RETINA DE OJO IZQUIERDO"
  },
  {
    "codigo":293544007,
    "descripcion":"REACCIÓN ADVERSA A TRINITRATO DE GLICERILO DE LIBERACIÓN MODIFICADA"
  },
  {
    "codigo":160637002,
    "descripcion":"EJERCICIO AERÓBICO, UNA VEZ POR SEMANA"
  },
  {
    "codigo":62333002,
    "descripcion":"EDAD GESTACIONAL, 13 SEMANAS"
  },
  {
    "codigo":95101004,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE PARTES BLANDAS DE HOMBRO"
  },
  {
    "codigo":226173004,
    "descripcion":"DIETA RICA EN SELENIO"
  },
  {
    "codigo":422781006,
    "descripcion":"EXPECTATIVAS PERSONALES INCONGRUENTES"
  },
  {
    "codigo":1141842000,
    "descripcion":"INFILTRACIÓN EOSINOFÍLICA DE HÍGADO"
  },
  {
    "codigo":715858000,
    "descripcion":"DEFORMIDAD MUCOGINGIVAL SOBRE CRESTA ALVEOLAR DESDENTADA DEBIDA A INSERCIÓN ABERRANTE DE FRENILLO LINGUAL"
  },
  {
    "codigo":93266001,
    "descripcion":"HIPOPLASIA CONGÉNITA DEL ILION"
  },
  {
    "codigo":60498001,
    "descripcion":"INFECCIÓN CONGÉNITA POR VIRUS HEPATITIS B"
  },
  {
    "codigo":289874000,
    "descripcion":"HALLAZGO RELACIONADO CON EL TONO DEL PERINEO FEMENINO"
  },
  {
    "codigo":191570001,
    "descripcion":"ESQUIZOFRENIA ESQUIZOAFECTIVA CRÓNICA"
  },
  {
    "codigo":224338007,
    "descripcion":"EN CUSTODIA POLICIAL"
  },
  {
    "codigo":187900002,
    "descripcion":"NEOPLASIA MALIGNA DE HUESOS DEL CRÁNEO Y LA CARA"
  },
  {
    "codigo":1269244003,
    "descripcion":"TROMBOSIS DE AMBAS ARTERIAS CEREBELOSAS"
  },
  {
    "codigo":24060004,
    "descripcion":"ÚLCERA GASTROCÓLICA"
  },
  {
    "codigo":1087141000119106,
    "descripcion":"INFECCIÓN POR METANEUMOVIRUS HUMANO"
  },
  {
    "codigo":253436004,
    "descripcion":"ESTENOSIS DE VÁLVULA AURICULOVENTRICULAR COMÚN"
  },
  {
    "codigo":22225000,
    "descripcion":"FRACTURA EXPUESTA DE HUESOS MÚLTIPLES DE LA EXTREMIDAD INFERIOR"
  },
  {
    "codigo":710353001,
    "descripcion":"MORFOLOGÍA DE CRESTA ALVEOLAR RESIDUAL DE MAXILAR SUPERIOR QUE RESISTE EL MOVIMIENTO VERTICAL Y HORIZONTAL"
  },
  {
    "codigo":1300177006,
    "descripcion":"ENFERMEDAD INFECCIOSA INVASIVA"
  },
  {
    "codigo":708518001,
    "descripcion":"PAPILOMATOSIS MAMARIA JUVENIL"
  },
  {
    "codigo":282534003,
    "descripcion":"DIFICULTAD PARA BAJAR ESCALERAS CORRIENDO"
  },
  {
    "codigo":184230005,
    "descripcion":"NOTAS EXTENSAS EN LA COMPUTADORA"
  },
  {
    "codigo":1003430006,
    "descripcion":"DISPLASIA CORTICAL FOCAL IIB"
  },
  {
    "codigo":249766008,
    "descripcion":"DEDOS DE LA MANO LARGOS Y DELGADOS"
  },
  {
    "codigo":51323005,
    "descripcion":"PERIMILÓLISIS"
  },
  {
    "codigo":247931007,
    "descripcion":"MOVIMIENTOS TORSIONALES COMPLEJOS REPETITIVOS DE OBJETOS CERCA DE LOS OJOS"
  },
  {
    "codigo":442704007,
    "descripcion":"HALLAZGO RELACIONADO CON DIFERENCIAS EN LA DISTRIBUCIÓN EN COMPARACIÓN CON EXAMEN RADIOLÓGICO PREVIO"
  },
  {
    "codigo":1260069001,
    "descripcion":"CARCINOMA ONCOCÍTICO DE OROFARINGE"
  },
  {
    "codigo":703013004,
    "descripcion":"BREVUNDIMONAS DIMINUTA U OLIGELLA URETHRALIS"
  },
  {
    "codigo":277029007,
    "descripcion":"ENLENTECIMIENTO FOCAL DE LA CONDUCCIÓN NERVIOSA MOTORA"
  },
  {
    "codigo":47653008,
    "descripcion":"RUIDOS RESPIRATORIOS RUDOS"
  },
  {
    "codigo":78586005,
    "descripcion":"DEFICIENCIA DE GAMMA GLUTAMIL TRANSPEPTIDASA"
  },
  {
    "codigo":240591000,
    "descripcion":"CONJUNTIVITIS NEONATAL POR CHLAMYDIA"
  },
  {
    "codigo":76751001,
    "descripcion":"DIABETES MELLITUS EN LA MADRE, QUE COMPLICA EL EMBARAZO, EL PARTO Y\/O EL PUERPERIO"
  },
  {
    "codigo":209658009,
    "descripcion":"SECCIÓN EXPUESTA DE LIGAMENTO ACROMIOCLAVICULAR"
  },
  {
    "codigo":15697881000119104,
    "descripcion":"ABSCESO DE BOLSA SEROSA DE AMBAS RODILLAS"
  },
  {
    "codigo":111354009,
    "descripcion":"INSUFICIENCIA VASCULAR CRÓNICA DEL INTESTINO"
  },
  {
    "codigo":733946009,
    "descripcion":"CARIES DENTAL ACTIVA SECUNDARIA QUE SE EXTIENDE HASTA EL TERCIO EXTERNO DE LA DENTINA"
  },
  {
    "codigo":109519006,
    "descripcion":"HIPERPLASIA MANDIBULAR TRANSVERSA CONGÉNITA"
  },
  {
    "codigo":1287332002,
    "descripcion":"CARCINOMA DE CÉLULAS DE MERKEL PRIMARIO DE PIEL DE CARA"
  },
  {
    "codigo":238756007,
    "descripcion":"SEUDOCROMHIDROSIS"
  },
  {
    "codigo":7545002,
    "descripcion":"LAMERSE LOS PIES"
  },
  {
    "codigo":204153003,
    "descripcion":"DISGENESIA IRIDOCORNEOTRABECULAR"
  },
  {
    "codigo":133081000119107,
    "descripcion":"CRECIMIENTO INTERNO DE EPITELIO CORNEAL"
  },
  {
    "codigo":366158000,
    "descripcion":"HALLAZGO EN LAS MEDICIONES VASCULARES"
  },
  {
    "codigo":202318002,
    "descripcion":"ANQUILOSIS DE ARTICULACIÓN DE TOBILLO"
  },
  {
    "codigo":726606003,
    "descripcion":"PARAPLEJÍA ESPÁSTICA AUTOSÓMICA RECESIVA TIPO 32"
  },
  {
    "codigo":169550004,
    "descripcion":"FRACASO DE LA ESTERILIZACIÓN FEMENINA"
  },
  {
    "codigo":300622009,
    "descripcion":"INCAPAZ DE VIAJAR EN TRANSPORTE PÚBLICO"
  },
  {
    "codigo":724771002,
    "descripcion":"TEMBLOR FISIOLÓGICO AUMENTADO"
  },
  {
    "codigo":235086009,
    "descripcion":"RELACIÓN INCISAL CLASE I"
  },
  {
    "codigo":397091005,
    "descripcion":"COMPROMISO DEL MARGEN QUIRÚRGICO PROXIMAL POR CARCINOMA IN SITU\/ADENOMA, NO APLICABLE"
  },
  {
    "codigo":298787006,
    "descripcion":"AMPLITUD DE EXTENSIÓN ACTIVA DEL HOMBRO NORMAL"
  },
  {
    "codigo":198648003,
    "descripcion":"ABORTO ESPONTÁNEO INCOMPLETO CON TRASTORNO METABÓLICO"
  },
  {
    "codigo":722936006,
    "descripcion":"ASFIXIA AL NACER CON PUNTAJE DE APGAR DE 4-6 A LOS 5 MINUTOS"
  },
  {
    "codigo":2040007,
    "descripcion":"SÍNDROME DE ABERTURA DE SALIDA TORÁCICA NEUROGÉNICO"
  },
  {
    "codigo":1148920008,
    "descripcion":"INFLAMACIÓN DE RETINA DEBIDA A ENFERMEDAD RENAL CRÓNICA ESTADIO 5"
  },
  {
    "codigo":360653002,
    "descripcion":"DEFICIENCIA DE PECTINESTERASA"
  },
  {
    "codigo":1343693003,
    "descripcion":"DESORGANIZACIÓN CONCEPTUAL"
  },
  {
    "codigo":196813002,
    "descripcion":"HERNIA INGUINAL IRREDUCTIBLE BILATERAL, RECURRENTE"
  },
  {
    "codigo":32973009,
    "descripcion":"REQUERIMIENTO HORMONAL AUMENTADO"
  },
  {
    "codigo":194978002,
    "descripcion":"INSUFICIENCIA MITRAL NO REUMÁTICA"
  },
  {
    "codigo":293282003,
    "descripcion":"REACCIÓN ADVERSA A LA GONADOTROFINA"
  },
  {
    "codigo":1145250005,
    "descripcion":"SENSIBILIDAD TÁCTIL DISTAL ALTERADA"
  },
  {
    "codigo":719266007,
    "descripcion":"ATROFIA CORIORRETINIANA BIFOCAL PROGRESIVA"
  },
  {
    "codigo":225911002,
    "descripcion":"CAPAZ DE AFRONTAR EL DOLOR"
  },
  {
    "codigo":94839003,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL PERONÉ"
  },
  {
    "codigo":291447006,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR PRIMAQUINA"
  },
  {
    "codigo":1010508000,
    "descripcion":"ESCLEROSIS DE EPÍFISIS DE FALANGE DE DEDO MEÑIQUE CON RADIOPACIDAD AUMENTADA"
  },
  {
    "codigo":1340023008,
    "descripcion":"TRASTORNO DE LIGAMENTO DE REGIÓN DE HOMBRO DERECHO"
  },
  {
    "codigo":289612006,
    "descripcion":"HALLAZGO RELACIONADO CON EL TAMAÑO DEL HIMEN"
  },
  {
    "codigo":93004007,
    "descripcion":"ANOMALÍA CONGÉNITA DE HUESO FRONTAL"
  },
  {
    "codigo":846668006,
    "descripcion":"INFARTO AGUDO DE MIOCARDIO CON ELEVACIÓN DE SEGMENTO ST DEBIDO A OCLUSIÓN DE RAMA DIAGONAL DE RAMA DESCENDENTE ANTERIOR DE ARTERIA CORONARIA IZQUIERDA"
  },
  {
    "codigo":189473001,
    "descripcion":"NEOPLASIA PARAGANGLIONAR DE COMPORTAMIENTO INCIERTO"
  },
  {
    "codigo":123937002,
    "descripcion":"INTOXICACIÓN POR TAXACEAE"
  },
  {
    "codigo":1303585005,
    "descripcion":"SÍNDROME INFANTIL DE NEURODEGENERACIÓN, ESPASTICIDAD PROGRESIVA, DISCAPACIDAD INTELECTUAL Y LESIONES DE LA SUSTANCIA BLANCA"
  },
  {
    "codigo":1172513005,
    "descripcion":"PREGNANEDIOL DENTRO DE RANGO DE REFERENCIA"
  },
  {
    "codigo":386081006,
    "descripcion":"DEFICIENCIA DE VITAMINA B6 (NO ANÉMICA)"
  },
  {
    "codigo":285942000,
    "descripcion":"INCAPAZ DE MANEJAR LOS CONTROLES DE LA DUCHA"
  },
  {
    "codigo":23798003,
    "descripcion":"TRANSLUCIDEZ DEL IRIS"
  },
  {
    "codigo":253174004,
    "descripcion":"APLASIA DEL VERMIS"
  },
  {
    "codigo":243981000119109,
    "descripcion":"FILARIASIS PULMONAR"
  },
  {
    "codigo":449782007,
    "descripcion":"GINGIVITIS PAPILAR"
  },
  {
    "codigo":21963003,
    "descripcion":"ENVENENAMIENTO POR ANIMAL MARINO"
  },
  {
    "codigo":710091005,
    "descripcion":"HALLAZGO RELACIONADO CON EL ESTADO DE DENTICIÓN COMPLETA"
  },
  {
    "codigo":284107008,
    "descripcion":"DIFICULTAD PARA CONTROLAR LA POSICIÓN"
  },
  {
    "codigo":216736005,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR WARFARINA"
  },
  {
    "codigo":249504006,
    "descripcion":"ELIMINACIÓN DE GASES"
  },
  {
    "codigo":446112008,
    "descripcion":"QUISTE DE PABELLÓN AURICULAR"
  },
  {
    "codigo":282272009,
    "descripcion":"PACIENTE PARA REASIGNACIÓN DE SEXO"
  },
  {
    "codigo":247669004,
    "descripcion":"DELIRIO DE IDENTIDAD GRANDIOSA"
  },
  {
    "codigo":870261007,
    "descripcion":"TRASTORNO GENERALIZADO DEL DESARROLLO CON ALTERACIÓN ACENTUADA DEL LENGUAJE FUNCIONAL SIN PÉRDIDA DE HABILIDADES ADQUIRIDAS PREVIAMENTE"
  },
  {
    "codigo":278602001,
    "descripcion":"EMPASTE DENTAL FLOJO"
  },
  {
    "codigo":409674002,
    "descripcion":"TIEMPO DE PROTROMBINA AUMENTADO"
  },
  {
    "codigo":1359946005,
    "descripcion":"BACTERIAS EN PARES"
  },
  {
    "codigo":735519006,
    "descripcion":"INFECCIÓN DE GLÁNDULA ENDOCRINA CAUSADA POR MYCOBACTERIUM TUBERCULOSIS"
  },
  {
    "codigo":473375006,
    "descripcion":"RUPTURA DE VALVA SEMILUNAR DE VÁLVULA TRICÚSPIDE"
  },
  {
    "codigo":1259807008,
    "descripcion":"NEFROBLASTOMA PRIMARIO DE RIÑÓN IZQUIERDO"
  },
  {
    "codigo":406004001,
    "descripcion":"HAPLOTIPO CDE"
  },
  {
    "codigo":209396003,
    "descripcion":"FRACTURA-LUXACIÓN EXPUESTA DE ARTICULACIÓN ESTERNOCLAVICULAR, ANTERIOR"
  },
  {
    "codigo":307700006,
    "descripcion":"NISTAGMO ATÁXICO"
  },
  {
    "codigo":45556008,
    "descripcion":"TULAREMIA PULMONAR"
  },
  {
    "codigo":78324009,
    "descripcion":"COLITIS ULCEROSA CRÓNICA LEVE"
  },
  {
    "codigo":367368009,
    "descripcion":"SULFITO OXIDASA - DEFICIENCIA"
  },
  {
    "codigo":897524009,
    "descripcion":"DELECIÓN DISTAL DEL BRAZO CORTO DEL CROMOSOMA 1"
  },
  {
    "codigo":76489005,
    "descripcion":"HALLAZGO RELACIONADO CON EL SENTIDO DEL GUSTO"
  },
  {
    "codigo":305865005,
    "descripcion":"ATENDIDO POR SERVICIO DE PSIQUIATRÍA"
  },
  {
    "codigo":11823681000119108,
    "descripcion":"ABRASIÓN DE PIEL DE BRAZO IZQUIERDO"
  },
  {
    "codigo":404169008,
    "descripcion":"HISTIOCITOSIS MALIGNA CON COMPROMISO CUTÁNEO"
  },
  {
    "codigo":369566000,
    "descripcion":"TUMOR MALIGNO QUE COMPROMETE EL OVARIO DERECHO POR PROPAGACIÓN DIRECTA PROVENIENTE DEL ÚTERO"
  },
  {
    "codigo":402334002,
    "descripcion":"APARICIÓN TARDÍA DE PSORIASIS DE TIPO 2"
  },
  {
    "codigo":251699006,
    "descripcion":"DRENAJE LAGRIMAL - PERMEABLE ÚNICAMENTE EN OCLUSIÓN PUNTUAL"
  },
  {
    "codigo":171123001,
    "descripcion":"CRIBADO DE HEPATITIS B - REQUERIDO"
  },
  {
    "codigo":236659004,
    "descripcion":"INCONTINENCIA URINARIA DE ESFUERZO AL TOSER"
  },
  {
    "codigo":731000119105,
    "descripcion":"ENFERMEDAD RENAL CRÓNICA EN ESTADIO 3 DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":726344001,
    "descripcion":"TRISOMÍA PARCIAL DE BRAZO LARGO DE CROMOSOMA 5"
  },
  {
    "codigo":267592003,
    "descripcion":"EPILEPSIA DE CORTEZA MOTORA PRIMARIA DE LÓBULO FRONTAL"
  },
  {
    "codigo":1119560004,
    "descripcion":"TABIQUE NASAL CORTO"
  },
  {
    "codigo":431432003,
    "descripcion":"ANGUSTIA POR LA PÉRDIDA DE MEMORIA"
  },
  {
    "codigo":365896007,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA RECORDAR EL AÑO ACTUAL"
  },
  {
    "codigo":398664009,
    "descripcion":"DEFICIENCIA DE UTP-HEXOSA-1-FOSFATO URIDILILTRANSFERASA"
  },
  {
    "codigo":724509002,
    "descripcion":"HIPOVENTILACIÓN CAUSADA POR SUSTANCIA"
  },
  {
    "codigo":298525003,
    "descripcion":"AMPLITUD DE EXTENSIÓN PASIVA DE LA COLUMNA VERTEBRAL DORSAL, NORMAL"
  },
  {
    "codigo":722674001,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE GLÁNDULA PARÓTIDA"
  },
  {
    "codigo":198386001,
    "descripcion":"LACERACIÓN ANTIGUA DE LA VULVA"
  },
  {
    "codigo":1778002,
    "descripcion":"OCLUSIÓN DEFECTUOSA POR DEGLUCIÓN ANORMAL"
  },
  {
    "codigo":1148658005,
    "descripcion":"FRECUENCIA ANORMAL DE ELECTRORRETINOGRAMA DE CENTELLEO CON ADAPTACIÓN A LA LUZ"
  },
  {
    "codigo":1279730009,
    "descripcion":"COREA POSTRAUMÁTICA"
  },
  {
    "codigo":131015007,
    "descripcion":"NIVEL DE HORMONA ESTIMULANTE DE LOS MELANOCITOS POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":294855008,
    "descripcion":"ALERGIA A ANTITROMBINA III"
  },
  {
    "codigo":293020000,
    "descripcion":"REACCIÓN ADVERSA A LA CEFOXITINA"
  },
  {
    "codigo":11852661000119105,
    "descripcion":"AMPUTACIÓN PARCIAL TRAUMÁTICA DE SEGUNDO A QUINTO DEDOS DE PIE IZQUIERDO"
  },
  {
    "codigo":260252003,
    "descripcion":"J2"
  },
  {
    "codigo":424092004,
    "descripcion":"EXPLICACIÓN DE LA LESIÓN TRAUMÁTICA, CUESTIONABLE"
  },
  {
    "codigo":127345001,
    "descripcion":"TRASTORNO DE LAS GÓNADAS ENDOCRINAS"
  },
  {
    "codigo":291185002,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR PIPOTIAZINA"
  },
  {
    "codigo":94577003,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE PIEL DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":225649001,
    "descripcion":"ESPERANZADO EN EL FUTURO"
  },
  {
    "codigo":15922191000119102,
    "descripcion":"RUPTURA TRAUMÁTICA DE TENDÓN DE BÍCEPS FEMORAL DERECHO"
  },
  {
    "codigo":685071000119102,
    "descripcion":"HEMOGLOBINA C-BETA 0 TALASEMIA"
  },
  {
    "codigo":92742004,
    "descripcion":"CARCINOMA IN SITU DE PIEL DE LA REGIÓN TEMPORAL"
  },
  {
    "codigo":420422005,
    "descripcion":"CETOACIDOSIS DIABÉTICA"
  },
  {
    "codigo":289350009,
    "descripcion":"PELOTEO CEFÁLICO FETAL, A TRAVÉS DEL ABDOMEN"
  },
  {
    "codigo":27206009,
    "descripcion":"AGRAFIA"
  },
  {
    "codigo":254747004,
    "descripcion":"FIBROMATOSIS AGRESIVA DE PIEL"
  },
  {
    "codigo":23536000,
    "descripcion":"DEFECTO DE ACOPLAMIENTO DE YODOTIROSILO"
  },
  {
    "codigo":285680001,
    "descripcion":"DIFICULTAD PARA CARGAR PESO"
  },
  {
    "codigo":1336091009,
    "descripcion":"DEFICIENCIA HEREDITARIA LEVE DE FACTOR IX"
  },
  {
    "codigo":449520004,
    "descripcion":"OBSTRUCCIÓN AL TRACTO DE SALIDA DE VENTRÍCULO DERECHO DEBIDA A TRABECULACIÓN SEPTOPARIETAL"
  },
  {
    "codigo":1268720005,
    "descripcion":"PERINEUROMA MALIGNO PRIMARIO"
  },
  {
    "codigo":416752006,
    "descripcion":"RESISTENCIA DE PARTES BLANDAS"
  },
  {
    "codigo":111631000119106,
    "descripcion":"DILATACIÓN CONGÉNITA DE PELVIS RENAL"
  },
  {
    "codigo":283845000,
    "descripcion":"LESIÓN POR DESOLLAMIENTO DE TRONCO"
  },
  {
    "codigo":414917005,
    "descripcion":"OBESIDAD SEGÚN PATRÓN DE CRECIMIENTO ADIPOCÍTICO"
  },
  {
    "codigo":447685007,
    "descripcion":"SEPSIS CAUSADA POR HAEMOPHILUS INFLUENZAE"
  },
  {
    "codigo":85402004,
    "descripcion":"SÍNDROME MENINGOERUPTIVO"
  },
  {
    "codigo":445850005,
    "descripcion":"QUEMADURA PROFUNDA DE TERCER GRADO DE REGIÓN DEL OJO"
  },
  {
    "codigo":707994006,
    "descripcion":"AUSENCIA DE ÚVULA"
  },
  {
    "codigo":19866007,
    "descripcion":"OPERACIÓN PREVIA DE CUELLO UTERINO, QUE AFECTA EL EMBARAZO"
  },
  {
    "codigo":50799005,
    "descripcion":"DISOCIACIÓN AURICULOVENTRICULAR"
  },
  {
    "codigo":247407006,
    "descripcion":"ALTA TOLERANCIA AL DOLOR"
  },
  {
    "codigo":1197679008,
    "descripcion":"ÍLEO PARALÍTICO DE INTESTINO DELGADO Y COLON"
  },
  {
    "codigo":312943008,
    "descripcion":"TUMEFACCIÓN IDIOPÁTICA DE LA PAPILA ÓPTICA"
  },
  {
    "codigo":16196000,
    "descripcion":"MONONUCLEOSIS POR CITOMEGALOVIRUS"
  },
  {
    "codigo":11855171000119100,
    "descripcion":"AMPOLLA TRAUMÁTICA DE MITAD IZQUIERDA DE PARED POSTERIOR DE TÓRAX"
  },
  {
    "codigo":1163076006,
    "descripcion":"ENCEFALITIS CAUSADA POR MORBILLIVIRUS"
  },
  {
    "codigo":16606531000119101,
    "descripcion":"ENTEROCOLITIS ISQUÉMICA DIFUSA AGUDA"
  },
  {
    "codigo":1259545004,
    "descripcion":"EXTRAVASACIÓN DE LÍQUIDO CEFALORRAQUÍDEO CRANEAL"
  },
  {
    "codigo":440345007,
    "descripcion":"TÍTULO DE DOCTOR OBTENIDO"
  },
  {
    "codigo":79897009,
    "descripcion":"ABSCESO CEREBELOSO"
  },
  {
    "codigo":471278002,
    "descripcion":"COMUNICACIÓN INTERAURICULAR RECURRENTE DESPUÉS DE PROCEDIMIENTO QUIRÚRGICO CARDIOVASCULAR PREVIO"
  },
  {
    "codigo":241902003,
    "descripcion":"EFECTO TÓXICO CAUSADO POR ADHESIVO"
  },
  {
    "codigo":438510004,
    "descripcion":"VÁRICES DE PRÓSTATA SANGRANTES"
  },
  {
    "codigo":209134006,
    "descripcion":"SUBLUXACIÓN NO EXPUESTA DE LA COLUMNA VERTEBRAL CERVICAL"
  },
  {
    "codigo":45294007,
    "descripcion":"SÍNDROME AURICULOTEMPORAL"
  },
  {
    "codigo":405742008,
    "descripcion":"HALLAZGO RELACIONADO CON EL TRATAMIENTO CON ASPIRINA"
  },
  {
    "codigo":733422008,
    "descripcion":"AMILOIDOSIS SISTÉMICA POR PROTEÍNA PRIÓNICA"
  },
  {
    "codigo":897262008,
    "descripcion":"CURVATURA ANORMAL DE FALANGE DE DEDO PULGAR"
  },
  {
    "codigo":403907002,
    "descripcion":"QUERATOACANTOMA GIGANTE"
  },
  {
    "codigo":698819004,
    "descripcion":"SEPSIS POSOPERATORIA"
  },
  {
    "codigo":240067001,
    "descripcion":"DISTROFIA MUSCULAR AUTOSÓMICA DOMINANTE CON DISTRIBUCIÓN EN LAS CINTURAS ESCAPULAR O PÉLVICA"
  },
  {
    "codigo":371139006,
    "descripcion":"CIRROSIS TEMPRANA"
  },
  {
    "codigo":372974008,
    "descripcion":"INFECCIÓN CAUSADA POR ASPERGILLUS BOUFFARDII"
  },
  {
    "codigo":762520000,
    "descripcion":"EROSIÓN DE AURÍCULA DERECHA DEBIDA A IMPLANTE DE DISPOSITIVO Y POSTERIOR A ÉL"
  },
  {
    "codigo":305603003,
    "descripcion":"BAJO ATENCIÓN DE NUTRICIONISTA EXTRAHOSPITALARIO"
  },
  {
    "codigo":41624003,
    "descripcion":"DISFUNCIÓN SEGMENTARIA"
  },
  {
    "codigo":367469000,
    "descripcion":"DEFICIENCIA DE LA VISIÓN EN COLORES"
  },
  {
    "codigo":860824009,
    "descripcion":"EOSINOFILIA DEBIDA A ENFERMEDAD INFECCIOSA"
  },
  {
    "codigo":1286808008,
    "descripcion":"NEOPLASIA GERMINAL NO SEMINOMATOSA PRIMARIA DE TESTÍCULO DESCENDIDO"
  },
  {
    "codigo":301933003,
    "descripcion":"HALLAZGO RELACIONADO CON LA PROFUNDIDAD DE LA CÁMARA ANTERIOR"
  },
  {
    "codigo":236397005,
    "descripcion":"GLOMERULONEFRITIS POSINFECCIOSA - VARIEDAD DE GARLAND"
  },
  {
    "codigo":269165008,
    "descripcion":"HERIDA ABIERTA DE TÍMPANO"
  },
  {
    "codigo":300098001,
    "descripcion":"MASA EN PABELLÓN AURICULAR"
  },
  {
    "codigo":7021009,
    "descripcion":"GRANULOMA EOSINOFÍLICO GASTROINTESTINAL"
  },
  {
    "codigo":11828701000119102,
    "descripcion":"AMPOLLA TRAUMÁTICA DE CADERA DERECHA"
  },
  {
    "codigo":726082003,
    "descripcion":"GLOMERULONEFRITIS INMUNOTACTOIDE"
  },
  {
    "codigo":1119298000,
    "descripcion":"ANOMALÍA ADQUIRIDA DE APARATO SUBVALVULAR MITRAL"
  },
  {
    "codigo":16907741000119103,
    "descripcion":"NEVO DISPLÁSICO DE PIEL DE PÁRPADO INFERIOR IZQUIERDO"
  },
  {
    "codigo":234562007,
    "descripcion":"DEFICIENCIA DE ANTICUERPO ANTIPROTEICO"
  },
  {
    "codigo":365634009,
    "descripcion":"CONTROL DE ANTICOAGULACIÓN - HALLAZGO"
  },
  {
    "codigo":427500003,
    "descripcion":"ARTROPATÍA DE CARILLA ARTICULAR DE LA COLUMNA CERVICAL"
  },
  {
    "codigo":294593005,
    "descripcion":"ALERGIA A CLORANFENICOL"
  },
  {
    "codigo":61547000,
    "descripcion":"INTOXICACIÓN POR GUTIERREZIA MICROCEPHALA"
  },
  {
    "codigo":94315003,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL GLANDE DEL PENE"
  },
  {
    "codigo":290923004,
    "descripcion":"INTOXICACIÓN POR TRAZODONA"
  },
  {
    "codigo":127083009,
    "descripcion":"LINFADENOPATÍA SUBMENTONIANA"
  },
  {
    "codigo":289088002,
    "descripcion":"COLOCA AL BEBÉ AL PECHO PARA AMAMANTARLO"
  },
  {
    "codigo":26944003,
    "descripcion":"ANEMIA MEGALOBLÁSTICA AGUDA POR DIÁLISIS"
  },
  {
    "codigo":92480004,
    "descripcion":"NEOPLASIA BENIGNA DE BORDE BERMELLÓN DE LABIO SUPERIOR"
  },
  {
    "codigo":254485000,
    "descripcion":"NEOPLASIA DEL VESTÍBULO NASAL"
  },
  {
    "codigo":90645002,
    "descripcion":"INTENTO FALLIDO DE ABORTO SIN COMPLICACIÓN"
  },
  {
    "codigo":290568003,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR TETRACAÍNA"
  },
  {
    "codigo":1237525006,
    "descripcion":"METÁSTASIS DE CARCINOMA DE ESTÓMAGO"
  },
  {
    "codigo":188949006,
    "descripcion":"NEOPLASIA BENIGNA DE HUESO TRAPEZOIDE"
  },
  {
    "codigo":418325008,
    "descripcion":"REACCIÓN ALÉRGICA CAUSADA POR ADHESIVO"
  },
  {
    "codigo":449258001,
    "descripcion":"HEMANGIOMA DE PARED TORÁCICA"
  },
  {
    "codigo":1335829006,
    "descripcion":"PROCTITIS CAUSADA POR MYCOPLASMA GENITALIUM"
  },
  {
    "codigo":1268458008,
    "descripcion":"CARCINOMA ANAPLÁSICO DE TIROIDES PRIMARIO"
  },
  {
    "codigo":840639002,
    "descripcion":"SECRECIÓN DE HERIDA DE REGIÓN OCULAR"
  },
  {
    "codigo":283583006,
    "descripcion":"HERIDA DE PERDIGÓN EN MUSLO"
  },
  {
    "codigo":609428000,
    "descripcion":"DAÑO FETAL POR TRASTORNO INFECCIOSO MATERNO"
  },
  {
    "codigo":306961000119105,
    "descripcion":"DERRAME ARTICULAR DE CADERA DERECHA"
  },
  {
    "codigo":185279008,
    "descripcion":"ATENDIDO POR UNA ENFERMERA DE CONSULTORIO PRIVADO"
  },
  {
    "codigo":1363092003,
    "descripcion":"ASTILLA EN FLANCO CON INFECCIÓN"
  },
  {
    "codigo":248980004,
    "descripcion":"SANGRADO POR CONTACTO DEL CUELLO UTERINO"
  },
  {
    "codigo":19604005,
    "descripcion":"ENFERMEDAD POR ALMACENAMIENTO DE TRIGLICÉRIDOS CON ICTIOSIS"
  },
  {
    "codigo":10956561000119106,
    "descripcion":"HERIDA ABIERTA DE DEDO MEÑIQUE IZQUIERDO"
  },
  {
    "codigo":314516007,
    "descripcion":"CELULITIS PRESEPTAL"
  },
  {
    "codigo":17769000,
    "descripcion":"LESIÓN TRAUMÁTICA DEL NERVIO CRANEAL"
  },
  {
    "codigo":871572007,
    "descripcion":"REACCIÓN ADVERSA A BAMETÁN"
  },
  {
    "codigo":704062006,
    "descripcion":"FRACTURA POR ESTRÉS DE HÚMERO"
  },
  {
    "codigo":276243003,
    "descripcion":"DELIRIOS PRIMARIOS"
  },
  {
    "codigo":440083004,
    "descripcion":"ABSORCIOMETRÍA DUAL POR RAYOS X DE CUELLO DE FÉMUR NORMAL"
  },
  {
    "codigo":1259283004,
    "descripcion":"COMPLEJO QRS DESCENDIDO"
  },
  {
    "codigo":833299006,
    "descripcion":"AGUDEZA VISUAL DE OJO DERECHO 3\/60"
  },
  {
    "codigo":472851007,
    "descripcion":"ESTENOSIS DE VÁLVULA AURICULOVENTRICULAR IZQUIERDA FETAL (MORFOLÓGICAMENTE NO MITRAL)"
  },
  {
    "codigo":866067008,
    "descripcion":"MIELITIS CAUSADA POR SCHISTOSOMA JAPONICUM"
  },
  {
    "codigo":38491000087105,
    "descripcion":"HIPOCINESIA DE MIOCARDIO DE REGIÓN LATERAL DE VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":46171000087101,
    "descripcion":"FRACTURA DE CARPO IZQUIERDO"
  },
  {
    "codigo":48731000087103,
    "descripcion":"DISTENSIÓN DE TENDÓN FLEXOR DE MUÑECA DERECHA"
  },
  {
    "codigo":41051000087102,
    "descripcion":"SUBLUXACIÓN DE ARTICULACIÓN FEMORORROTULIANA DERECHA"
  },
  {
    "codigo":307176005,
    "descripcion":"CIÁTICA AGUDA"
  },
  {
    "codigo":43611000087106,
    "descripcion":"CONTUSIÓN DE MEJILLA DERECHA"
  },
  {
    "codigo":12264001,
    "descripcion":"MESIOCLUSIÓN"
  },
  {
    "codigo":208872008,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA PROXIMAL DE DEDO DE LA MANO"
  },
  {
    "codigo":75965001,
    "descripcion":"GRANULOMA PERITONEAL"
  },
  {
    "codigo":897000009,
    "descripcion":"FORMA DE BALA ANORMAL CONGÉNITA DE FALANGE DE MANO"
  },
  {
    "codigo":403645003,
    "descripcion":"REACCIÓN DE MANIFESTACIÓN ACTÍNICA TARDÍA DEBIDA A TRATAMIENTO CITOTÓXICO"
  },
  {
    "codigo":239805001,
    "descripcion":"ESPONDILITIS ANQUILOSANTE JUVENIL"
  },
  {
    "codigo":272573006,
    "descripcion":"POSICIÓN DE TORACOTOMÍA"
  },
  {
    "codigo":698557007,
    "descripcion":"HEMATOMA TRAUMÁTICO DE PREPUCIO"
  },
  {
    "codigo":41362007,
    "descripcion":"PAQUIMENINGITIS OSIFICANTE"
  },
  {
    "codigo":236135005,
    "descripcion":"ESTOMA DE ALTO DÉBITO"
  },
  {
    "codigo":427443009,
    "descripcion":"MIOCARDITIS LINFOCÍTICA"
  },
  {
    "codigo":301671009,
    "descripcion":"SE ACUESTA EN LA CAMA"
  },
  {
    "codigo":267068004,
    "descripcion":"NUNCA HA SIDO SEXUALMENTE ACTIVO"
  },
  {
    "codigo":299836006,
    "descripcion":"REFLEJO SUPINADOR SÓLO PRESENTE CON REFUERZO"
  },
  {
    "codigo":309471000119100,
    "descripcion":"NECROSIS AVASCULAR DE HUESO DE REGIÓN DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":365372007,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA REALIZAR UNA ACTIVIDAD CREATIVA"
  },
  {
    "codigo":398140007,
    "descripcion":"FENÓMENO DE SOMOGYI"
  },
  {
    "codigo":335941000119107,
    "descripcion":"AGRANDAMIENTO CRÓNICO DE GLÁNDULA LAGRIMAL DERECHA"
  },
  {
    "codigo":10631391000119100,
    "descripcion":"ABSCESO DE PIEL DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":166929004,
    "descripcion":"PRUEBA DE TOLERANCIA A LA GLUCOSA (PTG) = GLUCOSURIA RENAL"
  },
  {
    "codigo":298001000,
    "descripcion":"PÉRDIDA DE PELO DEL CUERPO"
  },
  {
    "codigo":1073221000119108,
    "descripcion":"ARTRITIS DE HOMBRO DERECHO CAUSADA POR BACTERIAS"
  },
  {
    "codigo":16038111000119102,
    "descripcion":"OSTEOCONDROPATÍA DE RADIO DERECHO"
  },
  {
    "codigo":3089009,
    "descripcion":"EVALUACIÓN DE DISCAPACIDAD: ALTERACIÓN CLASE 7"
  },
  {
    "codigo":722150000,
    "descripcion":"ENFERMEDAD RENAL CRÓNICA DEBIDA A INFECCIÓN SISTÉMICA"
  },
  {
    "codigo":66790001,
    "descripcion":"CONTAMINACIÓN DEL CRECIMIENTO BACTERIANO"
  },
  {
    "codigo":145631000119102,
    "descripcion":"ANAFILAXIA CAUSADA POR ADITIVO ALIMENTARIO"
  },
  {
    "codigo":230630005,
    "descripcion":"COMPRESIÓN DE LIGAMENTO DE STRUTHER"
  },
  {
    "codigo":296166001,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE CLOZAPINA"
  },
  {
    "codigo":396305008,
    "descripcion":"MARGEN QUIRÚRGICO DISTAL NO AFECTADO POR CARCINOMA IN SITU"
  },
  {
    "codigo":425403003,
    "descripcion":"PERCEPCIÓN SENSORIAL LIMITADA"
  },
  {
    "codigo":390800000,
    "descripcion":"ALCANCE DEL OBJETIVO - HALLAZGO"
  },
  {
    "codigo":196027008,
    "descripcion":"BRONQUIOLITIS OBLITERANTE TÓXICA"
  },
  {
    "codigo":1144464000,
    "descripcion":"APLASIA DE QUINTO HUESO METACARPIANO"
  },
  {
    "codigo":292496004,
    "descripcion":"REACCIÓN ADVERSA AL BAMBUTEROL"
  },
  {
    "codigo":95888005,
    "descripcion":"FIEBRE MICOPLASMÁTICA POSPARTO"
  },
  {
    "codigo":290661003,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR DOXORUBICINA"
  },
  {
    "codigo":126821004,
    "descripcion":"NEOPLASIA DEL TERCIO SUPERIOR DEL ESÓFAGO"
  },
  {
    "codigo":94053004,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE PARTES BLANDAS DE LA CARA"
  },
  {
    "codigo":92218002,
    "descripcion":"NEOPLASIA BENIGNA DEL OÍDO MEDIO"
  },
  {
    "codigo":419898002,
    "descripcion":"EL MARGEN DE RESECCIÓN QUIRÚRGICA SUPERIOR ES EL MARGEN NO AFECTADO MÁS CERCANO AL CARCINOMA DUCTAL IN SITU"
  },
  {
    "codigo":59450004,
    "descripcion":"JUEGO SEXUAL MIXTO"
  },
  {
    "codigo":288826007,
    "descripcion":"IMITA PALABRAS"
  },
  {
    "codigo":26682008,
    "descripcion":"TALASEMIA BETA HOMOCIGOTA"
  },
  {
    "codigo":24847006,
    "descripcion":"FUNCIÓN CORPORAL GENERAL NO APLICABLE"
  },
  {
    "codigo":90383006,
    "descripcion":"AUSENCIA CONGÉNITA DE LA AORTA"
  },
  {
    "codigo":876815007,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE ESCROTO CON INFECCIÓN"
  },
  {
    "codigo":254223007,
    "descripcion":"CUTIS LAXO RECESIVO, TIPO II"
  },
  {
    "codigo":418063007,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA INFERIOR COMPROMETIDO POR CARCINOMA DUCTAL IN SITU"
  },
  {
    "codigo":285156004,
    "descripcion":"CAPAZ DE RECONOCER OBJETOS"
  },
  {
    "codigo":23012005,
    "descripcion":"DERMATITIS DE CONTACTO CAUSADA POR SOLVENTES"
  },
  {
    "codigo":448996004,
    "descripcion":"HEMANGIOMA DE AXILA"
  },
  {
    "codigo":88548007,
    "descripcion":"BAROSINUSITIS"
  },
  {
    "codigo":414393003,
    "descripcion":"TRASTORNO HEREDITARIO DE COMPONENTE CELULAR SANGUÍNEO"
  },
  {
    "codigo":283321007,
    "descripcion":"PICADURA DE INSECTO EN LA CABEZA Y EL CUELLO"
  },
  {
    "codigo":15683961000119108,
    "descripcion":"BURSITIS DE AMBAS MUÑECAS"
  },
  {
    "codigo":707470000,
    "descripcion":"CARCINOMA BRONQUIOLOALVEOLAR MUCINOSO PRIMARIO DE PULMÓN"
  },
  {
    "codigo":86713007,
    "descripcion":"FALTA DE PERSISTENCIA"
  },
  {
    "codigo":838542004,
    "descripcion":"INSUFICIENCIA MODERADA DE VÁLVULA PULMONAR"
  },
  {
    "codigo":1264526007,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE DEDO ANULAR"
  },
  {
    "codigo":19342008,
    "descripcion":"ENFERMEDAD SUBAGUDA"
  },
  {
    "codigo":248718009,
    "descripcion":"HALLAZGO RELACIONADO CON ARTERIA"
  },
  {
    "codigo":443491001,
    "descripcion":"MIONECROSIS ANAERÓBICA"
  },
  {
    "codigo":1075731000119104,
    "descripcion":"CONTRACTURA DE MÚSCULO DE PIE DERECHO"
  },
  {
    "codigo":1197155007,
    "descripcion":"MIOPATÍA NEMALÍNICA TIPO AMISH"
  },
  {
    "codigo":48440001,
    "descripcion":"GOTA ARTICULAR"
  },
  {
    "codigo":50275009,
    "descripcion":"MIOCARDIOPATÍA POR COBALTO"
  },
  {
    "codigo":81208006,
    "descripcion":"ECTRODACTILIA"
  },
  {
    "codigo":441656006,
    "descripcion":"CRISIS HIPERGLUCÉMICA DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":611251000124104,
    "descripcion":"DETECTOR DE HUMO FUNCIONANTE EN DOMICILIO"
  },
  {
    "codigo":212280009,
    "descripcion":"LESIÓN CERRADA DE NERVIO DIGITAL, MÚLTIPLE"
  },
  {
    "codigo":277816006,
    "descripcion":"MIEDO RELACIONADO CON UNA FUNCIÓN CORPORAL"
  },
  {
    "codigo":1971000124109,
    "descripcion":"TRANSICIÓN DE LA ATENCIÓN EN CUIDADOS PALIATIVOS A ATENCIÓN AGUDA"
  },
  {
    "codigo":767501008,
    "descripcion":"RETRUSIÓN DE LABIO INFERIOR"
  },
  {
    "codigo":112141008,
    "descripcion":"PRODUCCIÓN ANORMAL DE PLAQUETAS"
  },
  {
    "codigo":470754002,
    "descripcion":"NEOPLASIA DE CORAZÓN FETAL"
  },
  {
    "codigo":77538000,
    "descripcion":"DOLOR SUPERFICIAL"
  },
  {
    "codigo":274146004,
    "descripcion":"FRACTURA PATOLÓGICA DE VÉRTEBRA"
  },
  {
    "codigo":208610006,
    "descripcion":"FRACTURA NO EXPUESTA DE TIBIA PROXIMAL, CÓNDILO INTERNO (MESETA)"
  },
  {
    "codigo":437986008,
    "descripcion":"MENINGISMO"
  },
  {
    "codigo":896738008,
    "descripcion":"FORMA DE CONO ANORMAL CONGÉNITA DE EPÍFISIS DE FALANGE DE DEDO MEÑIQUE"
  },
  {
    "codigo":12002009,
    "descripcion":"HIPERINSULINISMO FUNCIONAL"
  },
  {
    "codigo":306914009,
    "descripcion":"PABELLÓN AURICULAR PEQUEÑO"
  },
  {
    "codigo":403383007,
    "descripcion":"LINFEDEMA LABIAL"
  },
  {
    "codigo":15958701000119105,
    "descripcion":"MELANOMA MALIGNO METASTÁSICO DE AMBOS RIÑONES"
  },
  {
    "codigo":73868002,
    "descripcion":"DESVIACIÓN RADIAL DE LA MUÑECA"
  },
  {
    "codigo":237708004,
    "descripcion":"HIPOFISITIS GRANULOMATOSA DE CÉLULAS GIGANTES"
  },
  {
    "codigo":1351820005,
    "descripcion":"COLANGIOGRAFÍA FLUOROSCÓPICA CON CONTRASTE NORMAL"
  },
  {
    "codigo":6497000,
    "descripcion":"ÍNDICE DE MASA CORPORAL DISMINUIDO"
  },
  {
    "codigo":235873001,
    "descripcion":"HEPATITIS POR HALOTANO"
  },
  {
    "codigo":301409004,
    "descripcion":"DOLOR A LA PALPACIÓN EN REGIÓN DE HIPOGASTRIO"
  },
  {
    "codigo":432481004,
    "descripcion":"ABSCESO DE PUNTO DE SUTURA EN CÓRNEA"
  },
  {
    "codigo":203105008,
    "descripcion":"FIBROSITIS DEL BRAZO"
  },
  {
    "codigo":365110000,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA MOVILIZARSE AL AIRE LIBRE"
  },
  {
    "codigo":11836231000119102,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN DE PIE DERECHO"
  },
  {
    "codigo":12000071000119102,
    "descripcion":"CONGELAMIENTO DE PIERNA IZQUIERDA"
  },
  {
    "codigo":37430004,
    "descripcion":"SÍFILIS DEL SINOVIO"
  },
  {
    "codigo":397878005,
    "descripcion":"INCONTINENCIA URINARIA POR REBOSAMIENTO"
  },
  {
    "codigo":299574006,
    "descripcion":"HALLAZGO RELACIONADO CON EL MOVIMIENTO DE DEDO DEL PIE"
  },
  {
    "codigo":1217078006,
    "descripcion":"PSEUDOHERMAFRODITISMO MASCULINO POR HIPERPLASIA SUPRARRENAL CONGÉNITA"
  },
  {
    "codigo":1153377008,
    "descripcion":"LEUCEMIA AGUDA DE FENOTIPO MIXTO CON T(9;22) (Q34;Q11.2); BCR-ABL1"
  },
  {
    "codigo":789259003,
    "descripcion":"DESACELERACIÓN PROLONGADA DE LATIDOS CARDÍACOS FETALES"
  },
  {
    "codigo":166667003,
    "descripcion":"NIVEL SÉRICO DE ASPARTATO AMINOTRANSFERASA\/TRANSAMINASA GLUTAMICOXALACÉTICA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":35595006,
    "descripcion":"DERADELFO"
  },
  {
    "codigo":721888002,
    "descripcion":"SÍNDROME DE CUERO CABELLUDO, OÍDO Y PEZÓN"
  },
  {
    "codigo":230368002,
    "descripcion":"ENFERMEDAD TRANSITORIA DE PELIZAEUS-MERZBACHER TIPO III"
  },
  {
    "codigo":197600002,
    "descripcion":"SÍNDROME NEFRÓTICO, GLOMERULONEFRITIS SEMILUNAR DIFUSA"
  },
  {
    "codigo":263136005,
    "descripcion":"RUPTURA DE LIGAMENTO DE CODO"
  },
  {
    "codigo":33760009,
    "descripcion":"PANICULITIS NODULAR FEBRIL RECIDIVANTE NO SUPURATIVA"
  },
  {
    "codigo":195765002,
    "descripcion":"RINITIS SIMPLE CRÓNICA"
  },
  {
    "codigo":31925001,
    "descripcion":"DEFICIENCIA HEREDITARIA DEL FACTOR I"
  },
  {
    "codigo":367431000119107,
    "descripcion":"DISFUNCIÓN ERÉCTIL CONCOMITANTE CON INSUFICIENCIA ARTERIAL Y DEBIDA A ELLA"
  },
  {
    "codigo":295904009,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE TRANILCIPROMINA"
  },
  {
    "codigo":426976009,
    "descripcion":"DOLOR PROVOCADO POR LA RESPIRACIÓN"
  },
  {
    "codigo":294069009,
    "descripcion":"ALERGIA A BIPERIDENO"
  },
  {
    "codigo":292234002,
    "descripcion":"REACCIÓN ADVERSA AL FLUOROURACILO"
  },
  {
    "codigo":718218005,
    "descripcion":"POROQUERATOSIS PALMOPLANTAR Y DISEMINADA"
  },
  {
    "codigo":95626009,
    "descripcion":"ÍLEO ESPÁSTICO DEL RECIÉN NACIDO"
  },
  {
    "codigo":126559003,
    "descripcion":"NEOPLASIA DEL ESTERNÓN"
  },
  {
    "codigo":124724003,
    "descripcion":"PERISTALTISMO URETERAL ANORMAL"
  },
  {
    "codigo":91956006,
    "descripcion":"ENFERMEDAD DE LAS AZORES, TIPO IV"
  },
  {
    "codigo":286729002,
    "descripcion":"CARÁCTER NO COOPERATIVO"
  },
  {
    "codigo":253961006,
    "descripcion":"DEFICIENCIA TRANSVERSA DE DEDO DEL PIE"
  },
  {
    "codigo":22750001,
    "descripcion":"DRENAJE VENOSO PULMONAR ANÓMALO HACIA LA PORCIÓN ABDOMINAL DE LA VENA CAVA INFERIOR"
  },
  {
    "codigo":1237001009,
    "descripcion":"INFLAMACIÓN SEBORREICA DE BORDE ANTERIOR DE PÁRPADO INFERIOR IZQUIERDO"
  },
  {
    "codigo":710878005,
    "descripcion":"TAQUICARDIA POR FIBRAS DE MAHAIM"
  },
  {
    "codigo":284894006,
    "descripcion":"CAPAZ DE MAQUILLARSE"
  },
  {
    "codigo":219358009,
    "descripcion":"LESIÓN POR BAJAS TEMPERATURAS EXTREMAS, CON PROPÓSITO DESCONOCIDO"
  },
  {
    "codigo":330741000119100,
    "descripcion":"SÍNDROME DE NERVIO INTERÓSEO POSTERIOR IZQUIERDO"
  },
  {
    "codigo":11858421000119101,
    "descripcion":"LESIÓN TRAUMÁTICA DE ARTERIA POPLÍTEA IZQUIERDA"
  },
  {
    "codigo":15964661000119102,
    "descripcion":"COR PULMONALE AGUDO DEBIDO A EMBOLIA PULMONAR SÉPTICA"
  },
  {
    "codigo":1091061000119103,
    "descripcion":"INFLAMACIÓN CRÓNICA DE MASTOIDES DERECHA"
  },
  {
    "codigo":115940341000119100,
    "descripcion":"ÚLCERA DE ANASTOMOSIS CRÓNICA"
  },
  {
    "codigo":15631861000119105,
    "descripcion":"VENAS ARACNIFORMES DE AMBAS EXTREMIDADES INFERIORES"
  },
  {
    "codigo":90101000119106,
    "descripcion":"EDENTULISMO PARCIAL CLASE II"
  },
  {
    "codigo":15936501000119100,
    "descripcion":"DERMATOSIS INFLAMATORIA DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":307701000119108,
    "descripcion":"DISPLASIA FIBROSA MONOSTÓTICA DE HÚMERO IZQUIERDO"
  },
  {
    "codigo":323061000119108,
    "descripcion":"LONGITUD DESIGUAL DE EXTREMIDAD SUPERIOR DEBIDA A ACORTAMIENTO ADQUIRIDO DE HÚMERO IZQUIERDO"
  },
  {
    "codigo":10954741000119108,
    "descripcion":"AVULSIÓN DE UNIDAD UNGUEAL DE PULGAR DERECHO"
  },
  {
    "codigo":141301000119102,
    "descripcion":"QUISTE BRONCÓGENO ADQUIRIDO"
  },
  {
    "codigo":1085941000119104,
    "descripcion":"HEMORRAGIA RECTAL DEBIDA A ENFERMEDAD DE CROHN"
  },
  {
    "codigo":745761781000119105,
    "descripcion":"DEFECTO DE CAMPO VISUAL DEBIDO A HEMORRAGIA INTRACEREBRAL Y POSTERIOR A ELLA"
  },
  {
    "codigo":12224501000119108,
    "descripcion":"INFECCIÓN DE HÍGADO TRASPLANTADO"
  },
  {
    "codigo":1297032008,
    "descripcion":"CONTRACTURA DE VEJIGA URINARIA"
  },
  {
    "codigo":248456009,
    "descripcion":"ESCALOFRÍOS O TEMBLORES"
  },
  {
    "codigo":707208009,
    "descripcion":"PIELONEFRITIS CRÓNICA NO OBSTRUCTIVA FAMILIAR ASOCIADA CON REFLUJO"
  },
  {
    "codigo":312157006,
    "descripcion":"MEDIASTINITIS INFECCIOSA"
  },
  {
    "codigo":770909004,
    "descripcion":"CONDRODISPLASIA METAFISARIA TIPO KAITILA"
  },
  {
    "codigo":15934741000119102,
    "descripcion":"DEFORMIDAD ADQUIRIDA EN CALCANEOVARO DE AMBOS PIES"
  },
  {
    "codigo":1196893009,
    "descripcion":"NEOPLASIA GLANDULAR INTRAEPITELIAL DE APÉNDICE DE ALTO GRADO"
  },
  {
    "codigo":703538003,
    "descripcion":"DEFICIENCIA DE LECTINA FIJADORA DE MANOSA"
  },
  {
    "codigo":769074003,
    "descripcion":"LEVADURA DE ESPECIE NO CRYPTOCOCCUS GATTII Y NO CRYPTOCOCCUS NEOFORMANS DETECTADA"
  },
  {
    "codigo":11838741000119103,
    "descripcion":"LACERACIÓN DE MÚSCULO INTRÍNSECO DE DEDO ANULAR DERECHO"
  },
  {
    "codigo":1162290006,
    "descripcion":"LORDOSIS DEBIDA A LESIÓN TRAUMÁTICA Y POSTERIOR A ELLA"
  },
  {
    "codigo":111879004,
    "descripcion":"HEPATITIS POR VIRUS A SIN COMA HEPÁTICO"
  },
  {
    "codigo":46343005,
    "descripcion":"EXOFORIA"
  },
  {
    "codigo":275719008,
    "descripcion":"EVIDENCIA DE INFECCIÓN EN EL ESPUTO"
  },
  {
    "codigo":472327008,
    "descripcion":"MIOCARDIOPATÍA DILATADA FETAL"
  },
  {
    "codigo":698033000,
    "descripcion":"CONTORNO GINGIVAL BAJO"
  },
  {
    "codigo":403121001,
    "descripcion":"MICETOMA CAUSADO POR PSEUDALLESCHERIA BOYDII"
  },
  {
    "codigo":291037001,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR LOPRAZOLAM"
  },
  {
    "codigo":110044008,
    "descripcion":"LACERACIÓN COMPLEJA DE LA REGIÓN CIGOMÁTICA DE LA MEJILLA"
  },
  {
    "codigo":1156785005,
    "descripcion":"LEIOMIOSARCOMA DE DUODENO"
  },
  {
    "codigo":75441006,
    "descripcion":"CUERPO EXTRAÑO EN EL OÍDO"
  },
  {
    "codigo":302982001,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR ENZIMAS"
  },
  {
    "codigo":1351558002,
    "descripcion":"FALTA DE PERFUSIÓN DE CAPILARES PERIFOVEALES DE OJO DERECHO"
  },
  {
    "codigo":237446005,
    "descripcion":"SÍFILIS MAMARIA"
  },
  {
    "codigo":401286005,
    "descripcion":"ESCALA DE DISNEA DE BORG: 6 - SEVERA (+)"
  },
  {
    "codigo":202843000,
    "descripcion":"DESGARRO DE ESPESOR TOTAL DEL MANGUITO ROTADOR"
  },
  {
    "codigo":366683001,
    "descripcion":"AMPLITUD DE MOVIMIENTO PASIVO DE ABDUCCIÓN DE DEDO DE LA MANO - HALLAZGO"
  },
  {
    "codigo":301147003,
    "descripcion":"HALLAZGO DE FRECUENCIA DEL PULSO"
  },
  {
    "codigo":39003006,
    "descripcion":"DELIRIO CAUSADO POR SUSTANCIA PSICOACTIVA"
  },
  {
    "codigo":235611008,
    "descripcion":"ÚLCERA VIRAL DE ESÓFAGO"
  },
  {
    "codigo":299312001,
    "descripcion":"SIGNO NOMINATIVO DE CADERA"
  },
  {
    "codigo":1251419009,
    "descripcion":"FOTOONICÓLISIS CAUSADA POR FÁRMACO"
  },
  {
    "codigo":233776003,
    "descripcion":"TRASTORNO TRAQUEOBRONQUIAL"
  },
  {
    "codigo":364848004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA DOBLAR LAS ESQUINAS CORRIENDO"
  },
  {
    "codigo":725296006,
    "descripcion":"MUCOLIPIDOSIS TIPO IV"
  },
  {
    "codigo":10966601000119100,
    "descripcion":"HERIDA PUNZANTE DE PIERNA DERECHA"
  },
  {
    "codigo":363013003,
    "descripcion":"COMPLICACIÓN DE PROCEDIMIENTO DE INTRODUCCIÓN"
  },
  {
    "codigo":231941003,
    "descripcion":"HERIDA NO PERFORANTE DE CÓRNEA"
  },
  {
    "codigo":788997004,
    "descripcion":"TRAQUEOBRONQUITIS OBSTRUCTIVA POR ASPERGILLUS"
  },
  {
    "codigo":723461007,
    "descripcion":"SÍNDROME DE ANOMALÍA FACIODIGITAL CON LA SECUENCIA DE PIERRE ROBIN"
  },
  {
    "codigo":1080751000119108,
    "descripcion":"LIPOSARCOMA PRIMARIO DE PARTES BLANDAS DE HOMBRO DERECHO"
  },
  {
    "codigo":295642000,
    "descripcion":"SOBREDOSIS INTENCIONAL DE MUSTINA"
  },
  {
    "codigo":428549008,
    "descripcion":"ANOMALÍA SECUNDARIA DE ST-T EN EL ELECTROCARDIOGRAMA"
  },
  {
    "codigo":66266003,
    "descripcion":"RAQUITISMO FOSFOPÉNICO"
  },
  {
    "codigo":721626003,
    "descripcion":"NEOPLASIA NEUROENDOCRINA MALIGNA PRIMARIA DE ESÓFAGO"
  },
  {
    "codigo":1149445008,
    "descripcion":"PERIODONTITIS LOCALIZADA ESTADIO 3 GRADO C SEGÚN LA CLASIFICACIÓN DE LAS ENFERMEDADES Y ALTERACIONES PERIODONTALES Y PERIIMPLANTARIAS DE 2017 DE LA ACADEMIA ESTADOUNIDENSE DE PERIODONTOLOGÍA Y LA FEDERACIÓN EUROPEA DE PERIODONTOLOGÍA"
  },
  {
    "codigo":262874007,
    "descripcion":"PERFORACIÓN TARDÍA DE COLON"
  },
  {
    "codigo":457647001,
    "descripcion":"TROMBOSIS DE VÁLVULA PULMONAR"
  },
  {
    "codigo":717956001,
    "descripcion":"CÁLCULO DE SEGMENTOS INTESTINALES DESPUÉS DE LA DERIVACIÓN URINARIA"
  },
  {
    "codigo":95364002,
    "descripcion":"ALTERACIÓN EN EL SITIO DE APLICACIÓN"
  },
  {
    "codigo":195503009,
    "descripcion":"RUPTURA DE VASO LINFÁTICO"
  },
  {
    "codigo":15717961000119106,
    "descripcion":"OSTEOFITO BILATERAL DE CRESTAS ILÍACAS"
  },
  {
    "codigo":160900005,
    "descripcion":"DESEMPLEO CRÓNICO"
  },
  {
    "codigo":128132009,
    "descripcion":"TRASTORNO DEL ANTEBRAZO"
  },
  {
    "codigo":191833002,
    "descripcion":"DEPENDENCIA DE LA COCAÍNA EN REMISIÓN"
  },
  {
    "codigo":1142105006,
    "descripcion":"TAQUICARDIA POR REENTRADA EN EL NÓDULO AURICULOVENTRICULAR TÍPICA"
  },
  {
    "codigo":11785801000119108,
    "descripcion":"ABRASIÓN DE PIEL DE LA MANO IZQUIERDA"
  },
  {
    "codigo":26158002,
    "descripcion":"INERCIA UTERINA"
  },
  {
    "codigo":124462004,
    "descripcion":"DEFICIENCIA DE ALFA - GLUCOSIDASA"
  },
  {
    "codigo":286467000,
    "descripcion":"PICA LOS ALIMENTOS"
  },
  {
    "codigo":253699002,
    "descripcion":"AISLAMIENTO DE ARTERIA CARÓTIDA PRIMITIVA"
  },
  {
    "codigo":89859004,
    "descripcion":"DISPLASIA FIBROSA MONOSTÓTICA"
  },
  {
    "codigo":450307004,
    "descripcion":"ARTERIA COLATERAL MAYOR QUE DERIVA EL FLUJO SISTÉMICO HACIA LA CIRCULACIÓN PULMONAR QUE IRRIGA TODO EL PULMÓN DERECHO"
  },
  {
    "codigo":55256001,
    "descripcion":"INFESTACIÓN CAUSADA POR DIPTERA"
  },
  {
    "codigo":448472004,
    "descripcion":"ANOMALÍA CONGÉNITA DE TRONCO PULMONAR"
  },
  {
    "codigo":219096004,
    "descripcion":"REACCIÓN ADVERSA A VACUNA ANTISARAMPIONOSA"
  },
  {
    "codigo":1169368008,
    "descripcion":"TRIYODOTIRONINA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":284632009,
    "descripcion":"TIRARLE EL PELO A OTRA PERSONA"
  },
  {
    "codigo":1003693002,
    "descripcion":"MIGRACIÓN TRANSPERITONEAL DE ÓVULO"
  },
  {
    "codigo":250029005,
    "descripcion":"MARCHA DE ATAXIA SENSITIVA"
  },
  {
    "codigo":315565005,
    "descripcion":"NACIDO EN ZIMBAWE"
  },
  {
    "codigo":282797009,
    "descripcion":"LESIÓN DE NERVIO PARASIMPÁTICO SACRO"
  },
  {
    "codigo":117122003,
    "descripcion":"CALIDAD DEL SOPLO CARDÍACO, ZUMBANTE"
  },
  {
    "codigo":248194004,
    "descripcion":"CARA ARRUGADA"
  },
  {
    "codigo":280962005,
    "descripcion":"HIPOMELANOSIS INDUCIDA POR AGENTES QUÍMICOS"
  },
  {
    "codigo":1231234008,
    "descripcion":"MUCOCELE DE ÓRBITA"
  },
  {
    "codigo":18818009,
    "descripcion":"DEPRESIÓN MAYOR RECURRENTE MODERADA"
  },
  {
    "codigo":47916000,
    "descripcion":"TRASTORNO DEL DESARROLLO DEL CÁLCULO"
  },
  {
    "codigo":408364003,
    "descripcion":"EL PACIENTE NO COMPRENDE POR QUÉ DEBE TOMAR TODA LA MEDICACIÓN"
  },
  {
    "codigo":703276005,
    "descripcion":"INSUFICIENCIA CARDÍACA CON FRACCIÓN DE EYECCIÓN DISMINUIDA DEBIDA A VALVULOPATÍA"
  },
  {
    "codigo":16048151000119100,
    "descripcion":"ARTRITIS INFECCIOSA DE AMBOS TOBILLOS CAUSADA POR VIRUS"
  },
  {
    "codigo":1260332008,
    "descripcion":"DISTONÍA DEBIDA A ANOXIA CEREBRAL"
  },
  {
    "codigo":78849002,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE EXTREMO DISTAL DE PERONÉ"
  },
  {
    "codigo":1083261000119107,
    "descripcion":"OTITIS MEDIA ALÉRGICA CRÓNICA BILATERAL"
  },
  {
    "codigo":766977007,
    "descripcion":"NEUROPATÍA AXÓNICA SEVERA DE COMIENZO TEMPRANO DEBIDA A DEFICIENCIA DE MITOFUSINA 2"
  },
  {
    "codigo":13313007,
    "descripcion":"TRASTORNO BIPOLAR LEVE"
  },
  {
    "codigo":111617009,
    "descripcion":"LESIÓN TRAUMÁTICA INTRACRANEAL CONCOMITANTE CON FRACTURA DE CRÁNEO EXPUESTA Y DEBIDA A ELLA"
  },
  {
    "codigo":1356801009,
    "descripcion":"DAÑO DE ARTICULACIÓN DE PARED PÉLVICA DURANTE PARTO VAGINAL"
  },
  {
    "codigo":765142003,
    "descripcion":"SÍNDROME DE MICRODUPLICACIÓN 16P11.2 PROXIMAL"
  },
  {
    "codigo":240854000,
    "descripcion":"LARVA MIGRANTE CUTÁNEA ANQUILOSTÓMICA"
  },
  {
    "codigo":109782008,
    "descripcion":"CELULITIS DEL ESPACIO BUCAL DE LA BOCA"
  },
  {
    "codigo":404694008,
    "descripcion":"ANISOCORIA FARMACOLÓGICA"
  },
  {
    "codigo":239019002,
    "descripcion":"DISPLASIA ODONTO-ONIQUIAL CON ALOPECIA"
  },
  {
    "codigo":402859003,
    "descripcion":"VASCULITIS NECROSANTE DE ETIOLOGÍA NO DETERMINADA"
  },
  {
    "codigo":271787007,
    "descripcion":"COLAPSO"
  },
  {
    "codigo":827008005,
    "descripcion":"VESÍCULA DE PIEL"
  },
  {
    "codigo":106112009,
    "descripcion":"HALLAZGO FETAL"
  },
  {
    "codigo":268117002,
    "descripcion":"CUERPO EXTRAÑO DEJADO EN MANO"
  },
  {
    "codigo":431957001,
    "descripcion":"ATENDIDO EN CONSULTORIO ESPECIALIZADO EN SALUD MENTAL"
  },
  {
    "codigo":202581004,
    "descripcion":"OSTEOCONDROMATOSIS SINOVIAL DE ARTICULACIÓN METACARPOFALÁNGICA"
  },
  {
    "codigo":169813005,
    "descripcion":"NACIMIENTO EN EL HOGAR"
  },
  {
    "codigo":300885006,
    "descripcion":"TUMEFACCIÓN MAMARIA"
  },
  {
    "codigo":366421007,
    "descripcion":"AMPLITUD DEL MOVIMIENTO ACTIVO DE ROTACIÓN HACIA LA DERECHA DE LA COLUMNA DORSAL - HALLAZGO"
  },
  {
    "codigo":5973007,
    "descripcion":"POSICIÓN MENTOILÍACA DERECHA POSTERIOR"
  },
  {
    "codigo":299050002,
    "descripcion":"PRUEBA DE FINKELSTEIN NEGATIVA"
  },
  {
    "codigo":725034002,
    "descripcion":"SÍNDROME PLAQUETARIO FAMILIAR CON PREDISPOSICIÓN A LA LEUCEMIA MIELÓGENA AGUDA"
  },
  {
    "codigo":2303007,
    "descripcion":"HERNIA INGUINAL CON GANGRENA"
  },
  {
    "codigo":262612001,
    "descripcion":"CUERPO EXTRAÑO EN RIÑÓN"
  },
  {
    "codigo":229844004,
    "descripcion":"DEFORMIDAD DE PIE"
  },
  {
    "codigo":721364005,
    "descripcion":"LESIÓN COMPLETA DE MÉDULA ESPINAL AL NIVEL DEL SEGUNDO SEGMENTO CERVICAL"
  },
  {
    "codigo":295380005,
    "descripcion":"SOBREDOSIS DE CARBENOXOLONA"
  },
  {
    "codigo":195241001,
    "descripcion":"SECUELAS DE HEMORRAGIA INTRACEREBRAL"
  },
  {
    "codigo":64169002,
    "descripcion":"CHOQUE TRAUMÁTICO"
  },
  {
    "codigo":129705003,
    "descripcion":"CON MAYOR RIESGO DE CRECIMIENTO DESPROPORCIONADO"
  },
  {
    "codigo":31401003,
    "descripcion":"ÚTERO BICORNE"
  },
  {
    "codigo":162473008,
    "descripcion":"FACTORES QUE EMPEORAN EL SÍNTOMA"
  },
  {
    "codigo":1145513008,
    "descripcion":"APLASIA DE FALANGE MEDIA DE DEDO MEÑIQUE"
  },
  {
    "codigo":293545008,
    "descripcion":"REACCIÓN ADVERSA AL TRINITRATO DE GLICERILO PARENTERAL"
  },
  {
    "codigo":95102006,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE PARTES BLANDAS DEL TÓRAX"
  },
  {
    "codigo":160638007,
    "descripcion":"EJERCICIO AERÓBICO, DOS VECES POR SEMANA"
  },
  {
    "codigo":62334008,
    "descripcion":"MARCHA ATETÓSICA"
  },
  {
    "codigo":783230008,
    "descripcion":"AGENESIA DE CUERPO UTERINO"
  },
  {
    "codigo":191571002,
    "descripcion":"EXACERBACIÓN AGUDA DE ESQUIZOFRENIA ESQUIZOAFECTIVA SUBCRÓNICA"
  },
  {
    "codigo":289875004,
    "descripcion":"PERINEO RÍGIDO"
  },
  {
    "codigo":1141843005,
    "descripcion":"SIGNO DE COLA DURAL"
  },
  {
    "codigo":27731006,
    "descripcion":"HECES BLANDAS"
  },
  {
    "codigo":93267005,
    "descripcion":"HIPOPLASIA CONGÉNITA DE HUESO INTERPARIETAL"
  },
  {
    "codigo":715859008,
    "descripcion":"PERIODONTITIS AGUDA MODERADA LOCALIZADA"
  },
  {
    "codigo":224339004,
    "descripcion":"PROCESAMIENTO PENDIENTE"
  },
  {
    "codigo":15968741000119100,
    "descripcion":"DOLOR LUMBAR CONCOMITANTE CON CIÁTICA BILATERAL Y DEBIDO A ELLA"
  },
  {
    "codigo":124200007,
    "descripcion":"DEFICIENCIA DE CATECOL OXIDASA"
  },
  {
    "codigo":25896009,
    "descripcion":"ATRESIA DEL ÍLEON"
  },
  {
    "codigo":1269245002,
    "descripcion":"TROMBOSIS DE AMBAS ARTERIAS CEREBRALES POSTERIORES"
  },
  {
    "codigo":89597008,
    "descripcion":"GLUCOGENOSIS, TIPO VII"
  },
  {
    "codigo":1300178001,
    "descripcion":"ENFERMEDAD INFECCIOSA BACTERIANA INVASIVA"
  },
  {
    "codigo":253437008,
    "descripcion":"ANOMALÍA DE VALVA DE VÁLVULA AURICULOVENTRICULAR COMÚN"
  },
  {
    "codigo":186066002,
    "descripcion":"SIN DESIGNACIÓN DE APODERADO"
  },
  {
    "codigo":16077131000119109,
    "descripcion":"DEPENDENCIA DE TABACO CAUSADA POR TABACO MASTICABLE EN REMISIÓN"
  },
  {
    "codigo":249767004,
    "descripcion":"DEDO DE LA MANO AHUSADO"
  },
  {
    "codigo":1003431005,
    "descripcion":"DISOSTOSIS MANDIBULOACRAL CONCOMITANTE CON LIPODISTROFIA TIPO A"
  },
  {
    "codigo":20391007,
    "descripcion":"QUISTE AMNIÓTICO"
  },
  {
    "codigo":247932000,
    "descripcion":"MOVIMIENTOS TORSIONALES COMPLEJOS REPETITIVOS DE LAS MANOS CERCA DE LOS OJOS"
  },
  {
    "codigo":184231009,
    "descripcion":"TOTALIDAD DE LAS NOTAS EN LA COMPUTADORA"
  },
  {
    "codigo":1260070000,
    "descripcion":"CARCINOMA BRONQUIOLOALVEOLAR NO MUCINOSO DE PULMÓN"
  },
  {
    "codigo":47654002,
    "descripcion":"UMBRAL CONVULSIVO AUMENTADO"
  },
  {
    "codigo":80422002,
    "descripcion":"CONDUCTA DESTRUCTIVA"
  },
  {
    "codigo":703014005,
    "descripcion":"PSEUDOMONAS FLUORESCENS O PSEUDOMONAS PUTIDA O PSEUDOMONAS MENDOCINA"
  },
  {
    "codigo":766715000,
    "descripcion":"MIOPATÍA METABÓLICA POR DEFECTO EN EL TRANSPORTADOR DE LACTATO"
  },
  {
    "codigo":209659001,
    "descripcion":"SECCIÓN EXPUESTA DE LIGAMENTO CORACOCLAVICULAR"
  },
  {
    "codigo":735782008,
    "descripcion":"RUPTURA TRAUMÁTICA DE SÍNFISIS DEL PUBIS SIN ALTERACIÓN DEL ANILLO PÉLVICO"
  },
  {
    "codigo":14886009,
    "descripcion":"CORAZÓN ABDOMINAL"
  },
  {
    "codigo":733947000,
    "descripcion":"CARIES DENTAL ACTIVA SECUNDARIA QUE SE EXTIENDE HASTA EL TERCIO MEDIO DE LA DENTINA"
  },
  {
    "codigo":109520000,
    "descripcion":"HIPERPLASIA ALVEOLAR CONGÉNITA DE LA MANDÍBULA"
  },
  {
    "codigo":11216008,
    "descripcion":"REACCIÓN DE FERNÁNDEZ A LA LEPROMINA"
  },
  {
    "codigo":238757003,
    "descripcion":"HEMATOHIDROSIS"
  },
  {
    "codigo":271525004,
    "descripcion":"CARCINOMA IN SITU DE HÍGADO Y SISTEMA BILIAR"
  },
  {
    "codigo":402597007,
    "descripcion":"ALERGIA A RESINA DE ÁRBOL"
  },
  {
    "codigo":1287333007,
    "descripcion":"CARCINOMA DE CÉLULAS DE MERKEL PRIMARIO DE PIEL DE MIEMBRO INFERIOR"
  },
  {
    "codigo":1187194006,
    "descripcion":"ENTEROPATÍA CRÓNICA ASOCIADA A GEN SLCO2A1"
  },
  {
    "codigo":269690006,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR COMBUSTIBLES Y LIMPIADORES DERIVADOS DEL PETRÓLEO"
  },
  {
    "codigo":235087000,
    "descripcion":"MALA OCLUSIÓN, CLASE II DE ANGLE, DIVISIÓN 2"
  },
  {
    "codigo":204154009,
    "descripcion":"DISGENESIA IRIDOTRABECULAR"
  },
  {
    "codigo":456973081000119104,
    "descripcion":"CARCINOMA PAPILAR IN SITU DE MAMA DERECHA"
  },
  {
    "codigo":300623004,
    "descripcion":"UTILIZA EL TRANSPORTE PÚBLICO"
  },
  {
    "codigo":202319005,
    "descripcion":"ANQUILOSIS DE LA ARTICULACIÓN SUBASTRAGALINA"
  },
  {
    "codigo":726607007,
    "descripcion":"PARAPLEJÍA ESPÁSTICA AUTOSÓMICA RECESIVA TIPO 26"
  },
  {
    "codigo":366159008,
    "descripcion":"HALLAZGO DE MEDICIÓN VENOSA"
  },
  {
    "codigo":298788001,
    "descripcion":"AMPLITUD DE EXTENSIÓN ACTIVA DE HOMBRO AUMENTADA"
  },
  {
    "codigo":15670041000119105,
    "descripcion":"LUXACIÓN CONGÉNITA DE CABEZA DE AMBOS RADIOS"
  },
  {
    "codigo":724772009,
    "descripcion":"TEMBLOR DEBIDO A ENFERMEDAD DEL SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":722937002,
    "descripcion":"ASFIXIA NEONATAL CON ACIDEMIA METABÓLICA DE CORDÓN"
  },
  {
    "codigo":788473003,
    "descripcion":"TRASTORNO REPETITIVO DEL MOVIMIENTO DE LA MANO DERECHA"
  },
  {
    "codigo":1088281000119107,
    "descripcion":"COLESTEATOMA DEL ÁTICO EPITIMPÁNICO DEL OÍDO MEDIO IZQUIERDO"
  },
  {
    "codigo":2041006,
    "descripcion":"GIGANTISMO EUNUCOIDE"
  },
  {
    "codigo":198649006,
    "descripcion":"SHOCK DEBIDO A ABORTO ESPONTÁNEO INCOMPLETO"
  },
  {
    "codigo":1148921007,
    "descripcion":"GLOMERULOPATÍA DEBIDA A RASGO DREPANOCÍTICO"
  },
  {
    "codigo":721102001,
    "descripcion":"OSTEOMIELITIS CAUSADA POR PASTEURELLA MULTOCIDA"
  },
  {
    "codigo":426190008,
    "descripcion":"QUISTE MAXILAR"
  },
  {
    "codigo":162211001,
    "descripcion":"CEFALEA DE ETIOLOGÍA VIRAL"
  },
  {
    "codigo":1343694009,
    "descripcion":"NEOPLASIA MALIGNA DE EPIGLOTIS"
  },
  {
    "codigo":719267003,
    "descripcion":"LEUCOENCEFALOPATÍA CAVITANTE PROGRESIVA"
  },
  {
    "codigo":293283008,
    "descripcion":"REACCIÓN ADVERSA A LEUPRORELINA"
  },
  {
    "codigo":291448001,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR PRIMAQUINA"
  },
  {
    "codigo":94840001,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL PRIMER HUESO CUNEIFORME DEL TARSO"
  },
  {
    "codigo":29304003,
    "descripcion":"INFECCIÓN CAUSADA POR STACHYLEPIS"
  },
  {
    "codigo":62072007,
    "descripcion":"EFECTO TÓXICO DE HUMOS METÁLICOS"
  },
  {
    "codigo":289613001,
    "descripcion":"HALLAZGO RELACIONADO CON LA FORMA DEL HIMEN"
  },
  {
    "codigo":225912009,
    "descripcion":"INCAPAZ DE SOPORTAR EL DOLOR"
  },
  {
    "codigo":1010509008,
    "descripcion":"ESCLEROSIS DE EPÍFISIS DE FALANGE DISTAL DE MANO CON RADIOPACIDAD AUMENTADA"
  },
  {
    "codigo":93005008,
    "descripcion":"ANOMALÍA CONGÉNITA DE HUESO HIOIDES"
  },
  {
    "codigo":386082004,
    "descripcion":"CUERPO EXTRAÑO EN LA CABEZA"
  },
  {
    "codigo":1303586006,
    "descripcion":"SÍNDROME DE RETRASO DEL NEURODESARROLLO, HIPOTONÍA, ATAXIA CEREBELOSA Y DEFECTOS DE LA CONDUCCIÓN CARDIACA"
  },
  {
    "codigo":123938007,
    "descripcion":"INTOXICACIÓN POR CONBRETACEAE"
  },
  {
    "codigo":449783002,
    "descripcion":"ZÓSTER SIN LESIONES CUTÁNEAS"
  },
  {
    "codigo":253175003,
    "descripcion":"APLASIA FAMILIAR DE VERMIS"
  },
  {
    "codigo":285943005,
    "descripcion":"OPERA LOS CONTROLES DE LA DUCHA"
  },
  {
    "codigo":710092003,
    "descripcion":"CONDICIÓN IDEAL DE DENTICIÓN COMPLETA"
  },
  {
    "codigo":218572006,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR ANTAGONISTAS DE ANTICOAGULANTES"
  },
  {
    "codigo":185804006,
    "descripcion":"INCUMPLIMIENTO CON EL CONTROL DE SALUD DE LA MUJER"
  },
  {
    "codigo":87500009,
    "descripcion":"LINFADENOPATÍA HILIAR"
  },
  {
    "codigo":216737001,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR FOSFURO DE CINC"
  },
  {
    "codigo":446113003,
    "descripcion":"GRANULOMA DE GLÚTEO"
  },
  {
    "codigo":11986151000119101,
    "descripcion":"QUEMADURA EPIDÉRMICA DE DORSO DE MANO DERECHA"
  },
  {
    "codigo":870262000,
    "descripcion":"TRASTORNO GENERALIZADO DEL DESARROLLO CON ALTERACIÓN DEL DESARROLLO INTELECTUAL SIN PÉRDIDA DE HABILIDADES ADQUIRIDAS PREVIAMENTE"
  },
  {
    "codigo":85665009,
    "descripcion":"TUMOR ENCAPSULADO"
  },
  {
    "codigo":52897009,
    "descripcion":"ONICOGRIFOSIS"
  },
  {
    "codigo":1090791000119102,
    "descripcion":"OTITIS MEDIA AGUDA SUPURATIVA RECIDIVANTE DEL OÍDO DERECHO CON RUPTURA ESPONTÁNEA DE LA MEMBRANA TIMPÁNICA"
  },
  {
    "codigo":247670003,
    "descripcion":"DELIRIO DE MISIÓN ESPECIAL"
  },
  {
    "codigo":16459000,
    "descripcion":"QUEILOSIS"
  },
  {
    "codigo":1359947001,
    "descripcion":"BACTERIAS EN EMPALIZADA"
  },
  {
    "codigo":51062009,
    "descripcion":"ESTENOSIS CONGÉNITA DEL PÍLORO"
  },
  {
    "codigo":60168000,
    "descripcion":"OSTEOMIELITIS"
  },
  {
    "codigo":409675001,
    "descripcion":"TIEMPO DE TROMBOPLASTINA PARCIAL AUMENTADO"
  },
  {
    "codigo":1228875006,
    "descripcion":"HIPERGLUCAGONEMIA ASOCIADA A GEN GCGR"
  },
  {
    "codigo":278603006,
    "descripcion":"CORONA DENTAL FLOJA"
  },
  {
    "codigo":16000231000119105,
    "descripcion":"SÍNDROME DEL IRIS FLÁCIDO INTRAOPERATORIO DE OJO DERECHO"
  },
  {
    "codigo":309536001,
    "descripcion":"ENTUMECIMIENTO DE DEDO DE LA MANO"
  },
  {
    "codigo":768288001,
    "descripcion":"HEPATITIS CRÓNICA CAUSADA POR VIRUS HEPATITIS C GENOTIPO 1B"
  },
  {
    "codigo":1259808003,
    "descripcion":"NEOPLASIA SÓLIDA PRIMARIA CON FUSIÓN DE GEN DEL RECEPTOR DE TIROSINA CINASA NEUROTRÓFICO"
  },
  {
    "codigo":735520000,
    "descripcion":"INFECCIÓN DISEMINADA CAUSADA POR BORRELIA"
  },
  {
    "codigo":10675431000119106,
    "descripcion":"ASMA ALÉRGICA PERSISTENTE SEVERA"
  },
  {
    "codigo":440608005,
    "descripcion":"STAPHYLOCOCCUS AUREUS RESISTENTE A LA METICILINA AISLADO EN CULTIVO"
  },
  {
    "codigo":473376007,
    "descripcion":"RUPTURA DE VALVA SEMILUNAR DE VÁLVULA AURICULOVENTRICULAR DERECHA (MORFOLÓGICAMENTE NO TRICÚSPIDE)"
  },
  {
    "codigo":406005000,
    "descripcion":"HAPLOTIPO CDE"
  },
  {
    "codigo":438773007,
    "descripcion":"EMBOLIA PULMONAR RECURRENTE"
  },
  {
    "codigo":274933008,
    "descripcion":"LESIÓN CAUSADA POR ARMAS MILITARES"
  },
  {
    "codigo":209397007,
    "descripcion":"FRACTURA-LUXACIÓN EXPUESTA DE ARTICULACIÓN ESTERNOCLAVICULAR, POSTERIOR"
  },
  {
    "codigo":109258002,
    "descripcion":"MUCOSITIS POR CONTACTO"
  },
  {
    "codigo":1290741009,
    "descripcion":"ARTRITIS REACTIVA DE ARTICULACIÓN DE TOBILLO DEBIDA A ENFERMEDAD INFECCIOSA TRANSMITIDA POR VÍA SEXUAL Y POSTERIOR A ELLA"
  },
  {
    "codigo":76490001,
    "descripcion":"OTOMICOSIS EXTERNA CAUSADA POR FUSARIUM"
  },
  {
    "codigo":305866006,
    "descripcion":"ATENDIDO POR SERVICIO DE PSIQUIATRÍA INFANTOJUVENIL"
  },
  {
    "codigo":10954006,
    "descripcion":"ACNÉ TROPICAL"
  },
  {
    "codigo":402335001,
    "descripcion":"PSORIASIS FAMILIAR"
  },
  {
    "codigo":404170009,
    "descripcion":"MASTOCITOSIS CUTÁNEA DIFUSA AMPOLLOSA"
  },
  {
    "codigo":1155999007,
    "descripcion":"SOBREDOSIS DE MACRÓLIDO ANTIBACTERIANO"
  },
  {
    "codigo":1186932001,
    "descripcion":"FILTRACIÓN POSTOPERATORIA DE LCR POR NARIZ"
  },
  {
    "codigo":40052002,
    "descripcion":"ANOMALÍA CONGÉNITA DEL CUELLO"
  },
  {
    "codigo":369567009,
    "descripcion":"TUMOR MALIGNO QUE COMPROMETE EL OVARIO DERECHO POR PROPAGACIÓN DIRECTA PROVENIENTE DE LA VAGINA"
  },
  {
    "codigo":72820004,
    "descripcion":"PARKINSONISMO INDUCIDO POR NEUROLÉPTICO"
  },
  {
    "codigo":1119561000,
    "descripcion":"VÉRTICE DE NARIZ DE FORMA TRIANGULAR"
  },
  {
    "codigo":726345000,
    "descripcion":"TRISOMÍA PARCIAL DE CROMOSOMA 6"
  },
  {
    "codigo":236660009,
    "descripcion":"INCONTINENCIA URINARIA AL REÍR"
  },
  {
    "codigo":365897003,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD DE RECORDAR EL NOMBRE DEL MONARCA REINANTE"
  },
  {
    "codigo":38217004,
    "descripcion":"CELULITIS DEL BRAZO"
  },
  {
    "codigo":398665005,
    "descripcion":"SÍNCOPE VASOVAGAL"
  },
  {
    "codigo":300361008,
    "descripcion":"VÓMITO CON CONTENIDO DE SANGRE"
  },
  {
    "codigo":298526002,
    "descripcion":"AMPLITUD DE EXTENSIÓN PASIVA DE LA COLUMNA VERTEBRAL DORSAL, AUMENTADA"
  },
  {
    "codigo":11795841000119109,
    "descripcion":"ABRASIÓN DE PIEL DE GENITALES MASCULINOS"
  },
  {
    "codigo":722675000,
    "descripcion":"SÍNDROME LARINGO-ONICO-CUTÁNEO"
  },
  {
    "codigo":67315001,
    "descripcion":"ARTROSIS DE REGIÓN DE HOMBRO"
  },
  {
    "codigo":1148659002,
    "descripcion":"ELECTRORRETINOGRAMA DE FLASH BRILLANTE ÚNICO CON ADAPTACIÓN A LA LUZ ANORMAL"
  },
  {
    "codigo":296691000,
    "descripcion":"SOBREDOSIS DE LATAMOXEF"
  },
  {
    "codigo":1779005,
    "descripcion":"SÍNDROME DE MOHR"
  },
  {
    "codigo":1279731008,
    "descripcion":"ROTURA DE RETINA DE OJO DERECHO"
  },
  {
    "codigo":460531008,
    "descripcion":"ORIGEN ANÓMALO DE ARTERIA CORONARIA DERECHA EN ARTERIA CORONARIA CIRCUNFLEJA IZQUIERDA"
  },
  {
    "codigo":425928002,
    "descripcion":"CUIDADO POR FAMILIAR"
  },
  {
    "codigo":360392003,
    "descripcion":"ESTRECHEZ ADQUIRIDA DE CONDUCTO DEFERENTE"
  },
  {
    "codigo":293021001,
    "descripcion":"REACCIÓN ADVERSA A LA FOSFOMICINA"
  },
  {
    "codigo":30877004,
    "descripcion":"ATROFIA DE CRESTA ALVEOLAR DE MAXILAR INFERIOR DESDENTADO"
  },
  {
    "codigo":127346000,
    "descripcion":"TRASTORNO NEUROLÓGICO QUE AFECTA LOS MOVIMIENTOS OCULARES"
  },
  {
    "codigo":424093009,
    "descripcion":"ANIMAL INCONTROLADO EN EL AMBIENTE"
  },
  {
    "codigo":260253008,
    "descripcion":"J4"
  },
  {
    "codigo":225650001,
    "descripcion":"SOMETIDO EMOCIONALMENTE"
  },
  {
    "codigo":300571000119109,
    "descripcion":"TRASTORNO DE TENDÓN DE MUSLO IZQUIERDO"
  },
  {
    "codigo":94578008,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE PIEL DE MUÑECA"
  },
  {
    "codigo":289351008,
    "descripcion":"PELOTEO CEFÁLICO FETAL EN EL FONDO UTERINO"
  },
  {
    "codigo":189212001,
    "descripcion":"CARCINOMA IN SITU DE GLÁNDULA SALIVAL"
  },
  {
    "codigo":1336092002,
    "descripcion":"DEFICIENCIA HEREDITARIA MODERADA DE FACTOR IX"
  },
  {
    "codigo":92743009,
    "descripcion":"CARCINOMA IN SITU DE PIEL DE MUSLO"
  },
  {
    "codigo":449587004,
    "descripcion":"AURÍCULA IZQUIERDA DIVIDIDA CON DESEMBOCADURA DE TODAS LAS VENAS PULMONARES EN LA CÁMARA PROXIMAL Y LUEGO EN LA AURÍCULA IZQUIERDA CON COMUNICACIÓN ADICIONAL EXTRACARDÍACA CON LA CÁMARA VENOSA PULMONAR"
  },
  {
    "codigo":449521000,
    "descripcion":"CONEXIÓN VENOSA PULMONAR ANÓMALA DE TIPO MIXTO CON DOS CONFLUENCIAS VENOSAS PULMONARES"
  },
  {
    "codigo":254748009,
    "descripcion":"FIBROSARCOMA CUTÁNEO"
  },
  {
    "codigo":416753001,
    "descripcion":"NEOPLASIA DE CONDUCTO NASOLAGRIMAL"
  },
  {
    "codigo":220145006,
    "descripcion":"CELULITIS DIFUSA DE LA CARA"
  },
  {
    "codigo":1332422001,
    "descripcion":"HISTIOCITOSIS DE CÉLULAS DE LANGERHANS DISEMINADA DE GANGLIOS LINFÁTICOS DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":1268721009,
    "descripcion":"SEMINOMA PRIMARIO MALIGNO DE TESTÍCULO"
  },
  {
    "codigo":283846004,
    "descripcion":"LESIÓN POR DESOLLAMIENTO DE ABDOMEN"
  },
  {
    "codigo":54470008,
    "descripcion":"DEFICIENCIA DE 3 BETA - HIDROXIESTEROIDE DESHIDROGENASA"
  },
  {
    "codigo":216475000,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ACETANILIDA"
  },
  {
    "codigo":249243006,
    "descripcion":"HALLAZGO RELACIONADO CON EL EPIDÍDIMO"
  },
  {
    "codigo":445851009,
    "descripcion":"LACERACIÓN DE REGIÓN HIPOGÁSTRICA"
  },
  {
    "codigo":312944002,
    "descripcion":"ATROFIA ÓPTICA COMPRESIVA"
  },
  {
    "codigo":247408001,
    "descripcion":"UMBRAL DE DOLOR, ALTO"
  },
  {
    "codigo":1197680006,
    "descripcion":"FÍSTULA DE COLON SIGMOIDE"
  },
  {
    "codigo":116336009,
    "descripcion":"HALLAZGO RELACIONADO CON LA ACTIVIDAD DE COMER Y\/O BEBER"
  },
  {
    "codigo":1163077002,
    "descripcion":"NECROSIS TUBULAR RENAL DIFTÉRICA"
  },
  {
    "codigo":48965007,
    "descripcion":"CLIC SISTÓLICO SIMPLE NO EYECTIVO"
  },
  {
    "codigo":442181008,
    "descripcion":"MONOPLEJÍA DE MIEMBRO SUPERIOR NO DOMINANTE COMO EFECTO TARDÍO DE ACCIDENTE CEREBROVASCULAR"
  },
  {
    "codigo":1259546003,
    "descripcion":"CARCINOMA BASOCELULAR PRIMARIO - INFILTRATIVO"
  },
  {
    "codigo":440346008,
    "descripcion":"ÚLCERA DE MIEMBRO POR INSUFICIENCIA VENOSA CRÓNICA"
  },
  {
    "codigo":438511000,
    "descripcion":"ESCLEROSIS MÚLTIPLE BENIGNA"
  },
  {
    "codigo":274671002,
    "descripcion":"DOLOR PÉLVICO Y PERINEAL"
  },
  {
    "codigo":733423003,
    "descripcion":"INSEGURIDAD ALIMENTARIA"
  },
  {
    "codigo":405743003,
    "descripcion":"LUGAR FÍSICO EN EL QUE SE ADMINISTRA ASPIRINA AL PACIENTE"
  },
  {
    "codigo":471279005,
    "descripcion":"COMPONENTE AURICULAR RECURRENTE DE DEFECTO DE TABIQUE AURICULOVENTRICULAR DESPUÉS DE PROCEDIMIENTO QUIRÚRGICO CARDIOVASCULAR PREVIO"
  },
  {
    "codigo":241903008,
    "descripcion":"EFECTO TÓXICO CAUSADO POR CIANOACRILATO"
  },
  {
    "codigo":372975009,
    "descripcion":"INFECCIÓN CAUSADA POR ASPERGILLUS CAESIELLUS"
  },
  {
    "codigo":698820005,
    "descripcion":"INFECCIÓN DE LUGAR DE PUNCIÓN POSTERIOR A PROCEDIMIENTO"
  },
  {
    "codigo":240068006,
    "descripcion":"DISTROFIA MUSCULAR AUTOSÓMICA DOMINANTE CON GEN LOCALIZADO EN 5Q31"
  },
  {
    "codigo":403908007,
    "descripcion":"QUERATOACANTOMA SUBUNGUEAL"
  },
  {
    "codigo":371140008,
    "descripcion":"GENOTIPO 1A DE ÁCIDO RIBONUCLEICO DE VIRUS DE HEPATITIS C DETECTADO POR REACCIÓN EN CADENA DE LA POLIMERASA"
  },
  {
    "codigo":762521001,
    "descripcion":"EXACERBACIÓN DE ASMA ALÉRGICA"
  },
  {
    "codigo":8857001,
    "descripcion":"ELIPTOCITOSIS HEREDITARIA POR DEFECTO DE ESPECTRINA ALFA"
  },
  {
    "codigo":305604009,
    "descripcion":"BAJO ATENCIÓN DE DIETISTA HOSPITALARIO"
  },
  {
    "codigo":205465004,
    "descripcion":"CONDRODISPLASIA"
  },
  {
    "codigo":860825005,
    "descripcion":"PAQUIMENINGITIS HIPERTRÓFICA DEBIDA A TRASTORNO DE LA FUNCIÓN INMUNITARIA"
  },
  {
    "codigo":172697005,
    "descripcion":"GINGIVITIS ULCEROSA AGUDA"
  },
  {
    "codigo":236398000,
    "descripcion":"GLOMERULONEFRITIS PROLIFERATIVA IDIOPÁTICA"
  },
  {
    "codigo":203630007,
    "descripcion":"CIFOSIS POR RADIACIÓN"
  },
  {
    "codigo":37955001,
    "descripcion":"HEMATOMA INTRACRANEAL TRAUMÁTICO"
  },
  {
    "codigo":234563002,
    "descripcion":"DEFICIENCIA DEL ANTICUERPO ANTIESTAFILOCÓCICO"
  },
  {
    "codigo":301934009,
    "descripcion":"HALLAZGO RELACIONADO CON EL ÁNGULO DE LA CÁMARA ANTERIOR"
  },
  {
    "codigo":365635005,
    "descripcion":"CONTROL DE WARFARINA - HALLAZGO"
  },
  {
    "codigo":5187006,
    "descripcion":"SÍNDROME DEL VIENTRE DE CIRUELA"
  },
  {
    "codigo":1119299008,
    "descripcion":"INSUFICIENCIA DE VÁLVULA MITRAL DEBIDA A ANOMALÍA CONGÉNITA DE APARATO SUBVALVULAR MITRAL"
  },
  {
    "codigo":300099009,
    "descripcion":"ÚLCERA EN PABELLÓN AURICULAR"
  },
  {
    "codigo":726083008,
    "descripcion":"SÍNDROME DE MENINGOCELE SACRO CONGÉNITO CON DEFECTO CARDÍACO CONOTRUNCAL"
  },
  {
    "codigo":167192005,
    "descripcion":"PRUEBAS DE FUNCIÓN GÁSTRICA, NORMALES"
  },
  {
    "codigo":134424008,
    "descripcion":"TRASTORNO DEBIDO A QUEMADURA DE MIEMBRO SUPERIOR Y POSTERIOR A ELLA"
  },
  {
    "codigo":296429001,
    "descripcion":"SOBREDOSIS DE TRIPELENAMINA"
  },
  {
    "codigo":263661007,
    "descripcion":"DISFUNCIÓN DEL FACTOR 5 DEL COMPLEMENTO"
  },
  {
    "codigo":720578000,
    "descripcion":"FILTRACIÓN POR MUÑÓN RECTAL"
  },
  {
    "codigo":32450007,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA VENA ILEOCÓLICA"
  },
  {
    "codigo":292759007,
    "descripcion":"REACCIÓN ADVERSA A LA GLICINA"
  },
  {
    "codigo":94316002,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL GLOMO YUGULAR"
  },
  {
    "codigo":127084003,
    "descripcion":"LINFADENOPATÍA MANDIBULAR"
  },
  {
    "codigo":290924005,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR TRAZODONA"
  },
  {
    "codigo":190785000,
    "descripcion":"HIPOALFALIPOPROTEINEMIA"
  },
  {
    "codigo":92481000,
    "descripcion":"NEOPLASIA BENIGNA DEL VESTÍBULO DE LA BOCA"
  },
  {
    "codigo":289089005,
    "descripcion":"NO COLOCA AL BEBÉ AL PECHO PARA AMAMANTARLO"
  },
  {
    "codigo":256321009,
    "descripcion":"TRASTORNO EN LA TRANSMISIÓN NEUROMUSCULAR"
  },
  {
    "codigo":254486004,
    "descripcion":"NEOPLASIA BENIGNA DE VESTÍBULO NASAL"
  },
  {
    "codigo":305591000119103,
    "descripcion":"COXA MAGNA DE FÉMUR IZQUIERDO"
  },
  {
    "codigo":188950006,
    "descripcion":"NEOPLASIA BENIGNA DE HUESO GRANDE"
  },
  {
    "codigo":1237526007,
    "descripcion":"METÁSTASIS DE CARCINOMA DE HUESO DE COSTILLA"
  },
  {
    "codigo":1268459000,
    "descripcion":"CARCINOMA PRIMARIO DE CORTEZA SUPRARRENAL"
  },
  {
    "codigo":711403001,
    "descripcion":"DEFICIENCIA DE TRANSPORTE DE FOLATO CEREBRAL"
  },
  {
    "codigo":187115002,
    "descripcion":"ESQUISTOSOMIASIS CUTÁNEA"
  },
  {
    "codigo":1137387004,
    "descripcion":"HIPOTONÍA AXIAL DEL LACTANTE"
  },
  {
    "codigo":283584000,
    "descripcion":"HERIDA DE PERDIGÓN EN RODILLA"
  },
  {
    "codigo":449259009,
    "descripcion":"NEOPLASIA MALIGNA DE LIGAMENTO ANCHO DEL ÚTERO"
  },
  {
    "codigo":1332160004,
    "descripcion":"EPILEPSIA HIPERMOTORA RELACIONADA CON EL SUEÑO"
  },
  {
    "codigo":10627511000119106,
    "descripcion":"FORÚNCULO DE PULGAR IZQUIERDO"
  },
  {
    "codigo":16908881000119100,
    "descripcion":"DERMATOFIBROMA DE PIEL DE PÁRPADO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":871573002,
    "descripcion":"REACCIÓN ADVERSA A ACETILCOLINA"
  },
  {
    "codigo":16034231000119107,
    "descripcion":"HIPERTROFIA DE HUESO DE PIE DERECHO"
  },
  {
    "codigo":216213002,
    "descripcion":"LESIÓN POR PROPULSOR A HÉLICE DE AERONAVE, SIN ACCIDENTE DE AERONAVE, VIAJERO EN AERONAVE MILITAR LESIONADO"
  },
  {
    "codigo":52373005,
    "descripcion":"ENTIERRO"
  },
  {
    "codigo":609429008,
    "descripcion":"TRASTORNO FETAL POR ENFERMEDAD EN LA MADRE"
  },
  {
    "codigo":247146001,
    "descripcion":"DEPÓSITO DE PIGMENTO EN LA MÁCULA"
  },
  {
    "codigo":1363093008,
    "descripcion":"ASTILLA EN FLANCO"
  },
  {
    "codigo":707733008,
    "descripcion":"ANOMALÍA DEL DESARROLLO DE CÚSPIDE DENTAL"
  },
  {
    "codigo":1197418004,
    "descripcion":"ENFERMEDAD DE CONDUCCIÓN CARDÍACA INFRAHISIANA Y TAQUIARRITMIA AURICULAR FAMILIAR"
  },
  {
    "codigo":773269009,
    "descripcion":"HERNIA PERINEAL OBSTRUIDA"
  },
  {
    "codigo":312682007,
    "descripcion":"EMPIEMA"
  },
  {
    "codigo":704063001,
    "descripcion":"FRACTURA POR ESTRÉS DE CUELLO DE FÉMUR"
  },
  {
    "codigo":472852000,
    "descripcion":"INSUFICIENCIA DE VÁLVULA AURICULOVENTRICULAR COMÚN FETAL"
  },
  {
    "codigo":1193748001,
    "descripcion":"INFLAMACIÓN INTESTINAL POR SHIGELLA SONNEI"
  },
  {
    "codigo":14100003,
    "descripcion":"ELEFANTIASIS DE PÁRPADO"
  },
  {
    "codigo":833300003,
    "descripcion":"AGUDEZA VISUAL DE OJO IZQUIERDO 3\/60"
  },
  {
    "codigo":866068003,
    "descripcion":"NEOPLASIA MALIGNA DE VAINA NERVIOSA DE LOCALIZACIONES SUPERPUESTAS DE NERVIOS PERIFÉRICOS Y SISTEMA NERVIOSO AUTÓNOMO"
  },
  {
    "codigo":309012006,
    "descripcion":"SITUACIONES DE DERIVACIÓN"
  },
  {
    "codigo":307177001,
    "descripcion":"CIÁTICA CRÓNICA"
  },
  {
    "codigo":276244009,
    "descripcion":"RECUERDOS DELIRANTES"
  },
  {
    "codigo":208873003,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA, PULGAR"
  },
  {
    "codigo":1290217005,
    "descripcion":"SUBLUXACIÓN DE PRÓTESIS DE CADERA"
  },
  {
    "codigo":235912004,
    "descripcion":"INSUFICIENCIA DEL TRASPLANTE HEPÁTICO"
  },
  {
    "codigo":239806000,
    "descripcion":"ESPONDILOARTROPATÍA JUVENIL"
  },
  {
    "codigo":897001008,
    "descripcion":"FORMA DE BALA ANORMAL CONGÉNITA DE FALANGE PROXIMAL DE DEDO DE MANO"
  },
  {
    "codigo":272574000,
    "descripcion":"ACOSTADO EN DECÚBITO DORSAL EN EL AGUA"
  },
  {
    "codigo":403646002,
    "descripcion":"ATROFIA CUTÁNEA CAUSADA POR CORTICOSTEROIDES"
  },
  {
    "codigo":15680081000119109,
    "descripcion":"CONJUNTIVITIS BILATERAL POR CHLAMYDIA"
  },
  {
    "codigo":733161009,
    "descripcion":"INFECCIÓN PARASITARIA DE COLON CAUSADA POR CYSTOISOSPORA BELLI"
  },
  {
    "codigo":762259005,
    "descripcion":"VULVITIS RECURRENTE"
  },
  {
    "codigo":205203006,
    "descripcion":"DEFICIENCIA TRANSVERSAL DE MIEMBRO INFERIOR - AL NIVEL DE LA CADERA"
  },
  {
    "codigo":44341000087104,
    "descripcion":"CONTUSIÓN DE CÓNDILO INTERNO DE TIBIA DERECHA"
  },
  {
    "codigo":39221000087104,
    "descripcion":"DOLOR CRÓNICO POSTERIOR A LESIÓN MUSCULOESQUELÉTICA"
  },
  {
    "codigo":301672002,
    "descripcion":"NO SE ACUESTA EN UNA CAMA"
  },
  {
    "codigo":203368004,
    "descripcion":"SINCONDROSIS ISQUIOPÚBICA"
  },
  {
    "codigo":46901000087109,
    "descripcion":"FRACTURA DE FALANGE DISTAL DE DEDO MEDIO IZQUIERDO"
  },
  {
    "codigo":236136006,
    "descripcion":"PROBLEMA VALVULAR DE ESTOMA"
  },
  {
    "codigo":41781000087108,
    "descripcion":"CELULITIS DE DEDO MEDIO DERECHO"
  },
  {
    "codigo":299837002,
    "descripcion":"REFLEJO SUPINADOR DISMINUIDO"
  },
  {
    "codigo":365373002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA REALIZAR JUEGOS Y ACTIVIDADES DEPORTIVAS"
  },
  {
    "codigo":430909002,
    "descripcion":"TRASTORNO DE CONDUCTA"
  },
  {
    "codigo":70461003,
    "descripcion":"IRIDOCICLITIS INDUCIDA POR LENTES"
  },
  {
    "codigo":37693008,
    "descripcion":"GASTRITIS POR LESIÓN CÁUSTICA"
  },
  {
    "codigo":296167005,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE CLOZAPINA"
  },
  {
    "codigo":64956000,
    "descripcion":"CISTITIS FOLICULAR"
  },
  {
    "codigo":230631009,
    "descripcion":"COMPRESIÓN DE NERVIO CUBITAL A NIVEL DE CODO"
  },
  {
    "codigo":294332002,
    "descripcion":"ALERGIA A ALCOHOL POLIVINÍLICO"
  },
  {
    "codigo":196028003,
    "descripcion":"FIBROSIS PULMONAR CRÓNICA CAUSADA POR SUSTANCIAS QUÍMICAS CALIENTES TRANSITORIAMENTE SUSPENDIDAS EN EL AIRE"
  },
  {
    "codigo":390801001,
    "descripcion":"OBJETIVO NO ALCANZADO"
  },
  {
    "codigo":95889002,
    "descripcion":"PIELONEFRITIS MICOPLASMÁTICA"
  },
  {
    "codigo":1144465004,
    "descripcion":"APLASIA DE FALANGE DISTAL DE MANO"
  },
  {
    "codigo":356198000,
    "descripcion":"FENÓMENO DE RAYNAUD SECUNDARIO"
  },
  {
    "codigo":292497008,
    "descripcion":"REACCIÓN ADVERSA AL FENOTEROL"
  },
  {
    "codigo":63121009,
    "descripcion":"INFECCIÓN CAUSADA POR STRONGYLOIDES CANIS"
  },
  {
    "codigo":94054005,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE PARTES BLANDAS DE LA CABEZA"
  },
  {
    "codigo":126822006,
    "descripcion":"NEOPLASIA DEL TERCIO MEDIO DEL ESÓFAGO"
  },
  {
    "codigo":290662005,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR DOXORUBICINA"
  },
  {
    "codigo":59451000,
    "descripcion":"CUTIS LAXA, AUTOSÓMICO RECESIVO"
  },
  {
    "codigo":11832351000119104,
    "descripcion":"LACERACIÓN DE VASO SANGUÍNEO DE DEDO DE MANO IZQUIERDA"
  },
  {
    "codigo":288827003,
    "descripcion":"NO IMITA PALABRAS"
  },
  {
    "codigo":92219005,
    "descripcion":"NEOPLASIA BENIGNA DEL TERCIO MEDIO DEL ESÓFAGO"
  },
  {
    "codigo":16010271000119105,
    "descripcion":"CLICS DE AMBAS CADERAS"
  },
  {
    "codigo":90384000,
    "descripcion":"INFECCIÓN CAUSADA POR PHYSOCEPHALUS"
  },
  {
    "codigo":286992006,
    "descripcion":"DISPAREUNIA NO PSICÓGENA"
  },
  {
    "codigo":876816008,
    "descripcion":"CUERPO EXTRAÑO SUPERFICIAL EN PERINEO CON INFECCIÓN"
  },
  {
    "codigo":98067641000119101,
    "descripcion":"TROMBOSIS VENOSA PROFUNDA CRÓNICA DE VENA PERONEA DERECHA"
  },
  {
    "codigo":55781004,
    "descripcion":"PRECOCIDAD INTELECTUAL"
  },
  {
    "codigo":285157008,
    "descripcion":"INCAPAZ DE RECONOCER OBJETOS"
  },
  {
    "codigo":283322000,
    "descripcion":"PICADURA DE INSECTO EN LA CABEZA"
  },
  {
    "codigo":448997008,
    "descripcion":"CISTADENOMA DE HÍGADO"
  },
  {
    "codigo":414394009,
    "descripcion":"TRASTORNO HEREDITARIO DE GLÓBULOS ROJOS"
  },
  {
    "codigo":707471001,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE CÉLULAS CLARAS DE TRÁQUEA"
  },
  {
    "codigo":1264527003,
    "descripcion":"OSTEÓLISIS DE HUESO ADYACENTE A PRÓTESIS DE ARTICULACIÓN DE CADERA"
  },
  {
    "codigo":445327005,
    "descripcion":"FORMA NORMAL DE EXTREMIDAD"
  },
  {
    "codigo":52111006,
    "descripcion":"PERISIGMOIDITIS"
  },
  {
    "codigo":1074361000119105,
    "descripcion":"ARTROSIS SECUNDARIA DE RODILLA DERECHA"
  },
  {
    "codigo":838543009,
    "descripcion":"INSUFICIENCIA SEVERA DE VÁLVULA PULMONAR"
  },
  {
    "codigo":1197156008,
    "descripcion":"MIOPATÍA NEMALÍNICA INTERMEDIA"
  },
  {
    "codigo":410724009,
    "descripcion":"TRASTORNO DE AMPOLLA FILTRANTE"
  },
  {
    "codigo":212281008,
    "descripcion":"LESIÓN ABIERTA, NERVIO DIGITAL COMÚN"
  },
  {
    "codigo":767502001,
    "descripcion":"EVERSIÓN DE LABIO INFERIOR"
  },
  {
    "codigo":46606001,
    "descripcion":"ÚLCERA CORNEAL PERFORADA"
  },
  {
    "codigo":310611000119102,
    "descripcion":"MIOSITIS INFECCIOSA DE ANTEBRAZO IZQUIERDO"
  },
  {
    "codigo":337081000119109,
    "descripcion":"GLAUCOMA UVEÍTICO DE OJO IZQUIERDO"
  },
  {
    "codigo":703801008,
    "descripcion":"ANGIOEDEMA ADQUIRIDO DEBIDO A TRASTORNO LINFOPROLIFERATIVO"
  },
  {
    "codigo":896739000,
    "descripcion":"FORMA DE CONO ANORMAL CONGÉNITA DE EPÍFISIS DE FALANGE DISTAL DE MANO"
  },
  {
    "codigo":44771000,
    "descripcion":"MICROCALCIFICACIONES DE LA MAMA"
  },
  {
    "codigo":306915005,
    "descripcion":"PABELLÓN AURICULAR DE FORMA ANORMAL"
  },
  {
    "codigo":208611005,
    "descripcion":"FRACTURA NO EXPUESTA DE TIBIA PROXIMAL, CÓNDILO EXTERNO (MESETA)"
  },
  {
    "codigo":274147008,
    "descripcion":"DEFORMIDAD EN VARO DEL DEDO GORDO"
  },
  {
    "codigo":403384001,
    "descripcion":"LINFEDEMA DE PABELLÓN AURICULAR"
  },
  {
    "codigo":698296002,
    "descripcion":"EXACERBACIÓN AGUDA DE INSUFICIENCIA CARDÍACA CONGESTIVA CRÓNICA"
  },
  {
    "codigo":440461000124101,
    "descripcion":"INGESTA INADECUADA DE PSYLLIUM"
  },
  {
    "codigo":460941000124102,
    "descripcion":"RELACIONES INTERPERSONALES POSITIVAS"
  },
  {
    "codigo":450701000124105,
    "descripcion":"MENISCO DISCOIDE CONGÉNITO DE RODILLA DERECHA"
  },
  {
    "codigo":204941003,
    "descripcion":"ATROFIA RENAL CONGÉNITA"
  },
  {
    "codigo":73869005,
    "descripcion":"BOCIO UNINODULAR TÓXICO"
  },
  {
    "codigo":237709007,
    "descripcion":"GRANULOMA DE LA GLÁNDULA HIPÓFISIS Y DEL HIPOTÁLAMO"
  },
  {
    "codigo":8333008,
    "descripcion":"NACIMIENTO DE TÉRMINO DE TRILLIZOS"
  },
  {
    "codigo":1351821009,
    "descripcion":"COLANGIOGRAFÍA FLUOROSCÓPICA CON CONTRASTE ANORMAL"
  },
  {
    "codigo":1153378003,
    "descripcion":"GOTA AGUDA MONOARTICULAR CAUSADA POR PLOMO"
  },
  {
    "codigo":235874007,
    "descripcion":"HEPATITIS POR ENFLURANO"
  },
  {
    "codigo":70199000,
    "descripcion":"ENFERMEDAD DE CÉLULA I"
  },
  {
    "codigo":203106009,
    "descripcion":"REUMATISMO DE LA MANO"
  },
  {
    "codigo":397879002,
    "descripcion":"ESPÉCIMEN ENMASCARADO POR MOCO"
  },
  {
    "codigo":702600000,
    "descripcion":"ESPASMO DE MÚSCULO MASTICATORIO"
  },
  {
    "codigo":1217079003,
    "descripcion":"DISTROFIA POLIGLANDULAR"
  },
  {
    "codigo":301410009,
    "descripcion":"DOLOR A LA PALPACIÓN EN FOSA ILÍACA DERECHA"
  },
  {
    "codigo":365111001,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA MOVILIZARSE CON DISPOSITIVOS ORTOPÉDICOS"
  },
  {
    "codigo":299575007,
    "descripcion":"DEBILIDAD DE DEDO DEL PIE"
  },
  {
    "codigo":102967008,
    "descripcion":"POTENCIAL EVOCADO VISUAL NORMAL"
  },
  {
    "codigo":234039000,
    "descripcion":"FLEBITIS DE VENA SAFENA"
  },
  {
    "codigo":2828008,
    "descripcion":"ESTENOSIS CONGÉNITA DE LAS NARINAS"
  },
  {
    "codigo":263137001,
    "descripcion":"RUPTURA DE LIGAMENTO DE LA MUÑECA"
  },
  {
    "codigo":166668008,
    "descripcion":"NIVEL SÉRICO DE ASPARTATO AMINOTRANSFERASA FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1076871000119101,
    "descripcion":"QUISTE ÓSEO SOLITARIO DE CÚBITO IZQUIERDO"
  },
  {
    "codigo":197601003,
    "descripcion":"SÍNDROME NEFRÓTICO CONGÉNITO TIPO FINLANDÉS"
  },
  {
    "codigo":230369005,
    "descripcion":"ENFERMEDAD DE PELIZAEUS-MERZBACHER DEL ADULTO TIPO IV"
  },
  {
    "codigo":164833007,
    "descripcion":"PRUEBA MUSCULOESQUELÉTICA NORMAL"
  },
  {
    "codigo":15986311000119103,
    "descripcion":"ANOMALÍA CONGÉNITA DE PAPILA ÓPTICA IZQUIERDA"
  },
  {
    "codigo":95627000,
    "descripcion":"FIEBRE DE RECIÉN NACIDO"
  },
  {
    "codigo":292235001,
    "descripcion":"REACCIÓN ADVERSA AL ETOPÓSIDO"
  },
  {
    "codigo":718219002,
    "descripcion":"ACIDOSIS LÁCTICA CONGÉNITA TIPO SAGUENAY-LAC-SAINT-JEAN"
  },
  {
    "codigo":290400005,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR CAOLÍN"
  },
  {
    "codigo":339591000119106,
    "descripcion":"RETINITIS FOCAL DE MÁCULA DE OJO IZQUIERDO"
  },
  {
    "codigo":93792007,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA CARA"
  },
  {
    "codigo":126560008,
    "descripcion":"NEOPLASIA DE LA CLAVÍCULA"
  },
  {
    "codigo":91957002,
    "descripcion":"DOLOR DE ESPALDA QUE COMPLICA EL EMBARAZO"
  },
  {
    "codigo":26421009,
    "descripcion":"HEMORROIDES EXTERNAS SANGRANTES"
  },
  {
    "codigo":1237002002,
    "descripcion":"INFLAMACIÓN SEBORREICA DE BORDE ANTERIOR DE PÁRPADO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":286730007,
    "descripcion":"CARÁCTER INCUMPLIDOR"
  },
  {
    "codigo":219359001,
    "descripcion":"LESIÓN POR ELECTROCUCIÓN, CON PROPÓSITO DESCONOCIDO"
  },
  {
    "codigo":186591007,
    "descripcion":"ENCEFALITIS CAUSADA POR VIRUS DE ENCEFALITIS TRANSMITIDA POR GARRAPATAS DEL LEJANO ORIENTE"
  },
  {
    "codigo":15714081000119105,
    "descripcion":"HALLUX VALGUS BILATERAL ADQUIRIDO DEBIDO A METATARSO PRIMUS VARO"
  },
  {
    "codigo":284895007,
    "descripcion":"INCAPAZ DE MAQUILLARSE"
  },
  {
    "codigo":709044004,
    "descripcion":"ENFERMEDAD RENAL CRÓNICA"
  },
  {
    "codigo":184756004,
    "descripcion":"SOLICITUD DE PERMISO PARA PORTACIÓN DE ESCOPETA - NO PAGADO"
  },
  {
    "codigo":20916007,
    "descripcion":"OTITIS MEDIA ADHESIVA CON ADHERENCIAS ENTRE EL TÍMPANO Y EL ESTRIBO"
  },
  {
    "codigo":19081000,
    "descripcion":"INFESTACIÓN CAUSADA POR GASTEROPHILUS INERMIS"
  },
  {
    "codigo":707209001,
    "descripcion":"QUERATODERMIA"
  },
  {
    "codigo":445065005,
    "descripcion":"MÉDICAMENTE APTO PARA CONFINAMIENTO EN CELDA"
  },
  {
    "codigo":215689006,
    "descripcion":"LESIÓN EN MEDIO DE TRANSPORTE ACUÁTICO PRODUCIDO POR MAQUINARIA DE CUBIERTA, OCUPANTE DE EMBARCACIÓN PEQUEÑA MOTORIZADA LESIONADO"
  },
  {
    "codigo":312158001,
    "descripcion":"INFECCIÓN DEL APARATO DIGESTIVO"
  },
  {
    "codigo":246622003,
    "descripcion":"OJOS FOTOSENSIBLES"
  },
  {
    "codigo":443230004,
    "descripcion":"METAPLASIA MIELOIDE"
  },
  {
    "codigo":1196894003,
    "descripcion":"NEOPLASIA EPITELIAL BENIGNA DE ESÓFAGO"
  },
  {
    "codigo":1295198006,
    "descripcion":"TUMOR MIXTO DE PARTES BLANDAS"
  },
  {
    "codigo":82782008,
    "descripcion":"EFECTO TÓXICO DEL ALCOHOL ETÍLICO"
  },
  {
    "codigo":769075002,
    "descripcion":"LEVADURA DE ESPECIE NO CRYPTOCOCCUS DETECTADA"
  },
  {
    "codigo":16034511000119100,
    "descripcion":"HIPERTROFIA DE HUESO DE PERONÉ IZQUIERDO"
  },
  {
    "codigo":19151000119101,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE OÍDO"
  },
  {
    "codigo":10650831000119101,
    "descripcion":"ÚLCERA POR ESTASIS VENOSA DE PIERNA IZQUIERDA CONCOMITANTE CON EDEMA DE PIERNA IZQUIERDA"
  },
  {
    "codigo":124111000119102,
    "descripcion":"RETINOPATÍA DE LA PREMATUREZ, ESTADIO 0"
  },
  {
    "codigo":101071000119104,
    "descripcion":"CRIBADO NEONATAL ANORMAL"
  },
  {
    "codigo":16057551000119105,
    "descripcion":"PARÁLISIS FACIAL DERECHA GRADO V DE HOUSE-BRACKMANN"
  },
  {
    "codigo":10632911000119103,
    "descripcion":"ABSCESO DE EXTREMIDAD SUPERIOR IZQUIERDA"
  },
  {
    "codigo":47311000119103,
    "descripcion":"ENCEFALOPATÍA ESTÁTICA"
  },
  {
    "codigo":11843791000119102,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE OÍDO EXTERNO DERECHO"
  },
  {
    "codigo":16044751000119106,
    "descripcion":"ARTRITIS IDIOPÁTICA JUVENIL POLIARTICULAR"
  },
  {
    "codigo":16003791000119106,
    "descripcion":"ARTROPATÍA DE MANGUITO ROTADOR DE HOMBRO DERECHO"
  },
  {
    "codigo":10865871000119107,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO PERIFÉRICO DE TÓRAX"
  },
  {
    "codigo":321231000119105,
    "descripcion":"ESPONDILOLISTESIS ADQUIRIDA DE VÉRTEBRAS DORSOLUMBARES"
  },
  {
    "codigo":111880001,
    "descripcion":"INFECCIÓN AGUDA POR VIH"
  },
  {
    "codigo":290511000119107,
    "descripcion":"SÍNDROME DEL TÚNEL TARSIANO DE NERVIO TIBIAL IZQUIERDO"
  },
  {
    "codigo":16039631000119108,
    "descripcion":"CONDROMALACIA DE CADERA DERECHA"
  },
  {
    "codigo":16702671000119109,
    "descripcion":"RETRASO PSICOMOTOR DEBIDO A ACCIDENTE CEREBROVASCULAR EMBÓLICO Y POSTERIOR A ÉL"
  },
  {
    "codigo":699869003,
    "descripcion":"DEFICIENCIA DE QUINASA-4 ASOCIADA AL RECEPTOR DE INTERLEUCINA-1"
  },
  {
    "codigo":313551000119109,
    "descripcion":"EPICONDILITIS MEDIAL DE ARTICULACIÓN DE CODO DERECHO"
  },
  {
    "codigo":1079381000119100,
    "descripcion":"NEOPLASIA BENIGNA DE PIEL DE OÍDO DERECHO"
  },
  {
    "codigo":77277003,
    "descripcion":"INTOXICACIÓN CAUSADA POR BISACODILO"
  },
  {
    "codigo":44509000,
    "descripcion":"LIQUEN PLANO LINEAL"
  },
  {
    "codigo":110045009,
    "descripcion":"LACERACIÓN COMPLEJA CONTAMINADA DE LA REGIÓN CIGOMÁTICA DE LA MEJILLA"
  },
  {
    "codigo":9906005,
    "descripcion":"SEPARACIÓN DE PRUEBA"
  },
  {
    "codigo":698034006,
    "descripcion":"CONTORNO GINGIVAL ALTO"
  },
  {
    "codigo":1156786006,
    "descripcion":"LEIOMIOSARCOMA DE ESÓFAGO"
  },
  {
    "codigo":403122008,
    "descripcion":"MICETOMA CAUSADO POR PYRENOCHAETA ROMEROI"
  },
  {
    "codigo":237447001,
    "descripcion":"SÍFILIS PRIMARIA DEL PEZÓN"
  },
  {
    "codigo":342101000119104,
    "descripcion":"ATROFIA SENIL DE COROIDES IZQUIERDA"
  },
  {
    "codigo":8071005,
    "descripcion":"ABORTO ESPONTÁNEO CON PERFORACIÓN DE INTESTINO"
  },
  {
    "codigo":268380000,
    "descripcion":"VELOCIDAD DE FLUJO RESPIRATORIO NORMAL"
  },
  {
    "codigo":235612001,
    "descripcion":"ÚLCERA ESOFÁGICA POR PROTOZOOS"
  },
  {
    "codigo":71772004,
    "descripcion":"VASOESPASMO"
  },
  {
    "codigo":295987004,
    "descripcion":"SOBREDOSIS DE FENOBARBITAL"
  },
  {
    "codigo":366684007,
    "descripcion":"HALLAZGO RELACIONADO CON LA AMPLITUD DE LA ADUCCIÓN DE DEDO DE LA MANO"
  },
  {
    "codigo":301148008,
    "descripcion":"FRECUENCIA DEL PULSO - ESTABLE"
  },
  {
    "codigo":299313006,
    "descripcion":"PRUEBA DE THOMAS POSITIVA"
  },
  {
    "codigo":364849007,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA CAMINAR EN PUNTAS DE PIE"
  },
  {
    "codigo":68102003,
    "descripcion":"INTOXICACIÓN POR AMMI MAJUS"
  },
  {
    "codigo":231942005,
    "descripcion":"ANILLO DE ÓXIDO EN LA CÓRNEA"
  },
  {
    "codigo":33499000,
    "descripcion":"TOXICIDAD DEL OXÍGENO"
  },
  {
    "codigo":363014009,
    "descripcion":"COMPLICACIÓN DE PROCEDIMIENTO DE MANIPULACIÓN"
  },
  {
    "codigo":788998009,
    "descripcion":"SÍFILIS OCULAR TARDÍA"
  },
  {
    "codigo":197339003,
    "descripcion":"HEPATITIS POR VIRUS COXSACKIE"
  },
  {
    "codigo":1149446009,
    "descripcion":"PERIODONTITIS LOCALIZADA ESTADIO 1 GRADO A SEGÚN LA CLASIFICACIÓN DE LAS ENFERMEDADES Y ALTERACIONES PERIODONTALES Y PERIIMPLANTARIAS DE 2017 DE LA ACADEMIA ESTADOUNIDENSE DE PERIODONTOLOGÍA Y LA FEDERACIÓN EUROPEA DE PERIODONTOLOGÍA"
  },
  {
    "codigo":721627007,
    "descripcion":"MELANOMA MALIGNO DE ESÓFAGO"
  },
  {
    "codigo":262875008,
    "descripcion":"SECCIÓN DE COLON"
  },
  {
    "codigo":236381000,
    "descripcion":"SÍNDROME NEFRÓTICO RESISTENTE A LOS ESTEROIDES"
  },
  {
    "codigo":95365001,
    "descripcion":"REACCIÓN EN EL SITIO DE APLICACIÓN"
  },
  {
    "codigo":293808009,
    "descripcion":"ALERGIA A LEVODOPA"
  },
  {
    "codigo":128133004,
    "descripcion":"TRASTORNO DE CODO"
  },
  {
    "codigo":160901009,
    "descripcion":"CESANTE"
  },
  {
    "codigo":93530003,
    "descripcion":"GRANULOMA DE HODGKIN DE GANGLIOS LINFÁTICOS INTRAPÉLVICOS"
  },
  {
    "codigo":1142106007,
    "descripcion":"HIPOTIROIDISMO CONGÉNITO TRANSITORIO DEBIDO A MUTACIÓN DE LA ENZIMA OXIDASA DUAL-2"
  },
  {
    "codigo":419375001,
    "descripcion":"REACCIÓN ALÉRGICA CAUSADA POR ACEITE"
  },
  {
    "codigo":1304111007,
    "descripcion":"HIPOMAGNESEMIA FAMILIAR PRIMARIA CON HIPERCALCIURIA Y NEFROCALCINOSIS"
  },
  {
    "codigo":124463009,
    "descripcion":"DEFICIENCIA DE BETA - GLUCOSIDASA"
  },
  {
    "codigo":253700001,
    "descripcion":"ORIGEN VARIABLE DE ARTERIAS CORONARIAS EN EL SENO AÓRTICO"
  },
  {
    "codigo":286468005,
    "descripcion":"NO PUEDE DESMENUZAR LA CARNE"
  },
  {
    "codigo":57092006,
    "descripcion":"ECCEMA DE LOS PLIEGUES DE FLEXIÓN"
  },
  {
    "codigo":417540008,
    "descripcion":"INVITACIÓN PARA CONTROL DE ACCIDENTE CEREBROVASCULAR\/ATAQUE ISQUÉMICO TRANSITORIO"
  },
  {
    "codigo":186329000,
    "descripcion":"YERSINIOSIS EXTRAINTESTINAL"
  },
  {
    "codigo":1169369000,
    "descripcion":"TIROXINA EN SUERO POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":450308009,
    "descripcion":"ARTERIA COLATERAL MAYOR QUE DERIVA EL FLUJO SISTÉMICO HACIA LA CIRCULACIÓN PULMONAR QUE IRRIGA TODO EL PULMÓN IZQUIERDO"
  },
  {
    "codigo":284633004,
    "descripcion":"APRETAR A OTRA PERSONA"
  },
  {
    "codigo":55257005,
    "descripcion":"TEJIDO EQUIVOCADO RECIBIDO"
  },
  {
    "codigo":344611000119101,
    "descripcion":"OPACIDAD PERIFÉRICA DE AMBAS CÓRNEAS"
  },
  {
    "codigo":16931000119102,
    "descripcion":"TRASTORNO NEUROLÓGICO DEBIDO A DEGENERACIÓN DE DISCO INTERVERTEBRAL LUMBAR"
  },
  {
    "codigo":98851000119102,
    "descripcion":"INFLAMACIÓN DE AMPOLLA FILTRANTE"
  },
  {
    "codigo":1081891000119103,
    "descripcion":"CARCINOMA MICROCÍTICO PRIMARIO DE LÓBULO INFERIOR PULMÓN DERECHO"
  },
  {
    "codigo":315566006,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: ÁRABE"
  },
  {
    "codigo":446638007,
    "descripcion":"LACERACIÓN DE PIEL DE PÁRPADO"
  },
  {
    "codigo":1003694008,
    "descripcion":"MIGRACIÓN TRANSPERITONEAL DE ESPERMATOZOIDE"
  },
  {
    "codigo":248195003,
    "descripcion":"ARRUGAS FACIALES FINAS"
  },
  {
    "codigo":1264003007,
    "descripcion":"INSUFICIENCIA VENTRICULAR DERECHA AGUDA POSTERIOR A INCISIÓN DE CORAZÓN"
  },
  {
    "codigo":82520000,
    "descripcion":"QUISTE EMBRIONARIO DE CONDUCTO DE GARTNER"
  },
  {
    "codigo":117123008,
    "descripcion":"CALIDAD DEL SOPLO CARDÍACO, VIBRATORIO"
  },
  {
    "codigo":703277001,
    "descripcion":"TROMBOSIS VENOSA PROFUNDA DE VENA FEMOROPOPLÍTEA"
  },
  {
    "codigo":408365002,
    "descripcion":"CAPAZ DE UTILIZAR MEDICAMENTOS"
  },
  {
    "codigo":441133003,
    "descripcion":"METAPNEUMOVIRUS HUMANO PRESENTE"
  },
  {
    "codigo":277293005,
    "descripcion":"ENGROSAMIENTO DE NERVIO PERIFÉRICO"
  },
  {
    "codigo":1356802002,
    "descripcion":"ENFERMEDAD RESPIRATORIA QUE REQUIERE VENTILACIÓN MECÁNICA ASISTIDA"
  },
  {
    "codigo":766978002,
    "descripcion":"CARCINOMA ESCAMOCELULAR DE VESÍCULA Y VÍA BILIAR EXTRAHEPÁTICA"
  },
  {
    "codigo":109783003,
    "descripcion":"CELULITIS DEL ESPACIO CANINO DE LA BOCA"
  },
  {
    "codigo":240855004,
    "descripcion":"ESTRONGILOIDIASIS CUTÁNEA"
  },
  {
    "codigo":13015741000119105,
    "descripcion":"MELANOCITOSIS OCULAR CONGÉNITA DE OJO IZQUIERDO"
  },
  {
    "codigo":765143008,
    "descripcion":"FEOCROMOCITOMA ESPORÁDICO Y PARAGANGLIOMA SECRETANTE"
  },
  {
    "codigo":206252004,
    "descripcion":"LESIÓN DE ESTERNOCLEIDOMASTOIDEO DEBIDA A LESIÓN OBSTÉTRICA"
  },
  {
    "codigo":402860008,
    "descripcion":"PITIRIASIS LIQUENOIDE AGUDA FEBRIL ULCERONECROSANTE"
  },
  {
    "codigo":73345000,
    "descripcion":"ABSCESO CRÓNICO DE MANDÍBULA"
  },
  {
    "codigo":239020008,
    "descripcion":"SÍNDROME DE DIENTES Y UÑAS DE FRIED"
  },
  {
    "codigo":366422000,
    "descripcion":"AMPLITUD DE MOVIMIENTO PASIVO DE ROTACIÓN HACIA LA DERECHA DE LA COLUMNA DORSAL - HALLAZGO"
  },
  {
    "codigo":7809009,
    "descripcion":"ABORTO ESPONTÁNEO CON LACERACIÓN DE ÚTERO"
  },
  {
    "codigo":399190000,
    "descripcion":"GLOMERULONEFRITIS HEREDITARIA NO PROGRESIVA"
  },
  {
    "codigo":169814004,
    "descripcion":"NACIDO EN UNIDAD DE MEDICINA GENERAL\/FAMILIAR"
  },
  {
    "codigo":202582006,
    "descripcion":"OSTEOCONDROMATOSIS SINOVIAL DE ARTICULACIÓN INTERFALÁNGICA PROXIMAL DE DEDO DE LA MANO"
  },
  {
    "codigo":300886007,
    "descripcion":"TUMEFACCIÓN CUTÁNEA"
  },
  {
    "codigo":38742007,
    "descripcion":"OCLUSIÓN DE LA ARTERIA RETINIANA CENTRAL"
  },
  {
    "codigo":725035001,
    "descripcion":"LIPODISTROFIA PARCIAL FAMILIAR TIPO KOBBERLING"
  },
  {
    "codigo":268118007,
    "descripcion":"CUERPO EXTRAÑO OLVIDADO EN CADERA"
  },
  {
    "codigo":2304001,
    "descripcion":"DISCITIS"
  },
  {
    "codigo":198912003,
    "descripcion":"SEPARACIÓN PREMATURA DE LA PLACENTA CON DEFECTO DE LA COAGULACIÓN"
  },
  {
    "codigo":395520006,
    "descripcion":"HIDROPERICARDIO"
  },
  {
    "codigo":297216006,
    "descripcion":"AUMENTO DE LA FALTA DE ALIENTO"
  },
  {
    "codigo":426453001,
    "descripcion":"ELECTROCARDIOGRAMA: RITMO DE MARCAPASOS"
  },
  {
    "codigo":229845003,
    "descripcion":"ANTEPIÉ VARO CONGÉNITO"
  },
  {
    "codigo":262613006,
    "descripcion":"CUERPO EXTRAÑO EN CONDUCTO URINARIO"
  },
  {
    "codigo":721365006,
    "descripcion":"LESIÓN COMPLETA DE MÉDULA ESPINAL AL NIVEL DEL TERCERO SEGMENTO CERVICAL"
  },
  {
    "codigo":295381009,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE CARBENOXOLONA"
  },
  {
    "codigo":162474002,
    "descripcion":"SIN FACTORES QUE EMPEOREN EL SÍNTOMA"
  },
  {
    "codigo":129706002,
    "descripcion":"CON MAYOR RIESGO DE CONDUCTA DESORGANIZADA DEL LACTANTE"
  },
  {
    "codigo":1145514002,
    "descripcion":"APLASIA DE FALANGE DE DEDO ÍNDICE"
  },
  {
    "codigo":95103001,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE PARTES BLANDAS DEL TRONCO"
  },
  {
    "codigo":293546009,
    "descripcion":"REACCIÓN ADVERSA AL TRINITRATO DE GLICERILO POR VÍA TRANSDÉRMICA"
  },
  {
    "codigo":160639004,
    "descripcion":"EJERCICIO AERÓBICO, TRES O MÁS VECES POR SEMANA"
  },
  {
    "codigo":226175006,
    "descripcion":"DIETA CON BAJO CONTENIDO DE COBRE"
  },
  {
    "codigo":783231007,
    "descripcion":"APLASIA DE CUERPO UTERINO"
  },
  {
    "codigo":93268000,
    "descripcion":"HIPOPLASIA CONGÉNITA DEL TRACTO INTESTINAL"
  },
  {
    "codigo":62335009,
    "descripcion":"ESTENOSIS CONGÉNITA DE LA VENA CAVA INFERIOR"
  },
  {
    "codigo":422783009,
    "descripcion":"ABUSA FÍSICAMENTE DE SU PAREJA"
  },
  {
    "codigo":715860003,
    "descripcion":"PERIODONTITIS AGUDA SEVERA LOCALIZADA"
  },
  {
    "codigo":1141844004,
    "descripcion":"SIGNO DEL LIMÓN"
  },
  {
    "codigo":289876003,
    "descripcion":"PERINEO TENSO"
  },
  {
    "codigo":347121000119105,
    "descripcion":"QUERATOPATÍA EN BANDA DE AMBOS OJOS"
  },
  {
    "codigo":224340002,
    "descripcion":"CONVICTO POR ACTIVIDAD CRIMINAL"
  },
  {
    "codigo":25897000,
    "descripcion":"NEUMOPATÍA DE LOS TRABAJADORES DE LA MALTA"
  },
  {
    "codigo":191572009,
    "descripcion":"EXACERBACIÓN AGUDA DE ESQUIZOFRENIA ESQUIZOAFECTIVA CRÓNICA"
  },
  {
    "codigo":124201006,
    "descripcion":"DEFICIENCIA DE CITOCROMO - C PEROXIDASA"
  },
  {
    "codigo":91433009,
    "descripcion":"INTOXICACIÓN POR MINOCICLINA"
  },
  {
    "codigo":1269246001,
    "descripcion":"TROMBOSIS DE AMBAS ARTERIAS VERTEBRALES"
  },
  {
    "codigo":89598003,
    "descripcion":"AUSENCIA DE MOTIVACIÓN"
  },
  {
    "codigo":253438003,
    "descripcion":"PROLAPSO DE VÁLVULA AURICULOVENTRICULAR COMÚN"
  },
  {
    "codigo":56830006,
    "descripcion":"INTOXICACIÓN POR ERYTHROPHLOEUM CLOROSTACHYS"
  },
  {
    "codigo":286206009,
    "descripcion":"CAPAZ DE GESTICULAR AL HABLAR"
  },
  {
    "codigo":448211002,
    "descripcion":"ADENOLINFOMA DE GLÁNDULA PARÓTIDA"
  },
  {
    "codigo":251603003,
    "descripcion":"FORMA DE LA ONDA DEL PATRÓN DE POTENCIALES EVOCADOS VISUALES"
  },
  {
    "codigo":87763006,
    "descripcion":"HEMORRAGIA DIGESTIVA BAJA"
  },
  {
    "codigo":186067006,
    "descripcion":"TIENE UN PODER LEGAL"
  },
  {
    "codigo":22227008,
    "descripcion":"PULSO ECTÓPICO"
  },
  {
    "codigo":20392000,
    "descripcion":"ENTROPIÓN CONGÉNITO"
  },
  {
    "codigo":282536001,
    "descripcion":"CAPAZ DE INICIAR LA CARRERA"
  },
  {
    "codigo":1003432003,
    "descripcion":"DISOSTOSIS MANDIBULOACRAL CONCOMITANTE CON LIPODISTROFIA TIPO B"
  },
  {
    "codigo":10970251000119106,
    "descripcion":"LACERACIÓN DE PIE IZQUIERDO"
  },
  {
    "codigo":249768009,
    "descripcion":"DEDOS DE LA MANO AHUSADOS"
  },
  {
    "codigo":247933005,
    "descripcion":"SACUDIR OBJETOS CERCA DE LOS OJOS"
  },
  {
    "codigo":442706009,
    "descripcion":"HALLAZGO RELACIONADO CON DIFERENCIA EN LA CANTIDAD DE CALCIFICACIONES EN COMPARACIÓN CON EXAMEN RADIOLÓGICO PREVIO"
  },
  {
    "codigo":1260071001,
    "descripcion":"CARCINOMA ESCAMOSO PAPILAR DE PULMÓN"
  },
  {
    "codigo":277031003,
    "descripcion":"RESPUESTA DECRECIENTE A ESTIMULACIÓN NERVIOSA REPETITIVA"
  },
  {
    "codigo":735783003,
    "descripcion":"LACERACIÓN DE ESTÓMAGO SIN PERFORACIÓN"
  },
  {
    "codigo":703015006,
    "descripcion":"VIRUS COXSACKIE HUMANO O ECOVIRUS HUMANO"
  },
  {
    "codigo":211495007,
    "descripcion":"CONTUSIÓN DE ÓRGANO GENITAL"
  },
  {
    "codigo":80423007,
    "descripcion":"NEUMOTÓRAX ESPONTÁNEO"
  },
  {
    "codigo":766716004,
    "descripcion":"SÍNDROME DE MONOSOMÍA 13Q34"
  },
  {
    "codigo":733948005,
    "descripcion":"CARIES DENTAL ACTIVA SECUNDARIA QUE SE EXTIENDE HASTA EL TERCIO INTERNO DE LA DENTINA"
  },
  {
    "codigo":13052006,
    "descripcion":"FLEXIBILIDAD CERÚLEA"
  },
  {
    "codigo":111356006,
    "descripcion":"FÍSTULA ENTEROCÓLICA"
  },
  {
    "codigo":109521001,
    "descripcion":"HIPERPLASIA ALVEOLAR CONGÉNITA DEL MAXILAR"
  },
  {
    "codigo":1287334001,
    "descripcion":"CARCINOMA DE CÉLULAS DE MERKEL PRIMARIO DE PIEL DE MIEMBRO INFERIOR IZQUIERDO"
  },
  {
    "codigo":74918002,
    "descripcion":"MIOCARDITIS POR VIRUS DEL SARAMPIÓN"
  },
  {
    "codigo":304294003,
    "descripcion":"HALLAZGO RELACIONADO CON HISOPADO"
  },
  {
    "codigo":238758008,
    "descripcion":"HIPERHIDROSIS GUSTATIVA"
  },
  {
    "codigo":1187195007,
    "descripcion":"MALFORMACIONES CORTICALES MICROCEFÁLICAS Y TALLA BAJA POR DEFICIENCIA DE RTTN"
  },
  {
    "codigo":1252731008,
    "descripcion":"NÓDULO DE PIEL DE ANTEBRAZO"
  },
  {
    "codigo":40315008,
    "descripcion":"PÁNCREAS ANULAR"
  },
  {
    "codigo":726608002,
    "descripcion":"PARAPLEJÍA ESPÁSTICA AUTOSÓMICA RECESIVA TIPO 23"
  },
  {
    "codigo":300624005,
    "descripcion":"NO VIAJA EN TRANSPORTE PÚBLICO"
  },
  {
    "codigo":235088005,
    "descripcion":"SUPERPOSICIÓN INVERSA"
  },
  {
    "codigo":1281829000,
    "descripcion":"OBSTRUCCIÓN DE TROMPA DE FALOPIO DISTAL IZQUIERDA"
  },
  {
    "codigo":724773004,
    "descripcion":"MIOCLONO FOCAL"
  },
  {
    "codigo":167717006,
    "descripcion":"CONTENIDO CELULAR DE LÍQUIDO CEFALORRAQUÍDEO DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1148922000,
    "descripcion":"HEMATURIA FRANCA INTERMITENTE"
  },
  {
    "codigo":298789009,
    "descripcion":"AMPLITUD DE EXTENSIÓN ACTIVA DE HOMBRO DISMINUIDA"
  },
  {
    "codigo":15724121000119102,
    "descripcion":"ENTESOPATÍA DE AMBAS RODILLAS"
  },
  {
    "codigo":198650006,
    "descripcion":"EMBOLIA DEBIDA A ABORTO ESPONTÁNEO INCOMPLETO"
  },
  {
    "codigo":722938007,
    "descripcion":"HIPOTIROIDISMO CONGÉNITO CENTRAL"
  },
  {
    "codigo":788474009,
    "descripcion":"TRASTORNO REPETITIVO DEL MOVIMIENTO DEL HOMBRO DERECHO"
  },
  {
    "codigo":1343695005,
    "descripcion":"NEOPLASIA MALIGNA DE PABELLÓN AURICULAR"
  },
  {
    "codigo":426191007,
    "descripcion":"MIXOMA CARDÍACO"
  },
  {
    "codigo":43912002,
    "descripcion":"INTOXICACIÓN POR EQUISETO ARVENSE"
  },
  {
    "codigo":719268008,
    "descripcion":"FUSIÓN VERTEBRAL ANTERIOR PROGRESIVA NO INFECCIOSA"
  },
  {
    "codigo":94841002,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL FLANCO"
  },
  {
    "codigo":724275005,
    "descripcion":"INMUNODEFICIENCIA PRIMARIA CON DEFICIENCIA DE CÉLULAS ASESINAS NATURALES E INSUFICIENCIA SUPRARRENAL"
  },
  {
    "codigo":225913004,
    "descripcion":"USA UN TURBANTE"
  },
  {
    "codigo":323161000119107,
    "descripcion":"ARTROSIS DE CADERA IZQUIERDA DEBIDA A DISPLASIA"
  },
  {
    "codigo":60238002,
    "descripcion":"TIRÓN MUSCULAR"
  },
  {
    "codigo":1010510003,
    "descripcion":"ESCLEROSIS DE EPÍFISIS DE HUESO METACARPIANO CON RADIOPACIDAD AUMENTADA"
  },
  {
    "codigo":289614007,
    "descripcion":"HALLAZGO RELACIONADO CON LA DISPOSICIÓN DEL HIMEN"
  },
  {
    "codigo":224078007,
    "descripcion":"OBSERVANCIA NOMINAL DE PRÁCTICAS RELIGIOSAS"
  },
  {
    "codigo":93006009,
    "descripcion":"ANOMALÍA CONGÉNITA DEL ILION"
  },
  {
    "codigo":255011002,
    "descripcion":"NEVO DE CÓRNEA"
  },
  {
    "codigo":123939004,
    "descripcion":"INTOXICACIÓN POR RUTACEAE"
  },
  {
    "codigo":253176002,
    "descripcion":"SÍNDROME DE GILLESPIE"
  },
  {
    "codigo":285944004,
    "descripcion":"NO MANEJA LOS CONTROLES DE LA DUCHA"
  },
  {
    "codigo":187640005,
    "descripcion":"NEOPLASIA MALIGNA DE DOS TERCIOS ANTERIORES DE CARA VENTRAL DE LENGUA"
  },
  {
    "codigo":23800005,
    "descripcion":"HIPOCALIEMIA, INGESTA INADECUADA"
  },
  {
    "codigo":449784008,
    "descripcion":"SÍNDROME DE LINFOCITOSIS INFILTRATIVA DIFUSA"
  },
  {
    "codigo":1089421000119101,
    "descripcion":"TROMPA DE EUSTAQUIO IZQUIERDA PERMEABLE"
  },
  {
    "codigo":447949005,
    "descripcion":"NEOPLASIA EPITELIAL MALIGNA DE MEJILLA"
  },
  {
    "codigo":284109006,
    "descripcion":"CAPAZ DE CONTROLAR LA POSICIÓN DE LA CABEZA"
  },
  {
    "codigo":118434000,
    "descripcion":"HALLAZGO GÁSTRICO"
  },
  {
    "codigo":710093008,
    "descripcion":"DENTICIÓN COMPLETA MÍNIMAMENTE COMPROMETIDA CON 3 O MENOS EN UN SEXTANTE"
  },
  {
    "codigo":679821000119103,
    "descripcion":"SUBLUXACIÓN ANTERIOR DE CRISTALINO IZQUIERDO"
  },
  {
    "codigo":249506008,
    "descripcion":"PASAJE DE FLATO RUIDOSO"
  },
  {
    "codigo":247671004,
    "descripcion":"DELIRIO RELIGIOSO"
  },
  {
    "codigo":1263479005,
    "descripcion":"NEOPLASIA MALIGNA DE PERINEO"
  },
  {
    "codigo":870263005,
    "descripcion":"TRASTORNO GENERALIZADO DEL DESARROLLO CON ALTERACIÓN DEL LENGUAJE FUNCIONAL"
  },
  {
    "codigo":409676000,
    "descripcion":"FIEBRE HEMORRÁGICA POR DENGUE, GRADO I"
  },
  {
    "codigo":278604000,
    "descripcion":"ENCHAPADO DENTAL FLOJO"
  },
  {
    "codigo":81996005,
    "descripcion":"TORSIÓN DE TESTÍCULO"
  },
  {
    "codigo":1359948006,
    "descripcion":"BACTERIAS EN TÉTRADAS"
  },
  {
    "codigo":1228876007,
    "descripcion":"PROTEINOSIS ALVEOLAR PULMONAR GRAVE POR DEFICIENCIA DE SINTETASA 1 DE ÁCIDO RIBONUCLEICO DE TRANSFERENCIA DE METIONINA DE INICIO TEMPRANO"
  },
  {
    "codigo":735521001,
    "descripcion":"ESTADIO CLÍNICO 1 DE INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA DE LA ORGANIZACIÓN MUNDIAL DE LA SALUD DE 2007 CONCOMITANTE CON TUBERCULOSIS"
  },
  {
    "codigo":473377003,
    "descripcion":"PERFORACIÓN DE VALVA DE VÁLVULA AURICULOVENTRICULAR DERECHA (MORFOLÓGICAMENTE NO TRICÚSPIDE)"
  },
  {
    "codigo":309537005,
    "descripcion":"ENTUMECIMIENTO DEL MIEMBRO INFERIOR"
  },
  {
    "codigo":438774001,
    "descripcion":"RIGIDEZ ABDOMINAL EN EPIGASTRIO"
  },
  {
    "codigo":768289009,
    "descripcion":"HEPATITIS CRÓNICA CAUSADA POR VIRUS HEPATITIS C GENOTIPO 1A"
  },
  {
    "codigo":1290742002,
    "descripcion":"ARTRITIS REACTIVA DE ARTICULACIÓN DE PIE DEBIDA A ENFERMEDAD INFECCIOSA TRANSMITIDA POR VÍA SEXUAL Y POSTERIOR A ELLA"
  },
  {
    "codigo":406006004,
    "descripcion":"HAPLOTIPO CDE"
  },
  {
    "codigo":897526006,
    "descripcion":"DELECIÓN DISTAL DEL BRAZO LARGO DEL CROMOSOMA 8"
  },
  {
    "codigo":764619001,
    "descripcion":"SÍNDROME DE TRISOMÍA 15 MOSAICO"
  },
  {
    "codigo":305867002,
    "descripcion":"VISTO POR EL SERVICIO DE PSIQUIATRÍA FORENSE"
  },
  {
    "codigo":109259005,
    "descripcion":"MUCOSITIS POR CONTACTO AGUDA"
  },
  {
    "codigo":41888000,
    "descripcion":"TRASTORNO DE LA ARTICULACIÓN TEMPOROMANDIBULAR"
  },
  {
    "codigo":404171008,
    "descripcion":"MASTOCITOMA"
  },
  {
    "codigo":205728002,
    "descripcion":"DUPLICACIÓN CROMOSÓMICA"
  },
  {
    "codigo":402336000,
    "descripcion":"PSORIASIS FAMILIAR CON FAMILIAR DE PRIMER GRADO AFECTADO"
  },
  {
    "codigo":238496008,
    "descripcion":"SENO PILOSO"
  },
  {
    "codigo":1156000009,
    "descripcion":"SOBREDOSIS DE SULFONAMIDA ANTIBACTERIANA"
  },
  {
    "codigo":7285009,
    "descripcion":"FÓRMULA SIN LECHE PARA LACTANTES"
  },
  {
    "codigo":300362001,
    "descripcion":"VÓMITO CON CONTENIDO DE SANGRE FRESCA"
  },
  {
    "codigo":726346004,
    "descripcion":"TRISOMÍA PARCIAL DE CROMOSOMA 7"
  },
  {
    "codigo":5450005,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DE CODO"
  },
  {
    "codigo":1119562007,
    "descripcion":"BASE ANCHA DE NARIZ"
  },
  {
    "codigo":365898008,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA RECORDAR EL NOMBRE DEL PRIMER MINISTRO ACTUAL"
  },
  {
    "codigo":429599001,
    "descripcion":"SITUACIÓN DE CRIBADO DE TUBERCULOSIS"
  },
  {
    "codigo":724511006,
    "descripcion":"LIQUEN PLANO NO EROSIVO DE MUCOSA BUCAL"
  },
  {
    "codigo":298527006,
    "descripcion":"AMPLITUD DE EXTENSIÓN PASIVA DE LA COLUMNA VERTEBRAL DORSAL, DISMINUIDA"
  },
  {
    "codigo":1279732001,
    "descripcion":"LESIÓN DE RETINA DE OJO DERECHO"
  },
  {
    "codigo":722676004,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE OÍDO MEDIO"
  },
  {
    "codigo":296692007,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE LATAMOXEF"
  },
  {
    "codigo":1148660007,
    "descripcion":"AMPLITUD DE ELECTRORRETINOGRAMA DE FLASH BRILLANTE ÚNICO CON ADAPTACIÓN A LA LUZ ANORMAL"
  },
  {
    "codigo":394996009,
    "descripcion":"EVALUACIÓN DE AUTOMEDICACIÓN - BAJO RIESGO"
  },
  {
    "codigo":131017004,
    "descripcion":"NIVEL DE HORMONA TIROESTIMULANTE POR DEBAJO DE NIVEL DE REFERENCIA"
  },
  {
    "codigo":354651000119102,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE HUESO DE MIEMBRO INFERIOR IZQUIERDO"
  },
  {
    "codigo":260254002,
    "descripcion":"J6"
  },
  {
    "codigo":94579000,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA PIEL"
  },
  {
    "codigo":1144990009,
    "descripcion":"ADHERENCIAS DELGADAS DE FONDO DE SACO DE DOUGLAS DEBIDAS A ENDOMETRIOSIS"
  },
  {
    "codigo":289352001,
    "descripcion":"PELOTEO CEFÁLICO FETAL EN LA REGIÓN SUPRAPÚBICA"
  },
  {
    "codigo":127347009,
    "descripcion":"TRAUMATISMO EN EL AMBIENTE LABORAL"
  },
  {
    "codigo":92744003,
    "descripcion":"CARCINOMA IN SITU DE PIEL DE DEDO DEL PIE"
  },
  {
    "codigo":59976005,
    "descripcion":"ERUCTACIÓN AUMENTADA"
  },
  {
    "codigo":254749001,
    "descripcion":"TUMOR FIBROHISTIOCÍTICO"
  },
  {
    "codigo":1336093007,
    "descripcion":"ENFERMEDAD SEVERA POR DEFICIENCIA HEREDITARIA DE FACTOR IX"
  },
  {
    "codigo":11796981000119102,
    "descripcion":"CONTUSIÓN DE AMBOS PULMONES"
  },
  {
    "codigo":87239004,
    "descripcion":"TROMBOSIS DE ARTERIA POPLÍTEA"
  },
  {
    "codigo":447687004,
    "descripcion":"NEOPLASIA BENIGNA DE PARTES BLANDAS DE LA MANO"
  },
  {
    "codigo":1332423006,
    "descripcion":"HISTIOCITOSIS DE CÉLULAS DE LANGERHANS DISEMINADA DE GANGLIOS LINFÁTICOS DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":414919008,
    "descripcion":"OBESIDAD SEGÚN FACTORES CONTRIBUYENTES"
  },
  {
    "codigo":283847008,
    "descripcion":"LESIÓN POR DESOLLAMIENTO DE REGIÓN PÉLVICA"
  },
  {
    "codigo":52636001,
    "descripcion":"RETICULOIDE ACTÍNICO"
  },
  {
    "codigo":183708003,
    "descripcion":"CONSULTA DOMICILIARIA SOLICITADA"
  },
  {
    "codigo":249244000,
    "descripcion":"HALLAZGO DE PENE"
  },
  {
    "codigo":445852002,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN"
  },
  {
    "codigo":314780006,
    "descripcion":"MELANOSIS CONJUNTIVAL RACIAL"
  },
  {
    "codigo":116337000,
    "descripcion":"HALLAZGO EN LA CAVIDAD BUCAL"
  },
  {
    "codigo":312945001,
    "descripcion":"NEUROPATÍA ÓPTICA INFILTRATIVA"
  },
  {
    "codigo":501000119108,
    "descripcion":"BACTERIEMIA CAUSADA POR BACTERIAS GRAMNEGATIVAS"
  },
  {
    "codigo":50801008,
    "descripcion":"LICUEFACCIÓN VÍTREA"
  },
  {
    "codigo":442182001,
    "descripcion":"ESTUDIO POR IMÁGENES DEL TRACTO GASTROINTESTINAL, ANORMAL"
  },
  {
    "codigo":81734004,
    "descripcion":"MASTITIS PERIDUCTAL"
  },
  {
    "codigo":1163078007,
    "descripcion":"ENCEFALITIS CAUSADA POR ORTHOPOXVIRUS"
  },
  {
    "codigo":79899007,
    "descripcion":"INTERACCIÓN FARMACOLÓGICA"
  },
  {
    "codigo":14363008,
    "descripcion":"SÍNDROME DE COMPRESIÓN DE ARTERIA ESPINAL ANTERIOR"
  },
  {
    "codigo":1259547007,
    "descripcion":"EXTRAVASACIÓN DE LÍQUIDO CEFALORRAQUÍDEO CRANEAL DEBIDA A SÍNDROME DE DEFICIENCIA DE COLÁGENO"
  },
  {
    "codigo":473115007,
    "descripcion":"AFLOJAMIENTO DE IMPLANTE MUSCULOESQUELÉTICO"
  },
  {
    "codigo":241904002,
    "descripcion":"EFECTO TÓXICO CAUSADO POR ADHESIVO DE ACETATO DE POLIVINILO"
  },
  {
    "codigo":372976005,
    "descripcion":"INFECCIÓN CAUSADA POR ASPERGILLUS CANDIDUS"
  },
  {
    "codigo":15676201000119100,
    "descripcion":"TENOSINOVITIS DE AMBOS TOBILLOS"
  },
  {
    "codigo":438512007,
    "descripcion":"RIGIDEZ ABDOMINAL EN REGIÓN PERIUMBILICAL"
  },
  {
    "codigo":209136008,
    "descripcion":"SUBLUXACIÓN NO EXPUESTA DE LA ARTICULACIÓN ATLOOCCIPITAL"
  },
  {
    "codigo":274672009,
    "descripcion":"CAMBIOS EN LA TEXTURA DE LA PIEL"
  },
  {
    "codigo":897264009,
    "descripcion":"CURVATURA ANORMAL DE FALANGE DE PIE"
  },
  {
    "codigo":471280008,
    "descripcion":"COMPONENTE VENTRICULAR RECURRENTE DE DEFECTO DE TABIQUE AURICULOVENTRICULAR DESPUÉS DE PROCEDIMIENTO QUIRÚRGICO CARDIOVASCULAR PREVIO"
  },
  {
    "codigo":403909004,
    "descripcion":"CARCINOMA BASOCELULAR PIGMENTADO"
  },
  {
    "codigo":305605005,
    "descripcion":"BAJO ATENCIÓN DE TERAPEUTA OCUPACIONAL"
  },
  {
    "codigo":240069003,
    "descripcion":"DISTROFIA MUSCULAR PROXIMAL DE INICIO TARDÍO, CON DISARTRIA"
  },
  {
    "codigo":41626001,
    "descripcion":"ÚLCERA GASTROYEYUNAL CRÓNICA SIN HEMORRAGIA, SIN PERFORACIÓN Y SIN OBSTRUCCIÓN"
  },
  {
    "codigo":10924841000119103,
    "descripcion":"FRACTURA CERRADA DE CÓNDILO INTERNO DE TIBIA DERECHA"
  },
  {
    "codigo":860826006,
    "descripcion":"ENFERMEDAD DE CREUTZFELDT-JAKOB CAUSADA POR HORMONA DE CRECIMIENTO HUMANA"
  },
  {
    "codigo":762522008,
    "descripcion":"DOLOR DE PENE Y ESCROTO"
  },
  {
    "codigo":269167000,
    "descripcion":"HERIDA ABIERTA DE LARINGE Y TRÁQUEA"
  },
  {
    "codigo":301935005,
    "descripcion":"HALLAZGO RELACIONADO CON MEDICIONES DE LA CÁMARA ANTERIOR"
  },
  {
    "codigo":203631006,
    "descripcion":"CIFOSIS POSLAMINECTOMÍA"
  },
  {
    "codigo":1119300000,
    "descripcion":"INSUFICIENCIA DE VÁLVULA MITRAL DEBIDA A ANOMALÍA ADQUIRIDA DE APARATO SUBVALVULAR MITRAL"
  },
  {
    "codigo":300100001,
    "descripcion":"EXCORIACIÓN DE PABELLÓN AURICULAR"
  },
  {
    "codigo":236399008,
    "descripcion":"GLOMERULONEFRITIS CON CAMBIO MÍNIMO SENSIBLE A LOS ESTEROIDES"
  },
  {
    "codigo":37956000,
    "descripcion":"ADENOSIS VAGINAL"
  },
  {
    "codigo":201796004,
    "descripcion":"ARTRITIS CRÓNICA JUVENIL DE COMIENZO SISTÉMICO"
  },
  {
    "codigo":365636006,
    "descripcion":"HALLAZGO RELACIONADO CON EL GRUPO SANGUÍNEO"
  },
  {
    "codigo":234564008,
    "descripcion":"ANOMALÍA EN EL CATABOLISMO PRIMARIO DE INMUNOGLOBULINAS"
  },
  {
    "codigo":167193000,
    "descripcion":"PRUEBA DE FUNCIÓN GÁSTRICA, ANORMAL"
  },
  {
    "codigo":298265003,
    "descripcion":"ARTICULACIÓN NORMAL"
  },
  {
    "codigo":36121005,
    "descripcion":"QUEMADURA PROFUNDA DE TERCER GRADO DE LA AXILA"
  },
  {
    "codigo":1518005,
    "descripcion":"ESPLENITIS"
  },
  {
    "codigo":296430006,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE TRIPELENAMINA"
  },
  {
    "codigo":34286007,
    "descripcion":"EMPIEMA CON FÍSTULA HEPATOPLEURAL"
  },
  {
    "codigo":261827001,
    "descripcion":"FÍSTULA ANAL ALTA"
  },
  {
    "codigo":219656000,
    "descripcion":"MORDIDA DENTARIA DÉBIL"
  },
  {
    "codigo":292760002,
    "descripcion":"REACCIÓN ADVERSA A LOS LÍQUIDOS DE DIÁLISIS"
  },
  {
    "codigo":391064004,
    "descripcion":"ABSORCIOMETRÍA DUAL POR RAYOS X DE CALCÁNEO NORMAL"
  },
  {
    "codigo":63384009,
    "descripcion":"DISTORSIÓN DE LA IMAGEN CORPORAL"
  },
  {
    "codigo":127085002,
    "descripcion":"LINFADENOPATÍA SUBMANDIBULAR"
  },
  {
    "codigo":94317006,
    "descripcion":"NEOPLASIA MALIGNA SECUNDARIA DEL NERVIO GLOSOFARÍNGEO"
  },
  {
    "codigo":290925006,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR TRAZODONA"
  },
  {
    "codigo":289090001,
    "descripcion":"DIFICULTAD PARA COLOCAR AL BEBÉ AL PECHO PARA AMAMANTARLO"
  },
  {
    "codigo":190786004,
    "descripcion":"HIPOBETALIPOPROTEINEMIA"
  },
  {
    "codigo":59714007,
    "descripcion":"PROTEINOSIS"
  },
  {
    "codigo":1237527003,
    "descripcion":"METÁSTASIS DE CARCINOMA DE HUESO DE ESTERNÓN"
  },
  {
    "codigo":140381000119104,
    "descripcion":"ÚLCERA DE DEDO DE PIE NEUROPÁTICA DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":188951005,
    "descripcion":"NEOPLASIA BENIGNA DE HUESO GANCHOSO"
  },
  {
    "codigo":449260004,
    "descripcion":"NEOPLASIA MALIGNA DE ALVÉOLO DENTAL"
  },
  {
    "codigo":1268460005,
    "descripcion":"CARCINOMA DE PARATIROIDES PRIMARIO"
  },
  {
    "codigo":23276006,
    "descripcion":"HEMORRAGIA INTRAVENTRICULAR"
  },
  {
    "codigo":285420006,
    "descripcion":"MIELOMA POR IGA"
  },
  {
    "codigo":15950941000119107,
    "descripcion":"MELANOMA MALIGNO DE PIEL DE PIE IZQUIERDO"
  },
  {
    "codigo":283585004,
    "descripcion":"HERIDA DE PERDIGÓN EN PIERNA"
  },
  {
    "codigo":185281005,
    "descripcion":"ATENDIDO POR UNA ENFERMERA DE ATENCIÓN PRIMARIA"
  },
  {
    "codigo":54209007,
    "descripcion":"SÍNDROME DE DISPLASIA ECTODÉRMICA HIDRÓTICA"
  },
  {
    "codigo":1363094002,
    "descripcion":"ASTILLA EN CADERA"
  },
  {
    "codigo":707734002,
    "descripcion":"NIVEL DE ENZIMAS HEPÁTICAS POR ENCIMA DEL RANGO DE REFERENCIA DEBIDO A FIBROSIS QUÍSTICA"
  },
  {
    "codigo":773270005,
    "descripcion":"HERNIA PERINEAL CON GANGRENA"
  },
  {
    "codigo":10681591000119103,
    "descripcion":"MASA DE PIEL DE DEDO DE AMBAS MANOS"
  },
  {
    "codigo":248982007,
    "descripcion":"HALLAZGO RELACIONADO CON EL EMBARAZO, PARTO Y PUERPERIO"
  },
  {
    "codigo":871574008,
    "descripcion":"REACCIÓN ADVERSA A CLOMOCICLINA"
  },
  {
    "codigo":687351000119103,
    "descripcion":"OLIGODENDROGLIOMA PRIMARIO DE LÓBULO PARIETAL"
  },
  {
    "codigo":216214008,
    "descripcion":"LESIÓN POR PROPULSOR A HÉLICE DE AERONAVE, SIN ACCIDENTE DE AERONAVE, MIEMBRO DE TRIPULACIÓN DE AERONAVE COMERCIAL EN TRANSPORTE POR TIERRA Y MAR LESIONADO"
  },
  {
    "codigo":247147005,
    "descripcion":"ATROFIA MACULAR DIFUSA"
  },
  {
    "codigo":441920005,
    "descripcion":"SOMBRA RADIOGRÁFICA DEL CORAZÓN, ANORMAL"
  },
  {
    "codigo":724744002,
    "descripcion":"PARAFILIA QUE AFECTA A INDIVIDUO QUE NO OTORGA SU CONSENTIMIENTO"
  },
  {
    "codigo":704064007,
    "descripcion":"FRACTURA POR ESTRÉS DE MANO"
  },
  {
    "codigo":81472005,
    "descripcion":"ENFERMEDAD POR EL VIRUS OSSA"
  },
  {
    "codigo":309013001,
    "descripcion":"DERIVADO POR UNA PERSONA"
  },
  {
    "codigo":333201000119100,
    "descripcion":"CORIORRETINITIS FOCAL PERIFÉRICA DERECHA"
  },
  {
    "codigo":472853005,
    "descripcion":"ESTENOSIS DE VÁLVULA AURICULOVENTRICULAR COMÚN FETAL"
  },
  {
    "codigo":276245005,
    "descripcion":"ESTADO DE ÁNIMO PERPLEJO NO DELIRANTE"
  },
  {
    "codigo":866069006,
    "descripcion":"NEOPLASIA MALIGNA DE VAINA NERVIOSA DE NERVIO PERIFÉRICO DE ABDOMEN"
  },
  {
    "codigo":897002001,
    "descripcion":"FORMA DE BALA ANORMAL CONGÉNITA DE FALANGE MEDIA DE DEDO DE MANO"
  },
  {
    "codigo":733162002,
    "descripcion":"NEOPLASIA NEUROENDOCRINA MALIGNA PRIMARIA DE ANO"
  },
  {
    "codigo":1193749009,
    "descripcion":"ENTERITIS POR VIBRIO CHOLERAE"
  },
  {
    "codigo":307178006,
    "descripcion":"FRACTURA CONMINUTA DE RÓTULA"
  },
  {
    "codigo":208874009,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE MÚLTIPLES DÍGITOS"
  },
  {
    "codigo":87441000119104,
    "descripcion":"ÚLCERA DE TOBILLO DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":272575004,
    "descripcion":"POSICIÓN DE FLOTACIÓN EN DECÚBITO DORSAL"
  },
  {
    "codigo":764095005,
    "descripcion":"SÍNDROME DE LEUCOENCEFALOPATÍA, ATAXIA, HIPODONCIA E HIPOMIELINIZACIÓN"
  },
  {
    "codigo":403647006,
    "descripcion":"ESTRÍAS POR CORTICOSTEROIDES"
  },
  {
    "codigo":205204000,
    "descripcion":"DEFICIENCIA TRANSVERSA DE EXTREMIDAD INFERIOR - NIVEL METATARSIANO"
  },
  {
    "codigo":74132001,
    "descripcion":"EFECTO TÓXICO DE DICLORODIFENILTRICLOROETANO"
  },
  {
    "codigo":239807009,
    "descripcion":"ARTRITIS REACTIVA JUVENIL"
  },
  {
    "codigo":762260000,
    "descripcion":"CARCINOMA LOBULAR PLEOMÓRFICO IN SITU DE MAMA"
  },
  {
    "codigo":237972006,
    "descripcion":"TRASTORNO DE LA ABSORCIÓN DE CARBOHIDRATOS"
  },
  {
    "codigo":41364008,
    "descripcion":"RECTOSIGMOIDITIS"
  },
  {
    "codigo":236137002,
    "descripcion":"FORMACIÓN DE CÁLCULO EN ESTOMA"
  },
  {
    "codigo":60971000119101,
    "descripcion":"RETINOPATÍA PROLIFERATIVA DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":6761005,
    "descripcion":"ÚLCERA DUODENAL HIPERGASTRINÉMICA FAMILIAR"
  },
  {
    "codigo":301673007,
    "descripcion":"DIFICULTAD PARA ACOSTARSE EN UNA CAMA"
  },
  {
    "codigo":201534002,
    "descripcion":"ARTROPATÍA ASOCIADA CON MICOSIS: REGIÓN DEL HOMBRO"
  },
  {
    "codigo":70462005,
    "descripcion":"ADAPTACIÓN A LAS BAJAS TEMPERATURAS"
  },
  {
    "codigo":299838007,
    "descripcion":"REFLEJO SUPINADOR NORMAL"
  },
  {
    "codigo":4926007,
    "descripcion":"ESQUIZOFRENIA EN REMISIÓN"
  },
  {
    "codigo":396307000,
    "descripcion":"INVASIÓN MIOMETRIAL POR TUMOR, AUSENTE"
  },
  {
    "codigo":298003002,
    "descripcion":"HALLAZGO RELACIONADO CON EL ASPECTO DE LA MUCOSA NASAL"
  },
  {
    "codigo":365374008,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA JUGAR"
  },
  {
    "codigo":39951000087100,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE GLÚTEO DERECHO"
  },
  {
    "codigo":429075005,
    "descripcion":"DEPENDENCIA DE DIÁLISIS POR ENFERMEDAD RENAL EN ESTADIO TERMINAL"
  },
  {
    "codigo":42511000087101,
    "descripcion":"HERIDA DE GENITALES EXTERNOS POR MORDEDURA"
  },
  {
    "codigo":68627009,
    "descripcion":"ESTRECHEZ ANORRECTAL"
  },
  {
    "codigo":294333007,
    "descripcion":"ALERGIA A CARBÓMERO 940"
  },
  {
    "codigo":63122002,
    "descripcion":"SÍNDROME DE HAJDU - CHENEY"
  },
  {
    "codigo":292498003,
    "descripcion":"REACCIÓN ADVERSA A LA ORCIPRENALINA"
  },
  {
    "codigo":1144466003,
    "descripcion":"APLASIA DE FALANGE DISTAL DE DEDO PULGAR"
  },
  {
    "codigo":15926981000119103,
    "descripcion":"LESIÓN BILATERAL DE PÁRPADOS SUPERIORES"
  },
  {
    "codigo":95890006,
    "descripcion":"ENDOCARDITIS POR FIEBRE Q"
  },
  {
    "codigo":390802008,
    "descripcion":"OBJETIVO ALCANZADO"
  },
  {
    "codigo":126823001,
    "descripcion":"NEOPLASIA DEL TERCIO INFERIOR DEL ESÓFAGO"
  },
  {
    "codigo":716647001,
    "descripcion":"OLIGOASTROCITOMA MIXTO"
  },
  {
    "codigo":94055006,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE PARTES BLANDAS DE CADERA"
  },
  {
    "codigo":419900000,
    "descripcion":"DISTROFIA CORNEAL GELATINOSA TIPO GOTA"
  },
  {
    "codigo":421735009,
    "descripcion":"PIGMENTACIÓN OCULAR DE MELANINA"
  },
  {
    "codigo":190524001,
    "descripcion":"INSUFICIENCIA CORTICOSUPRARRENAL INDUCIDA POR FÁRMACOS"
  },
  {
    "codigo":92220004,
    "descripcion":"NEOPLASIA BENIGNA DE LA GLÁNDULA SALIVAL MENOR"
  },
  {
    "codigo":124988006,
    "descripcion":"ALTERACIÓN DE LA MEIOSIS"
  },
  {
    "codigo":254225000,
    "descripcion":"ALOPECIA CONGÉNITA CON QUISTES DE QUERATINA"
  },
  {
    "codigo":286993001,
    "descripcion":"DISMENORREA NO PSICÓGENA"
  },
  {
    "codigo":288828008,
    "descripcion":"DIFICULTAD PARA IMITAR PALABRAS"
  },
  {
    "codigo":745745001,
    "descripcion":"CUMPLE CON EL MANEJO DEL BALANCE DE LÍQUIDOS"
  },
  {
    "codigo":876817004,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DEL PENE CON INFECCIÓN"
  },
  {
    "codigo":712977006,
    "descripcion":"LESIÓN TRAUMÁTICA DE RECTO DURANTE PROCEDIMIENTO QUIRÚRGICO"
  },
  {
    "codigo":88550004,
    "descripcion":"INTOXICACIÓN POR CYMOPTERUS WATSONII"
  },
  {
    "codigo":23014006,
    "descripcion":"ACTINOMICOSIS CERVICOFACIAL"
  },
  {
    "codigo":186854007,
    "descripcion":"UVEÍTIS POR SÍFILIS SECUNDARIA"
  },
  {
    "codigo":86715000,
    "descripcion":"TALASEMIA BETA CERO"
  },
  {
    "codigo":414395005,
    "descripcion":"TRASTORNO HEREDITARIO DE GLÓBULOS BLANCOS"
  },
  {
    "codigo":283323005,
    "descripcion":"PICADURA DE INSECTO EN LA FRENTE"
  },
  {
    "codigo":335711000119105,
    "descripcion":"BLEFAROCONJUNTIVITIS DE OJO DERECHO POR CONTACTO"
  },
  {
    "codigo":445328000,
    "descripcion":"PÁPULA CUTÁNEA"
  },
  {
    "codigo":838544003,
    "descripcion":"INSUFICIENCIA DE VÁLVULA AÓRTICA LEVE"
  },
  {
    "codigo":248720007,
    "descripcion":"SOPLO DEL FLUJO TIROIDEO"
  },
  {
    "codigo":1264528008,
    "descripcion":"OSTEÓLISIS DE HUESO ADYACENTE A PRÓTESIS DE ARTICULACIÓN DE RODILLA"
  },
  {
    "codigo":50277001,
    "descripcion":"INFECCIÓN CAUSADA POR IODAMOEBA"
  },
  {
    "codigo":707472008,
    "descripcion":"ADENOCARCINOMA PAPILAR PRIMARIO DE TRÁQUEA"
  },
  {
    "codigo":443493003,
    "descripcion":"MELANOMA MALIGNO MESTASTÁSICO"
  },
  {
    "codigo":1197157004,
    "descripcion":"MIOPATÍA NEMALÍNICA CONGÉNITA GRAVE"
  },
  {
    "codigo":212282001,
    "descripcion":"LESIÓN EXPUESTA, NERVIO DIGITAL EN DEDO DE LA MANO"
  },
  {
    "codigo":703802001,
    "descripcion":"ANGIOEDEMA ADQUIRIDO DEBIDO A AUTOANTICUERPO INHIBIDOR DE C1"
  },
  {
    "codigo":408890007,
    "descripcion":"CON MAYOR RIESGO DE DISFUNCIÓN ESPIRITUAL"
  },
  {
    "codigo":13839000,
    "descripcion":"SÍNDROME DE BERNHEIM"
  },
  {
    "codigo":277818007,
    "descripcion":"ANGUSTIA POR PERDER EL CONTROL INTESTINAL"
  },
  {
    "codigo":441658007,
    "descripcion":"NEUMONÍA CAUSADA POR STAPHYLOCOCCUS AUREUS"
  },
  {
    "codigo":767503006,
    "descripcion":"EXPECTATIVA DE VIDA LIMITADA A UN AÑO APROXIMADAMENTE"
  },
  {
    "codigo":275983007,
    "descripcion":"INMUNIZACIÓN ANTIGRIPAL RECOMENDADA"
  },
  {
    "codigo":470756000,
    "descripcion":"ANTROLITO DE SENO MAXILAR"
  },
  {
    "codigo":112143006,
    "descripcion":"FENOTIPO DEL SUBGRUPO ABO"
  },
  {
    "codigo":896740003,
    "descripcion":"FORMA DE CONO ANORMAL CONGÉNITA DE EPÍFISIS DE FALANGE MEDIA DE DEDO DE MANO"
  },
  {
    "codigo":208612003,
    "descripcion":"FRACTURA NO EXPUESTA DE TIBIA PROXIMAL, BICONDÍLEA"
  },
  {
    "codigo":306916006,
    "descripcion":"MOVILIDAD AUMENTADA DEL TÍMPANO"
  },
  {
    "codigo":403385000,
    "descripcion":"LINFEDEMA DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":700132008,
    "descripcion":"DERIVACIÓN VENTRICULOPERITONEAL IN SITU"
  },
  {
    "codigo":763833006,
    "descripcion":"SÍNDROME OROFACIODIGITAL TIPO 1"
  },
  {
    "codigo":10958841000119108,
    "descripcion":"HERIDA ABIERTA DE MANO IZQUIERDA DEBIDA A MORDEDURA"
  },
  {
    "codigo":1351822002,
    "descripcion":"COLANGIOGRAFÍA FLUOROSCÓPICA POSOPERATORIA CON CONTRASTE NORMAL"
  },
  {
    "codigo":237710002,
    "descripcion":"GRANULOMA HIPOFISARIO"
  },
  {
    "codigo":204942005,
    "descripcion":"AGENESIA RENAL"
  },
  {
    "codigo":399715001,
    "descripcion":"SITIO TUMORAL, INDETERMINADO"
  },
  {
    "codigo":1153379006,
    "descripcion":"LEUCEMIA AGUDA DE FENOTIPO MIXTO CON LINAJE DE LINFOCITOS T Y MIELOIDE"
  },
  {
    "codigo":1217080000,
    "descripcion":"PUBERTAD PRECOZ MASCULINA CON HIPERPLASIA SUPRARRENAL"
  },
  {
    "codigo":235875008,
    "descripcion":"HEPATITIS ALCOHÓLICA"
  },
  {
    "codigo":301411008,
    "descripcion":"DOLOR A LA PALPACIÓN EN FOSA ILÍACA IZQUIERDA"
  },
  {
    "codigo":102968003,
    "descripcion":"POTENCIAL EVOCADO VISUAL ANORMAL"
  },
  {
    "codigo":234040003,
    "descripcion":"TROMBOFLEBITIS DE VENA SAFENA"
  },
  {
    "codigo":299576008,
    "descripcion":"HALLAZGO RELACIONADO CON ARTICULACIÓN DE DEDO DEL PIE"
  },
  {
    "codigo":451431000124104,
    "descripcion":"TRASTORNO DE EXTREMIDAD INFERIOR IZQUIERDA"
  },
  {
    "codigo":365112008,
    "descripcion":"HALLAZGO EN EL USO DE UN DISPOSITIVO ORTOPÉDICO"
  },
  {
    "codigo":453991000124107,
    "descripcion":"FRACTURA DE HUESO DE MIEMBRO INFERIOR DERECHO"
  },
  {
    "codigo":1075501000119101,
    "descripcion":"PELLIZCAMIENTO DEL ACETÁBULO FEMORAL DE CADERA IZQUIERDA"
  },
  {
    "codigo":2829000,
    "descripcion":"ENFERMEDAD DE UHL"
  },
  {
    "codigo":92461000119101,
    "descripcion":"LESIÓN DE ENDOMETRIO"
  },
  {
    "codigo":166669000,
    "descripcion":"NIVEL SÉRICO DE ASPARTATO AMINOTRANSFERASA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":164834001,
    "descripcion":"PRUEBA MUSCULOESQUELÉTICA ANORMAL"
  },
  {
    "codigo":230370006,
    "descripcion":"ENFERMEDAD DE PELIZAEUS-MERZBACHER ATÍPICA TIPO V"
  },
  {
    "codigo":295906006,
    "descripcion":"SOBREDOSIS DE MOCLOBEMIDA"
  },
  {
    "codigo":292236000,
    "descripcion":"REACCIÓN ADVERSA A LA AMSACRINA"
  },
  {
    "codigo":95628005,
    "descripcion":"ENCEFALOPATÍA NEONATAL"
  },
  {
    "codigo":718220008,
    "descripcion":"SÍNDROME DE CÁNCER MAMARIO Y OVÁRICO HEREDITARIO"
  },
  {
    "codigo":93793002,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL NERVIO FACIAL"
  },
  {
    "codigo":192097003,
    "descripcion":"TRASTORNO EXPLOSIVO AISLADO"
  },
  {
    "codigo":126561007,
    "descripcion":"NEOPLASIA DE HUESO PÉLVICO"
  },
  {
    "codigo":290401009,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR CAOLÍN"
  },
  {
    "codigo":91958007,
    "descripcion":"NEOPLASIA BENIGNA DEL ESÓFAGO ABDOMINAL"
  },
  {
    "codigo":57355001,
    "descripcion":"NÓDULOS VOCALES EN LOS ADULTOS"
  },
  {
    "codigo":286731006,
    "descripcion":"CARÁCTER OBSTINADO"
  },
  {
    "codigo":253963009,
    "descripcion":"FOCOMELIA DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":55520003,
    "descripcion":"COMPRESIÓN VASCULAR DEL ESÓFAGO POR ARTERIA SUBCLAVIA DERECHA ABERRANTE ORIGINADA DE LA AORTA DESCENDENTE"
  },
  {
    "codigo":776416004,
    "descripcion":"SÍNDROME DE HIPERURICEMIA, HIPERTENSIÓN PULMONAR, INSUFICIENCIA RENAL Y ALCALOSIS"
  },
  {
    "codigo":219360006,
    "descripcion":"LESIÓN ACCIDENTAL O DELIBERADA NO DETERMINADA, POR CHOQUE VEHICULAR"
  },
  {
    "codigo":284896008,
    "descripcion":"SE MAQUILLA"
  },
  {
    "codigo":283061002,
    "descripcion":"ABRASIÓN DE LOS GENITALES"
  },
  {
    "codigo":20917003,
    "descripcion":"GLOMERULONEFRITIS CRÓNICA"
  },
  {
    "codigo":367201000119101,
    "descripcion":"TIROIDITIS CAUSADA POR AMIODARONA"
  },
  {
    "codigo":184757008,
    "descripcion":"SOLICITUD DE PERMISO PARA PORTACIÓN DE ESCOPETA - HONORARIOS PAGADOS"
  },
  {
    "codigo":446901009,
    "descripcion":"VERRUGA VULGAR DE PIEL DE PABELLÓN AURICULAR"
  },
  {
    "codigo":414133009,
    "descripcion":"DIVERTÍCULO ESOFÁGICO"
  },
  {
    "codigo":445066006,
    "descripcion":"LINFOSTASIS"
  },
  {
    "codigo":707210006,
    "descripcion":"DERMATOSIS AMPOLLAR INTRAEPIDÉRMICA"
  },
  {
    "codigo":1231498007,
    "descripcion":"DESVIACIÓN MODERADA DE LÍNEA MEDIA DE ARCO DENTAL MAXILAR HACIA LA DERECHA"
  },
  {
    "codigo":84618009,
    "descripcion":"TRASTORNO DEL METABOLISMO DEL PROPIONATO Y\/O METILMALONATO"
  },
  {
    "codigo":1196895002,
    "descripcion":"NEOPLASIA EPITELIAL BENIGNA DE INTESTINO GRUESO"
  },
  {
    "codigo":1295199003,
    "descripcion":"TUMOR CARTILAGINOSO ATÍPICO"
  },
  {
    "codigo":246623008,
    "descripcion":"OJO PEREZOSO"
  },
  {
    "codigo":48180002,
    "descripcion":"SÍNDROME OTOCEFÁLICO"
  },
  {
    "codigo":1162292003,
    "descripcion":"INFLAMACIÓN DE DISCO INTERVERTEBRAL CAUSADA POR MYCOBACTERIUM"
  },
  {
    "codigo":15686241000119106,
    "descripcion":"ARTRITIS REUMATOIDE DE AMBAS ARTICULACIONES ESCAPULOHUMERALES"
  },
  {
    "codigo":703540008,
    "descripcion":"OSTEOMIELITIS MULTIFOCAL RECURRENTE CRÓNICA, ANEMIA DISERITROPOYÉTICA CONGÉNITA Y DERMATOSIS NEUTROFÍLICA"
  },
  {
    "codigo":77278008,
    "descripcion":"INSERCIÓN VELAMENTOSA DEL CORDÓN UMBILICAL"
  },
  {
    "codigo":403123003,
    "descripcion":"DERMATOMICOSIS DISEMINADA CAUSADA POR PENICILLIUM"
  },
  {
    "codigo":1077161000119100,
    "descripcion":"QUISTE ÓSEO DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":11831721000119101,
    "descripcion":"LACERACIÓN DE VASO SANGUÍNEO DE PULGAR DERECHO"
  },
  {
    "codigo":206138281000119100,
    "descripcion":"ENFERMEDAD DE CROHN DE RECTO EN REMISIÓN"
  },
  {
    "codigo":10858921000119103,
    "descripcion":"HERIDA ABIERTA DE PARED TORÁCICA DERECHA DEBIDA A MORDEDURA HUMANA"
  },
  {
    "codigo":1087401000119104,
    "descripcion":"HERNIA PARAESTOMAL INCARCERADA"
  },
  {
    "codigo":314281000119102,
    "descripcion":"MIOSITIS OSIFICANTE TRAUMÁTICA DE MANO DERECHA"
  },
  {
    "codigo":11865001000119104,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO DE PIERNA IZQUIERDA"
  },
  {
    "codigo":319401000119107,
    "descripcion":"LUXACIÓN RECURRENTE DE REGIÓN ARTICULAR DE HOMBRO DERECHO"
  },
  {
    "codigo":345001000119108,
    "descripcion":"HIFEMA ESPONTÁNEO DE AMBOS OJOS"
  },
  {
    "codigo":145321000119108,
    "descripcion":"MASA PAPILAR DE VÍA BILIAR"
  },
  {
    "codigo":11824041000119108,
    "descripcion":"CONTUSIÓN DE REGIÓN AXILAR DERECHA"
  },
  {
    "codigo":12201000119102,
    "descripcion":"DESPROPORCIÓN PÉLVICA DEBIDA A PELVIS CONTRAÍDA"
  },
  {
    "codigo":698035007,
    "descripcion":"DISARMONÍA EN EL CONTORNO GINGIVAL"
  },
  {
    "codigo":237448006,
    "descripcion":"ACTINOMICOSIS MAMARIA"
  },
  {
    "codigo":301149000,
    "descripcion":"HALLAZGO DE RITMO DEL PULSO"
  },
  {
    "codigo":268381001,
    "descripcion":"FLUJO RESPIRATORIO ANORMAL"
  },
  {
    "codigo":91561000119109,
    "descripcion":"PARASOMNIA CAUSADA POR FÁRMACO"
  },
  {
    "codigo":1251421004,
    "descripcion":"PSORIASIS PUSTULAR DE PALMA Y PLANTA CAUSADA POR FÁRMACO"
  },
  {
    "codigo":235613006,
    "descripcion":"ÚLCERA DE ESÓFAGO CAUSADA POR RADIACIÓN"
  },
  {
    "codigo":299314000,
    "descripcion":"PRUEBA DE THOMAS NEGATIVA"
  },
  {
    "codigo":366685008,
    "descripcion":"AMPLITUD DE MOVIMIENTO ACTIVO DE ADUCCIÓN DE DEDO DE LA MANO - HALLAZGO"
  },
  {
    "codigo":233778002,
    "descripcion":"FÍSTULA TRAQUEAL"
  },
  {
    "codigo":397618002,
    "descripcion":"DEMUESTRA ADECUADO CONTROL DEL DOLOR DURANTE EL PERÍODO PERIOPERATORIO"
  },
  {
    "codigo":364850007,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA BRINCAR"
  },
  {
    "codigo":231943000,
    "descripcion":"LESIÓN TRAUMÁTICA DE CÓRNEA POR TEMPERATURA Y POR RADIACIÓN"
  },
  {
    "codigo":199175001,
    "descripcion":"TUBERCULOSIS DE LA MADRE QUE COMPLICA EL EMBARAZO, PARTO Y\/O PUERPERIO"
  },
  {
    "codigo":788999001,
    "descripcion":"MORDEDURA ABIERTA DE PULGAR"
  },
  {
    "codigo":16206741000119104,
    "descripcion":"SÍNDROME PIRIFORME DE AMBOS MIEMBROS INFERIORES"
  },
  {
    "codigo":1149447000,
    "descripcion":"PERIODONTITIS LOCALIZADA ESTADIO 1 GRADO B SEGÚN LA CLASIFICACIÓN DE LAS ENFERMEDADES Y ALTERACIONES PERIODONTALES Y PERIIMPLANTARIAS DE 2017 DE LA ACADEMIA ESTADOUNIDENSE DE PERIODONTOLOGÍA Y LA FEDERACIÓN EUROPEA DE PERIODONTOLOGÍA"
  },
  {
    "codigo":363015005,
    "descripcion":"COMPLICACIÓN DE PROCEDIMIENTO DE OBSERVACIÓN"
  },
  {
    "codigo":721628002,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE UNIÓN ESOFAGOGÁSTRICA"
  },
  {
    "codigo":295644004,
    "descripcion":"SOBREDOSIS DE NITROSOUREA"
  },
  {
    "codigo":262876009,
    "descripcion":"HEMATOMA RECTAL"
  },
  {
    "codigo":64433002,
    "descripcion":"POSICIÓN SACROILÍACA IZQUIERDA ANTERIOR"
  },
  {
    "codigo":228273003,
    "descripcion":"HALLAZGO RELACIONADO CON LA CONDUCTA DE CONSUMO DE ALCOHOL"
  },
  {
    "codigo":717958000,
    "descripcion":"CÁLCULO DE VÍA URINARIA SUPERIOR"
  },
  {
    "codigo":95366000,
    "descripcion":"IRRITACIÓN DEL SITIO DE APLICACIÓN"
  },
  {
    "codigo":193670002,
    "descripcion":"ESCOTOMA DE PUNTO CIEGO"
  },
  {
    "codigo":160902002,
    "descripcion":"TRABAJA DESPUÉS DE LA JUBILACIÓN"
  },
  {
    "codigo":128134005,
    "descripcion":"TRASTORNO DE TROMPA DE FALOPIO"
  },
  {
    "codigo":1142107003,
    "descripcion":"ENFERMEDAD DE BEHÇET NEONATAL TRANSITORIA"
  },
  {
    "codigo":93531004,
    "descripcion":"GRANULOMA DE HODGKIN DE GANGLIOS LINFÁTICOS INTRATORÁCICOS"
  },
  {
    "codigo":879963005,
    "descripcion":"EXACERBACIÓN DE BRONQUIECTASIA POR INFECCIÓN"
  },
  {
    "codigo":124464003,
    "descripcion":"DEFICIENCIA DE ALFA - GALACTOSIDASA"
  },
  {
    "codigo":1236741000,
    "descripcion":"ESTRÉS PARENTAL"
  },
  {
    "codigo":450309001,
    "descripcion":"ARTERIA COLATERAL MAYOR QUE DERIVA EL FLUJO SISTÉMICO HACIA LA CIRCULACIÓN PULMONAR QUE IRRIGA PARTE DEL PULMÓN DERECHO"
  },
  {
    "codigo":286469002,
    "descripcion":"DIFICULTAD PARA CORTAR ALIMENTOS"
  },
  {
    "codigo":417541007,
    "descripcion":"DADO DE ALTA DE LA ATENCIÓN DEL GERENCIADOR DE CASOS"
  },
  {
    "codigo":11838511000119108,
    "descripcion":"LACERACIÓN DE MÚSCULO INTRÍNSECO DE DEDO MEDIO DE MANO IZQUIERDA"
  },
  {
    "codigo":16016431000119108,
    "descripcion":"RUPTURA CRÓNICA DE LIGAMENTOS CRUZADOS ANTERIORES DE AMBAS RODILLAS"
  },
  {
    "codigo":22490002,
    "descripcion":"SANGRADO PROVENIENTE DE LA BOCA"
  },
  {
    "codigo":89861008,
    "descripcion":"INFECCIÓN CAUSADA POR CLOSTRIDIUM PERFRINGENS TIPO B"
  },
  {
    "codigo":1169370004,
    "descripcion":"TIROXINA EN SUERO POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":284634005,
    "descripcion":"PELLIZCAR A OTRA PERSONA"
  },
  {
    "codigo":343241000119102,
    "descripcion":"DESPRENDIMIENTO COMPLETO DE AMBAS RETINAS"
  },
  {
    "codigo":86191000,
    "descripcion":"ENDARTERITIS RETINIANA"
  },
  {
    "codigo":1234906009,
    "descripcion":"ANOMALÍA DEL DESARROLLO SEXUAL 46,XX OVOTESTICULAR"
  },
  {
    "codigo":315567002,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: BENGALÍ"
  },
  {
    "codigo":609544007,
    "descripcion":"HIPERSENSIBILIDAD NO ALÉRGICA A QUINAPRIL"
  },
  {
    "codigo":282799007,
    "descripcion":"LESIÓN DE GANGLIO CILIAR"
  },
  {
    "codigo":1003695009,
    "descripcion":"MIGRACIÓN TRANSPERITONEAL DE CIGOTO"
  },
  {
    "codigo":84356002,
    "descripcion":"PRODUCCIÓN NORMAL DE EOSINÓFILOS"
  },
  {
    "codigo":117124002,
    "descripcion":"CARACTERÍSTICA DEL SOPLO CARDÍACO, VIBRANTE"
  },
  {
    "codigo":1296772004,
    "descripcion":"SOBREDOSIS AGUDA DE PSICOESTIMULANTE"
  },
  {
    "codigo":248196002,
    "descripcion":"FACIES PATOGNOMÓNICA"
  },
  {
    "codigo":280964006,
    "descripcion":"EMBOLIA GASEOSA PULMONAR"
  },
  {
    "codigo":18820007,
    "descripcion":"QUISTE PREAURICULAR"
  },
  {
    "codigo":311897005,
    "descripcion":"HOYUELO SACRO"
  },
  {
    "codigo":16985007,
    "descripcion":"ESTADO DE AYUNO"
  },
  {
    "codigo":1080521000119108,
    "descripcion":"CARCINOMA DE CÉLULAS GRANDES PRIMARIO DE LÓBULO MEDIO DE PULMÓN DERECHO"
  },
  {
    "codigo":408366001,
    "descripcion":"INCAPAZ DE UTILIZAR MEDICACIÓN"
  },
  {
    "codigo":703278006,
    "descripcion":"VÍA VENOSA SISTÉMICA OBSTRUIDA DESPUÉS DE PROCEDIMIENTO"
  },
  {
    "codigo":1260334009,
    "descripcion":"DISTONÍA DEBIDA A SÍNDROME DE ATAXIA TELANGIECTASIA"
  },
  {
    "codigo":441134009,
    "descripcion":"TROMBOCITOPENIA DISMEGACARIOPOYÉTICA CONGÉNITA, TIPO PARIS TROUSSEAU"
  },
  {
    "codigo":766979005,
    "descripcion":"CARCINOMA ESCAMOCELULAR DE RECTO"
  },
  {
    "codigo":1356803007,
    "descripcion":"DAÑO DE ARTICULACIÓN DE PARED PÉLVICA"
  },
  {
    "codigo":406531009,
    "descripcion":"EL PACIENTE SOLICITA VER SUS REGISTROS MÉDICOS PERSONALES"
  },
  {
    "codigo":44248001,
    "descripcion":"SÍNDROME DE RAYMOND - CESTAN"
  },
  {
    "codigo":240856003,
    "descripcion":"PRURITO DEBIDO A STRONGYLOIDES"
  },
  {
    "codigo":11480007,
    "descripcion":"NEFROPATÍA INTERSTICIAL IDIOPÁTICA GRANULOMATOSA"
  },
  {
    "codigo":109784009,
    "descripcion":"CELULITIS DEL ESPACIO MASTICATORIO DE LA BOCA"
  },
  {
    "codigo":271789005,
    "descripcion":"VÉRTIGO Y MAREOS"
  },
  {
    "codigo":75181005,
    "descripcion":"HIPOTENSIÓN ARTERIAL ORTOSTÁTICA CRÓNICA"
  },
  {
    "codigo":239021007,
    "descripcion":"HIPODONCIA Y DISGÉNESIS UNGUEAL"
  },
  {
    "codigo":402861007,
    "descripcion":"GANGRENA ISQUÉMICA"
  },
  {
    "codigo":206253009,
    "descripcion":"LESIÓN OBSTÉTRICA DE LA CARA"
  },
  {
    "codigo":763309005,
    "descripcion":"LEUCEMIA MIELOIDE AGUDA CON MUTACIÓN SOMÁTICA DE NPM1"
  },
  {
    "codigo":7810004,
    "descripcion":"TRASTORNO POR ALMACENAMIENTO DE GLUCOPROTEÍNAS"
  },
  {
    "codigo":16782691000119109,
    "descripcion":"MELANOMA IN SITU DE PIEL DE MENTÓN"
  },
  {
    "codigo":237186006,
    "descripcion":"ESTENOSIS DEL CUELLO DEL ÚTERO EN EL EMBARAZO, PARTO Y PUERPERIO"
  },
  {
    "codigo":202583001,
    "descripcion":"OSTEOCONDROMATOSIS SINOVIAL DE ARTICULACIÓN INTERFALÁNGICA DISTAL DE DEDO DE LA MANO"
  },
  {
    "codigo":300887003,
    "descripcion":"TUMEFACCIÓN DE ESTRUCTURA MUSCULOESQUELÉTICA"
  },
  {
    "codigo":169815003,
    "descripcion":"UNIDAD CONSULTORA EN PARTO"
  },
  {
    "codigo":366423005,
    "descripcion":"AMPLITUD DE LA ROTACIÓN IZQUIERDA DE COLUMNA DORSAL - HALLAZGO"
  },
  {
    "codigo":725036000,
    "descripcion":"HIPOPARATIROIDISMO AISLADO FAMILIAR"
  },
  {
    "codigo":67841000,
    "descripcion":"VITILIGO DEL IRIS"
  },
  {
    "codigo":297217002,
    "descripcion":"DOLOR COSTAL"
  },
  {
    "codigo":262614000,
    "descripcion":"CUERPO EXTRAÑO EN URETRA MASCULINA"
  },
  {
    "codigo":229846002,
    "descripcion":"RETROPIÉ VARO CONGÉNITO"
  },
  {
    "codigo":295382002,
    "descripcion":"SOBREDOSIS INTENCIONAL DE CARBENOXOLONA"
  },
  {
    "codigo":470004,
    "descripcion":"SÍNDROME DEL TOQUE VÍTREO"
  },
  {
    "codigo":197078006,
    "descripcion":"OBSTRUCCIÓN INTESTINAL AGUDA"
  },
  {
    "codigo":721366007,
    "descripcion":"LESIÓN COMPLETA DE MÉDULA ESPINAL AL NIVEL DEL CUARTO SEGMENTO CERVICAL"
  },
  {
    "codigo":360918006,
    "descripcion":"NO FUMADOR AGRESIVO"
  },
  {
    "codigo":162475001,
    "descripcion":"SÍNTOMA QUE EMPEORA CON EL ALIMENTO"
  },
  {
    "codigo":64171002,
    "descripcion":"COMPLICACIÓN CARDÍACA OBSTÉTRICA POR LA ANESTESIA Y\/O LA SEDACIÓN"
  },
  {
    "codigo":195243003,
    "descripcion":"SECUELAS DE INFARTO CEREBRAL"
  },
  {
    "codigo":1145515001,
    "descripcion":"APLASIA DE FALANGE DE DEDO MEDIO DE MANO"
  },
  {
    "codigo":293547000,
    "descripcion":"REACCIÓN ADVERSA AL AEROSOL DE TRINITRATO DE GLICERILO"
  },
  {
    "codigo":129707006,
    "descripcion":"CON MAYOR RIESGO DE VIOLENCIA HACIA TERCEROS"
  },
  {
    "codigo":345751000119105,
    "descripcion":"QUISTE IDIOPÁTICO DE CUERPO CILIAR DE AMBOS OJOS"
  },
  {
    "codigo":717696001,
    "descripcion":"TEMOR A COMPLICACIONES DEL EMBARAZO"
  },
  {
    "codigo":160640002,
    "descripcion":"EJERCICIO ANAERÓBICO, NINGUNA VEZ POR SEMANA"
  },
  {
    "codigo":422784003,
    "descripcion":"CONSISTENCIA DE LAS DEPOSICIONES, ANORMAL"
  },
  {
    "codigo":1209216006,
    "descripcion":"TRASTORNO DE ENTESIS DE REGIÓN DE TOBILLO"
  },
  {
    "codigo":95104007,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE PARTES BLANDAS DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":715861004,
    "descripcion":"DISPLASIA DE LA CABEZA DE FÉMUR TIPO MEYER"
  },
  {
    "codigo":289877007,
    "descripcion":"PERINEO FEMENINO LAXO"
  },
  {
    "codigo":93269008,
    "descripcion":"HIPOPLASIA CONGÉNITA DEL ISQUION"
  },
  {
    "codigo":126037009,
    "descripcion":"RUPTURA AÓRTICA TRAUMÁTICA"
  },
  {
    "codigo":91434003,
    "descripcion":"INSUFICIENCIA DE VÁLVULA PULMONAR"
  },
  {
    "codigo":124202004,
    "descripcion":"DEFICIENCIA DE CATALASA"
  },
  {
    "codigo":25898005,
    "descripcion":"DIARREA SECRETORA CONGÉNITA"
  },
  {
    "codigo":1303850003,
    "descripcion":"REACCIÓN ADVERSA A COMPONENTE DE VACUNA QUE CONTIENE ANTÍGENO DE VIRUS DE ENCEFALITIS TRANSMITIDA POR GARRAPATAS"
  },
  {
    "codigo":11788081000119103,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DE DEDO ANULAR IZQUIERDO"
  },
  {
    "codigo":286207000,
    "descripcion":"INCAPAZ DE GESTICULAR AL HABLAR"
  },
  {
    "codigo":187903000,
    "descripcion":"NEOPLASIA MALIGNA DE HUESO MALAR"
  },
  {
    "codigo":24063002,
    "descripcion":"FRACTURA DE BASE DE CRÁNEO"
  },
  {
    "codigo":417279003,
    "descripcion":"TRASTORNO DREPANOCÍTICO POR HEMOGLOBINA S CON CRISIS HEMOLÍTICA"
  },
  {
    "codigo":1269247005,
    "descripcion":"INFECCIÓN DE TRACTO GENITAL FEMENINO DEBIDA A ABORTO INCOMPLETO"
  },
  {
    "codigo":253439006,
    "descripcion":"HENDIDURA VERDADERA DE VALVA DE VÁLVULA AURICULOVENTRICULAR COMÚN"
  },
  {
    "codigo":87764000,
    "descripcion":"SÍNDROME DE FOSTER - KENNEDY"
  },
  {
    "codigo":249769001,
    "descripcion":"DEDOS DE LA MANO MEMBRANOSOS"
  },
  {
    "codigo":448212009,
    "descripcion":"LINFOMA ANAPLÁSICO DE CÉLULAS GRANDES, ALK-NEGATIVO"
  },
  {
    "codigo":128971000119101,
    "descripcion":"CRIOGLOBULINEMIA DEBIDA A HEPATITIS C CRÓNICA"
  },
  {
    "codigo":282537005,
    "descripcion":"INCAPAZ DE EMPEZAR A CORRER"
  },
  {
    "codigo":73521000119108,
    "descripcion":"FRACTURA NO EXPUESTA DE PARED INTERNA DE ÓRBITA"
  },
  {
    "codigo":1003433008,
    "descripcion":"ROTACIÓN ANÓMALA DE INTESTINO DELGADO"
  },
  {
    "codigo":247934004,
    "descripcion":"SACUDIR LAS MANOS CERCA DE LOS OJOS"
  },
  {
    "codigo":12115761000119109,
    "descripcion":"QUEMADURA QUÍMICA DE DEDO DE PIE DERECHO"
  },
  {
    "codigo":1263742008,
    "descripcion":"ESPONDILÓLISIS DE REGIÓN LUMBOSACRA"
  },
  {
    "codigo":84094009,
    "descripcion":"HIPERTENSIÓN POR REBOTE"
  },
  {
    "codigo":442707000,
    "descripcion":"HALLAZGO RELACIONADO CON DIFERENCIA EN LA ATENUACIÓN RADIOGRÁFICA EN COMPARACIÓN CON EXAMEN RADIOLÓGICO PREVIO"
  },
  {
    "codigo":834566091000119104,
    "descripcion":"TELANGIECTASIA DE MÁCULA LÚTEA DE OJO DERECHO"
  },
  {
    "codigo":277032005,
    "descripcion":"SIN DISMINUCIÓN DE LA AMPLITUD"
  },
  {
    "codigo":703016007,
    "descripcion":"TRYPANOSOMA BRUCEI GAMBIENSE O TRYPANOSOMA BRUCEI RHODESIENSE"
  },
  {
    "codigo":768552007,
    "descripcion":"DEFECTO CONGÉNITO DEL TABIQUE INTERVENTRICULAR"
  },
  {
    "codigo":735784009,
    "descripcion":"LACERACIÓN DE ESTÓMAGO CONCOMITANTE CON PERFORACIÓN"
  },
  {
    "codigo":111357002,
    "descripcion":"DIVERTICULOSIS DEL YEYUNO SIN DIVERTICULITIS"
  },
  {
    "codigo":1260072008,
    "descripcion":"CARCINOMA PSEUDOSARCOMATOSO DE PULMÓN"
  },
  {
    "codigo":733949002,
    "descripcion":"CARIES DENTAL PRIMARIA INACTIVA QUE SE EXTIENDE HASTA LA MITAD EXTERNA DEL ESMALTE"
  },
  {
    "codigo":209661005,
    "descripcion":"SECCIÓN EXPUESTA DE LIGAMENTO DE CODO"
  },
  {
    "codigo":292811000119108,
    "descripcion":"COMPRESIÓN DE NERVIO MEDIANO DERECHO A LA ALTURA DEL CODO"
  },
  {
    "codigo":766717008,
    "descripcion":"DISPLASIA EPIFISARIA MÚLTIPLE DEBIDA A ANOMALÍA EN EL COLÁGENO TIPO 9"
  },
  {
    "codigo":109522008,
    "descripcion":"MICROGENIA"
  },
  {
    "codigo":699346009,
    "descripcion":"SÍNDROME DE PREDISPOSICIÓN HEREDITARIA AL CÁNCER"
  },
  {
    "codigo":304295002,
    "descripcion":"AMPLITUD DE MOVIMIENTO DE HOMBRO NORMAL"
  },
  {
    "codigo":1156263003,
    "descripcion":"HALLAZGO RELACIONADO CON TIEMPO DE FIBRINÓLISIS"
  },
  {
    "codigo":1287335000,
    "descripcion":"CARCINOMA DE CÉLULAS DE MERKEL PRIMARIO DE PIEL DE MIEMBRO INFERIOR DERECHO"
  },
  {
    "codigo":402599005,
    "descripcion":"ACANTOSIS NIGRICANS"
  },
  {
    "codigo":240594008,
    "descripcion":"INFECCIÓN GENITAL POR MICOPLASMA"
  },
  {
    "codigo":271527007,
    "descripcion":"NEOPLASIA BENIGNA DE HÍGADO Y VÍAS BILIARES"
  },
  {
    "codigo":7548000,
    "descripcion":"NEUMONITIS REUMÁTICA"
  },
  {
    "codigo":1252732001,
    "descripcion":"NÓDULO DE PIEL DE ANTEBRAZO IZQUIERDO"
  },
  {
    "codigo":74919005,
    "descripcion":"ESTRECHEZ CONGÉNITA DE URÉTER"
  },
  {
    "codigo":894119008,
    "descripcion":"CUADRANTOPSIA HOMÓNIMA INFERIOR DERECHA"
  },
  {
    "codigo":1085541000119106,
    "descripcion":"EDENTULISMO COMPLETO DE CLASE I DEBIDO A ENFERMEDAD PERIODONTAL"
  },
  {
    "codigo":321791000119100,
    "descripcion":"ARTRITIS ESTAFILOCÓCICA DE ARTICULACIÓN INTERVERTEBRAL"
  },
  {
    "codigo":202321000,
    "descripcion":"ANQUILOSIS DE LA ARTICULACIÓN METATARSOFALÁNGICA"
  },
  {
    "codigo":15749221000119107,
    "descripcion":"INESTABILIDAD DE ARTICULACIÓN SACROILÍACA DERECHA"
  },
  {
    "codigo":235089002,
    "descripcion":"SUPERPOSICIÓN REDUCIDA"
  },
  {
    "codigo":366161004,
    "descripcion":"HALLAZGO EN LA PRESIÓN VENOSA"
  },
  {
    "codigo":726609005,
    "descripcion":"PARAPLEJÍA ESPÁSTICA AUTOSÓMICA RECESIVA TIPO 64"
  },
  {
    "codigo":38481006,
    "descripcion":"NEFROPATÍA HIPERTENSIVA"
  },
  {
    "codigo":300625006,
    "descripcion":"DIFICULTAD PARA VIAJAR EN TRANSPORTE PÚBLICO"
  },
  {
    "codigo":298790000,
    "descripcion":"SIN AMPLITUD DE MOVIMIENTO ACTIVO DE EXTENSIÓN DE HOMBRO"
  },
  {
    "codigo":167718001,
    "descripcion":"LCR: LEUCOCITOSIS POLIMORFONUCLEAR"
  },
  {
    "codigo":1281830005,
    "descripcion":"OBSTRUCCIÓN DE TROMPA DE FALOPIO DISTAL DERECHA"
  },
  {
    "codigo":36646009,
    "descripcion":"ANSIEDAD ANTICIPATORIA, MODERADA"
  },
  {
    "codigo":722939004,
    "descripcion":"HIPOTIROIDISMO CONGÉNITO DEBIDO A DEFICIENCIA DE YODO"
  },
  {
    "codigo":1148923005,
    "descripcion":"GLOMERULOESCLEROSIS NODULAR IDIOPÁTICA"
  },
  {
    "codigo":788475005,
    "descripcion":"TRASTORNO REPETITIVO DEL MOVIMIENTO DEL BRAZO DERECHO"
  },
  {
    "codigo":721104000,
    "descripcion":"SEPSIS DEBIDA A INFECCIÓN DE LA VÍA URINARIA"
  },
  {
    "codigo":2043009,
    "descripcion":"GASTRITIS ALCOHÓLICA"
  },
  {
    "codigo":428027008,
    "descripcion":"ARTROPATÍA DE LA CADERA INDUCIDA POR CRISTALES"
  },
  {
    "codigo":293285001,
    "descripcion":"REACCIÓN ADVERSA A LA OXITOCINA"
  },
  {
    "codigo":162213003,
    "descripcion":"LLANTO EXCESIVO"
  },
  {
    "codigo":31141004,
    "descripcion":"INTOXICACIÓN POR PIRETRINAS"
  },
  {
    "codigo":63909006,
    "descripcion":"TRASTORNO DE PÁNICO CON AGORAFOBIA Y ATAQUES DE PÁNICO EN REMISIÓN PARCIAL"
  },
  {
    "codigo":225914005,
    "descripcion":"RESPIRACIÓN BURBUJEANTE"
  },
  {
    "codigo":93007000,
    "descripcion":"ANOMALÍA CONGÉNITA DE HUESO INTERPARIETAL"
  },
  {
    "codigo":94842009,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL PISO DE LA BOCA"
  },
  {
    "codigo":291450009,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR QUININA"
  },
  {
    "codigo":62074008,
    "descripcion":"TALASEMIA DELTA CERO"
  },
  {
    "codigo":1010511004,
    "descripcion":"ESCLEROSIS DE EPÍFISIS DE FALANGE MEDIA DE DEDO DE MANO CON RADIOPACIDAD AUMENTADA"
  },
  {
    "codigo":224079004,
    "descripcion":"OBSERVANCIA DE PRÁCTICAS RELIGIOSAS"
  },
  {
    "codigo":289615008,
    "descripcion":"LESIÓN DE HIMEN"
  },
  {
    "codigo":123940002,
    "descripcion":"INTOXICACIÓN POR ANACARDIACEAE"
  },
  {
    "codigo":417075004,
    "descripcion":"ENFERMEDAD NEUROINVASORA POR VIRUS DE LA ENCEFALITIS DE CALIFORNIA"
  },
  {
    "codigo":25636008,
    "descripcion":"CONDUCTOR EN ACCIDENTE DE EMBARCACIÓN"
  },
  {
    "codigo":255012009,
    "descripcion":"MELANOMA MALIGNO DE IRIS"
  },
  {
    "codigo":417017003,
    "descripcion":"SÍNDROME CEREBELOSO AGUDO"
  },
  {
    "codigo":285945003,
    "descripcion":"DIFICULTAD PARA MANEJAR LOS CONTROLES DE LA DUCHA"
  },
  {
    "codigo":253177006,
    "descripcion":"AGENESIA DEL VERMIS"
  },
  {
    "codigo":284110001,
    "descripcion":"INCAPAZ DE CONTROLAR LA POSICIÓN DE LA CABEZA"
  },
  {
    "codigo":449785009,
    "descripcion":"ENCÍA ADHERIDA DELGADA"
  },
  {
    "codigo":187641009,
    "descripcion":"NEOPLASIA MALIGNA DE FRENILLO LINGUAL"
  },
  {
    "codigo":415182001,
    "descripcion":"ENDOFTALMITIS POR PROPIONIBACTERIUM ACNES"
  },
  {
    "codigo":710094002,
    "descripcion":"DENTICIÓN COMPLETA SUSTANCIALMENTE COMPROMETIDA CON 4 O MÁS EN 3-5 SEXTANTES"
  },
  {
    "codigo":678451000119103,
    "descripcion":"GLAUCOMA DE OJO DERECHO POR PRESIÓN VENOSA EPIESCLERAL AUMENTADA"
  },
  {
    "codigo":251342007,
    "descripcion":"HALLAZGO DE LA PRUEBA DERMATOLÓGICA"
  },
  {
    "codigo":216739003,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR FUMIGANTE"
  },
  {
    "codigo":118435004,
    "descripcion":"HALLAZGO RELACIONADO CON EL INTESTINO DELGADO"
  },
  {
    "codigo":249507004,
    "descripcion":"EXPULSA FLATOS MALOLIENTES"
  },
  {
    "codigo":413347006,
    "descripcion":"HALLAZGO DE LA CLASIFICACIÓN DEL ESTADO FÍSICO DE LA SOCIEDAD ESTADOUNIDENSE DE ANESTESISTAS"
  },
  {
    "codigo":52899007,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DE MIEMBRO INFERIOR"
  },
  {
    "codigo":83832001,
    "descripcion":"LEUCODISTROFIA METACROMÁTICA SIN DEFICIENCIA DE ARILSULFATASA"
  },
  {
    "codigo":870264004,
    "descripcion":"TRASTORNO GENERALIZADO DEL DESARROLLO CON TRASTORNO DEL DESARROLLO INTELECTUAL Y ALTERACIÓN GENERALIZADA DEL LENGUAJE FUNCIONAL SIN PÉRDIDA DE HABILIDADES ADQUIRIDAS PREVIAMENTE"
  },
  {
    "codigo":18296004,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA ARTERIA OVÁRICA"
  },
  {
    "codigo":247672006,
    "descripcion":"HUMOR DELIRANTE"
  },
  {
    "codigo":49229003,
    "descripcion":"DÉJÀ ENTENDU"
  },
  {
    "codigo":1228877003,
    "descripcion":"VOLUMEN DE LÍQUIDO AMNIÓTICO POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1359949003,
    "descripcion":"COCOS GRAMPOSITIVOS EN PARES"
  },
  {
    "codigo":278605004,
    "descripcion":"PUENTE DENTAL FLOJO"
  },
  {
    "codigo":309538000,
    "descripcion":"ENTUMECIMIENTO DEL PIE"
  },
  {
    "codigo":409677009,
    "descripcion":"FIEBRE HEMORRÁGICA POR DENGUE, GRADO II"
  },
  {
    "codigo":1259810001,
    "descripcion":"PARAGANGLIOMA PRIMARIO MALIGNO DE OÍDO MEDIO"
  },
  {
    "codigo":735522008,
    "descripcion":"ESTADIO CLÍNICO 1 DE INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA DE LA ORGANIZACIÓN MUNDIAL DE LA SALUD DE 2007 CONCOMITANTE CON PALUDISMO"
  },
  {
    "codigo":702754009,
    "descripcion":"DEFORMIDAD DE CÓNDILO MANDIBULAR"
  },
  {
    "codigo":897527002,
    "descripcion":"DELECIÓN DISTAL DEL BRAZO LARGO DEL CROMOSOMA 9"
  },
  {
    "codigo":12791003,
    "descripcion":"DISCRONISMO DEL BIORRITMO"
  },
  {
    "codigo":209399005,
    "descripcion":"FRACTURA-SUBLUXACIÓN NO EXPUESTA DEL ESTERNÓN"
  },
  {
    "codigo":1290743007,
    "descripcion":"ARTRITIS REACTIVA DE ARTICULACIÓN DE PARED PÉLVICA DEBIDA A ENFERMEDAD INFECCIOSA TRANSMITIDA POR VÍA SEXUAL Y POSTERIOR A ELLA"
  },
  {
    "codigo":109260000,
    "descripcion":"MUCOSITIS POR CONTACTO SUBAGUDA"
  },
  {
    "codigo":404172001,
    "descripcion":"LEUCEMIA MASTOCÍTICA QUE AFECTA LA PIEL"
  },
  {
    "codigo":43724002,
    "descripcion":"ESCALOFRÍOS"
  },
  {
    "codigo":406007008,
    "descripcion":"HAPLOTIPO CDE"
  },
  {
    "codigo":240332005,
    "descripcion":"GASTROENTERITIS INFANTIL"
  },
  {
    "codigo":305868007,
    "descripcion":"ATENDIDO EN EL SERVICIO DE PSIQUIATRÍA DE ENLACE"
  },
  {
    "codigo":76492009,
    "descripcion":"MIOPATÍA DE CAMBIO MÍNIMO"
  },
  {
    "codigo":324301000119107,
    "descripcion":"ARTROPATÍA DEBIDA A TRASTORNO METABÓLICO"
  },
  {
    "codigo":238497004,
    "descripcion":"GRANULOMA DEL ESQUILADOR"
  },
  {
    "codigo":41889008,
    "descripcion":"HEPATITIS CRÓNICA PERSISTENTE"
  },
  {
    "codigo":1186934000,
    "descripcion":"CUIDADOR DE PERSONA DEPENDIENTE CON DISCAPACIDAD INTELECTUAL"
  },
  {
    "codigo":402337009,
    "descripcion":"PSORIASIS FAMILIAR SIN FAMILIAR DE PRIMER GRADO AFECTADO"
  },
  {
    "codigo":40054001,
    "descripcion":"INTOXICACIÓN POR GÉNERO HYMENOXYS"
  },
  {
    "codigo":1156001008,
    "descripcion":"SOBREDOSIS DE TETRACICLINA ANTIBACTERIANA"
  },
  {
    "codigo":16026471000119103,
    "descripcion":"TRASTORNO DE NERVIO SUPRAESCAPULAR DERECHO"
  },
  {
    "codigo":365899000,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA RECORDAR OBJETOS"
  },
  {
    "codigo":1119563002,
    "descripcion":"DORSO NASAL ANCHO"
  },
  {
    "codigo":241800007,
    "descripcion":"EFECTO TÓXICO CAUSADO POR ALFACLORALOSA"
  },
  {
    "codigo":726347008,
    "descripcion":"TRISOMÍA PARCIAL DE CROMOSOMA 8"
  },
  {
    "codigo":298528001,
    "descripcion":"SIN AMPLITUD DE EXTENSIÓN PASIVA DE LA COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":429600003,
    "descripcion":"INFECCIÓN CAUSADA POR BRUCELLA SUIS"
  },
  {
    "codigo":724512004,
    "descripcion":"HIPERPLASIA PAPILAR DE LA MUCOSA BUCAL"
  },
  {
    "codigo":394997000,
    "descripcion":"EVALUACIÓN DE AUTOMEDICACIÓN - RIESGO MODERADO"
  },
  {
    "codigo":296693002,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE LATAMOXEF"
  },
  {
    "codigo":1148661006,
    "descripcion":"FRECUENCIA DE ELECTRORRETINOGRAMA DE FLASH BRILLANTE ÚNICO CON ADAPTACIÓN A LA LUZ ANORMAL"
  },
  {
    "codigo":1279733006,
    "descripcion":"ROTURA DE RETINA DE OJO IZQUIERDO"
  },
  {
    "codigo":722677008,
    "descripcion":"MESOTELIOMA PRIMARIO DE LESIÓN SUPERPUESTA DE RETROPERITONEO, PERITONEO Y EPIPLÓN"
  },
  {
    "codigo":1090561000119102,
    "descripcion":"ESTENOSIS ADQUIRIDA DE CONDUCTO AUDITIVO EXTERNO DERECHO"
  },
  {
    "codigo":131018009,
    "descripcion":"HORMONA FOLICULOESTIMULANTE HIPOFISARIA ANORMAL"
  },
  {
    "codigo":260255001,
    "descripcion":"J8"
  },
  {
    "codigo":293023003,
    "descripcion":"REACCIÓN ADVERSA A LA CLINDAMICINA"
  },
  {
    "codigo":11822081000119105,
    "descripcion":"SUBLUXACIÓN DE ARTICULACIÓN DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":719007008,
    "descripcion":"POSITIVO PARA PROTEÍNA TUMORAL P53"
  },
  {
    "codigo":94580002,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL INTESTINO DELGADO"
  },
  {
    "codigo":291188000,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR PROMAZINA"
  },
  {
    "codigo":127348004,
    "descripcion":"VÍCTIMA DE UN ACCIDENTE AUTOMOVILÍSTICO"
  },
  {
    "codigo":1144991008,
    "descripcion":"AMENORREA DEBIDA A TRASTORNO OVÁRICO"
  },
  {
    "codigo":225652009,
    "descripcion":"AUSENCIA DE RESPUESTA EMOCIONAL"
  },
  {
    "codigo":92745002,
    "descripcion":"CARCINOMA IN SITU DE LA PIEL DEL TRONCO"
  },
  {
    "codigo":715337002,
    "descripcion":"INFECCIÓN CONGÉNITA CAUSADA POR VIRUS HERPES"
  },
  {
    "codigo":289353006,
    "descripcion":"PELOTEO CEFÁLICO FETAL, A TRAVÉS DE LA VAGINA"
  },
  {
    "codigo":254750001,
    "descripcion":"HISTIOCITOMA FIBROSO CUTÁNEO"
  },
  {
    "codigo":58142005,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA VENA BRAQUIAL"
  },
  {
    "codigo":25374005,
    "descripcion":"GASTROENTERITIS"
  },
  {
    "codigo":418590005,
    "descripcion":"LEIOMIOMA DE IRIS"
  },
  {
    "codigo":449523002,
    "descripcion":"VENA CAVA SUPERIOR DERECHA PERSISTENTE A SENO CORONARIO Y POSTERIORMENTE A AURÍCULA EN EL LADO DERECHO"
  },
  {
    "codigo":285683004,
    "descripcion":"CAPAZ DE CARGAR PESO EN LA PIERNA DERECHA"
  },
  {
    "codigo":416755008,
    "descripcion":"EXTENDIDO CERVICAL UNA VEZ POR AÑO DURANTE TODA LA VIDA"
  },
  {
    "codigo":414920002,
    "descripcion":"OBESIDAD SEGÚN PATRÓN DE DISTRIBUCIÓN DE GRASA"
  },
  {
    "codigo":283848003,
    "descripcion":"LESIÓN POR DESOLLAMIENTO DE PERINEO"
  },
  {
    "codigo":251080003,
    "descripcion":"TENSIÓN ARTERIAL LÁBIL"
  },
  {
    "codigo":21704002,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM KANSASII"
  },
  {
    "codigo":1363357000,
    "descripcion":"ATROFIA DE PARTES BLANDAS DE ÓRBITA IZQUIERDA"
  },
  {
    "codigo":447688009,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE VULVA"
  },
  {
    "codigo":282013001,
    "descripcion":"AMPOLLA DE FRACTURA"
  },
  {
    "codigo":314781005,
    "descripcion":"LIPODERMOIDE CONJUNTIVAL"
  },
  {
    "codigo":183709006,
    "descripcion":"CONSULTA DOMICILIARIA DE MEDICINA GENERAL SOLICITADA"
  },
  {
    "codigo":312946000,
    "descripcion":"SÍNDROME DE TERSON"
  },
  {
    "codigo":216477008,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR FENACETINA"
  },
  {
    "codigo":1197682003,
    "descripcion":"FÍSTULA DE INTESTINO DELGADO POR DIVERTICULITIS"
  },
  {
    "codigo":247410004,
    "descripcion":"TOS DOLOROSA"
  },
  {
    "codigo":116338005,
    "descripcion":"HALLAZGO FARÍNGEO"
  },
  {
    "codigo":1163079004,
    "descripcion":"POLINEUROPATÍA CAUSADA POR CITOMEGALOVIRUS 5 HUMANO"
  },
  {
    "codigo":442183006,
    "descripcion":"DISCINESIA PSICÓGENA"
  },
  {
    "codigo":276508000,
    "descripcion":"HIDROPESÍA FETAL"
  },
  {
    "codigo":735260000,
    "descripcion":"ATENDIDA EN UNIDAD DE EVALUACIÓN TEMPRANA DEL EMBARAZO"
  },
  {
    "codigo":1259548002,
    "descripcion":"CARCINOMA BASOCELULAR PRIMARIO - MICRONODULAR"
  },
  {
    "codigo":241905001,
    "descripcion":"ADHESIVO PARA EMPAPELAR PAREDES QUE CAUSA EFECTOS TÓXICOS"
  },
  {
    "codigo":438513002,
    "descripcion":"DEGENERACIÓN CEREBRAL POR ENFERMEDAD DE PARKINSON"
  },
  {
    "codigo":10677711000119101,
    "descripcion":"ENCEFALOPATÍA CAUSADA POR VIRUS INFLUENZA A"
  },
  {
    "codigo":274673004,
    "descripcion":"HIPERHIDROSIS GENERALIZADA"
  },
  {
    "codigo":372977001,
    "descripcion":"INFECCIÓN CAUSADA POR ASPERGILLUS CARNEUS"
  },
  {
    "codigo":12529006,
    "descripcion":"RALES ESPIRATORIOS"
  },
  {
    "codigo":471281007,
    "descripcion":"MUTACIÓN PUNTUAL"
  },
  {
    "codigo":209137004,
    "descripcion":"SUBLUXACIÓN NO EXPUESTA DE LA ARTICULACIÓN ATLOAXOIDEA"
  },
  {
    "codigo":240070002,
    "descripcion":"DISTROFIA MUSCULAR CON DISTRIBUCIÓN NO PREDOMINANTE EN CINTURA DE EXTREMIDAD"
  },
  {
    "codigo":305606006,
    "descripcion":"BAJO ATENCIÓN DE TERAPEUTA OCUPACIONAL COMUNITARIO"
  },
  {
    "codigo":1155739001,
    "descripcion":"INTOXICACIÓN POR AMINOGLUCÓSIDO ANTIBACTERIANO"
  },
  {
    "codigo":860827002,
    "descripcion":"EOSINOPENIA DEBIDA A ENFERMEDAD INFECCIOSA"
  },
  {
    "codigo":762523003,
    "descripcion":"CUERPO EXTRAÑO MAGNÉTICO RETENIDO EN OJO IZQUIERDO"
  },
  {
    "codigo":403910009,
    "descripcion":"CARCINOMA BASOCELULAR SÓLIDO CIRCUNSCRIPTO"
  },
  {
    "codigo":74395007,
    "descripcion":"FRACTURA EXPUESTA DE FALANGE DEL PIE"
  },
  {
    "codigo":236400001,
    "descripcion":"GLOMERULONEFRITIS CON CAMBIO MÍNIMO RESISTENTE A LOS ESTEROIDES"
  },
  {
    "codigo":301936006,
    "descripcion":"CÁMARA ANTERIOR DEL OJO: NORMAL"
  },
  {
    "codigo":169029001,
    "descripcion":"TOMOGRAFÍA NORMAL"
  },
  {
    "codigo":300101002,
    "descripcion":"SANGRADO DE PABELLÓN AURICULAR"
  },
  {
    "codigo":365637002,
    "descripcion":"HALLAZGO RELACIONADO CON EL GRUPO SANGUÍNEO ABO"
  },
  {
    "codigo":234565009,
    "descripcion":"HIPERCATABOLISMO DE INMUNOGLOBULINAS"
  },
  {
    "codigo":5189009,
    "descripcion":"INTOXICACIÓN POR NALORFINA"
  },
  {
    "codigo":68890003,
    "descripcion":"TRASTORNO ESQUIZOAFECTIVO"
  },
  {
    "codigo":1519002,
    "descripcion":"FLEBECTASIA CONGÉNITA"
  },
  {
    "codigo":34287003,
    "descripcion":"ENFERMEDAD DE ROSAI-DORFMAN"
  },
  {
    "codigo":296431005,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE TRIPELENAMINA"
  },
  {
    "codigo":294596002,
    "descripcion":"ALERGIA A ATOVACUONA"
  },
  {
    "codigo":720580006,
    "descripcion":"RESISTENCIA A FÁRMACO ANTINEOPLÁSICO"
  },
  {
    "codigo":391065003,
    "descripcion":"RESULTADO DE ABSORCIOMETRÍA DUAL POR RAYOS X DE CALCÁNEO, OSTEOPOROSIS"
  },
  {
    "codigo":292761003,
    "descripcion":"REACCIÓN ADVERSA A SOLUCIÓN PARA DIÁLISIS PERITONEAL"
  },
  {
    "codigo":194457007,
    "descripcion":"SECUELAS DE TRASTORNOS INFLAMATORIOS DEL SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":15648361000119108,
    "descripcion":"ANEURISMA DE ARTERIA CARÓTIDA INTERNA DERECHA"
  },
  {
    "codigo":127086001,
    "descripcion":"LINFADENOPATÍA CERVICAL"
  },
  {
    "codigo":421998001,
    "descripcion":"TRASTORNO DEL SISTEMA NERVIOSO CENTRAL CON SIDA (SÍNDROME DE INMUNODEFICIENCIA ADQUIRIDA)"
  },
  {
    "codigo":94318001,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA GLOTIS"
  },
  {
    "codigo":92483002,
    "descripcion":"NEOPLASIA BENIGNA DE LA PLEURA VISCERAL"
  },
  {
    "codigo":26947005,
    "descripcion":"HERIDA ABIERTA DE LA EXTREMIDAD INFERIOR"
  },
  {
    "codigo":715075005,
    "descripcion":"INFECCIÓN CAUSADA POR EURYTREMA"
  },
  {
    "codigo":190787008,
    "descripcion":"ABETALIPOPROTEINEMIA"
  },
  {
    "codigo":188952003,
    "descripcion":"NEOPLASIA BENIGNA DE METACARPIANO"
  },
  {
    "codigo":418328005,
    "descripcion":"REACCIÓN ADVERSA AL ÁCIDO NALIDÍXICO"
  },
  {
    "codigo":685981000119100,
    "descripcion":"LIPOSARCOMA PRIMARIO DE PARTES BLANDAS DE TRONCO"
  },
  {
    "codigo":1237528008,
    "descripcion":"METÁSTASIS DE CARCINOMA DE HUESO DE CLAVÍCULA"
  },
  {
    "codigo":88813005,
    "descripcion":"CISTITIS GONOCÓCICA CRÓNICA"
  },
  {
    "codigo":285421005,
    "descripcion":"MIELOMA POR IGG"
  },
  {
    "codigo":1268461009,
    "descripcion":"COLANGIOCARCINOMA PRIMARIO DE VÍA BILIAR"
  },
  {
    "codigo":185282003,
    "descripcion":"ATENDIDO POR UNA OBSTÉTRICA"
  },
  {
    "codigo":283586003,
    "descripcion":"HERIDA DE PERDIGÓN EN ESPINILLA"
  },
  {
    "codigo":840642008,
    "descripcion":"COMPRIMIDO EN MATERIA FECAL"
  },
  {
    "codigo":1363095001,
    "descripcion":"ASTILLA EN CADERA CON INFECCIÓN"
  },
  {
    "codigo":871575009,
    "descripcion":"REACCIÓN ADVERSA A MECLOZINA"
  },
  {
    "codigo":738668004,
    "descripcion":"COMPLICACIÓN PERIOPERATORIA"
  },
  {
    "codigo":312684008,
    "descripcion":"CRIBADO PARA LA DETECCIÓN ANTICUERPOS ANTI-D NEGATIVO"
  },
  {
    "codigo":1162817000,
    "descripcion":"SOBREDOSIS DE LITIO Y\/O COMPUESTO DE LITIO"
  },
  {
    "codigo":704065008,
    "descripcion":"FRACTURA POR ESTRÉS DE PIE"
  },
  {
    "codigo":734998001,
    "descripcion":"VÍCTIMA DE TRÁFICO DE PERSONAS"
  },
  {
    "codigo":472854004,
    "descripcion":"INSUFICIENCIA DE VÁLVULA TRONCAL FETAL"
  },
  {
    "codigo":309014007,
    "descripcion":"DERIVADO POR UN MÉDICO"
  },
  {
    "codigo":866070007,
    "descripcion":"NEOPLASIA MALIGNA MESENQUIMÁTICA DE CONDUCTO BILIAR"
  },
  {
    "codigo":1193750009,
    "descripcion":"INFLAMACIÓN INTESTINAL POR VIBRIO CHOLERAE"
  },
  {
    "codigo":15978551000119104,
    "descripcion":"MIELOPATÍA DE COLUMNA VERTEBRAL DORSOLUMBAR DEBIDA A TRASTORNO DE DISCO"
  },
  {
    "codigo":274411003,
    "descripcion":"BRONCODILATADORES UTILIZADOS UNA VEZ POR DÍA"
  },
  {
    "codigo":897003006,
    "descripcion":"FORMA DE BALA ANORMAL CONGÉNITA DE FALANGE DISTAL DE MANO"
  },
  {
    "codigo":733163007,
    "descripcion":"NEOPLASIA NEUROENDOCRINA MALIGNA PRIMARIA DE CONDUCTO ANAL"
  },
  {
    "codigo":77803008,
    "descripcion":"FRACTURA NO EXPUESTA DE DIÁFISIS DE PERONÉ"
  },
  {
    "codigo":403648001,
    "descripcion":"ESTRÍAS DEBIDAS A TRATAMIENTO CON CORTICOSTEROIDES TÓPICOS"
  },
  {
    "codigo":272576003,
    "descripcion":"ACOSTADO EN DECÚBITO VENTRAL EN EL AGUA"
  },
  {
    "codigo":75968004,
    "descripcion":"SÍNDROME DE SOTOS"
  },
  {
    "codigo":239808004,
    "descripcion":"TRÍADA DE ARTRITIS REACTIVA JUVENIL"
  },
  {
    "codigo":764096006,
    "descripcion":"INFERTILIDAD MASCULINA CON TERATOZOOSPERMIA DEBIDA A MUTACIÓN DE UN SOLO GEN"
  },
  {
    "codigo":762261001,
    "descripcion":"ALBUMINURIA PERSISTENTE"
  },
  {
    "codigo":6762003,
    "descripcion":"ALTERACIÓN EN EL TRANSPORTE INTESTINAL DE AMINOÁCIDOS A TRAVÉS DE LAS CÉLULAS EPITELIALES"
  },
  {
    "codigo":331831000119109,
    "descripcion":"DESPRENDIMIENTO TOTAL DE RETINA DERECHA"
  },
  {
    "codigo":37695001,
    "descripcion":"HIPERMETIONINEMIA NEONATAL"
  },
  {
    "codigo":4927003,
    "descripcion":"UVEÍTIS ANTERIOR AGUDA"
  },
  {
    "codigo":305361000119104,
    "descripcion":"CONTRACTURA DE MÚSCULO DE REGIÓN DE TOBILLO DERECHO"
  },
  {
    "codigo":299839004,
    "descripcion":"REFLEJO SUPINADOR ACTIVO"
  },
  {
    "codigo":365375009,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA RESISTIR PENSAMIENTOS OBSESIVOS"
  },
  {
    "codigo":68628004,
    "descripcion":"QUEMADURA EPIDÉRMICA DE DEDO DEL PIE"
  },
  {
    "codigo":396308005,
    "descripcion":"INVASIÓN MIOMETRIAL POR TUMOR, PRESENTE"
  },
  {
    "codigo":298004008,
    "descripcion":"LESIÓN DE MUCOSA NASAL"
  },
  {
    "codigo":66793004,
    "descripcion":"AUSENCIA CONGÉNITA DEL TRACTO ALIMENTARIO"
  },
  {
    "codigo":230633007,
    "descripcion":"COMPRESIÓN DE RAMA PALMAR PROFUNDA DE NERVIO CUBITAL"
  },
  {
    "codigo":296169008,
    "descripcion":"SOBREDOSIS DE RISPERIDONA"
  },
  {
    "codigo":423571001,
    "descripcion":"PERDIÓ SU PAPEL PREVIO"
  },
  {
    "codigo":38121000087100,
    "descripcion":"ACINESIA DE SEGMENTO ANTEROSEPTAL MEDIO DE VENTRÍCULO CARDÍACO IZQUIERDO"
  },
  {
    "codigo":95891005,
    "descripcion":"ENFERMEDAD SIMILAR A LA GRIPE"
  },
  {
    "codigo":292499006,
    "descripcion":"REACCIÓN ADVERSA AL REPROTEROL"
  },
  {
    "codigo":1144467007,
    "descripcion":"APLASIA DE FALANGE MEDIA DE DEDO DE MANO"
  },
  {
    "codigo":43241000087105,
    "descripcion":"HERIDA PUNZANTE DE HOMBRO DERECHO CON CUERPO EXTRAÑO"
  },
  {
    "codigo":40681000087107,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE DEDO ANULAR IZQUIERDO"
  },
  {
    "codigo":61288004,
    "descripcion":"ENVENENAMIENTO POR SERPIENTE VENENOSA"
  },
  {
    "codigo":61161000087109,
    "descripcion":"INFECCIÓN CAUSADA POR UREAPLASMA UREALYTICUM"
  },
  {
    "codigo":290664006,
    "descripcion":"INTOXICACIÓN POR EPIRUBICINA"
  },
  {
    "codigo":126824007,
    "descripcion":"NEOPLASIA DEL ESTÓMAGO"
  },
  {
    "codigo":714813000,
    "descripcion":"HEMATURIA RECURRENTE CONCOMITANTE CON ENFERMEDAD POR DEPÓSITOS DENSOS Y DEBIDA A ELLA"
  },
  {
    "codigo":94056007,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE PARTES BLANDAS DE REGIÓN INGUINAL"
  },
  {
    "codigo":419901001,
    "descripcion":"REACCIÓN ADVERSA A FÁRMACO ANTIINFLAMATORIO NO ESTEROIDE"
  },
  {
    "codigo":124989003,
    "descripcion":"ALTERACIÓN DEL NÚCLEO CELULAR"
  },
  {
    "codigo":716648006,
    "descripcion":"SARCOMA EMBRIONARIO DE HÍGADO"
  },
  {
    "codigo":35561000087109,
    "descripcion":"ISQUEMIA MIOCÁRDICO INFEROLATERAL CON EXTENSIÓN A CARA POSTERIOR"
  },
  {
    "codigo":90386003,
    "descripcion":"FOTOSENSIBILIDAD CAUSADA POR ALIMENTO"
  },
  {
    "codigo":254226004,
    "descripcion":"HIPOTRICOSIS CON QUERATOSIS PILAR"
  },
  {
    "codigo":55783001,
    "descripcion":"DEFICIENCIA DE L - LACTATO DESHIDROGENASA MUSCULAR"
  },
  {
    "codigo":24850009,
    "descripcion":"LESIÓN TRAUMÁTICA DE URÉTER"
  },
  {
    "codigo":876818009,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE LA INGLE CON INFECCIÓN"
  },
  {
    "codigo":285159006,
    "descripcion":"CAPAZ DE RECONOCER OBJETOS POR MEDIO DEL TACTO"
  },
  {
    "codigo":21180000,
    "descripcion":"ENFERMEDAD RELACIONADA CON EL MEDIO INDUSTRIAL"
  },
  {
    "codigo":283324004,
    "descripcion":"PICADURA DE INSECTO EN LA REGIÓN OCULAR"
  },
  {
    "codigo":414396006,
    "descripcion":"HERNIA DE LA PARED ABDOMINAL ANTERIOR"
  },
  {
    "codigo":838545002,
    "descripcion":"INSUFICIENCIA MODERADA DE VÁLVULA AÓRTICA"
  },
  {
    "codigo":707473003,
    "descripcion":"ADENOCARCINOMA MUCINOSO PRIMARIO DE TRÁQUEA"
  },
  {
    "codigo":19345005,
    "descripcion":"AVULSIÓN DE LABIO"
  },
  {
    "codigo":246886000,
    "descripcion":"AMPOLLA DE FILTRACIÓN APLANADA"
  },
  {
    "codigo":445329008,
    "descripcion":"PRURITO DE LESIÓN CUTÁNEA"
  },
  {
    "codigo":312422001,
    "descripcion":"FARINGITIS INFECCIOSA"
  },
  {
    "codigo":1197158009,
    "descripcion":"DESPRENDIMIENTO DE PLACENTA"
  },
  {
    "codigo":10629791000119104,
    "descripcion":"CELULITIS DE AXILA IZQUIERDA"
  },
  {
    "codigo":277819004,
    "descripcion":"ANSIEDAD ACERCA DE ORINARSE"
  },
  {
    "codigo":408891006,
    "descripcion":"CON MAYOR RIESGO DE DESESPERANZA"
  },
  {
    "codigo":81211007,
    "descripcion":"ESCLEROSIS LATERAL PRIMARIA"
  },
  {
    "codigo":212283006,
    "descripcion":"LESIÓN ABIERTA MÚLTIPLE, NERVIO DIGITAL"
  },
  {
    "codigo":112144000,
    "descripcion":"GRUPO SANGUÍNEO A (GRUPO SANGUÍNEO ABO)"
  },
  {
    "codigo":79376002,
    "descripcion":"ENFERMEDAD POR EL VIRUS BUNYAMWERA"
  },
  {
    "codigo":210448003,
    "descripcion":"HERIDA ABIERTA DE LA VAGINA"
  },
  {
    "codigo":306917002,
    "descripcion":"HALLAZGO RELACIONADO CON LA MOVILIDAD DEL MARTILLO"
  },
  {
    "codigo":896741004,
    "descripcion":"FORMA DE CONO ANORMAL CONGÉNITA DE EPÍFISIS DE FALANGE DE MANO"
  },
  {
    "codigo":763834000,
    "descripcion":"SÍNDROME OROFACIODIGITAL TIPO 12"
  },
  {
    "codigo":470757009,
    "descripcion":"ASCITIS A TENSIÓN"
  },
  {
    "codigo":208613008,
    "descripcion":"FRACTURA NO EXPUESTA DE ESPINA INTERCONDÍLEA DE TIBIA"
  },
  {
    "codigo":403386004,
    "descripcion":"LINFEDEMA GENITAL"
  },
  {
    "codigo":1222586005,
    "descripcion":"LIQUEN MIXEMATOSO LOCALIZADO"
  },
  {
    "codigo":10170007,
    "descripcion":"SÍNDROME BADS (BLACK LOCKS, OCULOCUTANEOUS ALBINISM, AND DEAFNESS OF THE SENSORINEURAL TYPE) - MECHONES OSCUROS, ALBINISMO OCULOCUTÁNEO Y SORDERA DE TIPO NEUROSENSORIAL"
  },
  {
    "codigo":237711003,
    "descripcion":"GRANULOMA HIPOTALÁMICO"
  },
  {
    "codigo":73871005,
    "descripcion":"IMPACTACIÓN DEL COLON"
  },
  {
    "codigo":301412001,
    "descripcion":"DOLOR A LA DESCOMPRESIÓN EN EPIGASTRIO"
  },
  {
    "codigo":1472931000168102,
    "descripcion":"EMPLEO INESTABLE"
  },
  {
    "codigo":6500006,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DEL TRONCO"
  },
  {
    "codigo":397881000,
    "descripcion":"ENFERMEDAD DIVERTICULAR"
  },
  {
    "codigo":1153380009,
    "descripcion":"HEMÓLISIS MECÁNICA POSTERIOR A INSERCIÓN DE PRÓTESIS DE VÁLVULA CARDÍACA"
  },
  {
    "codigo":235876009,
    "descripcion":"HEPATITIS INDUCIDA POR MEDICAMENTOS"
  },
  {
    "codigo":365113003,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA MOVILIZARSE CON SILLA DE RUEDAS"
  },
  {
    "codigo":299577004,
    "descripcion":"TUMEFACCIÓN DE ARTICULACIÓN DE DEDO DEL PIE"
  },
  {
    "codigo":234041004,
    "descripcion":"TROMBOSIS DE LA VENA MESENTÉRICA INFERIOR"
  },
  {
    "codigo":4665007,
    "descripcion":"RESPIRACIÓN COSTAL"
  },
  {
    "codigo":197603000,
    "descripcion":"SÍNDROME NEFRÓTICO ASOCIADO CON OTRO TRASTORNO"
  },
  {
    "codigo":426979002,
    "descripcion":"ASMA LEVE PERSISTENTE"
  },
  {
    "codigo":263139003,
    "descripcion":"RUPTURA DE LIGAMENTO DE LA ARTICULACIÓN DE LA RODILLA"
  },
  {
    "codigo":1074131000119104,
    "descripcion":"CONDROCALCINOSIS DE MANO IZQUIERDA"
  },
  {
    "codigo":230371005,
    "descripcion":"ENFERMEDAD DE COCKAYNE PELIZAEUS-MERZBACHER TIPO VI"
  },
  {
    "codigo":33763006,
    "descripcion":"NEFROPATÍA HIPERCALCÉMICA"
  },
  {
    "codigo":295907002,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE MOCLOBEMIDA"
  },
  {
    "codigo":195768000,
    "descripcion":"RINITIS HIPERTRÓFICA CRÓNICA"
  },
  {
    "codigo":11805651000119105,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA PROXIMAL DE DEDO MEDIO IZQUIERDO"
  },
  {
    "codigo":31928004,
    "descripcion":"ABSCESO DE LA PIEL Y\/O DEL TEJIDO CELULAR SUBCUTÁNEO"
  },
  {
    "codigo":425144005,
    "descripcion":"HERIDA MENOR ABIERTA"
  },
  {
    "codigo":336851000119106,
    "descripcion":"QUISTE DE ORA SERRATA DE LA RETINA"
  },
  {
    "codigo":441921000124106,
    "descripcion":"INGESTA INADECUADA DE MINERALES"
  },
  {
    "codigo":423309002,
    "descripcion":"TELANGIECTASIAS DEL BORDE PALPEBRAL"
  },
  {
    "codigo":95629002,
    "descripcion":"LLANTO EXCESIVO EN EL RECIÉN NACIDO"
  },
  {
    "codigo":62861003,
    "descripcion":"SÍFILIS SECUNDARIA, RECIDIVA (SIN TRATAMIENTO)"
  },
  {
    "codigo":30093007,
    "descripcion":"CÁLCULO DE VÍA BILIAR"
  },
  {
    "codigo":126562000,
    "descripcion":"NEOPLASIA DE HUESO ILÍACO"
  },
  {
    "codigo":292237009,
    "descripcion":"REACCIÓN ADVERSA AL CARBOPLATINO"
  },
  {
    "codigo":61026006,
    "descripcion":"ESTADIO G3"
  },
  {
    "codigo":91959004,
    "descripcion":"NEOPLASIA BENIGNA DEL NERVIO ABDUCTOR"
  },
  {
    "codigo":124727005,
    "descripcion":"AUSENCIA DE PERISTALTISMO URETERAL"
  },
  {
    "codigo":419639006,
    "descripcion":"INTOXICACIÓN CAUSADA POR AGENTE ANTIINFECCIOSO"
  },
  {
    "codigo":57356000,
    "descripcion":"BURSITIS DE LA MANO"
  },
  {
    "codigo":286732004,
    "descripcion":"CARÁCTER REBELDE"
  },
  {
    "codigo":22753004,
    "descripcion":"TRASTORNO FETAL Y\/O PLACENTARIO QUE AFECTA EL MANEJO MATERNO"
  },
  {
    "codigo":219361005,
    "descripcion":"LESIÓN ACCIDENTAL O DELIBERADA NO DETERMINADA, POR ACCIDENTE AÉREO"
  },
  {
    "codigo":284897004,
    "descripcion":"NO SE MAQUILLA"
  },
  {
    "codigo":86454000,
    "descripcion":"CIRROSIS POSTNECRÓTICA"
  },
  {
    "codigo":776417008,
    "descripcion":"ACROSTEÓLISIS, LESIONES TIPO QUELOIDES, SÍNDROME DE ENVEJECIMIENTO PREMATURO"
  },
  {
    "codigo":53686002,
    "descripcion":"SIGNO O SÍNTOMA PSIQUIÁTRICO"
  },
  {
    "codigo":250294002,
    "descripcion":"GRANULACIÓN GIGANTE"
  },
  {
    "codigo":446902002,
    "descripcion":"INFECCIÓN DE TESTÍCULO CAUSADA POR CHLAMYDIA TRACHOMATIS"
  },
  {
    "codigo":283062009,
    "descripcion":"ABRASIÓN DE PIEL DE MIEMBRO INFERIOR"
  },
  {
    "codigo":248459002,
    "descripcion":"DIFERENTE TEMPERATURA EN EXTREMIDADES OPUESTAS"
  },
  {
    "codigo":838283002,
    "descripcion":"CELULITIS Y ABSCESO DE MANO"
  },
  {
    "codigo":1231499004,
    "descripcion":"BLEFARITIS POR VIRUS DEL HERPES SIMPLE"
  },
  {
    "codigo":707211005,
    "descripcion":"LISTERIOSIS INVASIVA"
  },
  {
    "codigo":445067002,
    "descripcion":"PAÍS DE NACIMIENTO DESCONOCIDO"
  },
  {
    "codigo":84619001,
    "descripcion":"URETRITIS NO GONOCÓCICA"
  },
  {
    "codigo":1196896001,
    "descripcion":"NEOPLASIA BENIGNA EPITELIAL DE APÉNDICE"
  },
  {
    "codigo":12217761000119100,
    "descripcion":"FRACTURA DE HUESO ADYACENTE A PRÓTESIS DE ARTICULACIÓN DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":703541007,
    "descripcion":"SÍNDROME SIMILAR A NEUROFIBROMATOSIS TIPO 1"
  },
  {
    "codigo":1162293008,
    "descripcion":"ARTRITIS CAUSADA POR MYCOBACTERIUM"
  },
  {
    "codigo":79114003,
    "descripcion":"MOLDEADO DE LA CABEZA FETAL"
  },
  {
    "codigo":110047001,
    "descripcion":"LACERACIÓN SIMPLE DE LA REGIÓN PREAURICULAR DE LA CARA"
  },
  {
    "codigo":699871003,
    "descripcion":"ADHERENCIA CONGÉNITA DE PENE"
  },
  {
    "codigo":42676002,
    "descripcion":"DIFERENCIAS VENTILATORIAS REGIONALES POR RESISTENCIA AÉREA LOCAL"
  },
  {
    "codigo":1255092002,
    "descripcion":"ADENOCARCINOMA DE SENO PARANASAL"
  },
  {
    "codigo":9908006,
    "descripcion":"DESARROLLO PSICOMOTOR NORMAL"
  },
  {
    "codigo":1156788007,
    "descripcion":"LEIOMIOSARCOMA DE COLON"
  },
  {
    "codigo":698036008,
    "descripcion":"ATAXIA MOTORA ORAL"
  },
  {
    "codigo":1351561001,
    "descripcion":"FALTA DE PERFUSIÓN DE CAPILARES PERIFOVEALES DE OJO IZQUIERDO"
  },
  {
    "codigo":1076641000119107,
    "descripcion":"TENDINITIS DE RODILLA IZQUIERDA"
  },
  {
    "codigo":237449003,
    "descripcion":"GINECOMASTIA CAUSADA POR FÁRMACO"
  },
  {
    "codigo":403124009,
    "descripcion":"DERMATOMICOSIS DISEMINADA CAUSADA POR FUSARIUM"
  },
  {
    "codigo":73609005,
    "descripcion":"SECRECIÓN PANCREÁTICA ANORMAL"
  },
  {
    "codigo":301150000,
    "descripcion":"ELEVACIÓN DEL BRAZO QUE OBSTRUYE EL PULSO RADIAL"
  },
  {
    "codigo":235614000,
    "descripcion":"ÚLCERA POR ESTRÉS DEL ESÓFAGO"
  },
  {
    "codigo":1251422006,
    "descripcion":"OCLUSIÓN DE MICROVASCULATURA DE PIEL DEBIDO A COAGULOPATÍA"
  },
  {
    "codigo":366686009,
    "descripcion":"AMPLITUD DE MOVIMIENTO PASIVO DE ADUCCIÓN DE DEDO DE LA MANO - HALLAZGO"
  },
  {
    "codigo":348291000119100,
    "descripcion":"INFILTRADO CORNEAL DE OJO DERECHO POSTERIOR A QUERATOPLASTIA PENETRANTE"
  },
  {
    "codigo":315011000119101,
    "descripcion":"OSTEÍTIS DEFORMANTE DE CÚBITO Y RADIO IZQUIERDOS"
  },
  {
    "codigo":364851006,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA SALTAR"
  },
  {
    "codigo":4403007,
    "descripcion":"PELO EN SIGNO DE ADMIRACIÓN"
  },
  {
    "codigo":343171000119103,
    "descripcion":"DEFORMIDAD DE ÓRBITA DE AMBOS OJOS DEBIDA A LESIÓN TRAUMÁTICA"
  },
  {
    "codigo":459619971000119103,
    "descripcion":"SINOSTOSIS RADIOCUBITAL DE ANTEBRAZO IZQUIERDO POSTERIOR A LESIÓN TRAUMÁTICA"
  },
  {
    "codigo":291971000119104,
    "descripcion":"TRASTORNO DE NERVIO FEMORAL DERECHO"
  },
  {
    "codigo":11776131000119107,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE ANTEBRAZO IZQUIERDO"
  },
  {
    "codigo":233779005,
    "descripcion":"FÍSTULA TRAQUEAL CONGÉNITA"
  },
  {
    "codigo":135811000119107,
    "descripcion":"DEMENCIA CON CUERPOS DE LEWY CON ALTERACIÓN DE LA CONDUCTA"
  },
  {
    "codigo":5251000119108,
    "descripcion":"MALFORMACIÓN ARTERIOVENOSA ADQUIRIDA"
  },
  {
    "codigo":10964611000119109,
    "descripcion":"HALLAZGO ANORMAL RELACIONADO CON EL PELO"
  },
  {
    "codigo":335491000119109,
    "descripcion":"DACRIOPS DE APARATO LAGRIMAL DE OJO DERECHO"
  },
  {
    "codigo":363016006,
    "descripcion":"COMPLICACIÓN DE PROCEDIMIENTO FISIÁTRICO DE REHABILITACIÓN FÍSICA"
  },
  {
    "codigo":262877000,
    "descripcion":"CONTUSIÓN DE RECTO"
  },
  {
    "codigo":10859651000119108,
    "descripcion":"ALIMENTO ASPIRADO EN TRÁQUEA"
  },
  {
    "codigo":231944006,
    "descripcion":"QUERATOPATÍA DEL LABRADOR"
  },
  {
    "codigo":789000004,
    "descripcion":"ARTROSIS DE CADERA DEBIDA A TRAUMATISMO Y POSTERIOR A ÉL"
  },
  {
    "codigo":11773571000119109,
    "descripcion":"HERIDA INFECTADA DE CODO DERECHO DEBIDA A PICADURA DE INSECTO NO VENENOSO"
  },
  {
    "codigo":295645003,
    "descripcion":"SOBREDOSIS DE CARMUSTINA"
  },
  {
    "codigo":721629005,
    "descripcion":"LINTIS PLÁSTICA DE ESTÓMAGO"
  },
  {
    "codigo":195506001,
    "descripcion":"HIPOTENSIÓN IDIOPÁTICA"
  },
  {
    "codigo":193671003,
    "descripcion":"ESCOTOMA PARACECAL"
  },
  {
    "codigo":15933141000119104,
    "descripcion":"NEOPLASIA BENIGNA DE AMBAS TROMPAS UTERINAS"
  },
  {
    "codigo":128135006,
    "descripcion":"TRASTORNO DE MUSLO"
  },
  {
    "codigo":160903007,
    "descripcion":"TRABAJO DE JORNADA COMPLETA"
  },
  {
    "codigo":717959008,
    "descripcion":"COMPLICACIÓN CARDÍACA DE ANESTESIA DURANTE EL PUERPERIO"
  },
  {
    "codigo":95367009,
    "descripcion":"DOLOR EN EL SITIO DE APLICACIÓN"
  },
  {
    "codigo":124465002,
    "descripcion":"DEFICIENCIA DE BETA - GALACTOSIDASA"
  },
  {
    "codigo":1304113005,
    "descripcion":"SÍNDROME DE BLEFAROFIMOSIS, DISCAPACIDAD INTELECTUAL CON SOLAPAMIENTO CON SÍNDROME GENITO-PATELAR"
  },
  {
    "codigo":24326000,
    "descripcion":"LEUCODISTROFIA METACROMÁTICA, TIPO ADULTO"
  },
  {
    "codigo":12681000202102,
    "descripcion":"CAPAZ DE ASEGURAR SU SEGURIDAD PERSONAL"
  },
  {
    "codigo":1236742007,
    "descripcion":"MASA QUE OCUPA CUADRANTE SUPERIOR IZQUIERDO DE ABDOMEN"
  },
  {
    "codigo":1234907000,
    "descripcion":"TRASTORNO OVOTESTICULAR DE DESAROLLO SEXUAL"
  },
  {
    "codigo":1169371000,
    "descripcion":"CAPTACIÓN DE T3 POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":448475002,
    "descripcion":"SÍNDROME DE VÁLVULA PULMONAR AUSENTE CON DEFECTO DEL TABIQUE VENTRICULAR, NO DE TIPO FALLOT"
  },
  {
    "codigo":450310006,
    "descripcion":"ARTERIA COLATERAL MAYOR QUE DERIVA EL FLUJO SISTÉMICO HACIA LA CIRCULACIÓN PULMONAR QUE IRRIGA PARTE DEL PULMÓN IZQUIERDO"
  },
  {
    "codigo":88027004,
    "descripcion":"ENDOMIOMETRITIS"
  },
  {
    "codigo":284635006,
    "descripcion":"RASGUÑAR A OTRA PERSONA"
  },
  {
    "codigo":282800006,
    "descripcion":"LESIÓN DE GANGLIO PTERIGOPALATINO"
  },
  {
    "codigo":20656007,
    "descripcion":"VÁRICES SUBLINGUALES"
  },
  {
    "codigo":1264005000,
    "descripcion":"ENFERMEDAD DE GLÁNDULA SUBMANDIBULAR ASOCIADA A INMUNOGLOBULINA G4"
  },
  {
    "codigo":117125001,
    "descripcion":"CARACTERÍSTICA DEL SOPLO CARDÍACO, SOPLANTE"
  },
  {
    "codigo":315568007,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: CANTONÉS"
  },
  {
    "codigo":250032008,
    "descripcion":"MARCHA DE ATAXIA VESTIBULAR"
  },
  {
    "codigo":1231237001,
    "descripcion":"DESVIACIÓN INTERMITENTE DE LA MIRADA HACIA ABAJO"
  },
  {
    "codigo":84357006,
    "descripcion":"PLACENTA GEMELAR MONOAMNIÓTICA MONOCORIÓNICA"
  },
  {
    "codigo":280965007,
    "descripcion":"DISCAPACIDAD CONDUCTUAL"
  },
  {
    "codigo":18821006,
    "descripcion":"DISPLASIA DE OJO"
  },
  {
    "codigo":1296773009,
    "descripcion":"INTOXICACIÓN AGUDA POR OPIOIDES"
  },
  {
    "codigo":248197006,
    "descripcion":"FACIES ACROMEGÁLICA"
  },
  {
    "codigo":1079151000119109,
    "descripcion":"CARCINOMA BASOCELULAR PRIMARIO DE MIEMBRO SUPERIOR DERECHO"
  },
  {
    "codigo":82522008,
    "descripcion":"SÍNDROME DE CONTRACTURA ISQUÉMICA DEL VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":703279003,
    "descripcion":"COMPLICACIÓN EN VENA CAVA INFERIOR CONSECUTIVA A PROCEDIMIENTO"
  },
  {
    "codigo":15151004,
    "descripcion":"LESIÓN TRAUMÁTICA DE HÍGADO CON HERIDA ABIERTA HACIA CAVIDAD ABDOMINAL"
  },
  {
    "codigo":408367005,
    "descripcion":"EL PACIENTE OLVIDA TOMAR LA MEDICACIÓN"
  },
  {
    "codigo":1260335005,
    "descripcion":"DISTONÍA CAUSADA POR ANTAGONISTA DE RECEPTOR DE DOPAMINA"
  },
  {
    "codigo":11784201000119105,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE DEDO MEÑIQUE DERECHO"
  },
  {
    "codigo":766980008,
    "descripcion":"CARCINOMA ESCAMOCELULAR DE ESTÓMAGO"
  },
  {
    "codigo":765145001,
    "descripcion":"INMUNODEFICIENCIA COMBINADA SEVERA NEGATIVA PARA LINFOCITOS T Y POSITIVA PARA LINFOCITOS B DEBIDA A DEFICIENCIA DE CADENA GAMMA"
  },
  {
    "codigo":109785005,
    "descripcion":"HIPERPLASIA VERRUGOSA DE LA MUCOSA ORAL"
  },
  {
    "codigo":240857007,
    "descripcion":"LARVA MIGRANTE CUTÁNEA ESTRONGILOIDAL"
  },
  {
    "codigo":763310000,
    "descripcion":"ENCEFALOPATÍA NECROSANTE AGUDA DE LA INFANCIA"
  },
  {
    "codigo":402862000,
    "descripcion":"ÚLCERA DE PIERNA POR ARTERITIS"
  },
  {
    "codigo":206254003,
    "descripcion":"ESTEATONECROSIS SUBCUTÁNEA POR TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":366424004,
    "descripcion":"AMPLITUD DEL MOVIMIENTO ACTIVO DE ROTACIÓN HACIA LA IZQUIERDA DE LA COLUMNA DORSAL - HALLAZGO"
  },
  {
    "codigo":202584007,
    "descripcion":"OSTEOCONDROMATOSIS SINOVIAL DE LA CADERA"
  },
  {
    "codigo":300888008,
    "descripcion":"TUMEFACCIÓN DE UNA REGIÓN CORPORAL"
  },
  {
    "codigo":71512009,
    "descripcion":"ESTIMULACIÓN PRECOITAL"
  },
  {
    "codigo":344381000119101,
    "descripcion":"COROIDITIS FOCAL DE POLO POSTERIOR DE AMBOS OJOS"
  },
  {
    "codigo":297218007,
    "descripcion":"ANOMALÍA CONGÉNITA DE CONDUCTO ARTERIOSO"
  },
  {
    "codigo":35074008,
    "descripcion":"DOLOR ANAL IDIOPÁTICO CRÓNICO"
  },
  {
    "codigo":197079003,
    "descripcion":"OBSTRUCCIÓN INTESTINAL SUBAGUDA"
  },
  {
    "codigo":262615004,
    "descripcion":"CUERPO EXTRAÑO EN URETRA FEMENINA"
  },
  {
    "codigo":721367003,
    "descripcion":"LESIÓN COMPLETA DE MÉDULA ESPINAL AL NIVEL DEL QUINTO SEGMENTO CERVICAL"
  },
  {
    "codigo":229847006,
    "descripcion":"HUESO CUBOIDES EN FLEXIÓN PLANTAR"
  },
  {
    "codigo":162476000,
    "descripcion":"SÍNTOMA QUE EMPEORA CON EL EJERCICIO"
  },
  {
    "codigo":1145516000,
    "descripcion":"APLASIA DE FALANGE DE DEDO ANULAR"
  },
  {
    "codigo":129708001,
    "descripcion":"CON MAYOR RIESGO DE AUTOMUTILACIÓN"
  },
  {
    "codigo":424620000,
    "descripcion":"EXHIBE CONTROL ADECUADO DEL DOLOR CON ANALGÉSICOS ORALES"
  },
  {
    "codigo":293548005,
    "descripcion":"REACCIÓN ADVERSA AL DINITRATO DE ISOSORBIDA"
  },
  {
    "codigo":301891901000119107,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN EN DEDO DE PIE DERECHO NO ESTADIFICABLE"
  },
  {
    "codigo":160641003,
    "descripcion":"EJERCICIO ANAERÓBICO, UNA VEZ POR SEMANA"
  },
  {
    "codigo":226177003,
    "descripcion":"DIETA CON BAJO CONTENIDO DE MANGANESO"
  },
  {
    "codigo":717697005,
    "descripcion":"ULCERACIÓN TUBERCULOSA DE VULVA"
  },
  {
    "codigo":193409008,
    "descripcion":"DISTROFIA RETINIANA HIALINA"
  },
  {
    "codigo":95105008,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL CORDÓN ESPERMÁTICO"
  },
  {
    "codigo":1141846002,
    "descripcion":"EOSINOFILIA EPISÓDICA"
  },
  {
    "codigo":289878002,
    "descripcion":"TONO MUSCULAR PÉLVICO SATISFACTORIO"
  },
  {
    "codigo":1081661000119109,
    "descripcion":"RABDOMIOSARCOMA PRIMARIO DE CADERA DERECHA"
  },
  {
    "codigo":191574005,
    "descripcion":"ESQUIZOFRENIA ESQUIZOAFECTIVA EN REMISIÓN"
  },
  {
    "codigo":715862006,
    "descripcion":"DISPLASIA DE SMITH MCCORT"
  },
  {
    "codigo":224342005,
    "descripcion":"ABSUELTO DE CARGO CRIMINAL"
  },
  {
    "codigo":93270009,
    "descripcion":"HIPOPLASIA CONGÉNITA DE HUESO LAGRIMAL"
  },
  {
    "codigo":25899002,
    "descripcion":"FRACTURA BIMALEOLAR NO EXPUESTA"
  },
  {
    "codigo":1303851004,
    "descripcion":"REACCIÓN ADVERSA A COMPONENTE DE VACUNA QUE CONTIENE ANTÍGENO DE PAPILOMAVIRUS HUMANO"
  },
  {
    "codigo":714027006,
    "descripcion":"PARÁLISIS DE NERVIO TRIGÉMINO"
  },
  {
    "codigo":1269248000,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DEBIDO A OCLUSIÓN DE ARTERIA COROIDEA ANTERIOR"
  },
  {
    "codigo":124203009,
    "descripcion":"DEFICIENCIA DE PEROXIDASA"
  },
  {
    "codigo":286208005,
    "descripcion":"REALIZA MOVIMIENTOS PARA HABLAR"
  },
  {
    "codigo":710357000,
    "descripcion":"NEUROPATÍA PERIFÉRICA DE MIEMBRO SUPERIOR DEBIDA A ENFERMEDAD INFLAMATORIA"
  },
  {
    "codigo":253440008,
    "descripcion":"TEJIDO ACCESORIO EN VALVA DE VÁLVULA AURICULOVENTRICULAR COMÚN"
  },
  {
    "codigo":448213004,
    "descripcion":"LINFOMA NO HODGKIN DIFUSO DE PRÓSTATA"
  },
  {
    "codigo":15636951000119108,
    "descripcion":"CARCINOMA DUCTAL IN SITU DE AMBAS MAMAS"
  },
  {
    "codigo":53162000,
    "descripcion":"HEMATOMA DE LA VAGINA"
  },
  {
    "codigo":282538000,
    "descripcion":"COMIENZA A CORRER"
  },
  {
    "codigo":1003434002,
    "descripcion":"LIPOMA DEBIDO A DISRAFISMO NEUROESPINAL"
  },
  {
    "codigo":127601000119103,
    "descripcion":"INFECCIÓN DISEMINADA POR ACANTHAMOEBA"
  },
  {
    "codigo":263944006,
    "descripcion":"BANDA MUSCULAR ANTEROLATERAL"
  },
  {
    "codigo":247935003,
    "descripcion":"CONDUCTA AUTOESTIMULANTE"
  },
  {
    "codigo":18559007,
    "descripcion":"PRESENTACIÓN PÉLVICA FRANCA"
  },
  {
    "codigo":82260000,
    "descripcion":"DIABETES MELLITUS PREGESTACIONAL Y\/O TRASTORNO DE LA TOLERANCIA A LA GLUCOSA, CLASE R DE WHITE MODIFICADA"
  },
  {
    "codigo":10859121000119106,
    "descripcion":"HERIDA ABIERTA DE PARED TORÁCICA IZQUIERDA DEBIDA A MORDEDURA HUMANA"
  },
  {
    "codigo":346891000119100,
    "descripcion":"HEMORRAGIA DE COROIDES DE AMBOS OJOS"
  },
  {
    "codigo":277033000,
    "descripcion":"SIN RESPUESTA POSACTIVACIÓN"
  },
  {
    "codigo":768553002,
    "descripcion":"HIPERMANGANESEMIA CON DISTONÍA"
  },
  {
    "codigo":15692401000119107,
    "descripcion":"QUERATITIS LAMINAR DIFUSA DE OJO DERECHO"
  },
  {
    "codigo":1260073003,
    "descripcion":"CARCINOMA ESCAMOSO PAPILAR DE LARINGE"
  },
  {
    "codigo":735785005,
    "descripcion":"LACERACIÓN DE ESTÓMAGO CONCOMITANTE CON AVULSIÓN PARCIAL"
  },
  {
    "codigo":137644811000119102,
    "descripcion":"TUMOR NEUROENDOCRINO BIEN DIFERENCIADO GRADO 1 DE PULMÓN DERECHO"
  },
  {
    "codigo":733950002,
    "descripcion":"CARIES DENTAL PRIMARIA INACTIVA QUE SE EXTIENDE HASTA LA MITAD INTERNA DEL ESMALTE"
  },
  {
    "codigo":209662003,
    "descripcion":"SECCIÓN EXPUESTA DE LIGAMENTO LATERAL EXTERNO DE CODO"
  },
  {
    "codigo":78590007,
    "descripcion":"MAL DE LAS MONTAÑAS"
  },
  {
    "codigo":111358007,
    "descripcion":"DIVERTICULITIS DEL YEYUNO"
  },
  {
    "codigo":13054007,
    "descripcion":"INTOXICACIÓN CAUSADA POR ATROPINA"
  },
  {
    "codigo":674571000119104,
    "descripcion":"FALLO DE MADURACIÓN DE FÍSTULA ARTERIOVENOSA QUIRÚRGICA"
  },
  {
    "codigo":109523003,
    "descripcion":"HIPOPLASIA MANDIBULAR HORIZONTAL CONGÉNITA"
  },
  {
    "codigo":304296001,
    "descripcion":"AMPLITUD DE MOVIMIENTO DE HOMBRO AUMENTADA"
  },
  {
    "codigo":240595009,
    "descripcion":"INFECCIÓN GENITAL NO ESPECÍFICA PATÓGENO-NEGATIVA"
  },
  {
    "codigo":894120002,
    "descripcion":"CUADRANTOPSIA HOMÓNIMA INFERIOR IZQUIERDA"
  },
  {
    "codigo":1287336004,
    "descripcion":"CARCINOMA DE CÉLULAS DE MERKEL PRIMARIO DE PIEL DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":238760005,
    "descripcion":"LIVIDECES SIMÉTRICAS DE PLANTAS DEL PIE"
  },
  {
    "codigo":402600008,
    "descripcion":"XERODERMIA EN SÍNDROME GENÉTICO"
  },
  {
    "codigo":1187197004,
    "descripcion":"NEVO PIGMENTADO GIGANTE DE COMPORTAMIENTO INCIERTO"
  },
  {
    "codigo":1252733006,
    "descripcion":"NÓDULO DE PIEL DE ANTEBRAZO DERECHO"
  },
  {
    "codigo":726610000,
    "descripcion":"PARAPLEJÍA ESPÁSTICA AUTOSÓMICA RECESIVA TIPO 63"
  },
  {
    "codigo":5714002,
    "descripcion":"ENFERMEDAD CAUSADA POR POLYOMAVIRUS"
  },
  {
    "codigo":15967141000119103,
    "descripcion":"SÍNDROME DE ROBO DE ARTERIA SUBCLAVIA IZQUIERDA"
  },
  {
    "codigo":366162006,
    "descripcion":"HALLAZGO RELACIONADO CON LA PRESIÓN VENOSA CENTRAL"
  },
  {
    "codigo":202322007,
    "descripcion":"ANQUILOSIS DE LA ARTICULACIÓN DE DEDO DEL PIE"
  },
  {
    "codigo":235090006,
    "descripcion":"RELACIÓN DEL SEGMENTO BUCAL CLASE I"
  },
  {
    "codigo":724775006,
    "descripcion":"PARAPLEJÍA ESPÁSTICA HEREDITARIA LIGADA AL CROMOSOMA X"
  },
  {
    "codigo":67580000,
    "descripcion":"BARRA MEDIANA DE LA PRÓSTATA"
  },
  {
    "codigo":167719009,
    "descripcion":"LCR: LINFOCITOSIS"
  },
  {
    "codigo":722940002,
    "descripcion":"HIPOTIROIDISMO CENTRAL ADQUIRIDO"
  },
  {
    "codigo":428028003,
    "descripcion":"CONTRACTURA EN SUPINACIÓN DE LA MUÑECA"
  },
  {
    "codigo":1148924004,
    "descripcion":"DEMENCIA DEBIDA A DEFICIENCIA DE ÁCIDO FÓLICO"
  },
  {
    "codigo":1281831009,
    "descripcion":"CRISIS EPILÉPTICA CON DETENCIÓN DEL COMPORTAMIENTO DE INICIO FOCAL"
  },
  {
    "codigo":788476006,
    "descripcion":"TRASTORNO REPETITIVO DEL MOVIMIENTO DEL BRAZO IZQUIERDO"
  },
  {
    "codigo":721105004,
    "descripcion":"SÍNDROME DE KLIPPEL TRENAUNAY"
  },
  {
    "codigo":63910001,
    "descripcion":"DERMATITIS CRÓNICA DEL PLIEGUE LABIAL"
  },
  {
    "codigo":424358006,
    "descripcion":"PENACHO VITREORRETINIANO"
  },
  {
    "codigo":162214009,
    "descripcion":"LACTANTE QUE LLORA"
  },
  {
    "codigo":94843004,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL PIE"
  },
  {
    "codigo":29307005,
    "descripcion":"CRANEOLACUNIA"
  },
  {
    "codigo":225915006,
    "descripcion":"CON MAYOR RIESGO DE MALTRATO"
  },
  {
    "codigo":420688000,
    "descripcion":"ESTRABISMO CON PATRÓN EN X"
  },
  {
    "codigo":225544001,
    "descripcion":"ASPECTO CUTÁNEO NORMAL"
  },
  {
    "codigo":93008005,
    "descripcion":"ANOMALÍA CONGÉNITA DEL ISQUION"
  },
  {
    "codigo":1010512006,
    "descripcion":"ESCLEROSIS DE EPÍFISIS DE FALANGE DE MANO CON RADIOPACIDAD AUMENTADA"
  },
  {
    "codigo":289616009,
    "descripcion":"HIMEN VAGINAL NORMAL"
  },
  {
    "codigo":27472009,
    "descripcion":"PRUEBA DE WEBER, LATERALIZADO HACIA LA IZQUIERDA"
  },
  {
    "codigo":123941003,
    "descripcion":"INTOXICACIÓN POR ULMACEAE"
  },
  {
    "codigo":1303589004,
    "descripcion":"FETO MUY ACTIVO"
  },
  {
    "codigo":255013004,
    "descripcion":"XANTOGRANULOMA JUVENIL DE IRIS"
  },
  {
    "codigo":293951000119107,
    "descripcion":"SÍNDROME DE DOLOR REGIONAL COMPLEJO TIPO I DE AMBOS MIEMBROS INFERIORES"
  },
  {
    "codigo":91173007,
    "descripcion":"NÁUSEAS Y VÓMITOS CAUSADOS POR RADIACIÓN"
  },
  {
    "codigo":1172517006,
    "descripcion":"PREGNANEDIOL POR ENCIMA DE RANGO DE REFERENCIA"
  },
  {
    "codigo":253178001,
    "descripcion":"HIPOPLASIA DE CÉLULAS GRANULOSAS"
  },
  {
    "codigo":417018008,
    "descripcion":"COCCIDIOIDOMICOSIS PULMONAR"
  },
  {
    "codigo":710095001,
    "descripcion":"DENTICIÓN COMPLETA SEVERAMENTE COMPROMETIDA CON 4 O MÁS EN TODOS LOS SEXTANTES"
  },
  {
    "codigo":251343002,
    "descripcion":"PRUEBA CUTÁNEA CON HIDRÓXIDO DE POTASIO - HALLAZGO"
  },
  {
    "codigo":284111002,
    "descripcion":"CONTROLA LA POSICIÓN DE LA CABEZA"
  },
  {
    "codigo":87503006,
    "descripcion":"INFECCIÓN CAUSADA POR PROTOTHECA WICKERHAMII"
  },
  {
    "codigo":447951009,
    "descripcion":"SARCOMA DE EWING DE PARTES BLANDAS"
  },
  {
    "codigo":216740001,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR CIANURO"
  },
  {
    "codigo":118436003,
    "descripcion":"HALLAZGO RELACIONADO CON EL INTESTINO GRUESO"
  },
  {
    "codigo":249508009,
    "descripcion":"INCAPAZ DE CONTROLAR FLATOS"
  },
  {
    "codigo":20132009,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE LA CUARTA VÉRTEBRA CERVICAL"
  },
  {
    "codigo":870265003,
    "descripcion":"TRASTORNO GENERALIZADO DEL DESARROLLO CON ALTERACIÓN DEL DESARROLLO INTELECTUAL CON PÉRDIDA DE HABILIDADES ADQUIRIDAS PREVIAMENTE"
  },
  {
    "codigo":247673001,
    "descripcion":"PERPLEJIDAD DE ALUCINACIONES"
  },
  {
    "codigo":83833006,
    "descripcion":"INTOXICACIÓN POR CRIMIDINA"
  },
  {
    "codigo":1263481007,
    "descripcion":"DISPLASIA MESOMÉLICA DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":278606003,
    "descripcion":"PRÓTESIS MAXILOFACIAL - HALLAZGO"
  },
  {
    "codigo":409678004,
    "descripcion":"FIEBRE HEMORRÁGICA POR DENGUE, GRADO III"
  },
  {
    "codigo":14627000,
    "descripcion":"DIETA HIPERPROTEICA"
  },
  {
    "codigo":473379000,
    "descripcion":"RUPTURA DE VALVA DE VÁLVULA AURICULOVENTRICULAR IZQUIERDA (MORFOLÓGICAMENTE NO MITRAL)"
  },
  {
    "codigo":735523003,
    "descripcion":"ESTADIO CLÍNICO 2 DE INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA DE LA ORGANIZACIÓN MUNDIAL DE LA SALUD DE 2007 CONCOMITANTE CON TUBERCULOSIS"
  },
  {
    "codigo":211235006,
    "descripcion":"LESIONES TRAUMÁTICAS SUPERFICIALES MÚLTIPLES EN HOMBRO Y BRAZO"
  },
  {
    "codigo":309539008,
    "descripcion":"ENTUMECIMIENTO DE DEDO DEL PIE"
  },
  {
    "codigo":1290744001,
    "descripcion":"ARTRITIS REACTIVA DE ARTICULACIÓN DE CADERA DEBIDA A ENFERMEDAD INFECCIOSA TRANSMITIDA POR VÍA SEXUAL Y POSTERIOR A ELLA"
  },
  {
    "codigo":209400003,
    "descripcion":"FRACTURA-SUBLUXACIÓN NO EXPUESTA DE LA PELVIS"
  },
  {
    "codigo":406008003,
    "descripcion":"HAPLOTIPO CDE"
  },
  {
    "codigo":897528007,
    "descripcion":"DELECIÓN DISTAL DEL BRAZO LARGO DEL CROMOSOMA 6"
  },
  {
    "codigo":240333000,
    "descripcion":"INTOXICACIÓN ALIMENTARIA POR BACILLUS LICHENIFORMIS"
  },
  {
    "codigo":109261001,
    "descripcion":"MUCOSITIS POR CONTACTO CRÓNICA"
  },
  {
    "codigo":371405004,
    "descripcion":"TRASTORNO DEL GLOBO OCULAR"
  },
  {
    "codigo":404173006,
    "descripcion":"MASTOCITOSIS FAMILIAR"
  },
  {
    "codigo":764621006,
    "descripcion":"SÍNDROME DE TRISOMÍA 16 MOSAICO"
  },
  {
    "codigo":402338004,
    "descripcion":"VULVOVAGINITIS CIRCINADA CONCOMITANTE CON TRÍADA DE ARTRITIS REACTIVA"
  },
  {
    "codigo":41890004,
    "descripcion":"LIQUEN NÍTIDO"
  },
  {
    "codigo":269431000,
    "descripcion":"CHOQUE ELÉCTRICO NO LETAL"
  },
  {
    "codigo":238498009,
    "descripcion":"SENO PILOSO DE MAMA"
  },
  {
    "codigo":40055000,
    "descripcion":"SINUSITIS CRÓNICA"
  },
  {
    "codigo":7287001,
    "descripcion":"INTOXICACIÓN CAUSADA POR TRIORTOCRESILFOSFATO"
  },
  {
    "codigo":236663006,
    "descripcion":"INCONTINENCIA URINARIA DURANTE EL ORGASMO"
  },
  {
    "codigo":300364000,
    "descripcion":"VÓMITO CON CONTENIDO DE SANGRE DIGERIDA"
  },
  {
    "codigo":726348003,
    "descripcion":"TRISOMÍA PARCIAL DE CROMOSOMA 9"
  },
  {
    "codigo":365900005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA RECORDAR CARAS"
  },
  {
    "codigo":167457005,
    "descripcion":"ELECTROFORESIS DE PROTEÍNAS URINARIAS DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1279734000,
    "descripcion":"LESIÓN DE RETINA DE OJO IZQUIERDO"
  },
  {
    "codigo":724513009,
    "descripcion":"APLASIA CONGÉNITA DE ESTRUCTURA LAGRIMAL"
  },
  {
    "codigo":165622003,
    "descripcion":"HIERRO SÉRICO DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1148662004,
    "descripcion":"ELECTRORRETINOGRAMA CON ADAPTACIÓN A LA LUZ Y A LA OSCURIDAD ANORMAL"
  },
  {
    "codigo":394998005,
    "descripcion":"EVALUACIÓN DE AUTOMEDICACIÓN - ALTO RIESGO"
  },
  {
    "codigo":722678003,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE VAGINA"
  },
  {
    "codigo":65483000,
    "descripcion":"PLACENTA DE EMBARAZO MÚLTIPLE"
  },
  {
    "codigo":131019001,
    "descripcion":"NIVEL DE HORMONA FOLÍCULO ESTIMULANTE HIPOFISARIA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":679591000119104,
    "descripcion":"OSTEOMIELITIS DE ÓRBITA DE OJO DERECHO"
  },
  {
    "codigo":187144000,
    "descripcion":"QUISTE HIDATÍDICO DE RIÑÓN"
  },
  {
    "codigo":1144992001,
    "descripcion":"TEMOR AL CÁNCER DE VÍAS URINARIAS"
  },
  {
    "codigo":719008003,
    "descripcion":"CON MAYOR RIESGO DE FIBRILACIÓN AURICULAR"
  },
  {
    "codigo":293024009,
    "descripcion":"REACCIÓN ADVERSA A LA LINCOMICINA"
  },
  {
    "codigo":94581003,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL VELO DEL PALADAR"
  },
  {
    "codigo":29045004,
    "descripcion":"FRACTURA DE MONTEGGIA NO EXPUESTA"
  },
  {
    "codigo":225653004,
    "descripcion":"SE MOLESTA FÁCILMENTE"
  },
  {
    "codigo":127349007,
    "descripcion":"ACCIDENTE AUTOMOVILÍSTICO, CONDUCTOR"
  },
  {
    "codigo":10811201000119102,
    "descripcion":"TRASTORNO MENTAL EN LA MADRE QUE COMPLICA EL NACIMIENTO"
  },
  {
    "codigo":289354000,
    "descripcion":"SIN PELOTEO DE LA PRESENTACIÓN"
  },
  {
    "codigo":92746001,
    "descripcion":"CARCINOMA IN SITU DE LA PIEL DEL OMBLIGO"
  },
  {
    "codigo":59978006,
    "descripcion":"FUMADOR DE CIGARRO"
  },
  {
    "codigo":715338007,
    "descripcion":"ACIDOSIS LÁCTICA INFANTIL CONCOMITANTE CON ACIDURIA METILMALÓNICA FATAL"
  },
  {
    "codigo":844575001,
    "descripcion":"ANGIOEDEMA RESPIRATORIO"
  },
  {
    "codigo":254751002,
    "descripcion":"XANTOGRANULOMA ERUPTIVO SOLITARIO"
  },
  {
    "codigo":287519002,
    "descripcion":"PRIVACIÓN DE ALIMENTO"
  },
  {
    "codigo":713503007,
    "descripcion":"TRASTORNO DE LA MÉDULA ESPINAL CONCOMITANTE CON INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":418591009,
    "descripcion":"HERIDA POR QUEMADURA EN LA CÓRNEA"
  },
  {
    "codigo":285684005,
    "descripcion":"INCAPAZ DE CARGAR PESO EN LA PIERNA DERECHA"
  },
  {
    "codigo":449524008,
    "descripcion":"DISMINUCIÓN ESPONTÁNEA DEL TAMAÑO DE DEFECTO DE TABIQUE INTERVENTRICULAR DEBIDA A TEJIDO ACCESORIO DE VÁLVULA AURICULOVENTRICULAR"
  },
  {
    "codigo":447689001,
    "descripcion":"PROLAPSO DE VÁLVULA DE EUSTAQUIO A TRAVÉS DEL TABIQUE INTERAURICULAR"
  },
  {
    "codigo":1332425004,
    "descripcion":"HISTIOCITOSIS DE CÉLULAS DE LANGERHANS DISEMINADA DE GANGLIOS LINFÁTICOS DE CABEZA"
  },
  {
    "codigo":283849006,
    "descripcion":"LESIÓN POR DESOLLAMIENTO DE GENITALES"
  },
  {
    "codigo":183710001,
    "descripcion":"CONSULTA DOMICILIARIA PEDIÁTRICA SOLICITADA"
  },
  {
    "codigo":413086003,
    "descripcion":"DESVIACIÓN DE LA RAZÓN INTERNACIONAL NORMALIZADA DE LOS VALORES OBJETIVO"
  },
  {
    "codigo":1363358005,
    "descripcion":"ATROFIA DE PARTES BLANDAS DE ÓRBITA DERECHA"
  },
  {
    "codigo":247411000,
    "descripcion":"HABLA DOLOROSA"
  },
  {
    "codigo":444019000,
    "descripcion":"NO ESPERÓ PARA SER TRATADO"
  },
  {
    "codigo":116339002,
    "descripcion":"HALLAZGO MAMARIO"
  },
  {
    "codigo":1197683008,
    "descripcion":"VÁRICES DE VESÍCULA BILIAR"
  },
  {
    "codigo":312947009,
    "descripcion":"CORIORRETINOPATÍA SEROSA CENTRAL, AGUDA"
  },
  {
    "codigo":18035009,
    "descripcion":"LESIÓN TRAUMÁTICA DE TOBILLO EN SUPINACIÓN-EVERSIÓN, GRADO 2"
  },
  {
    "codigo":704328003,
    "descripcion":"FRACTURA OSTEOPORÓTICA DE TOBILLO"
  },
  {
    "codigo":1163080001,
    "descripcion":"DUODENITIS BACTERIANA"
  },
  {
    "codigo":14365001,
    "descripcion":"PROLAPSO CONGÉNITO DE VEJIGA URINARIA"
  },
  {
    "codigo":1259549005,
    "descripcion":"CARCINOMA VERRUGOSO PRIMARIO DE CAVIDAD ORAL"
  },
  {
    "codigo":276509008,
    "descripcion":"HIDROPESÍA FETAL NO DEBIDA A ISOINMUNIZACIÓN"
  },
  {
    "codigo":407581009,
    "descripcion":"REGISTRO DEL PACIENTE SOLICITADO POR PROCURADOR"
  },
  {
    "codigo":471282000,
    "descripcion":"MICRODELECIÓN CROMOSÓMICA"
  },
  {
    "codigo":12530001,
    "descripcion":"ANEURISMA ARTERIAL CIRSOIDEO"
  },
  {
    "codigo":241906000,
    "descripcion":"EFECTO TÓXICO CAUSADO POR ADHESIVO SÓLIDO"
  },
  {
    "codigo":274674005,
    "descripcion":"HIPERHIDROSIS LOCALIZADA"
  },
  {
    "codigo":372978006,
    "descripcion":"INFECCIÓN CAUSADA POR ASPERGILLUS CHEVALIERI"
  },
  {
    "codigo":405746006,
    "descripcion":"ACTUALMENTE NO FUMADOR PERO SE DESCONOCEN SUS ANTECEDENTES DE TABAQUISMO"
  },
  {
    "codigo":209138009,
    "descripcion":"SUBLUXACIÓN NO EXPUESTA ENTRE LA SEGUNDA Y TERCERA VÉRTEBRAS CERVICALES"
  },
  {
    "codigo":305607002,
    "descripcion":"BAJO ATENCIÓN DE TERAPEUTA OCUPACIONAL DE DEPARTAMENTO DE SERVICIOS SOCIALES"
  },
  {
    "codigo":240071003,
    "descripcion":"DISTROFIA MUSCULAR LIGADA AL X SIN PREDOMINIO EN LA CINTURA DE EXTREMIDAD"
  },
  {
    "codigo":403911008,
    "descripcion":"CARCINOMA BASOCELULAR ULCERONODULAR"
  },
  {
    "codigo":205468002,
    "descripcion":"HIPOCONDROPLASIA"
  },
  {
    "codigo":860828007,
    "descripcion":"NEOPLASIA DE ESTROMA GASTROINTESTINAL DE LOCALIZACIONES SUPERPUESTAS DE INTESTINO DELGADO"
  },
  {
    "codigo":926364008,
    "descripcion":"HALLAZGO EN LA INFUSIÓN DE NUTRICIÓN ENTERAL"
  },
  {
    "codigo":7025000,
    "descripcion":"ESQUIZOFRENIA INDIFERENCIADA SUBCRÓNICA CON EXACERBACIONES AGUDAS"
  },
  {
    "codigo":269169002,
    "descripcion":"HERIDA ABIERTA EN LA ESPALDA"
  },
  {
    "codigo":301937002,
    "descripcion":"HALLAZGO RELACIONADO CON EL ASPECTO DE LA PUPILA"
  },
  {
    "codigo":762524009,
    "descripcion":"CUERPO EXTRAÑO MAGNÉTICO RETENIDO EN OJO DERECHO"
  },
  {
    "codigo":74396008,
    "descripcion":"PENSAMIENTO TANGENCIAL"
  },
  {
    "codigo":236401002,
    "descripcion":"GLOMERULONEFRITIS CON CAMBIO MÍNIMO DEPENDIENTE DE ESTEROIDES"
  },
  {
    "codigo":271000119101,
    "descripcion":"TRASTORNO BIPOLAR MIXTO SEVERO TIPO I"
  },
  {
    "codigo":108661000119109,
    "descripcion":"INFECCIÓN CAUSADA POR STREPTOCOCCUS DEL GRUPO VIRIDANS"
  },
  {
    "codigo":234566005,
    "descripcion":"HIPERCATABOLISMO FAMILIAR DE INMUNOGLOBULINA"
  },
  {
    "codigo":169030006,
    "descripcion":"TOMOGRAFÍA ANORMAL"
  },
  {
    "codigo":365638007,
    "descripcion":"HALLAZGO DE GRUPO SANGUÍNEO RH"
  },
  {
    "codigo":1119302008,
    "descripcion":"COVID-19 AGUDO"
  },
  {
    "codigo":300102009,
    "descripcion":"HALLAZGO RELACIONADO CON LA SENSIBILIDAD DEL PABELLÓN AURICULAR"
  },
  {
    "codigo":429339004,
    "descripcion":"FRACTURA DE HUESO SESAMOIDEO"
  },
  {
    "codigo":298267006,
    "descripcion":"DERRAME DE LA VAINA TENDINOSA"
  },
  {
    "codigo":36123008,
    "descripcion":"OSIFICACIÓN ANORMAL"
  },
  {
    "codigo":427504007,
    "descripcion":"MUJER EN EDAD FÉRTIL"
  },
  {
    "codigo":34288008,
    "descripcion":"PLEUROTÓTONOS"
  },
  {
    "codigo":15702441000119101,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE TENDÓN DE RÓTULA IZQUIERDA"
  },
  {
    "codigo":391066002,
    "descripcion":"RESULTADO DE ABSORCIOMETRÍA DUAL POR RAYOS X DE CALCÁNEO, OSTEOPENIA"
  },
  {
    "codigo":292762005,
    "descripcion":"REACCIÓN ADVERSA A LÍQUIDO DE HEMODIÁLISIS"
  },
  {
    "codigo":423834007,
    "descripcion":"DIFICULTAD CON EL PATRÓN DE DESCANSO PRENATAL"
  },
  {
    "codigo":28783002,
    "descripcion":"ENFERMEDAD INFLAMATORIA DEL ÚTERO"
  },
  {
    "codigo":290927003,
    "descripcion":"INTOXICACIÓN POR VILOXAZINA"
  },
  {
    "codigo":61551003,
    "descripcion":"SÍNDROME DE DEFICIENCIA DE FACTOR MÚLTIPLE FAMILIAR, TIPO VI"
  },
  {
    "codigo":127087005,
    "descripcion":"LINFADENOPATÍA CERVICAL LATERAL"
  },
  {
    "codigo":94319009,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE GRANDES VASOS"
  },
  {
    "codigo":715076006,
    "descripcion":"CAPAZ DE PASAR DE LA CAMA A UNA SILLA"
  },
  {
    "codigo":25113000,
    "descripcion":"COREA GRAVÍDICA"
  },
  {
    "codigo":92484008,
    "descripcion":"NEOPLASIA BENIGNA DE LAS CUERDAS VOCALES"
  },
  {
    "codigo":418329002,
    "descripcion":"CAPTURA PUPILAR DE LENTE INTRAOCULAR"
  },
  {
    "codigo":1237529000,
    "descripcion":"METÁSTASIS DE CARCINOMA EN AMPOLLA DE VATER"
  },
  {
    "codigo":1335833004,
    "descripcion":"URETRITIS CAUSADA POR MYCOPLASMA GENITALIUM"
  },
  {
    "codigo":254489006,
    "descripcion":"NEOPLASIA DE RECESO FARÍNGEO"
  },
  {
    "codigo":56046002,
    "descripcion":"SUDORACIÓN GUSTATORIA"
  },
  {
    "codigo":1268462002,
    "descripcion":"OSTEOSARCOMA PRIMARIO DE HUESO"
  },
  {
    "codigo":285422003,
    "descripcion":"MIELOMA INMUNOGLOBULINA D"
  },
  {
    "codigo":33075007,
    "descripcion":"IDENTIFICACIÓN DE UN CUERPO POR EXAMEN DENTAL"
  },
  {
    "codigo":711406009,
    "descripcion":"NEUROPATÍA AXÓNICA AUTOSÓMICA RECESIVA CON NEUROMIOTONÍA"
  },
  {
    "codigo":283587007,
    "descripcion":"HERIDA DE PERDIGÓN EN PANTORRILLA"
  },
  {
    "codigo":1363096000,
    "descripcion":"ASTILLA EN GLÚTEO"
  },
  {
    "codigo":185283008,
    "descripcion":"ATENDIDO POR UN TRABAJADOR SOCIAL"
  },
  {
    "codigo":773272002,
    "descripcion":"HERNIA PERINEAL IRREDUCTIBLE"
  },
  {
    "codigo":15921731000119106,
    "descripcion":"TRASTORNO PSICÓTICO CAUSADO POR METANFETAMINA"
  },
  {
    "codigo":10816221000119100,
    "descripcion":"FRACTURA EXPUESTA DE LA PIERNA DERECHA"
  },
  {
    "codigo":871576005,
    "descripcion":"REACCIÓN ADVERSA A PIPERIDOLATO"
  },
  {
    "codigo":19608008,
    "descripcion":"METAPLASIA DE CÉLULAS DE HURTHLE DE LA GLÁNDULA TIROIDES"
  },
  {
    "codigo":216216005,
    "descripcion":"LESIÓN POR PROPULSOR A HÉLICE DE AERONAVE, SIN ACCIDENTE DE AERONAVE, VIAJERO EN AERONAVE COMERCIAL EN TRANSPORTE DESDE TIERRA Y MAR AL AIRE LESIONADO"
  },
  {
    "codigo":50541007,
    "descripcion":"SÍNDROME DE BRUNS"
  },
  {
    "codigo":247149008,
    "descripcion":"ESCLEROSIS MACULAR COROIDEA"
  },
  {
    "codigo":312685009,
    "descripcion":"CRIBADO PARA DETECCIÓN ANTICUERPOS ANTI-D POSITIVO"
  },
  {
    "codigo":441922002,
    "descripcion":"ROTA EL LUGAR DE INYECCIÓN DE INSULINA"
  },
  {
    "codigo":15938005,
    "descripcion":"ECLAMPSIA"
  },
  {
    "codigo":1162818005,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE LITIO Y\/O COMPUESTO DE LITIO"
  },
  {
    "codigo":704066009,
    "descripcion":"FRACTURA POR ESTRÉS DE FALANGE DE DEDO DE LA MANO"
  },
  {
    "codigo":276247002,
    "descripcion":"INCONGRUENCIA DEL ESTADO DE ÁNIMO"
  },
  {
    "codigo":472855003,
    "descripcion":"ESTENOSIS DE VÁLVULA TRONCAL FETAL"
  },
  {
    "codigo":210711006,
    "descripcion":"HERIDA ABIERTA DE LA PLANTA DEL PIE"
  },
  {
    "codigo":866071006,
    "descripcion":"NEOPLASIA MALIGNA MESENQUIMÁTICA DE VESÍCULA BILIAR"
  },
  {
    "codigo":309015008,
    "descripcion":"DERIVADO POR EL ESTABLECIMIENTO"
  },
  {
    "codigo":897004000,
    "descripcion":"VÁRICES ESOFÁGICAS POR CIRROSIS HEPÁTICA"
  },
  {
    "codigo":733164001,
    "descripcion":"INFECCIÓN GASTROINTESTINAL CAUSADA POR MYCOBACTERIUM NO TUBERCULOSIS"
  },
  {
    "codigo":1193751008,
    "descripcion":"ENTERITIS DEBIDA A ENFERMEDAD POR VIH"
  },
  {
    "codigo":208876006,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA NO EXPUESTA DE DEDO"
  },
  {
    "codigo":764097002,
    "descripcion":"SORDERA GENÉTICA POSLOCUTIVA NO SINDRÓMICA"
  },
  {
    "codigo":330461000119107,
    "descripcion":"ATRAPAMIENTO DE NERVIO CUBITAL EN LA MUÑECA IZQUIERDA"
  },
  {
    "codigo":239809007,
    "descripcion":"ARTRITIS JUVENIL EN LA ENFERMEDAD INTESTINAL INFLAMATORIA"
  },
  {
    "codigo":272577007,
    "descripcion":"FLOTANDO ACOSTADO EN DECÚBITO VENTRAL"
  },
  {
    "codigo":403649009,
    "descripcion":"ESTRÍAS DEBIDAS A TRATAMIENTO CON CORTICOSTEROIDES SISTÉMICOS"
  },
  {
    "codigo":16032631000119102,
    "descripcion":"OSTEONECROSIS DE AMBOS HÚMEROS"
  },
  {
    "codigo":205206003,
    "descripcion":"DEFICIENCIA TRANSVERSA DE EXTREMIDAD INFERIOR - A TRAVÉS DE FÉMUR"
  },
  {
    "codigo":41366005,
    "descripcion":"CÁLCULO DENTAL SUBGINGIVAL"
  },
  {
    "codigo":762262008,
    "descripcion":"VEJIGA URINARIA HIPERACTIVA DEBIDA A PROLAPSO DE ÓRGANO GENITAL FEMENINO"
  },
  {
    "codigo":301675000,
    "descripcion":"CAPAZ DE LEVANTARSE DE UNA CAMA"
  },
  {
    "codigo":37696000,
    "descripcion":"QUEMADURA DE PIERNA"
  },
  {
    "codigo":299840002,
    "descripcion":"REFLEJO SUPINADOR RETARDADO"
  },
  {
    "codigo":398144003,
    "descripcion":"DISPONIBILIDAD DE ASISTENCIA"
  },
  {
    "codigo":29831000175106,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN EN TALÓN DERECHO"
  },
  {
    "codigo":1217344005,
    "descripcion":"HALLAZGO RELACIONADO CON EL NIVEL DE SUSTANCIA EN SANGRE"
  },
  {
    "codigo":16907281000119100,
    "descripcion":"MELANOMA IN SITU DE PIEL DE PÁRPADO SUPERIOR DERECHO"
  },
  {
    "codigo":365376005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD DE PARTICIPAR EN JUEGOS"
  },
  {
    "codigo":206335051000132108,
    "descripcion":"QUISTE DE ESTÓMAGO"
  },
  {
    "codigo":68629007,
    "descripcion":"INTOXICACIÓN POR TIANFENICOL"
  },
  {
    "codigo":298005009,
    "descripcion":"HALLAZGO RELACIONADO CON LA CURACIÓN DE UNA HERIDA"
  },
  {
    "codigo":34026001,
    "descripcion":"POSICIÓN SEMIPRONA"
  },
  {
    "codigo":230634001,
    "descripcion":"COMPRESIÓN DEL NERVIO RADIAL"
  },
  {
    "codigo":294335000,
    "descripcion":"ALERGIA A HIPROMELOSA"
  },
  {
    "codigo":296170009,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE RISPERIDONA"
  },
  {
    "codigo":197866008,
    "descripcion":"DIVERTÍCULO DE VEJIGA URINARIA"
  },
  {
    "codigo":64959007,
    "descripcion":"ESPASMO DE ARTERIA RETINIANA"
  },
  {
    "codigo":1179071009,
    "descripcion":"INFECCIÓN DE INTESTINO CAUSADA POR SALMONELLA GRUPO C"
  },
  {
    "codigo":1144468002,
    "descripcion":"APLASIA DE FALANGE DE MANO"
  },
  {
    "codigo":292500002,
    "descripcion":"REACCIÓN ADVERSA AL RIMITEROL"
  },
  {
    "codigo":95892003,
    "descripcion":"LINFADENOPATÍA GENERALIZADA PERSISTENTE"
  },
  {
    "codigo":10927121000119107,
    "descripcion":"FRACTURA NO EXPUESTA DE DIÁFISIS DE QUINTO HUESO METACARPIANO DE MANO DERECHA"
  },
  {
    "codigo":94057003,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE PARTES BLANDAS DE MIEMBRO INFERIOR"
  },
  {
    "codigo":716649003,
    "descripcion":"CARCINOMA PERITONEAL PRIMARIO EXTRAOVÁRICO"
  },
  {
    "codigo":290665007,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR EPIRUBICINA"
  },
  {
    "codigo":126825008,
    "descripcion":"NEOPLASIA DEL CARDIAS DEL ESTÓMAGO"
  },
  {
    "codigo":687121000119109,
    "descripcion":"NEUROFIBROMA DE MIEMBRO INFERIOR"
  },
  {
    "codigo":714814006,
    "descripcion":"HEMATURIA PERSISTENTE CONCOMITANTE CON ENFERMEDAD POR DEPÓSITOS DENSOS Y DEBIDA A ELLA"
  },
  {
    "codigo":124990007,
    "descripcion":"ALTERACIÓN DE LA CENTROSFERA"
  },
  {
    "codigo":385299000,
    "descripcion":"VESÍCULA SEMINAL AUSENTE EN ESPÉCIMEN TUMORAL"
  },
  {
    "codigo":419902008,
    "descripcion":"ANILLO DE TENSIÓN CAPSULAR LUXADO"
  },
  {
    "codigo":59454008,
    "descripcion":"LARINGITIS SECA"
  },
  {
    "codigo":87211000119104,
    "descripcion":"TUMOR NEUROEPITELIAL DISEMBRIOPLÁSTICO"
  },
  {
    "codigo":92222007,
    "descripcion":"NEOPLASIA BENIGNA DE GLÁNDULAS ENDOCRINAS MÚLTIPLES"
  },
  {
    "codigo":876819001,
    "descripcion":"CUERPO EXTRAÑO SUPERFICIAL EN PARED TORÁCICA CON INFECCIÓN"
  },
  {
    "codigo":254227008,
    "descripcion":"HIPOTRICOSIS CON QUERATOSIS PILAR Y LENTIGINOSA"
  },
  {
    "codigo":46531000087105,
    "descripcion":"FRACTURA DE EXTREMO PROXIMAL DE PERONÉ DERECHO"
  },
  {
    "codigo":59331000087106,
    "descripcion":"ASPERGILLUS FLAVUS O ASPERGILLUS ORYZAE"
  },
  {
    "codigo":286995008,
    "descripcion":"INFERTILIDAD FEMENINA - CERVICAL\/VAGINAL"
  },
  {
    "codigo":712979009,
    "descripcion":"PÓLIPO DE COLON ASCENDENTE"
  },
  {
    "codigo":43971000087108,
    "descripcion":"CORTE EN PIEL DE GLÚTEO DERECHO"
  },
  {
    "codigo":15953221000119100,
    "descripcion":"RETRACCIÓN DE PEZÓN IZQUIERDO"
  },
  {
    "codigo":414397002,
    "descripcion":"HERNIA DE LA PARED ABDOMINAL ANTERIOR CON GANGRENA"
  },
  {
    "codigo":283325003,
    "descripcion":"PICADURA DE INSECTO EN LA REGIÓN AURICULAR"
  },
  {
    "codigo":332971000119108,
    "descripcion":"SINEQUIAS POSTERIORES DEL IRIS DEL OJO DERECHO"
  },
  {
    "codigo":142661000119102,
    "descripcion":"CUERPO EXTRAÑO RETENIDO"
  },
  {
    "codigo":838546001,
    "descripcion":"INSUFICIENCIA SEVERA DE VÁLVULA AÓRTICA"
  },
  {
    "codigo":445330003,
    "descripcion":"AUSENCIA DE VALVAS DE VÁLVULA AURICULOVENTRICULAR DERECHA EN VENTRÍCULO CON DOBLE TRACTO DE ENTRADA (ORIFICIO DESCUBIERTO)"
  },
  {
    "codigo":248722004,
    "descripcion":"ARTERIAS ENDURECIDAS"
  },
  {
    "codigo":19346006,
    "descripcion":"SÍNDROME DE MARFAN"
  },
  {
    "codigo":1197159001,
    "descripcion":"DESPRENDIMIENTO DE PLACENTA CON SANGRADO"
  },
  {
    "codigo":50279003,
    "descripcion":"ENFERMEDAD ÓSEA METABÓLICA"
  },
  {
    "codigo":443495005,
    "descripcion":"NEOPLASIA DE ESTRUCTURA DEL SISTEMA LINFOIDE"
  },
  {
    "codigo":312423006,
    "descripcion":"LARINGITIS INFECCIOSA"
  },
  {
    "codigo":212284000,
    "descripcion":"LESIÓN DEL NERVIO PROPIO DEL PULGAR"
  },
  {
    "codigo":246887009,
    "descripcion":"PATRÓN DE COLORACIÓN DE CONJUNTIVA BULBAR"
  },
  {
    "codigo":15676002,
    "descripcion":"PERICARDITIS REUMÁTICA AGUDA"
  },
  {
    "codigo":408892004,
    "descripcion":"HALLAZGO RELACIONADO CON LA EXPRESIÓN DE CREENCIAS RELIGIOSAS"
  },
  {
    "codigo":277820005,
    "descripcion":"ANSIEDAD ACERCA DE VOMITAR EN PÚBLICO"
  },
  {
    "codigo":10683871000119102,
    "descripcion":"NÓDULO DEL TEJIDO CELULAR SUBCUTÁNEO DE EXTREMIDAD SUPERIOR IZQUIERDA"
  },
  {
    "codigo":46609008,
    "descripcion":"INFECCIÓN CAUSADA POR CLOSTRIDIUM PERFRINGENS TIPO C"
  },
  {
    "codigo":77542002,
    "descripcion":"SÍNDROME DE GREBE"
  },
  {
    "codigo":470758004,
    "descripcion":"ASCITIS REFRACTARIA"
  },
  {
    "codigo":896742006,
    "descripcion":"FORMA DE CONO ANORMAL CONGÉNITA DE EPÍFISIS DE FALANGE PROXIMAL DE MANO"
  },
  {
    "codigo":306918007,
    "descripcion":"MOVILIDAD DEL MARTILLO NORMAL"
  },
  {
    "codigo":42939002,
    "descripcion":"PIEMIA"
  },
  {
    "codigo":763835004,
    "descripcion":"SÍNDROME OROFACIODIGITAL TIPO 13"
  },
  {
    "codigo":403387008,
    "descripcion":"LINFEDEMA DE PENE"
  },
  {
    "codigo":698299009,
    "descripcion":"RUPTURA TRAUMÁTICA DE MANGUITO ROTADOR"
  },
  {
    "codigo":235877000,
    "descripcion":"HEPATITIS ISQUÉMICA"
  },
  {
    "codigo":39269004,
    "descripcion":"PULSO TRICÓTICO"
  },
  {
    "codigo":301413006,
    "descripcion":"DOLOR A LA DESCOMPRESIÓN EN HIPOCONDRIO DERECHO"
  },
  {
    "codigo":268645007,
    "descripcion":"PATRÓN DE CONSUMO NOCIVO DE ALCOHOL SIN DEPENDENCIA"
  },
  {
    "codigo":1153381008,
    "descripcion":"LEUCEMIA AGUDA DE FENOTIPO MIXTO CON LINAJE DE LINFOCITOS B Y MIELOIDE"
  },
  {
    "codigo":399717009,
    "descripcion":"COMPROMISO POR MELANOMA DE MARGEN DE RESECCIÓN QUIRÚRGICA PROFUNDO, NO PUEDE SER EVALUADO"
  },
  {
    "codigo":397882007,
    "descripcion":"ANOMALÍA TRANSITORIA INADVERTIDA POR EL PACIENTE"
  },
  {
    "codigo":102970007,
    "descripcion":"POTENCIAL EVOCADO AUDITIVO NORMAL"
  },
  {
    "codigo":365114009,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA SUBIR Y BAJAR ESCALONES Y ESCALERAS"
  },
  {
    "codigo":299578009,
    "descripcion":"TUMEFACCIÓN ÓSEA DE ARTICULACIÓN DE DEDO DEL PIE"
  },
  {
    "codigo":201274009,
    "descripcion":"CLOASMA BRONCEADO"
  },
  {
    "codigo":166671000,
    "descripcion":"ENZIMAS CARDÍACAS - HALLAZGO DUDOSO"
  },
  {
    "codigo":37434008,
    "descripcion":"INFECCIÓN CAUSADA POR NEOCTENOTAENIA"
  },
  {
    "codigo":230372003,
    "descripcion":"ESCLEROSIS MÚLTIPLE RECIDIVANTE AGUDA"
  },
  {
    "codigo":335481000119106,
    "descripcion":"NEOVASCULARIZACIÓN PROFUNDA DE CÓRNEA DERECHA"
  },
  {
    "codigo":197604006,
    "descripcion":"SÍNDROME NEFRÓTICO EN LA AMILOIDOSIS"
  },
  {
    "codigo":295908007,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE MOCLOBEMIDA"
  },
  {
    "codigo":359609001,
    "descripcion":"OTITIS MEDIA AGUDA NO SUPURATIVA"
  },
  {
    "codigo":309011000119101,
    "descripcion":"TENDINITIS CALCIFICANTE DE MANO DERECHA"
  },
  {
    "codigo":294073007,
    "descripcion":"ALERGIA A TROPICAMIDA"
  },
  {
    "codigo":195769008,
    "descripcion":"RINITIS ATRÓFICA CRÓNICA"
  },
  {
    "codigo":64697009,
    "descripcion":"ANESTESIA TÉRMICA"
  },
  {
    "codigo":128398001,
    "descripcion":"ENFERMEDAD INFECCIOSA DEL APARATO DIGESTIVO"
  },
  {
    "codigo":718222000,
    "descripcion":"SÍNDROME DE PTERIGIÓN POPLÍTEO AUTOSÓMICO DOMINANTE"
  },
  {
    "codigo":292238004,
    "descripcion":"REACCIÓN ADVERSA AL CISPLATINO"
  },
  {
    "codigo":95630007,
    "descripcion":"DISCINESIA NEONATAL"
  },
  {
    "codigo":192099000,
    "descripcion":"TRASTORNO DE LA CONDUCTA Y LA EMOCIÓN EN LA INFANCIA"
  },
  {
    "codigo":423310007,
    "descripcion":"POLIARTRITIS POSINFECCIOSA DE ARTICULACIÓN DE MANO"
  },
  {
    "codigo":716387004,
    "descripcion":"SÍNDROME DE MICRODELECIÓN 2Q31.1"
  },
  {
    "codigo":126563005,
    "descripcion":"NEOPLASIA DE ISQUION"
  },
  {
    "codigo":290403007,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR PECTINA"
  },
  {
    "codigo":124728000,
    "descripcion":"LACTOSURIA"
  },
  {
    "codigo":28259009,
    "descripcion":"SÍNDROME DE CRIGLER - NAJJAR"
  },
  {
    "codigo":2331000124101,
    "descripcion":"PRIMER MOLAR SUPERIOR IZQUIERDO DECIDUO SUPERNUMERARIO"
  },
  {
    "codigo":91960009,
    "descripcion":"NEOPLASIA BENIGNA DEL NERVIO ACCESORIO"
  },
  {
    "codigo":253965002,
    "descripcion":"AGENESIA DE MÚLTIPLES HUESOS METATARSIANOS"
  },
  {
    "codigo":580891000124108,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN DE PIE"
  },
  {
    "codigo":88290000,
    "descripcion":"CORIORRETINITIS FOCAL DEBIDA A TOXOPLASMOSIS DISEMINADA ADQUIRIDA"
  },
  {
    "codigo":57357009,
    "descripcion":"ISQUEMIA TRANSITORIA"
  },
  {
    "codigo":286733009,
    "descripcion":"CARÁCTER EMPÁTICO"
  },
  {
    "codigo":219362003,
    "descripcion":"LESIÓN DE CAUSA ACCIDENTAL O INTENCIONAL INDETERMINADA POR SUSTANCIAS CÁUSTICAS, EXCLUIDAS INTOXICACIONES"
  },
  {
    "codigo":22754005,
    "descripcion":"NEUMONÍA ESTAFILOCÓCICA"
  },
  {
    "codigo":448738008,
    "descripcion":"LINFOMA NO HODGKIN DE PARTES BLANDAS"
  },
  {
    "codigo":20919000,
    "descripcion":"HENDIDURA HEPÁTICA CONGÉNITA"
  },
  {
    "codigo":284898009,
    "descripcion":"DIFICULTAD PARA MAQUILLARSE"
  },
  {
    "codigo":283063004,
    "descripcion":"ABRASIÓN DE PIEL DE DORSO DEL PIE"
  },
  {
    "codigo":208819009,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE HUESO SEMILUNAR (PALMAR)"
  },
  {
    "codigo":182924003,
    "descripcion":"DIETA CON BAJAS CALORÍAS"
  },
  {
    "codigo":1297036006,
    "descripcion":"AGAMMAGLOBULINEMIA AUTOSÓMICA RECESIVA"
  },
  {
    "codigo":445068007,
    "descripcion":"DISPLASIA DE PRÓSTATA"
  },
  {
    "codigo":1231500008,
    "descripcion":"ADHESIÓN DE MÚSCULO EXTRAOCULAR"
  },
  {
    "codigo":246625001,
    "descripcion":"USA ANTEOJOS OSCUROS"
  },
  {
    "codigo":10850221000119107,
    "descripcion":"LACERACIÓN DE PARED TORÁCICA DERECHA"
  },
  {
    "codigo":82785005,
    "descripcion":"SINOSTOSIS ASTRAGALONAVICULAR"
  },
  {
    "codigo":1196897005,
    "descripcion":"NEOPLASIA EPITELIAL BENIGNA DE DUODENO"
  },
  {
    "codigo":703542000,
    "descripcion":"DESPRENDIMIENTO DE RETINA Y ENCEFALOCELE OCCIPITAL"
  },
  {
    "codigo":275723000,
    "descripcion":"DETERIORO DEL ESTADO DEL PACIENTE"
  },
  {
    "codigo":274524231000119104,
    "descripcion":"ÚLCERA VENOSA DE TALÓN DERECHO"
  },
  {
    "codigo":699872005,
    "descripcion":"CEPA NO TIPIFICADA DE VIRUS INFLUENZA A PRESENTE"
  },
  {
    "codigo":110048006,
    "descripcion":"LACERACIÓN SIMPLE CONTAMINADA DE LA REGIÓN PREAURICULAR DE LA CARA"
  },
  {
    "codigo":337991000119106,
    "descripcion":"RETINOPATÍA POR PREMATUREZ DEL OJO IZQUIERDO ETAPA 2 - CRESTA INTRARRETINIANA"
  },
  {
    "codigo":9909003,
    "descripcion":"DEGENERACIÓN GRASA CARDÍACA"
  },
  {
    "codigo":1156789004,
    "descripcion":"ENFERMEDAD DE ALZHEIMER AUTOSÓMICA DOMINANTE DEBIDA A MUTACIÓN DE PROTEÍNA PRECURSORA AMILOIDE"
  },
  {
    "codigo":698037004,
    "descripcion":"FIJACIÓN ANCHA DE FRENILLO LABIAL"
  },
  {
    "codigo":272053006,
    "descripcion":"MAL TESTIGO"
  },
  {
    "codigo":403125005,
    "descripcion":"DERMATOMICOSIS DISEMINADA CAUSADA POR TRICHOSPORON"
  },
  {
    "codigo":11780321000119101,
    "descripcion":"LACERACIÓN DE MÚSCULO DE PIERNA DERECHA"
  },
  {
    "codigo":11862241000119102,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE DEDO GORDO DE PIE DERECHO"
  },
  {
    "codigo":8074002,
    "descripcion":"SÍNDROME DE PROLAPSO DE VÁLVULA MITRAL"
  },
  {
    "codigo":237450003,
    "descripcion":"GINECOMASTIA CAUSADA POR GONADOTROFINA CORIÓNICA HUMANA"
  },
  {
    "codigo":401290007,
    "descripcion":"ESCALA DE DISNEA DE BORG: 7 - MUY SEVERA"
  },
  {
    "codigo":366687000,
    "descripcion":"AMPLITUD DE MOVIMIENTO DE ARTICULACIÓN DEL PULGAR - HALLAZGO"
  },
  {
    "codigo":301151001,
    "descripcion":"PULSO PERIFÉRICO PRESENTE"
  },
  {
    "codigo":1251423001,
    "descripcion":"OCLUSIÓN DE MICROVASCULATURA DE PIEL CAUSADA POR CRIOGLOBULINA TIPO III"
  },
  {
    "codigo":1351562008,
    "descripcion":"FALTA DE PERFUSIÓN DE CAPILARES PERIFOVEALES DE AMBOS OJOS"
  },
  {
    "codigo":235615004,
    "descripcion":"ESTENOSIS ESOFÁGICA MALIGNA"
  },
  {
    "codigo":286088001,
    "descripcion":"LAVA LOS PLATOS"
  },
  {
    "codigo":364852004,
    "descripcion":"PATRÓN ELECTROENCEFALOGRÁFICO GENERALIZADO - HALLAZGO"
  },
  {
    "codigo":366971000119100,
    "descripcion":"AZOOSPERMIA DEBIDA A ENFERMEDAD INFECCIOSA"
  },
  {
    "codigo":12081531000119100,
    "descripcion":"QUEMADURA DE CÓRNEA DE OJO DERECHO"
  },
  {
    "codigo":789001000,
    "descripcion":"ARTROSIS DE RODILLA DEBIDA A TRAUMATISMO Y POSTERIOR A ÉL"
  },
  {
    "codigo":233780008,
    "descripcion":"FÍSTULA TRAQUEAL ADQUIRIDA"
  },
  {
    "codigo":1149449002,
    "descripcion":"PERIODONTITIS GENERALIZADA ESTADIO 4 GRADO B SEGÚN LA CLASIFICACIÓN DE LAS ENFERMEDADES Y ALTERACIONES PERIODONTALES Y PERIIMPLANTARIAS DE 2017 DE LA ACADEMIA ESTADOUNIDENSE DE PERIODONTOLOGÍA Y LA FEDERACIÓN EUROPEA DE PERIODONTOLOGÍA"
  },
  {
    "codigo":461321006,
    "descripcion":"HIPERTENSIÓN DE VENTRÍCULO DERECHO"
  },
  {
    "codigo":231945007,
    "descripcion":"LESIÓN DE LA CÓRNEA CAUSADA POR SUSTANCIAS QUÍMICAS"
  },
  {
    "codigo":721630000,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE CARDIAS GÁSTRICO"
  },
  {
    "codigo":734001,
    "descripcion":"OPOCÉFALO"
  },
  {
    "codigo":295646002,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE CARMUSTINA"
  },
  {
    "codigo":199177009,
    "descripcion":"FIEBRE POR MORDEDURA DE GATO"
  },
  {
    "codigo":262878005,
    "descripcion":"DESGARRO SEROSO DEL RECTO"
  },
  {
    "codigo":66270006,
    "descripcion":"COILONIQUIA"
  },
  {
    "codigo":197342009,
    "descripcion":"HEPATITIS EN LA FIEBRE AMARILLA"
  },
  {
    "codigo":424883003,
    "descripcion":"DIFICULTAD PARA VER LETRA IMPRESA DE PEQUEÑO TAMAÑO"
  },
  {
    "codigo":15959901000119101,
    "descripcion":"QUISTE EMBRIONARIO DE CONDUCTO DE GARTNER IZQUIERDO"
  },
  {
    "codigo":293811005,
    "descripcion":"ALERGIA A AMANTADINA"
  },
  {
    "codigo":151901000119101,
    "descripcion":"PROBLEMAS PSICOSOCIALES RELACIONADOS CON EMBARAZO NO DESEADO"
  },
  {
    "codigo":1088861000119104,
    "descripcion":"PERICONDRITIS DE OÍDO EXTERNO IZQUIERDO"
  },
  {
    "codigo":16528221000119104,
    "descripcion":"DUPLICACIÓN CONGÉNITA DE ARTERIA COMUNICANTE ANTERIOR"
  },
  {
    "codigo":1076061000119101,
    "descripcion":"QUISTE MUCOSO DIGITAL DE MANO IZQUIERDA"
  },
  {
    "codigo":717960003,
    "descripcion":"COMPLICACIÓN DE ANESTESIA EN EL SISTEMA NERVIOSO CENTRAL DURANTE EL PUERPERIO"
  },
  {
    "codigo":105821000119107,
    "descripcion":"INMUNIDAD CONTRA PAPERAS DETERMINADA POR SEROLOGÍA"
  },
  {
    "codigo":341341000119109,
    "descripcion":"CONJUNTIVOCALASIA DE OJO IZQUIERDO"
  },
  {
    "codigo":305501000119109,
    "descripcion":"CONTRACTURA DE ARTICULACIÓN DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":310621000119109,
    "descripcion":"MIOSITIS INFECCIOSA DE MANO IZQUIERDA"
  },
  {
    "codigo":133981000119106,
    "descripcion":"DISARTRIA COMO EFECTO TARDÍO DE ENFERMEDAD CEREBROVASCULAR"
  },
  {
    "codigo":499707741000119108,
    "descripcion":"LUXACIÓN DE PRÓTESIS ARTICULAR DE DEDO DE MANO"
  },
  {
    "codigo":193672005,
    "descripcion":"ANGIOESCOTOMA"
  },
  {
    "codigo":128136007,
    "descripcion":"TRASTORNO DE LA RODILLA"
  },
  {
    "codigo":95368004,
    "descripcion":"ÚLCERA EN EL SITIO DE APLICACIÓN"
  },
  {
    "codigo":10760541000119109,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA VULVA DURANTE EL EMBARAZO"
  },
  {
    "codigo":1240413005,
    "descripcion":"PRURITO DE PEZÓN"
  },
  {
    "codigo":191837001,
    "descripcion":"FARMACODEPENDENCIA DE CANNABIS, CONTINUA"
  },
  {
    "codigo":124466001,
    "descripcion":"DEFICIENCIA DE ALFA - MANOSIDASA"
  },
  {
    "codigo":1304114004,
    "descripcion":"SÍNDROME DE DISMORFIA FACIAL, HIPERTRICOSIS, EPILEPSIA, DISCAPACIDAD INTELECTUAL\/RETRASO DEL DESARROLLO, HIPERPLASIA GINGIVAL"
  },
  {
    "codigo":419378004,
    "descripcion":"CÓRNEA FARINATA"
  },
  {
    "codigo":1236743002,
    "descripcion":"MASA QUE OCUPA CUADRANTE INFERIOR IZQUIERDO DE ABDOMEN"
  },
  {
    "codigo":286471002,
    "descripcion":"CAPAZ DE REBANAR ALIMENTOS"
  },
  {
    "codigo":253703004,
    "descripcion":"ORIGEN ANÓMALO DE ARTERIA CORONARIA EN SENO NO ENFRENTADO"
  },
  {
    "codigo":417543005,
    "descripcion":"DESLIZAMIENTO INFERIOR DEL PUBIS"
  },
  {
    "codigo":450311005,
    "descripcion":"ARTERIA COLATERAL MAYOR QUE DERIVA EL FLUJO SISTÉMICO HACIA LA CIRCULACIÓN PULMONAR QUE IRRIGA UNA ZONA DE DISTRIBUCIÓN DESCONOCIDA"
  },
  {
    "codigo":57095008,
    "descripcion":"SEUDOALUCINACIONES"
  },
  {
    "codigo":448476001,
    "descripcion":"ESTENOSIS SUBPULMONAR"
  },
  {
    "codigo":55260003,
    "descripcion":"ESPOLÓN CALCÁNEO"
  },
  {
    "codigo":340501000119106,
    "descripcion":"DESPRENDIMIENTO HEMORRÁGICO DE EPITELIO PIGMENTARIO DE LA RETINA IZQUIERDA"
  },
  {
    "codigo":1234908005,
    "descripcion":"CONTINUACIÓN ÁCIGOS CONGÉNITA DE VENA CAVA INFERIOR"
  },
  {
    "codigo":284636007,
    "descripcion":"ARRANCARLE ALGO A OTRA PERSONA"
  },
  {
    "codigo":1169372007,
    "descripcion":"CAPTACIÓN DE T3 POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":250033003,
    "descripcion":"MARCHA DE ATAXIA VISUAL"
  },
  {
    "codigo":315569004,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: CHECO"
  },
  {
    "codigo":282801005,
    "descripcion":"LESIÓN DE GANGLIO SUBMAXILAR INFERIOR"
  },
  {
    "codigo":117126000,
    "descripcion":"CALIDAD DEL SOPLO CARDÍACO, RETUMBANTE"
  },
  {
    "codigo":53425008,
    "descripcion":"HEPATITIS VIRAL TIPO B ANICTÉRICA"
  },
  {
    "codigo":248198001,
    "descripcion":"FACIES ALÉRGICA"
  },
  {
    "codigo":18822004,
    "descripcion":"SÍNDROME DE LENTIGINOSIS CENTROFACIAL"
  },
  {
    "codigo":1264006004,
    "descripcion":"SÍNDROME AUTOINFLAMATORIO FAMILIAR POR FRÍO ASOCIADO AL GEN NLRC4"
  },
  {
    "codigo":1231238006,
    "descripcion":"MIOPATÍA EXTRAOCULAR INFILTRATIVA"
  },
  {
    "codigo":82523003,
    "descripcion":"INSUFICIENCIA CARDÍACA CONGESTIVA REUMÁTICA"
  },
  {
    "codigo":703280000,
    "descripcion":"HEMOSIDEROSIS DE MIEMBRO INFERIOR DEBIDA A INSUFICIENCIA VENOSA"
  },
  {
    "codigo":1260336006,
    "descripcion":"TRASTORNO DESMIELINIZANTE ADQUIRIDO DE NERVIO PERIFÉRICO"
  },
  {
    "codigo":275461003,
    "descripcion":"HERIDA DE UÑA DE DEDO DEL PIE"
  },
  {
    "codigo":46085004,
    "descripcion":"TROMBOSIS DE VENA RETINIANA"
  },
  {
    "codigo":766981007,
    "descripcion":"CARCINOMA ESCAMOCELULAR DE COLON"
  },
  {
    "codigo":765146000,
    "descripcion":"ALBINISMO OCULOCUTÁNEO, TIPO 1"
  },
  {
    "codigo":240858002,
    "descripcion":"ESTRONGILOIDIASIS MASIVA"
  },
  {
    "codigo":109786006,
    "descripcion":"MUCINOSIS ORAL FOCAL"
  },
  {
    "codigo":763311001,
    "descripcion":"ADRENOMIODISTROFIA"
  },
  {
    "codigo":44250009,
    "descripcion":"INFECCIÓN CAUSADA POR LOA LOA"
  },
  {
    "codigo":239023005,
    "descripcion":"SÍNDROME DE SALAMON"
  },
  {
    "codigo":75183008,
    "descripcion":"FUNCIÓN HEPÁTICA ANORMAL"
  },
  {
    "codigo":1187460003,
    "descripcion":"DISPLASIA RENAL MULTIQUÍSTICA UNILATERAL"
  },
  {
    "codigo":366425003,
    "descripcion":"AMPLITUD DE MOVIMIENTO PASIVO DE ROTACIÓN HACIA LA IZQUIERDA DE LA COLUMNA DORSAL - HALLAZGO"
  },
  {
    "codigo":169817006,
    "descripcion":"NACIMIENTO EN AMBULANCIA"
  },
  {
    "codigo":202585008,
    "descripcion":"OSTEOCONDROMATOSIS SINOVIAL DE ARTICULACIÓN SACROILÍACA"
  },
  {
    "codigo":4142001,
    "descripcion":"ASTENOPÍA MUSCULAR"
  },
  {
    "codigo":247688006,
    "descripcion":"DELIRIO HIPOCONDRÍACO"
  },
  {
    "codigo":67843002,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA ARTERIA AXILAR"
  },
  {
    "codigo":2307008,
    "descripcion":"NECROSIS GRASA DEL PÁNCREAS"
  },
  {
    "codigo":295384001,
    "descripcion":"SOBREDOSIS DE PIRENZEPINA"
  },
  {
    "codigo":262616003,
    "descripcion":"CUERPO EXTRAÑO EN LOS ÓRGANOS GENITALES Y PERINEO MASCULINOS"
  },
  {
    "codigo":721368008,
    "descripcion":"LESIÓN COMPLETA DE MÉDULA ESPINAL AL NIVEL DEL SEXTO SEGMENTO CERVICAL"
  },
  {
    "codigo":293549002,
    "descripcion":"REACCIÓN ADVERSA AL DINITRATO DE ISOSORBIDA PARENTERAL"
  },
  {
    "codigo":717698000,
    "descripcion":"ENDOMETRIOSIS DE INTESTINO DELGADO"
  },
  {
    "codigo":162477009,
    "descripcion":"SÍNTOMA QUE EMPEORA CON EL MOVIMIENTO"
  },
  {
    "codigo":1145517009,
    "descripcion":"APLASIA DE FALANGE DE DEDO MEÑIQUE"
  },
  {
    "codigo":193410003,
    "descripcion":"DISTROFIA PSEUDOINFLAMATORIA DE SORSBY DE FONDO DE OJO"
  },
  {
    "codigo":15631611000119106,
    "descripcion":"MÁCULA CICATRIZADA DE OJO DERECHO"
  },
  {
    "codigo":29570005,
    "descripcion":"ENFERMEDAD DE LEIGH"
  },
  {
    "codigo":160642005,
    "descripcion":"EJERCICIO ANAERÓBICO, DOS VECES POR SEMANA"
  },
  {
    "codigo":422786001,
    "descripcion":"CARECE DE APOYO EMOCIONAL"
  },
  {
    "codigo":224343000,
    "descripcion":"ASUNTOS BAJO LA JURISDICCIÓN DE UN JUZGADO"
  },
  {
    "codigo":715863001,
    "descripcion":"MIOPATÍA NECROSANTE AUTOINMUNITARIA"
  },
  {
    "codigo":27735002,
    "descripcion":"GLAUCOMA ASOCIADO CON TUMORES Y\/O QUISTES"
  },
  {
    "codigo":60503003,
    "descripcion":"RESORCIÓN INTERNA DE LA RAÍZ DEL DIENTE"
  },
  {
    "codigo":95106009,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE HUESO ESFENOIDES"
  },
  {
    "codigo":226178008,
    "descripcion":"DIETA CON BAJO CONTENIDO DE NÍQUEL"
  },
  {
    "codigo":1141847006,
    "descripcion":"EOSINOFILIA GASTROINTESTINAL"
  },
  {
    "codigo":289879005,
    "descripcion":"TONO MUSCULAR PÉLVICO POBRE"
  },
  {
    "codigo":93271008,
    "descripcion":"HIPOPLASIA CONGÉNITA DE VÁLVULA MITRAL"
  },
  {
    "codigo":124204003,
    "descripcion":"DEFICIENCIA DE YODURO PEROXIDASA"
  },
  {
    "codigo":1303852006,
    "descripcion":"REACCIÓN ADVERSA A COMPONENTE DE VACUNA QUE CONTIENE ANTÍGENO DE ALFAHERPESVIRUS 3 HUMANO"
  },
  {
    "codigo":25900007,
    "descripcion":"REORDENAMIENTO GENÉTICO, LINFOCITOS B, CADENA PESADA"
  },
  {
    "codigo":417281001,
    "descripcion":"PACIENTE QUE RECIBE LA DOSIS MÁXIMA TOLERADA DE INHIBIDOR DE ENZIMA CONVERTIDORA DE ANGIOTENSINA"
  },
  {
    "codigo":286209002,
    "descripcion":"NO GESTICULA AL HABLAR"
  },
  {
    "codigo":253441007,
    "descripcion":"DOBLE ORIFICIO DE VÁLVULA AURICULOVENTRICULAR COMÚN"
  },
  {
    "codigo":89601008,
    "descripcion":"TIC DE ORIGEN ORGÁNICO"
  },
  {
    "codigo":1269249008,
    "descripcion":"INFECCIÓN DE PELVIS DEBIDA A ABORTO INCOMPLETO"
  },
  {
    "codigo":22230001,
    "descripcion":"TRASTORNO DE PÁNICO CON AGORAFOBIA, EVITACIÓN AGORAFÓBICA EN REMISIÓN PARCIAL Y ATAQUES DE PÁNICO EN REMISIÓN TOTAL"
  },
  {
    "codigo":72413003,
    "descripcion":"SEDUCCIÓN MASCULINA"
  },
  {
    "codigo":448214005,
    "descripcion":"NEOPLASIA EPITELIAL MALIGNA DE OROFARINGE"
  },
  {
    "codigo":251606006,
    "descripcion":"FORMA DE LA ONDA DEL POTENCIAL EVOCADO VISUAL EN RESPUESTA AL DESTELLO"
  },
  {
    "codigo":1003435001,
    "descripcion":"NEVO LINEAL DE CÉLULAS BASALES"
  },
  {
    "codigo":249771001,
    "descripcion":"CAMBIO EN EL TAMAÑO DEL ANILLO - HALLAZGO"
  },
  {
    "codigo":282539008,
    "descripcion":"NO EMPIEZA A CORRER"
  },
  {
    "codigo":870528001,
    "descripcion":"DIABETES MELLITUS TIPO 1 RECIENTEMENTE DIAGNOSTICADA"
  },
  {
    "codigo":247936002,
    "descripcion":"PRESIÓN REPETITIVA SOBRE LOS OJOS"
  },
  {
    "codigo":1296512009,
    "descripcion":"PRESIÓN DE VENTRÍCULO IZQUIERDO DURANTE MESODIÁSTOLE POR DEBAJO DE RANGO DE REFERENCIA"
  },
  {
    "codigo":772224009,
    "descripcion":"SÍNDROME MICRO DE WARBURG"
  },
  {
    "codigo":16018711000119109,
    "descripcion":"DEFORMIDAD CONGÉNITA DE DEDO DE LA MANO DERECHA"
  },
  {
    "codigo":80426004,
    "descripcion":"HEMORROIDES INTERNAS PROLAPSADAS"
  },
  {
    "codigo":735786006,
    "descripcion":"LACERACIÓN DE ESTÓMAGO CON DAÑO MASIVO"
  },
  {
    "codigo":768554008,
    "descripcion":"HIPERMANGANESEMIA CON DISTONÍA TIPO 2"
  },
  {
    "codigo":1260074009,
    "descripcion":"CARCINOMA ESCAMOSO PAPILAR DE HIPOFARINGE"
  },
  {
    "codigo":733951003,
    "descripcion":"CARIES DENTAL PRIMARIA INACTIVA QUE SE EXTIENDE HASTA EL TERCIO EXTERNO DE LA DENTINA"
  },
  {
    "codigo":45823004,
    "descripcion":"PÓLIPO DE TROMPA DE FALOPIO"
  },
  {
    "codigo":111359004,
    "descripcion":"DIVERTICULITIS DE COLON"
  },
  {
    "codigo":766719006,
    "descripcion":"DISOMÍA UNIPARENTAL PATERNA DEL CROMOSOMA 1"
  },
  {
    "codigo":209663008,
    "descripcion":"SECCIÓN EXPUESTA DE LIGAMENTO LATERAL INTERNO DE CODO"
  },
  {
    "codigo":345521000119105,
    "descripcion":"QUERATOCONOS ESTABLES DE AMBOS OJOS"
  },
  {
    "codigo":109524009,
    "descripcion":"HIPOPLASIA MANDIBULAR VERTICAL CONGÉNITA"
  },
  {
    "codigo":894121003,
    "descripcion":"CUADRANTOPSIA HOMÓNIMA SUPERIOR DERECHA"
  },
  {
    "codigo":304297005,
    "descripcion":"AMPLITUD DE MOVIMIENTO DE HOMBRO DISMINUIDA"
  },
  {
    "codigo":402601007,
    "descripcion":"URTICARIA FÍSICA"
  },
  {
    "codigo":1252734000,
    "descripcion":"NÓDULO DE PIEL DE PULGAR"
  },
  {
    "codigo":238761009,
    "descripcion":"TELANGIECTASIA CUTÁNEA IDIOPÁTICA PRIMARIA"
  },
  {
    "codigo":1287337008,
    "descripcion":"TUMOR POSITIVO PARA RECEPTOR DE PROLACTINA"
  },
  {
    "codigo":319051000119102,
    "descripcion":"ARTRITIS REUMATOIDEA SERONEGATIVA DE ARTICULACIÓN DE RODILLA IZQUIERDA"
  },
  {
    "codigo":209288005,
    "descripcion":"FRACTURA-SUBLUXACIÓN NO EXPUESTA DE HUESO SEMILUNAR (PALMAR)"
  },
  {
    "codigo":7550008,
    "descripcion":"TAQUIPNEA TRANSITORIA DEL RECIÉN NACIDO"
  },
  {
    "codigo":366163001,
    "descripcion":"HALLAZGO EN LA PRESIÓN VENOSA YUGULAR"
  },
  {
    "codigo":1187198009,
    "descripcion":"TASA DE FILTRACIÓN GLOMERULAR DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":300627003,
    "descripcion":"CAPAZ DE VIAJAR EN TRANSPORTE PRIVADO"
  },
  {
    "codigo":726611001,
    "descripcion":"PARAPLEJÍA ESPÁSTICA AUTOSÓMICA RECESIVA TIPO 61"
  },
  {
    "codigo":235091005,
    "descripcion":"RELACIÓN DEL SEGMENTO BUCAL CLASE II - UNIDAD MEDIA"
  },
  {
    "codigo":1281832002,
    "descripcion":"CRISIS EPILÉPTICA CON DETENCIÓN DEL COMPORTAMIENTO CON CONCIENCIA PRESERVADA DE INICIO FOCAL"
  },
  {
    "codigo":167720003,
    "descripcion":"LCR: ERITROCITOSIS"
  },
  {
    "codigo":36648005,
    "descripcion":"AMPOLLA DE LA NARIZ, SIN INFECCIÓN"
  },
  {
    "codigo":292581000119100,
    "descripcion":"NEUROMA DE EXTREMIDAD INFERIOR DERECHA POSTERIOR A CIRUGÍA"
  },
  {
    "codigo":724776007,
    "descripcion":"DEMENCIA DEBIDA A TRASTORNO DEL SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":298792008,
    "descripcion":"AMPLITUD DE EXTENSIÓN PASIVA DE HOMBRO NORMAL"
  },
  {
    "codigo":1148925003,
    "descripcion":"PIURIA IDIOPÁTICA"
  },
  {
    "codigo":722941003,
    "descripcion":"HIPERTIROIDISMO SECUNDARIO"
  },
  {
    "codigo":34813004,
    "descripcion":"FRACTURA DE FOSA POSTERIOR"
  },
  {
    "codigo":428029006,
    "descripcion":"TRASTORNO DE CARTÍLAGO ARTICULAR DE CODO"
  },
  {
    "codigo":295122008,
    "descripcion":"SOBREDOSIS DE FÁRMACO ANALGÉSICO"
  },
  {
    "codigo":719271000,
    "descripcion":"HETEROPLASIA ÓSEA PROGRESIVA"
  },
  {
    "codigo":194983005,
    "descripcion":"INSUFICIENCIA DE VÁLVULA AÓRTICA, NO REUMÁTICA"
  },
  {
    "codigo":293287009,
    "descripcion":"METAHEMOGLOBINURIA TÓXICA"
  },
  {
    "codigo":291452001,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR QUININA"
  },
  {
    "codigo":193148004,
    "descripcion":"LESIÓN DE NERVIO PLANTAR"
  },
  {
    "codigo":94844005,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL ANTEBRAZO"
  },
  {
    "codigo":289617000,
    "descripcion":"PROBLEMA DEL HIMEN VAGINAL"
  },
  {
    "codigo":1010513001,
    "descripcion":"ESCLEROSIS DE EPÍFISIS DE FALANGE PROXIMAL DE MANO CON RADIOPACIDAD AUMENTADA"
  },
  {
    "codigo":93009002,
    "descripcion":"ANOMALÍA CONGÉNITA DE HUESO LAGRIMAL"
  },
  {
    "codigo":224081002,
    "descripcion":"OBSERVANCIA FANÁTICA DE PRÁCTICAS RELIGIOSAS"
  },
  {
    "codigo":60241006,
    "descripcion":"INCONTINENCIA URINARIA DE ESFUERZO EN LA MUJER"
  },
  {
    "codigo":1172518001,
    "descripcion":"PREGNANETRIOL DENTRO DE RANGO DE REFERENCIA"
  },
  {
    "codigo":123942005,
    "descripcion":"INTOXICACIÓN POR JUNCAGINACEAE"
  },
  {
    "codigo":417019000,
    "descripcion":"ARTERIOLITIS RETINIANA"
  },
  {
    "codigo":285947006,
    "descripcion":"CAPAZ DE INSERTAR Y REMOVER EL TAPÓN DE LA PILETA"
  },
  {
    "codigo":710096000,
    "descripcion":"PERIODONTITIS DEBIDA A SÍNDROME HISTIOCÍTICO"
  },
  {
    "codigo":253179009,
    "descripcion":"DISPLASIA CORTICAL DEL CEREBELO"
  },
  {
    "codigo":447952002,
    "descripcion":"LIPOMA DE YEYUNO"
  },
  {
    "codigo":415184000,
    "descripcion":"HALLAZGO RELACIONADO CON EL TIEMPO DE PROTROMBINA"
  },
  {
    "codigo":54736008,
    "descripcion":"XANTOMA PLANO DE PÁRPADO"
  },
  {
    "codigo":249509001,
    "descripcion":"INCAPAZ DE ELIMINAR GASES"
  },
  {
    "codigo":284112009,
    "descripcion":"NO CONTROLA LA POSICIÓN DE LA CABEZA"
  },
  {
    "codigo":216741002,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR METIL BROMURO"
  },
  {
    "codigo":15722521000119101,
    "descripcion":"ARTROSIS DE ARTICULACIÓN SUBASTRAGALINA DERECHA"
  },
  {
    "codigo":870266002,
    "descripcion":"TRASTORNO GENERALIZADO DEL DESARROLLO CON TRASTORNO DEL DESARROLLO INTELECTUAL Y ALTERACIÓN ACENTUADA DEL LENGUAJE FUNCIONAL CON PÉRDIDA DE HABILIDADES ADQUIRIDAS PREVIAMENTE"
  },
  {
    "codigo":409679007,
    "descripcion":"FIEBRE HEMORRÁGICA POR DENGUE, GRADO IV"
  },
  {
    "codigo":278607007,
    "descripcion":"DISPOSITIVO DE ORTODONCIA - HALLAZGO"
  },
  {
    "codigo":737359009,
    "descripcion":"ADENOMA UMBILICAL"
  },
  {
    "codigo":473380002,
    "descripcion":"PERFORACIÓN DE VALVA DE VÁLVULA AURICULOVENTRICULAR IZQUIERDA (MORFOLÓGICAMENTE NO MITRAL)"
  },
  {
    "codigo":309540005,
    "descripcion":"MASA DE LA ESPINILLA"
  },
  {
    "codigo":702756006,
    "descripcion":"HUMEDAD DE LA PIEL, NORMAL"
  },
  {
    "codigo":211236007,
    "descripcion":"SÍNDROME DEL ESCALENO ANTICUS"
  },
  {
    "codigo":1290745000,
    "descripcion":"ARTRITIS REACTIVA DE ARTICULACIÓN DE TOBILLO DEBIDA A DISENTERÍA Y POSTERIOR A ELLA"
  },
  {
    "codigo":1259812009,
    "descripcion":"ASTROBLASTOMA CEREBRAL PRIMARIO"
  },
  {
    "codigo":735524009,
    "descripcion":"ESTADIO CLÍNICO 2 DE INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA DE LA ORGANIZACIÓN MUNDIAL DE LA SALUD DE 2007 CONCOMITANTE CON PALUDISMO"
  },
  {
    "codigo":209401004,
    "descripcion":"FRACTURA-SUBLUXACIÓN ANTERIOR NO EXPUESTA DE ARTICULACIÓN ESTERNOCLAVICULAR"
  },
  {
    "codigo":897529004,
    "descripcion":"DELECIÓN DISTAL DEL BRAZO LARGO DEL CROMOSOMA 7"
  },
  {
    "codigo":406009006,
    "descripcion":"HAPLOTIPO CDE"
  },
  {
    "codigo":404174000,
    "descripcion":"ECTIMA GANGRENOSO NEONATAL"
  },
  {
    "codigo":305870003,
    "descripcion":"ATENDIDO POR SERVICIO DE PSICOGERIATRÍA"
  },
  {
    "codigo":764622004,
    "descripcion":"SÍNDROME DE TRISOMÍA 17 MOSAICO"
  },
  {
    "codigo":240334006,
    "descripcion":"INTOXICACIÓN ALIMENTARIA POR YERSINIA ENTEROCOLITICA"
  },
  {
    "codigo":109262008,
    "descripcion":"MUCOSITIS AGUDA"
  },
  {
    "codigo":238499001,
    "descripcion":"NÓDULO DE LOS LECHEROS"
  },
  {
    "codigo":9123002,
    "descripcion":"TURBIDEZ AUMENTADA"
  },
  {
    "codigo":402339007,
    "descripcion":"DISTROFIA UNGUEAL CONCOMITANTE CON TRÍADA DE ARTRITIS REACTIVA"
  },
  {
    "codigo":236664000,
    "descripcion":"INCONTINENCIA POSMICCIONAL"
  },
  {
    "codigo":302200001,
    "descripcion":"PALIDEZ DE LA PAPILA ÓPTICA"
  },
  {
    "codigo":300365004,
    "descripcion":"VÓMITO ALIMENTARIO"
  },
  {
    "codigo":726349006,
    "descripcion":"TRISOMÍA PARCIAL DE CROMOSOMA 10"
  },
  {
    "codigo":890189007,
    "descripcion":"SUSCEPTIBILIDAD GENÉTICA A LA HIPERTERMIA MALIGNA"
  },
  {
    "codigo":167458000,
    "descripcion":"ELECTROFORESIS DE PROTEÍNAS URINARIAS FUERA DE RANGO DE REFERENCIA"
  },
  {
    "codigo":365901009,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA RECORDAR SONIDOS"
  },
  {
    "codigo":724514003,
    "descripcion":"PERISTALTISMO ESOFÁGICO HIPERTENSIVO"
  },
  {
    "codigo":36386007,
    "descripcion":"ACOSO SEXUAL EVIDENTE POR PARTE DE UN HOMBRE"
  },
  {
    "codigo":394999002,
    "descripcion":"CALLOSIDAD EN LA MANO"
  },
  {
    "codigo":1279735004,
    "descripcion":"ROTURA DE RETINA DE AMBOS OJOS"
  },
  {
    "codigo":722679006,
    "descripcion":"ADENOCARCINOMA MUCINOSO PRIMARIO DE ENDOMETRIO"
  },
  {
    "codigo":360396000,
    "descripcion":"DEFORMIDAD DE LA MAMA"
  },
  {
    "codigo":1148663009,
    "descripcion":"ELECTRORRETINOGRAMA MULTIFOCAL ANORMAL"
  },
  {
    "codigo":196556002,
    "descripcion":"ECTROPIÓN ADQUIRIDO DE LABIO"
  },
  {
    "codigo":296695009,
    "descripcion":"SOBREDOSIS DE CEFALOSPORINA DE SEGUNDA GENERACIÓN"
  },
  {
    "codigo":165623008,
    "descripcion":"HIERRO SÉRICO POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":324071000119100,
    "descripcion":"LUXACIÓN DE TOBILLO DEBIDA A DISPLASIA CONGÉNITA"
  },
  {
    "codigo":131020007,
    "descripcion":"NIVEL DE HORMONA FOLICULOESTIMULANTE HIPOFISARIA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":425932008,
    "descripcion":"TROMBOSIS DE ARTERIA COMUNICANTE POSTERIOR"
  },
  {
    "codigo":63649001,
    "descripcion":"TRASTORNO DELUSORIO DE CANNABIS"
  },
  {
    "codigo":16052711000119101,
    "descripcion":"TENDINOSIS DE RODILLA IZQUIERDA"
  },
  {
    "codigo":293025005,
    "descripcion":"REACCIÓN ADVERSA AL ÁCIDO MANDÉLICO"
  },
  {
    "codigo":719009006,
    "descripcion":"DISCAPACIDAD INTELECTUAL LIGADA AL CROMOSOMA X TIPO WILSON"
  },
  {
    "codigo":1144993006,
    "descripcion":"AMENORREA DEBIDA A TRASTORNO HIPOTALÁMICO"
  },
  {
    "codigo":784545009,
    "descripcion":"SINOVITIS DE ARTICULACIÓN DE TOBILLO"
  },
  {
    "codigo":260257009,
    "descripcion":"N10"
  },
  {
    "codigo":291190004,
    "descripcion":"INTOXICACIÓN POR TIORIDAZINA"
  },
  {
    "codigo":94582005,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE PARTES BLANDAS DEL ABDOMEN"
  },
  {
    "codigo":225654005,
    "descripcion":"TEMPERAMENTAL"
  },
  {
    "codigo":127350007,
    "descripcion":"ACCIDENTE AUTOMOVILÍSTICO, PASAJERO"
  },
  {
    "codigo":59979003,
    "descripcion":"TRASTORNO DE LA SEGUNDA DIVISIÓN DEL QUINTO PAR CRANEAL"
  },
  {
    "codigo":715339004,
    "descripcion":"QUERATITIS AUTOSÓMICA DOMINANTE"
  },
  {
    "codigo":92747005,
    "descripcion":"CARCINOMA IN SITU DE LA PIEL DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":289355004,
    "descripcion":"SITUACIÓN OBLICUA CON CABEZA EN FOSA ILÍACA DERECHA"
  },
  {
    "codigo":713504001,
    "descripcion":"TRASTORNO RENAL CONCOMITANTE CON INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":58144006,
    "descripcion":"PERIARTERITIS NUDOSA BENIGNA DE LA PIEL"
  },
  {
    "codigo":89077005,
    "descripcion":"ALTERACIÓN DE LA COLORACIÓN UNGUEAL"
  },
  {
    "codigo":285685006,
    "descripcion":"CARGA PESO EN PIERNA DERECHA"
  },
  {
    "codigo":56309007,
    "descripcion":"ESTENOSIS SUBAÓRTICA CONGÉNITA TIPO TÚNEL"
  },
  {
    "codigo":449525009,
    "descripcion":"DISMINUCIÓN ESPONTÁNEA DEL TAMAÑO DE DEFECTO DEL TABIQUE INTERVENTRICULAR DEBIDO A REACCIÓN FIBROMUSCULAR"
  },
  {
    "codigo":1332426003,
    "descripcion":"HISTIOCITOSIS DE CÉLULAS DE LANGERHANS DISEMINADA DE GANGLIOS LINFÁTICOS CERVICALES"
  },
  {
    "codigo":87242005,
    "descripcion":"PATRÓN DE IMPULSO EXTENSOR"
  },
  {
    "codigo":283850006,
    "descripcion":"LESIÓN POR DESOLLAMIENTO DE MIEMBRO INFERIOR"
  },
  {
    "codigo":447690005,
    "descripcion":"PROLAPSO DE VÁLVULA DE EUSTAQUIO A TRAVÉS DE VÁLVULA TRICÚSPIDE"
  },
  {
    "codigo":19871000,
    "descripcion":"DISTROFIA COROIDEA GENERALIZADA TOTAL"
  },
  {
    "codigo":1363359002,
    "descripcion":"ATROFIA DE PARTES BLANDAS DE ÓRBITA, BILATERAL"
  },
  {
    "codigo":183711002,
    "descripcion":"CONSULTA DOMICILIARIA DE DERMATOLOGÍA SOLICITADA"
  },
  {
    "codigo":216479006,
    "descripcion":"INTOXICACIÓN ACCIDENTAL CAUSADA POR DERIVADOS DE PIRAZOL"
  },
  {
    "codigo":249247007,
    "descripcion":"PENE CURVADO"
  },
  {
    "codigo":52639008,
    "descripcion":"ADAPTACIÓN SOCIAL"
  },
  {
    "codigo":116340000,
    "descripcion":"TRASTORNO DEL APRENDIZAJE COGNITIVO"
  },
  {
    "codigo":314783008,
    "descripcion":"SÍNDROME PROTUBERANCIAL DEL UNO Y MEDIO"
  },
  {
    "codigo":1197684002,
    "descripcion":"ESOFAGITIS DEBIDA A ENFERMEDAD AUTOINMUNITARIA"
  },
  {
    "codigo":1090331000119100,
    "descripcion":"COCCIDIOIDOMICOSIS PROSTÁTICA"
  },
  {
    "codigo":247412007,
    "descripcion":"DOLOR DE PARTO"
  },
  {
    "codigo":1163081002,
    "descripcion":"DUODENITIS POR GIARDIA LAMBLIA"
  },
  {
    "codigo":212809004,
    "descripcion":"EFECTO TÓXICO DEL ALCOHOL METÍLICO"
  },
  {
    "codigo":442185004,
    "descripcion":"CATECOLAMINA EN ESPÉCIMEN DE ORINA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":704329006,
    "descripcion":"FRACTURA OSTEOPORÓTICA DE CLAVÍCULA"
  },
  {
    "codigo":14366000,
    "descripcion":"QUERATOCONJUNTIVITIS POR EXPOSICIÓN"
  },
  {
    "codigo":440350001,
    "descripcion":"CRANEOSINOSTOSIS RELACIONADA CON EL RECEPTOR DEL FACTOR DE CRECIMIENTO FIBROBLÁSTICO TIPO 3"
  },
  {
    "codigo":47134002,
    "descripcion":"MASTITIS NO INFECCIOSA DEL RECIÉN NACIDO"
  },
  {
    "codigo":276510003,
    "descripcion":"TRASTORNOS CARDIOVASCULARES PERINATALES"
  },
  {
    "codigo":1290483000,
    "descripcion":"RADIOGRAFÍA DE DEDO PULGAR NORMAL"
  },
  {
    "codigo":209139001,
    "descripcion":"SUBLUXACIÓN NO EXPUESTA ENTRE LA TERCERA Y CUARTA VÉRTEBRAS CERVICALES"
  },
  {
    "codigo":405747002,
    "descripcion":"ASPIRINA NO ADMINISTRADA"
  },
  {
    "codigo":45299002,
    "descripcion":"NEUROPATÍA AUTONÓMICA INTESTINAL"
  },
  {
    "codigo":12531002,
    "descripcion":"DISPERSIÓN GRUESA"
  },
  {
    "codigo":471283005,
    "descripcion":"ESCAPE DE AIRE DEL PULMÓN"
  },
  {
    "codigo":274675006,
    "descripcion":"FACTOR PSICOSOMÁTICO EN UNA AFECCIÓN FÍSICA, COMPONENTE PSICOLÓGICO MODERADO"
  },
  {
    "codigo":372979003,
    "descripcion":"INFECCIÓN CAUSADA POR ASPERGILLUS CLAVATO-NANICA"
  },
  {
    "codigo":241907009,
    "descripcion":"CEMENTO POLIESTIRENO QUE CAUSA EFECTOS TÓXICOS"
  },
  {
    "codigo":43464002,
    "descripcion":"REGURGITACIÓN DE PIGMENTO BILIAR"
  },
  {
    "codigo":1255880003,
    "descripcion":"ORINA DESPUÉS DE TENER RELACIONES SEXUALES"
  },
  {
    "codigo":403912001,
    "descripcion":"CARCINOMA BASOCELULAR QUÍSTICO"
  },
  {
    "codigo":305608007,
    "descripcion":"BAJO ATENCIÓN DE TERAPEUTA OCUPACIONAL HOSPITALARIO"
  },
  {
    "codigo":1155741000,
    "descripcion":"INTOXICACIÓN POR SULFONAMIDA ANTIBACTERIANA"
  },
  {
    "codigo":860829004,
    "descripcion":"NEOPLASIA DE ESTROMA GASTROINTESTINAL DE DIVERTÍCULO DE MECKEL"
  },
  {
    "codigo":762525005,
    "descripcion":"CUERPO EXTRAÑO NO MAGNÉTICO RETENIDO EN OJO IZQUIERDO"
  },
  {
    "codigo":926365009,
    "descripcion":"HALLAZGO EN LA INFUSIÓN PARA NUTRICIÓN PARENTERAL"
  },
  {
    "codigo":269170001,
    "descripcion":"HERIDA ABIERTA EN EL GLÚTEO"
  },
  {
    "codigo":301938007,
    "descripcion":"TAMAÑO DE LA PUPILA - HALLAZGO"
  },
  {
    "codigo":236402009,
    "descripcion":"GLOMERULOPATÍA ISQUÉMICA"
  },
  {
    "codigo":1119303003,
    "descripcion":"COVID-19 POST-AGUDO"
  },
  {
    "codigo":365639004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA RECONOCERSE A UNO MISMO"
  },
  {
    "codigo":300103004,
    "descripcion":"DOLOR A LA PALPACIÓN EN PABELLÓN AURICULAR"
  },
  {
    "codigo":298268001,
    "descripcion":"DOLOR A LA PALPACIÓN EN TENDÓN"
  },
  {
    "codigo":429340002,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO ESQUELÉTICO"
  },
  {
    "codigo":36124002,
    "descripcion":"HIPERSOMNIA PRIMARIA"
  },
  {
    "codigo":1521007,
    "descripcion":"AMPOLLA DE LA NALGA, SIN INFECCIÓN"
  },
  {
    "codigo":296433008,
    "descripcion":"SOBREDOSIS DE HIDROXIZINA"
  },
  {
    "codigo":294598001,
    "descripcion":"ALERGIA A ESTIBOGLUCONATO DE SODIO"
  },
  {
    "codigo":32454003,
    "descripcion":"ANOMALÍA CONGÉNITA DE LA GLÁNDULA TIROIDES"
  },
  {
    "codigo":292763000,
    "descripcion":"REACCIÓN ADVERSA A SOLUCIÓN DE HEMOFILTRACIÓN"
  },
  {
    "codigo":63387002,
    "descripcion":"SÍNDROME DE LARSEN"
  },
  {
    "codigo":127088000,
    "descripcion":"LINFADENOPATÍA SUPRACLAVICULAR"
  },
  {
    "codigo":94320003,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA CURVATURA MAYOR DEL ESTÓMAGO"
  },
  {
    "codigo":10949711000119106,
    "descripcion":"HERIDA ABIERTA DE ANTEBRAZO IZQUIERDO DEBIDA A MORDEDURA DE PERRO"
  },
  {
    "codigo":1092841000119100,
    "descripcion":"ABSCESO DE INTESTINO CONCOMITANTE CON COLITIS ULCEROSA Y DEBIDO A ELLA"
  },
  {
    "codigo":61552005,
    "descripcion":"RITMO VENTRICULAR POR ESTIMULACIÓN ARTIFICIAL"
  },
  {
    "codigo":290928008,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR VILOXAZINA"
  },
  {
    "codigo":715077002,
    "descripcion":"CAPAZ DE PASAR DE LA CAMA A UNA SILLA DE RUEDAS"
  },
  {
    "codigo":92485009,
    "descripcion":"NEOPLASIA BENIGNA DEL VÓMER"
  },
  {
    "codigo":254490002,
    "descripcion":"NEOPLASIA DE ORIFICIO DE TROMPA DE EUSTAQUIO"
  },
  {
    "codigo":1237530005,
    "descripcion":"METÁSTASIS DE ADENOCARCINOMA EN CUERPO CAROTÍDEO"
  },
  {
    "codigo":25114006,
    "descripcion":"FLEBITIS DE LAS VENAS PROFUNDAS DE LA EXTREMIDAD INFERIOR"
  },
  {
    "codigo":418330007,
    "descripcion":"FÍSTULA DE GLÁNDULA LAGRIMAL"
  },
  {
    "codigo":711407000,
    "descripcion":"TROMBOCITOPATÍA, ASPLENIA Y MIOSIS"
  },
  {
    "codigo":1335834005,
    "descripcion":"CERVICITIS POR MYCOPLASMA GENITALIUM"
  },
  {
    "codigo":1268463007,
    "descripcion":"LESIÓN DE MÉDULA ESPINAL DORSAL DEBIDA A LUXACIÓN DE ARTICULACIÓN DE COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":10759401000119105,
    "descripcion":"RASGO DREPANOCÍTICO EN LA MADRE QUE COMPLICA EL NACIMIENTO"
  },
  {
    "codigo":285423008,
    "descripcion":"GAMMAPATÍA MONOCLONAL POR IGA DE SIGNIFICACIÓN INCIERTA"
  },
  {
    "codigo":283588002,
    "descripcion":"HERIDA DE PERDIGÓN EN TOBILLO"
  },
  {
    "codigo":414660003,
    "descripcion":"HALLAZGO RELACIONADO CON MEGACARIOCITOS"
  },
  {
    "codigo":185284002,
    "descripcion":"ATENDIDO POR NUTRICIONISTA"
  },
  {
    "codigo":54212005,
    "descripcion":"CONTRACCIONES UTERINAS IRREGULARES"
  },
  {
    "codigo":890120009,
    "descripcion":"MIOCARDIOPATÍA HIPERTRÓFICA DEBIDA A TRASTORNO NEUROMUSCULAR"
  },
  {
    "codigo":609433001,
    "descripcion":"DISPOSICIÓN HIPERSENSIBLE"
  },
  {
    "codigo":871577001,
    "descripcion":"REACCIÓN ADVERSA A FENILPROPANOLAMINA"
  },
  {
    "codigo":50542000,
    "descripcion":"MELANOMA, NIVEL 2 DE CLARK"
  },
  {
    "codigo":248985009,
    "descripcion":"PRESENTACIÓN EN EL EMBARAZO"
  },
  {
    "codigo":1363097009,
    "descripcion":"ASTILLA EN GLÚTEO CON INFECCIÓN"
  },
  {
    "codigo":11824361000119109,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE BRAZO IZQUIERDO"
  },
  {
    "codigo":247150008,
    "descripcion":"CAMBIO MACULAR CON PATRÓN"
  },
  {
    "codigo":704067000,
    "descripcion":"FRACTURA POR ESTRÉS DE FÉMUR"
  },
  {
    "codigo":1162819002,
    "descripcion":"SOBREDOSIS INTENCIONAL DE LITIO Y\/O COMPUESTO DE LITIO"
  },
  {
    "codigo":81475007,
    "descripcion":"RESISTENCIA ADQUIRIDA A HORMONA ANTIDIURÉTICA"
  },
  {
    "codigo":1193752001,
    "descripcion":"INFLAMACIÓN INTESTINAL DEBIDA A ENFERMEDAD POR VIH"
  },
  {
    "codigo":472856002,
    "descripcion":"FRACTURA EXPUESTA DE HUESO DE MUÑECA Y\/O MANO"
  },
  {
    "codigo":866072004,
    "descripcion":"MELANOMA MALIGNO DE ÓRBITA"
  },
  {
    "codigo":210712004,
    "descripcion":"HERIDA ABIERTA DEL PIE, DORSO"
  },
  {
    "codigo":15949341000119100,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS INTRAEPIDÉRMICO DE AMBOS MIEMBROS SUPERIORES"
  },
  {
    "codigo":733165000,
    "descripcion":"CELULITIS ANOGENITAL DE LA LACTANCIA Y LA INFANCIA CAUSADA POR STREPTOCOCCUS BETA-HEMOLÍTICO DEL GRUPO A"
  },
  {
    "codigo":309016009,
    "descripcion":"DERIVADO A UNA PERSONA"
  },
  {
    "codigo":897005004,
    "descripcion":"VÁRICES DE ESÓFAGO DEBIDAS A CIRROSIS HEPÁTICA ALCOHÓLICA"
  },
  {
    "codigo":12269006,
    "descripcion":"RECESIÓN GINGIVAL DESPUÉS DE ENFERMEDAD INFECCIOSA"
  },
  {
    "codigo":272578002,
    "descripcion":"ACOSTADO EN DECÚBITO LATERAL EN EL AGUA"
  },
  {
    "codigo":239810002,
    "descripcion":"ESPONDILITIS ANQUILOSANTE CON COMPROMISO ORGÁNICO\/SISTÉMICO"
  },
  {
    "codigo":764098007,
    "descripcion":"SORDERA GENÉTICA PRELOCUTIVA NO SINDRÓMICA"
  },
  {
    "codigo":75970008,
    "descripcion":"TRASTORNO HEREDITARIO POLIGÉNICO"
  },
  {
    "codigo":403650009,
    "descripcion":"PSEUDOCICATRIZ ESTRELLADA CAUSADA POR CORTICOSTEROIDE"
  },
  {
    "codigo":762263003,
    "descripcion":"INCONTINENCIA URINARIA POR REBOSAMIENTO DEBIDA A PROLAPSO DE ÓRGANO GENITAL FEMENINO"
  },
  {
    "codigo":205207007,
    "descripcion":"DEFICIENCIA TRANSVERSA DE EXTREMIDAD INFERIOR - A TRAVÉS DE TIBIA\/PERONÉ"
  },
  {
    "codigo":237975008,
    "descripcion":"DEFICIENCIA DE LACTASA"
  },
  {
    "codigo":301676004,
    "descripcion":"INCAPAZ DE LEVANTARSE DE UNA CAMA"
  },
  {
    "codigo":72300008,
    "descripcion":"RIGIDEZ ABDOMINAL"
  },
  {
    "codigo":399980009,
    "descripcion":"ARTERITIS NECROSANTE"
  },
  {
    "codigo":365377001,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA INICIAR JUEGOS ESPONTÁNEOS"
  },
  {
    "codigo":299841003,
    "descripcion":"REFLEJO SUPINADOR INVERTIDO"
  },
  {
    "codigo":267073005,
    "descripcion":"SUICIDA"
  },
  {
    "codigo":1217345006,
    "descripcion":"NIVEL DE SUSTANCIA EN ORINA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":166934000,
    "descripcion":"NIVEL TERAPÉUTICO DE TEOFILINA"
  },
  {
    "codigo":201537009,
    "descripcion":"ARTROPATÍA ASOCIADA CON MICOSIS, DE LA MANO"
  },
  {
    "codigo":298006005,
    "descripcion":"HERIDA CURADA"
  },
  {
    "codigo":10679991000119103,
    "descripcion":"TUMORACIÓN DEL TEJIDO CELULAR SUBCUTÁNEO DE DEDO DE LA MANO DERECHA"
  },
  {
    "codigo":230635000,
    "descripcion":"COMPRESIÓN SUPRAESCAPULAR NERVIOSA"
  },
  {
    "codigo":3094009,
    "descripcion":"VÓMITO EN LACTANTES Y\/O NIÑOS"
  },
  {
    "codigo":1279539008,
    "descripcion":"VÍCTIMA DE VIOLENCIA DOMÉSTICA"
  },
  {
    "codigo":1259003,
    "descripcion":"ESQUISTOSIS"
  },
  {
    "codigo":197867004,
    "descripcion":"DIVERTÍCULO ADQUIRIDO DE VEJIGA URINARIA"
  },
  {
    "codigo":427243007,
    "descripcion":"DISPOSICIÓN PARA FORTALECER LA RELIGIOSIDAD"
  },
  {
    "codigo":296171008,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE RISPERIDONA"
  },
  {
    "codigo":64960002,
    "descripcion":"INFESTACIÓN CAUSADA POR CIMEX LECTULARIUS"
  },
  {
    "codigo":292501003,
    "descripcion":"REACCIÓN ADVERSA A LA RITODRINA"
  },
  {
    "codigo":718485003,
    "descripcion":"DILATACIÓN CONGÉNITA DE URÉTER"
  },
  {
    "codigo":1144469005,
    "descripcion":"APLASIA DE FALANGE PROXIMAL DE PULGAR"
  },
  {
    "codigo":16004791000119108,
    "descripcion":"VARIANZA CUBITAL POSITIVA CONGÉNITA DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":95893008,
    "descripcion":"MUGUET SEUDOMEMBRANOSO"
  },
  {
    "codigo":716650003,
    "descripcion":"MESOTELIOMA QUÍSTICO DE PERITONEO"
  },
  {
    "codigo":331601000119103,
    "descripcion":"ORZUELO INTERNO DE PÁRPADO SUPERIOR DE OJO DERECHO"
  },
  {
    "codigo":94058008,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE PARTES BLANDAS DEL CUELLO"
  },
  {
    "codigo":126826009,
    "descripcion":"NEOPLASIA DEL FONDO DEL ESTÓMAGO"
  },
  {
    "codigo":92223002,
    "descripcion":"NEOPLASIA BENIGNA DE MÚSCULO DEL ABDOMEN"
  },
  {
    "codigo":290666008,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR EPIRUBICINA"
  },
  {
    "codigo":192362008,
    "descripcion":"TRASTORNO AFECTIVO BIPOLAR, ACTUALMENTE EPISODIO MIXTO"
  },
  {
    "codigo":124991006,
    "descripcion":"ALTERACIÓN DEL CENTRÍOLO"
  },
  {
    "codigo":714815007,
    "descripcion":"HEMATURIA RECURRENTE CONCOMITANTE CON GLOMERULONEFRITIS DIFUSA CON SEMILUNAS Y DEBIDA A ELLA"
  },
  {
    "codigo":59455009,
    "descripcion":"ACIDOSIS METABÓLICA"
  },
  {
    "codigo":418068003,
    "descripcion":"BLASTOMICOSIS GENITOURINARIA"
  },
  {
    "codigo":876820007,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE LA MAMA CON INFECCIÓN"
  },
  {
    "codigo":285161002,
    "descripcion":"INCAPAZ DE RECONOCER OBJETOS POR MEDIO DEL TACTO"
  },
  {
    "codigo":11308881000119107,
    "descripcion":"MÚLTIPLES FRACTURAS VERTICALES EXPUESTAS POR CIZALLAMIENTO DE PELVIS CON ANILLO PÉLVICO INESTABLE"
  },
  {
    "codigo":283326002,
    "descripcion":"PICADURA DE INSECTO EN LA NARIZ"
  },
  {
    "codigo":1299134003,
    "descripcion":"CLASIFICACIÓN DE MILLER PARA RECESIÓN GINGIVAL, CLASE I"
  },
  {
    "codigo":15732561000119109,
    "descripcion":"ENTROPIÓN CON ECTROPIÓN DE AMBOS PÁRPADOS SUPERIORES"
  },
  {
    "codigo":414398007,
    "descripcion":"HERNIA DE LA PARED ABDOMINAL ANTERIOR CON OBSTRUCCIÓN Y GANGRENA"
  },
  {
    "codigo":445331004,
    "descripcion":"COLESTEATOSIS DIFUSA DEL OÍDO MEDIO Y MASTOIDES"
  },
  {
    "codigo":707475005,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE TRÁQUEA"
  },
  {
    "codigo":281491008,
    "descripcion":"DEFORMIDAD ADQUIRIDA EN FLEXIÓN FIJA DE ARTICULACIÓN DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":248723009,
    "descripcion":"HALLAZGO CAPILAR"
  },
  {
    "codigo":42141000087105,
    "descripcion":"CONTUSIÓN DE MANDÍBULA IZQUIERDA"
  },
  {
    "codigo":246888004,
    "descripcion":"CONJUNTIVA DEL LIMBO - HALLAZGO"
  },
  {
    "codigo":443496006,
    "descripcion":"ENCONDROMA DE HUESO"
  },
  {
    "codigo":212285004,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO SUPRAESCAPULAR"
  },
  {
    "codigo":48445006,
    "descripcion":"INTOXICACIÓN POR TOLBUTAMIDA"
  },
  {
    "codigo":408893009,
    "descripcion":"RELIGIOSIDAD ALTERADA"
  },
  {
    "codigo":277821009,
    "descripcion":"ANSIEDAD ACERCA DE SUFRIR UN ATAQUE"
  },
  {
    "codigo":13842006,
    "descripcion":"SUBINVOLUCIÓN DE ÚTERO EN PUERPERIO"
  },
  {
    "codigo":896743001,
    "descripcion":"FORMA DE CONO ANORMAL CONGÉNITA DE EPÍFISIS DE HUESO METACARPIANO"
  },
  {
    "codigo":208615001,
    "descripcion":"FRACTURA NO EXPUESTA DE CUELLO DE PERONÉ"
  },
  {
    "codigo":12007003,
    "descripcion":"INTOXICACIÓN POR GÉNERO HALOGETON"
  },
  {
    "codigo":306919004,
    "descripcion":"MARTILLO FIJO"
  },
  {
    "codigo":274151005,
    "descripcion":"AUSENCIA CONGÉNITA DE TESTÍCULO"
  },
  {
    "codigo":470759007,
    "descripcion":"OCLUSIÓN DE VENA CAVA SUPERIOR"
  },
  {
    "codigo":698300001,
    "descripcion":"ANAFILAXIS NO ALÉRGICA CAUSADA POR ADITIVO ALIMENTARIO"
  },
  {
    "codigo":403388003,
    "descripcion":"LINFEDEMA DE VULVA"
  },
  {
    "codigo":75708007,
    "descripcion":"INTOXICACIÓN POR ACOKANTHERA"
  },
  {
    "codigo":237713000,
    "descripcion":"MASA HIPOTALÁMICA"
  },
  {
    "codigo":73873008,
    "descripcion":"ENFERMEDAD METABÓLICA DEL COLÁGENO"
  },
  {
    "codigo":1153382001,
    "descripcion":"LINFOMA MALIGNO DE GLÁNDULA LAGRIMAL"
  },
  {
    "codigo":301414000,
    "descripcion":"DOLOR A LA DESCOMPRESIÓN EN HIPOCONDRIO IZQUIERDO"
  },
  {
    "codigo":235878005,
    "descripcion":"TRASTORNO VASCULAR HEPÁTICO"
  },
  {
    "codigo":268646008,
    "descripcion":"PATRÓN DE USO NOCIVO DE ALUCINÓGENO SIN DEPENDENCIA"
  },
  {
    "codigo":299579001,
    "descripcion":"ARTICULACIÓN DE DEDO DEL PIE - TUMEFACCIÓN DE PARTES BLANDAS"
  },
  {
    "codigo":234043001,
    "descripcion":"TROMBOSIS DE VENA DE PIERNA"
  },
  {
    "codigo":4667004,
    "descripcion":"INFERTILIDAD FEMENINA SECUNDARIA A ANOMALÍA ESTRUCTURAL CONGÉNITA DE LA VAGINA"
  },
  {
    "codigo":365115005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD DE SUBIR Y BAJAR ESCALERAS"
  },
  {
    "codigo":102971006,
    "descripcion":"POTENCIAL EVOCADO AUDITIVO ANORMAL"
  },
  {
    "codigo":201275005,
    "descripcion":"CLOASMA CAQUÉCTICO"
  },
  {
    "codigo":334111000119105,
    "descripcion":"LAGOFTALMOS PARALÍTICO DE PÁRPADO INFERIOR DERECHO"
  },
  {
    "codigo":35600002,
    "descripcion":"AMBLIOPÍA POR ESTRABISMO"
  },
  {
    "codigo":68368005,
    "descripcion":"CÁLCULO DEL COLÉDOCO CON COLECISTITIS CRÓNICA"
  },
  {
    "codigo":232208008,
    "descripcion":"TRASTORNO OTORRINOLARINGOLÓGICO"
  },
  {
    "codigo":197605007,
    "descripcion":"SÍNDROME NEFRÓTICO DEBIDO A DIABETES MELLITUS"
  },
  {
    "codigo":294074001,
    "descripcion":"ALERGIA A HIOSCINA"
  },
  {
    "codigo":10656031000119109,
    "descripcion":"ÚLCERA ISQUÉMICA ATEROSCLERÓTICA DE PARTE MEDIA DE PIE DERECHO"
  },
  {
    "codigo":62863000,
    "descripcion":"INFESTACIÓN CAUSADA POR GASTEROPHILUS"
  },
  {
    "codigo":195770009,
    "descripcion":"RINITIS INFECCIOSA CRÓNICA"
  },
  {
    "codigo":95631006,
    "descripcion":"SOMNOLENCIA DEL RECIÉN NACIDO"
  },
  {
    "codigo":292239007,
    "descripcion":"REACCIÓN ADVERSA A LA HIDROXIUREA"
  },
  {
    "codigo":290404001,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR PECTINA"
  },
  {
    "codigo":126564004,
    "descripcion":"NEOPLASIA DE PUBIS"
  },
  {
    "codigo":1471831000168103,
    "descripcion":"SE SIENTE INSEGURO CERCA DE SUS AMIGOS"
  },
  {
    "codigo":192100008,
    "descripcion":"DELINCUENCIA NEURÓTICA"
  },
  {
    "codigo":716388009,
    "descripcion":"CAPAZ DE ACCEDER AL JARDÍN"
  },
  {
    "codigo":10957241000119108,
    "descripcion":"HERIDA ABIERTA DE DEDO MEDIO DE MANO DERECHA DEBIDA A MORDEDURA HUMANA"
  },
  {
    "codigo":124729008,
    "descripcion":"MANOHEPTULOSURIA"
  },
  {
    "codigo":91961008,
    "descripcion":"NEOPLASIA BENIGNA DE SENO PARANASAL"
  },
  {
    "codigo":253966001,
    "descripcion":"ANOMALÍA CONGÉNITA DE PIE, INCLUIDOS LOS DEDOS"
  },
  {
    "codigo":286734003,
    "descripcion":"CARÁCTER INSENSIBLE"
  },
  {
    "codigo":448739000,
    "descripcion":"INFECCIÓN RECURRENTE DEL TRACTO RESPIRATORIO INFERIOR"
  },
  {
    "codigo":17288006,
    "descripcion":"HERIDA PUNZANTE DEL PIE"
  },
  {
    "codigo":446904001,
    "descripcion":"QUEMADURA PROFUNDA DE TERCER GRADO DE FRENTE"
  },
  {
    "codigo":283064005,
    "descripcion":"ABRASIÓN DE PIEL DE PLANTA DE PIE"
  },
  {
    "codigo":281229000,
    "descripcion":"LESIÓN OCUPANTE DE SISTEMA NERVIOSO"
  },
  {
    "codigo":1264269000,
    "descripcion":"CORIOAMNIONITIS BACTERIANA"
  },
  {
    "codigo":501000124106,
    "descripcion":"EXCLUSIÓN DE MEDICIÓN DE DESEMPEÑO POR MOTIVOS MÉDICOS"
  },
  {
    "codigo":182925002,
    "descripcion":"DIETA PARA DISOLUCIÓN DE CÁLCULOS BILIARES"
  },
  {
    "codigo":443381000124105,
    "descripcion":"OBESO CLASE II"
  },
  {
    "codigo":456181000124104,
    "descripcion":"TRASTORNO DE AMBOS OJOS"
  },
  {
    "codigo":248461006,
    "descripcion":"DIFERENTE TEMPERATURA EN BRAZOS Y PIERNAS"
  },
  {
    "codigo":84621006,
    "descripcion":"LESIÓN TRAUMÁTICA DE ESÓFAGO CON HERIDA ABIERTA HACIA CAVIDAD TORÁCICA"
  },
  {
    "codigo":246626000,
    "descripcion":"SE FROTA LOS OJOS"
  },
  {
    "codigo":1297037002,
    "descripcion":"ARTRITIS ENTEROPÁTICA DE ARTICULACIÓN DE RODILLA"
  },
  {
    "codigo":1196898000,
    "descripcion":"NEOPLASIA TERATOIDE RABDOIDE ATÍPICA MALIGNA PRIMARIA DE ENCÉFALO"
  },
  {
    "codigo":17250009,
    "descripcion":"AMPOLLA DE LA REGIÓN INTERESCAPULAR, CON INFECCIÓN"
  },
  {
    "codigo":1162295001,
    "descripcion":"ARTRITIS PSORIÁSICA DE MÚLTIPLES ARTICULACIONES"
  },
  {
    "codigo":703543005,
    "descripcion":"PARÁLISIS ESPÁSTICA ASCENDENTE HEREDITARIA DE COMIENZO EN LA INFANCIA"
  },
  {
    "codigo":769079008,
    "descripcion":"LEVADURA EN GEMACIÓN DETECTADA"
  },
  {
    "codigo":210188002,
    "descripcion":"LESIÓN EXPUESTA DEL BAZO"
  },
  {
    "codigo":110049003,
    "descripcion":"LACERACIÓN COMPLEJA DE LA REGIÓN PREAURICULAR DE LA CARA"
  },
  {
    "codigo":44513007,
    "descripcion":"ANOMALÍA CONGÉNITA DE RIÑÓN"
  },
  {
    "codigo":272054000,
    "descripcion":"MAL RELATOR"
  },
  {
    "codigo":403126006,
    "descripcion":"ONCODERMATITIS PAPULOSA AGUDA"
  },
  {
    "codigo":1156790008,
    "descripcion":"SÍNDROME DE PARÁLISIS SUPRANUCLEAR PROGRESIVA ATÍPICA"
  },
  {
    "codigo":698038009,
    "descripcion":"POSICIÓN DE LA CABEZA EN EL PLANO HORIZONTAL DE FRANKFURT"
  },
  {
    "codigo":237451004,
    "descripcion":"GINECOMASTIA DE LA PUBERTAD"
  },
  {
    "codigo":401291006,
    "descripcion":"ESCALA DE DISNEA DE BORG: 8 - MUY SEVERA (+)"
  },
  {
    "codigo":235616003,
    "descripcion":"ESTENOSIS ESOFÁGICA BENIGNA"
  },
  {
    "codigo":366688005,
    "descripcion":"HALLAZGO RELACIONADO CON LA AMPLITUD DE LA FLEXIÓN DEL PULGAR"
  },
  {
    "codigo":1251424007,
    "descripcion":"URTICARIA ALÉRGICA DE CONTACTO DISEMINADA"
  },
  {
    "codigo":301152008,
    "descripcion":"PULSO TEMPORAL PRESENTE"
  },
  {
    "codigo":202848009,
    "descripcion":"FIBROSITIS ESCAPULOHUMERAL"
  },
  {
    "codigo":10632071000119107,
    "descripcion":"ABSCESO DE DEDO DE LA MANO IZQUIERDA"
  },
  {
    "codigo":266549004,
    "descripcion":"SÍNDROME NEFRÓTICO CON GLOMERULONEFRITIS DE CAMBIOS MÍNIMOS"
  },
  {
    "codigo":233781007,
    "descripcion":"FÍSTULA TRAQUEOARTERIAL ADQUIRIDA"
  },
  {
    "codigo":299317007,
    "descripcion":"PRUEBA DE ORTOLANI POSITIVA"
  },
  {
    "codigo":1149450002,
    "descripcion":"PERIODONTITIS GENERALIZADA ESTADIO 4 GRADO A SEGÚN LA CLASIFICACIÓN DE LAS ENFERMEDADES Y ALTERACIONES PERIODONTALES Y PERIIMPLANTARIAS DE 2017 DE LA ACADEMIA ESTADOUNIDENSE DE PERIODONTOLOGÍA Y LA FEDERACIÓN EUROPEA DE PERIODONTOLOGÍA"
  },
  {
    "codigo":789002007,
    "descripcion":"ARTROSIS DE MUÑECA Y MANO DEBIDA A TRAUMATISMO Y POSTERIOR A ÉL"
  },
  {
    "codigo":262879002,
    "descripcion":"LACERACIÓN DE RECTO"
  },
  {
    "codigo":66271005,
    "descripcion":"RESISTENCIA CAPILAR AUMENTADA"
  },
  {
    "codigo":295647006,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE CARMUSTINA"
  },
  {
    "codigo":293812003,
    "descripcion":"ALERGIA A APOMORFINA"
  },
  {
    "codigo":457652006,
    "descripcion":"CALCIFICACIÓN DE VÁLVULA PULMONAR"
  },
  {
    "codigo":228276006,
    "descripcion":"BEBEDOR OCASIONAL"
  },
  {
    "codigo":423049000,
    "descripcion":"MARGINADO SOCIAL"
  },
  {
    "codigo":160905000,
    "descripcion":"PROBLEMA DE MALA ADAPTACIÓN LABORAL"
  },
  {
    "codigo":128137003,
    "descripcion":"TRASTORNO DE LA PIERNA"
  },
  {
    "codigo":717961004,
    "descripcion":"ALCALOSIS METABÓLICA SIN RESPUESTA A CLORURO"
  },
  {
    "codigo":95369007,
    "descripcion":"NECROSIS DEL SITIO DE APLICACIÓN"
  },
  {
    "codigo":1142110005,
    "descripcion":"BRADICARDIA SINUSAL MEDICAMENTOSA"
  },
  {
    "codigo":191838006,
    "descripcion":"FARMACODEPENDENCIA DE CANNABIS, EPISÓDICA"
  },
  {
    "codigo":352311000119100,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE PARTES BLANDAS DE MIEMBRO INFERIOR DERECHO"
  },
  {
    "codigo":15986231000119101,
    "descripcion":"ANOMALÍA CONGÉNITA DE PAPILA ÓPTICA DERECHA"
  },
  {
    "codigo":339511000119102,
    "descripcion":"ENTROPIÓN MECÁNICO DE PÁRPADO IZQUIERDO"
  },
  {
    "codigo":1591000119103,
    "descripcion":"DEMENCIA CON TRASTORNO DEL COMPORTAMIENTO"
  },
  {
    "codigo":216631000119102,
    "descripcion":"STENT EN RAMA CIRCUNFLEJA DE ARTERIA CORONARIA IZQUIERDA"
  },
  {
    "codigo":88631000119105,
    "descripcion":"DISPLASIA CONGÉNITA DE EXTREMIDAD"
  },
  {
    "codigo":11844151000119106,
    "descripcion":"LESIÓN TRAUMÁTICA DE OÍDO MEDIO IZQUIERDO"
  },
  {
    "codigo":16045111000119107,
    "descripcion":"ALTERACIÓN DE LA ALINEACIÓN DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":10633271000119108,
    "descripcion":"CELULITIS DE RODILLA IZQUIERDA"
  },
  {
    "codigo":298551000119105,
    "descripcion":"OSTEONECROSIS DE PERONÉ CAUSADA POR FÁRMACO"
  },
  {
    "codigo":16009271000119101,
    "descripcion":"EMBOLIA DE ARTERIA DE MIEMBRO SUPERIOR DERECHO"
  },
  {
    "codigo":4151000119102,
    "descripcion":"NEURALGIA DE NERVIO FACIAL"
  },
  {
    "codigo":769023031000119104,
    "descripcion":"ACCIDENTE CEREBROVASCULAR EN TÁLAMO"
  },
  {
    "codigo":10879031000119106,
    "descripcion":"HEMATOMA TRAUMÁTICO DE ÓRBITA"
  },
  {
    "codigo":417544004,
    "descripcion":"PERIARTERITIS RETINIANA SEGMENTARIA"
  },
  {
    "codigo":10679351000119109,
    "descripcion":"TUMEFACCIÓN LOCALIZADA DE CABEZA"
  },
  {
    "codigo":1236744008,
    "descripcion":"MASA QUE OCUPA CUADRANTE SUPERIOR DERECHO DE ABDOMEN"
  },
  {
    "codigo":415709002,
    "descripcion":"TENDENCIA A LAS NÁUSEAS Y LOS VÓMITOS"
  },
  {
    "codigo":251869004,
    "descripcion":"SUFICIENCIA DE LA HEMODIÁLISIS"
  },
  {
    "codigo":1169373002,
    "descripcion":"GLOBULINA FIJADORA DE TIROXINA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":286472009,
    "descripcion":"INCAPAZ DE REBANAR ALIMENTOS"
  },
  {
    "codigo":448477005,
    "descripcion":"RELACIÓN VENTRICULAR ENTRE PORCIÓN SUPERIOR E INFERIOR"
  },
  {
    "codigo":284637003,
    "descripcion":"APUÑALAR A OTRA PERSONA"
  },
  {
    "codigo":315570003,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: INGLÉS"
  },
  {
    "codigo":446642005,
    "descripcion":"INFECCIÓN DE ANO CAUSADA POR CHLAMYDIA TRACHOMATIS"
  },
  {
    "codigo":86194008,
    "descripcion":"MIOCARDIOPATÍA DILATADA DEBIDA A ENFERMEDAD INFECCIOSA"
  },
  {
    "codigo":20658008,
    "descripcion":"FUNCIÓN MUSCULAR NORMAL"
  },
  {
    "codigo":1296775002,
    "descripcion":"INTOXICACIÓN AGUDA CAUSADA POR AGENTE HIPNÓTICO"
  },
  {
    "codigo":1231239003,
    "descripcion":"INFLAMACIÓN DE GLÁNDULA LAGRIMAL DEBIDA A ENFERMEDAD DE GRAVES"
  },
  {
    "codigo":250034009,
    "descripcion":"TRASTORNO SENSORIOMOTRIZ DE LA MARCHA DE NIVEL MEDIO"
  },
  {
    "codigo":280967004,
    "descripcion":"TROMBOSIS DE INJERTO ARTERIAL"
  },
  {
    "codigo":115763002,
    "descripcion":"FENOTIPO TRANS D DÉBIL"
  },
  {
    "codigo":1264007008,
    "descripcion":"INFECCIÓN POR ADENOVIRUS EN PERSONA INMUNOCOMPROMETIDA"
  },
  {
    "codigo":117127009,
    "descripcion":"CALIDAD DEL SOPLO CARDÍACO, RONCO"
  },
  {
    "codigo":770652001,
    "descripcion":"ESTENOSIS DE CONDUCTO AUDITIVO EXTERNO DEBIDA A RADIOTERAPIA Y POSTERIOR A ELLA"
  },
  {
    "codigo":49756002,
    "descripcion":"NEUMOTÓRAX PERINATAL"
  },
  {
    "codigo":18823009,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE PENE SIN INFECCIÓN"
  },
  {
    "codigo":248199009,
    "descripcion":"FACIES DE DOWN"
  },
  {
    "codigo":703281001,
    "descripcion":"TELANGIECTASIAS VENOSAS DE MIEMBRO INFERIOR"
  },
  {
    "codigo":1260337002,
    "descripcion":"HIDROCEFALIA EX VACUO DEBIDA A ENFERMEDAD CEREBROVASCULAR"
  },
  {
    "codigo":1293105001,
    "descripcion":"HIDRADENOCARCINOMA"
  },
  {
    "codigo":408369008,
    "descripcion":"USO EXCESIVO DE MEDICACIÓN VERIFICADO"
  },
  {
    "codigo":766982000,
    "descripcion":"ANEMIA HEMOLÍTICA DEBIDA A DEFICIENCIA DE ADENILATO CINASA"
  },
  {
    "codigo":275462005,
    "descripcion":"TRASTORNO DEL OLFATO"
  },
  {
    "codigo":78854006,
    "descripcion":"TIÑA CAUSADA POR TRICHOPHYTON SCHOENLEINII"
  },
  {
    "codigo":16670191000119104,
    "descripcion":"FRACTURA NO EXPUESTA DE APÓFISIS CORONOIDES DE LADO DERECHO DE LA MANDÍBULA"
  },
  {
    "codigo":240859005,
    "descripcion":"CONJUNTIVITIS CAUSADA POR BACILO DE KOCH-WEEKS"
  },
  {
    "codigo":11483009,
    "descripcion":"DEFECTO VENTILATORIO"
  },
  {
    "codigo":402864004,
    "descripcion":"GANGRENA HÚMEDA DE PIE DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":239024004,
    "descripcion":"DISPLASIA ECTODÉRMICA, SINDACTILIA Y PILI TORTI"
  },
  {
    "codigo":341641000119100,
    "descripcion":"GLAUCOMA DE ÁNGULO ANATÓMICO CERRADO DEL OJO IZQUIERDO"
  },
  {
    "codigo":763312008,
    "descripcion":"SÍNDROME AUTOSÓMICO RECESIVO DE ATAXIA CEREBELOSA, SIGNOS PIRAMIDALES, NISTAGMO Y APRAXIA OCULOMOTRIZ"
  },
  {
    "codigo":1187461004,
    "descripcion":"GLUCOGENOSIS DEBIDA A DEFICIENCIA DE ALDOLASA A"
  },
  {
    "codigo":431962000,
    "descripcion":"ATENDIDO EN CONSULTORIO ESPECIALIZADO EN UROGINECOLOGÍA"
  },
  {
    "codigo":269957009,
    "descripcion":"RESULTADO DEL EXTENDIDO CERVICAL"
  },
  {
    "codigo":366426002,
    "descripcion":"AMPLITUD DE MOVIMIENTO DE LA COLUMNA LUMBAR - HALLAZGO"
  },
  {
    "codigo":399194009,
    "descripcion":"TRASTORNO CARACTERIZADO POR DOLOR DE ESPALDA"
  },
  {
    "codigo":202586009,
    "descripcion":"OSTEOCONDROMATOSIS SINOVIAL DE ARTICULACIÓN ROTULIANA"
  },
  {
    "codigo":69679003,
    "descripcion":"REACCIÓN AUTOINMUNITARIA INDUCIDA"
  },
  {
    "codigo":200751004,
    "descripcion":"ABSCESO DE LA CARA"
  },
  {
    "codigo":299055007,
    "descripcion":"HALLAZGO RELACIONADO CON ESTRUCTURA MUSCULOESQUELÉTICA DE DEDO DE LA MANO"
  },
  {
    "codigo":102447009,
    "descripcion":"OSTEOPOROSIS POSTMENOPÁUSICA"
  },
  {
    "codigo":2308003,
    "descripcion":"ALELOS SILENCIOSOS"
  },
  {
    "codigo":721369000,
    "descripcion":"LESIÓN COMPLETA DE MÉDULA ESPINAL AL NIVEL DEL SÉPTIMO SEGMENTO CERVICAL"
  },
  {
    "codigo":295385000,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE PIRENZEPINA"
  },
  {
    "codigo":262617007,
    "descripcion":"CUERPO EXTRAÑO EN PRÓSTATA"
  },
  {
    "codigo":360921008,
    "descripcion":"DEFICIENCIA DE PEPTIDASA A"
  },
  {
    "codigo":293550002,
    "descripcion":"REACCIÓN ADVERSA AL DINITRATO DE ISOSORBIDA POR VÍA ORAL"
  },
  {
    "codigo":162478004,
    "descripcion":"SÍNTOMA QUE EMPEORA CON EL CALOR"
  },
  {
    "codigo":129710004,
    "descripcion":"CON MAYOR RIESGO DE SÍNDROME POSTRAUMÁTICO"
  },
  {
    "codigo":1145518004,
    "descripcion":"APLASIA DE HUESO DE MANO"
  },
  {
    "codigo":226179000,
    "descripcion":"DIETA MODIFICADA CON ADITIVOS PARA ALIMENTOS"
  },
  {
    "codigo":160643000,
    "descripcion":"EJERCICIO ANAERÓBICO, TRES O MÁS VECES POR SEMANA"
  },
  {
    "codigo":95107000,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE SENO ESFENOIDAL"
  },
  {
    "codigo":62339003,
    "descripcion":"INFECCIÓN CAUSADA POR STRONGYLUS"
  },
  {
    "codigo":193411004,
    "descripcion":"DRUSA DOMINANTE"
  },
  {
    "codigo":422787005,
    "descripcion":"DIFICULTAD DEL CUIDADOR PARA PROVEER SEGURIDAD FÍSICA"
  },
  {
    "codigo":717699008,
    "descripcion":"ENDOMETRIOSIS DE INTESTINO GRUESO"
  },
  {
    "codigo":93272001,
    "descripcion":"HIPOPLASIA CONGÉNITA DEL METACARPO"
  },
  {
    "codigo":315171000119105,
    "descripcion":"OSTEOCONDRITIS DISECANTE DE CADERA IZQUIERDA"
  },
  {
    "codigo":1141848001,
    "descripcion":"HIPEREOSINOFILIA"
  },
  {
    "codigo":224344006,
    "descripcion":"ASUNTO EN JURISDICCIÓN DE TRIBUNAL DE PROTECCIÓN"
  },
  {
    "codigo":715864007,
    "descripcion":"TOXICOSIS HEPÁTICA POR COBRE NO RELACIONADA CON LA ENFERMEDAD DE WILSON DE LA LACTANCIA Y LA INFANCIA"
  },
  {
    "codigo":289880008,
    "descripcion":"HALLAZGO RELACIONADO CON LA COLORACIÓN DEL PERINEO FEMENINO"
  },
  {
    "codigo":60504009,
    "descripcion":"ANEMIA MEGALOBLÁSTICA POR DEFICIENCIA CONGÉNITA DE FACTOR INTRÍNSECO"
  },
  {
    "codigo":124205002,
    "descripcion":"DEFICIENCIA DE PROTOCATECUATO 3, 4 - DIOXIGENASA"
  },
  {
    "codigo":253442000,
    "descripcion":"ORIFICIO TRIPLE DE COMPONENTE VENTRICULAR IZQUIERDO DE VÁLVULA AURICULOVENTRICULAR COMÚN"
  },
  {
    "codigo":15935421000119103,
    "descripcion":"DEFORMIDAD EN FLEXIÓN DE ARTICULACIÓN DE AMBOS CODOS"
  },
  {
    "codigo":286210007,
    "descripcion":"DIFICULTAD PARA GESTICULAR AL HABLAR"
  },
  {
    "codigo":187906008,
    "descripcion":"NEOPLASIA MALIGNA DE HUESO ORBITARIO"
  },
  {
    "codigo":22231002,
    "descripcion":"ENTERITIS ALÉRGICA"
  },
  {
    "codigo":710359002,
    "descripcion":"NEUROPATÍA PERIFÉRICA DE MIEMBRO SUPERIOR DEBIDA A INFECCIÓN"
  },
  {
    "codigo":448215006,
    "descripcion":"NEOPLASIA EPITELIAL MALIGNA DE PELVIS RENAL"
  },
  {
    "codigo":1003436000,
    "descripcion":"RUPTURA LINEAL DE CORDÓN UMBILICAL"
  },
  {
    "codigo":184236004,
    "descripcion":"TARJETA DE REPETICIÓN DE LA PRESCRIPCIÓN EMITIDA"
  },
  {
    "codigo":282540005,
    "descripcion":"DIFICULTAD PARA EMPEZAR A CORRER"
  },
  {
    "codigo":77363004,
    "descripcion":"ALOPECIA CIRCUNSCRIPTA CONCÉNTRICA"
  },
  {
    "codigo":249772008,
    "descripcion":"SIGNO DE LA PLEGARIA"
  },
  {
    "codigo":84097002,
    "descripcion":"TRASTORNO DE CARTÍLAGO ARTICULAR DE MÚLTIPLES SITIOS"
  },
  {
    "codigo":444545003,
    "descripcion":"GLIOMA DE TRONCO ENCEFÁLICO"
  },
  {
    "codigo":772225005,
    "descripcion":"DEFICIENCIA DE RAB18"
  },
  {
    "codigo":247937006,
    "descripcion":"GOLPETEO REPETITIVO DEL MENTÓN"
  },
  {
    "codigo":1263745005,
    "descripcion":"HERIDA PUNZANTE DE DEDO MEÑIQUE"
  },
  {
    "codigo":870529009,
    "descripcion":"EDEMA MACULAR PERSISTENTE DEBIDO A DIABETES MELLITUS"
  },
  {
    "codigo":49494003,
    "descripcion":"GLÁNDULA SUPRARRENAL ECTÓPICA"
  },
  {
    "codigo":16726004,
    "descripcion":"OSTEODISTROFIA RENAL"
  },
  {
    "codigo":278870006,
    "descripcion":"CONDUCTA ANORMAL EN LA ENFERMEDAD - HALLAZGO"
  },
  {
    "codigo":442710007,
    "descripcion":"PRUEBA DE ASPIRACIÓN NEGATIVA PARA LÍQUIDO CEFALORRAQUÍDEO DURANTE PROCEDIMIENTO"
  },
  {
    "codigo":703019000,
    "descripcion":"CHRYSEOMONAS LUTEOLA O PSEUDOMONAS ORYZIHABITANS"
  },
  {
    "codigo":735787002,
    "descripcion":"LESIÓN TRAUMÁTICA DE ESTÓMAGO SIN PERFORACIÓN POSTERIOR A INGESTIÓN DE MATERIAL EXTRAÑO"
  },
  {
    "codigo":1081431000119104,
    "descripcion":"NEOPLASIA FILODES LIMÍTROFE DE MAMA IZQUIERDA"
  },
  {
    "codigo":1260075005,
    "descripcion":"CARCINOMA SÓLIDO DE TRÁQUEA"
  },
  {
    "codigo":344151000119105,
    "descripcion":"ADHESIÓN DE MEMBRANA PUPILAR DE AMBOS OJOS"
  },
  {
    "codigo":768555009,
    "descripcion":"SÍNDROME DE MICRODELECIÓN 5Q31.3"
  },
  {
    "codigo":766720000,
    "descripcion":"DISOMÍA UNIPARENTAL PATERNA DEL CROMOSOMA 21"
  },
  {
    "codigo":733952005,
    "descripcion":"CARIES DENTAL PRIMARIA INACTIVA QUE SE EXTIENDE HASTA EL TERCIO MEDIO DE LA DENTINA"
  },
  {
    "codigo":240597001,
    "descripcion":"VERRUGAS ANALES"
  },
  {
    "codigo":111360009,
    "descripcion":"ESTREÑIMIENTO TENAZ"
  },
  {
    "codigo":109525005,
    "descripcion":"HIPOPLASIA MANDIBULAR TRANSVERSA CONGÉNITA"
  },
  {
    "codigo":304298000,
    "descripcion":"HOMBRO SIN MOVIMIENTO"
  },
  {
    "codigo":9386003,
    "descripcion":"NEURITIS GOTOSA"
  },
  {
    "codigo":894122005,
    "descripcion":"CUADRANTOPSIA HOMÓNIMA SUPERIOR IZQUIERDA"
  },
  {
    "codigo":1156266006,
    "descripcion":"COMPRESIÓN DE MÉDULA ESPINAL CERVICAL"
  },
  {
    "codigo":1252735004,
    "descripcion":"NÓDULO DE PIEL DE PULGAR IZQUIERDO"
  },
  {
    "codigo":204159004,
    "descripcion":"POLICORIA"
  },
  {
    "codigo":7551007,
    "descripcion":"FRACTURA NO EXPUESTA DE CUELLO DE HUESO METACARPIANO"
  },
  {
    "codigo":38484003,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE ESPALDA SIN INFECCIÓN"
  },
  {
    "codigo":235092003,
    "descripcion":"RELACIÓN DEL SEGMENTO BUCAL CLASE III - UNIDAD MEDIA"
  },
  {
    "codigo":169556005,
    "descripcion":"ESTADO DE ANTICONCEPCIÓN DESCONOCIDO"
  },
  {
    "codigo":300628008,
    "descripcion":"INCAPAZ DE VIAJAR EN TRANSPORTE PRIVADO"
  },
  {
    "codigo":36649002,
    "descripcion":"CLONO"
  },
  {
    "codigo":298793003,
    "descripcion":"AMPLITUD DE EXTENSIÓN PASIVA DE HOMBRO AUMENTADA"
  },
  {
    "codigo":167721004,
    "descripcion":"CONTENIDO CELULAR DE LÍQUIDO CEFALORRAQUÍDEO POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":724777003,
    "descripcion":"DEMENCIA DEBIDA A ENFERMEDAD INFECCIOSA"
  },
  {
    "codigo":11786481000119107,
    "descripcion":"AMPOLLA DE DEDO ÍNDICE DE MANO DERECHA, CON INFECCIÓN"
  },
  {
    "codigo":1281833007,
    "descripcion":"CRISIS EPILÉPTICA CON DETENCIÓN DE COMPORTAMIENTO CON ALTERACIÓN DE CONCIENCIA DE INICIO FOCAL"
  },
  {
    "codigo":165886000,
    "descripcion":"ANTICUERPOS ANTI - MEMBRANA BASAL DETECTADOS"
  },
  {
    "codigo":1148926002,
    "descripcion":"HIPOFOSFATEMIA DEBIDA A ENFERMEDAD RENAL CRÓNICA"
  },
  {
    "codigo":12114161000119109,
    "descripcion":"QUEMADURA QUÍMICA DE PIE IZQUIERDO"
  },
  {
    "codigo":722942005,
    "descripcion":"HIPERTIROIDISMO FAMILIAR"
  },
  {
    "codigo":295123003,
    "descripcion":"SOBREDOSIS DE ANALGÉSICO NO OPIOIDE"
  },
  {
    "codigo":1343699004,
    "descripcion":"OTITIS MEDIA CRÓNICA CON DERRAME"
  },
  {
    "codigo":65747008,
    "descripcion":"QUEILITIS GLANDULAR, TIPO SUPURATIVO SUPERFICIAL"
  },
  {
    "codigo":293288004,
    "descripcion":"REACCIÓN ADVERSA A LA SOMATOTROFINA"
  },
  {
    "codigo":194984004,
    "descripcion":"ESTENOSIS AÓRTICA, NO REUMÁTICA"
  },
  {
    "codigo":719272007,
    "descripcion":"SÍNDROME DE PÉRDIDA DE LA AUDICIÓN NEUROSENSORIAL PROGRESIVA Y MIOCARDIOPATÍA HIPERTRÓFICA"
  },
  {
    "codigo":225917003,
    "descripcion":"LÍNEA DE SUTURA INTACTA"
  },
  {
    "codigo":94845006,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL PREPUCIO"
  },
  {
    "codigo":289618005,
    "descripcion":"HALLAZGO RELACIONADO CON EL ÚTERO"
  },
  {
    "codigo":1010514007,
    "descripcion":"ESCLEROSIS DE EPÍFISIS DE FALANGE DISTAL DE DEDO GORDO CON RADIOPACIDAD AUMENTADA"
  },
  {
    "codigo":91175000,
    "descripcion":"CONVULSIÓN"
  },
  {
    "codigo":387922007,
    "descripcion":"NEOPLASIA DE GLÁNDULA ENDOCRINA"
  },
  {
    "codigo":93010007,
    "descripcion":"ANOMALÍA CONGÉNITA DE LA VÉRTEBRA LUMBAR"
  },
  {
    "codigo":123943000,
    "descripcion":"INTOXICACIÓN POR URTICACEAE"
  },
  {
    "codigo":224082009,
    "descripcion":"INOBSERVANCIA DE PRÁCTICAS RELIGIOSAS"
  },
  {
    "codigo":255015006,
    "descripcion":"MELANOMA MALIGNO DE CUERPO CILIAR"
  },
  {
    "codigo":1303591007,
    "descripcion":"MENINGITIS CAUSADA POR CITROBACTER"
  },
  {
    "codigo":1172519009,
    "descripcion":"PROGESTERONA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":285948001,
    "descripcion":"INCAPAZ DE INSERTAR Y REMOVER EL TAPÓN DE LA PILETA"
  },
  {
    "codigo":187644001,
    "descripcion":"NEOPLASIA MALIGNA DE DORSO DE ZONA DE UNIÓN DE LENGUA"
  },
  {
    "codigo":346661000119106,
    "descripcion":"DEPÓSITO EN CONJUNTIVA DE AMBOS OJOS"
  },
  {
    "codigo":417020006,
    "descripcion":"IRITIS TRAUMÁTICA"
  },
  {
    "codigo":253180007,
    "descripcion":"DISGENESIA DEL TRONCO ENCEFÁLICO"
  },
  {
    "codigo":449788006,
    "descripcion":"APIÑAMIENTO DE DIENTES SUPERIORES POSTERIORES"
  },
  {
    "codigo":284113004,
    "descripcion":"DIFICULTAD PARA CONTROLAR LA POSICIÓN DE LA CABEZA"
  },
  {
    "codigo":447953007,
    "descripcion":"ENFERMEDAD DE BOWEN DE LA PIEL DEL TÓRAX"
  },
  {
    "codigo":15639231000119102,
    "descripcion":"EDEMA DE LA MÁCULA RETINIANA DE AMBOS OJOS"
  },
  {
    "codigo":85670002,
    "descripcion":"HIPOVITAMINOSIS"
  },
  {
    "codigo":216742009,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR FOSFINA"
  },
  {
    "codigo":10642111000119104,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN EN REGIÓN SACRA DE ESPALDA NO ESTADIFICABLE"
  },
  {
    "codigo":870267006,
    "descripcion":"TRASTORNO GENERALIZADO DEL DESARROLLO CON TRASTORNO DEL DESARROLLO INTELECTUAL Y ALTERACIÓN ACENTUADA DEL LENGUAJE FUNCIONAL SIN PÉRDIDA DE HABILIDADES ADQUIRIDAS PREVIAMENTE"
  },
  {
    "codigo":49232000,
    "descripcion":"ÚLCERA PÉPTICA CRÓNICA CON HEMORRAGIA"
  },
  {
    "codigo":74431000119105,
    "descripcion":"RESERVA OVÁRICA DISMINUIDA DEBIDA A AUMENTO DE HORMONA FOLICULOESTIMULANTE Y ESTRADIOL"
  },
  {
    "codigo":16464001,
    "descripcion":"EFECTO TÓXICO DEL TETRACLORURO DE CARBONO"
  },
  {
    "codigo":442448003,
    "descripcion":"FRACTURA DE CABEZA DE RADIO CON LUXACIÓN DE ARTICULACIÓN RADIOCUBITAL DISTAL Y RUPTURA DE LA MEMBRANA INTERÓSEA"
  },
  {
    "codigo":278608002,
    "descripcion":"PRÓTESIS MAXILOFACIAL PRESENTE"
  },
  {
    "codigo":247675008,
    "descripcion":"DELIRIO ASOCIADO CON EL OLFATO"
  },
  {
    "codigo":1359952006,
    "descripcion":"DEFICIENCIA DE DESCARBOXILASA DE L-AMINOÁCIDOS AROMÁTICOS"
  },
  {
    "codigo":47397001,
    "descripcion":"VÍCTIMA, CICLISTA EN ACCIDENTE VEHICULAR Y\/O DE TRÁNSITO"
  },
  {
    "codigo":702757002,
    "descripcion":"SEQUEDAD CUTÁNEA GRAVE"
  },
  {
    "codigo":1259813004,
    "descripcion":"OLIGOASTROCITOMA ANAPLÁSICO PRIMARIO DE SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":735525005,
    "descripcion":"ESTADIO CLÍNICO 3 DE INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA DE LA ORGANIZACIÓN MUNDIAL DE LA SALUD DE 2007 CONCOMITANTE CON TUBERCULOSIS"
  },
  {
    "codigo":406010001,
    "descripcion":"ANTÍGENO DE SUPERFICIE DE HEPATITIS B NO DETECTADO"
  },
  {
    "codigo":1290746004,
    "descripcion":"ARTRITIS REACTIVA DE ARTICULACIÓN DE PIE DEBIDA A DISENTERÍA Y POSTERIOR A ELLA"
  },
  {
    "codigo":209402006,
    "descripcion":"FRACTURA-SUBLUXACIÓN POSTERIOR NO EXPUESTA DE ARTICULACIÓN ESTERNOCLAVICULAR"
  },
  {
    "codigo":10959001,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DE LA LARINGE"
  },
  {
    "codigo":897530009,
    "descripcion":"ANQUILOSIS CONGÉNITA DE LA ARTICULACIÓN INCUDOMALEOLAR"
  },
  {
    "codigo":109263003,
    "descripcion":"MUCOSITIS CRÓNICA"
  },
  {
    "codigo":305871004,
    "descripcion":"VISTO POR EL SERVICIO DE PSIQUIATRÍA DE REHABILITACIÓN"
  },
  {
    "codigo":404175004,
    "descripcion":"TRÍADA DE OCLUSIÓN FOLICULAR: HIDRADENITIS, ACNÉ CONGLOBATA, CELULITIS DISECANTE DE CUERO CABELLUDO"
  },
  {
    "codigo":240335007,
    "descripcion":"INTOXICACIÓN ALIMENTARIA POR ESCHERICHIA COLI"
  },
  {
    "codigo":764623009,
    "descripcion":"SÍNDROME DE TRISOMÍA 2 MOSAICO"
  },
  {
    "codigo":238500005,
    "descripcion":"FÍSTULA PILOSA DE PIE"
  },
  {
    "codigo":9124008,
    "descripcion":"APENDICITIS SUBAGUDA"
  },
  {
    "codigo":402340009,
    "descripcion":"DISTROFIA UNGUEAL POR PITIRIASIS RUBRA PILARIS"
  },
  {
    "codigo":302201002,
    "descripcion":"TRABAJA CON ENCUESTAS TELEFÓNICAS"
  },
  {
    "codigo":236665004,
    "descripcion":"INCONTINENCIA URINARIA POSTURAL"
  },
  {
    "codigo":105593004,
    "descripcion":"DESEQUILIBRIO ELECTROLÍTICO"
  },
  {
    "codigo":1186937007,
    "descripcion":"PRUEBA DE FUNCIÓN TIROIDEA ANORMAL DEBIDA A INTERFERENCIA EN EL ANÁLISIS"
  },
  {
    "codigo":72825009,
    "descripcion":"HEMOSIDEROSIS ASOCIADA CON DERIVACIÓN VASCULAR"
  },
  {
    "codigo":365902002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA RECORDAR HABILIDADES MOTRICES"
  },
  {
    "codigo":300366003,
    "descripcion":"VÓMITO FECAL"
  },
  {
    "codigo":890190003,
    "descripcion":"BRAQUIMETATARSIA DEL PRIMER METATARSIANO"
  },
  {
    "codigo":398670003,
    "descripcion":"DERMATOFIBROSARCOMA PROTUBERANS PIGMENTADO DE PIEL"
  },
  {
    "codigo":726350006,
    "descripcion":"TRISOMÍA PARCIAL DE CROMOSOMA 11"
  },
  {
    "codigo":298531000,
    "descripcion":"AMPLITUD DE FLEXIÓN LATERAL ACTIVA HACIA LA DERECHA NORMAL DE LA COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":724515002,
    "descripcion":"PERISTALTISMO ESOFÁGICO HIPOTENSIVO"
  },
  {
    "codigo":11817971000119104,
    "descripcion":"ESGUINCE DE LIGAMENTO DE ARTICULACIÓN METACARPOFALÁNGICA DE DEDO MEÑIQUE DE MANO IZQUIERDA"
  },
  {
    "codigo":67320001,
    "descripcion":"EXCESO DE CONVERGENCIA"
  },
  {
    "codigo":34552002,
    "descripcion":"VÍCTIMA EN ACCIDENTE ENTRE DOS VEHÍCULOS"
  },
  {
    "codigo":1148664003,
    "descripcion":"RESPUESTA CENTRAL DE ELECTRORRETINOGRAMA MULTIFOCAL ANORMAL"
  },
  {
    "codigo":1279736003,
    "descripcion":"LESIÓN DE RETINA DE AMBOS OJOS"
  },
  {
    "codigo":165624002,
    "descripcion":"HIERRO SÉRICO POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":296696005,
    "descripcion":"SOBREDOSIS DE CEFACLOR"
  },
  {
    "codigo":1345272009,
    "descripcion":"INSUFICIENCIA OVÁRICA POSTERIOR A PROCEDIMIENTO"
  },
  {
    "codigo":722680009,
    "descripcion":"ADENOCARCINOMA SEROSO PRIMARIO DE ENDOMETRIO"
  },
  {
    "codigo":719010001,
    "descripcion":"DISCAPACIDAD INTELECTUAL LIGADA AL CROMOSOMA X TIPO SCHIMKE"
  },
  {
    "codigo":63650001,
    "descripcion":"CÓLERA"
  },
  {
    "codigo":260258004,
    "descripcion":"N12"
  },
  {
    "codigo":784546005,
    "descripcion":"SINOVITIS DE ARTICULACIÓN DE PIE"
  },
  {
    "codigo":293026006,
    "descripcion":"REACCIÓN ADVERSA AL MONOBACTAM"
  },
  {
    "codigo":291191000,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR TIORIDAZINA"
  },
  {
    "codigo":94583000,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE PARTES BLANDAS DE AXILA"
  },
  {
    "codigo":225655006,
    "descripcion":"POLIARTRITIS DEGENERATIVA"
  },
  {
    "codigo":127351006,
    "descripcion":"COLINA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":92748000,
    "descripcion":"CARCINOMA IN SITU DE LA PIEL DE LA MUÑECA"
  },
  {
    "codigo":715340002,
    "descripcion":"DISTROFIA MUSCULAR DE LAS CINTURAS DE LAS EXTREMIDADES TIPO 2D AUTOSÓMICA RECESIVA"
  },
  {
    "codigo":289356003,
    "descripcion":"SITUACIÓN OBLICUA CON CABEZA FETAL EN FOSA ILÍACA IZQUIERDA"
  },
  {
    "codigo":713505000,
    "descripcion":"SÍNDROME DE MALABSORCIÓN GASTROINTESTINAL CONCOMITANTE CON INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":16542861000119107,
    "descripcion":"FRACTURA NO EXPUESTA DE METÁFISIS DE EXTREMO DISTAL DE RADIO IZQUIERDO"
  },
  {
    "codigo":449526005,
    "descripcion":"DISMINUCIÓN ESPONTÁNEA DEL TAMAÑO DE DEFECTO DEL TABIQUE INTERVENTRICULAR DEBIDO A TEJIDO DE TABIQUE MEMBRANOSO"
  },
  {
    "codigo":414923000,
    "descripcion":"HERNIA OBSTRUIDA DE PARED ABDOMINAL ANTERIOR"
  },
  {
    "codigo":283851005,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DE CABEZA Y CUELLO"
  },
  {
    "codigo":1332427007,
    "descripcion":"HISTIOCITOSIS DE CÉLULAS DE LANGERHANS DISEMINADA DE BAZO"
  },
  {
    "codigo":21707009,
    "descripcion":"SICOSIS LUPOIDE"
  },
  {
    "codigo":413088002,
    "descripcion":"MEMORIA VISUAL SECUENCIAL ESCASA"
  },
  {
    "codigo":249248002,
    "descripcion":"CONTRACCIÓN DEL CUERPO DEL PENE"
  },
  {
    "codigo":871840004,
    "descripcion":"EPISODIO DE DEPRESIÓN"
  },
  {
    "codigo":10863911000119106,
    "descripcion":"HERIDA POR DISPARO DE ARMA DE FUEGO DE REGIÓN DE TOBILLO DERECHO"
  },
  {
    "codigo":447691009,
    "descripcion":"CONFLUENCIA VENOSA PULMONAR EN PROXIMIDAD DIRECTA A LA AURÍCULA IZQUIERDA"
  },
  {
    "codigo":1363360007,
    "descripcion":"HIPERINSULINISMO RESISTENTE A DIAZÓXIDO"
  },
  {
    "codigo":314784002,
    "descripcion":"GLAUCOMA SECUNDARIO DE ÁNGULO CERRADO DEBIDO A SINEQUIAS PERIFÉRICAS ANTERIORES"
  },
  {
    "codigo":116341001,
    "descripcion":"QUISTE OVÁRICO FUNCIONAL"
  },
  {
    "codigo":18037001,
    "descripcion":"ASCITIS BILIAR"
  },
  {
    "codigo":247413002,
    "descripcion":"DOLOR DE FALSO TRABAJO DE PARTO"
  },
  {
    "codigo":50805004,
    "descripcion":"ATROFIA DE LENGUA"
  },
  {
    "codigo":1197685001,
    "descripcion":"ÚLCERA DUODENAL VASCULÍTICA"
  },
  {
    "codigo":183712009,
    "descripcion":"CONSULTA DOMICILIARIA DE CARDIOLOGÍA SOLICITADA"
  },
  {
    "codigo":312949007,
    "descripcion":"ADENOCARCINOMA EPITELIAL PIGMENTARIO DE RETINA"
  },
  {
    "codigo":216480009,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR AMINOFENAZONA"
  },
  {
    "codigo":704330001,
    "descripcion":"FRACTURA OSTEOPORÓTICA DE FÉMUR"
  },
  {
    "codigo":83573009,
    "descripcion":"DIETA RESTRINGIDA EN FENILALANINA"
  },
  {
    "codigo":253107007,
    "descripcion":"ENCEFALOCELE NASOFARÍNGEO"
  },
  {
    "codigo":309279000,
    "descripcion":"TRASTORNO MENTAL ORGÁNICO INDUCIDO POR CAFEÍNA"
  },
  {
    "codigo":47135001,
    "descripcion":"DISFUNCIÓN SOMÁTICA"
  },
  {
    "codigo":1163082009,
    "descripcion":"DACRIOADENITIS CAUSADA POR CYTOMEGALOVIRUS"
  },
  {
    "codigo":473119001,
    "descripcion":"RUPTURA DE IMPLANTE MUSCULOESQUELÉTICO"
  },
  {
    "codigo":372980000,
    "descripcion":"INFECCIÓN CAUSADA POR ASPERGILLUS CONICUS"
  },
  {
    "codigo":1259551009,
    "descripcion":"CARCINOMA ESCAMOSO FUSOCELULAR PRIMARIO"
  },
  {
    "codigo":241908004,
    "descripcion":"EFECTO TÓXICO CAUSADO POR ADHESIVO EN BARRA"
  },
  {
    "codigo":471284004,
    "descripcion":"PÉRDIDA DE LÁMINA DURA"
  },
  {
    "codigo":1290484006,
    "descripcion":"RADIOGRAFÍA DE DEDO PULGAR ANORMAL"
  },
  {
    "codigo":405748007,
    "descripcion":"YA RECIBE ASPIRINA"
  },
  {
    "codigo":274676007,
    "descripcion":"HORMIGUEO CUTÁNEO"
  },
  {
    "codigo":43465001,
    "descripcion":"ERROR CONGÉNITO DEL METABOLISMO DE LAS LIPOPROTEÍNAS"
  },
  {
    "codigo":240073000,
    "descripcion":"DISTROFIA MUSCULAR AUTOSÓMICA RECESIVA SIN PREDOMINIO EN LA CINTURA DE EXTREMIDAD"
  },
  {
    "codigo":209140004,
    "descripcion":"SUBLUXACIÓN NO EXPUESTA ENTRE LA CUARTA Y QUINTA VÉRTEBRAS CERVICALES"
  },
  {
    "codigo":10697004,
    "descripcion":"ABORTO ESPONTÁNEO COMPLICADO POR INSUFICIENCIA RENAL"
  },
  {
    "codigo":305609004,
    "descripcion":"BAJO ATENCIÓN DE OPTOMETRISTA"
  },
  {
    "codigo":403913006,
    "descripcion":"CARCINOMA BASOCELULAR TIPO MORFEA ESCLEROSANTE"
  },
  {
    "codigo":762526006,
    "descripcion":"CUERPO EXTRAÑO NO MAGNÉTICO RETENIDO EN OJO DERECHO"
  },
  {
    "codigo":860830009,
    "descripcion":"NEOPLASIA DE ESTROMA GASTROINTESTINAL DE LOCALIZACIONES SUPERPUESTAS DE ESTÓMAGO"
  },
  {
    "codigo":203635002,
    "descripcion":"LORDOSIS POSLAMINECTOMÍA"
  },
  {
    "codigo":269171002,
    "descripcion":"HERIDA ABIERTA DE REGIÓN LUMBAR"
  },
  {
    "codigo":301939004,
    "descripcion":"PUPILA CONTRAÍDA"
  },
  {
    "codigo":236403004,
    "descripcion":"GLOMERULOSCLEROSIS SEGMENTARIA FOCAL"
  },
  {
    "codigo":74398009,
    "descripcion":"VARONES XX"
  },
  {
    "codigo":367475009,
    "descripcion":"LESIÓN DE NERVIO CUBITAL"
  },
  {
    "codigo":37960002,
    "descripcion":"ATAXIA CEREBELOSA DE SANGER - BROWN"
  },
  {
    "codigo":365640002,
    "descripcion":"COMPUESTO DE GRUPO SANGUÍNEO COMÚN - HALLAZGO"
  },
  {
    "codigo":300104005,
    "descripcion":"DOLOR GENERALIZADO A LA PALPACIÓN EN PABELLÓN AURICULAR"
  },
  {
    "codigo":234568006,
    "descripcion":"CANDIDIASIS MUCOCUTÁNEA CRÓNICA"
  },
  {
    "codigo":11849461000119100,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE PARED TORÁCICA DERECHA"
  },
  {
    "codigo":1119304009,
    "descripcion":"SÍNDROME CRÓNICO POST-COVID-19"
  },
  {
    "codigo":68893001,
    "descripcion":"CONTUSIÓN DE NALGA"
  },
  {
    "codigo":429341003,
    "descripcion":"LUXACIÓN DE PRÓTESIS DE ARTICULACIÓN DE HOMBRO"
  },
  {
    "codigo":298269009,
    "descripcion":"NÓDULO EN EL TENDÓN"
  },
  {
    "codigo":296434002,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE HIDROXIZINA"
  },
  {
    "codigo":198130006,
    "descripcion":"ENFERMEDAD INFLAMATORIA PÉLVICA EN LA MUJER"
  },
  {
    "codigo":34290009,
    "descripcion":"NEMATODIASIS PULMONAR"
  },
  {
    "codigo":425671009,
    "descripcion":"INTESTINO NEUROGÉNICO"
  },
  {
    "codigo":30620003,
    "descripcion":"ESPINA BÍFIDA DE LA REGIÓN DORSAL"
  },
  {
    "codigo":292764006,
    "descripcion":"REACCIÓN ADVERSA A SOLUCIÓN PARA CARDIOPLEJÍA"
  },
  {
    "codigo":718748007,
    "descripcion":"PORPHYROMONAS ASACCHAROLYTICA O PREVOTELLA MELANINOGENICA"
  },
  {
    "codigo":1091471000119100,
    "descripcion":"PERICONDRITIS DE OÍDO EXTERNO DERECHO"
  },
  {
    "codigo":290929000,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR VILOXAZINA"
  },
  {
    "codigo":422001004,
    "descripcion":"COROIDOPATÍA HIPERTENSIVA"
  },
  {
    "codigo":94321004,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE ENCÍA"
  },
  {
    "codigo":127089008,
    "descripcion":"LINFADENOPATÍA YUGULAR"
  },
  {
    "codigo":354191000119102,
    "descripcion":"NEOPLASIA BENIGNA DE CÓRNEA DERECHA"
  },
  {
    "codigo":92486005,
    "descripcion":"NEOPLASIA BENIGNA DE LA VULVA"
  },
  {
    "codigo":715078007,
    "descripcion":"CAPAZ DE PASAR DE UN AUTOMÓVIL A UNA SILLA DE RUEDAS"
  },
  {
    "codigo":26950008,
    "descripcion":"TAQUICARDIA AURICULAR ECTÓPICA CRÓNICA"
  },
  {
    "codigo":188955001,
    "descripcion":"NEOPLASIA BENIGNA DE HUESOS PÉLVICOS, SACRO Y CÓCCIX"
  },
  {
    "codigo":57883007,
    "descripcion":"DIETA PARA PRUEBA DE RENINA"
  },
  {
    "codigo":56048001,
    "descripcion":"XERODERMIA PIGMENTOSA, GRUPO E"
  },
  {
    "codigo":1268464001,
    "descripcion":"AMPUTACIÓN PARCIAL TRAUMÁTICA DE SEGUNDO A QUINTO DEDOS DE PIE"
  },
  {
    "codigo":285424002,
    "descripcion":"GAMMAPATÍA MONOCLONAL POR IGG DE SIGNIFICACIÓN INCIERTA"
  },
  {
    "codigo":1237531009,
    "descripcion":"METÁSTASIS DE ADENOCARCINOMA EN PARATIROIDES"
  },
  {
    "codigo":416496005,
    "descripcion":"DESPLAZAMIENTO SUPERIOR DE HUESO INNOMINADO"
  },
  {
    "codigo":54213000,
    "descripcion":"OLIGOAMNIOS SIN RUPTURA DE MEMBRANAS"
  },
  {
    "codigo":185285001,
    "descripcion":"ATENDIDO POR FISIOTERAPEUTA"
  },
  {
    "codigo":283589005,
    "descripcion":"HERIDA DE PERDIGÓN EN PIE"
  },
  {
    "codigo":86981007,
    "descripcion":"OTITIS EXTERNA INFECCIOSA"
  },
  {
    "codigo":773274001,
    "descripcion":"SÍNDROME CRANEOFACIOESQUELÉTICO Y DE DISCAPACIDAD INTELECTUAL LIGADO AL CROMOSOMA X"
  },
  {
    "codigo":1332165009,
    "descripcion":"ÚLCERA VENOSA DE PIE"
  },
  {
    "codigo":1363098004,
    "descripcion":"ASTILLA EN PERINEO"
  },
  {
    "codigo":871578006,
    "descripcion":"FÍSTULA ARTERIOVENOSA DE VASOS PULMONARES DESPUÉS DE ANASTOMOSIS CAVOPULMONAR SUPERIOR"
  },
  {
    "codigo":609434007,
    "descripcion":"DAÑO FETAL POR RUBÉOLA MATERNA"
  },
  {
    "codigo":279919005,
    "descripcion":"TÚBULO DEL EPOÓFORO"
  },
  {
    "codigo":50543005,
    "descripcion":"INSERCIÓN DEL PENSAMIENTO"
  },
  {
    "codigo":247151007,
    "descripcion":"MÁCULA - LESIONES MULTIFOCALES EN PLACAS"
  },
  {
    "codigo":441924001,
    "descripcion":"EDAD GESTACIONAL DESCONOCIDA"
  },
  {
    "codigo":278084002,
    "descripcion":"FRECUENCIA CARDÍACA FETAL BASAL NORMAL"
  },
  {
    "codigo":771439009,
    "descripcion":"SÍNDROME DE MICRODELECIÓN 14Q22Q23"
  },
  {
    "codigo":11796521000119106,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN DE DEDO ÍNDICE DERECHO"
  },
  {
    "codigo":704068005,
    "descripcion":"FRACTURA POR ESTRÉS DE DIÁFISIS DE FÉMUR"
  },
  {
    "codigo":309017000,
    "descripcion":"DERIVADO A UN MÉDICO"
  },
  {
    "codigo":1162820008,
    "descripcion":"SOBREDOSIS DE VITAMINA K Y\/O DERIVADO DE VITAMINA K"
  },
  {
    "codigo":276249004,
    "descripcion":"CONDUCTA INTROVERTIDA"
  },
  {
    "codigo":472857006,
    "descripcion":"HEMORRAGIA PULMONAR PERINATAL"
  },
  {
    "codigo":1193753006,
    "descripcion":"ENTERITIS PRESUMIBLEMENTE INFECCIOSA"
  },
  {
    "codigo":77806000,
    "descripcion":"DIETA HIPOCALÓRICA"
  },
  {
    "codigo":210713009,
    "descripcion":"HERIDA ABIERTA DEL TALÓN"
  },
  {
    "codigo":866073009,
    "descripcion":"MELANOMA MALIGNO DE LESIÓN SUPERPUESTA DE OJO Y ANEXOS"
  },
  {
    "codigo":897006003,
    "descripcion":"FORMA DE BALA ANORMAL CONGÉNITA DE FALANGE DE DEDO PULGAR"
  },
  {
    "codigo":733166004,
    "descripcion":"INFECCIÓN DE PIEL CAUSADA POR BORRELIA"
  },
  {
    "codigo":208878007,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN METACARPOFALÁNGICA"
  },
  {
    "codigo":239811003,
    "descripcion":"ESPONDILITIS ANQUILOSANTE CON COMPROMISO MULTISISTÉMICO"
  },
  {
    "codigo":272579005,
    "descripcion":"FLOTANDO ACOSTADO DE LADO"
  },
  {
    "codigo":75971007,
    "descripcion":"NEOVASCULARIZACIÓN DE COROIDES Y RETINA"
  },
  {
    "codigo":403651008,
    "descripcion":"TELANGIECTASIA POR CORTICOSTEROIDES"
  },
  {
    "codigo":74136003,
    "descripcion":"INFECCIÓN CAUSADA POR THELAZIA CALLIPAEDA"
  },
  {
    "codigo":41368006,
    "descripcion":"TRASTORNO DE LAS VÍAS URINARIAS"
  },
  {
    "codigo":762264009,
    "descripcion":"INCONTINENCIA DE URGENCIA DEBIDA A PROLAPSO DE ÓRGANO GENITAL FEMENINO"
  },
  {
    "codigo":399981008,
    "descripcion":"NEOPLASIA Y\/O HAMARTOMA"
  },
  {
    "codigo":301677008,
    "descripcion":"SE LEVANTA DE LA CAMA"
  },
  {
    "codigo":201538004,
    "descripcion":"ARTROPATÍA ASOCIADA CON MICOSIS, DE LA REGIÓN PÉLVICA Y DEL MUSLO"
  },
  {
    "codigo":299842005,
    "descripcion":"REFLEJO MIOTÁTICO DE DEDO DE LA MANO: AUSENTE"
  },
  {
    "codigo":365378006,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA MANEJAR Y EMPUJAR UN JUGUETE"
  },
  {
    "codigo":1217346007,
    "descripcion":"NIVEL DE SUSTANCIA EN SANGRE POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":70466008,
    "descripcion":"FROTE"
  },
  {
    "codigo":166935004,
    "descripcion":"NIVEL DE TEOFILINA POR DEBAJO DE RANGO TERAPÉUTICO"
  },
  {
    "codigo":3095005,
    "descripcion":"PALUDISMO INDUCIDO"
  },
  {
    "codigo":723991007,
    "descripcion":"SÍNDROME ANGIO-OSTEOHIPERTRÓFICO"
  },
  {
    "codigo":230636004,
    "descripcion":"COMPRESIÓN AXILAR NERVIOSA"
  },
  {
    "codigo":197868009,
    "descripcion":"DIVERTÍCULO FALSO DE VEJIGA"
  },
  {
    "codigo":196033004,
    "descripcion":"NEUMONITIS CAUSADA POR INHALACIÓN DE ALIMENTO REGURGITADO"
  },
  {
    "codigo":1179073007,
    "descripcion":"INFECCIÓN DE INTESTINO CAUSADA POR SALMONELLA GRUPO E"
  },
  {
    "codigo":294337008,
    "descripcion":"ALERGIA A HIDROXIETILCELULOSA"
  },
  {
    "codigo":10897911000119102,
    "descripcion":"FRACTURA EXPUESTA DE BASE DE PRIMER HUESO METACARPIANO DE MANO IZQUIERDA"
  },
  {
    "codigo":95894002,
    "descripcion":"MUGUET ATRÓFICO"
  },
  {
    "codigo":330231000119103,
    "descripcion":"COMPRESIÓN DE NERVIO MUSCULOCUTÁNEO DERECHO"
  },
  {
    "codigo":1144470006,
    "descripcion":"APLASIA DE FALANGE PROXIMAL DE DEDO DE MANO"
  },
  {
    "codigo":292502005,
    "descripcion":"REACCIÓN ADVERSA A LA TERBUTALINA"
  },
  {
    "codigo":782187000,
    "descripcion":"ACINETOBACTER BAUMANNII O GRUPO DE ACINETOBACTER NOSOCOMIALIS"
  },
  {
    "codigo":30358009,
    "descripcion":"ESTENOSIS ADQUIRIDA DE CONDUCTO AUDITIVO EXTERNO SECUNDARIA A CIRUGÍA"
  },
  {
    "codigo":126827000,
    "descripcion":"NEOPLASIA DEL CUERPO DEL ESTÓMAGO"
  },
  {
    "codigo":94059000,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE PARTES BLANDAS DE LA PELVIS"
  },
  {
    "codigo":716651004,
    "descripcion":"LEIOMIOSARCOMA DE INTESTINO DELGADO"
  },
  {
    "codigo":124992004,
    "descripcion":"ALTERACIÓN DEL CUERPO POLAR"
  },
  {
    "codigo":92224008,
    "descripcion":"NEOPLASIA BENIGNA DE MÚSCULO DE LOS GLÚTEOS"
  },
  {
    "codigo":714816008,
    "descripcion":"HEMATURIA PERSISTENTE CONCOMITANTE CON GLOMERULONEFRITIS SEMILUNAR DIFUSA Y DEBIDA A ELLA"
  },
  {
    "codigo":11799031000119107,
    "descripcion":"LESIÓN DE ARTERIA UTERINA DERECHA"
  },
  {
    "codigo":8550001000004107,
    "descripcion":"FRACTURA DE HUESO DE SENO PARANASAL"
  },
  {
    "codigo":876821006,
    "descripcion":"CUERPO EXTRAÑO SUPERFICIAL EN ANO CON INFECCIÓN"
  },
  {
    "codigo":254229006,
    "descripcion":"SEUDOMONILETRIX"
  },
  {
    "codigo":712981006,
    "descripcion":"BAJO ATENCIÓN DE RADIÓLOGO Y CIRUJANO"
  },
  {
    "codigo":1299135002,
    "descripcion":"CLASIFICACIÓN DE MILLER PARA RECESIÓN GINGIVAL, CLASE II"
  },
  {
    "codigo":283327006,
    "descripcion":"PICADURA DE INSECTO EN LA MEJILLA"
  },
  {
    "codigo":281492001,
    "descripcion":"DEFORMIDAD ADQUIRIDA FIJA EN FLEXIÓN DE CADERA"
  },
  {
    "codigo":248724003,
    "descripcion":"CAPILARES DILATADOS"
  },
  {
    "codigo":1231764004,
    "descripcion":"HEMATOMA DEL SITIO DE ACCESO VASCULAR"
  },
  {
    "codigo":84884003,
    "descripcion":"TELANGIECTASIA RETINIANA"
  },
  {
    "codigo":707476006,
    "descripcion":"ESTENOSIS DE ARTERIA PULMONAR DERECHA COMO COMPLICACIÓN DE PROCEDIMIENTO"
  },
  {
    "codigo":445332006,
    "descripcion":"DESPLAZAMIENTO DE DISCO INTERVERTEBRAL CERVICAL"
  },
  {
    "codigo":312425004,
    "descripcion":"INFECCIÓN DE LA SANGRE Y EL SISTEMA LINFÁTICO"
  },
  {
    "codigo":83049007,
    "descripcion":"MIOFIBROSIS"
  },
  {
    "codigo":1162558000,
    "descripcion":"ONDULACIÓN DE LA SUPERFICIE MAMARIA ASOCIADA CON PRÓTESIS"
  },
  {
    "codigo":771177009,
    "descripcion":"SÍNDROME DE ECTRODACTILIA POLIDACTILIA"
  },
  {
    "codigo":10953361000119108,
    "descripcion":"HERIDA ABIERTA DE DEDO ANULAR DE MANO IZQUIERDA DEBIDA A MORDEDURA DE GATO"
  },
  {
    "codigo":212286003,
    "descripcion":"CONTUSIÓN, NERVIO SUPRAESCAPULAR"
  },
  {
    "codigo":277822002,
    "descripcion":"ANSIEDAD ACERCA DE AHOGARSE"
  },
  {
    "codigo":45431000087102,
    "descripcion":"HERIDA PUNZANTE DE PANTORRILLA IZQUIERDA"
  },
  {
    "codigo":47991000087103,
    "descripcion":"FRACTURA DE DIÁFISIS DE HÚMERO DERECHO"
  },
  {
    "codigo":35191000087105,
    "descripcion":"LEVADURA DE ESPECIE NO CANDIDA ALBICANS O CANDIDA DUBLINIENSIS DETECTADA"
  },
  {
    "codigo":470760002,
    "descripcion":"OCLUSIÓN DE VENA CAVA INFERIOR"
  },
  {
    "codigo":274152003,
    "descripcion":"ESPONDILOLISTESIS"
  },
  {
    "codigo":110312002,
    "descripcion":"ALTURA DE CORONA DENTAL ANATÓMICAMENTE INSUFICIENTE"
  },
  {
    "codigo":40311000087107,
    "descripcion":"DISTENSIÓN DE TENDÓN DE DEDO PULGAR IZQUIERDO"
  },
  {
    "codigo":42871000087105,
    "descripcion":"HERIDA DE REGIÓN DE RODILLA IZQUIERDA POR MORDEDURA"
  },
  {
    "codigo":60791000087107,
    "descripcion":"GASTROENTERITIS CAUSADA POR AEROMONAS VERONII"
  },
  {
    "codigo":12008008,
    "descripcion":"PAPILOMA PALMAR EN LA FRAMBESIA"
  },
  {
    "codigo":306920005,
    "descripcion":"MOVILIDAD DE MARTILLO: AUMENTADA"
  },
  {
    "codigo":403389006,
    "descripcion":"SOFOCO POSMENOPÁUSICO"
  },
  {
    "codigo":763837007,
    "descripcion":"SÍNDROME OROFACIODIGITAL TIPO 14"
  },
  {
    "codigo":1157053007,
    "descripcion":"INTOXICACIÓN ACCIDENTAL CAUSADA POR SUSTANCIA CON ESTRUCTURA BENCENO"
  },
  {
    "codigo":41106001,
    "descripcion":"TRASTORNO POR INHIBIDOR DEL FACTOR DE VON WILLEBRAND"
  },
  {
    "codigo":237714006,
    "descripcion":"HAMARTOMA DE HIPOTÁLAMO"
  },
  {
    "codigo":39271004,
    "descripcion":"FARINGITIS ULCEROSA"
  },
  {
    "codigo":301415004,
    "descripcion":"DOLOR A LA DESCOMPRESIÓN DE LA REGIÓN CENTRAL"
  },
  {
    "codigo":1153383006,
    "descripcion":"LINFOMA MALIGNO DE HÍGADO"
  },
  {
    "codigo":399719007,
    "descripcion":"LOCALIZACIÓN DE TUMOR INTRAOCULAR, NO PUEDE SER DETERMINADO"
  },
  {
    "codigo":299580003,
    "descripcion":"ARTICULACIÓN DE DEDO DEL PIE - TUMEFACCIÓN SINOVIAL"
  },
  {
    "codigo":201276006,
    "descripcion":"CLOASMA CALÓRICO"
  },
  {
    "codigo":365116006,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA SUBIR Y BAJAR ESCALERAS GATEANDO"
  },
  {
    "codigo":232209000,
    "descripcion":"OBSTRUCCIÓN NASAL"
  },
  {
    "codigo":234044007,
    "descripcion":"TROMBOSIS DE VENA ILIOFEMORAL PROFUNDA"
  },
  {
    "codigo":70204006,
    "descripcion":"FRACTURA NO EXPUESTA DE QUINTO METATARSIANO"
  },
  {
    "codigo":998008,
    "descripcion":"ENFERMEDAD DE CHAGAS CON COMPROMISO DEL CORAZÓN"
  },
  {
    "codigo":263142009,
    "descripcion":"DIVISIÓN TRAUMÁTICA DE LIGAMENTO"
  },
  {
    "codigo":295910009,
    "descripcion":"SOBREDOSIS DE TRIPTÓFANO"
  },
  {
    "codigo":197606008,
    "descripcion":"SÍNDROME NEFRÓTICO EN EL PALUDISMO"
  },
  {
    "codigo":253576006,
    "descripcion":"INFUNDÍBULOS BILATERALES DEFICIENTES"
  },
  {
    "codigo":359611005,
    "descripcion":"NEUROPATÍA CON COMPLICACIÓN NEUROLÓGICA DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":195771008,
    "descripcion":"RINITIS ULCEROSA CRÓNICA"
  },
  {
    "codigo":718224004,
    "descripcion":"ATROFIA HEMIFACIAL PROGRESIVA"
  },
  {
    "codigo":93797001,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE ÓRGANO GENITAL FEMENINO"
  },
  {
    "codigo":292240009,
    "descripcion":"REACCIÓN ADVERSA A LA PROCARBAZINA"
  },
  {
    "codigo":126565003,
    "descripcion":"NEOPLASIA DE HUESO DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":16909561000119101,
    "descripcion":"DISFUNCIÓN DE GLÁNDULA DE MEIBOMIO DE PÁRPADO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":716389001,
    "descripcion":"CAPAZ DE ACCEDER AL PROPIO HOGAR"
  },
  {
    "codigo":419642000,
    "descripcion":"SOPLO CAROTÍDEO"
  },
  {
    "codigo":91962001,
    "descripcion":"NEOPLASIA BENIGNA DE NERVIO VESTIBULOCOCLEAR"
  },
  {
    "codigo":15680761000119102,
    "descripcion":"INFECCIÓN DE CONJUNTIVA DE OJO IZQUIERDO"
  },
  {
    "codigo":124730003,
    "descripcion":"ACOLURIA"
  },
  {
    "codigo":90127001,
    "descripcion":"FETO PAPIRÁCEO"
  },
  {
    "codigo":286735002,
    "descripcion":"RASGO DEL CARÁCTER: ESTABILIDAD AFECTIVA - HALLAZGO"
  },
  {
    "codigo":689401000119104,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE ENCÍA SUPERIOR"
  },
  {
    "codigo":11830521000119104,
    "descripcion":"LACERACIÓN DE ARCO PALMAR SUPERFICIAL DERECHO"
  },
  {
    "codigo":253967005,
    "descripcion":"POLIDACTILIA MESOAXIAL DE DEDO DEL PIE"
  },
  {
    "codigo":284900006,
    "descripcion":"CAPAZ DE REALIZAR ACTIVIDADES DE HIGIENE"
  },
  {
    "codigo":11804051000119100,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA DISTAL DE DEDO MEDIO IZQUIERDO"
  },
  {
    "codigo":446905000,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DE CARA"
  },
  {
    "codigo":86457007,
    "descripcion":"SECUENCIA REGULADORA DE ÁCIDOS NUCLEICOS"
  },
  {
    "codigo":250297009,
    "descripcion":"FÓRMULA LEUCOCÍTICA INVERSA"
  },
  {
    "codigo":51854002,
    "descripcion":"ATROFIA DE CONDUCTO BILIAR"
  },
  {
    "codigo":84622004,
    "descripcion":"INTOXICACIÓN ALIMENTARIA CAUSADA POR ESTAFILOCOCOS"
  },
  {
    "codigo":1264270004,
    "descripcion":"CORIOAMNIONITIS VIRAL"
  },
  {
    "codigo":215694006,
    "descripcion":"LESIÓN EN MEDIO DE TRANSPORTE ACUÁTICO PRODUCIDO POR MAQUINARIA DE CUBIERTA, CARGADOR DE MUELLES O ESTIBADOR LESIONADO"
  },
  {
    "codigo":1196899008,
    "descripcion":"HEMANGIOMA BENIGNO DE ESTÓMAGO"
  },
  {
    "codigo":246627009,
    "descripcion":"MANTIENE COPIA A LO LARGO DEL BRAZO"
  },
  {
    "codigo":1162296000,
    "descripcion":"INFLAMACIÓN DE BOLSA SEROSA CAUSADA POR MYCOBACTERIUM"
  },
  {
    "codigo":17251008,
    "descripcion":"INFESTACIÓN CAUSADA POR DEMODEX CANIS"
  },
  {
    "codigo":703544004,
    "descripcion":"MIOPATÍA CON CUERPOS DE INCLUSIÓN ASOCIADA CON ENFERMEDAD DE PAGET DE COMIENZO TEMPRANO Y DEMENCIA FRONTOTEMPORAL"
  },
  {
    "codigo":13581000,
    "descripcion":"TRASTORNO BIPOLAR I GRAVE, UN SOLO EPISODIO MANÍACO CON SÍNTOMAS PSICÓTICOS, CONGRUENTE CON EL ESTADO DE ÁNIMO"
  },
  {
    "codigo":79117005,
    "descripcion":"AGOTAMIENTO DE MÚSCULO CENTRAL"
  },
  {
    "codigo":275725007,
    "descripcion":"EXAMEN A LOS 8 MESES: ANORMAL - PARA OBSERVACIÓN"
  },
  {
    "codigo":734477008,
    "descripcion":"HIDROTÓRAX CONGÉNITO"
  },
  {
    "codigo":110050003,
    "descripcion":"LACERACIÓN COMPLEJA CONTAMINADA DE LA REGIÓN PREAURICULAR DE LA CARA"
  },
  {
    "codigo":698039001,
    "descripcion":"FRACTURA DE DIENTE INCOMPLETA"
  },
  {
    "codigo":403127002,
    "descripcion":"ONCODERMATITIS PAPULOSA CRÓNICA"
  },
  {
    "codigo":272055004,
    "descripcion":"RELATOR ENGAÑOSO"
  },
  {
    "codigo":370359005,
    "descripcion":"ECG: DUDOSO"
  },
  {
    "codigo":1156791007,
    "descripcion":"ENCEFALOPATÍA POR GLICINA ATÍPICA"
  },
  {
    "codigo":8076000,
    "descripcion":"PLACENTA ANORMAL POSTMADURA"
  },
  {
    "codigo":40844001,
    "descripcion":"INTOXICACIÓN POR HEXILRESORCINOL"
  },
  {
    "codigo":401292004,
    "descripcion":"ESCALA DE DISNEA DE BORG: 9 - MUY, MUY SEVERA (CASI MÁXIMA)"
  },
  {
    "codigo":6241000,
    "descripcion":"LIPOHIPERPLASIA DE VÁLVULA ILEOCECAL"
  },
  {
    "codigo":202849001,
    "descripcion":"PELLIZCAMIENTO SUBACROMIAL"
  },
  {
    "codigo":366689002,
    "descripcion":"AMPLITUD DE MOVIMIENTO ACTIVO DE FLEXIÓN DEL PULGAR - HALLAZGO"
  },
  {
    "codigo":301153003,
    "descripcion":"PULSO CAROTÍDEO PRESENTE"
  },
  {
    "codigo":73612008,
    "descripcion":"INTOXICACIÓN POR SETARIA LUTESCENS"
  },
  {
    "codigo":430390000,
    "descripcion":"TAQUIPNEA NEUROGÉNICA RELACIONADA CON EL SUEÑO"
  },
  {
    "codigo":233782000,
    "descripcion":"FÍSTULA TRAQUEOCUTÁNEA ADQUIRIDA"
  },
  {
    "codigo":299318002,
    "descripcion":"PRUEBA DE ORTOLANI NEGATIVA"
  },
  {
    "codigo":364854003,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA REBOTAR"
  },
  {
    "codigo":1251425008,
    "descripcion":"URTICARIA ALÉRGICA DE CONTACTO LOCALIZADA"
  },
  {
    "codigo":4406004,
    "descripcion":"ANOMALÍA CONGÉNITA DEL APARATO GENITAL MASCULINO"
  },
  {
    "codigo":23171000122102,
    "descripcion":"ALERGIA A FRUTO DEL KIWI"
  },
  {
    "codigo":37174005,
    "descripcion":"FRACTURA NO EXPUESTA DE HUESO GANCHOSO DEL CARPO"
  },
  {
    "codigo":399457008,
    "descripcion":"MARGEN QUIRÚRGICO PERIMETRAL COMPROMETIDO POR LINFOMA"
  },
  {
    "codigo":35339003,
    "descripcion":"PESTE NEUMÓNICA PRIMARIA"
  },
  {
    "codigo":363019004,
    "descripcion":"COMPLICACIÓN DE PROCEDIMIENTO DE PUNCIÓN"
  },
  {
    "codigo":231947004,
    "descripcion":"UVEÍTIS ANTERIOR IDIOPÁTICA"
  },
  {
    "codigo":11833031000119104,
    "descripcion":"ESGUINCE DE LIGAMENTO TARSOMETATARSIANO DE ARTICULACIÓN DE PIE DERECHO"
  },
  {
    "codigo":1149451003,
    "descripcion":"PERIODONTITIS GENERALIZADA ESTADIO 3 GRADO B SEGÚN LA CLASIFICACIÓN DE LAS ENFERMEDADES Y ALTERACIONES PERIODONTALES Y PERIIMPLANTARIAS DE 2017 DE LA ACADEMIA ESTADOUNIDENSE DE PERIODONTOLOGÍA Y LA FEDERACIÓN EUROPEA DE PERIODONTOLOGÍA"
  },
  {
    "codigo":33504000,
    "descripcion":"CONCRESCENCIA DE LOS DIENTES"
  },
  {
    "codigo":68107009,
    "descripcion":"PARESIA CEREBRAL CON ATAXIA HOMOLATERAL"
  },
  {
    "codigo":16010951000119105,
    "descripcion":"OSTEOARTROSIS DE AMBOS PIES DEBIDA A TRAUMATISMO"
  },
  {
    "codigo":736004,
    "descripcion":"ABSCESO DE LA CADERA"
  },
  {
    "codigo":197344005,
    "descripcion":"HEPATITIS CAUSADA POR ADENOVIRUS"
  },
  {
    "codigo":262880004,
    "descripcion":"PERFORACIÓN TARDÍA DE RECTO"
  },
  {
    "codigo":721632008,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE ANTRO PILÓRICO GÁSTRICO"
  },
  {
    "codigo":228277002,
    "descripcion":"BEBEDOR LEVE"
  },
  {
    "codigo":12242631000119107,
    "descripcion":"QUISTE DE GLÁNDULA PARÓTIDA IZQUIERDA"
  },
  {
    "codigo":293813008,
    "descripcion":"ALERGIA A LISURIDA"
  },
  {
    "codigo":423050000,
    "descripcion":"CARCINOMA PULMONAR MACROCÍTICO, TNM ESTADIO 2"
  },
  {
    "codigo":29834003,
    "descripcion":"NEUROPATÍA POR PELAGRA"
  },
  {
    "codigo":160906004,
    "descripcion":"TRABAJADOR INDEPENDIENTE"
  },
  {
    "codigo":62602005,
    "descripcion":"ENFERMEDAD ORGÁNICA PRESENTE"
  },
  {
    "codigo":717962006,
    "descripcion":"ALCALOSIS METABÓLICA SENSIBLE A CLORURO"
  },
  {
    "codigo":128138008,
    "descripcion":"TRASTORNO DE TOBILLO"
  },
  {
    "codigo":95370008,
    "descripcion":"CAMBIOS EN LA PIGMENTACIÓN DEL SITIO DE APLICACIÓN"
  },
  {
    "codigo":191839003,
    "descripcion":"FARMACODEPENDENCIA DE CANNABIS, EN REMISIÓN"
  },
  {
    "codigo":879967006,
    "descripcion":"CARGA VIRAL AUMENTADA"
  },
  {
    "codigo":1173044000,
    "descripcion":"TUMEFACCIÓN DE REGIÓN CLAVICULAR"
  },
  {
    "codigo":1142111009,
    "descripcion":"BRADICARDIA SINUSAL DEBIDA A ENFERMEDAD METABÓLICA"
  },
  {
    "codigo":1304116002,
    "descripcion":"SÍNDROME DE SOLAPAMIENTO DE SÍNDROME TIPO CRISPONI\/SÍNDROME DE SUDORACIÓN POR FRÍO Y DE SÍNDROME TIPO BOHRING-OPITZ ASOCIADO A GEN KLHL7"
  },
  {
    "codigo":57097000,
    "descripcion":"CRECIMIENTO Y DESARROLLO ALTERADOS: HABILIDADES SOCIALES"
  },
  {
    "codigo":417545003,
    "descripcion":"LIPOGRANULOMA ESCLEROSANTE SECUNDARIO"
  },
  {
    "codigo":286473004,
    "descripcion":"REBANA ALIMENTOS"
  },
  {
    "codigo":89865004,
    "descripcion":"INFECCIÓN CAUSADA POR PROTOSTRONGYLUS"
  },
  {
    "codigo":450313008,
    "descripcion":"COARTACIÓN DE AORTA ENTRE ARTERIAS CARÓTIDA PRIMITIVA IZQUIERDA Y CARÓTIDA PRIMITIVA DERECHA"
  },
  {
    "codigo":1236745009,
    "descripcion":"MASA QUE OCUPA CUADRANTE INFERIOR DERECHO DE ABDOMEN"
  },
  {
    "codigo":448478000,
    "descripcion":"ARTERIA COLATERAL QUE DERIVA EL FLUJO SISTÉMICO HACIA LA CIRCULACIÓN PULMONAR DESDE ARTERIA CORONARIA"
  },
  {
    "codigo":1234910007,
    "descripcion":"CABALGAMIENTO Y SUPERPOSICIÓN CONGÉNITOS DE VÁLVULA TRICÚSPIDE"
  },
  {
    "codigo":53427000,
    "descripcion":"SACUDIR LOS DEDOS DE LA MANO"
  },
  {
    "codigo":20659000,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO DE GENITALES FEMENINOS"
  },
  {
    "codigo":284638008,
    "descripcion":"CORTAR A OTRA PERSONA"
  },
  {
    "codigo":1169374008,
    "descripcion":"GLOBULINA FIJADORA DE TIROXINA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":315571004,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: FRANCÉS"
  },
  {
    "codigo":15666961000119100,
    "descripcion":"ARQUEAMIENTO CONGÉNITO DE FÉMUR IZQUIERDO"
  },
  {
    "codigo":15920401000119102,
    "descripcion":"REACCIÓN ALÉRGICA CAUSADA POR FRUTOS DE MAR"
  },
  {
    "codigo":15697681000119103,
    "descripcion":"TENDINITIS BILATERAL DE TOBILLO"
  },
  {
    "codigo":10836241000119104,
    "descripcion":"PEZÓN AGRIETADO ASOCIADO CON LA LACTANCIA"
  },
  {
    "codigo":15674641000119105,
    "descripcion":"TENDINITIS BILATERAL DE TENDÓN DEL MÚSCULO PSOAS"
  },
  {
    "codigo":15746321000119106,
    "descripcion":"INESTABILIDAD DE ARTICULACIÓN DE LA MANO IZQUIERDA"
  },
  {
    "codigo":849579281000119106,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DEBIDO A OCLUSIÓN DE ARTERIA COMUNICANTE POSTERIOR DERECHA"
  },
  {
    "codigo":226162961000119108,
    "descripcion":"TRASTORNO DE SISTEMA NERVIOSO CENTRAL DEBIDO A SÍNDROME DE SJÖGREN"
  },
  {
    "codigo":15669521000119108,
    "descripcion":"AUSENCIA CONGÉNITA DE EXTREMIDAD SUPERIOR IZQUIERDA"
  },
  {
    "codigo":1074961000119109,
    "descripcion":"ARTRITIS DE AMBAS ARTICULACIONES ESTERNOCLAVICULARES"
  },
  {
    "codigo":15738641000119109,
    "descripcion":"INFECCIÓN DE OJO IZQUIERDO"
  },
  {
    "codigo":114961000119106,
    "descripcion":"DESPRENDIMIENTO TARDÍO DEL CORDÓN UMBILICAL"
  },
  {
    "codigo":16908561000119107,
    "descripcion":"PAPILOMA DE PIEL DE PÁRPADO SUPERIOR DERECHO"
  },
  {
    "codigo":117128004,
    "descripcion":"CALIDAD DEL SOPLO CARDÍACO, RASPANTE"
  },
  {
    "codigo":112401000119106,
    "descripcion":"LESIÓN DE CONJUNTIVA"
  },
  {
    "codigo":1085201000119107,
    "descripcion":"FÍSTULA DE INTESTINO DEBIDA A PROCTITIS ULCEROSA CRÓNICA"
  },
  {
    "codigo":15715601000119109,
    "descripcion":"SECUESTRO ÓSEO TEMPORAL IZQUIERDO"
  },
  {
    "codigo":770653006,
    "descripcion":"ESTENOSIS DE CONDUCTO AUDITIVO EXTERNO CAUSADA POR RADIACIÓN IONIZANTE"
  },
  {
    "codigo":280968009,
    "descripcion":"TRASTORNO DE INJERTO ARTERIOVENOSO"
  },
  {
    "codigo":82525005,
    "descripcion":"ENFERMEDAD POLIQUÍSTICA RENAL CONGÉNITA"
  },
  {
    "codigo":277298001,
    "descripcion":"HERIDA POR ESCALPELO"
  },
  {
    "codigo":1260338007,
    "descripcion":"HIDROCEFALIA EX VACUO DEBIDA A RADIOTERAPIA Y POSTERIOR A ELLA"
  },
  {
    "codigo":80690008,
    "descripcion":"ENFERMEDAD DEGENERATIVA DEL SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":408370009,
    "descripcion":"USO INSUFICIENTE DE MEDICACIÓN VERIFICADO"
  },
  {
    "codigo":47922009,
    "descripcion":"BILIRRUBINURIA"
  },
  {
    "codigo":766983005,
    "descripcion":"SUSCEPTIBILIDAD A INFECCIONES RESPIRATORIAS ASOCIADA CON LA MUTACIÓN DE LA CADENA CD8 ALFA"
  },
  {
    "codigo":78855007,
    "descripcion":"SÍNDROME DE HIPERNASALIDAD POR DEBILIDAD VELOFARÍNGEA"
  },
  {
    "codigo":240860000,
    "descripcion":"LARVA MIGRANS CUTÁNEA POR GNATHOSTOMA"
  },
  {
    "codigo":109788007,
    "descripcion":"FIBROMA GINGIVAL OSIFICANTE PERIFÉRICO"
  },
  {
    "codigo":239025003,
    "descripcion":"ENANISMO, ALOPECIA, SEUDOANODONCIA, CUTIS LAXO"
  },
  {
    "codigo":271793004,
    "descripcion":"PATRÓN IRREGULAR DE SUEÑO-VIGILIA"
  },
  {
    "codigo":402865003,
    "descripcion":"LUPUS ERITEMATOSO SISTÉMICO ASOCIADO CON EL SÍNDROME ANTIFOSFOLIPÍDICO"
  },
  {
    "codigo":15931541000119108,
    "descripcion":"QUISTE FOLICULAR DE AMBOS OVARIOS"
  },
  {
    "codigo":269958004,
    "descripcion":"NO DETECTADO POR EXTENDIDO CERVICAL"
  },
  {
    "codigo":284821000119109,
    "descripcion":"ANEURISMA DE PORCIÓN INTRACRANEAL DE ARTERIA CARÓTIDA INTERNA"
  },
  {
    "codigo":1187462006,
    "descripcion":"GLUCOGENOSIS DEBIDA A DEFICIENCIA DE FOSFOGLICERATO CINASA 1"
  },
  {
    "codigo":202587000,
    "descripcion":"OSTEOCONDROMATOSIS SINOVIAL DE ARTICULACIÓN TIBIOPERONEA"
  },
  {
    "codigo":16314671000119104,
    "descripcion":"ENFERMEDAD DE DUPUYTREN DE LAS PALMAS DE AMBAS MANOS"
  },
  {
    "codigo":366427006,
    "descripcion":"AMPLITUD DE LA FLEXIÓN DE LA COLUMNA LUMBAR - HALLAZGO"
  },
  {
    "codigo":300891008,
    "descripcion":"EDEMA GENITAL"
  },
  {
    "codigo":102448004,
    "descripcion":"DISCINESIA MEDICAMENTOSA"
  },
  {
    "codigo":1077551000119106,
    "descripcion":"OSTEOMIELITIS CRÓNICA DE FÉMUR DERECHO"
  },
  {
    "codigo":299056008,
    "descripcion":"ESTRUCTURA MUSCULOESQUELÉTICA DE DEDO DE LA MANO - HALLAZGO"
  },
  {
    "codigo":67845009,
    "descripcion":"DEFICIENCIA DE AMINOMETILTRANSFERASA"
  },
  {
    "codigo":262618002,
    "descripcion":"CUERPO EXTRAÑO EN CONDUCTO DEFERENTE"
  },
  {
    "codigo":721370004,
    "descripcion":"LESIÓN COMPLETA DE MÉDULA ESPINAL AL NIVEL DEL OCTAVO SEGMENTO CERVICAL"
  },
  {
    "codigo":11864521000119103,
    "descripcion":"CONTUSIÓN DE PIE IZQUIERDO"
  },
  {
    "codigo":295386004,
    "descripcion":"SOBREDOSIS INTENCIONAL DE PIRENZEPINA"
  },
  {
    "codigo":129711000,
    "descripcion":"CON MAYOR RIESGO DE SÍNDROME DE ESTRÉS POR REUBICACIÓN"
  },
  {
    "codigo":66010009,
    "descripcion":"PARÁLISIS SUPRANUCLEAR"
  },
  {
    "codigo":293551003,
    "descripcion":"REACCIÓN ADVERSA AL DINITRATO DE ISOSORBIDA DE LIBERACIÓN MODIFICADA"
  },
  {
    "codigo":31407004,
    "descripcion":"HIPERTENSIÓN PREEXISTENTE QUE COMPLICA EL PUERPERIO Y\/O CONSTITUYE UN MOTIVO DE ATENCIÓN DURANTE ESTE PERÍODO"
  },
  {
    "codigo":162479007,
    "descripcion":"SÍNTOMA QUE EMPEORA CON EL FRÍO"
  },
  {
    "codigo":1340292000,
    "descripcion":"CONTUSIÓN DE MALÉOLO INTERNO"
  },
  {
    "codigo":1145519007,
    "descripcion":"APLASIA DE HUESO DE CARPO"
  },
  {
    "codigo":226180002,
    "descripcion":"DIETA SIN ADITIVOS ALIMENTARIOS"
  },
  {
    "codigo":95108005,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA MÉDULA ESPINAL"
  },
  {
    "codigo":717700009,
    "descripcion":"ENDOMETRIOSIS DE TÓRAX"
  },
  {
    "codigo":191577003,
    "descripcion":"ESQUIZOFRENIA CENESTOPÁTICA"
  },
  {
    "codigo":27737005,
    "descripcion":"RELLENO CAPILAR ANORMAL"
  },
  {
    "codigo":60505005,
    "descripcion":"ANOMALÍA CONGÉNITA DE PAPILA ÓPTICA"
  },
  {
    "codigo":93273006,
    "descripcion":"HIPOPLASIA CONGÉNITA DEL METATARSO"
  },
  {
    "codigo":715865008,
    "descripcion":"DISPLASIA ARRITMOGÉNICA AISLADA DE VENTRÍCULO DERECHO FAMILIAR"
  },
  {
    "codigo":1141849009,
    "descripcion":"SIGNO DE LESTER"
  },
  {
    "codigo":124206001,
    "descripcion":"DEFICIENCIA DE GENTISATO 1, 2 - DIOXIGENASA"
  },
  {
    "codigo":289881007,
    "descripcion":"HIPERPIGEMENTACIÓN DEL PERINEO FEMENINO"
  },
  {
    "codigo":224345007,
    "descripcion":"PODER NOTARIAL SOLICITADO"
  },
  {
    "codigo":58670006,
    "descripcion":"TRASTORNO DE GLÁNDULA LAGRIMAL ACCESORIA"
  },
  {
    "codigo":24067001,
    "descripcion":"PARAFASIA CENTRAL"
  },
  {
    "codigo":56835001,
    "descripcion":"PALICINESIA"
  },
  {
    "codigo":253443005,
    "descripcion":"ANOMALÍA DE EBSTEIN DE VÁLVULA AURICULOVENTRICULAR COMÚN"
  },
  {
    "codigo":251608007,
    "descripcion":"HALLAZGO RELACIONADO CON EL POTENCIAL EVOCADO AUDITIVO DEL TRONCO ENCEFÁLICO"
  },
  {
    "codigo":710360007,
    "descripcion":"NEUROPATÍA PERIFÉRICA DEBIDA A TRASTORNO METABÓLICO"
  },
  {
    "codigo":448216007,
    "descripcion":"NEOPLASIA EPITELIAL MALIGNA DE GLÁNDULA TIROIDES"
  },
  {
    "codigo":53165003,
    "descripcion":"ANEMIA MEGALOBLÁSTICA"
  },
  {
    "codigo":249773003,
    "descripcion":"PULGARES ANCHOS"
  },
  {
    "codigo":184237008,
    "descripcion":"TARJETA DE PRESCRIPCIÓN REPETIDA EXTRAVIADA"
  },
  {
    "codigo":1003437009,
    "descripcion":"HIPOPLASIA DE CÉLULAS DE LEYDIG DEBIDA A INACTIVACIÓN COMPLETA DEL RECEPTOR DE HORMONA LUTEINIZANTE"
  },
  {
    "codigo":444546002,
    "descripcion":"COLITIS ULCEROSA CRÓNICA"
  },
  {
    "codigo":278871005,
    "descripcion":"CONDUCTA INAPROPIADA EN LA ENFERMEDAD"
  },
  {
    "codigo":442711006,
    "descripcion":"HALLAZGO RELACIONADO CON DIFERENCIA EN EL COMPROMISO DEL LUGAR EN COMPARACIÓN CON EXAMEN RADIOLÓGICO PREVIO"
  },
  {
    "codigo":768556005,
    "descripcion":"SÍNDROME DE ATAXIA PANCITOPENIA"
  },
  {
    "codigo":703020006,
    "descripcion":"COCCIDIOIDES IMMITIS O COCCIDIOIDES POSADASII"
  },
  {
    "codigo":735788007,
    "descripcion":"HERIDA PERFORANTE DE ESTÓMAGO POSTERIOR A INGESTIÓN DE MATERIAL EXTRAÑO"
  },
  {
    "codigo":13057000,
    "descripcion":"DOLOR TORÁCICO PLEUROPERICÁRDICO"
  },
  {
    "codigo":766721001,
    "descripcion":"DISOMÍA UNIPARENTAL PATERNA DEL CROMOSOMA 7"
  },
  {
    "codigo":1080061000119107,
    "descripcion":"SARCOMA DE EWING PRIMARIO DE HUESO DE MANO DERECHA"
  },
  {
    "codigo":277036008,
    "descripcion":"UNIDADES MOTORAS ESTABLES"
  },
  {
    "codigo":1260076006,
    "descripcion":"CARCINOMA ESCAMOCELULAR NO QUERATINIZANTE DE CÉLULAS PEQUEÑAS DE PULMÓN"
  },
  {
    "codigo":342781000119108,
    "descripcion":"DERMATITIS ALÉRGICA POR CONTACTO DE PÁRPADO DERECHO"
  },
  {
    "codigo":111361008,
    "descripcion":"INVAGINACIÓN DEL CIEGO"
  },
  {
    "codigo":240598006,
    "descripcion":"VERRUGAS DE PENE"
  },
  {
    "codigo":109526006,
    "descripcion":"HIPOPLASIA ALVEOLAR CONGÉNITA DE LA MANDÍBULA"
  },
  {
    "codigo":43990006,
    "descripcion":"EMBARAZO DE SEXTILLIZOS"
  },
  {
    "codigo":402603005,
    "descripcion":"ERITEMA INFLAMATORIO DIFUSO"
  },
  {
    "codigo":238763007,
    "descripcion":"TELANGIECTASIA ESENCIAL GENERALIZADA"
  },
  {
    "codigo":304299008,
    "descripcion":"AMPLITUD DE MOVIMIENTO DE CODO NORMAL"
  },
  {
    "codigo":1252736003,
    "descripcion":"NÓDULO DE PIEL DE PULGAR DERECHO"
  },
  {
    "codigo":40320008,
    "descripcion":"CONDUCTO AUDITIVO DOBLE"
  },
  {
    "codigo":300629000,
    "descripcion":"UTILIZA TRANSPORTE PRIVADO"
  },
  {
    "codigo":71253000,
    "descripcion":"ENFERMEDAD DE TAY - SACHS, VARIANTE AB"
  },
  {
    "codigo":726613003,
    "descripcion":"DILATACIÓN DE COLÉDOCO DEBIDO A USO PERJUDICIAL DE KETAMINA"
  },
  {
    "codigo":366165008,
    "descripcion":"REFLEJO DE BÚSQUEDA - HALLAZGO"
  },
  {
    "codigo":1281834001,
    "descripcion":"CRISIS EPILÉPTICA COGNITIVA CON ALTERACIÓN DE CONCIENCIA DE INICIO FOCAL"
  },
  {
    "codigo":235093008,
    "descripcion":"MORDIDA ABIERTA LATERAL"
  },
  {
    "codigo":722943000,
    "descripcion":"MACROPROLACTINEMIA"
  },
  {
    "codigo":298794009,
    "descripcion":"AMPLITUD DE EXTENSIÓN PASIVA DE HOMBRO DISMINUIDA"
  },
  {
    "codigo":428031002,
    "descripcion":"FALSO ANEURISMA DE ARTERIA HUMERAL DISTAL"
  },
  {
    "codigo":198655001,
    "descripcion":"ABORTO ESPONTÁNEO COMPLETO CON INFECCIÓN PÉLVICA O DEL TRACTO GENITAL"
  },
  {
    "codigo":16837681000119104,
    "descripcion":"INFARTO DE MIOCARDIO DEBIDO A ISQUEMIA POR DEMANDA"
  },
  {
    "codigo":724778008,
    "descripcion":"ESCLEROSIS MÚLTIPLE RECIDIVANTE PROGRESIVA"
  },
  {
    "codigo":1148927006,
    "descripcion":"INFERTILIDAD FEMENINA IDIOPÁTICA"
  },
  {
    "codigo":15690801000119106,
    "descripcion":"ARTRITIS ENTEROPÁTICA DE AMBAS CADERAS"
  },
  {
    "codigo":295124009,
    "descripcion":"SOBREDOSIS DE PARACETAMOL"
  },
  {
    "codigo":293289007,
    "descripcion":"REACCIÓN ADVERSA A OCTREOTIDA"
  },
  {
    "codigo":291454000,
    "descripcion":"INTOXICACIÓN POR MEFLOQUINA"
  },
  {
    "codigo":422526001,
    "descripcion":"PELIGROS QUÍMICOS EN EL AMBIENTE"
  },
  {
    "codigo":1340030002,
    "descripcion":"ABRASIÓN DE PIEL DE TERCER DEDO DE PIE"
  },
  {
    "codigo":62078006,
    "descripcion":"INFECCIÓN CAUSADA POR HYPODEREUM"
  },
  {
    "codigo":94846007,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE HUESO FRONTAL"
  },
  {
    "codigo":420691000,
    "descripcion":"DEFICIENCIA NUTRICIONAL ASOCIADA CON SIDA (SÍNDROME DE INMUNODEFICIENCIA ADQUIRIDA)"
  },
  {
    "codigo":289619002,
    "descripcion":"ÚTERO, PRESENTE"
  },
  {
    "codigo":93011006,
    "descripcion":"ANOMALÍA CONGÉNITA DE HUESO NASAL"
  },
  {
    "codigo":846675007,
    "descripcion":"AMPOLLA SEROSA CUTÁNEA"
  },
  {
    "codigo":1303592000,
    "descripcion":"SEPSIS DEBIDA A INFECCIÓN CAUSADA POR CITROBACTER"
  },
  {
    "codigo":27475006,
    "descripcion":"BRONQUITIS CAUSADA POR EL VIRUS PARAINFLUENZA"
  },
  {
    "codigo":418856006,
    "descripcion":"NEUROPATÍA ÓPTICA PARANEOPLÁSICA"
  },
  {
    "codigo":255016007,
    "descripcion":"ADENOCARCINOMA DE EPITELIO PIGMENTADO DE CUERPO CILIAR"
  },
  {
    "codigo":123944006,
    "descripcion":"INTOXICACIÓN POR XANTHORRHOEACEAE"
  },
  {
    "codigo":449789003,
    "descripcion":"APIÑAMIENTO DE DIENTES INFERIORES ANTERIORES"
  },
  {
    "codigo":417021005,
    "descripcion":"DOLOR ESCLEROTÓMICO"
  },
  {
    "codigo":253181006,
    "descripcion":"DISPLASIA DE LA OLIVA"
  },
  {
    "codigo":56573006,
    "descripcion":"TRASTORNO DE TICS TRANSITORIOS"
  },
  {
    "codigo":285949009,
    "descripcion":"COLOCA Y RETIRA EL TAPÓN DEL DESAGÜE"
  },
  {
    "codigo":345291000119109,
    "descripcion":"GLAUCOMA DE BAJA TENSIÓN DE AMBOS OJOS"
  },
  {
    "codigo":15965541000119103,
    "descripcion":"ABSCESO DE GLÁNDULA DE BARTOLINO IZQUIERDA"
  },
  {
    "codigo":185810006,
    "descripcion":"CONTROL DE SALUD DE LA MUJER ANULADO"
  },
  {
    "codigo":315047001,
    "descripcion":"HEMATOMA SUBDURAL TRAUMÁTICO CON HERIDA INTRACRANEAL ABIERTA"
  },
  {
    "codigo":249511005,
    "descripcion":"DISPEPSIA POR DISMOTILIDAD"
  },
  {
    "codigo":870268001,
    "descripcion":"TRASTORNO GENERALIZADO DEL DESARROLLO CON TRASTORNO DEL DESARROLLO INTELECTUAL Y ALTERACIÓN COMPLETA DEL LENGUAJE FUNCIONAL SIN PÉRDIDA DE HABILIDADES ADQUIRIDAS PREVIAMENTE"
  },
  {
    "codigo":83836003,
    "descripcion":"EPIPLOCELE"
  },
  {
    "codigo":1263484004,
    "descripcion":"METÁSTASIS DE CARCINOMA ENDOMETRIOIDE EN OVARIO"
  },
  {
    "codigo":292351000119100,
    "descripcion":"TRASTORNO DE NERVIO ILIOINGUINAL IZQUIERDO"
  },
  {
    "codigo":51068008,
    "descripcion":"BRONQUIECTASIA EN EL ADULTO"
  },
  {
    "codigo":737361000,
    "descripcion":"CONFLICTO CON EL PAPEL SOCIAL"
  },
  {
    "codigo":247676009,
    "descripcion":"DELIRIO ASOCIADO CON ALUCINACIONES SEXUALES"
  },
  {
    "codigo":1228881003,
    "descripcion":"AMILOIDOSIS DE LEUCOCITOS QUIMIOTÁCTICOS FACTOR 2"
  },
  {
    "codigo":278609005,
    "descripcion":"PRÓTESIS MAXILOFACIAL FRACTURADA"
  },
  {
    "codigo":442449006,
    "descripcion":"INFECCIÓN DE HUESO DE TOBILLO Y\/O PIE"
  },
  {
    "codigo":1259814005,
    "descripcion":"ASTROCITOMA GEMISTOCÍTICO PRIMARIO DE CEREBRO"
  },
  {
    "codigo":47398006,
    "descripcion":"ÚLCERA CORNEAL MARGINAL"
  },
  {
    "codigo":735526006,
    "descripcion":"ESTADIO CLÍNICO 3 DE INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA DE LA ORGANIZACIÓN MUNDIAL DE LA SALUD DE 2007 CONCOMITANTE CON PALUDISMO"
  },
  {
    "codigo":1290747008,
    "descripcion":"ARTRITIS REACTIVA DE ARTICULACIÓN DE PARED PÉLVICA DEBIDA A DISENTERÍA Y POSTERIOR A ELLA"
  },
  {
    "codigo":897531008,
    "descripcion":"AGENESIA BILATERAL DE CÚBITO"
  },
  {
    "codigo":764624003,
    "descripcion":"SÍNDROME DE TRISOMÍA 20 MOSAICO"
  },
  {
    "codigo":404176003,
    "descripcion":"TÉTRADA DE OCLUSIÓN FOLICULAR: HIDRADENITIS, ACNÉ CONGLOBATA, CELULITIS DISECANTE DE CUERO CABELLUDO, QUISTE PILONIDAL"
  },
  {
    "codigo":305872006,
    "descripcion":"ATENDIDO POR SERVICIO DE SALUD PÚBLICA"
  },
  {
    "codigo":240336008,
    "descripcion":"INTOXICACIÓN ALIMENTARIA POR ESCHERICHIA COLI ENTEROTOXIGÉNICA"
  },
  {
    "codigo":109264009,
    "descripcion":"NEOPLASIA MALIGNA CUTÁNEA SUPERPUESTA"
  },
  {
    "codigo":41893002,
    "descripcion":"COMUNICACIÓN VENTRÍCULO IZQUIERDO - AURÍCULA DERECHA"
  },
  {
    "codigo":1156005004,
    "descripcion":"VALPROATO DE SODIO SÉRICO DENTRO DEL RANGO TERAPÉUTICO"
  },
  {
    "codigo":7290007,
    "descripcion":"CÁLCULO BILIAR IMPACTADO EN CONDUCTO CÍSTICO"
  },
  {
    "codigo":5455000,
    "descripcion":"ESOTROPÍA MONOCULAR"
  },
  {
    "codigo":302202009,
    "descripcion":"SÍNDROME DE LA TORRE DE BLOQUES"
  },
  {
    "codigo":890191004,
    "descripcion":"BRAQUIMETATARSIA DEL CUARTO METATARSIANO"
  },
  {
    "codigo":726351005,
    "descripcion":"TRISOMÍA PARCIAL DE CROMOSOMA 12"
  },
  {
    "codigo":300367007,
    "descripcion":"HALLAZGO RELACIONADO CON MEDICIONES DEL VÓMITO"
  },
  {
    "codigo":365903007,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA RECORDAR HABILIDADES MOTRICES NUEVAS"
  },
  {
    "codigo":724516001,
    "descripcion":"ÚLCERA DE ESÓFAGO CAUSADA POR AGENTE TÉRMICO"
  },
  {
    "codigo":298532007,
    "descripcion":"AMPLITUD DE FLEXIÓN LATERAL ACTIVA HACIA LA DERECHA DE LA COLUMNA VERTEBRAL DORSAL, AUMENTADA"
  },
  {
    "codigo":36388008,
    "descripcion":"ESTENOSIS DE UNIÓN URETEROPÉLVICA"
  },
  {
    "codigo":296697001,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE CEFACLOR"
  },
  {
    "codigo":427769002,
    "descripcion":"INFECCIÓN DE MUÑÓN DE AMPUTACIÓN"
  },
  {
    "codigo":1148665002,
    "descripcion":"RESPUESTA PARACENTRAL DE ELECTRORRETINOGRAMA MULTIFOCAL ANORMAL"
  },
  {
    "codigo":395001003,
    "descripcion":"HERIDAS ABIERTAS MÚLTIPLES DE HOMBRO Y BRAZO"
  },
  {
    "codigo":722681008,
    "descripcion":"ADENOCARCINOMA MIXTO PRIMARIO DE ENDOMETRIO"
  },
  {
    "codigo":262094002,
    "descripcion":"EMPARENTADO"
  },
  {
    "codigo":131022004,
    "descripcion":"NIVEL DE HORMONA LUTEINIZANTE HIPOFISARIA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":16621000146103,
    "descripcion":"NECESITA AYUDA PARA LAVARSE"
  },
  {
    "codigo":719011002,
    "descripcion":"DISCAPACIDAD INTELECTUAL LIGADA AL CROMOSOMA X TIPO PAI"
  },
  {
    "codigo":293027002,
    "descripcion":"REACCIÓN ADVERSA AL AZTREONAM"
  },
  {
    "codigo":1144995004,
    "descripcion":"INGESTA EXCESIVA DE VITAMINA B12 Y\/O DERIVADO DE VITAMINA B12"
  },
  {
    "codigo":260259007,
    "descripcion":"N14"
  },
  {
    "codigo":424099008,
    "descripcion":"COMA HEPÁTICO DEBIDO A HEPATITIS B AGUDA"
  },
  {
    "codigo":127352004,
    "descripcion":"COLINA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":94584006,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE PARTES BLANDAS DE GLÚTEO"
  },
  {
    "codigo":291192007,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR TIORIDAZINA"
  },
  {
    "codigo":225656007,
    "descripcion":"HUMOR IMPREDECIBLE"
  },
  {
    "codigo":59981001,
    "descripcion":"AUSENCIA CONGÉNITA DE PENE"
  },
  {
    "codigo":715341003,
    "descripcion":"DISTROFIA MUSCULAR DE LAS CINTURAS DE LAS EXTREMIDADES TIPO 2A AUTOSÓMICA RECESIVA"
  },
  {
    "codigo":289357007,
    "descripcion":"SITUACIÓN OBLICUA PODÁLICA EN FOSA ILÍACA DERECHA"
  },
  {
    "codigo":92749008,
    "descripcion":"CARCINOMA IN SITU DE LA PIEL"
  },
  {
    "codigo":713506004,
    "descripcion":"NEURITIS CONCOMITANTE CON INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":254754005,
    "descripcion":"FIBROXANTOMA ATÍPICO DE LA PIEL"
  },
  {
    "codigo":449527001,
    "descripcion":"CONDUCTO VENOSO AUSENTE CON CONEXIÓN DIRECTA DE VENA UMBILICAL A VENA CAVA INFERIOR"
  },
  {
    "codigo":285687003,
    "descripcion":"NO CARGA PESO EN PIERNA DERECHA"
  },
  {
    "codigo":1332428002,
    "descripcion":"HISTIOCITOSIS DE CÉLULAS DE LANGERHANS DISEMINADA DE GANGLIOS LINFÁTICOS DE MÚLTIPLES LOCALIZACIONES"
  },
  {
    "codigo":283852003,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO EN LA FRENTE"
  },
  {
    "codigo":414924006,
    "descripcion":"EVENTRACIÓN OBSTRUIDA EN PARED ABDOMINAL ANTERIOR"
  },
  {
    "codigo":871841000,
    "descripcion":"HEMORRAGIA PULMONAR DEBIDA A LEPTOSPIROSIS"
  },
  {
    "codigo":773537001,
    "descripcion":"SÍNDROME DE DIFERENCIACIÓN DEBIDO A QUIMIOTERAPIA CONCOMITANTE CON LEUCEMIA PROMIELOCÍTICA AGUDA Y POSTERIOR A ELLA"
  },
  {
    "codigo":10836071000119101,
    "descripcion":"LUXACIÓN DE LA SÍNFISIS DEL PUBIS EN EL EMBARAZO"
  },
  {
    "codigo":183713004,
    "descripcion":"CONSULTA DOMICILIARIA DE INMUNOLOGÍA SOLICITADA"
  },
  {
    "codigo":118177005,
    "descripcion":"HALLAZGO RELACIONADO CON LA POSICIÓN FETAL"
  },
  {
    "codigo":413089005,
    "descripcion":"MEMORIA AUDITIVA SECUENCIAL ESCASA"
  },
  {
    "codigo":1363361006,
    "descripcion":"HIPERINSULINISMO DIFUSO SENSIBLE A DIAZÓXIDO"
  },
  {
    "codigo":1197686000,
    "descripcion":"FÍSTULA DE INTESTINO GRUESO DEBIDA A DIVERTICULITIS"
  },
  {
    "codigo":216481008,
    "descripcion":"INTOXICACIÓN ACCIDENTAL CAUSADA POR FENILBUTAZONA"
  },
  {
    "codigo":249249005,
    "descripcion":"FLACCIDEZ PARCIAL DEL PENE"
  },
  {
    "codigo":312950007,
    "descripcion":"COROIDOPATÍA PUNTEADA INTERNA"
  },
  {
    "codigo":247414008,
    "descripcion":"DOLORES DE ENTUERTO"
  },
  {
    "codigo":48971001,
    "descripcion":"TIÑA DE LAS MANOS"
  },
  {
    "codigo":704331002,
    "descripcion":"FRACTURA OSTEOPORÓTICA DE PERONÉ"
  },
  {
    "codigo":677991000119104,
    "descripcion":"CUERPO HIALINO DE RETINA DE AMBOS OJOS"
  },
  {
    "codigo":1163083004,
    "descripcion":"DACRIOADENITIS POR ECHOVIRUS"
  },
  {
    "codigo":1259552002,
    "descripcion":"ENFERMEDAD CEREBROVASCULAR DEBIDA A IRRADIACIÓN CEREBRAL DIFERIDA-TARDÍA"
  },
  {
    "codigo":276512006,
    "descripcion":"DISRITMIA FETAL"
  },
  {
    "codigo":209141000,
    "descripcion":"SUBLUXACIÓN NO EXPUESTA ENTRE LA QUINTA Y SEXTA VÉRTEBRAS CERVICALES"
  },
  {
    "codigo":372981001,
    "descripcion":"INFECCIÓN CAUSADA POR ASPERGILLUS DEFLECTUS"
  },
  {
    "codigo":274677003,
    "descripcion":"HALLAZGOS ANORMALES EN EL EXAMEN MICROBIOLÓGICO DE LA ORINA"
  },
  {
    "codigo":405749004,
    "descripcion":"DIABETES DE DIAGNÓSTICO RECIENTE"
  },
  {
    "codigo":471285003,
    "descripcion":"ORIGEN ANÓMALO DE ARTERIA CORONARIA EN SENO AÓRTICO A LA IZQUIERDA DE SENO AÓRTICO NO ENFRENTADO"
  },
  {
    "codigo":241909007,
    "descripcion":"EFECTO TÓXICO CAUSADO POR PRODUCTO PARA CALZADO"
  },
  {
    "codigo":78069008,
    "descripcion":"PERICARDITIS REUMÁTICA CRÓNICA"
  },
  {
    "codigo":45301009,
    "descripcion":"INFESTACIÓN CAUSADA POR NOTOEDRES CATI"
  },
  {
    "codigo":403914000,
    "descripcion":"CARCINOMA BASOCELULAR SUPERFICIAL"
  },
  {
    "codigo":240074006,
    "descripcion":"DISTROFIA MUSCULAR ESCAPULOHUMERAL"
  },
  {
    "codigo":10698009,
    "descripcion":"IRIDOCICLITIS POR HERPES ZÓSTER"
  },
  {
    "codigo":762527002,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA BILATERAL DE HOMBROS"
  },
  {
    "codigo":305610009,
    "descripcion":"BAJO ATENCIÓN DE ESPECIALISTA EN ORTÓPTICA"
  },
  {
    "codigo":72564000,
    "descripcion":"MOVIMIENTO OCULAR RELÁMPAGO"
  },
  {
    "codigo":860831008,
    "descripcion":"HEMANGIOENDOTELIOMA EPITELIOIDE DE HÍGADO"
  },
  {
    "codigo":170868002,
    "descripcion":"CAMBIO EN SÍNTOMAS GINECOLÓGICOS"
  },
  {
    "codigo":236404005,
    "descripcion":"GLOMERULOSCLEROSIS SEGMENTARIA FOCAL CLÁSICA"
  },
  {
    "codigo":269172009,
    "descripcion":"HERIDA ABIERTA DE REGIÓN INGUINAL"
  },
  {
    "codigo":365641003,
    "descripcion":"GRUPO SANGUÍNEO MENOR - HALLAZGO"
  },
  {
    "codigo":300105006,
    "descripcion":"DOLOR FOCAL A LA PALPACIÓN EN PABELLÓN AURICULAR"
  },
  {
    "codigo":3358001,
    "descripcion":"LIQUEN ROJO MONILIFORME"
  },
  {
    "codigo":298270005,
    "descripcion":"ENGROSAMIENTO DE LA VAINA TENDINOSA"
  },
  {
    "codigo":429342005,
    "descripcion":"FRACTURA OSTEOCONDRAL NO EXPUESTA DE FÉMUR DISTAL"
  },
  {
    "codigo":167198009,
    "descripcion":"PRUEBA DE FUNCIÓN DIGESTIVA, NORMAL"
  },
  {
    "codigo":296435001,
    "descripcion":"SOBREDOSIS INTENCIONAL DE HIDROXIZINA"
  },
  {
    "codigo":294600007,
    "descripcion":"ALERGIA A PENTAMIDINA"
  },
  {
    "codigo":784285002,
    "descripcion":"TENESMO DE VEJIGA URINARIA"
  },
  {
    "codigo":718749004,
    "descripcion":"SÍNDROME DE DESCAMACIÓN CUTÁNEA GENERALIZADA"
  },
  {
    "codigo":391069009,
    "descripcion":"ABSORCIOMETRÍA DUAL DE RAYOS X DE HUESO DE REGIÓN DE ARTICULACIÓN DE CADERA NORMAL"
  },
  {
    "codigo":127090004,
    "descripcion":"LINFADENOPATÍA CERVICAL ANTERIOR"
  },
  {
    "codigo":94322006,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE HUESO GANCHOSO"
  },
  {
    "codigo":92487001,
    "descripcion":"NEOPLASIA BENIGNA DEL ANILLO DE WALDEYER"
  },
  {
    "codigo":715079004,
    "descripcion":"CAPAZ DE PASAR DE UNA SILLA A LA CAMA"
  },
  {
    "codigo":680501000119105,
    "descripcion":"SÍNDROME ENDOTELIAL IRIDOCORNEAL DE OJO DERECHO"
  },
  {
    "codigo":1237532002,
    "descripcion":"OCLUSIÓN DE VENA DE RETINA"
  },
  {
    "codigo":254492005,
    "descripcion":"NEOPLASIA DE SUPERFICIE NASOFARÍNGEA DE PALADAR BLANDO"
  },
  {
    "codigo":713244007,
    "descripcion":"FIBROSIS PULMONAR MEDICAMENTOSA"
  },
  {
    "codigo":1268465000,
    "descripcion":"AMPUTACIÓN PARCIAL TRAUMÁTICA DE DEDO GORDO DE PIE"
  },
  {
    "codigo":711409002,
    "descripcion":"ACIDURIA 3-METILGLUTACÓNICA TIPO IV CON SORDERA NEUROSENSORIAL, ENCEFALOPATÍA Y CUADRO SIMILAR AL SÍNDROME DE LEIGH"
  },
  {
    "codigo":16054991000119101,
    "descripcion":"ASTIGMATISMO DE OJO IZQUIERDO DESPUÉS DE PROCEDIMIENTO QUIRÚRGICO"
  },
  {
    "codigo":703539006,
    "descripcion":"SÍNDROME OCULOTRICOANAL DE MANITOBA"
  },
  {
    "codigo":283590001,
    "descripcion":"HERIDA DE PERDIGÓN EN DEDO DEL PIEL"
  },
  {
    "codigo":185286000,
    "descripcion":"ATENDIDO POR LOGOTERAPEUTA"
  },
  {
    "codigo":1332166005,
    "descripcion":"ÚLCERA VENOSA DE TALÓN"
  },
  {
    "codigo":414662006,
    "descripcion":"MELANOSIS"
  },
  {
    "codigo":773275000,
    "descripcion":"ENCEFALITIS LÍMBICA AGUDA DESPUÉS DE TRASPLANTE"
  },
  {
    "codigo":316358009,
    "descripcion":"LESIÓN TRAUMÁTICA PULMONAR"
  },
  {
    "codigo":216219003,
    "descripcion":"LESIÓN POR PROPULSOR A HÉLICE DE AERONAVE, SIN ACCIDENTE DE AERONAVE, PARACAIDISTA LESIONADO"
  },
  {
    "codigo":871579003,
    "descripcion":"DEFECTO PERIMEMBRANOSO DEL TABIQUE INTERVENTRICULAR EN EL CONO DE ENTRADA CON MALA ALINEACIÓN DEL TABIQUE AURICULOVENTRICULAR"
  },
  {
    "codigo":1363099007,
    "descripcion":"ASTILLA EN PERINEO CON INFECCIÓN"
  },
  {
    "codigo":609435008,
    "descripcion":"DAÑO FETAL POR LISTERIOSIS MATERNA"
  },
  {
    "codigo":52379009,
    "descripcion":"EDEMA SUBGLÓTICO"
  },
  {
    "codigo":247152000,
    "descripcion":"LESIÓN SUBRETINIANA"
  },
  {
    "codigo":50544004,
    "descripcion":"PÉRDIDA DE SANGRE FETAL PROVENIENTE DE VASOS PREVIOS"
  },
  {
    "codigo":279920004,
    "descripcion":"CONDUCTO DEL EPOÓFORO"
  },
  {
    "codigo":771440006,
    "descripcion":"SÍNDROME DE HEMIHIPERPLASIA CON LIPOMATOSIS MÚLTIPLE"
  },
  {
    "codigo":443760008,
    "descripcion":"HIPOVENTILACIÓN RELACIONADA CON EL SUEÑO"
  },
  {
    "codigo":278085001,
    "descripcion":"BRADICARDIA BASAL"
  },
  {
    "codigo":704069002,
    "descripcion":"FRACTURA POR ESTRÉS DE CLAVÍCULA"
  },
  {
    "codigo":310853003,
    "descripcion":"INFORME DE ESTADO DE VIVIENDA"
  },
  {
    "codigo":1162821007,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE VITAMINA K Y\/O DERIVADO DE VITAMINA K"
  },
  {
    "codigo":1193754000,
    "descripcion":"INFLAMACIÓN INTESTINAL PRESUMIBLEMENTE INFECCIOSA"
  },
  {
    "codigo":15700841000119102,
    "descripcion":"DISFUNCIÓN DE MÚSCULO OBLICUO SUPERIOR DE AMBOS OJOS"
  },
  {
    "codigo":866074003,
    "descripcion":"INFECCIÓN DE COLON CAUSADA POR SPIROCHAETES"
  },
  {
    "codigo":309018005,
    "descripcion":"DERIVADO A UN SERVICIO"
  },
  {
    "codigo":15864681000119104,
    "descripcion":"SUPERPOSICIÓN CONGÉNITA DE DEDOS DEL PIE DERECHO"
  },
  {
    "codigo":208879004,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA DISTAL"
  },
  {
    "codigo":897007007,
    "descripcion":"FORMA DE BALA ANORMAL CONGÉNITA DE FALANGE PROXIMAL DE DEDO PULGAR"
  },
  {
    "codigo":733167008,
    "descripcion":"GANGLIONITIS GENICULADA AGUDA CAUSADA POR VIRUS HERPES HUMANO TIPO 3"
  },
  {
    "codigo":11850601000119105,
    "descripcion":"CONTUSIÓN DE PARED TORÁCICA IZQUIERDA"
  },
  {
    "codigo":403652001,
    "descripcion":"LIPOATROFIA CAUSADA POR CORTICOESTEROIDE INYECTADO"
  },
  {
    "codigo":1255620003,
    "descripcion":"HIDRONEFROSIS OBSTRUCTIVA"
  },
  {
    "codigo":700399008,
    "descripcion":"EXTENDIDO CERVICAL - CAMBIO LIMÍTROFE EN LAS CÉLULAS ESCAMOSAS"
  },
  {
    "codigo":239812005,
    "descripcion":"ARTRITIS PSORIÁSICA CON COMPROMISO DE LA ARTICULACIÓN INTERFALÁNGICA DISTAL"
  },
  {
    "codigo":764100007,
    "descripcion":"MALFORMACIÓN VENOSA INTRAÓSEA PRIMARIA"
  },
  {
    "codigo":237977000,
    "descripcion":"TRASTORNO DEL METABOLISMO DEL GLICEROL"
  },
  {
    "codigo":272580008,
    "descripcion":"POSICIÓN SEMIRRECLINADA"
  },
  {
    "codigo":762265005,
    "descripcion":"INCONTINENCIA MIXTA DEBIDA A PROLAPSO DE ÓRGANO GENITAL FEMENINO"
  },
  {
    "codigo":11768681000119108,
    "descripcion":"HEMATOMA SUBUNGUEAL DE DEDO MEDIO DE MANO IZQUIERDA"
  },
  {
    "codigo":268910001,
    "descripcion":"EL ESTADO DEL PACIENTE MEJORA"
  },
  {
    "codigo":399982001,
    "descripcion":"TRASTORNO VASCULAR CONGÉNITO"
  },
  {
    "codigo":301678003,
    "descripcion":"NO SE LEVANTA DE UNA CAMA"
  },
  {
    "codigo":203374004,
    "descripcion":"DESPLAZAMIENTO AGUDO NO TRAUMÁTICO DE LA EPÍFISIS FEMORAL SUPERIOR"
  },
  {
    "codigo":299843000,
    "descripcion":"REFLEJO MIOTÁTICO DE DEDO DE LA MANO: PRESENTE SOLO CON REFUERZO"
  },
  {
    "codigo":365379003,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA PARTICIPAR EN ACTIVIDADES DEPORTIVAS"
  },
  {
    "codigo":398147005,
    "descripcion":"COMUNICACIÓN ANORMAL ENTRE EL SACO PERICÁRDICO Y LA PLEURA"
  },
  {
    "codigo":723992000,
    "descripcion":"SÍNDROME DE KUFOR RAKEB"
  },
  {
    "codigo":166936003,
    "descripcion":"NIVEL DE TEOFILINA POR ENCIMA DE RANGO TERAPÉUTICO"
  },
  {
    "codigo":298008006,
    "descripcion":"HERIDA HUMEDECIDA"
  },
  {
    "codigo":427245000,
    "descripcion":"LEUCOPENIA FEBRIL"
  },
  {
    "codigo":66797003,
    "descripcion":"DESORIENTACIÓN CON RESPECTO A LA PROPIA PERSONA"
  },
  {
    "codigo":296173006,
    "descripcion":"SOBREDOSIS DE TETRABENAZINA"
  },
  {
    "codigo":1261007,
    "descripcion":"FRACTURA DE MÚLTIPLES COSTILLAS"
  },
  {
    "codigo":230637008,
    "descripcion":"NEUROPATÍA COMPRESIVA DEL MIEMBRO INFERIOR"
  },
  {
    "codigo":11797661000119102,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE REGIÓN LUMBAR"
  },
  {
    "codigo":196034005,
    "descripcion":"NEUMONITIS CAUSADA POR INHALACIÓN DE LECHE"
  },
  {
    "codigo":32194006,
    "descripcion":"DRENAJE VENOSO PULMONAR ANÓMALO HACIA LAS VENAS HEPÁTICAS"
  },
  {
    "codigo":292503000,
    "descripcion":"REACCIÓN ADVERSA AL TULOBUTEROL"
  },
  {
    "codigo":423575005,
    "descripcion":"EMPUJE DE LA LENGUA AL TRAGAR, PERSISTENCIA ANORMAL DESPUÉS DE LA PRIMERA INFANCIA"
  },
  {
    "codigo":63127008,
    "descripcion":"DEFECTO EN LA SÍNTESIS DE TIROGLOBULINA"
  },
  {
    "codigo":94060005,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE PARTES BLANDAS DEL PERINEO"
  },
  {
    "codigo":126828005,
    "descripcion":"NEOPLASIA DE LA CURVATURA MENOR DEL ESTÓMAGO"
  },
  {
    "codigo":716652006,
    "descripcion":"CARCINOMA NEUROENDOCRINO HEPÁTICO PRIMARIO"
  },
  {
    "codigo":290668009,
    "descripcion":"INTOXICACIÓN POR IDARUBICINA"
  },
  {
    "codigo":714817004,
    "descripcion":"HEMATURIA RECURRENTE CONCOMITANTE CON GLOMERULONEFRITIS PROLIFERATIVA ENDOCAPILAR DIFUSA Y DEBIDA A ELLA"
  },
  {
    "codigo":24854000,
    "descripcion":"COMPLICACIÓN DE UNA EXTREMIDAD Y\/O DE OTRA PARTE DEL CUERPO REIMPLANTADA"
  },
  {
    "codigo":92225009,
    "descripcion":"NEOPLASIA BENIGNA DE MÚSCULO DE LA CARA"
  },
  {
    "codigo":254230001,
    "descripcion":"SÍNDROME DEL PELO IMPEINABLE"
  },
  {
    "codigo":302391000119103,
    "descripcion":"HIPEROSTOSIS ESQUELÉTICA IDIOPÁTICA DIFUSA DE COLUMNA VERTEBRAL DORSOLUMBAR"
  },
  {
    "codigo":23019001,
    "descripcion":"HIPOMETABOLISMO"
  },
  {
    "codigo":285163004,
    "descripcion":"CAPAZ DE RECONOCER OBJETOS VISUALMENTE"
  },
  {
    "codigo":283328001,
    "descripcion":"PICADURA DE INSECTO EN LA BOCA"
  },
  {
    "codigo":1299136001,
    "descripcion":"CLASIFICACIÓN DE MILLER PARA RECESIÓN GINGIVAL, CLASE III"
  },
  {
    "codigo":414400006,
    "descripcion":"HERNIA DE AMÍGDALA CEREBELOSA EN EL AGUJERO MAGNO"
  },
  {
    "codigo":445333001,
    "descripcion":"MARCADOR GENÉTICO DE SUSCEPTIBILIDAD A CÁNCER DE MAMA POSITIVO"
  },
  {
    "codigo":707477002,
    "descripcion":"ESTENOSIS DE ARTERIA PULMONAR COMO COMPLICACIÓN DE PROCEDIMIENTO"
  },
  {
    "codigo":281493006,
    "descripcion":"DEFORMIDAD ADQUIRIDA FIJA EN FLEXIÓN DE RODILLA"
  },
  {
    "codigo":455367991000119108,
    "descripcion":"FRACTURA ABIERTA DE PARED LATERAL DE ÓRBITA IZQUIERDA"
  },
  {
    "codigo":312426003,
    "descripcion":"INFECCIÓN ENDOCRINA"
  },
  {
    "codigo":246890003,
    "descripcion":"INYECCIÓN DEL LIMBO CORNEAL"
  },
  {
    "codigo":771178004,
    "descripcion":"SÍNDROME DE MALFORMACIÓN DE EDINBURGH"
  },
  {
    "codigo":237320005,
    "descripcion":"FALTA DE PROGRESIÓN EN LA PRIMERA ETAPA DEL PARTO"
  },
  {
    "codigo":410730009,
    "descripcion":"TRASTORNO DE LA REGIÓN VERTEBRAL"
  },
  {
    "codigo":408895002,
    "descripcion":"CON MAYOR RIESGO DE RELIGIOSIDAD ALTERADA"
  },
  {
    "codigo":48447003,
    "descripcion":"INSUFICIENCIA CARDÍACA CRÓNICA"
  },
  {
    "codigo":81215003,
    "descripcion":"IDEA SOBREVALUADA"
  },
  {
    "codigo":212287007,
    "descripcion":"LESIÓN ABIERTA, NERVIO SUPRAESCAPULAR"
  },
  {
    "codigo":1259028000,
    "descripcion":"LESIÓN DE PLEXO BRAQUIAL DEBIDA A VASCULITIS"
  },
  {
    "codigo":277823007,
    "descripcion":"ANSIEDAD ACERCA DE TRAGAR"
  },
  {
    "codigo":308756007,
    "descripcion":"APLASTAMIENTO DE VÉRTEBRA DORSAL"
  },
  {
    "codigo":77545000,
    "descripcion":"HIPOTENSIÓN ARTERIAL CRÓNICA"
  },
  {
    "codigo":863977001,
    "descripcion":"DERRAME PLEURAL DEBIDO A TRASTORNO DE PÁNCREAS"
  },
  {
    "codigo":15650411000119101,
    "descripcion":"CHASQUIDO BILATERAL DE RODILLAS"
  },
  {
    "codigo":110313007,
    "descripcion":"ALTURA CLÍNICA INSUFICIENTE DE CORONA DE DIENTE"
  },
  {
    "codigo":896745008,
    "descripcion":"TRASTORNO LINFOPROLIFERATIVO CUTÁNEO PRIMARIO DE LINFOCITOS T POSITIVOS PARA EL ANTÍGENO CD30"
  },
  {
    "codigo":1157054001,
    "descripcion":"INTOXICACIÓN CRÓNICA CAUSADA POR SUSTANCIA CON ESTRUCTURA BENCENO"
  },
  {
    "codigo":403390002,
    "descripcion":"ERITROMELALGIA PRIMARIA"
  },
  {
    "codigo":306921009,
    "descripcion":"HALLAZGO RELACIONADO CON LA MOVILIDAD DEL YUNQUE"
  },
  {
    "codigo":15676881000119109,
    "descripcion":"MIOSITIS DE BRAZO IZQUIERDO"
  },
  {
    "codigo":42942008,
    "descripcion":"FRACTURA DE LA COLUMNA VERTEBRAL POR COMPRESIÓN"
  },
  {
    "codigo":1255358009,
    "descripcion":"NEOPLASIA MALIGNA OLIGOMETASTÁSICA"
  },
  {
    "codigo":41041000087100,
    "descripcion":"LACERACIÓN DE EXTREMIDAD SUPERIOR DERECHA"
  },
  {
    "codigo":48721000087100,
    "descripcion":"DISTENSIÓN DE TENDÓN FLEXOR DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":41107005,
    "descripcion":"INFECCIÓN CAUSADA POR PNEUMOSPIRURA"
  },
  {
    "codigo":237715007,
    "descripcion":"MASA HIPOFISARIA"
  },
  {
    "codigo":1153384000,
    "descripcion":"NEOPLASIA DE ESTROMA GASTROINTESTINAL DE ÍLEON"
  },
  {
    "codigo":46161000087105,
    "descripcion":"FRACTURA DE EXTREMO DISTAL DE HÚMERO DERECHO"
  },
  {
    "codigo":85611000119105,
    "descripcion":"ESPONDILOARTROPATÍA INDIFERENCIADA"
  },
  {
    "codigo":301416003,
    "descripcion":"DOLOR A LA DESCOMPRESIÓN EN REGIÓN LUMBAR DERECHA"
  },
  {
    "codigo":38481000087108,
    "descripcion":"ACINESIA DE MIOCARDIO DE REGIÓN LATERAL DE VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":235880004,
    "descripcion":"FIBROSIS ALCOHÓLICA Y ESCLEROSIS HEPÁTICA"
  },
  {
    "codigo":43601000087109,
    "descripcion":"CONTUSIÓN DE MEJILLA IZQUIERDA"
  },
  {
    "codigo":4669001,
    "descripcion":"PINTA, LESIÓN PRIMARIA"
  },
  {
    "codigo":201277002,
    "descripcion":"CLOASMA HEPÁTICO"
  },
  {
    "codigo":365117002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD DE SUBIR Y BAJAR ESCALERAS SENTADO"
  },
  {
    "codigo":299581004,
    "descripcion":"DEFORMIDAD DE ARTICULACIÓN DE DEDO DEL PIE -"
  },
  {
    "codigo":15951621000119102,
    "descripcion":"DERMATOFIBROMA BILATERAL DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":102973009,
    "descripcion":"POTENCIAL EVOCADO AUDITIVO DEL TRONCO ENCEFÁLICO: NORMAL"
  },
  {
    "codigo":234045008,
    "descripcion":"TROMBOSIS DE LA VENA TRASPLANTADA"
  },
  {
    "codigo":426983002,
    "descripcion":"INFARTO DEL BULBO RAQUÍDEO"
  },
  {
    "codigo":263143004,
    "descripcion":"SECCIÓN TRAUMÁTICA DE LIGAMENTO DE LA MUÑECA"
  },
  {
    "codigo":66535005,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DE RODILLA"
  },
  {
    "codigo":197607004,
    "descripcion":"SÍNDROME NEFRÓTICO EN LA POLIARTERITIS NUDOSA"
  },
  {
    "codigo":295911008,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE TRIPTÓFANO"
  },
  {
    "codigo":195772001,
    "descripcion":"RINITIS MEMBRANOSA CRÓNICA"
  },
  {
    "codigo":294076004,
    "descripcion":"ALERGIA A ATROPINA"
  },
  {
    "codigo":161169000,
    "descripcion":"ÍNDICE DE MORBILIDAD BAJO"
  },
  {
    "codigo":425148008,
    "descripcion":"CARCINOMA ESCAMOCELULAR DE LA SIEN"
  },
  {
    "codigo":292241008,
    "descripcion":"REACCIÓN ADVERSA AL RAZOXANO"
  },
  {
    "codigo":95633009,
    "descripcion":"HIPOQUINESIA NEONATAL"
  },
  {
    "codigo":126566002,
    "descripcion":"NEOPLASIA DE OMÓPLATO"
  },
  {
    "codigo":16007071000119102,
    "descripcion":"REUMATISMO PALINDRÓMICO BILATERAL DE ARTICULACIONES DE MANOS"
  },
  {
    "codigo":716390005,
    "descripcion":"CAPAZ DE ACCEDER A LUGAR DE ESTACIONAMIENTO DE AUTOMÓVILES"
  },
  {
    "codigo":93798006,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE FÉMUR"
  },
  {
    "codigo":124731004,
    "descripcion":"INTERRUPCIÓN INDUCIDA DE LA ESPERMATOGENIA"
  },
  {
    "codigo":91963006,
    "descripcion":"NEOPLASIA BENIGNA DEL ACROMION"
  },
  {
    "codigo":26427008,
    "descripcion":"HISTOPLASMOSIS PULMONAR CRÓNICA"
  },
  {
    "codigo":253968000,
    "descripcion":"SINDACTILIA SIMPLE DE LOS DEDOS DE LOS PIES, SEGUNDA A CUARTA MEMBRANA INTERDIGITAL"
  },
  {
    "codigo":286736001,
    "descripcion":"TIENDE A SER ESTABLE EN SUS AFECTOS"
  },
  {
    "codigo":16908191000119106,
    "descripcion":"NEVO EPIDÉRMICO DE PÁRPADO INFERIOR DERECHO"
  },
  {
    "codigo":90128006,
    "descripcion":"FOTOSENSIBILIDAD"
  },
  {
    "codigo":219365001,
    "descripcion":"EFECTO TARDÍO DE LESIÓN TRAUMÁTICA PROVOCADA CON INTENCIONALIDAD DESCONOCIDA"
  },
  {
    "codigo":688031000119107,
    "descripcion":"SARCOMA PRIMARIO DE CUELLO"
  },
  {
    "codigo":88293003,
    "descripcion":"ASOCIACIÓN DE SONIDOS"
  },
  {
    "codigo":11311161000119101,
    "descripcion":"FRACTURA EXPUESTA DE CUARTA VÉRTEBRA DORSAL"
  },
  {
    "codigo":284901005,
    "descripcion":"INCAPAZ DE REALIZAR ACTIVIDADES DE HIGIENE"
  },
  {
    "codigo":186597006,
    "descripcion":"INTOXICACIÓN POR PESCADO"
  },
  {
    "codigo":55525008,
    "descripcion":"ÍLEO PARALÍTICO"
  },
  {
    "codigo":283066007,
    "descripcion":"ARAÑAZO DE LA CABEZA"
  },
  {
    "codigo":1264271000,
    "descripcion":"CORIOAMNIONITIS FÚNGICA"
  },
  {
    "codigo":19087001,
    "descripcion":"QUERIÓN"
  },
  {
    "codigo":1231503005,
    "descripcion":"TRASTORNO PSICÓTICO CON PRESENCIA DE INTROSPECCIÓN"
  },
  {
    "codigo":182927005,
    "descripcion":"DIETA LIBRE EN FENILALANINA"
  },
  {
    "codigo":248463009,
    "descripcion":"TOLERANTE A LA TEMPERATURA AMBIENTAL"
  },
  {
    "codigo":17252001,
    "descripcion":"INTOXICACIÓN POR DATURA"
  },
  {
    "codigo":1196900003,
    "descripcion":"LINFOMA DE CÉLULAS B DE INTESTINO DELGADO"
  },
  {
    "codigo":246628004,
    "descripcion":"SOSTIENE OBJETOS CERCA"
  },
  {
    "codigo":410468007,
    "descripcion":"ROSÉOLA DE IRIS"
  },
  {
    "codigo":82788007,
    "descripcion":"LESIÓN TRAUMÁTICA DE TOBILLO EN SUPINACIÓN-ROTACIÓN INTERNA"
  },
  {
    "codigo":1295204009,
    "descripcion":"LIPOMA INTRAMUSCULAR"
  },
  {
    "codigo":736313002,
    "descripcion":"TRASTORNO DISOCIATIVO CON SÍNTOMA NEUROLÓGICO CONCOMITANTE CON SÍNTOMAS DE ALTERACIÓN DE LA MARCHA"
  },
  {
    "codigo":80953005,
    "descripcion":"ÚLCERA PÉPTICA CRÓNICA CON PERFORACIÓN PERO SIN OBSTRUCCIÓN"
  },
  {
    "codigo":79118000,
    "descripcion":"ÚLCERA PÉPTICA AGUDA CON PERFORACIÓN"
  },
  {
    "codigo":1162297009,
    "descripcion":"INFECCIÓN DE SITIOS MÚLTIPLES DE COLUMNA VERTEBRAL CAUSADA POR MYCOBACTERIUM TUBERCULOSIS"
  },
  {
    "codigo":210190001,
    "descripcion":"LESIÓN TRAUMÁTICA ESPLÉNICA CON HEMATOMA SIN RUPTURA CAPSULAR, CON HERIDA ABIERTA HACIA CAVIDAD"
  },
  {
    "codigo":333881000119109,
    "descripcion":"OPACIDAD MENOR DE CÓRNEA DERECHA"
  },
  {
    "codigo":44515000,
    "descripcion":"PERSEVERACIÓN"
  },
  {
    "codigo":275726008,
    "descripcion":"EXAMEN A LOS 8 MESES: ANORMAL - DERIVADO"
  },
  {
    "codigo":110051004,
    "descripcion":"AVULSIÓN DE LA REGIÓN PREAURICULAR DE LA CARA"
  },
  {
    "codigo":699875007,
    "descripcion":"AMPUTACIÓN TRANSTIBIOPERONEA TRAUMÁTICA"
  },
  {
    "codigo":1156792000,
    "descripcion":"ENFERMEDAD DE GAUCHER ATÍPICA DEBIDA A DEFICIENCIA DE SAPOSINA C"
  },
  {
    "codigo":272056003,
    "descripcion":"TESTIGO POCO CONFIABLE"
  },
  {
    "codigo":1255096004,
    "descripcion":"ADENOCARCINOMA DE SENO ETMOIDAL"
  },
  {
    "codigo":611241000124101,
    "descripcion":"DETECTOR DE MONÓXIDO DE CARBONO FUNCIONANTE EN DOMICILIO"
  },
  {
    "codigo":1961000124102,
    "descripcion":"TRANSICIÓN DE LA ATENCIÓN EN CUIDADOS PALIATIVOS A ATENCIÓN DOMICILIARIA"
  },
  {
    "codigo":42680007,
    "descripcion":"NEUMONITIS LIPOIDE ENDÓGENA"
  },
  {
    "codigo":40845000,
    "descripcion":"ÚLCERA GASTROINTESTINAL"
  },
  {
    "codigo":237453001,
    "descripcion":"MASTALGIA CÍCLICA"
  },
  {
    "codigo":698040004,
    "descripcion":"MELANOMA MALIGNO DE CAVIDAD NASAL"
  },
  {
    "codigo":403128007,
    "descripcion":"ONCODERMATITIS ATRÓFICA"
  },
  {
    "codigo":71778000,
    "descripcion":"EXTINCIÓN SENSITIVA"
  },
  {
    "codigo":202850001,
    "descripcion":"PELLIZCAMIENTO DE APÓFISIS CORACOIDES"
  },
  {
    "codigo":235618002,
    "descripcion":"ESTENOSIS POR AGENTE CORROSIVO DEL ESÓFAGO"
  },
  {
    "codigo":401293009,
    "descripcion":"ESCALA DE DISNEA DE BORG: 10 - MÁXIMA"
  },
  {
    "codigo":366690006,
    "descripcion":"AMPLITUD DE MOVIMIENTO PASIVO DE FLEXIÓN DEL PULGAR - HALLAZGO"
  },
  {
    "codigo":6242007,
    "descripcion":"INFECCIÓN CAUSADA POR MARSHALLAGIA"
  },
  {
    "codigo":301154009,
    "descripcion":"PULSO BRAQUIAL PRESENTE"
  },
  {
    "codigo":1251426009,
    "descripcion":"DERMATITIS ALÉRGICA DE CONTACTO DE CUERO CABELLUDO"
  },
  {
    "codigo":364855002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA REBOTAR EN UN PIE"
  },
  {
    "codigo":233783005,
    "descripcion":"HEMORRAGIA TRAQUEAL"
  },
  {
    "codigo":299319005,
    "descripcion":"PRUEBA DE BARLOW POSITIVA"
  },
  {
    "codigo":201015007,
    "descripcion":"PRURIGO ACTÍNICO"
  },
  {
    "codigo":363020005,
    "descripcion":"COMPLICACIÓN DE PROCEDIMIENTO DE REDUCCIÓN"
  },
  {
    "codigo":1149452005,
    "descripcion":"PERIODONTITIS GENERALIZADA ESTADIO 3 GRADO C SEGÚN LA CLASIFICACIÓN DE LAS ENFERMEDADES Y ALTERACIONES PERIODONTALES Y PERIIMPLANTARIAS DE 2017 DE LA ACADEMIA ESTADOUNIDENSE DE PERIODONTOLOGÍA Y LA FEDERACIÓN EUROPEA DE PERIODONTOLOGÍA"
  },
  {
    "codigo":262881000,
    "descripcion":"SECCIÓN DE RECTO"
  },
  {
    "codigo":231948009,
    "descripcion":"CAMBIOS EN EL IRIS RELACIONADOS A LA EDAD"
  },
  {
    "codigo":721633003,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE LESIÓN SUPERPUESTA DE ESTÓMAGO"
  },
  {
    "codigo":33505004,
    "descripcion":"OCLUSIÓN DEFECTUOSA POR RESPIRACIÓN BUCAL"
  },
  {
    "codigo":295649009,
    "descripcion":"SOBREDOSIS DE LOMUSTINA"
  },
  {
    "codigo":293814002,
    "descripcion":"ALERGIA A PERGOLIDA"
  },
  {
    "codigo":64438006,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN METATARSOFALÁNGICA"
  },
  {
    "codigo":228278007,
    "descripcion":"BEBEDOR CON CONSUMO BASTANTE EXCESIVO"
  },
  {
    "codigo":128139000,
    "descripcion":"TRASTORNO INFLAMATORIO"
  },
  {
    "codigo":423051001,
    "descripcion":"HEMATOMA FACIAL"
  },
  {
    "codigo":717963001,
    "descripcion":"HIPERTRICOSIS CERVICAL ANTERIOR AISLADA"
  },
  {
    "codigo":62603000,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE CUERO CABELLUDO SIN INFECCIÓN"
  },
  {
    "codigo":95371007,
    "descripcion":"ERUPCIÓN EN SITIO DE APLICACIÓN"
  },
  {
    "codigo":160907008,
    "descripcion":"BAJO ESQUEMA DE ENTRENAMIENTO GUBERNAMENTAL"
  },
  {
    "codigo":879968001,
    "descripcion":"RESPUESTA VIRAL SOSTENIDA"
  },
  {
    "codigo":1142112002,
    "descripcion":"PÉRDIDA DE LA AUDICIÓN NEUROSENSORIAL DEBIDA A SÍFILIS CONGÉNITA TARDÍA"
  },
  {
    "codigo":93536009,
    "descripcion":"GRANULOMA DE HODGKIN DEL BAZO"
  },
  {
    "codigo":336391000119107,
    "descripcion":"ESCLERITIS ANTERIOR DE OJO DERECHO"
  },
  {
    "codigo":616839841000119101,
    "descripcion":"DOLOR LUMBAR VERTEBROGÉNICO"
  },
  {
    "codigo":160520003,
    "descripcion":"ORIGEN: MEDIO ORIENTE"
  },
  {
    "codigo":26165005,
    "descripcion":"NIVEL DE BILIRRUBINA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1304117006,
    "descripcion":"SÍNDROME TIPO CRISPONI\/SUDORACIÓN INDUCIDA POR FRÍO ASOCIADO A GEN KLHL7"
  },
  {
    "codigo":124469008,
    "descripcion":"DEFICIENCIA DE N - ACETIL - BETA - GLUCOSAMINIDASA"
  },
  {
    "codigo":450314002,
    "descripcion":"ANILLO VASCULAR CON CAYADO AÓRTICO DERECHO Y CONDUCTO ARTERIOSO IZQUIERDO PERMEABLE"
  },
  {
    "codigo":1236746005,
    "descripcion":"MASA QUE OCUPA MITAD SUPERIOR DE ABDOMEN"
  },
  {
    "codigo":600455841000119103,
    "descripcion":"ENDOMETRIOSIS SUPERFICIAL DE OVARIO IZQUIERDO"
  },
  {
    "codigo":286474005,
    "descripcion":"NO REBANA ALIMENTOS"
  },
  {
    "codigo":253706007,
    "descripcion":"ORIGEN ANÓMALO DE LA ARTERIA CORONARIA DERECHA DESDE EL TRONCO DE LA ARTERIA PULMONAR"
  },
  {
    "codigo":146081000119104,
    "descripcion":"ENFERMEDAD PULMONAR DEBIDA A TRASTORNO DEL TEJIDO CONJUNTIVO"
  },
  {
    "codigo":88031005,
    "descripcion":"INTOXICACIÓN POR 4 - AMINOPIRIDINA"
  },
  {
    "codigo":1234911006,
    "descripcion":"MALFORMACIÓN COCLEOVESTIBULAR CONGÉNITA"
  },
  {
    "codigo":22495007,
    "descripcion":"PESO ANORMAL"
  },
  {
    "codigo":448479008,
    "descripcion":"CONDUCTO ARTERIOSO ORIGINADO EN ARTERIA BRAQUIOCEFÁLICA"
  },
  {
    "codigo":1169375009,
    "descripcion":"GLOBULINA FIJADORA DE TIROXINA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":282804002,
    "descripcion":"LESIÓN QUÍMICA DE NERVIO CRANEAL"
  },
  {
    "codigo":413876003,
    "descripcion":"FRACTURA NO EXPUESTA DE PIERNA"
  },
  {
    "codigo":446644006,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÉDULA ESPINAL A NIVEL DE D1 A D6"
  },
  {
    "codigo":315572006,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: GUJERATI"
  },
  {
    "codigo":250036006,
    "descripcion":"MARCHA EXTRAPIRAMIDAL"
  },
  {
    "codigo":280969001,
    "descripcion":"TRASTORNO DE DERIVACIÓN ARTERIOVENOSA"
  },
  {
    "codigo":12106401000119107,
    "descripcion":"QUEMADURA DE REGIÓN DE CODO DERECHO"
  },
  {
    "codigo":1264009006,
    "descripcion":"DEFICIENCIA AISLADA DE CITOCROMO C OXIDASA"
  },
  {
    "codigo":117129007,
    "descripcion":"CALIDAD DEL SOPLO CARDÍACO, CHIRRIANTE"
  },
  {
    "codigo":248201006,
    "descripcion":"FACIES DE DISTROFIA MIOTÓNICA"
  },
  {
    "codigo":10959521000119109,
    "descripcion":"HERIDA ABIERTA DE MUÑECA IZQUIERDA DEBIDA A MORDEDURA HUMANA"
  },
  {
    "codigo":16990005,
    "descripcion":"ESQUIZOFRENIA SUBCRÓNICA"
  },
  {
    "codigo":703283003,
    "descripcion":"LINFEDEMA DEBIDO A INSUFICIENCIA VENOSA"
  },
  {
    "codigo":1091051000119100,
    "descripcion":"INFLAMACIÓN CRÓNICA DE CAVIDAD MASTOIDEA DERECHA"
  },
  {
    "codigo":16064491000119101,
    "descripcion":"HAMARTOMA CONGÉNITO DE IRIS DE OJO DERECHO"
  },
  {
    "codigo":90091000119101,
    "descripcion":"EDENTULISMO PARCIAL CLASE I"
  },
  {
    "codigo":11817451000119103,
    "descripcion":"ESGUINCE DE LIGAMENTO DE DEDO DE MANO IZQUIERDA"
  },
  {
    "codigo":12214251000119102,
    "descripcion":"INFECCIÓN DE CLAVÍCULA IZQUIERDA ASOCIADA CON DISPOSITIVO DE FIJACIÓN INTERNA"
  },
  {
    "codigo":277299009,
    "descripcion":"RUPTURA DE MALFORMACIÓN ARTERIOVENOSA CEREBRAL"
  },
  {
    "codigo":80691007,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DEL PIE, CON INFECCIÓN"
  },
  {
    "codigo":31211000119101,
    "descripcion":"ANGIOPATÍA PERIFÉRICA DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":307691000119108,
    "descripcion":"DISPLASIA FIBROSA MONOSTÓTICA DE FÉMUR IZQUIERDO"
  },
  {
    "codigo":16438251000119100,
    "descripcion":"SÍNDROME DE DOLOR LOCALIZADO EN TROCÁNTER MAYOR IZQUIERDO"
  },
  {
    "codigo":300011000119109,
    "descripcion":"ARTRITIS ESTAFILOCÓCICA DE MANO"
  },
  {
    "codigo":12268011000119103,
    "descripcion":"SÍNDROME COMPARTIMENTAL TRAUMÁTICO DE EXTREMIDAD SUPERIOR IZQUIERDA"
  },
  {
    "codigo":408371008,
    "descripcion":"INSTRUCCIONES ADECUADAS Y APROPIADAS RELACIONADAS CON EL TRATAMIENTO FARMACOLÓGICO"
  },
  {
    "codigo":323051000119106,
    "descripcion":"LONGITUD DESIGUAL DE EXTREMIDADES INFERIORES DEBIDA A ACORTAMIENTO ADQUIRIDO DE PERONÉ IZQUIERDO"
  },
  {
    "codigo":154091000119106,
    "descripcion":"DECLINACIÓN DEL ESTADO FUNCIONAL"
  },
  {
    "codigo":1085931000119108,
    "descripcion":"OBSTRUCCIÓN INTESTINAL DEBIDA A ENFERMEDAD DE CROHN"
  },
  {
    "codigo":330731000119109,
    "descripcion":"SÍNDROME DE COMPRESIÓN DE NERVIO FRÉNICO"
  },
  {
    "codigo":308232009,
    "descripcion":"LARINGOTRAQUEOMALACIA"
  },
  {
    "codigo":44253006,
    "descripcion":"MIOPATÍA NUTRICIONAL"
  },
  {
    "codigo":109789004,
    "descripcion":"TATUAJE DE AMALGAMA"
  },
  {
    "codigo":240861001,
    "descripcion":"ASCARIASIS LARVARIA"
  },
  {
    "codigo":77021007,
    "descripcion":"INFECCIÓN CAUSADA POR TAENIA TAENIAEFORMIS"
  },
  {
    "codigo":239026002,
    "descripcion":"SÍNDROME DE DIABETES INSÍPIDA - HIPOHIDROSIS"
  },
  {
    "codigo":402866002,
    "descripcion":"EDEMA PERIÓDICO"
  },
  {
    "codigo":271794005,
    "descripcion":"TRASTORNO DEL CICLO SUEÑO-VIGILIA"
  },
  {
    "codigo":9650008,
    "descripcion":"ESTRABISMO CONCOMITANTE"
  },
  {
    "codigo":763314009,
    "descripcion":"DISTROFIA MUSCULAR CONGÉNITA CON HIPERLAXITUD"
  },
  {
    "codigo":204423002,
    "descripcion":"ORIGEN ANÓMALO DEL CAYADO AÓRTICO"
  },
  {
    "codigo":1187463001,
    "descripcion":"TUMOR MICROQUÍSTICO DE ESTROMA OVÁRICO"
  },
  {
    "codigo":237191007,
    "descripcion":"PÓLIPO EN EL CUELLO DEL ÚTERO DURANTE EL EMBARAZO, PARTO Y PUERPERIO"
  },
  {
    "codigo":269959007,
    "descripcion":"EXTENDIDO CERVICAL - DISCARIOSIS LEVE"
  },
  {
    "codigo":300892001,
    "descripcion":"HALLAZGO RELACIONADO CON LA PÉRDIDA DE LÍQUIDO"
  },
  {
    "codigo":366428001,
    "descripcion":"AMPLITUD DEL MOVIMIENTO ACTIVO DE FLEXIÓN DE LA COLUMNA LUMBAR - HALLAZGO"
  },
  {
    "codigo":7815009,
    "descripcion":"HERNIA INGUINAL BILATERAL CON GANGRENA"
  },
  {
    "codigo":202588005,
    "descripcion":"OSTEOCONDROMATOSIS SINOVIAL DE TOBILLO"
  },
  {
    "codigo":1076181000119106,
    "descripcion":"BURSITIS DE RODILLA DERECHA"
  },
  {
    "codigo":167985001,
    "descripcion":"EXAMEN DEL ESPUTO: NORMAL"
  },
  {
    "codigo":397361006,
    "descripcion":"TAMAÑO DE PÓLIPO QUE NO PUEDE DETERMINARSE"
  },
  {
    "codigo":102449007,
    "descripcion":"DISCINESIA TARDÍA"
  },
  {
    "codigo":16041071000119102,
    "descripcion":"ARTRITIS IDIOPÁTICA JUVENIL DE INICIO SISTÉMICO DE RODILLA DERECHA"
  },
  {
    "codigo":725041008,
    "descripcion":"UTILIZA LOS BRAZOS PARA SALIR DE LA SILLA"
  },
  {
    "codigo":297222002,
    "descripcion":"ANOMALÍA VENOSA CONGÉNITA"
  },
  {
    "codigo":33243000,
    "descripcion":"CONTRACCIÓN DE VESÍCULA BILIAR AUMENTADA"
  },
  {
    "codigo":721371000,
    "descripcion":"SÍNDROME DEL CORDÓN CENTRAL DE MÉDULA ESPINAL CERVICAL"
  },
  {
    "codigo":197083003,
    "descripcion":"DIVERTICULOSIS DEL DUODENO"
  },
  {
    "codigo":262619005,
    "descripcion":"CUERPO EXTRAÑO EN EL TESTÍCULO"
  },
  {
    "codigo":66011008,
    "descripcion":"TRAQUEÍTIS VIRAL"
  },
  {
    "codigo":1145520001,
    "descripcion":"APLASIA DE HUESO METACARPIANO"
  },
  {
    "codigo":162480005,
    "descripcion":"SÍNTOMA QUE EMPEORA CON LA TOS"
  },
  {
    "codigo":293552005,
    "descripcion":"REACCIÓN ADVERSA AL MONONITRATO DE ISOSORBIDA"
  },
  {
    "codigo":193413001,
    "descripcion":"AMAUROSIS DE LEBER"
  },
  {
    "codigo":95109002,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LAS MENINGES ESPINALES"
  },
  {
    "codigo":226181003,
    "descripcion":"DIETA SIN COLORANTES PARA ALIMENTOS"
  },
  {
    "codigo":62341002,
    "descripcion":"ÚLCERA DUODENAL CRÓNICA CON HEMORRAGIA PERO SIN OBSTRUCCIÓN"
  },
  {
    "codigo":1340293005,
    "descripcion":"CONTUSIÓN DE CÓNDILO EXTERNO DE TIBIA"
  },
  {
    "codigo":160645007,
    "descripcion":"DISFRUTA EL EJERCICIO FÍSICO DE INTENSIDAD INTERMEDIA"
  },
  {
    "codigo":93274000,
    "descripcion":"HIPOPLASIA CONGÉNITA DE HUESO NASAL"
  },
  {
    "codigo":717701008,
    "descripcion":"ÚTERO BICORNE BICERVICAL CON HEMIVAGINA CIEGA"
  },
  {
    "codigo":289882000,
    "descripcion":"PERINEO FEMENINO ERITEMATOSO"
  },
  {
    "codigo":60506006,
    "descripcion":"AMPOLLA DEL CUERO CABELLUDO, CON INFECCIÓN"
  },
  {
    "codigo":224346008,
    "descripcion":"PODER NOTARIAL CONCEDIDO"
  },
  {
    "codigo":715866009,
    "descripcion":"POLIPOSIS ADENOMATOSA FAMILIAR ATENUADA"
  },
  {
    "codigo":1141850009,
    "descripcion":"NIVEL DE HIPEREOSINOFILIA QUE INDICA NEOPLASIA MALIGNA"
  },
  {
    "codigo":89604000,
    "descripcion":"AMPOLLA DE PENE SIN INFECCIÓN"
  },
  {
    "codigo":367881000119105,
    "descripcion":"ESTRECHEZ POSINFECCIOSA DE MEATO DE URETRA MASCULINA"
  },
  {
    "codigo":286212004,
    "descripcion":"CAPAZ DE EMPLEAR APOYO RESPIRATORIO AL HABLAR"
  },
  {
    "codigo":253444004,
    "descripcion":"ANOMALÍA DE CUERDAS TENDINOSAS DE VÁLVULA AURICULOVENTRICULAR COMÚN"
  },
  {
    "codigo":417284009,
    "descripcion":"ACTUAL CONSUMIDOR DE DROGAS"
  },
  {
    "codigo":341411000119101,
    "descripcion":"DEPÓSITO EN CONJUNTIVA DE OJO IZQUIERDO"
  },
  {
    "codigo":251609004,
    "descripcion":"AUMENTO DE LA LATENCIA DEL POTENCIAL EVOCADO AUDITIVO DEL TRONCO ENCEFÁLICO, ONDA I"
  },
  {
    "codigo":22233004,
    "descripcion":"QUEMADURA DE LA NARIZ"
  },
  {
    "codigo":448217003,
    "descripcion":"LINFOMA NO HODGKIN FOLICULAR DE PRÓSTATA"
  },
  {
    "codigo":282542002,
    "descripcion":"INCAPAZ DE PARAR DE CORRER"
  },
  {
    "codigo":184238003,
    "descripcion":"DUPLICADO DE TARJETA DE REPETICIÓN DE LA PRESCRIPCIÓN EMITIDO"
  },
  {
    "codigo":1003438004,
    "descripcion":"HIPOPLASIA DE CÉLULAS DE LEYDIG DEBIDA A INACTIVACIÓN PARCIAL DEL RECEPTOR DE HORMONA LUTEINIZANTE"
  },
  {
    "codigo":116867003,
    "descripcion":"DISPOSICIÓN DE UNIDAD DE HEMODERIVADO TRANSFUNDIDA"
  },
  {
    "codigo":444547006,
    "descripcion":"MANIFESTACIÓN CUTÁNEA DE ENFERMEDAD DE INJERTO VERSUS HUÉSPED"
  },
  {
    "codigo":247939009,
    "descripcion":"FRICCIÓN REPETITIVA DE LAS PARTES DEL CUERPO"
  },
  {
    "codigo":49496001,
    "descripcion":"URÉTER DOBLE"
  },
  {
    "codigo":442712004,
    "descripcion":"ASPECTO COSMÉTICO DE CICATRIZ QUIRÚRGICA INSATISFACTORIO"
  },
  {
    "codigo":1260077002,
    "descripcion":"CARCINOMA SÓLIDO DE PULMÓN"
  },
  {
    "codigo":735789004,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE PARTE DEL ABDOMEN"
  },
  {
    "codigo":703021005,
    "descripcion":"PROTEUS VULGARIS O PROTEUS PENNERI"
  },
  {
    "codigo":14893008,
    "descripcion":"QUEMADURA DE MANO"
  },
  {
    "codigo":111362001,
    "descripcion":"FORUNCULOSIS ANAL"
  },
  {
    "codigo":211501009,
    "descripcion":"CONTUSIÓN DE REGIÓN CLAVICULAR"
  },
  {
    "codigo":733954006,
    "descripcion":"CARIES DENTAL INACTIVA SECUNDARIA QUE SE EXTIENDE HASTA LA MITAD EXTERNA DEL ESMALTE"
  },
  {
    "codigo":766722008,
    "descripcion":"VARIANTE PARAPARÉTICA DEL SÍNDROME DE GUILLAIN-BARRÉ"
  },
  {
    "codigo":109527002,
    "descripcion":"HIPOPLASIA ALVEOLAR CONGÉNITA DEL MAXILAR"
  },
  {
    "codigo":1354711006,
    "descripcion":"FRACTURA DE PRIMERA COSTILLA"
  },
  {
    "codigo":304300000,
    "descripcion":"AMPLITUD DE MOVIMIENTO DE CODO AUMENTADA"
  },
  {
    "codigo":238764001,
    "descripcion":"TELANGIECTASIA BENIGNA HEREDITARIA"
  },
  {
    "codigo":11223009,
    "descripcion":"ANOMALÍA CONGÉNITA DE LA FARINGE"
  },
  {
    "codigo":402604004,
    "descripcion":"TRASTORNO DE LA COLORACIÓN DE LA PIEL"
  },
  {
    "codigo":16125501000119106,
    "descripcion":"DERRAME INTERMITENTE DE ARTICULACIÓN DE AMBAS CADERAS"
  },
  {
    "codigo":16754391000119100,
    "descripcion":"ANGINA ESTABLE DEBIDA A ARTERIOESCLEROSIS CORONARIA"
  },
  {
    "codigo":271532008,
    "descripcion":"ENFERMEDAD POR ECHOVIRUS"
  },
  {
    "codigo":11839191000119101,
    "descripcion":"DISTENSIÓN DE MÚSCULO INTRÍNSECO DE DEDO MEÑIQUE DE MANO DERECHA"
  },
  {
    "codigo":16289341000119108,
    "descripcion":"DISECCIÓN DE ARTERIA SUBCLAVIA DERECHA"
  },
  {
    "codigo":1252737007,
    "descripcion":"NÓDULO DE PIEL DE DEDO DE PIE IZQUIERDO"
  },
  {
    "codigo":235094002,
    "descripcion":"APERTURA LATERAL - DERECHA"
  },
  {
    "codigo":202326005,
    "descripcion":"PROTRUSIÓN DE ACETÁBULOS DE REGIÓN PÉLVICA Y MUSLO"
  },
  {
    "codigo":724779000,
    "descripcion":"TRASTORNO DE LA SUSTANCIA BLANCA CONCOMITANTE Y DEBIDO A ARTERIOPATÍA CEREBRAL AUTOSÓMICA DOMINANTE CON INFARTOS SUBCORTICALES Y LEUCOENCEFALOPATÍA"
  },
  {
    "codigo":366166009,
    "descripcion":"VOLTAJE DEL ELECTROCARDIOGRAMA - HALLAZGO"
  },
  {
    "codigo":1281835000,
    "descripcion":"CRISIS EPILÉPTICA AUTONÓMICA DE INICIO FOCAL"
  },
  {
    "codigo":726614009,
    "descripcion":"DISTROFIA MUSCULAR DE LAS CINTURAS DE LAS EXTREMIDADES TIPO 2P AUTOSÓMICA RECESIVA"
  },
  {
    "codigo":298795005,
    "descripcion":"SIN AMPLITUD PASIVA DE EXTENSIÓN DE HOMBRO"
  },
  {
    "codigo":397099007,
    "descripcion":"MARGEN QUIRÚRGICO DE CONDUCTO CÍSTICO NO COMPROMETIDO POR CARCINOMA IN SITU"
  },
  {
    "codigo":198656000,
    "descripcion":"ABORTO ESPONTÁNEO COMPLETO CON HEMORRAGIA TARDÍA O EXCESIVA"
  },
  {
    "codigo":788480001,
    "descripcion":"TRASTORNO REPETITIVO DEL MOVIMIENTO DE PIE IZQUIERDO"
  },
  {
    "codigo":1148928001,
    "descripcion":"HIPOCALCEMIA DEBIDA A ENFERMEDAD RENAL CRÓNICA"
  },
  {
    "codigo":16017111000119106,
    "descripcion":"ALTERACIÓN DE ASTA POSTERIOR DE MENISCO INTERNO DE AMBAS RODILLAS"
  },
  {
    "codigo":722944006,
    "descripcion":"HIPOGONADISMO HIPOGONADOTRÓFICO CONGÉNITO"
  },
  {
    "codigo":295125005,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE PARACETAMOL"
  },
  {
    "codigo":162218007,
    "descripcion":"PROBLEMA RELACIONADO CON EL ESTRÉS"
  },
  {
    "codigo":225919000,
    "descripcion":"CONTENIDO DE LA CONVERSACIÓN APROPIADO"
  },
  {
    "codigo":31146009,
    "descripcion":"REQUERIMIENTO HORMONAL NORMAL"
  },
  {
    "codigo":94847003,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL LÓBULO FRONTAL"
  },
  {
    "codigo":291455004,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR MEFLOQUINA"
  },
  {
    "codigo":422527005,
    "descripcion":"ESPASMOS INFANTILES REFRACTARIOS"
  },
  {
    "codigo":1081201000119105,
    "descripcion":"NEOPLASIA GERMINAL NO SEMINOMATOSA PRIMARIA DE TESTÍCULO DERECHO NO DESCENDIDO"
  },
  {
    "codigo":93012004,
    "descripcion":"ANOMALÍA CONGÉNITA DEL CORNETE NASAL"
  },
  {
    "codigo":846676008,
    "descripcion":"TEMPERATURA CORPORAL POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1010516009,
    "descripcion":"ESCLEROSIS DE EPÍFISIS DE FALANGE DE DEDO DE PIE CON RADIOPACIDAD AUMENTADA"
  },
  {
    "codigo":289620008,
    "descripcion":"ÚTERO NORMAL"
  },
  {
    "codigo":255017003,
    "descripcion":"ADENOCARCINOMA DE EPITELIO NO PIGMENTADO DE CUERPO CILIAR"
  },
  {
    "codigo":58409000,
    "descripcion":"ESOTROPÍA MONOCULAR CON PATRÓN A"
  },
  {
    "codigo":123945007,
    "descripcion":"INTOXICACIÓN POR SANTALACEAE"
  },
  {
    "codigo":56574000,
    "descripcion":"POLIURIA"
  },
  {
    "codigo":15744881000119108,
    "descripcion":"RIGIDEZ DE ARTICULACIÓN DE AMBAS REGIONES DE PIES"
  },
  {
    "codigo":417022003,
    "descripcion":"ESTRABISMO POR ENFERMEDAD OCULAR TIROIDEA"
  },
  {
    "codigo":253182004,
    "descripcion":"DISPLASIA DENTADA"
  },
  {
    "codigo":23806004,
    "descripcion":"INFECCIÓN CRÓNICA COMO COMPLICACIÓN DE UNA AMPUTACIÓN"
  },
  {
    "codigo":449790007,
    "descripcion":"FISURA OROFACIAL"
  },
  {
    "codigo":54739001,
    "descripcion":"CRISODERMIA"
  },
  {
    "codigo":285950009,
    "descripcion":"NO INSERTA Y REMUEVE EL TAPÓN DE LA PILETA"
  },
  {
    "codigo":185811005,
    "descripcion":"CONTROL DE SALUD DE LA MUJER REALIZADO"
  },
  {
    "codigo":87507007,
    "descripcion":"FRUSTRACIÓN SEXUAL"
  },
  {
    "codigo":249512003,
    "descripcion":"DESEO DE DEFECAR"
  },
  {
    "codigo":85672005,
    "descripcion":"ENFERMEDAD DE LAS CÉLULAS DEL ASTA ANTERIOR DE LA MÉDULA ESPINAL"
  },
  {
    "codigo":315048006,
    "descripcion":"HEMATOMA EXTRADURAL TRAUMÁTICO SIN HERIDA INTRACRANEAL ABIERTA"
  },
  {
    "codigo":20136007,
    "descripcion":"HUESOS ACCESORIOS DEL CARPO"
  },
  {
    "codigo":52904006,
    "descripcion":"ANOMALÍA CONGÉNITA DE LA VAGINA"
  },
  {
    "codigo":247677000,
    "descripcion":"DELIRIO EXTRAÑO ASOCIADO CON UNA SENSACIÓN CORPORAL"
  },
  {
    "codigo":1263485003,
    "descripcion":"ENFERMEDAD QUÍSTICA ADQUIRIDA DE RIÑÓN TRASPLANTADO"
  },
  {
    "codigo":278610000,
    "descripcion":"PRÓTESIS MAXILOFACIAL PERDIDA"
  },
  {
    "codigo":870269009,
    "descripcion":"TRASTORNO GENERALIZADO DEL DESARROLLO CON TRASTORNO DEL DESARROLLO INTELECTUAL Y AUSENCIA DE LENGUAJE FUNCIONAL CON PÉRDIDA DE HABILIDADES ADQUIRIDAS PREVIAMENTE"
  },
  {
    "codigo":737362007,
    "descripcion":"REQUIERE SUPERVISIÓN CONTINUA PARA ACTIVIDADES DE LA VIDA DIARIA"
  },
  {
    "codigo":473383000,
    "descripcion":"ANOMALÍA DEL CORAZÓN FETAL"
  },
  {
    "codigo":735527002,
    "descripcion":"ESTADIO CLÍNICO 4 DE INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA DE LA ORGANIZACIÓN MUNDIAL DE LA SALUD DE 2007 CONCOMITANTE CON TUBERCULOSIS"
  },
  {
    "codigo":1259815006,
    "descripcion":"GLIOBLASTOMA DE CÉLULAS GIGANTES PRIMARIO DE CEREBRO"
  },
  {
    "codigo":897532001,
    "descripcion":"AUSENCIA CONGÉNITA BILATERAL DE TIBIA"
  },
  {
    "codigo":45564002,
    "descripcion":"ACALASIA DEL ESÓFAGO"
  },
  {
    "codigo":1290748003,
    "descripcion":"ARTRITIS REACTIVA DE ARTICULACIÓN DE CADERA DEBIDA A DISENTERÍA Y POSTERIOR A ELLA"
  },
  {
    "codigo":1083711000119100,
    "descripcion":"CONDRITIS DE AMBOS OÍDOS EXTERNOS"
  },
  {
    "codigo":209404007,
    "descripcion":"FRACTURA-SUBLUXACIÓN EXPUESTA DEL ESTERNÓN"
  },
  {
    "codigo":406012009,
    "descripcion":"MORFOLOGÍA DE PÓLIPO, INDETERMINADA"
  },
  {
    "codigo":305873001,
    "descripcion":"VISTO POR EL SERVICIO DE OBSTETRICIA Y GINECOLOGÍA"
  },
  {
    "codigo":15937701000119107,
    "descripcion":"NEVO EPIDÉRMICO PILOSO PIGMENTADO BILATERAL DE OREJAS"
  },
  {
    "codigo":240337004,
    "descripcion":"INTOXICACIÓN ALIMENTARIA POR ESCHERICHIA COLI VEROTOXIGÉNICA"
  },
  {
    "codigo":371409005,
    "descripcion":"TRASTORNO DE LA REGIÓN OCULAR"
  },
  {
    "codigo":10961005,
    "descripcion":"FÍSTULA DEL CUELLO UTERINO"
  },
  {
    "codigo":404177007,
    "descripcion":"ANGIOEDEMA Y\/O URTICARIA"
  },
  {
    "codigo":346431000119101,
    "descripcion":"DEPÓSITOS CRISTALINOS BILATERALES EN HUMOR VÍTREO"
  },
  {
    "codigo":402342001,
    "descripcion":"ACANTOSIS NIGRICANS DE LA MEMBRANA MUCOSA ORAL"
  },
  {
    "codigo":764625002,
    "descripcion":"SÍNDROME DE TRISOMÍA 22 MOSAICO"
  },
  {
    "codigo":1156006003,
    "descripcion":"VALPROATO DE SODIO SÉRICO POR ENCIMA DEL RANGO TERAPÉUTICO"
  },
  {
    "codigo":9126005,
    "descripcion":"OLIGOMETRORRAGIA"
  },
  {
    "codigo":171131006,
    "descripcion":"MENINGOCELE"
  },
  {
    "codigo":236667007,
    "descripcion":"INCONTINENCIA URINARIA PSICÓGENA"
  },
  {
    "codigo":7291006,
    "descripcion":"TRASTORNO REACTIVO DE LA VINCULACIÓN EN LA LACTANCIA"
  },
  {
    "codigo":365904001,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA RECORDAR HABILIDADES MOTRICES PREVIAS"
  },
  {
    "codigo":726352003,
    "descripcion":"TRISOMÍA PARCIAL DE CROMOSOMA 13"
  },
  {
    "codigo":18751000119106,
    "descripcion":"MONOPLEJÍA DE PIERNA DE LADO DOMINANTE COMO SECUELA DE ENFERMEDAD CEREBROVASCULAR"
  },
  {
    "codigo":70992005,
    "descripcion":"SINEQUIAS ANTERIORES DEL IRIS"
  },
  {
    "codigo":36389000,
    "descripcion":"RASGO DE PERSONALIDAD PASIVA - DEPENDIENTE"
  },
  {
    "codigo":298533002,
    "descripcion":"AMPLITUD DE FLEXIÓN LATERAL ACTIVA HACIA LA DERECHA DE LA COLUMNA VERTEBRAL DORSAL, DISMINUIDA"
  },
  {
    "codigo":724517005,
    "descripcion":"GASTRITIS SUPERFICIAL AGUDA"
  },
  {
    "codigo":69157007,
    "descripcion":"LATIDO PRECORDIAL NORMAL"
  },
  {
    "codigo":263930000,
    "descripcion":"ACUOSO"
  },
  {
    "codigo":1148666001,
    "descripcion":"AUSENCIA DE RESPUESTA DE ELECTRORRETINOGRAMA"
  },
  {
    "codigo":427770001,
    "descripcion":"ARTRITIS REUMATOIDE DE LA ARTICULACIÓN TEMPOROMANDIBULAR"
  },
  {
    "codigo":34554001,
    "descripcion":"QUEMADURA EPIDÉRMICA DE AXILA"
  },
  {
    "codigo":165626000,
    "descripcion":"NIVEL DE FERRITINA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":395002005,
    "descripcion":"HERIDAS ABIERTAS MÚLTIPLES DE MUÑECA Y MANO"
  },
  {
    "codigo":296698006,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE CEFACLOR"
  },
  {
    "codigo":722682001,
    "descripcion":"CARCINOMA NEUROENDOCRINO MICROCÍTICO PRIMARIO DE ENDOMETRIO"
  },
  {
    "codigo":460538002,
    "descripcion":"ORIGEN ANÓMALO DE ARTERIA CORONARIA IZQUIERDA EN ARTERIA CORONARIA DERECHA"
  },
  {
    "codigo":67322009,
    "descripcion":"OSTEOMIELITIS SUBAGUDA"
  },
  {
    "codigo":12198361000119104,
    "descripcion":"DOLOR ASOCIADO A IMPLANTE DE MAMA IZQUIERDA"
  },
  {
    "codigo":424100000,
    "descripcion":"CAPACIDAD LIMITADA PARA EL PENSAMIENTO ABSTRACTO"
  },
  {
    "codigo":131023009,
    "descripcion":"NIVEL DE HORMONA LUTEINIZANTE HIPOFISARIA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":260260002,
    "descripcion":"N18"
  },
  {
    "codigo":30884007,
    "descripcion":"MIOCARDIOPATÍA RESTRICTIVA SECUNDARIA A TESAURISMOSIS FAMILIAR"
  },
  {
    "codigo":293028007,
    "descripcion":"REACCIÓN ADVERSA AL NITROIMIDAZOL"
  },
  {
    "codigo":719012009,
    "descripcion":"DISCAPACIDAD INTELECTUAL LIGADA AL CROMOSOMA X TIPO MILES CARPENTER"
  },
  {
    "codigo":225657003,
    "descripcion":"HUMOR LÁBIL"
  },
  {
    "codigo":94585007,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE PARTES BLANDAS DE LA CARA"
  },
  {
    "codigo":127353009,
    "descripcion":"ALBÚMINA DE ESTRUCTURA ANORMAL"
  },
  {
    "codigo":289358002,
    "descripcion":"SITUACIÓN OBLICUA PODÁLICA EN FOSA ILÍACA IZQUIERDA"
  },
  {
    "codigo":27214003,
    "descripcion":"HEMORRAGIA POSTPARTO ATÓNICA"
  },
  {
    "codigo":715342005,
    "descripcion":"SÍNDROME DE TALASEMIA ALFA CON DISCAPACIDAD INTELECTUAL LIGADA AL CROMOSOMA X"
  },
  {
    "codigo":119751000146104,
    "descripcion":"FIEBRE CAUSADA POR SARS-COV-2"
  },
  {
    "codigo":92750008,
    "descripcion":"CARCINOMA IN SITU DEL INTESTINO DELGADO"
  },
  {
    "codigo":713507008,
    "descripcion":"LINFADENOPATÍA CONCOMITANTE CON INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":23544000,
    "descripcion":"ESTENOSIS CONGÉNITA DE LA VAGINA"
  },
  {
    "codigo":285688008,
    "descripcion":"DIFICULTAD PARA CARGAR PESO EN LA PIERNA DERECHA"
  },
  {
    "codigo":293491000119107,
    "descripcion":"TROMBOSIS AGUDA PROFUNDA DE VENA ILÍACA IZQUIERDA"
  },
  {
    "codigo":1332429005,
    "descripcion":"HISTIOCITOSIS DE CÉLULAS DE LANGERHANS DISEMINADA DE GANGLIOS LINFÁTICOS DE TÓRAX"
  },
  {
    "codigo":21709007,
    "descripcion":"CICATRIZ COROIDEA"
  },
  {
    "codigo":118178000,
    "descripcion":"HALLAZGO RELACIONADO CON LA FUNCIÓN PLACENTARIA"
  },
  {
    "codigo":413090001,
    "descripcion":"ESTADO DE CARTA DE DERIVACIÓN"
  },
  {
    "codigo":283853008,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO EN LA REGIÓN OCULAR"
  },
  {
    "codigo":314786000,
    "descripcion":"EXOTROPÍA CONGÉNITA"
  },
  {
    "codigo":1363362004,
    "descripcion":"HIPERINSULINISMO DIFUSO RESISTENTE A DIAZÓXIDO"
  },
  {
    "codigo":183714005,
    "descripcion":"CONSULTA DOMICILIARIA DE NEUROLOGÍA SOLICITADA"
  },
  {
    "codigo":249250005,
    "descripcion":"HALLAZGO RELACIONADO CON GLANDE DE PENE"
  },
  {
    "codigo":871842007,
    "descripcion":"HEMORRAGIA INTRACRANEANA DEBIDA A LEPTOSPIROSIS"
  },
  {
    "codigo":312951006,
    "descripcion":"SÍNDROME DE MÚLTIPLES PUNTOS BLANCOS EVANESCENTES"
  },
  {
    "codigo":247415009,
    "descripcion":"LACTANCIA DOLOROSA"
  },
  {
    "codigo":1197687009,
    "descripcion":"VÁRICES DE COLÉDOCO"
  },
  {
    "codigo":1163084005,
    "descripcion":"DACRIOADENITIS CAUSADA POR BORRELIA BURGDORFERI"
  },
  {
    "codigo":704332009,
    "descripcion":"FRACTURA OSTEOPORÓTICA DE PIE"
  },
  {
    "codigo":276513001,
    "descripcion":"DISRITMIA NEONATAL"
  },
  {
    "codigo":473121006,
    "descripcion":"AFLOJAMIENTO DE DISPOSITIVO DE FIJACIÓN INTERNO"
  },
  {
    "codigo":1259553007,
    "descripcion":"CARCINOMA ESCAMOSO ACANTOLÍTICO PRIMARIO"
  },
  {
    "codigo":322471000119102,
    "descripcion":"ESCOLIOSIS TORACÓGENA DORSAL"
  },
  {
    "codigo":241910002,
    "descripcion":"EFECTO TÓXICO CAUSADO POR LUSTRE PARA CALZADO"
  },
  {
    "codigo":471286002,
    "descripcion":"ORIGEN ANÓMALO DE ARTERIA CORONARIA EN SENO AÓRTICO A LA DERECHA DE SENO AÓRTICO NO ENFRENTADO"
  },
  {
    "codigo":12534005,
    "descripcion":"RECUPERACIÓN DE BACTERIAS PATÓGENAS NO IDENTIFICADAS"
  },
  {
    "codigo":209142007,
    "descripcion":"SUBLUXACIÓN NO EXPUESTA ENTRE LA SEXTA Y SÉPTIMA VÉRTEBRAS CERVICALES"
  },
  {
    "codigo":372982008,
    "descripcion":"INFECCIÓN CAUSADA POR NEOSARTORYA FISCHERI"
  },
  {
    "codigo":1255883001,
    "descripcion":"SARCOMA DE HODGKIN DE GANGLIOS LINFÁTICOS DE MIEMBRO INFERIOR"
  },
  {
    "codigo":10699001,
    "descripcion":"ÚLCERA ESOFAGOGÁSTRICA"
  },
  {
    "codigo":403915004,
    "descripcion":"CARCINOMA BASOCELULAR DE CUERO CABELLUDO"
  },
  {
    "codigo":240075007,
    "descripcion":"DISTROFIA MUSCULAR AUTOSÓMICA DOMINANTE SIN PREDOMINIO EN LA CINTURA DE EXTREMIDAD"
  },
  {
    "codigo":305611008,
    "descripcion":"BAJO ATENCIÓN DE ESPECIALISTA EN ORTESIS"
  },
  {
    "codigo":860832001,
    "descripcion":"CONDROSARCOMA MIXOIDE EXTRAESQUELÉTICO DE PARTES BLANDAS DE EXTREMIDAD"
  },
  {
    "codigo":762528007,
    "descripcion":"SEPSIS CAUSADA POR KLEBSIELLA PNEUMONIAE"
  },
  {
    "codigo":74400008,
    "descripcion":"APENDICITIS"
  },
  {
    "codigo":301941003,
    "descripcion":"PUPILAS DE TAMAÑO NORMAL"
  },
  {
    "codigo":72565004,
    "descripcion":"FLEBITIS DE LAS VENAS SUPERFICIALES DE LA EXTREMIDAD INFERIOR"
  },
  {
    "codigo":170869005,
    "descripcion":"EFECTOS COLATERALES DE FÁRMACO DE EMPLEO GINECOLÓGICO"
  },
  {
    "codigo":39797006,
    "descripcion":"OSTEÍTIS DEL BRAZO"
  },
  {
    "codigo":236405006,
    "descripcion":"GLOMERULOSCLEROSIS SEGMENTARIA FOCAL CON HIPERFILTRACIÓN"
  },
  {
    "codigo":234570002,
    "descripcion":"INMUNODEFICIENCIA COMBINADA GRAVE CON INJERTO MATERNOFETAL"
  },
  {
    "codigo":365642005,
    "descripcion":"HALLAZGO RELACIONADO CON EL TIPO DE GRUPO SANGUÍNEO"
  },
  {
    "codigo":1119306006,
    "descripcion":"SÍNDROME INFLAMATORIO MULTISISTÉMICO EN ADULTOS"
  },
  {
    "codigo":70730006,
    "descripcion":"ERITROPOYESIS INEFICAZ"
  },
  {
    "codigo":167199001,
    "descripcion":"PRUEBA DE FUNCIÓN DIGESTIVA, ANORMAL"
  },
  {
    "codigo":132161000119105,
    "descripcion":"TROMBOSIS VENOSA PROFUNDA CRÓNICA DE VENA TIBIAL"
  },
  {
    "codigo":36127009,
    "descripcion":"FRACTURA DEL PUBIS"
  },
  {
    "codigo":128926000,
    "descripcion":"HALLAZGO POSPROCEDIMIENTO"
  },
  {
    "codigo":718750004,
    "descripcion":"TRASTORNO CONGÉNITO DE LA GLICOSILACIÓN POR ALTERACIÓN DE COG1"
  },
  {
    "codigo":391070005,
    "descripcion":"RESULTADO DE ABSORCIOMETRÍA DUAL POR RAYOS X DE HUESO DE REGIÓN DE ARTICULACIÓN DE CADERA, OSTEOPOROSIS"
  },
  {
    "codigo":423838005,
    "descripcion":"HERIDA DE QUEMADURA QUIRÚRGICA DE LA ESCLERÓTICA"
  },
  {
    "codigo":292766008,
    "descripcion":"REACCIÓN ADVERSA AL DIMETIL-ÉTER PROPANO"
  },
  {
    "codigo":127091000,
    "descripcion":"LINFADENOPATÍA RETROFARÍNGEA"
  },
  {
    "codigo":422003001,
    "descripcion":"CAQUEXIA ASOCIADA CON SIDA"
  },
  {
    "codigo":94323001,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA MANO"
  },
  {
    "codigo":290931009,
    "descripcion":"INTOXICACIÓN POR BECLAMIDA"
  },
  {
    "codigo":715080001,
    "descripcion":"CAPAZ DE PASAR DE UNA SILLA AL INODORO"
  },
  {
    "codigo":679131000119106,
    "descripcion":"DELLEN DE CÓRNEA DERECHA"
  },
  {
    "codigo":92488006,
    "descripcion":"NEOPLASIA BENIGNA DE HUESO CIGOMÁTICO"
  },
  {
    "codigo":289096007,
    "descripcion":"CAPAZ DE RESPIRAR PROFUNDAMENTE"
  },
  {
    "codigo":59720008,
    "descripcion":"HIPERTENSIÓN ARTERIAL DIASTÓLICA CONTINUA"
  },
  {
    "codigo":11820251000119107,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN MEDIOCARPIANA IZQUIERDA"
  },
  {
    "codigo":90653005,
    "descripcion":"HIPOVITAMINOSIS A CON ULCERACIÓN Y XEROSIS CORNEAL"
  },
  {
    "codigo":713245008,
    "descripcion":"GINGIVITIS INDUCIDA POR PLACA DENTAL"
  },
  {
    "codigo":285426000,
    "descripcion":"GAMMAPATÍA MONOCLONAL POR IGM DE SIGNIFICACIÓN INCIERTA"
  },
  {
    "codigo":418333009,
    "descripcion":"HALO LÍMBICO DE VOGT, TIPO II"
  },
  {
    "codigo":1268466004,
    "descripcion":"PÉRDIDA DE AUDICIÓN NEUROSENSORIAL DE BAJA FRECUENCIA"
  },
  {
    "codigo":15971701000119103,
    "descripcion":"HERNIA INGUINAL DERECHA DIRECTA"
  },
  {
    "codigo":711410007,
    "descripcion":"SIGNOS DE RETORNO DE CIRCULACIÓN ESPONTÁNEA"
  },
  {
    "codigo":414663001,
    "descripcion":"MELENA POR HEMORRAGIA GASTROINTESTINAL"
  },
  {
    "codigo":1332167001,
    "descripcion":"ÚLCERA POR ESTASIS DE REGIÓN MEDIA DE PIE"
  },
  {
    "codigo":283591002,
    "descripcion":"HERIDA DE PERDIGÓN EN HALLUX"
  },
  {
    "codigo":86983005,
    "descripcion":"ÚLCERA DUODENAL CON PERFORACIÓN PERO SIN OBSTRUCCIÓN"
  },
  {
    "codigo":871580000,
    "descripcion":"MALFORMACIÓN ARTERIOVENOSA DE VASOS PULMONARES DESPUÉS DE ANASTOMOSIS CAVOPULMONAR"
  },
  {
    "codigo":185287009,
    "descripcion":"ATENDIDO POR UN TERAPEUTA OCUPACIONAL"
  },
  {
    "codigo":1363100004,
    "descripcion":"ASTILLA EN ESCROTO Y TESTÍCULO CON INFECCIÓN"
  },
  {
    "codigo":773276004,
    "descripcion":"SÍNDROME DE EHLERS-DANLOS TIPO DISPLÁSICO ESPONDILOQUEIRAL"
  },
  {
    "codigo":279921000,
    "descripcion":"APÉNDICE VESICULAR DE OVARIO"
  },
  {
    "codigo":609436009,
    "descripcion":"DAÑO FETAL POR TOXOPLASMOSIS MATERNA"
  },
  {
    "codigo":11793781000119107,
    "descripcion":"AMPOLLA TRAUMÁTICA DE PIE DERECHO"
  },
  {
    "codigo":216220009,
    "descripcion":"LESIÓN POR PROPULSOR A HÉLICE DE AERONAVE, SIN ACCIDENTE DE AERONAVE, PERSONAL DE TIERRA O EMPLEADO DE LÍNEA AÉREA LESIONADO"
  },
  {
    "codigo":771441005,
    "descripcion":"HIPERBILIVERDINEMIA"
  },
  {
    "codigo":247153005,
    "descripcion":"DRUSAS RETINIANAS"
  },
  {
    "codigo":278086000,
    "descripcion":"TAQUICARDIA BASAL"
  },
  {
    "codigo":736838001,
    "descripcion":"EXCAVACIÓN DE PAPILA ÓPTICA DEBIDA A GLAUCOMA DE ÁNGULO ABIERTO"
  },
  {
    "codigo":16027151000119102,
    "descripcion":"QUISTE ÓSEO BILATERAL DE FÉMUR"
  },
  {
    "codigo":704070001,
    "descripcion":"FRACTURA POR ESTRÉS DE TOBILLO"
  },
  {
    "codigo":1162822000,
    "descripcion":"SOBREDOSIS INTENCIONAL DE VITAMINA K Y\/O DERIVADO DE VITAMINA K"
  },
  {
    "codigo":866075002,
    "descripcion":"INFECCIÓN DE BOLSA SEROSA CAUSADA POR PARÁSITO"
  },
  {
    "codigo":79643007,
    "descripcion":"POSICIÓN SACROILÍACA DERECHA ANTERIOR"
  },
  {
    "codigo":440091008,
    "descripcion":"HALLAZGO RELACIONADO CON LA DONACIÓN DE SANGRE, ÓRGANOS O TEJIDOS"
  },
  {
    "codigo":208880001,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA PROXIMAL"
  },
  {
    "codigo":897008002,
    "descripcion":"FORMA DE BALA ANORMAL CONGÉNITA DE FALANGE DISTAL DE DEDO PULGAR"
  },
  {
    "codigo":733168003,
    "descripcion":"ASPERGILOSIS INVASIVA DE CEREBRO"
  },
  {
    "codigo":700400001,
    "descripcion":"EXTENDIDO CERVICAL - CAMBIO LIMÍTROFE EN LAS CÉLULAS ENDOCERVICALES"
  },
  {
    "codigo":239813000,
    "descripcion":"DACTILITIS PSORIÁSICA"
  },
  {
    "codigo":1255621004,
    "descripcion":"ESTENOSIS DE SEGMENTO DISTAL DE TRONCO DE ARTERIA CORONARIA IZQUIERDA"
  },
  {
    "codigo":403653006,
    "descripcion":"ATROFIA CUTÁNEA CAUSADA POR CORTICOSTEROIDE TÓPICO"
  },
  {
    "codigo":272581007,
    "descripcion":"POSICIÓN PENDIENTE"
  },
  {
    "codigo":41370002,
    "descripcion":"MIELITIS"
  },
  {
    "codigo":237978005,
    "descripcion":"SÍNDROME DE INTOLERANCIA AL GLICEROL"
  },
  {
    "codigo":762266006,
    "descripcion":"SENSACIÓN DISMINUIDA DEBIDA A LAXITUD VAGINAL"
  },
  {
    "codigo":203375003,
    "descripcion":"DESPLAZAMIENTO DE EPÍFISIS FEMORAL NO TRAUMÁTICO CRÓNICO REAGUDIZADO"
  },
  {
    "codigo":301679006,
    "descripcion":"DIFICULTAD PARA LEVANTARSE DE UNA CAMA"
  },
  {
    "codigo":365380000,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA LLEVAR A CABO ACTIVIDADES RELIGIOSAS"
  },
  {
    "codigo":398148000,
    "descripcion":"NEUROPATÍA HEREDITARIA SENSITIVA Y AUTONÓMICA TIPO II"
  },
  {
    "codigo":267076002,
    "descripcion":"SE SIENTE SOLO"
  },
  {
    "codigo":4932002,
    "descripcion":"TRASTORNO DE PÁNICO CON AGORAFOBIA, EVITACIÓN AGORAFÓBICA MODERADA Y ATAQUES DE PÁNICO LEVES"
  },
  {
    "codigo":299844006,
    "descripcion":"REFLEJO MIOTÁTICO DE DEDO DE LA MANO REDUCIDO"
  },
  {
    "codigo":68633000,
    "descripcion":"TRASTORNO PUPILAR"
  },
  {
    "codigo":201540009,
    "descripcion":"ARTROPATÍA ASOCIADA CON MICOSIS, DE TOBILLO Y PIE"
  },
  {
    "codigo":3097002,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE LABIO, CON INFECCIÓN"
  },
  {
    "codigo":723993005,
    "descripcion":"SÍNDROME DE SORDERA NEUROSENSITIVA CON MIOCARDIOPATÍA DILATADA"
  },
  {
    "codigo":35865007,
    "descripcion":"VÓLVULO GÁSTRICO MESENTERIOAXIAL"
  },
  {
    "codigo":197870000,
    "descripcion":"VEJIGA ATÓNICA"
  },
  {
    "codigo":296174000,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE TETRABENAZINA"
  },
  {
    "codigo":230638003,
    "descripcion":"COMPRESIÓN DEL NERVIO CIÁTICO"
  },
  {
    "codigo":294339006,
    "descripcion":"ALERGIA A CARMELOSA"
  },
  {
    "codigo":196035006,
    "descripcion":"NEUMONITIS CAUSADA POR INHALACIÓN DE VÓMITO"
  },
  {
    "codigo":95896000,
    "descripcion":"INFECCIÓN POR PROTOZOARIOS"
  },
  {
    "codigo":718488001,
    "descripcion":"COMPLICACIÓN DEBIDA A PROCEDIMIENTO DE DIAGNÓSTICO POR IMÁGENES DE PACIENTE CON DISPOSITIVO MÉDICO IMPLANTADO"
  },
  {
    "codigo":1144472003,
    "descripcion":"DEMUESTRA CONOCIMIENTO SOBRE ABUSO DE ALCOHOL"
  },
  {
    "codigo":292504006,
    "descripcion":"REACCIÓN ADVERSA A FÁRMACOS ESTIMULANTES SELECTIVOS DE ADRENORRECEPTOR BETA-1"
  },
  {
    "codigo":61293001,
    "descripcion":"DEFORMIDAD CONGÉNITA DE LA ARTICULACIÓN DE LA RODILLA"
  },
  {
    "codigo":716653001,
    "descripcion":"CARCINOMA NEUROENDOCRINO DE TIMO"
  },
  {
    "codigo":126829002,
    "descripcion":"NEOPLASIA DE LA CURVATURA MAYOR DEL ESTÓMAGO"
  },
  {
    "codigo":290669001,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR IDARUBICINA"
  },
  {
    "codigo":94061009,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE PARTES BLANDAS DE HOMBRO"
  },
  {
    "codigo":92226005,
    "descripcion":"NEOPLASIA BENIGNA DE MÚSCULO DE LA CABEZA"
  },
  {
    "codigo":26690008,
    "descripcion":"EDAD GESTACIONAL, 8 SEMANAS"
  },
  {
    "codigo":714818009,
    "descripcion":"HEMATURIA PERSISTENTE CONCOMITANTE CON GLOMERULONEFRITIS PROLIFERATIVA ENDOCAPILAR DIFUSA Y DEBIDA A ELLA"
  },
  {
    "codigo":254231002,
    "descripcion":"PELO LANOSO CONGÉNITO"
  },
  {
    "codigo":285164005,
    "descripcion":"INCAPAZ DE RECONOCER OBJETOS VISUALMENTE"
  },
  {
    "codigo":23020007,
    "descripcion":"FRACTURA EXPUESTA DE SEGUNDO HUESO CUNEIFORME"
  },
  {
    "codigo":447169001,
    "descripcion":"FASCITIS CRANEAL"
  },
  {
    "codigo":416236009,
    "descripcion":"SÍNDROME DE ADHERENCIA GRASA DE MÚSCULO EXTRAOCULAR"
  },
  {
    "codigo":414401005,
    "descripcion":"HERNIA A TRAVÉS DEL AGUJERO CIÁTICO MENOR"
  },
  {
    "codigo":1299137005,
    "descripcion":"CLASIFICACIÓN DE MILLER PARA RECESIÓN GINGIVAL, CLASE IV"
  },
  {
    "codigo":281494000,
    "descripcion":"DEFORMIDAD VARA ADQUIRIDA DE ARTICULACIÓN DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":248726001,
    "descripcion":"CAPILARES FRÁGILES"
  },
  {
    "codigo":1231766002,
    "descripcion":"HEMORRAGIA DESPUÉS DE ADMINISTRACIÓN DE AGENTE TROMBOLÍTICO"
  },
  {
    "codigo":283329009,
    "descripcion":"PICADURA DE INSECTO EN LA GARGANTA"
  },
  {
    "codigo":19350004,
    "descripcion":"ATETOSIS CON RIGIDEZ"
  },
  {
    "codigo":707478007,
    "descripcion":"ESTENOSIS DE TRONCO PULMONAR COMO COMPLICACIÓN DE PROCEDIMIENTO"
  },
  {
    "codigo":445334007,
    "descripcion":"DEFECTO DEL TABIQUE AURICULOVENTRICULAR CON DEFECTO ADICIONAL DE LA PORCIÓN MUSCULAR DEL TABIQUE VENTRICULAR"
  },
  {
    "codigo":50283003,
    "descripcion":"ESTADIO CLÍNICO III"
  },
  {
    "codigo":246891004,
    "descripcion":"PANNUS DE LA CONJUNTIVA DEL LIMBO"
  },
  {
    "codigo":771179007,
    "descripcion":"SÍNDROME DE EXTRASÍSTOLES, BAJA ESTATURA, HIPERPIGMENTACIÓN Y MICROCEFALIA"
  },
  {
    "codigo":312427007,
    "descripcion":"INFECCIÓN TIROIDEA"
  },
  {
    "codigo":28791000119105,
    "descripcion":"NEUMONÍA COCCIDIOIDOMICÓTICA CRÓNICA"
  },
  {
    "codigo":212288002,
    "descripcion":"LESIÓN DEL NERVIO SUPRACLAVICULAR"
  },
  {
    "codigo":30191000175106,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN EN CODO DERECHO"
  },
  {
    "codigo":277824001,
    "descripcion":"ANSIEDAD ACERCA DE DESMAYARSE"
  },
  {
    "codigo":15730961000119100,
    "descripcion":"PARÁLISIS PARCIAL DE NERVIO OCULOMOTOR IZQUIERDO"
  },
  {
    "codigo":15680007,
    "descripcion":"DERMATITIS VESICULAR SUBEPIDÉRMICA"
  },
  {
    "codigo":308757003,
    "descripcion":"APLASTAMIENTO DE VÉRTEBRA CERVICAL"
  },
  {
    "codigo":112149005,
    "descripcion":"GRUPO SANGUÍNEO B (GRUPO SANGUÍNEO ABO)"
  },
  {
    "codigo":1259029008,
    "descripcion":"NEUROPATÍA DE PLEXO BRAQUIAL DEBIDA A ENFERMEDAD NEOPLÁSICA"
  },
  {
    "codigo":110314001,
    "descripcion":"ALTURA CLÍNICAMENTE INSUFICIENTE DE CORONA DE DIENTE POR ERUPCIÓN PASIVA ANÓMALA"
  },
  {
    "codigo":306922002,
    "descripcion":"MOVILIDAD NORMAL DEL YUNQUE"
  },
  {
    "codigo":77546004,
    "descripcion":"FRACTURA EXPUESTA DE SEIS COSTILLAS"
  },
  {
    "codigo":12010005,
    "descripcion":"OSTEODISTROFIA"
  },
  {
    "codigo":863978006,
    "descripcion":"DERRAME PLEURAL DEBIDO A PANCREATITIS"
  },
  {
    "codigo":15649041000119103,
    "descripcion":"ANEURISMA DE ARTERIA ILÍACA COMÚN IZQUIERDA"
  },
  {
    "codigo":1157055000,
    "descripcion":"INTOXICACIÓN CAUSADA POR SUSTANCIA CON ESTRUCTURA BENCENO"
  },
  {
    "codigo":403391003,
    "descripcion":"ERITROMELALGIA SECUNDARIA"
  },
  {
    "codigo":763839005,
    "descripcion":"SÍNDROME DE MARFAN NEONATAL"
  },
  {
    "codigo":1231240001,
    "descripcion":"NEURITIS ÓPTICA IDIOPÁTICA"
  },
  {
    "codigo":235881000,
    "descripcion":"INSUFICIENCIA HEPÁTICA POR ALCOHOL"
  },
  {
    "codigo":39273001,
    "descripcion":"PERIODONTITIS APICAL"
  },
  {
    "codigo":399721002,
    "descripcion":"INFILTRACIÓN TUMORAL POR LINFOCITOS, PRESENTE"
  },
  {
    "codigo":303531000119101,
    "descripcion":"DEPÓSITO DE CALCIO EN BOLSA SEROSA DE MANO DERECHA"
  },
  {
    "codigo":237716008,
    "descripcion":"QUISTE PITUITARIO"
  },
  {
    "codigo":11854251000119101,
    "descripcion":"DISTENSIÓN DE MÚSCULO INTRÍNSECO DE PIE IZQUIERDO"
  },
  {
    "codigo":11307281000119107,
    "descripcion":"FRACTURA NO EXPUESTA DE ACETÁBULO IZQUIERDO"
  },
  {
    "codigo":301417007,
    "descripcion":"DOLOR A LA DESCOMPRESIÓN EN REGIÓN LUMBAR IZQUIERDA"
  },
  {
    "codigo":1153385004,
    "descripcion":"NEOPLASIA DE ESTROMA GASTROINTESTINAL DE YEYUNO"
  },
  {
    "codigo":102974003,
    "descripcion":"POTENCIAL EVOCADO AUDITIVO DEL TRONCO ENCEFÁLICO ANORMAL"
  },
  {
    "codigo":37438006,
    "descripcion":"MANEJO DE UN HOGAR QUE ATRAVIESA UNA SITUACIÓN DE ALTERACIÓN, MODERADO"
  },
  {
    "codigo":365118007,
    "descripcion":"HALLAZGO RELACIONADO CON LA ESTABILIDAD DEL ESTADO DE ÁNIMO"
  },
  {
    "codigo":201278007,
    "descripcion":"CLOASMA TÓXICO"
  },
  {
    "codigo":234046009,
    "descripcion":"TROMBOSIS DE LA VENA RENAL TRASPLANTADA"
  },
  {
    "codigo":2835000,
    "descripcion":"ANEMIA HEMOLÍTICA CARDÍACA TRAUMÁTICA"
  },
  {
    "codigo":428819003,
    "descripcion":"USO INAPROPIADO DE OPIÁCEOS"
  },
  {
    "codigo":461587006,
    "descripcion":"ATRESIA CONGÉNITA DE LUZ DEL CAYADO AÓRTICO DISTAL A LA ARTERIA SUBCLAVIA"
  },
  {
    "codigo":11772331000119105,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXTERNA NO EXPUESTA DE CODO DERECHO"
  },
  {
    "codigo":44331000087105,
    "descripcion":"CONTUSIÓN DE CÓNDILO INTERNO DE TIBIA IZQUIERDA"
  },
  {
    "codigo":11051000087106,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA VÍA AÉREA DURANTE INTERVENCIÓN QUIRÚRGICA"
  },
  {
    "codigo":39211000087107,
    "descripcion":"DOLOR NEUROPÁTICO PERIFÉRICO CRÓNICO POSTERIOR A LESIÓN DE NERVIO PERIFÉRICO"
  },
  {
    "codigo":41771000087106,
    "descripcion":"CELULITIS DE PIERNA DERECHA"
  },
  {
    "codigo":263144005,
    "descripcion":"SECCIÓN TRAUMÁTICA DE LIGAMENTO DE DEDO DE LA MANO"
  },
  {
    "codigo":295912001,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE TRIPTÓFANO"
  },
  {
    "codigo":195773006,
    "descripcion":"RINITIS FIBRINOSA CRÓNICA"
  },
  {
    "codigo":294077008,
    "descripcion":"ALERGIA A TRIHEXIFENIDILO"
  },
  {
    "codigo":292242001,
    "descripcion":"REACCIÓN ADVERSA A LA CRISANTASPASA"
  },
  {
    "codigo":718226002,
    "descripcion":"SÍNDROME DE WOLF HIRSCHHORN"
  },
  {
    "codigo":359613008,
    "descripcion":"GASTROENTERITIS NO BACTERIANA INFECCIOSA AGUDA"
  },
  {
    "codigo":161170004,
    "descripcion":"ÍNDICE DE MORBILIDAD MEDIANO"
  },
  {
    "codigo":128402005,
    "descripcion":"ENFERMEDAD INFECCIOSA DEL APARATO CARDIOVASCULAR"
  },
  {
    "codigo":95634003,
    "descripcion":"PARO RESPIRATORIO NEONATAL"
  },
  {
    "codigo":93799003,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL PERONÉ"
  },
  {
    "codigo":126567006,
    "descripcion":"NEOPLASIA DEL ACROMION"
  },
  {
    "codigo":61031008,
    "descripcion":"HIPOCAPNIA"
  },
  {
    "codigo":716391009,
    "descripcion":"CAPAZ DE ADAPTARSE A CAMBIOS SENSITIVOS EN PARTE CORPORAL"
  },
  {
    "codigo":290407008,
    "descripcion":"INTOXICACIÓN POR CISAPRIDA"
  },
  {
    "codigo":190268003,
    "descripcion":"HIPOTIROIDISMO CONGÉNITO"
  },
  {
    "codigo":91964000,
    "descripcion":"NEOPLASIA BENIGNA DE ADENOIDES"
  },
  {
    "codigo":113221000119105,
    "descripcion":"OSTEOCONDROMA DE RADIO"
  },
  {
    "codigo":124732006,
    "descripcion":"CLIMATERIO MASCULINO PREMATURO"
  },
  {
    "codigo":90129003,
    "descripcion":"SÍNCOPE TUSIVO"
  },
  {
    "codigo":57361003,
    "descripcion":"ANOMALÍA DEL PAR DE CROMOSOMAS 5"
  },
  {
    "codigo":4831000119102,
    "descripcion":"ACÚFENO BILATERAL"
  },
  {
    "codigo":284902003,
    "descripcion":"REALIZA ACTIVIDADES DE HIGIENE"
  },
  {
    "codigo":11827781000119109,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN ROTULOFEMORAL IZQUIERDA"
  },
  {
    "codigo":10900191000119103,
    "descripcion":"ABRASIÓN DE CÓRNEA DERECHA"
  },
  {
    "codigo":448742006,
    "descripcion":"ANOMALÍA DE CAYADO AÓRTICO"
  },
  {
    "codigo":22758008,
    "descripcion":"SIGNO DE SPALDING - HORNER"
  },
  {
    "codigo":88294009,
    "descripcion":"RUPTURA DE OVARIO"
  },
  {
    "codigo":283067003,
    "descripcion":"ARAÑAZO DE LA CARA"
  },
  {
    "codigo":709051008,
    "descripcion":"CON MAYOR RIESGO DE NEOPLASIA MALIGNA"
  },
  {
    "codigo":10736351000119105,
    "descripcion":"VAGINITIS SUBAGUDA"
  },
  {
    "codigo":1297040002,
    "descripcion":"RUPTURA CRÓNICA DE LIGAMENTO LATERAL EXTERNO DE RODILLA"
  },
  {
    "codigo":248464003,
    "descripcion":"TOLERANTE AL CALOR"
  },
  {
    "codigo":314000002,
    "descripcion":"OCLUSIÓN DE RAMA DE VENA RETINIANA SIN NEOVASCULARIZACIÓN"
  },
  {
    "codigo":445072006,
    "descripcion":"PIGMENTACIÓN DE PIEL POR HEMOSIDERINA"
  },
  {
    "codigo":142201000119101,
    "descripcion":"TABIQUE LONGITUDINAL CONGÉNITO DE VAGINA"
  },
  {
    "codigo":410469004,
    "descripcion":"IRITIS PAPULOSA"
  },
  {
    "codigo":82789004,
    "descripcion":"MASTITIS AGUDA"
  },
  {
    "codigo":1196901004,
    "descripcion":"NEOPLASIA GLANDULAR INTRAEPITELIAL DE ESÓFAGO DE ALTO GRADO"
  },
  {
    "codigo":1162298004,
    "descripcion":"OSTEOARTROPATÍA HIPERTRÓFICA PARANEOPLÁSICA"
  },
  {
    "codigo":80954004,
    "descripcion":"FUNCIÓN RESPIRATORIA DISMINUIDA"
  },
  {
    "codigo":736314008,
    "descripcion":"TRASTORNO DISOCIATIVO CON SÍNTOMA NEUROLÓGICO CONCOMITANTE CON SÍNTOMAS COGNITIVOS"
  },
  {
    "codigo":48186008,
    "descripcion":"OCLUSIÓN DEFECTUOSA POR HÁBITOS LINGUALES"
  },
  {
    "codigo":439567002,
    "descripcion":"ESCLEROSIS MÚLTIPLE MALIGNA"
  },
  {
    "codigo":10955641000119104,
    "descripcion":"HERIDA PUNZANTE DE DEDO DE MANO IZQUIERDA"
  },
  {
    "codigo":275727004,
    "descripcion":"PRUEBA DE AUDICIÓN NORMAL"
  },
  {
    "codigo":44516004,
    "descripcion":"PSEUDO-OBSTRUCCIÓN CRÓNICA PRIMARIA DEL TRACTO GASTROINTESTINAL"
  },
  {
    "codigo":110052006,
    "descripcion":"LACERACIÓN SIMPLE DE LA REGIÓN PERIORAL DE LA CARA"
  },
  {
    "codigo":698041000,
    "descripcion":"MELANOMA MALIGNO DE VESTÍBULO DE LA BOCA"
  },
  {
    "codigo":699876008,
    "descripcion":"VÁRICE DE CUERDA VOCAL"
  },
  {
    "codigo":403129004,
    "descripcion":"ABSCESO FILARIÁSICO"
  },
  {
    "codigo":42681006,
    "descripcion":"HIPERPLASIA DE LAS CÉLULAS DE LOS ISLOTES PANCREÁTICOS"
  },
  {
    "codigo":75449008,
    "descripcion":"INFECCIÓN CAUSADA POR HOUTTUYNIA"
  },
  {
    "codigo":237454007,
    "descripcion":"MASTALGIA NO CÍCLICA"
  },
  {
    "codigo":1251427000,
    "descripcion":"DERMATITIS ALÉRGICA DE CONTACTO DE PIEL DE CARA"
  },
  {
    "codigo":39011001,
    "descripcion":"HEMOSIDEROSIS"
  },
  {
    "codigo":301155005,
    "descripcion":"PULSO RADIAL PRESENTE"
  },
  {
    "codigo":235619005,
    "descripcion":"ESTENOSIS ESOFÁGICA FARMACÓGENA"
  },
  {
    "codigo":366691005,
    "descripcion":"AMPLITUD DE LA EXTENSIÓN DEL PULGAR - HALLAZGO"
  },
  {
    "codigo":71779008,
    "descripcion":"SÍNDROME DE HIDROCEFALIA LIGADO AL CROMOSOMA X"
  },
  {
    "codigo":364856001,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA BRINCAR CON LOS PIES EN FORMA ALTERNADA"
  },
  {
    "codigo":399459006,
    "descripcion":"TROMPA DE FALOPIO IZQUIERDA NO UNIDA A OVARIO IZQUIERDO"
  },
  {
    "codigo":299320004,
    "descripcion":"PRUEBA DE BARLOW NEGATIVA"
  },
  {
    "codigo":233784004,
    "descripcion":"RUPTURA TRAQUEAL"
  },
  {
    "codigo":335021000119100,
    "descripcion":"DESGARRO RETINIANO GIGANTE DE OJO DERECHO"
  },
  {
    "codigo":440451000124103,
    "descripcion":"INGESTA INADECUADA DE ÉSTER DE ESTEROL VEGETAL"
  },
  {
    "codigo":201016008,
    "descripcion":"PRURIGO DE HEBRA"
  },
  {
    "codigo":450691000124105,
    "descripcion":"MENISCO DISCOIDE CONGÉNITO DE RODILLA IZQUIERDA"
  },
  {
    "codigo":231949001,
    "descripcion":"ATROFIA SECUNDARIA DEL IRIS"
  },
  {
    "codigo":1149453000,
    "descripcion":"PERIODONTITIS GENERALIZADA ESTADIO 3 GRADO A SEGÚN LA CLASIFICACIÓN DE LAS ENFERMEDADES Y ALTERACIONES PERIODONTALES Y PERIIMPLANTARIAS DE 2017 DE LA ACADEMIA ESTADOUNIDENSE DE PERIODONTOLOGÍA Y LA FEDERACIÓN EUROPEA DE PERIODONTOLOGÍA"
  },
  {
    "codigo":428557006,
    "descripcion":"DOLOR DE TIPO CONSTRICTIVO"
  },
  {
    "codigo":68109007,
    "descripcion":"ESTRECHEZ DE ARTERIA"
  },
  {
    "codigo":396808004,
    "descripcion":"MARGEN QUIRÚRGICO DEL PARÉNQUIMA PANCREÁTICO COMPROMETIDO POR CARCINOMA IN SITU"
  },
  {
    "codigo":363021009,
    "descripcion":"COMPLICACIÓN DE PROCEDIMIENTO DE TERAPIA RESPIRATORIA"
  },
  {
    "codigo":789005009,
    "descripcion":"PARÁLISIS DE ÚVULA POSDIFTÉRICA"
  },
  {
    "codigo":262882007,
    "descripcion":"LESIÓN TRAUMÁTICA DEL MESENTERIO"
  },
  {
    "codigo":162743000,
    "descripcion":"LABIOS AZULES"
  },
  {
    "codigo":293815001,
    "descripcion":"ALERGIA A BROMOCRIPTINA"
  },
  {
    "codigo":295650009,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE LOMUSTINA"
  },
  {
    "codigo":721634009,
    "descripcion":"NEOPLASIA NEUROENDOCRINA MALIGNA PRIMARIA DE ESTÓMAGO"
  },
  {
    "codigo":228279004,
    "descripcion":"BEBEDOR EXCESIVO CON CONSUMO MUY ALTO"
  },
  {
    "codigo":95372000,
    "descripcion":"EDEMA EN EL SITIO DE APLICACIÓN"
  },
  {
    "codigo":160908003,
    "descripcion":"RETIRADO, RECIBE INGRESOS POR INVERSIONES - ACONTECIMIENTO DE LA VIDA"
  },
  {
    "codigo":12105031000119100,
    "descripcion":"QUEMADURA QUÍMICA DE MANO DERECHA"
  },
  {
    "codigo":717964007,
    "descripcion":"ESCLEROSIS LATERAL PRIMARIA JUVENIL"
  },
  {
    "codigo":423052008,
    "descripcion":"DESPERTAR NOCTURNO FRECUENTE"
  },
  {
    "codigo":16637101000119107,
    "descripcion":"SARCOMA PRIMARIO DE INTESTINO DELGADO"
  },
  {
    "codigo":290145004,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR ASPIRINA"
  },
  {
    "codigo":1142113007,
    "descripcion":"DISFUNCIÓN SEXUAL DEBIDA A FÍSTULA OBSTÉTRICA"
  },
  {
    "codigo":1304118001,
    "descripcion":"NEUROFIBROMATOSIS TIPO 1 EN MOSAICO"
  },
  {
    "codigo":879969009,
    "descripcion":"DOLOR IRRUPTIVO"
  },
  {
    "codigo":386614005,
    "descripcion":"RESPIRACIÓN LENTA, SUPERFICIAL"
  },
  {
    "codigo":308551000119103,
    "descripcion":"SINDACTILIA DE DEDOS DE MANO DERECHA"
  },
  {
    "codigo":1236747001,
    "descripcion":"MASA QUE OCUPA MITAD INFERIOR DE ABDOMEN"
  },
  {
    "codigo":124470009,
    "descripcion":"DEFICIENCIA DE BETA - GLUCURONIDASA"
  },
  {
    "codigo":450315001,
    "descripcion":"ANILLO VASCULAR CON CAYADO AÓRTICO DERECHO Y LIGAMENTO ARTERIAL IZQUIERDO"
  },
  {
    "codigo":253707003,
    "descripcion":"ORIGEN ANÓMALO DE LA ARTERIA CORONARIA EN LA ARTERIA PULMONAR DERECHA"
  },
  {
    "codigo":417547006,
    "descripcion":"RETINITIS CRIPTOCÓCICA"
  },
  {
    "codigo":286475006,
    "descripcion":"DIFICULTAD PARA REBANAR ALIMENTOS"
  },
  {
    "codigo":88032003,
    "descripcion":"AMAUROSIS FUGAZ"
  },
  {
    "codigo":284640003,
    "descripcion":"SOFOCAR A OTRA PERSONA"
  },
  {
    "codigo":448480006,
    "descripcion":"CONDUCTO ARTERIOSO ORIGINADO EN ARTERIA SUBCLAVIA IZQUIERDA"
  },
  {
    "codigo":282805001,
    "descripcion":"LESIÓN TÉRMICA DE NERVIO CRANEAL"
  },
  {
    "codigo":250037002,
    "descripcion":"ESTENOSIS ANAL ADQUIRIDA"
  },
  {
    "codigo":1003701003,
    "descripcion":"MIGRACIÓN TRANSUTERINA DE ÓVULO"
  },
  {
    "codigo":413877007,
    "descripcion":"FRACTURA NO EXPUESTA DE TIBIA Y PERONÉ"
  },
  {
    "codigo":280970000,
    "descripcion":"OCLUSIÓN DE INJERTO ARTERIOVENOSO"
  },
  {
    "codigo":1264010001,
    "descripcion":"SÍNDROME HIPEREOSINOFÍLICO PRIMARIO"
  },
  {
    "codigo":117130002,
    "descripcion":"CARACTERÍSTICA DEL SOPLO CARDÍACO, BRAMANTE"
  },
  {
    "codigo":706954003,
    "descripcion":"CAPAZ DE REALIZAR AUTOCATETERISMO URETRAL INTERMITENTE"
  },
  {
    "codigo":84362007,
    "descripcion":"TIROIDITIS DE HASHIMOTO, VARIANTE FIBROSA"
  },
  {
    "codigo":1231242009,
    "descripcion":"ECTASIA CORNEAL IATROGÉNICA"
  },
  {
    "codigo":770655004,
    "descripcion":"SÍNDROME DE MICROCEFALIA, DEFECTO CEREBRAL, ESPASTICIDAD E HIPERNATREMIA"
  },
  {
    "codigo":80692000,
    "descripcion":"EFECTO TARDÍO DE UNA LESIÓN TRAUMÁTICA TENDINOSA"
  },
  {
    "codigo":408372001,
    "descripcion":"INSTRUCCIONES INADECUADAS E INAPROPIADAS RELACIONADAS CON EL TRATAMIENTO FARMACOLÓGICO"
  },
  {
    "codigo":1260340002,
    "descripcion":"HIDROCEFALIA EX VACUO DEBIDA A LESIÓN CEREBRAL"
  },
  {
    "codigo":11996641000119105,
    "descripcion":"DOLOR EN MUÑÓN DE AMPUTACIÓN DE EXTREMIDAD INFERIOR DERECHA"
  },
  {
    "codigo":1293108004,
    "descripcion":"CARCINOMA BASOCELULAR CON DIFERENCIACIÓN DE ANEXOS"
  },
  {
    "codigo":47924005,
    "descripcion":"TRASTORNO CORTICAL MOTOR"
  },
  {
    "codigo":703284009,
    "descripcion":"FACOMATOSIS CESIOFLAMMEA"
  },
  {
    "codigo":337531000119101,
    "descripcion":"QUERATITIS SUPERFICIAL DE OJO IZQUIERDO"
  },
  {
    "codigo":10823291000119101,
    "descripcion":"FRACTURA EXPUESTA DE LA FALANGE MEDIA DEL DEDO ÍNDICE DE LA MANO IZQUIERDA"
  },
  {
    "codigo":44254000,
    "descripcion":"LITIGIO"
  },
  {
    "codigo":109790008,
    "descripcion":"FIBROMA DE CÉLULAS GIGANTES DE LA MUCOSA ORAL"
  },
  {
    "codigo":11806331000119104,
    "descripcion":"LUXACIÓN TRAUMÁTICA POSTERIOR NO EXPUESTA DE RODILLA IZQUIERDA"
  },
  {
    "codigo":689861000119100,
    "descripcion":"TRIPLICACIÓN DE GEN DE ALFA GLOBINA"
  },
  {
    "codigo":1089221000119100,
    "descripcion":"PÉRDIDA DE LA AUDICIÓN DE OÍDO IZQUIERDO CAUSADA POR RUIDO"
  },
  {
    "codigo":318661000119102,
    "descripcion":"ARTROSIS DE ARTICULACIÓN DE MANO IZQUIERDA"
  },
  {
    "codigo":239027006,
    "descripcion":"DISPLASIA ECTODÉRMICA CON DEFECTOS DEL PELO-DIENTES"
  },
  {
    "codigo":16467141000119104,
    "descripcion":"MELORREOSTOSIS DE HÚMERO IZQUIERDO"
  },
  {
    "codigo":763315005,
    "descripcion":"MIOPATÍA CONGÉNITA CON COMIENZO SIMILAR A LA MIASTENIA"
  },
  {
    "codigo":402867006,
    "descripcion":"HEMANGIOMA CAPILAR"
  },
  {
    "codigo":1073861000119104,
    "descripcion":"DEFORMIDAD MANO DERECHA CONCOMITANTE CON ARTRITIS REUMATOIDE Y DEBIDA A ELLA"
  },
  {
    "codigo":1078981000119108,
    "descripcion":"CARCINOMA ADENOIDE QUÍSTICO DE GLÁNDULA LAGRIMAL DERECHA"
  },
  {
    "codigo":107557061000119108,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DEBIDO A EMBOLIA DE AMBAS ARTERIAS CEREBRALES ANTERIORES"
  },
  {
    "codigo":11797701000119109,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE REGIÓN SACRA"
  },
  {
    "codigo":339141000119108,
    "descripcion":"PAPILITIS ÓPTICA DE OJO IZQUIERDO"
  },
  {
    "codigo":1187464007,
    "descripcion":"SARCOMA DE CÉLULAS CLARAS DE RIÑÓN"
  },
  {
    "codigo":16264901000119109,
    "descripcion":"TRASTORNO DEPRESIVO MAYOR MODERADO RECURRENTE CONCOMITANTE CON ANSIEDAD"
  },
  {
    "codigo":202589002,
    "descripcion":"OSTEOCONDROMATOSIS SINOVIAL DE ARTICULACIÓN SUBASTRAGALINA"
  },
  {
    "codigo":295621000119107,
    "descripcion":"CALCIFICACIÓN Y OSIFICACIÓN DE MÚSCULO DE BRAZO DEBIDA A QUEMADURA"
  },
  {
    "codigo":313541000119107,
    "descripcion":"EPICONDILITIS MEDIAL DE ARTICULACIÓN DE CODO IZQUIERDO"
  },
  {
    "codigo":1081541000119109,
    "descripcion":"NEVO EPIDÉRMICO PILOSO PIGMENTADO DE MIEMBRO INFERIOR DERECHO"
  },
  {
    "codigo":300893006,
    "descripcion":"HALLAZGO NUTRICIONAL"
  },
  {
    "codigo":302728008,
    "descripcion":"ENDARTERITIS DEFORMANTE"
  },
  {
    "codigo":167986000,
    "descripcion":"EXAMEN DEL ESPUTO: ANORMAL"
  },
  {
    "codigo":366429009,
    "descripcion":"AMPLITUD DE MOVIMIENTO PASIVO DE FLEXIÓN DE LA COLUMNA LUMBAR - HALLAZGO"
  },
  {
    "codigo":725042001,
    "descripcion":"DISTROFIA AUTOSÓMICA RECESIVA DE LAS CINTURAS MUSCULARES DE LOS MIEMBROS TIPO 2J"
  },
  {
    "codigo":397362004,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA LATERAL (MUCOSO\/PARIETAL) COMPROMETIDO POR TUMOR, NO APLICABLE"
  },
  {
    "codigo":15957781000119103,
    "descripcion":"NEOPLASIA BENIGNA DE AMBAS GLÁNDULAS SUPRARRENALES"
  },
  {
    "codigo":36914006,
    "descripcion":"ENANISMO RENAL"
  },
  {
    "codigo":299058009,
    "descripcion":"DEDO DE LA MANO PEQUEÑO"
  },
  {
    "codigo":295388003,
    "descripcion":"SOBREDOSIS DE ÁCIDO 5-AMINOSALICÍLICO"
  },
  {
    "codigo":262620004,
    "descripcion":"CUERPO EXTRAÑO EN EL ESCROTO"
  },
  {
    "codigo":721372007,
    "descripcion":"SÍNDROME DEL CORDÓN CENTRAL DE MÉDULA ESPINAL AL NIVEL DEL PRIMER SEGMENTO CERVICAL"
  },
  {
    "codigo":293553000,
    "descripcion":"REACCIÓN ADVERSA A MONONITRATO DE ISOSORBIDA DE LIBERACIÓN MODIFICADA"
  },
  {
    "codigo":197084009,
    "descripcion":"DIVERTICULOSIS DEL YEYUNO"
  },
  {
    "codigo":129713002,
    "descripcion":"CON MAYOR RIESGO DE IMPOTENCIA"
  },
  {
    "codigo":1145521002,
    "descripcion":"APLASIA DE FALANGE DE DEDO PULGAR"
  },
  {
    "codigo":64177003,
    "descripcion":"BAJO PESO PARA EDAD GESTACIONAL CON SIGNOS DE DESNUTRICIÓN FETAL"
  },
  {
    "codigo":162481009,
    "descripcion":"SÍNTOMA QUE EMPEORA CON LA RESPIRACIÓN"
  },
  {
    "codigo":29574001,
    "descripcion":"NÓDULOS DE SCHMORL DE REGIÓN LUMBAR"
  },
  {
    "codigo":717702001,
    "descripcion":"ÚTERO BICORNE BICERVICAL CON CUELLO UTERINO Y VAGINA PERMEABLES"
  },
  {
    "codigo":226182005,
    "descripcion":"DIETA SIN COLORANTES AZOICOS"
  },
  {
    "codigo":95110007,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA COLUMNA VERTEBRAL"
  },
  {
    "codigo":715867000,
    "descripcion":"SÍNDROME DE PSEUDOAMINOPTERINA"
  },
  {
    "codigo":160646008,
    "descripcion":"GRADO 0 DE ACTIVIDAD SEGÚN EL PRINCIPIO DE FRECUENCIA, INTENSIDAD, DURACIÓN Y TIPO DE EJERCICIO: SIN ACTIVIDAD MODERADA\/VIGOROSA DURANTE 20 MINUTOS"
  },
  {
    "codigo":60507002,
    "descripcion":"HERNIA HIATAL CON GANGRENA Y OBSTRUCCIÓN"
  },
  {
    "codigo":93275004,
    "descripcion":"HIPOPLASIA CONGÉNITA DE LA CAVIDAD NASAL"
  },
  {
    "codigo":289883005,
    "descripcion":"HALLAZGO RELACIONADO CON LAS FUNCIONES GENITALES FEMENINAS"
  },
  {
    "codigo":224347004,
    "descripcion":"PODER NOTARIAL EN EXISTENCIA"
  },
  {
    "codigo":1141851008,
    "descripcion":"EOSINOFILIA MUSCULAR"
  },
  {
    "codigo":124208000,
    "descripcion":"DEFICIENCIA DE TRIPTÓFANO 2, 3 - DIOXIGENASA"
  },
  {
    "codigo":11835311000119105,
    "descripcion":"SUBLUXACIÓN ROTATORIA DE ARTICULACIÓN DE ESCAFOIDES DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":25904003,
    "descripcion":"DEFICIENCIA ADQUIRIDA DE FACTOR DE COAGULACIÓN"
  },
  {
    "codigo":253445003,
    "descripcion":"CUERDAS TENDINOSAS DE VÁLVULA AURICULOVENTRICULAR COMÚN EXCESIVAMENTE CORTAS"
  },
  {
    "codigo":94281000119101,
    "descripcion":"NEOPLASIA MALIGNA ENDOCRINA MÚLTIPLE TIPO 2A"
  },
  {
    "codigo":24069003,
    "descripcion":"ENFERMEDAD DE LAS OVEJAS DE NAIROBI"
  },
  {
    "codigo":286213009,
    "descripcion":"INCAPAZ DE EMPLEAR APOYO RESPIRATORIO AL HABLAR"
  },
  {
    "codigo":10907721000119103,
    "descripcion":"HERIDA POR DISPARO DE ARMA DE FUEGO DE NALGA IZQUIERDA"
  },
  {
    "codigo":22234005,
    "descripcion":"FRACTURA EXPUESTA DE LA DIÁFISIS DE LA TIBIA"
  },
  {
    "codigo":448218008,
    "descripcion":"NEOPLASIA MALIGNA DE ÁNGULO PONTOCEREBELOSO"
  },
  {
    "codigo":251610009,
    "descripcion":"POTENCIAL EVOCADO AUDITIVO DEL TRONCO ENCEFÁLICO, ONDAS II A V ANORMALES"
  },
  {
    "codigo":10743881000119104,
    "descripcion":"ANOMALÍA FETAL SOSPECHADA QUE AFECTA EL MANEJO DE LA MADRE"
  },
  {
    "codigo":184239006,
    "descripcion":"TARJETA DE REPETICIÓN DE LA PRESCRIPCIÓN VERIFICADA\/ACTUALIZADA"
  },
  {
    "codigo":282543007,
    "descripcion":"SE DETIENE AL CORRER"
  },
  {
    "codigo":1003439007,
    "descripcion":"REMANENTE VITELINO INTRABDOMINAL"
  },
  {
    "codigo":444548001,
    "descripcion":"PANCOLITIS ULCEROSA"
  },
  {
    "codigo":247940006,
    "descripcion":"MARCHA EN PUNTAS DE PIE REPETITIVA"
  },
  {
    "codigo":49497005,
    "descripcion":"SÍNDROME MEDULAR ANTERIOR DEBIDO A FRACTURA EXPUESTA A NIVEL DE T1-T6"
  },
  {
    "codigo":67811000119102,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA MICROCÍTICA DE PULMÓN, ESTADIO TNM 1"
  },
  {
    "codigo":80430001,
    "descripcion":"INTOXICACIÓN POR ZAMIA"
  },
  {
    "codigo":211502002,
    "descripcion":"CONTUSIÓN, HOMBRO Y BRAZO, SITIOS MÚLTIPLES"
  },
  {
    "codigo":703022003,
    "descripcion":"ANAEROCOCCUS TETRADIUS O ANAEROCOCCUS PREVOTII"
  },
  {
    "codigo":442713009,
    "descripcion":"HALLAZGO RELACIONADO CON DIFERENCIA EN LA FORMA EN COMPARACIÓN CON EXAMEN RADIOLÓGICO PREVIO"
  },
  {
    "codigo":16697571000119103,
    "descripcion":"DISECCIÓN DE ARTERIA BRAQUIAL DERECHA"
  },
  {
    "codigo":14894002,
    "descripcion":"COROIDITIS Y CORIORRETINITIS GENERALIZADA DISEMINADA"
  },
  {
    "codigo":1260078007,
    "descripcion":"LACTANCIA MATERNA"
  },
  {
    "codigo":735790008,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE PARTE DE LA REGIÓN LUMBAR"
  },
  {
    "codigo":13059002,
    "descripcion":"ICTIOSIS CONGÉNITA DE LA PIEL"
  },
  {
    "codigo":78595002,
    "descripcion":"ALUCINACIÓN AUDITIVA (ÓRDENES)"
  },
  {
    "codigo":111363006,
    "descripcion":"PROCTOPTOSIS"
  },
  {
    "codigo":733955007,
    "descripcion":"CARIES DENTAL INACTIVA SECUNDARIA QUE SE EXTIENDE HASTA LA MITAD INTERNA DEL ESMALTE"
  },
  {
    "codigo":240600000,
    "descripcion":"TRICOMONIASIS ASINTOMÁTICA"
  },
  {
    "codigo":15933821000119100,
    "descripcion":"OCLUSIÓN CONGÉNITA DE MEATO URETERAL"
  },
  {
    "codigo":109528007,
    "descripcion":"HIPOPLASIA MAXILAR TRANSVERSA CONGÉNITA"
  },
  {
    "codigo":238765000,
    "descripcion":"TELANGIECTASIA ARBORIZANTE PROGRESIVA ASCENDENTE"
  },
  {
    "codigo":304301001,
    "descripcion":"AMPLITUD DE MOVIMIENTO DE CODO DISMINUIDA"
  },
  {
    "codigo":42157000,
    "descripcion":"FRACTURA NO EXPUESTA DE COLUMNA VERTEBRAL"
  },
  {
    "codigo":402605003,
    "descripcion":"PIGMENTACIÓN FISIOLÓGICA"
  },
  {
    "codigo":1156269004,
    "descripcion":"COMUNICACIÓN OROANTRAL"
  },
  {
    "codigo":9389005,
    "descripcion":"QUERATITIS POR VIRUS DEL HERPES SIMPLE"
  },
  {
    "codigo":894125007,
    "descripcion":"ESPINA BÍFIDA ABIERTA DE COLUMNA VERTEBRAL CERVICOTORÁCICA"
  },
  {
    "codigo":1252738002,
    "descripcion":"NÓDULO DE PIEL DE DEDO DE PIE DERECHO"
  },
  {
    "codigo":366167000,
    "descripcion":"HALLAZGO RELACIONADO CON EL PATRÓN ELECTROCARDIOGRÁFICO DE MARCAPASOS CARDÍACO"
  },
  {
    "codigo":1285506008,
    "descripcion":"ENDOFTALMITIS POSTERIOR A CIRUGÍA DE IMPLANTE DE DISPOSITIVO DE DRENAJE PARA GLAUCOMA"
  },
  {
    "codigo":235095001,
    "descripcion":"APERTURA LATERAL - IZQUIERDA"
  },
  {
    "codigo":726615005,
    "descripcion":"DISTROFIA MUSCULAR DE LAS CINTURAS DE LAS EXTREMIDADES TIPO 2Q AUTOSÓMICA RECESIVA"
  },
  {
    "codigo":71255007,
    "descripcion":"LARINGOTRAQUEOBRONQUITIS POR ADENOVIRUS"
  },
  {
    "codigo":300631009,
    "descripcion":"NO VIAJA EN TRANSPORTE PRIVADO"
  },
  {
    "codigo":724780002,
    "descripcion":"DESMIELINIZACIÓN DE SISTEMA NERVIOSO CENTRAL CONCOMITANTE CON NEUROSARCOIDOSIS Y DEBIDA A ELLA"
  },
  {
    "codigo":397100004,
    "descripcion":"MARGEN QUIRÚRGICO DE CONDUCTO CÍSTICO COMPROMETIDO POR NEOPLASIA MALIGNA"
  },
  {
    "codigo":1281836004,
    "descripcion":"CRISIS EPILÉPTICA AUTONÓMICA CON ALTERACIÓN DE CONCIENCIA DE INICIO FOCAL"
  },
  {
    "codigo":167724007,
    "descripcion":"LCR: NO SE OBSERVAN MICROORGANISMOS"
  },
  {
    "codigo":788481002,
    "descripcion":"TRASTORNO REPETITIVO DEL MOVIMIENTO DEL PIE DERECHO"
  },
  {
    "codigo":204339005,
    "descripcion":"ANOMALÍA CONGÉNITA DE VÁLVULA PULMONAR"
  },
  {
    "codigo":722945007,
    "descripcion":"EXCESO DE ANDRÓGENOS CAUSADO POR FÁRMACO"
  },
  {
    "codigo":1148929009,
    "descripcion":"DEFICIENCIA DE FACTOR DE LA COAGULACIÓN DEBIDA A MALABSORCIÓN DE VITAMINA K"
  },
  {
    "codigo":198657009,
    "descripcion":"ABORTO ESPONTÁNEO COMPLETO CON DAÑO DE ÓRGANOS O TEJIDOS PÉLVICOS"
  },
  {
    "codigo":129451001,
    "descripcion":"ENFERMEDAD PULMONAR INTERSTICIAL ASOCIADA CON BRONQUIOLITIS"
  },
  {
    "codigo":162219004,
    "descripcion":"TIENDE A MOLESTARSE CON LA AUTORIDAD"
  },
  {
    "codigo":424363005,
    "descripcion":"ALMACENAMIENTO DE MEDICACIÓN INADECUADO"
  },
  {
    "codigo":194987006,
    "descripcion":"ESTENOSIS VALVULAR AÓRTICA CON INSUFICIENCIA"
  },
  {
    "codigo":719275009,
    "descripcion":"SÍNDROME DE HIPOGONADISMO HIPERGONADOTRÓFICO PRIMARIO Y ALOPECIA PARCIAL"
  },
  {
    "codigo":291456003,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR MEFLOQUINA"
  },
  {
    "codigo":193152004,
    "descripcion":"LESIÓN DEL NERVIO PERONEO PROFUNDO"
  },
  {
    "codigo":225920006,
    "descripcion":"CONTENIDO DE LA CONVERSACIÓN INAPROPIADO"
  },
  {
    "codigo":1208960007,
    "descripcion":"CONVULSIÓN EPILÉPTICA MOTORA"
  },
  {
    "codigo":1010517000,
    "descripcion":"ESCLEROSIS DE EPÍFISIS DE PRIMER HUESO METATARSIANO CON RADIOPACIDAD AUMENTADA"
  },
  {
    "codigo":94848008,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE SENO FRONTAL"
  },
  {
    "codigo":11784881000119101,
    "descripcion":"AMPOLLA TRAUMÁTICA DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":846677004,
    "descripcion":"INCAPAZ DE VISUALIZAR LA RETINA DEL OJO DERECHO"
  },
  {
    "codigo":289621007,
    "descripcion":"PROBLEMA UTERINO"
  },
  {
    "codigo":91178003,
    "descripcion":"DERMATITIS ALÉRGICA CAUSADA POR MORDEDURA DE CTENOCEPHALIDES CANIS"
  },
  {
    "codigo":1079831000119109,
    "descripcion":"NEVO DISPLÁSICO DE PIEL DE MIEMBRO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":342551000119109,
    "descripcion":"DERMATITIS ECCEMATOSA DE PÁRPADO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":25642007,
    "descripcion":"FISURA CONGÉNITA DEL ESTERNÓN"
  },
  {
    "codigo":255018008,
    "descripcion":"ADENOMA DE EPITELIO PIGMENTADO DE CUERPO CILIAR"
  },
  {
    "codigo":449791006,
    "descripcion":"APIÑAMIENTO DE DIENTES INFERIORES POSTERIORES"
  },
  {
    "codigo":285951008,
    "descripcion":"DIFICULTAD PARA INSERTAR Y REMOVER EL TAPÓN DE LA PILETA"
  },
  {
    "codigo":253183009,
    "descripcion":"HETEROTOPÍA OLIVAR"
  },
  {
    "codigo":218580004,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR PLASMA SANGUÍNEO"
  },
  {
    "codigo":710100004,
    "descripcion":"GRADO DE INCLINACIÓN DEL PLANO OCLUSAL CON PENDIENTE HACIA LA IZQUIERDA DEBIDO A ASIMETRÍA DENTAL"
  },
  {
    "codigo":284116007,
    "descripcion":"CAPAZ DE CONTROLAR LA POSICIÓN DE LA CINTURA ESCAPULAR"
  },
  {
    "codigo":315049003,
    "descripcion":"HEMATOMA EXTRADURAL TRAUMÁTICO CON HERIDA INTRACRANEAL ABIERTA"
  },
  {
    "codigo":249513008,
    "descripcion":"SIN DESEOS DEFECATORIOS"
  },
  {
    "codigo":446121009,
    "descripcion":"LESIÓN TRAUMÁTICA DEL BAZO POR TRACCIÓN"
  },
  {
    "codigo":51070004,
    "descripcion":"VARICOCELE"
  },
  {
    "codigo":870270005,
    "descripcion":"TRASTORNO GENERALIZADO DEL DESARROLLO CON TRASTORNO DEL DESARROLLO INTELECTUAL Y ALTERACIÓN COMPLETA DEL LENGUAJE FUNCIONAL CON PÉRDIDA DE HABILIDADES ADQUIRIDAS PREVIAMENTE"
  },
  {
    "codigo":247678005,
    "descripcion":"DELIRIO DE DESPERSONALIZACIÓN"
  },
  {
    "codigo":1163347004,
    "descripcion":"NEOPLASIA DE CAVIDAD ORAL, LABIO Y GLÁNDULA SALIVAL"
  },
  {
    "codigo":82003006,
    "descripcion":"VARIANTE DE ANEMIA POR DEFICIENCIA DE GLUCOSA-6-FOSFATO DESHIDROGENASA CLASE IV"
  },
  {
    "codigo":409683007,
    "descripcion":"HEMATÓCRITO ESTABLE"
  },
  {
    "codigo":1359955008,
    "descripcion":"HERIDA ABIERTA DE PIERNA DEBIDA A MORDEDURA DE GATO"
  },
  {
    "codigo":1259816007,
    "descripcion":"ASTROCITOMA FIBRILAR PRIMARIO DE CEREBRO"
  },
  {
    "codigo":735528007,
    "descripcion":"INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA EN ESTADIO 4 DE LA ORGANIZACIÓN MUNDIAL DE LA SALUD 2007 CONCOMITANTE CON PALUDISMO"
  },
  {
    "codigo":897533006,
    "descripcion":"AGENESIA BILATERAL DE RADIO"
  },
  {
    "codigo":209405008,
    "descripcion":"FRACTURA-SUBLUXACIÓN EXPUESTA DE LA PELVIS"
  },
  {
    "codigo":109266006,
    "descripcion":"MELANOMA IN SITU DE PIEL"
  },
  {
    "codigo":305874007,
    "descripcion":"VISTO POR EL SERVICIO DE GINECOLOGÍA"
  },
  {
    "codigo":76498008,
    "descripcion":"ESTADO POSTMENOPÁUSICO"
  },
  {
    "codigo":240338009,
    "descripcion":"INTOXICACIÓN ALIMENTARIA POR VIRUS"
  },
  {
    "codigo":205735005,
    "descripcion":"HIPOPLASIA ESPLÉNICA"
  },
  {
    "codigo":402343006,
    "descripcion":"HIPERQUERATOSIS DE RETENCIÓN"
  },
  {
    "codigo":238503007,
    "descripcion":"ENFERMEDAD POR POLIVINIL PIRROLIDONA"
  },
  {
    "codigo":1156007007,
    "descripcion":"VALPROATO DE SODIO SÉRICO POR DEBAJO DEL RANGO TERAPÉUTICO"
  },
  {
    "codigo":41895009,
    "descripcion":"DEFICIENCIA LONGITUDINAL DE HUESO DEL CARPO"
  },
  {
    "codigo":236668002,
    "descripcion":"PÉRDIDA DE ORINA DESDE VEJIGA URINARIA"
  },
  {
    "codigo":16047231000119100,
    "descripcion":"ENFERMEDAD POR DEPÓSITO DE HIDROXIAPATITA DE PIE IZQUIERDO"
  },
  {
    "codigo":365905000,
    "descripcion":"UTILIZACIÓN DE RECURSOS PARA RECUPERAR LA MEMORIA - HALLAZGO"
  },
  {
    "codigo":70993000,
    "descripcion":"CHOQUE PIRÓGENO"
  },
  {
    "codigo":300369005,
    "descripcion":"HALLAZGO RELACIONADO CON LA FLATULENCIA"
  },
  {
    "codigo":726353008,
    "descripcion":"TRISOMÍA PARCIAL DE CROMOSOMA 14"
  },
  {
    "codigo":267601009,
    "descripcion":"NEUROPATÍA INFLAMATORIA Y TÓXICA"
  },
  {
    "codigo":345061000119109,
    "descripcion":"MIOPÍA BILATERAL"
  },
  {
    "codigo":298534008,
    "descripcion":"SIN AMPLITUD DE FLEXIÓN LATERAL ACTIVA HACIA LA DERECHA DE LA COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":16538751000119104,
    "descripcion":"SENSACIÓN DE BLOQUEO DE OÍDOS BILATERAL"
  },
  {
    "codigo":1148667005,
    "descripcion":"RESPUESTA DE ELECTRORRETINOGRAMA CON ADAPTACIÓN A OSCURIDAD AUSENTE"
  },
  {
    "codigo":722683006,
    "descripcion":"CARCINOMA NEUROENDOCRINO PRIMARIO DE CUELLO UTERINO"
  },
  {
    "codigo":165627009,
    "descripcion":"FERRITINA SÉRICA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":131024003,
    "descripcion":"GONADOTROFINA HIPOFISARIA ANORMAL"
  },
  {
    "codigo":425936006,
    "descripcion":"MIGRAÑA OFTÁLMICA INTRATABLE"
  },
  {
    "codigo":260261003,
    "descripcion":"N24"
  },
  {
    "codigo":719013004,
    "descripcion":"DISCAPACIDAD INTELECTUAL LIGADA AL CROMOSOMA X TIPO CILLIERS"
  },
  {
    "codigo":293029004,
    "descripcion":"REACCIÓN ADVERSA AL METRONIDAZOL"
  },
  {
    "codigo":161957007,
    "descripcion":"ALIENTO NORMAL"
  },
  {
    "codigo":16866431000119108,
    "descripcion":"FRACTURA NO EXPUESTA DE CÓNDILO HUMERAL DERECHO"
  },
  {
    "codigo":127354003,
    "descripcion":"ALBÚMINA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":15637631000119109,
    "descripcion":"ESOTROPÍA ACOMODATIVA DE AMBOS OJOS"
  },
  {
    "codigo":29050005,
    "descripcion":"IRITIS AGUDA"
  },
  {
    "codigo":715343000,
    "descripcion":"DEFICIENCIA FAMILIAR DE ALDOSTERONA"
  },
  {
    "codigo":94586008,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE PARTES BLANDAS DE LA CABEZA"
  },
  {
    "codigo":27215002,
    "descripcion":"INVERSIÓN UTERINA"
  },
  {
    "codigo":59983003,
    "descripcion":"EVALUACIÓN DE DISCAPACIDAD: 80%"
  },
  {
    "codigo":291194008,
    "descripcion":"INTOXICACIÓN POR PERFENAZINA"
  },
  {
    "codigo":289359005,
    "descripcion":"CABEZA FETAL FLEXIONADA"
  },
  {
    "codigo":225658008,
    "descripcion":"HUMOR ESTABLE"
  },
  {
    "codigo":92751007,
    "descripcion":"CARCINOMA IN SITU DEL PALADAR BLANDO"
  },
  {
    "codigo":25380002,
    "descripcion":"PERICARDITIS SECUNDARIA A LUPUS ERITEMATOSO SISTÉMICO"
  },
  {
    "codigo":713508003,
    "descripcion":"ANEMIA APLÁSICA CONCOMITANTE CON INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":292121000119106,
    "descripcion":"TRASTORNO DE NERVIO PERONEO SUPERFICIAL DERECHO"
  },
  {
    "codigo":254756007,
    "descripcion":"XANTOMA VERRUCIFORME CUTÁNEO"
  },
  {
    "codigo":56313000,
    "descripcion":"PLACENTA ANORMAL QUE AFECTA EL MANEJO DE LA SITUACIÓN MATERNA"
  },
  {
    "codigo":285689000,
    "descripcion":"CAPAZ DE CARGAR PESO EN LA PIERNA IZQUIERDA"
  },
  {
    "codigo":449529003,
    "descripcion":"ANOMALÍA DE CÚSPIDE DE VÁLVULA PULMONAR"
  },
  {
    "codigo":1332430000,
    "descripcion":"HISTIOCITOSIS DE CÉLULAS DE LANGERHANS DISEMINADA DE GANGLIOS LINFÁTICOS DE PELVIS"
  },
  {
    "codigo":283854002,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO EN LA NARIZ"
  },
  {
    "codigo":413091002,
    "descripcion":"EL PACIENTE REHÚSA COPIA DE CARTA DE DERIVACIÓN"
  },
  {
    "codigo":216483006,
    "descripcion":"INTOXICACIÓN ACCIDENTAL CAUSADA POR ANTIRREUMÁTICOS"
  },
  {
    "codigo":183715006,
    "descripcion":"CONSULTA DOMICILIARIA GERIÁTRICA SOLICITADA"
  },
  {
    "codigo":118179008,
    "descripcion":"HALLAZGO RELACIONADO CON LA SECRECIÓN PLACENTARIA DE GONADOTROFINA CORIÓNICA"
  },
  {
    "codigo":18040001,
    "descripcion":"OSTEOPOROSIS SENIL"
  },
  {
    "codigo":50808002,
    "descripcion":"ATEROMA ARTERIAL"
  },
  {
    "codigo":444024002,
    "descripcion":"ATROFIA MULTISISTÉMICA, VARIANTE CEREBELOSA"
  },
  {
    "codigo":312952004,
    "descripcion":"CRISIS DE HIPOTONÍA"
  },
  {
    "codigo":1084851000119106,
    "descripcion":"COLANGITIS CRÓNICA REAGUDIZADA DEBIDA A CÁLCULO DE VÍA BILIAR"
  },
  {
    "codigo":1363363009,
    "descripcion":"HIPERINSULINISMO FOCAL RESISTENTE A DIAZÓXIDO"
  },
  {
    "codigo":52643007,
    "descripcion":"BALANITIS POR CANDIDA"
  },
  {
    "codigo":1197688004,
    "descripcion":"ÚLCERA DUODENAL DEBIDA A VASCULITIS POR IGA (INMUNOGLOBULINA A)"
  },
  {
    "codigo":704333004,
    "descripcion":"FRACTURA OSTEOPORÓTICA DE MANO"
  },
  {
    "codigo":81741005,
    "descripcion":"AUTOXIDACIÓN AUMENTADA"
  },
  {
    "codigo":1163085006,
    "descripcion":"DACRIOADENITIS POR CHLAMYDIA TRACHOMATIS"
  },
  {
    "codigo":212813006,
    "descripcion":"ALCOHOL ISOPROPÍLICO QUE OCASIONA EFECTO TÓXICO"
  },
  {
    "codigo":1259554001,
    "descripcion":"ENCEFALOPATÍA ANÓXICA DEBIDA A PARO RESPIRATORIO"
  },
  {
    "codigo":276514007,
    "descripcion":"INSUFICIENCIA CARDÍACA NEONATAL"
  },
  {
    "codigo":274679000,
    "descripcion":"HALLAZGO MICROBIOLÓGICO ANORMAL EN LÍQUIDO CEFALORRAQUÍDEO"
  },
  {
    "codigo":209143002,
    "descripcion":"SUBLUXACIÓN NO EXPUESTA ENTRE LA SÉPTIMA VÉRTEBRA CERVICAL Y LA PRIMERA VÉRTEBRA DORSAL"
  },
  {
    "codigo":176375003,
    "descripcion":"ACTIVIDAD HORMONAL"
  },
  {
    "codigo":241911003,
    "descripcion":"EFECTO TÓXICO CAUSADO POR TINTURA PARA CALZADO"
  },
  {
    "codigo":372983003,
    "descripcion":"INFECCIÓN CAUSADA POR ASPERGILLUS FLAVIPES"
  },
  {
    "codigo":471287006,
    "descripcion":"ORIGEN ANÓMALO DE ARTERIA CORONARIA IZQUIERDA Y ARTERIA CORONARIA DERECHA CON ORIFICIOS DOBLES EN SENO AÓRTICO A LA IZQUIERDA DE SENO AÓRTICO NO ENFRENTADO"
  },
  {
    "codigo":78071008,
    "descripcion":"HIDROMICROCEFALIA"
  },
  {
    "codigo":305612001,
    "descripcion":"BAJO ATENCIÓN DE ESPECIALISTA EN ADAPTACIÓN QUIRÚRGICA"
  },
  {
    "codigo":403916003,
    "descripcion":"CARCINOMA BASOCELULAR DE LA FRENTE"
  },
  {
    "codigo":43468004,
    "descripcion":"DEFECTO EN EL LLENADO"
  },
  {
    "codigo":76236006,
    "descripcion":"TRASTORNO DE TICS ATÍPICOS"
  },
  {
    "codigo":240076008,
    "descripcion":"DISTROFIA MUSCULAR ESCAPULOHUMERAL BENIGNA"
  },
  {
    "codigo":762529004,
    "descripcion":"SEPSIS CAUSADA POR ACINETOBACTER BAUMANNII"
  },
  {
    "codigo":860833006,
    "descripcion":"INFECCIÓN CAUSADA POR GNATHOSTOMA HISPIDUM"
  },
  {
    "codigo":205473008,
    "descripcion":"DISPLASIA MESOMÉLICA"
  },
  {
    "codigo":301942005,
    "descripcion":"HALLAZGO RELACIONADO CON LAS PROPORCIONES PUPILARES"
  },
  {
    "codigo":236406007,
    "descripcion":"NEFROPATÍA RELACIONADA CON EL SÍNDROME DE INMUNODEFICIENCIA ADQUIRIDA"
  },
  {
    "codigo":365643000,
    "descripcion":"HALLAZGO RELACIONADO CON EL TIPO DE ANTÍGENO RH"
  },
  {
    "codigo":234571003,
    "descripcion":"VERRUGAS, HIPOGAMMAGLOBULINEMIA, INFECCIONES Y MIELOCATEXIS"
  },
  {
    "codigo":300107003,
    "descripcion":"DOLOR AL MOVER EL PABELLÓN AURICULAR"
  },
  {
    "codigo":70731005,
    "descripcion":"ACIDEMIA"
  },
  {
    "codigo":298272002,
    "descripcion":"HALLAZGO RELACIONADO CON LA APARIENCIA DEL MÚSCULO ESQUELÉTICO"
  },
  {
    "codigo":427509002,
    "descripcion":"FRACTURA NO EXPUESTA DE SALTER-HARRIS TIPO I DE EPÍFISIS DISTAL DE FÉMUR"
  },
  {
    "codigo":1525003,
    "descripcion":"AMPOLLA DEL PIE, SIN INFECCIÓN"
  },
  {
    "codigo":198133008,
    "descripcion":"PERIOOFORITIS AGUDA"
  },
  {
    "codigo":196298000,
    "descripcion":"CARIES DENTAL AGUDA EN LA DENTINA"
  },
  {
    "codigo":720586000,
    "descripcion":"ENSANCHAMIENTO ÓSEO EN LOS EXTREMOS"
  },
  {
    "codigo":296437009,
    "descripcion":"SOBREDOSIS DE XANTINA"
  },
  {
    "codigo":294602004,
    "descripcion":"ALERGIA A DILOXANIDA"
  },
  {
    "codigo":718751000,
    "descripcion":"TRASTORNO CONGÉNITO DE LA GLICOSILACIÓN POR ALTERACIÓN DE COG4"
  },
  {
    "codigo":30623001,
    "descripcion":"ATRAPAMIENTO"
  },
  {
    "codigo":423839002,
    "descripcion":"RECURSOS COMUNITARIOS NO DISPONIBLES"
  },
  {
    "codigo":292767004,
    "descripcion":"REACCIÓN ADVERSA A PREPARADOS TÓPICOS CIRCULATORIOS"
  },
  {
    "codigo":63391007,
    "descripcion":"DIMELIA CUBITAL"
  },
  {
    "codigo":389236000,
    "descripcion":"DISPLASIA OSTEOESCLERÓTICA NEONATAL"
  },
  {
    "codigo":391071009,
    "descripcion":"RESULTADO DE ABSORCIOMETRÍA DUAL POR RAYOS X DE HUESO DE REGIÓN DE ARTICULACIÓN DE CADERA, OSTEOPENIA"
  },
  {
    "codigo":290932002,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR BECLAMIDA"
  },
  {
    "codigo":127092007,
    "descripcion":"LINFADENOPATÍA PRELARÍNGEA"
  },
  {
    "codigo":61556008,
    "descripcion":"TIROIDITIS IATROGÉNICA"
  },
  {
    "codigo":94324007,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA BÓVEDA DEL PALADAR"
  },
  {
    "codigo":715081002,
    "descripcion":"CAPAZ DE PASAR DE UNA SILLA A UNA SILLA DE RUEDAS"
  },
  {
    "codigo":323611000119101,
    "descripcion":"TUMOR TENOSINOVIAL DIFUSO DE CÉLULAS GIGANTES DE ARTICULACIÓN DE CADERA IZQUIERDA"
  },
  {
    "codigo":92489003,
    "descripcion":"CENTRO CARTILAGINOSO DE VÉRTEBRA CERVICAL HENDIDO"
  },
  {
    "codigo":289097003,
    "descripcion":"INCAPAZ DE RESPIRAR PROFUNDAMENTE"
  },
  {
    "codigo":59721007,
    "descripcion":"PÉNFIGO SIFILÍTICO CONGÉNITO"
  },
  {
    "codigo":420169008,
    "descripcion":"EXPRESA VERBALMENTE LA RUTINA PARA LA ADMINISTRACIÓN DE MEDICACIÓN"
  },
  {
    "codigo":90654004,
    "descripcion":"ESGUINCE DE LIGAMENTO ILIOFEMORAL"
  },
  {
    "codigo":57886004,
    "descripcion":"DIABETES MELLITUS CON DEFICIENCIA DE PROTEÍNAS"
  },
  {
    "codigo":449267001,
    "descripcion":"SARCOMA DE MANDÍBULA"
  },
  {
    "codigo":416499003,
    "descripcion":"DEFORMACIÓN DE TEJIDO"
  },
  {
    "codigo":1268467008,
    "descripcion":"PÉRDIDA DE AUDICIÓN CONDUCTIVA DE BAJA FRECUENCIA"
  },
  {
    "codigo":56051008,
    "descripcion":"CETOACIDOSIS"
  },
  {
    "codigo":185288004,
    "descripcion":"ATENDIDO POR CONSEJERO"
  },
  {
    "codigo":204808002,
    "descripcion":"QUISTE PANCREÁTICO CONGÉNITO"
  },
  {
    "codigo":447432006,
    "descripcion":"HIPERPLASIA FOVEOLAR FOCAL"
  },
  {
    "codigo":1332168006,
    "descripcion":"ÚLCERA VENOSA DE MUSLO"
  },
  {
    "codigo":609437000,
    "descripcion":"ESPECTRO DEL TRASTORNO DE ALCOHOLISMO FETAL"
  },
  {
    "codigo":1363101000,
    "descripcion":"ASTILLA EN ESCROTO Y TESTÍCULO"
  },
  {
    "codigo":283592009,
    "descripcion":"HERIDA DE PERDIGÓN EN DORSO DEL PIE"
  },
  {
    "codigo":871581001,
    "descripcion":"DEFECTO DEL TABIQUE INTERVENTRICULAR MUSCULAR EN LA PORCIÓN TRABECULAR INFERIOR"
  },
  {
    "codigo":85149007,
    "descripcion":"QUERATOMALACIA"
  },
  {
    "codigo":443762000,
    "descripcion":"CARDIOMEGALIA HIPERTRÓFICA"
  },
  {
    "codigo":771442003,
    "descripcion":"SÍNDROME DE OGDEN"
  },
  {
    "codigo":247154004,
    "descripcion":"DRUSA MACULAR"
  },
  {
    "codigo":279922007,
    "descripcion":"PARAÓFORO"
  },
  {
    "codigo":48711000,
    "descripcion":"INFESTACIÓN CAUSADA POR HIPPOBOSCIDAE"
  },
  {
    "codigo":212551001,
    "descripcion":"INTOXICACIÓN POR YODURO"
  },
  {
    "codigo":81479001,
    "descripcion":"SEGMENTACIÓN MACROMOLECULAR"
  },
  {
    "codigo":310855005,
    "descripcion":"INFORME DE VIVIENDA SOLICITADO"
  },
  {
    "codigo":1162823005,
    "descripcion":"SOBREDOSIS DE VITAMINA D Y\/O DERIVADO DE VITAMINA D"
  },
  {
    "codigo":440092001,
    "descripcion":"SÍNDROME DE DEFICIENCIA CONGÉNITA ENDÉMICA DE YODO, DE TIPO MIXEDEMATOSO"
  },
  {
    "codigo":278087009,
    "descripcion":"CURVA SACRA CÓNCAVA"
  },
  {
    "codigo":46876003,
    "descripcion":"CELULITIS DEL TRONCO"
  },
  {
    "codigo":866076001,
    "descripcion":"INFECCIÓN DE MAMA EN RECIÉN NACIDO CAUSADA POR STREPTOCOCCUS"
  },
  {
    "codigo":210716001,
    "descripcion":"SECCIÓN TOTAL, TENDÓN DEL MÚSCULO FLEXOR DEL PIE"
  },
  {
    "codigo":276252007,
    "descripcion":"PATRÓN DE INTERFERENCIA DE ALTA AMPLITUD REDUCIDO CON ACTIVIDAD ESPONTÁNEA ANORMAL EN EL ELECTROMIOGRAMA"
  },
  {
    "codigo":309020008,
    "descripcion":"ESTADO DE CERTIFICACIÓN JUDICIAL PENAL DE INDEMNIZACIÓN POR LESIONES"
  },
  {
    "codigo":208881002,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA DEL PULGAR"
  },
  {
    "codigo":733169006,
    "descripcion":"ASPERGILOSIS INVASIVA DEL TRACTO DIGESTIVO"
  },
  {
    "codigo":272582000,
    "descripcion":"SUSPENDIDO BOCA ABAJO"
  },
  {
    "codigo":12273009,
    "descripcion":"MOVIMIENTO OCULAR ANORMAL NO RÍTMICO"
  },
  {
    "codigo":403654000,
    "descripcion":"ATROFIA CUTÁNEA CAUSADA POR CORTICOSTEROIDE SISTÉMICO"
  },
  {
    "codigo":239814006,
    "descripcion":"ARTRITIS SERONEGATIVA SECUNDARIA A ENFERMEDAD INTESTINAL INFLAMATORIA"
  },
  {
    "codigo":1255622006,
    "descripcion":"ESTENOSIS DE SEGMENTO MEDIO DE TRONCO DE ARTERIA CORONARIA IZQUIERDA"
  },
  {
    "codigo":205211001,
    "descripcion":"DEFICIENCIA PROXIMAL FEMORAL FOCAL"
  },
  {
    "codigo":237979002,
    "descripcion":"TRASTORNO DEL METABOLISMO DE GLICERATO"
  },
  {
    "codigo":74139005,
    "descripcion":"ESTADIO L1"
  },
  {
    "codigo":203376002,
    "descripcion":"DESPLAZAMIENTO CRÓNICO NO TRAUMÁTICO DE LA EPÍFISIS FEMORAL SUPERIOR"
  },
  {
    "codigo":365381001,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA CUIDAR UNA MASCOTA"
  },
  {
    "codigo":267077006,
    "descripcion":"PÉRDIDA DE LA AUTOESTIMA"
  },
  {
    "codigo":299845007,
    "descripcion":"REFLEJO MIOTÁTICO DE DEDO DE LA MANO: NORMAL"
  },
  {
    "codigo":201541008,
    "descripcion":"ARTROPATÍA ASOCIADA CON MICOSIS, DE MÚLTIPLES LOCALIZACIONES"
  },
  {
    "codigo":166938002,
    "descripcion":"NIVEL TERAPÉUTICO DE FENOBARBITAL"
  },
  {
    "codigo":723994004,
    "descripcion":"CONVULSIONES Y DISCAPACIDAD INTELECTUAL DEBIDAS A HIDROXILISINURIA"
  },
  {
    "codigo":3098007,
    "descripcion":"RUPTURA DEL TABIQUE INTERVENTRICULAR"
  },
  {
    "codigo":298010008,
    "descripcion":"HERIDA SUCIA"
  },
  {
    "codigo":197871001,
    "descripcion":"VEJIGA URINARIA HIPOTÓNICA"
  },
  {
    "codigo":296175004,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE TETRABENAZINA"
  },
  {
    "codigo":230639006,
    "descripcion":"COMPRESIÓN DEL NERVIO OBTURADOR"
  },
  {
    "codigo":64964006,
    "descripcion":"HIPERSONORIDAD"
  },
  {
    "codigo":30361005,
    "descripcion":"MONOSOMÍA PARCIAL 1Q"
  },
  {
    "codigo":961739241000119108,
    "descripcion":"RETINOPATÍA PROLIFERATIVA DE OJO DERECHO DEBIDA A ANEMIA DREPANOCÍTICA"
  },
  {
    "codigo":299651000119102,
    "descripcion":"QUISTE ÓSEO SOLITARIO DE REGIÓN DE ARTICULACIÓN DE TOBILLO"
  },
  {
    "codigo":718489009,
    "descripcion":"CAPAZ DE UTILIZAR LA PRAGMÁTICA EN LA COMUNICACIÓN"
  },
  {
    "codigo":95897009,
    "descripcion":"HEPATITIS AMEBIANA"
  },
  {
    "codigo":94062002,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE PARTES BLANDAS DEL TÓRAX"
  },
  {
    "codigo":290670000,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR IDARUBICINA"
  },
  {
    "codigo":292505007,
    "descripcion":"REACCIÓN ADVERSA A LA DOBUTAMINA"
  },
  {
    "codigo":61294007,
    "descripcion":"DELGADEZ"
  },
  {
    "codigo":126830007,
    "descripcion":"NEOPLASIA DEL ANTRO PILÓRICO"
  },
  {
    "codigo":714819001,
    "descripcion":"HEMATURIA RECURRENTE CONCOMITANTE CON GLOMERULONEFRITIS MESANGIOCAPILAR DIFUSA Y DEBIDA A ELLA"
  },
  {
    "codigo":92227001,
    "descripcion":"NEOPLASIA BENIGNA DE MÚSCULO DE LA CADERA"
  },
  {
    "codigo":319768000,
    "descripcion":"TRASTORNO DEPRESIVO MAYOR RECURRENTE CON CARACTERÍSTICAS MELANCÓLICAS"
  },
  {
    "codigo":418072004,
    "descripcion":"DEPRESIÓN DEL SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":287000004,
    "descripcion":"CELULITIS DE LA MANO, EXCEPTO EN EL ÁREA DE LOS DEDOS"
  },
  {
    "codigo":1237272007,
    "descripcion":"HIPERCALCEMIA CAUSADA POR TIAZIDA Y\/O RETINOL"
  },
  {
    "codigo":90392009,
    "descripcion":"ESPASMO MUSCULAR NOCTURNO"
  },
  {
    "codigo":449005003,
    "descripcion":"AUSENCIA DE CUERDAS TENDINOSAS DE VÁLVULA MITRAL"
  },
  {
    "codigo":23021006,
    "descripcion":"AMPOLLA DEL PERINEO, CON INFECCIÓN"
  },
  {
    "codigo":186861006,
    "descripcion":"RECIDIVA DE SÍFILIS SECUNDARIA"
  },
  {
    "codigo":283330004,
    "descripcion":"PICADURA DE INSECTO EN LAS EXTREMIDADES SUPERIORES"
  },
  {
    "codigo":21186006,
    "descripcion":"OTITIS MEDIA CRÓNICA"
  },
  {
    "codigo":19351000,
    "descripcion":"GLOMERULONEFRITIS AGUDA"
  },
  {
    "codigo":53954009,
    "descripcion":"GASTROENTEROPATÍA EOSINOFÍLICA CON PREDOMINIO DE ENFERMEDAD DE LA SUBSEROSA"
  },
  {
    "codigo":1297303002,
    "descripcion":"CIERRE DE ÁNGULO AGUDO SECUNDARIO DE OJO DERECHO"
  },
  {
    "codigo":281495004,
    "descripcion":"DEFORMIDAD ADQUIRIDA EN VALGO DE ARTICULACIÓN DE MIEMBRO INFERIOR"
  },
  {
    "codigo":248727005,
    "descripcion":"HALLAZGO VENOSO"
  },
  {
    "codigo":707479004,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE SUBGLOTIS"
  },
  {
    "codigo":838551007,
    "descripcion":"DERMATITIS AUTOINMUNITARIA POR PROGESTERONA"
  },
  {
    "codigo":445335008,
    "descripcion":"TENDINITIS DEL EXTENSOR DEL DEDO ÍNDICE"
  },
  {
    "codigo":312428002,
    "descripcion":"INFECCIÓN DE LA CÓRNEA"
  },
  {
    "codigo":83052004,
    "descripcion":"MIASIS CUTÁNEA POR GUSANO BARRENADOR"
  },
  {
    "codigo":771180005,
    "descripcion":"SÍNDROME DE DEFORMIDAD EN VARO DEL DEDO GORDO-POLISINDACTILIA PREAXIAL"
  },
  {
    "codigo":246892006,
    "descripcion":"ENGROSAMIENTO DE LA CONJUNTIVA DEL LIMBO"
  },
  {
    "codigo":48449000,
    "descripcion":"MACRODACTILIA CONGÉNITA"
  },
  {
    "codigo":277825000,
    "descripcion":"ANSIEDAD ACERCA DE TEMBLAR"
  },
  {
    "codigo":1162561004,
    "descripcion":"TINCIÓN DE DIENTES"
  },
  {
    "codigo":212289005,
    "descripcion":"CONTUSIÓN, NERVIO SUPRACLAVICULAR"
  },
  {
    "codigo":116271901000119108,
    "descripcion":"DOLOR ÓSEO CAUSADO POR FACTOR ESTIMULANTE DE COLONIA DE GRANULOCITOS"
  },
  {
    "codigo":210454002,
    "descripcion":"HERIDA ABIERTA EN LA MAMA"
  },
  {
    "codigo":308758008,
    "descripcion":"APLASTAMIENTO DE VÉRTEBRA LUMBAR"
  },
  {
    "codigo":110315000,
    "descripcion":"ALTURA DE CORONA CLÍNICAMENTE INSUFICIENTE POR CARIES DENTAL"
  },
  {
    "codigo":44779003,
    "descripcion":"TRASTORNO DEL METABOLISMO DE LOS AMINOÁCIDOS"
  },
  {
    "codigo":306923007,
    "descripcion":"YUNQUE FIJO"
  },
  {
    "codigo":77547008,
    "descripcion":"DEGENERACIÓN DE DISCO INTERVERTEBRAL"
  },
  {
    "codigo":12011009,
    "descripcion":"FÍSTULA DEL APARATO GENITOURINARIO FEMENINO"
  },
  {
    "codigo":75712001,
    "descripcion":"COCCIDIOSIS RENAL"
  },
  {
    "codigo":208619007,
    "descripcion":"FRACTURA EXPUESTA DE TIBIA PROXIMAL, CÓNDILO INTERNO (MESETA)"
  },
  {
    "codigo":403392005,
    "descripcion":"ESTRÍAS DE LOS LEVANTADORES DE PESAS"
  },
  {
    "codigo":42944009,
    "descripcion":"DEGENERACIÓN DE CARTÍLAGO SEMILUNAR INTERNO"
  },
  {
    "codigo":204949001,
    "descripcion":"DISPLASIA RENAL"
  },
  {
    "codigo":237717004,
    "descripcion":"QUISTE ARACNOIDEO DE LA GLÁNDULA HIPÓFISIS"
  },
  {
    "codigo":73877009,
    "descripcion":"GOTA TOFÁCEA CRÓNICA"
  },
  {
    "codigo":72042002,
    "descripcion":"INCONTINENCIA FECAL"
  },
  {
    "codigo":268650001,
    "descripcion":"DISFUNCIÓN AUTÓNOMA SOMATOMORFA DE TRACTO GASTROINTESTINAL"
  },
  {
    "codigo":301418002,
    "descripcion":"DOLOR A LA DESCOMPRESIÓN EN HIPOGASTRIO"
  },
  {
    "codigo":1153386003,
    "descripcion":"NEOPLASIA DE ESTROMA GASTROINTESTINAL DE CARDIAS DEL ESTÓMAGO"
  },
  {
    "codigo":234047000,
    "descripcion":"TROMBOFLEBITIS POR RADIACIÓN"
  },
  {
    "codigo":37439003,
    "descripcion":"PERFORACIÓN DE VÍA BILIAR"
  },
  {
    "codigo":201279004,
    "descripcion":"CLOASMA TRAUMÁTICO"
  },
  {
    "codigo":365119004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA SUBIR Y BAJAR ESCALERAS DE ESPALDAS"
  },
  {
    "codigo":232212002,
    "descripcion":"ABSCESO DE OÍDO EXTERNO"
  },
  {
    "codigo":2836004,
    "descripcion":"EFECTO TÓXICO CAUSADO POR BUTANO"
  },
  {
    "codigo":68372009,
    "descripcion":"OBSTRUCCIÓN DE VÍAS AÉREAS SUPERIORES"
  },
  {
    "codigo":263145006,
    "descripcion":"SECCIÓN TRAUMÁTICA DE LIGAMENTO DEL PULGAR"
  },
  {
    "codigo":787433006,
    "descripcion":"METABOLIZADOR RÁPIDO DE LA FAMILIA 2 SUBFAMILIA D MIEMBRO 6 DEL CITOCROMO P450"
  },
  {
    "codigo":328681008,
    "descripcion":"AFASIA MOTORA"
  },
  {
    "codigo":230377009,
    "descripcion":"MIELINÓLISIS EXTRAPONTINA"
  },
  {
    "codigo":15703121000119108,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE TENDONES FLEXORES DE AMBOS PIES"
  },
  {
    "codigo":294078003,
    "descripcion":"ALERGIA A BENZATROPINA"
  },
  {
    "codigo":161171000,
    "descripcion":"ÍNDICE DE MORBILIDAD ALTO"
  },
  {
    "codigo":128403000,
    "descripcion":"CARDIOPATÍA INFECCIOSA"
  },
  {
    "codigo":423315002,
    "descripcion":"CONTACTO SOCIAL LIMITADO"
  },
  {
    "codigo":95635002,
    "descripcion":"ABSTINENCIA DE CAFEÍNA"
  },
  {
    "codigo":45061000087102,
    "descripcion":"NEOPLASIA MALIGNA DE MAMA EN REMISIÓN"
  },
  {
    "codigo":42501000087103,
    "descripcion":"HERIDA DE TRONCO POR MORDEDURA"
  },
  {
    "codigo":292243006,
    "descripcion":"REACCIÓN ADVERSA AL PACLITAXEL"
  },
  {
    "codigo":718227006,
    "descripcion":"SÍNDROME DE MICRODELECIÓN DE 16P11.2 PROXIMAL"
  },
  {
    "codigo":716392002,
    "descripcion":"CAPAZ DE POSTULARSE PARA UN CURSO DE EDUCACIÓN"
  },
  {
    "codigo":126568001,
    "descripcion":"NEOPLASIA DE HUESO LARGO DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":39941000087103,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE GLÚTEO IZQUIERDO"
  },
  {
    "codigo":290408003,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR CISAPRIDA"
  },
  {
    "codigo":93800004,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL PRIMER HUESO CUNEIFORME DEL TARSO"
  },
  {
    "codigo":124733001,
    "descripcion":"CLIMATERIO MASCULINO TARDÍO"
  },
  {
    "codigo":419645003,
    "descripcion":"NEOPLASIA BENIGNA DE LA CAVIDAD BUCAL"
  },
  {
    "codigo":91965004,
    "descripcion":"NEOPLASIA BENIGNA DE LOS ANEXOS EPIDÉRMICOS"
  },
  {
    "codigo":26429006,
    "descripcion":"ALTERACIÓN SENSITIVA - PERCEPTIVA: EXCESO DE ENTRADA"
  },
  {
    "codigo":714557009,
    "descripcion":"SE ADAPTA DESPUÉS DE UNA CRISIS PERSONAL"
  },
  {
    "codigo":712722007,
    "descripcion":"MALFORMACIÓN VASCULAR DE DUODENO DE DIEULAFOY"
  },
  {
    "codigo":448743001,
    "descripcion":"ANOMALÍA DE VÁLVULA AÓRTICA"
  },
  {
    "codigo":284903008,
    "descripcion":"NO REALIZA ACTIVIDADES DE HIGIENE"
  },
  {
    "codigo":219367009,
    "descripcion":"LESIÓN OCASIONADA POR OPERACIONES BÉLICAS"
  },
  {
    "codigo":85381000119105,
    "descripcion":"GLOMERULONEFRITIS DEBIDA A PÚRPURA DE HENOCH-SCHÖNLEIN"
  },
  {
    "codigo":283068008,
    "descripcion":"ARAÑAZO DE LA FRENTE"
  },
  {
    "codigo":84625002,
    "descripcion":"DERMATOSIS NEUTRÓFILA FEBRIL AGUDA"
  },
  {
    "codigo":1297041003,
    "descripcion":"ENOSTOSIS DE HÚMERO"
  },
  {
    "codigo":248465002,
    "descripcion":"TOLERANTE AL FRÍO"
  },
  {
    "codigo":215697004,
    "descripcion":"LESIÓN SUFRIDA A BORDO DE MEDIO DE TRANSPORTE ACUÁTICO CAUSADA POR MAQUINARIA DE SALA DE MÁQUINAS"
  },
  {
    "codigo":331141000119107,
    "descripcion":"CATARATA TOTAL TRAUMÁTICA BILATERAL"
  },
  {
    "codigo":246630002,
    "descripcion":"VISIÓN EXCÉNTRICA"
  },
  {
    "codigo":410470003,
    "descripcion":"RETINITIS SIFILÍTICA"
  },
  {
    "codigo":1196902006,
    "descripcion":"GLIOMA CEREBRAL ANGIOCÉNTRICO"
  },
  {
    "codigo":10626591000119104,
    "descripcion":"CARBUNCO DE MANO DERECHA"
  },
  {
    "codigo":48187004,
    "descripcion":"FRACTURA EXPUESTA DE TOBILLO"
  },
  {
    "codigo":277563003,
    "descripcion":"OCLUSIÓN BUCAL POSTERIOR DE DIENTES INFERIORES"
  },
  {
    "codigo":1162299007,
    "descripcion":"INFECCIÓN VIRAL DE VAINA TENDINOSA"
  },
  {
    "codigo":15419008,
    "descripcion":"MEMBRANA PILÓRICA CONGÉNITA"
  },
  {
    "codigo":736315009,
    "descripcion":"TRASTORNO DISOCIATIVO CON SÍNTOMA NEUROLÓGICO CONCOMITANTE CON ALTERACIÓN DE LA CONSCIENCIA"
  },
  {
    "codigo":79120002,
    "descripcion":"ELEVACIÓN CONGÉNITA DEL OMÓPLATO"
  },
  {
    "codigo":275728009,
    "descripcion":"AUDIOMETRÍA NORMAL"
  },
  {
    "codigo":110053001,
    "descripcion":"LACERACIÓN SIMPLE CONTAMINADA DE LA REGIÓN PERIORAL DE LA CARA"
  },
  {
    "codigo":10708511000119108,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE ÚTERO"
  },
  {
    "codigo":77285007,
    "descripcion":"INFARTO PLACENTARIO QUE AFECTA EL MANEJO DE LA SITUACIÓN MATERNA"
  },
  {
    "codigo":1156794004,
    "descripcion":"DESEQUILIBRIO CINEMÁTICO DEBIDO A TENSIÓN SUBOCCIPITAL"
  },
  {
    "codigo":9914004,
    "descripcion":"DILATACIÓN TÓXICA DEL INTESTINO"
  },
  {
    "codigo":698042007,
    "descripcion":"MELANOMA MALIGNO DE LENGUA"
  },
  {
    "codigo":403130009,
    "descripcion":"URTICARIA POR ESTRONGILOIDES"
  },
  {
    "codigo":204687007,
    "descripcion":"DIVERTÍCULO DE MECKEL DESPLAZADO"
  },
  {
    "codigo":237455008,
    "descripcion":"MASTALGIA A PARTIR DE PUNTO GATILLO"
  },
  {
    "codigo":366692003,
    "descripcion":"AMPLITUD DE MOVIMIENTO ACTIVO DE EXTENSIÓN DEL PULGAR - HALLAZGO"
  },
  {
    "codigo":235620004,
    "descripcion":"ESTENOSIS DE ESÓFAGO CAUSADA POR RADIACIÓN"
  },
  {
    "codigo":1251428005,
    "descripcion":"DERMATITIS ALÉRGICA DE CONTACTO DE PIEL DE PIE"
  },
  {
    "codigo":301156006,
    "descripcion":"PULSO CUBITAL PRESENTE"
  },
  {
    "codigo":299321000,
    "descripcion":"HALLAZGO RELACIONADO CON ARTICULACIÓN DE RODILLA"
  },
  {
    "codigo":233785003,
    "descripcion":"TRASTORNO INFECCIOSO DE LA TRÁQUEA"
  },
  {
    "codigo":201017004,
    "descripcion":"PRURIGO MITIS"
  },
  {
    "codigo":364857005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA TREPAR"
  },
  {
    "codigo":4409006,
    "descripcion":"DEFECTO DE LA SÍNTESIS DE ADENOSILCOBALAMINA Y METILCOBALAMINA"
  },
  {
    "codigo":168249008,
    "descripcion":"HALLAZGO DE INOCULACIÓN ANIMAL: MICROORGANISMO"
  },
  {
    "codigo":231950001,
    "descripcion":"LESIÓN DE IRIS Y CUERPO CILIAR"
  },
  {
    "codigo":363022002,
    "descripcion":"COMPLICACIÓN DE PROCEDIMIENTO DE TRACCIÓN"
  },
  {
    "codigo":461326001,
    "descripcion":"ORÍGENES ANÓMALOS SEPARADOS DE ARTERIAS CARÓTIDA INTERNA Y EXTERNA EN CAYADO AÓRTICO ÚNICO"
  },
  {
    "codigo":789006005,
    "descripcion":"PERITONITIS CAUSADA POR SALMONELLA TYPHI"
  },
  {
    "codigo":333651000119103,
    "descripcion":"EPIESCLERITIS NODULAR DE OJO DERECHO"
  },
  {
    "codigo":262883002,
    "descripcion":"CONTUSIÓN DE MESENTERIO"
  },
  {
    "codigo":197347003,
    "descripcion":"HEPATITIS EN SÍFILIS TARDÍA"
  },
  {
    "codigo":721635005,
    "descripcion":"NEOPLASIA NEUROENDOCRINA MALIGNA PRIMARIA DE CARDIAS GÁSTRICO"
  },
  {
    "codigo":787171006,
    "descripcion":"SÍNDROME DE MICRODELECIÓN 21Q22.11Q22.12"
  },
  {
    "codigo":295651008,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE LOMUSTINA"
  },
  {
    "codigo":228280001,
    "descripcion":"BEBEDOR A ESCONDIDAS"
  },
  {
    "codigo":451421000124102,
    "descripcion":"TRASTORNO DE EXTREMIDAD INFERIOR DERECHA"
  },
  {
    "codigo":424888007,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA ELIMINAR LOS ALIMENTOS EN CONDICIONES HIGIÉNICAS"
  },
  {
    "codigo":719800009,
    "descripcion":"SÍNDROME DE SORDERA, ONICODISTROFIA, OSTEODISTROFIA Y DISCAPACIDAD INTELECTUAL"
  },
  {
    "codigo":423053003,
    "descripcion":"ESTADO DE DESEMPEÑO ECOG - GRADO 3"
  },
  {
    "codigo":95373005,
    "descripcion":"ANESTESIA EN EL SITIO DE APLICACIÓN"
  },
  {
    "codigo":453981000124109,
    "descripcion":"FRACTURA DE HUESO DE MIEMBRO INFERIOR IZQUIERDO"
  },
  {
    "codigo":291981007,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ACETAZOLAMIDA"
  },
  {
    "codigo":11857901000119102,
    "descripcion":"RUPTURA TRAUMÁTICA DE TENDÓN ROTULIANO DERECHO"
  },
  {
    "codigo":1142114001,
    "descripcion":"TAQUICARDIA AURICULAR DE MACRORREENTRADA NO DEPENDIENTE DE ISTMO CAVOTRICUSPÍDEO DE AURÍCULA DERECHA MEDIADA POR CICATRIZ"
  },
  {
    "codigo":160909006,
    "descripcion":"AMBIENTE LABORAL PERJUDICIAL"
  },
  {
    "codigo":10901331000119109,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO FACIAL DERECHO"
  },
  {
    "codigo":879970005,
    "descripcion":"CON MAYOR RIESGO DE ERROR EN MEDICACIÓN"
  },
  {
    "codigo":15953901000119103,
    "descripcion":"INDURACIÓN DE MAMA DERECHA"
  },
  {
    "codigo":58935006,
    "descripcion":"LESIÓN TRAUMÁTICA DE ESTÓMAGO SIN HERIDA ABIERTA HACIA CAVIDAD ABDOMINAL"
  },
  {
    "codigo":386615006,
    "descripcion":"DIETA CON BAJO CONTENIDO DE AZÚCAR"
  },
  {
    "codigo":124471008,
    "descripcion":"DEFICIENCIA DE XILANO ENDO - 1, 3 - BETA - XILOSIDASA"
  },
  {
    "codigo":417548001,
    "descripcion":"CORMACK Y LEHANE GRADO 1"
  },
  {
    "codigo":1304119009,
    "descripcion":"NEUROFIBROMATOSIS TIPO 2 EN MOSAICO"
  },
  {
    "codigo":450316000,
    "descripcion":"DESHIDRATACIÓN SEVERA"
  },
  {
    "codigo":1269516003,
    "descripcion":"NEUROBORRELIOSIS DE LYME"
  },
  {
    "codigo":57100005,
    "descripcion":"ENDOFTALMITIS PARASITARIA"
  },
  {
    "codigo":1236748006,
    "descripcion":"MASA QUE OCUPA HEMIABDOMEN DERECHO"
  },
  {
    "codigo":16009351000119100,
    "descripcion":"ATEROEMBOLIA DE ARTERIA DE MIEMBRO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":253708008,
    "descripcion":"ORIGEN ANÓMALO DE LA ARTERIA CORONARIA EN LA ARTERIA PULMONAR IZQUIERDA"
  },
  {
    "codigo":22497004,
    "descripcion":"SÍNDROME DE TRISOMÍA PARCIAL 9Q"
  },
  {
    "codigo":284641004,
    "descripcion":"ESTRANGULAMIENTO DE OTRA PERSONA"
  },
  {
    "codigo":413878002,
    "descripcion":"FRACTURA NO EXPUESTA, DESPLAZADA, DE HUESO NASAL"
  },
  {
    "codigo":1003702005,
    "descripcion":"MIGRACIÓN TRANSUTERINA DE CIGOTO"
  },
  {
    "codigo":116871000119103,
    "descripcion":"LINFOMA DE CÉLULAS DEL MANTO DE GANGLIOS LINFÁTICOS DE MÚLTIPLES LOCALIZACIONES"
  },
  {
    "codigo":53430007,
    "descripcion":"MASTODINIA"
  },
  {
    "codigo":315574007,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: HAUSA"
  },
  {
    "codigo":280971001,
    "descripcion":"ESTENOSIS DE INJERTO ARTERIOVENOSO"
  },
  {
    "codigo":250038007,
    "descripcion":"RETROPULSIÓN AL CAMINAR"
  },
  {
    "codigo":117131003,
    "descripcion":"DURACIÓN DEL SOPLO CARDÍACO, LARGO"
  },
  {
    "codigo":690311000119104,
    "descripcion":"DISARTRIA DEBIDA A ACCIDENTE CEREBROVASCULAR EMBÓLICO Y POSTERIOR A ÉL"
  },
  {
    "codigo":18827005,
    "descripcion":"ANOMALÍA DEL SISTEMA DEL COMPLEMENTO"
  },
  {
    "codigo":1231243004,
    "descripcion":"GLAUCOMA PRIMARIO DE ÁNGULO ABIERTO CON PRESIÓN ELEVADA"
  },
  {
    "codigo":706955002,
    "descripcion":"DOLOR ALIVIADO POR ANALGÉSICO"
  },
  {
    "codigo":1296779008,
    "descripcion":"HIPERTENSIÓN OCULAR POR CÉLULAS FANTASMAS DE OJO DERECHO"
  },
  {
    "codigo":248203009,
    "descripcion":"FACIES HIPOGONADAL"
  },
  {
    "codigo":49760004,
    "descripcion":"RITMO AURICULAR IZQUIERDO"
  },
  {
    "codigo":10684551000119106,
    "descripcion":"NÓDULO DEL TEJIDO CELULAR SUBCUTÁNEO DE EXTREMIDAD INFERIOR DERECHA"
  },
  {
    "codigo":705120006,
    "descripcion":"FRACTURA EXPUESTA DE PARED INTERNA DE ACETÁBULO"
  },
  {
    "codigo":15157000,
    "descripcion":"INTENSIDAD DEL SOPLO CARDÍACO, GRADO III"
  },
  {
    "codigo":211765000,
    "descripcion":"QUEMADURA DE PRIMER GRADO DE DORSO (GLÚTEO EXCLUIDO)"
  },
  {
    "codigo":277301002,
    "descripcion":"RUPTURA DE MALFORMACIÓN ARTERIOVENOSA MEDULAR"
  },
  {
    "codigo":1260341003,
    "descripcion":"DISTONÍA DEBIDA A CALCIFICACIÓN FAMILIAR DE GANGLIOS DE LA BASE"
  },
  {
    "codigo":1073441000119101,
    "descripcion":"ARTRITIS INFECCIOSA DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":703285005,
    "descripcion":"FACOMATOSIS SPILOROSEA"
  },
  {
    "codigo":408373006,
    "descripcion":"CUMPLIMIENTO CON LA FARMACOTERAPIA, VERIFICADO"
  },
  {
    "codigo":12241031000119108,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE MAMA IZQUIERDA"
  },
  {
    "codigo":1293109007,
    "descripcion":"CARCINOMA DE GLÁNDULA SUDORÍPARA ENDOCRINA PRODUCTORA DE MUCINA"
  },
  {
    "codigo":46090001,
    "descripcion":"BALANOPOSTITIS"
  },
  {
    "codigo":766986002,
    "descripcion":"INSUFICIENCIA SUPRARRENAL AGUDA"
  },
  {
    "codigo":13322008,
    "descripcion":"CEFALEA POSTCONVULSIVA"
  },
  {
    "codigo":240863003,
    "descripcion":"ASCARIASIS MIGRATORIA"
  },
  {
    "codigo":44255004,
    "descripcion":"LINFOMA ESTADIO IIIE"
  },
  {
    "codigo":765151006,
    "descripcion":"ASFIXIOFILIA"
  },
  {
    "codigo":109791007,
    "descripcion":"ABSCESO DE PALADAR"
  },
  {
    "codigo":402868001,
    "descripcion":"NEOPLASIA BENIGNA DE VASOS LINFÁTICOS"
  },
  {
    "codigo":239028001,
    "descripcion":"SÍNDROME ODONTOTRICOMÉLICO"
  },
  {
    "codigo":206260003,
    "descripcion":"RECIÉN NACIDO VIVO CON SUFRIMIENTO FETAL PREPARTO"
  },
  {
    "codigo":763316006,
    "descripcion":"ANEURISMA CONGÉNITO DE CONDUCTO ARTERIOSO PERMEABLE"
  },
  {
    "codigo":269961003,
    "descripcion":"EXTENDIDO CERVICAL - DISCARIOSIS MODERADA"
  },
  {
    "codigo":106121005,
    "descripcion":"HALLAZGO EN LA MOTIVACIÓN"
  },
  {
    "codigo":300894000,
    "descripcion":"ANSIEDAD PARENTAL"
  },
  {
    "codigo":5982001,
    "descripcion":"SÍNDROME DE TRISOMÍA PARCIAL 2Q"
  },
  {
    "codigo":1187465008,
    "descripcion":"PARAPLEJÍA ESPÁSTICA AUTOSÓMICA DOMINANTE TIPO 9A"
  },
  {
    "codigo":366430004,
    "descripcion":"AMPLITUD DE LA EXTENSIÓN DE COLUMNA LUMBAR - HALLAZGO"
  },
  {
    "codigo":202590006,
    "descripcion":"OSTEOCONDROMATOSIS SINOVIAL DE ARTICULACIÓN ASTRAGALONAVICULAR"
  },
  {
    "codigo":1084831000119100,
    "descripcion":"COLANGITIS AGUDA DEBIDA A CÁLCULO DE CONDUCTO BILIAR"
  },
  {
    "codigo":12241311000119101,
    "descripcion":"FASCITIS PLANTAR DE PIE DERECHO"
  },
  {
    "codigo":1077151000119102,
    "descripcion":"QUISTE ÓSEO DE PIE DERECHO"
  },
  {
    "codigo":15984031000119101,
    "descripcion":"MIOQUIMIA DE MÚSCULO OBLICUO SUPERIOR DERECHO"
  },
  {
    "codigo":16050591000119104,
    "descripcion":"ARTRITIS DE ARTICULACIÓN DE REGIÓN DE MUÑECA DERECHA DEBIDA A INMUNIZACIÓN Y POSTERIOR A ELLA"
  },
  {
    "codigo":16032671000119104,
    "descripcion":"NECROSIS AVASCULAR DE HEMIPELVIS IZQUIERDA Y DERECHA"
  },
  {
    "codigo":16027551000119106,
    "descripcion":"EXOSTOSIS DE TIBIA IZQUIERDA"
  },
  {
    "codigo":167987009,
    "descripcion":"ESPUTO: NO INFECTADO"
  },
  {
    "codigo":15991711000119108,
    "descripcion":"IRITIS DE OJO DERECHO CAUSADA POR VIRUS HERPES ZÓSTER"
  },
  {
    "codigo":10835871000119104,
    "descripcion":"TRASTORNO DEPRESIVO EN LA MADRE QUE COMPLICA EL NACIMIENTO"
  },
  {
    "codigo":16347551000119107,
    "descripcion":"ENCONDROMA DE HÚMERO DERECHO"
  },
  {
    "codigo":395528004,
    "descripcion":"ESPÉCIMEN DE TEJIDO FRAGMENTADO"
  },
  {
    "codigo":16639391000119106,
    "descripcion":"COMPRESIÓN DE NERVIO PERIFÉRICO DE AMBAS EXTREMIDADES SUPERIORES"
  },
  {
    "codigo":135071000119105,
    "descripcion":"TROMBOSIS AGUDA DE VENA CAVA SUPERIOR"
  },
  {
    "codigo":198920001,
    "descripcion":"HEMORRAGIA PREPARTO CON TRAUMATISMO"
  },
  {
    "codigo":262621000,
    "descripcion":"CUERPO EXTRAÑO EN PERINEO MASCULINO"
  },
  {
    "codigo":16818591000119108,
    "descripcion":"CALCIFICACIÓN DE GANGLIOS BASALES"
  },
  {
    "codigo":10751391000119109,
    "descripcion":"CHOQUE DEBIDO A EMBARAZO ECTÓPICO"
  },
  {
    "codigo":10682271000119109,
    "descripcion":"TUMORACIÓN DE LA PIEL DE LA MANO IZQUIERDA"
  },
  {
    "codigo":2312009,
    "descripcion":"TRASTORNO REACTIVO DE LA VINCULACIÓN EN LA LACTANCIA O LA NIÑEZ TEMPRANA, TIPO INHIBIDO"
  },
  {
    "codigo":721373002,
    "descripcion":"SÍNDROME DEL CORDÓN CENTRAL DE MÉDULA ESPINAL AL NIVEL DEL SEGUNDO SEGMENTO CERVICAL"
  },
  {
    "codigo":197085005,
    "descripcion":"DIVERTICULOSIS DEL ÍLEON"
  },
  {
    "codigo":295389006,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE ÁCIDO 5-AMINOSALICÍLICO"
  },
  {
    "codigo":15929941000119103,
    "descripcion":"EDEMA POR ESTASIS VENOSA DE MIEMBRO INFERIOR DERECHO"
  },
  {
    "codigo":293554006,
    "descripcion":"REACCIÓN ADVERSA AL TETRANITRATO DE PENTAERITRITILO"
  },
  {
    "codigo":129714008,
    "descripcion":"HALLAZGO EN LA MAMOGRAFÍA"
  },
  {
    "codigo":1145522009,
    "descripcion":"MEJORÍA EN EL ESTADO NUTRICIONAL"
  },
  {
    "codigo":226183000,
    "descripcion":"DIETA SIN TARTRAZINA"
  },
  {
    "codigo":160647004,
    "descripcion":"NIVEL 1 DE ACTIVIDAD SEGÚN EL PRINCIPIO FITT; MEZCLA DE ACTIVIDADES MODERADAS\/ENÉRGICAS EN 1-4 OCASIONES EN 4 SEMANAS"
  },
  {
    "codigo":95111006,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE BAZO"
  },
  {
    "codigo":717703006,
    "descripcion":"AUSENCIA CONGÉNITA DE AMBOS OVARIOS"
  },
  {
    "codigo":193415008,
    "descripcion":"DISTROFIA TAPETORRETINIANA"
  },
  {
    "codigo":1141852001,
    "descripcion":"INFILTRACIÓN EOSINOFÍLICA DE ESTRUCTURA PULMONAR"
  },
  {
    "codigo":93276003,
    "descripcion":"HIPOPLASIA CONGÉNITA DEL CORNETE NASAL"
  },
  {
    "codigo":715868005,
    "descripcion":"HIPERPLASIA SUPRARRENAL PRIMARIA UNILATERAL"
  },
  {
    "codigo":338671000119100,
    "descripcion":"CICLITIS POSTERIOR DE OJO IZQUIERDO"
  },
  {
    "codigo":60508007,
    "descripcion":"LATEROFLEXIÓN FETAL"
  },
  {
    "codigo":419121001,
    "descripcion":"DERMATITIS ALÉRGICA DE CONTACTO DEL PABELLÓN AURICULAR"
  },
  {
    "codigo":714033002,
    "descripcion":"FÓRMULA A BASE DE SOJA PARA LACTANTES"
  },
  {
    "codigo":189745002,
    "descripcion":"GLOMANGIOMIOMA"
  },
  {
    "codigo":124209008,
    "descripcion":"DEFICIENCIA DE CISTEAMINA DIOXIGENASA"
  },
  {
    "codigo":253446002,
    "descripcion":"CUERDAS TENDINOSAS DE VÁLVULA AURICULOVENTRICULAR COMÚN EXCESIVAMENTE LARGAS"
  },
  {
    "codigo":286214003,
    "descripcion":"UTILIZA APOYO RESPIRATORIO PARA HABLAR"
  },
  {
    "codigo":1300187005,
    "descripcion":"ENFERMEDAD INFECCIOSA VIRAL INVASIVA"
  },
  {
    "codigo":251611008,
    "descripcion":"SÓLO SE OBSERVA LA ONDA I DEL POTENCIAL EVOCADO AUDITIVO DEL TRONCO ENCEFÁLICO"
  },
  {
    "codigo":55003009,
    "descripcion":"INSUFICIENCIA MEDULAR SUPRARRENAL"
  },
  {
    "codigo":282544001,
    "descripcion":"NO PARA DE CORRER"
  },
  {
    "codigo":15713161000119100,
    "descripcion":"INFARTO AGUDO DE TABIQUE DE MIOCARDIO CON ELEVACIÓN DE SEGMENTO ST"
  },
  {
    "codigo":1003440009,
    "descripcion":"FISURA LARÍNGEA TIPO 0"
  },
  {
    "codigo":11862921000119101,
    "descripcion":"ABRASIÓN DE PIEL DE DEDOS SEGUNDO A QUINTO DE PIE DERECHO"
  },
  {
    "codigo":247941005,
    "descripcion":"AFICIONARSE A OBJETOS ESPECIALES - RUTINA ESTEREOTIPADA"
  },
  {
    "codigo":18565007,
    "descripcion":"REDISTRIBUCIÓN"
  },
  {
    "codigo":213338000,
    "descripcion":"ERITEMA EN SITIO DE INYECCIÓN"
  },
  {
    "codigo":444549009,
    "descripcion":"EMBOLIA DESDE TROMBOSIS DE VENA DE MUSLO"
  },
  {
    "codigo":49498000,
    "descripcion":"ADENITIS MESENTÉRICA CAUSADA POR PASTEURELLA MULTOCIDA"
  },
  {
    "codigo":11781001000119102,
    "descripcion":"AMPOLLA TRAUMÁTICA DE CODO DERECHO"
  },
  {
    "codigo":442714003,
    "descripcion":"HALLAZGO RELACIONADO CON DIFERENCIA EN EL TAMAÑO EN COMPARACIÓN CON EXAMEN RADIOLÓGICO PREVIO"
  },
  {
    "codigo":14895001,
    "descripcion":"LISTA DE REEMPLAZO DE LA GRASA"
  },
  {
    "codigo":1260079004,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS DE CARA HIPOFARÍNGEA DEL PLIEGUE ARIEPIGLÓTICO"
  },
  {
    "codigo":735791007,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE PARTE DE LA PELVIS"
  },
  {
    "codigo":703023008,
    "descripcion":"STREPTOCOCCUS CONSTELLATUS O STREPTOCOCCUS ANGINOSUS"
  },
  {
    "codigo":209668004,
    "descripcion":"SECCIÓN EXPUESTA DE LIGAMENTO DE MUÑECA O MANO"
  },
  {
    "codigo":45828008,
    "descripcion":"ANEMIA EN LA MADRE, QUE COMPLICA EL EMBARAZO, EL PARTO Y\/O EL PUERPERIO"
  },
  {
    "codigo":699353000,
    "descripcion":"ESPACIO PRIMATE AUSENTE"
  },
  {
    "codigo":11225002,
    "descripcion":"HIPERAMONEMIA TRANSITORIA EN LA INFANCIA"
  },
  {
    "codigo":109529004,
    "descripcion":"HIPOPLASIA MAXILAR VERTICAL CONGÉNITA"
  },
  {
    "codigo":402606002,
    "descripcion":"FENOTIPO DE LA PIEL - HALLAZGO"
  },
  {
    "codigo":304302008,
    "descripcion":"AUSENCIA DE MOVIMIENTO DE CODO"
  },
  {
    "codigo":73091004,
    "descripcion":"ENCOPRESIS FUNCIONAL SECUNDARIA"
  },
  {
    "codigo":1285507004,
    "descripcion":"DEGENERACIÓN MACULAR NEOVASCULAR NO EXUDATIVA RELACIONADA CON EDAD"
  },
  {
    "codigo":235096000,
    "descripcion":"MORDIDA REDUCIDA"
  },
  {
    "codigo":300632002,
    "descripcion":"DIFICULTAD PARA VIAJAR EN TRANSPORTE PRIVADO"
  },
  {
    "codigo":202328006,
    "descripcion":"LESIÓN DE FIBROCARTÍLAGO ARTICULAR"
  },
  {
    "codigo":726616006,
    "descripcion":"DISTROFIA MUSCULAR DE LAS CINTURAS DE LAS EXTREMIDADES TIPO 2L AUTOSÓMICA RECESIVA"
  },
  {
    "codigo":169560008,
    "descripcion":"EMBARAZADA - CONFIRMACIÓN POR ANÁLISIS DE ORINA"
  },
  {
    "codigo":36653000,
    "descripcion":"RUBÉOLA"
  },
  {
    "codigo":3885002,
    "descripcion":"ISOINMUNIZACIÓN ABO QUE AFECTA AL EMBARAZO"
  },
  {
    "codigo":724781003,
    "descripcion":"DESMIELINIZACIÓN DE SISTEMA NERVIOSO CENTRAL CONCOMITANTE CON LUPUS ERITEMATOSO SISTÉMICO Y DEBIDA A ÉL"
  },
  {
    "codigo":341181000119101,
    "descripcion":"DEPÓSITOS CRISTALINOS EN VÍTREO DE OJO IZQUIERDO"
  },
  {
    "codigo":167725008,
    "descripcion":"LCR: SE OBSERVAN MICROORGANISMOS"
  },
  {
    "codigo":1281837008,
    "descripcion":"CRISIS EPILÉPTICA EMOCIONAL CON CONCIENCIA PRESERVADA DE INICIO FOCAL"
  },
  {
    "codigo":1148930004,
    "descripcion":"DEFICIENCIA DE FACTOR DE LA COAGULACIÓN POR DEFICIENCIA DE VITAMINA K EN LA ENFERMEDAD BILIAR OBSTRUCTIVA"
  },
  {
    "codigo":34818008,
    "descripcion":"DIABETES MELLITUS PREGESTACIONAL Y\/O TRASTORNO DE LA TOLERANCIA A LA GLUCOSA, CLASE B DE WHITE MODIFICADA"
  },
  {
    "codigo":16889021000119105,
    "descripcion":"ESTENOSIS CONGÉNITA DE CONDUCTO AUDITIVO EXTERNO IZQUIERDO"
  },
  {
    "codigo":426199009,
    "descripcion":"DEFICIENCIA CONGÉNITA DEL FACTOR IX SIN INHIBIDORES"
  },
  {
    "codigo":424364004,
    "descripcion":"INSATISFACCIÓN CON LAS RESPONSABILIDADES PARENTALES"
  },
  {
    "codigo":31148005,
    "descripcion":"INTOXICACIÓN POR TEMEFOS"
  },
  {
    "codigo":719276005,
    "descripcion":"DISTONÍA PRIMARIA TIPO 4"
  },
  {
    "codigo":293292006,
    "descripcion":"REACCIÓN ADVERSA A LA PROTIRELINA"
  },
  {
    "codigo":129452008,
    "descripcion":"NEUMONITIS INTERSTICIAL INESPECÍFICA"
  },
  {
    "codigo":29313001,
    "descripcion":"REQUERIMIENTO HORMONAL DISMINUIDO"
  },
  {
    "codigo":11809981000119107,
    "descripcion":"ABRASIÓN DE PIEL DE PIERNA DERECHA"
  },
  {
    "codigo":94849000,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL FONDO DEL ESTÓMAGO"
  },
  {
    "codigo":162220005,
    "descripcion":"ESCASA AUTOESTIMA"
  },
  {
    "codigo":225921005,
    "descripcion":"CONTENIDO DE LA CONVERSACIÓN RARO"
  },
  {
    "codigo":1208961006,
    "descripcion":"CONVULSIÓN EPILÉPTICA NO MOTORA"
  },
  {
    "codigo":1340033000,
    "descripcion":"ABRASIÓN DE PIEL DE SEGUNDO DEDO DE PIE"
  },
  {
    "codigo":10636631000119102,
    "descripcion":"ÚLCERA CRÓNICA DE TALÓN DERECHO"
  },
  {
    "codigo":289622000,
    "descripcion":"CUERPO DEL ÚTERO PRESENTE"
  },
  {
    "codigo":93014003,
    "descripcion":"ANOMALÍA CONGÉNITA DE HUESO PALATINO"
  },
  {
    "codigo":1010518005,
    "descripcion":"ESCLEROSIS DE EPÍFISIS DE FALANGE DE DEDO GORDO DE PIE CON RADIOPACIDAD AUMENTADA"
  },
  {
    "codigo":386091000,
    "descripcion":"HALLAZGO RELACIONADO CON EL CUMPLIMIENTO DEL TRATAMIENTO"
  },
  {
    "codigo":846678009,
    "descripcion":"INCAPAZ DE VISUALIZAR LA RETINA DEL OJO IZQUIERDO"
  },
  {
    "codigo":255019000,
    "descripcion":"ADENOMA DE EPITELIO NO PIGMENTADO DE CUERPO CILIAR"
  },
  {
    "codigo":123947004,
    "descripcion":"TRASTORNO POSESTREPTOCÓCICO"
  },
  {
    "codigo":1268992002,
    "descripcion":"LENTE INTRAOCULAR FÁQUICA PRESENTE"
  },
  {
    "codigo":23808003,
    "descripcion":"SÍNDROME DE OCLUSIÓN DE LA VENA DE ROLANDO"
  },
  {
    "codigo":56576003,
    "descripcion":"TRASTORNO DE PÁNICO SIN AGORAFOBIA"
  },
  {
    "codigo":12275031000119106,
    "descripcion":"AGRANDAMIENTO DE VENTRÍCULO CEREBRAL CONGÉNITO"
  },
  {
    "codigo":10692081000119100,
    "descripcion":"TUMEFACCIÓN LOCALIZADA DEL PULGAR IZQUIERDO"
  },
  {
    "codigo":253184003,
    "descripcion":"MALFORMACIÓN DE CHIARI"
  },
  {
    "codigo":710101000,
    "descripcion":"ANGULACIÓN ATÍPICA DE CÓNDILO MANDIBULAR"
  },
  {
    "codigo":218581000,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR FIBRINÓGENO HUMANO"
  },
  {
    "codigo":284117003,
    "descripcion":"INCAPAZ DE CONTROLAR LA POSICIÓN DE LA CINTURA ESCAPULAR"
  },
  {
    "codigo":251349003,
    "descripcion":"REACCIÓN CUTÁNEA DUDOSA"
  },
  {
    "codigo":87509005,
    "descripcion":"INFECCIÓN CAUSADA POR ONCHOCERCA RETICULATA"
  },
  {
    "codigo":446122002,
    "descripcion":"INFECCIÓN INTESTINAL CAUSADA POR CAMPYLOBACTER COLI"
  },
  {
    "codigo":15689201000119103,
    "descripcion":"ARTRITIS INFECCIOSA DE AMBAS CADERAS"
  },
  {
    "codigo":51071000,
    "descripcion":"ANEMIA HEMOLÍTICA MICROANGIOPÁTICA"
  },
  {
    "codigo":247679002,
    "descripcion":"IDEACIÓN DELIRANTE NIHILISTA"
  },
  {
    "codigo":83839005,
    "descripcion":"ACRODERMATITIS CONTINUA DE HALLOPEAU"
  },
  {
    "codigo":288241000119105,
    "descripcion":"TEMOR A LOS PUENTES"
  },
  {
    "codigo":870271009,
    "descripcion":"PRURITO DEBIDO A INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":278612008,
    "descripcion":"SUPERFICIE DE PRÓTESIS DENTAL - HALLAZGO"
  },
  {
    "codigo":1359956009,
    "descripcion":"HERIDA ABIERTA DE REGIÓN DE MUÑECA DEBIDA A MORDEDURA DE GATO"
  },
  {
    "codigo":1259817003,
    "descripcion":"XANTOASTROCITOMA PLEOMÓRFICO PRIMARIO DE ENCÉFALO"
  },
  {
    "codigo":735529004,
    "descripcion":"INFECCIÓN EXTRAINTESTINAL CAUSADA POR ENTAMOEBA"
  },
  {
    "codigo":897534000,
    "descripcion":"CALCIFICACIÓN DE CORDÓN UMBILICAL"
  },
  {
    "codigo":1080971000119102,
    "descripcion":"MELANOMA MALIGNO DE RETINA DE OJO IZQUIERDO"
  },
  {
    "codigo":240339001,
    "descripcion":"INTOXICACIÓN ALIMENTARIA POR ADENOVIRUS"
  },
  {
    "codigo":209406009,
    "descripcion":"FRACTURA-SUBLUXACIÓN EXPUESTA DE LA ARTICULACIÓN ESTERNOCLAVICULAR, ANTERIOR"
  },
  {
    "codigo":109267002,
    "descripcion":"MELANOMA MALIGNO SUPERPUESTO DE LA PIEL"
  },
  {
    "codigo":764627005,
    "descripcion":"SÍNDROME DE TRISOMÍA 3 MOSAICO"
  },
  {
    "codigo":305875008,
    "descripcion":"ATENDIDA EN SERVICIO DE INTERRUPCIÓN DEL EMBARAZO"
  },
  {
    "codigo":238504001,
    "descripcion":"DERMATITIS DE CONTACTO CAUSADA POR FIBRA DE VIDRIO"
  },
  {
    "codigo":1156008002,
    "descripcion":"INTOXICACIÓN POR CIANURO Y\/O COMPUESTO DE CIANURO"
  },
  {
    "codigo":205736006,
    "descripcion":"BAZO DEFORMADO"
  },
  {
    "codigo":9128006,
    "descripcion":"TRASTORNO DEL CICLO GAMMA GLUTAMIL"
  },
  {
    "codigo":343691000119107,
    "descripcion":"ÚLCERA CORNEAL EN ANILLO DE AMBOS OJOS"
  },
  {
    "codigo":105597003,
    "descripcion":"CEGUERA Y\/O NIVEL DE DETERIORO DE LA VISIÓN"
  },
  {
    "codigo":236669005,
    "descripcion":"EXTRAVASACIÓN DE ORINA DESDE VEJIGA URINARIA"
  },
  {
    "codigo":38226001,
    "descripcion":"DIETA SUAVE"
  },
  {
    "codigo":267602002,
    "descripcion":"NEUROPATÍA EN LA INSUFICIENCIA RENAL"
  },
  {
    "codigo":726354002,
    "descripcion":"TRISOMÍA PARCIAL DE CROMOSOMA 15"
  },
  {
    "codigo":7293009,
    "descripcion":"ALTO PESO AL NACER INDEPENDIENTEMENTE DE LA EDAD GESTACIONAL"
  },
  {
    "codigo":365906004,
    "descripcion":"MEMORIA DE LA EDAD PROPIA - HALLAZGO"
  },
  {
    "codigo":300370006,
    "descripcion":"HALLAZGO RELACIONADO CON LA PRESENCIA DE GAS EN EL TRACTO GASTROINTESTINAL SUPERIOR"
  },
  {
    "codigo":724519008,
    "descripcion":"ÚLCERA GÁSTRICA CAUSADA POR HELICOBACTER PYLORI Y AGENTE ANTIINFLAMATORIO NO ESTEROIDE"
  },
  {
    "codigo":1148668000,
    "descripcion":"RESPUESTA AUSENTE DE ELECTRORRETINOGRAMA CON ADAPTACIÓN A LA LUZ"
  },
  {
    "codigo":722684000,
    "descripcion":"ADENOCARCINOMA SEROSO PRIMARIO DE BAJO GRADO DE OVARIO"
  },
  {
    "codigo":296700002,
    "descripcion":"SOBREDOSIS DE CEFUROXIMA"
  },
  {
    "codigo":395004006,
    "descripcion":"ROTULACIÓN DE MEDICAMENTO: INADECUADA"
  },
  {
    "codigo":427772009,
    "descripcion":"PÉRDIDA DE LA AUDICIÓN ASIMÉTRICA"
  },
  {
    "codigo":294865002,
    "descripcion":"ALERGIA A COMPLEJO ANTI-INHIBIDOR DE LA COAGULACIÓN"
  },
  {
    "codigo":131025002,
    "descripcion":"NIVEL DE GONADOTROFINA HIPOFISARIA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":32721004,
    "descripcion":"BULIMIA NERVIOSA, TIPO PURGATIVO"
  },
  {
    "codigo":260262005,
    "descripcion":"N36"
  },
  {
    "codigo":194726006,
    "descripcion":"ESTENOSIS MITRAL CON INSUFICIENCIA"
  },
  {
    "codigo":293030009,
    "descripcion":"REACCIÓN ADVERSA AL TINIDAZOL"
  },
  {
    "codigo":127355002,
    "descripcion":"ALBÚMINA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":94587004,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE PARTES BLANDAS DE CADERA"
  },
  {
    "codigo":782715005,
    "descripcion":"INFECCIÓN CAUSADA POR BORDETELLA"
  },
  {
    "codigo":61819007,
    "descripcion":"RAQUISQUISIS"
  },
  {
    "codigo":289360000,
    "descripcion":"CABEZA FETAL PARCIALMENTE FLEXIONADA"
  },
  {
    "codigo":92752000,
    "descripcion":"CARCINOMA IN SITU DEL CORDÓN ESPERMÁTICO"
  },
  {
    "codigo":291195009,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR PERFENAZINA"
  },
  {
    "codigo":715344006,
    "descripcion":"NEUROFIBROMATOSIS-SÍNDROME DE NOONAN"
  },
  {
    "codigo":16019391000119107,
    "descripcion":"ATEROSCLEROSIS DE INJERTO-PUENTE NO BIOLÓGICO DE EXTREMIDAD INFERIOR DERECHA"
  },
  {
    "codigo":111283005,
    "descripcion":"INSUFICIENCIA VENTRICULAR IZQUIERDA CRÓNICA"
  },
  {
    "codigo":15665241000119101,
    "descripcion":"OPACIDAD VÍTREA CONGÉNITA DE OJO IZQUIERDO"
  },
  {
    "codigo":254757003,
    "descripcion":"COLESTEROSIS EXTRACELULAR"
  },
  {
    "codigo":713509006,
    "descripcion":"TORSIÓN CONGÉNITA DE PENE"
  },
  {
    "codigo":418597008,
    "descripcion":"TOLERA ACTIVIDAD EN EL CONTEXTO DEL ALTA"
  },
  {
    "codigo":844581009,
    "descripcion":"REACCIÓN DE PATERGIA"
  },
  {
    "codigo":15747161000119102,
    "descripcion":"LESIÓN DE AMBOS CANTOS"
  },
  {
    "codigo":447695000,
    "descripcion":"VÁLVULA TRONCAL TRICÚSPIDE"
  },
  {
    "codigo":1332431001,
    "descripcion":"HISTIOCITOSIS DE CÉLULAS DE LANGERHANS DISEMINADA DE GANGLIOS LINFÁTICOS ABDOMINALES"
  },
  {
    "codigo":283855001,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO EN LA BOCA"
  },
  {
    "codigo":285690009,
    "descripcion":"INCAPAZ DE CARGAR PESO EN LA PIERNA IZQUIERDA"
  },
  {
    "codigo":414927004,
    "descripcion":"MIASTENIA OCULAR CON ESTRABISMO"
  },
  {
    "codigo":21711003,
    "descripcion":"HIDROSALPINX"
  },
  {
    "codigo":216484000,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR SAL DE ORO"
  },
  {
    "codigo":773540001,
    "descripcion":"LEUCOQUERATOSIS"
  },
  {
    "codigo":314788004,
    "descripcion":"INSUFICIENCIA DE DIVERGENCIA"
  },
  {
    "codigo":18521000119106,
    "descripcion":"MICROALBUMINURIA DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":118180006,
    "descripcion":"HALLAZGO RELACIONADO CON LA FUNCIÓN DEL LÍQUIDO AMNIÓTICO"
  },
  {
    "codigo":183716007,
    "descripcion":"CONSULTA DOMICILIARIA DE GASTROENTEROLOGÍA SOLICITADA"
  },
  {
    "codigo":282020008,
    "descripcion":"PARTO PREMATURO"
  },
  {
    "codigo":413092009,
    "descripcion":"EL PACIENTE RECIBE COPIA DE CARTA DE DERIVACIÓN"
  },
  {
    "codigo":18041002,
    "descripcion":"ASMA DE LOS IMPRENTEROS"
  },
  {
    "codigo":346201000119107,
    "descripcion":"ENOFTALMOS DE AMBOS OJOS DEBIDO A ATROFIA DE TEJIDO ORBITARIO"
  },
  {
    "codigo":312953009,
    "descripcion":"ATAQUES DE RIGIDEZ"
  },
  {
    "codigo":704334005,
    "descripcion":"FRACTURA OSTEOPORÓTICA DE FÉMUR PROXIMAL"
  },
  {
    "codigo":1163086007,
    "descripcion":"ESQUISTOSOMIASIS AGUDA"
  },
  {
    "codigo":1259555000,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS VERRUGOSO PRIMARIO"
  },
  {
    "codigo":48974009,
    "descripcion":"ÚLCERA GÁSTRICA AGUDA CON HEMORRAGIA Y PERFORACIÓN"
  },
  {
    "codigo":47139007,
    "descripcion":"LEUCONIQUIA CONGÉNITA"
  },
  {
    "codigo":45304001,
    "descripcion":"PERICARDITIS CAUSADA POR DEPÓSITOS DE COLESTEROL"
  },
  {
    "codigo":471288001,
    "descripcion":"ORIGEN ANÓMALO DE ARTERIA CORONARIA IZQUIERDA Y ARTERIA CORONARIA DERECHA CON ORIFICIOS DOBLES EN SENO AÓRTICO A LA DERECHA DE SENO AÓRTICO NO ENFRENTADO"
  },
  {
    "codigo":241912005,
    "descripcion":"EFECTO TÓXICO CAUSADO POR BLANQUEADOR DE CALZADO DE LONA"
  },
  {
    "codigo":405752007,
    "descripcion":"DEFECTO CONGÉNITO DEL TABIQUE AURICULAR"
  },
  {
    "codigo":1290488009,
    "descripcion":"TRASTORNO DE TENDÓN DE REGIÓN DE RODILLA"
  },
  {
    "codigo":372984009,
    "descripcion":"INFECCIÓN CAUSADA POR ASPERGILLUS GLAUCUS"
  },
  {
    "codigo":240077004,
    "descripcion":"DISTROFIA MUSCULAR ESCAPULOHUMERAL GRAVE CON MIOCARDIOPATÍA"
  },
  {
    "codigo":305613006,
    "descripcion":"BAJO ATENCIÓN DE FISIOTERAPEUTA"
  },
  {
    "codigo":403917007,
    "descripcion":"CARCINOMA BASOCELULAR DE SIEN"
  },
  {
    "codigo":74402000,
    "descripcion":"CUERPO EXTRAÑO DEJADO ACCIDENTALMENTE EN EL CUERPO DURANTE UN PROCEDIMIENTO"
  },
  {
    "codigo":860834000,
    "descripcion":"GRANULOMA DE ENCÉFALO CAUSADO POR SCHISTOSOMA"
  },
  {
    "codigo":301943000,
    "descripcion":"PUPILAS IGUALES"
  },
  {
    "codigo":762530009,
    "descripcion":"LINFANGITIS ASCENDENTE CAUSADA POR BACTERIAS"
  },
  {
    "codigo":236407003,
    "descripcion":"NEFROPATÍA POR IGA"
  },
  {
    "codigo":269175006,
    "descripcion":"RASGO BETA TALASÉMICO"
  },
  {
    "codigo":203639008,
    "descripcion":"ESCOLIOSIS IDIOPÁTICA"
  },
  {
    "codigo":1237128001,
    "descripcion":"TAQUICARDIA VENTRICULAR MONOMORFA NO SOSTENIDA"
  },
  {
    "codigo":234572005,
    "descripcion":"INMUNODEFICIENCIA COMBINADA BENIGNA"
  },
  {
    "codigo":267340006,
    "descripcion":"PIREXIA MATERNA EN EL TRABAJO DE PARTO"
  },
  {
    "codigo":5196006,
    "descripcion":"INTOXICACIÓN POR HERTIA PALLENS"
  },
  {
    "codigo":300108008,
    "descripcion":"ENTUMECIMIENTO DE PABELLÓN AURICULAR"
  },
  {
    "codigo":298273007,
    "descripcion":"HALLAZGO RELACIONADO CON EL TAMAÑO DE MÚSCULO ESQUELÉTICO"
  },
  {
    "codigo":296438004,
    "descripcion":"SOBREDOSIS DE AMINOFILINA"
  },
  {
    "codigo":787958009,
    "descripcion":"RAOULTELLA ORNITHINOLYTICA O RAOULTELLA PLANTICOLA"
  },
  {
    "codigo":196299008,
    "descripcion":"CARIES DENTAL CRÓNICA EN LA DENTINA"
  },
  {
    "codigo":720587009,
    "descripcion":"MELANOMA DERIVADO DE DONANTE"
  },
  {
    "codigo":30624007,
    "descripcion":"QUISTE DE GLÁNDULA SUDORÍPARA"
  },
  {
    "codigo":718752007,
    "descripcion":"ATAXIA EPISÓDICA TIPO 7"
  },
  {
    "codigo":292768009,
    "descripcion":"REACCIÓN ADVERSA AL CITRATO"
  },
  {
    "codigo":127093002,
    "descripcion":"LINFADENOPATÍA DELFIANA"
  },
  {
    "codigo":1085991000119107,
    "descripcion":"CARIES DENTAL SOBRE SUPERFICIE LISA QUE PENETRA HASTA LA DENTINA"
  },
  {
    "codigo":184871000119108,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE PELVIS"
  },
  {
    "codigo":76481000119102,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN DEBIDA A ESPINA BÍFIDA"
  },
  {
    "codigo":389237009,
    "descripcion":"DISPLASIA DE BLOMSTRAND"
  },
  {
    "codigo":94325008,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA CABEZA DEL PÁNCREAS"
  },
  {
    "codigo":290933007,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR BECLAMIDA"
  },
  {
    "codigo":26954004,
    "descripcion":"TROMBOFLEBITIS DE SENO SAGITAL SUPERIOR"
  },
  {
    "codigo":190794006,
    "descripcion":"ENFERMEDAD DE GAUCHER"
  },
  {
    "codigo":92490007,
    "descripcion":"CENTRO CARTILAGINOSO DE VÉRTEBRA LUMBAR HENDIDO"
  },
  {
    "codigo":289098008,
    "descripcion":"RESPIRA PROFUNDAMENTE"
  },
  {
    "codigo":715082009,
    "descripcion":"CAPAZ DE PASAR DEL INODORO A UNA SILLA"
  },
  {
    "codigo":11791041000119104,
    "descripcion":"CONTUSIÓN DE RODILLA DERECHA"
  },
  {
    "codigo":15723201000119104,
    "descripcion":"ARTROSIS SECUNDARIA DE AMBOS HOMBROS"
  },
  {
    "codigo":711412004,
    "descripcion":"ACIDURIA 3-METILGLUTACÓNICA TIPO 5"
  },
  {
    "codigo":285428004,
    "descripcion":"GAMMAPATÍA MONOCLONAL POR IGD DE SIGNIFICACIÓN INCIERTA"
  },
  {
    "codigo":449268006,
    "descripcion":"SARCOMA DE CLAVÍCULA"
  },
  {
    "codigo":1332169003,
    "descripcion":"ÚLCERA VENOSA DE TOBILLO"
  },
  {
    "codigo":185289007,
    "descripcion":"ATENDIDO POR CIRUJANO ODONTOLÓGICO"
  },
  {
    "codigo":314526000,
    "descripcion":"ELISA PARA ANTÍGENO DE CHLAMYDIA: NEGATIVO"
  },
  {
    "codigo":707742001,
    "descripcion":"SÍNDROME DE BARTTER"
  },
  {
    "codigo":216222001,
    "descripcion":"LESIÓN POR DESCENSO VOLUNTARIO EN PARACAÍDAS, SIN ACCIDENTE DE AERONAVE"
  },
  {
    "codigo":773278003,
    "descripcion":"OSTEODISPLASIA FAMILIAR TIPO ANDERSON"
  },
  {
    "codigo":52382004,
    "descripcion":"INTOXICACIÓN POR INDOMETACINA"
  },
  {
    "codigo":1363102007,
    "descripcion":"ASTILLA EN CARA CON INFECCIÓN"
  },
  {
    "codigo":871582008,
    "descripcion":"FALLA DE DERIVACIÓN ARTERIAL SISTÉMICA-PULMONAR"
  },
  {
    "codigo":85150007,
    "descripcion":"ÚTERO BICAMERAL SELLADO"
  },
  {
    "codigo":279923002,
    "descripcion":"TÚBULO DEL PARAÓFORO"
  },
  {
    "codigo":247155003,
    "descripcion":"DEPÓSITOS VITELIFORMES MACULARES"
  },
  {
    "codigo":771443008,
    "descripcion":"DEFICIENCIA DEL COMPONENTE 3 DEL COMPLEMENTO"
  },
  {
    "codigo":441928003,
    "descripcion":"ESTUDIO POR IMÁGENES DEL SISTEMA MUSCULOESQUELÉTICO, ANORMAL"
  },
  {
    "codigo":278088004,
    "descripcion":"CURVA SACRA PLANA"
  },
  {
    "codigo":1162824004,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE VITAMINA D Y\/O DERIVADO DE VITAMINA D"
  },
  {
    "codigo":310856006,
    "descripcion":"INFORME DE VIVIENDA ENVIADO"
  },
  {
    "codigo":276253002,
    "descripcion":"PATRÓN DE INTERFERENCIA DE ALTA AMPLITUD REDUCIDO SIN ACTIVIDAD ESPONTÁNEA ANORMAL EN EL ELECTROMIOGRAMA"
  },
  {
    "codigo":866077005,
    "descripcion":"INFECCIÓN DE CONDUCTO BILIAR CAUSADA POR PARÁSITO"
  },
  {
    "codigo":210717005,
    "descripcion":"SECCIÓN TOTAL, TENDÓN DEL MÚSCULO EXTENSOR DEL PIE"
  },
  {
    "codigo":309021007,
    "descripcion":"ESTADO DEL INFORME DE APTITUD PARA LICENCIA DE CONDUCIR"
  },
  {
    "codigo":12274003,
    "descripcion":"ÚLCERA PÉPTICA AGUDA CON HEMORRAGIA"
  },
  {
    "codigo":45042004,
    "descripcion":"HEPATITIS VIRAL AGUDA FULMINANTE"
  },
  {
    "codigo":733170007,
    "descripcion":"ASPERGILOSIS CRÓNICA DE SENO PARANASAL"
  },
  {
    "codigo":208882009,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA NO EXPUESTA DE VARIOS DEDOS"
  },
  {
    "codigo":698567002,
    "descripcion":"CELULITIS RECURRENTE"
  },
  {
    "codigo":75975003,
    "descripcion":"DEFICIENCIA DE ÁCIDO FÓLICO (NO ANÉMICA)"
  },
  {
    "codigo":403655004,
    "descripcion":"DERMATITIS PERIORAL CAUSADA POR CORTICOSTEROIDES"
  },
  {
    "codigo":272583005,
    "descripcion":"NIÑO SOBRE LA FALDA"
  },
  {
    "codigo":1255623001,
    "descripcion":"ESTENOSIS DE ORIFICIO DE RAMA DESCENDENTE ANTERIOR DE ARTERIA CORONARIA IZQUIERDA"
  },
  {
    "codigo":237980004,
    "descripcion":"ACIDURIA D-GLICÉRICA"
  },
  {
    "codigo":205212008,
    "descripcion":"DEFICIENCIA TIBIAL CONGÉNITA TIPO I"
  },
  {
    "codigo":399985004,
    "descripcion":"POROMA ECRINO DE PIEL"
  },
  {
    "codigo":37702000,
    "descripcion":"ACRODERMITIS ENTEROPÁTICA HEREDITARIA"
  },
  {
    "codigo":267078001,
    "descripcion":"MOVIMIENTO INVOLUNTARIO"
  },
  {
    "codigo":301681008,
    "descripcion":"CAPAZ DE MOVERSE EN LA CAMA"
  },
  {
    "codigo":678901000119109,
    "descripcion":"DEPÓSITO EN CÓRNEA DERECHA"
  },
  {
    "codigo":365382008,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA REALIZAR ACTIVIDADES DE BRICOLAJE"
  },
  {
    "codigo":299846008,
    "descripcion":"REFLEJO MIOTÁTICO DE DEDO DE LA MANO: VIVO"
  },
  {
    "codigo":723995003,
    "descripcion":"DISPLASIA INMUNITARIA Y ÓSEA DE SCHIMKE"
  },
  {
    "codigo":166939005,
    "descripcion":"NIVEL DE FENOBARBITAL POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":298011007,
    "descripcion":"HALLAZGO RELACIONADO CON LA SENSIBILIDAD DE UNA HERIDA"
  },
  {
    "codigo":68635007,
    "descripcion":"DEFICIENCIA DE LA FUNCIÓN PLACENTARIA"
  },
  {
    "codigo":136721551000119105,
    "descripcion":"HEMANGIOBLASTOMA DE SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":1264004,
    "descripcion":"LESIÓN TRAUMÁTICA DE COLON IZQUIERDO SIN HERIDA ABIERTA HACIA CAVIDAD ABDOMINAL"
  },
  {
    "codigo":230640008,
    "descripcion":"COMPRESIÓN DEL NERVIO FEMORAL"
  },
  {
    "codigo":197872008,
    "descripcion":"INERCIA DE VEJIGA URINARIA"
  },
  {
    "codigo":785861005,
    "descripcion":"ACINETOBACTER BAUMANNII, ACINETOBACTER CALCOACETICUS O ACINETOBACTER PITTII"
  },
  {
    "codigo":425413006,
    "descripcion":"CIRROSIS HEPÁTICA INDUCIDA POR FÁRMACOS"
  },
  {
    "codigo":294341007,
    "descripcion":"ALERGIA A FLUCITOSINA"
  },
  {
    "codigo":12203151000119108,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DE DEDO DE PIE IZQUIERDO"
  },
  {
    "codigo":95898004,
    "descripcion":"MORDEDURA DE GARRAPATA"
  },
  {
    "codigo":194202008,
    "descripcion":"OTITIS EXTERNA INFECCIOSA POR ERISIPELA"
  },
  {
    "codigo":292506008,
    "descripcion":"REACCIÓN ADVERSA A LA DOPEXAMINA"
  },
  {
    "codigo":126831006,
    "descripcion":"NEOPLASIA DEL PÍLORO"
  },
  {
    "codigo":94063007,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE PARTES BLANDAS DEL TRONCO"
  },
  {
    "codigo":716655008,
    "descripcion":"MASTOCITOSIS SISTÉMICA AGRESIVA"
  },
  {
    "codigo":26692000,
    "descripcion":"HIPOTIROIDISMO CENTRAL"
  },
  {
    "codigo":92228006,
    "descripcion":"NEOPLASIA BENIGNA DE MÚSCULO DE LA REGIÓN INGUINAL"
  },
  {
    "codigo":714820007,
    "descripcion":"HEMATURIA PERSISTENTE CONCOMITANTE CON GLOMERULONEFRITIS MESANGIOCAPILAR DIFUSA Y DEBIDA A ELLA"
  },
  {
    "codigo":450841000,
    "descripcion":"INCONTINENCIA URINARIA INTERMITENTE"
  },
  {
    "codigo":287001000,
    "descripcion":"CELULITIS DE PIERNA, EXCEPTO PIE"
  },
  {
    "codigo":385305003,
    "descripcion":"COMPROMISO TUMORAL DEL MARGEN DE RESECCIÓN QUIRÚRGICA NO APLICABLE"
  },
  {
    "codigo":254233004,
    "descripcion":"PELO ENSORTIJADO CONGÉNITO"
  },
  {
    "codigo":1091011000119101,
    "descripcion":"OTITIS MEDIA SUPURATIVA CRÓNICA ATICOANTRAL DERECHA"
  },
  {
    "codigo":90393004,
    "descripcion":"INTOXICACIÓN POR SORGO ALMUM"
  },
  {
    "codigo":418073009,
    "descripcion":"SEUDOPARÁLISIS POR ARTRITIS GENERALIZADA"
  },
  {
    "codigo":449006002,
    "descripcion":"HABITUALMENTE CONSUME LA MAYOR PARTE DE LA INGESTA ALIMENTARIA POR LA NOCHE"
  },
  {
    "codigo":23022004,
    "descripcion":"BRONQUIECTASIA TUBERCULOSA"
  },
  {
    "codigo":88558006,
    "descripcion":"DERMATITIS CERCARIANA DE LAS AVES DE AGUA SALADA"
  },
  {
    "codigo":283331000,
    "descripcion":"PICADURA DE INSECTO EN LA MANO"
  },
  {
    "codigo":248728000,
    "descripcion":"ESTADO DE LAS VENAS YUGULARES"
  },
  {
    "codigo":707480001,
    "descripcion":"ANEMIA HEMOLÍTICA CRÓNICA"
  },
  {
    "codigo":19352007,
    "descripcion":"SENSACIÓN DE INESTABILIDAD DE LA RODILLA"
  },
  {
    "codigo":1297304008,
    "descripcion":"CIERRE DE ÁNGULO AGUDO SECUNDARIO DE OJO IZQUIERDO"
  },
  {
    "codigo":246893001,
    "descripcion":"METAPLASIA DE LA CONJUNTIVA DEL LIMBO"
  },
  {
    "codigo":1295469004,
    "descripcion":"NEOVASCULARIZACIÓN POLIPOIDE COROIDEA DE OJO"
  },
  {
    "codigo":312429005,
    "descripcion":"ABSCESO DE SISTEMA NERVIOSO"
  },
  {
    "codigo":115821006,
    "descripcion":"FENOTIPO DE GRUPO SANGUÍNEO LUTHERAN"
  },
  {
    "codigo":212290001,
    "descripcion":"LESIÓN ABIERTA DE NERVIO SUPRACLAVICULAR"
  },
  {
    "codigo":771181009,
    "descripcion":"HIPERTRICOSIS CUBITAL"
  },
  {
    "codigo":15682004,
    "descripcion":"DIFTERIA NASAL ANTERIOR"
  },
  {
    "codigo":277826004,
    "descripcion":"ANSIEDAD ACERCA DE TRANSPIRAR"
  },
  {
    "codigo":439831002,
    "descripcion":"INCAPAZ DE SALIR DE VACACIONES POR MOTIVOS MÉDICOS"
  },
  {
    "codigo":1259031004,
    "descripcion":"SÍNDROME DE MUÑECO CABEZA DE RESORTE"
  },
  {
    "codigo":274156000,
    "descripcion":"FRACTURA DE COLUMNA CERVICAL CON LESIÓN DE MÉDULA ESPINAL"
  },
  {
    "codigo":44780000,
    "descripcion":"ALUCINACIONES HIPNAGÓGICAS"
  },
  {
    "codigo":306924001,
    "descripcion":"MOVILIDAD DEL YUNQUE DISMINUIDA"
  },
  {
    "codigo":208620001,
    "descripcion":"FRACTURA EXPUESTA DE TIBIA PROXIMAL, CÓNDILO EXTERNO (MESETA)"
  },
  {
    "codigo":110316004,
    "descripcion":"ALTURA CLÍNICAMENTE INSUFICIENTE DE CORONA DE DIENTE POR FRACTURA"
  },
  {
    "codigo":403393000,
    "descripcion":"SEUDOCICATRIZ ESTRELLADA EN LA PÚRPURA SENIL"
  },
  {
    "codigo":10177005,
    "descripcion":"SÍNDROME DE TRIPLOIDÍA, DIPLOIDÍA, MIXOPLOIDÍA"
  },
  {
    "codigo":42945005,
    "descripcion":"FRACTURA EXPUESTA DEL RADIO"
  },
  {
    "codigo":204950001,
    "descripcion":"DISPLASIA RENAL BILATERAL"
  },
  {
    "codigo":270486005,
    "descripcion":"OBESIDAD LOCALIZADA"
  },
  {
    "codigo":237718009,
    "descripcion":"GLÁNDULA HIPÓFISIS AGRANDADA"
  },
  {
    "codigo":268651002,
    "descripcion":"DIARREA PSICÓGENA"
  },
  {
    "codigo":399723004,
    "descripcion":"PÓLIPO DE INTESTINO DELGADO"
  },
  {
    "codigo":301419005,
    "descripcion":"DOLOR A LA DESCOMPRESIÓN EN FOSA ILÍACA DERECHA"
  },
  {
    "codigo":1153387007,
    "descripcion":"NEOPLASIA DE ESTROMA GASTROINTESTINAL DE COLON"
  },
  {
    "codigo":39275008,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE TESTÍCULO, CON INFECCIÓN"
  },
  {
    "codigo":234048005,
    "descripcion":"TROMBOFLEBITIS IDIOPÁTICA RECURRENTE"
  },
  {
    "codigo":397888006,
    "descripcion":"PACIENTE EN POSICIÓN SUPINA CON APOYO DE CADERA"
  },
  {
    "codigo":365120005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA SUBIR Y BAJAR ESCALONES"
  },
  {
    "codigo":70208009,
    "descripcion":"ESTADO Y DESARROLLO SEXUAL NORMAL"
  },
  {
    "codigo":15675281000119101,
    "descripcion":"TENDINITIS DE LA ARTICULACIÓN METATARSOFALÁNGICA DEL SEGUNDO DEDO DEL PIE DERECHO"
  },
  {
    "codigo":787434000,
    "descripcion":"METABOLIZADOR INTERMEDIO-RÁPIDO DE LA FAMILIA 2 SUBFAMILIA D MIEMBRO 6 DEL CITOCROMO P450"
  },
  {
    "codigo":295914000,
    "descripcion":"SOBREDOSIS DE VENLAFAXINA"
  },
  {
    "codigo":230378004,
    "descripcion":"MIELITIS TRANSVERSA AGUDA NO INFECCIOSA"
  },
  {
    "codigo":10923921000119103,
    "descripcion":"FRACTURA NO EXPUESTA DE BASE DE CUARTO HUESO METACARPIANO DE MANO IZQUIERDA"
  },
  {
    "codigo":263146007,
    "descripcion":"LESIÓN POR APLASTAMIENTO DE LIGAMENTO"
  },
  {
    "codigo":721898008,
    "descripcion":"GLAUCOMA DE ÁNGULO ABIERTO DE AMBOS OJOS CAUSADO POR CORTICOSTEROIDES"
  },
  {
    "codigo":64703005,
    "descripcion":"BRONCONEUMONÍA TERMINAL"
  },
  {
    "codigo":294079006,
    "descripcion":"ALERGIA A CICLOPENTOLATO"
  },
  {
    "codigo":31935007,
    "descripcion":"COMPLICACIÓN DEBIDA A VACUNACIÓN"
  },
  {
    "codigo":292244000,
    "descripcion":"REACCIÓN ADVERSA A LA FLUDARABINA"
  },
  {
    "codigo":95636001,
    "descripcion":"SADOMASOQUISMO"
  },
  {
    "codigo":423316001,
    "descripcion":"DIFICULTAD PARA MANEJAR LA ANDROPAUSIA"
  },
  {
    "codigo":718228001,
    "descripcion":"SÍNDROME FETAL POR YODO"
  },
  {
    "codigo":193940005,
    "descripcion":"LAGOFTALMOS CICATRIZAL"
  },
  {
    "codigo":93801000,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL FLANCO"
  },
  {
    "codigo":783764008,
    "descripcion":"PARAPLEJÍA ESPÁSTICA AUTOSÓMICA RECESIVA TIPO 56"
  },
  {
    "codigo":290409006,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR CISAPRIDA"
  },
  {
    "codigo":716393007,
    "descripcion":"CAPAZ DE POSTULARSE PARA TRABAJO VOLUNTARIO"
  },
  {
    "codigo":126569009,
    "descripcion":"NEOPLASIA DE RADIO"
  },
  {
    "codigo":91966003,
    "descripcion":"NEOPLASIA BENIGNA DE LA CORTEZA SUPRARRENAL"
  },
  {
    "codigo":124734007,
    "descripcion":"HALLAZGO EN EL PERINEO"
  },
  {
    "codigo":286739008,
    "descripcion":"RASGO DE LA PERSONALIDAD: CONCLUSIÓN DE TAREAS - HALLAZGO"
  },
  {
    "codigo":24595009,
    "descripcion":"GOTA PRIMARIA"
  },
  {
    "codigo":253971008,
    "descripcion":"DEDO BÍFIDO"
  },
  {
    "codigo":43231000087104,
    "descripcion":"HERIDA PUNZANTE DE PIERNA DERECHA CON CUERPO EXTRAÑO"
  },
  {
    "codigo":219368004,
    "descripcion":"HERIDAS DE GUERRA POR FUEGO Y CONFLAGRACIONES"
  },
  {
    "codigo":55528005,
    "descripcion":"MENOSEPSIS"
  },
  {
    "codigo":15950021000119100,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE PIEL DE MAMA DERECHA"
  },
  {
    "codigo":48351000087108,
    "descripcion":"FRACTURA DE EXTREMO PROXIMAL DE FÉMUR DERECHO"
  },
  {
    "codigo":448744007,
    "descripcion":"ANEURISMA DE SENO DE VALSALVA AÓRTICO CON RUPTURA EN ARTERIA PULMONAR"
  },
  {
    "codigo":35551000087106,
    "descripcion":"ISQUEMIA MIOCÁRDICO INFEROLATERAL"
  },
  {
    "codigo":38111000087108,
    "descripcion":"ACINESIA DE SEGMENTO ANTEROLATERAL MEDIO DE VENTRÍCULO CARDÍACO IZQUIERDO"
  },
  {
    "codigo":283069000,
    "descripcion":"RASPADURA DE LA REGIÓN OCULAR"
  },
  {
    "codigo":446909006,
    "descripcion":"VÉRTICE CARDÍACO EN LA LÍNEA MEDIA"
  },
  {
    "codigo":248466001,
    "descripcion":"TOLERANTE AL CALOR Y AL FRÍO"
  },
  {
    "codigo":707218004,
    "descripcion":"DENSIDAD ÓSEA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":314002005,
    "descripcion":"RECHAZO DE ALOINJERTO CORNEAL"
  },
  {
    "codigo":1196903001,
    "descripcion":"HEMANGIOMA BENIGNO DE INTESTINO GRUESO"
  },
  {
    "codigo":215698009,
    "descripcion":"LESIÓN SUFRIDA A BORDO DE MEDIO DE TRANSPORTE ACUÁTICO CAUSADA POR MAQUINARIA DE SALA DE MÁQUINAS, OCUPANTE DE PEQUEÑA EMBARCACIÓN SIN MOTOR LESIONADO"
  },
  {
    "codigo":246631003,
    "descripcion":"CALCULA MAL LAS DISTANCIAS"
  },
  {
    "codigo":410471004,
    "descripcion":"NEURORRETINITIS"
  },
  {
    "codigo":1295207002,
    "descripcion":"NEUROMA SOLITARIO CIRCUNSCRITO VARIEDAD PLEXIFORME"
  },
  {
    "codigo":82791007,
    "descripcion":"DELIRIO EXTRAÑO"
  },
  {
    "codigo":80956002,
    "descripcion":"SÍNDROME DE OVARIO RESISTENTE"
  },
  {
    "codigo":736316005,
    "descripcion":"TRASTORNO DISOCIATIVO CON SÍNTOMA NEUROLÓGICO CONCOMITANTE CON SÍNTOMA DE LA PRODUCCIÓN DEL HABLA"
  },
  {
    "codigo":16005471000119100,
    "descripcion":"OCLUSIÓN DE ARTERIA DISTAL DE MIEMBRO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":686431000119100,
    "descripcion":"GLIOMA MALIGNO PRIMARIO DE LÓBULO FRONTAL"
  },
  {
    "codigo":275729001,
    "descripcion":"AUDIOMETRÍA ANORMAL"
  },
  {
    "codigo":48188009,
    "descripcion":"AZOOSPERMIA"
  },
  {
    "codigo":44518003,
    "descripcion":"FETO CELOSÓMICO"
  },
  {
    "codigo":110054007,
    "descripcion":"LACERACIÓN COMPLEJA DE LA REGIÓN PERIORAL DE LA CARA"
  },
  {
    "codigo":206523001,
    "descripcion":"ÍLEO MECONIAL"
  },
  {
    "codigo":698043002,
    "descripcion":"MELANOMA MALIGNO DE PISO DE LA BOCA"
  },
  {
    "codigo":1156795003,
    "descripcion":"SARCOMA DE KAPOSI DE COLON"
  },
  {
    "codigo":1287867005,
    "descripcion":"FUGA DE AMPOLLA FILTRANTE DE OJO IZQUIERDO"
  },
  {
    "codigo":75451007,
    "descripcion":"TALASEMIA MAYOR"
  },
  {
    "codigo":10680671000119105,
    "descripcion":"NÓDULO DE PIEL DE PIE IZQUIERDO"
  },
  {
    "codigo":403131008,
    "descripcion":"EQUINOCOCOSIS CUTÁNEA"
  },
  {
    "codigo":112991000119105,
    "descripcion":"ARTROSIS DE AMBAS ARTICULACIONES DE CADERA"
  },
  {
    "codigo":11827551000119105,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA DE DEDO GORDO IZQUIERDO"
  },
  {
    "codigo":204688002,
    "descripcion":"DIVERTÍCULO DE MECKEL HIPERTRÓFICO"
  },
  {
    "codigo":15733241000119100,
    "descripcion":"QUISTE PRIMARIO DE AMBAS RETINAS"
  },
  {
    "codigo":235621000,
    "descripcion":"ESTENOSIS INFECCIOSA DE ESÓFAGO"
  },
  {
    "codigo":301157002,
    "descripcion":"PULSO FEMORAL PRESENTE"
  },
  {
    "codigo":332281000119101,
    "descripcion":"ABSCESO DE ESCLERÓTICA DE OJO DERECHO"
  },
  {
    "codigo":1251429002,
    "descripcion":"DERMATITIS ATÓPICA PRURIGINOSA DEL ADULTO"
  },
  {
    "codigo":71781005,
    "descripcion":"DISMINUCIÓN DE LA TALLA"
  },
  {
    "codigo":364858000,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA GATEAR"
  },
  {
    "codigo":366693008,
    "descripcion":"AMPLITUD DE MOVIMIENTO PASIVO DE EXTENSIÓN DEL PULGAR - HALLAZGO"
  },
  {
    "codigo":4410001,
    "descripcion":"HERNIA RETROPERITONEAL CON OBSTRUCCIÓN"
  },
  {
    "codigo":233786002,
    "descripcion":"ESTENOSIS TRAQUEAL ADQUIRIDA"
  },
  {
    "codigo":299322007,
    "descripcion":"TUMEFACCIÓN DE ARTICULACIÓN DE RODILLA"
  },
  {
    "codigo":168250008,
    "descripcion":"INOCULACIÓN ANIMAL: AUSENCIA DE MICROORGANISMOS"
  },
  {
    "codigo":789007001,
    "descripcion":"EDEMA DE LABIO CON FÓVEA"
  },
  {
    "codigo":231951002,
    "descripcion":"ATROFIA TRAUMÁTICA DEL IRIS"
  },
  {
    "codigo":199183007,
    "descripcion":"PALUDISMO MATERNO DURANTE EL EMBARAZO, PARTO Y PUERPERIO"
  },
  {
    "codigo":66276000,
    "descripcion":"PERFUSIÓN VASCULAR DE ÓRGANO O TEJIDO, AUMENTADA"
  },
  {
    "codigo":1149455007,
    "descripcion":"PERIODONTITIS GENERALIZADA ESTADIO 2 GRADO C SEGÚN LA CLASIFICACIÓN DE LAS ENFERMEDADES Y ALTERACIONES PERIODONTALES Y PERIIMPLANTARIAS DE 2017 DE LA ACADEMIA ESTADOUNIDENSE DE PERIODONTOLOGÍA Y LA FEDERACIÓN EUROPEA DE PERIODONTOLOGÍA"
  },
  {
    "codigo":787172004,
    "descripcion":"MIOPATÍA AUTOSÓMICA RECESIVA DE COMIENZO EN LA INFANCIA CON OFTALMOPLEJÍA EXTERNA"
  },
  {
    "codigo":721636006,
    "descripcion":"NEOPLASIA NEUROENDOCRINA MALIGNA PRIMARIA DE CUERPO DEL ESTÓMAGO"
  },
  {
    "codigo":262884008,
    "descripcion":"LACERACIÓN DE MESENTERIO"
  },
  {
    "codigo":197348008,
    "descripcion":"HEPATITIS EN LA SÍFILIS SECUNDARIA"
  },
  {
    "codigo":228281002,
    "descripcion":"BEBEDOR PROBLEMA"
  },
  {
    "codigo":457657000,
    "descripcion":"PERFORACIÓN DE VALVA DE VÁLVULA PULMONAR"
  },
  {
    "codigo":424889004,
    "descripcion":"SINISTROCARDIA"
  },
  {
    "codigo":162745007,
    "descripcion":"DEDOS DE LA MANO CIANÓTICOS"
  },
  {
    "codigo":291982000,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR ACETAZOLAMIDA"
  },
  {
    "codigo":160910001,
    "descripcion":"NO APTO PARA EL TRABAJO"
  },
  {
    "codigo":95374004,
    "descripcion":"INFECCIÓN DEL SITIO DE APLICACIÓN"
  },
  {
    "codigo":11774611000119103,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE PULGAR IZQUIERDO"
  },
  {
    "codigo":1142115000,
    "descripcion":"FÍSTULA URETROVAGINAL CIRCUNFERENCIAL CON COMPROMISO DEL MECANISMO DE CONTINENCIA"
  },
  {
    "codigo":124472001,
    "descripcion":"DEFICIENCIA DE AMILO - 1, 6 - GLUCOSIDASA"
  },
  {
    "codigo":1591000124100,
    "descripcion":"CON MAYOR RIESGO DE READMISIÓN HOSPITALARIA"
  },
  {
    "codigo":441911000124103,
    "descripcion":"INGESTA EXCESIVA DE VITAMINA"
  },
  {
    "codigo":386616007,
    "descripcion":"RESPIRACIÓN SUPERFICIAL"
  },
  {
    "codigo":288312009,
    "descripcion":"HERIDA DE GUERRA - CARA"
  },
  {
    "codigo":1236749003,
    "descripcion":"MASA QUE OCUPA HEMIABDOMEN IZQUIERDO"
  },
  {
    "codigo":286477003,
    "descripcion":"CAPAZ DE ESPARCIR ALIMENTOS"
  },
  {
    "codigo":688941000119102,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE PARED LATERAL DE LA VEJIGA URINARIA"
  },
  {
    "codigo":415714003,
    "descripcion":"SÍNDROME DE ABERTURA DE SALIDA TORÁCICA DEBIDO A COSTILLA CERVICAL"
  },
  {
    "codigo":448482003,
    "descripcion":"SEPSIS CAUSADA POR BACILLUS ANTHRACIS"
  },
  {
    "codigo":284642006,
    "descripcion":"ASFIXIAR A OTRA PERSONA POR SOFOCACIÓN"
  },
  {
    "codigo":86199003,
    "descripcion":"INTOXICACIÓN POR HYOSCYAMUS NIGER"
  },
  {
    "codigo":708791005,
    "descripcion":"LACERACIÓN DE BOCA"
  },
  {
    "codigo":315575008,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: HINDÚ"
  },
  {
    "codigo":248204003,
    "descripcion":"ARRUGAS FACIALES HIPOGONADALES"
  },
  {
    "codigo":117132005,
    "descripcion":"DURACIÓN DEL SOPLO CARDÍACO, CORTO"
  },
  {
    "codigo":1296780006,
    "descripcion":"HIPERTENSIÓN OCULAR POR CÉLULAS FANTASMAS DE OJO IZQUIERDO"
  },
  {
    "codigo":1231244005,
    "descripcion":"PREFERENCIA POR MIRADA HORIZONTAL"
  },
  {
    "codigo":49761000,
    "descripcion":"POLIARTRITIS INFECCIOSA CRÓNICA"
  },
  {
    "codigo":1264012009,
    "descripcion":"INFLAMACIÓN DE MÚSCULO DE MANO"
  },
  {
    "codigo":280972008,
    "descripcion":"TROMBOSIS DE INJERTO ARTERIOVENOSO"
  },
  {
    "codigo":10656711000119101,
    "descripcion":"ÚLCERA NEUROPÁTICA DE PIE MEDIO DERECHO"
  },
  {
    "codigo":15981511000119101,
    "descripcion":"ENTROPIÓN MECÁNICO DE AMBOS PÁRPADOS SUPERIORES"
  },
  {
    "codigo":705121005,
    "descripcion":"FRACTURA NO EXPUESTA DE PARED MEDIAL DE ACETÁBULO"
  },
  {
    "codigo":408374000,
    "descripcion":"FÁRMACO REEMPLAZADO POR UNA ALTERNATIVA COSTOEFECTIVA"
  },
  {
    "codigo":211766004,
    "descripcion":"QUEMADURA TIPO A EPIDÉRMICA DE GLÚTEO"
  },
  {
    "codigo":1260342005,
    "descripcion":"HIDROCEFALIA EX VACUO DEBIDA A TRASTORNO DEGENERATIVO DE CEREBRO"
  },
  {
    "codigo":703286006,
    "descripcion":"FACOMATOSIS CESIOMARMORATA"
  },
  {
    "codigo":46091002,
    "descripcion":"TRASTORNO DEL SISTEMA NERVIOSO PARASIMPÁTICO"
  },
  {
    "codigo":13323003,
    "descripcion":"PUNTAJE DE APGAR 7"
  },
  {
    "codigo":5611000122107,
    "descripcion":"ALERGIA A CASEÍNA"
  },
  {
    "codigo":766987006,
    "descripcion":"SÍNDROME DE MOEBIUS"
  },
  {
    "codigo":109792000,
    "descripcion":"CELULITIS DEL PALADAR"
  },
  {
    "codigo":44256003,
    "descripcion":"ECCEMA CRÓNICO"
  },
  {
    "codigo":765152004,
    "descripcion":"OTITIS MEDIA SEROSA CRÓNICA DE OÍDO IZQUIERDO"
  },
  {
    "codigo":240864009,
    "descripcion":"ASCARIASIS BILIAR"
  },
  {
    "codigo":763317002,
    "descripcion":"SIGNATIA CONGÉNITA AISLADA"
  },
  {
    "codigo":9653005,
    "descripcion":"DESTRUCCIÓN DE GRANULOCITOS DISMINUIDA"
  },
  {
    "codigo":402869009,
    "descripcion":"PROLIFERACIÓN VASCULAR REACTIVA DE LA PIEL"
  },
  {
    "codigo":106122003,
    "descripcion":"ADAPTACIÓN Y\/O INADAPTACIÓN DEL INDIVIDUO"
  },
  {
    "codigo":7111000119109,
    "descripcion":"HEPATITIS VIRAL, TIPO E"
  },
  {
    "codigo":15709281000119103,
    "descripcion":"INFESTACIÓN PARASITARIA DE PÁRPADOS DE AMBOS OJOS"
  },
  {
    "codigo":366431000,
    "descripcion":"HALLAZGO RELACIONADO CON LA DISTRIBUCIÓN DE LA GRASA CORPORAL"
  },
  {
    "codigo":1187466009,
    "descripcion":"PARAPLEJÍA ESPÁSTICA AUTOSÓMICA DOMINANTE TIPO 9B"
  },
  {
    "codigo":300895004,
    "descripcion":"CRISIS DE ANSIEDAD"
  },
  {
    "codigo":725044000,
    "descripcion":"SÍNDROME DE GLICOPROTEÍNAS DEFICIENTES EN CARBOHIDRATOS TIPO 1O"
  },
  {
    "codigo":102452004,
    "descripcion":"ABSCESO DE LA GLÁNDULA TIROIDES"
  },
  {
    "codigo":299060006,
    "descripcion":"TUMEFACCIÓN DE DEDO DE LA MANO"
  },
  {
    "codigo":36916008,
    "descripcion":"TRASTORNO DE LAS ARTICULACIONES Y\/O DE LOS HUESOS DE LA ESPALDA EN LA MADRE, QUE COMPLICA EL EMBARAZO, EL PARTO Y\/O EL PUERPERIO"
  },
  {
    "codigo":297225000,
    "descripcion":"FENILCETONURIA MATERNA"
  },
  {
    "codigo":67849003,
    "descripcion":"DOLOR ATROZ"
  },
  {
    "codigo":395529007,
    "descripcion":"BAJO GRADO (BIEN A MODERADAMENTE DIFERENCIADO)"
  },
  {
    "codigo":295390002,
    "descripcion":"SOBREDOSIS INTENCIONAL DE ÁCIDO 5-AMINOSALICÍLICO"
  },
  {
    "codigo":262622007,
    "descripcion":"CUERPO EXTRAÑO EN LOS ÓRGANOS GENITALES Y PERINEO FEMENINOS"
  },
  {
    "codigo":721374008,
    "descripcion":"SÍNDROME DEL CORDÓN CENTRAL DE MÉDULA ESPINAL AL NIVEL DEL TERCER SEGMENTO CERVICAL"
  },
  {
    "codigo":1145523004,
    "descripcion":"HERIDA DEBIDA A ENFERMEDAD NEOPLÁSICA MALIGNA"
  },
  {
    "codigo":1075321000119101,
    "descripcion":"DEFORMIDAD DE PIE IZQUIERDO EN FLEXIÓN PLANTAR"
  },
  {
    "codigo":15698041000119102,
    "descripcion":"ABSCESO DE BOLSA SEROSA DE AMBAS MANOS"
  },
  {
    "codigo":33401000119102,
    "descripcion":"LESIÓN INFLAMATORIA DE PÁRPADO"
  },
  {
    "codigo":43641000119102,
    "descripcion":"SÍNDROME DE RESPUESTA INFLAMATORIA SISTÉMICA SIN DISFUNCIÓN ORGÁNICA"
  },
  {
    "codigo":12398201000119102,
    "descripcion":"TRASTORNO DE ANSIEDAD CAUSADO POR METANFETAMINA"
  },
  {
    "codigo":15713401000119106,
    "descripcion":"DEFORMIDAD EN CUELLO DE CISNE DE LOS DEDOS DE AMBAS MANOS"
  },
  {
    "codigo":87161000119107,
    "descripcion":"EPENDIMOMA CEREBRAL BENIGNO"
  },
  {
    "codigo":162483007,
    "descripcion":"FACTORES QUE MEJORAN EL SÍNTOMA"
  },
  {
    "codigo":291961000119105,
    "descripcion":"TRASTORNO DE NERVIO FEMORAL IZQUIERDO"
  },
  {
    "codigo":66681000119107,
    "descripcion":"PORTADOR DE SÍNDROME DE VON HIPPEL-LINDAU"
  },
  {
    "codigo":11822201000119107,
    "descripcion":"LUXACIÓN NO EXPUESTA DE ARTICULACIÓN ACROMIOCLAVICULAR DERECHA"
  },
  {
    "codigo":11840121000119105,
    "descripcion":"HEMATOMA DE REGIÓN AURICULAR IZQUIERDA"
  },
  {
    "codigo":30841000119109,
    "descripcion":"CONTUSIÓN DE REGIÓN ESTERNAL"
  },
  {
    "codigo":135801000119109,
    "descripcion":"COMPRESIÓN DE CEREBRO DEBIDA A LESIÓN FOCAL"
  },
  {
    "codigo":121000119106,
    "descripcion":"LESIÓN DE PIEL DE CARA"
  },
  {
    "codigo":350841000119107,
    "descripcion":"NEOPLASIA BENIGNA DE ENCÉFALO INFRATENTORIAL"
  },
  {
    "codigo":11781241000119109,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO POSTERIOR DE MUSLO DERECHO"
  },
  {
    "codigo":15739001000119109,
    "descripcion":"GLAUCOMA DE OJO DERECHO DEBIDO A ANOMALÍA CONGÉNITA DE IRIS"
  },
  {
    "codigo":93277007,
    "descripcion":"HIPOPLASIA CONGÉNITA DEL TABIQUE NASAL"
  },
  {
    "codigo":224349001,
    "descripcion":"AFECTADO POR PROCEDIMIENTOS LEGALES"
  },
  {
    "codigo":25906001,
    "descripcion":"TRASTORNO DEL OÍDO"
  },
  {
    "codigo":27741009,
    "descripcion":"TENDINITIS CALCIFICANTE DE HOMBRO"
  },
  {
    "codigo":91442002,
    "descripcion":"ESTENOSIS DE VÁLVULA PULMONAR REUMÁTICA"
  },
  {
    "codigo":60509004,
    "descripcion":"INFECCIÓN CAUSADA POR THYSANOSOMA ACTINIOIDES"
  },
  {
    "codigo":286215002,
    "descripcion":"NO EMPLEA APOYO RESPIRATORIO AL HABLAR"
  },
  {
    "codigo":1269255003,
    "descripcion":"DAÑO DE ÓRGANO DE PELVIS DEBIDO A ABORTO INCOMPLETO"
  },
  {
    "codigo":253447006,
    "descripcion":"CUERDAS TENDINOSAS DE VÁLVULA AURICULOVENTRICULAR COMÚN EN EL TABIQUE DE SALIDA"
  },
  {
    "codigo":1300188000,
    "descripcion":"HIPOPLASIA PONTOCEREBELOSA CONGÉNITA TIPO 11"
  },
  {
    "codigo":251612001,
    "descripcion":"POTENCIAL EVOCADO AUDITIVO, LATENCIA NORMAL DE LA ONDA I CON LATENCIA AUMENTADA DE LAS ONDAS RESTANTES"
  },
  {
    "codigo":55004003,
    "descripcion":"SÍNDROME DE SECRECIÓN INADECUADA DE HORMONA ANTIDIURÉTICA"
  },
  {
    "codigo":448220006,
    "descripcion":"LINFOMA NO HODGKIN DE HUESO"
  },
  {
    "codigo":282545000,
    "descripcion":"DIFICULTAD PARA PARAR DE CORRER"
  },
  {
    "codigo":774065001,
    "descripcion":"SÍNDROME DE LEUCONIQUIA TOTAL, QUISTES TRIQUILÉMICOS Y DISTROFIA CILIAR"
  },
  {
    "codigo":247942003,
    "descripcion":"COLECCIÓN DE OBJETOS - RUTINA ESTEREOTIPADA"
  },
  {
    "codigo":1362054007,
    "descripcion":"PLIEGUE DE EPICANTO"
  },
  {
    "codigo":444550009,
    "descripcion":"ANOMALÍA DEL DESARROLLO DE LA APÓFISIS ODONTOIDES DEL AXIS"
  },
  {
    "codigo":442715002,
    "descripcion":"ATRAPAMIENTO DE INTESTINO EN FRACTURA DE LA COLUMNA VERTEBRAL"
  },
  {
    "codigo":735792000,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DE REGIÓN LUMBAR"
  },
  {
    "codigo":1260080001,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS DE SENO MAXILAR"
  },
  {
    "codigo":703024002,
    "descripcion":"PARECHOVIRUS HUMANO 1 O PARECHOVIRUS HUMANO 2"
  },
  {
    "codigo":47664006,
    "descripcion":"TRASTORNO PSICÓTICO CON ALUCINACIONES INDUCIDO POR SEDANTES, HIPNÓTICOS Y\/O ANSIOLÍTICOS"
  },
  {
    "codigo":768560008,
    "descripcion":"DEFICIENCIA DE MDA5"
  },
  {
    "codigo":80432009,
    "descripcion":"POROQUERATOSIS DE MIBELLI"
  },
  {
    "codigo":111365004,
    "descripcion":"HERNIA INGUINAL INDIRECTA FUNICULAR"
  },
  {
    "codigo":733957004,
    "descripcion":"CARIES DENTAL INACTIVA SECUNDARIA QUE SE EXTIENDE HASTA EL TERCIO EXTERNO DE LA DENTINA"
  },
  {
    "codigo":209669007,
    "descripcion":"SECCIÓN EXPUESTA DE LIGAMENTO DE LA MUÑECA"
  },
  {
    "codigo":76762001,
    "descripcion":"MIOPATÍA EOSINÓFILA"
  },
  {
    "codigo":43994002,
    "descripcion":"CONDUCTA QUE DENOTA UNA DISMINUCIÓN DE LA ACTIVIDAD MOTRIZ"
  },
  {
    "codigo":1354714003,
    "descripcion":"FRACTURA DE SEGUNDA COSTILLA"
  },
  {
    "codigo":11226001,
    "descripcion":"CICLITIS HETEROCRÓMICA DE FUCHS"
  },
  {
    "codigo":699354006,
    "descripcion":"SARCOMA DE ÓRBITA"
  },
  {
    "codigo":240602008,
    "descripcion":"LINFOGRANULOMA VENÉREO TEMPRANO"
  },
  {
    "codigo":249096006,
    "descripcion":"POSICIÓN BREGMAILÍACA TRANSVERSA"
  },
  {
    "codigo":304303003,
    "descripcion":"AMPLITUD DE MOVIMIENTO DE LA MUÑECA NORMAL"
  },
  {
    "codigo":402607006,
    "descripcion":"PIGMENTACIÓN CONSTITUCIONAL DE LA PIEL-HALLAZGO"
  },
  {
    "codigo":204164000,
    "descripcion":"ESCLERÓTICA AZUL"
  },
  {
    "codigo":269700008,
    "descripcion":"EFECTO DE LA IGNICIÓN DE LAS VESTIMENTAS POR INCENDIO DE LA ROPA DE CAMA"
  },
  {
    "codigo":366169002,
    "descripcion":"EJE DE LA ONDA P EN EL ELECTROCARDIOGRAMA - HALLAZGO"
  },
  {
    "codigo":202329003,
    "descripcion":"LESIÓN DE BANKART"
  },
  {
    "codigo":726617002,
    "descripcion":"DISTROFIA MUSCULAR DE LAS CINTURAS DE LAS EXTREMIDADES TIPO 2N AUTOSÓMICA RECESIVA"
  },
  {
    "codigo":398937006,
    "descripcion":"ANEMIA HEMOLÍTICA AUTOINMUNITARIA POR CRIOAGLUTININAS"
  },
  {
    "codigo":169561007,
    "descripcion":"EMBARAZADA - CONFIRMACIÓN POR ANÁLISIS DE SANGRE"
  },
  {
    "codigo":235097009,
    "descripcion":"INCISIVOS BORDE A BORDE"
  },
  {
    "codigo":3886001,
    "descripcion":"FECALITOS CONGÉNITOS"
  },
  {
    "codigo":1281838003,
    "descripcion":"CRISIS EPILÉPTICA EMOCIONAL CON ALTERACIÓN DE CONCIENCIA DE INICIO FOCAL"
  },
  {
    "codigo":724782005,
    "descripcion":"DESMIELINIZACIÓN DE SISTEMA NERVIOSO CENTRAL CONCOMITANTE CON ENFERMEDAD DE SJOGREN Y DEBIDA A ELLA"
  },
  {
    "codigo":298798007,
    "descripcion":"AMPLITUD DE ABDUCCIÓN ACTIVA DE HOMBRO NORMAL"
  },
  {
    "codigo":34819000,
    "descripcion":"INTOXICACIÓN POR PINUS"
  },
  {
    "codigo":1148931000,
    "descripcion":"CARCINOMA QUÍSTICO DE CÉLULAS RENALES"
  },
  {
    "codigo":264195003,
    "descripcion":"BANDA DE SIMONART"
  },
  {
    "codigo":722947004,
    "descripcion":"RAQUITISMO HIPOCALCÉMICO"
  },
  {
    "codigo":788483004,
    "descripcion":"TRASTORNO DE MOVIMIENTO REPETITIVO DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":198659007,
    "descripcion":"ABORTO ESPONTÁNEO COMPLETO CON INSUFICIENCIA RENAL"
  },
  {
    "codigo":10743651000119105,
    "descripcion":"INFLAMACIÓN DEL CUELLO UTERINO EN EL EMBARAZO"
  },
  {
    "codigo":32984002,
    "descripcion":"POLICITEMIA NEONATAL"
  },
  {
    "codigo":65752003,
    "descripcion":"FRACTURA SUBCONDÍLEA DE MANDÍBULA NO EXPUESTA"
  },
  {
    "codigo":360664004,
    "descripcion":"DEFICIENCIA DE METOXILASA DE PECTINA"
  },
  {
    "codigo":216004,
    "descripcion":"DELIRIO DE PERSECUCIÓN"
  },
  {
    "codigo":293293001,
    "descripcion":"REACCIÓN ADVERSA A LA TIROTROFINA"
  },
  {
    "codigo":94850000,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA VESÍCULA BILIAR"
  },
  {
    "codigo":162221009,
    "descripcion":"INQUIETUD MOTRIZ"
  },
  {
    "codigo":291458002,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR PROGUANIL"
  },
  {
    "codigo":225922003,
    "descripcion":"CONTENIDO DE LA CONVERSACIÓN RACIONAL"
  },
  {
    "codigo":231421000119102,
    "descripcion":"NIÑO VÍCTIMA DE NEGLIGENCIA NUTRICIONAL"
  },
  {
    "codigo":194989009,
    "descripcion":"TRASTORNO DE VÁLVULA TRICÚSPIDE, NO REUMÁTICO"
  },
  {
    "codigo":387927001,
    "descripcion":"NEOPLASIA DEL SISTEMA ENDOCRINO"
  },
  {
    "codigo":93015002,
    "descripcion":"ANOMALÍA CONGÉNITA DE HUESO PARIETAL"
  },
  {
    "codigo":1010519002,
    "descripcion":"ESCLEROSIS DE EPÍFISIS DE FALANGE PROXIMAL DE DEDO GORDO CON RADIOPACIDAD AUMENTADA"
  },
  {
    "codigo":846679001,
    "descripcion":"EXAGERACIÓN DE REFLEJO SUPRARROTULIANO"
  },
  {
    "codigo":313341000119104,
    "descripcion":"ARTROFITO EN ARTICULACIÓN DE CODO IZQUIERDO"
  },
  {
    "codigo":289623005,
    "descripcion":"CUERPO DEL ÚTERO AUSENTE"
  },
  {
    "codigo":224087003,
    "descripcion":"SIN FAMILIARES"
  },
  {
    "codigo":420695009,
    "descripcion":"AUSENCIA DE SIGNOS PRECORDIALES"
  },
  {
    "codigo":255020006,
    "descripcion":"LEIOMIOMA DE CUERPO CILIAR"
  },
  {
    "codigo":189484008,
    "descripcion":"NEOPLASIA DE CEREBRO Y MÉDULA ESPINAL DE COMPORTAMIENTO INCIERTO"
  },
  {
    "codigo":123948009,
    "descripcion":"TRASTORNO DESPUÉS DE ENFERMEDAD VIRAL"
  },
  {
    "codigo":91180009,
    "descripcion":"SEUDOHIPOALDOSTERONISMO, TIPO 1, FORMA RECESIVA"
  },
  {
    "codigo":253185002,
    "descripcion":"MALFORMACIÓN DE CHIARI TIPO I"
  },
  {
    "codigo":285953006,
    "descripcion":"CAPAZ DE INSERTAR EL TAPÓN DEL DESAGÜE"
  },
  {
    "codigo":87510000,
    "descripcion":"PERITONITIS CRÓNICA"
  },
  {
    "codigo":449793009,
    "descripcion":"HEMORRAGIA EN ESPACIO SUBDURAL DE NEUROEJE"
  },
  {
    "codigo":185814002,
    "descripcion":"ASISTE AL CONTROL DE SALUD - MASCULINO"
  },
  {
    "codigo":251350003,
    "descripcion":"REACCIÓN CUTÁNEA DÉBIL"
  },
  {
    "codigo":218582007,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR GLÓBULOS ROJOS CONCENTRADOS"
  },
  {
    "codigo":284118008,
    "descripcion":"CONTROLA LA POSICIÓN DE LA CINTURA ESCAPULAR"
  },
  {
    "codigo":249515001,
    "descripcion":"EVACUACIÓN INCOMPLETA DEL INTESTINO"
  },
  {
    "codigo":710102007,
    "descripcion":"GRADO DE INCLINACIÓN DEL PLANO OCLUSAL CON PENDIENTE HACIA LA DERECHA DEBIDO A ASIMETRÍA DENTAL"
  },
  {
    "codigo":216747003,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR SUSTANCIA AROMÁTICA CORROSIVA"
  },
  {
    "codigo":315051004,
    "descripcion":"DIABETES RESUELTA"
  },
  {
    "codigo":16916631000119104,
    "descripcion":"INFECCIÓN URINARIA POR STREPTOCOCCUS AGALACTIAE"
  },
  {
    "codigo":446123007,
    "descripcion":"ABSCESO TUBERCULOSO"
  },
  {
    "codigo":870272002,
    "descripcion":"ARTRITIS REACTIVA DEBIDA A MICOBACTERIOSIS Y POSTERIOR A ELLA"
  },
  {
    "codigo":247680004,
    "descripcion":"DELIRIO CON RESPECTO AL ASPECTO"
  },
  {
    "codigo":16015511000119106,
    "descripcion":"TRASTORNO ÓSEO DE ARTICULACIÓN DE TOBILLO IZQUIERDO POSTERIOR A POLIOMIELITIS"
  },
  {
    "codigo":1359957000,
    "descripcion":"HERIDA ABIERTA DE PULGAR DEBIDA A MORDEDURA DE GATO"
  },
  {
    "codigo":278613003,
    "descripcion":"HALLAZGO RELACIONADO CON EL AJUSTE DE PRÓTESIS MAXILOFACIAL"
  },
  {
    "codigo":49237006,
    "descripcion":"DIARREA ALÉRGICA"
  },
  {
    "codigo":47402002,
    "descripcion":"FRACTURA EXPUESTA DE DOS COSTILLAS"
  },
  {
    "codigo":1079601000119103,
    "descripcion":"CONDROSARCOMA PRIMARIO DE HUESO DE EXTREMIDAD SUPERIOR DERECHA"
  },
  {
    "codigo":209407000,
    "descripcion":"FRACTURA-SUBLUXACIÓN EXPUESTA DE LA ARTICULACIÓN ESTERNOCLAVICULAR, POSTERIOR"
  },
  {
    "codigo":735530009,
    "descripcion":"TRASTORNO OCULAR CAUSADO POR TOXOPLASMA GONDII"
  },
  {
    "codigo":1259818008,
    "descripcion":"ASTROCITOMA PILOMIXOIDE PRIMARIO DE CEREBRO"
  },
  {
    "codigo":210696006,
    "descripcion":"SECCIÓN COMPLETA DEL TENDÓN CALCÁNEO (TENDÓN DE AQUILES)"
  },
  {
    "codigo":1290751005,
    "descripcion":"SARCOMA PLEOMÓRFICO INDIFERENCIADO"
  },
  {
    "codigo":406015006,
    "descripcion":"OVARIO DERECHO AUSENTE EN EL ESPÉCIMEN"
  },
  {
    "codigo":438783006,
    "descripcion":"INSUFICIENCIA RENAL AGUDA POSOPERATORIA"
  },
  {
    "codigo":764628000,
    "descripcion":"SÍNDROME DE TRISOMÍA 4 MOSAICO"
  },
  {
    "codigo":342321000119105,
    "descripcion":"HIPERTRICOSIS DE PÁRPADO SUPERIOR DERECHO"
  },
  {
    "codigo":10964002,
    "descripcion":"HIPERTENSIÓN PULMONAR PROGRESIVA"
  },
  {
    "codigo":45567009,
    "descripcion":"INTOXICACIÓN POR LUPINUS SERICEUS"
  },
  {
    "codigo":43732005,
    "descripcion":"MOTILIDAD INTESTINAL DISCORDANTE"
  },
  {
    "codigo":109268007,
    "descripcion":"MELANOMA IN SITU DE UNA REGIÓN NO CUTÁNEA"
  },
  {
    "codigo":238505000,
    "descripcion":"REACCIÓN CUTÁNEA CAUSADA POR MATERIAL DE SUTURA"
  },
  {
    "codigo":305876009,
    "descripcion":"VISTO POR EL SERVICIO DE OBSTETRICIA"
  },
  {
    "codigo":15634891000119101,
    "descripcion":"DEFORMIDAD DE AMBOS PIES EN FLEXIÓN PLANTAR"
  },
  {
    "codigo":402345004,
    "descripcion":"DESCAMACIÓN CUTÁNEA LUEGO DE ENFERMEDAD FEBRIL"
  },
  {
    "codigo":1156009005,
    "descripcion":"INTOXICACIÓN ACCIDENTAL CAUSADA POR CIANURO Y\/O DERIVADO DE CIANURO"
  },
  {
    "codigo":236670006,
    "descripcion":"URINOMA PARAVESICAL"
  },
  {
    "codigo":344571000119105,
    "descripcion":"COROIDITIS FOCAL PERIFÉRICA DE AMBOS OJOS"
  },
  {
    "codigo":726355001,
    "descripcion":"TRISOMÍA PARCIAL DE CROMOSOMA 16"
  },
  {
    "codigo":300371005,
    "descripcion":"IMPOSIBILIDAD PARA ERUCTAR"
  },
  {
    "codigo":70995007,
    "descripcion":"HIPERTENSIÓN PULMONAR"
  },
  {
    "codigo":365907008,
    "descripcion":"MEMORIA ACTUAL - HALLAZGO"
  },
  {
    "codigo":724520002,
    "descripcion":"ÚLCERA DE ESTÓMAGO DEBIDA A GASTRITIS EOSINOFÍLICA"
  },
  {
    "codigo":298536005,
    "descripcion":"AMPLITUD DE FLEXIÓN LATERAL PASIVA HACIA LA DERECHA DE LA COLUMNA VERTEBRAL DORSAL, NORMAL"
  },
  {
    "codigo":296701003,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE CEFUROXIMA"
  },
  {
    "codigo":427773004,
    "descripcion":"FRACTURA EXPUESTA, NO DESPLAZADA, DE HUESO NASAL"
  },
  {
    "codigo":722685004,
    "descripcion":"ADENOCARCINOMA SEROSO PRIMARIO DE ALTO GRADO DE OVARIO"
  },
  {
    "codigo":1279741006,
    "descripcion":"FRACTURA ABIERTA DE METÁFISIS DE RADIO DISTAL"
  },
  {
    "codigo":165629007,
    "descripcion":"CAPACIDAD DE FIJACIÓN DE HIERRO TOTAL DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1148669008,
    "descripcion":"RESPUESTA AUSENTE DE ELECTRORRETINOGRAMA CON ADAPTACIÓN A LA LUZ Y A LA OSCURIDAD"
  },
  {
    "codigo":131026001,
    "descripcion":"NIVEL DE GONADOTROFINA HIPOFISARIA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":32722006,
    "descripcion":"INTOXICACIÓN CAUSADA POR HIDRÓXIDO DE ALUMINIO"
  },
  {
    "codigo":720850008,
    "descripcion":"SÍNDROME DE ATROFIA COROIDEA Y ALOPECIA"
  },
  {
    "codigo":260263000,
    "descripcion":"N4.5"
  },
  {
    "codigo":30887000,
    "descripcion":"ESTAQUIBOTRIOTOXICOSIS"
  },
  {
    "codigo":194727002,
    "descripcion":"ESTENOSIS NO REUMÁTICA DE VÁLVULA MITRAL"
  },
  {
    "codigo":293031008,
    "descripcion":"REACCIÓN ADVERSA AL NIMORAZOL"
  },
  {
    "codigo":127356001,
    "descripcion":"VITAMINA E POR DEBAJO DE RANGO DE REFERENCIA"
  },
  {
    "codigo":29052002,
    "descripcion":"PULMÓN DERECHO BILOBULADO"
  },
  {
    "codigo":291196005,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR PERFENAZINA"
  },
  {
    "codigo":225660005,
    "descripcion":"CREE QUE LOS TELÉFONOS ESTÁN INTERVENIDOS"
  },
  {
    "codigo":289361001,
    "descripcion":"CABEZA FETAL EXTENDIDA"
  },
  {
    "codigo":94588009,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE PARTES BLANDAS DE REGIÓN INGUINAL"
  },
  {
    "codigo":672511000119101,
    "descripcion":"DISARTRIA DEBIDA A ACCIDENTE CEREBROVASCULAR HEMORRÁGICO Y POSTERIOR A ÉL"
  },
  {
    "codigo":387665005,
    "descripcion":"ABSCESO DE LA PULPA"
  },
  {
    "codigo":92753005,
    "descripcion":"CARCINOMA IN SITU DE SENO ESFENOIDAL"
  },
  {
    "codigo":715345007,
    "descripcion":"ENFERMEDAD DE PARKINSON DE COMIENZO TEMPRANO"
  },
  {
    "codigo":58150001,
    "descripcion":"FRACTURA DE CLAVÍCULA"
  },
  {
    "codigo":844582002,
    "descripcion":"CALIDAD DE VIDA ALTERADA"
  },
  {
    "codigo":713510001,
    "descripcion":"AUMENTO DE TAMAÑO DEL HÍGADO CONCOMITANTE CON INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":254758008,
    "descripcion":"TUMOR CUTÁNEO DE ORIGEN NEURAL"
  },
  {
    "codigo":344831000119105,
    "descripcion":"EDEMA DE AMBAS ÓRBITAS"
  },
  {
    "codigo":283856000,
    "descripcion":"LESIÓN POR APLASTAMIENTO DE LA REGIÓN ANTERIOR DEL CUELLO"
  },
  {
    "codigo":447696004,
    "descripcion":"VÁLVULA AÓRTICA UNICÚSPIDE UNICOMISURAL"
  },
  {
    "codigo":52645000,
    "descripcion":"ENFERMEDAD FUNCIONAL PRESENTE"
  },
  {
    "codigo":19877001,
    "descripcion":"RINOFIMA"
  },
  {
    "codigo":87248009,
    "descripcion":"NECROSIS HEPÁTICA"
  },
  {
    "codigo":183717003,
    "descripcion":"CONSULTA DOMICILIARIA PSIQUIÁTRICA SOLICITADA"
  },
  {
    "codigo":216485004,
    "descripcion":"INTOXICACIÓN ACCIDENTAL CAUSADA POR INDOMETACINA"
  },
  {
    "codigo":118181005,
    "descripcion":"HALLAZGO RELACIONADO CON LA PRODUCCIÓN DE LÍQUIDO AMNIÓTICO"
  },
  {
    "codigo":249253007,
    "descripcion":"HALLAZGO EN EL PREPUCIO"
  },
  {
    "codigo":17151000119108,
    "descripcion":"DEFICIENCIA PARCIAL DE HORMONA DE CRECIMIENTO"
  },
  {
    "codigo":312954003,
    "descripcion":"IDIOMA NO DOCUMENTADO"
  },
  {
    "codigo":1197690003,
    "descripcion":"ÚLCERA DUODENAL DEBIDA A SARCOIDOSIS"
  },
  {
    "codigo":1082111000119109,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE LÓBULO INFERIOR DE PULMÓN IZQUIERDO"
  },
  {
    "codigo":247418006,
    "descripcion":"DOLOR SUPERFICIAL DURANTE EL COITO"
  },
  {
    "codigo":442191002,
    "descripcion":"ESTEATOHEPATITIS"
  },
  {
    "codigo":1163087003,
    "descripcion":"PERITONITIS INFECCIOSA AGUDA"
  },
  {
    "codigo":48975005,
    "descripcion":"TRABAJO DE PARTO INDUCIDO"
  },
  {
    "codigo":704335006,
    "descripcion":"FRACTURA OSTEOPORÓTICA DE HÚMERO"
  },
  {
    "codigo":16207008,
    "descripcion":"LACTANCIA POSMADURA"
  },
  {
    "codigo":407588003,
    "descripcion":"INCAPAZ DE COMPLETAR UNA ORACIÓN EN UN CICLO RESPIRATORIO"
  },
  {
    "codigo":1259556004,
    "descripcion":"ENCEFALOPATÍA ANÓXICA DEBIDA A PARO CARDÍACO"
  },
  {
    "codigo":241913000,
    "descripcion":"IMPERMEABILIZANTE PARA CALZADO QUE CAUSA EFECTOS TÓXICOS"
  },
  {
    "codigo":276516009,
    "descripcion":"ISQUEMIA MIOCÁRDICA DEL RECIÉN NACIDO"
  },
  {
    "codigo":405753002,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA COLA DE CABALLO SIN LESIÓN ÓSEA VERTEBRAL"
  },
  {
    "codigo":274681003,
    "descripcion":"HALLAZGO MICROBIOLÓGICO ANORMAL EN ESPÉCIMEN DE ÓRGANO GENITAL FEMENINO"
  },
  {
    "codigo":1290489001,
    "descripcion":"TRASTORNO DE TENDÓN DE MANO"
  },
  {
    "codigo":372985005,
    "descripcion":"INFECCIÓN CAUSADA POR ASPERGILLUS JANUS"
  },
  {
    "codigo":11787161000119107,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE DEDO MEDIO IZQUIERDO"
  },
  {
    "codigo":305614000,
    "descripcion":"BAJO ATENCIÓN DE FISIOTERAPEUTA EXTRAHOSPITALARIO"
  },
  {
    "codigo":209145009,
    "descripcion":"SUBLUXACIÓN VERTEBRAL NO EXPUESTA CON LESIÓN MEDULAR COMPLETA A NIVEL CERVICAL"
  },
  {
    "codigo":403918002,
    "descripcion":"CARCINOMA BASOCELULAR DE GLABELA"
  },
  {
    "codigo":471289009,
    "descripcion":"ORIGEN ANÓMALO DE ARTERIA CIRCUNFLEJA EN SENO AÓRTICO A LA DER. DE SENO AÓRTICO NO ENFRENTADO Y ORIGEN ANÓMALO DE ARTERIA CORONARIA DESCENDENTE ANTERIOR IZQ.Y ARTERIA CORONARIA DER. EN SENO AÓRTICO A LA IZQ. DE SENO AÓRTICO NO ENFRENTADO"
  },
  {
    "codigo":10859571000119103,
    "descripcion":"ASPIRACIÓN DE CONTENIDO GÁSTRICO HACIA TRÁQUEA"
  },
  {
    "codigo":240078009,
    "descripcion":"DISTROFIA MUSCULAR CONGÉNITA BENIGNA CON CONTRACTURAS EN FLEXIÓN DE LOS DEDOS DE LA MANO"
  },
  {
    "codigo":1255886009,
    "descripcion":"MICOSIS FUNGOIDE DE GANGLIOS LINFÁTICOS DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":762531008,
    "descripcion":"HIPERSENSIBILIDAD RENAL CAUSADA POR FÁRMACO"
  },
  {
    "codigo":11842611000119105,
    "descripcion":"RUPTURA TRAUMÁTICA DE TENDÓN DE REGIÓN DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":72568002,
    "descripcion":"DERMATITIS DE LA UNIÓN DERMOEPIDÉRMICA, TIPO VACUOLAR"
  },
  {
    "codigo":203640005,
    "descripcion":"CIFOESCOLIOSIS IDIOPÁTICA"
  },
  {
    "codigo":301944006,
    "descripcion":"AUSENCIA DE REACCIÓN PUPILAR A LA LUZ"
  },
  {
    "codigo":201805000,
    "descripcion":"ARTRITIS JUVENIL EN LA ENFERMEDAD DE CROHN"
  },
  {
    "codigo":234573000,
    "descripcion":"DEFECTO DE CÉLULA FAGOCÍTICA"
  },
  {
    "codigo":300109000,
    "descripcion":"HALLAZGO RELACIONADO CON LA TEMPERATURA DEL PABELLÓN AURICULAR"
  },
  {
    "codigo":347341000119101,
    "descripcion":"DACRIOADENITIS AGUDA DE AMBOS OJOS"
  },
  {
    "codigo":365645007,
    "descripcion":"HALLAZGO DE GENOTIPO RH"
  },
  {
    "codigo":70733008,
    "descripcion":"LIMITACIÓN DEL MOVIMIENTO ARTICULAR"
  },
  {
    "codigo":298274001,
    "descripcion":"AGRANDAMIENTO DE MÚSCULO ESQUELÉTICO"
  },
  {
    "codigo":68898005,
    "descripcion":"CONJUNTIVITIS CATARRAL"
  },
  {
    "codigo":787959001,
    "descripcion":"PAENIBACILLUS PABULI O PAENIBACILLUS POLYMYXA"
  },
  {
    "codigo":198135001,
    "descripcion":"PERISALPINGITIS AGUDA"
  },
  {
    "codigo":394743007,
    "descripcion":"SEXO DESCONOCIDO"
  },
  {
    "codigo":296439007,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE AMINOFILINA"
  },
  {
    "codigo":294604003,
    "descripcion":"ALERGIA A CLIOQUINOL"
  },
  {
    "codigo":720588004,
    "descripcion":"SENSIBILIDAD A FÁRMACO NO MEDIADA POR INMUNOGLOBULINA"
  },
  {
    "codigo":292769001,
    "descripcion":"REACCIÓN ADVERSA A PREPARADO ANTIHEMORROIDAL"
  },
  {
    "codigo":718753002,
    "descripcion":"ATAXIA EPISÓDICA TIPO 6"
  },
  {
    "codigo":63393005,
    "descripcion":"ANOREXIA NERVIOSA, TIPO COMPULSIVO\/PURGATIVO"
  },
  {
    "codigo":784289008,
    "descripcion":"PARÁLISIS DE NERVIO"
  },
  {
    "codigo":192630004,
    "descripcion":"TRASTORNO ALIMENTARIO PSICÓGENO EN LA LACTANCIA Y LA NIÑEZ"
  },
  {
    "codigo":28790007,
    "descripcion":"OBSTRUCCIÓN DE LA ARTERIA CEREBRAL ANTERIOR"
  },
  {
    "codigo":289099000,
    "descripcion":"NO RESPIRA PROFUNDAMENTE"
  },
  {
    "codigo":94326009,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA CABEZA"
  },
  {
    "codigo":127094008,
    "descripcion":"LINFADENOPATÍA PRETRAQUEAL"
  },
  {
    "codigo":61558009,
    "descripcion":"PERICARDITIS INDUCIDA POR HIDRALAZINA"
  },
  {
    "codigo":715083004,
    "descripcion":"CAPAZ DE PASAR DEL INODORO A UNA SILLA DE RUEDAS"
  },
  {
    "codigo":92491006,
    "descripcion":"CENTRO CARTILAGINOSO DE VÉRTEBRA SACRA HENDIDO"
  },
  {
    "codigo":449269003,
    "descripcion":"SARCOMA DE COSTILLA"
  },
  {
    "codigo":23285006,
    "descripcion":"COITO DOLOROSO MASCULINO"
  },
  {
    "codigo":86986002,
    "descripcion":"ENFERMEDAD HEMOLÍTICA DEL FETO O RECIÉN NACIDO POR ISOINMUNIZACIÓN RHD"
  },
  {
    "codigo":1332170002,
    "descripcion":"ÚLCERA VENOSA DE PANTORRILLA"
  },
  {
    "codigo":185290003,
    "descripcion":"VISTO POR MÉDICO REEMPLAZANTE"
  },
  {
    "codigo":283594005,
    "descripcion":"HERIDA DE PERDIGÓN EN PLANTA DEL PIE"
  },
  {
    "codigo":414666009,
    "descripcion":"MENINGIOMA DE ÓRBITA"
  },
  {
    "codigo":1363103002,
    "descripcion":"ASTILLA EN CABEZA"
  },
  {
    "codigo":871583003,
    "descripcion":"ANOMALÍA CONGÉNITA DE VÁLVULA AURICULOVENTRICULAR DEL LADO IZQUIERDO EN VENTRÍCULO CON DOBLE ENTRADA"
  },
  {
    "codigo":773279006,
    "descripcion":"SÍNDROME DE POLIDACTILIA POSTAXIAL Y ANOMALÍAS DENTALES Y VERTEBRALES"
  },
  {
    "codigo":314527009,
    "descripcion":"ANTÍGENO DE CHLAMYDIA DETECTADO POR ENSAYO DE INMUNOADSORCIÓN LIGADO A ENZIMAS"
  },
  {
    "codigo":247156002,
    "descripcion":"EXUDADO SUBRETINIANO"
  },
  {
    "codigo":771444002,
    "descripcion":"ACIDURIA METILMALÓNICA POR DEFECTO DEL RECEPTOR DE TRANSCOBALAMINA"
  },
  {
    "codigo":1197428008,
    "descripcion":"ESPECTRO DE INMUNODEFICIENCIA COMBINADA Y ENTEROPATÍA"
  },
  {
    "codigo":48713002,
    "descripcion":"NEFROPATÍA AMILOIDE"
  },
  {
    "codigo":310857002,
    "descripcion":"INFORME DE VIVIENDA PAGADO"
  },
  {
    "codigo":1162825003,
    "descripcion":"SOBREDOSIS INTENCIONAL DE VITAMINA D Y\/O DERIVADO DE VITAMINA D"
  },
  {
    "codigo":15945005,
    "descripcion":"POLIDIPSIA PSICÓGENA"
  },
  {
    "codigo":210718000,
    "descripcion":"SECCIÓN PARCIAL, TENDÓN DEL MÚSCULO FLEXOR DEL PIE"
  },
  {
    "codigo":866078000,
    "descripcion":"INFECCIÓN CAUSADA POR ANGIOSTRONGYLUS COSTARICENSIS"
  },
  {
    "codigo":276254008,
    "descripcion":"RECLUTAMIENTO TEMPRANO DE UNIDAD POLIFÁSICA MOTORA DE CORTA DURACIÓN CON ACTIVIDAD ESPONTÁNEA ANORMAL EN EL ELECTROMIOGRAMA"
  },
  {
    "codigo":405491001,
    "descripcion":"INCIDENTE ADVERSO QUE NO OCASIONA EFECTO PERJUDICIAL"
  },
  {
    "codigo":208883004,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA EXPUESTA DE DÍGITO DE MANO"
  },
  {
    "codigo":733171006,
    "descripcion":"ASPERGILOSIS PULMONAR CRÓNICA"
  },
  {
    "codigo":403656003,
    "descripcion":"ROSÁCEA CAUSADA POR CORTICOSTEROIDE TÓPICO"
  },
  {
    "codigo":272584004,
    "descripcion":"POSICIÓN DEL PACIENTE PARA INTUBACIÓN TRAQUEAL"
  },
  {
    "codigo":764104003,
    "descripcion":"INFECCIÓN CAUSADA POR RICKETTSIA FELIS"
  },
  {
    "codigo":1255624007,
    "descripcion":"ESTENOSIS DE ORIFICIO DE RAMA CIRCUNFLEJA DE ARTERIA CORONARIA IZQUIERDA"
  },
  {
    "codigo":239816008,
    "descripcion":"SINOVITIS DE CODO"
  },
  {
    "codigo":237981000,
    "descripcion":"TRASTORNO DEL METABOLISMO DEL PIRUVATO Y DE LA CADENA RESPIRATORIA MITOCONDRIAL"
  },
  {
    "codigo":205213003,
    "descripcion":"DEFICIENCIA TIBIAL CONGÉNITA TIPO II"
  },
  {
    "codigo":762269004,
    "descripcion":"FIBROSIS QUÍSTICA CLÁSICA"
  },
  {
    "codigo":170610000,
    "descripcion":"ESTEROIDES ORALES USADOS EN ÚLTIMO LUGAR"
  },
  {
    "codigo":301682001,
    "descripcion":"INCAPAZ DE MOVERSE EN LA CAMA"
  },
  {
    "codigo":39538002,
    "descripcion":"DESORIENTACIÓN CON RESPECTO A LAS PERSONAS, EL TIEMPO Y EL ESPACIO"
  },
  {
    "codigo":399986003,
    "descripcion":"TRASTORNO DE PARED CORPORAL"
  },
  {
    "codigo":432754003,
    "descripcion":"LESIÓN TRAUMÁTICA DE ESTERNÓN"
  },
  {
    "codigo":677531000119109,
    "descripcion":"AGUJERO REDONDO DE LA RETINA DE AMBOS OJOS"
  },
  {
    "codigo":70471001,
    "descripcion":"FÍSTULA MAMARIA"
  },
  {
    "codigo":365383003,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA REALIZAR ACTIVIDADES DE MANTENIMIENTO DEL AUTO"
  },
  {
    "codigo":299847004,
    "descripcion":"REFLEJO MIOTÁTICO DE DEDO DE LA MANO: RETARDADO"
  },
  {
    "codigo":295520007,
    "descripcion":"SOBREDOSIS DE METOHEXITAL"
  },
  {
    "codigo":37703005,
    "descripcion":"HIPERINSULINISMO ECTÓPICO"
  },
  {
    "codigo":398151007,
    "descripcion":"TONO MUSCULAR DISMINUIDO"
  },
  {
    "codigo":298012000,
    "descripcion":"DOLOR DE HERIDA"
  },
  {
    "codigo":267079009,
    "descripcion":"TIEMBLA"
  },
  {
    "codigo":166940007,
    "descripcion":"NIVEL DE FENOBARBITAL POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":35868009,
    "descripcion":"SÍNDROME CARCINOIDE"
  },
  {
    "codigo":165105001,
    "descripcion":"FUNCIÓN METABÓLICA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":230641007,
    "descripcion":"COMPRESIÓN DE NERVIO CIÁTICO POPLÍTEO EXTERNO"
  },
  {
    "codigo":16025551000119102,
    "descripcion":"TROMBOFLEBITIS DE VENA YUGULAR IZQUIERDA"
  },
  {
    "codigo":294342000,
    "descripcion":"ALERGIA A TERBINAFINA"
  },
  {
    "codigo":425414000,
    "descripcion":"ESTENOSIS BILATERAL DE ARTERIA RENAL"
  },
  {
    "codigo":785862003,
    "descripcion":"SALMONELLA TORNOW O SALMONELLA APAPA"
  },
  {
    "codigo":720326004,
    "descripcion":"QUISTE Y TROFOZOÍTO DE GIARDIA LAMBLIA"
  },
  {
    "codigo":296177007,
    "descripcion":"SOBREDOSIS DE BUTIROFENONA"
  },
  {
    "codigo":1144475001,
    "descripcion":"DEMUESTRA CONOCIMIENTO SOBRE ABUSO DE FÁRMACOS"
  },
  {
    "codigo":194203003,
    "descripcion":"OTITIS EXTERNA INFECCIOSA POR IMPÉTIGO"
  },
  {
    "codigo":292507004,
    "descripcion":"REACCIÓN ADVERSA A LA ISOPRENALINA"
  },
  {
    "codigo":95899007,
    "descripcion":"ACCIÓN FARMACOLÓGICA AUMENTADA"
  },
  {
    "codigo":126832004,
    "descripcion":"NEOPLASIA DEL INTESTINO DELGADO"
  },
  {
    "codigo":28528006,
    "descripcion":"MASTURBACIÓN HABITUAL EN EL ADULTO"
  },
  {
    "codigo":290672008,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR DAUNORUBICINA"
  },
  {
    "codigo":61296009,
    "descripcion":"TRASTORNO DEL CÓCCIX"
  },
  {
    "codigo":92229003,
    "descripcion":"NEOPLASIA BENIGNA DE MÚSCULO DE LA EXTREMIDAD INFERIOR"
  },
  {
    "codigo":714821006,
    "descripcion":"HEMATURIA RECURRENTE CONCOMITANTE CON GLOMERULONEFRITIS MEMBRANOSA DIFUSA Y DEBIDA A ELLA"
  },
  {
    "codigo":712986001,
    "descripcion":"ENCEFALITIS CAUSADA POR VIRUS DE ENCEFALITIS TRANSMITIDO POR GARRAPATAS"
  },
  {
    "codigo":57626004,
    "descripcion":"ESFUERZO EN LA DEFECACIÓN"
  },
  {
    "codigo":254234005,
    "descripcion":"SÍNDROME DE MARIE UNNA"
  },
  {
    "codigo":450842007,
    "descripcion":"ENURESIS NOCTURNA PRIMARIA DE ETIOLOGÍA NO ORGÁNICA"
  },
  {
    "codigo":287002007,
    "descripcion":"CELULITIS DEL PIE, EXCEPTO EN EL ÁREA DE LOS DEDOS"
  },
  {
    "codigo":95496006,
    "descripcion":"DISPLASIA RETINIANA GEOGRÁFICA"
  },
  {
    "codigo":416239002,
    "descripcion":"REQUERIMIENTO DE TRATAMIENTO DE ENFERMEDAD CRÓNICA A LARGO PLAZO"
  },
  {
    "codigo":711151004,
    "descripcion":"HIPOMAGNESEMIA CON HIPOCALCEMIA SECUNDARIA"
  },
  {
    "codigo":55791005,
    "descripcion":"MARCHA DE CHARCOT"
  },
  {
    "codigo":23023009,
    "descripcion":"TRASTORNO DE AMÍGDALAS PALATINAS"
  },
  {
    "codigo":186863009,
    "descripcion":"MENINGITIS SIFILÍTICA SECUNDARIA AGUDA"
  },
  {
    "codigo":53956006,
    "descripcion":"TRASTORNO DE PÁNICO SIN AGORAFOBIA CON ATAQUES DE PÁNICO EN REMISIÓN PARCIAL"
  },
  {
    "codigo":283332007,
    "descripcion":"PICADURA DE INSECTO EN EL DORSO DE LA MANO"
  },
  {
    "codigo":314265001,
    "descripcion":"MEMBRANA COROIDEA NEOVASCULAR CLÁSICA"
  },
  {
    "codigo":707481002,
    "descripcion":"CARCINOMA BASALOIDE PRIMARIO DE CÉLULAS ESCAMOSAS DE HIPOFARINGE"
  },
  {
    "codigo":84889008,
    "descripcion":"ABSCESO PARAFARÍNGEO"
  },
  {
    "codigo":248729008,
    "descripcion":"PRESIÓN VENOSA YUGULAR AUMENTADA EN LA INSPIRACIÓN"
  },
  {
    "codigo":771182002,
    "descripcion":"SÍNDROME DE DEFORMIDAD DE PULGAR, ALOPECIA Y ANOMALÍAS PIGMENTARIAS"
  },
  {
    "codigo":443502000,
    "descripcion":"ATEROSCLEROSIS DE ARTERIA CORONARIA"
  },
  {
    "codigo":1297305009,
    "descripcion":"CIERRE DE ÁNGULO AGUDO SECUNDARIO DE AMBOS OJOS"
  },
  {
    "codigo":115822004,
    "descripcion":"FENOTIPO LUTHERAN NEGATIVO"
  },
  {
    "codigo":246894007,
    "descripcion":"QUERATINIZACIÓN DE LA CONJUNTIVA DEL LIMBO"
  },
  {
    "codigo":1162563001,
    "descripcion":"HEMATOMA INTRACRANEAL POSQUIRÚRGICO"
  },
  {
    "codigo":212291002,
    "descripcion":"LESIÓN TRAUMÁTICA DEL NERVIO TORÁCICO LARGO"
  },
  {
    "codigo":441667007,
    "descripcion":"EXTENDIDO CERVICAL DE PAPANICOLAOU ANORMAL CON ÁCIDO DESOXIRRIBONUCLEICO DE PAPILOMAVIRUS HUMANO DETECTADO"
  },
  {
    "codigo":210456000,
    "descripcion":"HERIDA ABIERTA EN LA PARED ABDOMINAL ANTERIOR"
  },
  {
    "codigo":277827008,
    "descripcion":"ANSIEDAD ACERCA DE MORIRSE"
  },
  {
    "codigo":306925000,
    "descripcion":"MOVILIDAD DEL YUNQUE AUMENTADA"
  },
  {
    "codigo":208621002,
    "descripcion":"FRACTURA EXPUESTA DE TIBIA PROXIMAL, BICONDÍLEA"
  },
  {
    "codigo":110317008,
    "descripcion":"GUÍA OCLUSAL"
  },
  {
    "codigo":274157009,
    "descripcion":"FRACTURA DE COLUMNA DORSAL CON LESIÓN DE MÉDULA ESPINAL"
  },
  {
    "codigo":1157058003,
    "descripcion":"CONDUCTA INFANTIL ORGANIZADA"
  },
  {
    "codigo":403394006,
    "descripcion":"ATROFODERMIA FOLICULAR CON HIPERQUERATOSIS PALMOPLANTAR"
  },
  {
    "codigo":270487001,
    "descripcion":"TRASTORNO NO ORGÁNICO DEL SUEÑO"
  },
  {
    "codigo":237719001,
    "descripcion":"ADENOMA HIPOFISARIO QUE AGRANDA LA SILLA TURCA"
  },
  {
    "codigo":1153388002,
    "descripcion":"NEOPLASIA DE ESTROMA GASTROINTESTINAL DE CUERPO DEL ESTÓMAGO"
  },
  {
    "codigo":301420004,
    "descripcion":"DOLOR A LA DESCOMPRESIÓN EN FOSA ILÍACA IZQUIERDA"
  },
  {
    "codigo":399724005,
    "descripcion":"TUMOR QUE INVADE EL CUERPO CILIAR"
  },
  {
    "codigo":235884008,
    "descripcion":"INSUFICIENCIA HEPÁTICA FULMINANTE"
  },
  {
    "codigo":268652009,
    "descripcion":"INSOMNIO TRANSITORIO"
  },
  {
    "codigo":201281002,
    "descripcion":"MANCHA DE COLOR CAFÉ CON LECHE"
  },
  {
    "codigo":397889003,
    "descripcion":"BALANITIS GANGRENOSA"
  },
  {
    "codigo":234049002,
    "descripcion":"EMBOLIA VENOSA"
  },
  {
    "codigo":4673003,
    "descripcion":"FRACTURA EXPUESTA DEL MALÉOLO LATERAL"
  },
  {
    "codigo":199446000,
    "descripcion":"ANOMALÍA DE PARTES BLANDAS PÉLVICAS EN EL EMBARAZO, EL PARTO Y EL PUERPERIO"
  },
  {
    "codigo":232214001,
    "descripcion":"CELULITIS DE LA AURÍCULA"
  },
  {
    "codigo":365121009,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA MOVILIZARSE EN ASCENSOR Y ESCALERA MECÁNICA"
  },
  {
    "codigo":2838003,
    "descripcion":"PIBLOKTO"
  },
  {
    "codigo":299585008,
    "descripcion":"AMPLITUD DE FLEXIÓN ACTIVA DE DEDO DEL PIE NORMAL"
  },
  {
    "codigo":363286005,
    "descripcion":"COMPLICACIÓN RENAL DE PROCEDIMIENTO"
  },
  {
    "codigo":1003002,
    "descripcion":"DISCRIMINACIÓN RELIGIOSA"
  },
  {
    "codigo":787435004,
    "descripcion":"METABOLIZADOR LENTO-NORMAL DE LA FAMILIA 2 SUBFAMILIA D MIEMBRO 6 DEL CITOCROMO P450"
  },
  {
    "codigo":66539004,
    "descripcion":"DIETA CON BAJO CONTENIDO DE HIDRATOS DE CARBONO"
  },
  {
    "codigo":295915004,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE VENLAFAXINA"
  },
  {
    "codigo":230379007,
    "descripcion":"MIELITIS NECROSANTE SUBAGUDA"
  },
  {
    "codigo":29821000175108,
    "descripcion":"ÚLCERA POR PRESIÓN EN CADERA IZQUIERDA, ESTADIO IV"
  },
  {
    "codigo":294080009,
    "descripcion":"ALERGIA A GLICOPIRRONIO"
  },
  {
    "codigo":11987511000119107,
    "descripcion":"QUEMADURA EPIDÉRMICA DE PIE DERECHO"
  },
  {
    "codigo":30101004,
    "descripcion":"CISTINA - LISINURIA NEONATAL"
  },
  {
    "codigo":95637005,
    "descripcion":"TRASTORNO FACTICIO INFLIGIDO A OTRO"
  },
  {
    "codigo":292245004,
    "descripcion":"REACCIÓN ADVERSA A LA AMINOGLUTETIMIDA"
  },
  {
    "codigo":1176981005,
    "descripcion":"UVEÍTIS POSTERIOR TUBERCULOSA"
  },
  {
    "codigo":128405007,
    "descripcion":"CARDITIS POR VIRUS COXSACKIE"
  },
  {
    "codigo":716394001,
    "descripcion":"CAPAZ DE EVALUAR RIESGO"
  },
  {
    "codigo":1092151000119109,
    "descripcion":"COLESTEATOMA RECURRENTE DE CAVIDAD MASTOIDEA DERECHA"
  },
  {
    "codigo":126570005,
    "descripcion":"NEOPLASIA DEL CÚBITO"
  },
  {
    "codigo":93802007,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL PISO DE LA BOCA"
  },
  {
    "codigo":26431002,
    "descripcion":"INTOXICACIÓN POR BRASSICA NAPUS"
  },
  {
    "codigo":288575003,
    "descripcion":"CAPAZ DE COMUNICARSE"
  },
  {
    "codigo":91967007,
    "descripcion":"NEOPLASIA BENIGNA DE GLÁNDULA SUPRARRENAL"
  },
  {
    "codigo":124735008,
    "descripcion":"COMIENZO TARDÍO DE TRABAJO DE PARTO"
  },
  {
    "codigo":253972001,
    "descripcion":"SINDACTILIA DE PULGAR"
  },
  {
    "codigo":24596005,
    "descripcion":"OCLUSIÓN DE RAMA VENOSA RETINIANA"
  },
  {
    "codigo":286740005,
    "descripcion":"CARÁCTER TENAZ"
  },
  {
    "codigo":284905001,
    "descripcion":"DIFICULTAD PARA REALIZAR ACTIVIDADES DE HIGIENE"
  },
  {
    "codigo":721000119107,
    "descripcion":"ENFERMEDAD RENAL CRÓNICA EN ESTADIO 4 DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":219369007,
    "descripcion":"HERIDA DE GUERRA POR FUEGO O CONFLAGRACIÓN ORIGINADA EN BOMBA DE GASOLINA"
  },
  {
    "codigo":20926000,
    "descripcion":"ADHERENCIA DEL MESENTERIO"
  },
  {
    "codigo":448745008,
    "descripcion":"ANEURISMA DE SENO DE VALSALVA AÓRTICO CON RUPTURA EN AURÍCULA DERECHA"
  },
  {
    "codigo":283070004,
    "descripcion":"ARAÑAZO DE LA REGIÓN DEL OÍDO"
  },
  {
    "codigo":314003000,
    "descripcion":"INFARTO COROIDEO"
  },
  {
    "codigo":215699001,
    "descripcion":"LESIÓN SUFRIDA A BORDO DE MEDIO DE TRANSPORTE ACUÁTICO CAUSADA POR MAQUINARIA DE SALA DE MÁQUINAS, OCUPANTE DE PEQUEÑA EMBARCACIÓN DE MOTOR LESIONADO"
  },
  {
    "codigo":248467005,
    "descripcion":"INTOLERANCIA A LA TEMPERATURA AMBIENTE"
  },
  {
    "codigo":38841000087101,
    "descripcion":"LACTOBACILLUS ACIDOPHILUS O LACTOBACILLUS GASSERI"
  },
  {
    "codigo":707219007,
    "descripcion":"AUSENCIA DE ENCÍA QUERATINIZADA"
  },
  {
    "codigo":19091006,
    "descripcion":"DEGENERACIÓN PALIDOLUISIANA"
  },
  {
    "codigo":84627005,
    "descripcion":"DACRIOCISTITIS CRÓNICA"
  },
  {
    "codigo":43961000087104,
    "descripcion":"HERIDA CORTANTE DE PIEL DE GLÚTEO IZQUIERDO"
  },
  {
    "codigo":41401000087107,
    "descripcion":"ESGUINCE DE LIGAMENTO RADIAL COLATERAL DE ARTICULACIÓN DE CODO DERECHO"
  },
  {
    "codigo":46521000087108,
    "descripcion":"FRACTURA DE EXTREMO PROXIMAL DE PERONÉ IZQUIERDO"
  },
  {
    "codigo":11770731000119105,
    "descripcion":"LUXACIÓN TRAUMÁTICA POSTERIOR NO EXPUESTA DE CABEZA DEL RADIO DERECHO"
  },
  {
    "codigo":410472006,
    "descripcion":"NEURORRETINITIS POR BARTONELLA HENSELAE"
  },
  {
    "codigo":1196904007,
    "descripcion":"ANGIOMIOLIPOMA HEPÁTICO"
  },
  {
    "codigo":1162301000,
    "descripcion":"SEPARACIÓN DE ANILLO FIBROSO DE DISCO INTERVERTEBRAL"
  },
  {
    "codigo":736317001,
    "descripcion":"ALTERACIÓN DEL FUNCIONAMIENTO EJECUTIVO"
  },
  {
    "codigo":1264275009,
    "descripcion":"CRISIS EPILÉPTICA CON AUTOMATISMOS DE INICIO FOCAL"
  },
  {
    "codigo":408637006,
    "descripcion":"ENFERMEDAD CAUSADA POR COCO GRAMPOSITIVO"
  },
  {
    "codigo":275730006,
    "descripcion":"ESTUDIOS URODINÁMICOS NORMALES"
  },
  {
    "codigo":77287004,
    "descripcion":"RETRASO MENTAL LIMÍTROFE"
  },
  {
    "codigo":1287868000,
    "descripcion":"FUGA DE AMPOLLA FILTRANTE DE OJO DERECHO"
  },
  {
    "codigo":403132001,
    "descripcion":"CISTICERCOSIS CUTÁNEA"
  },
  {
    "codigo":1156796002,
    "descripcion":"ATAXIA CEREBELOSA AUTOSÓMICA DOMINANTE TIPO 2"
  },
  {
    "codigo":16905221000119105,
    "descripcion":"MELANOMA MALIGNO DE PIEL DE PÁRPADO INFERIOR IZQUIERDO"
  },
  {
    "codigo":110055008,
    "descripcion":"LACERACIÓN COMPLEJA CONTAMINADA DE LA REGIÓN PERIORAL DE LA CARA"
  },
  {
    "codigo":237457000,
    "descripcion":"PAPILOMA CUTÁNEO DE LA MAMA"
  },
  {
    "codigo":698044008,
    "descripcion":"MELANOMA MALIGNO DE ARCO PALATINO"
  },
  {
    "codigo":330911000119101,
    "descripcion":"VITILIGO DE PIEL DE PÁRPADO SUPERIOR IZQUIERDO Y REGIÓN PERIOCULAR"
  },
  {
    "codigo":1351569004,
    "descripcion":"SÍNDROME DE HIPERINMUNOGLOBULINA M AUTOSÓMICO RECESIVO DEBIDO A DEFICIENCIA DE UNG"
  },
  {
    "codigo":685061000119108,
    "descripcion":"HEMOGLOBINA C-BETA + TALASEMIA"
  },
  {
    "codigo":10734751000119102,
    "descripcion":"ADENOSIS ESCLEROSANTE DE MAMA DERECHA"
  },
  {
    "codigo":366694002,
    "descripcion":"HALLAZGO RELACIONADO CON LA AMPLITUD DE LA ABDUCCIÓN DEL PULGAR"
  },
  {
    "codigo":301158007,
    "descripcion":"PULSO POPLÍTEO PRESENTE"
  },
  {
    "codigo":235622007,
    "descripcion":"MEMBRANA\/ANILLO ESOFÁGICO"
  },
  {
    "codigo":299323002,
    "descripcion":"TUMEFACCIÓN ÓSEA DE REGIÓN DE ARTICULACIÓN DE RODILLA"
  },
  {
    "codigo":430395005,
    "descripcion":"NEUMONÍA CAUSADA POR BACTERIAS GRAMNEGATIVAS"
  },
  {
    "codigo":233787006,
    "descripcion":"ESTENOSIS SUBGLÓTICA ADQUIRIDA"
  },
  {
    "codigo":168251007,
    "descripcion":"INOCULACIÓN DE ANIMALES: BACTERIAS"
  },
  {
    "codigo":364859008,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA ARRASTRAR LOS PIES"
  },
  {
    "codigo":363024001,
    "descripcion":"ANOMALÍA CONGÉNITA DEL ABDOMEN"
  },
  {
    "codigo":15977631000119105,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE OJO IZQUIERDO"
  },
  {
    "codigo":2576002,
    "descripcion":"TRACOMA"
  },
  {
    "codigo":789008006,
    "descripcion":"UVEÍTIS POSTERIOR DEBIDA A ENFERMEDAD INFECCIOSA"
  },
  {
    "codigo":1149456008,
    "descripcion":"PERIODONTITIS GENERALIZADA ESTADIO 2 GRADO B SEGÚN LA CLASIFICACIÓN DE LAS ENFERMEDADES Y ALTERACIONES PERIODONTALES Y PERIIMPLANTARIAS DE 2017 DE LA ACADEMIA ESTADOUNIDENSE DE PERIODONTOLOGÍA Y LA FEDERACIÓN EUROPEA DE PERIODONTOLOGÍA"
  },
  {
    "codigo":231952009,
    "descripcion":"DESGARROS DEL ESTROMA DEL IRIS"
  },
  {
    "codigo":721637002,
    "descripcion":"NEOPLASIA NEUROENDOCRINA MALIGNA PRIMARIA DE ANTRO PILÓRICO GÁSTRICO"
  },
  {
    "codigo":295653006,
    "descripcion":"SOBREDOSIS DE ANTINEOPLÁSICO DEL GRUPO TRIAZENO"
  },
  {
    "codigo":66277009,
    "descripcion":"DESNERVACIÓN"
  },
  {
    "codigo":262885009,
    "descripcion":"DESGARRO MESENTÉRICO"
  },
  {
    "codigo":293818004,
    "descripcion":"ALERGIA A CARBONATO DE LITIO"
  },
  {
    "codigo":424890008,
    "descripcion":"DIETA DESEQUILIBRADA"
  },
  {
    "codigo":162746008,
    "descripcion":"DEDOS DEL PIE CIANÓTICOS"
  },
  {
    "codigo":193679001,
    "descripcion":"CUADRANTOPSIA HOMÓNIMA"
  },
  {
    "codigo":95375003,
    "descripcion":"ATROFIA DEL SITIO DE APLICACIÓN"
  },
  {
    "codigo":62607004,
    "descripcion":"INCAPACIDAD PARA EL ORGASMO"
  },
  {
    "codigo":699059008,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIOS SUPERFICIALES DE LA CABEZA"
  },
  {
    "codigo":29839008,
    "descripcion":"ENFERMEDAD CAUSADA POR RHABDOVIRIDAE"
  },
  {
    "codigo":15705401000119105,
    "descripcion":"CONCRECIÓN EN CONJUNTIVA DE PÁRPADO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":290148002,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR SAL DE ÁCIDO SALICÍLICO"
  },
  {
    "codigo":10954041000119105,
    "descripcion":"HERIDA ABIERTA DE MUÑECA DERECHA DEBIDA A MORDEDURA DE GATO"
  },
  {
    "codigo":28004004,
    "descripcion":"ÁNTRAX DE LA TÚNICA VAGINAL"
  },
  {
    "codigo":1142116004,
    "descripcion":"FÍSTULA URETROVAGINAL CIRCUNFERENCIAL CON CICATRIZACIÓN SEVERA"
  },
  {
    "codigo":736371000168105,
    "descripcion":"RECEPCIÓN LIMITADA DE TELÉFONO CELULAR"
  },
  {
    "codigo":421220009,
    "descripcion":"ESTRABISMO CON PATRÓN EN LAMBDA"
  },
  {
    "codigo":386617003,
    "descripcion":"HALLAZGO DEL APARATO DIGESTIVO"
  },
  {
    "codigo":26169004,
    "descripcion":"OTITIS MEDIA ALÉRGICA"
  },
  {
    "codigo":1304121004,
    "descripcion":"SÍNDROME DEL OJO CAÍDO"
  },
  {
    "codigo":124473006,
    "descripcion":"DEFICIENCIA DE HIALURONOGLUCOSAMINIDASA"
  },
  {
    "codigo":777998000,
    "descripcion":"SÍNDROME DE BRAQUIDACTILIA PREAXIAL DE TEMTAMY"
  },
  {
    "codigo":253710005,
    "descripcion":"ORIFICIO CORONARIO ANORMALMENTE ELEVADO"
  },
  {
    "codigo":89870006,
    "descripcion":"URTICARIA ACUAGÉNICA"
  },
  {
    "codigo":286478008,
    "descripcion":"INCAPAZ DE ESPARCIR ALIMENTOS"
  },
  {
    "codigo":22499001,
    "descripcion":"AUSENCIA DE FORMACIÓN DEL LÍQUIDO CEFALORRAQUÍDEO"
  },
  {
    "codigo":88035001,
    "descripcion":"MEGALOGASTRIA CONGÉNITA"
  },
  {
    "codigo":16661971000119104,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DEBIDO A ESTENOSIS BILATERAL DE ARTERIAS CARÓTIDAS"
  },
  {
    "codigo":284643001,
    "descripcion":"ESTRANGULAR A OTRA PERSONA"
  },
  {
    "codigo":448483008,
    "descripcion":"SEPSIS CAUSADA POR ENTEROBACTER"
  },
  {
    "codigo":250040002,
    "descripcion":"MARCHA COREICA"
  },
  {
    "codigo":1003704006,
    "descripcion":"AGENESIA DE HUESO METACARPIANO"
  },
  {
    "codigo":2321000124104,
    "descripcion":"PRIMER MOLAR SUPERIOR DERECHO TEMPORARIO SUPERNUMERARIO"
  },
  {
    "codigo":315576009,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: IBA"
  },
  {
    "codigo":248205002,
    "descripcion":"FACIES HIPOTIROIDEA"
  },
  {
    "codigo":280973003,
    "descripcion":"INFECCIÓN DE INJERTO ARTERIOVENOSO"
  },
  {
    "codigo":1264013004,
    "descripcion":"DOLOR EN MÚSCULO DE MANO"
  },
  {
    "codigo":18829008,
    "descripcion":"DEPLECIÓN DE ELECTRÓLITOS"
  },
  {
    "codigo":705122003,
    "descripcion":"FRACTURA EXPUESTA COMBINADA DE COLUMNAS ANTERIOR Y POSTERIOR DE ACETÁBULO"
  },
  {
    "codigo":49762007,
    "descripcion":"DEFICIENCIA HEREDITARIA DE FACTOR XI"
  },
  {
    "codigo":1260343000,
    "descripcion":"DISTONÍA DEBIDA A ENCEFALITIS"
  },
  {
    "codigo":703287002,
    "descripcion":"FALLA DE PRÓTESIS DE VÁLVULA TRICÚSPIDE"
  },
  {
    "codigo":408375004,
    "descripcion":"NO SE DISPONE DE OPCIONES FARMACOLÓGICAS COSTOEFECTIVAS"
  },
  {
    "codigo":277303004,
    "descripcion":"HEMORRAGIA SUBARACNOIDEA INTRACRANEAL CON ANGIOGRAFÍA NEGATIVA"
  },
  {
    "codigo":211767008,
    "descripcion":"QUEMADURA EPIDÉRMICA DE GENITALES"
  },
  {
    "codigo":78860006,
    "descripcion":"SENSACIÓN DE PESADEZ EN LOS PÁRPADOS"
  },
  {
    "codigo":275468009,
    "descripcion":"CUADRIPLEJÍA CONGÉNITA"
  },
  {
    "codigo":240865005,
    "descripcion":"GRANULOMA POR ÁSCARIS PERITONEAL"
  },
  {
    "codigo":109793005,
    "descripcion":"PROFUNDIDAD VESTIBULAR DISMINUIDA LUEGO DE LA PÉRDIDA DENTAL"
  },
  {
    "codigo":765153009,
    "descripcion":"OTITIS MEDIA SEROSA CRÓNICA DE OÍDO DERECHO"
  },
  {
    "codigo":239030004,
    "descripcion":"SÍNDROME BUCOFACIAL - DIGITAL III"
  },
  {
    "codigo":402870005,
    "descripcion":"PROLIFERACIÓN DE TEJIDO FIBROSO REACTIVO"
  },
  {
    "codigo":206262006,
    "descripcion":"RECIÉN NACIDO VIVO CON FRECUENCIA CARDÍACA ANORMAL ANTES DEL TRABAJO DE PARTO"
  },
  {
    "codigo":763318007,
    "descripcion":"TRASTORNO DEL TEJIDO CONJUNTIVO DEBIDO A DEFICIENCIA DE LISILHIDROXILASA-3"
  },
  {
    "codigo":1187467000,
    "descripcion":"PARAPLEJÍA ESPÁSTICA AUTOSÓMICA RECESIVA TIPO 9B"
  },
  {
    "codigo":204427001,
    "descripcion":"CONVOLUCIONES PERSISTENTES DEL ARCO AÓRTICO"
  },
  {
    "codigo":269963000,
    "descripcion":"EXTENDIDO CERVICAL, INFLAMACIÓN VIRAL NO ESPECIFICADA"
  },
  {
    "codigo":10874631000119104,
    "descripcion":"HERIDA ABIERTA DE PÁRPADO DERECHO"
  },
  {
    "codigo":202592003,
    "descripcion":"OSTEOCONDROMATOSIS SINOVIAL DE PRIMERA ARTICULACIÓN METATARSOFALÁNGICA"
  },
  {
    "codigo":366432007,
    "descripcion":"REFLEJO TRICIPITAL - HALLAZGO"
  },
  {
    "codigo":397365002,
    "descripcion":"CONFIGURACIÓN DE PÓLIPO NO PUEDE DETERMINARSE"
  },
  {
    "codigo":725045004,
    "descripcion":"DISGENESIA GONADAL PARCIAL 46,XY"
  },
  {
    "codigo":299061005,
    "descripcion":"HALLAZGO RELACIONADO CON ARTICULACIÓN DE DEDO DE LA MANO"
  },
  {
    "codigo":102453009,
    "descripcion":"CELULITIS PERIAMIGDALINA"
  },
  {
    "codigo":395530002,
    "descripcion":"ALTO GRADO (ESCASAMENTE DIFERENCIADO A INDIFERENCIADO)"
  },
  {
    "codigo":67850003,
    "descripcion":"ENFERMEDAD CAUSADA POR APHTHOVIRUS"
  },
  {
    "codigo":297226004,
    "descripcion":"TRASTORNO DE LA SÍNTESIS DE CREATINA"
  },
  {
    "codigo":2314005,
    "descripcion":"RELACIÓN SEXUAL NO PROTEGIDA"
  },
  {
    "codigo":35082008,
    "descripcion":"REMANENTE TÍMICO CERVICAL"
  },
  {
    "codigo":262623002,
    "descripcion":"CUERPO EXTRAÑO EN CUELLO UTERINO"
  },
  {
    "codigo":479003,
    "descripcion":"ENFERMEDAD DE GRAVES CON MIXEDEMA PRETIBIAL Y CRISIS TIROTÓXICA"
  },
  {
    "codigo":162484001,
    "descripcion":"SIN FACTORES QUE MEJOREN EL SÍNTOMA"
  },
  {
    "codigo":721375009,
    "descripcion":"SÍNDROME DEL CORDÓN CENTRAL DE MÉDULA ESPINAL AL NIVEL DEL CUARTO SEGMENTO CERVICAL"
  },
  {
    "codigo":31412003,
    "descripcion":"LINFANGITIS AGUDA DE LA RODILLA"
  },
  {
    "codigo":129716005,
    "descripcion":"MAMA CONSTITUIDA CASI ÍNTEGRAMENTE POR GRASA"
  },
  {
    "codigo":160649001,
    "descripcion":"NIVEL 3 DE ACTIVIDAD SEGÚN EL PRINCIPIO FITT; ACTIVIDAD MODERADA EN MÁS DE 12 OCASIONES EN 4 SEMANAS"
  },
  {
    "codigo":12214331000119101,
    "descripcion":"INFECCIÓN DE PERONÉ IZQUIERDO ASOCIADA CON DISPOSITIVO DE FIJACIÓN INTERNA"
  },
  {
    "codigo":717705004,
    "descripcion":"SÍNDROME DE MAYER-ROKITANSKY-KÜSTER-HAUSER TIPO 2"
  },
  {
    "codigo":1340297006,
    "descripcion":"MIELOCISTOCELE NO TERMINAL"
  },
  {
    "codigo":226185007,
    "descripcion":"DIETA SIN HIDROXIANISOL BUTILADO"
  },
  {
    "codigo":95113009,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL ESTERNÓN"
  },
  {
    "codigo":93278002,
    "descripcion":"HIPOPLASIA CONGÉNITA DE LA NARIZ"
  },
  {
    "codigo":27742002,
    "descripcion":"ASOCIACIÓN VATER"
  },
  {
    "codigo":335931000119103,
    "descripcion":"MUCOCELE CRÓNICO LAGRIMAL DERECHO"
  },
  {
    "codigo":16064571000119103,
    "descripcion":"HAMARTOMA CONGÉNITO DE AMBOS IRIS"
  },
  {
    "codigo":105811000119100,
    "descripcion":"INMUNIDAD CONTRA HEPATITIS B DETERMINADA POR SEROLOGÍA"
  },
  {
    "codigo":1088851000119101,
    "descripcion":"TRASTORNO DE OÍDO EXTERNO IZQUIERDO"
  },
  {
    "codigo":124211004,
    "descripcion":"DEFICIENCIA DE MIO - INOSITOL OXIGENASA"
  },
  {
    "codigo":91443007,
    "descripcion":"BRONQUIO ACCESORIO"
  },
  {
    "codigo":292691000119103,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DEBIDO A OCLUSIÓN DE ARTERIA VERTEBRAL IZQUIERDA"
  },
  {
    "codigo":290131000119105,
    "descripcion":"LESIÓN DE NERVIO CIÁTICO POPLÍTEO EXTERNO DERECHO"
  },
  {
    "codigo":126291000119105,
    "descripcion":"LESIÓN ESCAMOSA INTRAEPITELIAL DE ALTO GRADO EN EXTENDIDO DE PAPANICOLAOU ANAL"
  },
  {
    "codigo":3411000119107,
    "descripcion":"TRASTORNO GASTRODUODENAL"
  },
  {
    "codigo":336211000119106,
    "descripcion":"ÚLCERA DE CÓRNEA CENTRAL DE OJO DERECHO"
  },
  {
    "codigo":1086291000119109,
    "descripcion":"ABSCESO DE YEYUNO CONCOMITANTE CON DIVERTICULITIS Y DEBIDO A ELLA"
  },
  {
    "codigo":131411000119107,
    "descripcion":"MENINGITIS CAUSADA POR ARBOVIRUS"
  },
  {
    "codigo":351571000119105,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE OVARIO DERECHO"
  },
  {
    "codigo":103251000119104,
    "descripcion":"FUGA DE AMPOLLA FILTRANTE DE OJO DEBIDA A TRABECULECTOMÍA Y POSTERIOR A ELLA"
  },
  {
    "codigo":286216001,
    "descripcion":"DIFICULTAD PARA EMPLEAR APOYO RESPIRATORIO AL HABLAR"
  },
  {
    "codigo":590365011000119106,
    "descripcion":"DISNEA ASOCIADA A TRANSFUSIÓN"
  },
  {
    "codigo":133971000119108,
    "descripcion":"EMBOLIA PULMONAR CRÓNICA"
  },
  {
    "codigo":56840009,
    "descripcion":"IDIOSINCRASIA"
  },
  {
    "codigo":338771000119109,
    "descripcion":"PTERIGIÓN PERIFÉRICO ESTACIONARIO DE OJO IZQUIERDO"
  },
  {
    "codigo":251613006,
    "descripcion":"INTERVALO ENTRE LAS ONDAS I Y III DEL POTENCIAL EVOCADO AUDITIVO DEL TRONCO ENCEFÁLICO AUMENTADO"
  },
  {
    "codigo":448221005,
    "descripcion":"SARCOMA DE PERONÉ"
  },
  {
    "codigo":1300189008,
    "descripcion":"OBSTRUCCIÓN DE SEGMENTO DE BOMBA DE CATÉTER INTRATECAL"
  },
  {
    "codigo":1003442001,
    "descripcion":"SINOSTOSIS BILATERAL DE HÚMERO, RADIO Y CÚBITO"
  },
  {
    "codigo":774066000,
    "descripcion":"ANGIOLIPOMATOSIS FAMILIAR"
  },
  {
    "codigo":85938000,
    "descripcion":"SINTENÍA"
  },
  {
    "codigo":184242000,
    "descripcion":"TARJETA DE COOPERACIÓN OBSTÉTRICA EMITIDA"
  },
  {
    "codigo":218845008,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR TOLAZOLINA"
  },
  {
    "codigo":15956181000119102,
    "descripcion":"ADENOCARCINOMA METASTÁSICO DE AMBOS PULMONES"
  },
  {
    "codigo":249778007,
    "descripcion":"PIERNA EMACIADA"
  },
  {
    "codigo":20402005,
    "descripcion":"LACERACIÓN MODERADA DE HÍGADO CON HERIDA ABIERTA HACIA CAVIDAD ABDOMINAL"
  },
  {
    "codigo":11860181000119104,
    "descripcion":"ESGUINCE DE LIGAMENTO LATERAL INTERNO DE RODILLA DERECHA"
  },
  {
    "codigo":247943008,
    "descripcion":"DISPOSICIÓN DE OBJETOS EN LÍNEA RECTA - RUTINA ESTEREOTIPADA"
  },
  {
    "codigo":870535009,
    "descripcion":"DISNEA CRÓNICA"
  },
  {
    "codigo":12105941000119105,
    "descripcion":"QUEMADURA DE BRAZO IZQUIERDO"
  },
  {
    "codigo":772231008,
    "descripcion":"CAPAZ DE MANTENER EL EQUILIBRIO AL PONERSE DE PIE CON AMBOS PIES SEPARADOS"
  },
  {
    "codigo":444551008,
    "descripcion":"ANTICUERPO ANTINUCLEAR POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":213340005,
    "descripcion":"INFLAMACIÓN EN SITIO DE INYECCIÓN"
  },
  {
    "codigo":16011631000119100,
    "descripcion":"OSTEOCONDROSIS JUVENIL DE LA TUBEROSIDAD TIBIAL DE AMBAS RODILLAS"
  },
  {
    "codigo":442716001,
    "descripcion":"HALLAZGO RELACIONADO CON DIFERENCIA EN LA OPACIDAD EN COMPARACIÓN CON EXAMEN RADIOLÓGICO PREVIO"
  },
  {
    "codigo":703025001,
    "descripcion":"TRICHOSPORON BEIGELII O TRICHOSPORON CUTANEUM"
  },
  {
    "codigo":1260081002,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS DE REGIÓN POSCRICOIDEA"
  },
  {
    "codigo":80433004,
    "descripcion":"QUEMADURA DE MAMA"
  },
  {
    "codigo":735793005,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE ABDOMEN"
  },
  {
    "codigo":47665007,
    "descripcion":"SIGNOS ELECTROCARDIOGRÁFICOS DE DESVIACIÓN DEL EJE HACIA LA DERECHA"
  },
  {
    "codigo":78598000,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DEL OJO"
  },
  {
    "codigo":309809007,
    "descripcion":"ACTIVIDAD ELÉCTRICA SIN PULSO CON REANIMACIÓN EXITOSA"
  },
  {
    "codigo":111366003,
    "descripcion":"HERNIA PARAUMBILICAL CON GANGRENA"
  },
  {
    "codigo":209670008,
    "descripcion":"SECCIÓN EXPUESTA DE LIGAMENTO DE LA MUÑECA, ÚNICA"
  },
  {
    "codigo":733958009,
    "descripcion":"CARIES DENTAL INACTIVA SECUNDARIA QUE SE EXTIENDE HASTA EL TERCIO MEDIO DE LA DENTINA"
  },
  {
    "codigo":369715008,
    "descripcion":"MEDICIÓN DE BRESLOW - INVASIÓN > 1,5 MM DESDE EL BORDE PROFUNDO DE LA CAPA GRANULAR"
  },
  {
    "codigo":240603003,
    "descripcion":"LINFOGRANULOMA VENÉREO TARDÍO"
  },
  {
    "codigo":699355007,
    "descripcion":"LEIOMIOSARCOMA DE ÓRBITA"
  },
  {
    "codigo":402608001,
    "descripcion":"COLOR CONSTITUCIONAL DE PELO-HALLAZGO"
  },
  {
    "codigo":74928006,
    "descripcion":"DISPLASIA CAMPOMÉLICA"
  },
  {
    "codigo":304304009,
    "descripcion":"AMPLITUD DE MOVIMIENTO DE MUÑECA AUMENTADA"
  },
  {
    "codigo":1252741006,
    "descripcion":"ÚLCERA VARICOSA DE TALÓN"
  },
  {
    "codigo":1187205008,
    "descripcion":"TRASTORNO MENTAL ORGÁNICO CAUSADO POR SEDANTE"
  },
  {
    "codigo":169562000,
    "descripcion":"EMBARAZADA - CONFIRMACIÓN POR EXAMEN VAGINAL"
  },
  {
    "codigo":366170001,
    "descripcion":"HALLAZGO ELECTROCARDIOGRÁFICO EN EL EJE DE QRS"
  },
  {
    "codigo":398938001,
    "descripcion":"PLATICITOS"
  },
  {
    "codigo":235098004,
    "descripcion":"MORDIDA TRAUMÁTICA"
  },
  {
    "codigo":300634001,
    "descripcion":"CAPAZ DE MANEJAR UN AUTO"
  },
  {
    "codigo":726618007,
    "descripcion":"DISTROFIA MUSCULAR DE LAS CINTURAS DE LAS EXTREMIDADES TIPO 2M AUTOSÓMICA RECESIVA"
  },
  {
    "codigo":724783000,
    "descripcion":"DESMIELINIZACIÓN DE SISTEMA NERVIOSO CENTRAL DEBIDA A ENFERMEDAD DE BEHCET"
  },
  {
    "codigo":431706008,
    "descripcion":"OCLUSIÓN DE ARTERIA DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":202330008,
    "descripcion":"LESIÓN DE BANKART INVERSA"
  },
  {
    "codigo":1281839006,
    "descripcion":"CRISIS EPILÉPTICA SENSORIAL DE INICIO FOCAL"
  },
  {
    "codigo":36655007,
    "descripcion":"ANQUILOSIS COMPLETA DE LA COLUMNA VERTEBRAL"
  },
  {
    "codigo":16476681000119105,
    "descripcion":"HIPOTENSIÓN INTRACRANEAL ESPONTÁNEA"
  },
  {
    "codigo":198660002,
    "descripcion":"ABORTO ESPONTÁNEO COMPLETO CON TRASTORNO METABÓLICO"
  },
  {
    "codigo":788484005,
    "descripcion":"TRASTORNO REPETITIVO DEL MOVIMIENTO DEL MUSLO IZQUIERDO"
  },
  {
    "codigo":1148932007,
    "descripcion":"CISTITIS VIRAL"
  },
  {
    "codigo":32985001,
    "descripcion":"SÍNDROME DE CEFALOSINDACTILIA DE GREIG"
  },
  {
    "codigo":722948009,
    "descripcion":"TRASTORNO GLOMERULAR DEBIDO A AMILOIDOSIS HEREDOFAMILIAR NO NEUROPÁTICA"
  },
  {
    "codigo":426201006,
    "descripcion":"NO SE DISPONE DE INTÉRPRETE"
  },
  {
    "codigo":194990000,
    "descripcion":"INSUFICIENCIA TRICUSPÍDEA NO REUMÁTICA"
  },
  {
    "codigo":31150002,
    "descripcion":"LISTA DE REEMPLAZO DE LA CARNE SEMIGRASA"
  },
  {
    "codigo":719278006,
    "descripcion":"DISTONÍA PRIMARIA TIPO 13"
  },
  {
    "codigo":293294007,
    "descripcion":"REACCIÓN ADVERSA A AGENTE REGULADOR DEL CALCIO"
  },
  {
    "codigo":94851001,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE TRACTO GASTROINTESTINAL"
  },
  {
    "codigo":291459005,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR PROGUANILO"
  },
  {
    "codigo":29315008,
    "descripcion":"DISFONÍA ESPASMÓDICA IDIOPÁTICA DE ADUCCIÓN"
  },
  {
    "codigo":225923008,
    "descripcion":"CONTENIDO DE LA CONVERSACIÓN LIMITADO"
  },
  {
    "codigo":846680003,
    "descripcion":"HIPOGONADISMO HIPOGONADOTRÓFICO FUNCIONAL"
  },
  {
    "codigo":289624004,
    "descripcion":"ÚTERO PEQUEÑO"
  },
  {
    "codigo":1010520008,
    "descripcion":"ESCLEROSIS DE EPÍFISIS DE FALANGE DE SEGUNDO DEDO DE PIE CON RADIOPACIDAD AUMENTADA"
  },
  {
    "codigo":123949001,
    "descripcion":"ARTRITIS REACTIVA POSESTREPTOCÓCICA"
  },
  {
    "codigo":224088008,
    "descripcion":"ÚLTIMO MIEMBRO SOBREVIVIENTE DE LA FAMILIA"
  },
  {
    "codigo":255021005,
    "descripcion":"MELANOMA MALIGNO DE COROIDES"
  },
  {
    "codigo":285954000,
    "descripcion":"INCAPAZ DE INSERTAR EL TAPÓN DE LA PILETA"
  },
  {
    "codigo":253186001,
    "descripcion":"MALFORMACIÓN DE CHIARI TIPO III"
  },
  {
    "codigo":418861008,
    "descripcion":"MARGEN QUIRÚRGICO PROFUNDO AFECTADO POR CARCINOMA DUCTAL IN SITU"
  },
  {
    "codigo":449794003,
    "descripcion":"HEMATOMA DE ESPACIO SUBDURAL DEL NEUROEJE"
  },
  {
    "codigo":56578002,
    "descripcion":"FUMADOR MODERADO (20 CIGARRILLOS O MENOS POR DÍA)"
  },
  {
    "codigo":284119000,
    "descripcion":"NO CONTROLA LA POSICIÓN DE LA CINTURA ESCAPULAR"
  },
  {
    "codigo":710103002,
    "descripcion":"GRADO DE INCLINACIÓN DEL PLANO OCLUSAL CON PENDIENTE HACIA LA IZQUIERDA DEBIDO A ASIMETRÍA ESQUELÉTICA"
  },
  {
    "codigo":218583002,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR SANGRE ENTERA"
  },
  {
    "codigo":251351004,
    "descripcion":"REACCIÓN CUTÁNEA FUERTE"
  },
  {
    "codigo":249516000,
    "descripcion":"MOVIMIENTOS INTESTINALES INFRECUENTES"
  },
  {
    "codigo":446124001,
    "descripcion":"TUMOR DE ESTROMA GASTROINTESTINAL DE ESÓFAGO"
  },
  {
    "codigo":413356003,
    "descripcion":"DEFICIENCIA DE 4-HIDROXIFENILPIRUVATO DIOXIGENASA"
  },
  {
    "codigo":216748008,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ÁCIDO CARBÓLICO"
  },
  {
    "codigo":13271000119101,
    "descripcion":"PROLAPSO DE DISCO INTERVERTEBRAL DORSAL SIN RADICULOPATÍA"
  },
  {
    "codigo":870273007,
    "descripcion":"UVEÍTIS POSTERIOR DEBIDA A SÍFILIS TARDÍA"
  },
  {
    "codigo":1263489009,
    "descripcion":"MIELOPATÍA DEBIDA A EXPOSICIÓN ELÉCTRICA"
  },
  {
    "codigo":49238001,
    "descripcion":"MELANODERMIA"
  },
  {
    "codigo":442454002,
    "descripcion":"ATENDIDO EN CENTRO ESPECIALIZADO EN QUEMADURAS"
  },
  {
    "codigo":367421000119109,
    "descripcion":"RETENCIÓN DE ORINA CAUSADA POR FÁRMACO"
  },
  {
    "codigo":1359958005,
    "descripcion":"HERIDA ABIERTA DE DEDO DEBIDA A MORDEDURA DE GATO"
  },
  {
    "codigo":1228886008,
    "descripcion":"SÍNDROME DE MICRODELECIÓN 9Q33.3Q34.11"
  },
  {
    "codigo":1259819000,
    "descripcion":"GANGLIOGLIOMA ANAPLÁSICO PRIMARIO DE SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":1078231000119104,
    "descripcion":"CÚBITO VARO CONGÉNITO DE CODO DERECHO"
  },
  {
    "codigo":438784000,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR EXCIPIENTE FARMACÉUTICO"
  },
  {
    "codigo":735531008,
    "descripcion":"PALUDISMO CLÍNICO"
  },
  {
    "codigo":274944000,
    "descripcion":"ADENOMATOSIS DE CÉLULAS DE LOS ISLOTES PANCREÁTICOS"
  },
  {
    "codigo":897536003,
    "descripcion":"DELECIÓN DISTAL DEL BRAZO LARGO DEL CROMOSOMA 3"
  },
  {
    "codigo":45568004,
    "descripcion":"DIVERTICULOSIS DEL INTESTINO GRUESO SIN DIVERTICULITIS"
  },
  {
    "codigo":307712005,
    "descripcion":"FRACTURA DE BARTON EXPUESTA"
  },
  {
    "codigo":11783281000119100,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA ANTERIOR DE CADERA IZQUIERDA"
  },
  {
    "codigo":406016007,
    "descripcion":"OVARIO IZQUIERDO AUSENTE EN EL ESPÉCIMEN"
  },
  {
    "codigo":305877000,
    "descripcion":"VISTO EN EL SERVICIO DE SALUD OCUPACIONAL"
  },
  {
    "codigo":830165002,
    "descripcion":"ALERGIA A SULFONATO DE POLIESTIRENO"
  },
  {
    "codigo":371413003,
    "descripcion":"INFECCIÓN DE ESCROTO"
  },
  {
    "codigo":68721000119102,
    "descripcion":"NEUROPATÍA ILIOINGUINAL"
  },
  {
    "codigo":764629008,
    "descripcion":"SÍNDROME DE TRISOMÍA 5 MOSAICO"
  },
  {
    "codigo":402346003,
    "descripcion":"DESCAMACIÓN DE PIEL MEDICAMENTOSA"
  },
  {
    "codigo":238506004,
    "descripcion":"DERMATOSIS POR FRÍO"
  },
  {
    "codigo":105599000,
    "descripcion":"ANEMIA RELACIONADA CON ALTERACIÓN DE LA SÍNTESIS DE ADN"
  },
  {
    "codigo":236671005,
    "descripcion":"NECROSIS DE VEJIGA URINARIA"
  },
  {
    "codigo":72831007,
    "descripcion":"RAQUITISMO DEPENDIENTE DE VITAMINA D, TIPO 2"
  },
  {
    "codigo":38228000,
    "descripcion":"PARÁLISIS DE LA LENGUA"
  },
  {
    "codigo":267604001,
    "descripcion":"SÍNDROME MIASTÉNICO DEBIDO A AMIOTROFIA DIABÉTICA"
  },
  {
    "codigo":726356000,
    "descripcion":"TRISOMÍA PARCIAL DE CROMOSOMA 17"
  },
  {
    "codigo":300372003,
    "descripcion":"HALLAZGO RELACIONADO CON LA VELOCIDAD DE LA DEGLUCIÓN"
  },
  {
    "codigo":365908003,
    "descripcion":"MEMORIA DEL LUGAR ACTUAL - HALLAZGO"
  },
  {
    "codigo":398676009,
    "descripcion":"AFTA MAYOR"
  },
  {
    "codigo":298537001,
    "descripcion":"AMPLITUD DE FLEXIÓN LATERAL PASIVA HACIA LA DERECHA DE LA COLUMNA VERTEBRAL DORSAL, AUMENTADA"
  },
  {
    "codigo":724521003,
    "descripcion":"ÚLCERA DE ESTÓMAGO DEBIDA A GASTRITIS LINFOCÍTICA"
  },
  {
    "codigo":165630002,
    "descripcion":"CAPACIDAD DE FIJACIÓN DE HIERRO TOTAL POR DEBAJO DE RANGO DE REFERENCIA"
  },
  {
    "codigo":722686003,
    "descripcion":"CARCINOMA SEROSO PRIMARIO DE ANEXOS UTERINOS"
  },
  {
    "codigo":296702005,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE CEFUROXIMA"
  },
  {
    "codigo":67326007,
    "descripcion":"FLUJO VASCULAR SIN REFLUJO"
  },
  {
    "codigo":1148670009,
    "descripcion":"RESPUESTA AUSENTE EN ELECTRORRETINOGRAMA DE PATRÓN"
  },
  {
    "codigo":720851007,
    "descripcion":"SÍNDROME DE CONDRODISPLASIA CON TRASTORNO DEL DESARROLLO SEXUAL"
  },
  {
    "codigo":293032001,
    "descripcion":"REACCIÓN ADVERSA A LA SULFONAMIDA"
  },
  {
    "codigo":30888005,
    "descripcion":"AMPOLLA DE LA ENCÍA, CON INFECCIÓN"
  },
  {
    "codigo":719016007,
    "descripcion":"DISCAPACIDAD INTELECTUAL LIGADA AL CROMOSOMA X TIPO CANTAGREL"
  },
  {
    "codigo":63656007,
    "descripcion":"TRASTORNO DEL METABOLISMO DEL MANGANESO"
  },
  {
    "codigo":94589001,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE PARTES BLANDAS DE MIEMBRO INFERIOR"
  },
  {
    "codigo":717181004,
    "descripcion":"HIPERPROLINEMIA TIPO 2"
  },
  {
    "codigo":127357005,
    "descripcion":"HALLAZGO RELACIONADO CON UNA SUSTANCIA FISIOLÓGICA"
  },
  {
    "codigo":343461000119102,
    "descripcion":"COROIDITIS SERPIGINOSA DE AMBOS OJOS"
  },
  {
    "codigo":225661009,
    "descripcion":"PENSAMIENTOS POSITIVOS"
  },
  {
    "codigo":92754004,
    "descripcion":"CARCINOMA IN SITU DE BAZO"
  },
  {
    "codigo":387666006,
    "descripcion":"DILATACIÓN AGUDA DEL ESTÓMAGO"
  },
  {
    "codigo":713511002,
    "descripcion":"ENDOCARDITIS AGUDA CONCOMITANTE CON INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":844583007,
    "descripcion":"IRRITABILIDAD DESPUÉS DE VACUNACIÓN"
  },
  {
    "codigo":123687007,
    "descripcion":"FOLICULITIS AGUDA"
  },
  {
    "codigo":285692001,
    "descripcion":"CARGA PESO EN PIERNA IZQUIERDA"
  },
  {
    "codigo":449532000,
    "descripcion":"ANOMALÍA CONGÉNITA DE VENA CARDÍACA ANTERIOR"
  },
  {
    "codigo":416764003,
    "descripcion":"HIPOXIA CORNEAL"
  },
  {
    "codigo":153151000119100,
    "descripcion":"DISFUNCIÓN PSICOSEXUAL ASOCIADA CON EXCITACIÓN SEXUAL INHIBIDA"
  },
  {
    "codigo":15781000119107,
    "descripcion":"CARDIOPATÍA HIPERTENSIVA Y ENFERMEDAD RENAL CRÓNICA CON INSUFICIENCIA CARDÍACA CONGESTIVA"
  },
  {
    "codigo":10638911000119101,
    "descripcion":"ÚLCERA NEUROPÁTICA DE PANTORRILLA IZQUIERDA"
  },
  {
    "codigo":447697008,
    "descripcion":"VÁLVULA PULMONAR UNICÚSPIDE UNICOMISURAL"
  },
  {
    "codigo":283857009,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO EN LA REGIÓN CLAVICULAR"
  },
  {
    "codigo":249254001,
    "descripcion":"DEFICIENCIA PREPUCIAL"
  },
  {
    "codigo":216486003,
    "descripcion":"INTOXICACIÓN ACCIDENTAL CAUSADA POR NAPROXENO"
  },
  {
    "codigo":413094005,
    "descripcion":"PLAN DE MANEJO CLÍNICO ACORDADO"
  },
  {
    "codigo":85414007,
    "descripcion":"INFERTILIDAD SECUNDARIA A OBSTRUCCIÓN DE LOS CONDUCTOS DEFERENTES"
  },
  {
    "codigo":183718008,
    "descripcion":"CONSULTA DOMICILIARIA DE REUMATOLOGÍA SOLICITADA"
  },
  {
    "codigo":312955002,
    "descripcion":"CORIORRETINITIS SIFILÍTICA TERCIARIA"
  },
  {
    "codigo":247419003,
    "descripcion":"DOLOR INTENSO DURANTE EL COITO"
  },
  {
    "codigo":1197691004,
    "descripcion":"ÚLCERA DUODENAL DEBIDA A ENFERMEDAD CELÍACA"
  },
  {
    "codigo":16864831000119104,
    "descripcion":"RADICULITIS LUMBAR"
  },
  {
    "codigo":83579008,
    "descripcion":"DISGENESIA GONADAL MIXTA"
  },
  {
    "codigo":292915009,
    "descripcion":"REACCIÓN ADVERSA A LA DIETILCARBAMAZINA"
  },
  {
    "codigo":16208003,
    "descripcion":"DIETA HIPOGRASA"
  },
  {
    "codigo":290521000119100,
    "descripcion":"SÍNDROME DEL TÚNEL TARSIANO DE NERVIO TIBIAL DERECHO"
  },
  {
    "codigo":704336007,
    "descripcion":"FRACTURA OSTEOPORÓTICA DE RADIO"
  },
  {
    "codigo":48976006,
    "descripcion":"DEFICIENCIA DE PRECALICREÍNA"
  },
  {
    "codigo":1163088008,
    "descripcion":"PERITONITIS INFECCIOSA AGUDA GENERALIZADA"
  },
  {
    "codigo":473125002,
    "descripcion":"MIGRACIÓN DE STENT VASCULAR"
  },
  {
    "codigo":276517000,
    "descripcion":"ISQUEMIA MIOCÁRDICA TRANSITORIA DEL RECIÉN NACIDO"
  },
  {
    "codigo":1259557008,
    "descripcion":"CARCINOMA BASOCELULAR PRIMARIO TIPO MORFEA ESCLEROSANTE"
  },
  {
    "codigo":471290000,
    "descripcion":"ORIGEN ANÓMALO DE ART. DESCENDENTE ANTERIOR IZQUIERDA EN SENO AÓRTICO A LA DERECHA DE SENO AÓRTICO NO ENFRENTADO Y ORIGEN ANÓMALO DE ART. CIRCUNFLEJA Y ART. CORONARIA DERECHA EN SENO AÓRTICO A LA IZQUIERDA DE SENO AÓRTICO NO ENFRENTADO"
  },
  {
    "codigo":1290490005,
    "descripcion":"TRASTORNO DE TENDÓN DE REGIÓN DE MUÑECA"
  },
  {
    "codigo":241914006,
    "descripcion":"EFECTO TÓXICO CAUSADO POR MATERIAL FOTOGRÁFICO"
  },
  {
    "codigo":274682005,
    "descripcion":"HALLAZGO MICROBIOLÓGICO ANORMAL EN ESPÉCIMEN DE ÓRGANO GENITAL MASCULINO"
  },
  {
    "codigo":405754008,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA MÉDULA ESPINAL CERVICAL"
  },
  {
    "codigo":209146005,
    "descripcion":"SUBLUXACIÓN VERTEBRAL NO EXPUESTA CON LESIÓN MEDULAR ANTERIOR A NIVEL CERVICAL"
  },
  {
    "codigo":372986006,
    "descripcion":"INFECCIÓN CAUSADA POR ASPERGILLUS MAYDIS"
  },
  {
    "codigo":1255887000,
    "descripcion":"PARAGRANULOMA DE HODGKIN DE GANGLIOS LINFÁTICOS DE MIEMBRO INFERIOR"
  },
  {
    "codigo":305615004,
    "descripcion":"BAJO ATENCIÓN DE FISIOTERAPEUTA HOSPITALARIO"
  },
  {
    "codigo":403919005,
    "descripcion":"CARCINOMA BASOCELULAR DE PÁRPADO SUPERIOR"
  },
  {
    "codigo":762532001,
    "descripcion":"DISFORIA DE INTEGRIDAD CORPORAL"
  },
  {
    "codigo":8868001,
    "descripcion":"BOCIO DISHORMONOGÉNICO Y PÉRDIDA DE YODUROS"
  },
  {
    "codigo":860836003,
    "descripcion":"ENDOFTALMITIS CAUSADA POR ASCARIS LUMBRICOIDES"
  },
  {
    "codigo":236409000,
    "descripcion":"GLOMERULONEFRITIS MESANGIOCAPILAR TIPO III"
  },
  {
    "codigo":7033004,
    "descripcion":"ESTADO DE AUSENCIA EPILÉPTICA"
  },
  {
    "codigo":301945007,
    "descripcion":"REACCIÓN PUPILAR AFERENTE A LA LUZ, NORMAL"
  },
  {
    "codigo":433017009,
    "descripcion":"DOLOR EN LA SÍNFISIS DEL PUBIS DURANTE EL EMBARAZO"
  },
  {
    "codigo":169038004,
    "descripcion":"TOMOGRAFÍA: TÓRAX NORMAL"
  },
  {
    "codigo":300110005,
    "descripcion":"PABELLÓN AURICULAR CALIENTE"
  },
  {
    "codigo":234574006,
    "descripcion":"TRASTORNO DEL NÚMERO DE CÉLULAS FAGOCÍTICAS"
  },
  {
    "codigo":298275000,
    "descripcion":"TAMAÑO NORMAL DEL MÚSCULO ESQUELÉTICO"
  },
  {
    "codigo":167203001,
    "descripcion":"PRUEBA DE ABSORCIÓN DE D - XILOSA, NORMAL"
  },
  {
    "codigo":365646008,
    "descripcion":"HALLAZGO RELACIONADO CON EL TÍTULO DE ANTICUERPOS CONTRA GRUPO SANGUÍNEO"
  },
  {
    "codigo":345971000119104,
    "descripcion":"CORIORRETINITIS DISEMINADA GENERALIZADA DE AMBOS OJOS"
  },
  {
    "codigo":429347004,
    "descripcion":"ESCLEROSIS DE VÁLVULA AÓRTICA REUMÁTICA"
  },
  {
    "codigo":198136000,
    "descripcion":"PERIOOFORITIS SUBAGUDA"
  },
  {
    "codigo":1083251000119105,
    "descripcion":"CONDRODERMATITIS NODULAR HELICOIDAL DE AMBAS OREJAS"
  },
  {
    "codigo":34296003,
    "descripcion":"POSICIÓN DE RANA"
  },
  {
    "codigo":427512004,
    "descripcion":"DEPENDIENTE PARA CAMINAR"
  },
  {
    "codigo":787960006,
    "descripcion":"BACILLUS CIRCULANS O PAENIBACILLUS GLUCANOLYTICUS"
  },
  {
    "codigo":196301001,
    "descripcion":"CARIES AGUDA DEL ESMALTE DENTAL"
  },
  {
    "codigo":296440009,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE AMINOFILINA"
  },
  {
    "codigo":292770000,
    "descripcion":"REACCIÓN ADVERSA A LA SACAROSA"
  },
  {
    "codigo":425677008,
    "descripcion":"DOLOR IRRADIADO AL BRAZO IZQUIERDO"
  },
  {
    "codigo":15966221000119102,
    "descripcion":"DISPLASIA FIBROMUSCULAR BILATERAL DE LAS ARTERIAS RENALES"
  },
  {
    "codigo":290935000,
    "descripcion":"INTOXICACIÓN POR LAMOTRIGINA"
  },
  {
    "codigo":718754008,
    "descripcion":"ATAXIA EPISÓDICA TIPO 4"
  },
  {
    "codigo":94327000,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL CORAZÓN"
  },
  {
    "codigo":192631000,
    "descripcion":"PICA EN LA LACTANCIA Y NIÑEZ"
  },
  {
    "codigo":389239007,
    "descripcion":"DISPLASIA DE RAINE"
  },
  {
    "codigo":127095009,
    "descripcion":"LINFADENOPATÍA INFRACLAVICULAR"
  },
  {
    "codigo":92492004,
    "descripcion":"CENTRO CARTILAGINOSO DE VÉRTEBRA DORSAL HENDIDO"
  },
  {
    "codigo":715084005,
    "descripcion":"CAPAZ DE PASAR DE UNA SILLA DE RUEDAS A LA CAMA"
  },
  {
    "codigo":289100008,
    "descripcion":"DIFICULTAD EN RESPIRAR PROFUNDAMENTE"
  },
  {
    "codigo":713249002,
    "descripcion":"GRANULOMA PIÓGENO DE ENCÍA DEBIDO A EMBARAZO"
  },
  {
    "codigo":254515006,
    "descripcion":"NEOPLASIA BENIGNA DE COMISURA POSTERIOR"
  },
  {
    "codigo":449270002,
    "descripcion":"HIPOPLASIA DE ANILLO DE VÁLVULA MITRAL"
  },
  {
    "codigo":711414003,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE CÉLULAS CLARAS DE PULMÓN"
  },
  {
    "codigo":285430002,
    "descripcion":"GAMMAPATÍA MONOCLONAL POR CADENAS LIVIANAS DE SIGNIFICACIÓN INCIERTA"
  },
  {
    "codigo":10942631000119103,
    "descripcion":"LESIÓN TRAUMÁTICA DE CONDUCTO DE GLÁNDULA LAGRIMAL IZQUIERDA"
  },
  {
    "codigo":88822006,
    "descripcion":"AMNESIA ANTERÓGRADA"
  },
  {
    "codigo":414667000,
    "descripcion":"MIELOMENINGOCELE"
  },
  {
    "codigo":1332171003,
    "descripcion":"ÚLCERA VENOSA DE DEDO DE PIE"
  },
  {
    "codigo":185291004,
    "descripcion":"ATENDIDO POR MÉDICO EN ENTRENAMIENTO"
  },
  {
    "codigo":283595006,
    "descripcion":"HERIDA DE PERDIGÓN EN TALÓN"
  },
  {
    "codigo":216224000,
    "descripcion":"LESIÓN POR DESCENSO VOLUNTARIO EN PARACAÍDAS, SIN ACCIDENTE DE AERONAVE, VIAJERO EN AERONAVE MILITAR LESIONADO"
  },
  {
    "codigo":19616004,
    "descripcion":"DESPLAZAMIENTO DEL MEDIASTINO"
  },
  {
    "codigo":1197429000,
    "descripcion":"ARTERIOPATÍA, ACCIDENTES CEREBROVASCULARES Y LEUCOENCEFALOPATÍA ASOCIADA A CATEPSINA A"
  },
  {
    "codigo":1363104008,
    "descripcion":"ASTILLA EN CABEZA CON INFECCIÓN"
  },
  {
    "codigo":871584009,
    "descripcion":"COMPLICACIÓN DEBIDA A ANASTOMOSIS CAVOPULMONAR SUPERIOR Y POSTERIOR A ELLA"
  },
  {
    "codigo":773280009,
    "descripcion":"SÍNDROME DE HIDROCEFALIA, ESCLERÓTICAS AZULES Y NEFROPATÍA"
  },
  {
    "codigo":771445001,
    "descripcion":"HIPERCALCEMIA INFANTIL AUTOSÓMICA RECESIVA"
  },
  {
    "codigo":11843751000119107,
    "descripcion":"ABRASIÓN DE PIEL DE PABELLÓN AURICULAR IZQUIERDO"
  },
  {
    "codigo":247157006,
    "descripcion":"DEPÓSITO SUBRETINIANO DE LÍPIDOS"
  },
  {
    "codigo":1162826002,
    "descripcion":"MALFORMACIÓN DE MÉDULA ESPINAL HENDIDA TIPO I"
  },
  {
    "codigo":278090003,
    "descripcion":"CABEZA FETAL BIEN FLEXIONADA"
  },
  {
    "codigo":1085761000119103,
    "descripcion":"COMPLICACIÓN DEBIDA A ENFERMEDAD DE CROHN DE INTESTINO GRUESO"
  },
  {
    "codigo":46879005,
    "descripcion":"BAJA AFINIDAD INMUNOLÓGICA"
  },
  {
    "codigo":866079008,
    "descripcion":"MELANOMA MALIGNO DE GLÁNDULA LAGRIMAL"
  },
  {
    "codigo":276255009,
    "descripcion":"RECLUTAMIENTO TEMPRANO DE UNIDADES POLIFÁSICAS MOTORAS DE CORTA DURACIÓN SIN ACTIVIDAD ESPONTÁNEA ANORMAL EN EL ELECTROMIOGRAMA"
  },
  {
    "codigo":210719008,
    "descripcion":"SECCIÓN PARCIAL, TENDÓN DEL MÚSCULO EXTENSOR DEL PIE"
  },
  {
    "codigo":733172004,
    "descripcion":"AMEBOMA DE INTESTINO GRUESO CAUSADO POR ENTAMOEBA HISTOLYTICA"
  },
  {
    "codigo":405492008,
    "descripcion":"TUBO ENDOTRAQUEAL OBSTRUIDO"
  },
  {
    "codigo":764105002,
    "descripcion":"ELASTÓLISIS DÉRMICA PAPILAR SIMILAR A PSEUDOXANTOMA ELÁSTICO"
  },
  {
    "codigo":272585003,
    "descripcion":"POSICIÓN DEL PACIENTE CON EXTENSIÓN DE LA CABEZA"
  },
  {
    "codigo":239817004,
    "descripcion":"SINOVITIS DE LA RODILLA"
  },
  {
    "codigo":403657007,
    "descripcion":"PANICULITIS CAUSADA POR TRATAMIENTO CON CORTICOSTEROIDES"
  },
  {
    "codigo":1255625008,
    "descripcion":"PARTO EN LAS ÚLTIMAS CUATRO SEMANAS"
  },
  {
    "codigo":370889009,
    "descripcion":"HEPATITIS PORTAL LINFOCÍTICA"
  },
  {
    "codigo":762270003,
    "descripcion":"FIBROSIS QUÍSTICA ATÍPICA"
  },
  {
    "codigo":74142004,
    "descripcion":"TRASTORNO ALIMENTARIO EN LA LACTANCIA O PRIMERA INFANCIA"
  },
  {
    "codigo":237982007,
    "descripcion":"DEFICIENCIA DE LACTATO DESHIDROGENASA"
  },
  {
    "codigo":170611001,
    "descripcion":"FÁRMACOS MAS USADOS EN FORMA INTERMITENTE"
  },
  {
    "codigo":39539005,
    "descripcion":"FUNCIÓN RENAL ANORMAL"
  },
  {
    "codigo":301683006,
    "descripcion":"SE MUEVE EN LA CAMA"
  },
  {
    "codigo":398152000,
    "descripcion":"TONO MUSCULAR ESCASO"
  },
  {
    "codigo":168776009,
    "descripcion":"RADIOGRAFÍA SIMPLE DE PARTES BLANDAS DE EXTREMIDAD NORMAL"
  },
  {
    "codigo":365384009,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD DE REALIZAR ACTIVIDADES EDUCATIVAS Y DE ENTRENAMIENTO"
  },
  {
    "codigo":299848009,
    "descripcion":"REFLEJO MIOTÁTICO DE DEDO DE LA MANO: INVERTIDO"
  },
  {
    "codigo":68637004,
    "descripcion":"XERODERMIA PIGMENTOSA, GRUPO D"
  },
  {
    "codigo":298013005,
    "descripcion":"HALLAZGO RELACIONADO CON EL COLOR DE UNA HERIDA"
  },
  {
    "codigo":295541000119102,
    "descripcion":"CALCIFICACIÓN Y OSIFICACIÓN DE MÚSCULO DE LA MANO DEBIDA A QUEMADURA"
  },
  {
    "codigo":165106000,
    "descripcion":"FUNCIÓN METABÓLICA FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":296178002,
    "descripcion":"SOBREDOSIS DE BENPERIDOL"
  },
  {
    "codigo":294343005,
    "descripcion":"ALERGIA A NITROFENOL"
  },
  {
    "codigo":785863008,
    "descripcion":"STAPHYLOCOCCUS INTERMEDIUS O STAPHYLOCOCCUS PSEUDINTERMEDIUS"
  },
  {
    "codigo":423580001,
    "descripcion":"DEFICIENCIA DE ENZIMA CYP1A2 DE CITOCROMO P450"
  },
  {
    "codigo":95900002,
    "descripcion":"DISMINUCIÓN DE LA ACCIÓN DE UN FÁRMACO"
  },
  {
    "codigo":716657000,
    "descripcion":"CARCINOMA PAPILAR DE GLÁNDULA TIROIDES CON SÍNDROME DE NEOPLASIA PAPILAR RENAL FAMILIAR"
  },
  {
    "codigo":194204009,
    "descripcion":"FORUNCULOSIS DE CONDUCTO AUDITIVO EXTERNO"
  },
  {
    "codigo":292508009,
    "descripcion":"REACCIÓN ADVERSA A LA ISOPRENALINA ADMINISTRADA POR VÍA ORAL"
  },
  {
    "codigo":28529003,
    "descripcion":"RESPUESTA A LA INMUNIZACIÓN ACTIVA"
  },
  {
    "codigo":290673003,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR DAUNORUBICINA"
  },
  {
    "codigo":59462000,
    "descripcion":"VOLTAJE ELECTROCARDIOGRÁFICO DISMINUIDO"
  },
  {
    "codigo":126833009,
    "descripcion":"NEOPLASIA DEL DUODENO"
  },
  {
    "codigo":714822004,
    "descripcion":"HEMATURIA PERSISTENTE CONCOMITANTE CON GLOMERULONEFRITIS MEMBRANOSA DIFUSA Y DEBIDA A ELLA"
  },
  {
    "codigo":92230008,
    "descripcion":"NEOPLASIA BENIGNA DE MÚSCULO DEL CUELLO"
  },
  {
    "codigo":418075002,
    "descripcion":"VERBALIZA UN PLAN PARA REDUCIR LAS BARRERAS QUE LE IMPIDEN REALIZAR EJERCICIO FÍSICO"
  },
  {
    "codigo":450843002,
    "descripcion":"ENURESIS NOCTURNA SECUNDARIA DE ETIOLOGÍA NO ORGÁNICA"
  },
  {
    "codigo":23311000119105,
    "descripcion":"INFARTO AGUDO DE MIOCARDIO DEBIDO A OCLUSIÓN DE ARTERIA CORONARIA DERECHA"
  },
  {
    "codigo":449008001,
    "descripcion":"VALVA AURICULOVENTRICULAR FLOTANTE EN DEFECTO DE TABIQUE AURICULOVENTRICULAR"
  },
  {
    "codigo":23024003,
    "descripcion":"MACROGIRIA"
  },
  {
    "codigo":711152006,
    "descripcion":"HIPOCALCEMIA AUTOSÓMICA DOMINANTE"
  },
  {
    "codigo":285168008,
    "descripcion":"CAPAZ DE RECONOCER CARAS VISUALMENTE"
  },
  {
    "codigo":414405001,
    "descripcion":"ABERRACIÓN VISUAL DE ALTO ORDEN"
  },
  {
    "codigo":283333002,
    "descripcion":"PICADURA DE INSECTO EN LA PALMA DE LA MANO"
  },
  {
    "codigo":86725005,
    "descripcion":"ELEVACIÓN DE UNA COLONIA BACTERIANA"
  },
  {
    "codigo":314266000,
    "descripcion":"MEMBRANA COROIDEA NEOVASCULAR OCULTA"
  },
  {
    "codigo":281498002,
    "descripcion":"EXOSTOSIS SUBUNGUEAL DE DEDO GORDO"
  },
  {
    "codigo":84890004,
    "descripcion":"ENFERMEDAD CAUSADA POR GAMMAHERPESVIRINAE"
  },
  {
    "codigo":1297306005,
    "descripcion":"CELULITIS DE DEDO GORDO DE PIE"
  },
  {
    "codigo":1088271000119109,
    "descripcion":"MEMBRANA TIMPÁNICA IZQUIERDA ATRÓFICA NO FLÁCIDA"
  },
  {
    "codigo":445338005,
    "descripcion":"SÍNDROME DE DISGENESIA TESTICULAR"
  },
  {
    "codigo":19354008,
    "descripcion":"GANGLIÓN DE VAINA DE TENDÓN"
  },
  {
    "codigo":707482009,
    "descripcion":"CARCINOMA PAPILAR ESCAMOCELULAR PRIMARIO DE HIPOFARINGE"
  },
  {
    "codigo":443503005,
    "descripcion":"DOLOR PERIUMBILLICAL"
  },
  {
    "codigo":246895008,
    "descripcion":"LESIÓN FOCAL DE LIMBO DE CONJUNTIVA"
  },
  {
    "codigo":115823009,
    "descripcion":"FENOTIPO LULU"
  },
  {
    "codigo":441668002,
    "descripcion":"CONDUCTA RELACIONADA CON LA OBTENCIÓN DE DROGAS"
  },
  {
    "codigo":277828003,
    "descripcion":"ANSIEDAD ACERCA DE PERDER LA RAZÓN"
  },
  {
    "codigo":79385002,
    "descripcion":"SÍNDROME DE LOWE"
  },
  {
    "codigo":210457009,
    "descripcion":"HERIDA ABIERTA EN LA REGIÓN EPIGÁSTRICA"
  },
  {
    "codigo":110318003,
    "descripcion":"FALTA DE GUÍA OCLUSAL ANTERIOR"
  },
  {
    "codigo":274158004,
    "descripcion":"FRACTURA DE COLUMNA LUMBAR CON LESIÓN DE MÉDULA ESPINAL"
  },
  {
    "codigo":306926004,
    "descripcion":"HALLAZGO RELACIONADO CON LA MOVILIDAD DEL ESTRIBO"
  },
  {
    "codigo":208622009,
    "descripcion":"FRACTURA EXPUESTA DE ESPINA TIBIAL"
  },
  {
    "codigo":403395007,
    "descripcion":"ATROFODERMIA LINEAL DE MOULIN"
  },
  {
    "codigo":10947651000119106,
    "descripcion":"HERIDA ABIERTA DE DEDO ANULAR DERECHO DEBIDA A MORDEDURA DE PERRO"
  },
  {
    "codigo":41112006,
    "descripcion":"DIETA CON 150 MILIGRAMOS DE CALCIO"
  },
  {
    "codigo":237720007,
    "descripcion":"HAMARTOMA DE LA GLÁNDULA HIPÓFISIS Y DEL HIPOTÁLAMO"
  },
  {
    "codigo":301421000,
    "descripcion":"DOLOR A LA PALPACIÓN EN EXTREMIDAD"
  },
  {
    "codigo":1351832009,
    "descripcion":"SÍNDROME DE BROWN-SÉQUARD DEBIDO A TRAUMATISMO"
  },
  {
    "codigo":268653004,
    "descripcion":"HIPERSOMNIA TRANSITORIA"
  },
  {
    "codigo":1153389005,
    "descripcion":"DETENCIÓN DEL CRECIMIENTO EPIFISARIO DEBIDA A TRASTORNO DE SISTEMA ENDOCRINO"
  },
  {
    "codigo":293384004,
    "descripcion":"REACCIÓN ADVERSA A LOS PREPARADOS MINERALES Y MULTIVITAMÍNICOS"
  },
  {
    "codigo":235885009,
    "descripcion":"INSUFICIENCIA HEPÁTICA SUBFULMINANTE"
  },
  {
    "codigo":234050002,
    "descripcion":"INSUFICIENCIA VENOSA DE PIERNA"
  },
  {
    "codigo":365122002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA UTILIZAR EL ASCENSOR"
  },
  {
    "codigo":232215000,
    "descripcion":"ABSCESO DE LA AURÍCULA"
  },
  {
    "codigo":363287001,
    "descripcion":"INSUFICIENCIA RENAL RELACIONADA CON VASCULOPATÍA RENAL"
  },
  {
    "codigo":37442009,
    "descripcion":"ÚLCERA PÉPTICA SIN HEMORRAGIA Y SIN PERFORACIÓN"
  },
  {
    "codigo":299586009,
    "descripcion":"AMPLITUD DE FLEXIÓN ACTIVA DE DEDO DEL PIE AUMENTADA"
  },
  {
    "codigo":35607004,
    "descripcion":"TRASTORNO DE PÁNICO CON AGORAFOBIA"
  },
  {
    "codigo":428823006,
    "descripcion":"USO INAPROPIADO DE CANNABIS"
  },
  {
    "codigo":789271009,
    "descripcion":"INTOXICACIÓN POR AGONISTA DE RECEPTOR ADRENÉRGICO ALFA 2 CENTRAL"
  },
  {
    "codigo":66540002,
    "descripcion":"DISTENSIÓN MUSCULAR EN LA REGIÓN DORSAL DE LA ESPALDA"
  },
  {
    "codigo":33772003,
    "descripcion":"MIELOMALACIA"
  },
  {
    "codigo":295916003,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE VENLAFAXINA"
  },
  {
    "codigo":230380005,
    "descripcion":"ESCLEROSIS CONCÉNTRICA, DE BALO"
  },
  {
    "codigo":263148008,
    "descripcion":"FRACTURA DE SENO ESFENOIDAL"
  },
  {
    "codigo":10976631000119101,
    "descripcion":"LEIOMIOSARCOMA DE PIEL DEL TÓRAX"
  },
  {
    "codigo":294081008,
    "descripcion":"ALERGIA A HOMATROPINA"
  },
  {
    "codigo":359617009,
    "descripcion":"INSUFICIENCIA CARDÍACA DERECHA AGUDA"
  },
  {
    "codigo":423318000,
    "descripcion":"ADENOCARCINOMA QUÍSTICO DE OROFARINGE"
  },
  {
    "codigo":292246003,
    "descripcion":"REACCIÓN ADVERSA A UN ANTAGONISTA ESTROGÉNICO"
  },
  {
    "codigo":718230004,
    "descripcion":"SUSCEPTIBILIDAD MENDELIANA A ENFERMEDAD POR MICOBACTERIAS DEBIDA A DEFICIENCIA COMPLETA DE RECEPTOR 1 DE INTERFERÓN GAMMA"
  },
  {
    "codigo":783766005,
    "descripcion":"POLICITEMIA SECUNDARIA AUTOSÓMICA RECESIVA NO ASOCIADA CON EL GEN DE VON HIPPEL LINDAU"
  },
  {
    "codigo":1176982003,
    "descripcion":"UVEÍTIS POSTERIOR VIRAL"
  },
  {
    "codigo":30102006,
    "descripcion":"ANOMALÍA EN EL TRANSPORTE DE GLUCOSA - 6 - FOSFATO"
  },
  {
    "codigo":716395000,
    "descripcion":"CAPAZ DE COLABORAR EN LA PREPARACIÓN DE COMIDA"
  },
  {
    "codigo":93803002,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL PIE"
  },
  {
    "codigo":61035004,
    "descripcion":"QUEMADURA DE LA TRÁQUEA"
  },
  {
    "codigo":4951000175104,
    "descripcion":"UTILIZA LA COMUNICACIÓN ESCRITA"
  },
  {
    "codigo":419648001,
    "descripcion":"DEGENERACIÓN SENIL DE LA CÓRNEA EN EMBUDO"
  },
  {
    "codigo":714560002,
    "descripcion":"NO SE ADAPTA DESPUÉS DE UNA CRISIS PERSONAL"
  },
  {
    "codigo":126571009,
    "descripcion":"NEOPLASIA DE HUESO CORTO DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":288576002,
    "descripcion":"INCAPAZ DE COMUNICARSE"
  },
  {
    "codigo":91968002,
    "descripcion":"NEOPLASIA BENIGNA DE LA MÉDULA SUPRARRENAL"
  },
  {
    "codigo":15701521000119100,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE TENDÓN EXTENSOR DE AMBAS MANOS"
  },
  {
    "codigo":12571000132104,
    "descripcion":"NEUMONÍA CAUSADA POR HERPES ZÓSTER"
  },
  {
    "codigo":124736009,
    "descripcion":"PRESENTACIÓN FETAL COMPUESTA"
  },
  {
    "codigo":26432009,
    "descripcion":"FACIES MIOPÁTICA"
  },
  {
    "codigo":286741009,
    "descripcion":"TIENDE A ABANDONAR TAREAS"
  },
  {
    "codigo":16711031000119109,
    "descripcion":"NEOVASCULARIZACIÓN DE RETINA DEBIDA A OCLUSIÓN DE VENA CENTRAL RETINIANA DE OJO DERECHO"
  },
  {
    "codigo":283071000,
    "descripcion":"ARAÑAZO DE LA NARIZ"
  },
  {
    "codigo":448746009,
    "descripcion":"ANEURISMA DE SENO DE VALSALVA AÓRTICO CON RUPTURA EN VENTRÍCULO DERECHO"
  },
  {
    "codigo":86463003,
    "descripcion":"QUISTE RENAL ÚNICO MULTILOCULAR"
  },
  {
    "codigo":248468000,
    "descripcion":"INTOLERANTE AL CALOR Y AL FRÍO"
  },
  {
    "codigo":20927009,
    "descripcion":"FIEBRE HEMORRÁGICA DENGUE"
  },
  {
    "codigo":707220001,
    "descripcion":"FOLICULITIS PROFUNDA"
  },
  {
    "codigo":19092004,
    "descripcion":"SÍNDROME DE HOLT - ORAM"
  },
  {
    "codigo":314004006,
    "descripcion":"CRISTALES EN LA RETINA"
  },
  {
    "codigo":1297044006,
    "descripcion":"GANGLIÓN DE VAINA TENDINOSA DE MANO"
  },
  {
    "codigo":445076009,
    "descripcion":"UTILIZA ANOTADOR MANUAL"
  },
  {
    "codigo":547853841000119107,
    "descripcion":"FRACTURA ABIERTA DE PARED LATERAL DE ÓRBITA DERECHA"
  },
  {
    "codigo":410473001,
    "descripcion":"UVEÍTIS DE LYME"
  },
  {
    "codigo":82793005,
    "descripcion":"OBESIDAD HIPOTALÁMICA"
  },
  {
    "codigo":1196905008,
    "descripcion":"HEMANGIOMA BENIGNO DE INTESTINO DELGADO"
  },
  {
    "codigo":408638001,
    "descripcion":"ENFERMEDAD CAUSADA POR BACILO GRAMNEGATIVO"
  },
  {
    "codigo":736318006,
    "descripcion":"AUMENTO DE LA SOCIABILIDAD"
  },
  {
    "codigo":1162302007,
    "descripcion":"OSIFICACIÓN DEL LIGAMENTO AMARILLO"
  },
  {
    "codigo":46355004,
    "descripcion":"ÁNTRAX DEL ESCROTO"
  },
  {
    "codigo":275731005,
    "descripcion":"ESTUDIOS URODINÁMICOS ANORMALES"
  },
  {
    "codigo":47251000087102,
    "descripcion":"LESIÓN DE PLEXO BRAQUIAL DE EXTREMIDAD SUPERIOR DERECHA"
  },
  {
    "codigo":39571000087103,
    "descripcion":"HEMATOMA DE REGIÓN INGUINAL DERECHA"
  },
  {
    "codigo":111891008,
    "descripcion":"HEPATITIS VIRAL TIPO B SIN COMA HEPÁTICO"
  },
  {
    "codigo":42131000087104,
    "descripcion":"ABRASIÓN DE PIEL DE MÚLTIPLES DEDOS DE PIE DERECHO"
  },
  {
    "codigo":683691000119106,
    "descripcion":"NEVO DISPLÁSICO DE PIEL DE LA CARA"
  },
  {
    "codigo":329541000119100,
    "descripcion":"OCLUSIÓN BILATERAL DE ARTERIAS CEREBRALES ANTERIORES"
  },
  {
    "codigo":110056009,
    "descripcion":"AVULSIÓN DE LA REGIÓN PERIORAL DE LA CARA"
  },
  {
    "codigo":28331000119107,
    "descripcion":"EDEMA DE RETINA DEBIDO A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":370365005,
    "descripcion":"SOBRECARGA DE VENTRÍCULO IZQUIERDO EN ELECTROCARDIOGRAMA"
  },
  {
    "codigo":1156797006,
    "descripcion":"SARCOMA DE KAPOSI DE RECTO"
  },
  {
    "codigo":403133006,
    "descripcion":"ESPARGANOSIS CUTÁNEA"
  },
  {
    "codigo":206525008,
    "descripcion":"ENTEROCOLITIS NECROSANTE NEONATAL"
  },
  {
    "codigo":698045009,
    "descripcion":"MELANOMA MALIGNO DE MUCOSA YUGAL"
  },
  {
    "codigo":1351570003,
    "descripcion":"SÍNDROME DE HIPERINMUNOGLOBULINA M AUTOSÓMICO DOMINANTE DEBIDO A DEFICIENCIA DE CITIDINA DESAMINASA INDUCIDA POR ACTIVACIÓN"
  },
  {
    "codigo":237458005,
    "descripcion":"QUISTE HIDATÍDICO DE MAMA"
  },
  {
    "codigo":366695001,
    "descripcion":"AMPLITUD DE MOVIMIENTO ACTIVO DE ABDUCCIÓN DEL PULGAR - HALLAZGO"
  },
  {
    "codigo":235623002,
    "descripcion":"ANILLO ESOFÁGICO INFERIOR"
  },
  {
    "codigo":301159004,
    "descripcion":"PULSO TIBIAL POSTERIOR PRESENTE"
  },
  {
    "codigo":399463004,
    "descripcion":"RETINITIS"
  },
  {
    "codigo":202855006,
    "descripcion":"EPICONDILITIS LATERAL"
  },
  {
    "codigo":1251431006,
    "descripcion":"DERMATITIS ATÓPICA IMPETIGINIZADA DEL ADULTO"
  },
  {
    "codigo":168252000,
    "descripcion":"INOCULACIÓN DE ANIMALES: VIRUS"
  },
  {
    "codigo":233788001,
    "descripcion":"TRAQUEOBRONQUIOMALACIA"
  },
  {
    "codigo":16467781000119105,
    "descripcion":"MELORREOSTOSIS DE HUESO DE ANTEBRAZO IZQUIERDO"
  },
  {
    "codigo":364860003,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA RODAR"
  },
  {
    "codigo":266556005,
    "descripcion":"CÁLCULO DE RIÑÓN Y URÉTER"
  },
  {
    "codigo":430396006,
    "descripcion":"DISFUNCIÓN SISTÓLICA CRÓNICA DEL VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":299324008,
    "descripcion":"TUMEFACCIÓN DE PARTES BLANDAS DE ARTICULACIÓN DE RODILLA"
  },
  {
    "codigo":363025000,
    "descripcion":"ANOMALÍA CONGÉNITA DEL DORSO"
  },
  {
    "codigo":4412009,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO DIGITAL"
  },
  {
    "codigo":789009003,
    "descripcion":"APNEA DEL SUEÑO CENTRAL PRIMARIA DEL PREMATURO"
  },
  {
    "codigo":428561000,
    "descripcion":"HEMATOMA SUBDURAL OCCIPITAL"
  },
  {
    "codigo":231953004,
    "descripcion":"DESGARRO DE LA RAÍZ DEL IRIS"
  },
  {
    "codigo":1149457004,
    "descripcion":"PERIODONTITIS GENERALIZADA ESTADIO 2 GRADO A SEGÚN LA CLASIFICACIÓN DE LAS ENFERMEDADES Y ALTERACIONES PERIODONTALES Y PERIIMPLANTARIAS DE 2017 DE LA ACADEMIA ESTADOUNIDENSE DE PERIODONTOLOGÍA Y LA FEDERACIÓN EUROPEA DE PERIODONTOLOGÍA"
  },
  {
    "codigo":295654000,
    "descripcion":"SOBREDOSIS DE DACARBAZINA"
  },
  {
    "codigo":787174003,
    "descripcion":"SÍNDROME DE DISCAPACIDAD INTELECTUAL, MOVIMIENTOS HIPERQUINÉTICOS Y ATAXIA DE TRONCO"
  },
  {
    "codigo":262886005,
    "descripcion":"LESIÓN DE EPIPLÓN MAYOR"
  },
  {
    "codigo":10624991000119103,
    "descripcion":"BRONCONEUMONÍA CAUSADA POR ACHROMOBACTER"
  },
  {
    "codigo":721638007,
    "descripcion":"CARCINOMA NEUROENDOCRINO PRIMARIO DE ESTÓMAGO"
  },
  {
    "codigo":64443004,
    "descripcion":"HEMATOMA NO TRAUMÁTICO DE LA VESÍCULA SEMINAL"
  },
  {
    "codigo":293819007,
    "descripcion":"ALERGIA A CITRATO DE LITIO"
  },
  {
    "codigo":95376002,
    "descripcion":"ALTERACIÓN DEL SITIO DE INYECCIÓN"
  },
  {
    "codigo":291984004,
    "descripcion":"INTOXICACIÓN POR DROGAS BLOQUEANTES ADRENÉRGICAS NEURONALES"
  },
  {
    "codigo":717968005,
    "descripcion":"SÍNDROME DE MELANOMA Y TUMOR DEL SISTEMA NEURAL"
  },
  {
    "codigo":112761000119101,
    "descripcion":"ENOFTALMÍA DEBIDA A SÍNDROME DE SENO SILENCIOSO"
  },
  {
    "codigo":1240421004,
    "descripcion":"DERMATITIS PRURIGINOSA"
  },
  {
    "codigo":879973007,
    "descripcion":"DOLOR IRRUPTIVO ONCOLÓGICO"
  },
  {
    "codigo":16906361000119102,
    "descripcion":"QUISTE DERMOIDE DE PÁRPADO INFERIOR DERECHO"
  },
  {
    "codigo":1142117008,
    "descripcion":"TAQUICARDIA POR REENTRADA EN EL NODO AURICULOVENTRICULAR ATÍPICA LENTA-LENTA"
  },
  {
    "codigo":26170003,
    "descripcion":"ASCITIS POR ORINA"
  },
  {
    "codigo":1304122006,
    "descripcion":"ESOTROPÍA PROGRESIVA ADQUIRIDA DEBIDA A MIOPÍA ELEVADA"
  },
  {
    "codigo":386618008,
    "descripcion":"TRACTO GASTROINTESTINAL - HALLAZGO"
  },
  {
    "codigo":286479000,
    "descripcion":"UNTA ALIMENTOS"
  },
  {
    "codigo":15677561000119104,
    "descripcion":"MIOSITIS DE BRAZO DERECHO"
  },
  {
    "codigo":1236751004,
    "descripcion":"LESIÓN DE MÉDULA ESPINAL"
  },
  {
    "codigo":89871005,
    "descripcion":"SIGNO DE ROSENBACH"
  },
  {
    "codigo":777999008,
    "descripcion":"HIPOMIELINIZACIÓN CON COMPROMISO DEL TRONCO ENCEFÁLICO Y DE LA MÉDULA ESPINAL Y ESPASTICIDAD DE LAS PIERNAS"
  },
  {
    "codigo":253711009,
    "descripcion":"ORIFICIO CORONARIO ASIMÉTRICO"
  },
  {
    "codigo":448484002,
    "descripcion":"ARTIFICIO DEBIDO A REALIZACIÓN DE EXTENDIDO"
  },
  {
    "codigo":1471821000168101,
    "descripcion":"SE SIENTE INSEGURO CERCA DE SU FAMILIA"
  },
  {
    "codigo":332051000119100,
    "descripcion":"ANILLO DE SOEMMERRING DE OJO DERECHO"
  },
  {
    "codigo":22500005,
    "descripcion":"INFECCIÓN POR OESOPHAGOSTOMUM"
  },
  {
    "codigo":315577000,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: KUTCHI"
  },
  {
    "codigo":284644007,
    "descripcion":"AHOGAR A OTRA PERSONA"
  },
  {
    "codigo":248206001,
    "descripcion":"FACIES MARFANOIDE"
  },
  {
    "codigo":1296782003,
    "descripcion":"BRADIARRITMIA ESTABLE"
  },
  {
    "codigo":1264014005,
    "descripcion":"DOLOR EN MÚSCULO DE HOMBRO"
  },
  {
    "codigo":1231246007,
    "descripcion":"QUISTE HEMORRÁGICO DE ÓRBITA"
  },
  {
    "codigo":444814009,
    "descripcion":"SINUSITIS VIRAL"
  },
  {
    "codigo":280974009,
    "descripcion":"HEMORRAGIA DE INJERTO ARTERIOVENOSO"
  },
  {
    "codigo":11800851000119104,
    "descripcion":"LACERACIÓN DE RIÑÓN DERECHO"
  },
  {
    "codigo":705123008,
    "descripcion":"FRACTURA NO EXPUESTA DE COLUMNAS ANTERIOR Y POSTERIOR DE ACETÁBULO"
  },
  {
    "codigo":408376003,
    "descripcion":"ALTERNATIVAS FARMACOLÓGICAS COSTO-EFECTIVAS, NO CONSIDERADAS"
  },
  {
    "codigo":211768003,
    "descripcion":"CORROSIÓN DE PRIMER GRADO DE TRONCO"
  },
  {
    "codigo":440811000124101,
    "descripcion":"INGESTA INADECUADA DE SODIO"
  },
  {
    "codigo":1260344006,
    "descripcion":"HIDROCEFALIA EX VACUO DEBIDA A ENVEJECIMIENTO"
  },
  {
    "codigo":15160007,
    "descripcion":"VIRILIZACIÓN"
  },
  {
    "codigo":703288007,
    "descripcion":"FALLA DE PRÓTESIS DE VÁLVULA TRICÚSPIDE QUE REQUIERE REVISIÓN"
  },
  {
    "codigo":216584003,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR LIDOCAÍNA"
  },
  {
    "codigo":443371000124107,
    "descripcion":"OBESO CLASE I"
  },
  {
    "codigo":13325005,
    "descripcion":"OSTEOMIELITIS CRÓNICA DE LA MANO"
  },
  {
    "codigo":765154003,
    "descripcion":"HIPERTROFIA DE RIÑÓN DERECHO CONCOMITANTE CON HIPOPLASIA CONGÉNITA DE RIÑÓN IZQUIERDO Y DEBIDA A ELLA"
  },
  {
    "codigo":109794004,
    "descripcion":"PROFUNDIDAD VESTIBULAR INADECUADA LUEGO DE LA PÉRDIDA DENTARIA"
  },
  {
    "codigo":240866006,
    "descripcion":"TOXOCARIASIS OCULAR"
  },
  {
    "codigo":271799000,
    "descripcion":"MOVIMIENTOS ANORMALES DE LA CABEZA"
  },
  {
    "codigo":206263001,
    "descripcion":"RECIÉN NACIDO VIVO CON HIPOXIA ANTES DEL TRABAJO DE PARTO"
  },
  {
    "codigo":239031000,
    "descripcion":"SÍNDROME BUCOFACIAL - DIGITAL IV"
  },
  {
    "codigo":1287607005,
    "descripcion":"CARCINOMA SEBÁCEO DE PIEL DE PÁRPADO INFERIOR"
  },
  {
    "codigo":402871009,
    "descripcion":"NEOPLASIA MALIGNA DE TEJIDO FIBROSO SUBCUTÁNEO"
  },
  {
    "codigo":1187468005,
    "descripcion":"PARAPLEJÍA ESPÁSTICA AUTOSÓMICA DOMINANTE TIPO 73"
  },
  {
    "codigo":269964006,
    "descripcion":"EXTENDIDO CERVICAL - VIRUS PAPILOMA"
  },
  {
    "codigo":433804007,
    "descripcion":"RECHAZO ACELERADO DE TRASPLANTE INTESTINAL"
  },
  {
    "codigo":1351308008,
    "descripcion":"AGUJERO MACULAR DE ESPESOR PARCIAL"
  },
  {
    "codigo":366433002,
    "descripcion":"AMPLITUD DEL MOVIMIENTO ACTIVO DE EXTENSIÓN DE LA COLUMNA LUMBAR - HALLAZGO"
  },
  {
    "codigo":202593008,
    "descripcion":"OSTEOCONDROMATOSIS SINOVIAL DE ARTICULACIÓN METATARSOFALÁNGICA DE SEGUNDO A QUINTO DEDOS"
  },
  {
    "codigo":397366001,
    "descripcion":"MARGEN QUIRÚRGICO DE CONDUCTO CÍSTICO COMPROMETIDO POR CARCINOMA IN SITU"
  },
  {
    "codigo":167990003,
    "descripcion":"ESPUTO: ASPECTO NORMAL"
  },
  {
    "codigo":725046003,
    "descripcion":"DEFICIENCIA DE ACIL-COA DESHIDROGENASA 9"
  },
  {
    "codigo":69686006,
    "descripcion":"APERISTALTISMO DEL ESÓFAGO"
  },
  {
    "codigo":688711000119104,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE PLIEGUE ARITENOEPIGLÓTICO"
  },
  {
    "codigo":721376005,
    "descripcion":"SÍNDROME DEL CORDÓN CENTRAL DE MÉDULA ESPINAL AL NIVEL DEL QUINTO SEGMENTO CERVICAL"
  },
  {
    "codigo":334561000119100,
    "descripcion":"QUERATOCONO ESTABLE DE OJO DERECHO"
  },
  {
    "codigo":162485000,
    "descripcion":"SÍNTOMA QUE MEJORA CON EL ALIMENTO"
  },
  {
    "codigo":262624008,
    "descripcion":"TAMPÓN RETENIDO EN VAGINA"
  },
  {
    "codigo":129717001,
    "descripcion":"FORMACIONES FIBROGLANDULARES DISEMINADAS"
  },
  {
    "codigo":64181003,
    "descripcion":"INTENTO FALLIDO DE ABORTO CON PERFORACIÓN DE VAGINA"
  },
  {
    "codigo":424629004,
    "descripcion":"BARRERAS PARA EL TRANSPORTE IMPIDEN LA CAPACIDAD PARA UTILIZAR RECURSOS COMUNITARIOS"
  },
  {
    "codigo":293557004,
    "descripcion":"REACCIÓN ADVERSA A PENTOXIFILINA"
  },
  {
    "codigo":1145525006,
    "descripcion":"SISTEMA MUSCULOESQUELÉTICO NORMAL"
  },
  {
    "codigo":721672004,
    "descripcion":"ADENOCARCINOMA MUCINOSO PRIMARIO DE APÉNDICE"
  },
  {
    "codigo":160650001,
    "descripcion":"NIVEL 4 DE ACTIVIDAD SEGÚN EL PRINCIPIO DE FRECUENCIA, INTENSIDAD, DURACIÓN Y TIPO DE EJERCICIO; 12 OCASIONES O MÁS DE UNA MEZCLA DE ACTIVIDADES MODERADAS O ENÉRGICAS EN 4 SEMANAS"
  },
  {
    "codigo":717706003,
    "descripcion":"QUISTE DE CONDUCTO DE SKENE"
  },
  {
    "codigo":783242003,
    "descripcion":"DISTONÍA CERVICAL DE COMIENZO EN LA VIDA ADULTA TIPO DYT23"
  },
  {
    "codigo":191583000,
    "descripcion":"EPISODIO MANÍACO ÚNICO, LEVE"
  },
  {
    "codigo":226186008,
    "descripcion":"DIETA SIN HIDROXITOLUENO BUTILADO"
  },
  {
    "codigo":224351002,
    "descripcion":"NO APTO PARA RECIBIR INDEMNIZACIÓN POR LESIONES CRIMINALES"
  },
  {
    "codigo":93279005,
    "descripcion":"HIPOPLASIA CONGÉNITA DE OVARIO"
  },
  {
    "codigo":289887006,
    "descripcion":"HALLAZGO RELACIONADO CON LA FRECUENCIA DEL PERÍODO MENSTRUAL"
  },
  {
    "codigo":714036005,
    "descripcion":"PSEUDOBOLSILLO GINGIVAL"
  },
  {
    "codigo":124212006,
    "descripcion":"DEFICIENCIA DE CINURENINA 3 - MONOOXIGENASA"
  },
  {
    "codigo":11311841000119107,
    "descripcion":"FRACTURA POR OSTEOPOROSIS SECUNDARIA DE VÉRTEBRA SACRA"
  },
  {
    "codigo":1269257006,
    "descripcion":"ARTERIOESCLEROSIS DE BYPASS CON ARTERIA CORONARIA BIOLÓGICA NO AUTÓLOGA"
  },
  {
    "codigo":15735521000119108,
    "descripcion":"EPITELIOPATÍA CORNEAL DE OJO DERECHO CAUSADA POR VIRUS HERPES SIMPLEX"
  },
  {
    "codigo":251614000,
    "descripcion":"INTERVALO ENTRE LAS ONDAS III Y V DEL POTENCIAL EVOCADO AUDITIVO DEL TRONCO ENCEFÁLICO AUMENTADO"
  },
  {
    "codigo":55006001,
    "descripcion":"NEFROPATÍA POR CADENAS LIVIANAS"
  },
  {
    "codigo":253449009,
    "descripcion":"ANOMALÍA DEL MÚSCULO PAPILAR DE VÁLVULA AURICULOVENTRICULAR COMÚN"
  },
  {
    "codigo":56841008,
    "descripcion":"FIBROSIS PULMONAR MASIVA"
  },
  {
    "codigo":1300190004,
    "descripcion":"HIPOPLASIA PONTOCEREBELOSA CONGÉNITA TIPO 12"
  },
  {
    "codigo":308091000119103,
    "descripcion":"HIPERLAXITUD ARTICULAR DE MUÑECA DERECHA"
  },
  {
    "codigo":11776891000119102,
    "descripcion":"LACERACIÓN DE PORCIÓN LARGA DE MÚSCULO BÍCEPS BRAQUIAL DERECHO"
  },
  {
    "codigo":339501000119100,
    "descripcion":"LAGOFTALMOS MECÁNICO DE PÁRPADO IZQUIERDO"
  },
  {
    "codigo":184243005,
    "descripcion":"TARJETA DE COOPERACIÓN OBSTÉTRICA PERDIDA"
  },
  {
    "codigo":216621000119100,
    "descripcion":"STENT EN RAMA DESCENDENTE ANTERIOR DE ARTERIA CORONARIA IZQUIERDA"
  },
  {
    "codigo":139821000119102,
    "descripcion":"MUTACIÓN HETEROCIGOTA DE METILENTETRAHIDROFOLATO REDUCTASA"
  },
  {
    "codigo":103981000119101,
    "descripcion":"RETINOPATÍA PROLIFERATIVA POSTERIOR A CIRUGÍA DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":12207661000119105,
    "descripcion":"INFECCIÓN DE RÓTULA DERECHA ASOCIADA CON DISPOSITIVO DE FIJACIÓN INTERNA"
  },
  {
    "codigo":444552001,
    "descripcion":"HIPERPLASIA DE HUESO MANDIBULAR"
  },
  {
    "codigo":306221000119107,
    "descripcion":"GOTA CRÓNICA DE RODILLA, SIN TOFO, CAUSADA POR FÁRMACO"
  },
  {
    "codigo":247944002,
    "descripcion":"RUTINA DE POSTURAS"
  },
  {
    "codigo":348083004,
    "descripcion":"TRASTORNO PRIMARIO DEL SENTIDO DEL GUSTO"
  },
  {
    "codigo":127021000119102,
    "descripcion":"MASA DE PERINEO MASCULINO"
  },
  {
    "codigo":298541000119108,
    "descripcion":"OSTEONECROSIS DE FÉMUR CAUSADA POR FÁRMACO"
  },
  {
    "codigo":68141000119109,
    "descripcion":"PARÁLISIS FACIAL GRADO IV DE HOUSE-BRACKMANN"
  },
  {
    "codigo":1263752007,
    "descripcion":"FERTILIDAD MASCULINA DISMINUIDA"
  },
  {
    "codigo":15927341000119106,
    "descripcion":"PORTADOR DE ENFERMEDAD DE TRANSMISIÓN SEXUAL"
  },
  {
    "codigo":331821000119106,
    "descripcion":"MACULOPATÍA TÓXICA DERECHA"
  },
  {
    "codigo":770397004,
    "descripcion":"QUEMADURA PROFUNDA DE ESPESOR TOTAL DE DEDO DE LA MANO"
  },
  {
    "codigo":1296520006,
    "descripcion":"DISTENSIÓN ABDOMINAL FUNCIONAL POSTERIOR A INGESTA DE CIERTOS ALIMENTOS"
  },
  {
    "codigo":442717005,
    "descripcion":"ESTUDIO POR IMÁGENES DE LA VÍA BILIAR, ANORMAL"
  },
  {
    "codigo":703026000,
    "descripcion":"MYCOBACTERIUM FORTUITUM O MYCOBACTERIUM PEREGRINUM"
  },
  {
    "codigo":735794004,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE REGIÓN LUMBAR"
  },
  {
    "codigo":1260082009,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS DE PARED POSTERIOR DE HIPOFARINGE"
  },
  {
    "codigo":111367007,
    "descripcion":"ABSCESO PÉLVICO"
  },
  {
    "codigo":43996000,
    "descripcion":"CONFIGURACIÓN DE ÁCIDOS NUCLEICOS"
  },
  {
    "codigo":109532001,
    "descripcion":"EXFOLIACIÓN PRECOZ DEBIDA A ERUPCIÓN ECTÓPICA DE DIENTE CERCANO"
  },
  {
    "codigo":209671007,
    "descripcion":"SECCIÓN EXPUESTA DE LIGAMENTOS DE LA MUÑECA, MÚLTIPLES"
  },
  {
    "codigo":240604009,
    "descripcion":"LINFOGRANULOMA VENÉREO LATENTE"
  },
  {
    "codigo":1287345003,
    "descripcion":"INFECCIÓN DE OROFARINGE CAUSADA POR CANDIDA"
  },
  {
    "codigo":304305005,
    "descripcion":"AMPLITUD DE MOVIMIENTO DE MUÑECA DISMINUIDA"
  },
  {
    "codigo":238769006,
    "descripcion":"TELANGIECTASIA SOLAR"
  },
  {
    "codigo":15983791000119102,
    "descripcion":"ANOMALÍA ESTRUCTURAL CONGÉNITA DE ÓRBITA DERECHA"
  },
  {
    "codigo":204166003,
    "descripcion":"ANOMALÍAS MÚLTIPLES DEL SEGMENTO ANTERIOR DEL OJO"
  },
  {
    "codigo":1252742004,
    "descripcion":"ÚLCERA VARICOSA DE PIE"
  },
  {
    "codigo":1285510006,
    "descripcion":"LESIÓN TRAUMÁTICA DE GLOBO DE OJO"
  },
  {
    "codigo":300635000,
    "descripcion":"INCAPAZ DE MANEJAR UN AUTO"
  },
  {
    "codigo":366171002,
    "descripcion":"CONDUCCIÓN CARDÍACA - HALLAZGO"
  },
  {
    "codigo":726619004,
    "descripcion":"SÍNDROME DE PTOSIS PALPEBRAL, ESTRABISMO Y PUPILA ECTÓPICA"
  },
  {
    "codigo":431707004,
    "descripcion":"DEFORMIDAD DE MUÑECA DEBIDA A ARTRITIS REUMATOIDEA"
  },
  {
    "codigo":169563005,
    "descripcion":"EMBARAZADA - EN HISTORIA CLÍNICA"
  },
  {
    "codigo":202331007,
    "descripcion":"DESPRENDIMIENTO DEL RODETE GLENOIDEO"
  },
  {
    "codigo":298800000,
    "descripcion":"AMPLITUD DE ABDUCCIÓN ACTIVA DE HOMBRO AUMENTADA"
  },
  {
    "codigo":235099007,
    "descripcion":"SOBREMORDIDA TRAUMÁTICA EN PALADAR"
  },
  {
    "codigo":724784006,
    "descripcion":"DESMIELINIZACIÓN DE SISTEMA NERVIOSO CENTRAL CONCOMITANTE CON ENFERMEDAD MITOCONDRIAL Y DEBIDA A ELLA"
  },
  {
    "codigo":1281840008,
    "descripcion":"CRISIS EPILÉPTICA DE INICIO NO MOTOR CON ALTERACIÓN DE CONCIENCIA"
  },
  {
    "codigo":722949001,
    "descripcion":"ENFERMEDAD DE MÉNIÈRE FAMILIAR"
  },
  {
    "codigo":36656008,
    "descripcion":"BERIBERI"
  },
  {
    "codigo":198661003,
    "descripcion":"ABORTO ESPONTÁNEO COMPLETO CON CHOQUE"
  },
  {
    "codigo":10960201000119101,
    "descripcion":"HERIDA ABIERTA DE ANTEBRAZO IZQUIERDO"
  },
  {
    "codigo":34821005,
    "descripcion":"ESTENOSIS CONGÉNITA DE LA COANA NASAL"
  },
  {
    "codigo":788485006,
    "descripcion":"TRASTORNO DE MOVIMIENTO REPETITIVO DE TOBILLO DERECHO"
  },
  {
    "codigo":1074351000119108,
    "descripcion":"ARTROSIS SECUNDARIA DE RODILLA IZQUIERDA"
  },
  {
    "codigo":11779401000119102,
    "descripcion":"AMPOLLA DE CODO DERECHO, CON INFECCIÓN"
  },
  {
    "codigo":1148933002,
    "descripcion":"HIDRONEFROSIS CONGÉNITA DEBIDA A OBSTRUCCIÓN DE ORIFICIO URETERAL"
  },
  {
    "codigo":65754002,
    "descripcion":"DISMENORREA PRIMARIA"
  },
  {
    "codigo":426202004,
    "descripcion":"SÍNDROME DE RECONSTITUCIÓN INMUNOLÓGICA"
  },
  {
    "codigo":63919000,
    "descripcion":"FACTOR R"
  },
  {
    "codigo":194991001,
    "descripcion":"ESTENOSIS TRICUSPÍDEA, NO REUMÁTICA"
  },
  {
    "codigo":293295008,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR BISFOSFONATO"
  },
  {
    "codigo":422532006,
    "descripcion":"INHIBICIÓN DE ENZIMA DE CITOCROMO P450 CYP3A POR SUSTANCIA"
  },
  {
    "codigo":94852008,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA MUCOSA GINGIVAL"
  },
  {
    "codigo":224089000,
    "descripcion":"SIN FAMILIARES CONOCIDOS"
  },
  {
    "codigo":1340036008,
    "descripcion":"ABRASIÓN DE PIEL DE CUARTO DEDO DE PIE"
  },
  {
    "codigo":289625003,
    "descripcion":"HALLAZGO RELACIONADO CON LA ALTURA DEL FONDO DEL ÚTERO"
  },
  {
    "codigo":93017005,
    "descripcion":"ANOMALÍA CONGÉNITA DE LOS HUESOS PÉLVICOS"
  },
  {
    "codigo":1010521007,
    "descripcion":"ESCLEROSIS DE EPÍFISIS DE FALANGE DE TERCER DEDO DE PIE CON RADIOPACIDAD AUMENTADA"
  },
  {
    "codigo":123950001,
    "descripcion":"COREA REUMÁTICA SIN COMPROMISO CARDÍACO"
  },
  {
    "codigo":255022003,
    "descripcion":"HEMANGIOMA DE COROIDES"
  },
  {
    "codigo":25646005,
    "descripcion":"CISTINURIA AISLADA"
  },
  {
    "codigo":449795002,
    "descripcion":"HEMORRAGIA EN ESPACIO SUBDURAL DE COLUMNA VERTEBRAL"
  },
  {
    "codigo":285955004,
    "descripcion":"COLOCA EL TAPÓN DEL DESAGÜE"
  },
  {
    "codigo":56579005,
    "descripcion":"ÚLCERA GASTROYEYUNAL CRÓNICA SIN HEMORRAGIA Y SIN PERFORACIÓN PERO CON OBSTRUCCIÓN"
  },
  {
    "codigo":253187005,
    "descripcion":"MALFORMACIÓN DE CHIARI TIPO IV"
  },
  {
    "codigo":185816000,
    "descripcion":"INCUMPLIMIENTO EN EL CONTROL DE SALUD DEL HOMBRE"
  },
  {
    "codigo":284120006,
    "descripcion":"DIFICULTAD PARA CONTROLAR LA POSICIÓN DE LA CINTURA ESCAPULAR"
  },
  {
    "codigo":251352006,
    "descripcion":"REACCIÓN CUTÁNEA EXTREMA"
  },
  {
    "codigo":710104008,
    "descripcion":"GRADO DE INCLINACIÓN DEL PLANO OCLUSAL CON PENDIENTE HACIA LA DERECHA DEBIDO A ASIMETRÍA ESQUELÉTICA"
  },
  {
    "codigo":52909001,
    "descripcion":"INTOXICACIÓN CAUSADA POR GAS MOSTAZA"
  },
  {
    "codigo":87512008,
    "descripcion":"DEPRESIÓN MAYOR LEVE"
  },
  {
    "codigo":1263490000,
    "descripcion":"MIELOPATÍA DEBIDA A ENFERMEDAD HEPÁTICA"
  },
  {
    "codigo":249517009,
    "descripcion":"ESTREÑIMIENTO ALTERNADO CON DIARREA"
  },
  {
    "codigo":870274001,
    "descripcion":"ARTRITIS POSTERIOR A MICOBACTERIOSIS"
  },
  {
    "codigo":1359959002,
    "descripcion":"HERIDA ABIERTA DE DEDO ANULAR DEBIDA A MORDEDURA DE GATO"
  },
  {
    "codigo":278615005,
    "descripcion":"PRÓTESIS DENTAL, PRESENTE"
  },
  {
    "codigo":82007007,
    "descripcion":"TORACOPARACÉFALO"
  },
  {
    "codigo":735532001,
    "descripcion":"INFECCIÓN DE PULMÓN CAUSADA POR ECHINOCOCCUS"
  },
  {
    "codigo":1259820006,
    "descripcion":"CÁNCER DE PULMÓN NO MICROCÍTICO PRIMARIO NEGATIVO PARA EL GEN DE ESPECIES REACTIVAS DEL OXÍGENO-1"
  },
  {
    "codigo":307713000,
    "descripcion":"FRACTURA DE BARTON NO EXPUESTA"
  },
  {
    "codigo":1076861000119107,
    "descripcion":"QUISTE ÓSEO SOLITARIO DE CÚBITO DERECHO"
  },
  {
    "codigo":406017003,
    "descripcion":"INTEGRIDAD DEL ESPÉCIMEN, NO ESPECIFICADA"
  },
  {
    "codigo":274945004,
    "descripcion":"AMILOIDOSIS AA"
  },
  {
    "codigo":242177005,
    "descripcion":"LESIÓN TRAUMÁTICA EN CAÍDA SOBRE EMBARCACIÓN DEBIDA A ACCIDENTE QUE INVOLUCRA A LA EMBARCACIÓN"
  },
  {
    "codigo":438785004,
    "descripcion":"TROMBOSIS PROFUNDA DE VENA TIBIAL"
  },
  {
    "codigo":897537007,
    "descripcion":"ANOMALÍA CONGÉNITA DE CONDUCTO AUDITIVO INTERNO"
  },
  {
    "codigo":339581000119108,
    "descripcion":"QUERATITIS MACULAR DE OJO IZQUIERDO"
  },
  {
    "codigo":76502001,
    "descripcion":"FÍSTULA DE FONDO DE SACO"
  },
  {
    "codigo":109270003,
    "descripcion":"MELANOMA IN SITU DE LA CARA"
  },
  {
    "codigo":764630003,
    "descripcion":"SÍNDROME DE TRISOMÍA 7 MOSAICO"
  },
  {
    "codigo":305878005,
    "descripcion":"ATENDIDO POR SERVICIO DE PSICOTERAPIA"
  },
  {
    "codigo":402347007,
    "descripcion":"DESCAMACIÓN SECUNDARIA A ENFERMEDAD SISTÉMICA AGUDA"
  },
  {
    "codigo":369579009,
    "descripcion":"TUMOR MALIGNO QUE COMPROMETE EL CUERPO UTERINO POR PROPAGACIÓN DIRECTA DE LA TROMPA DE FALOPIO"
  },
  {
    "codigo":105600002,
    "descripcion":"TRASTORNO DE LOS NEUTRÓFILOS"
  },
  {
    "codigo":236672003,
    "descripcion":"PROSTATITIS POR CLAMIDIA"
  },
  {
    "codigo":70997004,
    "descripcion":"ANSIEDAD LEVE"
  },
  {
    "codigo":365909006,
    "descripcion":"MEMORIA DEL AÑO ACTUAL - HALLAZGO"
  },
  {
    "codigo":300373008,
    "descripcion":"HALLAZGO RELACIONADO CON LA DEFECACIÓN"
  },
  {
    "codigo":726357009,
    "descripcion":"TRISOMÍA PARCIAL DE CROMOSOMA 18"
  },
  {
    "codigo":368561000119102,
    "descripcion":"HIPEROSMOLARIDAD DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":276659006,
    "descripcion":"INFECCIÓN CLÍNICA DEL RECIÉN NACIDO"
  },
  {
    "codigo":724522005,
    "descripcion":"ÚLCERA ANASTOMÓTICA DE ESTÓMAGO CAUSADA POR HELICOBACTER PYLORI"
  },
  {
    "codigo":298538006,
    "descripcion":"AMPLITUD DE FLEXIÓN LATERAL PASIVA HACIA LA DERECHA DE LA COLUMNA VERTEBRAL DORSAL, DISMINUIDA"
  },
  {
    "codigo":11837361000119104,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE MUSLO IZQUIERDO"
  },
  {
    "codigo":165631003,
    "descripcion":"NIVEL DE HIERRO SÉRICO FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":427775006,
    "descripcion":"TROMBOSIS VENOSA PROFUNDA DE VENA FEMORAL PROFUNDA"
  },
  {
    "codigo":722687007,
    "descripcion":"CARCINOMA MUCINOSO PRIMARIO DE ANEXOS UTERINOS"
  },
  {
    "codigo":720852000,
    "descripcion":"SÍNDROME DE HIPERTRICOSIS CERVICAL Y NEUROPATÍA PERIFÉRICA"
  },
  {
    "codigo":1148671008,
    "descripcion":"SOBREDOSIS DE ANFETAMINA Y\/O DERIVADO DE ANFETAMINA"
  },
  {
    "codigo":425940002,
    "descripcion":"INFLAMACIÓN DE BOLSA SEROSA DE OLÉCRANON"
  },
  {
    "codigo":131028000,
    "descripcion":"NIVEL DE HORMONA ANTIDIURÉTICA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":360404009,
    "descripcion":"DEFORMACIÓN DE LA MAMA"
  },
  {
    "codigo":719017003,
    "descripcion":"DISCAPACIDAD INTELECTUAL LIGADA AL CROMOSOMA X TIPO ARMFIELD"
  },
  {
    "codigo":424105005,
    "descripcion":"OSTEONECROSIS DEL CARPO"
  },
  {
    "codigo":260265007,
    "descripcion":"N48"
  },
  {
    "codigo":1145001009,
    "descripcion":"GASTRITIS DEBIDA A SARCOIDOSIS"
  },
  {
    "codigo":225662002,
    "descripcion":"CAPAZ DE PENSAR CLARAMENTE"
  },
  {
    "codigo":10936241000119109,
    "descripcion":"FRACTURA NO EXPUESTA DE HUESO TRAPEZOIDE DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":1079371000119103,
    "descripcion":"NEOPLASIA BENIGNA DE PIEL DE MIEMBRO SUPERIOR DERECHO"
  },
  {
    "codigo":717182006,
    "descripcion":"HIPERINSULINISMO DEBIDO A DEFICIENCIA DE GLUCOCINASA"
  },
  {
    "codigo":782718007,
    "descripcion":"SÍNDROME DE DISTONÍA-AFONÍA"
  },
  {
    "codigo":94590005,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE PARTES BLANDAS DEL CUELLO"
  },
  {
    "codigo":420435001,
    "descripcion":"EDEMA SIN FÓVEA"
  },
  {
    "codigo":387667002,
    "descripcion":"TIMPANISMO GÁSTRICO"
  },
  {
    "codigo":289363003,
    "descripcion":"HALLAZGO RELACIONADO CON LA POSICIÓN DE LA PRESENTACIÓN DE VÉRTICE"
  },
  {
    "codigo":192894009,
    "descripcion":"SIRINGOMIELIA Y SIRINGOBULBIA"
  },
  {
    "codigo":844584001,
    "descripcion":"EFECTO REBOTE DE MEDICACIÓN"
  },
  {
    "codigo":123688002,
    "descripcion":"FOLICULITIS CRÓNICA"
  },
  {
    "codigo":254760005,
    "descripcion":"HAMARTOMA NEUROMUSCULAR"
  },
  {
    "codigo":25384006,
    "descripcion":"ANTÍGENO DE GRUPO SANGUÍNEO S>2<"
  },
  {
    "codigo":713512009,
    "descripcion":"DEBILIDAD MUSCULAR DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":1268733004,
    "descripcion":"PIEL GRASA DEBIDA A SECRECIÓN EXCESIVA DE SEBO"
  },
  {
    "codigo":56317004,
    "descripcion":"ALOPECIA"
  },
  {
    "codigo":285693006,
    "descripcion":"NO CARGA PESO EN PIERNA IZQUIERDA"
  },
  {
    "codigo":23549005,
    "descripcion":"ONICOMICOSIS CAUSADA POR TRICHOPHYTON MENTAGROPHYTES"
  },
  {
    "codigo":449533005,
    "descripcion":"LOCALIZACIÓN SUPRACARDÍACA DE CONEXIÓN ANÓMALA DE VENA PULMONAR A VENA ÁCIGOS"
  },
  {
    "codigo":447698003,
    "descripcion":"DEFECTO DEL TABIQUE INTERVENTRICULAR CON MALA ALINEACIÓN ANTERIOR DEL TABIQUE CORRESPONDIENTE AL TRACTO DE SALIDA Y CABALGAMIENTO DE VÁLVULA AÓRTICA"
  },
  {
    "codigo":283858004,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DE PULGAR"
  },
  {
    "codigo":183719000,
    "descripcion":"CONSULTA DOMICILIARIA DE MEDICINA RESPIRATORIA SOLICITADA"
  },
  {
    "codigo":249255000,
    "descripcion":"PREPUCIO CIRCUNCIDADO"
  },
  {
    "codigo":216487007,
    "descripcion":"INTOXICACIÓN ACCIDENTAL CAUSADA POR IBUPROFENO"
  },
  {
    "codigo":118183008,
    "descripcion":"HALLAZGO RELACIONADO CON LA FERTILIDAD"
  },
  {
    "codigo":312956001,
    "descripcion":"CORIORRETINOPATÍA SEROSA CENTRAL"
  },
  {
    "codigo":1197692006,
    "descripcion":"ÚLCERA DUODENAL POR ENFERMEDAD DE CROHN"
  },
  {
    "codigo":83580006,
    "descripcion":"INFECCIÓN CAUSADA POR AVITELLINA"
  },
  {
    "codigo":1163089000,
    "descripcion":"ENDOCARDITIS INFECCIOSA AGUDA DE HEMICARDIO IZQUIERDO"
  },
  {
    "codigo":247420009,
    "descripcion":"FUNCIÓN SEXUAL DOLOROSA"
  },
  {
    "codigo":704337003,
    "descripcion":"FRACTURA OSTEOPORÓTICA DE OMÓPLATO"
  },
  {
    "codigo":407590002,
    "descripcion":"REACCIÓN ADVERSA A ANTAGONISTA DEL RECEPTOR DE ANGIOTENSINA II"
  },
  {
    "codigo":1259558003,
    "descripcion":"ENCEFALOPATÍA ANÓXICA DEBIDA A ASFIXIA"
  },
  {
    "codigo":276518005,
    "descripcion":"REGURGITACIÓN TRICUSPÍDEA TRANSITORIA DEL RECIÉN NACIDO"
  },
  {
    "codigo":471291001,
    "descripcion":"ORIGEN ANÓMALO DE ARTERIA CORONARIA DERECHA EN SENO AÓRTICO A LA DERECHA DE SENO AÓRTICO NO ENFRENTADO Y ORIGEN ANÓMALO DE ARTERIA DESCENDENTE ANTERIOR IZQUIERDA EN SENO AÓRTICO A LA IZQUIERDA DE SENO AÓRTICO NO ENFRENTADO"
  },
  {
    "codigo":45307008,
    "descripcion":"EMBARAZO EXTRACORIAL"
  },
  {
    "codigo":1290491009,
    "descripcion":"TRASTORNO DE TENDÓN DE REGIÓN DE CODO"
  },
  {
    "codigo":405755009,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÉDULA ESPINAL CERVICAL ANTERIOR A NIVEL DE C1-C4 SIN LESIÓN VERTEBRAL"
  },
  {
    "codigo":240080003,
    "descripcion":"HIPOTONÍA CONGÉNITA BENIGNA"
  },
  {
    "codigo":305616003,
    "descripcion":"BAJO ATENCIÓN DE TERAPEUTA ESPECIALISTA EN EL HABLA Y EN EL LENGUAJE"
  },
  {
    "codigo":1255888005,
    "descripcion":"PARAGRANULOMA DE HODGKIN DE GANGLIOS LINFÁTICOS DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":762533006,
    "descripcion":"PSEUDODRUSA RETICULAR"
  },
  {
    "codigo":860837007,
    "descripcion":"MIOCARDIOPATÍA DEBIDA A ENFERMEDAD DEL TEJIDO CONJUNTIVO"
  },
  {
    "codigo":236410005,
    "descripcion":"GLOMERULONEFRITIS MESANGIOCAPILAR TIPO IV"
  },
  {
    "codigo":301946008,
    "descripcion":"REACCIÓN PUPILAR A LA LUZ, NORMAL"
  },
  {
    "codigo":70735001,
    "descripcion":"INTOXICACIÓN POR SESBANIA"
  },
  {
    "codigo":344601000119104,
    "descripcion":"CORIORRETINITIS DISEMINADA PERIFÉRICA DE AMBOS OJOS"
  },
  {
    "codigo":365647004,
    "descripcion":"HALLAZGO RELACIONADO CON EL TÍTULO DE ANTICUERPOS RHD"
  },
  {
    "codigo":169039007,
    "descripcion":"TOMOGRAFÍA: TÓRAX ANORMAL"
  },
  {
    "codigo":201807008,
    "descripcion":"ARTRITIS JUVENIL EN LA COLITIS ULCEROSA"
  },
  {
    "codigo":300111009,
    "descripcion":"HALLAZGO RELACIONADO CON LA COLORACIÓN DEL PABELLÓN AURICULAR"
  },
  {
    "codigo":298276004,
    "descripcion":"HALLAZGO RELACIONADO CON LA DISPOSICIÓN DEL MÚSCULO ESQUELÉTICO"
  },
  {
    "codigo":199972004,
    "descripcion":"LACERACIÓN DE CUELLO UTERINO DEBIDA A NACIMIENTO"
  },
  {
    "codigo":167204007,
    "descripcion":"PRUEBA DE ABSORCIÓN DE D - XILOSA, ANORMAL"
  },
  {
    "codigo":68900007,
    "descripcion":"AFASIA POSTRAUMÁTICA"
  },
  {
    "codigo":787961005,
    "descripcion":"KLEBSIELLA PNEUMONIAE SUBESPECIE PNEUMONIAE O RAOULTELLA PLANTICOLA"
  },
  {
    "codigo":198137009,
    "descripcion":"SALPINGOOFORITIS SUBAGUDA"
  },
  {
    "codigo":722425009,
    "descripcion":"CÁNCER DE PULMÓN NO MICROCÍTICO POSITIVO PARA ESPECIE REACTIVA DE OXÍGENO 1"
  },
  {
    "codigo":65230006,
    "descripcion":"SÍNDROME DE MONONUCLEOSIS HETERÓFILO NEGATIVO"
  },
  {
    "codigo":391075000,
    "descripcion":"RESULTADO DE ABSORCIOMETRÍA DE RAYOS X DE ENERGÍA DUAL DE HUESO DE VÉRTEBRA LUMBAR, OSTEOPOROSIS"
  },
  {
    "codigo":196302008,
    "descripcion":"CARIES CRÓNICA DEL ESMALTE DENTAL"
  },
  {
    "codigo":292771001,
    "descripcion":"REACCIÓN ADVERSA A PREPARADO PARA REMOCIÓN DE CERUMEN"
  },
  {
    "codigo":423843003,
    "descripcion":"LUGAR DE GASTROSTOMÍA ENDOSCÓPICA PERCUTÁNEA INFECTADO"
  },
  {
    "codigo":521000146105,
    "descripcion":"MIASTENIA GRAVE CAUSADA POR ANTICUERPOS ESPECÍFICOS ANTI-MUSK (CINASA ESPECÍFICA DE MÚSCULO)"
  },
  {
    "codigo":63395003,
    "descripcion":"FOLIE À TROIS"
  },
  {
    "codigo":718755009,
    "descripcion":"ATAXIA EPISÓDICA TIPO 3"
  },
  {
    "codigo":290936004,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR LAMOTRIGINA"
  },
  {
    "codigo":127096005,
    "descripcion":"LINFADENOPATÍA ESCALENA"
  },
  {
    "codigo":94328005,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL ÁNGULO HEPÁTICO DEL COLON"
  },
  {
    "codigo":715085006,
    "descripcion":"CAPAZ DE PASAR DE UNA SILLA DE RUEDAS A UN AUTOMÓVIL"
  },
  {
    "codigo":289101007,
    "descripcion":"CAPAZ DE CONTROLAR LA RESPIRACIÓN"
  },
  {
    "codigo":90658001,
    "descripcion":"SOPLO VENOSO"
  },
  {
    "codigo":287266002,
    "descripcion":"DEFICIENCIA DE LACTATO DESHIDROGENASA MUSCULAR"
  },
  {
    "codigo":713250002,
    "descripcion":"ENFERMEDAD GINGIVAL CAUSADA POR VIRUS VARICELA-ZÓSTER"
  },
  {
    "codigo":10941261000119103,
    "descripcion":"COMPRESIÓN FOCAL DE CEREBRO DEBIDA A TRAUMATISMO"
  },
  {
    "codigo":254498009,
    "descripcion":"NEOPLASIA DE ARCO FARINGOPALATINO"
  },
  {
    "codigo":449271003,
    "descripcion":"COARTACIÓN RESIDUAL DE AORTA"
  },
  {
    "codigo":23287003,
    "descripcion":"CONTUSIÓN DEL ESCROTO"
  },
  {
    "codigo":56055004,
    "descripcion":"INTOXICACIÓN POR HEPTACLORO"
  },
  {
    "codigo":1137399006,
    "descripcion":"HIPOTONÍA DE MÚSCULOS DE REGIÓN DE LA BOCA"
  },
  {
    "codigo":185292006,
    "descripcion":"ATENDIDO POR UN ESTUDIANTE DE MEDICINA"
  },
  {
    "codigo":54220007,
    "descripcion":"FISURA DEL PEZÓN"
  },
  {
    "codigo":871585005,
    "descripcion":"ANOMALÍA CONGÉNITA DE VÁLVULA AURICULOVENTRICULAR DEL LADO DERECHO EN VENTRÍCULO CON DOBLE ENTRADA"
  },
  {
    "codigo":773281008,
    "descripcion":"SÍNDROME DE THAKKER DONNAI"
  },
  {
    "codigo":1363105009,
    "descripcion":"ASTILLA EN CUELLO CON INFECCIÓN"
  },
  {
    "codigo":443766002,
    "descripcion":"INVASIÓN NEOPLÁSICA DE PERITONEO VISCERAL"
  },
  {
    "codigo":771446000,
    "descripcion":"COLANGITIS Y PANCREATITIS FOLICULAR"
  },
  {
    "codigo":247158001,
    "descripcion":"DESPRENDIMIENTO EPITELIAL DEL PIGMENTO MACULAR"
  },
  {
    "codigo":1197430005,
    "descripcion":"DEFICIENCIA COMBINADA DE LA FOSFORILACIÓN OXIDATIVA ASOCIADA A GEN QRSL1"
  },
  {
    "codigo":279926005,
    "descripcion":"MIEDO A LAS AGUJAS"
  },
  {
    "codigo":17782008,
    "descripcion":"TRASTORNO BIPOLAR I, EPISODIO MÁS RECIENTE MANÍACO CON SÍNTOMAS CATATÓNICOS"
  },
  {
    "codigo":441931002,
    "descripcion":"ALERGIA A CLOROPROCAÍNA"
  },
  {
    "codigo":278091004,
    "descripcion":"CABEZA FETAL DEFLEXIONADA"
  },
  {
    "codigo":210720002,
    "descripcion":"LESIÓN POR DESOLLAMIENTO DE PIE"
  },
  {
    "codigo":1259296003,
    "descripcion":"FORMACIÓN DE TEJIDO CONECTIVO EN SITIO DE FRACTURA DE RAÍZ DE DIENTE"
  },
  {
    "codigo":309024004,
    "descripcion":"SITUACIÓN DEL INFORME DE SEGURO DE VIDA"
  },
  {
    "codigo":276256005,
    "descripcion":"PATRÓN ELECTROMIOGRÁFICO INDETERMINADO"
  },
  {
    "codigo":866080006,
    "descripcion":"NEOPLASIA MALIGNA DE CÉLULAS GERMINATIVAS DE CORAZÓN"
  },
  {
    "codigo":315528008,
    "descripcion":"NACIDO EN SAN KITTS Y NEVIS"
  },
  {
    "codigo":405493003,
    "descripcion":"EVALUACIÓN INADECUADA DEL EQUIPAMIENTO"
  },
  {
    "codigo":897013003,
    "descripcion":"RUPTURA ESPONTÁNEA DE CORDÓN UMBILICAL FETAL"
  },
  {
    "codigo":208885006,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN METACARPOFALÁNGICA"
  },
  {
    "codigo":15721601000119102,
    "descripcion":"CONTRACTURA DE ARTICULACIONES DE AMBAS CADERAS"
  },
  {
    "codigo":764106001,
    "descripcion":"SIMBRAQUIDACTILIA DE DEDO DE LA MANO"
  },
  {
    "codigo":272586002,
    "descripcion":"POSICIÓN DEL PACIENTE CON FLEXIÓN DEL CUELLO"
  },
  {
    "codigo":733173009,
    "descripcion":"MENINGITIS EOSINOFÍLICA CAUSADA POR ANGIOSTRONGYLUS CANTONENSIS"
  },
  {
    "codigo":239818009,
    "descripcion":"SINOVITIS DE HOMBRO"
  },
  {
    "codigo":237983002,
    "descripcion":"DEFICIENCIA DE FUMARATO HIDRATASA"
  },
  {
    "codigo":15639681000119104,
    "descripcion":"DEBILIDAD DE AMBAS MANOS"
  },
  {
    "codigo":762271004,
    "descripcion":"FIBROSIS QUÍSTICA SUBCLÍNICA"
  },
  {
    "codigo":205215005,
    "descripcion":"DEFICIENCIA TIBIAL CONGÉNITA TIPO III"
  },
  {
    "codigo":301684000,
    "descripcion":"NO SE MUEVE EN LA CAMA"
  },
  {
    "codigo":39540007,
    "descripcion":"DEPRESIÓN CONGÉNITA EN EL CRÁNEO"
  },
  {
    "codigo":168777000,
    "descripcion":"RADIOGRAFÍA SIMPLE DE PARTES BLANDAS DE EXTREMIDAD ANORMAL"
  },
  {
    "codigo":299849001,
    "descripcion":"REFLEJO DE HOFFMAN POSITIVO"
  },
  {
    "codigo":170612008,
    "descripcion":"SIBILANCIA QUE AUMENTA CON EL EJERCICIO"
  },
  {
    "codigo":365385005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA USAR INSTALACIONES EDUCATIVAS"
  },
  {
    "codigo":723998001,
    "descripcion":"SÍNDROME DE BAJA ESTATURA, SECUENCIA DE PIERRE ROBIN, FISURA DE MANDÍBULA ANOMALÍAS DE LAS MANOS Y PIE ZAMBO"
  },
  {
    "codigo":298014004,
    "descripcion":"HALLAZGO RELACIONADO CON LA PRUEBA DE MANTOUX"
  },
  {
    "codigo":166942004,
    "descripcion":"NIVEL DE FENITOÍNA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":230643005,
    "descripcion":"COMPRESIÓN DEL NERVIO TIBIAL"
  },
  {
    "codigo":427251005,
    "descripcion":"OBSTRUCCIÓN DE VÍA AÉREA CAUSADA POR ALIMENTO"
  },
  {
    "codigo":165107009,
    "descripcion":"ÍNDICE METABÓLICO RÁPIDO"
  },
  {
    "codigo":196040003,
    "descripcion":"NEUMONITIS POR ASPIRACIÓN DEBIDO A ANESTESIA DURANTE EL TRABAJO DE PARTO Y EL PARTO"
  },
  {
    "codigo":294344004,
    "descripcion":"ALERGIA A TOLNAFTATO"
  },
  {
    "codigo":30365001,
    "descripcion":"INTOXICACIÓN POR ALCALOIDE DE RAUWOLFIA"
  },
  {
    "codigo":64968009,
    "descripcion":"INFECCIÓN CAUSADA POR NOTOCOTYLUS"
  },
  {
    "codigo":95901003,
    "descripcion":"ACCIÓN PROLONGADA DE UN FÁRMACO"
  },
  {
    "codigo":292509001,
    "descripcion":"REACCIÓN ADVERSA A LA ISOPRENALINA ADMINISTRADA POR INHALACIÓN"
  },
  {
    "codigo":24584003,
    "descripcion":"MIOCARDIOPATÍA RESTRICTIVA SECUNDARIA A CÁNCER"
  },
  {
    "codigo":782194002,
    "descripcion":"QUISTE DE RAFE MEDIO GENITAL"
  },
  {
    "codigo":126834003,
    "descripcion":"NEOPLASIA DEL YEYUNO"
  },
  {
    "codigo":94066004,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL ESFENOIDES"
  },
  {
    "codigo":716658005,
    "descripcion":"FIBROADENOMAS MÚLTIPLES DE AMBAS MAMAS"
  },
  {
    "codigo":421746007,
    "descripcion":"INCISIÓN CORNEAL INTACTA"
  },
  {
    "codigo":190535006,
    "descripcion":"HIPERSECRECIÓN DE PROGESTERONA OVÁRICA"
  },
  {
    "codigo":92231007,
    "descripcion":"NEOPLASIA BENIGNA DE MÚSCULO DE LA PELVIS"
  },
  {
    "codigo":712988000,
    "descripcion":"LEUCOPLASIA ORAL CAUSADA POR SANGUINARINA"
  },
  {
    "codigo":714823009,
    "descripcion":"HEMATURIA RECURRENTE CONCOMITANTE CON ANOMALÍA GLOMERULAR MENOR Y DEBIDA A ELLA"
  },
  {
    "codigo":419911008,
    "descripcion":"FIBRINA EN LA CÁMARA ANTERIOR"
  },
  {
    "codigo":57628003,
    "descripcion":"INTOXICACIÓN POR HIDRATO DE CLORAL"
  },
  {
    "codigo":254236007,
    "descripcion":"UÑAS AGRANDADAS CONGÉNITAS"
  },
  {
    "codigo":450844008,
    "descripcion":"ENURESIS NOCTURNA DE ETIOLOGÍA NO ORGÁNICA"
  },
  {
    "codigo":711153001,
    "descripcion":"SÍNDROME DE BOWEN-CONRADI"
  },
  {
    "codigo":285169000,
    "descripcion":"INCAPAZ DE RECONOCER CARAS VISUALMENTE"
  },
  {
    "codigo":414406000,
    "descripcion":"ABERRACIÓN DEL FRENTE DE ONDA DE ALTO ORDEN"
  },
  {
    "codigo":449009009,
    "descripcion":"VENA CAVA INFERIOR IZQUIERDA CONECTADA A AURÍCULA EN EL LADO IZQUIERDO"
  },
  {
    "codigo":52123000,
    "descripcion":"CISTITIS ENFISEMATOSA"
  },
  {
    "codigo":1297307001,
    "descripcion":"CELULITIS DE SEGUNDO DEDO DE PIE"
  },
  {
    "codigo":445339002,
    "descripcion":"NEUROPATÍA CAUSADA POR RADIACIÓN IONIZANTE"
  },
  {
    "codigo":283334008,
    "descripcion":"PICADURA DE INSECTO EN DEDO DE LA MANO"
  },
  {
    "codigo":248731004,
    "descripcion":"ONDA \"A\" DEL PULSO VENOSO YUGULAR EXAGERADA"
  },
  {
    "codigo":281499005,
    "descripcion":"EXOSTOSIS SUBUNGUEAL DE SEGUNDO A QUINTO DEDOS DEL PIE"
  },
  {
    "codigo":707483004,
    "descripcion":"CARCINOMA PRIMARIO INDIFERENCIADO DE HIPOFARINGE"
  },
  {
    "codigo":323151000119105,
    "descripcion":"LONGITUD DESIGUAL DE EXTREMIDAD SUPERIOR DEBIDA A ACORTAMIENTO ADQUIRIDO DE CÚBITO DERECHO"
  },
  {
    "codigo":83056001,
    "descripcion":"BORRAMIENTO CERVICAL, 30%"
  },
  {
    "codigo":771184001,
    "descripcion":"SÍNDROME DE LEUCOENCEFALOPATÍA Y QUERATODERMIA PALMOPLANTAR"
  },
  {
    "codigo":314267009,
    "descripcion":"MEMBRANA COROIDEA NEOVASCULAR EXTRAMACULAR"
  },
  {
    "codigo":115824003,
    "descripcion":"FENOTIPO IN (LU)"
  },
  {
    "codigo":296681000119100,
    "descripcion":"HIPERLAXITUD ARTICULAR DE HOMBRO"
  },
  {
    "codigo":50288007,
    "descripcion":"INTOXICACIÓN CRÓNICA POR COBRE"
  },
  {
    "codigo":246896009,
    "descripcion":"FOLÍCULOS DE LA CONJUNTIVA DEL LIMBO"
  },
  {
    "codigo":212293004,
    "descripcion":"CONTUSIÓN, NERVIO TORÁCICO LARGO"
  },
  {
    "codigo":277829006,
    "descripcion":"ANSIEDAD ACERCA DE PERDER CONTROL DE LAS EMOCIONES"
  },
  {
    "codigo":1162565008,
    "descripcion":"CÁLCULO DE CONDUCTO BILIAR INTRAHEPÁTICO"
  },
  {
    "codigo":210458004,
    "descripcion":"HERIDA ABIERTA EN LA REGIÓN UMBILICAL"
  },
  {
    "codigo":77551005,
    "descripcion":"FRACTURA EXPUESTA DE HUESO METATARSIANO"
  },
  {
    "codigo":110319006,
    "descripcion":"FALTA DE GUÍA OCLUSAL EN LOS CANINOS"
  },
  {
    "codigo":306927008,
    "descripcion":"MOVILIDAD DEL ESTRIBO NORMAL"
  },
  {
    "codigo":1157060001,
    "descripcion":"ASTROCITOMA DIFUSO DE CEREBRO"
  },
  {
    "codigo":10180006,
    "descripcion":"HEMOSIDEROSIS FOCAL"
  },
  {
    "codigo":1351833004,
    "descripcion":"SÍNDROME DE BROWN-SÉQUARD DEBIDO A PROLAPSO DE DISCO INTERVERTEBRAL"
  },
  {
    "codigo":237721006,
    "descripcion":"NEOPLASIA DE REGIÓN PITUITARIA Y SUPRASELAR"
  },
  {
    "codigo":1153390001,
    "descripcion":"DETENCIÓN DEL CRECIMIENTO EPIFISARIO DEBIDA A ENFERMEDAD RENAL"
  },
  {
    "codigo":6510002,
    "descripcion":"ESTADIO VX"
  },
  {
    "codigo":432494002,
    "descripcion":"CABEZA UBICADA EN PINZA QUIRÚRGICA"
  },
  {
    "codigo":268654005,
    "descripcion":"INTRUSIONES REPETITIVAS DURANTE EL SUEÑO"
  },
  {
    "codigo":235886005,
    "descripcion":"INSUFICIENCIA HEPÁTICA CRÓNICA"
  },
  {
    "codigo":399726007,
    "descripcion":"URÉTER COMPROMETIDO POR EXTENSIÓN DIRECTA DE NEOPLASIA MALIGNA"
  },
  {
    "codigo":299587000,
    "descripcion":"AMPLITUD DE FLEXIÓN ACTIVA DE DEDO DEL PIE DISMINUIDA"
  },
  {
    "codigo":234051003,
    "descripcion":"INSUFICIENCIA VENOSA PRIMARIA DE PIERNA"
  },
  {
    "codigo":70211005,
    "descripcion":"INFARTO AGUDO DE MIOCARDIO DE PARED ANTEROLATERAL"
  },
  {
    "codigo":365123007,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA USAR ASCENSOR DE ESCALERA"
  },
  {
    "codigo":679811000119105,
    "descripcion":"SUBLUXACIÓN ANTERIOR DE CRISTALINO DE AMBOS OJOS"
  },
  {
    "codigo":789272002,
    "descripcion":"SOBREDOSIS DE AGONISTA DE RECEPTOR ADRENÉRGICO ALFA 2 CENTRAL"
  },
  {
    "codigo":232216004,
    "descripcion":"DEFORMIDAD DE LA OREJA"
  },
  {
    "codigo":723736005,
    "descripcion":"SALPINGITIS XANTOGRANULOMATOSA"
  },
  {
    "codigo":263149000,
    "descripcion":"FRACTURA DE PLACA CRIBIFORME"
  },
  {
    "codigo":35608009,
    "descripcion":"MORTINATO INMADURO DE SEXO MASCULINO (500 - 999 GRAMOS)"
  },
  {
    "codigo":461592008,
    "descripcion":"ATRESIA CONGÉNITA DE LUZ DEL CAYADO AÓRTICO ENTRE ARTERIA SUBCLAVIA Y ARTERIA CARÓTIDA PRIMITIVA"
  },
  {
    "codigo":197613008,
    "descripcion":"GLOMERULONEFRITIS PROLIFERATIVA MESANGIAL CRÓNICA"
  },
  {
    "codigo":294082001,
    "descripcion":"ALERGIA A IPRATROPIO"
  },
  {
    "codigo":230381009,
    "descripcion":"EPILEPSIA FOCAL"
  },
  {
    "codigo":62871001,
    "descripcion":"HEMOGLOBINURIA PAROXÍSTICA IDIOPÁTICA INDUCIDA POR FRÍO"
  },
  {
    "codigo":783767001,
    "descripcion":"HIPERINSULINISMO AUTOSÓMICO RECESIVO DEBIDO A DEFICIENCIA DE RECEPTOR 1 DE SULFONILUREA"
  },
  {
    "codigo":292247007,
    "descripcion":"REACCIÓN ADVERSA AL TRILOSTANO"
  },
  {
    "codigo":1176983008,
    "descripcion":"HIDÁTIDE POLIQUÍSTICO POR ECHINOCOCCUS VOGELI"
  },
  {
    "codigo":192108001,
    "descripcion":"TRASTORNO DE ANSIEDAD Y MIEDO EN LA INFANCIA Y ADOLESCENCIA"
  },
  {
    "codigo":126572002,
    "descripcion":"NEOPLASIA DE HUESO DEL CARPO"
  },
  {
    "codigo":716396004,
    "descripcion":"CAPAZ DE TENER CONSCIENCIA DE SÍ MISMO"
  },
  {
    "codigo":238728002,
    "descripcion":"ALOPECIA INVOLUTIVA"
  },
  {
    "codigo":93804008,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL ANTEBRAZO"
  },
  {
    "codigo":290412009,
    "descripcion":"INTOXICACIÓN POR NABILONA"
  },
  {
    "codigo":26433004,
    "descripcion":"ALUCINACIÓN CONGRUENTE CON EL ESTADO DE ÁNIMO"
  },
  {
    "codigo":91969005,
    "descripcion":"NEOPLASIA BENIGNA DE MUCOSA DE CRESTA ALVEOLAR"
  },
  {
    "codigo":288577006,
    "descripcion":"SE COMUNICA"
  },
  {
    "codigo":16027831000119102,
    "descripcion":"EXOSTOSIS DE CALCÁNEO IZQUIERDO"
  },
  {
    "codigo":286742002,
    "descripcion":"ACCIDENTE CEREBROVASCULAR INMINENTE"
  },
  {
    "codigo":448747000,
    "descripcion":"TRONCO ARTERIAL COMÚN CON ARTERIA PULMONAR ORIGINADA EN SENO DE VÁLVULA TRONCAL"
  },
  {
    "codigo":219371007,
    "descripcion":"HERIDAS DE GUERRA POR BALAS Y FRAGMENTOS"
  },
  {
    "codigo":49201000175103,
    "descripcion":"EN LISTA DE ESPERA PARA TRASPLANTE RENAL"
  },
  {
    "codigo":284907009,
    "descripcion":"CAPAZ DE USAR EL INODORO"
  },
  {
    "codigo":20928004,
    "descripcion":"ÚLCERA DEL ANO"
  },
  {
    "codigo":11823441000119100,
    "descripcion":"AMPOLLA TRAUMÁTICA DE BRAZO IZQUIERDO"
  },
  {
    "codigo":283072007,
    "descripcion":"ARAÑAZO DE LA MEJILLA"
  },
  {
    "codigo":707221002,
    "descripcion":"GLOMERULOESCLEROSIS DE RIÑÓN DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":15919441000119101,
    "descripcion":"REACCIÓN ALÉRGICA CAUSADA POR VENENO DE HIMENÓPTERO"
  },
  {
    "codigo":314005007,
    "descripcion":"CICATRIZ CORNEAL VISUALMENTE SIGNIFICATIVA"
  },
  {
    "codigo":50026000,
    "descripcion":"TRASTORNO DE ANSIEDAD ORGÁNICO CAUSADO POR SUSTANCIA PSICOACTIVA"
  },
  {
    "codigo":279400631000119108,
    "descripcion":"ATRAPAMIENTO DE MÚSCULO RECTO INFERIOR DE OJO IZQUIERDO"
  },
  {
    "codigo":17258002,
    "descripcion":"ENCEFALOPATÍA ANÓXICA CRÓNICA"
  },
  {
    "codigo":410474007,
    "descripcion":"QUERATITIS DE LYME"
  },
  {
    "codigo":15423000,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DEL ANO, SIN INFECCIÓN"
  },
  {
    "codigo":1162303002,
    "descripcion":"ARTRITIS REUMATOIDEA SERONEGATIVA CON EROSIÓN ARTICULAR"
  },
  {
    "codigo":736319003,
    "descripcion":"PENSAMIENTO DESORGANIZADO"
  },
  {
    "codigo":354641000119104,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE HUESO DE MIEMBRO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":277567002,
    "descripcion":"LEUCEMIA PROLINFOCÍTICA DE CÉLULAS T"
  },
  {
    "codigo":769087009,
    "descripcion":"VÓMITOS DURANTE EL TERCER TRIMESTRE DE GESTACIÓN"
  },
  {
    "codigo":408639009,
    "descripcion":"MASTITIS POR CORYNEBACTERIUM"
  },
  {
    "codigo":111892001,
    "descripcion":"HEPATITIS INFECCIOSA NEONATAL"
  },
  {
    "codigo":275732003,
    "descripcion":"ÍNDICE DE PICO FLUJO NORMAL"
  },
  {
    "codigo":110057000,
    "descripcion":"LACERACIÓN SIMPLE DE LA FRENTE"
  },
  {
    "codigo":77289001,
    "descripcion":"MATERIAL INSUFICIENTE PARA DIAGNÓSTICO"
  },
  {
    "codigo":491000119101,
    "descripcion":"BACTERIEMIA CAUSADA POR BACTERIAS GRAMPOSITIVAS"
  },
  {
    "codigo":403134000,
    "descripcion":"DERMATOSIS CAUSADA POR TENIA"
  },
  {
    "codigo":42686001,
    "descripcion":"ANOMALÍA CROMOSÓMICA FETAL QUE AFECTA LA ATENCIÓN OBSTÉTRICA"
  },
  {
    "codigo":1156798001,
    "descripcion":"ENFERMEDAD DE ALZHEIMER AUTOSÓMICA DOMINANTE DEBIDA A MUTACIÓN DE PRESENILINA 2"
  },
  {
    "codigo":9918001,
    "descripcion":"PTOSIS RENAL"
  },
  {
    "codigo":698046005,
    "descripcion":"POSICIÓN NATURAL DE LA CABEZA"
  },
  {
    "codigo":1287870009,
    "descripcion":"OTOFIMA"
  },
  {
    "codigo":237459002,
    "descripcion":"QUISTE LINFÁTICO DE MAMA"
  },
  {
    "codigo":204691002,
    "descripcion":"ATRESIA Y ESTENOSIS DE INTESTINO DELGADO"
  },
  {
    "codigo":47981000087100,
    "descripcion":"FRACTURA DE DIÁFISIS DE FÉMUR DERECHO"
  },
  {
    "codigo":42861000087101,
    "descripcion":"HERIDA DE MAMA IZQUIERDA POR MORDEDURA"
  },
  {
    "codigo":366696000,
    "descripcion":"AMPLITUD DE MOVIMIENTO PASIVO DE ABDUCCIÓN DEL PULGAR - HALLAZGO"
  },
  {
    "codigo":40301000087105,
    "descripcion":"DISTENSIÓN DE MÚSCULO POSTERIOR DE MUSLO IZQUIERDO"
  },
  {
    "codigo":60781000087105,
    "descripcion":"INFLAMACIÓN DE ESTÓMAGO E INTESTINO CAUSADA POR AEROMONAS"
  },
  {
    "codigo":1251432004,
    "descripcion":"DERMATITIS ATÓPICA NUMULAR DEL ADULTO"
  },
  {
    "codigo":202856007,
    "descripcion":"TENDINITIS DEL BÍCEPS"
  },
  {
    "codigo":301160009,
    "descripcion":"PULSO PEDIO PRESENTE"
  },
  {
    "codigo":430397002,
    "descripcion":"TRASTORNO DEL SISTEMA NERVIOSO CAUSADO POR VIRUS DEL NILO OCCIDENTAL"
  },
  {
    "codigo":397629003,
    "descripcion":"PARTICIPA EN EL PLAN DE ATENCIÓN Y DECISIONES PERIOPERATORIAS"
  },
  {
    "codigo":364861004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA RODAR HACIA UN COSTADO"
  },
  {
    "codigo":168253005,
    "descripcion":"INOCULACIÓN DE ANIMALES: PARÁSITOS"
  },
  {
    "codigo":301701000119102,
    "descripcion":"TENDINITIS DE TENDÓN DE AQUILES DERECHO"
  },
  {
    "codigo":363026004,
    "descripcion":"ANOMALÍA CONGÉNITA DE CAVIDAD CORPORAL"
  },
  {
    "codigo":231954005,
    "descripcion":"HIPEMA TRAUMÁTICO"
  },
  {
    "codigo":789010008,
    "descripcion":"MIOCLONÍA PROPIOESPINAL AL COMIENZO DEL SUEÑO"
  },
  {
    "codigo":262887001,
    "descripcion":"CONTUSIÓN DE EPIPLÓN MAYOR"
  },
  {
    "codigo":787175002,
    "descripcion":"SÍNDROME DE DISCAPACIDAD INTELECTUAL Y ALTERACIÓN DEL SUEÑO RELACIONADO CON ANQUIRINA 3"
  },
  {
    "codigo":1149458009,
    "descripcion":"PERIODONTITIS GENERALIZADA ESTADIO 1 GRADO C SEGÚN LA CLASIFICACIÓN DE LAS ENFERMEDADES Y ALTERACIONES PERIODONTALES Y PERIIMPLANTARIAS DE 2017 DE LA ACADEMIA ESTADOUNIDENSE DE PERIODONTOLOGÍA Y LA FEDERACIÓN EUROPEA DE PERIODONTOLOGÍA"
  },
  {
    "codigo":295655004,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE DACARBAZINA"
  },
  {
    "codigo":721639004,
    "descripcion":"CARCINOMA NEUROENDOCRINO PRIMARIO DE CARDIAS GÁSTRICO"
  },
  {
    "codigo":148822661000119106,
    "descripcion":"NEOPLASIA NEUROENDOCRINA MALIGNA DE CAVIDAD NASAL"
  },
  {
    "codigo":62609001,
    "descripcion":"ANEMIA HEMOLÍTICA AUTOINMUNITARIA CAUSADA POR INMUNOGLOBULINA G MÁS COMPLEMENTO"
  },
  {
    "codigo":291985003,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR GUANETIDINA"
  },
  {
    "codigo":128145008,
    "descripcion":"HALLAZGO EN LAS MUCOSAS"
  },
  {
    "codigo":16003871000119102,
    "descripcion":"ARTROPATÍA DE MANGUITO ROTADOR DE AMBOS HOMBROS"
  },
  {
    "codigo":1142118003,
    "descripcion":"TAQUICARDIA POR REENTRADA EN EL NODO AURICULOVENTRICULAR ATÍPICA"
  },
  {
    "codigo":10679071000119103,
    "descripcion":"TUMEFACCIÓN LOCALIZADA DE LA MANO IZQUIERDA"
  },
  {
    "codigo":1240422006,
    "descripcion":"PRURITO DE PIEL PERIANAL"
  },
  {
    "codigo":60774007,
    "descripcion":"ENFERMEDAD POR EL VIRUS MADRID"
  },
  {
    "codigo":386619000,
    "descripcion":"DIETA HIPOSÓDICA"
  },
  {
    "codigo":1304123001,
    "descripcion":"NEOPLASIA MALIGNA DE TRACTO GASTROINTESTINAL SUPERIOR"
  },
  {
    "codigo":124475004,
    "descripcion":"DEFICIENCIA DE LIQUENASA"
  },
  {
    "codigo":57104001,
    "descripcion":"HALLAZGO RELACIONADO CON LA RESPUESTA A UNA PRUEBA CUTÁNEA"
  },
  {
    "codigo":778000002,
    "descripcion":"SÍNDROME DE MICRODELECIÓN 3Q26Q27"
  },
  {
    "codigo":253712002,
    "descripcion":"ORIFICIO CORONARIO DOBLE"
  },
  {
    "codigo":1269520004,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÉDULA ESPINAL CERVICAL DEBIDA A FRACTURA NO EXPUESTA DE COLUMNA CERVICAL"
  },
  {
    "codigo":286480002,
    "descripcion":"NO ESPARCE ALIMENTOS"
  },
  {
    "codigo":1236752006,
    "descripcion":"DERMATOSIS AMPOLLAR SUBEPIDÉRMICA AUTOINMUNITARIA"
  },
  {
    "codigo":188176007,
    "descripcion":"NEOPLASIA MALIGNA DE CONDUCTO ENDOCERVICAL"
  },
  {
    "codigo":448485001,
    "descripcion":"ESPÉCIMEN SATISFACTORIO PARA LA EVALUACIÓN PERO LIMITADO POR DEGENERACIÓN CELULAR"
  },
  {
    "codigo":284645008,
    "descripcion":"DISPARARLE A OTRA PERSONA"
  },
  {
    "codigo":88037009,
    "descripcion":"FRAMBESIA, LESIÓN TERCIARIA"
  },
  {
    "codigo":315578005,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: MANDARÍN"
  },
  {
    "codigo":3001000119103,
    "descripcion":"CANDIDIASIS DE LENGUA"
  },
  {
    "codigo":250042005,
    "descripcion":"MARCHA DISTÓNICA"
  },
  {
    "codigo":51599000,
    "descripcion":"EDEMA DE LARINGE"
  },
  {
    "codigo":1231247003,
    "descripcion":"ENTROPIÓN MECÁNICO DE PÁRPADO SUPERIOR"
  },
  {
    "codigo":280975005,
    "descripcion":"RUPTURA DE INJERTO ARTERIOVENOSO"
  },
  {
    "codigo":1264015006,
    "descripcion":"INFLAMACIÓN DE MÚSCULO DE HOMBRO"
  },
  {
    "codigo":1296783008,
    "descripcion":"RASGO ALFA-TRIPTASEMIA HEREDITARIA DETECTADO"
  },
  {
    "codigo":705124002,
    "descripcion":"FRACTURA EXPUESTA INTRARTICULAR DE CABEZA DE FÉMUR"
  },
  {
    "codigo":11307961000119106,
    "descripcion":"FRACTURA PATOLÓGICA DE PELVIS EN SITIO DE NEOPLASIA"
  },
  {
    "codigo":703289004,
    "descripcion":"FALLA DE PRÓTESIS DE VÁLVULA TRICÚSPIDE QUE REQUIERE REEMPLAZO"
  },
  {
    "codigo":211769006,
    "descripcion":"QUEMADURA EPIDÉRMICA DE MÚLTIPLES SITIOS DEL TRONCO"
  },
  {
    "codigo":1260345007,
    "descripcion":"CEFALEA DEBIDA A HIPERTENSIÓN ARTERIAL"
  },
  {
    "codigo":275470000,
    "descripcion":"COMA POSTERIOR A PARO CARDIORRESPIRATORIO"
  },
  {
    "codigo":406542000,
    "descripcion":"MEJORÍA EN LAS RELACIONES DE AMISTAD Y\/O FAMILIARES"
  },
  {
    "codigo":78862003,
    "descripcion":"SÍNDROME DE AYERZA"
  },
  {
    "codigo":46094005,
    "descripcion":"INFESTACIÓN CAUSADA POR NOTOEDRES"
  },
  {
    "codigo":242702008,
    "descripcion":"LESIÓN EN COLISIÓN ACCIDENTAL ENTRE NADADORES"
  },
  {
    "codigo":11491000,
    "descripcion":"ANEMIA POR DEFICIENCIA DE NIACINA"
  },
  {
    "codigo":240867002,
    "descripcion":"TRIQUINOSIS INVASIVA"
  },
  {
    "codigo":109795003,
    "descripcion":"FALTA DE CONTACTO DENTAL INTERPROXIMAL"
  },
  {
    "codigo":765155002,
    "descripcion":"HIPERTROFIA DE RIÑÓN IZQUIERDO CONCOMITANTE CON HIPOPLASIA CONGÉNITA DE RIÑÓN IZQUIERDO Y DEBIDA A ELLA"
  },
  {
    "codigo":1287608000,
    "descripcion":"CARCINOMA SEBÁCEO DE PIEL DE PÁRPADO SUPERIOR"
  },
  {
    "codigo":699619009,
    "descripcion":"GAMETOCITO DE PLASMODIUM MALARIAE EN ERITROCITO"
  },
  {
    "codigo":402872002,
    "descripcion":"NEOPLASIA BENIGNA FIBROHISTIOCÍTICA DE PIEL"
  },
  {
    "codigo":763320005,
    "descripcion":"SÍNDROME CRANEOFACIOFRONTODIGITAL"
  },
  {
    "codigo":687341000119100,
    "descripcion":"OLIGODENDROGLIOMA PRIMARIO DE LÓBULO OCCIPITAL"
  },
  {
    "codigo":206264007,
    "descripcion":"RECIÉN NACIDO VIVO CON MECONIO EN LÍQUIDO AMNIÓTICO PREVIO AL TRABAJO DE PARTO"
  },
  {
    "codigo":239032007,
    "descripcion":"SÍNDROME DE BERLÍN"
  },
  {
    "codigo":827021003,
    "descripcion":"OPACIDAD DE REFLEJO LUMINOSO EN LA MEMBRANA TIMPÁNICA"
  },
  {
    "codigo":366434008,
    "descripcion":"AMPLITUD DE MOVIMIENTO PASIVO DE EXTENSIÓN DE LA COLUMNA LUMBAR - HALLAZGO"
  },
  {
    "codigo":36919001,
    "descripcion":"ANEMIA CAUSADA POR PLOMO"
  },
  {
    "codigo":430135002,
    "descripcion":"AMPLITUD DE FLEXIÓN Y EXTENSIÓN DE COLUMNA CERVICAL DISMINUIDA"
  },
  {
    "codigo":169826009,
    "descripcion":"UN SOLO NACIDO VIVO DE EMBARAZO ÚNICO"
  },
  {
    "codigo":167991004,
    "descripcion":"ESPUTO: EXCESIVO, MUCOIDE"
  },
  {
    "codigo":725047007,
    "descripcion":"ENFERMEDAD DE CHARCOT-MARIE-TOOTH AUTOSÓMICA RECESIVA CON DISFONÍA"
  },
  {
    "codigo":395532005,
    "descripcion":"EXTENSIÓN DE INVASIÓN TUMORAL: NO PUEDE SER DETERMINADA"
  },
  {
    "codigo":295393000,
    "descripcion":"SOBREDOSIS DE HIDRÓXIDO DE ALUMINIO"
  },
  {
    "codigo":721377001,
    "descripcion":"SÍNDROME DEL CORDÓN CENTRAL DE MÉDULA ESPINAL AL NIVEL DEL SEXTO SEGMENTO CERVICAL"
  },
  {
    "codigo":360929005,
    "descripcion":"NO FUMADOR INTOLERANTE"
  },
  {
    "codigo":262625009,
    "descripcion":"CUERPO EXTRAÑO EN PERINEO FEMENINO"
  },
  {
    "codigo":162486004,
    "descripcion":"SÍNTOMA QUE MEJORA CON EL EJERCICIO"
  },
  {
    "codigo":333191000119103,
    "descripcion":"COROIDITIS FOCAL PERIFÉRICA DERECHA"
  },
  {
    "codigo":12921000122102,
    "descripcion":"ALERGIA A MEJILLÓN"
  },
  {
    "codigo":129718006,
    "descripcion":"COMPOSICIÓN MAMARIA HETEROGÉNEAMENTE DENSA"
  },
  {
    "codigo":195254008,
    "descripcion":"ATEROMA DE ARTERIA DE EXTREMIDAD"
  },
  {
    "codigo":293558009,
    "descripcion":"REACCIÓN ADVERSA AL CICLANDELATO"
  },
  {
    "codigo":160651002,
    "descripcion":"NIVEL 5 DE ACTIVIDAD SEGÚN EL PRINCIPIO FITT; 12 OCASIONES O MÁS DE ACTIVIDADES ENÉRGICAS EN 4 SEMANAS"
  },
  {
    "codigo":95115002,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA SUBGLOTIS"
  },
  {
    "codigo":226187004,
    "descripcion":"DIETA CON BAJO CONTENIDO EN CONSERVANTES ALIMENTARIOS"
  },
  {
    "codigo":783243008,
    "descripcion":"ADENOHIPOFISITIS"
  },
  {
    "codigo":1141856003,
    "descripcion":"SIGNO DE TRACTO LARGO"
  },
  {
    "codigo":191584006,
    "descripcion":"EPISODIO MANÍACO ÚNICO, MODERADO"
  },
  {
    "codigo":91445000,
    "descripcion":"ANEURISMA DE ARTERIA FEMORAL"
  },
  {
    "codigo":224352009,
    "descripcion":"CALIFICADO PARA RECIBIR INDEMNIZACIÓN POR LESIONES DELICTIVAS"
  },
  {
    "codigo":714037001,
    "descripcion":"AGRANDAMIENTO GINGIVAL DEBIDO A PSEUDOBOLSILLO"
  },
  {
    "codigo":124213001,
    "descripcion":"DEFICIENCIA DE MONOOXIGENASA INESPECÍFICA"
  },
  {
    "codigo":93280008,
    "descripcion":"HIPOPLASIA CONGÉNITA DE TROMPA DE FALOPIO"
  },
  {
    "codigo":286218000,
    "descripcion":"CAPAZ DE USAR FLUJO DE AIRE PULMONAR PARA HABLAR"
  },
  {
    "codigo":56842001,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE BRAZO SIN INFECCIÓN"
  },
  {
    "codigo":46259007,
    "descripcion":"INTOXICACIÓN POR HEDERA HELIX"
  },
  {
    "codigo":1300191000,
    "descripcion":"HIPOPLASIA PONTOCEREBELOSA CONGÉNITA TIPO 13"
  },
  {
    "codigo":417290008,
    "descripcion":"ESCLEROQUERATITIS"
  },
  {
    "codigo":253450009,
    "descripcion":"MALFORMACIÓN EN PARACAÍDAS DE VÁLVULA AURICULOVENTRICULAR COMÚN"
  },
  {
    "codigo":251615004,
    "descripcion":"ANOMALÍA DEL POTENCIAL EVOCADO AUDITIVO DEL TRONCO ENCEFÁLICO RELACIONADA CON LA FASE"
  },
  {
    "codigo":1003444000,
    "descripcion":"LISENCEFALIA TIPO 3"
  },
  {
    "codigo":10956321000119105,
    "descripcion":"HERIDA ABIERTA DE DEDO ÍNDICE IZQUIERDO DEBIDA A MORDEDURA"
  },
  {
    "codigo":282548003,
    "descripcion":"INCAPAZ DE EVITAR OBSTÁCULOS AL CORRER"
  },
  {
    "codigo":774068004,
    "descripcion":"SÍNDROME DE DISCAPACIDAD INTELECTUAL, APNEA OBSTRUCTIVA DEL SUEÑO Y DISMORFIA LEVE POR MUTACIONES EN AHDC1"
  },
  {
    "codigo":85940005,
    "descripcion":"OTITIS MEDIA TUBERCULOSA"
  },
  {
    "codigo":870537001,
    "descripcion":"SIGNO DE RISSER"
  },
  {
    "codigo":247945001,
    "descripcion":"AMANERAMIENTOS COMPLEJOS - ESTEREOTIPO"
  },
  {
    "codigo":60961000119107,
    "descripcion":"RETINOPATÍA DIABÉTICA NO PROLIFERATIVA DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":772233006,
    "descripcion":"CAPAZ DE MANTENER EL EQUILIBRIO AL PONERSE DE PIE CON AMBOS PIES JUNTOS"
  },
  {
    "codigo":442718000,
    "descripcion":"PRUEBA DE ASPIRACIÓN NEGATIVA PARA SANGRE DURANTE PROCEDIMIENTO"
  },
  {
    "codigo":689851000119102,
    "descripcion":"CARCINOMA DE CÉLULAS DE TRANSICIÓN DE ORIFICIO VESICAL"
  },
  {
    "codigo":735795003,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE PELVIS"
  },
  {
    "codigo":16012551000119100,
    "descripcion":"EMBOLIA DE ARTERIA DE MIEMBRO INFERIOR DERECHO"
  },
  {
    "codigo":16038151000119101,
    "descripcion":"OSTEOCONDROPATÍA DE CÚBITO DERECHO"
  },
  {
    "codigo":350471000119102,
    "descripcion":"NEUROPATÍA PERIFÉRICA DE FIBRAS PEQUEÑAS IDIOPÁTICA"
  },
  {
    "codigo":16050951000119103,
    "descripcion":"ARTRITIS DE ARTICULACIÓN DE REGIÓN DE MUÑECA IZQUIERDA DEBIDA A INMUNIZACIÓN Y POSTERIOR A ELLA"
  },
  {
    "codigo":314631000119101,
    "descripcion":"ESTENOSIS ÓSEA Y SUBLUXACIÓN DE AGUJEROS INTERVERTEBRALES CERVICALES"
  },
  {
    "codigo":1080071000119101,
    "descripcion":"SARCOMA DE EWING PRIMARIO DE HUESO DE EXTREMIDAD INFERIOR DERECHA"
  },
  {
    "codigo":1082631000119106,
    "descripcion":"HEMORRAGIA GÁSTRICA DEBIDA A GASTRITIS ALÉRGICA"
  },
  {
    "codigo":10677511000119107,
    "descripcion":"INFECCIÓN DE UÑA DE DEDO DEL PIE"
  },
  {
    "codigo":10682631000119108,
    "descripcion":"TUMORACIÓN DE LA PIEL DEL PIE DERECHO"
  },
  {
    "codigo":15997191000119109,
    "descripcion":"PLIEGUE COROIDEO DE OJO IZQUIERDO"
  },
  {
    "codigo":10628871000119101,
    "descripcion":"GASTROENTERITIS CAUSADA POR VIRUS DE LA GRIPE"
  },
  {
    "codigo":137991000119103,
    "descripcion":"TRASTORNO CONVULSIVO COMO SECUELA DE ACCIDENTE CEREBROVASCULAR"
  },
  {
    "codigo":10685191000119106,
    "descripcion":"NÓDULO DE TEJIDO CELULAR SUBCUTÁNEO DE CUELLO"
  },
  {
    "codigo":117511000119107,
    "descripcion":"URGENCIA URINARIA DEBIDA A HIPERTROFIA PROSTÁTICA BENIGNA"
  },
  {
    "codigo":291591000119107,
    "descripcion":"HEMORRAGIA SUBDURAL INTRACRANEAL SUBAGUDA NO TRAUMÁTICA"
  },
  {
    "codigo":1085191000119109,
    "descripcion":"COMPLICACIÓN DEBIDA A PROCTITIS ULCEROSA CRÓNICA"
  },
  {
    "codigo":1092871000119107,
    "descripcion":"OBSTRUCCIÓN INTESTINAL DEBIDA A COLITIS ULCEROSA"
  },
  {
    "codigo":683271000119108,
    "descripcion":"NEVO MELANOCÍTICO CONGÉNITO DE TRONCO"
  },
  {
    "codigo":15981831000119109,
    "descripcion":"TRASTORNO DE PIEL DE PÁRPADO DERECHO"
  },
  {
    "codigo":109533006,
    "descripcion":"EXFOLIACIÓN PRECOZ DE LOS DIENTES DEBIDA A RESORCIÓN IDIOPÁTICA DE LA RAÍZ"
  },
  {
    "codigo":1354717005,
    "descripcion":"FRACTURA DE TERCERA COSTILLA"
  },
  {
    "codigo":699357004,
    "descripcion":"SARCOMA DE ESTROMA ENDOMETRIAL DE BAJO GRADO"
  },
  {
    "codigo":42162004,
    "descripcion":"DEFORMIDAD CONGÉNITA EN VARO DE PIE"
  },
  {
    "codigo":402610004,
    "descripcion":"HIPERMELANOSIS POR FACTOR HORMONAL"
  },
  {
    "codigo":304306006,
    "descripcion":"AUSENCIA DE MOVIMIENTO DE LA MUÑECA"
  },
  {
    "codigo":238770007,
    "descripcion":"HIPERPLASIA ENDOTELIAL PAPILAR INTRAVASCULAR"
  },
  {
    "codigo":74930008,
    "descripcion":"FÓRMULA DE HIPERALIMENTACIÓN PARA EL TRATAMIENTO DE LA INSUFICIENCIA RENAL"
  },
  {
    "codigo":202332000,
    "descripcion":"DESGARRO DE RODETE GLENOIDEO"
  },
  {
    "codigo":1252743009,
    "descripcion":"ÚLCERA VARICOSA DE TOBILLO"
  },
  {
    "codigo":169564004,
    "descripcion":"EMBARAZADA - CONFIRMACIÓN POR PALPACIÓN ABDOMINAL"
  },
  {
    "codigo":726620005,
    "descripcion":"FORMA LETAL DE SÍNDROME DE ARTROGRIPOSIS E HIPERQUERATOSIS"
  },
  {
    "codigo":5724005,
    "descripcion":"INTOXICACIÓN POR LATHYRUS"
  },
  {
    "codigo":890460004,
    "descripcion":"TRASTORNO DEL DESARROLLO SEXUAL 46,XX"
  },
  {
    "codigo":69425000,
    "descripcion":"FRACTURA EXPUESTA DE CUERPO DE LA MANDÍBULA"
  },
  {
    "codigo":298801001,
    "descripcion":"AMPLITUD DE ABDUCCIÓN ACTIVA DE HOMBRO DISMINUIDA"
  },
  {
    "codigo":335701000119107,
    "descripcion":"ABSCESO DE CÓRNEA DE OJO DERECHO"
  },
  {
    "codigo":366172009,
    "descripcion":"FUNCIÓN NODAL - HALLAZGO"
  },
  {
    "codigo":167729002,
    "descripcion":"ANÁLISIS BIOQUÍMICO DE LÍQUIDO CEFALORRAQUÍDEO DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":300636004,
    "descripcion":"CONDUCE UN AUTO"
  },
  {
    "codigo":16037871000119102,
    "descripcion":"OSTEOCONDROPATÍA DE RADIO IZQUIERDO"
  },
  {
    "codigo":296966002,
    "descripcion":"SOBREDOSIS DE ÁCIDO FÓLICO"
  },
  {
    "codigo":34822003,
    "descripcion":"ELACIÓN"
  },
  {
    "codigo":788486007,
    "descripcion":"TRASTORNO REPETITIVO DEL MOVIMIENTO DEL MUSLO DERECHO"
  },
  {
    "codigo":1148934008,
    "descripcion":"HIPERCALCEMIA DEBIDA A ENFERMEDAD RENAL CRÓNICA"
  },
  {
    "codigo":219006,
    "descripcion":"BEBEDOR DE ALCOHOL"
  },
  {
    "codigo":424368001,
    "descripcion":"INDUCCIÓN DE ENZIMA DE CITOCROMO P450 CYP1A2 POR SUSTANCIA"
  },
  {
    "codigo":129456006,
    "descripcion":"INSUFICIENCIA ENZIMÁTICA ESPECÍFICA"
  },
  {
    "codigo":194992008,
    "descripcion":"ESTENOSIS DE VÁLVULA TRICÚSPIDE DE ETIOLOGÍA NO REUMÁTICA CON INSUFICIENCIA"
  },
  {
    "codigo":291461001,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR CICLOGUANIL"
  },
  {
    "codigo":94853003,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL GLANDE DEL PENE"
  },
  {
    "codigo":1340037004,
    "descripcion":"TRASTORNO DEL SISTEMA NERVIOSO DEBIDO A VACUNACIÓN Y POSTERIOR A ELLA"
  },
  {
    "codigo":62085005,
    "descripcion":"QUEJIDO"
  },
  {
    "codigo":1010522000,
    "descripcion":"ESCLEROSIS DE EPÍFISIS DE FALANGE DE CUARTO DEDO DE PIE CON RADIOPACIDAD AUMENTADA"
  },
  {
    "codigo":93018000,
    "descripcion":"ANOMALÍA CONGÉNITA DEL PERICARDIO"
  },
  {
    "codigo":289626002,
    "descripcion":"FONDO UTERINO A NIVEL DE LA SÍNFISIS PÚBICA"
  },
  {
    "codigo":191322006,
    "descripcion":"TROMBOCITOPENIA MEDICAMENTOSA"
  },
  {
    "codigo":58415000,
    "descripcion":"CHORRO DE ORINA NORMAL"
  },
  {
    "codigo":189487001,
    "descripcion":"NEOPLASIA DE CEREBRO, SUPRATENTORIAL DE COMPORTAMIENTO INCIERTO O DESCONOCIDO"
  },
  {
    "codigo":123951002,
    "descripcion":"CELULITIS DE LA PIEL"
  },
  {
    "codigo":713775002,
    "descripcion":"PATRÓN DE USO NOCIVO DE NUEVA SUSTANCIA PSICOACTIVA"
  },
  {
    "codigo":253188000,
    "descripcion":"ANOMALÍA DE LA CANALIZACIÓN Y DIFERENCIACIÓN RETRÓGRADA"
  },
  {
    "codigo":449796001,
    "descripcion":"HEMATOMA TRAUMÁTICO DE ESPACIO SUBDURAL DEL NEUROEJE"
  },
  {
    "codigo":255023008,
    "descripcion":"NEUROFIBROMA DE COROIDES"
  },
  {
    "codigo":285956003,
    "descripcion":"NO INSERTA EL TAPÓN DE LA PILETA"
  },
  {
    "codigo":187652003,
    "descripcion":"NEOPLASIA MALIGNA DE PISO DE BOCA ANTERIOR"
  },
  {
    "codigo":56580008,
    "descripcion":"PANICULITIS SEPTAL"
  },
  {
    "codigo":23812009,
    "descripcion":"ÚLCERA DUODENAL CON HEMORRAGIA Y PERFORACIÓN"
  },
  {
    "codigo":447961002,
    "descripcion":"ALERGIA A HONGO ALIMENTICIO"
  },
  {
    "codigo":87513003,
    "descripcion":"HERPES ZÓSTER OFTÁLMICO"
  },
  {
    "codigo":216750000,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ÁCIDOS"
  },
  {
    "codigo":710105009,
    "descripcion":"CARIES DE RAÍZ MODERADA LIMITADA A LA MITAD EXTERNA DE LA DENTINA"
  },
  {
    "codigo":92451000119103,
    "descripcion":"LESIÓN DE TROMPA DE FALOPIO"
  },
  {
    "codigo":52910006,
    "descripcion":"TRASTORNO DE ANSIEDAD DEBIDO A CONDICIÓN MÉDICA GENERAL"
  },
  {
    "codigo":282286008,
    "descripcion":"RECESIÓN TEMPORAL DEL CABELLO"
  },
  {
    "codigo":870275000,
    "descripcion":"LESIÓN CUTÁNEA PIGMENTADA DE MIEMBRO SUPERIOR DE NATURALEZA INCIERTA"
  },
  {
    "codigo":1263491001,
    "descripcion":"MIELITIS DEBIDA A LUPUS ERITEMATOSO SISTÉMICO"
  },
  {
    "codigo":247683002,
    "descripcion":"DELIRIO DE SER AMADO"
  },
  {
    "codigo":737368006,
    "descripcion":"PROBLEMA DE RELACIÓN ENTRE CUIDADOR Y NIÑO"
  },
  {
    "codigo":1359960007,
    "descripcion":"HERIDA ABIERTA DE DEDO ÍNDICE DEBIDA A MORDEDURA DE GATO"
  },
  {
    "codigo":278616006,
    "descripcion":"PRÓTESIS DENTAL FRACTURADA"
  },
  {
    "codigo":14637005,
    "descripcion":"LIPOFUSCINOSIS CEROIDE NEURONAL INFANTIL TARDÍA"
  },
  {
    "codigo":735533006,
    "descripcion":"INFECCIÓN DE HUESO CAUSADA POR ECHINOCOCCUS"
  },
  {
    "codigo":1075491000119108,
    "descripcion":"PELLIZCAMIENTO DEL ACETÁBULO FEMORAL DE CADERA DERECHA"
  },
  {
    "codigo":1259821005,
    "descripcion":"CÁNCER DE PULMÓN NO MICROCÍTICO PRIMARIO POSITIVO PARA ONCOGÉN DE FUSIÓN ALK (CINASA DE LINFOMA ANAPLÁSICO)"
  },
  {
    "codigo":438786003,
    "descripcion":"QUEMADURA QUÍMICA DE MANO"
  },
  {
    "codigo":240343002,
    "descripcion":"INTOXICACIÓN ALIMENTARIA POR VIRUS DE ESTRUCTURA REDONDA PEQUEÑA"
  },
  {
    "codigo":305879002,
    "descripcion":"ATENDIDO POR SERVICIO DE CRIBADO DE PATOLOGÍA MAMARIA"
  },
  {
    "codigo":109271004,
    "descripcion":"NEVO MELANOCÍTICO DE LABIO"
  },
  {
    "codigo":404183005,
    "descripcion":"PROBLEMA FUNCIONAL DE LA VISIÓN"
  },
  {
    "codigo":830167005,
    "descripcion":"ALERGIA A CLORAZEPATO"
  },
  {
    "codigo":402348002,
    "descripcion":"REACCIÓN DE KÖBNER POR LIQUEN PLANO"
  },
  {
    "codigo":11835991000119100,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN METATARSOFALÁNGICA DE SEGUNDO A QUINTO DEDOS DE PIE IZQUIERDO"
  },
  {
    "codigo":369580007,
    "descripcion":"TUMOR MALIGNO QUE COMPROMETE LA VAGINA POR PROPAGACIÓN DIRECTA DEL CUELLO UTERINO"
  },
  {
    "codigo":105601003,
    "descripcion":"TRASTORNO CUANTITATIVO DE LOS NEUTRÓFILOS"
  },
  {
    "codigo":7297005,
    "descripcion":"DERMATITIS SEBORREICA GENERALIZADA DEL LACTANTE"
  },
  {
    "codigo":14430001000004102,
    "descripcion":"FRACTURA DE EXTREMO DISTAL DE CÚBITO DERECHO"
  },
  {
    "codigo":236673008,
    "descripcion":"PROSTATITIS NO BACTERIANA"
  },
  {
    "codigo":365910001,
    "descripcion":"HALLAZGO EN LA TENDENCIA DEL PESO"
  },
  {
    "codigo":38230003,
    "descripcion":"SENO DE VALSALVA ROTO EN VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":726358004,
    "descripcion":"TRISOMÍA PARCIAL DE CROMOSOMA 19"
  },
  {
    "codigo":724523000,
    "descripcion":"ÚLCERA ANASTOMÓTICA DE ESTÓMAGO CAUSADA POR FÁRMACO"
  },
  {
    "codigo":70998009,
    "descripcion":"INFARTO AGUDO DE MIOCARDIO DE SEGMENTO BASAL INFERIOR DE VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":298539003,
    "descripcion":"SIN AMPLITUD DE FLEXIÓN LATERAL PASIVA HACIA LA DERECHA DE LA COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":69163003,
    "descripcion":"INFECCIÓN POR TAENIA SAGINATA"
  },
  {
    "codigo":34560001,
    "descripcion":"DISNEA ESPIRATORIA"
  },
  {
    "codigo":722688002,
    "descripcion":"NEOPLASIA EPITELIAL MALIGNA"
  },
  {
    "codigo":296704006,
    "descripcion":"SOBREDOSIS DE CEFAMANDOL"
  },
  {
    "codigo":427776007,
    "descripcion":"TROMBOSIS DE VENA POPLÍTEA"
  },
  {
    "codigo":425941003,
    "descripcion":"LEUCEMIA LINFOBLÁSTICA AGUDA DE CÉLULAS PRECURSORAS DE LINFOCITOS B EN REMISIÓN"
  },
  {
    "codigo":720853005,
    "descripcion":"SÍNDROME DE INMUNODEFICIENCIA COMBINADA SEVERA, MICROCEFALIA, RETARDO DEL CRECIMIENTO Y SENSIBILIDAD A RADIACIÓN IONIZANTE"
  },
  {
    "codigo":293034000,
    "descripcion":"REACCIÓN ADVERSA AL SULFALOXATO CÁLCICO"
  },
  {
    "codigo":131029008,
    "descripcion":"NIVEL DE HORMONA ANTIDIURÉTICA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":719018008,
    "descripcion":"DISCAPACIDAD INTELECTUAL LIGADA AL CROMOSOMA X TIPO ABIDI"
  },
  {
    "codigo":717183001,
    "descripcion":"SÍNDROME DE QUERATODERMIA HEREDITARIA MUTILANTE CON ICTIOSIS"
  },
  {
    "codigo":260266008,
    "descripcion":"N5"
  },
  {
    "codigo":291199003,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR PROCLORPERAZINA"
  },
  {
    "codigo":61823004,
    "descripcion":"LESIÓN TRAUMÁTICA DEL PÁNCREAS"
  },
  {
    "codigo":782719004,
    "descripcion":"ATAXIA CEREBELOSA AUTOSÓMICA RECESIVA DEBIDA A HOMOLOGÍA DE STIP1 Y DEFICIENCIA DE PROTEÍNA 1 CON CAJA U"
  },
  {
    "codigo":127359008,
    "descripcion":"SUSTANCIA FISIOLÓGICA DE ESTRUCTURA ANORMAL"
  },
  {
    "codigo":94591009,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE PARTES BLANDAS DE LA PELVIS"
  },
  {
    "codigo":92756002,
    "descripcion":"CARCINOMA IN SITU DEL ESTÓMAGO"
  },
  {
    "codigo":420436000,
    "descripcion":"MONONEUROPATÍA DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":422271008,
    "descripcion":"PIGMENTO SOBRE ENDOTELIO CORNEAL"
  },
  {
    "codigo":340721000119105,
    "descripcion":"CORIORRETINITIS FOCAL IZQUIERDA"
  },
  {
    "codigo":844585000,
    "descripcion":"SIN TRATAMIENTO PREVIO"
  },
  {
    "codigo":25385007,
    "descripcion":"CONCUBINATO INCESTUOSO CON NIÑAS"
  },
  {
    "codigo":285694000,
    "descripcion":"DIFICULTAD PARA CARGAR PESO EN LA PIERNA IZQUIERDA"
  },
  {
    "codigo":254761009,
    "descripcion":"NEUROFIBROMA CUTÁNEO"
  },
  {
    "codigo":449534004,
    "descripcion":"ESPACIO INTERCORDAL DE CUERDAS TENDINOSAS TRICUSPÍDEAS OBSTRUIDO"
  },
  {
    "codigo":1268734005,
    "descripcion":"HIPERTROFIA ADQUIRIDA DE VENTRÍCULO CARDÍACO DERECHO"
  },
  {
    "codigo":1332435005,
    "descripcion":"POLIPOSIS DE CAVIDAD NASAL Y\/O SENO PARANASAL"
  },
  {
    "codigo":283859007,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DE LA REGIÓN PÉLVICA"
  },
  {
    "codigo":216488002,
    "descripcion":"INTOXICACIÓN ACCIDENTAL CAUSADA POR KETOPROFENO"
  },
  {
    "codigo":249256004,
    "descripcion":"FRENILLO TIRANTE DEL PREPUCIO"
  },
  {
    "codigo":183720006,
    "descripcion":"CONSULTA DOMICILIARIA DE PSICOGERIATRÍA SOLICITADA"
  },
  {
    "codigo":413096007,
    "descripcion":"CONSUMIDOR DE DROGAS NO INYECTABLES"
  },
  {
    "codigo":1197693001,
    "descripcion":"ÚLCERA DE ANO CAUSADA POR FÁRMACO"
  },
  {
    "codigo":312957005,
    "descripcion":"VARIANTE DE CORIORRETINOPATÍA SEROSA CENTRAL"
  },
  {
    "codigo":704338008,
    "descripcion":"FRACTURA OSTEOPORÓTICA DE TIBIA"
  },
  {
    "codigo":1163090009,
    "descripcion":"ACALASIA DEBIDA A ENFERMEDAD DE CHAGAS"
  },
  {
    "codigo":276519002,
    "descripcion":"HIPOTENSIÓN NEONATAL"
  },
  {
    "codigo":1259559006,
    "descripcion":"CARCINOMA BASOCELULAR SUPERFICIAL PRIMARIO"
  },
  {
    "codigo":1290492002,
    "descripcion":"TRASTORNO DE TENDÓN DE PIE"
  },
  {
    "codigo":405756005,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÉDULA ESPINAL CERVICAL ANTERIOR, SIN LESIÓN ÓSEA VERTEBRAL, C5-7"
  },
  {
    "codigo":209148006,
    "descripcion":"SÍNDROME MEDULAR POSTERIOR DE MÉDULA CERVICAL DEBIDO A SUBLUXACIÓN VERTEBRAL NO EXPUESTA DE COLUMNA CERVICAL"
  },
  {
    "codigo":372988007,
    "descripcion":"INFECCIÓN CAUSADA POR ASPERGILLUS NIVEUS"
  },
  {
    "codigo":403921000,
    "descripcion":"MELANOMA MALIGNO LIMÍTROFE"
  },
  {
    "codigo":471292008,
    "descripcion":"ORIGEN ANÓMALO DE ARTERIAS CORONARIA DERECHA Y CIRCUNFLEJA EN SENO AÓRTICO A LA DERECHA DE SENO AÓRTICO NO ENFRENTADO Y ORIGEN ANÓMALO DE ARTERIA DESCENDENTE ANTERIOR IZQUIERDA EN SENO AÓRTICO A LA IZQUIERDA DE SENO AÓRTICO NO ENFRENTADO"
  },
  {
    "codigo":76241003,
    "descripcion":"INTOXICACIÓN POR JATROPHA CURCAS"
  },
  {
    "codigo":240081004,
    "descripcion":"MIOPATÍA CENTRONUCLEAR AUTOSÓMICA RECESIVA"
  },
  {
    "codigo":1080511000119101,
    "descripcion":"CARCINOMA DE CÉLULAS GRANDES PRIMARIO DE BRONQUIO PRINCIPAL DERECHO"
  },
  {
    "codigo":305617007,
    "descripcion":"BAJO ATENCIÓN DE LOGOTERAPEUTA EXTRAHOSPITALARIO"
  },
  {
    "codigo":762534000,
    "descripcion":"BRADIARRITMIA SUPRAVENTRICULAR"
  },
  {
    "codigo":301947004,
    "descripcion":"REACCIÓN PUPILAR CERCANA AUSENTE"
  },
  {
    "codigo":70736000,
    "descripcion":"OSTEOCONDRITIS"
  },
  {
    "codigo":236411009,
    "descripcion":"NEFROPATÍA POR IGM"
  },
  {
    "codigo":300112002,
    "descripcion":"PABELLÓN AURICULAR PIGMENTADO"
  },
  {
    "codigo":343231000119106,
    "descripcion":"MACULOPATÍA TÓXICA DE AMBOS OJOS"
  },
  {
    "codigo":234576008,
    "descripcion":"NEUTROPENIA FAMILIAR CRÓNICA"
  },
  {
    "codigo":365648009,
    "descripcion":"COMPATIBILIDAD SANGUÍNEA - HALLAZGO"
  },
  {
    "codigo":429349001,
    "descripcion":"AVULSIÓN DE PIEL"
  },
  {
    "codigo":15989951000119107,
    "descripcion":"ESTRÍAS ANGIOIDES DE COROIDES DE OJO IZQUIERDO"
  },
  {
    "codigo":36133000,
    "descripcion":"POSICIÓN ANORMAL DE VÁLVULA CARDÍACA"
  },
  {
    "codigo":298277008,
    "descripcion":"LESIÓN DE MÚSCULO ESQUELÉTICO"
  },
  {
    "codigo":296442001,
    "descripcion":"SOBREDOSIS DE TEOFILINA"
  },
  {
    "codigo":34298002,
    "descripcion":"CONJUNTIVITIS NEONATAL"
  },
  {
    "codigo":198138004,
    "descripcion":"PERISALPINGITIS SUBAGUDA"
  },
  {
    "codigo":32463001,
    "descripcion":"HIPERPLASIA PRIMARIA DE CÉLULAS CLARAS"
  },
  {
    "codigo":294607005,
    "descripcion":"ALERGIA A PIRAZINAMIDA"
  },
  {
    "codigo":391076004,
    "descripcion":"RESULTADO DE ABSORCIOMETRÍA DE RAYOS X DE ENERGÍA DUAL LUMBAR, OSTEOPENIA"
  },
  {
    "codigo":718756005,
    "descripcion":"ATAXIA EPISÓDICA TIPO 5"
  },
  {
    "codigo":10966361000119106,
    "descripcion":"HERIDA ABIERTA DE MUSLO DERECHO DEBIDA A MORDEDURA HUMANA"
  },
  {
    "codigo":784292007,
    "descripcion":"ECCEMA VESICULAR AGUDO DE PIE"
  },
  {
    "codigo":292772008,
    "descripcion":"REACCIÓN ADVERSA A CINC TÓPICO"
  },
  {
    "codigo":127097001,
    "descripcion":"LINFADENOPATÍA TORÁCICA"
  },
  {
    "codigo":94329002,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL HILIO PULMONAR"
  },
  {
    "codigo":782457003,
    "descripcion":"HIPERHIDROSIS FOCAL PRIMARIA DE PALMA DE LA MANO DERECHA"
  },
  {
    "codigo":11785561000119107,
    "descripcion":"ABRASIÓN DE PIEL DE DEDO DE LA MANO IZQUIERDA"
  },
  {
    "codigo":420174000,
    "descripcion":"ALERGIA A TRIGO"
  },
  {
    "codigo":289102000,
    "descripcion":"INCAPAZ DE CONTROLAR LA RESPIRACIÓN"
  },
  {
    "codigo":290937008,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR LAMOTRIGINA"
  },
  {
    "codigo":92494003,
    "descripcion":"OSIFICACIÓN BIPARTITA DE CENTRO DE VÉRTEBRA CERVICAL"
  },
  {
    "codigo":715086007,
    "descripcion":"CAPAZ DE PASAR DE UNA SILLA DE RUEDAS A UNA SILLA"
  },
  {
    "codigo":188963000,
    "descripcion":"NEOPLASIA BENIGNA DE LOS HUESOS LARGOS DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":57891003,
    "descripcion":"RECIÉN NACIDO A TÉRMINO"
  },
  {
    "codigo":713251003,
    "descripcion":"ENFERMEDAD GINGIVAL CAUSADA POR TREPONEMA PALLIDUM"
  },
  {
    "codigo":449272005,
    "descripcion":"CAYADO AÓRTICO A LA IZQUIERDA, PRESENTE"
  },
  {
    "codigo":285432005,
    "descripcion":"CARCINOMA DE CUELLO UTERINO"
  },
  {
    "codigo":185293001,
    "descripcion":"VISTO POR CONSULTOR"
  },
  {
    "codigo":773282001,
    "descripcion":"SÍNDROME DE MACROSOMÍA, MICROFTALMÍA Y PALADAR HENDIDO"
  },
  {
    "codigo":1363106005,
    "descripcion":"ASTILLA EN CUERO CABELLUDO CON INFECCIÓN"
  },
  {
    "codigo":871586006,
    "descripcion":"NEUMOTÓRAX DEBIDO A PROCEDIMIENTO Y POSTERIOR A ÉL"
  },
  {
    "codigo":17783003,
    "descripcion":"ENFERMEDAD TERRESTRE"
  },
  {
    "codigo":443767006,
    "descripcion":"PATRÓN PERIFÉRICO DE ANTICUERPOS ANTINUCLEARES"
  },
  {
    "codigo":50551008,
    "descripcion":"ALTERACIÓN DE LA MADURACIÓN LEUCOCÍTICA CON DESVIACIÓN HACIA LA DERECHA"
  },
  {
    "codigo":1162828001,
    "descripcion":"ENFERMEDAD LINFOPROLIFERATIVA LIGADA AL CROMOSOMA X DEBIDO A DEFICIENCIA DE SH2D1A"
  },
  {
    "codigo":11814541000119105,
    "descripcion":"RUPTURA TRAUMÁTICA DE LIGAMENTO LATERAL DE ARTICULACIÓN DE DEDO ANULAR IZQUIERDO"
  },
  {
    "codigo":771447009,
    "descripcion":"SÍNDROME NEFRÓTICO DE INICIO EN LA INFANCIA ASOCIADO A LAMININA SUBUNIDAD BETA 2"
  },
  {
    "codigo":247159009,
    "descripcion":"DESGARRO EPITELIAL DE PIGMENTO MACULAR DE RETINA"
  },
  {
    "codigo":278092006,
    "descripcion":"VOLUMEN DE LÍQUIDO AMNIÓTICO DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":704076007,
    "descripcion":"POSICIÓN DE TRÍPODE"
  },
  {
    "codigo":276257001,
    "descripcion":"SILENCIO ELÉCTRICO DEL EMG"
  },
  {
    "codigo":319271000119101,
    "descripcion":"LUXACIÓN RECURRENTE DE ARTICULACIÓN DE RODILLA IZQUIERDA"
  },
  {
    "codigo":73511000119101,
    "descripcion":"PERFIL DE HIERRO FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":866081005,
    "descripcion":"INFECCIÓN DE DISCO INTERVERTEBRAL CAUSADA POR PARÁSITO"
  },
  {
    "codigo":210721003,
    "descripcion":"LESIÓN POR DESOLLAMIENTO DE PIE, CARA PLANTAR"
  },
  {
    "codigo":1259297007,
    "descripcion":"FORMACIÓN DE HUESO ALVEOLAR Y TEJIDO CONECTIVO EN SITIO DE FRACTURA DE RAÍZ DE DIENTE"
  },
  {
    "codigo":345741000119108,
    "descripcion":"EDEMA DE CÓRNEA IDIOPÁTICO DE AMBOS OJOS"
  },
  {
    "codigo":14113009,
    "descripcion":"INTOXICACIÓN POR OXYLOBIUM"
  },
  {
    "codigo":733174003,
    "descripcion":"LINFANGITIS AGUDA CAUSADA POR BACTERIA"
  },
  {
    "codigo":77814006,
    "descripcion":"MORTINATO PREMATURO DE SEXO MASCULINO (1000 - 2499 GRAMOS)"
  },
  {
    "codigo":208886007,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA DEL PULGAR"
  },
  {
    "codigo":1255627000,
    "descripcion":"NEFROPATÍA POSTRASPLANTE RENAL CAUSADA POR POLIOMAVIRUS BK"
  },
  {
    "codigo":405494009,
    "descripcion":"PROBLEMA IDENTIFICADO CON EL CONSENTIMIENTO DEL PACIENTE"
  },
  {
    "codigo":897014009,
    "descripcion":"RUPTURA ESPONTÁNEA PARCIAL DE CORDÓN UMBILICAL FETAL"
  },
  {
    "codigo":370891001,
    "descripcion":"TABUN-AGENTE NEUROTÓXICO"
  },
  {
    "codigo":239819001,
    "descripcion":"OLIGOARTRITIS INFLAMATORIA INDIFERENCIADA"
  },
  {
    "codigo":403659005,
    "descripcion":"NECROSIS CUMARÍNICA"
  },
  {
    "codigo":272587006,
    "descripcion":"POSICIÓN INCLINADA"
  },
  {
    "codigo":10443009,
    "descripcion":"INFECCIÓN LOCALIZADA"
  },
  {
    "codigo":75979009,
    "descripcion":"SÍNDROME DE JOHANSON - BLIZZARD"
  },
  {
    "codigo":205216006,
    "descripcion":"DEFICIENCIA PERONEA CONGÉNITA TIPO I"
  },
  {
    "codigo":237984008,
    "descripcion":"SÍNDROME NARP - NEUROPATÍA, ATAXIA Y RETINITIS PIGMENTOSA"
  },
  {
    "codigo":16594881000119101,
    "descripcion":"NEUROMA ACÚSTICO DE NERVIO VESTIBULAR IZQUIERDO"
  },
  {
    "codigo":301685004,
    "descripcion":"DIFICULTAD PARA MOVERSE EN LA CAMA"
  },
  {
    "codigo":299850001,
    "descripcion":"REFLEJO DE HOFFMAN NEGATIVO"
  },
  {
    "codigo":37706002,
    "descripcion":"HIPOCINESIA DE LA PARED CARDÍACA"
  },
  {
    "codigo":201546003,
    "descripcion":"ARTRITIS DE REGIÓN DE HOMBRO POSTERIOR A HELMINTIASIS"
  },
  {
    "codigo":365386006,
    "descripcion":"TOLERANCIA AL EJERCICIO - HALLAZGO"
  },
  {
    "codigo":298015003,
    "descripcion":"NECROSIS PAPILAR RENAL AGUDA CON INSUFICIENCIA RENAL"
  },
  {
    "codigo":292801000119105,
    "descripcion":"TRASTORNO DE NERVIO MEDIANO IZQUIERDO"
  },
  {
    "codigo":723999009,
    "descripcion":"SÍNDROME DE RETINITIS PIGMENTOSA, HIPOPITUITARISMO, NEFRONOFTISIS Y DISPLASIA ESQUELÉTICA"
  },
  {
    "codigo":166943009,
    "descripcion":"NIVEL TERAPÉUTICO DE FENITOÍNA"
  },
  {
    "codigo":427252003,
    "descripcion":"DOLOR IRRADIADO AL LADO DERECHO DEL PECHO"
  },
  {
    "codigo":230644004,
    "descripcion":"COMPRESIÓN DEL NERVIO PLANTAR INTERNO"
  },
  {
    "codigo":15693761000119106,
    "descripcion":"QUERATITIS FÚNGICA IZQUIERDA"
  },
  {
    "codigo":197876006,
    "descripcion":"PARÁLISIS DE ESFÍNTER DE VEJIGA URINARIA"
  },
  {
    "codigo":165108004,
    "descripcion":"ÍNDICE METABÓLICO LENTO"
  },
  {
    "codigo":296180008,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE BENPERIDOL"
  },
  {
    "codigo":64969001,
    "descripcion":"HIPODONCIA"
  },
  {
    "codigo":34036009,
    "descripcion":"QUEMADURA PROFUNDA DE TERCER GRADO DE LA PALMA DE LA MANO"
  },
  {
    "codigo":1144478004,
    "descripcion":"DEMUESTRA CONOCIMIENTO SOBRE MEDICACIÓN"
  },
  {
    "codigo":95902005,
    "descripcion":"ACCIÓN REDUCIDA DE UN FÁRMACO"
  },
  {
    "codigo":292510006,
    "descripcion":"REACCIÓN ADVERSA A LA ISOPRENALINA ADMINISTRADA POR VÍA PARENTERAL"
  },
  {
    "codigo":423582009,
    "descripcion":"QUISTE ARACNOIDEO TRAUMÁTICO"
  },
  {
    "codigo":716659002,
    "descripcion":"CARCINOMA ESCAMOCELULAR DE CABEZA Y CUELLO"
  },
  {
    "codigo":126835002,
    "descripcion":"NEOPLASIA DEL ÍLEON"
  },
  {
    "codigo":388979002,
    "descripcion":"CRISIASIS DE CÓRNEA"
  },
  {
    "codigo":92232000,
    "descripcion":"NEOPLASIA BENIGNA DE MÚSCULO DEL PERINEO"
  },
  {
    "codigo":94067008,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE SENO ESFENOIDAL"
  },
  {
    "codigo":714824003,
    "descripcion":"HEMATURIA PERSISTENTE CONCOMITANTE CON ANOMALÍA GLOMERULAR MENOR Y DEBIDA A ELLA"
  },
  {
    "codigo":59464004,
    "descripcion":"INSUFICIENCIA DE VÁLVULAS MITRAL Y AÓRTICA REUMÁTICAS"
  },
  {
    "codigo":254237003,
    "descripcion":"APLASIA DE PIEL"
  },
  {
    "codigo":418077005,
    "descripcion":"EL MARGEN DE RESECCIÓN QUIRÚRGICA SUPERIOR ES EL MARGEN NO AFECTADO MÁS CERCANO A LA NEOPLASIA MALIGNA"
  },
  {
    "codigo":88562000,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE TOBILLO Y\/O PIE"
  },
  {
    "codigo":450845009,
    "descripcion":"ENURESIS NOCTURNA PRIMARIA"
  },
  {
    "codigo":385309009,
    "descripcion":"TUMOR QUE INVADE EPITELIO SOLAMENTE"
  },
  {
    "codigo":712989008,
    "descripcion":"TUMOR FILOIDE DE MAMA"
  },
  {
    "codigo":285170004,
    "descripcion":"CAPAZ DE RECONOCER CARAS"
  },
  {
    "codigo":449010004,
    "descripcion":"VENA CAVA INFERIOR IZQUIERDA CONECTADA A AURÍCULA EN EL LADO DERECHO"
  },
  {
    "codigo":711154007,
    "descripcion":"HIPOPIGMENTACIÓN EN GOTAS Y QUERATODERMIA PALMOPLANTAR PUNTEADA CON CALCIFICACIÓN ECTÓPICA O SIN ELLA"
  },
  {
    "codigo":416242008,
    "descripcion":"COMPRESIÓN DE LA SINCONDROSIS ESFENOBASILAR"
  },
  {
    "codigo":283335009,
    "descripcion":"PICADURA DE INSECTO EN EL PULGAR"
  },
  {
    "codigo":314268004,
    "descripcion":"MEMBRANA COROIDEA NEOVASCULAR PERIPAPILAR"
  },
  {
    "codigo":707484005,
    "descripcion":"CARCINOMA ADENOIDE PRIMARIO DE HIPOFARINGE, DE CÉLULAS ESCAMOSAS"
  },
  {
    "codigo":248732006,
    "descripcion":"ONDAS EN CAÑÓN"
  },
  {
    "codigo":1297308006,
    "descripcion":"CELULITIS DE TERCER DEDO DE PIE"
  },
  {
    "codigo":771185000,
    "descripcion":"SÍNDROME DE OROFARINGE IMPERFORADA CON ANOMALÍAS COSTOVERTEBRALES"
  },
  {
    "codigo":246897000,
    "descripcion":"PAPILAS DE CONJUNTIVA DE LIMBO"
  },
  {
    "codigo":115825002,
    "descripcion":"FENOTIPO XS2"
  },
  {
    "codigo":212294005,
    "descripcion":"LESIÓN ABIERTA, NERVIO TORÁCICO LARGO"
  },
  {
    "codigo":46619002,
    "descripcion":"BLOQUEO CARDÍACO CONGÉNITO"
  },
  {
    "codigo":210459007,
    "descripcion":"HERIDA ABIERTA DE LA REGIÓN HIPOGÁSTRICA"
  },
  {
    "codigo":274160002,
    "descripcion":"FRACTURA DE FALANGE DEL PULGAR"
  },
  {
    "codigo":306928003,
    "descripcion":"ESTRIBO FIJO"
  },
  {
    "codigo":208624005,
    "descripcion":"FRACTURA EXPUESTA DE CABEZA DE PERONÉ"
  },
  {
    "codigo":678441000119100,
    "descripcion":"GLAUCOMA DE OJO IZQUIERDO POR PRESIÓN VENOSA EPIESCLERAL AUMENTADA"
  },
  {
    "codigo":1157061002,
    "descripcion":"GLIOSARCOMA DE SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":403397004,
    "descripcion":"PIEL LAXA POSINFLAMATORIA"
  },
  {
    "codigo":15669801000119102,
    "descripcion":"TALIPES DEL PIE IZQUIERDO"
  },
  {
    "codigo":23081000119102,
    "descripcion":"FRAGMENTO DE LENTE RETENIDO EN EL VÍTREO"
  },
  {
    "codigo":237722004,
    "descripcion":"SÍNDROME DE LA SILLA TURCA VACÍA"
  },
  {
    "codigo":1351834005,
    "descripcion":"SÍNDROME DE BROWN-SÉQUARD DEBIDO A ESCLEROSIS MÚLTIPLE"
  },
  {
    "codigo":41114007,
    "descripcion":"PREECLAMPSIA LEVE"
  },
  {
    "codigo":270490007,
    "descripcion":"OTITIS MEDIA AGUDA CON DERRAME"
  },
  {
    "codigo":235887001,
    "descripcion":"RUPTURA DE HÍGADO"
  },
  {
    "codigo":301423002,
    "descripcion":"DOLOR A LA PALPACIÓN EN EL MIEMBRO INFERIOR"
  },
  {
    "codigo":1153391002,
    "descripcion":"ESPONDILOPATÍA DESTRUCTIVA"
  },
  {
    "codigo":72047008,
    "descripcion":"ENFERMEDAD DE OSGOOD - SCHLATTER"
  },
  {
    "codigo":365124001,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA UTILIZAR LAS ESCALERAS MECÁNICAS"
  },
  {
    "codigo":299588005,
    "descripcion":"SIN AMPLITUD ACTIVA DE FLEXIÓN DE DEDO DEL PIE"
  },
  {
    "codigo":234052005,
    "descripcion":"INSUFICIENCIA VENOSA SECUNDARIA DE PIERNA"
  },
  {
    "codigo":4676006,
    "descripcion":"GLOMERULONEFRITIS ASOCIADA CON LUPUS ERITEMATOSO SISTÉMICO, CLASE II DE LA OMS"
  },
  {
    "codigo":1088041000119106,
    "descripcion":"INFLAMACIÓN AGUDA DE MASTOIDES IZQUIERDA"
  },
  {
    "codigo":363289003,
    "descripcion":"COMPLICACIÓN DE PROCEDIMIENTO EN EL APARATO REPRODUCTOR"
  },
  {
    "codigo":428825004,
    "descripcion":"MEJORÍA DE LA MOTILIDAD DE LA PARED VENTRICULAR IZQUIERDA EN COMPARACIÓN CON ESTUDIO PREVIO"
  },
  {
    "codigo":789273007,
    "descripcion":"REACCIÓN ADVERSA A AGONISTA DE RECEPTOR ADRENÉRGICO ALFA 2 CENTRAL"
  },
  {
    "codigo":232217008,
    "descripcion":"DEFORMIDAD CONGÉNITA DE LA OREJA"
  },
  {
    "codigo":263150000,
    "descripcion":"FRACTURA DE HUESO PETROSO"
  },
  {
    "codigo":721902002,
    "descripcion":"SÍNDROME DE SCHILBACH ROTT"
  },
  {
    "codigo":295918002,
    "descripcion":"SOBREDOSIS DE FÁRMACO INHIBIDOR DE LA RECAPTACIÓN DE SEROTONINA"
  },
  {
    "codigo":349881000221109,
    "descripcion":"HEPATITIS C EN EMBARAZO"
  },
  {
    "codigo":195779005,
    "descripcion":"FARINGITIS QUERATÓSICA"
  },
  {
    "codigo":294083006,
    "descripcion":"ALERGIA A METIXENO"
  },
  {
    "codigo":359619007,
    "descripcion":"PINEALOMA"
  },
  {
    "codigo":1176984002,
    "descripcion":"POLINEUROPATÍA LEPROSA"
  },
  {
    "codigo":292248002,
    "descripcion":"REACCIÓN ADVERSA AL TAMOXIFENO"
  },
  {
    "codigo":423320002,
    "descripcion":"DIFICULTAD DEL CUIDADOR PARA PROVEER ATENCIÓN DE LA SALUD"
  },
  {
    "codigo":95640005,
    "descripcion":"TRASTORNO DEL TRONCO ENCEFÁLICO"
  },
  {
    "codigo":783768006,
    "descripcion":"HIPERINSULINISMO AUTOSÓMICO RECESIVO DEBIDO A DEFICIENCIA DE KIR6.2"
  },
  {
    "codigo":718232007,
    "descripcion":"INFECCIÓN BACTERIANA PIÓGENA DEBIDA A DEFICIENCIA DE PROTEÍNA 88 DE RESPUESTA PRIMARIA DE DIFERENCIACIÓN MIELOIDE"
  },
  {
    "codigo":290413004,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR NABILONA"
  },
  {
    "codigo":126573007,
    "descripcion":"NEOPLASIA DE HUESO ESCAFOIDES"
  },
  {
    "codigo":61037007,
    "descripcion":"BOCIO COLOIDE"
  },
  {
    "codigo":288578001,
    "descripcion":"NO SE COMUNICA"
  },
  {
    "codigo":716397008,
    "descripcion":"CAPAZ DE SER OPTIMISTA"
  },
  {
    "codigo":714562005,
    "descripcion":"RESPETA EFECTIVAMENTE REGLAS Y LÍMITES"
  },
  {
    "codigo":297821000119103,
    "descripcion":"DERRAME INTERMITENTE DE ARTICULACIÓN DE REGIÓN DE HOMBRO"
  },
  {
    "codigo":91970006,
    "descripcion":"NEOPLASIA BENIGNA DE LA AMPOLLA DE VATER"
  },
  {
    "codigo":253975004,
    "descripcion":"SINFALANGISMO"
  },
  {
    "codigo":286743007,
    "descripcion":"TIENDE A POSTERGAR"
  },
  {
    "codigo":219372000,
    "descripcion":"HERIDA DE GUERRA POR BALAS DE GOMA"
  },
  {
    "codigo":22764001,
    "descripcion":"DISPLASIA METATRÓFICA"
  },
  {
    "codigo":284908004,
    "descripcion":"INCAPAZ DE USAR EL INODORO"
  },
  {
    "codigo":11848541000119106,
    "descripcion":"ABRASIÓN DE PIEL DE PÁRPADO IZQUIERDO"
  },
  {
    "codigo":53697002,
    "descripcion":"CONDUCTO LAGRIMAL ACCESORIO"
  },
  {
    "codigo":283073002,
    "descripcion":"RASGUÑO DE LA BOCA"
  },
  {
    "codigo":323390301000119108,
    "descripcion":"DESGARRO PARCIAL DE MANGUITO ROTADOR DERECHO"
  },
  {
    "codigo":15999991000119103,
    "descripcion":"TRASTORNO DE ESCLERÓTICA DE AMBOS OJOS"
  },
  {
    "codigo":51862005,
    "descripcion":"INTOXICACIÓN POR DIYODOHIDROXIQUININA"
  },
  {
    "codigo":314006008,
    "descripcion":"RETINOPATÍA SEROSA CENTRAL AGUDA, CON LÍQUIDO SUBRETINIANO"
  },
  {
    "codigo":248470009,
    "descripcion":"SENSIBLE A LOS CAMBIOS DE LA TEMPERATURA AMBIENTAL"
  },
  {
    "codigo":707222009,
    "descripcion":"GASTROENTERITIS EPIDÉMICA"
  },
  {
    "codigo":246635007,
    "descripcion":"VISIÓN DÉBIL"
  },
  {
    "codigo":1295211008,
    "descripcion":"RADIOGRAFÍA DE CAJA TORÁCICA NORMAL"
  },
  {
    "codigo":410475008,
    "descripcion":"CONJUNTIVITIS DE LYME"
  },
  {
    "codigo":212032004,
    "descripcion":"QUEMADURA DE BOCA Y FARINGE"
  },
  {
    "codigo":80960004,
    "descripcion":"INFECCIÓN CAUSADA POR YERSINIA ENTEROCOLITICA"
  },
  {
    "codigo":13000001000004102,
    "descripcion":"CELULITIS DE MANO DERECHA"
  },
  {
    "codigo":277568007,
    "descripcion":"VARIANTE DE TRICOLEUCEMIA"
  },
  {
    "codigo":736320009,
    "descripcion":"SENTIDO DE TITULARIDAD DE UN DERECHO"
  },
  {
    "codigo":8520001000004106,
    "descripcion":"ABSCESO SUBCUTÁNEO DE RODILLA"
  },
  {
    "codigo":210197003,
    "descripcion":"LESIÓN CERRADA DEL RIÑÓN"
  },
  {
    "codigo":13960001000004106,
    "descripcion":"FRACTURA DE TUBÉRCULO PÚBICO"
  },
  {
    "codigo":13320001000004109,
    "descripcion":"VIRUS SINCICIAL RESPIRATORIO HUMANO AISLADO EN CULTIVO DE ESPUTO"
  },
  {
    "codigo":15727761000119101,
    "descripcion":"ADHERENCIAS DE AMBAS ARTICULACIONES TEMPOROMANDIBULARES"
  },
  {
    "codigo":79125007,
    "descripcion":"LUXACIÓN EXPUESTA DE LA PRIMERA VÉRTEBRA CERVICAL"
  },
  {
    "codigo":275733008,
    "descripcion":"ÍNDICE DE PICO FLUJO ANORMAL"
  },
  {
    "codigo":308501009,
    "descripcion":"SITUACIÓN DEL MONITOREO DEL ASMA"
  },
  {
    "codigo":46357007,
    "descripcion":"FRACTURAS MÚLTIPLES EXPUESTAS DEL EXTREMO SUPERIOR DEL RADIO"
  },
  {
    "codigo":110058005,
    "descripcion":"LACERACIÓN SIMPLE CONTAMINADA DE LA FRENTE"
  },
  {
    "codigo":698047001,
    "descripcion":"OSTEOPOROSIS CIRCUNSCRIPTA"
  },
  {
    "codigo":304831001,
    "descripcion":"HEMATOMA SUBDURAL INTRACRANEAL CRÓNICO"
  },
  {
    "codigo":370367002,
    "descripcion":"PRUEBA DE TOLERANCIA AL ESFUERZO, DUDOSA"
  },
  {
    "codigo":403135004,
    "descripcion":"LEISHMANIASIS MUCOCUTÁNEA NORTEAMERICANA"
  },
  {
    "codigo":1287871008,
    "descripcion":"GNATOFIMA"
  },
  {
    "codigo":1156799009,
    "descripcion":"POLIPOSIS JUVENIL DEL LACTANTE"
  },
  {
    "codigo":40852003,
    "descripcion":"AGRAMATISMO"
  },
  {
    "codigo":1351572006,
    "descripcion":"SÍNDROME DE HIPERINMUNOGLOBULINA M AUTOSÓMICO RECESIVO DEBIDO A DEFICIENCIA DE CITIDINA DESAMINASA INDUCIDA POR ACTIVACIÓN"
  },
  {
    "codigo":237460007,
    "descripcion":"TRASTORNO DEL PEZÓN"
  },
  {
    "codigo":71785001,
    "descripcion":"SÍNDROME DE HIPERHIDRATACIÓN HIPOTÓNICA"
  },
  {
    "codigo":202857003,
    "descripcion":"TENDINITIS DEL MÚSCULO TRÍCEPS"
  },
  {
    "codigo":399465006,
    "descripcion":"FIMBRIAS DE LA TROMPA DE FALOPIO DERECHA CERRADAS"
  },
  {
    "codigo":301161008,
    "descripcion":"AUSENCIA DE PULSO PERIFÉRICO"
  },
  {
    "codigo":366697009,
    "descripcion":"HALLAZGO RELACIONADO CON LA AMPLITUD DE LA ADUCCIÓN DEL PULGAR"
  },
  {
    "codigo":1251433009,
    "descripcion":"DERMATITIS ATÓPICA CRÓNICA LIQUENIFICADA DEL ADULTO"
  },
  {
    "codigo":235625009,
    "descripcion":"ANILLO MUSCULAR DE PORCIÓN INFERIOR DEL ESÓFAGO"
  },
  {
    "codigo":168254004,
    "descripcion":"INOCULACIÓN DE ANIMALES: HONGOS"
  },
  {
    "codigo":299326005,
    "descripcion":"ARTICULACIÓN DE LA RODILLA - TUMEFACCIÓN SINOVIAL"
  },
  {
    "codigo":364862006,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA RODAR TOTALMENTE"
  },
  {
    "codigo":430398007,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR BARBITÚRICO"
  },
  {
    "codigo":4414005,
    "descripcion":"INFECCIÓN CAUSADA POR SETARIA"
  },
  {
    "codigo":1149459001,
    "descripcion":"PERIODONTITIS GENERALIZADA ESTADIO 1 GRADO B SEGÚN LA CLASIFICACIÓN DE LAS ENFERMEDADES Y ALTERACIONES PERIODONTALES Y PERIIMPLANTARIAS DE 2017 DE LA ACADEMIA ESTADOUNIDENSE DE PERIODONTOLOGÍA Y LA FEDERACIÓN EUROPEA DE PERIODONTOLOGÍA"
  },
  {
    "codigo":266558006,
    "descripcion":"ESTENOSIS ADQUIRIDA DE URÉTER"
  },
  {
    "codigo":35347003,
    "descripcion":"PARTO RETARDADO DESPUÉS DE LA RUPTURA ARTIFICIAL DE MEMBRANAS"
  },
  {
    "codigo":461331004,
    "descripcion":"POSICIÓN ANÓMALA DE ORIFICIO DE ARTERIA CORONARIA"
  },
  {
    "codigo":43591000087101,
    "descripcion":"CONTUSIÓN DE REGIÓN DE OJO DERECHO"
  },
  {
    "codigo":231955006,
    "descripcion":"HEMORRAGIA EN EL ESTROMA DEL IRIS"
  },
  {
    "codigo":789011007,
    "descripcion":"SÍNTOMA PSICOLÓGICO DEBIDO A DEMENCIA"
  },
  {
    "codigo":363027008,
    "descripcion":"ANOMALÍA CONGÉNITA DE UNA PARED CORPORAL"
  },
  {
    "codigo":38471000087106,
    "descripcion":"ACINESIA DE MIOCARDIO DE REGIÓN SEPTAL DE VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":41031000087106,
    "descripcion":"LACERACIÓN DE EXTREMIDAD SUPERIOR IZQUIERDA"
  },
  {
    "codigo":48711000087108,
    "descripcion":"DISTENSIÓN DE MÚSCULO SUPRAESPINOSO DERECHO"
  },
  {
    "codigo":11769131000119106,
    "descripcion":"RUPTURA TRAUMÁTICA DE TENDÓN DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":262888006,
    "descripcion":"LACERACIÓN DE EPIPLÓN MAYOR"
  },
  {
    "codigo":295656003,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE DACARBAZINA"
  },
  {
    "codigo":197352008,
    "descripcion":"HEPATITIS TÓXICA"
  },
  {
    "codigo":721640002,
    "descripcion":"CARCINOMA NEUROENDOCRINO PRIMARIO DE CUERPO DEL ESTÓMAGO"
  },
  {
    "codigo":64445006,
    "descripcion":"SENSIBILIDAD AL DESLUMBRAMIENTO AUMENTADA"
  },
  {
    "codigo":785341006,
    "descripcion":"HEMORRAGIA INTRAPARTO DEBIDA A LEIOMIOMA"
  },
  {
    "codigo":228285006,
    "descripcion":"BEBE EN EL HOGAR"
  },
  {
    "codigo":95378001,
    "descripcion":"HIPERSENSIBILIDAD EN EL SITIO DE INYECCIÓN"
  },
  {
    "codigo":291986002,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR GUANETIDINA"
  },
  {
    "codigo":423058007,
    "descripcion":"ALERGIA A VENENO DE AVISPA"
  },
  {
    "codigo":1240423001,
    "descripcion":"TRASTORNO PRURIGINOSO DE PIEL"
  },
  {
    "codigo":128146009,
    "descripcion":"DERIVACIÓN PORTOSISTÉMICA"
  },
  {
    "codigo":28007006,
    "descripcion":"TRASTORNO SENSITIVO DEL NERVIO TRIGÉMINO"
  },
  {
    "codigo":1142119006,
    "descripcion":"TAQUICARDIA POR REENTRADA EN EL NODO AURICULOVENTRICULAR ATÍPICA RÁPIDA-LENTA"
  },
  {
    "codigo":290151009,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR PENTAZOCINA"
  },
  {
    "codigo":124476003,
    "descripcion":"DEFICIENCIA DE GLUCANO 1, 3 - ALFA - GLUCOSIDASA"
  },
  {
    "codigo":758441000000101,
    "descripcion":"CAPAZ DE LAVAR LA ROPA"
  },
  {
    "codigo":386620006,
    "descripcion":"DIETA SIN ADICIÓN DE SAL"
  },
  {
    "codigo":1269521000,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÉDULA ESPINAL CERVICAL DEBIDA A FRACTURA EXPUESTA DE COLUMNA CERVICAL"
  },
  {
    "codigo":57105000,
    "descripcion":"ACROPARESTESIA SIMPLE"
  },
  {
    "codigo":778001003,
    "descripcion":"ENCEFALOPATÍA EPILÉPTICA ASOCIADA AL CANAL DE POTASIO DEPENDIENTE DEL VOLTAJE SUBFAMILIA Q MIEMBRO 2 (KCNQ2)"
  },
  {
    "codigo":188177003,
    "descripcion":"NEOPLASIA MALIGNA DE GLÁNDULA ENDOCERVICAL"
  },
  {
    "codigo":286481003,
    "descripcion":"DIFICULTAD PARA ESPARCIR ALIMENTOS"
  },
  {
    "codigo":448486000,
    "descripcion":"VENA COLATERAL ANÓMALA DE LA CIRCULACIÓN PULMONAR A LA CIRCULACIÓN SISTÉMICA"
  },
  {
    "codigo":186342000,
    "descripcion":"INFECCIÓN PULMONAR POR COMPLEJO MYCOBACTERIUM AVIUM"
  },
  {
    "codigo":250043000,
    "descripcion":"TRASTORNO SENSORIOMOTRIZ DE LA MARCHA DE ALTO NIVEL"
  },
  {
    "codigo":284646009,
    "descripcion":"ESCUPIR A OTRA PERSONA"
  },
  {
    "codigo":53435002,
    "descripcion":"ADENOMA DE GLÁNDULAS DE BRUNNER"
  },
  {
    "codigo":315579002,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: POLACO"
  },
  {
    "codigo":86203003,
    "descripcion":"POLIHIDRAMNIOS"
  },
  {
    "codigo":248208000,
    "descripcion":"FACIES PARKINSONIANA"
  },
  {
    "codigo":1296784002,
    "descripcion":"LIPOFUSCINOSIS CEROIDE NEURONAL TIPO 6A"
  },
  {
    "codigo":444816006,
    "descripcion":"EMBOLIA DESDE TROMBOSIS DE VENA DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":1264016007,
    "descripcion":"DOLOR EN MÚSCULO DE ANTEBRAZO"
  },
  {
    "codigo":280976006,
    "descripcion":"ANEURISMA DE INJERTO ARTERIOVENOSO"
  },
  {
    "codigo":1231248008,
    "descripcion":"LAGOFTALMOS MECÁNICO DE PÁRPADO INFERIOR"
  },
  {
    "codigo":705125001,
    "descripcion":"FRACTURA NO EXPUESTA DE PARED POSTERIOR DE ACETÁBULO"
  },
  {
    "codigo":16997008,
    "descripcion":"AGITACIÓN NEONATAL"
  },
  {
    "codigo":80698001,
    "descripcion":"MIOSITIS ORBITARIA"
  },
  {
    "codigo":408378002,
    "descripcion":"CONTROL REGULAR DISCUTIDO CON EL PACIENTE"
  },
  {
    "codigo":49765009,
    "descripcion":"HIPERPIGMENTACIÓN DE LA PIEL"
  },
  {
    "codigo":1293114006,
    "descripcion":"EMBOLIA DE ARTERIA PULMONAR DEBIDA A CUERPO EXTRAÑO"
  },
  {
    "codigo":1260346008,
    "descripcion":"CEFALEA DEBIDA A SÍNDROME DE ABSTINENCIA DE CAFEÍNA"
  },
  {
    "codigo":275471001,
    "descripcion":"DEPENDENCIA DE PSICOESTIMULANTES"
  },
  {
    "codigo":703290008,
    "descripcion":"FALLA DE PRÓTESIS DE VÁLVULA PULMONAR QUE REQUIERE REVISIÓN"
  },
  {
    "codigo":77028001,
    "descripcion":"SÍFILIS SECUNDARIA DEL ANO"
  },
  {
    "codigo":109796002,
    "descripcion":"FALTA DE SOPORTE DEL ARCO ALVEOLAR SUPERIOR"
  },
  {
    "codigo":439311009,
    "descripcion":"TIENE INTENCIÓN DE CONTINUAR EL EMBARAZO"
  },
  {
    "codigo":765156001,
    "descripcion":"RIÑÓN IZQUIERDO PEQUEÑO"
  },
  {
    "codigo":240868007,
    "descripcion":"TRIQUINOSIS MIGRATORIA"
  },
  {
    "codigo":271801002,
    "descripcion":"ALTERACIÓN DEL SENTIDO DEL GUSTO"
  },
  {
    "codigo":15703801000119107,
    "descripcion":"CONTRACTURA DE MÚSCULO DE AMBAS MANOS"
  },
  {
    "codigo":304569003,
    "descripcion":"NIVEL DE INTERÉS ERÓTICO, NORMAL"
  },
  {
    "codigo":402873007,
    "descripcion":"TUMOR MALIGNO FIBROHISTIOCÍTICO DE LA PIEL"
  },
  {
    "codigo":106126000,
    "descripcion":"HALLAZGO RELACIONADO CON EL ESTADO EMOCIONAL"
  },
  {
    "codigo":7822001,
    "descripcion":"INTENTO FALLIDO DE ABORTO COMPLICADO POR LESIÓN DE TEJIDOS Y\/U ÓRGANOS PÉLVICOS"
  },
  {
    "codigo":1187470001,
    "descripcion":"PARAPLEJÍA ESPÁSTICA AUTOSÓMICA RECESIVA TIPO 75"
  },
  {
    "codigo":685971000119103,
    "descripcion":"LIPOSARCOMA PRIMARIO DE PARTES BLANDAS DE TÓRAX"
  },
  {
    "codigo":169827000,
    "descripcion":"UN SOLO MORTINATO"
  },
  {
    "codigo":202595001,
    "descripcion":"OSTEOCONDROMATOSIS SINOVIAL DE ARTICULACIÓN INTERFALÁNGICA DE DEDO DEL PIE"
  },
  {
    "codigo":5987007,
    "descripcion":"OLOR DE RECONOCIMIENTO"
  },
  {
    "codigo":430136001,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR FÁRMACO ANTIPARKINSONIANO"
  },
  {
    "codigo":366435009,
    "descripcion":"AMPLITUD DE LA FLEXIÓN LATERAL DERECHA DE COLUMNA LUMBAR - HALLAZGO"
  },
  {
    "codigo":725048002,
    "descripcion":"ENFERMEDAD DE CHARCOT-MARIE-TOOTH TIPO EB1"
  },
  {
    "codigo":69688007,
    "descripcion":"ERITEMA NUDOSO CRÓNICO"
  },
  {
    "codigo":395533000,
    "descripcion":"TUMOR QUE INVADE LA LÁMINA PROPIA"
  },
  {
    "codigo":67853001,
    "descripcion":"PÓLIPO DE LA URETRA"
  },
  {
    "codigo":611231000124106,
    "descripcion":"EXTINTOR DE INCENDIOS FUNCIONANTE EN DOMICILIO"
  },
  {
    "codigo":10817581000119101,
    "descripcion":"FRACTURA EXPUESTA DE DIÁFISIS DE SEGUNDO HUESO METACARPIANO DE MANO DERECHA"
  },
  {
    "codigo":1149197005,
    "descripcion":"REQUERIMIENTO NUTRICIONAL POR ENCIMA DE LO ESPERADO"
  },
  {
    "codigo":198925006,
    "descripcion":"HEMORRAGIA PREPARTO CON LEIOMIOMA UTERINO"
  },
  {
    "codigo":426466001,
    "descripcion":"DOLOR IRRADIADO AL FLANCO IZQUIERDO"
  },
  {
    "codigo":262626005,
    "descripcion":"LESIÓN EN ORIFICIO NATURAL"
  },
  {
    "codigo":721378006,
    "descripcion":"SÍNDROME DEL CORDÓN CENTRAL DE MÉDULA ESPINAL AL NIVEL DEL SÉPTIMO SEGMENTO CERVICAL"
  },
  {
    "codigo":295394006,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE HIDRÓXIDO DE ALUMINIO"
  },
  {
    "codigo":293559001,
    "descripcion":"REACCIÓN ADVERSA A LA NICOFURANOSA"
  },
  {
    "codigo":129719003,
    "descripcion":"COMPOSICIÓN MAMARIA EXTREMADAMENTE DENSA"
  },
  {
    "codigo":282547008,
    "descripcion":"CAPAZ DE EVITAR OBSTÁCULOS AL CORRER"
  },
  {
    "codigo":162487008,
    "descripcion":"SÍNTOMA QUE MEJORA CON EL MOVIMIENTO"
  },
  {
    "codigo":424631008,
    "descripcion":"GANGLIONEUROMA MEDIASTÍNICO"
  },
  {
    "codigo":783244002,
    "descripcion":"NEUROPATÍA SENSITIVA AGUDA PURA"
  },
  {
    "codigo":95116001,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA GLÁNDULA SUBLINGUAL"
  },
  {
    "codigo":160652009,
    "descripcion":"REALIZA EJERCICIO FÍSICO INADECUADO"
  },
  {
    "codigo":226188009,
    "descripcion":"DIETA CON CONTENIDO MÍNIMO DE BENZOATO"
  },
  {
    "codigo":224353004,
    "descripcion":"PROTECCIÓN INFANTIL - HALLAZGO"
  },
  {
    "codigo":1141857007,
    "descripcion":"SIGNO DE VÍA DE TRANVÍA DE NERVIO ÓPTICO"
  },
  {
    "codigo":16033991000119102,
    "descripcion":"HIPERTROFIA DE HUESO DE AMBAS CLAVÍCULAS"
  },
  {
    "codigo":93281007,
    "descripcion":"HIPOPLASIA CONGÉNITA DE HUESO PALATINO"
  },
  {
    "codigo":289889009,
    "descripcion":"VARIACIÓN EN LA CANTIDAD DEL FLUJO MENSTRUAL"
  },
  {
    "codigo":91446004,
    "descripcion":"INVAGINACIÓN DE APÉNDICE ILEOCECAL"
  },
  {
    "codigo":714038006,
    "descripcion":"ENFERMEDAD GINGIVAL CAUSADA POR MATERIAL DE RESTAURACIÓN DENTAL"
  },
  {
    "codigo":124214007,
    "descripcion":"DEFICIENCIA DE 11 - BETA - MONOOXIGENASA"
  },
  {
    "codigo":24075007,
    "descripcion":"PRESIÓN INTRAOCULAR ANORMAL"
  },
  {
    "codigo":286219008,
    "descripcion":"INCAPAZ DE USAR LA CORRIENTE DE AIRE PULMONAR AL HABLAR"
  },
  {
    "codigo":253451008,
    "descripcion":"MÚSCULO PAPILAR DE VÁLVULA AURICULOVENTRICULAR COMÚN AUSENTE"
  },
  {
    "codigo":251616003,
    "descripcion":"AUMENTO DEL UMBRAL DE LA ONDA V DEL POTENCIAL EVOCADO AUDITIVO DEL TRONCO ENCEFÁLICO"
  },
  {
    "codigo":22240003,
    "descripcion":"PERICORONITIS"
  },
  {
    "codigo":1300192007,
    "descripcion":"HIPOPLASIA PONTOCEREBELOSA CONGÉNITA TIPO 14"
  },
  {
    "codigo":249781002,
    "descripcion":"PIERNA GRANDE"
  },
  {
    "codigo":184245003,
    "descripcion":"TARJETA DE COOPERACIÓN OBSTÉTRICA ACTUALIZADA"
  },
  {
    "codigo":1003445004,
    "descripcion":"ESPINA BÍFIDA ABIERTA DE COLUMNA VERTEBRAL LUMBOSACRA CON HIDROCEFALIA"
  },
  {
    "codigo":282549006,
    "descripcion":"EVITA OBSTÁCULOS AL CORRER"
  },
  {
    "codigo":774069007,
    "descripcion":"DEMENCIA NEURODEGENERATIVA ASOCIADA CON PRKAR1B CON FILAMENTOS INTERMEDIOS"
  },
  {
    "codigo":247946000,
    "descripcion":"RESISTENCIA A CAMBIAR"
  },
  {
    "codigo":53173007,
    "descripcion":"ESTADIO B2 DE DUKES MODIFICADO"
  },
  {
    "codigo":772234000,
    "descripcion":"CAPAZ DE MANTENER EL EQUILIBRIO AL PARARSE CON AMBOS PIES EN POSICIÓN DE SEMI TÁNDEM"
  },
  {
    "codigo":51338006,
    "descripcion":"GASTROENTEROPATÍA EOSINOFÍLICA CON ALERGIA ALIMENTARIA"
  },
  {
    "codigo":82271004,
    "descripcion":"TRAUMATISMO CRANEOENCEFÁLICO"
  },
  {
    "codigo":16735006,
    "descripcion":"AFRONTAMIENTO DE EVITACIÓN"
  },
  {
    "codigo":442719008,
    "descripcion":"HALLAZGO RELACIONADO CON DIFERENCIA EN EL MARGEN EN COMPARACIÓN CON EXAMEN RADIOLÓGICO PREVIO"
  },
  {
    "codigo":14900002,
    "descripcion":"HIPOPITUITARISMO DEBIDO A RADIOTERAPIA"
  },
  {
    "codigo":735796002,
    "descripcion":"MÚLTIPLES LESIONES TRAUMÁTICAS ABDOMINALES"
  },
  {
    "codigo":703028004,
    "descripcion":"AEROMONAS HYDROPHILA O AEROMONAS PUNCTATA"
  },
  {
    "codigo":1260084005,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS DE VALÉCULA"
  },
  {
    "codigo":211508003,
    "descripcion":"CONTUSIÓN DE LA MANO, PALMA"
  },
  {
    "codigo":80436007,
    "descripcion":"PRESIÓN DE ENCLAVAMIENTO VENOSA AUMENTADA"
  },
  {
    "codigo":15679841000119107,
    "descripcion":"CONJUNTIVITIS NEONATAL DE AMBOS OJOS"
  },
  {
    "codigo":111369005,
    "descripcion":"DEGENERACIÓN PARENQUIMATOSA DEL HÍGADO"
  },
  {
    "codigo":733961005,
    "descripcion":"CARIES DENTAL PRIMARIA INACTIVA QUE SE EXTIENDE HASTA EL TERCIO INTERNO DE LA DENTINA"
  },
  {
    "codigo":45833007,
    "descripcion":"LUXACIÓN EXPUESTA DE HUESO NAVICULAR DE PIE"
  },
  {
    "codigo":109534000,
    "descripcion":"EXFOLIACIÓN PRECOZ DE DIENTES DEBIDA A RESORCIÓN DE LA RAÍZ DESPUÉS DE TRAUMATISMO"
  },
  {
    "codigo":16908641000119109,
    "descripcion":"PAPILOMA DE PIEL DE PÁRPADO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":334331000119103,
    "descripcion":"VASCULARIZACIÓN LOCALIZADA DE CÓRNEA DERECHA"
  },
  {
    "codigo":240606006,
    "descripcion":"DONOVANOSIS - ÚLCERA ANOGENITAL"
  },
  {
    "codigo":402611000,
    "descripcion":"HIPERMELANOSIS POR TRASTORNO ENDOCRINO"
  },
  {
    "codigo":699358009,
    "descripcion":"SARCOMA DE ESTROMA ENDOMETRIAL DE ALTO GRADO"
  },
  {
    "codigo":304307002,
    "descripcion":"AMPLITUD DE MOVIMIENTO DE LOS DEDOS DE LA MANO NORMAL"
  },
  {
    "codigo":72161000119100,
    "descripcion":"SÍNDROME ANTIFOSFOLIPÍDICO EN EL EMBARAZO"
  },
  {
    "codigo":16476641000119100,
    "descripcion":"FÍSTULA ARTERIOVENOSA ADQUIRIDA DE DURAMADRE DE CEREBRO"
  },
  {
    "codigo":1080801000119102,
    "descripcion":"HISTIOCITOMA FIBROSO MALIGNO PRIMARIO DE PARTES BLANDAS DE EXTREMIDAD SUPERIOR IZQUIERDA"
  },
  {
    "codigo":238771006,
    "descripcion":"VÁRICES PALMARES"
  },
  {
    "codigo":340961000119102,
    "descripcion":"DOBLE PTERIGIÓN DE OJO IZQUIERDO"
  },
  {
    "codigo":15698401000119105,
    "descripcion":"INFLAMACIÓN DE HUESO DE MITAD IZQUIERDA DE PELVIS Y MITAD DERECHA DE PELVIS"
  },
  {
    "codigo":15726561000119105,
    "descripcion":"ANQUILOSIS DE ARTICULACIÓN DE DEDO DE MANO DERECHA"
  },
  {
    "codigo":1252744003,
    "descripcion":"SUBLUXACIÓN ANTERIOR DE ARTICULACIÓN ESTERNOCLAVICULAR"
  },
  {
    "codigo":10806241000119108,
    "descripcion":"TALASEMIA EN LA MADRE QUE COMPLICA EL NACIMIENTO"
  },
  {
    "codigo":307681000119105,
    "descripcion":"DISPLASIA FIBROSA MONOSTÓTICA DE HUESO DE CINTURA ESCAPULAR IZQUIERDA"
  },
  {
    "codigo":348641000119106,
    "descripcion":"RUPTURA DE CÁPSULA POSTERIOR DE CRISTALINO IZQUIERDO DURANTE PROCEDIMIENTO QUIRÚRGICO"
  },
  {
    "codigo":61921000119107,
    "descripcion":"CAMBIO DE PERSONALIDAD DEBIDO A TRASTORNO ORGÁNICO"
  },
  {
    "codigo":330721000119106,
    "descripcion":"COMPRESIÓN DE NERVIO PERONEO SUPERFICIAL DERECHO"
  },
  {
    "codigo":11781601000119105,
    "descripcion":"LESIÓN TRAUMÁTICA DE VENA FEMORAL IZQUIERDA"
  },
  {
    "codigo":1078241000119108,
    "descripcion":"CÚBITO VALGO CONGÉNITO IZQUIERDO"
  },
  {
    "codigo":128481000119107,
    "descripcion":"IMPLANTE ANTICONCEPTIVO EN TROMPA DE FALOPIO IN SITU"
  },
  {
    "codigo":305121000119107,
    "descripcion":"CIFOSIS CERVICODORSAL CONGÉNITA"
  },
  {
    "codigo":323041000119109,
    "descripcion":"LONGITUD DESIGUAL DE EXTREMIDAD INFERIOR DEBIDA A ACORTAMIENTO ADQUIRIDO DE FÉMUR IZQUIERDO"
  },
  {
    "codigo":431709001,
    "descripcion":"ABSCESO PILONIDAL DEL SURCO INTERGLÚTEO"
  },
  {
    "codigo":202333005,
    "descripcion":"DESGARRO DE FIBROCARTÍLAGO TRIANGULAR"
  },
  {
    "codigo":169565003,
    "descripcion":"EMBARAZO PLANEADO"
  },
  {
    "codigo":1281842000,
    "descripcion":"ESPECTRO DE TRASTORNOS DEL MOVIMIENTO, CRISIS Y RETRASO DEL DESARROLLO ASOCIADO A GEN GNAO1"
  },
  {
    "codigo":726621009,
    "descripcion":"SÍNDROME DE APÉNDICE CAUDAL Y SORDERA"
  },
  {
    "codigo":366173004,
    "descripcion":"FUNCIÓN DEL NÓDULO SINUSAL - HALLAZGO"
  },
  {
    "codigo":300637008,
    "descripcion":"NO MANEJA UN AUTO"
  },
  {
    "codigo":5725006,
    "descripcion":"EXOTROPÍA MONOCULAR"
  },
  {
    "codigo":167730007,
    "descripcion":"ANÁLISIS BIOQUÍMICO DE LÍQUIDO CEFALORRAQUÍDEO FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":724786008,
    "descripcion":"EPILEPSIA DEBIDA A LESIÓN CEREBRAL ANOXICOISQUÉMICA PERINATAL"
  },
  {
    "codigo":298802008,
    "descripcion":"SIN AMPLITUD DE MOVIMIENTO ACTIVO DE ABDUCCIÓN DE HOMBRO"
  },
  {
    "codigo":198663000,
    "descripcion":"ABORTO ESPONTÁNEO COMPLETO CON EMBOLIA"
  },
  {
    "codigo":2055003,
    "descripcion":"EROSIÓN RECURRENTE DE CÓRNEA"
  },
  {
    "codigo":788487003,
    "descripcion":"TRASTORNO REPETITIVO DEL MOVIMIENTO DE AMBAS MANOS"
  },
  {
    "codigo":296967006,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE ÁCIDO FÓLICO"
  },
  {
    "codigo":67591007,
    "descripcion":"INADAPTACIÓN ESCOLAR"
  },
  {
    "codigo":1148935009,
    "descripcion":"NEFROBLASTOMA QUÍSTICO PARCIALMENTE DIFERENCIADO"
  },
  {
    "codigo":32988004,
    "descripcion":"FRACTURA EXPUESTA DE SITIOS MÚLTIPLES DE LAS FALANGES DE LA MANO"
  },
  {
    "codigo":31153000,
    "descripcion":"FORMA DE UNA COLONIA BACTERIANA, FILAMENTOSA"
  },
  {
    "codigo":16665391000119102,
    "descripcion":"FRACTURA EXPUESTA DE PARED INTERNA DE ÓRBITA DERECHA"
  },
  {
    "codigo":1208966001,
    "descripcion":"CRISIS EPILÉPTICA MOTORA DE INICIO GENERALIZADO"
  },
  {
    "codigo":11832111000119103,
    "descripcion":"LESIÓN TRAUMÁTICA DE VASO SANGUÍNEO DE DEDO ANULAR DE MANO DERECHA"
  },
  {
    "codigo":291462008,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR CICLOGUANIL"
  },
  {
    "codigo":94854009,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL GLOMO YUGULAR"
  },
  {
    "codigo":191323001,
    "descripcion":"TROMBOCITOPENIA POR CIRCULACIÓN SANGUÍNEA EXTRACORPÓREA"
  },
  {
    "codigo":846683001,
    "descripcion":"INFARTO AGUDO DE MIOCARDIO CON ELEVACIÓN DE SEGMENTO ST DEBIDO A OCLUSIÓN DE ARTERIA INTERMEDIA"
  },
  {
    "codigo":1010523005,
    "descripcion":"ESCLEROSIS DE EPÍFISIS DE FALANGE DE QUINTO DEDO DE PIE CON RADIOPACIDAD AUMENTADA"
  },
  {
    "codigo":289627006,
    "descripcion":"FONDO UTERINO A NIVEL UMBILICAL"
  },
  {
    "codigo":93019008,
    "descripcion":"ANOMALÍA CONGÉNITA DEL PREMAXILAR"
  },
  {
    "codigo":224091008,
    "descripcion":"FAMILIARES MÁS CERCANOS"
  },
  {
    "codigo":255024002,
    "descripcion":"NEVO DE MEMBRANA COROIDES"
  },
  {
    "codigo":189488006,
    "descripcion":"NEOPLASIA DE CEREBRO DE COMPORTAMIENTO INCIERTO O DESCONOCIDO, INFRATENTORIAL"
  },
  {
    "codigo":123952009,
    "descripcion":"TRASTORNO DE LA NASOFARINGE"
  },
  {
    "codigo":23813004,
    "descripcion":"FRACTURA EXPUESTA DEL EXTREMO PROXIMAL DEL RADIO"
  },
  {
    "codigo":449797005,
    "descripcion":"HEMATOMA NO TRAUMÁTICO DE ESPACIO SUBDURAL DEL NEUROEJE"
  },
  {
    "codigo":117551000119108,
    "descripcion":"VACIAMIENTO INCOMPLETO DE VEJIGA URINARIA DEBIDO A HIPERTROFIA PROSTÁTICA BENIGNA"
  },
  {
    "codigo":1074121000119102,
    "descripcion":"CONDROCALCINOSIS DE MANO DERECHA"
  },
  {
    "codigo":943590191000119108,
    "descripcion":"LACERACIÓN DE VENA FEMORAL"
  },
  {
    "codigo":253189008,
    "descripcion":"DISGENESIA SACRA"
  },
  {
    "codigo":284122003,
    "descripcion":"CAPAZ DE CONTROLAR LA POSICIÓN DEL TRONCO"
  },
  {
    "codigo":285957007,
    "descripcion":"DIFICULTAD PARA INSERTAR EL TAPÓN DE LA PILETA"
  },
  {
    "codigo":218586005,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR SUSTITUTOS MACROMOLECULARES DE LA SANGRE"
  },
  {
    "codigo":21978005,
    "descripcion":"SÍNDROME MEDULAR ANTERIOR DEBIDO A FRACTURA EXPUESTA A NIVEL DE C1-C4"
  },
  {
    "codigo":187653008,
    "descripcion":"NEOPLASIA MALIGNA DE PISO LATERAL DE BOCA"
  },
  {
    "codigo":54746005,
    "descripcion":"EROTOFOBIA"
  },
  {
    "codigo":216751001,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ÁCIDO CLORHÍDRICO"
  },
  {
    "codigo":20143001,
    "descripcion":"BLOQUEO BILATERAL DE LAS RAMAS DEL HAZ DE HIS"
  },
  {
    "codigo":710106005,
    "descripcion":"TUBERCULOSIS EXTENSAMENTE RESISTENTE"
  },
  {
    "codigo":447962009,
    "descripcion":"AURÍCULA IZQUIERDA DIVIDIDA CON TRACTO DE SALIDA RESTRICTIVO DE LA CÁMARA PROXIMAL A LA AURÍCULA IZQUIERDA"
  },
  {
    "codigo":249519007,
    "descripcion":"DIARREA Y VÓMITOS"
  },
  {
    "codigo":870276004,
    "descripcion":"BRONQUITIS PLÁSTICA DESPUÉS DE PROCEDIMIENTO CARDÍACO"
  },
  {
    "codigo":1263492008,
    "descripcion":"MIELITIS DEBIDA A VASCULITIS"
  },
  {
    "codigo":247684008,
    "descripcion":"DELIRIO DE CATÁSTROFE"
  },
  {
    "codigo":278617002,
    "descripcion":"CAÍDA DE DIENTE DE PRÓTESIS DENTAL"
  },
  {
    "codigo":737369003,
    "descripcion":"BÚSQUEDA DE SENSACIONES"
  },
  {
    "codigo":213081005,
    "descripcion":"MOVILIDAD DE PRÓTESIS"
  },
  {
    "codigo":1359961006,
    "descripcion":"HERIDA ABIERTA DE DEDO MEDIO DEBIDA A MORDEDURA DE GATO"
  },
  {
    "codigo":735534000,
    "descripcion":"INFECCIÓN DE SISTEMA NERVIOSO CENTRAL CAUSADA POR ECHINOCOCCUS"
  },
  {
    "codigo":1259822003,
    "descripcion":"CÁNCER DE PULMÓN NO MICROCÍTICO PRIMARIO NEGATIVO PARA ONCOGÉN DE FUSIÓN ALK (CINASA DE LINFOMA ANAPLÁSICO)"
  },
  {
    "codigo":80174007,
    "descripcion":"FACIES HURLOIDE"
  },
  {
    "codigo":12803000,
    "descripcion":"GRAN AUMENTO DE PESO MATERNO"
  },
  {
    "codigo":897539005,
    "descripcion":"ANOMALÍA CONGÉNITA DE CÓCLEA"
  },
  {
    "codigo":45571007,
    "descripcion":"INTOXICACIÓN POR NICOTIANA TABACUM"
  },
  {
    "codigo":830168000,
    "descripcion":"ALERGIA A ESTRONA"
  },
  {
    "codigo":274947007,
    "descripcion":"AURÍCULA DERECHA DIVIDIDA"
  },
  {
    "codigo":109272006,
    "descripcion":"MELANOMA IN SITU DE LABIO"
  },
  {
    "codigo":240344008,
    "descripcion":"INTOXICACIÓN ALIMENTARIA PARASITARIA"
  },
  {
    "codigo":43736008,
    "descripcion":"INSUFICIENCIA VENTRICULAR IZQUIERDA REUMÁTICA"
  },
  {
    "codigo":1156013003,
    "descripcion":"REACCIÓN ADVERSA A ANESTÉSICO INHALATORIO CON ESTRUCTURA ÉTER"
  },
  {
    "codigo":74669004,
    "descripcion":"CIRROSIS CARDÍACA"
  },
  {
    "codigo":9133005,
    "descripcion":"POLINEUROPATÍA AMILOIDE FAMILIAR, TIPO IOWA"
  },
  {
    "codigo":238509006,
    "descripcion":"SABAÑÓN PUSTULAR"
  },
  {
    "codigo":402349005,
    "descripcion":"LIQUEN PLANO CRÓNICO"
  },
  {
    "codigo":1285250005,
    "descripcion":"HALLAZGO RELACIONADO CON AMPLITUD DE MOVIMIENTO DE DORSIFLEXIÓN DE TOBILLO"
  },
  {
    "codigo":105602005,
    "descripcion":"ANORMALIDAD CUANTITATIVA DE GRANULOCITOS"
  },
  {
    "codigo":300375001,
    "descripcion":"CAPAZ DE DEFECAR"
  },
  {
    "codigo":398679002,
    "descripcion":"PAPULOSIS BOWENOIDE DE PENE"
  },
  {
    "codigo":365911002,
    "descripcion":"MEMORIA DE LA PROPIA FECHA DE NACIMIENTO - HALLAZGO"
  },
  {
    "codigo":726359007,
    "descripcion":"TRISOMÍA PARCIAL DE BRAZO CORTO DE CROMOSOMA 19"
  },
  {
    "codigo":267607008,
    "descripcion":"PARÁLISIS PERIÓDICA FAMILIAR"
  },
  {
    "codigo":724524006,
    "descripcion":"PÓLIPO HAMARTOMATOSO DE ESTÓMAGO"
  },
  {
    "codigo":460545002,
    "descripcion":"ATRESIA CONGÉNITA DE ORIFICIO DE ARTERIA CORONARIA DERECHA"
  },
  {
    "codigo":427777003,
    "descripcion":"ENFERMEDAD PULMONAR RESTRICTIVA CAUSADA POR DISTROFIA MUSCULAR"
  },
  {
    "codigo":722689005,
    "descripcion":"MELANOMA IN SITU DE CONJUNTIVA"
  },
  {
    "codigo":1148673006,
    "descripcion":"SOBREDOSIS INTENCIONAL DE ANFETAMINA Y\/O DERIVADO DE ANFETAMINA"
  },
  {
    "codigo":296705007,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE CEFAMANDOL"
  },
  {
    "codigo":198401009,
    "descripcion":"SÍNTOMAS DE LOS ÓRGANOS GENITALES FEMENINOS"
  },
  {
    "codigo":131030003,
    "descripcion":"OXITOCINA ANORMAL"
  },
  {
    "codigo":11671000119103,
    "descripcion":"CONTRACTURA DE CUELLO DE VEJIGA URINARIA"
  },
  {
    "codigo":1076631000119103,
    "descripcion":"TENDINITIS DE ADUCTOR DE LA CADERA DERECHA"
  },
  {
    "codigo":360406006,
    "descripcion":"DAÑO UNGUEAL INDUCIDO POR ARSÉNICO"
  },
  {
    "codigo":719019000,
    "descripcion":"SÍNDROME WT EXTREMIDADES-SANGRE"
  },
  {
    "codigo":260267004,
    "descripcion":"N6"
  },
  {
    "codigo":293035004,
    "descripcion":"REACCIÓN ADVERSA AL FTALILSULFATIAZOL"
  },
  {
    "codigo":1145003007,
    "descripcion":"HIPERSENSIBILIDAD A VACUNA ARNM CONTRA SARS-COV-2"
  },
  {
    "codigo":422272001,
    "descripcion":"HALLAZGO OCULAR ECOGRÁFICO"
  },
  {
    "codigo":94592002,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE PARTES BLANDAS DEL PERINEO"
  },
  {
    "codigo":127360003,
    "descripcion":"CANTIDAD DE SUSTANCIA FISIOLÓGICA FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":225664001,
    "descripcion":"NO RECONOCE FOTOGRAFÍAS DE SÍ MISMO"
  },
  {
    "codigo":782720005,
    "descripcion":"HIPOPLASIA PONTOCEREBELOSA CONGÉNITA TIPO 10"
  },
  {
    "codigo":61824005,
    "descripcion":"INFECCIÓN CAUSADA POR STILESIA HEPATICA"
  },
  {
    "codigo":717184007,
    "descripcion":"QUERATODERMIA PALMOPLANTAR PUNTEADA TIPO 1"
  },
  {
    "codigo":59989004,
    "descripcion":"INFESTACIÓN CAUSADA POR DERMATOBIA HOMINIS"
  },
  {
    "codigo":289365005,
    "descripcion":"HALLAZGO RELACIONADO CON UNA POSICIÓN ANÓMALA DEL FETO"
  },
  {
    "codigo":92757006,
    "descripcion":"CARCINOMA IN SITU DE LA SUBGLOTIS"
  },
  {
    "codigo":15986071000119108,
    "descripcion":"ANOMALÍA CONGÉNITA DE PUPILA DERECHA"
  },
  {
    "codigo":11781681000119102,
    "descripcion":"LACERACIÓN DE VENA FEMORAL IZQUIERDA"
  },
  {
    "codigo":418602001,
    "descripcion":"ECTROPIÓN DEL PUNTO LAGRIMAL"
  },
  {
    "codigo":254762002,
    "descripcion":"NEUROFIBROMA ESTORIFORME CUTÁNEO"
  },
  {
    "codigo":1303338003,
    "descripcion":"GLAUCOMA POR CIERRE ANGULAR PRIMARIO DE OJO DERECHO"
  },
  {
    "codigo":713514005,
    "descripcion":"DEBILIDAD MUSCULAR DE MIEMBRO"
  },
  {
    "codigo":58154005,
    "descripcion":"FRACTURA EXPUESTA DE CUATRO COSTILLAS"
  },
  {
    "codigo":283860002,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO EN EL PERINEO"
  },
  {
    "codigo":251092003,
    "descripcion":"PARO SINUSAL CON ESCAPE AURICULAR"
  },
  {
    "codigo":15713841000119106,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE CADERA IZQUIERDA"
  },
  {
    "codigo":1332436006,
    "descripcion":"HIPERTENSIÓN EN ENFERMEDAD RENAL CRÓNICA EN ESTADIO 3B DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":447700007,
    "descripcion":"VENTANA AORTOPULMONAR DISTAL CON BORDE SUPERIOR MÍNIMO"
  },
  {
    "codigo":185556008,
    "descripcion":"NUEVO LLAMADO POSTERGADO"
  },
  {
    "codigo":118185001,
    "descripcion":"HALLAZGO RELACIONADO CON EL EMBARAZO"
  },
  {
    "codigo":87252009,
    "descripcion":"POLIPOSIS GÁSTRICA"
  },
  {
    "codigo":282025003,
    "descripcion":"QUISTE DE LABIOS DE LA VULVA"
  },
  {
    "codigo":19881001,
    "descripcion":"PSEUDO-OBSTRUCCIÓN CRÓNICA PRIMARIA DEL INTESTINO DELGADO"
  },
  {
    "codigo":183721005,
    "descripcion":"CONSULTA DOMICILIARIA DE ONCOLOGÍA SOLICITADA"
  },
  {
    "codigo":11863601000119106,
    "descripcion":"CONTUSIÓN DE DEDO DE PIE IZQUIERDO"
  },
  {
    "codigo":1363369008,
    "descripcion":"CAMA PARA PACIENTE INTERNADO NO DISPONIBLE"
  },
  {
    "codigo":247422001,
    "descripcion":"ORGASMO DOLOROSO"
  },
  {
    "codigo":312958000,
    "descripcion":"RETINOPATÍA POR CLOROQUINA"
  },
  {
    "codigo":249257008,
    "descripcion":"CAPUCHÓN PREPUCIAL"
  },
  {
    "codigo":83582003,
    "descripcion":"INFECCIÓN CAUSADA POR CABALLONEMA"
  },
  {
    "codigo":1197694007,
    "descripcion":"VÁRICES ESOFÁGICAS SANGRANTES POR HEPATOPATÍA TÓXICA"
  },
  {
    "codigo":704339000,
    "descripcion":"FRACTURA OSTEOPORÓTICA DE CÚBITO"
  },
  {
    "codigo":47144000,
    "descripcion":"NEUTROFILIA AGUDA"
  },
  {
    "codigo":1163091008,
    "descripcion":"QUISTE CEREBELOSO INFECCIOSO"
  },
  {
    "codigo":1259560001,
    "descripcion":"MIOPATÍA CONGÉNITA MULTIFOCAL CON OFTALMOPLEJÍA EXTERNA"
  },
  {
    "codigo":11810661000119100,
    "descripcion":"RUPTURA TRAUMÁTICA DE TENDÓN DE REGIÓN DE CADERA IZQUIERDA"
  },
  {
    "codigo":341861000119100,
    "descripcion":"CATARATA NEGRA DE OJO IZQUIERDO"
  },
  {
    "codigo":897277000,
    "descripcion":"EPIGNATO CONGÉNITO"
  },
  {
    "codigo":405757001,
    "descripcion":"LESIÓN MEDULAR CERVICAL CENTRAL SIN LESIÓN OSTEOVERTEBRAL, C1-C4"
  },
  {
    "codigo":276520008,
    "descripcion":"ÍLEO TRANSITORIO DEL PREMATURO"
  },
  {
    "codigo":209149003,
    "descripcion":"SUBLUXACIÓN NO EXPUESTA DE MÚLTIPLES VÉRTEBRAS CERVICALES"
  },
  {
    "codigo":372989004,
    "descripcion":"INFECCIÓN CAUSADA POR ASPERGILLUS NONATUM"
  },
  {
    "codigo":471293003,
    "descripcion":"ORIGEN ANÓMALO DE ART. DESCENDENTE ANTERIOR IZQUIERDA Y ART. CORONARIA DERECHA EN SENO AÓRTICO A LA DERECHA DE SENO AÓRTICO NO ENFRENTADO Y ORIGEN ANÓMALO DE ART. CIRCUNFLEJA EN SENO AÓRTICO A LA IZQUIERDA DE SENO AÓRTICO NO ENFRENTADO"
  },
  {
    "codigo":1290493007,
    "descripcion":"TRASTORNO DE TENDÓN DE REGIÓN DE TOBILLO"
  },
  {
    "codigo":274685007,
    "descripcion":"HALLAZGO CITOLÓGICO ANORMAL EN ESPÉCIMEN DE ÓRGANO GENITAL MASCULINO"
  },
  {
    "codigo":305618002,
    "descripcion":"BAJO ATENCIÓN DE LOGOTERAPEUTA HOSPITALARIO"
  },
  {
    "codigo":10706006,
    "descripcion":"TUBERCULOSIS DEL SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":240082006,
    "descripcion":"MIOPATÍA CON ANORMALIDAD DEL TIPO DE FIBRA HISTOQUÍMICA"
  },
  {
    "codigo":403922007,
    "descripcion":"MELANOMA MALIGNO CON CÉLULAS EN BALÓN"
  },
  {
    "codigo":1255890006,
    "descripcion":"LINFOMA DE HODGKIN, VARIANTE DEPLECIÓN LINFOCITARIA DE GANGLIOS LINFÁTICOS DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":762535004,
    "descripcion":"PIGMENTACIÓN DE MIEMBRO INFERIOR CON HEMOSIDERINA DEBIDA A VENAS VARICOSAS"
  },
  {
    "codigo":271015004,
    "descripcion":"INESTABILIDAD CONGÉNITA DE LA ARTICULACIÓN DE LA CADERA"
  },
  {
    "codigo":860839005,
    "descripcion":"MIOCARDIOPATÍA DEBIDA A ENFERMEDAD DE ALMACENAMIENTO"
  },
  {
    "codigo":236412002,
    "descripcion":"NEFROPATÍA C1Q"
  },
  {
    "codigo":7036007,
    "descripcion":"FROTE PERICÁRDICO"
  },
  {
    "codigo":365649001,
    "descripcion":"ERITROSEDIMENTACIÓN - HALLAZGO"
  },
  {
    "codigo":5201002,
    "descripcion":"HEMORROIDES ULCERADAS"
  },
  {
    "codigo":301948009,
    "descripcion":"REACCIÓN PUPILAR CERCANA TARDÍA"
  },
  {
    "codigo":234577004,
    "descripcion":"HISTIOCITOSIS POR LIPOCROMO - FAMILIAR"
  },
  {
    "codigo":1079141000119107,
    "descripcion":"CARCINOMA BASOCELULAR PRIMARIO DE PIEL DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":300113007,
    "descripcion":"PABELLÓN AURICULAR HIPOPIGMENTADO"
  },
  {
    "codigo":70737009,
    "descripcion":"MUCOPOLISACARIDOSIS, MPS - II"
  },
  {
    "codigo":429350001,
    "descripcion":"ARTROPATÍA DE ARTICULACIÓN CIGOAPOFISARIA VERTEBRAL"
  },
  {
    "codigo":298278003,
    "descripcion":"DEPÓSITO EN MÚSCULO ESQUELÉTICO"
  },
  {
    "codigo":1217617009,
    "descripcion":"SARCOMA DE KAPOSI DE PARTE INTERNA DE BOCA"
  },
  {
    "codigo":1531000,
    "descripcion":"INTOXICACIÓN CAUSADA POR DERIVADOS DE NITROFURANO"
  },
  {
    "codigo":427515002,
    "descripcion":"ESTENOSIS CRÍTICA DE VÁLVULA AÓRTICA"
  },
  {
    "codigo":296443006,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE TEOFILINA"
  },
  {
    "codigo":61562003,
    "descripcion":"INTOXICACIÓN POR LOLIUM PERENNE"
  },
  {
    "codigo":1306746005,
    "descripcion":"GLAUCOMA DE CÉLULAS FANTASMA DE OJO DERECHO DEBIDO A HEMORRAGIA INTRAOCULAR Y POSTERIOR A ELLA"
  },
  {
    "codigo":127098006,
    "descripcion":"LINFADENOPATÍA PREVERTEBRAL"
  },
  {
    "codigo":16754841000119103,
    "descripcion":"SANGRADO UTERINO ANORMAL POR NEOPLASIA ENDOMETRIAL INTRAEPITELIAL"
  },
  {
    "codigo":782458008,
    "descripcion":"HIPERHIDROSIS FOCAL PRIMARIA DE PALMA DE LA MANO IZQUIERDA"
  },
  {
    "codigo":94330007,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LOS GANGLIOS LINFÁTICOS HIPOGÁSTRICOS"
  },
  {
    "codigo":92495002,
    "descripcion":"OSIFICACIÓN BIPARTITA DE HUESO INTERPARIETAL"
  },
  {
    "codigo":715087003,
    "descripcion":"CAPAZ DE PASAR DE UNA SILLA DE RUEDAS A UN INODORO"
  },
  {
    "codigo":289103005,
    "descripcion":"CONTROLA LA RESPIRACIÓN"
  },
  {
    "codigo":25124003,
    "descripcion":"FALTA DE ATENCIÓN SELECTIVA"
  },
  {
    "codigo":125081000119106,
    "descripcion":"INFARTO CEREBRAL DEBIDO A OCLUSIÓN DE ARTERIA PRECEREBRAL"
  },
  {
    "codigo":1335844007,
    "descripcion":"REESTENOSIS DE ARTERIA CORONARIA POSTERIOR A INSERCIÓN DE STENT EN ARTERIA CORONARIA"
  },
  {
    "codigo":23289000,
    "descripcion":"VISIÓN ANORMAL DEL COLOR"
  },
  {
    "codigo":1137401000,
    "descripcion":"MIOTONÍA PARADÓJICA"
  },
  {
    "codigo":709582000,
    "descripcion":"COMPLICACIÓN ARTERIAL DE PROCEDIMIENTO"
  },
  {
    "codigo":88825008,
    "descripcion":"ANOMALÍA CONGÉNITA DEL CUELLO UTERINO"
  },
  {
    "codigo":250830004,
    "descripcion":"BLOQUEO NEUROMUSCULAR - HALLAZGO"
  },
  {
    "codigo":119741000146102,
    "descripcion":"CONJUNTIVITIS DEBIDA A COVID-19"
  },
  {
    "codigo":21454007,
    "descripcion":"HEMORRAGIA SUBARACNOIDEA INTRACRANEAL"
  },
  {
    "codigo":283598008,
    "descripcion":"HERIDA POR PINCHAZO DE AGUJA EN LA CABEZA"
  },
  {
    "codigo":1363107001,
    "descripcion":"ASTILLA EN ANO"
  },
  {
    "codigo":871587002,
    "descripcion":"MIOCARDITIS DEBIDA ENFERMEDAD DE CHAGAS"
  },
  {
    "codigo":609443003,
    "descripcion":"PRODUCTOS RETENIDOS DE LA CONCEPCIÓN DESPUÉS DE LA INTERRUPCIÓN INDUCIDA DEL EMBARAZO"
  },
  {
    "codigo":98611000119104,
    "descripcion":"SÍNDROME DE DOLOR CRÓNICO POSTORACOTOMÍA"
  },
  {
    "codigo":314531003,
    "descripcion":"QUEMADURA DEL SEGMENTO ANTERIOR DEL GLOBO OCULAR"
  },
  {
    "codigo":773283006,
    "descripcion":"NEOPLASIA MALIGNA DE CÉLULAS GERMINALES DEL CUELLO UTERINO"
  },
  {
    "codigo":707747007,
    "descripcion":"HIPERALDOSTERONISMO PSEUDOPRIMARIO"
  },
  {
    "codigo":344371000119104,
    "descripcion":"RETINITIS FOCAL DE POLO POSTERIOR DE AMBOS OJOS"
  },
  {
    "codigo":312696001,
    "descripcion":"SUSTANCIA DEL CRISTALINO RETENIDA EN EL CUERPO VÍTREO"
  },
  {
    "codigo":1197432002,
    "descripcion":"TELANGIECTASIA DE PIEL"
  },
  {
    "codigo":443768001,
    "descripcion":"RIÑÓN IZQUIERDO AUSENTE"
  },
  {
    "codigo":771448004,
    "descripcion":"SÍNDROME DE AUTISMO-EPILEPSIA POR DEFICIENCIA DE DESHIDROGENASA QUINASA DE CETOÁCIDOS DE CADENA RAMIFICADA"
  },
  {
    "codigo":1081651000119107,
    "descripcion":"RABDOMIOSARCOMA PRIMARIO DE EXTREMIDAD SUPERIOR DERECHA"
  },
  {
    "codigo":441933004,
    "descripcion":"DISTENSIÓN DE MÚSCULO Y\/O TENDÓN DE PIERNA"
  },
  {
    "codigo":46882000,
    "descripcion":"ENTEROCOLITIS ISQUÉMICA CRÓNICA"
  },
  {
    "codigo":1162829009,
    "descripcion":"DOLOR CRÓNICO DEL BOLSILLO PARA DISPOSITIVO ELECTRÓNICO CARDÍACO IMPLANTABLE POSTERIOR A SU IMPLANTE"
  },
  {
    "codigo":1259298002,
    "descripcion":"FORMACIÓN DE TEJIDO DURO EN SITIO DE FRACTURA DE RAÍZ DE DIENTE"
  },
  {
    "codigo":866082003,
    "descripcion":"MELANOMA MALIGNO DE SISTEMA DE DRENAJE LAGRIMAL"
  },
  {
    "codigo":14114003,
    "descripcion":"PSEUDOQUILOTÓRAX"
  },
  {
    "codigo":210722005,
    "descripcion":"LESIÓN POR DESOLLAMIENTO DE PIE, CARA DORSAL"
  },
  {
    "codigo":700407003,
    "descripcion":"REFLEJO PLANTAR NORMAL"
  },
  {
    "codigo":72141000119104,
    "descripcion":"ÚLCERA CRÓNICA DE PIEL DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":405495005,
    "descripcion":"PRESIÓN DE VÍA AÉREA ALTA"
  },
  {
    "codigo":208887003,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA DISTAL DE DEDO DE LA MANO"
  },
  {
    "codigo":77815007,
    "descripcion":"TRASTORNO DE LA IDENTIDAD SEXUAL DEL ADULTO, PREVIAMENTE HOMOSEXUAL"
  },
  {
    "codigo":764108000,
    "descripcion":"SÍNDROME DE PELO LANUDO CON QUERATODERMIA PALMOPLANTAR"
  },
  {
    "codigo":272588001,
    "descripcion":"DESNUTRICIÓN (CALÓRICA)"
  },
  {
    "codigo":1255628005,
    "descripcion":"RABDOMIOSARCOMA DE MIOMETRIO DE CUERPO DE ÚTERO"
  },
  {
    "codigo":239820007,
    "descripcion":"MONOARTRITIS INFLAMATORIA INDIFERENCIADA"
  },
  {
    "codigo":762273001,
    "descripcion":"PERFORACIÓN INTRAUTERINA DEL INTESTINO FETAL CONCOMITANTE CON ATRESIA CONGÉNITA DEL TRACTO INTESTINAL Y DEBIDA A ELLA"
  },
  {
    "codigo":205217002,
    "descripcion":"DEFICIENCIA PERONEA CONGÉNITA TIPO II"
  },
  {
    "codigo":16675431000119101,
    "descripcion":"ECOGRAFÍA DE AMBOS RIÑONES ANORMAL"
  },
  {
    "codigo":303521007,
    "descripcion":"CAPAZ DE PONERSE LA PELUCA"
  },
  {
    "codigo":317901000119108,
    "descripcion":"ARTRITIS NEUMOCÓCICA DE REGIÓN DE HOMBRO DERECHO"
  },
  {
    "codigo":399990001,
    "descripcion":"PAPULOSIS BOWENOIDE DE VULVA"
  },
  {
    "codigo":237985009,
    "descripcion":"SÍNDROME DE PEARSON"
  },
  {
    "codigo":203382004,
    "descripcion":"OSTEOCONDROSIS JUVENIL DE CABEZA DE HÚMERO"
  },
  {
    "codigo":299851002,
    "descripcion":"REFLEJO ABDOMINAL PRESENTE SÓLO CON SENSIBILIZACIÓN"
  },
  {
    "codigo":398155003,
    "descripcion":"UVEÍTIS ANTERIOR CRÓNICA"
  },
  {
    "codigo":365387002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA DESENVOLVERSE EN UN AMBIENTE FAMILIAR"
  },
  {
    "codigo":4939006,
    "descripcion":"ANEMIA HEMOLÍTICA POR NEOPLASIA NO LINFOIDE"
  },
  {
    "codigo":267083009,
    "descripcion":"SÍNTOMA DE INCOORDINACIÓN"
  },
  {
    "codigo":298016002,
    "descripcion":"PELVIS CONGELADA NO MALIGNA, MASCULINA"
  },
  {
    "codigo":166944003,
    "descripcion":"NIVEL DE FENITOÍNA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":68640004,
    "descripcion":"ULCERACIÓN DE LA VULVA"
  },
  {
    "codigo":724000006,
    "descripcion":"SÍNDROME RETINOHEPATOENDOCRINOLÓGICO"
  },
  {
    "codigo":15665921000119100,
    "descripcion":"COALICIÓN TARSIANA BILATERAL"
  },
  {
    "codigo":34037000,
    "descripcion":"MICROANEURISMA DE ARTERIA DE LA RETINA"
  },
  {
    "codigo":230645003,
    "descripcion":"NEUROPATÍA DEL TRONCO POR COMPRESIÓN"
  },
  {
    "codigo":296181007,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE BENPERIDOL"
  },
  {
    "codigo":64970000,
    "descripcion":"TIPO DE SUSTANCIA DESCONOCIDA"
  },
  {
    "codigo":294346002,
    "descripcion":"ALERGIA A AMOROLFINA"
  },
  {
    "codigo":425418002,
    "descripcion":"INFECCIÓN GENERALIZADA POR HISTOPLASMA CAPSULATUM"
  },
  {
    "codigo":346881000119103,
    "descripcion":"RUPTURA DE COROIDES DE AMBOS OJOS"
  },
  {
    "codigo":95903000,
    "descripcion":"AUSENCIA DE REACCIÓN A UN FÁRMACO"
  },
  {
    "codigo":194207002,
    "descripcion":"OTITIS EXTERNA CRÓNICA POR ASPERGILOSIS"
  },
  {
    "codigo":718495005,
    "descripcion":"VÍCTIMA ADULTA DE ABUSO SEXUAL DURANTE EL SERVICIO MILITAR"
  },
  {
    "codigo":63135006,
    "descripcion":"AMIOTONÍA CONGÉNITA"
  },
  {
    "codigo":126836001,
    "descripcion":"NEOPLASIA DEL DIVERTÍCULO DE MECKEL"
  },
  {
    "codigo":94068003,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA MÉDULA ESPINAL"
  },
  {
    "codigo":388980004,
    "descripcion":"DEBILIDAD DEL TERCER PAR CRANEAL"
  },
  {
    "codigo":61300005,
    "descripcion":"ÚLCERA PÉPTICA CRÓNICA CON HEMORRAGIA Y PERFORACIÓN"
  },
  {
    "codigo":290676006,
    "descripcion":"INTOXICACIÓN POR ÓXIDO MERCÚRICO"
  },
  {
    "codigo":716660007,
    "descripcion":"INFECCIÓN CONGÉNITA CAUSADA POR VIRUS DE EPSTEIN-BARR"
  },
  {
    "codigo":714825002,
    "descripcion":"HEMATURIA RECURRENTE CONCOMITANTE CON GLOMERULONEFRITIS MESANGIAL PROLIFERATIVA DIFUSA Y DEBIDA A ELLA"
  },
  {
    "codigo":206216003,
    "descripcion":"LUXACIÓN OBSTÉTRICA DE HOMBRO"
  },
  {
    "codigo":92233005,
    "descripcion":"NEOPLASIA BENIGNA DE MÚSCULO DE HOMBRO"
  },
  {
    "codigo":418078000,
    "descripcion":"MOVIMIENTO OCULAR HACIA ABAJO LIMITADO"
  },
  {
    "codigo":57630001,
    "descripcion":"PRIMER TRIMESTRE DEL EMBARAZO"
  },
  {
    "codigo":385310004,
    "descripcion":"MARGEN MUCOSO DISTAL DE RESECCIÓN QUIRÚRGICA, AFECTADO POR CARCINOMA IN SITU"
  },
  {
    "codigo":450846005,
    "descripcion":"ENURESIS NOCTURNA SECUNDARIA"
  },
  {
    "codigo":287006005,
    "descripcion":"ARTRITIS REUMATOIDE DE MÚLTIPLES ARTICULACIONES"
  },
  {
    "codigo":285171000,
    "descripcion":"INCAPAZ DE RECONOCER CARAS"
  },
  {
    "codigo":449011000,
    "descripcion":"FENESTRACIÓN DE VALVA DE VÁLVULA AURICULOVENTRICULAR EN DEFECTO DEL TABIQUE AURICULOVENTRICULAR"
  },
  {
    "codigo":186867005,
    "descripcion":"SÍFILIS INICIAL LATENTE"
  },
  {
    "codigo":711155008,
    "descripcion":"TRASTORNO CONGÉNITO DE LA GLICOSILACIÓN ALG12"
  },
  {
    "codigo":283336005,
    "descripcion":"PICADURA DE INSECTO EN EL TRONCO"
  },
  {
    "codigo":320411000119106,
    "descripcion":"ARTROSIS SECUNDARIA DE MUÑECA DERECHA"
  },
  {
    "codigo":445341001,
    "descripcion":"EDEMA INDURADO CON FÓVEA"
  },
  {
    "codigo":248733001,
    "descripcion":"EXAGERACIÓN DE LA ONDA \"V\" DE LA PRESIÓN VENOSA YUGULAR"
  },
  {
    "codigo":1297309003,
    "descripcion":"CELULITIS DE DEDO DE PIE IZQUIERDO"
  },
  {
    "codigo":53960009,
    "descripcion":"AMPOLLAS POR FRICCIÓN DE LA PLANTA DEL PIE"
  },
  {
    "codigo":707485006,
    "descripcion":"CARCINOMA ADENOESCAMOSO PRIMARIO DE HIPOFARINGE"
  },
  {
    "codigo":314269007,
    "descripcion":"MEMBRANA COROIDEA NEOVASCULAR IDIOPÁTICA"
  },
  {
    "codigo":52125007,
    "descripcion":"CONVULSIÓN GUSTATIVA"
  },
  {
    "codigo":115826001,
    "descripcion":"FENOTIPO LUTHERAN NEGATIVO ADQUIRIDO"
  },
  {
    "codigo":771186004,
    "descripcion":"SÍNDROME DE POIQUILODERMIA, ALOPECIA, RETROGNATISMO Y FISURA PALATINA"
  },
  {
    "codigo":246898005,
    "descripcion":"FLICTENA DE CONJUNTIVA DE LIMBO"
  },
  {
    "codigo":1229938006,
    "descripcion":"ATROFIA DE GLOBO OCULAR"
  },
  {
    "codigo":1162567000,
    "descripcion":"ÍLEO PARALÍTICO POSQUIRÚRGICO"
  },
  {
    "codigo":277831002,
    "descripcion":"ANGUSTIA POR ENGORDAR"
  },
  {
    "codigo":48455005,
    "descripcion":"SÍNDROME DEL PISO ORBITARIO"
  },
  {
    "codigo":310599006,
    "descripcion":"NEOPLASIA MALIGNA DEL CANTO DEL OJO"
  },
  {
    "codigo":212295006,
    "descripcion":"LESIÓN DE NERVIO INTERCOSTOBRAQUIAL"
  },
  {
    "codigo":15687005,
    "descripcion":"QUEMADURA PROFUNDA DE TERCER GRADO DE LA EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":110321001,
    "descripcion":"OCLUSIÓN DENTAL DE BORDE A BORDE"
  },
  {
    "codigo":44785005,
    "descripcion":"GLOMERULOPATÍA CON CAMBIOS MÍNIMOS"
  },
  {
    "codigo":208625006,
    "descripcion":"FRACTURA EXPUESTA DEL CUELLO DEL PERONÉ"
  },
  {
    "codigo":77553008,
    "descripcion":"DEGENERACIÓN OPTICOCOCLEODENTADA"
  },
  {
    "codigo":12017008,
    "descripcion":"AUSENCIA CONGÉNITA DE OVARIO"
  },
  {
    "codigo":403398009,
    "descripcion":"PIEL LAXA LUEGO DE URTICARIA-ANGIOEDEMA"
  },
  {
    "codigo":1157062009,
    "descripcion":"GLIOBLASTOMA DE CÉLULAS GIGANTES DEL SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":10753231000119104,
    "descripcion":"RUPTURA PREMATURA DE MEMBRANAS EN EMBARAZO A TÉRMINO CON COMIENZO DEL TRABAJO DE PARTO MÁS DE 24 HORAS DESPUÉS DE LA RUPTURA"
  },
  {
    "codigo":1351835006,
    "descripcion":"SÍNDROME DE BROWN-SÉQUARD DEBIDO A ENFERMEDAD POR DESCOMPRESIÓN"
  },
  {
    "codigo":73883007,
    "descripcion":"PROTEINURIA DE EMULSIÓN"
  },
  {
    "codigo":41115008,
    "descripcion":"HIPERPIGMENTACIÓN DE PÁRPADO"
  },
  {
    "codigo":237723009,
    "descripcion":"COMPRESIÓN DEL TALLO HIPOFISARIO"
  },
  {
    "codigo":270491006,
    "descripcion":"SALPINGITIS DE TROMPA DE EUSTAQUIO"
  },
  {
    "codigo":72048003,
    "descripcion":"APENDICITIS AGUDA SIN PERITONITIS"
  },
  {
    "codigo":235888006,
    "descripcion":"COLESTASIS DEL EMBARAZO"
  },
  {
    "codigo":268656007,
    "descripcion":"LESIÓN SECUNDARIA DE FRAMBESIA"
  },
  {
    "codigo":301424008,
    "descripcion":"DOLOR A LA PALPACIÓN POSTERIOR A PROCEDIMIENTO"
  },
  {
    "codigo":1153392009,
    "descripcion":"BAJA ESTATURA DEBIDA A OSTEOESCLEROSIS"
  },
  {
    "codigo":365125000,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA SUBIRSE Y BAJARSE DE LOS MUEBLES"
  },
  {
    "codigo":102981005,
    "descripcion":"REFLEJO NORMAL"
  },
  {
    "codigo":201285006,
    "descripcion":"LÉNTIGO - PECAS"
  },
  {
    "codigo":37445006,
    "descripcion":"CINCONISMO"
  },
  {
    "codigo":397893009,
    "descripcion":"MORBILIDAD CARDIOVASCULAR"
  },
  {
    "codigo":363290007,
    "descripcion":"TRASTORNO HEREDITARIO DEL APARATO REPRODUCTOR"
  },
  {
    "codigo":263151001,
    "descripcion":"FRACTURA NO EXPUESTA DE MAXILAR SUPERIOR"
  },
  {
    "codigo":295919005,
    "descripcion":"SOBREDOSIS DE SERTRALINA"
  },
  {
    "codigo":721903007,
    "descripcion":"SÍNDROME DE MICROCEFALIA, HIPOGAMMAGLOBULINEMIA, INMUNIDAD ANORMAL"
  },
  {
    "codigo":294084000,
    "descripcion":"ALERGIA A ORFENADRINA"
  },
  {
    "codigo":425156006,
    "descripcion":"INDUCCIÓN FARMACOLÓGICA DE ENZIMA CYP1A2 DEL CITOCROMO P450"
  },
  {
    "codigo":195780008,
    "descripcion":"FARINGITIS SECA"
  },
  {
    "codigo":1176985001,
    "descripcion":"NEUMOTÓRAX ESPONTÁNEO DEBIDO A INFECCIÓN POR PNEUMOCYSTIS JIROVECII"
  },
  {
    "codigo":11791721000119107,
    "descripcion":"LESIÓN TRAUMÁTICA DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":292249005,
    "descripcion":"REACCIÓN ADVERSA AL FORMESTANO"
  },
  {
    "codigo":30105008,
    "descripcion":"DIETA PARA INSUFICIENCIA RENAL AGUDA"
  },
  {
    "codigo":95641009,
    "descripcion":"TRASTORNO DEL MESENCÉFALO"
  },
  {
    "codigo":126574001,
    "descripcion":"NEOPLASIA DE HUESO PISIFORME DE REGIÓN DE MUÑECA"
  },
  {
    "codigo":716398003,
    "descripcion":"CAPAZ DE LLEVAR A CABO LA RUTINA DIARIA"
  },
  {
    "codigo":192110004,
    "descripcion":"TRASTORNO DE MIEDO EN LA INFANCIA Y ADOLESCENCIA"
  },
  {
    "codigo":93806005,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE HUESO FRONTAL"
  },
  {
    "codigo":290414005,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR NABILONA"
  },
  {
    "codigo":132611000119104,
    "descripcion":"TROMBOSIS AGUDA DE VENA SUBCLAVIA"
  },
  {
    "codigo":91971005,
    "descripcion":"NEOPLASIA BENIGNA DE CONDUCTO ANAL"
  },
  {
    "codigo":26435006,
    "descripcion":"DERMATITIS AGUDA"
  },
  {
    "codigo":288579009,
    "descripcion":"DIFICULTAD PARA COMUNICARSE"
  },
  {
    "codigo":286744001,
    "descripcion":"RASGO DE LA PERSONALIDAD: NIVEL DE OPTIMISMO - HALLAZGO"
  },
  {
    "codigo":253976003,
    "descripcion":"CONTRACTURA DE MÚSCULO ESTERNOCLEIDOMASTOIDEO"
  },
  {
    "codigo":712728006,
    "descripcion":"PÓLIPO DE COLON DESCENDENTE"
  },
  {
    "codigo":1237016007,
    "descripcion":"CON RIESGO ELEVADO DE EXPOSICIÓN A VIRUS DE SARAMPIÓN"
  },
  {
    "codigo":448749002,
    "descripcion":"EXUDADO SANGUINOLENTO DE HERIDA"
  },
  {
    "codigo":219373005,
    "descripcion":"HERIDA DE GUERRA POR PROYECTILES DE RIFLE"
  },
  {
    "codigo":284909007,
    "descripcion":"USA EL INODORO"
  },
  {
    "codigo":55533009,
    "descripcion":"OLVIDOS FRECUENTES"
  },
  {
    "codigo":20930002,
    "descripcion":"ANOSOGNOSIA"
  },
  {
    "codigo":184770004,
    "descripcion":"SOLICITUD DE CERTIFICADOS VARIOS"
  },
  {
    "codigo":250306005,
    "descripcion":"ANOMALÍA CROMOSÓMICA DE LOS LEUCOCITOS"
  },
  {
    "codigo":52147007,
    "descripcion":"PULSO ABRUPTO"
  },
  {
    "codigo":86466006,
    "descripcion":"ESTENOSIS MITRAL REUMÁTICA"
  },
  {
    "codigo":283074008,
    "descripcion":"ARAÑAZO DE CUELLO"
  },
  {
    "codigo":414146004,
    "descripcion":"TUBERCULOSIS RESISTENTE AL ETAMBUTOL"
  },
  {
    "codigo":838295002,
    "descripcion":"IMPÉTIGO AMPOLLAR DEL ÁREA DEL PAÑAL"
  },
  {
    "codigo":215703003,
    "descripcion":"LESIÓN SUFRIDA A BORDO DE MEDIO DE TRANSPORTE ACUÁTICO CAUSADA POR MAQUINARIA DE SALA DE MÁQUINAS, NADADOR LESIONADO"
  },
  {
    "codigo":314007004,
    "descripcion":"RETINOPATÍA SEROSA CENTRAL CRÓNICA CON DESPRENDIMIENTO DIFUSO DEL EPITELIO PIGMENTARIO DE LA RETINA"
  },
  {
    "codigo":281239006,
    "descripcion":"ASMA AGUDA"
  },
  {
    "codigo":248471008,
    "descripcion":"TOLERANTE A LOS CAMBIOS DE LA TEMPERATURA AMBIENTAL"
  },
  {
    "codigo":1295212001,
    "descripcion":"RADIOGRAFÍA DE CAJA TORÁCICA ANORMAL"
  },
  {
    "codigo":82796002,
    "descripcion":"ESCROFULODERMIA"
  },
  {
    "codigo":770924008,
    "descripcion":"GOTA AGUDA"
  },
  {
    "codigo":246636008,
    "descripcion":"VISIÓN BORROSA"
  },
  {
    "codigo":80961000,
    "descripcion":"PICADURA DE INSECTO VENENOSO EN LA REGIÓN DE LA PARED TORÁCICA, SIN INFECCIÓN"
  },
  {
    "codigo":16054071000119101,
    "descripcion":"DISPLASIA GLENOIDEA CONGÉNITA DE ESCÁPULA DERECHA"
  },
  {
    "codigo":277569004,
    "descripcion":"LEUCEMIA DE LINFOCITOS GRANULARES GRANDES"
  },
  {
    "codigo":410476009,
    "descripcion":"UVEÍTIS POR LEPTOSPIROSIS"
  },
  {
    "codigo":1089181000119108,
    "descripcion":"OTITIS EXTERNA DE CONDUCTO AUDITIVO EXTERNO IZQUIERDO CAUSADA POR HONGO"
  },
  {
    "codigo":736321008,
    "descripcion":"LESIÓN TRAUMÁTICA DE AMBAS CORTEZAS VISUALES"
  },
  {
    "codigo":1162305009,
    "descripcion":"ESCOLIOSIS DEBIDA A OSTEOPOROSIS VERTEBRAL"
  },
  {
    "codigo":308502002,
    "descripcion":"SITUACIÓN DEL MONITOREO DE LA HIPERTENSIÓN"
  },
  {
    "codigo":110059002,
    "descripcion":"LACERACIÓN COMPLEJA DE LA FRENTE"
  },
  {
    "codigo":42688000,
    "descripcion":"PREOCUPACIÓN DEL PENSAMIENTO"
  },
  {
    "codigo":1287872001,
    "descripcion":"MENTOFIMA"
  },
  {
    "codigo":403136003,
    "descripcion":"LEISHMANIASIS CUTÁNEA COMPLEJA POR LEISHMANIA BRASILIENSIS"
  },
  {
    "codigo":30181000175108,
    "descripcion":"ÚLCERA POR PRESIÓN EN TOBILLO IZQUIERDO, ESTADIO IV"
  },
  {
    "codigo":206528005,
    "descripcion":"TAPÓN DE MECONIO"
  },
  {
    "codigo":698048006,
    "descripcion":"CARCINOMA ESCAMOCELULAR NO QUERATINIZANTE INDIFERENCIADO DE NASOFARINGE"
  },
  {
    "codigo":370368007,
    "descripcion":"CANDIDIASIS RENAL"
  },
  {
    "codigo":1156800008,
    "descripcion":"ENFERMEDAD DE ALZHEIMER AUTOSÓMICA DOMINANTE DEBIDA A MUTACIÓN DE PRESENILINA 1"
  },
  {
    "codigo":272064009,
    "descripcion":"DEFICIENCIA DE AMILOPECTINA 6-GLUCANOHIDROLASA"
  },
  {
    "codigo":1351573001,
    "descripcion":"SÍNDROME DE HIPERINMUNOGLOBULINA M AUTOSÓMICO RECESIVO DEBIDO A DEFICIENCIA DE PROTEÍNA APRIL"
  },
  {
    "codigo":237461006,
    "descripcion":"GLÁNDULA DE MONTGOMERY INFECTADA"
  },
  {
    "codigo":12203831000119108,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DE REGIÓN PALMAR DE MANO IZQUIERDA"
  },
  {
    "codigo":301162001,
    "descripcion":"PULSO TEMPORAL AUSENTE"
  },
  {
    "codigo":73621009,
    "descripcion":"GEMELOS MONOAMNIÓTICOS"
  },
  {
    "codigo":1251434003,
    "descripcion":"DERMATITIS ATÓPICA GENERALIZADA DEL ADULTO"
  },
  {
    "codigo":366698004,
    "descripcion":"AMPLITUD DE MOVIMIENTO ACTIVO DE ADUCCIÓN DEL PULGAR - HALLAZGO"
  },
  {
    "codigo":235626005,
    "descripcion":"RUPTURA ESOFÁGICA"
  },
  {
    "codigo":39018007,
    "descripcion":"HIPERTENSIÓN ARTERIAL RENAL"
  },
  {
    "codigo":37183000,
    "descripcion":"CISTINURIA, TIPO 1"
  },
  {
    "codigo":233791001,
    "descripcion":"FÍSTULA BRONQUIAL"
  },
  {
    "codigo":299327001,
    "descripcion":"TUMEFACCIÓN SUPRARROTULIANA DE ARTICULACIÓN DE RODILLA"
  },
  {
    "codigo":364863001,
    "descripcion":"FRECUENCIA ELECTROENCEFALOGRÁFICA DOMINANTE - HALLAZGO"
  },
  {
    "codigo":430399004,
    "descripcion":"INFECCIÓN DE MÉDULA ESPINAL CAUSADA POR HISTOPLASMA"
  },
  {
    "codigo":397631007,
    "descripcion":"DEMORA EN LA DERIVACIÓN - NO CONCERTÓ NUEVA CONSULTA"
  },
  {
    "codigo":789012000,
    "descripcion":"HERIDA PUNZANTE DE PULGAR CON CUERPO EXTRAÑO"
  },
  {
    "codigo":363028003,
    "descripcion":"ANOMALÍA CONGÉNITA DE ESTRUCTURA CARDIOVASCULAR DEL TRONCO"
  },
  {
    "codigo":1149460006,
    "descripcion":"PERIODONTITIS GENERALIZADA ESTADIO 1 GRADO A SEGÚN LA CLASIFICACIÓN DE LAS ENFERMEDADES Y ALTERACIONES PERIODONTALES Y PERIIMPLANTARIAS DE 2017 DE LA ACADEMIA ESTADOUNIDENSE DE PERIODONTOLOGÍA Y LA FEDERACIÓN EUROPEA DE PERIODONTOLOGÍA"
  },
  {
    "codigo":231956007,
    "descripcion":"ANIRIDIA TRAUMÁTICA"
  },
  {
    "codigo":68116008,
    "descripcion":"DEGENERACIÓN DENTATORRUBROPALIDOLUISIANA"
  },
  {
    "codigo":262889003,
    "descripcion":"DESGARRO DE EPIPLÓN MAYOR"
  },
  {
    "codigo":33513003,
    "descripcion":"DEFICIENCIA FAMILIAR DE APOLIPOPROTEÍNA C - II"
  },
  {
    "codigo":787177005,
    "descripcion":"TRASTORNO INFLAMATORIO DE LA VÍA VISUAL"
  },
  {
    "codigo":1091691000119101,
    "descripcion":"ENFERMEDAD DE MÉNIÈRE DEL OÍDO INTERNO DERECHO"
  },
  {
    "codigo":721641003,
    "descripcion":"CARCINOMA NEUROENDOCRINO PRIMARIO DE ANTRO PILÓRICO GÁSTRICO"
  },
  {
    "codigo":66281009,
    "descripcion":"CORIORRETINITIS DEBIDA A SÍFILIS SECUNDARIA"
  },
  {
    "codigo":457662004,
    "descripcion":"RUPTURA DE VALVA SEMILUNAR DE VÁLVULA PULMONAR"
  },
  {
    "codigo":195518005,
    "descripcion":"FLEBOESCLEROSIS"
  },
  {
    "codigo":228286007,
    "descripcion":"BEBE EN LA CASA DE OTROS"
  },
  {
    "codigo":128147000,
    "descripcion":"GALOPE POR SUMA"
  },
  {
    "codigo":293822009,
    "descripcion":"ALERGIA A BUTRIPTILINA"
  },
  {
    "codigo":193683001,
    "descripcion":"CEGUERA A LOS COLORES"
  },
  {
    "codigo":423059004,
    "descripcion":"VISIÓN A DISTANCIA 20\/40"
  },
  {
    "codigo":41761000087102,
    "descripcion":"CELULITIS DE DEDO MEÑIQUE DERECHO"
  },
  {
    "codigo":421224000,
    "descripcion":"INFECCIÓN INTESTINAL CAUSADA POR KLEBSIELLA AEROGENES"
  },
  {
    "codigo":95379009,
    "descripcion":"IRRITACIÓN EN EL SITIO DE INYECCIÓN"
  },
  {
    "codigo":28008001,
    "descripcion":"EFECTO TÓXICO DE LA SAL DE COBRE"
  },
  {
    "codigo":1142120000,
    "descripcion":"TAQUICARDIA RECIPROCANTE AURICULOVENTRICULAR ORTODRÓMICA QUE UTILIZA VÍA ACCESORIA MANIFIESTA"
  },
  {
    "codigo":879976004,
    "descripcion":"LESIÓN DE HUESO"
  },
  {
    "codigo":44321000087108,
    "descripcion":"CONTUSIÓN DE CÓNDILO EXTERNO DE TIBIA DERECHA"
  },
  {
    "codigo":417554000,
    "descripcion":"TERATOMA MALIGNO DE TESTÍCULO DESCENDIDO"
  },
  {
    "codigo":253714001,
    "descripcion":"TRAYECTO ANORMAL DE ARTERIA CORONARIA"
  },
  {
    "codigo":89874002,
    "descripcion":"SÍNDROME DE DOLOR XIFOIDEO"
  },
  {
    "codigo":778002005,
    "descripcion":"ENCEFALOPATÍA POR SUBUNIDAD 2 DEL CANAL ALFA CONTROLADO POR VOLTAJE DE SODIO"
  },
  {
    "codigo":284647000,
    "descripcion":"IRA PRIMITIVA"
  },
  {
    "codigo":24338009,
    "descripcion":"FRUCTOSURIA"
  },
  {
    "codigo":448487009,
    "descripcion":"CONEXIÓN VENOSA PULMONAR ANÓMALA DE TIPO MIXTO"
  },
  {
    "codigo":315580004,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: PORTUGUÉS"
  },
  {
    "codigo":761731000000100,
    "descripcion":"DIFICULTAD PARA UTILIZAR COMPUTADORA PERSONAL"
  },
  {
    "codigo":250044006,
    "descripcion":"MARCHA CAUTELOSA"
  },
  {
    "codigo":16030111000119100,
    "descripcion":"OSTEOMIELITIS SUBAGUDA DE HUESO FEMORAL DERECHO"
  },
  {
    "codigo":1231249000,
    "descripcion":"ECTROPIÓN MECÁNICO DE PÁRPADO SUPERIOR"
  },
  {
    "codigo":86204009,
    "descripcion":"SÍNDROME DE CILIOS INMÓVILES"
  },
  {
    "codigo":280977002,
    "descripcion":"HEMORRAGIA DE DERIVACIÓN ARTERIOVENOSA"
  },
  {
    "codigo":1264017003,
    "descripcion":"INFLAMACIÓN DE MÚSCULO DE ANTEBRAZO"
  },
  {
    "codigo":864131000000100,
    "descripcion":"VIVE EN REFUGIO"
  },
  {
    "codigo":261000119107,
    "descripcion":"TRASTORNO BIPOLAR DE TIPO I CON DEPRESIÓN SEVERA"
  },
  {
    "codigo":248209008,
    "descripcion":"FACIES TIROTÓXICA"
  },
  {
    "codigo":16998003,
    "descripcion":"HERIDA ABIERTA DE LOS ANEXOS OCULARES"
  },
  {
    "codigo":408379005,
    "descripcion":"RESULTADO DE ESTUDIO DE DIAGNÓSTICO POR IMÁGENES DUDOSO"
  },
  {
    "codigo":1293115007,
    "descripcion":"GLOMERULOESCLEROSIS FOCAL Y SEGMENTARIA CAUSADA POR SUSTANCIA"
  },
  {
    "codigo":703291007,
    "descripcion":"ESTENOSIS DE PRÓTESIS DE VÁLVULA PULMONAR"
  },
  {
    "codigo":16357791000119106,
    "descripcion":"ADENOMA DE GLÁNDULA SUPRARRENAL IZQUIERDA"
  },
  {
    "codigo":766992008,
    "descripcion":"SÍNDROME DE OSTEÓLISIS MULTICÉNTRICA CARPOTARSIANA"
  },
  {
    "codigo":275472008,
    "descripcion":"DISFONÍA PSICÓGENA"
  },
  {
    "codigo":137631000119107,
    "descripcion":"ÚLCERA NEUROPÁTICA DE TOBILLO"
  },
  {
    "codigo":240869004,
    "descripcion":"CAPILARIASIS HEPÁTICA"
  },
  {
    "codigo":765157005,
    "descripcion":"RIÑÓN DERECHO PEQUEÑO"
  },
  {
    "codigo":15675961000119102,
    "descripcion":"TENDINITIS CALCIFICANTE BILATERAL DE MUÑECA"
  },
  {
    "codigo":402874001,
    "descripcion":"NEOPLASIA DE ORIGEN EN LA VAINA NERVIOSA"
  },
  {
    "codigo":1156538002,
    "descripcion":"LESIÓN TRAUMÁTICA DE REGIÓN DE COLUMNA VERTEBRAL"
  },
  {
    "codigo":206266009,
    "descripcion":"RECIÉN NACIDO VIVO CON SUFRIMIENTO FETAL DURANTE EL TRABAJO DE PARTO"
  },
  {
    "codigo":204431007,
    "descripcion":"ATRESIA Y ESTENOSIS DE LA ARTERIA AORTA"
  },
  {
    "codigo":202596000,
    "descripcion":"CHASQUIDO ARTICULAR"
  },
  {
    "codigo":5988002,
    "descripcion":"FALTA DE INTUICIÓN"
  },
  {
    "codigo":399204005,
    "descripcion":"RESPUESTA TERAPÉUTICA PARCIAL"
  },
  {
    "codigo":366436005,
    "descripcion":"AMPLITUD DEL MOVIMIENTO ACTIVO DE FLEXIÓN LATERAL HACIA LA DERECHA DE LA COLUMNA LUMBAR - HALLAZGO"
  },
  {
    "codigo":169828005,
    "descripcion":"GEMELOS - AMBOS NACIDOS VIVOS"
  },
  {
    "codigo":299065001,
    "descripcion":"AMPLITUD DE FLEXIÓN ACTIVA DE DEDO DE LA MANO NORMAL"
  },
  {
    "codigo":69689004,
    "descripcion":"LLANTO FETAL INTRAUTERINO"
  },
  {
    "codigo":725049005,
    "descripcion":"FIBROMATOSIS AGRESIVA"
  },
  {
    "codigo":36921006,
    "descripcion":"ESTOMATITIS VESICULAR"
  },
  {
    "codigo":102457005,
    "descripcion":"SÍNDROME DEL LACTANTE Y\/O NIÑO GOLPEADO"
  },
  {
    "codigo":395534006,
    "descripcion":"TUMOR QUE INVADE LA MUSCULAR DE LA MUCOSA"
  },
  {
    "codigo":67854007,
    "descripcion":"SÍNDROME DE MAROTEAUX - LAMY, FORMA LEVE"
  },
  {
    "codigo":262627001,
    "descripcion":"LACERACIÓN DE MUCOSA YUGAL"
  },
  {
    "codigo":721379003,
    "descripcion":"SÍNDROME DEL CORDÓN CENTRAL DE MÉDULA ESPINAL AL NIVEL DEL OCTAVO SEGMENTO CERVICAL"
  },
  {
    "codigo":426467005,
    "descripcion":"FRACTURA DE HUTCHINSON"
  },
  {
    "codigo":295395007,
    "descripcion":"SOBREDOSIS INTENCIONAL DE HIDRÓXIDO DE ALUMINIO"
  },
  {
    "codigo":330451000119105,
    "descripcion":"ATRAPAMIENTO DE NERVIO CUBITAL EN LA MUÑECA DERECHA"
  },
  {
    "codigo":424632001,
    "descripcion":"ADENOCARCINOMA DE PULMÓN, ESTADIO II"
  },
  {
    "codigo":197091007,
    "descripcion":"ENFERMEDAD DIVERTICULAR DE LOS INTESTINOS GRUESO Y DELGADO SIN PERFORACIÓN O ABSCESO"
  },
  {
    "codigo":162488003,
    "descripcion":"SÍNTOMA QUE MEJORA CON EL DESCANSO"
  },
  {
    "codigo":440441000124100,
    "descripcion":"INGESTA INADECUADA DE ÉSTER DE ESTANOL VEGETAL"
  },
  {
    "codigo":64184006,
    "descripcion":"GRUPO DE VOZ RONCA ESFORZADA DETENIDA - RÍTMICA INTERMITENTE"
  },
  {
    "codigo":293560006,
    "descripcion":"REACCIÓN ADVERSA AL NICOTINATO DE INOSITOL"
  },
  {
    "codigo":783245001,
    "descripcion":"INMUNODEFICIENCIA PRIMARIA CON INFECCIÓN POSTERIOR A ADMINISTRACIÓN DE VACUNA ANTISARAMPIONOSA-ANTIPAROTIDÍTICA-ANTIRRUBEÓLICA"
  },
  {
    "codigo":129720009,
    "descripcion":"CAMBIO DESDE LA ÚLTIMA MAMOGRAFÍA"
  },
  {
    "codigo":226189001,
    "descripcion":"DIETA CON BAJO NIVEL DE GLUTAMATO MONOSÓDICO"
  },
  {
    "codigo":2681000124107,
    "descripcion":"SEGUNDO PREMOLAR SUPERIOR IZQUIERDO PERMANENTE SUPERNUMERARIO"
  },
  {
    "codigo":93282000,
    "descripcion":"HIPOPLASIA CONGÉNITA DE HUESO PARIETAL"
  },
  {
    "codigo":29581008,
    "descripcion":"DEFICIENCIA LONGITUDINAL DE HUESO DE TARSO"
  },
  {
    "codigo":289890000,
    "descripcion":"HALLAZGO RELACIONADO CON LA DURACIÓN DE LA MENSTRUACIÓN"
  },
  {
    "codigo":60514000,
    "descripcion":"MIOCARDIOPATÍA DILATADA DEBIDA A ENFERMEDAD POR DEPÓSITO LISOSOMAL FAMILIAR"
  },
  {
    "codigo":224354005,
    "descripcion":"NIÑO EN REGISTRO DE RIESGO"
  },
  {
    "codigo":715874005,
    "descripcion":"INFECCIÓN DE LA PIEL CAUSADA POR NEOSCYTALIDIUM DIMIDIATUM"
  },
  {
    "codigo":191586008,
    "descripcion":"EPISODIO MANÍACO ÚNICO, GRAVE, CON SÍNTOMAS PSICÓTICOS"
  },
  {
    "codigo":1172791005,
    "descripcion":"ENFERMEDAD GINGIVAL POR MYCOBACTERIUM LEPRAE"
  },
  {
    "codigo":124215008,
    "descripcion":"DEFICIENCIA DE FENILALANINA 4 - MONOOXIGENASA"
  },
  {
    "codigo":253452001,
    "descripcion":"MÚSCULO PAPILAR DE VÁLVULA AURICULOVENTRICULAR COMÚN FUSIONADO"
  },
  {
    "codigo":187916000,
    "descripcion":"NEOPLASIA MALIGNA DE VÉRTEBRA CERVICAL"
  },
  {
    "codigo":286220002,
    "descripcion":"UTILIZA EL FLUJO DE AIRE PULMONAR PARA HABLAR"
  },
  {
    "codigo":448225001,
    "descripcion":"SATURACIÓN DE OXÍGENO DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1300193002,
    "descripcion":"ENCEFALITIS LÍMBICA AUTOINMUNITARIA"
  },
  {
    "codigo":687111000119102,
    "descripcion":"NEUROFIBROMA DE CABEZA"
  },
  {
    "codigo":55009008,
    "descripcion":"DEMENCIA DEGENERATIVA PRIMARIA TIPO ALZHEIMER, DE INICIO EN LA EDAD SENIL, CON IDEAS DELIRANTES"
  },
  {
    "codigo":85942002,
    "descripcion":"ULCERACIÓN DE INTESTINO"
  },
  {
    "codigo":1003446003,
    "descripcion":"SINOSTOSIS HÚMERO - CUBITAL BILATERAL"
  },
  {
    "codigo":53174001,
    "descripcion":"OSTEOPOROSIS POR INACTIVIDAD"
  },
  {
    "codigo":282550006,
    "descripcion":"NO EVITA OBSTÁCULOS AL CORRER"
  },
  {
    "codigo":774070008,
    "descripcion":"SÍNDROME DE RETRASO DEL DESARROLLO ASOCIADO A FIBULINA 1, ANOMALÍA DEL SISTEMA NERVIOSO CENTRAL Y SINDACTILIA"
  },
  {
    "codigo":446390008,
    "descripcion":"LESIÓN TRAUMÁTICA DE CUERPO DE PÁNCREAS"
  },
  {
    "codigo":51339003,
    "descripcion":"DEPENDENCIA DE VARIAS SUSTANCIAS"
  },
  {
    "codigo":444555004,
    "descripcion":"SEROMA DE MAMA COMO COMPLICACIÓN DE PROCEDIMIENTO"
  },
  {
    "codigo":772235004,
    "descripcion":"INCAPAZ DE MANTENER EL EQUILIBRIO AL PARARSE CON AMBOS PIES SEPARADOS"
  },
  {
    "codigo":1296523008,
    "descripcion":"HIPOGLUCEMIA NOCTURNA"
  },
  {
    "codigo":1263755009,
    "descripcion":"HEMATOMA SUBUNGUEAL DE PULGAR"
  },
  {
    "codigo":247947009,
    "descripcion":"RESISTENCIA A LOS CAMBIOS DEL MEDIO AMBIENTE"
  },
  {
    "codigo":82272006,
    "descripcion":"RESFRÍO COMÚN"
  },
  {
    "codigo":80437003,
    "descripcion":"ABSCESO DE LA PARED ABDOMINAL"
  },
  {
    "codigo":14901003,
    "descripcion":"ANQUILOSIS DE DIENTE"
  },
  {
    "codigo":735797006,
    "descripcion":"MÚLTIPLES LESIONES TRAUMÁTICAS DE REGIÓN LUMBAR"
  },
  {
    "codigo":703029007,
    "descripcion":"PREVOTELLA LOESCHEII O PREVOTELLA DENTICOLA"
  },
  {
    "codigo":16006151000119108,
    "descripcion":"TROMBOFLEBITIS DE VENA SUPERFICIAL DE MIEMBRO SUPERIOR DERECHO"
  },
  {
    "codigo":332961000119102,
    "descripcion":"CICATRIZ CORIORRETINIANA POSINFLAMATORIA DE OJO DERECHO"
  },
  {
    "codigo":211509006,
    "descripcion":"CONTUSIÓN DE LA MANO, DORSO"
  },
  {
    "codigo":733962003,
    "descripcion":"CARIES DENTAL INACTIVA SECUNDARIA QUE SE EXTIENDE HASTA EL TERCIO INTERNO DE LA DENTINA"
  },
  {
    "codigo":209674004,
    "descripcion":"SECCIÓN EXPUESTA DE LIGAMENTO DEL PULGAR"
  },
  {
    "codigo":1260085006,
    "descripcion":"CARCINOMA INDIFERENCIADO DE HIPOFARINGE"
  },
  {
    "codigo":699359001,
    "descripcion":"ESPACIO DE LEEWAY PRESENTE"
  },
  {
    "codigo":238772004,
    "descripcion":"LIVEDO RETICULARIS"
  },
  {
    "codigo":52616002,
    "descripcion":"SÍNDROME DE FREEMAN - SHELDON"
  },
  {
    "codigo":402612007,
    "descripcion":"HIPERMELANOSIS POR NEOPLASIA"
  },
  {
    "codigo":304308007,
    "descripcion":"AMPLITUD DE MOVIMIENTO DE DEDO DE LA MANO AUMENTADA"
  },
  {
    "codigo":73097000,
    "descripcion":"TRASTORNO AMNÉSICO POR EL ALCOHOL"
  },
  {
    "codigo":1187209002,
    "descripcion":"NEVO PIGMENTADO GIGANTE DE PIEL CONGÉNITO BENIGNO"
  },
  {
    "codigo":1252745002,
    "descripcion":"SUBLUXACIÓN LATERAL DE ARTICULACIÓN FEMORORROTULIANA"
  },
  {
    "codigo":1285513008,
    "descripcion":"AGUJERO MACULAR LAMELAR"
  },
  {
    "codigo":726622002,
    "descripcion":"SÍNDROME DE PARAPLEJÍA ESPÁSTICA CON ENFERMEDAD DE PAGET ÓSEA"
  },
  {
    "codigo":71262003,
    "descripcion":"ÚLCERA GINGIVAL"
  },
  {
    "codigo":202334004,
    "descripcion":"SEPARACIÓN DEL FIBROCARTÍLAGO TRIANGULAR"
  },
  {
    "codigo":169566002,
    "descripcion":"EMBARAZO NO PLANEADO PERO DESEADO"
  },
  {
    "codigo":431710006,
    "descripcion":"ENFERMEDAD PILONIDAL DEL SURCO INTERGLÚTEO"
  },
  {
    "codigo":366174005,
    "descripcion":"FUNCIÓN DEL NÓDULO AURICULOVENTRICULAR - HALLAZGO"
  },
  {
    "codigo":38494008,
    "descripcion":"SÍNDROME DE DISPLASIA MESOMÉLICA DE LANGER"
  },
  {
    "codigo":36659001,
    "descripcion":"RANURA CONGÉNITA DE LA PUNTA DE LA NARIZ"
  },
  {
    "codigo":300638003,
    "descripcion":"DIFICULTAD PARA MANEJAR UN AUTO"
  },
  {
    "codigo":336571000119100,
    "descripcion":"DACRIOADENITIS AGUDA DE OJO DERECHO"
  },
  {
    "codigo":1073851000119101,
    "descripcion":"DEFORMIDAD DE MUÑECA IZQUIERDA DEBIDA A ARTRITIS REUMATOIDE"
  },
  {
    "codigo":300731000119102,
    "descripcion":"TRASTORNO DE TENDÓN DE MUSLO DERECHO"
  },
  {
    "codigo":323771000119100,
    "descripcion":"SINDACTILIA SIMPLE DE DEDOS DEL PIE DERECHO"
  },
  {
    "codigo":318651000119104,
    "descripcion":"OSTEOARTROSIS DE CODO IZQUIERDO"
  },
  {
    "codigo":1078971000119105,
    "descripcion":"CARCINOMA ADENOIDE QUÍSTICO DE GLÁNDULA LAGRIMAL IZQUIERDA"
  },
  {
    "codigo":339131000119104,
    "descripcion":"QUISTE DE ORA SERRATA DE RETINA DE OJO IZQUIERDO"
  },
  {
    "codigo":308411000119100,
    "descripcion":"GRANULOMA POR CUERPO EXTRAÑO DE PARTES BLANDAS DE BRAZO IZQUIERDO"
  },
  {
    "codigo":341691000119108,
    "descripcion":"DEGENERACIÓN DE COROIDES DE OJO IZQUIERDO"
  },
  {
    "codigo":346811000119109,
    "descripcion":"CONJUNTIVITIS PAPILAR GIGANTE CRÓNICA BILATERAL"
  },
  {
    "codigo":1148936005,
    "descripcion":"HIPERFOSFATEMIA DEBIDA A ENFERMEDAD RENAL CRÓNICA"
  },
  {
    "codigo":72891000119103,
    "descripcion":"SARCOMA DE KAPOSI DE VÍSCERA"
  },
  {
    "codigo":16741051000119109,
    "descripcion":"REESTENOSIS DE STENT VASCULAR PERIFÉRICO"
  },
  {
    "codigo":16098491000119109,
    "descripcion":"HEPATITIS AUTOINMUNITARIA CRÓNICA"
  },
  {
    "codigo":10947771000119106,
    "descripcion":"HERIDA ABIERTA DE DEDO ÍNDICE IZQUIERDO DEBIDA A MORDEDURA DE ANIMAL"
  },
  {
    "codigo":722952009,
    "descripcion":"VESTIBULOPATÍA CRÓNICA BILATERAL"
  },
  {
    "codigo":8891000119108,
    "descripcion":"AMPOLLA TRAUMÁTICA DE ENCÍA"
  },
  {
    "codigo":788488008,
    "descripcion":"TRASTORNO REPETITIVO DEL MOVIMIENTO DE AMBOS ANTEBRAZOS"
  },
  {
    "codigo":11775291000119106,
    "descripcion":"LACERACIÓN DE TENDÓN DE BRAZO IZQUIERDO"
  },
  {
    "codigo":63922003,
    "descripcion":"ENDOMETRITIS CRÓNICA"
  },
  {
    "codigo":719282008,
    "descripcion":"SÍNDROME DE DISCINESIA CILIAR PRIMARIA Y RETINITIS PIGMENTOSA"
  },
  {
    "codigo":1340039001,
    "descripcion":"PORTADOR ASINTOMÁTICO DE ORGANISMO INFECCIOSO EN PIEL"
  },
  {
    "codigo":94855005,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL NERVIO GLOSOFARÍNGEO"
  },
  {
    "codigo":289628001,
    "descripcion":"FONDO UTERINO ENTRE LA SÍNFISIS PÚBICA Y EL OMBLIGO"
  },
  {
    "codigo":93020002,
    "descripcion":"ANOMALÍA CONGÉNITA DE HUESO PREESFENOIDAL"
  },
  {
    "codigo":1010524004,
    "descripcion":"ESCLEROSIS DE EPÍFISIS DE FALANGE DISTAL DE SEGUNDO DEDO DE PIE CON RADIOPACIDAD AUMENTADA"
  },
  {
    "codigo":846684007,
    "descripcion":"OCLUSIÓN DE ARTERIA INTERMEDIA"
  },
  {
    "codigo":255025001,
    "descripcion":"OSTEOMA DE COROIDES"
  },
  {
    "codigo":123953004,
    "descripcion":"HIPOGONADISMO HIPOGONADOTRÓFICO IDIOPÁTICO"
  },
  {
    "codigo":713777005,
    "descripcion":"ESPONDILOARTRITIS AXIAL NO RADIOGRÁFICA"
  },
  {
    "codigo":449798000,
    "descripcion":"APIÑAMIENTO DE DIENTES SUPERIORES ANTERIORES"
  },
  {
    "codigo":253190004,
    "descripcion":"AGENESIA LUMBOSACRA"
  },
  {
    "codigo":284123008,
    "descripcion":"INCAPAZ DE CONTROLAR LA POSICIÓN DEL TRONCO"
  },
  {
    "codigo":249520001,
    "descripcion":"PURGACIÓN AUTOINDUCIDA"
  },
  {
    "codigo":216752008,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ÁCIDO NÍTRICO"
  },
  {
    "codigo":315056009,
    "descripcion":"NEUROPATÍA DEL NERVIO PUDENDO"
  },
  {
    "codigo":1263493003,
    "descripcion":"MIELITIS DEBIDA A SÍNDROME DE SJÖGREN"
  },
  {
    "codigo":870277008,
    "descripcion":"LESIÓN CUTÁNEA PIGMENTADA DE CUELLO DE NATURALEZA INCIERTA"
  },
  {
    "codigo":317051000119106,
    "descripcion":"REUMATISMO PALINDRÓMICO DE ARTICULACIÓN DE REGIÓN DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":442035006,
    "descripcion":"INFECCIÓN CAUSADA POR ANISAKIDAE"
  },
  {
    "codigo":213082003,
    "descripcion":"LUXACIÓN DE PRÓTESIS ARTICULAR"
  },
  {
    "codigo":1359962004,
    "descripcion":"HERIDA ABIERTA DE DEDO MEÑIQUE DEBIDA A MORDEDURA DE GATO"
  },
  {
    "codigo":1228890005,
    "descripcion":"SÍNDROME DE HAO FOUNTAIN DEBIDO A MICRODELECIÓN 16P13.2"
  },
  {
    "codigo":278618007,
    "descripcion":"RUPTURA DE GANCHO DE RETENCIÓN DE PRÓTESIS DENTAL"
  },
  {
    "codigo":309001000119104,
    "descripcion":"TENDINITIS CALCIFICANTE DE CODO DERECHO"
  },
  {
    "codigo":10958601000119105,
    "descripcion":"HERIDA ABIERTA DE PIE IZQUIERDO"
  },
  {
    "codigo":1259823008,
    "descripcion":"CORDOMA PRIMARIO DE COLUMNA CERVICAL"
  },
  {
    "codigo":274948002,
    "descripcion":"DEPRESIÓN ENDÓGENA - RECURRENTE"
  },
  {
    "codigo":209412004,
    "descripcion":"ESGUINCE DE LIGAMENTO CORACOCLAVICULAR"
  },
  {
    "codigo":11777801000119106,
    "descripcion":"DISTENSIÓN DE MANGUITO ROTADOR DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":12804006,
    "descripcion":"TIÑA CRURAL CAUSADA POR TRICHOPHYTON RUBRUM"
  },
  {
    "codigo":78340007,
    "descripcion":"OBSTRUCCIÓN MECÁNICA DE UN DISPOSITIVO CARDÍACO"
  },
  {
    "codigo":305881000,
    "descripcion":"VISTO EN EL SERVICIO DE ECOGRAFÍA"
  },
  {
    "codigo":109273001,
    "descripcion":"NEVO MELANOCÍTICO DE PÁRPADO, INCLUIDO EL CANTO"
  },
  {
    "codigo":830169008,
    "descripcion":"ALERGIA A ISOETARINA"
  },
  {
    "codigo":238510001,
    "descripcion":"ERITEMA AB IGNE"
  },
  {
    "codigo":402350005,
    "descripcion":"ALOPECIA CICATRIZAL POR LIQUEN PLANO DE CUERO CABELLUDO"
  },
  {
    "codigo":105603000,
    "descripcion":"TRASTORNO BENIGNO DE LOS LINFOCITOS Y\/O LAS CÉLULAS PLASMÁTICAS"
  },
  {
    "codigo":1156014009,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE ARTICULACIÓN DE LA CADERA"
  },
  {
    "codigo":300376000,
    "descripcion":"DEFECA"
  },
  {
    "codigo":726360002,
    "descripcion":"TRISOMÍA PARCIAL DE CROMOSOMA 20"
  },
  {
    "codigo":398680004,
    "descripcion":"CITRULINEMIA"
  },
  {
    "codigo":5464005,
    "descripcion":"PSICOSIS REACTIVA BREVE"
  },
  {
    "codigo":365912009,
    "descripcion":"MEMORIA DEL MES ACTUAL - HALLAZGO"
  },
  {
    "codigo":724525007,
    "descripcion":"DUODENITIS CAUSADA POR HELICOBACTER PYLORI"
  },
  {
    "codigo":1052205008,
    "descripcion":"PÉRDIDA DE LA AUDICIÓN CONDUCTIVA Y NEUROSENSORIAL COMBINADAS DE OÍDO IZQUIERDO CON AUDICIÓN NORMAL DEL OÍDO DERECHO"
  },
  {
    "codigo":722690001,
    "descripcion":"NEOPLASIA BENIGNA CONDROGÉNICA"
  },
  {
    "codigo":233005009,
    "descripcion":"PANCREATITIS INDOLORA"
  },
  {
    "codigo":198402002,
    "descripcion":"DISPAREUNIA DE CAUSA NO PSICÓGENA EN LA MUJER"
  },
  {
    "codigo":1148674000,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE ANFETAMINA Y\/O DERIVADO DE ANFETAMINA"
  },
  {
    "codigo":427778008,
    "descripcion":"INCOMPETENCIA DEL LIMEN NASAL"
  },
  {
    "codigo":1794009,
    "descripcion":"EDEMA CORNEAL IDIOPÁTICO"
  },
  {
    "codigo":296706008,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE CEFAMANDOL"
  },
  {
    "codigo":720855003,
    "descripcion":"SÍNDROME CEREBRO-OCULO-NASAL"
  },
  {
    "codigo":131031004,
    "descripcion":"NIVEL DE OXITOCINA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":294871008,
    "descripcion":"ALERGIA A ANCROD"
  },
  {
    "codigo":1145004001,
    "descripcion":"DEMUESTRA CONOCIMIENTO SOBRE RÉGIMEN NUTRICIONAL"
  },
  {
    "codigo":194732001,
    "descripcion":"VALVULOPATÍAS MITRALES Y AÓRTICAS"
  },
  {
    "codigo":293036003,
    "descripcion":"REACCIÓN ADVERSA A LA SULFAMETOPIRAZINA"
  },
  {
    "codigo":719020006,
    "descripcion":"SÍNDROME DE PALLISTER-W"
  },
  {
    "codigo":225665000,
    "descripcion":"SE RECONOCE"
  },
  {
    "codigo":260268009,
    "descripcion":"N8"
  },
  {
    "codigo":291201001,
    "descripcion":"INTOXICACIÓN POR TRIFLUOPERAZINA"
  },
  {
    "codigo":192897002,
    "descripcion":"MIELOPATÍA POR INFARTO AGUDO DE LA MÉDULA ESPINAL"
  },
  {
    "codigo":94593007,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE PARTES BLANDAS DE HOMBRO"
  },
  {
    "codigo":717185008,
    "descripcion":"DEFICIENCIA DE LEUCOTRIENO C4 SINTASA"
  },
  {
    "codigo":29057008,
    "descripcion":"ANOMALÍA VENOSA DEL CORDÓN UMBILICAL"
  },
  {
    "codigo":782721009,
    "descripcion":"SÍNDROME AUTOSÓMICO RECESIVO DE ATAXIA CEREBELOSA, EPILEPSIA, AUTOSÓMICA RECESIVA DEBIDA A HOMOLOGÍA DE STIP1 Y DEFICIENCIA DE PROTEÍNA 1 CON CAJA U"
  },
  {
    "codigo":337981000119108,
    "descripcion":"RETINOPATÍA POR PREMATUREZ DEL OJO IZQUIERDO ETAPA 3 - CRESTA CON PROLIFERACIÓN FIBROVASCULAR EXTRARRETINIANA"
  },
  {
    "codigo":420438004,
    "descripcion":"HALLAZGO RELACIONADO CON PRUEBA OFTÁLMICA"
  },
  {
    "codigo":92758001,
    "descripcion":"CARCINOMA IN SITU DE LA GLÁNDULA SUBLINGUAL"
  },
  {
    "codigo":289366006,
    "descripcion":"POSICIÓN ANÓMALA DEL FETO EN LA PRESENTACIÓN DE CARA"
  },
  {
    "codigo":59990008,
    "descripcion":"MUCOPOLISACARIDOSIS, MPS - III - B"
  },
  {
    "codigo":418603006,
    "descripcion":"REACCIÓN ADVERSA A LA MINOCICLINA"
  },
  {
    "codigo":254763007,
    "descripcion":"TUMOR DE CÉLULAS GRANULARES DE LA PIEL"
  },
  {
    "codigo":1303339006,
    "descripcion":"GLAUCOMA POR CIERRE ANGULAR PRIMARIO DE OJO IZQUIERDO"
  },
  {
    "codigo":449536002,
    "descripcion":"DOBLE CAYADO AÓRTICO CON ARCO DERECHO DOMINANTE, ATRESIA DE ARCO IZQUIERDO Y LIGAMENTO IZQUIERDO A DIVERTÍCULO"
  },
  {
    "codigo":11999601000119101,
    "descripcion":"QUEMADURA DE TERCER GRADO DE REGIÓN DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":283861003,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO EN EL DEDO GORDO"
  },
  {
    "codigo":447701006,
    "descripcion":"VENTANA AORTOPULMONAR INTERMEDIA CON BORDES SUPERIOR E INFERIOR ADECUADOS"
  },
  {
    "codigo":118186000,
    "descripcion":"HALLAZGO EN LA TELARCA"
  },
  {
    "codigo":251093008,
    "descripcion":"PARO SINUSAL CON ESCAPE DE LA UNIÓN AURICULOVENTRICULAR"
  },
  {
    "codigo":282026002,
    "descripcion":"LESIÓN TRAUMÁTICA DE PARTES BLANDAS"
  },
  {
    "codigo":183722003,
    "descripcion":"CONSULTA DOMICILIARIA DE DIABETOLOGÍA SOLICITADA"
  },
  {
    "codigo":249258003,
    "descripcion":"ORIFICIO DE SALIDA DEL PREPUCIO ESTRECHO"
  },
  {
    "codigo":85418005,
    "descripcion":"TRASTORNO DE LOS SUEÑOS"
  },
  {
    "codigo":1363370009,
    "descripcion":"ENFERMEDAD MITOCONDRIAL RELACIONADA CON EL DOMINIO AAA DE LA FAMILIA ATPASA QUE CONTIENE 3A"
  },
  {
    "codigo":1197695008,
    "descripcion":"VÁRICES ESOFÁGICAS SANGRANTES POR HEPATITIS VIRAL"
  },
  {
    "codigo":1163092001,
    "descripcion":"ATAXIA DEBIDA A TRASTORNO DE LA FUNCIÓN INMUNOLÓGICA"
  },
  {
    "codigo":312959008,
    "descripcion":"RETINOPATÍA POR DESFERROXIAMINA"
  },
  {
    "codigo":704340003,
    "descripcion":"ACTITUD CONFLICTIVA CON RESPECTO AL TRATAMIENTO"
  },
  {
    "codigo":48980001,
    "descripcion":"OBSTRUCCIÓN CONGÉNITA DE LA URETRA"
  },
  {
    "codigo":210985000,
    "descripcion":"LESIÓN SUPERFICIAL DE LA CABEZA, EXCLUIDO LOS OJOS"
  },
  {
    "codigo":1259561002,
    "descripcion":"MELANOMA MALIGNO PRIMARIO DE CÉLULAS BALONIZADAS"
  },
  {
    "codigo":276521007,
    "descripcion":"OBSTRUCCIÓN INTESTINAL PERINATAL"
  },
  {
    "codigo":1290494001,
    "descripcion":"TENDINOSIS DE CODO"
  },
  {
    "codigo":897278005,
    "descripcion":"EPIGNATO FETAL"
  },
  {
    "codigo":405758006,
    "descripcion":"LESIÓN MEDULAR CERVICAL CENTRAL SIN LESIÓN OSTEOVERTEBRAL, C5-C7"
  },
  {
    "codigo":76243000,
    "descripcion":"ENFERMEDAD GRANULOMATOSA CRÓNICA, TIPO IVA"
  },
  {
    "codigo":471294009,
    "descripcion":"QUISTE PERICÁRDICO CONGÉNITO"
  },
  {
    "codigo":274686008,
    "descripcion":"HALLAZGOS CITOLÓGICOS ANORMALES EN LCR"
  },
  {
    "codigo":340491000119104,
    "descripcion":"ORZUELO EXTERNO DE PÁRPADO IZQUIERDO"
  },
  {
    "codigo":240083001,
    "descripcion":"MIOPATÍA CON HIPOTROFIA TIPO I"
  },
  {
    "codigo":372990008,
    "descripcion":"INFECCIÓN CAUSADA POR ASPERGILLUM OCHRACEUS"
  },
  {
    "codigo":698835006,
    "descripcion":"MIOCLONÍA ORIGINADA EN LA CORTEZA CEREBRAL"
  },
  {
    "codigo":403923002,
    "descripcion":"MELANOMA MALIGNO FUSOCELULAR"
  },
  {
    "codigo":8872002,
    "descripcion":"OSTEOMIELITIS DE LA REGIÓN PÉLVICA"
  },
  {
    "codigo":762536003,
    "descripcion":"LIPODERMATOSCLEROSIS DE MIEMBRO INFERIOR DEBIDA A VENAS VARICOSAS"
  },
  {
    "codigo":205480005,
    "descripcion":"DISPLASIA EPIFISARIA HEMIMÉLICA"
  },
  {
    "codigo":860840007,
    "descripcion":"GRANULOMA DE ENCÉFALO CAUSADO POR SCHISTOSOMA JAPONICUM"
  },
  {
    "codigo":203645000,
    "descripcion":"ESCOLIOSIS POSTURAL"
  },
  {
    "codigo":301949001,
    "descripcion":"REACCIÓN PUPILAR CERCANA BRUSCA"
  },
  {
    "codigo":7037003,
    "descripcion":"SÍNDROME XTE"
  },
  {
    "codigo":16288421000119101,
    "descripcion":"DISECCIÓN DE ARTERIA FEMORAL DERECHA"
  },
  {
    "codigo":236413007,
    "descripcion":"GLOMERULONEFRITIS MEMBRANOSA - ESTADIO I"
  },
  {
    "codigo":365650001,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA RECONOCER LAS PARTES DEL PROPIO CUERPO"
  },
  {
    "codigo":431186002,
    "descripcion":"RECHAZO ACELERADO DE TRASPLANTE CARDÍACO"
  },
  {
    "codigo":169042001,
    "descripcion":"CINERRADIOGRAFÍA NORMAL"
  },
  {
    "codigo":70738004,
    "descripcion":"HIPOTRICOSIS PALPEBRAL"
  },
  {
    "codigo":15960741000119103,
    "descripcion":"ANGINA INESTABLE DEBIDA A ARTERIOESCLEROSIS DE BYPASS CON INJERTO DE ARTERIA CORONARIA BIOLÓGICA NO AUTÓLOGA"
  },
  {
    "codigo":300114001,
    "descripcion":"PABELLÓN AURICULAR DESPIGMENTADO"
  },
  {
    "codigo":170877009,
    "descripcion":"CAMBIO EN LOS SÍNTOMAS URINARIOS"
  },
  {
    "codigo":234578009,
    "descripcion":"OPSONIZACIÓN DEFECTUOSA DE CÉLULAS FAGOCÍTICAS"
  },
  {
    "codigo":5202009,
    "descripcion":"LESIÓN TRAUMÁTICA CEREBRAL CON HERIDA INTRACRANEAL ABIERTA Y CONCUSIÓN"
  },
  {
    "codigo":298279006,
    "descripcion":"NÓDULO MUSCULAR"
  },
  {
    "codigo":36135007,
    "descripcion":"ENDOCARDITIS NO INFECCIOSA"
  },
  {
    "codigo":296444000,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE TEOFILINA"
  },
  {
    "codigo":16016191000119100,
    "descripcion":"CONDROCALCINOSIS DE AMBOS TOBILLOS"
  },
  {
    "codigo":1532007,
    "descripcion":"FARINGITIS VIRAL"
  },
  {
    "codigo":196305005,
    "descripcion":"ODONTOCLASIA"
  },
  {
    "codigo":294609008,
    "descripcion":"ALERGIA A CAPREOMICINA"
  },
  {
    "codigo":63398001,
    "descripcion":"INFECCIÓN BACTERIANA CAUSADA POR PSEUDOMONAS"
  },
  {
    "codigo":391078003,
    "descripcion":"ECOGRAFÍA CUANTITATIVA DE TALÓN - PUNTAJE T"
  },
  {
    "codigo":782459000,
    "descripcion":"HIPERHIDROSIS FOCAL PRIMARIA DE AMBAS PALMAS DE LAS MANOS"
  },
  {
    "codigo":292774009,
    "descripcion":"REACCIÓN ADVERSA A ACEITE FIJO"
  },
  {
    "codigo":1306747001,
    "descripcion":"ENFERMEDAD POR DEFICIENCIA DE ISOBUTIRIL-COENZIMA A DESHIDROGENASA"
  },
  {
    "codigo":127099003,
    "descripcion":"LINFADENOPATÍA PREPERICÁRDICA"
  },
  {
    "codigo":733448000,
    "descripcion":"DEFICIENCIA DE GUANILATO CICLASA 2C"
  },
  {
    "codigo":28795002,
    "descripcion":"OTITIS MEDIA SUBAGUDA EXUDATIVA"
  },
  {
    "codigo":290939006,
    "descripcion":"INTOXICACIÓN POR PIRACETAM"
  },
  {
    "codigo":94331006,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL NERVIO HIPOGLOSO"
  },
  {
    "codigo":92496001,
    "descripcion":"OSIFICACIÓN BIPARTITA DEL CENTRO DE LA VÉRTEBRA LUMBAR"
  },
  {
    "codigo":289104004,
    "descripcion":"NO CONTROLA LA RESPIRACIÓN"
  },
  {
    "codigo":90661000,
    "descripcion":"ESPASMO DIAFRAGMÁTICO TÓNICO"
  },
  {
    "codigo":715088008,
    "descripcion":"DEPENDIENTE EN LA TRANSFERENCIA DE LA SILLA A LA CAMA"
  },
  {
    "codigo":25125002,
    "descripcion":"INTOXICACIÓN POR ERODIUM"
  },
  {
    "codigo":1335845008,
    "descripcion":"TRASTORNO RELACIONADO CON EL REGULADOR DE LA CONDUCTANCIA TRANSMEMBRANARIA DE LA FIBROSIS QUÍSTICA"
  },
  {
    "codigo":254501009,
    "descripcion":"NEOPLASIA DE CARA INFERIOR DE PALADAR BLANDO"
  },
  {
    "codigo":418341009,
    "descripcion":"TRASTORNO DE CONDUCCIÓN AURICULOVENTRICULAR"
  },
  {
    "codigo":1137402007,
    "descripcion":"MIOTONÍA POR PERCUSIÓN"
  },
  {
    "codigo":283599000,
    "descripcion":"HERIDA POR PINCHAZO DE AGUJA EN EL CUERO CABELLUDO"
  },
  {
    "codigo":86991001,
    "descripcion":"CONSISTENCIA ANORMAL"
  },
  {
    "codigo":773284000,
    "descripcion":"NEOPLASIA MALIGNA DE CÉLULAS GERMINALES DEL CUERPO UTERINO"
  },
  {
    "codigo":248996001,
    "descripcion":"PELVIS TRANSVERSAMENTE CONTRAÍDA"
  },
  {
    "codigo":19620000,
    "descripcion":"DESPRENDIMIENTO DE RETINA REGMATÓGENO"
  },
  {
    "codigo":185295008,
    "descripcion":"ATENDIDO POR MÉDICO DE GUARDIA"
  },
  {
    "codigo":314532005,
    "descripcion":"CUERPO EXTRAÑO EN EL SEGMENTO ANTERIOR DEL GLOBO OCULAR"
  },
  {
    "codigo":1363108006,
    "descripcion":"ASTILLA EN ESCROTO CON INFECCIÓN"
  },
  {
    "codigo":871588007,
    "descripcion":"SÍNDROME DE COMPRESIÓN DEL TRONCO BRAQUIOCEFÁLICO"
  },
  {
    "codigo":247161000,
    "descripcion":"HEMORRAGIA SUBRETINIANA MACULAR"
  },
  {
    "codigo":312697005,
    "descripcion":"MATERIAL NUCLEAR RETENIDO EN EL CUERPO VÍTREO"
  },
  {
    "codigo":15743961000119108,
    "descripcion":"MASA DE ARTICULACIÓN DE CADERA DERECHA"
  },
  {
    "codigo":771449007,
    "descripcion":"CONGELAMIENTO CON NECROSIS TISULAR DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":443769009,
    "descripcion":"ABSCESO DE ESTRUCTURA GENITAL FEMENINA"
  },
  {
    "codigo":1162830004,
    "descripcion":"ENFERMEDAD LINFOPROLIFERATIVA LIGADA AL CROMOSOMA X DEBIDO A DEFICIENCIA DE XIAP"
  },
  {
    "codigo":441934005,
    "descripcion":"RESULTADO DE PROCEDIMIENTO DE MEDICIÓN, PRESENTE"
  },
  {
    "codigo":48718006,
    "descripcion":"SÍNDROME DE ROBERT SC FOCOMELIA"
  },
  {
    "codigo":278094007,
    "descripcion":"PARTO RÁPIDO"
  },
  {
    "codigo":343001000119109,
    "descripcion":"MELASMA DE PÁRPADO IZQUIERDO Y ÁREA PERIOCULAR"
  },
  {
    "codigo":210723000,
    "descripcion":"LESIÓN POR DESOLLAMIENTO DE TALÓN"
  },
  {
    "codigo":276259003,
    "descripcion":"PARO RESPIRATORIO PREVIO A PARO CARDÍACO"
  },
  {
    "codigo":440099005,
    "descripcion":"RESULTADO DE ABSORCIOMETRÍA DUAL POR RAYOS X DE CUELLO DE FÉMUR, OSTEOPENIA"
  },
  {
    "codigo":1259299005,
    "descripcion":"FORMACIÓN DE TEJIDO DE GRANULACIÓN EN SITIO DE FRACTURA DE RAÍZ DE DIENTE"
  },
  {
    "codigo":866083008,
    "descripcion":"INFECCIÓN DE PÁRPADO CAUSADA POR MYCOBACTERIUM TUBERCULOSIS"
  },
  {
    "codigo":1290232003,
    "descripcion":"ARTROFIBROSIS DE PIE"
  },
  {
    "codigo":405496006,
    "descripcion":"INCAPACIDAD PARA SUMINISTRAR VENTILACIÓN MECÁNICA AL PACIENTE"
  },
  {
    "codigo":208888008,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA PROXIMAL DE DEDO DE LA MANO"
  },
  {
    "codigo":698573001,
    "descripcion":"HEMATOMA INFECTADO"
  },
  {
    "codigo":403661001,
    "descripcion":"LIPOATROFIA CAUSADA POR FÁRMACO INYECTADO"
  },
  {
    "codigo":43213000,
    "descripcion":"GRANULOMA POR TATUAJE"
  },
  {
    "codigo":700408008,
    "descripcion":"REFLEJO DE HOFFMAN DUDOSO"
  },
  {
    "codigo":1255629002,
    "descripcion":"CARCINOMA DE CÉLULAS EN ANILLO DE SELLO DE PULMÓN"
  },
  {
    "codigo":239821006,
    "descripcion":"ARTRITIS INFLAMATORIA SECUNDARIA"
  },
  {
    "codigo":77816008,
    "descripcion":"ACNÉ POR DETERGENTES"
  },
  {
    "codigo":870323006,
    "descripcion":"VÍA VENOSA PULMONAR ANÓMALA OBSTRUIDA"
  },
  {
    "codigo":272589009,
    "descripcion":"POSICIÓN EN EL AGUA"
  },
  {
    "codigo":10939661000119102,
    "descripcion":"LACERACIÓN DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":303522000,
    "descripcion":"INCAPAZ DE PONERSE LA PELUCA"
  },
  {
    "codigo":237986005,
    "descripcion":"TRASTORNO DE LOS COMPLEJOS DE LA CADENA RESPIRATORIA MITOCONDRIAL"
  },
  {
    "codigo":762274007,
    "descripcion":"ÚLCERA DE ESTÓMAGO DEBIDA A INFECCIÓN"
  },
  {
    "codigo":205218007,
    "descripcion":"DEFICIENCIA PERONEA CONGÉNITA TIPO III"
  },
  {
    "codigo":301687007,
    "descripcion":"CAPAZ DE RODAR EN LA CAMA"
  },
  {
    "codigo":267084003,
    "descripcion":"INESTABILIDAD PRESENTE"
  },
  {
    "codigo":70476006,
    "descripcion":"TRASTORNO DEL QUIASMA ÓPTICO"
  },
  {
    "codigo":365388007,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA REALIZAR ACTIVIDADES EDUCATIVAS"
  },
  {
    "codigo":299852009,
    "descripcion":"REFLEJO ABDOMINAL DISMINUIDO"
  },
  {
    "codigo":724001005,
    "descripcion":"SÍNDROME DE RETINITIS PIGMENTOSA, DISCAPACIDAD INTELECTUAL, SORDERA E HIPOGENITALISMO"
  },
  {
    "codigo":298017006,
    "descripcion":"PELVIS CONGELADA NO MALIGNA, FEMENINA"
  },
  {
    "codigo":230646002,
    "descripcion":"NEUROPATÍA INTERCOSTAL"
  },
  {
    "codigo":165110002,
    "descripcion":"ÍNDICE METABÓLICO BASAL POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":34038005,
    "descripcion":"ADHERENCIA DE PLEURA"
  },
  {
    "codigo":99751000119103,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE CÓRNEA"
  },
  {
    "codigo":66806007,
    "descripcion":"SIGNOS DE ANORMALIDAD EN EL EEG, POR ESTIMULACIÓN SONORA"
  },
  {
    "codigo":345511000119103,
    "descripcion":"QUERATOCONO INESTABLE DE AMBOS OJOS"
  },
  {
    "codigo":1082791000119104,
    "descripcion":"NEURITIS ACÚSTICA DE AMBOS OÍDOS DEBIDA A ENFERMEDAD INFECCIOSA"
  },
  {
    "codigo":425419005,
    "descripcion":"ISQUEMIA INFERIOR EN EL ELECTROCARDIOGRAMA"
  },
  {
    "codigo":10667431000119105,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN DE PIERNA IZQUIERDA ESTADIO II"
  },
  {
    "codigo":785867009,
    "descripcion":"HEMORRAGIA EXCESIVA DEBIDA A INTERRUPCIÓN INDUCIDA DE EMBARAZO Y POSTERIOR A ELLA"
  },
  {
    "codigo":292512003,
    "descripcion":"REACCIÓN ADVERSA A LA METILDOPA"
  },
  {
    "codigo":1144480005,
    "descripcion":"CANTIDAD DE CAÍDAS DISMINUIDA"
  },
  {
    "codigo":95904006,
    "descripcion":"POTENCIACIÓN DE INTERACCIÓN FARMACOLÓGICA"
  },
  {
    "codigo":194208007,
    "descripcion":"OTITIS EXTERNA CRÓNICA MONILIÁSICA"
  },
  {
    "codigo":388981000,
    "descripcion":"SÍNDROME DEL CUELLO CORTO CONGÉNITO"
  },
  {
    "codigo":290677002,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ÓXIDO MERCÚRICO"
  },
  {
    "codigo":126837005,
    "descripcion":"NEOPLASIA DEL INTESTINO GRUESO"
  },
  {
    "codigo":716661006,
    "descripcion":"NEOPLASIA DE CORAZÓN EN LA INFANCIA"
  },
  {
    "codigo":94069006,
    "descripcion":"NEOPLASIA PRIMARIA MALIGNA DE LAS MENINGES ESPINALES"
  },
  {
    "codigo":419914000,
    "descripcion":"REACCIÓN ADVERSA A AGENTE ANESTÉSICO"
  },
  {
    "codigo":782197009,
    "descripcion":"INTOLERANCIA A SUSTANCIA"
  },
  {
    "codigo":714826001,
    "descripcion":"HEMATURIA PERSISTENTE CONCOMITANTE CON GLOMERULONEFRITIS PROLIFERATIVA MESANGIAL DIFUSA Y DEBIDA A ELLA"
  },
  {
    "codigo":59466002,
    "descripcion":"SEGUNDO TRIMESTRE DEL EMBARAZO"
  },
  {
    "codigo":92234004,
    "descripcion":"NEOPLASIA BENIGNA DE MÚSCULO DEL TÓRAX"
  },
  {
    "codigo":190538008,
    "descripcion":"INSUFICIENCIA OVÁRICA POSABLATIVA"
  },
  {
    "codigo":287007001,
    "descripcion":"ARTRITIS REUMATOIDE DE ARTICULACIÓN DE LA MANO"
  },
  {
    "codigo":385311000,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA DISTAL DE MUCOSA, NO AFECTADO POR CARCINOMA IN SITU"
  },
  {
    "codigo":319041000119104,
    "descripcion":"ARTRITIS REUMATOIDEA SERONEGATIVA DE ARTICULACIÓN DE CADERA IZQUIERDA"
  },
  {
    "codigo":450847001,
    "descripcion":"RESPONDE AL DOLOR"
  },
  {
    "codigo":254239000,
    "descripcion":"RETRACCIÓN CONGÉNITA DE PEZÓN"
  },
  {
    "codigo":186868000,
    "descripcion":"RECIDIVA SEROLÓGICA LUEGO DEL TRATAMIENTO CONTRA LA SÍFILIS INICIAL LATENTE"
  },
  {
    "codigo":283337001,
    "descripcion":"PICADURA DE INSECTO EN LA REGIÓN PÉLVICA"
  },
  {
    "codigo":711156009,
    "descripcion":"SÍNDROME DE BAJA ESTATURA, FACIES CARACTERÍSTICA, DISCAPACIDAD INTELECTUAL, MACRODONCIA Y ANOMALÍAS ESQUELÉTICAS"
  },
  {
    "codigo":12115521000119107,
    "descripcion":"QUEMADURA QUÍMICA DE RODILLA DERECHA"
  },
  {
    "codigo":1331913009,
    "descripcion":"VARIANTE ESTRUCTURAL"
  },
  {
    "codigo":292571000119103,
    "descripcion":"TRASTORNO DE NERVIO SAFENO EXTERNO IZQUIERDO"
  },
  {
    "codigo":248734007,
    "descripcion":"DISMINUCIÓN DE LA AMPLITUD DE LA ONDA \"Y\" DEL PULSO VENOSO YUGULAR"
  },
  {
    "codigo":314270008,
    "descripcion":"HIPERPLASIA PRIMARIA PERSISTENTE DEL CUERPO VÍTREO"
  },
  {
    "codigo":281502009,
    "descripcion":"LUXACIÓN ERECTA"
  },
  {
    "codigo":246899002,
    "descripcion":"CONJUNTIVA PALPEBRAL - HALLAZGO"
  },
  {
    "codigo":17523003,
    "descripcion":"MOSAICO GENÉTICO"
  },
  {
    "codigo":1297310008,
    "descripcion":"CELULITIS DE DEDO DE PIE DERECHO"
  },
  {
    "codigo":707486007,
    "descripcion":"CARCINOMA BASALOIDE PRIMARIO DE HIPOFARINGE"
  },
  {
    "codigo":115827005,
    "descripcion":"FENOTIPO LUTHERAN DÉBIL"
  },
  {
    "codigo":771187008,
    "descripcion":"SÍNDROME DE CAMPTODACTILIA, ARTROPATÍA, COXA VARA, PERICARDITIS"
  },
  {
    "codigo":1162568005,
    "descripcion":"EMULSIFICACIÓN POSOPERATORIA DE ACEITE DE SILICONA EN LOS OJOS"
  },
  {
    "codigo":1085301000119100,
    "descripcion":"FISURA DE PALADAR DURO Y LABIO"
  },
  {
    "codigo":212296007,
    "descripcion":"LESIÓN TRAUMÁTICA NO EXPUESTA DE NERVIO INTERCOSTOBRAQUIAL"
  },
  {
    "codigo":1259037000,
    "descripcion":"NEUROPATÍA AUTONÓMICA DEBIDA A NEOPLASIA ENDOCRINA MÚLTIPLE TIPO 2B"
  },
  {
    "codigo":310600009,
    "descripcion":"NEOPLASIA BENIGNA DEL CANTO DEL OJO"
  },
  {
    "codigo":46621007,
    "descripcion":"ATELECTASIA"
  },
  {
    "codigo":79389008,
    "descripcion":"NEUROPATÍA POR BERIBERI"
  },
  {
    "codigo":306930001,
    "descripcion":"MOVILIDAD DEL ESTRIBO, REDUCIDA"
  },
  {
    "codigo":274162005,
    "descripcion":"ESGUINCE DE REGIÓN DORSAL"
  },
  {
    "codigo":110322008,
    "descripcion":"OCLUSIÓN MESIAL EN LA DENTICIÓN PRIMARIA"
  },
  {
    "codigo":405234008,
    "descripcion":"MICCIÓN INADECUADA"
  },
  {
    "codigo":403399001,
    "descripcion":"PIEL LAXA LUEGO DE REACCIÓN ALÉRGICA"
  },
  {
    "codigo":1157063004,
    "descripcion":"NEOPLASIA MALIGNA DE REGIÓN DE COLUMNA VERTEBRAL"
  },
  {
    "codigo":404104001,
    "descripcion":"PAPULOSIS LINFOMATOIDE TIPO B (TIPO MICOSIS FUNGOIDE)"
  },
  {
    "codigo":237724003,
    "descripcion":"TRASTORNO HIPOTALÁMICO DEL APETITO"
  },
  {
    "codigo":270492004,
    "descripcion":"BLOQUEO AURÍCULO-VENTRICULAR DE PRIMER GRADO"
  },
  {
    "codigo":1351836007,
    "descripcion":"SÍNDROME DE ALKURAYA KUCINSKAS"
  },
  {
    "codigo":39281000,
    "descripcion":"QUERATITIS ESTRIADA"
  },
  {
    "codigo":41116009,
    "descripcion":"INFECCIÓN POR ESPIROQUETAS"
  },
  {
    "codigo":235889003,
    "descripcion":"HEPATITIS CRÓNICA FARMACÓGENA"
  },
  {
    "codigo":1153393004,
    "descripcion":"NEOPLASIA MALIGNA MIXTA COMPLEJA Y DEL ESTROMA DE EPIPLÓN"
  },
  {
    "codigo":321551000119102,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE TENDÓN FLEXOR DE MUSLO IZQUIERDO"
  },
  {
    "codigo":102982003,
    "descripcion":"REFLEJOS ASIMÉTRICOS"
  },
  {
    "codigo":397894003,
    "descripcion":"DEFECTO PERICÁRDICO CONGÉNITO"
  },
  {
    "codigo":365126004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA SENTARSE EN UNA SILLA Y LEVANTARSE DE ELLA"
  },
  {
    "codigo":234054006,
    "descripcion":"VÁRICES DE LIGAMENTO ANCHO"
  },
  {
    "codigo":299590006,
    "descripcion":"AMPLITUD DE FLEXIÓN PASIVA DE DEDO DEL PIE NORMAL"
  },
  {
    "codigo":35611005,
    "descripcion":"DOLOR A LA DESCOMPRESIÓN"
  },
  {
    "codigo":721904001,
    "descripcion":"SÍNDROME DE ROMBO"
  },
  {
    "codigo":230384001,
    "descripcion":"EPILEPSIA PARCIAL ATÍPICA BENIGNA, INFANTIL"
  },
  {
    "codigo":295920004,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE SERTRALINA"
  },
  {
    "codigo":263152008,
    "descripcion":"FRACTURAS FACIALES MÚLTIPLES"
  },
  {
    "codigo":359621002,
    "descripcion":"QUISTES PERIVENTRICULARES ADQUIRIDOS DEL RECIÉN NACIDO"
  },
  {
    "codigo":1176986000,
    "descripcion":"HIDÁTIDE POLIQUÍSTICO POR ECHINOCOCCUS OLIGARTHUS"
  },
  {
    "codigo":783770002,
    "descripcion":"MIOPATÍA DE COMIENZO TARDÍO RELACIONADA CON ALFA-B CRISTALINA"
  },
  {
    "codigo":292250005,
    "descripcion":"REACCIÓN ADVERSA A UN ALCALOIDE DE LA VINCA"
  },
  {
    "codigo":423322005,
    "descripcion":"PIELONEFRITIS OBSTRUCTIVA RECURRENTE"
  },
  {
    "codigo":295081000119103,
    "descripcion":"SUBLUXACIÓN CONGÉNITA DE CABEZA DE RADIO"
  },
  {
    "codigo":126575000,
    "descripcion":"NEOPLASIA DE HUESO SEMILUNAR"
  },
  {
    "codigo":93807001,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL LÓBULO FRONTAL"
  },
  {
    "codigo":28271003,
    "descripcion":"ENFERMEDAD NO INFLAMATORIA DE LA VULVA"
  },
  {
    "codigo":716399006,
    "descripcion":"CAPAZ DE SELECCIONAR LA VESTIMENTA ADECUADA"
  },
  {
    "codigo":91972003,
    "descripcion":"NEOPLASIA BENIGNA DE LA CARA ANTERIOR DE LA EPIGLOTIS"
  },
  {
    "codigo":59204004,
    "descripcion":"ABORTO ESPONTÁNEO CON EMBOLIA SÉPTICA"
  },
  {
    "codigo":26436007,
    "descripcion":"TRASTORNO DEL EQUILIBRIO ACIDOBÁSICO"
  },
  {
    "codigo":286745000,
    "descripcion":"CARÁCTER OPTIMISTA"
  },
  {
    "codigo":1237017003,
    "descripcion":"CON RIESGO ELEVADO DE EXPOSICIÓN A VIRUS DE PAROTIDITIS"
  },
  {
    "codigo":253977007,
    "descripcion":"TUMOR CONGÉNITO DE MÚSCULO ESTERNOCLEIDOMASTOIDEO"
  },
  {
    "codigo":284910002,
    "descripcion":"NO USA EL INODORO"
  },
  {
    "codigo":1087811000119103,
    "descripcion":"HEMORRAGIA GÁSTRICA DEBIDA A GASTRITIS IRRITATIVA"
  },
  {
    "codigo":184771000,
    "descripcion":"CERTIFICADOS VARIOS COMPLETOS"
  },
  {
    "codigo":446915006,
    "descripcion":"FILTRACIÓN DESDE COLA DE PÁNCREAS"
  },
  {
    "codigo":1264280000,
    "descripcion":"RESORCIÓN EXTERNA IDIOPÁTICA DE RAÍZ DE DIENTE"
  },
  {
    "codigo":283075009,
    "descripcion":"EXCORIACIÓN DE LA GARGANTA"
  },
  {
    "codigo":838296001,
    "descripcion":"BUFTALMOS BILATERAL"
  },
  {
    "codigo":707224005,
    "descripcion":"INFECCIÓN RESPIRATORIA AGUDA SEVERA"
  },
  {
    "codigo":410477000,
    "descripcion":"UVEÍTIS INFECCIOSA"
  },
  {
    "codigo":17261001,
    "descripcion":"PROBLEMAS DEL ENVEJECIMIENTO"
  },
  {
    "codigo":314008009,
    "descripcion":"RETINOPATÍA SEROSA CENTRAL INACTIVA CON DESPRENDIMIENTO FOCAL DEL EPITELIO PIGMENTARIO DE LA RETINA"
  },
  {
    "codigo":281240008,
    "descripcion":"EXTENSIÓN DEL ACCIDENTE CEREBROVASCULAR"
  },
  {
    "codigo":246637004,
    "descripcion":"EL OJO NO FUNCIONA CORRECTAMENTE"
  },
  {
    "codigo":215704009,
    "descripcion":"LESIÓN SUFRIDA A BORDO DE MEDIO DE TRANSPORTE ACUÁTICO CAUSADA POR MAQUINARIA DE SALA DE MÁQUINAS, CARGADOR DE MUELLES O ESTIBADOR LESIONADO"
  },
  {
    "codigo":11819331000119107,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN RADIOCARPIANA DERECHA"
  },
  {
    "codigo":50029007,
    "descripcion":"HIPOMAGNESEMIA-HIPERCALCIURIA FAMILIAR"
  },
  {
    "codigo":48194001,
    "descripcion":"HIPERTENSIÓN GESTACIONAL"
  },
  {
    "codigo":736322001,
    "descripcion":"LINFOMA FOLICULAR PEDIÁTRICO"
  },
  {
    "codigo":277570003,
    "descripcion":"LINFOMA CON DERRAME"
  },
  {
    "codigo":408642003,
    "descripcion":"CARCINOMA RENAL DE CÉLULAS DE TRANSICIÓN"
  },
  {
    "codigo":1162306005,
    "descripcion":"ARTRITIS PSORIÁSICA OLIGOARTICULAR"
  },
  {
    "codigo":80962007,
    "descripcion":"TRASTORNO DEL NERVIO GLOSOFARÍNGEO"
  },
  {
    "codigo":275735001,
    "descripcion":"BEBÉ NORMAL AL NACER"
  },
  {
    "codigo":46359005,
    "descripcion":"NEUTROPENIA ASOCIADA CON ENFERMEDAD INFECCIOSA"
  },
  {
    "codigo":324061000119106,
    "descripcion":"LUXACIÓN DE ARTICULACIÓN DE PIE DEBIDA A DISPLASIA CONGÉNITA"
  },
  {
    "codigo":16026231000119100,
    "descripcion":"MALFORMACIÓN ARTERIOVENOSA CONGÉNITA DE EXTREMIDAD SUPERIOR IZQUIERDA"
  },
  {
    "codigo":110060007,
    "descripcion":"LACERACIÓN COMPLEJA CONTAMINADA DE LA FRENTE"
  },
  {
    "codigo":206529002,
    "descripcion":"FECALITOS CONGÉNITOS QUE CAUSAN OBSTRUCCIÓN"
  },
  {
    "codigo":1287873006,
    "descripcion":"BLEFAROFIMA"
  },
  {
    "codigo":1156801007,
    "descripcion":"SÍNDROME DE ACTIVACIÓN MACROFÁGICA DEBIDO A ARTRITIS JUVENIL DE COMIENZO SISTÉMICO"
  },
  {
    "codigo":42689008,
    "descripcion":"PRESIÓN SANGUÍNEA DIASTÓLICA DISMINUIDA"
  },
  {
    "codigo":239297008,
    "descripcion":"GRANULOMATOSIS LINFOMATOIDE DE PULMÓN"
  },
  {
    "codigo":133751000119102,
    "descripcion":"LINFOMA DE COLON"
  },
  {
    "codigo":403137007,
    "descripcion":"LEISHMANIASIS CUTÁNEA LOCALIZADA POR LEISHMANIA MEXICANA"
  },
  {
    "codigo":237462004,
    "descripcion":"INFECCIÓN DEL PEZÓN"
  },
  {
    "codigo":235627001,
    "descripcion":"RUPTURA TRAUMÁTICA DEL ESÓFAGO"
  },
  {
    "codigo":301163006,
    "descripcion":"PULSO CAROTÍDEO AUSENTE"
  },
  {
    "codigo":366699007,
    "descripcion":"AMPLITUD DE MOVIMIENTO PASIVO DE ADUCCIÓN DEL PULGAR - HALLAZGO"
  },
  {
    "codigo":71787009,
    "descripcion":"VAGINISMO PSICOLÓGICO"
  },
  {
    "codigo":299328006,
    "descripcion":"DEFORMIDAD DE ARTICULACIÓN DE RODILLA"
  },
  {
    "codigo":4416007,
    "descripcion":"SÍNDROME DE HEERFORDT"
  },
  {
    "codigo":364864007,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA SENTARSE"
  },
  {
    "codigo":233792008,
    "descripcion":"FÍSTULA BRONCOCUTÁNEA"
  },
  {
    "codigo":266560008,
    "descripcion":"URETEROCELE ADQUIRIDO"
  },
  {
    "codigo":231957003,
    "descripcion":"CICLODIÁLISIS TRAUMÁTICA"
  },
  {
    "codigo":250035005,
    "descripcion":"MARCHA PARAPLÉJICA"
  },
  {
    "codigo":789013005,
    "descripcion":"HERIDA PUNZANTE DE PULGAR SIN CUERPO EXTRAÑO"
  },
  {
    "codigo":2581006,
    "descripcion":"ESPASTICIDAD EN NAVAJA"
  },
  {
    "codigo":363029006,
    "descripcion":"ANOMALÍA CONGÉNITA DE ANEXOS EPIDÉRMICOS"
  },
  {
    "codigo":361194002,
    "descripcion":"FIBROPLASIA PULMONAR PERINATAL"
  },
  {
    "codigo":295658002,
    "descripcion":"SOBREDOSIS DE ANTIBIÓTICO CITOTÓXICO"
  },
  {
    "codigo":1090321000119103,
    "descripcion":"ABSCESO RETROPERITONEAL CONSECUTIVO A PROCEDIMIENTO"
  },
  {
    "codigo":11821841000119103,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN ESTERNOCLAVICULAR IZQUIERDA"
  },
  {
    "codigo":262890007,
    "descripcion":"LESIÓN TRAUMÁTICA DEL TRACTO URINARIO"
  },
  {
    "codigo":721642005,
    "descripcion":"CARCINOMA NEUROENDOCRINO PRIMARIO DE LOCALIZACIONES SUPERPUESTAS DE ESTÓMAGO"
  },
  {
    "codigo":197354009,
    "descripcion":"HEPATOPATÍA TÓXICA"
  },
  {
    "codigo":228287003,
    "descripcion":"BEBE EN LUGARES PÚBLICOS"
  },
  {
    "codigo":293823004,
    "descripcion":"ALERGIA A DOXEPINA"
  },
  {
    "codigo":291988001,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR INHIBIDOR DE LA ENZIMA CONVERTIDORA DE ANGIOTENSINA"
  },
  {
    "codigo":62612003,
    "descripcion":"FIBROSIS DEL PERINEO QUE AFECTA EL EMBARAZO"
  },
  {
    "codigo":128148005,
    "descripcion":"SOPLO CARDÍACO, CATEGORIZADO SEGÚN LA INTENSIDAD"
  },
  {
    "codigo":95380007,
    "descripcion":"CAMBIOS EN LA PIGMENTACIÓN DEL SITIO DE INYECCIÓN"
  },
  {
    "codigo":60777000,
    "descripcion":"LINFANGITIS AGUDA DE CADERA"
  },
  {
    "codigo":191849000,
    "descripcion":"FARMACODEPENDENCIA DE ALUCINÓGENOS, CONTINUA"
  },
  {
    "codigo":1142121001,
    "descripcion":"TAQUICARDIA DE REENTRADA DEL NODO AURICULOVENTRICULAR CON NODOS AURICULOVENTRICULARES GEMELOS"
  },
  {
    "codigo":290153007,
    "descripcion":"INTOXICACIÓN POR FENAZOCINA"
  },
  {
    "codigo":879977008,
    "descripcion":"LESIÓN MUCOSA GÁSTRICA"
  },
  {
    "codigo":124478002,
    "descripcion":"DEFICIENCIA DE AMP NUCLEOSIDASA"
  },
  {
    "codigo":58942006,
    "descripcion":"ERITEMA DISCRÓMICO PERSISTENTE"
  },
  {
    "codigo":778003000,
    "descripcion":"ENFERMEDAD DE CHARCOT-MARIE-TOOTH INTERMEDIA AUTOSÓMICA DOMINANTE CON DOLOR NEUROPÁTICO"
  },
  {
    "codigo":24339001,
    "descripcion":"FÍSTULA SIGMOIDEOVAGINAL"
  },
  {
    "codigo":286483000,
    "descripcion":"CAPAZ DE MEZCLAR INGREDIENTES DE UNA COMIDA"
  },
  {
    "codigo":253715000,
    "descripcion":"TRAYECTO INTRAMURAL DE ARTERIA CORONARIA"
  },
  {
    "codigo":417555004,
    "descripcion":"PRESIÓN INTRAOCULAR DEL OJO IZQUIERDO"
  },
  {
    "codigo":22504001,
    "descripcion":"ÚTERO BILOCULAR"
  },
  {
    "codigo":42491000087106,
    "descripcion":"HERIDA DE NARIZ POR MORDEDURA"
  },
  {
    "codigo":448488004,
    "descripcion":"DEFORMIDAD DE LA PARED TORÁCICA"
  },
  {
    "codigo":284648005,
    "descripcion":"HALLAZGO RELACIONADO CON LA INGESTA DE ALIMENTOS"
  },
  {
    "codigo":39931000087109,
    "descripcion":"LACERACIÓN DE TENDÓN FLEXOR DE PULGAR DERECHO"
  },
  {
    "codigo":10976171000119106,
    "descripcion":"HERIDA PENETRANTE DE OJO DERECHO PROPIAMENTE DICHO"
  },
  {
    "codigo":315581000,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: PUNJABI"
  },
  {
    "codigo":446653004,
    "descripcion":"CUERPO EXTRAÑO EN MIEMBRO INFERIOR"
  },
  {
    "codigo":250045007,
    "descripcion":"MARCHA BAMBOLEANTE"
  },
  {
    "codigo":1231250000,
    "descripcion":"ENTROPIÓN MECÁNICO DE PÁRPADO INFERIOR"
  },
  {
    "codigo":18834007,
    "descripcion":"ARTROPATÍA POR CRISTALES"
  },
  {
    "codigo":444818007,
    "descripcion":"EDENTULISMO PARCIAL"
  },
  {
    "codigo":280978007,
    "descripcion":"INFECCIÓN DE DERIVACIÓN ARTERIOVENOSA"
  },
  {
    "codigo":770663003,
    "descripcion":"TETRASOMÍA 11Q24.1"
  },
  {
    "codigo":703292000,
    "descripcion":"INSUFICIENCIA DE PRÓTESIS DE VÁLVULA TRICÚSPIDE"
  },
  {
    "codigo":705127009,
    "descripcion":"GINGIVITIS DEBIDA A LEUCEMIA"
  },
  {
    "codigo":47932002,
    "descripcion":"QUISTE MUCINOSO HIPERTRÓFICO DE LA VESÍCULA BILIAR"
  },
  {
    "codigo":211772004,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO SUPERFICIAL DE MAMA"
  },
  {
    "codigo":80700005,
    "descripcion":"VESÍCULA FLOTANTE"
  },
  {
    "codigo":1293116008,
    "descripcion":"MALFORMACIÓN CAPILAR DIFUSA CON SOBRECRECIMIENTO"
  },
  {
    "codigo":1260348009,
    "descripcion":"CEFALEA DEBIDA A GLAUCOMA AGUDO DE ÁNGULO ESTRECHO"
  },
  {
    "codigo":408380008,
    "descripcion":"ECOCARDIOGRAMA AMBIGUO"
  },
  {
    "codigo":275473003,
    "descripcion":"INHIBICIÓN LABORAL ESPECÍFICA"
  },
  {
    "codigo":406545003,
    "descripcion":"APOYO DISPONIBLE LAS 24 HORAS"
  },
  {
    "codigo":111633007,
    "descripcion":"FRACTURA EXPUESTA DEL SACRO Y\/O DEL CÓCCIX CON LESIÓN COMPLETA DE LA COLA DE CABALLO MEDULAR"
  },
  {
    "codigo":109798001,
    "descripcion":"FALTA DE DISTANCIA VERTICAL INTERMAXILAR ADECUADA"
  },
  {
    "codigo":240870003,
    "descripcion":"INFECCIÓN POR CAPILLARIA AEROPHILA"
  },
  {
    "codigo":206267000,
    "descripcion":"RECIÉN NACIDO VIVO CON FRECUENCIA CARDÍACA ANORMAL DURANTE EL TRABAJO DE PARTO"
  },
  {
    "codigo":402875000,
    "descripcion":"NEOPLASIA BENIGNA DE ORIGEN EN LA VAINA NERVIOSA"
  },
  {
    "codigo":42427004,
    "descripcion":"CON MAYOR RIESGO DE SOFOCACIÓN"
  },
  {
    "codigo":239035009,
    "descripcion":"DISPLASIA ECTODÉRMICA CON DEFECTO CABELLO-UÑA"
  },
  {
    "codigo":302736004,
    "descripcion":"DEFICIENCIA DE PROTEASA"
  },
  {
    "codigo":211635004,
    "descripcion":"CUERPO EXTRAÑO EN EL YEYUNO"
  },
  {
    "codigo":366437001,
    "descripcion":"AMPLITUD DE MOVIMIENTO PASIVO DE FLEXIÓN LATERAL HACIA LA DERECHA DE LA COLUMNA LUMBAR - HALLAZGO"
  },
  {
    "codigo":169829002,
    "descripcion":"GEMELOS - UNO, MORTINATO; EL OTRO NACIDO VIVO"
  },
  {
    "codigo":399205006,
    "descripcion":"SEUDOFOLICULITIS DE LA BARBA"
  },
  {
    "codigo":299066000,
    "descripcion":"AMPLITUD DE FLEXIÓN ACTIVA DE DEDO DE LA MANO AUMENTADA"
  },
  {
    "codigo":202597009,
    "descripcion":"CHASQUIDO DE HOMBRO"
  },
  {
    "codigo":102458000,
    "descripcion":"SÍNDROME DEL LACTANTE SACUDIDO"
  },
  {
    "codigo":725050005,
    "descripcion":"OSTEOPETROSIS AUTOSÓMICA DOMINANTE TIPO 2"
  },
  {
    "codigo":69690008,
    "descripcion":"ALUCINACIONES HIPNOPÓMPICAS"
  },
  {
    "codigo":297231002,
    "descripcion":"ACIDURIA 3-METILGLUTACÓNICA ACIDURIA TIPO 2"
  },
  {
    "codigo":166159005,
    "descripcion":"ANTÍGENO PROSTÁTICO ESPECÍFICO DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":197092000,
    "descripcion":"HEMORRAGIA DE INTESTINO GRUESO CON ENFERMEDAD DIVERTICULAR DE INTESTINO GRUESO"
  },
  {
    "codigo":721380000,
    "descripcion":"SÍNDROME DEL CORDÓN ANTERIOR DE MÉDULA ESPINAL CERVICAL"
  },
  {
    "codigo":67855008,
    "descripcion":"ENFERMEDAD DE NIEMANN - PICK, TIPO C, FORMA SUBAGUDA"
  },
  {
    "codigo":66020004,
    "descripcion":"SÍNDROME MEDULAR POSTERIOR DEBIDO A FRACTURA EXPUESTA A NIVEL DE C5 - C7"
  },
  {
    "codigo":262628006,
    "descripcion":"LACERACIÓN DE SUPERFICIE INTRABUCAL DE LABIO"
  },
  {
    "codigo":360932008,
    "descripcion":"DEFICIENCIA DE AMINOPEPTIDASA"
  },
  {
    "codigo":293561005,
    "descripcion":"REACCIÓN ADVERSA A LA ISOXSUPRINA"
  },
  {
    "codigo":162489006,
    "descripcion":"SÍNTOMA QUE MEJORA CON EL CALOR"
  },
  {
    "codigo":783246000,
    "descripcion":"SÍNDROME DE MEGALOCÓRNEA, ESFEROFAQUIA Y GLAUCOMA SECUNDARIO"
  },
  {
    "codigo":62350000,
    "descripcion":"GRANULOMA CUTÁNEO POR ALMIDÓN"
  },
  {
    "codigo":95118000,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA PARED SUPERIOR DE LA NASOFARINGE"
  },
  {
    "codigo":129721008,
    "descripcion":"NUEVO HALLAZGO DESDE LA MAMOGRAFÍA PREVIA"
  },
  {
    "codigo":160654005,
    "descripcion":"DISPUESTO A SER DONANTE"
  },
  {
    "codigo":11771411000119103,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN DE CODO DERECHO"
  },
  {
    "codigo":226190005,
    "descripcion":"DIETA CON BAJO CONTENIDO DE DIÓXIDO DE SULFURO"
  },
  {
    "codigo":289891001,
    "descripcion":"DURACIÓN DEL CICLO MENSTRUAL - HALLAZGO"
  },
  {
    "codigo":91448003,
    "descripcion":"FÍSTULA ILEORRECTAL"
  },
  {
    "codigo":419128007,
    "descripcion":"EXPRESA VERBALMENTE UN PLAN PARA LA REDUCCIÓN DE IMPEDIMENTOS PARA EL CUMPLIMIENTO DE LA MEDICACIÓN"
  },
  {
    "codigo":451411000124105,
    "descripcion":"TRASTORNO DE EXTREMIDAD SUPERIOR IZQUIERDA"
  },
  {
    "codigo":124216009,
    "descripcion":"DEFICIENCIA DE TRIPTÓFANO 5 - MONOOXIGENASA"
  },
  {
    "codigo":286221003,
    "descripcion":"NO USA EL FLUJO DE AIRE PULMONAR AL HABLAR"
  },
  {
    "codigo":253453006,
    "descripcion":"MÚSCULO PAPILAR DE VÁLVULA AURICULOVENTRICULAR COMÚN HIPOPLÁSICO"
  },
  {
    "codigo":12400301000119102,
    "descripcion":"DOLOR CRÓNICO POSTERIOR A ARTROPLASTIA TOTAL DE CADERA DERECHA"
  },
  {
    "codigo":187917009,
    "descripcion":"NEOPLASIA MALIGNA DE VÉRTEBRA DORSAL"
  },
  {
    "codigo":87778004,
    "descripcion":"ESGUINCE DE MANO"
  },
  {
    "codigo":1300194008,
    "descripcion":"SÍNDROME DE MITCHELL"
  },
  {
    "codigo":20407004,
    "descripcion":"HEMATURIA BENIGNA"
  },
  {
    "codigo":282551005,
    "descripcion":"DIFICULTAD PARA EVITAR OBSTÁCULOS AL CORRER"
  },
  {
    "codigo":1003447007,
    "descripcion":"ENFERMEDAD DE PELIZAEUS-MERZBACHER, SÍNDROME NULO"
  },
  {
    "codigo":774071007,
    "descripcion":"SÍNDROME DE PANCITOPENIA CON RETRASO DEL DESARROLLO"
  },
  {
    "codigo":870540001,
    "descripcion":"CONTUSIÓN DE ROMBENCÉFALO"
  },
  {
    "codigo":446391007,
    "descripcion":"LESIÓN TRAUMÁTICA DE CABEZA DE PÁNCREAS"
  },
  {
    "codigo":772236003,
    "descripcion":"INCAPAZ DE MANTENER EL EQUILIBRIO AL PARARSE CON UN PIE DELANTE DE OTRO"
  },
  {
    "codigo":444556003,
    "descripcion":"ARTRITIS SERONEGATIVA DE ARTICULACIÓN DE COLUMNA VERTEBRAL"
  },
  {
    "codigo":1263756005,
    "descripcion":"HEMATOMA SUBUNGUEAL DE DEDO ÍNDICE"
  },
  {
    "codigo":247948004,
    "descripcion":"RESISTENCIA A LOS CAMBIOS DE LOS OBJETOS DOMÉSTICOS"
  },
  {
    "codigo":1362060007,
    "descripcion":"CONJUNTIVITIS HEMORRÁGICA AGUDA CAUSADA POR ENTEROVIRUS"
  },
  {
    "codigo":213345000,
    "descripcion":"LESIÓN TRAUMÁTICA QUE COMPROMETE MÚLTIPLES REGIONES CORPORALES"
  },
  {
    "codigo":16737003,
    "descripcion":"INTENSIDAD VOCAL ANORMAL"
  },
  {
    "codigo":770401007,
    "descripcion":"SÍNDROME DE MICRODELECIÓN 10Q22.3Q23.3"
  },
  {
    "codigo":735798001,
    "descripcion":"MÚLTIPLES LESIONES TRAUMÁTICAS DE PELVIS"
  },
  {
    "codigo":703030002,
    "descripcion":"CHRYSEOBACTERIUM INDOLOGENES O EMPEDOBACTER BREVIS"
  },
  {
    "codigo":211510001,
    "descripcion":"CONTUSIÓN DE LA MUÑECA, SUPERFICIE PALMAR"
  },
  {
    "codigo":1260086007,
    "descripcion":"CARCINOMA ENDOMETRIOIDE DE ENDOMETRIO"
  },
  {
    "codigo":209675003,
    "descripcion":"SECCIÓN EXPUESTA DE LIGAMENTO DEL PULGAR, ARTICULACIÓN METACARPOFALÁNGICA, LIGAMENTO LATERAL RADIAL"
  },
  {
    "codigo":111371005,
    "descripcion":"HEMORRAGIA SUBCAPSULAR DEL HÍGADO"
  },
  {
    "codigo":331591000119105,
    "descripcion":"LAGOFTALMOS DE PÁRPADO SUPERIOR DERECHO"
  },
  {
    "codigo":1354720002,
    "descripcion":"FRACTURA DE CUARTA COSTILLA"
  },
  {
    "codigo":109536003,
    "descripcion":"EXFOLIACIÓN DEMORADA DE UN SOLO DIENTE"
  },
  {
    "codigo":699360006,
    "descripcion":"ESPACIO DE LEEWAY AUSENTE"
  },
  {
    "codigo":240608007,
    "descripcion":"DONOVANOSIS - LESIÓN NO GENITAL"
  },
  {
    "codigo":402613002,
    "descripcion":"HIPERMELANOSIS POR TRASTORNO NUTRICIONAL"
  },
  {
    "codigo":304309004,
    "descripcion":"AMPLITUD DEL MOVIMIENTO DE DEDO DE LA MANO, DISMINUIDA"
  },
  {
    "codigo":763061004,
    "descripcion":"SÍNDROME DE MICRODUPLICACIÓN 20Q11.2"
  },
  {
    "codigo":238773009,
    "descripcion":"LIVEDO RETICULARIS IDIOPÁTICO"
  },
  {
    "codigo":1285514002,
    "descripcion":"RETINOPATÍA NO PROLIFERATIVA DEBIDA A DREPANOCITOSIS"
  },
  {
    "codigo":1252746001,
    "descripcion":"SUBLUXACIÓN DE ARTICULACIÓN RADIOCUBITAL DISTAL"
  },
  {
    "codigo":73098005,
    "descripcion":"URTICARIA COLINÉRGICA"
  },
  {
    "codigo":1187210007,
    "descripcion":"SÍNDROME EXTRAPIRAMIDAL CON DISCAPACIDAD INTELECTUAL Y EPILEPSIA"
  },
  {
    "codigo":202335003,
    "descripcion":"SEPARACIÓN DEL RODETE ACETABULAR"
  },
  {
    "codigo":366175006,
    "descripcion":"PATRÓN DE LA CONDUCCIÓN CARDÍACA - HALLAZGO"
  },
  {
    "codigo":169567006,
    "descripcion":"EMBARAZO NO PLANEADO Y NO DESEADO"
  },
  {
    "codigo":398943008,
    "descripcion":"NEVO MELANOCÍTICO CONGÉNITO PIGMENTADO DE PIEL"
  },
  {
    "codigo":38495009,
    "descripcion":"HIPOCALIEMIA, PÉRDIDAS RENALES EXCESIVAS"
  },
  {
    "codigo":1281844004,
    "descripcion":"DISTONÍA 28"
  },
  {
    "codigo":298804009,
    "descripcion":"AMPLITUD DE ABDUCCIÓN PASIVA DE HOMBRO NORMAL"
  },
  {
    "codigo":1148937001,
    "descripcion":"HIDRONEFROSIS CONGÉNITA DEBIDA A OBSTRUCCIÓN DE VEJIGA URINARIA"
  },
  {
    "codigo":428041004,
    "descripcion":"TIROIDITIS GRANULOMATOSA SUBAGUDA"
  },
  {
    "codigo":295134000,
    "descripcion":"SOBREDOSIS DE SALICILATO"
  },
  {
    "codigo":426206001,
    "descripcion":"DOLOR CONSTANTE"
  },
  {
    "codigo":222008,
    "descripcion":"EPIGLOTITIS AGUDA CON OBSTRUCCIÓN"
  },
  {
    "codigo":342421000119100,
    "descripcion":"FILARIASIS LINFÁTICA DE PÁRPADO DERECHO"
  },
  {
    "codigo":1089941000119101,
    "descripcion":"GINGIVITIS CRÓNICA DEBIDA A ENFERMEDAD GINGIVAL NO INDUCIDA POR PLACA"
  },
  {
    "codigo":11857301000119101,
    "descripcion":"HEMATOMA DE PIE IZQUIERDO"
  },
  {
    "codigo":12181000119103,
    "descripcion":"GRANULOMA POR CONTACTO DE LARINGE"
  },
  {
    "codigo":1077141000119104,
    "descripcion":"QUISTE ÓSEO DE TOBILLO DERECHO"
  },
  {
    "codigo":135061000119104,
    "descripcion":"TROMBOSIS CRÓNICA DE VENA CAVA SUPERIOR"
  },
  {
    "codigo":1082261000119101,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE PIEL DE HOMBRO DERECHO"
  },
  {
    "codigo":16237461000119104,
    "descripcion":"DISFUNCIÓN DE GLÁNDULA DE MEIBOMIO DE OJO IZQUIERDO"
  },
  {
    "codigo":12400021000119108,
    "descripcion":"TRAUMATISMO ACÚSTICO EXPLOSIVO DE AMBOS OÍDOS"
  },
  {
    "codigo":15960981000119105,
    "descripcion":"TROMBO MURAL DE VENTRÍCULO IZQUIERDO POSTERIOR A INFARTO AGUDO DE MIOCARDIO"
  },
  {
    "codigo":337301000119104,
    "descripcion":"QUISTE DE LA GLÁNDULA DE MEIBOMIO DEL PÁRPADO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":31155007,
    "descripcion":"COLESTASIS INTRAHEPÁTICA RECIDIVANTE BENIGNA"
  },
  {
    "codigo":1092501000119104,
    "descripcion":"CHOQUE SÉPTICO CONCOMITANTE CON DISFUNCIÓN ORGÁNICA AGUDA DEBIDO A GONOCOCO"
  },
  {
    "codigo":477380501000119109,
    "descripcion":"PORTADOR DE DEFICIENCIA DE DIHIDROLIPOAMIDA DESHIDROGENASA"
  },
  {
    "codigo":1340040004,
    "descripcion":"LEUCOENCEFALOPATÍA AGUDA REVERSIBLE CON AUMENTO DE ALFA CETOGLUTARATO EN ORINA"
  },
  {
    "codigo":301461000119107,
    "descripcion":"ABSCESO DE BOLSA SEROSA DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":1010525003,
    "descripcion":"ESCLEROSIS DE EPÍFISIS DE FALANGE DISTAL DE TERCER DEDO DE PIE CON RADIOPACIDAD AUMENTADA"
  },
  {
    "codigo":93021003,
    "descripcion":"ANOMALÍA CONGÉNITA DEL PUBIS"
  },
  {
    "codigo":781149006,
    "descripcion":"LACERACIÓN ACCIDENTAL DE UN VASO SANGUÍNEO DURANTE UN PROCEDIMIENTO"
  },
  {
    "codigo":29320008,
    "descripcion":"RITMO ECTÓPICO"
  },
  {
    "codigo":846685008,
    "descripcion":"INFECCIÓN DE VÍA BILIAR"
  },
  {
    "codigo":255026000,
    "descripcion":"ASTROCITOMA DE LA RETINA"
  },
  {
    "codigo":289629009,
    "descripcion":"FONDO UTERINO POR ENCIMA DEL NIVEL UMBILICAL"
  },
  {
    "codigo":16881941000119104,
    "descripcion":"LESIÓN ESCLEROSANTE COMPLEJA DE MAMA DERECHA"
  },
  {
    "codigo":285959005,
    "descripcion":"CAPAZ DE RETIRAR EL TAPÓN DEL DESAGÜE"
  },
  {
    "codigo":449799008,
    "descripcion":"ASTROCITOMA SUBEPENDIMARIO DE CÉLULAS GIGANTES"
  },
  {
    "codigo":284124002,
    "descripcion":"CONTROLA LA POSICIÓN DEL TRONCO"
  },
  {
    "codigo":54748006,
    "descripcion":"LUXACIÓN EXPUESTA DEL PULGAR"
  },
  {
    "codigo":742876007,
    "descripcion":"TRASTORNO DE LA BIOGÉNESIS DE PEROXISOMAS"
  },
  {
    "codigo":315057000,
    "descripcion":"XANTOMA GÁSTRICO"
  },
  {
    "codigo":334101000119107,
    "descripcion":"ECTROPIÓN ESPÁSTICO DE PÁRPADO INFERIOR DERECHO"
  },
  {
    "codigo":10629551000119101,
    "descripcion":"SINUSITIS ESFENOIDAL AGUDA RECURRENTE"
  },
  {
    "codigo":216753003,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ÁCIDO SULFÚRICO"
  },
  {
    "codigo":870278003,
    "descripcion":"LESIÓN CUTÁNEA PIGMENTADA DE TRONCO DE NATURALEZA INCIERTA"
  },
  {
    "codigo":11931000202101,
    "descripcion":"CAPAZ DE MANEJAR SU SALUD PERSONAL"
  },
  {
    "codigo":51078006,
    "descripcion":"RISA"
  },
  {
    "codigo":247686005,
    "descripcion":"DELIRIO DEPRESIVO DE CATÁSTROFE"
  },
  {
    "codigo":1263494009,
    "descripcion":"MIELITIS DEBIDA A SÍNDROME DE BEHCET"
  },
  {
    "codigo":278619004,
    "descripcion":"PRÓTESIS DENTAL, PERDIDA"
  },
  {
    "codigo":442459007,
    "descripcion":"ENFERMEDAD DE INMUNODEFICIENCIA COMBINADA"
  },
  {
    "codigo":213083008,
    "descripcion":"FACTURA DE AUTOINJERTO ÓSEO"
  },
  {
    "codigo":473392002,
    "descripcion":"NEFROSCLEROSIS HIPERTENSIVA"
  },
  {
    "codigo":735536003,
    "descripcion":"INMUNODEFICIENCIA DE COMIENZO EN LA EDAD ADULTA"
  },
  {
    "codigo":1259824002,
    "descripcion":"CORDOMA PRIMARIO DE COLUMNA LUMBAR"
  },
  {
    "codigo":440624006,
    "descripcion":"DEFORMIDAD DE DÍGITO DE LA MANO POR BANDA AMNIÓTICA"
  },
  {
    "codigo":690761000119100,
    "descripcion":"CISTADENOMA SEROSO DE PÁNCREAS"
  },
  {
    "codigo":274949005,
    "descripcion":"LESIONES DE PIEL AUTOINFLIGIDAS"
  },
  {
    "codigo":897541006,
    "descripcion":"ANOMALÍA CONGÉNITA DE VÍA BILIAR"
  },
  {
    "codigo":209413009,
    "descripcion":"ESGUINCE CORACOHUMERAL"
  },
  {
    "codigo":305882007,
    "descripcion":"VISTO EN EL SERVICIO DE IMÁGENES POR RESONANCIA MAGNÉTICA NUCLEAR"
  },
  {
    "codigo":10970008,
    "descripcion":"CALCIFICACIÓN DEL CRISTALINO"
  },
  {
    "codigo":830170009,
    "descripcion":"ALERGIA A LACHESINA"
  },
  {
    "codigo":238511002,
    "descripcion":"QUEMADURA CUTÁNEA POR MICROONDAS"
  },
  {
    "codigo":109274007,
    "descripcion":"MELANOMA IN SITU DE PÁRPADO, INCLUIDO EL CANTO"
  },
  {
    "codigo":74671004,
    "descripcion":"INFECCIÓN CAUSADA POR DACTYLOGYRUS"
  },
  {
    "codigo":1156015005,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE REGIÓN DE LA CADERA"
  },
  {
    "codigo":236676000,
    "descripcion":"ESCAPE DE ORINA DE LA PRÓSTATA"
  },
  {
    "codigo":402351009,
    "descripcion":"ONICOATROFIA POR LIQUEN PLANO"
  },
  {
    "codigo":72836002,
    "descripcion":"COMA HEPÁTICO"
  },
  {
    "codigo":1285252002,
    "descripcion":"HALLAZGO RELACIONADO CON RANGO ACTIVO DE DORSIFLEXIÓN DE TOBILLO"
  },
  {
    "codigo":16583241000119106,
    "descripcion":"ARTROSIS SECUNDARIA DE TOBILLO DERECHO"
  },
  {
    "codigo":105604006,
    "descripcion":"DEFICIENCIA DE ANTICOAGULANTE NATURAL"
  },
  {
    "codigo":10822371000119100,
    "descripcion":"FRACTURA EXPUESTA DE EXTREMO DISTAL DE FÉMUR DERECHO"
  },
  {
    "codigo":40068008,
    "descripcion":"HIDROURETERONEFROSIS"
  },
  {
    "codigo":890201000,
    "descripcion":"AGENESIA DE CONDUCTO CÍSTICO"
  },
  {
    "codigo":11831881000119106,
    "descripcion":"LESIÓN TRAUMÁTICA DE VASO SANGUÍNEO DE DEDO MEÑIQUE DE MANO DERECHA"
  },
  {
    "codigo":726361003,
    "descripcion":"TRISOMÍA PARCIAL DE CROMOSOMA 21"
  },
  {
    "codigo":365913004,
    "descripcion":"MEMORIA DE EVENTO IMPORTANTE - HALLAZGO"
  },
  {
    "codigo":16910921000119108,
    "descripcion":"NEVO MELANOCÍTICO CONGÉNITO DE PIEL DE PÁRPADO INFERIOR IZQUIERDO"
  },
  {
    "codigo":167470001,
    "descripcion":"CALCIO EN ORINA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":300377009,
    "descripcion":"NO DEFECA"
  },
  {
    "codigo":69166006,
    "descripcion":"FRACTURA DE EXTREMO PROXIMAL DE PIERNA"
  },
  {
    "codigo":427779000,
    "descripcion":"MASA DE GLÁNDULA SALIVAL"
  },
  {
    "codigo":298542009,
    "descripcion":"AMPLITUD DE FLEXIÓN ACTIVA LATERAL IZQUIERDA DE LA COLUMNA VERTEBRAL DORSAL, NORMAL"
  },
  {
    "codigo":722691002,
    "descripcion":"NEOPLASIA MESENQUIMÁTICA BENIGNA DE DIFERENCIACIÓN INCIERTA"
  },
  {
    "codigo":1052206009,
    "descripcion":"PÉRDIDA DE LA AUDICIÓN CONDUCTIVA Y NEUROSENSORIAL COMBINADAS DE OÍDO DERECHO CON AUDICIÓN NORMAL DEL OÍDO IZQUIERDO"
  },
  {
    "codigo":724526008,
    "descripcion":"DUODENITIS CAUSADA POR FÁRMACO"
  },
  {
    "codigo":34563004,
    "descripcion":"CANCEROFOBIA"
  },
  {
    "codigo":16638691000119105,
    "descripcion":"COMPRESIÓN BILATERAL DE NERVIOS GENITOFEMORALES"
  },
  {
    "codigo":67331009,
    "descripcion":"RASGO DE PERSONALIDAD - HALLAZGO"
  },
  {
    "codigo":294872001,
    "descripcion":"ALERGIA A HEPARINA"
  },
  {
    "codigo":720856002,
    "descripcion":"SÍNDROME DE DISPLASIA ECTODÉRMICA CON ECTRODACTILIA Y DISTROFIA MACULAR"
  },
  {
    "codigo":32728005,
    "descripcion":"HEMORRAGIA SECUNDARIA A RUPTURA DE ANEURISMA CEREBRAL CONGÉNITO"
  },
  {
    "codigo":196568006,
    "descripcion":"LEUCOPLASIA DE MUCOSA YUGAL"
  },
  {
    "codigo":131032006,
    "descripcion":"NIVEL DE OXITOCINA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1145005000,
    "descripcion":"DEMUESTRA CONOCIMIENTO SOBRE RÉGIMEN DE LÍQUIDOS"
  },
  {
    "codigo":260269001,
    "descripcion":"HALLAZGO RELACIONADO CON LA VISIÓN A DISTANCIA"
  },
  {
    "codigo":11805411000119107,
    "descripcion":"SUBLUXACIÓN DE ARTICULACIÓN INTERFALÁNGICA PROXIMAL DE DEDO MEÑIQUE DE MANO DERECHA"
  },
  {
    "codigo":719021005,
    "descripcion":"SÍNDROME DE FOCOMELIA-DK"
  },
  {
    "codigo":194733006,
    "descripcion":"ESTENOSIS MITRAL Y AÓRTICA"
  },
  {
    "codigo":293037007,
    "descripcion":"REACCIÓN ADVERSA A LA SULFADIAZINA"
  },
  {
    "codigo":94594001,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE PARTES BLANDAS DEL TÓRAX"
  },
  {
    "codigo":782722002,
    "descripcion":"SÍNDROME DE RETRASO GENERALIZADO DEL DESARROLLO, QUISTES PULMONARES, CRECIMIENTO EXCESIVO Y TUMOR DE WILMS"
  },
  {
    "codigo":225666004,
    "descripcion":"CONFUNDE LA IDENTIDAD DE LAS PERSONAS"
  },
  {
    "codigo":336611000119109,
    "descripcion":"GLAUCOMA DE ÁNGULO AGUDO DE OJO DERECHO"
  },
  {
    "codigo":127362006,
    "descripcion":"EMBARAZOS ANTERIORES"
  },
  {
    "codigo":192898007,
    "descripcion":"MIELOPATÍA POR TROMBOSIS ARTERIAL DE LA MÉDULA ESPINAL"
  },
  {
    "codigo":291202008,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR TRIFLUOPERAZINA"
  },
  {
    "codigo":717186009,
    "descripcion":"MALABSORCIÓN INTESTINAL DEBIDA A DEFECTO DE LA SÍNTESIS DE ÁCIDOS BILIARES"
  },
  {
    "codigo":715351002,
    "descripcion":"CORYNEBACTERIUM PSEUDODIPHTHERITICUM O CORYNEBACTERIUM PROPINQUUM"
  },
  {
    "codigo":289367002,
    "descripcion":"POSICIÓN ANÓMALA DEL FETO EN PRESENTACIÓN CEFÁLICA DE BREGMA"
  },
  {
    "codigo":92759009,
    "descripcion":"CARCINOMA IN SITU DE LA GLÁNDULA SUBMAXILAR"
  },
  {
    "codigo":254764001,
    "descripcion":"NEUROEPITELIOMA PERIFÉRICO"
  },
  {
    "codigo":1336108005,
    "descripcion":"IRIDOCICLITIS AGUDA"
  },
  {
    "codigo":713516007,
    "descripcion":"LINFOMA PRIMARIO CON DERRAME"
  },
  {
    "codigo":1303340008,
    "descripcion":"GLAUCOMA POR CIERRE ANGULAR PRIMARIO DE AMBOS OJOS"
  },
  {
    "codigo":56321006,
    "descripcion":"PERISALPINGITIS"
  },
  {
    "codigo":449537006,
    "descripcion":"DEFECTO DEL TABIQUE AURICULOVENTRICULAR CON INSUFICIENCIA DE VÁLVULA AURICULOVENTRICULAR A TRAVÉS DE COMISURA MURAL INFERIOR ANTEROSUPERIOR DERECHA"
  },
  {
    "codigo":416769008,
    "descripcion":"TERATOMA TESTICULAR MALIGNO"
  },
  {
    "codigo":54486001,
    "descripcion":"POSICIÓN SACROILÍACA IZQUIERDA TRANSVERSA"
  },
  {
    "codigo":251094002,
    "descripcion":"PARO SINUSAL CON ESCAPE VENTRICULAR"
  },
  {
    "codigo":709846003,
    "descripcion":"UBICACIÓN IDEAL EN UNA SOLA ARCADA Y EXTENSIÓN DE ZONA DESDENTADA DE LA CAVIDAD BUCAL"
  },
  {
    "codigo":447702004,
    "descripcion":"VENTANA AORTOPULMONAR CONFLUENTE CON BORDE SUPERIOR E INFERIOR MÍNIMO"
  },
  {
    "codigo":283862005,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO EN EL DORSO DEL PIE"
  },
  {
    "codigo":218326006,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR ANTIBIÓTICOS ANTINEOPLÁSICOS"
  },
  {
    "codigo":413099000,
    "descripcion":"QUISTE DE GLÁNDULA PINEAL"
  },
  {
    "codigo":216491002,
    "descripcion":"INTOXICACIÓN ACCIDENTAL CAUSADA POR PIRABITAL"
  },
  {
    "codigo":19883003,
    "descripcion":"ATROFIA DE LOS CORNETES NASALES"
  },
  {
    "codigo":773547003,
    "descripcion":"SÍNDROME DE MICRODELECIÓN 13Q12.3"
  },
  {
    "codigo":282027006,
    "descripcion":"PERÍODO NORMAL"
  },
  {
    "codigo":249259006,
    "descripcion":"GLOBO DEL PREPUCIO"
  },
  {
    "codigo":247424000,
    "descripcion":"PIEL SUCIA"
  },
  {
    "codigo":312960003,
    "descripcion":"RETINOPATÍA POR QUININA"
  },
  {
    "codigo":119831000119106,
    "descripcion":"FALTA DE PERCEPCIÓN DE SIGNOS DE HIPOGLUCEMIA DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":16012311000119106,
    "descripcion":"TROMBOFLEBITIS DE AMBAS VENAS TIBIALES"
  },
  {
    "codigo":1197696009,
    "descripcion":"VÁRICES ESOFÁGICAS SANGRANTES POR FIBROSIS HEPÁTICA"
  },
  {
    "codigo":704341004,
    "descripcion":"ACTITUD CONFLICTIVA CON RESPECTO AL MANEJO DE MEDICACIÓN"
  },
  {
    "codigo":1163093006,
    "descripcion":"TIROIDITIS FÚNGICA AGUDA"
  },
  {
    "codigo":276522000,
    "descripcion":"PERITONITIS NEONATAL"
  },
  {
    "codigo":339121000119102,
    "descripcion":"ATROFIA ORBITARIA IZQUIERDA"
  },
  {
    "codigo":47146003,
    "descripcion":"INFESTACIÓN CAUSADA POR CHORIOPTES"
  },
  {
    "codigo":1290495000,
    "descripcion":"TENDINOSIS DE HOMBRO"
  },
  {
    "codigo":1259562009,
    "descripcion":"DETERIORO COGNITIVO DEBIDO A IRRADIACIÓN CEREBRAL DIFERIDA-TARDÍA"
  },
  {
    "codigo":241919001,
    "descripcion":"EFECTO TÓXICO CAUSADO POR ENCENDEDOR"
  },
  {
    "codigo":405759003,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA MÉDULA ESPINAL CERVICAL SIN LESIÓN VERTEBRAL"
  },
  {
    "codigo":897279002,
    "descripcion":"EPIGNATO FETAL CON SIAMESES"
  },
  {
    "codigo":209151004,
    "descripcion":"SUBLUXACIÓN EXPUESTA DE LA COLUMNA VERTEBRAL CERVICAL"
  },
  {
    "codigo":372991007,
    "descripcion":"INFECCIÓN CAUSADA POR ASPERGILLUS ORYZAE"
  },
  {
    "codigo":43476002,
    "descripcion":"BRAQUIDACTILIA"
  },
  {
    "codigo":1255892003,
    "descripcion":"LINFOMA DE HODGKIN, VARIANTE DEPLECIÓN LINFOCITARIA DE GANGLIOS LINFÁTICOS DE MIEMBRO INFERIOR"
  },
  {
    "codigo":305620004,
    "descripcion":"ESTADO DEL REGISTRO DE LA TRANSACCIÓN"
  },
  {
    "codigo":240084007,
    "descripcion":"MIOPATÍA CONGÉNITA CON DESPROPORCIÓN DEL TIPO DE FIBRA"
  },
  {
    "codigo":698836007,
    "descripcion":"MIOCLONÍA DE MÉDULA ESPINAL"
  },
  {
    "codigo":403924008,
    "descripcion":"MELANOMA MALIGNO DESMOPLÁSICO"
  },
  {
    "codigo":717192003,
    "descripcion":"SÍNDROME DE ARTROPATÍA DIGITAL FAMILIAR Y BRAQUIDACTILIA"
  },
  {
    "codigo":860841006,
    "descripcion":"ENCEFALOMIELITIS CAUSADA POR BACTERIA"
  },
  {
    "codigo":205481009,
    "descripcion":"METACONDROMATOSIS"
  },
  {
    "codigo":301950001,
    "descripcion":"PUPILA NORMAL"
  },
  {
    "codigo":236414001,
    "descripcion":"GLOMERULONEFRITIS MEMBRANOSA - ESTADIO II"
  },
  {
    "codigo":203646004,
    "descripcion":"ESCOLIOSIS IDIOPÁTICA DEL ADOLESCENTE"
  },
  {
    "codigo":170878004,
    "descripcion":"EFECTO COLATERAL DE FÁRMACO PARA VÍAS URINARIAS"
  },
  {
    "codigo":1186686006,
    "descripcion":"AMBIENTE NO DESAFIANTE"
  },
  {
    "codigo":300115000,
    "descripcion":"PABELLÓN AURICULAR ERITEMATOSO"
  },
  {
    "codigo":234579001,
    "descripcion":"DEFICIENCIA DE PROTEÍNA FIJADORA DE MANANO"
  },
  {
    "codigo":726099002,
    "descripcion":"TROMBOSIS VENOSA VISCERAL"
  },
  {
    "codigo":365651002,
    "descripcion":"NIVEL DE VISCOSIDAD SANGUÍNEA"
  },
  {
    "codigo":169043006,
    "descripcion":"CINERRADIOGRAFÍA ANORMAL"
  },
  {
    "codigo":3368006,
    "descripcion":"DOLOR SORDO EN EL PECHO"
  },
  {
    "codigo":298280009,
    "descripcion":"TUMEFACCIÓN DE MÚSCULO ESQUELÉTICO"
  },
  {
    "codigo":722429003,
    "descripcion":"SÍNDROME DE DEFICIENCIA DISTAL DE MIEMBRO CON MICROGNATIA"
  },
  {
    "codigo":1345021007,
    "descripcion":"OSTEOCONDROPATÍA DE CÚBITO"
  },
  {
    "codigo":198141008,
    "descripcion":"PERIOOFORITIS CRÓNICA"
  },
  {
    "codigo":294610003,
    "descripcion":"ALERGIA A CICLOSERINA"
  },
  {
    "codigo":718759003,
    "descripcion":"LISENCEFALIA DEBIDA A MUTACIÓN DE TUBULINA ALFA 1A"
  },
  {
    "codigo":40421000119104,
    "descripcion":"OBSTRUCCIÓN URINARIA DEBIDA A PRÓSTATA NODULAR"
  },
  {
    "codigo":292775005,
    "descripcion":"REACCIÓN ADVERSA AL ACEITE DE OLIVA"
  },
  {
    "codigo":391079006,
    "descripcion":"ECOGRAFÍA CUANTITATIVA DE TALÓN - PUNTAJE Z"
  },
  {
    "codigo":61564002,
    "descripcion":"TIFLITIS"
  },
  {
    "codigo":94332004,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA CARA HIPOFARÍNGEA DEL PLIEGUE ARITENOEPIGLÓTICO"
  },
  {
    "codigo":422012004,
    "descripcion":"NEURITIS CON SÍNDROME DE INMUNODEFICIENCIA ADQUIRIDA"
  },
  {
    "codigo":127100006,
    "descripcion":"LINFADENOPATÍA PERICÁRDICA LATERAL"
  },
  {
    "codigo":715089000,
    "descripcion":"DEPENDIENTE EN LA TRANSFERENCIA DE LA CAMA A LA SILLA"
  },
  {
    "codigo":290940008,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR PIRACETAM"
  },
  {
    "codigo":15932901000119107,
    "descripcion":"OBSTRUCCIÓN PARCIAL DE TROMPA UTERINA IZQUIERDA"
  },
  {
    "codigo":15988351000119101,
    "descripcion":"FÍSTULA CARÓTIDO-CAVERNOSA DERECHA ADQUIRIDA"
  },
  {
    "codigo":289105003,
    "descripcion":"DIFICULTAD EN EL CONTROL DE LA RESPIRACIÓN"
  },
  {
    "codigo":92497005,
    "descripcion":"OSIFICACIÓN BIPARTITA DE CENTRO DE VÉRTEBRA SACRA"
  },
  {
    "codigo":90662007,
    "descripcion":"DISPROSODIA DEL DIALECTO SEUDOEXTRANJERO"
  },
  {
    "codigo":1137403002,
    "descripcion":"HIPOTONÍA SEVERA DE MÚSCULO"
  },
  {
    "codigo":416507005,
    "descripcion":"HERIDA NO PERFORANTE DE LA ESCLERÓTICA"
  },
  {
    "codigo":23291008,
    "descripcion":"MENINGITIS CAUSADA POR VIRUS HERPES SIMPLE HUMANO"
  },
  {
    "codigo":283600002,
    "descripcion":"HERIDA POR PINCHAZO DE AGUJA EN LA CARA"
  },
  {
    "codigo":709584004,
    "descripcion":"ATEROSCLEROSIS DE INJERTO-PUENTE DE MIEMBRO INFERIOR"
  },
  {
    "codigo":314533000,
    "descripcion":"TRAUMATISMO CERRADO DEL OJO"
  },
  {
    "codigo":185296009,
    "descripcion":"ATENDIDO POR ENFERMERA HOSPITALARIA"
  },
  {
    "codigo":11783961000119101,
    "descripcion":"HERIDA INFECTADA DE MUSLO DERECHO DEBIDA A PICADURA DE INSECTO NO VENENOSO"
  },
  {
    "codigo":871589004,
    "descripcion":"TRASTORNO DE VENA CAVA SUPERIOR DEBIDO A PROCEDIMIENTO"
  },
  {
    "codigo":85157005,
    "descripcion":"POSTURA DE DECORTICACIÓN"
  },
  {
    "codigo":312698000,
    "descripcion":"MATERIAL DE LENTE BLANDA RETENIDO EN EL CUERPO VÍTREO"
  },
  {
    "codigo":15716121000119102,
    "descripcion":"ENOSTOSIS DE RADIO IZQUIERDO"
  },
  {
    "codigo":443770005,
    "descripcion":"FÍSTULA ARTERIOVENOSA DE EXTREMIDAD SUPERIOR IZQUIERDA"
  },
  {
    "codigo":771450007,
    "descripcion":"CONGELAMIENTO CON NECROSIS TISULAR DE BRAZO"
  },
  {
    "codigo":704079000,
    "descripcion":"HEMORRAGIA SUBARACNOIDEA PERIMESENCEFÁLICA NO ANEURISMÁTICA"
  },
  {
    "codigo":247162007,
    "descripcion":"FIBROSIS SUBRETINIANA"
  },
  {
    "codigo":315161000119104,
    "descripcion":"OSTEOCONDRITIS DISECANTE DE CODO IZQUIERDO"
  },
  {
    "codigo":212559004,
    "descripcion":"PRECOCIDAD FÍSICA"
  },
  {
    "codigo":441935006,
    "descripcion":"PÉRDIDA DE TODOS LOS DIENTES"
  },
  {
    "codigo":278095008,
    "descripcion":"VELOCIDAD DEL PARTO, NORMAL"
  },
  {
    "codigo":440100002,
    "descripcion":"RESULTADO DE ABSORCIOMETRÍA DUAL POR RAYOS X DE CUELLO DE FÉMUR, OSTEOPOROSIS"
  },
  {
    "codigo":1259300002,
    "descripcion":"PULPA DENTAL NORMAL POSTERIOR A TRAUMATISMO DENTAL"
  },
  {
    "codigo":866084002,
    "descripcion":"LINFOPENIA DEBIDA A INFECCIÓN"
  },
  {
    "codigo":210724006,
    "descripcion":"DAÑO MULTITISULAR SEVERO DEL PIE"
  },
  {
    "codigo":208889000,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA EXPUESTA DE MÚLTIPLES DÍGITOS DE MANO"
  },
  {
    "codigo":405497002,
    "descripcion":"DIFICULTAD CON LA EXTUBACIÓN TRAQUEAL"
  },
  {
    "codigo":77817004,
    "descripcion":"SÍNDROME DE NEU-LAXOVA"
  },
  {
    "codigo":272590000,
    "descripcion":"ACOSTADO EN EL AGUA"
  },
  {
    "codigo":10446001,
    "descripcion":"ASPERGILOMA"
  },
  {
    "codigo":239822004,
    "descripcion":"ARTRITIS SECUNDARIA A NEOPLASIA MALIGNA NO HEMATOLÓGICO"
  },
  {
    "codigo":1255630007,
    "descripcion":"CARCINOMA DE CÉLULAS EN ANILLO DE SELLO DE TRÁQUEA"
  },
  {
    "codigo":403662008,
    "descripcion":"HIPERTROFIA ADIPOSA DEBIDA A INYECCIÓN DE FÁRMACO O MEDICAMENTO"
  },
  {
    "codigo":237987001,
    "descripcion":"DEFICIENCIA DE COMPLEJO ENZIMÁTICO DE LA CADENA RESPIRATORIA MITOCONDRIAL"
  },
  {
    "codigo":126321000146108,
    "descripcion":"USUALMENTE CAPAZ DE CUIDAR A UN NIÑO"
  },
  {
    "codigo":303523005,
    "descripcion":"SE PONE LA PELUCA"
  },
  {
    "codigo":762275008,
    "descripcion":"DIVERTÍCULO DE DUODENO"
  },
  {
    "codigo":301688002,
    "descripcion":"INCAPAZ DE RODAR EN LA CAMA"
  },
  {
    "codigo":399992009,
    "descripcion":"ERITRODERMIA"
  },
  {
    "codigo":365389004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA REALIZAR ACTIVIDADES DE OCUPACIÓN Y EMPLEO"
  },
  {
    "codigo":299853004,
    "descripcion":"REFLEJO ABDOMINAL NORMAL"
  },
  {
    "codigo":201549005,
    "descripcion":"ARTRITIS DE MANO POSTERIOR A HELMINTIASIS"
  },
  {
    "codigo":398157006,
    "descripcion":"ENFERMEDAD DIVERTICULAR DEL INTESTINO GRUESO"
  },
  {
    "codigo":1081421000119102,
    "descripcion":"NEOPLASIA FILOIDE BENIGNA DE MAMA DERECHA"
  },
  {
    "codigo":166946001,
    "descripcion":"NIVEL TERAPÉUTICO DE VALPROATO"
  },
  {
    "codigo":724002003,
    "descripcion":"SÍNDROME DE ISQUEMIA DE RETINA, HIALINOSIS DE PEQUEÑOS VASOS DEL TRACTO DIGESTIVO Y CALCIFICACIÓN CEREBRAL DIFUSA"
  },
  {
    "codigo":35874009,
    "descripcion":"TRABAJO DE PARTO NORMAL"
  },
  {
    "codigo":296183005,
    "descripcion":"SOBREDOSIS DE TRIFLUPERIDOL"
  },
  {
    "codigo":230647006,
    "descripcion":"NEUROPATÍA ABDOMINAL"
  },
  {
    "codigo":1271009,
    "descripcion":"SÍNDROME DE ALMOHADILLAS EN LOS NUDILLOS, LEUCONIQUIA, SORDERA NEUROSENSORIAL E HIPERQUERATOSIS PALMOPLANTAR"
  },
  {
    "codigo":294348001,
    "descripcion":"ALERGIA A GRISEOFULVINA"
  },
  {
    "codigo":785868004,
    "descripcion":"HEMORRAGIA SECUNDARIA DEBIDA A INTERRUPCIÓN INDUCIDA DE EMBARAZO Y POSTERIOR A ELLA"
  },
  {
    "codigo":425420004,
    "descripcion":"TROMBOSIS DE ARTERIA CARÓTIDA INTERNA"
  },
  {
    "codigo":153831000119100,
    "descripcion":"ÚLCERA VENOSA DE EXTREMIDAD INFERIOR DEBIDA A HIPERTENSIÓN VENOSA PERIFÉRICA CRÓNICA"
  },
  {
    "codigo":32204007,
    "descripcion":"ACTINOBACILOSIS PULMONAR"
  },
  {
    "codigo":63137003,
    "descripcion":"GASTRITIS EROSIVA CRÓNICA"
  },
  {
    "codigo":344141000119108,
    "descripcion":"ENDOFTALMITIS PURULENTA DE AMBOS OJOS"
  },
  {
    "codigo":126838000,
    "descripcion":"NEOPLASIA DEL COLON"
  },
  {
    "codigo":1144481009,
    "descripcion":"SE SIENTE MÁS EMPODERADO"
  },
  {
    "codigo":421750000,
    "descripcion":"CETOACIDOSIS DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":30369007,
    "descripcion":"INFECCIÓN CAUSADA POR PARAGONIMUS"
  },
  {
    "codigo":28534004,
    "descripcion":"PARÁLISIS ESPÁSTICA POR TRAUMATISMO INTRACRANEAL DEL NACIMIENTO"
  },
  {
    "codigo":716662004,
    "descripcion":"ENFERMEDAD DE PARKINSON AUTOSÓMICA DOMINANTE DE COMIENZO TARDÍO"
  },
  {
    "codigo":388982007,
    "descripcion":"ONIQUIA DE DEDO DE PIE"
  },
  {
    "codigo":290678007,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR ÓXIDO MERCÚRICO"
  },
  {
    "codigo":92235003,
    "descripcion":"NEOPLASIA BENIGNA DE MÚSCULO DEL TRONCO"
  },
  {
    "codigo":16046311000119104,
    "descripcion":"ENFERMEDAD POR DEPÓSITO DE HIDROXIAPATITA DE CADERA IZQUIERDA"
  },
  {
    "codigo":714827005,
    "descripcion":"HEMATURIA RECURRENTE CONCOMITANTE CON LESIONES GLOMERULARES SEGMENTARIAS Y FOCALES Y DEBIDA A ELLAS"
  },
  {
    "codigo":450848006,
    "descripcion":"ENGROSAMIENTO DE PIEL DE MAMA"
  },
  {
    "codigo":287008006,
    "descripcion":"ARTRITIS REUMATOIDE DE TOBILLO Y\/O PIE"
  },
  {
    "codigo":711157000,
    "descripcion":"SÍNDROME DE MUERTE SÚBITA DEL LACTANTE CON DISGENESIA TESTICULAR"
  },
  {
    "codigo":24864009,
    "descripcion":"ESGUINCE DE ARTICULACIÓN INTERFALÁNGICA DE DEDO DE PIE"
  },
  {
    "codigo":285173002,
    "descripcion":"CAPAZ DE RECONOCER SONIDOS"
  },
  {
    "codigo":385312007,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA PROXIMAL DE MUCOSA, NO AFECTADO POR CARCINOMA IN SITU"
  },
  {
    "codigo":283338006,
    "descripcion":"PICADURA DE INSECTO EN LOS GENITALES"
  },
  {
    "codigo":707487003,
    "descripcion":"CARCINOMA PRIMARIO DE CÉLULAS GIGANTES DE HIPOFARINGE"
  },
  {
    "codigo":281503004,
    "descripcion":"LUXACIÓN DE ARTICULACIÓN CARPOMETACARPIANA"
  },
  {
    "codigo":1297311007,
    "descripcion":"CELULITIS DE CUARTO DEDO DE PIE"
  },
  {
    "codigo":248735008,
    "descripcion":"DESCENSO ABRUPTO DE LA ONDA \"Y\" DEL PULSO VENOSO YUGULAR"
  },
  {
    "codigo":1229940001,
    "descripcion":"INMUNODEFICIENCIA COMBINADA GRAVE T- B+ AUTOSÓMICA RECESIVA POR DEFICIENCIA DE IL-7RALPH"
  },
  {
    "codigo":1162569002,
    "descripcion":"BACTERIEMIA POSQUIRÚRGICA"
  },
  {
    "codigo":212297003,
    "descripcion":"LESIÓN TRAUMÁTICA ABIERTA DE NERVIO INTERCOSTOBRAQUIAL"
  },
  {
    "codigo":16675201000119107,
    "descripcion":"DOLOR DE TESTÍCULO DERECHO"
  },
  {
    "codigo":277833004,
    "descripcion":"ANSIEDAD ACERCA DE DESVANECERSE"
  },
  {
    "codigo":15689008,
    "descripcion":"SEUDOHIPOALDOSTERONISMO, TIPO 2"
  },
  {
    "codigo":81225008,
    "descripcion":"ÚLCERA GÁSTRICA AGUDA SIN HEMORRAGIA Y SIN PERFORACIÓN PERO CON OBSTRUCCIÓN"
  },
  {
    "codigo":1259038005,
    "descripcion":"PARAPLEJÍA ESPÁSTICA HEREDITARIA AUTOSÓMICA DOMINANTE COMPLEJA"
  },
  {
    "codigo":306931002,
    "descripcion":"MOVILIDAD DEL ESTRIBO, AUMENTADA"
  },
  {
    "codigo":110323003,
    "descripcion":"OCLUSIÓN DISTAL EN LA DENTICIÓN PRIMARIA"
  },
  {
    "codigo":700147004,
    "descripcion":"FRACTURA POR AVULSIÓN DE EPITRÓCLEA DE HÚMERO"
  },
  {
    "codigo":10184002,
    "descripcion":"COLANGITIS RECIDIVANTE"
  },
  {
    "codigo":1157064005,
    "descripcion":"ASTROCITOMA GEMISTOCÍTICO DE SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":15966901000119100,
    "descripcion":"SÍNDROME DE ABERTURA DE SALIDA TORÁCICA VENOSO IZQUIERDO"
  },
  {
    "codigo":42952007,
    "descripcion":"HEMATOPOYESIS EXTRAMEDULAR"
  },
  {
    "codigo":403400008,
    "descripcion":"PIEL LAXA CON DEFICIENCIA DEL COMPLEMENTO"
  },
  {
    "codigo":237725002,
    "descripcion":"OSMORREGULACIÓN DEFECTUOSA"
  },
  {
    "codigo":1351837003,
    "descripcion":"SÍNDROME DE DISCAPACIDAD INTELECTUAL Y OREJAS CON FORMA DE COPA"
  },
  {
    "codigo":204957003,
    "descripcion":"ENFERMEDAD QUÍSTICA MEDULAR DEL RIÑÓN"
  },
  {
    "codigo":8349005,
    "descripcion":"EXPOSICIÓN AL SEXO"
  },
  {
    "codigo":346651000119109,
    "descripcion":"EDEMA CONJUNTIVAL DE AMBOS OJOS"
  },
  {
    "codigo":1153394005,
    "descripcion":"CONDRÓLISIS CONGÉNITA"
  },
  {
    "codigo":399730005,
    "descripcion":"ADENOMA DE RECTO"
  },
  {
    "codigo":235890007,
    "descripcion":"ENFERMEDAD HEPÁTICA AUTOINMUNITARIA"
  },
  {
    "codigo":268658008,
    "descripcion":"INHIBICIÓN LABORAL O ACADÉMICA ESPECÍFICA"
  },
  {
    "codigo":37447003,
    "descripcion":"TIPO DE SUSTANCIA NO APLICABLE"
  },
  {
    "codigo":299591005,
    "descripcion":"AMPLITUD DE FLEXIÓN PASIVA DE DEDO DEL PIE AUMENTADA"
  },
  {
    "codigo":234055007,
    "descripcion":"VÁRICES DE LAS PIERNAS DISTRIBUIDAS EN EL TERRITORIO DE LA VENA SAFENA INTERNA"
  },
  {
    "codigo":102983008,
    "descripcion":"REFLEJO TENDINOSO BREVE"
  },
  {
    "codigo":232220000,
    "descripcion":"LÓBULO DE LA OREJA DESGARRADO"
  },
  {
    "codigo":428828002,
    "descripcion":"HALLADO EN EL ASIENTO TRASERO DE UN AUTOMÓVIL"
  },
  {
    "codigo":365127008,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA LEVANTARSE DE UNA SILLA"
  },
  {
    "codigo":295921000,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE SERTRALINA"
  },
  {
    "codigo":74421000119107,
    "descripcion":"RESERVA OVÁRICA DISMINUIDA DEBIDA A RESPUESTA POBRE DE HORMONA FOLICULOESTIMULANTE"
  },
  {
    "codigo":263153003,
    "descripcion":"FRACTURA DE COMPLEJO FRONTONASOETMOIDAL"
  },
  {
    "codigo":195782000,
    "descripcion":"FARINGITIS FOLICULAR CRÓNICA"
  },
  {
    "codigo":197617009,
    "descripcion":"GLOMERULONEFRITIS EXUDATIVA CRÓNICA"
  },
  {
    "codigo":64710004,
    "descripcion":"LUXACIÓN DE KIENBOCK"
  },
  {
    "codigo":783771003,
    "descripcion":"CARCINOMA DE CÉLULAS ACINARES DE PÁNCREAS"
  },
  {
    "codigo":95643007,
    "descripcion":"ENCEFALITIS AUTOINMUNITARIA"
  },
  {
    "codigo":193947008,
    "descripcion":"NEURALGIA CILIAR"
  },
  {
    "codigo":292251009,
    "descripcion":"REACCIÓN ADVERSA A LA VINBLASTINA"
  },
  {
    "codigo":1176987009,
    "descripcion":"PERIODONTITIS POR CAMPYLOBACTER"
  },
  {
    "codigo":126576004,
    "descripcion":"NEOPLASIA DE HUESO TRAPECIO"
  },
  {
    "codigo":716400004,
    "descripcion":"CAPAZ DE LIMPIAR OBJETOS A LA ALTURA DEL HOMBRO"
  },
  {
    "codigo":93808006,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE SENO FRONTAL"
  },
  {
    "codigo":290416007,
    "descripcion":"INTOXICACIÓN POR DOMPERIDONA"
  },
  {
    "codigo":190277005,
    "descripcion":"HIPOTIROIDISMO CAUSADO POR RADIACIÓN"
  },
  {
    "codigo":288581006,
    "descripcion":"CAPAZ DE EMPLEAR LA COMUNICACIÓN NO VERBAL"
  },
  {
    "codigo":253978002,
    "descripcion":"CARACTERÍSTICAS DISMÓRFICAS"
  },
  {
    "codigo":286746004,
    "descripcion":"CARÁCTER PESIMISTA"
  },
  {
    "codigo":712730008,
    "descripcion":"PÓLIPO DE COLON TRANSVERSO"
  },
  {
    "codigo":1237018008,
    "descripcion":"CON RIESGO ELEVADO DE EXPOSICIÓN A VIRUS DE RUBÉOLA"
  },
  {
    "codigo":219375003,
    "descripcion":"LESIÓN DE GUERRA POR BALA DE CARABINA"
  },
  {
    "codigo":284911003,
    "descripcion":"DIFICULTAD PARA USAR EL INODORO"
  },
  {
    "codigo":16733161000119105,
    "descripcion":"INFECCIÓN ASOCIADA CON NEUROESTIMULADOR DE MÉDULA ESPINAL"
  },
  {
    "codigo":283076005,
    "descripcion":"ARAÑAZO DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":20932005,
    "descripcion":"SALPINGITIS PUERPERAL"
  },
  {
    "codigo":184772007,
    "descripcion":"FACTURA CERTIFICADA DIVERSA PARA LA ORGANIZACIÓN DE ORIGEN"
  },
  {
    "codigo":446916007,
    "descripcion":"CORAZÓN FUNCIONALMENTE UNIVENTRICULAR"
  },
  {
    "codigo":314009001,
    "descripcion":"RETINOPATÍA SEROSA CENTRAL CON DESPRENDIMIENTO MÍNIMO DEL EPITELIO PIGMENTARIO DE LA RETINA"
  },
  {
    "codigo":1264281001,
    "descripcion":"LACERACIÓN DE TENDÓN DE ANTEBRAZO"
  },
  {
    "codigo":84633001,
    "descripcion":"LINFOMA ESTADIO IIISE"
  },
  {
    "codigo":349161000119106,
    "descripcion":"ATROFIA ÓPTICA PARCIAL DE AMBOS OJOS"
  },
  {
    "codigo":838297005,
    "descripcion":"ADENOMA DE GLÁNDULA MUCOSA BRONQUIAL"
  },
  {
    "codigo":248473006,
    "descripcion":"HUELE A NO LAVADO"
  },
  {
    "codigo":707225006,
    "descripcion":"ENFERMEDAD MENINGOCÓCICA INVASIVA"
  },
  {
    "codigo":1295214000,
    "descripcion":"ICTERICIA NEONATAL DEBIDA A CONJUGACIÓN TARDÍA DE BILIRRUBINA POSTERIOR A PARTO PRETÉRMINO"
  },
  {
    "codigo":15750121000119108,
    "descripcion":"OBESIDAD SEVERA MATERNA PREEXISTENTE QUE COMPLICA EL EMBARAZO"
  },
  {
    "codigo":21481000119108,
    "descripcion":"EFECTO TÓXICO DE EXPOSICIÓN SECUNDARIA A TABACO"
  },
  {
    "codigo":410478005,
    "descripcion":"SÍFILIS OCULAR"
  },
  {
    "codigo":17262008,
    "descripcion":"PSICOSIS DE KORSAKOFF NO ALCOHÓLICA"
  },
  {
    "codigo":246638009,
    "descripcion":"INTERFERENCIA CON LA VISIÓN"
  },
  {
    "codigo":212035002,
    "descripcion":"QUEMADURA POR AGENTES CORROSIVOS DE BOCA Y FARINGE"
  },
  {
    "codigo":1162307001,
    "descripcion":"OSTEÓLISIS SECUNDARIA"
  },
  {
    "codigo":80963002,
    "descripcion":"VARIANTE DE ANEMIA POR DEFICIENCIA DE GLUCOSA-6-FOSFATO DESHIDROGENASA CLASE V"
  },
  {
    "codigo":277571004,
    "descripcion":"LEUCEMIA LINFOBLÁSTICA AGUDA DE LINFOCITOS B"
  },
  {
    "codigo":408643008,
    "descripcion":"CARCINOMA DUCTAL INFILTRANTE DE MAMA"
  },
  {
    "codigo":734488002,
    "descripcion":"ACUERDO DOCUMENTADO PARA VERIFICACIÓN DE LA MUERTE ESPERADA POR UN MÉDICO COMPETENTE"
  },
  {
    "codigo":111896003,
    "descripcion":"HEPATITIS VIRAL SIN COMA HEPÁTICO"
  },
  {
    "codigo":439576009,
    "descripcion":"TEMOR A BEBER POR DISFAGIA"
  },
  {
    "codigo":296221000119101,
    "descripcion":"ALTERACIÓN DE CUERNO POSTERIOR DE MENISCO INTERNO DEBIDA A LESIÓN TRAUMÁTICA DE RODILLA"
  },
  {
    "codigo":44525005,
    "descripcion":"PERCEPCIÓN ANORMAL Y DESAGRADABLE DE UN AROMA FUERTE"
  },
  {
    "codigo":110061006,
    "descripcion":"AVULSIÓN DE LA FRENTE"
  },
  {
    "codigo":77293007,
    "descripcion":"ESPASMO HIPERTENSIVO DE CARDIAS"
  },
  {
    "codigo":1156802000,
    "descripcion":"LUMBALGIA MIOFASCIAL"
  },
  {
    "codigo":403138002,
    "descripcion":"TRIPANOSOMIASIS AFRICANA QUE AFECTA LA PIEL"
  },
  {
    "codigo":40855001,
    "descripcion":"ENFERMEDAD POR DEFICIENCIA HEREDITARIA DE FACTOR VII"
  },
  {
    "codigo":401303003,
    "descripcion":"INFARTO AGUDO DE MIOCARDIO CON ELEVACIÓN DEL SEGMENTO ST"
  },
  {
    "codigo":204695006,
    "descripcion":"AUSENCIA CONGÉNITA DE DUODENO"
  },
  {
    "codigo":301164000,
    "descripcion":"PULSO BRAQUIAL AUSENTE"
  },
  {
    "codigo":237463009,
    "descripcion":"ECCEMA DE PEZÓN"
  },
  {
    "codigo":1351575008,
    "descripcion":"SÍNDROME DE HIPERINMUNOGLOBULINA M AUTOSÓMICO RECESIVO DEBIDO A DEFICIENCIA DE CTNNBL1"
  },
  {
    "codigo":235628006,
    "descripcion":"ESÓFAGO EN CASCANUECES"
  },
  {
    "codigo":399468008,
    "descripcion":"PÓLIPO GLANDULAR FÚNDICO SOLITARIO"
  },
  {
    "codigo":366700008,
    "descripcion":"HALLAZGO RELACIONADO CON LA AMPLITUD DE LA OPOSICIÓN DEL PULGAR"
  },
  {
    "codigo":201025002,
    "descripcion":"PRURITO INVERNAL"
  },
  {
    "codigo":233793003,
    "descripcion":"FÍSTULA BRONCOPLEURAL"
  },
  {
    "codigo":299329003,
    "descripcion":"DEFORMIDAD DE ARTICULACIÓN DE RODILLA FIJA EN FLEXIÓN"
  },
  {
    "codigo":430401005,
    "descripcion":"ENFERMEDAD CARDÍACA CAUSADA POR RADIACIÓN IONIZANTE"
  },
  {
    "codigo":168257006,
    "descripcion":"POSTMORTEM - SIN ORGANISMOS AISLADOS"
  },
  {
    "codigo":397633005,
    "descripcion":"DERIVACIÓN RETRASADA - CANCELACIÓN DE LA CONSULTA"
  },
  {
    "codigo":364865008,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA SENTARSE SIN SOSTÉN"
  },
  {
    "codigo":363030001,
    "descripcion":"ANOMALÍA CONGÉNITA DE LA PORCIÓN INFERIOR DEL TRONCO"
  },
  {
    "codigo":789014004,
    "descripcion":"RADICULOPATÍA CAUSADA POR ELECTRICIDAD"
  },
  {
    "codigo":428566005,
    "descripcion":"GESTACIÓN DE MENOS DE 20 SEMANAS"
  },
  {
    "codigo":2582004,
    "descripcion":"QUEMADURA PROFUNDA DE TERCER GRADO DE SITIOS MÚLTIPLES DE LA EXTREMIDAD INFERIOR"
  },
  {
    "codigo":721643000,
    "descripcion":"NEOPLASIA MESENQUIMÁTICA MALIGNA PRIMARIA DE ESTÓMAGO"
  },
  {
    "codigo":361195001,
    "descripcion":"FIBROPLASIA PULMONAR"
  },
  {
    "codigo":295659005,
    "descripcion":"SOBREDOSIS DE DACTINOMICINA"
  },
  {
    "codigo":262891006,
    "descripcion":"HEMATOMA DE RIÑÓN"
  },
  {
    "codigo":787179008,
    "descripcion":"INFLAMACIÓN CRÓNICA DE ESTRUCTURA DE DRENAJE LAGRIMAL"
  },
  {
    "codigo":719808002,
    "descripcion":"SÍNDROME DE MICRODELECIÓN DE CROMOSOMA XP11.3"
  },
  {
    "codigo":424896002,
    "descripcion":"DIFICULTAD CON LAS RESPONSABILIDADES PARENTALES"
  },
  {
    "codigo":293824005,
    "descripcion":"ALERGIA A IPRINDOL"
  },
  {
    "codigo":195520008,
    "descripcion":"FLEBÓLITOS PÉLVICOS"
  },
  {
    "codigo":228288008,
    "descripcion":"BEBE EN EL PARQUE"
  },
  {
    "codigo":128149002,
    "descripcion":"SOPLO CARDÍACO, CATEGORIZADO POR EL RITMO"
  },
  {
    "codigo":15998391000119107,
    "descripcion":"TRASTORNO DE LA MÁCULA DEL OJO DERECHO"
  },
  {
    "codigo":717973004,
    "descripcion":"SÍNDROME DE DUPLICACIÓN CROMOSÓMICA 3Q29"
  },
  {
    "codigo":95381006,
    "descripcion":"INFECCIÓN DEL SITIO DE INYECCIÓN"
  },
  {
    "codigo":191850000,
    "descripcion":"FARMACODEPENDENCIA DE ALUCINÓGENOS, EPISÓDICA"
  },
  {
    "codigo":290154001,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR FENAZOCINA"
  },
  {
    "codigo":291989009,
    "descripcion":"INTOXICACIÓN INTENCIONAL CAUSADA POR INHIBIDORES DE LA ENZIMA CONVERTIDORA DE ANGIOTENSINA"
  },
  {
    "codigo":1142122008,
    "descripcion":"TAQUICARDIA RECIPROCANTE AURICULOVENTRICULAR ANTIDRÓMICA QUE UTILIZA VÍA ACCESORIA CON CONDUCCIÓN BIDIRECCIONAL"
  },
  {
    "codigo":188180002,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LOCALIZACIONES SUPERPUESTAS DE CUELLO UTERINO"
  },
  {
    "codigo":24340004,
    "descripcion":"FALTA DE DISCERNIMIENTO"
  },
  {
    "codigo":253716004,
    "descripcion":"TRAYECTO ABERRANTE DE ARTERIA CORONARIA DESCENDENTE ANTERIOR IZQUIERDA DESDE LA ARTERIA CORONARIA DERECHA A TRAVÉS DEL TRACTO DE SALIDA DEL VENTRÍCULO DERECHO"
  },
  {
    "codigo":778004006,
    "descripcion":"AUTOINFLAMACIÓN-DEFICIENCIA DE ANTICUERPOS ASOCIADA A FOSFOLIPASA C GAMMA 2-DESREGULACIÓN INMUNE"
  },
  {
    "codigo":286484006,
    "descripcion":"INCAPAZ DE MEZCLAR INGREDIENTES DE UNA COMIDA"
  },
  {
    "codigo":413886002,
    "descripcion":"ABERRACIÓN DEL FRENTE DE ONDA, COMA"
  },
  {
    "codigo":20670007,
    "descripcion":"TOS METÁLICA"
  },
  {
    "codigo":51603000,
    "descripcion":"PAQUIDERMIA PLEGADA DE CUERO CABELLUDO"
  },
  {
    "codigo":1231251001,
    "descripcion":"ECTROPIÓN MECÁNICO DE PÁRPADO INFERIOR"
  },
  {
    "codigo":315582007,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: RUSO"
  },
  {
    "codigo":134891000119104,
    "descripcion":"CALCINOSIS DISTRÓFICA DE ESCROTO"
  },
  {
    "codigo":444819004,
    "descripcion":"POLIARTERITIS DE RIÑÓN"
  },
  {
    "codigo":280979004,
    "descripcion":"TROMBOSIS DE DERIVACIÓN ARTERIOVENOSA"
  },
  {
    "codigo":43221000087101,
    "descripcion":"HERIDA PUNZANTE DE CADERA DERECHA CON CUERPO EXTRAÑO"
  },
  {
    "codigo":40661000087101,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE DEDO MEDIO IZQUIERDO"
  },
  {
    "codigo":48341000087105,
    "descripcion":"FRACTURA DE EXTREMO PROXIMAL DE FÉMUR IZQUIERDO"
  },
  {
    "codigo":38101000087106,
    "descripcion":"ACINESIA DE SEGMENTO ANTERIOR MEDIO DE VENTRÍCULO CARDÍACO IZQUIERDO"
  },
  {
    "codigo":82536003,
    "descripcion":"REQUERIMIENTO HORMONAL ANORMAL"
  },
  {
    "codigo":705128004,
    "descripcion":"INFARTO CEREBRAL DEBIDO A EMBOLIA DE ARTERIA CEREBRAL MEDIA"
  },
  {
    "codigo":61141000087108,
    "descripcion":"INFECCIÓN CAUSADA POR STACHYBOTRYS CHARTARUM"
  },
  {
    "codigo":49768006,
    "descripcion":"ALTERACIÓN DE LA LOCALIZACIÓN ESPACIAL: SEÑALIZACIÓN PASADA"
  },
  {
    "codigo":35541000087108,
    "descripcion":"ISQUEMIA DE MIOCARDIO INFERIOR"
  },
  {
    "codigo":354181000119100,
    "descripcion":"NEOPLASIA BENIGNA DE EPIDÍDIMO DERECHO"
  },
  {
    "codigo":770664009,
    "descripcion":"DISFUNCIÓN NEONATAL DEL TRONCO ENCEFÁLICO"
  },
  {
    "codigo":15165002,
    "descripcion":"FÍSTULA URETRORRECTAL"
  },
  {
    "codigo":1293117004,
    "descripcion":"TRASTORNO FETAL CAUSADO POR DEPENDENCIA ALCOHÓLICA MATERNA DURANTE EMBARAZO"
  },
  {
    "codigo":703293005,
    "descripcion":"INSUFICIENCIA DE PRÓTESIS DE VÁLVULA PULMONAR"
  },
  {
    "codigo":47933007,
    "descripcion":"PODALGIA"
  },
  {
    "codigo":108421000119102,
    "descripcion":"TROMBO MURAL DE VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":211773009,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO SUPERFICIAL DE PARED TORÁCICA"
  },
  {
    "codigo":80701009,
    "descripcion":"INTOXICACIÓN POR GÉNERO HELENIUM"
  },
  {
    "codigo":406546002,
    "descripcion":"FAMILIARES COMPROMETIDOS CON EL CUIDADO"
  },
  {
    "codigo":275474009,
    "descripcion":"HIPERFAGIA PSICÓGENA"
  },
  {
    "codigo":240871004,
    "descripcion":"INFECCIÓN PULMONAR POR CAPILARIASIS"
  },
  {
    "codigo":109799009,
    "descripcion":"DISTANCIA VERTICAL INTERMAXILAR EXCESIVA"
  },
  {
    "codigo":9660004,
    "descripcion":"ESTENOSIS CONGÉNITA DE TRÁQUEA"
  },
  {
    "codigo":206268005,
    "descripcion":"RECIÉN NACIDO VIVO CON HIPOXIA DURANTE EL TRABAJO DE PARTO"
  },
  {
    "codigo":1091461000119106,
    "descripcion":"TRASTORNO DE OÍDO EXTERNO DERECHO"
  },
  {
    "codigo":402876004,
    "descripcion":"NEOPLASIA MALIGNA DE ORIGEN EN VAINA NERVIOSA"
  },
  {
    "codigo":1254844005,
    "descripcion":"NEOPLASIA MESENQUIMATOSA PRIMARIA MALIGNA DE VÍA BILIAR"
  },
  {
    "codigo":239036005,
    "descripcion":"SÍNDROME TRICO-OCULODERMOVERTEBRAL"
  },
  {
    "codigo":433809002,
    "descripcion":"RECHAZO ACELERADO DE TRASPLANTE DE PÁNCREAS"
  },
  {
    "codigo":401041004,
    "descripcion":"HELICOBACTER PYLORI NO OBSERVADO POR MICROSCOPÍA"
  },
  {
    "codigo":40593004,
    "descripcion":"FIBRILACIÓN"
  },
  {
    "codigo":204433005,
    "descripcion":"APLASIA DE LA ARTERIA AORTA"
  },
  {
    "codigo":106129007,
    "descripcion":"CONDUCTA DE LA FUNCIÓN MOTRIZ - HALLAZGO"
  },
  {
    "codigo":71526000,
    "descripcion":"MANO DE PREDICADOR"
  },
  {
    "codigo":202598004,
    "descripcion":"CHASQUIDO DE ARTICULACIÓN ESTERNOCLAVICULAR"
  },
  {
    "codigo":366438006,
    "descripcion":"AMPLITUD DE LA FLEXIÓN LATERAL IZQUIERDA DE COLUMNA LUMBAR - HALLAZGO"
  },
  {
    "codigo":169830007,
    "descripcion":"GEMELOS: AMBOS MORTINATOS"
  },
  {
    "codigo":102459008,
    "descripcion":"TOLERANCIA AUMENTADA"
  },
  {
    "codigo":166160000,
    "descripcion":"ANTÍGENO PROSTÁTICO ESPECÍFICO FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":299067009,
    "descripcion":"AMPLITUD DE FLEXIÓN ACTIVA DE DEDO DE LA MANO DISMINUIDA"
  },
  {
    "codigo":36923009,
    "descripcion":"DEPRESIÓN MAYOR, UN SOLO EPISODIO"
  },
  {
    "codigo":395536008,
    "descripcion":"HALLAZGO RELACIONADO CON EL MARGEN DE RESECCIÓN QUIRÚRGICA"
  },
  {
    "codigo":721381001,
    "descripcion":"SÍNDROME DEL CORDÓN ANTERIOR DE MÉDULA ESPINAL AL NIVEL DEL PRIMER SEGMENTO CERVICAL"
  },
  {
    "codigo":297232009,
    "descripcion":"ACIDURIA 3-METILGLUTACÓNICA TIPO 3"
  },
  {
    "codigo":262629003,
    "descripcion":"LACERACIÓN DE MUCOSA BUCAL ALVEOLAR"
  },
  {
    "codigo":295397004,
    "descripcion":"SOBREDOSIS DE TRISILICATO DE MAGNESIO"
  },
  {
    "codigo":426469008,
    "descripcion":"DOLOR IRRADIADO A PIERNA IZQUIERDA"
  },
  {
    "codigo":129722001,
    "descripcion":"HALLAZGO PARCIALMENTE REMOVIDO DESDE LA ÚLTIMA MAMOGRAFÍA"
  },
  {
    "codigo":162490002,
    "descripcion":"SÍNTOMA QUE MEJORA CON EL FRÍO"
  },
  {
    "codigo":293562003,
    "descripcion":"REACCIÓN ADVERSA AL NAFTIDROFURILO"
  },
  {
    "codigo":1145530005,
    "descripcion":"DEFICIENCIA DE GLUCOSA - 6 - FOSFATO DESHIDROGENASA CON ACTIVIDAD ENZIMÁTICA NORMAL"
  },
  {
    "codigo":195258006,
    "descripcion":"ANEURISMA DE AORTA TORÁCICA ROTO"
  },
  {
    "codigo":62351001,
    "descripcion":"FOBIA SOCIAL GENERALIZADA"
  },
  {
    "codigo":15702201000119104,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE TENDÓN DE PIERNA DERECHA"
  },
  {
    "codigo":160655006,
    "descripcion":"DISPUESTO A DONAR SANGRE"
  },
  {
    "codigo":95119008,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA REGIÓN SUPRACLAVICULAR"
  },
  {
    "codigo":226191009,
    "descripcion":"DIETA SIN CHOCOLATE"
  },
  {
    "codigo":93284004,
    "descripcion":"HIPOPLASIA CONGÉNITA DEL PREMAXILAR"
  },
  {
    "codigo":289892008,
    "descripcion":"CICLO MENSTRUAL CORTO"
  },
  {
    "codigo":25913001,
    "descripcion":"ATROFIA ESENCIAL DEL IRIS"
  },
  {
    "codigo":1303865002,
    "descripcion":"SÍNDROME DE HÁBITO MARFANOIDE, DISMORFIA FACIAL, ANOMALÍA ESQUELÉTICA Y DEFECTO CARDÍACO"
  },
  {
    "codigo":191588009,
    "descripcion":"EPISODIO MANÍACO ÚNICO, EN REMISIÓN TOTAL"
  },
  {
    "codigo":1172793008,
    "descripcion":"TUMOR MALIGNO DE VAINA DE NERVIO PERIFÉRICO DE MUCOSA GINGIVAL"
  },
  {
    "codigo":253454000,
    "descripcion":"ANOMALÍA DE VÁLVULA AURICULOVENTRICULAR DERECHA EN VENTRÍCULO CON DOBLE TRACTO DE ENTRADA"
  },
  {
    "codigo":417294004,
    "descripcion":"QUERATITIS FACTICIA"
  },
  {
    "codigo":286222005,
    "descripcion":"DIFICULTAD PARA USAR LA CORRIENTE DE AIRE PULMONAR AL HABLAR"
  },
  {
    "codigo":187918004,
    "descripcion":"NEOPLASIA MALIGNA DE VÉRTEBRA LUMBAR"
  },
  {
    "codigo":775907000,
    "descripcion":"HIPOPLASIA PONTOCEREBELOSA CONGÉNITA TIPO 9"
  },
  {
    "codigo":24078009,
    "descripcion":"GANGOSA EN LA FRAMBESIA"
  },
  {
    "codigo":89614009,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO DE LA NARIZ"
  },
  {
    "codigo":446392000,
    "descripcion":"LESIÓN TRAUMÁTICA DE COLA DE PÁNCREAS"
  },
  {
    "codigo":448227009,
    "descripcion":"HETEROTOPIA VENTRICULAR LIGADA AL CROMOSOMA X"
  },
  {
    "codigo":1003448002,
    "descripcion":"ESPINA BÍFIDA ABIERTA DE COLUMNA VERTEBRAL LUMBOSACRA"
  },
  {
    "codigo":184248001,
    "descripcion":"REGISTRO DE MOVIMIENTOS FETALES - ENTREGADO"
  },
  {
    "codigo":708536001,
    "descripcion":"DISQUERATOSIS CONGÉNITA LIGADA AL CROMOSOMA X"
  },
  {
    "codigo":441901000124101,
    "descripcion":"INGESTA INADECUADA DE VITAMINA"
  },
  {
    "codigo":249784005,
    "descripcion":"DEFORMIDAD ROTACIONAL DE MIEMBRO INFERIOR"
  },
  {
    "codigo":20408009,
    "descripcion":"EFECTO BOHR DISMINUIDO"
  },
  {
    "codigo":1263757001,
    "descripcion":"HEMATOMA SUBUNGUEAL DE DEDO MEÑIQUE"
  },
  {
    "codigo":330221000119101,
    "descripcion":"COMPRESIÓN DE NERVIO MUSCULOCUTÁNEO IZQUIERDO"
  },
  {
    "codigo":18573003,
    "descripcion":"EROTOMANÍA OBSESIVA"
  },
  {
    "codigo":247949007,
    "descripcion":"RESISTENCIA A LOS CAMBIOS EN LOS PATRONES DE ACTIVIDAD"
  },
  {
    "codigo":772237007,
    "descripcion":"INCAPAZ DE MANTENER EL EQUILIBRIO AL PARARSE CON AMBOS PIES EN POSICIÓN DE SEMI TÁNDEM"
  },
  {
    "codigo":213346004,
    "descripcion":"FRACTURAS QUE COMPROMETEN MÚLTIPLES REGIONES DEL ORGANISMO"
  },
  {
    "codigo":16738008,
    "descripcion":"INFECCIÓN CAUSADA POR AMOEBOTAENIA"
  },
  {
    "codigo":211511002,
    "descripcion":"CONTUSIÓN DE MUÑECA, DORSO"
  },
  {
    "codigo":703031003,
    "descripcion":"CANDIDA INCONSPICUA O CANDIDA NORVEGENSIS"
  },
  {
    "codigo":1260087003,
    "descripcion":"ADENOCARCINOMA FETAL DE PULMÓN"
  },
  {
    "codigo":735799009,
    "descripcion":"LACERACIÓN DE HOMBRO SIN CUERPO EXTRAÑO"
  },
  {
    "codigo":209676002,
    "descripcion":"SECCIÓN EXPUESTA DE LIGAMENTO DEL PULGAR, ARTICULACIÓN METACARPOFALÁNGICA, LIGAMENTO LATERAL CUBITAL"
  },
  {
    "codigo":111372003,
    "descripcion":"GANGRENA DE LA VESÍCULA BILIAR"
  },
  {
    "codigo":439052006,
    "descripcion":"LESIÓN TRAUMÁTICA DE TENDÓN FLEXOR DE LA MANO"
  },
  {
    "codigo":109537007,
    "descripcion":"EXFOLIACIÓN DEMORADA DE UN SOLO DIENTE ASOCIADA CON TRAUMATISMO PREVIO"
  },
  {
    "codigo":44001008,
    "descripcion":"EYACULACIÓN PRECOZ"
  },
  {
    "codigo":238774003,
    "descripcion":"LIVEDO RETICULARIS IDIOPÁTICO CON ULCERACIÓN DE INVIERNO"
  },
  {
    "codigo":74934004,
    "descripcion":"ABSTINENCIA DE SUSTANCIA PSICOACTIVA"
  },
  {
    "codigo":18401000122101,
    "descripcion":"HIPERSENSIBILIDAD NO ALÉRGICA A IMIDAPRIL"
  },
  {
    "codigo":763062006,
    "descripcion":"SÍNDROME DE MICRODELECIÓN 2Q33.1"
  },
  {
    "codigo":271542005,
    "descripcion":"MÚSCULOS INTRÍNSECOS DE LA MANO ABERRANTES"
  },
  {
    "codigo":402614008,
    "descripcion":"HIPERMELANOSIS POR TRASTORNO DEL TEJIDO CONJUNTIVO"
  },
  {
    "codigo":1285515001,
    "descripcion":"GRANULOMA COROIDAL"
  },
  {
    "codigo":304310009,
    "descripcion":"AUSENCIA DE MOVIMIENTO DE DEDO DE LA MANO"
  },
  {
    "codigo":1252747005,
    "descripcion":"ERUPCIÓN POLIMÓRFICA DEL EMBARAZO"
  },
  {
    "codigo":204171005,
    "descripcion":"OPACIDAD CONGÉNITA DEL VÍTREO"
  },
  {
    "codigo":169568001,
    "descripcion":"EMBARAZO NO PLANEADO - SE DESCONOCE SI EL NIÑO ES DESEADO"
  },
  {
    "codigo":202336002,
    "descripcion":"DESGARRO DE RODETE ACETABULAR"
  },
  {
    "codigo":10625671000119106,
    "descripcion":"BRONCONEUMONÍA CAUSADA POR STREPTOCOCCUS"
  },
  {
    "codigo":10926881000119100,
    "descripcion":"FRACTURA NO EXPUESTA DE DIÁFISIS DE SEGUNDO HUESO METACARPIANO DE MANO DERECHA"
  },
  {
    "codigo":366176007,
    "descripcion":"REFLEJO DE HOCIQUEO - HALLAZGO"
  },
  {
    "codigo":235104008,
    "descripcion":"DIENTE IMPACTADO"
  },
  {
    "codigo":724789001,
    "descripcion":"EPILEPSIA DEBIDA A TUMOR INTRACRANEAL"
  },
  {
    "codigo":300640008,
    "descripcion":"CAPAZ DE MANEJAR UNA MOTOCICLETA"
  },
  {
    "codigo":298805005,
    "descripcion":"AMPLITUD DE ABDUCCIÓN PASIVA DE HOMBRO AUMENTADA"
  },
  {
    "codigo":167733009,
    "descripcion":"PROTEÍNAS EN LÍQUIDO CEFALORRAQUÍDEO DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":296970005,
    "descripcion":"SOBREDOSIS DE POTASIO"
  },
  {
    "codigo":722954005,
    "descripcion":"LINFOMA DE LINFOCITOS B INCLASIFICABLE, CON CARACTERÍSTICAS INTERMEDIAS ENTRE LINFOMA DE HODGKIN CLÁSICO Y LINFOMA DIFUSO DE LINFOCITOS B GRANDES"
  },
  {
    "codigo":223003,
    "descripcion":"NEOPLASIA DE CUERPO DE ÚTERO QUE AFECTA AL EMBARAZO"
  },
  {
    "codigo":721119004,
    "descripcion":"PSEUDOTROMBOCITOPENIA"
  },
  {
    "codigo":295135004,
    "descripcion":"SOBREDOSIS DE ASPIRINA"
  },
  {
    "codigo":65759007,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA BOCA"
  },
  {
    "codigo":424372002,
    "descripcion":"EDEMA DE EXTREMIDAD"
  },
  {
    "codigo":63924002,
    "descripcion":"GASTROENTEROPATÍA EOSINOFÍLICA CON ENFERMEDAD MUCOSA PREDOMINANTE"
  },
  {
    "codigo":293300005,
    "descripcion":"REACCIÓN ADVERSA A LA HORMONA REGULADORA DEL CALCIO"
  },
  {
    "codigo":1340041000,
    "descripcion":"INMUNODEFICIENCIA COMBINADA DEBIDA A DEFICIENCIA DE FCH01"
  },
  {
    "codigo":94857002,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE GRANDES VASOS"
  },
  {
    "codigo":29321007,
    "descripcion":"APOFISITIS"
  },
  {
    "codigo":1208969008,
    "descripcion":"CRISIS EPILÉPTICA TÓNICA DE INICIO GENERALIZADO"
  },
  {
    "codigo":224094000,
    "descripcion":"MIEMBRO DE FAMILIA PEQUEÑA"
  },
  {
    "codigo":1010526002,
    "descripcion":"ESCLEROSIS DE EPÍFISIS DE FALANGE DISTAL DE CUARTO DEDO DE PIE CON RADIOPACIDAD AUMENTADA"
  },
  {
    "codigo":60254004,
    "descripcion":"FÍSTULA PERICÁRDICA"
  },
  {
    "codigo":93022005,
    "descripcion":"ANOMALÍA CONGÉNITA DE CARTÍLAGO COSTAL"
  },
  {
    "codigo":289630004,
    "descripcion":"FONDO UTERINO ENTRE EL OMBLIGO Y EL APÉNDICE XIFOIDES DEL ESTERNÓN"
  },
  {
    "codigo":846686009,
    "descripcion":"PRURITO EN SITIO DE INYECCIÓN"
  },
  {
    "codigo":250991000119100,
    "descripcion":"MARCHA TAMBALEANTE"
  },
  {
    "codigo":10631791000119101,
    "descripcion":"ONIQUIA DE DEDO DE MANO DERECHA"
  },
  {
    "codigo":10905711000119100,
    "descripcion":"HERIDA ABIERTA DE CARA DEBIDA A MORDEDURA DE PERRO"
  },
  {
    "codigo":10741871000119101,
    "descripcion":"DEPENDENCIA DEL ALCOHOL DURANTE EL EMBARAZO"
  },
  {
    "codigo":91187007,
    "descripcion":"ENANISMO HIPOFISARIO CON SILLA TURCA PEQUEÑA"
  },
  {
    "codigo":87151000119105,
    "descripcion":"GLIOMA MALIGNO DE SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":33391000119104,
    "descripcion":"LESIÓN AURICULAR"
  },
  {
    "codigo":16035951000119106,
    "descripcion":"OSTEÓLISIS DE TIBIA DERECHA"
  },
  {
    "codigo":397970031000119102,
    "descripcion":"DISTENSIÓN DE MÚSCULO ADUCTOR DE MUSLO IZQUIERDO"
  },
  {
    "codigo":16038511000119109,
    "descripcion":"OSTEOPATÍA DE FÉMUR DERECHO POSTERIOR A POLIOMIELITIS"
  },
  {
    "codigo":16025711000119109,
    "descripcion":"ANEURISMA AGUDO DE VENA POPLÍTEA IZQUIERDA"
  },
  {
    "codigo":684579951000119109,
    "descripcion":"CARCINOMA PRIMARIO DE CÉLULAS ESCAMOSAS DE PIEL DE PIE DERECHO"
  },
  {
    "codigo":12067951000119107,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DURANTE OPERACIÓN DE CORAZÓN"
  },
  {
    "codigo":284125001,
    "descripcion":"NO CONTROLA LA POSICIÓN DEL TRONCO"
  },
  {
    "codigo":335471000119108,
    "descripcion":"MIOPÍA ALTA PROGRESIVA DEGENERATIVA DE OJO DERECHO"
  },
  {
    "codigo":10752111000119109,
    "descripcion":"CISTITIS AGUDA POSPARTO"
  },
  {
    "codigo":184431000119108,
    "descripcion":"NEUMONÍA AGUDA CAUSADA POR COCCIDIOIDOMICOSIS"
  },
  {
    "codigo":10629231000119109,
    "descripcion":"AMIGDALITIS ESTREPTOCÓCICA AGUDA RECURRENTE"
  },
  {
    "codigo":140911000119109,
    "descripcion":"ACCIDENTE CEREBROVASCULAR ISQUÉMICO CON COMA"
  },
  {
    "codigo":449800007,
    "descripcion":"NEOPLASIA DE CÚPULA VESICAL"
  },
  {
    "codigo":332731000119108,
    "descripcion":"IRIDOCICLITIS RECURRENTE DE OJO DERECHO"
  },
  {
    "codigo":21981000,
    "descripcion":"ARTERIA CORONARIA ÚNICA"
  },
  {
    "codigo":52914002,
    "descripcion":"CANDIDIASIS ANAL"
  },
  {
    "codigo":315058005,
    "descripcion":"CÁNCER DE COLON NO RELACIONADO CON POLIPOSIS HEREDITARIA"
  },
  {
    "codigo":247687001,
    "descripcion":"DELIRIO DEPRESIVO DE POBREZA"
  },
  {
    "codigo":1263495005,
    "descripcion":"MIELITIS DEBIDA A ESCLEROSIS MÚLTIPLE"
  },
  {
    "codigo":870279006,
    "descripcion":"LESIÓN CUTÁNEA PIGMENTADA DE CABEZA DE NATURALEZA INCIERTA"
  },
  {
    "codigo":18311006,
    "descripcion":"MENINGITIS ASÉPTICA CAUSADA POR FÁRMACO"
  },
  {
    "codigo":213084002,
    "descripcion":"DESPLAZAMIENTO DE AUTOINJERTO ÓSEO"
  },
  {
    "codigo":409692005,
    "descripcion":"INMUNOGLOBULINA M CONTRA DENGUE NEGATIVA"
  },
  {
    "codigo":1163356007,
    "descripcion":"MANCHADO DENTAL EXTRÍNSECO MEDICAMENTOSO"
  },
  {
    "codigo":1259825001,
    "descripcion":"CORDOMA PRIMARIO DE COLUMNA TORÁCICA"
  },
  {
    "codigo":11856981000119107,
    "descripcion":"HEMATOMA SUBUNGUEAL DE DEDO GORDO DE PIE DERECHO"
  },
  {
    "codigo":735537007,
    "descripcion":"COMA HIPERGLUCÉMICO HIPEROSMOLAR DEBIDO A DIABETES MELLITUS SIN CETOACIDOSIS"
  },
  {
    "codigo":473393007,
    "descripcion":"OCLUSIÓN CONGÉNITA DE SENO CORONARIO"
  },
  {
    "codigo":209414003,
    "descripcion":"DISTENSIÓN DE TENDÓN INFRAESPINOSO"
  },
  {
    "codigo":45574004,
    "descripcion":"IDENTIFICACIÓN DE UN CUERPO POR DETALLES RADIOLÓGICOS ESPECÍFICOS"
  },
  {
    "codigo":274950005,
    "descripcion":"BRUXISMO DURANTE EL SUEÑO"
  },
  {
    "codigo":897542004,
    "descripcion":"DELECIÓN DISTAL DEL BRAZO LARGO DEL CROMOSOMA 2"
  },
  {
    "codigo":305883002,
    "descripcion":"VISTO EN EL SERVICIO DE TOMOGRAFÍA COMPUTARIZADA"
  },
  {
    "codigo":830171008,
    "descripcion":"ALERGIA A MECLOZINA"
  },
  {
    "codigo":109275008,
    "descripcion":"NEVO MELANOCÍTICO DEL CUERO CABELLUDO"
  },
  {
    "codigo":115951000119105,
    "descripcion":"SÍNTOMA MAMARIO DE CAMBIO EN LA PIEL"
  },
  {
    "codigo":402352002,
    "descripcion":"POIQUILODERMIA POR LIQUEN PLANO"
  },
  {
    "codigo":1156016006,
    "descripcion":"TROMBOSIS DE ARTERIA CEREBRAL POSTERIOR IZQUIERDA"
  },
  {
    "codigo":205744006,
    "descripcion":"QUISTE CONGÉNITO DE GLÁNDULA SUPRARRENAL"
  },
  {
    "codigo":302213007,
    "descripcion":"FÍSTULA CAROTIDEOCAVERNOSA"
  },
  {
    "codigo":1285253007,
    "descripcion":"HALLAZGO RELACIONADO CON RANGO PASIVO DE DORSIFLEXIÓN DE TOBILLO"
  },
  {
    "codigo":236677009,
    "descripcion":"EXTRAVASACIÓN DE ORINA DE LA PRÓSTATA"
  },
  {
    "codigo":300378004,
    "descripcion":"DIFICULTAD PARA DEFECAR"
  },
  {
    "codigo":365914005,
    "descripcion":"MEMORIA DE PERSONA IMPORTANTE - HALLAZGO"
  },
  {
    "codigo":726362005,
    "descripcion":"TRISOMÍA PARCIAL DE CROMOSOMA 22"
  },
  {
    "codigo":890202007,
    "descripcion":"EMBRIOPATÍA CAUSADA POR ACITRETINA"
  },
  {
    "codigo":167471002,
    "descripcion":"CALCIO EN ORINA FUERA DE RANGO DE REFERENCIA"
  },
  {
    "codigo":298543004,
    "descripcion":"AMPLITUD DE FLEXIÓN LATERAL ACTIVA HACIA LA IZQUIERDA DE LA COLUMNA VERTEBRAL DORSAL, AUMENTADA"
  },
  {
    "codigo":724527004,
    "descripcion":"DUODENITIS CAUSADA POR SUSTANCIA QUÍMICA"
  },
  {
    "codigo":427780002,
    "descripcion":"LARINGITIS CAUSADA POR REFLUJO GASTROESOFÁGICO"
  },
  {
    "codigo":722692009,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE ÓRGANOS RESPIRATORIOS E INTRATORÁCICOS"
  },
  {
    "codigo":131033001,
    "descripcion":"EPINEFRINA ANORMAL"
  },
  {
    "codigo":289732131000119101,
    "descripcion":"INFARTO AGUDO DE COLON DEBIDO A TROMBOSIS DE VENA MESENTÉRICA"
  },
  {
    "codigo":296708009,
    "descripcion":"SOBREDOSIS DE CEFALOSPORINA DE TERCERA GENERACIÓN"
  },
  {
    "codigo":294873006,
    "descripcion":"ALERGIA A ENOXAPARINA"
  },
  {
    "codigo":308771000119102,
    "descripcion":"TENDINITIS DE TENDÓN DEL MÚSCULO GLÚTEO DERECHO"
  },
  {
    "codigo":194734000,
    "descripcion":"ESTENOSIS MITRAL E INSUFICIENCIA AÓRTICA"
  },
  {
    "codigo":293038002,
    "descripcion":"REACCIÓN ADVERSA A LA SULFADIMETOXINA"
  },
  {
    "codigo":260270000,
    "descripcion":"VISIÓN A DISTANCIA 6\/4"
  },
  {
    "codigo":717187000,
    "descripcion":"SÍNDROME DE NEFRONOPTISIS Y FIBROSIS HEPÁTICA"
  },
  {
    "codigo":94595000,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE PARTES BLANDAS DEL TRONCO"
  },
  {
    "codigo":291203003,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR TRIFLUOPERAZINA"
  },
  {
    "codigo":422275004,
    "descripcion":"GANGRENA DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":192899004,
    "descripcion":"MIELOPATÍA POR EDEMA DE LA MÉDULA ESPINAL"
  },
  {
    "codigo":782723007,
    "descripcion":"SÍNDROME DE DISCAPACIDAD INTELECTUAL SEVERA Y DIPLEJÍA ESPÁSTICA PROGRESIVA"
  },
  {
    "codigo":59992000,
    "descripcion":"LÍNEA DE BURTON"
  },
  {
    "codigo":92760004,
    "descripcion":"CARCINOMA IN SITU DE LA PARED SUPERIOR DE LA NASOFARINGE"
  },
  {
    "codigo":289368007,
    "descripcion":"POSICIÓN ANÓMALA DEL FETO EN LA PRESENTACIÓN DE HOMBROS"
  },
  {
    "codigo":254765000,
    "descripcion":"TUMOR CUTÁNEO ORIGINADO EN CÉLULAS DE MÚSCULO LISO"
  },
  {
    "codigo":715352009,
    "descripcion":"STAPHYLOCOCCUS PSEUDINTERMEDIUS O STAPHYLOCOCCUS DELPHINI"
  },
  {
    "codigo":189229003,
    "descripcion":"CARCINOMA IN SITU DE ÁNGULO ESPLÉNICO"
  },
  {
    "codigo":418605004,
    "descripcion":"ADIPOSIS TUBEROSA SIMPLE"
  },
  {
    "codigo":449538001,
    "descripcion":"DEFECTO DEL TABIQUE AURICULOVENTRICULAR CON INSUFICIENCIA DE VÁLVULA AURICULOVENTRICULAR A TRAVÉS DE COMISURA DE VALVA EN PUENTE SUPERIOR ANTEROSUPERIOR DERECHA"
  },
  {
    "codigo":283863000,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO EN LA PLANTA DEL PIE"
  },
  {
    "codigo":416770009,
    "descripcion":"SÍNDROME DE HISTOPLASMOSIS OCULAR"
  },
  {
    "codigo":21719001,
    "descripcion":"RINITIS ALÉRGICA CAUSADA POR POLEN"
  },
  {
    "codigo":709847007,
    "descripcion":"UBICACIÓN Y EXTENSIÓN DE REGIÓN EDÉNTULA DE LA CAVIDAD BUCAL MÍNIMAMENTE COMPROMETIDA"
  },
  {
    "codigo":10849981000119105,
    "descripcion":"HERIDA ABIERTA DE MAMA IZQUIERDA"
  },
  {
    "codigo":447703009,
    "descripcion":"DOBLE CAYADO AÓRTICO CON ARCO IZQUIERDO DOMINANTE Y COARTACIÓN DE ARCO DERECHO"
  },
  {
    "codigo":183724002,
    "descripcion":"CONSULTA DOMICILIARIA DE CIRUGÍA GENERAL SOLICITADA"
  },
  {
    "codigo":282028001,
    "descripcion":"INFECCIÓN POR STAPHYLOCOCCUS AUREUS MULTIRRESISTENTE"
  },
  {
    "codigo":118188004,
    "descripcion":"HALLAZGO RELACIONADO CON EL NEONATO"
  },
  {
    "codigo":773548008,
    "descripcion":"ENCEFALOPATÍA EPILÉPTICA DE INICIO TEMPRANO, CEGUERA CORTICAL, DISCAPACIDAD INTELECTUAL Y DISMORFIA FACIAL"
  },
  {
    "codigo":1197697000,
    "descripcion":"VÁRICES ESOFÁGICAS SANGRANTES POR COLANGITIS BILIAR PRIMARIA"
  },
  {
    "codigo":50817002,
    "descripcion":"EMBOLIA DE LA VENA CAVA"
  },
  {
    "codigo":413100008,
    "descripcion":"SÍNDROME AQUINÉTICO CON RIGIDEZ"
  },
  {
    "codigo":247425004,
    "descripcion":"MAL ESTADO DE LA PIEL"
  },
  {
    "codigo":312961004,
    "descripcion":"RETINOPATÍA POR TAMOXIFENO"
  },
  {
    "codigo":85420008,
    "descripcion":"PLEURESÍA ESTREPTOCÓCICA"
  },
  {
    "codigo":83585001,
    "descripcion":"SÍNDROME DE TRISOMÍA PROXIMAL 14Q"
  },
  {
    "codigo":704342006,
    "descripcion":"ACTITUD CONFLICTIVA HACIA EL EJERCICIO"
  },
  {
    "codigo":81750007,
    "descripcion":"TRASTORNO DE LA FUNCIÓN SENSITIVA DEL NERVIO GLOSOFARÍNGEO"
  },
  {
    "codigo":79915001,
    "descripcion":"FATIGABILIDAD"
  },
  {
    "codigo":48982009,
    "descripcion":"SÍNDROME DE BANNWARTH"
  },
  {
    "codigo":1259563004,
    "descripcion":"MELANOMA FUSOCELULAR MALIGNO PRIMARIO"
  },
  {
    "codigo":276523005,
    "descripcion":"COLITIS NEONATAL TRANSITORIA"
  },
  {
    "codigo":47147007,
    "descripcion":"MALFORMACIÓN CONGÉNITA DEL PULMÓN"
  },
  {
    "codigo":210987008,
    "descripcion":"ABRASIÓN DE LA CARA"
  },
  {
    "codigo":14379009,
    "descripcion":"ANEMIA DISMÓRFICA"
  },
  {
    "codigo":372992000,
    "descripcion":"INFECCIÓN CAUSADA POR ASPERGILLUS PARASITICUS"
  },
  {
    "codigo":1290496004,
    "descripcion":"TENDINOSIS DE PIE"
  },
  {
    "codigo":241920007,
    "descripcion":"EFECTO TÓXICO CAUSADO POR MATERIAL DE MATAFUEGOS"
  },
  {
    "codigo":405760008,
    "descripcion":"LESIÓN TRAUMÁTICA COMPLETA DE LA MÉDULA ESPINAL CERVICAL, SIN LESIÓN VERTEBRAL, C1-4"
  },
  {
    "codigo":274688009,
    "descripcion":"HALLAZGO CITOLÓGICO ANORMAL EN ESPÉCIMEN DE ÓRGANO GENITAL FEMENINO"
  },
  {
    "codigo":45312009,
    "descripcion":"NEUMONÍA EN LA FIEBRE TIFOIDEA"
  },
  {
    "codigo":698837003,
    "descripcion":"QUISTE PORENCEFÁLICO POSTRAUMÁTICO DE CEREBRO"
  },
  {
    "codigo":15984471000119107,
    "descripcion":"MALFORMACIÓN CONGÉNITA DEL OÍDO IZQUIERDO CON ALTERACIÓN AUDITIVA"
  },
  {
    "codigo":43477006,
    "descripcion":"XERODERMIA PIGMENTOSA, GRUPO A"
  },
  {
    "codigo":240085008,
    "descripcion":"MIOPATÍA CONGÉNITA CON TIPO DE FIBRA UNIFORME"
  },
  {
    "codigo":403925009,
    "descripcion":"MELANOMA MALIGNO NEUROTRÓPICO"
  },
  {
    "codigo":762538002,
    "descripcion":"TRASTORNO DE VÁLVULA CARDÍACA POSTERIOR A PROCEDIMIENTO"
  },
  {
    "codigo":271018002,
    "descripcion":"AUSENCIA CONGÉNITA DE TENDÓN"
  },
  {
    "codigo":205482002,
    "descripcion":"SÍNDROMES FATALES DE OSIFICACIÓN RETARDADA"
  },
  {
    "codigo":860842004,
    "descripcion":"ENCEFALOMIELITIS CAUSADA POR COXIELLA BURNETII"
  },
  {
    "codigo":269183000,
    "descripcion":"HERIDA ABIERTA DE PIE, EXCEPTO DEDO(S) DEL PIE"
  },
  {
    "codigo":236415000,
    "descripcion":"GLOMERULONEFRITIS MEMBRANOSA - ESTADIO III"
  },
  {
    "codigo":301951002,
    "descripcion":"HALLAZGO RELACIONADO CON LA APARIENCIA DEL IRIS"
  },
  {
    "codigo":1186687002,
    "descripcion":"AMBIENTE DESCONOCIDO"
  },
  {
    "codigo":39807006,
    "descripcion":"DELIRIO POR INTOXICACIÓN CON CANNABIS"
  },
  {
    "codigo":203647008,
    "descripcion":"ESCOLIOSIS POSQUIRÚRGICA"
  },
  {
    "codigo":431188001,
    "descripcion":"SE TRASLADA EN MONTACARGA"
  },
  {
    "codigo":234580003,
    "descripcion":"DEFECTO QUIMIOTÁCTICO DE CÉLULAS FAGOCÍTICAS"
  },
  {
    "codigo":300116004,
    "descripcion":"PABELLÓN AURICULAR DE COLOR NORMAL"
  },
  {
    "codigo":365652009,
    "descripcion":"VISCOSIDAD PLASMÁTICA - HALLAZGO"
  },
  {
    "codigo":68905002,
    "descripcion":"ASTIGMATISMO REGULAR"
  },
  {
    "codigo":429353004,
    "descripcion":"LESIÓN TRAUMÁTICA DE RADIO"
  },
  {
    "codigo":199977005,
    "descripcion":"LACERACIÓN OBSTÉTRICA DE LA PORCIÓN SUPERIOR DE LA VAGINA"
  },
  {
    "codigo":427518000,
    "descripcion":"QUISTE SINOVIAL DE LA COLUMNA VERTEBRAL LUMBAR"
  },
  {
    "codigo":298281008,
    "descripcion":"DEBILIDAD FACIAL SUPERIOR"
  },
  {
    "codigo":198142001,
    "descripcion":"SALPINGOOFORITIS CRÓNICA"
  },
  {
    "codigo":296446003,
    "descripcion":"SOBREDOSIS DE PREPARADOS BRONCODILATADORES"
  },
  {
    "codigo":11862001000119109,
    "descripcion":"RUPTURA TRAUMÁTICA DE LIGAMENTO CRUZADO DE ARTICULACIÓN DE RODILLA DERECHA"
  },
  {
    "codigo":67070005,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DE LA OREJA"
  },
  {
    "codigo":284811000119102,
    "descripcion":"ANEURISMA DE PORCIÓN EXTRACRANEAL DE ARTERIA CARÓTIDA INTERNA"
  },
  {
    "codigo":1534008,
    "descripcion":"PARÁLISIS DE LA MIRADA CONJUGADA"
  },
  {
    "codigo":722430008,
    "descripcion":"SÍNDROME DE TRISOMÍA 6P DISTAL"
  },
  {
    "codigo":12081291000119104,
    "descripcion":"QUEMADURA QUÍMICA DE SACO CONJUNTIVAL DERECHO"
  },
  {
    "codigo":294611004,
    "descripcion":"ALERGIA A RIFAMPICINA"
  },
  {
    "codigo":30632004,
    "descripcion":"FRACTURA NO EXPUESTA DE HUESO PIRAMIDAL DEL CARPO"
  },
  {
    "codigo":292776006,
    "descripcion":"REACCIÓN ADVERSA A ACEITE DE MANÍ"
  },
  {
    "codigo":128936008,
    "descripcion":"INFECCIÓN DE LA PIEL, DE ORIGEN BACTERIANO"
  },
  {
    "codigo":391080009,
    "descripcion":"RESULTADO DE ECOGRAFÍA CUANTITATIVA DE TALÓN: NORMAL"
  },
  {
    "codigo":61565001,
    "descripcion":"COLESTEROLOSIS DE VESÍCULA BILIAR"
  },
  {
    "codigo":1306749003,
    "descripcion":"GLAUCOMA DE CÉLULAS FANTASMA DE AMBOS OJOS DEBIDO A HEMORRAGIA INTRAOCULAR Y POSTERIOR A ELLA"
  },
  {
    "codigo":127101005,
    "descripcion":"LINFADENOPATÍA PULMONAR"
  },
  {
    "codigo":290941007,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR PIRACETAM"
  },
  {
    "codigo":92498000,
    "descripcion":"OSIFICACIÓN BIPARTITA DE LA VÉRTEBRA ESTERNAL"
  },
  {
    "codigo":782461009,
    "descripcion":"HIPERHIDROSIS FOCAL PRIMARIA DE LA PLANTA DEL PIE DERECHO"
  },
  {
    "codigo":94333009,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA CARA HIPOFARÍNGEA DEL PLIEGUE INTERARITENOIDEO"
  },
  {
    "codigo":715090009,
    "descripcion":"DIFICULTAD PARA PASAR DE LA CAMA A LA SILLA"
  },
  {
    "codigo":11809061000119104,
    "descripcion":"HERIDA DE MUSLO DERECHO DEBIDA A PICADURA DE INSECTO NO VENENOSO"
  },
  {
    "codigo":254503007,
    "descripcion":"NEOPLASIA MALIGNA DE CARA INFERIOR DE PALADAR BLANDO"
  },
  {
    "codigo":416508000,
    "descripcion":"DISFUNCIÓN SOMÁTICA DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":23292001,
    "descripcion":"GRUPO DE VOZ DE TONO ALTO"
  },
  {
    "codigo":340261000119105,
    "descripcion":"ASTIGMATISMO IRREGULAR DE OJO IZQUIERDO"
  },
  {
    "codigo":94501000119106,
    "descripcion":"HIPOTENSIÓN TRANSITORIA"
  },
  {
    "codigo":285436008,
    "descripcion":"CAPAZ DE REALIZAR FUNCIONES MOTRICES ORALES"
  },
  {
    "codigo":185297000,
    "descripcion":"ATENDIDO POR OBSTÉTRICA DE HOSPITAL"
  },
  {
    "codigo":250833002,
    "descripcion":"DEPRESIÓN ANTE ESTÍMULOS SIMPLES - HALLAZGO"
  },
  {
    "codigo":54225002,
    "descripcion":"CARDIOPATÍA HIPERTENSIVA MALIGNA"
  },
  {
    "codigo":86993003,
    "descripcion":"ANOMALÍA CONGÉNITA DEL RECTO"
  },
  {
    "codigo":283601003,
    "descripcion":"HERIDA POR PINCHAZO DE AGUJA EN LA FRENTE"
  },
  {
    "codigo":709585003,
    "descripcion":"ATEROSCLEROSIS DE INJERTO-PUENTE BIOLÓGICO, NO AUTÓLOGO, DE MIEMBRO INFERIOR"
  },
  {
    "codigo":216230000,
    "descripcion":"LESIÓN POR DESCENSO VOLUNTARIO EN PARACAÍDAS, SIN ACCIDENTE DE AERONAVE, PARACAIDISTA LESIONADO"
  },
  {
    "codigo":707750005,
    "descripcion":"HIPERALDOSTERONISMO CONCOMITANTE CON HIPERPLASIA DE CORTEZA SUPRARRENAL"
  },
  {
    "codigo":314534006,
    "descripcion":"QUEMADURA TÉRMICA"
  },
  {
    "codigo":871590008,
    "descripcion":"OBSTRUCCIÓN ADQUIRIDA DE DERIVACIÓN ARTERIAL SISTÉMICA-PULMONAR DEBIDA A PROCEDIMIENTO Y POSTERIOR A ÉL"
  },
  {
    "codigo":17787002,
    "descripcion":"NEURITIS PERIFÉRICA EN EL EMBARAZO"
  },
  {
    "codigo":247163002,
    "descripcion":"FIBROSIS SUBRETINIANA MACULAR"
  },
  {
    "codigo":312699008,
    "descripcion":"LUXACIÓN DE LENTE INTRAOCULAR"
  },
  {
    "codigo":704080002,
    "descripcion":"FRACTURA NO EXPUESTA DE CUELLO DE QUINTO METACARPIANO"
  },
  {
    "codigo":81488005,
    "descripcion":"HEMORRAGIA DEL CUELLO UTERINO"
  },
  {
    "codigo":313791000119106,
    "descripcion":"ATROFIA MUSCULAR DE ANTEBRAZO IZQUIERDO"
  },
  {
    "codigo":1162832007,
    "descripcion":"SÍNDROME DE MAYER ROKITANSKY KÜSTER HAUSER TIPO 1"
  },
  {
    "codigo":278096009,
    "descripcion":"VELOCIDAD DEL PARTO, LENTA"
  },
  {
    "codigo":866085001,
    "descripcion":"INFECCIÓN DE NERVIO CRANEAL CAUSADA POR MUCORALES"
  },
  {
    "codigo":11838041000119101,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO INTRÍNSECO DE DEDO MEÑIQUE DERECHO"
  },
  {
    "codigo":46885003,
    "descripcion":"OSTEOMALACIA DE PELVIS"
  },
  {
    "codigo":833317005,
    "descripcion":"REACCIÓN ADVERSA A INSULINA REGULAR"
  },
  {
    "codigo":210725007,
    "descripcion":"DAÑO MULTITISULAR MASIVO DEL PIE"
  },
  {
    "codigo":276261007,
    "descripcion":"DEFICIENCIA DE PTERINA-4-CARBINOLAMINA DESHIDRATASA"
  },
  {
    "codigo":309029009,
    "descripcion":"SITUACIÓN DEL INFORME DE SEGURIDAD SOCIAL"
  },
  {
    "codigo":1290234002,
    "descripcion":"CARCINOMA NEUROENDOCRINO MICROCÍTICO DE OVARIO"
  },
  {
    "codigo":405498007,
    "descripcion":"PREMEDICACIÓN INADECUADA"
  },
  {
    "codigo":272591001,
    "descripcion":"APOYO VERTICAL FLOTANTE"
  },
  {
    "codigo":403663003,
    "descripcion":"PIGMENTACIÓN ORAL INDUCIDA POR FÁRMACOS"
  },
  {
    "codigo":1255631006,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS TIPO FUSOCELULAR DE HIPOFARINGE"
  },
  {
    "codigo":303524004,
    "descripcion":"NO SE PONE LA PELUCA"
  },
  {
    "codigo":237988006,
    "descripcion":"DEFICIENCIA DE NICOTINAMIDA ADENINA DINUCLEÓTIDO COENZIMA Q REDUCTASA"
  },
  {
    "codigo":762276009,
    "descripcion":"ÚLCERA DE DUODENO DEBIDA A INFECCIÓN"
  },
  {
    "codigo":170617002,
    "descripcion":"EFECTO COLATERAL DE FÁRMACO PARA VÍAS RESPIRATORIAS"
  },
  {
    "codigo":39545002,
    "descripcion":"DIETA CON BAJO CONTENIDO DE COLESTEROL Y GRASAS SATURADAS"
  },
  {
    "codigo":399993004,
    "descripcion":"TRASTORNO DEL GUSTO"
  },
  {
    "codigo":301689005,
    "descripcion":"RUEDA EN LA CAMA"
  },
  {
    "codigo":398158001,
    "descripcion":"COMPLICACIÓN DE LA VÍA INTRAVASCULAR"
  },
  {
    "codigo":299854005,
    "descripcion":"REFLEJO ABDOMINAL VIVO"
  },
  {
    "codigo":201550005,
    "descripcion":"ARTRITIS DE REGIÓN PÉLVICA POSTERIOR A HELMINTIASIS"
  },
  {
    "codigo":1217358007,
    "descripcion":"NIVEL DE SUSTANCIA EN SANGRE DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":365390008,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD DE SOBRELLEVAR ACTIVIDADES LABORALES"
  },
  {
    "codigo":166947005,
    "descripcion":"NIVEL DE VALPROATO POR DEBAJO DE RANGO DE REFERENCIA"
  },
  {
    "codigo":429091008,
    "descripcion":"DEPENDENCIA DE LA VENTILACIÓN CON PRESIÓN POSITIVA BIFÁSICA EN LA VÍA AÉREA"
  },
  {
    "codigo":230648001,
    "descripcion":"SÍNDROME DE COMPRESIÓN DE NERVIO CUTÁNEO ABDOMINAL"
  },
  {
    "codigo":722168002,
    "descripcion":"GLOMERULONEFRITIS MEMBRANOSA CONCOMITANTE CON ENFERMEDAD INFECCIOSA"
  },
  {
    "codigo":1080051000119105,
    "descripcion":"SARCOMA DE EWING PRIMARIO DE HUESO DE PIE DERECHO"
  },
  {
    "codigo":296184004,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE TRIFLUPERIDOL"
  },
  {
    "codigo":165112005,
    "descripcion":"COEFICIENTE RESPIRATORIO, NORMAL"
  },
  {
    "codigo":342771000119105,
    "descripcion":"DERMATITIS ALÉRGICA POR CONTACTO DE PÁRPADO INFERIOR DERECHO"
  },
  {
    "codigo":294349009,
    "descripcion":"ALERGIA A AMFOTERICINA"
  },
  {
    "codigo":292514002,
    "descripcion":"REACCIÓN ADVERSA A APRACLONIDINA"
  },
  {
    "codigo":423586007,
    "descripcion":"OSTEOMA DE CRÁNEO"
  },
  {
    "codigo":95906008,
    "descripcion":"INTERACCIÓN DE FÁRMACO CON ALCOHOL"
  },
  {
    "codigo":388983002,
    "descripcion":"PARONIQUIA DE DEDO DE PIE"
  },
  {
    "codigo":94071006,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE BAZO"
  },
  {
    "codigo":126839008,
    "descripcion":"NEOPLASIA DEL CIEGO"
  },
  {
    "codigo":714828000,
    "descripcion":"HEMATURIA PERSISTENTE CONCOMITANTE CON LESIONES GLOMERULARES FOCALES Y SEGMENTARIAS Y DEBIDA A ELLAS"
  },
  {
    "codigo":92236002,
    "descripcion":"NEOPLASIA BENIGNA DE MÚSCULO DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":419916003,
    "descripcion":"VÍCTIMA DE MALTRATO EMOCIONAL"
  },
  {
    "codigo":716663009,
    "descripcion":"DISTROFIA RETINIANA SEVERA DE COMIENZO EN LA PRIMERA INFANCIA"
  },
  {
    "codigo":876833001,
    "descripcion":"INGESTA EXCESIVA DE HIERRO"
  },
  {
    "codigo":385313002,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA PROXIMAL DE MUCOSA, AFECTADO POR CARCINOMA IN SITU"
  },
  {
    "codigo":450849003,
    "descripcion":"MALABSORCIÓN CONGÉNITA DE MONOSACÁRIDOS"
  },
  {
    "codigo":254241004,
    "descripcion":"NEUROFIBROMATOSIS SEGMENTARIA"
  },
  {
    "codigo":711158005,
    "descripcion":"ATAXIA ESPINOCEREBELOSA TIPO 36"
  },
  {
    "codigo":416246006,
    "descripcion":"CONSUMO PROLONGADO DE ALTAS DOSIS DE CÁÑAMO"
  },
  {
    "codigo":285174008,
    "descripcion":"INCAPAZ DE RECONOCER SONIDOS"
  },
  {
    "codigo":449014008,
    "descripcion":"DESEMBOCADURA DE VENA HEPÁTICA EN AURÍCULA EN EL LADO IZQUIERDO"
  },
  {
    "codigo":283339003,
    "descripcion":"PICADURA DE INSECTO EN LAS EXTREMIDADES INFERIORES"
  },
  {
    "codigo":53963006,
    "descripcion":"FRICCIÓN EXCESIVA DE LOS DIENTES"
  },
  {
    "codigo":86731008,
    "descripcion":"FRACTURAS EXPUESTAS MÚLTIPLES DE LA PELVIS CON INTERRUPCIÓN DEL CÍRCULO PÉLVICO"
  },
  {
    "codigo":1297312000,
    "descripcion":"CELULITIS DE QUINTO DEDO DE PIE"
  },
  {
    "codigo":1264544004,
    "descripcion":"FRACTURA DE HUESO ADYACENTE A PRÓTESIS DE ARTICULACIÓN DE MUÑECA"
  },
  {
    "codigo":281504005,
    "descripcion":"LUXACIÓN FEMORORROTULIANA EXTERNA"
  },
  {
    "codigo":15664321000119100,
    "descripcion":"PAPILOMA DE CONJUNTIVA DE AMBOS OJOS"
  },
  {
    "codigo":19360008,
    "descripcion":"LINFANGITIS AGUDA DE BRAZO"
  },
  {
    "codigo":248736009,
    "descripcion":"DESCENSO LENTO DE LA ONDA \"Y\" DEL PULSO VENOSO YUGULAR"
  },
  {
    "codigo":16018471000119107,
    "descripcion":"ALTERACIÓN DE RÓTULA DERECHA"
  },
  {
    "codigo":1229941002,
    "descripcion":"INMUNODEFICIENCIA COMBINADA GRAVE T- B+ AUTOSÓMICA RECESIVA DEBIDA A DEFICIENCIA DE CD45"
  },
  {
    "codigo":50293005,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE PENE CON INFECCIÓN"
  },
  {
    "codigo":277834005,
    "descripcion":"ANSIEDAD ACERCA DE SUFRIR UN ATAQUE CARDÍACO"
  },
  {
    "codigo":212298008,
    "descripcion":"LESIÓN DEL NERVIO INTERÓSEO ANTERIOR"
  },
  {
    "codigo":1259039002,
    "descripcion":"DESMIELINIZACIÓN DE SISTEMA NERVIOSO CENTRAL DEBIDA A ENFERMEDAD DE WHIPPLE"
  },
  {
    "codigo":1082561000119104,
    "descripcion":"OTITIS MEDIA AGUDA SUPURATIVA RECURRENTE CON RUPTURA ESPONTÁNEA DE LA MEMBRANA TIMPÁNICA"
  },
  {
    "codigo":15746241000119106,
    "descripcion":"INESTABILIDAD DE ARTICULACIÓN DE LA MANO DERECHA"
  },
  {
    "codigo":274164006,
    "descripcion":"TRAUMATISMO CRANEOENCEFÁLICO LEVE"
  },
  {
    "codigo":345281000119106,
    "descripcion":"LUXACIÓN ESPONTÁNEA OCULAR BILATERAL"
  },
  {
    "codigo":110324009,
    "descripcion":"OCLUSIÓN DEL PLANO TERMINAL EN LA DENTICIÓN PRIMARIA"
  },
  {
    "codigo":42953002,
    "descripcion":"MIASIS GENITOURINARIA"
  },
  {
    "codigo":306932009,
    "descripcion":"SUPERESTRUCTURA DEL ESTRIBO, AUSENTE"
  },
  {
    "codigo":1157065006,
    "descripcion":"NEOPLASIA BENIGNA DE REGIÓN DE COLUMNA VERTEBRAL"
  },
  {
    "codigo":403401007,
    "descripcion":"PSEUDOXANTOMA ELÁSTICO ADQUIRIDO"
  },
  {
    "codigo":237726001,
    "descripcion":"DEFECTO DE OSMORREGULACIÓN - ADIPSIA"
  },
  {
    "codigo":270494003,
    "descripcion":"NECROSIS PAPILAR AGUDA"
  },
  {
    "codigo":1351838008,
    "descripcion":"SÍNDROME DE DISCAPACIDAD INTELECTUAL, CATARATAS DE COMIENZO TEMPRANO Y MICROCEFALIA"
  },
  {
    "codigo":204958008,
    "descripcion":"NEFRONOPTISIS"
  },
  {
    "codigo":1153395006,
    "descripcion":"OSIFICACIÓN MUSCULAR IDIOPÁTICA"
  },
  {
    "codigo":102984002,
    "descripcion":"CAÍDA HACIA ATRÁS PROVOCADA POR LA PRUEBA DE ROMBERG"
  },
  {
    "codigo":299592003,
    "descripcion":"AMPLITUD DE FLEXIÓN PASIVA DE DEDO DEL PIE DISMINUIDA"
  },
  {
    "codigo":365128003,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA ACOSTARSE EN LA CAMA Y LEVANTARSE DE ELLA"
  },
  {
    "codigo":37448008,
    "descripcion":"ALTERACIÓN DE LA INTUICIÓN"
  },
  {
    "codigo":232221001,
    "descripcion":"CALCIFICACIÓN DEL PABELLÓN AURICULAR"
  },
  {
    "codigo":234056008,
    "descripcion":"VÁRICES DE LAS PIERNAS DISTRIBUIDAS EN EL TERRITORIO DE LA VENA SAFENA EXTERNA"
  },
  {
    "codigo":461597002,
    "descripcion":"ATRESIA CONGÉNITA DE LUZ DEL CAYADO AÓRTICO ENTRE ARTERIA CARÓTIDA PRIMITIVA IZQUIERDA Y ARTERIA CARÓTIDA PRIMITIVA DERECHA"
  },
  {
    "codigo":166685005,
    "descripcion":"ELECTRÓLITOS DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":363293009,
    "descripcion":"INTOXICACIÓN AUTOINFLIGIDA"
  },
  {
    "codigo":787442004,
    "descripcion":"FORMA SISTÉMICA DE INFECCIÓN CRÓNICA ACTIVA POR VIRUS DE EPSTEIN-BARR, TIPO DE CÉLULAS T Y NK"
  },
  {
    "codigo":33778004,
    "descripcion":"RESPIRACIÓN BRONCOVESICULAR"
  },
  {
    "codigo":197618004,
    "descripcion":"GLOMERULONEFRITIS FOCAL CRÓNICA"
  },
  {
    "codigo":263154009,
    "descripcion":"FRACTURA DE COMPLEJO FRONTONASOETMOIDAL CON AUMENTO DE LA DISTANCIA INTERCANTAL"
  },
  {
    "codigo":294087007,
    "descripcion":"ALERGIA A OXITROPIO"
  },
  {
    "codigo":95644001,
    "descripcion":"ENCEFALITIS POR LUPUS ERITEMATOSO SISTÉMICO"
  },
  {
    "codigo":292252002,
    "descripcion":"REACCIÓN ADVERSA A LA VINCRISTINA"
  },
  {
    "codigo":1176988004,
    "descripcion":"NEUMONÍA ENTEROBACTERIANA"
  },
  {
    "codigo":423324006,
    "descripcion":"CAPACIDAD DE RAZONAMIENTO LIMITADA"
  },
  {
    "codigo":716401000,
    "descripcion":"CAPAZ DE LIMPIAR OBJETOS A LA ALTURA DE LA CINTURA"
  },
  {
    "codigo":290417003,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR DOMPERIDONA"
  },
  {
    "codigo":10751631000119101,
    "descripcion":"TRABAJO DE PARTO OBSTRUIDO DEBIDO A ANOMALÍA DE LA PELVIS MATERNA"
  },
  {
    "codigo":93809003,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL FONDO DEL ESTÓMAGO"
  },
  {
    "codigo":61041006,
    "descripcion":"LUXACIONES CERRADAS MÚLTIPLES DEL DORSO"
  },
  {
    "codigo":421489005,
    "descripcion":"ASTIGMATISMO EN CONTRA DE LA REGLA"
  },
  {
    "codigo":675471000119102,
    "descripcion":"HEBRAS VÍTREAS DE OJO DERECHO"
  },
  {
    "codigo":126577008,
    "descripcion":"NEOPLASIA DE HUESO TRAPEZOIDE"
  },
  {
    "codigo":288582004,
    "descripcion":"INCAPAZ DE EMPLEAR LA COMUNICACIÓN NO VERBAL"
  },
  {
    "codigo":1237019000,
    "descripcion":"CON RIESGO ELEVADO DE EXPOSICIÓN A HAEMOPHILUS INFLUENZAE TIPO B"
  },
  {
    "codigo":253979005,
    "descripcion":"DEFORMIDAD CONGÉNITA DEL CRÁNEO"
  },
  {
    "codigo":712731007,
    "descripcion":"PÓLIPO DE ÁNGULO HEPÁTICO DEL COLON"
  },
  {
    "codigo":55536001,
    "descripcion":"POSICIÓN ANÓMALA CONGÉNITA DE RIÑÓN"
  },
  {
    "codigo":219376002,
    "descripcion":"HERIDA DE GUERRA POR BALA DE AMETRALLADORA"
  },
  {
    "codigo":283077001,
    "descripcion":"ARAÑAZO DE HOMBRO"
  },
  {
    "codigo":184773002,
    "descripcion":"CERTIFICADOS DIVERSOS - ARANCEL IMPAGO"
  },
  {
    "codigo":250309003,
    "descripcion":"PRUEBA PARA ANTÍGENO ERITROCÍTICO EQUINO, POSITIVA"
  },
  {
    "codigo":446917003,
    "descripcion":"HERIDA POR MORDIDA DE SERPIENTE NO VENENOSA EN EXTREMIDAD INFERIOR"
  },
  {
    "codigo":414149006,
    "descripcion":"TUBERCULOSIS RESISTENTE A LA ETIONAMIDA"
  },
  {
    "codigo":248474000,
    "descripcion":"HUELE A AMONÍACO"
  },
  {
    "codigo":838298000,
    "descripcion":"CISTADENOMA MUCINOSO DE GLÁNDULA MUCOSA BRONQUIAL"
  },
  {
    "codigo":11790121000119102,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE DEDO ANULAR DERECHO"
  },
  {
    "codigo":314010006,
    "descripcion":"MACULOPATÍA EXUDATIVA DIFUSA DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":246639001,
    "descripcion":"FORMAS EN EL CAMPO VISUAL"
  },
  {
    "codigo":17263003,
    "descripcion":"EMBOLIA DE LÍQUIDO AMNIÓTICO"
  },
  {
    "codigo":1196911006,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE NEUROEPITELIO DE IRIS"
  },
  {
    "codigo":408644002,
    "descripcion":"ADENOCARCINOMA DUODENAL"
  },
  {
    "codigo":6411000179107,
    "descripcion":"EDEMA DE MÉDULA ÓSEA"
  },
  {
    "codigo":1162308006,
    "descripcion":"ESCOLIOSIS DEBIDA A INFECCIÓN Y POSTERIOR A ELLA"
  },
  {
    "codigo":277572006,
    "descripcion":"LEUCEMIA LINFOBLÁSTICA AGUDA DE CÉLULAS PRECURSORAS DE LINFOCITOS B"
  },
  {
    "codigo":111897007,
    "descripcion":"ENCEFALITIS NECROSANTE AGUDA"
  },
  {
    "codigo":110062004,
    "descripcion":"LACERACIÓN SIMPLE DEL PABELLÓN AURICULAR"
  },
  {
    "codigo":44526006,
    "descripcion":"NISTAGMO ROTATORIO"
  },
  {
    "codigo":698051004,
    "descripcion":"MICRODONCIA RELATIVA GENERALIZADA"
  },
  {
    "codigo":1156803005,
    "descripcion":"ENCEFALOPATÍA NEONATAL POR GLICINA"
  },
  {
    "codigo":403139005,
    "descripcion":"TRIPANOSOMIASIS AMERICANA QUE AFECTA LA PIEL"
  },
  {
    "codigo":237464003,
    "descripcion":"FISURA Y FÍSTULA DEL PEZÓN"
  },
  {
    "codigo":204696007,
    "descripcion":"AUSENCIA CONGÉNITA DE YEYUNO"
  },
  {
    "codigo":1351576009,
    "descripcion":"SÍNDROME DE HIPERINMUNOGLOBULINA M AUTOSÓMICO RECESIVO DEBIDO A DEFICIENCIA DE MSH6"
  },
  {
    "codigo":235629003,
    "descripcion":"TRASTORNO NO ESPECÍFICO DE MOTILIDAD ESOFÁGICA"
  },
  {
    "codigo":301165004,
    "descripcion":"PULSO RADIAL AUSENTE"
  },
  {
    "codigo":366701007,
    "descripcion":"AMPLITUD DE MOVIMIENTO ACTIVO DE OPOSICIÓN DEL PULGAR - HALLAZGO"
  },
  {
    "codigo":677981000119102,
    "descripcion":"PSEUDOAGUJERO MACULAR DE OJO DERECHO"
  },
  {
    "codigo":168258001,
    "descripcion":"POSTMORTEM - BACTERIA AISLADA"
  },
  {
    "codigo":39021009,
    "descripcion":"TRASTORNO DE REFRACCIÓN"
  },
  {
    "codigo":430402003,
    "descripcion":"ABSCESO DE VÁLVULA TRICÚSPIDE CAUSADO POR BACTERIAS"
  },
  {
    "codigo":69954004,
    "descripcion":"TROMBOFLEBITIS DE LA MAMA"
  },
  {
    "codigo":22621000119103,
    "descripcion":"TRASTORNO DE ANSIEDAD CAUSADO POR FÁRMACO"
  },
  {
    "codigo":4418008,
    "descripcion":"ERGOTISMO GANGRENOSO"
  },
  {
    "codigo":364866009,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA ARRODILLARSE"
  },
  {
    "codigo":363031002,
    "descripcion":"ANOMALÍA CONGÉNITA DE ESTRUCTURA LINFÁTICA DEL TRONCO"
  },
  {
    "codigo":299330008,
    "descripcion":"DEFORMIDAD EN VALGO DE ARTICULACIÓN DE RODILLA"
  },
  {
    "codigo":233794009,
    "descripcion":"FÍSTULA BRONCOPLEURAL TUBERCULOSA"
  },
  {
    "codigo":789015003,
    "descripcion":"RADICULOPATÍA CAUSADA POR RADIACIÓN"
  },
  {
    "codigo":231959000,
    "descripcion":"CUERPO EXTRAÑO EN LA CÁMARA ANTERIOR"
  },
  {
    "codigo":428567001,
    "descripcion":"EMBARAZO ENTRE 14 Y 20 SEMANAS"
  },
  {
    "codigo":361196000,
    "descripcion":"FIBROSIS HILIAR IDIOPÁTICA"
  },
  {
    "codigo":295660000,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE DACTINOMICINA"
  },
  {
    "codigo":2583009,
    "descripcion":"RED DE CHIARI"
  },
  {
    "codigo":819948005,
    "descripcion":"OBESIDAD CLASE III"
  },
  {
    "codigo":721644006,
    "descripcion":"NEOPLASIA NEUROENDOCRINA MALIGNA PRIMARIA DE DUODENO"
  },
  {
    "codigo":228289000,
    "descripcion":"BEBE EN LA CALLE"
  },
  {
    "codigo":785345002,
    "descripcion":"NEUMOCONIOSIS CAUSADA POR POLVO DE SISAL"
  },
  {
    "codigo":31681005,
    "descripcion":"NEURALGIA TRIGEMINAL"
  },
  {
    "codigo":293825006,
    "descripcion":"ALERGIA A LOFEPRAMINA"
  },
  {
    "codigo":423062001,
    "descripcion":"ESTENOSIS DE FÍSTULA ARTERIOVENOSA PARA DIÁLISIS"
  },
  {
    "codigo":128150002,
    "descripcion":"SOPLO CARDÍACO, CATEGORIZADO POR EL TONO"
  },
  {
    "codigo":95382004,
    "descripcion":"ABSCESO DE SITIO DE INYECCIÓN"
  },
  {
    "codigo":16052471000119103,
    "descripcion":"TENDINOSIS BILATERAL DE MÚSCULO BÍCEPS BRAQUIAL"
  },
  {
    "codigo":290155000,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR FENAZOCINA"
  },
  {
    "codigo":191851001,
    "descripcion":"FARMACODEPENDENCIA DE ALUCINÓGENOS, EN REMISIÓN"
  },
  {
    "codigo":93547002,
    "descripcion":"SARCOMA DE HODGKIN DE GANGLIOS LINFÁTICOS INTRABDOMINALES"
  },
  {
    "codigo":1142123003,
    "descripcion":"DESPOLARIZACIÓN AURICULAR PREMATURA CON CONDUCCIÓN VENTRICULAR ABERRANTE"
  },
  {
    "codigo":29811000175104,
    "descripcion":"ÚLCERA POR PRESIÓN EN CADERA IZQUIERDA, ESTADIO III"
  },
  {
    "codigo":297361000119100,
    "descripcion":"ARTRITIS ESTREPTOCÓCICA DE MANO"
  },
  {
    "codigo":124480008,
    "descripcion":"DEFICIENCIA DE NAD (P)^+^ NUCLEOSIDASA"
  },
  {
    "codigo":26176009,
    "descripcion":"FRACTURA DE SHEPHERD"
  },
  {
    "codigo":11792631000119107,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN DE DEDO ANULAR DERECHO"
  },
  {
    "codigo":778005007,
    "descripcion":"DUPLICACIÓN DE GLÁNDULA HIPÓFISIS"
  },
  {
    "codigo":286485007,
    "descripcion":"MEZCLA LOS INGREDIENTES DE UNA COMIDA"
  },
  {
    "codigo":253717008,
    "descripcion":"ARTERIA CORONARIA QUE TRANSCURRE ENTRE LA AORTA Y EL TRONCO PULMONAR"
  },
  {
    "codigo":315583002,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: SOMALÍ"
  },
  {
    "codigo":250047004,
    "descripcion":"ASTASIA TALÁMICA"
  },
  {
    "codigo":446655006,
    "descripcion":"OBSTRUCCIÓN DE VENA SISTÉMICA"
  },
  {
    "codigo":53439008,
    "descripcion":"SECRECIÓN HORMONAL ANORMAL"
  },
  {
    "codigo":280980001,
    "descripcion":"ESTENOSIS DE DERIVACIÓN ARTERIOVENOSA"
  },
  {
    "codigo":1296788004,
    "descripcion":"PAPILEDEMA DE OJO DEBIDO A PRESIÓN INTRAOCULAR POR DEBAJO DE RANGO DE REFERENCIA"
  },
  {
    "codigo":444820005,
    "descripcion":"ABSCESO DE GLÁNDULA URETRAL"
  },
  {
    "codigo":1264020006,
    "descripcion":"SEPSIS POSTERIOR A EMBARAZO ECTÓPICO"
  },
  {
    "codigo":51604006,
    "descripcion":"NEURITIS RETROBULBAR AGUDA"
  },
  {
    "codigo":770665005,
    "descripcion":"MONOSOMÍA 10Q NO DISTAL"
  },
  {
    "codigo":705129007,
    "descripcion":"TROMBOSIS DE ARTERIA CEREBRAL MEDIA"
  },
  {
    "codigo":408382000,
    "descripcion":"CONSULTA DOMICILIARIA PLANIFICADA POR PROFESIONAL SANITARIO"
  },
  {
    "codigo":1260350001,
    "descripcion":"TRASTORNO DE GLOMÉRULO CAUSADO POR PLASMODIUM MALARIAE"
  },
  {
    "codigo":80702002,
    "descripcion":"INTOXICACIÓN POR SETARIA"
  },
  {
    "codigo":703294004,
    "descripcion":"HEMANGIOMA CONGÉNITO RÁPIDAMENTE INVOLUTIVO"
  },
  {
    "codigo":736062005,
    "descripcion":"QUEMADURA QUE INVOLUCRA 10-19 POR CIENTO DE LA SUPERFICIE CORPORAL, CON 10-14 POR CIENTO DE LA SUPERFICIE CORPORAL CON QUEMADURA DE ESPESOR COMPLETO"
  },
  {
    "codigo":11821611000119103,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA ANTERIOR DE ARTICULACIÓN ESTERNOCLAVICULAR IZQUIERDA"
  },
  {
    "codigo":680491000119103,
    "descripcion":"SÍNDROME ENDOTELIAL IRIDOCORNEAL BILATERAL"
  },
  {
    "codigo":1090091000119104,
    "descripcion":"EDENTULISMO PARCIAL CLASE IV DEBIDO A CARIES"
  },
  {
    "codigo":46511000087100,
    "descripcion":"FRACTURA DE FALANGE DE DEDO GORDO DE PIE DERECHO"
  },
  {
    "codigo":275475005,
    "descripcion":"HERIDA PERFORANTE DE PÁRPADO"
  },
  {
    "codigo":43951000087102,
    "descripcion":"CORTE EN MUSLO DERECHO"
  },
  {
    "codigo":78867009,
    "descripcion":"TIEMPO DE VIDA DE LOS ERITROCITOS DISMINUIDO"
  },
  {
    "codigo":41391000087109,
    "descripcion":"ESGUINCE DE LIGAMENTO RADIAL COLATERAL DE ARTICULACIÓN DE CODO IZQUIERDO"
  },
  {
    "codigo":240872006,
    "descripcion":"TERNIDENIASIS"
  },
  {
    "codigo":109800008,
    "descripcion":"TRASTORNO DE LA ÚVULA PALATINA"
  },
  {
    "codigo":42429001,
    "descripcion":"HEMORRAGIA CEREBROMENÍNGEA"
  },
  {
    "codigo":1287613001,
    "descripcion":"CRISIS EPILÉPTICA DE INICIO FOCAL NEONATAL"
  },
  {
    "codigo":206269002,
    "descripcion":"RECIÉN NACIDO VIVO CON MECONIO EN LÍQUIDO AMNIÓTICO DURANTE EL TRABAJO DE PARTO"
  },
  {
    "codigo":763325000,
    "descripcion":"RESISTENCIA A LA INSULINA"
  },
  {
    "codigo":44264009,
    "descripcion":"LUXACIÓN TRAUMÁTICA DE ARTICULACIÓN DE VÉRTEBRA CERVICAL"
  },
  {
    "codigo":271805006,
    "descripcion":"ANESTESIA CUTÁNEA"
  },
  {
    "codigo":1254845006,
    "descripcion":"NEOPLASIA MESENQUIMATOSA PRIMARIA MALIGNA DE VESÍCULA BILIAR"
  },
  {
    "codigo":239037001,
    "descripcion":"SÍNDROME DE DISPLASIA UNGUEAL, ANQUILOBLÉFARON Y PELO ENSORTIJADO"
  },
  {
    "codigo":370109009,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA CON COMPROMISO TUMORAL"
  },
  {
    "codigo":7826003,
    "descripcion":"ENFERMEDAD DE MIKULICZ"
  },
  {
    "codigo":366439003,
    "descripcion":"AMPLITUD DEL MOVIMIENTO ACTIVO DE FLEXIÓN LATERAL HACIA LA IZQUIERDA DE LA COLUMNA LUMBAR - HALLAZGO"
  },
  {
    "codigo":399207003,
    "descripcion":"ESOTROPÍA SECUNDARIA"
  },
  {
    "codigo":169831006,
    "descripcion":"TRILLIZOS - TODOS NACIDOS VIVOS"
  },
  {
    "codigo":202599007,
    "descripcion":"CHASQUIDO DE ARTICULACIÓN ACROMIOCLAVICULAR"
  },
  {
    "codigo":725052002,
    "descripcion":"FIBROSIS QUÍSTICA FETAL"
  },
  {
    "codigo":102460003,
    "descripcion":"TOLERANCIA DISMINUIDA"
  },
  {
    "codigo":299068004,
    "descripcion":"SIN AMPLITUD ACTIVA DE FLEXIÓN DE DEDO DE LA MANO"
  },
  {
    "codigo":36924003,
    "descripcion":"FRACTURA NO EXPUESTA DE HUESO METATARSIANO"
  },
  {
    "codigo":167996009,
    "descripcion":"ESTUDIO MICROSCÓPICO DEL ESPUTO - NO SE DETECTARON ANOMALÍAS"
  },
  {
    "codigo":35089004,
    "descripcion":"INFECCIÓN UROGENITAL CAUSADA POR TRICHOMONAS VAGINALIS"
  },
  {
    "codigo":395537004,
    "descripcion":"COMPROMISO TUMORAL DE MARGEN DE RESECCIÓN QUIRÚRGICA: NO EVALUABLE"
  },
  {
    "codigo":297233004,
    "descripcion":"ACIDURIA 3-METILGLUTACÓNICA TIPO 4"
  },
  {
    "codigo":33254005,
    "descripcion":"PÉRDIDA DE LA MEMORIA A CORTO PLAZO NO COMPENSADA"
  },
  {
    "codigo":486006,
    "descripcion":"INSUFICIENCIA VASCULAR AGUDA"
  },
  {
    "codigo":66022007,
    "descripcion":"AMUSIA MOTORA VOCAL"
  },
  {
    "codigo":721382008,
    "descripcion":"SÍNDROME DEL CORDÓN ANTERIOR DE MÉDULA ESPINAL AL NIVEL DEL SEGUNDO SEGMENTO CERVICAL"
  },
  {
    "codigo":295398009,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE TRISILICATO DE MAGNESIO"
  },
  {
    "codigo":426470009,
    "descripcion":"LIPOMA DE DE CONO MEDULAR"
  },
  {
    "codigo":129723006,
    "descripcion":"SIN CAMBIOS SIGNIFICATIVOS CON RESPECTO A LA MAMOGRAFÍA ANTERIOR"
  },
  {
    "codigo":293563008,
    "descripcion":"EFECTO ADVERSO DE ALCOHOL NICOTÍNICO"
  },
  {
    "codigo":226192002,
    "descripcion":"DIETA SIN CACAO"
  },
  {
    "codigo":95120002,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA SUPRAGLOTIS"
  },
  {
    "codigo":783248004,
    "descripcion":"SÍNDROME DE HIPERINMUNOGLOBULINEMIA M CON SUSCEPTIBILIDAD A INFECCIONES OPORTUNISTAS"
  },
  {
    "codigo":16028511000119106,
    "descripcion":"EXOSTOSIS BILATERAL DE CÚBITOS"
  },
  {
    "codigo":160656007,
    "descripcion":"DISPUESTO A SER DONANTE DE RIÑÓN"
  },
  {
    "codigo":1141861001,
    "descripcion":"MIALGIA INDUCIDA POR EJERCICIO"
  },
  {
    "codigo":93285003,
    "descripcion":"HIPOPLASIA CONGÉNITA DE HUESO PREESFENOIDAL"
  },
  {
    "codigo":289893003,
    "descripcion":"HALLAZGO RELACIONADO CON LA DURACIÓN DEL PERÍODO MENSTRUAL"
  },
  {
    "codigo":1303866001,
    "descripcion":"SÍNDROME DE RETRASO DEL DESARROLLO-DISCAPACIDAD INTELECTUAL-OBESIDAD ASOCIADO AL GEN MYT1L"
  },
  {
    "codigo":15920121000119103,
    "descripcion":"REACCIÓN ALÉRGICA CAUSADA POR VACUNA"
  },
  {
    "codigo":1092601000119103,
    "descripcion":"SEPSIS CAUSADA POR GONOCOCO"
  },
  {
    "codigo":91450006,
    "descripcion":"INTOXICACIÓN POR METALDEHÍDO"
  },
  {
    "codigo":24079001,
    "descripcion":"DERMATITIS ATÓPICA"
  },
  {
    "codigo":253455004,
    "descripcion":"ATRESIA DE VÁLVULA AURICULOVENTRICULAR DERECHA"
  },
  {
    "codigo":775908005,
    "descripcion":"DEFECTO COMBINADO DE LA FOSFORILACIÓN OXIDATIVA TIPO 17"
  },
  {
    "codigo":446393005,
    "descripcion":"LACERACIÓN SUPERFICIAL DE MUÑECA"
  },
  {
    "codigo":249785006,
    "descripcion":"TORSIÓN TIBIAL"
  },
  {
    "codigo":1003449005,
    "descripcion":"MICRODELECIÓN PATERNA 14Q32.2"
  },
  {
    "codigo":1296526000,
    "descripcion":"DEGENERACIÓN MACULAR DISCIFORME"
  },
  {
    "codigo":184249009,
    "descripcion":"REGISTRO DE MOVIMIENTOS FETALES - EXTRAVIADO"
  },
  {
    "codigo":772238002,
    "descripcion":"INCAPAZ DE MANTENER EL EQUILIBRIO AL PARARSE CON AMBOS PIES JUNTOS"
  },
  {
    "codigo":444558002,
    "descripcion":"NEFRONOPTISIS INFANTIL"
  },
  {
    "codigo":282553008,
    "descripcion":"CAPAZ DE DOBLAR ESQUINAS AL CORRER"
  },
  {
    "codigo":84110003,
    "descripcion":"INFECCIÓN CAUSADA POR EURYTREMA PANCREATICUM"
  },
  {
    "codigo":1263758006,
    "descripcion":"HEMATOMA SUBUNGUEAL DE DEDO MEDIO"
  },
  {
    "codigo":247950007,
    "descripcion":"HALLAZGO RELACIONADO CON LA CONDUCTA DURANTE EL SUEÑO"
  },
  {
    "codigo":82275008,
    "descripcion":"GRANULOMATOSIS EOSINOFÍLICA CON POLIANGEÍTIS"
  },
  {
    "codigo":213347008,
    "descripcion":"FRACTURAS QUE COMPROMETEN LA CABEZA CON EL CUELLO"
  },
  {
    "codigo":703032005,
    "descripcion":"ENTEROCOCCUS CASSELIFLAVUS O ENTEROCOCCUS GALLINARUM"
  },
  {
    "codigo":735800008,
    "descripcion":"LACERACIÓN DE BRAZO SIN CUERPO EXTRAÑO"
  },
  {
    "codigo":439053001,
    "descripcion":"CATÉTER URINARIO IN SITU"
  },
  {
    "codigo":328851000119107,
    "descripcion":"CHOQUE CARDIOGÉNICO DESPUÉS DE PROCEDIMIENTO"
  },
  {
    "codigo":302381000119101,
    "descripcion":"HIPEROSTOSIS ESQUELÉTICA IDIOPÁTICA DIFUSA DE COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":1260088008,
    "descripcion":"CARCINOMA DUCTAL INFILTRANTE DE OROFARINGE"
  },
  {
    "codigo":2311000124107,
    "descripcion":"SEGUNDO MOLAR SUPERIOR IZQUIERDO DECIDUO SUPERNUMERARIO"
  },
  {
    "codigo":209677006,
    "descripcion":"SECCIÓN EXPUESTA DE LIGAMENTO DE PULGAR, ARTICULACIÓN INTERFALÁNGICA, LIGAMENTO LATERAL RADIAL"
  },
  {
    "codigo":111373008,
    "descripcion":"PERICOLANGITIS"
  },
  {
    "codigo":109538002,
    "descripcion":"EXFOLIACIÓN DENTAL GENERALIZADA RETRASADA NO RELACIONADA CON UNA ENFERMEDAD SISTÉMICA"
  },
  {
    "codigo":271543000,
    "descripcion":"FRACTURA DE PRÓTESIS"
  },
  {
    "codigo":763063001,
    "descripcion":"CARCINOMA ADENOIDE BASAL DE CUELLO UTERINO"
  },
  {
    "codigo":238775002,
    "descripcion":"LIVEDO RETICULARIS IDIOPÁTICA CON ULCERACIONES DE VERANO"
  },
  {
    "codigo":1156279002,
    "descripcion":"CUMPLE CON ESQUEMA DE EJERCICIO FÍSICO"
  },
  {
    "codigo":304311008,
    "descripcion":"AMPLITUD DE MOVIMIENTO DEL PULGAR NORMAL"
  },
  {
    "codigo":402615009,
    "descripcion":"HIPERMELANOSIS POR TRASTORNO DEL SISTEMA NERVIOSO"
  },
  {
    "codigo":1252748000,
    "descripcion":"SUBLUXACIÓN DE ARTICULACIÓN CARPOMETACARPIANA"
  },
  {
    "codigo":1187212004,
    "descripcion":"SÍNDROME DE HIPOTONÍA SEVERA, RETRASO DEL DESARROLLO PSICOMOTOR, ESTRABISMO Y DEFECTO CARDÍACO SEPTAL"
  },
  {
    "codigo":7564008,
    "descripcion":"DIETA CARDÍACA LÍQUIDA"
  },
  {
    "codigo":366177003,
    "descripcion":"PATRÓN DE LA CONDUCCIÓN AURICULOVENTRICULAR - HALLAZGO"
  },
  {
    "codigo":202337006,
    "descripcion":"HOMBRO EN RESORTE"
  },
  {
    "codigo":300641007,
    "descripcion":"INCAPAZ DE MANEJAR UNA MOTOCICLETA"
  },
  {
    "codigo":11826631000119102,
    "descripcion":"DISTENSIÓN DE TENDÓN DE LA MANO IZQUIERDA"
  },
  {
    "codigo":890465009,
    "descripcion":"INGESTA EXCESIVA DE CALCIO"
  },
  {
    "codigo":169569009,
    "descripcion":"ES CUESTIONABLE SI EL EMBARAZO FUE PLANEADO"
  },
  {
    "codigo":69430001,
    "descripcion":"ABSCESO DE LA VULVA"
  },
  {
    "codigo":36662003,
    "descripcion":"DERRAME DE ARTICULACIÓN DE SITIOS MÚLTIPLES"
  },
  {
    "codigo":724790005,
    "descripcion":"LACERACIÓN DE FASCIA DEL CUELLO"
  },
  {
    "codigo":298806006,
    "descripcion":"AMPLITUD DE ABDUCCIÓN PASIVA DE HOMBRO DISMINUIDA"
  },
  {
    "codigo":1148939003,
    "descripcion":"HIDRONEFROSIS CONGÉNITA DEBIDA A OBSTRUCCIÓN URETERAL"
  },
  {
    "codigo":722955006,
    "descripcion":"TRASTORNO LINFOPROLIFERATIVO CRÓNICO DE CÉLULAS ASESINAS NATURALES"
  },
  {
    "codigo":788491008,
    "descripcion":"HIPERINSULINEMIA DEBIDA A INSULINOMA MALIGNO"
  },
  {
    "codigo":296971009,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE POTASIO"
  },
  {
    "codigo":295136003,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE ASPIRINA"
  },
  {
    "codigo":1343712004,
    "descripcion":"HERNIA OBTURATRIZ RECURRENTE"
  },
  {
    "codigo":194997002,
    "descripcion":"ESTENOSIS PULMONAR, NO REUMÁTICA"
  },
  {
    "codigo":29322000,
    "descripcion":"INSUFICIENCIA CEREBROVASCULAR AGUDA"
  },
  {
    "codigo":293301009,
    "descripcion":"REACCIÓN ADVERSA A LA CALCITONINA"
  },
  {
    "codigo":225930002,
    "descripcion":"CON MAYOR RIESGO DE ASFIXIA"
  },
  {
    "codigo":1340042007,
    "descripcion":"INTERVILLOSITIS CRÓNICA DE ETIOLOGÍA DESCONOCIDA"
  },
  {
    "codigo":93023000,
    "descripcion":"ANOMALÍA CONGÉNITA DE VÉRTEBRA SACRA"
  },
  {
    "codigo":94858007,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA CURVATURA MAYOR DEL ESTÓMAGO"
  },
  {
    "codigo":1208970009,
    "descripcion":"CRISIS EPILÉPTICA CLÓNICA DE INICIO GENERALIZADO"
  },
  {
    "codigo":289631000,
    "descripcion":"FONDO UTERINO A NIVEL DEL APÉNDICE XIFOIDES DEL ESTERNÓN"
  },
  {
    "codigo":1010527006,
    "descripcion":"ESCLEROSIS DE EPÍFISIS DE FALANGE DISTAL DE QUINTO DEDO DE PIE CON RADIOPACIDAD AUMENTADA"
  },
  {
    "codigo":255028004,
    "descripcion":"CARCINOMA TIROIDEO FOLICULAR"
  },
  {
    "codigo":285961001,
    "descripcion":"RETIRA EL TAPÓN DEL DESAGÜE"
  },
  {
    "codigo":253193002,
    "descripcion":"MALFORMACIÓN VASCULAR DEL SISTEMA NERVIOSO"
  },
  {
    "codigo":56585003,
    "descripcion":"PARAQUERATOSIS DE LA PIEL"
  },
  {
    "codigo":23817003,
    "descripcion":"SÍNDROME DE LEVY - HOLLISTER"
  },
  {
    "codigo":449801006,
    "descripcion":"NEOPLASIA BENIGNA DE CÚPULA VESICAL"
  },
  {
    "codigo":284126000,
    "descripcion":"DIFICULTAD PARA CONTROLAR LA POSICIÓN DEL TRONCO"
  },
  {
    "codigo":251358005,
    "descripcion":"CAMBIO AUDITIVO"
  },
  {
    "codigo":710110008,
    "descripcion":"DOLOR FANTASMA"
  },
  {
    "codigo":185822009,
    "descripcion":"CONTROL DE SALUD MASCULINO CANCELADO"
  },
  {
    "codigo":776005371000119104,
    "descripcion":"ADAMANTINOMA MALIGNO PRIMARIO DE HUESO LARGO DE MIEMBRO INFERIOR IZQUIERDO"
  },
  {
    "codigo":15650121000119100,
    "descripcion":"GANGRENA DE EXTREMIDAD SUPERIOR DERECHA DEBIDA A ATEROSCLEROSIS"
  },
  {
    "codigo":216755005,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR AGENTES ALCALINOS CÁUSTICOS"
  },
  {
    "codigo":15742281000119102,
    "descripcion":"SÍNDROME DE CONDUCTO DEL TARSO DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":323401000119101,
    "descripcion":"DEFORMIDAD EN VALGO ADQUIRIDA DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":21321000119104,
    "descripcion":"FÍSTULA PANCREÁTICA, ACINAR"
  },
  {
    "codigo":15724361000119105,
    "descripcion":"ENTESOPATÍA DE PIE IZQUIERDO"
  },
  {
    "codigo":16098121000119104,
    "descripcion":"ARTROFIBROSIS DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":290121000119107,
    "descripcion":"LESIÓN DE NERVIO CIÁTICO POPLÍTEO EXTERNO IZQUIERDO"
  },
  {
    "codigo":336201000119108,
    "descripcion":"PTERIGIÓN CENTRAL DE OJO DERECHO"
  },
  {
    "codigo":674121000119107,
    "descripcion":"ATAXIA DEBIDA A ACCIDENTE CEREBROVASCULAR HEMORRÁGICO Y POSTERIOR A ÉL"
  },
  {
    "codigo":1088841000119103,
    "descripcion":"CONDRITIS DEL OÍDO EXTERNO IZQUIERDO"
  },
  {
    "codigo":679241000119105,
    "descripcion":"DEGENERACIÓN MARGINAL PELÚCIDA DE CÓRNEA DE OJO DERECHO"
  },
  {
    "codigo":15629641000119107,
    "descripcion":"INSUFICIENCIA CARDÍACA SISTÓLICA EN ESTADIO B DEBIDA A MIOCARDIOPATÍA ISQUÉMICA"
  },
  {
    "codigo":144201000119107,
    "descripcion":"AUMENTO DE TRANSLUCIDEZ DE LA NUCA EN LA ECOGRAFÍA FETAL"
  },
  {
    "codigo":870280009,
    "descripcion":"TRASTORNO GENERALIZADO DEL DESARROLLO CON ALTERACIÓN SEVERA DEL LENGUAJE FUNCIONAL CON PÉRDIDA DE HABILIDADES ADQUIRIDAS PREVIAMENTE"
  },
  {
    "codigo":213085001,
    "descripcion":"FRACTURA DE ALOINJERTO ÓSEO"
  },
  {
    "codigo":15716681000119107,
    "descripcion":"ENOSTOSIS DE CÚBITO DERECHO"
  },
  {
    "codigo":1263496006,
    "descripcion":"MIELITIS DEBIDA A SÍNDROME ANTIFOSFOLÍPIDO"
  },
  {
    "codigo":1163357003,
    "descripcion":"NEOPLASIA MALIGNA DE CAVIDAD ORAL, LABIO Y GLÁNDULA SALIVAL"
  },
  {
    "codigo":409693000,
    "descripcion":"ANTICUERPO ANTI-DENGUE INMUNOGLOBULINA M DETECTADO"
  },
  {
    "codigo":1259826000,
    "descripcion":"HEMANGIOENDOTELIOMA EPITELIOIDE PRIMARIO DE HÍGADO"
  },
  {
    "codigo":473394001,
    "descripcion":"OCLUSIÓN CONGÉNITA DE VENA ILÍACA"
  },
  {
    "codigo":735538002,
    "descripcion":"ACIDOSIS LÁCTICA DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":211250002,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE ANTEBRAZO SIN INFECCIÓN"
  },
  {
    "codigo":278621009,
    "descripcion":"OCLUSIÓN DE LA PRÓTESIS DENTAL INCORRECTA"
  },
  {
    "codigo":702770006,
    "descripcion":"CONDUCTA SEXUAL DESCONOCIDA"
  },
  {
    "codigo":209415002,
    "descripcion":"DISTENSIÓN DE TENDÓN SUBESCAPULAR"
  },
  {
    "codigo":830172001,
    "descripcion":"ALERGIA A METAMIZOL"
  },
  {
    "codigo":404188001,
    "descripcion":"SECUELA DE MENINGITIS"
  },
  {
    "codigo":274951009,
    "descripcion":"ESTALLIDOS DE CÓLERA"
  },
  {
    "codigo":897543009,
    "descripcion":"TRISOMÍA DISTAL 1P"
  },
  {
    "codigo":11829141000119106,
    "descripcion":"AMPOLLA TRAUMÁTICA DE RODILLA IZQUIERDA"
  },
  {
    "codigo":240348006,
    "descripcion":"INTOXICACIÓN ALIMENTARIA POR METALES PESADOS"
  },
  {
    "codigo":305884008,
    "descripcion":"VISTO POR EL SERVICIO DE CIRUGÍA"
  },
  {
    "codigo":74673001,
    "descripcion":"CÓDIGO DE PROCEDIMIENTO NO APLICABLE"
  },
  {
    "codigo":1156017002,
    "descripcion":"TROMBOSIS DE ARTERIA CEREBRAL POSTERIOR DERECHA"
  },
  {
    "codigo":41905003,
    "descripcion":"PROBLEMA EN LA ELECCIÓN DE LA PROFESIÓN"
  },
  {
    "codigo":238513004,
    "descripcion":"CAMBIO EN LA PIEL PRODUCIDO POR LUZ ULTRAVIOLETA"
  },
  {
    "codigo":109276009,
    "descripcion":"MELANOMA IN SITU DE CUERO CABELLUDO"
  },
  {
    "codigo":402353007,
    "descripcion":"DISTROFIA UNGUEAL POR LIQUEN NITIDUS"
  },
  {
    "codigo":236678004,
    "descripcion":"FÍSTULA PROSTÁTICA HACIA LA PIEL"
  },
  {
    "codigo":40070004,
    "descripcion":"INFECCIÓN CAUSADA POR MOLLUSCUM CONTAGIOSUM"
  },
  {
    "codigo":105606008,
    "descripcion":"LESIÓN TRAUMÁTICA DEL SISTEMA MUSCULOESQUELÉTICO"
  },
  {
    "codigo":726363000,
    "descripcion":"TETRAPLOIDIA"
  },
  {
    "codigo":71003000,
    "descripcion":"ENANISMO ATELEIÓTICO"
  },
  {
    "codigo":5467003,
    "descripcion":"RITMO RESPIRATORIO NORMAL"
  },
  {
    "codigo":365915006,
    "descripcion":"MEMORIA PARA CONTAR AL REVÉS - HALLAZGO"
  },
  {
    "codigo":300379007,
    "descripcion":"HALLAZGO RELACIONADO CON LA VELOCIDAD DE LA DEFECACIÓN"
  },
  {
    "codigo":298544005,
    "descripcion":"AMPLITUD DE FLEXIÓN LATERAL ACTIVA HACIA LA IZQUIERDA DE LA COLUMNA VERTEBRAL DORSAL, DISMINUIDA"
  },
  {
    "codigo":724528009,
    "descripcion":"ÚLCERA DUODENAL CAUSADA POR HELICOBACTER PYLORI"
  },
  {
    "codigo":296709001,
    "descripcion":"SOBREDOSIS DE CEFOTAXIMA"
  },
  {
    "codigo":427781003,
    "descripcion":"CONTRACTURA DE MÚSCULOS GEMELOS POR LESIÓN TRAUMÁTICA"
  },
  {
    "codigo":165637004,
    "descripcion":"CINÉTICA DEL HIERRO: NORMAL"
  },
  {
    "codigo":294874000,
    "descripcion":"ALERGIA A DALTEPARINA"
  },
  {
    "codigo":720858001,
    "descripcion":"SÍNDROME DE EHLERS-DANLOS TIPO CARDÍACO VALVULAR"
  },
  {
    "codigo":65498003,
    "descripcion":"ANEURISMA DE LA ARTERIA MESENTÉRICA SUPERIOR"
  },
  {
    "codigo":32730007,
    "descripcion":"DESDOBLAMIENTO AMPLIO DEL PRIMER RUIDO CARDÍACO, R>1<"
  },
  {
    "codigo":131034007,
    "descripcion":"NIVEL DE EPINEFRINA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":260271001,
    "descripcion":"VISIÓN A DISTANCIA 6\/5"
  },
  {
    "codigo":360410009,
    "descripcion":"DEFICIENCIA DE TIROSINA AMINOTRANSFERASA HEPÁTICA"
  },
  {
    "codigo":194735004,
    "descripcion":"INSUFICIENCIA MITRAL Y ESTENOSIS AÓRTICA"
  },
  {
    "codigo":293039005,
    "descripcion":"REACCIÓN ADVERSA A LA SULFADIMIDINA"
  },
  {
    "codigo":1145007008,
    "descripcion":"DEMUESTRA CONOCIMIENTO SOBRE ESQUEMA TERAPÉUTICO"
  },
  {
    "codigo":782724001,
    "descripcion":"SÍNDROME DE DISFUNCIÓN MULTISISTÉMICA DEL MÚSCULO LISO"
  },
  {
    "codigo":719023008,
    "descripcion":"DERIVADO POR CENTRO DE CUIDADOS"
  },
  {
    "codigo":16527561000119105,
    "descripcion":"CARCINOMA NO MICROCÍTICO PRIMARIO DE LÓBULO INFERIOR DE PULMÓN DERECHO"
  },
  {
    "codigo":94596004,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE PARTES BLANDAS DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":127364007,
    "descripcion":"PRIMIGESTA"
  },
  {
    "codigo":61828008,
    "descripcion":"LISOGENIA"
  },
  {
    "codigo":92761000,
    "descripcion":"CARCINOMA IN SITU DE LA SUPRAGLOTIS"
  },
  {
    "codigo":192900009,
    "descripcion":"MIELOPATÍA POR HEMATOMIELIA"
  },
  {
    "codigo":289369004,
    "descripcion":"CABEZA FETAL 5\/5 POR ENCIMA DEL BORDE PÉLVICO"
  },
  {
    "codigo":418606003,
    "descripcion":"ALERGIA A ACEITE DE ALMENDRAS"
  },
  {
    "codigo":254766004,
    "descripcion":"GANGLIONEUROMA CUTÁNEO"
  },
  {
    "codigo":90926009,
    "descripcion":"ASPECTO DE LA SUPERFICIE DE UNA COLONIA BACTERIANA, ATERCIOPELADA"
  },
  {
    "codigo":16419171000119104,
    "descripcion":"SÍNDROME DE ESTRÉS DE TIBIA MEDIAL DE PIERNA IZQUIERDA"
  },
  {
    "codigo":89091004,
    "descripcion":"EDEMA DE PÁRPADO"
  },
  {
    "codigo":414936000,
    "descripcion":"CONDENA CONDICIONAL A PRESTAR SERVICIOS COMUNITARIOS"
  },
  {
    "codigo":449539009,
    "descripcion":"DEFECTO DEL TABIQUE AURICULOVENTRICULAR CON INSUFICIENCIA DE VÁLVULA AURICULOVENTRICULAR A TRAVÉS DE COMISURA MURAL INFERIOR DE VALVA EN PUENTE INFERIOR DERECHA"
  },
  {
    "codigo":709848002,
    "descripcion":"UBICACIÓN Y EXTENSIÓN DE REGIÓN EDÉNTULA DE LA CAVIDAD BUCAL MODERADAMENTE COMPROMETIDA"
  },
  {
    "codigo":445869000,
    "descripcion":"AXONOTMESIS DE NERVIO PERIFÉRICO"
  },
  {
    "codigo":708013001,
    "descripcion":"XANTOMA VERRUCIFORME DE MUCOSA BUCAL"
  },
  {
    "codigo":183725001,
    "descripcion":"CONSULTA DOMICILIARIA DE OFTALMOLOGÍA SOLICITADA"
  },
  {
    "codigo":773549000,
    "descripcion":"DEFICIENCIA DE RIBOFLAVINA MATERNA"
  },
  {
    "codigo":249261002,
    "descripcion":"EL PREPUCIO SE RETRAE"
  },
  {
    "codigo":19885005,
    "descripcion":"EXOFTALMÍA HIPERTIROIDEA"
  },
  {
    "codigo":118189007,
    "descripcion":"HALLAZGO PRENATAL"
  },
  {
    "codigo":18050000,
    "descripcion":"PRESIÓN ARTERIAL SISTÓLICA AUMENTADA"
  },
  {
    "codigo":83586000,
    "descripcion":"SÍNDROME DE EHLERS-DANLOS, VARIANTE CON ALTERACIÓN DE LA FIBRONECTINA"
  },
  {
    "codigo":413101007,
    "descripcion":"EPILEPSIA INDUCIDA POR ESTRÉS"
  },
  {
    "codigo":247426003,
    "descripcion":"PIEL NO SALUDABLE"
  },
  {
    "codigo":1197698005,
    "descripcion":"VÁRICES ESOFÁGICAS SANGRANTES POR HEPATOPATÍA ALCOHÓLICA"
  },
  {
    "codigo":312962006,
    "descripcion":"RETINOPATÍA POR TIORIDAZINA"
  },
  {
    "codigo":50818007,
    "descripcion":"EYACULACIÓN DOLOROSA"
  },
  {
    "codigo":704343001,
    "descripcion":"ACTITUD CONFLICTIVA HACIA EL RÉGIMEN NUTRICIONAL"
  },
  {
    "codigo":1163095004,
    "descripcion":"TIROIDITIS BACTERIANA AGUDA"
  },
  {
    "codigo":48983004,
    "descripcion":"ANEMIA SIDEROBLÁSTICA LIGADA AL CROMOSOMA X"
  },
  {
    "codigo":1259564005,
    "descripcion":"MELANOMA MALIGNO DESMOPLÁSICO PRIMARIO"
  },
  {
    "codigo":14380007,
    "descripcion":"CUERPO EXTRAÑO EN LA BOCA"
  },
  {
    "codigo":407596008,
    "descripcion":"ECOCARDIOGRAMA QUE MUESTRA DISFUNCIÓN SISTÓLICA DEL VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":209153001,
    "descripcion":"SUBLUXACIÓN EXPUESTA DE LA ARTICULACIÓN ATLOOCCIPITAL"
  },
  {
    "codigo":471297002,
    "descripcion":"ORIGEN ANÓMALO DE ARTERIA CORONARIA ÚNICA EN SENO AÓRTICO NO ENFRENTADO"
  },
  {
    "codigo":372993005,
    "descripcion":"INFECCIÓN CAUSADA POR ASPERGILLUS PENICILLOIDES"
  },
  {
    "codigo":241921006,
    "descripcion":"EFECTO TÓXICO CAUSADO POR RETARDADOR DE FUEGO"
  },
  {
    "codigo":78081007,
    "descripcion":"INFECCIÓN CAUSADA POR CUNNINGHAMELLA"
  },
  {
    "codigo":1290497008,
    "descripcion":"TENDINOSIS DE TOBILLO"
  },
  {
    "codigo":43478001,
    "descripcion":"DOLOR ABDOMINAL A LA PALPACIÓN"
  },
  {
    "codigo":371158002,
    "descripcion":"TRASTORNO DE ARTERIA BASILAR"
  },
  {
    "codigo":405761007,
    "descripcion":"LESIÓN TRAUMÁTICA COMPLETA DE LA MÉDULA ESPINAL CERVICAL, SIN LESIÓN VERTEBRAL, C5-7"
  },
  {
    "codigo":1255894002,
    "descripcion":"GRANULOMA DE HODGKIN DE GANGLIOS LINFÁTICOS DE MIEMBRO INFERIOR"
  },
  {
    "codigo":403926005,
    "descripcion":"MELANOMA MALIGNO DE LA CAVIDAD ORAL"
  },
  {
    "codigo":305622007,
    "descripcion":"ATENDIDO POR CONSEJERO ESPECIALIZADO EN DUELO"
  },
  {
    "codigo":74411000,
    "descripcion":"SECRECIÓN ECTÓPICA DE HORMONA ANTIDIURÉTICA"
  },
  {
    "codigo":698838008,
    "descripcion":"HIPERTENSIÓN INTRACRANEANA BENIGNA DEBIDA A FÁRMACO"
  },
  {
    "codigo":240086009,
    "descripcion":"MIOPATÍA CON INCLUSIONES CITOPLÁSMICAS"
  },
  {
    "codigo":8875000,
    "descripcion":"PROTEINURIA COLICUATIVA"
  },
  {
    "codigo":762539005,
    "descripcion":"ENDOCARDITIS DE NEOVÁLVULA AÓRTICA"
  },
  {
    "codigo":205483007,
    "descripcion":"HIPOCONDROGÉNESIS"
  },
  {
    "codigo":16038551000119105,
    "descripcion":"TRASTORNO DE FÉMURES BILATERALES POSTERIOR A POLIOMIELITIS"
  },
  {
    "codigo":860843009,
    "descripcion":"GRANULOMA DE ESPACIO EPIDURAL ESPINAL CAUSADO POR MYCOBACTERIUM"
  },
  {
    "codigo":236416004,
    "descripcion":"GLOMERULONEFRITIS MEMBRANOSA - ESTADIO IV"
  },
  {
    "codigo":1186688007,
    "descripcion":"AMBIENTE FAMILIAR"
  },
  {
    "codigo":301952009,
    "descripcion":"IRIS AZUL"
  },
  {
    "codigo":10631831000119107,
    "descripcion":"ONIQUIA DE PULGAR"
  },
  {
    "codigo":234581004,
    "descripcion":"DEFECTO DE LA ADHESIÓN FAGOCITARIA"
  },
  {
    "codigo":365653004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CONCENTRACIÓN DE PROTEÍNAS, TIRA REACTIVA"
  },
  {
    "codigo":300117008,
    "descripcion":"HALLAZGO RELACIONADO CON MEDICIONES DEL PABELLÓN AURICULAR"
  },
  {
    "codigo":431189009,
    "descripcion":"ABSCESO DE VÁLVULA TRICÚSPIDE"
  },
  {
    "codigo":726101009,
    "descripcion":"ENFERMEDAD DE CROHN EXTRAINTESTINAL"
  },
  {
    "codigo":298282001,
    "descripcion":"CUADRIPARESIA ESPÁSTICA"
  },
  {
    "codigo":10877591000119109,
    "descripcion":"HERIDA ABIERTA DE RODILLA DERECHA"
  },
  {
    "codigo":429354005,
    "descripcion":"ÚLCERA CRÓNICA DE MUSLO"
  },
  {
    "codigo":15684401000119103,
    "descripcion":"PERIOSTITIS BILATERAL DE PIES"
  },
  {
    "codigo":36138009,
    "descripcion":"INMUNODEFICIENCIA CONGÉNITA"
  },
  {
    "codigo":198143006,
    "descripcion":"PERISALPINGITIS CRÓNICA"
  },
  {
    "codigo":296447007,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE PREPARADOS BRONCODILATADORES"
  },
  {
    "codigo":722431007,
    "descripcion":"SÍNDROME DE ÚTERO DOBLE, HEMIVAGINA Y AGENESIA RENAL"
  },
  {
    "codigo":294612006,
    "descripcion":"ALERGIA A RIFABUTINA"
  },
  {
    "codigo":338891000119100,
    "descripcion":"OCLUSIÓN PARCIAL DE ARTERIA DE LA RETINA IZQUIERDA"
  },
  {
    "codigo":292777002,
    "descripcion":"REACCIÓN ADVERSA AL ACEITE DE CASTOR"
  },
  {
    "codigo":423849004,
    "descripcion":"SÍNDROME DE FRICCIÓN DE LA BANDELETA ILIOTIBIAL"
  },
  {
    "codigo":128937004,
    "descripcion":"INFECCIÓN DE LA PIEL, DE ORIGEN VIRAL"
  },
  {
    "codigo":718761007,
    "descripcion":"MICROFTALMÍA SINDRÓMICA DEBIDA A MUTACIÓN DEL GEN ORTHODENTICLE HOMEOBOX 2"
  },
  {
    "codigo":391081008,
    "descripcion":"RESULTADO DE ECOGRAFÍA CUANTITATIVA DE TALÓN: OSTEOPOROSIS"
  },
  {
    "codigo":28798000,
    "descripcion":"SUSTANCIA NO ASIGNADA A UNA CATEGORÍA CIENTÍFICA"
  },
  {
    "codigo":782462002,
    "descripcion":"HIPERHIDROSIS FOCAL PRIMARIA DE LA PLANTA DEL PIE IZQUIERDO"
  },
  {
    "codigo":422014003,
    "descripcion":"TRASTORNO DEBIDO A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":1306750003,
    "descripcion":"GLAUCOMA DE CÉLULAS FANTASMA DE OJO IZQUIERDO DEBIDO A HEMORRAGIA INTRAOCULAR Y POSTERIOR A ELLA"
  },
  {
    "codigo":94334003,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA HIPOFARINGE"
  },
  {
    "codigo":420179005,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR ÁCIDO GRASO"
  },
  {
    "codigo":92499008,
    "descripcion":"OSIFICACIÓN BIPARTITA DE HUESO SUPRAOCCIPITAL"
  },
  {
    "codigo":418344001,
    "descripcion":"ALERGIA A CAFEÍNA"
  },
  {
    "codigo":287272002,
    "descripcion":"AGUJERO SEPTAL CARDÍACO AGRANDADO"
  },
  {
    "codigo":254504001,
    "descripcion":"NEOPLASIA BENIGNA DE CARA INFERIOR DE PALADAR BLANDO"
  },
  {
    "codigo":715091008,
    "descripcion":"DIFICULTAD PARA PASAR DEL AUTOMÓVIL A LA SILLA DE RUEDAS"
  },
  {
    "codigo":713256008,
    "descripcion":"PERIODONTITIS DEBIDA A RESORCIÓN DE RAÍZ CERVICAL"
  },
  {
    "codigo":285437004,
    "descripcion":"INCAPAZ DE REALIZAR FUNCIONES MOTRICES ORALES"
  },
  {
    "codigo":449277004,
    "descripcion":"UTILIZA LUBRICANTE DURANTE LA ACTIVIDAD SEXUAL"
  },
  {
    "codigo":23293006,
    "descripcion":"RUPTURA DEL OJO CON PÉRDIDA PARCIAL DEL TEJIDO INTRAOCULAR"
  },
  {
    "codigo":11211000119108,
    "descripcion":"ANOMALÍA CONGÉNITA DE PUPILA"
  },
  {
    "codigo":1076171000119108,
    "descripcion":"BURSITIS ROTULIANA DE RODILLA DERECHA"
  },
  {
    "codigo":1137405009,
    "descripcion":"DEBILIDAD DE MÚSCULO DE BRAZO"
  },
  {
    "codigo":11807691000119109,
    "descripcion":"RUPTURA TRAUMÁTICA DE LIGAMENTO ESCAFOSEMILUNAR DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":66661000119103,
    "descripcion":"PORTADOR DE CROMOSOMA X FRÁGIL"
  },
  {
    "codigo":283602005,
    "descripcion":"HERIDA POR PINCHAZO DE AGUJA EN LA REGIÓN OCULAR"
  },
  {
    "codigo":185298005,
    "descripcion":"VISTO POR MÉDICO DELEGADO"
  },
  {
    "codigo":216231001,
    "descripcion":"LESIÓN POR DESCENSO VOLUNTARIO EN PARACAÍDAS, SIN ACCIDENTE DE AERONAVE, PERSONAL DE TIERRA O EMPLEADO DE LÍNEA AÉREA LESIONADO"
  },
  {
    "codigo":609447002,
    "descripcion":"INTERRUPCIÓN INDUCIDA DEL EMBARAZO COMPLICADA POR DAÑO DE ÓRGANOS Y\/O TEJIDOS PÉLVICOS"
  },
  {
    "codigo":445607003,
    "descripcion":"ORIFICIO AÓRTICO POSTERIOR IZQUIERDO CON RESPECTO A ORIFICIO PULMONAR"
  },
  {
    "codigo":314535007,
    "descripcion":"LACERACIÓN DE PÁRPADO SIN COMPROMISO DEL BORDE PALPEBRAL"
  },
  {
    "codigo":707751009,
    "descripcion":"HIPERPLASIA YUXTAGLOMERULAR CONCOMITANTE CON HIPERALDOSTERONISMO SECUNDARIO"
  },
  {
    "codigo":247164008,
    "descripcion":"LESIÓN DISCOIDE SUBRETINIANA"
  },
  {
    "codigo":312700009,
    "descripcion":"LENTE INTRAOCULAR DESPLAZADO EN EL CUERPO VÍTREO"
  },
  {
    "codigo":312421000119107,
    "descripcion":"EPICONDILITIS DE HÚMERO DERECHO"
  },
  {
    "codigo":441937003,
    "descripcion":"CORTOCIRCUITO CARDÍACO BIDIRECCIONAL"
  },
  {
    "codigo":704081003,
    "descripcion":"FRACTURA NO EXPUESTA DE METÁFISIS DE HUESO METATARSIANO"
  },
  {
    "codigo":48721008,
    "descripcion":"PARÁLISIS CEREBRAL CUADRIPLÉJICA"
  },
  {
    "codigo":276262000,
    "descripcion":"DEFICIENCIA DE UROPORFIRINÓGENO DECARBOXILASA"
  },
  {
    "codigo":11836671000119102,
    "descripcion":"SUBLUXACIÓN DE ARTICULACIÓN DE PIE DERECHO"
  },
  {
    "codigo":866086000,
    "descripcion":"INFERTILIDAD MASCULINA DEBIDA A INFECCIÓN POR MICOPLASMA"
  },
  {
    "codigo":309030004,
    "descripcion":"SITUACIÓN DEL INFORME DEL ABOGADO"
  },
  {
    "codigo":16014591000119103,
    "descripcion":"TROMBOFLEBITIS DE VENA SUPERFICIAL DE AMBOS MIEMBROS INFERIORES"
  },
  {
    "codigo":405499004,
    "descripcion":"COMUNICACIÓN PREOPERATORIA CON EL PACIENTE INADECUADA"
  },
  {
    "codigo":733179008,
    "descripcion":"ARTRITIS DEBIDA A INFECCIÓN PARASITARIA Y POSTERIOR A ELLA"
  },
  {
    "codigo":285951000119105,
    "descripcion":"RUPTURA MECÁNICA DE INJERTO-PUENTE DE ARTERIA CORONARIA"
  },
  {
    "codigo":75984003,
    "descripcion":"QUEMADURA DE LA PARED DEL TÓRAX"
  },
  {
    "codigo":1255632004,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS TIPO FUSOCELULAR DE LARINGE"
  },
  {
    "codigo":272592008,
    "descripcion":"PONERSE EN CUCLILLAS EN EL AGUA"
  },
  {
    "codigo":403664009,
    "descripcion":"REACCIÓN FIJA POR FÁRMACO QUE AFECTA MEMBRANA MUCOSA BUCAL"
  },
  {
    "codigo":367871000119107,
    "descripcion":"ESTRECHEZ POSINFECCIOSA DE URETRA MASCULINA"
  },
  {
    "codigo":237989003,
    "descripcion":"DEFICIENCIA DE LA SUCCINATO-COENZIMA Q REDUCTASA"
  },
  {
    "codigo":41381004,
    "descripcion":"NEUMONÍA CAUSADA POR PSEUDOMONAS"
  },
  {
    "codigo":762277000,
    "descripcion":"DIVERTÍCULO DE INTESTINO DELGADO SIN HEMORRAGIA"
  },
  {
    "codigo":303525003,
    "descripcion":"DIFICULTAD PARA PONERSE LA PELUCA"
  },
  {
    "codigo":15742361000119102,
    "descripcion":"TRASTORNO DE AMBAS RÓTULAS"
  },
  {
    "codigo":205221009,
    "descripcion":"AGENESIA DE MÚLTIPLES HUESOS DEL TARSO"
  },
  {
    "codigo":301690001,
    "descripcion":"NO RUEDA EN LA CAMA"
  },
  {
    "codigo":16669951000119109,
    "descripcion":"FRACTURA NO EXPUESTA DE APÓFISIS CONDÍLEA DERECHA DE MANDÍBULA"
  },
  {
    "codigo":37711000,
    "descripcion":"NEUMONITIS POR CADMIO"
  },
  {
    "codigo":299855006,
    "descripcion":"REFLEJO ABDOMINAL TARDÍO"
  },
  {
    "codigo":365391007,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA REALIZAR ACTIVIDADES DIFICULTOSAS"
  },
  {
    "codigo":166948000,
    "descripcion":"NIVEL DE VALPROATO POR ENCIMA DE RANGO DE REFERENCIA"
  },
  {
    "codigo":789540001,
    "descripcion":"INMUNIZACIÓN RETRASADA"
  },
  {
    "codigo":35876006,
    "descripcion":"INFECCIÓN OCULAR GONOCÓCICA"
  },
  {
    "codigo":165113000,
    "descripcion":"COEFICIENTE RESPIRATORIO, ANORMAL"
  },
  {
    "codigo":34041001,
    "descripcion":"SÍNDROME DE ACHARD - THIERS"
  },
  {
    "codigo":197881002,
    "descripcion":"RUPTURA ESPONTÁNEA DE VEJIGA"
  },
  {
    "codigo":296185003,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE TRIFLUPERIDOL"
  },
  {
    "codigo":16561561000119108,
    "descripcion":"FRACTURA NO EXPUESTA DE HUESO CIGOMÁTICO DERECHO"
  },
  {
    "codigo":230649009,
    "descripcion":"SÍNDROME DE COMPRESIONES MÚLTIPLES"
  },
  {
    "codigo":425422007,
    "descripcion":"CEFALEA CAUSADA POR ALTITUD ELEVADA"
  },
  {
    "codigo":63139000,
    "descripcion":"EFECTO TÓXICO DEL FREÓN"
  },
  {
    "codigo":196046009,
    "descripcion":"NEUMOPATÍA AGUDA POR RADIACIÓN"
  },
  {
    "codigo":294350009,
    "descripcion":"ALERGIA A NATAMICINA"
  },
  {
    "codigo":292515001,
    "descripcion":"REACCIÓN ADVERSA A LA CLONIDINA"
  },
  {
    "codigo":95907004,
    "descripcion":"INTERACCIÓN DE FÁRMACO CON ALIMENTOS"
  },
  {
    "codigo":27941000146109,
    "descripcion":"NECESITA AYUDA PARA ACICALAMIENTO PERSONAL"
  },
  {
    "codigo":30371007,
    "descripcion":"FRACTURA EXPUESTA DE BASE DE CRÁNEO CON CONTUSIÓN Y LACERACIÓN DE CEREBRO"
  },
  {
    "codigo":290680001,
    "descripcion":"INTOXICACIÓN CON METOTREXATO"
  },
  {
    "codigo":716664003,
    "descripcion":"DISTONÍA PRIMARIA 21"
  },
  {
    "codigo":94072004,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL ÁNGULO ESPLÉNICO DEL COLON"
  },
  {
    "codigo":314931000119106,
    "descripcion":"ENFERMEDAD DE PAGET DE HOMBRO DERECHO"
  },
  {
    "codigo":126840005,
    "descripcion":"NEOPLASIA DEL COLON ASCENDENTE"
  },
  {
    "codigo":92237006,
    "descripcion":"NEOPLASIA BENIGNA DE MÚSCULO"
  },
  {
    "codigo":16698931000119108,
    "descripcion":"RUPTURA TRAUMÁTICA DE LIGAMENTO COLATERAL DE ARTICULACIÓN DE PULGAR IZQUIERDO"
  },
  {
    "codigo":714829008,
    "descripcion":"DEPENDENCIA DE ALCOHOL, MODERADA"
  },
  {
    "codigo":932947661000119102,
    "descripcion":"CARCINOMA ASOCIADO A PROTEÍNA NUCLEAR EN TESTÍCULO CON METÁSTASIS EN HUESO"
  },
  {
    "codigo":450850003,
    "descripcion":"UTILIZA ANILLO VAGINAL LIBERADOR DE HORMONAS"
  },
  {
    "codigo":254242006,
    "descripcion":"NEUROFIBROMA DIFUSO"
  },
  {
    "codigo":876834007,
    "descripcion":"INGESTA EXCESIVA DE FIBRA VEGETAL"
  },
  {
    "codigo":711159002,
    "descripcion":"SÍNDROME DE HISTIOCITOSIS-LINFADENOPATÍA PLUS"
  },
  {
    "codigo":55799007,
    "descripcion":"TIÑA DE LA CABEZA POR MICROSPORUM"
  },
  {
    "codigo":288461000119105,
    "descripcion":"PSICOSIS CAUSADA POR INHALANTE"
  },
  {
    "codigo":840396000,
    "descripcion":"ARTROPATÍA POSTRAUMÁTICA"
  },
  {
    "codigo":283340001,
    "descripcion":"PICADURA DE INSECTO EN EL DEDO GORDO"
  },
  {
    "codigo":15935181000119105,
    "descripcion":"CÚBITO VARO CONGÉNITO DE AMBOS CODOS"
  },
  {
    "codigo":449015009,
    "descripcion":"DESEMBOCADURA DE VENA HEPÁTICA EN AURÍCULA EN EL LADO DERECHO"
  },
  {
    "codigo":53964000,
    "descripcion":"INFECCIÓN CAUSADA POR PARASCARIS"
  },
  {
    "codigo":248737000,
    "descripcion":"DESCENSO ABRUPTO DE LA ONDA \"X\" DEL PULSO VENOSO YUGULAR"
  },
  {
    "codigo":707489000,
    "descripcion":"CARCINOMA FUSOCELULAR PRIMARIO DE CÉLULAS ESCAMOSAS DE HIPOFARINGE"
  },
  {
    "codigo":102334311000119101,
    "descripcion":"PROCTITIS ULCEROSA AGUDA"
  },
  {
    "codigo":445345005,
    "descripcion":"SINOVITIS SIMÉTRICA SERONEGATIVA REMITENTE CON EDEMA CON FÓVEA"
  },
  {
    "codigo":1297313005,
    "descripcion":"TRASTORNO DEGENERATIVO DE CARTÍLAGO ARTICULAR DE RODILLA"
  },
  {
    "codigo":609185006,
    "descripcion":"INFORME DE RESONANCIA MAGNÉTICA RECIBIDO"
  },
  {
    "codigo":115830003,
    "descripcion":"FENOTIPO DE GRUPO SANGUÍNEO KIDD"
  },
  {
    "codigo":246902004,
    "descripcion":"INYECCIÓN EN LA CONJUNTIVA PALPEBRAL"
  },
  {
    "codigo":83062006,
    "descripcion":"INFECCIÓN CAUSADA POR CANDIDA ALBICANS"
  },
  {
    "codigo":212299000,
    "descripcion":"CONTUSIÓN, NERVIO INTERÓSEO ANTERIOR"
  },
  {
    "codigo":1229942009,
    "descripcion":"INMUNODEFICIENCIA COMBINADA GRAVE POR DEFICIENCIA DE CORONINA 1A"
  },
  {
    "codigo":1259040000,
    "descripcion":"DOLOR NEUROPÁTICO CENTRAL"
  },
  {
    "codigo":341536001,
    "descripcion":"HIPERLISINEMIA PERIÓDICA"
  },
  {
    "codigo":208629000,
    "descripcion":"FRACTURA NO EXPUESTA DE TIBIA Y PERONÉ, DIÁFISIS"
  },
  {
    "codigo":700149001,
    "descripcion":"CON LICENCIA PARENTAL"
  },
  {
    "codigo":306933004,
    "descripcion":"ERITEMA SOBRE ÁREA MASTOIDEA"
  },
  {
    "codigo":274165007,
    "descripcion":"LACERACIÓN DE PIEL"
  },
  {
    "codigo":403402000,
    "descripcion":"DERMATOSIS PERFORANTE REACTIVA ADQUIRIDA"
  },
  {
    "codigo":15718401000119102,
    "descripcion":"PROTRUSIÓN INTRAPÉLVICA DE ACETÁBULO DERECHO"
  },
  {
    "codigo":75722007,
    "descripcion":"VOLUBILIDAD"
  },
  {
    "codigo":1351839000,
    "descripcion":"SÍNDROME DE BROWN-SÉQUARD DEBIDO A ENFERMEDAD NEOPLÁSICA"
  },
  {
    "codigo":42954008,
    "descripcion":"DIABETES MELLITUS ASOCIADA CON ANORMALIDAD DE RECEPTORES"
  },
  {
    "codigo":1157066007,
    "descripcion":"NEOPLASIA BENIGNA DE VÉRTEBRA"
  },
  {
    "codigo":317441000119104,
    "descripcion":"DETENCIÓN PARCIAL DEL CRECIMIENTO EPIFISARIO DE FÉMUR DISTAL DERECHO"
  },
  {
    "codigo":237727005,
    "descripcion":"DEFECTO DE OSMORREGULACIÓN - POLIDIPSIA"
  },
  {
    "codigo":72052003,
    "descripcion":"MEMBRANA TIMPÁNICA ATRÓFICA NO FLÁCCIDA"
  },
  {
    "codigo":1153396007,
    "descripcion":"INFECCIÓN DE DISCO INTERVERTEBRAL CAUSADA POR BACTERIA"
  },
  {
    "codigo":37449000,
    "descripcion":"FRACTURA EXPUESTA DEL CÚBITO"
  },
  {
    "codigo":102985001,
    "descripcion":"PRUEBA DE ROMBERG POSITIVA CON DIRECCIÓN DE LA CAÍDA AFECTADA POR EL GIRO DE LA CABEZA"
  },
  {
    "codigo":10967041000119107,
    "descripcion":"HERIDA PUNZANTE DE RODILLA IZQUIERDA"
  },
  {
    "codigo":234057004,
    "descripcion":"VENAS VARICOSAS PERFORANTES DE LA PANTORRILLA"
  },
  {
    "codigo":365129006,
    "descripcion":"HALLAZGO RELACIONADO CON EL NIVEL DE ESPERANZA"
  },
  {
    "codigo":299593008,
    "descripcion":"SIN AMPLITUD PASIVA DE FLEXIÓN DE DEDO DEL PIE"
  },
  {
    "codigo":363294003,
    "descripcion":"SECUELAS DE TRASTORNOS CARDIOVASCULARES"
  },
  {
    "codigo":68382005,
    "descripcion":"OTORREA DE LÍQUIDO CEFALORRAQUÍDEO"
  },
  {
    "codigo":166686006,
    "descripcion":"ELECTRÓLITOS FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":232222008,
    "descripcion":"OTITIS EXTERNA AGUDA DE ORIGEN VIRAL"
  },
  {
    "codigo":426995002,
    "descripcion":"RITMO DE ESCAPE DE LA UNIÓN AURICULOVENTRICULAR EN EL ELECTROCARDIOGRAMA"
  },
  {
    "codigo":295923002,
    "descripcion":"SOBREDOSIS DE PAROXETINA"
  },
  {
    "codigo":263155005,
    "descripcion":"FRACTURA DE HUESOS DEL CENTRO DE LA CARA"
  },
  {
    "codigo":197619007,
    "descripcion":"GLOMERULONEFRITIS DIFUSA CRÓNICA"
  },
  {
    "codigo":164851008,
    "descripcion":"ECG AMBULATORIO NORMAL"
  },
  {
    "codigo":33779007,
    "descripcion":"ANTICUERPOS ANTIBACTERIANOS DETECTADOS"
  },
  {
    "codigo":294088002,
    "descripcion":"ALERGIA A OXIBUTININA"
  },
  {
    "codigo":230387008,
    "descripcion":"EPILEPSIA AUTOLIMITADA CON CONVULSIONES AUTONÓMICAS"
  },
  {
    "codigo":359624005,
    "descripcion":"QUISTE PERIVENTRICULAR ADQUIRIDO"
  },
  {
    "codigo":278536002,
    "descripcion":"SÍNDROME POSTERIOR A PERICARDIOTOMÍA"
  },
  {
    "codigo":64712007,
    "descripcion":"ECOLALIA"
  },
  {
    "codigo":783773000,
    "descripcion":"CANTIDAD ANORMAL CONGÉNITA DE ORIFICIOS DE ARTERIA CORONARIA"
  },
  {
    "codigo":11815221000119101,
    "descripcion":"RUPTURA TRAUMÁTICA DE LIGAMENTO COLATERAL DE ARTICULACIÓN DE DEDO ÍNDICE DERECHO"
  },
  {
    "codigo":1176989007,
    "descripcion":"PARKINSONISMO DEBIDO A ENFERMEDAD POR PRIONES"
  },
  {
    "codigo":423325007,
    "descripcion":"CARCINOMA BASOCELULAR DE CONDUCTO AUDITIVO EXTERNO"
  },
  {
    "codigo":292253007,
    "descripcion":"REACCIÓN ADVERSA A LA VINDESINA"
  },
  {
    "codigo":126578003,
    "descripcion":"NEOPLASIA DE HUESO GANCHOSO"
  },
  {
    "codigo":716402007,
    "descripcion":"CAPAZ DE DIRIGIR LA ENERGÍA"
  },
  {
    "codigo":26439000,
    "descripcion":"PROBLEMA BÁSICO PARA EL APRENDIZAJE DE LA MATEMÁTICA"
  },
  {
    "codigo":91975001,
    "descripcion":"NEOPLASIA BENIGNA DE CUERPO DE LA LENGUA"
  },
  {
    "codigo":290418008,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR DOMPERIDONA"
  },
  {
    "codigo":346421000119104,
    "descripcion":"EDEMA MACULAR CISTOIDEO DE AMBAS RETINAS"
  },
  {
    "codigo":190279008,
    "descripcion":"HIPOTIROIDISMO POR DÉFICIT DE YODO"
  },
  {
    "codigo":796936501000119105,
    "descripcion":"DISECCIÓN DE AORTA TORÁCICA DESCENDENTE TIPO IIIA"
  },
  {
    "codigo":288583009,
    "descripcion":"EMPLEA COMUNICACIÓN NO VERBAL"
  },
  {
    "codigo":286748003,
    "descripcion":"ALTO NIVEL DE EGOCENTRISMO"
  },
  {
    "codigo":1237020006,
    "descripcion":"CON RIESGO ELEVADO DE EXPOSICIÓN A VIRUS DE HEPATITIS B"
  },
  {
    "codigo":253980008,
    "descripcion":"DEFECTO DE OSIFICACIÓN DEL CRÁNEO"
  },
  {
    "codigo":284913000,
    "descripcion":"CAPAZ DE USAR PALANGANA"
  },
  {
    "codigo":319951000119101,
    "descripcion":"NÓDULO REUMATOIDE SUBCUTÁNEO DE MANO DERECHA"
  },
  {
    "codigo":219377006,
    "descripcion":"HERIDA DE GUERRA POR BALA DE PISTOLA"
  },
  {
    "codigo":86470003,
    "descripcion":"OSTEOGÉNESIS IMPERFECTA, PERINATAL MORTAL RECESIVA"
  },
  {
    "codigo":283078006,
    "descripcion":"ARAÑAZO DE LA AXILA"
  },
  {
    "codigo":53702006,
    "descripcion":"INTOXICACIÓN POR TIABENDAZOL"
  },
  {
    "codigo":250310008,
    "descripcion":"PRUEBA PARA ANTÍGENO ERITROCÍTICO EQUINO, NEGATIVA"
  },
  {
    "codigo":184774008,
    "descripcion":"CERTIFICADOS DIVERSOS - ARANCEL PAGO"
  },
  {
    "codigo":446918008,
    "descripcion":"LACERACIÓN SUPERFICIAL DE CADERA"
  },
  {
    "codigo":709062008,
    "descripcion":"GINGIVITIS CAUSADA POR FÁRMACO"
  },
  {
    "codigo":215707002,
    "descripcion":"LESIÓN SUFRIDA A BORDO DE MEDIO DE TRANSPORTE ACUÁTICO CAUSADA POR MAQUINARIA DE CUBIERTA"
  },
  {
    "codigo":314011005,
    "descripcion":"MACULOPATÍA EXUDATIVA FOCAL DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":19099008,
    "descripcion":"INTENTO FALLIDO DE ABORTO CON LACERACIÓN DE VEJIGA"
  },
  {
    "codigo":1295216003,
    "descripcion":"ECTOMESENQUIMOMA"
  },
  {
    "codigo":246640004,
    "descripcion":"LUCES O COLORES EN EL CAMPO VISUAL"
  },
  {
    "codigo":1196912004,
    "descripcion":"NEOPLASIA ESTROMAL GASTROINTESTINAL DE APÉNDICE"
  },
  {
    "codigo":410480004,
    "descripcion":"IRITIS EN EL SÍNDROME DE BEHCET"
  },
  {
    "codigo":82800008,
    "descripcion":"POLIDIPSIA PRIMARIA"
  },
  {
    "codigo":408645001,
    "descripcion":"ADENOCARCINOMA DE INTESTINO GRUESO"
  },
  {
    "codigo":277573001,
    "descripcion":"LEUCEMIA LINFOBLÁSTICA AGUDA COMÚN"
  },
  {
    "codigo":212037005,
    "descripcion":"QUEMADURA DE LARINGE, TRÁQUEA Y PULMÓN"
  },
  {
    "codigo":310341009,
    "descripcion":"SEGUIMIENTO (AGUARDAR PARA DECIDIR)"
  },
  {
    "codigo":80965009,
    "descripcion":"AFASIA SEMÁNTICA"
  },
  {
    "codigo":111898002,
    "descripcion":"OTITIS EXTERNA MICÓTICA CRÓNICA"
  },
  {
    "codigo":699887000,
    "descripcion":"CELULITIS AGUDA DE PELVIS FEMENINA"
  },
  {
    "codigo":110063009,
    "descripcion":"LACERACIÓN SIMPLE CONTAMINADA DEL PABELLÓN AURICULAR"
  },
  {
    "codigo":1156804004,
    "descripcion":"NEOPLASIA NEUROECTODÉRMICA PERIFÉRICA DE CUERPO UTERINO"
  },
  {
    "codigo":1351577000,
    "descripcion":"SÍNDROME DE HIPERINMUNOGLOBULINA M AUTOSÓMICO RECESIVO DEBIDO A DEFICIENCIA DE SUBUNIDAD INO80 DE COMPLEJO DE ATPASA"
  },
  {
    "codigo":237465002,
    "descripcion":"QUISTE DE RETENCIÓN DE LA GLÁNDULA DE MONTGOMERY"
  },
  {
    "codigo":204697003,
    "descripcion":"AUSENCIA CONGÉNITA DE ÍLEON"
  },
  {
    "codigo":366702000,
    "descripcion":"AMPLITUD DE MOVIMIENTO PASIVO DE OPOSICIÓN DEL PULGAR - HALLAZGO"
  },
  {
    "codigo":40857009,
    "descripcion":"COLON CATÁRTICO"
  },
  {
    "codigo":301166003,
    "descripcion":"PULSO CUBITAL AUSENTE"
  },
  {
    "codigo":71790003,
    "descripcion":"FRACTURA EXPUESTA DEL CUARTO HUESO METATARSIANO"
  },
  {
    "codigo":235630008,
    "descripcion":"HIPERTENSIÓN DEL ESFÍNTER ESOFÁGICO INFERIOR"
  },
  {
    "codigo":364867000,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA PONERSE EN CUCLILLAS"
  },
  {
    "codigo":11817731000119104,
    "descripcion":"ESGUINCE DE LIGAMENTO DE DEDO MEÑIQUE DERECHO"
  },
  {
    "codigo":233795005,
    "descripcion":"TRASTORNO INFECCIOSO DE BRONQUIO"
  },
  {
    "codigo":299331007,
    "descripcion":"DEFORMIDAD EN VARO DE RODILLA"
  },
  {
    "codigo":166424001,
    "descripcion":"HORMONAS FETOPLACENTARIAS FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":789016002,
    "descripcion":"RADICULOPATÍA TÓXICA"
  },
  {
    "codigo":2584003,
    "descripcion":"DEGENERACIÓN CEREBRAL EN LA NIÑEZ"
  },
  {
    "codigo":231960005,
    "descripcion":"CUERPO EXTRAÑO EN EL IRIS"
  },
  {
    "codigo":363032009,
    "descripcion":"ANOMALÍA CONGÉNITA DE ESTRUCTURA MUSCULOESQUELÉTICA DEL TRONCO"
  },
  {
    "codigo":295661001,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE DACTINOMICINA"
  },
  {
    "codigo":819949002,
    "descripcion":"INFESTACIÓN CAUSADA POR CORDYLOBIA RODHAINI"
  },
  {
    "codigo":787181005,
    "descripcion":"DEBARYOMYCES HANSENII O PICHIA MEMBRANIFACIENS"
  },
  {
    "codigo":721645007,
    "descripcion":"CARCINOMA NEUROENDOCRINO PRIMARIO DE DUODENO"
  },
  {
    "codigo":719810000,
    "descripcion":"SÍNDROME DE DISCAPACIDAD INTELECTUAL LIGADA AL CROMOSOMA X CON CONVULSIONES Y PSORIASIS"
  },
  {
    "codigo":262893009,
    "descripcion":"LACERACIÓN DE RIÑÓN"
  },
  {
    "codigo":293826007,
    "descripcion":"ALERGIA A NORTRIPTILINA"
  },
  {
    "codigo":193687000,
    "descripcion":"ENFERMEDAD DE OGUCHI"
  },
  {
    "codigo":228290009,
    "descripcion":"BEBE EN EL TRABAJO"
  },
  {
    "codigo":128151003,
    "descripcion":"SOPLO CARDÍACO, CATEGORIZADO POR LAS CARACTERÍSTICAS"
  },
  {
    "codigo":717975006,
    "descripcion":"ATROFIA ÓPTICA AUTOSÓMICA DOMINANTE Y SÍNDROME DE NEUROPATÍA PERIFÉRICA"
  },
  {
    "codigo":29847008,
    "descripcion":"COMPLICACIÓN OBSTÉTRICA POR LA ANESTESIA Y\/O SEDACIÓN"
  },
  {
    "codigo":95383009,
    "descripcion":"ABSCESO ESTÉRIL DEL SITIO DE INYECCIÓN"
  },
  {
    "codigo":28012007,
    "descripcion":"FRACTURA NO EXPUESTA DE DIÁFISIS DE TIBIA"
  },
  {
    "codigo":419393000,
    "descripcion":"MUERTE - MUERTE SOSPECHOSA"
  },
  {
    "codigo":1142124009,
    "descripcion":"DESPOLARIZACIÓN AURICULAR PREMATURA CON CONDUCCIÓN NORMAL"
  },
  {
    "codigo":93548007,
    "descripcion":"SARCOMA DE HODGKIN DE GANGLIOS LINFÁTICOS INTRAPÉLVICOS"
  },
  {
    "codigo":16434231000119101,
    "descripcion":"PUBALGIA ATLÉTICA DE REGIÓN INGUINAL DERECHA"
  },
  {
    "codigo":124467005,
    "descripcion":"DEFICIENCIA DE BETA - FRUCTOFURANOSIDASA"
  },
  {
    "codigo":322461000119108,
    "descripcion":"POLINEUROPATÍA DEBIDA A ESCLEROSIS SISTÉMICA"
  },
  {
    "codigo":58945008,
    "descripcion":"CELULITIS DEL MENTÓN"
  },
  {
    "codigo":124481007,
    "descripcion":"DEFICIENCIA DE ADENOSILHOMOCISTEINASA"
  },
  {
    "codigo":417558002,
    "descripcion":"LUXACIÓN DE ARTICULACIÓN DE CODO"
  },
  {
    "codigo":253718003,
    "descripcion":"ARTERIA CIRCUNFLEJA QUE TRANSCURRE POR DETRÁS DEL TRONCO PULMONAR"
  },
  {
    "codigo":778006008,
    "descripcion":"APLASIA Y MIELODISPLASIA AUTOSÓMICA DOMINANTE"
  },
  {
    "codigo":415723000,
    "descripcion":"TIÑA CAUSADA POR TRICHOPHYTON"
  },
  {
    "codigo":286486008,
    "descripcion":"NO MEZCLA INGREDIENTES DE UNA COMIDA"
  },
  {
    "codigo":4941000175101,
    "descripcion":"DIFICULTAD PARA SEGUIR INSTRUCCIONES"
  },
  {
    "codigo":55275006,
    "descripcion":"VASCULITIS NODULAR"
  },
  {
    "codigo":186347006,
    "descripcion":"DIFTERIA DE PENE"
  },
  {
    "codigo":86208007,
    "descripcion":"SÍNDROME DE DOLOR DE FLANCO-HEMATURIA"
  },
  {
    "codigo":446656007,
    "descripcion":"ANATOMÍA BRONQUIAL EN ESPEJO"
  },
  {
    "codigo":12561000132105,
    "descripcion":"INFECCIÓN BACTERIANA CONCOMITANTE CON HERPES ZÓSTER Y DEBIDA A ÉL"
  },
  {
    "codigo":248213001,
    "descripcion":"TEZ RUBICUNDA"
  },
  {
    "codigo":315584008,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: CASTELLANO"
  },
  {
    "codigo":280981002,
    "descripcion":"OCLUSIÓN DE DERIVACIÓN ARTERIOVENOSA"
  },
  {
    "codigo":1264021005,
    "descripcion":"ERUPCIÓN DE PIEL DE CARA"
  },
  {
    "codigo":250048009,
    "descripcion":"ATAXIA FRONTAL"
  },
  {
    "codigo":132151000119108,
    "descripcion":"TROMBOSIS VENOSA PROFUNDA CRÓNICA DE VENA POPLÍTEA"
  },
  {
    "codigo":1231253003,
    "descripcion":"AGUJERO MACULAR DEBIDO A MIOPÍA ALTA PROGRESIVA DEGENERATIVA"
  },
  {
    "codigo":705130002,
    "descripcion":"INFARTO CEREBRAL DEBIDO A TROMBOSIS DE ARTERIA CEREBRAL MEDIA"
  },
  {
    "codigo":1088721000119103,
    "descripcion":"BOLSILLO DE RETRACCIÓN DE MEMBRANA TIMPÁNICA IZQUIERDA"
  },
  {
    "codigo":770666006,
    "descripcion":"TRISOMÍA 10Q NO DISTAL"
  },
  {
    "codigo":736063000,
    "descripcion":"QUEMADURA QUE INVOLUCRA 10-19 POR CIENTO DE LA SUPERFICIE CORPORAL, CON 15-19 POR CIENTO DE LA SUPERFICIE CORPORAL CON QUEMADURA DE ESPESOR COMPLETO"
  },
  {
    "codigo":1293119001,
    "descripcion":"GLOMERULOESCLEROSIS FOCAL Y SEGMENTARIA CON ENFERMEDAD INFECCIOSA"
  },
  {
    "codigo":1260351002,
    "descripcion":"DIPLOPÍA FUNCIONAL"
  },
  {
    "codigo":211775002,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO SUPERFICIAL DE PARED ABDOMINAL"
  },
  {
    "codigo":703295003,
    "descripcion":"HEMANGIOMA CONGÉNITO NO INVOLUCIONANTE"
  },
  {
    "codigo":15167005,
    "descripcion":"PATRÓN DE USO NOCIVO DE ALCOHOL"
  },
  {
    "codigo":111636004,
    "descripcion":"FRACTURA EXPUESTA DE TRÁQUEA"
  },
  {
    "codigo":78868004,
    "descripcion":"OTITIS MEDIA CRÓNICA MUCOIDE"
  },
  {
    "codigo":275476006,
    "descripcion":"CUERPO EXTRAÑO DEBAJO DEL PÁRPADO"
  },
  {
    "codigo":46100008,
    "descripcion":"GEMELO PARASITARIO DE GEMELARES UNIDOS ASIMÉTRICOS"
  },
  {
    "codigo":240873001,
    "descripcion":"GNATOSTOMIASIS LARVARIA"
  },
  {
    "codigo":109801007,
    "descripcion":"ANOMALÍA ADQUIRIDA DE LA ÚVULA"
  },
  {
    "codigo":679121000119108,
    "descripcion":"DELLEN DE CÓRNEA IZQUIERDA"
  },
  {
    "codigo":402878003,
    "descripcion":"TUMOR DE CÉLULAS GERMINALES"
  },
  {
    "codigo":763326004,
    "descripcion":"VENTILACIÓN CON MÁSCARA DIFÍCIL"
  },
  {
    "codigo":75198005,
    "descripcion":"DIVERTÍCULO GÁSTRICO"
  },
  {
    "codigo":239038006,
    "descripcion":"SÍNDROME DE KIRMAN"
  },
  {
    "codigo":1287614007,
    "descripcion":"CRISIS EPILÉPTICA ELECTROCLÍNICA DE INICIO FOCAL NEONATAL"
  },
  {
    "codigo":73363000,
    "descripcion":"TULAREMIA OCULOGLANDULAR"
  },
  {
    "codigo":1254846007,
    "descripcion":"NEOPLASIA MESENQUIMATOSA PRIMARIA MALIGNA DE DUODENO"
  },
  {
    "codigo":106131003,
    "descripcion":"HALLAZGO EN EL ESTADO DE ÁNIMO"
  },
  {
    "codigo":47241000087100,
    "descripcion":"LESIÓN DE PLEXO BRAQUIAL DE EXTREMIDAD SUPERIOR IZQUIERDA"
  },
  {
    "codigo":42121000087101,
    "descripcion":"ABRASIÓN DE PIEL DE MÚLTIPLES DEDOS DE PIE IZQUIERDO"
  },
  {
    "codigo":366440001,
    "descripcion":"AMPLITUD DE MOVIMIENTO PASIVO DE FLEXIÓN LATERAL HACIA LA IZQUIERDA DE LA COLUMNA LUMBAR - HALLAZGO"
  },
  {
    "codigo":39561000087107,
    "descripcion":"HEMATOMA DE REGIÓN INGUINAL IZQUIERDA"
  },
  {
    "codigo":169832004,
    "descripcion":"TRILLIZOS - DOS NACIDOS VIVOS Y UN MORTINATO"
  },
  {
    "codigo":202600005,
    "descripcion":"CHASQUIDO DE CODO"
  },
  {
    "codigo":201736002,
    "descripcion":"ARTRITIS REACTIVA"
  },
  {
    "codigo":167997000,
    "descripcion":"ESPUTO: EOSINOFILIA"
  },
  {
    "codigo":36925002,
    "descripcion":"OBSTRUCCIÓN DE BRONQUIO"
  },
  {
    "codigo":102461004,
    "descripcion":"INTOLERANCIA AUMENTADA"
  },
  {
    "codigo":35090008,
    "descripcion":"EVALUACIÓN DE DISCAPACIDAD: 5%"
  },
  {
    "codigo":395538009,
    "descripcion":"OBSERVACIÓN MICROSCÓPICA DE ESPÉCIMEN"
  },
  {
    "codigo":66023002,
    "descripcion":"LUXACIÓN NO EXPUESTA DE ASTRÁGALO"
  },
  {
    "codigo":721383003,
    "descripcion":"SÍNDROME DEL CORDÓN ANTERIOR DE MÉDULA ESPINAL AL NIVEL DEL TERCERO SEGMENTO CERVICAL"
  },
  {
    "codigo":295399001,
    "descripcion":"SOBREDOSIS INTENCIONAL DE TRISILICATO DE MAGNESIO"
  },
  {
    "codigo":262631007,
    "descripcion":"ABRASIÓN DE PALADAR"
  },
  {
    "codigo":786919007,
    "descripcion":"COMPORTAMIENTO SEXUALMENTE AGRESIVO"
  },
  {
    "codigo":162492005,
    "descripcion":"SECUENCIA DE APARICIÓN DEL SÍNTOMA"
  },
  {
    "codigo":11849221000119106,
    "descripcion":"HERIDA DE MAMA DERECHA DEBIDA A PICADURA DE INSECTO NO VENENOSO"
  },
  {
    "codigo":11986591000119100,
    "descripcion":"QUEMADURA EPIDÉRMICA DE PIERNA IZQUIERDA"
  },
  {
    "codigo":160657003,
    "descripcion":"DISPUESTO A SER DONANTE DE CÓRNEAS"
  },
  {
    "codigo":29585004,
    "descripcion":"ASPIRACIÓN DE VÓMITO EN LA VÍA RESPIRATORIA INFERIOR"
  },
  {
    "codigo":95121003,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LAS GLÁNDULAS SUDORÍPARAS"
  },
  {
    "codigo":226193007,
    "descripcion":"DIETA ELEMENTAL"
  },
  {
    "codigo":1091231000119102,
    "descripcion":"OTITIS EXTERNA DIFUSA DERECHA"
  },
  {
    "codigo":783249007,
    "descripcion":"SÍNDROME DE HIPERINMUNOGLOBULINEMIA M SIN SUSCEPTIBILIDAD A INFECCIONES OPORTUNISTAS"
  },
  {
    "codigo":93286002,
    "descripcion":"HIPOPLASIA CONGÉNITA DEL PUBIS"
  },
  {
    "codigo":191590005,
    "descripcion":"EPISODIOS MANÍACOS RECURRENTES"
  },
  {
    "codigo":1141862008,
    "descripcion":"DOLOR DE MÚSCULO GEMELO"
  },
  {
    "codigo":289894009,
    "descripcion":"SANGRADO MENSTRUAL PRESENTE"
  },
  {
    "codigo":124219002,
    "descripcion":"DEFICIENCIA DE ESCUALENO MONOOXIGENASA"
  },
  {
    "codigo":1303867005,
    "descripcion":"SÍNDROME DE OBESIDAD, HIPERFAGIA, RETRASO DE DESARROLLO GRAVE DE INICIO PRECOZ"
  },
  {
    "codigo":419131008,
    "descripcion":"REFLEJO SUPRARROTULIANO ASIMÉTRICO"
  },
  {
    "codigo":187920001,
    "descripcion":"NEOPLASIA MALIGNA DE COSTILLAS, ESTERNÓN Y CLAVÍCULA"
  },
  {
    "codigo":10675871000119106,
    "descripcion":"ASMA ALÉRGICA PERSISTENTE LEVE"
  },
  {
    "codigo":353951000119106,
    "descripcion":"NEOPLASIA BENIGNA DE HUESO LARGO DE MIEMBRO SUPERIOR DERECHO"
  },
  {
    "codigo":286224006,
    "descripcion":"CAPAZ DE UTILIZAR EL FLUJO DE AIRE GLÓTICO PARA HABLAR"
  },
  {
    "codigo":1300197001,
    "descripcion":"SÍNDROME SIMILAR A NF1 (NEUROFIBROMATOSIS 1) EN MOSAICO"
  },
  {
    "codigo":775909002,
    "descripcion":"SÍNDROME DE NEUTROPENIA CONGÉNITA, MIELOFIBROSIS Y NEFROMEGALIA"
  },
  {
    "codigo":448229007,
    "descripcion":"LEIOMIOSARCOMA DE ESÓFAGO INFERIOR"
  },
  {
    "codigo":681631000119108,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE CUERPO DEL ESTÓMAGO"
  },
  {
    "codigo":87781009,
    "descripcion":"HERNIA RETROPERITONEAL"
  },
  {
    "codigo":413626002,
    "descripcion":"ENDOFTALMITIS BACTERIANA"
  },
  {
    "codigo":282554002,
    "descripcion":"INCAPAZ DE DOBLAR ESQUINAS AL CORRER"
  },
  {
    "codigo":446394004,
    "descripcion":"HALLAZGO RELACIONADO CON CUTIVO MICROBIANO"
  },
  {
    "codigo":249786007,
    "descripcion":"PIERNA CORTA"
  },
  {
    "codigo":184250009,
    "descripcion":"DUPLICADO DE REGISTRO DE MOVIMIENTOS FETALES - ENTREGADO"
  },
  {
    "codigo":1263759003,
    "descripcion":"HEMATOMA SUBUNGUEAL DE DEDO ANULAR"
  },
  {
    "codigo":84111004,
    "descripcion":"FRACTURA EXPUESTA DE HUESO CIGOMÁTICO"
  },
  {
    "codigo":247951006,
    "descripcion":"REACCIÓN AL DESPERTAR ABRUPTO"
  },
  {
    "codigo":1296527009,
    "descripcion":"FIBROSIS QUÍSTICA DEBIDA A MUTACIÓN HETEROCIGOTA DELTAF508"
  },
  {
    "codigo":770404004,
    "descripcion":"SÍNDROME DE CORIORRETINOPATÍA Y MICROCEFALIA AUTOSÓMICO RECESIVO"
  },
  {
    "codigo":703033000,
    "descripcion":"CITROBACTER AMALONATICUS O CITROBACTER KOSERI"
  },
  {
    "codigo":82276009,
    "descripcion":"INTOXICACIÓN CAUSADA POR ANTIDEPRESIVO"
  },
  {
    "codigo":1260089000,
    "descripcion":"CARCINOMA LINFOEPITELIAL DE HIPOFARINGE"
  },
  {
    "codigo":47673003,
    "descripcion":"FUNDUS FLAVIMACULATUS"
  },
  {
    "codigo":735801007,
    "descripcion":"HERIDA PUNZANTE DE HOMBRO SIN CUERPO EXTRAÑO"
  },
  {
    "codigo":209678001,
    "descripcion":"SECCIÓN EXPUESTA DE LIGAMENTO DE PULGAR, ARTICULACIÓN INTERFALÁNGICA, LIGAMENTO LATERAL CUBITAL"
  },
  {
    "codigo":111374002,
    "descripcion":"SEUDOQUISTE PANCREÁTICO"
  },
  {
    "codigo":76771005,
    "descripcion":"HEMORRAGIA POSPARTO ASOCIADA CON HIPOFIBRINOGENEMIA"
  },
  {
    "codigo":44003006,
    "descripcion":"INTOXICACIÓN CAUSADA POR BARBITÚRICOS"
  },
  {
    "codigo":238776001,
    "descripcion":"LIVEDO RETICULARIS IDIOPÁTICO CON COMPROMISO SISTÉMICO"
  },
  {
    "codigo":304312001,
    "descripcion":"AMPLITUD DE MOVIMIENTO DE PULGAR AUMENTADA"
  },
  {
    "codigo":471521000124101,
    "descripcion":"HALLAZGO RELACIONADO CON LADO DERECHO DEL CORAZÓN"
  },
  {
    "codigo":402616005,
    "descripcion":"HIPERMELANOSIS CAUSADA POR AGENTE FOTODINÁMICO"
  },
  {
    "codigo":763064007,
    "descripcion":"CARCINOMA ADENOIDE QUÍSTICO DE CUELLO UTERINO"
  },
  {
    "codigo":440801000124104,
    "descripcion":"INGESTA INADECUADA DE FÓSFORO"
  },
  {
    "codigo":1252749008,
    "descripcion":"LACERACIÓN DE MÚSCULO PECTORAL"
  },
  {
    "codigo":204173008,
    "descripcion":"COLOBOMA DE RETINA"
  },
  {
    "codigo":300642000,
    "descripcion":"CONDUCE UNA MOTOCICLETA"
  },
  {
    "codigo":267874003,
    "descripcion":"ESCLERODERMIA"
  },
  {
    "codigo":890466005,
    "descripcion":"INGESTA INADECUADA DE CALCIO"
  },
  {
    "codigo":235106005,
    "descripcion":"DESVIACIÓN MANDIBULAR"
  },
  {
    "codigo":10760301000119103,
    "descripcion":"RETRACCIÓN DE PEZÓN DURANTE LACTANCIA"
  },
  {
    "codigo":298807002,
    "descripcion":"SIN AMPLITUD PASIVA DE ABDUCCIÓN DE HOMBRO"
  },
  {
    "codigo":724791009,
    "descripcion":"LACERACIÓN DE TENDÓN DEL CUELLO"
  },
  {
    "codigo":296972002,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE POTASIO"
  },
  {
    "codigo":722956007,
    "descripcion":"TRASTORNO LINFOPROLIFERATIVO TEMPRANO POSTRASPLANTE"
  },
  {
    "codigo":65761003,
    "descripcion":"DOLOR INFLAMATORIO"
  },
  {
    "codigo":1343713009,
    "descripcion":"HERNIA LUMBAR RECURRENTE"
  },
  {
    "codigo":293302002,
    "descripcion":"REACCIÓN ADVERSA A LA SALCATONINA"
  },
  {
    "codigo":291467002,
    "descripcion":"INTOXICACIÓN INVOLUNTARIA POR TIABENDAZOL"
  },
  {
    "codigo":225931003,
    "descripcion":"CON MAYOR RIESGO DE CRISIS EPILÉPTICAS"
  },
  {
    "codigo":1208971008,
    "descripcion":"CRISIS EPILÉPTICA MIOCLÓNICA-ATÓNICA DE INICIO GENERALIZADO"
  },
  {
    "codigo":1010528001,
    "descripcion":"ESCLEROSIS DE EPÍFISIS DE FALANGE MEDIA DE SEGUNDO DEDO DE PIE CON RADIOPACIDAD AUMENTADA"
  },
  {
    "codigo":93024006,
    "descripcion":"ANOMALÍA CONGÉNITA DE HUESO ESCAMOSO"
  },
  {
    "codigo":289632007,
    "descripcion":"ÚTERO DE TAMAÑO NORMAL"
  },
  {
    "codigo":418869005,
    "descripcion":"SOPLO FEMORAL"
  },
  {
    "codigo":255029007,
    "descripcion":"CARCINOMA TIROIDEO PAPILAR"
  },
  {
    "codigo":139681000119102,
    "descripcion":"CONDROMATOSIS SINOVIAL DE MUÑECA"
  },
  {
    "codigo":187658004,
    "descripcion":"NEOPLASIA MALIGNA DE VESTÍBULO BUCAL"
  },
  {
    "codigo":449802004,
    "descripcion":"CARCINOMA IN SITU DE CÚPULA VESICAL"
  },
  {
    "codigo":253194008,
    "descripcion":"ANEURISMA DE LA VENA DE GALENO"
  },
  {
    "codigo":285962008,
    "descripcion":"NO REMUEVE EL TAPÓN DE LA PILETA"
  },
  {
    "codigo":251359002,
    "descripcion":"MEJORÍA EN LA AUDICIÓN"
  },
  {
    "codigo":21983002,
    "descripcion":"TIROIDITIS DE HASHIMOTO"
  },
  {
    "codigo":185823004,
    "descripcion":"HALLAZGO RELACIONADO CON LA TEXTURA DE LA PIEL"
  },
  {
    "codigo":303521000119104,
    "descripcion":"DEPÓSITO DE CALCIO EN BOLSA SEROSA DE CODO DERECHO"
  },
  {
    "codigo":249524005,
    "descripcion":"PÉRDIDA DE CONCIENCIA DE LA NECESIDAD DE DEFECAR"
  },
  {
    "codigo":216756006,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR HIDRÓXIDO DE SODIO"
  },
  {
    "codigo":446132009,
    "descripcion":"CUERPO EXTRAÑO EN MUSLO"
  },
  {
    "codigo":1263497002,
    "descripcion":"ENFERMEDAD DE NEURONA MOTORA DEBIDA A ENFERMEDAD NEOPLÁSICA"
  },
  {
    "codigo":247689003,
    "descripcion":"DELIRIO HIPOCONDRÍACO DEPRESIVO"
  },
  {
    "codigo":870281008,
    "descripcion":"ESPONDILOARTRITIS CAUSADA POR PARÁSITO"
  },
  {
    "codigo":213086000,
    "descripcion":"DESPLAZAMIENTO DE ALOINJERTO ÓSEO"
  },
  {
    "codigo":278622002,
    "descripcion":"PACIENTE INCAPAZ DE COMER CON PRÓTESIS DENTAL"
  },
  {
    "codigo":409694006,
    "descripcion":"ANTICUERPO ANTI-DENGUE INMUNOGLOBULINA G NO DETECTADO"
  },
  {
    "codigo":473395000,
    "descripcion":"OCLUSIÓN CONGÉNITA DE VENA FEMORAL"
  },
  {
    "codigo":211251003,
    "descripcion":"ABRASIÓN DE PIEL DE CODO"
  },
  {
    "codigo":101411000119100,
    "descripcion":"DEFECTO BENIGNO DE HUESO CORTICAL"
  },
  {
    "codigo":1079331000119101,
    "descripcion":"NEOPLASIA BENIGNA DE PIEL DE MIEMBRO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":306211000119100,
    "descripcion":"GOTA TOFÁCEA CRÓNICA DE RODILLA CAUSADA POR FÁRMACO"
  },
  {
    "codigo":1089571000119101,
    "descripcion":"CUERPO EXTRAÑO RETENIDO EN OÍDO MEDIO IZQUIERDO"
  },
  {
    "codigo":1571000119104,
    "descripcion":"HIPERLIPIDEMIA MIXTA DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":334371000119100,
    "descripcion":"CONJUNTIVITIS LEÑOSA DE OJO DERECHO"
  },
  {
    "codigo":16636451000119101,
    "descripcion":"LESIÓN DE AMBOS NERVIOS CUBITALES"
  },
  {
    "codigo":10861091000119102,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO FEMORAL DERECHO"
  },
  {
    "codigo":10738211000119102,
    "descripcion":"FÍSTULA CONGÉNITA ENTRE EL ÚTERO Y LA VÍA URINARIA"
  },
  {
    "codigo":29731000119103,
    "descripcion":"HEMORRAGIA INTESTINAL DEBIDA A ANGIODISPLASIA DE INTESTINO"
  },
  {
    "codigo":298531000119104,
    "descripcion":"OSTEONECROSIS DE HUESO DE TOBILLO CAUSADA POR FÁRMACO"
  },
  {
    "codigo":16068131000119104,
    "descripcion":"GRANULOMA DE PARTES BLANDAS DE AMBOS PIES POR CUERPO EXTRAÑO"
  },
  {
    "codigo":209416001,
    "descripcion":"DISTENSIÓN DEL TENDÓN DEL MÚSCULO SUPRAESPINOSO"
  },
  {
    "codigo":556179491000119104,
    "descripcion":"ENFERMEDAD PULMONAR INTERSTICIAL DEBIDA A VAPEO"
  },
  {
    "codigo":78344003,
    "descripcion":"RETRASO EN LA EXTENSIÓN"
  },
  {
    "codigo":139811000119109,
    "descripcion":"MUTACIÓN HOMOCIGOTA DE METILENTETRAHIDROFOLATO REDUCTASA"
  },
  {
    "codigo":11047971000119109,
    "descripcion":"EFECTO SOBRE EL RECIÉN NACIDO DE LA DEPRESIÓN PUERPERAL MATERNA"
  },
  {
    "codigo":438792009,
    "descripcion":"ENFERMEDAD POR DEFICIENCIA HEREDITARIA DE FACTOR IX SIN INHIBIDORES"
  },
  {
    "codigo":830173006,
    "descripcion":"ALERGIA A METENAMINA"
  },
  {
    "codigo":109277000,
    "descripcion":"NEVO MELANOCÍTICO DEL OÍDO"
  },
  {
    "codigo":240349003,
    "descripcion":"CÓLERA CAUSADO POR VIBRIO CHOLERAE O1 BIOTIPO CLÁSICO"
  },
  {
    "codigo":305885009,
    "descripcion":"ATENDIDO POR SERVICIO DE CIRUGÍA MAMARIA"
  },
  {
    "codigo":402354001,
    "descripcion":"DISTROFIA UNGUEAL POR LIQUEN ESTRIADO"
  },
  {
    "codigo":1156018007,
    "descripcion":"TROMBOSIS DE ARTERIA CEREBELOSA IZQUIERDA"
  },
  {
    "codigo":302215000,
    "descripcion":"TRASTORNO TROMBOCITOPÉNICO"
  },
  {
    "codigo":40071000,
    "descripcion":"COMPRESIÓN DE TROMPA DE EUSTAQUIO"
  },
  {
    "codigo":1285255000,
    "descripcion":"SIN RANGO ACTIVO DE DORSIFLEXIÓN DE TOBILLO"
  },
  {
    "codigo":72839009,
    "descripcion":"GANGLIONITIS DEL GENICULADO"
  },
  {
    "codigo":300380005,
    "descripcion":"HALLAZGO RELACIONADO CON LA FRECUENCIA DE LA DEFECACIÓN"
  },
  {
    "codigo":726364006,
    "descripcion":"MONOSOMÍA AUTOSÓMICA COMPLETA"
  },
  {
    "codigo":365916007,
    "descripcion":"MEMORIA PARA RECORDAR DIRECCIÓN - HALLAZGO"
  },
  {
    "codigo":890204008,
    "descripcion":"ANOMALÍA ADQUIRIDA POSTERIOR A REPARACIÓN DE VÁLVULA CARDÍACA CON MALFORMACIÓN CONGÉNITA"
  },
  {
    "codigo":3633001,
    "descripcion":"ABSCESO DE LA MANO"
  },
  {
    "codigo":724529001,
    "descripcion":"ÚLCERA DUODENAL CAUSADA POR FÁRMACO"
  },
  {
    "codigo":306031000119101,
    "descripcion":"TRASTORNO DE LIGAMENTO DE ARTICULACIÓN DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":267612009,
    "descripcion":"DEGENERACIÓN DE MÁCULA POR QUISTE, AGUJERO O SEUDOAGUJERO"
  },
  {
    "codigo":10627951000119101,
    "descripcion":"CARBUNCO DE DEDO DE PIE DERECHO"
  },
  {
    "codigo":298545006,
    "descripcion":"SIN AMPLITUD DE FLEXIÓN LATERAL ACTIVA HACIA LA IZQUIERDA DE LA COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":67334001,
    "descripcion":"PRONÓSTICO RESERVADO"
  },
  {
    "codigo":10818261000119109,
    "descripcion":"FRACTURA EXPUESTA DE FALANGE DISTAL DE DEDO MEDIO IZQUIERDO"
  },
  {
    "codigo":427782005,
    "descripcion":"LESIÓN TRAUMÁTICA DE MAXILAR INFERIOR"
  },
  {
    "codigo":296710006,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE CEFOTAXIMA"
  },
  {
    "codigo":34566007,
    "descripcion":"ENFERMEDAD POR ALMACENAMIENTO DE ÁCIDO SIÁLICO, FORMA INFANTIL SEVERA"
  },
  {
    "codigo":722694005,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE HUESO Y CARTÍLAGO ARTICULAR"
  },
  {
    "codigo":165638009,
    "descripcion":"CINÉTICA DEL HIERRO FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":142191000119104,
    "descripcion":"TABIQUE VAGINAL TRANSVERSO CONGÉNITO"
  },
  {
    "codigo":294875004,
    "descripcion":"ALERGIA A TINZAPARINA"
  },
  {
    "codigo":9267009,
    "descripcion":"DOLOR DE PECHO DURANTE EL REPOSO"
  },
  {
    "codigo":720859009,
    "descripcion":"SÍNDROME DE EHLERS-DANLOS TIPO CIFOESCOLIÓTICO CON SORDERA"
  },
  {
    "codigo":719024002,
    "descripcion":"CAPAZ DE PASAR DE UNA UBICACIÓN A OTRA CON AYUDA"
  },
  {
    "codigo":194736003,
    "descripcion":"INSUFICIENCIA AÓRTICA Y MITRAL"
  },
  {
    "codigo":131035008,
    "descripcion":"NIVEL DE EPINEFRINA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":293040007,
    "descripcion":"REACCIÓN ADVERSA AL SULFAFURAZOL"
  },
  {
    "codigo":260272008,
    "descripcion":"VISIÓN A DISTANCIA 6\/6"
  },
  {
    "codigo":782725000,
    "descripcion":"PARAPLEJÍA ESPÁSTICA AUTOSÓMICA RECESIVA TIPO 69"
  },
  {
    "codigo":16034671000119107,
    "descripcion":"HIPERTROFIA DE HUESO DE OMÓPLATO DERECHO"
  },
  {
    "codigo":29061002,
    "descripcion":"INFECCIÓN CAUSADA POR BOTHRIOCEPHALUS"
  },
  {
    "codigo":291205005,
    "descripcion":"INTOXICACIÓN POR TIOXANTENO"
  },
  {
    "codigo":127365008,
    "descripcion":"SECUNDIGESTA"
  },
  {
    "codigo":94597008,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL CORDÓN ESPERMÁTICO"
  },
  {
    "codigo":289370003,
    "descripcion":"CABEZA FETAL 4\/5 POR ENCIMA DEL BORDE PÉLVICO"
  },
  {
    "codigo":59994004,
    "descripcion":"TOS FERINA"
  },
  {
    "codigo":92762007,
    "descripcion":"CARCINOMA IN SITU DE GLÁNDULA SUDORÍPARA"
  },
  {
    "codigo":90927000,
    "descripcion":"AMBLIOPÍA REFRACTARIA"
  },
  {
    "codigo":189231007,
    "descripcion":"CARCINOMA IN SITU DEL RECTO Y LA UNIÓN RECTOSIGMOIDEA"
  },
  {
    "codigo":254767008,
    "descripcion":"LEIOMIOMA CUTÁNEO"
  },
  {
    "codigo":415359008,
    "descripcion":"UVEÍTIS POR SARCOIDOSIS"
  },
  {
    "codigo":447705002,
    "descripcion":"NEOPLASIA MALIGNA DE CÉLULAS GERMINALES DE MEDIASTINO POSTERIOR"
  },
  {
    "codigo":1332441003,
    "descripcion":"HIPERTENSIÓN EN ENFERMEDAD RENAL CRÓNICA EN ESTADIO 3A DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":709849005,
    "descripcion":"UBICACIÓN Y MAGNITUD DE REGIÓN EDÉNTULA DE LA CAVIDAD BUCAL SEVERAMENTE COMPROMETIDAS"
  },
  {
    "codigo":183726000,
    "descripcion":"CONSULTA DOMICILIARIA DE OTORRINOLARINGOLOGÍA SOLICITADA"
  },
  {
    "codigo":413102000,
    "descripcion":"INFARTO DE GANGLIOS BASALES"
  },
  {
    "codigo":414937009,
    "descripcion":"EN EL MARCO DE LA NORMA RECOMENDADA PARA CUIDADOS PALIATIVOS"
  },
  {
    "codigo":251097009,
    "descripcion":"FUNCIÓN DEL NÓDULO AURICULOVENTRICULAR DISOCIADA"
  },
  {
    "codigo":85422000,
    "descripcion":"TALASEMIA ALFA MÁS TIPO NO DELECIÓN"
  },
  {
    "codigo":216494005,
    "descripcion":"INTOXICACIÓN ACCIDENTAL CAUSADA POR PENTAZOCINA"
  },
  {
    "codigo":19886006,
    "descripcion":"SÍNDROME DE STURGE-WEBER"
  },
  {
    "codigo":708014007,
    "descripcion":"NO TIENE CUIDADOR INFORMAL"
  },
  {
    "codigo":312963001,
    "descripcion":"RETINOPATÍA POR METANOL"
  },
  {
    "codigo":18051001,
    "descripcion":"EFECTO TÓXICO DEL DICLORVOS"
  },
  {
    "codigo":1197699002,
    "descripcion":"ESTENOSIS DE INTESTINO DELGADO DEBIDA A DIVERTICULITIS"
  },
  {
    "codigo":249262009,
    "descripcion":"EL PREPUCIO NO SE RETRAE"
  },
  {
    "codigo":247427007,
    "descripcion":"PIEL FRÁGIL"
  },
  {
    "codigo":83587009,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN LA REGIÓN DE LA MEJILLA, CON INFECCIÓN"
  },
  {
    "codigo":1163096003,
    "descripcion":"ENCEFALITIS POR ORGANISMO DE LA FAMILIA FILOVIRIDAE"
  },
  {
    "codigo":308541000119100,
    "descripcion":"SINDACTILIA DE DEDOS DE MANO IZQUIERDA"
  },
  {
    "codigo":704344007,
    "descripcion":"ACTITUD CONFLICTIVA HACIA LA ATENCIÓN"
  },
  {
    "codigo":473133001,
    "descripcion":"MIGRACIÓN DE CATÉTER DE DRENAJE BILIAR TRANSHEPÁTICO PERCUTÁNEO"
  },
  {
    "codigo":276525003,
    "descripcion":"ÚLCERA PÉPTICA DEL RECIÉN NACIDO"
  },
  {
    "codigo":407597004,
    "descripcion":"ECOCARDIOGRAMA QUE MUESTRA DISFUNCIÓN DIASTÓLICA DEL VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":210989006,
    "descripcion":"ABRASIÓN DE CUERO CABELLUDO"
  },
  {
    "codigo":1259565006,
    "descripcion":"COREA CAUSADA POR ANTICONCEPTIVO ORAL"
  },
  {
    "codigo":1290498003,
    "descripcion":"TENDINOSIS DE RODILLA"
  },
  {
    "codigo":372994004,
    "descripcion":"INFECCIÓN CAUSADA POR ASPERGILLUS PHIALISEPTUS"
  },
  {
    "codigo":11803811000119109,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA PROXIMAL DE DEDO MEÑIQUE DERECHO"
  },
  {
    "codigo":209154007,
    "descripcion":"SUBLUXACIÓN EXPUESTA DE LA ARTICULACIÓN ATLOAXOIDEA"
  },
  {
    "codigo":698839000,
    "descripcion":"HIPERTENSIÓN INTRACRANEAL BENIGNA DEBIDA A HIPERVITAMINOSIS A"
  },
  {
    "codigo":12546009,
    "descripcion":"ENFERMEDAD HEMORRÁGICA DEL RECIÉN NACIDO POR DEFICIENCIA DE VITAMINA K"
  },
  {
    "codigo":403927001,
    "descripcion":"MELANOMA MALIGNO DE APARATO UNGUEAL"
  },
  {
    "codigo":240087000,
    "descripcion":"MIOPATÍA CON AGREGADOS TUBULARES"
  },
  {
    "codigo":1255895001,
    "descripcion":"LINFOMA DE BURKITT DE GANGLIOS LINFÁTICOS DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":305623002,
    "descripcion":"ATENDIDO POR CONSEJERO ESPECIALIZADO EN GENÉTICA"
  },
  {
    "codigo":471298007,
    "descripcion":"ORIGEN ANÓMALO DE ARTERIA CORONARIA ÚNICA EN SENO AÓRTICO A LA IZQUIERDA DE SENO AÓRTICO NO ENFRENTADO"
  },
  {
    "codigo":205484001,
    "descripcion":"SÍNDROME DE POLIDACTILIA Y COSTILLA CORTA"
  },
  {
    "codigo":860844003,
    "descripcion":"GRANULOMA DE ESPACIO EPIDURAL ESPINAL CAUSADO POR HONGO"
  },
  {
    "codigo":271020004,
    "descripcion":"AGENESIA DE MAMA CON PEZÓN AUSENTE"
  },
  {
    "codigo":762540007,
    "descripcion":"ENDOCARDITIS DE NEOVÁLVULA PULMONAR"
  },
  {
    "codigo":301953004,
    "descripcion":"IRIS MARRÓN"
  },
  {
    "codigo":367489004,
    "descripcion":"OSTEOPETROSIS MALIGNA INFANTIL"
  },
  {
    "codigo":1186689004,
    "descripcion":"AMBIENTE AMIGABLE"
  },
  {
    "codigo":236417008,
    "descripcion":"GLOMERULONEFRITIS MEMBRANOSA - ESTADIO V"
  },
  {
    "codigo":39809009,
    "descripcion":"TRASTORNO DEPRESIVO MAYOR RECURRENTE CON SÍNTOMAS CATATÓNICOS"
  },
  {
    "codigo":365654005,
    "descripcion":"CONTENIDO PROTEICO DE LÍQUIDO PLEURAL - HALLAZGO"
  },
  {
    "codigo":234582006,
    "descripcion":"DEFICIENCIA DE LA ADHESIÓN LEUCOCITARIA - TIPO 1"
  },
  {
    "codigo":267350007,
    "descripcion":"PROBLEMAS OBSTÉTRICOS POR ANESTESIA"
  },
  {
    "codigo":36139001,
    "descripcion":"CISTITIS INTERSTICIAL ULCERATIVA CRÓNICA"
  },
  {
    "codigo":1217622009,
    "descripcion":"PARÁLISIS CONGÉNITA DE MIRADA HORIZONTAL"
  },
  {
    "codigo":298283006,
    "descripcion":"DEBILIDAD DE MÚSCULO DE LA MANO"
  },
  {
    "codigo":722432000,
    "descripcion":"SÍNDROME DE ANOMALÍA DE DUANE, MIOPATÍA Y ESCOLIOSIS"
  },
  {
    "codigo":427520002,
    "descripcion":"INFECCIÓN DISEMINADA POR MYCOBACTEROIDES ABSCESSUS"
  },
  {
    "codigo":296448002,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE PREPARADOS BRONCODILATADORES"
  },
  {
    "codigo":196309004,
    "descripcion":"DESGASTE DENTAL APROXIMAL"
  },
  {
    "codigo":11832791000119108,
    "descripcion":"ESGUINCE DE ARTICULACIÓN INTERFALÁNGICA DE SEGUNDO A QUINTO DEDOS DE PIE DERECHO"
  },
  {
    "codigo":391082001,
    "descripcion":"RESULTADO DE ECOGRAFÍA CUANTITATIVA DE TALÓN: OSTEOPENIA"
  },
  {
    "codigo":65237009,
    "descripcion":"GLÁNDULA TIROIDES ACCESORIA"
  },
  {
    "codigo":63402005,
    "descripcion":"SÍNDROME DE MEIGS"
  },
  {
    "codigo":1074801000119103,
    "descripcion":"ARTRITIS DE PRIMERA ARTICULACIÓN CARPOMETACARPIANA DE MANO IZQUIERDA"
  },
  {
    "codigo":128938009,
    "descripcion":"INFECCIÓN DE LA PIEL, DE ORIGEN PARASITARIO"
  },
  {
    "codigo":422015002,
    "descripcion":"SENSACIÓN CORNEAL NORMAL"
  },
  {
    "codigo":94335002,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE ÍLEON"
  },
  {
    "codigo":1306751004,
    "descripcion":"RETRASO DEL DESARROLLO POR DEFICIENCIA DE 2-METILBUTIRIL-COA-DESHIDROGENASA"
  },
  {
    "codigo":290943005,
    "descripcion":"INTOXICACIÓN POR GABAPENTINA"
  },
  {
    "codigo":782463007,
    "descripcion":"HIPERHIDROSIS FOCAL PRIMARIA DE LA PLANTA DE AMBOS PIES"
  },
  {
    "codigo":127103008,
    "descripcion":"LINFADENOPATÍA TRAQUEOBRONQUIAL"
  },
  {
    "codigo":715092001,
    "descripcion":"DIFICULTAD PARA PASAR DE LA SILLA A LA CAMA"
  },
  {
    "codigo":92500004,
    "descripcion":"OSIFICACIÓN BIPARTITA DEL CENTRO DE LA VÉRTEBRA DORSAL"
  },
  {
    "codigo":254505000,
    "descripcion":"NEOPLASIA DE CARA HIPOFARÍNGEA DE PLIEGUE ARITENOEPIGLÓTICO"
  },
  {
    "codigo":420180008,
    "descripcion":"VÍCTIMA DE RELACIÓN SEXUAL ABUSIVA CON LA ESPOSA"
  },
  {
    "codigo":1335849002,
    "descripcion":"DEPRESIÓN RESPIRATORIA CAUSADA POR OPIOIDE"
  },
  {
    "codigo":713257004,
    "descripcion":"EL CUIDADOR PRIMARIO EXHIBE CALOR EMOCIONAL Y AMOR AL NIÑO"
  },
  {
    "codigo":11314801000119108,
    "descripcion":"FRACTURA POR ESTRÉS DE FALANGE DE PIE IZQUIERDO"
  },
  {
    "codigo":416510003,
    "descripcion":"NEOPLASIA DEL APARATO LAGRIMAL"
  },
  {
    "codigo":1137406005,
    "descripcion":"DEBILIDAD DE MÚSCULO FLEXOR DE DEDO DE MANO"
  },
  {
    "codigo":311051000119103,
    "descripcion":"MIOSITIS INTERSTICIAL DE ANTEBRAZO IZQUIERDO"
  },
  {
    "codigo":283603000,
    "descripcion":"HERIDA POR PINCHAZO DE AGUJA EN LA REGIÓN AURICULAR"
  },
  {
    "codigo":285438009,
    "descripcion":"REALIZA FUNCIONES MOTRICES ORALES"
  },
  {
    "codigo":21459002,
    "descripcion":"PÉRDIDA DE DIENTES POR ENFERMEDAD PERIODONTAL LOCAL"
  },
  {
    "codigo":185299002,
    "descripcion":"ATENDIDO POR RECEPCIONISTA"
  },
  {
    "codigo":86995005,
    "descripcion":"MIOCARDIOPATÍA DILATADA DEBIDA A MUCOPOLISACARIDOSIS"
  },
  {
    "codigo":709587006,
    "descripcion":"ATEROSCLEROSIS DE INJERTO-PUENTE AUTÓLOGO DE MIEMBRO INFERIOR"
  },
  {
    "codigo":871592000,
    "descripcion":"COMPLICACIÓN DEBIDA A CREACIÓN DE DERIVACIÓN DE IZQUIERDA A DERECHA, DE LA CIRCULACIÓN SISTÉMICA A LA PULMONAR"
  },
  {
    "codigo":314536008,
    "descripcion":"LACERACIÓN DE PÁRPADO CON COMPROMISO DEL BORDE PALPEBRAL"
  },
  {
    "codigo":50557007,
    "descripcion":"REPARACIÓN CICATRIZADA DEL PISO PÉLVICO QUE AFECTA AL EMBARAZO"
  },
  {
    "codigo":312701008,
    "descripcion":"AGUJERO MACULAR INMINENTE"
  },
  {
    "codigo":247165009,
    "descripcion":"DESPRENDIMIENTO DE RETINA - LÍQUIDO SUBRETINIANO"
  },
  {
    "codigo":278098005,
    "descripcion":"SÍNDROME DE CRANDALL"
  },
  {
    "codigo":704082005,
    "descripcion":"FRACTURA NO EXPUESTA DE METÁFISIS DE PRIMER METATARSIANO"
  },
  {
    "codigo":309031000,
    "descripcion":"SITUACIÓN DEL INFORME SOBRE PENSIONES DE GUERRA"
  },
  {
    "codigo":441938008,
    "descripcion":"CORTOCIRCUITO CARDÍACO DE IZQUIERDA A DERECHA"
  },
  {
    "codigo":276263005,
    "descripcion":"DEFICIENCIA DE PORFOBILINÓGENO DESAMINASA"
  },
  {
    "codigo":1290236000,
    "descripcion":"ARTROFIBROSIS DE CADERA"
  },
  {
    "codigo":866087009,
    "descripcion":"FRACTURA PATOLÓGICA DE VÉRTEBRA EN SITIO DE NEOPLASIA METASTÁSICA"
  },
  {
    "codigo":208892001,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE CADERA"
  },
  {
    "codigo":700412002,
    "descripcion":"NO TIENE LICENCIA DE CONDUCIR"
  },
  {
    "codigo":733180006,
    "descripcion":"ARTRITIS DEBIDA A INFECCIÓN VIRAL Y POSTERIOR A ELLA"
  },
  {
    "codigo":698577000,
    "descripcion":"HIPOTIROIDISMO EN EL LACTANTE CAUSADO POR FÁRMACO MATERNO"
  },
  {
    "codigo":239825002,
    "descripcion":"ARTICULACIÓN TABÉTICA"
  },
  {
    "codigo":272593003,
    "descripcion":"POSICIÓN SOBRE EL CABALLO"
  },
  {
    "codigo":43217004,
    "descripcion":"DEFICIENCIA HEREDITARIA DE FACTOR XII"
  },
  {
    "codigo":403665005,
    "descripcion":"ULCERACIÓN BUCAL MEDICAMENTOSA"
  },
  {
    "codigo":15986751000119101,
    "descripcion":"ANOMALÍA CONGÉNITA DE RETINA DE OJO IZQUIERDO"
  },
  {
    "codigo":300680004,
    "descripcion":"DIFICULTAD PARA CRUZAR POR PASO A NIVEL"
  },
  {
    "codigo":205222002,
    "descripcion":"AGENESIA DE PRIMER METATARSIANO"
  },
  {
    "codigo":762278005,
    "descripcion":"TRASTORNO DE HÍGADO DEBIDO A TRASTORNO DEL METABOLISMO DE AMINOÁCIDOS"
  },
  {
    "codigo":237990007,
    "descripcion":"UBIQUINONA DESHIDROGENASA"
  },
  {
    "codigo":8614008,
    "descripcion":"FATIGA VOCAL"
  },
  {
    "codigo":301691002,
    "descripcion":"DIFICULTAD PARA RODAR EN LA CAMA"
  },
  {
    "codigo":39547005,
    "descripcion":"ENTESOPATÍA DE LA RODILLA"
  },
  {
    "codigo":399995006,
    "descripcion":"NEVO EPIDÉRMICO INFLAMATORIO VERRUGOSO LINEAL"
  },
  {
    "codigo":267088000,
    "descripcion":"SE ADORMECE"
  },
  {
    "codigo":365392000,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD DE REALIZAR ACTIVIDADES LABORALES"
  },
  {
    "codigo":201552002,
    "descripcion":"ARTRITIS DE TOBILLO Y\/O PIE POSTERIOR A HELMINTIASIS"
  },
  {
    "codigo":72315009,
    "descripcion":"MIOSITIS POR CUERPOS DE INCLUSIÓN"
  },
  {
    "codigo":398160004,
    "descripcion":"BLOQUEO EN PARCHES DE LA CONDUCCIÓN NERVIOSA SENSORIAL"
  },
  {
    "codigo":37712007,
    "descripcion":"INTOXICACIÓN POR POLIURETANO"
  },
  {
    "codigo":299856007,
    "descripcion":"REFLEJO SACRO AUSENTE"
  },
  {
    "codigo":429093006,
    "descripcion":"ESTADO NEUROVASCULAR ANORMAL DE PORCIÓN DISTAL DE UN MIEMBRO"
  },
  {
    "codigo":396325007,
    "descripcion":"TRASTORNO DEGENERATIVO DE LA PIEL"
  },
  {
    "codigo":3109008,
    "descripcion":"DISTIMIA SECUNDARIA DE INICIO TEMPRANO"
  },
  {
    "codigo":196047000,
    "descripcion":"NEUMONITIS AGUDA POR RADIACIÓN"
  },
  {
    "codigo":230650009,
    "descripcion":"NEUROMA TRAUMÁTICO"
  },
  {
    "codigo":34042008,
    "descripcion":"HIPERQUERATOSIS FOLICULAR PENETRANTE CUTÁNEA"
  },
  {
    "codigo":425423002,
    "descripcion":"DOLOR PROVOCADO POR MOVIMIENTO"
  },
  {
    "codigo":294351008,
    "descripcion":"ALERGIA A NISTATINA"
  },
  {
    "codigo":185011009,
    "descripcion":"INFORME DE PENSIONES DE GUERRA SOLICITADO"
  },
  {
    "codigo":292516000,
    "descripcion":"REACCIÓN ADVERSA A LA LOFEXIDINA"
  },
  {
    "codigo":63140003,
    "descripcion":"SUPURACIÓN AGUDA DE SENO ETMOIDAL"
  },
  {
    "codigo":716665002,
    "descripcion":"INSUFICIENCIA CRÓNICA DEL INTESTINO DELGADO"
  },
  {
    "codigo":290681002,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR METOTREXATO"
  },
  {
    "codigo":11782361000119107,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN DE RODILLA DERECHA"
  },
  {
    "codigo":369011000119102,
    "descripcion":"INFECCIÓN DE LA VÍA URINARIA CAUSADA POR PSEUDOMONAS"
  },
  {
    "codigo":94073009,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL ESTERNÓN"
  },
  {
    "codigo":126841009,
    "descripcion":"NEOPLASIA DEL ÁNGULO HEPÁTICO DEL COLON"
  },
  {
    "codigo":714830003,
    "descripcion":"INCAPAZ DE ACORDAR CON EL PLAN DE ATENCIÓN"
  },
  {
    "codigo":92238001,
    "descripcion":"NEOPLASIA BENIGNA DEL MIOCARDIO"
  },
  {
    "codigo":681124211000119103,
    "descripcion":"DERIVACIÓN VENTRICULOPERITONEAL CON VÁLVULA PROGRAMABLE IN SITU"
  },
  {
    "codigo":1306489008,
    "descripcion":"CARCINOMA DUCTAL INFILTRANTE PRIMARIO DE CUADRANTE INFERIOR INTERNO DE MAMA DERECHA"
  },
  {
    "codigo":254243001,
    "descripcion":"MANCHA EN HOJA DE FRESNO, ESCLEROSIS TUBEROSA"
  },
  {
    "codigo":24867002,
    "descripcion":"INSUFICIENCIA SUPRARRENAL SEVERA"
  },
  {
    "codigo":450851004,
    "descripcion":"UTILIZA DIAFRAGMA ANTICONCEPTIVO"
  },
  {
    "codigo":285176005,
    "descripcion":"CAPAZ DE RECONOCER EL ENTORNO"
  },
  {
    "codigo":449016005,
    "descripcion":"VENA HEPÁTICA A AURÍCULA IZQUIERDA Y AURÍCULA DERECHA"
  },
  {
    "codigo":711160007,
    "descripcion":"DEFICIENCIA DE EOSINÓFILO PEROXIDASA"
  },
  {
    "codigo":283341002,
    "descripcion":"PICADURA DE INSECTO EN EL DORSO DEL PIE"
  },
  {
    "codigo":21197006,
    "descripcion":"EFECTO TÓXICO DEL CIANURO DE POTASIO"
  },
  {
    "codigo":19362000,
    "descripcion":"LARVA MIGRATORIA CUTÁNEA"
  },
  {
    "codigo":1297314004,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE QUINTO DEDO DE PIE DERECHO"
  },
  {
    "codigo":281506007,
    "descripcion":"LUXACIÓN DE LA ARTICULACIÓN SUBASTRAGALINA"
  },
  {
    "codigo":707490009,
    "descripcion":"CARCINOMA VERRUGOSO PRIMARIO DE HIPOFARINGE"
  },
  {
    "codigo":17527002,
    "descripcion":"CABALGAMIENTO DE LOS HUESOS DEL CRÁNEO"
  },
  {
    "codigo":1229943004,
    "descripcion":"SÍNDROME SIMILAR A PRADER WILLI ASOCIADO AL GEN SIM1"
  },
  {
    "codigo":115831004,
    "descripcion":"JK"
  },
  {
    "codigo":246903009,
    "descripcion":"INFILTRACIÓN DIFUSA DE LA CONJUNTIVA PALPEBRAL"
  },
  {
    "codigo":1079821000119106,
    "descripcion":"CARCINOMA DUCTAL IN SITU DE MAMA DERECHA"
  },
  {
    "codigo":15692007,
    "descripcion":"POSICIÓN FRONTOILÍACA DERECHA TRANSVERSA"
  },
  {
    "codigo":212300008,
    "descripcion":"LESIÓN ABIERTA, NERVIO INTERÓSEO ANTERIOR"
  },
  {
    "codigo":1259041001,
    "descripcion":"SÍNDROME DE COLA DE CABALLO DEBIDO A PROCEDIMIENTO Y POSTERIOR A ÉL"
  },
  {
    "codigo":342541000119107,
    "descripcion":"DERMATITIS ECCEMATOSA DE PÁRPADO DERECHO"
  },
  {
    "codigo":13857004,
    "descripcion":"INTOXICACIÓN POR TALIDOMIDA"
  },
  {
    "codigo":700150001,
    "descripcion":"DEFICIENCIA CONGÉNITA DE LEPTINA"
  },
  {
    "codigo":274166008,
    "descripcion":"LACERACIÓN DE CUERO CABELLUDO"
  },
  {
    "codigo":1157067003,
    "descripcion":"NEOPLASIA MALIGNA VERTEBRAL"
  },
  {
    "codigo":403403005,
    "descripcion":"COLAGENOMA PERFORANTE VERRUGOSO"
  },
  {
    "codigo":237728000,
    "descripcion":"AUSENCIA DE OSMORREGULACIÓN"
  },
  {
    "codigo":1351840003,
    "descripcion":"SÍNDROME DE BROWN-SÉQUARD CAUSADO POR RADIACIÓN"
  },
  {
    "codigo":152231000119106,
    "descripcion":"EMBARAZO NO CONFIRMADO AÚN"
  },
  {
    "codigo":1153397003,
    "descripcion":"LINFOMA CUTÁNEO DE LINFOCITOS T SIMILAR A HIDROA VACCINIFORME"
  },
  {
    "codigo":37450000,
    "descripcion":"CUERPO EXTRAÑO EN LA CÓRNEA"
  },
  {
    "codigo":365130001,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA ACOSTARSE EN LA CAMA"
  },
  {
    "codigo":268661009,
    "descripcion":"TRASTORNO DE CONDUCTA ANTISOCIAL NO AGRESIVA"
  },
  {
    "codigo":70218004,
    "descripcion":"DESPLAZAMIENTO DE DISCO INTERVERTEBRAL, SIN MIELOPATÍA"
  },
  {
    "codigo":68383000,
    "descripcion":"INFECCIÓN CAUSADA POR ECHINOPARYPHIUM"
  },
  {
    "codigo":234058009,
    "descripcion":"VENAS GENITALES VARICOSAS EN EL EMBARAZO"
  },
  {
    "codigo":201290009,
    "descripcion":"LEUCODERMIA ESTIVAL"
  },
  {
    "codigo":232223003,
    "descripcion":"OTITIS EXTERNA AGUDA DE ORIGEN MICÓTICO"
  },
  {
    "codigo":164852001,
    "descripcion":"ECG AMBULATORIO ANORMAL"
  },
  {
    "codigo":230388003,
    "descripcion":"EPILEPSIA VISUAL OCCIPITAL DE LA INFANCIA"
  },
  {
    "codigo":721908003,
    "descripcion":"DISTENSIÓN DE MÚSCULO DE PARED ANTERIOR DEL TÓRAX"
  },
  {
    "codigo":263156006,
    "descripcion":"FRACTURA DE MAXILAR SUPERIOR"
  },
  {
    "codigo":295924008,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE PAROXETINA"
  },
  {
    "codigo":294089005,
    "descripcion":"ALERGIA A PROCICLIDINA"
  },
  {
    "codigo":1082331000119102,
    "descripcion":"NEFROBLASTOMA DE RIÑÓN DERECHO"
  },
  {
    "codigo":31945009,
    "descripcion":"PELVIS CIFÓTICA"
  },
  {
    "codigo":292254001,
    "descripcion":"REACCIÓN ADVERSA AL DIMETILSULFÓXIDO"
  },
  {
    "codigo":1176990003,
    "descripcion":"PANUVEÍTIS FÚNGICA"
  },
  {
    "codigo":95646004,
    "descripcion":"DEGENERACIÓN CEREBELOSA"
  },
  {
    "codigo":783774006,
    "descripcion":"SÍNDROME DE ATRESIA DE CONDUCTO AUDITIVO EXTERNO, ASTRÁGALO VERTICAL E HIPERTELORISMO"
  },
  {
    "codigo":62878007,
    "descripcion":"ATROFIA DE LAS ENCÍAS"
  },
  {
    "codigo":193950006,
    "descripcion":"TRASTORNO SENSITIVO DEL PÁRPADO"
  },
  {
    "codigo":716403002,
    "descripcion":"CAPAZ DE DIVIDIR LA ATENCIÓN"
  },
  {
    "codigo":126579006,
    "descripcion":"NEOPLASIA DE HUESO METACARPIANO"
  },
  {
    "codigo":91976000,
    "descripcion":"NEOPLASIA BENIGNA DE LA PARED ANTERIOR DE LA NASOFARINGE"
  },
  {
    "codigo":26440003,
    "descripcion":"SABOR VOLTAICO"
  },
  {
    "codigo":288584003,
    "descripcion":"NO EMPLEA LA COMUNICACIÓN NO VERBAL"
  },
  {
    "codigo":57373003,
    "descripcion":"TRANSFORMACIÓN MIXOIDE DE VÁLVULA CARDÍACA"
  },
  {
    "codigo":712733005,
    "descripcion":"LESIÓN TRAUMÁTICA DE PAPILA ÓPTICA"
  },
  {
    "codigo":1237021005,
    "descripcion":"CON RIESGO ELEVADO DE EXPOSICIÓN A VIRUS DE LA ENCEFALITIS EUROPEA TRANSMITIDA POR GARRAPATA"
  },
  {
    "codigo":188445006,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE PERITONEO Y RETROPERITONEO"
  },
  {
    "codigo":286749006,
    "descripcion":"NIVEL MODERADO DE EGOCENTRISMO"
  },
  {
    "codigo":219378001,
    "descripcion":"HERIDA DE GUERRA POR BALA DE RIFLE"
  },
  {
    "codigo":284914006,
    "descripcion":"INCAPAZ DE USAR PALANGANA"
  },
  {
    "codigo":446919000,
    "descripcion":"LACERACIÓN SUPERFICIAL DE MUSLO"
  },
  {
    "codigo":53703001,
    "descripcion":"MIOCARDIOPATÍA ENDOMIOCÁRDICA EOSINÓFILA PRIMARIA"
  },
  {
    "codigo":283079003,
    "descripcion":"ARAÑAZO DE BRAZO"
  },
  {
    "codigo":250311007,
    "descripcion":"HALLAZGO RELACIONADO CON LAS PLAQUETAS"
  },
  {
    "codigo":838300000,
    "descripcion":"ESCLERÓTICAS AZULES DE AMBOS OJOS"
  },
  {
    "codigo":248476003,
    "descripcion":"HEDOR URÉMICO"
  },
  {
    "codigo":215708007,
    "descripcion":"LESIÓN SUFRIDA A BORDO DE MEDIO DE TRANSPORTE ACUÁTICO CAUSADA POR MAQUINARIA DE CUBIERTA, OCUPANTE DE PEQUEÑA EMBARCACIÓN MOTORIZADA LESIONADO"
  },
  {
    "codigo":246641000,
    "descripcion":"PERCEPCIÓN DE LUCES EN EL CAMPO VISUAL"
  },
  {
    "codigo":51868009,
    "descripcion":"ÚLCERA DEL DUODENO"
  },
  {
    "codigo":410481000,
    "descripcion":"PANUVEÍTIS EN EL SÍNDROME DE BEHCET"
  },
  {
    "codigo":1295217007,
    "descripcion":"MIXOMA CELULAR"
  },
  {
    "codigo":212038000,
    "descripcion":"QUEMADURA POR AGENTES CORROSIVOS DE LARINGE Y TRÁQUEA"
  },
  {
    "codigo":408646000,
    "descripcion":"ADENOCARCINOMA HEPÁTICO"
  },
  {
    "codigo":310342002,
    "descripcion":"MARGEN DE RESECCIÓN LIBRE"
  },
  {
    "codigo":15965301000119109,
    "descripcion":"TORSIÓN ADQUIRIDA DE PENE"
  },
  {
    "codigo":277574007,
    "descripcion":"LEUCEMIA LINFOBLÁSTICA AGUDA DE CÉLULAS NULAS"
  },
  {
    "codigo":767259000,
    "descripcion":"PROTRUSIÓN DE LABIO SUPERIOR"
  },
  {
    "codigo":1162310008,
    "descripcion":"ESCOLIOSIS DEBIDA A LESIÓN TRAUMÁTICA Y POSTERIOR A ELLA"
  },
  {
    "codigo":210203000,
    "descripcion":"LESIÓN EXPUESTA DE RIÑÓN"
  },
  {
    "codigo":13595002,
    "descripcion":"TORSIÓN DE OVARIO"
  },
  {
    "codigo":292111000119104,
    "descripcion":"TRASTORNO DE NERVIO PERONEO PROFUNDO IZQUIERDO"
  },
  {
    "codigo":111899005,
    "descripcion":"ASPERGILOSIS CUTÁNEA"
  },
  {
    "codigo":275739007,
    "descripcion":"AMILASA SÉRICA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":110064003,
    "descripcion":"LACERACIÓN COMPLEJA DEL PABELLÓN AURICULAR"
  },
  {
    "codigo":77296004,
    "descripcion":"INFARTO DE LA MAMA"
  },
  {
    "codigo":698053001,
    "descripcion":"HIPOMINERALIZACIÓN DE INCISIVO MOLAR"
  },
  {
    "codigo":15748521000119101,
    "descripcion":"RIGIDEZ BILATERAL DE MÚSCULOS GEMELOS"
  },
  {
    "codigo":1156805003,
    "descripcion":"ENFERMEDAD DE CASTLEMAN MULTICÉNTRICA"
  },
  {
    "codigo":403141006,
    "descripcion":"PICADURA DE HORMIGA"
  },
  {
    "codigo":237466001,
    "descripcion":"HIPERTROFIA DE LA GLÁNDULA DE MONTGOMERY"
  },
  {
    "codigo":8090002,
    "descripcion":"GRANULOMA EOSINOFÍLICO DE LA MUCOSA ORAL"
  },
  {
    "codigo":10859791000119109,
    "descripcion":"ASPIRACIÓN DE CONTENIDO GÁSTRICO HACIA VÍA RESPIRATORIA"
  },
  {
    "codigo":399471000,
    "descripcion":"VESÍCULA SEMINAL COMPROMETIDA POR EXTENSIÓN DIRECTA DE NEOPLASIA MALIGNA"
  },
  {
    "codigo":366703005,
    "descripcion":"AMPLITUD DE MOVIMIENTO DE ARTICULACIÓN DE DEDO DEL PIE - HALLAZGO"
  },
  {
    "codigo":301167007,
    "descripcion":"PULSO FEMORAL AUSENTE"
  },
  {
    "codigo":202863007,
    "descripcion":"TENDINITIS DE ADUCTOR"
  },
  {
    "codigo":235631007,
    "descripcion":"TRASTORNO CRICOFARÍNGEO"
  },
  {
    "codigo":430404002,
    "descripcion":"ABSCESO DE MÉDULA ESPINAL CAUSADO POR HISTOPLASMA"
  },
  {
    "codigo":39023007,
    "descripcion":"ÚLCERA CRÓNICA DEL CUERPO CAVERNOSO"
  },
  {
    "codigo":266564004,
    "descripcion":"ABSCESO URETRAL Y PERIURETRAL"
  },
  {
    "codigo":364868005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA AGACHARSE"
  },
  {
    "codigo":168260004,
    "descripcion":"POSTMORTEM - VIRUS AISLADOS"
  },
  {
    "codigo":69956002,
    "descripcion":"INTOXICACIÓN CAUSADA POR AGENTE ORGANOFOSFORADO ANTICOLINESTERASA"
  },
  {
    "codigo":166425000,
    "descripcion":"HORMONAS FETOPLACENTARIAS DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":233796006,
    "descripcion":"ESTENOSIS BRONQUIAL ADQUIRIDA"
  },
  {
    "codigo":2585002,
    "descripcion":"PLEURESÍA NEUMOCÓCICA"
  },
  {
    "codigo":789017006,
    "descripcion":"RADICULOPATÍA DEBIDA A TRASTORNO DE DISCO INTERVETEBRAL"
  },
  {
    "codigo":347561000119108,
    "descripcion":"CATARATA POLAR SUBCAPSULAR POSTERIOR SENIL DE AMBOS OJOS"
  },
  {
    "codigo":321091000119102,
    "descripcion":"ESTENOSIS DE CONDUCTO VERTEBRAL DE REGIÓN CERVICOTORÁCICA DE COLUMNA VERTEBRAL"
  },
  {
    "codigo":231961009,
    "descripcion":"CUERPO EXTRAÑO EN EL CUERPO CILIAR"
  },
  {
    "codigo":819950002,
    "descripcion":"SÍNDROME DE RESISTENCIA GENERALIZADA A GLUCOCORTICOIDES"
  },
  {
    "codigo":787182003,
    "descripcion":"TRICHOPHYTON MENTAGROPHYTES O TRICHOPHYTON RUBRUM"
  },
  {
    "codigo":361198004,
    "descripcion":"ARTRITIS SARCOIDÓTICA"
  },
  {
    "codigo":262894003,
    "descripcion":"RUPTURA DE PELVIS RENAL"
  },
  {
    "codigo":230126006,
    "descripcion":"HALLAZGO RELACIONADO CON LA ALIMENTACIÓN DEL LACTANTE"
  },
  {
    "codigo":1084841000119109,
    "descripcion":"COLANGITIS AGUDA DEBIDA A CÁLCULO DE CONDUCTO BILIAR CON OBSTRUCCIÓN"
  },
  {
    "codigo":721646008,
    "descripcion":"DIVERTICULITIS CONGÉNITA DE INTESTINO DELGADO"
  },
  {
    "codigo":719811001,
    "descripcion":"DISCAPACIDAD INTELECTUAL LIGADA AL CROMOSOMA X TIPO CABEZAS"
  },
  {
    "codigo":750009,
    "descripcion":"INFECCIÓN POR SCHISTOSOMA MANSONI"
  },
  {
    "codigo":293827003,
    "descripcion":"ALERGIA A TRIMIPRAMINA"
  },
  {
    "codigo":457667005,
    "descripcion":"RUPTURA DE ANILLO DE VÁLVULA PULMONAR"
  },
  {
    "codigo":423064000,
    "descripcion":"INFECCIÓN DE PARTES BLANDAS DE LA COLUMNA VERTEBRAL LUMBAR"
  },
  {
    "codigo":228291008,
    "descripcion":"BEBE EN LUGARES PERMITIDOS"
  },
  {
    "codigo":95384003,
    "descripcion":"EXTRAVASACIÓN DEL SITIO DE INYECCIÓN"
  },
  {
    "codigo":29848003,
    "descripcion":"INTOXICACIÓN POR TAXUS CUSPIDATA"
  },
  {
    "codigo":128152005,
    "descripcion":"SOPLO CARDÍACO, CATEGORIZADO POR LA DURACIÓN"
  },
  {
    "codigo":160920006,
    "descripcion":"TRABAJA LEJOS DEL HOGAR"
  },
  {
    "codigo":291992008,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR DIGOXINA"
  },
  {
    "codigo":781677003,
    "descripcion":"PROPENSIÓN A REACCIÓN ADVERSA AL POTASIO"
  },
  {
    "codigo":191853003,
    "descripcion":"DEPENDENCIA DE ASPIRACIÓN DE PEGAMENTOS"
  },
  {
    "codigo":93549004,
    "descripcion":"SARCOMA DE HODGKIN DE GANGLIOS LINFÁTICOS INTRATORÁCICOS"
  },
  {
    "codigo":290157008,
    "descripcion":"INTOXICACIÓN POR ANÁLOGOS DE LA METADONA"
  },
  {
    "codigo":188183000,
    "descripcion":"NEOPLASIA MALIGNA DEL MUÑÓN CERVICAL"
  },
  {
    "codigo":1269527001,
    "descripcion":"SÍNDROME DE CORDÓN CENTRAL DE MÉDULA CERVICAL DEBIDO A LUXACIÓN NO EXPUESTA DE COLUMNA CERVICAL"
  },
  {
    "codigo":778007004,
    "descripcion":"SÍNDROME DE MICRODELECIÓN 12P12.1"
  },
  {
    "codigo":286487004,
    "descripcion":"DIFICULTAD PARA MEZCLAR INGREDIENTES DE UNA COMIDA"
  },
  {
    "codigo":253719006,
    "descripcion":"ARTERIA CIRCUNFLEJA QUE TRANSCURRE POR DETRÁS DE LA AORTA"
  },
  {
    "codigo":22508003,
    "descripcion":"INSUFICIENCIA HEPÁTICA DEBIDA A PROCEDIMIENTO"
  },
  {
    "codigo":415724006,
    "descripcion":"AMIGDALITIS CAUSADA POR BACTERIAS GRAMNEGATIVAS"
  },
  {
    "codigo":250049001,
    "descripcion":"MARCHA EN PEQUEÑOS PASOS"
  },
  {
    "codigo":446657003,
    "descripcion":"DISCORDANCIA AURICULOVENTRICULAR CON ROTACIÓN HACIA LA DERECHA"
  },
  {
    "codigo":20673009,
    "descripcion":"TRASTORNO DEL TIMO"
  },
  {
    "codigo":315585009,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: SWAHILI"
  },
  {
    "codigo":1296790003,
    "descripcion":"RETINOPATÍA CAUSADA POR PENTOSANO POLISULFATO"
  },
  {
    "codigo":53441009,
    "descripcion":"FRACTURAS MÚLTIPLES NO EXPUESTAS DE EXTREMIDAD INFERIOR Y COSTILLAS"
  },
  {
    "codigo":248214007,
    "descripcion":"ASPECTO ICTÉRICO DE LA CARA"
  },
  {
    "codigo":280982009,
    "descripcion":"PATRÓN DE USO NOCIVO DE LAXANTE"
  },
  {
    "codigo":770667002,
    "descripcion":"DISTROFIA MACULAR OCULTA"
  },
  {
    "codigo":705131003,
    "descripcion":"NIÑO CON MAYOR RIESGO DE SOBREPESO, ÍNDICE DE MASA CORPORAL POR ENCIMA DE PERCENTILO 85"
  },
  {
    "codigo":211776001,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO SUPERFICIAL DE DORSO (GLÚTEO EXCLUIDO)"
  },
  {
    "codigo":703296002,
    "descripcion":"INSUFICIENCIA AGUDA DE VÁLVULA TRICÚSPIDE PROTÉSICA"
  },
  {
    "codigo":408384004,
    "descripcion":"CONTROL DE RETINOPATÍA DIABÉTICA DE LOS 12 MESES"
  },
  {
    "codigo":47936004,
    "descripcion":"INFECCIÓN CAUSADA POR CYSTICERCUS FASCIOLARIS"
  },
  {
    "codigo":1260352009,
    "descripcion":"DEMENCIA FRONTOTEMPORAL DEBIDA A MUTACIÓN TARDBP"
  },
  {
    "codigo":275477002,
    "descripcion":"GLAUCOMA DEBIDO A QUISTE OCULAR"
  },
  {
    "codigo":625544171000132109,
    "descripcion":"TRASTORNO DE STENT PANCREÁTICO"
  },
  {
    "codigo":13333006,
    "descripcion":"REGIÓN DE TERMINACIÓN GENÉTICA"
  },
  {
    "codigo":46101007,
    "descripcion":"HIPEREXTENSIÓN DE LA RODILLA, ADQUIRIDA"
  },
  {
    "codigo":109802000,
    "descripcion":"ABSCESO DE LA ÚVULA PALATINA"
  },
  {
    "codigo":111637008,
    "descripcion":"FRACTURA EXPUESTA DE CLAVÍCULA"
  },
  {
    "codigo":240874007,
    "descripcion":"LARVA MIGRANS VISCERAL POR GNATHOSTOMA"
  },
  {
    "codigo":370111000,
    "descripcion":"CONFIGURACIÓN TUMORAL"
  },
  {
    "codigo":75199002,
    "descripcion":"CUERPO EXTRAÑO ANTIGUO RETENIDO, LUEGO DE HERIDA PENETRANTE DE ÓRBITA"
  },
  {
    "codigo":323601000119104,
    "descripcion":"TUMOR TENOSINOVIAL DIFUSO DE CÉLULAS GIGANTES DE MANO IZQUIERDA"
  },
  {
    "codigo":271807003,
    "descripcion":"ERUPCIÓN CUTÁNEA"
  },
  {
    "codigo":15724561000119104,
    "descripcion":"CHASQUIDO DE AMBAS CADERAS"
  },
  {
    "codigo":1254847003,
    "descripcion":"NEOPLASIA MESENQUIMATOSA PRIMARIA MALIGNA DE APÉNDICE"
  },
  {
    "codigo":402879006,
    "descripcion":"INFILTRACIÓN LEUCÉMICA DE CÉLULAS T DE LA PIEL"
  },
  {
    "codigo":1287615008,
    "descripcion":"CRISIS EPILÉPTICA SOLO ELECTROGRÁFICA DE INICIO FOCAL NEONATAL"
  },
  {
    "codigo":69811008,
    "descripcion":"COROIDITIS Y CORIORRETINITIS PERIFÉRICA DISEMINADA"
  },
  {
    "codigo":106132005,
    "descripcion":"HALLAZGO RELACIONADO CON EL HABLA"
  },
  {
    "codigo":366441002,
    "descripcion":"AMPLITUD DE LA ROTACIÓN DERECHA DE COLUMNA LUMBAR - HALLAZGO"
  },
  {
    "codigo":202601009,
    "descripcion":"CHASQUIDO DE ARTICULACIÓN RADIOCUBITAL DISTAL"
  },
  {
    "codigo":200766001,
    "descripcion":"PARAQUERATOSIS"
  },
  {
    "codigo":169833009,
    "descripcion":"TRILLIZOS - UNO NACIDO VIVO Y DOS MORTINATOS"
  },
  {
    "codigo":167998005,
    "descripcion":"ESPUTO: CÉLULAS MALIGNAS"
  },
  {
    "codigo":102462006,
    "descripcion":"INTOLERANCIA DISMINUIDA"
  },
  {
    "codigo":299070008,
    "descripcion":"AMPLITUD DE FLEXIÓN PASIVA DE DEDO DE LA MANO NORMAL"
  },
  {
    "codigo":264467005,
    "descripcion":"TENDÓN FALSO - CORAZÓN"
  },
  {
    "codigo":47971000087102,
    "descripcion":"FRACTURA DE DIÁFISIS DE CÚBITO IZQUIERDO"
  },
  {
    "codigo":297235006,
    "descripcion":"ACIDURIA 3-METILGLUTACÓNICA NO CLASIFICADA"
  },
  {
    "codigo":262632000,
    "descripcion":"ABRASIÓN DE SUPERFICIE INTRABUCAL DE LABIO"
  },
  {
    "codigo":10946731000119105,
    "descripcion":"AVULSIÓN DE UNIDAD UNGUEAL DE DEDO ÍNDICE DERECHO"
  },
  {
    "codigo":40291000087106,
    "descripcion":"DISTENSIÓN DE TENDÓN DE ADUCTOR DE CADERA DERECHA"
  },
  {
    "codigo":488007,
    "descripcion":"MIOCARDITIS FIBROIDE"
  },
  {
    "codigo":162493000,
    "descripcion":"SÍNTOMA SIN PATRÓN ESPECÍFICO"
  },
  {
    "codigo":64189001,
    "descripcion":"INTOXICACIÓN POR ARSINA"
  },
  {
    "codigo":295400008,
    "descripcion":"SOBREDOSIS DE FÁRMACO ANTIDIARREICO"
  },
  {
    "codigo":293565001,
    "descripcion":"REACCIÓN ADVERSA A LA TIMOXAMINA"
  },
  {
    "codigo":721384009,
    "descripcion":"SÍNDROME DEL CORDÓN ANTERIOR DE MÉDULA ESPINAL AL NIVEL DEL CUARTO SEGMENTO CERVICAL"
  },
  {
    "codigo":226194001,
    "descripcion":"DIETA DE ELIMINACIÓN"
  },
  {
    "codigo":95122005,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA COLA DEL PÁNCREAS"
  },
  {
    "codigo":783250007,
    "descripcion":"TROMBOFILIA HEREDITARIA DEBIDA A DEFICIENCIA CONGÉNITA DE GLICOPROTEÍNA (POLI-L) RICA EN HISTIDINA"
  },
  {
    "codigo":160658008,
    "descripcion":"DISPUESTO A DONAR SU CUERPO"
  },
  {
    "codigo":1141863003,
    "descripcion":"ESPASMO INTERMITENTE DOLOROSO DE MÚSCULO"
  },
  {
    "codigo":352581000119104,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE TESTÍCULO DERECHO DESCENDIDO"
  },
  {
    "codigo":289895005,
    "descripcion":"SIN MENSTRUACIÓN EN LA ACTUALIDAD"
  },
  {
    "codigo":93287006,
    "descripcion":"HIPOPLASIA CONGÉNITA DE VÁLVULA PULMONAR"
  },
  {
    "codigo":1303868000,
    "descripcion":"SÍNDROME DE RETRASO DE DESARROLLO, EPILEPSIA Y DIABETES NEONATAL, FORMA INTERMEDIA"
  },
  {
    "codigo":58684001,
    "descripcion":"PARASITOSIS INTRAERITROCÍTICA CAUSADA POR ENTOPOLYPOIDES"
  },
  {
    "codigo":124220008,
    "descripcion":"DEFICIENCIA DE ESTEROIDE 17 - ALFA - MONOOXIGENASA"
  },
  {
    "codigo":187921002,
    "descripcion":"TRASTORNO DEL LENGUAJE RECEPTIVO EN EL DESARROLLO"
  },
  {
    "codigo":286225007,
    "descripcion":"INCAPAZ DE USAR EL FLUJO DE AIRE GLÓTICO AL HABLAR"
  },
  {
    "codigo":253457007,
    "descripcion":"DISPLASIA DE VÁLVULA AURICULOVENTRICULAR DERECHA"
  },
  {
    "codigo":12204511000119103,
    "descripcion":"POSICIÓN ANÓMALA DE PRÓTESIS DE PENE"
  },
  {
    "codigo":1300198006,
    "descripcion":"SÍNDROME DE BLEFAROFIMOSIS, DISCAPACIDAD INTELECTUAL ASOCIADO A UN REGULADOR DE CROMATINA DEPENDIENTE DE ACTINA, SUBFAMILIA A, MIEMBRO 2, ASOCIADO A SWI\/SNF"
  },
  {
    "codigo":282555001,
    "descripcion":"DOBLA ESQUINAS AL CORRER"
  },
  {
    "codigo":249787003,
    "descripcion":"ACORTAMIENTO APARENTE DE PIERNA"
  },
  {
    "codigo":446395003,
    "descripcion":"LACERACIÓN SUPERFICIAL DE CODO"
  },
  {
    "codigo":184251008,
    "descripcion":"REGISTRO DE MOVIMIENTOS FETALES - VERIFICADO"
  },
  {
    "codigo":444560000,
    "descripcion":"SANGRADO UTERINO DISFUNCIONAL OLIGOOVULATORIO"
  },
  {
    "codigo":1296528004,
    "descripcion":"FIBROSIS QUÍSTICA DEBIDA A MUTACIÓN HOMOCIGOTA DELTAF508"
  },
  {
    "codigo":870544005,
    "descripcion":"OCLUSIÓN DE ARTERIA BASILAR DISTAL"
  },
  {
    "codigo":18576006,
    "descripcion":"ENCOPRESIS FUNCIONAL PRIMARIA"
  },
  {
    "codigo":1263760008,
    "descripcion":"HEMATOMA DE TOBILLO"
  },
  {
    "codigo":770405003,
    "descripcion":"EPILEPSIA FAMILIAR DEL LÓBULO TEMPORAL MESIAL"
  },
  {
    "codigo":16054751000119108,
    "descripcion":"ESOTROPÍA INFANTIL DE OJO IZQUIERDO"
  },
  {
    "codigo":735802000,
    "descripcion":"HERIDA PUNZANTE DE BRAZO SIN CUERPO EXTRAÑO"
  },
  {
    "codigo":703034006,
    "descripcion":"CITROBACTER KOSERI O CITROBACTER FARMERI"
  },
  {
    "codigo":1260090009,
    "descripcion":"CARCINOMA LINFOEPITELIAL DE LARINGE"
  },
  {
    "codigo":78607009,
    "descripcion":"TUMOR EPITELIAL DE OVARIO, ESTADIO II DE LA FIGO"
  },
  {
    "codigo":109540007,
    "descripcion":"FALLA DE EXFOLIACIÓN ASOCIADA CON FALTA DE DIENTE SUCEDÁNEO"
  },
  {
    "codigo":402617001,
    "descripcion":"HIPERMELANOSIS ADQUIRIDA CIRCUNSCRIPTA"
  },
  {
    "codigo":304313006,
    "descripcion":"AMPLITUD DE MOVIMIENTO DE PULGAR DISMINUIDA"
  },
  {
    "codigo":763065008,
    "descripcion":"VARIANTE DE ATAXIA TELANGIECTASIA"
  },
  {
    "codigo":1285518004,
    "descripcion":"SÍNDROME DE WOLFRAM TIPO 1"
  },
  {
    "codigo":1092371000119103,
    "descripcion":"PIELONEFRITIS POR SALMONELLA"
  },
  {
    "codigo":1252750008,
    "descripcion":"LACERACIÓN DE VENA RENAL"
  },
  {
    "codigo":890467001,
    "descripcion":"INGESTA EXCESIVA DE POTASIO"
  },
  {
    "codigo":235107001,
    "descripcion":"DESPLAZAMIENTO MANDIBULAR"
  },
  {
    "codigo":300643005,
    "descripcion":"NO MANEJA UNA MOTOCICLETA"
  },
  {
    "codigo":398947009,
    "descripcion":"AGUDEZA VISUAL DE OJO DERECHO-CORREGIDA"
  },
  {
    "codigo":724792002,
    "descripcion":"SÍNDROME MEDULAR DORSAL INCOMPLETO"
  },
  {
    "codigo":36664002,
    "descripcion":"INTENTO FALLIDO DE ABORTO CON EMBOLIA GASEOSA"
  },
  {
    "codigo":2061000,
    "descripcion":"PÉRDIDA DE AUDICIÓN CONDUCTIVA EN SITIOS COMBINADOS"
  },
  {
    "codigo":1148941002,
    "descripcion":"RETENCIÓN DE PARTE DE LA PLACENTA Y MEMBRANA UTERINA SIN HEMORRAGIA"
  },
  {
    "codigo":722957003,
    "descripcion":"TRASTORNO LINFOPROLIFERATIVO CON HIPERPLASIA PLASMACÍTICA REACTIVA POSTRASPLANTE"
  },
  {
    "codigo":661691000124108,
    "descripcion":"INFLAMACIÓN DE ARTICULACIÓN DE REGIÓN DE HOMBRO DERECHO"
  },
  {
    "codigo":231437006,
    "descripcion":"PSICOSIS REACTIVAS"
  },
  {
    "codigo":295138002,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE ANALGÉSICOS NO OPIÁCEOS"
  },
  {
    "codigo":1343714003,
    "descripcion":"HERNIA DE SPIEGEL RECURRENTE"
  },
  {
    "codigo":941000119103,
    "descripcion":"DISTENSIÓN DE RODILLA"
  },
  {
    "codigo":31159001,
    "descripcion":"COLORACIÓN AZULADA DEL CUELLO UTERINO"
  },
  {
    "codigo":293303007,
    "descripcion":"REACCIÓN ADVERSA A LA CALCITONINA (CERDO)"
  },
  {
    "codigo":1208972001,
    "descripcion":"CRISIS EPILÉPTICA MIOCLÓNICA DE INICIO GENERALIZADO"
  },
  {
    "codigo":291468007,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR TIABENDAZOL"
  },
  {
    "codigo":94860009,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE HUESO GANCHOSO"
  },
  {
    "codigo":191329002,
    "descripcion":"FRAGILIDAD CAPILAR HEREDITARIA"
  },
  {
    "codigo":93025007,
    "descripcion":"ANOMALÍA CONGÉNITA DE LA VÉRTEBRA ESTERNAL"
  },
  {
    "codigo":1010529009,
    "descripcion":"ESCLEROSIS DE EPÍFISIS DE FALANGE MEDIA DE TERCER DEDO DE PIE CON RADIOPACIDAD AUMENTADA"
  },
  {
    "codigo":255030002,
    "descripcion":"CARCINOMA MIXTO PAPILAR Y FOLICULAR DE GLÁNDULA TIROIDES"
  },
  {
    "codigo":789043007,
    "descripcion":"SEPSIS SIN CHOQUE SÉPTICO"
  },
  {
    "codigo":23819000,
    "descripcion":"EMBOLIA DE SENO CAVERNOSO VENOSO"
  },
  {
    "codigo":285963003,
    "descripcion":"DIFICULTAD PARA REMOVER EL TAPÓN DE LA PILETA"
  },
  {
    "codigo":187659007,
    "descripcion":"NEOPLASIA MALIGNA DE SURCO BUCAL MAXILAR"
  },
  {
    "codigo":302151000119105,
    "descripcion":"HIPERPLASIA ALVEOLAR DE MAXILAR"
  },
  {
    "codigo":253195009,
    "descripcion":"ARTERIA TRIGEMINAL EMBRIONARIA PERSISTENTE"
  },
  {
    "codigo":449803009,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE CÚPULA VESICAL"
  },
  {
    "codigo":284128004,
    "descripcion":"CAPAZ DE CONTROLAR LA POSICIÓN PÉLVICA"
  },
  {
    "codigo":185824005,
    "descripcion":"CONTROL DE SALUD MASCULINO REALIZADO"
  },
  {
    "codigo":15676641000119100,
    "descripcion":"MIOSITIS DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":251360007,
    "descripcion":"SIN CAMBIOS AUDITIVOS"
  },
  {
    "codigo":447968008,
    "descripcion":"AORTA DESCENDENTE ANTERIOR Y DEL MISMO LADO QUE LA VENA ÁCIGOS CON CONTINUIDAD DE LA VENA CAVA INFERIOR EN LA VENA ÁCIGOS"
  },
  {
    "codigo":20149002,
    "descripcion":"AMPOLLA DE DEDO DE LA MANO, SIN INFECCIÓN"
  },
  {
    "codigo":216757002,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR LEJÍA"
  },
  {
    "codigo":249525006,
    "descripcion":"NO ES CONSCIENTE DEL PASAJE DE MATERIA FECAL"
  },
  {
    "codigo":870282001,
    "descripcion":"TRASTORNO GENERALIZADO DEL DESARROLLO CON ALTERACIÓN SEVERA DEL LENGUAJE FUNCIONAL SIN PÉRDIDA DE HABILIDADES ADQUIRIDAS PREVIAMENTE"
  },
  {
    "codigo":83850008,
    "descripcion":"ACIDOSIS URÉMICA"
  },
  {
    "codigo":409695007,
    "descripcion":"ANTICUERPO ANTI-DENGUE INMUNOGLOBULINA G DETECTADO"
  },
  {
    "codigo":278623007,
    "descripcion":"PACIENTE INCAPAZ DE MASTICAR CON PRÓTESIS DENTAL"
  },
  {
    "codigo":213087009,
    "descripcion":"RESORCIÓN DE AUTOINJERTO ÓSEO"
  },
  {
    "codigo":702772003,
    "descripcion":"INTOLERANCIA AMBIENTAL IDIOPÁTICA"
  },
  {
    "codigo":80180004,
    "descripcion":"DEGENERACIÓN PALIDONIGRAL"
  },
  {
    "codigo":211252005,
    "descripcion":"ABRASIÓN DE PIEL DE ANTEBRAZO"
  },
  {
    "codigo":1259828004,
    "descripcion":"NEOPLASIA PRIMARIA MALIGNA DE VAINA NERVIOSA DE NERVIO PERIFÉRICO DE ABDOMEN"
  },
  {
    "codigo":735540007,
    "descripcion":"ADULTO DE CONSTITUCIÓN DELGADA"
  },
  {
    "codigo":78345002,
    "descripcion":"TROMBOCITOPENIA POR PRODUCCIÓN PLAQUETARIA DISMINUIDA"
  },
  {
    "codigo":897545002,
    "descripcion":"DUPLICACIÓN DISTAL DEL CROMOSOMA 21"
  },
  {
    "codigo":209417005,
    "descripcion":"ESGUINCE DE ARTICULACIÓN DE HOMBRO, ANTERIOR"
  },
  {
    "codigo":274953007,
    "descripcion":"TRASTORNO PSICÓTICO AGUDO POLIMORFO"
  },
  {
    "codigo":404190000,
    "descripcion":"DISCAPACIDAD MÚLTIPLE Y COMPLEJA"
  },
  {
    "codigo":830174000,
    "descripcion":"ALERGIA A OXEDRINA"
  },
  {
    "codigo":240350003,
    "descripcion":"VIBRIÓN COLÉRICO NO-01"
  },
  {
    "codigo":109278005,
    "descripcion":"MELANOMA IN SITU DEL OÍDO"
  },
  {
    "codigo":305886005,
    "descripcion":"ATENDIDO POR SERVICIO DE CIRUGÍA CARDIOTORÁCICA"
  },
  {
    "codigo":43742007,
    "descripcion":"PERICARDITIS ASOCIADA CON ANEMIA CRÓNICA GRAVE"
  },
  {
    "codigo":402355000,
    "descripcion":"ENFERMEDAD DE INJERTO VERSUS HUÉSPED AGUDA"
  },
  {
    "codigo":331131000119103,
    "descripcion":"CATARATA TOTAL TRAUMÁTICA IZQUIERDA"
  },
  {
    "codigo":1156019004,
    "descripcion":"TROMBOSIS DE ARTERIA CEREBELOSA DERECHA"
  },
  {
    "codigo":1092861000119101,
    "descripcion":"FÍSTULA DE INTESTINO DEBIDA A COLITIS ULCEROSA"
  },
  {
    "codigo":683261000119102,
    "descripcion":"NEVO MELANOCÍTICO PIGMENTADO CONGÉNITO DE PIEL DE CUERO CABELLUDO"
  },
  {
    "codigo":68861000119103,
    "descripcion":"NEUROPATÍA CUBITAL A NIVEL DE LA MUÑECA"
  },
  {
    "codigo":10854141000119104,
    "descripcion":"EPÍFISIS CAPITAL SUPERIOR DE FÉMUR DERECHO DESPLAZADA"
  },
  {
    "codigo":337661000119105,
    "descripcion":"ANILLO DE SOEMMERRING DE OJO IZQUIERDO"
  },
  {
    "codigo":309501000119106,
    "descripcion":"NECROSIS AVASCULAR DE PERONÉ IZQUIERDO"
  },
  {
    "codigo":10849021000119107,
    "descripcion":"CUERPO EXTRAÑO EN EL PUNTO LAGRIMAL IZQUIERDO"
  },
  {
    "codigo":345341000119107,
    "descripcion":"CONJUNTIVITIS LEÑOSA DE AMBOS OJOS"
  },
  {
    "codigo":15933181000119109,
    "descripcion":"ABSCESO DE TROMPA DE FALOPIO DERECHA"
  },
  {
    "codigo":15966461000119108,
    "descripcion":"DISECCIÓN DE ARTERIA RENAL IZQUIERDA"
  },
  {
    "codigo":11811581000119102,
    "descripcion":"CONTUSIÓN DE COLA DE PÁNCREAS"
  },
  {
    "codigo":1085181000119106,
    "descripcion":"ABSCESO DE INTESTINO CONCOMITANTE CON PROCTITIS ULCEROSA CRÓNICA Y DEBIDO A ELLA"
  },
  {
    "codigo":117501000119109,
    "descripcion":"DIFICULTAD PARA INICIAR LA MICCIÓN DEBIDA A HIPERTROFIA PROSTÁTICA BENIGNA"
  },
  {
    "codigo":1082621000119108,
    "descripcion":"COMA HEPÁTICO DEBIDO A INSUFICIENCIA HEPÁTICA ALCOHÓLICA"
  },
  {
    "codigo":286461000119106,
    "descripcion":"REFLEJO NAUSEOSO FARÍNGEO HIPERACTIVO"
  },
  {
    "codigo":125181000119107,
    "descripcion":"RUPTURA FAMILIAR DEBIDA A HOSTILIDAD ENTRE PADRE E HIJO"
  },
  {
    "codigo":267613004,
    "descripcion":"DISTROFIA PROGRESIVA DE CONOS (SIN COMPROMISO DE BASTONES)"
  },
  {
    "codigo":291581000119109,
    "descripcion":"HEMORRAGIA SUBDURAL NO TRAUMÁTICA, AGUDA"
  },
  {
    "codigo":726365007,
    "descripcion":"DELECIÓN DE PARTE DEL CROMOSOMA 1"
  },
  {
    "codigo":300381009,
    "descripcion":"DEFECACIÓN FRECUENTE"
  },
  {
    "codigo":10898811000119109,
    "descripcion":"HERIDA ABIERTA DE LABIO DEBIDA A MORDEDURA HUMANA"
  },
  {
    "codigo":36402006,
    "descripcion":"GLOMERULONEFRITIS ASOCIADA CON LUPUS ERITEMATOSO SISTÉMICO, CLASE IV DE LA OMS"
  },
  {
    "codigo":1052210007,
    "descripcion":"FLEBOESCLEROSIS DE VENA INTRAHEPÁTICA"
  },
  {
    "codigo":724530006,
    "descripcion":"ÚLCERA DUODENAL CAUSADA POR HELICOBACTER PYLORI Y AGENTE ANTIINFLAMATORIO NO ESTEROIDE"
  },
  {
    "codigo":427783000,
    "descripcion":"TORSIÓN DE APÉNDICE DE EPIDÍDIMO"
  },
  {
    "codigo":296711005,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE CEFOTAXIMA"
  },
  {
    "codigo":294876003,
    "descripcion":"ALERGIA A HEPARINOIDE"
  },
  {
    "codigo":720860004,
    "descripcion":"SÍNDROME DE EHLERS-DANLOS TIPO CONTRACTURA MUSCULAR"
  },
  {
    "codigo":196572005,
    "descripcion":"QUERATOSIS SUBLINGUAL"
  },
  {
    "codigo":131036009,
    "descripcion":"NORADRENALINA ANORMAL"
  },
  {
    "codigo":719025001,
    "descripcion":"RESULTADO DE BIOPSIA RENAL ANORMAL"
  },
  {
    "codigo":260273003,
    "descripcion":"VISIÓN A DISTANCIA 6\/9"
  },
  {
    "codigo":161969004,
    "descripcion":"ALETEO CARDÍACO"
  },
  {
    "codigo":293041006,
    "descripcion":"REACCIÓN ADVERSA A LA SULFAGUANIDINA"
  },
  {
    "codigo":30897009,
    "descripcion":"INTOXICACIÓN POR TRIYODOTIRONINA"
  },
  {
    "codigo":94598003,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE HUESO ESFENOIDES"
  },
  {
    "codigo":15951381000119109,
    "descripcion":"MELANOMA IN SITU DE PIEL DE AMBAS MAMAS"
  },
  {
    "codigo":61830005,
    "descripcion":"NEURALGIA ESFENOPALATINA"
  },
  {
    "codigo":291206006,
    "descripcion":"INTOXICACIÓN POR CLORPROTIXENO"
  },
  {
    "codigo":782726004,
    "descripcion":"PARAPLEJÍA ESPÁSTICA AUTOSÓMICA RECESIVA TIPO 71"
  },
  {
    "codigo":127366009,
    "descripcion":"TERCER EMBARAZO"
  },
  {
    "codigo":92763002,
    "descripcion":"CARCINOMA IN SITU DE LA COLA DEL PÁNCREAS"
  },
  {
    "codigo":289371004,
    "descripcion":"CABEZA FETAL 3\/5 POR ENCIMA DEL BORDE PÉLVICO"
  },
  {
    "codigo":254768003,
    "descripcion":"PILOLEIOMIOMA MÚLTIPLE"
  },
  {
    "codigo":687791000119107,
    "descripcion":"RABDOMIOSARCOMA PRIMARIO DE AXILA"
  },
  {
    "codigo":447706001,
    "descripcion":"LEIOMIOSARCOMA DE CUERO CABELLUDO"
  },
  {
    "codigo":414938004,
    "descripcion":"EN EL SISTEMA DE ENTREGA REPETIDA"
  },
  {
    "codigo":1332442005,
    "descripcion":"HIPERTENSIÓN EN ENFERMEDAD RENAL CRÓNICA EN ESTADIO 3 DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":709850005,
    "descripcion":"UBICACIÓN Y MAGNITUD DE REGIÓN DESDENTADA DE LA CAVIDAD BUCAL SUSTANCIALMENTE COMPROMETIDA"
  },
  {
    "codigo":251098004,
    "descripcion":"FIBRAS LENTAS DEL NÓDULO AV"
  },
  {
    "codigo":773551001,
    "descripcion":"SÍNDROME DE DISCAPACIDAD INTELECTUAL SEVERA, LENGUAJE POBRE, ESTRABISMO, CARA CON MUECAS Y DEDOS LARGOS"
  },
  {
    "codigo":19887002,
    "descripcion":"CLAUSTROFOBIA"
  },
  {
    "codigo":11310921000119104,
    "descripcion":"FRACTURA NO EXPUESTA DE TERCERA VÉRTEBRA LUMBAR"
  },
  {
    "codigo":249263004,
    "descripcion":"ADHERENCIAS DE PREPUCIO"
  },
  {
    "codigo":85423005,
    "descripcion":"POLINEUROPATÍA MOTRIZ"
  },
  {
    "codigo":1197700001,
    "descripcion":"VÁRICES ESOFÁGICAS SANGRANTES POR HEPATITIS AUTOINMUNITARIA"
  },
  {
    "codigo":183727009,
    "descripcion":"CONSULTA DOMICILIARIA ORTOPÉDICA SOLICITADA"
  },
  {
    "codigo":87881000119106,
    "descripcion":"TEMBLOR DEBIDO A HIPOTENSIÓN ORTOSTÁTICA"
  },
  {
    "codigo":50820005,
    "descripcion":"CITOPENIA"
  },
  {
    "codigo":444036008,
    "descripcion":"LESIÓN TRAUMÁTICA DE AORTA"
  },
  {
    "codigo":18052008,
    "descripcion":"INTOXICACIÓN CAUSADA POR MEPERIDINA"
  },
  {
    "codigo":16217003,
    "descripcion":"CHOQUE DEBIDO A LA ADMINISTRACIÓN DE ANESTESIA"
  },
  {
    "codigo":11775971000119101,
    "descripcion":"LESIÓN TRAUMÁTICA DE REGIÓN DE CODO DERECHO"
  },
  {
    "codigo":1163097007,
    "descripcion":"ENCEFALITIS CAUSADA POR FLAVIVIRUS"
  },
  {
    "codigo":704345008,
    "descripcion":"NEUMONITIS INTERSTICIAL CRÓNICA"
  },
  {
    "codigo":276526002,
    "descripcion":"ASCITIS QUILOSA DEL RECIÉN NACIDO"
  },
  {
    "codigo":440366004,
    "descripcion":"FRACTURA NO EXPUESTA DE EPITRÓCLEA"
  },
  {
    "codigo":1259566007,
    "descripcion":"CARCINOMA TRIQUILEMAL PRIMARIO"
  },
  {
    "codigo":407598009,
    "descripcion":"SIN CONSENTIMIENTO PARA ADMINISTRACIÓN DE TERCER REFUERZO DE VACUNACIÓN CONTRA HAEMOPHILUS INFLUENZAE TIPO B"
  },
  {
    "codigo":372995003,
    "descripcion":"INFECCIÓN CAUSADA POR ASPERGILLUM REPENS"
  },
  {
    "codigo":471299004,
    "descripcion":"ORIGEN ANÓMALO DE ARTERIA CORONARIA ÚNICA EN SENO AÓRTICO A LA DERECHA DE SENO AÓRTICO NO ENFRENTADO"
  },
  {
    "codigo":1290499006,
    "descripcion":"PERIAORTITIS IDIOPÁTICA"
  },
  {
    "codigo":371160000,
    "descripcion":"TRASTORNO DE CARÓTIDA"
  },
  {
    "codigo":209155008,
    "descripcion":"SUBLUXACIÓN EXPUESTA ENTRE LA SEGUNDA Y TERCERA VÉRTEBRAS CERVICALES"
  },
  {
    "codigo":895448002,
    "descripcion":"SÍNDROME MULTISISTÉMICO INFLAMATORIO PEDIÁTRICO"
  },
  {
    "codigo":698840003,
    "descripcion":"GLAUCOMA NEOVASCULAR DEBIDO A HIFEMA"
  },
  {
    "codigo":403928006,
    "descripcion":"TRIQUILEMOMA DESMOPLÁSICO"
  },
  {
    "codigo":305624008,
    "descripcion":"ATENDIDO POR CONSEJERO MATRIMONIAL"
  },
  {
    "codigo":860845002,
    "descripcion":"GRANULOMA DE ESPACIO SUBDURAL ESPINAL CAUSADO POR PARÁSITO"
  },
  {
    "codigo":1286829004,
    "descripcion":"HIPERTENSIÓN OCULAR DEBIDA A HEMÓLISIS POSTERIOR A HEMORRAGIA INTRAOCULAR"
  },
  {
    "codigo":41645005,
    "descripcion":"INFECCIÓN CAUSADA POR TOXOCARA CATI"
  },
  {
    "codigo":762541006,
    "descripcion":"PERFORACIÓN DE AURÍCULA IZQUIERDA DEBIDA A PROCEDIMIENTO Y POSTERIOR ÉL"
  },
  {
    "codigo":690301000119102,
    "descripcion":"TRASTORNO DE FLUIDEZ DEBIDO A ACCIDENTE CEREBROVASCULAR EMBÓLICO Y POSTERIOR A ÉL"
  },
  {
    "codigo":236418003,
    "descripcion":"ENFERMEDAD DE MEMBRANA BASAL DELGADA"
  },
  {
    "codigo":301954005,
    "descripcion":"IRIS VERDE"
  },
  {
    "codigo":1186690008,
    "descripcion":"AMBIENTE HOSTIL"
  },
  {
    "codigo":234583001,
    "descripcion":"DEFICIENCIA DE ADHESIÓN LEUCOCITARIA - TIPO 2"
  },
  {
    "codigo":1217623004,
    "descripcion":"MEMBRANA CONGÉNITA DE PUNTO LAGRIMAL"
  },
  {
    "codigo":37975005,
    "descripcion":"OVARIO ACCESORIO"
  },
  {
    "codigo":365655006,
    "descripcion":"CONCENTRACIÓN SANGUÍNEA DETERMINADA CON TIRA REACTIVA - HALLAZGO"
  },
  {
    "codigo":298284000,
    "descripcion":"MOVIMIENTO MUSCULAR CONTRA RESISTENCIA, INCOMPLETO"
  },
  {
    "codigo":336151000119100,
    "descripcion":"ESCOTOMA CENTROCECAL DE OJO DERECHO"
  },
  {
    "codigo":429356007,
    "descripcion":"ARRUGA DE PIEL DE LA GLABELA"
  },
  {
    "codigo":425686003,
    "descripcion":"CUIDADO POR CÓNYUGE"
  },
  {
    "codigo":720598005,
    "descripcion":"SÍNDROME DE LESIÓN DE CALOTA CRANEANA CON FORMA DE ROSQUILLA Y FRAGILIDAD ÓSEA"
  },
  {
    "codigo":294614007,
    "descripcion":"ALERGIA A ISONIAZIDA"
  },
  {
    "codigo":128939001,
    "descripcion":"INFECCIÓN DEL TEJIDO CELULAR SUBCUTÁNEO"
  },
  {
    "codigo":30635002,
    "descripcion":"ABSCESO DE TIMO"
  },
  {
    "codigo":1144747004,
    "descripcion":"CONTROL DE IMPULSOS ALTERADO"
  },
  {
    "codigo":718763005,
    "descripcion":"SÍNDROME DE DISPLASIA ESPONDILOEPIFISARIA CON MIOPÍA Y SORDERA NEUROSENSORIAL"
  },
  {
    "codigo":292779004,
    "descripcion":"REACCIÓN ADVERSA AL GLICEROL"
  },
  {
    "codigo":1073431000119105,
    "descripcion":"ARTRITIS INFECCIOSA DE CODO DERECHO"
  },
  {
    "codigo":94336001,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LOS GANGLIOS LINFÁTICOS ILÍACOS"
  },
  {
    "codigo":127104002,
    "descripcion":"LINFADENOPATÍA TRAQUEOBRONQUIAL SUPERIOR"
  },
  {
    "codigo":61568004,
    "descripcion":"ABORTO ESPONTÁNEO CON SALPINGO-OOFORITIS"
  },
  {
    "codigo":290944004,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR GABAPENTINA"
  },
  {
    "codigo":15710641000119100,
    "descripcion":"DISECCIÓN BILATERAL DE ARTERIAS VERTEBRALES"
  },
  {
    "codigo":28800007,
    "descripcion":"INTOXICACIÓN POR SULFADIAZINA"
  },
  {
    "codigo":92501000,
    "descripcion":"FISURA CONGÉNITA DEL TIMO"
  },
  {
    "codigo":59733002,
    "descripcion":"CARDIOPATÍA HIPERTENSIVA QUE COMPLICA EL PARTO Y\/O CONSTITUYE UN MOTIVO DE ATENCIÓN DURANTE ESTE PROCEDIMIENTO"
  },
  {
    "codigo":11778481000119101,
    "descripcion":"DISTENSIÓN DE MÚSCULO Y\/O TENDÓN DE TRÍCEPS BRAQUIAL IZQUIERDO"
  },
  {
    "codigo":715093006,
    "descripcion":"DIFICULTAD PARA PASAR DE LA SILLA AL INODORO"
  },
  {
    "codigo":420181007,
    "descripcion":"EXCESO DE ACOMODACIÓN"
  },
  {
    "codigo":289109009,
    "descripcion":"CAPAZ DE RESOPLAR"
  },
  {
    "codigo":254506004,
    "descripcion":"TUMOR BENIGNO DEL PLIEGUE ARITENOEPIGLÓTICO - CARA HIPOFARÍNGEA"
  },
  {
    "codigo":1137407001,
    "descripcion":"DEBILIDAD DE MÚSCULO EXTENSOR DE DEDO DE MANO"
  },
  {
    "codigo":285439001,
    "descripcion":"NO REALIZA FUNCIONES MOTRICES ORALES"
  },
  {
    "codigo":449279001,
    "descripcion":"RARA VEZ CENA"
  },
  {
    "codigo":416511004,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA NO EXPUESTA DE MÚLTIPLES DEDOS DE LA MANO"
  },
  {
    "codigo":185300005,
    "descripcion":"VISTO POR MÉDICO DE TURNO"
  },
  {
    "codigo":86996006,
    "descripcion":"MACRONIQUIA"
  },
  {
    "codigo":414676007,
    "descripcion":"NEUROBLASTOMA METASTÁSICO DE ÓRBITA PROPIAMENTE DICHA"
  },
  {
    "codigo":283604006,
    "descripcion":"HERIDA POR PINCHAZO DE AGUJA EN LA NARIZ"
  },
  {
    "codigo":145841000119107,
    "descripcion":"PATRÓN DE USO EPISÓDICO NOCIVO DE FENCICLIDINA"
  },
  {
    "codigo":216233003,
    "descripcion":"INTOXICACIÓN CAUSADA POR MONÓXIDO DE CARBONO DE AERONAVE EN TRÁNSITO, SIN ACCIDENTE DE AERONAVE"
  },
  {
    "codigo":609449004,
    "descripcion":"INTERRUPCIÓN INDUCIDA DEL EMBARAZO COMPLICADA POR EMBOLIA"
  },
  {
    "codigo":871593005,
    "descripcion":"COMPLICACIÓN DEBIDA A OPERACIÓN DE CONDUCTO CARDÍACO"
  },
  {
    "codigo":314537004,
    "descripcion":"PAPILOPATÍA ÓPTICA DIABÉTICA"
  },
  {
    "codigo":707753007,
    "descripcion":"QUEILITIS ANGULAR DEBIDA A AUSENCIA DE DIMENSIÓN VERTICAL INTERMAXILAR ADECUADA"
  },
  {
    "codigo":1363113005,
    "descripcion":"TUBERCULOSIS MULTIFOCAL"
  },
  {
    "codigo":312702001,
    "descripcion":"AGUJERO MACULAR DE ESPESOR TOTAL, ESTADIO II"
  },
  {
    "codigo":17790008,
    "descripcion":"TRASTORNO DE LA UÑA"
  },
  {
    "codigo":704083000,
    "descripcion":"FRACTURA NO EXPUESTA DE METÁFISIS DE SEGUNDO METATARSIANO"
  },
  {
    "codigo":48723006,
    "descripcion":"HIPOGONADISMO MASCULINO"
  },
  {
    "codigo":79656000,
    "descripcion":"ANOMALÍA DEL PAR DE CROMOSOMAS 19"
  },
  {
    "codigo":46888001,
    "descripcion":"NISTAGMO ASOCIADO CON TRASTORNO DEL SISTEMA VESTIBULAR"
  },
  {
    "codigo":42331000087101,
    "descripcion":"CONTUSIÓN DE COSTILLA DERECHA"
  },
  {
    "codigo":866088004,
    "descripcion":"MICROCÓRNEA DE AMBOS OJOS"
  },
  {
    "codigo":309032007,
    "descripcion":"SITUACIÓN ADMINISTRATIVA DE LA INVESTIGACIÓN"
  },
  {
    "codigo":45053005,
    "descripcion":"TIROIDITIS CRÓNICA"
  },
  {
    "codigo":405501007,
    "descripcion":"HIPERTERMIA MALIGNA"
  },
  {
    "codigo":1290237009,
    "descripcion":"ENOSTOSIS PÉLVICA"
  },
  {
    "codigo":239826001,
    "descripcion":"SÍNDROME INFANTIL CRÓNICO NEUROLÓGICO, CUTÁNEO Y ARTICULAR"
  },
  {
    "codigo":698578005,
    "descripcion":"FIEBRE POSTERIOR A VACUNACIÓN ANTIDIFTÉRICA, ANTITETÁNICA Y CONTRA LA TOS FERINA"
  },
  {
    "codigo":403666006,
    "descripcion":"MUCOSITIS MEDICAMENTOSA"
  },
  {
    "codigo":272594009,
    "descripcion":"MONTADO EN UN CABALLO MIRANDO HACIA ADELANTE"
  },
  {
    "codigo":762279002,
    "descripcion":"NÁUSEA FUNCIONAL"
  },
  {
    "codigo":205223007,
    "descripcion":"AGENESIA DEL QUINTO METATARSIANO"
  },
  {
    "codigo":1075941000119106,
    "descripcion":"TENOSINOVITIS DE TOBILLO DERECHO"
  },
  {
    "codigo":338661000119106,
    "descripcion":"LUXACIÓN POSTERIOR DE CRISTALINO IZQUIERDO"
  },
  {
    "codigo":4945003,
    "descripcion":"MICROGIRIA"
  },
  {
    "codigo":299857003,
    "descripcion":"REFLEJO SACRO PRESENTE SÓLO CON REFUERZO"
  },
  {
    "codigo":365393005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA REALIZAR TAREAS DE OFICINA"
  },
  {
    "codigo":201553007,
    "descripcion":"ARTRITIS DE MÚLTIPLES LOCALIZACIONES POSTERIOR A HELMINTIASIS"
  },
  {
    "codigo":3110003,
    "descripcion":"OTITIS MEDIA AGUDA"
  },
  {
    "codigo":396326008,
    "descripcion":"DERMATOSIS SENIL"
  },
  {
    "codigo":166950008,
    "descripcion":"NIVEL TERAPÉUTICO DE CARBAMAZEPINA"
  },
  {
    "codigo":772839003,
    "descripcion":"NEUMONÍA CAUSADA POR VIRUS DE LA INFLUENZA A"
  },
  {
    "codigo":296187006,
    "descripcion":"SOBREDOSIS DE HALOPERIDOL"
  },
  {
    "codigo":230651008,
    "descripcion":"TRASTORNO DE LAS NEURONAS ESPINALES OBJETIVABLE POR HIPERACTIVIDAD"
  },
  {
    "codigo":64976006,
    "descripcion":"INVAGINACIÓN CECOCÓLICA"
  },
  {
    "codigo":95909001,
    "descripcion":"TOLERANCIA FARMACOLÓGICA NORMAL"
  },
  {
    "codigo":367641000119101,
    "descripcion":"SECRECIÓN AUMENTADA DE GASTRINA"
  },
  {
    "codigo":63141004,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN DE PIE"
  },
  {
    "codigo":718501007,
    "descripcion":"RUIDO HIDROAÉREO AGUDO"
  },
  {
    "codigo":292517009,
    "descripcion":"REACCIÓN ADVERSA A LA DIPIVEFRINA"
  },
  {
    "codigo":126842002,
    "descripcion":"NEOPLASIA DEL COLON TRANSVERSO"
  },
  {
    "codigo":1306490004,
    "descripcion":"CARCINOMA DUCTAL INFILTRANTE PRIMARIO CUADRANTE INFERIOR EXTERNO DE MAMA DERECHA"
  },
  {
    "codigo":290682009,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR METOTREXATO"
  },
  {
    "codigo":714831004,
    "descripcion":"ACUERDA CON EL PLAN DE ATENCIÓN"
  },
  {
    "codigo":59471009,
    "descripcion":"FARINGITIS FLEMONOSA"
  },
  {
    "codigo":92239009,
    "descripcion":"NEOPLASIA BENIGNA DEL MIOMETRIO"
  },
  {
    "codigo":450852006,
    "descripcion":"SACO VITELINO PRESENTE"
  },
  {
    "codigo":254244007,
    "descripcion":"PARCHE TIPO PIEL DE NARANJA"
  },
  {
    "codigo":24868007,
    "descripcion":"CISTITIS GONOCÓCICA AGUDA"
  },
  {
    "codigo":285177001,
    "descripcion":"INCAPAZ DE RECONOCER EL ENTORNO"
  },
  {
    "codigo":13491000119101,
    "descripcion":"REFLUJO VESICOURETERAL DEBIDO A SISTEMA COLECTOR DUPLICADO"
  },
  {
    "codigo":711161006,
    "descripcion":"ANEMIA MICROCÍTICA HIPOCRÓMICA CON SOBRECARGA DE HIERRO"
  },
  {
    "codigo":86734000,
    "descripcion":"MORFOLOGÍA DE UNA COLONIA BACTERIANA, BORDE EROSIONADO"
  },
  {
    "codigo":250574005,
    "descripcion":"AMINOÁCIDOS - HALLAZGO"
  },
  {
    "codigo":283342009,
    "descripcion":"PICADURA DE INSECTO EN LA PLANTA DEL PIE"
  },
  {
    "codigo":248739002,
    "descripcion":"PERFORANTE INCOMPETENTE"
  },
  {
    "codigo":341171000119104,
    "descripcion":"CICLOTROPÍA DE OJO IZQUIERDO"
  },
  {
    "codigo":445347002,
    "descripcion":"QUISTE CALCIFICANTE DE GLÁNDULA TIROIDES"
  },
  {
    "codigo":19363005,
    "descripcion":"INTENTO FALLIDO DE ABORTO CON EMBOLIA DE COÁGULO SANGUÍNEO"
  },
  {
    "codigo":1297315003,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE QUINTO DEDO DE PIE IZQUIERDO"
  },
  {
    "codigo":707491008,
    "descripcion":"CARCINOMA LINFOEPITELIAL PRIMARIO DE HIPOFARINGE"
  },
  {
    "codigo":50296002,
    "descripcion":"CONFIGURACIÓN DE LÍPIDOS"
  },
  {
    "codigo":246904003,
    "descripcion":"FORMACIÓN MEMBRANOSA DE LA CONJUNTIVA PALPEBRAL"
  },
  {
    "codigo":1295480004,
    "descripcion":"FRACTURA OSTEOPORÓTICA DEBIDA A OSTEOPOROSIS IDIOPÁTICA"
  },
  {
    "codigo":1229944005,
    "descripcion":"RETRACCIÓN DE CÁPSULA DE CADERA"
  },
  {
    "codigo":115832006,
    "descripcion":"FENOTIPO JKJK"
  },
  {
    "codigo":15693002,
    "descripcion":"INFECCIÓN CAUSADA POR ORNITHOBILHARZIA"
  },
  {
    "codigo":310605004,
    "descripcion":"HISTIOCITOMA FIBROSO DE VAINA TENDINOSA"
  },
  {
    "codigo":212301007,
    "descripcion":"LESIÓN DEL NERVIO INTERÓSEO POSTERIOR"
  },
  {
    "codigo":46626002,
    "descripcion":"NECROSIS GRASA NODULAR SUBCUTÁNEA EN LA PANCREATITIS"
  },
  {
    "codigo":1259042008,
    "descripcion":"DESMIELINIZACIÓN DE SISTEMA NERVIOSO CENTRAL DEBIDA A BORRELIOSIS DE LYME"
  },
  {
    "codigo":12023003,
    "descripcion":"VALVULOPATÍA AÓRTICA REUMÁTICA"
  },
  {
    "codigo":274167004,
    "descripcion":"LACERACIÓN DE LA PARED TORÁCICA"
  },
  {
    "codigo":306935006,
    "descripcion":"SECRECIÓN MUCOPURULENTA DE LA CAVIDAD MASTOIDEA"
  },
  {
    "codigo":16125261000119105,
    "descripcion":"DERRAME INTERMITENTE DE ARTICULACIÓN DE AMBAS RODILLAS"
  },
  {
    "codigo":10188004,
    "descripcion":"OSTEOMIELITIS AGUDA DE MANO"
  },
  {
    "codigo":403404004,
    "descripcion":"PSEUDOXANTOMA ELÁSTICO PERFORANTE ADQUIRIDO"
  },
  {
    "codigo":75724008,
    "descripcion":"ATETOSIS PUPILAR"
  },
  {
    "codigo":1157068008,
    "descripcion":"ASTROCITOMA FIBRILAR DE SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":288231000119101,
    "descripcion":"CUIDA A FAMILIAR DEPENDIENTE EN EL HOGAR"
  },
  {
    "codigo":1351841004,
    "descripcion":"SÍNDROME DE BROWN-SÉQUARD DEBIDO A ESPONDILOSIS CERVICAL"
  },
  {
    "codigo":41121007,
    "descripcion":"RETROFLEXIÓN DEL ÚTERO"
  },
  {
    "codigo":237729008,
    "descripcion":"OSMOSTATO HIPOTALÁMICO REPROGRAMADO"
  },
  {
    "codigo":72054002,
    "descripcion":"OSTEÍTIS GOMOSA EN LA FRAMBESIA"
  },
  {
    "codigo":268662002,
    "descripcion":"AUSENTISMO ESCOLAR INJUSTIFICADO DEL NIÑO NO SOCIALIZADO"
  },
  {
    "codigo":1153398008,
    "descripcion":"BURSITIS IDIOPÁTICA"
  },
  {
    "codigo":234059001,
    "descripcion":"ESTENOSIS VENOSA"
  },
  {
    "codigo":365131002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA LEVANTARSE DE LA CAMA"
  },
  {
    "codigo":70219007,
    "descripcion":"INFESTACIÓN CAUSADA POR CUCARACHAS"
  },
  {
    "codigo":102987009,
    "descripcion":"PRUEBA DE LA MARCHA EN LÍNEA RECTA CON RESULTADOS NORMALES"
  },
  {
    "codigo":166688007,
    "descripcion":"NIVEL DE POTASIO SÉRICO DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":232224009,
    "descripcion":"OTITIS EXTERNA INFECCIOSA CRÓNICA"
  },
  {
    "codigo":263157002,
    "descripcion":"FRACTURA DE HUESO ALVEOLAR MAXILAR"
  },
  {
    "codigo":426997005,
    "descripcion":"LESIÓN TRAUMÁTICA DURANTE EL EMBARAZO"
  },
  {
    "codigo":230389006,
    "descripcion":"EPILEPSIA PRIMARIA DE LA LECTURA, HEREDITARIA"
  },
  {
    "codigo":16016871000119108,
    "descripcion":"ARTRITIS INFECCIOSA DE ARTICULACIONES DE AMBAS RODILLAS CAUSADA POR VIRUS"
  },
  {
    "codigo":33781009,
    "descripcion":"ABSCESO ABDOMINOPÉLVICO"
  },
  {
    "codigo":295925009,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE PAROXETINA"
  },
  {
    "codigo":292255000,
    "descripcion":"REACCIÓN ADVERSA A FÁRMACO INMUNODEPRESOR"
  },
  {
    "codigo":128415001,
    "descripcion":"NEOPLASIA DEL TUBO DIGESTIVO"
  },
  {
    "codigo":15744641000119104,
    "descripcion":"MASA DE ARTICULACIÓN DE MANO DERECHA"
  },
  {
    "codigo":1176991004,
    "descripcion":"PARKINSONISMO POSTERIOR A INFECCIÓN POR MICOPLASMA"
  },
  {
    "codigo":193951005,
    "descripcion":"REFLEJO DE PARPADEO DEFICIENTE"
  },
  {
    "codigo":1144223007,
    "descripcion":"ENCEFALOPATÍA ISQUÉMICA HIPÓXICA NEONATAL"
  },
  {
    "codigo":95647008,
    "descripcion":"ENFERMEDAD DE LA NEURONA MOTORA SUPERIOR"
  },
  {
    "codigo":93812000,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA MUCOSA GINGIVAL"
  },
  {
    "codigo":290420006,
    "descripcion":"INTOXICACIÓN POR METOCLOPRAMIDA"
  },
  {
    "codigo":716404008,
    "descripcion":"CAPAZ DE REALIZAR TAREAS DEL HOGAR"
  },
  {
    "codigo":126580009,
    "descripcion":"NEOPLASIA DE FALANGE DE LA MANO"
  },
  {
    "codigo":288585002,
    "descripcion":"DIFICULTAD PARA EMPLEAR LA COMUNICACIÓN NO VERBAL"
  },
  {
    "codigo":91955005,
    "descripcion":"ENFERMEDAD DE LAS AZORES, TIPO III"
  },
  {
    "codigo":91977009,
    "descripcion":"NEOPLASIA BENIGNA DE LA PARED ANTERIOR DE LA VEJIGA"
  },
  {
    "codigo":1237022003,
    "descripcion":"CON RIESGO ELEVADO DE EXPOSICIÓN A POLIOVIRUS HUMANO"
  },
  {
    "codigo":712734004,
    "descripcion":"VÉRTIGO DEBIDO A LESIÓN CEREBRAL"
  },
  {
    "codigo":24606006,
    "descripcion":"PÁRPADO ACCESORIO"
  },
  {
    "codigo":286750006,
    "descripcion":"NIVEL BAJO DE EGOCENTRISMO"
  },
  {
    "codigo":317211000119104,
    "descripcion":"PANICULITIS LUMBAR Y TORÁCICA"
  },
  {
    "codigo":186611004,
    "descripcion":"FLACCIDEZ MUSCULAR"
  },
  {
    "codigo":15636251000119104,
    "descripcion":"ALTERACIÓN DE LA ALINEACIÓN DE AMBAS RODILLAS"
  },
  {
    "codigo":284915007,
    "descripcion":"UTILIZA SILLA INODORO"
  },
  {
    "codigo":283080000,
    "descripcion":"ARAÑAZO DE CODO"
  },
  {
    "codigo":55539008,
    "descripcion":"ESTRÉS FÍSICO"
  },
  {
    "codigo":219379009,
    "descripcion":"HERIDA DE GUERRA POR BALA DE ESCOPETA"
  },
  {
    "codigo":53704007,
    "descripcion":"PELVIS LORDÓTICA"
  },
  {
    "codigo":709064009,
    "descripcion":"TENSIÓN DE PISO PÉLVICO"
  },
  {
    "codigo":838301001,
    "descripcion":"TRASTORNO DE VEJIGA URINARIA CAUSADO POR SCHISTOSOMA"
  },
  {
    "codigo":281245003,
    "descripcion":"DOLOR TORÁCICO MUSCULOESQUELÉTICO"
  },
  {
    "codigo":215709004,
    "descripcion":"LESIÓN SUFRIDA A BORDO DE MEDIO DE TRANSPORTE ACUÁTICO CAUSADA POR MAQUINARIA DE CUBIERTA. OCUPANTE DE PEQUEÑA EMBARCACIÓN MOTORIZADA LESIONADO"
  },
  {
    "codigo":443250000,
    "descripcion":"NEOPLASIA FIBROMATOSA MALIGNA"
  },
  {
    "codigo":17266006,
    "descripcion":"COLANGITIS PRIMARIA"
  },
  {
    "codigo":246642007,
    "descripcion":"VE CHISPAS"
  },
  {
    "codigo":410482007,
    "descripcion":"IRITIS CON ARTRITIS PSORIÁSICA"
  },
  {
    "codigo":80967001,
    "descripcion":"CARIES DENTAL"
  },
  {
    "codigo":50034006,
    "descripcion":"INTOXICACIÓN POR SOLANUM INCANUM"
  },
  {
    "codigo":310343007,
    "descripcion":"SEGUNDA OPINIÓN REQUERIDA"
  },
  {
    "codigo":212039008,
    "descripcion":"CORROSIÓN DE LARINGE, TRÁQUEA Y PULMÓN"
  },
  {
    "codigo":13596001,
    "descripcion":"PERITONITIS DIFTÉRICA"
  },
  {
    "codigo":277575008,
    "descripcion":"LEUCEMIA LINFOBLÁSTICA AGUDA DE CÉLULAS T"
  },
  {
    "codigo":308508003,
    "descripcion":"SITUACIÓN DEL CONTROL GERIÁTRICO"
  },
  {
    "codigo":408647009,
    "descripcion":"ADENOCARCINOMA GÁSTRICO"
  },
  {
    "codigo":767260005,
    "descripcion":"RETRUSIÓN DE LABIO SUPERIOR"
  },
  {
    "codigo":111900000,
    "descripcion":"NEUMONÍA EN LA ASPERGILOSIS"
  },
  {
    "codigo":1162311007,
    "descripcion":"SARCOMA DE CUERPO UTERINO"
  },
  {
    "codigo":110065002,
    "descripcion":"LACERACIÓN COMPLEJA CONTAMINADA DEL PABELLÓN AURICULAR"
  },
  {
    "codigo":208369005,
    "descripcion":"FRACTURA NO EXPUESTA DE HUESO GANCHOSO, APÓFISIS UNCIFORME"
  },
  {
    "codigo":1083471000119102,
    "descripcion":"OTITIS EXTERNA DIFUSA DE AMBOS CONDUCTOS AUDITIVOS EXTERNOS"
  },
  {
    "codigo":1156806002,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE SISTEMA MUSCULOESQUELÉTICO"
  },
  {
    "codigo":403142004,
    "descripcion":"PICADURA DE HIMENÓPTEROS"
  },
  {
    "codigo":304838007,
    "descripcion":"LESIÓN EN EL NERVIO TROCLEAR"
  },
  {
    "codigo":698054007,
    "descripcion":"ASIMETRÍA DE BORDE INFERIOR DE LA MANDÍBULA"
  },
  {
    "codigo":1255110007,
    "descripcion":"ADENOCARCINOMA DE SENO MAXILAR"
  },
  {
    "codigo":204699000,
    "descripcion":"ESTENOSIS CONGÉNITA DE YEYUNO"
  },
  {
    "codigo":235632000,
    "descripcion":"FALTA DE COORDINACIÓN CRICOFARÍNGEA"
  },
  {
    "codigo":301168002,
    "descripcion":"PULSO POPLÍTEO AUSENTE"
  },
  {
    "codigo":366704004,
    "descripcion":"HALLAZGO RELACIONADO CON LA AMPLITUD DE LA FLEXIÓN DE DEDO DEL PIE"
  },
  {
    "codigo":71792006,
    "descripcion":"TRASTORNO DEL RITMO NODAL"
  },
  {
    "codigo":168261000,
    "descripcion":"POSTMORTEM - PARÁSITO AISLADO"
  },
  {
    "codigo":233797002,
    "descripcion":"QUISTE BRONCOGÉNICO INFECTADO"
  },
  {
    "codigo":364869002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA HACER EL PUENTE"
  },
  {
    "codigo":789018001,
    "descripcion":"RADICULOPATÍA DEBIDA A TRASTORNO METABÓLICO"
  },
  {
    "codigo":231962002,
    "descripcion":"QUISTE MIÓTICO DEL IRIS"
  },
  {
    "codigo":346191000119109,
    "descripcion":"EPÍFORA DE AMBOS OJOS"
  },
  {
    "codigo":461338005,
    "descripcion":"ANOMALÍA CARDIOVASCULAR DEBIDA A ORIGEN ANÓMALO DE ORIFICIO DE ARTERIA CORONARIA"
  },
  {
    "codigo":363034005,
    "descripcion":"ANOMALÍA CONGÉNITA DE ESTRUCTURA NERVIOSA DEL TRONCO"
  },
  {
    "codigo":230127002,
    "descripcion":"DEMANDA ALIMENTACIÓN"
  },
  {
    "codigo":15720681000119104,
    "descripcion":"LUXACIÓN PATOLÓGICA DE CADERA IZQUIERDA"
  },
  {
    "codigo":295663003,
    "descripcion":"SOBREDOSIS DE BLEOMICINA"
  },
  {
    "codigo":262895002,
    "descripcion":"RUPTURA DE URÉTER"
  },
  {
    "codigo":721647004,
    "descripcion":"DIVERTICULOSIS CONGÉNITA DE INTESTINO DELGADO"
  },
  {
    "codigo":361199007,
    "descripcion":"NEUROPATÍA AMILOIDE FAMILIAR, TIPO FINLANDÉS"
  },
  {
    "codigo":228292001,
    "descripcion":"BEBE EN BARES"
  },
  {
    "codigo":719812008,
    "descripcion":"SÍNDROME DE DISCAPACIDAD INTELECTUAL LIGADA AL CROMOSOMA X CON PLAGIOCEFALIA"
  },
  {
    "codigo":293828008,
    "descripcion":"ALERGIA A AMOXAPINA"
  },
  {
    "codigo":95385002,
    "descripcion":"HEMORRAGIA DEL SITIO DE INYECCIÓN"
  },
  {
    "codigo":717977003,
    "descripcion":"SÍNDROME DE LISENCEFALIA, TIPO NORMAN ROBERTS"
  },
  {
    "codigo":128153000,
    "descripcion":"HALLAZGO EN EL SISTEMA HEMOSTÁTICO"
  },
  {
    "codigo":291993003,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR DIGOXINA"
  },
  {
    "codigo":421230000,
    "descripcion":"HEPATOMEGALIA ASOCIADA CON SIDA"
  },
  {
    "codigo":349871000221106,
    "descripcion":"HEPATITIS B EN EMBARAZO"
  },
  {
    "codigo":290158003,
    "descripcion":"INTOXICACIÓN POR DEXTROMORAMIDA"
  },
  {
    "codigo":26179002,
    "descripcion":"ATRESIA DEL ESÓFAGO"
  },
  {
    "codigo":124483005,
    "descripcion":"DEFICIENCIA DE TRIPÉPTIDO AMINOPEPTIDASA"
  },
  {
    "codigo":419395007,
    "descripcion":"DISTROFIA CORNEAL CRISTALINA DE SCHNYDER"
  },
  {
    "codigo":253720000,
    "descripcion":"FÍSTULA ARTERIOVENOSA CORONARIA CONGÉNITA"
  },
  {
    "codigo":188184006,
    "descripcion":"NEOPLASIA MALIGNA DE LA UNIÓN ESCAMOCOLUMNAR DEL CUELLO UTERINO"
  },
  {
    "codigo":778008009,
    "descripcion":"DISPLASIA ÓSEA LIGADA A RECEPTOR DEL FACTOR DE CRECIMIENTO FIBROBLÁSTICO 2 CON INCURVACIÓN DE LAS EXTREMIDADES"
  },
  {
    "codigo":448493001,
    "descripcion":"ESTÓMAGO EN POSICIÓN CENTRAL"
  },
  {
    "codigo":55277003,
    "descripcion":"INFECCIÓN CAUSADA POR TETRAMERES"
  },
  {
    "codigo":250050001,
    "descripcion":"MARCHA MAGNÉTICA"
  },
  {
    "codigo":20674003,
    "descripcion":"FÍSTULA ORAL"
  },
  {
    "codigo":315586005,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: SYLHETI"
  },
  {
    "codigo":280983004,
    "descripcion":"PATRÓN DE USO NOCIVO DE VITAMINA"
  },
  {
    "codigo":1231255005,
    "descripcion":"NEOVASCULARIZACIÓN COROIDEA YUXTAFOVEAL"
  },
  {
    "codigo":1264023008,
    "descripcion":"PUENTE DENTAL APOYADO SOBRE IMPLANTE IN SITU"
  },
  {
    "codigo":770668007,
    "descripcion":"DISOMÍA UNIPARENTAL PATERNA DEL CROMOSOMA 13"
  },
  {
    "codigo":408385003,
    "descripcion":"CONTROL DE RETINOPATÍA DIABÉTICA A LOS 6 MESES"
  },
  {
    "codigo":1260353004,
    "descripcion":"DEMENCIA FRONTOTEMPORAL DEBIDA A MUTACIÓN DE PROTEÍNA QUE CONTIENE VALOSINA"
  },
  {
    "codigo":211777005,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO SUPERFICIAL DE GLÚTEO"
  },
  {
    "codigo":703297006,
    "descripcion":"ESTENOSIS E INSUFICIENCIA DE PRÓTESIS DE VÁLVULA AÓRTICA"
  },
  {
    "codigo":46102000,
    "descripcion":"ENFERMEDAD POR FLAVOBACTERIUM COLUMNARE"
  },
  {
    "codigo":111638003,
    "descripcion":"FRACTURA EXPUESTA DEL EXTREMO ESTERNAL DE LA CLAVÍCULA"
  },
  {
    "codigo":275478007,
    "descripcion":"OREJA PROMINENTE"
  },
  {
    "codigo":109803005,
    "descripcion":"ANOMALÍA LABIAL ADQUIRIDA"
  },
  {
    "codigo":240875008,
    "descripcion":"GNATOSTOMIASIS CEREBRAL"
  },
  {
    "codigo":1179400001,
    "descripcion":"HIPOTIROIDISMO CONGÉNITO DEBIDO AL FACTOR DE MADURACIÓN OXIDASA DUAL-2"
  },
  {
    "codigo":239040001,
    "descripcion":"DISPLASIA ECTODÉRMICA CON DEFECTOS DE LOS DIENTES-UÑAS"
  },
  {
    "codigo":42432003,
    "descripcion":"SÍNDROME OTOPALATODIGITAL, TIPO II"
  },
  {
    "codigo":106133000,
    "descripcion":"HALLAZGO RELACIONADO CON EL LENGUAJE"
  },
  {
    "codigo":271808008,
    "descripcion":"EDEMA GENERALIZADO"
  },
  {
    "codigo":1287616009,
    "descripcion":"CRISIS EPILÉPTICA ELECTROCLÍNICA NO MOTORA DE INICIO FOCAL NEONATAL"
  },
  {
    "codigo":1254848008,
    "descripcion":"NEOPLASIA MESENQUIMATOSA PRIMARIA MALIGNA DE ESÓFAGO"
  },
  {
    "codigo":402880009,
    "descripcion":"LINFOMA CUTÁNEO PRIMARIO DE GRANDES CÉLULAS T"
  },
  {
    "codigo":202602002,
    "descripcion":"CHASQUIDO DE MUÑECA"
  },
  {
    "codigo":169834003,
    "descripcion":"TRILLIZOS - TODOS MORTINATOS"
  },
  {
    "codigo":5994005,
    "descripcion":"ELIPTOCITOSIS HEREDITARIA POR DEFICIENCIA DE PROTEÍNA 4, 1"
  },
  {
    "codigo":366442009,
    "descripcion":"AMPLITUD DEL MOVIMIENTO ACTIVO DE ROTACIÓN HACIA LA DERECHA DE LA COLUMNA LUMBAR - HALLAZGO"
  },
  {
    "codigo":167999002,
    "descripcion":"ESPUTO: CUERPOS DE ASBESTO"
  },
  {
    "codigo":200767005,
    "descripcion":"PITIRIASIS SIMPLE"
  },
  {
    "codigo":299071007,
    "descripcion":"AMPLITUD DE FLEXIÓN PASIVA DE DEDO DE LA MANO AUMENTADA"
  },
  {
    "codigo":788756004,
    "descripcion":"ONCOCITOMA DE CÉLULAS FUSIFORMES DE GLÁNDULA HIPÓFISIS POSTERIOR"
  },
  {
    "codigo":395540004,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA DE MUCOSA NO AFECTADO POR NEOPLASIA MALIGNA"
  },
  {
    "codigo":11820011000119100,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN RADIOCUBITAL INFERIOR IZQUIERDA"
  },
  {
    "codigo":33257003,
    "descripcion":"DUPLICACIÓN CONGÉNITA DE LOS ÓRGANOS DIGESTIVOS"
  },
  {
    "codigo":262633005,
    "descripcion":"ABRASIÓN DE MUCOSA BUCAL ALVEOLAR"
  },
  {
    "codigo":721385005,
    "descripcion":"SÍNDROME DEL CORDÓN ANTERIOR DE MÉDULA ESPINAL AL NIVEL DEL QUINTO SEGMENTO CERVICAL"
  },
  {
    "codigo":295401007,
    "descripcion":"SOBREDOSIS DE LOPERAMIDA"
  },
  {
    "codigo":105451000119102,
    "descripcion":"TRASTORNO AMNÉSICO ASOCIADO CON AFECCIÓN MÉDICA GENERAL"
  },
  {
    "codigo":293566000,
    "descripcion":"REACCIÓN ADVERSA A LA BETAHISTINA"
  },
  {
    "codigo":129726003,
    "descripcion":"AUMENTO DEL NÚMERO DE CALCIFICACIONES CON RESPECTO A LA MAMOGRAFÍA ANTERIOR"
  },
  {
    "codigo":64190005,
    "descripcion":"MIOCARDITIS POR RUBÉOLA"
  },
  {
    "codigo":95123000,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL ASTRÁGALO"
  },
  {
    "codigo":226195000,
    "descripcion":"DIETA CON BAJO CONTENIDO DE ALÉRGENOS"
  },
  {
    "codigo":351211000119104,
    "descripcion":"LINFOMA DE LINFOCITOS B DE GANGLIOS LINFÁTICOS DE MÚLTIPLES LOCALIZACIONES"
  },
  {
    "codigo":33341000087102,
    "descripcion":"STREPTOCOCCUS SALIVARIUS O STREPTOCOCCUS VESTIBULARIS"
  },
  {
    "codigo":38461000087102,
    "descripcion":"AEROMONAS SOBRIA O AEROMONAS VERONII"
  },
  {
    "codigo":43581000087103,
    "descripcion":"CONTUSIÓN DE REGIÓN DE OJO IZQUIERDO"
  },
  {
    "codigo":93288001,
    "descripcion":"HIPOPLASIA CONGÉNITA DEL RADIO"
  },
  {
    "codigo":191592002,
    "descripcion":"EPISODIOS MANÍACOS RECURRENTES, LEVES"
  },
  {
    "codigo":48701000087106,
    "descripcion":"DISTENSIÓN DE MÚSCULO SUPRAESPINOSO IZQUIERDO"
  },
  {
    "codigo":715880002,
    "descripcion":"TRABAJO DE PARTO OBSTRUIDO DEBIDO A ANOMALÍA FETAL"
  },
  {
    "codigo":783251006,
    "descripcion":"TROMBOCITOPENIA HEREDITARIA CON PLAQUETAS NORMALES"
  },
  {
    "codigo":678891000119105,
    "descripcion":"DEPÓSITO EN CÓRNEA IZQUIERDA"
  },
  {
    "codigo":41021000087109,
    "descripcion":"FRACTURA POR AVULSIÓN DE FALANGE DE DEDO PULGAR DERECHO"
  },
  {
    "codigo":1141864009,
    "descripcion":"ESPASMO PERIORAL"
  },
  {
    "codigo":124221007,
    "descripcion":"DEFICIENCIA DE ESTEROIDE 21 - MONOOXIGENASA"
  },
  {
    "codigo":1303869008,
    "descripcion":"LIPOMA CAÓTICO DE CONO MEDULAR"
  },
  {
    "codigo":187371000119108,
    "descripcion":"TRASTORNO DE CARTÍLAGO ARTICULAR DE TOBILLO"
  },
  {
    "codigo":253458002,
    "descripcion":"HIPOPLASIA DE VÁLVULA AURICULOVENTRICULAR DERECHA"
  },
  {
    "codigo":417298001,
    "descripcion":"DESEO VEHEMENTE ANORMAL DE CONSUMIR DROGAS"
  },
  {
    "codigo":1088491000119109,
    "descripcion":"OTITIS NO INFECCIOSA CRÓNICA EXTERNA DE CONDUCTO AUDITIVO EXTERNO IZQUIERDO"
  },
  {
    "codigo":89618007,
    "descripcion":"TRASTORNO DELIRANTE, TIPO PERSECUTORIO"
  },
  {
    "codigo":22247000,
    "descripcion":"DEHISCENCIA DE HERIDA QUIRÚRGICA"
  },
  {
    "codigo":286226008,
    "descripcion":"UTILIZA EL FLUJO DE AIRE GLÓTICO PARA HABLAR"
  },
  {
    "codigo":448231003,
    "descripcion":"LINFOMA NO HODGKIN FOLICULAR DE NARIZ"
  },
  {
    "codigo":282556000,
    "descripcion":"NO DOBLA ESQUINAS AL CORRER"
  },
  {
    "codigo":1073311000000100,
    "descripcion":"LAVA LA ROPA"
  },
  {
    "codigo":708540005,
    "descripcion":"LESIÓN DE ESTRUCTURA CORPORAL POR CONMOCIÓN"
  },
  {
    "codigo":11793541000119106,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO DE TOBILLO DERECHO, CON INFECCIÓN"
  },
  {
    "codigo":249788008,
    "descripcion":"ACORTAMIENTO REAL DE PIERNA"
  },
  {
    "codigo":758431000000105,
    "descripcion":"INCAPAZ DE LAVAR ROPA"
  },
  {
    "codigo":870545006,
    "descripcion":"CAPAZ DE MANEJAR CORRESPONDENCIA"
  },
  {
    "codigo":247953009,
    "descripcion":"EVOCACIÓN DETALLADA DE UN SUEÑO"
  },
  {
    "codigo":770406002,
    "descripcion":"BRAQUIDACTILIA TIPO B2"
  },
  {
    "codigo":213350006,
    "descripcion":"FRACTURAS QUE COMPROMETEN EL TÓRAX CON LA REGIÓN LUMBAR Y LA PELVIS"
  },
  {
    "codigo":442726008,
    "descripcion":"HALLAZGO RELACIONADO CON DIFERENCIA EN LA LOCALIZACIÓN EN COMPARACIÓN CON EXAMEN RADIOLÓGICO PREVIO"
  },
  {
    "codigo":14907004,
    "descripcion":"URTICARIA AMPOLLAR"
  },
  {
    "codigo":735803005,
    "descripcion":"LACERACIÓN DE MÚSCULO DE MANGUITO ROTADOR"
  },
  {
    "codigo":211515006,
    "descripcion":"CONTUSIÓN DE MÚLTIPLES DEDOS DE MANO"
  },
  {
    "codigo":703035007,
    "descripcion":"CITROBACTER BRAAKII O CITROBACTER FREUNDII O CITROBACTER SEDLAKII"
  },
  {
    "codigo":1260091008,
    "descripcion":"CARCINOMA LINFOEPITELIAL DE OROFARINGE"
  },
  {
    "codigo":733968004,
    "descripcion":"CARIES DENTAL ACTIVA"
  },
  {
    "codigo":353721000119100,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE GLÁNDULA SUPRARRENAL IZQUIERDA"
  },
  {
    "codigo":209680007,
    "descripcion":"SECCIÓN EXPUESTA DE LIGAMENTO DE DEDO DE LA MANO"
  },
  {
    "codigo":11237000,
    "descripcion":"MARCHA EN CUATRO APOYOS"
  },
  {
    "codigo":11822521000119100,
    "descripcion":"AMPOLLA TRAUMÁTICA DE AXILA DERECHA"
  },
  {
    "codigo":371685005,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM AVIUM"
  },
  {
    "codigo":109541006,
    "descripcion":"FALTA DE EXFOLIACIÓN ASOCIADA CON ERUPCIÓN ECTÓPICA DE DIENTE SUCEDÁNEO"
  },
  {
    "codigo":240613006,
    "descripcion":"ENFERMEDAD POR RICKETTSIAS DEL GRUPO DE LOS TIFUS"
  },
  {
    "codigo":238778000,
    "descripcion":"ANGIODISCINESIA"
  },
  {
    "codigo":304314000,
    "descripcion":"AUSENCIA DE MOVIMIENTO DEL PULGAR"
  },
  {
    "codigo":681401000119103,
    "descripcion":"PRESENCIA DE VARIANTE DE CADENA ALFA DE HEMOGLOBINA"
  },
  {
    "codigo":402618006,
    "descripcion":"PIGMENTACIÓN ENDÓGENA NO MELÁNICA"
  },
  {
    "codigo":1156282007,
    "descripcion":"CUMPLE CON RÉGIMEN DE LÍQUIDOS"
  },
  {
    "codigo":763066009,
    "descripcion":"SÍNDROME DE DEFECTO DEL TABIQUE AURICULOVENTRICULAR, BLEFAROFIMOSIS Y DEFECTO RADIAL Y ANAL"
  },
  {
    "codigo":1187215002,
    "descripcion":"DISGIRIA ASOCIADA A TUBULINOPATÍA"
  },
  {
    "codigo":42170009,
    "descripcion":"LÍQUIDO AMNIÓTICO ANORMAL"
  },
  {
    "codigo":1091001000119104,
    "descripcion":"OTITIS MEDIA DERECHA CRÓNICA ALÉRGICA"
  },
  {
    "codigo":204175001,
    "descripcion":"PLIEGUE Y QUISTE CONGÉNITO DEL SEGMENTO POSTERIOR DEL OJO"
  },
  {
    "codigo":73103007,
    "descripcion":"PÓLIPO DEL OÍDO MEDIO"
  },
  {
    "codigo":1285519007,
    "descripcion":"SÍNDROME DE WOLFRAM TIPO 2"
  },
  {
    "codigo":726628003,
    "descripcion":"CONDROMALACIA FAMILIAR DE RÓTULA"
  },
  {
    "codigo":300644004,
    "descripcion":"DIFICULTAD PARA MANEJAR UNA MOTOCICLETA"
  },
  {
    "codigo":890468006,
    "descripcion":"INGESTA INADECUADA DE POTASIO"
  },
  {
    "codigo":36665001,
    "descripcion":"ANEURISMA AURICULAR"
  },
  {
    "codigo":724793007,
    "descripcion":"SÍNDROME MEDULAR LUMBAR INCOMPLETO"
  },
  {
    "codigo":231438001,
    "descripcion":"PSICOSIS PRESBIOFRÉNICA"
  },
  {
    "codigo":34830002,
    "descripcion":"CELULITIS DEL ESCROTO"
  },
  {
    "codigo":1281849009,
    "descripcion":"CON MAYOR RIESGO DE FRACTURA DE CABEZA DE FÉMUR"
  },
  {
    "codigo":722958008,
    "descripcion":"TRASTORNO LINFOPROLIFERATIVO POSTRASPLANTE SIMILAR A MONONUCLEOSIS INFECCIOSA"
  },
  {
    "codigo":1148942009,
    "descripcion":"RETENCIÓN DE PARTE DE LA PLACENTA SIN HEMORRAGIA"
  },
  {
    "codigo":360675000,
    "descripcion":"DEFICIENCIA DE LACTONASA"
  },
  {
    "codigo":1343715002,
    "descripcion":"DEGENERACIÓN DE SÉPTIMO DISCO INTERVERTEBRAL CERVICAL"
  },
  {
    "codigo":196835005,
    "descripcion":"HERNIA FEMORAL OBSTRUIDA"
  },
  {
    "codigo":195000004,
    "descripcion":"ESTENOSIS VALVULAR PULMONAR CON INSUFICIENCIA"
  },
  {
    "codigo":1941000124101,
    "descripcion":"TRANSICIÓN DE LA ATENCIÓN PROLONGADA A ATENCIÓN DOMICILIARIA"
  },
  {
    "codigo":326072005,
    "descripcion":"CARCINOMA DE CABEZA DE PÁNCREAS"
  },
  {
    "codigo":225933000,
    "descripcion":"CON MAYOR RIESGO RELACIONADO CON FUEGO"
  },
  {
    "codigo":422541001,
    "descripcion":"CARCINOMA INDIFERENCIADO DE NASOFARINGE"
  },
  {
    "codigo":1208973006,
    "descripcion":"CRISIS EPILÉPTICA MIOCLÓNICA-TÓNICO-CLÓNICA DE INICIO GENERALIZADO"
  },
  {
    "codigo":193165008,
    "descripcion":"NEUROPATÍA ASOCIADA CON ATAXIA HEREDITARIA"
  },
  {
    "codigo":60258001,
    "descripcion":"DISTROFIA CORNEAL MACULAR"
  },
  {
    "codigo":94861008,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA MANO"
  },
  {
    "codigo":1010530004,
    "descripcion":"ESCLEROSIS DE EPÍFISIS DE FALANGE PROXIMAL DE SEGUNDO DEDO DE PIE CON RADIOPACIDAD AUMENTADA"
  },
  {
    "codigo":93026008,
    "descripcion":"ANOMALÍA CONGÉNITA DE HUESO SUPRAOCCIPITAL"
  },
  {
    "codigo":420706008,
    "descripcion":"FASCIOLIASIS NASOFARÍNGEA"
  },
  {
    "codigo":289634008,
    "descripcion":"ÚTERO DE FORMA IRREGULAR"
  },
  {
    "codigo":58423003,
    "descripcion":"INFERTILIDAD SECUNDARIA A ENFERMEDAD SISTÉMICA"
  },
  {
    "codigo":1141602008,
    "descripcion":"PALUDISMO COMPLICADO"
  },
  {
    "codigo":418871005,
    "descripcion":"DEGENERACIÓN ESFEROIDAL DE LA CONJUNTIVA"
  },
  {
    "codigo":255031003,
    "descripcion":"CARCINOMA ANAPLÁSICO DE GLÁNDULA TIROIDES"
  },
  {
    "codigo":187660002,
    "descripcion":"NEOPLASIA MALIGNA DE SURCO GINGIVOBUCAL MANDIBULAR"
  },
  {
    "codigo":449804003,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE CÚPULA VESICAL"
  },
  {
    "codigo":253196005,
    "descripcion":"ARTERIA ÓTICA EMBRIONARIA PERSISTENTE"
  },
  {
    "codigo":23820006,
    "descripcion":"MIOPATÍA DE IMPRESIÓN DIGITAL"
  },
  {
    "codigo":284129007,
    "descripcion":"INCAPAZ DE CONTROLAR LA POSICIÓN PÉLVICA"
  },
  {
    "codigo":110471000119102,
    "descripcion":"TENOSINOVITIS SUPURATIVA DE TENDÓN FLEXOR"
  },
  {
    "codigo":21985009,
    "descripcion":"PROLIFERACIÓN FIBROHISTIOCÍTICA DE LA PIEL"
  },
  {
    "codigo":87521009,
    "descripcion":"DESÁNIMO"
  },
  {
    "codigo":52918004,
    "descripcion":"INFECCIÓN CAUSADA POR ECHINOCHASMUS"
  },
  {
    "codigo":249526007,
    "descripcion":"INCAPAZ DE DISTINGUIR ENTRE MATERIA FECAL Y FLATOS"
  },
  {
    "codigo":1263499004,
    "descripcion":"MIOPATÍA DEBIDA A SÍNDROME PARANEOPLÁSICO"
  },
  {
    "codigo":870283006,
    "descripcion":"GRANULOMA SUBDURAL ESPINAL CAUSADO POR HONGO"
  },
  {
    "codigo":247691006,
    "descripcion":"DELIRIO DE REEMPLAZO DE LA VOLUNTAD POR UNA FUERZA EXTERNA"
  },
  {
    "codigo":278624001,
    "descripcion":"PACIENTE INCAPAZ DE MORDER CON PRÓTESIS DENTAL"
  },
  {
    "codigo":213088004,
    "descripcion":"RECHAZO DE ALOINJERTO ÓSEO"
  },
  {
    "codigo":737376008,
    "descripcion":"AMBIENTE DE TRABAJO POCO FAVORABLE"
  },
  {
    "codigo":735541006,
    "descripcion":"TRASTORNO NEUROLÓGICO FUNCIONAL"
  },
  {
    "codigo":1259829007,
    "descripcion":"NEOPLASIA PRIMARIA MALIGNA DE VAINA DE NERVIO PERIFÉRICO DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":473397008,
    "descripcion":"CATÉTER PARA DIÁLISIS IN SITU UTILIZABLE"
  },
  {
    "codigo":309557009,
    "descripcion":"ENTUMECIMIENTO DE LA CARA"
  },
  {
    "codigo":242186000,
    "descripcion":"NADADOR LESIONADO POR HÉLICE DE EMBARCACIÓN"
  },
  {
    "codigo":209418000,
    "descripcion":"ESGUINCE DE ARTICULACIÓN DE HOMBRO, POSTERIOR"
  },
  {
    "codigo":897546001,
    "descripcion":"TRISOMÍA DISTAL 12Q"
  },
  {
    "codigo":699103001,
    "descripcion":"PIE DE COLOR ROSADO OSCURO EN POSICIÓN DECLIVE"
  },
  {
    "codigo":404191001,
    "descripcion":"ALTERACIÓN VISUAL EN MULTIDISCAPACIDAD"
  },
  {
    "codigo":305887001,
    "descripcion":"VISTO EN EL SERVICIO DE CIRUGÍA DENTAL"
  },
  {
    "codigo":830175004,
    "descripcion":"ALERGIA A PIPERIDOLATO"
  },
  {
    "codigo":109279002,
    "descripcion":"NEVO MELANOCÍTICO DE CONDUCTO AUDITIVO EXTERNO"
  },
  {
    "codigo":240351004,
    "descripcion":"CÓLERA - VIBRIO CHOLERAE GRUPO O139"
  },
  {
    "codigo":371423007,
    "descripcion":"ISOSPORIASIS"
  },
  {
    "codigo":402356004,
    "descripcion":"ENFERMEDAD DE INJERTO VERSUS HUÉSPED CRÓNICA"
  },
  {
    "codigo":1156020005,
    "descripcion":"NIVEL SÉRICO DE LITIO DENTRO DEL RANGO TERAPÉUTICO"
  },
  {
    "codigo":9140006,
    "descripcion":"SENSIBILIDAD DE LA PIEL A LA RADIACIÓN"
  },
  {
    "codigo":238516007,
    "descripcion":"BRONCEADO SOLAR"
  },
  {
    "codigo":7305005,
    "descripcion":"COARTACIÓN DE AORTA"
  },
  {
    "codigo":302217008,
    "descripcion":"TRASTORNO DE LA CÁMARA ANTERIOR DEL OJO"
  },
  {
    "codigo":1285257008,
    "descripcion":"RANGO ACTIVO NORMAL DE DORSIFLEXIÓN DE TOBILLO"
  },
  {
    "codigo":236681009,
    "descripcion":"URETRITIS INFECCIOSA"
  },
  {
    "codigo":300382002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CANTIDAD DE DEFECACIÓN"
  },
  {
    "codigo":202078001,
    "descripcion":"DESGARRO EN PICO DE LORO DEL ASTA POSTERIOR DEL MENISCO INTERNO"
  },
  {
    "codigo":890206005,
    "descripcion":"ANOMALÍA ADQUIRIDA DE VÁLVULA AURICULOVENTRICULAR COMÚN POSTERIOR A PROCEDIMIENTO"
  },
  {
    "codigo":365918008,
    "descripcion":"MEMORIA SEMÁNTICA - HALLAZGO"
  },
  {
    "codigo":726366008,
    "descripcion":"DELECIÓN DE PARTE DEL CROMOSOMA 2"
  },
  {
    "codigo":298547003,
    "descripcion":"AMPLITUD DE FLEXIÓN LATERAL PASIVA HACIA LA IZQUIERDA DE LA COLUMNA VERTEBRAL DORSAL, NORMAL"
  },
  {
    "codigo":10680791000119100,
    "descripcion":"NÓDULO DE PIEL DE EXTREMIDAD INFERIOR IZQUIERDA"
  },
  {
    "codigo":16005591000119100,
    "descripcion":"CELULITIS DE CODO DERECHO"
  },
  {
    "codigo":90071000119102,
    "descripcion":"EDENTULISMO COMPLETO CLASE IV"
  },
  {
    "codigo":1085911000119103,
    "descripcion":"COMPLICACIÓN DEBIDA A ENFERMEDAD DE CROHN"
  },
  {
    "codigo":330711000119104,
    "descripcion":"NEUROPATÍA POR COMPRESIÓN DE NERVIO PERONEO SUPERFICIAL IZQUIERDO"
  },
  {
    "codigo":10642391000119105,
    "descripcion":"ÚLCERA CRÓNICA NO CAUSADA POR PRESIÓN DE SACRO QUE SE EXTIENDE HASTA EL TEJIDO ADIPOSO"
  },
  {
    "codigo":338391000119106,
    "descripcion":"DEGENERACIÓN DE MARGEN PUPILAR IZQUIERDO"
  },
  {
    "codigo":10629591000119106,
    "descripcion":"SINUSITIS FRONTAL AGUDA RECURRENTE"
  },
  {
    "codigo":97751000119108,
    "descripcion":"ENFERMEDAD DE ALZHEIMER CON COMPORTAMIENTO ALTERADO"
  },
  {
    "codigo":15749591000119107,
    "descripcion":"REFLUJO GASTROESOFÁGICO NEONATAL"
  },
  {
    "codigo":1091031000119106,
    "descripcion":"PERICONDRITIS CRÓNICA DE OÍDO EXTERNO DERECHO"
  },
  {
    "codigo":16041431000119108,
    "descripcion":"ARTRITIS IDIOPÁTICA JUVENIL DE INICIO SISTÉMICO DE ARTICULACIÓN DE REGIÓN DE HOMBRO DERECHO"
  },
  {
    "codigo":16046551000119105,
    "descripcion":"ENFERMEDAD POR DEPÓSITO DE HIDROXIAPATITA DE TOBILLO DERECHO"
  },
  {
    "codigo":340951000119104,
    "descripcion":"SÍNDROME DE OJO SECO IZQUIERDO"
  },
  {
    "codigo":10675671000119107,
    "descripcion":"ASMA ALÉRGICA PERSISTENTE SEVERA NO CONTROLADA"
  },
  {
    "codigo":720861000,
    "descripcion":"SÍNDROME DE EHLERS-DANLOS TIPO PROGEROIDE"
  },
  {
    "codigo":10627031000119108,
    "descripcion":"FORÚNCULO DE PIE IZQUIERDO"
  },
  {
    "codigo":12206551000119109,
    "descripcion":"INFECCIÓN ASOCIADA CON PRÓTESIS ARTICULAR DE REGIÓN DE MUÑECA DERECHA"
  },
  {
    "codigo":16008151000119109,
    "descripcion":"RUPTURA DEGENERATIVA DE COMPLEJO FIBROCARTILAGINOSO TRIANGULAR DE AMBAS REGIONES DE MUÑECA"
  },
  {
    "codigo":11854011000119108,
    "descripcion":"LESIÓN TRAUMÁTICA DE PIE IZQUIERDO"
  },
  {
    "codigo":424114000,
    "descripcion":"FIBROSIS SISTÉMICA NEFROGÉNICA"
  },
  {
    "codigo":719026000,
    "descripcion":"TROFOZOITO DE ENTAMOEBA DISPAR O ENTAMOEBA HISTOLYTICA"
  },
  {
    "codigo":425949001,
    "descripcion":"DEFICIENCIA HEREDITARIA LEVE DE FACTOR VIII CON INHIBIDORES"
  },
  {
    "codigo":293042004,
    "descripcion":"REACCIÓN ADVERSA A LA SULFOUREA"
  },
  {
    "codigo":686421000119103,
    "descripcion":"GLIOMA MALIGNO PRIMARIO DE VENTRÍCULO CEREBRAL"
  },
  {
    "codigo":127367000,
    "descripcion":"CUARTO EMBARAZO"
  },
  {
    "codigo":260274009,
    "descripcion":"VISIÓN A DISTANCIA 6\/12"
  },
  {
    "codigo":291207002,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR CLORPROTIXENO"
  },
  {
    "codigo":717191005,
    "descripcion":"SÍNDROME NEFRÓTICO RESISTENTE A ESTEROIDES IDIOPÁTICO ESPORÁDICO"
  },
  {
    "codigo":94599006,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE SENO ESFENOIDAL"
  },
  {
    "codigo":782727008,
    "descripcion":"PARAPLEJÍA ESPÁSTICA AUTOSÓMICA TIPO 72"
  },
  {
    "codigo":61831009,
    "descripcion":"TRASTORNO PSICÓTICO INDUCIDO"
  },
  {
    "codigo":289372006,
    "descripcion":"CABEZA FETAL 2\/5 POR ENCIMA DEL BORDE PÉLVICO"
  },
  {
    "codigo":15978991000119100,
    "descripcion":"TIMPANOESCLEROSIS DEL OÍDO MEDIO DERECHO"
  },
  {
    "codigo":92764008,
    "descripcion":"CARCINOMA IN SITU DE TESTÍCULO"
  },
  {
    "codigo":112981000119107,
    "descripcion":"ARTROSIS DE AMBAS ARTICULACIONES DE RODILLA"
  },
  {
    "codigo":1336113009,
    "descripcion":"SÍNDROME DE ATOPIA ASOCIADO AL MIEMBRO 11 DE LA FAMILIA DEL DOMINIO DE RECLUTAMIENTO DE CASPASAS CON INTERFERENCIA DOMINANTE DE LA SEÑALIZACIÓN DEL FACTOR NUCLEAR KAPPA-B"
  },
  {
    "codigo":449542003,
    "descripcion":"OBSTRUCCIÓN DEL TRACTO DE SALIDA EN VENTRÍCULO SOLITARIO INDETERMINADO"
  },
  {
    "codigo":332271000119104,
    "descripcion":"ECTASIA DE ESCLERÓTICA DERECHA"
  },
  {
    "codigo":447707005,
    "descripcion":"LEIOMIOSARCOMA DE CARDIAS"
  },
  {
    "codigo":414939007,
    "descripcion":"EN LISTA DE ESPERA SUSPENDIDA"
  },
  {
    "codigo":183728004,
    "descripcion":"CONSULTA DOMICILIARIA DE NEUROCIRUGÍA SOLICITADA"
  },
  {
    "codigo":249264005,
    "descripcion":"PREPUCIO ESTRECHO Y RETRAÍDO"
  },
  {
    "codigo":118192006,
    "descripcion":"HALLAZGO RELACIONADO CON EL AUTOCONCEPTO"
  },
  {
    "codigo":19888007,
    "descripcion":"ACUÑAMIENTO VERTEBRAL"
  },
  {
    "codigo":773552008,
    "descripcion":"SÍNDROME DE DISCAPACIDAD INTELECTUAL, DIFICULTADES EN LA ALIMENTACIÓN, RETRASO DEL DESARROLLO Y MICROCEFALIA"
  },
  {
    "codigo":708016009,
    "descripcion":"FIJACIÓN DESTRUCTIVA DE FRENILLO LABIAL"
  },
  {
    "codigo":181893002,
    "descripcion":"RESPIRACIÓN EXCESIVAMENTE PROFUNDA"
  },
  {
    "codigo":1197701002,
    "descripcion":"PANCREATITIS AUTOINMUNITARIA TIPO 1 CON COMPROMISO EXTRAPANCREÁTICO"
  },
  {
    "codigo":50821009,
    "descripcion":"OCLUSIÓN DE LA RAMA ARTERIAL RETINIANA"
  },
  {
    "codigo":1163098002,
    "descripcion":"ENCEFALITIS POR ECHOVIRUS HUMANO"
  },
  {
    "codigo":210991003,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE CABEZA, INFECTADA"
  },
  {
    "codigo":1259567003,
    "descripcion":"CARCINOMA PRIMARIO DUCTAL ECRINO DE PIEL"
  },
  {
    "codigo":276527006,
    "descripcion":"GASTRITIS DEL RECIÉN NACIDO"
  },
  {
    "codigo":473135008,
    "descripcion":"MIGRACIÓN DE CATÉTER SUPRAPÚBICO"
  },
  {
    "codigo":440367008,
    "descripcion":"COMPLICACIÓN DE INJERTO DE PIEL ARTIFICIAL"
  },
  {
    "codigo":1290500002,
    "descripcion":"SÍNDROME DE ACTIVACIÓN DE MACRÓFAGOS DEBIDO A ENFERMEDAD INFECCIOSA"
  },
  {
    "codigo":372996002,
    "descripcion":"INFECCIÓN CAUSADA POR ASPERGILLUS RESTRICTUS"
  },
  {
    "codigo":405764004,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA MÉDULA ESPINAL CERVICAL POSTERIOR SIN LESIÓN VERTEBRAL, C5-7"
  },
  {
    "codigo":471300007,
    "descripcion":"EN LISTA DE ESPERA PARA TRASPLANTE DE ÓRGANO"
  },
  {
    "codigo":371161001,
    "descripcion":"FACTURA EXPUESTA DE CRÁNEO"
  },
  {
    "codigo":240089002,
    "descripcion":"MIOPATÍA EN ACROMEGALIA"
  },
  {
    "codigo":403929003,
    "descripcion":"CARCINOMA TRIQUILEMAL"
  },
  {
    "codigo":698841004,
    "descripcion":"HERPES DE LA BARBA"
  },
  {
    "codigo":209156009,
    "descripcion":"SUBLUXACIÓN EXPUESTA ENTRE LA TERCERA Y CUARTA VÉRTEBRAS CERVICALES"
  },
  {
    "codigo":10713006,
    "descripcion":"ENFERMEDAD PULMONAR INTERSTICIAL DIFUSA REUMATOIDEA"
  },
  {
    "codigo":860846001,
    "descripcion":"GRANULOMA DE ESPACIO EPIDURAL ESPINAL CAUSADO POR BACTERIA"
  },
  {
    "codigo":1255897009,
    "descripcion":"LINFOMA DE HODGKIN DE GANGLIOS LINFÁTICOS DE MIEMBRO INFERIOR, PREDOMINIO LINFOCÍTICO-HISTIOCÍTICO"
  },
  {
    "codigo":305625009,
    "descripcion":"ATENDIDO POR CONSEJERO ESPECIALIZADO EN SALUD MENTAL"
  },
  {
    "codigo":762542004,
    "descripcion":"EROSIÓN DE AURÍCULA IZQUIERDA DEBIDA A IMPLANTE DE DISPOSITIVO Y POSTERIOR A ÉL"
  },
  {
    "codigo":1286830009,
    "descripcion":"HIPERTENSIÓN OCULAR FACOLÍTICA"
  },
  {
    "codigo":301955006,
    "descripcion":"IRIS NORMAL"
  },
  {
    "codigo":236419006,
    "descripcion":"GLOMERULONEFRITIS HEREDITARIA PROGRESIVA SIN SORDERA"
  },
  {
    "codigo":115491000119105,
    "descripcion":"DISFUNCIÓN PSICOSOCIAL DEBIDA A DOLOR CRÓNICO"
  },
  {
    "codigo":300120000,
    "descripcion":"PABELLÓN AURICULAR NORMAL"
  },
  {
    "codigo":1186691007,
    "descripcion":"AMBIENTE TRISTE"
  },
  {
    "codigo":1217624005,
    "descripcion":"DISTORSIÓN ORBITARIA CONGÉNITA"
  },
  {
    "codigo":688931000119106,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE CARA LATERAL DEL PISO DE LA BOCA"
  },
  {
    "codigo":234584007,
    "descripcion":"DEFICIENCIA DE TUFTSINA"
  },
  {
    "codigo":365656007,
    "descripcion":"CONCENTRACIÓN DE UROBILINÓGENO DETERMINADA CON TIRA REACTIVA - HALLAZGO"
  },
  {
    "codigo":5208008,
    "descripcion":"DISFONÍA FLÁCCIDA"
  },
  {
    "codigo":37976006,
    "descripcion":"ÍLEO BILIAR"
  },
  {
    "codigo":16636861000119101,
    "descripcion":"LESIÓN BILATERAL DE NERVIOS CIÁTICOS POPLÍTEOS EXTERNOS"
  },
  {
    "codigo":298285004,
    "descripcion":"ESCLERODERMIA CON COMPROMISO LIMITADO DE LA PIEL"
  },
  {
    "codigo":67074001,
    "descripcion":"INTOXICACIÓN POR EUCALIPTUS"
  },
  {
    "codigo":722434004,
    "descripcion":"DISESPONDILOENCONDROMATOSIS"
  },
  {
    "codigo":1538006,
    "descripcion":"ANOMALÍA DE SISTEMA NERVIOSO CENTRAL FETAL QUE AFECTA EL CUIDADO OBSTÉTRICO"
  },
  {
    "codigo":720599002,
    "descripcion":"CAMPOMELIA TIPO CUMMING"
  },
  {
    "codigo":425687007,
    "descripcion":"ESPINA BÍFIDA ABIERTA DE LA COLUMNA VERTEBRAL CERVICAL"
  },
  {
    "codigo":294615008,
    "descripcion":"ALERGIA A ETAMBUTOL"
  },
  {
    "codigo":292780001,
    "descripcion":"REACCIÓN ADVERSA A LUBRICANTES"
  },
  {
    "codigo":718764004,
    "descripcion":"DISPLASIA ESPONDILOEPIFISARIA TIPO REARDON"
  },
  {
    "codigo":128940004,
    "descripcion":"PARASITOSIS DE PULMÓN"
  },
  {
    "codigo":1144748009,
    "descripcion":"CONCENTRACIÓN ALTERADA"
  },
  {
    "codigo":127105001,
    "descripcion":"LINFADENOPATÍA TRAQUEOBRONQUIAL INFERIOR"
  },
  {
    "codigo":290945003,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR GABAPENTINA"
  },
  {
    "codigo":422017005,
    "descripcion":"EXCAVACIÓN COROIDEA, POR ECOGRAFÍA"
  },
  {
    "codigo":28801006,
    "descripcion":"ESCOLIOSIS INFANTIL IDIOPÁTICA RESOLUTIVA"
  },
  {
    "codigo":94337005,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE HUESO ILÍACO"
  },
  {
    "codigo":61569007,
    "descripcion":"AGORAFOBIA SIN ANTECEDENTES DE TRASTORNO DE PÁNICO"
  },
  {
    "codigo":715094000,
    "descripcion":"DIFICULTAD PARA PASAR DE LA SILLA A LA SILLA DE RUEDAS"
  },
  {
    "codigo":289110004,
    "descripcion":"RESOPLA"
  },
  {
    "codigo":188971001,
    "descripcion":"NEOPLASIA BENIGNA DE CALCÁNEO"
  },
  {
    "codigo":285440004,
    "descripcion":"DIFICULTAD PARA REALIZAR FUNCIONES MOTRICES ORALES"
  },
  {
    "codigo":1137408006,
    "descripcion":"DEBILIDAD DE MÚSCULO DE REGIÓN DE TOBILLO"
  },
  {
    "codigo":86997002,
    "descripcion":"SÍNDROME DEL CROMOSOMA 10 EN ANILLO"
  },
  {
    "codigo":21461006,
    "descripcion":"COLESTEROLOSIS DEL OÍDO MEDIO"
  },
  {
    "codigo":283605007,
    "descripcion":"HERIDA POR PINCHAZO DE AGUJA EN LA MEJILLA"
  },
  {
    "codigo":707754001,
    "descripcion":"HIPERALDOSTERONISMO PSEUDOPRIMARIO ADQUIRIDO"
  },
  {
    "codigo":185301009,
    "descripcion":"ATENDIDO POR RESIDENTE SUPERIOR DE MEDICINA FAMILIAR\/GENERAL"
  },
  {
    "codigo":281770004,
    "descripcion":"FORTALEZA DEL EGO - HALLAZGO"
  },
  {
    "codigo":609450004,
    "descripcion":"INTERRUPCIÓN INDUCIDA DEL EMBARAZO COMPLICADA POR INFECCIÓN GENITOPÉLVICA"
  },
  {
    "codigo":1363114004,
    "descripcion":"DISPLASIA EPIFISARIA MÚLTIPLE TIPO 7"
  },
  {
    "codigo":871594004,
    "descripcion":"ESTENOSIS CONGÉNITA DE VÁLVULA TRONCAL"
  },
  {
    "codigo":443775000,
    "descripcion":"COMPRESIÓN DE INTESTINO EN ADHERENCIAS ABDOMINALES"
  },
  {
    "codigo":314538009,
    "descripcion":"NEUROPATÍA ÓPTICA RELACIONADA CON EL TABAQUISMO"
  },
  {
    "codigo":771455002,
    "descripcion":"QUEMADURA DE AMBAS MUÑECAS Y MANOS"
  },
  {
    "codigo":247167001,
    "descripcion":"DESGARRO DE RETINA OPERCULADO"
  },
  {
    "codigo":312703006,
    "descripcion":"AGUJERO MACULAR DE ESPESOR TOTAL, ESTADIO III"
  },
  {
    "codigo":48724000,
    "descripcion":"INSUFICIENCIA DE VÁLVULA MITRAL"
  },
  {
    "codigo":11996401000119106,
    "descripcion":"NEUROMA DE MUÑÓN DE AMPUTACIÓN DE MIEMBRO INFERIOR IZQUIERDO"
  },
  {
    "codigo":337291000119100,
    "descripcion":"ECTROPIÓN CICATRIZAL SUPERIOR IZQUIERDO"
  },
  {
    "codigo":704084006,
    "descripcion":"FRACTURA NO EXPUESTA DE METÁFISIS DE TERCER METATARSIANO"
  },
  {
    "codigo":833321003,
    "descripcion":"DEGENERACIÓN HIDRÓPICA DE VELLOSIDADES CORIÓNICAS"
  },
  {
    "codigo":276265003,
    "descripcion":"DEFICIENCIA DE FERROQUELATASA"
  },
  {
    "codigo":866089007,
    "descripcion":"MEGALOCÓRNEA DE AMBOS OJOS"
  },
  {
    "codigo":12286000,
    "descripcion":"CALCIFICACIÓN SUPRARRENAL"
  },
  {
    "codigo":405502000,
    "descripcion":"DISTRACCIÓN DE MIEMBRO DEL PERSONAL"
  },
  {
    "codigo":307198001,
    "descripcion":"BRIDAS DEL INTESTINO DELGADO"
  },
  {
    "codigo":208894000,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE LA ARTICULACIÓN DE LA CADERA, POSTERIOR"
  },
  {
    "codigo":11806091000119103,
    "descripcion":"SUBLUXACIÓN LATERAL DE ARTICULACIÓN FEMORORROTULIANA IZQUIERDA"
  },
  {
    "codigo":698579002,
    "descripcion":"FIEBRE DESPUÉS DE VACUNACIÓN ANTIDIFTÉRICA"
  },
  {
    "codigo":403667002,
    "descripcion":"DERMATITIS RETINOIDE"
  },
  {
    "codigo":272595005,
    "descripcion":"RECOSTADO DE COSTADO SOBRE UN CABALLO"
  },
  {
    "codigo":10451007,
    "descripcion":"CAYADO AÓRTICO DOBLE"
  },
  {
    "codigo":1074571000119105,
    "descripcion":"OSTEOARTROSIS DE ARTICULACIÓN SACROILÍACA IZQUIERDA"
  },
  {
    "codigo":762280004,
    "descripcion":"INFECCIÓN CUTÁNEA DISEMINADA CAUSADA POR HERPES SIMPLE CONCOMITANTE CON ENFERMEDAD DE LA PIEL Y DEBIDA A ELLA"
  },
  {
    "codigo":9611000119107,
    "descripcion":"ESTENOSIS DE ARTERIA CARÓTIDA SINTOMÁTICA"
  },
  {
    "codigo":301693004,
    "descripcion":"CAPAZ DE MOVERSE HACIA ARRIBA Y HACIA ABAJO EN LA CAMA"
  },
  {
    "codigo":6781006,
    "descripcion":"INTOXICACIÓN POR ALLIUM"
  },
  {
    "codigo":39549008,
    "descripcion":"HIPOVENTILACIÓN CRÓNICA"
  },
  {
    "codigo":203389008,
    "descripcion":"OSTEOCONDROSIS JUVENIL DE CENTRO ROTULIANO SECUNDARIO"
  },
  {
    "codigo":365394004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA REALIZAR ACTIVIDADES RELACIONADAS CON LA TECNOLOGÍA DE LA INFORMACIÓN"
  },
  {
    "codigo":267090004,
    "descripcion":"TIENE PÁRPADOS CAÍDOS"
  },
  {
    "codigo":299858008,
    "descripcion":"REFLEJO SACRO DISMINUIDO"
  },
  {
    "codigo":37714008,
    "descripcion":"INTOXICACIÓN CAUSADA POR FÁRMACO QUERATOPLÁSTICO"
  },
  {
    "codigo":166951007,
    "descripcion":"NIVEL DE CARBAMAZEPINA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":230652001,
    "descripcion":"SÍNDROME DE FASCICULACIÓN-MIALGIA BENIGNO"
  },
  {
    "codigo":66812002,
    "descripcion":"ONDA T APLANADA"
  },
  {
    "codigo":296188001,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE HALOPERIDOL"
  },
  {
    "codigo":196049002,
    "descripcion":"ENFERMEDAD PULMONAR CRÓNICA POR RADIACIÓN"
  },
  {
    "codigo":16012991000119101,
    "descripcion":"TROMBOSIS DE ARTERIA FEMORAL IZQUIERDA"
  },
  {
    "codigo":292518004,
    "descripcion":"REACCIÓN ADVERSA A LA DOPAMINA"
  },
  {
    "codigo":95910006,
    "descripcion":"TOLERANCIA FARMACOLÓGICA ANORMAL"
  },
  {
    "codigo":1306491000,
    "descripcion":"CARCINOMA DUCTAL INFILTRANTE PRIMARIO DE CUADRANTE SUPERIOR EXTERNO DE MAMA DERECHA"
  },
  {
    "codigo":423590009,
    "descripcion":"COLITIS POR CLOSTRIDIUM DIFFICILE"
  },
  {
    "codigo":94075002,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA SUBGLOTIS"
  },
  {
    "codigo":716667005,
    "descripcion":"ATROFIA DE LÓBULO TEMPORAL DERECHO"
  },
  {
    "codigo":126843007,
    "descripcion":"NEOPLASIA DEL ÁNGULO ESPLÉNICO DEL COLON"
  },
  {
    "codigo":366643009,
    "descripcion":"AMPLITUD DE EVERSIÓN ACTIVA DE ARTICULACIÓN SUBASTRAGALINA - HALLAZGO"
  },
  {
    "codigo":288848001,
    "descripcion":"CAPAZ DE RESPIRAR"
  },
  {
    "codigo":419920004,
    "descripcion":"HIPERPLASIA SUPRARRENAL"
  },
  {
    "codigo":92240006,
    "descripcion":"NEOPLASIA BENIGNA DE HUESO DE LA NARIZ"
  },
  {
    "codigo":418085001,
    "descripcion":"ALERGIA A FRUTA CÍTRICA"
  },
  {
    "codigo":15740761000119102,
    "descripcion":"ALMOHADILLAS DE NUDILLOS DE LA MANO DERECHA"
  },
  {
    "codigo":711162004,
    "descripcion":"VITREORRETINOCOROIDOPATÍA AUTOSÓMICA DOMINANTE"
  },
  {
    "codigo":339801000119103,
    "descripcion":"ENTROPIÓN DEL PÁRPADO INFERIOR IZQUIERDO"
  },
  {
    "codigo":23034007,
    "descripcion":"HÁLITO DE DIMETILCETONA"
  },
  {
    "codigo":283343004,
    "descripcion":"PICADURA DE INSECTO EN EL TALÓN"
  },
  {
    "codigo":1299151005,
    "descripcion":"SÍNDROME DE O'SULLIVAN MCLEOD"
  },
  {
    "codigo":707492001,
    "descripcion":"CARCINOMA PRIMARIO DE CÉLULAS ESCAMOSAS DE HIPOFARINGE"
  },
  {
    "codigo":1297316002,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE QUINTO DEDO DE PIE"
  },
  {
    "codigo":19364004,
    "descripcion":"URTICARIA DE CONTACTO"
  },
  {
    "codigo":10907481000119106,
    "descripcion":"HERIDA DE ARMA DE FUEGO EN REGIÓN AXILAR DERECHA"
  },
  {
    "codigo":84900008,
    "descripcion":"LACERACIÓN CEREBELOSA CON HERIDA INTRACRANEAL ABIERTA Y PÉRDIDA DE CONSCIENCIA"
  },
  {
    "codigo":1295481000,
    "descripcion":"OSTEOPOROSIS DEBIDA A TRASTORNO ENDOCRINOLÓGICO"
  },
  {
    "codigo":246905002,
    "descripcion":"LESIÓN FOCAL DE CONJUNTIVA PALPEBRAL"
  },
  {
    "codigo":115833001,
    "descripcion":"IN"
  },
  {
    "codigo":212302000,
    "descripcion":"CONTUSIÓN, NERVIO INTERÓSEO POSTERIOR"
  },
  {
    "codigo":277838008,
    "descripcion":"ANSIEDAD ACERCA DE PARECER RIDÍCULO"
  },
  {
    "codigo":119731000146105,
    "descripcion":"MIOCARDIOPATÍA DEBIDA A COVID-19"
  },
  {
    "codigo":13859001,
    "descripcion":"MELLIZOS RECIÉN NACIDOS PREMATUROS"
  },
  {
    "codigo":1259043003,
    "descripcion":"SÍNDROME DE COLA DE CABALLO DEBIDO A ESTENOSIS ESPINAL"
  },
  {
    "codigo":15632371000119104,
    "descripcion":"TRASTORNO DE AMBAS ARTICULACIONES ROTULOFEMORALES"
  },
  {
    "codigo":46627006,
    "descripcion":"CORIORRETINITIS"
  },
  {
    "codigo":79395009,
    "descripcion":"PELO SECO"
  },
  {
    "codigo":77560002,
    "descripcion":"DERMATITIS POR CONTACTO CAUSADA POR CINTA ADHESIVA"
  },
  {
    "codigo":208632002,
    "descripcion":"FRACTURA EXPUESTA DE TIBIA Y PERONÉ, DIÁFISIS"
  },
  {
    "codigo":306936007,
    "descripcion":"RESTOS EPITELIALES DE LA CAVIDAD MASTOIDEA"
  },
  {
    "codigo":274168009,
    "descripcion":"ÓRGANOS GENITALES - HERIDA ABIERTA"
  },
  {
    "codigo":403405003,
    "descripcion":"POIQUILODERMIA CAUSADA POR LESIÓN POR FRÍO"
  },
  {
    "codigo":313331000119108,
    "descripcion":"ARTROFITO EN ARTICULACIÓN DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":698317008,
    "descripcion":"SANGRE EN VÓMITO DEL RECIÉN NACIDO DEBIDA A SANGRE MATERNA DEGLUTIDA"
  },
  {
    "codigo":270498000,
    "descripcion":"ANOMALÍA DE POSICIÓN Y PRESENTACIÓN FETAL"
  },
  {
    "codigo":303266002,
    "descripcion":"APLASIA DE MÉDULA ÓSEA"
  },
  {
    "codigo":237730003,
    "descripcion":"SOBREACTIVIDAD HIPOTALÁMICA"
  },
  {
    "codigo":1351842006,
    "descripcion":"SÍNDROME DE BROWN-SÉQUARD DEBIDO A ISQUEMIA"
  },
  {
    "codigo":1153399000,
    "descripcion":"ELIPTOCITOSIS HEREDITARIA HOMOCIGÓTICA"
  },
  {
    "codigo":235895002,
    "descripcion":"CIRROSIS DE LAENNEC, NO ALCOHÓLICA"
  },
  {
    "codigo":15933581000119104,
    "descripcion":"QUISTE DE TROMPA DE FALOPIO IZQUIERDA"
  },
  {
    "codigo":268663007,
    "descripcion":"ROBO SOLITARIO"
  },
  {
    "codigo":299596000,
    "descripcion":"AMPLITUD DE EXTENSIÓN ACTIVA DE DEDO DEL PIE NORMAL"
  },
  {
    "codigo":397900003,
    "descripcion":"GANGRENA DE FOURNIER DE PENE"
  },
  {
    "codigo":102988004,
    "descripcion":"PRUEBA DE LA MARCHA EN LÍNEA RECTA CON RESULTADOS ANORMALES"
  },
  {
    "codigo":234060006,
    "descripcion":"ESTENOSIS DE LA VENA SUBCLAVIA"
  },
  {
    "codigo":10664231000119100,
    "descripcion":"ÚLCERA ISQUÉMICA ATEROSCLERÓTICA DE PANTORRILLA DERECHA"
  },
  {
    "codigo":365132009,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA MOVERSE EN LA CAMA"
  },
  {
    "codigo":166689004,
    "descripcion":"NIVEL DE POTASIO SÉRICO POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":363297005,
    "descripcion":"SECUELAS DE ENDOCRINOPATÍAS"
  },
  {
    "codigo":723745006,
    "descripcion":"DESCRIPCIÓN MORFOLÓGICA SOLAMENTE, CON DIAGNÓSTICO DIFERENCIAL"
  },
  {
    "codigo":232225005,
    "descripcion":"OTITIS EXTERNA BACTERIANA CRÓNICA"
  },
  {
    "codigo":164854000,
    "descripcion":"ELECTROCARDIOGRAMA NORMAL"
  },
  {
    "codigo":787446001,
    "descripcion":"PERIODONTITIS LOCALIZADA"
  },
  {
    "codigo":263158007,
    "descripcion":"FRACTURA TOTAL DE ALVÉOLO MAXILAR"
  },
  {
    "codigo":294091002,
    "descripcion":"ALERGIA A DORNASA ALFA"
  },
  {
    "codigo":195787006,
    "descripcion":"FÍSTULA DE SENO PARANASAL"
  },
  {
    "codigo":1079591000119105,
    "descripcion":"CONDROSARCOMA PRIMARIO DE OMÓPLATO IZQUIERDO"
  },
  {
    "codigo":64715009,
    "descripcion":"CARDIOPATÍA HIPERTENSIVA"
  },
  {
    "codigo":292256004,
    "descripcion":"REACCIÓN ADVERSA A LA CICLOSPORINA"
  },
  {
    "codigo":30112004,
    "descripcion":"INTOXICACIÓN POR MELIANTHUS"
  },
  {
    "codigo":1176992006,
    "descripcion":"ABSCESO MICOBACTERIANO DE MÉDULA ESPINAL"
  },
  {
    "codigo":28277004,
    "descripcion":"CONDUCTA MOTORA AUMENTADA"
  },
  {
    "codigo":290421005,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR METOCLOPRAMIDA"
  },
  {
    "codigo":126581008,
    "descripcion":"NEOPLASIA DE HUESO DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":716405009,
    "descripcion":"CAPAZ DE SECAR LA PARTE SUPERIOR DEL CUERPO"
  },
  {
    "codigo":190282003,
    "descripcion":"HIPOTIROIDISMO POR ÁCIDO PARAAMINOSALICÍLICO"
  },
  {
    "codigo":91978004,
    "descripcion":"NEOPLASIA BENIGNA DEL ANO"
  },
  {
    "codigo":26442006,
    "descripcion":"FRACTURA NO EXPUESTA DE DIÁFISIS DE FÉMUR"
  },
  {
    "codigo":57375005,
    "descripcion":"HIPERPLASIA EOSINOFÍLICA DE LA MÉDULA ÓSEA"
  },
  {
    "codigo":286751005,
    "descripcion":"CARÁCTER GENEROSO"
  },
  {
    "codigo":1237023008,
    "descripcion":"CON RIESGO ELEVADO DE EXPOSICIÓN A NEISSERIA MENINGITIDIS"
  },
  {
    "codigo":90143008,
    "descripcion":"INTOXICACIÓN POR ASTRAGALUS"
  },
  {
    "codigo":10965441000119105,
    "descripcion":"HERIDA ABIERTA DE CADERA IZQUIERDA DEBIDA A MORDEDURA HUMANA"
  },
  {
    "codigo":11784641000119105,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE REGIÓN DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":186612006,
    "descripcion":"FIEBRE POR PIXUNA"
  },
  {
    "codigo":448756008,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE HOMBRO Y BRAZO CON INFECCIÓN"
  },
  {
    "codigo":283081001,
    "descripcion":"ARAÑAZO DE ANTEBRAZO"
  },
  {
    "codigo":86473001,
    "descripcion":"EFECTO TÓXICO DEL ÉTER DE PETRÓLEO"
  },
  {
    "codigo":284916008,
    "descripcion":"NO USA PALANGANA"
  },
  {
    "codigo":20937004,
    "descripcion":"DISPROSODIA MOTORA"
  },
  {
    "codigo":709065005,
    "descripcion":"ALETEO CARDÍACO POSOPERATORIO"
  },
  {
    "codigo":414153008,
    "descripcion":"EXACERBACIÓN DE ENFERMEDAD DE CROHN DEL INTESTINO GRUESO"
  },
  {
    "codigo":314014002,
    "descripcion":"MACULOPATÍA ISQUÉMICA DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":445086005,
    "descripcion":"EMBARAZO QUÍMICO"
  },
  {
    "codigo":1231518006,
    "descripcion":"SIGNO DE FÓVEA CUBITAL"
  },
  {
    "codigo":1297054005,
    "descripcion":"CIERRE DE ÁNGULO POSOPERATORIO DE OJO DERECHO"
  },
  {
    "codigo":838302008,
    "descripcion":"TRASTORNO DE VEJIGA URINARIA CAUSADO POR SCHISTOSOMA JAPONICUM"
  },
  {
    "codigo":246643002,
    "descripcion":"VE RAYOS"
  },
  {
    "codigo":310344001,
    "descripcion":"EL PACIENTE ACUDIÓ PARA UNA SEGUNDA OPINIÓN"
  },
  {
    "codigo":408648004,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS DE LA EPIGLOTIS"
  },
  {
    "codigo":111901001,
    "descripcion":"GRANULOMATOSIS BRONCOCÉNTRICA"
  },
  {
    "codigo":48200009,
    "descripcion":"TRASTORNO DE LOS HUESOS Y\/O DE LAS ARTICULACIONES DE LAS EXTREMIDADES INFERIORES EN LA MADRE, QUE COMPLICA EL EMBARAZO, EL PARTO Y\/O EL PUERPERIO"
  },
  {
    "codigo":46365005,
    "descripcion":"INTENTO FALLIDO DE ABORTO CON PERFORACIÓN DE TEJIDO PERIURETRAL"
  },
  {
    "codigo":242973005,
    "descripcion":"TESTIGO DE EXHIBICIÓN IMPÚDICA"
  },
  {
    "codigo":210205007,
    "descripcion":"HEMATOMA DE RIÑÓN SIN RUPTURA DE LA CÁPSULA, CON HERIDA ABIERTA HACIA CAVIDAD"
  },
  {
    "codigo":275741008,
    "descripcion":"LEUCOCITOS EN ORINA"
  },
  {
    "codigo":110066001,
    "descripcion":"AVULSIÓN DE PABELLÓN AURICULAR"
  },
  {
    "codigo":208370006,
    "descripcion":"FRACTURA NO EXPUESTA DEL ESCAFOIDES, POLO PROXIMAL"
  },
  {
    "codigo":672501000119104,
    "descripcion":"DISARTRIA DEBIDA A ACCIDENTE CEREBROVASCULAR ISQUÉMICO Y POSTERIOR A ÉL"
  },
  {
    "codigo":1156807006,
    "descripcion":"NEOPLASIA NEUROECTODÉRMICA PERIFÉRICA DE CUELLO UTERINO"
  },
  {
    "codigo":698055008,
    "descripcion":"SIALADENITIS NECROSANTE SUBAGUDA"
  },
  {
    "codigo":403143009,
    "descripcion":"TIRIOSIS DE LAS PESTAÑAS"
  },
  {
    "codigo":237468000,
    "descripcion":"PAPILOMA CUTÁNEO DEL PEZÓN"
  },
  {
    "codigo":204700004,
    "descripcion":"ESTENOSIS ILEAL CONGÉNITA"
  },
  {
    "codigo":1082101000119106,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE PIEL DE MIEMBRO INFERIOR IZQUIERDO"
  },
  {
    "codigo":344821000119107,
    "descripcion":"AGRANDAMIENTO BILATERAL DE ÓRBITAS"
  },
  {
    "codigo":15637391000119101,
    "descripcion":"ALTERACIÓN DE MENISCO DE RODILLA DERECHA"
  },
  {
    "codigo":366705003,
    "descripcion":"AMPLITUD DE MOVIMIENTO ACTIVO DE FLEXIÓN DE DEDO DEL PIE - HALLAZGO"
  },
  {
    "codigo":301169005,
    "descripcion":"PULSO TIBIAL POSTERIOR AUSENTE"
  },
  {
    "codigo":235633005,
    "descripcion":"BARRA CRICOFARÍNGEA"
  },
  {
    "codigo":399473002,
    "descripcion":"HIPERPLASIA SIMPLE ENDOMETRIAL ATÍPICA"
  },
  {
    "codigo":364870001,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA CARGAR PESO"
  },
  {
    "codigo":168262007,
    "descripcion":"HONGO AISLADO EN EXAMEN POSTMORTEM"
  },
  {
    "codigo":233798007,
    "descripcion":"BRONCOMALACIA ADQUIRIDA"
  },
  {
    "codigo":363035006,
    "descripcion":"ANOMALÍA CONGÉNITA DEL TÓRAX"
  },
  {
    "codigo":231963007,
    "descripcion":"QUISTE MIÓTICO DEL CUERPO CILIAR"
  },
  {
    "codigo":166427008,
    "descripcion":"NIVEL DE LACTÓGENO PLACENTARIO HUMANO DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":789019009,
    "descripcion":"RADICULOPATÍA DEBIDA A ENFERMEDAD NEOPLÁSICA"
  },
  {
    "codigo":262896001,
    "descripcion":"PERFORACIÓN DE URÉTER"
  },
  {
    "codigo":361200005,
    "descripcion":"URTICARIA FAMILIAR FEBRIL"
  },
  {
    "codigo":293829000,
    "descripcion":"ALERGIA A AMITRIPTILINA"
  },
  {
    "codigo":392133001,
    "descripcion":"SÍNDROME DE DISPERSIÓN PIGMENTARIA"
  },
  {
    "codigo":295664009,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE BLEOMICINA"
  },
  {
    "codigo":719813003,
    "descripcion":"DISOSTOSIS MANDIBULOFACIAL LIGADA AL CROMOSOMA X"
  },
  {
    "codigo":721648009,
    "descripcion":"DIVERTÍCULO CONGÉNITO DE INTESTINO DELGADO"
  },
  {
    "codigo":228293006,
    "descripcion":"BEBE EN RESTAURANTES"
  },
  {
    "codigo":95386001,
    "descripcion":"TROMBOSIS DEL SITIO DE INYECCIÓN"
  },
  {
    "codigo":423066003,
    "descripcion":"HALLAZGO RELACIONADO CON LA REGIÓN BUCAL"
  },
  {
    "codigo":62618004,
    "descripcion":"TOS MATINAL"
  },
  {
    "codigo":193690006,
    "descripcion":"UMBRAL ANORMAL DE CONOS O BASTONES"
  },
  {
    "codigo":717978008,
    "descripcion":"OPACIDADES DE AMBOS PULMONES EN RADIOGRAFÍA SIMPLE DE TÓRAX"
  },
  {
    "codigo":191855005,
    "descripcion":"ADICCIÓN A LA ASPIRACIÓN DE PEGAMENTO, CONTINUA"
  },
  {
    "codigo":290159006,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR DEXTROMORAMIDA"
  },
  {
    "codigo":778009001,
    "descripcion":"SÍNDROME DE BLEFAROFIMOSIS Y DISCAPACIDAD INTELECTUAL, TIPO VERLOES"
  },
  {
    "codigo":253721001,
    "descripcion":"FÍSTULA AISLADA DE ARTERIA CORONARIA"
  },
  {
    "codigo":1269529003,
    "descripcion":"SÍNDROME DE CORDÓN CENTRAL DEBIDO A LESIÓN TRAUMÁTICA"
  },
  {
    "codigo":286489001,
    "descripcion":"CAPAZ DE PREPARAR COMIDA"
  },
  {
    "codigo":128041000119107,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE TERCIO DISTAL DE ESÓFAGO"
  },
  {
    "codigo":1163144004,
    "descripcion":"COLITIS CAUSADA POR BALANTIDIUM COLI"
  },
  {
    "codigo":446659000,
    "descripcion":"DESEQUILIBRIO VENTRICULAR CON VENTRÍCULO IZQUIERDO DOMINANTE Y VENTRÍCULO DERECHO HIPOPLÁSICO"
  },
  {
    "codigo":315587001,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: TAMIL"
  },
  {
    "codigo":250051002,
    "descripcion":"MARCHA FRONTAL"
  },
  {
    "codigo":53443007,
    "descripcion":"TRABAJO DE PARTO PROLONGADO"
  },
  {
    "codigo":347331000119105,
    "descripcion":"DACRIOCISTITIS AGUDA DE AMBOS OJOS"
  },
  {
    "codigo":1264024002,
    "descripcion":"DOLOR EN MÚLTIPLES MÚSCULOS"
  },
  {
    "codigo":280984005,
    "descripcion":"PATRÓN DE USO NOCIVO DE HIERBAS MEDICINALES"
  },
  {
    "codigo":1231256006,
    "descripcion":"DESVIACIÓN INTERMITENTE DE LA MIRADA CONJUGADA HORIZONTAL"
  },
  {
    "codigo":49773000,
    "descripcion":"INFECCIÓN CAUSADA POR CARYOPHYLLAEUS"
  },
  {
    "codigo":248216009,
    "descripcion":"CAMBIOS DEL CUTIS"
  },
  {
    "codigo":770669004,
    "descripcion":"DISOMÍA UNIPARENTAL PATERNA DEL CROMOSOMA 5"
  },
  {
    "codigo":211778000,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL SUPERFICIAL DE GENITALES"
  },
  {
    "codigo":703298001,
    "descripcion":"MALFORMACIÓN LINFÁTICA DIFUSA"
  },
  {
    "codigo":408386002,
    "descripcion":"VAGINITIS ATRÓFICA PERIMENOPÁUSICA"
  },
  {
    "codigo":47938003,
    "descripcion":"BRONQUIOLITIS OBLITERANTE CRÓNICA"
  },
  {
    "codigo":1293122004,
    "descripcion":"TROMBOSIS DE VENA ESPLÁCNICA"
  },
  {
    "codigo":1260354005,
    "descripcion":"DEMENCIA FRONTOTEMPORAL DEBIDA A MUTACIÓN DE GEN C9ORF72"
  },
  {
    "codigo":15170009,
    "descripcion":"LINFADENITIS SUBMANDIBULAR"
  },
  {
    "codigo":766999004,
    "descripcion":"AUSENCIA CONGÉNITA DE PIE IZQUIERDO"
  },
  {
    "codigo":13335004,
    "descripcion":"GLOMERULONEFRITIS ESCLEROSANTE"
  },
  {
    "codigo":111639006,
    "descripcion":"FRACTURA NO EXPUESTA DE ACROMION DEL OMÓPLATO"
  },
  {
    "codigo":1356823008,
    "descripcion":"SÍNDROME CONSTITUCIONAL DE DEFICIENCIA DE REPARACIÓN DE EMPAREJAMIENTOS ERRÓNEOS DEBIDO A MUTACIÓN DEL HOMÓLOGO 2 DE PMS1, COMPONENTE DEL SISTEMA DE REPARACIÓN DE EMPAREJAMIENTOS ERRÓNEOS"
  },
  {
    "codigo":251443003,
    "descripcion":"ARTIFICIO DEL ELECTROENCEFALOGRAMA - MOVIMIENTO DEL PACIENTE"
  },
  {
    "codigo":109804004,
    "descripcion":"QUEILITIS MEDICAMENTOSA"
  },
  {
    "codigo":44268007,
    "descripcion":"RETINOSQUISIS"
  },
  {
    "codigo":271809000,
    "descripcion":"EDEMA PERIFÉRICO"
  },
  {
    "codigo":1287617000,
    "descripcion":"CRISIS EPILÉPTICA ELECTROCLÍNICA MOTORA DE INICIO FOCAL NEONATAL"
  },
  {
    "codigo":320861000119107,
    "descripcion":"QUISTE ÓSEO SOLITARIO DEL HÚMERO IZQUIERDO"
  },
  {
    "codigo":402881008,
    "descripcion":"LINFOMA CUTÁNEO PRIMARIO DE CÉLULAS B"
  },
  {
    "codigo":9665009,
    "descripcion":"LESIÓN TRAUMÁTICA POR FRICCIÓN OCUPACIONAL DE DIENTE"
  },
  {
    "codigo":130551000119103,
    "descripcion":"STENT EN RAMA DE ARTERIA CORONARIA DERECHA"
  },
  {
    "codigo":106134006,
    "descripcion":"PERCEPCIÓN Y\/O TRASTORNO DE LA PERCEPCIÓN"
  },
  {
    "codigo":827030006,
    "descripcion":"FASE DE RECUPERACIÓN LENTA DE REFLEJO"
  },
  {
    "codigo":401046009,
    "descripcion":"SÍNDROME DE NICOLAIDES-BARAITSER"
  },
  {
    "codigo":71531003,
    "descripcion":"POSICIÓN FRONTOILÍACA DERECHA ANTERIOR"
  },
  {
    "codigo":366443004,
    "descripcion":"REFLEJO BICIPITAL - HALLAZGO"
  },
  {
    "codigo":202603007,
    "descripcion":"CHASQUIDO DE ARTICULACIÓN METACARPOFALÁNGICA"
  },
  {
    "codigo":299072000,
    "descripcion":"AMPLITUD DE FLEXIÓN PASIVA DE DEDO DE LA MANO DISMINUIDA"
  },
  {
    "codigo":30171000175105,
    "descripcion":"ÚLCERA POR PRESIÓN EN TOBILLO IZQUIERDO, ESTADIO III"
  },
  {
    "codigo":4160001,
    "descripcion":"ANOMALÍA CONGÉNITA DEL APARATO RESPIRATORIO SUPERIOR"
  },
  {
    "codigo":397376003,
    "descripcion":"PROFUNDIDAD DE LA INVASIÓN TUMORAL NO PUEDE DETERMINARSE"
  },
  {
    "codigo":11845111000119106,
    "descripcion":"FÍSTULA CAVERNOSA CAROTÍDEA DERECHA TRAUMÁTICA"
  },
  {
    "codigo":102464007,
    "descripcion":"SENSIBILIDAD NORMAL A LAS INFECCIONES"
  },
  {
    "codigo":168000008,
    "descripcion":"ESPUTO: CÉLULAS SANGUÍNEAS PRESENTES"
  },
  {
    "codigo":29930001000004103,
    "descripcion":"DOLOR LUMBAR RESISTENTE AL TRATAMIENTO"
  },
  {
    "codigo":32170001000004105,
    "descripcion":"ABSCESO SUPRAPÚBICO"
  },
  {
    "codigo":10753681000119101,
    "descripcion":"HIPOTIROIDISMO POSPARTO"
  },
  {
    "codigo":297237003,
    "descripcion":"DEFICIENCIA GENERALIZADA DE URIDINA DIFOSFATO GALACTOSA-4-EPIMERASA"
  },
  {
    "codigo":166165005,
    "descripcion":"ESTUDIOS DE ANTICUERPOS NORMALES"
  },
  {
    "codigo":395541000,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA DE MUCOSA AFECTADO POR NEOPLASIA MALIGNA"
  },
  {
    "codigo":13290001000004109,
    "descripcion":"ASPERGILLUS AISLADO EN CULTIVO DE ESPUTO"
  },
  {
    "codigo":788757008,
    "descripcion":"PITUICITOMA DE GLÁNDULA HIPÓFISIS POSTERIOR"
  },
  {
    "codigo":295402000,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE LOPERAMIDA"
  },
  {
    "codigo":15668881000119102,
    "descripcion":"DEFORMIDAD CONGÉNITA DE ARTICULACIÓN DE AMBAS RODILLAS"
  },
  {
    "codigo":104081000119103,
    "descripcion":"PAPILOMA INVERTIDO BENIGNO"
  },
  {
    "codigo":721386006,
    "descripcion":"SÍNDROME DEL CORDÓN ANTERIOR DE MÉDULA ESPINAL AL NIVEL DEL SEXTO SEGMENTO CERVICAL"
  },
  {
    "codigo":490008,
    "descripcion":"REACCIÓN ALÉRGICA DE VÍAS AÉREAS SUPERIORES"
  },
  {
    "codigo":33258008,
    "descripcion":"MIOCARDIOPATÍA RESTRICTIVA ENDOMIOCÁRDICA EOSINÓFILA PRIMARIA"
  },
  {
    "codigo":162495007,
    "descripcion":"SÍNTOMA QUE APARECE A LA NOCHE"
  },
  {
    "codigo":719551008,
    "descripcion":"HEMATURIA DEBIDA A CISTITIS POR RADIACIÓN"
  },
  {
    "codigo":293567009,
    "descripcion":"REACCIÓN ADVERSA A AGENTE ANTIVARICOSO"
  },
  {
    "codigo":193428001,
    "descripcion":"DEFICIENCIA DE LOS FASCÍCULOS DE FIBRAS NERVIOSAS RETINIANAS"
  },
  {
    "codigo":129727007,
    "descripcion":"DISMINUCIÓN DEL NÚMERO DE CALCIFICACIONES DESDE LA ÚLTIMA MAMOGRAFÍA"
  },
  {
    "codigo":226196004,
    "descripcion":"DIETA CON BAJO CONTENIDO EN TIRAMINA"
  },
  {
    "codigo":160660005,
    "descripcion":"DIETA INICIADA POR EL PACIENTE"
  },
  {
    "codigo":95124006,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE HUESO DEL TARSO"
  },
  {
    "codigo":62356006,
    "descripcion":"FRACTURA EXPUESTA SUPRACONDÍLEA DE HÚMERO"
  },
  {
    "codigo":289897002,
    "descripcion":"HALLAZGO RELACIONADO CON LAS MEDICIONES DE LA MENSTRUACIÓN"
  },
  {
    "codigo":715881003,
    "descripcion":"ENTEROBACTERIACEAE PRODUCTORAS DE CARBAPENEMASA"
  },
  {
    "codigo":1141865005,
    "descripcion":"SÍNTOMA PSEUDOBULBAR"
  },
  {
    "codigo":191593007,
    "descripcion":"EPISODIOS MANÍACOS RECURRENTES, MODERADOS"
  },
  {
    "codigo":124222000,
    "descripcion":"DEFICIENCIA DE ESTRADIOL 6BETA - MONOOXIGENASA"
  },
  {
    "codigo":189758001,
    "descripcion":"MELANOMA IN SITU"
  },
  {
    "codigo":91454002,
    "descripcion":"PLEOCITOSIS"
  },
  {
    "codigo":286227004,
    "descripcion":"NO USA EL FLUJO DE AIRE GLÓTICO AL HABLAR"
  },
  {
    "codigo":44311000087100,
    "descripcion":"CONTUSIÓN DE CÓNDILO EXTERNO DE TIBIA IZQUIERDA"
  },
  {
    "codigo":41751000087100,
    "descripcion":"CELULITIS DE DEDO ÍNDICE DERECHO"
  },
  {
    "codigo":39191000087108,
    "descripcion":"DOLOR NEUROPÁTICO CENTRAL CRÓNICO DEBIDO A LESIÓN ESPINAL"
  },
  {
    "codigo":448232005,
    "descripcion":"HEMANGIOMA DE COLUMNA VERTEBRAL"
  },
  {
    "codigo":249789000,
    "descripcion":"PIERNAS CORTAS PROPORCIONADAS"
  },
  {
    "codigo":55016009,
    "descripcion":"SÍNDROME CEREBRAL - HIPERTROFIA CONGÉNITA MUSCULAR"
  },
  {
    "codigo":85949006,
    "descripcion":"EUFORIA"
  },
  {
    "codigo":53181008,
    "descripcion":"MARCAS POR RASCADO"
  },
  {
    "codigo":708541009,
    "descripcion":"ABLÉFARON COMPLETO"
  },
  {
    "codigo":282557009,
    "descripcion":"DIFICULTAD PARA DOBLAR ESQUINAS AL CORRER"
  },
  {
    "codigo":247954003,
    "descripcion":"SUEÑOS REPETITIVOS"
  },
  {
    "codigo":84114007,
    "descripcion":"INSUFICIENCIA CARDÍACA"
  },
  {
    "codigo":870546007,
    "descripcion":"INCAPAZ DE MANEJAR CORRESPONDENCIA"
  },
  {
    "codigo":442727004,
    "descripcion":"HALLAZGO RELACIONADO CON DIFERENCIA EN LA SIMETRÍA EN COMPARACIÓN CON EXAMEN RADIOLÓGICO PREVIO"
  },
  {
    "codigo":770407006,
    "descripcion":"ERITROCITOSIS DE CHUVASH"
  },
  {
    "codigo":1260092001,
    "descripcion":"CARCINOMA BRONQUIOLOALVEOLAR MIXTO MUCINOSO Y NO MUCINOSO DE PULMÓN"
  },
  {
    "codigo":735804004,
    "descripcion":"LACERACIÓN DE TENDÓN DE MANGUITO ROTADOR"
  },
  {
    "codigo":703036008,
    "descripcion":"PREVOTELLA BUCCALIS O PREVOTELLA VERORALIS"
  },
  {
    "codigo":209681006,
    "descripcion":"SECCIÓN EXPUESTA DE LIGAMENTO DE DEDO, ARTICULACIÓN METACARPOFALÁNGICA, LIGAMENTO LATERAL RADIAL"
  },
  {
    "codigo":78609007,
    "descripcion":"DERRAME PERITONEAL CRÓNICO"
  },
  {
    "codigo":45841007,
    "descripcion":"ENFERMEDAD DE CADENA LIVIANA KAPPA"
  },
  {
    "codigo":111377009,
    "descripcion":"ACIDOSIS METABÓLICA, BRECHA ANIÓNICA NORMAL"
  },
  {
    "codigo":44006003,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE LA NARIZ, CON INFECCIÓN"
  },
  {
    "codigo":109542004,
    "descripcion":"FALLA DE ERUPCIÓN DENTAL"
  },
  {
    "codigo":249389151000119103,
    "descripcion":"MELANOMA MALIGNO DE PIEL DE MUÑECA DERECHA"
  },
  {
    "codigo":371686006,
    "descripcion":"INFECCIÓN CAUSADA POR GRUPO MYCOBACTERIUM AVIUM-INTRACELLULARE"
  },
  {
    "codigo":763067000,
    "descripcion":"ATROFIA CONGÉNITA BENIGNA DE MÚSCULOS ESPINALES AUTOSÓMICA DOMINANTE"
  },
  {
    "codigo":402619003,
    "descripcion":"PIGMENTACIÓN CAUSADA POR DIETA"
  },
  {
    "codigo":271547004,
    "descripcion":"CRISIS DE STOKES-ADAMS"
  },
  {
    "codigo":304315004,
    "descripcion":"AMPLITUD DE MOVIMIENTO DE LA CADERA NORMAL"
  },
  {
    "codigo":1252752000,
    "descripcion":"LESIÓN TRAUMÁTICA MUSCULAR DE MUSLO"
  },
  {
    "codigo":366181003,
    "descripcion":"HALLAZGO EN EL ASPECTO DE UNA DERIVACIÓN CARDIOVASCULAR"
  },
  {
    "codigo":235109003,
    "descripcion":"LUXACIÓN DE LA ARTICULACIÓN TEMPOROMANDIBULAR - NO TRAUMÁTICA"
  },
  {
    "codigo":726629006,
    "descripcion":"SÍNDROME DE DEFECTO DEL CUERO CABELLUDO Y POLIDACTILIA POSTAXIAL"
  },
  {
    "codigo":38501006,
    "descripcion":"HEMATOMA ATRAUMÁTICO DEL CUERPO CAVERNOSO"
  },
  {
    "codigo":71269007,
    "descripcion":"FUNCIÓN HEMOSTÁTICA NORMAL"
  },
  {
    "codigo":69434005,
    "descripcion":"INTOXICACIÓN POR ANTIDEPRESIVO TRICÍCLICO"
  },
  {
    "codigo":722959000,
    "descripcion":"ANOREXIA NERVIOSA CONCOMITANTE CON PESO CORPORAL PELIGROSAMENTE BAJO"
  },
  {
    "codigo":298810009,
    "descripcion":"AMPLITUD DE ADUCCIÓN ACTIVA DE HOMBRO NORMAL"
  },
  {
    "codigo":296975000,
    "descripcion":"SOBREDOSIS DE HIPOLIPEMIANTE"
  },
  {
    "codigo":34831003,
    "descripcion":"INGURGITACIÓN DE MAMA EN EL RECIÉN NACIDO"
  },
  {
    "codigo":1148943004,
    "descripcion":"RETENCIÓN DE PLACENTA Y MEMBRANA UTERINA"
  },
  {
    "codigo":264207005,
    "descripcion":"INFECCIÓN CAUSADA POR CORYNEBACTERIUM MINITISSIMUM"
  },
  {
    "codigo":67599009,
    "descripcion":"CONGESTIÓN PULMONAR"
  },
  {
    "codigo":231439009,
    "descripcion":"ESTADO DE CONFUSIÓN TÓXICO"
  },
  {
    "codigo":65764006,
    "descripcion":"POLIDISTROFIA PSEUDO - HURLER"
  },
  {
    "codigo":295140007,
    "descripcion":"SOBREDOSIS DE PENTAZOCINA"
  },
  {
    "codigo":299411000119100,
    "descripcion":"NÓDULO REUMATOIDEO DE TEJIDO CELULAR SUBCUTÁNEO DE TOBILLO"
  },
  {
    "codigo":228007,
    "descripcion":"FENÓMENO LEPROSO DE LUCIO"
  },
  {
    "codigo":11768211000119100,
    "descripcion":"LACERACIÓN DE MÚSCULO CRURAL ANTERIOR DE PIERNA DERECHA"
  },
  {
    "codigo":15726841000119108,
    "descripcion":"ARTROPATÍA DE AMBAS RODILLAS"
  },
  {
    "codigo":1208974000,
    "descripcion":"ESPASMOS EPILÉPTICOS DE INICIO GENERALIZADO"
  },
  {
    "codigo":94862001,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA BÓVEDA DEL PALADAR"
  },
  {
    "codigo":29326002,
    "descripcion":"HIPERPARATIROIDISMO ECTÓPICO"
  },
  {
    "codigo":291470003,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR HEXILRESORCINOL"
  },
  {
    "codigo":62094004,
    "descripcion":"INTOXICACIÓN POR PHILODENDRON"
  },
  {
    "codigo":225934006,
    "descripcion":"FUMA EN LA CAMA"
  },
  {
    "codigo":1010531000,
    "descripcion":"ESCLEROSIS DE EPÍFISIS DE FALANGE MEDIA DE QUINTO DEDO DE PIE CON RADIOPACIDAD AUMENTADA"
  },
  {
    "codigo":93027004,
    "descripcion":"ANOMALÍA CONGÉNITA DE VÉRTEBRA DORSAL"
  },
  {
    "codigo":60259009,
    "descripcion":"ONICOTILOMANÍA"
  },
  {
    "codigo":289635009,
    "descripcion":"ÚTERO DE FORMA OVOIDE"
  },
  {
    "codigo":418872003,
    "descripcion":"TAQUICARDIA VENTRICULAR FASCICULAR"
  },
  {
    "codigo":255032005,
    "descripcion":"CARCINOMA MEDULAR TIROIDEO"
  },
  {
    "codigo":58424009,
    "descripcion":"COMER EN EXCESO"
  },
  {
    "codigo":440431000124105,
    "descripcion":"INGESTA INADECUADA DE BETA GLUCANO"
  },
  {
    "codigo":449805002,
    "descripcion":"COLANGITIS EOSINOFÍLICA"
  },
  {
    "codigo":253197001,
    "descripcion":"ARTERIA HIPOGLOSA EMBRIONARIA PERSISTENTE"
  },
  {
    "codigo":450671000124109,
    "descripcion":"CUERPO EXTRAÑO EN OJO"
  },
  {
    "codigo":187661003,
    "descripcion":"NEOPLASIA MALIGNA DE SURCO LABIAL MAXILAR"
  },
  {
    "codigo":285965005,
    "descripcion":"CAPAZ DE HACER CORRER EL AGUA DEL INODORO"
  },
  {
    "codigo":15864211000119107,
    "descripcion":"ATRESIA CONGÉNITA DE AMBOS OÍDOS EXTERNOS"
  },
  {
    "codigo":89357009,
    "descripcion":"CONCUBINATO VENAL"
  },
  {
    "codigo":87522002,
    "descripcion":"ANEMIA FERROPÉNICA"
  },
  {
    "codigo":284130002,
    "descripcion":"CONTROLA LA POSICIÓN DE LA PELVIS"
  },
  {
    "codigo":447970004,
    "descripcion":"DOBLE CAYADO AÓRTICO CON ARCO IZQUIERDO DOMINANTE Y ATRESIA DEL ARCO DERECHO"
  },
  {
    "codigo":2671000124109,
    "descripcion":"PRIMER PREMOLAR SUPERIOR DERECHO PERMANENTE SUPERNUMERARIO"
  },
  {
    "codigo":870284000,
    "descripcion":"ENFERMEDAD SIMILAR A TRASTORNO DE PELIZAEUS-MERZBACHER DEBIDA A MUTACIÓN EN HSPD1"
  },
  {
    "codigo":247692004,
    "descripcion":"DELIRIO DE CONTROL DE LA VOZ"
  },
  {
    "codigo":682541000119106,
    "descripcion":"CARCINOMA BASOCELULAR PRIMARIO DE PIEL DE REGIÓN PERIANAL"
  },
  {
    "codigo":711000119100,
    "descripcion":"ENFERMEDAD RENAL CRÓNICA EN ESTADIO 5 DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":278625000,
    "descripcion":"PACIENTE QUE NO PUEDE UTILIZAR PRÓTESIS MAXILOFACIAL"
  },
  {
    "codigo":737377004,
    "descripcion":"HIPOACUSIA DE CONDUCCIÓN Y NEUROSENSORIAL MIXTA CONGÉNITA"
  },
  {
    "codigo":213089007,
    "descripcion":"RUPTURA DE PLACA ÓSEA"
  },
  {
    "codigo":276790000,
    "descripcion":"ESTENOSIS AÓRTICA AISLADA"
  },
  {
    "codigo":49249007,
    "descripcion":"ENDOCERVICITIS AGUDA"
  },
  {
    "codigo":1259830002,
    "descripcion":"NEOPLASIA PRIMARIA MALIGNA DE VAINA DE NERVIO PERIFÉRICO DE CABEZA Y CUELLO"
  },
  {
    "codigo":473398003,
    "descripcion":"CATÉTER PARA DIÁLISIS IN SITU INUTILIZABLE"
  },
  {
    "codigo":735542004,
    "descripcion":"TRASTORNO NEUROLÓGICO DISOCIATIVO CON SÍNTOMA DE DEBILIDAD"
  },
  {
    "codigo":211254006,
    "descripcion":"ABRASIÓN DE REGIÓN DORSAL DE MUÑECA"
  },
  {
    "codigo":440630006,
    "descripcion":"SÍNDROME DE INTESTINO IRRITABLE CARACTERIZADO POR ESTREÑIMIENTO"
  },
  {
    "codigo":80182007,
    "descripcion":"CICLO MENSTRUAL IRREGULAR"
  },
  {
    "codigo":897547005,
    "descripcion":"DUPLICACIÓN DISTAL DEL CROMOSOMA 14"
  },
  {
    "codigo":242187009,
    "descripcion":"INTOXICACIÓN POR GASES DE ESCAPE A BORDO DE EMBARCACIÓN"
  },
  {
    "codigo":830176003,
    "descripcion":"ALERGIA A ÁCIDO PERMANGÁNICO"
  },
  {
    "codigo":109280004,
    "descripcion":"MELANOMA IN SITU DE CONDUCTO AUDITIVO EXTERNO"
  },
  {
    "codigo":305888006,
    "descripcion":"VISTO POR EL SERVICIO DE OTORRINOLARINGOLOGÍA"
  },
  {
    "codigo":240352006,
    "descripcion":"INFECCIÓN POR ESCHERICHIA COLI ENTEROTOXIGÉNICA"
  },
  {
    "codigo":404192008,
    "descripcion":"INFECCIÓN DE PRÓTESIS DE PENE"
  },
  {
    "codigo":205749001,
    "descripcion":"AUSENCIA CONGÉNITA DE GLÁNDULA HIPÓFISIS"
  },
  {
    "codigo":328391000119108,
    "descripcion":"PANCITOPENIA CAUSADA POR FÁRMACO ANTIDIABÉTICO"
  },
  {
    "codigo":402357008,
    "descripcion":"ENFERMEDAD DE INJERTO VERSUS HUÉSPED CRÓNICA LIQUENOIDE"
  },
  {
    "codigo":1156021009,
    "descripcion":"NIVEL SÉRICO DE LITIO POR ENCIMA DEL RANGO TERAPÉUTICO"
  },
  {
    "codigo":236682002,
    "descripcion":"URETRITIS GONOCÓCICA"
  },
  {
    "codigo":1285258003,
    "descripcion":"RANGO PASIVO NORMAL DE DORSIFLEXIÓN DE TOBILLO"
  },
  {
    "codigo":302218003,
    "descripcion":"PULGAR AUSENTE"
  },
  {
    "codigo":365919000,
    "descripcion":"MEMORIA VERBAL - HALLAZGO"
  },
  {
    "codigo":890207001,
    "descripcion":"INSUFICIENCIA ADQUIRIDA DE VÁLVULA AURICULOVENTRICULAR COMÚN POSTERIOR A PROCEDIMIENTO"
  },
  {
    "codigo":726367004,
    "descripcion":"DELECIÓN DE PARTE DEL BRAZO LARGO DEL CROMOSOMA 2"
  },
  {
    "codigo":300383007,
    "descripcion":"HALLAZGO RELACIONADO CON LA ELIMINACIÓN DE MECONIO"
  },
  {
    "codigo":202079009,
    "descripcion":"SEPARACIÓN PERIFÉRICA DEL MENISCO INTERNO"
  },
  {
    "codigo":724532003,
    "descripcion":"ÚLCERA DE DUODENO CAUSADA POR SUSTANCIA QUÍMICA"
  },
  {
    "codigo":298548008,
    "descripcion":"AMPLITUD DE FLEXIÓN LATERAL PASIVA HACIA LA IZQUIERDA DE LA COLUMNA VERTEBRAL DORSAL, AUMENTADA"
  },
  {
    "codigo":427785007,
    "descripcion":"HIPERPLASIA ATÍPICA DE CONDUCTO GALACTÓFORO"
  },
  {
    "codigo":360414000,
    "descripcion":"ELASTÓLISIS PERIFOLICULAR"
  },
  {
    "codigo":296713008,
    "descripcion":"SOBREDOSIS DE CEFTAZIDIMA"
  },
  {
    "codigo":32734003,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DE SITIOS MÚLTIPLES DEL TRONCO"
  },
  {
    "codigo":131038005,
    "descripcion":"NIVEL DE NOREPINEFRINA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":12115121000119100,
    "descripcion":"QUEMADURA QUÍMICA DE VÍA RESPIRATORIA"
  },
  {
    "codigo":15673521000119101,
    "descripcion":"NÓDULO REUMATOIDE DE TEJIDO SUBCUTÁNEO DE AMBAS MANOS"
  },
  {
    "codigo":190045361000119101,
    "descripcion":"HIPERPARATIROIDISMO PRIMARIO NORMOCALCÉMICO"
  },
  {
    "codigo":813925041000119103,
    "descripcion":"FILTRACIÓN ESPONTÁNEA DE LÍQUIDO CEFALORRAQUÍDEO DE COLUMNA"
  },
  {
    "codigo":3761000119104,
    "descripcion":"HIPOTESTOSTERONISMO"
  },
  {
    "codigo":1073841000119103,
    "descripcion":"DEFORMIDAD DE MUÑECA DERECHA DEBIDA A ARTRITIS REUMATOIDE"
  },
  {
    "codigo":90801000119103,
    "descripcion":"HIPOPLASIA ADQUIRIDA DE HUESO CIGOMÁTICO"
  },
  {
    "codigo":11864241000119107,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":336561000119106,
    "descripcion":"DACRIOCISTITIS AGUDA DE SACO LAGRIMAL DERECHO"
  },
  {
    "codigo":127368005,
    "descripcion":"QUINTO EMBARAZO"
  },
  {
    "codigo":15742641000119105,
    "descripcion":"TUMEFACCIÓN BILATERAL DE DEDOS DE LAS MANOS"
  },
  {
    "codigo":341681000119105,
    "descripcion":"DESPRENDIMIENTO DE COROIDES DE OJO IZQUIERDO"
  },
  {
    "codigo":323761000119106,
    "descripcion":"SINDACTILIA SIMPLE DE DEDOS DEL PIE IZQUIERDO"
  },
  {
    "codigo":94600009,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA MÉDULA ESPINAL"
  },
  {
    "codigo":346801000119106,
    "descripcion":"UVEÍTIS ANTERIOR CRÓNICA DE AMBOS OJOS"
  },
  {
    "codigo":11306161000119107,
    "descripcion":"FRACTURA POR AVULSIÓN EXPUESTA DE ESPINA ILÍACA ANTEROINFERIOR DE HUESO ILÍACO IZQUIERDO"
  },
  {
    "codigo":12107441000119107,
    "descripcion":"INFECCIÓN ASOCIADA CON PRÓTESIS ARTICULAR DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":1076401000119108,
    "descripcion":"DEPÓSITO DE CALCIO EN BOLSA SEROSA DE PIE IZQUIERDO"
  },
  {
    "codigo":289373001,
    "descripcion":"CABEZA FETAL 1\/5 POR ENCIMA DEL BORDE PÉLVICO"
  },
  {
    "codigo":291208007,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR CLORPROTIXENO"
  },
  {
    "codigo":1336114003,
    "descripcion":"SÍNDROME DE ARTRITIS PIOGÉNICA, PIODERMA GANGRENOSO, ACNÉ, HIDRADENITIS SUPURATIVA"
  },
  {
    "codigo":254770007,
    "descripcion":"LEIOMIOMA DARTOICO"
  },
  {
    "codigo":123698008,
    "descripcion":"ECCEMA VESICULOSO"
  },
  {
    "codigo":330901000119104,
    "descripcion":"VITILIGO DE PIEL DE PÁRPADO DERECHO Y REGIÓN PERIOCULAR"
  },
  {
    "codigo":449543008,
    "descripcion":"MOVIMIENTO PARADÓJICO DE TABIQUE INTERVENTRICULAR"
  },
  {
    "codigo":447708000,
    "descripcion":"NEOPLASIA MALIGNA DE CÉLULAS GERMINALES DE MEDIASTINO ANTERIOR"
  },
  {
    "codigo":709852002,
    "descripcion":"LESIÓN GALVÁNICA DE CAVIDAD BUCAL"
  },
  {
    "codigo":414940009,
    "descripcion":"EN QUIMIOPROFILAXIS CONTRA TUBERCULOSIS"
  },
  {
    "codigo":118193001,
    "descripcion":"HALLAZGO RELACIONADO CON LOS ROLES"
  },
  {
    "codigo":773553003,
    "descripcion":"SÍNDROME DE HIPOHIDROSIS, HIPOPLASIA DEL ESMALTE, QUERATODERMIA PALMOPLANTAR Y DISCAPACIDAD INTELECTUAL"
  },
  {
    "codigo":216497003,
    "descripcion":"INTOXICACIÓN ACCIDENTAL CAUSADA POR BARBITÚRICOS"
  },
  {
    "codigo":249265006,
    "descripcion":"PREPUCIO RETRAÍDO, FIJO"
  },
  {
    "codigo":183729007,
    "descripcion":"CONSULTA DOMICILIARIA DE CIRUGÍA PEDIÁTRICA SOLICITADA"
  },
  {
    "codigo":247430000,
    "descripcion":"PIEL DURA"
  },
  {
    "codigo":278363000,
    "descripcion":"MACROCITOSIS ALCOHÓLICA"
  },
  {
    "codigo":12100911000119104,
    "descripcion":"QUEMADURA DE REGIÓN AXILAR DERECHA"
  },
  {
    "codigo":1163099005,
    "descripcion":"ENCEFALITIS POR VIRUS DEL HERPES HUMANO TIPO 4"
  },
  {
    "codigo":276528001,
    "descripcion":"LESIÓN TÉRMICA DEL RECIÉN NACIDO"
  },
  {
    "codigo":47152002,
    "descripcion":"ÚLCERA GASTROYEYUNAL SIN HEMORRAGIA Y SIN PERFORACIÓN PERO CON OBSTRUCCIÓN"
  },
  {
    "codigo":440368003,
    "descripcion":"COMPLICACIÓN DE TUBO DE VENTILACIÓN TIMPÁNICA RETENIDO"
  },
  {
    "codigo":14384003,
    "descripcion":"DIARREA POSPRANDIAL"
  },
  {
    "codigo":210992005,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE CARA"
  },
  {
    "codigo":209157000,
    "descripcion":"SUBLUXACIÓN EXPUESTA ENTRE LA CUARTA Y QUINTA VÉRTEBRAS CERVICALES"
  },
  {
    "codigo":1259568008,
    "descripcion":"MIELITIS TRANSVERSA COMPLETA"
  },
  {
    "codigo":241925002,
    "descripcion":"EFECTO TÓXICO CAUSADO POR CRAYÓN"
  },
  {
    "codigo":78085003,
    "descripcion":"FRACTURA EXPUESTA A NIVEL DE T7 - T12 CON LESIÓN INCOMPLETA DE LA MÉDULA ESPINAL"
  },
  {
    "codigo":405765003,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA MÉDULA ESPINAL CERVICAL POSTERIOR, SIN LESIÓN VERTEBRAL, C1-4"
  },
  {
    "codigo":372997006,
    "descripcion":"INFECCIÓN CAUSADA POR ASPERGILLUS RUGULOSUS"
  },
  {
    "codigo":471301006,
    "descripcion":"RESTRICCIÓN EXCESIVA ADQUIRIDA DE COMUNICACIÓN INTERAURICULAR"
  },
  {
    "codigo":1255898004,
    "descripcion":"LINFOMA DE HODGKIN, VARIANTE CELULARIDAD MIXTA DE GANGLIOS LINFÁTICOS DE MIEMBRO INFERIOR"
  },
  {
    "codigo":305626005,
    "descripcion":"ATENDIDO POR UN TERAPEUTA ESPECIALIZADO EN TERAPIA COMPLEMENTARIA"
  },
  {
    "codigo":698842006,
    "descripcion":"APÉNDICE DE FRENILLO"
  },
  {
    "codigo":240090006,
    "descripcion":"MIOPATÍA EN HIPERPARATIROIDISMO"
  },
  {
    "codigo":371162008,
    "descripcion":"FRACTURA NO EXPUESTA DE CRÁNEO"
  },
  {
    "codigo":403930008,
    "descripcion":"PILOMATRIXOMA FAMILIAR MÚLTIPLE"
  },
  {
    "codigo":860847005,
    "descripcion":"GRANULOMA DE ESPACIO SUBDURAL ESPINAL CAUSADO POR MYCOBACTERIUM"
  },
  {
    "codigo":1186692000,
    "descripcion":"AMBIENTE FELIZ"
  },
  {
    "codigo":762543009,
    "descripcion":"ERITEMA NECROLÍTICO ACRO"
  },
  {
    "codigo":1286831008,
    "descripcion":"CIERRE DE ÁNGULO DEBIDO A MALFORMACIÓN CONGÉNITA DE ÁNGULO DE CÁMARA ANTERIOR DE OJO"
  },
  {
    "codigo":39812007,
    "descripcion":"CONTUSIÓN DEL ANTEBRAZO"
  },
  {
    "codigo":301956007,
    "descripcion":"POSICIÓN DEL CRISTALINO, NORMAL"
  },
  {
    "codigo":300121001,
    "descripcion":"CONDUCTO AUDITIVO NO OBSERVADO"
  },
  {
    "codigo":431193003,
    "descripcion":"INFECCIÓN DEL TORRENTE SANGUÍNEO"
  },
  {
    "codigo":365657003,
    "descripcion":"CONCENTRACIÓN DE GLUCOSA, TIRA REACTIVA - HALLAZGO"
  },
  {
    "codigo":333411000119101,
    "descripcion":"PERIOSTITIS ORBITARIA DERECHA"
  },
  {
    "codigo":1217625006,
    "descripcion":"EXPANSIÓN CONGÉNITA DE ÓRBITA"
  },
  {
    "codigo":234585008,
    "descripcion":"DEFECTO FAGOCÍTICO CITOCIDA"
  },
  {
    "codigo":298286003,
    "descripcion":"PROBLEMA DE LA FUERZA MUSCULAR DEL MÚSCULO ESQUELÉTICO"
  },
  {
    "codigo":429358008,
    "descripcion":"ESTEATOCISTOMA SIMPLE"
  },
  {
    "codigo":1539003,
    "descripcion":"DEDO DE LA MANO EN GATILLO ADQUIRIDO"
  },
  {
    "codigo":722435003,
    "descripcion":"DISTONÍA 16"
  },
  {
    "codigo":425688002,
    "descripcion":"LEUCEMIA LINFOBLÁSTICA AGUDA POSITIVA PARA CROMOSOMA FILADELFIA"
  },
  {
    "codigo":720600004,
    "descripcion":"SÍNDROME DE CAMPTODACTILIA CON HIPERPLASIA DE TEJIDO FIBROSO Y DISPLASIA ESQUELÉTICA"
  },
  {
    "codigo":143101000119101,
    "descripcion":"HEMOCROMATOSIS CONSECUTIVA A TRANSFUSIONES DE ERITROCITOS REPETIDAS"
  },
  {
    "codigo":718765003,
    "descripcion":"SÍNDROME DE DISPLASIA ESPONDILOEPIFISARIA Y BRAQUIDACTILIA CON TRASTORNO DEL HABLA"
  },
  {
    "codigo":127106000,
    "descripcion":"LINFADENOPATÍA TRAQUEAL"
  },
  {
    "codigo":94338000,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LOS GANGLIOS LINFÁTICOS INFRACLAVICULARES"
  },
  {
    "codigo":289111000,
    "descripcion":"NO RESOPLA"
  },
  {
    "codigo":92503002,
    "descripcion":"NEUROFIBROMATOSIS TIPO 2"
  },
  {
    "codigo":715095004,
    "descripcion":"DIFICULTAD PARA PASAR DEL INODORO A LA SILLA"
  },
  {
    "codigo":420183005,
    "descripcion":"SANGRADO DEL IRIS"
  },
  {
    "codigo":254508003,
    "descripcion":"TUMOR DE LA COMISURA ANTERIOR"
  },
  {
    "codigo":306941000119106,
    "descripcion":"DERRAME DE ARTICULACIÓN DE PIE DERECHO"
  },
  {
    "codigo":713260006,
    "descripcion":"ENCEFALITIS SUBAGUDA POR ADENOVIRUS CONCOMITANTE CON INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":10684311000119100,
    "descripcion":"NÓDULO DE PIEL DE MANO DERECHA"
  },
  {
    "codigo":25132006,
    "descripcion":"ANTÍGENO DE GRUPO SANGUÍNEO N>2<"
  },
  {
    "codigo":416513001,
    "descripcion":"DISFUNCIÓN DEL SACRO EN ROTACIÓN"
  },
  {
    "codigo":11857661000119107,
    "descripcion":"RUPTURA DE TENDÓN DE AQUILES DERECHO"
  },
  {
    "codigo":1137409003,
    "descripcion":"DEBILIDAD DE MÚSCULO DE PIERNA"
  },
  {
    "codigo":188972008,
    "descripcion":"NEOPLASIA BENIGNA DEL CUNEIFORME INTERNO"
  },
  {
    "codigo":15953661000119108,
    "descripcion":"ABSCESO NO PUERPERAL DE ARÉOLA IZQUIERDA"
  },
  {
    "codigo":187137009,
    "descripcion":"INFECCIÓN ÓSEA POR ECHINOCOCCUS GRANULOSUS"
  },
  {
    "codigo":54230003,
    "descripcion":"INSOMNIO MIXTO"
  },
  {
    "codigo":609451000,
    "descripcion":"INTERRUPCIÓN INDUCIDA DEL EMBARAZO COMPLICADA POR TRASTORNO METABÓLICO"
  },
  {
    "codigo":314539001,
    "descripcion":"NEUROPATÍA ÓPTICA RELACIONADA CON EL ALCOHOLISMO"
  },
  {
    "codigo":283606008,
    "descripcion":"HERIDA POR PINCHAZO DE AGUJA EN LA BOCA"
  },
  {
    "codigo":16009111000119104,
    "descripcion":"DEFORMIDAD CONGÉNITA DE HUESO DE ANTEBRAZO IZQUIERDO"
  },
  {
    "codigo":871595003,
    "descripcion":"FALLA DE CONDUCTO CARDÍACO DESPUÉS DE CONSTRUCCIÓN DE CONDUCTO CARDÍACO"
  },
  {
    "codigo":281771000,
    "descripcion":"FORTALEZA DEL EGO, ELEVADA"
  },
  {
    "codigo":312704000,
    "descripcion":"AGUJERO MACULAR DE ESPESOR TOTAL, ESTADIO IV"
  },
  {
    "codigo":443776004,
    "descripcion":"ATRAPAMIENTO DE INTESTINO EN LIGAMENTO ANCHO"
  },
  {
    "codigo":247168006,
    "descripcion":"DESGARRO DE RETINA EN U"
  },
  {
    "codigo":1162837001,
    "descripcion":"SINFALANGISMO PROXIMAL"
  },
  {
    "codigo":310869005,
    "descripcion":"PLANIFICACIÓN DEL MOVIMIENTO"
  },
  {
    "codigo":866090003,
    "descripcion":"MENINGOMIELITIS CAUSADA POR TREPONEMA PALLIDUM"
  },
  {
    "codigo":309034008,
    "descripcion":"SITUACIÓN DE PRUEBA FARMACOLÓGICA CLÍNICA"
  },
  {
    "codigo":45055003,
    "descripcion":"INSUFICIENCIA OVÁRICA POSTERIOR A RADIOTERAPIA"
  },
  {
    "codigo":1073201000119104,
    "descripcion":"ARTRITIS DE TOBILLO IZQUIERDO CAUSADA POR STREPTOCOCCUS"
  },
  {
    "codigo":405503005,
    "descripcion":"DESATENCIÓN DE MIEMBRO DEL PERSONAL"
  },
  {
    "codigo":208895004,
    "descripcion":"LUXACIÓN OBTURATRIZ TRAUMÁTICA NO EXPUESTA DE LA CADERA"
  },
  {
    "codigo":1290239007,
    "descripcion":"TUMOR TENOSINOVIAL DE CÉLULAS GIGANTES DIFUSO DE ARTICULACIÓN GLENOHUMERAL"
  },
  {
    "codigo":733183008,
    "descripcion":"QUISTES PULMONARES NEONATALES ADQUIRIDOS"
  },
  {
    "codigo":307199009,
    "descripcion":"DOLOR ABDOMINAL PSICOSOMÁTICO"
  },
  {
    "codigo":239828000,
    "descripcion":"ARTRITIS DESTRUCTIVA ASOCIADA A APATITA"
  },
  {
    "codigo":698580004,
    "descripcion":"FIEBRE POSTERIOR A VACUNACIÓN ANTITETÁNICA"
  },
  {
    "codigo":403668007,
    "descripcion":"ERITROMELALGIA MEDICAMENTOSA"
  },
  {
    "codigo":762281000,
    "descripcion":"PAQUIMENINGITIS HIPERTRÓFICA DEBIDA A INFECCIÓN"
  },
  {
    "codigo":43220007,
    "descripcion":"FIEBRE DE WESSELSBRON"
  },
  {
    "codigo":205225000,
    "descripcion":"AGENESIA DE CUARTO Y QUINTO METATARSIANOS"
  },
  {
    "codigo":237993009,
    "descripcion":"DEFICIENCIAS COMBINADAS COMPLEJAS"
  },
  {
    "codigo":301694005,
    "descripcion":"INCAPAZ DE MOVERSE HACIA ARRIBA Y HACIA ABAJO EN LA CAMA"
  },
  {
    "codigo":299859000,
    "descripcion":"REFLEJO SACRO NORMAL"
  },
  {
    "codigo":103251002,
    "descripcion":"MOTILIDAD OCULAR NORMAL"
  },
  {
    "codigo":365395003,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD DE REALIZAR ACTIVIDADES DE GERENCIA Y SUPERVISIÓN"
  },
  {
    "codigo":166952000,
    "descripcion":"NIVEL DE CARBAMAZEPINA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":37715009,
    "descripcion":"PERICARDITIS ADHESIVA"
  },
  {
    "codigo":12243301000119100,
    "descripcion":"ABSCESO INTRAABDOMINAL POSTERIOR A PROCEDIMIENTO"
  },
  {
    "codigo":294354000,
    "descripcion":"ALERGIA A UNDECENOATO"
  },
  {
    "codigo":296189009,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE HALOPERIDOL"
  },
  {
    "codigo":95911005,
    "descripcion":"TOLERANCIA FARMACOLÓGICA AUMENTADA"
  },
  {
    "codigo":292519007,
    "descripcion":"REACCIÓN ADVERSA A LA EFEDRINA"
  },
  {
    "codigo":126844001,
    "descripcion":"NEOPLASIA DEL COLON DESCENDENTE"
  },
  {
    "codigo":94076001,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA GLÁNDULA SUBLINGUAL"
  },
  {
    "codigo":290684005,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR MERCAPTOPURINA"
  },
  {
    "codigo":1306492007,
    "descripcion":"CARCINOMA DUCTAL INFILTRANTE PRIMARIO DE CUADRANTE SUPERIOR INTERNO DE MAMA DERECHA"
  },
  {
    "codigo":338431000119101,
    "descripcion":"EXOFTALMÍA PULSÁTIL DE OJO IZQUIERDO"
  },
  {
    "codigo":92241005,
    "descripcion":"NEOPLASIA BENIGNA DE LA CAVIDAD NASAL"
  },
  {
    "codigo":90406001,
    "descripcion":"AMORFOSÍNTESIS"
  },
  {
    "codigo":288849009,
    "descripcion":"INCAPAZ DE RESPIRAR"
  },
  {
    "codigo":254246009,
    "descripcion":"MALFORMACIÓN CONGÉNITA CAUSADA POR AGENTES CITOTÓXICOS"
  },
  {
    "codigo":38595071000119104,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DEBIDO A TROMBOSIS DE ARTERIA CEREBRAL POSTERIOR DERECHA"
  },
  {
    "codigo":186875004,
    "descripcion":"ENDOCARDITIS SIFILÍTICA DE VÁLVULA MITRAL"
  },
  {
    "codigo":711163009,
    "descripcion":"BRADIOPSIA"
  },
  {
    "codigo":1299152003,
    "descripcion":"LEUCOENCEFALOPATÍA PROGRESIVA DE COMIENZO EN LA VIDA ADULTA Y SORDERA DE COMIENZO TEMPRANO"
  },
  {
    "codigo":217808004,
    "descripcion":"OBSTRUCCIÓN RESPIRATORIA DEBIDA A CUERPO EXTRAÑO EN ESÓFAGO"
  },
  {
    "codigo":283344005,
    "descripcion":"PICADURA DE MOSQUITO"
  },
  {
    "codigo":86736003,
    "descripcion":"PRODUCCIÓN ANORMAL DE LINFOCITOS"
  },
  {
    "codigo":281509000,
    "descripcion":"COMA HIPÓXICO - ISQUÉMICO"
  },
  {
    "codigo":248741001,
    "descripcion":"VÁRICES RETICULARES"
  },
  {
    "codigo":445349004,
    "descripcion":"AISLAMIENTO DE ARTERIA CARÓTIDA PRIMITIVA DERECHA"
  },
  {
    "codigo":707493006,
    "descripcion":"CARCINOMA LINFOEPITELIAL PRIMARIO DE TRÁQUEA"
  },
  {
    "codigo":246906001,
    "descripcion":"PAPILAS DE CONJUNTIVA PALPEBRAL"
  },
  {
    "codigo":1264549009,
    "descripcion":"SUBLUXACIÓN DE ARTICULACIÓN INTERFALÁNGICA DE SEGUNDO A QUINTO DEDOS DE PIE"
  },
  {
    "codigo":15712921000119103,
    "descripcion":"INFARTO AGUDO DE PARED LATERAL DE MIOCARDIO CON ELEVACIÓN DEL SEGMENTO ST"
  },
  {
    "codigo":1295482007,
    "descripcion":"OSTEOPOROSIS DEBIDA A ENFERMEDAD RENAL CRÓNICA"
  },
  {
    "codigo":443514008,
    "descripcion":"EDEMA DE HOMBRO"
  },
  {
    "codigo":1229946007,
    "descripcion":"SÍNDROME DE TIPO PRADER WILLI ASOCIADO AL MIEMBRO L2 DE LA FAMILIA DE PROTEÍNAS DEL GEN DE ANTÍGENO ASOCIADO A MELANOMA"
  },
  {
    "codigo":277839000,
    "descripcion":"ANSIEDAD ACERCA DE DECIR ALGO INCORRECTO"
  },
  {
    "codigo":736591003,
    "descripcion":"PÓLIPO DE AMBAS FOSAS NASALES"
  },
  {
    "codigo":115834007,
    "descripcion":"FENOTIPO DE GRUPO SANGUÍNEO DUFFY"
  },
  {
    "codigo":212303005,
    "descripcion":"LESIÓN ABIERTA, NERVIO INTERÓSEO POSTERIOR"
  },
  {
    "codigo":310607007,
    "descripcion":"SARCOIDOSIS DE LOS CORNETES NASALES INFERIORES"
  },
  {
    "codigo":441679007,
    "descripcion":"HALLAZGO RELACIONADO CON EL ESTADO DE CRIBADO PRENATAL"
  },
  {
    "codigo":734756006,
    "descripcion":"DEBILIDAD DE MÚSCULO FACIAL IZQUIERDO"
  },
  {
    "codigo":1259044009,
    "descripcion":"SÍNDROME DE COLA DE CABALLO DEBIDO A TRASTORNO VASCULAR"
  },
  {
    "codigo":405241002,
    "descripcion":"PICA EN LOS ANIMALES"
  },
  {
    "codigo":306937003,
    "descripcion":"TUBO DE VENTILACIÓN PERMEABLE"
  },
  {
    "codigo":11780761000119107,
    "descripcion":"CONTUSIÓN DE ANTEBRAZO IZQUIERDO"
  },
  {
    "codigo":12025005,
    "descripcion":"RESPIRACIÓN PARADÓJICA"
  },
  {
    "codigo":700153004,
    "descripcion":"PEZÓN ANORMAL"
  },
  {
    "codigo":274169001,
    "descripcion":"HERIDA ABIERTA DE LABIOS VULVARES"
  },
  {
    "codigo":367411000119102,
    "descripcion":"INSUFICIENCIA HIPOFISARIA MEDICAMENTOSA"
  },
  {
    "codigo":403406002,
    "descripcion":"POIQUILODERMIA DEBIDA A CALOR DE TERAPIA CON RADIACIÓN INFRARROJA"
  },
  {
    "codigo":698318003,
    "descripcion":"MELENA DEL RECIÉN NACIDO DEBIDA A SANGRE MATERNA DEGLUTIDA"
  },
  {
    "codigo":1157070004,
    "descripcion":"ASTROCITOMA PILOMIXOIDE"
  },
  {
    "codigo":75726005,
    "descripcion":"OBSTRUCCIÓN DE LA VESÍCULA BILIAR"
  },
  {
    "codigo":1351843001,
    "descripcion":"SÍNDROME DE BAJA ESTATURA, DISMORFISMO FACIAL Y DISCAPACIDAD INTELECTUAL RELACIONADO CON DESMETILASA DE LISINA 3B"
  },
  {
    "codigo":73891003,
    "descripcion":"ANEMIA MEGALOBLÁSTICA AGUDA CAUSADA POR ÓXIDO NITROSO"
  },
  {
    "codigo":237731004,
    "descripcion":"PÉRDIDA DE INHIBICIÓN HIPOTALÁMICA"
  },
  {
    "codigo":301432000,
    "descripcion":"ANEURISMA DE ARTERIA DE CABEZA Y CUELLO"
  },
  {
    "codigo":268664001,
    "descripcion":"TRASTORNO EMOCIONAL DE LA NIÑEZ"
  },
  {
    "codigo":235896001,
    "descripcion":"CIRROSIS INFECCIOSA"
  },
  {
    "codigo":39288006,
    "descripcion":"OTITIS MEDIA PURULENTA"
  },
  {
    "codigo":432504007,
    "descripcion":"INFARTO CEREBRAL"
  },
  {
    "codigo":11809741000119100,
    "descripcion":"HERIDA DE PIERNA DERECHA DEBIDA A PICADURA DE INSECTO NO VENENOSO"
  },
  {
    "codigo":365133004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA RODAR EN LA CAMA"
  },
  {
    "codigo":234061005,
    "descripcion":"ESTENOSIS DE LA VENA YUGULAR INTERNA"
  },
  {
    "codigo":363298000,
    "descripcion":"SECUELAS DE TRASTORNOS GASTROINTESTINALES"
  },
  {
    "codigo":1078221000119102,
    "descripcion":"CÚBITO VARO CONGÉNITO DE CODO IZQUIERDO"
  },
  {
    "codigo":299597009,
    "descripcion":"AMPLITUD DE EXTENSIÓN ACTIVA DE DEDO DEL PIE AUMENTADA"
  },
  {
    "codigo":232226006,
    "descripcion":"OTITIS EXTERNA CRÓNICA DE ETIOLOGÍA VIRAL"
  },
  {
    "codigo":166690008,
    "descripcion":"NIVEL DE POTASIO EN SUERO POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":461602009,
    "descripcion":"OBSTRUCCIÓN COMPLETA ADQUIRIDA DEL CAYADO AÓRTICO"
  },
  {
    "codigo":66551002,
    "descripcion":"CEFALEA PSICÓGENA"
  },
  {
    "codigo":230391003,
    "descripcion":"EPILEPSIA DE LÓBULO TEMPORAL AMIGDALOHIPOCÁMPICO"
  },
  {
    "codigo":263159004,
    "descripcion":"FRACTURA PARCIAL DE ALVÉOLO MAXILAR"
  },
  {
    "codigo":787447005,
    "descripcion":"PERIODONTITIS GENERALIZADA"
  },
  {
    "codigo":295927001,
    "descripcion":"SOBREDOSIS DE NEFAZODONA"
  },
  {
    "codigo":2850009,
    "descripcion":"INFECCIÓN CAUSADA POR SCHISTOSOMA INCOGNITUM"
  },
  {
    "codigo":195788001,
    "descripcion":"SINUSITIS RECURRENTE"
  },
  {
    "codigo":64716005,
    "descripcion":"FUCOSIDOSIS"
  },
  {
    "codigo":31948006,
    "descripcion":"DERMATITIS DE CONTACTO CAUSADA POR PLÁSTICO"
  },
  {
    "codigo":359628008,
    "descripcion":"CONJUNTIVITIS CAUSADA POR ENTEROVIRUS TIPO 70"
  },
  {
    "codigo":1176993001,
    "descripcion":"COMPRESIÓN FÚNGICA DE LA MÉDULA ESPINAL"
  },
  {
    "codigo":193953008,
    "descripcion":"ANQUILOBLÉFARON"
  },
  {
    "codigo":126582001,
    "descripcion":"NEOPLASIA DE HUESO LARGO DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":292257008,
    "descripcion":"REACCIÓN ADVERSA A LA AZATIOPRINA"
  },
  {
    "codigo":290422003,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR METOCLOPRAMIDA"
  },
  {
    "codigo":93814004,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL GLOMO YUGULAR"
  },
  {
    "codigo":716406005,
    "descripcion":"CAPAZ DE INVOLUCRARSE EN LA ESTRUCTURA Y RUTINA DE LA VIDA DIARIA"
  },
  {
    "codigo":21043008,
    "descripcion":"TRASTORNO DE LA CITOMATRIZ DEL NEUTRÓFILO"
  },
  {
    "codigo":288587005,
    "descripcion":"CAPAZ DE EMPLEAR EL LENGUAJE CORPORAL"
  },
  {
    "codigo":91979007,
    "descripcion":"NEOPLASIA BENIGNA DEL CUERPO AÓRTICO"
  },
  {
    "codigo":190283008,
    "descripcion":"HIPOTIROIDISMO CAUSADO POR FENILBUTAZONA"
  },
  {
    "codigo":1237024002,
    "descripcion":"CON RIESGO ELEVADO DE EXPOSICIÓN A VIRUS DE RABIA"
  },
  {
    "codigo":286752003,
    "descripcion":"CARÁCTER ALTRUISTA"
  },
  {
    "codigo":1204256006,
    "descripcion":"MASA EN ENCÍA"
  },
  {
    "codigo":219381006,
    "descripcion":"HERIDA DE GUERRA POR FRAGMENTOS DE BOMBA ANTIPERSONAL"
  },
  {
    "codigo":414154002,
    "descripcion":"EXACERBACIÓN DE ENFERMEDAD DE CROHN DEL INTESTINO DELGADO"
  },
  {
    "codigo":283082008,
    "descripcion":"ARAÑAZO DE LA MUÑECA"
  },
  {
    "codigo":53706009,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN LA REGIÓN DE LA VULVA, CON INFECCIÓN"
  },
  {
    "codigo":314015001,
    "descripcion":"MACULOPATÍA MIXTA DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":1231519003,
    "descripcion":"SIGNO DE SOPLADOR DE CUERNO"
  },
  {
    "codigo":838303003,
    "descripcion":"NEOPLASIA INTRAEPITELIAL BILIAR DE GRADO 3 DE HÍGADO"
  },
  {
    "codigo":836468000,
    "descripcion":"ENGROSAMIENTO DE HUESO EN ARTICULACIÓN"
  },
  {
    "codigo":738164003,
    "descripcion":"DEFORMIDAD DE OREJA CORTADA"
  },
  {
    "codigo":1295220004,
    "descripcion":"SÍNDROME HEMOLÍTICO URÉMICO ATÍPICO CON ANTICUERPOS ANTI FACTOR H"
  },
  {
    "codigo":17268007,
    "descripcion":"CLINODACTILIA CONGÉNITA"
  },
  {
    "codigo":246644008,
    "descripcion":"VE HALOS ALREDEDOR DE LOS OBJETOS"
  },
  {
    "codigo":310345000,
    "descripcion":"EL PACIENTE SOLICITA SEGUNDA OPINIÓN A MÉDICO ESPECIALISTA"
  },
  {
    "codigo":410484008,
    "descripcion":"IRITIS CON COLITIS ULCEROSA"
  },
  {
    "codigo":80969003,
    "descripcion":"ACODAMIENTO POSOPERATORIO DE URÉTER"
  },
  {
    "codigo":277577000,
    "descripcion":"GAMMAPATÍA MONOCLONAL DE SIGNIFICACIÓN INCIERTA"
  },
  {
    "codigo":1162313005,
    "descripcion":"ARTRITIS REUMATOIDE POSITIVA PARA ANTICUERPOS ANTIPÉPTIDO CÍCLICO CITRULINADO Y PARA FACTOR REUMATOIDE"
  },
  {
    "codigo":408649007,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS DE LA FARINGE"
  },
  {
    "codigo":1080731000119102,
    "descripcion":"LIPOSARCOMA PRIMARIO DE PARTES BLANDAS DE CADERA DERECHA"
  },
  {
    "codigo":275742001,
    "descripcion":"PIURIA ESTÉRIL"
  },
  {
    "codigo":767262002,
    "descripcion":"FRACTURA EXPUESTA DE CÓCCIX"
  },
  {
    "codigo":308510001,
    "descripcion":"SITUACIÓN DEL CONTROL DEL ESTRÉS"
  },
  {
    "codigo":242974004,
    "descripcion":"RECEPTOR DE UNA LLAMADA TELEFÓNICA OBSCENA"
  },
  {
    "codigo":439582007,
    "descripcion":"RIGIDEZ ABDOMINAL EN CUADRANTE SUPERIOR IZQUIERDO"
  },
  {
    "codigo":110067005,
    "descripcion":"LACERACIÓN SIMPLE DEL CUERO CABELLUDO"
  },
  {
    "codigo":208371005,
    "descripcion":"FRACTURA NO EXPUESTA DEL ESCAFOIDES, CINTURA ESCAFOIDEA, TRANSVERSA"
  },
  {
    "codigo":44531008,
    "descripcion":"DESDOBLAMIENTO FIJO DEL SEGUNDO RUIDO CARDÍACO, R>2<"
  },
  {
    "codigo":11763009,
    "descripcion":"PLACENTA INCRETA"
  },
  {
    "codigo":403144003,
    "descripcion":"TIRIOSIS DISEMINADA"
  },
  {
    "codigo":1255112004,
    "descripcion":"ADENOCARCINOMA DE OROFARINGE"
  },
  {
    "codigo":698056009,
    "descripcion":"FRACTURA NO EXPUESTA DE BASE DE QUINTO METACARPIANO"
  },
  {
    "codigo":237469008,
    "descripcion":"DEFORMIDAD DEL PEZÓN"
  },
  {
    "codigo":366706002,
    "descripcion":"AMPLITUD DE MOVIMIENTO PASIVO DE FLEXIÓN DE DEDO DEL PIE - HALLAZGO"
  },
  {
    "codigo":235634004,
    "descripcion":"PRESBIESÓFAGO"
  },
  {
    "codigo":316981000119103,
    "descripcion":"DOLOR DE BRAZO DERECHO"
  },
  {
    "codigo":301170006,
    "descripcion":"PULSO PEDIO AUSENTE"
  },
  {
    "codigo":364871002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA CARGAR PESO EN LA PIERNA DERECHA"
  },
  {
    "codigo":299335003,
    "descripcion":"AMPLITUD DE FLEXIÓN ACTIVA DE LA RODILLA NORMAL"
  },
  {
    "codigo":233799004,
    "descripcion":"TRAQUEOBRONQUITIS TÓXICA AGUDA"
  },
  {
    "codigo":231964001,
    "descripcion":"NEOPLASIA DE IRIS"
  },
  {
    "codigo":789020003,
    "descripcion":"RADICULOPATÍA DEBIDA A DEFICIENCIA NUTRICIONAL"
  },
  {
    "codigo":1149468004,
    "descripcion":"INTOXICACIÓN CAUSADA POR SOMATROPINA"
  },
  {
    "codigo":297500005,
    "descripcion":"OBESIDAD ENDÓGENA"
  },
  {
    "codigo":166428003,
    "descripcion":"LACTÓGENO PLACENTARIO HUMANO FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":363036007,
    "descripcion":"ANOMALÍA CONGÉNITA DEL ANILLO TIMPÁNICO"
  },
  {
    "codigo":819953000,
    "descripcion":"ENFERMEDAD DE ALMACENAMIENTO DE GLUCÓGENO DEBIDA A DEFICIENCIA DE FOSFORILASA CINASA MUSCULAR"
  },
  {
    "codigo":721649001,
    "descripcion":"ATRESIA DE YEYUNO TIPO IIIB"
  },
  {
    "codigo":68124003,
    "descripcion":"PENETRACIÓN CON EL PENE"
  },
  {
    "codigo":295665005,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE BLEOMICINA"
  },
  {
    "codigo":262897005,
    "descripcion":"SECCIÓN DE URÉTER"
  },
  {
    "codigo":31686000,
    "descripcion":"ANOMALÍA CONGÉNITA DEL TRACTO ALIMENTARIO INFERIOR"
  },
  {
    "codigo":361201009,
    "descripcion":"HIPERPLASIA PERSISTENTE DEL TIMO"
  },
  {
    "codigo":228294000,
    "descripcion":"BEBE EN HOTELES"
  },
  {
    "codigo":33521009,
    "descripcion":"ANOMALÍA CONGÉNITA DE LA FORMA DEL CRISTALINO"
  },
  {
    "codigo":293830005,
    "descripcion":"ALERGIA A CLOMIPRAMINA"
  },
  {
    "codigo":719814009,
    "descripcion":"SUSCEPTIBILIDAD MENDELIANA A ENFERMEDAD POR MICOBACTERIAS LIGADA AL CROMOSOMA X"
  },
  {
    "codigo":29851005,
    "descripcion":"SIGNO DEL HALO"
  },
  {
    "codigo":291995005,
    "descripcion":"INTOXICACIÓN POR INHIBIDOR DE LA FOSFODIESTERASA"
  },
  {
    "codigo":193691005,
    "descripcion":"ADAPTACIÓN DEMORADA DE CONOS O BASTONES"
  },
  {
    "codigo":95387005,
    "descripcion":"MALABSORCIÓN DEL SITIO DE INYECCIÓN"
  },
  {
    "codigo":290160001,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR DEXTROMORAMIDA"
  },
  {
    "codigo":160923008,
    "descripcion":"TRABAJO SEDENTARIO"
  },
  {
    "codigo":28016005,
    "descripcion":"MEMBRANA DE JACKSON"
  },
  {
    "codigo":191856006,
    "descripcion":"ADICCIÓN A LA ASPIRACIÓN DE PEGAMENTO, EPISÓDICA"
  },
  {
    "codigo":58949002,
    "descripcion":"ABSCESO TUBO-OVÁRICO"
  },
  {
    "codigo":57114005,
    "descripcion":"FRACTURA NO EXPUESTA DE HUESO TRAPECIO DEL CARPO"
  },
  {
    "codigo":778010006,
    "descripcion":"SÍNDROME DE FRAGILIDAD CUTÁNEA, PELO LANOSO Y QUERATODERMIA PALMOPLANTAR"
  },
  {
    "codigo":286490005,
    "descripcion":"INCAPAZ DE PREPARAR COMIDA"
  },
  {
    "codigo":1269530008,
    "descripcion":"SÍNDROME DE CORDÓN CENTRAL DE MÉDULA CERVICAL DEBIDO A LESIÓN TRAUMÁTICA"
  },
  {
    "codigo":253722008,
    "descripcion":"FÍSTULA ARTERIAL CORONARIA MÚLTIPLE"
  },
  {
    "codigo":22511002,
    "descripcion":"ÚLCERA DUODENAL AGUDA CON PERFORACIÓN PERO SIN OBSTRUCCIÓN"
  },
  {
    "codigo":284655007,
    "descripcion":"REQUERIMIENTO ALIMENTARIO - HALLAZGO"
  },
  {
    "codigo":448495008,
    "descripcion":"ESTÓMAGO EN EL LADO DERECHO"
  },
  {
    "codigo":20676001,
    "descripcion":"DIETA SÓDICA"
  },
  {
    "codigo":86212001,
    "descripcion":"INFECCIÓN CAUSADA POR MICRONEMA"
  },
  {
    "codigo":345961000119105,
    "descripcion":"COROIDITIS DISEMINADA GENERALIZADA DE AMBOS OJOS"
  },
  {
    "codigo":315588006,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: URDU"
  },
  {
    "codigo":1264025001,
    "descripcion":"INFLAMACIÓN DE MÚLTIPLES MÚSCULOS"
  },
  {
    "codigo":1231257002,
    "descripcion":"DESVIACIÓN INTERMITENTE DE LA MIRADA HACIA ARRIBA"
  },
  {
    "codigo":706969002,
    "descripcion":"RUPTURA TRAUMÁTICA DE VÍA AÉREA"
  },
  {
    "codigo":250052009,
    "descripcion":"MARCHA DE PETREN"
  },
  {
    "codigo":280985006,
    "descripcion":"PATRÓN DE USO NOCIVO DE DIURÉTICO"
  },
  {
    "codigo":770670003,
    "descripcion":"DISOMÍA UNIPARENTAL PATERNA DEL CROMOSOMA 6"
  },
  {
    "codigo":82542004,
    "descripcion":"NEUMOPERICARDIO"
  },
  {
    "codigo":705134006,
    "descripcion":"FRACTURA EXPUESTA DE TECHO DE ACETÁBULO"
  },
  {
    "codigo":49774006,
    "descripcion":"EXOFTALMÍA INTERMITENTE"
  },
  {
    "codigo":277315000,
    "descripcion":"RUPTURA DE ANEURISMA DE ARTERIA CEREBRAL ANTERIOR"
  },
  {
    "codigo":1260355006,
    "descripcion":"DEMENCIA FRONTOTEMPORAL DEBIDA A MUTACIÓN FUS"
  },
  {
    "codigo":767000001,
    "descripcion":"AUSENCIA CONGÉNITA DE PIE DERECHO"
  },
  {
    "codigo":703299009,
    "descripcion":"MALFORMACIÓN CAPILAR CUTÁNEA"
  },
  {
    "codigo":1293123009,
    "descripcion":"GLOMANGIOMA"
  },
  {
    "codigo":406552001,
    "descripcion":"AUTOMANEJO DE PROBLEMAS RELACIONADOS CON LA SALUD MENTAL"
  },
  {
    "codigo":275480001,
    "descripcion":"PABELLÓN AURICULAR GRANDE"
  },
  {
    "codigo":240877000,
    "descripcion":"MIASIS CUTÁNEA"
  },
  {
    "codigo":111640008,
    "descripcion":"FRACTURA NO EXPUESTA DE RADIO"
  },
  {
    "codigo":109805003,
    "descripcion":"QUEILITIS FACTICIA"
  },
  {
    "codigo":402882001,
    "descripcion":"ENFERMEDAD DE HODGKIN QUE AFECTA LA PIEL"
  },
  {
    "codigo":42434002,
    "descripcion":"HEMONEUMOTÓRAX TRAUMÁTICO"
  },
  {
    "codigo":1287618005,
    "descripcion":"CRISIS EPILÉPTICA ELECTROCLÍNICA SECUENCIAL DE INICIO FOCAL NEONATAL"
  },
  {
    "codigo":239042009,
    "descripcion":"DISPLASIA ECTODÉRMICO CON DEFECTOS DE LOS DIENTES Y SUDOR"
  },
  {
    "codigo":827031005,
    "descripcion":"SITIO DE INYECCIÓN NORMAL"
  },
  {
    "codigo":202604001,
    "descripcion":"CHASQUIDO DE ARTICULACIÓN INTERFALÁNGICA PROXIMAL DE DEDO DE MANO"
  },
  {
    "codigo":366444005,
    "descripcion":"AMPLITUD DE MOVIMIENTO PASIVO DE ROTACIÓN HACIA LA DERECHA DE LA COLUMNA LUMBAR - HALLAZGO"
  },
  {
    "codigo":1085751000119100,
    "descripcion":"ABSCESO DE INTESTINO CONCOMITANTE CON ENFERMEDAD DE CROHN DE INTESTINO GRUESO Y DEBIDO A ELLA"
  },
  {
    "codigo":299073005,
    "descripcion":"SIN AMPLITUD PASIVA DE FLEXIÓN DE DEDO DE LA MANO"
  },
  {
    "codigo":168001007,
    "descripcion":"ESPUTO: PIOCITOS PRESENTES"
  },
  {
    "codigo":102465008,
    "descripcion":"SENSIBILIDAD ANORMAL A LAS INFECCIONES"
  },
  {
    "codigo":397377007,
    "descripcion":"TAMAÑO TUMORAL, NO APLICABLE"
  },
  {
    "codigo":2326000,
    "descripcion":"ANULACIÓN DEL MATRIMONIO"
  },
  {
    "codigo":788758003,
    "descripcion":"EPENDIMOMA SELAR DE HIPÓFISIS POSTERIOR"
  },
  {
    "codigo":67862004,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN REGIÓN DE CODO, CON INFECCIÓN"
  },
  {
    "codigo":725057008,
    "descripcion":"ANEMIA HEMOLÍTICA NO ESFEROCÍTICA DEBIDA A DEFICIENCIA DE TRIFOSFATASA DE ADENOSINA"
  },
  {
    "codigo":166166006,
    "descripcion":"ESTUDIOS DE ANTICUERPOS ANORMALES"
  },
  {
    "codigo":395542007,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA DE MUCOSA AFECTADO POR ADENOMA"
  },
  {
    "codigo":297238008,
    "descripcion":"DEFICIENCIA ERITROCÍTICA DE URIDINA DIFOSFATO GALACTOSA-4-EPIMERASA"
  },
  {
    "codigo":721387002,
    "descripcion":"SÍNDROME DEL CORDÓN ANTERIOR DE MÉDULA ESPINAL AL NIVEL DEL SÉPTIMO SEGMENTO CERVICAL"
  },
  {
    "codigo":262635003,
    "descripcion":"CONTUSIÓN EN LA CAVIDAD BUCAL"
  },
  {
    "codigo":295403005,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE LOPERAMIDA"
  },
  {
    "codigo":129728002,
    "descripcion":"HALLAZGO MENOS DEFINIDO CON RESPECTO A LA MAMOGRAFÍA ANTERIOR"
  },
  {
    "codigo":293568004,
    "descripcion":"REACCIÓN ADVERSA A TETRADECIL SULFATO DE SODIO"
  },
  {
    "codigo":717717002,
    "descripcion":"DOLOR NO CÍCLICO EN PELVIS FEMENINA"
  },
  {
    "codigo":15722961000119101,
    "descripcion":"OSTEOARTROSIS DE AMBAS ARTICULACIONES SACROILÍACAS"
  },
  {
    "codigo":95125007,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE HUESO TEMPORAL"
  },
  {
    "codigo":226197008,
    "descripcion":"DIETA CON BAJO CONTENIDO DE SALICILATO"
  },
  {
    "codigo":422805009,
    "descripcion":"EROSIÓN DE TUMOR ESOFÁGICO HACIA BRONQUIO"
  },
  {
    "codigo":783253009,
    "descripcion":"HERNIA INGUINAL DIRECTA IZQUIERDA"
  },
  {
    "codigo":93290000,
    "descripcion":"HIPOPLASIA CONGÉNITA DE LA PELVIS RENAL"
  },
  {
    "codigo":715882005,
    "descripcion":"SÍNDROME RESPIRATORIO AGUDO SEVERO DEL TRACTO RESPIRATORIO SUPERIOR"
  },
  {
    "codigo":11790801000119103,
    "descripcion":"CONTUSIÓN DE MUSLO DERECHO"
  },
  {
    "codigo":124223005,
    "descripcion":"DEFICIENCIA DE PROGESTERONA 11ALFA - MONOOXIGENASA"
  },
  {
    "codigo":253460000,
    "descripcion":"SUPERPOSICIÓN DE VÁLVULA AURICULOVENTRICULAR DERECHA"
  },
  {
    "codigo":56852002,
    "descripcion":"ACROMATOPSIA"
  },
  {
    "codigo":89620005,
    "descripcion":"HIPEREXTENSIÓN"
  },
  {
    "codigo":55017000,
    "descripcion":"EDEMA POR CALOR"
  },
  {
    "codigo":286228009,
    "descripcion":"DIFICULTAD PARA USAR EL FLUJO DE AIRE GLÓTICO AL HABLAR"
  },
  {
    "codigo":448233000,
    "descripcion":"NEOPLASIA MALIGNA DE ÓRGANO URINARIO"
  },
  {
    "codigo":446398001,
    "descripcion":"PULSO TIBIAL ANTERIOR BIFÁSICO"
  },
  {
    "codigo":282558004,
    "descripcion":"CAPAZ DE CAMINAR EN PUNTAS DE PIE"
  },
  {
    "codigo":249790009,
    "descripcion":"ACORTAMIENTO PROXIMAL DE PIERNA"
  },
  {
    "codigo":247955002,
    "descripcion":"BAJO NIVEL DE CONCIENCIA DURANTE EPISODIO DE SONAMBULISMO"
  },
  {
    "codigo":870547003,
    "descripcion":"CON DIFICULTAD PARA MANEJAR CORRESPONDENCIA"
  },
  {
    "codigo":55281000087101,
    "descripcion":"YERSINIA ENTEROCOLITICA O YERSINIA FREDERIKSENII"
  },
  {
    "codigo":49512000,
    "descripcion":"TRASTORNO BIPOLAR I DEPRESIVO EN REMISIÓN PARCIAL"
  },
  {
    "codigo":770408001,
    "descripcion":"ESTENOSIS CONGÉNITA DE CONDUCTO VERTEBRAL CERVICAL"
  },
  {
    "codigo":39921000087107,
    "descripcion":"LACERACIÓN DE TENDÓN EXTENSOR DE PULGAR IZQUIERDO"
  },
  {
    "codigo":42481000087109,
    "descripcion":"HERIDA DE CARA POR MORDEDURA"
  },
  {
    "codigo":442728009,
    "descripcion":"SENSIBILIDAD AL GLUTEN DE CAUSA NO CELÍACA"
  },
  {
    "codigo":735805003,
    "descripcion":"LACERACIÓN DE ANTEBRAZO SIN CUERPO EXTRAÑO"
  },
  {
    "codigo":703037004,
    "descripcion":"YERSINIA FREDERIKSENII O YERSINIA INTERMEDIA"
  },
  {
    "codigo":1260093006,
    "descripcion":"ADENOCARCINOMA MIXTO DE PULMÓN"
  },
  {
    "codigo":111378004,
    "descripcion":"ALCALOSIS RESPIRATORIA"
  },
  {
    "codigo":209682004,
    "descripcion":"SECCIÓN EXPUESTA DE LIGAMENTO DE DEDO, ARTICULACIÓN METACARPOFALÁNGICA, LIGAMENTO LATERAL CUBITAL"
  },
  {
    "codigo":733970008,
    "descripcion":"CARIES DENTAL ACTIVA PRIMARIA QUE SE EXTIENDE HASTA EL ESMALTE"
  },
  {
    "codigo":371687002,
    "descripcion":"INFECCIÓN DISEMINADA CAUSADA POR EL GRUPO MYCOBACTERIUM AVIUM-INTRACELLULARE"
  },
  {
    "codigo":240615004,
    "descripcion":"FIEBRE MANCHADA DE LAS MONTAÑAS ROCOSAS OCCIDENTALES"
  },
  {
    "codigo":9404003,
    "descripcion":"TUMEFACCIÓN DE ÓRBITA"
  },
  {
    "codigo":304316003,
    "descripcion":"AMPLITUD DE MOVIMIENTO DE CADERA AUMENTADA"
  },
  {
    "codigo":763068005,
    "descripcion":"PARAPLEJÍA ESPÁSTICA AUTOSÓMICA DOMINANTE TIPO 31"
  },
  {
    "codigo":238780006,
    "descripcion":"CAPILARITIS IDIOPÁTICA"
  },
  {
    "codigo":1156284008,
    "descripcion":"CUMPLE CON ESQUEMA DE VACUNACIÓN"
  },
  {
    "codigo":402620009,
    "descripcion":"PIGMENTACIÓN NO MELÁNICA CAUSADA POR SUSTANCIA EXÓGENA"
  },
  {
    "codigo":73105000,
    "descripcion":"BURSITIS DE PATA DE GANSO"
  },
  {
    "codigo":11793311000119102,
    "descripcion":"SUBLUXACIÓN DE ARTICULACIÓN DE DEDO DE PIE IZQUIERDO"
  },
  {
    "codigo":300646002,
    "descripcion":"CAPAZ DE CONDUCIR UNA BICICLETA"
  },
  {
    "codigo":366182005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CONCIENCIA DEL LATIDO CARDÍACO"
  },
  {
    "codigo":235110008,
    "descripcion":"QUISTE ODONTÓGENO"
  },
  {
    "codigo":724795000,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO A LA ALTURA DE LA MUÑECA"
  },
  {
    "codigo":3899003,
    "descripcion":"TIFLITIS NEUTROPÉNICA"
  },
  {
    "codigo":298811008,
    "descripcion":"AMPLITUD DE ADUCCIÓN ACTIVA DE HOMBRO AUMENTADA"
  },
  {
    "codigo":167739008,
    "descripcion":"GLUCOSA EN LÍQUIDO CEFALORRAQUÍDEO DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":36667009,
    "descripcion":"NECATORIASIS"
  },
  {
    "codigo":296976004,
    "descripcion":"SOBREDOSIS DE CLOFIBRATO"
  },
  {
    "codigo":722960005,
    "descripcion":"ANOREXIA NERVIOSA CONCOMITANTE CON PESO CORPORAL SIGNIFICATIVAMENTE BAJO"
  },
  {
    "codigo":231440006,
    "descripcion":"DELIRIO DE ORIGEN MIXTO"
  },
  {
    "codigo":67600007,
    "descripcion":"FÍSTULA BILIOVASCULAR"
  },
  {
    "codigo":196837002,
    "descripcion":"HERNIA CRURAL IRREDUCTIBLE"
  },
  {
    "codigo":295141006,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE PENTAZOCINA"
  },
  {
    "codigo":293306004,
    "descripcion":"REACCIÓN ADVERSA A LA EPOETINA ALFA"
  },
  {
    "codigo":195002007,
    "descripcion":"VALVULOPATÍA MÚLTIPLE"
  },
  {
    "codigo":291471004,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR HEXILRESORCINOL"
  },
  {
    "codigo":94863006,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA CABEZA DEL PÁNCREAS"
  },
  {
    "codigo":225935007,
    "descripcion":"ESCONDE CIGARRILLOS ENCENDIDOS EN LOS BOLSILLOS"
  },
  {
    "codigo":224100002,
    "descripcion":"MIEMBRO DE FAMILIA NUCLEAR TÍPICA"
  },
  {
    "codigo":289636005,
    "descripcion":"ÚTERO DE FORMA GLOBOSA"
  },
  {
    "codigo":1010532007,
    "descripcion":"ESCLEROSIS DE EPÍFISIS DE FALANGE MEDIA DE CUARTO DEDO DE PIE CON RADIOPACIDAD AUMENTADA"
  },
  {
    "codigo":255033000,
    "descripcion":"ADENOMA DE GLÁNDULA TIROIDES"
  },
  {
    "codigo":1141604009,
    "descripcion":"SENSACIÓN PEGAJOSA EN OJO"
  },
  {
    "codigo":93028009,
    "descripcion":"ANOMALÍA CONGÉNITA DEL VÓMER"
  },
  {
    "codigo":449806001,
    "descripcion":"COLITIS ESTERCORÁCEA"
  },
  {
    "codigo":262081000210100,
    "descripcion":"FALTA DE APOYO PSICOSOCIAL"
  },
  {
    "codigo":187662005,
    "descripcion":"NEOPLASIA MALIGNA DE SURCO LABIAL MANDIBULAR"
  },
  {
    "codigo":253198006,
    "descripcion":"ARTERIA INTERSEGMENTARIA PROATLOIDEA EMBRIONARIA PERSISTENTE"
  },
  {
    "codigo":285966006,
    "descripcion":"INCAPAZ DE HACER CORRER EL AGUA DEL INODORO"
  },
  {
    "codigo":681171000119103,
    "descripcion":"PAPILOMA DE CONJUNTIVA DE OJO IZQUIERDO"
  },
  {
    "codigo":21987001,
    "descripcion":"PARTO DEMORADO DEL SEGUNDO RECIÉN NACIDO DE EMBARAZO MÚLTIPLE"
  },
  {
    "codigo":284131003,
    "descripcion":"NO CONTROLA LA POSICIÓN PÉLVICA"
  },
  {
    "codigo":185827003,
    "descripcion":"ASISTE AL CONTROL DE SALUD MASCULINO"
  },
  {
    "codigo":87523007,
    "descripcion":"UNIÓN MACROMOLECULAR AUMENTADA"
  },
  {
    "codigo":315064003,
    "descripcion":"SANGRE EN EL PAPEL HIGIÉNICO"
  },
  {
    "codigo":451401000124107,
    "descripcion":"TRASTORNO DE EXTREMIDAD SUPERIOR DERECHA"
  },
  {
    "codigo":870285004,
    "descripcion":"ENFERMEDAD SIMILAR A TRASTORNO DE PELIZAEUS-MERZBACHER DEBIDA A MUTACIÓN EN SLC16A2"
  },
  {
    "codigo":18317005,
    "descripcion":"FÍSTULA RECTOVULVAR"
  },
  {
    "codigo":83853005,
    "descripcion":"FÓRMULA ENTERAL"
  },
  {
    "codigo":1263501007,
    "descripcion":"TRASTORNO MIOCLÓNICO DEBIDO A UREMIA"
  },
  {
    "codigo":15973741000119102,
    "descripcion":"NÓDULO DE PIEL DE AMBOS PULGARES"
  },
  {
    "codigo":247693009,
    "descripcion":"DELIRIO DE CONTROL DE LA ESCRITURA"
  },
  {
    "codigo":213090003,
    "descripcion":"AFLOJAMIENTO DE PLACA"
  },
  {
    "codigo":278626004,
    "descripcion":"PACIENTE INCAPAZ DE USAR PRÓTESIS DENTAL"
  },
  {
    "codigo":737378009,
    "descripcion":"ESTADIO CLÍNICO 1 DE INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA DE LA ORGANIZACIÓN MUNDIAL DE LA SALUD DE 2007"
  },
  {
    "codigo":80183002,
    "descripcion":"QUEMADURA DE SITIOS MÚLTIPLES DE LA EXTREMIDAD INFERIOR"
  },
  {
    "codigo":1259831003,
    "descripcion":"NEOPLASIA PRIMARIA MALIGNA DE VAINA DE NERVIO PERIFÉRICO DE PELVIS"
  },
  {
    "codigo":440631005,
    "descripcion":"EFECTO TARDÍO DE LESIÓN TRAUMÁTICA DE TESTÍCULO"
  },
  {
    "codigo":47415006,
    "descripcion":"COLOR ANORMAL"
  },
  {
    "codigo":78348000,
    "descripcion":"CUERPO EXTRAÑO NO MAGNÉTICO RETENIDO EN EL CRISTALINO"
  },
  {
    "codigo":735543009,
    "descripcion":"TRASTORNO NEUROLÓGICO DISOCIATIVO CON SÍNTOMA DE ALTERACIÓN SENSITIVA"
  },
  {
    "codigo":209420002,
    "descripcion":"DISTENSIÓN DE LA CABEZA LARGA DEL MÚSCULO BÍCEPS"
  },
  {
    "codigo":235656001,
    "descripcion":"GASTRITIS REACTIVA"
  },
  {
    "codigo":242188004,
    "descripcion":"AGOBIADO POR HUMO A BORDO DE EMBARCACIÓN"
  },
  {
    "codigo":897548000,
    "descripcion":"DUPLICACIÓN DISTAL DEL CROMOSOMA 15"
  },
  {
    "codigo":109281000,
    "descripcion":"NEVO MELANOCÍTICO DEL CUELLO"
  },
  {
    "codigo":240353001,
    "descripcion":"INFECCIÓN DEL TRACTO GASTRINTESTINAL POR ESCHERICHIA COLI ENTEROPATÓGENA"
  },
  {
    "codigo":404193003,
    "descripcion":"INFECCIÓN DE PRÓTESIS DENTAL"
  },
  {
    "codigo":76513003,
    "descripcion":"FIBROADENOSIS CRÓNICA DE LA MAMA"
  },
  {
    "codigo":305889003,
    "descripcion":"VISTO POR EL SERVICIO DE CIRUGÍA ENDOCRINOLÓGICA"
  },
  {
    "codigo":830177007,
    "descripcion":"ALERGIA A SULFATO DE SODIO"
  },
  {
    "codigo":699105008,
    "descripcion":"NIVEL DE EDEMA FLUCTUANTE"
  },
  {
    "codigo":205750001,
    "descripcion":"GLÁNDULA HIPÓFISIS ACCESORIA"
  },
  {
    "codigo":1156022002,
    "descripcion":"NIVEL SÉRICO DE LITIO POR DEBAJO DEL RANGO TERAPÉUTICO"
  },
  {
    "codigo":402358003,
    "descripcion":"ENFERMEDAD DE INJERTO VERSUS HUÉSPED CRÓNICA ESCLERODERMOIDE"
  },
  {
    "codigo":41910004,
    "descripcion":"PERIOSTITIS"
  },
  {
    "codigo":1287094005,
    "descripcion":"SÍNDROME DE EHLERS DANLOS TIPO CLÁSICO 2"
  },
  {
    "codigo":238518008,
    "descripcion":"COMEDÓN SOLAR"
  },
  {
    "codigo":269451001,
    "descripcion":"EMBOLIA GASEOSA POSQUIRÚRGICA"
  },
  {
    "codigo":105611005,
    "descripcion":"ESGUINCE ARTICULAR"
  },
  {
    "codigo":1285259006,
    "descripcion":"RANGO ACTIVO DE DORSIFLEXIÓN DE TOBILLO AUMENTADO"
  },
  {
    "codigo":236683007,
    "descripcion":"URETRITIS POR CLAMIDIA"
  },
  {
    "codigo":300384001,
    "descripcion":"HALLAZGO RELACIONADO CON MEDICIONES DE LA DEFECACIÓN"
  },
  {
    "codigo":431456004,
    "descripcion":"RECHAZO ACELERADO DE TRASPLANTE DE MÉDULA ÓSEA"
  },
  {
    "codigo":365920006,
    "descripcion":"HALLAZGO RELACIONADO CON LOS TIPOS DE RECUERDOS"
  },
  {
    "codigo":202080007,
    "descripcion":"DESGARRO RADIAL DEL MENISCO INTERNO"
  },
  {
    "codigo":298549000,
    "descripcion":"AMPLITUD DE FLEXIÓN LATERAL PASIVA HACIA LA IZQUIERDA DE LA COLUMNA VERTEBRAL DORSAL, DISMINUIDA"
  },
  {
    "codigo":726368009,
    "descripcion":"DELECIÓN DE PARTE DEL BRAZO CORTO DEL CROMOSOMA 2"
  },
  {
    "codigo":724533008,
    "descripcion":"ÚLCERA DUODENAL CAUSADA POR VIRUS"
  },
  {
    "codigo":15675041000119102,
    "descripcion":"TENDINITIS DE TENDÓN SUPRAESPINOSO DERECHO"
  },
  {
    "codigo":296714002,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE CEFTAZIDIMA"
  },
  {
    "codigo":34570004,
    "descripcion":"SUBLUXACIÓN DE DIENTE"
  },
  {
    "codigo":65503000,
    "descripcion":"RUIDOS RESPIRATORIOS AUSENTES"
  },
  {
    "codigo":427786008,
    "descripcion":"MUCOSITIS ULCEROSA DE VAGINA"
  },
  {
    "codigo":131039002,
    "descripcion":"ÁCIDO VAINILLILMANDÉLICO ANORMAL"
  },
  {
    "codigo":425951002,
    "descripcion":"SÍNDROME DEL PULMÓN ENCOGIDO"
  },
  {
    "codigo":720863002,
    "descripcion":"SÍNDROME DE EIKEN"
  },
  {
    "codigo":32735002,
    "descripcion":"ENCEFALITIS SIFILÍTICA CONGÉNITA"
  },
  {
    "codigo":196575007,
    "descripcion":"MORDEDURA DE LABIO"
  },
  {
    "codigo":10759841000119105,
    "descripcion":"ENFERMEDAD INFECCIOSA DE TRANSMISIÓN SEXUAL EN LA MADRE QUE COMPLICA EL NACIMIENTO"
  },
  {
    "codigo":293044003,
    "descripcion":"EFECTO ADVERSO DE LA SULFADIAZINA DE PLATA"
  },
  {
    "codigo":10923681000119106,
    "descripcion":"FRACTURA NO EXPUESTA DE BASE DE PRIMER HUESO METACARPIANO DE MANO IZQUIERDA"
  },
  {
    "codigo":260276006,
    "descripcion":"VISIÓN A DISTANCIA 6\/24"
  },
  {
    "codigo":161972006,
    "descripcion":"DOLOR TORÁCICO CENTRAL"
  },
  {
    "codigo":127369002,
    "descripcion":"SEXTO EMBARAZO"
  },
  {
    "codigo":192905004,
    "descripcion":"MIELOPATÍA POR DISCOPATÍA INTERVERTEBRAL"
  },
  {
    "codigo":94601008,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LAS MENINGES ESPINALES"
  },
  {
    "codigo":92766005,
    "descripcion":"CARCINOMA IN SITU DE CONDUCTO TIROGLOSO"
  },
  {
    "codigo":289374007,
    "descripcion":"CABEZA FETAL 0\/5 POR ENCIMA DEL BORDE PÉLVICO"
  },
  {
    "codigo":123699000,
    "descripcion":"ECCEMA EXUDATIVO"
  },
  {
    "codigo":1336115002,
    "descripcion":"SÍNDROME DE PIODERMA GANGRENOSO, ACNÉ, HIDRADENITIS SUPURATIVA, ESPONDILITIS ANQUILOSANTE"
  },
  {
    "codigo":578968971000119100,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DEBIDO A TROMBOSIS DE AMBAS ARTERIAS VERTEBRALES"
  },
  {
    "codigo":16862091000119100,
    "descripcion":"CUERPO EXTRAÑO ASPIRADO EN TRACTO RESPIRATORIO"
  },
  {
    "codigo":112011000119102,
    "descripcion":"CRIBADO PARA DEPRESIÓN NEGATIVO EN CUESTIONARIO SOBRE LA SALUD DEL PACIENTE-9"
  },
  {
    "codigo":11808651000119103,
    "descripcion":"PERFORACIÓN TRAUMÁTICA DE COLON ASCENDENTE"
  },
  {
    "codigo":16419211000119102,
    "descripcion":"SÍNDROME DE ESTRÉS DE TIBIA MEDIAL DE AMBAS PIERNAS"
  },
  {
    "codigo":1089931000119105,
    "descripcion":"MIOCARDITIS DEBIDA A ESCARLATINA"
  },
  {
    "codigo":11798411000119101,
    "descripcion":"HEMATOMA TRAUMÁTICO DE RIÑÓN DERECHO"
  },
  {
    "codigo":416776003,
    "descripcion":"PRESCRIPCIÓN RECOGIDA POR MIEMBRO DE LA FAMILIA"
  },
  {
    "codigo":1077131000119108,
    "descripcion":"QUISTE ÓSEO DE TIBIA IZQUIERDA"
  },
  {
    "codigo":1092491000119106,
    "descripcion":"CHOQUE SÉPTICO CONCOMITANTE CON DISFUNCIÓN ORGÁNICA AGUDA DEBIDO A ENTEROCOCCUS"
  },
  {
    "codigo":254771006,
    "descripcion":"LEIOMIOSARCOMA CUTÁNEO"
  },
  {
    "codigo":40331000119107,
    "descripcion":"COLECISTITIS AGUDA DEBIDA A CÁLCULO BILIAR"
  },
  {
    "codigo":319371000119109,
    "descripcion":"LUXACIÓN RECURRENTE DE ARTICULACIÓN DE CADERA DERECHA"
  },
  {
    "codigo":16662411000119105,
    "descripcion":"DISECCIÓN DE ARTERIA RADIAL IZQUIERDA"
  },
  {
    "codigo":1137672001,
    "descripcion":"MENOR NIVEL DE CONFUSIÓN"
  },
  {
    "codigo":306571000119106,
    "descripcion":"GOTA TOFÁCEA CRÓNICA CAUSADA POR FÁRMACO"
  },
  {
    "codigo":1079691000119109,
    "descripcion":"NEVO MELANOCÍTICO PIGMENTADO CONGÉNITO DE PIEL DE MIEMBRO SUPERIOR DERECHO"
  },
  {
    "codigo":11818891000119109,
    "descripcion":"ESGUINCE DE LIGAMENTO DE MANO IZQUIERDA"
  },
  {
    "codigo":414941008,
    "descripcion":"ONICOMICOSIS"
  },
  {
    "codigo":183730002,
    "descripcion":"CONSULTA DOMICILIARIA OBSTÉTRICA SOLICITADA"
  },
  {
    "codigo":85426002,
    "descripcion":"PLEURESÍA BACTERIANA CON DERRAME"
  },
  {
    "codigo":10897211000119109,
    "descripcion":"HERIDA PUNZANTE DE ESCROTO"
  },
  {
    "codigo":249266007,
    "descripcion":"ENGROSAMIENTO DEL CORDÓN ESPERMÁTICO"
  },
  {
    "codigo":445874008,
    "descripcion":"RUPTURA TRAUMÁTICA DE ARTERIA GASTROEPIPLOICA"
  },
  {
    "codigo":773554009,
    "descripcion":"SÍNDROME DE DISMORFISMO FACIAL, MICROCEFALIA Y RETRASO DEL DESARROLLO RELACIONADO CON LA SUBUNIDAD 6 DEL COMPLEJO THO"
  },
  {
    "codigo":247431001,
    "descripcion":"INDURACIÓN LEÑOSA DE LA PIEL Y TEJIDO SUBCUTÁNEO"
  },
  {
    "codigo":216498008,
    "descripcion":"INTOXICACIÓN ACCIDENTAL CAUSADA POR AMOBARBITAL"
  },
  {
    "codigo":1197703004,
    "descripcion":"DISFUNCIÓN DE GASTROSTOMÍA"
  },
  {
    "codigo":83591004,
    "descripcion":"INFECCIÓN CAUSADA POR AMPHIMERUS"
  },
  {
    "codigo":81756001,
    "descripcion":"NISTAGMO HORIZONTAL"
  },
  {
    "codigo":1163100002,
    "descripcion":"ENCEFALITIS POR VIRUS COXSACKIE HUMANO"
  },
  {
    "codigo":704348005,
    "descripcion":"CON MAYOR RIESGO DE HEMORRAGIA"
  },
  {
    "codigo":210993000,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE CUELLO"
  },
  {
    "codigo":1259569000,
    "descripcion":"HIDRADENOCARCINOMA DE CÉLULAS CLARAS ECRINAS PRIMARIO DE PIEL"
  },
  {
    "codigo":16005231000119102,
    "descripcion":"AMIOTROFIA NEURÁLGICA DE PLEXO BRAQUIAL DERECHO"
  },
  {
    "codigo":276529009,
    "descripcion":"HIPOTERMIA AMBIENTAL DEL RECIÉN NACIDO"
  },
  {
    "codigo":372998001,
    "descripcion":"INFECCIÓN CAUSADA POR ASPERGILLUS SCLEROTIORUM"
  },
  {
    "codigo":897286005,
    "descripcion":"IRRITACIÓN DE PIEL PERIANAL"
  },
  {
    "codigo":112751000119103,
    "descripcion":"ANOMALÍA CONGÉNITA DE SURCO ORBITARIO SUPERIOR"
  },
  {
    "codigo":209158005,
    "descripcion":"SUBLUXACIÓN EXPUESTA ENTRE LA QUINTA Y SEXTA VÉRTEBRAS CERVICALES"
  },
  {
    "codigo":305627001,
    "descripcion":"ATENDIDO POR UN ACUPUNTURISTA"
  },
  {
    "codigo":76251002,
    "descripcion":"APRAXIA DE CONSTRUCCIÓN"
  },
  {
    "codigo":11827311000119104,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA DE DEDO GORDO IZQUIERDO"
  },
  {
    "codigo":371163003,
    "descripcion":"TRASTORNO INFLAMATORIO DEL PENE"
  },
  {
    "codigo":240091005,
    "descripcion":"MIOPATÍA EN HIPOPARATIROIDISMO"
  },
  {
    "codigo":1255899007,
    "descripcion":"MASTOCITOMA MALIGNO DE GANGLIOS LINFÁTICOS DE MIEMBRO INFERIOR"
  },
  {
    "codigo":860848000,
    "descripcion":"INDENTACIÓN EN LUGAR DE INYECCIÓN"
  },
  {
    "codigo":1286832001,
    "descripcion":"CIERRE DE ÁNGULO AGUDO DEBIDO A MALFORMACIÓN CONGÉNITA DE ÁNGULO DE CÁMARA ANTERIOR DE OJO"
  },
  {
    "codigo":403931007,
    "descripcion":"MANTELOMA"
  },
  {
    "codigo":301957003,
    "descripcion":"HALLAZGO RELACIONADO CON LENTES ARTIFICIALES"
  },
  {
    "codigo":1186693005,
    "descripcion":"AMBIENTE RUIDOSO"
  },
  {
    "codigo":332041000119102,
    "descripcion":"RETINOPATÍA SOLAR DE OJO DERECHO"
  },
  {
    "codigo":726106004,
    "descripcion":"LEIOMIOMATOSIS DIFUSA LIGADA AL CROMOSOMA X CON SÍNDROME DE ALPORT"
  },
  {
    "codigo":1217626007,
    "descripcion":"AGENESIA DE SISTEMA DE DRENAJE NASOLAGRIMAL"
  },
  {
    "codigo":365658008,
    "descripcion":"CONCENTRACIÓN DE CUERPOS CETÓNICOS DETERMINADA CON TIRA REACTIVA - HALLAZGO"
  },
  {
    "codigo":300122008,
    "descripcion":"HALLAZGO RELACIONADO CON APARIENCIA DE CONDUCTO AUDITIVO"
  },
  {
    "codigo":234586009,
    "descripcion":"DEFICIENCIA LEUCOCITARIA DE GLUCOSA-6-FOSFATO DESHIDROGENASA"
  },
  {
    "codigo":298287007,
    "descripcion":"HALLAZGO RELACIONADO CON LA SENSIBILIDAD DEL MÚSCULO ESQUELÉTICO"
  },
  {
    "codigo":722436002,
    "descripcion":"EPIDERMÓLISIS BULLOSA DISTRÓFICA DE UÑAS SOLAMENTE"
  },
  {
    "codigo":296452002,
    "descripcion":"SOBREDOSIS DE DITRANOL"
  },
  {
    "codigo":720601000,
    "descripcion":"SÍNDROME DE CAMPTODACTILIA Y ESTATURA ELEVADA CON ESCOLIOSIS Y PÉRDIDA DE LA AUDICIÓN"
  },
  {
    "codigo":294617000,
    "descripcion":"ALERGIA A DAPSONA"
  },
  {
    "codigo":15733001000119107,
    "descripcion":"RETINOSQUISIS PLANA DE OJO IZQUIERDO"
  },
  {
    "codigo":11774371000119101,
    "descripcion":"AMPOLLA TRAUMÁTICA DE PULGAR DE MANO DERECHA"
  },
  {
    "codigo":30638000,
    "descripcion":"INTOXICACIÓN POR CESTRUM LAEVIGATUM"
  },
  {
    "codigo":1144750001,
    "descripcion":"DIFICULTAD PARA ENFRENTAR SITUACIONES NUEVAS"
  },
  {
    "codigo":718766002,
    "descripcion":"SÍNDROME DE DISPLASIA ESPONDILOEPIFISARIA, CRANEOSINOSTOSIS, FISURA DE PALADAR, CATARATA Y DISCAPACIDAD INTELECTUAL"
  },
  {
    "codigo":128942007,
    "descripcion":"ENFERMEDAD CAUSADA POR PROTOZOARIO FLAGELADO"
  },
  {
    "codigo":192643004,
    "descripcion":"MENINGITIS POR HAEMOPHILUS"
  },
  {
    "codigo":94339008,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LOS GANGLIOS LINFÁTICOS INGUINALES"
  },
  {
    "codigo":127107009,
    "descripcion":"LINFADENOPATÍA PARAESTERNAL"
  },
  {
    "codigo":1208451008,
    "descripcion":"CARCINOMA DE CÉLULAS TRANSICIONALES DE TRACTO URINARIO SUPERIOR"
  },
  {
    "codigo":715096003,
    "descripcion":"DIFICULTAD PARA PASAR DE INODORO A SILLA DE RUEDAS"
  },
  {
    "codigo":289112007,
    "descripcion":"DIFICULTAD PARA RESOPLAR"
  },
  {
    "codigo":190808009,
    "descripcion":"HIPERGAMMAGLOBULINEMIA POLICLONAL"
  },
  {
    "codigo":25133001,
    "descripcion":"ACCIDENTE CEREBROVASCULAR COMPLETAMENTE DESARROLLADO"
  },
  {
    "codigo":90669003,
    "descripcion":"DIVERTÍCULO CONGÉNITO DE ESTÓMAGO"
  },
  {
    "codigo":188973003,
    "descripcion":"NEOPLASIA BENIGNA DEL CUNEIFORME MEDIO"
  },
  {
    "codigo":713261005,
    "descripcion":"ENFERMEDAD GINGIVAL CAUSADA POR NEISSERIA GONORRHOEAE"
  },
  {
    "codigo":254509006,
    "descripcion":"NEOPLASIA MALIGNA DE COMISURA ANTERIOR DE LARINGE"
  },
  {
    "codigo":285442007,
    "descripcion":"CAPAZ DE MOVER LA MANDÍBULA"
  },
  {
    "codigo":1137410008,
    "descripcion":"DEBILIDAD DE MÚSCULO DE ANTEBRAZO"
  },
  {
    "codigo":283607004,
    "descripcion":"HERIDA POR PINCHAZO DE AGUJA EN EL CUELLO"
  },
  {
    "codigo":185303007,
    "descripcion":"ATENDIDO POR PODÓLOGO"
  },
  {
    "codigo":249004001,
    "descripcion":"HALLAZGO DE LA PARED PÉLVICA LATERAL"
  },
  {
    "codigo":445612002,
    "descripcion":"AZOEMIA POSRENAL"
  },
  {
    "codigo":871596002,
    "descripcion":"PERMEABILIDAD RESIDUAL DE CONDUCTO ARTERIAL DESPUÉS DE REPARACIÓN DE CONDUCTO ARTERIOSO PERMEABLE"
  },
  {
    "codigo":707756004,
    "descripcion":"SÍNDROME DE GITELMAN"
  },
  {
    "codigo":314540004,
    "descripcion":"NEUROPATÍA ÓPTICA MEDICAMENTOSA"
  },
  {
    "codigo":216236006,
    "descripcion":"INTOXICACIÓN POR MONÓXIDO DE CARBONO DE AERONAVE EN TRÁNSITO, SIN ACCIDENTE DE AERONAVE, VIAJERO DE AERONAVE MILITAR LESIONADO"
  },
  {
    "codigo":19628007,
    "descripcion":"AUSENCIA HORMONAL"
  },
  {
    "codigo":609452007,
    "descripcion":"INTERRUPCIÓN INDUCIDA DEL EMBARAZO COMPLICADA POR INSUFICIENCIA RENAL"
  },
  {
    "codigo":281772007,
    "descripcion":"FORTALEZA DEL EGO, MODERADA"
  },
  {
    "codigo":50561001,
    "descripcion":"INTOXICACIÓN POR SAPONARIA"
  },
  {
    "codigo":247169003,
    "descripcion":"DESGARRO LINEAL DE RETINA"
  },
  {
    "codigo":334551000119102,
    "descripcion":"QUERATOCONO INESTABLE DE OJO DERECHO"
  },
  {
    "codigo":443777008,
    "descripcion":"COMPRESIÓN DE INTESTINO EN PLIEGUE CECOCÓLICO"
  },
  {
    "codigo":441942006,
    "descripcion":"NEUMONÍA CAUSADA POR STREPTOCOCCUS PYOGENES"
  },
  {
    "codigo":1259307004,
    "descripcion":"RESORCIÓN INTERNA DE DIENTE POSTERIOR A TRAUMATISMO DENTAL"
  },
  {
    "codigo":866091004,
    "descripcion":"MANSONELIASIS CAUSADA POR MANSONELLA STREPTOCERCA"
  },
  {
    "codigo":309035009,
    "descripcion":"SITUACIÓN DEL CONTROL DEL EVENTO DE LA PRESCRIPCIÓN"
  },
  {
    "codigo":733184002,
    "descripcion":"DEMENCIA CAUSADA POR EXPOSICIÓN A METAL PESADO"
  },
  {
    "codigo":208896003,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE LA ARTICULACIÓN DE LA CADERA, ANTERIOR"
  },
  {
    "codigo":307200007,
    "descripcion":"CONVULSIÓN FEBRIL RECURRENTE"
  },
  {
    "codigo":698581000,
    "descripcion":"FIEBRE POSTERIOR A VACUNACIÓN CONTRA LA TOS FERINA"
  },
  {
    "codigo":308081000119101,
    "descripcion":"HIPERLAXITUD ARTICULAR DE HOMBRO DERECHO"
  },
  {
    "codigo":403669004,
    "descripcion":"ATROFIA CUTÁNEA CAUSADA POR FÁRMACO"
  },
  {
    "codigo":10453005,
    "descripcion":"FORÚNCULO DE MANO"
  },
  {
    "codigo":10957681000119101,
    "descripcion":"HERIDA ABIERTA DE PULGAR IZQUIERDO DEBIDA A MORDEDURA"
  },
  {
    "codigo":237994003,
    "descripcion":"DELECIÓN Y DUPLICACIÓN DE ADN MITOCONDRIAL"
  },
  {
    "codigo":762282007,
    "descripcion":"PAQUIMENINGITIS RELACIONADA CON INMUNOGLOBULINA G4"
  },
  {
    "codigo":399999000,
    "descripcion":"QUISTE QUERATINIZANTE"
  },
  {
    "codigo":301695006,
    "descripcion":"SE MUEVA HACIA ARRIBA Y HACIA ABAJO EN LA CAMA"
  },
  {
    "codigo":365396002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD DE AFRONTAR EL DOLOR"
  },
  {
    "codigo":299860005,
    "descripcion":"REFLEJO SACRO ACTIVO"
  },
  {
    "codigo":103252009,
    "descripcion":"MOTILIDAD OCULAR ANORMAL"
  },
  {
    "codigo":230654000,
    "descripcion":"PIERNAS DOLORIDAS Y DEDOS DEL PIE MÓVILES"
  },
  {
    "codigo":785875003,
    "descripcion":"TRASTORNO DE REGIÓN ARTICULAR"
  },
  {
    "codigo":196051003,
    "descripcion":"NEUMOPATÍAS INTERSTICIALES MEDICAMENTOSAS"
  },
  {
    "codigo":292520001,
    "descripcion":"REACCIÓN ADVERSA A LA OXIMETAZOLINA"
  },
  {
    "codigo":423592001,
    "descripcion":"INFECCIÓN POR VIRUS DE LA ENCEFALITIS EQUINA OCCIDENTAL, NO NEUROINVASIVA"
  },
  {
    "codigo":95912003,
    "descripcion":"TOLERANCIA FARMACOLÓGICA DISMINUIDA"
  },
  {
    "codigo":63144007,
    "descripcion":"VULVITIS"
  },
  {
    "codigo":126845000,
    "descripcion":"NEOPLASIA DEL COLON SIGMOIDE"
  },
  {
    "codigo":1306493002,
    "descripcion":"CARCINOMA DUCTAL INFILTRANTE PRIMARIO DE CUADRANTE INFERIOR INTERNO DE MAMA IZQUIERDA"
  },
  {
    "codigo":94077005,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA GLÁNDULA SUBMAXILAR"
  },
  {
    "codigo":290685006,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR MERCAPTOPURINA"
  },
  {
    "codigo":92242003,
    "descripcion":"NEOPLASIA BENIGNA DEL CORNETE ETMOIDAL DE LA NARIZ"
  },
  {
    "codigo":254247000,
    "descripcion":"SÍNDROME DE BENZODIAZEPINA FETAL"
  },
  {
    "codigo":418087009,
    "descripcion":"AGENESIA DEL APARATO LAGRIMAL"
  },
  {
    "codigo":711164003,
    "descripcion":"VASCULOPATÍA ASOCIADA A LA PROTEÍNA STING DE COMIENZO EN LA LACTANCIA"
  },
  {
    "codigo":1074341000119106,
    "descripcion":"ARTROSIS SECUNDARIA DE AMBAS RODILLAS"
  },
  {
    "codigo":449020009,
    "descripcion":"HEMORRAGIA INTRAPARENQUIMATOSA DE CEREBRO"
  },
  {
    "codigo":250577003,
    "descripcion":"HALLAZGO DE NIVEL DE FENILALANINA EN SUERO"
  },
  {
    "codigo":283345006,
    "descripcion":"PICADURA DE MOSCA"
  },
  {
    "codigo":217809007,
    "descripcion":"COMPRESIÓN RESPIRATORIA DEBIDA A CUERPO EXTRAÑO EN ESÓFAGO"
  },
  {
    "codigo":1299153008,
    "descripcion":"HEMOCROMATOSIS DIGÉNICA"
  },
  {
    "codigo":84902000,
    "descripcion":"OSTEOCONDROSIS JUVENIL DE LA TIBIA"
  },
  {
    "codigo":21201006,
    "descripcion":"DEGENERACIÓN CEREBELOSA ESPORÁDICA"
  },
  {
    "codigo":707494000,
    "descripcion":"CARCINOMA VERRUGOSO PRIMARIO DE TRÁQUEA"
  },
  {
    "codigo":445350004,
    "descripcion":"ARTERIA SUBCLAVIA IZQUIERDA AISLADA"
  },
  {
    "codigo":281510005,
    "descripcion":"COMA MEDICAMENTOSO"
  },
  {
    "codigo":15875391000119103,
    "descripcion":"DEFORMIDAD EN VARO DE AMBAS TIBIAS"
  },
  {
    "codigo":248742008,
    "descripcion":"VÁRICES DEL TRONCOS"
  },
  {
    "codigo":1295483002,
    "descripcion":"FRACTURA OSTEOPORÓTICA DEBIDA A OSTEOPOROSIS POSTMENOPÁUSICA"
  },
  {
    "codigo":410747005,
    "descripcion":"HALLAZGO RELACIONADO CON EL TEJIDO CELULAR SUBCUTÁNEO"
  },
  {
    "codigo":246907005,
    "descripcion":"CONJUNTIVA PALPEBRAL - PAPILAS EN EMPEDRADO"
  },
  {
    "codigo":17531008,
    "descripcion":"LEUCOPLASIA LABIAL"
  },
  {
    "codigo":443515009,
    "descripcion":"SIGNO DE STEMMER"
  },
  {
    "codigo":50299009,
    "descripcion":"PARAFILIA"
  },
  {
    "codigo":1197179009,
    "descripcion":"CELULITIS AGUDA"
  },
  {
    "codigo":310608002,
    "descripcion":"INFECCIÓN DE HUESO ASOCIADA CON ALAMBRE DE KIRSCHNER PARA FIJACIÓN INTERNA"
  },
  {
    "codigo":115835008,
    "descripcion":"FY"
  },
  {
    "codigo":210469001,
    "descripcion":"HERIDA ABIERTA DE LA PARED ABDOMINAL LATERAL"
  },
  {
    "codigo":734757002,
    "descripcion":"DEBILIDAD DE MÚSCULO FACIAL DERECHO"
  },
  {
    "codigo":1259045005,
    "descripcion":"COMPRESIÓN DE COLA DE CABALLO DEBIDA A LESIÓN ESPINAL"
  },
  {
    "codigo":439845008,
    "descripcion":"FÍSTULA ARTERIOVENOSA DE ARTERIA POPLÍTEA A VENA SAFENA INTERNA CONSTRUIDA QUIRÚRGICAMENTE"
  },
  {
    "codigo":15685081000119102,
    "descripcion":"EPITELIOPATÍA CORNEAL DE OJO DERECHO CAUSADA POR VIRUS VARICELA ZÓSTER"
  },
  {
    "codigo":208634001,
    "descripcion":"FRACTURA NO EXPUESTA DE TIBIA DISTAL"
  },
  {
    "codigo":373000005,
    "descripcion":"INFECCIÓN CAUSADA POR ASPERGILLUS SULFUREUS"
  },
  {
    "codigo":700154005,
    "descripcion":"ATENDIDO EN CONSULTORIO ESPECIALIZADO EN MANEJO DEL PESO"
  },
  {
    "codigo":12026006,
    "descripcion":"TAQUICARDIA PAROXÍSTICA"
  },
  {
    "codigo":16094681000119103,
    "descripcion":"PACIENTE DE INSTITUCIÓN DE SERVICIOS DE CUIDADOS ORGANIZADOS"
  },
  {
    "codigo":1157071000,
    "descripcion":"GANGLIOGLIOMA ANAPLÁSICO"
  },
  {
    "codigo":306938008,
    "descripcion":"TUBO DE VENTILACIÓN OBSTRUIDO POR CERA"
  },
  {
    "codigo":110330009,
    "descripcion":"FALTA DE TRONERA ENTRE DIENTES ADYACENTES"
  },
  {
    "codigo":42959003,
    "descripcion":"REACCIÓN DE ENROJECIMIENTO A LA PRUEBA CUTÁNEA"
  },
  {
    "codigo":10191004,
    "descripcion":"EFECTO ANTICOAGULANTE"
  },
  {
    "codigo":11998681000119104,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO DE PIE IZQUIERDO"
  },
  {
    "codigo":403407006,
    "descripcion":"POIQUILODERMIA CAUSADA POR AGENTE FOTODINÁMICO"
  },
  {
    "codigo":270500004,
    "descripcion":"PROLAPSO DE CORDÓN UMBILICAL"
  },
  {
    "codigo":1351844007,
    "descripcion":"SÍNDROME DE AUTOINMUNIDAD DE APARICIÓN TEMPRANA, AUTOINFLAMACIÓN E INMUNODEFICIENCIA POR HAPLOINSUFICIENCIA DE SUPRESOR DE SEÑALIZACIÓN DE CITOCINAS 1"
  },
  {
    "codigo":301433005,
    "descripcion":"ANEURISMA DE ARTERIA DEL TRONCO"
  },
  {
    "codigo":235897005,
    "descripcion":"CIRROSIS ASOCIADA A HIPOXIA"
  },
  {
    "codigo":201294000,
    "descripcion":"QUISTES FOLICULARES DE LA PIEL Y DEL TEJIDO CELULAR SUBCUTÁNEO"
  },
  {
    "codigo":72057009,
    "descripcion":"DERMATITIS DE CONTACTO CAUSADA POR PEDICULICIDA"
  },
  {
    "codigo":102990003,
    "descripcion":"PRUEBA DE LA MARCHA EN LÍNEA RECTA CON LOS OJOS CERRADOS CON RESULTADOS NORMALES"
  },
  {
    "codigo":234062003,
    "descripcion":"ESTENOSIS DE LA VENA PULMONAR"
  },
  {
    "codigo":299598004,
    "descripcion":"AMPLITUD DE EXTENSIÓN ACTIVA DE DEDO DEL PIE DISMINUIDA"
  },
  {
    "codigo":397902006,
    "descripcion":"CABEZA HIPEREXTENDIDA"
  },
  {
    "codigo":126311000146103,
    "descripcion":"NUNCA CAPAZ DE CUIDAR A UN NIÑO"
  },
  {
    "codigo":365134005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA PONERSE DE COSTADO EN LA CAMA"
  },
  {
    "codigo":789283006,
    "descripcion":"NEUROTOXICIDAD CAUSADA POR VENENO DE SERPIENTE"
  },
  {
    "codigo":363299008,
    "descripcion":"SECUELAS DE ENFERMEDADES HEREDITARIAS"
  },
  {
    "codigo":787448000,
    "descripcion":"PERIODONTITIS CON PATRÓN EN MOLARES E INCISIVOS"
  },
  {
    "codigo":339571000119105,
    "descripcion":"MEMBRANA EPIRRETINIANA DE OJO IZQUIERDO"
  },
  {
    "codigo":295928006,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE NEFAZODONA"
  },
  {
    "codigo":359629000,
    "descripcion":"DILATACIÓN VENTRICULAR POSHEMORRÁGICA PROGRESIVA"
  },
  {
    "codigo":66552009,
    "descripcion":"NO SE RECIBIÓ MUESTRA DE TEJIDO"
  },
  {
    "codigo":263160009,
    "descripcion":"FRACTURA DE TUBEROSIDAD MAXILAR"
  },
  {
    "codigo":425165004,
    "descripcion":"DEFICIENCIA EN EL RÉGIMEN DE MEDICACIÓN"
  },
  {
    "codigo":294093004,
    "descripcion":"ALERGIA A TILOXAPOL"
  },
  {
    "codigo":16697101000119102,
    "descripcion":"MALFORMACIÓN CONGÉNITA DE VENA RENAL IZQUIERDA"
  },
  {
    "codigo":95650006,
    "descripcion":"HEMIPLEJÍA TRANSITORIA"
  },
  {
    "codigo":716407001,
    "descripcion":"CAPAZ DE ESTABLECER ESTRUCTURA Y RUTINA EN LA VIDA DIARIA"
  },
  {
    "codigo":93815003,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL NERVIO GLOSOFARÍNGEO"
  },
  {
    "codigo":192119003,
    "descripcion":"CELOS ENTRE HERMANOS"
  },
  {
    "codigo":126583006,
    "descripcion":"NEOPLASIA DE FÉMUR"
  },
  {
    "codigo":288588000,
    "descripcion":"INCAPAZ DE EMPLEAR EL LENGUAJE CORPORAL"
  },
  {
    "codigo":190284002,
    "descripcion":"HIPOTIROIDISMO CAUSADO POR RESORCINOL"
  },
  {
    "codigo":91980005,
    "descripcion":"NEOPLASIA BENIGNA DE VÉRTICE DE VEJIGA"
  },
  {
    "codigo":124748007,
    "descripcion":"ADRENARCA TARDÍA"
  },
  {
    "codigo":90145001,
    "descripcion":"PROMINENCIA FRONTAL"
  },
  {
    "codigo":1204257002,
    "descripcion":"MASA EN PALADAR DURO"
  },
  {
    "codigo":16015271000119101,
    "descripcion":"PELLIZCAMIENTO DE ARTICULACIÓN DE TOBILLO DERECHO"
  },
  {
    "codigo":1237025001,
    "descripcion":"CON RIESGO ELEVADO DE EXPOSICIÓN A COMPLEJO MYCOBACTERIUM TUBERCULOSIS"
  },
  {
    "codigo":286753008,
    "descripcion":"RASGO DE LA PERSONALIDAD: CONTROL DE IMPULSOS - HALLAZGO"
  },
  {
    "codigo":22774003,
    "descripcion":"ALCALOSIS HIPOPOTASÉMICA"
  },
  {
    "codigo":284918009,
    "descripcion":"DIFICULTAD AL USAR LA PALANGANA"
  },
  {
    "codigo":414155001,
    "descripcion":"EXACERBACIÓN DE COLITIS NO INFECCIOSA"
  },
  {
    "codigo":283083003,
    "descripcion":"ARAÑAZO DE LA MANO"
  },
  {
    "codigo":368551000119104,
    "descripcion":"DISLIPIDEMIA DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":446923008,
    "descripcion":"GLOMERULOPATÍA POR LIPOPROTEÍNAS"
  },
  {
    "codigo":314016000,
    "descripcion":"OPACIDAD DEL CRISTALINO RELACIONADA CON LA EDAD"
  },
  {
    "codigo":762419009,
    "descripcion":"PUPILA PARASIMPATICOTÓNICA CAUSADA POR FÁRMACO"
  },
  {
    "codigo":445088006,
    "descripcion":"EDEMA DE CARA"
  },
  {
    "codigo":1297056007,
    "descripcion":"CIERRE DE ÁNGULO POSOPERATORIO DE OJO IZQUIERDO"
  },
  {
    "codigo":248480008,
    "descripcion":"SÍNTOMA DE TUMEFACCIÓN DE LA PIERNA"
  },
  {
    "codigo":838304009,
    "descripcion":"EPENDIMOMA BENIGNO DE SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":443253003,
    "descripcion":"INSUFICIENCIA CARDÍACA SISTÓLICA CRÓNICA REAGUDIZADA"
  },
  {
    "codigo":736330000,
    "descripcion":"FALTA DE VOLUNTAD"
  },
  {
    "codigo":246645009,
    "descripcion":"VE COLORES EN EL CAMPO VISUAL"
  },
  {
    "codigo":410485009,
    "descripcion":"IRITIS CON ENFERMEDAD DE CROHN"
  },
  {
    "codigo":212042002,
    "descripcion":"QUEMADURA POR AGENTES CORROSIVOS DE ESÓFAGO"
  },
  {
    "codigo":1162314004,
    "descripcion":"DOLOR DE CUELLO MIOFASCIAL"
  },
  {
    "codigo":310346004,
    "descripcion":"EL PACIENTE SOLICITA OTRA OPINIÓN LUEGO DE CONSULTA CON MÉDICO ESPECIALISTA"
  },
  {
    "codigo":210207004,
    "descripcion":"RUPTURA COMPLETA DE PARÉNQUIMA RENAL CON HERIDA ABIERTA HACIA CAVIDAD"
  },
  {
    "codigo":767263007,
    "descripcion":"SÍNDROME DE DELECIÓN 22Q11.2"
  },
  {
    "codigo":110068000,
    "descripcion":"LACERACIÓN SIMPLE CONTAMINADA DEL CUERO CABELLUDO"
  },
  {
    "codigo":44532001,
    "descripcion":"EFECTOS DE LA PRESIÓN ATMOSFÉRICA"
  },
  {
    "codigo":77300003,
    "descripcion":"ERITEMA GYRATUM REPENTINO"
  },
  {
    "codigo":11764003,
    "descripcion":"ESTADO POSTCONCUSIÓN"
  },
  {
    "codigo":342081000119106,
    "descripcion":"ENTROPIÓN SENIL DE PÁRPADO IZQUIERDO"
  },
  {
    "codigo":208372003,
    "descripcion":"FRACTURA NO EXPUESTA DEL ESCAFOIDES, CINTURA ESCAFOIDEA, OBLICUA"
  },
  {
    "codigo":370377000,
    "descripcion":"PRUEBA DE RINNE: NEGATIVA"
  },
  {
    "codigo":42697001,
    "descripcion":"CONTUSIÓN DE LOS TEJIDOS ORBITARIOS"
  },
  {
    "codigo":403145002,
    "descripcion":"PICADURA DE TISANÓPTERO"
  },
  {
    "codigo":698057000,
    "descripcion":"FRACTURA NO EXPUESTA DE BASE DE CUARTO METACARPIANO"
  },
  {
    "codigo":206537005,
    "descripcion":"TRASTORNO PERINATAL CUTÁNEO Y DE REGULACIÓN DE TEMPERATURA"
  },
  {
    "codigo":73630001,
    "descripcion":"PROTEINURIA PRERRENAL"
  },
  {
    "codigo":1156809009,
    "descripcion":"NEOPLASIA MESENQUIMÁTICA MALIGNA DE DUODENO"
  },
  {
    "codigo":1255113009,
    "descripcion":"PLACA BACTERIANA POR PRÓTESIS DENTAL"
  },
  {
    "codigo":1079361000119109,
    "descripcion":"NEOPLASIA BENIGNA DE PIEL DE MIEMBRO INFERIOR IZQUIERDO"
  },
  {
    "codigo":237470009,
    "descripcion":"DESPLAZAMIENTO DEL IMPLANTE MAMARIO PROTÉSICO"
  },
  {
    "codigo":235635003,
    "descripcion":"INCOORDINACIÓN PALATOESOFÁGICA"
  },
  {
    "codigo":301171005,
    "descripcion":"HALLAZGO ARTERIAL LUEGO DE PROCEDIMIENTO"
  },
  {
    "codigo":366707006,
    "descripcion":"HALLAZGO RELACIONADO CON LA AMPLITUD DE LA EXTENSIÓN DE DEDO DEL PIE"
  },
  {
    "codigo":233800000,
    "descripcion":"TRASTORNO DE ANASTOMOSIS BRONQUIAL"
  },
  {
    "codigo":299336002,
    "descripcion":"AMPLITUD DE FLEXIÓN ACTIVA DE LA RODILLA AUMENTADA"
  },
  {
    "codigo":397640006,
    "descripcion":"CONOCIMIENTO DE ATENCIÓN DE LA SALUD-HALLAZGO"
  },
  {
    "codigo":364872009,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA CARGAR PESO EN LA PIERNA IZQUIERDA"
  },
  {
    "codigo":35357002,
    "descripcion":"MORFOLOGÍA DE UNA COLONIA BACTERIANA, BORDES"
  },
  {
    "codigo":363037003,
    "descripcion":"ANOMALÍA CONGÉNITA DE LA PORCIÓN SUPERIOR DEL TRONCO"
  },
  {
    "codigo":789021004,
    "descripcion":"RADICULOPATÍA DEBIDA A ESPONDILOSIS"
  },
  {
    "codigo":1149469007,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR SOMATROPINA"
  },
  {
    "codigo":2589008,
    "descripcion":"DACRIOADENITIS AGUDA"
  },
  {
    "codigo":262898000,
    "descripcion":"LESIÓN DE LA PARED URETERAL"
  },
  {
    "codigo":361202002,
    "descripcion":"HIPERTROFIA DE TIMO"
  },
  {
    "codigo":721650001,
    "descripcion":"ATRESIA DE YEYUNO TIPO IVB"
  },
  {
    "codigo":228295004,
    "descripcion":"BEBE EN CLUBES NOCTURNOS"
  },
  {
    "codigo":64455005,
    "descripcion":"FRACTURA DE ACETÁBULO"
  },
  {
    "codigo":719815005,
    "descripcion":"MIOPATÍA LIGADA AL CROMOSOMA X CON AUTOFAGIA EXCESIVA"
  },
  {
    "codigo":95388000,
    "descripcion":"DOLOR EN EL SITIO DE INYECCIÓN"
  },
  {
    "codigo":293831009,
    "descripcion":"ALERGIA A DESIPRAMINA"
  },
  {
    "codigo":62620001,
    "descripcion":"ESPONDILOLISTESIS, GRADO 2"
  },
  {
    "codigo":291996006,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR INHIBIDOR DE LA FOSFODIESTERASA"
  },
  {
    "codigo":191857002,
    "descripcion":"ADICCIÓN A LA ASPIRACIÓN DE PEGAMENTO, EN REMISIÓN"
  },
  {
    "codigo":124486002,
    "descripcion":"DEFICIENCIA DE CISTEINILO - GLICINA DIPEPTIDASA"
  },
  {
    "codigo":26182007,
    "descripcion":"INTOXICACIÓN POR LOLIUM"
  },
  {
    "codigo":24347001,
    "descripcion":"CELULITIS DE LAS CUERDAS VOCALES"
  },
  {
    "codigo":417563003,
    "descripcion":"GRANULOMA DE SACO LAGRIMAL"
  },
  {
    "codigo":253723003,
    "descripcion":"FÍSTULA CORONARIA A PARTIR DEL VENTRÍCULO DERECHO"
  },
  {
    "codigo":778011005,
    "descripcion":"DISCAPACIDAD INTELECTUAL SEVERA Y PARAPLEJÍA ESPÁSTICA PROGRESIVA"
  },
  {
    "codigo":1269531007,
    "descripcion":"SÍNDROME DE CORDÓN CENTRAL DEBIDO A SIRINGOMIELIA"
  },
  {
    "codigo":296200001,
    "descripcion":"SOBREDOSIS DE FLUSPIRILENO"
  },
  {
    "codigo":286491009,
    "descripcion":"PREPARA LA COMIDA"
  },
  {
    "codigo":344591000119106,
    "descripcion":"COROIDITIS DISEMINADA PERIFÉRICA DE AMBOS OJOS"
  },
  {
    "codigo":53445000,
    "descripcion":"EPIDERMIZACIÓN DEL CUELLO UTERINO"
  },
  {
    "codigo":22512009,
    "descripcion":"FIBROSIS DE LA VESÍCULA SEMINAL"
  },
  {
    "codigo":315589003,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: YORUBA"
  },
  {
    "codigo":250053004,
    "descripcion":"ATAXIA PARKINSONIANA"
  },
  {
    "codigo":1264026000,
    "descripcion":"INFLAMACIÓN DE MÚSCULO DE BRAZO"
  },
  {
    "codigo":706970001,
    "descripcion":"NEOPLASIA MALIGNA DE MAMA TRIPLE NEGATIVA"
  },
  {
    "codigo":11786921000119102,
    "descripcion":"CONTUSIÓN DE CADERA IZQUIERDA"
  },
  {
    "codigo":248218005,
    "descripcion":"DESPIERTO"
  },
  {
    "codigo":280986007,
    "descripcion":"PATRÓN DE USO NOCIVO DE ANTIÁCIDO"
  },
  {
    "codigo":18842008,
    "descripcion":"DEGENERACIÓN CORTICOBASAL"
  },
  {
    "codigo":1231258007,
    "descripcion":"ENDOFTALMITIS ENDÓGENA CAUSADA POR ASPERGILLUS"
  },
  {
    "codigo":705135007,
    "descripcion":"FRACTURA NO EXPUESTA DE TECHO DE ACETÁBULO"
  },
  {
    "codigo":703300001,
    "descripcion":"ENCEFALOPATÍA HIPÓXICA ISQUÉMICA"
  },
  {
    "codigo":1293124003,
    "descripcion":"GLOMANGIOMATOSIS"
  },
  {
    "codigo":277316004,
    "descripcion":"RUPTURA DE ANEURISMA DE ARTERIA CEREBRAL MEDIA"
  },
  {
    "codigo":211780006,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO PROFUNDA DE MAMA"
  },
  {
    "codigo":767001002,
    "descripcion":"AUSENCIA CONGÉNITA DE PIERNA Y PIE"
  },
  {
    "codigo":275481002,
    "descripcion":"OTITIS MEDIA NO SUPURADA"
  },
  {
    "codigo":373785006,
    "descripcion":"PARTES DEL CONJUNTO DE DATOS ADMINISTRATIVOS SOBRE CÁNCER"
  },
  {
    "codigo":406553006,
    "descripcion":"RED DE CONTENCIÓN INFORMAL ACTIVA, DISPONIBLE"
  },
  {
    "codigo":111641007,
    "descripcion":"FRACTURA EXPUESTA DEL CUELLO DEL RADIO"
  },
  {
    "codigo":109806002,
    "descripcion":"ANOMALÍA LINGUAL ADQUIRIDA"
  },
  {
    "codigo":77038006,
    "descripcion":"TUBERCULOSIS DE LOS GANGLIOS LINFÁTICOS PERIFÉRICOS"
  },
  {
    "codigo":1254851001,
    "descripcion":"CONTRACCIÓN ANÓMALA DE VESÍCULA BILIAR"
  },
  {
    "codigo":1287619002,
    "descripcion":"CRISIS EPILÉPTICA CON AUTOMATISMOS DE INICIO FOCAL NEONATAL"
  },
  {
    "codigo":239043004,
    "descripcion":"SÍNDROME DE SANDMAN-ANDRA"
  },
  {
    "codigo":402883006,
    "descripcion":"DERMATOSIS DE CÉLULAS HISTIOCÍTICAS NO LANGERHANS"
  },
  {
    "codigo":237208000,
    "descripcion":"RECTOCELE EN EL EMBARAZO, PARTO Y PUERPERIO"
  },
  {
    "codigo":271811009,
    "descripcion":"ENROJECIMIENTO FACIAL"
  },
  {
    "codigo":40600002,
    "descripcion":"BRONQUITIS NEUMOCÓCICA"
  },
  {
    "codigo":827032003,
    "descripcion":"PULMÓN NORMAL"
  },
  {
    "codigo":106136008,
    "descripcion":"HALLAZGO EN EL ÁREA DE LA MEMORIA"
  },
  {
    "codigo":202605000,
    "descripcion":"CHASQUIDO DE ARTICULACIÓN INTERFALÁNGICA DISTAL DE DEDO DE MANO"
  },
  {
    "codigo":11842371000119107,
    "descripcion":"DISTENSIÓN DE TENDÓN DE TOBILLO DERECHO"
  },
  {
    "codigo":347101000119101,
    "descripcion":"BLEFAROCONJUNTIVITIS DE AMBOS OJOS"
  },
  {
    "codigo":300909004,
    "descripcion":"REACCIÓN ALÉRGICA CAUSADA POR PICADURA DE AVISPA"
  },
  {
    "codigo":366445006,
    "descripcion":"AMPLITUD DE LA ROTACIÓN IZQUIERDA DE COLUMNA LUMBAR - HALLAZGO"
  },
  {
    "codigo":399213007,
    "descripcion":"TOXICIDAD POR QUIMIOTERAPIA"
  },
  {
    "codigo":725058003,
    "descripcion":"SÍNDROME DE ATAQUES DE CEFALEAS NEURALGIFORMES UNILATERALES DE BREVE DURACIÓN CON INYECCIÓN CONJUNTIVAL Y SECRECIÓN LAGRIMAL"
  },
  {
    "codigo":102466009,
    "descripcion":"SUSCEPTIBILIDAD A INFECCIONES AUMENTADA"
  },
  {
    "codigo":166167002,
    "descripcion":"ANTICUERPOS MATERNOS PRESENTES"
  },
  {
    "codigo":35095003,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA ARTERIA ILEOCÓLICA"
  },
  {
    "codigo":262636002,
    "descripcion":"CONTUSIÓN DE PALADAR"
  },
  {
    "codigo":5256002,
    "descripcion":"LESIÓN TRAUMÁTICA DE BAZO CON HERIDA ABIERTA HACIA CAVIDAD ABDOMINAL"
  },
  {
    "codigo":33260005,
    "descripcion":"DEFORMIDAD EN TENEDOR"
  },
  {
    "codigo":721388007,
    "descripcion":"SÍNDROME DEL CORDÓN ANTERIOR DE MÉDULA ESPINAL AL NIVEL DEL OCTAVO SEGMENTO CERVICAL"
  },
  {
    "codigo":195265003,
    "descripcion":"ANEURISMA DE AORTA TORACOABDOMINAL, ROTO"
  },
  {
    "codigo":162497004,
    "descripcion":"MODIFICACIÓN DEL SÍNTOMA"
  },
  {
    "codigo":129729005,
    "descripcion":"HALLAZGO MÁS DEFINIDO CON RESPECTO A LA MAMOGRAFÍA ANTERIOR"
  },
  {
    "codigo":293569007,
    "descripcion":"REACCIÓN ADVERSA A LA ETANOLAMINA"
  },
  {
    "codigo":598251000005104,
    "descripcion":"DEJÓ DE CONSUMIR NICOTINA DESPUÉS DEL PRIMER TRIMESTRE"
  },
  {
    "codigo":29590001,
    "descripcion":"CATARATA TOTAL CONGÉNITA"
  },
  {
    "codigo":783254003,
    "descripcion":"SÍNDROME DE PERSISTENCIA HEREDITARIA DE HEMOGLOBINA FETAL CON DREPANOCITOSIS"
  },
  {
    "codigo":226198003,
    "descripcion":"DIETA LIBRE DE LECHE DE VACA"
  },
  {
    "codigo":95126008,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL LÓBULO TEMPORAL"
  },
  {
    "codigo":93291001,
    "descripcion":"HIPOPLASIA CONGÉNITA DE COSTILLA"
  },
  {
    "codigo":191595000,
    "descripcion":"EPISODIOS MANÍACOS RECURRENTES, GRAVES, CON SÍNTOMAS PSICÓTICOS"
  },
  {
    "codigo":289899004,
    "descripcion":"HALLAZGO RELACIONADO CON LA PERCEPCIÓN DE LA MENSTRUACIÓN"
  },
  {
    "codigo":224363007,
    "descripcion":"EMPLEADO"
  },
  {
    "codigo":1306376001,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE CUADRANTE INFERIOR INTERNO DE MAMA"
  },
  {
    "codigo":1303872001,
    "descripcion":"SECUENCIA DE ANEMIA Y POLICITEMIA EN FETOS GEMELARES"
  },
  {
    "codigo":124224004,
    "descripcion":"DEFICIENCIA DE FERROXIDASA"
  },
  {
    "codigo":253461001,
    "descripcion":"DILATACIÓN DE ANILLO DE VÁLVULA AURICULOVENTRICULAR DERECHA"
  },
  {
    "codigo":187925006,
    "descripcion":"NEOPLASIA MALIGNA DE CARTÍLAGO COSTAL"
  },
  {
    "codigo":20415001,
    "descripcion":"POLIDISTROFIA PROGRESIVA ESCLEROSANTE"
  },
  {
    "codigo":53183006,
    "descripcion":"ABORTO ESPONTÁNEO CON HEMÓLISIS INTRAVASCULAR"
  },
  {
    "codigo":282559007,
    "descripcion":"INCAPAZ DE CAMINAR EN PUNTAS DE PIE"
  },
  {
    "codigo":249791008,
    "descripcion":"ACORTAMIENTO DE PORCIÓN MEDIA DE PIERNA"
  },
  {
    "codigo":247956001,
    "descripcion":"BAJO NIVEL DE REACTIVIDAD DURANTE EPISODIO DE SONAMBULISMO"
  },
  {
    "codigo":446399009,
    "descripcion":"PULSO PEDIO BIFÁSICO"
  },
  {
    "codigo":772244003,
    "descripcion":"HERNIA PARAESOFÁGICA OBSTRUIDA"
  },
  {
    "codigo":103851000119100,
    "descripcion":"ENFERMEDAD PULMONAR RESTRICTIVA DEBIDA A ESCLEROSIS LATERAL AMIOTRÓFICA"
  },
  {
    "codigo":82281000,
    "descripcion":"SIGNOS ELECTROCARDIOGRÁFICOS DE HIPERTROFIA AURICULAR"
  },
  {
    "codigo":84116009,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO POR COMPRESIÓN"
  },
  {
    "codigo":870548008,
    "descripcion":"FRACTURA NO EXPUESTA DE CRÁNEO CON LACERACIÓN CEREBRAL"
  },
  {
    "codigo":49513005,
    "descripcion":"DESHIDRATACIÓN POR FIEBRE EN EL RECIÉN NACIDO"
  },
  {
    "codigo":1260094000,
    "descripcion":"CARCINOMA VERRUGOSO DE HIPOFARINGE"
  },
  {
    "codigo":770409009,
    "descripcion":"POLISINDACTILIA CRUZADA"
  },
  {
    "codigo":735806002,
    "descripcion":"HERIDA PUNZANTE DE ANTEBRAZO SIN CUERPO EXTRAÑO"
  },
  {
    "codigo":11818411000119103,
    "descripcion":"ESGUINCE DE LIGAMENTO DE ARTICULACIÓN INTERFALÁNGICA DE PULGAR IZQUIERDO"
  },
  {
    "codigo":703038009,
    "descripcion":"BREVUNDIMONAS DIMINUTA O BREVUNDIMONAS VESICULARIS"
  },
  {
    "codigo":80446009,
    "descripcion":"LABIO LEPORINO BILATERAL COMPLETO"
  },
  {
    "codigo":38091000087101,
    "descripcion":"ACINESIA DE MIOCARDIO DE REGIÓN INFEROSEPTAL DE VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":111379007,
    "descripcion":"DEFICIENCIA MINERAL"
  },
  {
    "codigo":677291000119105,
    "descripcion":"HIPOTONÍA DE AMBOS OJOS DEBIDA A FÍSTULA OCULAR"
  },
  {
    "codigo":209683009,
    "descripcion":"SECCIÓN EXPUESTA DE LIGAMENTO DE DEDO DE LA MANO, ARTICULACIÓN INTERFALÁNGICA PROXIMAL, LIGAMENTO LATERAL RADIAL"
  },
  {
    "codigo":733971007,
    "descripcion":"CARIES DENTAL PRIMARIA INACTIVA QUE SE EXTIENDE HASTA EL ESMALTE"
  },
  {
    "codigo":109544003,
    "descripcion":"FALTA DE ERUPCIÓN DENTAL ASOCIADA CON IMPACTACIÓN"
  },
  {
    "codigo":40651000087104,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE TERCER DEDO DE PIE DERECHO"
  },
  {
    "codigo":43211000087109,
    "descripcion":"HERIDA PUNZANTE DE MANO DERECHA CON CUERPO EXTRAÑO"
  },
  {
    "codigo":1086891000119105,
    "descripcion":"MATERIAL DE RESTAURACIÓN DENTAL FRACTURADO CON PÉRDIDA DE MATERIAL"
  },
  {
    "codigo":240616003,
    "descripcion":"FIEBRE MANCHADA DE LAS MONTAÑAS ROCOSAS ORIENTALES"
  },
  {
    "codigo":763069002,
    "descripcion":"PARAPLEJÍA ESPÁSTICA AUTOSÓMICA DOMINANTE TIPO 41"
  },
  {
    "codigo":238781005,
    "descripcion":"PÚRPURA URTICANTE"
  },
  {
    "codigo":402621008,
    "descripcion":"VITILIGO IDIOPÁTICO"
  },
  {
    "codigo":366183000,
    "descripcion":"HALLAZGO RELACIONADO CON CARACTERÍSTICA DEL LATIDO DE LA PUNTA"
  },
  {
    "codigo":890471003,
    "descripcion":"INGESTA EXCESIVA DE ZINC"
  },
  {
    "codigo":300647006,
    "descripcion":"INCAPAZ DE CONDUCIR UNA BICICLETA"
  },
  {
    "codigo":235111007,
    "descripcion":"QUISTE ODONTÓGENO GLANDULAR"
  },
  {
    "codigo":298812001,
    "descripcion":"AMPLITUD DE ADUCCIÓN ACTIVA DE HOMBRO DISMINUIDA"
  },
  {
    "codigo":724796004,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO A LA ALTURA DE LA MANO"
  },
  {
    "codigo":167740005,
    "descripcion":"GLUCOSA EN LÍQUIDO CEFALORRAQUÍDEO POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":3900008,
    "descripcion":"POLINEUROPATÍA MIXTA SENSITIVOMOTRIZ"
  },
  {
    "codigo":939821000000109,
    "descripcion":"CAPAZ DE MANEJAR RIESGO EN CASA"
  },
  {
    "codigo":323141000119108,
    "descripcion":"LONGITUD DESIGUAL DE EXTREMIDAD INFERIOR DEBIDA A ACORTAMIENTO ADQUIRIDO DE TIBIA DERECHA"
  },
  {
    "codigo":296977008,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE CLOFIBRATO"
  },
  {
    "codigo":2065009,
    "descripcion":"ATROFIA ÓPTICA HEREDITARIA DOMINANTE"
  },
  {
    "codigo":295142004,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE PENTAZOCINA"
  },
  {
    "codigo":296671000119103,
    "descripcion":"HIPERLAXITUD ARTICULAR DE RODILLA"
  },
  {
    "codigo":195003002,
    "descripcion":"TRASTORNOS DE LAS VÁLVULAS AÓRTICA Y TRICÚSPIDE"
  },
  {
    "codigo":424379006,
    "descripcion":"MANTENIMIENTO INADECUADO DE LOS PARÁMETROS DE DESARROLLO"
  },
  {
    "codigo":94864000,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA CABEZA"
  },
  {
    "codigo":29328001,
    "descripcion":"NOTOMELO"
  },
  {
    "codigo":293307008,
    "descripcion":"REACCIÓN ADVERSA A LA EPOETINA BETA"
  },
  {
    "codigo":1208976003,
    "descripcion":"TROMBO MURAL AURICULAR"
  },
  {
    "codigo":225936008,
    "descripcion":"TIRA CIGARRILLOS ENCENDIDOS"
  },
  {
    "codigo":93029001,
    "descripcion":"ANOMALÍA CONGÉNITA DE HUESO CIGOMÁTICO"
  },
  {
    "codigo":1010533002,
    "descripcion":"ESCLEROSIS DE EPÍFISIS DE FALANGE PROXIMAL DE TERCER DEDO DE PIE CON RADIOPACIDAD AUMENTADA"
  },
  {
    "codigo":289637001,
    "descripcion":"ÚTERO CON FORMA DE CORAZÓN"
  },
  {
    "codigo":224101003,
    "descripcion":"MIEMBRO DE FAMILIA MONOPARENTAL"
  },
  {
    "codigo":15671161000119102,
    "descripcion":"EXOTROPÍA CONGÉNITA DE AMBOS OJOS"
  },
  {
    "codigo":25658005,
    "descripcion":"TRASTORNO DE LA VAGINA"
  },
  {
    "codigo":255034006,
    "descripcion":"ADENOMA FOLICULAR DE GLÁNDULA TIROIDES"
  },
  {
    "codigo":58426006,
    "descripcion":"INFECCIÓN CAUSADA POR BUNOSTOMUM"
  },
  {
    "codigo":417039001,
    "descripcion":"FRACTURA-LUXACIÓN DE ARTICULACIÓN DE LA CINTURA ESCAPULAR"
  },
  {
    "codigo":285967002,
    "descripcion":"DESCARGA EL INODORO"
  },
  {
    "codigo":253199003,
    "descripcion":"MALFORMACIÓN CONGÉNITA DE LAS MENINGES"
  },
  {
    "codigo":449807005,
    "descripcion":"LACERACIÓN PERINEAL DE TERCER GRADO, TIPO 3A"
  },
  {
    "codigo":352121000119105,
    "descripcion":"MELANOMA IN SITU DE OÍDO DERECHO"
  },
  {
    "codigo":1089401000119105,
    "descripcion":"OTOESCLEROSIS DE LOS HUESECILLOS DEL OÍDO IZQUIERDO"
  },
  {
    "codigo":284132005,
    "descripcion":"DIFICULTAD PARA CONTROLAR LA POSICIÓN PÉLVICA"
  },
  {
    "codigo":249529000,
    "descripcion":"ELIMINACIÓN DE MECONIO"
  },
  {
    "codigo":18318000,
    "descripcion":"ENAMORAMIENTO"
  },
  {
    "codigo":870286003,
    "descripcion":"ENFERMEDAD SIMILAR A TRASTORNO DE PELIZAEUS-MERZBACHER DEBIDA A MUTACIÓN EN AIMP1"
  },
  {
    "codigo":83854004,
    "descripcion":"INFECCIÓN CAUSADA POR MADURELLA GRISEA"
  },
  {
    "codigo":247694003,
    "descripcion":"PASIVIDAD DE ACTOS VOLITIVOS"
  },
  {
    "codigo":737379001,
    "descripcion":"ESTADIO CLÍNICO 2 DE INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA DE LA ORGANIZACIÓN MUNDIAL DE LA SALUD DE 2007"
  },
  {
    "codigo":213091004,
    "descripcion":"PROMINENCIA DE PLACA"
  },
  {
    "codigo":278627008,
    "descripcion":"SUPERFICIE DE LA PRÓTESIS DENTAL RUGOSA"
  },
  {
    "codigo":735544003,
    "descripcion":"TRASTORNO NEUROLÓGICO DISOCIATIVO CON SÍNTOMA DE TRASTORNO DEL MOVIMIENTO"
  },
  {
    "codigo":14648003,
    "descripcion":"SIGNO PIRAMIDAL"
  },
  {
    "codigo":1259832005,
    "descripcion":"NEOPLASIA PRIMARIA MALIGNA DE VAINA DE NERVIO PERIFÉRICO DE TÓRAX"
  },
  {
    "codigo":299181000119100,
    "descripcion":"HEMARTROSIS DE MUÑECA DERECHA"
  },
  {
    "codigo":440632003,
    "descripcion":"RECIBIÓ EDUCACIÓN DE POSDOCTORADO"
  },
  {
    "codigo":276792008,
    "descripcion":"HIPERTENSIÓN PULMONAR CON OBESIDAD EXTREMA"
  },
  {
    "codigo":211256008,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE ANTEBRAZO, INFECTADA"
  },
  {
    "codigo":135341000119101,
    "descripcion":"INFECCIÓN POR PEPTOSTREPTOCOCCUS"
  },
  {
    "codigo":45581006,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE MAMA CON INFECCIÓN"
  },
  {
    "codigo":897549008,
    "descripcion":"DUPLICACIÓN DISTAL DEL CROMOSOMA 13"
  },
  {
    "codigo":830178002,
    "descripcion":"ALERGIA A TERODILINA"
  },
  {
    "codigo":109282007,
    "descripcion":"MELANOMA IN SITU DEL CUELLO"
  },
  {
    "codigo":238519000,
    "descripcion":"REACCIÓN A LA FOTOQUIMIOTERAPIA"
  },
  {
    "codigo":764642008,
    "descripcion":"AMPOLLA DE CONDUCTO AUDITIVO EXTERNO"
  },
  {
    "codigo":305890007,
    "descripcion":"VISTO POR EL SERVICIO DE CIRUGÍA GASTROINTESTINAL"
  },
  {
    "codigo":240354007,
    "descripcion":"INFECCIÓN DEL TRACTO GASTRINTESTINAL POR ESCHERICHIA COLI ENTEROHEMORRÁGICA"
  },
  {
    "codigo":404194009,
    "descripcion":"DESGASTE DENTAL POR RECHINAR DE DIENTES"
  },
  {
    "codigo":402359006,
    "descripcion":"NECRÓLISIS EPIDÉRMICA TÓXICA POR ENFERMEDAD DE INJERTO VERSUS HUÉSPED"
  },
  {
    "codigo":1285260001,
    "descripcion":"RANGO ACTIVO DE DORSIFLEXIÓN DE TOBILLO DISMINUIDO"
  },
  {
    "codigo":236684001,
    "descripcion":"URETRITIS TUBERCULOSA"
  },
  {
    "codigo":105612003,
    "descripcion":"LESIÓN TRAUMÁTICA DE ÓRGANO INTERNO"
  },
  {
    "codigo":300385000,
    "descripcion":"DESEO DE DEFECAR - HALLAZGO"
  },
  {
    "codigo":726369001,
    "descripcion":"DELECIÓN DE PARTE DEL CROMOSOMA 3"
  },
  {
    "codigo":5473002,
    "descripcion":"AMPOLLA DE LA PARED TORÁCICA, CON INFECCIÓN"
  },
  {
    "codigo":890209003,
    "descripcion":"ESTENOSIS ADQUIRIDA DE TRONCO ARTERIAL COMÚN POSTERIOR A PROCEDIMIENTO"
  },
  {
    "codigo":71009001,
    "descripcion":"VESÍCULA BILIAR MULTITABICADA"
  },
  {
    "codigo":365921005,
    "descripcion":"CAMBIO DE PESO - HALLAZGO"
  },
  {
    "codigo":202081006,
    "descripcion":"DESGARRO POR SEPARACIÓN HORIZONTAL DE MENISCO INTERNO"
  },
  {
    "codigo":298550000,
    "descripcion":"SIN AMPLITUD DE FLEXIÓN LATERAL PASIVA HACIA LA IZQUIERDA DE LA COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":682311000119102,
    "descripcion":"ANGIOSARCOMA PRIMARIO DE CARA"
  },
  {
    "codigo":724534002,
    "descripcion":"ÚLCERA DUODENAL CAUSADA POR HONGO"
  },
  {
    "codigo":34571000,
    "descripcion":"ANOVULACIÓN"
  },
  {
    "codigo":36406009,
    "descripcion":"INFECCIÓN CRUZADA"
  },
  {
    "codigo":296715001,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE CEFTAZIDIMA"
  },
  {
    "codigo":108871000119104,
    "descripcion":"INFECCIÓN CAUSADA POR LACTOCOCCUS"
  },
  {
    "codigo":427787004,
    "descripcion":"ABSCESO EN ESPACIO EPIDURAL DE COLUMNA CERVICAL"
  },
  {
    "codigo":10676551000119105,
    "descripcion":"ASMA ALÉRGICA PERSISTENTE MODERADA CONTROLADA"
  },
  {
    "codigo":131040000,
    "descripcion":"NIVEL DE ÁCIDO VAINILLILMANDÉLICO POR ENCIMA DE RANGO DE REFERENCIA"
  },
  {
    "codigo":360416003,
    "descripcion":"DEFICIENCIA DE GLUTARIL-COA DESHIDROGENASA"
  },
  {
    "codigo":65504006,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DEL TALÓN"
  },
  {
    "codigo":720864008,
    "descripcion":"ENCEFALOPATÍA DEBIDA A DEFICIENCIA DE PROSAPOSINA"
  },
  {
    "codigo":294880008,
    "descripcion":"ALERGIA A ACENOCUMAROL"
  },
  {
    "codigo":161973001,
    "descripcion":"DOLOR DE LA PARED ANTERIOR DEL TÓRAX"
  },
  {
    "codigo":260277002,
    "descripcion":"VISIÓN A DISTANCIA 6\/36"
  },
  {
    "codigo":15729121000119101,
    "descripcion":"LUXACIÓN DE TOBILLO DERECHO DEBIDA A DISPLASIA CONGÉNITA"
  },
  {
    "codigo":194741006,
    "descripcion":"ESTENOSIS E INSUFICIENCIA TRICUSPÍDEA REUMÁTICA"
  },
  {
    "codigo":63669006,
    "descripcion":"FRACTURA DE LE FORT, TIPO I"
  },
  {
    "codigo":422282000,
    "descripcion":"NEOPLASIA MALIGNA CON SÍNDROME DE INMUNODEFICIENCIA ADQUIRIDA"
  },
  {
    "codigo":94602001,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA COLUMNA VERTEBRAL"
  },
  {
    "codigo":717194002,
    "descripcion":"ACINETOBACTER ANITRATUS O ACINETOBACTER HAEMOLYTICUS"
  },
  {
    "codigo":192906003,
    "descripcion":"MIELOPATÍA POR NEOPLASIA"
  },
  {
    "codigo":127370001,
    "descripcion":"SÉPTIMO EMBARAZO"
  },
  {
    "codigo":29066007,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE CODO"
  },
  {
    "codigo":92767001,
    "descripcion":"CARCINOMA IN SITU DE LA GLÁNDULA TIROIDES"
  },
  {
    "codigo":481000119104,
    "descripcion":"DISTENSIÓN DE MÚSCULO ISQUIOTIBIAL"
  },
  {
    "codigo":289375008,
    "descripcion":"NALGAS PROFUNDAMENTE ENCAJADAS"
  },
  {
    "codigo":1336116001,
    "descripcion":"SÍNDROME DE ARTRITIS PSORIÁSICA, PIODERMA GANGRENOSO, ACNÉ, HIDRADENITIS SUPURATIVA"
  },
  {
    "codigo":713524002,
    "descripcion":"TRASTORNO DEL SUEÑO CAUSADO POR INHIBIDOR DE TRANSCRIPTASA INVERSA"
  },
  {
    "codigo":123700004,
    "descripcion":"ECCEMA PUSTULOSO"
  },
  {
    "codigo":89097000,
    "descripcion":"FÍSTULA LABERÍNTICA"
  },
  {
    "codigo":23561002,
    "descripcion":"INFESTACIÓN CAUSADA POR VARROIDAE"
  },
  {
    "codigo":11770491000119101,
    "descripcion":"SUBLUXACIÓN ANTERIOR DE CABEZA DE RADIO DERECHO"
  },
  {
    "codigo":1137673006,
    "descripcion":"MEJORÍA EN EL NIVEL DE ÁNIMO DEPRIMIDO"
  },
  {
    "codigo":301691000119102,
    "descripcion":"TENDINITIS DE TENDÓN DE AQUILES IZQUIERDO"
  },
  {
    "codigo":414942001,
    "descripcion":"FRACTURA EXPUESTA DE PIERNA"
  },
  {
    "codigo":185566000,
    "descripcion":"INMUNIZACIÓN INFANTIL - NUEVO LLAMADO ANULADO"
  },
  {
    "codigo":447710003,
    "descripcion":"DERMATOFIBROSARCOMA PROTUBERANS DE PIEL DE HOMBRO"
  },
  {
    "codigo":216499000,
    "descripcion":"INTOXICACIÓN ACCIDENTAL CAUSADA POR BARBITAL"
  },
  {
    "codigo":314803001,
    "descripcion":"ATENDIDO EN CONSULTORIO DE ENFERMERÍA DE ACCESO ABIERTO"
  },
  {
    "codigo":183731003,
    "descripcion":"CONSULTA DOMICILIARIA DE GINECOLOGÍA SOLICITADA"
  },
  {
    "codigo":11829861000119100,
    "descripcion":"HEMATOMA DE PIERNA DERECHA"
  },
  {
    "codigo":97381000119100,
    "descripcion":"VEJIGA URINARIA NEUROGÉNICA DEBIDA A CUADRIPLEJÍA"
  },
  {
    "codigo":101000119102,
    "descripcion":"SENSACIÓN DE ENTUMECIMIENTO Y HORMIGUEO EN LA PIEL"
  },
  {
    "codigo":16289381000119103,
    "descripcion":"DISECCIÓN DE ARTERIA HEPÁTICA"
  },
  {
    "codigo":52659007,
    "descripcion":"DIETA RESTRINGIDA EN VITAMINA K DURANTE LA TERAPIA DE ANTICOAGULACIÓN"
  },
  {
    "codigo":368741000119105,
    "descripcion":"RETINOPATÍA NO PROLIFERATIVA MODERADA DEBIDA A DIABETES MELLITUS SECUNDARIA"
  },
  {
    "codigo":15974501000119106,
    "descripcion":"NEOPLASIA BENIGNA DE PARTES BLANDAS DE AMBOS MIEMBROS INFERIORES"
  },
  {
    "codigo":110181000119105,
    "descripcion":"NEUROPATÍA PERIFÉRICA SENSITIVA DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":314981000119107,
    "descripcion":"OSTEÍTIS DEFORMANTE DE CÚBITO Y RADIO"
  },
  {
    "codigo":15933541000119109,
    "descripcion":"ENDOMETRIOSIS EN TROMPA DE FALOPIO DERECHA"
  },
  {
    "codigo":1075301000119105,
    "descripcion":"DEFORMIDAD EN VARO ADQUIRIDA DE ARTICULACIÓN DE REGIÓN DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":11847781000119106,
    "descripcion":"ABRASIÓN INFECTADA DE MUCOSA BUCAL"
  },
  {
    "codigo":338021000119106,
    "descripcion":"RETINOPATÍA POR PREMATUREZ DEL OJO IZQUIERDO"
  },
  {
    "codigo":12403301000119106,
    "descripcion":"INESTABILIDAD DE PRÓTESIS DE ARTICULACIÓN GLENOHUMERAL IZQUIERDA"
  },
  {
    "codigo":12239461000119106,
    "descripcion":"GLAUCOMA DE OJO IZQUIERDO"
  },
  {
    "codigo":11794021000119108,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE DEDO GORDO DE PIE IZQUIERDO"
  },
  {
    "codigo":348261000119107,
    "descripcion":"PAPILOMA DE PÁRPADO DERECHO"
  },
  {
    "codigo":43621000119108,
    "descripcion":"INTOXICACIÓN CAUSADA POR LÁTEX"
  },
  {
    "codigo":1197704005,
    "descripcion":"HEPATITIS AUTOINMUNE CON AUTOANTICUERPOS NEGATIVOS"
  },
  {
    "codigo":704349002,
    "descripcion":"CON MAYOR RIESGO DE MALTRATO DE ANCIANO"
  },
  {
    "codigo":278365007,
    "descripcion":"SANGRADO INDUCIDO POR ANTICOAGULANTES"
  },
  {
    "codigo":442205007,
    "descripcion":"FRACTURA POR SOBRECARGA DE TIBIA"
  },
  {
    "codigo":212829003,
    "descripcion":"EFECTO TÓXICO DEL DICLOROMETANO"
  },
  {
    "codigo":309298003,
    "descripcion":"HALLAZGO RELACIONADO CON TRATAMIENTO FARMACOLÓGICO"
  },
  {
    "codigo":1259570004,
    "descripcion":"COREA CAUSADA POR ANTAGONISTA DE RECEPTOR DE DOPAMINA"
  },
  {
    "codigo":473138005,
    "descripcion":"MIGRACIÓN DE CATÉTER VENOSO CENTRAL"
  },
  {
    "codigo":210994006,
    "descripcion":"ABRASIÓN INFECTADA DE CUERO CABELLUDO"
  },
  {
    "codigo":14386001,
    "descripcion":"LEPRA INDETERMINADA"
  },
  {
    "codigo":79922009,
    "descripcion":"DOLOR EPIGÁSTRICO"
  },
  {
    "codigo":209159002,
    "descripcion":"SUBLUXACIÓN EXPUESTA ENTRE LA SEXTA Y SÉPTIMA VÉRTEBRAS CERVICALES"
  },
  {
    "codigo":241927005,
    "descripcion":"EFECTO TÓXICO CAUSADO POR PRODUCTOS PARA EL CUIDADO DE MASCOTAS"
  },
  {
    "codigo":733447005,
    "descripcion":"OBSTRUCCIÓN INTESTINAL EN EL RECIÉN NACIDO DEBIDA A DEFICIENCIA DE GUANILATO CICLASA 2C"
  },
  {
    "codigo":403932000,
    "descripcion":"TRICOGERMINOMA"
  },
  {
    "codigo":1255900002,
    "descripcion":"RESTAURACIÓN DENTAL SATISFACTORIA PARA ODONTÓLOGO"
  },
  {
    "codigo":43484003,
    "descripcion":"PESTE CELULOCUTÁNEA"
  },
  {
    "codigo":240092003,
    "descripcion":"MIOPATÍA EN OSTEOMALACIA"
  },
  {
    "codigo":305628006,
    "descripcion":"ATENDIDO POR UN QUIROPRÁCTICO"
  },
  {
    "codigo":74417001,
    "descripcion":"BRONQUITIS CRÓNICA MUCOPURULENTA"
  },
  {
    "codigo":762545002,
    "descripcion":"DERMATITIS ALÉRGICA POR CONTACTO OCUPACIONAL CAUSADA POR CALZADO"
  },
  {
    "codigo":1286833006,
    "descripcion":"DISPLASIA ESPONDILOEPIMETAFISARIA CON LAXITUD ARTICULAR TIPO BEIGHTON"
  },
  {
    "codigo":860849008,
    "descripcion":"GRANULOMA DE MÉDULA ESPINAL CAUSADO POR HONGO"
  },
  {
    "codigo":15977391000119102,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE AMBAS GLÁNDULAS LAGRIMALES"
  },
  {
    "codigo":367494004,
    "descripcion":"NACIMIENTO PREMATURO"
  },
  {
    "codigo":1186694004,
    "descripcion":"AMBIENTE EXTRAÑO"
  },
  {
    "codigo":365659000,
    "descripcion":"HALLAZGO RELACIONADO CON EL ASPECTO GENERAL DEL ESPÉCIMEN"
  },
  {
    "codigo":234587000,
    "descripcion":"DEFICIENCIA DE LACTOFERRINA NEUTROFÍLICA"
  },
  {
    "codigo":201819000,
    "descripcion":"ARTROSIS GENERALIZADA"
  },
  {
    "codigo":1217627003,
    "descripcion":"CONTRACCIÓN CONGÉNITA DE ÓRBITA"
  },
  {
    "codigo":7046009,
    "descripcion":"HIPERLEUCINA - ISOLEUCINEMIA"
  },
  {
    "codigo":300123003,
    "descripcion":"HALLAZGO RELACIONADO CON TAMAÑO DE CONDUCTO AUDITIVO"
  },
  {
    "codigo":70747007,
    "descripcion":"DEPRESIÓN MAYOR, UN SOLO EPISODIO, EN REMISIÓN PARCIAL"
  },
  {
    "codigo":726107008,
    "descripcion":"MIOPATÍA DISTAL TIPO WELANDER"
  },
  {
    "codigo":16059311000119105,
    "descripcion":"DEFECTO DEL CAMPO VISUAL CON ESCALÓN NASAL BILATERAL"
  },
  {
    "codigo":298288002,
    "descripcion":"DOLOR MUSCULAR DIFUSO A LA PALPACIÓN"
  },
  {
    "codigo":429360005,
    "descripcion":"TENDINITIS DE RODILLA"
  },
  {
    "codigo":36144008,
    "descripcion":"SIGNO DE MCCLINTOCK"
  },
  {
    "codigo":3376008,
    "descripcion":"PSEUDOPTIALISMO"
  },
  {
    "codigo":10953801000119101,
    "descripcion":"HERIDA ABIERTA DE ANTEBRAZO IZQUIERDO DEBIDA A MORDEDURA DE GATO"
  },
  {
    "codigo":722437006,
    "descripcion":"SÍNDROME DE ECTOPIA DE CRISTALINO, DISTROFIA CORIORRETINIANA Y MIOPÍA"
  },
  {
    "codigo":427525007,
    "descripcion":"CURVATURA DE LA COLUMNA VERTEBRAL POR OSTEOMALACIA"
  },
  {
    "codigo":67077008,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE AXILA CON INFECCIÓN"
  },
  {
    "codigo":65242001,
    "descripcion":"MIASTENIA INDUCIDA POR DROGAS"
  },
  {
    "codigo":296453007,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE DITRANOL"
  },
  {
    "codigo":294618005,
    "descripcion":"ALERGIA A CLOFAZIMINA"
  },
  {
    "codigo":720602007,
    "descripcion":"SÍNDROME DE CAMPTODACTILIA TIPO GUADALAJARA 1"
  },
  {
    "codigo":292783004,
    "descripcion":"REACCIÓN ADVERSA A LA PARAFINA"
  },
  {
    "codigo":94340005,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA REGIÓN INGUINAL"
  },
  {
    "codigo":192644005,
    "descripcion":"MENINGITIS MENINGOCÓCICA"
  },
  {
    "codigo":190809001,
    "descripcion":"PÚRPURA HIPERGAMMAGLOBULINÉMICA DE WALDENSTROM"
  },
  {
    "codigo":289113002,
    "descripcion":"CAPAZ DE TOSER"
  },
  {
    "codigo":715097007,
    "descripcion":"DIFICULTAD PARA PASAR DE LA SILLA DE RUEDAS A LA CAMA"
  },
  {
    "codigo":254510001,
    "descripcion":"CARCINOMA IN SITU DE LA COMISURA ANTERIOR"
  },
  {
    "codigo":92505009,
    "descripcion":"MORDIDA EN CRUZ BILATERAL"
  },
  {
    "codigo":1335854006,
    "descripcion":"ESTOMATITIS DEBIDA A RADIOTERAPIA Y POSTERIOR A ELLA"
  },
  {
    "codigo":188974009,
    "descripcion":"NEOPLASIA BENIGNA DEL CUNEIFORME EXTERNO"
  },
  {
    "codigo":88835002,
    "descripcion":"FRACTURA NO EXPUESTA DE CARTÍLAGO TIROIDES"
  },
  {
    "codigo":285443002,
    "descripcion":"INCAPAZ DE MOVER LA MANDÍBULA"
  },
  {
    "codigo":1137411007,
    "descripcion":"DEBILIDAD DE MÚSCULO FLEXOR DE ARTICULACIÓN DE CADERA"
  },
  {
    "codigo":185304001,
    "descripcion":"ATENDIDO POR MÉDICO DE ORGANIZACIÓN COOPERATIVA"
  },
  {
    "codigo":249005000,
    "descripcion":"PAREDES PÉLVICAS LATERALES CONVERGENTES"
  },
  {
    "codigo":283608009,
    "descripcion":"HERIDA POR PINCHAZO DE AGUJA EN LA GARGANTA"
  },
  {
    "codigo":609453002,
    "descripcion":"INTERRUPCIÓN INDUCIDA DEL EMBARAZO COMPLICADA POR CHOQUE"
  },
  {
    "codigo":281773002,
    "descripcion":"FORTALEZA DEL EGO, BAJA"
  },
  {
    "codigo":333181000119101,
    "descripcion":"RETINITIS PERIFÉRICA FOCAL DE OJO DERECHO"
  },
  {
    "codigo":216237002,
    "descripcion":"INTOXICACIÓN CAUSADA POR MONÓXIDO DE CARBONO DE AERONAVE EN TRÁNSITO, SIN ACCIDENTE DE AERONAVE, MIEMBRO DE TRIPULACIÓN DE AERONAVE COMERCIAL EN TRANSPORTE DE SUPERFICIE A SUPERFICIE LESIONADO"
  },
  {
    "codigo":871597006,
    "descripcion":"DISPLASIA CONGÉNITA DE VÁLVULA AÓRTICA"
  },
  {
    "codigo":771458000,
    "descripcion":"NUEVO CONTACTO SEXUAL"
  },
  {
    "codigo":83330001,
    "descripcion":"CONDUCTO ARTERIOSO PERSISTENTE"
  },
  {
    "codigo":17794004,
    "descripcion":"LEISHMANIASIS CUTÁNEA RECURRENTE"
  },
  {
    "codigo":687331000119109,
    "descripcion":"OLIGODENDROGLIOMA PRIMARIO DE LÓBULO FRONTAL"
  },
  {
    "codigo":1162839003,
    "descripcion":"SÍNDROME DE APROSENCEFALIA XK"
  },
  {
    "codigo":704087004,
    "descripcion":"FRACTURA NO EXPUESTA DE METÁFISIS DE QUINTO METATARSIANO"
  },
  {
    "codigo":276268001,
    "descripcion":"CITOPENIA MEDIADA POR CÉLULAS T"
  },
  {
    "codigo":210732003,
    "descripcion":"LESIÓN POR DESOLLAMIENTO DE DEDO DEL PIE"
  },
  {
    "codigo":866092006,
    "descripcion":"ANEMIA MEGALOBLÁSTICA DEBIDA A DEFICIENCIA DE DIHIDROFOLATO REDUCTASA"
  },
  {
    "codigo":46892008,
    "descripcion":"INFECCIÓN CAUSADA POR ATHESMIA"
  },
  {
    "codigo":1259308009,
    "descripcion":"ESGUINCE DE LIGAMENTO DE ARTICULACIÓN METACARPOFALÁNGICA DE DEDO ÍNDICE"
  },
  {
    "codigo":307201006,
    "descripcion":"HIPONATREMIA DILUCIONAL"
  },
  {
    "codigo":403670003,
    "descripcion":"PSEUDOXANTOMA ELÁSTICO MEDICAMENTOSO"
  },
  {
    "codigo":10628631000119103,
    "descripcion":"DERMATITIS IRRITATIVA POR CONTACTO CAUSADA POR METAL"
  },
  {
    "codigo":41387000,
    "descripcion":"ANEMIA HEMOLÍTICA NO ESFEROCÍTICA HEREDITARIA POR DEFICIENCIA DE FOSFOFRUCTOQUINASA"
  },
  {
    "codigo":762283002,
    "descripcion":"ECTIMA CAUSADO POR STAPHYLOCOCCUS AUREUS"
  },
  {
    "codigo":8619003,
    "descripcion":"INFÉRTIL"
  },
  {
    "codigo":237995002,
    "descripcion":"DEPLECIÓN DEL ADN MITOCONDRIAL"
  },
  {
    "codigo":60951000119105,
    "descripcion":"CEGUERA DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":205227008,
    "descripcion":"AUSENCIA CONGÉNITA DE DEDO GORDO"
  },
  {
    "codigo":400000002,
    "descripcion":"NEVO EPIDÉRMICO EPIDERMOLÍTICO SISTEMATIZADO"
  },
  {
    "codigo":16910001000119100,
    "descripcion":"LAGOFTALMOS CICATRIZAL DE PÁRPADO SUPERIOR E INFERIOR DERECHO"
  },
  {
    "codigo":203392007,
    "descripcion":"OSTEOCONDROSIS JUVENIL DE PIE"
  },
  {
    "codigo":301696007,
    "descripcion":"NO SE MUEVE HACIA ARRIBA Y HACIA ABAJO EN LA CAMA"
  },
  {
    "codigo":10874391000119107,
    "descripcion":"HERIDA ABIERTA DE MEJILLA IZQUIERDA"
  },
  {
    "codigo":430933008,
    "descripcion":"TAMAÑO DE ÚTERO GESTANTE EN DISCREPANCIA CON LA EDAD GESTACIONAL"
  },
  {
    "codigo":299861009,
    "descripcion":"REFLEJO SACRO RETRASADO"
  },
  {
    "codigo":4949009,
    "descripcion":"TRASTORNO DE LAS HABILIDADES MOTORAS"
  },
  {
    "codigo":429098002,
    "descripcion":"TROMBOEMBOLIA VENOSA"
  },
  {
    "codigo":68650003,
    "descripcion":"FRACTURA DE CINCO COSTILLAS"
  },
  {
    "codigo":10929841000119102,
    "descripcion":"FRACTURA NO EXPUESTA DEL CUARTO METATARSIANO DEL PIE IZQUIERDO"
  },
  {
    "codigo":396330006,
    "descripcion":"CRISIS CELÍACA"
  },
  {
    "codigo":35882009,
    "descripcion":"ANOMALÍA DE LA DINÁMICA DEL TRABAJO DE PARTO"
  },
  {
    "codigo":296191001,
    "descripcion":"SOBREDOSIS DE DROPERIDOL"
  },
  {
    "codigo":197887003,
    "descripcion":"HEMORRAGIA DE VEJIGA"
  },
  {
    "codigo":230655004,
    "descripcion":"NEUROPATÍA CRÓNICA IDIOPÁTICA"
  },
  {
    "codigo":294356003,
    "descripcion":"ALERGIA A CLOTRIMAZOL"
  },
  {
    "codigo":196052005,
    "descripcion":"NEUMOPATÍA INTERSTICIAL MEDICAMENTOSA AGUDA"
  },
  {
    "codigo":292521002,
    "descripcion":"REACCIÓN ADVERSA AL XAMOTEROL"
  },
  {
    "codigo":423593006,
    "descripcion":"RECURSOS ASISTENCIALES INADECUADOS"
  },
  {
    "codigo":194217007,
    "descripcion":"OTITIS EXTERNA AGUDA POR RADIACIÓN"
  },
  {
    "codigo":95913008,
    "descripcion":"INVERSIÓN DE LA ACCIÓN DE UN FÁRMACO"
  },
  {
    "codigo":94078000,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA PARED SUPERIOR DE LA NASOFARINGE"
  },
  {
    "codigo":126846004,
    "descripcion":"NEOPLASIA DE APÉNDICE ILEOCECAL"
  },
  {
    "codigo":59475000,
    "descripcion":"TOS CONVULSA AGRAVADA POR NEUMONÍA"
  },
  {
    "codigo":1306494008,
    "descripcion":"CARCINOMA DUCTAL INFILTRANTE PRIMARIO DE CUADRANTE INFERIOR EXTERNO DE MAMA IZQUIERDA"
  },
  {
    "codigo":11804491000119104,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA DISTAL DE DEDO ANULAR IZQUIERDO"
  },
  {
    "codigo":23037000,
    "descripcion":"NÚMERO DE PARTOS: DIEZ O MÁS"
  },
  {
    "codigo":55805001,
    "descripcion":"INTOXICACIÓN POR CLORATO"
  },
  {
    "codigo":186877007,
    "descripcion":"ENDOCARDITIS SIFILÍTICA DE VÁLVULA TRICÚSPIDE"
  },
  {
    "codigo":15955941000119102,
    "descripcion":"CARCINOMA MICROCÍTICO PRIMARIO DE PULMÓN IZQUIERDO"
  },
  {
    "codigo":217810002,
    "descripcion":"INTERRUPCIÓN DE LA RESPIRACIÓN PRODUCIDA POR CUERPO EXTRAÑO EN ESÓFAGO"
  },
  {
    "codigo":1299154002,
    "descripcion":"SÍNDROME DE DEFECTOS CARDÍACOS CONGÉNITOS, DISCAPACIDAD INTELECTUAL Y DISMORFIA FACIAL RELACIONADO CON CDK13"
  },
  {
    "codigo":21202004,
    "descripcion":"HEMORRAGIA SUBARACNOIDEA INTRACRANEAL PERINATAL"
  },
  {
    "codigo":53970006,
    "descripcion":"RESISTENCIA VASCULAR DISMINUIDA"
  },
  {
    "codigo":283346007,
    "descripcion":"PICADURA DE INSECTO INFECTADA EN LA CABEZA Y EL CUELLO"
  },
  {
    "codigo":447186007,
    "descripcion":"PULSO TIBIAL POSTERIOR BIFÁSICO"
  },
  {
    "codigo":445351000,
    "descripcion":"ARTERIA SUBCLAVIA DERECHA AISLADA"
  },
  {
    "codigo":414418009,
    "descripcion":"ALOJADO"
  },
  {
    "codigo":248743003,
    "descripcion":"VENAS SUBCUTÁNEAS DILATADAS"
  },
  {
    "codigo":707495004,
    "descripcion":"CARCINOMA ADENOIDE PRIMARIO DE CÉLULAS ESCAMOSAS DE TRÁQUEA"
  },
  {
    "codigo":246908000,
    "descripcion":"FOLÍCULOS DE LA CONJUNTIVA PALPEBRAL"
  },
  {
    "codigo":17532001,
    "descripcion":"PRESENTACIÓN PÉLVICA ANÓMALA CONVERTIDA EXITOSAMENTE EN PRESENTACIÓN CEFÁLICA"
  },
  {
    "codigo":12105701000119105,
    "descripcion":"QUEMADURA DE MANO IZQUIERDA"
  },
  {
    "codigo":312444006,
    "descripcion":"PARAPARESIA ESPÁSTICA"
  },
  {
    "codigo":1197180007,
    "descripcion":"UVEÍTIS ANTERIOR RECURRENTE"
  },
  {
    "codigo":1295484008,
    "descripcion":"FRACTURA OSTEOPORÓTICA DEBIDA A OSTEOPOROSIS POR DESUSO"
  },
  {
    "codigo":11859941000119107,
    "descripcion":"ESGUINCE DE LIGAMENTO CRUZADO ANTERIOR DE RODILLA DERECHA"
  },
  {
    "codigo":1162577003,
    "descripcion":"ESTENOSIS DE INTESTINO DELGADO"
  },
  {
    "codigo":277841004,
    "descripcion":"INTOLERANCIA SENSITIVA"
  },
  {
    "codigo":310609005,
    "descripcion":"INFECCIÓN Y REACCIÓN INFLAMATORIA POR DISPOSITIVO ORTOPÉDICO DE FIJACIÓN INTERNA"
  },
  {
    "codigo":210470000,
    "descripcion":"HERIDA ABIERTA EN EL HIPOCONDRIO"
  },
  {
    "codigo":1259046006,
    "descripcion":"SÍNDROME DE COLA DE CABALLO DEBIDO A INFECCIÓN"
  },
  {
    "codigo":79398006,
    "descripcion":"HIPERCORTISOLISMO SECUNDARIO A NEOPLASIA SUPRARRENAL"
  },
  {
    "codigo":77563000,
    "descripcion":"OBSTRUCCIÓN POR PELVIS ÓSEA"
  },
  {
    "codigo":439846009,
    "descripcion":"FÍSTULA ARTERIOVENOSA RADIOCEFÁLICA CONSTRUIDA QUIRÚRGICAMENTE"
  },
  {
    "codigo":274171001,
    "descripcion":"LACERACIÓN DE LA ESPALDA"
  },
  {
    "codigo":44795003,
    "descripcion":"INCOMPATIBILIDAD RH QUE AFECTA AL EMBARAZO"
  },
  {
    "codigo":732923001,
    "descripcion":"HEMORRAGIA DE BULBO RAQUÍDEO"
  },
  {
    "codigo":208635000,
    "descripcion":"FRACTURA NO EXPUESTA DE TIBIA DISTAL, EXTRARTICULAR"
  },
  {
    "codigo":110331008,
    "descripcion":"FORMA DE LA RAÍZ DENTAL"
  },
  {
    "codigo":11833471000119105,
    "descripcion":"ESGUINCE DE LIGAMENTO INTERNO DE ARTICULACIÓN DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":403408001,
    "descripcion":"POIQUILODERMIA POR CONJUNTIVOPATÍA"
  },
  {
    "codigo":1157072007,
    "descripcion":"GLIOSARCOMA DE MÉDULA ESPINAL"
  },
  {
    "codigo":73893000,
    "descripcion":"TOXOPLASMOSIS CONGÉNITA"
  },
  {
    "codigo":237733001,
    "descripcion":"SÍNDROME DIENCEFÁLICO"
  },
  {
    "codigo":16011391000119108,
    "descripcion":"ESTENOSIS DE ARTERIA DE MIEMBRO INFERIOR IZQUIERDO"
  },
  {
    "codigo":235898000,
    "descripcion":"FIBROSIS PERICELULAR DE LA SÍFILIS CONGÉNITA"
  },
  {
    "codigo":8357008,
    "descripcion":"LIBIDO DISMINUIDA"
  },
  {
    "codigo":268666004,
    "descripcion":"TRASTORNO DE LA NIÑEZ Y ADOLESCENCIA CON SENSIBILIDAD"
  },
  {
    "codigo":102991004,
    "descripcion":"PRUEBA DE LA MARCHA EN LÍNEA RECTA CON LOS OJOS CERRADOS CON RESULTADOS ANORMALES"
  },
  {
    "codigo":365135006,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA MOVERSE HACIA ARRIBA Y HACIA ABAJO EN LA CAMA"
  },
  {
    "codigo":299599007,
    "descripcion":"SIN AMPLITUD ACTIVA DE EXTENSIÓN DE DEDO DEL PIE"
  },
  {
    "codigo":234063008,
    "descripcion":"ESTENOSIS DE LA VENA CAVA INFERIOR"
  },
  {
    "codigo":363300000,
    "descripcion":"SECUELAS DE ENFERMEDADES INFLAMATORIAS"
  },
  {
    "codigo":1075481000119105,
    "descripcion":"PELLIZCAMIENTO INTERNO DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":35620001,
    "descripcion":"ENFERMEDAD CAUSADA POR PHLEBOVIRUS"
  },
  {
    "codigo":166692000,
    "descripcion":"NIVEL DE SODIO SÉRICO DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":230393000,
    "descripcion":"EPILEPSIA DE LÓBULO TEMPORAL LATERAL"
  },
  {
    "codigo":295929003,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE NEFAZODONA"
  },
  {
    "codigo":10521000119108,
    "descripcion":"NEUROPATÍA DE NERVIO PERONEO COMÚN EN CABEZA DE PERONÉ"
  },
  {
    "codigo":195790000,
    "descripcion":"PANSINUSITIS"
  },
  {
    "codigo":263161008,
    "descripcion":"FRACTURA DE PARED DE LA CAVIDAD ALVEOLAR MAXILAR"
  },
  {
    "codigo":64718006,
    "descripcion":"XEROSIS CONJUNTIVAL"
  },
  {
    "codigo":15630771000119104,
    "descripcion":"UVEÍTIS DEL OJO DERECHO"
  },
  {
    "codigo":95651005,
    "descripcion":"PARAPARESIA PROGRESIVA CRÓNICA"
  },
  {
    "codigo":292259006,
    "descripcion":"REACCIÓN ADVERSA A FÁRMACO ANOREXÍGENO DE ACCIÓN CENTRAL"
  },
  {
    "codigo":1176995008,
    "descripcion":"REACCIÓN CUTÁNEA MEDIADA POR TOXINA ESTREPTOCÓCICA"
  },
  {
    "codigo":126584000,
    "descripcion":"NEOPLASIA DEL PERONÉ"
  },
  {
    "codigo":290424002,
    "descripcion":"INTOXICACIÓN POR ANTAGONISTA DEL RECEPTOR 5-HT3"
  },
  {
    "codigo":61048000,
    "descripcion":"ENDOCARDITIS GONOCÓCICA"
  },
  {
    "codigo":1339000004,
    "descripcion":"MADRE PORTADORA DE STREPTOCOCCUS DEL GRUPO B EN EL MOMENTO DEL PARTO"
  },
  {
    "codigo":311731000119106,
    "descripcion":"ESCOLIOSIS IDIOPÁTICA JUVENIL DE COLUMNA TORACOLUMBAR"
  },
  {
    "codigo":716408006,
    "descripcion":"CAPAZ DE SENTIRSE CONFIADO"
  },
  {
    "codigo":202675004,
    "descripcion":"ESPONDILOSIS LUMBOSACRA EN DOS NIVELES SIN MIELOPATÍA"
  },
  {
    "codigo":93816002,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA GLOTIS"
  },
  {
    "codigo":1237026000,
    "descripcion":"CON RIESGO ELEVADO DE EXPOSICIÓN A VIRUS DE HEPATITIS A"
  },
  {
    "codigo":91981009,
    "descripcion":"NEOPLASIA BENIGNA DE APÉNDICE ILEOCECAL"
  },
  {
    "codigo":26445008,
    "descripcion":"SÍNDROME DEL OJO DE GATO"
  },
  {
    "codigo":286754002,
    "descripcion":"CARÁCTER PACIENTE"
  },
  {
    "codigo":288589008,
    "descripcion":"UTILIZA EL LENGUAJE CORPORAL"
  },
  {
    "codigo":710903001,
    "descripcion":"PERIODONTITIS CONCOMITANTE CON TRASTORNO GENÉTICO"
  },
  {
    "codigo":22775002,
    "descripcion":"VULVITIS ALÉRGICA"
  },
  {
    "codigo":415991003,
    "descripcion":"TRASTORNO VENTRICULAR"
  },
  {
    "codigo":88311004,
    "descripcion":"OLIGOZOOSPERMIA"
  },
  {
    "codigo":24610009,
    "descripcion":"INVAGINACIÓN RECTOSIGMOIDEA"
  },
  {
    "codigo":55543007,
    "descripcion":"EMBARAZOS PREVIOS: 3"
  },
  {
    "codigo":414156000,
    "descripcion":"EXACERBACIÓN DE COLITIS ULCEROSA"
  },
  {
    "codigo":219383009,
    "descripcion":"HERIDA DE GUERRA POR FRAGMENTOS DE ARTILLERÍA"
  },
  {
    "codigo":20940004,
    "descripcion":"HEMIPARESIA RAQUÍDEA"
  },
  {
    "codigo":15987431000119100,
    "descripcion":"OPACIDAD CONGÉNITA DE CÓRNEA DERECHA"
  },
  {
    "codigo":283084009,
    "descripcion":"ARAÑAZO DE DORSO DE MANO"
  },
  {
    "codigo":838305005,
    "descripcion":"COLESTASIS INTRAHEPÁTICA BENIGNA TIPO 1"
  },
  {
    "codigo":215713006,
    "descripcion":"LESIÓN SUFRIDA A BORDO DE MEDIO DE TRANSPORTE ACUÁTICO CAUSADA POR MAQUINARIA DE CUBIERTA, NADADOR LESIONADO"
  },
  {
    "codigo":314017009,
    "descripcion":"GLAUCOMA CRÓNICO REAGUDIZADO"
  },
  {
    "codigo":410486005,
    "descripcion":"AMBLIOPÍA POR OCLUSIÓN"
  },
  {
    "codigo":340711000119103,
    "descripcion":"COROIDITIS FOCAL IZQUIERDA"
  },
  {
    "codigo":836470009,
    "descripcion":"PRUEBA AUDITIVA DE DIAPASÓN NORMAL"
  },
  {
    "codigo":443254009,
    "descripcion":"INSUFICIENCIA CARDÍACA SISTÓLICA AGUDA"
  },
  {
    "codigo":1162315003,
    "descripcion":"LORDOSIS DEBIDA A OSTEOPOROSIS VERTEBRAL"
  },
  {
    "codigo":277579002,
    "descripcion":"MIELOMA DE CADENAS LIVIANAS"
  },
  {
    "codigo":767264001,
    "descripcion":"NÓDULO DE DESGASTE DE PABELLÓN AURICULAR"
  },
  {
    "codigo":13600006,
    "descripcion":"FOLICULITIS"
  },
  {
    "codigo":111904009,
    "descripcion":"CANDIDIASIS DE LOCALIZACIÓN UROGENITAL"
  },
  {
    "codigo":308512009,
    "descripcion":"SITUACIÓN DEL CONTROL DEL TABAQUISMO"
  },
  {
    "codigo":206538000,
    "descripcion":"HIDROPESÍA FETAL IDIOPÁTICA"
  },
  {
    "codigo":403146001,
    "descripcion":"DERMATITIS POR ORUGA"
  },
  {
    "codigo":110069008,
    "descripcion":"LACERACIÓN COMPLEJA DEL CUERO CABELLUDO"
  },
  {
    "codigo":1255114003,
    "descripcion":"DEFICIENCIA DE PARTES BLANDAS BUCALES ALREDEDOR DE IMPLANTE DE DIENTE"
  },
  {
    "codigo":1156810004,
    "descripcion":"NEOPLASIA MESENQUIMÁTICA MALIGNA DE ESÓFAGO"
  },
  {
    "codigo":370378005,
    "descripcion":"PRUEBA DE RINNE: POSITIVA"
  },
  {
    "codigo":42698006,
    "descripcion":"ÚLCERA GASTROYEYUNAL CON HEMORRAGIA Y OBSTRUCCIÓN"
  },
  {
    "codigo":698058005,
    "descripcion":"FRACTURA NO EXPUESTA DE BASE DE TERCER METACARPIANO"
  },
  {
    "codigo":208373008,
    "descripcion":"FRACTURA NO EXPUESTA DEL ESCAFOIDES, CINTURA ESCAFOIDEA, CONMINUTA"
  },
  {
    "codigo":40863000,
    "descripcion":"PÉRDIDA DE LA CONSCIENCIA DE DURACIÓN MODERADA"
  },
  {
    "codigo":73631002,
    "descripcion":"TRASTORNO DE DESARROLLO Y\/O DIFERENCIACIÓN TESTICULAR"
  },
  {
    "codigo":237471008,
    "descripcion":"INFECCIÓN DEL IMPLANTE MAMARIO"
  },
  {
    "codigo":1251444001,
    "descripcion":"SENSIBILIZACIÓN ALÉRGICA DE CONTACTO OCUPACIONAL"
  },
  {
    "codigo":235636002,
    "descripcion":"DISFAGIA POSVAGOTOMÍA"
  },
  {
    "codigo":301172003,
    "descripcion":"VENA PRESENTE"
  },
  {
    "codigo":202868003,
    "descripcion":"TENDINITIS Y BURSITIS DE LA PATA DE GANSO"
  },
  {
    "codigo":399476005,
    "descripcion":"TUMOR QUE INVADE LA CÓRNEA"
  },
  {
    "codigo":15715201000119106,
    "descripcion":"HIPOPLASIA ADQUIRIDA DE HUESO CIGOMÁTICO IZQUIERDO"
  },
  {
    "codigo":366708001,
    "descripcion":"AMPLITUD DE MOVIMIENTO ACTIVO DE EXTENSIÓN DE DEDO DEL PIE - HALLAZGO"
  },
  {
    "codigo":233801001,
    "descripcion":"FILTRACIÓN POR ANASTOMOSIS BRONQUIAL"
  },
  {
    "codigo":364873004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA TRANSFERIR PESO"
  },
  {
    "codigo":299337006,
    "descripcion":"AMPLITUD DE FLEXIÓN ACTIVA DE LA RODILLA DISMINUIDA"
  },
  {
    "codigo":37193007,
    "descripcion":"DEFICIENCIA DE FACTOR VII"
  },
  {
    "codigo":266569009,
    "descripcion":"HIPERPLASIA PROSTÁTICA BENIGNA"
  },
  {
    "codigo":68126001,
    "descripcion":"GANGRENA Y OBSTRUCCIÓN CONCOMITANTES CON HERNIA FEMORAL BILATERAL Y DEBIDAS A ELLA"
  },
  {
    "codigo":789022006,
    "descripcion":"RECHAZA LÍQUIDOS"
  },
  {
    "codigo":363038008,
    "descripcion":"TRASTORNO BACTERIANO CONGÉNITO"
  },
  {
    "codigo":1149470008,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR SOMATROPINA"
  },
  {
    "codigo":295667002,
    "descripcion":"SOBREDOSIS DE MITOMICINA"
  },
  {
    "codigo":66291003,
    "descripcion":"QUERATOCONJUNTIVITIS FLICTENULAR TUBERCULOSA"
  },
  {
    "codigo":755004,
    "descripcion":"FITOBEZOAR POSTGASTRECTOMÍA"
  },
  {
    "codigo":721651002,
    "descripcion":"INVAGINACIÓN DE INTESTINO DELGADO"
  },
  {
    "codigo":361203007,
    "descripcion":"ACIDURIA MALÓNICA"
  },
  {
    "codigo":262899008,
    "descripcion":"FALSA VÍA DE URÉTER"
  },
  {
    "codigo":457672001,
    "descripcion":"CALCIFICACIÓN DE ANILLO DE VÁLVULA PULMONAR"
  },
  {
    "codigo":195528001,
    "descripcion":"FIEBRE REUMÁTICA AGUDA"
  },
  {
    "codigo":293832002,
    "descripcion":"ALERGIA A DOTIEPINA"
  },
  {
    "codigo":719816006,
    "descripcion":"ANEMIA SIDEROBLÁSTICA LIGADA AL CROMOSOMA X CON ATAXIA ESPINOCEREBELOSA"
  },
  {
    "codigo":16235701000119100,
    "descripcion":"ECTROPIÓN SENIL DE AMBOS PÁRPADOS SUPERIORES"
  },
  {
    "codigo":291997002,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR INHIBIDOR DE LA FOSFODIESTERASA"
  },
  {
    "codigo":29853008,
    "descripcion":"POSICIÓN DEL TELEVISOR"
  },
  {
    "codigo":95389008,
    "descripcion":"ARDOR EN SITIO DE INYECCIÓN"
  },
  {
    "codigo":781682005,
    "descripcion":"HIPEREMIA DE GLOBO OCULAR"
  },
  {
    "codigo":93554008,
    "descripcion":"SARCOMA DE HODGKIN DEL BAZO"
  },
  {
    "codigo":419399001,
    "descripcion":"DESCRIBE VERBALMENTE LAS INSTRUCCIONES BRINDADAS AL ALTA EN RELACIÓN CON EL PLAN DE ACTIVIDAD"
  },
  {
    "codigo":290162009,
    "descripcion":"INTOXICACIÓN POR DEXTROPROPOXIFENO"
  },
  {
    "codigo":1080501000119104,
    "descripcion":"CARCINOMA DE CÉLULAS GRANDES PRIMARIO DE LÓBULO INFERIOR DE PULMÓN DERECHO"
  },
  {
    "codigo":1269532000,
    "descripcion":"SÍNDROME DE CORDÓN CENTRAL DEBIDO A NEOPLASIA"
  },
  {
    "codigo":89884001,
    "descripcion":"SOPLO CARDÍACO DECRECIENTE"
  },
  {
    "codigo":288327009,
    "descripcion":"ANOMALÍA DE LA GRANULACIÓN"
  },
  {
    "codigo":778012003,
    "descripcion":"SÍNDROME DE TEMPLE"
  },
  {
    "codigo":286492002,
    "descripcion":"NO PREPARA COMIDA"
  },
  {
    "codigo":448497000,
    "descripcion":"DEFORMIDAD CONGÉNITA DE ANILLO DE VÁLVULA MITRAL"
  },
  {
    "codigo":253724009,
    "descripcion":"FÍSTULA CORONARIA A PARTIR DEL VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":188188009,
    "descripcion":"CORIOCARCINOMA"
  },
  {
    "codigo":20678000,
    "descripcion":"RESISTENCIA EXTREMA A LA INSULINA CON ACANTOSIS NIGRICANS, HIRSUTISMO Y AUTOANTICUERPOS CONTRA LOS RECEPTORES DE INSULINA"
  },
  {
    "codigo":86214000,
    "descripcion":"INFECCIÓN CAUSADA POR THEILERIA MUTANS"
  },
  {
    "codigo":250054005,
    "descripcion":"TRASTORNO FRONTAL DE LA MARCHA"
  },
  {
    "codigo":315590007,
    "descripcion":"NACIDO EN YEMEN"
  },
  {
    "codigo":248219002,
    "descripcion":"CONTINÚA DURMIÉNDOSE"
  },
  {
    "codigo":1231259004,
    "descripcion":"UVEÍTIS DEBIDA A ARTRITIS IDIOPÁTICA JUVENIL"
  },
  {
    "codigo":51611005,
    "descripcion":"URTICARIA CRÓNICA"
  },
  {
    "codigo":444827008,
    "descripcion":"ERITEMA DE PIEL"
  },
  {
    "codigo":1264027009,
    "descripcion":"DOLOR EN MÚSCULO DE BRAZO"
  },
  {
    "codigo":705136008,
    "descripcion":"FRACTURA EXPUESTA DE PARED TRANSVERSAL Y POSTERIOR DE ACETÁBULO"
  },
  {
    "codigo":703301002,
    "descripcion":"ENCEFALOPATÍA HIPÓXICA ISQUÉMICA LEVE"
  },
  {
    "codigo":1293125002,
    "descripcion":"HEMANGIOMA INFANTIL"
  },
  {
    "codigo":15691241000119101,
    "descripcion":"ARTRITIS REUMATOIDEA SERONEGATIVA BILATERAL DE RODILLA"
  },
  {
    "codigo":211781005,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO PROFUNDA DE PARED TORÁCICA"
  },
  {
    "codigo":15173006,
    "descripcion":"ORGANISMOS RAROS"
  },
  {
    "codigo":47941007,
    "descripcion":"ENTERITIS PURULENTA"
  },
  {
    "codigo":406554000,
    "descripcion":"CON BAJO RIESGO DE DAÑARSE A SÍ MISMO"
  },
  {
    "codigo":111642000,
    "descripcion":"FRACTURA EXPUESTA DE BASE DE PULGAR"
  },
  {
    "codigo":13338002,
    "descripcion":"VERRUGA PALMAR"
  },
  {
    "codigo":373786007,
    "descripcion":"MOTIVOS PARA RETRASAR EL TRATAMIENTO"
  },
  {
    "codigo":767002009,
    "descripcion":"LUXACIÓN CONGÉNITA DE CADERA IZQUIERDA"
  },
  {
    "codigo":240879002,
    "descripcion":"MIASIS SUBCUTÁNEA"
  },
  {
    "codigo":77039003,
    "descripcion":"ENSORTIJAMIENTO PROGRESIVO ADQUIRIDO DEL PELO"
  },
  {
    "codigo":275482009,
    "descripcion":"OTOTOXICIDAD MEDICAMENTOSA - SORDERA"
  },
  {
    "codigo":109807006,
    "descripcion":"GLOSITIS AGUDA"
  },
  {
    "codigo":10939881000119105,
    "descripcion":"CONDUCTA DE CONSUMO DE ALCOHOL NO SALUDABLE"
  },
  {
    "codigo":11503009,
    "descripcion":"ANEMIA RELATIVA"
  },
  {
    "codigo":271812002,
    "descripcion":"RUBOR EXCESIVO"
  },
  {
    "codigo":402884000,
    "descripcion":"REACCIÓN POR EL VIRUS VACCINIA EN EL SITIO DE VACUNACIÓN"
  },
  {
    "codigo":370116005,
    "descripcion":"ESTRECHAMIENTO DE HENDIDURA PALPEBRAL"
  },
  {
    "codigo":75204008,
    "descripcion":"INFARTO DE EPIPLÓN"
  },
  {
    "codigo":1351321001,
    "descripcion":"CON MAYOR RIESGO DE GLAUCOMA DE ÁNGULO CERRADO"
  },
  {
    "codigo":1254852008,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS DE CARTÍLAGO LARÍNGEO"
  },
  {
    "codigo":1287620008,
    "descripcion":"CRISIS EPILÉPTICA MIOCLÓNICA DE INICIO FOCAL NEONATAL"
  },
  {
    "codigo":106137004,
    "descripcion":"HALLAZGO EN EL CAMPO DE LA INTELIGENCIA"
  },
  {
    "codigo":237209008,
    "descripcion":"ABDOMEN PÉNDULO EN EL EMBARAZO, PARTO Y\/O PUERPERIO"
  },
  {
    "codigo":827033008,
    "descripcion":"AMÍGDALA FARÍNGEA NORMAL"
  },
  {
    "codigo":202606004,
    "descripcion":"CHASQUIDO DE LA CADERA"
  },
  {
    "codigo":366446007,
    "descripcion":"AMPLITUD DEL MOVIMIENTO ACTIVO DE ROTACIÓN HACIA LA IZQUIERDA DE LA COLUMNA LUMBAR - HALLAZGO"
  },
  {
    "codigo":102467000,
    "descripcion":"SUSCEPTIBILIDAD A LAS INFECCIONES DISMINUIDA"
  },
  {
    "codigo":300910009,
    "descripcion":"ALERGIA A POLEN"
  },
  {
    "codigo":345731000119104,
    "descripcion":"QUISTES IDIOPÁTICOS DE AMBOS IRIS"
  },
  {
    "codigo":166168007,
    "descripcion":"ANTICUERPOS REAGÍNICOS DETECTADOS"
  },
  {
    "codigo":395544008,
    "descripcion":"MÁRGENES DE RESECCIÓN QUIRÚRGICA PROFUNDA AFECTADOS POR TUMOR"
  },
  {
    "codigo":295405003,
    "descripcion":"SOBREDOSIS DE CAOLÍN"
  },
  {
    "codigo":721389004,
    "descripcion":"SÍNDROME DEL CORDÓN POSTERIOR DE MÉDULA ESPINAL CERVICAL"
  },
  {
    "codigo":262637006,
    "descripcion":"CONTUSIÓN DE ENCÍAS"
  },
  {
    "codigo":129730000,
    "descripcion":"REMOCIÓN DE UN IMPLANTE DESDE LA MAMOGRAFÍA ANTERIOR"
  },
  {
    "codigo":33261009,
    "descripcion":"ABSCESO DE AMÍGDALA"
  },
  {
    "codigo":162498009,
    "descripcion":"SÍNTOMA QUE NO CAMBIA"
  },
  {
    "codigo":29591002,
    "descripcion":"BRONQUITIS PURULENTA"
  },
  {
    "codigo":783255002,
    "descripcion":"ANEMIA APLÁSICA HEREDITARIA AISLADA"
  },
  {
    "codigo":95127004,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE TESTÍCULO"
  },
  {
    "codigo":226199006,
    "descripcion":"DIETA SIN PROTEÍNA DE LECHE DE VACA"
  },
  {
    "codigo":224364001,
    "descripcion":"EN TRABAJO OCASIONAL REMUNERADO"
  },
  {
    "codigo":1141868007,
    "descripcion":"SIGNO DE LA CUERDA"
  },
  {
    "codigo":93292008,
    "descripcion":"HIPOPLASIA CONGÉNITA DEL BAZO"
  },
  {
    "codigo":289900009,
    "descripcion":"DOLOR MENSTRUAL PRESENTE"
  },
  {
    "codigo":319261000119107,
    "descripcion":"LUXACIÓN RECURRENTE DE ARTICULACIÓN DE CADERA IZQUIERDA"
  },
  {
    "codigo":60524008,
    "descripcion":"FIBROSIS DE TESTÍCULO"
  },
  {
    "codigo":1303873006,
    "descripcion":"RESTRICCIÓN SELECTIVA DEL CRECIMIENTO INTRAUTERINO"
  },
  {
    "codigo":1269270002,
    "descripcion":"SÍNDROME URÉMICO HEMOLÍTICO ASOCIADO A INFECCIÓN"
  },
  {
    "codigo":286230006,
    "descripcion":"CAPAZ DE USAR FLUJO DE AIRE PALATINO PARA HABLAR"
  },
  {
    "codigo":187926007,
    "descripcion":"NEOPLASIA MALIGNA DE ARTICULACIÓN COSTOVERTEBRAL"
  },
  {
    "codigo":253462008,
    "descripcion":"ESTENOSIS DE VÁLVULA AURICULOVENTRICULAR DERECHA"
  },
  {
    "codigo":55019002,
    "descripcion":"HÁBITOS INTESTINALES NORMALES"
  },
  {
    "codigo":1300203003,
    "descripcion":"EMBARAZO PRODUCTO DE CONCEPCIÓN NATURAL"
  },
  {
    "codigo":29801000175102,
    "descripcion":"ÚLCERA POR PRESIÓN EN CADERA IZQUIERDA, ESTADIO II"
  },
  {
    "codigo":249792001,
    "descripcion":"ACORTAMIENTO DISTAL DE PIERNA"
  },
  {
    "codigo":282560002,
    "descripcion":"CAMINA EN PUNTAS DE PIE"
  },
  {
    "codigo":446400002,
    "descripcion":"PULSO PEDIO MONOFÁSICO"
  },
  {
    "codigo":16021431000119106,
    "descripcion":"BURSITIS DE AMBOS TOBILLOS"
  },
  {
    "codigo":1085521000119100,
    "descripcion":"EDENTULISMO COMPLETO DE CLASE IV DEBIDO A CARIES"
  },
  {
    "codigo":774080007,
    "descripcion":"ESCLERODERMIA NEONATAL"
  },
  {
    "codigo":870549000,
    "descripcion":"FRACTURA NO EXPUESTA DE CRÁNEO CON CONTUSIÓN DE CEREBRO"
  },
  {
    "codigo":247957005,
    "descripcion":"BAJO NIVEL DE HABILIDAD MOTRIZ DURANTE EPISODIO DE SONAMBULISMO"
  },
  {
    "codigo":770410004,
    "descripcion":"SÍNDROME DE MONOSOMÍA DISTAL 14Q"
  },
  {
    "codigo":211519000,
    "descripcion":"CONTUSIÓN DE CADERA Y MUSLO"
  },
  {
    "codigo":203144000,
    "descripcion":"OSTEOPATÍAS, CONDROPATÍAS Y DEFORMIDADES MUSCULOESQUELÉTICAS ADQUIRIDAS"
  },
  {
    "codigo":1260095004,
    "descripcion":"SÍNDROME DE MENKE HENNEKAM"
  },
  {
    "codigo":14911005,
    "descripcion":"SÍNDROME DE INTERPOSICIÓN SUBFRÉNICA"
  },
  {
    "codigo":735807006,
    "descripcion":"RUPTURA TRAUMÁTICA DE LIGAMENTO LATERAL RADIAL DE CODO"
  },
  {
    "codigo":733972000,
    "descripcion":"CARIES DENTAL ACTIVA PRIMARIA QUE SE EXTIENDE HASTA LA DENTINA"
  },
  {
    "codigo":209684003,
    "descripcion":"SECCIÓN EXPUESTA DE LIGAMENTO DE DEDO, ARTICULACIÓN INTERFALÁNGICA PROXIMAL, LIGAMENTO LATERAL CUBITAL"
  },
  {
    "codigo":109545002,
    "descripcion":"FOLÍCULO DENTAL HIPERPLÁSICO"
  },
  {
    "codigo":321771000119101,
    "descripcion":"ARTRITIS DE HOMBRO DERECHO CAUSADA POR STAPHYLOCOCCUS"
  },
  {
    "codigo":348241000119108,
    "descripcion":"HIPERTROPÍA DE OJO DERECHO"
  },
  {
    "codigo":402622001,
    "descripcion":"HIPOMELANOSIS POR CICATRIZ"
  },
  {
    "codigo":304318002,
    "descripcion":"AUSENCIA DE MOVIMIENTO DE LA CADERA"
  },
  {
    "codigo":238782003,
    "descripcion":"LIQUEN AUREA"
  },
  {
    "codigo":763070001,
    "descripcion":"PARAPLEJÍA ESPÁSTICA AUTOSÓMICA DOMINANTE TIPO 42"
  },
  {
    "codigo":1156286005,
    "descripcion":"CUMPLE CON ESQUEMA DE REHABILITACIÓN"
  },
  {
    "codigo":74942003,
    "descripcion":"ENFERMEDAD HIDATÍDICA"
  },
  {
    "codigo":7571003,
    "descripcion":"SENTIMIENTO DE CULPA"
  },
  {
    "codigo":43941000087100,
    "descripcion":"CORTE EN CADERA DERECHA"
  },
  {
    "codigo":46501000087102,
    "descripcion":"FRACTURA DE FALANGE DE DEDO GORDO DE PIE IZQUIERDO"
  },
  {
    "codigo":1187219008,
    "descripcion":"TRASTORNO CAUSADO POR SUSTANCIA PSICOACTIVA"
  },
  {
    "codigo":235112000,
    "descripcion":"QUISTE ODONTOGÉNICO INFLAMATORIO"
  },
  {
    "codigo":300648001,
    "descripcion":"CONDUCE UNA BICICLETA"
  },
  {
    "codigo":38504003,
    "descripcion":"ALTERACIÓN DE LA CAPACIDAD DE JUICIO"
  },
  {
    "codigo":10661000087107,
    "descripcion":"LESIÓN TRAUMÁTICA DE VEJIGA URINARIA DURANTE PROCEDIMIENTO QUIRÚRGICO"
  },
  {
    "codigo":890472005,
    "descripcion":"INGESTA INADECUADA DE ZINC"
  },
  {
    "codigo":366184006,
    "descripcion":"HALLAZGO RELACIONADO CON LA POSICIÓN DEL LATIDO DE LA PUNTA DEL CORAZÓN"
  },
  {
    "codigo":267880006,
    "descripcion":"ARTRITIS PIÓGENA DE LA REGIÓN PÉLVICA Y EL MUSLO"
  },
  {
    "codigo":41381000087107,
    "descripcion":"HEMATOMA DE TERCER DEDO DE PIE DERECHO"
  },
  {
    "codigo":69437003,
    "descripcion":"PULSO PEDIO ANORMAL"
  },
  {
    "codigo":298813006,
    "descripcion":"SIN AMPLITUD DE MOVIMIENTO ACTIVO DE ADUCCIÓN DE HOMBRO"
  },
  {
    "codigo":36669007,
    "descripcion":"RINITIS ULCERATIVA"
  },
  {
    "codigo":724797008,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO MEDIANO EN LA MUÑECA"
  },
  {
    "codigo":167741009,
    "descripcion":"GLUCOSA EN LÍQUIDO CEFALORRAQUÍDEO POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":231442003,
    "descripcion":"TRASTORNO CATATÓNICO ORGÁNICO"
  },
  {
    "codigo":67602004,
    "descripcion":"PERITONITIS AGUDA"
  },
  {
    "codigo":2066005,
    "descripcion":"ÚLCERA GÁSTRICA CON HEMORRAGIA Y PERFORACIÓN PERO SIN OBSTRUCCIÓN"
  },
  {
    "codigo":296978003,
    "descripcion":"SOBREDOSIS INTENCIONAL DE CLOFIBRATO"
  },
  {
    "codigo":32999002,
    "descripcion":"COMPLICACIÓN DE HERIDA QUIRÚRGICA OBSTÉTRICA"
  },
  {
    "codigo":293308003,
    "descripcion":"REACCIÓN ADVERSA A SUSTITUTOS PLASMÁTICOS"
  },
  {
    "codigo":1071111000000103,
    "descripcion":"DIFICULTAD PARA COMPRENDER Y USAR DINERO"
  },
  {
    "codigo":162236007,
    "descripcion":"DEBILIDAD PRESENTE"
  },
  {
    "codigo":195004008,
    "descripcion":"TRASTORNOS DE LAS VÁLVULAS MITRAL Y TRICÚSPIDE"
  },
  {
    "codigo":1340049003,
    "descripcion":"TUMOR GLÓMICO BENIGNO SUBUNGUEAL"
  },
  {
    "codigo":225937004,
    "descripcion":"TIRA FÓSFOROS ENCENDIDOS"
  },
  {
    "codigo":94865004,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL CORAZÓN"
  },
  {
    "codigo":1208977007,
    "descripcion":"TROMBO MURAL VENTRICULAR"
  },
  {
    "codigo":29329009,
    "descripcion":"INTOXICACIÓN POR CASTALIS"
  },
  {
    "codigo":846694002,
    "descripcion":"EDEMA AGUDO"
  },
  {
    "codigo":15997471000119103,
    "descripcion":"ISQUEMIA DE RETINA DE OJO IZQUIERDO"
  },
  {
    "codigo":93030006,
    "descripcion":"AUSENCIA CONGÉNITA DEL BAZO"
  },
  {
    "codigo":289638006,
    "descripcion":"ÚTERO DE FORMA NORMAL"
  },
  {
    "codigo":1010534008,
    "descripcion":"ESCLEROSIS DE EPÍFISIS DE FALANGE PROXIMAL DE CUARTO DEDO DE PIE CON RADIOPACIDAD AUMENTADA"
  },
  {
    "codigo":224102005,
    "descripcion":"MIEMBRO DE FAMILIA EXTENDIDA"
  },
  {
    "codigo":91195006,
    "descripcion":"NEFRITIS TUBULOINTERSTICIAL AGUDA POR HONGOS"
  },
  {
    "codigo":123963007,
    "descripcion":"TRASTORNO EN EL METABOLISMO DEL COLESTEROL"
  },
  {
    "codigo":449808000,
    "descripcion":"LACERACIÓN PERINEAL DE TERCER GRADO, TIPO 3B"
  },
  {
    "codigo":255035007,
    "descripcion":"CARCINOMA SUPRARRENAL"
  },
  {
    "codigo":285968007,
    "descripcion":"NO HACE CORRER EL AGUA DEL INODORO"
  },
  {
    "codigo":185829000,
    "descripcion":"INCUMPLIMIENTO DEL CONTROL DE SALUD DEL HOMBRE"
  },
  {
    "codigo":15725241000119101,
    "descripcion":"DERRAME DE ARTICULACIÓN DE AMBAS MANOS"
  },
  {
    "codigo":216762001,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR CARNE"
  },
  {
    "codigo":282298003,
    "descripcion":"CAPAZ DE MANTENERSE EN EQUILIBRIO"
  },
  {
    "codigo":678431000119109,
    "descripcion":"GLAUCOMA BILATERAL POR PRESIÓN VENOSA EPIESCLERAL AUMENTADA"
  },
  {
    "codigo":249530005,
    "descripcion":"NO HA PASADO MECONIO"
  },
  {
    "codigo":20154006,
    "descripcion":"NEUMATURIA"
  },
  {
    "codigo":247695002,
    "descripcion":"ENAJENACIÓN DEL PENSAMIENTO"
  },
  {
    "codigo":182159002,
    "descripcion":"TUBERCULOSIS DISEMINADA"
  },
  {
    "codigo":1263503005,
    "descripcion":"TRASTORNO MIOCLÓNICO DEBIDO A SIALIDOSIS"
  },
  {
    "codigo":870287007,
    "descripcion":"ENFERMEDAD SIMILAR A TRASTORNO DE PELIZAEUS-MERZBACHER DEBIDA A MUTACIÓN EN GJC2"
  },
  {
    "codigo":771983008,
    "descripcion":"CON MAYOR RIESGO DE MALTRATO PSICOLÓGICO"
  },
  {
    "codigo":278628003,
    "descripcion":"SUPERFICIE DE LA PRÓTESIS DENTAL FILOSA"
  },
  {
    "codigo":49252004,
    "descripcion":"BAROTITIS MEDIA"
  },
  {
    "codigo":737380003,
    "descripcion":"ESTADIO CLÍNICO 3 DE INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA DE LA ORGANIZACIÓN MUNDIAL DE LA SALUD DE 2007"
  },
  {
    "codigo":1259833000,
    "descripcion":"NEOPLASIA PRIMARIA MALIGNA DE CÉLULA EPITELIOIDE PERIVASCULAR"
  },
  {
    "codigo":735545002,
    "descripcion":"TRASTORNO DISOCIATIVO CON SÍNTOMA NEUROLÓGICO CON SÍNTOMA VISUAL"
  },
  {
    "codigo":276793003,
    "descripcion":"HIPERTENSIÓN PULMONAR CON ESTENOSIS MITRAL OCULTA"
  },
  {
    "codigo":211257004,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE CODO"
  },
  {
    "codigo":307726001,
    "descripcion":"ANEMIA EN EL CARCINOMA OVÁRICO"
  },
  {
    "codigo":12814002,
    "descripcion":"TRASTORNO DE LOS LINFOCITOS B"
  },
  {
    "codigo":45582004,
    "descripcion":"SÍNDROME DE RUBINSTEIN - TAYBI"
  },
  {
    "codigo":699107000,
    "descripcion":"NIVEL DE EDEMA ESTÁTICO"
  },
  {
    "codigo":109283002,
    "descripcion":"NEVO MELANOCÍTICO DEL TRONCO"
  },
  {
    "codigo":305891006,
    "descripcion":"VISTO POR EL SERVICIO DE CIRUGÍA GENERAL"
  },
  {
    "codigo":240355008,
    "descripcion":"INFECCIÓN DEL TRACTO GASTRINTESTINAL POR ESCHERICHIA COLI ENTEROINVASIVA"
  },
  {
    "codigo":402360001,
    "descripcion":"ENFERMEDAD DE INJERTO VERSUS HUÉSPED MATERNOFETAL"
  },
  {
    "codigo":1156024001,
    "descripcion":"NIVEL SÉRICO DE DIGOXINA POR ENCIMA DEL RANGO TERAPÉUTICO"
  },
  {
    "codigo":238520006,
    "descripcion":"QUEMADURA DEBIDA A FOTOTERAPIA CON LUZ ULTRAVIOLETA B Y POSTERIOR A ELLA"
  },
  {
    "codigo":680941000119100,
    "descripcion":"OCLUSIÓN PARCIAL DE VENAS DE AMBAS RETINAS"
  },
  {
    "codigo":236685000,
    "descripcion":"INFECCIÓN DE URETRA CAUSADA POR SCHISTOSOMA"
  },
  {
    "codigo":40077001,
    "descripcion":"PENSAMIENTO MÁGICO"
  },
  {
    "codigo":1285261002,
    "descripcion":"RANGO PASIVO DE DORSIFLEXIÓN DE TOBILLO AUMENTADO"
  },
  {
    "codigo":2301000124109,
    "descripcion":"INCISIVO CENTRAL SUPERIOR DERECHO TEMPORARIO SUPERNUMERARIO"
  },
  {
    "codigo":10947411000119108,
    "descripcion":"HERIDA ABIERTA DE DEDO MEDIO DE MANO IZQUIERDA DEBIDA A MORDEDURA DE PERRO"
  },
  {
    "codigo":726370000,
    "descripcion":"DELECIÓN DE PARTE DEL BRAZO LARGO DEL CROMOSOMA 3"
  },
  {
    "codigo":300386004,
    "descripcion":"CONSCIENTE DEL PASAJE DE MATERIA FECAL"
  },
  {
    "codigo":15918061000119103,
    "descripcion":"FRACTURA NO EXPUESTA DE BORDE ALVEOLAR DE MANDÍBULA IZQUIERDA"
  },
  {
    "codigo":202082004,
    "descripcion":"DESGARROS MÚLTIPLES DEL MENISCO INTERNO"
  },
  {
    "codigo":890210008,
    "descripcion":"ANOMALÍA ESTRUCTURAL ADQUIRIDA DE TROMPA FARINGOTIMPÁNICA POSTERIOR A PROCEDIMIENTO"
  },
  {
    "codigo":724535001,
    "descripcion":"VÁRICES DE INTESTINO DELGADO"
  },
  {
    "codigo":3639002,
    "descripcion":"GLOSOPTOSIS"
  },
  {
    "codigo":165644008,
    "descripcion":"VITAMINA B12 SÉRICA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":427788009,
    "descripcion":"ÚLCERA DE LABIO GENITAL"
  },
  {
    "codigo":131041001,
    "descripcion":"NIVEL DE ÁCIDO VAINILLILMANDÉLICO POR DEBAJO DE RANGO DE REFERENCIA"
  },
  {
    "codigo":294881007,
    "descripcion":"ALERGIA A WARFARINA"
  },
  {
    "codigo":293046001,
    "descripcion":"REACCIÓN ADVERSA A LA SULFACETAMIDA"
  },
  {
    "codigo":15631931000119106,
    "descripcion":"QUISTE COMPLEJO DE OVARIO DERECHO"
  },
  {
    "codigo":260278007,
    "descripcion":"VISIÓN A DISTANCIA 6\/60"
  },
  {
    "codigo":161974007,
    "descripcion":"DOLOR PARAESTERNAL"
  },
  {
    "codigo":717195001,
    "descripcion":"ACINETOBACTER BAUMANNII O ACINETOBACTER HAEMOLYTICUS"
  },
  {
    "codigo":127371002,
    "descripcion":"OCTAVO EMBARAZO"
  },
  {
    "codigo":94603006,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE BAZO"
  },
  {
    "codigo":192907007,
    "descripcion":"MIELOPATÍA POR ESPONDILOSIS"
  },
  {
    "codigo":291211008,
    "descripcion":"INTOXICACIÓN POR DECANOATO DE FLUPENTIXOL"
  },
  {
    "codigo":92768006,
    "descripcion":"CARCINOMA IN SITU DEL BORDE DE LA LENGUA"
  },
  {
    "codigo":123701000,
    "descripcion":"ECCEMA CON COSTRAS"
  },
  {
    "codigo":289376009,
    "descripcion":"DESCENSO FETAL EN RELACIÓN CON LAS ESPINAS CIÁTICAS - HALLAZGO"
  },
  {
    "codigo":60000008,
    "descripcion":"EMBARAZO MESOMÉTRICO"
  },
  {
    "codigo":713525001,
    "descripcion":"NEUMONÍA BACTERIANA RECURRENTE"
  },
  {
    "codigo":1336117005,
    "descripcion":"HEMOFILIA B DE LEYDEN"
  },
  {
    "codigo":1137674000,
    "descripcion":"MENOR NIVEL DE ESTRÉS POR REUBICACIÓN"
  },
  {
    "codigo":1303349009,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO INTRÍNSECO DE DEDO MEDIO DE MANO"
  },
  {
    "codigo":25397008,
    "descripcion":"ANOMALÍA DEL ACUEDUCTO DE SILVIO"
  },
  {
    "codigo":449546000,
    "descripcion":"SEPSIS CAUSADA POR HAEMOPHILUS INFLUENZAE TIPO B"
  },
  {
    "codigo":447711004,
    "descripcion":"NEOPLASIA FOLICULAR DE GLÁNDULA TIROIDES"
  },
  {
    "codigo":414943006,
    "descripcion":"FRACTURA EXPUESTA DE TIBIA Y PERONÉ"
  },
  {
    "codigo":282036005,
    "descripcion":"ANEURISMA ARTERIAL CONGÉNITO"
  },
  {
    "codigo":773556006,
    "descripcion":"SÍNDROME DE CÚBITOS CORTOS, DISMORFISMO, HIPOTONÍA Y DISCAPACIDAD INTELECTUAL"
  },
  {
    "codigo":183732005,
    "descripcion":"CONSULTA DOMICILIARIA DE CIRUGÍA PLÁSTICA SOLICITADA"
  },
  {
    "codigo":708020008,
    "descripcion":"DOLOR EN MIEMBRO INFERIOR DURANTE LA ELEVACIÓN"
  },
  {
    "codigo":118196009,
    "descripcion":"HALLAZGO EN LA ESCALA DE VALORES"
  },
  {
    "codigo":312969002,
    "descripcion":"HALLAZGOS GENÉTICOS NORMALES"
  },
  {
    "codigo":216500009,
    "descripcion":"INTOXICACIÓN ACCIDENTAL CAUSADA POR BUTABARBITAL"
  },
  {
    "codigo":1197705006,
    "descripcion":"HAMARTOMA DE GLÁNDULA DUODENAL"
  },
  {
    "codigo":704350002,
    "descripcion":"CON MAYOR RIESGO DE ALTERACIÓN DE DESARROLLO INFANTIL"
  },
  {
    "codigo":1163102005,
    "descripcion":"ENCEFALITIS CAUSADA POR BUNYAVIRIDAE"
  },
  {
    "codigo":683451000119103,
    "descripcion":"DERMATOFIBROMA DE TRONCO"
  },
  {
    "codigo":276531000,
    "descripcion":"TAQUIPNEA TRANSITORIA LEVE DEL RECIÉN NACIDO"
  },
  {
    "codigo":278366008,
    "descripcion":"EXCESO DE ANTICOAGULANTES SIN SANGRADO"
  },
  {
    "codigo":1259571000,
    "descripcion":"CARCINOMA MICROCÍTICO ECRINO PRIMARIO DE PIEL"
  },
  {
    "codigo":290111000119100,
    "descripcion":"LESIÓN DE NERVIO FEMORAL DERECHO"
  },
  {
    "codigo":331071000119101,
    "descripcion":"IRITIS POR HERPES ZÓSTER"
  },
  {
    "codigo":16320831000119100,
    "descripcion":"DEGENERACIÓN MACULAR MIÓPICA DEL OJO DERECHO"
  },
  {
    "codigo":674111000119100,
    "descripcion":"ATAXIA DEBIDA A ACCIDENTE CEREBROVASCULAR ISQUÉMICO Y POSTERIOR A ÉL"
  },
  {
    "codigo":305471000119103,
    "descripcion":"CONTRACTURA DE ARTICULACIÓN DE CADERA IZQUIERDA"
  },
  {
    "codigo":336191000119105,
    "descripcion":"OCLUSIÓN DE ARTERIA CENTRAL DE LA RETINA DERECHA"
  },
  {
    "codigo":16000831000119106,
    "descripcion":"ESCLERITIS DE OJO DERECHO POR HERPES ZOSTER"
  },
  {
    "codigo":877927231000119106,
    "descripcion":"URTICARIA MULTIFORME"
  },
  {
    "codigo":1073471000119108,
    "descripcion":"ARTRITIS INFECCIOSA DE MANO DERECHA"
  },
  {
    "codigo":341311000119105,
    "descripcion":"ABSCESO DE CÓRNEA DE OJO IZQUIERDO"
  },
  {
    "codigo":300351000119107,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE MUSLO IZQUIERDO"
  },
  {
    "codigo":12242751000119105,
    "descripcion":"DEBILIDAD DE MÚSCULO FACIAL DERECHO DEBIDA A ACCIDENTE CEREBROVASCULAR Y POSTERIOR A ÉL"
  },
  {
    "codigo":16052031000119109,
    "descripcion":"DESGARRO TENDINOSO NO TRAUMÁTICO DE MÚSCULO TRÍCEPS BRAQUIAL DERECHO"
  },
  {
    "codigo":16034111000119107,
    "descripcion":"HIPERTROFIA DE RADIO IZQUIERDO"
  },
  {
    "codigo":11100991000119107,
    "descripcion":"INFECCIÓN DE NALGA POR HERPES SIMPLE"
  },
  {
    "codigo":328511000119109,
    "descripcion":"ÉMBOLO EN SILLA DE MONTAR DE ARTERIA PULMONAR"
  },
  {
    "codigo":10632511000119107,
    "descripcion":"ABSCESO DE PIE IZQUIERDO"
  },
  {
    "codigo":10665791000119109,
    "descripcion":"ÚLCERA ISQUÉMICA ATEROSCLERÓTICA DE MUSLO IZQUIERDO"
  },
  {
    "codigo":1076031000119109,
    "descripcion":"HIPERTROFIA DE MEMBRANA SINOVIAL DE PIE DERECHO"
  },
  {
    "codigo":1621000119101,
    "descripcion":"INFECCIÓN POR CHLAMYDIA TRACHOMATIS EN EL EMBARAZO"
  },
  {
    "codigo":1286834000,
    "descripcion":"DISPLASIA ESPONDILOEPIMETAFISARIA CON LAXITUD ARTICULAR TIPO EXOC6B"
  },
  {
    "codigo":403933005,
    "descripcion":"SEBACEOMA"
  },
  {
    "codigo":305629003,
    "descripcion":"ATENDIDO POR UN HOMEÓPATA"
  },
  {
    "codigo":301959000,
    "descripcion":"PAPILA ÓPTICA NO OBSERVADA"
  },
  {
    "codigo":860850008,
    "descripcion":"GRANULOMA DE ESPACIO SUBDURAL ESPINAL CAUSADO POR BACTERIA"
  },
  {
    "codigo":203655001,
    "descripcion":"CIFOSIS EN LA DISPLASIA ESQUELÉTICA"
  },
  {
    "codigo":236423003,
    "descripcion":"DISFUNCIÓN RENAL"
  },
  {
    "codigo":1186695003,
    "descripcion":"AMBIENTE CAÓTICO"
  },
  {
    "codigo":269191009,
    "descripcion":"EFECTO TARDÍO DE COMPLICACIÓN DE ATENCIÓN MÉDICA Y QUIRÚRGICA"
  },
  {
    "codigo":37980001,
    "descripcion":"ENFERMEDAD DE CONCATO"
  },
  {
    "codigo":234588005,
    "descripcion":"DEFICIENCIA GRANULAR SECUNDARIA DE NEUTRÓFILOS"
  },
  {
    "codigo":365660005,
    "descripcion":"ASPECTO DEL VÓMITO - HALLAZGO"
  },
  {
    "codigo":1217628008,
    "descripcion":"ANOFTALMIA CONGÉNITA CON PRÓTESIS ORBITARIA"
  },
  {
    "codigo":68913001,
    "descripcion":"TALASEMIA ALFA"
  },
  {
    "codigo":300124009,
    "descripcion":"CONDUCTO AUDITIVO GRANDE"
  },
  {
    "codigo":298289005,
    "descripcion":"PUNTO MUSCULAR DOLOROSO A LA PALPACIÓN"
  },
  {
    "codigo":296454001,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE DITRANOL"
  },
  {
    "codigo":1542009,
    "descripcion":"ONFALOCELE CON OBSTRUCCIÓN"
  },
  {
    "codigo":720603002,
    "descripcion":"SÍNDROME DE CAMPTODACTILIA TIPO GUADALAJARA 2"
  },
  {
    "codigo":425691002,
    "descripcion":"CONSENTIMIENTO PARA COMPARTIR HISTORIA CLÍNICA ELECTRÓNICA, OTORGADO"
  },
  {
    "codigo":263219008,
    "descripcion":"FRACTURA DE AMBAS RAMAS PÚBICAS"
  },
  {
    "codigo":32475006,
    "descripcion":"GENERACIÓN F>2<"
  },
  {
    "codigo":292784005,
    "descripcion":"REACCIÓN ADVERSA A LA PARAFINA BLANDA AMARILLA"
  },
  {
    "codigo":15677321000119100,
    "descripcion":"MIOSITIS DE AMBAS MANOS"
  },
  {
    "codigo":499932911000119106,
    "descripcion":"EPIESCLERITIS NODULAR DE AMBOS OJOS"
  },
  {
    "codigo":128944008,
    "descripcion":"INFECCIÓN BACTERIANA CAUSADA POR BACILLUS"
  },
  {
    "codigo":587751151000119107,
    "descripcion":"INFECCIÓN AGUDA DE VÍAS RESPIRATORIAS INFERIORES CAUSADA POR VIRUS SINCICIAL RESPIRATORIO"
  },
  {
    "codigo":16031471000119107,
    "descripcion":"OSTEONECROSIS DE AMBOS FÉMURES CAUSADA POR FÁRMACO"
  },
  {
    "codigo":127109007,
    "descripcion":"LINFADENOPATÍA MEDIASTÍNICA ANTERIOR"
  },
  {
    "codigo":94341009,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA CARA INTERNA DE LABIO"
  },
  {
    "codigo":420186002,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA INTERNO AFECTADO POR NEOPLASIA MALIGNA"
  },
  {
    "codigo":715098002,
    "descripcion":"DIFICULTAD PARA PASAR DE LA SILLA DE RUEDAS AL AUTOMÓVIL"
  },
  {
    "codigo":92506005,
    "descripcion":"INSUFICIENCIA CARDÍACA CONGESTIVA BIVENTRICULAR"
  },
  {
    "codigo":190810006,
    "descripcion":"PÚRPURA HIPERGAMMAGLOBULINÉMICA BENIGNA PRIMARIA"
  },
  {
    "codigo":289114008,
    "descripcion":"TOSE"
  },
  {
    "codigo":254511002,
    "descripcion":"NEOPLASIA BENIGNA DE COMISURA ANTERIOR"
  },
  {
    "codigo":1137412000,
    "descripcion":"DEBILIDAD DE MÚSCULO DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":1268484002,
    "descripcion":"SARCOMA SINOVIAL PRIMARIO"
  },
  {
    "codigo":285444008,
    "descripcion":"MUEVE LA MANDÍBULA"
  },
  {
    "codigo":283609001,
    "descripcion":"HERIDA POR PINCHAZO DE AGUJA EN EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":185305000,
    "descripcion":"VISTO POR FLEBOTOMISTA"
  },
  {
    "codigo":11800611000119101,
    "descripcion":"TRANSECCIÓN TRAUMÁTICA COMPLETA DE VENA MESENTÉRICA SUPERIOR"
  },
  {
    "codigo":12236681000119108,
    "descripcion":"NEURITIS BRAQUIAL DE MIEMBRO SUPERIOR DERECHO"
  },
  {
    "codigo":871598001,
    "descripcion":"ANOMALÍA ADQUIRIDA DE TRONCO ARTERIAL COMÚN DESPUÉS DE REPARACIÓN DE TRONCO ARTERIOSO"
  },
  {
    "codigo":1363118001,
    "descripcion":"ENFERMEDAD ADRENOCORTICAL MICRONODULAR AISLADA"
  },
  {
    "codigo":249006004,
    "descripcion":"PAREDES PÉLVICAS LATERALES DIVERGENTES"
  },
  {
    "codigo":773294005,
    "descripcion":"PARONIQUIA DE DEDO DEL PIE IZQUIERDO DEBIDA A UÑA ENCARNADA"
  },
  {
    "codigo":609454008,
    "descripcion":"INTERRUPCIÓN INDUCIDA DEL EMBARAZO COMPLICADA POR NECROSIS HEPÁTICA AGUDA"
  },
  {
    "codigo":331811000119104,
    "descripcion":"DESPRENDIMIENTO DE RETINA DERECHA POR TRACCIÓN"
  },
  {
    "codigo":50563003,
    "descripcion":"DERMATITIS SEBORREICA"
  },
  {
    "codigo":247171003,
    "descripcion":"DIÁLISIS GIGANTE RETINIANA"
  },
  {
    "codigo":441944007,
    "descripcion":"SÍNDROME OTO-ÓNICO-PERONEO"
  },
  {
    "codigo":309037001,
    "descripcion":"SITUACIÓN DE TRASLADO"
  },
  {
    "codigo":440109001,
    "descripcion":"ENFERMEDAD CELÍACA NO DETECTADA POR CRIBADO DE AUTOANTICUERPOS"
  },
  {
    "codigo":866093001,
    "descripcion":"NEOPLASIA MALIGNA DE VAINA DE NERVIO PERIFÉRICO DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":1259309001,
    "descripcion":"CARCINOMA PRIMARIO DE CUERPO DE PÁNCREAS"
  },
  {
    "codigo":704088009,
    "descripcion":"FRACTURA EXPUESTA DE DIÁFISIS DE SEGUNDO METACARPIANO"
  },
  {
    "codigo":733186000,
    "descripcion":"ALTERACIÓN DE LA ALINEACIÓN DE MENISCO DE RODILLA DEBIDA A LESIÓN TRAUMÁTICA ANTIGUA Y POSTERIOR A ELLA"
  },
  {
    "codigo":45058001,
    "descripcion":"SÍFILIS DE VÁLVULA PULMONAR"
  },
  {
    "codigo":210733008,
    "descripcion":"LESIÓN POR DESOLLAMIENTO DE MÚLTIPLES DEDOS DE LOS PIES"
  },
  {
    "codigo":307202004,
    "descripcion":"DERRAME PLEURAL HEMORRÁGICO"
  },
  {
    "codigo":305341000119103,
    "descripcion":"CONTRACTURA DE MÚSCULO DE BRAZO IZQUIERDO"
  },
  {
    "codigo":403671004,
    "descripcion":"ANETODERMIA MEDICAMENTOSA"
  },
  {
    "codigo":1255639008,
    "descripcion":"RUPTURA DE RETINA CON RETINOSQUISIS"
  },
  {
    "codigo":237996001,
    "descripcion":"DEFICIENCIA DE ACIL-COA DESHIDROGENASA DE CADENA LARGA"
  },
  {
    "codigo":205228003,
    "descripcion":"AUSENCIA CONGÉNITA DE QUINTO DEDO DEL PIE"
  },
  {
    "codigo":15952061000119106,
    "descripcion":"TROMBOFLEBITIS DE VENA AXILAR IZQUIERDA"
  },
  {
    "codigo":762284008,
    "descripcion":"CELULITIS CAUSADA POR STAPHYLOCOCCUS AUREUS"
  },
  {
    "codigo":170625000,
    "descripcion":"TÉCNICA DE INHALACIÓN: BUENA"
  },
  {
    "codigo":400001003,
    "descripcion":"LINFOMA CUTÁNEO PRIMARIO"
  },
  {
    "codigo":301697003,
    "descripcion":"DIFICULTAD PARA MOVERSE HACIA ARRIBA Y HACIA ABAJO EN LA CAMA"
  },
  {
    "codigo":72321008,
    "descripcion":"QUERATOCONJUNTIVITIS POR VIRUS DEL HERPES SIMPLE"
  },
  {
    "codigo":365398001,
    "descripcion":"NIVEL DE EGOCENTRISMO - HALLAZGO"
  },
  {
    "codigo":299862002,
    "descripcion":"REFLEJO SACRO INVERTIDO"
  },
  {
    "codigo":201558003,
    "descripcion":"ARTRITIS REACTIVA DE ARTICULACIÓN GLENOHUMERAL"
  },
  {
    "codigo":430934002,
    "descripcion":"MUTACIÓN MITOCONDRIAL"
  },
  {
    "codigo":103254005,
    "descripcion":"REFLEJO CORNEAL DISMINUIDO"
  },
  {
    "codigo":37718006,
    "descripcion":"PIE EQUINO ADQUIRIDO"
  },
  {
    "codigo":70486007,
    "descripcion":"CICLOTROPÍA"
  },
  {
    "codigo":396331005,
    "descripcion":"ENFERMEDAD CELÍACA"
  },
  {
    "codigo":1344768000,
    "descripcion":"HALLAZGO RELACIONADO CON EL APEGO INTERPERSONAL"
  },
  {
    "codigo":10682711000119105,
    "descripcion":"TUMORACIÓN DE LA PIEL DE LA MANO DERECHA"
  },
  {
    "codigo":230656003,
    "descripcion":"NEUROPATÍA SENSORIOMOTRIZ DESMIELINIZANTE"
  },
  {
    "codigo":16636401000119100,
    "descripcion":"MONONEUROPATÍA DE AMBAS EXTREMIDADES SUPERIORES"
  },
  {
    "codigo":34048007,
    "descripcion":"SINDACTILIA DE DEDOS DE LA MANO"
  },
  {
    "codigo":196053000,
    "descripcion":"NEUMOPATÍAS INTERSTICIALES MEDICAMENTOSAS CRÓNICAS"
  },
  {
    "codigo":1280009,
    "descripcion":"QUIMERA ISÓLOGA"
  },
  {
    "codigo":64981002,
    "descripcion":"ATRESIA DE LARINGE"
  },
  {
    "codigo":334321000119101,
    "descripcion":"GLAUCOMA DE BAJA TENSIÓN DEL OJO DERECHO"
  },
  {
    "codigo":296192008,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE DROPERIDOL"
  },
  {
    "codigo":163285006,
    "descripcion":"MASA EN FOSA ILÍACA DERECHA"
  },
  {
    "codigo":294357007,
    "descripcion":"ALERGIA A FENTICONAZOL"
  },
  {
    "codigo":30378001,
    "descripcion":"INFECCIÓN CAUSADA POR TYROPHAGUS"
  },
  {
    "codigo":95914002,
    "descripcion":"REVERSIÓN DE LA ACTIVIDAD DE LOS OPIÁCEOS"
  },
  {
    "codigo":11829591000119109,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DE DEDO PULGAR IZQUIERDO"
  },
  {
    "codigo":292522009,
    "descripcion":"REACCIÓN ADVERSA A FÁRMACO ANTICOLINÉRGICO"
  },
  {
    "codigo":290687003,
    "descripcion":"INTOXICACIÓN POR TIOGUANINA"
  },
  {
    "codigo":126847008,
    "descripcion":"NEOPLASIA DEL RECTO"
  },
  {
    "codigo":94079008,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA REGIÓN SUPRACLAVICULAR"
  },
  {
    "codigo":49544001,
    "descripcion":"PUNTAJE DE APGAR 10"
  },
  {
    "codigo":1306495009,
    "descripcion":"CARCINOMA DUCTAL INFILTRANTE PRIMARIO DE CUADRANTE SUPERIOR INTERNO DE MAMA IZQUIERDA"
  },
  {
    "codigo":254249002,
    "descripcion":"SÍNDROME DE CARBAMAZEPINA FETAL"
  },
  {
    "codigo":287017006,
    "descripcion":"SINOVITIS\/TENOSINOVITIS - HOMBRO"
  },
  {
    "codigo":307851000119102,
    "descripcion":"FÍSTULA DE ARTICULACIÓN DE REGIÓN DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":186878002,
    "descripcion":"ENDOCARDITIS SIFILÍTICA DE VÁLVULA PULMONAR"
  },
  {
    "codigo":15735281000119109,
    "descripcion":"RETINOPATÍA DE AMBOS OJOS"
  },
  {
    "codigo":285182008,
    "descripcion":"CAPAZ DE RECONOCER SONIDOS DE ADVERTENCIA"
  },
  {
    "codigo":283347003,
    "descripcion":"PICADURA INFECTADA EN EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":447187003,
    "descripcion":"PULSO TIBIAL POSTERIOR MONOFÁSICO"
  },
  {
    "codigo":1264552001,
    "descripcion":"EN RIESGO DE EXPOSICIÓN A VIRUS DE HEPATITIS B DEBIDO A OCUPACIÓN"
  },
  {
    "codigo":11776651000119106,
    "descripcion":"LACERACIÓN DE TENDÓN DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":314280007,
    "descripcion":"HEMATURIA DE CAUSA DESCONOCIDA"
  },
  {
    "codigo":115837000,
    "descripcion":"FENOTIPO DE GRUPO SANGUÍNEO KELL"
  },
  {
    "codigo":246909008,
    "descripcion":"CONJUNTIVA PALPEBRAL - FOLÍCULOS GIGANTES"
  },
  {
    "codigo":1295485009,
    "descripcion":"SÍNDROME DE DE BARSY ASOCIADO AL GEN ALDH18A1"
  },
  {
    "codigo":212306002,
    "descripcion":"LESIONES NERVIOSAS MÚLTIPLES DE LA CINTURA ESCAPULAR Y DE MIEMBROS SUPERIORES"
  },
  {
    "codigo":48466003,
    "descripcion":"FRACTURA DE LA BÓVEDA DEL CRÁNEO"
  },
  {
    "codigo":10849061000119102,
    "descripcion":"CUERPO EXTRAÑO DE SACO CONJUNTIVAL DE OJO DERECHO"
  },
  {
    "codigo":1162578008,
    "descripcion":"LESIÓN TRAUMÁTICA ACCIDENTAL DE INTESTINO DURANTE PROCEDIMIENTO QUIRÚRGICO"
  },
  {
    "codigo":1259047002,
    "descripcion":"COMPRESIÓN INFLAMATORIA DE COLA DE CABALLO"
  },
  {
    "codigo":15928101000119105,
    "descripcion":"PROBLEMA DE RELACIÓN ENTRE PROGENITOR E HIJO ADOPTADO"
  },
  {
    "codigo":110332001,
    "descripcion":"FORMA NORMAL DE RAÍZ DENTAL"
  },
  {
    "codigo":44796002,
    "descripcion":"URÉTER ECTÓPICO"
  },
  {
    "codigo":306940003,
    "descripcion":"SECRECIÓN EN MEATO MEDIO"
  },
  {
    "codigo":208636004,
    "descripcion":"FRACTURA NO EXPUESTA DE TIBIA DISTAL, INTRARTICULAR"
  },
  {
    "codigo":405244005,
    "descripcion":"DERMATITIS DE CONTACTO CAUSADA POR ORINA"
  },
  {
    "codigo":274172008,
    "descripcion":"LACERACIÓN DE DEDO DE LA MANO"
  },
  {
    "codigo":698321001,
    "descripcion":"TRASTORNO NEONATAL CAUSADO POR ALCOHOL TRANSMITIDO A TRAVÉS DE LA LECHE MATERNA"
  },
  {
    "codigo":10193001,
    "descripcion":"ARTRITIS CAUSADA POR PSEUDOMONAS"
  },
  {
    "codigo":42961007,
    "descripcion":"INTOXICACIÓN POR APOCYNUM"
  },
  {
    "codigo":186419006,
    "descripcion":"GANGRENA GASEOSA DE MANO"
  },
  {
    "codigo":403409009,
    "descripcion":"MIOFIBROMATOSIS INFANTIL SOLITARIA"
  },
  {
    "codigo":270502007,
    "descripcion":"ABSCESO DE MAMA DE CAUSA OBSTÉTRICA"
  },
  {
    "codigo":237734007,
    "descripcion":"SÍNDROME DE CUSHING DEPENDIENTE DE ACTH"
  },
  {
    "codigo":203131005,
    "descripcion":"ALMOHADILLA DEL TALÓN DOLOROSA A LA PALPACIÓN"
  },
  {
    "codigo":39291006,
    "descripcion":"EMBOLIA DE VENA RENAL"
  },
  {
    "codigo":268667008,
    "descripcion":"TRASTORNO DE LA NIÑEZ Y ADOLESCENCIA CON TIMIDEZ"
  },
  {
    "codigo":1153403009,
    "descripcion":"ANEMIA FERROPÉNICA HEREDITARIA"
  },
  {
    "codigo":235899008,
    "descripcion":"ESCLEROSIS HEPÁTICA"
  },
  {
    "codigo":102992006,
    "descripcion":"MARCHA EN TIJERA PARA LA PRUEBA DE LA MARCHA EN LÍNEA RECTA CON LOS OJOS CERRADOS"
  },
  {
    "codigo":365136007,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA REALIZAR ACTIVIDADES FÍSICAS CON PROPÓSITOS GENERALES"
  },
  {
    "codigo":4688008,
    "descripcion":"INTOXICACIÓN POR GRISEOFULVINA"
  },
  {
    "codigo":68389001,
    "descripcion":"VAGINITIS MUCOPURULENTA"
  },
  {
    "codigo":363301001,
    "descripcion":"SECUELAS DE ENFERMEDADES NEOPLÁSICAS"
  },
  {
    "codigo":10904511000119107,
    "descripcion":"LACERACIÓN DE NALGA DERECHA"
  },
  {
    "codigo":232229004,
    "descripcion":"OTITIS GRANULOMATOSA EXTERNA"
  },
  {
    "codigo":166693005,
    "descripcion":"NIVEL DE SODIO SÉRICO FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":2853006,
    "descripcion":"QUERATITIS MACULAR"
  },
  {
    "codigo":263162001,
    "descripcion":"FRACTURA CONMINUTA DEL ALVÉOLO MAXILAR"
  },
  {
    "codigo":1074111000119109,
    "descripcion":"CONDROCALCINOSIS DE ARTICULACIÓN DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":66554005,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO DE GENITALES MASCULINOS"
  },
  {
    "codigo":230394006,
    "descripcion":"EPILEPSIA DE LÓBULO FRONTAL"
  },
  {
    "codigo":197626007,
    "descripcion":"GLOMERULONEFRITIS MEMBRANOPROLIFERATIVA FOCAL"
  },
  {
    "codigo":294095006,
    "descripcion":"ALERGIA A CARBOCISTEÍNA"
  },
  {
    "codigo":193956000,
    "descripcion":"TRASTORNOS DEGENERATIVOS DE LOS PÁRPADOS Y LA REGIÓN PERIOCULAR"
  },
  {
    "codigo":292260001,
    "descripcion":"REACCIÓN ADVERSA AL MAZINDOL"
  },
  {
    "codigo":11861081000119105,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN DE TOBILLO DERECHO"
  },
  {
    "codigo":95652003,
    "descripcion":"PARÁLISIS FLÁCCIDA CONGÉNITA"
  },
  {
    "codigo":359631009,
    "descripcion":"LEUCEMIA MIELOIDE AGUDA, MÍNIMAMENTE DIFERENCIADA, FAB M0"
  },
  {
    "codigo":310361000119106,
    "descripcion":"OSTEOFITO DE CRESTA ILÍACA IZQUIERDA"
  },
  {
    "codigo":30116001,
    "descripcion":"URETRITIS TRICOMONIÁSICA"
  },
  {
    "codigo":290425001,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ANTAGONISTA DEL RECEPTOR 5-HT3"
  },
  {
    "codigo":1176996009,
    "descripcion":"ALOPECIA CICATRIZAL LEPROMATOSA"
  },
  {
    "codigo":716409003,
    "descripcion":"CAPAZ DE DESENVOLVERSE EN UN AMBIENTE ESCOLAR"
  },
  {
    "codigo":126585004,
    "descripcion":"NEOPLASIA DE TIBIA"
  },
  {
    "codigo":93817006,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE GRANDES VASOS"
  },
  {
    "codigo":11144004,
    "descripcion":"ESTRECHEZ CONGÉNITA DEL MEATO ÓSEO DEL OÍDO MEDIO"
  },
  {
    "codigo":11779161000119108,
    "descripcion":"RUPTURA TRAUMÁTICA DE RODETE GLENOIDEO DERECHO"
  },
  {
    "codigo":10959961000119109,
    "descripcion":"HERIDA ABIERTA DE REGIÓN DE CODO DERECHO"
  },
  {
    "codigo":288590004,
    "descripcion":"NO EMPLEA EL LENGUAJE CORPORAL"
  },
  {
    "codigo":286755001,
    "descripcion":"CARÁCTER IMPACIENTE"
  },
  {
    "codigo":1237027009,
    "descripcion":"CON RIESGO ELEVADO DE EXPOSICIÓN A VIRUS VARICELA ZÓSTER"
  },
  {
    "codigo":415992005,
    "descripcion":"TRASTORNO DEL VENTRÍCULO CARDÍACO DERECHO"
  },
  {
    "codigo":284920007,
    "descripcion":"CAPAZ DE USAR ORINAL"
  },
  {
    "codigo":446925001,
    "descripcion":"TUMOR DE ESTROMA GASTROINTESTINAL DE INTESTINO DELGADO"
  },
  {
    "codigo":184781001,
    "descripcion":"TIENE PRESCRIPCIONES GRATUITAS - AUTOMÁTICAS"
  },
  {
    "codigo":1076621000119101,
    "descripcion":"TENDINITIS DE RODILLA DERECHA"
  },
  {
    "codigo":53709002,
    "descripcion":"HEMATOCELE FEMENINO"
  },
  {
    "codigo":283085005,
    "descripcion":"ARAÑAZO DE LA PALMA DE LA MANO"
  },
  {
    "codigo":248482000,
    "descripcion":"TUMEFACCIÓN GENERALIZADA DE ÓRBITA"
  },
  {
    "codigo":414157009,
    "descripcion":"EXCESO DE LÍQUIDO EN EL ESTÓMAGO"
  },
  {
    "codigo":707234001,
    "descripcion":"QUISTE DE CUARTA HENDIDURA BRANQUIAL"
  },
  {
    "codigo":215714000,
    "descripcion":"LESIÓN SUFRIDA A BORDO DE MEDIO DE TRANSPORTE ACUÁTICO CAUSADA POR MAQUINARIA DE CUBIERTA, CARGADOR DE MUELLES O ESTIBADOR LESIONADO"
  },
  {
    "codigo":314018004,
    "descripcion":"CON MAYOR RIESGO DE GLAUCOMA"
  },
  {
    "codigo":445090007,
    "descripcion":"COLONOPATÍA FIBROSANTE"
  },
  {
    "codigo":84642008,
    "descripcion":"REGURGITACIÓN CRÓNICA"
  },
  {
    "codigo":1297058008,
    "descripcion":"CIERRE DE ÁNGULO POSOPERATORIO DE AMBOS OJOS"
  },
  {
    "codigo":836471008,
    "descripcion":"PIERCING EN LENGUA"
  },
  {
    "codigo":212044001,
    "descripcion":"QUEMADURA DE VAGINA Y ÚTERO"
  },
  {
    "codigo":1162316002,
    "descripcion":"DEFORMIDAD EN LORDOSIS DE COLUMNA VERTEBRAL DEBIDA A DESEQUILIBRIO MUSCULAR"
  },
  {
    "codigo":441420000,
    "descripcion":"MUTACIÓN HOMOCIGOTA DEL GEN G20210A DE PROTROMBINA"
  },
  {
    "codigo":310348003,
    "descripcion":"ATENDIDO POR UN PSICÓLOGO"
  },
  {
    "codigo":277580004,
    "descripcion":"MIELOMA NO SECRETOR"
  },
  {
    "codigo":339341000119106,
    "descripcion":"SÍNDROME DE MÚLTIPLES PUNTOS BLANCOS EVANESCENTES DE OJO IZQUIERDO"
  },
  {
    "codigo":13601005,
    "descripcion":"TRASTORNO PARANOIDE DE LA PERSONALIDAD"
  },
  {
    "codigo":242977006,
    "descripcion":"LESIÓN CON PROPÓSITO DESCONOCIDO POR CAÍDA DESDE CONSTRUCCIÓN ELEVADA"
  },
  {
    "codigo":208374002,
    "descripcion":"FRACTURA NO EXPUESTA DE TUBEROSIDAD DE ESCAFOIDES"
  },
  {
    "codigo":77302006,
    "descripcion":"INFESTACIÓN CAUSADA POR CERATOPOGONIDAE"
  },
  {
    "codigo":1156811000,
    "descripcion":"NEOPLASIA MESENQUIMÁTICA MALIGNA DE ANO"
  },
  {
    "codigo":75467001,
    "descripcion":"DISCOPATÍA INTERVERTEBRAL DE LA REGIÓN CERVICAL, CON MIELOPATÍA"
  },
  {
    "codigo":370379002,
    "descripcion":"ECOGRAFÍA PRENATAL - HALLAZGO"
  },
  {
    "codigo":698059002,
    "descripcion":"FRACTURA NO EXPUESTA DE BASE DE SEGUNDO METACARPIANO"
  },
  {
    "codigo":110070009,
    "descripcion":"LACERACIÓN CONTAMINADA COMPLEJA DEL CUERO CABELLUDO"
  },
  {
    "codigo":403147005,
    "descripcion":"DERMATOSIS CAUSADA POR POLILLA Y\/O MARIPOSA"
  },
  {
    "codigo":206539008,
    "descripcion":"ESCLEREMA NEONATAL"
  },
  {
    "codigo":237472001,
    "descripcion":"PROTRUSIÓN DE IMPLANTE MAMARIO"
  },
  {
    "codigo":401312001,
    "descripcion":"NEOPLASIA ANAL INTRAEPITELIAL GRADO II"
  },
  {
    "codigo":1251445000,
    "descripcion":"METÁSTASIS DE NEUROBLASTOMA EN ESTRUCTURA ABDOMINOTORÁCICA"
  },
  {
    "codigo":235637006,
    "descripcion":"DIVERTÍCULOS ESOFÁGICOS MEDIOS"
  },
  {
    "codigo":301173008,
    "descripcion":"VENA AUSENTE"
  },
  {
    "codigo":299338001,
    "descripcion":"SIN AMPLITUD ACTIVA DE FLEXIÓN DE RODILLA"
  },
  {
    "codigo":366709009,
    "descripcion":"AMPLITUD DE MOVIMIENTO PASIVO DE EXTENSIÓN DE DEDO DEL PIE - HALLAZGO"
  },
  {
    "codigo":364874005,
    "descripcion":"PATRÓN ELECTROENCEFALOGRÁFICO FOCAL - HALLAZGO"
  },
  {
    "codigo":12246721000119103,
    "descripcion":"BLEFARITIS BILATERAL DE PÁRPADOS INFERIORES"
  },
  {
    "codigo":266570005,
    "descripcion":"FIMOSIS Y PREPUCIO REDUNDANTE"
  },
  {
    "codigo":233802008,
    "descripcion":"HEMORRAGIA DE ANASTOMOSIS BRONQUIAL"
  },
  {
    "codigo":363039000,
    "descripcion":"TRASTORNO CONGÉNITO DEL TEJIDO CONJUNTIVO"
  },
  {
    "codigo":166431002,
    "descripcion":"PRUEBA DE FUNCIÓN PLACENTARIA NORMAL"
  },
  {
    "codigo":2591000,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DE REGIÓN DE HOMBRO"
  },
  {
    "codigo":789023001,
    "descripcion":"REQUIERE VACUNACIÓN CONTRA ENCEFALITIS VIRAL TRANSMITIDA POR ARTRÓPODOS"
  },
  {
    "codigo":428575007,
    "descripcion":"HIPERTENSIÓN SECUNDARIA A TRASPLANTE RENAL"
  },
  {
    "codigo":197364000,
    "descripcion":"HEPATONECROSIS HEMORRÁGICA CENTRAL"
  },
  {
    "codigo":231967008,
    "descripcion":"CATARATA POR CONCUSIÓN"
  },
  {
    "codigo":262900003,
    "descripcion":"RUPTURA DE LA UNIÓN PELVICOURETERAL"
  },
  {
    "codigo":756003,
    "descripcion":"MIOPERICARDITIS REUMÁTICA CRÓNICA"
  },
  {
    "codigo":295668007,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE MITOMICINA"
  },
  {
    "codigo":392137000,
    "descripcion":"HENDIDURA DE CICLODIÁLISIS"
  },
  {
    "codigo":721652009,
    "descripcion":"ÍLEO BILIAR DE INTESTINO DELGADO"
  },
  {
    "codigo":64457002,
    "descripcion":"PIEL ANSERINA"
  },
  {
    "codigo":719817002,
    "descripcion":"ATAXIA ESPINOCEREBELOSA LIGADA AL CROMOSOMA X TIPO 3"
  },
  {
    "codigo":11837121000119107,
    "descripcion":"CUERPO EXTRAÑO SUPERFICIAL DE CADERA DERECHA CON INFECCIÓN"
  },
  {
    "codigo":293833007,
    "descripcion":"ALERGIA A IMIPRAMINA"
  },
  {
    "codigo":228297007,
    "descripcion":"BEBE SOLO"
  },
  {
    "codigo":160926000,
    "descripcion":"APTO PARA EL TRABAJO"
  },
  {
    "codigo":95390004,
    "descripcion":"DAÑO NERVIOSO EN EL SITIO DE INYECCIÓN"
  },
  {
    "codigo":1079131000119103,
    "descripcion":"CARCINOMA BASOCELULAR PRIMARIO DE MIEMBRO INFERIOR IZQUIERDO"
  },
  {
    "codigo":781683000,
    "descripcion":"HIPEREMIA EPIESCLERAL"
  },
  {
    "codigo":60787001,
    "descripcion":"HIPOPLASIA CONGÉNITA DEL CAYADO AÓRTICO"
  },
  {
    "codigo":290163004,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR DEXTROPROPOXIFENO"
  },
  {
    "codigo":419400008,
    "descripcion":"TAQUICARDIA INCISIONAL"
  },
  {
    "codigo":188189001,
    "descripcion":"NEOPLASIA MALIGNA DEL CUERPO UTERINO, EXCLUIDO EL ISTMO"
  },
  {
    "codigo":1269533005,
    "descripcion":"SÍNDROME DE CORDÓN CENTRAL DEBIDO A ESPONDILOSIS CERVICAL"
  },
  {
    "codigo":253725005,
    "descripcion":"CALCIFICACIÓN CONGÉNITA DE ARTERIA CORONARIA"
  },
  {
    "codigo":286493007,
    "descripcion":"DIFICULTAD PARA PREPARAR COMIDA"
  },
  {
    "codigo":88050005,
    "descripcion":"HEMATOMA DEL PABELLÓN DE LA OREJA"
  },
  {
    "codigo":448498005,
    "descripcion":"TABIQUE INFUNDIBULAR PRESENTE"
  },
  {
    "codigo":22514005,
    "descripcion":"NACIMIENTO DE TÉRMINO DE GEMELOS DICIGÓTICOS, UNO VIVO, UNO MUERTO"
  },
  {
    "codigo":250055006,
    "descripcion":"MARCHA INCONGRUENTE"
  },
  {
    "codigo":1264028004,
    "descripcion":"DOLOR EN MÚSCULO DE PIERNA"
  },
  {
    "codigo":248220008,
    "descripcion":"DORMIDO"
  },
  {
    "codigo":1231260009,
    "descripcion":"ENDOFTALMITIS ENDÓGENA CAUSADA POR CANDIDA"
  },
  {
    "codigo":82545002,
    "descripcion":"REACCIÓN A LA TRANSFUSIÓN DE SANGRE"
  },
  {
    "codigo":705137004,
    "descripcion":"FRACTURA NO EXPUESTA TRANSVERSAL Y DE PARED POSTERIOR DE ACETÁBULO"
  },
  {
    "codigo":80710001,
    "descripcion":"HIPOMAGNESEMIA PRIMARIA"
  },
  {
    "codigo":1293126001,
    "descripcion":"NEOPLASIA DE CÉLULAS FUSIFORMES NTRK-REORGANIZADA"
  },
  {
    "codigo":211782003,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO PROFUNDA DE PARED ABDOMINAL"
  },
  {
    "codigo":16017551000119103,
    "descripcion":"ALTERACIÓN CRÓNICA DE ASTA POSTERIOR DE MENISCO EXTERNO DE AMBAS RODILLAS"
  },
  {
    "codigo":703302009,
    "descripcion":"ENCEFALOPATÍA HIPÓXICA ISQUÉMICA MODERADA"
  },
  {
    "codigo":209947002,
    "descripcion":"HEMORRAGIA SUBDURAL TRAUMÁTICA INTRACRANEAL CERRADA"
  },
  {
    "codigo":373787003,
    "descripcion":"RETRASO DEL TRATAMIENTO - DECISIÓN DEL PACIENTE"
  },
  {
    "codigo":406555004,
    "descripcion":"CON BAJO RIESGO DE DAÑAR A OTROS"
  },
  {
    "codigo":767003004,
    "descripcion":"LUXACIÓN CONGÉNITA DE CADERA DERECHA"
  },
  {
    "codigo":78875003,
    "descripcion":"CATARATA SENIL CORTICAL"
  },
  {
    "codigo":111643005,
    "descripcion":"FRACTURA EXPUESTA DE RÓTULA"
  },
  {
    "codigo":13339005,
    "descripcion":"INFECCIÓN CAUSADA POR TAENIA PISIFORMIS"
  },
  {
    "codigo":109808001,
    "descripcion":"GLOSITIS CRÓNICA"
  },
  {
    "codigo":240880004,
    "descripcion":"MIASIS DE HERIDA"
  },
  {
    "codigo":402885004,
    "descripcion":"QUERATOCONJUNTIVITIS PRIMARIA POR HERPES SIMPLEX"
  },
  {
    "codigo":271813007,
    "descripcion":"PETEQUIAS"
  },
  {
    "codigo":1287621007,
    "descripcion":"CRISIS EPILÉPTICA TÓNICA DE INICIO FOCAL NEONATAL"
  },
  {
    "codigo":75205009,
    "descripcion":"ASCITIS POR ORINA EN EL NEONATO"
  },
  {
    "codigo":827034002,
    "descripcion":"CICATRIZ DE PIEL POSTERIOR A INMUNIZACIÓN CON BACILO DE CALMETTE-GUERIN"
  },
  {
    "codigo":237210003,
    "descripcion":"CISTOCELE EN EL EMBARAZO, PARTO Y PUERPERIO"
  },
  {
    "codigo":401050002,
    "descripcion":"ARTERIA CARÓTIDA - HALLAZGO"
  },
  {
    "codigo":5999000,
    "descripcion":"ESCALA DEL COMA DE GLASGOW, 9"
  },
  {
    "codigo":106138009,
    "descripcion":"HALLAZGO EN EL ÁREA DEL APRENDIZAJE"
  },
  {
    "codigo":268143001,
    "descripcion":"ESPINA BÍFIDA CON HIDROCEFALIA - EXPUESTA"
  },
  {
    "codigo":10759611000119105,
    "descripcion":"RUPTURA PREMATURA DE MEMBRANAS CON COMIENZO DEL TRABAJO DE PARTO MÁS DE 24 HORAS DESPUÉS DE LA RUPTURA"
  },
  {
    "codigo":366447003,
    "descripcion":"AMPLITUD DE MOVIMIENTO PASIVO DE ROTACIÓN HACIA LA IZQUIERDA DE LA COLUMNA LUMBAR - HALLAZGO"
  },
  {
    "codigo":1351322008,
    "descripcion":"LÍQUIDO AMNIÓTICO MALOLIENTE"
  },
  {
    "codigo":202607008,
    "descripcion":"MÚLTIPLES CHASQUIDOS ARTICULARES"
  },
  {
    "codigo":1081641000119105,
    "descripcion":"RABDOMIOSARCOMA PRIMARIO DE REGIÓN DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":299076002,
    "descripcion":"AMPLITUD DE EXTENSIÓN ACTIVA DE DEDO DE LA MANO NORMAL"
  },
  {
    "codigo":344361000119105,
    "descripcion":"ESCLERITIS POSTERIOR DE AMBOS OJOS"
  },
  {
    "codigo":725060001,
    "descripcion":"TORSIÓN DE LA PUNTA CAUSADA POR FÁRMACO"
  },
  {
    "codigo":12058921000119107,
    "descripcion":"POSICIÓN ANÓMALA DE IMPLANTE DE MAMA IZQUIERDA"
  },
  {
    "codigo":262638001,
    "descripcion":"CONTUSIÓN DE SUPERFICIE INTRABUCAL DE LABIO"
  },
  {
    "codigo":295406002,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE CAOLÍN"
  },
  {
    "codigo":33262002,
    "descripcion":"OSTEOARTROSIS DE LOCALIZACIONES MÚLTIPLES, NO ESPECIFICADA COMO GENERALIZADA"
  },
  {
    "codigo":395545009,
    "descripcion":"MÁRGENES DE RESECCIÓN QUIRÚRGICA DE MUCOSA NO AFECTADOS POR CARCINOMA IN SITU"
  },
  {
    "codigo":64195000,
    "descripcion":"VARIACIÓN GENÉTICA"
  },
  {
    "codigo":162499001,
    "descripcion":"SÍNTOMA QUE CAMBIA"
  },
  {
    "codigo":721390008,
    "descripcion":"SÍNDROME DEL CORDÓN POSTERIOR DE MÉDULA ESPINAL AL NIVEL DEL PRIMER SEGMENTO CERVICAL"
  },
  {
    "codigo":129731001,
    "descripcion":"REVISIÓN DEL IMPLANTE DESDE LA MAMOGRAFÍA ANTERIOR"
  },
  {
    "codigo":293571007,
    "descripcion":"REACCIÓN ADVERSA A LA ESTREPTOQUINASA"
  },
  {
    "codigo":783256001,
    "descripcion":"ANOMALÍA FAMILIAR DE LA TROMBOMODULINA"
  },
  {
    "codigo":424643009,
    "descripcion":"ASMA ALÉRGICA MEDIADA POR IGE"
  },
  {
    "codigo":224365000,
    "descripcion":"EN TRABAJO TRANSITORIO REMUNERADO"
  },
  {
    "codigo":226200009,
    "descripcion":"DIETA SIN FRUTAS SECAS"
  },
  {
    "codigo":95128009,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL MESENTERIO"
  },
  {
    "codigo":93293003,
    "descripcion":"HIPOPLASIA CONGÉNITA DE HUESO ESCAMOSO"
  },
  {
    "codigo":1141869004,
    "descripcion":"SIGNO DEL CHAL"
  },
  {
    "codigo":191597008,
    "descripcion":"EPISODIOS MANÍACOS RECURRENTES, EN REMISIÓN TOTAL"
  },
  {
    "codigo":60525009,
    "descripcion":"NEUROPATÍA PLANTAR LATERAL"
  },
  {
    "codigo":419138002,
    "descripcion":"PREPUBERAL"
  },
  {
    "codigo":58690002,
    "descripcion":"PARASOMNIA"
  },
  {
    "codigo":124226002,
    "descripcion":"DEFICIENCIA DE DESHIDROGENASA"
  },
  {
    "codigo":27757009,
    "descripcion":"PLEURESÍA TABICADA"
  },
  {
    "codigo":289901008,
    "descripcion":"AUSENCIA DEL DOLOR DURANTE EL PERÍODO"
  },
  {
    "codigo":25922000,
    "descripcion":"TRASTORNO DEPRESIVO MAYOR, UN SOLO EPISODIO DE INICIO EN EL PERÍODO POSTPARTO"
  },
  {
    "codigo":24087000,
    "descripcion":"QUEMADURA DE LA ENCÍA"
  },
  {
    "codigo":317891000119109,
    "descripcion":"ARTRITIS DE RODILLA DERECHA CAUSADA POR STREPTOCOCCUS PNEUMONIAE"
  },
  {
    "codigo":1269271003,
    "descripcion":"SÍNDROME DE FANCONI ATÍPICO E HIPERINSULINISMO NEONATAL"
  },
  {
    "codigo":187927003,
    "descripcion":"NEOPLASIA MALIGNA DE LA APÓFISIS XIFOIDES"
  },
  {
    "codigo":286231005,
    "descripcion":"INCAPAZ DE USAR EL FLUJO DE AIRE PALATINO AL HABLAR"
  },
  {
    "codigo":417303004,
    "descripcion":"VASCULITIS RETINIANA SECUNDARIA A LUPUS ERITEMATOSO SISTÉMICO"
  },
  {
    "codigo":253463003,
    "descripcion":"CABALGAMIENTO DE VÁLVULA AURICULOVENTRICULAR DERECHA"
  },
  {
    "codigo":291421000119106,
    "descripcion":"HEMORRAGIA ATRAUMÁTICA DE ESPACIO SUBARACNOIDEO DE ARTERIA VERTEBRAL IZQUIERDA"
  },
  {
    "codigo":1084151000119100,
    "descripcion":"PÉRDIDA DE LA AUDICIÓN DE AMBOS OÍDOS CAUSADA POR RUIDO"
  },
  {
    "codigo":282561003,
    "descripcion":"NO CAMINA EN PUNTAS DE PIE"
  },
  {
    "codigo":346871000119101,
    "descripcion":"COROIDITIS DE AMBOS OJOS"
  },
  {
    "codigo":247958000,
    "descripcion":"EXPRESIÓN EN BLANCO Y VISTA FIJA DURANTE EPISODIO DE SONAMBULISMO"
  },
  {
    "codigo":870550000,
    "descripcion":"FRACTURA NO EXPUESTA DE BASE DE CRÁNEO CON LACERACIÓN CEREBRAL"
  },
  {
    "codigo":770411000,
    "descripcion":"MONOSOMÍA DISTAL 19P13.3"
  },
  {
    "codigo":213355001,
    "descripcion":"FRACTURAS QUE COMPROMETEN AMBOS MIEMBROS INFERIORES"
  },
  {
    "codigo":82283002,
    "descripcion":"ELEMENTO DE ACRECENTAMIENTO GENÉTICO"
  },
  {
    "codigo":442731005,
    "descripcion":"ESTUDIO POR IMÁGENES DEL CEREBRO, ANORMAL"
  },
  {
    "codigo":735808001,
    "descripcion":"RUPTURA TRAUMÁTICA DE LIGAMENTO LATERAL CUBITAL DE CODO"
  },
  {
    "codigo":1260096003,
    "descripcion":"SÍNDROME DE DESGASTE ASOCIADO AL SÍNDROME DE INMUNODEFICIENCIA ADQUIRIDO"
  },
  {
    "codigo":4931000175107,
    "descripcion":"SE PIERDE EN LUGAR CONOCIDO"
  },
  {
    "codigo":19191000119106,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE NERVIO PERIFÉRICO"
  },
  {
    "codigo":45891000175109,
    "descripcion":"VÍCTIMA DE TRABAJO FORZADO"
  },
  {
    "codigo":209685002,
    "descripcion":"SECCIÓN EXPUESTA DE LIGAMENTO DE DEDO DE LA MANO, ARTICULACIÓN INTERFALÁNGICA DISTAL, LIGAMENTO LATERAL RADIAL"
  },
  {
    "codigo":12551000132107,
    "descripcion":"NEUROPATÍA CRANEAL DEBIDA A HERPES ZÓSTER"
  },
  {
    "codigo":45845003,
    "descripcion":"HERNIA FEMORAL CON GANGRENA"
  },
  {
    "codigo":733973005,
    "descripcion":"CARIES DENTAL PRIMARIA INACTIVA QUE SE EXTIENDE HASTA LA DENTINA"
  },
  {
    "codigo":109546001,
    "descripcion":"FISURA DE PALADAR PRIMARIO"
  },
  {
    "codigo":240618002,
    "descripcion":"TIFUS DEL VIEJO MUNDO"
  },
  {
    "codigo":1354730006,
    "descripcion":"FRACTURA DE QUINTA COSTILLA"
  },
  {
    "codigo":271551002,
    "descripcion":"COME ALIMENTOS PRECOCIDOS"
  },
  {
    "codigo":304319005,
    "descripcion":"AMPLITUD DE MOVIMIENTO DE LA RODILLA NORMAL"
  },
  {
    "codigo":402623006,
    "descripcion":"HIPOMELANOSIS ALREDEDOR DE NEOPLASIA MELANOCÍTICA"
  },
  {
    "codigo":238783008,
    "descripcion":"ERUPCIÓN PURPÚRICA PIGMENTADA FAMILIAR"
  },
  {
    "codigo":1187220002,
    "descripcion":"TRASTORNO CAUSADO POR COCAÍNA"
  },
  {
    "codigo":73108003,
    "descripcion":"INTOXICACIÓN POR TRIFLUPERIDOL"
  },
  {
    "codigo":12198801000119106,
    "descripcion":"DISLOCACIÓN DE ARTICULACIÓN PROTÉSICA DE CODO IZQUIERDO"
  },
  {
    "codigo":11789201000119106,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO DE DEDO ÍNDICE DE MANO IZQUIERDA"
  },
  {
    "codigo":890473000,
    "descripcion":"INGESTA EXCESIVA DE FÓSFORO"
  },
  {
    "codigo":15639441000119107,
    "descripcion":"CATARATA SUBCAPSULAR POSTERIOR DE OJO IZQUIERDO"
  },
  {
    "codigo":366185007,
    "descripcion":"HALLAZGO RELACIONADO CON EL VOLUMEN DE LOS RUIDOS CARDÍACOS"
  },
  {
    "codigo":320401000119108,
    "descripcion":"ARTROSIS SECUNDARIA DE HOMBRO DERECHO"
  },
  {
    "codigo":300649009,
    "descripcion":"NO CONDUCE UNA BICICLETA"
  },
  {
    "codigo":3902000,
    "descripcion":"NEUTROPENIA MEDICAMENTOSA, NO RELACIONADA CON LA DOSIS"
  },
  {
    "codigo":724798003,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO MEDIANO EN LA MANO"
  },
  {
    "codigo":1148947003,
    "descripcion":"INGESTA EXCESIVA DE CLORURO"
  },
  {
    "codigo":788499005,
    "descripcion":"ECCEMA DE MIEMBRO INFERIOR"
  },
  {
    "codigo":44671000087102,
    "descripcion":"MYCOBACTERIUM GASTRI O MYCOBACTERIUM KANSASII"
  },
  {
    "codigo":722963007,
    "descripcion":"SÍNDROME DE PIERNAS INQUIETAS SECUNDARIO"
  },
  {
    "codigo":231443008,
    "descripcion":"TRASTORNO AFECTIVO ORGÁNICO DEL HEMISFERIO DERECHO"
  },
  {
    "codigo":33000001,
    "descripcion":"ATROFIA DE CONDUCTO DEFERENTE"
  },
  {
    "codigo":47231000087106,
    "descripcion":"DISTENSIÓN DE TENDÓN DE EXTREMIDAD SUPERIOR DERECHA"
  },
  {
    "codigo":295144003,
    "descripcion":"SOBREDOSIS DE FENAZOCINA"
  },
  {
    "codigo":196840002,
    "descripcion":"HERNIA CRURAL IRREDUCTIBLE BILATERAL"
  },
  {
    "codigo":39551000087109,
    "descripcion":"FRACTURA DE CÓNDILO MEDIAL DE TIBIA DERECHA"
  },
  {
    "codigo":349381000119100,
    "descripcion":"NEOPLASIA BENIGNA DE COROIDES IZQUIERDA"
  },
  {
    "codigo":65768009,
    "descripcion":"SÍNDROME DE DEFICIENCIA DA FACTOR MÚLTIPLE FAMILIAR, TIPO II"
  },
  {
    "codigo":719293005,
    "descripcion":"OSCILACIÓN DE LÍQUIDO DE DRENAJE TORÁCICO"
  },
  {
    "codigo":293309006,
    "descripcion":"REACCIÓN ADVERSA A GELATINA"
  },
  {
    "codigo":62098001,
    "descripcion":"CABEZA FETAL NO ENCAJADA"
  },
  {
    "codigo":195005009,
    "descripcion":"VALVULOPATÍAS MITRAL, AÓRTICA Y TRICUSPÍDEA COMBINADAS"
  },
  {
    "codigo":1340050003,
    "descripcion":"TUMOR GLÓMICO BENIGNO FAMILIAR DE PIEL"
  },
  {
    "codigo":29330004,
    "descripcion":"CÓLICO SALIVAL"
  },
  {
    "codigo":94866003,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL ÁNGULO HEPÁTICO DEL COLON"
  },
  {
    "codigo":291474007,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR KANAMICINA"
  },
  {
    "codigo":224103000,
    "descripcion":"MIEMBRO DE FAMILIA ADOPTIVA"
  },
  {
    "codigo":225938009,
    "descripcion":"CON MAYOR RIESGO DE SER ESCALDADO"
  },
  {
    "codigo":289639003,
    "descripcion":"HALLAZGO RELACIONADO CON LA CONSISTENCIA DEL ÚTERO"
  },
  {
    "codigo":93031005,
    "descripcion":"ATRESIA DE VENA CAVA INFERIOR"
  },
  {
    "codigo":781159007,
    "descripcion":"LEVORROTACIÓN CONGÉNITA DEL CORAZÓN"
  },
  {
    "codigo":1010535009,
    "descripcion":"ESCLEROSIS DE EPÍFISIS DE FALANGE PROXIMAL DE QUINTO DEDO DE PIE CON RADIOPACIDAD AUMENTADA"
  },
  {
    "codigo":123964001,
    "descripcion":"UROPORFIRINURIA"
  },
  {
    "codigo":255036008,
    "descripcion":"ADENOMA SUPRARRENAL"
  },
  {
    "codigo":1071841000000108,
    "descripcion":"NO SE LEVANTA DE LA CAMA SIN ASISTENCIA"
  },
  {
    "codigo":285969004,
    "descripcion":"DIFICULTAD PARA HACER CORRER EL AGUA DEL INODORO"
  },
  {
    "codigo":449809008,
    "descripcion":"LACERACIÓN PERINEAL DE TERCER GRADO, TIPO 3C"
  },
  {
    "codigo":16051551000119103,
    "descripcion":"ARTROPATÍA DE RODILLA IZQUIERDA POR SÍNDROME DE BEHCET"
  },
  {
    "codigo":446139000,
    "descripcion":"LACERACIÓN DE TENDÓN DE PIE"
  },
  {
    "codigo":52923004,
    "descripcion":"AEROMOZO EN ACCIDENTE AÉREO"
  },
  {
    "codigo":282299006,
    "descripcion":"INCAPAZ DE MANTENER EL EQUILIBRIO"
  },
  {
    "codigo":216763006,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR MOLUSCOS"
  },
  {
    "codigo":20155007,
    "descripcion":"ACIDURIA ORÓTICA SECUNDARIA"
  },
  {
    "codigo":249531009,
    "descripcion":"ESPASMO INTESTINAL"
  },
  {
    "codigo":870288002,
    "descripcion":"PARKINSONISMO CAUSADO POR METANOL"
  },
  {
    "codigo":771984002,
    "descripcion":"CON MAYOR RIESGO DE MALTRATO EMOCIONAL"
  },
  {
    "codigo":247696001,
    "descripcion":"DELIRIO DEL PROPIO ASPECTO"
  },
  {
    "codigo":409701001,
    "descripcion":"ENFERMEDAD BIFÁSICA"
  },
  {
    "codigo":16485001,
    "descripcion":"ÚLCERA DE AMÍGDALA"
  },
  {
    "codigo":213093001,
    "descripcion":"RUPTURA DE TORNILLO ÓSEO"
  },
  {
    "codigo":737381004,
    "descripcion":"ESTADIO CLÍNICO 4 DE INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA DE LA ORGANIZACIÓN MUNDIAL DE LA SALUD DE 2007"
  },
  {
    "codigo":278629006,
    "descripcion":"PRÓTESIS MAXILOFACIAL FLOJA"
  },
  {
    "codigo":132601000119102,
    "descripcion":"TROMBOSIS VENOSA PROFUNDA AGUDA DE VENA PÉLVICA"
  },
  {
    "codigo":735546001,
    "descripcion":"TRASTORNO DISOCIATIVO CON SÍNTOMA NEUROLÓGICO CON SÍNTOMA DEGLUTORIO"
  },
  {
    "codigo":12815001,
    "descripcion":"INTOXICACIÓN POR LIDOCAÍNA"
  },
  {
    "codigo":211258009,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE ANTEBRAZO"
  },
  {
    "codigo":276794009,
    "descripcion":"HIPERTENSIÓN PULMONAR FACULTATIVA CON DERIVACIÓN A NIVEL AURICULAR"
  },
  {
    "codigo":307727005,
    "descripcion":"FRACTURA EXPUESTA DEL PERONÉ DISTAL"
  },
  {
    "codigo":45583009,
    "descripcion":"CONTRACCIÓN PÉLVICA RENAL"
  },
  {
    "codigo":305892004,
    "descripcion":"VISTO POR EL SERVICIO DE CIRUGÍA DE MANO"
  },
  {
    "codigo":11820691000119100,
    "descripcion":"INESTABILIDAD MULTIDIRECCIONAL DE ARTICULACIÓN ESCAPULOHUMERAL DERECHA"
  },
  {
    "codigo":679571000119100,
    "descripcion":"OSTEOMIELITIS DE AMBAS ÓRBITAS OCULARES"
  },
  {
    "codigo":109284008,
    "descripcion":"MELANOMA IN SITU DEL TRONCO"
  },
  {
    "codigo":1471801000168105,
    "descripcion":"SUBEMPLEADO"
  },
  {
    "codigo":402361002,
    "descripcion":"DISTROFIA UNGUEAL DEBIDA A ENFERMEDAD DE INJERTO VERSUS HUÉSPED"
  },
  {
    "codigo":240356009,
    "descripcion":"INFECCIÓN DEL TRACTO GASTROINTESTINAL CON ESCHERICHIA COLI ENTEROADHERENTE"
  },
  {
    "codigo":1156025000,
    "descripcion":"NIVEL SÉRICO DE DIGOXINA DENTRO DEL RANGO TERAPÉUTICO"
  },
  {
    "codigo":238521005,
    "descripcion":"FITOFOTODERMATITIS"
  },
  {
    "codigo":72846000,
    "descripcion":"EDAD GESTACIONAL, 14 SEMANAS"
  },
  {
    "codigo":15697401000119109,
    "descripcion":"ABSCESO SUBPERIÓSTICO DE AMBAS ÓRBITAS"
  },
  {
    "codigo":236686004,
    "descripcion":"FÍSTULA URETRAL ESQUISTOSOMIÁSICA"
  },
  {
    "codigo":302222008,
    "descripcion":"FRACTURA NO EXPUESTA DE CODO"
  },
  {
    "codigo":1285262009,
    "descripcion":"RANGO PASIVO DE DORSIFLEXIÓN DE TOBILLO DISMINUIDO"
  },
  {
    "codigo":726371001,
    "descripcion":"DELECIÓN DE PARTE DEL CROMOSOMA 4"
  },
  {
    "codigo":267619000,
    "descripcion":"UVEÍTIS ANTERIOR NO INFECCIOSA"
  },
  {
    "codigo":38243003,
    "descripcion":"INFECCIÓN CAUSADA POR EUPARYPHIUM"
  },
  {
    "codigo":71011005,
    "descripcion":"INFESTACIÓN CAUSADA POR PHTHIRUS PUBIS"
  },
  {
    "codigo":365923008,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA TOMAR DECISIONES"
  },
  {
    "codigo":202083009,
    "descripcion":"QUISTE DEL MENISCO INTERNO"
  },
  {
    "codigo":3640000,
    "descripcion":"EFECTO TARDÍO DE UNA AMPUTACIÓN TRAUMÁTICA"
  },
  {
    "codigo":724536000,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE ÍLEON"
  },
  {
    "codigo":440791000124100,
    "descripcion":"INGESTA INADECUADA DE MAGNESIO"
  },
  {
    "codigo":471000124104,
    "descripcion":"AUMENTO DE TIEMPO DE SESIÓN DE HEMODIÁLISIS"
  },
  {
    "codigo":427789001,
    "descripcion":"MIOCLONÍA DEL MÚSCULO TENSOR DEL TÍMPANO"
  },
  {
    "codigo":395021002,
    "descripcion":"UTILIZA SISTEMA DE DOSIS CONTROLADA"
  },
  {
    "codigo":722701000,
    "descripcion":"HERIDA PUNZANTE DE CABEZA CON CUERPO EXTRAÑO"
  },
  {
    "codigo":471511000124109,
    "descripcion":"HALLAZGO RELACIONADO CON LADO IZQUIERDO DEL CORAZÓN"
  },
  {
    "codigo":67341007,
    "descripcion":"DEFICIENCIA LONGITUDINAL DE EXTREMIDAD"
  },
  {
    "codigo":165645009,
    "descripcion":"VITAMINA B12 SÉRICA POR DEBAJO DE RANGO DE REFERENCIA"
  },
  {
    "codigo":360418002,
    "descripcion":"ATROFIA MACULAR PERIFOLICULAR"
  },
  {
    "codigo":296717009,
    "descripcion":"SOBREDOSIS DE CEFTIZOXIMA"
  },
  {
    "codigo":131042008,
    "descripcion":"HORMONA CORTICOSUPRARRENAL ANORMAL"
  },
  {
    "codigo":196578009,
    "descripcion":"ENFERMEDAD DE CROHN DE PARTES BLANDAS OROFACIALES"
  },
  {
    "codigo":260279004,
    "descripcion":"VISIÓN A DISTANCIA 3\/4"
  },
  {
    "codigo":293047005,
    "descripcion":"REACCIÓN ADVERSA AL GRUPO DE TETRACICLINAS"
  },
  {
    "codigo":717196000,
    "descripcion":"ACINETOBACTER ALCALIGENES O ACINETOBACTER LWOFFII"
  },
  {
    "codigo":291212001,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR DECANOATO DE FLUPENTIXOL"
  },
  {
    "codigo":94604000,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL ÁNGULO ESPLÉNICO DEL COLON"
  },
  {
    "codigo":387681000,
    "descripcion":"VULVITIS EROSIVA"
  },
  {
    "codigo":289377000,
    "descripcion":"NIVEL -5 DE LA PRESENTACIÓN EN RELACIÓN CON LAS ESPINAS ISQUIÁTICAS"
  },
  {
    "codigo":127372009,
    "descripcion":"NOVENO EMBARAZO"
  },
  {
    "codigo":16027591000119101,
    "descripcion":"EXOSTOSIS DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":92769003,
    "descripcion":"CARCINOMA IN SITU DE LA LENGUA"
  },
  {
    "codigo":60001007,
    "descripcion":"ESTADO DE NO EMBARAZO"
  },
  {
    "codigo":713526000,
    "descripcion":"NEUMONÍA BACTERIANA RECURRENTE CONCOMITANTE CON INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":254774003,
    "descripcion":"SÍNDROME DE COBB"
  },
  {
    "codigo":1303350009,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO INTRÍNSECO DE DEDO ANULAR DE MANO"
  },
  {
    "codigo":89099002,
    "descripcion":"BRONQUITIS ALÉRGICA CRÓNICA"
  },
  {
    "codigo":298951000119104,
    "descripcion":"GOTA DE VÉRTEBRA DEBIDA A DISFUNCIÓN RENAL"
  },
  {
    "codigo":1137675004,
    "descripcion":"SÍNDROME DE ESTRÉS POR REUBICACIÓN"
  },
  {
    "codigo":414944000,
    "descripcion":"FRACTURA EXPUESTA, DESPLAZADA, DE HUESO NASAL"
  },
  {
    "codigo":449547009,
    "descripcion":"ARTERIA PULMONAR DERECHA CON CONEXIÓN ARTERIAL PROXIMAL AUSENTE"
  },
  {
    "codigo":10948551000119106,
    "descripcion":"HERIDA POR ARMA BLANCA DE MANO DERECHA"
  },
  {
    "codigo":447712006,
    "descripcion":"MELANOMA MALIGNO DE PIEL DEL ANO"
  },
  {
    "codigo":283872008,
    "descripcion":"PÉRDIDA DEL TERCIO EXTERNO DE LA CEJA"
  },
  {
    "codigo":249269000,
    "descripcion":"ESMEGMA REPULSIVO"
  },
  {
    "codigo":282037001,
    "descripcion":"AUSENCIA DE PABELLÓN AURICULAR"
  },
  {
    "codigo":52661003,
    "descripcion":"PROCESO REUMATOIDEO EXTRARTICULAR"
  },
  {
    "codigo":773557002,
    "descripcion":"SÍNDROME DE DISOSTOSIS MANDIBULOFACIAL, MACROBLÉFARON Y MACROSTOMÍA"
  },
  {
    "codigo":183733000,
    "descripcion":"CONSULTA DOMICILIARIA DE CIRUGÍA ORAL SOLICITADA"
  },
  {
    "codigo":246963006,
    "descripcion":"PÉRDIDA DEL ESTROMA PERIFÉRICO DE LA CÓRNEA"
  },
  {
    "codigo":216501008,
    "descripcion":"INTOXICACIÓN ACCIDENTAL CAUSADA POR PENTOBARBITAL"
  },
  {
    "codigo":413109009,
    "descripcion":"MEDICACIÓN NEUROLÉPTICA ADECUADA"
  },
  {
    "codigo":354401000119103,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE GLÁNDULA LAGRIMAL DERECHA"
  },
  {
    "codigo":11823201000119103,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE REGIÓN DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":18058007,
    "descripcion":"FLEBITIS DE SENO VENOSO INTRACRANEAL"
  },
  {
    "codigo":444042007,
    "descripcion":"FATIGA EXCESIVA LUEGO DE ESFUERZO"
  },
  {
    "codigo":247434009,
    "descripcion":"ARRUGA DE LA PIEL"
  },
  {
    "codigo":1197706007,
    "descripcion":"GASTRITIS POR VASCULITIS"
  },
  {
    "codigo":704351003,
    "descripcion":"CON MAYOR RIESGO DE AFRONTAMIENTO FAMILIAR INEFECTIVO"
  },
  {
    "codigo":1091681000119104,
    "descripcion":"INFLAMACIÓN DE MASTOIDES DERECHA"
  },
  {
    "codigo":1163103000,
    "descripcion":"ENCEFALITIS POR LISAVIRUS DEL MURCIÉLAGO AUSTRALIANO"
  },
  {
    "codigo":16223008,
    "descripcion":"QUEMADURA DE REGIÓN ESCAPULAR"
  },
  {
    "codigo":1359711009,
    "descripcion":"DISPLASIA UNGUEAL"
  },
  {
    "codigo":15673441000119106,
    "descripcion":"NÓDULO REUMATOIDEO DE AMBOS TOBILLOS"
  },
  {
    "codigo":276532007,
    "descripcion":"SÍNDROME DE AVERY, TIPO 2"
  },
  {
    "codigo":767289441000119108,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE ESCLERÓTICA DE OJO DERECHO"
  },
  {
    "codigo":241929008,
    "descripcion":"REACCIÓN ALÉRGICA AGUDA"
  },
  {
    "codigo":895454001,
    "descripcion":"LIQUEN ESCLEROSO"
  },
  {
    "codigo":10718002,
    "descripcion":"MIXEDEMA JUVENIL"
  },
  {
    "codigo":43486001,
    "descripcion":"PARÁLISIS CEREBRAL HEMIPLÉJICA"
  },
  {
    "codigo":373001009,
    "descripcion":"INFECCIÓN CAUSADA POR ASPERGILLUS SYDOWI"
  },
  {
    "codigo":1255902005,
    "descripcion":"LINFOMA DE HODGKIN DE GANGLIOS LINFÁTICOS DE MIEMBRO INFERIOR"
  },
  {
    "codigo":403934004,
    "descripcion":"SIRINGOMA DE CÉLULAS CLARAS"
  },
  {
    "codigo":405769009,
    "descripcion":"SÍNDROME DE KLINEFELTER, XXY"
  },
  {
    "codigo":305630008,
    "descripcion":"ATENDIDO POR UN HIPNOTERAPEUTA"
  },
  {
    "codigo":698846009,
    "descripcion":"DISTROFIA DE MÚSCULO TIBIAL"
  },
  {
    "codigo":11831321000119100,
    "descripcion":"LESIÓN TRAUMÁTICA DE VENA DORSAL DE PIE IZQUIERDO"
  },
  {
    "codigo":29721000119101,
    "descripcion":"ANEURISMA DE ARTERIA PERIFÉRICA"
  },
  {
    "codigo":111641000119102,
    "descripcion":"QUISTE CONGÉNITO DE PLEXO COROIDEO"
  },
  {
    "codigo":306201000119103,
    "descripcion":"GOTA CRÓNICA DE CADERA, SIN TOFO, CAUSADA POR FÁRMACO"
  },
  {
    "codigo":1079321000119104,
    "descripcion":"NEOPLASIA BENIGNA DE OMÓPLATO DERECHO"
  },
  {
    "codigo":15684121000119104,
    "descripcion":"INFLAMACIÓN DE PERIOSTIO DE PIERNA DERECHA"
  },
  {
    "codigo":203656000,
    "descripcion":"CIFOSIS NEUROMUSCULAR"
  },
  {
    "codigo":1089561000119107,
    "descripcion":"OTALGIA DE OÍDO IZQUIERDO, DERIVADA"
  },
  {
    "codigo":15735321000119104,
    "descripcion":"TRASTORNO DE VASO SANGUÍNEO DE RETINA DE OJO IZQUIERDO"
  },
  {
    "codigo":690201000119109,
    "descripcion":"ATAXIA DEBIDA A ACCIDENTE CEREBROVASCULAR EMBÓLICO Y POSTERIOR A ÉL"
  },
  {
    "codigo":10761241000119104,
    "descripcion":"TRABAJO DE PARTO PRETÉRMINO CON PARTO PRETÉRMINO"
  },
  {
    "codigo":10953241000119103,
    "descripcion":"HERIDA ABIERTA DE DEDO ÍNDICE IZQUIERDO DEBIDA A MORDEDURA DE GATO"
  },
  {
    "codigo":15663641000119104,
    "descripcion":"CONJUNTIVITIS HEMORRÁGICA AGUDA DE OJO DERECHO"
  },
  {
    "codigo":1186696002,
    "descripcion":"AMBIENTE PELIGROSO"
  },
  {
    "codigo":301960005,
    "descripcion":"PAPILA ÓPTICA ANORMAL"
  },
  {
    "codigo":1217629000,
    "descripcion":"DEFORMIDAD CONGÉNITA ÓSEA Y DE PARTES BLANDAS DE ÓRBITA"
  },
  {
    "codigo":37981002,
    "descripcion":"ASPERGILOSIS BRONCOPULMONAR ALÉRGICA"
  },
  {
    "codigo":234589002,
    "descripcion":"DEFICIENCIA DE GLUTATIÓN SINTASA"
  },
  {
    "codigo":12199961000119109,
    "descripcion":"INFECCIÓN ASOCIADA CON PRÓTESIS ARTICULAR DE CADERA IZQUIERDA"
  },
  {
    "codigo":236424009,
    "descripcion":"DISFUNCIÓN RENAL AGUDA"
  },
  {
    "codigo":300125005,
    "descripcion":"CONDUCTO AUDITIVO PEQUEÑO"
  },
  {
    "codigo":298290001,
    "descripcion":"DOLOR A LA PALPACIÓN EN INSERCIÓN MUSCULAR"
  },
  {
    "codigo":429362002,
    "descripcion":"BAJA ESTATURA ASOCIADA CON TRASPLANTE DE MÉDULA ÓSEA"
  },
  {
    "codigo":365661009,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA RECONOCER LOS DEDOS DE SUS MANOS"
  },
  {
    "codigo":68914007,
    "descripcion":"VÓLVULO MESENTEROAXIAL CONGÉNITO DE ESTÓMAGO"
  },
  {
    "codigo":724274009,
    "descripcion":"EPILEPSIA INFANTIL CON CRISIS FOCALES MIGRATORIAS"
  },
  {
    "codigo":722439009,
    "descripcion":"SÍNDROME DE DISTROFIA ENDOTELIAL, HIPOPLASIA DE IRIS, CATARATA CONGÉNITA Y ADELGAZAMIENTO DEL ESTROMA"
  },
  {
    "codigo":10678831000119100,
    "descripcion":"TUMEFACCIÓN LOCALIZADA DE DEDO DE LA MANO IZQUIERDA"
  },
  {
    "codigo":294620008,
    "descripcion":"ALERGIA A BENZOATO DE BENCILO"
  },
  {
    "codigo":720604008,
    "descripcion":"POLIPOSIS CON CAPUCHÓN"
  },
  {
    "codigo":292785006,
    "descripcion":"REACCIÓN ADVERSA A LA PARAFINA BLANDA BLANCA"
  },
  {
    "codigo":718769009,
    "descripcion":"ATAXIA ESPINOCEREBELOSA TIPO 26"
  },
  {
    "codigo":127110002,
    "descripcion":"LINFADENOPATÍA MEDIASTÍNICA POSTERIOR"
  },
  {
    "codigo":128945009,
    "descripcion":"INFECCIÓN CAUSADA POR ENTEROBACTERIACEAE"
  },
  {
    "codigo":61574004,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA VENA RADIAL"
  },
  {
    "codigo":94342002,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA CARA INTERNA DE LABIO INFERIOR"
  },
  {
    "codigo":92507001,
    "descripcion":"MORDIDA EN CRUZ BUCAL"
  },
  {
    "codigo":16003631000119104,
    "descripcion":"TENDINITIS BILATERAL DE MANGUITOS ROTADORES"
  },
  {
    "codigo":715099005,
    "descripcion":"DIFICULTAD PARA PASAR DE LA SILLA DE RUEDAS A LA SILLA"
  },
  {
    "codigo":289115009,
    "descripcion":"NO TOSE"
  },
  {
    "codigo":188976006,
    "descripcion":"NEOPLASIA BENIGNA DE HUESO NAVICULAR DE PIE"
  },
  {
    "codigo":254512009,
    "descripcion":"TUMOR DE LA COMISURA POSTERIOR"
  },
  {
    "codigo":25136009,
    "descripcion":"MARCHA ATÁXICA"
  },
  {
    "codigo":1268485001,
    "descripcion":"NEOPLASIA DE CÉLULAS GERMINALES NO SEMINOMATOSO PRIMARIO DE TESTÍCULO"
  },
  {
    "codigo":1137413005,
    "descripcion":"DEBILIDAD DE MÚSCULO PERONEO"
  },
  {
    "codigo":88837005,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA ARTERIA PULMONAR"
  },
  {
    "codigo":11825711000119108,
    "descripcion":"LACERACIÓN DE TENDÓN DE LA MANO IZQUIERDA"
  },
  {
    "codigo":15731401000119102,
    "descripcion":"PAPILEDEMA DE AMBOS OJOS DEBIDO A PRESIÓN INTRAOCULAR POR DEBAJO DE RANGO DE REFERENCIA"
  },
  {
    "codigo":285445009,
    "descripcion":"NO MUEVE LA MANDÍBULA"
  },
  {
    "codigo":29231000119109,
    "descripcion":"VÍCTIMA ADULTA DE ABUSO SEXUAL EXTRAFAMILIAR"
  },
  {
    "codigo":15649481000119103,
    "descripcion":"ANEURISMA DE ARTERIA FEMORAL IZQUIERDA"
  },
  {
    "codigo":283610006,
    "descripcion":"HERIDA POR PINCHAZO DE AGUJA EN EL HOMBRO"
  },
  {
    "codigo":185306004,
    "descripcion":"ATENDIDO POR AUDIÓLOGO"
  },
  {
    "codigo":216239004,
    "descripcion":"INTOXICACIÓN POR MONÓXIDO DE CARBONO DE AERONAVE EN TRÁNSITO, SIN ACCIDENTE DE AERONAVE, VIAJERO DE AERONAVE COMERCIAL EN TRANSPORTE DESDE TIERRA Y MAR AL AIRE LESIONADO"
  },
  {
    "codigo":773295006,
    "descripcion":"PARONIQUIA DE DEDO DEL PIE DERECHO POR UÑA ENCARNADA"
  },
  {
    "codigo":609455009,
    "descripcion":"INTERRUPCIÓN INDUCIDA DEL EMBARAZO COMPLICADA POR INSUFICIENCIA RENAL AGUDA"
  },
  {
    "codigo":17796002,
    "descripcion":"DERMATOSIS ACANTOLÍTICA TRANSITORIA"
  },
  {
    "codigo":871599009,
    "descripcion":"VENTRÍCULO DERECHO CON DOBLE SALIDA CON DEFECTO SUBAÓRTICO O DEFECTO CON DOBLE COMPROMISO DE TABIQUE VENTRICULAR Y ESTENOSIS PULMONAR TIPO FALLOT"
  },
  {
    "codigo":247172005,
    "descripcion":"DESGARRO MACULAR RETINIANO"
  },
  {
    "codigo":704089001,
    "descripcion":"ATENDIDO POR SERVICIO DE CIRUGÍA DE COLUMNA VERTEBRAL"
  },
  {
    "codigo":48729005,
    "descripcion":"HEMORRAGIA GASTROINTESTINAL PERINATAL"
  },
  {
    "codigo":12208841000119108,
    "descripcion":"OSTEÓLISIS DE HUESO ADYACENTE A PRÓTESIS DE ARTICULACIÓN DE RODILLA DERECHA"
  },
  {
    "codigo":441945008,
    "descripcion":"TROMBOFILIA DEBIDA A TRAUMATISMO"
  },
  {
    "codigo":210734002,
    "descripcion":"HERIDA ABIERTA DEL (DE LOS) DEDO(S) DEL PIE CON DAÑO UNGUEAL"
  },
  {
    "codigo":16769891000119103,
    "descripcion":"FRACTURA NO EXPUESTA DE COLUMNA ANTERIOR DE ACETÁBULO IZQUIERDO"
  },
  {
    "codigo":1259310006,
    "descripcion":"CARCINOMA PRIMARIO DE COLA DE PÁNCREAS"
  },
  {
    "codigo":866094007,
    "descripcion":"NEOPLASIA MALIGNA DE VAINA DE NERVIO PERIFÉRICO DE PELVIS"
  },
  {
    "codigo":833326008,
    "descripcion":"DEMENCIA VASCULAR CORTICAL"
  },
  {
    "codigo":46894009,
    "descripcion":"DIABETES MELLITUS GESTACIONAL CLASE A2"
  },
  {
    "codigo":14126008,
    "descripcion":"ANEMIA SIDEROBLÁSTICA AUTOSÓMICA REFRACTARIA A PIRIDOXINA"
  },
  {
    "codigo":77827005,
    "descripcion":"OSTEOCONDROSIS JUVENIL DEL QUINTO HUESO METATARSIANO"
  },
  {
    "codigo":700419006,
    "descripcion":"REQUIERE VACUNACIÓN ANTIRRUBEÓLICA"
  },
  {
    "codigo":303971000119105,
    "descripcion":"GOTA CRÓNICA DE RODILLA SIN TOFO DEBIDA A DISFUNCIÓN RENAL"
  },
  {
    "codigo":733187009,
    "descripcion":"OSTEÓLISIS POSTERIOR A PROCEDIMIENTO QUIRÚRGICO EN EL SISTEMA ESQUELÉTICO"
  },
  {
    "codigo":1255640005,
    "descripcion":"MÚLTIPLES RUPTURAS DE RETINA CON RETINOSQUISIS"
  },
  {
    "codigo":403672006,
    "descripcion":"CUTIS LAXA INDUCIDA POR FÁRMACOS"
  },
  {
    "codigo":239832006,
    "descripcion":"ENFERMEDAD POR DEPÓSITO DE PIROFOSFATO DE CALCIO"
  },
  {
    "codigo":698584008,
    "descripcion":"HEMORRAGIA POSOPERATORIA DE HERIDA"
  },
  {
    "codigo":687101000119100,
    "descripcion":"NEUROFIBROMA DE MANO"
  },
  {
    "codigo":237997005,
    "descripcion":"DEFICIENCIA DE DESHIDROGENASA ACIL-COA DE CADENA MUY LARGA"
  },
  {
    "codigo":762285009,
    "descripcion":"REACCIÓN CUTÁNEA CAUSADA POR TOXINA BACTERIANA"
  },
  {
    "codigo":170626004,
    "descripcion":"TÉCNICA DE INHALACIÓN: MALA"
  },
  {
    "codigo":398167001,
    "descripcion":"MALESTAR DEL ANESTESIÓLOGO"
  },
  {
    "codigo":430935001,
    "descripcion":"ÚLCERA CRÓNICA DE DEDO DEL PIE"
  },
  {
    "codigo":201559006,
    "descripcion":"ARTRITIS REACTIVA DE ARTICULACIÓN ESTERNOCLAVICULAR"
  },
  {
    "codigo":1217367007,
    "descripcion":"TRASTORNO DE NEURODESARROLLO ASOCIADO A GEN PLAA"
  },
  {
    "codigo":299863007,
    "descripcion":"REFLEJO ANAL AUSENTE"
  },
  {
    "codigo":267095009,
    "descripcion":"PROBLEMA DE DISCURSO"
  },
  {
    "codigo":429100002,
    "descripcion":"SUPRESIÓN DE CONSONANTE FINAL"
  },
  {
    "codigo":365399009,
    "descripcion":"HALLAZGO RELACIONADO CON LA SUFICIENCIA DE LA DIÁLISIS"
  },
  {
    "codigo":396332003,
    "descripcion":"REUMATISMO"
  },
  {
    "codigo":4951008,
    "descripcion":"ASTENOPÍA NERVIOSA"
  },
  {
    "codigo":87191000119100,
    "descripcion":"GANGLIOGLIOMA"
  },
  {
    "codigo":103255006,
    "descripcion":"MIRADA CONJUGADA"
  },
  {
    "codigo":285832001,
    "descripcion":"LESIÓN TRAUMÁTICA DEL CORDÓN ESPERMÁTICO"
  },
  {
    "codigo":166956002,
    "descripcion":"NIVEL TERAPÉUTICO DE LITIO"
  },
  {
    "codigo":296193003,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE DROPERIDOL"
  },
  {
    "codigo":230657007,
    "descripcion":"NEUROPATÍA SENSORIOMOTRIZ AXÓNICA"
  },
  {
    "codigo":1344769008,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE TENDÓN DE MÚSCULO BÍCEPS FEMORAL"
  },
  {
    "codigo":722177009,
    "descripcion":"DEPENDIENTE PARA BEBER"
  },
  {
    "codigo":294358002,
    "descripcion":"ALERGIA A TIOCONAZOL"
  },
  {
    "codigo":392662004,
    "descripcion":"ENCEFALITIS DEL NILO OCCIDENTAL"
  },
  {
    "codigo":95915001,
    "descripcion":"RESISTENCIA AUMENTADA A UN FÁRMACO"
  },
  {
    "codigo":332951000119104,
    "descripcion":"CICATRIZ CORIORRETINIANA DE OJO DERECHO POSTERIOR A CIRUGÍA"
  },
  {
    "codigo":423595004,
    "descripcion":"CARCINOMATOSIS POR ADENOCARCINOMA"
  },
  {
    "codigo":292523004,
    "descripcion":"REACCIÓN ADVERSA A FÁRMACO ANTIMUSCARÍNICO"
  },
  {
    "codigo":126848003,
    "descripcion":"NEOPLASIA DE LA UNIÓN RECTOSIGMOIDE"
  },
  {
    "codigo":1306496005,
    "descripcion":"CARCINOMA DUCTAL INFILTRANTE PRIMARIO DE CUADRANTE SUPERIOR EXTERNO DE MAMA IZQUIERDA"
  },
  {
    "codigo":94080006,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA SUPRAGLOTIS"
  },
  {
    "codigo":290688008,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR TIOGUANINA"
  },
  {
    "codigo":61312009,
    "descripcion":"INTOXICACIÓN POR PRUNUS VIRGINIANA"
  },
  {
    "codigo":142641000119101,
    "descripcion":"FRAGMENTO DE CUERPO EXTRAÑO RETENIDO DE VIDRIO"
  },
  {
    "codigo":288853006,
    "descripcion":"CAPAZ DE BEBER"
  },
  {
    "codigo":10654871000119108,
    "descripcion":"ÚLCERA ISQUÉMICA ATEROSCLERÓTICA DE PIE IZQUIERDO"
  },
  {
    "codigo":59477008,
    "descripcion":"PALABRAS ESTEREOTIPADAS"
  },
  {
    "codigo":254250002,
    "descripcion":"SÍNDROME DE COCAÍNA FETAL"
  },
  {
    "codigo":10900631000119109,
    "descripcion":"ENUCLEACIÓN TRAUMÁTICA DE OJO IZQUIERDO"
  },
  {
    "codigo":23039002,
    "descripcion":"FRACTURAS MÚLTIPLES DE LA EXTREMIDAD SUPERIOR, ESTERNÓN Y COSTILLAS"
  },
  {
    "codigo":285183003,
    "descripcion":"INCAPAZ DE RECONOCER SONIDOS DE ADVERTENCIA"
  },
  {
    "codigo":15707441000119104,
    "descripcion":"MIOSITIS OSIFICANTE TRAUMÁTICA DE PIERNAS BILATERALES"
  },
  {
    "codigo":711167005,
    "descripcion":"ENTERITIS CAUSADA POR YERSINIA ENTEROCOLITICA"
  },
  {
    "codigo":170163009,
    "descripcion":"EXAMEN A LOS 4.5 AÑOS: NORMAL"
  },
  {
    "codigo":55807009,
    "descripcion":"EXOFTALMOS DEBIDO A BOCIO TÓXICO DIFUSO"
  },
  {
    "codigo":53972003,
    "descripcion":"RUIDOS RESPIRATORIOS AGREGADOS"
  },
  {
    "codigo":447188008,
    "descripcion":"PULSO TIBIAL ANTERIOR MONOFÁSICO"
  },
  {
    "codigo":283348008,
    "descripcion":"PICADURA DE INSECTO INFECTADA EN EL DORSO DE LA MANO"
  },
  {
    "codigo":445353002,
    "descripcion":"DIABETES MELLITUS TIPO 2 LÁBIL"
  },
  {
    "codigo":183209007,
    "descripcion":"BOLSA DE COLOSTOMÍA CAMBIADA"
  },
  {
    "codigo":281513007,
    "descripcion":"FRACTURA-LUXACIÓN TRANSESCAFOIDEA-PERISEMILUNAR"
  },
  {
    "codigo":83070001,
    "descripcion":"AMPOLLA POR FRICCIÓN CON INFECCIÓN"
  },
  {
    "codigo":16745931000119102,
    "descripcion":"RETINOPATÍA NO PROLIFERATIVA LEVE BILATERAL DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":246910003,
    "descripcion":"GRANULOMA DE CONJUNTIVA PALPEBRAL"
  },
  {
    "codigo":1197182004,
    "descripcion":"MÁCULA MELANÓTICA DE MUCOSA GINGIVAL"
  },
  {
    "codigo":115838005,
    "descripcion":"FENOTIPO KELL>NULO<"
  },
  {
    "codigo":312446008,
    "descripcion":"TRASTORNO COITAL FEMENINO"
  },
  {
    "codigo":277843001,
    "descripcion":"PROBLEMA DE CONDUCTA"
  },
  {
    "codigo":1162579000,
    "descripcion":"DISMOTILIDAD ESOFÁGICA POSTERIOR A CIRUGÍA BARIÁTRICA"
  },
  {
    "codigo":15699003,
    "descripcion":"DIARREA SECRETORA"
  },
  {
    "codigo":212307006,
    "descripcion":"LESIÓN DEL NERVIO SENSORIAL CUTÁNEO A NIVEL DEL ANTEBRAZO"
  },
  {
    "codigo":441683007,
    "descripcion":"MASA DE MUÑECA"
  },
  {
    "codigo":439848005,
    "descripcion":"HISTORIA CLÍNICA VERIFICADA POR EL SUJETO"
  },
  {
    "codigo":1259048007,
    "descripcion":"LESIÓN DE PLEXO BRAQUIAL DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":274173003,
    "descripcion":"LACERACIÓN DEL PULGAR"
  },
  {
    "codigo":306941004,
    "descripcion":"SECRECIÓN EN MEATO INFERIOR"
  },
  {
    "codigo":110333006,
    "descripcion":"MORFOLOGÍA ANORMAL DE LA RAÍZ DENTAL"
  },
  {
    "codigo":372477008,
    "descripcion":"SIRINGOMIELIA POSTRAUMÁTICA"
  },
  {
    "codigo":335461000119102,
    "descripcion":"AMBLIOPÍA POR DEPRIVACIÓN DE OJO DERECHO"
  },
  {
    "codigo":208637008,
    "descripcion":"FRACTURA EXPUESTA DE TIBIA DISTAL"
  },
  {
    "codigo":403410004,
    "descripcion":"MIOFIBROMATOSIS INFANTIL MULTICÉNTRICA"
  },
  {
    "codigo":10194007,
    "descripcion":"ORQUITIS CRÓNICA"
  },
  {
    "codigo":75730008,
    "descripcion":"INTOXICACIÓN POR LINDANO"
  },
  {
    "codigo":237735008,
    "descripcion":"SÍNDROME DE CUSHING SUPRARRENAL"
  },
  {
    "codigo":204967008,
    "descripcion":"DEFECTOS OBSTRUCTIVOS DEL URÉTER Y DE LA PELVIS RENAL"
  },
  {
    "codigo":235900003,
    "descripcion":"ESCLEROSIS DE LAS VENAS PORTA Y ESPLÉNICA"
  },
  {
    "codigo":268668003,
    "descripcion":"TRASTORNO DE LA NIÑEZ Y ADOLESCENCIA CON INTROVERSIÓN"
  },
  {
    "codigo":1153404003,
    "descripcion":"NEOPLASIA DE ESTROMA GASTROINTESTINAL DE ANTRO PILÓRICO DEL ESTÓMAGO"
  },
  {
    "codigo":399740008,
    "descripcion":"EXTENSIÓN DEL COMPROMISO TUMORAL NO ESPECIFICADO"
  },
  {
    "codigo":102993001,
    "descripcion":"DESVIACIÓN LATERAL PARA LA PRUEBA DE LA MARCHA EN LÍNEA RECTA CON LOS OJOS CERRADOS"
  },
  {
    "codigo":234065001,
    "descripcion":"ESTENOSIS DE LA VENA CAVA SUPERIOR"
  },
  {
    "codigo":365137003,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA LEVANTAR"
  },
  {
    "codigo":70225006,
    "descripcion":"HIPOTIROIDISMO DEBIDO A EXCESO DE YODO"
  },
  {
    "codigo":299601009,
    "descripcion":"AMPLITUD DE EXTENSIÓN PASIVA DE DEDO DEL PIE NORMAL"
  },
  {
    "codigo":789286003,
    "descripcion":"CHOQUE CAUSADO POR VENENO DE SERPIENTE"
  },
  {
    "codigo":68390005,
    "descripcion":"DEFICIENCIA DE PROTEÍNA 1 ACTIVADORA DE ESFINGOLÍPIDO"
  },
  {
    "codigo":363302008,
    "descripcion":"SECUELAS DE TRASTORNOS NEUROLÓGICOS"
  },
  {
    "codigo":232230009,
    "descripcion":"OTITIS EXTERNA MALIGNA CAUSADA POR PSEUDOMONAS AERUGINOSA"
  },
  {
    "codigo":197627003,
    "descripcion":"SÍNDROME DE HEMATURIA BENIGNA RECURRENTE"
  },
  {
    "codigo":308991000119104,
    "descripcion":"TENDINITIS CALCIFICANTE DE TOBILLO DERECHO"
  },
  {
    "codigo":263163006,
    "descripcion":"FRACTURA DE COMPLEJO CIGOMÁTICO"
  },
  {
    "codigo":230395007,
    "descripcion":"EPILEPSIA DE CORTEZA MOTORA SUPLEMENTARIA DE LÓBULO FRONTAL"
  },
  {
    "codigo":295931007,
    "descripcion":"SOBREDOSIS DE CITALOPRAM"
  },
  {
    "codigo":294096007,
    "descripcion":"ALERGIA A METILCISTEÍNA"
  },
  {
    "codigo":1176997000,
    "descripcion":"INFECCIÓN CUTÁNEA CAUSADA POR STAPHYLOCOCCUS AUREUS RESISTENTE A LA METICILINA"
  },
  {
    "codigo":128421002,
    "descripcion":"FASCITIS OSIFICANTE"
  },
  {
    "codigo":292261002,
    "descripcion":"REACCIÓN ADVERSA A LA FENTERMINA"
  },
  {
    "codigo":423333008,
    "descripcion":"EXANTEMA CAUSADO POR VARICELA"
  },
  {
    "codigo":95653008,
    "descripcion":"MIGRAÑA AGUDA CONFUSIONAL"
  },
  {
    "codigo":290426000,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR ANTAGONISTA DEL RECEPTOR DE 5-HT3"
  },
  {
    "codigo":126586003,
    "descripcion":"NEOPLASIA DE HUESO CORTO DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":93818001,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA CURVATURA MAYOR DEL ESTÓMAGO"
  },
  {
    "codigo":716410008,
    "descripcion":"CAPAZ DE DESENVOLVERSE EN UN AMBIENTE LABORAL"
  },
  {
    "codigo":288591000,
    "descripcion":"DIFICULTAD PARA EMPLEAR EL LENGUAJE CORPORAL"
  },
  {
    "codigo":419663003,
    "descripcion":"DISPOSITIVO PARA VÍA AÉREA PRESENTE"
  },
  {
    "codigo":286756000,
    "descripcion":"CARÁCTER IMPULSIVO"
  },
  {
    "codigo":24612001,
    "descripcion":"SIBILANCIAS - RONCUS"
  },
  {
    "codigo":1237028004,
    "descripcion":"CON RIESGO ELEVADO DE EXPOSICIÓN A VIRUS INFLUENZA"
  },
  {
    "codigo":415993000,
    "descripcion":"TRASTORNO DEL VENTRÍCULO CARDÍACO IZQUIERDO"
  },
  {
    "codigo":88313001,
    "descripcion":"ELEVACIÓN DE UNA COLONIA BACTERIANA, UMBILICADA"
  },
  {
    "codigo":284921006,
    "descripcion":"INCAPAZ DE USAR ORINAL"
  },
  {
    "codigo":15683481000119108,
    "descripcion":"BURSISITS DE AMBAS BOLSAS SEROSAS INTERMETATARSIANAS"
  },
  {
    "codigo":446926000,
    "descripcion":"ABSCESO TUBERCULOSO DE SACRO"
  },
  {
    "codigo":283086006,
    "descripcion":"ARAÑAZO DE DEDO DE LA MANO"
  },
  {
    "codigo":707235000,
    "descripcion":"MÚLTIPLES ABSCESOS GINGIVALES AGUDOS"
  },
  {
    "codigo":184782008,
    "descripcion":"TIENE PRESCRIPCIONES GRATUITAS - BAJOS INGRESOS"
  },
  {
    "codigo":838307002,
    "descripcion":"ATROFIA ÓPTICA AUTOSÓMICA DOMINANTE DE COMIENZO EN LA INFANCIA"
  },
  {
    "codigo":1075251000119104,
    "descripcion":"METATARSO ADUCTO IZQUIERDO ADQUIRIDO"
  },
  {
    "codigo":248483005,
    "descripcion":"TUMEFACCIÓN LOCALIZADA DE ÓRBITA"
  },
  {
    "codigo":51875005,
    "descripcion":"PERFORACIÓN GASTROINTESTINAL"
  },
  {
    "codigo":314019007,
    "descripcion":"TELANGIECTASIA YUXTAFOVEOLAR IDIOPÁTICA"
  },
  {
    "codigo":337971000119105,
    "descripcion":"RETINOPATÍA POR PREMATUREZ DE OJO IZQUIERDO, ETAPA 4 - DESPRENDIMIENTO SUBTOTAL DE RETINA"
  },
  {
    "codigo":836472001,
    "descripcion":"DEFORMACIÓN FUSIFORME DE DEDOS DE AMBAS MANOS DEBIDA A ARTRITIS REUMATOIDEA"
  },
  {
    "codigo":543303731000119106,
    "descripcion":"TRASTORNO DE MÚSCULO ESQUELÉTICO CAUSADO POR ESTATINA"
  },
  {
    "codigo":441421001,
    "descripcion":"MUTACIÓN HETEROCIGOTA DEL GEN G20210A DE PROTROMBINA"
  },
  {
    "codigo":16695501000119102,
    "descripcion":"FRACTURA NO EXPUESTA DE MITAD IZQUIERDA DE HUESO OCCIPITAL"
  },
  {
    "codigo":242978001,
    "descripcion":"LESIÓN CON PROPÓSITO DESCONOCIDO POR CAÍDA DESDE EDIFICIO ALTO"
  },
  {
    "codigo":111906006,
    "descripcion":"INFECCIÓN CAUSADA POR LEPTOSPHAERIA SENEGALENSIS"
  },
  {
    "codigo":208375001,
    "descripcion":"FRACTURA NO EXPUESTA DE MÚLTIPLES HUESOS DE CARPO"
  },
  {
    "codigo":77303001,
    "descripcion":"DELIRIO DE POBREZA"
  },
  {
    "codigo":11767005,
    "descripcion":"VÓMITO BILIOSO POSTERIOR A CIRUGÍA GASTROINTESTINAL"
  },
  {
    "codigo":403148000,
    "descripcion":"REACCIÓN BULLOSA POR PICADURA DE INSECTO"
  },
  {
    "codigo":1255116001,
    "descripcion":"SÍNDROME DE EHLERS-DANLOS MIOPÁTICO"
  },
  {
    "codigo":110071008,
    "descripcion":"AVULSIÓN DEL CUERO CABELLUDO"
  },
  {
    "codigo":370380004,
    "descripcion":"ECOGRAFÍA - HALLAZGO"
  },
  {
    "codigo":15958221000119106,
    "descripcion":"ADENOCARCINOMA METASTÁSICO DE RIÑÓN IZQUIERDO"
  },
  {
    "codigo":75468006,
    "descripcion":"ARTROPATÍA DE LA RODILLA Y\/O DEL PIE INDUCIDA POR CRISTALES"
  },
  {
    "codigo":1156812007,
    "descripcion":"NEOPLASIA MESENQUIMÁTICA MALIGNA DE APÉNDICE"
  },
  {
    "codigo":237473006,
    "descripcion":"RUPTURA DEL IMPLANTE MAMARIO"
  },
  {
    "codigo":401313006,
    "descripcion":"NEOPLASIA ANAL INTRAEPITELIAL GRADO I"
  },
  {
    "codigo":16669031000119102,
    "descripcion":"FRACTURA NO EXPUESTA DE PARED INTERNA DE ÓRBITA IZQUIERDA"
  },
  {
    "codigo":235638001,
    "descripcion":"DIVERTÍCULO POR PULSIÓN DE ESÓFAGO MEDIO"
  },
  {
    "codigo":301174002,
    "descripcion":"HALLAZGO RELACIONADO CON EL ASPECTO DE UNA VENA"
  },
  {
    "codigo":1251446004,
    "descripcion":"DEFICIENCIA DE NAD(P)HX DESHIDRATASA"
  },
  {
    "codigo":366710004,
    "descripcion":"HALLAZGO RELACIONADO CON LA AMPLITUD DE LA ABDUCCIÓN DE DEDO DEL PIE"
  },
  {
    "codigo":6262004,
    "descripcion":"INFECCIÓN CAUSADA POR NIPPOSTRONGYLUS"
  },
  {
    "codigo":364875006,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA GIRAR"
  },
  {
    "codigo":1149472000,
    "descripcion":"TROMBOFLEBITIS DE AMBAS EXTREMIDADES INFERIORES EN EL EMBARAZO"
  },
  {
    "codigo":68128000,
    "descripcion":"REACCIÓN DE URTICARIA A LA PRUEBA CUTÁNEA"
  },
  {
    "codigo":266571009,
    "descripcion":"FIMOSIS ADQUIRIDA"
  },
  {
    "codigo":231968003,
    "descripcion":"CATARATA POSTERIOR A RUPTURA DE CÁPSULA"
  },
  {
    "codigo":363040003,
    "descripcion":"INMUNODEFICIENCIA CONGÉNITA QUE COMPROMETE AL SISTEMA HEMATOPOYÉTICO"
  },
  {
    "codigo":209032008,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA EXPUESTA DE MÚLTIPLES ARTICULACIONES INTERFALÁNGICAS DE DEDO DE PIE"
  },
  {
    "codigo":789024007,
    "descripcion":"REQUIERE VACUNACIÓN CONTRA CÓLERA CON FIBRE TIFOIDEA-PARATIFOIDEA"
  },
  {
    "codigo":166432009,
    "descripcion":"PRUEBA DE FUNCIÓN PLACENTARIA ANORMAL"
  },
  {
    "codigo":1077761000119101,
    "descripcion":"OSTEOMIELITIS DE TIBIA IZQUIERDA"
  },
  {
    "codigo":262901004,
    "descripcion":"LESIÓN DE VÍA URINARIA"
  },
  {
    "codigo":295669004,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE MITOMICINA"
  },
  {
    "codigo":721653004,
    "descripcion":"ENTEROLITO DE INTESTINO DELGADO"
  },
  {
    "codigo":93363006,
    "descripcion":"POSICIÓN ANÓMALA CONGÉNITA DE LA TRÁQUEA"
  },
  {
    "codigo":293834001,
    "descripcion":"ALERGIA A PROTRIPTILINA"
  },
  {
    "codigo":228298002,
    "descripcion":"BEBE EN COMPAÑÍA"
  },
  {
    "codigo":366951000119109,
    "descripcion":"ADRENOLEUCODISTROFIA DEL ADOLESCENTE LIGADA AL CROMOSOMA X"
  },
  {
    "codigo":64458007,
    "descripcion":"CONTUSIÓN DE LABIO"
  },
  {
    "codigo":95391000,
    "descripcion":"INFLAMACIÓN DEL SITIO DE INYECCIÓN"
  },
  {
    "codigo":719818007,
    "descripcion":"ATAXIA ESPINOCEREBELOSA LIGADA AL CROMOSOMA X TIPO 4"
  },
  {
    "codigo":15741441000119104,
    "descripcion":"CONTRACTURA CONGÉNITA DE ARTICULACIÓN DE DEDO DE PIE IZQUIERDO"
  },
  {
    "codigo":290164005,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR DEXTROPROPOXIFENO"
  },
  {
    "codigo":781684006,
    "descripcion":"HIPERSENSIBILIDAD NO ALÉRGICA A AGENTE ANTIINFLAMATORIO NO ESTEROIDE"
  },
  {
    "codigo":93556005,
    "descripcion":"HOLOGASTROSQUISIS"
  },
  {
    "codigo":28020009,
    "descripcion":"CUERPO EXTRAÑO EN LA VULVA"
  },
  {
    "codigo":26185009,
    "descripcion":"SECRECIÓN DE GLÁNDULA EXOCRINA AUMENTADA"
  },
  {
    "codigo":778014002,
    "descripcion":"CHASQUIDO DE CADERA NEONATAL"
  },
  {
    "codigo":124489009,
    "descripcion":"DEFICIENCIA DE DIPEPTIDASA"
  },
  {
    "codigo":89886004,
    "descripcion":"ANOMALÍA CONGÉNITA DEL MÚSCULO ESQUELÉTICO"
  },
  {
    "codigo":24350003,
    "descripcion":"LESIÓN TRAUMÁTICA DE PULMÓN SIN HERIDA ABIERTA HACIA TÓRAX"
  },
  {
    "codigo":1269534004,
    "descripcion":"SÍNDROME DE CORDÓN CENTRAL DE MÉDULA CERVICAL DEBIDO A LUXACIÓN NO EXPUESTA INCOMPLETA DE COLUMNA CERVICAL"
  },
  {
    "codigo":253726006,
    "descripcion":"CIRCULACIÓN CORONARIA DEPENDIENTE DEL VENTRÍCULO DERECHO"
  },
  {
    "codigo":219123000,
    "descripcion":"AUTOINTOXICACIÓN POR ARSÉNICO Y\/O COMPUESTO DE ARSÉNICO"
  },
  {
    "codigo":384798004,
    "descripcion":"MARGEN LATERAL (MUCOSO\/MURAL) DE RESECCIÓN QUIRÚRGICA AFECTADO POR ADENOMA"
  },
  {
    "codigo":448499002,
    "descripcion":"CONEXIÓN VENOSA PULMONAR ANÓMALA DE LOCALIZACIÓN INFRACARDÍACA"
  },
  {
    "codigo":417566006,
    "descripcion":"ATENDIDO EN CONSULTORIO DE ENFERMERÍA ESPECIALIZADO EN DIABETES"
  },
  {
    "codigo":188190005,
    "descripcion":"NEOPLASIA MALIGNA DEL CUERNO DE CUERPO UTERINO"
  },
  {
    "codigo":315592004,
    "descripcion":"UÑA DEL PIE PARTIDA"
  },
  {
    "codigo":250056007,
    "descripcion":"MARCHA BIZARRA"
  },
  {
    "codigo":10963611000119107,
    "descripcion":"LACERACIÓN DE DEDO MEÑIQUE DERECHO"
  },
  {
    "codigo":1264029007,
    "descripcion":"INFLAMACIÓN DE MÚSCULO DE PIERNA"
  },
  {
    "codigo":1231261008,
    "descripcion":"ATRAPAMIENTO DE GLOBO OCULAR DEBIDO A EVENTO TRAUMÁTICO"
  },
  {
    "codigo":82546001,
    "descripcion":"ENFERMEDAD INMUNOPROLIFERATIVA REACTIVA"
  },
  {
    "codigo":51613008,
    "descripcion":"INFECCIÓN CAUSADA POR BABESIA DIVERGENS"
  },
  {
    "codigo":770674007,
    "descripcion":"LESIÓN TUBERCULOSA DE PULMÓN"
  },
  {
    "codigo":49778009,
    "descripcion":"ARTERIOSCLEROSIS PULMONAR IDIOPÁTICA"
  },
  {
    "codigo":80711002,
    "descripcion":"TRASTORNO NARCISISTA DE LA PERSONALIDAD"
  },
  {
    "codigo":408391001,
    "descripcion":"BAJO ATENCIÓN DE DIABETÓLOGO"
  },
  {
    "codigo":703303004,
    "descripcion":"ENCEFALOPATÍA HIPÓXICA ISQUÉMICA SEVERA"
  },
  {
    "codigo":277319006,
    "descripcion":"RUPTURA DE ANEURISMA DE ARTERIA CEREBRAL POSTERIOR"
  },
  {
    "codigo":211783008,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO PROFUNDA DE DORSO"
  },
  {
    "codigo":406556003,
    "descripcion":"RIESGO ELEVADO DE DAÑAR A OTROS"
  },
  {
    "codigo":111644004,
    "descripcion":"FRACTURA NO EXPUESTA DE EXTREMO PROXIMAL DE PIERNA"
  },
  {
    "codigo":767004005,
    "descripcion":"LUXACIÓN CONGÉNITA DE CADERA IZQUIERDA CONCOMITANTE CON SUBLUXACIÓN CONGÉNITA DE CADERA DERECHA"
  },
  {
    "codigo":373788008,
    "descripcion":"RETRASO DEL TRATAMIENTO - MOTIVO CLÍNICO"
  },
  {
    "codigo":44273001,
    "descripcion":"BRADICARDIA REFLEJA"
  },
  {
    "codigo":765169002,
    "descripcion":"ESCATOLOGÍA TELEFÓNICA"
  },
  {
    "codigo":77041002,
    "descripcion":"INTOXICACIÓN POR MOLIBDENO"
  },
  {
    "codigo":1287622000,
    "descripcion":"CRISIS EPILÉPTICA CLÓNICA DE INICIO FOCAL NEONATAL"
  },
  {
    "codigo":109809009,
    "descripcion":"ABSCESO DE ESPACIO SUBLINGUAL"
  },
  {
    "codigo":402886003,
    "descripcion":"INFECCIÓN DE LABIOS PRIMARIA POR HERPES SIMPLEX"
  },
  {
    "codigo":239046007,
    "descripcion":"DISPLASIA ECTODÉRMICA CON DEFECTO DE LAS UÑAS"
  },
  {
    "codigo":106139001,
    "descripcion":"PERSONALIDAD Y\/O RASGO DE LA PERSONALIDAD"
  },
  {
    "codigo":827035001,
    "descripcion":"PIEL FRÍA Y HÚMEDA"
  },
  {
    "codigo":73371001,
    "descripcion":"PÉRDIDA DE LA AUDICIÓN NEURAL"
  },
  {
    "codigo":1254854009,
    "descripcion":"DERMATITIS DE CONTACTO FOTOALÉRGICA DEBIDA A FÁRMACO ANTIINFLAMATORIO NO ESTEROIDE"
  },
  {
    "codigo":401051003,
    "descripcion":"ARTERIA CAROTÍDEA TORTUOSA"
  },
  {
    "codigo":300912001,
    "descripcion":"ALERGIA A CHOCOLATE"
  },
  {
    "codigo":202608003,
    "descripcion":"CHASQUIDO DE ARTICULACIÓN SACROILÍACA"
  },
  {
    "codigo":399216004,
    "descripcion":"DEXTRANSPOSICIÓN DE GRANDES VASOS"
  },
  {
    "codigo":366448008,
    "descripcion":"ELEVACIÓN DE LA PIERNA RECTA - HALLAZGO"
  },
  {
    "codigo":102469002,
    "descripcion":"RESPUESTA TERAPÉUTICA AUMENTADA"
  },
  {
    "codigo":430149006,
    "descripcion":"REACCIÓN DE HIPERSENSIBILIDAD CRUZADA"
  },
  {
    "codigo":200773006,
    "descripcion":"PRURIGO DE BESNIER"
  },
  {
    "codigo":15989711000119108,
    "descripcion":"ESTRABISMO RESTRICTIVO DE OJO IZQUIERDO DEBIDO A FIBROSIS ORBITARIA"
  },
  {
    "codigo":69701009,
    "descripcion":"FUNCIÓN CORPORAL ANORMAL"
  },
  {
    "codigo":299077006,
    "descripcion":"AMPLITUD DE EXTENSIÓN ACTIVA DE DEDO DE LA MANO AUMENTADA"
  },
  {
    "codigo":395546005,
    "descripcion":"MÁRGENES DE RESECCIÓN QUIRÚRGICA DE MUCOSA AFECTADOS POR CARCINOMA IN SITU"
  },
  {
    "codigo":10966121000119103,
    "descripcion":"LACERACIÓN DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":360943000,
    "descripcion":"DEFICIENCIA DE CARNOSINASA"
  },
  {
    "codigo":426479005,
    "descripcion":"VERRUGA URETRAL"
  },
  {
    "codigo":295407006,
    "descripcion":"SOBREDOSIS INTENCIONAL DE CAOLÍN"
  },
  {
    "codigo":721391007,
    "descripcion":"SÍNDROME DEL CORDÓN POSTERIOR DE MÉDULA ESPINAL AL NIVEL DEL SEGUNDO SEGMENTO CERVICAL"
  },
  {
    "codigo":293572000,
    "descripcion":"REACCIÓN ADVERSA A LA UROCINASA"
  },
  {
    "codigo":262639009,
    "descripcion":"CONTUSIÓN DE MUCOSA BUCAL ALVEOLAR"
  },
  {
    "codigo":195268001,
    "descripcion":"ANEURISMA DE AORTA ABDOMINAL FILTRANTE"
  },
  {
    "codigo":424644003,
    "descripcion":"FRACTURA PATOLÓGICA DEL PIE"
  },
  {
    "codigo":11785321000119106,
    "descripcion":"AMPOLLA TRAUMÁTICA DE MANO DERECHA"
  },
  {
    "codigo":129732008,
    "descripcion":"FORMA DE LA LESIÓN DETERMINADA POR UN ESTUDIO RADIOGRÁFICO"
  },
  {
    "codigo":95129001,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL MESOCOLON"
  },
  {
    "codigo":783257005,
    "descripcion":"PARÁLISIS FACIAL PERIFÉRICA RECURRENTE FAMILIAR"
  },
  {
    "codigo":226201008,
    "descripcion":"DIETA SIN MANÍ"
  },
  {
    "codigo":289902001,
    "descripcion":"PERÍODOS MENSTRUALES NORMALES"
  },
  {
    "codigo":1141870003,
    "descripcion":"SIGNO DE ANILLO DE SELLO"
  },
  {
    "codigo":224366004,
    "descripcion":"EN TRABAJO PROTEGIDO"
  },
  {
    "codigo":290051000119103,
    "descripcion":"OTITIS MEDIA AGUDA SUPURATIVA RECIDIVANTE DE AMBOS OÍDOS MEDIOS"
  },
  {
    "codigo":93294009,
    "descripcion":"HIPOPLASIA CONGÉNITA DE HUESO SUPRAOCCIPITAL"
  },
  {
    "codigo":58691003,
    "descripcion":"NEUMOCONIOSIS POR ANTIMONIO"
  },
  {
    "codigo":286232003,
    "descripcion":"UTILIZA EL FLUJO DE AIRE PALATINO PARA HABLAR"
  },
  {
    "codigo":56856004,
    "descripcion":"VÍCTIMA DE PERTURBACIÓN CIVIL"
  },
  {
    "codigo":22253000,
    "descripcion":"DOLOR"
  },
  {
    "codigo":253464009,
    "descripcion":"ANOMALÍA DE VALVA DE VÁLVULA AURICULOVENTRICULAR DERECHA"
  },
  {
    "codigo":345501000119101,
    "descripcion":"QUERATOMALACIA BILATERAL"
  },
  {
    "codigo":249794000,
    "descripcion":"PIE AUSENTE"
  },
  {
    "codigo":774082004,
    "descripcion":"DERMATOMIOSITIS NEONATAL"
  },
  {
    "codigo":282562005,
    "descripcion":"DIFICULTAD PARA CAMINAR EN PUNTAS DE PIE"
  },
  {
    "codigo":870551001,
    "descripcion":"FRACTURA NO EXPUESTA DE BASE DE CRÁNEO CON CONTUSIÓN DE CEREBRO"
  },
  {
    "codigo":11814301000119104,
    "descripcion":"RUPTURA TRAUMÁTICA DE LIGAMENTO DE ARTICULACIÓN DE DEDO MEDIO DE MANO IZQUIERDA"
  },
  {
    "codigo":247959008,
    "descripcion":"FALTA DE RESPUESTA A LA COMUNICACIÓN DURANTE EPISODIO DE SONAMBULISMO"
  },
  {
    "codigo":703041000,
    "descripcion":"SÍNDROME DISEJECUTIVO"
  },
  {
    "codigo":80449002,
    "descripcion":"AGOTAMIENTO MUSCULAR"
  },
  {
    "codigo":211521005,
    "descripcion":"CONTUSIÓN, RODILLA Y PIERNA"
  },
  {
    "codigo":1260097007,
    "descripcion":"SÍNDROME DE DISCAPACIDAD DEL DESARROLLO, ATAXIA, EPILEPSIA ASOCIADO AL GEN PUM1"
  },
  {
    "codigo":10640951000119102,
    "descripcion":"ÚLCERA CRÓNICA DE PANTORRILLA IZQUIERDA"
  },
  {
    "codigo":209686001,
    "descripcion":"SECCIÓN EXPUESTA DE LIGAMENTO DE DEDO DE LA MANO, ARTICULACIÓN INTERFALÁNGICA DISTAL, LIGAMENTO LATERAL CUBITAL"
  },
  {
    "codigo":45846002,
    "descripcion":"SENSIBILIDAD A LOS OLORES"
  },
  {
    "codigo":111382002,
    "descripcion":"LIPIDOSIS INDUCIDA QUÍMICAMENTE"
  },
  {
    "codigo":733974004,
    "descripcion":"CARIES DENTAL ACTIVA SECUNDARIA QUE SE EXTIENDE HASTA EL ESMALTE"
  },
  {
    "codigo":735809009,
    "descripcion":"LACERACIÓN DE DEDO DE LA MANO SIN CUERPO EXTRAÑO"
  },
  {
    "codigo":15638071000119104,
    "descripcion":"LINFEDEMA DE MIEMBRO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":1354731005,
    "descripcion":"FRACTURA DE SEXTA COSTILLA"
  },
  {
    "codigo":402624000,
    "descripcion":"LENTIGINOSIS"
  },
  {
    "codigo":74944002,
    "descripcion":"VÍA URETRAL FALSA"
  },
  {
    "codigo":42176003,
    "descripcion":"AMNESIA PARA LOS EVENTOS RECIENTES"
  },
  {
    "codigo":304320004,
    "descripcion":"AMPLITUD DE MOVIMIENTO DE RODILLA AUMENTADA"
  },
  {
    "codigo":7573000,
    "descripcion":"FENILCETONURIA CLÁSICA"
  },
  {
    "codigo":204181009,
    "descripcion":"PLIEGUE RETINIANO CONGÉNITO"
  },
  {
    "codigo":267882003,
    "descripcion":"ARTRITIS PIÓGENA DE TOBILLO Y PIE"
  },
  {
    "codigo":366186008,
    "descripcion":"ASPECTO DEL VENTRÍCULO IZQUIERDO - HALLAZGO"
  },
  {
    "codigo":300650009,
    "descripcion":"DIFICULTAD PARA CONDUCIR UNA BICICLETA"
  },
  {
    "codigo":298815004,
    "descripcion":"AMPLITUD DE ADUCCIÓN PASIVA DE HOMBRO NORMAL"
  },
  {
    "codigo":724799006,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚLTIPLES NERVIOS EN LA MUÑECA"
  },
  {
    "codigo":167743007,
    "descripcion":"NIVEL DE CLORURO EN LÍQUIDO CEFALORRAQUÍDEO DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":722964001,
    "descripcion":"PARKINSONISMO ATÍPICO"
  },
  {
    "codigo":231444002,
    "descripcion":"TRASTORNO BIPOLAR ORGÁNICO"
  },
  {
    "codigo":1148948008,
    "descripcion":"INGESTA INADECUADA DE CLORURO"
  },
  {
    "codigo":426217000,
    "descripcion":"LEUCEMIA ALEUCÉMICA EN REMISIÓN"
  },
  {
    "codigo":296980009,
    "descripcion":"SOBREDOSIS DE AGENTE ANTIARRÍTMICO CARDÍACO"
  },
  {
    "codigo":1085291000119101,
    "descripcion":"URANOESTAFILOSQUISIS CON LABIO LEPORINO"
  },
  {
    "codigo":295145002,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE FENAZOCINA"
  },
  {
    "codigo":196841003,
    "descripcion":"HERNIA CRURAL BILATERAL, IRREDUCTIBLE, RECURRENTE"
  },
  {
    "codigo":293310001,
    "descripcion":"REACCIÓN ADVERSA A HETALMIDÓN"
  },
  {
    "codigo":292561000119109,
    "descripcion":"TRASTORNO DE NERVIO SAFENO EXTERNO DERECHO"
  },
  {
    "codigo":15693521000119109,
    "descripcion":"QUERATITIS DE OJO IZQUIERDO CAUSADA POR MYCOBACTERIUM"
  },
  {
    "codigo":63934006,
    "descripcion":"CABALGAMIENTO DE AORTA"
  },
  {
    "codigo":717459000,
    "descripcion":"MEGAURÉTER PRIMARIO CONGÉNITO"
  },
  {
    "codigo":1340051004,
    "descripcion":"TUMOR GLÓMICO BENIGNO DE OÍDO"
  },
  {
    "codigo":94867007,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL HILIO PULMONAR"
  },
  {
    "codigo":291475008,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR KANAMICINA"
  },
  {
    "codigo":289640001,
    "descripcion":"ÚTERO BLANDO"
  },
  {
    "codigo":47961000087106,
    "descripcion":"FRACTURA DE DIÁFISIS DE RADIO IZQUIERDO"
  },
  {
    "codigo":93032003,
    "descripcion":"ATRESIA DEL TRACTO INTESTINAL"
  },
  {
    "codigo":40281000087109,
    "descripcion":"DISTENSIÓN DE TENDÓN DE ADUCTOR DE CADERA IZQUIERDA"
  },
  {
    "codigo":715624006,
    "descripcion":"SÍNDROME DE NEUROPATÍA ATÁXICA CRÓNICA, OFTALMOPLEJÍA, PROTEÍNA INMUNOGLOBULINA M MONOCLONAL, CRIOAGLUTININA Y ANTICUERPOS ANTI-EPÍTOPE DISIALOSIL"
  },
  {
    "codigo":224104006,
    "descripcion":"MIEMBRO DE FAMILIA SUSTITUTA"
  },
  {
    "codigo":123965000,
    "descripcion":"COPROPORFIRINURIA"
  },
  {
    "codigo":255037004,
    "descripcion":"CARCINOMA DE GLÁNDULA PARATIROIDES"
  },
  {
    "codigo":449810003,
    "descripcion":"DISPOSITIVO DE ANALGESIA CONTROLADO POR EL PACIENTE IN SITU"
  },
  {
    "codigo":187666008,
    "descripcion":"NEOPLASIA MALIGNA DE LA UNIÓN ENTRE EL PALADAR DURO Y EL PALADAR BLANDO"
  },
  {
    "codigo":284135007,
    "descripcion":"CAPAZ DE MOVER LAS CUATRO EXTREMIDADES"
  },
  {
    "codigo":87527008,
    "descripcion":"EMBARAZO A TÉRMINO"
  },
  {
    "codigo":282300003,
    "descripcion":"SE MANTIENE EN EQUILIBRIO"
  },
  {
    "codigo":446140003,
    "descripcion":"LACERACIÓN DE ARTERIA TIBIAL ANTERIOR"
  },
  {
    "codigo":85692003,
    "descripcion":"TUBERCULOSIS DE LOS GANGLIOS LINFÁTICOS TRAQUEOBRONQUIALES"
  },
  {
    "codigo":1263505003,
    "descripcion":"TRASTORNO MIOCLÓNICO DEBIDO A ENFERMEDAD MITOCONDRIAL"
  },
  {
    "codigo":51089004,
    "descripcion":"MANCHA DE NACIMIENTO DE LA PIEL"
  },
  {
    "codigo":870289005,
    "descripcion":"HERIDA ABIERTA DE ESPESOR PARCIAL DE PÁRPADO"
  },
  {
    "codigo":247697005,
    "descripcion":"SOBRESTIMA EL PESO DE SU CUERPO"
  },
  {
    "codigo":93832004,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE ÍLEON"
  },
  {
    "codigo":16486000,
    "descripcion":"OOFORITIS AGUDA"
  },
  {
    "codigo":278630001,
    "descripcion":"PRÓTESIS DENTAL INESTABLE"
  },
  {
    "codigo":213094007,
    "descripcion":"AFLOJAMIENTO DE TORNILLO"
  },
  {
    "codigo":409702008,
    "descripcion":"HIPERPIREXIA"
  },
  {
    "codigo":211259001,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE MUÑECA"
  },
  {
    "codigo":735547005,
    "descripcion":"TRASTORNO DISOCIATIVO CON SÍNTOMA NEUROLÓGICO CONCOMITANTE CON SÍNTOMA AUDITIVO"
  },
  {
    "codigo":14651005,
    "descripcion":"OSTEOPOROSIS INDUCIDA POR FÁRMACO"
  },
  {
    "codigo":702779007,
    "descripcion":"PLAN DE ATENCIÓN DE EMERGENCIA ACORDADO"
  },
  {
    "codigo":16023711000119105,
    "descripcion":"VÁRICE DE VENA DE EXTREMIDAD SUPERIOR IZQUIERDA"
  },
  {
    "codigo":12816000,
    "descripcion":"TAMAÑO DE UNA COLONIA BACTERIANA, GRANDE"
  },
  {
    "codigo":276795005,
    "descripcion":"PROLAPSO DE VALVA ANTERIOR DE VÁLVULA MITRAL"
  },
  {
    "codigo":240357000,
    "descripcion":"ENFERMEDAD ENTÉRICA POR CLOSTRIDIUM"
  },
  {
    "codigo":1290768009,
    "descripcion":"ARTRITIS REUMATOIDEA SERONEGATIVA DE ARTICULACIÓN DE REGIÓN DE HOMBRO"
  },
  {
    "codigo":10981006,
    "descripcion":"TRASTORNO BIPOLAR I MIXTO GRAVE CON SÍNTOMAS PSICÓTICOS"
  },
  {
    "codigo":305893009,
    "descripcion":"VISTO POR EL SERVICIO DE CIRUGÍA HEPATOBILIAR"
  },
  {
    "codigo":109285009,
    "descripcion":"NEVO MELANOCÍTICO DE PIEL DE MAMA"
  },
  {
    "codigo":238522003,
    "descripcion":"FOTODERMATITIS POR PODA"
  },
  {
    "codigo":1156026004,
    "descripcion":"NIVEL SÉRICO DE DIGOXINA POR DEBAJO DEL RANGO TERAPÉUTICO"
  },
  {
    "codigo":15669561000119103,
    "descripcion":"AUSENCIA CONGÉNITA DE EXTREMIDAD SUPERIOR DERECHA"
  },
  {
    "codigo":678201000119103,
    "descripcion":"RUBEOSIS DEL IRIS DEL OJO IZQUIERDO"
  },
  {
    "codigo":74682007,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DE DEDO DE PIE"
  },
  {
    "codigo":369594008,
    "descripcion":"TUMOR MALIGNO CON COMPROMISO DE ÓRGANO POR PROPAGACIÓN DIRECTA DESDE VEJIGA"
  },
  {
    "codigo":105615001,
    "descripcion":"HERIDA ABIERTA DEL TRONCO"
  },
  {
    "codigo":402362009,
    "descripcion":"ENFERMEDAD DE LA MUCOSA BUCAL POR ENFERMEDAD DE INJERTO VERSUS HUÉSPED"
  },
  {
    "codigo":236687008,
    "descripcion":"ABSCESO URETRAL GONOCÓCICO"
  },
  {
    "codigo":365924002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD DE UTILIZAR ESTRATEGIAS PARA LA TOMA DE DECISIONES"
  },
  {
    "codigo":726372008,
    "descripcion":"DELECIÓN DE PARTE DEL CROMOSOMA 5"
  },
  {
    "codigo":3641001,
    "descripcion":"INFECCIÓN CAUSADA POR COENUROSIS SERIALIS"
  },
  {
    "codigo":298553003,
    "descripcion":"AMPLITUD DE ROTACIÓN ACTIVA HACIA LA DERECHA DE LA COLUMNA DORSAL VERTEBRAL, NORMAL"
  },
  {
    "codigo":200249004,
    "descripcion":"HEMORROIDES EN EMBARAZO Y PUERPERIO"
  },
  {
    "codigo":16898361000119108,
    "descripcion":"FRACTURA NO EXPUESTA EN MARTILLO DE FALANGE DISTAL DE DEDO MEDIO DE MANO IZQUIERDA"
  },
  {
    "codigo":724537009,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE YEYUNO"
  },
  {
    "codigo":296718004,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE CEFTIZOXIMA"
  },
  {
    "codigo":230707007,
    "descripcion":"INFARTO HEMORRÁGICO DE LA CIRCULACIÓN CEREBRAL ANTERIOR"
  },
  {
    "codigo":427790005,
    "descripcion":"OCLUSIÓN PARCIAL DE TROMPA DE FALOPIO"
  },
  {
    "codigo":722702007,
    "descripcion":"LACERACIÓN FOCAL DE CEREBELO"
  },
  {
    "codigo":395022009,
    "descripcion":"SÍNTOMAS NOCTURNOS DE ASMA"
  },
  {
    "codigo":196579001,
    "descripcion":"PÓLIPO BUCAL"
  },
  {
    "codigo":131043003,
    "descripcion":"NIVEL DE HORMONA CORTICOSUPRARRENAL POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":294883005,
    "descripcion":"ALERGIA A FENINDIONA"
  },
  {
    "codigo":360419005,
    "descripcion":"INFECCIÓN CAUSADA POR ENTEROBIUS VERMICULARIS"
  },
  {
    "codigo":32739008,
    "descripcion":"PARÁLISIS DE MULETA"
  },
  {
    "codigo":63672004,
    "descripcion":"AUSENCIA DE REACCIÓN A LA PRUEBA CUTÁNEA"
  },
  {
    "codigo":11848301000119100,
    "descripcion":"HERIDA INFECTADA DE PÁRPADO DERECHO DEBIDA A PICADURA DE INSECTO NO VENENOSO"
  },
  {
    "codigo":29069000,
    "descripcion":"INTOXICACIÓN POR ANTICOAGULANTE RODENTICIDA"
  },
  {
    "codigo":661681000124105,
    "descripcion":"ARTRITIS DE ARTICULACIÓN DE REGIÓN DE HOMBRO DERECHO"
  },
  {
    "codigo":94605004,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL ESTERNÓN"
  },
  {
    "codigo":127373004,
    "descripcion":"DÉCIMO EMBARAZO"
  },
  {
    "codigo":291213006,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR DECANOATO DE FLUPENTIXOL"
  },
  {
    "codigo":60002000,
    "descripcion":"GASTRITIS HIPERTRÓFICA"
  },
  {
    "codigo":717197009,
    "descripcion":"AEROMONAS CAVIAE O AEROMONAS HYDROPHILA"
  },
  {
    "codigo":92770002,
    "descripcion":"CARCINOMA IN SITU DE LA FOSA AMIGDALINA"
  },
  {
    "codigo":289378005,
    "descripcion":"NIVEL -4 DE LA PRESENTACIÓN EN RELACIÓN CON LAS ESPINAS ISQUIÁTICAS"
  },
  {
    "codigo":387682007,
    "descripcion":"CELULITIS VULVAR"
  },
  {
    "codigo":254775002,
    "descripcion":"SÍNDROME DE BREGEAT"
  },
  {
    "codigo":123703002,
    "descripcion":"ECCEMA EXCORIADO"
  },
  {
    "codigo":90935002,
    "descripcion":"HEMOFILIA"
  },
  {
    "codigo":1303351008,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO INTRÍNSECO DE DEDO MEÑIQUE"
  },
  {
    "codigo":713527009,
    "descripcion":"TRASTORNO DEL SISTEMA NERVIOSO PERIFÉRICO CONCOMITANTE CON INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":1336119008,
    "descripcion":"GLOMERULOPATÍA POR COMPONENTE 4 DEL COMPLEMENTO"
  },
  {
    "codigo":1137676003,
    "descripcion":"MENOR NIVEL DE ESTRÉS ESPIRITUAL"
  },
  {
    "codigo":285708004,
    "descripcion":"LESIÓN DE LA ARTERIA SISTÉMICA"
  },
  {
    "codigo":416780008,
    "descripcion":"DEMENCIA DEGENERATIVA PRIMARIA DE TIPO ALZHEIMER, INICIO EN LA ETAPA PRESENIL"
  },
  {
    "codigo":680711000119102,
    "descripcion":"MUCOCELE DE SACO LAGRIMAL IZQUIERDO"
  },
  {
    "codigo":708022000,
    "descripcion":"SÍNDROME DE DISPLASIA LINFÁTICA PULMONAR CONGÉNITA"
  },
  {
    "codigo":216502001,
    "descripcion":"INTOXICACIÓN ACCIDENTAL CAUSADA POR FENOBARBITAL"
  },
  {
    "codigo":19894004,
    "descripcion":"INTOXICACIÓN ALIMENTARIA CAUSADA POR BACILLUS CEREUS"
  },
  {
    "codigo":413110004,
    "descripcion":"NEUROLÉPTICO INYECTABLE ADMINISTRADO"
  },
  {
    "codigo":282038006,
    "descripcion":"ANOMALÍA CONGÉNITA DEL OÍDO EXTERNO"
  },
  {
    "codigo":445878006,
    "descripcion":"FOLICULITIS GRANULOMATOSA MULTIFOCAL DE GLÁNDULA TIROIDES"
  },
  {
    "codigo":183734006,
    "descripcion":"CONSULTA DOMICILIARIA DE UROLOGÍA SOLICITADA"
  },
  {
    "codigo":85430004,
    "descripcion":"HUSO DE KRUKENBERG"
  },
  {
    "codigo":1197707003,
    "descripcion":"ÚLCERA ANASTOMÓTICA GASTROINTESTINAL DEBIDA A ENFERMEDAD DE CROHN"
  },
  {
    "codigo":704352005,
    "descripcion":"CON MAYOR RIESGO DE RETRASO DEL CRECIMIENTO"
  },
  {
    "codigo":1163104006,
    "descripcion":"ENCEFALITIS POR POLIOMAVIRUS BK"
  },
  {
    "codigo":473141001,
    "descripcion":"PROTRUSIÓN DE IMPLANTE MUSCULOESQUELÉTICO"
  },
  {
    "codigo":276533002,
    "descripcion":"SÍNDROME NEONATAL POR ASPIRACIÓN"
  },
  {
    "codigo":1259573002,
    "descripcion":"ADENOCARCINOMA APOCRINO CUTÁNEO PRIMARIO"
  },
  {
    "codigo":373002002,
    "descripcion":"INFECCIÓN CAUSADA POR ASPERGILLUS TAUMANII"
  },
  {
    "codigo":241930003,
    "descripcion":"ANAFILAXIA CAUSADA POR VENENO"
  },
  {
    "codigo":209162004,
    "descripcion":"SUBLUXACIÓN VERTEBRAL EXPUESTA CON LESIÓN MEDULAR COMPLETA A NIVEL CERVICAL"
  },
  {
    "codigo":15727521000119103,
    "descripcion":"ARTROFITO EN ARTICULACIÓN DE MANO IZQUIERDA"
  },
  {
    "codigo":12554006,
    "descripcion":"LAXITUD"
  },
  {
    "codigo":698847000,
    "descripcion":"DISTROFIA HEREDITARIA DE LA RETINA QUE AFECTA PRINCIPALMENTE AL EPITELIO PIGMENTARIO"
  },
  {
    "codigo":240095001,
    "descripcion":"MIOPATÍA POR ALMACENAMIENTO DE LÍPIDOS"
  },
  {
    "codigo":733450008,
    "descripcion":"SÍNDROME DE GLICOPROTEÍNAS DEFICIENTES EN CARBOHIDRATOS TIPO 2 DEBIDO A DEFICIENCIA DE ALFA MANOSIDASA CLASE 1B, MIEMBRO 1"
  },
  {
    "codigo":895455000,
    "descripcion":"SE MOVILIZA CON SCOOTER ADAPTADO"
  },
  {
    "codigo":403935003,
    "descripcion":"SIRINGOMAS FAMILIARES MÚLTIPLES"
  },
  {
    "codigo":76255006,
    "descripcion":"INFECCIÓN CAUSADA POR HISTOPLASMA CAPSULATUM"
  },
  {
    "codigo":305631007,
    "descripcion":"ATENDIDO POR UN OSTEÓPATA"
  },
  {
    "codigo":860852000,
    "descripcion":"GRANULOMA DE TRONCO ENCEFÁLICO"
  },
  {
    "codigo":8884000,
    "descripcion":"ASCITIS FETAL QUE OCASIONA DESPROPORCIÓN"
  },
  {
    "codigo":762548000,
    "descripcion":"DERMATITIS ALÉRGICA POR CONTACTO OCUPACIONAL CAUSADA POR COSMÉTICO"
  },
  {
    "codigo":300091000119100,
    "descripcion":"OSTEOMIELITIS SUBAGUDA DE MANO"
  },
  {
    "codigo":41652007,
    "descripcion":"DOLOR EN EL OJO"
  },
  {
    "codigo":72585000,
    "descripcion":"SÍNDROME PARKINSONIANO CON HIPOTENSIÓN ORTOSTÁTICA IDIOPÁTICA"
  },
  {
    "codigo":1186697006,
    "descripcion":"AMBIENTE IMPERSONAL"
  },
  {
    "codigo":301961009,
    "descripcion":"PAPILA ÓPTICA NORMAL"
  },
  {
    "codigo":365662002,
    "descripcion":"ASPECTO DEL LÍQUIDO AMNIÓTICO - HALLAZGO"
  },
  {
    "codigo":203657009,
    "descripcion":"CIFOSIS OSTEOPORÓTICA"
  },
  {
    "codigo":234590006,
    "descripcion":"DEFICIENCIA DE GLUTATIÓN PEROXIDASA"
  },
  {
    "codigo":300126006,
    "descripcion":"CONDUCTO AUDITIVO DE TAMAÑO NORMAL"
  },
  {
    "codigo":37982009,
    "descripcion":"HIPERAMINOACIDURIA DICARBOXÍLICA E HIPERPROLINEMIA"
  },
  {
    "codigo":15864051000119100,
    "descripcion":"QUISTE DE REGIÓN PREAURICULAR DERECHA"
  },
  {
    "codigo":11773171000119100,
    "descripcion":"LACERACIÓN DE MÚSCULO DE ANTEBRAZO IZQUIERDO"
  },
  {
    "codigo":294131000119102,
    "descripcion":"HEMIPLEJÍA DE LADO DERECHO NO DOMINANTE"
  },
  {
    "codigo":117491000119102,
    "descripcion":"ESFUERZO DURANTE LA MICCIÓN DEBIDO A HIPERTROFIA PROSTÁTICA BENIGNA"
  },
  {
    "codigo":368371000119102,
    "descripcion":"HEMATURIA CONCOMITANTE CON TRIGONITIS Y DEBIDA A ELLA"
  },
  {
    "codigo":140531000119105,
    "descripcion":"ÚLCERA DE PIE NEUROPÁTICA DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":291571000119106,
    "descripcion":"HEMORRAGIA CEREBRAL ESPONTÁNEA"
  },
  {
    "codigo":15628531000119107,
    "descripcion":"FUNDUS FLAVIMACULATUS DE OJO DERECHO"
  },
  {
    "codigo":296691000119102,
    "descripcion":"HIPERLAXITUD ARTICULAR DE MUÑECA"
  },
  {
    "codigo":9971000119105,
    "descripcion":"MIELOPATÍA CONCOMITANTE CON ESTENOSIS ESPINAL DE REGIÓN CERVICAL Y DEBIDA A ELLA"
  },
  {
    "codigo":114931000119103,
    "descripcion":"HIPERSENSIBILIDAD A ABACAVIR"
  },
  {
    "codigo":683251000119104,
    "descripcion":"NEVO MELANOCÍTICO PIGMENTADO CONGÉNITO DE PIEL DEL CUELLO"
  },
  {
    "codigo":806161651000119106,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DEBIDO A EMBOLIA DE ARTERIA VERTEBRAL DERECHA"
  },
  {
    "codigo":586065651000119108,
    "descripcion":"ENDOMETRIOSIS DE COLON SIGMOIDE"
  },
  {
    "codigo":10948851000119108,
    "descripcion":"HERIDA ABIERTA DE BRAZO DERECHO DEBIDA A MORDEDURA DE PERRO"
  },
  {
    "codigo":11995891000119108,
    "descripcion":"HEMATOMA DE MUÑÓN DE AMPUTACIÓN DE EXTREMIDAD INFERIOR IZQUIERDA"
  },
  {
    "codigo":65245004,
    "descripcion":"LIPOMATOSIS NODULAR CIRCUNSCRIPTA"
  },
  {
    "codigo":1544005,
    "descripcion":"LUXACIÓN EXPUESTA DE LA RODILLA"
  },
  {
    "codigo":16836851000119109,
    "descripcion":"ABORTO ESPONTÁNEO DE EMBARAZO ECTÓPICO EN TROMPA DE FALOPIO DERECHA"
  },
  {
    "codigo":294621007,
    "descripcion":"ALERGIA A MONOSULFIRAM"
  },
  {
    "codigo":196317007,
    "descripcion":"MANCHADO DENTAL POSERUPTIVO"
  },
  {
    "codigo":720605009,
    "descripcion":"SÍNDROME DE ANOMALÍA CARDÍACA Y HETEROTAXIA"
  },
  {
    "codigo":784306000,
    "descripcion":"RUPTURA DE CÁPSULA DE CRISTALINO"
  },
  {
    "codigo":718770005,
    "descripcion":"ATAXIA ESPINOCEREBELOSA TIPO 25"
  },
  {
    "codigo":423858006,
    "descripcion":"ESCALDADURA CUTÁNEA"
  },
  {
    "codigo":292786007,
    "descripcion":"REACCIÓN ADVERSA A LA PARAFINA LÍQUIDA"
  },
  {
    "codigo":127111003,
    "descripcion":"LINFADENOPATÍA ESOFÁGICA"
  },
  {
    "codigo":61575003,
    "descripcion":"PERICARDITIS SECUNDARIA A ANEURISMA AÓRTICO"
  },
  {
    "codigo":28807005,
    "descripcion":"CRIOGLOBULINEMIA SECUNDARIA"
  },
  {
    "codigo":192647003,
    "descripcion":"MENINGITIS SIFILÍTICA SECUNDARIA"
  },
  {
    "codigo":94343007,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA CARA INTERNA DE LABIO SUPERIOR"
  },
  {
    "codigo":290951008,
    "descripcion":"INTOXICACIÓN POR METILFENOBARBITAL"
  },
  {
    "codigo":715100002,
    "descripcion":"DIFICULTAD PARA PASAR DE LA SILLA DE RUEDAS AL INODORO"
  },
  {
    "codigo":289116005,
    "descripcion":"DIFICULTAD PARA TOSER"
  },
  {
    "codigo":1092821000119106,
    "descripcion":"MIOSITIS POR TOXOPLASMA"
  },
  {
    "codigo":90673000,
    "descripcion":"SENSACIÓN DE ARDOR"
  },
  {
    "codigo":713265001,
    "descripcion":"ANEURISMA CEREBRAL ROTO, NO TRAUMÁTICO"
  },
  {
    "codigo":1335857004,
    "descripcion":"EFECTO DE RADIACIÓN IONIZANTE"
  },
  {
    "codigo":254513004,
    "descripcion":"NEOPLASIA MALIGNA DE COMISURA POSTERIOR"
  },
  {
    "codigo":1268486000,
    "descripcion":"GANGLIONEUROBLASTOMA PRIMARIO"
  },
  {
    "codigo":1137414004,
    "descripcion":"DEBILIDAD DE MÚSCULO TIBIAL ANTERIOR"
  },
  {
    "codigo":16057711000119103,
    "descripcion":"PARÁLISIS FACIAL DERECHA GRADO III DE HOUSE-BRACKMANN"
  },
  {
    "codigo":285446005,
    "descripcion":"DIFICULTAD PARA MOVER LA MANDÍBULA"
  },
  {
    "codigo":283611005,
    "descripcion":"HERIDA POR PINCHAZO DE AGUJA EN LA AXILA"
  },
  {
    "codigo":185307008,
    "descripcion":"VISTO POR TÉCNICO EN OPTOMETRÍA"
  },
  {
    "codigo":1363120003,
    "descripcion":"OSTEOPERIOSTITIS PERIAPICAL"
  },
  {
    "codigo":609456005,
    "descripcion":"INTERRUPCIÓN INDUCIDA DEL EMBARAZO COMPLICADA POR AFIBRINOGENEMIA"
  },
  {
    "codigo":773296007,
    "descripcion":"PARONIQUIA DEBIDA A UÑA ENCARNADA"
  },
  {
    "codigo":314544008,
    "descripcion":"ENDOFTALMITIS POSQUIRÚRGICA"
  },
  {
    "codigo":871600007,
    "descripcion":"DEFECTO DEL TABIQUE INTERVENTRICULAR CON TABIQUE DE SALIDA MAL ALINEADO EN LA PORCIÓN POSTERIOR"
  },
  {
    "codigo":50565005,
    "descripcion":"ÚLCERA ILEAL"
  },
  {
    "codigo":81498004,
    "descripcion":"BURSITIS DE LA CADERA"
  },
  {
    "codigo":704090005,
    "descripcion":"FRACTURA EXPUESTA DE DIÁFISIS DE TERCER METACARPIANO"
  },
  {
    "codigo":441946009,
    "descripcion":"TROMBOFILIA DEBIDA A TRASTORNO MIELOPROLIFERATIVO"
  },
  {
    "codigo":309039003,
    "descripcion":"SITUACIÓN DE ALTA HOSPITALARIA"
  },
  {
    "codigo":302601000119104,
    "descripcion":"ANQUILOSIS DE ARTICULACIÓN DE CADERA DERECHA"
  },
  {
    "codigo":1259311005,
    "descripcion":"CISTOADENOCARCINOMA PRIMARIO DE PÁNCREAS"
  },
  {
    "codigo":208900000,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE LA ARTICULACIÓN DE LA CADERA, POSTERIOR"
  },
  {
    "codigo":866095008,
    "descripcion":"NEOPLASIA MALIGNA DE VAINA DE NERVIO PERIFÉRICO DE TÓRAX"
  },
  {
    "codigo":15703561000119106,
    "descripcion":"CONTRACTURA DE AMBOS TENDONES DE AQUILES"
  },
  {
    "codigo":403673001,
    "descripcion":"PSEUDOESCLERODERMIA MEDICAMENTOSA"
  },
  {
    "codigo":239833001,
    "descripcion":"CONDROCALCINOSIS DE ARTICULACIÓN DE RODILLA CAUSADA POR CRISTALES DE PIROFOSFATO"
  },
  {
    "codigo":75993002,
    "descripcion":"VULVOVAGINITIS ATRÓFICA"
  },
  {
    "codigo":237998000,
    "descripcion":"DEFICIENCIA DE LA CADENA CORTA 3-HIDROXIACIL-COA DESHIDROGENASA"
  },
  {
    "codigo":8622001,
    "descripcion":"FUNCIÓN VESICULAR NORMAL"
  },
  {
    "codigo":698585009,
    "descripcion":"HEMORRAGIA POSOPERATORIA DE HERIDA ABDOMINAL"
  },
  {
    "codigo":1255641009,
    "descripcion":"CARCINOMA PLEOMÓRFICO DE PULMÓN"
  },
  {
    "codigo":205230001,
    "descripcion":"AUSENCIA CONGÉNITA DE CUARTO Y QUINTO DEDOS DEL PIE"
  },
  {
    "codigo":762286005,
    "descripcion":"HEMORRAGIA SUBAPONEURÓTICA EPICRANEAL SUBGALEAL DEBIDA A TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":41390006,
    "descripcion":"INTOXICACIÓN POR CLORFENAMINA"
  },
  {
    "codigo":685731000119103,
    "descripcion":"LEIOMIOSARCOMA PRIMARIO DE TRONCO"
  },
  {
    "codigo":400003000,
    "descripcion":"PUBERTAD TARDÍA"
  },
  {
    "codigo":170627008,
    "descripcion":"OBSTRUCCIÓN REVERSIBLE DE LAS VÍAS AÉREAS"
  },
  {
    "codigo":299864001,
    "descripcion":"REFLEJO ANAL PRESENTE SÓLO CON REFUERZO"
  },
  {
    "codigo":365400002,
    "descripcion":"HALLAZGO DE LA ETAPA DE LA PUBERTAD"
  },
  {
    "codigo":4952001,
    "descripcion":"IRRITABILIDAD CEREBRAL EN EL RECIÉN NACIDO"
  },
  {
    "codigo":430936000,
    "descripcion":"LUXACIÓN NO EXPUESTA DE ARTICULACIÓN QUE RODEA AL HUESO SEMILUNAR"
  },
  {
    "codigo":267096005,
    "descripcion":"DOLOR DE CABEZA FRONTAL"
  },
  {
    "codigo":398168006,
    "descripcion":"ASPECTO LIMPIO EN TÉRMINOS GENERALES"
  },
  {
    "codigo":201560001,
    "descripcion":"ARTRITIS REACTIVA DE ARTICULACIÓN ACROMIOCLAVICULAR"
  },
  {
    "codigo":103256007,
    "descripcion":"MIRADA LATERAL CONJUGADA"
  },
  {
    "codigo":68653001,
    "descripcion":"DOLOR ANAL"
  },
  {
    "codigo":203395009,
    "descripcion":"OSTEOCONDROSIS DE QUINTO METATARSIANO"
  },
  {
    "codigo":35885006,
    "descripcion":"HIPERURICEMIA"
  },
  {
    "codigo":166957006,
    "descripcion":"NIVEL ALTO DE LITIO - TÓXICO"
  },
  {
    "codigo":396333008,
    "descripcion":"REUMATISMO NO ARTICULAR"
  },
  {
    "codigo":1282001,
    "descripcion":"PERICONDRITIS LARÍNGEA"
  },
  {
    "codigo":230658002,
    "descripcion":"NEUROPATÍA ATÁXICA IDIOPÁTICA CRÓNICA"
  },
  {
    "codigo":722178004,
    "descripcion":"DEPENDIENTE PARA LAS ACTIVIDADES DE HIGIENE PERSONAL"
  },
  {
    "codigo":1344770009,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE TENDÓN DE MANO"
  },
  {
    "codigo":32215002,
    "descripcion":"ENFERMEDAD SUBAGUDA POR RADIACIÓN"
  },
  {
    "codigo":197890009,
    "descripcion":"VEJIGA URINARIA EN RELOJ DE ARENA"
  },
  {
    "codigo":294359005,
    "descripcion":"ALERGIA A ECONAZOL"
  },
  {
    "codigo":95916000,
    "descripcion":"RESISTENCIA FARMACOLÓGICA DISMINUIDA"
  },
  {
    "codigo":785879009,
    "descripcion":"CISTOADENOMA MUCINOSO DE PÁNCREAS"
  },
  {
    "codigo":16469821000119106,
    "descripcion":"FATIGA DEBIDA A ACCIDENTE CEREBROVASCULAR CON HEMORRAGIA INTRACRANEAL Y POSTERIOR A ÉL"
  },
  {
    "codigo":290689000,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR TIOGUANINA"
  },
  {
    "codigo":1306497001,
    "descripcion":"CARCINOMA DUCTAL INFILTRANTE PRIMARIO DE PORCIÓN CENTRAL DE MAMA DERECHA"
  },
  {
    "codigo":1082601000112109,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE VÍSCERA"
  },
  {
    "codigo":126849006,
    "descripcion":"NEOPLASIA DEL ANO"
  },
  {
    "codigo":716673006,
    "descripcion":"INFECCIÓN DEL TRACTO RESPIRATORIO SUPERIOR CAUSADA POR HONGOS"
  },
  {
    "codigo":92246000,
    "descripcion":"NEOPLASIA BENIGNA DEL CUELLO"
  },
  {
    "codigo":288854000,
    "descripcion":"INCAPAZ DE BEBER"
  },
  {
    "codigo":94081005,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE GLÁNDULA SUDORÍPARA"
  },
  {
    "codigo":254251003,
    "descripcion":"SÍNDROME DE MINOXIDIL FETAL"
  },
  {
    "codigo":711168000,
    "descripcion":"ÚLCERA DE PIEL DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":447189000,
    "descripcion":"URETEROCELE RESIDUAL"
  },
  {
    "codigo":283349000,
    "descripcion":"PICADURA DE INSECTO INFECTADA EN LA PALMA DE LA MANO"
  },
  {
    "codigo":86741006,
    "descripcion":"INTENSIDAD VOCAL NORMAL"
  },
  {
    "codigo":1264554000,
    "descripcion":"SIGNOS DE ABSTINENCIA A OPIOIDES EN PRUEBA DE NALOXONA"
  },
  {
    "codigo":281514001,
    "descripcion":"FRACTURA-LUXACIÓN CON AFECTACIÓN TRANSESCAFOIDEA DE HUESOS GRANDE Y PERISEMILUNAR"
  },
  {
    "codigo":84906002,
    "descripcion":"CIANOSIS LOCAL"
  },
  {
    "codigo":52138004,
    "descripcion":"FIEBRE ESTREPTOBACILAR"
  },
  {
    "codigo":248746006,
    "descripcion":"DIRECCIÓN DEL FLUJO VENOSO"
  },
  {
    "codigo":83071002,
    "descripcion":"DESGARRO ANTIGUO DE CARTÍLAGO EN ASA DE BALDE"
  },
  {
    "codigo":115839002,
    "descripcion":"FENOTIPO KELL>MOD<"
  },
  {
    "codigo":17535004,
    "descripcion":"ACOSTADO EN LA CAMA"
  },
  {
    "codigo":246911004,
    "descripcion":"PAPILOMA DE CONJUNTIVA PALPEBRAL"
  },
  {
    "codigo":312447004,
    "descripcion":"TRASTORNO DEL COITO MASCULINO"
  },
  {
    "codigo":16908401000119105,
    "descripcion":"CARCINOMA SEBÁCEO DE PIEL DE PÁRPADO INFERIOR DERECHO"
  },
  {
    "codigo":1197183009,
    "descripcion":"ANGIOEDEMA GINGIVAL POR DEFICIENCIA DE INHIBIDOR DE C1 ESTERASA"
  },
  {
    "codigo":212308001,
    "descripcion":"LESIÓN DE MÚLTIPLES NERVIOS A NIVEL DEL ANTEBRAZO"
  },
  {
    "codigo":277844007,
    "descripcion":"LINFANGIOLEIOMIOMATOSIS PULMONAR"
  },
  {
    "codigo":439849002,
    "descripcion":"LESIÓN TRAUMÁTICA POR FRICCIÓN DENTAL EXTENDIDA HASTA LA DENTINA"
  },
  {
    "codigo":688241000119107,
    "descripcion":"ENFERMEDAD DE SÉZARY DE GANGLIOS LINFÁTICOS DE AXILA"
  },
  {
    "codigo":1259049004,
    "descripcion":"ENFERMEDAD DE CASTLEMAN CON GAMMAPATÍA MONOCLONAL POR INMUNOGLOBULINA M DE SIGNIFICACIÓN INCIERTA"
  },
  {
    "codigo":334091000119102,
    "descripcion":"ENTROPIÓN ESPÁSTICO DE PÁRPADO INFERIOR DERECHO"
  },
  {
    "codigo":110334000,
    "descripcion":"RAÍZ DENTAL LARGA"
  },
  {
    "codigo":208638003,
    "descripcion":"FRACTURA EXPUESTA DE TIBIA DISTAL, EXTRARTICULAR"
  },
  {
    "codigo":405246007,
    "descripcion":"INFECCIÓN Y FIBROSIS DE CORDÓN ESPERMÁTICO REMANENTE"
  },
  {
    "codigo":77566008,
    "descripcion":"SIGNOS ELECTROCARDIOGRÁFICOS DE HIPERTROFIA DE AURÍCULA DERECHA"
  },
  {
    "codigo":732926009,
    "descripcion":"SÍNDROME DE HIDROCEFALIA, ESTATURA ELEVADA Y LAXITUD ARTICULAR"
  },
  {
    "codigo":274174009,
    "descripcion":"LESIÓN DE TENDÓN - EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":403411000,
    "descripcion":"MIOFIBROMATOSIS INFANTIL SISTÉMICA AGRESIVA"
  },
  {
    "codigo":11802891000119105,
    "descripcion":"ESGUINCE DE LIGAMENTO DE ARTICULACIÓN RADIOCARPIANA DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":10901771000119106,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO HIPOGLOSO IZQUIERDO"
  },
  {
    "codigo":237736009,
    "descripcion":"SÍNDROME DE CUSHING CÍCLICO"
  },
  {
    "codigo":1153405002,
    "descripcion":"NEOPLASIA DE ESTROMA GASTROINTESTINAL DE RECTO"
  },
  {
    "codigo":235901004,
    "descripcion":"FIBROSIS HEPÁTICA CON ESCLEROSIS HEPÁTICA"
  },
  {
    "codigo":268669006,
    "descripcion":"TRASTORNO DE LA NIÑEZ Y ADOLESCENCIA CON MUTISMO ELECTIVO"
  },
  {
    "codigo":15954341000119102,
    "descripcion":"NECROSIS ADIPOSA DE MAMA DERECHA"
  },
  {
    "codigo":234066000,
    "descripcion":"ESTENOSIS DE LA VENA TRASPLANTADA"
  },
  {
    "codigo":299602002,
    "descripcion":"AMPLITUD DE EXTENSIÓN PASIVA DE DEDO DEL PIE AUMENTADA"
  },
  {
    "codigo":37458007,
    "descripcion":"DETERMINACIÓN DEL RESULTADO: COMPLICACIÓN EVITABLE DERIVADA DE UN ERROR EN LA TÉCNICA"
  },
  {
    "codigo":102994007,
    "descripcion":"PRUEBA DE LA TABLA HORIZONTAL"
  },
  {
    "codigo":4690009,
    "descripcion":"ACIDOSIS METABÓLICA CAUSADA POR PARALDEHÍDO"
  },
  {
    "codigo":365138008,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA TRANSPORTAR UN OBJETO"
  },
  {
    "codigo":363303003,
    "descripcion":"SECUELAS DE TRASTORNOS ALIMENTARIOS"
  },
  {
    "codigo":428839004,
    "descripcion":"ARTRITIS GOTOSA DE DEDO DE PIE"
  },
  {
    "codigo":166695003,
    "descripcion":"NIVEL DE CLORURO SÉRICO DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":263164000,
    "descripcion":"FRACTURA DE HUESO CIGOMÁTICO"
  },
  {
    "codigo":68391009,
    "descripcion":"GRUPO DE VOZ RONCA ESFORZADA DETENIDA - ARRÍTMICA INTERMITENTE"
  },
  {
    "codigo":232231008,
    "descripcion":"OTITIS EXTERNA NO INFECCIOSA"
  },
  {
    "codigo":1020003,
    "descripcion":"ENFERMEDAD CAUSADA POR NAIROVIRUS"
  },
  {
    "codigo":295932000,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE CITALOPRAM"
  },
  {
    "codigo":66556007,
    "descripcion":"HEMOBILIA"
  },
  {
    "codigo":230396008,
    "descripcion":"EPILEPSIA DE CÍNGULO DE LÓBULO FRONTAL"
  },
  {
    "codigo":294097003,
    "descripcion":"ALERGIA A ACETILCISTEÍNA"
  },
  {
    "codigo":30118000,
    "descripcion":"PUERPERIO, 1 DÍA"
  },
  {
    "codigo":690751000119102,
    "descripcion":"CISTADENOMA MUCINOSO DE PÁNCREAS"
  },
  {
    "codigo":95654002,
    "descripcion":"HEMICRÁNEA PAROXÍSTICA CRÓNICA"
  },
  {
    "codigo":1176998005,
    "descripcion":"ERUPCIÓN CUTÁNEA CAUSADA POR BACTERIEMIA"
  },
  {
    "codigo":292262009,
    "descripcion":"REACCIÓN ADVERSA A LA DEXFENFLURAMINA"
  },
  {
    "codigo":192123006,
    "descripcion":"TRASTORNO DE BAJO RENDIMIENTO ACADÉMICO"
  },
  {
    "codigo":716411007,
    "descripcion":"CAPAZ DE TENER UN NIVEL DE VIGOR FUNCIONAL"
  },
  {
    "codigo":126587007,
    "descripcion":"NEOPLASIA DE RÓTULA"
  },
  {
    "codigo":59216005,
    "descripcion":"TRASTORNO DE LA IDENTIDAD SEXUAL DEL ADULTO, SEXUALMENTE ATRAÍDO POR VARONES"
  },
  {
    "codigo":1237029007,
    "descripcion":"CON RIESGO ELEVADO DE EXPOSICIÓN A STREPTOCOCCUS PNEUMONIAE"
  },
  {
    "codigo":219386001,
    "descripcion":"HERIDA DE GUERRA POR FRAGMENTOS DE GRANADA"
  },
  {
    "codigo":253989009,
    "descripcion":"LABIO LEPORINO BILATERAL INCOMPLETO Y FISURA ALVEOLAR BILATERAL INCOMPLETA"
  },
  {
    "codigo":286757009,
    "descripcion":"TIENDE A SER INTOLERANTE A LA FRUSTRACIÓN"
  },
  {
    "codigo":284922004,
    "descripcion":"UTILIZA EL ORINAL MASCULINO"
  },
  {
    "codigo":55546004,
    "descripcion":"ORIGEN ANÓMALO DE ARTERIA CIRCUNFLEJA IZQUIERDA EN ARTERIA CORONARIA DERECHA"
  },
  {
    "codigo":283087002,
    "descripcion":"ARAÑAZO DE PULGAR"
  },
  {
    "codigo":86479002,
    "descripcion":"LINFANGITIS INFECCIOSA DE LOS GANGLIOS LINFÁTICOS PROFUNDOS"
  },
  {
    "codigo":119247004,
    "descripcion":"HIPOALBUMINEMIA"
  },
  {
    "codigo":20943002,
    "descripcion":"CERVICITIS GONOCÓCICA AGUDA"
  },
  {
    "codigo":314020001,
    "descripcion":"QUERATITIS VIRAL"
  },
  {
    "codigo":248484004,
    "descripcion":"SACO LAGRIMAL TUMEFACTO"
  },
  {
    "codigo":1297060005,
    "descripcion":"CIERRE DE ÁNGULO DE OJO DERECHO DEBIDO A UVEÍTIS"
  },
  {
    "codigo":838308007,
    "descripcion":"DISPLASIA FIBROMUSCULAR DE PARED DE ARTERIA INTRACRANEAL"
  },
  {
    "codigo":50041000,
    "descripcion":"VÉRTIGO OBJETIVO"
  },
  {
    "codigo":17273001,
    "descripcion":"CRIPTOCOCOSIS MUCOCUTÁNEA"
  },
  {
    "codigo":443257002,
    "descripcion":"EFECTO COLATERAL DE FÁRMACO DE USO ENDOCRINOLÓGICO"
  },
  {
    "codigo":19108007,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN LA REGIÓN DEL TRONCO, CON INFECCIÓN"
  },
  {
    "codigo":836473006,
    "descripcion":"NIVEL DE EXCITABILIDAD EMOCIONAL NORMAL"
  },
  {
    "codigo":1162318001,
    "descripcion":"LORDOSIS DEBIDA A INFECCIÓN Y POSTERIOR A ELLA"
  },
  {
    "codigo":111907002,
    "descripcion":"INFECCIÓN CAUSADA POR MORTIERELLA WOLFII"
  },
  {
    "codigo":308515006,
    "descripcion":"SITUACIÓN DEL CONTROL GINECOLÓGICO - MUJER SANA"
  },
  {
    "codigo":79139007,
    "descripcion":"ACARICIAR"
  },
  {
    "codigo":13603008,
    "descripcion":"DETERMINACIÓN DEL RESULTADO: MUERTE EVITABLE DERIVADA DE UN ERROR EN LA TÉCNICA"
  },
  {
    "codigo":110072001,
    "descripcion":"LACERACIÓN SIMPLE DE LA NARIZ"
  },
  {
    "codigo":763597000,
    "descripcion":"ATAXIA HEREDITARIA"
  },
  {
    "codigo":370381000,
    "descripcion":"ECOGRAFÍA PRENATAL INCAPAZ DE CONFIRMAR EMBARAZO"
  },
  {
    "codigo":12106611000119107,
    "descripcion":"QUEMADURA DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":1156813002,
    "descripcion":"ENFERMEDAD DE GAUCHER CON OFTALMOPLEJÍA Y CALCIFICACIÓN CARDIOVASCULAR"
  },
  {
    "codigo":237474000,
    "descripcion":"CONTRACTURA CAPSULAR DE MAMA"
  },
  {
    "codigo":403149008,
    "descripcion":"HERIDA POR PICADURA DE ARAÑA"
  },
  {
    "codigo":401314000,
    "descripcion":"INFARTO AGUDO DE MIOCARDIO SIN ELEVACIÓN DEL SEGMENTO ST"
  },
  {
    "codigo":366711000,
    "descripcion":"AMPLITUD DE MOVIMIENTO ACTIVO DE ABDUCCIÓN DE DEDO DEL PIE - HALLAZGO"
  },
  {
    "codigo":8098009,
    "descripcion":"ENFERMEDAD INFECCIOSA TRANSMITIDA POR VÍA SEXUAL"
  },
  {
    "codigo":301175001,
    "descripcion":"INGURGITACIÓN VENOSA"
  },
  {
    "codigo":71799002,
    "descripcion":"ESTENOSIS DE VÁLVULA MITRAL REUMÁTICA E INSUFICIENCIA DE VÁLVULA AÓRTICA"
  },
  {
    "codigo":15930381000119104,
    "descripcion":"EDEMA DE AMBAS PAPILAS ÓPTICAS"
  },
  {
    "codigo":170103007,
    "descripcion":"EVALUACIÓN AL NACER ANORMAL - PARA OBSERVACIÓN"
  },
  {
    "codigo":1251447008,
    "descripcion":"DEFICIENCIA DE NAD(P)HX EPIMERASA"
  },
  {
    "codigo":235639009,
    "descripcion":"FÍSTULA ESOFÁGICA INTERNA"
  },
  {
    "codigo":397644002,
    "descripcion":"MANTENIMIENTO DEL DERECHO A LA PRIVACIDAD"
  },
  {
    "codigo":299340006,
    "descripcion":"AMPLITUD DE FLEXIÓN PASIVA DE LA RODILLA NORMAL"
  },
  {
    "codigo":364876007,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA GIRAR EL CUERPO"
  },
  {
    "codigo":233804009,
    "descripcion":"DEHISCENCIA DE ANASTOMOSIS BRONQUIAL"
  },
  {
    "codigo":2593002,
    "descripcion":"SÍNDROME DE DUBOWITZ"
  },
  {
    "codigo":363041004,
    "descripcion":"ANEMIA HEMOLÍTICA NO ESFEROCÍTICA CONGÉNITA POR METABOLOPATÍA CONGÉNITA"
  },
  {
    "codigo":723489005,
    "descripcion":"SUBSÍNDROME HEMATOPOYÉTICO DEL SÍNDROME AGUDO POR RADIACIÓN"
  },
  {
    "codigo":231969006,
    "descripcion":"CUERPO EXTRAÑO EN CRISTALINO"
  },
  {
    "codigo":1149473005,
    "descripcion":"TROMBOFLEBITIS DE AMBAS EXTREMIDADES INFERIORES EN EL PUERPERIO"
  },
  {
    "codigo":789025008,
    "descripcion":"REQUIERE VACUNACIÓN ANTIDIFTÉRICA"
  },
  {
    "codigo":461345005,
    "descripcion":"ORIFICIO DE ARTERIA CORONARIA ANORMALMENTE BAJO"
  },
  {
    "codigo":758002,
    "descripcion":"QUISTE DEL ÚTERO"
  },
  {
    "codigo":721654005,
    "descripcion":"ENFERMEDAD DIVERTICULAR DE INTESTINO DELGADO Y GRUESO"
  },
  {
    "codigo":262902006,
    "descripcion":"HEMATOMA DE VÍA URINARIA"
  },
  {
    "codigo":66294006,
    "descripcion":"OBSTRUCCIÓN POR PARTES BLANDAS PÉLVICAS ANORMALES"
  },
  {
    "codigo":293835000,
    "descripcion":"ALERGIA A INHIBIDOR DE MONOAMINOOXIDASA"
  },
  {
    "codigo":719819004,
    "descripcion":"COMPLEJO DE XERODERMIA PIGMENTOSA Y SÍNDROME DE COCKAYNE"
  },
  {
    "codigo":228299005,
    "descripcion":"BEBE CON LA FAMILIA"
  },
  {
    "codigo":1076391000119106,
    "descripcion":"DEPÓSITO DE CALCIO EN BOLSA SEROSA DE PIE DERECHO"
  },
  {
    "codigo":11863361000119100,
    "descripcion":"AMPOLLA DE SEGUNDO A QUINTO DEDO DE PIE IZQUIERDO, CON INFECCIÓN"
  },
  {
    "codigo":95392007,
    "descripcion":"EDEMA EN EL SITIO DE INYECCIÓN"
  },
  {
    "codigo":292000005,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ALCALOIDE DEL CORNEZUELO DE CENTENO"
  },
  {
    "codigo":93557001,
    "descripcion":"HOLORRAQUISQUISIS"
  },
  {
    "codigo":15985831000119107,
    "descripcion":"DISTONÍA DE LA MANO IZQUIERDA"
  },
  {
    "codigo":57119000,
    "descripcion":"HIPERAMONEMIA, TIPO III"
  },
  {
    "codigo":286495000,
    "descripcion":"CAPAZ DE PREPARAR COMIDA PARA ANIMALES"
  },
  {
    "codigo":253727002,
    "descripcion":"PREDOMINIO VARIABLE DE CIRCULACIÓN CORONARIA"
  },
  {
    "codigo":1269535003,
    "descripcion":"SÍNDROME DE CORDÓN CENTRAL DE MÉDULA CERVICAL DEBIDO A LUXACIÓN EXPUESTA DE COLUMNA CERVICAL"
  },
  {
    "codigo":384799007,
    "descripcion":"MARGEN LATERAL (MUCOSO\/MURAL) DE RESECCIÓN QUIRÚRGICA AFECTADO POR CARCINOMA IN SITU"
  },
  {
    "codigo":188191009,
    "descripcion":"NEOPLASIA MALIGNA DEL FONDO DEL CUERPO UTERINO"
  },
  {
    "codigo":88052002,
    "descripcion":"MUTISMO"
  },
  {
    "codigo":251892004,
    "descripcion":"PRUEBA DE ESFUERZO - HALLAZGO"
  },
  {
    "codigo":448500006,
    "descripcion":"CONEXIÓN VENOSA PULMONAR ANÓMALA DE LOCALIZACIÓN INTRACARDÍCA"
  },
  {
    "codigo":284660006,
    "descripcion":"ROMPER VENTANAS"
  },
  {
    "codigo":1003721002,
    "descripcion":"DOLOR DE ARTICULACIÓN DE RODILLA"
  },
  {
    "codigo":282825002,
    "descripcion":"FIBRILACIÓN AURICULAR PAROXÍSTICA"
  },
  {
    "codigo":250057003,
    "descripcion":"ANORMALIDAD SIMULADA DE LA MARCHA"
  },
  {
    "codigo":20681005,
    "descripcion":"PERFORACIÓN DE DISPOSITIVO CARDÍACO"
  },
  {
    "codigo":413897002,
    "descripcion":"DESTOXIFICACIÓN COMUNITARIA REGISTRADA"
  },
  {
    "codigo":1231262001,
    "descripcion":"LESIÓN PERFORANTE DE GLOBO OCULAR"
  },
  {
    "codigo":315593009,
    "descripcion":"NECESIDAD DE INTÉRPRETE"
  },
  {
    "codigo":1264030002,
    "descripcion":"DOLOR EN MÚSCULO DE TOBILLO"
  },
  {
    "codigo":444830001,
    "descripcion":"NEFRONOPTISIS JUVENIL"
  },
  {
    "codigo":18846006,
    "descripcion":"NÁUSEAS Y VÓMITOS INDUCIDOS POR QUIMIOTERAPIA"
  },
  {
    "codigo":84382006,
    "descripcion":"NACIMIENTO PREMATURO DE GEMELOS DICIGÓTICOS, AMBOS MUERTOS"
  },
  {
    "codigo":82547005,
    "descripcion":"MENINGOENCEFALITIS ADENOVIRAL AGUDA"
  },
  {
    "codigo":277320000,
    "descripcion":"RUPTURA DE ANEURISMA DE LA ARTERIA COMUNICANTE ANTERIOR"
  },
  {
    "codigo":1293128000,
    "descripcion":"HEMANGIOMA ANASTOMOSANTE"
  },
  {
    "codigo":770675008,
    "descripcion":"NEOPLASIA DE VÉRTEBRA DORSAL"
  },
  {
    "codigo":211784002,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO PROFUNDA DE GLÚTEO"
  },
  {
    "codigo":47944004,
    "descripcion":"MALA OCLUSIÓN DENTAL"
  },
  {
    "codigo":768840005,
    "descripcion":"MORDIDA CRUZADA ANTERIOR CON DESTRUCCIÓN DE LA MUCOSA BUCAL"
  },
  {
    "codigo":703304005,
    "descripcion":"ENCEFALOPATÍA HIPÓXICA ISQUÉMICA DEBIDA A ESTRANGULAMIENTO"
  },
  {
    "codigo":1260360005,
    "descripcion":"DISTONÍA DEBIDA A NEURODEGENERACIÓN ATÍPICA ASOCIADA A PANTOTENATO CINASA"
  },
  {
    "codigo":373789000,
    "descripcion":"RETRASO DEL TRATAMIENTO - MOTIVO LOGÍSTICO"
  },
  {
    "codigo":80712009,
    "descripcion":"ESPONDILÓLISIS CONGÉNITA DE LA REGIÓN LUMBOSACRA"
  },
  {
    "codigo":1078901000119100,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE LÓBULO SUPERIOR DE PULMÓN IZQUIERDO"
  },
  {
    "codigo":111645003,
    "descripcion":"FRACTURA EXPUESTA DE EXTREMO PROXIMAL DE TIBIA"
  },
  {
    "codigo":40411000119106,
    "descripcion":"PRÓSTATA NODULAR SIN OBSTRUCCIÓN URINARIA"
  },
  {
    "codigo":408392008,
    "descripcion":"BAJO ATENCIÓN DE ENFERMERA ESPECIALIZADA EN DIABETES"
  },
  {
    "codigo":767005006,
    "descripcion":"LUXACIÓN CONGÉNITA DE CADERA DERECHA CONCOMITANTE CON SUBLUXACIÓN CONGÉNITA DE CADERA IZQUIERDA"
  },
  {
    "codigo":406557007,
    "descripcion":"PREFIERE COOPERAR CON UN PUNTO DE CONTACTO"
  },
  {
    "codigo":765170001,
    "descripcion":"EPILEPSIA CON ENCEFALOPATÍA RELACIONADA CON LA SUBUNIDAD 8 DEL CANAL DE SODIO ALFA DEPENDIENTE DEL VOLTAJE"
  },
  {
    "codigo":46109009,
    "descripcion":"ISQUEMIA SUBENDOCÁRDICA"
  },
  {
    "codigo":109810004,
    "descripcion":"CELULITIS DE LA LENGUA"
  },
  {
    "codigo":16834011000119109,
    "descripcion":"OBSTRUCCIÓN PARCIAL DE INTESTINO"
  },
  {
    "codigo":44274007,
    "descripcion":"NEUMONITIS INTERSTICIAL LINFOIDE"
  },
  {
    "codigo":271815000,
    "descripcion":"PIEL GRUESA"
  },
  {
    "codigo":240882007,
    "descripcion":"NÓDULO POR ESCABIOSIS"
  },
  {
    "codigo":1254855005,
    "descripcion":"DERMATITIS DE CONTACTO FOTOALÉRGICA DEBIDA A SUSTANCIA VEGETAL"
  },
  {
    "codigo":1287623005,
    "descripcion":"ESPASMOS EPILÉPTICOS DE INICIO FOCAL NEONATALES"
  },
  {
    "codigo":402887007,
    "descripcion":"INFECCIÓN PRIMARIA POR HERPES SIMPLEX"
  },
  {
    "codigo":827036000,
    "descripcion":"ÚLCERA TRÓFICA DE PIEL"
  },
  {
    "codigo":341621000119106,
    "descripcion":"DACRIOADENITIS CRÓNICA DE OJO IZQUIERDO"
  },
  {
    "codigo":366449000,
    "descripcion":"HALLAZGO RELACIONADO CON LA PRUEBA DE LASÈGUE"
  },
  {
    "codigo":1351324009,
    "descripcion":"INMUNODEFICIENCIA COMBINADA AUTOSÓMICA DOMINANTE DEBIDA A DEFICIENCIA DE PROTEÍNA DE INTERACCIÓN ERBB2"
  },
  {
    "codigo":391919221000119107,
    "descripcion":"MELANOMA MALIGNO DE PIEL DE DEDO DE MANO IZQUIERDA"
  },
  {
    "codigo":315151000119101,
    "descripcion":"OSTEOCONDRITIS DISECANTE DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":73372008,
    "descripcion":"INFECCIÓN CAUSADA POR MESOCESTOIDES"
  },
  {
    "codigo":202609006,
    "descripcion":"CHASQUIDO DE RODILLA"
  },
  {
    "codigo":300913006,
    "descripcion":"ALERGIA A MARISCO"
  },
  {
    "codigo":102470001,
    "descripcion":"RESPUESTA TERAPÉUTICA DISMINUIDA"
  },
  {
    "codigo":299078001,
    "descripcion":"AMPLITUD DE EXTENSIÓN ACTIVA DE DEDO DE LA MANO DISMINUIDA"
  },
  {
    "codigo":395547001,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA PROFUNDA NO AFECTADO POR NEOPLASIA MALIGNA"
  },
  {
    "codigo":721392000,
    "descripcion":"SÍNDROME DEL CORDÓN POSTERIOR DE MÉDULA ESPINAL AL NIVEL DEL TERCER SEGMENTO CERVICAL"
  },
  {
    "codigo":496002,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE LA TERCERA VÉRTEBRA CERVICAL"
  },
  {
    "codigo":197104005,
    "descripcion":"DIVERTÍCULO PERFORADO DE INTESTINO"
  },
  {
    "codigo":31429000,
    "descripcion":"DISGENESIA CEREBRAL CORTICAL"
  },
  {
    "codigo":129733003,
    "descripcion":"LESIÓN DE FORMA REDONDEADA"
  },
  {
    "codigo":293573005,
    "descripcion":"REACCIÓN ADVERSA A LA ALTEPLASA"
  },
  {
    "codigo":783258000,
    "descripcion":"DEMENCIA FAMILIAR, TIPO DANÉS"
  },
  {
    "codigo":226202001,
    "descripcion":"DIETA SIN NUEZ DE BRASIL"
  },
  {
    "codigo":62362001,
    "descripcion":"INFECCIÓN CAUSADA POR EUSTRONGYLIDES"
  },
  {
    "codigo":288681000119103,
    "descripcion":"VÍCTIMA ADULTA DE MALTRATO FÍSICO PERPETRADO POR PAREJA MASCULINA"
  },
  {
    "codigo":95130006,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE EPIPLÓN"
  },
  {
    "codigo":193434008,
    "descripcion":"COROIDITIS YUXTAPAPILAR FOCAL"
  },
  {
    "codigo":1141871004,
    "descripcion":"SIGNO EN V"
  },
  {
    "codigo":93295005,
    "descripcion":"HIPOPLASIA CONGÉNITA DEL ASTRÁGALO"
  },
  {
    "codigo":289903006,
    "descripcion":"MENOPAUSIA PRESENTE"
  },
  {
    "codigo":715887004,
    "descripcion":"ANAFILAXIA CAUSADA POR SAL SULFITO"
  },
  {
    "codigo":27759007,
    "descripcion":"INTOXICACIÓN POR BRASSICA RAPA"
  },
  {
    "codigo":124228001,
    "descripcion":"DEFICIENCIA DE OXIDASA"
  },
  {
    "codigo":224367008,
    "descripcion":"EXPERIENCIA LABORAL"
  },
  {
    "codigo":25924004,
    "descripcion":"LITIASIS BILIAR CON COLECISTITIS"
  },
  {
    "codigo":1269273000,
    "descripcion":"NEOPLASIA MALIGNA DIAGNOSTICADA DURANTE EMBARAZO"
  },
  {
    "codigo":187929000,
    "descripcion":"NEOPLASIA MALIGNA DE OMÓPLATO Y HUESOS LARGOS DEL BRAZO"
  },
  {
    "codigo":253465005,
    "descripcion":"AUSENCIA DE VALVAS DE VÁLVULA AURICULOVENTRICULAR DERECHA"
  },
  {
    "codigo":349861000221102,
    "descripcion":"HEPATITIS C EXPUESTO PERINATAL"
  },
  {
    "codigo":286233008,
    "descripcion":"NO USA EL FLUJO DE AIRE PALATINO PARA HABLAR"
  },
  {
    "codigo":98371000119102,
    "descripcion":"QUISTE RENAL COMPLEJO ADQUIRIDO"
  },
  {
    "codigo":448238009,
    "descripcion":"CRECIMIENTO PAPILAR DE VEJIGA"
  },
  {
    "codigo":344131000119104,
    "descripcion":"RETRACCIÓN DE ÁNGULO DE CÁMARA DE AMBOS OJOS"
  },
  {
    "codigo":249795004,
    "descripcion":"AUSENCIA DE HUESO EN PIE"
  },
  {
    "codigo":774083009,
    "descripcion":"ANEMIA HEMOLÍTICA AUTOINMUNITARIA NEONATAL"
  },
  {
    "codigo":247960003,
    "descripcion":"NO SE DESPIERTA FÁCILMENTE DURANTE EPISODIO DE SONAMBULISMO"
  },
  {
    "codigo":442733008,
    "descripcion":"HEMIPLEJÍA COMO EFECTO TARDÍO DE ACCIDENTE CEREBROVASCULAR"
  },
  {
    "codigo":82285009,
    "descripcion":"DIETA HIPOGRASA PARA MANDÍBULA ALAMBRADA"
  },
  {
    "codigo":80450002,
    "descripcion":"AMPOLLA DEL PERINEO, SIN INFECCIÓN"
  },
  {
    "codigo":1081411000119109,
    "descripcion":"NEOPLASIA FILOIDE BENIGNA DE MAMA IZQUIERDA"
  },
  {
    "codigo":153821000119103,
    "descripcion":"ISQUEMIA VISCERAL"
  },
  {
    "codigo":735810004,
    "descripcion":"HERIDA PUNZANTE DE DEDO DE LA MANO SIN CUERPO EXTRAÑO"
  },
  {
    "codigo":733975003,
    "descripcion":"CARIES DENTAL INACTIVA SECUNDARIA QUE SE EXTIENDE HASTA EL ESMALTE"
  },
  {
    "codigo":111383007,
    "descripcion":"SIALIDOSIS DISMÓRFICA, FORMA JUVENIL"
  },
  {
    "codigo":109548000,
    "descripcion":"PALADAR HENDIDO BILATERAL"
  },
  {
    "codigo":1354732003,
    "descripcion":"FRACTURA DE SÉPTIMA COSTILLA"
  },
  {
    "codigo":16019831000119100,
    "descripcion":"SINOVITIS TRANSITORIA DE TOBILLO DERECHO"
  },
  {
    "codigo":304321000,
    "descripcion":"AMPLITUD DEL MOVIMIENTO DE LA RODILLA DISMINUIDA"
  },
  {
    "codigo":11244009,
    "descripcion":"SÍNDROME POLIGLANDULAR AUTOINMUNITARIO, TIPO 1"
  },
  {
    "codigo":74945001,
    "descripcion":"ABSCESO UTERINO"
  },
  {
    "codigo":238785001,
    "descripcion":"VASCULITIS CUTÁNEA PRIMARIA"
  },
  {
    "codigo":42177007,
    "descripcion":"FRECUENCIA DEL PULSO DISMINUIDA"
  },
  {
    "codigo":1252758001,
    "descripcion":"FRACTURA DE ARCO CIGOMÁTICO"
  },
  {
    "codigo":235115003,
    "descripcion":"ANGIOPATÍA HIALINA CON CÉLULAS GIGANTES"
  },
  {
    "codigo":366187004,
    "descripcion":"REFLEJO DE SUCCIÓN - HALLAZGO"
  },
  {
    "codigo":267883008,
    "descripcion":"ARTRITIS REACTIVA POSTINFECCIÓN GENITOURINARIA"
  },
  {
    "codigo":167744001,
    "descripcion":"NIVEL DE CLORURO EN LÍQUIDO CEFALORRAQUÍDEO POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":298816003,
    "descripcion":"AMPLITUD DE ADUCCIÓN PASIVA DE HOMBRO AUMENTADA"
  },
  {
    "codigo":724800005,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚLTIPLES NERVIOS EN LA MANO"
  },
  {
    "codigo":722965000,
    "descripcion":"PARKINSONISMO DEBIDO A TRASTORNO NEURODEGENERATIVO"
  },
  {
    "codigo":231445001,
    "descripcion":"TRASTORNO ORGÁNICO DE DISOCIACIÓN"
  },
  {
    "codigo":65770000,
    "descripcion":"FERTILIDAD AUMENTADA"
  },
  {
    "codigo":295146001,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE FENAZOCINA"
  },
  {
    "codigo":296981008,
    "descripcion":"SOBREDOSIS DE ANTIARRÍTMICO DE CLASE I"
  },
  {
    "codigo":426218005,
    "descripcion":"TENDINITIS DEL FLEXOR LARGO DEL DEDO GORDO"
  },
  {
    "codigo":162239000,
    "descripcion":"DEBILIDAD ABDOMINAL"
  },
  {
    "codigo":33002009,
    "descripcion":"SÍNTESIS MACROMOLECULAR DEFECTUOSA"
  },
  {
    "codigo":293311002,
    "descripcion":"REACCIÓN ADVERSA A PENTALMIDÓN"
  },
  {
    "codigo":63935007,
    "descripcion":"AUSENCIA CONGÉNITA DE PESTAÑAS"
  },
  {
    "codigo":15747601000119105,
    "descripcion":"MASA DE MÚSCULO DE EXTREMIDAD SUPERIOR DERECHA"
  },
  {
    "codigo":62100001,
    "descripcion":"OSTEOCONDROSIS JUVENIL DE LA EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":94868002,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL NERVIO HIPOGLOSO"
  },
  {
    "codigo":225940004,
    "descripcion":"USA MEDIAS RARAS"
  },
  {
    "codigo":1340052006,
    "descripcion":"TUMOR GLÓMICO BENIGNO"
  },
  {
    "codigo":74411000119100,
    "descripcion":"NEOPLASIA PROSTÁTICA INTRAEPITELIAL Y ATIPIA ADYACENTE"
  },
  {
    "codigo":346641000119107,
    "descripcion":"GRANULOMA DE CONJUNTIVA DE AMBOS OJOS"
  },
  {
    "codigo":289641002,
    "descripcion":"ÚTERO FIRME"
  },
  {
    "codigo":715625007,
    "descripcion":"RETRASO DE CRECIMIENTO DEBIDO A RESISTENCIA AL FACTOR DE CRECIMIENTO I SIMILAR A LA INSULINA"
  },
  {
    "codigo":93033008,
    "descripcion":"ATRESIA DE VENA CAVA SUPERIOR"
  },
  {
    "codigo":60265009,
    "descripcion":"ABORTO ESPONTÁNEO CON EMBOLIA GASEOSA"
  },
  {
    "codigo":224105007,
    "descripcion":"MIEMBRO DE FAMILIA SUSTITUTA POR UN PERÍODO BREVE"
  },
  {
    "codigo":123966004,
    "descripcion":"PROTOPORFIRINURIA"
  },
  {
    "codigo":1083921000119109,
    "descripcion":"DISFUNCIÓN DE AMBAS ESTRUCTURAS LABERÍNTICAS"
  },
  {
    "codigo":253203003,
    "descripcion":"HIPOPLASIA DE CIRCUNVOLUCIONES CEREBRALES"
  },
  {
    "codigo":449811004,
    "descripcion":"MARCHA ESTABLE"
  },
  {
    "codigo":56595005,
    "descripcion":"HIPERTIROSINEMIA"
  },
  {
    "codigo":41011000087101,
    "descripcion":"FRACTURA POR AVULSIÓN DE FALANGE DE DEDO PULGAR IZQUIERDO"
  },
  {
    "codigo":46131000087103,
    "descripcion":"FRACTURA DE EXTREMO DISTAL DE HÚMERO IZQUIERDO"
  },
  {
    "codigo":1010483009,
    "descripcion":"ESCLEROSIS DE EPÍFISIS DE FALANGE MEDIA DE DEDO ANULAR CON RADIOPACIDAD AUMENTADA"
  },
  {
    "codigo":43571000087100,
    "descripcion":"CONTUSIÓN DE PÁRPADO SUPERIOR DERECHO"
  },
  {
    "codigo":10969771000119106,
    "descripcion":"HERIDA ABIERTA DE MUSLO DERECHO DEBIDA A MORDEDURA DE PERRO"
  },
  {
    "codigo":284136008,
    "descripcion":"INCAPAZ DE MOVER LAS CUATRO EXTREMIDADES"
  },
  {
    "codigo":282301004,
    "descripcion":"NO MANTIENE EL EQUILIBRIO"
  },
  {
    "codigo":249533007,
    "descripcion":"OBESIDAD ABDOMINAL"
  },
  {
    "codigo":247698000,
    "descripcion":"SUBESTIMA EL PESO DE SU CUERPO"
  },
  {
    "codigo":870290001,
    "descripcion":"MIELOPATÍA DEBIDA A DEFICIENCIA DE VIRAMINA B12"
  },
  {
    "codigo":1263506002,
    "descripcion":"TRASTORNO MIOCLÓNICO DEBIDO A LIPOFUSCINOSIS CEROIDE NEURONAL"
  },
  {
    "codigo":83858001,
    "descripcion":"INDICANURIA"
  },
  {
    "codigo":313234004,
    "descripcion":"ANTICUERPOS ANTI-HEPATITIS B PRESENTES"
  },
  {
    "codigo":18322005,
    "descripcion":"TROMBOSIS DE LA PRENSA DE HERÓFILO"
  },
  {
    "codigo":49255002,
    "descripcion":"CONVULSIÓN URÉMICA"
  },
  {
    "codigo":278631002,
    "descripcion":"PRÓTESIS DENTAL FLOJA"
  },
  {
    "codigo":735548000,
    "descripcion":"TRASTORNO DISOCIATIVO CON SÍNTOMA NEUROLÓGICO CONCOMITANTE CON MAREOS"
  },
  {
    "codigo":1163367008,
    "descripcion":"DECOLORACIÓN DENTAL INTRÍNSECA POR TETRACICLINA"
  },
  {
    "codigo":213095008,
    "descripcion":"PROMINENCIA DE TORNILLO"
  },
  {
    "codigo":16487009,
    "descripcion":"PROMISCUIDAD SEXUAL DE ADOLESCENTE FEMENINA"
  },
  {
    "codigo":276796006,
    "descripcion":"TAQUICARDIA AURICULAR"
  },
  {
    "codigo":307729008,
    "descripcion":"METAPLASIA DE TRÍGONO"
  },
  {
    "codigo":10671071000119102,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN EN PIERNA IZQUIERDA NO ESTADIFICABLE"
  },
  {
    "codigo":305894003,
    "descripcion":"VISTO POR EL SERVICIO DE NEUROCIRUGÍA"
  },
  {
    "codigo":10982004,
    "descripcion":"CELULITIS DEL CORDÓN ESPERMÁTICO"
  },
  {
    "codigo":109286005,
    "descripcion":"MELANOMA IN SITU DE PIEL DE MAMA"
  },
  {
    "codigo":240358005,
    "descripcion":"ENTEROCOLITIS NEUTROPÉNICA"
  },
  {
    "codigo":402363004,
    "descripcion":"GRANULOMA ANULAR LOCALIZADO"
  },
  {
    "codigo":105616000,
    "descripcion":"HERIDA ABIERTA DE UNA EXTREMIDAD"
  },
  {
    "codigo":1156027008,
    "descripcion":"TROMBO DE SENO DURAL EN EL EMBARAZO"
  },
  {
    "codigo":9147009,
    "descripcion":"OSTEOPOIQUILOSIS"
  },
  {
    "codigo":369595009,
    "descripcion":"TUMOR MALIGNO CON COMPROMISO DE ÓRGANO POR PROPAGACIÓN DIRECTA DESDE ENDOMETRIO"
  },
  {
    "codigo":365925001,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD DE TOMAR DECISIONES ELABORADAS"
  },
  {
    "codigo":726373003,
    "descripcion":"DELECIÓN DE PARTE DEL BRAZO LARGO DEL CROMOSOMA 5"
  },
  {
    "codigo":724538004,
    "descripcion":"DIVERTICULOSIS DE INTESTINO GRUESO"
  },
  {
    "codigo":349151000119109,
    "descripcion":"ABSCESO DE REGIÓN PERIORBITARIA DE AMBOS OJOS"
  },
  {
    "codigo":3642008,
    "descripcion":"DEFICIENCIA DE ESTÉRIL - SULFATASA"
  },
  {
    "codigo":298554009,
    "descripcion":"AMPLITUD DE ROTACIÓN ACTIVA HACIA LA DERECHA DE LA COLUMNA DORSAL VERTEBRAL, AUMENTADA"
  },
  {
    "codigo":722703002,
    "descripcion":"HEMORRAGIA INTRAVENTRICULAR TRAUMÁTICA"
  },
  {
    "codigo":15723641000119104,
    "descripcion":"TRASTORNO DE BOLSA SEROSA DE AMBOS HOMBROS"
  },
  {
    "codigo":395023004,
    "descripcion":"PACIENTE DISCONFORME CON EL ESQUEMA FARMACOLÓGICO"
  },
  {
    "codigo":296719007,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE CEFTIZOXIMA"
  },
  {
    "codigo":427791009,
    "descripcion":"INCOMPETENCIA VELOFARÍNGEA CONGÉNITA"
  },
  {
    "codigo":32740005,
    "descripcion":"HERNIA LUMBAR CON GANGRENA"
  },
  {
    "codigo":161977000,
    "descripcion":"DOLOR DEL REBORDE COSTAL"
  },
  {
    "codigo":65508009,
    "descripcion":"GRANULOMA ANULAR"
  },
  {
    "codigo":260281002,
    "descripcion":"VISIÓN A DISTANCIA 3\/6"
  },
  {
    "codigo":131044009,
    "descripcion":"NIVEL DE HORMONA CORTICOSUPRARRENAL POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":30905007,
    "descripcion":"FRACTURA SUPRACONDÍLEA DE FÉMUR NO EXPUESTA"
  },
  {
    "codigo":293049008,
    "descripcion":"REACCIÓN ADVERSA A LA DOXICICLINA"
  },
  {
    "codigo":94606003,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE ESTÓMAGO"
  },
  {
    "codigo":717198004,
    "descripcion":"BACTEROIDES BUCCAE O BACTEROIDES ORIS"
  },
  {
    "codigo":127374005,
    "descripcion":"MÁS DE 10 EMBARAZOS"
  },
  {
    "codigo":29070004,
    "descripcion":"FIBROESCLEROSIS DE LA MAMA"
  },
  {
    "codigo":27235001,
    "descripcion":"INFECCIÓN HEPÁTICA POR ECHINOCOCCUS MULTILOCULARIS"
  },
  {
    "codigo":289379002,
    "descripcion":"NIVEL -3 DE LA PRESENTACIÓN EN RELACIÓN CON LAS ESPINAS ISQUIÁTICAS"
  },
  {
    "codigo":92771003,
    "descripcion":"CARCINOMA IN SITU DEL PILAR AMIGDALINO"
  },
  {
    "codigo":254776001,
    "descripcion":"NEVOS ANGIOMATOSOS MÚLTIPLES DE LA PIEL"
  },
  {
    "codigo":713528004,
    "descripcion":"ERUPCIÓN DE LA PIEL CAUSADA POR FÁRMACO ANTIRRETROVIRAL"
  },
  {
    "codigo":611211000124100,
    "descripcion":"SEGURIDAD DEL DOMICILIO"
  },
  {
    "codigo":123704008,
    "descripcion":"ECCEMA LIQUENIFICADO"
  },
  {
    "codigo":1931000124106,
    "descripcion":"TRANSICIÓN DE LA ATENCIÓN PROLONGADA A ATENCIÓN AGUDA"
  },
  {
    "codigo":460171000124107,
    "descripcion":"FRACTURA DE HUESO DE MANO DERECHA"
  },
  {
    "codigo":416781007,
    "descripcion":"TIEMPO DE REACCIÓN NORMAL"
  },
  {
    "codigo":1137677007,
    "descripcion":"DESARROLLO FISIOLÓGICO FETAL NORMAL"
  },
  {
    "codigo":285709007,
    "descripcion":"LESIÓN ARTERIAL EN CABEZA Y CUELLO"
  },
  {
    "codigo":296211000119108,
    "descripcion":"ALTERACIÓN DE CUERNO POSTERIOR DE MENISCO EXTERNO DEBIDA A LESIÓN TRAUMÁTICA DE RODILLA"
  },
  {
    "codigo":87266004,
    "descripcion":"EMBOLIA CAUSADA POR CUALQUIER DISPOSITIVO, IMPLANTE Y\/O INJERTO"
  },
  {
    "codigo":351661000119103,
    "descripcion":"NEVO MELANOCÍTICO DE MIEMBRO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":54498006,
    "descripcion":"ESTADIO C1 DE DUKES MODIFICADO"
  },
  {
    "codigo":249271000,
    "descripcion":"AUSENCIA DE ESMEGMA"
  },
  {
    "codigo":118199002,
    "descripcion":"HALLAZGO RELACIONADO CON LA SEXUALIDAD Y LA ACTIVIDAD SEXUAL"
  },
  {
    "codigo":282039003,
    "descripcion":"TRASTORNO DE LOS HUESECILLOS DEL OÍDO"
  },
  {
    "codigo":216503006,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR SECOBARBITAL"
  },
  {
    "codigo":1197708008,
    "descripcion":"ÚLCERA GÁSTRICA POR VASCULITIS"
  },
  {
    "codigo":704353000,
    "descripcion":"CON MAYOR RIESGO DE LESIÓN TRAUMÁTICA AMBIENTAL"
  },
  {
    "codigo":1163105007,
    "descripcion":"ENCEFALITIS POR VIRUS ALFUY"
  },
  {
    "codigo":47158003,
    "descripcion":"INFECCIÓN POR HONGOS DEMATIÁCEOS"
  },
  {
    "codigo":14390004,
    "descripcion":"MASTITIS ACTINOBACILAR"
  },
  {
    "codigo":276534008,
    "descripcion":"FILTRACIÓN DE AIRE PULMONAR EN EL NEONATO"
  },
  {
    "codigo":473142008,
    "descripcion":"PROTRUSIÓN DE DISPOSITIVO DE FIJACIÓN INTERNA"
  },
  {
    "codigo":342070009,
    "descripcion":"FRACTURA NO EXPUESTA DEL PIE"
  },
  {
    "codigo":241931004,
    "descripcion":"ANAFILAXIA PRODUCIDA POR PICADURA DE ABEJA"
  },
  {
    "codigo":766219005,
    "descripcion":"INTOXICACIÓN POR METACUALONA"
  },
  {
    "codigo":373003007,
    "descripcion":"INFECCIÓN CAUSADA POR ASPERGILLUS TERREUS"
  },
  {
    "codigo":240096000,
    "descripcion":"CITOPATÍA MITOCONDRIAL"
  },
  {
    "codigo":405771009,
    "descripcion":"CIFOESCOLIOSIS ADQUIRIDA"
  },
  {
    "codigo":209163009,
    "descripcion":"SUBLUXACIÓN VERTEBRAL EXPUESTA CON LESIÓN MEDULAR ANTERIOR A NIVEL CERVICAL"
  },
  {
    "codigo":733451007,
    "descripcion":"TRASTORNO CONGÉNITO DE GLICOSILACIÓN TIPO 1S"
  },
  {
    "codigo":403936002,
    "descripcion":"SIRINGOFIBROADENOMA ECRINO DE LA PIEL"
  },
  {
    "codigo":698848005,
    "descripcion":"DISTROFIA DE RETINA HEREDITARIA QUE AFECTA PRINCIPALMENTE A LA RETINA SENSORIAL"
  },
  {
    "codigo":762549008,
    "descripcion":"DERMATITIS ALÉRGICA POR CONTACTO OCUPACIONAL CAUSADA POR FRAGANCIA"
  },
  {
    "codigo":367498001,
    "descripcion":"RINITIS ALÉRGICA ESTACIONAL"
  },
  {
    "codigo":1186698001,
    "descripcion":"AMBIENTE DE AISLAMIENTO"
  },
  {
    "codigo":170890002,
    "descripcion":"CAMBIO EN LOS SÍNTOMAS OTORRINOLARINGOLÓGICOS"
  },
  {
    "codigo":12203591000119109,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DE ANTEBRAZO IZQUIERDO"
  },
  {
    "codigo":236426006,
    "descripcion":"NECROSIS TUBULAR AGUDA POSOPERATORIA"
  },
  {
    "codigo":300127002,
    "descripcion":"ESTRECHAMIENTO DE CONDUCTO AUDITIVO"
  },
  {
    "codigo":234591005,
    "descripcion":"DEFECTO FAGOCÍTICO COMBINADO"
  },
  {
    "codigo":365663007,
    "descripcion":"ASPECTO DEL LÍQUIDO ASCÍTICO - HALLAZGO"
  },
  {
    "codigo":1217631009,
    "descripcion":"FRACTURA ORBITARIA COMPLEJA"
  },
  {
    "codigo":253320002,
    "descripcion":"VENA CAVA INFERIOR HACIA LA IZQUIERDA DE LA COLUMNA VERTEBRAL CON AORTA DESCENDENTE DERECHA"
  },
  {
    "codigo":724276006,
    "descripcion":"SÍNDROME DE DESREGULACIÓN INMUNITARIA LIGADA AL CROMOSOMA X, POLIENDOCRINOPATÍA Y ENTEROPATÍA"
  },
  {
    "codigo":298292009,
    "descripcion":"DOLOR CON EL MOVIMIENTO DE MÚSCULO ESQUELÉTICO"
  },
  {
    "codigo":67081008,
    "descripcion":"PARAPSORIASIS EN PLACAS GRANDES"
  },
  {
    "codigo":296457008,
    "descripcion":"SOBREDOSIS DE ÁCIDO GAMOLÉNICO"
  },
  {
    "codigo":196318002,
    "descripcion":"TINCIÓN DE DIENTES CAUSADA POR FÁRMACOS"
  },
  {
    "codigo":720606005,
    "descripcion":"SÍNDROME CARDIOCRANEAL TIPO PFEIFFER"
  },
  {
    "codigo":354171000119103,
    "descripcion":"NEOPLASIA BENIGNA DE OJO DERECHO"
  },
  {
    "codigo":292787003,
    "descripcion":"REACCIÓN ADVERSA A LA SILICONA"
  },
  {
    "codigo":15936461000119100,
    "descripcion":"HORARIO DE TRABAJO ESTRESANTE"
  },
  {
    "codigo":683981000119101,
    "descripcion":"SARCOMA DE EWING PRIMARIO DE HUESO DE COLUMNA VERTEBRAL"
  },
  {
    "codigo":1085901000119101,
    "descripcion":"ABSCESO DE INTESTINO CONCOMITANTE CON ENFERMEDAD DE CROHN Y DEBIDO A ELLA"
  },
  {
    "codigo":16468941000119103,
    "descripcion":"DISFUNCIÓN DE YEYUNOSTOMÍA"
  },
  {
    "codigo":340941000119101,
    "descripcion":"SÍNDROME DE DUANE DE OJO IZQUIERDO"
  },
  {
    "codigo":11858381000119105,
    "descripcion":"LESIÓN TRAUMÁTICA DE ARTERIA POPLÍTEA DERECHA"
  },
  {
    "codigo":94344001,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LOS GANGLIOS LINFÁTICOS INTERCOSTALES"
  },
  {
    "codigo":11812301000119107,
    "descripcion":"LESIÓN TRAUMÁTICA PRIMARIA DE COLON ASCENDENTE POR EXPLOSIÓN"
  },
  {
    "codigo":338381000119108,
    "descripcion":"ADHESIÓN DE MEMBRANA PUPILAR DE OJO IZQUIERDO"
  },
  {
    "codigo":11817421000119106,
    "descripcion":"ESGUINCE DE LIGAMENTO DE PULGAR IZQUIERDO"
  },
  {
    "codigo":353741000119106,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE PULMÓN IZQUIERDO"
  },
  {
    "codigo":681421000119107,
    "descripcion":"PRESENCIA DE VARIANTE DE CADENA DELTA DE HEMOGLOBINA"
  },
  {
    "codigo":90061000119108,
    "descripcion":"EDENTULISMO COMPLETO CLASE III"
  },
  {
    "codigo":16637901000119109,
    "descripcion":"TRASTORNO DE NERVIOS OBTURADORES BILATERALES"
  },
  {
    "codigo":16863181000119109,
    "descripcion":"TRASTORNO NEONATAL TRANSITORIO DE SISTEMA ENDOCRINO"
  },
  {
    "codigo":16696781000119108,
    "descripcion":"TUMEFACCIÓN BILATERAL DE OREJA"
  },
  {
    "codigo":289117001,
    "descripcion":"CAPAZ DE EXPECTORAR"
  },
  {
    "codigo":192648008,
    "descripcion":"MENINGITIS DEBIDA A FIEBRE TIFOIDEA"
  },
  {
    "codigo":127112005,
    "descripcion":"LINFADENOPATÍA INTERCOSTAL"
  },
  {
    "codigo":715101003,
    "descripcion":"NO PASA DE LA CAMA A LA SILLA"
  },
  {
    "codigo":108411000119109,
    "descripcion":"TROMBO MURAL DE AURÍCULA IZQUIERDA"
  },
  {
    "codigo":254514005,
    "descripcion":"CARCINOMA IN SITU DE LA COMISURA POSTERIOR"
  },
  {
    "codigo":90674006,
    "descripcion":"TIC DIAFRAGMÁTICO"
  },
  {
    "codigo":1335858009,
    "descripcion":"EFECTO DE RADIACIÓN"
  },
  {
    "codigo":1137415003,
    "descripcion":"DEBILIDAD DE MÚSCULO TRÍCEPS BRAQUIAL"
  },
  {
    "codigo":1268487009,
    "descripcion":"CARCINOMA PRIMARIO DE RINOFARINGE"
  },
  {
    "codigo":283612003,
    "descripcion":"HERIDA POR PINCHAZO DE AGUJA EN EL BRAZO"
  },
  {
    "codigo":609457001,
    "descripcion":"INTERRUPCIÓN INDUCIDA DEL EMBARAZO COMPLICADA POR EMBOLIA GASEOSA"
  },
  {
    "codigo":54236009,
    "descripcion":"REPLICACIÓN GENÉTICA"
  },
  {
    "codigo":216241003,
    "descripcion":"INTOXICACIÓN POR MONÓXIDO DE CARBONO DE AERONAVE EN TRÁNSITO, SIN ACCIDENTE DE AERONAVE, VIAJERO DE AERONAVE SIN MOTOR, EXCEPTO PARACAIDISTA, LESIONADO"
  },
  {
    "codigo":1363121004,
    "descripcion":"PARTO SIN ASISTENCIA"
  },
  {
    "codigo":871601006,
    "descripcion":"VENTRÍCULO DERECHO CON DOBLE SALIDA CON DEFECTO DE TABIQUE VENTRICULAR SUBAÓRTICO Y ESTENOSIS PULMONAR TIPO FALLOT"
  },
  {
    "codigo":314545009,
    "descripcion":"ENDOFTALMITIS POSQUIRÚRGICA AGUDA"
  },
  {
    "codigo":247174006,
    "descripcion":"RETINOSQUISIS - DESGARRO DE LA LÁMINA INTERNA"
  },
  {
    "codigo":704091009,
    "descripcion":"FRACTURA EXPUESTA DE DIÁFISIS DE CUARTO METACARPIANO"
  },
  {
    "codigo":1259312003,
    "descripcion":"FIBROSARCOMA PRIMARIO DE BAZO"
  },
  {
    "codigo":866096009,
    "descripcion":"NEOPLASIA MALIGNA DE VAINA DE NERVIO PERIFÉRICO DE CABEZA Y CUELLO"
  },
  {
    "codigo":12293001,
    "descripcion":"INTOXICACIÓN POR MALVA"
  },
  {
    "codigo":208901001,
    "descripcion":"LUXACIÓN OBTURATRIZ TRAUMÁTICA EXPUESTA DE LA CADERA"
  },
  {
    "codigo":43226001,
    "descripcion":"MIOPATÍA SARCOTUBULAR"
  },
  {
    "codigo":1255642002,
    "descripcion":"ADENOCARCINOMA POLIMORFO DE BAJO GRADO DE OROFARINGE"
  },
  {
    "codigo":403674007,
    "descripcion":"FENÓMENO DE RAYNAUD MEDICAMENTOSO"
  },
  {
    "codigo":75994008,
    "descripcion":"GASTROPARESIA NO DIABÉTICA"
  },
  {
    "codigo":762287001,
    "descripcion":"APNEA NEONATAL MIXTA"
  },
  {
    "codigo":239834007,
    "descripcion":"ARTRITIS POR PIROFOSFATO"
  },
  {
    "codigo":15675721000119105,
    "descripcion":"TENDINITIS CALCIFICADA DE AMBOS CODOS"
  },
  {
    "codigo":237999008,
    "descripcion":"DEFICIENCIA DE LA PROTEÍNA TRIFUNCIONAL MITOCONDRIAL"
  },
  {
    "codigo":72324000,
    "descripcion":"INFESTACIÓN CAUSADA POR MELOPHAGUS"
  },
  {
    "codigo":170628003,
    "descripcion":"OBSTRUCCIÓN IRREVERSIBLE DE LAS VÍAS AÉREAS"
  },
  {
    "codigo":299865000,
    "descripcion":"REFLEJO ANAL DISMINUIDO"
  },
  {
    "codigo":432772009,
    "descripcion":"RECHAZO HIPERAGUDO DE TRASPLANTE HEPÁTICO"
  },
  {
    "codigo":201561002,
    "descripcion":"ARTRITIS REACTIVA DE CODO"
  },
  {
    "codigo":103257003,
    "descripcion":"MIRADA LATERAL CONJUGADA ANORMAL"
  },
  {
    "codigo":365401003,
    "descripcion":"DESARROLLO GENITAL MASCULINO SEGÚN TANNER - HALLAZGO"
  },
  {
    "codigo":267097001,
    "descripcion":"IDEAS CULPOSAS"
  },
  {
    "codigo":4953006,
    "descripcion":"EFECTO TÓXICO DEL ALCOHOL BUTÍLICO"
  },
  {
    "codigo":430937009,
    "descripcion":"HERIDA CERRADA DE CABEZA"
  },
  {
    "codigo":166958001,
    "descripcion":"NIVEL DE LITIO POR DEBAJO DEL RANGO TERAPÉUTICO"
  },
  {
    "codigo":396334002,
    "descripcion":"INFECCIÓN CAUSADA POR DRACUNCULUS MEDINENSIS"
  },
  {
    "codigo":230659005,
    "descripcion":"DISFUNCIÓN AUTONÓMICA SEGMENTARIA"
  },
  {
    "codigo":296195005,
    "descripcion":"SOBREDOSIS DE DIFENILBUTILPIPERIDINA"
  },
  {
    "codigo":722179007,
    "descripcion":"DEPENDIENTE PARA SENTARSE"
  },
  {
    "codigo":294360000,
    "descripcion":"ALERGIA A ISOCONAZOL"
  },
  {
    "codigo":165123009,
    "descripcion":"RESULTADO NORMAL DE BIOPSIA NO QUIRÚRGICA"
  },
  {
    "codigo":1179096007,
    "descripcion":"LEIOMIOMA UTERINO METASTATIZANTE"
  },
  {
    "codigo":720344007,
    "descripcion":"TUMOR FILODES DE MAMA BENIGNO"
  },
  {
    "codigo":292525006,
    "descripcion":"REACCIÓN ADVERSA A LOS ALCALOIDES DE LA BELLADONA"
  },
  {
    "codigo":95917009,
    "descripcion":"RESISTENCIA A LOS CORTICOIDES"
  },
  {
    "codigo":718509009,
    "descripcion":"HERIDA ABIERTA DE ANTEBRAZO DEBIDA A MORDEDURA DE GATO"
  },
  {
    "codigo":94082003,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA COLA DEL PÁNCREAS"
  },
  {
    "codigo":126850006,
    "descripcion":"NEOPLASIA DE CONDUCTO ANAL"
  },
  {
    "codigo":1306498006,
    "descripcion":"CARCINOMA DUCTAL INFILTRANTE PRIMARIO DE PORCIÓN CENTRAL DE MAMA IZQUIERDA"
  },
  {
    "codigo":288855004,
    "descripcion":"BEBE"
  },
  {
    "codigo":92247009,
    "descripcion":"NEOPLASIA BENIGNA DEL SISTEMA NERVIOSO"
  },
  {
    "codigo":254252005,
    "descripcion":"SÍNDROME DE MISOPROSTOL FETAL"
  },
  {
    "codigo":418092006,
    "descripcion":"CONGESTIÓN DE VÍAS RESPIRATORIAS"
  },
  {
    "codigo":10681111000119100,
    "descripcion":"NÓDULO DE PIEL DE TÓRAX"
  },
  {
    "codigo":416257001,
    "descripcion":"LEPRA MULTIBACILAR"
  },
  {
    "codigo":449025004,
    "descripcion":"ANILLO VASCULAR CON CAYADO AÓRTICO IZQUIERDO Y LIGAMENTO DEL CONDUCTO ARTERIAL DERECHO ORIGINADO EN DIVERTÍCULO AÓRTICO RETROESOFÁGICO CON ARTERIA SUBCLAVIA DERECHA ABERRANTE"
  },
  {
    "codigo":285185005,
    "descripcion":"CAPAZ DE RECONOCER OLORES"
  },
  {
    "codigo":55809007,
    "descripcion":"COLITIS CAUSADA POR RADIACIÓN"
  },
  {
    "codigo":283350000,
    "descripcion":"PICADURA DE INSECTO INFECTADA EN EL PULGAR"
  },
  {
    "codigo":53974002,
    "descripcion":"DISPLASIA DE KNIEST"
  },
  {
    "codigo":281515000,
    "descripcion":"FRACTURA-LUXACIÓN CON AFECTACIÓN TRANSESCAFOIDEA, DE LOS HUESOS GRANDE, GANCHOSO Y PIRAMIDAL, Y DE LA ZONA PERISEMILUNAR"
  },
  {
    "codigo":52139007,
    "descripcion":"HIPERVOLEMIA POR ALTERACIÓN DE LAS FUERZAS DE STARLING"
  },
  {
    "codigo":1197184003,
    "descripcion":"AUMENTO DE TAMAÑO GENERALIZADO DE ENCÍA EXACERBADO POR EMBARAZO"
  },
  {
    "codigo":246912006,
    "descripcion":"ÓRBITA - HALLAZGO"
  },
  {
    "codigo":1295488006,
    "descripcion":"SÍNDROME DE DE BARSY ASOCIADO PIRROLINA-5-CARBOXILATO REDUCTASA 1"
  },
  {
    "codigo":441685000,
    "descripcion":"ETANOL EN ESPÉCIMEN DE SANGRE POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":83072009,
    "descripcion":"HEPATITIS PALÚDICA"
  },
  {
    "codigo":443520009,
    "descripcion":"CONDROSARCOMA"
  },
  {
    "codigo":769365007,
    "descripcion":"LA PIEL ESTÁ LIMPIA"
  },
  {
    "codigo":277845008,
    "descripcion":"CUERPO EXTRAÑO EN LA URETRA MEMBRANOSA"
  },
  {
    "codigo":13866000,
    "descripcion":"ACIDOSIS FETAL QUE AFECTA EL MANEJO DE LA MADRE"
  },
  {
    "codigo":732927000,
    "descripcion":"SÍNDROME DE MANO HENDIDA, UROPATÍA OBSTRUCTIVA, ESPINA BÍFIDA Y DEFECTO DIAFRAGMÁTICO"
  },
  {
    "codigo":306943001,
    "descripcion":"EPIGLOTIS REDUNDANTE"
  },
  {
    "codigo":405247003,
    "descripcion":"OBSTRUCCIÓN DE ESÓFAGO"
  },
  {
    "codigo":77567004,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE LA COLUMNA VERTEBRAL"
  },
  {
    "codigo":274175005,
    "descripcion":"LESIÓN DE TENDÓN DE MIEMBRO INFERIOR"
  },
  {
    "codigo":110335004,
    "descripcion":"RAÍZ DENTAL CORTA"
  },
  {
    "codigo":208639006,
    "descripcion":"FRACTURA EXPUESTA DE TIBIA DISTAL, INTRARTICULAR"
  },
  {
    "codigo":332721000119105,
    "descripcion":"IRITIS RECURRENTE DE OJO DERECHO"
  },
  {
    "codigo":763860004,
    "descripcion":"SÍNDROME OTOFACIOCERVICAL"
  },
  {
    "codigo":403412007,
    "descripcion":"QUELOIDE DE LÓBULO DE LA OREJA"
  },
  {
    "codigo":237737000,
    "descripcion":"SEUDOSÍNDROME DE CUSHING"
  },
  {
    "codigo":10196009,
    "descripcion":"OSTEOCONDROSIS JUVENIL DEL ACETÁBULO"
  },
  {
    "codigo":270505009,
    "descripcion":"ENFERMEDAD DE KASHIN-BECK"
  },
  {
    "codigo":365139000,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA DIRIGIR (UN AUTOMÓVIL)"
  },
  {
    "codigo":299603007,
    "descripcion":"AMPLITUD DE EXTENSIÓN PASIVA DE DEDO DEL PIE DISMINUIDA"
  },
  {
    "codigo":102995008,
    "descripcion":"PRUEBA POSITIVA DE LA TABLA HORIZONTAL"
  },
  {
    "codigo":234067009,
    "descripcion":"ESTENOSIS VENOSA INTRÍNSECA"
  },
  {
    "codigo":232232001,
    "descripcion":"OTITIS EXTERNA NO INFECCIOSA AGUDA"
  },
  {
    "codigo":2856003,
    "descripcion":"DERMATOSIS POR SENSIBILIDAD A LA VITAMINA A"
  },
  {
    "codigo":725587007,
    "descripcion":"SÍNDROME DE GLICOPROTEÍNAS CON DEFICIENCIA DE CARBOHIDRATOS TIPO 2D"
  },
  {
    "codigo":166696002,
    "descripcion":"NIVEL DE CLORURO SÉRICO FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":197629000,
    "descripcion":"GLOMERULONEFRITIS ANAFILACTOIDE"
  },
  {
    "codigo":363304009,
    "descripcion":"TRASTORNO DEBIDO A INTOXICACIÓN Y POSTERIOR A ELLA"
  },
  {
    "codigo":164861001,
    "descripcion":"ISQUEMIA DE MIOCARDIO EN EL ELECTROCARDIOGRAMA"
  },
  {
    "codigo":66557003,
    "descripcion":"EVALUACIÓN DE DISCAPACIDAD: NORMAL, SIN DISCAPACIDAD NI DAÑO ALGUNO"
  },
  {
    "codigo":230397004,
    "descripcion":"EPILEPSIA DE LÓBULO FRONTAL FRONTOPOLAR ANTERIOR"
  },
  {
    "codigo":1098981000119101,
    "descripcion":"NEOPLASIA MALIGNA RECURRENTE DE PRÓSTATA"
  },
  {
    "codigo":10873931000119107,
    "descripcion":"PROLAPSO INCOMPLETO DE ÚTERO"
  },
  {
    "codigo":295933005,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE CITALOPRAM"
  },
  {
    "codigo":359634001,
    "descripcion":"HIDROCEFALIA POSHEMORRÁGICA DEL LACTANTE"
  },
  {
    "codigo":11775051000119109,
    "descripcion":"CONTUSIÓN DE MANO IZQUIERDA"
  },
  {
    "codigo":95655001,
    "descripcion":"MIGRAÑA OFTÁLMICA"
  },
  {
    "codigo":292263004,
    "descripcion":"REACCIÓN ADVERSA A LA ANFEPRAMONA"
  },
  {
    "codigo":716412000,
    "descripcion":"CAPAZ DE IDENTIFICAR INTERESES"
  },
  {
    "codigo":126588002,
    "descripcion":"NEOPLASIA DE HUESO DEL TARSO"
  },
  {
    "codigo":93820003,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE HUESO GANCHOSO"
  },
  {
    "codigo":290428004,
    "descripcion":"INTOXICACIÓN POR LAXANTES"
  },
  {
    "codigo":12240101000119106,
    "descripcion":"MICROCALCIFICACIÓN MAMOGRÁFICA DE MAMA DERECHA"
  },
  {
    "codigo":224892002,
    "descripcion":"INVOLUCRADO EN PROCEDIMIENTOS LEGALES CIVILES"
  },
  {
    "codigo":28284007,
    "descripcion":"ESTENOSIS VALVULAR REUMÁTICA CON INSUFICIENCIA"
  },
  {
    "codigo":91985000,
    "descripcion":"NEOPLASIA BENIGNA DE COLON ASCENDENTE"
  },
  {
    "codigo":288593002,
    "descripcion":"CAPAZ DE USAR UN SISTEMA DE COMUNICACIÓN NO VERBAL"
  },
  {
    "codigo":115941000119108,
    "descripcion":"SÍNTOMA MAMARIO DE CAMBIO EN EL PEZÓN"
  },
  {
    "codigo":89471000119102,
    "descripcion":"HIPERPARATIROIDISMO SECUNDARIO DE ORIGEN NO RENAL"
  },
  {
    "codigo":24614000,
    "descripcion":"SECUENCIA DE LATERALIDAD"
  },
  {
    "codigo":1237030002,
    "descripcion":"CON RIESGO ELEVADO DE EXPOSICIÓN A BORDETELLA PERTUSSIS"
  },
  {
    "codigo":712742003,
    "descripcion":"INTOXICACIÓN CON BENZODIAZEPINA"
  },
  {
    "codigo":286758004,
    "descripcion":"RASGO DE LA PERSONALIDAD: ORGANIZACIÓN PERSONAL - HALLAZGO"
  },
  {
    "codigo":598377701000119108,
    "descripcion":"ADENOCARCINOMA DE CÉLULAS CLARAS DE OVARIO DE ORIGEN MULLERIANO"
  },
  {
    "codigo":188454009,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE PIEL DE LA CABEZA"
  },
  {
    "codigo":219387005,
    "descripcion":"HERIDA DE GUERRA POR FRAGMENTOS DE MISIL TELEDIRIGIDO"
  },
  {
    "codigo":284923009,
    "descripcion":"NO USA ORINAL"
  },
  {
    "codigo":446928004,
    "descripcion":"DEHISCENCIA DE GASTROYEYUNOSTOMÍA"
  },
  {
    "codigo":335231000119106,
    "descripcion":"ESTAFILOMA ECUATORIAL DERECHO"
  },
  {
    "codigo":283088007,
    "descripcion":"ARAÑAZO DEL TRONCO"
  },
  {
    "codigo":20944008,
    "descripcion":"ESCOLIOSIS POSTURAL CONGÉNITA"
  },
  {
    "codigo":119248009,
    "descripcion":"HIPERALBUMINEMIA"
  },
  {
    "codigo":51877002,
    "descripcion":"TORSIÓN DE EPIPLÓN"
  },
  {
    "codigo":248485003,
    "descripcion":"SACO LAGRIMAL TUMEFACTO - QUÍSTICO"
  },
  {
    "codigo":838309004,
    "descripcion":"ANOMALÍA CEREBROVASCULAR DEBIDA A ENFERMEDAD DE TAKAYASU"
  },
  {
    "codigo":184784009,
    "descripcion":"TIENE CERTIFICADO PARA LA COMPRA DE MEDICAMENTOS CON DESCUENTO"
  },
  {
    "codigo":1231525004,
    "descripcion":"LABIO LEPORINO COMPLETO"
  },
  {
    "codigo":707237008,
    "descripcion":"ENFERMEDAD GINGIVAL DEBIDA A PLACA DENTAL"
  },
  {
    "codigo":1297061009,
    "descripcion":"CIERRE DE ÁNGULO DE OJO IZQUIERDO DEBIDO A UVEÍTIS"
  },
  {
    "codigo":246650003,
    "descripcion":"HALLAZGO RELACIONADO CON EL MOVIMIENTO DE LA IMAGEN VISUAL"
  },
  {
    "codigo":1196922005,
    "descripcion":"GLAUCOMA NEOVASCULAR DEBIDO A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":244815007,
    "descripcion":"OBSTRUCCIÓN PILÓRICA"
  },
  {
    "codigo":212047008,
    "descripcion":"QUEMADURA POR AGENTES CORROSIVOS DE ÓRGANOS GENITOURINARIOS INTERNOS"
  },
  {
    "codigo":11777561000119105,
    "descripcion":"DESGARRO DE TRÍCEPS BRAQUIAL DERECHO"
  },
  {
    "codigo":1162319009,
    "descripcion":"ARTRITIS REUMATOIDE EROSIVA POSITIVA PARA ANTICUERPO ANTIPÉPTIDO CÍCLICO CITRULINADO Y PARA FACTOR REUMATOIDE"
  },
  {
    "codigo":46372006,
    "descripcion":"TRASTORNO DE LA EXCITACIÓN SEXUAL EN LA MUJER"
  },
  {
    "codigo":242980007,
    "descripcion":"LESIÓN CON PROPÓSITO DESCONOCIDO POR CAÍDA DESDE PUENTE"
  },
  {
    "codigo":15709721000119107,
    "descripcion":"HIPERPIGMENTACIÓN DE PÁRPADO INFERIOR IZQUIERDO Y DE ÁREA PERIOCULAR IZQUIERDA"
  },
  {
    "codigo":110073006,
    "descripcion":"LACERACIÓN SIMPLE CONTAMINADA DE LA NARIZ"
  },
  {
    "codigo":308761000119108,
    "descripcion":"TENDINITIS DE TENDÓN DE LA REGIÓN GLÚTEA IZQUIERDA"
  },
  {
    "codigo":133510681000119108,
    "descripcion":"MASA EN AXILA IZQUIERDA"
  },
  {
    "codigo":370382007,
    "descripcion":"ECOGRAFÍA PRENATAL QUE CONFIRMA EMBARAZO ECTÓPICO"
  },
  {
    "codigo":1156814008,
    "descripcion":"LIPODISTROFIA CONGÉNITA GENERALIZADA CON MIOPATÍA"
  },
  {
    "codigo":237475004,
    "descripcion":"FILTRACIÓN DE IMPLANTE MAMARIO"
  },
  {
    "codigo":401315004,
    "descripcion":"SÍNDROME DE SMITH-MAGENIS"
  },
  {
    "codigo":303011007,
    "descripcion":"NEUTROPENIA - TRASTORNO"
  },
  {
    "codigo":301176000,
    "descripcion":"HALLAZGO RELACIONADO CON EL PULSO VENOSO YUGULAR"
  },
  {
    "codigo":170104001,
    "descripcion":"EVALUACIÓN AL NACER ANORMAL - DERIVADO"
  },
  {
    "codigo":399480000,
    "descripcion":"TUMOR QUE INVADE LA PAPILA ÓPTICA"
  },
  {
    "codigo":1251448003,
    "descripcion":"SÍNDROME DE HIPERVISCOSIDAD POLICLONAL"
  },
  {
    "codigo":202872004,
    "descripcion":"TENDINITIS DEL MÚSCULO BÍCEPS CRURAL"
  },
  {
    "codigo":235640006,
    "descripcion":"FÍSTULA TRAQUEOESOFÁGICA SIN ATRESIA ESOFÁGICA"
  },
  {
    "codigo":366712007,
    "descripcion":"AMPLITUD DE MOVIMIENTO PASIVO DE ABDUCCIÓN DE DEDO DEL PIE - HALLAZGO"
  },
  {
    "codigo":364877003,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA ESTAR DE PIE"
  },
  {
    "codigo":337741000119101,
    "descripcion":"DEFECTO DE SECTOR DE CAMPO VISUAL DE OJO IZQUIERDO"
  },
  {
    "codigo":299341005,
    "descripcion":"AMPLITUD DE FLEXIÓN PASIVA DE LA RODILLA AUMENTADA"
  },
  {
    "codigo":233805005,
    "descripcion":"ESTENOSIS DE ANASTOMOSIS BRONQUIAL"
  },
  {
    "codigo":363042006,
    "descripcion":"SECUELAS CONGÉNITAS DE TRASTORNOS"
  },
  {
    "codigo":231970007,
    "descripcion":"CATARATA EN ENFERMEDADES SISTÉMICAS"
  },
  {
    "codigo":428578009,
    "descripcion":"HALLADO ATRAPADO"
  },
  {
    "codigo":262903001,
    "descripcion":"CONTUSIÓN DE VÍA URINARIA"
  },
  {
    "codigo":789026009,
    "descripcion":"REQUIERE VACUNACIÓN ANTIDIFTÉRICA-ANTITETÁNICA-ANTICOQUELUCHE CON ANTIPOLIOMIELÍTICA"
  },
  {
    "codigo":721655006,
    "descripcion":"LESIÓN TRAUMÁTICA PRIMARIA DE INTESTINO DELGADO POR EXPLOSIÓN"
  },
  {
    "codigo":197367007,
    "descripcion":"GRANULOMAS HEPÁTICOS EN LA BERILIOSIS"
  },
  {
    "codigo":228300002,
    "descripcion":"BEBE CON EL CÓNYUGE"
  },
  {
    "codigo":293836004,
    "descripcion":"ALERGIA A FENELZINA"
  },
  {
    "codigo":64460009,
    "descripcion":"FÓRMULA DE HIPERALIMENTACIÓN PARA EL TRATAMIENTO DE FÍSTULA INTESTINAL"
  },
  {
    "codigo":95393002,
    "descripcion":"DERMATITIS EN EL SITIO DE INYECCIÓN"
  },
  {
    "codigo":10633191000119101,
    "descripcion":"CELULITIS DE PIE IZQUIERDO"
  },
  {
    "codigo":1354885001,
    "descripcion":"POBREZA ENERGÉTICA DOMÉSTICA DEBIDA A RESIDENCIA INADECUADAMENTE IMPERMEABILIZADA"
  },
  {
    "codigo":1142134000,
    "descripcion":"SUSCEPTIBILIDAD GENÉTICA INCIERTA A LA HIPERTERMIA MALIGNA DEBIDA A MUTACIÓN DEL GEN DEL RECEPTOR 1 DE RIANODINA"
  },
  {
    "codigo":29857009,
    "descripcion":"DOLOR DE PECHO"
  },
  {
    "codigo":292001009,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR ALCALOIDE DEL CORNEZUELO DE CENTENO"
  },
  {
    "codigo":421238007,
    "descripcion":"ISLA CENTRAL DE LA VISIÓN"
  },
  {
    "codigo":290166007,
    "descripcion":"INTOXICACIÓN POR DIPIPANONA"
  },
  {
    "codigo":124491001,
    "descripcion":"DEFICIENCIA DE SERINA CARBOXIPEPTIDASA"
  },
  {
    "codigo":288331003,
    "descripcion":"CAPAZ DE LEVANTAR"
  },
  {
    "codigo":386635007,
    "descripcion":"PUBERTAD PRECOZ CON HIPERFUNCIÓN ADRENOCORTICAL"
  },
  {
    "codigo":1269536002,
    "descripcion":"SÍNDROME DE CORDÓN CENTRAL DE MÉDULA CERVICAL DEBIDO A LUXACIÓN EXPUESTA INCOMPLETA DE COLUMNA CERVICAL"
  },
  {
    "codigo":188192002,
    "descripcion":"NEOPLASIA MALIGNA DE ENDOMETRIO DE CUERPO UTERINO"
  },
  {
    "codigo":286496004,
    "descripcion":"INCAPAZ DE PREPARAR COMIDA PARA ANIMALES"
  },
  {
    "codigo":253728007,
    "descripcion":"SISTEMA CORONARIO DOMINANTE DERECHO"
  },
  {
    "codigo":585603201000119101,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN DE TEJIDO PROFUNDO DE CODO DERECHO"
  },
  {
    "codigo":448501005,
    "descripcion":"VENA CAVA INFERIOR IZQUIERDA INTERRUMPIDA"
  },
  {
    "codigo":284661005,
    "descripcion":"DESTROZAR LOS MUEBLES"
  },
  {
    "codigo":219125007,
    "descripcion":"SUICIDIO E INTOXICACIÓN AUTOINFLIGIDA POR GASES DE USO DOMÉSTICO"
  },
  {
    "codigo":415733008,
    "descripcion":"CONJUNTIVITIS TÓXICA"
  },
  {
    "codigo":186357007,
    "descripcion":"AMIGDALITIS ESTREPTOCÓCICA CON ESCARLATINA"
  },
  {
    "codigo":315594003,
    "descripcion":"INTÉRPRETE NECESARIO"
  },
  {
    "codigo":413898007,
    "descripcion":"COMPLICACIÓN DE QUERATOPLASTIA REFRACTIVA POR CIRUGÍA LÁSER"
  },
  {
    "codigo":1003722009,
    "descripcion":"DOLOR EN REGIÓN DE RODILLA"
  },
  {
    "codigo":51615001,
    "descripcion":"FIBROSIS PULMONAR"
  },
  {
    "codigo":1264031003,
    "descripcion":"DOLOR EN MÚSCULO DE PIE"
  },
  {
    "codigo":248223005,
    "descripcion":"SIENTE QUE SE DESMAYA"
  },
  {
    "codigo":277321001,
    "descripcion":"LESIÓN DEL NERVIO FRÉNICO"
  },
  {
    "codigo":770676009,
    "descripcion":"NEOPLASIA DE VÉRTEBRA LUMBAR"
  },
  {
    "codigo":211785001,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL PROFUNDA DE GENITALES"
  },
  {
    "codigo":11999361000119107,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO DE ANTEBRAZO DERECHO"
  },
  {
    "codigo":408393003,
    "descripcion":"BAJO ATENCIÓN DE ESPECIALISTA EN EXAMEN DE LA RETINA"
  },
  {
    "codigo":703305006,
    "descripcion":"ENCEFALOPATÍA HIPÓXICA ISQUÉMICA DEBIDA A PARO CARDÍACO"
  },
  {
    "codigo":15177007,
    "descripcion":"VÉRTIGO APOPLÉJICO"
  },
  {
    "codigo":768841009,
    "descripcion":"MORDIDA CRUZADA POSTERIOR LIMITADA AL LADO DERECHO"
  },
  {
    "codigo":111646002,
    "descripcion":"FRACTURA EXPUESTA DE DIÁFISIS DE PERONÉ"
  },
  {
    "codigo":406558002,
    "descripcion":"FIEBRE POR PICADURA DE GARRAPATA AFRICANA"
  },
  {
    "codigo":275486007,
    "descripcion":"ENFERMEDAD CRÓNICA DE AMÍGDALA"
  },
  {
    "codigo":109811000,
    "descripcion":"CELULITIS DEL ESPACIO SUBLINGUAL"
  },
  {
    "codigo":765171002,
    "descripcion":"SÍNDROME DE DELECIÓN DISTAL DEL CROMOSOMA 18Q"
  },
  {
    "codigo":402888002,
    "descripcion":"INFECCIÓN PRIMARIA DE GENITALES POR HERPES SIMPLEX"
  },
  {
    "codigo":1287624004,
    "descripcion":"CRISIS EPILÉPTICA AUTONÓMICA DE INICIO FOCAL NEONATAL"
  },
  {
    "codigo":1254856006,
    "descripcion":"DERMATITIS DE CONTACTO FOTOALÉRGICA DEBIDA A FRAGANCIA"
  },
  {
    "codigo":149941000119100,
    "descripcion":"REFLUJO VESICOURETERAL SIN NEFROPATÍA POR REFLUJO"
  },
  {
    "codigo":239048008,
    "descripcion":"DISPLASIA ECTODÉRMICA CON DEFECTO DE SUDORACIÓN"
  },
  {
    "codigo":1351325005,
    "descripcion":"INMUNODEFICIENCIA COMBINADA AUTOSÓMICA DOMINANTE DEBIDA A DEFICIENCIA PARCIAL DE TRANSDUCTOR DE SEÑALES DE LA FAMILIA DE CITOCINAS PARA INTERLEUCINA 6"
  },
  {
    "codigo":366450000,
    "descripcion":"PRUEBA DE BRAGARD-HALLAZGO"
  },
  {
    "codigo":827037009,
    "descripcion":"ENCÍA NORMAL"
  },
  {
    "codigo":202610001,
    "descripcion":"CHASQUIDO DE ARTICULACIÓN TIBIOPERONEA"
  },
  {
    "codigo":300914000,
    "descripcion":"ALERGIA A QUESO"
  },
  {
    "codigo":6002006,
    "descripcion":"SÍNDROME DE MONOSOMÍA PARCIAL 10P"
  },
  {
    "codigo":268146009,
    "descripcion":"ESPINA BÍFIDA SIN HIDROCEFALIA - EXPUESTA"
  },
  {
    "codigo":200775004,
    "descripcion":"NEURODERMATITIS ATÓPICA"
  },
  {
    "codigo":16206261000119105,
    "descripcion":"COMPRESIÓN DE AMBOS NERVIOS CUBITALES A LA ALTURA DE LA MUÑECA"
  },
  {
    "codigo":299079009,
    "descripcion":"SIN AMPLITUD ACTIVA DE EXTENSIÓN DE DEDO DE LA MANO"
  },
  {
    "codigo":35100001,
    "descripcion":"TIMPANOESCLEROSIS QUE COMPROMETE A LA MEMBRANA TIMPÁNICA Y A LOS HUESECILLOS DEL OÍDO"
  },
  {
    "codigo":236595003,
    "descripcion":"HIDROURÉTER NO OBSTRUCTIVO"
  },
  {
    "codigo":67868000,
    "descripcion":"INFECCIÓN CAUSADA POR HEPATOZOON"
  },
  {
    "codigo":395548006,
    "descripcion":"MÁRGENES DE RESECCIÓN QUIRÚRGICA PROFUNDA NO AFECTADOS POR CARCINOMA IN SITU"
  },
  {
    "codigo":16671311000119100,
    "descripcion":"FRACTURA NO EXPUESTA DE MANDÍBULA DERECHA"
  },
  {
    "codigo":16015951000119101,
    "descripcion":"ARTRITIS GOTOSA DE AMBOS PIES"
  },
  {
    "codigo":721393005,
    "descripcion":"SÍNDROME DEL CORDÓN POSTERIOR DE MÉDULA ESPINAL AL NIVEL C4"
  },
  {
    "codigo":197105006,
    "descripcion":"DIVERTÍCULO PERFORADO DEL DUODENO"
  },
  {
    "codigo":313781000119108,
    "descripcion":"ATROFIA DE MÚSCULO DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":295409009,
    "descripcion":"SOBREDOSIS DE FÁRMACO ESTIMULANTE DE LA MOTILIDAD"
  },
  {
    "codigo":162502002,
    "descripcion":"TIPO DE DOLOR - HALLAZGO"
  },
  {
    "codigo":64198003,
    "descripcion":"PUNTAJE DE APGAR 9"
  },
  {
    "codigo":293574004,
    "descripcion":"REACCIÓN ADVERSA A LA ANISTREPLASA"
  },
  {
    "codigo":31430005,
    "descripcion":"TEMBLOR POSTURAL MEDICAMENTOSO"
  },
  {
    "codigo":129734009,
    "descripcion":"LESIÓN DE FORMA OVALADA"
  },
  {
    "codigo":95131005,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL PERITONEO"
  },
  {
    "codigo":289904000,
    "descripcion":"MENOPAUSIA AUSENTE"
  },
  {
    "codigo":224368003,
    "descripcion":"EN PROGRAMA DE COLOCACIÓN LABORAL"
  },
  {
    "codigo":60528006,
    "descripcion":"SÍFILIS SECUNDARIA DE LA BOCA"
  },
  {
    "codigo":93296006,
    "descripcion":"HIPOPLASIA CONGÉNITA DEL TARSO"
  },
  {
    "codigo":286234002,
    "descripcion":"DIFICULTAD PARA USAR EL FLUJO DE AIRE PALATINO"
  },
  {
    "codigo":342761000119104,
    "descripcion":"DERMATITIS ALÉRGICA POR CONTACTO DE PÁRPADO SUPERIOR DERECHO"
  },
  {
    "codigo":55023005,
    "descripcion":"COLITIS AMEBIANA NO DISENTÉRICA"
  },
  {
    "codigo":22255007,
    "descripcion":"LEUCOENCEFALOPATÍA MULTIFOCAL PROGRESIVA"
  },
  {
    "codigo":1003460001,
    "descripcion":"OSTEONECROSIS PROGRESIVA BILATERAL DE HUESOS SEMILUNARES"
  },
  {
    "codigo":53188002,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN LA REGIÓN DE LA ENCÍA, CON INFECCIÓN"
  },
  {
    "codigo":774084003,
    "descripcion":"SÍNDROME ANTIFOSFOLIPÍDICO NEONATAL"
  },
  {
    "codigo":249796003,
    "descripcion":"PIE GRANDE Y ANCHO"
  },
  {
    "codigo":315332001,
    "descripcion":"PROTEÍNA DE BENCE JONES NO DETECTADA"
  },
  {
    "codigo":20420001,
    "descripcion":"AGRESIÓN REFORZADA"
  },
  {
    "codigo":870553003,
    "descripcion":"FRACTURA EXPUESTA DE CALOTA CRANEANA CON LACERACIÓN DE CEREBRO"
  },
  {
    "codigo":247961004,
    "descripcion":"SIN RECUERDO DE EPISODIO DE SONAMBULISMO"
  },
  {
    "codigo":444569004,
    "descripcion":"ANEURISMA DE AORTA ABDOMINAL INFRARRENAL"
  },
  {
    "codigo":84121007,
    "descripcion":"IMINOGLICINURIA"
  },
  {
    "codigo":409966000,
    "descripcion":"DIARREA AGUDA"
  },
  {
    "codigo":1080041000119108,
    "descripcion":"SARCOMA DE EWING PRIMARIO DE HUESO DE EXTREMIDAD SUPERIOR DERECHA"
  },
  {
    "codigo":16750002,
    "descripcion":"TROMBOFLEBITIS PROFUNDA"
  },
  {
    "codigo":213358004,
    "descripcion":"FRACTURAS QUE COMPROMETEN MÚLTIPLES REGIONES DE UN\/LOS MIEMBRO\/S SUPERIOR\/ES CON UN\/LOS MIEMBRO\/S INFERIOR\/ES"
  },
  {
    "codigo":82286005,
    "descripcion":"SÍNDROME DE HIPERINMUNOGLOBULINA M"
  },
  {
    "codigo":770414008,
    "descripcion":"SÍNDROME DE ALPORT"
  },
  {
    "codigo":14915001,
    "descripcion":"COMPENSACIÓN POR DOSIFICACIÓN DE GENES"
  },
  {
    "codigo":735811000,
    "descripcion":"LACERACIÓN DE MUÑECA SIN CUERPO EXTRAÑO"
  },
  {
    "codigo":47683004,
    "descripcion":"LEUCODISTROFIA METACROMÁTICA, TIPO INFANTIL TARDÍA"
  },
  {
    "codigo":211523008,
    "descripcion":"CONTUSIÓN, TOBILLO Y PIE, EXCLUIDOS DEDOS"
  },
  {
    "codigo":733976002,
    "descripcion":"CARIES DENTAL ACTIVA SECUNDARIA QUE SE EXTIENDE HASTA LA DENTINA"
  },
  {
    "codigo":78616008,
    "descripcion":"PREDACIÓN"
  },
  {
    "codigo":15635331000119107,
    "descripcion":"BEBÉ PREMATURO, 34 SEMANAS"
  },
  {
    "codigo":109549008,
    "descripcion":"ANOMALÍA CONGÉNITA DE LABIO"
  },
  {
    "codigo":238786000,
    "descripcion":"PÚRPURA DE GOUGEROT-RUITER"
  },
  {
    "codigo":402626003,
    "descripcion":"DISTROFIA UNGUEAL POR TRAUMATISMO"
  },
  {
    "codigo":304322007,
    "descripcion":"AUSENCIA DE MOVIMIENTO DE LA RODILLA"
  },
  {
    "codigo":300652001,
    "descripcion":"CAPAZ DE ORGANIZAR UN VIAJE"
  },
  {
    "codigo":235116002,
    "descripcion":"LESIÓN FIBROSA ÓSEA DE LA MANDÍBULA"
  },
  {
    "codigo":5740008,
    "descripcion":"HEMATOMA PÉLVICO DURANTE EL PARTO"
  },
  {
    "codigo":366188009,
    "descripcion":"FUNCIÓN DEL VENTRÍCULO IZQUIERDO - HALLAZGO"
  },
  {
    "codigo":167745000,
    "descripcion":"NIVEL DE CLORURO EN LÍQUIDO CEFALORRAQUÍDEO POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":298817007,
    "descripcion":"AMPLITUD DE ADUCCIÓN PASIVA DE HOMBRO DISMINUIDA"
  },
  {
    "codigo":231446000,
    "descripcion":"TRASTORNO EMOCIONAL ORGÁNICO LÁBIL"
  },
  {
    "codigo":724801009,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO A LA ALTURA DE LA CADERA"
  },
  {
    "codigo":2070002,
    "descripcion":"ARDOR EN OJO"
  },
  {
    "codigo":296982001,
    "descripcion":"SOBREDOSIS DE DISOPIRAMIDA"
  },
  {
    "codigo":722966004,
    "descripcion":"COREA DEBIDA A TRASTORNO HEREDODEGENERATIVO"
  },
  {
    "codigo":428054006,
    "descripcion":"PÓLIPO ADENOMATOSO DE COLON"
  },
  {
    "codigo":65771001,
    "descripcion":"ESTADO HETERÓLOGO"
  },
  {
    "codigo":30161000175102,
    "descripcion":"ÚLCERA POR PRESIÓN EN TOBILLO IZQUIERDO, ESTADIO II"
  },
  {
    "codigo":1145280000,
    "descripcion":"ERITEMA PERIFOLICULAR"
  },
  {
    "codigo":719296002,
    "descripcion":"DISTROFIA CORNEAL AMORFA POSTERIOR"
  },
  {
    "codigo":818952002,
    "descripcion":"GLOMERULOPATÍA POR FIBRONECTINA"
  },
  {
    "codigo":291477000,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ESTREPTOMICINA"
  },
  {
    "codigo":293312009,
    "descripcion":"REACCIÓN ADVERSA A DEXTRAN"
  },
  {
    "codigo":94869005,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA CARA HIPOFARÍNGEA DEL PLIEGUE ARITENOEPIGLÓTICO"
  },
  {
    "codigo":191338000,
    "descripcion":"NEUTROPENIA ESPLÉNICA PRIMARIA"
  },
  {
    "codigo":93034002,
    "descripcion":"ATRESIA DEL ÚTERO"
  },
  {
    "codigo":125802004,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA DE DEDO DE LA MANO"
  },
  {
    "codigo":10968401000119103,
    "descripcion":"LACERACIÓN DE DEDO DEL PIE IZQUIERDO"
  },
  {
    "codigo":715626008,
    "descripcion":"FIBROSIS ENDOMIOCÁRDICA TROPICAL"
  },
  {
    "codigo":255039001,
    "descripcion":"POLIPEPTIDOMA PANCREÁTICO"
  },
  {
    "codigo":289642009,
    "descripcion":"ÚTERO DURO"
  },
  {
    "codigo":11787601000119104,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE DEDO ANULAR DERECHO"
  },
  {
    "codigo":224106008,
    "descripcion":"MIEMBRO DE FAMILIA SUSTITUTA POR PERÍODO PROLONGADO"
  },
  {
    "codigo":123967008,
    "descripcion":"TIROSINURIA"
  },
  {
    "codigo":285972006,
    "descripcion":"CAPAZ DE CONTROLAR LA TEMPERATURA DEL AGUA EN EL HOGAR"
  },
  {
    "codigo":417044008,
    "descripcion":"MOLA HIDATIFORME, BENIGNA"
  },
  {
    "codigo":253204009,
    "descripcion":"MALFORMACIÓN CONGÉNITA DE OJO, OÍDO Y CUELLO"
  },
  {
    "codigo":284137004,
    "descripcion":"MUEVE LAS CUATRO EXTREMIDADES"
  },
  {
    "codigo":54761006,
    "descripcion":"TRASTORNO BIPOLAR I DEPRESIVO GRAVE CON SÍNTOMAS PSICÓTICOS, CONGRUENTE CON EL ESTADO DE ÁNIMO"
  },
  {
    "codigo":249534001,
    "descripcion":"EXCESO DE PIEL DE LA PARED ABDOMINAL"
  },
  {
    "codigo":216766003,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR BAYAS"
  },
  {
    "codigo":282302006,
    "descripcion":"DIFICULTAD PARA MANTENER EL EQUILIBRIO"
  },
  {
    "codigo":18323000,
    "descripcion":"ANEMIA HEMOLÍTICA INMUNITARIA MEDICAMENTOSA, TIPO INMUNOCOMPLEJO"
  },
  {
    "codigo":20158009,
    "descripcion":"FRACTURA EXPUESTA DE LA RAMA DE LA MANDÍBULA"
  },
  {
    "codigo":870291002,
    "descripcion":"MIELOPATÍA DEBIDA A LATIRISMO"
  },
  {
    "codigo":313235003,
    "descripcion":"CÉLULAS DE BURR, PRESENTES"
  },
  {
    "codigo":1263507006,
    "descripcion":"TRASTORNO MIOCLÓNICO DEBIDO A INSUFICIENCIA HEPÁTICA"
  },
  {
    "codigo":44301000087102,
    "descripcion":"CONTUSIÓN DE MALÉOLO INTERNO DERECHO"
  },
  {
    "codigo":247699008,
    "descripcion":"HALLAZGO PSICOLÓGICO DE LA PERCEPCIÓN"
  },
  {
    "codigo":41741000087103,
    "descripcion":"CELULITIS DE DEDO ANULAR IZQUIERDO"
  },
  {
    "codigo":39181000087106,
    "descripcion":"DOLOR NEUROPÁTICO CENTRAL CRÓNICO DEBIDO A ESCLEROSIS MÚLTIPLE"
  },
  {
    "codigo":292331000119106,
    "descripcion":"INFLAMACIÓN DE NERVIO SAFENO IZQUIERDO"
  },
  {
    "codigo":213096009,
    "descripcion":"RUPTURA DE TORNILLO INTRAMEDULAR"
  },
  {
    "codigo":276797002,
    "descripcion":"TUMOR MALIGNO DE TEJIDO FIBROSO"
  },
  {
    "codigo":278632009,
    "descripcion":"PIEZA DENTARIA DE LA PRÓTESIS DENTAL CON TONO INCORRECTO"
  },
  {
    "codigo":20101000119101,
    "descripcion":"OBSTRUCCIÓN PROXIMAL BILATERAL DE TROMPAS DE FALOPIO"
  },
  {
    "codigo":47421005,
    "descripcion":"DEFICIENCIA DE MANGANESO"
  },
  {
    "codigo":1290770000,
    "descripcion":"SÍNDROME DE ESTRÉS DE TIBIA MEDIAL"
  },
  {
    "codigo":735549008,
    "descripcion":"TRASTORNO COMPULSIVO DE JUEGO, PREDOMINANTEMENTE FUERA DE LÍNEA"
  },
  {
    "codigo":702781009,
    "descripcion":"MUTACIÓN DE ÁCIDO DESOXIRRIBONUCLEICO MITOCONDRIAL 1555 A A G NO DETECTADA"
  },
  {
    "codigo":897554004,
    "descripcion":"HAMARTOMA MELANOCÍTICO DÉRMICO"
  },
  {
    "codigo":12818004,
    "descripcion":"URETEROCELE"
  },
  {
    "codigo":109287001,
    "descripcion":"NEVO MELANOCÍTICO DE LA PIEL PERIANAL"
  },
  {
    "codigo":305895002,
    "descripcion":"VISTO POR EL SERVICIO DE OFTALMOLOGÍA"
  },
  {
    "codigo":404199004,
    "descripcion":"INCISIVO TRAUMATIZADO"
  },
  {
    "codigo":402364005,
    "descripcion":"GRANULOMA ANULAR GENERALIZADO"
  },
  {
    "codigo":369596005,
    "descripcion":"TUMOR MALIGNO CON COMPROMISO DE ÓRGANO POR PROPAGACIÓN DIRECTA DESDE TROMPA DE FALOPIO"
  },
  {
    "codigo":41916005,
    "descripcion":"HERNIA PARAUMBILICAL CON GANGRENA Y OBSTRUCCIÓN"
  },
  {
    "codigo":11816581000119107,
    "descripcion":"LESIÓN TRAUMÁTICA DE VENA BRAQUIAL IZQUIERDA"
  },
  {
    "codigo":302225005,
    "descripcion":"POLINEUROPATÍA Y MONONEUROPATÍA"
  },
  {
    "codigo":236689006,
    "descripcion":"ABSCESO PERIURETRAL ESQUISTOSOMIÁSICO"
  },
  {
    "codigo":675461000119108,
    "descripcion":"HEBRAS VÍTREAS DE OJO IZQUIERDO"
  },
  {
    "codigo":365926000,
    "descripcion":"SOLUCIÓN DE PROBLEMA - HALLAZGO"
  },
  {
    "codigo":171153008,
    "descripcion":"CRIBADO PARA CÁNCER DE CUELLO UTERINO - DESEADO"
  },
  {
    "codigo":300390002,
    "descripcion":"HALLAZGO RELACIONADO CON LA OBSERVACIÓN GENERAL DEL PROCESO DIGESTIVO"
  },
  {
    "codigo":267622003,
    "descripcion":"QUISTE DEL IRIS POR IMPLANTE QUIRÚRGICO"
  },
  {
    "codigo":726374009,
    "descripcion":"DELECIÓN DE PARTE DEL CROMOSOMA 6"
  },
  {
    "codigo":298555005,
    "descripcion":"AMPLITUD DE ROTACIÓN ACTIVA HACIA LA DERECHA DE LA COLUMNA DORSAL VERTEBRAL, DISMINUIDA"
  },
  {
    "codigo":722704008,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE NARIZ"
  },
  {
    "codigo":294885003,
    "descripcion":"ALERGIA A ETAMSILATO"
  },
  {
    "codigo":425957003,
    "descripcion":"HEMORRAGIA INTRAVENTRICULAR CEREBRAL NO TRAUMÁTICA"
  },
  {
    "codigo":131045005,
    "descripcion":"17 - ESTEROIDES CETÓGENOS ANORMALES"
  },
  {
    "codigo":321311000119108,
    "descripcion":"ESPONDILOSIS DE COLUMNA VERTEBRAL CERVICODORSAL"
  },
  {
    "codigo":719034006,
    "descripcion":"ANTICUERPO CONTRA VIRUS DE EPSTEIN-BARR NO DETECTADO"
  },
  {
    "codigo":424122007,
    "descripcion":"HALLAZGO RELACIONADO CON EL ESTADO DE DESEMPEÑO ECOG"
  },
  {
    "codigo":293050008,
    "descripcion":"REACCIÓN ADVERSA A LA LIMECICLINA"
  },
  {
    "codigo":260282009,
    "descripcion":"VISIÓN A DISTANCIA 3\/9"
  },
  {
    "codigo":291215004,
    "descripcion":"INTOXICACIÓN POR DECANOATO DE ZUCLOPENTIXOL"
  },
  {
    "codigo":717199007,
    "descripcion":"BLASTOSCHIZOMYCES CAPITATUS O CANDIDA KRUSEI O PROTOTHECA ZOPFII"
  },
  {
    "codigo":27236000,
    "descripcion":"SIGNO OCULAR DE GOWER"
  },
  {
    "codigo":715364001,
    "descripcion":"ANEURISMA AÓRTICO ABDOMINAL FAMILIAR"
  },
  {
    "codigo":420452002,
    "descripcion":"MIELOPATÍA ASOCIADA CON SIDA"
  },
  {
    "codigo":94607007,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA SUBGLOTIS"
  },
  {
    "codigo":1010276004,
    "descripcion":"CROMOSOMA EN ANILLO"
  },
  {
    "codigo":92772005,
    "descripcion":"CARCINOMA IN SITU DE LA TRÁQUEA"
  },
  {
    "codigo":289380004,
    "descripcion":"NIVEL -2 DE LA PRESENTACIÓN EN RELACIÓN CON LAS ESPINAS ISQUIÁTICAS"
  },
  {
    "codigo":677971000119100,
    "descripcion":"AGUJERO MACULAR DE ESPESOR PARCIAL DE OJO DERECHO"
  },
  {
    "codigo":1336121003,
    "descripcion":"GLOMERULONEFRITIS POR COMPONENTE 4 DEL COMPLEMENTO"
  },
  {
    "codigo":1303353006,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE DEDO MEDIO"
  },
  {
    "codigo":713529007,
    "descripcion":"ESTEATOSIS HEPÁTICA CAUSADA POR INHIBIDOR DE PROTEASA RETROVIRAL"
  },
  {
    "codigo":123705009,
    "descripcion":"DERMATITIS DE CONTACTO EXFOLIATIVA GENERALIZADA"
  },
  {
    "codigo":1137678002,
    "descripcion":"INTERCAMBIO DE GASES RESPIRATORIOS NORMAL"
  },
  {
    "codigo":285710002,
    "descripcion":"LESIÓN DE LA ARTERIA SISTÉMICA DEL TRONCO"
  },
  {
    "codigo":54499003,
    "descripcion":"CONTUSIÓN DE LA REGIÓN INTERESCAPULAR"
  },
  {
    "codigo":21731004,
    "descripcion":"PSEUDOPUBERTAD FEMENINA"
  },
  {
    "codigo":445880000,
    "descripcion":"COCCIDIODOMICOSIS PROGRESIVA"
  },
  {
    "codigo":282040001,
    "descripcion":"ANOMALÍA CONGÉNITA DE LA NARIZ Y NASOFARINGE"
  },
  {
    "codigo":118200004,
    "descripcion":"HALLAZGO RELACIONADO CON EL ESTADO SEXUAL"
  },
  {
    "codigo":1363384004,
    "descripcion":"SINEQUIAS ANTERIORES PERIFÉRICAS EN CUADRANTE INFERIOR DE ÁNGULO IRIDOCORNEAL DE OJO IZQUIERDO"
  },
  {
    "codigo":2661000124102,
    "descripcion":"PRIMER MOLAR SUPERIOR IZQUIERDO PERMANENTE SUPERNUMERARIO"
  },
  {
    "codigo":249272007,
    "descripcion":"ESMEGMA EN CANTIDAD EXCESIVA"
  },
  {
    "codigo":413112007,
    "descripcion":"CON NEUROLÉPTICO INYECTABLE"
  },
  {
    "codigo":247437002,
    "descripcion":"PATRÓN DE PIGMENTACIÓN"
  },
  {
    "codigo":440421000124107,
    "descripcion":"INGESTA EXCESIVA DE SUSTANCIA BIOACTIVA"
  },
  {
    "codigo":50829006,
    "descripcion":"PROBLEMA BÁSICO DEL APRENDIZAJE"
  },
  {
    "codigo":11874541000119103,
    "descripcion":"JUANETE DE SASTRE BILATERAL"
  },
  {
    "codigo":704354006,
    "descripcion":"CON MAYOR RIESGO DE ANAFILAXIA"
  },
  {
    "codigo":1163106008,
    "descripcion":"ENCEFALITIS CAUSADA POR ARENAVIRUS"
  },
  {
    "codigo":237064007,
    "descripcion":"FIBROIDE DEL LIGAMENTO REDONDO"
  },
  {
    "codigo":733452000,
    "descripcion":"SÍNDROME DE LEUCOENCEFALOPATÍA, DISTONÍA Y NEUROPATÍA MOTRIZ"
  },
  {
    "codigo":1259575009,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE GLÁNDULA CERUMINOSA DE PIEL"
  },
  {
    "codigo":405772002,
    "descripcion":"CIFOESCOLIOSIS CONGÉNITA"
  },
  {
    "codigo":373004001,
    "descripcion":"INFECCIÓN CAUSADA POR ASPERGILLUS TERRICOLA"
  },
  {
    "codigo":766220004,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR METACUALONA"
  },
  {
    "codigo":241932006,
    "descripcion":"ANAFILAXIA PRODUCIDA POR PICADURA DE AVISPA"
  },
  {
    "codigo":910018951000119100,
    "descripcion":"DISTENSIÓN DE MÚSCULO ADUCTOR DE MUSLO DERECHO"
  },
  {
    "codigo":698849002,
    "descripcion":"TETRASOMÍA 18P"
  },
  {
    "codigo":76257003,
    "descripcion":"VÁLVULA CARDÍACA BICÚSPIDE"
  },
  {
    "codigo":305633005,
    "descripcion":"ATENDIDO POR MÉDICO EMERGENTÓLOGO"
  },
  {
    "codigo":403937006,
    "descripcion":"HIDROACANTOMA SIMPLE DE LA PIEL"
  },
  {
    "codigo":1255905007,
    "descripcion":"LINFOMA DE HODGKIN DE GANGLIOS LINFÁTICOS DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":43489008,
    "descripcion":"FIEBRE HEMORRÁGICA DEL CONGO Y CRIMEA"
  },
  {
    "codigo":1155766001,
    "descripcion":"ANOMALÍA NUCLEAR EN EXTENDIDO CERVICAL"
  },
  {
    "codigo":895457008,
    "descripcion":"SE MOVILIZA CON BASTÓN"
  },
  {
    "codigo":236427002,
    "descripcion":"NECROSIS TUBULAR AGUDA POSTRAUMÁTICA"
  },
  {
    "codigo":170891003,
    "descripcion":"EFECTO COLATERAL DE FÁRMACO EMPLEADO EN OTORRINOLARINGOLOGÍA"
  },
  {
    "codigo":301963007,
    "descripcion":"APOSICIÓN NORMAL DEL ORIFICIO LAGRIMAL INFERIOR"
  },
  {
    "codigo":1186699009,
    "descripcion":"AMBIENTE RECLUIDO"
  },
  {
    "codigo":1217632002,
    "descripcion":"CONTRACCIÓN DIFUSA DE CAVIDAD ORBITARIA CON PÉRDIDA DE VOLUMEN Y SUPERFICIE"
  },
  {
    "codigo":365664001,
    "descripcion":"ASPECTO DEL LÍQUIDO PLEURAL - HALLAZGO"
  },
  {
    "codigo":373939004,
    "descripcion":"SIENTE CALOR Y SUDORACIÓN"
  },
  {
    "codigo":300128007,
    "descripcion":"DEFORMACIÓN DE CONDUCTO AUDITIVO"
  },
  {
    "codigo":398432008,
    "descripcion":"DEBILIDAD BULBAR"
  },
  {
    "codigo":68917000,
    "descripcion":"ENFERMEDAD BRONQUIOLAR"
  },
  {
    "codigo":724277002,
    "descripcion":"SÍNDROME DE ICTIOSIS CONGÉNITA CON HIPOTRICOSIS"
  },
  {
    "codigo":167221003,
    "descripcion":"ANÁLISIS DE ORINA: SIN ANORMALIDAD"
  },
  {
    "codigo":298293004,
    "descripcion":"SIGNO CON NOMBRE PROPIO DEL MÚSCULO ESQUELÉTICO"
  },
  {
    "codigo":3381004,
    "descripcion":"FRACTURA EXPUESTA DEL ASTRÁGALO"
  },
  {
    "codigo":1090081000119102,
    "descripcion":"EDENTULISMO PARCIAL CLASE III DEBIDO A CARIES"
  },
  {
    "codigo":296458003,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE ÁCIDO GAMOLÉNICO"
  },
  {
    "codigo":1179359005,
    "descripcion":"EPILEPSIA MATERNA DEBIDA A ACCIDENTE CEREBROVASCULAR PERINATAL"
  },
  {
    "codigo":196319005,
    "descripcion":"TINCIÓN DENTAL CAUSADA POR METALES"
  },
  {
    "codigo":294623005,
    "descripcion":"ALERGIA A CARBARILO"
  },
  {
    "codigo":65247007,
    "descripcion":"REORDENAMIENTO GENÉTICO, LINFOCITOS T"
  },
  {
    "codigo":718772002,
    "descripcion":"ATAXIA ESPINOCEREBELOSA TIPO 23"
  },
  {
    "codigo":63412003,
    "descripcion":"DEPRESIÓN MAYOR EN REMISIÓN COMPLETA"
  },
  {
    "codigo":292788008,
    "descripcion":"REACCIÓN ADVERSA A LA DIMETICONA"
  },
  {
    "codigo":94345000,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LOS GANGLIOS LINFÁTICOS INTESTINALES"
  },
  {
    "codigo":127113000,
    "descripcion":"LINFADENOPATÍA DIAFRAGMÁTICA"
  },
  {
    "codigo":192649000,
    "descripcion":"MENINGITIS ACTINOMICÓTICA"
  },
  {
    "codigo":290953006,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR METILFENOBARBITAL"
  },
  {
    "codigo":1208457007,
    "descripcion":"CARCINOMA NEUROENDOCRINO DE CÉLULAS PEQUEÑAS DE PRÓSTATA"
  },
  {
    "codigo":190814002,
    "descripcion":"PÚRPURA CRIOGLOBULINÉMICA"
  },
  {
    "codigo":715102005,
    "descripcion":"NO PASA DE LA CAMA A UNA SILLA DE RUEDAS"
  },
  {
    "codigo":289118006,
    "descripcion":"INCAPAZ DE EXPECTORAR"
  },
  {
    "codigo":1335859001,
    "descripcion":"ICTERICIA NEONATAL PRECOZ DEBIDA A HEMÓLISIS EXCESIVA"
  },
  {
    "codigo":308391000119100,
    "descripcion":"GRANULOMA POR CUERPO EXTRAÑO DE PARTES BLANDAS DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":16016551000119101,
    "descripcion":"RUPTURA DEGENERATIVA DE MENISCO EXTERNO DE RODILLA DERECHA"
  },
  {
    "codigo":85671000119102,
    "descripcion":"DEFORMIDAD EN VALGO DE DEDO GORDO DEL PIE DEBIDA A METATARSO PRIMUS VARO"
  },
  {
    "codigo":16011431000119103,
    "descripcion":"ESTENOSIS DE ARTERIA DE MIEMBRO INFERIOR DERECHO"
  },
  {
    "codigo":305831000119104,
    "descripcion":"ALTERACIÓN DE MENISCO DEBIDA A LESIÓN TRAUMÁTICA DE RODILLA"
  },
  {
    "codigo":10632871000119101,
    "descripcion":"ABSCESO DE EXTREMIDAD SUPERIOR DERECHA"
  },
  {
    "codigo":629149351000119106,
    "descripcion":"SCHWANNOMA DE NERVIO CRANEAL"
  },
  {
    "codigo":331431000119107,
    "descripcion":"MOLESTIA VISUAL DE OJO DERECHO"
  },
  {
    "codigo":15978151000119108,
    "descripcion":"HEMANGIOMA CAPILAR DE REGIÓN DE ÓRBITA IZQUIERDA"
  },
  {
    "codigo":10676391000119108,
    "descripcion":"ASMA ALÉRGICA PERSISTENTE MODERADA"
  },
  {
    "codigo":10635431000119108,
    "descripcion":"ÚLCERA CRÓNICA DE TALÓN"
  },
  {
    "codigo":10681511000119107,
    "descripcion":"MASA DE PIEL DE AMBAS EXTREMIDADES SUPERIORES"
  },
  {
    "codigo":15988391000119106,
    "descripcion":"FÍSTULA CARÓTIDO-CAVERNOSA IZQUIERDA ADQUIRIDA"
  },
  {
    "codigo":341671000119107,
    "descripcion":"HEMORRAGIA DE COROIDES DE OJO IZQUIERDO"
  },
  {
    "codigo":16034471000119109,
    "descripcion":"HIPERTROFIA ÓSEA DE CLAVÍCULA DERECHA"
  },
  {
    "codigo":16057511000119109,
    "descripcion":"PARÁLISIS FACIAL IZQUIERDA GRADO VI DE HOUSE-BRACKMANN"
  },
  {
    "codigo":16039591000119108,
    "descripcion":"CONDROMALACIA DE AMBAS CADERAS"
  },
  {
    "codigo":339111000119109,
    "descripcion":"CELULITIS ORBITARIA IZQUIERDA"
  },
  {
    "codigo":449288005,
    "descripcion":"INFECCIÓN DE FÍSTULA ARTERIOVENOSA PARA HEMODIÁLISIS"
  },
  {
    "codigo":709597002,
    "descripcion":"TROMBOSIS AGUDA DE VENA SUPERFICIAL DE MIEMBRO INFERIOR"
  },
  {
    "codigo":250845006,
    "descripcion":"HALLAZGO VASCULAR INTRACEREBRAL"
  },
  {
    "codigo":283613008,
    "descripcion":"HERIDA POR PINCHAZO DE AGUJA EN EL CODO"
  },
  {
    "codigo":871602004,
    "descripcion":"DEFECTO PERIMEMBRANOSO DEL TABIQUE INTERVENTRICULAR EN EL CONO DE SALIDA CON MALA ALINEACIÓN DEL TABIQUE AURICULOVENTRICULAR EN SU PORCIÓN ANTERIOR"
  },
  {
    "codigo":314546005,
    "descripcion":"ENDOFTALMITIS POSQUIRÚRGICA CRÓNICA"
  },
  {
    "codigo":609458006,
    "descripcion":"INTERRUPCIÓN INDUCIDA DEL EMBARAZO COMPLICADA POR EMBOLIA DE LÍQUIDO AMNIÓTICO"
  },
  {
    "codigo":216242005,
    "descripcion":"INTOXICACIÓN POR MONÓXIDO DE CARBONO EN AERONAVE EN TRÁNSITO, SIN ACCIDENTE DE AERONAVE, PARACAIDISTA LESIONADO"
  },
  {
    "codigo":299861000119104,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE TENDÓN FLEXOR DE PIERNA"
  },
  {
    "codigo":704092002,
    "descripcion":"FRACTURA EXPUESTA DE DIÁFISIS DE QUINTO METACARPIANO"
  },
  {
    "codigo":81500003,
    "descripcion":"PÚRPURA ESTEROIDEA"
  },
  {
    "codigo":212572003,
    "descripcion":"QUE COME SIEMPRE"
  },
  {
    "codigo":10677231000119100,
    "descripcion":"ÚLCERA NEUROPÁTICA DE TOBILLO DERECHO"
  },
  {
    "codigo":48732008,
    "descripcion":"ATROFIA DE LA TÚNICA VAGINAL"
  },
  {
    "codigo":866097000,
    "descripcion":"NEOPLASIA MALIGNA DE VAINA DE NERVIO PERIFÉRICO DE MIEMBRO INFERIOR"
  },
  {
    "codigo":79665007,
    "descripcion":"SÍNDROME DE WILDERVANCK"
  },
  {
    "codigo":16002031000119102,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DEBIDO A TROMBO DE ARTERIA CEREBRAL MEDIA DERECHA"
  },
  {
    "codigo":11987951000119102,
    "descripcion":"QUEMADURA EPIDÉRMICA DE BRAZO DERECHO"
  },
  {
    "codigo":1259313008,
    "descripcion":"CARCINOMA PRIMARIO DE VÍA BILIAR INTRAHEPÁTICA"
  },
  {
    "codigo":77830003,
    "descripcion":"QUEMADURA EPIDÉRMICA DE MÚLTIPLES SITIOS"
  },
  {
    "codigo":733190003,
    "descripcion":"DEMENCIA DEBIDA A NEOPLASIA MALIGNA PRIMARIA DE CEREBRO"
  },
  {
    "codigo":45062007,
    "descripcion":"EXOTROPÍA MONOCULAR CON PATRÓN A"
  },
  {
    "codigo":208902008,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE LA ARTICULACIÓN DE LA CADERA, ANTERIOR"
  },
  {
    "codigo":1255643007,
    "descripcion":"CARCINOMA DE CÉLULAS ACINARES DE TRÁQUEA"
  },
  {
    "codigo":239835008,
    "descripcion":"ARTRITIS POR PIROFOSFATO IDIOPÁTICA"
  },
  {
    "codigo":403675008,
    "descripcion":"DERMATOSIS MEDICAMENTOSA"
  },
  {
    "codigo":238000002,
    "descripcion":"DEFICIENCIA COMBINADA DE LA CADENA LARGA 3-HIDROXIACIL-COA DESHIDROGENASA Y ENOIL COA HIDRATASA"
  },
  {
    "codigo":1092591000119105,
    "descripcion":"SEPSIS CAUSADA POR ENTEROCOCCUS"
  },
  {
    "codigo":41392003,
    "descripcion":"FRACTURAS MÚLTIPLES NO EXPUESTAS DE EXTREMIDAD INFERIOR Y ESTERNÓN"
  },
  {
    "codigo":303536005,
    "descripcion":"AMPLITUD DE RETRACCIÓN ACTIVA DE COLUMNA CERVICAL NORMAL"
  },
  {
    "codigo":762288006,
    "descripcion":"HEMORRAGIA NEONATAL DE RIÑÓN"
  },
  {
    "codigo":72325004,
    "descripcion":"QUISTE DE LA GLÁNDULA TIROIDES"
  },
  {
    "codigo":432773004,
    "descripcion":"RECHAZO HIPERAGUDO DE TRASPLANTE CARDÍACO"
  },
  {
    "codigo":170629006,
    "descripcion":"BRONCODILATADORES USADOS MÁS DE UNA VEZ POR DÍA"
  },
  {
    "codigo":400005007,
    "descripcion":"ECCEMA ERITRODÉRMICO"
  },
  {
    "codigo":15729801000119102,
    "descripcion":"ARTROPATÍA DE CADERA DERECHA"
  },
  {
    "codigo":37722001,
    "descripcion":"TULAREMIA ULCEROGLANDULAR"
  },
  {
    "codigo":11306121000119102,
    "descripcion":"FRACTURA POR AVULSIÓN EXPUESTA DE HUESO ILÍACO DERECHO"
  },
  {
    "codigo":398170002,
    "descripcion":"EPIDERMÓLISIS BULLOSA SIMPLE AUTOSÓMICA DOMINANTE"
  },
  {
    "codigo":299866004,
    "descripcion":"REFLEJO ANAL NORMAL"
  },
  {
    "codigo":365402005,
    "descripcion":"DESARROLLO MAMARIO EN LAS NIÑAS SEGÚN TANNER - HALLAZGO"
  },
  {
    "codigo":1217370006,
    "descripcion":"SÍNDROME MULTISISTÉMICO ASOCIADO A GEN DE SUBUNIDAD ALFA 5 DE LAMININA"
  },
  {
    "codigo":430938004,
    "descripcion":"TENOSINOVITIS SUPURATIVA"
  },
  {
    "codigo":1184602008,
    "descripcion":"ÁCIDO PANTOTÉNICO DENTRO DE RANGO DE REFERENCIA"
  },
  {
    "codigo":201562009,
    "descripcion":"ARTRITIS REACTIVA DE ARTICULACIÓN RADIOCUBITAL DISTAL"
  },
  {
    "codigo":3119002,
    "descripcion":"LACERACIÓN DEL TRONCO ENCEFÁLICO CON HERIDA INTRACRANEAL ABIERTA Y PÉRDIDA DE CONSCIENCIA"
  },
  {
    "codigo":396335001,
    "descripcion":"COLECISTITIS REAGUDIZADA"
  },
  {
    "codigo":103258008,
    "descripcion":"MIRADA VERTICAL CONJUGADA"
  },
  {
    "codigo":724015007,
    "descripcion":"SÍNDROME DE ARTRITIS PIÓGENA, PIODERMA GANGRENOSO Y ACNÉ"
  },
  {
    "codigo":230660000,
    "descripcion":"HIPERHIDROSIS SEGMENTARIA"
  },
  {
    "codigo":1284000,
    "descripcion":"OCLUSIÓN DEFECTUOSA DE LA MANDÍBULA"
  },
  {
    "codigo":197892001,
    "descripcion":"METAPLASIA ESCAMOSA DE VEJIGA URINARIA"
  },
  {
    "codigo":165124003,
    "descripcion":"RESULTADO ANORMAL DE BIOPSIA NO QUIRÚRGICA"
  },
  {
    "codigo":722180005,
    "descripcion":"DEPENDIENTE PARA ESTAR DE PIE"
  },
  {
    "codigo":296196006,
    "descripcion":"SOBREDOSIS DE PIMOZIDA"
  },
  {
    "codigo":294361001,
    "descripcion":"ALERGIA A SULCONAZOL"
  },
  {
    "codigo":720345008,
    "descripcion":"SÍNDROME DE INMUNODEFICIENCIA SEVERA DE LINFOCITOS T, ALOPECIA CONGÉNITA Y DISTROFIA UNGUEAL"
  },
  {
    "codigo":718510004,
    "descripcion":"HERIDA ABIERTA DE ANTEBRAZO DEBIDA A MORDEDURA DE PERRO"
  },
  {
    "codigo":1208840000,
    "descripcion":"ACROMATOPSIA INCOMPLETA"
  },
  {
    "codigo":1306499003,
    "descripcion":"CARCINOMA DUCTAL INFILTRANTE PRIMARIO DE PROLONGACIÓN AXILAR DE MAMA DERECHA"
  },
  {
    "codigo":126851005,
    "descripcion":"NEOPLASIA DEL HÍGADO"
  },
  {
    "codigo":94083008,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL ASTRÁGALO"
  },
  {
    "codigo":288856003,
    "descripcion":"NO BEBE"
  },
  {
    "codigo":190552005,
    "descripcion":"HIPOFUNCIÓN TESTICULAR POSABLATIVA"
  },
  {
    "codigo":254253000,
    "descripcion":"SÍNDROME DE PRIMIDONA FETAL"
  },
  {
    "codigo":840627005,
    "descripcion":"ÚTERO GRÁVIDO DE TAMAÑO CORRESPONDIENTE A 20-24 SEMANAS"
  },
  {
    "codigo":450861006,
    "descripcion":"INFECCIÓN CAUSADA POR GRIMONTIA HOLLISAE"
  },
  {
    "codigo":285186006,
    "descripcion":"INCAPAZ DE RECONOCER OLORES"
  },
  {
    "codigo":23042008,
    "descripcion":"PARAPARESIA RAQUÍDEA"
  },
  {
    "codigo":283351001,
    "descripcion":"PICADURA INFECTADA EN LA REGIÓN PÉLVICA"
  },
  {
    "codigo":281516004,
    "descripcion":"FRACTURA-LUXACIÓN PERISEMILUNAR TRANSESTILOIDEA"
  },
  {
    "codigo":15978071000119100,
    "descripcion":"HEMANGIOMA CAPILAR DE REGIÓN DE ÓRBITA DERECHA"
  },
  {
    "codigo":248748007,
    "descripcion":"VENA DURA"
  },
  {
    "codigo":246913001,
    "descripcion":"MARGEN ORBITARIO - HALLAZGO"
  },
  {
    "codigo":50305006,
    "descripcion":"POLIOSIS CIRCUNSCRIPTA ADQUIRIDA"
  },
  {
    "codigo":441686004,
    "descripcion":"FALANGE EN DELTA DE DEDO DE LA MANO"
  },
  {
    "codigo":1259051000,
    "descripcion":"VARIANTE BRAQUIAL DE POLIRRADICULONEUROPATÍA DESMIELINIZANTE INMUNITARIA CRÓNICA"
  },
  {
    "codigo":769366008,
    "descripcion":"ATAQUE AGUDO RESUELTO"
  },
  {
    "codigo":310614009,
    "descripcion":"FACTOR ANTINUCLEAR DÉBILMENTE DETECTADO"
  },
  {
    "codigo":10735191000119105,
    "descripcion":"ECTASIA DE CONDUCTO GALACTÓFORO DE MAMA DERECHA"
  },
  {
    "codigo":46635009,
    "descripcion":"DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":13867009,
    "descripcion":"COARTACIÓN DE AORTA PREDUCTAL"
  },
  {
    "codigo":110336003,
    "descripcion":"RAÍZ DENTAL CURVA"
  },
  {
    "codigo":732928005,
    "descripcion":"APLASIA DE TRÓCLEA DE HÚMERO"
  },
  {
    "codigo":274176006,
    "descripcion":"DEFORMIDAD POSTRAUMÁTICA"
  },
  {
    "codigo":306944007,
    "descripcion":"ARITENOIDES - HALLAZGO"
  },
  {
    "codigo":763861000,
    "descripcion":"SÍNDROME DE PAQUIGIRIA, DISCAPACIDAD INTELECTUAL Y EPILEPSIA"
  },
  {
    "codigo":405248008,
    "descripcion":"OBSTRUCCIÓN POR CUERPO EXTRAÑO DE PORCIÓN TORÁCICA DEL ESÓFAGO"
  },
  {
    "codigo":331351000119107,
    "descripcion":"PROLAPSO DE VÍTREO DE OJO DERECHO"
  },
  {
    "codigo":1255381006,
    "descripcion":"ESGUINCE DE LIGAMENTO DE ARTICULACIÓN METACARPOFALÁNGICA DE DEDO DE MANO"
  },
  {
    "codigo":237738005,
    "descripcion":"SEUDOSÍNDROME DE CUSHING INDUCIDO POR ALCOHOL"
  },
  {
    "codigo":235903001,
    "descripcion":"TRASTORNO METABÓLICO Y GENÉTICO QUE AFECTA EL HÍGADO"
  },
  {
    "codigo":39295002,
    "descripcion":"FIBROMA SUBUNGUEAL"
  },
  {
    "codigo":432511006,
    "descripcion":"ABSCESO DE LUGAR DE INSERCIÓN DE BOTÓN DE GASTROSTOMÍA"
  },
  {
    "codigo":297139009,
    "descripcion":"ABSCESO RETROESTERNAL"
  },
  {
    "codigo":299604001,
    "descripcion":"SIN AMPLITUD PASIVA DE EXTENSIÓN DE DEDO DEL PIE"
  },
  {
    "codigo":725588002,
    "descripcion":"ICTIOSIS EN TRAJE DE BAÑO"
  },
  {
    "codigo":15705841000119105,
    "descripcion":"DEPÓSITO DE CALCIO EN BOLSA SEROSA DE MUÑECAS BILATERALES"
  },
  {
    "codigo":234068004,
    "descripcion":"ESTENOSIS DE VENA CAUSADA POR RADIACIÓN"
  },
  {
    "codigo":461609000,
    "descripcion":"OBSTRUCCIÓN ADQUIRIDA DE LUZ DE CAYADO AÓRTICO"
  },
  {
    "codigo":102996009,
    "descripcion":"CRIESTESIA"
  },
  {
    "codigo":363305005,
    "descripcion":"SECUELA DE TRASTORNOS REPRODUCTIVOS"
  },
  {
    "codigo":35625006,
    "descripcion":"QUERATOSIS DEL OÍDO MEDIO"
  },
  {
    "codigo":789289005,
    "descripcion":"DAÑO DE PIEL Y TEJIDO SUBCUTÁNEO CAUSADO POR VENENO DE SERPIENTE"
  },
  {
    "codigo":688011000119102,
    "descripcion":"SARCOMA PRIMARIO DE REGIÓN INGUINAL"
  },
  {
    "codigo":232233006,
    "descripcion":"OTITIS EXTERNA AGUDA IRRITATIVA"
  },
  {
    "codigo":263166003,
    "descripcion":"FRACTURA DE APÓFISIS PALATINA"
  },
  {
    "codigo":294099000,
    "descripcion":"ALERGIA A NIQUETAMIDA"
  },
  {
    "codigo":230398009,
    "descripcion":"EPILEPSIA ORBITOFRONTAL DE LÓBULO FRONTAL"
  },
  {
    "codigo":164862008,
    "descripcion":"ELECTROCARDIOGRAMA: SIN ISQUEMIA MIOCÁRDICA"
  },
  {
    "codigo":95656000,
    "descripcion":"MIGRAÑA HEMIPLÉJICA FAMILIAR"
  },
  {
    "codigo":1177000004,
    "descripcion":"NÓDULO PULMONAR POR PNEUMOCYSTIS"
  },
  {
    "codigo":292264005,
    "descripcion":"REACCIÓN ADVERSA A LA FENFLURAMINA"
  },
  {
    "codigo":333861000119100,
    "descripcion":"ESOTROPÍA MONOCULAR DE OJO DERECHO"
  },
  {
    "codigo":93821004,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA MANO"
  },
  {
    "codigo":716413005,
    "descripcion":"CAPAZ DE IDENTIFICAR LA ESTRUCTURA Y RUTINA DE LA VIDA DIARIA"
  },
  {
    "codigo":126589005,
    "descripcion":"NEOPLASIA DE HUESO CALCÁNEO"
  },
  {
    "codigo":290429007,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR BISACODILO"
  },
  {
    "codigo":91986004,
    "descripcion":"NEOPLASIA BENIGNA DE LA AXILA"
  },
  {
    "codigo":288594008,
    "descripcion":"INCAPAZ DE USAR UN SISTEMA DE COMUNICACIÓN NO VERBAL"
  },
  {
    "codigo":417831002,
    "descripcion":"AISLAMIENTO NO IDENTIFICADO"
  },
  {
    "codigo":1237031003,
    "descripcion":"METÁSTASIS DE CARCINOMA DE FONDO DE ESTÓMAGO"
  },
  {
    "codigo":286759007,
    "descripcion":"TIENDE A PLANIFICAR A FUTURO"
  },
  {
    "codigo":712743008,
    "descripcion":"ESPÉCIMEN INSATISFACTORIO PARA LA EVALUACIÓN DEBIDO A ALMACENAMIENTO INADECUADO DE LA MUESTRA"
  },
  {
    "codigo":219388000,
    "descripcion":"HERIDA DE GUERRA POR FRAGMENTOS DE MINA TERRESTRE"
  },
  {
    "codigo":284924003,
    "descripcion":"DIFICULTAD PARA USAR ORINAL"
  },
  {
    "codigo":22780006,
    "descripcion":"HEMORRAGIA SUBPERIÓSTICA"
  },
  {
    "codigo":88316009,
    "descripcion":"FUNCIÓN MUSCULAR AUMENTADA"
  },
  {
    "codigo":709073001,
    "descripcion":"TRASTORNO NEUROCOGNITIVO"
  },
  {
    "codigo":119249001,
    "descripcion":"AGAMMAGLOBULINEMIA"
  },
  {
    "codigo":283089004,
    "descripcion":"ARAÑAZO DE ESPALDA"
  },
  {
    "codigo":281254000,
    "descripcion":"OBSTRUCCIÓN DEL INTESTINO GRUESO"
  },
  {
    "codigo":53713009,
    "descripcion":"TRABAJA COMO PROSTITUTA"
  },
  {
    "codigo":248486002,
    "descripcion":"SACO LAGRIMAL TUMEFACTO - SÓLIDO"
  },
  {
    "codigo":707238003,
    "descripcion":"SARCOIDOSIS DE LA CAVIDAD BUCAL"
  },
  {
    "codigo":1297062002,
    "descripcion":"CIERRE DE ÁNGULO DE AMBOS OJOS DEBIDO A UVEÍTIS"
  },
  {
    "codigo":1196923000,
    "descripcion":"GLAUCOMA NEOVASCULAR DEBIDO A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":838310009,
    "descripcion":"CAMPTODACTILIA DE DEDOS DE AMBOS PIES"
  },
  {
    "codigo":50043002,
    "descripcion":"TRASTORNO DEL APARATO RESPIRATORIO"
  },
  {
    "codigo":314022009,
    "descripcion":"OBSTRUCCIÓN DE CONDUCTO NASOLAGRIMAL"
  },
  {
    "codigo":246651004,
    "descripcion":"DESVANECIMIENTO DE LA IMAGEN VISUAL"
  },
  {
    "codigo":836475004,
    "descripcion":"SECRECIÓN NASAL MUCOPURULENTA"
  },
  {
    "codigo":408656001,
    "descripcion":"INTEGRIDAD DE ESPÉCIMEN MESORRECTAL, NO APLICABLE"
  },
  {
    "codigo":770939009,
    "descripcion":"SÍNDROME SIMILAR A LA ENFERMEDAD DE HUNTINGTON TIPO 3"
  },
  {
    "codigo":143551000119106,
    "descripcion":"TROMBOSIS CRÓNICA DE VENA ESPLÉNICA"
  },
  {
    "codigo":80976008,
    "descripcion":"CRISIS MIASTÉNICA"
  },
  {
    "codigo":10629311000119107,
    "descripcion":"ARTRITIS PSORIÁSICA MUTILANTE"
  },
  {
    "codigo":16036031000119107,
    "descripcion":"OSTEÓLISIS BILATERAL DE RADIOS"
  },
  {
    "codigo":242981006,
    "descripcion":"LESIÓN CON PROPÓSITO DESCONOCIDO POR CAÍDA DESDE ACCIDENTE GEOGRÁFICO ELEVADO"
  },
  {
    "codigo":210213008,
    "descripcion":"LESIÓN CERRADA DE LA URETRA"
  },
  {
    "codigo":11831641000119102,
    "descripcion":"LACERACIÓN DE VASO SANGUÍNEO DE PULGAR IZQUIERDO"
  },
  {
    "codigo":44538002,
    "descripcion":"CEFALEA NASAL"
  },
  {
    "codigo":110074000,
    "descripcion":"LACERACIÓN COMPLEJA DE LA NARIZ"
  },
  {
    "codigo":765434008,
    "descripcion":"DISCAPACIDAD INTELECTUAL RELACIONADA CON LA PROTEÍNA DE UNIÓN 2 DEL POTENCIADOR DEL VIRUS DE LA INMUNODEFICIENCIA HUMANA TIPO I"
  },
  {
    "codigo":370383002,
    "descripcion":"ECOGRAFÍA PRENATAL QUE CONFIRMA EMBARAZO INTRAUTERINO"
  },
  {
    "codigo":403151007,
    "descripcion":"DERMATITIS POR PICADURA DE ARAÑA"
  },
  {
    "codigo":303012000,
    "descripcion":"NEOPLASIA MALIGNA DE PARED POSTERIOR DE HIPOFARINGE"
  },
  {
    "codigo":1156815009,
    "descripcion":"POLIPOSIS ADENOMATOSA FAMILIAR DEBIDA A MICRODELECIÓN 5Q22.2"
  },
  {
    "codigo":237476003,
    "descripcion":"DEFLACIÓN DE IMPLANTE MAMARIO RELLENO CON SOLUCIÓN SALINA"
  },
  {
    "codigo":401316003,
    "descripcion":"NIÑO AFECTADO POR SÍNDROME DE MÜNCHHAUSEN"
  },
  {
    "codigo":204708006,
    "descripcion":"AUSENCIA CONGÉNITA DE ANO, CON FÍSTULA"
  },
  {
    "codigo":170105000,
    "descripcion":"EVALUACIÓN AL NACER ANORMAL - EN TRATAMIENTO"
  },
  {
    "codigo":366713002,
    "descripcion":"HALLAZGO RELACIONADO CON LA AMPLITUD DE LA ADUCCIÓN DE DEDO DEL PIE"
  },
  {
    "codigo":71801004,
    "descripcion":"COLANGITIS ESTENOSANTE"
  },
  {
    "codigo":235641005,
    "descripcion":"FÍSTULA BRONCOESOFÁGICA"
  },
  {
    "codigo":432249006,
    "descripcion":"INFARTO DE MÉDULA ESPINAL"
  },
  {
    "codigo":1251449006,
    "descripcion":"DEFICIENCIA DE LA PROTEASA ESPECÍFICA DE LA UBIQUITINA 18"
  },
  {
    "codigo":301177009,
    "descripcion":"RETORNO VENOSO RETRASADO EN VENA DE LA EXTREMIDAD"
  },
  {
    "codigo":202873009,
    "descripcion":"TENDINITIS DEL MÚSCULO SEMIMEMBRANOSO"
  },
  {
    "codigo":299342003,
    "descripcion":"AMPLITUD DE FLEXIÓN PASIVA DE LA RODILLA DISMINUIDA"
  },
  {
    "codigo":201038005,
    "descripcion":"CALLO - LESIÓN"
  },
  {
    "codigo":233806006,
    "descripcion":"NECROSIS DE ANASTOMOSIS BRONQUIAL"
  },
  {
    "codigo":364878008,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA GOLPEAR"
  },
  {
    "codigo":199203001,
    "descripcion":"HEPATITIS VIRAL QUE COMPLICA EMBARAZO, PARTO Y PUERPERIO"
  },
  {
    "codigo":789027000,
    "descripcion":"REQUIERE VACUNACIÓN ANTIDIFTÉRICA-ANTITETÁNICA-ANTICOQUELUCHE CON VACUNA ANTITIFOIDEA-PARATIFOIDEA"
  },
  {
    "codigo":231971006,
    "descripcion":"CATARATA EN HIPOPARATIROIDISMO"
  },
  {
    "codigo":35363006,
    "descripcion":"CÓLICO INFANTIL"
  },
  {
    "codigo":166435006,
    "descripcion":"PRUEBA SÉRICA DE EMBARAZO NEGATIVA"
  },
  {
    "codigo":197368002,
    "descripcion":"GRANULOMAS HEPÁTICOS EN LA SARCOIDOSIS"
  },
  {
    "codigo":361208003,
    "descripcion":"APNEA DEL SUEÑO PRIMARIA EN EL RECIÉN NACIDO"
  },
  {
    "codigo":33528003,
    "descripcion":"MIRINGITIS BULLOSA"
  },
  {
    "codigo":336371000119106,
    "descripcion":"DEFECTO ARQUEADO DE CAMPO VISUAL DE OJO DERECHO"
  },
  {
    "codigo":787192006,
    "descripcion":"METABOLIZADOR ULTRARRÁPIDO DE LA FAMILIA 2 SUBFAMILIA C MIEMBRO 9 DEL CITOCROMO P450"
  },
  {
    "codigo":262904007,
    "descripcion":"LACERACIÓN DE VÍA URINARIA"
  },
  {
    "codigo":721656007,
    "descripcion":"NEUMATOSIS INTESTINAL DE INTESTINO DELGADO"
  },
  {
    "codigo":392141001,
    "descripcion":"CRECIMIENTO EPITELIAL CORNEAL SUBCOLGAJO"
  },
  {
    "codigo":295672006,
    "descripcion":"SOBREDOSIS DE PLICAMICINA"
  },
  {
    "codigo":424909003,
    "descripcion":"RETINOPATÍA TÓXICA"
  },
  {
    "codigo":31693001,
    "descripcion":"FRACTURA DE DOS COSTILLAS"
  },
  {
    "codigo":83464003,
    "descripcion":"MARCACIONES AUMENTADAS"
  },
  {
    "codigo":228301003,
    "descripcion":"BEBE CON LOS HIJOS"
  },
  {
    "codigo":457677007,
    "descripcion":"DEHISCENCIA DE ANILLO DE VÁLVULA PULMONAR COMO COMPLICACIÓN DE PROCEDIMIENTO"
  },
  {
    "codigo":293837008,
    "descripcion":"ALERGIA A IPRONIAZIDA"
  },
  {
    "codigo":11805171000119109,
    "descripcion":"SUBLUXACIÓN DE ARTICULACIÓN INTERFALÁNGICA PROXIMAL DE DEDO ÍNDICE DE MANO IZQUIERDA"
  },
  {
    "codigo":309901000119103,
    "descripcion":"GOTA PRIMARIA CRÓNICA DE MÚLTIPLES LOCALIZACIONES, SIN TOFO"
  },
  {
    "codigo":95394008,
    "descripcion":"URTICARIA EN EL SITIO DE INYECCIÓN"
  },
  {
    "codigo":93559003,
    "descripcion":"HIPOGONADISMO CON ANOSMIA"
  },
  {
    "codigo":290167003,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR DIPIPANONA"
  },
  {
    "codigo":288332005,
    "descripcion":"INCAPAZ DE LEVANTAR"
  },
  {
    "codigo":26188006,
    "descripcion":"PULSO TIBIAL NORMAL"
  },
  {
    "codigo":124492008,
    "descripcion":"DEFICIENCIA DE CARBOXIPEPTIDASA A"
  },
  {
    "codigo":386636008,
    "descripcion":"DIETA SIN ADICIÓN DE AZÚCAR"
  },
  {
    "codigo":253729004,
    "descripcion":"SISTEMA CORONARIO DOMINANTE IZQUIERDO"
  },
  {
    "codigo":384801005,
    "descripcion":"MARGEN LATERAL (MUCOSO\/MURAL) DE RESECCIÓN QUIRÚRGICA AFECTADO POR NEOPLASIA MALIGNA"
  },
  {
    "codigo":188193007,
    "descripcion":"NEOPLASIA MALIGNA DE MIOMETRIO DEL CUERPO UTERINO"
  },
  {
    "codigo":16667431000119102,
    "descripcion":"FRACTURA NO EXPUESTA DE LADO DERECHO DE MAXILAR SUPERIOR"
  },
  {
    "codigo":286497008,
    "descripcion":"PREPARA ALIMENTOS PARA ANIMALES"
  },
  {
    "codigo":284662003,
    "descripcion":"CONDUCTA DE ENFRENTAMIENTO"
  },
  {
    "codigo":250059000,
    "descripcion":"SE CHOCA CONTRA COSAS"
  },
  {
    "codigo":219126008,
    "descripcion":"SUICIDIO E INTOXICACIÓN AUTOINFLIGIDA POR GAS DISTRIBUIDO POR GASODUCTO"
  },
  {
    "codigo":315595002,
    "descripcion":"INTÉRPRETE INNECESARIO"
  },
  {
    "codigo":1003723004,
    "descripcion":"CONTRACTURA EN FLEXIÓN DE ARTICULACIONES INTERFALÁNGICAS PROXIMALES DE DEDOS ÍNDICE, MEDIO, ANULAR Y MEÑIQUE"
  },
  {
    "codigo":86219005,
    "descripcion":"SÍNDROME DE ARTRITIS REUMATOIDEA - UVEÍTIS"
  },
  {
    "codigo":446667008,
    "descripcion":"DOS VÁLVULAS AURICULOVENTRICULARES EN VENTRÍCULO CON DOBLE ENTRADA"
  },
  {
    "codigo":280992001,
    "descripcion":"DIVERTÍCULO PERFORADO DE INTESTINO GRUESO"
  },
  {
    "codigo":1264032005,
    "descripcion":"INFLAMACIÓN DE MÚSCULO DE ARTICULACIÓN DE TOBILLO"
  },
  {
    "codigo":84384007,
    "descripcion":"PRODUCCIÓN HORMONAL AUMENTADA"
  },
  {
    "codigo":11834151000119107,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN METACARPOFALÁNGICA DE PULGAR IZQUIERDO"
  },
  {
    "codigo":49781004,
    "descripcion":"GASTRITIS FLEMONOSA"
  },
  {
    "codigo":211786000,
    "descripcion":"CORROSIÓN DE SEGUNDO GRADO DE TRONCO"
  },
  {
    "codigo":1076161000119102,
    "descripcion":"INFLAMACIÓN DE BOLSA SEROSA SUBTENDINOSA INFERIOR DE MÚSCULO BÍCEPS FEMORAL DE RODILLA DERECHA"
  },
  {
    "codigo":1260362002,
    "descripcion":"DISTONÍA DEBIDA A SÍNDROME DE RETT"
  },
  {
    "codigo":768842002,
    "descripcion":"MORDIDA CRUZADA POSTERIOR LIMITADA AL LADO IZQUIERDO"
  },
  {
    "codigo":1293130003,
    "descripcion":"ANGIOMIOLIPOMA EPITELIOIDE"
  },
  {
    "codigo":338881000119103,
    "descripcion":"ÚLCERA PERFORADA DE CÓRNEA IZQUIERDA"
  },
  {
    "codigo":703306007,
    "descripcion":"HIPERALDOSTERONISMO PRIMARIO DEBIDO A NEOPLASIA MALIGNA DE GLÁNDULA SUPRARRENAL SECRETANTE DE ALDOSTERONA"
  },
  {
    "codigo":277322008,
    "descripcion":"RUPTURA DE ANEURISMA DE LA ARTERIA COMUNICANTE POSTERIOR"
  },
  {
    "codigo":408394009,
    "descripcion":"BAJO ATENCIÓN DE ESPECIALISTA EN DETECCIÓN DE PIE DIABÉTICO"
  },
  {
    "codigo":275487003,
    "descripcion":"ENFERMEDAD CRÓNICA DE ADENOIDES"
  },
  {
    "codigo":406559005,
    "descripcion":"INFECCIÓN DEL SISTEMA NERVIOSO CENTRAL DE ORIGEN AMEBIANO"
  },
  {
    "codigo":111647006,
    "descripcion":"FRACTURA NO EXPUESTA DE TERCER METATARSIANO"
  },
  {
    "codigo":13343009,
    "descripcion":"TRASTORNO FUNCIONAL LOCALIZADO"
  },
  {
    "codigo":78879009,
    "descripcion":"HEMORRAGIA INTRACRANEAL TRAUMÁTICA CON HERIDA INTRACRANEAL ABIERTA Y CONCUSIÓN"
  },
  {
    "codigo":312411000119100,
    "descripcion":"EPICONDILITIS DE HÚMERO IZQUIERDO"
  },
  {
    "codigo":109812007,
    "descripcion":"LENGUA VASCULAR"
  },
  {
    "codigo":240884008,
    "descripcion":"DERMATOSIS POR ARTRÓPODOS"
  },
  {
    "codigo":239049000,
    "descripcion":"SÍNDROME DE HIPOHIDROSIS CON NEUROLABERINTITIS"
  },
  {
    "codigo":44276009,
    "descripcion":"PROMISCUIDAD HABITUAL"
  },
  {
    "codigo":1287625003,
    "descripcion":"CRISIS EPILÉPTICA CON DETENCIÓN DEL COMPORTAMIENTO DE INICIO FOCAL NEONATAL"
  },
  {
    "codigo":402889005,
    "descripcion":"INFECCIÓN PRIMARIA DEL PENE POR HERPES SIMPLEX"
  },
  {
    "codigo":271817008,
    "descripcion":"NO HA CRECIDO EN ALTURA"
  },
  {
    "codigo":827038004,
    "descripcion":"GENITALES EXTERNOS NORMALES"
  },
  {
    "codigo":1351326006,
    "descripcion":"SÍNDROME DE HIPER-IGE AUTOSÓMICO DOMINANTE POR DEFICIENCIA DE STAT3"
  },
  {
    "codigo":366451001,
    "descripcion":"ESTIRAMIENTO DEL NERVIO FEMORAL - HALLAZGO"
  },
  {
    "codigo":202611002,
    "descripcion":"CHASQUIDO DE TOBILLO"
  },
  {
    "codigo":399219006,
    "descripcion":"QUERATOCONJUNTIVITIS CAUSADA POR MORAXELLA BOVIS"
  },
  {
    "codigo":4168008,
    "descripcion":"CONDROMALACIA DEL PLATILLO TIBIAL"
  },
  {
    "codigo":102472009,
    "descripcion":"RESPUESTA TERAPÉUTICA PROLONGADA"
  },
  {
    "codigo":367861000119101,
    "descripcion":"ESTRECHEZ POSINFECCIOSA DE URETRA FEMENINA"
  },
  {
    "codigo":395549003,
    "descripcion":"MÁRGENES DE RESECCIÓN QUIRÚRGICA PROFUNDA AFECTADOS POR CARCINOMA IN SITU"
  },
  {
    "codigo":198941007,
    "descripcion":"HIPERTENSIÓN QUE COMPLICA EL EMBARAZO, PARTO Y PUERPERIO"
  },
  {
    "codigo":15932661000119102,
    "descripcion":"PÓLIPO DE TROMPA UTERINA DERECHA"
  },
  {
    "codigo":67869008,
    "descripcion":"CALCIFICACIÓN MASIVA (PARAPLÉJICA)"
  },
  {
    "codigo":66034004,
    "descripcion":"TRASTORNO DE LA RESONANCIA NASAL"
  },
  {
    "codigo":721394004,
    "descripcion":"SÍNDROME DEL CORDÓN POSTERIOR DE MÉDULA ESPINAL AL NIVEL DEL QUINTO SEGMENTO CERVICAL"
  },
  {
    "codigo":295410004,
    "descripcion":"SOBREDOSIS DE CISAPRIDA"
  },
  {
    "codigo":197106007,
    "descripcion":"DIVERTÍCULO PERFORADO DEL YEYUNO"
  },
  {
    "codigo":293575003,
    "descripcion":"REACCIÓN ADVERSA A LAS BROMELINAS"
  },
  {
    "codigo":424647005,
    "descripcion":"CALAMBRE EN EXTREMIDAD"
  },
  {
    "codigo":129735005,
    "descripcion":"LESIÓN LOBULILLAR"
  },
  {
    "codigo":162503007,
    "descripcion":"DOLOR LACERANTE"
  },
  {
    "codigo":226204000,
    "descripcion":"DIETA SIN SOJA"
  },
  {
    "codigo":717724001,
    "descripcion":"DERMATITIS IRRITATIVA POR CONTACTO DE GENITALES FEMENINOS"
  },
  {
    "codigo":195271009,
    "descripcion":"ANEURISMA DE ARTERIA HUMERAL"
  },
  {
    "codigo":95132003,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL RETROPERITONEO"
  },
  {
    "codigo":1145543005,
    "descripcion":"FISURA DE LABIO COMPLETA DEL LADO IZQUIERDO E INCOMPLETA DEL LADO DERECHO"
  },
  {
    "codigo":193436005,
    "descripcion":"CORIORRETINITIS FOCAL YUXTAPAPILAR"
  },
  {
    "codigo":15988111000119100,
    "descripcion":"ANOMALÍA CONGÉNITA DE AMBAS ESCLERÓTICAS"
  },
  {
    "codigo":29596007,
    "descripcion":"HIPERCAPNIA"
  },
  {
    "codigo":93297002,
    "descripcion":"HIPOPLASIA CONGÉNITA DEL TIMO"
  },
  {
    "codigo":341391000119101,
    "descripcion":"GRANULOMA DE CONJUNTIVA IZQUIERDA"
  },
  {
    "codigo":289905004,
    "descripcion":"APARATO GENITAL FEMENINO NORMAL"
  },
  {
    "codigo":224369006,
    "descripcion":"EN UN ESQUEMA DE ENTRENAMIENTO JUVENIL"
  },
  {
    "codigo":10745231000119102,
    "descripcion":"PARO CARDÍACO DEBIDO A ADMINISTRACIÓN DE ANESTESIA EN EMBARAZO"
  },
  {
    "codigo":1303878002,
    "descripcion":"ESTENOSIS DE ARTERIA ILÍACA EXTERNA DERECHA"
  },
  {
    "codigo":124230004,
    "descripcion":"DEFICIENCIA DE OXIGENASA"
  },
  {
    "codigo":58694006,
    "descripcion":"TERATOGÉNESIS"
  },
  {
    "codigo":253467002,
    "descripcion":"DOBLE ORIFICIO DE VÁLVULA AURICULOVENTRICULAR DERECHA"
  },
  {
    "codigo":89627008,
    "descripcion":"HIPONATREMIA"
  },
  {
    "codigo":1003461002,
    "descripcion":"DISPLASIA CORTICAL FOCAL TIPO II"
  },
  {
    "codigo":53189005,
    "descripcion":"AUSENCIA CONGÉNITA DE TRÁQUEA"
  },
  {
    "codigo":315333006,
    "descripcion":"PROTEÍNA DE BENCE JONES DETECTADA"
  },
  {
    "codigo":249797007,
    "descripcion":"HUESO GRANDE EN EL PIE"
  },
  {
    "codigo":69161000119103,
    "descripcion":"ANOMALÍA FUNCIONAL DE LA MARCHA"
  },
  {
    "codigo":247962006,
    "descripcion":"AUTOMATISMO DEL SUEÑO"
  },
  {
    "codigo":442735001,
    "descripcion":"ATEROSCLEROSIS DE INJERTO-PUENTE NO AUTÓLOGO DE MIEMBRO"
  },
  {
    "codigo":870554009,
    "descripcion":"FRACTURA EXPUESTA DE CALOTA CRANEANA CON CONTUSIÓN DE CEREBRO"
  },
  {
    "codigo":16751003,
    "descripcion":"NEFRITIS TUBULOINTERSTICIAL AGUDA ASOCIADA CON INFECCIÓN SISTÉMICA"
  },
  {
    "codigo":15633961000119104,
    "descripcion":"ECOGRAFÍA DE MAMA ANORMAL"
  },
  {
    "codigo":278895007,
    "descripcion":"FÍSTULA BUCAL"
  },
  {
    "codigo":14916000,
    "descripcion":"FRACTURA DE HUESO TRAPEZOIDE DE LA MUÑECA"
  },
  {
    "codigo":1260100002,
    "descripcion":"CARCINOMA TIPO GLÁNDULA SALIVAL DE HIPOFARINGE"
  },
  {
    "codigo":735812007,
    "descripcion":"LACERACIÓN DE MANO SIN CUERPO EXTRAÑO"
  },
  {
    "codigo":111385000,
    "descripcion":"ENFERMEDAD DE TAY - SACHS"
  },
  {
    "codigo":733977006,
    "descripcion":"CARIES DENTAL INACTIVA SECUNDARIA QUE SE EXTIENDE HASTA LA DENTINA"
  },
  {
    "codigo":209689008,
    "descripcion":"SECCIÓN EXPUESTA DE LIGAMENTO DE LA CADERA"
  },
  {
    "codigo":11246006,
    "descripcion":"POSICIÓN FRONTOILÍACA IZQUIERDA ANTERIOR"
  },
  {
    "codigo":109550008,
    "descripcion":"FOSAS COMISURALES CONGÉNITAS"
  },
  {
    "codigo":304323002,
    "descripcion":"AMPLITUD DE MOVIMIENTO DE TOBILLO NORMAL"
  },
  {
    "codigo":271555006,
    "descripcion":"PACIENTE REGISTRADO POR GPR"
  },
  {
    "codigo":402627007,
    "descripcion":"DAÑO UNGUEAL POR AGENTE EXTERNO"
  },
  {
    "codigo":238787009,
    "descripcion":"VASCULITIS CUTÁNEA SECUNDARIA"
  },
  {
    "codigo":73112009,
    "descripcion":"COLOR OSCURO"
  },
  {
    "codigo":366189001,
    "descripcion":"MOVIMIENTO DE LA PARED VENTRICULAR IZQUIERDA - HALLAZGO"
  },
  {
    "codigo":235117006,
    "descripcion":"ENFERMEDAD DE PAGET DE LA MANDÍBULA"
  },
  {
    "codigo":71277006,
    "descripcion":"INTOXICACIÓN POR FENOLFTALEÍNA"
  },
  {
    "codigo":38509008,
    "descripcion":"INTOXICACIÓN POR OXALATO"
  },
  {
    "codigo":300653006,
    "descripcion":"INCAPAZ DE ORGANIZAR UN VIAJE"
  },
  {
    "codigo":724802002,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO A LA ALTURA DEL MUSLO"
  },
  {
    "codigo":298818002,
    "descripcion":"SIN AMPLITUD PASIVA DE ADUCCIÓN DE HOMBRO"
  },
  {
    "codigo":167746004,
    "descripcion":"NIVEL DE CLORURO EN LÍQUIDO CEFALORRAQUÍDEO FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":296983006,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE DISOPIRAMIDA"
  },
  {
    "codigo":722967008,
    "descripcion":"ATAXIA DEBIDA A MUTACIONES MITOCONDRIALES"
  },
  {
    "codigo":343901000119105,
    "descripcion":"DESPRENDIMIENTO DE RETINA DE AMBOS OJOS DEBIDO A DESGARRO DE RETINA"
  },
  {
    "codigo":295148000,
    "descripcion":"SOBREDOSIS DE SUSTANCIA ANÁLOGA A LA METADONA"
  },
  {
    "codigo":293313004,
    "descripcion":"REACCIÓN ADVERSA A PRODUCTOS PERFLUOROCARBONADOS"
  },
  {
    "codigo":719297006,
    "descripcion":"MACULOPATÍA PLACOIDE PERSISTENTE"
  },
  {
    "codigo":1081181000119109,
    "descripcion":"NEOPLASIA GERMINAL NO SEMINOMATOSA PRIMARIA DE TESTÍCULO DERECHO DESCENDIDO"
  },
  {
    "codigo":193174005,
    "descripcion":"POLINEURITIS POSINFECCIOSA"
  },
  {
    "codigo":94870006,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA CARA HIPOFARÍNGEA DEL PLIEGUE INTERARITENOIDEO"
  },
  {
    "codigo":225942007,
    "descripcion":"USA ROPA DE NOCHE DEBAJO DE LA ROPA DE DÍA"
  },
  {
    "codigo":1340054007,
    "descripcion":"TUMOR GLÓMICO BENIGNO DE PIEL"
  },
  {
    "codigo":420715001,
    "descripcion":"MICROALBUMINURIA PERSISTENTE DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":93035001,
    "descripcion":"FENESTRACIÓN CONGÉNITA DE HUESO BASIOCCIPITAL"
  },
  {
    "codigo":291478005,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR ESTREPTOMICINA"
  },
  {
    "codigo":715627004,
    "descripcion":"SÍNDROME DE CONGELAMIENTO PRIMARIO PROGRESIVO DE LA MARCHA"
  },
  {
    "codigo":289643004,
    "descripcion":"ÚTERO FLÁCIDO"
  },
  {
    "codigo":224107004,
    "descripcion":"MIEMBRO DE FAMILIA ATÍPICA"
  },
  {
    "codigo":123968003,
    "descripcion":"LICOPENEMIA"
  },
  {
    "codigo":18060001000004100,
    "descripcion":"ABSCESO DE PIEL DE MAMA"
  },
  {
    "codigo":10351000132101,
    "descripcion":"SÍNDROME POSTPOLIPECTOMÍA POR ELECTROCOAGULACIÓN"
  },
  {
    "codigo":11980001000004100,
    "descripcion":"ABSCESO PARAESPINAL"
  },
  {
    "codigo":15691921000119100,
    "descripcion":"ARTRITIS REUMATOIDEA SEROPOSITIVA DE AMBAS ARTICULACIONES DE CADERA"
  },
  {
    "codigo":29580001000004102,
    "descripcion":"FRACTURA POR ESTALLIDO DE NOVENA VÉRTEBRA DORSAL"
  },
  {
    "codigo":449813001,
    "descripcion":"ENTUMECIMIENTO EN SILLA DE MONTAR"
  },
  {
    "codigo":16780001000004106,
    "descripcion":"ABSCESO DE AORTA"
  },
  {
    "codigo":13260001000004107,
    "descripcion":"LESIÓN TRAUMÁTICA DE RODILLA DERECHA"
  },
  {
    "codigo":10858641000119101,
    "descripcion":"HERIDA ABIERTA EN MITAD POSTERIOR IZQUIERDA DE PARED TORÁCICA DEBIDA A MORDEDURA DE PERRO"
  },
  {
    "codigo":13900001000004105,
    "descripcion":"CULTIVO POSITIVO PARA BURKHOLDERIA GLADIOLI"
  },
  {
    "codigo":285973001,
    "descripcion":"INCAPAZ DE CONTROLAR LA TEMPERATURA DEL AGUA EN EL HOGAR"
  },
  {
    "codigo":317431000119108,
    "descripcion":"DETENCIÓN PARCIAL DEL CRECIMIENTO EPIFISARIO DE TIBIA PROXIMAL IZQUIERDA"
  },
  {
    "codigo":16046071000119109,
    "descripcion":"REUMATISMO PALINDRÓMICO DE ARTICULACIONES BILATERALES DE MUÑECAS"
  },
  {
    "codigo":249535000,
    "descripcion":"PTOSIS DE PIEL ABDOMINAL"
  },
  {
    "codigo":284138009,
    "descripcion":"DIFICULTAD PARA MOVER LAS CUATRO EXTREMIDADES"
  },
  {
    "codigo":216767007,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR SEMILLAS"
  },
  {
    "codigo":1263508001,
    "descripcion":"LESIÓN TRAUMÁTICA DEBIDA A CONVULSIÓN"
  },
  {
    "codigo":213097000,
    "descripcion":"MOVILIDAD DEL CLAVO INTRAMEDULAR"
  },
  {
    "codigo":247700009,
    "descripcion":"PERCEPCIÓN NORMAL"
  },
  {
    "codigo":278633004,
    "descripcion":"PRÓTESIS DENTAL EXCESIVAMENTE VISIBLE"
  },
  {
    "codigo":409705005,
    "descripcion":"NEOPLASIA BENIGNA DEL SITIO DE COLOSTOMÍA"
  },
  {
    "codigo":14654002,
    "descripcion":"ANAFILAXIA LOCALIZADA"
  },
  {
    "codigo":702782002,
    "descripcion":"MUTACIÓN DE ADN MITOCONDRIAL 1555 A A G POSITIVA"
  },
  {
    "codigo":309566008,
    "descripcion":"PROBLEMA DE RODILLA"
  },
  {
    "codigo":1290771001,
    "descripcion":"SÍNDROME DE ESTRÉS TIBIAL"
  },
  {
    "codigo":735550008,
    "descripcion":"TRASTORNO COMPULSIVO DE JUEGO, PREDOMINANTEMENTE EN LÍNEA"
  },
  {
    "codigo":897555003,
    "descripcion":"DILATACIÓN DE AORTA ASCENDENTE POSTERIOR A PROCEDIMIENTO"
  },
  {
    "codigo":307731004,
    "descripcion":"LESIÓN DE TENDÓN DE MANGUITO ROTADOR DE HOMBRO"
  },
  {
    "codigo":78355003,
    "descripcion":"NEORICKETTSIOSIS"
  },
  {
    "codigo":39911000087104,
    "descripcion":"HEMATOMA DE REGIÓN DE OJO DERECHO"
  },
  {
    "codigo":404200001,
    "descripcion":"MASA ABDOMINAL CENTRAL"
  },
  {
    "codigo":305896001,
    "descripcion":"ATENDIDO POR SERVICIO DE CIRUGÍA BUCAL"
  },
  {
    "codigo":42471000087107,
    "descripcion":"HERIDA PUNZANTE DE PARED POSTERIOR DE TÓRAX CON CUERPO EXTRAÑO"
  },
  {
    "codigo":34791000087108,
    "descripcion":"MÚLTIPLES LESIONES TRAUMÁTICAS DE EXTREMIDAD SUPERIOR LIBRE"
  },
  {
    "codigo":76520005,
    "descripcion":"SÍNDROME DE ROBINOW"
  },
  {
    "codigo":109288006,
    "descripcion":"MELANOMA IN SITU DE LA PIEL PERIANAL"
  },
  {
    "codigo":240360007,
    "descripcion":"ERITEMA NUDOSO DEBIDO A YERSINIOSIS"
  },
  {
    "codigo":1354472008,
    "descripcion":"INMUNODEFICIENCIA COMBINADA VARIABLE AUTOSÓMICA RECESIVA DEBIDA A MUTACIÓN DE ARHGEF1"
  },
  {
    "codigo":238525001,
    "descripcion":"FOTODERMATITIS POLIMORFA"
  },
  {
    "codigo":369597001,
    "descripcion":"TUMOR MALIGNO CON COMPROMISO DE ÓRGANO POR PROPAGACIÓN DIRECTA DESDE OVARIO"
  },
  {
    "codigo":205757003,
    "descripcion":"GLÁNDULA PARATIROIDES ABERRANTE"
  },
  {
    "codigo":43752006,
    "descripcion":"ENTEROCOLITIS"
  },
  {
    "codigo":402365006,
    "descripcion":"GRANULOMA ANULAR PERFORANTE"
  },
  {
    "codigo":1156029006,
    "descripcion":"TROMBO DE SENO DURAL EN EL PUERPERIO"
  },
  {
    "codigo":236690002,
    "descripcion":"URETRITIS DEBIDA A TRÍADA DE ARTRITIS REACTIVA"
  },
  {
    "codigo":171154002,
    "descripcion":"CRIBADO PARA CÁNCER DE CUELLO UTERINO - INNECESARIO"
  },
  {
    "codigo":302226006,
    "descripcion":"ENFERMEDAD DE NERVIO PERIFÉRICO"
  },
  {
    "codigo":38247002,
    "descripcion":"DEPENDENCIA DE ALUCINÓGENOS"
  },
  {
    "codigo":300391003,
    "descripcion":"HALLAZGO RELACIONADO CON LA APARIENCIA DE LA MATERIA FECAL"
  },
  {
    "codigo":726375005,
    "descripcion":"DELECIÓN DE PARTE DEL BRAZO LARGO DEL CROMOSOMA 6"
  },
  {
    "codigo":267623008,
    "descripcion":"QUISTE DEL IRIS POR IMPLANTE TRAUMÁTICO"
  },
  {
    "codigo":365927009,
    "descripcion":"MECANISMO DE DEFENSA PSICOLÓGICA - HALLAZGO"
  },
  {
    "codigo":298556006,
    "descripcion":"SIN AMPLITUD DE ROTACIÓN ACTIVA HACIA LA DERECHA DE LA COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":3644009,
    "descripcion":"MACERACIÓN DE LA EPIDERMIS"
  },
  {
    "codigo":724540009,
    "descripcion":"PANCREATITIS CRÓNICA CALCIFICANTE TROPICAL"
  },
  {
    "codigo":429628009,
    "descripcion":"EN POSICIÓN DE FOWLER MODIFICADA"
  },
  {
    "codigo":165649003,
    "descripcion":"FOLATO SÉRICO DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":296721002,
    "descripcion":"SOBREDOSIS DE CEFIXIMA"
  },
  {
    "codigo":427793007,
    "descripcion":"COMPLICACIÓN DE CATÉTER URINARIO"
  },
  {
    "codigo":722705009,
    "descripcion":"LACERACIÓN MENOR DE VENA YUGULAR EXTERNA"
  },
  {
    "codigo":294886002,
    "descripcion":"ALERGIA A TROMBOPLASTINA"
  },
  {
    "codigo":65510006,
    "descripcion":"RECESIÓN GINGIVAL GENERALIZADA"
  },
  {
    "codigo":131046006,
    "descripcion":"NIVEL DE 17-CETOSTEROIDES POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":360422007,
    "descripcion":"DUPLICACIÓN DE ÚTERO CON DUPLICACIÓN DE CUELLO UTERINO Y VAGINA"
  },
  {
    "codigo":260283004,
    "descripcion":"VISIÓN A DISTANCIA 3\/12"
  },
  {
    "codigo":1208720000,
    "descripcion":"SÍNDROME DE AGENESIA DEL CUERPO CALLOSO, MACROCEFALIA E HIPERTELORISMO"
  },
  {
    "codigo":94608002,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA GLÁNDULA SUBLINGUAL"
  },
  {
    "codigo":291216003,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR DECANOATO DE ZUCLOPENTIXOL"
  },
  {
    "codigo":717200005,
    "descripcion":"CANDIDA INCONSPICUA O CANDIDA KRUSEI O CANDIDA LAMBICA"
  },
  {
    "codigo":782736007,
    "descripcion":"SÍNDROME DE DISCAPACIDAD INTELECTUAL SEVERA Y DISMORFISMO FACIAL DEBIDO A HAPLOINSUFICIENCIA EN EL DOMINIO 5 DEL GEN SET"
  },
  {
    "codigo":289381000,
    "descripcion":"NIVEL -1 DE LA PRESENTACIÓN EN RELACIÓN CON LAS ESPINAS ISQUIÁTICAS"
  },
  {
    "codigo":92773000,
    "descripcion":"CARCINOMA IN SITU DE COLON TRANSVERSO"
  },
  {
    "codigo":10834681000119101,
    "descripcion":"FRACTURA EXPUESTA DE FALANGE PROXIMAL DE DEDO PULGAR DERECHO"
  },
  {
    "codigo":254778000,
    "descripcion":"LIVEDO RETICULAR CONGÉNITO"
  },
  {
    "codigo":713530002,
    "descripcion":"AGRANULOCITOSIS CONCOMITANTE CON INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":123706005,
    "descripcion":"DISTROFIA DEL PELO"
  },
  {
    "codigo":1336122005,
    "descripcion":"DELECIÓN PEQUEÑA"
  },
  {
    "codigo":58170007,
    "descripcion":"MENINGITIS VIRAL"
  },
  {
    "codigo":285711003,
    "descripcion":"LESIÓN ARTERIAL EN EXTREMIDADES SUPERIORES"
  },
  {
    "codigo":1137679005,
    "descripcion":"BUENA RESPUESTA A LA MEDICACIÓN"
  },
  {
    "codigo":449551006,
    "descripcion":"ESTENOSIS ÚNICA DE ARTERIA PULMONAR IZQUIERDA"
  },
  {
    "codigo":56335008,
    "descripcion":"INFECCIÓN CAUSADA POR TRICHOMONAS"
  },
  {
    "codigo":283876006,
    "descripcion":"GASTROENTERITIS POR ASTROVIRUS"
  },
  {
    "codigo":54500007,
    "descripcion":"DIETA LÍQUIDA ABSOLUTA"
  },
  {
    "codigo":118201000,
    "descripcion":"HALLAZGO RELACIONADO CON EL DESARROLLO SEXUAL"
  },
  {
    "codigo":282041002,
    "descripcion":"ANOMALÍA CONGÉNITA DE LA CAVIDAD ORAL"
  },
  {
    "codigo":708025003,
    "descripcion":"PIONEUMOTÓRAX CONSECUTIVO A INFECCIÓN POR COCCIDIOIDES"
  },
  {
    "codigo":76691000119101,
    "descripcion":"ÚLCERA DE AMÍGDALA DEBIDA A AMIGDALOLITO"
  },
  {
    "codigo":183737004,
    "descripcion":"CONSULTA DOMICILIARIA RECIBIDA"
  },
  {
    "codigo":16732921000119107,
    "descripcion":"INFECCIÓN DE NEUROESTIMULADOR ENCEFÁLICO"
  },
  {
    "codigo":249273002,
    "descripcion":"HALLAZGO RELACIONADO CON LA VÍA URINARIA PROPIAMENTE DICHA"
  },
  {
    "codigo":1363385003,
    "descripcion":"SINEQUIAS ANTERIORES PERIFÉRICAS EN CUADRANTE NASAL DE ÁNGULO IRIDOCORNEAL DE OJO DERECHO"
  },
  {
    "codigo":312974005,
    "descripcion":"RUPTURA PREMATURA PRETÉRMINO DE MEMBRANAS"
  },
  {
    "codigo":1197710005,
    "descripcion":"PANCREATITIS AGUDA POR ENFERMEDAD SISTÉMICA"
  },
  {
    "codigo":247438007,
    "descripcion":"TINCIÓN CUTÁNEA"
  },
  {
    "codigo":81763001,
    "descripcion":"CON MAYOR RIESGO DE LESIÓN TRAUMÁTICA"
  },
  {
    "codigo":212835003,
    "descripcion":"EFECTO TÓXICO DE ÁLCALI CÁUSTICO"
  },
  {
    "codigo":1163107004,
    "descripcion":"COLITIS POR STAPHYLOCOCCUS AUREUS METICILINORRESISTENTE"
  },
  {
    "codigo":704355007,
    "descripcion":"CON MAYOR RIESGO DE ALTERACIÓN DE VÍNCULO ENTRE CUIDADOR Y NIÑO"
  },
  {
    "codigo":276536005,
    "descripcion":"SÍNDROME DE INSUFICIENCIA RESPIRATORIA DEL RECIÉN NACIDO"
  },
  {
    "codigo":766221000,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR METACUALONA"
  },
  {
    "codigo":45325001,
    "descripcion":"UNIÓN RECTOSIGMOIDE HIPERACTIVA"
  },
  {
    "codigo":209165002,
    "descripcion":"SÍNDROME MEDULAR POSTERIOR DE MÉDULA CERVICAL DEBIDO A SUBLUXACIÓN VERTEBRAL EXPUESTA DE COLUMNA CERVICAL"
  },
  {
    "codigo":241933001,
    "descripcion":"ANAFILAXIA PRODUCIDA POR MANÍ"
  },
  {
    "codigo":12557004,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DEL PERINEO, CON INFECCIÓN"
  },
  {
    "codigo":733453005,
    "descripcion":"SÍNDROME NEFRÓTICO CONGÉNITO, ENFERMEDAD PULMONAR INTERSTICIAL Y EPIDERMÓLISIS BULLOSA"
  },
  {
    "codigo":373005000,
    "descripcion":"INFECCIÓN CAUSADA POR ASPERGILLUS UNGUIS"
  },
  {
    "codigo":405773007,
    "descripcion":"DEFORMIDAD DE LA COLUMNA VERTEBRAL CAUSADA POR CIFOESCOLIOSIS"
  },
  {
    "codigo":403938001,
    "descripcion":"ESPIRADENOMA ECRINO DE LA PIEL"
  },
  {
    "codigo":240098004,
    "descripcion":"MIOPATÍA POR DEFICIENCIA DE PROTEÍNAS"
  },
  {
    "codigo":43490004,
    "descripcion":"INFECCIÓN POR TERNIDENS DIMINUTUS"
  },
  {
    "codigo":305634004,
    "descripcion":"ATENDIDO POR UN ANESTESISTA"
  },
  {
    "codigo":1255906008,
    "descripcion":"LINFOMA MALIGNO DE GANGLIOS LINFÁTICOS DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":1286839005,
    "descripcion":"SEMINOMA PRIMARIO DE TESTÍCULO DESCENDIDO"
  },
  {
    "codigo":301964001,
    "descripcion":"APOSICIÓN DEFICIENTE DEL ORIFICIO LAGRIMAL INFERIOR"
  },
  {
    "codigo":203660002,
    "descripcion":"LORDOSIS NEUROMUSCULAR"
  },
  {
    "codigo":269196004,
    "descripcion":"PICADURA DE INSECTO, NO VENENOSO, EN ESCROTO Y TESTÍCULO"
  },
  {
    "codigo":7052005,
    "descripcion":"ALUCINOSIS ALCOHÓLICA"
  },
  {
    "codigo":433036004,
    "descripcion":"DIVERTÍCULO DE CÁLIZ RENAL"
  },
  {
    "codigo":236428007,
    "descripcion":"INSUFICIENCIA RENAL AGUDA NEFROTÓXICA"
  },
  {
    "codigo":365665000,
    "descripcion":"ASPECTO DEL LÍQUIDO CEFALORRAQUÍDEO - HALLAZGO"
  },
  {
    "codigo":201825001,
    "descripcion":"ARTROSIS MÚLTIPLE SECUNDARIA"
  },
  {
    "codigo":132141000119106,
    "descripcion":"TROMBOSIS VENOSA PROFUNDA CRÓNICA DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":1186700005,
    "descripcion":"AMBIENTE PROTEGIDO"
  },
  {
    "codigo":300129004,
    "descripcion":"SANGRADO DE CONDUCTO AUDITIVO"
  },
  {
    "codigo":679111000119101,
    "descripcion":"DELLEN CORNEAL BILATERAL"
  },
  {
    "codigo":37985006,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD DE DIFUSIÓN PULMONAR"
  },
  {
    "codigo":1217633007,
    "descripcion":"CONTRACCIÓN DIFUSA DE CAVIDAD ORBITARIA CON PÉRDIDA DE VOLUMEN"
  },
  {
    "codigo":5217008,
    "descripcion":"TRASTORNO DEL ESPECTRO DE LA PERSONA RÍGIDA"
  },
  {
    "codigo":234593008,
    "descripcion":"ANOMALÍA DE LA VÍA CLÁSICA DEL COMPLEMENTO"
  },
  {
    "codigo":167222005,
    "descripcion":"RESULTADO ANORMAL DE ANÁLISIS DE ORINA"
  },
  {
    "codigo":724278007,
    "descripcion":"COLANGITIS ESCLEROSANTE NEONATAL"
  },
  {
    "codigo":34315001,
    "descripcion":"TRASTORNO BIPOLAR II, EPISODIO MÁS RECIENTE DE CARACTERÍSTICAS DEPRESIVAS PROFUNDAS CON SÍNTOMAS MELANCÓLICOS"
  },
  {
    "codigo":296459006,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE ÁCIDO GAMOLÉNICO"
  },
  {
    "codigo":1179360000,
    "descripcion":"EPILEPSIA FETAL DEBIDA A ACCIDENTE CEREBROVASCULAR PERINATAL"
  },
  {
    "codigo":1088711000119105,
    "descripcion":"TRASTORNO DE MEMBRANA TIMPÁNICA IZQUIERDA"
  },
  {
    "codigo":196320004,
    "descripcion":"MANCHADO DENTAL POR SANGRADO PULPAR"
  },
  {
    "codigo":720608006,
    "descripcion":"ESPECIE DE MYCOPLASMA O UREAPLASMA UREALYTICUM"
  },
  {
    "codigo":292789000,
    "descripcion":"REACCIÓN ADVERSA AL ALCOHOL DE LANOLINA"
  },
  {
    "codigo":351431000119108,
    "descripcion":"CARCINOMA DE CÉLULAS DE MERKEL PRIMARIO DE PIEL DE EXTREMIDAD SUPERIOR DERECHA"
  },
  {
    "codigo":63413008,
    "descripcion":"CENTRO DE OSIFICACIÓN ACCESORIO"
  },
  {
    "codigo":61578001,
    "descripcion":"FUNCIÓN ANORMAL DEL APARATO DIGESTIVO"
  },
  {
    "codigo":192650000,
    "descripcion":"MENINGITIS CAUSADA POR BORDETELLA PERTUSSIS"
  },
  {
    "codigo":28810003,
    "descripcion":"VUELO DE IDEAS"
  },
  {
    "codigo":94346004,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL INTESTINO"
  },
  {
    "codigo":127114006,
    "descripcion":"LINFADENOPATÍA INNOMINADA"
  },
  {
    "codigo":715103000,
    "descripcion":"NO PASA DE LA SILLA DE RUEDAS A UN AUTOMÓVIL"
  },
  {
    "codigo":190815001,
    "descripcion":"VASCULITIS CRIOGLOBULINÉMICA"
  },
  {
    "codigo":289119003,
    "descripcion":"ELIMINA ESPUTOS"
  },
  {
    "codigo":26975007,
    "descripcion":"HIPERPLASIA LOBULAR COMPENSATORIA DEL HÍGADO"
  },
  {
    "codigo":254516007,
    "descripcion":"NEOPLASIA DE EPIGLOTIS SUPRAHIOIDEA"
  },
  {
    "codigo":449289002,
    "descripcion":"NEVO MELANOCÍTICO DE LENGUA"
  },
  {
    "codigo":285449003,
    "descripcion":"INCAPAZ DE MOVER LA MANDÍBULA REPETIDAMENTE"
  },
  {
    "codigo":187145004,
    "descripcion":"EQUINOCOCOSIS DE PÁNCREAS"
  },
  {
    "codigo":1137417006,
    "descripcion":"CAPAZ DE COMUNICAR INFORMACIÓN ACERCA DE LAS NÁUSEAS"
  },
  {
    "codigo":711433008,
    "descripcion":"EVENTO POTENCIALMENTE FATAL APARENTE EN LACTANTE"
  },
  {
    "codigo":283614002,
    "descripcion":"HERIDA POR PINCHAZO DE AGUJA EN EL ANTEBRAZO"
  },
  {
    "codigo":840670005,
    "descripcion":"SISTEMA NERVIOSO MOTOR INTACTO"
  },
  {
    "codigo":87006007,
    "descripcion":"TRASTORNO HEREDITARIO AUTOSÓMICO DOMINANTE, PENETRANCIA INCOMPLETA"
  },
  {
    "codigo":773299000,
    "descripcion":"DISOMÍA UNIPARENTAL MATERNA DEL CROMOSOMA 16"
  },
  {
    "codigo":1363123001,
    "descripcion":"ASTILLA EN ESCROTO"
  },
  {
    "codigo":21470009,
    "descripcion":"SÍNCOPE ANGINOSO"
  },
  {
    "codigo":314547001,
    "descripcion":"ENDOFTALMITIS POSTRAUMÁTICA"
  },
  {
    "codigo":112001000119100,
    "descripcion":"CRIBADO PARA DEPRESIÓN POSITIVO EN EL CUESTIONARIO SOBRE LA SALUD DEL PACIENTE-9"
  },
  {
    "codigo":15712641000119101,
    "descripcion":"ISQUEMIA DE MIEMBRO SUPERIOR DERECHO"
  },
  {
    "codigo":316801000119101,
    "descripcion":"DOLOR EN LA PIERNA IZQUIERDA"
  },
  {
    "codigo":321921000119100,
    "descripcion":"RIGIDEZ DE ARTICULACIÓN DE LA CADERA IZQUIERDA"
  },
  {
    "codigo":52403007,
    "descripcion":"TROMBOANGEÍTIS OBLITERANTE"
  },
  {
    "codigo":15740801000119105,
    "descripcion":"ALMOHADILLAS DE NUDILLOS DE LA MANO IZQUIERDA"
  },
  {
    "codigo":15684481000119106,
    "descripcion":"PERIOSTITIS DE PIE DERECHO"
  },
  {
    "codigo":12161000119107,
    "descripcion":"LLANTO EXCESIVO, NIÑO NO LACTANTE"
  },
  {
    "codigo":12236161000119108,
    "descripcion":"CONJUNTIVITIS DE OJO IZQUIERDO"
  },
  {
    "codigo":12200321000119107,
    "descripcion":"FALLA DE TRASPLANTE DE PULMÓN"
  },
  {
    "codigo":15664001000119107,
    "descripcion":"HEMARTROSIS DE AMBOS CODOS"
  },
  {
    "codigo":11864961000119103,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO DE PIERNA DERECHA"
  },
  {
    "codigo":593005441000119104,
    "descripcion":"TRASTORNO DE DIENTE DEBIDO A SÍNDROME DE SJÖGREN"
  },
  {
    "codigo":314241000119107,
    "descripcion":"MIOSITIS OSIFICANTE TRAUMÁTICA DE BRAZO IZQUIERDO"
  },
  {
    "codigo":11780481000119105,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO DE BRAZO DERECHO"
  },
  {
    "codigo":11995521000119108,
    "descripcion":"DEHISCENCIA DE HERIDA DE MUÑÓN DE AMPUTACIÓN DE EXTREMIDAD INFERIOR IZQUIERDA"
  },
  {
    "codigo":83336007,
    "descripcion":"RUPTURA DEL DIAFRAGMA"
  },
  {
    "codigo":301441000119108,
    "descripcion":"ABSCESO DE BOLSA SEROSA DE RODILLA IZQUIERDA"
  },
  {
    "codigo":15707521000119109,
    "descripcion":"MIOSITIS OSIFICANTE TRAUMÁTICA DE BRAZOS BILATERALES"
  },
  {
    "codigo":704093007,
    "descripcion":"FRACTURA NO EXPUESTA EN MARTILLO DE FALANGE DISTAL DE DEDO ANULAR"
  },
  {
    "codigo":247176008,
    "descripcion":"RETINOSQUISIS - DESGARRO DE LA LÁMINA EXTERNA"
  },
  {
    "codigo":310877009,
    "descripcion":"ESTADO DE PROGRAMA DE REDUCCIÓN"
  },
  {
    "codigo":866098005,
    "descripcion":"LINFOMA DE LINFOCITOS B GRANDES ORIGINADO EN ENFERMEDAD DE CASTLEMAN MULTICÉNTRICA ASOCIADA CON HHV8"
  },
  {
    "codigo":14130006,
    "descripcion":"INTOXICACIÓN CAUSADA POR AMPICILINA"
  },
  {
    "codigo":309042009,
    "descripcion":"SITUACIÓN DE PROCEDIMIENTO MEDICOLEGAL"
  },
  {
    "codigo":897031002,
    "descripcion":"MIELITIS FLÁCIDA AGUDA"
  },
  {
    "codigo":700423003,
    "descripcion":"ADENOCARCINOMA DE PÁNCREAS"
  },
  {
    "codigo":733191004,
    "descripcion":"DEMENCIA DEBIDA A HEMATOMA SUBDURAL CRÓNICO"
  },
  {
    "codigo":12295008,
    "descripcion":"BRONQUIECTASIA"
  },
  {
    "codigo":1255644001,
    "descripcion":"CARCINOMA DE CÉLULAS ACINARES DE PULMÓN"
  },
  {
    "codigo":681621000119105,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE CUERPO DE PÁNCREAS"
  },
  {
    "codigo":75996005,
    "descripcion":"TIÑA PEDIA CAUSADA POR EPIDERMOPHYTON FLOCCOSUM"
  },
  {
    "codigo":303537001,
    "descripcion":"AMPLITUD DE MOVIMIENTO ACTIVO DE RETRACCIÓN DE LA COLUMNA CERVICAL AUMENTADA"
  },
  {
    "codigo":239836009,
    "descripcion":"ARTRITIS SECUNDARIA POR PIROFOSFATO"
  },
  {
    "codigo":762289003,
    "descripcion":"HEMORRAGIA NEONATAL DE VEJIGA URINARIA"
  },
  {
    "codigo":238001003,
    "descripcion":"DEFICIENCIA DE LA CARNITINA PALMITOILTRANSFERASA I"
  },
  {
    "codigo":170630001,
    "descripcion":"BRONCODILATADORES USADOS COMO MÁXIMO UNA VEZ AL DÍA"
  },
  {
    "codigo":432774005,
    "descripcion":"RECHAZO HIPERAGUDO DE TRASPLANTE DE PULMÓN"
  },
  {
    "codigo":365403000,
    "descripcion":"ETAPA DEL VELLO PÚBICO - HALLAZGO"
  },
  {
    "codigo":400006008,
    "descripcion":"HAMARTOMA"
  },
  {
    "codigo":103259000,
    "descripcion":"MIRADA VERTICAL CONJUGADA ANORMAL"
  },
  {
    "codigo":1184603003,
    "descripcion":"INCONTINENCIA URINARIA POSOPERATORIA"
  },
  {
    "codigo":1217371005,
    "descripcion":"SÍNDROME DE HIPOTONÍA INFANTIL, ANOMALÍAS OCULOMOTORAS, MOVIMIENTOS HIPERQUINÉTICOS Y RETRASO DEL DESARROLLO"
  },
  {
    "codigo":430939007,
    "descripcion":"ABRASIÓN DE PIEL DE REGIÓN SACRA"
  },
  {
    "codigo":12205871000119105,
    "descripcion":"RUPTURA DE IMPLANTE DE MAMA DERECHA"
  },
  {
    "codigo":299867008,
    "descripcion":"REFLEJO ANAL ACTIVO"
  },
  {
    "codigo":396336000,
    "descripcion":"COLITIS AGUDA Y CRÓNICA"
  },
  {
    "codigo":166960004,
    "descripcion":"NIVEL TERAPÉUTICO DE DIGOXINA"
  },
  {
    "codigo":15701961000119100,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE TENDÓN DE MANO DERECHA"
  },
  {
    "codigo":724016008,
    "descripcion":"SÍNDROME DE PTOSIS, LIMITACIÓN DE LOS MOVIMIENTOS OCULARES HACIA ARRIBA Y AUSENCIA DE PUNTO LAGRIMAL"
  },
  {
    "codigo":230661001,
    "descripcion":"HIPOHIDROSIS SEGMENTARIA"
  },
  {
    "codigo":296197002,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE PIMOZIDA"
  },
  {
    "codigo":722181009,
    "descripcion":"DEPENDIENTE PARA PONERSE DE PIE"
  },
  {
    "codigo":425434004,
    "descripcion":"ADHERENCIA ADQUIRIDA DE LABIOS VULVARES"
  },
  {
    "codigo":294362008,
    "descripcion":"ALERGIA A KETOCONAZOL"
  },
  {
    "codigo":292527003,
    "descripcion":"REACCIÓN ADVERSA AL BIPERIDENO"
  },
  {
    "codigo":290692001,
    "descripcion":"INTOXICACIÓN POR PENTOSTATINA"
  },
  {
    "codigo":94084002,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE HUESO DEL TARSO"
  },
  {
    "codigo":126852003,
    "descripcion":"NEOPLASIA DE LAS VÍAS BILIARES INTRAHEPÁTICAS"
  },
  {
    "codigo":1306500007,
    "descripcion":"CARCINOMA DUCTAL INFILTRANTE PRIMARIO DE PROLONGACIÓN AXILAR DE MAMA IZQUIERDA"
  },
  {
    "codigo":190553000,
    "descripcion":"HIPOFUNCIÓN TESTICULAR POSTQUIRÚRGICA"
  },
  {
    "codigo":288857007,
    "descripcion":"DIFICULTAD PARA BEBER"
  },
  {
    "codigo":254254006,
    "descripcion":"SÍNDROME DE TOLUENO FETAL"
  },
  {
    "codigo":90414007,
    "descripcion":"APLASIA ERITROCITARIA PURA ADQUIRIDA CRÓNICA"
  },
  {
    "codigo":188718006,
    "descripcion":"PLASMOCITOMA EXTRAMEDULAR"
  },
  {
    "codigo":876846006,
    "descripcion":"AGENESIA DE CUERDAS TENDINOSAS DE VÁLVULA TRICÚSPIDE"
  },
  {
    "codigo":285187002,
    "descripcion":"CAPAZ DE RECORDAR SU FECHA DE CUMPLEAÑOS"
  },
  {
    "codigo":449027007,
    "descripcion":"ORIGEN DISTAL DE ARTERIA BRAQUIOCEFÁLICA CON COMPRESIÓN TRAQUEAL"
  },
  {
    "codigo":711171008,
    "descripcion":"RESORCIÓN DE HUESO ALVEOLAR MAXILAR ANTERIOR Y ESPINA NASAL DEBIDA A LEPRA LEPROMATOSA"
  },
  {
    "codigo":86744003,
    "descripcion":"QUEMADURA PROFUNDA DE TERCER GRADO DEL TRONCO"
  },
  {
    "codigo":283352008,
    "descripcion":"PICADURA DE INSECTO INFECTADA EN LOS GENITALES"
  },
  {
    "codigo":19373007,
    "descripcion":"OFTALMOPLEJÍA EXTERNA"
  },
  {
    "codigo":281517008,
    "descripcion":"FRACTURA-LUXACIÓN PERISEMILUNAR Y ESCAFOTRANSESTILOIDEA"
  },
  {
    "codigo":83074005,
    "descripcion":"EMBARAZO INDESEADO"
  },
  {
    "codigo":246914007,
    "descripcion":"PÉRDIDA DE CONTINUIDAD DEL MARGEN ORBITARIO"
  },
  {
    "codigo":212311000,
    "descripcion":"CONTUSIÓN, NERVIO CIÁTICO"
  },
  {
    "codigo":441687008,
    "descripcion":"ESTUDIO POR IMÁGENES DEL APARATO GENITOURINARIO, ANORMAL"
  },
  {
    "codigo":13868004,
    "descripcion":"PARA 5"
  },
  {
    "codigo":1259052007,
    "descripcion":"CEFALEA CAUSADA POR MONÓXIDO DE CARBONO"
  },
  {
    "codigo":732929002,
    "descripcion":"DISTROFIA MUSCULAR DE LAS CINTURAS DE LAS EXTREMIDADES TIPO 2S AUTOSÓMICA RECESIVA"
  },
  {
    "codigo":44801007,
    "descripcion":"CONTUSIÓN DE LA CADERA"
  },
  {
    "codigo":306945008,
    "descripcion":"HALLAZGO RELACIONADO CON LA MOVILIDAD DEL CARTÍLAGO ARITENOIDES"
  },
  {
    "codigo":110337007,
    "descripcion":"FORMA CÓNICA DE LA RAÍZ DENTAL"
  },
  {
    "codigo":403414008,
    "descripcion":"PANICULITIS CON DEFICIENCIA DEL COMPLEMENTO"
  },
  {
    "codigo":270507001,
    "descripcion":"FRACTURA PATOLÓGICA DE VÉRTEBRA DORSAL"
  },
  {
    "codigo":237739002,
    "descripcion":"SEUDOSÍNDROME DEPRESIVO DE CUSHING"
  },
  {
    "codigo":6528000,
    "descripcion":"NUCLEACIÓN DE CRISTALES DE COLESTEROL EN BILIS"
  },
  {
    "codigo":1153408000,
    "descripcion":"CALCIFICACIÓN MUSCULAR DEBIDA A DERMATOMIOSITIS DEL ADULTO"
  },
  {
    "codigo":10625431000119105,
    "descripcion":"BRONCONEUMONÍA CAUSADA POR MYCOPLASMA PNEUMONIAE"
  },
  {
    "codigo":268672004,
    "descripcion":"TRASTORNO EN EL DESARROLLO DEL HABLA Y EL LENGUAJE"
  },
  {
    "codigo":399744004,
    "descripcion":"TROMPA DE FALOPIO IZQUIERDA FUSIONADA CON EL OVARIO IZQUIERDO"
  },
  {
    "codigo":102997000,
    "descripcion":"PSICROALGIA"
  },
  {
    "codigo":365141004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA CONSTRUIR COSAS"
  },
  {
    "codigo":725589005,
    "descripcion":"DISTROFIA BULLOSA DE TIPO MACULAR"
  },
  {
    "codigo":234069007,
    "descripcion":"COMPRESIÓN AORTOCAVA"
  },
  {
    "codigo":232234000,
    "descripcion":"OTITIS EXTERNA AGUDA DE CAUSA ALÉRGICA"
  },
  {
    "codigo":12099991000119108,
    "descripcion":"INFECCIÓN ASOCIADA A IMPLANTE PROTÉSICO DE MAMA IZQUIERDA"
  },
  {
    "codigo":2858002,
    "descripcion":"SEPSIS PUERPERAL"
  },
  {
    "codigo":166698001,
    "descripcion":"NIVEL DE BICARBONATO SÉRICO DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1023001,
    "descripcion":"APNEA"
  },
  {
    "codigo":230399001,
    "descripcion":"EPILEPSIA DE LÓBULO FRONTAL DORSOLATERAL"
  },
  {
    "codigo":199466009,
    "descripcion":"ÚTERO GRÁVIDO INCARCERADO EN RETROVERSIÓN"
  },
  {
    "codigo":295935003,
    "descripcion":"SOBREDOSIS DE FLUOXETINA"
  },
  {
    "codigo":263167007,
    "descripcion":"FRACTURA POR ESTALLIDO DE ÓRBITA"
  },
  {
    "codigo":15678001000119106,
    "descripcion":"CORIORRETINITIS DE AMBOS OJOS CAUSADA POR CITOMEGALOVIRUS HUMANO BETA 5"
  },
  {
    "codigo":294100008,
    "descripcion":"ALERGIA A ETAMIVÁN"
  },
  {
    "codigo":1177001000,
    "descripcion":"TRASTORNO DE TICS DEBIDO A COREA REUMÁTICA"
  },
  {
    "codigo":31956009,
    "descripcion":"DEPENDENCIA DE COCAÍNA"
  },
  {
    "codigo":126590001,
    "descripcion":"NEOPLASIA DEL ASTRÁGALO"
  },
  {
    "codigo":95657009,
    "descripcion":"SÍNDROME DE CEFALEA CRÓNICA MIXTA"
  },
  {
    "codigo":290430002,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR BISACODILO"
  },
  {
    "codigo":716414004,
    "descripcion":"CAPAZ DE MANTENER LA ESTRUCTURA Y RUTINA EN LA VIDA DIARIA"
  },
  {
    "codigo":16906801000119109,
    "descripcion":"NEOPLASIA BENIGNA DE PIEL DE PÁRPADO INFERIOR DERECHO"
  },
  {
    "codigo":190291004,
    "descripcion":"PUBERTAD PREMATURA POR HIPOTIROIDISMO"
  },
  {
    "codigo":91987008,
    "descripcion":"NEOPLASIA BENIGNA DE GANGLIOS LINFÁTICOS AXILARES"
  },
  {
    "codigo":288595009,
    "descripcion":"UTILIZA UN SISTEMA DE COMUNICACIÓN NO VERBAL PARA EXPRESARSE"
  },
  {
    "codigo":286760002,
    "descripcion":"TIENDE A NO PLANIFICAR A FUTURO"
  },
  {
    "codigo":1237032005,
    "descripcion":"METÁSTASIS DE CARCINOMA DE PORCIÓN TORÁCICA DE ESÓFAGO"
  },
  {
    "codigo":88317000,
    "descripcion":"EROTISMO ANAL"
  },
  {
    "codigo":448765001,
    "descripcion":"DESCENSO DE PESO NO INTENCIONAL"
  },
  {
    "codigo":219389008,
    "descripcion":"HERIDA DE GUERRA POR FRAGMENTOS DE COHETE"
  },
  {
    "codigo":119250001,
    "descripcion":"HIPOGAMMAGLOBULINEMIA"
  },
  {
    "codigo":283090008,
    "descripcion":"ARAÑAZO DE TÓRAX"
  },
  {
    "codigo":84647002,
    "descripcion":"MELANOPLAQUIA"
  },
  {
    "codigo":306021000119104,
    "descripcion":"TRASTORNO DE LIGAMENTO DE ARTICULACIÓN DE LA CADERA IZQUIERDA"
  },
  {
    "codigo":51879004,
    "descripcion":"LUXACIÓN CERRADA MEDIAL DEL EXTREMO PROXIMAL DE LA TIBIA"
  },
  {
    "codigo":314023004,
    "descripcion":"CONDUCTO NASOLAGRIMAL PERMEABLE"
  },
  {
    "codigo":248487006,
    "descripcion":"TUMEFACCIÓN DE PAPILA ÓPTICA"
  },
  {
    "codigo":281255004,
    "descripcion":"OBSTRUCCIÓN DEL INTESTINO DELGADO"
  },
  {
    "codigo":838311008,
    "descripcion":"HEMANGIOMA CAVERNOSO DE HÍGADO"
  },
  {
    "codigo":15952741000119105,
    "descripcion":"PAPILOMA INTRADUCTAL DE AMBAS MAMAS"
  },
  {
    "codigo":246652006,
    "descripcion":"LA IMAGEN VISUAL SE DESVANECE Y REAPARECE"
  },
  {
    "codigo":1295228006,
    "descripcion":"SINOVITIS CRÓNICA DE REGIÓN DE MUÑECA DEBIDA A HEMARTROSIS"
  },
  {
    "codigo":770940006,
    "descripcion":"NEVO PANFOLICULAR CONGÉNITO"
  },
  {
    "codigo":17276009,
    "descripcion":"FERTILIDAD DISMINUIDA"
  },
  {
    "codigo":279420009,
    "descripcion":"HEMATOMA DE PIEL"
  },
  {
    "codigo":1162321004,
    "descripcion":"OSTEONECROSIS DE PIERNA POR HEMOGLOBINOPATÍA"
  },
  {
    "codigo":408657005,
    "descripcion":"ESPÉCIMEN MESORRECTAL COMPLETAMENTE INTACTO"
  },
  {
    "codigo":212049006,
    "descripcion":"QUEMADURAS CLASIFICADAS SEGÚN EL PORCENTAJE DE SUPERFICIE CORPORAL QUEMADA"
  },
  {
    "codigo":242982004,
    "descripcion":"LESIÓN CON PROPÓSITO DESCONOCIDO POR CAÍDA DESDE ACANTILADO"
  },
  {
    "codigo":439590007,
    "descripcion":"PRUEBA DE ESTRÉS CARDIOVASCULAR ANORMAL"
  },
  {
    "codigo":308518008,
    "descripcion":"ESTADO DEL CONTROL DE SALUD DEL HOMBRE"
  },
  {
    "codigo":111910009,
    "descripcion":"INFECCIÓN AMEBIÁSICA"
  },
  {
    "codigo":16008191000119104,
    "descripcion":"RUPTURA DEGENERATIVA DE FIBROCARTÍLAGO TRIANGULAR DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":110075004,
    "descripcion":"LACERACIÓN COMPLEJA CONTAMINADA DE LA NARIZ"
  },
  {
    "codigo":208379007,
    "descripcion":"FRACTURA EXPUESTA DE HUESO GANCHOSO, APÓFISIS UNCIFORME"
  },
  {
    "codigo":403152000,
    "descripcion":"BLEFARITIS DEMODÉCTICA"
  },
  {
    "codigo":765435009,
    "descripcion":"SÍNDROME AUTOINFLAMATORIO ASOCIADO A OTULIN"
  },
  {
    "codigo":1156816005,
    "descripcion":"GANGLIOGLIOMA NASAL"
  },
  {
    "codigo":10683391000119107,
    "descripcion":"TUMORACIÓN DEL TEJIDO CELULAR SUBCUTÁNEO DE LA PARED ABDOMINAL"
  },
  {
    "codigo":204709003,
    "descripcion":"AUSENCIA CONGÉNITA DE RECTO, CON FÍSTULA"
  },
  {
    "codigo":237477007,
    "descripcion":"DOLOR ASOCIADO CON IMPLANTE MAMARIO"
  },
  {
    "codigo":898941951000119108,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DEBIDO A OCLUSIÓN DE AMBAS ARTERIAS VERTEBRALES"
  },
  {
    "codigo":235642003,
    "descripcion":"FÍSTULA ESOFÁGICA EXTERNA"
  },
  {
    "codigo":301178004,
    "descripcion":"RETORNO VENOSO NORMAL EN VENA DE LA EXTREMIDAD"
  },
  {
    "codigo":71802006,
    "descripcion":"ASTASIA-ABASIA"
  },
  {
    "codigo":1251450006,
    "descripcion":"SÍNDROME DE TRIPLICACIÓN 16P12.1P12.3"
  },
  {
    "codigo":364879000,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA LANZAR"
  },
  {
    "codigo":366714008,
    "descripcion":"AMPLITUD DE MOVIMIENTO ACTIVO DE ADUCCIÓN DE DEDO DEL PIE - HALLAZGO"
  },
  {
    "codigo":168271003,
    "descripcion":"HELICOBACTER DETECTADO POR SEROLOGÍA"
  },
  {
    "codigo":299343008,
    "descripcion":"SIN AMPLITUD PASIVA DE FLEXIÓN DE RODILLA"
  },
  {
    "codigo":231972004,
    "descripcion":"CATARATA POR DESNUTRICIÓN-DESHIDRATACIÓN"
  },
  {
    "codigo":789028005,
    "descripcion":"REQUIERE VACUNACIÓN CONTRA LEISHMANIASIS"
  },
  {
    "codigo":166436007,
    "descripcion":"PRUEBA SÉRICA DE EMBARAZO, DUDOSA"
  },
  {
    "codigo":787193001,
    "descripcion":"METABOLIZADOR RÁPIDO DE LA FAMILIA 2 SUBFAMILIA C MIEMBRO 9 DEL CITOCROMO P450"
  },
  {
    "codigo":295673001,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE PLICAMICINA"
  },
  {
    "codigo":721657003,
    "descripcion":"INTOXICACIÓN ALIMENTARIA CAUSADA POR LISTERIA MONOCYTOGENES"
  },
  {
    "codigo":262905008,
    "descripcion":"RUPTURA DE VÍA URINARIA"
  },
  {
    "codigo":293838003,
    "descripcion":"ALERGIA A ISOCARBOXAZIDA"
  },
  {
    "codigo":126301000146100,
    "descripcion":"CAPAZ OCASIONALMENTE DE CUIDAR A UN NIÑO"
  },
  {
    "codigo":228302005,
    "descripcion":"BEBE CON AMIGOS"
  },
  {
    "codigo":193699007,
    "descripcion":"CEGUERA - AMBOS OJOS"
  },
  {
    "codigo":95395009,
    "descripcion":"TUMORACIÓN EN EL SITIO DE INYECCIÓN"
  },
  {
    "codigo":421240002,
    "descripcion":"TOXICOSIS PRODUCIDA POR PENICILLIUM PURPUROGENUM"
  },
  {
    "codigo":93560008,
    "descripcion":"PERFORACIÓN IATROGÉNICA DE LA FARINGE"
  },
  {
    "codigo":288333000,
    "descripcion":"LEVANTA OBJETOS"
  },
  {
    "codigo":290168008,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR DIPIPANONA"
  },
  {
    "codigo":124493003,
    "descripcion":"DEFICIENCIA DE CARBOXIPEPTIDASA B"
  },
  {
    "codigo":879992009,
    "descripcion":"GASTRINOMA DE DUODENO"
  },
  {
    "codigo":417570003,
    "descripcion":"CORIOCARCINOMA GESTACIONAL"
  },
  {
    "codigo":384802003,
    "descripcion":"MARGEN LATERAL (MUCOSO\/MURAL) DE RESECCIÓN QUIRÚRGICA NO AFECTADO POR CARCINOMA IN SITU"
  },
  {
    "codigo":286498003,
    "descripcion":"NO PREPARA COMIDA PARA ANIMALES"
  },
  {
    "codigo":712482006,
    "descripcion":"BURSITIS DE MIEMBRO INFERIOR"
  },
  {
    "codigo":24354007,
    "descripcion":"INTOXICACIÓN POR COLCHICINA"
  },
  {
    "codigo":415735001,
    "descripcion":"QUERATOCONJUNTIVITIS TÓXICA"
  },
  {
    "codigo":253730009,
    "descripcion":"SISTEMA CORONARIO EQUILIBRADO"
  },
  {
    "codigo":219127004,
    "descripcion":"SUICIDIO E INTOXICACIÓN AUTOINFLIGIDA POR GAS LICUADO DE PETRÓLEO DISTRIBUIDO EN ENVASES MÓVILES"
  },
  {
    "codigo":315596001,
    "descripcion":"ABSCESO DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":446668003,
    "descripcion":"RETRONO VENOSO PULMONAR OBSTRUIDO POR COMPRESIÓN EXTRÍNSECA"
  },
  {
    "codigo":1003724005,
    "descripcion":"CONTRACTURA EN FLEXIÓN DE ARTICULACIÓN INTERFALÁNGICA PROXIMAL DE DEDO ANULAR"
  },
  {
    "codigo":250060005,
    "descripcion":"MANIPULA TORPEMENTE LAS COSAS"
  },
  {
    "codigo":1264033000,
    "descripcion":"INFLAMACIÓN DE MÚSCULO DE PIE"
  },
  {
    "codigo":413900009,
    "descripcion":"RESUMEN COMPUTARIZADO ACTUALIZADO"
  },
  {
    "codigo":248225003,
    "descripcion":"PARECE EN TRANCE"
  },
  {
    "codigo":18849004,
    "descripcion":"INFECCIÓN CAUSADA POR TRICHOSTRONGYLUS AXEI"
  },
  {
    "codigo":280993006,
    "descripcion":"DIVERTÍCULO PERFORADO DE INTESTINO DELGADO"
  },
  {
    "codigo":770678005,
    "descripcion":"ENCEFALOPATÍA PROGRESIVA CON EDEMA, HIPSARRITMIA Y SÍNDROME TIPO ATROFIA ÓPTICA"
  },
  {
    "codigo":703307003,
    "descripcion":"ANOMALÍA ADQUIRIDA DE ÁRBOL ARTERIAL PULMONAR"
  },
  {
    "codigo":1293131004,
    "descripcion":"ANGIOMIOLIPOMA"
  },
  {
    "codigo":408395005,
    "descripcion":"BAJO ATENCIÓN DE PSICÓLOGO"
  },
  {
    "codigo":768843007,
    "descripcion":"SÍNDROME DE ESTATURA ELEVADA, DISCAPACIDAD INTELECTUAL Y DISMORFISMO FACIAL"
  },
  {
    "codigo":15984231000119105,
    "descripcion":"TUBERCULOSIS DE OÍDO IZQUIERDO"
  },
  {
    "codigo":111648001,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE VÉRTEBRA CERVICAL"
  },
  {
    "codigo":406560000,
    "descripcion":"MORDEDURA DE ANIMAL POTENCIALMENTE RABIOSO"
  },
  {
    "codigo":1260363007,
    "descripcion":"DISTONÍA DEBIDA A ENFERMEDAD DE PELIZAEUS-MERZBACHER"
  },
  {
    "codigo":211787009,
    "descripcion":"QUEMADURA DE SEGUNDO GRADO DE SITIOS MÚLTIPLES DE TRONCO"
  },
  {
    "codigo":337511000119106,
    "descripcion":"SIMBLÉFARON DE OJO IZQUIERDO"
  },
  {
    "codigo":439328007,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE CABEZA Y\/O CUELLO"
  },
  {
    "codigo":275488008,
    "descripcion":"ODINOFAGIA CRÓNICA"
  },
  {
    "codigo":109813002,
    "descripcion":"ÚLCERA PÉPTICA INDUCIDA POR DROGAS"
  },
  {
    "codigo":10659431000119107,
    "descripcion":"ÚLCERA DE TALÓN IZQUIERDO"
  },
  {
    "codigo":281352004,
    "descripcion":"BURSITIS DE MÚSCULO PSOAS ILÍACO"
  },
  {
    "codigo":239050000,
    "descripcion":"SÍNDROME DE ALOPECIA, DISTROFIA UNGUEAL, COMPLICACIONES OFTÁLMICAS, DISFUNCIÓN TIROIDEA, HIPOHIDROSIS, EFÉLIDES, ENTEROPATÍA E INFECCIONES RESPIRATORIAS"
  },
  {
    "codigo":240885009,
    "descripcion":"DERMATOSIS CAUSADA POR ÁCAROS"
  },
  {
    "codigo":1287626002,
    "descripcion":"ABRASIÓN DE PIEL DE PARED ABDOMINAL ANTERIOR"
  },
  {
    "codigo":42442001,
    "descripcion":"LIQUEN ESTRIADO"
  },
  {
    "codigo":11779841000119102,
    "descripcion":"HERIDA DE REGIÓN DE ANTEBRAZO DERECHO DEBIDA A PICADURA DE INSECTO NO VENENOSO"
  },
  {
    "codigo":15630081000119103,
    "descripcion":"ANTEVERSIÓN CONGÉNITA DE FÉMUR DERECHO"
  },
  {
    "codigo":9674006,
    "descripcion":"TRASTORNO DE ADAPTACIÓN, CON AISLAMIENTO SOCIAL"
  },
  {
    "codigo":1254858007,
    "descripcion":"LIPOMATOSIS PERINEURAL"
  },
  {
    "codigo":11861761000119103,
    "descripcion":"RUPTURA DE LIGAMENTO CRUZADO ANTERIOR DE RODILLA DERECHA"
  },
  {
    "codigo":402890001,
    "descripcion":"VULVOVAGINITIS HERPÉTICA PRIMARIA"
  },
  {
    "codigo":1351327002,
    "descripcion":"INMUNODEFICIENCIA COMBINADA AUTOSÓMICA RECESIVA DEBIDA A DEFICIENCIA DE RECEPTOR DE INTERLEUCINA 6"
  },
  {
    "codigo":106143002,
    "descripcion":"PROBLEMAS RELACIONADOS CON LA SEXUALIDAD"
  },
  {
    "codigo":40607004,
    "descripcion":"HIPERTIROIDISMO SECUNDARIO A MOLA HIDATIFORME CON CRISIS TIROTÓXICA"
  },
  {
    "codigo":73375005,
    "descripcion":"ÚLCERA DE LA LARINGE"
  },
  {
    "codigo":827039007,
    "descripcion":"CARÁCTER NORMAL DEL PULSO"
  },
  {
    "codigo":399220000,
    "descripcion":"POSICIÓN CORPORAL TRANSVERSAL"
  },
  {
    "codigo":366452008,
    "descripcion":"REFLEJO DEL SUPINADOR LARGO - HALLAZGO"
  },
  {
    "codigo":202612009,
    "descripcion":"CHASQUIDO DE ARTICULACIÓN SUBASTRAGALINA"
  },
  {
    "codigo":102473004,
    "descripcion":"RESPUESTA TERAPÉUTICA REDUCIDA"
  },
  {
    "codigo":299081006,
    "descripcion":"AMPLITUD DE EXTENSIÓN PASIVA DE DEDO DE LA MANO NORMAL"
  },
  {
    "codigo":198942000,
    "descripcion":"HIPERTENSIÓN ESENCIAL BENIGNA QUE COMPLICA EL EMBARAZO, EL NACIMIENTO Y EL PUERPERIO"
  },
  {
    "codigo":295411000,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE CISAPRIDA"
  },
  {
    "codigo":67870009,
    "descripcion":"INTOXICACIÓN POR RUMEX"
  },
  {
    "codigo":721395003,
    "descripcion":"SÍNDROME DEL CORDÓN POSTERIOR DE MÉDULA ESPINAL AL NIVEL DEL SEXTO SEGMENTO CERVICAL"
  },
  {
    "codigo":197107003,
    "descripcion":"DIVERTÍCULO PERFORADO DEL ÍLEON"
  },
  {
    "codigo":426483005,
    "descripcion":"DOLOR IRRADIADO A LA REGIÓN TORÁCICA, LADO IZQUIERDO"
  },
  {
    "codigo":424648000,
    "descripcion":"FRACTURA NO EXPUESTA DE BASE DEL QUINTO METATARSIANO"
  },
  {
    "codigo":162504001,
    "descripcion":"CÓLICO"
  },
  {
    "codigo":293576002,
    "descripcion":"REACCIÓN ADVERSA A LA DESOXIRRIBONUCLEASA"
  },
  {
    "codigo":195272002,
    "descripcion":"ANEURISMA DE ARTERIA RADIAL"
  },
  {
    "codigo":1145544004,
    "descripcion":"FISURA DE LABIO COMPLETA DEL LADO DERECHO E INCOMPLETA DEL LADO IZQUIERDO"
  },
  {
    "codigo":129736006,
    "descripcion":"LESIÓN DE FORMA IRREGULAR"
  },
  {
    "codigo":717725000,
    "descripcion":"DERMATITIS POR CONTACTO DE GENITALES FEMENINOS"
  },
  {
    "codigo":783261004,
    "descripcion":"NO BEBEDOR DE ALCOHOL DE POR VIDA"
  },
  {
    "codigo":226205004,
    "descripcion":"DIETA SIN GERMEN DE TRIGO"
  },
  {
    "codigo":95133008,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE MUSLO"
  },
  {
    "codigo":289906003,
    "descripcion":"PROBLEMA DEL APARATO GENITAL FEMENINO"
  },
  {
    "codigo":16314421000119103,
    "descripcion":"INFECCIÓN POR TIÑA DE LA INGLE MODIFICADA POR ESTEROIDES"
  },
  {
    "codigo":93298007,
    "descripcion":"HIPOPLASIA CONGÉNITA DE TIBIA"
  },
  {
    "codigo":224370007,
    "descripcion":"EN ÁMBITO DE TRABAJO GUBERNAMENTAL"
  },
  {
    "codigo":1303879005,
    "descripcion":"ESTENOSIS DE ARTERIA ILÍACA EXTERNA IZQUIERDA"
  },
  {
    "codigo":58695007,
    "descripcion":"CROMOBLASTOMICOSIS CAUSADA POR FONSECAEA COMPACTA"
  },
  {
    "codigo":286236000,
    "descripcion":"CAPAZ DE COORDINAR EL FLUJO DEL AIRE CON LA EMISIÓN DE LA VOZ"
  },
  {
    "codigo":11808821000119105,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE REGIÓN DE CADERA DERECHA"
  },
  {
    "codigo":187932002,
    "descripcion":"NEOPLASIA MALIGNA DE HÚMERO"
  },
  {
    "codigo":89628003,
    "descripcion":"COLECISTITIS SUPURATIVA AGUDA"
  },
  {
    "codigo":253468007,
    "descripcion":"ANOMALÍA DE EBSTEIN DE VÁLVULA AURICULOVENTRICULAR DERECHA"
  },
  {
    "codigo":55025003,
    "descripcion":"COLITIS URÉMICA"
  },
  {
    "codigo":1300209004,
    "descripcion":"TRASTORNO PERINATAL MATERNO"
  },
  {
    "codigo":53190001,
    "descripcion":"COMPRESIÓN VASCULAR DEL ESÓFAGO POR ARTERIA ABERRANTE"
  },
  {
    "codigo":249798002,
    "descripcion":"ARQUEAMIENTO DE HUESO DEL PIE"
  },
  {
    "codigo":413638006,
    "descripcion":"MIOCLONÍA NEONATAL BENIGNA DURANTE EL SUEÑO"
  },
  {
    "codigo":247963001,
    "descripcion":"VERIFICACIÓN COMPULSIVA"
  },
  {
    "codigo":20422009,
    "descripcion":"MUSITACIÓN"
  },
  {
    "codigo":1003462009,
    "descripcion":"DISPLASIA CORTICAL FOCAL TIPO IB"
  },
  {
    "codigo":870555005,
    "descripcion":"FRACTURA EXPUESTA DE CRÁNEO CON CONTUSIÓN DE CEREBRO"
  },
  {
    "codigo":51355005,
    "descripcion":"INTOXICACIÓN POR SARCOSTEMMA"
  },
  {
    "codigo":1263771009,
    "descripcion":"ENFERMEDAD INFLAMATORIA PÉLVICA AGUDA SOBRE CRÓNICA"
  },
  {
    "codigo":16097641000119100,
    "descripcion":"ARTROFIBROSIS DE RODILLA DERECHA"
  },
  {
    "codigo":369001000119100,
    "descripcion":"INFECCIÓN DE LA VÍA URINARIA CAUSADA POR KLEBSIELLA"
  },
  {
    "codigo":735813002,
    "descripcion":"LACERACIÓN DE MUÑECA CON CUERPO EXTRAÑO"
  },
  {
    "codigo":1260101003,
    "descripcion":"TATUAJE DE COLOR AZUL DE TEJIDO BLANDO BUCAL"
  },
  {
    "codigo":41321000119101,
    "descripcion":"SÍNDROME DE DOLOR MIOFASCIAL DE LA COLUMNA DORSAL"
  },
  {
    "codigo":13082000,
    "descripcion":"PLEURITIS DIAFRAGMÁTICA"
  },
  {
    "codigo":733978001,
    "descripcion":"CARIES DENTAL PRIMARIA INACTIVA QUE SE EXTIENDE HASTA LA PULPA"
  },
  {
    "codigo":111386004,
    "descripcion":"PORFIRIA CUTÁNEA TARDÍA HOMOCIGOTA"
  },
  {
    "codigo":209690004,
    "descripcion":"SECCIÓN EXPUESTA DE LIGAMENTO ILIOFEMORAL"
  },
  {
    "codigo":45850009,
    "descripcion":"CONTINENCIA DE LA VEJIGA"
  },
  {
    "codigo":109551007,
    "descripcion":"INSERCIÓN ECTÓPICA DEL FRENILLO LABIAL"
  },
  {
    "codigo":76783007,
    "descripcion":"HEPATITIS CRÓNICA"
  },
  {
    "codigo":402628002,
    "descripcion":"DISTROFIA UNGUEAL ASOCIADA CON ENFERMEDAD DERMATOLÓGICA"
  },
  {
    "codigo":238788004,
    "descripcion":"SÍNDROME DE ESTASIS VENOSA"
  },
  {
    "codigo":11837801000119106,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO INTRÍNSECO DE DEDO MEÑIQUE IZQUIERDO"
  },
  {
    "codigo":9412006,
    "descripcion":"TRASTORNO DE LA FUNCIÓN DE DESVIACIÓN DE LA LENGUA DEL DUODÉCIMO PAR CRANEAL"
  },
  {
    "codigo":1156292004,
    "descripcion":"RECUENTO DE BASÓFILOS POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":304324008,
    "descripcion":"AMPLITUD DE MOVIMIENTO DE TOBILLO AUMENTADA"
  },
  {
    "codigo":398958000,
    "descripcion":"CONDRODISPLASIA PUNCTATA, TIPO DOMINANTE LIGADA AL CROMOSOMA X"
  },
  {
    "codigo":235118001,
    "descripcion":"CAVIDAD ÓSEA IDIOPÁTICA DE MANDÍBULA DE STAFNE"
  },
  {
    "codigo":71278001,
    "descripcion":"INFESTACIÓN CAUSADA POR ORNITHONYSSUS"
  },
  {
    "codigo":300654000,
    "descripcion":"ORGANIZA UN VIAJE"
  },
  {
    "codigo":366190005,
    "descripcion":"FLUJO SANGUÍNEO DEL VENTRÍCULO IZQUIERDO - HALLAZGO"
  },
  {
    "codigo":342531000119103,
    "descripcion":"DERMATITIS ECCEMATOSA DE PÁRPADO INFERIOR DERECHO"
  },
  {
    "codigo":36675003,
    "descripcion":"PERIFLEBITIS"
  },
  {
    "codigo":1079811000119104,
    "descripcion":"CARCINOMA DUCTAL IN SITU DE MAMA IZQUIERDA"
  },
  {
    "codigo":724803007,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO TIBIAL A LA ALTURA DE LA PIERNA"
  },
  {
    "codigo":296984000,
    "descripcion":"SOBREDOSIS INTENCIONAL DE DISOPIRAMIDA"
  },
  {
    "codigo":722968003,
    "descripcion":"ATAXIA ADQUIRIDA"
  },
  {
    "codigo":34840004,
    "descripcion":"TENDINITIS"
  },
  {
    "codigo":231448004,
    "descripcion":"DISFUNCIÓN DE LA MEMORIA ASOCIADA A LA EDAD"
  },
  {
    "codigo":33005006,
    "descripcion":"FLUJO RETRÓGRADO"
  },
  {
    "codigo":295149008,
    "descripcion":"SOBREDOSIS DE DEXTROMORAMIDA"
  },
  {
    "codigo":719298001,
    "descripcion":"DISPLASIA DE PELVIS Y HOMBRO"
  },
  {
    "codigo":293314005,
    "descripcion":"REACCIÓN ADVERSA A SOLUCIÓN DE PROTEÍNAS PLASMÁTICAS"
  },
  {
    "codigo":1145282008,
    "descripcion":"VELOCIDAD LENTA DE CRECIMIENTO DE PELO DE CUERO CABELLUDO"
  },
  {
    "codigo":422551000,
    "descripcion":"NO BUSCA ATENCIÓN HABITUAL DE LA SALUD"
  },
  {
    "codigo":225943002,
    "descripcion":"CON MAYOR RIESGO DE INFECCIÓN CRUZADA"
  },
  {
    "codigo":94871005,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA HIPOFARINGE"
  },
  {
    "codigo":93036000,
    "descripcion":"FENESTRACIÓN CONGÉNITA DE HUESO BASIESFENOIDAL"
  },
  {
    "codigo":289644005,
    "descripcion":"HALLAZGO RELACIONADO CON LA DISPOSICIÓN DEL ÚTERO"
  },
  {
    "codigo":60268006,
    "descripcion":"ENFERMEDAD DE GRAVES CON MIXEDEMA PRETIBIAL"
  },
  {
    "codigo":715628009,
    "descripcion":"SÍNDROME DE DISCAPACIDAD INTELECTUAL, OBESIDAD DE TRONCO, DISTROFIA DE LA RETINA Y MICROPENE"
  },
  {
    "codigo":224108009,
    "descripcion":"MIEMBRO DE FAMILIA RECONSTITUIDA"
  },
  {
    "codigo":598241000005101,
    "descripcion":"DEJÓ DE CONSUMIR NICOTINA EN EL PRIMER TRIMESTRE"
  },
  {
    "codigo":253206006,
    "descripcion":"MALFORMACIÓN CONGÉNITA DE LA CEJA"
  },
  {
    "codigo":449814007,
    "descripcion":"CEFALALGIA AUTONÓMICA DEL TRIGÉMINO"
  },
  {
    "codigo":185835000,
    "descripcion":"CONTROL DE SALUD DEL ADULTO ANULADO"
  },
  {
    "codigo":285974007,
    "descripcion":"CONTROLA LA TEMPERATURA DEL AGUA QUE SE UTILIZA EN EL HOGAR"
  },
  {
    "codigo":21995002,
    "descripcion":"DIENTE NATAL"
  },
  {
    "codigo":284139001,
    "descripcion":"CAPAZ DE MOVER EL BRAZO"
  },
  {
    "codigo":16018231000119105,
    "descripcion":"OSTEOPATÍA DE PERONÉ DERECHO POSTERIOR A POLIOMIELITIS"
  },
  {
    "codigo":204552001,
    "descripcion":"ESTENOSIS SUBGLÓTICA CONGÉNITA"
  },
  {
    "codigo":1082321000119100,
    "descripcion":"NEFROBLASTOMA DE RIÑÓN IZQUIERDO"
  },
  {
    "codigo":282304007,
    "descripcion":"CAPAZ DE MANTENERSE EN EQUILIBRIO CUANDO ESTÁ SENTADO"
  },
  {
    "codigo":870293004,
    "descripcion":"MIELITIS CAUSADA POR TREPONEMA PALLIDUM"
  },
  {
    "codigo":51093005,
    "descripcion":"POSTURA NORMAL"
  },
  {
    "codigo":247701008,
    "descripcion":"PERCEPCIÓN ANORMAL"
  },
  {
    "codigo":49258000,
    "descripcion":"ENDOCERVICITIS CRÓNICA"
  },
  {
    "codigo":213098005,
    "descripcion":"PROMINENCIA DE CLAVO INTRAMEDULAR"
  },
  {
    "codigo":409706006,
    "descripcion":"PÓLIPO DEL SITIO DE COLOSTOMÍA"
  },
  {
    "codigo":278634005,
    "descripcion":"PRÓTESIS DENTAL ESCASAMENTE VISIBLE"
  },
  {
    "codigo":15664081000119104,
    "descripcion":"TUMOR TENOSINOVIAL DE CÉLULAS GIGANTES DIFUSO DE AMBAS ARTICULACIONES DE TOBILLO"
  },
  {
    "codigo":276799004,
    "descripcion":"DERMATOFIBROSARCOMA PROTUBERANTE"
  },
  {
    "codigo":309567004,
    "descripcion":"PROBLEMA DE DEDO DEL PIE"
  },
  {
    "codigo":735551007,
    "descripcion":"TRASTORNO RELACIONADO CON EL JUEGO"
  },
  {
    "codigo":702783007,
    "descripcion":"HETEROCIGOSIDAD PARA MUTACIÓN DE GEN PROTOCADHERINA 19 DETECTADA"
  },
  {
    "codigo":12820001,
    "descripcion":"TRASTORNO DEL SACRO"
  },
  {
    "codigo":209428009,
    "descripcion":"ESGUINCE DE LIGAMENTO LATERAL EXTERNO DE ARTICULACIÓN DE CODO"
  },
  {
    "codigo":1354473003,
    "descripcion":"SEGUIMIENTO REALIZADO POR OBSTÉTRICA"
  },
  {
    "codigo":109289003,
    "descripcion":"NEVO MELANOCÍTICO DEL MIEMBRO SUPERIOR"
  },
  {
    "codigo":305897005,
    "descripcion":"VISTO POR EL SERVICIO DE ORTOPEDIA"
  },
  {
    "codigo":240361006,
    "descripcion":"INFECCIÓN AMEBIANA ASINTOMÁTICA"
  },
  {
    "codigo":238526000,
    "descripcion":"ERUPCIÓN JUVENIL DE PRIMAVERA"
  },
  {
    "codigo":76521009,
    "descripcion":"GLOMERULONEFRITIS ASOCIADA CON LUPUS ERITEMATOSO SISTÉMICO, CLASE III DE LA OMS"
  },
  {
    "codigo":74686005,
    "descripcion":"TRASTORNO BIPOLAR I DEPRESIVO LEVE"
  },
  {
    "codigo":41918006,
    "descripcion":"RESORCIÓN EXTERNA DE DIENTE"
  },
  {
    "codigo":402366007,
    "descripcion":"GRANULOMA ANULAR SUBCUTÁNEO"
  },
  {
    "codigo":369598006,
    "descripcion":"TUMOR MALIGNO CON COMPROMISO DE ÓRGANO POR PROPAGACIÓN DIRECTA DESDE PRÓSTATA"
  },
  {
    "codigo":171155001,
    "descripcion":"CRIBADO PARA CÁNCER DE CUELLO UTERINO - ACTUALIZADO"
  },
  {
    "codigo":302227002,
    "descripcion":"EQUIMOSIS"
  },
  {
    "codigo":40083003,
    "descripcion":"TRASTORNO DE MOVIMIENTOS ESTEREOTIPADOS, CON COMPORTAMIENTO AUTOLESIVO"
  },
  {
    "codigo":203923004,
    "descripcion":"ACRANIA"
  },
  {
    "codigo":1285267003,
    "descripcion":"RANGO PASIVO DE FLEXIÓN PLANTAR DE TOBILLO DISMINUIDO"
  },
  {
    "codigo":236691003,
    "descripcion":"INFECCIÓN DE GLÁNDULA ACCESORIA MASCULINA"
  },
  {
    "codigo":38081000087103,
    "descripcion":"ACINESIA DE MIOCARDIO DE REGIÓN INFEROLATERAL DE VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":71016000,
    "descripcion":"DIQUEIRIA"
  },
  {
    "codigo":398696001,
    "descripcion":"NEVO CONGÉNITO MELANOCÍTICO PIGMENTADO"
  },
  {
    "codigo":890216002,
    "descripcion":"LARINGOMALACIA ADQUIRIDA"
  },
  {
    "codigo":43201000087107,
    "descripcion":"HERIDA PUNZANTE DE MUÑECA IZQUIERDA CON CUERPO EXTRAÑO"
  },
  {
    "codigo":35521000087104,
    "descripcion":"ISQUEMIA DE MIOCARDIO DE ÁPEX CARDÍACO"
  },
  {
    "codigo":300392005,
    "descripcion":"MATERIA FECAL CON TRAZAS DE SANGRE"
  },
  {
    "codigo":40641000087102,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE TERCER DEDO DE PIE IZQUIERDO"
  },
  {
    "codigo":726376006,
    "descripcion":"DELECIÓN DE PARTE DEL BRAZO CORTO DEL CROMOSOMA 6"
  },
  {
    "codigo":429629001,
    "descripcion":"ALIVIO DEL DOLOR CON ANTIÁCIDO"
  },
  {
    "codigo":724541008,
    "descripcion":"TUBERCULOSIS MILIAR AGUDA DE LOCALIZACIÓN ÚNICA"
  },
  {
    "codigo":427794001,
    "descripcion":"HIPERHIDROSIS FOCAL PRIMARIA"
  },
  {
    "codigo":292101000119102,
    "descripcion":"TRASTORNO DE NERVIO PERONEO PROFUNDO DERECHO"
  },
  {
    "codigo":165650003,
    "descripcion":"NIVEL SÉRICO DE FOLATO POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":34578006,
    "descripcion":"FRACTURA EXPUESTA DE MONTEGGIA"
  },
  {
    "codigo":425959000,
    "descripcion":"DISPOSICIÓN PARA MEJORAR LA CAPACIDAD FAMILIAR PARA AFRONTAR UNA SITUACIÓN"
  },
  {
    "codigo":296722009,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE CEFIXIMA"
  },
  {
    "codigo":294887006,
    "descripcion":"ALERGIA A ÁCIDO TRANEXÁMICO"
  },
  {
    "codigo":293052000,
    "descripcion":"REACCIÓN ADVERSA A LA OXITETRACICLINA"
  },
  {
    "codigo":260284005,
    "descripcion":"VISIÓN A DISTANCIA 3\/18"
  },
  {
    "codigo":30908009,
    "descripcion":"TRASTORNO DE CONDUCTO DEFERENTE"
  },
  {
    "codigo":782737003,
    "descripcion":"SÍNDROME DE ATROFIA CEREBRAL Y CEREBELOSA DIFUSA, CONVULSIONES INTRATABLES Y MICROCEFALIA PROGRESIVA"
  },
  {
    "codigo":94609005,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LOS GANGLIOS LINFÁTICOS SUBMANDIBULARES"
  },
  {
    "codigo":15938821000119108,
    "descripcion":"NEVO MELANOCÍTICO PIGMENTADO CONGÉNITO DE PIEL DE AMBOS MIEMBROS SUPERIORES"
  },
  {
    "codigo":291217007,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR DECANOATO DE ZUCLOPENTIXOL"
  },
  {
    "codigo":717201009,
    "descripcion":"COMAMONAS ACIDOVORANS O COMAMONAS TESTOSTERONI"
  },
  {
    "codigo":715366004,
    "descripcion":"ATAXIA CEREBELOSA AUTOSÓMICA RECESIVA CON APRAXIA OCULOMOTRIZ TIPO 1"
  },
  {
    "codigo":92774006,
    "descripcion":"CARCINOMA IN SITU DEL TRÍGONO VESICAL"
  },
  {
    "codigo":289382007,
    "descripcion":"NIVEL 0 DE LA PRESENTACIÓN EN RELACIÓN CON LAS ESPINAS ISQUIÁTICAS"
  },
  {
    "codigo":1336123000,
    "descripcion":"INSERCIÓN PEQUEÑA"
  },
  {
    "codigo":123707001,
    "descripcion":"DISTROFIA PRIMARIA DEL PELO"
  },
  {
    "codigo":713531003,
    "descripcion":"ALTERACIÓN VISUAL CONCOMITANTE CON INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":1303355004,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE DEDO ÍNDICE CON INFECCIÓN"
  },
  {
    "codigo":189243008,
    "descripcion":"CARCINOMA IN SITU DE CONDUCTO HEPÁTICO"
  },
  {
    "codigo":285712005,
    "descripcion":"LESIÓN ARTERIAL EN EXTREMIDADES INFERIORES"
  },
  {
    "codigo":321081000119100,
    "descripcion":"INESTABILIDAD DE COLUMNA VERTEBRAL DORSOLUMBAR"
  },
  {
    "codigo":1137680008,
    "descripcion":"PERCEPCIÓN SENSITIVA NORMAL"
  },
  {
    "codigo":23568008,
    "descripcion":"METATARSO ADUCTO"
  },
  {
    "codigo":283877002,
    "descripcion":"GASTROENTERITIS POR CALICIVIRUS"
  },
  {
    "codigo":15722041000119101,
    "descripcion":"INFECCIÓN DE BOLSAS SEROSAS PRERROTULIANAS BILATERALES DE RODILLAS"
  },
  {
    "codigo":414949005,
    "descripcion":"REFLEJO DE OPPENHEIM"
  },
  {
    "codigo":54501006,
    "descripcion":"NEOLOGISMO"
  },
  {
    "codigo":87269006,
    "descripcion":"FORÚNCULO DE RODILLA"
  },
  {
    "codigo":11789881000119102,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE DEDO MEDIO DE MANO IZQUIERDA"
  },
  {
    "codigo":708026002,
    "descripcion":"NEUMONITIS CRÓNICA DE LA LACTANCIA"
  },
  {
    "codigo":216506003,
    "descripcion":"INTOXICACIÓN ACCIDENTAL CAUSADA POR HIDRATO DE CORAL"
  },
  {
    "codigo":1363386002,
    "descripcion":"SINEQUIAS ANTERIORES PERIFÉRICAS EN CUADRANTE NASAL DE ÁNGULO IRIDOCORNEAL DE OJO IZQUIERDO"
  },
  {
    "codigo":118202007,
    "descripcion":"HALLAZGO RELACIONADO CON LA FUNCIÓN SEXUAL"
  },
  {
    "codigo":249274008,
    "descripcion":"SÍNTOMAS URINARIOS"
  },
  {
    "codigo":183738009,
    "descripcion":"CONSULTA DOMICILIARIA DE MEDICINA GENERAL, REALIZADA"
  },
  {
    "codigo":282042009,
    "descripcion":"ANOMALÍA CONGÉNITA DE CONDUCTO SALIVAL"
  },
  {
    "codigo":247439004,
    "descripcion":"MANCHAS DE NICOTINA EN LOS DEDOS DE LA MANO"
  },
  {
    "codigo":116367006,
    "descripcion":"HALLAZGO PSICOLÓGICO"
  },
  {
    "codigo":312975006,
    "descripcion":"MICROALBUMINURIA"
  },
  {
    "codigo":1197711009,
    "descripcion":"PANCREATITIS ISQUÉMICA AGUDA"
  },
  {
    "codigo":212836002,
    "descripcion":"EFECTO TÓXICO CAUSADO POR LAVANDINA"
  },
  {
    "codigo":442212003,
    "descripcion":"DÉFICIT COGNITIVO RESIDUAL COMO EFECTO TARDÍO DE ACCIDENTE CEREBROVASCULAR"
  },
  {
    "codigo":1359716004,
    "descripcion":"COMPLICACIÓN POSTERIOR A CIRUGÍA BARIÁTICA"
  },
  {
    "codigo":704356008,
    "descripcion":"CON MAYOR RIESGO DE COMPLICACIÓN ASOCIADA CON ATENCIÓN SANITARIA"
  },
  {
    "codigo":276537001,
    "descripcion":"INSUFICIENCIA PULMONAR CRÓNICA DEL PREMATURO"
  },
  {
    "codigo":47161002,
    "descripcion":"INTENTO FALLIDO DE ABORTO CON PERFORACIÓN DEL CUELLO DEL ÚTERO"
  },
  {
    "codigo":1163108009,
    "descripcion":"COLITIS POR PSEUDOMONAS AERUGINOSA"
  },
  {
    "codigo":1259577001,
    "descripcion":"CARCINOMA PRIMARIO ANEXIAL DE PIEL MIXTO ECRINO\/PILAR"
  },
  {
    "codigo":45326000,
    "descripcion":"DOLOR EN REGIÓN DE HOMBRO"
  },
  {
    "codigo":405774001,
    "descripcion":"ATENCIÓN DE LA SALUD MENTAL, FRECUENTE"
  },
  {
    "codigo":209166001,
    "descripcion":"SUBLUXACIÓN EXPUESTA DE MÚLTIPLES VÉRTEBRAS CERVICALES"
  },
  {
    "codigo":733454004,
    "descripcion":"SÍNDROME DE BRAQUIDACTILIA CON PULGAR LARGO"
  },
  {
    "codigo":373006004,
    "descripcion":"INFECCIÓN CAUSADA POR ASPERGILLUS USTUS"
  },
  {
    "codigo":241934007,
    "descripcion":"ANAFILAXIA PRODUCIDA POR MARISCOS"
  },
  {
    "codigo":43491000,
    "descripcion":"EPIDIDIMITIS AGUDA"
  },
  {
    "codigo":698851003,
    "descripcion":"SÍNDROME DE ANOFTALMÍA RELACIONADA CON SOX2"
  },
  {
    "codigo":1255907004,
    "descripcion":"LINFOMA MALIGNO DE GANGLIOS LINFÁTICOS DE MIEMBRO INFERIOR"
  },
  {
    "codigo":305635003,
    "descripcion":"ATENDIDO POR UN ONCÓLOGO CLÍNICO"
  },
  {
    "codigo":240099007,
    "descripcion":"MIOPATÍA POR DEPLECIÓN DE POTASIO"
  },
  {
    "codigo":74424000,
    "descripcion":"DIETA PARA LACTANTES A LOS 6 MESES: ARROZ, CEBADA, HIERRO, SIN MIEL"
  },
  {
    "codigo":762552000,
    "descripcion":"DERMATITIS ALÉRGICA POR CONTACTO OCUPACIONAL CAUSADA POR MATERIAL ODONTOLÓGICO"
  },
  {
    "codigo":860856002,
    "descripcion":"ESQUISTOSOMIASIS HEPATOESPLÉNICA CAUSADA POR SCHISTOSOMA HAEMATOBIUM"
  },
  {
    "codigo":403939009,
    "descripcion":"CARCINOMA DUCTAL ECRINO DE PIEL"
  },
  {
    "codigo":41656005,
    "descripcion":"SÍNDROME DE PLEONOSTOSIS DE LERI"
  },
  {
    "codigo":205496008,
    "descripcion":"OSTEOGÉNESIS IMPERFECTA TIPO II"
  },
  {
    "codigo":301965000,
    "descripcion":"ORIFICIO LAGRIMAL INFERIOR AUSENTE"
  },
  {
    "codigo":203661003,
    "descripcion":"ESCOLIOSIS EN LA DISPLASIA ESQUELÉTICA"
  },
  {
    "codigo":201826000,
    "descripcion":"OSTEOARTROSIS EROSIVA"
  },
  {
    "codigo":269197008,
    "descripcion":"PICADURA DE INSECTO, NO VENENOSO, EN ESCROTO Y\/O TESTÍCULO, INFECTADA"
  },
  {
    "codigo":234594002,
    "descripcion":"DEFICIENCIA DEL COMPLEMENTO 1Q"
  },
  {
    "codigo":1217634001,
    "descripcion":"EDEMA MACULAR CISTOIDE POSTERIOR A CIRUGÍA DE CATARATAS"
  },
  {
    "codigo":365666004,
    "descripcion":"HALLAZGO RELACIONADO CON EL COLOR DEL ESPÉCIMEN"
  },
  {
    "codigo":5218003,
    "descripcion":"INTOXICACIÓN POR EUPATORIUM RUGOSUM"
  },
  {
    "codigo":1186701009,
    "descripcion":"AMBIENTE ESTIMULANTE"
  },
  {
    "codigo":300130009,
    "descripcion":"LESIÓN DE CONDUCTO AUDITIVO"
  },
  {
    "codigo":724279004,
    "descripcion":"DEFECTO COMBINADO DE LA FOSFORILACIÓN OXIDATIVA TIPO 5"
  },
  {
    "codigo":36151004,
    "descripcion":"ESOFAGITIS QUÍMICA"
  },
  {
    "codigo":722444002,
    "descripcion":"SARCOMA PRIMARIO DE CÉLULAS GIGANTES DE RETROPERITONEO"
  },
  {
    "codigo":198156004,
    "descripcion":"PARAMETRITIS AGUDA"
  },
  {
    "codigo":16052231000119100,
    "descripcion":"TENDINITIS DE TENDÓN DE CUÁDRICEPS IZQUIERDO"
  },
  {
    "codigo":1179361001,
    "descripcion":"PÉRDIDA DE AUDICIÓN NEUROSENSORIAL PERINATAL MATERNA"
  },
  {
    "codigo":294625003,
    "descripcion":"ALERGIA A LINDANO"
  },
  {
    "codigo":720609003,
    "descripcion":"SÍNDROME DE MIOCARDIOPATÍA CON CATARATA Y ENFERMEDAD DE LA CADERA Y VERTEBRAL"
  },
  {
    "codigo":423862000,
    "descripcion":"VISIÓN A DISTANCIA 20\/15"
  },
  {
    "codigo":718774001,
    "descripcion":"ATAXIA ESPINOCEREBELOSA TIPO 21"
  },
  {
    "codigo":677741000119109,
    "descripcion":"RETINOPATÍA PROLIFERATIVA NO DIABÉTICA DE AMBOS OJOS"
  },
  {
    "codigo":292790009,
    "descripcion":"REACCIÓN ADVERSA A AGENTE MODIFICADOR DE LA VISCOSIDAD"
  },
  {
    "codigo":161718009,
    "descripcion":"RETRASO MENSTRUAL"
  },
  {
    "codigo":11792391000119104,
    "descripcion":"LUXACIÓN TRAUMÁTICA ABIERTA DE ARTICULACIÓN DE DEDO MEDIO DE MANO IZQUIERDA"
  },
  {
    "codigo":1208459005,
    "descripcion":"CARCINOMA MICROPAPILAR DE UROTELIO"
  },
  {
    "codigo":94347008,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LOS GANGLIOS LINFÁTICOS INTRABDOMINALES"
  },
  {
    "codigo":323591000119106,
    "descripcion":"TUMOR TENOSINOVIAL DIFUSO DE CÉLULAS GIGANTES DE CODO IZQUIERDO"
  },
  {
    "codigo":715104006,
    "descripcion":"NO PASA DE LA SILLA A LA CAMA"
  },
  {
    "codigo":26976008,
    "descripcion":"RELACIÓN VENTILACIÓN - PERFUSIÓN DISMINUIDA"
  },
  {
    "codigo":289120009,
    "descripcion":"NO EXPECTORA"
  },
  {
    "codigo":188981002,
    "descripcion":"LIPOMA DE LA FRENTE"
  },
  {
    "codigo":254517003,
    "descripcion":"NEOPLASIA MALIGNA DE EPIGLOTIS SUPRAHIOIDEA"
  },
  {
    "codigo":1335861005,
    "descripcion":"ENCEFALITIS CAUSADA POR VIRUS BORNA"
  },
  {
    "codigo":285450003,
    "descripcion":"MUEVE LA MANDÍBULA REPETIDAMENTE"
  },
  {
    "codigo":283615001,
    "descripcion":"HERIDA POR PINCHAZO DE AGUJA EN LA MUÑECA"
  },
  {
    "codigo":52404001,
    "descripcion":"MASTOIDITIS"
  },
  {
    "codigo":840671009,
    "descripcion":"CRISTALINO OCULAR NORMAL"
  },
  {
    "codigo":19636003,
    "descripcion":"MONOCITOSIS"
  },
  {
    "codigo":871604003,
    "descripcion":"DEFECTO DE TABIQUE VENTRICULAR CON COMPROMISO DOBLE DE SALIDA YUXTAARTERIAL CON EXTENSIÓN PERIMEMBRANOSA Y TABIQUE DE SALIDA MAL ALINEADO EN LA PARTE POSTERIOR"
  },
  {
    "codigo":314548006,
    "descripcion":"ENDOFTALMITIS ENDÓGENA"
  },
  {
    "codigo":773300008,
    "descripcion":"SÍNDROME DE DISPLASIA ESPONDILOEPIMETAFISARIA E HIPOTRICOSIS"
  },
  {
    "codigo":11821371000119101,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN CARPOMETACARPIANA DE MUÑECA DERECHA"
  },
  {
    "codigo":247177004,
    "descripcion":"DEGENERACIÓN CORIORRETINIANA"
  },
  {
    "codigo":352571000119102,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE TESTÍCULO NO DESCENDIDO IZQUIERDO"
  },
  {
    "codigo":704094001,
    "descripcion":"FRACTURA NO EXPUESTA DE FALANGE PROXIMAL DE DEDO ANULAR"
  },
  {
    "codigo":310878004,
    "descripcion":"ESTADO DE PROGRAMA DE REDUCCIÓN DE COLESTEROL"
  },
  {
    "codigo":1259315001,
    "descripcion":"CARCINOMA PRIMARIO DE SUPERFICIE VENTRAL DE DOS TERCIOS ANTERIORES DE LENGUA"
  },
  {
    "codigo":866099002,
    "descripcion":"NEURORRETINITIS ESTRELLADA IDIOPÁTICA DE LEBER"
  },
  {
    "codigo":79667004,
    "descripcion":"SECUENCIA MACROMOLECULAR ANORMAL"
  },
  {
    "codigo":302171000119101,
    "descripcion":"QUISTE ÓSEO ANEURISMÁTICO DE RADIO IZQUIERDO"
  },
  {
    "codigo":1085531000119102,
    "descripcion":"EDENTULISMO COMPLETO DEBIDO A ENFERMEDAD PERIODONTAL"
  },
  {
    "codigo":289371000119100,
    "descripcion":"RUPTURA FAMILIAR DEBIDA A NIÑO BAJO CUIDADO DE FAMILIAR DIFERENTE A LOS PADRES"
  },
  {
    "codigo":166491000119100,
    "descripcion":"ESTRÉS DEBIDO A TENSIÓN FAMILIAR"
  },
  {
    "codigo":10688091000119100,
    "descripcion":"PÉRDIDA DE AIRE PULMONAR POSTERIOR A PROCEDIMIENTO"
  },
  {
    "codigo":186971000119106,
    "descripcion":"ANEURISMA DE FÍSTULA ARTERIOVENOSA ADQUIRIDA"
  },
  {
    "codigo":105051000119106,
    "descripcion":"CARCINOMA INDIFERENCIADO DE CÉLULAS GRANDES METASTÁSICO DE PULMÓN"
  },
  {
    "codigo":5211000119107,
    "descripcion":"ABSCESO DE INTESTINO CONCOMITANTE CON ENFERMEDAD DIVERTICULAR Y DEBIDO A ELLA"
  },
  {
    "codigo":15639131000119107,
    "descripcion":"EDEMA DE LA MÁCULA RETINIANA DE OJO DERECHO"
  },
  {
    "codigo":335451000119104,
    "descripcion":"DERMATOCALASIA DE PÁRPADO DERECHO"
  },
  {
    "codigo":961190491000119107,
    "descripcion":"DERIVACIÓN VENTRICULOPLEURAL CON VÁLVULA PROGRAMABLE IN SITU"
  },
  {
    "codigo":133211000119107,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE LÓBULO DE LA OREJA PERFORADO"
  },
  {
    "codigo":110171000119107,
    "descripcion":"ÚLCERA DE EXTREMIDAD INFERIOR DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":239837000,
    "descripcion":"TOFO POR PIROFOSFATO"
  },
  {
    "codigo":10859611000119107,
    "descripcion":"ASPIRACIÓN DE CONTENIDO GÁSTRICO HACIA BRONQUIOS"
  },
  {
    "codigo":1075291000119109,
    "descripcion":"DEFORMIDAD EN VALGO ADQUIRIDA DE ARTICULACIÓN DE REGIÓN DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":322651000119108,
    "descripcion":"SINOVITIS TRANSITORIA DE MUÑECA DERECHA"
  },
  {
    "codigo":10461000,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO CON INFECCIÓN"
  },
  {
    "codigo":1255645000,
    "descripcion":"CARCINOMA DE CÉLULAS ACINARES DE OROFARINGE"
  },
  {
    "codigo":208904009,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA NO EXPUESTA DE CADERA"
  },
  {
    "codigo":41394002,
    "descripcion":"ÁNTRAX DEL CUERPO CAVERNOSO"
  },
  {
    "codigo":238002005,
    "descripcion":"DEFICIENCIA DE LA CARNITINA PALMITOILTRANSFERASA II"
  },
  {
    "codigo":303538006,
    "descripcion":"AMPLITUD DE RETRACCIÓN ACTIVA DE COLUMNA CERVICAL DISMINUIDA"
  },
  {
    "codigo":762290007,
    "descripcion":"HEMORRAGIA UTERINA NEONATAL"
  },
  {
    "codigo":74162007,
    "descripcion":"COLESTASIS INTRAHEPÁTICA PROGRESIVA"
  },
  {
    "codigo":170631002,
    "descripcion":"ALTERACIÓN DEL SUEÑO POR ASMA"
  },
  {
    "codigo":301703002,
    "descripcion":"SIBILANCIA POLIFÓNICA ESPIRATORIA"
  },
  {
    "codigo":168796001,
    "descripcion":"MIELOGRAFÍA NORMAL"
  },
  {
    "codigo":1217372003,
    "descripcion":"SÍNDROME DE MIOPÍA, LAXITUD ARTICULAR GENERALIZADA Y BAJA ESTATURA"
  },
  {
    "codigo":299868003,
    "descripcion":"REFLEJO ANAL RETARDADO"
  },
  {
    "codigo":398172005,
    "descripcion":"CONSENTIMIENTO PARA ANESTESIA, OTORGADO"
  },
  {
    "codigo":365404006,
    "descripcion":"ESTADIO DE TANNER PARA EL VELLO AXILAR - HALLAZGO"
  },
  {
    "codigo":201564005,
    "descripcion":"ARTRITIS REACTIVA DE ARTICULACIÓN METACARPOFALÁNGICA"
  },
  {
    "codigo":134193000,
    "descripcion":"SEUDOCICATRIZ ESTRELLADA"
  },
  {
    "codigo":430940009,
    "descripcion":"TRASTORNO DE ARTICULACIÓN GLENOHUMERAL"
  },
  {
    "codigo":166961000,
    "descripcion":"NIVEL DE DIGOXINA POR DEBAJO DEL RANGO TERAPÉUTICO"
  },
  {
    "codigo":16028271000119101,
    "descripcion":"EXOSTOSIS BILATERAL DE CINTURAS ESCAPULARES"
  },
  {
    "codigo":103260005,
    "descripcion":"MIRADA CONJUGADA DESCENDENTE"
  },
  {
    "codigo":1344774000,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE TENDÓN DE CABEZA LARGA DE BÍCEPS BRAQUIAL"
  },
  {
    "codigo":396337009,
    "descripcion":"GASTRITIS AGUDA Y CRÓNICA"
  },
  {
    "codigo":1286003,
    "descripcion":"TRASTORNO DE LA COAGULACIÓN POR DEFICIENCIA DE VITAMINA K"
  },
  {
    "codigo":296198007,
    "descripcion":"SOBREDOSIS INTENCIONAL DE PIMOZIDA"
  },
  {
    "codigo":66822008,
    "descripcion":"ARTROPATÍA SUBAGUDA"
  },
  {
    "codigo":230662008,
    "descripcion":"SÍNDROME DE ROSS"
  },
  {
    "codigo":294363003,
    "descripcion":"ALERGIA A MICONAZOL"
  },
  {
    "codigo":32219008,
    "descripcion":"CRANEORRAQUISQUISIS"
  },
  {
    "codigo":718512007,
    "descripcion":"IDIOMA PRINCIPAL HABLADO: ROMANÍ"
  },
  {
    "codigo":292528008,
    "descripcion":"REACCIÓN ADVERSA AL BROMURO DE EMEPRONIO"
  },
  {
    "codigo":94085001,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE HUESO TEMPORAL"
  },
  {
    "codigo":423600008,
    "descripcion":"CARCINOMA PULMONAR MACROCÍTICO, TNM ESTADIO 4"
  },
  {
    "codigo":61317003,
    "descripcion":"QUEMADURA PROFUNDA DE TERCER GRADO DE TOBILLO"
  },
  {
    "codigo":1306501006,
    "descripcion":"CARCINOMA DUCTAL INFILTRANTE PRIMARIO DE PORCIÓN CENTRAL DE MAMA"
  },
  {
    "codigo":290693006,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR PENTOSTATINA"
  },
  {
    "codigo":126853008,
    "descripcion":"NEOPLASIA DE LAS VÍAS BILIARES"
  },
  {
    "codigo":11768431000119109,
    "descripcion":"HEMATOMA SUBUNGUEAL DE PULGAR DERECHO"
  },
  {
    "codigo":682761000119103,
    "descripcion":"NEOPLASIA BENIGNA DE GLÁNDULA LAGRIMAL DERECHA"
  },
  {
    "codigo":26714005,
    "descripcion":"TRASTORNO PSICÓTICO CON ALUCINACIONES INDUCIDO POR CANNABIS"
  },
  {
    "codigo":92250007,
    "descripcion":"NEOPLASIA BENIGNA DE LA NARIZ"
  },
  {
    "codigo":419930008,
    "descripcion":"ALERGIA A DIURÉTICO TIPO SULFONAMIDA"
  },
  {
    "codigo":287023001,
    "descripcion":"BURSITIS DE MÚLTIPLES BOLSAS SEROSAS"
  },
  {
    "codigo":876847002,
    "descripcion":"AGENESIA DE HUESO CARPIANO Y METACARPIANO"
  },
  {
    "codigo":254255007,
    "descripcion":"MALFORMACIÓN CONGÉNITA DE LA HIPÓFISIS ANTERIOR"
  },
  {
    "codigo":90415008,
    "descripcion":"CONDUCTA INMADURA"
  },
  {
    "codigo":711172001,
    "descripcion":"APARIENCIA ATÍPICA DE CÓNDILO MANDIBULAR"
  },
  {
    "codigo":15674121000119105,
    "descripcion":"MIOSITIS INFECCIOSA DE AMBAS PIERNAS"
  },
  {
    "codigo":285188007,
    "descripcion":"INCAPAZ DE RECORDAR SU FECHA DE CUMPLEAÑOS"
  },
  {
    "codigo":88580009,
    "descripcion":"PÓLIPO ANAL"
  },
  {
    "codigo":283353003,
    "descripcion":"PICADURA DE INSECTO INFECTADA EN EL DORSO DEL PIE"
  },
  {
    "codigo":281518003,
    "descripcion":"FRACTURA-LUXACIÓN DEL PLANO PALMAR TRANSESCAFOIDEO-SEMILUNAR"
  },
  {
    "codigo":1092361000119109,
    "descripcion":"NEUMONÍA POR RUBÉOLA"
  },
  {
    "codigo":84910004,
    "descripcion":"INFECCIÓN CAUSADA POR STRONGYLOIDES SIMIAE"
  },
  {
    "codigo":183214006,
    "descripcion":"BOLSA DE ILEOSTOMÍA CAMBIADA"
  },
  {
    "codigo":50307003,
    "descripcion":"PELVIS EN FORMA DE EMBUDO"
  },
  {
    "codigo":246915008,
    "descripcion":"HALLAZGO RELACIONADO CON EL GLOBO OCULAR"
  },
  {
    "codigo":328611000119105,
    "descripcion":"HISTIOCITOSIS PULMONAR DE CÉLULAS DE LANGERHANS DEL ADULTO"
  },
  {
    "codigo":441688003,
    "descripcion":"CUADRIPLEJÍA INCOMPLETA DEBIDA A LESIÓN DE MÉDULA ESPINAL ENTRE PRIMERA Y CUARTA VÉRTEBRAS CERVICALES"
  },
  {
    "codigo":1162584006,
    "descripcion":"FIBROMATOSIS AGRESIVA DE PARED ABDOMINAL"
  },
  {
    "codigo":212312007,
    "descripcion":"LESIÓN ABIERTA DE NERVIO CIÁTICO"
  },
  {
    "codigo":439853000,
    "descripcion":"CONSENTIMIENTO PARA ASESORAMIENTO OTORGADO"
  },
  {
    "codigo":1259053002,
    "descripcion":"CATARATA POSTIRRADIACIÓN CRANEAL"
  },
  {
    "codigo":274178007,
    "descripcion":"CICATRIZACIÓN POSTERIOR A LESIÓN TRAUMÁTICA"
  },
  {
    "codigo":732930007,
    "descripcion":"ISTROFIA MUSCULAR DE LAS CINTURAS DE LAS EXTREMIDADES TIPO 2T AUTOSÓMICA RECESIVA"
  },
  {
    "codigo":306946009,
    "descripcion":"ARITENOIDES MÓVIL"
  },
  {
    "codigo":763863002,
    "descripcion":"SÍNDROME DE PECTUS EXCAVATUM, MACROCEFALIA Y UÑAS DISPLÁSICAS"
  },
  {
    "codigo":237740000,
    "descripcion":"SEUDOSÍNDROME DE CUSHING ARTIFICIAL"
  },
  {
    "codigo":403415009,
    "descripcion":"PANICULITIS POR DEFICIENCIA DE ALFA-1-ANTITRIPSINA"
  },
  {
    "codigo":235601000112100,
    "descripcion":"HEPATOPATÍA ALCOHÓLICA Y METABÓLICA"
  },
  {
    "codigo":16004311000119100,
    "descripcion":"TENOSINOVITIS DE APÓFISIS ESTILOIDES DE RADIO BILATERAL"
  },
  {
    "codigo":41132007,
    "descripcion":"DICÉFALO TRIPUS TRIBRAQUIO"
  },
  {
    "codigo":270508006,
    "descripcion":"FRACTURA PATOLÓGICA DE VÉRTEBRA LUMBAR"
  },
  {
    "codigo":399745003,
    "descripcion":"TUMOR QUE INVADE LA CÁMARA ANTERIOR DEL OJO"
  },
  {
    "codigo":256081000112109,
    "descripcion":"E. COLI O153:H19 O O178:H19"
  },
  {
    "codigo":1153409008,
    "descripcion":"ANEMIA POR DEFICIENCIA DE VITAMINA B12 DEBIDA A GASTRITIS ATRÓFICA CRÓNICA"
  },
  {
    "codigo":432513009,
    "descripcion":"DEFORMIDAD DEBIDA A QUEMADURA Y POSTERIOR A ELLA"
  },
  {
    "codigo":268673009,
    "descripcion":"AFASIA CONGÉNITA"
  },
  {
    "codigo":725590001,
    "descripcion":"DISTROFIA PIGMENTARIA MACULAR EN ALAS DE MARIPOSA"
  },
  {
    "codigo":235905008,
    "descripcion":"HIPERBILIRRUBINEMIA FISIOLÓGICA"
  },
  {
    "codigo":10679511000119103,
    "descripcion":"TUMORACIÓN DE LA PIEL DEL TÓRAX"
  },
  {
    "codigo":102998005,
    "descripcion":"CRIANESTESIA"
  },
  {
    "codigo":365142006,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA CONSTRUIR UNA TORRE"
  },
  {
    "codigo":234070008,
    "descripcion":"COMPRESIÓN DE LA VENA TRASPLANTADA"
  },
  {
    "codigo":1217110005,
    "descripcion":"BENDOPNEA"
  },
  {
    "codigo":789291002,
    "descripcion":"COAGULOPATÍA POR CONSUMO CAUSADA POR VENENO DE SERPIENTE"
  },
  {
    "codigo":232235004,
    "descripcion":"OTITIS EXTERNA AGUDA TRAUMÁTICA"
  },
  {
    "codigo":166699009,
    "descripcion":"NIVEL DE BICARBONATO SÉRICO FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":263168002,
    "descripcion":"FRACTURA DE PARED ORBITARIA INTERNA"
  },
  {
    "codigo":295936002,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE FLUOXETINA"
  },
  {
    "codigo":15758551000119106,
    "descripcion":"CONDUCTA SEXUAL DE ALTO RIESGO DE LA ADOLESCENCIA"
  },
  {
    "codigo":230400008,
    "descripcion":"EPILEPSIA OPERCULAR DE LÓBULO FRONTAL"
  },
  {
    "codigo":31957000,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE LA NARIZ, SIN INFECCIÓN"
  },
  {
    "codigo":195797002,
    "descripcion":"VEGETACIONES ADENOIDES"
  },
  {
    "codigo":331121000119101,
    "descripcion":"CATARATA TOTAL DE OJO DERECHO DEBIDA A TRAUMATISMO Y POSTERIOR A ÉL"
  },
  {
    "codigo":294101007,
    "descripcion":"ALERGIA A DOXAPRAM"
  },
  {
    "codigo":95658004,
    "descripcion":"SÍNDROME DE CEFALEA POR TOS"
  },
  {
    "codigo":292266007,
    "descripcion":"REACCIÓN ADVERSA A LA LEVODOPA"
  },
  {
    "codigo":1177002007,
    "descripcion":"TRASTORNO DE TICS DEBIDO A ENFERMEDAD PRIÓNICA"
  },
  {
    "codigo":1339007001,
    "descripcion":"TRASTORNO DE PREPUCIO DE PENE"
  },
  {
    "codigo":126591002,
    "descripcion":"NEOPLASIA DE HUESO CUBOIDES"
  },
  {
    "codigo":716415003,
    "descripcion":"CAPAZ DE ADOPTAR UNA DECISIÓN SOBRE INFORMACIÓN SEGURA A BRINDAR POR VÍA TELEFÓNICA"
  },
  {
    "codigo":192127007,
    "descripcion":"TRASTORNO POR DÉFICIT DE ATENCIÓN EN LA INFANCIA"
  },
  {
    "codigo":288596005,
    "descripcion":"NO USA UN SISTEMA DE COMUNICACIÓN NO VERBAL"
  },
  {
    "codigo":1237033000,
    "descripcion":"METÁSTASIS DE CARCINOMA DE GLÁNDULA SUBLINGUAL"
  },
  {
    "codigo":253993003,
    "descripcion":"FISURA CENTRAL DE PALADAR DURO"
  },
  {
    "codigo":286761003,
    "descripcion":"CARÁCTER ERRÁTICO"
  },
  {
    "codigo":11773451000119101,
    "descripcion":"ABRASIÓN DE PIEL DE PULGAR IZQUIERDO"
  },
  {
    "codigo":24617007,
    "descripcion":"MORDIDA ABIERTA POSTERIOR"
  },
  {
    "codigo":284926001,
    "descripcion":"CAPAZ DE UTILIZAR ORINAL DE CAMA"
  },
  {
    "codigo":219390004,
    "descripcion":"HERIDA DE GUERRA POR FRAGMENTOS DE CÁPSULA DE PROYECTIL"
  },
  {
    "codigo":15732081000119109,
    "descripcion":"QUISTE SEBÁCEO DE AMBOS PÁRPADOS"
  },
  {
    "codigo":303496005,
    "descripcion":"NO SE PONE DE COSTADO EN LA CAMA"
  },
  {
    "codigo":88318005,
    "descripcion":"ESTENOSIS TRICUSPÍDEA REUMÁTICA"
  },
  {
    "codigo":283091007,
    "descripcion":"ARAÑAZO DE PECHO"
  },
  {
    "codigo":709075008,
    "descripcion":"SÍNDROME DE EXCESO DE AROMATASA"
  },
  {
    "codigo":1297064001,
    "descripcion":"ARTRITIS ENTEROPÁTICA"
  },
  {
    "codigo":248488001,
    "descripcion":"ULCERACIÓN DEL GANGLIO LINFÁTICO"
  },
  {
    "codigo":838312001,
    "descripcion":"CALCINOSIS DEBIDA A DERMATOMIOSITIS DE TIPO INFANTIL"
  },
  {
    "codigo":445096001,
    "descripcion":"NEUMONÍA CAUSADA POR METAPNEUMOVIRUS HUMANO"
  },
  {
    "codigo":314024005,
    "descripcion":"QUERATITIS ANTIGUA"
  },
  {
    "codigo":16907941000119100,
    "descripcion":"NEVO EPIDÉRMICO PILOSO PIGMENTADO DE PÁRPADO INFERIOR DERECHO"
  },
  {
    "codigo":84648007,
    "descripcion":"FETO ACARDIO"
  },
  {
    "codigo":707240008,
    "descripcion":"QUEILITIS ANGULAR DEBIDA A INFECCIÓN BACTERIANA"
  },
  {
    "codigo":246653001,
    "descripcion":"LA IMAGEN VISUAL PERSISTE"
  },
  {
    "codigo":1295229003,
    "descripcion":"CORDOMA DESDIFERENCIADO"
  },
  {
    "codigo":770941005,
    "descripcion":"SÍNDROME DE ALOPECIA, DEFECTO NEUROLÓGICO PROGRESIVO Y ENDOCRINOPATÍA"
  },
  {
    "codigo":836477007,
    "descripcion":"ENFISEMA CRÓNICO CAUSADO POR VAPOR"
  },
  {
    "codigo":408658000,
    "descripcion":"ESPÉCIMEN MESORRECTAL CASI COMPLETAMENTE INTACTO"
  },
  {
    "codigo":48210000,
    "descripcion":"ESPONDILOSIS LUMBOSACRA SIN MIELOPATÍA"
  },
  {
    "codigo":443261008,
    "descripcion":"ADENOCARCINOMA OXIFÍLICO"
  },
  {
    "codigo":308519000,
    "descripcion":"SITUACIÓN DEL CONTROL DEL ADULTO SANO"
  },
  {
    "codigo":210215001,
    "descripcion":"LESIÓN TRAUMÁTICA DE VEJIGA URINARIA Y URETRA CON HERIDA ABIERTA HACIA CAVIDAD ABDOMINAL"
  },
  {
    "codigo":11828901000119104,
    "descripcion":"AMPOLLA DE RODILLA IZQUIERDA, CON INFECCIÓN"
  },
  {
    "codigo":439591006,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR AGENTE SALURÉTICO"
  },
  {
    "codigo":111911008,
    "descripcion":"AMEBIASIS INTESTINAL CRÓNICA SIN ABSCESOS"
  },
  {
    "codigo":242983009,
    "descripcion":"LESIÓN CON PROPÓSITO DESCONOCIDO ASOCIADO CON VEHÍCULOS EN MOVIMIENTO"
  },
  {
    "codigo":11772001,
    "descripcion":"ESTENOSIS DE SACO LAGRIMAL"
  },
  {
    "codigo":110076003,
    "descripcion":"AVULSIÓN DE LA NARIZ"
  },
  {
    "codigo":208380005,
    "descripcion":"FRACTURA EXPUESTA DEL ESCAFOIDES, POLO PROXIMAL"
  },
  {
    "codigo":75473000,
    "descripcion":"FÍSTULA ARTERIOVENOSA ADQUIRIDA DEL CORAZÓN"
  },
  {
    "codigo":1156817001,
    "descripcion":"ARTRITIS IDIOPÁTICA JUVENIL POSITIVA PARA ANTICUERPOS ANTINUCLEARES DE INICIO OLIGOARTICULAR EXTENDIDO"
  },
  {
    "codigo":698065002,
    "descripcion":"REFLUJO ÁCIDO"
  },
  {
    "codigo":1255121003,
    "descripcion":"SÍNDROME DE EHLERS-DANLOS SIMILAR AL TIPO CLÁSICO 2"
  },
  {
    "codigo":1251451005,
    "descripcion":"SÍNDROME DE ARTROGRIPOSIS MÚLTIPLE CONGÉNITA NO LETAL AUTOSÓMICA RECESIVA ASOCIADA AL GEN MYBPC1"
  },
  {
    "codigo":6267005,
    "descripcion":"MENINGITIS SIFILÍTICA CONGÉNITA"
  },
  {
    "codigo":301179007,
    "descripcion":"ACCESO VENOSO DIFÍCIL"
  },
  {
    "codigo":201040000,
    "descripcion":"CALLOSIDAD"
  },
  {
    "codigo":366715009,
    "descripcion":"AMPLITUD DE MOVIMIENTO PASIVO DE ADUCCIÓN DE DEDO DEL PIE - HALLAZGO"
  },
  {
    "codigo":364880002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA ATRAPAR"
  },
  {
    "codigo":168272005,
    "descripcion":"HELICOBACTER NO DETECTADO POR SEROLOGÍA"
  },
  {
    "codigo":233808007,
    "descripcion":"EDEMA DE ANASTOMOSIS BRONQUIAL"
  },
  {
    "codigo":37200009,
    "descripcion":"TRASTORNO DEL METABOLISMO DE LA TIROSINA"
  },
  {
    "codigo":789029002,
    "descripcion":"REQUIERE VACUNACIÓN ANTISARAMPIONOSA"
  },
  {
    "codigo":166437003,
    "descripcion":"PRUEBA SÉRICA DE EMBARAZO POSITIVA"
  },
  {
    "codigo":363045008,
    "descripcion":"TRASTORNO HEREDITARIO DEL TEJIDO CONJUNTIVO"
  },
  {
    "codigo":361210001,
    "descripcion":"PÚRPURA POR ESTASIS"
  },
  {
    "codigo":787194007,
    "descripcion":"METABOLIZADOR INTERMEDIO-RÁPIDO DE LA FAMILIA 2 SUBFAMILIA C MIEMBRO 9 DEL CITOCROMO P450"
  },
  {
    "codigo":295674007,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE PLICAMICINA"
  },
  {
    "codigo":262906009,
    "descripcion":"PERFORACIÓN DE VÍA URINARIA"
  },
  {
    "codigo":228303000,
    "descripcion":"BEBE CON LOS COLEGAS"
  },
  {
    "codigo":10956761000119104,
    "descripcion":"HERIDA ABIERTA DE DEDO MEÑIQUE DERECHO"
  },
  {
    "codigo":293839006,
    "descripcion":"ALERGIA A TRANILCIPROMINA"
  },
  {
    "codigo":424911007,
    "descripcion":"ENCEFALITIS PARANEOPLÁSICA"
  },
  {
    "codigo":719823007,
    "descripcion":"SÍNDROME DE EXTRASÍSTOLES VENTRICULARES CON SÍNCOPE, PERODACTILIA Y SECUENCIA DE PIERRE ROBIN"
  },
  {
    "codigo":292004001,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR DIAZÓXIDO"
  },
  {
    "codigo":160932005,
    "descripcion":"PROBLEMA FINANCIERO"
  },
  {
    "codigo":95396005,
    "descripcion":"QUISTE EN EL SITIO DE INYECCIÓN"
  },
  {
    "codigo":62628008,
    "descripcion":"SÍNDROME DE SINOSTOSIS MÚLTIPLE"
  },
  {
    "codigo":879993004,
    "descripcion":"INCOMODIDAD CAUSADA POR DISPOSITIVO"
  },
  {
    "codigo":93561007,
    "descripcion":"PERFORACIÓN IATROGÉNICA DE LA TRÁQUEA"
  },
  {
    "codigo":419406002,
    "descripcion":"REACCIÓN ADVERSA A LÍQUIDO O SOLUCIÓN FARMACÉUTICA"
  },
  {
    "codigo":288334006,
    "descripcion":"NO ELEVA"
  },
  {
    "codigo":188195000,
    "descripcion":"NEOPLASIA MALIGNA DEL ISTMO DEL CUERPO UTERINO"
  },
  {
    "codigo":712483001,
    "descripcion":"BURSITIS DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":190030009,
    "descripcion":"LEUCEMIAS COMPUESTAS"
  },
  {
    "codigo":89891003,
    "descripcion":"URETRITIS FOLICULAR"
  },
  {
    "codigo":286499006,
    "descripcion":"DIFICULTAD PARA PREPARAR COMIDA PARA ANIMALES"
  },
  {
    "codigo":253731008,
    "descripcion":"AGENESIA PARCIAL DE PERICARDIO"
  },
  {
    "codigo":1269539009,
    "descripcion":"SÍNDROME DE ABSTINENCIA DE ANTIDEPRESIVO"
  },
  {
    "codigo":284664002,
    "descripcion":"QUEJA POR COMPORTAMIENTO"
  },
  {
    "codigo":315597005,
    "descripcion":"ABSCESO DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":446669006,
    "descripcion":"HEMORRAGIA DE ANASTOMOSIS"
  },
  {
    "codigo":53453008,
    "descripcion":"OSTEOMIELITIS DE REGIÓN DE HOMBRO"
  },
  {
    "codigo":250061009,
    "descripcion":"DEJA CAER COSAS"
  },
  {
    "codigo":280994000,
    "descripcion":"ESTADO CONFUSIONAL CRÓNICO"
  },
  {
    "codigo":444834005,
    "descripcion":"ABSCESO DE GLÁNDULA URETRAL CAUSADO POR NEISSERIA GONORRHOEAE"
  },
  {
    "codigo":1264034006,
    "descripcion":"DOLOR EN MÚSCULO DE MUSLO"
  },
  {
    "codigo":49783001,
    "descripcion":"SÍNDROME PARANEOPLÁSICO"
  },
  {
    "codigo":770679002,
    "descripcion":"SÍNDROME DE POLINEUROPATÍA, DISCAPACIDAD INTELECTUAL, ACROMICRIA Y MENOPAUSIA PREMATURA"
  },
  {
    "codigo":1260364001,
    "descripcion":"DISTONÍA DEBIDA A LESIÓN CEREBRAL PERINATAL"
  },
  {
    "codigo":275489000,
    "descripcion":"HERIDA DE OROFARINGE"
  },
  {
    "codigo":277324009,
    "descripcion":"RUPTURA DE ANEURISMA DE ARTERIA BASILAR"
  },
  {
    "codigo":46113002,
    "descripcion":"INSUFICIENCIA CARDÍACA HIPERTENSIVA"
  },
  {
    "codigo":703308008,
    "descripcion":"DISECCIÓN ADQUIRIDA DE ARTERIA PULMONAR"
  },
  {
    "codigo":1073421000119107,
    "descripcion":"ARTRITIS INFECCIOSA DE CODO IZQUIERDO"
  },
  {
    "codigo":406561001,
    "descripcion":"MORDEDURA DE ANIMAL POTENCIALMENTE RABIOSO A HUMANO"
  },
  {
    "codigo":373793006,
    "descripcion":"BASES PARA EL DIAGNÓSTICO DE CÁNCER"
  },
  {
    "codigo":111649009,
    "descripcion":"LUXACIÓN NO EXPUESTA ANTERIOR DE LA CADERA"
  },
  {
    "codigo":145831000119103,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE CÉLULAS GERMINALES"
  },
  {
    "codigo":240886005,
    "descripcion":"PRURITO DEL ALMACENERO"
  },
  {
    "codigo":109814008,
    "descripcion":"GASTROENTERITIS ULCERADA AGUDA COMPLICADA CON NEUMONÍA"
  },
  {
    "codigo":206283000,
    "descripcion":"NEUMONÍA ESTAFILOCÓCICA CONGÉNITA"
  },
  {
    "codigo":402891002,
    "descripcion":"INFECCIÓN OCULAR RECURRENTE POR HERPES SIMPLE"
  },
  {
    "codigo":1254859004,
    "descripcion":"SENSIBILIDAD CUTÁNEA REDUCIDA POSQUIRÚRGICA"
  },
  {
    "codigo":302752001,
    "descripcion":"ENCOPRESIS FUNCIONAL"
  },
  {
    "codigo":204448004,
    "descripcion":"ATRESIA DE LA ARTERIA PULMONAR CON DEFECTO SEPTAL"
  },
  {
    "codigo":1351328007,
    "descripcion":"INMUNODEFICIENCIA COMBINADA AUTOSÓMICA RECESIVA DEBIDA A DEFICIENCIA DE TRANSDUCTOR DE SEÑAL DE LA FAMILIA DE CITOCINAS INTERLEUCINA 6 COMPLETA"
  },
  {
    "codigo":106144008,
    "descripcion":"HALLAZGO DE LAS NEURONAS Y\/O DE LAS FIBRAS NERVIOSAS"
  },
  {
    "codigo":40608009,
    "descripcion":"HIPERTROPÍA"
  },
  {
    "codigo":366453003,
    "descripcion":"RESPUESTA DE COMPRESIÓN CEFÁLICA - HALLAZGO"
  },
  {
    "codigo":202613004,
    "descripcion":"CHASQUIDO DE ARTICULACIÓN ASTRAGALONAVICULAR"
  },
  {
    "codigo":10631591000119108,
    "descripcion":"ABSCESO DE PIEL DE MUÑECA DERECHA"
  },
  {
    "codigo":300917007,
    "descripcion":"ISQUEMIA DE LOS PIES"
  },
  {
    "codigo":168010004,
    "descripcion":"EXAMEN DE LÍQUIDO ASCÍTICO, NORMAL"
  },
  {
    "codigo":299082004,
    "descripcion":"AMPLITUD DE EXTENSIÓN PASIVA DE DEDO DE LA MANO AUMENTADA"
  },
  {
    "codigo":11997761000119104,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DE RODILLA DERECHA"
  },
  {
    "codigo":395551004,
    "descripcion":"INVASIÓN TUMORAL VENOSA (GRANDES VASOS)\/ LINFÁTICA (PEQUEÑOS VASOS), NO APLICABLE"
  },
  {
    "codigo":721396002,
    "descripcion":"SÍNDROME DEL CORDÓN POSTERIOR DE MÉDULA ESPINAL AL NIVEL DEL SÉPTIMO SEGMENTO CERVICAL"
  },
  {
    "codigo":295412007,
    "descripcion":"SOBREDOSIS INTENCIONAL DE CISAPRIDA"
  },
  {
    "codigo":162505000,
    "descripcion":"DOLOR OPRESIVO"
  },
  {
    "codigo":719561001,
    "descripcion":"REQUIERE CONTACTO A TRAVÉS DEL CUIDADOR"
  },
  {
    "codigo":129737002,
    "descripcion":"CARACTERÍSTICAS RADIOGRÁFICAS DE BORDE DE LESIÓN"
  },
  {
    "codigo":293577006,
    "descripcion":"REACCIÓN ADVERSA A LA HIALURONIDASA"
  },
  {
    "codigo":195273007,
    "descripcion":"ANEURISMA DE ARTERIA CUBITAL"
  },
  {
    "codigo":1075931000119102,
    "descripcion":"TENOSINOVITIS DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":95134002,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL TERCER HUESO CUNEIFORME DEL TARSO"
  },
  {
    "codigo":62366003,
    "descripcion":"ÚLCERA GÁSTRICA CON HEMORRAGIA Y PERFORACIÓN"
  },
  {
    "codigo":226206003,
    "descripcion":"DIETA SIN LEVADURA"
  },
  {
    "codigo":15684161000119109,
    "descripcion":"PERIOSTITIS DE AMBAS PIERNAS"
  },
  {
    "codigo":193438006,
    "descripcion":"RETINOCOROIDITIS FOCAL PERIFÉRICA"
  },
  {
    "codigo":160670007,
    "descripcion":"DIETA PARA DIABÉTICOS"
  },
  {
    "codigo":93299004,
    "descripcion":"HIPOPLASIA CONGÉNITA DEL ANILLO TIMPÁNICO"
  },
  {
    "codigo":224371006,
    "descripcion":"EN VÍAS DE PROYECTO DE TRABAJO"
  },
  {
    "codigo":60531007,
    "descripcion":"ÚLCERA GÁSTRICA CRÓNICA SIN HEMORRAGIA Y SIN PERFORACIÓN PERO CON OBSTRUCCIÓN"
  },
  {
    "codigo":111027004,
    "descripcion":"HIPERTROFIA DEL TABIQUE INTERVENTRICULAR"
  },
  {
    "codigo":124232007,
    "descripcion":"DEFICIENCIA DE MONOOXIGENASA"
  },
  {
    "codigo":1303880008,
    "descripcion":"TROMBOSIS VENOSA PROFUNDA DE VENA TIBIAL POSTERIOR"
  },
  {
    "codigo":1269277004,
    "descripcion":"DEFICIENCIA DE ADHESIÓN LEUCOCITARIA TIPO 3"
  },
  {
    "codigo":253469004,
    "descripcion":"PROLAPSO DE VÁLVULA AURICULOVENTRICULAR DERECHA"
  },
  {
    "codigo":89629006,
    "descripcion":"ARGIRIA DE LA PIEL"
  },
  {
    "codigo":286237009,
    "descripcion":"INCAPAZ DE COORDINAR EL FLUJO DE AIRE CON LA EMISIÓN DE LA VOZ"
  },
  {
    "codigo":1300210009,
    "descripcion":"CON MAYOR RIESGO DE TRASTORNO PERINATAL MATERNO"
  },
  {
    "codigo":1003463004,
    "descripcion":"DISPLASIA CORTICAL FOCAL TIPO I"
  },
  {
    "codigo":249799005,
    "descripcion":"ANGULACIÓN DE HUESO DEL PIE"
  },
  {
    "codigo":85959007,
    "descripcion":"INTOXICACIÓN POR LINUM"
  },
  {
    "codigo":84124004,
    "descripcion":"ÚLCERA GASTROYEYUNAL CON HEMORRAGIA"
  },
  {
    "codigo":870556006,
    "descripcion":"FRACTURA EXPUESTA DE CRÁNEO CON LACERACIÓN DE CEREBRO"
  },
  {
    "codigo":247964007,
    "descripcion":"REPETICIÓN COMPULSIVA"
  },
  {
    "codigo":280732008,
    "descripcion":"TRASTORNO OBSTÉTRICO DEL ÚTERO"
  },
  {
    "codigo":121871000119100,
    "descripcion":"SINEQUIAS ADQUIRIDAS DE PREPUCIO DEL PENE"
  },
  {
    "codigo":213361003,
    "descripcion":"FRACTURAS QUE COMPROMETEN EL TÓRAX CON LA REGIÓN LUMBAR Y LA PELVIS Y MIEMBRO\/S"
  },
  {
    "codigo":1260102005,
    "descripcion":"TATUAJE DE COLOR NEGRO DE TEJIDO BLANDO BUCAL"
  },
  {
    "codigo":11836431000119103,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN MEDIOTARSIANA DERECHA"
  },
  {
    "codigo":47686007,
    "descripcion":"PALADAR HENDIDO BILATERAL INCOMPLETO"
  },
  {
    "codigo":735814008,
    "descripcion":"LACERACIÓN DE MANO CON CUERPO EXTRAÑO"
  },
  {
    "codigo":109552000,
    "descripcion":"QUISTE DE BIFURCACIÓN BUCAL"
  },
  {
    "codigo":111387008,
    "descripcion":"PORFIRIA CAUSADA POR EFECTO TÓXICO DE SUSTANCIAS"
  },
  {
    "codigo":699376002,
    "descripcion":"TUMEFACCIÓN DE LABIO"
  },
  {
    "codigo":367631000119105,
    "descripcion":"HIPOTIROIDISMO CAUSADO POR FÁRMACO"
  },
  {
    "codigo":39951000119105,
    "descripcion":"TRASTORNO GENERALIZADO DEL DESARROLLO DE ESTADO RESIDUAL"
  },
  {
    "codigo":240624008,
    "descripcion":"PELIOSIS BACILAR CAUSADA POR BARTONELLA"
  },
  {
    "codigo":402629005,
    "descripcion":"CAMBIOS UNGUEALES ASOCIADOS CON ENFERMEDAD SISTÉMICA"
  },
  {
    "codigo":74949007,
    "descripcion":"INFESTACIÓN CAUSADA POR ANOPLURA"
  },
  {
    "codigo":269722001,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR SALICILATO"
  },
  {
    "codigo":300655004,
    "descripcion":"NO ORGANIZA UN VIAJE"
  },
  {
    "codigo":5743005,
    "descripcion":"IRIDOSQUISIS"
  },
  {
    "codigo":341161000119105,
    "descripcion":"EDEMA MACULAR CISTOIDEO DE RETINA IZQUIERDA"
  },
  {
    "codigo":235119009,
    "descripcion":"APLASIA DE LA APÓFISIS CONDÍLEA DE LA MANDÍBULA"
  },
  {
    "codigo":724804001,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO SENSITIVO CUTÁNEO A NIVEL DE PIERNA"
  },
  {
    "codigo":366191009,
    "descripcion":"ASPECTO DEL VENTRÍCULO DERECHO - HALLAZGO"
  },
  {
    "codigo":3908001,
    "descripcion":"INFESTACIÓN CAUSADA POR HAEMATOPINUS"
  },
  {
    "codigo":36676002,
    "descripcion":"GRADO DE AFECTACIÓN: DETERIORO PROFUNDO DE AMBOS OJOS"
  },
  {
    "codigo":2073000,
    "descripcion":"IDEACIÓN DELIRANTE"
  },
  {
    "codigo":16561321000119107,
    "descripcion":"FRACTURA ABIERTA DE HUESO CIGOMÁTICO IZQUIERDO"
  },
  {
    "codigo":722969006,
    "descripcion":"TEMBLOR DEBIDO A TRASTORNO METABÓLICO"
  },
  {
    "codigo":231449007,
    "descripcion":"PSICOSIS EPILÉPTICA"
  },
  {
    "codigo":360686003,
    "descripcion":"DEFICIENCIA DE ALDONOLACTONASA"
  },
  {
    "codigo":188296005,
    "descripcion":"NEOPLASIA MALIGNA DEL BULBO RAQUÍDEO"
  },
  {
    "codigo":33006007,
    "descripcion":"MIOCARDIOPATÍA RESTRICTIVA SECUNDARIA A FIBROELASTOSIS ENDOCÁRDICA"
  },
  {
    "codigo":295150008,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE DEXTROMORAMIDA"
  },
  {
    "codigo":1145283003,
    "descripcion":"CAPAZ DE PARTICIPAR EN ACTIVIDADES SOCIALES"
  },
  {
    "codigo":293315006,
    "descripcion":"REACCIÓN ADVERSA A HEMODERIVADO"
  },
  {
    "codigo":719299009,
    "descripcion":"SÍNDROME DE DISPLASIA PELVIESCAPULAR"
  },
  {
    "codigo":94872003,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE ÍLEON"
  },
  {
    "codigo":291480004,
    "descripcion":"INTOXICACIÓN POR GENTAMICINA"
  },
  {
    "codigo":72627004,
    "descripcion":"RECHAZO DE INJERTO"
  },
  {
    "codigo":225944008,
    "descripcion":"DOLOR A LA PALPACIÓN EN HERIDA"
  },
  {
    "codigo":1340056009,
    "descripcion":"TUMOR GLÓMICO BENIGNO DE MASTOIDES"
  },
  {
    "codigo":715629001,
    "descripcion":"SÍNDROME DE EPILEPSIA GENERALIZADA Y DISCINESIA PAROXÍSTICA"
  },
  {
    "codigo":224109001,
    "descripcion":"CRIANZA EN GRUPO COMUNITARIO"
  },
  {
    "codigo":289645006,
    "descripcion":"ÚTERO CENTRAL"
  },
  {
    "codigo":420717009,
    "descripcion":"HALLAZGO DE PULSO DETERMINADO POR DOPPLER"
  },
  {
    "codigo":93037009,
    "descripcion":"COSTILLA RAMIFICADA CONGÉNITA"
  },
  {
    "codigo":123970007,
    "descripcion":"TRASTORNO EN EL METABOLISMO DEL YODO"
  },
  {
    "codigo":253207002,
    "descripcion":"SINOFRIS"
  },
  {
    "codigo":449815008,
    "descripcion":"HEMATOMA DE REGIÓN PERIANAL"
  },
  {
    "codigo":251372001,
    "descripcion":"VÍA AÉREA NASAL PERMEABLE"
  },
  {
    "codigo":285975008,
    "descripcion":"NO CONTROLA LA TEMPERATURA DEL AGUA EN EL HOGAR"
  },
  {
    "codigo":54764003,
    "descripcion":"SINQUILIA"
  },
  {
    "codigo":284140004,
    "descripcion":"INCAPAZ DE MOVER EL BRAZO"
  },
  {
    "codigo":249537008,
    "descripcion":"HALLAZGO DE OMBLIGO"
  },
  {
    "codigo":85697009,
    "descripcion":"MÚSCULO OCULAR SUPERNUMERARIO"
  },
  {
    "codigo":282305008,
    "descripcion":"INCAPAZ DE MANTENER EL EQUILIBRIO SENTADO"
  },
  {
    "codigo":870294005,
    "descripcion":"MIELITIS CAUSADA POR TOXOPLASMA GONDII"
  },
  {
    "codigo":245867000,
    "descripcion":"ESPONDILÓLISIS ADQUIRIDA"
  },
  {
    "codigo":213099002,
    "descripcion":"RUPTURA DE FIJADOR EXTERNO"
  },
  {
    "codigo":278635006,
    "descripcion":"PRÓTESIS DENTAL EXCESIVAMENTE ANCHA"
  },
  {
    "codigo":29791000175103,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN EN CADERA IZQUIERDA ESTADIO I"
  },
  {
    "codigo":735552000,
    "descripcion":"TRASTORNO RELACIONADO CON EL JUEGO, PREDOMINANTEMENTE EN LÍNEA"
  },
  {
    "codigo":15990391000119105,
    "descripcion":"DEPÓSITOS RETINIANOS DE OJO IZQUIERDO"
  },
  {
    "codigo":80192004,
    "descripcion":"RUPTURA MASIVA DE PARÉNQUIMA DE BAZO CON HERIDA ABIERTA HACIA CAVIDAD ABDOMINAL"
  },
  {
    "codigo":1080951000119106,
    "descripcion":"MELANOMA MALIGNO DE CUERPO CILIAR DE OJO IZQUIERDO"
  },
  {
    "codigo":209429001,
    "descripcion":"ESGUINCE DE LIGAMENTO LATERAL INTERNO DE ARTICULACIÓN DE CODO"
  },
  {
    "codigo":307733001,
    "descripcion":"ABORTO COMPLETO INEVITABLE"
  },
  {
    "codigo":897557006,
    "descripcion":"ACORTAMIENTO CONGÉNITO DE OREJA"
  },
  {
    "codigo":78357006,
    "descripcion":"DEBILIDAD ESPINAL A NIVEL MOTOR"
  },
  {
    "codigo":317201000119102,
    "descripcion":"PANICULITIS DE TÓRAX"
  },
  {
    "codigo":10986001,
    "descripcion":"OSTEOCLASIA"
  },
  {
    "codigo":305898000,
    "descripcion":"VISTO POR EL SERVICIO DE CIRUGÍA PANCREÁTICA"
  },
  {
    "codigo":240362004,
    "descripcion":"INFECCIÓN AMEBIANA SINTOMÁTICA NO INVASIVA"
  },
  {
    "codigo":109290007,
    "descripcion":"MELANOMA IN SITU DEL MIEMBRO SUPERIOR"
  },
  {
    "codigo":1156031002,
    "descripcion":"VÁRICES VENOSAS EN EL EMBARAZO"
  },
  {
    "codigo":402367003,
    "descripcion":"GRANULOMA ANULAR LINEAL"
  },
  {
    "codigo":369599003,
    "descripcion":"TUMOR MALIGNO CON COMPROMISO DE ÓRGANO POR PROPAGACIÓN DIRECTA DESDE CUELLO UTERINO"
  },
  {
    "codigo":71441000119104,
    "descripcion":"SÍNDROME NEFRÓTICO DEBIDO A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":11786001000119105,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO DE MANO DERECHA"
  },
  {
    "codigo":105620001,
    "descripcion":"EFECTO DE CUERPO EXTRAÑO"
  },
  {
    "codigo":236692005,
    "descripcion":"TRASTORNO DEGENERATIVO DE LA URETRA"
  },
  {
    "codigo":12113681000119106,
    "descripcion":"QUEMADURA QUÍMICA DE CARA"
  },
  {
    "codigo":302228007,
    "descripcion":"EQUIMOSIS ESPONTÁNEA"
  },
  {
    "codigo":1285268008,
    "descripcion":"RANGO PASIVO DE FLEXIÓN PLANTAR DE TOBILLO AUMENTADO"
  },
  {
    "codigo":269460009,
    "descripcion":"NEOPLASIA MALIGNA DE CURVATURA MAYOR DE ESTÓMAGO"
  },
  {
    "codigo":726377002,
    "descripcion":"DELECIÓN DE PARTE DEL CROMOSOMA 7"
  },
  {
    "codigo":1186964008,
    "descripcion":"PERIODONTITIS EXACERBADA POR NEUTROPENIA FAMILAR CRÓNICA"
  },
  {
    "codigo":890217006,
    "descripcion":"POSICIÓN ANÓMALA CONGÉNITA DE VÍA PANCREATOBILIAR"
  },
  {
    "codigo":365929007,
    "descripcion":"CONSCIENCIA Y ALERTA - HALLAZGO"
  },
  {
    "codigo":202089008,
    "descripcion":"DESGARRO ANTIGUO EN ASA DE BALDE DEL MENISCO EXTERNO"
  },
  {
    "codigo":724542001,
    "descripcion":"ENCEFALITIS CAUSADA POR EL VIRUS DE LA ENCEFALLOMIELITIS EQUINA VENEZOLANA"
  },
  {
    "codigo":429630006,
    "descripcion":"LUXACIÓN CERRADA DE ARTICULACIÓN RADIOCARPIANA"
  },
  {
    "codigo":298558007,
    "descripcion":"AMPLITUD DE ROTACIÓN PASIVA HACIA LA DERECHA DE LA COLUMNA VERTEBRAL DORSAL, NORMAL"
  },
  {
    "codigo":427795000,
    "descripcion":"INFECCIÓN CAUSADA POR BRUCELLA ABORTUS"
  },
  {
    "codigo":722707001,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE SISTEMA NERVIOSO PERIFÉRICO"
  },
  {
    "codigo":296723004,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE CEFIXIMA"
  },
  {
    "codigo":38811000087102,
    "descripcion":"DOLOR TORÁCICO CRÓNICO PRIMARIO"
  },
  {
    "codigo":294888001,
    "descripcion":"ALERGIA A COLÁGENO"
  },
  {
    "codigo":43931000087106,
    "descripcion":"CORTE EN TOBILLO DERECHO"
  },
  {
    "codigo":41371000087105,
    "descripcion":"HEMATOMA DE SEGUNDO DEDO DE PIE DERECHO"
  },
  {
    "codigo":46491000087105,
    "descripcion":"FRACTURA DE CUELLO DE FÉMUR DERECHO"
  },
  {
    "codigo":131048007,
    "descripcion":"17 - CETOESTEROIDES ANORMALES"
  },
  {
    "codigo":360424008,
    "descripcion":"OVARIO DISPLÁSICO"
  },
  {
    "codigo":784573006,
    "descripcion":"HEMORRAGIA EXTRADURAL INTRACRANEAL TRAUMÁTICA"
  },
  {
    "codigo":260285006,
    "descripcion":"VISIÓN A DISTANCIA 3\/24"
  },
  {
    "codigo":422290000,
    "descripcion":"TRASTORNO ALÉRGICO CUTÁNEO"
  },
  {
    "codigo":94610000,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA GLÁNDULA SUBMAXILAR"
  },
  {
    "codigo":717202002,
    "descripcion":"ESPECIE DE GEMELLA O STREPTOCOCCUS PNEUMONIAE"
  },
  {
    "codigo":127378008,
    "descripcion":"PARESIA BILATERAL"
  },
  {
    "codigo":782738008,
    "descripcion":"NEFRITIS INTERSTICIAL CARIOMEGÁLICA"
  },
  {
    "codigo":29074008,
    "descripcion":"PÓLIPO DE SENO MAXILAR"
  },
  {
    "codigo":289383002,
    "descripcion":"NIVEL 1 DE LA PRESENTACIÓN EN RELACIÓN CON LAS ESPINAS ISQUIÁTICAS"
  },
  {
    "codigo":92775007,
    "descripcion":"CARCINOMA IN SITU DE TESTÍCULO RETENIDO"
  },
  {
    "codigo":402440008,
    "descripcion":"PENFIGOIDE BULLOSO CON COMPROMISO DE MUCOSA BUCAL"
  },
  {
    "codigo":713532005,
    "descripcion":"ARTRITIS INFECCIOSA CONCOMITANTE CON INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":1336124006,
    "descripcion":"ENFERMEDAD DE DEPÓSITOS DENSOS DEL COMPONENTE 4 DEL COMPLEMENTO"
  },
  {
    "codigo":123708006,
    "descripcion":"DISTROFIA SECUNDARIA DEL PELO"
  },
  {
    "codigo":89105000,
    "descripcion":"ASTEATOSIS CUTÁNEA"
  },
  {
    "codigo":16703711000119100,
    "descripcion":"DÉFICIT DE MEMORIA DEBIDO A ACCIDENTE CEREBROVASCULAR EMBÓLICO Y POSTERIOR A ÉL"
  },
  {
    "codigo":254780006,
    "descripcion":"MALFORMACIÓN ARTERIOVENOSA CUTÁNEA"
  },
  {
    "codigo":346181000119106,
    "descripcion":"EPÍFORA DE AMBOS OJOS DEBIDA A PRODUCCIÓN EXCESIVA DE LÁGRIMAS"
  },
  {
    "codigo":11814981000119108,
    "descripcion":"RUPTURA DE LIGAMENTO DE DEDO DE MANO DERECHA"
  },
  {
    "codigo":16048351000119102,
    "descripcion":"ARTRITIS VIRAL DE ARTICULACIÓN DE REGIÓN DE HOMBRO, BILATERAL"
  },
  {
    "codigo":449553009,
    "descripcion":"HEMANGIOMA SUPRACLAVICULAR"
  },
  {
    "codigo":1083461000119108,
    "descripcion":"DIVISIÓN CONGÉNITA DE AMBOS LÓBULOS DE OREJAS"
  },
  {
    "codigo":54502004,
    "descripcion":"DEMENCIA DEGENERATIVA PRIMARIA TIPO ALZHEIMER, DE INICIO EN LA EDAD PRESENIL, CON DELUSIONES"
  },
  {
    "codigo":414950005,
    "descripcion":"GLIOMA DEL NERVIO ÓPTICO ORBITARIO"
  },
  {
    "codigo":283878007,
    "descripcion":"ALTERACIÓN DE REGISTRO"
  },
  {
    "codigo":183739001,
    "descripcion":"CONSULTA DOMICILIARIA PEDIÁTRICA, REALIZADA"
  },
  {
    "codigo":314811006,
    "descripcion":"DISCRIMINACIÓN TÁCTIL DEL PIE DERECHO ANORMAL"
  },
  {
    "codigo":216507007,
    "descripcion":"INTOXICACIÓN ACCIDENTAL CAUSADA POR PARALDEHÍDO"
  },
  {
    "codigo":1363387006,
    "descripcion":"SINEQUIAS ANTERIORES PERIFÉRICAS EN CUADRANTE TEMPORAL DE ÁNGULO IRIDOCORNEAL DE OJO DERECHO"
  },
  {
    "codigo":249275009,
    "descripcion":"DESEO DE ORINAR"
  },
  {
    "codigo":247440002,
    "descripcion":"LESIÓN DE PIEL O MUCOSA"
  },
  {
    "codigo":1197712002,
    "descripcion":"FÍSTULA COLEDOCOYEYUNAL ADQUIRIDA"
  },
  {
    "codigo":19899009,
    "descripcion":"INFECCIÓN CAUSADA POR TRIODONTOPHORUS"
  },
  {
    "codigo":293241000119100,
    "descripcion":"EXACERBACIÓN AGUDA DE BRONQUITIS OBSTRUCTIVA CRÓNICA"
  },
  {
    "codigo":1163109001,
    "descripcion":"COLITIS POR GIARDIA LAMBLIA"
  },
  {
    "codigo":704357004,
    "descripcion":"CON MAYOR RIESGO DE CONDUCTA AUTOLESIVA"
  },
  {
    "codigo":1259578006,
    "descripcion":"CARCINOMA ANEXIAL CUTÁNEO PRIMARIO INDIFERENCIADO"
  },
  {
    "codigo":405775000,
    "descripcion":"BAJO CUIDADO DE ASISTENTE SOCIAL"
  },
  {
    "codigo":733455003,
    "descripcion":"SÍNDROME DE PARAPLEJÍA ESPÁSTICA, GLAUCOMA Y DISCAPACIDAD INTELECTUAL"
  },
  {
    "codigo":78095005,
    "descripcion":"HEMATOSALPINGE"
  },
  {
    "codigo":241935008,
    "descripcion":"ANAFILAXIA PRODUCIDA POR CLARA DE HUEVO"
  },
  {
    "codigo":373007008,
    "descripcion":"INFECCIÓN CAUSADA POR ASPERGILLUS VERSICOLOR"
  },
  {
    "codigo":305636002,
    "descripcion":"ATENDIDO POR UN RADIOTERAPEUTA"
  },
  {
    "codigo":240100004,
    "descripcion":"MIOPATÍA DEBIDA A MORDEDURA DE VÍBORA"
  },
  {
    "codigo":403940006,
    "descripcion":"HIDRADENOCARCINOMA ECRINO DE CÉLULAS CLARAS DE LA PIEL"
  },
  {
    "codigo":1255908009,
    "descripcion":"LACERACIÓN DE MÚSCULO CRURAL POSTERIOR DE PIERNA"
  },
  {
    "codigo":205497004,
    "descripcion":"OSTEOGÉNESIS IMPERFECTA TIPO IV"
  },
  {
    "codigo":301966004,
    "descripcion":"ORIFICIO LAGRIMAL INFERIOR NORMAL"
  },
  {
    "codigo":203662005,
    "descripcion":"ESCOLIOSIS NEUROMUSCULAR"
  },
  {
    "codigo":348691000119103,
    "descripcion":"HIPERTROPÍA DE OJO IZQUIERDO"
  },
  {
    "codigo":1217635000,
    "descripcion":"CONTRACCIÓN DIFUSA DE CAVIDAD ORBITARIA CON PÉRDIDA DE SUPERFICIE"
  },
  {
    "codigo":234595001,
    "descripcion":"DEFICIENCIA DE LA CADENA 1Q BETA DEL COMPLEMENTO"
  },
  {
    "codigo":236430009,
    "descripcion":"NEFROPATÍA POR PIGMENTOS"
  },
  {
    "codigo":365667008,
    "descripcion":"HALLAZGO RELACIONADO CON EL COLOR DE UN LÍQUIDO"
  },
  {
    "codigo":300131008,
    "descripcion":"TUMORACIÓN EN CONDUCTO AUDITIVO"
  },
  {
    "codigo":1085971000119106,
    "descripcion":"CARIES DENTAL SOBRE SUPERFICIE CON HENDIDURAS Y FISURAS CON PENETRACIÓN HASTA LA PULPA"
  },
  {
    "codigo":167224006,
    "descripcion":"ORINA DE LA MITAD DEL CHORRO MICCIONAL = SIN ANOMALÍAS"
  },
  {
    "codigo":1345037001,
    "descripcion":"ETAPA DE ACCIÓN PARA LOGRAR UN CAMBIO EN CONDUCTA DE USO DE SUSTANCIA"
  },
  {
    "codigo":296461002,
    "descripcion":"SOBREDOSIS DE RETINOIDE"
  },
  {
    "codigo":722445001,
    "descripcion":"SARCOMA PRIMARIO DE CÉLULAS GIGANTES DE PERITONEO"
  },
  {
    "codigo":2291000124108,
    "descripcion":"CANINO SUPERIOR DERECHO DECIDUO SUPERNUMERARIO"
  },
  {
    "codigo":11817491000119108,
    "descripcion":"ESGUINCE DE LIGAMENTO DE DEDO ÍNDICE IZQUIERDO"
  },
  {
    "codigo":322221000119102,
    "descripcion":"QUISTE SINOVIAL DE RODILLA IZQUIERDA"
  },
  {
    "codigo":32482005,
    "descripcion":"PROTEINURIA ORTOSTÁTICA"
  },
  {
    "codigo":1179362008,
    "descripcion":"HIPOACUSIA NEUROSENSORIAL NEONATAL"
  },
  {
    "codigo":161719001,
    "descripcion":"DESEA RETRASAR LA MENSTRUACIÓN"
  },
  {
    "codigo":720610008,
    "descripcion":"SÍNDROME DE MIOCARDIOPATÍA Y ANOMALÍA RENAL"
  },
  {
    "codigo":425698008,
    "descripcion":"DIVERTICULOSIS DE CIEGO"
  },
  {
    "codigo":423863005,
    "descripcion":"ALTERNANCIA ELÉCTRICA DEL CORAZÓN"
  },
  {
    "codigo":292791008,
    "descripcion":"REACCIÓN ADVERSA AL ALCOHOL POLIVINÍLICO"
  },
  {
    "codigo":389260001,
    "descripcion":"CONDRODISPLASIA LETAL CON HUESO FRAGMENTADO"
  },
  {
    "codigo":1208460000,
    "descripcion":"CARCINOMA SARCOMATOIDE UROTELIAL DE VEJIGA"
  },
  {
    "codigo":94348003,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LOS ÓRGANOS INTRABDOMINALES"
  },
  {
    "codigo":290956003,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR FENOBARBITAL"
  },
  {
    "codigo":127116008,
    "descripcion":"LINFADENOPATÍA RELACIONADA CON LOS INTESTINOS"
  },
  {
    "codigo":715105007,
    "descripcion":"NO PASA DE LA SILLA AL INODORO"
  },
  {
    "codigo":289121008,
    "descripcion":"DIFICULTAD PARA EXPECTORAR"
  },
  {
    "codigo":190817009,
    "descripcion":"MACROGLOBULINEMIA"
  },
  {
    "codigo":1237558002,
    "descripcion":"VENA VARICOSA DE PANTORRILLA IZQUIERDA"
  },
  {
    "codigo":1335862003,
    "descripcion":"ESQUIZOFRENIA DE INICIO EN LA INFANCIA"
  },
  {
    "codigo":254518008,
    "descripcion":"NEOPLASIA BENIGNA DE EPIGLOTIS SUPRAHIOIDEA"
  },
  {
    "codigo":90678009,
    "descripcion":"TRASTORNO DE LABIO"
  },
  {
    "codigo":711435001,
    "descripcion":"ERITEMA NUDOSO MIGRATORIO CRÓNICO"
  },
  {
    "codigo":49991000119104,
    "descripcion":"LINFADENOPATÍA FOCAL"
  },
  {
    "codigo":188982009,
    "descripcion":"LIPOMA DE CEJA"
  },
  {
    "codigo":285451004,
    "descripcion":"NO MUEVE LA MANDÍBULA REPETIDAMENTE"
  },
  {
    "codigo":283616000,
    "descripcion":"HERIDA PUNZANTE DE MANO CAUSADA POR AGUJA"
  },
  {
    "codigo":840672002,
    "descripcion":"CRISTALINO OCULAR TRANSPARENTE"
  },
  {
    "codigo":10755041000119100,
    "descripcion":"DEPENDENCIA DE ALCOHOL EN EL MOMENTO DEL PARTO"
  },
  {
    "codigo":52405000,
    "descripcion":"QUEMADURA DEL TRONCO"
  },
  {
    "codigo":871605002,
    "descripcion":"TRANSPOSICIÓN DE GRANDES ARTERIAS CON CONEXIONES AURICULOVENTRICULARES CONCORDANTES Y DEFECTO DEL TABIQUE VENTRICULAR Y OBSTRUCCIÓN DEL TRACTO DE SALIDA DEL VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":314549003,
    "descripcion":"EPIESCLERITIS DIFUSA"
  },
  {
    "codigo":85173004,
    "descripcion":"RECONOCIMIENTO FALSO"
  },
  {
    "codigo":609461007,
    "descripcion":"INTERRUPCIÓN INDUCIDA DEL EMBARAZO COMPLICADA POR ANOXIA CEREBRAL"
  },
  {
    "codigo":17802000,
    "descripcion":"MESIODENS"
  },
  {
    "codigo":50570003,
    "descripcion":"ANEURISMA DE VASOS CORONARIOS"
  },
  {
    "codigo":443786003,
    "descripcion":"LESIÓN TRAUMÁTICA DURANTE LA PRÁCTICA DE ACTIVIDAD DEPORTIVA"
  },
  {
    "codigo":441951003,
    "descripcion":"MONOPLEJÍA DE MIEMBRO SUPERIOR DE LADO DOMINANTE"
  },
  {
    "codigo":310879007,
    "descripcion":"PROGRAMA DE REDUCCIÓN DE COLESTEROL - CONVOCADO"
  },
  {
    "codigo":1259316000,
    "descripcion":"CARCINOMA PRIMARIO DE DOS TERCIOS ANTERIORES DE LENGUA - CARA DORSAL"
  },
  {
    "codigo":833332003,
    "descripcion":"MEMBRANA AMNIÓTICA INCOMPLETA"
  },
  {
    "codigo":866100005,
    "descripcion":"ALOPECIA ISQUÉMICA DEBIDA A TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":1088481000119106,
    "descripcion":"INFLAMACIÓN CRÓNICA DE MEMBRANA TIMPÁNICA IZQUIERDA"
  },
  {
    "codigo":79668009,
    "descripcion":"VASA PREVIA"
  },
  {
    "codigo":733193001,
    "descripcion":"DEMENCIA CON LEUCOENCEFALOPATÍA MULTIFOCAL PROGRESIVA"
  },
  {
    "codigo":678881000119107,
    "descripcion":"DEPÓSITO EN AMBAS CÓRNEAS"
  },
  {
    "codigo":1290249005,
    "descripcion":"QUISTE POPLÍTEO"
  },
  {
    "codigo":700425005,
    "descripcion":"ENTEROPATÍA INDUCIDA POR FÁRMACO ANTIINFLAMATORIO NO ESTEROIDE"
  },
  {
    "codigo":1255646004,
    "descripcion":"CARCINOMA ESCAMOSO BASALOIDE DE HIPOFARINGE"
  },
  {
    "codigo":403678005,
    "descripcion":"NECROSIS DE COLGAJO CUTÁNEO"
  },
  {
    "codigo":239838005,
    "descripcion":"CONDROCALCINOSIS"
  },
  {
    "codigo":238003000,
    "descripcion":"DEFICIENCIA DE CARNITINA ACILCARNITINA TRANSLOCASA"
  },
  {
    "codigo":303539003,
    "descripcion":"SIN AMPLITUD DE MOVIMIENTO ACTIVO DE RETRACCIÓN DE LA COLUMNA VERTEBRAL CERVICAL"
  },
  {
    "codigo":308021000119100,
    "descripcion":"HIPERLAXITUD ARTICULAR DE REGIÓN DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":15952181000119101,
    "descripcion":"TUMEFACCIÓN DE GLÁNDULA PARÓTIDA DERECHA"
  },
  {
    "codigo":338741000119102,
    "descripcion":"QUERATOCONJUNTIVITIS FLICTENULAR DE OJO IZQUIERDO"
  },
  {
    "codigo":12240181000119103,
    "descripcion":"MASA DE MAMA IZQUIERDA"
  },
  {
    "codigo":1073461000119102,
    "descripcion":"ARTRITIS INFECCIOSA DE MANO IZQUIERDA"
  },
  {
    "codigo":1091381000119105,
    "descripcion":"ABSCESO DE OÍDO EXTERNO DERECHO"
  },
  {
    "codigo":8501000119104,
    "descripcion":"CARDIOPATÍA HIPERTENSIVA Y ENFERMEDAD RENAL CRÓNICA"
  },
  {
    "codigo":15959861000119107,
    "descripcion":"QUISTE EMBRIONARIO DE CONDUCTO DE GARTNER DERECHO"
  },
  {
    "codigo":354101000119108,
    "descripcion":"NEOPLASIA BENIGNA DE ÓRBITA IZQUIERDA"
  },
  {
    "codigo":10972981000119108,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO DIGITAL DE DEDO DE LA MANO IZQUIERDA"
  },
  {
    "codigo":16466741000119102,
    "descripcion":"MELORREOSTOSIS DE PIE DERECHO"
  },
  {
    "codigo":15934261000119108,
    "descripcion":"DEDO EN MARTILLO ADQUIRIDO DE SEGUNDO A QUINTO DEDOS DE PIE DERECHO"
  },
  {
    "codigo":428263221000119103,
    "descripcion":"MELANOMA IN SITU DE EPITELIO DE VAGINA"
  },
  {
    "codigo":11858741000119104,
    "descripcion":"LESIÓN TRAUMÁTICA DE VENA POPLÍTEA IZQUIERDA"
  },
  {
    "codigo":144181000119106,
    "descripcion":"VENTRICULOMEGALIA EN LA ECOGRAFÍA FETAL"
  },
  {
    "codigo":170632009,
    "descripcion":"DESPERTAR NOCTURNO POR ASMA"
  },
  {
    "codigo":331061000119107,
    "descripcion":"ALTERACIÓN VASCULAR DE PÁRPADO IZQUIERDO"
  },
  {
    "codigo":10755381000119108,
    "descripcion":"ANEMIA POR DEFICIENCIA DE HIERRO POSPARTO"
  },
  {
    "codigo":299869006,
    "descripcion":"REFLEJO BULBOCAVERNOSO POSITIVO"
  },
  {
    "codigo":201565006,
    "descripcion":"ARTRITIS REACTIVA DE ARTICULACIÓN INTERFALÁNGICA PROXIMAL DE DEDO DE MANO"
  },
  {
    "codigo":1217373008,
    "descripcion":"SÍNDROME DE HERNIA DIAFRAGMÁTICA, INTESTINO CORTO Y ASPLENIA"
  },
  {
    "codigo":400008009,
    "descripcion":"LEPRA DIMORFA"
  },
  {
    "codigo":168797005,
    "descripcion":"MIELOGRAFÍA ANORMAL"
  },
  {
    "codigo":103261009,
    "descripcion":"MIRADA CONJUGADA ASCENDENTE"
  },
  {
    "codigo":396338004,
    "descripcion":"LEUCODISTROFIA METACROMÁTICA"
  },
  {
    "codigo":68658005,
    "descripcion":"EVALUACIÓN DE DISCAPACIDAD: 15%"
  },
  {
    "codigo":134194006,
    "descripcion":"CONSOLIDACIÓN TARDÍA DE FRACTURA"
  },
  {
    "codigo":197895004,
    "descripcion":"CICATRIZ DE VEJIGA URINARIA"
  },
  {
    "codigo":1287007,
    "descripcion":"AUSENCIA CONGÉNITA DE CONDUCTO BILIAR"
  },
  {
    "codigo":34055009,
    "descripcion":"INSPIRACIÓN EN FORMA DE SILBIDO ÁSPERO"
  },
  {
    "codigo":785884003,
    "descripcion":"DESGARRO DE RETINA DE OJO DERECHO"
  },
  {
    "codigo":1090991000119100,
    "descripcion":"CONDRODERMATITIS NODULAR HELICOIDAL DE LA OREJA DERECHA"
  },
  {
    "codigo":30385002,
    "descripcion":"AFASIA GRAFOMOTORA"
  },
  {
    "codigo":718513002,
    "descripcion":"ROMANÍ COMO SEGUNDO IDIOMA"
  },
  {
    "codigo":1144497004,
    "descripcion":"FRACTURA PATOLÓGICA DE PELVIS Y FÉMUR"
  },
  {
    "codigo":390833005,
    "descripcion":"OSTEOPOROSIS CAUSADA POR CORTICOSTEROIDE"
  },
  {
    "codigo":94086000,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL LÓBULO TEMPORAL"
  },
  {
    "codigo":194225009,
    "descripcion":"TRASTORNOS NO INFECCIOSOS DEL PABELLÓN AURICULAR"
  },
  {
    "codigo":126854002,
    "descripcion":"NEOPLASIA DE LA VESÍCULA BILIAR"
  },
  {
    "codigo":421766003,
    "descripcion":"TROMBOCITOPENIA CON SIDA (SÍNDROME DE INMUNODEFICIENCIA ADQUIRIDA)"
  },
  {
    "codigo":290694000,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR PENTOSTATINA"
  },
  {
    "codigo":1306502004,
    "descripcion":"CARCINOMA DUCTAL INFILTRANTE PRIMARIO DE PROLONGACIÓN AXILAR DE MAMA"
  },
  {
    "codigo":11848981000119109,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE MAMA DERECHA"
  },
  {
    "codigo":28550007,
    "descripcion":"CATARATA CAPSULAR CONGÉNITA"
  },
  {
    "codigo":288859005,
    "descripcion":"CAPAZ DE BEBER DE UN BEBEDERO"
  },
  {
    "codigo":26715006,
    "descripcion":"MIOPATÍA INDUCIDA POR ESTEROIDES"
  },
  {
    "codigo":92251006,
    "descripcion":"NEOPLASIA BENIGNA DE LOS GANGLIOS LINFÁTICOS DEL OBTURADOR"
  },
  {
    "codigo":10811000202109,
    "descripcion":"PROCTITIS ULCEROSA"
  },
  {
    "codigo":385328002,
    "descripcion":"MARGEN EPIPLOICO DE RESECCIÓN QUIRÚRGICA NO AFECTADO POR NEOPLASIA MALIGNA"
  },
  {
    "codigo":24880004,
    "descripcion":"INTOXICACIÓN POR ÁCIDO 2-(2-METIL-4-CLOROFENOXI)PROPIÓNICO"
  },
  {
    "codigo":254256008,
    "descripcion":"MALFORMACIÓN CONGÉNITA DE LA HIPÓFISIS POSTERIOR"
  },
  {
    "codigo":713008009,
    "descripcion":"ANTÍGENO P24 DE VIRUS DE INMUNODEFICIENCIA HUMANA DETECTADO"
  },
  {
    "codigo":285189004,
    "descripcion":"CAPAZ DE RECORDAR SU EDAD"
  },
  {
    "codigo":23045005,
    "descripcion":"DIABETES MELLITUS DEPENDIENTE DE INSULINA TIPO IA"
  },
  {
    "codigo":711173006,
    "descripcion":"CARIES DE FOSAS Y FISURAS"
  },
  {
    "codigo":10675631000119109,
    "descripcion":"ASMA PERSISTENTE SEVERA CONTROLADA CONCOMITANTE CON RINITIS ALÉRGICA"
  },
  {
    "codigo":19375000,
    "descripcion":"ARTRITIS PIÓGENA DE LA REGIÓN DE LA PELVIS"
  },
  {
    "codigo":283354009,
    "descripcion":"PICADURA DE INSECTO INFECTADA EN LA PLANTA DEL PIE"
  },
  {
    "codigo":445359003,
    "descripcion":"MENINGOENCEFALITIS BACTERIANA"
  },
  {
    "codigo":707503004,
    "descripcion":"NEUMONÍA CAUSADA POR SCHISTOSOMA MANSONI"
  },
  {
    "codigo":281519006,
    "descripcion":"FRACTURA - SUBLUXACIÓN DE ARTICULACIÓN DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":443524000,
    "descripcion":"ARTROSIS SECUNDARIA"
  },
  {
    "codigo":1295492004,
    "descripcion":"HIPERTENSIÓN OCULAR DE OJO DERECHO"
  },
  {
    "codigo":11796041000119106,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN METACARPOFALÁNGICA DE DEDO DE MANO IZQUIERDA"
  },
  {
    "codigo":83076007,
    "descripcion":"TRASTORNO DEL METABOLISMO DE LA GLICINA"
  },
  {
    "codigo":246916009,
    "descripcion":"GLOBO OCULAR AUSENTE"
  },
  {
    "codigo":212313002,
    "descripcion":"LESIÓN CERRADA DE NERVIO CRURAL"
  },
  {
    "codigo":115844009,
    "descripcion":"FENOTIPO DE GRUPO SANGUÍNEO KX"
  },
  {
    "codigo":15705007,
    "descripcion":"FLEBITIS DEL SENO BASILAR"
  },
  {
    "codigo":1162585007,
    "descripcion":"INFESTACIÓN DE LUGAR DE RESIDENCIA"
  },
  {
    "codigo":306947000,
    "descripcion":"ARITENOIDES PARCIALMENTE FIJO"
  },
  {
    "codigo":274179004,
    "descripcion":"HEMATOMA TRAUMÁTICO"
  },
  {
    "codigo":403416005,
    "descripcion":"PANICULITIS SECUNDARIA A ENFERMEDAD PANCREÁTICA"
  },
  {
    "codigo":1351853000,
    "descripcion":"INMUNODEFICIENCIA LINFOPROLIFERATIVA HIPERINFLAMATORIA FAMILIAR"
  },
  {
    "codigo":763864008,
    "descripcion":"LINFOCITOSIS DE LINFOCITOS B POLICLONALES PERSISTENTES"
  },
  {
    "codigo":41133002,
    "descripcion":"SÍNDROME MEDULAR POSTERIOR DEBIDO A FRACTURA NO EXPUESTA A NIVEL DE T7 - T12"
  },
  {
    "codigo":237741001,
    "descripcion":"HIPERALDOSTERONISMO PRIMARIO POR ADENOMA SUPRARRENAL"
  },
  {
    "codigo":204973009,
    "descripcion":"URETEROCELE CONGÉNITO SIMPLE"
  },
  {
    "codigo":268674003,
    "descripcion":"TRASTORNO DEL DESARROLLO DE LA FUNCIÓN MOTORA"
  },
  {
    "codigo":1153410003,
    "descripcion":"ESPONDILOARTRITIS BACTERIANA"
  },
  {
    "codigo":235906009,
    "descripcion":"HIPERBILIRRUBINEMIA - CONJUGADA - TIPO III"
  },
  {
    "codigo":102999002,
    "descripcion":"CRIALGESIA"
  },
  {
    "codigo":725591002,
    "descripcion":"DEFICIENCIA CONGÉNITA DE HEPARÁN SULFATO EN ENTEROCITOS"
  },
  {
    "codigo":365143001,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA LANZAR OBJETOS"
  },
  {
    "codigo":397911006,
    "descripcion":"BLOQUEO DE CONDUCCIÓN NERVIOSA MOTORA - COMPLETO"
  },
  {
    "codigo":234071007,
    "descripcion":"ACODAMIENTO DE VENA TRASPLANTADA"
  },
  {
    "codigo":299607008,
    "descripcion":"AMPLITUD DE ABDUCCIÓN ACTIVA DE DEDO DEL PIE NORMAL"
  },
  {
    "codigo":232236003,
    "descripcion":"OITIS NO INFECCIOSA CRÓNICA EXTERNA"
  },
  {
    "codigo":428844006,
    "descripcion":"COMPLEJOS VENTRICULARES PREMATUROS PAREADOS EN EL ELECTROCARDIOGRAMA"
  },
  {
    "codigo":33793000,
    "descripcion":"INFARTO DE TESTÍCULO"
  },
  {
    "codigo":263169005,
    "descripcion":"FRACTURA DE PARED ORBITARIA EXTERNA"
  },
  {
    "codigo":164865005,
    "descripcion":"INFARTO DE MIOCARDIO EN EL ELECTROCARDIOGRAMA"
  },
  {
    "codigo":427009007,
    "descripcion":"RUIDOS EPIGÁSTRICOS PRESENTES"
  },
  {
    "codigo":295937006,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE FLUOXETINA"
  },
  {
    "codigo":195798007,
    "descripcion":"ADENOAMIGDALITIS CRÓNICA"
  },
  {
    "codigo":783787000,
    "descripcion":"SÍNDROME DE VASCULOPATÍA RETINIANA CON LEUCOENCEFALOPATÍA CEREBRAL Y MANIFESTACIONES SISTÉMICAS"
  },
  {
    "codigo":95659007,
    "descripcion":"CEFALEA POR HERNIA DEL ROMBENCÉFALO"
  },
  {
    "codigo":716416002,
    "descripcion":"CAPAZ DE MANEJAR LA TEMPERATURA CORPORAL"
  },
  {
    "codigo":28288005,
    "descripcion":"MEDIANA EDAD"
  },
  {
    "codigo":290432005,
    "descripcion":"INTOXICACIÓN POR DANTRÓN"
  },
  {
    "codigo":93824007,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA CABEZA"
  },
  {
    "codigo":26453000,
    "descripcion":"TRASTORNO MENTAL EN LA ADOLESCENCIA"
  },
  {
    "codigo":190293001,
    "descripcion":"TIROIDITIS AGUDA"
  },
  {
    "codigo":126592009,
    "descripcion":"NEOPLASIA DE HUESO NAVICULAR DE PIE"
  },
  {
    "codigo":1339008006,
    "descripcion":"TRASTORNO DE PREPUCIO DE CLÍTORIS"
  },
  {
    "codigo":288597001,
    "descripcion":"DIFICULTAD PARA USAR UN SISTEMA DE COMUNICACIÓN NO VERBAL"
  },
  {
    "codigo":91989006,
    "descripcion":"NEOPLASIA BENIGNA DE LA ESPALDA"
  },
  {
    "codigo":59221008,
    "descripcion":"RINOFARINGITIS CAUSADA POR EL VIRUS DE LA PARAINFLUENZA"
  },
  {
    "codigo":90154003,
    "descripcion":"ENFERMEDAD DEL MÚSCULO PAPILAR"
  },
  {
    "codigo":303281000119103,
    "descripcion":"TENDINITIS CALCIFICANTE DE BRAZO DERECHO"
  },
  {
    "codigo":286762005,
    "descripcion":"RASGO DE LA PERSONALIDAD: NIVEL DE ORGULLO - HALLAZGO"
  },
  {
    "codigo":1237034006,
    "descripcion":"METÁSTASIS DE CARCINOMA DE GLÁNDULA SUBMAXILAR"
  },
  {
    "codigo":219391000,
    "descripcion":"HERIDA DE GUERRA POR FRAGMENTOS DE GRANADA FRAGMENTARIA"
  },
  {
    "codigo":253994009,
    "descripcion":"FISURA BILATERAL DE PALADAR DURO"
  },
  {
    "codigo":188458007,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE PIEL DE HOMBRO Y BRAZO"
  },
  {
    "codigo":55551005,
    "descripcion":"SALPINGITIS CRÓNICA"
  },
  {
    "codigo":284927005,
    "descripcion":"INCAPAZ DE UTILIZAR ORINAL DE CAMA"
  },
  {
    "codigo":283092000,
    "descripcion":"EXCORIACIÓN DEL ABDOMEN"
  },
  {
    "codigo":446932005,
    "descripcion":"INFLAMACIÓN DE PLIEGUE CUTÁNEO PERIORAL"
  },
  {
    "codigo":20948006,
    "descripcion":"ANOMALÍA CONGÉNITA DE DEDO DE MANO"
  },
  {
    "codigo":1297065000,
    "descripcion":"ARTRITIS RELACIONADA TEMPORALMENTE CON ENFERMEDAD INFLAMATORIA INTESTINAL"
  },
  {
    "codigo":709076009,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN CAUSADA POR DISPOSITIVO"
  },
  {
    "codigo":51881002,
    "descripcion":"LESIÓN TRAUMÁTICA DEL NERVIO ESPLÁCNICO"
  },
  {
    "codigo":15704241000119107,
    "descripcion":"ATROFIA MUSCULAR BILATERAL DE ANTEBRAZO"
  },
  {
    "codigo":86484008,
    "descripcion":"CUARTO RUIDO AURICULAR ANORMAL, R>4<"
  },
  {
    "codigo":838313006,
    "descripcion":"CAMPTODACTILIA DE DEDOS DE AMBAS MANOS"
  },
  {
    "codigo":281257007,
    "descripcion":"HUMOR HIPOMANÍACO"
  },
  {
    "codigo":836478002,
    "descripcion":"BRONQUIOLITIS OBLITERATIVA SUBAGUDA CAUSADA POR VAPORES QUÍMICOS"
  },
  {
    "codigo":770942003,
    "descripcion":"SÍNDROME DE KOSTMANN"
  },
  {
    "codigo":410494003,
    "descripcion":"UVEÍTIS POR LENTE DE CONTACTO"
  },
  {
    "codigo":246654007,
    "descripcion":"IMÁGENES VISUALES MÚLTIPLES"
  },
  {
    "codigo":82814008,
    "descripcion":"COMPLEJO DE EDIPO"
  },
  {
    "codigo":277587001,
    "descripcion":"LEUCEMIA MIELOIDE CRÓNICA JUVENIL"
  },
  {
    "codigo":1295230008,
    "descripcion":"CORDOMA POBREMENTE DIFERENCIADO"
  },
  {
    "codigo":212051005,
    "descripcion":"QUEMADURAS POR AGENTES CORROSIVOS QUE COMPROMETEN MENOS DEL 10% DE LA SUPERFICIE CORPORAL"
  },
  {
    "codigo":79144000,
    "descripcion":"GRANULOMA ACTÍNICO"
  },
  {
    "codigo":408659008,
    "descripcion":"INTEGRIDAD DE ESPÉCIMEN MESORRECTAL, INCOMPLETA"
  },
  {
    "codigo":210216000,
    "descripcion":"LESIÓN TRAUMÁTICA EXPUESTA DE VEJIGA URINARIA"
  },
  {
    "codigo":111912001,
    "descripcion":"DISENTERÍA AMEBIANA AGUDA SIN ABSCESO"
  },
  {
    "codigo":439592004,
    "descripcion":"ASPIRACIÓN TRAQUEAL"
  },
  {
    "codigo":242984003,
    "descripcion":"LESIÓN POR IMPACTO CON VEHÍCULO EN MOVIMIENTO, DE INTENCIÓN DESCONOCIDA"
  },
  {
    "codigo":13608004,
    "descripcion":"IRIDOCICLITIS POR VIRUS DEL HERPES SIMPLE"
  },
  {
    "codigo":765437001,
    "descripcion":"CONDUCTA ABUSIVA HACIA LAS PERSONAS"
  },
  {
    "codigo":110077007,
    "descripcion":"LACERACIÓN SIMPLE DEL MENTÓN"
  },
  {
    "codigo":1287890000,
    "descripcion":"OCLUSIÓN DE AMBAS ARTERIAS COMUNICANTES POSTERIORES"
  },
  {
    "codigo":698066001,
    "descripcion":"ESPACIO LIMITADO ENTRE ARCADAS DENTALES EDÉNTULAS"
  },
  {
    "codigo":208381009,
    "descripcion":"FRACTURA EXPUESTA DEL ESCAFOIDES, CINTURA ESCAFOIDEA, TRANSVERSA"
  },
  {
    "codigo":112971000119109,
    "descripcion":"ARTROSIS DE ARTICULACIÓN DE AMBOS TOBILLOS"
  },
  {
    "codigo":403154004,
    "descripcion":"QUEMADURA POR MILPIÉS"
  },
  {
    "codigo":75474006,
    "descripcion":"AUSENCIA CONGÉNITA DEL PEZÓN"
  },
  {
    "codigo":204711007,
    "descripcion":"ATRESIA DEL INTESTINO GRUESO"
  },
  {
    "codigo":332261000119105,
    "descripcion":"ESCLERITIS DE OJO DERECHO"
  },
  {
    "codigo":235644002,
    "descripcion":"TRASTORNO DEL DISPOSITIVO ANTIRREFLUJO ESOFÁGICO IMPLANTADO"
  },
  {
    "codigo":1251452003,
    "descripcion":"SÍNDROME DE DELECIÓN PROXIMAL 4Q25"
  },
  {
    "codigo":366716005,
    "descripcion":"ESTABILIDAD DE ARTICULACIÓN"
  },
  {
    "codigo":301180005,
    "descripcion":"APARATO CARDIOVASCULAR NORMAL"
  },
  {
    "codigo":10627711000119100,
    "descripcion":"FORÚNCULO DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":71804007,
    "descripcion":"PICADURA DE INSECTO VENENOSO EN LA REGIÓN ESCAPULAR, SIN INFECCIÓN"
  },
  {
    "codigo":201041001,
    "descripcion":"CALLOSIDAD EN DEDO DE PIE"
  },
  {
    "codigo":364881003,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA ALCANZAR"
  },
  {
    "codigo":1149478001,
    "descripcion":"BACTERIEMIA CAUSADA POR BACTERIAS COLIFORMES"
  },
  {
    "codigo":231974003,
    "descripcion":"PERLAS DE ELSCHING"
  },
  {
    "codigo":789030007,
    "descripcion":"REQUIERE VACUNACIÓN ANTIPAROTIDÍTICA"
  },
  {
    "codigo":262907000,
    "descripcion":"RUPTURA TRAUMÁTICA DE VEJIGA URINARIA"
  },
  {
    "codigo":721659000,
    "descripcion":"INFECCIÓN PARASITARIA QUE PRODUCE INFLAMACIÓN DEL INTESTINO DELGADO"
  },
  {
    "codigo":66299001,
    "descripcion":"FACIES ESCAFOIDEA"
  },
  {
    "codigo":199206009,
    "descripcion":"INFECCIONES URETRALES DURANTE EL EMBARAZO"
  },
  {
    "codigo":719824001,
    "descripcion":"SÍNDROME DE VICI"
  },
  {
    "codigo":228304006,
    "descripcion":"BEBE CON LOS SOCIOS"
  },
  {
    "codigo":62629000,
    "descripcion":"DIÁSTASIS DEL MÚSCULO RECTO"
  },
  {
    "codigo":160933000,
    "descripcion":"ENDEUDADO"
  },
  {
    "codigo":95397001,
    "descripcion":"NECROSIS DEL SITIO DE INYECCIÓN"
  },
  {
    "codigo":293840008,
    "descripcion":"ALERGIA A MOCLOBEMIDA"
  },
  {
    "codigo":16909081000119101,
    "descripcion":"HIDROCISTOMA APOCRINO DE PÁRPADO INFERIOR DERECHO"
  },
  {
    "codigo":292005000,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR DIAZÓXIDO"
  },
  {
    "codigo":93562000,
    "descripcion":"OSIFICACIÓN INCOMPLETA DE HUESO ALIESFENOIDAL"
  },
  {
    "codigo":423077009,
    "descripcion":"CRIBADO PARA DESARROLLO ANORMAL"
  },
  {
    "codigo":421242005,
    "descripcion":"FOLÍCULO CONJUNTIVAL"
  },
  {
    "codigo":15680281000119103,
    "descripcion":"QUERATOCONJUNTIVITIS BILATERAL POR VIRUS DEL HERPES ZÓSTER"
  },
  {
    "codigo":288335007,
    "descripcion":"DIFICULTAD PARA ELEVARSE"
  },
  {
    "codigo":253732001,
    "descripcion":"AGENESIA DE PERICARDIO"
  },
  {
    "codigo":384804002,
    "descripcion":"MARGEN LATERAL (MUCOSO\/MURAL) DE RESECCIÓN QUIRÚRGICA NO AFECTADO POR NEOPLASIA MALIGNA"
  },
  {
    "codigo":712484007,
    "descripcion":"BURSITIS DE CODO"
  },
  {
    "codigo":284665001,
    "descripcion":"ROBAR A LOS PADRES"
  },
  {
    "codigo":415737009,
    "descripcion":"ENDOFTALMITIS POR TOXOCARA"
  },
  {
    "codigo":250062002,
    "descripcion":"BRAZOS ATÁXICOS"
  },
  {
    "codigo":27921000146103,
    "descripcion":"NECESITA AYUDA PARA MANEJAR MEDICACIÓN"
  },
  {
    "codigo":84387000,
    "descripcion":"ASINTOMÁTICO"
  },
  {
    "codigo":1003726007,
    "descripcion":"CONTRACTURA EN FLEXIÓN DE ARTICULACIÓN INTERFALÁNGICA PROXIMAL DE DEDO MEÑIQUE"
  },
  {
    "codigo":446670007,
    "descripcion":"ORIFICIO AÓRTICO A LA DERECHA DEL ORIFICIO PULMONAR"
  },
  {
    "codigo":11803571000119104,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA PROXIMAL DE DEDO ÍNDICE IZQUIERDO"
  },
  {
    "codigo":248227006,
    "descripcion":"AUSENCIAS"
  },
  {
    "codigo":1264035007,
    "descripcion":"DOLOR EN MÚSCULO DE PELVIS"
  },
  {
    "codigo":1231267007,
    "descripcion":"EPENDIMOMA MALIGNO PRIMARIO DE NERVIO ÓPTICO"
  },
  {
    "codigo":770680004,
    "descripcion":"SÍNDROME TIPO PRADER-WILLI"
  },
  {
    "codigo":703309000,
    "descripcion":"HIPERTIROIDISMO GESTACIONAL FAMILIAR"
  },
  {
    "codigo":1260365000,
    "descripcion":"DISTONÍA DEBIDA A ENFERMEDAD MITOCONDRIAL"
  },
  {
    "codigo":277325005,
    "descripcion":"RUPTURA DE ANEURISMA DE ARTERIA CEREBELOSA POSTEROINFERIOR"
  },
  {
    "codigo":373794000,
    "descripcion":"DIAGNÓSTICO DE CÁNCER BASADO EN EL CERTIFICADO DE DEFUNCIÓN"
  },
  {
    "codigo":47949009,
    "descripcion":"LIBIDO NORMAL"
  },
  {
    "codigo":210440005,
    "descripcion":"HERIDA ABIERTA DE LABIO MAYOR VULVAR"
  },
  {
    "codigo":406562008,
    "descripcion":"INFECCIÓN POR BLASTOMYCES DEL SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":240887001,
    "descripcion":"PRURITO DE LOS PANADEROS"
  },
  {
    "codigo":44279002,
    "descripcion":"SUDAMINA"
  },
  {
    "codigo":77047003,
    "descripcion":"MURMULLO VESICULAR"
  },
  {
    "codigo":275490009,
    "descripcion":"CARCINOMA DE BASE DE LENGUA - CARA DORSAL"
  },
  {
    "codigo":94771004,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE BRONQUIO DEL LÓBULO INFERIOR DERECHO DEL PULMÓN"
  },
  {
    "codigo":206284006,
    "descripcion":"NEUMONÍA CONGÉNITA PRODUCIDA POR ESTREPTOCOCO HEMOLÍTICO DEL GRUPO A"
  },
  {
    "codigo":237217000,
    "descripcion":"FIBROIDES UTERINOS EN EL EMBARAZO, PARTO Y PUERPERIO"
  },
  {
    "codigo":40609001,
    "descripcion":"ENFERMEDAD INFECCIOSA EN LA MADRE QUE COMPLICA EL EMBARAZO, EL NACIMIENTO Y\/O EL PUERPERIO"
  },
  {
    "codigo":402892009,
    "descripcion":"HERPES SIMPLEX LABIAL RECURRENTE"
  },
  {
    "codigo":1254860009,
    "descripcion":"NECROSIS PARCIAL DE COLGAJO MIOCUTÁNEO"
  },
  {
    "codigo":1351329004,
    "descripcion":"INMUNODEFICIENCIA COMBINADA AUTOSÓMICA RECESIVA DEBIDA A DEFICIENCIA PARCIAL DE TRANSDUCTOR DE SEÑALES DE LA FAMILIA DE CITOCINAS PARA INTERLEUCINA 6"
  },
  {
    "codigo":38774000,
    "descripcion":"PECTUS CARINATUM"
  },
  {
    "codigo":106145009,
    "descripcion":"HALLAZGO EN EL SISTEMA NERVIOSO MOTOR"
  },
  {
    "codigo":15955021000119109,
    "descripcion":"PTOSIS DE MAMA DERECHA"
  },
  {
    "codigo":168011000,
    "descripcion":"EXAMEN DE LÍQUIDO ASCÍTICO, ANORMAL"
  },
  {
    "codigo":366454009,
    "descripcion":"RESPUESTA DE ROTACIÓN SIMULADA - HALLAZGO"
  },
  {
    "codigo":102475006,
    "descripcion":"HALLAZGO EN LA REACCIÓN DEL PACIENTE"
  },
  {
    "codigo":69707008,
    "descripcion":"QUERATINIZACIÓN ANORMAL"
  },
  {
    "codigo":715528001,
    "descripcion":"SÍNDROME DE DEGENERACIÓN COCLEOSACULAR Y CATARATAS"
  },
  {
    "codigo":299083009,
    "descripcion":"AMPLITUD DE EXTENSIÓN PASIVA DE DEDO DE LA MANO DISMINUIDA"
  },
  {
    "codigo":12242151000119106,
    "descripcion":"SÍNDROME DE LA ABERTURA DE SALIDA TORÁCICA IZQUIERDO"
  },
  {
    "codigo":461088006,
    "descripcion":"ANOMALÍA CARDIOVASCULAR DEBIDA A ORIGEN ANÓMALO DE ARTERIA CORONARIA EN ARTERIA PULMONAR"
  },
  {
    "codigo":395552006,
    "descripcion":"INVASIÓN TUMORAL VENOSA (GRANDES VASOS)\/ LINFÁTICA (PEQUEÑOS VASOS), AUSENTE"
  },
  {
    "codigo":264480008,
    "descripcion":"CONDUCTO DE GARTNER PERSISTENTE"
  },
  {
    "codigo":721397006,
    "descripcion":"SÍNDROME DEL CORDÓN POSTERIOR DE MÉDULA ESPINAL AL NIVEL DEL OCTAVO SEGMENTO CERVICAL"
  },
  {
    "codigo":293578001,
    "descripcion":"REACCIÓN ADVERSA A LA ESTREPTODORNASA ESTREPTOQUINASA"
  },
  {
    "codigo":1145546002,
    "descripcion":"INTOXICACIÓN POR ÁCIDO NICOTÍNICO"
  },
  {
    "codigo":162506004,
    "descripcion":"DOLOR PUNZANTE"
  },
  {
    "codigo":337281000119103,
    "descripcion":"ENTROPIÓN CICATRIZAL DE PÁRPADO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":129738007,
    "descripcion":"LESIÓN DEMARCADA"
  },
  {
    "codigo":424650008,
    "descripcion":"CLARIDAD DEL HABLA LIMITADA"
  },
  {
    "codigo":29599000,
    "descripcion":"ESQUIZOFRENIA INDIFERENCIADA CRÓNICA"
  },
  {
    "codigo":95135001,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL ESÓFAGO TORÁCICO"
  },
  {
    "codigo":91521000119104,
    "descripcion":"NARCOLEPSIA TIPO 2"
  },
  {
    "codigo":1074561000119104,
    "descripcion":"OSTEOARTROSIS DE ARTICULACIÓN SACROILÍACA DERECHA"
  },
  {
    "codigo":160671006,
    "descripcion":"DIETA SIN GLUTEN"
  },
  {
    "codigo":226207007,
    "descripcion":"DIETA DE TEXTURA MODIFICADA"
  },
  {
    "codigo":191604000,
    "descripcion":"TRASTORNO DEPRESIVO MAYOR, EPISODIO ÚNICO, GRAVE, CON SÍNTOMAS PSICÓTICOS"
  },
  {
    "codigo":715892002,
    "descripcion":"ONICOMICOSIS CAUSADA POR NEOSCYTALIDIUM DIMIDIATUM"
  },
  {
    "codigo":224372004,
    "descripcion":"REALIZA TRABAJO VOLUNTARIO"
  },
  {
    "codigo":27764006,
    "descripcion":"NO ACEPTACIÓN DE LA ENFERMEDAD"
  },
  {
    "codigo":93300007,
    "descripcion":"HIPOPLASIA CONGÉNITA DEL CÚBITO"
  },
  {
    "codigo":419145002,
    "descripcion":"PESADILLA"
  },
  {
    "codigo":91465007,
    "descripcion":"SÍNDROME DE MALABSORCIÓN DE ÁCIDOS BILIARES, TIPO III"
  },
  {
    "codigo":253470003,
    "descripcion":"HENDIDURA VERDADERA DE VALVA DE VÁLVULA AURICULOVENTRICULAR DERECHA"
  },
  {
    "codigo":286238004,
    "descripcion":"COORDINA EL FLUJO DE AIRE CON LA EMISIÓN DE LA VOZ"
  },
  {
    "codigo":417310005,
    "descripcion":"TENSIÓN LATERAL DE SINCONDROSIS ESFENOBASILAR"
  },
  {
    "codigo":1003464005,
    "descripcion":"DISPLASIA CORTICAL FOCAL TIPO IA"
  },
  {
    "codigo":249800009,
    "descripcion":"ACORTAMIENTO DE HUESO DEL PIE"
  },
  {
    "codigo":53192009,
    "descripcion":"ESTASIS DE VÍA BILIAR"
  },
  {
    "codigo":247965008,
    "descripcion":"LAVADO COMPULSIVO"
  },
  {
    "codigo":15931061000119103,
    "descripcion":"SARCOMA PRIMARIO DE OVARIO DERECHO"
  },
  {
    "codigo":16754006,
    "descripcion":"TRASTORNO DEL METABOLISMO DEL SELENIO"
  },
  {
    "codigo":1260103000,
    "descripcion":"TATUAJE DE COLOR ROJO DE TEJIDO BLANDO BUCAL"
  },
  {
    "codigo":14919007,
    "descripcion":"RÁNULA"
  },
  {
    "codigo":735815009,
    "descripcion":"HERIDA PUNZANTE DE MUÑECA SIN CUERPO EXTRAÑO"
  },
  {
    "codigo":111388003,
    "descripcion":"CUTIS LAXA, AUTOSÓMICO DOMINANTE"
  },
  {
    "codigo":78620007,
    "descripcion":"ABSCESO DE LA PIEL, CON LINFANGITIS"
  },
  {
    "codigo":733980007,
    "descripcion":"CARIES DENTAL ACTIVA PRIMARIA QUE SE EXTIENDE HASTA LA PULPA"
  },
  {
    "codigo":76785000,
    "descripcion":"INFESTACIÓN CAUSADA POR PSYCHODIDAE"
  },
  {
    "codigo":109553005,
    "descripcion":"QUISTE PALATINO DEL RECIÉN NACIDO"
  },
  {
    "codigo":699377006,
    "descripcion":"CONTRACCIONES OCULARES"
  },
  {
    "codigo":402630000,
    "descripcion":"ANORMALIDAD UNGUEAL INDUCIDA POR FÁRMACOS"
  },
  {
    "codigo":1156294003,
    "descripcion":"RECUENTO DE LINFOCITOS POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":304326005,
    "descripcion":"AMPLITUD DE MOVIMIENTO DE TOBILLO DISMINUIDA"
  },
  {
    "codigo":9414007,
    "descripcion":"TRASTORNO DE LA TOLERANCIA A LA GLUCOSA"
  },
  {
    "codigo":271558008,
    "descripcion":"MONONUCLEOSIS INFECCIOSA"
  },
  {
    "codigo":339791000119104,
    "descripcion":"RETRACCIÓN ANORMAL DE PÁRPADO INFERIOR IZQUIERDO"
  },
  {
    "codigo":269723006,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR ANTIRREUMÁTICO"
  },
  {
    "codigo":1077071000119105,
    "descripcion":"QUISTE ÓSEO DE MANO IZQUIERDA"
  },
  {
    "codigo":366192002,
    "descripcion":"TAMAÑO DEL MIOCARDIO DEL VENTRÍCULO DERECHO - HALLAZGO"
  },
  {
    "codigo":235120003,
    "descripcion":"HIPOPLASIA DE LA APÓFISIS CONDÍLEA MANDIBULAR"
  },
  {
    "codigo":300656003,
    "descripcion":"DIFICULTAD PARA ORGANIZAR UN VIAJE"
  },
  {
    "codigo":298821000,
    "descripcion":"AMPLITUD DE ROTACIÓN INTERNA ACTIVA DE ARTICULACIÓN DE HOMBRO, NORMAL"
  },
  {
    "codigo":724805000,
    "descripcion":"NEOPLASIA NEUROEPITELIOMATOSA MALIGNA PRIMARIA DE NERVIO PERIFÉRICO"
  },
  {
    "codigo":167749006,
    "descripcion":"GLOBULINAS EN LÍQUIDO CEFALORRAQUÍDEO DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":15986511000119108,
    "descripcion":"HIPERTROFIA CONGÉNITA DE EPITELIO PIGMENTARIO DE LA RETINA DEL OJO DERECHO"
  },
  {
    "codigo":3909009,
    "descripcion":"COEUR EN SABOT"
  },
  {
    "codigo":296986003,
    "descripcion":"SOBREDOSIS DE QUINIDINA"
  },
  {
    "codigo":722970007,
    "descripcion":"TEMBLOR DEBIDO A ABUSO DE SUSTANCIA"
  },
  {
    "codigo":34842007,
    "descripcion":"HEMORRAGIA PREPARTO"
  },
  {
    "codigo":428058009,
    "descripcion":"GESTACIÓN DE MENOS DE 9 SEMANAS"
  },
  {
    "codigo":15714281000119104,
    "descripcion":"DEDO DEL PIE IZQUIERDO EN MARTILLO ADQUIRIDO"
  },
  {
    "codigo":11782121000119104,
    "descripcion":"ESGUINCE DE CADERA DERECHA"
  },
  {
    "codigo":65775005,
    "descripcion":"FRACTURA EXPUESTA DEL EXTREMO SUPERIOR DE RADIO Y CÚBITO"
  },
  {
    "codigo":295151007,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE DEXTROMORAMIDA"
  },
  {
    "codigo":195012000,
    "descripcion":"ENDOCARDITIS ASOCIADA CON OTRO TRASTORNO"
  },
  {
    "codigo":719300001,
    "descripcion":"ATAXIA ESPINOCEREBELOSA TIPO 35"
  },
  {
    "codigo":293316007,
    "descripcion":"REACCIÓN ADVERSA A SOLUCIÓN DE ALBÚMINA"
  },
  {
    "codigo":291481000,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR GENTAMICINA"
  },
  {
    "codigo":1145284009,
    "descripcion":"CUMPLE CON PROTOCOLO DE PRUEBA DIAGNÓSTICA"
  },
  {
    "codigo":253855721000119107,
    "descripcion":"ENFERMEDAD DE CROHN DE INTESTINO DELGADO EN REMISIÓN"
  },
  {
    "codigo":1208985003,
    "descripcion":"HIPOPIGMENTACIÓN LINEAL Y ASIMETRÍA CRANEOFACIAL CON ANOMALÍAS ACRALES, OCULARES Y CEREBRALES"
  },
  {
    "codigo":193177003,
    "descripcion":"POLINEUROPATÍA EN ENFERMEDAD VASCULAR DEL COLÁGENO"
  },
  {
    "codigo":94873008,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL HUESO ILÍACO"
  },
  {
    "codigo":93038004,
    "descripcion":"CARTÍLAGO COSTAL RAMIFICADO CONGÉNITO"
  },
  {
    "codigo":420718004,
    "descripcion":"ENFERMEDAD DESMIELINIZANTE DEL SISTEMA NERVIOSO CENTRAL ASOCIADA CON SIDA"
  },
  {
    "codigo":715630006,
    "descripcion":"HIPERPIGMENTACIÓN PROGRESIVA FAMILIAR"
  },
  {
    "codigo":289646007,
    "descripcion":"ÚTERO DESVIADO HACIA LA DERECHA"
  },
  {
    "codigo":224110006,
    "descripcion":"ABANDONADO POR LOS PADRES"
  },
  {
    "codigo":255043002,
    "descripcion":"TUMOR ENDOCRINO PANCREÁTICO MIXTO"
  },
  {
    "codigo":123971006,
    "descripcion":"FRACTURA DE COLLES"
  },
  {
    "codigo":417048006,
    "descripcion":"DREPANOCITOSIS-TALASEMIA SIN CRISIS HEMOLÍTICA"
  },
  {
    "codigo":253208007,
    "descripcion":"CEJA AUSENTE"
  },
  {
    "codigo":284141000,
    "descripcion":"MUEVE EL BRAZO"
  },
  {
    "codigo":218605001,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR FENACETINA"
  },
  {
    "codigo":449816009,
    "descripcion":"OSTEONECROSIS DE CÓNDILO FEMORAL"
  },
  {
    "codigo":285976009,
    "descripcion":"DIFICULTAD PARA CONTROLAR LA TEMPERATURA DEL AGUA EN EL HOGAR"
  },
  {
    "codigo":58341661000119101,
    "descripcion":"TROMBOSIS VENOSA PROFUNDA CRÓNICA DE AMBAS VENAS PERONEAS"
  },
  {
    "codigo":251373006,
    "descripcion":"HALLAZGO DE PRUEBA GASTROINTESTINAL"
  },
  {
    "codigo":185837008,
    "descripcion":"CONTROL DE SALUD DEL ADULTO REALIZADO"
  },
  {
    "codigo":249538003,
    "descripcion":"OMBLIGO PERMEABLE"
  },
  {
    "codigo":1263511000,
    "descripcion":"COMPRESIÓN DE MÉDULA ESPINA DEBIDA A HEMORRAGIA"
  },
  {
    "codigo":282306009,
    "descripcion":"MANTIENE EL EQUILIBRIO SENTADO"
  },
  {
    "codigo":870295006,
    "descripcion":"PARKINSONISMO CAUSADO POR DISULFURO DE CARBONO"
  },
  {
    "codigo":247703006,
    "descripcion":"REACCIÓN A LSD (DIETILAMIDA DE ÁCIDO LISÉRGICO)"
  },
  {
    "codigo":49260003,
    "descripcion":"RITMO VENTRICULAR"
  },
  {
    "codigo":213100005,
    "descripcion":"AFLOJAMIENTO DE PERNO FIJADOR EXTERNO"
  },
  {
    "codigo":278636007,
    "descripcion":"PRÓTESIS DENTAL EXCESIVAMENTE GRANDE"
  },
  {
    "codigo":702785000,
    "descripcion":"LINFOMA ANAPLÁSICO DE CÉLULAS GRANDES DE TIPO T Y CÉLULAS NULAS"
  },
  {
    "codigo":1079581000119107,
    "descripcion":"CONDROSARCOMA PRIMARIO DE HUESO DE EXTREMIDAD INFERIOR IZQUIERDA"
  },
  {
    "codigo":17971005,
    "descripcion":"SEDADO"
  },
  {
    "codigo":735553005,
    "descripcion":"TRASTORNO RELACIONADO CON EL JUEGO, PREDOMINANTEMENTE FUERA DE LÍNEA"
  },
  {
    "codigo":10637751000119102,
    "descripcion":"ÚLCERA CRÓNICA DE PIEL DE TOBILLO"
  },
  {
    "codigo":80193009,
    "descripcion":"SÍNDROME POSTERIOR A CIRUGÍA GÁSTRICA"
  },
  {
    "codigo":897558001,
    "descripcion":"NEVO MELANOCÍTICO PEQUEÑO CONGÉNITO"
  },
  {
    "codigo":78358001,
    "descripcion":"ABSTINENCIA DE ANFETAMINA"
  },
  {
    "codigo":307734007,
    "descripcion":"ABORTO COMPLETO INEVITABLE COMPLICADO CON INFECCIÓN PÉLVICA Y DEL APARATO GENITAL"
  },
  {
    "codigo":109291006,
    "descripcion":"NEVO MELANOCÍTICO DE HOMBRO"
  },
  {
    "codigo":369600000,
    "descripcion":"TUMOR MALIGNO CON COMPROMISO DE ÓRGANO POR PROPAGACIÓN DIRECTA DESDE ÚTERO"
  },
  {
    "codigo":240363009,
    "descripcion":"MEGACOLON TÓXICO DEBIDO A INFECCIÓN AMEBIANA"
  },
  {
    "codigo":305899008,
    "descripcion":"VISTO POR EL SERVICIO DE CIRUGÍA PEDIÁTRICA"
  },
  {
    "codigo":238528004,
    "descripcion":"REACCIÓN ACTÍNICA"
  },
  {
    "codigo":236693000,
    "descripcion":"ESTENOSIS DE LA URETRA POSCATETERISMO"
  },
  {
    "codigo":1156032009,
    "descripcion":"VÁRICES VENOSAS EN EL PUERPERIO"
  },
  {
    "codigo":402368008,
    "descripcion":"SARCOIDOSIS ICTIOSIFORME"
  },
  {
    "codigo":125521000119101,
    "descripcion":"SÍNDROME DE TRISOMÍA COMPLETA DE CROMOSOMA 13 FETAL"
  },
  {
    "codigo":302229004,
    "descripcion":"INTOXICACIÓN ALIMENTARIA POR SALMONELLA"
  },
  {
    "codigo":1285269000,
    "descripcion":"HALLAZGO RELACIONADO CON RANGO PASIVO DE FLEXIÓN PLANTAR DE TOBILLO"
  },
  {
    "codigo":151991000119107,
    "descripcion":"SIN CUIDADOR CAPACITADO EN EL DOMICILIO"
  },
  {
    "codigo":267626000,
    "descripcion":"CATARATA HIPERMADURA"
  },
  {
    "codigo":171157009,
    "descripcion":"CRIBADO PARA DETECCIÓN DE CÁNCER DE CUELLO UTERINO - NO LOGRADO"
  },
  {
    "codigo":365930002,
    "descripcion":"INSOMNIO - HALLAZGO"
  },
  {
    "codigo":1186965009,
    "descripcion":"PERIODONTITIS EXACERBADA POR NEUTROPENIA CÍCLICA"
  },
  {
    "codigo":38250004,
    "descripcion":"TRABAJO DE PARTO INTERRUMPIDO"
  },
  {
    "codigo":300394006,
    "descripcion":"HALLAZGO RELACIONADO CON MEDICIONES DE LA MATERIA FECAL"
  },
  {
    "codigo":726378007,
    "descripcion":"DELECIÓN DE PARTE DEL CROMOSOMA 8"
  },
  {
    "codigo":1052223000,
    "descripcion":"DISFUNCIÓN LABERÍNTICA HIPOACTIVA DE OÍDO INTERNO DERECHO"
  },
  {
    "codigo":298559004,
    "descripcion":"AMPLITUD DE ROTACIÓN PASIVA HACIA LA DERECHA DE LA COLUMNA VERTEBRAL DORSAL, AUMENTADA"
  },
  {
    "codigo":724543006,
    "descripcion":"INFECCIÓN QUE OCASIONA MÚLTIPLES ABSCESOS CEREBRALES"
  },
  {
    "codigo":34580000,
    "descripcion":"ÚLCERA DUODENAL SIN HEMORRAGIA, SIN PERFORACIÓN Y SIN OBSTRUCCIÓN"
  },
  {
    "codigo":200255009,
    "descripcion":"HEMORROIDES EN PUERPERIO"
  },
  {
    "codigo":67348001,
    "descripcion":"CONCLUSIÓN DELIRANTE"
  },
  {
    "codigo":427796004,
    "descripcion":"ENCEFALITIS CAUSADA POR VIRUS HERPES SIMPLE HUMANO"
  },
  {
    "codigo":289361000119106,
    "descripcion":"RUPTURA FAMILIAR DEBIDA A RETORNO O UBICACIÓN DE NIÑO EN HOGAR SUSTITUTO"
  },
  {
    "codigo":344811000119100,
    "descripcion":"EXOSTOSIS DE AMBAS ÓRBITAS"
  },
  {
    "codigo":395028008,
    "descripcion":"OBSERVACIÓN DE ESPÉCIMEN DE PIEL"
  },
  {
    "codigo":1082091000119101,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE PIEL DE CADERA IZQUIERDA"
  },
  {
    "codigo":131049004,
    "descripcion":"NIVEL DE 17-CETOESTEROIDES POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":16755281000119108,
    "descripcion":"SANGRADO UTERINO ANORMAL POR COAGULOPATÍA"
  },
  {
    "codigo":294889009,
    "descripcion":"ALERGIA A APROTININA"
  },
  {
    "codigo":425961009,
    "descripcion":"OPACIFICACIÓN CORNEAL CAUSADA POR HERPES SIMPLE"
  },
  {
    "codigo":360425009,
    "descripcion":"COCCIDIOSIS HUMANA"
  },
  {
    "codigo":293054004,
    "descripcion":"REACCIÓN ADVERSA A LA CLORTETRACICLINA"
  },
  {
    "codigo":15690321000119109,
    "descripcion":"ARTRITIS DE AMBAS MUÑECAS CAUSADA POR BACTERIA"
  },
  {
    "codigo":260286007,
    "descripcion":"VISIÓN A DISTANCIA 3\/36"
  },
  {
    "codigo":782739000,
    "descripcion":"TRASTORNO DE LA PROTEÍNA DE UNIÓN A EMOPAMILO CON DEFECTO NEUROLÓGICO EN VARONES"
  },
  {
    "codigo":94611001,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LOS GANGLIOS LINFÁTICOS SUBMENTONIANOS"
  },
  {
    "codigo":192915005,
    "descripcion":"PARÁLISIS DE TRONCO SIMPÁTICO CERVICAL"
  },
  {
    "codigo":291219005,
    "descripcion":"INTOXICACIÓN POR ZUCLOPENTIXOL"
  },
  {
    "codigo":717203007,
    "descripcion":"GEMELLA MORBILLORUM O STREPTOCOCCUS ACIDOMINIMUS O STREPTOCOCCUS PNEUMONIAE"
  },
  {
    "codigo":95240001,
    "descripcion":"RINITIS SECA"
  },
  {
    "codigo":39541000087106,
    "descripcion":"FRACTURA DE CÓNDILO MEDIAL DE TIBIA IZQUIERDA"
  },
  {
    "codigo":47221000087109,
    "descripcion":"DISTENSIÓN DE TENDÓN DE EXTREMIDAD SUPERIOR IZQUIERDA"
  },
  {
    "codigo":289384008,
    "descripcion":"NIVEL 2 DE LA PRESENTACIÓN EN RELACIÓN CON LAS ESPINAS ISQUIÁTICAS"
  },
  {
    "codigo":92776008,
    "descripcion":"CARCINOMA IN SITU DE LA ENCÍA SUPERIOR"
  },
  {
    "codigo":27240009,
    "descripcion":"SEUDOVIRUELA BOVINA"
  },
  {
    "codigo":123709003,
    "descripcion":"DISTROFIA IDIOPÁTICA DEL PELO"
  },
  {
    "codigo":713533000,
    "descripcion":"ANEMIA HEMOLÍTICA ADQUIRIDA CONCOMITANTE CON INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":416786002,
    "descripcion":"LESIÓN PENETRANTE DEL CRISTALINO"
  },
  {
    "codigo":56338005,
    "descripcion":"FIBROSIS ESPLÉNICA"
  },
  {
    "codigo":283879004,
    "descripcion":"LESIÓN TRAUMÁTICA UROGENITAL"
  },
  {
    "codigo":708028001,
    "descripcion":"DISPLASIA ALVEOLOCAPILAR PULMONAR CONGÉNITA"
  },
  {
    "codigo":216508002,
    "descripcion":"INTOXICACIÓN ACCIDENTAL CAUSADA POR COMPUESTOS DE BROMO"
  },
  {
    "codigo":1363388001,
    "descripcion":"SINEQUIAS ANTERIORES PERIFÉRICAS EN CUADRANTE TEMPORAL DE ÁNGULO IRIDOCORNEAL DE OJO IZQUIERDO"
  },
  {
    "codigo":19900004,
    "descripcion":"VISIÓN PERIFÉRICA DISMINUIDA"
  },
  {
    "codigo":413116005,
    "descripcion":"UTILIZA ANTICONCEPCIÓN TRANSDÉRMICA"
  },
  {
    "codigo":249276005,
    "descripcion":"FALTA DE DESEO DE ORINAR"
  },
  {
    "codigo":183740004,
    "descripcion":"CONSULTA DOMICILIARIA DERMATOLÓGICA, REALIZADA"
  },
  {
    "codigo":85436005,
    "descripcion":"ENFERMEDAD POR EL VIRUS ITAQUI"
  },
  {
    "codigo":247441003,
    "descripcion":"ERITEMA"
  },
  {
    "codigo":1197713007,
    "descripcion":"FÍSTULA COLECISTOCOLÓNICA ADQUIRIDA"
  },
  {
    "codigo":1163110006,
    "descripcion":"COLITIS POR KLEBSIELLA OXYTOCA"
  },
  {
    "codigo":309307000,
    "descripcion":"DETECTADO POR CITOLOGÍA"
  },
  {
    "codigo":473147002,
    "descripcion":"MAL FUNCIONAMIENTO DE CATÉTER DE DIÁLISIS PERITONEAL"
  },
  {
    "codigo":276539003,
    "descripcion":"INGESTIÓN DE SANGRE MATERNA DEL RECIÉN NACIDO"
  },
  {
    "codigo":47163004,
    "descripcion":"EVALUACIÓN DE DISCAPACIDAD: 55%"
  },
  {
    "codigo":1259579003,
    "descripcion":"DEMENCIA DEBIDA A SÍNDROME DE BEHCET"
  },
  {
    "codigo":897296001,
    "descripcion":"SECCIÓN TRAUMÁTICA DE TENDÓN EXTENSOR DEL ANTEBRAZO"
  },
  {
    "codigo":733456002,
    "descripcion":"SÍNDROME DE PULGAR TRIFALÁNGICO Y LUXACIÓN DE RÓTULA"
  },
  {
    "codigo":274704003,
    "descripcion":"HALLAZGOS ANORMALES EN ESPECÍMENES DE ÓRGANOS DIGESTIVOS Y CAVIDAD ABDOMINAL"
  },
  {
    "codigo":373008003,
    "descripcion":"INFECCIÓN CAUSADA POR ASPERGILLUS WENTII"
  },
  {
    "codigo":45328004,
    "descripcion":"INTOXICACIÓN POR DIGITALIS PURPUREA"
  },
  {
    "codigo":240101000,
    "descripcion":"MIOPATÍA INDUCIDA POR DROGAS"
  },
  {
    "codigo":241936009,
    "descripcion":"ANAFILAXIA PRODUCIDA POR PROTEÍNA DE LECHE VACUNA"
  },
  {
    "codigo":1255909001,
    "descripcion":"LACERACIÓN DE MÚSCULO CRURAL ANTERIOR DE PIERNA"
  },
  {
    "codigo":403941005,
    "descripcion":"CILINDROMA MALIGNO DE LA PIEL"
  },
  {
    "codigo":305637006,
    "descripcion":"ATENDIDO POR UN MÉDICO DE PLANIFICACIÓN FAMILIAR"
  },
  {
    "codigo":232115006,
    "descripcion":"PARÁLISIS DE LA MIRADA HORIZONTAL"
  },
  {
    "codigo":10725009,
    "descripcion":"HIPERTENSIÓN ARTERIAL BENIGNA"
  },
  {
    "codigo":860858001,
    "descripcion":"ENFERMEDAD POR ALMACENAMIENTO DE GLUCÓGENO DEBIDA A DEFICIENCIA DE PIRUVATO CINASA MUSCULAR"
  },
  {
    "codigo":41658006,
    "descripcion":"ENUCLEACIÓN TRAUMÁTICA DEL OJO"
  },
  {
    "codigo":203663000,
    "descripcion":"ESCOLIOSIS EN LA NEUROFIBROMATOSIS"
  },
  {
    "codigo":39823006,
    "descripcion":"ATEROSCLEROSIS GENERALIZADA"
  },
  {
    "codigo":236431008,
    "descripcion":"ANURIA TRAUMÁTICA - SÍNDROME DE APLASTAMIENTO"
  },
  {
    "codigo":300132001,
    "descripcion":"SECRECIÓN DEL OÍDO"
  },
  {
    "codigo":765070521000119105,
    "descripcion":"STENT METÁLICO SIN CUBIERTA EN RAMA DE ARTERIA CORONARIA IZQUIERDA"
  },
  {
    "codigo":234596000,
    "descripcion":"DISFUNCIÓN DEL COMPLEMENTO 1Q"
  },
  {
    "codigo":1217636004,
    "descripcion":"NISTAGMO CICLOVERGENTE"
  },
  {
    "codigo":70756004,
    "descripcion":"ATRESIA BRONQUIAL CON ENFISEMA PULMONAR SEGMENTARIO"
  },
  {
    "codigo":301967008,
    "descripcion":"ORIFICIO LAGRIMAL INFERIOR DILATADO"
  },
  {
    "codigo":726116007,
    "descripcion":"ANOMALÍA CONGÉNITA DE HUESO DE CINTURA ESCAPULAR"
  },
  {
    "codigo":199993001,
    "descripcion":"TRAUMATISMO OBSTÉTRICO QUE CAUSA HEMATOMA PÉLVICO"
  },
  {
    "codigo":724281002,
    "descripcion":"SÍNDROME DE HIPOSMIA, HIPOPLASIA NASAL Y OCULAR E HIPOGONADISMO HIPOGONADOTRÓFICO"
  },
  {
    "codigo":347321000119107,
    "descripcion":"CONJUNTIVITIS FOLICULAR AGUDA DE AMBOS OJOS"
  },
  {
    "codigo":1471791000168109,
    "descripcion":"SE SIENTE INSEGURO EN SU HOGAR"
  },
  {
    "codigo":167225007,
    "descripcion":"ORINA DE LA MITAD DEL CHORRO MICCIONAL = ANORMAL"
  },
  {
    "codigo":1345038006,
    "descripcion":"ETAPA DE PREPARACIÓN DE LA DISPOSICIÓN A CAMBIAR LA CONDUCTA DE CONSUMO DE SUSTANCIAS"
  },
  {
    "codigo":296462009,
    "descripcion":"SOBREDOSIS DE ETRETINATO"
  },
  {
    "codigo":1179363003,
    "descripcion":"PÚRPURA PERINATAL MATERNA"
  },
  {
    "codigo":294627006,
    "descripcion":"ALERGIA A MALATIÓN"
  },
  {
    "codigo":63416000,
    "descripcion":"DISLALIA"
  },
  {
    "codigo":292792001,
    "descripcion":"REACCIÓN ADVERSA AL CARBÓMERO-940"
  },
  {
    "codigo":423864004,
    "descripcion":"OLVIDA COMPLETAR SU CUIDADO PERSONAL"
  },
  {
    "codigo":1208461001,
    "descripcion":"CARCINOMA UROTELIAL PLASMACITOIDE DE VEJIGA"
  },
  {
    "codigo":461000124106,
    "descripcion":"AUMENTO DE TAMAÑO DE DIALIZADOR DE HEMODIÁLISIS"
  },
  {
    "codigo":471501000124106,
    "descripcion":"CATÉTER EN NERVIO PERIFÉRICO IN SITU"
  },
  {
    "codigo":127117004,
    "descripcion":"LINFADENOPATÍA CELÍACA"
  },
  {
    "codigo":1306765002,
    "descripcion":"DESPRENDIMIENTO DE RETINA DE OJO DERECHO"
  },
  {
    "codigo":94349006,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LAS VÍAS BILIARES INTRAHEPÁTICAS"
  },
  {
    "codigo":389261002,
    "descripcion":"DISPLASIA DE GREENBERG"
  },
  {
    "codigo":190818004,
    "descripcion":"MACROGLOBULINEMIA DE WALDENSTRÖM"
  },
  {
    "codigo":254519000,
    "descripcion":"NEOPLASIA DE EPIGLOTIS INFRAHIOIDEA"
  },
  {
    "codigo":420194009,
    "descripcion":"EL MARGEN DE RESECCIÓN QUIRÚRGICA INFERIOR ES EL MARGEN NO AFECTADO MÁS CERCANO A LA NEOPLASIA MALIGNA"
  },
  {
    "codigo":90679001,
    "descripcion":"INFECCIÓN INTESTINAL MIXTA CAUSADA POR ORGANISMOS DE CLASES CESTODA Y\/O TREMATODA Y\/O DE TIPO NEMATODA"
  },
  {
    "codigo":715106008,
    "descripcion":"NO PASA DE LA SILLA A LA SILLA DE RUEDAS"
  },
  {
    "codigo":188983004,
    "descripcion":"LIPOMA DE PÁRPADO"
  },
  {
    "codigo":1237559005,
    "descripcion":"VENA VARICOSA DE PANTORRILLA DERECHA"
  },
  {
    "codigo":418359007,
    "descripcion":"EL MARGEN DE RESECCIÓN QUIRÚRGICA EXTERNO ES EL MARGEN NO AFECTADO MÁS CERCANO A LA NEOPLASIA MALIGNA"
  },
  {
    "codigo":1335863008,
    "descripcion":"ESCLERITIS IDIOPÁTICA"
  },
  {
    "codigo":187148002,
    "descripcion":"CISTICERCOSIS DE SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":449292003,
    "descripcion":"LINFOMA NO HODGKIN DE AMÍGDALA PALATINA"
  },
  {
    "codigo":1137420003,
    "descripcion":"CAPAZ DE COMUNICAR INFORMACIÓN ACERCA DEL DOLOR"
  },
  {
    "codigo":285452006,
    "descripcion":"DIFICULTAD PARA MOVER LA MANDÍBULA REPETIDAMENTE"
  },
  {
    "codigo":414689001,
    "descripcion":"UVEÍTIS ANTERIOR PRODUCIDA POR METIPRANOLOL"
  },
  {
    "codigo":246109831000119101,
    "descripcion":"LACERACIÓN DE MÚSCULO INTRÍNSECO DE DEDO ANULAR"
  },
  {
    "codigo":840673007,
    "descripcion":"CABEZA NORMAL"
  },
  {
    "codigo":609462000,
    "descripcion":"INTERRUPCIÓN INDUCIDA DEL EMBARAZO COMPLICADA POR SÍNDROME DE DESFIBRINACIÓN"
  },
  {
    "codigo":773302000,
    "descripcion":"SÍNDROME DE DISPLASIA ESPONDILOEPIMETAFISARIA Y DENTICIÓN ANORMAL"
  },
  {
    "codigo":283617009,
    "descripcion":"HERIDA POR PINCHAZO DE AGUJA EN EL DORSO DE LA MANO"
  },
  {
    "codigo":871606001,
    "descripcion":"DEFECTO DEL TABIQUE INTERVENTRICULAR CON TABIQUE DE SALIDA MAL ALINEADO EN LA PORCIÓN ANTERIOR"
  },
  {
    "codigo":249014005,
    "descripcion":"HALLAZGO RELACIONADO CON LA FORMA DEL ABDOMEN DE LA EMBARAZADA"
  },
  {
    "codigo":707766007,
    "descripcion":"MANIFESTACIÓN DE PÁNCREAS EXOCRINO CONCOMITANTE CON FIBROSIS QUÍSTICA Y DEBIDA A ELLA"
  },
  {
    "codigo":1363126009,
    "descripcion":"REACCIÓN ADVERSA A AGENTE HIPOGLUCEMIANTE DE BIGUANIDA"
  },
  {
    "codigo":247179001,
    "descripcion":"DRUSAS PERIFÉRICAS"
  },
  {
    "codigo":15724321000119100,
    "descripcion":"TRASTORNO DE ENTESIS DE DEDO DE PIE IZQUIERDO"
  },
  {
    "codigo":79669001,
    "descripcion":"INTOXICACIÓN POR NUEZ MOHOSA"
  },
  {
    "codigo":1087111000119107,
    "descripcion":"INFECCIÓN DE LA PIEL PERIANAL CAUSADA POR VIRUS DEL HERPES SIMPLE"
  },
  {
    "codigo":276277008,
    "descripcion":"HEMORRAGIA SUBARACNOIDEA PROVENIENTE DE MÚLTIPLES ANEURISMAS"
  },
  {
    "codigo":866101009,
    "descripcion":"NEVO DE LA UNIÓN DERMOEPIDÉRMICA DE PÁRPADO"
  },
  {
    "codigo":1259317009,
    "descripcion":"CARCINOMA PRIMARIO DE LÍNEA MEDIA DE LENGUA"
  },
  {
    "codigo":307210003,
    "descripcion":"SEUDOARTROSIS DE INJERTO ÓSEO"
  },
  {
    "codigo":897034005,
    "descripcion":"ANTICUERPOS CONTRA SARS-COV-2 DETECTADOS"
  },
  {
    "codigo":1290250005,
    "descripcion":"NECROSIS TISULAR DE PIE DEBIDA A CONGELAMIENTO Y POSTERIOR A ÉL"
  },
  {
    "codigo":733194007,
    "descripcion":"DEMENCIA CONCOMITANTE CON SÍNDROME DE DOWN Y DEBIDA A ÉL"
  },
  {
    "codigo":208906006,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA NO EXPUESTA DE LA ARTICULACIÓN DE LA CADERA, POSTERIOR"
  },
  {
    "codigo":239839002,
    "descripcion":"CONDROCALCINOSIS IDIOPÁTICA"
  },
  {
    "codigo":403679002,
    "descripcion":"DEFORMACIÓN EN CONCAVIDAD DE COLGAJO DE PIEL"
  },
  {
    "codigo":43231004,
    "descripcion":"CÓLICO ESOFÁGICO"
  },
  {
    "codigo":698591006,
    "descripcion":"ENFERMEDAD RENAL HIPERTENSIVA BENIGNA CON INSUFICIENCIA RENAL"
  },
  {
    "codigo":1255647008,
    "descripcion":"CARCINOMA ESCAMOSO BASALOIDE DE LARINGE"
  },
  {
    "codigo":8628002,
    "descripcion":"VAGINITIS ENFISEMATOSA"
  },
  {
    "codigo":762292004,
    "descripcion":"HIPERGLUCEMIA NEONATAL DEBIDA A TRATAMIENTO INTRAVENOSO IATROGÉNICO"
  },
  {
    "codigo":238004006,
    "descripcion":"DEFICIENCIA DE SUCCINIL-COA ACETOACETATO TRANSFERASA"
  },
  {
    "codigo":860596009,
    "descripcion":"GANGRENA DE MESENTERIO DE INTESTINO DELGADO"
  },
  {
    "codigo":432777003,
    "descripcion":"RECHAZO ACELERADO DE TRASPLANTE HEPÁTICO"
  },
  {
    "codigo":170633004,
    "descripcion":"ALTERACIÓN SEMANAL DEL SUEÑO POR ASMA"
  },
  {
    "codigo":103262002,
    "descripcion":"MIRADA FIJA"
  },
  {
    "codigo":267102003,
    "descripcion":"GARGANTA IRRITADA"
  },
  {
    "codigo":1217374002,
    "descripcion":"CONDUCTA DE ALIMENTACIÓN RESTRINGIDA"
  },
  {
    "codigo":299870007,
    "descripcion":"REFLEJO BULBOCAVERNOSO NEGATIVO"
  },
  {
    "codigo":365406008,
    "descripcion":"HALLAZGO RELACIONADO CON LA PROFUNDIDAD DE LA ANESTESIA"
  },
  {
    "codigo":201566007,
    "descripcion":"ARTRITIS REACTIVA DE ARTICULACIÓN INTERFALÁNGICA DISTAL DE DEDO DE MANO"
  },
  {
    "codigo":68659002,
    "descripcion":"BLEFAROCONJUNTIVITIS"
  },
  {
    "codigo":166963002,
    "descripcion":"NIVEL DE DIGOXINA POR ENCIMA DEL RANGO TERAPÉUTICO"
  },
  {
    "codigo":16697871000119100,
    "descripcion":"SÍNDROME DE ACTIVACIÓN DE MASTOCITOS"
  },
  {
    "codigo":1074191000119100,
    "descripcion":"CONDROCALCINOSIS DE PIE DERECHO"
  },
  {
    "codigo":313871000119102,
    "descripcion":"ATROFIA DE MÚSCULO QUE ACTÚA SOBRE ARTICULACIÓN DE TOBILLO DERECHO"
  },
  {
    "codigo":10628111000119100,
    "descripcion":"CARBUNCO DE PIE DERECHO"
  },
  {
    "codigo":306191000119101,
    "descripcion":"GOTA TOFÁCEA CRÓNICA DE CADERA CAUSADA POR FÁRMACO"
  },
  {
    "codigo":68111000119105,
    "descripcion":"PARÁLISIS FACIAL GRADO I DE HOUSE-BRACKMANN"
  },
  {
    "codigo":342031000119105,
    "descripcion":"PIGMENTACIÓN CORNEAL ANTERIOR IZQUIERDA"
  },
  {
    "codigo":288271000119103,
    "descripcion":"TRASTORNO DE LA FLUIDEZ, DE INICIO EN LA INFANCIA"
  },
  {
    "codigo":10656271000119102,
    "descripcion":"ÚLCERA DE PIEL DE DEDO DE PIE DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":10679311000119108,
    "descripcion":"TUMEFACCIÓN LOCALIZADA BILATERAL DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":11826191000119108,
    "descripcion":"RUPTURA TRAUMÁTICA DE TENDÓN DE MÚSCULO ADUCTOR DE CADERA DERECHA"
  },
  {
    "codigo":15986191000119105,
    "descripcion":"COLOBOMA CONGÉNITO DE PAPILA ÓPTICA IZQUIERDA"
  },
  {
    "codigo":10640911000119103,
    "descripcion":"NECROSIS DE MÚSCULO DE LA PANTORRILLA CONCOMITANTE CON ÚLCERA CRÓNICA DE PANTORRILLA Y DEBIDA A ELLA"
  },
  {
    "codigo":16009231000119104,
    "descripcion":"DEFORMIDAD CONGÉNITA DE HUESO DE ANTEBRAZO DERECHO"
  },
  {
    "codigo":11847611000119107,
    "descripcion":"CUERPO EXTRAÑO EN MEMBRANA MUCOSA DE LA LENGUA"
  },
  {
    "codigo":1092111000119108,
    "descripcion":"ESTENOSIS DE CONDUCTO AUDITIVO EXTERNO DERECHO DEBIDO A Y DESPUÉS DE INFECCIÓN"
  },
  {
    "codigo":132111000119107,
    "descripcion":"TROMBOSIS VENOSA PROFUNDA AGUDA DE MIEMBRO INFERIOR DEBIDA A Y DESPUÉS DE INJERTO-PUENTE DE ARTERIA CORONARIA"
  },
  {
    "codigo":16774671000119108,
    "descripcion":"CARCINOMA BASOCELULAR PRIMARIO DE PIEL DE LABIO MAYOR DE LA VULVA"
  },
  {
    "codigo":720349002,
    "descripcion":"SECUELAS DE ENFERMEDAD INFECCIOSA"
  },
  {
    "codigo":294365005,
    "descripcion":"ALERGIA A FLUCONAZOL"
  },
  {
    "codigo":230664009,
    "descripcion":"HIPOTENSIÓN ORTOSTÁTICA SIMPATOTÓNICA"
  },
  {
    "codigo":785885002,
    "descripcion":"DESGARRO DE RETINA DE OJO IZQUIERDO"
  },
  {
    "codigo":352341000119101,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE CORDÓN ESPERMÁTICO DERECHO"
  },
  {
    "codigo":390834004,
    "descripcion":"RETINOPATÍA NO PROLIFERATIVA DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":1089621000119103,
    "descripcion":"ACÚFENO PULSÁTIL SUBJECTIVO DEL OÍDO IZQUIERDO"
  },
  {
    "codigo":292530005,
    "descripcion":"REACCIÓN ADVERSA AL CLORURO DE LAQUESINA"
  },
  {
    "codigo":1144498009,
    "descripcion":"CONSOLIDACIÓN DEFECTUOSA DE FRACTURA DE PELVIS Y FÉMUR"
  },
  {
    "codigo":126855001,
    "descripcion":"NEOPLASIA DE LAS VÍAS BILIARES EXTRAHEPÁTICAS"
  },
  {
    "codigo":288860000,
    "descripcion":"INCAPAZ DE BEBER DE UN BEBEDERO"
  },
  {
    "codigo":94087009,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE TESTÍCULO"
  },
  {
    "codigo":59484000,
    "descripcion":"POLIARTRITIS POR CLAMIDIAS"
  },
  {
    "codigo":1306503009,
    "descripcion":"CARCINOMA DUCTAL INFILTRANTE PRIMARIO DE CUADRANTE INFERIOR INTERNO DE MAMA"
  },
  {
    "codigo":92252004,
    "descripcion":"NEOPLASIA BENIGNA DE HUESO OCCIPITAL"
  },
  {
    "codigo":24881000,
    "descripcion":"FACIES MIASTÉNICA"
  },
  {
    "codigo":385329005,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA DE EPIPLÓN MENOR AFECTADO POR NEOPLASIA MALIGNA"
  },
  {
    "codigo":1237297006,
    "descripcion":"ARTROFIBROSIS DE TOBILLO"
  },
  {
    "codigo":287025008,
    "descripcion":"BURSITIS DE BOLSA SEROSA DE TOBILLO O PIE"
  },
  {
    "codigo":711174000,
    "descripcion":"CARIES INTERPROXIMAL DEL ESMALTE"
  },
  {
    "codigo":1299163000,
    "descripcion":"DISPLASIA CONGÉNITA DE ARTICULACIÓN DE PIE"
  },
  {
    "codigo":285190008,
    "descripcion":"CAPAZ DE RECORDAR EL DÍA DE LA SEMANA"
  },
  {
    "codigo":283355005,
    "descripcion":"LACERACIÓN DE LA CAVIDAD BUCAL"
  },
  {
    "codigo":281520000,
    "descripcion":"DERRAME TRAUMÁTICO DE ARTICULACIÓN DE CODO"
  },
  {
    "codigo":707504005,
    "descripcion":"SANGRADO POR URETRA MASCULINA"
  },
  {
    "codigo":83077003,
    "descripcion":"ALTA ESTATURA PARA LA EDAD"
  },
  {
    "codigo":312453004,
    "descripcion":"ASMA - ACTUALMENTE EN ACTIVIDAD"
  },
  {
    "codigo":115845005,
    "descripcion":"FENOTIPO MCLEOD"
  },
  {
    "codigo":1295493009,
    "descripcion":"HIPERTENSIÓN OCULAR DE OJO IZQUIERDO"
  },
  {
    "codigo":441690002,
    "descripcion":"HIPERGLUCEMIA MEDICAMENTOSA"
  },
  {
    "codigo":277850002,
    "descripcion":"SÍNDROME DE DIÓGENES"
  },
  {
    "codigo":212314008,
    "descripcion":"LESIÓN ABIERTA DE NERVIO CRURAL"
  },
  {
    "codigo":46639003,
    "descripcion":"LESIÓN TRAUMÁTICA DE TOBILLO EN SUPINACIÓN-ADUCCIÓN"
  },
  {
    "codigo":439855007,
    "descripcion":"EXTENDIDO DE PAPANICOLAOU ANAL ANORMAL"
  },
  {
    "codigo":79407008,
    "descripcion":"TALIPES ASIMÉTRICO"
  },
  {
    "codigo":274180001,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE CARA"
  },
  {
    "codigo":1259055009,
    "descripcion":"TRASTORNO DE SISTEMA NERVIOSO AUTÓNOMO DEBIDO A LEPRA"
  },
  {
    "codigo":732932004,
    "descripcion":"PARAPLEJÍA ESPÁSTICA AUTOSÓMICA RECESIVA TIPO 18"
  },
  {
    "codigo":306948005,
    "descripcion":"ARITENOIDES FIJO"
  },
  {
    "codigo":110340007,
    "descripcion":"PÉRDIDA DEL PUNTEADO GINGIVAL"
  },
  {
    "codigo":77572008,
    "descripcion":"MÚLTIPLES FRACTURAS EXPUESTAS DE MIEMBRO INFERIOR Y ESTERNÓN"
  },
  {
    "codigo":403417001,
    "descripcion":"PANICULITIS CALCIFICANTE POR HIPERPARATIROIDISMO"
  },
  {
    "codigo":1255385002,
    "descripcion":"RABDOMIOSARCOMA DE ENDOMETRIO DE CUERPO DE ÚTERO"
  },
  {
    "codigo":354851000119101,
    "descripcion":"LINFOMA NO-HODGKIN FOLICULAR DE GANGLIOS LINFÁTICOS DE MÚLTIPLES LOCALIZACIONES"
  },
  {
    "codigo":763865009,
    "descripcion":"ASTROCITOMA PILOCÍTICO"
  },
  {
    "codigo":204974003,
    "descripcion":"URÉTER IMPERMEABLE"
  },
  {
    "codigo":1092131000119103,
    "descripcion":"ESTENOSIS TRAUMÁTICA DE CONDUCTO AUDITIVO EXTERNO DERECHO"
  },
  {
    "codigo":1351854006,
    "descripcion":"SÍNDROME DE HIPOMAGNESEMIA PRIMARIA, CRISIS CONVULSIVAS GENERALIZADAS, DISCAPACIDAD INTELECTUAL Y OBESIDAD"
  },
  {
    "codigo":270510008,
    "descripcion":"COMUNICACIÓN ANÓMALA DE ARTERIA CORONARIA"
  },
  {
    "codigo":237742008,
    "descripcion":"HIPERALDOSTERONISMO PRIMARIO POR HIPERPLASIA"
  },
  {
    "codigo":1153411004,
    "descripcion":"ESPONDILOARTRITIS FÚNGICA"
  },
  {
    "codigo":366979004,
    "descripcion":"ESTADO DE ÁNIMO DEPRIMIDO"
  },
  {
    "codigo":301443008,
    "descripcion":"CAPAZ DE UTILIZAR INSTALACIONES EDUCATIVAS"
  },
  {
    "codigo":103000001,
    "descripcion":"CRIMODINIA"
  },
  {
    "codigo":234072000,
    "descripcion":"HIPERTENSIÓN VENOSA"
  },
  {
    "codigo":299608003,
    "descripcion":"AMPLITUD DE ABDUCCIÓN ACTIVA DE DEDO DEL PIE AUMENTADA"
  },
  {
    "codigo":365144007,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA REALIZAR ACTIVIDADES GENERALES QUE INVOLUCRAN MANIPULACIÓN"
  },
  {
    "codigo":35629000,
    "descripcion":"CICATRIZ DISEMINADA DE LA RETINA Y DE LA COROIDES"
  },
  {
    "codigo":725592009,
    "descripcion":"NEFROPATÍA MEMBRANOSA CONGÉNITA DEBIDA A ALOINMUNIZACIÓN MATERNA CONTRA ENDOPEPTIDASA NEUTRA"
  },
  {
    "codigo":16466621000119101,
    "descripcion":"MELORREOSTOSIS DE REGIÓN DE HOMBRO DERECHO"
  },
  {
    "codigo":232237007,
    "descripcion":"OTITIS CRÓNICA EXTERNA POR RADIACIÓN"
  },
  {
    "codigo":230402000,
    "descripcion":"CISTITIS PANMURAL"
  },
  {
    "codigo":166701009,
    "descripcion":"NIVEL DE CALCIO SÉRICO DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":263170006,
    "descripcion":"FRACTURA DE REBORDE SUPRAORBITARIO"
  },
  {
    "codigo":164866006,
    "descripcion":"ELECTROCARDIOGRAMA: SIN INFARTO MIOCÁRDICO"
  },
  {
    "codigo":294103005,
    "descripcion":"ALERGIA A BERACTANT"
  },
  {
    "codigo":64727007,
    "descripcion":"URÉTER ACCESORIO"
  },
  {
    "codigo":328381000119105,
    "descripcion":"PANCITOPENIA CAUSADA POR ANTICONVULSIVANTE"
  },
  {
    "codigo":95660002,
    "descripcion":"CEFALEA POR ESTALLIDO"
  },
  {
    "codigo":30124006,
    "descripcion":"RUPTURA DE RIÑÓN"
  },
  {
    "codigo":290433000,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR DANTRÓN"
  },
  {
    "codigo":126593004,
    "descripcion":"NEOPLASIA DEL PRIMER HUESO CUNEIFORME DEL PIE"
  },
  {
    "codigo":716417006,
    "descripcion":"CAPAZ DE MANEJAR EL DOLOR GENERALIZADO"
  },
  {
    "codigo":93825008,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL CORAZÓN"
  },
  {
    "codigo":224897008,
    "descripcion":"INVOLUCRADO EN PROCEDIMIENTOS LEGALES PENALES"
  },
  {
    "codigo":91990002,
    "descripcion":"NEOPLASIA BENIGNA DE LA BASE DE LA LENGUA"
  },
  {
    "codigo":190294007,
    "descripcion":"TIROIDITIS AGUDA NO SUPURATIVA"
  },
  {
    "codigo":286763000,
    "descripcion":"CARÁCTER MODESTO"
  },
  {
    "codigo":253995005,
    "descripcion":"PALADAR HENDIDO INCOMPLETO DEL PALAR BLANDO Y DURO"
  },
  {
    "codigo":1237035007,
    "descripcion":"METÁSTASIS DE CARCINOMA DE GLÁNDULA PARÓTIDA"
  },
  {
    "codigo":284928000,
    "descripcion":"UTILIZA ORINAL DE CAMA"
  },
  {
    "codigo":22784002,
    "descripcion":"ESCLERODERMIA LINEAL"
  },
  {
    "codigo":448768004,
    "descripcion":"LESIÓN TRAUMÁTICA DE VEJIGA Y URETRA"
  },
  {
    "codigo":186624004,
    "descripcion":"COMA HEPÁTICO DEBIDO A HEPATITIS B AGUDA CON AGENTE DELTA"
  },
  {
    "codigo":88320008,
    "descripcion":"TOLERANCIA FARMACOLÓGICA"
  },
  {
    "codigo":446933000,
    "descripcion":"ESTEATONECROSIS DE TEJIDO CELULAR SUBCUTÁNEO"
  },
  {
    "codigo":283093005,
    "descripcion":"EXCORIACIÓN DE REGIÓN PÉLVICA"
  },
  {
    "codigo":16030551000119108,
    "descripcion":"OSTEOMIELITIS SUBAGUDA DE HUESO TIBIAL IZQUIERDO"
  },
  {
    "codigo":445098000,
    "descripcion":"ABSCESO AGUDO DE PIEL Y\/O TEJIDO CELULAR SUBCUTÁNEO"
  },
  {
    "codigo":86485009,
    "descripcion":"DESVIACIÓN DISOCIADA"
  },
  {
    "codigo":1264298001,
    "descripcion":"AMPOLLA TRAUMÁTICA DE PARED POSTERIOR DE TÓRAX"
  },
  {
    "codigo":838314000,
    "descripcion":"ARTERIOLOPATÍA CÁLCICA DEBIDA A UREMIA"
  },
  {
    "codigo":314026007,
    "descripcion":"DESPRENDIMIENTO DEL EPITELIO PIGMENTARIO DE LA RETINA, ZONA AVASCULAR"
  },
  {
    "codigo":51882009,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN LA REGIÓN INTERESCAPULAR, CON INFECCIÓN"
  },
  {
    "codigo":410495002,
    "descripcion":"ENDOFTALMITIS POSOPERATORIA CAUSADA POR PROPIONIBACTERIUM ACNES"
  },
  {
    "codigo":15676401000119104,
    "descripcion":"TENDINITIS DE TENDÓN FLEXOR DE MANO IZQUIERDA"
  },
  {
    "codigo":836479005,
    "descripcion":"BRONQUIOLITIS OBLITERATIVA SUBAGUDA CAUSADA POR VAPOR"
  },
  {
    "codigo":1295231007,
    "descripcion":"TUMOR DE SPITZ MALIGNO"
  },
  {
    "codigo":770943008,
    "descripcion":"SÍNDROME DE DISPLASIA DE DENTINA CON HUESOS ESCLERÓTICOS"
  },
  {
    "codigo":15444000,
    "descripcion":"LORDOSIS POSTURAL ADQUIRIDA"
  },
  {
    "codigo":246655008,
    "descripcion":"DIPLOPÍA CON AMBOS OJOS ABIERTOS"
  },
  {
    "codigo":80980003,
    "descripcion":"FRACTURA EXPUESTA A NIVEL DE C5 - C7 CON LESIÓN TRAUMÁTICA DE LA MÉDULA ESPINAL"
  },
  {
    "codigo":769108003,
    "descripcion":"HALLAZGO RELACIONADO CON LA PRESENCIA DE LEVADURA EN GEMACIÓN CON BASE ANCHA Y DOBLE PARED"
  },
  {
    "codigo":1162324007,
    "descripcion":"OSTEONECROSIS DE MÚLTIPLES SITIOS DEBIDA A HEMOGLOBINOPATÍA"
  },
  {
    "codigo":242985002,
    "descripcion":"LESIÓN POR IMPACTO CON VEHÍCULO DE MOTOR EN MOVIMIENTO, DE INTENCIÓN DESCONOCIDA"
  },
  {
    "codigo":210217009,
    "descripcion":"LESIÓN EXPUESTA DE LA URETRA"
  },
  {
    "codigo":439593009,
    "descripcion":"RIGIDEZ ABDOMINAL DEL CUADRANTE INFERIOR IZQUIERDO"
  },
  {
    "codigo":208382002,
    "descripcion":"FRACTURA EXPUESTA DE ESCAFOIDES, CINTURA ESCAFOIDEA, OBLICUA"
  },
  {
    "codigo":110078002,
    "descripcion":"LACERACIÓN SIMPLE CONTAMINADA DEL MENTÓN"
  },
  {
    "codigo":650284171000119103,
    "descripcion":"SUBLUXACIÓN ANTERIOR DE CABEZA DE RADIO"
  },
  {
    "codigo":765438006,
    "descripcion":"CONDUCTA ABUSIVA HACIA LOS ANIMALES"
  },
  {
    "codigo":403155003,
    "descripcion":"DERMATOSIS CAUSADA POR ECHINOIDEA"
  },
  {
    "codigo":1156819003,
    "descripcion":"ARTRITIS IDIOPÁTICA JUVENIL NEGATIVA PARA ANTICUERPOS ANTINUCLEARES DE INICIO OLIGOARTICULAR EXTENDIDO"
  },
  {
    "codigo":698067005,
    "descripcion":"RELACIÓN MAXILOMANDIBULAR CLASE I EN PACIENTE EDÉNTULO"
  },
  {
    "codigo":204712000,
    "descripcion":"ATRESIA ANAL"
  },
  {
    "codigo":1351592004,
    "descripcion":"SÍNDROME DE AUTODESTILACIÓN ALCOHÓLICA"
  },
  {
    "codigo":235645001,
    "descripcion":"DESPLAZAMIENTO DE DISPOSITIVO ANTIRREFLUJO ESOFÁGICO"
  },
  {
    "codigo":399485005,
    "descripcion":"LINFOMA QUE COMPROMETE PARED MUSCULAR Y\/O SUBSEROSA"
  },
  {
    "codigo":170109006,
    "descripcion":"EXAMEN DEL NIÑO A LOS 10 DÍAS: NORMAL"
  },
  {
    "codigo":1251453008,
    "descripcion":"SÍNDROME DE LAMB SHAFFER"
  },
  {
    "codigo":301181009,
    "descripcion":"PROBLEMA EN EL APARATO CARDIOVASCULAR"
  },
  {
    "codigo":299346000,
    "descripcion":"AMPLITUD DE EXTENSIÓN ACTIVA DE LA RODILLA NORMAL"
  },
  {
    "codigo":266578003,
    "descripcion":"QUISTE SOLITARIO DE MAMA"
  },
  {
    "codigo":364882005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA EMPUJAR"
  },
  {
    "codigo":4434006,
    "descripcion":"SÍNDROME DE BLOOM"
  },
  {
    "codigo":168274006,
    "descripcion":"TÍTULOS DE MYCOPLASMA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":201042008,
    "descripcion":"CALLOSIDAD ENTRE DEDOS DEL PIE"
  },
  {
    "codigo":233810009,
    "descripcion":"LESIÓN TRAUMÁTICA PULMONAR DIRECTA AGUDA"
  },
  {
    "codigo":231975002,
    "descripcion":"EXFOLIACIÓN DE LA CÁPSULA DEL CRISTALINO"
  },
  {
    "codigo":789031006,
    "descripcion":"REQUIERE VACUNACIÓN ANTICOQUELUCHE"
  },
  {
    "codigo":1149479009,
    "descripcion":"BACTERIEMIA CAUSADA POR CLOSTRIDIUM"
  },
  {
    "codigo":721660005,
    "descripcion":"ENTERITIS DE INTESTINO DELGADO POR RADIACIÓN"
  },
  {
    "codigo":719825000,
    "descripcion":"SÍNDROME DE DISCAPACIDAD INTELECTUAL LIGADA AL CROMOSOMA X, MACROCEFALIA Y MACROORQUIDIA"
  },
  {
    "codigo":361212009,
    "descripcion":"PÉNFIGO VULGAR ORAL"
  },
  {
    "codigo":295676009,
    "descripcion":"SOBREDOSIS DE ACLARRUBICINA"
  },
  {
    "codigo":64465004,
    "descripcion":"SÍNDROME DE HIPERNASALIDAD POR ENFERMEDAD NEUROLÓGICA"
  },
  {
    "codigo":228305007,
    "descripcion":"BEBE CON CONOCIDOS"
  },
  {
    "codigo":29862005,
    "descripcion":"HERNIA PARAUMBILICAL"
  },
  {
    "codigo":95398006,
    "descripcion":"ANESTESIA EN EL SITIO DE INYECCIÓN"
  },
  {
    "codigo":160934006,
    "descripcion":"CAMBIO RELATIVO A LA SITUACIÓN FINANCIERA"
  },
  {
    "codigo":421243000,
    "descripcion":"ELEVACIÓN PRECORDIAL"
  },
  {
    "codigo":290171000,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR METADONA"
  },
  {
    "codigo":687551000119105,
    "descripcion":"NEVO EPIDÉRMICO PILOSO PIGMENTADO DE CUELLO"
  },
  {
    "codigo":10681791000119105,
    "descripcion":"MASA DE PIEL DE DEDO DE AMBOS PIES"
  },
  {
    "codigo":124496006,
    "descripcion":"DEFICIENCIA DE TROMBINA"
  },
  {
    "codigo":89893000,
    "descripcion":"RETRASO DEL PARPADEO"
  },
  {
    "codigo":417573001,
    "descripcion":"INFECCIÓN POR VIRUS DE LA ENCEFALITIS EQUINA DEL ESTE NO NEUROINVASIVA"
  },
  {
    "codigo":778021002,
    "descripcion":"SÍNDROME DE MICROFTALMÍA, RETINITIS PIGMENTARIA, FOVEOSQUISIS, DRUSAS PAPILARES"
  },
  {
    "codigo":253733006,
    "descripcion":"QUISTE PLEUROPERICÁRDICO"
  },
  {
    "codigo":16006591000119109,
    "descripcion":"GOTA TOFÁCEA CRÓNICA DE MANO IZQUIERDA"
  },
  {
    "codigo":333401000119104,
    "descripcion":"PANOFTALMITIS DE OJO DERECHO"
  },
  {
    "codigo":413903006,
    "descripcion":"AFECCIÓN DE CAUSA LABORAL"
  },
  {
    "codigo":250063007,
    "descripcion":"PRUEBA ÍNDICE-NARIZ ANORMAL"
  },
  {
    "codigo":315599008,
    "descripcion":"ATENDIDO EN CONSULTORIO ESPECIALIZADO EN JÓVENES"
  },
  {
    "codigo":248228001,
    "descripcion":"LIPOTIMIA"
  },
  {
    "codigo":1264036008,
    "descripcion":"INFLAMACIÓN DE MÚSCULO DE MUSLO"
  },
  {
    "codigo":443001001,
    "descripcion":"CONDROCALCINOSIS DE ARTICULACIÓN DE CODO"
  },
  {
    "codigo":770681000,
    "descripcion":"SÍNDROME DE SECUENCIA DE PIERRE ROBIN Y OLIGODACTILIA"
  },
  {
    "codigo":15182000,
    "descripcion":"SÍNDROME DE COFFIN - LOWRY"
  },
  {
    "codigo":306931000119102,
    "descripcion":"DERRAME ARTICULAR DE CODO DERECHO"
  },
  {
    "codigo":1260366004,
    "descripcion":"DISTONÍA DEBIDA A ENFERMEDAD DE NIEMANN-PICK TIPO C"
  },
  {
    "codigo":703310005,
    "descripcion":"NEFROPATÍA PROGRESIVA AUTOSÓMICA DOMINANTE CON HIPERTENSIÓN"
  },
  {
    "codigo":277326006,
    "descripcion":"RUPTURA DE LA MÉDULA ESPINAL"
  },
  {
    "codigo":768846004,
    "descripcion":"TRASTORNO CONGÉNITO DE LA DESGLUCOSILACIÓN DE N-GLUCANASA 1"
  },
  {
    "codigo":1293134007,
    "descripcion":"HEMANGIOENDOTELIOMA COMPUESTO NEUROENDOCRINO"
  },
  {
    "codigo":406563003,
    "descripcion":"INFECCIÓN DEL SISTEMA NERVIOSO CENTRAL POR BORRELIA"
  },
  {
    "codigo":373795004,
    "descripcion":"DIAGNÓSTICO DE CÁNCER BASADO EN LA EVIDENCIA MÉDICA"
  },
  {
    "codigo":275491008,
    "descripcion":"NEOPLASIA BENIGNA DE CARA DORSAL DE BASE DE LENGUA"
  },
  {
    "codigo":111651008,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE HUESO NAVICULAR DE PIE"
  },
  {
    "codigo":109816005,
    "descripcion":"HERNIA FORAMINAL A TRAVÉS DEL AGUJERO EPIPLOICO"
  },
  {
    "codigo":11512006,
    "descripcion":"FUNCIÓN SEXUAL NORMAL"
  },
  {
    "codigo":765176007,
    "descripcion":"PSICOSIS Y DEPRESIÓN SEVERA CONCOMITANTE CON TRASTORNO AFECTIVO BIPOLAR DEBIDA A ELLA"
  },
  {
    "codigo":240888006,
    "descripcion":"PRURITO POR COPRA"
  },
  {
    "codigo":239053003,
    "descripcion":"PLIEGUES ANULARES BENIGNOS MÚLTIPLES DE LAS EXTREMIDADES"
  },
  {
    "codigo":402893004,
    "descripcion":"INFECCIÓN RECURRENTE DE LA REGIÓN PERIANAL POR HERPES SIMPLEX"
  },
  {
    "codigo":206285007,
    "descripcion":"NEUMONÍA CONGÉNITA PRODUCIDA POR ESTREPTOCOCO HEMOLÍTICO DEL GRUPO B"
  },
  {
    "codigo":1254861008,
    "descripcion":"PSEUDOXANTOMA ELÁSTICO PERFORANTE ADQUIRIDO DE REGIÓN PERIUMBILICAL"
  },
  {
    "codigo":827042001,
    "descripcion":"ÍNDICE DE PRESIÓN ARTERIAL NORMAL"
  },
  {
    "codigo":106146005,
    "descripcion":"HALLAZGO EN LOS REFLEJOS"
  },
  {
    "codigo":40610006,
    "descripcion":"INFECCIÓN POR ARBOVIRUS"
  },
  {
    "codigo":15927181000119103,
    "descripcion":"LESIÓN DE PÁRPADO DERECHO"
  },
  {
    "codigo":401058009,
    "descripcion":"NECESITA AYUDA PARA ADMINISTRAR SUS PROPIOS ASUNTOS FINANCIEROS"
  },
  {
    "codigo":399223003,
    "descripcion":"PACIENTE APTO PARA ENSAYO CLÍNICO"
  },
  {
    "codigo":366455005,
    "descripcion":"HALLAZGO RELACIONADO CON LA PRUEBA DEL HUNDIMIENTO"
  },
  {
    "codigo":202615006,
    "descripcion":"CHASQUIDO DE PRIMERA ARTICULACIÓN METATARSOFALÁNGICA"
  },
  {
    "codigo":300919005,
    "descripcion":"TROMBOSIS ARTERIAL DIGITAL"
  },
  {
    "codigo":299084003,
    "descripcion":"SIN AMPLITUD PASIVA DE EXTENSIÓN DE DEDO DE LA MANO"
  },
  {
    "codigo":102476007,
    "descripcion":"REACCIÓN ANORMAL DEL PACIENTE"
  },
  {
    "codigo":461089003,
    "descripcion":"ANOMALÍA CARDÍACA DEBIDA A ABSCESO CARDÍACO"
  },
  {
    "codigo":67873006,
    "descripcion":"HIPOPROLACTINEMIA"
  },
  {
    "codigo":10657831000119102,
    "descripcion":"ÚLCERA NEUROPÁTICA DE DEDO DE PIE DERECHO"
  },
  {
    "codigo":66038001,
    "descripcion":"SÍNDROME DE MILLER"
  },
  {
    "codigo":721398001,
    "descripcion":"SÍNDROME DE BROWN-SEQUARD DE MÉDULA ESPINAL CERVICAL"
  },
  {
    "codigo":195275000,
    "descripcion":"ANEURISMA DE ARTERIA ILÍACA COMÚN"
  },
  {
    "codigo":295414008,
    "descripcion":"SOBREDOSIS DE FÁRMACO ANTIEMÉTICO"
  },
  {
    "codigo":719563003,
    "descripcion":"REQUIERE GUÍA DE LAZARILLO"
  },
  {
    "codigo":129739004,
    "descripcion":"LESIÓN MICROLOBULADA"
  },
  {
    "codigo":1145547006,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ÁCIDO NICOTÍNICO"
  },
  {
    "codigo":95136000,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE TIMO"
  },
  {
    "codigo":293579009,
    "descripcion":"REACCIÓN ADVERSA A LA QUIMOTRIPSINA"
  },
  {
    "codigo":226208002,
    "descripcion":"DIETA RESTRINGIDA EN LÍQUIDOS"
  },
  {
    "codigo":193440001,
    "descripcion":"LESIÓN TESTICULAR DEL SÍNDROME ADRENOGENITAL"
  },
  {
    "codigo":160672004,
    "descripcion":"DIETA HIPOCOLESTEROLÉMICA"
  },
  {
    "codigo":1141877000,
    "descripcion":"ERUPCIÓN DE MEMBRANA MUCOSA ORAL"
  },
  {
    "codigo":93301006,
    "descripcion":"HIPOPLASIA CONGÉNITA DE CONDUCTO DEFERENTE"
  },
  {
    "codigo":335911000119108,
    "descripcion":"ECTROPIÓN CICATRIZAL DE PÁRPADO DERECHO"
  },
  {
    "codigo":124234008,
    "descripcion":"DEFICIENCIA DE DIOXIGENASA"
  },
  {
    "codigo":24095001,
    "descripcion":"PLACENTA PREVIA OCLUSIVA PARCIAL"
  },
  {
    "codigo":56863004,
    "descripcion":"FRACTURA NO EXPUESTA DE ÓRBITA"
  },
  {
    "codigo":253471004,
    "descripcion":"TEJIDO ACCESORIO EN VALVA DE VÁLVULA AURICULOVENTRICULAR DERECHA"
  },
  {
    "codigo":286239007,
    "descripcion":"NO COORDINA EL FLUJO DE AIRE CON LA EMISIÓN DE LA VOZ"
  },
  {
    "codigo":11778241000119105,
    "descripcion":"RUPTURA TRAUMÁTICA DE TENDÓN DE MÚSCULO SUBESCAPULAR DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":55028001,
    "descripcion":"FORÚNCULO DE CONDUCTO DEFERENTE"
  },
  {
    "codigo":292659003,
    "descripcion":"REACCIÓN ADVERSA AL ÁCIDO SALICÍLICO TÓPICO"
  },
  {
    "codigo":218868004,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR FÁRMACO BLOQUEANTE GANGLIONAR"
  },
  {
    "codigo":87796008,
    "descripcion":"ÚLCERA GASTROYEYUNAL CON HEMORRAGIA Y PERFORACIÓN PERO SIN OBSTRUCCIÓN"
  },
  {
    "codigo":446409001,
    "descripcion":"MÉDULA ÓSEA NORMOCELULAR"
  },
  {
    "codigo":20425006,
    "descripcion":"TRASTORNO LABERÍNTICO"
  },
  {
    "codigo":1003465006,
    "descripcion":"NEUROFIBROMATOSIS ESPINAL FAMILIAR"
  },
  {
    "codigo":249801008,
    "descripcion":"CORRECCIÓN DE ARCO BAJO CON EL PIE EN PUNTA"
  },
  {
    "codigo":10959041000119109,
    "descripcion":"LACERACIÓN DE MANO IZQUIERDA"
  },
  {
    "codigo":278899001,
    "descripcion":"AMILOIDOSIS DE VEJIGA URINARIA"
  },
  {
    "codigo":247966009,
    "descripcion":"LAVADO DE MANOS COMPULSIVO"
  },
  {
    "codigo":49523001,
    "descripcion":"QUEMADURA EPIDÉRMICA DE MÚLTIPLES SITIOS DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":735816005,
    "descripcion":"HERIDA PUNZANTE DE MANO SIN CUERPO EXTRAÑO"
  },
  {
    "codigo":1260104006,
    "descripcion":"TATUAJE DE PIGMENTACIÓN AMARILLA DE TEJIDOS BLANDOS DE BOCA"
  },
  {
    "codigo":703048006,
    "descripcion":"REFLUJO VESICOURETERAL DESPUÉS DE TRASPLANTE RENAL"
  },
  {
    "codigo":209693002,
    "descripcion":"SECCIÓN EXPUESTA DE LIGAMENTO DE LA RODILLA"
  },
  {
    "codigo":13085003,
    "descripcion":"QUEMADURA DE LA LARINGE"
  },
  {
    "codigo":45853006,
    "descripcion":"SÍNDROME DE ROUSSY - LÉVY"
  },
  {
    "codigo":111389006,
    "descripcion":"EPIDERMÓLISIS BULLOSA DISTRÓFICA DOMINANTE"
  },
  {
    "codigo":109554004,
    "descripcion":"QUISTE GASTROINTESTINAL ORAL ECTÓPICO"
  },
  {
    "codigo":240626005,
    "descripcion":"ERLIQUIOSIS DEL HUMANO"
  },
  {
    "codigo":44018007,
    "descripcion":"SÍNDROME DE ICTERICIA COLESTÁSICA"
  },
  {
    "codigo":271559000,
    "descripcion":"PENSAMIENTOS OBSESIVOS ACERCA DE CAUSAR DAÑO A OTROS"
  },
  {
    "codigo":402631001,
    "descripcion":"TRASTORNO DEL COLOR UNGUEAL"
  },
  {
    "codigo":304327001,
    "descripcion":"SIN MOVIMIENTO DE TOBILLO"
  },
  {
    "codigo":92661000119104,
    "descripcion":"HIPERHIDROSIS FOCAL SECUNDARIA"
  },
  {
    "codigo":338421000119104,
    "descripcion":"COROIDOPATÍA PUNTEADA INTERNA DE OJO IZQUIERDO"
  },
  {
    "codigo":42183005,
    "descripcion":"PSEUDOHIPOPARATIROIDISMO TIPO II"
  },
  {
    "codigo":1075701000119106,
    "descripcion":"GRANULOMA POR CUERPO EXTRAÑO DE PARTES BLANDAS DE PIE IZQUIERDO"
  },
  {
    "codigo":38513001,
    "descripcion":"ATROFIA SENIL DE LA COROIDES"
  },
  {
    "codigo":235121004,
    "descripcion":"HIPERTROFIA DE GLÁNDULAS SALIVALES MENORES"
  },
  {
    "codigo":366193007,
    "descripcion":"FUNCIÓN DEL VENTRÍCULO DERECHO - HALLAZGO"
  },
  {
    "codigo":311951000119102,
    "descripcion":"OSTEOCONDROSIS JUVENIL DEL TARSO IZQUIERDO"
  },
  {
    "codigo":267889007,
    "descripcion":"ARTROSIS GENERALIZADA DE LA MANO"
  },
  {
    "codigo":16040591000119102,
    "descripcion":"ARTRITIS IDIOPÁTICA JUVENIL DE INICIO SISTÉMICO DE MANO IZQUIERDA"
  },
  {
    "codigo":36678001,
    "descripcion":"ARTRITIS PIÓGENA DE REGIÓN DE HOMBRO"
  },
  {
    "codigo":724806004,
    "descripcion":"NEOPLASIA NEUROEPITELIOMATOSA MALIGNA PRIMARIA DE SISTEMA NERVIOSO AUTÓNOMO"
  },
  {
    "codigo":167750006,
    "descripcion":"GLOBULINAS EN LÍQUIDO CEFALORRAQUÍDEO POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":298822007,
    "descripcion":"AMPLITUD DE ROTACIÓN INTERNA ACTIVA DE ARTICULACIÓN DE HOMBRO, AUMENTADA"
  },
  {
    "codigo":1148955005,
    "descripcion":"DESARROLLO INFANTIL NORMAL"
  },
  {
    "codigo":296987007,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE QUINIDINA"
  },
  {
    "codigo":426224004,
    "descripcion":"ORIENTADO EN TIEMPO, ESPACIO Y PERSONA"
  },
  {
    "codigo":719301002,
    "descripcion":"ATAXIA ESPINOCEREBELOSA TIPO 37"
  },
  {
    "codigo":293317003,
    "descripcion":"REACCIÓN ADVERSA A LA ANTITROMBINA III"
  },
  {
    "codigo":1145285005,
    "descripcion":"COMUNICACIÓN APROPIADA DE INFORMACIÓN PERSONAL"
  },
  {
    "codigo":94874002,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA REGIÓN INGUINAL"
  },
  {
    "codigo":29338006,
    "descripcion":"DISCRIMINACIÓN POLÍTICA"
  },
  {
    "codigo":62106007,
    "descripcion":"CONMOCIÓN SIN PÉRDIDA DE LA CONCIENCIA"
  },
  {
    "codigo":291482007,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR GENTAMICINA"
  },
  {
    "codigo":27503000,
    "descripcion":"SÍNDROME DE GILBERT"
  },
  {
    "codigo":193178008,
    "descripcion":"POLINEUROPATÍA EN EL LUPUS ERITEMATOSO DISEMINADO"
  },
  {
    "codigo":289647003,
    "descripcion":"ÚTERO DESVIADO HACIA LA IZQUIERDA"
  },
  {
    "codigo":715631005,
    "descripcion":"CONDRODISPLASIA PUNTEADA TIPO TORIELLO"
  },
  {
    "codigo":93039007,
    "descripcion":"VESÍCULA BILIAR BILOBULADA CONGÉNITA"
  },
  {
    "codigo":25668000,
    "descripcion":"TIFO MURINO"
  },
  {
    "codigo":58436003,
    "descripcion":"LIBIDO AUMENTADA"
  },
  {
    "codigo":123972004,
    "descripcion":"FRACTURA DE COLLES INVERTIDA"
  },
  {
    "codigo":449817000,
    "descripcion":"SÍNDROME DE PETERS PLUS"
  },
  {
    "codigo":89369001,
    "descripcion":"ANENCÉFALO"
  },
  {
    "codigo":15686441000119107,
    "descripcion":"SINOVITIS TRANSITORIA DE ARTICULACIONES DE AMBAS CADERAS"
  },
  {
    "codigo":253209004,
    "descripcion":"CEJA DOBLE"
  },
  {
    "codigo":218606000,
    "descripcion":"REACCIÓN ADVERSA A LA ACETANILIDA"
  },
  {
    "codigo":21998000,
    "descripcion":"PELVIS DE ROBERT"
  },
  {
    "codigo":284142007,
    "descripcion":"NO MUEVE EL BRAZO"
  },
  {
    "codigo":282307000,
    "descripcion":"NO MANTIENE EL EQUILIBRIO SENTADO"
  },
  {
    "codigo":249539006,
    "descripcion":"OMBLIGO PROMINENTE"
  },
  {
    "codigo":247704000,
    "descripcion":"PERCEPCIÓN CAMBIADA DE LAS COSAS"
  },
  {
    "codigo":52931009,
    "descripcion":"HEMORROIDES INTERNAS TROMBOSADAS"
  },
  {
    "codigo":444312002,
    "descripcion":"HEMORRAGIA DE ESTRUCTURA DE CAVIDAD ABDOMINAL"
  },
  {
    "codigo":1263512007,
    "descripcion":"TRASTORNO MIOCLÓNICO DEBIDO A DEMENCIA"
  },
  {
    "codigo":870296007,
    "descripcion":"INFESTACIÓN PARASITARIA DE PÁRPADO CAUSADA POR DEMODEX"
  },
  {
    "codigo":83864008,
    "descripcion":"HEPATITIS COLESTÁTICA INDUCIDA POR DROGAS"
  },
  {
    "codigo":16206941000119101,
    "descripcion":"NEUROMA DE MORTON DE AMBOS PIES"
  },
  {
    "codigo":409709004,
    "descripcion":"TRASTORNO CROMOSÓMICO"
  },
  {
    "codigo":278637003,
    "descripcion":"PRÓTESIS DENTAL EXCESIVAMENTE PEQUEÑA"
  },
  {
    "codigo":213101009,
    "descripcion":"RUPTURA DE DISPOSITIVO DE FIJACIÓN ESPINAL"
  },
  {
    "codigo":80194003,
    "descripcion":"FASE INMUNE DE LA LEPTOSPIROSIS"
  },
  {
    "codigo":735554004,
    "descripcion":"INFECCIÓN QUE CAUSA ABSCESO DEL SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":702786004,
    "descripcion":"LINFOMA FOLICULAR NO HODGKIN DIFUSO, SUBTIPO DE CÉLULAS CENTRALES GRADO 1"
  },
  {
    "codigo":307735008,
    "descripcion":"ABORTO COMPLETO INEVITABLE COMPLICADO POR HEMORRAGIA TARDÍA O EXCESIVA"
  },
  {
    "codigo":78359009,
    "descripcion":"SIGNO DEL CORDÓN"
  },
  {
    "codigo":699116001,
    "descripcion":"EXAMEN DE OÍDO ANORMAL"
  },
  {
    "codigo":305900003,
    "descripcion":"VISTO POR EL SERVICIO DE CIRUGÍA PLÁSTICA"
  },
  {
    "codigo":240364003,
    "descripcion":"ULCERACIÓN AMÉBICA PERIANAL"
  },
  {
    "codigo":404204005,
    "descripcion":"INTERACCIÓN MEDICAMENTOSA"
  },
  {
    "codigo":109292004,
    "descripcion":"MELANOMA IN SITU DE HOMBRO"
  },
  {
    "codigo":371436007,
    "descripcion":"TRASTORNO DE ÓRBITA"
  },
  {
    "codigo":402369000,
    "descripcion":"SARCOIDOSIS ATRÓFICA"
  },
  {
    "codigo":43756009,
    "descripcion":"RUPTURA TRAUMÁTICA DEL BAZO"
  },
  {
    "codigo":369601001,
    "descripcion":"TUMOR MALIGNO CON COMPROMISO DE ÓRGANO POR PROPAGACIÓN DIRECTA DESDE VAGINA"
  },
  {
    "codigo":238529007,
    "descripcion":"FOLICULITIS ACTÍNICA"
  },
  {
    "codigo":41921008,
    "descripcion":"EFECTO TÓXICO DE GAS LICUADO DE PETRÓLEO"
  },
  {
    "codigo":72854003,
    "descripcion":"NEUMONÍA POR ASPIRACIÓN SECUNDARIA A PREAHOGAMIENTO"
  },
  {
    "codigo":1285270004,
    "descripcion":"RANGO ACTIVO DE FLEXIÓN PLANTAR DE TOBILLO DISMINUIDO"
  },
  {
    "codigo":1186966005,
    "descripcion":"PERIODONTITIS EXACERBADA POR NEUTROPENIA FAMILIAR"
  },
  {
    "codigo":431467003,
    "descripcion":"ABSCESO DE TEJIDO PERIVESICULAR QUE RODEA A LA VEJIGA"
  },
  {
    "codigo":365931003,
    "descripcion":"HALLAZGO RELACIONADO CON EL NIVEL DE CONCIENCIA"
  },
  {
    "codigo":726379004,
    "descripcion":"DELECIÓN DE PARTE DEL CROMOSOMA 9"
  },
  {
    "codigo":300395007,
    "descripcion":"HALLAZGO RELACIONADO CON LA PIEL DE LA PARED ABDOMINAL"
  },
  {
    "codigo":724544000,
    "descripcion":"INFECCIÓN QUE OCASIONA TIC"
  },
  {
    "codigo":890219009,
    "descripcion":"RAMIFICACIÓN ANÓMALA CONGÉNITA DEL ÁRBOL TRAQUEOBRONQUIAL"
  },
  {
    "codigo":429632003,
    "descripcion":"TRASTORNO DE CARTÍLAGO ARTICULAR DE LA RODILLA"
  },
  {
    "codigo":1080721000119100,
    "descripcion":"LIPOSARCOMA PRIMARIO DE PARTES BLANDAS DE EXTREMIDAD SUPERIOR DERECHA"
  },
  {
    "codigo":1052224006,
    "descripcion":"DISFUNCIÓN LABERÍNTICA HIPOACTIVA DE OÍDO INTERNO IZQUIERDO"
  },
  {
    "codigo":298560009,
    "descripcion":"AMPLITUD DE ROTACIÓN PASIVA HACIA LA DERECHA DE LA COLUMNA VERTEBRAL DORSAL, DISMINUIDA"
  },
  {
    "codigo":287991000119107,
    "descripcion":"DISCORDIA CON VECINOS, INQUILINOS Y PROPIETARIOS"
  },
  {
    "codigo":1148693003,
    "descripcion":"LESIÓN FOLICULAR DE TIROIDES"
  },
  {
    "codigo":296725006,
    "descripcion":"SOBREDOSIS DE CEFODIZIMA"
  },
  {
    "codigo":427797008,
    "descripcion":"CAMBIO DE CONDUCTA INUSITADO"
  },
  {
    "codigo":65514002,
    "descripcion":"MENSTRUACIÓN VICARIANTE"
  },
  {
    "codigo":1179626002,
    "descripcion":"INSUFICIENCIA RESPIRATORIA EN PERÍODO NEONATAL TEMPRANO"
  },
  {
    "codigo":131050004,
    "descripcion":"NIVEL DE 17-CETOESTEROIDES POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":15744401000119103,
    "descripcion":"INESTABILIDAD DE AMBAS ARTICULACIONES DE LA CADERA"
  },
  {
    "codigo":360426005,
    "descripcion":"DISPLASIA OVÁRICA CONGÉNITA"
  },
  {
    "codigo":293055003,
    "descripcion":"REACCIÓN ADVERSA A LA DEMECLOCICLINA"
  },
  {
    "codigo":260287003,
    "descripcion":"VISIÓN A DISTANCIA 3\/60"
  },
  {
    "codigo":30911005,
    "descripcion":"CRIOGLOBULINEMIA"
  },
  {
    "codigo":717204001,
    "descripcion":"KLEBSIELLA OXYTOCA O RAOULTELLA PLANTICOLA O RAOULTELLA TERRIGENA"
  },
  {
    "codigo":291220004,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ZUCLOPENTIXOL"
  },
  {
    "codigo":29076005,
    "descripcion":"SÍNDROME DE MECKEL - GRUBER"
  },
  {
    "codigo":94612008,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LOS GANGLIOS LINFÁTICOS INGUINALES SUPERFICIALES"
  },
  {
    "codigo":715369006,
    "descripcion":"TRASTORNO CEREBELOPARENQUIMATOSO AUTOSÓMICO RECESIVO TIPO 3"
  },
  {
    "codigo":189246000,
    "descripcion":"CARCINOMA IN SITU DEL ESFÍNTER DE ODDI"
  },
  {
    "codigo":27241008,
    "descripcion":"COLITIS ISQUÉMICA CRÓNICA"
  },
  {
    "codigo":289385009,
    "descripcion":"NIVEL 3 DE LA PRESENTACIÓN EN RELACIÓN CON LAS ESPINAS ISQUIÁTICAS"
  },
  {
    "codigo":254782003,
    "descripcion":"HEMANGIOMATOSIS PROGRESIVAS MÚLTIPLES"
  },
  {
    "codigo":90942002,
    "descripcion":"FORÚNCULO DE MUSLO"
  },
  {
    "codigo":123710008,
    "descripcion":"DISTROFIA DE UÑAS, TOTAL"
  },
  {
    "codigo":449555002,
    "descripcion":"ANOMALÍA COMISURAL DE VÁLVULA AÓRTICA"
  },
  {
    "codigo":35151000087100,
    "descripcion":"DERMATITIS CAUSADA POR SUSTANCIA ADMINISTRADA POR VÍA ORAL"
  },
  {
    "codigo":283880001,
    "descripcion":"CONFABULACIÓN MOMENTÁNEA"
  },
  {
    "codigo":185576002,
    "descripcion":"DESARROLLO INFANTIL - NUEVO LLAMADO ANULADO"
  },
  {
    "codigo":414952002,
    "descripcion":"LEUCOPLASIA VELLOSA ORAL"
  },
  {
    "codigo":47951000087108,
    "descripcion":"FRACTURA DE DIÁFISIS DE HÚMERO IZQUIERDO"
  },
  {
    "codigo":40271000087107,
    "descripcion":"ESGUINCE DE LIGAMENTO DE ARTICULACIÓN RADIOCUBITAL DISTAL DERECHA"
  },
  {
    "codigo":42831000087108,
    "descripcion":"DISTENSIÓN DE TENDÓN DE MÚSCULO GLÚTEO DERECHO"
  },
  {
    "codigo":183741000,
    "descripcion":"CONSULTA DOMICILIARIA CARDIOLÓGICA, REALIZADA"
  },
  {
    "codigo":52669001,
    "descripcion":"AUTOMATISMO"
  },
  {
    "codigo":249277001,
    "descripcion":"TIENE QUE AUTOESTIMULARSE PARA ORINAR"
  },
  {
    "codigo":413117001,
    "descripcion":"ESTADO DE VARICELA"
  },
  {
    "codigo":85437001,
    "descripcion":"HIPOPLASIA CONGÉNITA DE TESTÍCULO"
  },
  {
    "codigo":216509005,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR BROMURO"
  },
  {
    "codigo":16782891000119108,
    "descripcion":"CARCINOMA DE CÉLULAS DE MERKEL PRIMARIO DE PIEL DE SIEN"
  },
  {
    "codigo":871869008,
    "descripcion":"DIFICULTAD PARA DEMOSTRAR CONOCIMIENTOS SOBRE LA SALUD"
  },
  {
    "codigo":1197714001,
    "descripcion":"ÚLCERA GÁSTRICA POR ENFERMEDAD DE CROHN"
  },
  {
    "codigo":118205009,
    "descripcion":"HALLAZGO RELACIONADO CON LOS DATOS DE LA SECUENCIA MOLECULAR"
  },
  {
    "codigo":708029009,
    "descripcion":"DISPLASIA ACINAR PULMONAR CONGÉNITA"
  },
  {
    "codigo":1363389009,
    "descripcion":"NEOVASCULARIZACIÓN DE CUADRANTE INFERIOR DE ÁNGULO IRIDOCORNEAL DE OJO DERECHO"
  },
  {
    "codigo":247442005,
    "descripcion":"SOLUCIÓN DE CONTINUIDAD"
  },
  {
    "codigo":704359001,
    "descripcion":"CON MAYOR RIESGO DE POLIFARMACIA"
  },
  {
    "codigo":1163111005,
    "descripcion":"COLITIS CAUSADA POR ESCHERICHIA COLI"
  },
  {
    "codigo":1259580000,
    "descripcion":"FIBROSARCOMA INFANTIL PRIMARIO"
  },
  {
    "codigo":276540001,
    "descripcion":"ASPIRACIÓN NEONATAL DE LÍQUIDO AMNIÓTICO"
  },
  {
    "codigo":440380006,
    "descripcion":"STAPHYLOCOCCUS AUREUS RESISTENTE A METICILINA NO DETECTADO POR CRIBADO"
  },
  {
    "codigo":241937000,
    "descripcion":"ANAFILAXIA FARMACÓGENA"
  },
  {
    "codigo":78097002,
    "descripcion":"OFTALMOPLEJÍA TOTAL"
  },
  {
    "codigo":897297005,
    "descripcion":"SECCIÓN TRAUMÁTICA DE TENDÓN EXTENSOR DE MUÑECA"
  },
  {
    "codigo":733457006,
    "descripcion":"SÍNDROME DE EHLERS-DANLOS Y OSTEOGÉNESIS IMPERFECTA"
  },
  {
    "codigo":373009006,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM AGRI"
  },
  {
    "codigo":209169008,
    "descripcion":"SUBLUXACIÓN NO EXPUESTA DE LA COLUMNA VERTEBRAL LUMBAR"
  },
  {
    "codigo":176401009,
    "descripcion":"PERICARDITIS HEMÁTICA AGUDA"
  },
  {
    "codigo":405777008,
    "descripcion":"PACIENTE PSIQUIÁTRICO INTERNADO"
  },
  {
    "codigo":403942003,
    "descripcion":"ESPIRADENOMA ECRINO MALIGNO DE PIEL"
  },
  {
    "codigo":305638001,
    "descripcion":"ATENDIDO POR MÉDICO GENERAL PROPIO"
  },
  {
    "codigo":15992671000119103,
    "descripcion":"NEURORRETINITIS DE OJO IZQUIERDO"
  },
  {
    "codigo":698854006,
    "descripcion":"HIPERANDROGENISMO DEBIDO A TIPO NO CLÁSICO DE DEFICIENCIA DE 21-HIDROXILASA"
  },
  {
    "codigo":1255910006,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO CRURAL ANTERIOR DE PIERNA"
  },
  {
    "codigo":240102007,
    "descripcion":"MIOPATÍA POR CLOROQUINA"
  },
  {
    "codigo":41659003,
    "descripcion":"INFECCIÓN POR HAEMOPHILUS"
  },
  {
    "codigo":1083231000119104,
    "descripcion":"PERFORACIÓN CENTRAL DE AMBAS MEMBRANAS TIMPÁNICAS"
  },
  {
    "codigo":100191000119105,
    "descripcion":"ASIMETRÍA ADQUIRIDA DE PRÓSTATA"
  },
  {
    "codigo":236432001,
    "descripcion":"SÍNDROME RENAL PULMONAR"
  },
  {
    "codigo":1286843009,
    "descripcion":"CIERRE DE ÁNGULO POSOPERATORIO"
  },
  {
    "codigo":860859009,
    "descripcion":"PROTOPORFIRIA ERITROPOYÉTICA DEBIDA A DEFICIENCIA DE FERROQUELATASA"
  },
  {
    "codigo":301968003,
    "descripcion":"ORIFICIO LAGRIMAL INFERIOR CERRADO"
  },
  {
    "codigo":203664006,
    "descripcion":"ESCOLIOSIS EN LAS CONJUNTIVOPATÍAS"
  },
  {
    "codigo":726117003,
    "descripcion":"DEFORMIDAD CONGÉNITA DE DEDO DE PIE"
  },
  {
    "codigo":300133006,
    "descripcion":"HALLAZGO RELACIONADO CON SENSIBILIDAD DE CONDUCTO AUDITIVO"
  },
  {
    "codigo":365669006,
    "descripcion":"HALLAZGO RELACIONADO CON LA TURBIDEZ DE UN LÍQUIDO"
  },
  {
    "codigo":1217637008,
    "descripcion":"INFILTRADO CORNEAL RELACIONADO CON LENTE DE CONTACTO POR HIPOXIA"
  },
  {
    "codigo":234597009,
    "descripcion":"DEFICIENCIA DEL COMPLEMENTO 1R"
  },
  {
    "codigo":201829007,
    "descripcion":"ARTROSIS PRIMARIA LOCALIZADA"
  },
  {
    "codigo":298298008,
    "descripcion":"HALLAZGO RELACIONADO CON MEDICIONES DEL MÚSCULO ESQUELÉTICO"
  },
  {
    "codigo":724282009,
    "descripcion":"SÍNDROME DE HIPOPARATIROIDISMO, SORDERA Y ENFERMEDAD RENAL"
  },
  {
    "codigo":1551001,
    "descripcion":"OSTEOMIELITIS DE FÉMUR"
  },
  {
    "codigo":1345039003,
    "descripcion":"ETAPA DE CONTEMPLACIÓN DE LA DISPOSICIÓN A CAMBIAR LA CONDUCTA DE CONSUMO DE SUSTANCIAS"
  },
  {
    "codigo":296463004,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE ETRETINATO"
  },
  {
    "codigo":198159006,
    "descripcion":"PARAMETRITIS CRÓNICA Y CELULITIS PÉLVICA"
  },
  {
    "codigo":34319007,
    "descripcion":"INDURACIÓN DE LA PIEL"
  },
  {
    "codigo":720612000,
    "descripcion":"SÍNDROME CARDIOESPONDILOCARPOFACIAL"
  },
  {
    "codigo":1179364009,
    "descripcion":"PÚRPURA FETAL"
  },
  {
    "codigo":292793006,
    "descripcion":"REACCIÓN ADVERSA A AGENTE MODIFICADOR DE LA VISCOSIDAD DERIVADO DE LA CELULOSA"
  },
  {
    "codigo":161721006,
    "descripcion":"PÉRDIDA MENSTRUAL ESTABLE"
  },
  {
    "codigo":760838291000119102,
    "descripcion":"TRASTORNO DE TENDÓN DE AMBAS PIERNAS"
  },
  {
    "codigo":1306766001,
    "descripcion":"DESPRENDIMIENTO DE RETINA DE OJO IZQUIERDO"
  },
  {
    "codigo":290958002,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR PRIMIDONA"
  },
  {
    "codigo":61582004,
    "descripcion":"RINITIS ALÉRGICA"
  },
  {
    "codigo":94350006,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LOS GANGLIOS LINFÁTICOS INTRAPÉLVICOS"
  },
  {
    "codigo":127118009,
    "descripcion":"LINFADENOPATÍA MESENTÉRICA SUPERIOR"
  },
  {
    "codigo":389262009,
    "descripcion":"DISPLASIA DIAFISARIA MOTEADA"
  },
  {
    "codigo":843331731000119104,
    "descripcion":"OSTEÍTIS DEFORMANTE DE AMBOS HÚMEROS"
  },
  {
    "codigo":715107004,
    "descripcion":"NO PASA DEL INODORO A LA SILLA"
  },
  {
    "codigo":192654009,
    "descripcion":"MENINGITIS CAUSADA POR BACILLUS PYOCYANEUS"
  },
  {
    "codigo":289123006,
    "descripcion":"RESPIRACIÓN PROFUNDA"
  },
  {
    "codigo":1237560000,
    "descripcion":"VENA VARICOSA DE MUSLO IZQUIERDO"
  },
  {
    "codigo":188984005,
    "descripcion":"LIPOMA DE CARA EXTERNA DE LA NARIZ"
  },
  {
    "codigo":254520006,
    "descripcion":"NEOPLASIA MALIGNA DE EPIGLOTIS INFRAHIOIDEA"
  },
  {
    "codigo":88845000,
    "descripcion":"TRASTORNO ORGÁNICO DE PERSONALIDAD DE TIPO EXPLOSIVO"
  },
  {
    "codigo":446631000124105,
    "descripcion":"FRACTURA DE EXTREMIDAD SUPERIOR DERECHA"
  },
  {
    "codigo":1268493001,
    "descripcion":"LESIÓN TRAUMÁTICA DE TEJIDO PERIOCULAR"
  },
  {
    "codigo":1137421004,
    "descripcion":"CAPAZ DE MANEJAR ESQUEMA DE MEDICACIÓN MEDIANTE TÉCNICA DE MEMORIA"
  },
  {
    "codigo":187149005,
    "descripcion":"CISTICERCOSIS OCULAR"
  },
  {
    "codigo":449293008,
    "descripcion":"SARCOMA DE TEJIDO CONJUNTIVO"
  },
  {
    "codigo":840674001,
    "descripcion":"REGIÓN DE CUELLO NORMAL"
  },
  {
    "codigo":11817261000119102,
    "descripcion":"ESGUINCE DE LIGAMENTO DE ARTICULACIÓN ESTERNOCLAVICULAR DERECHA"
  },
  {
    "codigo":1085741000119102,
    "descripcion":"CONTORNO DE RESTAURACIÓN DENTAL EXISTENTE BIOLÓGICAMENTE INCOMPATIBLE CON LA SALUD BUCAL"
  },
  {
    "codigo":283618004,
    "descripcion":"HERIDA POR PINCHAZO DE AGUJA EN LA PALMA DE LA MANO"
  },
  {
    "codigo":709602009,
    "descripcion":"TROMBOSIS CRÓNICA DE VENA SUPERFICIAL DE MIEMBRO INFERIOR"
  },
  {
    "codigo":314551004,
    "descripcion":"TRASTORNO DE INJERTO CORNEAL"
  },
  {
    "codigo":609463005,
    "descripcion":"INTERRUPCIÓN INDUCIDA DEL EMBARAZO COMPLICADA POR DESEQUILIBRIO ELECTROLÍTICO"
  },
  {
    "codigo":773303005,
    "descripcion":"DISPLASIA ESPONDILOEPIMETAFISARIA TIPO GENEVIEVE"
  },
  {
    "codigo":871607005,
    "descripcion":"DEFECTO DE TABIQUE VENTRICULAR CON COMPROMISO DOBLE DE SALIDA YUXTAARTERIAL CON EXTENSIÓN PERIMEMBRANOSA Y TABIQUE DE SALIDA MAL ALINEADO EN LA PARTE ANTERIOR"
  },
  {
    "codigo":15969009,
    "descripcion":"DESMIOGNATO"
  },
  {
    "codigo":833334002,
    "descripcion":"SUBLUXACIÓN DE MUÑECA"
  },
  {
    "codigo":276278003,
    "descripcion":"HEMORRAGIA SUBARACNOIDEA PROVENIENTE DE ANEURISMA DE ARTERIA CEREBRAL ANTERIOR"
  },
  {
    "codigo":210742001,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA, SEGUNDO A QUINTO DEDOS DEL PIE"
  },
  {
    "codigo":866102002,
    "descripcion":"NEVO INTRADÉRMICO DE PÁRPADO"
  },
  {
    "codigo":1259318004,
    "descripcion":"CARCINOMA PRIMARIO DE CARA DORSAL DE BASE DE LENGUA"
  },
  {
    "codigo":45067001,
    "descripcion":"TRASTORNO ESPÁSTICO DEL SEGMENTO MUSCULAR LISO DEL ESÓFAGO"
  },
  {
    "codigo":208907002,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA NO EXPUESTA DE LA ARTICULACIÓN DE LA CADERA, ANTERIOR"
  },
  {
    "codigo":307211004,
    "descripcion":"SEUDOARTROSIS DE ESPONDILOSINDESIS"
  },
  {
    "codigo":897035006,
    "descripcion":"ANTICUERPOS CONTRA SARS-COV-2 NO DETECTADOS"
  },
  {
    "codigo":239840000,
    "descripcion":"CONDROCALCINOSIS FAMILIAR"
  },
  {
    "codigo":77835008,
    "descripcion":"SÍNDROME DE OFTALMOPLEJÍA PLUS"
  },
  {
    "codigo":733195008,
    "descripcion":"EPILEPSIA DE LA LACTANCIA CON CONVULSIONES FOCALES MIGRATORIAS"
  },
  {
    "codigo":1255648003,
    "descripcion":"CARCINOMA BASALOIDE DE HIPOFARINGE"
  },
  {
    "codigo":698592004,
    "descripcion":"DISFUNCIÓN SISTÓLICA DE VENTRÍCULO IZQUIERDO ASINTOMÁTICA"
  },
  {
    "codigo":403680004,
    "descripcion":"NECROSIS DE INJERTO DE PIEL"
  },
  {
    "codigo":10464008,
    "descripcion":"LUXACIÓN RECURRENTE DE ARTICULACIÓN DE MANO"
  },
  {
    "codigo":860597000,
    "descripcion":"GANGRENA DE MESENTERIO DE ÍLEON"
  },
  {
    "codigo":303541002,
    "descripcion":"AMPLITUD DE PROTRACCIÓN ACTIVA DE COLUMNA CERVICAL, NORMAL"
  },
  {
    "codigo":205237003,
    "descripcion":"NEUMONITIS"
  },
  {
    "codigo":762293009,
    "descripcion":"TETANIA NEONATAL SIN DEFICIENCIA DE CALCIO"
  },
  {
    "codigo":170634005,
    "descripcion":"TRASTORNOS DEL SUEÑO FRECUENTES DEBIDOS AL ASMA"
  },
  {
    "codigo":301706005,
    "descripcion":"ABSCESO DE PIE"
  },
  {
    "codigo":400010006,
    "descripcion":"NEVO MELANOCÍTICO DE PIEL"
  },
  {
    "codigo":201567003,
    "descripcion":"ARTRITIS REACTIVA DE CADERA"
  },
  {
    "codigo":365407004,
    "descripcion":"FORMA DE LA ONDA INTRARTERIAL - HALLAZGO"
  },
  {
    "codigo":299871006,
    "descripcion":"REFLEJO ROTULIANO PRESENTE SÓLO CON REFUERZO"
  },
  {
    "codigo":37727007,
    "descripcion":"FLUJO VASCULAR AUMENTADO"
  },
  {
    "codigo":267103008,
    "descripcion":"SENSACIÓN DE TUMORACIÓN EN LA GARGANTA"
  },
  {
    "codigo":103263007,
    "descripcion":"MIRADA NO CONJUGADA"
  },
  {
    "codigo":199732004,
    "descripcion":"HALLAZGO ANORMAL EN CRIBADO PRENATAL DE LA MADRE"
  },
  {
    "codigo":429108009,
    "descripcion":"HALLAZGO RELACIONADO CON ESTADO NEUROVASCULAR DE UN MIEMBRO"
  },
  {
    "codigo":296201002,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE FLUSPIRILENO"
  },
  {
    "codigo":230665005,
    "descripcion":"DISFUNCIÓN AUTÓNOMA FARMACÓGENA"
  },
  {
    "codigo":294366006,
    "descripcion":"ALERGIA A ITRACONAZOL"
  },
  {
    "codigo":1144499001,
    "descripcion":"TUBERCULOSIS DE PELVIS Y FÉMUR"
  },
  {
    "codigo":390835003,
    "descripcion":"CONTUSIÓN POSTRAUMÁTICA"
  },
  {
    "codigo":294121000119100,
    "descripcion":"HEMIPLEJÍA DE LADO DERECHO DOMINANTE"
  },
  {
    "codigo":7401000119101,
    "descripcion":"PÓLIPO ADENOMATOSO DE RECTO"
  },
  {
    "codigo":11837161000119102,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE LA REGIÓN DE CADERA IZQUIERDA"
  },
  {
    "codigo":683241000119101,
    "descripcion":"NEVO MELANOCÍTICO PIGMENTADO CONGÉNITO DE PIEL DE LABIO"
  },
  {
    "codigo":1082601000119104,
    "descripcion":"ASCITIS DEBIDA A CIRROSIS ALCOHÓLICA"
  },
  {
    "codigo":12236521000119105,
    "descripcion":"BURSITIS DE MUÑECA DERECHA"
  },
  {
    "codigo":15920361000119106,
    "descripcion":"REACCIÓN ALÉRGICA CAUSADA POR MANÍ"
  },
  {
    "codigo":140521000119107,
    "descripcion":"ÚLCERA ISQUÉMICA DE PIE DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":290696003,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR CITARABINA"
  },
  {
    "codigo":15715561000119109,
    "descripcion":"SECUESTRO ÓSEO DE AMBOS HUESOS TEMPORALES"
  },
  {
    "codigo":337641000119106,
    "descripcion":"ESPASMO DE ACOMODACIÓN DE OJO IZQUIERDO"
  },
  {
    "codigo":11780841000119102,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO ESQUELÉTICO DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":16839401000119104,
    "descripcion":"DOLOR LUMBAR CONCOMITANTE CON NEURALGIA DE NERVIO CIÁTICO IZQUIERDO"
  },
  {
    "codigo":97001000119106,
    "descripcion":"DOLOR TORÁCICO LOCALIZADO"
  },
  {
    "codigo":15741161000119107,
    "descripcion":"QUISTE SINOVIAL DE CARA DORSAL DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":317161000119107,
    "descripcion":"PANICULITIS LUMBAR"
  },
  {
    "codigo":15669481000119108,
    "descripcion":"AUSENCIA CONGÉNITA DE AMBAS EXTREMIDADES SUPERIORES"
  },
  {
    "codigo":314601000119108,
    "descripcion":"BURSITIS DE OLÉCRANON DE CODO DERECHO"
  },
  {
    "codigo":288861001,
    "descripcion":"BEBE DE UN BEBEDERO"
  },
  {
    "codigo":714845005,
    "descripcion":"SE ADAPTA A SITUACIÓN LABORAL"
  },
  {
    "codigo":385330000,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA DE EPIPLÓN MAYOR AFECTADO POR NEOPLASIA MALIGNA"
  },
  {
    "codigo":1237298001,
    "descripcion":"ARTROFIBROSIS DE MANO"
  },
  {
    "codigo":92253009,
    "descripcion":"NEOPLASIA BENIGNA DEL LÓBULO OCCIPITAL"
  },
  {
    "codigo":57650002,
    "descripcion":"DIENTE PRIMARIO PERSISTENTE"
  },
  {
    "codigo":78741000119103,
    "descripcion":"OCLUSIÓN CORONARIA AGUDA QUE NO OCASIONA INFARTO DE MIOCARDIO"
  },
  {
    "codigo":449031001,
    "descripcion":"ANOMALÍA CONGÉNITA DE VALVA DE VÁLVULA AURICULOVENTRICULAR DERECHA EN VENTRÍCULO CON DOBLE TRACTO DE ENTRADA"
  },
  {
    "codigo":711175004,
    "descripcion":"CARIES DE SUPERFICIE LISA DE DIENTE"
  },
  {
    "codigo":285191007,
    "descripcion":"INCAPAZ DE RECORDAR EL DÍA DE LA SEMANA"
  },
  {
    "codigo":840412001,
    "descripcion":"DETECTOR DE MONÓXIDO DE CARBONO PRESENTE"
  },
  {
    "codigo":283356006,
    "descripcion":"HERIDA ABIERTA EN LA GARGANTA"
  },
  {
    "codigo":1299164006,
    "descripcion":"ESTADO EPILÉPTICO CON SÍNTOMAS MOTORES PROMINENTES"
  },
  {
    "codigo":281521001,
    "descripcion":"DERRAME TRAUMÁTICO DE ARTICULACIÓN DE RODILLA"
  },
  {
    "codigo":248753002,
    "descripcion":"RELLENO CAPILAR"
  },
  {
    "codigo":609201007,
    "descripcion":"HEMORRAGIA DE CONDUCTO PANCREÁTICO"
  },
  {
    "codigo":19377008,
    "descripcion":"INFECCIÓN CAUSADA POR HABRONEMA"
  },
  {
    "codigo":1295494003,
    "descripcion":"HIPERTENSIÓN OCULAR BILATERAL"
  },
  {
    "codigo":443526003,
    "descripcion":"PATRÓN HOMOGÉNEO DE ANTICUERPOS ANTINUCLEARES"
  },
  {
    "codigo":312454005,
    "descripcion":"ASMA - ACTUALMENTE LATENTE"
  },
  {
    "codigo":246918005,
    "descripcion":"DESPLAZAMIENTO DEL OJO"
  },
  {
    "codigo":48475001,
    "descripcion":"TRASTORNO DEL DIAFRAGMA"
  },
  {
    "codigo":1162587004,
    "descripcion":"PERFORACIÓN INTRAUTERINA DE INTESTINO FETAL DEBIDA A ESTENOSIS INTESTINAL"
  },
  {
    "codigo":15707004,
    "descripcion":"HIPERCAPNIA CON TRASTORNO ÁCIDO - BASE MIXTO"
  },
  {
    "codigo":46640001,
    "descripcion":"ASTENOPÍA DE ACOMODACIÓN"
  },
  {
    "codigo":212315009,
    "descripcion":"LESIÓN CERRADA DE NERVIO TIBIAL POSTERIOR"
  },
  {
    "codigo":1259056005,
    "descripcion":"TRASTORNO DE SISTEMA NERVIOSO AUTÓNOMO DEBIDO A TRASTORNO METABÓLICO"
  },
  {
    "codigo":439856008,
    "descripcion":"EXTENDIDO DE PAPANICOLAOU VAGINAL ANORMAL"
  },
  {
    "codigo":274181002,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE CUERO CABELLUDO"
  },
  {
    "codigo":306949002,
    "descripcion":"FISURA LARÍNGEA TIPO I"
  },
  {
    "codigo":110341006,
    "descripcion":"DOLOR GINGIVAL A LA PALPACIÓN"
  },
  {
    "codigo":896691006,
    "descripcion":"INFARTO AGUDO DE MIOCARDIO CON ELEVACIÓN DEL SEGMENTO ST POR OBSTRUCCIÓN DE RAMA CIRCUNFLEJA DE LA ARTERIA CORONARIA IZQUIERDA"
  },
  {
    "codigo":732933009,
    "descripcion":"PARAPLEJÍA ESPÁSTICA AUTOSÓMICA RECESIVA TIPO 25"
  },
  {
    "codigo":763866005,
    "descripcion":"SÍNDROME DE POLIDACTILIA POSTAXIAL, ANOMALÍAS DE LA HIPÓFISIS ANTERIOR Y DISMORFISMO FACIAL"
  },
  {
    "codigo":42970005,
    "descripcion":"TROMBOSIS NO PIÓGENA DE SENO VENOSO INTRACRANEAL"
  },
  {
    "codigo":403418006,
    "descripcion":"PANICULITIS CALCIFICANTE POR HIPERPARATIROIDISMO EN ENFERMEDAD RENAL"
  },
  {
    "codigo":235908005,
    "descripcion":"ENFERMEDAD POR ALMACENAMIENTO DE GLUCÓGENO TIPO IX"
  },
  {
    "codigo":1153412006,
    "descripcion":"SÍNDROME TORÁCICO AGUDO DEBIDO A TALASEMIA DE CÉLULAS FALCIFORMES CON CRISIS DREPANOCÍTICA"
  },
  {
    "codigo":103001002,
    "descripcion":"AFIEBRADO"
  },
  {
    "codigo":37465004,
    "descripcion":"PLASMACITOSIS"
  },
  {
    "codigo":234073005,
    "descripcion":"HIPERTENSIÓN VENOSA DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":299609006,
    "descripcion":"AMPLITUD DE ABDUCCIÓN ACTIVA DE DEDO DEL PIE DISMINUIDA"
  },
  {
    "codigo":70233007,
    "descripcion":"INFECCIÓN CAUSADA POR VIRUS PARAINFLUENZA 2 HUMANO"
  },
  {
    "codigo":365145008,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA LEVANTAR OBJETOS"
  },
  {
    "codigo":461614001,
    "descripcion":"OBSTRUCCIÓN ADQUIRIDA DE LUZ DE CAYADO AÓRTICO DISTAL A LA ARTERIA SUBCLAVIA"
  },
  {
    "codigo":232238002,
    "descripcion":"OSTEORRADIONECROSIS DE CONDUCTO AUDITIVO EXTERNO"
  },
  {
    "codigo":166702002,
    "descripcion":"NIVEL DE CALCIO SÉRICO POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1027000,
    "descripcion":"ENFERMEDAD POR REFLUJO ALCALINO"
  },
  {
    "codigo":363310009,
    "descripcion":"INFECCIÓN DE PARTES BLANDAS ASOCIADA CON TUBERCULOSIS"
  },
  {
    "codigo":164867002,
    "descripcion":"INFARTO DE MIOCARDIO ANTIGUO EN EL ELECTROCARDIOGRAMA"
  },
  {
    "codigo":1149235008,
    "descripcion":"INTOXICACIÓN ACCIDENTAL CAUSADA POR CORTICOSTEROIDE Y\/O DERIVADO DE CORTICOSTEROIDE"
  },
  {
    "codigo":721416000,
    "descripcion":"FRACTURA DE SEGUNDA VÉRTEBRA DORSAL"
  },
  {
    "codigo":230403005,
    "descripcion":"EPILEPSIA DE LÓBULO PARIETAL"
  },
  {
    "codigo":263171005,
    "descripcion":"FRACTURA DE HUESOS NASALES"
  },
  {
    "codigo":295939009,
    "descripcion":"SOBREDOSIS DE FLUVOXAMINA"
  },
  {
    "codigo":64728002,
    "descripcion":"FRACTURA DE LA COLUMNA VERTEBRAL POR TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":292269000,
    "descripcion":"REACCIÓN ADVERSA A LA AMANTADINA"
  },
  {
    "codigo":359640008,
    "descripcion":"LEUCEMIA MIELOIDE AGUDA SIN MADURACIÓN, FAB M1"
  },
  {
    "codigo":783789002,
    "descripcion":"BRAQUIOLMIA AUTOSÓMICA RECESIVA"
  },
  {
    "codigo":95661003,
    "descripcion":"SÍNDROME DE SUPRESIÓN DE ERGOTAMINA"
  },
  {
    "codigo":423341008,
    "descripcion":"EDEMA DE PAPILA ÓPTICA"
  },
  {
    "codigo":1177005009,
    "descripcion":"DIFTERIA OCULAR"
  },
  {
    "codigo":716418001,
    "descripcion":"CAPAZ DE MANEJAR EL BIENESTAR PROPIO"
  },
  {
    "codigo":421506003,
    "descripcion":"ATROFIA DEL EPITELIO PIGMENTARIO DE LA RETINA"
  },
  {
    "codigo":126594005,
    "descripcion":"NEOPLASIA DEL SEGUNDO HUESO CUNEIFORME DEL PIE"
  },
  {
    "codigo":290434006,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR DANTRÓN"
  },
  {
    "codigo":28290006,
    "descripcion":"AFECTO INAPROPIADO"
  },
  {
    "codigo":1339010008,
    "descripcion":"STREPTOCOCCUS PNEUMONIAE SEROTIPO DANÉS 15B O STREPTOCOCCUS PNEUMONIAE SEROTIPO DANÉS 15C"
  },
  {
    "codigo":93826009,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL ÁNGULO HEPÁTICO DEL COLON"
  },
  {
    "codigo":91991003,
    "descripcion":"NEOPLASIA BENIGNA DE LAS VÍAS BILIARES"
  },
  {
    "codigo":288599003,
    "descripcion":"CAPAZ DE EMPLEAR LA COMUNICACIÓN VERBAL"
  },
  {
    "codigo":419671004,
    "descripcion":"TAQUICARDIA VENTRICULAR POLIMÓRFICA CATECOLAMINÉRGICA"
  },
  {
    "codigo":59223006,
    "descripcion":"JUVENIL"
  },
  {
    "codigo":24620004,
    "descripcion":"ANEMIA HEMOLÍTICA DEBIDA A BABESIOSIS"
  },
  {
    "codigo":253996006,
    "descripcion":"PALADAR HENDIDO COMPLETO DEL PALADAR BLANDO Y DURO"
  },
  {
    "codigo":286764006,
    "descripcion":"CARÁCTER HUMILDE"
  },
  {
    "codigo":1237036008,
    "descripcion":"METÁSTASIS DE CARCINOMA DE TERCIO MEDIO DE ESÓFAGO"
  },
  {
    "codigo":219393002,
    "descripcion":"HERIDAS DE GUERRA POR EXPLOSIÓN DE ARMAS MARINAS"
  },
  {
    "codigo":284929008,
    "descripcion":"NO UTILIZA ORINAL DE CAMA"
  },
  {
    "codigo":414166008,
    "descripcion":"LINFOMA EXTRAGANGLIONAR DE CÉLULAS NK\/T, TIPO NASAL"
  },
  {
    "codigo":248491001,
    "descripcion":"TUMEFACCIÓN DE REGIÓN DE RODILLA"
  },
  {
    "codigo":838315004,
    "descripcion":"ENCEFALOMIELITIS CAUSADA POR BURKHOLDERIA"
  },
  {
    "codigo":707243005,
    "descripcion":"QUEILITIS EXFOLIATIVA IDIOPÁTICA"
  },
  {
    "codigo":1295232000,
    "descripcion":"ANGIODISPLASIA DE TRACTO GASTROINTESTINAL"
  },
  {
    "codigo":443264000,
    "descripcion":"FÍSTULA ARTERIOVENOSA DE EXTREMIDAD SUPERIOR DERECHA"
  },
  {
    "codigo":770944002,
    "descripcion":"SÍNDROME OCULOOTODENTAL"
  },
  {
    "codigo":16002711000119105,
    "descripcion":"DOLOR DE MIEMBRO SUPERIOR DERECHO CONCOMITANTE CON ISQUEMIA Y DEBIDO A ELLA"
  },
  {
    "codigo":410496001,
    "descripcion":"ENDOFTALMITIS POSOPERATORIA ESTÉRIL"
  },
  {
    "codigo":50048006,
    "descripcion":"CON MAYOR RIESGO DE DÉFICIT DE VOLUMEN"
  },
  {
    "codigo":15730481000119100,
    "descripcion":"ESOTROPÍA POR DEPRIVACIÓN SENSITIVA DE OJO DERECHO"
  },
  {
    "codigo":836480008,
    "descripcion":"ESTENOSIS DE VÁLVULA AÓRTICA LEVE"
  },
  {
    "codigo":246656009,
    "descripcion":"PÉRDIDA DE PARTE DEL CAMPO VISUAL"
  },
  {
    "codigo":277589003,
    "descripcion":"NEOPLASIA MIELODISPLÁSICA\/MIELOPROLIFERATIVA CON NEUTROFILIA"
  },
  {
    "codigo":15445004,
    "descripcion":"GASTRITIS NO EROSIVA NO ESPECÍFICA ATRÓFICA"
  },
  {
    "codigo":769109006,
    "descripcion":"LEVADURA ENCAPSULADA DETECTADA"
  },
  {
    "codigo":1162325008,
    "descripcion":"OSTEONECROSIS DE HUESO DE MANO DEBIDA A HEMOGLOBINOPATÍA"
  },
  {
    "codigo":242986001,
    "descripcion":"LESIÓN CON PROPÓSITO DESCONOCIDO POR IMPACTO DE TREN EN MOVIMIENTO"
  },
  {
    "codigo":15648561000119102,
    "descripcion":"ANEURISMA DE ARTERIA CARÓTIDA IZQUIERDA"
  },
  {
    "codigo":308522003,
    "descripcion":"SITUACIÓN DEL CONTROL CLÍNICO"
  },
  {
    "codigo":603434003,
    "descripcion":"EDUCADO HASTA EL CICLO SUPERIOR DEL NIVEL DE ESCOLARIDAD SECUNDARIA"
  },
  {
    "codigo":110079005,
    "descripcion":"LACERACIÓN COMPLEJA DEL MENTÓN"
  },
  {
    "codigo":77311006,
    "descripcion":"ONFALOANGIÓPAGO"
  },
  {
    "codigo":208383007,
    "descripcion":"FRACTURA EXPUESTA DE ESCAFOIDES, CINTURA ESCAFOIDEA, CONMINUTA"
  },
  {
    "codigo":698068000,
    "descripcion":"RELACIÓN MAXILOMANDIBULAR CLASE II EN PACIENTE DESDENTADO"
  },
  {
    "codigo":403156002,
    "descripcion":"DERMATOSIS CAUSADA POR COELENTERATA"
  },
  {
    "codigo":370388006,
    "descripcion":"PACIENTE CON COMPROMISO INMUNOLÓGICO"
  },
  {
    "codigo":11853771000119100,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":401321000,
    "descripcion":"HOSPITAL NOTIFICADO DE LA DEFUNCIÓN"
  },
  {
    "codigo":304852009,
    "descripcion":"TRANSFERENCIA POSITIVA"
  },
  {
    "codigo":40873003,
    "descripcion":"SÍNDROME DE DEFICIENCIA DE SULFITO OXIDASA"
  },
  {
    "codigo":235646000,
    "descripcion":"INFECCIÓN DEL DISPOSITIVO ANTIRREFLUJO ESOFÁGICO"
  },
  {
    "codigo":170110001,
    "descripcion":"EXAMEN DEL NIÑO A LOS 10 DÍAS: ANORMAL - PARA OBSERVACIÓN"
  },
  {
    "codigo":1251454002,
    "descripcion":"METÁSTASIS DE NEUROBLASTOMA EN GLÁNDULA SUPRARRENAL"
  },
  {
    "codigo":366718006,
    "descripcion":"HALLAZGO RELACIONADO CON LA TEMPERATURA ARTICULAR"
  },
  {
    "codigo":364883000,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA TIRAR"
  },
  {
    "codigo":6270009,
    "descripcion":"ENFERMEDAD POR VIRUS BANZI"
  },
  {
    "codigo":71806009,
    "descripcion":"INTOXICACIÓN POR CENTAUREA SOLSTITIALIS"
  },
  {
    "codigo":69971003,
    "descripcion":"SÍNDROME DE HABER"
  },
  {
    "codigo":201043003,
    "descripcion":"CALLOSIDAD DEBAJO DE LA CABEZA DE METATARSIANO"
  },
  {
    "codigo":11771851000119104,
    "descripcion":"LUXACIÓN TRAUMÁTICA POSTERIOR NO EXPUESTA DE CODO DERECHO"
  },
  {
    "codigo":397651006,
    "descripcion":"EDAD ÓSEA-HALLAZGO"
  },
  {
    "codigo":266579006,
    "descripcion":"TRASTORNO INFLAMATORIO DE LA MAMA"
  },
  {
    "codigo":37203006,
    "descripcion":"ENFERMEDAD CAUSADA POR CALICIVIRUS"
  },
  {
    "codigo":168275007,
    "descripcion":"TÍTULOS DE MYCOPLASMA FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":233811008,
    "descripcion":"LESIÓN TRAUMÁTICA AGUDA INDIRECTA DE PULMÓN"
  },
  {
    "codigo":166440003,
    "descripcion":"HORMONAS SEXUALES FEMENINAS DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":789032004,
    "descripcion":"REQUIERE VACUNACIÓN CONTRA PESTE"
  },
  {
    "codigo":363048005,
    "descripcion":"TRASTORNO QUÍSTICO DEL SISTEMA LINFÁTICO"
  },
  {
    "codigo":112741000119100,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE SURCO ORBITARIO SUPERIOR"
  },
  {
    "codigo":723496007,
    "descripcion":"ENTEROPATÍA POR CÉLULAS ASESINAS NATURALES"
  },
  {
    "codigo":1149480007,
    "descripcion":"BACTERIEMIA CAUSADA POR PROTEUS"
  },
  {
    "codigo":299347009,
    "descripcion":"AMPLITUD DE EXTENSIÓN ACTIVA DE LA RODILLA AUMENTADA"
  },
  {
    "codigo":262909002,
    "descripcion":"PERFORACIÓN DE VEJIGA URINARIA"
  },
  {
    "codigo":295677000,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE ACLARRUBICINA"
  },
  {
    "codigo":361213004,
    "descripcion":"AUSENCIA CONGÉNITA DE PELVIS Y EXTREMIDAD INFERIOR"
  },
  {
    "codigo":426749004,
    "descripcion":"FIBRILACIÓN AURICULAR CRÓNICA"
  },
  {
    "codigo":461352007,
    "descripcion":"ORIFICIO DE ARTERIA CORONARIA CON FORMA DE HENDIDURA"
  },
  {
    "codigo":293842000,
    "descripcion":"ALERGIA A TRIPTÓFANO"
  },
  {
    "codigo":721661009,
    "descripcion":"AMILOIDOSIS DE INTESTINO DELGADO"
  },
  {
    "codigo":457682000,
    "descripcion":"OBSTRUCCIÓN DE VÁLVULA AÓRTICA DEBIDA A NEOPLASIA"
  },
  {
    "codigo":66301008,
    "descripcion":"INFECCIÓN CAUSADA POR SHIGELLA DEL GRUPO A"
  },
  {
    "codigo":719826004,
    "descripcion":"SÍNDROME DE DISCAPACIDAD INTELECTUAL LIGADA AL CROMOSOMA X CON ACROMEGALIA E HIPERACTIVIDAD"
  },
  {
    "codigo":228306008,
    "descripcion":"BEBE CON EXTRAÑOS"
  },
  {
    "codigo":95399003,
    "descripcion":"PARESTESIA DEL SITIO DE INYECCIÓN"
  },
  {
    "codigo":160935007,
    "descripcion":"GANANCIA FINANCIERA REPENTINA"
  },
  {
    "codigo":292007008,
    "descripcion":"INTOXICACIÓN POR HIDRALAZINA"
  },
  {
    "codigo":62631009,
    "descripcion":"QUISTE CONGÉNITO DEL SEGMENTO POSTERIOR DEL OJO"
  },
  {
    "codigo":93564004,
    "descripcion":"OSIFICACIÓN INCOMPLETA DE ARCO DE VÉRTEBRA CERVICAL"
  },
  {
    "codigo":124497002,
    "descripcion":"DEFICIENCIA DE PLASMINA"
  },
  {
    "codigo":288337004,
    "descripcion":"CAPAZ DE DIRIGIR (UN AUTOMÓVIL)"
  },
  {
    "codigo":58961005,
    "descripcion":"GRANULOMA MALIGNO DE LA CARA"
  },
  {
    "codigo":157265008,
    "descripcion":"LUXACIÓN DE ARTICULACIÓN DE LA CADERA"
  },
  {
    "codigo":253734000,
    "descripcion":"DIVERTÍCULO PERICÁRDICO"
  },
  {
    "codigo":24358005,
    "descripcion":"TEJIDO TÍMICO ACCESORIO"
  },
  {
    "codigo":286502005,
    "descripcion":"CAPAZ DE PREPARAR BEBIDAS"
  },
  {
    "codigo":89894006,
    "descripcion":"TOXICOSIS POR PENICILLIUM CYCLOPIUM"
  },
  {
    "codigo":778022009,
    "descripcion":"SÍNDROME EHLERS-DANLOS SIMILAR A CLÁSICO TIPO 1"
  },
  {
    "codigo":219131005,
    "descripcion":"INTOXICACIÓN AUTOINFLIGIDA CAUSADA POR GASES DE ESCAPE DE VEHÍCULO DE MOTOR"
  },
  {
    "codigo":413904000,
    "descripcion":"AFECCIÓN QUE EMPEORA CON EL TRABAJO"
  },
  {
    "codigo":250064001,
    "descripcion":"PRUEBA ÍNDICE-ÍNDICE ANORMAL"
  },
  {
    "codigo":53456000,
    "descripcion":"INTOXICACIÓN POR PINDONA"
  },
  {
    "codigo":446672004,
    "descripcion":"INFECCIÓN INTESTINAL CAUSADA POR VIBRIO CHOLERAE NO-O139"
  },
  {
    "codigo":332031000119106,
    "descripcion":"ESPASMO DE ACOMODACIÓN DE OJO DERECHO"
  },
  {
    "codigo":1003728008,
    "descripcion":"TRASTORNO FETAL DEBIDO A HIPERTENSIÓN MATERNA"
  },
  {
    "codigo":1264037004,
    "descripcion":"INFLAMACIÓN DE MÚSCULO DE PELVIS"
  },
  {
    "codigo":10899711000119108,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO OCULOMOTOR IZQUIERDO"
  },
  {
    "codigo":248229009,
    "descripcion":"SÍNTOMA VASOVAGAL"
  },
  {
    "codigo":10653951000119109,
    "descripcion":"ÚLCERA ISQUÉMICA DE DEDO DE PIE IZQUIERDO DEBIDA A ENFERMEDAD ATEROSCLERÓTICA"
  },
  {
    "codigo":770682007,
    "descripcion":"NEOPLASIA GLIONEURONAL FORMADORA DE ROSETAS"
  },
  {
    "codigo":443002008,
    "descripcion":"CONDROCALCINOSIS DE ARTICULACIÓN DE CADERA"
  },
  {
    "codigo":211791004,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO DE GLÚTEO"
  },
  {
    "codigo":305561000119105,
    "descripcion":"CONTRACTURA DE ARTICULACIÓN DE RODILLA DERECHA"
  },
  {
    "codigo":703311009,
    "descripcion":"ARTERITIS CEREBRAL DEBIDA A ENFERMEDAD INFECCIOSA"
  },
  {
    "codigo":275492001,
    "descripcion":"CARCINOMA IN SITU DE BASE DE LENGUA - CARA DORSAL"
  },
  {
    "codigo":373796003,
    "descripcion":"DIAGNÓSTICO DE CÁNCER BASADO EN LAS INVESTIGACIONES, SIN DIAGNÓSTICO POR ESTUDIO HISTOLÓGICO"
  },
  {
    "codigo":472100003,
    "descripcion":"MIOCARDIOPATÍA ISQUÉMICA DILATADA DEBIDA A ENFERMEDAD CORONARIA"
  },
  {
    "codigo":209956005,
    "descripcion":"HEMORRAGIA SUBDURAL POSTERIOR A HERIDA ABIERTA DE LA CABEZA"
  },
  {
    "codigo":109817001,
    "descripcion":"HERNIA INTERSIGMOIDEA"
  },
  {
    "codigo":406564009,
    "descripcion":"INFECCIÓN DEL SISTEMA NERVIOSO CENTRAL POR BRUCELLA"
  },
  {
    "codigo":240889003,
    "descripcion":"PRURITO POR PYEMOTES TRITICI"
  },
  {
    "codigo":688691000119102,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE PARED ANTERIOR DE VEJIGA URINARIA"
  },
  {
    "codigo":1254862001,
    "descripcion":"ESCLERODERMA ASOCIADO CON PARAPROTEINEMIA"
  },
  {
    "codigo":402894005,
    "descripcion":"HERPES SIMPLEX GENITAL RECURRENTE"
  },
  {
    "codigo":16581000146103,
    "descripcion":"NECESITA AYUDA PARA CAMINAR"
  },
  {
    "codigo":206286008,
    "descripcion":"NEUMONÍA CONGÉNITA POR ESCHERICHIA COLI"
  },
  {
    "codigo":401059001,
    "descripcion":"ADMINISTRACIÓN DE LA OBTENCIÓN DE LA HISTORIA CLÍNICA"
  },
  {
    "codigo":106147001,
    "descripcion":"HALLAZGO SENSITIVO EN EL SISTEMA NERVIOSO"
  },
  {
    "codigo":239054009,
    "descripcion":"ANOMALÍA DE LOS PLIEGUES CUTÁNEOS RETICULOPIGMENTADOS"
  },
  {
    "codigo":9678009,
    "descripcion":"MENINGOENCEFALITIS CAUSADA POR VIRUS DE HERPES SIMPLE HUMANO"
  },
  {
    "codigo":827043006,
    "descripcion":"SOPLO SISTÓLICO EN EL VÉRTICE DEL CORAZÓN"
  },
  {
    "codigo":204451006,
    "descripcion":"ANOMALÍAS DE LAS GRANDES VENAS"
  },
  {
    "codigo":38776003,
    "descripcion":"AUSENCIA CONGÉNITA DE MÚSCULO ESQUELÉTICO"
  },
  {
    "codigo":300920004,
    "descripcion":"ATEROSCLEROSIS DE ARTERIA CARÓTIDA"
  },
  {
    "codigo":366456006,
    "descripcion":"HALLAZGO RELACIONADO CON ESTRUCTURA GENERAL DE TÓRAX"
  },
  {
    "codigo":202616007,
    "descripcion":"CHASQUIDO DE ARTICULACIÓN METATARSOFALÁNGICA DE SEGUNDO A QUINTO DEDOS"
  },
  {
    "codigo":102477003,
    "descripcion":"REACCIÓN INEVALUABLE"
  },
  {
    "codigo":276403006,
    "descripcion":"MUÑÓN UMBILICAL PEGAJOSO"
  },
  {
    "codigo":461090007,
    "descripcion":"CONDUCTO ARTERIOSO DERECHO"
  },
  {
    "codigo":395554007,
    "descripcion":"INVASIÓN TUMORAL VENOSA (GRANDES VASOS)\/ LINFÁTICA (PEQUEÑOS VASOS), INDETERMINADA"
  },
  {
    "codigo":1149218009,
    "descripcion":"ARTRITIS REUMATOIDE CON VASCULITIS AISLADA DE PLIEGUE UNGUEAL"
  },
  {
    "codigo":428322007,
    "descripcion":"NEOPLASIA MALIGNA DE ANEXOS UTERINOS"
  },
  {
    "codigo":334541000119104,
    "descripcion":"QUERATOMALACIA DE OJO DERECHO"
  },
  {
    "codigo":35106007,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN DE RODILLA"
  },
  {
    "codigo":426487006,
    "descripcion":"EFECTO TÓXICO DE LA INGESTIÓN DE MOLUSCOS"
  },
  {
    "codigo":295415009,
    "descripcion":"SOBREDOSIS DE NABILONA"
  },
  {
    "codigo":721399009,
    "descripcion":"SÍNDROME DE BROWN-SEQUARD AL NIVEL DEL PRIMER SEGMENTO CERVICAL"
  },
  {
    "codigo":1145548001,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR ÁCIDO NICOTÍNICO"
  },
  {
    "codigo":195276004,
    "descripcion":"ANEURISMA DE ARTERIA ILÍACA EXTERNA"
  },
  {
    "codigo":129740002,
    "descripcion":"LESIÓN ENMASCARADA"
  },
  {
    "codigo":62369005,
    "descripcion":"ENFERMEDAD SUBAGUDA DE LA MONTAÑA"
  },
  {
    "codigo":226209005,
    "descripcion":"DIETA CON ALTO CONTENIDO DE LÍQUIDOS"
  },
  {
    "codigo":95137009,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE CONDUCTO TIROGLOSO"
  },
  {
    "codigo":160673009,
    "descripcion":"DIETA HIPOPROTEICA"
  },
  {
    "codigo":93302004,
    "descripcion":"HIPOPLASIA CONGÉNITA DEL VÓMER"
  },
  {
    "codigo":58699001,
    "descripcion":"DILATACIÓN CERVICAL, 2CM"
  },
  {
    "codigo":16036711000119104,
    "descripcion":"DETENCIÓN DE CRECIMIENTO EPIFISARIO DE ANTEBRAZO IZQUIERDO"
  },
  {
    "codigo":308071000119104,
    "descripcion":"HIPERLAXITUD ARTICULAR DE RODILLA DERECHA"
  },
  {
    "codigo":1303883005,
    "descripcion":"TROMBOSIS VENOSA PROFUNDA DE VENA TIBIAL POSTERIOR DERECHA"
  },
  {
    "codigo":56864005,
    "descripcion":"INTOXICACIÓN POR BACCHARIS"
  },
  {
    "codigo":253472006,
    "descripcion":"DISPLASIA DE VALVA DE VÁLVULA AURICULOVENTRICULAR DERECHA"
  },
  {
    "codigo":286240009,
    "descripcion":"DIFICULTAD PARA COORDINAR EL FLUJO DE AIRE CON LA EMISIÓN DE LA VOZ"
  },
  {
    "codigo":1300213006,
    "descripcion":"FOBIA AL ATRAGANTAMIENTO"
  },
  {
    "codigo":218869007,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR BROMURO DE PENTAMETONIO"
  },
  {
    "codigo":53194005,
    "descripcion":"ATETOSIS POSTHEMIPLÉJICA"
  },
  {
    "codigo":1003466007,
    "descripcion":"TRASTORNO FETAL DEBIDO A ENFERMEDAD AUTOINMUNITARIA MATERNA"
  },
  {
    "codigo":247967000,
    "descripcion":"LIMPIEZA COMPULSIVA"
  },
  {
    "codigo":1296543002,
    "descripcion":"HIPERTENSIÓN OCULAR DE OJO DERECHO DEBIDA A TRAUMATISMO OCULAR"
  },
  {
    "codigo":49524007,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE INGLE CON INFECCIÓN"
  },
  {
    "codigo":16756008,
    "descripcion":"ALBUMINURIA EN EL EMBARAZO SIN HIPERTENSIÓN"
  },
  {
    "codigo":735817001,
    "descripcion":"RUPTURA TRAUMÁTICA DE LIGAMENTO DE MUÑECA"
  },
  {
    "codigo":14921002,
    "descripcion":"SÍNDROME DE AARSKOG"
  },
  {
    "codigo":703049003,
    "descripcion":"DEFORMIDAD EN VALGO DE DEDO GORDO A NIVEL DE ARTICULACIÓN INTERFALÁNGICA"
  },
  {
    "codigo":1260105007,
    "descripcion":"CICATRIZ DE MEMBRANA MUCOSA DE LABIO SUPERIOR"
  },
  {
    "codigo":1074331000119102,
    "descripcion":"ARTROSIS SECUNDARIA DE CADERA DERECHA"
  },
  {
    "codigo":111390002,
    "descripcion":"AMILOIDOSIS CUTÁNEA LOCALIZADA PRIMARIA DOMINANTE"
  },
  {
    "codigo":733982004,
    "descripcion":"CARIES DENTAL ACTIVA SECUNDARIA QUE SE EXTIENDE HASTA LA PULPA"
  },
  {
    "codigo":78622004,
    "descripcion":"GALACTORREA NO ASOCIADA CON EL NACIMIENTO"
  },
  {
    "codigo":11251000,
    "descripcion":"CISTITIS POR RADIACIÓN"
  },
  {
    "codigo":209694008,
    "descripcion":"SECCIÓN EXPUESTA DE LIGAMENTO LATERAL EXTERNO DE LA RODILLA"
  },
  {
    "codigo":766750008,
    "descripcion":"DISPLASIA EPIFISARIA MÚLTIPLE CON MINIEPÍFISIS"
  },
  {
    "codigo":1354739007,
    "descripcion":"FRACTURA DE OCTAVA COSTILLA"
  },
  {
    "codigo":1156296001,
    "descripcion":"NEUTROPENIA ADQUIRIDA"
  },
  {
    "codigo":74952004,
    "descripcion":"EDAD GESTACIONAL, 3 SEMANAS"
  },
  {
    "codigo":11805851000119106,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA PROXIMAL DE DEDO MEDIO DERECHO"
  },
  {
    "codigo":238792006,
    "descripcion":"ÚLCERA ARTERIOVENOSA MIXTA DE LA PIERNA"
  },
  {
    "codigo":304328006,
    "descripcion":"AMPLITUD DE MOVIMIENTO DEL PIE NORMAL"
  },
  {
    "codigo":402632008,
    "descripcion":"CAMBIO DEL COLOR UNGUEAL POR FÁRMACO INGERIDO"
  },
  {
    "codigo":7581004,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE LA CONJUNTIVA"
  },
  {
    "codigo":204189006,
    "descripcion":"ESTENOSIS CONGÉNITA DE LA ARTERIA RETINIANA"
  },
  {
    "codigo":366194001,
    "descripcion":"FLUJO SANGUÍNEO DEL VENTRÍCULO DERECHO - HALLAZGO"
  },
  {
    "codigo":300658002,
    "descripcion":"CAPAZ DE REALIZAR ACTIVIDADES RELACIONADAS CON EL USO DE MEDIOS DE TRANSPORTE"
  },
  {
    "codigo":267890003,
    "descripcion":"ARTROSIS SECUNDARIA LOCALIZADA DEL MUSLO Y DE LA REGIÓN PÉLVICA"
  },
  {
    "codigo":235122006,
    "descripcion":"SIALOADENITIS VIRAL AGUDA"
  },
  {
    "codigo":298823002,
    "descripcion":"AMPLITUD DE ROTACIÓN INTERNA ACTIVA DE ARTICULACIÓN DE HOMBRO, DISMINUIDA"
  },
  {
    "codigo":167751005,
    "descripcion":"GLOBULINAS EN LÍQUIDO CEFALORRAQUÍDEO POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":724807008,
    "descripcion":"GLIOMA DE SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":296988002,
    "descripcion":"SOBREDOSIS INTENCIONAL DE QUINIDINA"
  },
  {
    "codigo":722972004,
    "descripcion":"TRASTORNO DE TIC SECUNDARIO"
  },
  {
    "codigo":231452004,
    "descripcion":"SÍNDROME DE PERSONALIDAD POR EPILEPSIA LÍMBICA"
  },
  {
    "codigo":1148956006,
    "descripcion":"SISTEMA ENDOCRINO NORMAL"
  },
  {
    "codigo":295153005,
    "descripcion":"SOBREDOSIS DE DEXTROPROPOXIFENO"
  },
  {
    "codigo":241006,
    "descripcion":"EPILEPSIA PARCIAL CONTINUA"
  },
  {
    "codigo":424390001,
    "descripcion":"PARO CARDÍACO CAUSADO POR ELECTROCUCIÓN"
  },
  {
    "codigo":63942007,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO DEL TRONCO"
  },
  {
    "codigo":193179000,
    "descripcion":"POLINEUROPATÍA EN LA POLIARTERITIS NUDOSA"
  },
  {
    "codigo":162246009,
    "descripcion":"SÍNTOMAS SENSITIVOS"
  },
  {
    "codigo":719302009,
    "descripcion":"ATAXIA ESPINOCEREBELOSA TIPO 5"
  },
  {
    "codigo":94875001,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA CARA INTERNA DE LABIO"
  },
  {
    "codigo":1208987006,
    "descripcion":"SÍNDROME DE TRASTORNO DE CONDUCTA, DISCAPACIDAD INTELECTUAL, OBESIDAD Y RASGOS DISMÓRFICOS ASOCIADO A GEN PHIP"
  },
  {
    "codigo":422555009,
    "descripcion":"AMBIENTE CON ELEVADO NIVEL DE CONTAMINACIÓN"
  },
  {
    "codigo":783003009,
    "descripcion":"DISPLASIA TORACOMÉLICA"
  },
  {
    "codigo":715632003,
    "descripcion":"ALBINISMO OCULOCUTÁNEO TIPO 4"
  },
  {
    "codigo":289648008,
    "descripcion":"POSICIÓN NORMAL DEL ÚTERO"
  },
  {
    "codigo":93040009,
    "descripcion":"BLEFAROFIMOSIS CONGÉNITA"
  },
  {
    "codigo":11834831000119107,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN DE PULGAR DERECHO"
  },
  {
    "codigo":58437007,
    "descripcion":"MENINGITIS TUBERCULOSA"
  },
  {
    "codigo":123973009,
    "descripcion":"FRACTURA DE MONTEGGIA"
  },
  {
    "codigo":285978005,
    "descripcion":"CAPAZ DE CONTROLAR EL TERMOSTATO EN EL HOGAR"
  },
  {
    "codigo":284143002,
    "descripcion":"DIFICULTAD PARA MOVER EL BRAZO"
  },
  {
    "codigo":54767005,
    "descripcion":"TRASTORNO DE LAS VÍAS ÓPTICAS"
  },
  {
    "codigo":20164002,
    "descripcion":"INFECCIÓN CAUSADA POR TROGLOSTRONGYLUS"
  },
  {
    "codigo":413380004,
    "descripcion":"ESTRABISMO CON PATRÓN EN A"
  },
  {
    "codigo":282308005,
    "descripcion":"DIFICULTAD PARA MANTENER EL EQUILIBRIO SENTADO"
  },
  {
    "codigo":249540008,
    "descripcion":"OMBLIGO HUNDIDO"
  },
  {
    "codigo":85700008,
    "descripcion":"MICROHEPATÍA"
  },
  {
    "codigo":870297003,
    "descripcion":"MIOPATÍA DEBIDA A ALCOHOLISMO CRÓNICO"
  },
  {
    "codigo":247705004,
    "descripcion":"PERCEPCIÓN DE QUE LAS COSAS CAMBIAN DE FORMA"
  },
  {
    "codigo":51097006,
    "descripcion":"HIPERGLICINEMIA NEONATAL TRANSITORIA"
  },
  {
    "codigo":444313007,
    "descripcion":"INFECCIÓN CAUSADA POR BACTEROIDES FRAGILIS"
  },
  {
    "codigo":349851000221104,
    "descripcion":"HEPATITIS B EXPUESTO PERINATAL"
  },
  {
    "codigo":213102002,
    "descripcion":"MOVILIDAD DE DISPOSITIVO DE FIJACIÓN ESPINAL"
  },
  {
    "codigo":442478007,
    "descripcion":"EMBARAZO MÚLTIPLE QUE INCLUYE EMBARAZO INTRAUTERINO Y EMBARAZO TUBARIO"
  },
  {
    "codigo":278638008,
    "descripcion":"PRÓTESIS DENTAL MUY VOLUMINOSA"
  },
  {
    "codigo":735555003,
    "descripcion":"ABSCESO PROFUNDO DE HEMISFERIO CEREBRAL"
  },
  {
    "codigo":15632131000119104,
    "descripcion":"FIBROMATOSIS DE LA FASCIA PLANTAR DE AMBOS PIES"
  },
  {
    "codigo":276803003,
    "descripcion":"ADENOCARCINOMA DE ESÓFAGO"
  },
  {
    "codigo":897560004,
    "descripcion":"VÉRTEBRA EN MARIPOSA"
  },
  {
    "codigo":78360004,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE TOBILLO CON INFECCIÓN"
  },
  {
    "codigo":1290776006,
    "descripcion":"PERIAORTITIS RELACIONADA CON INMUNOGLOBULINA G4"
  },
  {
    "codigo":240365002,
    "descripcion":"INFECCIÓN INTESTINAL POR FLAGELADO"
  },
  {
    "codigo":371437003,
    "descripcion":"DEFICIENCIA DE SELENIO Y\/O VITAMINA E"
  },
  {
    "codigo":305901004,
    "descripcion":"ATENDIDO EN EL SERVICIO DE CIRUGÍA DE TRASPLANTES"
  },
  {
    "codigo":368541000119101,
    "descripcion":"QUEIROARTROPATÍA DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":15933341000119101,
    "descripcion":"ANOMALÍA CONGÉNITA DE TROMPA DE FALOPIO DERECHA"
  },
  {
    "codigo":10989008,
    "descripcion":"PIE EQUINO"
  },
  {
    "codigo":109293009,
    "descripcion":"NEVO MELANOCÍTICO DE LA EXTREMIDAD INFERIOR"
  },
  {
    "codigo":238530002,
    "descripcion":"ACNÉ EXACERBADO POR LUZ"
  },
  {
    "codigo":402370004,
    "descripcion":"SARCOIDOSIS ULCERATIVA"
  },
  {
    "codigo":1285271000,
    "descripcion":"RANGO ACTIVO DE FLEXIÓN PLANTAR DE TOBILLO AUMENTADO"
  },
  {
    "codigo":1186967001,
    "descripcion":"PERIODONTITIS DEBIDA A DEFICIENCIA DE LA ADHESIÓN LEUCOCITARIA"
  },
  {
    "codigo":72855002,
    "descripcion":"PROGNATISMO CONGÉNITO"
  },
  {
    "codigo":203927003,
    "descripcion":"INIENCEFALIA CERRADA"
  },
  {
    "codigo":269463006,
    "descripcion":"NEOPLASIA MALIGNA DE OÍDO MEDIO Y MASTOIDES"
  },
  {
    "codigo":236695007,
    "descripcion":"ESTRECHAMIENTO DE LA URETRA POSINFLAMATORIO"
  },
  {
    "codigo":171159007,
    "descripcion":"DETECCIÓN SELECTIVA DE CÁNCER CERVICAL - RESULTADOS AÚN NO RECIBIDOS"
  },
  {
    "codigo":726380001,
    "descripcion":"DELECIÓN DE PARTE DEL CROMOSOMA 10"
  },
  {
    "codigo":302231008,
    "descripcion":"INFECCIÓN POR SALMONELLA"
  },
  {
    "codigo":890220003,
    "descripcion":"TRASTORNO AÓRTICO ASOCIADO CON VÁLVULA AÓRTICA BICÚSPIDE"
  },
  {
    "codigo":267628004,
    "descripcion":"CONSTRICCIÓN GENERALIZADA DEL CAMPO VISUAL"
  },
  {
    "codigo":365932005,
    "descripcion":"PERCENTILOS DE PESO DEL NIÑO - HALLAZGO"
  },
  {
    "codigo":431468008,
    "descripcion":"SÍNDROME DE COLAPSO VENTRICULAR"
  },
  {
    "codigo":300396008,
    "descripcion":"PIEL DE LA PARED ABDOMINAL ESTIRADA"
  },
  {
    "codigo":724545004,
    "descripcion":"TIC DEBIDO A INFECCIÓN Y POSTERIOR A ELLA"
  },
  {
    "codigo":3649004,
    "descripcion":"CONTUSIÓN DE SITIOS MÚLTIPLES DEL TRONCO"
  },
  {
    "codigo":36417005,
    "descripcion":"FRACTURA NO EXPUESTA DE ISQUION"
  },
  {
    "codigo":1052225007,
    "descripcion":"DISFUNCIÓN LABERÍNTICA HIPERACTIVA DE OÍDO INTERNO DERECHO"
  },
  {
    "codigo":298561008,
    "descripcion":"SIN AMPLITUD DE ROTACIÓN PASIVA HACIA LA DERECHA DE LA COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":296726007,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE CEFODIZIMA"
  },
  {
    "codigo":131051000,
    "descripcion":"PROGESTERONA ANORMAL"
  },
  {
    "codigo":1148694009,
    "descripcion":"DEFICIENCIA DE VASOPRESINA POSQUIRÚRGICA"
  },
  {
    "codigo":1179627006,
    "descripcion":"DISTRÉS RESPIRATORIO NEONATAL"
  },
  {
    "codigo":425963007,
    "descripcion":"ANEURISMA DE AORTA ASCENDENTE"
  },
  {
    "codigo":10663991000119105,
    "descripcion":"ÚLCERA ISQUÉMICA ATEROSCLERÓTICA DE PIERNA IZQUIERDA"
  },
  {
    "codigo":15988791000119105,
    "descripcion":"CONJUNTIVITIS NEONATAL DE OJO DERECHO CAUSADA POR NEISSERIA GONORRHOEAE"
  },
  {
    "codigo":293056002,
    "descripcion":"REACCIÓN ADVERSA A TETRACICLINA"
  },
  {
    "codigo":719040004,
    "descripcion":"ANAFILAXIA CAUSADA POR HARINA DE LUPINO"
  },
  {
    "codigo":717205000,
    "descripcion":"KLEBSIELLA PNEUMONIAE SUBESPECIE PNEUMONIAE O RAOULTELLA PLANTICOLA O RAOULTELLA TERRIGENA"
  },
  {
    "codigo":260288008,
    "descripcion":"VISIÓN A DISTANCIA 1\/24"
  },
  {
    "codigo":1079351000119107,
    "descripcion":"NEOPLASIA BENIGNA DE PIEL DE PÁRPADO IZQUIERDO"
  },
  {
    "codigo":422293003,
    "descripcion":"CLASE IV DE LA CLASIFICACIÓN DE LA ASOCIACIÓN CARDIOLÓGICA DE NUEVA YORK (NEW YORK HEART ASSOCIATION CLASSIFICATION)"
  },
  {
    "codigo":291221000,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR ZUCLOPENTIXOL"
  },
  {
    "codigo":1208725005,
    "descripcion":"SÍNDROME DE LINFANGIOENDOTELIOMATOSIS MULTIFOCAL Y TROMBOCITOPENIA"
  },
  {
    "codigo":94613003,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA PARED SUPERIOR DE LA NASOFARINGE"
  },
  {
    "codigo":24328004,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE PIE SIN INFECCIÓN"
  },
  {
    "codigo":1010282001,
    "descripcion":"TRASTORNO NEONATAL DEBIDO A LESIÓN TRAUMÁTICA MATERNA"
  },
  {
    "codigo":96311000119109,
    "descripcion":"EXACERBACIÓN DE INSUFICIENCIA CARDÍACA CONGESTIVA"
  },
  {
    "codigo":289386005,
    "descripcion":"NIVEL 4 DE LA PRESENTACIÓN EN RELACIÓN CON LAS ESPINAS ISQUIÁTICAS"
  },
  {
    "codigo":1303359005,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN DE MEÑIQUE"
  },
  {
    "codigo":123711007,
    "descripcion":"DISTROFIA PARCIAL DE LA UÑA"
  },
  {
    "codigo":1137684004,
    "descripcion":"PERFUSIÓN A LA HERIDA NORMAL"
  },
  {
    "codigo":11784401000119106,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE DEDO MEÑIQUE IZQUIERDO"
  },
  {
    "codigo":21737000,
    "descripcion":"TEJIDO FETAL RETENIDO"
  },
  {
    "codigo":283881002,
    "descripcion":"CONFABULACIÓN FANTÁSTICA"
  },
  {
    "codigo":185577006,
    "descripcion":"PRIMERA FALLA EN CRIBADO PARA ALTERACIONES AUDITIVAS EN NIÑOS"
  },
  {
    "codigo":1363390000,
    "descripcion":"SINEQUIAS ANTERIORES PERIFÉRICAS EN CUADRANTE SUPERIOR DE ÁNGULO IRIDOCORNEAL DE OJO DERECHO"
  },
  {
    "codigo":87273009,
    "descripcion":"TEMPERATURA CORPORAL NORMAL"
  },
  {
    "codigo":773566003,
    "descripcion":"INCAPAZ DE INICIAR LA MARCHA"
  },
  {
    "codigo":708030004,
    "descripcion":"ENFISEMA PULMONAR CON FIBROSIS PULMONAR CONCOMITANTE"
  },
  {
    "codigo":118206005,
    "descripcion":"HALLAZGO RELACIONADO CON EL REQUERIMIENTO HORMONAL"
  },
  {
    "codigo":85438006,
    "descripcion":"ENFERMEDAD POR TIERRA DIATOMÁCEA"
  },
  {
    "codigo":183742007,
    "descripcion":"CONSULTA DOMICILIARIA INMUNOLÓGICA, REALIZADA"
  },
  {
    "codigo":1197715000,
    "descripcion":"TRASTORNO FUNCIONAL DE TRACTO GASTROINTESTINAL INFANTIL"
  },
  {
    "codigo":871870009,
    "descripcion":"CAPAZ DE DEMOSTRAR CONOCIMIENTOS RELACIONADOS CON LA SALUD"
  },
  {
    "codigo":247443000,
    "descripcion":"CAVIDAD EN LA PIEL"
  },
  {
    "codigo":46121000087100,
    "descripcion":"ESGUINCE DE LIGAMENTO SACROESPINOSO DERECHO"
  },
  {
    "codigo":33321000087106,
    "descripcion":"ACHROMOBACTER DENITRIFICANS O ACHROMOBACTER XYLOSOXIDANS"
  },
  {
    "codigo":1163112003,
    "descripcion":"COLITIS POR ESCHERICHIA COLI ENTEROPATÓGENA"
  },
  {
    "codigo":43561000087109,
    "descripcion":"CONTUSIÓN DE PÁRPADO INFERIOR DERECHO"
  },
  {
    "codigo":704360006,
    "descripcion":"CON MAYOR RIESGO DE INFECCIÓN DE OJO"
  },
  {
    "codigo":1259581001,
    "descripcion":"DEMENCIA DEBIDA A ENFERMEDAD CELÍACA"
  },
  {
    "codigo":309309002,
    "descripcion":"NO DETECTADO POR PRUEBA DE CITOLOGÍA"
  },
  {
    "codigo":276541002,
    "descripcion":"ASPIRACIÓN NEONATAL DE MOCO"
  },
  {
    "codigo":373010001,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM AICHIENSE"
  },
  {
    "codigo":241938005,
    "descripcion":"ANAFILAXIA PRODUCIDA POR PENICILINA"
  },
  {
    "codigo":209170009,
    "descripcion":"SUBLUXACIÓN NO EXPUESTA DE LA COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":240103002,
    "descripcion":"MIOPATÍA POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":1255911005,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO CRURAL POSTERIOR DE PIERNA"
  },
  {
    "codigo":403943008,
    "descripcion":"TUMOR MIXTO MALIGNO DE PIEL"
  },
  {
    "codigo":1155772001,
    "descripcion":"INTOXICACIÓN CAUSADA POR ESTIMULANTE DEL SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":74428002,
    "descripcion":"TRANSFECCIÓN GENÉTICA"
  },
  {
    "codigo":1286844003,
    "descripcion":"CIERRE DE ÁNGULO POSOPERATORIO AGUDO"
  },
  {
    "codigo":860860004,
    "descripcion":"ENFERMEDAD POR ALMACENAMIENTO DE GLUCÓGENO TIPO IXB"
  },
  {
    "codigo":1081861000119105,
    "descripcion":"CARCINOMA MICROCÍTICO PRIMARIO DE LÓBULO SUPERIOR DE PULMÓN IZQUIERDO"
  },
  {
    "codigo":305639009,
    "descripcion":"ATENDIDO POR ASOCIADO DEL MÉDICO GENERAL"
  },
  {
    "codigo":236433006,
    "descripcion":"INSUFICIENCIA RENAL CRÓNICA REAGUDIZADA"
  },
  {
    "codigo":203665007,
    "descripcion":"SÍNDROME DE LA ESPALDA PLANA"
  },
  {
    "codigo":16046751000119102,
    "descripcion":"ENFERMEDAD POR DEPÓSITO DE HIDROXIAPATITA DE AMBAS RODILLAS"
  },
  {
    "codigo":301969006,
    "descripcion":"ORIFICIO LAGRIMAL SUPERIOR AUSENTE"
  },
  {
    "codigo":344581000119108,
    "descripcion":"CORIORRETINITIS FOCAL PERIFÉRICA DE AMBOS OJOS"
  },
  {
    "codigo":1217638003,
    "descripcion":"DEPÓSITOS CORNEALES POR TRASTORNO METABÓLICO"
  },
  {
    "codigo":234598004,
    "descripcion":"DEFICIENCIA EL COMPLEMENTO 1S"
  },
  {
    "codigo":365670007,
    "descripcion":"HALLAZGO RELACIONADO CON EL OLOR DEL ESPÉCIMEN"
  },
  {
    "codigo":3387000,
    "descripcion":"AFASIA DE DISCRIMINACIÓN AUDITIVA"
  },
  {
    "codigo":726118008,
    "descripcion":"CICATRIZ TRAUMÁTICA DE PÁRPADO"
  },
  {
    "codigo":724283004,
    "descripcion":"LEUCODISTROFIA HIPOMIELINIZANTE CON ATROFIA DE GANGLIOS BASALES Y CEREBELO"
  },
  {
    "codigo":167227004,
    "descripcion":"ORINA DE LA MITAD DEL CHORRO MICCIONAL = SIN CRECIMIENTO"
  },
  {
    "codigo":413747009,
    "descripcion":"EXUDADO EN GOTAS DE CERA DE VELA"
  },
  {
    "codigo":198160001,
    "descripcion":"CELULITIS PÉLVICA CRÓNICA FEMENINA"
  },
  {
    "codigo":36155008,
    "descripcion":"HEPATITIS EN ENFERMEDAD VIRAL POR COXSACKIE"
  },
  {
    "codigo":296464005,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE ETRETINATO"
  },
  {
    "codigo":1179365005,
    "descripcion":"EPISTAXIS FETAL"
  },
  {
    "codigo":15637151000119108,
    "descripcion":"TENDINITIS DE LA PORCIÓN LARGA DEL MÚSCULO BÍCEPS BRAQUIAL DE AMBOS HOMBROS"
  },
  {
    "codigo":292794000,
    "descripcion":"REACCIÓN ADVERSA A LA HIPROMELOSA"
  },
  {
    "codigo":294629009,
    "descripcion":"ALERGIA A FENOTRINA"
  },
  {
    "codigo":318111000119108,
    "descripcion":"ARTRITIS REACTIVA DE ARTICULACIÓN DE CADERA DERECHA DEBIDA A DISENTERÍA Y POSTERIOR A ELLA"
  },
  {
    "codigo":161722004,
    "descripcion":"PÉRDIDA MENSTRUAL EN AUMENTO"
  },
  {
    "codigo":784314006,
    "descripcion":"ADENOMIOSIS DE ÚTERO"
  },
  {
    "codigo":127119001,
    "descripcion":"LINFADENOPATÍA YUXTAINTESTINAL"
  },
  {
    "codigo":389263004,
    "descripcion":"DISPLASIA DE ASTLEY - KENDALL"
  },
  {
    "codigo":94351005,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LOS GANGLIOS LINFÁTICOS INTRATORÁCICOS"
  },
  {
    "codigo":290959005,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR PRIMIDONA"
  },
  {
    "codigo":192655005,
    "descripcion":"MENINGITIS POR ESCHERICHIA COLI"
  },
  {
    "codigo":289124000,
    "descripcion":"CAPAZ DE REALIZAR ACTIVIDADES PARA EL CUIDADO DE LA BOCA"
  },
  {
    "codigo":1306767005,
    "descripcion":"DESPRENDIMIENTO BILATERAL DE RETINA"
  },
  {
    "codigo":59748008,
    "descripcion":"LACERACIÓN DE LA CORTEZA CEREBRAL CON HERIDA INTRACRANEAL ABIERTA"
  },
  {
    "codigo":1237561001,
    "descripcion":"VENA VARICOSA DE MUSLO DERECHO"
  },
  {
    "codigo":715108009,
    "descripcion":"NO PASA DEL INODORO A LA SILLA DE RUEDAS"
  },
  {
    "codigo":254521005,
    "descripcion":"NEOPLASIA BENIGNA DE EPIGLOTIS INFRAHIOIDEA"
  },
  {
    "codigo":188985006,
    "descripcion":"LIPOMA DE MEJILLA"
  },
  {
    "codigo":449294002,
    "descripcion":"SARCOMA DE OMÓPLATO"
  },
  {
    "codigo":1268494007,
    "descripcion":"QUEMADURA DE TEJIDO PERIOCULAR"
  },
  {
    "codigo":840675000,
    "descripcion":"DEFORMIDAD DE ARTICULACIÓN FIBROSA"
  },
  {
    "codigo":285454007,
    "descripcion":"CAPAZ DE ABRIR Y CERRAR LA BOCA"
  },
  {
    "codigo":283619007,
    "descripcion":"HERIDA POR PINCHAZO DE AGUJA EN DEDO DE LA MANO"
  },
  {
    "codigo":87011009,
    "descripcion":"INTOXICACIÓN POR EUPATORIUM ADENOPHORUM"
  },
  {
    "codigo":460161000124100,
    "descripcion":"FRACTURA DE HUESO DE MANO IZQUIERDA"
  },
  {
    "codigo":609464004,
    "descripcion":"INTERRUPCIÓN INDUCIDA DEL EMBARAZO COMPLICADA POR ENDOMETRITIS"
  },
  {
    "codigo":773304004,
    "descripcion":"DISPLASIA ESPONDILOMETAFISARIA TIPO GOLDEN"
  },
  {
    "codigo":314552006,
    "descripcion":"ASTIGMATISMO POR INJERTO CORNEAL"
  },
  {
    "codigo":19640007,
    "descripcion":"DISFUNCIÓN DE LA ENTEROSTOMÍA"
  },
  {
    "codigo":50573001,
    "descripcion":"HEMORRAGIA DE PENE"
  },
  {
    "codigo":771469002,
    "descripcion":"SÍNDROME DE ATAXIA ESPÁSTICA, EPILEPSIA MIOCLÓNICA, NEUROPATÍA DE INICIO TEMPRANO"
  },
  {
    "codigo":15967341000119100,
    "descripcion":"ESTENOSIS DE ARTERIA SUBCLAVIA DERECHA"
  },
  {
    "codigo":83341004,
    "descripcion":"PERIFOLICULITIS"
  },
  {
    "codigo":85176007,
    "descripcion":"INTOXICACIÓN POR GÉNERO HELICHRYSUM"
  },
  {
    "codigo":470401000124103,
    "descripcion":"LIMPIEZA AUTÓNOMA DE PRÓTESIS DENTAL"
  },
  {
    "codigo":247181004,
    "descripcion":"RETINOSQUISIS PERIFÉRICA - DIFUSA"
  },
  {
    "codigo":704098003,
    "descripcion":"UTILIZA DISPOSITIVO INHALADOR"
  },
  {
    "codigo":15970005,
    "descripcion":"HEMATOMA ESOFÁGICO INTRAMURAL"
  },
  {
    "codigo":441954006,
    "descripcion":"ALERGIA A SEVOFLURANO"
  },
  {
    "codigo":79671001,
    "descripcion":"SÍNDROME DE LA VENA CAVA INFERIOR"
  },
  {
    "codigo":833335001,
    "descripcion":"LUXACIÓN DE MUÑECA"
  },
  {
    "codigo":210743006,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA, DEDO GORDO"
  },
  {
    "codigo":866103007,
    "descripcion":"ENFERMEDAD PULMONAR INTERSTICIAL DEBIDA A POLIMIOSITIS JUVENIL"
  },
  {
    "codigo":1259319007,
    "descripcion":"MELANOMA AMELANÓTICO CUTÁNEO PRIMARIO"
  },
  {
    "codigo":307212006,
    "descripcion":"DISFUNCIÓN DE DERIVACIÓN VENTRICULAR CEREBRAL"
  },
  {
    "codigo":208908007,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA EXPUESTA DE LA ARTICULACIÓN DE LA CADERA"
  },
  {
    "codigo":403681000,
    "descripcion":"HIPERTROFIA DE INJERTO DE PIEL"
  },
  {
    "codigo":733196009,
    "descripcion":"LUXACIÓN TRAUMÁTICA DE ARTICULACIÓN ATLO-OCCIPITAL"
  },
  {
    "codigo":239841001,
    "descripcion":"CONDROCALCINOSIS SECUNDARIA"
  },
  {
    "codigo":1255649006,
    "descripcion":"CARCINOMA BASALOIDE DE OROFARINGE"
  },
  {
    "codigo":762294003,
    "descripcion":"HIPERTIROTROFINEMIA INFANTIL TRANSITORIA"
  },
  {
    "codigo":74166005,
    "descripcion":"FIEBRE AMARILLA URBANA"
  },
  {
    "codigo":678509831000119103,
    "descripcion":"LESIÓN TRAUMÁTICA DE PULMÓN DEBIDA A DABBING"
  },
  {
    "codigo":860598005,
    "descripcion":"GANGRENA DE MESENTERIO DE YEYUNO"
  },
  {
    "codigo":238006008,
    "descripcion":"TRASTORNO DEL METABOLISMO DE LAS PURINAS Y PIRIMIDINAS"
  },
  {
    "codigo":303542009,
    "descripcion":"AMPLITUD DE PROTRACCIÓN ACTIVA DE COLUMNA CERVICAL, AUMENTADA"
  },
  {
    "codigo":170635006,
    "descripcion":"SIN TRASTORNOS DEL SUEÑO DEBIDOS AL ASMA"
  },
  {
    "codigo":103264001,
    "descripcion":"OJOS GIRATORIOS"
  },
  {
    "codigo":299872004,
    "descripcion":"REFLEJO ROTULIANO DISMINUIDO"
  },
  {
    "codigo":201568008,
    "descripcion":"ARTRITIS REACTIVA DE ARTICULACIÓN SACROILÍACA"
  },
  {
    "codigo":365408009,
    "descripcion":"HALLAZGO DE LA FORMA DE ONDA DEL ELECTROCARDIOGRAMA"
  },
  {
    "codigo":789557002,
    "descripcion":"ANOMALÍAS FETALES MÚLTIPLES"
  },
  {
    "codigo":35893006,
    "descripcion":"QUISTE DIAFRAGMÁTICO"
  },
  {
    "codigo":103841000119102,
    "descripcion":"RETINOPATÍA COMO EFECTO TARDÍO DE RADIACIÓN"
  },
  {
    "codigo":199733009,
    "descripcion":"HALLAZGO HEMATOLÓGICO ANORMAL EN CRIBADO MATERNO PRENATAL"
  },
  {
    "codigo":21921000119103,
    "descripcion":"DEMENCIA CONCOMITANTE CON ENFERMEDAD DE PICK Y DEBIDA A ELLA"
  },
  {
    "codigo":230666006,
    "descripcion":"DISFUNCIÓN AUTÓNOMA PARANEOPLÁSICA"
  },
  {
    "codigo":296202009,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE FLUSPIRILENO"
  },
  {
    "codigo":390836002,
    "descripcion":"SUBLUXACIÓN NO TRAUMÁTICA DE ARTICULACIÓN ACROMIOCLAVICULAR"
  },
  {
    "codigo":292532002,
    "descripcion":"REACCIÓN ADVERSA A LA HIOSCINA"
  },
  {
    "codigo":15668641000119106,
    "descripcion":"PIE CALCÁNEO VALGO BILATERAL"
  },
  {
    "codigo":1144500005,
    "descripcion":"OSTEOMIELITIS CRÓNICA DE PELVIS Y FÉMUR"
  },
  {
    "codigo":10999201000119106,
    "descripcion":"REFLUJO GASTROESOFÁGICO EN UN NIÑO"
  },
  {
    "codigo":1306505002,
    "descripcion":"CARCINOMA DUCTAL INFILTRANTE PRIMARIO DE CUADRANTE SUPERIOR INTERNO DE MAMA"
  },
  {
    "codigo":1086881000119107,
    "descripcion":"MATERIAL DE RESTAURACIÓN DENTAL FRACTURADO"
  },
  {
    "codigo":290697007,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR CITARABINA"
  },
  {
    "codigo":94089007,
    "descripcion":"NEOPLASIA PRIMARIA MALIGNA DEL MESOCOLON"
  },
  {
    "codigo":126857009,
    "descripcion":"NEOPLASIA DEL COLÉDOCO"
  },
  {
    "codigo":92254003,
    "descripcion":"NEOPLASIA BENIGNA DE LOS GANGLIOS LINFÁTICOS OCCIPITALES"
  },
  {
    "codigo":59486003,
    "descripcion":"EVALUACIÓN DE DISCAPACIDAD: 4%"
  },
  {
    "codigo":714846006,
    "descripcion":"SE ADMINISTRA MEDICACIÓN NO PARENTERAL"
  },
  {
    "codigo":26718008,
    "descripcion":"SÍNDROME DE DISTROFIA DE ROBINSON DE LAS UÑAS - SORDERA"
  },
  {
    "codigo":254259001,
    "descripcion":"AUSENCIA DE CROMOSOMA SEXUAL"
  },
  {
    "codigo":288862008,
    "descripcion":"NO BEBE DE UN BEBEDERO"
  },
  {
    "codigo":292291000119100,
    "descripcion":"COMPRESIÓN DE NERVIO OBTURADOR IZQUIERDO"
  },
  {
    "codigo":82371000119101,
    "descripcion":"DEMENCIA DEBIDA A ESCLEROSIS MÚLTIPLE CON ALTERACIÓN DEL COMPORTAMIENTO"
  },
  {
    "codigo":1075651000119101,
    "descripcion":"DOLOR EN ARTICULACIÓN ESTERNOCLAVICULAR IZQUIERDA"
  },
  {
    "codigo":307651000119103,
    "descripcion":"DISPLASIA FIBROSA MONOSTÓTICA DE HUESO DE ANTEBRAZO IZQUIERDO"
  },
  {
    "codigo":1088451000119104,
    "descripcion":"INFLAMACIÓN CRÓNICA DE MASTOIDES IZQUIERDA"
  },
  {
    "codigo":1237299009,
    "descripcion":"RETRACCIÓN ANORMAL DE PEZÓN"
  },
  {
    "codigo":451000119106,
    "descripcion":"LESIÓN TRAUMÁTICA CERRADA DE LA CABEZA"
  },
  {
    "codigo":87491000119107,
    "descripcion":"ÚLCERA DE ANTEPIÉ DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":338371000119105,
    "descripcion":"ENDOFTALMITIS PURULENTA IZQUIERDA"
  },
  {
    "codigo":11799491000119100,
    "descripcion":"TRANSECCIÓN TRAUMÁTICA COMPLETA DE ARTERIA MESENTÉRICA SUPERIOR"
  },
  {
    "codigo":90051000119106,
    "descripcion":"EDENTULISMO COMPLETO CLASE II"
  },
  {
    "codigo":679690691000119102,
    "descripcion":"ENDOMETRIOSIS PROFUNDA DE VEJIGA"
  },
  {
    "codigo":187331000119105,
    "descripcion":"ARTROPATÍA DE PELVIS DEBIDA A TRASTORNO NEUROLÓGICO"
  },
  {
    "codigo":340931000119105,
    "descripcion":"ECTROPIÓN DE PÁRPADO IZQUIERDO"
  },
  {
    "codigo":123331000119107,
    "descripcion":"LESIÓN TRAUMÁTICA DEBIDA A TRAUMATISMO ACUMULADO POR IMPACTO REITERADO"
  },
  {
    "codigo":10760131000119108,
    "descripcion":"EMBOLIA PIÉMICA Y SÉPTICA EN EL EMBARAZO"
  },
  {
    "codigo":283357002,
    "descripcion":"LACERACIÓN DEL MIEMBRO INFERIOR"
  },
  {
    "codigo":1078211000119109,
    "descripcion":"CÚBITO VALGO CONGÉNITO DERECHO"
  },
  {
    "codigo":449032008,
    "descripcion":"ANOMALÍA CONGÉNITA DE MÚSCULO PAPILAR DE VÁLVULA AURICULOVENTRICULAR DERECHA EN VENTRÍCULO CON DOBLE TRACTO DE ENTRADA"
  },
  {
    "codigo":1299165007,
    "descripcion":"ESTADO EPILÉPTICO MIOCLÓNICO"
  },
  {
    "codigo":19378003,
    "descripcion":"PSEUDOTABES DEBIDO A DIABETES MELLITUS"
  },
  {
    "codigo":1264562008,
    "descripcion":"INTUBACIÓN ENDOBRONQUIAL ACCIDENTAL"
  },
  {
    "codigo":183218009,
    "descripcion":"BOLSA DE GASTROSTOMÍA CAMBIADA"
  },
  {
    "codigo":281522008,
    "descripcion":"HEMARTROSIS TRAUMÁTICA DE ARTICULACIÓN DE CODO"
  },
  {
    "codigo":246919002,
    "descripcion":"DESPLAZAMIENTO LATERAL DE GLOBO OCULAR"
  },
  {
    "codigo":83079000,
    "descripcion":"INFECCIÓN CAUSADA POR SCHISTOCEPHALUS"
  },
  {
    "codigo":17543009,
    "descripcion":"QUEMADURA DE ÓRGANO INTERNO"
  },
  {
    "codigo":81244001,
    "descripcion":"AMPOLLA DEL CUELLO, CON INFECCIÓN"
  },
  {
    "codigo":50311009,
    "descripcion":"AGREGACIÓN DE ERITROCITOS"
  },
  {
    "codigo":212316005,
    "descripcion":"LESIÓN TRAUMÁTICA EXPUESTA DEL NERVIO TIBIAL"
  },
  {
    "codigo":15708009,
    "descripcion":"NEUMOCONIOSIS BENIGNA"
  },
  {
    "codigo":1259057001,
    "descripcion":"TRASTORNO DE SISTEMA NERVIOSO AUTÓNOMO DEBIDO A INFECCIÓN POR VIH"
  },
  {
    "codigo":10755951000119102,
    "descripcion":"SOPLO CARDÍACO EN LA MADRE EN EL MOMENTO DEL NACIMIENTO"
  },
  {
    "codigo":306950002,
    "descripcion":"FISURA LARÍNGEA TIPO II"
  },
  {
    "codigo":110342004,
    "descripcion":"ERITEMA GINGIVAL"
  },
  {
    "codigo":896774004,
    "descripcion":"HIMEN CRIBIFORME"
  },
  {
    "codigo":763867001,
    "descripcion":"SÍNDROME DE HIPEROSTOSIS SEGMENTARIA, LIPOMATOSIS, MALFORMACIÓN ARTERIOVENOSA Y NEVO EPIDÉRMICO"
  },
  {
    "codigo":274182009,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE CUELLO"
  },
  {
    "codigo":403419003,
    "descripcion":"PANICULITIS POR HIPERURICEMIA"
  },
  {
    "codigo":270512000,
    "descripcion":"ANEURISMA PULMONAR ARTERIOVENOSO"
  },
  {
    "codigo":75739009,
    "descripcion":"DISTROFIA NODULAR DE SALZMANN"
  },
  {
    "codigo":41136005,
    "descripcion":"ENVENENAMIENTO POR FENCICLIDINA"
  },
  {
    "codigo":237744009,
    "descripcion":"HIPERFUNCIÓN SUPRARRENAL"
  },
  {
    "codigo":1153413001,
    "descripcion":"SECUESTRO AGUDO DE BAZO DEBIDO A TALASEMIA DE CÉLULAS FALCIFORMES CON CRISIS DREPANOCÍTICA"
  },
  {
    "codigo":235909002,
    "descripcion":"DEFICIENCIA DE ALFA-1-ANTIQUIMOTRIPSINA"
  },
  {
    "codigo":301445001,
    "descripcion":"INCAPAZ DE UTILIZAR INSTALACIONES EDUCATIVAS"
  },
  {
    "codigo":299610001,
    "descripcion":"SIN AMPLITUD ACTIVA DE ABDUCCIÓN DE DEDO DEL PIE"
  },
  {
    "codigo":234074004,
    "descripcion":"HIPERTENSIÓN VENOSA DE LA MANO"
  },
  {
    "codigo":133935000,
    "descripcion":"MÉNAGE À TROIS"
  },
  {
    "codigo":103002009,
    "descripcion":"SENSACIÓN DE FRÍO Y CALOR"
  },
  {
    "codigo":365146009,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA MANIPULAR OBJETOS"
  },
  {
    "codigo":232239005,
    "descripcion":"OTITIS EXTERNA CRÓNICA IRRITATIVA"
  },
  {
    "codigo":15726601000119105,
    "descripcion":"ANQUILOSIS DE ARTICULACIÓN DE DEDO DE MANO IZQUIERDA"
  },
  {
    "codigo":263172003,
    "descripcion":"FRACTURA DE MANDÍBULA"
  },
  {
    "codigo":230404004,
    "descripcion":"EPILEPSIA DE LÓBULO OCCIPITAL"
  },
  {
    "codigo":295940006,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE FLUVOXAMINA"
  },
  {
    "codigo":164868007,
    "descripcion":"INFARTO ANTEROSEPTAL EN EL ELECTROCARDIOGRAMA"
  },
  {
    "codigo":11794441000119107,
    "descripcion":"LACERACIÓN DEL DIAFRAGMA"
  },
  {
    "codigo":294105003,
    "descripcion":"ALERGIA A PUMACTANT"
  },
  {
    "codigo":425177009,
    "descripcion":"ENDOCARDITIS INFECCIOSA DEL LADO DERECHO"
  },
  {
    "codigo":292270004,
    "descripcion":"REACCIÓN ADVERSA A LA APOMORFINA"
  },
  {
    "codigo":1177006005,
    "descripcion":"TRASTORNO DE TICS DEBIDO A SÍNDROME POSENCEFALÍTICO"
  },
  {
    "codigo":95662005,
    "descripcion":"NEUROPATÍA SENSITIVA"
  },
  {
    "codigo":128430005,
    "descripcion":"ENFERMEDAD HEREDITARIA LIGADA AL CROMOSOMA X"
  },
  {
    "codigo":93827000,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL HILIO PULMONAR"
  },
  {
    "codigo":192131001,
    "descripcion":"HIPERCINESIA CON RETRASO DEL DESARROLLO"
  },
  {
    "codigo":30126008,
    "descripcion":"DIVERTÍCULO SUPRADIAFRAGMÁTICO ADQUIRIDO DEL ESÓFAGO"
  },
  {
    "codigo":126595006,
    "descripcion":"NEOPLASIA DEL TERCER HUESO CUNEIFORME DEL PIE"
  },
  {
    "codigo":288600000,
    "descripcion":"INCAPAZ DE EMPLEAR LA COMUNICACIÓN VERBAL"
  },
  {
    "codigo":716419009,
    "descripcion":"CAPAZ DE MANEJAR EL DOLOR EN PARTE DEL CUERPO"
  },
  {
    "codigo":91992005,
    "descripcion":"NEOPLASIA BENIGNA DE VEJIGA URINARIA"
  },
  {
    "codigo":15863971000119106,
    "descripcion":"QUISTE DE AMBAS REGIONES PREAURICULARES"
  },
  {
    "codigo":253997002,
    "descripcion":"HENDIDURA DEL PALADAR BLANDO"
  },
  {
    "codigo":10948771000119107,
    "descripcion":"HERIDA POR ARMA BLANCA DE BRAZO IZQUIERDO"
  },
  {
    "codigo":1237037004,
    "descripcion":"METÁSTASIS DE CARCINOMA DE PORCIÓN CERVICAL DE ESÓFAGO"
  },
  {
    "codigo":286765007,
    "descripcion":"CARÁCTER EXCESIVAMENTE ORGULLOSO"
  },
  {
    "codigo":186626002,
    "descripcion":"HEPATITIS VIRAL B AGUDA CON AGENTE DELTA (COINFECCIÓN), SIN COMA HEPÁTICO"
  },
  {
    "codigo":284930003,
    "descripcion":"DIFICULTAD PARA UTILIZAR ORINAL DE CAMA"
  },
  {
    "codigo":250327000,
    "descripcion":"VÍA DE COAGULACIÓN SANGUÍNEA - HALLAZGO"
  },
  {
    "codigo":86487001,
    "descripcion":"PITIRIASIS LIQUENOIDE AGUDA"
  },
  {
    "codigo":219394008,
    "descripcion":"HERIDA DE GUERRA POR EXPLOSIÓN DE CARGA DE PROFUNDIDAD"
  },
  {
    "codigo":283095003,
    "descripcion":"ARAÑAZO DE PERINEO"
  },
  {
    "codigo":446935007,
    "descripcion":"QUISTE EPIDERMOIDE DE PIEL DE REGIÓN INGUINAL"
  },
  {
    "codigo":281260000,
    "descripcion":"HALLAZGO RELACIONADO CON ADMINISTRACIÓN DE ESPÉCIMEN"
  },
  {
    "codigo":445100000,
    "descripcion":"ESTENOSIS DE CONDUCTO VERTEBRAL EN LA UNIÓN CRANEOVERTEBRAL"
  },
  {
    "codigo":354621000119105,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA SUPERPUESTA DE HUESO Y CARTÍLAGO ARTICULAR DE MIEMBRO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":838316003,
    "descripcion":"ENDOCARDITIS INFECCIOSA AGUDA DE CORAZÓN DERECHO"
  },
  {
    "codigo":314028008,
    "descripcion":"RETRACCIÓN DEL ÁNGULO OCULAR POSTRAUMÁTICA"
  },
  {
    "codigo":770945001,
    "descripcion":"MONODACTILIA TETRAMÉLICA"
  },
  {
    "codigo":279425004,
    "descripcion":"TRASTORNO DEL PELO"
  },
  {
    "codigo":443265004,
    "descripcion":"TRASTORNO COGNITIVO"
  },
  {
    "codigo":410497005,
    "descripcion":"ENDOFTALMITIS POSOPERATORIA INFECCIOSA"
  },
  {
    "codigo":836481007,
    "descripcion":"ESTENOSIS MODERADA DE VÁLVULA AÓRTICA"
  },
  {
    "codigo":16302551000119102,
    "descripcion":"LESIÓN DE HUESO DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":471000119102,
    "descripcion":"DISFUNCIÓN SOMÁTICA DE ARTICULACIÓN SACROILÍACA"
  },
  {
    "codigo":769110001,
    "descripcion":"HALLAZGO RELACIONADO CON LA PRESENCIA DE LEVADURA CON MÚLTIPLES GEMACIONES"
  },
  {
    "codigo":1162326009,
    "descripcion":"OSTEONECROSIS DE HÚMERO DEBIDA A HEMOGLOBINOPATÍA"
  },
  {
    "codigo":603435002,
    "descripcion":"EDUCADO HASTA EL CICLO BÁSICO DEL NIVEL DE ESCOLARIDAD SECUNDARIA"
  },
  {
    "codigo":242987005,
    "descripcion":"LESIÓN TRAUMÁTICA POR COLISIÓN DE VEHÍCULO DE MOTOR, DE INTENCIÓN DESCONOCIDA"
  },
  {
    "codigo":308523008,
    "descripcion":"ESTADO DE CONTROL CLÍNICO A"
  },
  {
    "codigo":208384001,
    "descripcion":"FRACTURA EXPUESTA DE ESCAFOIDES, TUBEROSIDAD"
  },
  {
    "codigo":110080008,
    "descripcion":"LACERACIÓN COMPLEJA CONTAMINADA DEL MENTÓN"
  },
  {
    "codigo":304853004,
    "descripcion":"TRANSFERENCIA NEGATIVA"
  },
  {
    "codigo":403157006,
    "descripcion":"DERMATITIS POR MILLEPORA COMPLANATA"
  },
  {
    "codigo":1156821008,
    "descripcion":"SÍNDROME DE DISFUNCIÓN SINUSAL AUTOSÓMICO RECESIVO"
  },
  {
    "codigo":9941009,
    "descripcion":"COROIDITIS SIFILÍTICA CONGÉNITA"
  },
  {
    "codigo":698069008,
    "descripcion":"RELACIÓN MAXILOMANDIBULAR CLASE III EN PACIENTE DESDENTADO"
  },
  {
    "codigo":401322007,
    "descripcion":"BAJO ATENCIÓN DE EQUIPO"
  },
  {
    "codigo":40874009,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DE PIERNA"
  },
  {
    "codigo":170111002,
    "descripcion":"EXAMEN DEL NIÑO A LOS 10 DÍAS: ANORMAL - DERIVADO"
  },
  {
    "codigo":366719003,
    "descripcion":"PRUEBA TALÓN-ESPINILLA - HALLAZGO"
  },
  {
    "codigo":15702641000119104,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE TENDÓN EXTENSOR DE AMBAS REGIONES DE MUÑECA"
  },
  {
    "codigo":301183007,
    "descripcion":"ENDOCARDITIS BACTERIANA"
  },
  {
    "codigo":299348004,
    "descripcion":"AMPLITUD DE EXTENSIÓN ACTIVA DE LA RODILLA DISMINUIDA"
  },
  {
    "codigo":364884006,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA EMPUJAR Y TIRAR"
  },
  {
    "codigo":168276008,
    "descripcion":"DETECTADO POR SEROLOGÍA"
  },
  {
    "codigo":266580009,
    "descripcion":"MASTITIS AGUDA DE LA ADOLESCENCIA"
  },
  {
    "codigo":723497003,
    "descripcion":"SÍNDROME DE NEUROPATÍA PERIFÉRICA CON HIPOACUSIA NEUROSENSORIAL"
  },
  {
    "codigo":231977005,
    "descripcion":"SUBLUXACIÓN ESPONTÁNEA DEL CRISTALINO"
  },
  {
    "codigo":1149481006,
    "descripcion":"SEPSIS CAUSADA POR BACTERIAS COLIFORMES"
  },
  {
    "codigo":789033009,
    "descripcion":"REQUIERE VACUNACIÓN CONTRA TULAREMIA"
  },
  {
    "codigo":230142004,
    "descripcion":"MENINGITIS CAUSADA POR VIRUS COXSACKIE HUMANO A"
  },
  {
    "codigo":33534005,
    "descripcion":"FÉMUR ENCORVADO CONGÉNITO"
  },
  {
    "codigo":295678005,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE ACLARRUBICINA"
  },
  {
    "codigo":262910007,
    "descripcion":"PERFORACIÓN ACCIDENTAL QUIRÚRGICA DE VEJIGA URINARIA"
  },
  {
    "codigo":424915003,
    "descripcion":"CLASE III DE MALLAMPATI"
  },
  {
    "codigo":293843005,
    "descripcion":"ALERGIA A VENLAFAXINA"
  },
  {
    "codigo":719827008,
    "descripcion":"TRASTORNO INMUNONEUROLÓGICO LIGADO AL CROMOSOMA X"
  },
  {
    "codigo":292008003,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR HIDRALAZINA"
  },
  {
    "codigo":95400005,
    "descripcion":"ÚLCERA DEL SITIO DE INYECCIÓN"
  },
  {
    "codigo":29864006,
    "descripcion":"URETRITIS GONOCÓCICA AGUDA"
  },
  {
    "codigo":423080005,
    "descripcion":"DIFICULTAD DEL CUIDADOR PARA PROVEER UNA GUÍA EMOCIONAL"
  },
  {
    "codigo":160936008,
    "descripcion":"PROPIETARIO - SIN HIPOTECA"
  },
  {
    "codigo":290173002,
    "descripcion":"INTOXICACIÓN POR OPIOIDES DERIVADOS DE LA MORFINA"
  },
  {
    "codigo":93565003,
    "descripcion":"OSIFICACIÓN INCOMPLETA DEL ARCO DE LA VÉRTEBRA LUMBAR"
  },
  {
    "codigo":7603007,
    "descripcion":"PLATISPONDILIA"
  },
  {
    "codigo":124498007,
    "descripcion":"DEFICIENCIA DE ENTEROPEPTIDASA"
  },
  {
    "codigo":286503000,
    "descripcion":"INCAPAZ DE PREPARAR BEBIDAS"
  },
  {
    "codigo":157266009,
    "descripcion":"LUXACIÓN DE RODILLA"
  },
  {
    "codigo":288338009,
    "descripcion":"INCAPAZ DE DIRIGIR (UN AUTOMÓVIL)"
  },
  {
    "codigo":712487000,
    "descripcion":"ENFERMEDAD RENAL EN ESTADIO TERMINAL DEBIDA A HIPERTENSIÓN BENIGNA"
  },
  {
    "codigo":778023004,
    "descripcion":"ENFERMEDAD AUTOINMUNITARIA MULTISISTÉMICA SINDRÓMICA DEBIDA A DEFICIENCIA DE ITCH-PROTEÍNA LIGASA DE UBIQUITINA E3"
  },
  {
    "codigo":250065000,
    "descripcion":"PIERNAS ATÁXICAS"
  },
  {
    "codigo":1003729000,
    "descripcion":"TRASTORNO FETAL DEBIDO A PREECLAMPSIA MATERNA"
  },
  {
    "codigo":10626111000119101,
    "descripcion":"FORÚNCULO DE DEDO DERECHO"
  },
  {
    "codigo":413905004,
    "descripcion":"AUSENCIA CONGÉNITA DE ESTRUCTURA CARDÍACA"
  },
  {
    "codigo":446673009,
    "descripcion":"FILTRACIÓN DE BILIS DESDE CONDUCTO BILIAR ACCESORIO"
  },
  {
    "codigo":86225009,
    "descripcion":"ANEMIA HEMOLÍTICA DE ALTA AFINIDAD TIPO HAPTENO"
  },
  {
    "codigo":16032831000119103,
    "descripcion":"NECROSIS AVASCULAR DE AMBOS RADIOS"
  },
  {
    "codigo":1231270006,
    "descripcion":"GLAUCOMA POSTERIOR A ONCOCERCOSIS OCULAR"
  },
  {
    "codigo":444838008,
    "descripcion":"DEFICIENCIA DE 2-METILBUTIRIL-COA DESHIDROGENASA"
  },
  {
    "codigo":770683002,
    "descripcion":"SIRINGOMIELIA SECUNDARIA"
  },
  {
    "codigo":47952001,
    "descripcion":"DACRIOLITO"
  },
  {
    "codigo":703312002,
    "descripcion":"ARTERITIS CEREBRAL PRIMARIA"
  },
  {
    "codigo":1260368003,
    "descripcion":"EPILEPSIA DEBIDA A SÍNDROME DE RASMUSSEN"
  },
  {
    "codigo":211792006,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO DE GENITALES"
  },
  {
    "codigo":277328007,
    "descripcion":"RUPTURA DE ANEURISMA DE LA ZONA DE LA ARTERIA COMUNICANTE ANTERIOR DE LA CARÓTIDA INTERNA"
  },
  {
    "codigo":1293136009,
    "descripcion":"HEMANGIOMA EPITELIOIDE CELULAR"
  },
  {
    "codigo":78885002,
    "descripcion":"ENFERMEDAD DE ORIGEN PRESUNTAMENTE INFECCIOSO"
  },
  {
    "codigo":16907481000119101,
    "descripcion":"ECTROPIÓN PARALÍTICO DE PÁRPADO IZQUIERDO"
  },
  {
    "codigo":472101004,
    "descripcion":"INTERRUPCIÓN DEL CAYADO AÓRTICO DISTAL A ARTERIA SUBCLAVIA"
  },
  {
    "codigo":406565005,
    "descripcion":"DEFICIENCIA DE LINFOCITOS T CD4"
  },
  {
    "codigo":111653006,
    "descripcion":"ESGUINCE DE LA REGIÓN SACROILÍACA"
  },
  {
    "codigo":373797007,
    "descripcion":"DIAGNÓSTICO DE CÁNCER BASADO EN MARCADORES TUMORALES ESPECÍFICOS"
  },
  {
    "codigo":767013007,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR HORMONA HIPOTALÁMICA"
  },
  {
    "codigo":109818006,
    "descripcion":"PELVIS MASCULINA CONGELADA"
  },
  {
    "codigo":240890007,
    "descripcion":"COMEZÓN CAUSADA POR PYEMOTES TRITICI"
  },
  {
    "codigo":208122008,
    "descripcion":"FRACTURA NO EXPUESTA DE LARINGE Y TRÁQUEA"
  },
  {
    "codigo":765178008,
    "descripcion":"ALTERACIÓN VISUAL Y AUDITIVA TOTAL"
  },
  {
    "codigo":371962007,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL ESÓFAGO ABDOMINAL"
  },
  {
    "codigo":271823003,
    "descripcion":"TAQUIPNEA"
  },
  {
    "codigo":206287004,
    "descripcion":"NEUMONÍA CONGÉNITA POR PSEUDOMONAS"
  },
  {
    "codigo":239055005,
    "descripcion":"ACROPAQUIA"
  },
  {
    "codigo":402895006,
    "descripcion":"HERPES SIMPLEX RECURRENTE DEL PENE"
  },
  {
    "codigo":827044000,
    "descripcion":"ERUPCIÓN DE CUERO CABELLUDO"
  },
  {
    "codigo":1351332001,
    "descripcion":"INMUNODEFICIENCIA COMBINADA AUTOSÓMICA RECESIVA DEBIDA A MUTACIÓN DE SUBUNIDAD CATALÍTICA DELTA 1 DE ADN POLIMERASA"
  },
  {
    "codigo":302756003,
    "descripcion":"HUIDA CON AMANTE"
  },
  {
    "codigo":401060006,
    "descripcion":"ANTECEDENTES OBTENIDOS POR TERCERA PERSONA"
  },
  {
    "codigo":300921000,
    "descripcion":"ESTENOSIS DE ARTERIA SUBCLAVIA"
  },
  {
    "codigo":202617003,
    "descripcion":"CHASQUIDO DE ARTICULACIÓN INTERFALÁNGICA DE DEDO DE PIE"
  },
  {
    "codigo":168014008,
    "descripcion":"LÍQUIDO ASCÍTICO LÍMPIDO"
  },
  {
    "codigo":102478008,
    "descripcion":"ENFERMEDAD PREEXISTENTE"
  },
  {
    "codigo":4174008,
    "descripcion":"PLACENTA TRIPARTITA"
  },
  {
    "codigo":333171000119104,
    "descripcion":"PTERIGIÓN PERIFÉRICO PROGRESIVO DE OJO DERECHO"
  },
  {
    "codigo":67875004,
    "descripcion":"GRITO AGUDO"
  },
  {
    "codigo":1149219001,
    "descripcion":"ARTRITIS REUMATOIDE CON VASCULITIS SISTÉMICA"
  },
  {
    "codigo":461091006,
    "descripcion":"CONDUCTO ARTERIOSO DERECHO PERMEABLE"
  },
  {
    "codigo":2339001,
    "descripcion":"SOBREXPOSICIÓN AL SEXO"
  },
  {
    "codigo":395555008,
    "descripcion":"SIN HALLAZGO PATOLÓGICO ADICIONAL EN ESPÉCIMEN TUMORAL"
  },
  {
    "codigo":426488001,
    "descripcion":"INFERTILIDAD FEMENINA DEBIDA A OLIGO-OVULACIÓN"
  },
  {
    "codigo":721400002,
    "descripcion":"SÍNDROME DE BROWN-SEQUARD AL NIVEL DEL SEGUNDO SEGMENTO CERVICAL"
  },
  {
    "codigo":197112002,
    "descripcion":"PERFORACIÓN Y ABSCESO CONCOMITANTES CON ENFERMEDAD DIVERTICULAR DE INTESTINOS DELGADO Y GRUESO Y DEBIDOS A ELLA"
  },
  {
    "codigo":262648004,
    "descripcion":"HEMATOMA DE CAVIDAD BUCAL"
  },
  {
    "codigo":295416005,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE NABILONA"
  },
  {
    "codigo":504009,
    "descripcion":"HIRSUTISMO DEPENDIENTE DE ANDRÓGENOS"
  },
  {
    "codigo":14914931000119107,
    "descripcion":"CARCINOMA METASTÁSICO DE CÉLULAS DE MERKEL DE HÍGADO"
  },
  {
    "codigo":129741003,
    "descripcion":"LESIÓN MAL DEFINIDA"
  },
  {
    "codigo":64205004,
    "descripcion":"CREPITACIÓN SUBCUTÁNEA"
  },
  {
    "codigo":15953421000119101,
    "descripcion":"FISURA DE PEZÓN DERECHO"
  },
  {
    "codigo":195277008,
    "descripcion":"ANEURISMA DE ARTERIA ILÍACA INTERNA"
  },
  {
    "codigo":226210000,
    "descripcion":"DIETA LICUADA"
  },
  {
    "codigo":95138004,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA GLÁNDULA TIROIDES"
  },
  {
    "codigo":29602005,
    "descripcion":"INTOXICACIÓN CAUSADA POR TIOTEPA"
  },
  {
    "codigo":193442009,
    "descripcion":"CORIORRETINITIS DEL POLO POSTERIOR DISEMINADA"
  },
  {
    "codigo":224375002,
    "descripcion":"EN TRABAJO HABITUAL"
  },
  {
    "codigo":27767004,
    "descripcion":"CELULITIS DE LA FRENTE"
  },
  {
    "codigo":93303009,
    "descripcion":"HIPOPLASIA CONGÉNITA DE HUESO CIGOMÁTICO"
  },
  {
    "codigo":1303884004,
    "descripcion":"TROMBOSIS VENOSA PROFUNDA DE VENA TIBIAL POSTERIOR IZQUIERDA"
  },
  {
    "codigo":124236005,
    "descripcion":"DEFICIENCIA DE REDUCTASA"
  },
  {
    "codigo":253473001,
    "descripcion":"ANOMALÍA DE CUERDA TENDINOSA DE VÁLVULA AURICULOVENTRICULAR"
  },
  {
    "codigo":91468009,
    "descripcion":"MIOCARDITIS MENINGOCÓCICA"
  },
  {
    "codigo":187937008,
    "descripcion":"NEOPLASIA MALIGNA DE HUESO DE CARPO - ESCAFOIDES"
  },
  {
    "codigo":1300214000,
    "descripcion":"DISPLASIA CONGÉNITA DE ARTICULACIÓN DE REGIÓN DE HOMBRO DERECHO"
  },
  {
    "codigo":55030004,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DE MAMA"
  },
  {
    "codigo":87798009,
    "descripcion":"TRASTORNO DE PÁNICO CON AGORAFOBIA, EVITACIÓN AGORAFÓBICA EN REMISIÓN TOTAL Y ATAQUES DE PÁNICO MODERADOS"
  },
  {
    "codigo":20427003,
    "descripcion":"SÍNDROME POSTFLEBÍTICO"
  },
  {
    "codigo":446411005,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO POPLÍTEO"
  },
  {
    "codigo":249803006,
    "descripcion":"DEFORMIDAD DE PIE EN ABDUCCIÓN"
  },
  {
    "codigo":10684071000119105,
    "descripcion":"NÓDULO DEL TEJIDO CELULAR SUBCUTÁNEO DE EXTREMIDAD INFERIOR IZQUIERDA"
  },
  {
    "codigo":247968005,
    "descripcion":"ACUMULACIÓN COMPULSIVA"
  },
  {
    "codigo":1296544008,
    "descripcion":"HIPERTENSIÓN OCULAR DE OJO IZQUIERDO DEBIDA A TRASTORNO VASCULAR OCULAR"
  },
  {
    "codigo":689831000119108,
    "descripcion":"CARCINOMA DE CÉLULAS DE TRANSICIÓN DE TRÍGONO VESICAL"
  },
  {
    "codigo":703050003,
    "descripcion":"ARTROSIS SECUNDARIA DE ARTICULACIÓN MEDIOTARSIANA"
  },
  {
    "codigo":735818006,
    "descripcion":"RUPTURA TRAUMÁTICA DE LIGAMENTO INTERCARPIANO"
  },
  {
    "codigo":45855004,
    "descripcion":"PERICONDRITIS AGUDA DE PABELLÓN DE LA OREJA"
  },
  {
    "codigo":13087006,
    "descripcion":"NECROSIS DE LA LARINGE"
  },
  {
    "codigo":766751007,
    "descripcion":"ANOMALÍA DE NEUHAUSER"
  },
  {
    "codigo":209695009,
    "descripcion":"SECCIÓN EXPUESTA DE LIGAMENTO LATERAL INTERNO DE LA RODILLA"
  },
  {
    "codigo":109556002,
    "descripcion":"INSERCIÓN ABERRANTE DEL FRENILLO DE LA LENGUA"
  },
  {
    "codigo":78623009,
    "descripcion":"ENDOMETRITIS"
  },
  {
    "codigo":8001000119106,
    "descripcion":"ATEROSCLEROSIS DE INJERTO-PUENTE AORTOILÍACO"
  },
  {
    "codigo":9417000,
    "descripcion":"TRASTORNO DEL POOL DE ALMACENAMIENTO DE NUCLEÓTIDOS"
  },
  {
    "codigo":1354740009,
    "descripcion":"FRACTURA DE NOVENA COSTILLA"
  },
  {
    "codigo":16637761000119107,
    "descripcion":"TRASTORNO DE AMBOS NERVIOS CIÁTICOS POPLÍTEOS EXTERNOS"
  },
  {
    "codigo":304329003,
    "descripcion":"AMPLITUD DE MOVIMIENTO DEL PIE AUMENTADA"
  },
  {
    "codigo":402633003,
    "descripcion":"MELANONIQUIA"
  },
  {
    "codigo":366195000,
    "descripcion":"MOVIMIENTO DE LA PARED DEL VENTRÍCULO DERECHO - HALLAZGO"
  },
  {
    "codigo":398963001,
    "descripcion":"DEBILIDAD DEL NERVIO MOTOR OCULAR EXTERNO"
  },
  {
    "codigo":235123001,
    "descripcion":"SIALOADENITIS AGUDA DE LA PAROTIDITIS"
  },
  {
    "codigo":300659005,
    "descripcion":"INCAPAZ DE REALIZAR ACTIVIDADES RELACIONADAS CON EL USO DE MEDIOS DE TRANSPORTE"
  },
  {
    "codigo":5747006,
    "descripcion":"NEUROPATÍA DEL PLEXO BRAQUIAL INFERIOR"
  },
  {
    "codigo":36680007,
    "descripcion":"INTENSIDAD DEL SOPLO CARDÍACO, GRADO II"
  },
  {
    "codigo":298824008,
    "descripcion":"SIN AMPLITUD DE ROTACIÓN INTERNA ACTIVA DE ARTICULACIÓN DE HOMBRO"
  },
  {
    "codigo":428061005,
    "descripcion":"NEOPLASIA MALIGNA ENCEFÁLICA"
  },
  {
    "codigo":722973009,
    "descripcion":"TIC DEBIDO A TRASTORNO DEL DESARROLLO"
  },
  {
    "codigo":231453009,
    "descripcion":"SÍNDROME DE LOBOTOMÍA"
  },
  {
    "codigo":34845009,
    "descripcion":"ENDOCARDITIS MENINGOCÓCICA"
  },
  {
    "codigo":242004,
    "descripcion":"YEYUNITIS NO INFECCIOSA"
  },
  {
    "codigo":33010005,
    "descripcion":"SÍNDROME DEL LACTANTE HIPOTÓNICO"
  },
  {
    "codigo":295154004,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE DEXTROPROPOXIFENO"
  },
  {
    "codigo":65778007,
    "descripcion":"BLOQUEO SINOAURICULAR"
  },
  {
    "codigo":63943002,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DEL PÁRPADO Y\/O DE LA REGIÓN PERIOCULAR"
  },
  {
    "codigo":94876000,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA CARA INTERNA DE LABIO INFERIOR"
  },
  {
    "codigo":193180002,
    "descripcion":"POLINEUROPATÍA EN LA ARTRITIS REUMATOIDE"
  },
  {
    "codigo":783004003,
    "descripcion":"SÍNDROME DE COSTILLAS DELGADAS, HUESOS TUBULARES Y DISMORFISMO"
  },
  {
    "codigo":191345000,
    "descripcion":"NEUTROPENIA NEONATAL ADQUIRIDA"
  },
  {
    "codigo":289649000,
    "descripcion":"DESPLAZAMIENTO DEL ÚTERO - HALLAZGO"
  },
  {
    "codigo":420721002,
    "descripcion":"TRASTORNO ASOCIADO CON SÍNDROME DE INMUNODEFICIENCIA ADQUIRIDA"
  },
  {
    "codigo":291484008,
    "descripcion":"INTOXICACIÓN POR TOBRAMICINA"
  },
  {
    "codigo":62108008,
    "descripcion":"INFECCIÓN CAUSADA POR SCHISTOSOMA HIPPOPOTAMI"
  },
  {
    "codigo":715633008,
    "descripcion":"SÍNDROME DE WERNER ATÍPICO"
  },
  {
    "codigo":224113008,
    "descripcion":"TIENE PADRES JÓVENES"
  },
  {
    "codigo":285979002,
    "descripcion":"INCAPAZ DE CONTROLAR EL TERMOSTATO EN EL HOGAR"
  },
  {
    "codigo":449819002,
    "descripcion":"SÍNDROME DE MONOSOMÍA PARCIAL 3P"
  },
  {
    "codigo":417051004,
    "descripcion":"CON MAYOR RIESGO DE MALA ADMINISTRACIÓN FINANCIERA\/MATERIAL"
  },
  {
    "codigo":187675005,
    "descripcion":"NEOPLASIA MALIGNA DE PILAR AMIGDALINO"
  },
  {
    "codigo":54768000,
    "descripcion":"DISTENSIÓN VESICAL"
  },
  {
    "codigo":22000002,
    "descripcion":"FRACTURA EXPUESTA DE TRES COSTILLAS"
  },
  {
    "codigo":218608004,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR DERIVADO PIRAZÓLICO"
  },
  {
    "codigo":87536007,
    "descripcion":"COMPLICACIÓN DEL SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":20165001,
    "descripcion":"HIPERFOSFATEMIA"
  },
  {
    "codigo":1075471000119107,
    "descripcion":"PELLIZCAMIENTO INTERNO DE HOMBRO DERECHO"
  },
  {
    "codigo":741061001,
    "descripcion":"HERNIA FEMORAL DERECHA RECURRENTE OBSTRUIDA CON GANGRENA"
  },
  {
    "codigo":249541007,
    "descripcion":"PLIEGUES CUTÁNEOS FLOJOS DE LA PARED ABDOMINAL"
  },
  {
    "codigo":247706003,
    "descripcion":"CROMATOPSIA"
  },
  {
    "codigo":83866005,
    "descripcion":"GLOMERULONEFRITIS PROLIFERATIVA FOCAL Y SEGMENTARIA"
  },
  {
    "codigo":1263514008,
    "descripcion":"CONVULSIÓN DEBIDA A MIGRAÑA CON AURA"
  },
  {
    "codigo":49263001,
    "descripcion":"ESPERMATOCELE"
  },
  {
    "codigo":870298008,
    "descripcion":"INFESTACIÓN PARASITARIA DE INTESTINO CAUSADA POR TAENIA SOLIUM"
  },
  {
    "codigo":278639000,
    "descripcion":"PRÓTESIS DENTAL MUY PEQUEÑA"
  },
  {
    "codigo":442479004,
    "descripcion":"MÁRGENES QUIRÚRGICOS DE LESIÓN RESECADA POCO CLAROS"
  },
  {
    "codigo":213103007,
    "descripcion":"PROMINENCIA DE DISPOSITIVO DE FIJACIÓN ESPINAL"
  },
  {
    "codigo":11780521000119105,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO DE BRAZO IZQUIERDO"
  },
  {
    "codigo":409711008,
    "descripcion":"LABERINTITIS VIRAL"
  },
  {
    "codigo":735556002,
    "descripcion":"ABSCESO DE CUERPO CALLOSO"
  },
  {
    "codigo":702788003,
    "descripcion":"OBSTRUCCIÓN RESPIRATORIA LIMÍTROFE EN LA ESPIROMETRÍA"
  },
  {
    "codigo":311407009,
    "descripcion":"PRUEBA DE MEMORIA DE DÍGITOS HACIA ADELANTE"
  },
  {
    "codigo":15712681000119106,
    "descripcion":"ISQUEMIA DE EXTREMIDAD SUPERIOR IZQUIERDA"
  },
  {
    "codigo":367171000119100,
    "descripcion":"HEMATURIA CONCOMITANTE CON CISTITIS Y DEBIDA A ELLA"
  },
  {
    "codigo":309572008,
    "descripcion":"SÍNTOMAS RECTALES"
  },
  {
    "codigo":276804009,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS DEL ESÓFAGO"
  },
  {
    "codigo":1290777002,
    "descripcion":"OSTEOCONDRITIS DISECANTE DE HUESO DE REGIÓN DE ARTICULACIÓN DE RODILLA"
  },
  {
    "codigo":307737000,
    "descripcion":"ABORTO INCOMPLETO INEVITABLE"
  },
  {
    "codigo":285251000119101,
    "descripcion":"DEXTROTRANSPOSICIÓN DE LAS GRANDES ARTERIAS"
  },
  {
    "codigo":897561000,
    "descripcion":"DELECIÓN DISTAL DEL BRAZO LARGO DEL CROMOSOMA 16"
  },
  {
    "codigo":12825006,
    "descripcion":"INFECCIÓN CAUSADA POR ENCEPHALITOZOON"
  },
  {
    "codigo":311721000119108,
    "descripcion":"ESCOLIOSIS IDIOPÁTICA JUVENIL DE COLUMNA TORÁCICA"
  },
  {
    "codigo":240366001,
    "descripcion":"INFECCIÓN POR CHILOMASTIS MESLINI"
  },
  {
    "codigo":109294003,
    "descripcion":"MELANOMA IN SITU DE LA EXTREMIDAD INFERIOR"
  },
  {
    "codigo":43758005,
    "descripcion":"INFECCIÓN CAUSADA POR HEXAMITA"
  },
  {
    "codigo":305902006,
    "descripcion":"VISTO POR EL SERVICIO DE TRAUMA"
  },
  {
    "codigo":402371000,
    "descripcion":"SARCOIDOSIS VERRUGOSA"
  },
  {
    "codigo":271299001,
    "descripcion":"EL ESTADO DEL PACIENTE EMPEORÓ"
  },
  {
    "codigo":238531003,
    "descripcion":"DERMATOSIS INDUCIDA POR EL AGUA"
  },
  {
    "codigo":1156035006,
    "descripcion":"LESIÓN CEREBRAL NO TRAUMÁTICA"
  },
  {
    "codigo":74691006,
    "descripcion":"CAMINAR A PASOS REGULARES"
  },
  {
    "codigo":269464000,
    "descripcion":"NEOPLASIA MALIGNA DE LÓBULO SUPERIOR, BRONQUIO O PULMÓN"
  },
  {
    "codigo":302232001,
    "descripcion":"FRACTURA DE CODO - EXPUESTA"
  },
  {
    "codigo":171160002,
    "descripcion":"CRIBADO PARA CÁNCER DE CUELLO UTERINO NORMAL"
  },
  {
    "codigo":1285272007,
    "descripcion":"HALLAZGO RELACIONADO CON RANGO ACTIVO DE FLEXIÓN PLANTAR DE TOBILLO"
  },
  {
    "codigo":365933000,
    "descripcion":"ESTADO DE ALERTA MENTAL - HALLAZGO"
  },
  {
    "codigo":203928008,
    "descripcion":"INIENCEFALIA ABIERTA"
  },
  {
    "codigo":38253002,
    "descripcion":"INESTABILIDAD DE ARTICULACIÓN LUMBOSACRA"
  },
  {
    "codigo":726381002,
    "descripcion":"DELECIÓN DE PARTE DEL CROMOSOMA 11"
  },
  {
    "codigo":300397004,
    "descripcion":"PÉRDIDA DE LA TURGENCIA CUTÁNEA ABDOMINAL"
  },
  {
    "codigo":890221004,
    "descripcion":"SÍNDROME ACROCARDIOFACIAL"
  },
  {
    "codigo":431469000,
    "descripcion":"PRÓSTATA ESPONJOSA"
  },
  {
    "codigo":202093002,
    "descripcion":"DESGARRO EN PICO DE LORO DEL CUERNO POSTERIOR DEL MENISCO EXTERNO"
  },
  {
    "codigo":71021002,
    "descripcion":"BERIBERI SECO"
  },
  {
    "codigo":429634002,
    "descripcion":"DISCAPACIDAD BILATERAL DE MIEMBROS SUPERIORES"
  },
  {
    "codigo":724546003,
    "descripcion":"INFECCIÓN QUE OCASIONA PARKINSONISMO"
  },
  {
    "codigo":3650004,
    "descripcion":"AUSENCIA CONGÉNITA DEL HÍGADO"
  },
  {
    "codigo":69186005,
    "descripcion":"SÍNDROME DE LACERACIÓN DEL LIGAMENTO ANCHO"
  },
  {
    "codigo":1052226008,
    "descripcion":"DISFUNCIÓN LABERÍNTICA HIPERACTIVA DE OÍDO INTERNO IZQUIERDO"
  },
  {
    "codigo":296727003,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE CEFODIZIMA"
  },
  {
    "codigo":1148695005,
    "descripcion":"HIPOPARATIROIDISMO POST-TIROIDECTOMÍA"
  },
  {
    "codigo":165655008,
    "descripcion":"FOLATO ERITROCÍTICO DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":360428006,
    "descripcion":"FÍSTULA ANAL TRANSESFINTERIANA"
  },
  {
    "codigo":131052007,
    "descripcion":"NIVEL DE PROGESTERONA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":719041000,
    "descripcion":"SÍNDROME DE DISPLASIA DE CADERA CON ENCONDROMAS U OSTEOCONDROMAS"
  },
  {
    "codigo":260289000,
    "descripcion":"VISIÓN A DISTANCIA 1\/36"
  },
  {
    "codigo":11809501000119107,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE REGIÓN DE RODILLA DERECHA"
  },
  {
    "codigo":424129003,
    "descripcion":"DESARROLLO DEL LENGUAJE - RESPONDE A LA INTERJECCIÓN \"NO\" DETENIENDO BREVEMENTE LA ACTIVIDAD"
  },
  {
    "codigo":293057006,
    "descripcion":"REACCIÓN ADVERSA AL CLORANFENICOL"
  },
  {
    "codigo":30913008,
    "descripcion":"TRASTORNO DEL METABOLISMO DEL HIERRO"
  },
  {
    "codigo":61846002,
    "descripcion":"COMPORTAMIENTO SEXUAL ABERRANTE DE ADOLESCENTE MASCULINO"
  },
  {
    "codigo":717206004,
    "descripcion":"KLUYVERA ASCORBATA O KLUYVERA CRYOCRESCENS"
  },
  {
    "codigo":314231000119103,
    "descripcion":"MIOSITIS OSIFICANTE TRAUMÁTICA DE MUSLO IZQUIERDO"
  },
  {
    "codigo":1208726006,
    "descripcion":"SÍNDROME DE INSUFICIENCIA HEPÁTICA AGUDA INFANTIL ASOCIADA A FIEBRE"
  },
  {
    "codigo":782742006,
    "descripcion":"ENFERMEDAD DE CHARCOT-MARIE-TOOTH TIPO 2 AUTOSÓMICA DOMINANTE CON AXONES GIGANTES"
  },
  {
    "codigo":192918007,
    "descripcion":"NEUROPATÍA AUTONÓMICA DEBIDA A AMILOIDOSIS"
  },
  {
    "codigo":289387001,
    "descripcion":"NIVEL 5 DE LA PRESENTACIÓN EN RELACIÓN CON LAS ESPINAS ISQUIÁTICAS"
  },
  {
    "codigo":92779001,
    "descripcion":"CARCINOMA IN SITU DE LAS VÍAS RESPIRATORIAS SUPERIORES"
  },
  {
    "codigo":94614009,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LOS GANGLIOS LINFÁTICOS SUPRACLAVICULARES"
  },
  {
    "codigo":10963831000119103,
    "descripcion":"LACERACIÓN DE PIERNA DERECHA"
  },
  {
    "codigo":1010283006,
    "descripcion":"TRASTORNO FETAL DEBIDO A LESIÓN TRAUMÁTICA MATERNA"
  },
  {
    "codigo":715371006,
    "descripcion":"ATAXIA CEREBELOSA Y DISPLASIA ECTODÉRMICA"
  },
  {
    "codigo":123712000,
    "descripcion":"ATELECTASIA AGUDA"
  },
  {
    "codigo":30151000175104,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN EN TOBILLO IZQUIERDO, ESTADIO I"
  },
  {
    "codigo":254784002,
    "descripcion":"SÍNDROME DEL NEVO AZUL"
  },
  {
    "codigo":418624001,
    "descripcion":"EL MARGEN DE RESECCIÓN QUIRÚRGICA INTERNO ES EL MARGEN NO AFECTADO MÁS CERCANO AL CARCINOMA DUCTAL IN SITU"
  },
  {
    "codigo":1137685003,
    "descripcion":"PERFUSIÓN TISULAR NORMAL"
  },
  {
    "codigo":89109006,
    "descripcion":"ANTÍGENO DE GRUPO SANGUÍNEO D^U^"
  },
  {
    "codigo":16098321000119102,
    "descripcion":"ARTROFIBROSIS DE ARTICULACIÓN DE REGIÓN DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":251114004,
    "descripcion":"BLOQUEO AURICULOVENTRICULAR INTERMITENTE DE SEGUNDO GRADO"
  },
  {
    "codigo":708031000,
    "descripcion":"NEUMONITIS EOSINOFÍLICA IDIOPÁTICA"
  },
  {
    "codigo":118207001,
    "descripcion":"HALLAZGO RELACIONADO CON LA CONFIGURACIÓN MOLECULAR"
  },
  {
    "codigo":283882009,
    "descripcion":"HALLAZGO RELACIONADO CON EL FUNCIONAMIENTO DE LA MEMORIA"
  },
  {
    "codigo":249279003,
    "descripcion":"DEBE HACER FUERZA PARA ORINAR"
  },
  {
    "codigo":19903002,
    "descripcion":"DISFONÍA ESPÁSTICA DE TIPO ADUCTOR"
  },
  {
    "codigo":183743002,
    "descripcion":"CONSULTA DOMICILIARIA NEUROLÓGICA, REALIZADA"
  },
  {
    "codigo":216511001,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ÉSTER CARBÁMICO"
  },
  {
    "codigo":773567007,
    "descripcion":"CAPAZ DE INICIAR LA MARCHA"
  },
  {
    "codigo":52671001,
    "descripcion":"INTOXICACIÓN POR OXITETRACICLINA"
  },
  {
    "codigo":413119003,
    "descripcion":"MIEMBRO DE GRUPO DE ACCIDENTE CEREBROVASCULAR"
  },
  {
    "codigo":1363391001,
    "descripcion":"SINEQUIAS ANTERIORES PERIFÉRICAS EN CUADRANTE INFERIOR DE ÁNGULO IRIDOCORNEAL DE OJO DERECHO"
  },
  {
    "codigo":1197716004,
    "descripcion":"ULCERACIÓN AFTOSA DE INTESTINO GRUESO"
  },
  {
    "codigo":247444006,
    "descripcion":"EXCORIACIÓN DE LA PIEL"
  },
  {
    "codigo":81769002,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN TESTÍCULO, CON INFECCIÓN"
  },
  {
    "codigo":343211000119101,
    "descripcion":"OCLUSIÓN TRANSITORIA DE AMBAS ARTERIAS RETINIANAS"
  },
  {
    "codigo":704361005,
    "descripcion":"CON MAYOR RIESGO DE INGESTIÓN DEFICIENTE DE ALIMENTOS"
  },
  {
    "codigo":49001006,
    "descripcion":"SINQUISIS CENTELLEANTE"
  },
  {
    "codigo":1163113008,
    "descripcion":"COLITIS POR ESCHERICHIA COLI ENTEROTOXIGÉNICA"
  },
  {
    "codigo":79934001,
    "descripcion":"INFECCIÓN CAUSADA POR ENDOLIMAX"
  },
  {
    "codigo":702526004,
    "descripcion":"AL CUIDADO DE SERVICIO DE DEFENSA DE PERSONAS SIN HOGAR"
  },
  {
    "codigo":473150004,
    "descripcion":"NO RECIBE MEDICACIÓN PSICOTRÓPICA"
  },
  {
    "codigo":1259582008,
    "descripcion":"RABDOMIOSARCOMA BOTRIOIDE PRIMARIO"
  },
  {
    "codigo":276542009,
    "descripcion":"ASPIRACIÓN NEONATAL DE LECHE"
  },
  {
    "codigo":241939002,
    "descripcion":"ANAFILAXIA PRODUCIDA POR INSULINA"
  },
  {
    "codigo":373011002,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM ALVEI"
  },
  {
    "codigo":44291000087101,
    "descripcion":"CONTUSIÓN DE MALÉOLO EXTERNO DE PERONÉ DERECHO"
  },
  {
    "codigo":405779006,
    "descripcion":"ATENDIDO POR PSICÓLOGO CLÍNICO"
  },
  {
    "codigo":12563008,
    "descripcion":"MIOCARDIOPATÍA DILATADA CAUSADA POR RADIACIÓN"
  },
  {
    "codigo":897299008,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE LA MEJILLA CON INFECCIÓN"
  },
  {
    "codigo":403944002,
    "descripcion":"CARCINOMA ECRINO DE CÉLULAS PEQUEÑAS DE PIEL"
  },
  {
    "codigo":39171000087109,
    "descripcion":"DOLOR NEUROPÁTICO CENTRAL CRÓNICO DEBIDO A LESIÓN CEREBRAL"
  },
  {
    "codigo":10728006,
    "descripcion":"HERNIA PARAESOFÁGICA GANGRENOSA"
  },
  {
    "codigo":41731000087109,
    "descripcion":"CELULITIS DE DEDO MEDIO IZQUIERDO"
  },
  {
    "codigo":860861000,
    "descripcion":"INFECCIÓN DE HÍGADO Y BAZO CAUSADA POR SCHISTOSOMA MANSONI"
  },
  {
    "codigo":240104008,
    "descripcion":"DISTROFIA MIOTÓNICA CONGÉNITA"
  },
  {
    "codigo":236434000,
    "descripcion":"INSUFICIENCIA RENAL TERMINAL NO TRATADA CON DIÁLISIS"
  },
  {
    "codigo":269202001,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE PIE Y\/O DEDO DE PIE, INFECTADA"
  },
  {
    "codigo":367506006,
    "descripcion":"POLIDACTILIA"
  },
  {
    "codigo":301970007,
    "descripcion":"ORIFICIO LAGRIMAL SUPERIOR NORMAL"
  },
  {
    "codigo":7058009,
    "descripcion":"INCUMPLIMIENTO DEL TRATAMIENTO"
  },
  {
    "codigo":5223003,
    "descripcion":"HEMATOMA DEL CORDÓN ESPERMÁTICO"
  },
  {
    "codigo":201831003,
    "descripcion":"ARTROSIS PRIMARIA LOCALIZADA DE REGIÓN DE HOMBRO"
  },
  {
    "codigo":300135004,
    "descripcion":"HALLAZGO RELACIONADO CON COLOR DE CONDUCTO AUDITIVO"
  },
  {
    "codigo":365671006,
    "descripcion":"OLOR DEL VÓMITO - HALLAZGO"
  },
  {
    "codigo":70759006,
    "descripcion":"PIODERMITIS"
  },
  {
    "codigo":37991008,
    "descripcion":"SÍNDROME DE PARINAUD"
  },
  {
    "codigo":1217639006,
    "descripcion":"NISTAGMO PERIÓDICO ALTERNANTE CONGÉNITO"
  },
  {
    "codigo":234599007,
    "descripcion":"DEFICIENCIA DEL COMPLEMENTO 2"
  },
  {
    "codigo":724284005,
    "descripcion":"HIPERTELORISMO TIPO TEEBI"
  },
  {
    "codigo":298300008,
    "descripcion":"MÚSCULO ESQUELÉTICO NORMAL"
  },
  {
    "codigo":167228009,
    "descripcion":"ORINA DE LA MITAD DEL CHORRO MICCIONAL = RESULTADO DUDOSO"
  },
  {
    "codigo":1345041002,
    "descripcion":"ETAPA DE PRECONTEMPLACIÓN DE LA DISPOSICIÓN A CAMBIAR LA CONDUCTA DE CONSUMO DE SUSTANCIAS"
  },
  {
    "codigo":722449007,
    "descripcion":"SÍNDROME DE FIBROMATOSIS GINGIVAL CON SORDERA PROGRESIVA"
  },
  {
    "codigo":65254001,
    "descripcion":"SOPLO TELESISTÓLICO"
  },
  {
    "codigo":427537009,
    "descripcion":"EROSIÓN DE LABIOS VULVARES"
  },
  {
    "codigo":294630004,
    "descripcion":"ALERGIA A PERMETRINA"
  },
  {
    "codigo":16838111000119103,
    "descripcion":"COLITIS RECURRENTE CAUSADA POR CLOSTRIDIUM DIFFICILE"
  },
  {
    "codigo":1179366006,
    "descripcion":"EPISTAXIS PERINATAL MATERNA"
  },
  {
    "codigo":292795004,
    "descripcion":"REACCIÓN ADVERSA A COLIRIO A BASE DE HIPROMELOSA"
  },
  {
    "codigo":1306768000,
    "descripcion":"GLAUCOMA FACOMÓRFICO DE OJO IZQUIERDO DEBIDO A TRASTORNO DE CRISTALINO"
  },
  {
    "codigo":161723009,
    "descripcion":"PÉRDIDA MENSTRUAL EN DISMINUCIÓN"
  },
  {
    "codigo":94352003,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LOS ÓRGANOS INTRATORÁCICOS"
  },
  {
    "codigo":389264005,
    "descripcion":"GENOCONDROMATOSIS"
  },
  {
    "codigo":192656006,
    "descripcion":"MENINGITIS CAUSADA POR BACILO DE FRIEDLANDER"
  },
  {
    "codigo":127120007,
    "descripcion":"LINFADENOPATÍA HEPÁTICA"
  },
  {
    "codigo":715109001,
    "descripcion":"NO PASA DE LA SILLA DE RUEDAS A LA CAMA"
  },
  {
    "codigo":16018911000119107,
    "descripcion":"ATEROSCLEROSIS DE INJERTO PUENTE DE MATERIAL NO BIOLÓGICO DE AMBOS MIEMBROS INFERIORES"
  },
  {
    "codigo":289125004,
    "descripcion":"INCAPAZ DE REALIZAR ACTIVIDADES PARA EL CUIDADO DE LA BOCA"
  },
  {
    "codigo":92517006,
    "descripcion":"ARTERIOSCLEROSIS CORONARIA CALCIFICADA"
  },
  {
    "codigo":1335866000,
    "descripcion":"ESCLERITIS INMUNOMEDIADA"
  },
  {
    "codigo":254522003,
    "descripcion":"NEOPLASIA DE CARTÍLAGO ARITENOIDES"
  },
  {
    "codigo":713274004,
    "descripcion":"LACERACIÓN DE DEDO ÍNDICE"
  },
  {
    "codigo":418362005,
    "descripcion":"MUERTE - MUERTE SÚBITA"
  },
  {
    "codigo":188986007,
    "descripcion":"LIPOMA DE SIEN"
  },
  {
    "codigo":449295001,
    "descripcion":"SARCOMA DE CRÁNEO"
  },
  {
    "codigo":15746681000119104,
    "descripcion":"PUPILA ATÓNICA DE AMBOS OJOS"
  },
  {
    "codigo":23311005,
    "descripcion":"INTOXICACIÓN POR ASAEMIA AXILLARIS"
  },
  {
    "codigo":711439007,
    "descripcion":"PRUEBA DE APREHENSIÓN DE RODILLA POSITIVA"
  },
  {
    "codigo":285455008,
    "descripcion":"CLADOSPORIOSIS"
  },
  {
    "codigo":88847008,
    "descripcion":"DIETA LÍQUIDA GENERAL"
  },
  {
    "codigo":283620001,
    "descripcion":"HERIDA POR PINCHAZO DE AGUJA EN EL PULGAR"
  },
  {
    "codigo":187151009,
    "descripcion":"DIFILOBOTRIASIS"
  },
  {
    "codigo":840676004,
    "descripcion":"DEFORMIDAD DE PIE IZQUIERDO"
  },
  {
    "codigo":314553001,
    "descripcion":"INFECCIÓN DE INJERTO DE CÓRNEA"
  },
  {
    "codigo":1363129002,
    "descripcion":"ASTILLA EN DORSO"
  },
  {
    "codigo":249017003,
    "descripcion":"ÚTERO GESTANTE DESPLAZADO LATERALMENTE"
  },
  {
    "codigo":609465003,
    "descripcion":"INTERRUPCIÓN INDUCIDA DEL EMBARAZO COMPLICADA POR EMBOLIA GRASA"
  },
  {
    "codigo":773305003,
    "descripcion":"SÍNDROME DE MICROCEFALIA, POLIMICROGIRIA Y AGENESIA DE CUERPO CALLOSO"
  },
  {
    "codigo":52409006,
    "descripcion":"BRONQUIOLITIS EXUDATIVA"
  },
  {
    "codigo":871609008,
    "descripcion":"DEFECTO DE TABIQUE VENTRICULAR CON COMPROMISO DOBLE DE SALIDA YUXTAARTERIAL Y TABIQUE DE SALIDA MAL ALINEADO EN LA PARTE ANTERIOR"
  },
  {
    "codigo":771470001,
    "descripcion":"SÍNDROME DE JAWAD"
  },
  {
    "codigo":443790001,
    "descripcion":"TUMOR DE CÉLULAS GIGANTES"
  },
  {
    "codigo":247182006,
    "descripcion":"DEGENERACIÓN VITREORRETINIANA"
  },
  {
    "codigo":312718007,
    "descripcion":"TRASTORNOS CAUSADOS POR IMPLANTES Y PRÓTESIS OCULARES"
  },
  {
    "codigo":48739004,
    "descripcion":"ABORTO ESPONTÁNEO CON FALLA Y\/O PARO CARDÍACO"
  },
  {
    "codigo":441955007,
    "descripcion":"ALERGIA A SUFENTANILO"
  },
  {
    "codigo":14136000,
    "descripcion":"ABORTO ESPONTÁNEO CON PERFORACIÓN DE LIGAMENTO ANCHO"
  },
  {
    "codigo":866104001,
    "descripcion":"HIPOTENSIÓN INTRACRANEAL DEBIDA A FÍSTULA DE LÍQUIDO CEFALORRAQUÍDEO"
  },
  {
    "codigo":319251000119105,
    "descripcion":"LUXACIÓN RECURRENTE DE ARTICULACIÓN DE MANO IZQUIERDA"
  },
  {
    "codigo":15971009,
    "descripcion":"LESIÓN TRAUMÁTICA DE VENA TIBIAL ANTERIOR"
  },
  {
    "codigo":1259320001,
    "descripcion":"CARCINOMA PRIMARIO DE TROMPA DE FALOPIO"
  },
  {
    "codigo":15638291000119105,
    "descripcion":"ANGIOMIOLIPOMA DE AMBOS RIÑONES"
  },
  {
    "codigo":440411000124104,
    "descripcion":"INGESTA INADECUADA DE SUSTANCIA BIOACTIVA"
  },
  {
    "codigo":276280009,
    "descripcion":"HEMORRAGIA SUBARACNOIDEA PROVENIENTE DE ANEURISMA DE LA ARTERIA CEREBRAL MEDIA"
  },
  {
    "codigo":183816003,
    "descripcion":"PROCEDIMIENTO DE ADMISIÓN NO FINANCIADO"
  },
  {
    "codigo":79672008,
    "descripcion":"REFLEJO POSTURAL ANORMAL"
  },
  {
    "codigo":733197000,
    "descripcion":"LUXACIÓN TRAUMÁTICA DE ARTICULACIÓN ATLANTOAXOIDEA"
  },
  {
    "codigo":2651000124104,
    "descripcion":"INCISIVO LATERAL SUPERIOR IZQUIERDO PERMANENTE SUPERNUMERARIO"
  },
  {
    "codigo":12301009,
    "descripcion":"INFECCIÓN NEONATAL DEL TRACTO URINARIO"
  },
  {
    "codigo":698594003,
    "descripcion":"INSUFICIENCIA CARDÍACA CONGESTIVA SINTOMÁTICA"
  },
  {
    "codigo":1255650006,
    "descripcion":"CARCINOMA BASALOIDE DE LARINGE"
  },
  {
    "codigo":43234007,
    "descripcion":"DEFORMIDAD EN OJAL"
  },
  {
    "codigo":239842008,
    "descripcion":"ARTRITIS Y PERIARTRITIS POR URATO MONOSÓDICO"
  },
  {
    "codigo":403682007,
    "descripcion":"HIPERPIGMENTACIÓN DE INJERTO CUTÁNEO"
  },
  {
    "codigo":762295002,
    "descripcion":"HIDROCEFALIA OBSTRUCTIVA CONGÉNITA"
  },
  {
    "codigo":238007004,
    "descripcion":"DEFICIENCIA PARCIAL DE HIPOXANTINA-GUANINA FOSFORRIBOSILTRANSFERASA"
  },
  {
    "codigo":10696621000119105,
    "descripcion":"RESERVA OVÁRICA DISMINUIDA DEBIDA A EDAD MATERNA AVANZADA"
  },
  {
    "codigo":203404001,
    "descripcion":"OSTEOCONDRITIS DISECANTE DE LA RÓTULA"
  },
  {
    "codigo":400012003,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE PIEL"
  },
  {
    "codigo":292781000119106,
    "descripcion":"LESIÓN DE NERVIO MEDIANO IZQUIERDO"
  },
  {
    "codigo":15913031000119100,
    "descripcion":"CEGUERA CORTICAL DE AMBOS LADOS DEL ENCÉFALO"
  },
  {
    "codigo":170636007,
    "descripcion":"ASMA QUE NUNCA PRODUCE TRASTORNOS DEL SUEÑO"
  },
  {
    "codigo":72332008,
    "descripcion":"LESIÓN TRAUMÁTICA DE INTESTINO CON HERIDA ABIERTA HACIA CAVIDAD ABDOMINAL"
  },
  {
    "codigo":365409001,
    "descripcion":"HALLAZGO RELACIONADO CON EL NIVEL DE EXTROVERSIÓN"
  },
  {
    "codigo":201569000,
    "descripcion":"ARTRITIS REACTIVA DE RODILLA"
  },
  {
    "codigo":103265000,
    "descripcion":"MIRADA POSTBÁSICA"
  },
  {
    "codigo":430945004,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM RESISTENTE A MÚLTIPLES AGENTES ANTIMICOBACTERIANOS"
  },
  {
    "codigo":39564008,
    "descripcion":"MONOCÉFALO"
  },
  {
    "codigo":299873009,
    "descripcion":"REFLEJO ROTULIANO NORMAL"
  },
  {
    "codigo":1217377009,
    "descripcion":"DIFICULTAD PARA COMER DEBIDA A FATIGA"
  },
  {
    "codigo":199734003,
    "descripcion":"HALLAZGO BIOQUÍMICO ANORMAL EN EL CRIBADO MATERNO PRENATAL"
  },
  {
    "codigo":230667002,
    "descripcion":"ANHIDROSIS IDIOPÁTICA CRÓNICA"
  },
  {
    "codigo":348231000119104,
    "descripcion":"HIPOTROPÍA DE OJO DERECHO"
  },
  {
    "codigo":787723002,
    "descripcion":"ÁCIDO DESOXIRRIBONUCLEICO DE VIRUS PAPILOMA HUMANO DETECTADO"
  },
  {
    "codigo":165131004,
    "descripcion":"RESULTADO NORMAL DE BIOPSIA QUIRÚRGICA"
  },
  {
    "codigo":6671000122109,
    "descripcion":"ALERGIA A POLEN DE PARIETARIA"
  },
  {
    "codigo":722187008,
    "descripcion":"SUBINMUNIZADO"
  },
  {
    "codigo":720352005,
    "descripcion":"NO SE OBSERVAN CUERPOS DE AMIANTO EN EL EXAMEN MICROSCÓPICO"
  },
  {
    "codigo":294368007,
    "descripcion":"ALERGIA A INOSINA PRANOBEX"
  },
  {
    "codigo":1085511000119107,
    "descripcion":"EDENTULISMO COMPLETO DE CLASE III DEBIDO A CARIES"
  },
  {
    "codigo":63157004,
    "descripcion":"AFASIA PARIETOCCIPITAL"
  },
  {
    "codigo":95925006,
    "descripcion":"MUJER VÍCTIMA DE ABUSO PSICOLÓGICO"
  },
  {
    "codigo":292533007,
    "descripcion":"REACCIÓN ADVERSA A BROMHIDRATO DE HIOSCINA"
  },
  {
    "codigo":30389008,
    "descripcion":"TEJIDO NORMAL"
  },
  {
    "codigo":1144501009,
    "descripcion":"OSTEOMIELITIS AGUDA DE PELVIS Y FÉMUR"
  },
  {
    "codigo":716682000,
    "descripcion":"TALASEMIA BETA DOMINANTE"
  },
  {
    "codigo":94090003,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE EPIPLÓN"
  },
  {
    "codigo":126858004,
    "descripcion":"NEOPLASIA DE LA AMPOLLA DE VATER"
  },
  {
    "codigo":1306506001,
    "descripcion":"CARCINOMA DUCTAL INFILTRANTE PRIMARIO DE CUADRANTE SUPERIOR EXTERNO DE MAMA"
  },
  {
    "codigo":714847002,
    "descripcion":"NO SE ADMINISTRA MEDICACIÓN NO PARENTERAL"
  },
  {
    "codigo":92255002,
    "descripcion":"NEOPLASIA BENIGNA DEL NERVIO OCULOMOTOR"
  },
  {
    "codigo":288863003,
    "descripcion":"DIFICULTAD PARA BEBER DE UN BEBEDERO"
  },
  {
    "codigo":1237300001,
    "descripcion":"RETRACCIÓN ANORMAL DE PEZÓN IZQUIERDO"
  },
  {
    "codigo":57652005,
    "descripcion":"ANTÍGENO DE GRUPO SANGUÍNEO V^U^"
  },
  {
    "codigo":90420008,
    "descripcion":"ACTIVIDAD HORMONAL NORMAL"
  },
  {
    "codigo":321761000119107,
    "descripcion":"ARTRITIS DE RODILLA DERECHA CAUSADA POR STAPHYLOCOCCUS"
  },
  {
    "codigo":416265003,
    "descripcion":"TUBERCULOMA CEREBRAL"
  },
  {
    "codigo":285193005,
    "descripcion":"CAPAZ DE RECORDAR EL MES DEL AÑO"
  },
  {
    "codigo":283358007,
    "descripcion":"LACERACIÓN DE CABEZA Y CUELLO"
  },
  {
    "codigo":1299166008,
    "descripcion":"ESTADO EPILÉPTICO TÓNICO-CLÓNICO GENERALIZADO"
  },
  {
    "codigo":281523003,
    "descripcion":"HEMARTROSIS TRAUMÁTICA DE LA ARTICULACIÓN DE LA RODILLA"
  },
  {
    "codigo":188061000119100,
    "descripcion":"TRASTORNO DE PROCESAMIENTO AUDITIVO CENTRAL"
  },
  {
    "codigo":15934621000119101,
    "descripcion":"DEFORMIDAD ADQUIRIDA EN CALCANEOVALGO DE PIE IZQUIERDO"
  },
  {
    "codigo":354461000119102,
    "descripcion":"SARCOMA DE KAPOSI DE PULMÓN DERECHO"
  },
  {
    "codigo":16899741000119100,
    "descripcion":"ESPONDILOLISIS CONGÉNITA"
  },
  {
    "codigo":679581000119102,
    "descripcion":"OSTEOMIELITIS DE ÓRBITA DE OJO IZQUIERDO"
  },
  {
    "codigo":10753181000119105,
    "descripcion":"RUPTURA PREMATURA DE MEMBRANAS EN EMBARAZO A TÉRMINO CON COMIENZO DEL TRABAJO DE PARTO DENTRO DE 24 HORAS DESPUÉS DE LA RUPTURA"
  },
  {
    "codigo":11828381000119106,
    "descripcion":"LACERACIÓN DE TENDÓN DE CUÁDRICEPS DERECHO"
  },
  {
    "codigo":15932061000119107,
    "descripcion":"ENDOMETRIOSIS DE OVARIO DERECHO"
  },
  {
    "codigo":336541000119107,
    "descripcion":"UVEÍTIS ANTERIOR AGUDA DE OJO DERECHO"
  },
  {
    "codigo":1086621000119109,
    "descripcion":"COLESTEATOMA TIMPÁNICO"
  },
  {
    "codigo":1181000119106,
    "descripcion":"DIETA Y HÁBITOS ALIMENTARIOS INAPROPIADOS"
  },
  {
    "codigo":15629981000119109,
    "descripcion":"DOLOR EN INGLE DERECHA"
  },
  {
    "codigo":246920008,
    "descripcion":"GLOBO OCULAR GRANDE"
  },
  {
    "codigo":129181000119109,
    "descripcion":"ENFERMEDAD RENAL CRÓNICA DEBIDA A HIPERTENSIÓN, ESTADIO 2"
  },
  {
    "codigo":313501000119105,
    "descripcion":"LUMBALGIA CONCOMITANTE CON NEURALGIA DE NERVIO CIÁTICO DERECHO"
  },
  {
    "codigo":316061000119106,
    "descripcion":"OSTEONECROSIS DE RADIO CAUSADA POR FÁRMACO"
  },
  {
    "codigo":62621000119107,
    "descripcion":"HEMOGLOBINOPATÍA FETAL"
  },
  {
    "codigo":52381000119109,
    "descripcion":"PROBLEMA CON PARES"
  },
  {
    "codigo":1162589001,
    "descripcion":"PERFORACIÓN NEONATAL DE INTESTINO DEBIDA A ESTENOSIS INTESTINAL CONGÉNITA"
  },
  {
    "codigo":212317001,
    "descripcion":"LESIÓN DE NERVIO PERONEO"
  },
  {
    "codigo":312456007,
    "descripcion":"ATENDIDO POR ENFERMERA PEDIÁTRICA EXTRAHOSPITALARIA"
  },
  {
    "codigo":79410001,
    "descripcion":"CATARATA CONGÉNITA"
  },
  {
    "codigo":896775003,
    "descripcion":"FORMA ANCHA ANORMAL CONGÉNITA DE FALANGE"
  },
  {
    "codigo":274183004,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE PARED ABDOMINAL"
  },
  {
    "codigo":77575005,
    "descripcion":"HIPERPROLACTINEMIA SECUNDARIA A TUMOR SECRETOR DE PROLACTINA"
  },
  {
    "codigo":306951003,
    "descripcion":"FISURA LARÍNGEA TIPO III"
  },
  {
    "codigo":44807006,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO DE DORSO DE LA MANO"
  },
  {
    "codigo":104981000119104,
    "descripcion":"OLIGODENDROGLIOMA CEREBRAL"
  },
  {
    "codigo":763868006,
    "descripcion":"BAJA ESTATURA RELACIONADA CON GEN SHOX"
  },
  {
    "codigo":41137001,
    "descripcion":"TENOSINOVITIS BICIPITAL"
  },
  {
    "codigo":73905001,
    "descripcion":"VE DESTELLOS"
  },
  {
    "codigo":403420009,
    "descripcion":"PANICULITIS POR ÉMBOLOS DE COLESTEROL"
  },
  {
    "codigo":237745005,
    "descripcion":"HIPERSECRECIÓN DE CATECOLAMINAS"
  },
  {
    "codigo":270513005,
    "descripcion":"HENDIDURA PALATINA CENTRAL COMPLETA"
  },
  {
    "codigo":301446000,
    "descripcion":"UTILIZA INSTALACIONES EDUCATIVAS"
  },
  {
    "codigo":235910007,
    "descripcion":"TRASTORNO POR TRASPLANTE HEPÁTICO"
  },
  {
    "codigo":1153414007,
    "descripcion":"SÍNDROME TORÁCICO AGUDO DEBIDO A DREPANOCITOSIS CON HEMOGLOBINA C CON CRISIS DREPANOCÍTICA"
  },
  {
    "codigo":365147000,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA MANIPULAR OBJETOS INTERRELACIONADOS"
  },
  {
    "codigo":39302008,
    "descripcion":"COLOBOMA DE FONDO"
  },
  {
    "codigo":234075003,
    "descripcion":"HIPERTENSIÓN VENOSA DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":201307004,
    "descripcion":"ENFERMEDADES CICATRIZALES Y FIBROSIS CUTÁNEA"
  },
  {
    "codigo":103003004,
    "descripcion":"DISMINUCIÓN DE LA SENSACIÓN POSTURAL"
  },
  {
    "codigo":397915002,
    "descripcion":"HIPERLIPOPROTEINEMIA TIPO IIA DE FREDRICKSON"
  },
  {
    "codigo":166704001,
    "descripcion":"NIVEL DE FOSFATO SÉRICO DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":68400004,
    "descripcion":"INFECCIÓN CAUSADA POR RHABDITIS"
  },
  {
    "codigo":232240007,
    "descripcion":"OTITIS ALÉRGICA CRÓNICA EXTERNA"
  },
  {
    "codigo":427013000,
    "descripcion":"CONSUMO DE ALCOHOL DURANTE EL EMBARAZO"
  },
  {
    "codigo":789296007,
    "descripcion":"QUERATOCONJUNTIVITIS FLICTENULAR CAUSADA POR TOXINA ESTAFILOCÓCICA"
  },
  {
    "codigo":164869004,
    "descripcion":"INFARTO POSTEROINFERIOR EN EL ELECTROCARDIOGRAMA"
  },
  {
    "codigo":295941005,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE FLUVOXAMINA"
  },
  {
    "codigo":133961000119102,
    "descripcion":"CONJUNTIVITIS AGUDA CAUSADA POR SUSTANCIA QUÍMICA"
  },
  {
    "codigo":263173008,
    "descripcion":"FRACTURA CONMINUTA DE HUESO ALVEOLAR MANDIBULAR"
  },
  {
    "codigo":294106002,
    "descripcion":"ALERGIA A COLFOSCERILO"
  },
  {
    "codigo":359642000,
    "descripcion":"DIABETES MELLITUS TIPO 2 EN PERSONA NO OBESA"
  },
  {
    "codigo":64730000,
    "descripcion":"RITMO SINUSAL NORMAL"
  },
  {
    "codigo":425178004,
    "descripcion":"ADENOCARCINOMA DE LA UNIÓN RECTOSIGMOIDEA"
  },
  {
    "codigo":95663000,
    "descripcion":"NEUROPATÍA MOTORA PERIFÉRICA"
  },
  {
    "codigo":1177007001,
    "descripcion":"FIBROSIS PULMONAR DEBIDA A PARACOCCIDIOIDOMICOSIS PULMONAR"
  },
  {
    "codigo":193967004,
    "descripcion":"EDEMA PALPEBRAL"
  },
  {
    "codigo":128431009,
    "descripcion":"HIDROCEFALIA INTERNA"
  },
  {
    "codigo":421508002,
    "descripcion":"NEUMONÍA VIRAL CON SÍNDROME DE INMUNODEFICIENCIA ADQUIRIDA"
  },
  {
    "codigo":716420003,
    "descripcion":"CAPAZ DE MANEJAR RIESGO EN LA COMUNIDAD"
  },
  {
    "codigo":93828005,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL NERVIO HIPOGLOSO"
  },
  {
    "codigo":323204005,
    "descripcion":"INTOXICACIÓN POR VICIA FABA"
  },
  {
    "codigo":126596007,
    "descripcion":"NEOPLASIA DE HUESO DEL METATARSO"
  },
  {
    "codigo":192132008,
    "descripcion":"TRASTORNO DE CONDUCTA HIPERCINÉTICA"
  },
  {
    "codigo":91993000,
    "descripcion":"NEOPLASIA BENIGNA DE VASO SANGUÍNEO ABDOMINAL"
  },
  {
    "codigo":288601001,
    "descripcion":"EMPLEA COMUNICACIÓN VERBAL"
  },
  {
    "codigo":297801000119107,
    "descripcion":"DERRAME INTERMITENTE DE ARTICULACIÓN DE CADERA"
  },
  {
    "codigo":290436008,
    "descripcion":"INTOXICACIÓN POR PICOSULFATO DE SODIO"
  },
  {
    "codigo":59225004,
    "descripcion":"DERMATITIS PERIVASCULAR SUPERFICIAL Y PROFUNDA"
  },
  {
    "codigo":188462001,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE CEREBRO Y MÉDULA ESPINAL"
  },
  {
    "codigo":712750007,
    "descripcion":"NEOPLASIA MALIGNA DE PARED TORÁCICA"
  },
  {
    "codigo":286766008,
    "descripcion":"CARÁCTER ARROGANTE"
  },
  {
    "codigo":55555001,
    "descripcion":"PANNUS TRACOMATOSO"
  },
  {
    "codigo":57390009,
    "descripcion":"CRIOINMUNOGLOBULINEMIA MIXTA CON COMPONENTE MONOCLONAL"
  },
  {
    "codigo":1237038009,
    "descripcion":"METÁSTASIS DE CARCINOMA EN ESÓFAGO ABDOMINAL"
  },
  {
    "codigo":219395009,
    "descripcion":"HERIDA DE GUERRA POR EXPLOSIÓN DE MINA SUBMARINA"
  },
  {
    "codigo":283096002,
    "descripcion":"ARAÑAZO DE LOS GENITALES"
  },
  {
    "codigo":250328005,
    "descripcion":"VÍA DE COAGULACIÓN INTRÍNSECA - HALLAZGO"
  },
  {
    "codigo":20952006,
    "descripcion":"TRASTORNO NEONATAL CAUSADO POR SUSTANCIA NOCIVA TRANSMITIDA A TRAVÉS DE LECHE MATERNA"
  },
  {
    "codigo":314029000,
    "descripcion":"UVEÍTIS TUBERCULOSA"
  },
  {
    "codigo":281261001,
    "descripcion":"HALLAZGO RELACIONADO CON RECIPIENTE DE ESPÉCIMEN"
  },
  {
    "codigo":446936008,
    "descripcion":"QUISTE EPIDERMOIDE DE PIEL DE CARA"
  },
  {
    "codigo":248493003,
    "descripcion":"DILATACIÓN DE VASO SANGUÍNEO"
  },
  {
    "codigo":707245003,
    "descripcion":"QUEILITIS ANGULAR DEBIDA A DEFICIENCIA NUTRICIONAL"
  },
  {
    "codigo":772781000,
    "descripcion":"HERNIA FEMORAL BILATERAL RECURRENTE OBSTRUIDA"
  },
  {
    "codigo":51885006,
    "descripcion":"NÁUSEAS MATUTINAS"
  },
  {
    "codigo":19117007,
    "descripcion":"PLACENTA REFLEXA"
  },
  {
    "codigo":770946000,
    "descripcion":"OLIGODACTILIA POSTAXIAL TETRAMÉLICA"
  },
  {
    "codigo":410498000,
    "descripcion":"INFLAMACIÓN POSOPERATORIA ASOCIADA CON LENTE INTRAOCULAR"
  },
  {
    "codigo":838317007,
    "descripcion":"BURSITIS DEBIDA A SÍFILIS TARDÍA"
  },
  {
    "codigo":836482000,
    "descripcion":"ESTENOSIS SEVERA DE VÁLVULA AÓRTICA"
  },
  {
    "codigo":1295234004,
    "descripcion":"MELANOMA MALIGNO DE SPITZ"
  },
  {
    "codigo":246658005,
    "descripcion":"ESCOTOMA POSITIVO"
  },
  {
    "codigo":1162327000,
    "descripcion":"OSTEONECROSIS DE HUESO DE PIE DEBIDA A HEMOGLOBINOPATÍA"
  },
  {
    "codigo":408663001,
    "descripcion":"CONJUNTIVOCALASIA"
  },
  {
    "codigo":242988000,
    "descripcion":"LESIÓN CON PROPÓSITO DESCONOCIDO POR CHOQUE DE AERONAVE"
  },
  {
    "codigo":210220001,
    "descripcion":"LESIÓN TRAUMÁTICA DE URÉTER CON HERIDA ABIERTA HACIA CAVIDAD"
  },
  {
    "codigo":208385000,
    "descripcion":"FRACTURA EXPUESTA DE MÚLTIPLES HUESOS DE CARPO"
  },
  {
    "codigo":110081007,
    "descripcion":"AVULSIÓN DEL MENTÓN"
  },
  {
    "codigo":403158001,
    "descripcion":"DERMATITIS DE CONTACTO ALÉRGICA CAUSADA POR BRYOZOA"
  },
  {
    "codigo":1156822001,
    "descripcion":"ENFERMEDAD DE PARKINSON FAMILIAR AUTOSÓMICA RECESIVA"
  },
  {
    "codigo":15973501000119109,
    "descripcion":"DISPLASIA CONGÉNITA DE AMBAS EXTREMIDADES INFERIORES"
  },
  {
    "codigo":304854005,
    "descripcion":"TRANSFERENCIA DELIRANTE"
  },
  {
    "codigo":75478009,
    "descripcion":"TOXICIDAD"
  },
  {
    "codigo":698070009,
    "descripcion":"HIPERPLASIA DE GLÁNDULA SALIVAL"
  },
  {
    "codigo":401323002,
    "descripcion":"ESCALA DE DISNEA DE BORG: 0,5 - MUY, MUY LEVE (APENAS PERCEPTIBLE)"
  },
  {
    "codigo":204715003,
    "descripcion":"ATRESIA DE APÉNDICE ILEOCECAL"
  },
  {
    "codigo":8107007,
    "descripcion":"POROCEFALIASIS"
  },
  {
    "codigo":1251456000,
    "descripcion":"METÁSTASIS DE NEUROBLASTOMA EN CEREBRO"
  },
  {
    "codigo":303019009,
    "descripcion":"HIFEMA ESPONTÁNEO"
  },
  {
    "codigo":301184001,
    "descripcion":"VEGETACIONES DE VÁLVULA AÓRTICA"
  },
  {
    "codigo":235648004,
    "descripcion":"ÚLCERA GÁSTRICA AGUDA FARMACÓGENA"
  },
  {
    "codigo":333952004,
    "descripcion":"CONSTRICCIÓN NO HIPERTRÓFICA ADQUIRIDA DEL PÍLORO"
  },
  {
    "codigo":202880006,
    "descripcion":"TENDINITIS DEL MÚSCULO TIBIAL ANTERIOR"
  },
  {
    "codigo":683441000119100,
    "descripcion":"DERMATOFIBROMA DE CUERO CABELLUDO"
  },
  {
    "codigo":69973000,
    "descripcion":"ANOMALÍA VASCULAR DE PÁRPADO"
  },
  {
    "codigo":366720009,
    "descripcion":"DISCRIMINACIÓN ESTÁTICA DE DOS PUNTOS - HALLAZGO"
  },
  {
    "codigo":170112009,
    "descripcion":"EXAMEN DEL NIÑO A LOS 10 DÍAS: ANORMAL - EN TRATAMIENTO"
  },
  {
    "codigo":233813006,
    "descripcion":"LESIÓN PULMONAR ASOCIADA CON EL RESPIRADOR"
  },
  {
    "codigo":364885007,
    "descripcion":"SIMETRÍA DEL ELECTROENCEFALOGRAMA - HALLAZGO"
  },
  {
    "codigo":266581008,
    "descripcion":"SALPINGOOFORITIS AGUDA"
  },
  {
    "codigo":397653009,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA OÍR"
  },
  {
    "codigo":231978000,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA DEL CRISTALINO"
  },
  {
    "codigo":789034003,
    "descripcion":"REQUIERE VACUNACIÓN CONTRA FIEBRE TIFOIDEA Y PARATIFOIDEA"
  },
  {
    "codigo":10949911000119109,
    "descripcion":"HERIDA ABIERTA DE ANTEBRAZO DERECHO DEBIDA A MORDEDURA DE ANIMAL"
  },
  {
    "codigo":11824561000119103,
    "descripcion":"LESIÓN TRAUMÁTICA DE VASO SANGUÍNEO DE BRAZO IZQUIERDO"
  },
  {
    "codigo":299349007,
    "descripcion":"SIN AMPLITUD ACTIVA DE EXTENSIÓN DE RODILLA"
  },
  {
    "codigo":1149482004,
    "descripcion":"SEPSIS CAUSADA POR CLOSTRIDIUM"
  },
  {
    "codigo":2602008,
    "descripcion":"HEMARTROSIS DE REGIÓN DE HOMBRO"
  },
  {
    "codigo":428586009,
    "descripcion":"FRECUENCIA CARDÍACA ELEVADA, DENTRO DEL RANGO NORMAL"
  },
  {
    "codigo":262911006,
    "descripcion":"LESIÓN TRAUMÁTICA DE CUELLO DE VEJIGA URINARIA"
  },
  {
    "codigo":721663007,
    "descripcion":"OCLUSIÓN AGUDA DE VENA MESENTÉRICA"
  },
  {
    "codigo":31700001,
    "descripcion":"OTITIS MEDIA ADHESIVA CON ADHERENCIAS ENTRE EL TÍMPANO Y EL YUNQUE"
  },
  {
    "codigo":230143009,
    "descripcion":"MENINGITIS CAUSADA POR VIRUS COXSACKIE HUMANO B"
  },
  {
    "codigo":293844004,
    "descripcion":"ALERGIA A INHIBIDOR SELECTIVO DE LA RECAPTACIÓN DE SEROTONINA"
  },
  {
    "codigo":160937004,
    "descripcion":"PROPIETARIO CON HIPOTECA"
  },
  {
    "codigo":292009006,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR HIDRALAZINA"
  },
  {
    "codigo":28030000,
    "descripcion":"NACIMIENTO DE GEMELOS"
  },
  {
    "codigo":95401009,
    "descripcion":"CONTUSIÓN DEL SITIO DE INYECCIÓN"
  },
  {
    "codigo":93566002,
    "descripcion":"OSIFICACIÓN INCOMPLETA DE ARCO DE VÉRTEBRA SACRA"
  },
  {
    "codigo":290174008,
    "descripcion":"INTOXICACIÓN POR BUPRENORFINA"
  },
  {
    "codigo":288339001,
    "descripcion":"CONDUCE"
  },
  {
    "codigo":421246008,
    "descripcion":"LINFOMA LINFOBLÁSTICO DE CÉLULAS T"
  },
  {
    "codigo":26195002,
    "descripcion":"INFECCIÓN BACTERIANA CAUSADA POR PROTEUS MIRABILIS"
  },
  {
    "codigo":124499004,
    "descripcion":"DEFICIENCIA DE ELASTASA PANCREÁTICA"
  },
  {
    "codigo":58963008,
    "descripcion":"ACROFOBIA"
  },
  {
    "codigo":253736003,
    "descripcion":"HIPOPLASIA LARÍNGEA"
  },
  {
    "codigo":778024005,
    "descripcion":"MONOCITOPENIA CON SUSCEPTIBILIDAD A INFECCIONES"
  },
  {
    "codigo":712488005,
    "descripcion":"XEROSTOMÍA DEBIDA A HIPOSECRECIÓN DE GLÁNDULA SALIVAL"
  },
  {
    "codigo":286504006,
    "descripcion":"PREPARA BEBIDAS"
  },
  {
    "codigo":24360007,
    "descripcion":"CENUROSIS"
  },
  {
    "codigo":186365005,
    "descripcion":"MENINGOCOCCEMIA AGUDA"
  },
  {
    "codigo":1611000119108,
    "descripcion":"DESHIDRATACIÓN LEVE"
  },
  {
    "codigo":448509007,
    "descripcion":"NEOPLASIA MALIGNA TRANSGLÓTICA DE LARINGE"
  },
  {
    "codigo":413906003,
    "descripcion":"FALLA CONGÉNITA DE FUSIÓN ENTRE LOS PROCESOS MAXILAR Y MANDIBULAR"
  },
  {
    "codigo":250066004,
    "descripcion":"PRUEBA TALÓN-ESPINILLA: ANORMAL"
  },
  {
    "codigo":1003730005,
    "descripcion":"TRASTORNO NEONATAL DEBIDO A HIPERTENSIÓN MATERNA"
  },
  {
    "codigo":248231000,
    "descripcion":"ANESTESIA SUAVE"
  },
  {
    "codigo":51623004,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE VAGINA SIN INFECCIÓN"
  },
  {
    "codigo":1231271005,
    "descripcion":"GLAUCOMA DEBIDO A RETINOPATÍA DE PREMATUREZ Y POSTERIOR A ELLA"
  },
  {
    "codigo":705148006,
    "descripcion":"CAPAZ DE UTILIZAR DISPOSITIVO DE ANALGESIA CONTROLADO POR EL PACIENTE"
  },
  {
    "codigo":770684008,
    "descripcion":"CARCINOMA ESCAMOCELULAR DE HÍGADO Y VÍA BILIAR INTRAHEPÁTICA"
  },
  {
    "codigo":211793001,
    "descripcion":"QUEMADURA DE TERCER GRADO DEL TRONCO POR AGENTE CORROSIVO"
  },
  {
    "codigo":277329004,
    "descripcion":"RUPTURA DE ANEURISMA DE LA ZONA DE LA ARTERIA COMUNICANTE POSTERIOR DE LA CARÓTIDA INTERNA"
  },
  {
    "codigo":1260369006,
    "descripcion":"EPILEPSIA DEBIDA A HEMORRAGIA INTRAVENTRICULAR PERINATAL"
  },
  {
    "codigo":703313007,
    "descripcion":"ANGIOPATÍA CEREBRAL AMILOIDE ASOCIADA CON AMILOIDOSIS SISTÉMICA"
  },
  {
    "codigo":10762111000119102,
    "descripcion":"ADHERENCIA VITREOMACULAR DE AMBOS OJOS"
  },
  {
    "codigo":767014001,
    "descripcion":"ALERGIA A HORMONA HIPOTALÁMICA"
  },
  {
    "codigo":373798002,
    "descripcion":"DIAGNÓSTICO DE CÁNCER BASADO EN LA EVIDENCIA CITOLÓGICA"
  },
  {
    "codigo":406566006,
    "descripcion":"INFECCIÓN DEL SISTEMA NERVIOSO CENTRAL POR CHLAMYDIA"
  },
  {
    "codigo":472102006,
    "descripcion":"INTERRUPCIÓN DE CAYADO AÓRTICO ENTRE ARTERIA SUBCLAVIA Y ARTERIA CARÓTIDA PRIMITIVA"
  },
  {
    "codigo":44283002,
    "descripcion":"ABSCESO DE LENGUA"
  },
  {
    "codigo":109819003,
    "descripcion":"CIRROSIS BILIAR OBSTRUCTIVA"
  },
  {
    "codigo":371963002,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA CORTEZA SUPRARRENAL"
  },
  {
    "codigo":240891006,
    "descripcion":"PRURITO DE LA SEMILLA DE ALGODÓN"
  },
  {
    "codigo":1254864000,
    "descripcion":"PRURITO PARANEOPLÁSICO"
  },
  {
    "codigo":42448002,
    "descripcion":"QUERATOCONJUNTIVITIS POR HERPES ZÓSTER"
  },
  {
    "codigo":239056006,
    "descripcion":"SÍNDROME DE FLYNN-AIRD"
  },
  {
    "codigo":763344007,
    "descripcion":"SÍNDROME DE ATAXIA CEREBELOSA, DISCAPACIDAD INTELECTUAL, APRAXIA OCULOMOTRIZ Y QUISTES CEREBELOSOS"
  },
  {
    "codigo":402896007,
    "descripcion":"VULVOVAGINITIS HERPÉTICA RECURRENTE"
  },
  {
    "codigo":271824009,
    "descripcion":"RESPIRACIÓN INTERMITENTE"
  },
  {
    "codigo":685951000119107,
    "descripcion":"LIPOSARCOMA PRIMARIO DE PARTES BLANDAS DE PERINEO"
  },
  {
    "codigo":827045004,
    "descripcion":"ERUPCIÓN DE LA BOCA"
  },
  {
    "codigo":1351333006,
    "descripcion":"INMUNODEFICIENCIA COMBINADA AUTOSÓMICA RECESIVA DEBIDA A MUTACIÓN DE SUBUNIDAD ACCESORIA DELTA 2 DE ADN POLIMERASA"
  },
  {
    "codigo":302757007,
    "descripcion":"PERÍODOS REGULARES"
  },
  {
    "codigo":331801000119102,
    "descripcion":"OCLUSIÓN TRANSITORIA DE ARTERIA DE LA RETINA DERECHA"
  },
  {
    "codigo":40613008,
    "descripcion":"FRACTURA EXPUESTA DE HUESOS NASALES"
  },
  {
    "codigo":15732761000119102,
    "descripcion":"ECTROPIÓN MECÁNICO DE AMBOS PÁRPADOS"
  },
  {
    "codigo":300922007,
    "descripcion":"ESPINA DE PESCADO EN LA FARINGE"
  },
  {
    "codigo":102479000,
    "descripcion":"MEJORÍA DE UNA ENFERMEDAD PREEXISTENTE"
  },
  {
    "codigo":299087005,
    "descripcion":"AMPLITUD DE ABDUCCIÓN ACTIVA DE DEDO DE LA MANO NORMAL"
  },
  {
    "codigo":16470041000119105,
    "descripcion":"INCONTINENCIA URINARIA DEBIDA A ACCIDENTE CEREBROVASCULAR CON HEMORRAGIA INTRACRANEAL Y POSTERIOR A ÉL"
  },
  {
    "codigo":4175009,
    "descripcion":"INFESTACIÓN CAUSADA POR OESTRUS"
  },
  {
    "codigo":168015009,
    "descripcion":"LÍQUIDO ASCÍTICO TURBIO"
  },
  {
    "codigo":67876003,
    "descripcion":"OBSTRUCCIÓN CONGÉNITA DEL ACUEDUCTO DE SILVIO"
  },
  {
    "codigo":461092004,
    "descripcion":"CIERRE ESPONTÁNEO DE DEFECTO DE TABIQUE INTERAURICULAR RESIDUAL EN LA FOSA OVAL"
  },
  {
    "codigo":297252005,
    "descripcion":"DEFICIENCIA DE GLUCÓGENO-FOSFORILASA-QUINASA, AUTOSÓMICA RECESIVA"
  },
  {
    "codigo":295417001,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE NABILONA"
  },
  {
    "codigo":86041000119107,
    "descripcion":"MARCAPASOS CARDÍACO NORMALMENTE FUNCIONANTE IN SITU"
  },
  {
    "codigo":721401003,
    "descripcion":"SÍNDROME DE BROWN-SEQUARD AL NIVEL DEL TERCERO SEGMENTO CERVICAL"
  },
  {
    "codigo":360953004,
    "descripcion":"DEFICIENCIA DE AMINOACIL - HISTIDINA DIPEPTIDASA"
  },
  {
    "codigo":11774131000119101,
    "descripcion":"CONTUSIÓN DE DEDO ANULAR DERECHO"
  },
  {
    "codigo":262649007,
    "descripcion":"HEMATOMA DE PALADAR"
  },
  {
    "codigo":31438003,
    "descripcion":"RESISTENCIA A UN FÁRMACO"
  },
  {
    "codigo":11718681000119109,
    "descripcion":"LAGOFTALMOS BILATERAL"
  },
  {
    "codigo":129742005,
    "descripcion":"LESIÓN ESPIGADA"
  },
  {
    "codigo":719566006,
    "descripcion":"DIABÉTICO CON MEDICACIÓN INYECTABLE DIFERENTE A LA INSULINA"
  },
  {
    "codigo":64206003,
    "descripcion":"HIPOMENORREA"
  },
  {
    "codigo":226211001,
    "descripcion":"DIETA A BASE DE PAPILLAS"
  },
  {
    "codigo":97401000146106,
    "descripcion":"VIRUS PAPILOMA HUMANO DE ALTO RIESGO DETECTADO"
  },
  {
    "codigo":717731002,
    "descripcion":"CARCINOMA BASOCELULAR DE VULVA"
  },
  {
    "codigo":160675002,
    "descripcion":"DIETA CON BAJO CONTENIDO DE RESIDUOS"
  },
  {
    "codigo":62371005,
    "descripcion":"SIDEROSIS PULMONAR"
  },
  {
    "codigo":193443004,
    "descripcion":"CORIORRETINITIS PERIFÉRICA DISEMINADA"
  },
  {
    "codigo":95139007,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE TIBIA"
  },
  {
    "codigo":224376001,
    "descripcion":"TRABAJA IRREGULARMENTE"
  },
  {
    "codigo":93304003,
    "descripcion":"POSICIÓN ANÓMALA CONGÉNITA DE LA GLÁNDULA SUPRARRENAL"
  },
  {
    "codigo":124237001,
    "descripcion":"DEFICIENCIA DE TRANSFERASA"
  },
  {
    "codigo":25933002,
    "descripcion":"DEPÓSITO DE BETEL SOBRE LOS DIENTES"
  },
  {
    "codigo":1303885003,
    "descripcion":"RUPTURA TRAUMÁTICA DE ISTMO AÓRTICO"
  },
  {
    "codigo":286242001,
    "descripcion":"CAPAZ DE UTILIZAR PROCESOS FONOLÓGICOS"
  },
  {
    "codigo":187938003,
    "descripcion":"NEOPLASIA MALIGNA DE HUESO DEL CARPO - SEMILUNAR"
  },
  {
    "codigo":10846541000119103,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO SENSITIVO CUTÁNEO DE DEDO DE PIE DERECHO"
  },
  {
    "codigo":253474007,
    "descripcion":"CUERDAS TENDINOSAS DE VÁLVULA AURICULOVENTRICULAR DERECHA EXCESIVAMENTE CORTAS"
  },
  {
    "codigo":55031000,
    "descripcion":"PIGMENTACIÓN CORNEAL ESTROMAL"
  },
  {
    "codigo":1300215004,
    "descripcion":"DISPLASIA CONGÉNITA DE ARTICULACIÓN DE REGIÓN DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":249804000,
    "descripcion":"CALCANEOVALGO POSTURAL"
  },
  {
    "codigo":10656231000119100,
    "descripcion":"ÚLCERA DE PIEL DE DEDO DE PIE DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":1003468008,
    "descripcion":"TERATOMA NASOFARÍNGEO CONGÉNITO"
  },
  {
    "codigo":247969002,
    "descripcion":"CONTEO COMPULSIVO"
  },
  {
    "codigo":1362081007,
    "descripcion":"GINGIVITIS LOCALIZADA CON TEJIDO PERIODONTAL DISMINUIDO Y PERIODONTITIS ESTABLE"
  },
  {
    "codigo":1296545009,
    "descripcion":"HIPERTENSIÓN OCULAR BILATERAL DEBIDA A TRASTORNO VASCULAR OCULAR"
  },
  {
    "codigo":49526009,
    "descripcion":"PRESBICUSIA"
  },
  {
    "codigo":735819003,
    "descripcion":"RUPTURA TRAUMÁTICA DE LIGAMENTO LATERAL DE MUÑECA"
  },
  {
    "codigo":703051004,
    "descripcion":"ARTROSIS MEDIOTARSIANA"
  },
  {
    "codigo":15981031000119104,
    "descripcion":"ECTROPIÓN MECÁNICO DE AMBOS PÁRPADOS INFERIORES"
  },
  {
    "codigo":766752000,
    "descripcion":"NEUROLINFOMATOSIS"
  },
  {
    "codigo":439072001,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO MEDIANO DISTAL AL ANTEBRAZO"
  },
  {
    "codigo":209696005,
    "descripcion":"SECCIÓN EXPUESTA DE LIGAMENTO CRUZADO POSTERIOR DE LA RODILLA"
  },
  {
    "codigo":240629003,
    "descripcion":"PULMÓN DE CHOQUE EN EL PALUDISMO"
  },
  {
    "codigo":109557006,
    "descripcion":"ANOMALÍA CONGÉNITA DE LA ÚVULA"
  },
  {
    "codigo":699381006,
    "descripcion":"DISPLASIA OCULOESQUELÉTICA"
  },
  {
    "codigo":76789006,
    "descripcion":"PROBLEMA DE CONVERSIÓN DE LA INFORMACIÓN"
  },
  {
    "codigo":15708801000119102,
    "descripcion":"LUXACIÓN RECURRENTE DE AMBAS ARTICULACIONES DE CADERA"
  },
  {
    "codigo":1354741008,
    "descripcion":"FRACTURA DE DÉCIMA COSTILLA"
  },
  {
    "codigo":9418005,
    "descripcion":"NECROBIOSIS LIPOIDEA"
  },
  {
    "codigo":238794007,
    "descripcion":"ÚLCERA ISQUÉMICA EN EL PIE"
  },
  {
    "codigo":304330008,
    "descripcion":"AMPLITUD DEL MOVIMIENTO DEL PIE, DISMINUIDA"
  },
  {
    "codigo":402634009,
    "descripcion":"ANORMALIDAD DE LA FORMA UNGUEAL"
  },
  {
    "codigo":73119000,
    "descripcion":"SÍNDROME DE RETINITIS PIGMENTARIA - SORDERA - ATAXIA"
  },
  {
    "codigo":300660000,
    "descripcion":"REALIZA ACTIVIDADES RELACIONADAS CON EL USO DE TRANSPORTES"
  },
  {
    "codigo":366196004,
    "descripcion":"PERFUSIÓN MIOCÁRDICA - HALLAZGO"
  },
  {
    "codigo":235124007,
    "descripcion":"SIALOADENITIS BACTERIANA AGUDA"
  },
  {
    "codigo":69449002,
    "descripcion":"ACCIÓN DE UN FÁRMACO"
  },
  {
    "codigo":3913002,
    "descripcion":"LESIÓN TRAUMÁTICA DE CONDUCTO GASTROINTESTINAL CON HERIDA ABIERTA HACIA CAVIDAD ABDOMINAL"
  },
  {
    "codigo":724809006,
    "descripcion":"RETINOPATÍA AUTOINMUNITARIA"
  },
  {
    "codigo":117531000119102,
    "descripcion":"FRECUENCIA URINARIA DEBIDA A HIPERTROFIA PROSTÁTICA BENIGNA"
  },
  {
    "codigo":296990001,
    "descripcion":"SOBREDOSIS DE PROCAINAMIDA"
  },
  {
    "codigo":722974003,
    "descripcion":"MIOCLONÍA SEGMENTARIA"
  },
  {
    "codigo":231454003,
    "descripcion":"PERSONALIDAD PSEUDOPSICOPÁTICA ORGÁNICA"
  },
  {
    "codigo":10957441000119109,
    "descripcion":"HERIDA PUNZANTE DE PULGAR IZQUIERDO"
  },
  {
    "codigo":16419611000119104,
    "descripcion":"SÍNDROME DE ESTRÉS DE TIBIA MEDIAL DE PIERNA DERECHA"
  },
  {
    "codigo":295155003,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE DEXTROPROPOXIFENO"
  },
  {
    "codigo":162248005,
    "descripcion":"TIENE SENSACIÓN DE COSQUILLEO"
  },
  {
    "codigo":719304005,
    "descripcion":"DISPLASIA ESPONDILOMETAFISARIA TIPO SCHMIDT"
  },
  {
    "codigo":91061000119100,
    "descripcion":"CONDROSARCOMA PRIMARIO DE HUESO PÉLVICO"
  },
  {
    "codigo":63944008,
    "descripcion":"ROLIDO DIASTÓLICO"
  },
  {
    "codigo":783005002,
    "descripcion":"SÍNDROME DE MICROBRAQUICEFALIA SEVERA, DISCAPACIDAD INTELECTUAL Y PARÁLISIS CEREBRAL ATETOIDE"
  },
  {
    "codigo":29341002,
    "descripcion":"INTOXICACIÓN POR MELIA AZEDARACH"
  },
  {
    "codigo":289650000,
    "descripcion":"CUELLO UTERINO PROLAPSADO EN LA VAGINA CON TRACCIÓN"
  },
  {
    "codigo":94877009,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA CARA INTERNA DE LABIO SUPERIOR"
  },
  {
    "codigo":715634002,
    "descripcion":"DISPLASIA CEMENTO-ÓSEA FLORIDA"
  },
  {
    "codigo":291485009,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR TOBRAMICINA"
  },
  {
    "codigo":224114002,
    "descripcion":"TIENE PADRES ADOLESCENTES"
  },
  {
    "codigo":255047001,
    "descripcion":"TUMOR NEUROENDOCRINO BENIGNO"
  },
  {
    "codigo":123975002,
    "descripcion":"FRACTURA TRIMALEOLAR"
  },
  {
    "codigo":25671008,
    "descripcion":"MENINGITIS EOSINÓFILA"
  },
  {
    "codigo":253212001,
    "descripcion":"EPIBLÉFARON"
  },
  {
    "codigo":285980004,
    "descripcion":"CONTROLA EL TERMOSTATO DE LA TEMPERATURA EN EL HOGAR"
  },
  {
    "codigo":56604005,
    "descripcion":"SÍNDROME DE COHEN"
  },
  {
    "codigo":1074101000119106,
    "descripcion":"CONDROCALCINOSIS DE ARTICULACIÓN DE MUÑECA DERECHA"
  },
  {
    "codigo":449820008,
    "descripcion":"SÍNDROME NEFRÓTICO INFANTIL RESISTENTE A ESTEROIDES"
  },
  {
    "codigo":87537003,
    "descripcion":"CROMATISMO VISUAL"
  },
  {
    "codigo":16638901000119108,
    "descripcion":"COMPRESIÓN DE AMBOS NERVIOS SAFENOS EXTERNOS"
  },
  {
    "codigo":10632271000119102,
    "descripcion":"ABSCESO DE PULPEJO DE PULGAR IZQUIERDO"
  },
  {
    "codigo":284145009,
    "descripcion":"CAPAZ DE MOVER LA MANO"
  },
  {
    "codigo":282310007,
    "descripcion":"CAPAZ DE MANTENERSE EN EQUILIBRIO CUANDO ESTÁ DE PIE"
  },
  {
    "codigo":870299000,
    "descripcion":"MIOPATÍA DEBIDA A DEFICIENCIA DE CALCIO"
  },
  {
    "codigo":741062008,
    "descripcion":"NO INCLUIDO EN LA FUERZA LABORAL"
  },
  {
    "codigo":247707007,
    "descripcion":"PERCEPCIÓN CAMBIADA DE LA GENTE"
  },
  {
    "codigo":409712001,
    "descripcion":"PROLAPSO DE VÁLVULA MITRAL"
  },
  {
    "codigo":278640003,
    "descripcion":"PIEZAS DENTALES DE PRÓTESIS DENTAL MUY OSCURAS"
  },
  {
    "codigo":311408004,
    "descripcion":"TÓRAX INESTABLE CERRADO"
  },
  {
    "codigo":82032009,
    "descripcion":"PRODUCCIÓN NORMAL DE NEUTRÓFILOS"
  },
  {
    "codigo":276805005,
    "descripcion":"LEIOMIOMA DEL ESÓFAGO"
  },
  {
    "codigo":735557006,
    "descripcion":"INFECCIÓN QUE CAUSA GRANULOMA DEL SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":1290778007,
    "descripcion":"OSTEOCONDRITIS DISECANTE DE HUESO DE REGIÓN DE ARTICULACIÓN DE CADERA"
  },
  {
    "codigo":305903001,
    "descripcion":"VISTO POR EL SERVICIO DE UROLOGÍA"
  },
  {
    "codigo":109295002,
    "descripcion":"NEVO MELANOCÍTICO DE LA CADERA"
  },
  {
    "codigo":404207003,
    "descripcion":"MALLA DE HERNIOPLASTIA INFECTADA"
  },
  {
    "codigo":240367005,
    "descripcion":"INFECCIÓN CAUSADA POR DIENTAMOEBA FRAGILIS"
  },
  {
    "codigo":304068004,
    "descripcion":"LABIO LEPORINO BILATERAL"
  },
  {
    "codigo":238532005,
    "descripcion":"DEDOS DE MANO ARRUGADOS"
  },
  {
    "codigo":1285273002,
    "descripcion":"RANGO PASIVO NORMAL DE FLEXIÓN PLANTAR DE TOBILLO"
  },
  {
    "codigo":171161003,
    "descripcion":"CRIBADO PARA CÁNCER DE CUELLO UTERINO - ANORMAL"
  },
  {
    "codigo":236697004,
    "descripcion":"FÍSTULA URETRAL ADQUIRIDA"
  },
  {
    "codigo":1186969003,
    "descripcion":"PERIODONTITIS EXACERBADA POR NEUTROPENIA ADQUIRIDA"
  },
  {
    "codigo":302233006,
    "descripcion":"ESTENOSIS DE ARTERIA RENAL"
  },
  {
    "codigo":120041000119109,
    "descripcion":"FIBRILACIÓN AURICULAR CON RESPUESTA VENTRICULAR RÁPIDA"
  },
  {
    "codigo":365934006,
    "descripcion":"HALLAZGO RELACIONADO CON LA CONCIENCIA DE SÍ MISMO"
  },
  {
    "codigo":890222006,
    "descripcion":"AMELIA BILATERAL DE EXTREMIDADES INFERIORES"
  },
  {
    "codigo":202094008,
    "descripcion":"SEPARACIÓN PERIFÉRICA DEL MENISCO EXTERNO"
  },
  {
    "codigo":300398009,
    "descripcion":"CICATRIZ CUTÁNEA ABDOMINAL"
  },
  {
    "codigo":71022009,
    "descripcion":"PULSO ARTERIAL CAROTÍDEO ANORMAL"
  },
  {
    "codigo":200259003,
    "descripcion":"TROMBOSIS VENOSA CEREBRAL DURANTE EL EMBARAZO"
  },
  {
    "codigo":726382009,
    "descripcion":"DELECIÓN DE PARTE DEL CROMOSOMA 12"
  },
  {
    "codigo":724547007,
    "descripcion":"INFECCIÓN QUE OCASIONA COREA"
  },
  {
    "codigo":722712000,
    "descripcion":"CÁNCER OCUPACIONAL DE PIEL"
  },
  {
    "codigo":1816003,
    "descripcion":"TRASTORNO DE PÁNICO CON AGORAFOBIA, EVITACIÓN AGORAFÓBICA GRAVE Y ATAQUES DE PÁNICO LEVES"
  },
  {
    "codigo":1148696006,
    "descripcion":"LEUCOPENIA MEDICAMENTOSA"
  },
  {
    "codigo":165656009,
    "descripcion":"FOLATO ERITROCÍTICO POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":131053002,
    "descripcion":"NIVEL DE PROGESTERONA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":294893003,
    "descripcion":"ALERGIA A COMPLEJO DE HIERRO POLISACÁRIDO"
  },
  {
    "codigo":360429003,
    "descripcion":"SÍNDROME DE EPIBLÉFARON INFERIOR OBLICUO CONGÉNITO"
  },
  {
    "codigo":15959581000119101,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE AMBOS URÉTERES"
  },
  {
    "codigo":719042007,
    "descripcion":"SÍNDROME DE COLOBOMA DE ÚVEA CON FISURA DE LABIO Y PALADAR Y DISCAPACIDAD INTELECTUAL"
  },
  {
    "codigo":260290009,
    "descripcion":"VISIÓN A DISTANCIA 1\/60"
  },
  {
    "codigo":1208727002,
    "descripcion":"SÍNDROME DE DISCAPACIDAD INTELECTUAL GRAVE, AGENESIA DE CUERPO CALLOSO, DIMORFISMO FACIAL Y ATAXIA CEREBELOSA"
  },
  {
    "codigo":782743001,
    "descripcion":"SÍNDROME SIMILAR A LA ENFERMEDAD DE HUNTINGTON DEBIDO A EXPANSIONES DEL MARCO DE LECTURA ABIERTO 72 EN EL CROMOSOMA 9"
  },
  {
    "codigo":291223002,
    "descripcion":"INTOXICACIÓN POR FLUPENTIXOL"
  },
  {
    "codigo":94615005,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA REGIÓN SUPRACLAVICULAR"
  },
  {
    "codigo":1010284000,
    "descripcion":"TRASTORNO FETAL DEBIDO A ANOMALÍAS EN LA BIOQUÍMICA SANGUÍNEA MATERNA"
  },
  {
    "codigo":717207008,
    "descripcion":"MALASSEZIA FURFUR O MALASSEZIA PACHYDERMATIS"
  },
  {
    "codigo":92780003,
    "descripcion":"CARCINOMA IN SITU DEL TERCIO SUPERIOR DEL ESÓFAGO"
  },
  {
    "codigo":387692004,
    "descripcion":"INERCIA UTERINA HIPOTÓNICA"
  },
  {
    "codigo":289388006,
    "descripcion":"PRESENTACIÓN PALPABLE POR VAGINA - HALLAZGO"
  },
  {
    "codigo":254785001,
    "descripcion":"HEMANGIOMATOSIS ADQUIRIDA"
  },
  {
    "codigo":123713005,
    "descripcion":"ATELECTASIA CRÓNICA"
  },
  {
    "codigo":23574008,
    "descripcion":"PELVIS OBSTRUIDA"
  },
  {
    "codigo":87275002,
    "descripcion":"PÉRDIDA SENSITIVA DISOCIADA"
  },
  {
    "codigo":283883004,
    "descripcion":"HALLAZGO RELACIONADO CON LA MEMORIA INMEDIATA"
  },
  {
    "codigo":368311000119105,
    "descripcion":"VEJIGA URINARIA NEUROPÁTICA REFLEJA"
  },
  {
    "codigo":871872001,
    "descripcion":"INCAPAZ DE DEMOSTRAR CONOCIMIENTOS SOBRE LA SALUD"
  },
  {
    "codigo":249280000,
    "descripcion":"DEBE ADOPTAR UNA POSTURA EN PARTICULAR PARA ORINAR"
  },
  {
    "codigo":185579009,
    "descripcion":"SEGUNDA FALLA EN CRIBADO PARA ALTERACIONES AUDITIVAS EN NIÑOS"
  },
  {
    "codigo":118208006,
    "descripcion":"HALLAZGO RELACIONADO CON LA RESPUESTA TERAPÉUTICA"
  },
  {
    "codigo":183744008,
    "descripcion":"CONSULTA DOMICILIARIA GERIÁTRICA, REALIZADA"
  },
  {
    "codigo":1363392008,
    "descripcion":"SINEQUIAS ANTERIORES PERIFÉRICAS EN CUADRANTE SUPERIOR DE ÁNGULO IRIDOCORNEAL DE OJO IZQUIERDO"
  },
  {
    "codigo":1079121000119101,
    "descripcion":"CARCINOMA BASOCELULAR PRIMARIO DE PIEL DE CADERA IZQUIERDA"
  },
  {
    "codigo":247445007,
    "descripcion":"PUNTO DE LA PIEL"
  },
  {
    "codigo":286391000119108,
    "descripcion":"FÍSTULA ADQUIRIDA DE ARTERIA CORONARIA"
  },
  {
    "codigo":83605009,
    "descripcion":"ANISMO"
  },
  {
    "codigo":1197717008,
    "descripcion":"VÓMITO FUNCIONAL INFANTIL"
  },
  {
    "codigo":704362003,
    "descripcion":"CON MAYOR RIESGO DE HIPERTERMIA"
  },
  {
    "codigo":1163114002,
    "descripcion":"COLITIS POR ESCHERICHIA COLI ENTEROHEMORRÁGICA"
  },
  {
    "codigo":79935000,
    "descripcion":"ENFERMEDAD DE FARBER"
  },
  {
    "codigo":1259583003,
    "descripcion":"RABDOMIOSARCOMA FUSOCELULAR PRIMARIO"
  },
  {
    "codigo":276543004,
    "descripcion":"HEMORRAGIA TRAQUEOBRONQUIAL"
  },
  {
    "codigo":274708000,
    "descripcion":"ESPUTO ANORMAL"
  },
  {
    "codigo":1290516000,
    "descripcion":"MISOFONÍA"
  },
  {
    "codigo":897300000,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE OÍDO CON INFECCIÓN"
  },
  {
    "codigo":733460004,
    "descripcion":"USUARIO DE MARIHUANA"
  },
  {
    "codigo":45332005,
    "descripcion":"RELLENO CAPILAR NORMAL"
  },
  {
    "codigo":43497001,
    "descripcion":"TRASTORNO DEL ESTADO DE ÁNIMO INDUCIDO POR ANFETAMINAS"
  },
  {
    "codigo":373012009,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM ASIATICUM"
  },
  {
    "codigo":10729003,
    "descripcion":"SÍNDROME RESPIRATORIO DEL FUMADOR"
  },
  {
    "codigo":403945001,
    "descripcion":"ADENOMA CERUMINOSO"
  },
  {
    "codigo":240105009,
    "descripcion":"MIOSITIS VIRAL"
  },
  {
    "codigo":762558001,
    "descripcion":"DERMATITIS ALÉRGICA POR CONTACTO OCUPACIONAL CAUSADA POR PRODUCTO DE PELUQUERÍA"
  },
  {
    "codigo":860862007,
    "descripcion":"PÓLIPO HIPERPLÁSICO DE APÉNDICE"
  },
  {
    "codigo":236435004,
    "descripcion":"INSUFICIENCIA RENAL EN ESTADIO TERMINAL EN DIÁLISIS"
  },
  {
    "codigo":39901000087101,
    "descripcion":"HEMATOMA DE PÁRPADO INFERIOR DERECHO"
  },
  {
    "codigo":301971006,
    "descripcion":"ORIFICIO LAGRIMAL SUPERIOR DILATADO"
  },
  {
    "codigo":42461000087103,
    "descripcion":"HERIDA PUNZANTE DE GLÚTEO CON CUERPO EXTRAÑO"
  },
  {
    "codigo":37992001,
    "descripcion":"INSUFICIENCIA PANCREÁTICA"
  },
  {
    "codigo":34781000087106,
    "descripcion":"LESIONES TRAUMÁTICAS MÚLTIPLES DE EXTREMIDAD INFERIOR LIBRE"
  },
  {
    "codigo":300136003,
    "descripcion":"CONDUCTO AUDITIVO DE COLOR NORMAL"
  },
  {
    "codigo":365672004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD DE RAZONAMIENTO"
  },
  {
    "codigo":234600005,
    "descripcion":"DEFICIENCIA DEL COMPLEMENTO 4"
  },
  {
    "codigo":169064005,
    "descripcion":"TC NORMAL"
  },
  {
    "codigo":1217640008,
    "descripcion":"PARÁLISIS CONGÉNITA MONOCULAR DE MÚSCULO ELEVADOR"
  },
  {
    "codigo":315371000119107,
    "descripcion":"OSTEOCONDROPATÍA DE MANO IZQUIERDA"
  },
  {
    "codigo":724285006,
    "descripcion":"DEDO DEL PIE EN MARTILLO ADQUIRIDO"
  },
  {
    "codigo":298301007,
    "descripcion":"PROBLEMA DEL MÚSCULO ESQUELÉTICO"
  },
  {
    "codigo":722450007,
    "descripcion":"SÍNDROME DE GLAUCOMA, ECTOPIA, MICROESFEROFAQUIA, RIGIDEZ ARTICULAR Y BAJA ESTATURA"
  },
  {
    "codigo":296466007,
    "descripcion":"SOBREDOSIS DE ACITRETINA"
  },
  {
    "codigo":1144764001,
    "descripcion":"NEOPLASIA MALIGNA DE ESÓFAGO CON FUSIÓN DEL GEN DE LA NEURREGULINA 1"
  },
  {
    "codigo":30652003,
    "descripcion":"SÍNDROME DE EHLERS - DANLOS HIPERMÓVIL"
  },
  {
    "codigo":292796003,
    "descripcion":"REACCIÓN ADVERSA A LA HIDROXIETILCELULOSA"
  },
  {
    "codigo":161724003,
    "descripcion":"DURACIÓN DE CICLO ESTABLE"
  },
  {
    "codigo":290961001,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR CARBAMAZEPINA"
  },
  {
    "codigo":61585002,
    "descripcion":"OSTEOMIELITIS DE LA MANO"
  },
  {
    "codigo":1081631000119101,
    "descripcion":"RABDOMIOSARCOMA PRIMARIO DE EXTREMIDAD INFERIOR IZQUIERDA"
  },
  {
    "codigo":1208465005,
    "descripcion":"REACCIÓN ADVERSA A BEBTELOVIMAB"
  },
  {
    "codigo":127121006,
    "descripcion":"LINFADENOPATÍA CÍSTICA"
  },
  {
    "codigo":1306769008,
    "descripcion":"TRASTORNO DE CRISTALINO DE OJO DERECHO"
  },
  {
    "codigo":94353008,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL ISQUION"
  },
  {
    "codigo":15991071000119102,
    "descripcion":"PARS PLANITIS DE OJO IZQUIERDO"
  },
  {
    "codigo":289126003,
    "descripcion":"REALIZA ACTIVIDADES DE CUIDADO BUCAL"
  },
  {
    "codigo":715110006,
    "descripcion":"NO PASA DE LA SILLA DE RUEDAS AL AUTOMÓVIL"
  },
  {
    "codigo":420198007,
    "descripcion":"REACCIÓN ALÉRGICA CAUSADA POR PLATINO"
  },
  {
    "codigo":418363000,
    "descripcion":"PRURITO CUTÁNEO"
  },
  {
    "codigo":25147002,
    "descripcion":"DERMATOSIS PUSTULOSA SUBCORNEAL"
  },
  {
    "codigo":713275003,
    "descripcion":"ESPLENOMEGALIA CONCOMITANTE CON INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":188987003,
    "descripcion":"LIPOMA DE OÍDO"
  },
  {
    "codigo":416528001,
    "descripcion":"ADELGAZAMIENTO INTENCIONAL"
  },
  {
    "codigo":711440009,
    "descripcion":"PRUEBA DE APREHENSIÓN DE RODILLA NEGATIVA"
  },
  {
    "codigo":283621002,
    "descripcion":"HERIDA POR PINCHAZO DE AGUJA EN EL TRONCO"
  },
  {
    "codigo":285456009,
    "descripcion":"INCAPAZ DE ABRIR Y CERRAR LA BOCA"
  },
  {
    "codigo":87013007,
    "descripcion":"INFESTACIÓN CAUSADA POR OTOBIUS"
  },
  {
    "codigo":15718841000119102,
    "descripcion":"TRASTORNO DE ENTESIS DE AMBAS REGIONES DE MUÑECA"
  },
  {
    "codigo":840677008,
    "descripcion":"DEFORMIDAD DE PIE DERECHO"
  },
  {
    "codigo":609466002,
    "descripcion":"INTERRUPCIÓN INDUCIDA DEL EMBARAZO COMPLICADA POR HEMÓLISIS INTRAVASCULAR"
  },
  {
    "codigo":773306002,
    "descripcion":"MIOPATÍA LETAL CONGÉNITA TIPO COMPTON NORTH"
  },
  {
    "codigo":707770004,
    "descripcion":"DUPLICACIÓN CONGÉNITA DE SISTEMA COLECTOR RENAL"
  },
  {
    "codigo":344351000119108,
    "descripcion":"SINEQUIAS POSTERIORES DEL IRIS DE AMBOS OJOS"
  },
  {
    "codigo":871610003,
    "descripcion":"DEFECTO DE TABIQUE VENTRICULAR CON COMPROMISO DOBLE DE SALIDA YUXTAARTERIAL CON EXTENSIÓN PERIMEMBRANOSA"
  },
  {
    "codigo":1363130007,
    "descripcion":"ASTILLA EN DORSO CON INFECCIÓN"
  },
  {
    "codigo":314554007,
    "descripcion":"VASCULARIZACIÓN DE INJERTO CORNEAL"
  },
  {
    "codigo":249018008,
    "descripcion":"ÚTERO IRRITABLE"
  },
  {
    "codigo":771471002,
    "descripcion":"SÍNDROME DE EDEMA DEL NERVIO ÓPTICO Y ESPLENOMEGALIA"
  },
  {
    "codigo":51891008,
    "descripcion":"POLIARTROPATÍA ASOCIADA CON OTRA ENFERMEDAD"
  },
  {
    "codigo":312719004,
    "descripcion":"TRASTORNO DE LENTE INTRAOCULAR"
  },
  {
    "codigo":247183001,
    "descripcion":"DEGENERACIÓN RETINIANA CON COPOS PERIFÉRICOS"
  },
  {
    "codigo":11786681000119105,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO DE REGIÓN INGUINAL IZQUIERDA"
  },
  {
    "codigo":317881000119106,
    "descripcion":"ARTRITIS NEUMOCÓCICA DE ARTICULACIÓN DE CADERA DERECHA"
  },
  {
    "codigo":1162852008,
    "descripcion":"CALCINOSIS TUMORAL NORMOFOSFATÉMICA FAMILIAR"
  },
  {
    "codigo":866105000,
    "descripcion":"INESTABILIDAD DE COLUMNA VERTEBRAL DEBIDA A TRASTORNO INFECCIOSO"
  },
  {
    "codigo":440121002,
    "descripcion":"LINFEDEMA POSQUIRÚRGICO"
  },
  {
    "codigo":1259321002,
    "descripcion":"CARCINOMA PRIMARIO DE LARINGE"
  },
  {
    "codigo":210745004,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA, VARIOS DEDOS DEL PIE"
  },
  {
    "codigo":441956008,
    "descripcion":"COBALTO EN ESPÉCIMEN DE SANGRE POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":276281008,
    "descripcion":"HEMORRAGIA SUBARACNOIDEA PROVENIENTE DE ANEURISMA DE LA ARTERIA CEREBRAL POSTERIOR"
  },
  {
    "codigo":733198005,
    "descripcion":"ENCEFALOPATÍA DEBIDA A CIRCULACIÓN EXTRACORPÓREA Y POSTERIOR A ELLA"
  },
  {
    "codigo":307214007,
    "descripcion":"HEMATOMA DE LA REGIÓN TEMPORAL"
  },
  {
    "codigo":208910009,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA EXPUESTA DE LA ARTICULACIÓN DE LA CADERA, POSTERIOR"
  },
  {
    "codigo":698595002,
    "descripcion":"ECOGENICIDAD DEL CORAZÓN FETAL EN ECOGRAFÍA OBSTÉTRICA"
  },
  {
    "codigo":291411000119104,
    "descripcion":"HEMORRAGIA ESPONTÁNEA DE ARTERIA COMUNICANTE POSTERIOR IZQUIERDA EN ESPACIO SUBARACNOIDEO"
  },
  {
    "codigo":239843003,
    "descripcion":"GOTA SECUNDARIA"
  },
  {
    "codigo":1255651005,
    "descripcion":"CARCINOMA ESCAMOSO BASALOIDE DE PULMÓN"
  },
  {
    "codigo":303544005,
    "descripcion":"AMPLITUD DE PROTRACCIÓN ACTIVA DE COLUMNA CERVICAL DISMINUIDA"
  },
  {
    "codigo":203405000,
    "descripcion":"OSTEOCONDRITIS DISECANTE DEL CÓNDILO FEMORAL EXTERNO"
  },
  {
    "codigo":540981000124107,
    "descripcion":"MASA DE ÁNGULO HEPÁTICO DE COLON"
  },
  {
    "codigo":432781003,
    "descripcion":"POSICIÓN EN SILLA DE PLAYA"
  },
  {
    "codigo":170637003,
    "descripcion":"ASMA QUE LIMITA LAS ACTIVIDADES"
  },
  {
    "codigo":39565009,
    "descripcion":"CRISIS DE DOLOR"
  },
  {
    "codigo":234338001,
    "descripcion":"TRASTORNO ERITROCITARIO DE TIPO NO ANÉMICO"
  },
  {
    "codigo":299874003,
    "descripcion":"REFLEJO ROTULIANO ACTIVO"
  },
  {
    "codigo":430946003,
    "descripcion":"INFECCIÓN CAUSADA POR BACTERIAS RESISTENTES A QUINOLONAS Y FLUOROQUINOLONAS"
  },
  {
    "codigo":103266004,
    "descripcion":"DESEQUILIBRIO DEL MÚSCULO OCULAR"
  },
  {
    "codigo":201570004,
    "descripcion":"ARTRITIS REACTIVA DE ARTICULACIÓN TIBIOPERONEA"
  },
  {
    "codigo":365410006,
    "descripcion":"ONDA P ELECTROCARDIOGRÁFICA - HALLAZGO"
  },
  {
    "codigo":1217378004,
    "descripcion":"DISTRACCIÓN DURANTE LA ALIMENTACIÓN"
  },
  {
    "codigo":134199001,
    "descripcion":"ANOMALÍA DE LOS LEUCOCITOS"
  },
  {
    "codigo":199735002,
    "descripcion":"HALLAZGO CITOLÓGICO ANORMAL EN EL CRIBADO MATERNO PRENATAL"
  },
  {
    "codigo":396343006,
    "descripcion":"FUNISITIS"
  },
  {
    "codigo":165132006,
    "descripcion":"RESULTADO ANORMAL DE BIOPSIA QUIRÚRGICA"
  },
  {
    "codigo":230668007,
    "descripcion":"HIPERHIDROSIS DIFUSA IDIOPÁTICA"
  },
  {
    "codigo":720353000,
    "descripcion":"CRISTALES CON FORMA DE AGUJA PRESENTES"
  },
  {
    "codigo":787724008,
    "descripcion":"ÁCIDO DESOXIRRIBONUCLEICO DE VIRUS PAPILOMA HUMANO NO DETECTADO"
  },
  {
    "codigo":346861000119107,
    "descripcion":"GLAUCOMA DE ÁNGULO ANATÓMICO CERRADO DE AMBOS OJOS"
  },
  {
    "codigo":294369004,
    "descripcion":"ALERGIA A ZIDOVUDINA"
  },
  {
    "codigo":785889008,
    "descripcion":"USUARIO DE CIGARRILLO ELECTRÓNICO CARGADO CON NICOTINA"
  },
  {
    "codigo":292534001,
    "descripcion":"REACCIÓN ADVERSA A LA ATROPINA"
  },
  {
    "codigo":1144502002,
    "descripcion":"PERIOSTITIS SIN OSTEOMIELITIS DE PELVIS Y FÉMUR"
  },
  {
    "codigo":30390004,
    "descripcion":"TRASTORNO METABÓLICO GENERALIZADO"
  },
  {
    "codigo":11815661000119109,
    "descripcion":"RUPTURA TRAUMÁTICA DE PLACA PALMAR DE ARTICULACIÓN DE DEDO MEÑIQUE DERECHO"
  },
  {
    "codigo":95926007,
    "descripcion":"CÓNYUGE VÍCTIMA DE ABUSO PSICOLÓGICO"
  },
  {
    "codigo":290699005,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR FLUOROURACILO"
  },
  {
    "codigo":1306507005,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE PORCIÓN CENTRAL DE MAMA DERECHA"
  },
  {
    "codigo":126859007,
    "descripcion":"NEOPLASIA DE PÁNCREAS"
  },
  {
    "codigo":716683005,
    "descripcion":"SÍNDROME DE MICRODUPLICACIÓN 17Q21.31"
  },
  {
    "codigo":92256001,
    "descripcion":"NEOPLASIA BENIGNA DEL NERVIO OLFATORIO"
  },
  {
    "codigo":320391000119106,
    "descripcion":"ARTROSIS SECUNDARIA DE MANO DERECHA"
  },
  {
    "codigo":714848007,
    "descripcion":"INCAPAZ DE ADMINISTRARSE MEDICACIÓN NO PARENTERAL"
  },
  {
    "codigo":57653000,
    "descripcion":"INSUFICIENCIA MULTIORGÁNICA"
  },
  {
    "codigo":876853002,
    "descripcion":"AGENESIA DE HUESO TARSIANO Y METATARSIANO"
  },
  {
    "codigo":130081000119101,
    "descripcion":"SÍNDROME DE DOWN DETECTADO POR CRIBADO DE MÚLTIPLES MARCADORES"
  },
  {
    "codigo":188725004,
    "descripcion":"LEUCEMIA LINFOIDEA"
  },
  {
    "codigo":254261005,
    "descripcion":"SEUDOTRISOMÍA 18"
  },
  {
    "codigo":1237301002,
    "descripcion":"RETRACCIÓN ANORMAL DE PEZÓN DERECHO"
  },
  {
    "codigo":713013008,
    "descripcion":"ATAQUE DE APNEA DEL LLANTO"
  },
  {
    "codigo":711178002,
    "descripcion":"ESPECIE DE KLEBSIELLA O ESPECIE DE ENTEROBACTER"
  },
  {
    "codigo":285194004,
    "descripcion":"INCAPAZ DE RECORDAR EL MES DEL AÑO"
  },
  {
    "codigo":449034009,
    "descripcion":"NEOPLASIA MALIGNA DE REGIÓN ANTEROLATERAL DEL PISO DE LA BOCA"
  },
  {
    "codigo":293921000119104,
    "descripcion":"SÍNDROME DE DOLOR REGIONAL COMPLEJO TIPO I DE AMBOS MIEMBROS SUPERIORES"
  },
  {
    "codigo":283359004,
    "descripcion":"LACERACIÓN DE FRENTE"
  },
  {
    "codigo":1299167004,
    "descripcion":"ESTADO EPILÉPTICO TÓNICO-CLÓNICO FOCAL A BILATERAL"
  },
  {
    "codigo":609204004,
    "descripcion":"HEMATOMA SUBCORIÓNICO"
  },
  {
    "codigo":248756005,
    "descripcion":"ESCASA PERFUSIÓN CUBITAL DE LA MANO"
  },
  {
    "codigo":1297332004,
    "descripcion":"CIERRE DE ÁNGULO DE OJO DERECHO CAUSADO POR FÁRMACO"
  },
  {
    "codigo":707508008,
    "descripcion":"NEUMONÍA CAUSADA POR SCHISTOSOMA HAEMATOBIUM"
  },
  {
    "codigo":281524009,
    "descripcion":"LESIÓN DEL FIBROCARTÍLAGO TRIANGULAR DE LA ARTICULACIÓN DE LA MUÑECA"
  },
  {
    "codigo":312457003,
    "descripcion":"ANTICUERPO DE GRUPO SANGUÍNEO IRREGULAR DETECTADO"
  },
  {
    "codigo":11818171000119101,
    "descripcion":"ESGUINCE DE LIGAMENTO DE ARTICULACIÓN METACARPOFALÁNGICA DE DEDO MEÑIQUE DE MANO DERECHA"
  },
  {
    "codigo":246921007,
    "descripcion":"GLOBO OCULAR ESTAFILOMATOSO"
  },
  {
    "codigo":103611000119102,
    "descripcion":"CIRROSIS HEPÁTICA DEBIDA A HEPATITIS B"
  },
  {
    "codigo":1162590005,
    "descripcion":"DIVERTICULITIS DE COLON ASCENDENTE"
  },
  {
    "codigo":212318006,
    "descripcion":"LESIÓN NO EXPUESTA DE NERVIO CIÁTICO POPLÍTEO EXTERNO"
  },
  {
    "codigo":736606009,
    "descripcion":"PUBERTAD PRECOZ INDEPENDIENTE DE LA GONADOTROFINA"
  },
  {
    "codigo":79411002,
    "descripcion":"PROSTATITIS AGUDA"
  },
  {
    "codigo":1259059003,
    "descripcion":"TRASTORNO DE SISTEMA NERVIOSO AUTÓNOMO DEBIDO A DIFTERIA"
  },
  {
    "codigo":7031000119100,
    "descripcion":"FUGA PSICÓGENA CONCOMITANTE CON REACCIÓN DE ESTRÉS Y DEBIDA A ELLA"
  },
  {
    "codigo":210483004,
    "descripcion":"HERIDA ABIERTA EN LA REGIÓN PÉLVICA"
  },
  {
    "codigo":10669431000119102,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN EN ESPALDA NO ESTADIFICABLE"
  },
  {
    "codigo":10628471000119103,
    "descripcion":"PARONIQUIA DE PULGAR"
  },
  {
    "codigo":10751351000119104,
    "descripcion":"SEPSIS DEBIDA A EMBARAZO ECTÓPICO"
  },
  {
    "codigo":15919991000119104,
    "descripcion":"REACCIÓN ALÉRGICA CAUSADA POR ANESTÉSICO"
  },
  {
    "codigo":896776002,
    "descripcion":"FORMA ANCHA ANORMAL CONGÉNITA DE FALANGE DE PIE"
  },
  {
    "codigo":1084791000119106,
    "descripcion":"PARO CARDÍACO DEBIDO A FIEBRE TIFOIDEA"
  },
  {
    "codigo":10679671000119105,
    "descripcion":"MASA DE TEJIDO SUBCUTÁNEO DE DEDO DE AMBAS MANOS"
  },
  {
    "codigo":11839351000119109,
    "descripcion":"DISTENSIÓN DE MÚSCULO DE MUÑECA DERECHA"
  },
  {
    "codigo":334711000119109,
    "descripcion":"OFTALMOPLEJÍA INTERNUCLEAR DE OJO DERECHO"
  },
  {
    "codigo":322901000119100,
    "descripcion":"DEDO DE LA MANO EN GATILLO ADQUIRIDO, DEDO MEÑIQUE IZQUIERDO"
  },
  {
    "codigo":1077111000119103,
    "descripcion":"QUISTE ÓSEO DE TIBIA DERECHA"
  },
  {
    "codigo":12151000119105,
    "descripcion":"VÉRTIGO CRÓNICO"
  },
  {
    "codigo":274184005,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DEL DORSO"
  },
  {
    "codigo":286071000119109,
    "descripcion":"ESTENOSIS CONGÉNITA DE ARTERIA PULMONAR PERIFÉRICA"
  },
  {
    "codigo":110344003,
    "descripcion":"DEGLUCIÓN DE LA LENGUA"
  },
  {
    "codigo":939885431000119109,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DEBIDO A EMBOLIA DE AMBAS ARTERIAS CEREBRALES MEDIAS"
  },
  {
    "codigo":15999351000119109,
    "descripcion":"CICATRIZ DE CÓRNEA DE OJO IZQUIERDO"
  },
  {
    "codigo":763869003,
    "descripcion":"MIELITIS CAUSADA POR RADIACIÓN IONIZANTE POSTERIOR A RADIOTERAPIA"
  },
  {
    "codigo":403421008,
    "descripcion":"PANICULITIS NEONATAL POR FRÍO"
  },
  {
    "codigo":10205009,
    "descripcion":"ANEMIA MEGALOBLÁSTICA POR DERMATITIS EXFOLIATIVA"
  },
  {
    "codigo":8370004,
    "descripcion":"ANEURISMA DE ARTERIA ESPINAL"
  },
  {
    "codigo":72071001,
    "descripcion":"TIROIDITIS POR VIRUS DE LA PAROTIDITIS URLIANA"
  },
  {
    "codigo":235911006,
    "descripcion":"RECHAZO DE TRASPLANTE HEPÁTICO"
  },
  {
    "codigo":1153415008,
    "descripcion":"SECUESTRO AGUDO DE BAZO DEBIDO A ENFERMEDAD DE CÉLULAS FALCIFORMES CON HEMOGLOBINA C CON CRISIS DREPANOCÍTICA"
  },
  {
    "codigo":432519008,
    "descripcion":"ANTÍGENO DE CÁNCER 125 POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":234076002,
    "descripcion":"HEMORRAGIA VENOSA"
  },
  {
    "codigo":301447009,
    "descripcion":"SARPULLIDO MULTIMÓRFICO"
  },
  {
    "codigo":365148005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA GOLPEAR OBJETOS ENTRE SÍ"
  },
  {
    "codigo":166705000,
    "descripcion":"NIVEL DE FOSFATO SÉRICO FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":201308009,
    "descripcion":"CICATRIZ EXUBERANTE"
  },
  {
    "codigo":428849001,
    "descripcion":"OBSTRUCCIÓN PARCIAL DE VÍA AÉREA CAUSADA POR ALIMENTO"
  },
  {
    "codigo":789297003,
    "descripcion":"QUERATITIS MARGINAL DE OJO DERECHO CAUSADA POR TOXINA ESTAFILOCÓCICA"
  },
  {
    "codigo":16434671000119101,
    "descripcion":"SÍNDROME METABÓLICO RELACIONADO CON REGULADOR DE CONDUCTANCIA TRANSMEMBRANARIO DE FIBROSIS QUÍSTICA"
  },
  {
    "codigo":299612009,
    "descripcion":"AMPLITUD DE ABDUCCIÓN PASIVA DE DEDO DEL PIE NORMAL"
  },
  {
    "codigo":232241006,
    "descripcion":"OTITIS TRAUMÁTICA CRÓNICA EXTERNA"
  },
  {
    "codigo":35633007,
    "descripcion":"REACCIÓN A TRANSFUSIÓN DEBIDA A EXCESO DE VOLUMEN"
  },
  {
    "codigo":263174002,
    "descripcion":"FRACTURA DE LA PARED DEL BOLSILLO PERIODONTAL MANDIBULAR"
  },
  {
    "codigo":164870003,
    "descripcion":"INFARTO SUDENDOCÁRDICO EN EL ELECTROCARDIOGRAMA"
  },
  {
    "codigo":64731001,
    "descripcion":"TRASTORNO BIPOLAR I GRAVE, EPISODIO MÁS RECIENTE MIXTO, CON SÍNTOMAS PSICÓTICOS, CONGRUENTE CON EL ESTADO DE ÁNIMO"
  },
  {
    "codigo":195803003,
    "descripcion":"AMIGDALITIS CASEOSA"
  },
  {
    "codigo":359643005,
    "descripcion":"ENTESITIS"
  },
  {
    "codigo":423344000,
    "descripcion":"VÍCTIMA DE DISCIPLINA SEVERA"
  },
  {
    "codigo":95664006,
    "descripcion":"COMPRESIÓN DE NERVIO CRANEAL"
  },
  {
    "codigo":292272007,
    "descripcion":"REACCIÓN ADVERSA A LA LISURIDA"
  },
  {
    "codigo":30128009,
    "descripcion":"ENFERMEDAD DE TIETZE"
  },
  {
    "codigo":16270831000119107,
    "descripcion":"BULIMIA NERVIOSA EN REMISIÓN PARCIAL"
  },
  {
    "codigo":126597003,
    "descripcion":"NEOPLASIA DE FALANGE DEL PIE"
  },
  {
    "codigo":716421004,
    "descripcion":"CAPAZ DE MANEJAR EL ESTRÉS"
  },
  {
    "codigo":1339013005,
    "descripcion":"TRASTORNO DE ENCÉFALO DEBIDO A RADIOTERAPIA Y POSTERIOR A ELLA"
  },
  {
    "codigo":93829002,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA CARA HIPOFARÍNGEA DEL PLIEGUE ARITENOEPIGLÓTICO"
  },
  {
    "codigo":290437004,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR PICOSULFATO DE SODIO"
  },
  {
    "codigo":28293008,
    "descripcion":"ENFERMEDAD POR DEFICIENCIA HEREDITARIA DE FACTOR VIII"
  },
  {
    "codigo":10864111000119107,
    "descripcion":"HERIDA POR DISPARO DE ARMA DE FUEGO DE PIERNA IZQUIERDA"
  },
  {
    "codigo":288602008,
    "descripcion":"NO EMPLEA LA COMUNICACIÓN VERBAL"
  },
  {
    "codigo":1237039001,
    "descripcion":"METÁSTASIS DE CARCINOMA DE TERCIO SUPERIOR DE ESÓFAGO"
  },
  {
    "codigo":286767004,
    "descripcion":"RASGO DE LA PERSONALIDAD: ESFUERZO EN EL TRABAJO - HALLAZGO"
  },
  {
    "codigo":188463006,
    "descripcion":"ENFERMEDAD PÉLVICA INFLAMATORIA POR CLAMIDIA"
  },
  {
    "codigo":448772000,
    "descripcion":"MASA DE ESTRUCTURA DE CAVIDAD ABDOMINAL"
  },
  {
    "codigo":186628001,
    "descripcion":"COMA HEPÁTICO DEBIDO A HEPATITIS VIRAL TIPO C"
  },
  {
    "codigo":22788004,
    "descripcion":"RUPTURA DE LA VESÍCULA BILIAR"
  },
  {
    "codigo":219396005,
    "descripcion":"HERIDA DE GUERRA POR EXPLOSIÓN DE PROYECTIL DE ARTILLERÍA MARÍTIMO"
  },
  {
    "codigo":284932006,
    "descripcion":"CAPAZ DE ADAPTAR ROPA PARA EL BAÑO"
  },
  {
    "codigo":20953001,
    "descripcion":"CRIPTOCOCOSIS PULMONAR"
  },
  {
    "codigo":86489003,
    "descripcion":"NEUROPATÍA AUTONÓMICA PERIFÉRICA IDIOPÁTICA"
  },
  {
    "codigo":283097006,
    "descripcion":"ARAÑAZO DE INGLE"
  },
  {
    "codigo":838318002,
    "descripcion":"NEOPLASIA INTRAEPITELIAL PLANA DE ALTO GRADO DE VESÍCULA BILIAR"
  },
  {
    "codigo":314030005,
    "descripcion":"UVEÍTIS POSTRAUMÁTICA"
  },
  {
    "codigo":51886007,
    "descripcion":"TRITANOMALÍA"
  },
  {
    "codigo":772782007,
    "descripcion":"HERNIA FEMORAL DERECHA RECURRENTE OBSTRUIDA"
  },
  {
    "codigo":248494009,
    "descripcion":"DISTENSIÓN DE ARTERIA"
  },
  {
    "codigo":312195001,
    "descripcion":"INFECCIÓN GENITAL MASCULINA"
  },
  {
    "codigo":445102008,
    "descripcion":"BRONQUIOLITIS CAUSADA POR METAPNEUMOVIRUS HUMANO"
  },
  {
    "codigo":246659002,
    "descripcion":"ESCOTOMA PERIFÉRICO"
  },
  {
    "codigo":410499008,
    "descripcion":"TRABECULITIS"
  },
  {
    "codigo":770947009,
    "descripcion":"NEUTROPENIA CONGÉNITA SEVERA AUTOSÓMICA DOMINANTE"
  },
  {
    "codigo":1162328005,
    "descripcion":"OSTEONECROSIS DE HUESO DE ANTEBRAZO DEBIDA A HEMOGLOBINOPATÍA"
  },
  {
    "codigo":48216006,
    "descripcion":"MIASIS OFTÁLMICA"
  },
  {
    "codigo":408664007,
    "descripcion":"OCLUSIÓN DE LA ARTERIA PONTINA"
  },
  {
    "codigo":308525001,
    "descripcion":"ESTADO DE CONTROL CLÍNICO B"
  },
  {
    "codigo":210221002,
    "descripcion":"LESIÓN NO EXPUESTA DEL ÚTERO"
  },
  {
    "codigo":110082000,
    "descripcion":"AVULSIÓN DE LA MANDÍBULA"
  },
  {
    "codigo":275757008,
    "descripcion":"MIELOCITOS EN SANGRE"
  },
  {
    "codigo":220935971000119109,
    "descripcion":"RETINOPATÍA IZQUIERDA CAUSADA POR PENTOSANO POLISULFATO"
  },
  {
    "codigo":11849661000119103,
    "descripcion":"ABRASIÓN DE PIEL DE PARED TORÁCICA IZQUIERDA"
  },
  {
    "codigo":241154007,
    "descripcion":"ANGINA ABDOMINAL"
  },
  {
    "codigo":1287895005,
    "descripcion":"TROMBOSIS VENOSA PROFUNDA CRÓNICA DE EXTREMIDAD SUPERIOR IZQUIERDA POSTERIOR A PROCEDIMIENTO"
  },
  {
    "codigo":370391006,
    "descripcion":"PACIENTE INMUNODEPRIMIDO"
  },
  {
    "codigo":42711005,
    "descripcion":"NECROSIS DE LA PULPA"
  },
  {
    "codigo":304855006,
    "descripcion":"TRANSFERENCIA EROTIZADA"
  },
  {
    "codigo":403159009,
    "descripcion":"DERMATITIS POR ESPONJA"
  },
  {
    "codigo":204716002,
    "descripcion":"ATRESIA DE ANO CON FÍSTULA"
  },
  {
    "codigo":1156823006,
    "descripcion":"ATROFIA ÓPTICA AUTOSÓMICA RECESIVA BILATERAL"
  },
  {
    "codigo":698071008,
    "descripcion":"HIPERPLASIA ONCOCÍTICA NODULAR MULTIFOCAL DE GLÁNDULA SALIVAL"
  },
  {
    "codigo":354391000119100,
    "descripcion":"SARCOMA DE KAPOSI DE PULMÓN IZQUIERDO"
  },
  {
    "codigo":16001111000119100,
    "descripcion":"DESPLAZAMIENTO DE OJO IZQUIERDO"
  },
  {
    "codigo":301185000,
    "descripcion":"VEGETACIONES DE VÁLVULA MITRAL"
  },
  {
    "codigo":71809002,
    "descripcion":"DIETA GRASA"
  },
  {
    "codigo":39041004,
    "descripcion":"MIOCARDIOPATÍA RESTRICTIVA SECUNDARIA A SARCOIDOSIS"
  },
  {
    "codigo":202881005,
    "descripcion":"TENDINITIS DEL MÚSCULO TIBIAL POSTERIOR"
  },
  {
    "codigo":6273006,
    "descripcion":"PRIAPISMO"
  },
  {
    "codigo":366721008,
    "descripcion":"HALLAZGO RELACIONADO CON NÚMERO DE ARTICULACIONES COMPROMETIDAS"
  },
  {
    "codigo":233814000,
    "descripcion":"NEOPLASIA DE VÍA ÁREA INFERIOR Y MEDIASTINO"
  },
  {
    "codigo":1091671000119102,
    "descripcion":"TRASTORNO DE MASTOIDES DERECHA"
  },
  {
    "codigo":1251457009,
    "descripcion":"METÁSTASIS DE NEUROBLASTOMA EN SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":723499000,
    "descripcion":"DERMOIDE EN ANILLO DE CÓRNEA"
  },
  {
    "codigo":168278009,
    "descripcion":"SEROLOGÍA DE HELICOBACTER DUDOSA"
  },
  {
    "codigo":364886008,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA EMPUJAR Y TIRAR DE UN OBJETO GRANDE POR EL PISO"
  },
  {
    "codigo":789035002,
    "descripcion":"REQUIERE VACUNACIÓN CONTRA HEPATITIS VIRAL"
  },
  {
    "codigo":166443001,
    "descripcion":"NIVEL DE PROGESTERONA SÉRICA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":231979008,
    "descripcion":"LUXACIÓN ESPONTÁNEA DEL CRISTALINO"
  },
  {
    "codigo":721664001,
    "descripcion":"VASCULITIS DE ARTERIA MESENTÉRICA"
  },
  {
    "codigo":230144003,
    "descripcion":"MENINGOENCEFALITIS CRÓNICA POR ECOVIRUS"
  },
  {
    "codigo":262912004,
    "descripcion":"LESIÓN DE URETRA MASCULINA"
  },
  {
    "codigo":295680004,
    "descripcion":"SOBREDOSIS DE MITOXANTRONA"
  },
  {
    "codigo":361216007,
    "descripcion":"MONONEUROPATÍA FEMORAL DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":293845003,
    "descripcion":"ALERGIA A SERTRALINA"
  },
  {
    "codigo":15728881000119102,
    "descripcion":"TRASTORNO DE ARTICULACIÓN DE TOBILLO DERECHO"
  },
  {
    "codigo":95402002,
    "descripcion":"INDURACIÓN DEL SITIO DE INYECCIÓN"
  },
  {
    "codigo":28031001,
    "descripcion":"REACCIÓN INMUNITARIA MEDIADA POR CÉLULAS"
  },
  {
    "codigo":160938009,
    "descripcion":"CASA ALQUILADA AL AYUNTAMIENTO"
  },
  {
    "codigo":93567006,
    "descripcion":"OSIFICACIÓN INCOMPLETA DEL ARCO DE LA VÉRTEBRA DORSAL"
  },
  {
    "codigo":290175009,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR BUPRENORFINA"
  },
  {
    "codigo":58964002,
    "descripcion":"ABSCESO DE ANTEBRAZO"
  },
  {
    "codigo":288340004,
    "descripcion":"NO DIRIGE (UN AUTOMÓVIL)"
  },
  {
    "codigo":419412007,
    "descripcion":"ALERGIA A CAUCHO"
  },
  {
    "codigo":778025006,
    "descripcion":"SÍNDROME DE HIPOTONÍA-CISTINURIA ATÍPICO"
  },
  {
    "codigo":24361006,
    "descripcion":"RETRACCIÓN DEL MEDIASTINO"
  },
  {
    "codigo":253737007,
    "descripcion":"LARINGOMALACIA CONGÉNITA"
  },
  {
    "codigo":55294001,
    "descripcion":"NECROSIS HEPÁTICA FOCAL"
  },
  {
    "codigo":448510002,
    "descripcion":"ESTENOSIS DE ARTERIA PULMONAR IZQUIERDA"
  },
  {
    "codigo":286505007,
    "descripcion":"NO PREPARA BEBIDAS"
  },
  {
    "codigo":57129007,
    "descripcion":"CUERPO EXTRAÑO MAGNÉTICO RETENIDO EN EL CUERPO VÍTREO"
  },
  {
    "codigo":284670008,
    "descripcion":"COMPROMISO NUTRICIONAL"
  },
  {
    "codigo":250067008,
    "descripcion":"ATAXIA DEL TRONCO"
  },
  {
    "codigo":51624005,
    "descripcion":"TROMBOCITOPENIA DILUCIONAL"
  },
  {
    "codigo":706984006,
    "descripcion":"ENFERMEDAD PERIODONTAL NECROSANTE"
  },
  {
    "codigo":248232007,
    "descripcion":"ANESTESIA PROFUNDA"
  },
  {
    "codigo":10760741000119100,
    "descripcion":"CUATRILLIZOS, ALGUNOS NACIDOS VIVOS"
  },
  {
    "codigo":770685009,
    "descripcion":"CARCINOMA INDIFERENCIADO DE HÍGADO Y VÍA BILIAR INTRAHEPÁTICA"
  },
  {
    "codigo":1293138005,
    "descripcion":"HEMANGIOMA EPITELIOIDE ATÍPICO"
  },
  {
    "codigo":1260370007,
    "descripcion":"EPILEPSIA DEBIDA A HEMORRAGIA PERIVENTRICULAR PERINATAL"
  },
  {
    "codigo":767015000,
    "descripcion":"ALERGIA A HORMONA HIPOFISARIA"
  },
  {
    "codigo":277330009,
    "descripcion":"RUPTURA DE ANEURISMA DE LA BIFURCACIÓN DE LA CARÓTIDA INTERNA"
  },
  {
    "codigo":211794007,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO DE SITIOS MÚLTIPLES DE TRONCO"
  },
  {
    "codigo":406567002,
    "descripcion":"INFECCIÓN DEL SISTEMA NERVIOSO CENTRAL POR COCCIDIOIDES"
  },
  {
    "codigo":275495004,
    "descripcion":"LARINGOTRAQUEOBRONQUITIS AGUDA FIBRINOSA"
  },
  {
    "codigo":78887005,
    "descripcion":"PLEURESÍA SEROPURULENTA"
  },
  {
    "codigo":373799005,
    "descripcion":"DIAGNÓSTICO DE CÁNCER BASADO EN LA EVIDENCIA HISTOLÓGICA DE LA PRESENCIA DE METÁSTASIS"
  },
  {
    "codigo":472103001,
    "descripcion":"INTERRUPCIÓN DE CAYADO AÓRTICO ENTRE ARTERIA CARÓTIDA PRIMITIVA IZQUIERDA Y ARTERIA CARÓTIDA PRIMITIVA DERECHA"
  },
  {
    "codigo":240892004,
    "descripcion":"PRURITO POR FRIJOL COLORADO"
  },
  {
    "codigo":16059071000119100,
    "descripcion":"DEFECTO DE CAMPO VISUAL DE OJO DERECHO"
  },
  {
    "codigo":371964008,
    "descripcion":"NEOPLASIA MALIGNA DE LA CORTEZA SUPRARRENAL"
  },
  {
    "codigo":206289001,
    "descripcion":"NEUMONÍA CONGÉNITA POR CHLAMYDIA"
  },
  {
    "codigo":239057002,
    "descripcion":"SÍNDROME CUTÁNEO CON ICTIOSIS"
  },
  {
    "codigo":402897003,
    "descripcion":"INFECCIÓN POR HERPES ZÓSTER EN DERMATOMA CERVICAL"
  },
  {
    "codigo":109820009,
    "descripcion":"HIPERPLASIA HEPÁTICA NODULAR"
  },
  {
    "codigo":271825005,
    "descripcion":"DISTRÉS RESPIRATORIO"
  },
  {
    "codigo":1254865004,
    "descripcion":"REACCIÓN CUTÁNEA POR CONTACTO CON HIDROZOOS"
  },
  {
    "codigo":763345008,
    "descripcion":"ENFERMEDAD DE CHARCOT-MARIE-TOOTH TIPO 4B3"
  },
  {
    "codigo":106150003,
    "descripcion":"HALLAZGO EN NERVIO CRANEAL"
  },
  {
    "codigo":827046003,
    "descripcion":"SOPLO DIASTÓLICO EN EL VÉRTICE DEL CORAZÓN"
  },
  {
    "codigo":300923002,
    "descripcion":"QUISTE DEL CUERO CABELLUDO"
  },
  {
    "codigo":299088000,
    "descripcion":"AMPLITUD DE ABDUCCIÓN ACTIVA DE DEDO DE LA MANO AUMENTADA"
  },
  {
    "codigo":102480002,
    "descripcion":"DOLOR AGUDO GENERALIZADO"
  },
  {
    "codigo":200784004,
    "descripcion":"DERMATITIS DE CONTACTO CAUSADA POR HIDROCARBURO CLORADO"
  },
  {
    "codigo":168016005,
    "descripcion":"LÍQUIDO ASCÍTICO SANGUINOLENTO"
  },
  {
    "codigo":140121000119100,
    "descripcion":"HIPERTENSIÓN EN ENFERMEDAD RENAL CRÓNICA EN ESTADIO 3 DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":395557000,
    "descripcion":"TUMOR - HALLAZGO"
  },
  {
    "codigo":297253000,
    "descripcion":"DEFICIENCIA CARDÍACA DE GLUCÓGENO-FOSFORILASA-QUINASA"
  },
  {
    "codigo":2341000,
    "descripcion":"INFECCIÓN CAUSADA POR MONILIFORMIS"
  },
  {
    "codigo":67877007,
    "descripcion":"ÉXTASIS"
  },
  {
    "codigo":10953561000119102,
    "descripcion":"HERIDA ABIERTA DE DEDO ANULAR DERECHO DEBIDA A MORDEDURA DE GATO"
  },
  {
    "codigo":461093009,
    "descripcion":"CONDUCTO ARTERIOSO BILATERAL"
  },
  {
    "codigo":198949009,
    "descripcion":"HIPERTENSIÓN RENAL QUE COMPLICA EMBARAZO, PARTO Y PUERPERIO"
  },
  {
    "codigo":66042003,
    "descripcion":"HIPERPLASIA CONGÉNITA DE MÚSCULO"
  },
  {
    "codigo":721402005,
    "descripcion":"SÍNDROME DE BROWN-SEQUARD AL NIVEL DEL CUARTO SEGMENTO CERVICAL"
  },
  {
    "codigo":262650007,
    "descripcion":"HEMATOMA GINGIVAL"
  },
  {
    "codigo":129743000,
    "descripcion":"MODIFICADORES DE LA DENSIDAD DE LA LESIÓN"
  },
  {
    "codigo":303961000119104,
    "descripcion":"GOTA TOFÁCEA CRÓNICA DE RODILLA DEBIDA A DISFUNCIÓN RENAL"
  },
  {
    "codigo":195279006,
    "descripcion":"ANEURISMA DE ARTERIA TIBIAL ANTERIOR"
  },
  {
    "codigo":193444005,
    "descripcion":"CORIORRETINITIS DISEMINADA GENERAL"
  },
  {
    "codigo":29604006,
    "descripcion":"INFECCIÓN CAUSADA POR TRICHOSTRONGYLUS COLUBRIFORMIS"
  },
  {
    "codigo":226212008,
    "descripcion":"DIETA CON UNA SOLA TEXTURA"
  },
  {
    "codigo":717732009,
    "descripcion":"MÁCULA MELANÓTICA VULVAR"
  },
  {
    "codigo":93305002,
    "descripcion":"POSICIÓN ANÓMALA CONGÉNITA DE LA AORTA"
  },
  {
    "codigo":95140009,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL BORDE DE LA LENGUA"
  },
  {
    "codigo":60537006,
    "descripcion":"ESTRIDOR CONVULSIVO"
  },
  {
    "codigo":124238006,
    "descripcion":"DEFICIENCIA DE NICOTINAMIDA METILTRANSFERASA"
  },
  {
    "codigo":126291000146104,
    "descripcion":"SIEMPRE CAPAZ DE CUIDAR A UN NIÑO"
  },
  {
    "codigo":39251000146107,
    "descripcion":"TRASTORNO DEL SUEÑO DEBIDO A DEPENDENCIA DE ALCOHOL"
  },
  {
    "codigo":34131000146109,
    "descripcion":"LESIONES TRAUMÁTICAS MÚLTIPLES DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":286243006,
    "descripcion":"INCAPAZ DE UTILIZAR PROCESOS FONOLÓGICOS"
  },
  {
    "codigo":187939006,
    "descripcion":"NEOPLASIA MALIGNA DE HUESO DEL CARPO - PIRAMIDAL"
  },
  {
    "codigo":687091000119105,
    "descripcion":"NEUROFIBROMA DE CARA"
  },
  {
    "codigo":253475008,
    "descripcion":"CUERDAS TENDINOSAS DE VÁLVULA AURICULOVENTRICULAR DERECHA EXCESIVAMENTE LARGAS"
  },
  {
    "codigo":22264002,
    "descripcion":"RIGIDEZ CATATÓNICA"
  },
  {
    "codigo":1300216003,
    "descripcion":"DISPLASIA CONGÉNITA DE ARTICULACIÓN DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":284408005,
    "descripcion":"DIFICULTAD PARA MANTENER EL EQUILIBRIO AL INCLINARSE"
  },
  {
    "codigo":448248006,
    "descripcion":"NEOPLASIA MALIGNA DE REGIÓN SUPRASELAR AXIAL DEL CEREBRO"
  },
  {
    "codigo":332941000119101,
    "descripcion":"QUISTE PRIMARIO DE ANILLO CILIAR DE OJO DERECHO"
  },
  {
    "codigo":1362082000,
    "descripcion":"GINGIVITIS GENERALIZADA CON TEJIDO PERIODONTAL DISMINUIDO SIN PERIODONTITIS"
  },
  {
    "codigo":247970001,
    "descripcion":"PROLIJIDAD COMPULSIVA"
  },
  {
    "codigo":446413008,
    "descripcion":"INFECCIÓN CAUSADA POR STAPHYLOCOCCUS AUREUS PRODUCTOR DE LEUCOCIDINA DE PANTON-VALENTINE"
  },
  {
    "codigo":403379007,
    "descripcion":"SÍNDROME DE COLOR ROJIZO POR HIPERHIDROSIS"
  },
  {
    "codigo":444578005,
    "descripcion":"TRASTORNO DE CARTÍLAGO ARTICULAR DE COLUMNA VERTEBRAL"
  },
  {
    "codigo":213367004,
    "descripcion":"LUXACIÓN, ESGUINCE Y DISTENSIÓN QUE AFECTA MÚLTIPLES REGIONES DEL CUERPO"
  },
  {
    "codigo":14924005,
    "descripcion":"INTOXICACIÓN POR AGAVE"
  },
  {
    "codigo":703052006,
    "descripcion":"ARTROSIS PRIMARIA MEDIOTARSIANA"
  },
  {
    "codigo":209697001,
    "descripcion":"SECCIÓN EXPUESTA DE LIGAMENTO CRUZADO ANTERIOR DE LA RODILLA"
  },
  {
    "codigo":78625002,
    "descripcion":"HIPERPARATIROIDISMO SECUNDARIO A MALABSORCIÓN INTESTINAL"
  },
  {
    "codigo":735820009,
    "descripcion":"RUPTURA TRAUMÁTICA DE LIGAMENTO RADIOCARPIANO"
  },
  {
    "codigo":766753005,
    "descripcion":"ENFERMEDAD SIMILAR A SÍNDROME DE ROTURA DE NIJMEGEN"
  },
  {
    "codigo":439073006,
    "descripcion":"CATÉTER DE DIÁLISIS PERITONEAL IN SITU"
  },
  {
    "codigo":109558001,
    "descripcion":"MALFORMACIÓN VASCULAR DE DIEULAFOY"
  },
  {
    "codigo":13089009,
    "descripcion":"BRONQUIOLITIS ADENOVIRAL"
  },
  {
    "codigo":471841009,
    "descripcion":"MIOCARDIOPATÍA INFLAMATORIA"
  },
  {
    "codigo":699382004,
    "descripcion":"AGENESIA DE ESMALTE"
  },
  {
    "codigo":240630008,
    "descripcion":"ESPLENOMEGALIA PALÚDICA HIPERREACTIVA"
  },
  {
    "codigo":11254008,
    "descripcion":"FRACTURA NO EXPUESTA DE CUARTO METATARSIANO"
  },
  {
    "codigo":74955002,
    "descripcion":"RETRACCIÓN DE PEZÓN ASOCIADA CON EL PARTO"
  },
  {
    "codigo":1287371004,
    "descripcion":"FISURA ANORRECTAL"
  },
  {
    "codigo":402635005,
    "descripcion":"NEOPLASIA BENIGNA DEL APARATO UNGUEAL"
  },
  {
    "codigo":304331007,
    "descripcion":"SIN MOVIMIENTO DEL PIE"
  },
  {
    "codigo":204192005,
    "descripcion":"COLOBOMA DE COROIDES"
  },
  {
    "codigo":73120006,
    "descripcion":"ESTENOSIS DEL DUODENO"
  },
  {
    "codigo":7584007,
    "descripcion":"DESEQUILIBRIO OCUPACIONAL"
  },
  {
    "codigo":300661001,
    "descripcion":"NO REALIZA ACTIVIDADES RELACIONADAS CON EL USO DE MEDIOS DE TRANSPORTE"
  },
  {
    "codigo":235125008,
    "descripcion":"PAROTITIS RECURRENTE"
  },
  {
    "codigo":366197008,
    "descripcion":"PERMEABILIDAD DE ARTERIA CORONARIA - HALLAZGO"
  },
  {
    "codigo":167754002,
    "descripcion":"ELECTROFORESIS DE LÍQUIDO CEFALORRAQUÍDEO DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":3914008,
    "descripcion":"TRASTORNO MENTAL EN LA NIÑEZ"
  },
  {
    "codigo":722975002,
    "descripcion":"ESTEREOTIPIA PRIMARIA"
  },
  {
    "codigo":34241000119104,
    "descripcion":"TORTÍCOLIS OCULAR"
  },
  {
    "codigo":231455002,
    "descripcion":"PERSONALIDAD PSEUDORRETARDADA ORGÁNICA"
  },
  {
    "codigo":296991002,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE PROCAINAMIDA"
  },
  {
    "codigo":424393004,
    "descripcion":"INFORMES DE VIOLENCIA EN EL AMBIENTE"
  },
  {
    "codigo":719305006,
    "descripcion":"SÍNDROME DE ANQUILOSIS DE ESTRIBO CON PULGAR Y DEDOS DEL PIE ANCHOS"
  },
  {
    "codigo":31177006,
    "descripcion":"TRASTORNO DE HIPERACTIVIDAD CON DÉFICIT DE ATENCIÓN, TIPO COMBINADO"
  },
  {
    "codigo":16909761000119108,
    "descripcion":"LAGOFTALMÍA DE PÁRPADOS SUPERIOR E INFERIOR IZQUIERDOS"
  },
  {
    "codigo":63945009,
    "descripcion":"INTOXICACIÓN POR MELICA"
  },
  {
    "codigo":94878004,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL INTESTINO"
  },
  {
    "codigo":62110005,
    "descripcion":"SÍNDROME FETAL POR METIL MERCURIO"
  },
  {
    "codigo":422558006,
    "descripcion":"INCISIÓN CORNEAL LIMPIA"
  },
  {
    "codigo":291486005,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR TOBRAMICINA"
  },
  {
    "codigo":289651001,
    "descripcion":"PROLAPSO DE CUELLO UTERINO EN LA VAGINA CON EL ESFUERZO"
  },
  {
    "codigo":27507004,
    "descripcion":"HEMARTROSIS DE LA MANO"
  },
  {
    "codigo":191347008,
    "descripcion":"NEUTROPENIA CÍCLICA"
  },
  {
    "codigo":123976001,
    "descripcion":"TRASTORNO POSINFECCIOSO"
  },
  {
    "codigo":1172552003,
    "descripcion":"ESTRIOL EN SUERO POR FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":12105461000119100,
    "descripcion":"QUEMADURA DE DORSO DE MANO IZQUIERDA"
  },
  {
    "codigo":58440007,
    "descripcion":"ESTÍMULO NO ERÓTICO"
  },
  {
    "codigo":285981000,
    "descripcion":"NO CONTROLA EL TERMOSTATO EN EL HOGAR"
  },
  {
    "codigo":253213006,
    "descripcion":"ANQUILOBLÉFARON CONGÉNITO"
  },
  {
    "codigo":449821007,
    "descripcion":"SÍNDROME BRANQUIO-OCULO-FACIAL"
  },
  {
    "codigo":308981000119102,
    "descripcion":"TENDINITIS CALCIFICANTE DE REGIÓN DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":11804251000119108,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA DISTAL DE DEDO MEDIO DERECHO"
  },
  {
    "codigo":218610002,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR AMINOFENAZONA"
  },
  {
    "codigo":415218004,
    "descripcion":"TOXOPLASMOSIS RETINIANA EXTERNA PUNTEADA"
  },
  {
    "codigo":284146005,
    "descripcion":"INCAPAZ DE MOVER LA MANO"
  },
  {
    "codigo":10821211000119109,
    "descripcion":"FRACTURA EXPUESTA DE DIÁFISIS DE QUINTO HUESO METACARPIANO DE MANO IZQUIERDA"
  },
  {
    "codigo":733192006,
    "descripcion":"DEMENCIA DEBIDA A ENCEFALITIS HERPÉTICA"
  },
  {
    "codigo":54770009,
    "descripcion":"CAVERNITIS DE PENE"
  },
  {
    "codigo":741063003,
    "descripcion":"INYECCIÓN DE DROGA ILÍCITA EN LOS ÚLTIMOS 12 MESES"
  },
  {
    "codigo":249543005,
    "descripcion":"ABDOMEN BLANDO"
  },
  {
    "codigo":282311006,
    "descripcion":"INCAPAZ DE MANTENER EL EQUILIBRIO EN BIPEDESTACIÓN"
  },
  {
    "codigo":51100001,
    "descripcion":"DISFONÍA PARKINSONIANA HIPOQUINÉTICA"
  },
  {
    "codigo":247708002,
    "descripcion":"HIPOESTESIA DE SENTIDOS ESPECIALES"
  },
  {
    "codigo":444316004,
    "descripcion":"ALERGIA ESTACIONAL"
  },
  {
    "codigo":870300008,
    "descripcion":"INFECCIÓN PARASITARIA DE DUODENO CAUSADA POR ANISAKIS"
  },
  {
    "codigo":16011151000119101,
    "descripcion":"OSTEONECROSIS DE ASTRÁGALO DERECHO"
  },
  {
    "codigo":278641004,
    "descripcion":"PIEZAS DENTALES DE PRÓTESIS DENTAL MUY CLARAS"
  },
  {
    "codigo":311409007,
    "descripcion":"TÓRAX INESTABLE ABIERTO"
  },
  {
    "codigo":49265008,
    "descripcion":"FOLICULITIS QUELOIDE DE LA NUCA"
  },
  {
    "codigo":735558001,
    "descripcion":"GRANULOMA CEREBRAL CAUSADO POR INFECCIÓN PARASITARIA"
  },
  {
    "codigo":14662005,
    "descripcion":"AUSENCIA DE SUDORACIÓN"
  },
  {
    "codigo":1290779004,
    "descripcion":"OSTEOCONDRITIS DISECANTE DE HUESO DE CODO"
  },
  {
    "codigo":69051000119104,
    "descripcion":"PRUEBA DE ESFUERZO EN CINTA CAMINADORA NEGATIVA PARA ANGINA DE PECHO"
  },
  {
    "codigo":240368000,
    "descripcion":"INFECCIÓN POR RETORTAMONAS INTESTINALIS"
  },
  {
    "codigo":1354480001,
    "descripcion":"INMUNODEFICIENCIA COMBINADA VARIABLE AUTOSÓMICA DOMINANTE DEBIDA A MUTACIÓN DE SEC61A1"
  },
  {
    "codigo":109296001,
    "descripcion":"MELANOMA IN SITU DE LA CADERA"
  },
  {
    "codigo":12242831000119106,
    "descripcion":"DOLOR A LA PALPACIÓN DE ARTICULACIÓN TEMPOROMANDIBULAR DERECHA"
  },
  {
    "codigo":305904007,
    "descripcion":"VISTO POR EL SERVICIO DE CIRUGÍA VASCULAR"
  },
  {
    "codigo":238533000,
    "descripcion":"LESIÓN CAUSADA POR CORAL"
  },
  {
    "codigo":830192008,
    "descripcion":"CÚPULA VESICAL PERCIBIDA A MITAD DE CAMINO DEL OMBLIGO"
  },
  {
    "codigo":402373002,
    "descripcion":"SARCOIDOSIS HIPOMELANÓTICA"
  },
  {
    "codigo":11833231000119108,
    "descripcion":"ESGUINCE DE LIGAMENTO DE ARTICULACIÓN METATARSOFALÁNGICA DE SEGUNDO A QUINTO DEDOS DE PIE IZQUIERDO"
  },
  {
    "codigo":72858000,
    "descripcion":"TRASTORNO DE LA FUNCIÓN DEL HABLA EN LA CORTEZA CEREBRAL"
  },
  {
    "codigo":1287109009,
    "descripcion":"LESIÓN TRAUMÁTICA DE NARIZ"
  },
  {
    "codigo":1186970002,
    "descripcion":"PERIODONTITIS POR SÍNDROME DE EHLERS-DANLOS TIPO 4"
  },
  {
    "codigo":171162005,
    "descripcion":"CRIBADO PARA CÁNCER DE CUELLO UTERINO Y RECLAMO DE HONORARIOS"
  },
  {
    "codigo":7322007,
    "descripcion":"CORTEZA SUPRARRENAL ACCESORIA"
  },
  {
    "codigo":1285274008,
    "descripcion":"RANGO ACTIVO NORMAL DE FLEXIÓN PLANTAR DE TOBILLO"
  },
  {
    "codigo":300399001,
    "descripcion":"PIEL DE LA PARED ABDOMINAL, NORMAL"
  },
  {
    "codigo":236698009,
    "descripcion":"FÍSTULA URETRAL ABOCADA A LA PIEL"
  },
  {
    "codigo":337961000119104,
    "descripcion":"RETINOPATÍA POR PREMATUREZ ETAPA 5 DE OJO IZQUIERDO"
  },
  {
    "codigo":71023004,
    "descripcion":"PERICARDITIS SECUNDARIA A INFARTO AGUDO DE MIOCARDIO"
  },
  {
    "codigo":890223001,
    "descripcion":"AMELIA BILATERAL DE EXTREMIDADES SUPERIORES"
  },
  {
    "codigo":726383004,
    "descripcion":"DELECIÓN DE PARTE DEL BRAZO LARGO DEL CROMOSOMA 12"
  },
  {
    "codigo":365935007,
    "descripcion":"HALLAZGO RELACIONADO CON LA IMAGEN DE UNO MISMO"
  },
  {
    "codigo":298564000,
    "descripcion":"AMPLITUD DE ROTACIÓN ACTIVA HACIA LA IZQUIERDA DE LA COLUMNA VERTEBRAL DORSAL, NORMAL"
  },
  {
    "codigo":11315241000119105,
    "descripcion":"FRACTURA PATOLÓGICA DE MAXILAR SUPERIOR"
  },
  {
    "codigo":724548002,
    "descripcion":"COREA DEBIDA A TRASTORNO INFECCIOSO Y POSTERIOR A ÉL"
  },
  {
    "codigo":36420002,
    "descripcion":"ENFERMEDAD SIMIESCA B"
  },
  {
    "codigo":202095009,
    "descripcion":"DESGARRO RADIAL DEL MENISCO EXTERNO"
  },
  {
    "codigo":3652007,
    "descripcion":"HIPERSECRECIÓN DE SOMATOTROPINA"
  },
  {
    "codigo":200260008,
    "descripcion":"TROMBOSIS VENOSA CEREBRAL EN EL PUERPERIO"
  },
  {
    "codigo":198425001,
    "descripcion":"SUPRESIÓN DE LA MENSTRUACIÓN"
  },
  {
    "codigo":296729000,
    "descripcion":"SOBREDOSIS DE CEFPODOXIMA"
  },
  {
    "codigo":722713005,
    "descripcion":"CARCINOMA IN SITU DE MARGEN ANAL"
  },
  {
    "codigo":427801009,
    "descripcion":"ESCLERÓTICA BLANCA"
  },
  {
    "codigo":263961009,
    "descripcion":"AURÍCULA BILATERAL ISOMÉTRICA"
  },
  {
    "codigo":65518004,
    "descripcion":"HIPERTENSIÓN ARTERIAL DIASTÓLICA LÁBIL"
  },
  {
    "codigo":131054008,
    "descripcion":"11 - DESOXICORTICOSTERONA ANORMAL"
  },
  {
    "codigo":30915001,
    "descripcion":"SECUENCIA DE HOLOPROSENCEFALIA"
  },
  {
    "codigo":719043002,
    "descripcion":"SÍNDROME DE ANOMALÍA VERTEBRAL, ATRESIA ANAL, ANOMALÍA CARDÍACA, FÍSTULA TRAQUEOESOFÁGICA, ANOMALÍA RENAL Y DEFECTO DE EXTREMIDAD CON HIDROCEFALIA"
  },
  {
    "codigo":294894009,
    "descripcion":"ALERGIA A FEREDETATO DE SODIO"
  },
  {
    "codigo":424131007,
    "descripcion":"FACILIDAD PARA LA FORMACIÓN DE HEMATOMAS"
  },
  {
    "codigo":1145027009,
    "descripcion":"ESCASEZ ADQUIRIDA DE VÍAS BILIARES INTRAHEPÁTICAS"
  },
  {
    "codigo":293059009,
    "descripcion":"REACCIÓN ADVERSA A FÁRMACO ANTIPROTOZOARIO"
  },
  {
    "codigo":717208003,
    "descripcion":"NEISSERIA MENINGITIDIS SEROGRUPO B O ESCHERICHIA COLI K1"
  },
  {
    "codigo":422296006,
    "descripcion":"SIGNO PRECORDIAL"
  },
  {
    "codigo":782744007,
    "descripcion":"DEFICIENCIA DE SINTETASA DE ÁCIDO LIPOICO"
  },
  {
    "codigo":291224008,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR FLUPENTIXOL"
  },
  {
    "codigo":94616006,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA SUPRAGLOTIS"
  },
  {
    "codigo":60013002,
    "descripcion":"QUERATOCONJUNTIVITIS POR VIRUS DEL SARAMPIÓN"
  },
  {
    "codigo":1010285004,
    "descripcion":"TRASTORNO NEONATAL DEBIDO A ANOMALÍA EN LA BIOQUÍMICA SANGUÍNEA MATERNA"
  },
  {
    "codigo":92781004,
    "descripcion":"CARCINOMA IN SITU DEL URACO"
  },
  {
    "codigo":58178000,
    "descripcion":"PÉRDIDA DEL TEJIDO DURANTE EL PROCESAMIENTO"
  },
  {
    "codigo":254786000,
    "descripcion":"ANGIOMA CUTÁNEO EN RACIMO"
  },
  {
    "codigo":123714004,
    "descripcion":"CIERRE ESPONTÁNEO DE DEFECTO DE TABIQUE INTERVENTRICULAR"
  },
  {
    "codigo":418626004,
    "descripcion":"ALERGIA A LANGOSTA"
  },
  {
    "codigo":1137687006,
    "descripcion":"INSUFICIENCIA DE VÁLVULA AURICULOVENTRICULAR IZQUIERDA (MORFOLÓGICAMENTE NO MITRAL)"
  },
  {
    "codigo":449559008,
    "descripcion":"ESTENOSIS MÚLTIPLES DE ARTERIA PULMONAR IZQUIERDA"
  },
  {
    "codigo":251116002,
    "descripcion":"PATRÓN DE WOLFF-PAKINSON-WHITE TIPO A"
  },
  {
    "codigo":185580007,
    "descripcion":"DEFECTO AUDITIVO INFANTIL DETECTADO EN EL CRIBADO, DERIVADO AL ESPECIALISTA"
  },
  {
    "codigo":249281001,
    "descripcion":"INCAPAZ DE ORINAR ACOSTADO"
  },
  {
    "codigo":366941000119107,
    "descripcion":"HEMATURIA CONCOMITANTE CON CISTITIS AGUDA Y DEBIDA A ELLA"
  },
  {
    "codigo":118209003,
    "descripcion":"HALLAZGO RELACIONADO CON EL ESFUERZO EN EL EJERCICIO"
  },
  {
    "codigo":52673003,
    "descripcion":"TOS DISMINUIDA"
  },
  {
    "codigo":413121008,
    "descripcion":"DEPENDIENTE DE UN AYUDANTE PARA EMPUJAR LA SILLA DE RUEDAS"
  },
  {
    "codigo":19905009,
    "descripcion":"PROSTATITIS CRÓNICA"
  },
  {
    "codigo":183745009,
    "descripcion":"CONSULTA DOMICILIARIA DE GASTROENTEROLOGÍA, REALIZADA"
  },
  {
    "codigo":1197718003,
    "descripcion":"TRASTORNO DE RUMIACIÓN JUVENIL"
  },
  {
    "codigo":1077751000119103,
    "descripcion":"OSTEOMIELITIS DE TIBIA DERECHA"
  },
  {
    "codigo":18070006,
    "descripcion":"CERUMEN IMPACTADO"
  },
  {
    "codigo":247446008,
    "descripcion":"PIEL AGRIETADA Y ENROJECIDA"
  },
  {
    "codigo":1163115001,
    "descripcion":"COLITIS POR ESCHERICHIA COLI ENTEROINVASIVA"
  },
  {
    "codigo":81771002,
    "descripcion":"SÍNDROME DE OPITZ - FRIAS"
  },
  {
    "codigo":704363008,
    "descripcion":"CON MAYOR RIESGO DE DESARROLLO ALTERADO DE LACTANTE"
  },
  {
    "codigo":702528003,
    "descripcion":"RETRASO DEL DESARROLLO DEL LENGUAJE RECEPTIVO-EXPRESIVO"
  },
  {
    "codigo":276544005,
    "descripcion":"APNEA DEL PREMATURO"
  },
  {
    "codigo":15714961000119100,
    "descripcion":"OSTEOFITOS DE AMBOS HOMBROS"
  },
  {
    "codigo":473152007,
    "descripcion":"ÚLCERA SUPERFICIAL DE PIEL EN LUGAR DE INSERCIÓN DE GENERADOR DE PULSOS DE MARCAPASOS"
  },
  {
    "codigo":733461000,
    "descripcion":"CONSUMIDOR DE COCAÍNA"
  },
  {
    "codigo":1259584009,
    "descripcion":"DEMENCIA DEBIDA A DIÁLISIS Y POSTERIOR A ELLA"
  },
  {
    "codigo":241941001,
    "descripcion":"ANAFILAXIA PRODUCIDA POR FLUIDO SEMINAL"
  },
  {
    "codigo":897301001,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE CARA CON INFECCIÓN"
  },
  {
    "codigo":211008009,
    "descripcion":"PICADURA DE INSECTO, NO VENENOSO, EN LA CARA"
  },
  {
    "codigo":373013004,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM AURUM"
  },
  {
    "codigo":15987191000119108,
    "descripcion":"MICROFTALMÍA DE OJO DERECHO"
  },
  {
    "codigo":403946000,
    "descripcion":"ENFERMEDAD DE PAGET DEL PEZÓN"
  },
  {
    "codigo":405781008,
    "descripcion":"NECESIDADES DE ATENCIÓN COMPLEJAS"
  },
  {
    "codigo":240106005,
    "descripcion":"MIOSITIS AGUDA BENIGNA"
  },
  {
    "codigo":43498006,
    "descripcion":"RETENCIÓN DE LÍQUIDOS"
  },
  {
    "codigo":41663005,
    "descripcion":"TRASTORNO DEL PABELLÓN AURICULAR"
  },
  {
    "codigo":205503007,
    "descripcion":"OSTEOPETROSIS TARDA"
  },
  {
    "codigo":39828002,
    "descripcion":"ABSCESO DE ÓRBITA"
  },
  {
    "codigo":236436003,
    "descripcion":"INSUFICIENCIA RENAL EN ESTADIO TERMINAL CON TRASPLANTE RENAL"
  },
  {
    "codigo":301972004,
    "descripcion":"ORIFICIO LAGRIMAL SUPERIOR CERRADO"
  },
  {
    "codigo":11864721000119106,
    "descripcion":"LACERACIÓN DE MÚSCULO CRURAL POSTERIOR DE PIERNA DERECHA"
  },
  {
    "codigo":267369002,
    "descripcion":"BOCIO SIMPLE"
  },
  {
    "codigo":300137007,
    "descripcion":"CONDUCTO AUDITIVO NORMAL"
  },
  {
    "codigo":298302000,
    "descripcion":"HALLAZGO RELACIONADO CON LA MARCHA"
  },
  {
    "codigo":234601009,
    "descripcion":"DEFICIENCIA DEL COMPLEMENTO 4A"
  },
  {
    "codigo":68926002,
    "descripcion":"CALCIFICACIÓN ARTERIAL IDIOPÁTICA DE LA INFANCIA"
  },
  {
    "codigo":36158005,
    "descripcion":"TRASTORNO ESQUIZOFRENIFORME, CON CARACTERÍSTICAS DE BUEN PRONÓSTICO"
  },
  {
    "codigo":460307002,
    "descripcion":"ARTERIA COLATERAL QUE DERIVA EL FLUJO SISTÉMICO HACIA LA CIRCULACIÓN PULMONAR DESDE LA ARTERIA CARÓTIDA DERECHA"
  },
  {
    "codigo":296467003,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE ACITRETINA"
  },
  {
    "codigo":38071000087100,
    "descripcion":"ACINESIA DE MIOCARDIO DE REGIÓN INFERIOR DE VENTRÍCULO IZQUIERDO"
  },
  {
    "codigo":722451006,
    "descripcion":"SÍNDROME DE GÓMEZ-LÓPEZ-HERNÁNDEZ"
  },
  {
    "codigo":43191000087105,
    "descripcion":"HERIDA PUNZANTE DE HOMBRO IZQUIERDO CON CUERPO EXTRAÑO"
  },
  {
    "codigo":35511000087107,
    "descripcion":"ISQUEMIA DE MIOCARDIO DE REGIÓN ANTEROSEPTAL"
  },
  {
    "codigo":40631000087108,
    "descripcion":"ABRASIÓN DE PIEL DE QUINTO DEDO DE PIE DERECHO"
  },
  {
    "codigo":48311000087109,
    "descripcion":"FRACTURA DE MÚLTIPLES COSTILLAS DEL LADO DERECHO"
  },
  {
    "codigo":1144765000,
    "descripcion":"VÁRICES VENOSAS DE VULVA EN EL PUERPERIO"
  },
  {
    "codigo":161725002,
    "descripcion":"DURACIÓN DEL CICLO MENSTRUAL EN AUMENTO"
  },
  {
    "codigo":784317004,
    "descripcion":"FATIGA DEBIDA A QUIMIOTERAPIA"
  },
  {
    "codigo":30653008,
    "descripcion":"EMBARAZOS PREVIOS: 5"
  },
  {
    "codigo":422034002,
    "descripcion":"RETINOPATÍA DIABÉTICA DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":94354002,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LOS ISLOTES DE LANGERHANS"
  },
  {
    "codigo":127122004,
    "descripcion":"LINFADENOPATÍA DEL FORAMEN EPIPLOICO"
  },
  {
    "codigo":28818005,
    "descripcion":"HALLAZGO NORMAL DE VOLUMEN ESPIRATORIO FORZADO"
  },
  {
    "codigo":192658007,
    "descripcion":"NEUMONITIS INTERSTICIAL GIGANTOCELULAR"
  },
  {
    "codigo":290962008,
    "descripcion":"INTOXICACIÓN INTENCIONAL CAUSADA POR CARBAMAZEPINA"
  },
  {
    "codigo":1306770009,
    "descripcion":"TRASTORNO DE CRISTALINO DE OJO IZQUIERDO"
  },
  {
    "codigo":190823004,
    "descripcion":"SÍNDROME DE WESTPHAL-STRUMPELL"
  },
  {
    "codigo":715111005,
    "descripcion":"NO PASA DE LA SILLA DE RUEDAS A LA SILLA"
  },
  {
    "codigo":289127007,
    "descripcion":"NO REALIZA ACTIVIDADES PARA EL CUIDADO DE LA BOCA"
  },
  {
    "codigo":713276002,
    "descripcion":"ALERGIA A INHIBIDOR DE TRANSCRIPTASA INVERSA"
  },
  {
    "codigo":1335868004,
    "descripcion":"CATATONÍA IDIOPÁTICA"
  },
  {
    "codigo":418364006,
    "descripcion":"REACCIÓN ALÉRGICA CAUSADA POR POLEN"
  },
  {
    "codigo":25148007,
    "descripcion":"AUSENCIA CONGÉNITA DE LA ÚVULA"
  },
  {
    "codigo":56081000,
    "descripcion":"QUISTE SUBCONJUNTIVAL"
  },
  {
    "codigo":1237564009,
    "descripcion":"VENA VARICOSA DE PIE IZQUIERDO"
  },
  {
    "codigo":188988008,
    "descripcion":"LIPOMA DEL MEATO AUDITIVO EXTERNO"
  },
  {
    "codigo":285457000,
    "descripcion":"ABRE Y CIERRA LA BOCA"
  },
  {
    "codigo":711441008,
    "descripcion":"HEMORRAGIA DE CIEGO"
  },
  {
    "codigo":840678003,
    "descripcion":"AMPLITUD DE MOVIMIENTO DE COLUMNA VERTEBRAL DISMINUIDA"
  },
  {
    "codigo":1332198004,
    "descripcion":"LESIÓN DE NERVIO FEMORAL"
  },
  {
    "codigo":249019000,
    "descripcion":"CICATRIZACIÓN DEL ÚTERO"
  },
  {
    "codigo":283622009,
    "descripcion":"HERIDA POR PINCHAZO DE AGUJA EN LA ESPALDA"
  },
  {
    "codigo":871611004,
    "descripcion":"DEFECTO DE TABIQUE VENTRICULAR CON COMPROMISO DOBLE DE SALIDA YUXTAARTERIAL CON TABIQUE DE SALIDA MAL ALINEADO EN LA PARTE POSTERIOR"
  },
  {
    "codigo":609467006,
    "descripcion":"INTERRUPCIÓN INDUCIDA DEL EMBARAZO COMPLICADA POR LACERACIÓN DE INTESTINO"
  },
  {
    "codigo":773307006,
    "descripcion":"SÍNDROME DE ZECHI CEIDE"
  },
  {
    "codigo":1363131006,
    "descripcion":"ASTILLA EN REGIÓN ESCAPULAR"
  },
  {
    "codigo":17808001,
    "descripcion":"LÓBULO ÁCIGOS DEL PULMÓN"
  },
  {
    "codigo":312720005,
    "descripcion":"DEPÓSITO EN LENTE INTRAOCULAR"
  },
  {
    "codigo":247184007,
    "descripcion":"RETINA - PENACHO QUÍSTICO PERIFÉRICO"
  },
  {
    "codigo":310885000,
    "descripcion":"ISOENZIMA ÓSEA DE FOSFATASA ALCALINA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":771472009,
    "descripcion":"RETRASO DEL DESARROLLO Y DEL HABLA DEBIDO A DEFICIENCIA DE SOX5"
  },
  {
    "codigo":441957004,
    "descripcion":"LIPASA EN ESPÉCIMEN DE SUERO POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":276282001,
    "descripcion":"HEMORRAGIA SUBARACNOIDEA PROVENIENTE DE ANEURISMA DE LA ARTERIA COMUNICANTE ANTERIOR"
  },
  {
    "codigo":46906003,
    "descripcion":"EDAD GESTACIONAL, 27 SEMANAS"
  },
  {
    "codigo":866106004,
    "descripcion":"QUERATITIS INTERSTICIAL DEBIDA A SÍFILIS CONGÉNITA TARDÍA"
  },
  {
    "codigo":79674009,
    "descripcion":"HIPERHEPARINEMIA"
  },
  {
    "codigo":733199002,
    "descripcion":"INFARTO CEREBRAL MULTIFOCAL DEBIDO A PROCEDIMIENTO EN SISTEMA CARDIOVASCULAR Y POSTERIOR A ÉL"
  },
  {
    "codigo":440122009,
    "descripcion":"RIGIDEZ ABDOMINAL GENERALIZADA"
  },
  {
    "codigo":1259322009,
    "descripcion":"CARCINOMA LOBULILLAR PRIMARIO DE MAMA"
  },
  {
    "codigo":307215008,
    "descripcion":"MASA EN PALMA DE LA MANO"
  },
  {
    "codigo":208911008,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA EXPUESTA DE LA ARTICULACIÓN DE LA CADERA, ANTERIOR"
  },
  {
    "codigo":1255652003,
    "descripcion":"CARCINOMA EX ADENOMA PLEOMORFO DE OROFARINGE"
  },
  {
    "codigo":1082771000119100,
    "descripcion":"ESÓFAGO DE BARRETT CON DISPLASIA DE BAJO GRADO"
  },
  {
    "codigo":239844009,
    "descripcion":"GOTA SECUNDARIA A ALTERACIÓN RENAL"
  },
  {
    "codigo":238009001,
    "descripcion":"DEFICIENCIA TIPO I DE ADENINA FOSFORRIBOSIL TRANSFERASA"
  },
  {
    "codigo":762297005,
    "descripcion":"TRASTORNO DE LA SUSTANCIA BLANCA DEBIDO DEFICIENCIA DE VITAMINA B12"
  },
  {
    "codigo":303545006,
    "descripcion":"AMPLITUD NO ACTIVA DE PROTACCIÓN DE COLUMNA CERVICAL"
  },
  {
    "codigo":400014002,
    "descripcion":"DISQUERATOSIS INTRAEPITELIAL BENIGNA HEREDITARIA"
  },
  {
    "codigo":432782005,
    "descripcion":"RECHAZO HIPERAGUDO DE TRASPLANTE DE MÉDULA ÓSEA"
  },
  {
    "codigo":170638008,
    "descripcion":"ASMA QUE NO LIMITA LAS ACTIVIDADES"
  },
  {
    "codigo":301710008,
    "descripcion":"CELULITIS DE CODO"
  },
  {
    "codigo":299875002,
    "descripcion":"REFLEJO ROTULIANO RETARDADO"
  },
  {
    "codigo":201571000,
    "descripcion":"ARTRITIS REACTIVA DE ARTICULACIÓN DE TOBILLO"
  },
  {
    "codigo":70499005,
    "descripcion":"SENO DÉRMICO CONGÉNITO"
  },
  {
    "codigo":365411005,
    "descripcion":"INTERVALO PR - HALLAZGO"
  },
  {
    "codigo":1217379007,
    "descripcion":"LEUCODISTROFIA HIPOMIELINIZANTE AUTOSÓMICA RECESIVA ASOCIADA A GEN NKX6-2"
  },
  {
    "codigo":430947007,
    "descripcion":"SÍNDROME PARALÍTICO DEL LADO NO DOMINANTE COMO EFECTO TARDÍO DE ACCIDENTE CEREBROVASCULAR"
  },
  {
    "codigo":234339009,
    "descripcion":"MACROCITOSIS - SIN ANEMIA"
  },
  {
    "codigo":1184611008,
    "descripcion":"MARCHA DIPLÉJICA"
  },
  {
    "codigo":441871000124101,
    "descripcion":"INGESTA EXCESIVA DE COBRE"
  },
  {
    "codigo":789560009,
    "descripcion":"ANOMALÍA FETAL CAUSADA POR FÁRMACO ANTIHIPERTENSIVO"
  },
  {
    "codigo":230669004,
    "descripcion":"MIASTENIA DETERMINADA GENÉTICAMENTE"
  },
  {
    "codigo":66829004,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA ARTERIA ESPLÉNICA"
  },
  {
    "codigo":296205006,
    "descripcion":"SOBREDOSIS DE LEVOMEPROMAZINA"
  },
  {
    "codigo":34061007,
    "descripcion":"SENSIBILIDAD DE LOS TEJIDOS"
  },
  {
    "codigo":64994000,
    "descripcion":"APENDICITIS FULMINANTE AGUDA CON PERFORACIÓN Y PERITONITIS"
  },
  {
    "codigo":345491000119108,
    "descripcion":"TRASTORNO DE AMBAS CÓRNEAS POSTERIOR A CIRUGÍA DE CATARATA"
  },
  {
    "codigo":294370003,
    "descripcion":"ALERGIA A GANCICLOVIR"
  },
  {
    "codigo":292535000,
    "descripcion":"REACCIÓN ADVERSA AL TRIHEXIFENIDILO"
  },
  {
    "codigo":718519003,
    "descripcion":"ATRAPAMIENTO DE RAMA SUPERFICIAL DE NERVIO RADIAL"
  },
  {
    "codigo":95927003,
    "descripcion":"PROGENITOR VÍCTIMA DE MALTRATO PSICOLÓGICO"
  },
  {
    "codigo":423607006,
    "descripcion":"ADENOCARCINOMA DE ANO"
  },
  {
    "codigo":1144503007,
    "descripcion":"INFECCIÓN DE HUESO DE PELVIS Y FÉMUR"
  },
  {
    "codigo":319021000119105,
    "descripcion":"ARTRITIS REUMATOIDEA SERONEGATIVA DE ARTICULACIÓN DE CODO IZQUIERDO"
  },
  {
    "codigo":1306508000,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE PORCIÓN CENTRAL DE MAMA IZQUIERDA"
  },
  {
    "codigo":126860002,
    "descripcion":"NEOPLASIA DE LA CABEZA DEL PÁNCREAS"
  },
  {
    "codigo":716684004,
    "descripcion":"ENCEFALITIS LÍMBICA CON ANTICUERPOS ANTI-RECEPTOR DE N-METIL-D-ASPARTATO"
  },
  {
    "codigo":94092006,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL RETROPERITONEO"
  },
  {
    "codigo":290700006,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR FLUOROURACILO"
  },
  {
    "codigo":15965741000119107,
    "descripcion":"ENDOMETRIOSIS EN LIGAMENTO REDONDO IZQUIERDO"
  },
  {
    "codigo":714849004,
    "descripcion":"NO SE ADMINISTRA MEDICACIÓN PARENTERAL"
  },
  {
    "codigo":92257005,
    "descripcion":"NEOPLASIA BENIGNA DEL NERVIO ÓPTICO"
  },
  {
    "codigo":288865005,
    "descripcion":"CAPAZ DE BEBER CON UN SORBETE"
  },
  {
    "codigo":713014002,
    "descripcion":"INFECCIÓN CAUSADA POR BORRELIA MIYAMOTOI"
  },
  {
    "codigo":254262003,
    "descripcion":"INSERCIÓN Y TRANSLOCACIÓN DESEQUILIBRADA"
  },
  {
    "codigo":188726003,
    "descripcion":"LEUCEMIA LINFOIDE SUBAGUDA"
  },
  {
    "codigo":16021191000119103,
    "descripcion":"BURSITIS BILATERAL DE MÚSCULOS PSOAS ILÍACOS"
  },
  {
    "codigo":876854008,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE FLANCO CON INFECCIÓN"
  },
  {
    "codigo":55819001,
    "descripcion":"FONDO ALBINÓTICO"
  },
  {
    "codigo":1237302009,
    "descripcion":"RETRACCIÓN ANORMAL DE AMBOS PEZONES"
  },
  {
    "codigo":711179005,
    "descripcion":"QUISTE DE ENTAMOEBA HISTOLYTICA O ENTAMOEBA DISPAR"
  },
  {
    "codigo":88587007,
    "descripcion":"ENVEJECIMIENTO PREMATURO"
  },
  {
    "codigo":11843271000119105,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE OÍDO DERECHO CON INFECCIÓN"
  },
  {
    "codigo":128711000119106,
    "descripcion":"NEUMONÍA CAUSADA POR STAPHYLOCOCCUS AUREUS SENSIBLE A LA METICILINA"
  },
  {
    "codigo":707509000,
    "descripcion":"TRAQUEBRONQUITIS CAUSADA POR ASPERGILLUS"
  },
  {
    "codigo":283360009,
    "descripcion":"LACERACIÓN DE LA REGIÓN OCULAR"
  },
  {
    "codigo":1264565005,
    "descripcion":"DEFICIENCIA FAMILIAR DE LECITINA-COLESTEROL-ACIL-TRANSFERASA"
  },
  {
    "codigo":281525005,
    "descripcion":"FRACTURA DE EPICÓNDILO DE HÚMERO"
  },
  {
    "codigo":1295498000,
    "descripcion":"HIPERTENSIÓN OCULAR SECUNDARIA DE OJO IZQUIERDO"
  },
  {
    "codigo":50314001,
    "descripcion":"PARESIA BILATERAL PARCIAL"
  },
  {
    "codigo":1297333009,
    "descripcion":"CIERRE DE ÁNGULO DE OJO IZQUIERDO CAUSADO POR FÁRMACO"
  },
  {
    "codigo":212319003,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL NO EXPUESTA DE NERVIO PERONEO"
  },
  {
    "codigo":13876002,
    "descripcion":"DERMATITIS FIBROSANTE"
  },
  {
    "codigo":210484005,
    "descripcion":"HERIDA ABIERTA EN EL PERINEO"
  },
  {
    "codigo":1259060008,
    "descripcion":"TRASTORNO DE SISTEMA NERVIOSO AUTÓNOMO DEBIDO A ENCEFALITIS"
  },
  {
    "codigo":306953000,
    "descripcion":"FISURA LARÍNGEA TIPO IV"
  },
  {
    "codigo":110345002,
    "descripcion":"RETICULINA NORMAL"
  },
  {
    "codigo":405257002,
    "descripcion":"POSICIÓN INVERSA DE DIENTE ADYACENTE"
  },
  {
    "codigo":896777006,
    "descripcion":"FORMA ANCHA ANORMAL CONGÉNITA DE FALANGE DE DEDO GORDO"
  },
  {
    "codigo":274185006,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE LA MAMA"
  },
  {
    "codigo":403422001,
    "descripcion":"PANICULITIS NODULAR"
  },
  {
    "codigo":75742003,
    "descripcion":"MARCHA BALANCEANTE"
  },
  {
    "codigo":1351859001,
    "descripcion":"SÍNDROME POST-CUIDADOS INTENSIVOS"
  },
  {
    "codigo":237747002,
    "descripcion":"SÍNDROME DE FEMINIZACIÓN-ADRENOGENITAL"
  },
  {
    "codigo":16898641000119100,
    "descripcion":"GONORREA DE TRACTO GENITOURINARIO INFERIOR"
  },
  {
    "codigo":135761000119101,
    "descripcion":"DEGENERACIÓN CEREBRAL DEBIDA A ALCOHOLISMO"
  },
  {
    "codigo":12247121000119101,
    "descripcion":"NECROSIS AVASCULAR DE CÓNDILO FEMORAL EXTERNO DERECHO"
  },
  {
    "codigo":332881000119100,
    "descripcion":"OFTALMOPLEJÍA EXTERNA PROGRESIVA DE OJO DERECHO"
  },
  {
    "codigo":10759761000119100,
    "descripcion":"RUBÉOLA EN LA MADRE QUE COMPLICA EL NACIMIENTO"
  },
  {
    "codigo":15718481000119105,
    "descripcion":"FALTA DE FUSÍÓN DE ACROMION DE OMÓPLATO DERECHO"
  },
  {
    "codigo":112721000119106,
    "descripcion":"HIPERTROFIA DE ÚVULA"
  },
  {
    "codigo":1077841000119106,
    "descripcion":"OSTEONECROSIS DE CÓNDILO FEMORAL INTERNO IZQUIERDO"
  },
  {
    "codigo":16606801000119105,
    "descripcion":"DISECCIÓN DE ARTERIA DE EXTREMIDAD INFERIOR DERECHA"
  },
  {
    "codigo":317521000119109,
    "descripcion":"TENDINITIS DE TENDÓN ROTULIANO DERECHO"
  },
  {
    "codigo":301448004,
    "descripcion":"NO UTILIZA INSTALACIONES EDUCATIVAS"
  },
  {
    "codigo":345681000119108,
    "descripcion":"OFTALMOPLEJÍA INTERNA TOTAL DE AMBOS OJOS"
  },
  {
    "codigo":140881000119109,
    "descripcion":"COMPRESIÓN DE CEREBRO CONCOMITANTE CON HEMORRAGIA CEREBRAL ESPONTÁNEA Y DEBIDA A ELLA"
  },
  {
    "codigo":678481000119105,
    "descripcion":"TRASTORNO DE DIRECCIÓN DE FLUJO DE HUMOR ACUOSO DE OJO DERECHO"
  },
  {
    "codigo":11778641000119108,
    "descripcion":"DISTENSIÓN DE MÚSCULO INFRAESPINOSO IZQUIERDO"
  },
  {
    "codigo":105041000119109,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS METASTÁSICO DE PULMÓN"
  },
  {
    "codigo":15715921000119109,
    "descripcion":"ENOSTOSIS DE AMBOS CÚBITOS"
  },
  {
    "codigo":605954641000119109,
    "descripcion":"SENSACIÓN DE CUERPO EXTRAÑO EN OJO"
  },
  {
    "codigo":97361000119109,
    "descripcion":"HIPOALBUMINEMIA DEBIDA A DESNUTRICIÓN CALÓRICO-PROTEICA"
  },
  {
    "codigo":397917005,
    "descripcion":"EQUIPO EN USO"
  },
  {
    "codigo":103005006,
    "descripcion":"ANALGESIA INADECUADA"
  },
  {
    "codigo":234077006,
    "descripcion":"HEMORRAGIA DE LA VENA TRASPLANTADA"
  },
  {
    "codigo":428850001,
    "descripcion":"SÍNDROME DE LI-FRAUMENI"
  },
  {
    "codigo":299613004,
    "descripcion":"AMPLITUD DE ABDUCCIÓN PASIVA DE DEDO DEL PIE AUMENTADA"
  },
  {
    "codigo":232242004,
    "descripcion":"NEURODERMATITIS DEL OÍDO EXTERNO"
  },
  {
    "codigo":168541005,
    "descripcion":"RESULTADO DE RADIOGRAFÍA SIMPLE: NORMAL"
  },
  {
    "codigo":321531000119108,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE TENDÓN FLEXOR DE PIERNA IZQUIERDA"
  },
  {
    "codigo":789298008,
    "descripcion":"QUERATITIS MARGINAL DE AMBOS OJOS CAUSADA POR TOXINA ESTAFILOCÓCICA"
  },
  {
    "codigo":263175001,
    "descripcion":"FRACTURA DENTOALVEOLAR MANDIBULAR"
  },
  {
    "codigo":164871004,
    "descripcion":"INFARTO LATERAL EN EL ELECTROCARDIOGRAMA"
  },
  {
    "codigo":230407006,
    "descripcion":"SÍNDROME HEMIPLEJÍA-HEMICONVULSIÓN-EPILEPSIA"
  },
  {
    "codigo":295943008,
    "descripcion":"SOBREDOSIS DE ANTIDEPRESIVO TETRACÍCLICO"
  },
  {
    "codigo":15997231000119100,
    "descripcion":"PLIEGUE COROIDEO CONGÉNITO DE OJO IZQUIERDO"
  },
  {
    "codigo":195804009,
    "descripcion":"AMIGDALITIS LINGULAR"
  },
  {
    "codigo":292273002,
    "descripcion":"REACCIÓN ADVERSA A LA PERGOLIDA"
  },
  {
    "codigo":678191000119101,
    "descripcion":"RUBEOSIS DE IRIS DE AMBOS OJOS"
  },
  {
    "codigo":1177009003,
    "descripcion":"TUBERCULOSIS DE PENE"
  },
  {
    "codigo":95665007,
    "descripcion":"PARESTESIA FACIAL"
  },
  {
    "codigo":1339014004,
    "descripcion":"TRASTORNO DE HUESO CAUSADO POR RADIACIÓN IONIZANTE"
  },
  {
    "codigo":716422006,
    "descripcion":"CAPAZ DE MANEJAR EL CUIDADO DE CATÉTER URINARIO"
  },
  {
    "codigo":93830007,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA CARA HIPOFARÍNGEA DEL PLIEGUE INTERARITENOIDEO"
  },
  {
    "codigo":126598008,
    "descripcion":"NEOPLASIA DEL TEJIDO CONJUNTIVO"
  },
  {
    "codigo":290438009,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR PICOSULFATO DE SODIO"
  },
  {
    "codigo":91995007,
    "descripcion":"NEOPLASIA BENIGNA DE VASO SANGUÍNEO AXILAR"
  },
  {
    "codigo":57392001,
    "descripcion":"INFESTACIÓN CAUSADA POR CALLIPHORIDAE"
  },
  {
    "codigo":254000002,
    "descripcion":"FISURA BILATERAL DE PALADAR BLANDO"
  },
  {
    "codigo":712752004,
    "descripcion":"MIALGIA DE PISO PÉLVICO"
  },
  {
    "codigo":24624008,
    "descripcion":"ANEURISMA DE LA ARTERIA CARÓTIDA INTERNA"
  },
  {
    "codigo":219397001,
    "descripcion":"HERIDA DE GUERRA POR EXPLOSIÓN DE TORPEDO"
  },
  {
    "codigo":286768009,
    "descripcion":"CARÁCTER TRABAJADOR"
  },
  {
    "codigo":284933001,
    "descripcion":"INCAPAZ DE ADAPTAR ROPA PARA EL BAÑO"
  },
  {
    "codigo":283098001,
    "descripcion":"ARAÑAZO DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":772783002,
    "descripcion":"HERNIA FEMORAL IZQUIERDA RECURRENTE OBSTRUIDA"
  },
  {
    "codigo":281263003,
    "descripcion":"DERRAME DE ESPÉCIMEN"
  },
  {
    "codigo":248495005,
    "descripcion":"DISTENSIÓN DE VENA"
  },
  {
    "codigo":707247006,
    "descripcion":"LIQUEN PLANO ORAL ANULAR"
  },
  {
    "codigo":838319005,
    "descripcion":"NEUROPATÍA AUTONÓMICA DEBIDA A ENFERMEDAD DE FABRY"
  },
  {
    "codigo":312196000,
    "descripcion":"INFECCIÓN GENITAL FEMENINA"
  },
  {
    "codigo":314031009,
    "descripcion":"CORIORRETINITIS AGUDA POR TOXOPLASMOSIS"
  },
  {
    "codigo":410500004,
    "descripcion":"SIGNO DE HUTCHINSON"
  },
  {
    "codigo":770948004,
    "descripcion":"SÍNDROME RIZOMÉLICO TIPO URBACH"
  },
  {
    "codigo":246660007,
    "descripcion":"ESCOTOMA EN ANILLO PERIFÉRICO"
  },
  {
    "codigo":17284008,
    "descripcion":"ESTIMULACIÓN PORNOGRÁFICA"
  },
  {
    "codigo":82820009,
    "descripcion":"ANOMALÍA CONGÉNITA DE LA PRÓSTATA"
  },
  {
    "codigo":1162329002,
    "descripcion":"ESPONDILOLISTESIS DEBIDA A LESIÓN TRAUMÁTICA Y POSTERIOR A ELLA"
  },
  {
    "codigo":288648004,
    "descripcion":"ELIGE TEMAS DE CONVERSACIÓN"
  },
  {
    "codigo":408665008,
    "descripcion":"TROMBOSIS DE ARTERIA PONTINA"
  },
  {
    "codigo":439598000,
    "descripcion":"ABRASIÓN CUTÁNEA DE REGIÓN LUMBAR"
  },
  {
    "codigo":212057009,
    "descripcion":"CORROSIÓN QUE COMPROMETE 10 AL 19 PORCIENTO DE LA SUPERFICIE CORPORAL"
  },
  {
    "codigo":79150005,
    "descripcion":"OTITIS EXTERNA AGUDA POR SUSTANCIA QUÍMICA"
  },
  {
    "codigo":210222009,
    "descripcion":"LESIÓN EXPUESTA DEL ÚTERO"
  },
  {
    "codigo":110083005,
    "descripcion":"AVULSIÓN DEL MAXILAR"
  },
  {
    "codigo":44547005,
    "descripcion":"CALICOSIS"
  },
  {
    "codigo":698072001,
    "descripcion":"METAMORFOSIS CALCIFICANTE DE PULPA DE DIENTE"
  },
  {
    "codigo":42712003,
    "descripcion":"LLANTO DE GATO"
  },
  {
    "codigo":403160004,
    "descripcion":"PICADURA DE MOLUSCO"
  },
  {
    "codigo":1287896006,
    "descripcion":"TROMBOSIS VENOSA PROFUNDA CRÓNICA DE EXTREMIDAD SUPERIOR DERECHA POSTERIOR A PROCEDIMIENTO"
  },
  {
    "codigo":304856007,
    "descripcion":"AUTOTRANSFERENCIA DE OBJETO"
  },
  {
    "codigo":204717006,
    "descripcion":"ATRESIA DE RECTO CON FÍSTULA"
  },
  {
    "codigo":73645008,
    "descripcion":"DOLOR VISCERAL"
  },
  {
    "codigo":366722001,
    "descripcion":"HALLAZGO RELACIONADO CON ANGULACIÓN DE ARTICULACIÓN"
  },
  {
    "codigo":202882003,
    "descripcion":"FASCITIS PLANTAR"
  },
  {
    "codigo":301186004,
    "descripcion":"HALLAZGO EN VÍAS RESPIRATORIAS SUPERIORES"
  },
  {
    "codigo":1251458004,
    "descripcion":"METÁSTASIS DE NEUROBLASTOMA EN TÓRAX"
  },
  {
    "codigo":235650007,
    "descripcion":"ÚLCERA DE ESTÓMAGO CRÓNICA FARMACÓGENA"
  },
  {
    "codigo":399490008,
    "descripcion":"ADENOCARCINOMA DE PRÓSTATA"
  },
  {
    "codigo":4439001,
    "descripcion":"PARÁLISIS OCULOMOTORA CÍCLICA"
  },
  {
    "codigo":397655002,
    "descripcion":"RETRASO DE LA DERIVACIÓN - NO RECIBIDA EN EL PLAZO DE 24 HORAS"
  },
  {
    "codigo":233815004,
    "descripcion":"HIPERTENSIÓN PULMONAR PERSISTENTE DEL RECIÉN NACIDO"
  },
  {
    "codigo":364887004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA EMPUJAR Y TIRAR UN JUGUETE GRANDE CON RUEDAS HACIA ADELANTE"
  },
  {
    "codigo":299351006,
    "descripcion":"AMPLITUD DE EXTENSIÓN PASIVA DE LA RODILLA NORMAL"
  },
  {
    "codigo":68140000,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DE MUSLO"
  },
  {
    "codigo":231980006,
    "descripcion":"LUXACIÓN TRAUMÁTICA DEL CRISTALINO"
  },
  {
    "codigo":166444007,
    "descripcion":"NIVEL DE PROGESTERONA SÉRICA FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":721665000,
    "descripcion":"HAMARTOMA DE INTESTINO DELGADO"
  },
  {
    "codigo":723500009,
    "descripcion":"APLASIA CUTÁNEA CONGÉNITA DE EXTREMIDAD AUTOSÓMICA RECESIVA"
  },
  {
    "codigo":230145002,
    "descripcion":"DIFICULTAD PARA RESPIRAR"
  },
  {
    "codigo":295681000,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE MITOXANTRONA"
  },
  {
    "codigo":266921000,
    "descripcion":"EX FUMADOR OCASIONAL DE CIGARRILLOS (< 1\/DÍA)"
  },
  {
    "codigo":262913009,
    "descripcion":"RUPTURA TRAUMÁTICA DE URETRA MASCULINA"
  },
  {
    "codigo":424918001,
    "descripcion":"BORDE PALPEBRAL IRREGULAR"
  },
  {
    "codigo":197377009,
    "descripcion":"CÁLCULO BILIAR CON COLECISTITIS AGUDA Y SIN OBSTRUCCIÓN"
  },
  {
    "codigo":64470006,
    "descripcion":"INTOXICACIÓN POR COLOCASIA ANTIQUORUM"
  },
  {
    "codigo":228310006,
    "descripcion":"BEBE A LA MAÑANA PARA ELIMINAR LA RESACA"
  },
  {
    "codigo":62635000,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE LA CÓRNEA"
  },
  {
    "codigo":160939001,
    "descripcion":"VIVIENDA ALQUILADA A ASOCIACIÓN INMOBILIARIA"
  },
  {
    "codigo":292011002,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR DIPIRIDAMOL"
  },
  {
    "codigo":95403007,
    "descripcion":"FIBROSIS DEL SITIO DE INYECCIÓN"
  },
  {
    "codigo":93568001,
    "descripcion":"OSIFICACIÓN INCOMPLETA DE HUESO BASIOCCIPITAL"
  },
  {
    "codigo":290176005,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR BUPRENORFINA"
  },
  {
    "codigo":15701041000119100,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE AMBOS TENDONES DE AQUILES"
  },
  {
    "codigo":288341000,
    "descripcion":"DIFICULTAD PARA DIRIGIR (UN AUTOMÓVIL)"
  },
  {
    "codigo":28032008,
    "descripcion":"DIABETES MELLITUS DEPENDIENTE DE INSULINA TIPO IB"
  },
  {
    "codigo":880000009,
    "descripcion":"ANEURISMA ADQUIRIDO DE VENTRÍCULO CARDÍACO DERECHO"
  },
  {
    "codigo":124501007,
    "descripcion":"DEFICIENCIA DE PEPSINA A"
  },
  {
    "codigo":57130002,
    "descripcion":"MIOPATÍA DE LOS MÚSCULOS EXTRAOCULARES"
  },
  {
    "codigo":417578005,
    "descripcion":"DISFUNCIÓN SOMÁTICA DE SINCONDROSIS ESFENOBASILAR"
  },
  {
    "codigo":300081000119103,
    "descripcion":"OSTEOMIELITIS SUBAGUDA DE FÉMUR"
  },
  {
    "codigo":778026007,
    "descripcion":"SÍNDROME POLIMALFORMATIVO LETAL TIPO BOISSEL"
  },
  {
    "codigo":286506008,
    "descripcion":"DIFICULTAD PARA PREPARAR BEBIDAS"
  },
  {
    "codigo":413908002,
    "descripcion":"CONSENTIMIENTO PARA LA VACUNACIÓN ANTISARAMPIONOSA, ANTIPAROTIDÍTICA Y ANTIRRUBÉOLICA, OTORGADO"
  },
  {
    "codigo":1264041000,
    "descripcion":"OSTEOPETROSIS AUTOSÓMICA DOMINANTE TIPO 1"
  },
  {
    "codigo":11768881000119107,
    "descripcion":"HEMATOMA SUBUNGUEAL DE DEDO MEÑIQUE DE MANO IZQUIERDA"
  },
  {
    "codigo":1231273008,
    "descripcion":"NEOVASCULARIZACIÓN COROIDEA EXTRAFOVEAL"
  },
  {
    "codigo":84393008,
    "descripcion":"INTOXICACIÓN POR HIDRATO DE TERPINA"
  },
  {
    "codigo":770686005,
    "descripcion":"NEOPLASIA MALIGNA DE CÉLULAS GERMINALES DE LA VAGINA"
  },
  {
    "codigo":703315000,
    "descripcion":"CISTOCELE INGUINAL"
  },
  {
    "codigo":1293139002,
    "descripcion":"HEMANGIOMA INTRAMUSCULAR"
  },
  {
    "codigo":1260371006,
    "descripcion":"EPILEPSIA DEBIDA A ISQUEMIA CEREBRAL PERINATAL"
  },
  {
    "codigo":13352000,
    "descripcion":"CORTOCIRCUITO BIDIRECCIONAL"
  },
  {
    "codigo":275496003,
    "descripcion":"INFECCIÓN NASAL"
  },
  {
    "codigo":767016004,
    "descripcion":"OCLUSIÓN COMPLETA DE URÉTER POR COMPRESIÓN EXTERNA"
  },
  {
    "codigo":406568007,
    "descripcion":"INFECCIÓN DEL SISTEMA NERVIOSO CENTRAL POR VIRUS COXSACKIE"
  },
  {
    "codigo":373800009,
    "descripcion":"DIAGNÓSTICO DE CÁNCER BASADO EN LA EVIDENCIA HISTOLÓGICA DEL SITIO PRIMARIO"
  },
  {
    "codigo":765181003,
    "descripcion":"TROMBOSIS CAUSADA POR DISPOSITIVO DE ASISTENCIA VENTRICULAR IZQUIERDA"
  },
  {
    "codigo":109821008,
    "descripcion":"NEOPLASIA MALIGNA SUPERPUESTA DEL TRACTO GASTROINTESTINAL"
  },
  {
    "codigo":240893009,
    "descripcion":"PRURITO POR CEBADA"
  },
  {
    "codigo":371965009,
    "descripcion":"NEOPLASIA MALIGNA DE LA MÉDULA SUPRARRENAL"
  },
  {
    "codigo":1254866003,
    "descripcion":"PRURITO DEBIDO A HERPES ZÓSTER Y POSTERIOR A ÉL"
  },
  {
    "codigo":304594002,
    "descripcion":"INTENTO DE SUICIDIO"
  },
  {
    "codigo":16467301000119103,
    "descripcion":"MELORREOSTOSIS DE PIE IZQUIERDO"
  },
  {
    "codigo":271826006,
    "descripcion":"ESPUTO ANORMAL - CANTIDAD"
  },
  {
    "codigo":9682006,
    "descripcion":"FRACTURA DE OMÓPLATO"
  },
  {
    "codigo":402898008,
    "descripcion":"INFECCIÓN POR HERPES ZÓSTER EN DERMATOMA SACRO"
  },
  {
    "codigo":763346009,
    "descripcion":"SÍNDROME DE ACINESIA FETAL Y HEMORRAGIA CEREBRAL Y RETINIANA"
  },
  {
    "codigo":106151004,
    "descripcion":"HALLAZGO RELACIONADO CON EL SENTIDO DEL OLFATO"
  },
  {
    "codigo":1351335004,
    "descripcion":"SIGNO DE HOOVER DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":7847004,
    "descripcion":"QUEILITIS"
  },
  {
    "codigo":827047007,
    "descripcion":"PARÁLISIS DE NERVIO VAGO"
  },
  {
    "codigo":302759005,
    "descripcion":"IDEAS AUTORREFERENCIALES DE CULPA"
  },
  {
    "codigo":73383004,
    "descripcion":"ALOPECIA MEDICAMENTOSA"
  },
  {
    "codigo":399228007,
    "descripcion":"TETRALOGÍA DE FALLOT CON AUSENCIA DE VÁLVULA PULMONAR"
  },
  {
    "codigo":300924008,
    "descripcion":"ECCEMA DE LA CARA"
  },
  {
    "codigo":366460009,
    "descripcion":"TONO MUSCULAR ABDOMINAL - HALLAZGO"
  },
  {
    "codigo":38780008,
    "descripcion":"ENDOMETRIOSIS DE LA VULVA"
  },
  {
    "codigo":200785003,
    "descripcion":"DERMATITIS DE CONTACTO CAUSADA POR CICLOHEXANO"
  },
  {
    "codigo":168017001,
    "descripcion":"LÍQUIDO ASCÍTICO PURULENTO"
  },
  {
    "codigo":102481003,
    "descripcion":"DOLOR CRÓNICO GENERALIZADO"
  },
  {
    "codigo":299089008,
    "descripcion":"AMPLITUD DE ABDUCCIÓN ACTIVA DE DEDO DE LA MANO DISMINUIDA"
  },
  {
    "codigo":67878002,
    "descripcion":"ABSCESO DE BRAZO"
  },
  {
    "codigo":461094003,
    "descripcion":"CONDUCTO ARTERIOSO BILATERAL CON CONDUCTO ARTERIOSO IZQUIERDO PERMEABLE Y CONDUCTO ARTERIOSO DERECHO CERRADO"
  },
  {
    "codigo":1149222004,
    "descripcion":"SOBREDOSIS"
  },
  {
    "codigo":297254006,
    "descripcion":"DEFICIENCIA HEPÁTICA Y MUSCULAR DE GLUCÓGENO-FOSFORILASA-QUINASA"
  },
  {
    "codigo":721403000,
    "descripcion":"SÍNDROME DE BROWN-SEQUARD AL NIVEL DEL QUINTO SEGMENTO CERVICAL"
  },
  {
    "codigo":295419003,
    "descripcion":"SOBREDOSIS DE DOMPERIDONA"
  },
  {
    "codigo":262651006,
    "descripcion":"HEMATOMA DE LENGUA"
  },
  {
    "codigo":293584003,
    "descripcion":"ALERGIA A PARACETAMOL"
  },
  {
    "codigo":129744006,
    "descripcion":"LESIÓN DE ALTA DENSIDAD"
  },
  {
    "codigo":162512009,
    "descripcion":"ANTECEDENTES ALIMENTARIOS"
  },
  {
    "codigo":195280009,
    "descripcion":"ANEURISMA DE ARTERIA DORSAL DEL PIE"
  },
  {
    "codigo":226213003,
    "descripcion":"DIETA DE LÍQUIDOS ESPESADOS"
  },
  {
    "codigo":717733004,
    "descripcion":"DERMATOSIS ACANTOLÍTICA BENIGNA DE VULVA"
  },
  {
    "codigo":685721000119101,
    "descripcion":"LEIOMIOSARCOMA PRIMARIO DE TÓRAX"
  },
  {
    "codigo":193445006,
    "descripcion":"RETINITIS DISEMINADA METASTÁSICA"
  },
  {
    "codigo":95141008,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA LENGUA"
  },
  {
    "codigo":191610000,
    "descripcion":"TRASTORNO DEPRESIVO MAYOR, EPISODIOS RECURRENTES, LEVE"
  },
  {
    "codigo":224378000,
    "descripcion":"CON DOS TRABAJOS A LA VEZ"
  },
  {
    "codigo":1141882007,
    "descripcion":"FIBROELASTOSIS ENDOCÁRDICA CONGÉNITA"
  },
  {
    "codigo":58703003,
    "descripcion":"DEPRESIÓN POSTPARTO"
  },
  {
    "codigo":124239003,
    "descripcion":"DEFICIENCIA DE GUANIDINOACETATO METILTRANSFERASA"
  },
  {
    "codigo":286244000,
    "descripcion":"UTILIZA PROCESOS FONOLÓGICOS"
  },
  {
    "codigo":89636007,
    "descripcion":"FRACTURA NO EXPUESTA DE SEIS COSTILLAS"
  },
  {
    "codigo":187940008,
    "descripcion":"NEOPLASIA MALIGNA DE HUESO DEL CARPO - PISIFORME"
  },
  {
    "codigo":253476009,
    "descripcion":"CUERDAS TENDINOSAS DE VÁLVULA AURICULOVENTRICULAR DERECHA EN TABIQUE DE SALIDA"
  },
  {
    "codigo":55033002,
    "descripcion":"CONTRACTURA DE MÚSCULO"
  },
  {
    "codigo":284409002,
    "descripcion":"NO MANTIENE EL EQUILIBRIO AL INCLINARSE"
  },
  {
    "codigo":1300217007,
    "descripcion":"DISPLASIA CONGÉNITA DE ARTICULACIÓN DE TOBILLO DERECHO"
  },
  {
    "codigo":20430005,
    "descripcion":"HETEROSEXUAL"
  },
  {
    "codigo":247971002,
    "descripcion":"ARREGLO COMPULSIVO DE OBJETOS"
  },
  {
    "codigo":11718451000119104,
    "descripcion":"RETRACCIÓN ANORMAL DE AMBOS PÁRPADOS"
  },
  {
    "codigo":870563006,
    "descripcion":"CONTUSIÓN DE CEREBRO CON HERIDA INTRACRANEAL ABIERTA"
  },
  {
    "codigo":278904002,
    "descripcion":"DIETA PARA PACIENTES HEMODIALIZADOS"
  },
  {
    "codigo":213368009,
    "descripcion":"LUXACIONES, ESGUINCES Y DISTENSIONES QUE COMPROMETEN LA CABEZA Y EL CUELLO"
  },
  {
    "codigo":703053001,
    "descripcion":"ARTROSIS MEDIOTARSIANA SECUNDARIA A TRAUMATISMO"
  },
  {
    "codigo":47693006,
    "descripcion":"RUPTURA DE APÉNDICE ILEOCECAL"
  },
  {
    "codigo":439074000,
    "descripcion":"DISPLASIA EN EL EXTENDIDO CERVICAL"
  },
  {
    "codigo":78626001,
    "descripcion":"ANOMALÍA CONGÉNITA DEL TRONCO"
  },
  {
    "codigo":735821008,
    "descripcion":"RUPTURA TRAUMÁTICA DE LIGAMENTO CUBITOCARPIANO"
  },
  {
    "codigo":331571000119109,
    "descripcion":"ECTROPIÓN MECÁNICO DE PÁRPADO SUPERIOR DERECHO"
  },
  {
    "codigo":15951821000119103,
    "descripcion":"DERMATOFIBROMA DE AMBOS MIEMBROS INFERIORES"
  },
  {
    "codigo":111394006,
    "descripcion":"TRASTORNO DEL TRANSPORTE METABÓLICO"
  },
  {
    "codigo":209698006,
    "descripcion":"SECCIÓN EXPUESTA DE LIGAMENTO TIBIOPERONEO SUPERIOR"
  },
  {
    "codigo":240631007,
    "descripcion":"PALUDISMO DE LOS AEROPUERTOS"
  },
  {
    "codigo":304332000,
    "descripcion":"AMPLITUD DE MOVIMIENTO SUBASTRAGALINO NORMAL"
  },
  {
    "codigo":11255009,
    "descripcion":"ARTERITIS RETINIANA"
  },
  {
    "codigo":42188001,
    "descripcion":"FRACTURA NO EXPUESTA DE TOBILLO"
  },
  {
    "codigo":1156300000,
    "descripcion":"NEUTROPENIA ÉTNICA BENIGNA"
  },
  {
    "codigo":109559009,
    "descripcion":"LÓBULO HEPÁTICO DE RIEDEL"
  },
  {
    "codigo":10954701000119106,
    "descripcion":"AVULSIÓN DE UNIDAD UNGUEAL DE PULGAR IZQUIERDO"
  },
  {
    "codigo":402636006,
    "descripcion":"NEOPLASIA MALIGNA DEL APARATO UNGUEAL"
  },
  {
    "codigo":9420008,
    "descripcion":"OBSTRUCCIÓN NEONATAL DE CONDUCTO NASOLAGRIMAL"
  },
  {
    "codigo":238796009,
    "descripcion":"ÚLCERA NEUROISQUÉMICA EN EL PIE"
  },
  {
    "codigo":32871000119101,
    "descripcion":"INFECCIÓN ODONTÓGENA DE LA MANDÍBULA"
  },
  {
    "codigo":73121005,
    "descripcion":"DÉFICIT EN EL MANEJO DE LA SALUD (TOTAL)"
  },
  {
    "codigo":269729005,
    "descripcion":"LESIÓN AUTOINFLIGIDA CON QUEMADURA QUÍMICA EXTERNA"
  },
  {
    "codigo":1187233008,
    "descripcion":"DEFICIENCIA DE LA ADHESIÓN LEUCOCITARIA"
  },
  {
    "codigo":71286001,
    "descripcion":"COMPRESIÓN DE LA MÉDULA ESPINAL"
  },
  {
    "codigo":7585008,
    "descripcion":"FRACTURA DE HUESO PIRAMIDAL DEL CARPO"
  },
  {
    "codigo":366198003,
    "descripcion":"REFLEJO DE DEGLUCIÓN - HALLAZGO"
  },
  {
    "codigo":688231000119103,
    "descripcion":"ENFERMEDAD DE SÉZARY DE GANGLIOS LINFÁTICOS DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":300662008,
    "descripcion":"DIFICULTAD PARA REALIZAR ACTIVIDADES RELACIONADAS CON EL USO DE MEDIOS DE TRANSPORTE"
  },
  {
    "codigo":235126009,
    "descripcion":"SIALOADENITIS CRÓNICA"
  },
  {
    "codigo":298827001,
    "descripcion":"AMPLITUD DE ROTACIÓN INTERNA PASIVA DE ARTICULACIÓN DE HOMBRO, NORMAL"
  },
  {
    "codigo":724811002,
    "descripcion":"TRASTORNO DEL SISTEMA NERVIOSO AUTÓNOMO DEBIDO A ENFERMEDAD INFECCIOSA"
  },
  {
    "codigo":167755001,
    "descripcion":"ELECTROFORESIS DE LÍQUIDO CEFALORRAQUÍDEO FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":722976001,
    "descripcion":"ESTEREOTIPIA SECUNDARIA"
  },
  {
    "codigo":231456001,
    "descripcion":"SÍNDROME POSLEUCOTOMÍA"
  },
  {
    "codigo":229621000,
    "descripcion":"TRASTORNO DE LA FLUIDEZ"
  },
  {
    "codigo":16007271000119107,
    "descripcion":"GANGRENA DE DEDO DE MANO DERECHA"
  },
  {
    "codigo":196853004,
    "descripcion":"PASTEURELOSIS SEPTICÉMICA"
  },
  {
    "codigo":295157006,
    "descripcion":"SOBREDOSIS DE DIPIPANONA"
  },
  {
    "codigo":33013007,
    "descripcion":"GRADO DE GLEASON: 8"
  },
  {
    "codigo":10682471000119108,
    "descripcion":"TUMORACIÓN DEL TEJIDO CELULAR SUBCUTÁNEO DE LA PIERNA IZQUIERDA"
  },
  {
    "codigo":11311361000119103,
    "descripcion":"FRACTURA POR OSTEOPOROSIS SECUNDARIA DE VÉRTEBRA DORSAL"
  },
  {
    "codigo":719306007,
    "descripcion":"SÍNDROME DE ESTEATOCISTOMA MÚLTIPLE CON DIENTE NATAL"
  },
  {
    "codigo":193183000,
    "descripcion":"NEUROPATÍA DOLOROSA AGUDA DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":1208991001,
    "descripcion":"CONVULSIÓN EPILÉPTICA MIOCLÓNICA"
  },
  {
    "codigo":783007005,
    "descripcion":"INFECCIÓN RECURRENTE POR NEISSERIA DEBIDA A DEFICIENCIA DE FACTOR D"
  },
  {
    "codigo":94879007,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LOS ÓRGANOS INTRABDOMINALES"
  },
  {
    "codigo":93044000,
    "descripcion":"URÉTER CONVOLUTO CONGÉNITO"
  },
  {
    "codigo":224116000,
    "descripcion":"TIENE MADRE ANCIANA"
  },
  {
    "codigo":289652008,
    "descripcion":"CUELLO UTERINO VISIBLE EN EL INTROITO VAGINAL"
  },
  {
    "codigo":91209001,
    "descripcion":"DIETA HOSPITALARIA BÁSICA MODIFICADA"
  },
  {
    "codigo":123977005,
    "descripcion":"FIEBRE POR ETIOCOLANONA"
  },
  {
    "codigo":253214000,
    "descripcion":"DISTIQUIASIS CONGÉNITA"
  },
  {
    "codigo":449822000,
    "descripcion":"ANOMALÍA DE CONVERGENCIA"
  },
  {
    "codigo":1172553008,
    "descripcion":"HALLAZGO RELACIONADO CON EL NIVEL DE ESTRIOL"
  },
  {
    "codigo":285982007,
    "descripcion":"DIFICULTAD PARA CONTROLAR EL TERMOSTATO EN EL HOGAR"
  },
  {
    "codigo":284147001,
    "descripcion":"MUEVE LA MANO"
  },
  {
    "codigo":251379005,
    "descripcion":"SENSACIÓN GASTROINTESTINAL ALTERADA"
  },
  {
    "codigo":54771008,
    "descripcion":"ENDOFLEBITIS"
  },
  {
    "codigo":249544004,
    "descripcion":"MÚSCULOS ABDOMINALES TENSOS"
  },
  {
    "codigo":282312004,
    "descripcion":"MANTIENE EL EQUILIBRIO EN BIPEDESTACIÓN"
  },
  {
    "codigo":1263517001,
    "descripcion":"MENINGITIS DEBIDA A GRANULOMATOSIS CON POLIANGEÍTIS"
  },
  {
    "codigo":35381000119101,
    "descripcion":"EMBARAZO CUÁDRUPLE CON PÉRDIDA DE UN FETO O MÁS"
  },
  {
    "codigo":247709005,
    "descripcion":"PERCEPCIÓN DE QUE LAS COSAS APARECEN SIN COLORES"
  },
  {
    "codigo":870301007,
    "descripcion":"MIOCARDITIS DEBIDA A DERMATOMIOSITIS DE TIPO INFANTIL"
  },
  {
    "codigo":18333008,
    "descripcion":"PELO DESCOLORIDO"
  },
  {
    "codigo":409714000,
    "descripcion":"METÁSTASIS DE GANGLIOS LINFÁTICOS REGIONALES DERECHOS, PRESENTE"
  },
  {
    "codigo":278642006,
    "descripcion":"DISPOSITIVO ORTODÓNCICO FRACTURADO"
  },
  {
    "codigo":209436000,
    "descripcion":"ESGUINCE DE MUÑECA Y MANO"
  },
  {
    "codigo":735559009,
    "descripcion":"GRANULOMA DE ESTRUCTURA INTRACRANEAL CAUSADO POR HONGO"
  },
  {
    "codigo":1290780001,
    "descripcion":"OSTEOCONDRITIS DISECANTE DE HUESO DE PIE"
  },
  {
    "codigo":897564008,
    "descripcion":"DELECIÓN DISTAL DE BRAZO LARGO DE CROMOSOMA 12"
  },
  {
    "codigo":830193003,
    "descripcion":"CÚPULA VESICAL PERCIBIDA A LA ALTURA DEL OMBLIGO"
  },
  {
    "codigo":109297005,
    "descripcion":"BURSITIS AGUDA"
  },
  {
    "codigo":305905008,
    "descripcion":"VISTO POR SERVICIOS SOCIALES"
  },
  {
    "codigo":240369008,
    "descripcion":"INFECCIÓN EL CILIADO INTESTINAL"
  },
  {
    "codigo":238534006,
    "descripcion":"DERMATITIS MARINA"
  },
  {
    "codigo":402374008,
    "descripcion":"DISTROFIA UNGUEAL POR SARCOIDOSIS"
  },
  {
    "codigo":236699001,
    "descripcion":"FÍSTULAS URETROCUTÁNEAS MÚLTIPLES"
  },
  {
    "codigo":171163000,
    "descripcion":"EXTENDIDO CERVICAL - ESTADO DESCONOCIDO"
  },
  {
    "codigo":336591000119104,
    "descripcion":"CONJUNTIVITIS AGUDA DE OJO DERECHO CAUSADA POR SUSTANCIA QUÍMICA"
  },
  {
    "codigo":269467007,
    "descripcion":"NEOPLASIA MALIGNA DE HUESOS DE LA MANO"
  },
  {
    "codigo":1073871000119105,
    "descripcion":"DEFORMIDAD DE MANO IZQUIERDA CONCOMITANTE CON ARTRITIS REUMATOIDE Y DEBIDA A ELLA"
  },
  {
    "codigo":1285275009,
    "descripcion":"SIN RANGO PASIVO DE FLEXIÓN PLANTAR DE TOBILLO"
  },
  {
    "codigo":90831000119105,
    "descripcion":"GLIOMA MALIGNO CEREBRAL DE GRADO 4"
  },
  {
    "codigo":202096005,
    "descripcion":"DESGARRO POR SEPARACIÓN HORIZONTAL DE MENISCO EXTERNO"
  },
  {
    "codigo":726384005,
    "descripcion":"DELECIÓN DE PARTE DEL CROMOSOMA 13"
  },
  {
    "codigo":365936008,
    "descripcion":"HALLAZGO RELACIONADO CON EL SENTIDO DE LA IDENTIDAD"
  },
  {
    "codigo":300400008,
    "descripcion":"HALLAZGO RELACIONADO CON LA CONSISTENCIA DEL ABDOMEN"
  },
  {
    "codigo":10959721000119101,
    "descripcion":"HERIDA PUNZANTE DE CODO IZQUIERDO"
  },
  {
    "codigo":298565004,
    "descripcion":"AMPLITUD DE ROTACIÓN ACTIVA HACIA LA IZQUIERDA DE LA COLUMNA VERTEBRAL DORSAL, AUMENTADA"
  },
  {
    "codigo":724549005,
    "descripcion":"EPILEPSIA DEBIDA A ENFERMEDAD INFECCIOSA DEL SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":16229071000119108,
    "descripcion":"HIFEMA ESPONTÁNEO DE OJO DERECHO"
  },
  {
    "codigo":198426000,
    "descripcion":"SUPRESIÓN DE LA OVULACIÓN"
  },
  {
    "codigo":395034001,
    "descripcion":"OBSERVACIÓN DE COMPLEJO INMUNE"
  },
  {
    "codigo":722714004,
    "descripcion":"CARCINOMA MUCOEPIDERMOIDE PRIMARIO DE APARATO LAGRIMAL"
  },
  {
    "codigo":296730005,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE CEFPODOXIMA"
  },
  {
    "codigo":34586006,
    "descripcion":"INTOXICACIÓN POR CROTALARIA"
  },
  {
    "codigo":1148698007,
    "descripcion":"ENFERMEDAD CAUSADA POR BOCAVIRUS HUMANO"
  },
  {
    "codigo":165658005,
    "descripcion":"FOLATO EN SANGRE ENTERA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":360431007,
    "descripcion":"DIENTE EMBUTIDO"
  },
  {
    "codigo":424132000,
    "descripcion":"CARCINOMA PULMONAR NO MICROCÍTICO, TNM ESTADIO 1"
  },
  {
    "codigo":131055009,
    "descripcion":"NIVEL DE 11-DESOXICORTICOSTERONA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":63684002,
    "descripcion":"MIOPATÍA VISCOSA CAVITARIA HEREDITARIA"
  },
  {
    "codigo":260292001,
    "descripcion":"CUENTA LOS DEDOS - 1 METRO"
  },
  {
    "codigo":293060004,
    "descripcion":"REACCIÓN ADVERSA A LA ATOVACUONA"
  },
  {
    "codigo":11778921000119106,
    "descripcion":"SUBLUXACIÓN DE CABEZA DE RADIO DERECHO"
  },
  {
    "codigo":719044008,
    "descripcion":"AGENESIA PARCIAL DE PÁNCREAS"
  },
  {
    "codigo":29081001,
    "descripcion":"ESPOROTRICOSIS ÓSEA"
  },
  {
    "codigo":94617002,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LAS GLÁNDULAS SUDORÍPARAS"
  },
  {
    "codigo":717209006,
    "descripcion":"NEISSERIA MENINGITIDIS SEROGRUPO Y O NEISSERIA MENINGITIDIS SEROGRUPO W135"
  },
  {
    "codigo":782745008,
    "descripcion":"DEFICIENCIA DE LIPOIL TRANSFERASA 1"
  },
  {
    "codigo":291225009,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR FLUPENTIXOL"
  },
  {
    "codigo":1010286003,
    "descripcion":"TRASTORNO FETAL DEBIDO A ENFERMEDAD CARDIOVASCULAR CRÓNICA MATERNA"
  },
  {
    "codigo":715374003,
    "descripcion":"SÍNDROME DE ATROFIA ÓPTICA AUTOSÓMICA DOMINANTE PLUS"
  },
  {
    "codigo":92782006,
    "descripcion":"CARCINOMA IN SITU DE URÉTER"
  },
  {
    "codigo":289390007,
    "descripcion":"VÉRTEX PALPABLE EN EL TACTO VAGINAL"
  },
  {
    "codigo":420462009,
    "descripcion":"INFESTACIÓN CAUSADA POR PIOJOS MASTICADORES"
  },
  {
    "codigo":189251006,
    "descripcion":"CARCINOMA IN SITU DEL APARATO RESPIRATORIO"
  },
  {
    "codigo":90947008,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE FLANCO SIN INFECCIÓN"
  },
  {
    "codigo":254787009,
    "descripcion":"HEMANGIOMA CUTÁNEO VERRUGOSO"
  },
  {
    "codigo":1137688001,
    "descripcion":"EX USUARIO DE CIGARRILLO ELECTRÓNICO POR MENOS DE 1 AÑO"
  },
  {
    "codigo":449560003,
    "descripcion":"ESTENOSIS MÚLTIPLES DE ARTERIA PULMONAR DERECHA"
  },
  {
    "codigo":416792008,
    "descripcion":"MALFORMACIÓN DE LA VENA DE GALENO"
  },
  {
    "codigo":185581006,
    "descripcion":"CONTROL DE LOS DOS AÑOS REALIZADO"
  },
  {
    "codigo":251117006,
    "descripcion":"PATRÓN DE WOLFF-PARKINSON-WHITE TIPO B"
  },
  {
    "codigo":54509008,
    "descripcion":"NEUROPATÍA RELACIONADA CON DEFICIENCIA VITAMÍNICA"
  },
  {
    "codigo":1332461009,
    "descripcion":"TRASTORNO DE DISCO INTERVERTEBRAL DE COLUMNA DORSOLUMBAR"
  },
  {
    "codigo":282050000,
    "descripcion":"LESIÓN DE YEYUNO"
  },
  {
    "codigo":183746005,
    "descripcion":"CONSULTA DOMICILIARIA PSIQUIÁTRICA, REALIZADA"
  },
  {
    "codigo":52674009,
    "descripcion":"ISQUEMIA"
  },
  {
    "codigo":1363394009,
    "descripcion":"NEOVASCULARIZACIÓN DE CUADRANTE NASAL DE ÁNGULO IRIDOCORNEAL DE OJO IZQUIERDO"
  },
  {
    "codigo":216514009,
    "descripcion":"INTOXICACIÓN ACCIDENTAL CAUSADA POR GLUTETIMIDA"
  },
  {
    "codigo":18071005,
    "descripcion":"ENCEFALITIS MENINGOCÓCICA"
  },
  {
    "codigo":1197719006,
    "descripcion":"DOLOR ABDOMINAL FUNCIONAL INFANTIL"
  },
  {
    "codigo":1163116000,
    "descripcion":"COLITIS CAUSADA POR CANDIDA"
  },
  {
    "codigo":704364002,
    "descripcion":"CON MAYOR RIESGO DE PERFUSIÓN TISULAR INEFECTIVA"
  },
  {
    "codigo":339101000119106,
    "descripcion":"QUISTE DE ÓRBITA IZQUIERDA"
  },
  {
    "codigo":211009001,
    "descripcion":"PICADURA DE INSECTO, NO VENENOSO, EN EL CUELLO"
  },
  {
    "codigo":473153002,
    "descripcion":"CATÉTER URETERAL RETENIDO"
  },
  {
    "codigo":407617005,
    "descripcion":"SIN CONVULSIONES DURANTE EL TRATAMIENTO"
  },
  {
    "codigo":276545006,
    "descripcion":"APNEA OBSTRUCTIVA DEL RECIÉN NACIDO"
  },
  {
    "codigo":1076381000119108,
    "descripcion":"INFECCIÓN DE BOLSA SEROSA PRERROTULIANA DE RODILLA IZQUIERDA"
  },
  {
    "codigo":1259585005,
    "descripcion":"OSTEOSARCOMA EXTRAESQUELÉTICO PRIMARIO"
  },
  {
    "codigo":702529006,
    "descripcion":"SOBREXTENSIÓN DE PRÓTESIS DENTAL COMPLETA"
  },
  {
    "codigo":274710003,
    "descripcion":"CAMPO PULMONAR ANORMAL"
  },
  {
    "codigo":373014005,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM AUSTROAFRICANUM"
  },
  {
    "codigo":897302008,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE TRONCO CON INFECCIÓN"
  },
  {
    "codigo":698859001,
    "descripcion":"UTILIZACIÓN DE NUTRIENTES ALTERADA"
  },
  {
    "codigo":240107001,
    "descripcion":"MIALGIA VIRAL"
  },
  {
    "codigo":76267008,
    "descripcion":"TRASTORNO DE VÁLVULA PULMONAR"
  },
  {
    "codigo":403947009,
    "descripcion":"ENFERMEDAD DE PAGET PERIANAL"
  },
  {
    "codigo":860864008,
    "descripcion":"GRANULOMA DE ENCÉFALO CAUSADO POR SCHISTOSOMA HAEMATOBIUM"
  },
  {
    "codigo":269205004,
    "descripcion":"PICADURA DE INSECTO, NO VENENOSO, EN EL PIE"
  },
  {
    "codigo":170901005,
    "descripcion":"PROBLEMA EN UN PACIENTE OSTOMIZADO"
  },
  {
    "codigo":1186709006,
    "descripcion":"DISPLASIA VALVULAR MIXOMATOSA LIGADA AL CROMOSOMA X ASOCIADA A GEN FLNA"
  },
  {
    "codigo":1217642000,
    "descripcion":"NISTAGMO CENTRÍPETO"
  },
  {
    "codigo":301973009,
    "descripcion":"HALLAZGO RELACIONADO CON LA PRODUCCIÓN DE LÁGRIMAS"
  },
  {
    "codigo":234602002,
    "descripcion":"DEFICIENCIA DEL COMPLEMENTO 4B"
  },
  {
    "codigo":365674003,
    "descripcion":"HALLAZGO RELACIONADO CON OLOR DE LAS HECES"
  },
  {
    "codigo":300138002,
    "descripcion":"PROBLEMA DE CONDUCTO AUDITIVO"
  },
  {
    "codigo":201834006,
    "descripcion":"ARTROSIS PRIMARIA LOCALIZADA, DE LA MANO"
  },
  {
    "codigo":167231005,
    "descripcion":"ORINA=NORMAL A LA INSPECCIÓN"
  },
  {
    "codigo":298303005,
    "descripcion":"HALLAZGO RELACIONADO CON MEDICIONES DE LA MARCHA"
  },
  {
    "codigo":3391005,
    "descripcion":"RESULTADO NEGATIVO PARA PRESENCIA DE CÉLULAS TUMORALES"
  },
  {
    "codigo":68927006,
    "descripcion":"CROMODACRIORREA"
  },
  {
    "codigo":722452004,
    "descripcion":"SÍNDROME DE DEFICIENCIA PREAXIAL, POLIDACTILIA POSTAXIAL E HIPOSPADIAS"
  },
  {
    "codigo":12246481000119106,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE AMBOS RIÑONES"
  },
  {
    "codigo":1556006,
    "descripcion":"MELANOMA, NIVEL 4 DE CLARK"
  },
  {
    "codigo":296468008,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE ACITRETINA"
  },
  {
    "codigo":294633002,
    "descripcion":"ALERGIA A INMUNOGLOBULINA HUMANA"
  },
  {
    "codigo":15687121000119107,
    "descripcion":"SINOVITIS DE AMBOS PIES"
  },
  {
    "codigo":11892331000119101,
    "descripcion":"QUERATITIS ULCERATIVA PERIFÉRICA DE OJO DERECHO"
  },
  {
    "codigo":161726001,
    "descripcion":"DURACIÓN DEL CICLO MENSTRUAL EN DISMINUCIÓN"
  },
  {
    "codigo":30654002,
    "descripcion":"HIPERTROFIA DE LA UÑA"
  },
  {
    "codigo":292798002,
    "descripcion":"REACCIÓN ADVERSA A LA CARMELOSA"
  },
  {
    "codigo":1144766004,
    "descripcion":"VÁRICES VENOSAS DE PERINEO EN EL PUERPERIO"
  },
  {
    "codigo":260030003,
    "descripcion":"DALTONISMO"
  },
  {
    "codigo":784318009,
    "descripcion":"FATIGA DEBIDA A RADIOTERAPIA"
  },
  {
    "codigo":94355001,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE ISTMO UTERINO"
  },
  {
    "codigo":341611000119104,
    "descripcion":"DACRIOCISTITIS CRÓNICA DE SACO LAGRIMAL DE OJO IZQUIERDO"
  },
  {
    "codigo":192659004,
    "descripcion":"MENINGITIS POR MORGANELLA MORGANII"
  },
  {
    "codigo":41361000087101,
    "descripcion":"HEMATOMA DE CUARTO DEDO DE PIE DERECHO"
  },
  {
    "codigo":1078891000119104,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE BRONQUIO PRINCIPAL IZQUIERDO"
  },
  {
    "codigo":56721000087103,
    "descripcion":"QUEJAS REPETITIVAS"
  },
  {
    "codigo":1306771008,
    "descripcion":"TRASTORNO DE CRISTALINO BILATERAL"
  },
  {
    "codigo":420200001,
    "descripcion":"TRASTORNO DEL MAGNESIO"
  },
  {
    "codigo":289128002,
    "descripcion":"DIFICULTAD PARA REALIZAR ACTIVIDADES PARA EL CUIDADO DE LA BOCA"
  },
  {
    "codigo":127123009,
    "descripcion":"LINFADENOPATÍA GÁSTRICA IZQUIERDA"
  },
  {
    "codigo":46481000087108,
    "descripcion":"FRACTURA DE CUELLO DE FÉMUR IZQUIERDO"
  },
  {
    "codigo":43921000087109,
    "descripcion":"CORTE EN PIEL DE MUSLO IZQUIERDO"
  },
  {
    "codigo":715112003,
    "descripcion":"NO PASA DE LA SILLA DE RUEDAS AL INODORO"
  },
  {
    "codigo":254525001,
    "descripcion":"NEOPLASIA DE VENTRÍCULO DE LARINGE"
  },
  {
    "codigo":57917004,
    "descripcion":"SÍNDROME DE SECKEL"
  },
  {
    "codigo":1237565005,
    "descripcion":"VENA VARICOSA DE PIE DERECHO"
  },
  {
    "codigo":713277006,
    "descripcion":"QUERATOQUISTE ODONTÓGENO"
  },
  {
    "codigo":1335869007,
    "descripcion":"SÍNDROME DE PALADAR HENDIDO, CARDIOPATÍA CONGÉNITA Y DISCAPACIDAD INTELECTUAL"
  },
  {
    "codigo":90685008,
    "descripcion":"PÓLIPO DE SENO ESFENOIDAL"
  },
  {
    "codigo":315141000119103,
    "descripcion":"OSTEOCONDRITIS DISECANTE DE HUESO DE MANO IZQUIERDA"
  },
  {
    "codigo":88850006,
    "descripcion":"PANSINUSITIS CRÓNICA"
  },
  {
    "codigo":285458005,
    "descripcion":"NO ABRE NI CIERRA LA BOCA"
  },
  {
    "codigo":1137426009,
    "descripcion":"CAPAZ DE PARTICIPAR EN PLANIFICACIÓN DE CUIDADOS"
  },
  {
    "codigo":283623004,
    "descripcion":"HERIDA POR PINCHAZO DE AGUJA EN EL TÓRAX"
  },
  {
    "codigo":840679006,
    "descripcion":"OCLUSIÓN DE RAMA SEPTAL DE RAMA DESCENDIENTE ANTERIOR DE ARTERIA CORONARIA IZQUIERDA"
  },
  {
    "codigo":609468001,
    "descripcion":"INTERRUPCIÓN INDUCIDA DEL EMBARAZO COMPLICADA POR LACERACIÓN DE LIGAMENTO ANCHO"
  },
  {
    "codigo":773308001,
    "descripcion":"ENFERMEDAD DE CHARCOT-MARIE-TOOTH INTERMEDIA AUTOSÓMICA RECESIVA TIPO A"
  },
  {
    "codigo":1363132004,
    "descripcion":"ASTILLA EN REGIÓN ESCAPULAR CON INFECCIÓN"
  },
  {
    "codigo":249020006,
    "descripcion":"OBSERVACIÓN DEL CUELLO UTERINO DURANTE EL EMBARAZO Y EL TRABAJO DE PARTO"
  },
  {
    "codigo":707772007,
    "descripcion":"NÓDULO PULMONAR CONSECUTIVO A INFECCIÓN POR COCCIDIOIDES"
  },
  {
    "codigo":871612006,
    "descripcion":"DEFECTO DEL TABIQUE INTERVENTRICULAR MUSCULAR EN LA PORCIÓN TRABECULAR ANTERIOR"
  },
  {
    "codigo":314556009,
    "descripcion":"INJERTO CORNEAL SANO"
  },
  {
    "codigo":15634181000119107,
    "descripcion":"TOMOGRAFÍA COMPUTARIZADA DE ABDOMEN ANORMAL"
  },
  {
    "codigo":288671000119101,
    "descripcion":"VÍCTIMA ADULTA DE MALTRATO FÍSICO PERPETRADO POR PAREJA FEMENINA"
  },
  {
    "codigo":771473004,
    "descripcion":"SÍNDROME DE NEVO EPIDÉRMICO PAPULAR CON CAPAS DE CÉLULAS BASALES \"EN HORIZONTE\""
  },
  {
    "codigo":48742005,
    "descripcion":"HEMORRAGIA RETINIANA PROFUNDA"
  },
  {
    "codigo":11839391000119104,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO DE MANO DERECHA"
  },
  {
    "codigo":1259323004,
    "descripcion":"CARCINOMA PRIMARIO DE BORDE BERMELLÓN DE LABIO SUPERIOR"
  },
  {
    "codigo":276283006,
    "descripcion":"HEMORRAGIA SUBARACNOIDEA PROVENIENTE DE ANEURISMA DE LA ARTERIA COMUNICANTE POSTERIOR"
  },
  {
    "codigo":407355006,
    "descripcion":"INFECCIÓN POR ERBOVIRUS"
  },
  {
    "codigo":866107008,
    "descripcion":"INFESTACIÓN DE ÓRBITA CAUSADA POR LARVAS DE MOSCA"
  },
  {
    "codigo":46907007,
    "descripcion":"DUPLICACIÓN CONGÉNITA DE LA VESÍCULA BILIAR"
  },
  {
    "codigo":897040003,
    "descripcion":"DERMATITIS IRRITATIVA POR CONTACTO CAUSADA POR CLORO EN UNA PILETA"
  },
  {
    "codigo":733200004,
    "descripcion":"SIDEROSIS SUPERFICIAL DE SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":45072005,
    "descripcion":"ACNÉ NECRÓTICA MILIAR"
  },
  {
    "codigo":307216009,
    "descripcion":"CARCINOMA PERFORADO DEL ESÓFAGO"
  },
  {
    "codigo":10469003,
    "descripcion":"HIPOCALIEMIA CRÓNICA"
  },
  {
    "codigo":698597005,
    "descripcion":"ARTERIA ÚNICA DE CORDÓN UMBILICAL FETAL EN ECOGRAFÍA OBSTÉTRICA"
  },
  {
    "codigo":239845005,
    "descripcion":"GOTA CAUSADA POR FÁRMACO"
  },
  {
    "codigo":16754591000119108,
    "descripcion":"SANGRADO UTERINO ANORMAL DEBIDO A PÓLIPO ENDOCERVICAL"
  },
  {
    "codigo":762298000,
    "descripcion":"ALTERACIÓN COGNITIVA DEBIDA A TOXICIDAD DE SUSTANCIA"
  },
  {
    "codigo":403685009,
    "descripcion":"CICATRIZ QUIRÚRGICA HIPERTRÓFICA"
  },
  {
    "codigo":344121000119102,
    "descripcion":"EROSIÓN CORNEAL RECIDIVANTE BILATERAL"
  },
  {
    "codigo":15745081000119102,
    "descripcion":"INESTABILIDAD DE AMBAS RODILLAS"
  },
  {
    "codigo":238010006,
    "descripcion":"DEFICIENCIA TIPO II DE ADENINA FOSFORRIBOSIL TRANSFERASA"
  },
  {
    "codigo":170639000,
    "descripcion":"MEDICIÓN DEL PICO FLUJO EN EL HOGAR"
  },
  {
    "codigo":8634009,
    "descripcion":"SÍNDROME DE DISTIQUIASIS - LINFOEDEMA"
  },
  {
    "codigo":301711007,
    "descripcion":"ABSCESO DE CODO"
  },
  {
    "codigo":203407008,
    "descripcion":"OSTEOCONDRITIS DISECANTE DE CABEZA DE HÚMERO"
  },
  {
    "codigo":299876001,
    "descripcion":"REFLEJO ROTULIANO INVERTIDO"
  },
  {
    "codigo":430948002,
    "descripcion":"FRACTURA DE LA COLUMNA CERVICAL POR COMPRESIÓN"
  },
  {
    "codigo":103268003,
    "descripcion":"OJERAS"
  },
  {
    "codigo":267108004,
    "descripcion":"SÍNTOMA DE TRONCO POSTERIOR"
  },
  {
    "codigo":1217380005,
    "descripcion":"SÍNDROME DE HIPOHIDROSIS, DESEQUILIBRIO ELECTROLÍTICO, DISFUNCIÓN DE LA GLÁNDULA LAGRIMAL, ICTIOSIS Y XEROSTOMÍA"
  },
  {
    "codigo":234340006,
    "descripcion":"DEFICIENCIA DE HIERRO SIN ANEMIA"
  },
  {
    "codigo":365412003,
    "descripcion":"ONDA Q ELECTROCARDIOGRÁFICA - HALLAZGO"
  },
  {
    "codigo":37732008,
    "descripcion":"SOBRECARGA"
  },
  {
    "codigo":1184612001,
    "descripcion":"MARCHA MIELOPÁTICA"
  },
  {
    "codigo":201572007,
    "descripcion":"ARTRITIS REACTIVA DE ARTICULACIÓN SUBASTRAGALINA"
  },
  {
    "codigo":199737005,
    "descripcion":"HALLAZGO RADIOLÓGICO ANORMAL EN EL CRIBADO MATERNO PRENATAL"
  },
  {
    "codigo":3129009,
    "descripcion":"INFARTO DE OVARIO"
  },
  {
    "codigo":230670003,
    "descripcion":"MIASTENIA FAMILIAR INFANTIL"
  },
  {
    "codigo":296206007,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE LEVOMEPROMAZINA"
  },
  {
    "codigo":294371004,
    "descripcion":"ALERGIA A FAMCICLOVIR"
  },
  {
    "codigo":1144504001,
    "descripcion":"OSTEOPATÍA DE PELVIS Y FÉMUR COMO CONSECUENCIA DE POLIOMIELITIS"
  },
  {
    "codigo":196067009,
    "descripcion":"EMPIEMA TABICADO"
  },
  {
    "codigo":292536004,
    "descripcion":"REACCIÓN ADVERSA A LA BENZATROPINA"
  },
  {
    "codigo":63160006,
    "descripcion":"EFECTO TÓXICO DEL NAFTALENO"
  },
  {
    "codigo":390840006,
    "descripcion":"PRÓXIMA CITA"
  },
  {
    "codigo":94093001,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE MUSLO"
  },
  {
    "codigo":2281000124105,
    "descripcion":"INCISIVO LATERAL SUPERIOR DERECHO TEMPORARIO SUPERNUMERARIO"
  },
  {
    "codigo":126861003,
    "descripcion":"NEOPLASIA DEL CUERPO DEL PÁNCREAS"
  },
  {
    "codigo":716685003,
    "descripcion":"SÍNDROME DE ÚLCERA RECTAL SOLITARIA"
  },
  {
    "codigo":28557005,
    "descripcion":"DISPLASIA GELEOFÍSICA"
  },
  {
    "codigo":92258000,
    "descripcion":"NEOPLASIA BENIGNA DE ÓRBITA"
  },
  {
    "codigo":1306509008,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE PORCIÓN CENTRAL DE MAMA"
  },
  {
    "codigo":714850004,
    "descripcion":"SE ADMINISTRA MEDICACIÓN PARENTERAL"
  },
  {
    "codigo":288866006,
    "descripcion":"INCAPAZ DE BEBER CON UN SORBETE"
  },
  {
    "codigo":1237303004,
    "descripcion":"RETRACCIÓN ANORMAL CONGÉNITA DE PEZÓN"
  },
  {
    "codigo":418103007,
    "descripcion":"HIPERTROFIA DE LA AMÍGDALA LINGUAL"
  },
  {
    "codigo":876855009,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE PARED ABDOMINAL CON INFECCIÓN"
  },
  {
    "codigo":285196002,
    "descripcion":"CAPAZ DE RECORDAR EL AÑO ACTUAL"
  },
  {
    "codigo":283361008,
    "descripcion":"LACERACIÓN EN LA REGIÓN AURICULAR"
  },
  {
    "codigo":1083911000119102,
    "descripcion":"QUERATOSIS OBTURATRIZ DE AMBOS CONDUCTOS AUDITIVOS EXTERNOS"
  },
  {
    "codigo":1297334003,
    "descripcion":"CIERRE DE ÁNGULO DE AMBOS OJOS CAUSADO POR FÁRMACO"
  },
  {
    "codigo":707510005,
    "descripcion":"PROTEINOSIS ALVEOLAR PULMONAR SECUNDARIA"
  },
  {
    "codigo":248758006,
    "descripcion":"PERFUSIÓN ARTERIAL DE LA PIERNA ESCASA"
  },
  {
    "codigo":84918006,
    "descripcion":"AUSENCIA CONGÉNITA DEL RADIO"
  },
  {
    "codigo":346631000119103,
    "descripcion":"HIPEREMIA CONJUNTIVAL BILATERAL"
  },
  {
    "codigo":281526006,
    "descripcion":"FRACTURA DE EPITRÓCLEA"
  },
  {
    "codigo":115851000,
    "descripcion":"FENOTIPO DE GRUPO SANGUÍNEO COLTON"
  },
  {
    "codigo":246923005,
    "descripcion":"OJOS HUNDIDOS"
  },
  {
    "codigo":17547005,
    "descripcion":"ENGROSAMIENTO DE LAS CUERDAS VOCALES"
  },
  {
    "codigo":1295499008,
    "descripcion":"RADIOGRAFÍA DE VÍA BILIAR CON CONTRASTE NORMAL"
  },
  {
    "codigo":1162592002,
    "descripcion":"FILTRACIÓN POSQUIRÚRGICA DE HERIDA DE CONJUNTIVA"
  },
  {
    "codigo":212320009,
    "descripcion":"LESIÓN CERRADA DE NERVIO PERONEO PROFUNDO"
  },
  {
    "codigo":15993351000119107,
    "descripcion":"IRITIS DE OJO IZQUIERDO DEBIDA A SÍFILIS SECUNDARIA"
  },
  {
    "codigo":1259061007,
    "descripcion":"DISTONÍA FAMILIAR IDIOPÁTICA DE INICIO EN LA ADULTEZ"
  },
  {
    "codigo":896778001,
    "descripcion":"FORMA ANCHA ANORMAL CONGÉNITA DE FALANGE DE SEGUNDO DEDO DE PIE"
  },
  {
    "codigo":274186007,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE GLÚTEOS"
  },
  {
    "codigo":405258007,
    "descripcion":"DESPLAZAMIENTO DENTAL"
  },
  {
    "codigo":303284000,
    "descripcion":"EQUIMOSIS DE CAVIDAD BUCAL"
  },
  {
    "codigo":270516002,
    "descripcion":"MACROGLOSIA CONGÉNITA"
  },
  {
    "codigo":73908004,
    "descripcion":"INFECCIÓN CAUSADA POR BABESIA MICROTI"
  },
  {
    "codigo":237748007,
    "descripcion":"PSEUDOHERMAFRODITA, VARÓN CON TRASTORNO CORTICOSUPRARRENAL"
  },
  {
    "codigo":6537000,
    "descripcion":"TEJIDO HIPOFISARIO ECTÓPICO"
  },
  {
    "codigo":1153417000,
    "descripcion":"LINFOHISTIOCITOSIS HEMOFAGOCÍTICA SECUNDARIA"
  },
  {
    "codigo":72073003,
    "descripcion":"LESIÓN TRAUMÁTICA DEL FLANCO"
  },
  {
    "codigo":301449007,
    "descripcion":"DIFICULTAD PARA UTILIZAR INSTALACIONES EDUCATIVAS"
  },
  {
    "codigo":397918000,
    "descripcion":"TIPO DE ANTÍGENO LEUCOCITARIO HUMANO"
  },
  {
    "codigo":234078001,
    "descripcion":"RUPTURA VENOSA"
  },
  {
    "codigo":235913009,
    "descripcion":"TRASTORNO CONGÉNITO DE LA VESÍCULA Y DE LA VÍA BILIAR"
  },
  {
    "codigo":4702003,
    "descripcion":"TRASTORNO HEREDITARIO DEL METABOLISMO DE FOLATOS"
  },
  {
    "codigo":365150002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA COLOCAR UN OBJETO SOBRE OTRO"
  },
  {
    "codigo":299614005,
    "descripcion":"AMPLITUD DE ABDUCCIÓN PASIVA DE DEDO DEL PIE DISMINUIDA"
  },
  {
    "codigo":700211007,
    "descripcion":"SÍNDROME MAMARIO CUBITAL"
  },
  {
    "codigo":168542003,
    "descripcion":"RESULTADO DE RADIOGRAFÍA SIMPLE: ANORMAL"
  },
  {
    "codigo":35635000,
    "descripcion":"NEURALGIA CERVICOBRAQUIAL"
  },
  {
    "codigo":789299000,
    "descripcion":"QUERATITIS MARGINAL DE OJO IZQUIERDO CAUSADA POR TOXINA ESTAFILOCÓCICA"
  },
  {
    "codigo":430686008,
    "descripcion":"DISGENESIA ESPINAL"
  },
  {
    "codigo":284971000119100,
    "descripcion":"ENFERMEDAD RENAL CRÓNICA DEBIDA A HIPERTENSIÓN BENIGNA, ESTADIO 1"
  },
  {
    "codigo":11817771000119101,
    "descripcion":"ESGUINCE DE LIGAMENTO DE DEDO MEDIO DERECHO"
  },
  {
    "codigo":11825451000119102,
    "descripcion":"HEMATOMA DE MUSLO IZQUIERDO"
  },
  {
    "codigo":354091000119103,
    "descripcion":"NEOPLASIA BENIGNA DE OVARIO IZQUIERDO"
  },
  {
    "codigo":1073451000119104,
    "descripcion":"ARTRITIS INFECCIOSA DE MUÑECA DERECHA"
  },
  {
    "codigo":331051000119105,
    "descripcion":"ALTERACIÓN VASCULAR DE PÁRPADO INFERIOR IZQUIERDO"
  },
  {
    "codigo":338731000119106,
    "descripcion":"FOTOQUERATITIS DE OJO IZQUIERDO"
  },
  {
    "codigo":10970411000119106,
    "descripcion":"HERIDA ABIERTA DE PIERNA IZQUIERDA DEBIDA A MORDEDURA DE PERRO"
  },
  {
    "codigo":1081131000119108,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE MÚSCULO DE EXTREMIDAD INFERIOR DERECHA"
  },
  {
    "codigo":290091000119108,
    "descripcion":"LESIÓN DE NERVIO FEMORAL IZQUIERDO"
  },
  {
    "codigo":154411000119109,
    "descripcion":"NÓDULO DE PRÓSTATA"
  },
  {
    "codigo":346411000119106,
    "descripcion":"EDEMA MACULAR CISTOIDE DE AMBOS OJOS DEBIDO A CIRUGÍA DE CATARATAS Y POSTERIOR A ELLA"
  },
  {
    "codigo":674091000119108,
    "descripcion":"VÉRTIGO DEBIDO A ACCIDENTE CEREBROVASCULAR ISQUÉMICO Y POSTERIOR A ÉL"
  },
  {
    "codigo":232243009,
    "descripcion":"OTITIS SEBORREICA EXTERNA"
  },
  {
    "codigo":284158251000119106,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE MÚSCULO LISO"
  },
  {
    "codigo":915141931000119109,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DEBIDO A EMBOLIA DE ARTERIA BASILAR"
  },
  {
    "codigo":121131000119109,
    "descripcion":"ENFERMEDAD DE INJERTO VERSUS HUÉSPED CRÓNICA DESPUÉS DE TRASPLANTE DE MÉDULA ÓSEA"
  },
  {
    "codigo":336171000119109,
    "descripcion":"ESCOTOMA CENTRAL DE OJO DERECHO"
  },
  {
    "codigo":294109009,
    "descripcion":"ALERGIA A ANTAGONISTA DE RECEPTOR DE HISTAMINA H1"
  },
  {
    "codigo":292274008,
    "descripcion":"REACCIÓN ADVERSA A LA BROMOCRIPTINA"
  },
  {
    "codigo":716423001,
    "descripcion":"CAPAZ DE MANEJAR VISITANTES EN EL HOGAR"
  },
  {
    "codigo":290439001,
    "descripcion":"OBESIDAD FAMILIAR"
  },
  {
    "codigo":1339015003,
    "descripcion":"TRASTORNO DE PÁRPADO CAUSADO POR RADIACIÓN"
  },
  {
    "codigo":95666008,
    "descripcion":"PARESIA FACIAL"
  },
  {
    "codigo":1177010008,
    "descripcion":"INFECCIÓN DE NERVIO PERIFÉRICO"
  },
  {
    "codigo":28295001,
    "descripcion":"SÍNDROME DEL LÓBULO MEDIO"
  },
  {
    "codigo":93831006,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA HIPOFARINGE"
  },
  {
    "codigo":21461000119104,
    "descripcion":"EROSIÓN DE HUESECILLOS DEL OÍDO"
  },
  {
    "codigo":26460006,
    "descripcion":"EPÍFISIS FEMORAL SUPERIOR DESPLAZADA"
  },
  {
    "codigo":91996008,
    "descripcion":"NEOPLASIA BENIGNA DE VASO SANGUÍNEO DE GLÚTEO"
  },
  {
    "codigo":288604009,
    "descripcion":"CAPAZ DE EMPLEAR LOS ELEMENTOS DEL LENGUAJE"
  },
  {
    "codigo":286769001,
    "descripcion":"TIENDE A NO TRABAJAR MUCHO"
  },
  {
    "codigo":254001003,
    "descripcion":"FISURA COMPLETA DE PALADAR BLANDO"
  },
  {
    "codigo":1237041000,
    "descripcion":"METÁSTASIS DE CARCINOMA DE PÍLORO"
  },
  {
    "codigo":448774004,
    "descripcion":"LINFOMA NO HODGKIN DE CUELLO UTERINO"
  },
  {
    "codigo":219398006,
    "descripcion":"HERIDA DE GUERRA POR EXPLOSIÓN SUBMARINA"
  },
  {
    "codigo":284934007,
    "descripcion":"SE ACOMODA LA ROPA PARA IR AL BAÑO"
  },
  {
    "codigo":446939001,
    "descripcion":"CORDOMA DE CLIVUS"
  },
  {
    "codigo":414171001,
    "descripcion":"INFECCIÓN EXTRAPULMONAR POR PNEUMOCYSTIS JIROVECI"
  },
  {
    "codigo":283099009,
    "descripcion":"ARAÑAZO DE NALGA"
  },
  {
    "codigo":314032002,
    "descripcion":"CORIORRETINITIS INACTIVA POR TOXOPLASMOSIS"
  },
  {
    "codigo":707248001,
    "descripcion":"LIQUEN PLANO PAPULAR DE LA CAVIDAD ORAL"
  },
  {
    "codigo":838320004,
    "descripcion":"NEUROPATÍA AUTONÓMICA DEBIDA A HIPOGLUCEMIA INDUCIDA POR MEDICACIÓN"
  },
  {
    "codigo":1264304005,
    "descripcion":"NECROSIS HEPÁTICA AGUDA POSTERIOR A EMBARAZO MOLAR"
  },
  {
    "codigo":248496006,
    "descripcion":"DISTENSIÓN VENOSA ALREDEDOR DE HOMBRO"
  },
  {
    "codigo":215728006,
    "descripcion":"LESIÓN SUFRIDA A BORDO DE MEDIO DE TRANSPORTE ACUÁTICO CAUSADA POR MAQUINARIA DE CARGA"
  },
  {
    "codigo":410501000,
    "descripcion":"UVEÍTIS MEDICAMENTOSA"
  },
  {
    "codigo":281264009,
    "descripcion":"FRASCO O RECIPIENTE INAPROPIADO PARA ESPÉCIMEN"
  },
  {
    "codigo":1295237006,
    "descripcion":"TELANGIECTASIA DE COLON"
  },
  {
    "codigo":246661006,
    "descripcion":"ESCOTOMA PERIFÉRICO LOCAL"
  },
  {
    "codigo":82821008,
    "descripcion":"ATRESIA DE CONDUCTO BILIAR EXTRAHEPÁTICO"
  },
  {
    "codigo":17285009,
    "descripcion":"EMBARAZO INTRAPERITONEAL"
  },
  {
    "codigo":312197009,
    "descripcion":"INFECCIÓN TISULAR POR NEMATODOS"
  },
  {
    "codigo":1162330007,
    "descripcion":"ESPONDILOARTRITIS CAUSADA POR MYCOBACTERIUM"
  },
  {
    "codigo":242991000,
    "descripcion":"PUNCIÓN ACCIDENTAL DURANTE ATENCIÓN MÉDICA"
  },
  {
    "codigo":408666009,
    "descripcion":"DISECCIÓN DE AORTA ABDOMINAL"
  },
  {
    "codigo":44548000,
    "descripcion":"HIPERACTIVIDAD MOTORA"
  },
  {
    "codigo":308527009,
    "descripcion":"ESTADO DE CONTROL CLÍNICO C"
  },
  {
    "codigo":296201000119105,
    "descripcion":"ALTERACIÓN DE MENISCO INTERNO DEBIDA A LESIÓN TRAUMÁTICA DE RODILLA"
  },
  {
    "codigo":208388003,
    "descripcion":"FRACTURA A NIVEL DE LA MUÑECA Y LA MANO"
  },
  {
    "codigo":110084004,
    "descripcion":"LACERACIÓN SIMPLE DE LA LENGUA"
  },
  {
    "codigo":10863881000119106,
    "descripcion":"HERIDA POR DISPARO DE ARMA DE FUEGO DE REGIÓN DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":351651000119100,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE MAMA DERECHA"
  },
  {
    "codigo":403161000,
    "descripcion":"DERMATOSIS CAUSADAS POR CONTACTO CON CRUSTÁCEOS"
  },
  {
    "codigo":304857003,
    "descripcion":"TRANSFERENCIA IDEALIZANTE"
  },
  {
    "codigo":1156825004,
    "descripcion":"OSTEOCONDROSIS JUVENIL DE TARSO"
  },
  {
    "codigo":23971000119101,
    "descripcion":"ESPONDILOLISTESIS LUMBAR CONGÉNITA"
  },
  {
    "codigo":698073006,
    "descripcion":"CALCIFICACIÓN LINEAL DIFUSA DE LA PULPA"
  },
  {
    "codigo":206553008,
    "descripcion":"NIÑO BRONCEADO"
  },
  {
    "codigo":366723006,
    "descripcion":"HALLAZGO RELACIONADO CON EL GRADO DE POTENCIA MUSCULAR"
  },
  {
    "codigo":399491007,
    "descripcion":"TUMOR QUE INVADE EL CONDUCTO DE SCHLEMM"
  },
  {
    "codigo":301187008,
    "descripcion":"HALLAZGO RELACIONADO CON LA APARIENCIA DE LA NARIZ"
  },
  {
    "codigo":202883008,
    "descripcion":"EXOSTOSIS CALCÁNEA POSTERIOR"
  },
  {
    "codigo":855760291000119105,
    "descripcion":"MALFORMACIÓN CAVERNOSA DE MÉDULA ESPINAL ESPORÁDICA"
  },
  {
    "codigo":233816003,
    "descripcion":"COMPLICACIÓN CARDÍACA POSQUIRÚRGICA"
  },
  {
    "codigo":299352004,
    "descripcion":"AMPLITUD DE EXTENSIÓN PASIVA DE LA RODILLA AUMENTADA"
  },
  {
    "codigo":235651006,
    "descripcion":"EROSIÓN GÁSTRICA"
  },
  {
    "codigo":15971901000119100,
    "descripcion":"HERNIA INGUINAL DERECHA INDIRECTA"
  },
  {
    "codigo":201048007,
    "descripcion":"ESCLERODERMIA LOCALIZADA"
  },
  {
    "codigo":1251459007,
    "descripcion":"METÁSTASIS DE NEUROBLASTOMA EN ÁREA PARAESPINAL"
  },
  {
    "codigo":364888009,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA EMPUJAR Y TIRAR UN JUGUETE GRANDE CON RUEDAS HACIA ATRÁS"
  },
  {
    "codigo":789037005,
    "descripcion":"MIOCARDIOPATÍA REUMÁTICA"
  },
  {
    "codigo":231981005,
    "descripcion":"CORIORRETINITIS EN PERDIGONADA"
  },
  {
    "codigo":11820451000119108,
    "descripcion":"SUBLUXACIÓN ANTERIOR DE ARTICULACIÓN GLENOHUMERAL DERECHA"
  },
  {
    "codigo":230146001,
    "descripcion":"MENINGITIS POSTSARAMPIONOSA"
  },
  {
    "codigo":66306003,
    "descripcion":"FÍSTULA DE LA VENTANA OVAL"
  },
  {
    "codigo":262914003,
    "descripcion":"RUPTURA PARCIAL DE URETRA MASCULINA"
  },
  {
    "codigo":721666004,
    "descripcion":"PÓLIPO HIPERPLÁSICO DE INTESTINO DELGADO"
  },
  {
    "codigo":197378004,
    "descripcion":"CÁLCULO EN VESÍCULA BILIAR CON COLECISTITIS AGUDA Y OBSTRUCCIÓN"
  },
  {
    "codigo":295682007,
    "descripcion":"SOBREDOSIS INTENCIONAL DE MITOXANTRONA"
  },
  {
    "codigo":457687006,
    "descripcion":"TROMBOSIS DE VÁLVULA AÓRTICA"
  },
  {
    "codigo":293847006,
    "descripcion":"ALERGIA A PAROXETINA"
  },
  {
    "codigo":95404001,
    "descripcion":"ATROFIA DEL SITIO DE INYECCIÓN"
  },
  {
    "codigo":423084001,
    "descripcion":"EXUDADO MACULAR"
  },
  {
    "codigo":160940004,
    "descripcion":"CASA ALQUILADA AL PROPIETARIO"
  },
  {
    "codigo":421249001,
    "descripcion":"NEOPLASIA MALIGNA DE BORDE BERMELLÓN DE LABIO"
  },
  {
    "codigo":292012009,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR DIPIRIDAMOL"
  },
  {
    "codigo":124502000,
    "descripcion":"DEFICIENCIA DE PEPSINA B"
  },
  {
    "codigo":93569009,
    "descripcion":"OSIFICACIÓN INCOMPLETA DE HUESO BASIESFENOIDAL"
  },
  {
    "codigo":880001008,
    "descripcion":"ENTEROPATÍA CON PÉRDIDA DE PROTEÍNAS DEBIDA A PROCEDIMIENTO CARDÍACO Y POSTERIOR A ÉL"
  },
  {
    "codigo":26198000,
    "descripcion":"PRIMER RUIDO CARDÍACO NORMAL, R>1<"
  },
  {
    "codigo":11793981000119109,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE DEDO GORDO DE PIE DERECHO CON INFECCIÓN"
  },
  {
    "codigo":298711000119103,
    "descripcion":"OSTEONECROSIS DE TIBIA DEBIDA A TRAUMATISMO"
  },
  {
    "codigo":781697008,
    "descripcion":"NIVEL DE ANTICUERPOS ANTIPÉPTIDO CÍCLICO CITRULINADO POR ENCIMA DE RANGO DE REFERENCIA"
  },
  {
    "codigo":778027003,
    "descripcion":"DEFICIENCIA PRIMARIA DE CD59"
  },
  {
    "codigo":1269547009,
    "descripcion":"DEPENDENCIA DE ANTIDEPRESIVO"
  },
  {
    "codigo":24363009,
    "descripcion":"FIEBRE REUMÁTICA SIN COMPROMISO CARDÍACO"
  },
  {
    "codigo":22528004,
    "descripcion":"OCLUSIÓN DE CONDUCTO GALACTÓFORO"
  },
  {
    "codigo":55296004,
    "descripcion":"EXCESO DE GLOBULINA LIGADORA DE TIROXINA LIGADA AL CROMOSOMA X"
  },
  {
    "codigo":11822961000119100,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE BRAZO IZQUIERDO"
  },
  {
    "codigo":53461003,
    "descripcion":"TAMAÑO NORMAL"
  },
  {
    "codigo":413909005,
    "descripcion":"ESTADO DE CONSENTIMIENTO PARA COMPARTIR REGISTROS"
  },
  {
    "codigo":250069006,
    "descripcion":"TENSIÓN MUSCULAR"
  },
  {
    "codigo":1231274002,
    "descripcion":"FOVEOSQUISIS MIÓPICA"
  },
  {
    "codigo":51626007,
    "descripcion":"SÍNDROME DE WERNER"
  },
  {
    "codigo":248234008,
    "descripcion":"MENTALMENTE ALERTA"
  },
  {
    "codigo":770687001,
    "descripcion":"VASCULITIS DEBIDA A DEFICIENCIA DE DESAMINASA DE ADENOSINA 2"
  },
  {
    "codigo":1293140000,
    "descripcion":"ERUPCIÓN CUTÁNEA Y MUCOSITIS INDUCIDA POR MYCOPLASMA PNEUMONIAE"
  },
  {
    "codigo":15188001,
    "descripcion":"PÉRDIDA DE LA AUDICIÓN"
  },
  {
    "codigo":703316004,
    "descripcion":"LINFEDEMA ASOCIADO CON OBESIDAD"
  },
  {
    "codigo":108401000119106,
    "descripcion":"CANDIDIASIS DE CONDUCTO GALACTÓFORO MAMARIO"
  },
  {
    "codigo":1091441000119107,
    "descripcion":"COLESTEATOMA DEL OÍDO EXTERNO DERECHO"
  },
  {
    "codigo":406569004,
    "descripcion":"INFECCIÓN CRIPTOCÓCICA DEL SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":13353005,
    "descripcion":"REFLEJO PUPILAR AUSENTE"
  },
  {
    "codigo":275497007,
    "descripcion":"INFECCIÓN DE VÍAS RESPIRATORIAS INFERIORES Y MEDIASTINO"
  },
  {
    "codigo":46121008,
    "descripcion":"ENFERMEDAD POR EL VIRUS CALOVO"
  },
  {
    "codigo":109822001,
    "descripcion":"NEOPLASIA MALIGNA SUPERPUESTA DE LABIO"
  },
  {
    "codigo":240894003,
    "descripcion":"FOLICULITIS POR DEMODEX"
  },
  {
    "codigo":354161000119109,
    "descripcion":"NEOPLASIA BENIGNA DE TESTÍCULO IZQUIERDO"
  },
  {
    "codigo":765182005,
    "descripcion":"PREECLAMPSIA EN EL PUERPERIO"
  },
  {
    "codigo":371966005,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA MÉDULA SUPRARRENAL"
  },
  {
    "codigo":402899000,
    "descripcion":"ANETODERMIA LUEGO DE VARICELA"
  },
  {
    "codigo":77054009,
    "descripcion":"CELULITIS DE MUSLO"
  },
  {
    "codigo":271827002,
    "descripcion":"ESPUTO ANORMAL - COLOR"
  },
  {
    "codigo":763347000,
    "descripcion":"ENFERMEDAD DE CHARCOT-MARIE-TOOTH TIPO 6 LIGADA AL CROMOSOMA X"
  },
  {
    "codigo":239059004,
    "descripcion":"SÍNDROME DE QUERATITIS-ICTIOSIS-SORDERA"
  },
  {
    "codigo":1254867007,
    "descripcion":"PSORIASIS EN PLACA CON PÚSTULAS"
  },
  {
    "codigo":40616000,
    "descripcion":"ANORMALIDAD EN LOS MOVIMIENTOS PROPULSORES DE LA MOTILIDAD DEL INTESTINO GRUESO"
  },
  {
    "codigo":302760000,
    "descripcion":"FLUJO RÁPIDO DEL PENSAMIENTO"
  },
  {
    "codigo":827048002,
    "descripcion":"PARÁLISIS DE NERVIO ACCESORIO"
  },
  {
    "codigo":204456001,
    "descripcion":"RETORNO VENOSO PULMONAR ANÓMALO, COMPLETO, SUBDIAFRAGMÁTICO"
  },
  {
    "codigo":106152006,
    "descripcion":"HALLAZGO EN EL SEGUNDO PAR CRANEAL"
  },
  {
    "codigo":366461008,
    "descripcion":"HALLAZGO EN LA NOTA DE PERCUSIÓN ABDOMINAL"
  },
  {
    "codigo":300925009,
    "descripcion":"NÓDULO EN DEDO DE LA MANO"
  },
  {
    "codigo":200786002,
    "descripcion":"DERMATITIS DE CONTACTO CAUSADA POR ÉSTER"
  },
  {
    "codigo":299090004,
    "descripcion":"SIN AMPLITUD ACTIVA DE ABDUCCIÓN DE DEDO DE LA MANO"
  },
  {
    "codigo":102482005,
    "descripcion":"DOLORES DEL CRECIMIENTO"
  },
  {
    "codigo":461095002,
    "descripcion":"CONDUCTO ARTERIOSO BILATERAL CERRADO CON CONDUCTO ARTERIOSO IZQUIERDO CERRADO Y CONDUCTO ARTERIOSO DERECHO ABIERTO"
  },
  {
    "codigo":297255007,
    "descripcion":"DEFICIENCIA HEPÁTICA DE GLUCÓGENO-FOSFORILASA-QUINASA"
  },
  {
    "codigo":1149223009,
    "descripcion":"SOBREDOSIS ACCIDENTAL"
  },
  {
    "codigo":231719009,
    "descripcion":"DISFAGIA LUSORIA"
  },
  {
    "codigo":35111009,
    "descripcion":"SÍNDROME DEL TRIPLE X"
  },
  {
    "codigo":262652004,
    "descripcion":"HEMATOMA DEL PISO DE LA BOCA"
  },
  {
    "codigo":721404006,
    "descripcion":"SÍNDROME DE BROWN-SEQUARD AL NIVEL DEL SEXTO SEGMENTO CERVICAL"
  },
  {
    "codigo":295420009,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE DOMPERIDONA"
  },
  {
    "codigo":293585002,
    "descripcion":"ALERGIA A SALICILATO"
  },
  {
    "codigo":129745007,
    "descripcion":"LESIÓN DE IGUAL DENSIDAD (ISODENSA)"
  },
  {
    "codigo":195281008,
    "descripcion":"ANEURISMA DE ARTERIA TIBIAL POSTERIOR"
  },
  {
    "codigo":95142001,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA FOSA AMIGDALINA"
  },
  {
    "codigo":717734005,
    "descripcion":"CARCINOMA PAPILAR DE GLÁNDULA TIROIDES CON NEOPLASIA PAPILAR RENAL"
  },
  {
    "codigo":193446007,
    "descripcion":"RETINITIS EPITELIAL PIGMENTADA DISEMINADA"
  },
  {
    "codigo":226214009,
    "descripcion":"DIETA PARA LA PREPARACIÓN INTESTINAL"
  },
  {
    "codigo":191611001,
    "descripcion":"TRASTORNO DEPRESIVO MAYOR, EPISODIOS RECURRENTES, MODERADO"
  },
  {
    "codigo":10678591000119104,
    "descripcion":"TUMEFACCIÓN LOCALIZADA DE AMBAS EXTREMIDADES INFERIORES"
  },
  {
    "codigo":93307005,
    "descripcion":"POSICIÓN ANÓMALA CONGÉNITA DE ARCO DE VÉRTEBRA CERVICAL"
  },
  {
    "codigo":715899006,
    "descripcion":"OSTEOCONDRITIS DISECANTE FAMILIAR"
  },
  {
    "codigo":420987007,
    "descripcion":"PUNTOS EPITELIALES CORNEALES"
  },
  {
    "codigo":419152000,
    "descripcion":"VISIÓN A DISTANCIA 6\/4,5"
  },
  {
    "codigo":124240001,
    "descripcion":"DEFICIENCIA DE TETINA - HOMOCISTEÍNA METILTRANSFERASA"
  },
  {
    "codigo":224379008,
    "descripcion":"SEMIRRETIRADO"
  },
  {
    "codigo":253477000,
    "descripcion":"ANOMALÍA EN ARCADA DE CUERDAS TENDINOSAS DE VÁLVULA AURICULOVENTRICULAR DERECHA"
  },
  {
    "codigo":89637003,
    "descripcion":"PIELITIS GLANDULAR"
  },
  {
    "codigo":286245004,
    "descripcion":"NO UTILIZA PROCESOS FONOLÓGICOS"
  },
  {
    "codigo":187941007,
    "descripcion":"NEOPLASIA MALIGNA DE HUESO DEL CARPO - TRAPECIO"
  },
  {
    "codigo":1300218002,
    "descripcion":"DISPLASIA CONGÉNITA DE ARTICULACIÓN DE TOBILLO"
  },
  {
    "codigo":448250003,
    "descripcion":"TERATOMA MALIGNO DE REGIÓN PINEAL"
  },
  {
    "codigo":284410007,
    "descripcion":"MANTIENE EL EQUILIBRIO AL INCLINARSE"
  },
  {
    "codigo":249807007,
    "descripcion":"DEFORMIDAD DE LA FLEXIÓN PLANTAR"
  },
  {
    "codigo":870564000,
    "descripcion":"OCLUSIÓN DE VENA ESPINAL"
  },
  {
    "codigo":84132007,
    "descripcion":"EDAD GESTACIONAL, 35 SEMANAS"
  },
  {
    "codigo":213369001,
    "descripcion":"LUXACIONES, ESGUINCES Y DISTENSIONES QUE COMPROMETEN EL TÓRAX JUNTO CON LA REGIÓN LUMBAR Y LA PELVIS"
  },
  {
    "codigo":247972009,
    "descripcion":"INCAPACIDAD PARA RESISTIR LAS CONDUCTAS COMPULSIVAS"
  },
  {
    "codigo":278905001,
    "descripcion":"DIETA DURANTE DIÁLISIS PERITONEAL AMBULATORIA CONTINUA"
  },
  {
    "codigo":82297005,
    "descripcion":"CONGESTIÓN DE SENO PARANASAL"
  },
  {
    "codigo":16761005,
    "descripcion":"ESOFAGITIS"
  },
  {
    "codigo":768590001,
    "descripcion":"HALLAZGO RELACIONADO CON LA PRESENCIA DE HIFAS Y ESPORAS DE DERMATOFITOS EN EL INTERIOR DEL TALLO DEL PELO"
  },
  {
    "codigo":735822001,
    "descripcion":"RUPTURA TRAUMÁTICA DE LIGAMENTO DE ARTICULACIÓN METACARPOFALÁNGICA DE LA MANO"
  },
  {
    "codigo":309838005,
    "descripcion":"TRASTORNO EMOCIONAL"
  },
  {
    "codigo":1260110006,
    "descripcion":"CARCINOMA TIPO GLÁNDULA SALIVAL DE OROFARINGE"
  },
  {
    "codigo":703054007,
    "descripcion":"ARTROSIS MEDIOTARSIANA SECUNDARIA A ARTRITIS INFLAMATORIA"
  },
  {
    "codigo":766755003,
    "descripcion":"SÍNDROME DE TETRASOMÍA 5P"
  },
  {
    "codigo":111395007,
    "descripcion":"DIABETES INSÍPIDA NEFROGÉNICA"
  },
  {
    "codigo":240632000,
    "descripcion":"NEUMOCISTOSIS DISEMINADA"
  },
  {
    "codigo":371704001,
    "descripcion":"LESIÓN POR EXPOSICIÓN QUÍMICA"
  },
  {
    "codigo":699384003,
    "descripcion":"HEMANGIOMA DE GLÁNDULA SALIVAL"
  },
  {
    "codigo":109560004,
    "descripcion":"DISPLASIA TESTICULAR QUÍSTICA"
  },
  {
    "codigo":11256005,
    "descripcion":"MELANOSIS COLI"
  },
  {
    "codigo":402637002,
    "descripcion":"ALOPECIA POR ALTERACIÓN DEL CICLO PILOSO"
  },
  {
    "codigo":74957005,
    "descripcion":"ESCALA DEL COMA DE GLASGOW, 5"
  },
  {
    "codigo":304333005,
    "descripcion":"AMPLITUD DE MOVIMIENTO SUBASTRAGALINO AUMENTADA"
  },
  {
    "codigo":10871411000119109,
    "descripcion":"CISTADENOMA MUCINOSO DE OVARIO IZQUIERDO"
  },
  {
    "codigo":235127000,
    "descripcion":"SIALOADENITIS OBSTRUCTIVA"
  },
  {
    "codigo":40354009,
    "descripcion":"SÍNDROME DE DE LANGE"
  },
  {
    "codigo":7586009,
    "descripcion":"TRISOMÍA PARCIAL 14Q"
  },
  {
    "codigo":366199006,
    "descripcion":"HALLAZGO DEL PULSO"
  },
  {
    "codigo":69452005,
    "descripcion":"HEMORRAGIA DEL CUERPO CAVERNOSO"
  },
  {
    "codigo":298828006,
    "descripcion":"AMPLITUD DE ROTACIÓN INTERNA PASIVA DE ARTICULACIÓN DE HOMBRO, AUMENTADA"
  },
  {
    "codigo":10900391000119101,
    "descripcion":"LACERACIÓN DE CÓRNEA IZQUIERDA"
  },
  {
    "codigo":296993004,
    "descripcion":"SOBREDOSIS INTENCIONAL DE PROCAINAMIDA"
  },
  {
    "codigo":722977005,
    "descripcion":"DEMENCIA CONCOMITANTE CON NEUROCISTICERCOSIS Y DEBIDA A ELLA"
  },
  {
    "codigo":33014001,
    "descripcion":"ESCOTOMA CENTROCECAL"
  },
  {
    "codigo":295158001,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE DIPIPANONA"
  },
  {
    "codigo":332711000119103,
    "descripcion":"PTERIGIÓN RECIDIVANTE DEL OJO DERECHO"
  },
  {
    "codigo":229622007,
    "descripcion":"DISFLUIDEZ"
  },
  {
    "codigo":65782009,
    "descripcion":"FACIES DE HUTCHINSON"
  },
  {
    "codigo":15979431000119104,
    "descripcion":"COLESTEATOSIS DIFUSA DE OÍDO MEDIO DERECHO"
  },
  {
    "codigo":660391000119105,
    "descripcion":"INMUNIDAD CONTRA LA POLIOMIELITIS POR SEROLOGÍA POSITIVA"
  },
  {
    "codigo":783008000,
    "descripcion":"QUISTES DERMOIDES Y EPIDERMOIDES HIPOFISARIOS"
  },
  {
    "codigo":62112002,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA MAMA"
  },
  {
    "codigo":1340064003,
    "descripcion":"TRASTORNO DE TENDÓN DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":94880005,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LAS VÍAS BILIARES INTRAHEPÁTICAS"
  },
  {
    "codigo":193184006,
    "descripcion":"NEUROPATÍA DOLOROSA CRÓNICA DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":291488006,
    "descripcion":"INTOXICACIÓN POR NETILMICINA"
  },
  {
    "codigo":1141621000,
    "descripcion":"NEOPLASIA EPITELIAL MALIGNA DE SENO PIRIFORME"
  },
  {
    "codigo":289653003,
    "descripcion":"CUELLO UTERINO VISIBLE EN EL INTROITO VAGINAL CON TRACCIÓN"
  },
  {
    "codigo":123978000,
    "descripcion":"TRASTORNO FUNCIONAL NO IDENTIFICADO"
  },
  {
    "codigo":294067006,
    "descripcion":"ALERGIA A ALCALOIDE DE LA BELLADONA"
  },
  {
    "codigo":418890002,
    "descripcion":"EL MARGEN DE RESECCIÓN QUIRÚRGICA PROFUNDO ES EL MARGEN NO AFECTADO MÁS CERCANO A LA NEOPLASIA MALIGNA"
  },
  {
    "codigo":1172554002,
    "descripcion":"ESTRIOL EN SUERO DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":10955841000119103,
    "descripcion":"HERIDA PUNZANTE DE DEDO DE MANO DERECHA"
  },
  {
    "codigo":91210006,
    "descripcion":"FÍSTULA ANOURETRAL CONGÉNITA"
  },
  {
    "codigo":253215004,
    "descripcion":"ALACRIMA"
  },
  {
    "codigo":449823005,
    "descripcion":"TENOSINOVITIS DE PULGAR"
  },
  {
    "codigo":87540003,
    "descripcion":"DEFORMIDAD ORBITARIA"
  },
  {
    "codigo":22004006,
    "descripcion":"INTOXICACIÓN POR THRELKELDIA PROCERIFLORA"
  },
  {
    "codigo":447988007,
    "descripcion":"TRONCO ARTERIAL COMÚN CON ARTERIAS PULMONARES ORIGINADAS EN EL TRONCO Y CAYADO AÓRTICO NO OBSTRUIDO"
  },
  {
    "codigo":251380008,
    "descripcion":"SENSACIÓN GASTROINTESTINAL INMODIFICADA"
  },
  {
    "codigo":284148006,
    "descripcion":"NO MUEVE LA MANO"
  },
  {
    "codigo":249545003,
    "descripcion":"DEFENSA ABDOMINAL"
  },
  {
    "codigo":630352961000119108,
    "descripcion":"IRITIS DE AMBOS OJOS DEBIDA A PROCEDIMIENTO QUIRÚRGICO EN AMBOS OJOS Y POSTERIOR A ÉL"
  },
  {
    "codigo":870302000,
    "descripcion":"INFESTACIÓN PARASITARIA DE ÓRBITA CAUSADA POR TAENIA SOLIUM"
  },
  {
    "codigo":413385009,
    "descripcion":"CAPACIDAD ANORMAL PARA ESCUCHAR LA VOZ"
  },
  {
    "codigo":689371000119102,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE PILAR AMIGDALINO"
  },
  {
    "codigo":52937008,
    "descripcion":"INFERTILIDAD SECUNDARIA A INFECCIÓN"
  },
  {
    "codigo":83870002,
    "descripcion":"INTOXICACIÓN POR TRIFOLIUM HYBRIDUM"
  },
  {
    "codigo":247710000,
    "descripcion":"PERCEPCIÓN DE QUE LAS COSAS APARECEN GRISES"
  },
  {
    "codigo":1263518006,
    "descripcion":"MENINGITIS DEBIDA A LUPUS ERITEMATOSO SISTÉMICO"
  },
  {
    "codigo":278643001,
    "descripcion":"PACIENTE INCAPAZ DE COMER CON DISPOSITIVO ORTODÓNCICO"
  },
  {
    "codigo":409715004,
    "descripcion":"METÁSTASIS DE GANGLIOS LINFÁTICOS REGIONALES IZQUIERDOS, PRESENTE"
  },
  {
    "codigo":442483004,
    "descripcion":"ATRAPAMIENTO DE INTESTINO POR PERITONEO ESCLERÓTICO"
  },
  {
    "codigo":211272000,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN EL CODO"
  },
  {
    "codigo":735560004,
    "descripcion":"INFECCIÓN QUE CAUSA GRANULOMA DE LA MÉDULA ESPINAL"
  },
  {
    "codigo":702792005,
    "descripcion":"VÁRICES BUCALES"
  },
  {
    "codigo":309576006,
    "descripcion":"TUMORACIÓN EN MUSLO"
  },
  {
    "codigo":14664006,
    "descripcion":"QUEMADURA EPIDÉRMICA DE MANO"
  },
  {
    "codigo":45597001,
    "descripcion":"GRUPO SANGUÍNEO A>3<B"
  },
  {
    "codigo":1290781002,
    "descripcion":"OSTEOCONDRITIS DISECANTE DE HUESO DE TOBILLO"
  },
  {
    "codigo":1167368004,
    "descripcion":"HIPERTROFIA GINGIVAL EXACERBADA POR LA PUBERTAD"
  },
  {
    "codigo":109298000,
    "descripcion":"BURSITIS SUBAGUDA"
  },
  {
    "codigo":305906009,
    "descripcion":"ATENDIDO EN CONSULTORIO ESPECIALIZADO EN ATENCIÓN PRIMARIA DE LA SALUD"
  },
  {
    "codigo":240370009,
    "descripcion":"CRIPTOSPORIDIOSIS"
  },
  {
    "codigo":236700000,
    "descripcion":"EXTRAVASACIÓN DE ORINA DE LA URETRA"
  },
  {
    "codigo":402375009,
    "descripcion":"ENFERMEDAD DE CROHN DE LA VULVA"
  },
  {
    "codigo":72860003,
    "descripcion":"TRASTORNO DE LA CAVIDAD Y\/O MEMBRANA AMNIÓTICA"
  },
  {
    "codigo":1186972005,
    "descripcion":"CAPACIDAD VITAL FORZADA DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1285276005,
    "descripcion":"SIN RANGO ACTIVO DE FLEXIÓN PLANTAR DE TOBILLO"
  },
  {
    "codigo":171164006,
    "descripcion":"EXTENDIDO CERVICAL PENDIENTE"
  },
  {
    "codigo":202097001,
    "descripcion":"DESGARROS MÚLTIPLES DEL MENISCO EXTERNO"
  },
  {
    "codigo":38257001,
    "descripcion":"NACIMIENTO DE TÉRMINO DE GEMELOS MONOCIGÓTICOS, UNO VIVO, OTRO MUERTO"
  },
  {
    "codigo":62991000119101,
    "descripcion":"DEFECTO DE LA PARED ABDOMINAL FETAL"
  },
  {
    "codigo":365937004,
    "descripcion":"HALLAZGO RELACIONADO AL USO DE REFERENCIAS AL YO"
  },
  {
    "codigo":10630671000119101,
    "descripcion":"LINFANGITIS AGUDA DE MANO DERECHA"
  },
  {
    "codigo":726385006,
    "descripcion":"DELECIÓN DE PARTE DEL CROMOSOMA 14"
  },
  {
    "codigo":335221000119108,
    "descripcion":"ATROFIA ESENCIAL DE IRIS DERECHO"
  },
  {
    "codigo":265798000,
    "descripcion":"AUSENCIA CONGÉNITA COMPLETA DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":300401007,
    "descripcion":"HALLAZGO RELACIONADO CON EL CONTORNO ABDOMINAL"
  },
  {
    "codigo":298566003,
    "descripcion":"AMPLITUD DE ROTACIÓN ACTIVA HACIA LA IZQUIERDA DE LA COLUMNA VERTEBRAL DORSAL, DISMINUIDA"
  },
  {
    "codigo":724550005,
    "descripcion":"INSUFICIENCIA CARDÍACA NEONATAL DEBIDA A SOBREPERFUSIÓN PULMONAR"
  },
  {
    "codigo":1052230006,
    "descripcion":"SUPRESIÓN DE SEÑAL VISUAL"
  },
  {
    "codigo":36422005,
    "descripcion":"TRANSPOSICIÓN DE LAS VENAS PULMONARES"
  },
  {
    "codigo":165659002,
    "descripcion":"FOLATO EN SANGRE ENTERA POR DEBAJO DE RANGO DE REFERENCIA"
  },
  {
    "codigo":1148699004,
    "descripcion":"INFLAMACIÓN DE INTESTINO DELGADO CAUSADA POR CALICIVIRUS"
  },
  {
    "codigo":427803007,
    "descripcion":"FRACTURA NO EXPUESTA DE CUERPO ESCAPULAR"
  },
  {
    "codigo":360432000,
    "descripcion":"ENFERMEDAD POR CLORURO DE VINILO"
  },
  {
    "codigo":65520001,
    "descripcion":"HIPEROXALURIA PRIMARIA, TIPO I"
  },
  {
    "codigo":296731009,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE CEFPODOXIMA"
  },
  {
    "codigo":196592003,
    "descripcion":"MACROGLOSIA ADQUIRIDA"
  },
  {
    "codigo":131056005,
    "descripcion":"NIVEL DE 11-DESOXICORTICOSTERONA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":294896006,
    "descripcion":"ALERGIA A HIERRO SORBITOL"
  },
  {
    "codigo":308751000119106,
    "descripcion":"ENFERMEDAD GLOMERULAR DEBIDA A LUPUS ERITEMATOSO SISTÉMICO"
  },
  {
    "codigo":16037391000119107,
    "descripcion":"DETENCIÓN EPIFISARIA DE AMBOS HÚMEROS"
  },
  {
    "codigo":424133005,
    "descripcion":"MEDIDAS DE CONTROL DE INFECCIONES INADECUADAS"
  },
  {
    "codigo":260293006,
    "descripcion":"CUENTA LOS DEDOS - 1\/2 METRO"
  },
  {
    "codigo":719045009,
    "descripcion":"LEIOMIOMA DE ÓRBITA"
  },
  {
    "codigo":717210001,
    "descripcion":"PSEUDOMONAS ACIDOVORANS O PSEUDOMONAS TESTOSTERONI"
  },
  {
    "codigo":12105231000119109,
    "descripcion":"CONGELAMIENTO DE MANO DERECHA"
  },
  {
    "codigo":94618007,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA COLA DEL PÁNCREAS"
  },
  {
    "codigo":29082008,
    "descripcion":"RESPUESTA NORMAL AL ESTÍMULO DE NEURONA Y FIBRA NERVIOSA"
  },
  {
    "codigo":92783001,
    "descripcion":"CARCINOMA IN SITU DEL ORIFICIO URETERAL DE LA VEJIGA"
  },
  {
    "codigo":61850009,
    "descripcion":"ESTENOSIS DE LA VULVA"
  },
  {
    "codigo":15683241000119104,
    "descripcion":"BURSITIS INFRARROTULIANA BILATERAL"
  },
  {
    "codigo":782746009,
    "descripcion":"PARAPLEJÍA ESPÁSTICA AUTOSÓMICA RECESIVA TIPO 60"
  },
  {
    "codigo":289391006,
    "descripcion":"BOCA FETAL PALPABLE POR VÍA VAGINAL"
  },
  {
    "codigo":1010287007,
    "descripcion":"TRASTORNO NEONATAL DEBIDO A ENFERMEDAD CARDIOVASCULAR CRÓNICA MATERNA"
  },
  {
    "codigo":25412000,
    "descripcion":"MICROANEURISMA DE ARTERIA DE LA RETINA DEBIDO A DIABETES MELLITUS"
  },
  {
    "codigo":123716002,
    "descripcion":"CIRROSIS LATENTE"
  },
  {
    "codigo":189252004,
    "descripcion":"CARCINOMA IN SITU DEL CARTÍLAGO TIROIDES"
  },
  {
    "codigo":254788004,
    "descripcion":"ANGIOQUERATOMA CUTÁNEO"
  },
  {
    "codigo":10823491000119102,
    "descripcion":"FRACTURA ABIERTA EN MARTILLO DE FALANGE DISTAL DE DEDO MEÑIQUE DE MANO IZQUIERDA"
  },
  {
    "codigo":251118001,
    "descripcion":"PATRÓN LOWN-GANONG-LEVINE"
  },
  {
    "codigo":1332462002,
    "descripcion":"LESIÓN DE RAÍCES DE NERVIOS RAQUÍDEOS LUMBARES Y SACROS"
  },
  {
    "codigo":87278000,
    "descripcion":"HEMIANOPSIA BINASAL"
  },
  {
    "codigo":183747001,
    "descripcion":"CONSULTA DOMICILIARIA REUMATOLÓGICA, REALIZADA"
  },
  {
    "codigo":282051001,
    "descripcion":"LESIÓN TRAUMÁTICA DE ÍLEON"
  },
  {
    "codigo":52675005,
    "descripcion":"HIPOVITAMINOSIS K"
  },
  {
    "codigo":1363395005,
    "descripcion":"NEOVASCULARIZACIÓN DE CUADRANTE TEMPORAL DE ÁNGULO IRIDOCORNEAL DE OJO IZQUIERDO"
  },
  {
    "codigo":1197720000,
    "descripcion":"CONGESTIÓN HEPÁTICA PASIVA AGUDA"
  },
  {
    "codigo":312984006,
    "descripcion":"HEMORRAGIA UTERINA ANORMAL NO RELACIONADA CON EL CICLO MENSTRUAL"
  },
  {
    "codigo":704365001,
    "descripcion":"CON MAYOR RIESGO DE INSATISFACCIÓN CON ATENCIÓN SANITARIA"
  },
  {
    "codigo":16237004,
    "descripcion":"FLUCTUACIÓN"
  },
  {
    "codigo":1163117009,
    "descripcion":"COLITIS CAUSADA POR CHLAMYDIA"
  },
  {
    "codigo":702530001,
    "descripcion":"SOBREXTENSIÓN DE PRÓTESIS DENTAL PARCIAL REMOVIBLE"
  },
  {
    "codigo":211010006,
    "descripcion":"PICADURA DE INSECTO, NO VENENOSO, EN EL CUERO CABELLUDO"
  },
  {
    "codigo":276546007,
    "descripcion":"APNEA PROLONGADA DEL RECIÉN NACIDO"
  },
  {
    "codigo":473154008,
    "descripcion":"FRAGMENTO DE CATÉTER URETERAL RETENIDO"
  },
  {
    "codigo":1259586006,
    "descripcion":"DEMENCIA DEBIDA A ENCEFALITIS AUTOINMUNITARIA"
  },
  {
    "codigo":897303003,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE NARIZ CON INFECCIÓN"
  },
  {
    "codigo":373015006,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM BORSTELENSE"
  },
  {
    "codigo":305644002,
    "descripcion":"ATENDIDO POR ESPECIALISTA EN CUIDADOS INTENSIVOS"
  },
  {
    "codigo":240108006,
    "descripcion":"GANGRENA GASEOSA DE EXTREMIDAD"
  },
  {
    "codigo":762561000,
    "descripcion":"DERMATITIS ALÉRGICA POR CONTACTO OCUPACIONAL CAUSADA POR ACEITE DE CORTE"
  },
  {
    "codigo":1186710001,
    "descripcion":"LEUCOENCEFALOPATÍA CON CALCIFICACIONES Y QUISTES"
  },
  {
    "codigo":236438002,
    "descripcion":"NECROSIS PAPILAR CALCIFICANTE"
  },
  {
    "codigo":301974003,
    "descripcion":"HALLAZGO RELACIONADO CON LAS MEDICIONES DE LA SECRECIÓN LAGRIMAL"
  },
  {
    "codigo":269206003,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN PIE Y DEDO DEL PIE, INFECTADA"
  },
  {
    "codigo":860865009,
    "descripcion":"ENCEFALITIS CAUSADA POR TRYPANOSOMA BRUCEI GAMBIENSE"
  },
  {
    "codigo":367510009,
    "descripcion":"DESVIACIÓN CUBITAL"
  },
  {
    "codigo":365675002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CONSISTENCIA DEL ESPÉCIMEN"
  },
  {
    "codigo":16013431000119104,
    "descripcion":"CLAUDICACIÓN INTERMITENTE BILATERAL DE MIEMBROS INFERIORES DEBIDA A ATEROSCLEROSIS DE INJERTO-PUENTE NO BIOLÓGICO"
  },
  {
    "codigo":1217643005,
    "descripcion":"PARÁLISIS DE MIRADA HORIZONTAL CONGÉNITA AISLADA"
  },
  {
    "codigo":300139005,
    "descripcion":"HALLAZGO RELACIONADO CON LA APARIENCIA DE LA MEMBRANA TIMPÁNICA"
  },
  {
    "codigo":201835007,
    "descripcion":"ARTROSIS PRIMARIA LOCALIZADA, DE LA REGIÓN PÉLVICA Y MUSLO"
  },
  {
    "codigo":167232003,
    "descripcion":"ORINA=OSCURA\/CONCENTRADA"
  },
  {
    "codigo":298304004,
    "descripcion":"HALLAZGO RELACIONADO CON EL EQUILIBRIO"
  },
  {
    "codigo":12531000132101,
    "descripcion":"DISTENSIÓN DE DEDO DE PIE"
  },
  {
    "codigo":36160007,
    "descripcion":"CONTUSIÓN DE LOS ÓRGANOS GENITALES MASCULINOS"
  },
  {
    "codigo":67093004,
    "descripcion":"ERITROPOYESIS MEGALOBLÁSTICA"
  },
  {
    "codigo":15741201000119102,
    "descripcion":"GANGLIÓN DE CARA DORSAL DE AMBAS MUÑECAS"
  },
  {
    "codigo":722453009,
    "descripcion":"SÍNDROME DE MASTOCITOSIS CUTÁNEA, BAJA ESTATURA Y PÉRDIDA DE AUDICIÓN"
  },
  {
    "codigo":165397008,
    "descripcion":"HEMOGLOBINA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":455733521000119103,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE PIEL DE CABEZA Y\/O CUELLO"
  },
  {
    "codigo":425706005,
    "descripcion":"REACCIÓN DE RECONSTITUCIÓN INMUNOLÓGICA"
  },
  {
    "codigo":32490005,
    "descripcion":"ÚLCERA DUODENAL AGUDA SIN HEMORRAGIA Y SIN PERFORACIÓN"
  },
  {
    "codigo":391103005,
    "descripcion":"EVENTO ADVERSO POSTERIOR A TRATAMIENTO COMPLEMENTARIO"
  },
  {
    "codigo":292799005,
    "descripcion":"REACCIÓN ADVERSA A AGENTES ANTIINFECCIOSOS"
  },
  {
    "codigo":94356000,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE MAXILAR INFERIOR"
  },
  {
    "codigo":1306772001,
    "descripcion":"GLAUCOMA POR DEPÓSITO DE PARTÍCULAS DE CRISTALINO EN OJO DERECHO"
  },
  {
    "codigo":127124003,
    "descripcion":"LINFADENOPATÍA DE LA CURVATURA MENOR DEL ESTÓMAGO"
  },
  {
    "codigo":340241000119106,
    "descripcion":"CORIORRETINITIS FOCAL YUXTAPAPILAR DE OJO IZQUIERDO"
  },
  {
    "codigo":15632811000119100,
    "descripcion":"ATROFIA ÓPTICA DEL OJO DERECHO"
  },
  {
    "codigo":389268008,
    "descripcion":"ESPONDILOENCONDROMATOSIS"
  },
  {
    "codigo":290964009,
    "descripcion":"INTOXICACIÓN POR VIGABATRINA"
  },
  {
    "codigo":28820008,
    "descripcion":"SECUENCIA DE AMINOÁCIDOS"
  },
  {
    "codigo":59753003,
    "descripcion":"DISTROFIA COROIDEA PERIPAPILAR TOTAL"
  },
  {
    "codigo":192660009,
    "descripcion":"MENINGITIS POR PSEUDOMONAS"
  },
  {
    "codigo":289129005,
    "descripcion":"CAPAZ DE REALIZAR ACTIVIDADES PARA EL CUIDADO DEL PELO"
  },
  {
    "codigo":715113008,
    "descripcion":"SE TRANSFIERE DE LA CAMA A LA SILLA"
  },
  {
    "codigo":156222001,
    "descripcion":"CORDÓN UMBILICAL CORTO"
  },
  {
    "codigo":713278001,
    "descripcion":"NEURALGIA CONCOMITANTE CON INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":254526000,
    "descripcion":"NEOPLASIA MALIGNA DE VENTRÍCULO LARÍNGEO"
  },
  {
    "codigo":1237566006,
    "descripcion":"VENA VARICOSA DE REGIÓN DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":1335870008,
    "descripcion":"ICTERICIA NEONATAL PRECOZ DEBIDA A SANGRADO"
  },
  {
    "codigo":188990009,
    "descripcion":"LIPOMA DE PIEL Y TEJIDO CELULAR SUBCUTÁNEO (EXCEPTO CARA)"
  },
  {
    "codigo":57918009,
    "descripcion":"JANICÉFALO"
  },
  {
    "codigo":23315001,
    "descripcion":"SECUOIOSIS"
  },
  {
    "codigo":285459002,
    "descripcion":"DIFICULTAD PARA ABRIR Y CERRAR LA BOCA"
  },
  {
    "codigo":47211000087101,
    "descripcion":"DISTENSIÓN DE TENDÓN DE MÚSCULO SUBESCAPULAR DE HOMBRO DERECHO"
  },
  {
    "codigo":711443006,
    "descripcion":"AFASIA DEBIDA A DAÑO CEREBRAL"
  },
  {
    "codigo":39531000087100,
    "descripcion":"DISTENSIÓN DE TENDÓN EXTENSOR DE REGIÓN DE MUÑECA DERECHA"
  },
  {
    "codigo":42091000087102,
    "descripcion":"CONTUSIÓN SUPRAORBITARIA DERECHA"
  },
  {
    "codigo":1268499002,
    "descripcion":"CARCINOMA PRIMARIO DE CONDUCTO COLECTOR DE RIÑÓN"
  },
  {
    "codigo":447464004,
    "descripcion":"LESIÓN TRAUMÁTICA COMPLETA DE MÉDULA ESPINAL A NIVEL DE D7 A D12"
  },
  {
    "codigo":283624005,
    "descripcion":"HERIDA POR PINCHAZO DE AGUJA EN LA MAMA"
  },
  {
    "codigo":314557000,
    "descripcion":"QUERATITIS BACTERIANA"
  },
  {
    "codigo":21480008,
    "descripcion":"BLEFAROFIMOSIS ADQUIRIDA"
  },
  {
    "codigo":871613001,
    "descripcion":"TOPOLOGÍA VENTRICULAR DE MANO DERECHA"
  },
  {
    "codigo":840680009,
    "descripcion":"INFARTO AGUDO DE MIOCARDIO CON ELEVACIÓN DEL SEGMENTO ST DEBIDO A OCLUSIÓN DE RAMA SEPTAL DE RAMA DESCENDIENTE ANTERIOR DE ARTERIA CORONARIA IZQUIERDA"
  },
  {
    "codigo":52413004,
    "descripcion":"ANEMIA HEMOLÍTICA NO ESFEROCÍTICA HEREDITARIA POR DEFICIENCIA DE GLUCOSA FOSFATO ISOMERASA"
  },
  {
    "codigo":779100741000119102,
    "descripcion":"ÚLCERA VENOSA DE MUSLO DERECHO"
  },
  {
    "codigo":609469009,
    "descripcion":"INTERRUPCIÓN INDUCIDA DEL EMBARAZO COMPLICADA POR LACERACIÓN DE CUELLO UTERINO"
  },
  {
    "codigo":312722002,
    "descripcion":"DEPRESIÓN POR LÁSER YAG EN LENTE INTRAOCULAR"
  },
  {
    "codigo":1363133009,
    "descripcion":"ASTILLA EN REGIÓN INTERESCAPULAR"
  },
  {
    "codigo":17810004,
    "descripcion":"TROMBOSIS CAPILAR"
  },
  {
    "codigo":771474005,
    "descripcion":"ADENOCARCINOMA GÁSTRICO Y POLIPOSIS PROXIMAL DE ESTÓMAGO"
  },
  {
    "codigo":10963371000119109,
    "descripcion":"LACERACIÓN DEL DEDO ÍNDICE IZQUIERDO"
  },
  {
    "codigo":15975000,
    "descripcion":"INTOXICACIÓN POR ECHIUM LYCOPIS"
  },
  {
    "codigo":247186009,
    "descripcion":"RETINA PERIFÉRICA - BLANCA SIN PRESIÓN"
  },
  {
    "codigo":83346009,
    "descripcion":"DIETA PARA LACTANTES DE 5 A 7 MESES: CEREAL"
  },
  {
    "codigo":294536000,
    "descripcion":"ALERGIA A CEFALOTINA"
  },
  {
    "codigo":1162855005,
    "descripcion":"CARCINOMA DE VESÍCULA BILIAR Y VÍA BILIAR EXTRAHEPÁTICA"
  },
  {
    "codigo":81511006,
    "descripcion":"PROBLEMA BÁSICO PARA EL APRENDIZAJE DEL LENGUAJE"
  },
  {
    "codigo":276284000,
    "descripcion":"HEMORRAGIA SUBARACNOIDEA PROVENIENTE DE ANEURISMA DE LA ARTERIA BASILAR"
  },
  {
    "codigo":866108003,
    "descripcion":"INESTABILIDAD DE COLUMNA VERTEBRAL DEBIDA A DEGENERACIÓN DE COLUMNA VERTEBRAL"
  },
  {
    "codigo":1259324005,
    "descripcion":"CARCINOMA PRIMARIO DE BORDE BERMELLÓN DE LABIO INFERIOR"
  },
  {
    "codigo":14140009,
    "descripcion":"HIPERCALIEMIA"
  },
  {
    "codigo":342751000119101,
    "descripcion":"CEGUERA CORTICAL DEL LADO IZQUIERDO DEL CEREBRO"
  },
  {
    "codigo":698598000,
    "descripcion":"ECOGENICIDAD DEL INTESTINO FETAL EN LA ECOGRAFÍA OBSTÉTRICA"
  },
  {
    "codigo":1255654002,
    "descripcion":"CARCINOMA DE CÉLULAS GIGANTES DE LARINGE"
  },
  {
    "codigo":123461000119109,
    "descripcion":"HIPOTERMIA NO ASOCIADA CON TEMPERATURA AMBIENTAL BAJA"
  },
  {
    "codigo":403686005,
    "descripcion":"CICATRIZ QUIRÚRGICA QUELOIDE"
  },
  {
    "codigo":239846006,
    "descripcion":"GOTA CAUSADA POR PLOMO"
  },
  {
    "codigo":860603002,
    "descripcion":"HERIDA DE EPISIOTOMÍA"
  },
  {
    "codigo":1080031000119104,
    "descripcion":"SARCOMA DE EWING PRIMARIO DE OMÓPLATO IZQUIERDO"
  },
  {
    "codigo":238011005,
    "descripcion":"DEFICIENCIA DE LA PIROFOSFOHIDROLASA DE INOSINA TRIFOSFATO"
  },
  {
    "codigo":8635005,
    "descripcion":"DELIRIUM POR ABSTINENCIA DE ALCOHOL"
  },
  {
    "codigo":762299008,
    "descripcion":"MIELOPATÍA DEBIDA A TOXICIDAD DE UNA SUSTANCIA"
  },
  {
    "codigo":203408003,
    "descripcion":"OSTEOCONDRITIS DISECANTE DE CÓNDILO HUMERAL"
  },
  {
    "codigo":6800004,
    "descripcion":"ANTÍGENO DE GRUPO SANGUÍNEO E^U^"
  },
  {
    "codigo":201573002,
    "descripcion":"ARTRITIS REACTIVA DE ARTICULACIÓN ASTRAGALONAVICULAR"
  },
  {
    "codigo":398181004,
    "descripcion":"CRITERIOS DE MUERTE DEL TRONCO ENCEFÁLICO CUMPLIDOS LUEGO DEL PRIMER EXAMEN"
  },
  {
    "codigo":234341005,
    "descripcion":"MACROCITOSIS RELACIONADA CON EL ALCOHOL"
  },
  {
    "codigo":103269006,
    "descripcion":"INTOLERANCIA A LAS LENTES DE CONTACTO"
  },
  {
    "codigo":299877005,
    "descripcion":"REFLEJO AQUÍLEO PRESENTE SÓLO CON REFUERZO"
  },
  {
    "codigo":199738000,
    "descripcion":"HALLAZGO CROMOSÓMICO Y GENÉTICO ANORMAL EN EL CRIBADO MATERNO PRENATAL"
  },
  {
    "codigo":1217381009,
    "descripcion":"SÍNDROME DE RETRASO DE NEURODESARROLLO, CONVULSIONES, ANOMALÍAS OFTALMOLÓGICAS, OSTEOPENIA Y ATROFIA CEREBELOSA"
  },
  {
    "codigo":789562001,
    "descripcion":"ÚLCERA DE TALÓN DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":68666001,
    "descripcion":"FÍSTULA DE VEJIGA URINARIA"
  },
  {
    "codigo":365413008,
    "descripcion":"ONDA R ELECTROCARDIOGRÁFICA - HALLAZGO"
  },
  {
    "codigo":1184613006,
    "descripcion":"REACCIÓN ADVERSA A PLASMA CONVALECIENTE"
  },
  {
    "codigo":10965881000119103,
    "descripcion":"HERIDA PUNZANTE DE DEDO DE PIE IZQUIERDO"
  },
  {
    "codigo":429114002,
    "descripcion":"NEOPLASIA MALIGNA BASOCELULAR DE PIEL"
  },
  {
    "codigo":461882008,
    "descripcion":"DISPLASIA DE GLOTIS"
  },
  {
    "codigo":722191003,
    "descripcion":"VASCULITIS POSITIVA PARA ANTICUERPOS ANTICITOPLASMA DE NEUTRÓFILOS"
  },
  {
    "codigo":230671004,
    "descripcion":"DEFICIENCIA DE LA RESÍNTESIS DE ACETILCOLINA"
  },
  {
    "codigo":197903003,
    "descripcion":"URETRITIS CANDIDIÁSICA"
  },
  {
    "codigo":34063005,
    "descripcion":"HEMIANOPSIA HOMÓNIMA"
  },
  {
    "codigo":296207003,
    "descripcion":"SOBREDOSIS INTENCIONAL DE LEVOMEPROMAZINA"
  },
  {
    "codigo":64996003,
    "descripcion":"SANGRADO INTERMENSTRUAL IRREGULAR"
  },
  {
    "codigo":294372006,
    "descripcion":"ALERGIA A DIDANOSINA"
  },
  {
    "codigo":1144505000,
    "descripcion":"DESEO URGENTE DE RESPIRAR PROFUNDAMENTE"
  },
  {
    "codigo":95929000,
    "descripcion":"ANCIANO VÍCTIMA DE ABUSO PSICOLÓGICO"
  },
  {
    "codigo":1471781000168106,
    "descripcion":"SE SIENTE INSEGURO EN EL VECINDARIO"
  },
  {
    "codigo":11785081000119107,
    "descripcion":"AMPOLLA TRAUMÁTICA DE DEDO MEDIO IZQUIERDO"
  },
  {
    "codigo":292537008,
    "descripcion":"REACCIÓN ADVERSA AL CICLOPENTOLATO"
  },
  {
    "codigo":290702003,
    "descripcion":"INTOXICACIÓN POR ETOPÓSIDO"
  },
  {
    "codigo":126862005,
    "descripcion":"NEOPLASIA DE LA COLA DEL PÁNCREAS"
  },
  {
    "codigo":94094007,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL TERCER HUESO CUNEIFORME DEL TARSO"
  },
  {
    "codigo":714851000,
    "descripcion":"INCAPAZ DE ADMINISTRARSE MEDICACIÓN PARENTERAL"
  },
  {
    "codigo":288867002,
    "descripcion":"BEBE CON UN SORBETE"
  },
  {
    "codigo":92259008,
    "descripcion":"NEOPLASIA BENIGNA DE LA OROFARINGE"
  },
  {
    "codigo":188728002,
    "descripcion":"LEUCEMIA LINFOIDE ALEUCÉMICA"
  },
  {
    "codigo":254264002,
    "descripcion":"TRISOMÍA PARCIAL DEL CROMOSOMA 21 EN EL SÍNDROME DE DOWN"
  },
  {
    "codigo":1237304005,
    "descripcion":"ARTROFIBROSIS DE ARTICULACIÓN DE MUÑECA"
  },
  {
    "codigo":440771000124101,
    "descripcion":"INGESTA EXCESIVA DE BIOTINA"
  },
  {
    "codigo":5571000124103,
    "descripcion":"ACCIDENTE CEREBROVASCULAR CON HEMORRAGIA INTRACRANEAL"
  },
  {
    "codigo":876856005,
    "descripcion":"ESTENOSIS DE LA ARTERIA CORONARIA DERECHA"
  },
  {
    "codigo":449037002,
    "descripcion":"VÁLVULA TRONCAL CABALGADA SOBRE EL TABIQUE INTERVENTRICULAR"
  },
  {
    "codigo":186893003,
    "descripcion":"RUPTURA DE ANEURISMA CEREBRAL SIFILÍTICO"
  },
  {
    "codigo":451000124109,
    "descripcion":"AUMENTO DEL FLUJO SANGUÍNEO EN HEMODIÁLISIS"
  },
  {
    "codigo":55821006,
    "descripcion":"SÍNDROME DE HAY - WELLS DE DISPLASIA ECTODÉRMICA"
  },
  {
    "codigo":285197006,
    "descripcion":"INCAPAZ DE RECORDAR EL AÑO ACTUAL"
  },
  {
    "codigo":345261000119102,
    "descripcion":"DRUSAS DE AMBAS MÁCULAS"
  },
  {
    "codigo":283362001,
    "descripcion":"LACERACIÓN EN LA MEJILLA"
  },
  {
    "codigo":119522002,
    "descripcion":"TRASTORNO DEL INTESTINO DELGADO"
  },
  {
    "codigo":281527002,
    "descripcion":"FRACTURA DE APÓFISIS ESTILOIDES DE RADIO"
  },
  {
    "codigo":248759003,
    "descripcion":"RELACIÓN SEXUAL DIFICULTOSA"
  },
  {
    "codigo":1297335002,
    "descripcion":"CIERRE DE ÁNGULO AGUDO POSOPERATORIO DE OJO DERECHO"
  },
  {
    "codigo":707511009,
    "descripcion":"ASMA LEVE PERSISTENTE NO COMPLICADA"
  },
  {
    "codigo":246924004,
    "descripcion":"HALLAZGO CORNEAL"
  },
  {
    "codigo":1295500004,
    "descripcion":"HIPERTENSIÓN OCULAR SECUNDARIA DE OJO DERECHO"
  },
  {
    "codigo":115852007,
    "descripcion":"FENOTIPO CO (A- B-)"
  },
  {
    "codigo":441697004,
    "descripcion":"TROMBOFILIA ASOCIADA CON EMBARAZO"
  },
  {
    "codigo":1162593007,
    "descripcion":"FILTRACIÓN POSQUIRÚRGICA DE HERIDA QUIRÚRGICA DE ESCLERÓTICA"
  },
  {
    "codigo":212321008,
    "descripcion":"LESIÓN EXPUESTA DE NERVIO CIÁTICO POPLÍTEO EXTERNO"
  },
  {
    "codigo":1259062000,
    "descripcion":"TOXICIDAD AGUDA DE CEREBRO DEBIDA A RADIOTERAPIA DE CEREBRO Y POSTERIOR A ELLA"
  },
  {
    "codigo":439862003,
    "descripcion":"HEMATOMA CAUSADO POR MARCAPASOS CARDÍACO"
  },
  {
    "codigo":79414005,
    "descripcion":"DISTOCIA DEL ANILLO DE BANDL"
  },
  {
    "codigo":44811000,
    "descripcion":"AMENORREA FISIOLÓGICA"
  },
  {
    "codigo":274187003,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DEL TÓRAX"
  },
  {
    "codigo":403424000,
    "descripcion":"LIPOGRANULOMA ESCLEROSANTE IDIOPÁTICO"
  },
  {
    "codigo":896779009,
    "descripcion":"FORMA ANCHA ANORMAL CONGÉNITA DE FALANGE DE TERCER DEDO DE PIE"
  },
  {
    "codigo":1255392007,
    "descripcion":"CARCINOMA INDIFERENCIADO DE TRÁQUEA"
  },
  {
    "codigo":303285004,
    "descripcion":"EQUIMOSIS DEL PALADAR"
  },
  {
    "codigo":237749004,
    "descripcion":"SÍNDROME ADRENOGENITAL - VIRILIZACIÓN"
  },
  {
    "codigo":270517006,
    "descripcion":"RIÑÓN TRIPLE CON PELVIS TRIPLE"
  },
  {
    "codigo":1153418005,
    "descripcion":"TRANSFORMACIÓN NODULAR ANGIOMATOIDE ESCLEROSANTE DE BAZO"
  },
  {
    "codigo":39306006,
    "descripcion":"TUBERCULOSIS DEL ANO"
  },
  {
    "codigo":301450007,
    "descripcion":"CAPAZ DE REALIZAR ACTIVIDADES EDUCATIVAS"
  },
  {
    "codigo":72074009,
    "descripcion":"INFECCIÓN CAUSADA POR TRICHOSTRONGYLUS ORIENTALIS"
  },
  {
    "codigo":103007003,
    "descripcion":"CEFALEA POR COMPRESIÓN EXTERNA DE LA CABEZA"
  },
  {
    "codigo":365151003,
    "descripcion":"CAPACIDAD DE EMOCIONARSE - HALLAZGO"
  },
  {
    "codigo":201311005,
    "descripcion":"CICATRIZ QUIRÚRGICA DOLOROSA"
  },
  {
    "codigo":299615006,
    "descripcion":"SIN AMPLITUD PASIVA DE ABDUCCIÓN DE DEDO DEL PIE"
  },
  {
    "codigo":37471005,
    "descripcion":"NEUMONITIS POR HIPERSENSIBILIDAD"
  },
  {
    "codigo":15693281000119105,
    "descripcion":"QUERATITIS DE OJO DERECHO CAUSADA POR ACANTHAMOEBA"
  },
  {
    "codigo":234079009,
    "descripcion":"RUPTURA DE LA VENA TRASPLANTADA"
  },
  {
    "codigo":164873001,
    "descripcion":"HIPERTROFIA DE VENTRÍCULO IZQUIERDO EN EL ELECTROCARDIOGRAMA"
  },
  {
    "codigo":295945001,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE MAPROTILINA"
  },
  {
    "codigo":66569006,
    "descripcion":"RAÍZ DENTAL RETENIDA"
  },
  {
    "codigo":292321000119108,
    "descripcion":"INFLAMACIÓN DE NERVIO SAFENO DERECHO"
  },
  {
    "codigo":1033009,
    "descripcion":"ARTRITIS TORÁCICA"
  },
  {
    "codigo":359646002,
    "descripcion":"LISTERIOSIS DISEMINADA NEONATAL"
  },
  {
    "codigo":263177009,
    "descripcion":"FRACTURA BILATERAL DE LA CABEZA DEL CÓNDILO Y FRACTURA MEDIAL DE LA MANDÍBULA"
  },
  {
    "codigo":15638021000119100,
    "descripcion":"LINFEDEMA DE MIEMBRO SUPERIOR DERECHO"
  },
  {
    "codigo":12207621000119100,
    "descripcion":"INFECCIÓN DE HÚMERO DERECHO ASOCIADA CON DISPOSITIVO DE FIJACIÓN INTERNA"
  },
  {
    "codigo":16846341000119101,
    "descripcion":"ESTENOSIS DE ARTERIA CELÍACA"
  },
  {
    "codigo":1074181000119103,
    "descripcion":"CONDROCALCINOSIS DE TOBILLO DERECHO"
  },
  {
    "codigo":306181000119104,
    "descripcion":"GOTA CRÓNICA DE MANO, SIN TOFO, CAUSADA POR FÁRMACO"
  },
  {
    "codigo":16477701000119105,
    "descripcion":"DISECCIÓN DE ARTERIA CELÍACA"
  },
  {
    "codigo":1177011007,
    "descripcion":"INFECCIÓN DE NERVIO CAUSADA POR FUNGI"
  },
  {
    "codigo":10756101000119107,
    "descripcion":"INFECCIÓN POR ESTREPTOCOCO DEL GRUPO B EN LA MADRE QUE COMPLICA EL NACIMIENTO"
  },
  {
    "codigo":1079301000119108,
    "descripcion":"NEOPLASIA BENIGNA DE HUESO DE MIEMBRO INFERIOR DERECHO"
  },
  {
    "codigo":10850821000119108,
    "descripcion":"ALIMENTO ASPIRADO EN NASOFARINGE"
  },
  {
    "codigo":15934981000119109,
    "descripcion":"SUPERPOSICIÓN ADQUIRIDA DE DEDOS DE PIE DERECHO"
  },
  {
    "codigo":292275009,
    "descripcion":"REACCIÓN ADVERSA A FÁRMACO ANTIDEPRESIVO"
  },
  {
    "codigo":1339016002,
    "descripcion":"TRASTORNO DE ESCLERÓTICA CAUSADO POR RADIACIÓN"
  },
  {
    "codigo":1089541000119108,
    "descripcion":"COLESTEATOMA RECURRENTE DE CAVIDAD MASTOIDEA IZQUIERDA"
  },
  {
    "codigo":15929861000119106,
    "descripcion":"EDEMA POR ESTASIS VENOSA DE AMBOS MIEMBROS INFERIORES"
  },
  {
    "codigo":12202501000119106,
    "descripcion":"OLIGURIA DESPUÉS DE PROCEDIMIENTO"
  },
  {
    "codigo":15927301000119109,
    "descripcion":"PORTADOR DE VIRUS LINFOTRÓPICO DE CÉLULAS T HUMANO TIPO 1"
  },
  {
    "codigo":288605005,
    "descripcion":"INCAPAZ DE EMPLEAR LOS ELEMENTOS DEL LENGUAJE"
  },
  {
    "codigo":59229005,
    "descripcion":"PORFIRIA CUTÁNEA TARDÍA FAMILIAR"
  },
  {
    "codigo":91997004,
    "descripcion":"NEOPLASIA BENIGNA DE VASO SANGUÍNEO DE LA CARA"
  },
  {
    "codigo":716424007,
    "descripcion":"CAPAZ DE MOVILIZARSE SOBRE TERRENO DESIGUAL"
  },
  {
    "codigo":286770000,
    "descripcion":"TRABAJADOR PROMEDIO - RASGO DEL CARÁCTER"
  },
  {
    "codigo":254002005,
    "descripcion":"FISURA INCOMPLETA DE PALADAR BLANDO"
  },
  {
    "codigo":90162006,
    "descripcion":"SIRINGOPONTIA"
  },
  {
    "codigo":10807061000119103,
    "descripcion":"TRASTORNO HEPÁTICO EN LA MADRE QUE COMPLICA EL NACIMIENTO"
  },
  {
    "codigo":1237042007,
    "descripcion":"METÁSTASIS DE CARCINOMA DE ANTRO PILÓRICO"
  },
  {
    "codigo":448775003,
    "descripcion":"SARCOMA DE RADIO"
  },
  {
    "codigo":284935008,
    "descripcion":"NO ADAPTA ROPA PARA EL BAÑO"
  },
  {
    "codigo":283100001,
    "descripcion":"ARAÑAZO DE CADERA"
  },
  {
    "codigo":86492004,
    "descripcion":"TRASTORNO CORTICAL VISUAL"
  },
  {
    "codigo":446940004,
    "descripcion":"QUISTE EPENDIMARIO DE MÉDULA ESPINAL"
  },
  {
    "codigo":53724006,
    "descripcion":"RECRUDECIMIENTO SEXUAL EN EL ANCIANO"
  },
  {
    "codigo":838321000,
    "descripcion":"GANGLIONOPATÍA AUTONÓMICA"
  },
  {
    "codigo":414172008,
    "descripcion":"COMPRESIÓN EXTRÍNSECA DE ESTÓMAGO"
  },
  {
    "codigo":248497002,
    "descripcion":"VENAS DE LA PARED ABDOMINAL DILATADAS"
  },
  {
    "codigo":215729003,
    "descripcion":"LESIÓN SUFRIDA A BORDO DE MEDIO DE TRANSPORTE ACUÁTICO CAUSADA POR MAQUINARIA DE CARGA, OCUPANTE DE PEQUEÑA EMBARCACIÓN NO MOTORIZADA LESIONADO"
  },
  {
    "codigo":281265005,
    "descripcion":"ESPÉCIMEN INCORRECTAMENTE ROTULADO"
  },
  {
    "codigo":445105005,
    "descripcion":"NEOPLASIA DE CÉLULAS DENDRÍTICAS PLASMOCITOIDES BLÁSTICAS"
  },
  {
    "codigo":314033007,
    "descripcion":"GLAUCOMA UVEÍTICO"
  },
  {
    "codigo":1264305006,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE DEDO MEDIO DE MANO CON INFECCIÓN"
  },
  {
    "codigo":1297073009,
    "descripcion":"POLIURIA ADÍPSICA RELACIONADA CON ARGININA VASOPRESINA"
  },
  {
    "codigo":836486002,
    "descripcion":"INFILTRADO LINFOMATOSO DE RIÑÓN"
  },
  {
    "codigo":707249009,
    "descripcion":"LIQUEN PLANO BUCAL RETICULAR"
  },
  {
    "codigo":246662004,
    "descripcion":"ESCOTOMA ALTITUDINAL"
  },
  {
    "codigo":410502007,
    "descripcion":"ARTRITIS IDIOPÁTICA JUVENIL"
  },
  {
    "codigo":310363000,
    "descripcion":"SITUACIÓN DE INFORME LABORAL"
  },
  {
    "codigo":408667000,
    "descripcion":"HIPOTENSIÓN ASOCIADA CON HEMODIÁLISIS"
  },
  {
    "codigo":1162331006,
    "descripcion":"ESPONDILOARTRITIS VIRAL"
  },
  {
    "codigo":79152002,
    "descripcion":"MIOCARDIOPATÍA DILATADA DEBIDA A TRASTORNO NEUROMUSCULAR"
  },
  {
    "codigo":111920004,
    "descripcion":"INFECCIÓN CAUSADA POR SCHISTOSOMA BOVIS"
  },
  {
    "codigo":242992007,
    "descripcion":"PUNCIÓN ACCIDENTAL DURANTE UN PROCEDIMIENTO"
  },
  {
    "codigo":13616008,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DEL OJO Y\/O DE LOS ANEXOS OCULARES"
  },
  {
    "codigo":110085003,
    "descripcion":"LACERACIÓN SIMPLE CONTAMINADA DE LA LENGUA"
  },
  {
    "codigo":11781007,
    "descripcion":"ANEMIA HEMOLÍTICA AUTOINMUNITARIA CAUSADA POR COMPLEMENTO"
  },
  {
    "codigo":44549008,
    "descripcion":"NEUMONÍA POR ASPIRACIÓN POSTERIOR A PROCEDIMIENTO"
  },
  {
    "codigo":10999881000119102,
    "descripcion":"PRÓTESIS EN MAMA IZQUIERDA IN SITU"
  },
  {
    "codigo":206554002,
    "descripcion":"INFECCIÓN CUTÁNEA NEONATAL"
  },
  {
    "codigo":1156826003,
    "descripcion":"ENCEFALOPATÍA INFANTIL POR GLICINA"
  },
  {
    "codigo":1255130006,
    "descripcion":"QUEMADURA QUÍMICA DE DEDO DE PIE"
  },
  {
    "codigo":15669321000119104,
    "descripcion":"AUSENCIA CONGÉNITA DE EXTREMIDAD INFERIOR DERECHA"
  },
  {
    "codigo":366724000,
    "descripcion":"GRADO DE FUERZA MUSCULAR DEL CONSEJO DE INVESTIGACIÓN MÉDICA - HALLAZGO"
  },
  {
    "codigo":202884002,
    "descripcion":"PELLIZCAMIENTO DE REGIÓN ANTERIOR DE TOBILLO"
  },
  {
    "codigo":6276003,
    "descripcion":"BIORRITMO INFRADIANO ANORMAL"
  },
  {
    "codigo":301188003,
    "descripcion":"HALLAZGO RELACIONADO CON EL TAMAÑO DE LA NARIZ"
  },
  {
    "codigo":677961000119106,
    "descripcion":"AGUJERO MACULAR DE ESPESOR COMPLETO DE OJO DERECHO"
  },
  {
    "codigo":1251460002,
    "descripcion":"METÁSTASIS DE NEUROBLASTOMA EN PELVIS"
  },
  {
    "codigo":235652004,
    "descripcion":"EROSIONES GÁSTRICAS MÚLTIPLES"
  },
  {
    "codigo":4441000,
    "descripcion":"TRASTORNO BIPOLAR GRAVE CON SÍNTOMAS PSICÓTICOS"
  },
  {
    "codigo":364889001,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA EMPUJAR Y TIRAR UN JUGUETE PEQUEÑO CON RUEDAS HACIA ADELANTE"
  },
  {
    "codigo":201049004,
    "descripcion":"MORFEA"
  },
  {
    "codigo":233817007,
    "descripcion":"ENFERMEDAD VASCULAR TRIPLE DEL CORAZÓN"
  },
  {
    "codigo":104521000119108,
    "descripcion":"QUERATOPATÍA MEDICAMENTOSA"
  },
  {
    "codigo":1149486001,
    "descripcion":"SEPSIS CAUSADA POR PROTEUS"
  },
  {
    "codigo":299353009,
    "descripcion":"AMPLITUD DE EXTENSIÓN PASIVA DE LA RODILLA DISMINUIDA"
  },
  {
    "codigo":723502001,
    "descripcion":"DISTROFIA RETICULAR DE EPITELIO PIGMENTARIO DE LA RETINA"
  },
  {
    "codigo":363054006,
    "descripcion":"TRASTORNO DEGENERATIVO DE HUESO"
  },
  {
    "codigo":2606006,
    "descripcion":"FORÚNCULO DEL PERINEO"
  },
  {
    "codigo":68142008,
    "descripcion":"CONTUSIÓN DE LA EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":166446009,
    "descripcion":"NIVEL SÉRICO DE 17 - B - ESTRADIOL DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":262915002,
    "descripcion":"RUPTURA TOTAL DE URETRA MASCULINA"
  },
  {
    "codigo":66307007,
    "descripcion":"TRASTORNO DE CONDUCTA, TIPO GRUPAL"
  },
  {
    "codigo":721667008,
    "descripcion":"PÓLIPO FIBROIDE INFLAMATORIO DE INTESTINO DELGADO"
  },
  {
    "codigo":293848001,
    "descripcion":"ALERGIA A NEFAZODONA"
  },
  {
    "codigo":424920003,
    "descripcion":"SISTEMA PARA TOMA DE MEDICACIÓN INADECUADO"
  },
  {
    "codigo":228312003,
    "descripcion":"TOMA CANTIDADES SIMILARES DE ALCOHOL DURANTE LA SEMANA"
  },
  {
    "codigo":31704005,
    "descripcion":"CICATRICES HEMORROIDALES RESIDUALES"
  },
  {
    "codigo":95405000,
    "descripcion":"REACCIÓN EN EL SITIO DE IMPLANTE"
  },
  {
    "codigo":160941000,
    "descripcion":"TELÉFONO EN EL HOGAR"
  },
  {
    "codigo":880002001,
    "descripcion":"DILATACIÓN ADQUIRIDA DE VENTRÍCULO CARDÍACO IZQUIERDO"
  },
  {
    "codigo":193709009,
    "descripcion":"CEGUERA BILATERAL ADQUIRIDA"
  },
  {
    "codigo":93570005,
    "descripcion":"OSIFICACIÓN INCOMPLETA DEL CALCÁNEO"
  },
  {
    "codigo":157271002,
    "descripcion":"LUXACIÓN DE TOBILLO"
  },
  {
    "codigo":288343002,
    "descripcion":"CAPAZ DE TRANSPORTAR UN OBJETO"
  },
  {
    "codigo":124503005,
    "descripcion":"DEFICIENCIA DE QUIMOSINA"
  },
  {
    "codigo":188204000,
    "descripcion":"NEOPLASIA MALIGNA DEL LIGAMENTO REDONDO"
  },
  {
    "codigo":417580004,
    "descripcion":"FRACTURA-LUXACIÓN EXPUESTA DE DEDO DE LA MANO"
  },
  {
    "codigo":1090071000119100,
    "descripcion":"EDENTULISMO PARCIAL CLASE II DEBIDO A CARIES"
  },
  {
    "codigo":253740007,
    "descripcion":"MALFORMACIÓN CONGÉNITA DE TRÁQUEA Y BRONQUIOS"
  },
  {
    "codigo":778028008,
    "descripcion":"INMUNODEFICIENCIA DEBIDA A DEFICIENCIA DE CD25"
  },
  {
    "codigo":286508009,
    "descripcion":"CAPAZ DE SEGUIR LAS INSTRUCCIONES DE UNA RECETA"
  },
  {
    "codigo":315606000,
    "descripcion":"COLON OCUPADO"
  },
  {
    "codigo":15999511000119103,
    "descripcion":"TRASTORNO DEL OJO DERECHO POSTERIOR A CIRUGÍA DE CATARATAS"
  },
  {
    "codigo":282838005,
    "descripcion":"INCAPAZ DE MOVERSE DE UNA POSICIÓN"
  },
  {
    "codigo":250070007,
    "descripcion":"SENSACIÓN DE TENSIÓN FÍSICA"
  },
  {
    "codigo":53462005,
    "descripcion":"HERNIA INGUINAL BILATERAL RECURRENTE CON GANGRENA"
  },
  {
    "codigo":1231275001,
    "descripcion":"MIDRIASIS EPISÓDICA DEBIDA A HIPERACTIVIDAD SIMPÁTICA"
  },
  {
    "codigo":1264043002,
    "descripcion":"ERUPCIÓN DE PIEL DE PENE"
  },
  {
    "codigo":706987004,
    "descripcion":"DERMATITIS POR FLAGELADOS"
  },
  {
    "codigo":281003006,
    "descripcion":"ATAQUE DE AHOGO POR COMPRESIÓN LARÍNGEA O TRAQUEAL"
  },
  {
    "codigo":10674711000119105,
    "descripcion":"EXACERBACIÓN SEVERA AGUDA DE ASMA CONCOMITANTE CON RINITIS ALÉRGICA"
  },
  {
    "codigo":17024001,
    "descripcion":"VENTANA AORTOPULMONAR"
  },
  {
    "codigo":82560004,
    "descripcion":"INSUFICIENCIA DE LAS CÉLULAS DE LEYDIG EN EL ADULTO"
  },
  {
    "codigo":277333006,
    "descripcion":"QUISTE DEL SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":352791000119108,
    "descripcion":"LINFOMA NO-HODGKIN DE GANGLIOS LINFÁTICOS DE MÚLTIPLES LOCALIZACIONES"
  },
  {
    "codigo":209962000,
    "descripcion":"AMILOIDOSIS ASOCIADA A MIELOMA"
  },
  {
    "codigo":373802001,
    "descripcion":"HALLAZGO RELACIONADO CON LA ESCALA DEL ESTADO FUNCIONAL DE LA OMS"
  },
  {
    "codigo":275498002,
    "descripcion":"INFECCIÓN DEL TRACTO RESPIRATORIO"
  },
  {
    "codigo":406570003,
    "descripcion":"INFECCIÓN DEL SISTEMA NERVIOSO CENTRAL POR CITOMEGALOVIRUS"
  },
  {
    "codigo":15727281000119102,
    "descripcion":"HIPERLAXITUD ARTICULAR DE AMBOS PIES"
  },
  {
    "codigo":44287001,
    "descripcion":"ALTERACIÓN EN LA FORMACIÓN DE BILIS"
  },
  {
    "codigo":240895002,
    "descripcion":"DERMATOSIS DERMATOFAGOIDE"
  },
  {
    "codigo":371967001,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA AMPOLLA DE VATER"
  },
  {
    "codigo":109823006,
    "descripcion":"NEOPLASIA MALIGNA SUPERPUESTA DE LA LENGUA"
  },
  {
    "codigo":42452002,
    "descripcion":"RADICULOPATÍA DORSAL"
  },
  {
    "codigo":1254868002,
    "descripcion":"POIQUILODERMIA DEBIDA A RADIOTERAPIA Y POSTERIOR A ELLA"
  },
  {
    "codigo":206292002,
    "descripcion":"SÍNDROME DE ASPIRACIÓN DE MECONIO"
  },
  {
    "codigo":763348005,
    "descripcion":"SÍNDROME AUTOSÓMICO RECESIVO DE ATAXIA CEREBELOSA CON ESPASTICIDAD DE COMIENZO TARDÍO"
  },
  {
    "codigo":402900005,
    "descripcion":"LEUCOPLAQUIA PILOSA BUCAL ASOCIADA A INMUNODEFICIENCIA"
  },
  {
    "codigo":271828007,
    "descripcion":"ESPUTO ANORMAL - OLOR"
  },
  {
    "codigo":106153001,
    "descripcion":"HALLAZGO EN EL TERCER PAR CRANEAL"
  },
  {
    "codigo":239060009,
    "descripcion":"ICTIOSIS VULGAR ATÍPICA CON HIPOGONADISMO"
  },
  {
    "codigo":237225003,
    "descripcion":"ÚTERO BICORNE EN EL EMBARAZO, PARTO Y PUERPERIO"
  },
  {
    "codigo":299851000119101,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE TENDÓN FLEXOR DE ANTEBRAZO"
  },
  {
    "codigo":827049005,
    "descripcion":"PARÁLISIS DE NERVIO MOTOR SUPERIOR"
  },
  {
    "codigo":204457005,
    "descripcion":"RETORNO VENOSO PULMONAR ANÓMALO, COMPLETO, SUPRADIAFRAGMÁTICO"
  },
  {
    "codigo":366462001,
    "descripcion":"REFLEJO MIOTÁTICO DE DEDO DE LA MANO-HALLAZGO"
  },
  {
    "codigo":300926005,
    "descripcion":"ECCEMA DE MUÑECA"
  },
  {
    "codigo":268158009,
    "descripcion":"MEGALOCÓRNEA"
  },
  {
    "codigo":200787006,
    "descripcion":"DERMATITIS DE CONTACTO CAUSADA POR GLICOL"
  },
  {
    "codigo":461096001,
    "descripcion":"CONDUCTO ARTERIOSO BILATERAL PERMEABLE"
  },
  {
    "codigo":1149224003,
    "descripcion":"SOBREDOSIS INTENCIONAL"
  },
  {
    "codigo":297256008,
    "descripcion":"DEFICIENCIA DE GLICEROL-QUINASA - AISLADA"
  },
  {
    "codigo":721405007,
    "descripcion":"SÍNDROME DE BROWN-SEQUARD AL NIVEL DEL SÉPTIMO SEGMENTO CERVICAL"
  },
  {
    "codigo":295421008,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE DOMPERIDONA"
  },
  {
    "codigo":262653009,
    "descripcion":"HEMATOMA DE MUCOSA YUGAL"
  },
  {
    "codigo":424658001,
    "descripcion":"DESARROLLO DEL LENGUAJE - CAPAZ DE DECIR ESPONTÁNEAMENTE TRES PALABRAS O MÁS"
  },
  {
    "codigo":293586001,
    "descripcion":"ALERGIA A ASPIRINA"
  },
  {
    "codigo":228050004,
    "descripcion":"TRISOMÍA PARCIAL 21Q"
  },
  {
    "codigo":129746008,
    "descripcion":"LESIÓN DE BAJA DENSIDAD (SIN GRASA)"
  },
  {
    "codigo":226215005,
    "descripcion":"DIETA PARA ESTUDIO DE EQUILIBRIO"
  },
  {
    "codigo":95143006,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL PILAR AMIGDALINO"
  },
  {
    "codigo":717735006,
    "descripcion":"CARCINOMA DE CÉLULAS RENALES LOCALIZADO EN RIÑÓN CON EXCEPCIÓN DE PELVIS RENAL"
  },
  {
    "codigo":93308000,
    "descripcion":"POSICIÓN ANÓMALA CONGÉNITA DEL ARCO DE LA VÉRTEBRA LUMBAR"
  },
  {
    "codigo":715900001,
    "descripcion":"GLIOMA COROIDEO"
  },
  {
    "codigo":160679008,
    "descripcion":"VERSATILIDAD - FUNCIONAMIENTO SOCIAL"
  },
  {
    "codigo":16057471000119100,
    "descripcion":"PARÁLISIS FACIAL DERECHA GRADO VI DE HOUSE-BRACKMANN"
  },
  {
    "codigo":60540006,
    "descripcion":"CELULITIS DE LA CARA EXTERNA DE LA MEJILLA"
  },
  {
    "codigo":224380006,
    "descripcion":"ANTECEDENTE DE BÚSQUEDA DE TRABAJO"
  },
  {
    "codigo":124241002,
    "descripcion":"DEFICIENCIA DE ACETILSEROTONINA METILTRANSFERASA"
  },
  {
    "codigo":419153005,
    "descripcion":"BOCIO NODULAR"
  },
  {
    "codigo":187942000,
    "descripcion":"NEOPLASIA MALIGNA DE HUESO DEL CARPO - TRAPEZOIDE"
  },
  {
    "codigo":1303889009,
    "descripcion":"GLAUCOMA DE ÁNGULO ABIERTO DE OJO IZQUIERDO DEBIDO A SÍNDROME SISTÉMICO"
  },
  {
    "codigo":286246003,
    "descripcion":"DIFICULTAD PARA UTILIZAR PROCESOS FONOLÓGICOS"
  },
  {
    "codigo":253478005,
    "descripcion":"ANOMALÍA CONGÉNITA DE MÚSCULO PAPILAR DE VÁLVULA AURICULOVENTRICULAR DERECHA"
  },
  {
    "codigo":89638008,
    "descripcion":"XIFODINIA"
  },
  {
    "codigo":1151000119104,
    "descripcion":"QUERATOSIS PILAR ADQUIRIDA"
  },
  {
    "codigo":284411006,
    "descripcion":"INCAPAZ DE MANTENER EL EQUILIBRIO AL INCLINARSE"
  },
  {
    "codigo":53200002,
    "descripcion":"ABSCESO DE PARAMETRIO"
  },
  {
    "codigo":249808002,
    "descripcion":"DEFORMIDAD EN EQUINOVARO DEL PIE"
  },
  {
    "codigo":282576006,
    "descripcion":"CAPAZ DE BRINCAR"
  },
  {
    "codigo":85968009,
    "descripcion":"FÍSTULA DUODENAL EXTERNA"
  },
  {
    "codigo":870565004,
    "descripcion":"CONTUSIÓN DE ROMBENCÉFALO CON HERIDA INTRACRANEAL ABIERTA"
  },
  {
    "codigo":247973004,
    "descripcion":"CONDUCTA DESINHIBIDA"
  },
  {
    "codigo":213370000,
    "descripcion":"LUXACIONES, ESGUINCES Y DISTENSIONES QUE COMPROMETEN MÚLTIPLES REGIONES DE LOS MIEMBROS SUPERIORES"
  },
  {
    "codigo":768591002,
    "descripcion":"HALLAZGO RELACIONADO CON LA PRESENCIA DE HIFAS Y ESPORAS DE DERMATOFITOS POR FUERA DEL TALLO DEL PELO"
  },
  {
    "codigo":47695004,
    "descripcion":"AFRONTAMIENTO INEFICAZ (INDIVIDUAL)"
  },
  {
    "codigo":735823006,
    "descripcion":"RUPTURA TRAUMÁTICA DE LIGAMENTO DE ARTICULACIÓN INTERFALÁNGICA DE DEDO DE LA MANO"
  },
  {
    "codigo":15703321000119105,
    "descripcion":"DEDO DE LA MANO EN GATILLO ADQUIRIDO, AMBOS DEDOS MEDIOS"
  },
  {
    "codigo":766756002,
    "descripcion":"TRAYECTO SUBÓRTICO DE VENA BRAQUIOCEFÁLICA"
  },
  {
    "codigo":10624281000119106,
    "descripcion":"DERMATITIS ECCEMATOSA DE PÁRPADOS DE AMBOS OJOS"
  },
  {
    "codigo":109561000,
    "descripcion":"DISPLASIA CEREBROFACIAL"
  },
  {
    "codigo":111396008,
    "descripcion":"SÍNDROME DE CHÉDIAK - HIGASHI"
  },
  {
    "codigo":42190000,
    "descripcion":"AUSENCIA CONGÉNITA DEL MÚSCULO ABDOMINAL"
  },
  {
    "codigo":304334004,
    "descripcion":"AMPLITUD DE MOVIMIENTO SUBASTRAGALINO DISMINUIDA"
  },
  {
    "codigo":238798005,
    "descripcion":"LINFANGIOMA SIMPLE"
  },
  {
    "codigo":402638007,
    "descripcion":"ALOPECIA POR ENFERMEDAD SUBYACENTE"
  },
  {
    "codigo":7587000,
    "descripcion":"OSTEOMIELITIS AGUDA DE REGIÓN DE HOMBRO"
  },
  {
    "codigo":73123008,
    "descripcion":"MUCOPOLISACARIDOSIS, MPS - I - S"
  },
  {
    "codigo":431736004,
    "descripcion":"INFECCIÓN DE LA MANO POR MORDIDA"
  },
  {
    "codigo":235128005,
    "descripcion":"QUISTE POR EXTRAVASACIÓN DE LA GLÁNDULA SALIVAL MENOR"
  },
  {
    "codigo":38520008,
    "descripcion":"DETERMINACIÓN DEL RESULTADO: SATISFACTORIO PARA EL PACIENTE"
  },
  {
    "codigo":366200009,
    "descripcion":"HALLAZGO RELACIONADO CON EL CARÁCTER DEL PULSO"
  },
  {
    "codigo":36685002,
    "descripcion":"EVALUACIÓN DE DISCAPACIDAD: 7%"
  },
  {
    "codigo":298829003,
    "descripcion":"AMPLITUD DE ROTACIÓN INTERNA PASIVA DE ARTICULACIÓN DE HOMBRO, DISMINUIDA"
  },
  {
    "codigo":724813004,
    "descripcion":"TRASTORNO DEL SISTEMA NERVIOSO AUTÓNOMO CONCOMITANTE CON TRASTORNO NEURODEGENERATIVO Y DEBIDO A ÉL"
  },
  {
    "codigo":300664009,
    "descripcion":"CAPAZ DE REALIZAR EJERCICIO DE SEGURIDAD VIAL"
  },
  {
    "codigo":722978000,
    "descripcion":"DEMENCIA TÓXICA"
  },
  {
    "codigo":1148962001,
    "descripcion":"LESIÓN TRAUMÁTICA DE PULMÓN DEBIDA A USO DE CIGARRILLO ELECTRÓNICO"
  },
  {
    "codigo":34850003,
    "descripcion":"ANTÍGENO DE GRUPO SANGUÍNEO FY^X^"
  },
  {
    "codigo":10817101000119103,
    "descripcion":"FRACTURA ABIERTA DE BASE DE SEGUNDO HUESO METACARPIANO DE MANO DERECHA"
  },
  {
    "codigo":229623002,
    "descripcion":"DISFLUIDEZ DEL DESARROLLO"
  },
  {
    "codigo":65783004,
    "descripcion":"PLÁSMIDO CONJUGATIVO"
  },
  {
    "codigo":295159009,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE DIPIPANONA"
  },
  {
    "codigo":195020003,
    "descripcion":"MIOCARDIOPATÍA HIPERTRÓFICA SIN OBSTRUCCIÓN"
  },
  {
    "codigo":162252005,
    "descripcion":"HABLA LIMITADA"
  },
  {
    "codigo":63948006,
    "descripcion":"FRACTURA EXPUESTA DEL OLÉCRANON DEL CÚBITO"
  },
  {
    "codigo":291489003,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR NETILMICINA"
  },
  {
    "codigo":29345006,
    "descripcion":"ATRESIA DE CONDUCTO EYACULADOR"
  },
  {
    "codigo":193185007,
    "descripcion":"NEUROPATÍA ASINTOMÁTICA DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":304871000119102,
    "descripcion":"DETENCIÓN TOTAL DEL CRECIMIENTO EPIFISARIO DE RADIO DISTAL DERECHO"
  },
  {
    "codigo":94881009,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LOS ÓRGANOS INTRATORÁCICOS"
  },
  {
    "codigo":783009008,
    "descripcion":"DEFICIENCIA HIPOFISARIA DEBIDA A QUISTES DE LA HENDIDURA DE RATHKE"
  },
  {
    "codigo":93046003,
    "descripcion":"QUISTE CONGÉNITO DE VEJIGA URINARIA"
  },
  {
    "codigo":422561007,
    "descripcion":"FENÓMENO MIOTÓNICO DURANTE EL CALENTAMIENTO - APRETÓN DE MANOS"
  },
  {
    "codigo":1141622007,
    "descripcion":"PÓLIPO FIBROEPITELIAL DE MEMBRANA MUCOSA ORAL"
  },
  {
    "codigo":1172555001,
    "descripcion":"ESTRIOL EN SUERO POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":289654009,
    "descripcion":"CUELLO UTERINO VISIBLE EN EL INTROITO VAGINAL DURANTE EL ESFUERZO"
  },
  {
    "codigo":255051004,
    "descripcion":"TUMOR DE ORIGEN DESCONOCIDO"
  },
  {
    "codigo":123979008,
    "descripcion":"TEMPERATURA CORPORAL ANORMAL"
  },
  {
    "codigo":449824004,
    "descripcion":"SÍNDROME DE MARDEN WALKER"
  },
  {
    "codigo":10626791000119106,
    "descripcion":"FORÚNCULO DEL MUSLO IZQUIERDO"
  },
  {
    "codigo":56608008,
    "descripcion":"DOLOR DE REGIÓN DE MUÑECA"
  },
  {
    "codigo":417056009,
    "descripcion":"EXTENSIÓN BILATERAL DEL SACRO"
  },
  {
    "codigo":218613000,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR IBUPROFENO"
  },
  {
    "codigo":285984008,
    "descripcion":"CAPAZ DE ENCENDER EL CONDUCTOR ELÉCTRICO PRINCIPAL"
  },
  {
    "codigo":87541004,
    "descripcion":"VESÍCULA BILIAR ECTÓPICA"
  },
  {
    "codigo":284149003,
    "descripcion":"DIFICULTAD PARA MOVER LA MANO"
  },
  {
    "codigo":447989004,
    "descripcion":"LINFOMA NO HODGKIN DE LOCALIZACIÓN EXTRAGANGLIONAR"
  },
  {
    "codigo":251381007,
    "descripcion":"SÍNTOMAS GASTROINTESTINALES REPRODUCIDOS"
  },
  {
    "codigo":249546002,
    "descripcion":"HALLAZGO RELACIONADO CON LOS MOVIMIENTOS ABDOMINALES"
  },
  {
    "codigo":282314003,
    "descripcion":"NO MANTIENE EL EQUILIBRIO EN BIPEDESTACIÓN"
  },
  {
    "codigo":10928001000119103,
    "descripcion":"FRACTURA NO EXPUESTA DE CUELLO DE METACARPIANO DE MANO DERECHA"
  },
  {
    "codigo":247711001,
    "descripcion":"PERCEPCIÓN DE QUE LAS COSAS APARECEN PLANAS"
  },
  {
    "codigo":870303005,
    "descripcion":"TRASTORNO GENERALIZADO DEL DESARROLLO CON ALTERACIÓN COMPLETA DEL LENGUAJE FUNCIONAL CON PÉRDIDA DE HABILIDADES ADQUIRIDAS PREVIAMENTE"
  },
  {
    "codigo":442484005,
    "descripcion":"ATRAPAMIENTO DE INTESTINO EN FRACTURA"
  },
  {
    "codigo":278644007,
    "descripcion":"PACIENTE INCAPAZ DE MASTICAR CON DISPOSITIVO ORTODÓNCICO"
  },
  {
    "codigo":735561000,
    "descripcion":"INFECCIÓN QUE CAUSA GRANULOMA DEL ESPACIO EXTRADURAL DE LA MÉDULA ESPINAL"
  },
  {
    "codigo":47433000,
    "descripcion":"INFECCIÓN CAUSADA POR HAMMONDIA"
  },
  {
    "codigo":32641000119107,
    "descripcion":"INSUFICIENCIA HIPOTALÁMICA INDUCIDA POR EJERCICIO"
  },
  {
    "codigo":276809004,
    "descripcion":"CÁNCER GÁSTRICO TEMPRANO"
  },
  {
    "codigo":211273005,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN EL ANTEBRAZO"
  },
  {
    "codigo":333851000119102,
    "descripcion":"ESOTROPÍA MONOCULAR DE OJO DERECHO CON ESTRABISMO CON PATRÓN EN A"
  },
  {
    "codigo":897566005,
    "descripcion":"DELECIÓN DISTAL DEL CROMOSOMA 21"
  },
  {
    "codigo":305907000,
    "descripcion":"ATENDIDO EN EL HOSPITAL DE DÍA"
  },
  {
    "codigo":1290782009,
    "descripcion":"FRACTURA POR SOBRECARGA DE HUESO DE RODILLA"
  },
  {
    "codigo":10901531000119104,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO ACCESORIO IZQUIERDO"
  },
  {
    "codigo":1354483004,
    "descripcion":"INMUNODEFICIENCIA COMBINADA VARIABLE AUTOSÓMICA RECESIVA DEBIDA A MUTACIÓN DE PIK3CG"
  },
  {
    "codigo":240371008,
    "descripcion":"CRIPTOSPORIDIASIS INTESTINAL CRÓNICA"
  },
  {
    "codigo":43763009,
    "descripcion":"NEURALGIA DE NERVIO GLOSOFARÍNGEO"
  },
  {
    "codigo":109299008,
    "descripcion":"BURSITIS CRÓNICA"
  },
  {
    "codigo":205768003,
    "descripcion":"SITUS INVERSUS COMPLETO CON DEXTROCARDIA"
  },
  {
    "codigo":10995009,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE REGIÓN ESCAPULAR CON INFECCIÓN"
  },
  {
    "codigo":402376005,
    "descripcion":"ENFERMEDAD DE CROHN DEL PENE"
  },
  {
    "codigo":11858101000119100,
    "descripcion":"DISTENSIÓN DE MÚSCULO DE CARA POSTERIOR DE PIERNA IZQUIERDA"
  },
  {
    "codigo":238536008,
    "descripcion":"ÚLCERA TRAUMÁTICA"
  },
  {
    "codigo":1285277001,
    "descripcion":"HALLAZGO RELACIONADO CON RANGO DE FLEXIÓN PLANTAR DE TOBILLO"
  },
  {
    "codigo":105629000,
    "descripcion":"INFECCIÓN CLAMIDIAL"
  },
  {
    "codigo":236701001,
    "descripcion":"URINOMA PARAURETRAL"
  },
  {
    "codigo":72861004,
    "descripcion":"TRASTORNO DE PÁNICO SIN AGORAFOBIA CON ATAQUES DE PÁNICO LEVES"
  },
  {
    "codigo":269469005,
    "descripcion":"NEOPLASIA MALIGNA DE PARTES BLANDAS"
  },
  {
    "codigo":171165007,
    "descripcion":"SIN EXTENDIDO - SIN ACTIVIDAD SEXUAL"
  },
  {
    "codigo":300402000,
    "descripcion":"DISTENSIÓN ABDOMINAL UNIFORME"
  },
  {
    "codigo":15954101000119102,
    "descripcion":"HEMATOMA NO TRAUMÁTICO DE MAMA DERECHA"
  },
  {
    "codigo":12103861000119103,
    "descripcion":"QUEMADURA DE PIERNA IZQUIERDA"
  },
  {
    "codigo":202098006,
    "descripcion":"QUISTE DEL MENISCO EXTERNO"
  },
  {
    "codigo":38258006,
    "descripcion":"FÓRMULA DE HIPERALIMENTACIÓN PARA EL TRATAMIENTO DE LA ENFERMEDAD INFLAMATORIA INTESTINAL"
  },
  {
    "codigo":36423000,
    "descripcion":"RIGIDEZ DE DESCORTICACIÓN"
  },
  {
    "codigo":365938009,
    "descripcion":"HALLAZGO RELACIONADO CON LA CONFIANZA EN SÍ MISMO"
  },
  {
    "codigo":726386007,
    "descripcion":"DELECIÓN DE PARTE DEL CROMOSOMA 15"
  },
  {
    "codigo":5490008,
    "descripcion":"TIÑA DE LA BARBA POR TRICHOPHYTON VERRUCOSUM"
  },
  {
    "codigo":1052231005,
    "descripcion":"SUPRESIÓN DE SEÑAL VISUAL DE OJO IZQUIERDO"
  },
  {
    "codigo":298567007,
    "descripcion":"SIN AMPLITUD DE ROTACIÓN ACTIVA HACIA LA IZQUIERDA DE LA COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":724551009,
    "descripcion":"QUEMADURA NEONATAL DEBIDA A EXPOSICIÓN A LUZ ULTRAVIOLETA ARTIFICIAL DURANTE FOTOTERAPIA"
  },
  {
    "codigo":64136002,
    "descripcion":"EFECTO TÓXICO DEL QUEROSÉN"
  },
  {
    "codigo":294897002,
    "descripcion":"ALERGIA A SAL FERROSA"
  },
  {
    "codigo":425969006,
    "descripcion":"EXACERBACIÓN DE ASMA INTERMITENTE"
  },
  {
    "codigo":260294000,
    "descripcion":"CUENTA LOS DEDOS - 1\/3 METRO"
  },
  {
    "codigo":719046005,
    "descripcion":"SÍNDROME DE MICRODELECIÓN 12Q14"
  },
  {
    "codigo":10684751000119103,
    "descripcion":"NÓDULO DEL TEJIDO CELULAR SUBCUTÁNEO DE LA PARED TORÁCICA"
  },
  {
    "codigo":293062007,
    "descripcion":"REACCIÓN ADVERSA A ESTIBOGLUCONATO DE SODIO"
  },
  {
    "codigo":782747000,
    "descripcion":"PARAPLEJÍA ESPÁSTICA AUTOSÓMICA RECESIVA TIPO 66"
  },
  {
    "codigo":291227001,
    "descripcion":"INTOXICACIÓN POR OXIPERTINA"
  },
  {
    "codigo":717211002,
    "descripcion":"PSEUDOMONAS ALCALIGENES O PSEUDOMONAS PSEUDOALCALIGENES"
  },
  {
    "codigo":12241231000119104,
    "descripcion":"TENDINITIS DE ANTEBRAZO DERECHO"
  },
  {
    "codigo":94619004,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL ASTRÁGALO"
  },
  {
    "codigo":35151000119105,
    "descripcion":"INFLAMACIÓN DE BOLSILLO ILEOANAL"
  },
  {
    "codigo":387696001,
    "descripcion":"DISFUNCIÓN UTERINA HIPOTÓNICA PRIMARIA"
  },
  {
    "codigo":289392004,
    "descripcion":"OREJA FETAL PALPABLE POR VÍA VAGINAL"
  },
  {
    "codigo":92784007,
    "descripcion":"CARCINOMA IN SITU DE LA URETRA"
  },
  {
    "codigo":123717006,
    "descripcion":"CIRROSIS AVANZADA"
  },
  {
    "codigo":1336133008,
    "descripcion":"ALTERACIÓN DE ARTICULACIÓN DE REGIÓN DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":189253009,
    "descripcion":"CARCINOMA IN SITU DEL CARTÍLAGO CRICOIDES"
  },
  {
    "codigo":1137690000,
    "descripcion":"NUNCA USÓ CIGARRILLO ELECTRÓNICO"
  },
  {
    "codigo":89114005,
    "descripcion":"IRIDOCICLITIS SECUNDARIA INFECCIOSA"
  },
  {
    "codigo":1332463007,
    "descripcion":"LESIÓN DE RAÍZ DE NERVIO RAQUÍDEO DORSAL"
  },
  {
    "codigo":413124000,
    "descripcion":"DERIVACIÓN POR ACCIDENTE CEREBROVASCULAR\/ATAQUE ISQUÉMICO TRANSITORIO"
  },
  {
    "codigo":118212000,
    "descripcion":"HALLAZGO EN EL NÚMERO DE PARTOS"
  },
  {
    "codigo":251119009,
    "descripcion":"PATRÓN DE LA CONDUCCIÓN VENTRICULAR"
  },
  {
    "codigo":85444005,
    "descripcion":"TRASTORNO DEL METABOLISMO DE LAS PIRIMIDINAS"
  },
  {
    "codigo":183748006,
    "descripcion":"CONSULTA DOMICILIARIA DE MEDICINA RESPIRATORIA REALIZADA"
  },
  {
    "codigo":1363396006,
    "descripcion":"NEOVASCULARIZACIÓN DE CUADRANTE TEMPORAL DE ÁNGULO IRIDOCORNEAL DE OJO DERECHO"
  },
  {
    "codigo":282052008,
    "descripcion":"QUEMADURA DE YEYUNO"
  },
  {
    "codigo":1197721001,
    "descripcion":"ESTREÑIMIENTO FUNCIONAL EN LACTANTE"
  },
  {
    "codigo":249284009,
    "descripcion":"SIN PERCEPCIÓN DE LA ELIMINACIÓN DE ORINA"
  },
  {
    "codigo":247449001,
    "descripcion":"DEPRESIÓN PALMAR"
  },
  {
    "codigo":11313641000119107,
    "descripcion":"FRACTURA EXPUESTA DE HUESO OCCIPITAL"
  },
  {
    "codigo":704366000,
    "descripcion":"REVELACIÓN SOBRE SÍ MISMO INAPROPIADA"
  },
  {
    "codigo":212846000,
    "descripcion":"EFECTO TÓXICO DE ESTAÑO Y\/O COMPUESTOS DE ESTAÑO"
  },
  {
    "codigo":1163118004,
    "descripcion":"INFECCIÓN CONGÉNITA POR VIRUS DE LA CORIOMENINGITIS LINFOCÍTICA"
  },
  {
    "codigo":81774005,
    "descripcion":"PARÁLISIS DE KLUMPKE - DÉJERINE COMO MANIFESTACIÓN DE TRAUMATISMO OBSTÉTRICO"
  },
  {
    "codigo":442222009,
    "descripcion":"INFECCIÓN DE ESTOMA DE TRAQUEOSTOMÍA"
  },
  {
    "codigo":702531002,
    "descripcion":"PÉRDIDA DEL GUSTO EN TERCIO POSTERIOR DE LA LENGUA"
  },
  {
    "codigo":16238009,
    "descripcion":"NECROBIOSIS LIPOIDEA, TIPO NECROBIÓTICA"
  },
  {
    "codigo":276547003,
    "descripcion":"PERFORACIÓN TRAQUEAL NEONATAL"
  },
  {
    "codigo":1259587002,
    "descripcion":"CARCINOSARCOMA PRIMARIO DE PIEL"
  },
  {
    "codigo":78104003,
    "descripcion":"REGURGITACIÓN DE CONTENIDO GÁSTRICO"
  },
  {
    "codigo":274712006,
    "descripcion":"PERCUSIÓN TORÁCICA ANORMAL"
  },
  {
    "codigo":373016007,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM BRANDERI"
  },
  {
    "codigo":438552009,
    "descripcion":"CON MAYOR RIESGO DE CONDUCTA DESTRUCTIVA HACIA LA PROPIEDAD"
  },
  {
    "codigo":241944009,
    "descripcion":"ANAFILAXIS NO ALÉRGICA CAUSADA POR SANGRE COMPLETA"
  },
  {
    "codigo":240109003,
    "descripcion":"GANGRENA GASEOSA UTERINA"
  },
  {
    "codigo":897304009,
    "descripcion":"CUERPO EXTRAÑO SUPERFICIAL DE LABIO CON INFECCIÓN"
  },
  {
    "codigo":698861005,
    "descripcion":"NÁUSEAS Y VÓMITOS INTRATABLES"
  },
  {
    "codigo":305645001,
    "descripcion":"ATENDIDO POR ESPECIALISTA EN CUIDADOS INTENSIVOS DE ADULTOS"
  },
  {
    "codigo":403949007,
    "descripcion":"ADENOCARCINOMA APOCRINO DE LA PIEL"
  },
  {
    "codigo":205506004,
    "descripcion":"DISPLASIA CRANEODIAFISARIA"
  },
  {
    "codigo":10851101000119103,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR INHIBIDOR DE LA RECAPTACIÓN DE NORADRENALINA Y SEROTONINA"
  },
  {
    "codigo":860866005,
    "descripcion":"ENCEFALITIS CAUSADA POR TRYPANOSOMA BRUCEI RHODESIENSE"
  },
  {
    "codigo":74434009,
    "descripcion":"ATROFIA DE CONDUCTO CÍSTICO"
  },
  {
    "codigo":1186711002,
    "descripcion":"SÍNDROME DE DISCAPACIDAD INTELECTUAL Y ARRITMIA CARDÍACA POR DEFICIENCIA DE GNB5"
  },
  {
    "codigo":301975002,
    "descripcion":"DRENAJE NORMAL DE LÁGRIMAS CON FLUORESCEÍNA"
  },
  {
    "codigo":7063008,
    "descripcion":"NEUMONÍA GANGRENOSA"
  },
  {
    "codigo":234604001,
    "descripcion":"DEFICIENCIA DE LA VÍA ALTERNA"
  },
  {
    "codigo":1217644004,
    "descripcion":"COLESTEATOMA ORBITARIO"
  },
  {
    "codigo":70764005,
    "descripcion":"TRASTORNO DE DESPERSONALIZACIÓN"
  },
  {
    "codigo":15930141000119106,
    "descripcion":"EDEMA DE AMBOS PÁRPADOS INFERIORES"
  },
  {
    "codigo":300140007,
    "descripcion":"MEMBRANA TIMPÁNICA OPACA"
  },
  {
    "codigo":267372009,
    "descripcion":"ERITRODERMIA ICTIOSIFORME BULLOSA NO CONGÉNITA"
  },
  {
    "codigo":298305003,
    "descripcion":"HALLAZGO RELACIONADO CON EL EQUILIBRIO GENERAL"
  },
  {
    "codigo":338871000119101,
    "descripcion":"SINEQUIAS PERIFÉRICAS ANTERIORES DE OJO IZQUIERDO"
  },
  {
    "codigo":167233008,
    "descripcion":"ORINA: NARANJA"
  },
  {
    "codigo":722454003,
    "descripcion":"SÍNDROME DE DISCAPACIDAD INTELECTUAL, DISMORFISMO CRANEOFACIAL, HIPOGONADISMO Y DIABETES MELLITUS"
  },
  {
    "codigo":296470004,
    "descripcion":"SOBREDOSIS DE TRETINOÍNA"
  },
  {
    "codigo":1076151000119104,
    "descripcion":"INFLAMACIÓN DE BOLSA SEROSA SUBTENDINOSA INFERIOR DE MÚSCULO BÍCEPS FEMORAL DE RODILLA IZQUIERDA"
  },
  {
    "codigo":292800009,
    "descripcion":"REACCIÓN ADVERSA A FÁRMACO ANTIMICÓTICO"
  },
  {
    "codigo":127125002,
    "descripcion":"LINFADENOPATÍA DE LA CURVATURA MAYOR DEL ESTÓMAGO"
  },
  {
    "codigo":782485001,
    "descripcion":"ENFERMEDAD CAUSADA POR CESTODO DE BOTHRIOCEPHALIDEA"
  },
  {
    "codigo":290965005,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR VIGABATRINA"
  },
  {
    "codigo":1306773006,
    "descripcion":"GLAUCOMA POR DEPÓSITO DE PARTÍCULAS DE CRISTALINO EN OJO IZQUIERDO"
  },
  {
    "codigo":15713361000119102,
    "descripcion":"CODO VALGO ADQUIRIDO DE AMBOS CODOS"
  },
  {
    "codigo":94357009,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE YEYUNO"
  },
  {
    "codigo":289130000,
    "descripcion":"INCAPAZ DE REALIZAR ACTIVIDADES PARA EL CUIDADO DEL PELO"
  },
  {
    "codigo":715114002,
    "descripcion":"SE TRANSFIERE DE LA CAMA A LA SILLA DE RUEDAS"
  },
  {
    "codigo":158058005,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR ANTITOXINA TETÁNICA"
  },
  {
    "codigo":312401000119103,
    "descripcion":"FALTA DE SOPORTE OCLUSAL POSTERIOR"
  },
  {
    "codigo":25151000,
    "descripcion":"PRODUCCIÓN DE ERITROCITOS AUMENTADA"
  },
  {
    "codigo":1237567002,
    "descripcion":"VENA VARICOSA DE REGIÓN DE TOBILLO DERECHO"
  },
  {
    "codigo":418367004,
    "descripcion":"REACCIÓN ALÉRGICA CAUSADA POR POLEN DE GRAMÍNEAS"
  },
  {
    "codigo":1335871007,
    "descripcion":"ICTERICIA NEONATAL PRECOZ DEBIDA A GALACTOSEMIA"
  },
  {
    "codigo":188991008,
    "descripcion":"LIPOMA DE LA PARED TORÁCICA ANTERIOR"
  },
  {
    "codigo":254527009,
    "descripcion":"NEOPLASIA BENIGNA DE VENTRÍCULO LARÍNGEO"
  },
  {
    "codigo":1268500006,
    "descripcion":"CARCINOMA RENAL PRIMARIO DE CÉLULAS CROMÓFOBAS"
  },
  {
    "codigo":250857002,
    "descripcion":"TORNIQUETE - HALLAZGO"
  },
  {
    "codigo":11781201000119107,
    "descripcion":"RUPTURA TRAUMÁTICA DE TENDÓN DE MÚSCULO ISQUIOTIBIAL DE MIEMBRO INFERIOR IZQUIERDO"
  },
  {
    "codigo":283625006,
    "descripcion":"HERIDA POR PINCHAZO DE AGUJA EN EL ABDOMEN"
  },
  {
    "codigo":11863121000119108,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE PIEL DE DEDO GORDO DE PIE IZQUIERDO"
  },
  {
    "codigo":183486001,
    "descripcion":"ADMITIDO EN UN CENTRO DE DESINTOXICACIÓN ALCOHÓLICA"
  },
  {
    "codigo":1363134003,
    "descripcion":"ASTILLA EN REGIÓN INTERESCAPULAR CON INFECCIÓN"
  },
  {
    "codigo":314558005,
    "descripcion":"QUERATITIS FÚNGICA"
  },
  {
    "codigo":52414005,
    "descripcion":"SÍFILIS SECUNDARIA DE LA VULVA"
  },
  {
    "codigo":609470005,
    "descripcion":"INTERRUPCIÓN INDUCIDA DEL EMBARAZO COMPLICADA POR LACERACIÓN DE ÚTERO"
  },
  {
    "codigo":871614007,
    "descripcion":"TRAYECTO INTRAPERICÁRDICO ANORMAL DE GRANDES ARTERIAS"
  },
  {
    "codigo":367851000119103,
    "descripcion":"ESTRECHEZ POSINFECCIOSA DE URETRA MEMBRANOSA"
  },
  {
    "codigo":247187000,
    "descripcion":"RETINA PERIFÉRICA - BLANCA CON PRESIÓN"
  },
  {
    "codigo":85182005,
    "descripcion":"CURIOSIDAD SEXUAL"
  },
  {
    "codigo":771475006,
    "descripcion":"NEUROPATÍA MOTRIZ HEREDITARIA DISTAL DE COMIENZO EN LA VIDA ADULTA"
  },
  {
    "codigo":40261000087103,
    "descripcion":"TENDINITIS DE BÍCEPS FEMORAL DERECHO"
  },
  {
    "codigo":312723007,
    "descripcion":"GOTITAS DE ACEITE DE SILICONA EN LENTE INTRAOCULAR"
  },
  {
    "codigo":47941000087105,
    "descripcion":"FRACTURA DE DIÁFISIS DE FÉMUR IZQUIERDO"
  },
  {
    "codigo":42821000087106,
    "descripcion":"DISTENSIÓN DE TENDÓN DE MÚSCULO GLÚTEO IZQUIERDO"
  },
  {
    "codigo":15976004,
    "descripcion":"RITMO CIRCADIANO ANORMAL"
  },
  {
    "codigo":81512004,
    "descripcion":"ARTROFITO EN LA RODILLA"
  },
  {
    "codigo":441960006,
    "descripcion":"DÉFICIT DEL HABLA Y DEL LENGUAJE COMO EFECTO TARDÍO DE ACCIDENTE CEREBROVASCULAR"
  },
  {
    "codigo":48744006,
    "descripcion":"VARIACIÓN NORMAL EN EL ESPESOR"
  },
  {
    "codigo":1162856006,
    "descripcion":"NEOPLASIA NEUROENDOCRINA DE COLON"
  },
  {
    "codigo":276285004,
    "descripcion":"HEMORRAGIA SUBARACNOIDEA PROVENIENTE DE ANEURISMA DE LA ARTERIA CEREBELOSA POSTEROINFERIOR"
  },
  {
    "codigo":46909005,
    "descripcion":"INTENSIDAD DEL SOPLO CARDÍACO, GRADO I"
  },
  {
    "codigo":866109006,
    "descripcion":"SÍNDROME LINFOCÍTICO HIPEREOSINOFÍLICO"
  },
  {
    "codigo":1259325006,
    "descripcion":"CARCINOMA PRIMARIO DE FRENILLO LABIAL"
  },
  {
    "codigo":12306004,
    "descripcion":"INTOXICACIÓN POR OSTEOSPERMUM ECKLONIS"
  },
  {
    "codigo":307218005,
    "descripcion":"PERFORACIÓN TRAUMÁTICA DEL ESÓFAGO"
  },
  {
    "codigo":733202007,
    "descripcion":"CALCIFICACIÓN DISTRÓFICA DE PIEL DEBIDA A LESIÓN TRAUMÁTICA CUTÁNEA LOCALIZADA"
  },
  {
    "codigo":403687001,
    "descripcion":"CALCIFICACIÓN EN CICATRIZ QUIRÚRGICA"
  },
  {
    "codigo":239847002,
    "descripcion":"GOTA SECUNDARIA A DEFECTO ENZIMÁTICO"
  },
  {
    "codigo":341381000119104,
    "descripcion":"HIPEREMIA CONJUNTIVAL DE OJO IZQUIERDO"
  },
  {
    "codigo":1255655001,
    "descripcion":"CARCINOMA DE CÉLULAS GIGANTES DE TRÁQUEA"
  },
  {
    "codigo":76007003,
    "descripcion":"INFECCIÓN CAUSADA POR NEOASCARIS"
  },
  {
    "codigo":762300000,
    "descripcion":"TRASTORNO DEL MOVIMIENTO DEBIDO A EFECTO TÓXICO DE UNA SUSTANCIA"
  },
  {
    "codigo":860604008,
    "descripcion":"ALERGIA A MANZANA"
  },
  {
    "codigo":301713005,
    "descripcion":"HIPERPLASIA VULVAR"
  },
  {
    "codigo":203409006,
    "descripcion":"OSTEOCONDRITIS DISECANTE DE LA CABEZA DEL RADIO"
  },
  {
    "codigo":299878000,
    "descripcion":"REFLEJO AQUÍLEO DISMINUIDO"
  },
  {
    "codigo":1184614000,
    "descripcion":"AMBIENTE LIMPIO"
  },
  {
    "codigo":1217382002,
    "descripcion":"SÍNDROME DE DISCAPACIDAD INTELECTUAL, AUTISMO, APRAXIA DEL HABLA Y DISMORFISMO CRANEOFACIAL"
  },
  {
    "codigo":365414002,
    "descripcion":"ONDA S ELECTROCARDIOGRÁFICA - HALLAZGO"
  },
  {
    "codigo":400017009,
    "descripcion":"MALFORMACIÓN VASCULAR MIXTA"
  },
  {
    "codigo":10636831000119103,
    "descripcion":"ÚLCERA CRÓNICA DE SEGMENTO MEDIO DE PIE DERECHO"
  },
  {
    "codigo":396347007,
    "descripcion":"HERNIA UMBILICAL"
  },
  {
    "codigo":230672006,
    "descripcion":"MIASTENIA CONGÉNITA"
  },
  {
    "codigo":294373001,
    "descripcion":"ALERGIA A ZALCITABINA"
  },
  {
    "codigo":292538003,
    "descripcion":"REACCIÓN ADVERSA A GLICOPIRRONIO"
  },
  {
    "codigo":390842003,
    "descripcion":"ATENDIDO POR DIABETÓLOGO"
  },
  {
    "codigo":95930005,
    "descripcion":"VÍCTIMA DE NEGLIGENCIA"
  },
  {
    "codigo":30394008,
    "descripcion":"REACCIÓN A UNA TRANSFUSIÓN, CAUSADA POR PRODUCTOS DEL METABOLISMO CELULAR"
  },
  {
    "codigo":421775001,
    "descripcion":"GLÓBULOS BLANCOS EN HUMOR VÍTREO"
  },
  {
    "codigo":126863000,
    "descripcion":"NEOPLASIA DE CONDUCTO PANCREÁTICO"
  },
  {
    "codigo":1306511004,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA BILATERAL DE MAMAS"
  },
  {
    "codigo":290703008,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ETOPÓSIDO"
  },
  {
    "codigo":92260003,
    "descripcion":"NEOPLASIA BENIGNA DE OVARIO"
  },
  {
    "codigo":16426681000119106,
    "descripcion":"ARTRITIS DE ARTICULACIÓN CIGOAPOFISARIA DE COLUMNA VERTEBRAL CERVICAL"
  },
  {
    "codigo":288441000119106,
    "descripcion":"HABILIDADES PARA LA INTERACCIÓN SOCIAL INADECUADAS"
  },
  {
    "codigo":714852007,
    "descripcion":"NO SE ASIMILA CULTURALMENTE"
  },
  {
    "codigo":288868007,
    "descripcion":"NO BEBE CON UN SORBETE"
  },
  {
    "codigo":876857001,
    "descripcion":"ESTENOSIS DEL TRONCO DE LA ARTERIA CORONARIA IZQUIERDA"
  },
  {
    "codigo":385337002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD DE COMPRENSIÓN"
  },
  {
    "codigo":90425003,
    "descripcion":"INTOXICACIÓN POR RAPHANUS RAPHANISTRUM"
  },
  {
    "codigo":1237305006,
    "descripcion":"ARTROFIBROSIS DE CODO"
  },
  {
    "codigo":713017009,
    "descripcion":"INCUMPLIMIENTO DE RÉGIMEN DE MEDICACIÓN ANTIRRETROVIRAL"
  },
  {
    "codigo":285198001,
    "descripcion":"CAPAZ DE RECORDAR EL NOMBRE DEL MONARCA REINANTE"
  },
  {
    "codigo":55822004,
    "descripcion":"HIPERLIPIDEMIA"
  },
  {
    "codigo":416270005,
    "descripcion":"HALLAZGO RELACIONADO CON EL SISTEMA LAGRIMAL"
  },
  {
    "codigo":449038007,
    "descripcion":"UTILIZA DISPOSITIVO INTRAUTERINO LIBERADOR DE HORMONAS COMO MÉTODO ANTICONCEPTIVO"
  },
  {
    "codigo":840419005,
    "descripcion":"DISECCIÓN DE ARTERIA CARÓTIDA EXTRACRANEAL"
  },
  {
    "codigo":283363006,
    "descripcion":"LACERACIÓN DE LABIO"
  },
  {
    "codigo":119523007,
    "descripcion":"TRASTORNO DEL INTESTINO GRUESO"
  },
  {
    "codigo":19384000,
    "descripcion":"SOPLO DE GRAHAM STEELL"
  },
  {
    "codigo":445368001,
    "descripcion":"POSICIÓN Y ORIENTACIÓN CARDÍACAS NORMALES"
  },
  {
    "codigo":707512002,
    "descripcion":"ASMA MODERADA PERSISTENTE NO COMPLICADA"
  },
  {
    "codigo":1297336001,
    "descripcion":"CIERRE DE ÁNGULO AGUDO POSOPERATORIO DE OJO IZQUIERDO"
  },
  {
    "codigo":1081171000119106,
    "descripcion":"NEOPLASIA GERMINAL NO SEMINOMATOSA PRIMARIA DE TESTÍCULO IZQUIERDO NO DESCENDIDO"
  },
  {
    "codigo":281528007,
    "descripcion":"FRACTURA DE OLÉCRANON"
  },
  {
    "codigo":1295501000,
    "descripcion":"RADIOGRAFÍA DE VÍA BILIAR CON CONTRASTE ANORMAL"
  },
  {
    "codigo":248760008,
    "descripcion":"RELACIÓN SEXUAL NO EXITOSA"
  },
  {
    "codigo":84920009,
    "descripcion":"LUXACIÓN EXPUESTA DE LA CADERA"
  },
  {
    "codigo":246925003,
    "descripcion":"VASCULARIZACIÓN DE CÓRNEA"
  },
  {
    "codigo":446621000124107,
    "descripcion":"FRACTURA DE EXTREMIDAD SUPERIOR IZQUIERDA"
  },
  {
    "codigo":115853002,
    "descripcion":"FENOTIPO DE GRUPO SANGUÍNEO GERBICH"
  },
  {
    "codigo":212322001,
    "descripcion":"LESIÓN ABIERTA DEL NERVIO PERONEO SUPERFICIAL"
  },
  {
    "codigo":1162594001,
    "descripcion":"LESIÓN DE ESCLERÓTICA"
  },
  {
    "codigo":441698009,
    "descripcion":"OSTEÓLISIS DE HUESO ADYACENTE A PRÓTESIS"
  },
  {
    "codigo":767543001,
    "descripcion":"QUISTE SEBÁCEO CUTÁNEO"
  },
  {
    "codigo":1259063005,
    "descripcion":"POLINEUROPATÍA SENSITIVA AGUDA"
  },
  {
    "codigo":896780007,
    "descripcion":"FORMA ANCHA ANORMAL CONGÉNITA DE FALANGE CUARTO DEDO DE PIE"
  },
  {
    "codigo":274188008,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DEL PERINEO"
  },
  {
    "codigo":1222625002,
    "descripcion":"CRISIS HIPERCIANÓTICA DEBIDA A CARDIOPATÍA CONGÉNITA"
  },
  {
    "codigo":1255393002,
    "descripcion":"CARCINOMA INDIFERENCIADO DE PULMÓN"
  },
  {
    "codigo":1351862003,
    "descripcion":"SÍNDROME POST UNIDAD DE CUIDADOS INTENSIVOS FAMILIAR"
  },
  {
    "codigo":303286003,
    "descripcion":"EQUIMOSIS DE ENCÍAS"
  },
  {
    "codigo":237750004,
    "descripcion":"SEUDOHERMAFRODITA, MUJER CON TRASTORNO CORTICOSUPRARRENAL"
  },
  {
    "codigo":41142009,
    "descripcion":"LEUCODISTROFIA DE CÉLULAS GLOBOIDES, DE INICIO TARDÍO"
  },
  {
    "codigo":1153419002,
    "descripcion":"GOTA CRÓNICA CAUSADA POR FÁRMACO"
  },
  {
    "codigo":235915002,
    "descripcion":"DEFECTO DE LA SÍNTESIS DE ÁCIDOS BILIARES"
  },
  {
    "codigo":16019591000119104,
    "descripcion":"SINOTIVIS TRANSITORIA DE PIE DERECHO"
  },
  {
    "codigo":365152005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA PASAR OBJETOS DE UNA MANO A LA OTRA"
  },
  {
    "codigo":103008008,
    "descripcion":"CEFALEA POSTPARTO"
  },
  {
    "codigo":232245002,
    "descripcion":"MIRINGITIS GRANULAR"
  },
  {
    "codigo":295946000,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE MAPROTILINA"
  },
  {
    "codigo":1034003,
    "descripcion":"FÍSTULA PORTOMESENTÉRICA"
  },
  {
    "codigo":230410004,
    "descripcion":"EPILEPSIA NEONATAL FAMILIAR AUTOLIMITADA"
  },
  {
    "codigo":164874007,
    "descripcion":"ELECTROCARDIOGRAMA: SIN HIPERTROFIA VENTRICULAR IZQUIERDA"
  },
  {
    "codigo":294111000,
    "descripcion":"ALERGIA A ASTEMIZOL"
  },
  {
    "codigo":425183007,
    "descripcion":"NADIE EN EL HOGAR PARA RECIBIR AL PACIENTE"
  },
  {
    "codigo":1177012000,
    "descripcion":"NEUROESQUISTOSOMIASIS"
  },
  {
    "codigo":292276005,
    "descripcion":"REACCIÓN ADVERSA AL LITIO"
  },
  {
    "codigo":15638971000119100,
    "descripcion":"PELLIZCAMIENTO DEL ACETÁBULO FEMORAL DE AMBAS CADERAS"
  },
  {
    "codigo":290441000,
    "descripcion":"INTOXICACIÓN POR LACTULOSA"
  },
  {
    "codigo":95668009,
    "descripcion":"DOLOR FACIAL"
  },
  {
    "codigo":126601003,
    "descripcion":"NEOPLASIA DE PARTES BLANDAS DE LA CABEZA"
  },
  {
    "codigo":1339017006,
    "descripcion":"TRASTORNO DE MÉDULA ÓSEA CAUSADO POR RADIACIÓN IONIZANTE"
  },
  {
    "codigo":346401000119108,
    "descripcion":"DEGENERACIÓN MACULAR CISTOIDE DE AMBAS RETINAS"
  },
  {
    "codigo":716425008,
    "descripcion":"CAPAZ DE MOVILIZARSE EN INTERIORES CON SILLA DE RUEDAS MOTORIZADA"
  },
  {
    "codigo":93833009,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE HUESO ILÍACO"
  },
  {
    "codigo":288606006,
    "descripcion":"UTILIZA LOS ELEMENTOS DEL LENGUAJE"
  },
  {
    "codigo":254003000,
    "descripcion":"FISURA SUBMUCOSA OCULTA DE PALADAR"
  },
  {
    "codigo":286771001,
    "descripcion":"RASGO DE LA PERSONALIDAD: ESCRUPULOSIDAD - HALLAZGO"
  },
  {
    "codigo":91998009,
    "descripcion":"NEOPLASIA BENIGNA DE VASO SANGUÍNEO DE DEDO DE LA MANO"
  },
  {
    "codigo":1237043002,
    "descripcion":"METÁSTASIS DE CARCINOMA DE CURVATURA MAYOR DE ESTÓMAGO"
  },
  {
    "codigo":16035551000119100,
    "descripcion":"OSTEÓLISIS DE RADIO IZQUIERDO"
  },
  {
    "codigo":235231000119100,
    "descripcion":"OSTEOFITO"
  },
  {
    "codigo":10680031000119101,
    "descripcion":"TUMEFACCIÓN DEL TEJIDO CELULAR SUBCUTÁNEO DEL ANTEBRAZO DERECHO"
  },
  {
    "codigo":16045791000119102,
    "descripcion":"ALTERACIÓN DE LA ALINEACIÓN DE LA ARTICULACIÓN SACROILÍACA IZQUIERDA"
  },
  {
    "codigo":16040671000119104,
    "descripcion":"ARTRITIS IDIOPÁTICA JUVENIL DE INICIO SISTÉMICO DE PIE IZQUIERDO"
  },
  {
    "codigo":352991000119105,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE HUESO DE MANO DERECHA"
  },
  {
    "codigo":11844831000119106,
    "descripcion":"LESIÓN TRAUMÁTICA DE ARTERIA VERTEBRAL IZQUIERDA"
  },
  {
    "codigo":294111000119107,
    "descripcion":"HEMIPLEJÍA DE LADO IZQUIERDO NO DOMINANTE"
  },
  {
    "codigo":10633951000119108,
    "descripcion":"CELULITIS DE MIEMBRO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":317151000119105,
    "descripcion":"PANICULITIS DE CUELLO Y TÓRAX"
  },
  {
    "codigo":10685151000119101,
    "descripcion":"TUMORACIÓN DE LA PIEL DEL CUELLO"
  },
  {
    "codigo":304351000119102,
    "descripcion":"GOTA CRÓNICA DE MUÑECA, SIN TOFO, DEBIDA A DISFUNCIÓN RENAL"
  },
  {
    "codigo":448776002,
    "descripcion":"SARCOMA DE VÉRTEBRA"
  },
  {
    "codigo":250591000119109,
    "descripcion":"HIPERPLASIA SUPRARRENAL CONGÉNITA PERDEDORA DE SAL CON VIRILIZACIÓN"
  },
  {
    "codigo":55560002,
    "descripcion":"HERPES ZÓSTER DISEMINADO"
  },
  {
    "codigo":1074911000119106,
    "descripcion":"ARTRITIS DE TOBILLO DERECHO"
  },
  {
    "codigo":16043231000119108,
    "descripcion":"ARTRITIS IDIOPÁTICA JUVENIL MONOARTICULAR"
  },
  {
    "codigo":16265951000119109,
    "descripcion":"TRASTORNO DEPRESIVO MAYOR CONCOMITANTE CON EPISODIO ÚNICO DE ANSIEDAD"
  },
  {
    "codigo":1092831000119109,
    "descripcion":"NEFROPATÍA INTERSTICIAL POR TOXOPLASMA"
  },
  {
    "codigo":20957000,
    "descripcion":"TRASTORNO DEL METABOLISMO DE LOS CARBOHIDRATOS"
  },
  {
    "codigo":283101002,
    "descripcion":"ARAÑAZO DE MUSLO"
  },
  {
    "codigo":284936009,
    "descripcion":"DIFICULTAD PARA ADAPTAR ROPA PARA EL BAÑO"
  },
  {
    "codigo":414173003,
    "descripcion":"DEGENERACIÓN MACULAR SENIL EXUDATIVA"
  },
  {
    "codigo":281266006,
    "descripcion":"MUESTRA NO RECIBIDA"
  },
  {
    "codigo":445106006,
    "descripcion":"DILATACIÓN CONGÉNITA DE ARTERIA PULMONAR IZQUIERDA"
  },
  {
    "codigo":248498007,
    "descripcion":"VENAS EPIGÁSTRICAS DILATADAS"
  },
  {
    "codigo":707250009,
    "descripcion":"SÍNDROME VULVOVAGINAL-GINGIVAL"
  },
  {
    "codigo":215730008,
    "descripcion":"LESIÓN SUFRIDA A BORDO DE MEDIO DE TRANSPORTE ACUÁTICO CAUSADA POR MAQUINARIA DE CARGA, OCUPANTE DE PEQUEÑA EMBARCACIÓN MOTORIZADA LESIONADO"
  },
  {
    "codigo":1264306007,
    "descripcion":"DERMATITIS LOCALIZADA CAUSADA POR SUSTANCIA ADMINISTRADA POR VÍA ORAL"
  },
  {
    "codigo":838322007,
    "descripcion":"NEUROPATÍA AUTONÓMICA DEBIDA A SÍNDROME DE ALLGROVE"
  },
  {
    "codigo":410503002,
    "descripcion":"ESOTROPÍA ADQUIRIDA"
  },
  {
    "codigo":246663009,
    "descripcion":"VISIÓN A TRAVÉS DE UNA CORTINA"
  },
  {
    "codigo":212060002,
    "descripcion":"QUEMADURA QUE COMPROMETE 20-29 PORCIENTO DE LA SUPERFICIE DEL CUERPO, CON QUEMADURA DE ESPESOR COMPLETO QUE AFECTA 10-19 PORCIENTO DE LA SUPERFICIE CORPORAL"
  },
  {
    "codigo":408668005,
    "descripcion":"HIPOTENSIÓN IATROGÉNICA"
  },
  {
    "codigo":80988005,
    "descripcion":"CRIOFIBRINOGENEMIA MIXTA"
  },
  {
    "codigo":111921000,
    "descripcion":"DERMATITIS CERCARIANA POR TRICHOBILHARZIA"
  },
  {
    "codigo":242993002,
    "descripcion":"PERFORACIÓN ACCIDENTAL DURANTE ATENCIÓN MÉDICA"
  },
  {
    "codigo":13617004,
    "descripcion":"TRAQUEOBRONQUITIS"
  },
  {
    "codigo":308529007,
    "descripcion":"ESTADO DE CONTROL CLÍNICO D"
  },
  {
    "codigo":77318000,
    "descripcion":"DIETA GENERAL PARA UN ADULTO"
  },
  {
    "codigo":208390002,
    "descripcion":"FRACTURA DE PRIMER METACARPIANO"
  },
  {
    "codigo":110086002,
    "descripcion":"LACERACIÓN COMPLEJA DE LA LENGUA"
  },
  {
    "codigo":10670831000119103,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN EN CODO DERECHO NO ESTADIFICABLE"
  },
  {
    "codigo":304859000,
    "descripcion":"RELACIÓN AMBIVALENTE"
  },
  {
    "codigo":75483001,
    "descripcion":"RESPIRACIÓN DOLOROSA"
  },
  {
    "codigo":1156827007,
    "descripcion":"FENÓMENO DE MARCUS-GUNN INVERTIDO"
  },
  {
    "codigo":202885001,
    "descripcion":"PELLIZCAMIENTO PERONEO DE TOBILLO"
  },
  {
    "codigo":432261003,
    "descripcion":"CANDIDEMIA"
  },
  {
    "codigo":366725004,
    "descripcion":"HALLAZGO RELACIONADO CON TONO MUSCULAR"
  },
  {
    "codigo":301189006,
    "descripcion":"HALLAZGO RELACIONADO CON UNA DEFORMIDAD NASAL"
  },
  {
    "codigo":299354003,
    "descripcion":"SIN AMPLITUD PASIVA DE EXTENSIÓN DE RODILLA"
  },
  {
    "codigo":364890005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA EMPUJAR Y TIRAR DE UN OBJETO AL CORRER"
  },
  {
    "codigo":15723401000119103,
    "descripcion":"GANGLIÓN DE REGIÓN DE AMBOS HOMBROS"
  },
  {
    "codigo":461359003,
    "descripcion":"ORIFICIO COMÚN DE ARTERIA CORONARIA"
  },
  {
    "codigo":1149487005,
    "descripcion":"BACTERIEMIA CAUSADA POR PSEUDOMONAS"
  },
  {
    "codigo":723503006,
    "descripcion":"SÍNDROME DE DEGENERACIÓN DE LA RETINA, NANOFTALMOS Y GLAUCOMA"
  },
  {
    "codigo":363055007,
    "descripcion":"TRASTORNO DEGENERATIVO DE CARTÍLAGO"
  },
  {
    "codigo":231983008,
    "descripcion":"EPITELITIS PIGMENTARIA RETINIANA"
  },
  {
    "codigo":262916001,
    "descripcion":"LESIÓN DE URETRA FEMENINA"
  },
  {
    "codigo":66308002,
    "descripcion":"FRACTURA DE HÚMERO"
  },
  {
    "codigo":721668003,
    "descripcion":"HIPERPLASIA LINFOIDE DE INTESTINO DELGADO"
  },
  {
    "codigo":230148000,
    "descripcion":"MENINGITIS POR STAPHYLOCOCCUS AUREUS"
  },
  {
    "codigo":415624002,
    "descripcion":"ÚLCERA GÁSTRICA POR ESTRÉS"
  },
  {
    "codigo":789039008,
    "descripcion":"TAQUICARDIA AURICULAR MACRO-REENTRANTE MEDIADA POR CICATRIZ"
  },
  {
    "codigo":295684008,
    "descripcion":"SOBREDOSIS DE DOXORUBICINA"
  },
  {
    "codigo":719833004,
    "descripcion":"SÍNDROME DE NEUROPATÍA VISCERAL Y ANOMALÍA CEREBRAL CON DISMORFISMO FACIAL Y RETRASO DEL DESARROLLO"
  },
  {
    "codigo":11791241000119108,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE MANO IZQUIERDA"
  },
  {
    "codigo":228313008,
    "descripcion":"BEBE ALCOHOL EN FORMA IRREGULAR DURANTE LA SEMANA"
  },
  {
    "codigo":293849009,
    "descripcion":"ALERGIA A CITALOPRAM"
  },
  {
    "codigo":132131000119102,
    "descripcion":"TROMBOSIS VENOSA PROFUNDA CRÓNICA DE PANTORRILLA"
  },
  {
    "codigo":95406004,
    "descripcion":"REACCIÓN MEDICAMENTOSA EN EL SITIO DE IMPLANTE"
  },
  {
    "codigo":292014005,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR NITRATO"
  },
  {
    "codigo":160942007,
    "descripcion":"SÓLO TELÉFONO PÚBLICO"
  },
  {
    "codigo":290179003,
    "descripcion":"INTOXICACIÓN INTENCIONAL CAUSADA POR CODEÍNA"
  },
  {
    "codigo":880003006,
    "descripcion":"DEFECTO RESIDUAL DE TABIQUE INTERVENTRICULAR POSTERIOR A PROCEDIMIENTO"
  },
  {
    "codigo":93571009,
    "descripcion":"OSIFICACIÓN INCOMPLETA DEL CARPO"
  },
  {
    "codigo":124504004,
    "descripcion":"DEFICIENCIA DE RENINA"
  },
  {
    "codigo":778029000,
    "descripcion":"ENCEFALOMIOPATÍA MITOCONDRIAL INFANTIL ASOCIADA CON FASTKD2"
  },
  {
    "codigo":255576009,
    "descripcion":"MENTIR"
  },
  {
    "codigo":288344008,
    "descripcion":"INCAPAZ DE TRANSPORTAR UN OBJETO"
  },
  {
    "codigo":286509001,
    "descripcion":"INCAPAZ DE SEGUIR LAS INSTRUCCIONES DE UNA RECETA"
  },
  {
    "codigo":253741006,
    "descripcion":"HENDIDURA TRAQUEOESOFÁGICA CONGÉNITA"
  },
  {
    "codigo":1269549007,
    "descripcion":"CON MAYOR RIESGO DE TRASTORNO FETAL"
  },
  {
    "codigo":712493008,
    "descripcion":"ENOFTALMOS CONCOMITANTE CON SÍNDROME DEL SENO SILENTE Y DEBIDO A ÉL"
  },
  {
    "codigo":415746003,
    "descripcion":"RUPTURA TRAUMÁTICA O NO TRAUMÁTICA DE TENDÓN"
  },
  {
    "codigo":105661000119103,
    "descripcion":"PROBLEMA CON CÓNYUGE O PAREJA ANCIANOS"
  },
  {
    "codigo":413911001,
    "descripcion":"PRESERVATIVO ENTREGADO"
  },
  {
    "codigo":282839002,
    "descripcion":"SE MUEVE DESDE UNA POSICIÓN"
  },
  {
    "codigo":679101000119104,
    "descripcion":"XEROSIS DE CÓRNEA DE OJO DERECHO"
  },
  {
    "codigo":10837181000119104,
    "descripcion":"FRACTURA EXPUESTA DE DIÁFISIS DE TERCER HUESO METACARPIANO DE MANO IZQUIERDA"
  },
  {
    "codigo":86231007,
    "descripcion":"EXHUMACIÓN PARA IDENTIFICACIÓN"
  },
  {
    "codigo":1231276000,
    "descripcion":"ENDOFTALMITIS EXÓGENA CAUSADA POR HONGOS"
  },
  {
    "codigo":351421000119105,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE RIÑÓN IZQUIERDO"
  },
  {
    "codigo":23741000119105,
    "descripcion":"TRASTORNO BIPOLAR I, MANÍACO SEVERO"
  },
  {
    "codigo":248236005,
    "descripcion":"MENTALMENTE DISTRAÍDO"
  },
  {
    "codigo":444844007,
    "descripcion":"APLASIA CONGÉNITA DE APÓFISIS ODONTOIDES"
  },
  {
    "codigo":17025000,
    "descripcion":"SÍNDROME DE EHLERS-DANLOS VASCULAR"
  },
  {
    "codigo":1088701000119107,
    "descripcion":"COLESTEATOMA DE MEMBRANA TIMPÁNICA IZQUIERDA"
  },
  {
    "codigo":79191000119101,
    "descripcion":"NECROSIS AVASCULAR DE HUESO COMO EFECTO TARDÍO DE OSTEOMIELITIS"
  },
  {
    "codigo":49793008,
    "descripcion":"ENFERMEDAD FAMILIAR DE LA NEURONA MOTORA"
  },
  {
    "codigo":15190000,
    "descripcion":"PÉRDIDA DE LA AUDICIÓN CONDUCTIVA A NIVEL DE LA MEMBRANA TIMPÁNICA"
  },
  {
    "codigo":1260374003,
    "descripcion":"EPILEPSIA DEBIDA A ENFERMEDAD INFECCIOSA CONGÉNITA"
  },
  {
    "codigo":703318003,
    "descripcion":"ESTENOSIS DE NEOVÁLVULA AÓRTICA"
  },
  {
    "codigo":406571004,
    "descripcion":"INFECCIÓN DEL SISTEMA NERVIOSO CENTRAL POR ECHOVIRUS"
  },
  {
    "codigo":373803006,
    "descripcion":"ESTADO DE DESEMPEÑO DE LA OMS, GRADO 0"
  },
  {
    "codigo":124680001,
    "descripcion":"DEFICIENCIA DE METILMALONILO - COA MUTASA"
  },
  {
    "codigo":109824000,
    "descripcion":"NEOPLASIA MALIGNA SUPERPUESTA DE GLÁNDULA SALIVAL MAYOR"
  },
  {
    "codigo":12203351000119106,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DE RODILLA IZQUIERDA"
  },
  {
    "codigo":44288006,
    "descripcion":"ANOMALÍA POR ANORMALIDAD ERITROCÍTICA EXTRÍNSECA"
  },
  {
    "codigo":208128007,
    "descripcion":"FRACTURA EXPUESTA DE LARINGE Y TRÁQUEA"
  },
  {
    "codigo":371968006,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LOS DOS TERCIOS ANTERIORES DE LA LENGUA"
  },
  {
    "codigo":1287637001,
    "descripcion":"MASTITIS PURULENTA ASOCIADA CON LACTANCIA"
  },
  {
    "codigo":763349002,
    "descripcion":"EPILEPSIA MIOCLÓNICA PROGRESIVA CON DISTONÍA"
  },
  {
    "codigo":1254869005,
    "descripcion":"LESIÓN DE PIEL PIGMENTADA DE NATURALEZA INCIERTA DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":304597009,
    "descripcion":"HALLAZGO DE PRUEBA DE HELICOBACTER EN SANGRE"
  },
  {
    "codigo":402901009,
    "descripcion":"LEUCOPLASIA VELLOSA BUCAL ASOCIADA A ENFERMEDAD POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":827050005,
    "descripcion":"PARÁLISIS DE NERVIO GLOSOFARÍNGEO"
  },
  {
    "codigo":106154007,
    "descripcion":"HALLAZGO EN EL CUARTO PAR CRANEAL"
  },
  {
    "codigo":300927001,
    "descripcion":"INFECCIÓN DE EPISIOTOMÍA"
  },
  {
    "codigo":6015002,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DE SITIOS MÚLTIPLES DE LA EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":366463006,
    "descripcion":"MATIDEZ ABDOMINAL CAMBIANTE"
  },
  {
    "codigo":200788001,
    "descripcion":"DERMATITIS DE CONTACTO CAUSADA POR HIDROCARBURO"
  },
  {
    "codigo":102484006,
    "descripcion":"SIGNO ASOCIADO"
  },
  {
    "codigo":36948007,
    "descripcion":"FASCITIS"
  },
  {
    "codigo":299092007,
    "descripcion":"AMPLITUD DE ABDUCCIÓN PASIVA DE DEDO DE LA MANO NORMAL"
  },
  {
    "codigo":168020009,
    "descripcion":"MICROSCOPIA DE LÍQUIDO ASCÍTICO, NO SE DETECTARON ANOMALÍAS"
  },
  {
    "codigo":1149225002,
    "descripcion":"SOBREDOSIS AGUDA"
  },
  {
    "codigo":461097005,
    "descripcion":"CONDUCTO ARTERIOSO BILATERAL CERRADO"
  },
  {
    "codigo":67881007,
    "descripcion":"PLACENTA ANULAR"
  },
  {
    "codigo":66046000,
    "descripcion":"DEGENERACIÓN QUÍSTICA DE LA GLÁNDULA LAGRIMAL"
  },
  {
    "codigo":197118003,
    "descripcion":"CONSTIPACIÓN FUNCIONAL"
  },
  {
    "codigo":262654003,
    "descripcion":"HEMATOMA DE SUPERFICIE INTRABUCAL DE LABIO"
  },
  {
    "codigo":681611000119103,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE CUELLO DE VEJIGA URINARIA"
  },
  {
    "codigo":721406008,
    "descripcion":"SÍNDROME DE BROWN-SEQUARD AL NIVEL DEL OCTAVO SEGMENTO CERVICAL"
  },
  {
    "codigo":129747004,
    "descripcion":"LESIÓN CON CONTENIDO DE GRASA (RADIOTRANSPARENTE)"
  },
  {
    "codigo":162515006,
    "descripcion":"DIETA CON ALTO CONTENIDO DE POLIINSATURADOS"
  },
  {
    "codigo":95144000,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA TRÁQUEA"
  },
  {
    "codigo":424659009,
    "descripcion":"INFESTACIÓN EN LA COMUNIDAD"
  },
  {
    "codigo":160680006,
    "descripcion":"MOVILIDAD COMPLETA"
  },
  {
    "codigo":717736007,
    "descripcion":"CARCINOMA DE CÉLULAS RENALES FAMILIAR"
  },
  {
    "codigo":226216006,
    "descripcion":"DIETA CON BAJO CONTENIDO DE ÁCIDO VAINILLILMANDÉLICO"
  },
  {
    "codigo":29608009,
    "descripcion":"EPIGLOTITIS AGUDA"
  },
  {
    "codigo":715901002,
    "descripcion":"EPENDIMOBLASTOMA"
  },
  {
    "codigo":1091211000119107,
    "descripcion":"OTOESCLEROSIS COCLEAR DE OÍDO DERECHO"
  },
  {
    "codigo":191613003,
    "descripcion":"TRASTORNO DEPRESIVO MAYOR, EPISODIOS RECURRENTES, GRAVE, CON SÍNTOMAS PSICÓTICOS"
  },
  {
    "codigo":224381005,
    "descripcion":"EN BÚSQUEDA DE TRABAJO"
  },
  {
    "codigo":93309008,
    "descripcion":"POSICIÓN ANÓMALA CONGÉNITA DE ARCO DE VÉRTEBRA SACRA"
  },
  {
    "codigo":1303890000,
    "descripcion":"GLAUCOMA DE ÁNGULO ABIERTO DE OJO DERECHO DEBIDO A SÍNDROME SISTÉMICO"
  },
  {
    "codigo":89639000,
    "descripcion":"UTILIZA ANTICONCEPCIÓN VAGINAL"
  },
  {
    "codigo":56871000,
    "descripcion":"AMILOIDOSIS LOCALIZADA"
  },
  {
    "codigo":124242009,
    "descripcion":"DEFICIENCIA DE BETAÍNA - HOMOCISTEÍNA METILTRANSFERASA"
  },
  {
    "codigo":253479002,
    "descripcion":"MALFORMACIÓN CONGÉNITA EN PARACAÍDAS DE VÁLVULA AURICULOVENTRICULAR DERECHA"
  },
  {
    "codigo":187943005,
    "descripcion":"NEOPLASIA MALIGNA DE HUESO DEL CARPO - GRANDE"
  },
  {
    "codigo":251644002,
    "descripcion":"PRUEBA GINECOLÓGICA - HALLAZGO"
  },
  {
    "codigo":22268004,
    "descripcion":"PROBLEMA LEGAL"
  },
  {
    "codigo":284412004,
    "descripcion":"CAPAZ DE MANTENER EL EQUILIBRIO AL INCLINARSE"
  },
  {
    "codigo":315345002,
    "descripcion":"LESIÓN TRAUMÁTICA PULMONAR AGUDA"
  },
  {
    "codigo":1003473002,
    "descripcion":"APLASIA MEDICAMENTOSA DE CÉLULAS B"
  },
  {
    "codigo":282577002,
    "descripcion":"INCAPAZ DE BRINCAR"
  },
  {
    "codigo":249809005,
    "descripcion":"DEFORMIDAD EN ADUCCIÓN DE PIE"
  },
  {
    "codigo":20433007,
    "descripcion":"FRACTURA DE EXTREMO SUPERIOR DE TIBIA"
  },
  {
    "codigo":870566003,
    "descripcion":"OCLUSIÓN DE ARTERIA COROIDEA ANTERIOR"
  },
  {
    "codigo":247974005,
    "descripcion":"CONDUCTA DESCONTROLADA"
  },
  {
    "codigo":213371001,
    "descripcion":"LUXACIONES, ESGUINCES Y DISTENSIONES QUE COMPROMETEN MÚLTIPLES REGIONES DE LOS MIEMBROS INFERIORES"
  },
  {
    "codigo":16763008,
    "descripcion":"HEMORRAGIA DE HÍGADO"
  },
  {
    "codigo":735824000,
    "descripcion":"RUPTURA TRAUMÁTICA DE LIGAMENTO LATERAL DE ARTICULACIÓN METACARPOFALÁNGICA DE MANO"
  },
  {
    "codigo":86280002,
    "descripcion":"TORACOMELO"
  },
  {
    "codigo":45861001,
    "descripcion":"TENDINITIS DE PATA DE GANSO"
  },
  {
    "codigo":703056009,
    "descripcion":"CAPNOCYTOPHAGA CANIMORSUS O CAPNOCYTOPHAGA CYNODEGMI"
  },
  {
    "codigo":209701003,
    "descripcion":"SECCIÓN EXPUESTA DE LIGAMENTO DE TOBILLO O PIE"
  },
  {
    "codigo":111397004,
    "descripcion":"SACAROPINURIA"
  },
  {
    "codigo":766757006,
    "descripcion":"CARCINOMA DE ESTÓMAGO INDIFERENCIADO"
  },
  {
    "codigo":15675481000119102,
    "descripcion":"TENDINITIS DE PIE IZQUIERDO"
  },
  {
    "codigo":78629008,
    "descripcion":"DEFICIENCIA TOTAL DEL AUTOCUIDADO"
  },
  {
    "codigo":1354746003,
    "descripcion":"FRACTURA DE UNDÉCIMA COSTILLA"
  },
  {
    "codigo":11258006,
    "descripcion":"TIÑA DE LA BARBA POR TRICHOPHYTON MENTAGROPHYTES"
  },
  {
    "codigo":109562007,
    "descripcion":"CORIOANGIOSIS"
  },
  {
    "codigo":238799002,
    "descripcion":"LINFANGIOMA CIRCUNSCRIPTO"
  },
  {
    "codigo":304335003,
    "descripcion":"SIN MOVIMIENTO DE ARTICULACIÓN SUBASTRAGALINA"
  },
  {
    "codigo":402639004,
    "descripcion":"ALOPECIA POR FRICCIÓN Y TRAUMATISMO"
  },
  {
    "codigo":271567008,
    "descripcion":"SÍNDROME TIPO TOS FERINA"
  },
  {
    "codigo":1285540008,
    "descripcion":"NEOVASCULOPATÍA PAQUICOROIDEA"
  },
  {
    "codigo":204196008,
    "descripcion":"ANOMALÍAS CONGÉNITAS DE PÁRPADO, SISTEMA LAGRIMAL Y ÓRBITA"
  },
  {
    "codigo":235129002,
    "descripcion":"QUISTE POR RETENCIÓN MUCOSA DE LA GLÁNDULA SALIVAL MENOR"
  },
  {
    "codigo":300665005,
    "descripcion":"INCAPAZ DE REALIZAR EJERCICIO DE SEGURIDAD VIAL"
  },
  {
    "codigo":5753006,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA VENA RENAL"
  },
  {
    "codigo":366201008,
    "descripcion":"HALLAZGO DEL VOLUMEN DEL PULSO"
  },
  {
    "codigo":431737008,
    "descripcion":"INFECCIÓN AGUDA DEL TRACTO URINIARIO INFERIOR"
  },
  {
    "codigo":724814005,
    "descripcion":"NEUROPATÍA AUTONÓMICA DEBIDA A CANALOPATIA DE SODIO"
  },
  {
    "codigo":298830008,
    "descripcion":"SIN AMPLITUD DE ROTACIÓN INTERNA PASIVA DE ARTICULACIÓN DE HOMBRO"
  },
  {
    "codigo":296995006,
    "descripcion":"SOBREDOSIS DE ANTIARRÍTMICO DE CLASE II"
  },
  {
    "codigo":231459008,
    "descripcion":"PATRÓN DE USO NOCIVO DE ANALGÉSICO NO PSICOTRÓPICO"
  },
  {
    "codigo":722979008,
    "descripcion":"DEMENCIA DEBIDA A ANOMALÍA METABÓLICA"
  },
  {
    "codigo":426232007,
    "descripcion":"ALERGIA AMBIENTAL"
  },
  {
    "codigo":196856007,
    "descripcion":"ONFALOCELE CON GANGRENA"
  },
  {
    "codigo":424397003,
    "descripcion":"CLASE IV DE MALLAMPATI"
  },
  {
    "codigo":195021004,
    "descripcion":"MIOCARDIOPATÍA DILATADA PRIMARIA"
  },
  {
    "codigo":94882002,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL ISQUION"
  },
  {
    "codigo":783010003,
    "descripcion":"VARIANTE FARINGOCERVICOBRAQUIAL DE SÍNDROME DE GUILLAIN-BARRÉ"
  },
  {
    "codigo":225954007,
    "descripcion":"INGESTA DE LÍQUIDOS REDUCIDA ANTES DE ACOSTARSE"
  },
  {
    "codigo":193186008,
    "descripcion":"POLINEUROPATÍA ASOCIADA CON OTRO TRASTORNO"
  },
  {
    "codigo":291490007,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR NETILMICINA"
  },
  {
    "codigo":289655005,
    "descripcion":"FONDO UTERINO DESPLAZADO POR DEBAJO DEL INTROITO"
  },
  {
    "codigo":1172556000,
    "descripcion":"ESTRIOL EN SUERO POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":255052006,
    "descripcion":"NEOPLASIA MALIGNA DE ORIGEN DESCONOCIDO"
  },
  {
    "codigo":187681002,
    "descripcion":"NEOPLASIA MALIGNA DE LA EPIGLOTIS ANTERIOR"
  },
  {
    "codigo":449825003,
    "descripcion":"CELULITIS DE PULGAR"
  },
  {
    "codigo":253217007,
    "descripcion":"ORIFICIO LAGRIMAL IMPERFORADO"
  },
  {
    "codigo":15950221000119108,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE PIEL DE MAMA IZQUIERDA"
  },
  {
    "codigo":285985009,
    "descripcion":"INCAPAZ DE ENCENDER EL CONDUCTOR ELÉCTRICO PRINCIPAL"
  },
  {
    "codigo":710134003,
    "descripcion":"RIGIDEZ MUSCULAR AGUDA DE CUELLO"
  },
  {
    "codigo":284150003,
    "descripcion":"CAPAZ DE MOVER LA PIERNA"
  },
  {
    "codigo":218614006,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR DICLOFENACO SÓDICO"
  },
  {
    "codigo":22006008,
    "descripcion":"HIPERTELORISMO OCULAR"
  },
  {
    "codigo":447990008,
    "descripcion":"PAPILOMA DE LABIO"
  },
  {
    "codigo":282315002,
    "descripcion":"DIFICULTAD PARA MANTENER EL EQUILIBRIO EN BIPEDESTACIÓN"
  },
  {
    "codigo":415222009,
    "descripcion":"TUBERCULOSIS RESISTENTE A LA PIRAZINAMIDA"
  },
  {
    "codigo":18336000,
    "descripcion":"FRACTURA EXPUESTA DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":870304004,
    "descripcion":"TRASTORNO GENERALIZADO DEL DESARROLLO CON ALTERACIÓN COMPLETA DEL LENGUAJE FUNCIONAL SIN PÉRDIDA DE HABILIDADES ADQUIRIDAS PREVIAMENTE"
  },
  {
    "codigo":12237351000119106,
    "descripcion":"ANEURISMA DE ARTERIA DE MIEMBRO INFERIOR IZQUIERDO"
  },
  {
    "codigo":313248004,
    "descripcion":"MELANOMA MALIGNO DE LA PARED TORÁCICA"
  },
  {
    "codigo":247712008,
    "descripcion":"PERCEPCIÓN AUMENTADA"
  },
  {
    "codigo":47880003,
    "descripcion":"AUSENCIA CONGÉNITA DE MÚSCULO Y\/O TENDÓN"
  },
  {
    "codigo":332481000119102,
    "descripcion":"DEGENERACIÓN EN ENCAJE DE RETINA DERECHA"
  },
  {
    "codigo":473418001,
    "descripcion":"ADENOMA MUCINOSO PAPILAR INTRADUCTAL DE PÁNCREAS"
  },
  {
    "codigo":278645008,
    "descripcion":"PACIENTE INCAPAZ DE UTILIZAR DISPOSITIVO ORTODÓNCICO"
  },
  {
    "codigo":211274004,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN LA MUÑECA"
  },
  {
    "codigo":47434006,
    "descripcion":"SÍNDROME DE WAARDENBURG"
  },
  {
    "codigo":735562007,
    "descripcion":"INFECCIÓN QUE CAUSA QUISTE DEL SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":276810009,
    "descripcion":"CÁNCER GÁSTRICO TARDÍO"
  },
  {
    "codigo":300424000,
    "descripcion":"HALLAZGO RELACIONADO CON MATIDEZ ABDOMINAL"
  },
  {
    "codigo":1290783004,
    "descripcion":"FRACTURA POR SOBRECARGA DE HUESO DE REGIÓN DE CADERA"
  },
  {
    "codigo":209439007,
    "descripcion":"ESGUINCE DE ARTICULACIÓN CARPIANA"
  },
  {
    "codigo":109300000,
    "descripcion":"MIOSITIS PROLIFERATIVA"
  },
  {
    "codigo":240372001,
    "descripcion":"CICLOSPORIASIS"
  },
  {
    "codigo":305908005,
    "descripcion":"ATENDIDO EN HOSPITAL DE DÍA PSIQUIÁTRICO"
  },
  {
    "codigo":830196006,
    "descripcion":"CORDOMA DE COLUMNA VERTEBRAL CERVICAL"
  },
  {
    "codigo":402377001,
    "descripcion":"ENFERMEDAD DE CROHN DEL ESCROTO"
  },
  {
    "codigo":60251000119101,
    "descripcion":"TRASTORNO DE CONTROL DE IMPULSOS EN REMISIÓN"
  },
  {
    "codigo":238537004,
    "descripcion":"DERMATITIS POR CACTUS"
  },
  {
    "codigo":205769006,
    "descripcion":"SITUS INVERSUS CON LEVOCARDIA"
  },
  {
    "codigo":203934001,
    "descripcion":"ESPINA BÍFIDA CERVICAL CON HIDROCEFALIA"
  },
  {
    "codigo":105630005,
    "descripcion":"ENFERMEDAD CAUSADA POR POXVIRIDAE"
  },
  {
    "codigo":7326005,
    "descripcion":"SIGNOS ELECTROCARDIOGRÁFICOS DE INFARTO INFERIOR"
  },
  {
    "codigo":236702008,
    "descripcion":"CISTITIS AGUDA CON CULTIVO POSITIVO"
  },
  {
    "codigo":365939001,
    "descripcion":"HALLAZGO RELACIONADO CON LA AUTOESTIMA"
  },
  {
    "codigo":202099003,
    "descripcion":"MENISCO EXTERNO DISCOIDE"
  },
  {
    "codigo":726387003,
    "descripcion":"DELECIÓN DE PARTE DEL CROMOSOMA 16"
  },
  {
    "codigo":300403005,
    "descripcion":"DISTENSIÓN ABDOMINAL LOCALIZADA"
  },
  {
    "codigo":724552002,
    "descripcion":"CARCINOMA PRIMARIO ESCASAMENTE DIFERENCIADO DE GLÁNDULA TIROIDES"
  },
  {
    "codigo":1052232003,
    "descripcion":"SUPRESIÓN DE SEÑAL VISUAL DE OJO DERECHO"
  },
  {
    "codigo":69192004,
    "descripcion":"TRAQUIONIQUIA"
  },
  {
    "codigo":306011000119106,
    "descripcion":"TRASTORNO DE LIGAMENTO DE ARTICULACIÓN DE MANO IZQUIERDA"
  },
  {
    "codigo":396872002,
    "descripcion":"MARGEN QUIRÚRGICO PANCREÁTICO RETROPERITONEAL POSTERIOR INVADIDO POR TUMOR"
  },
  {
    "codigo":1821000,
    "descripcion":"APNEA POR QUIMIORRECEPTOR"
  },
  {
    "codigo":34589004,
    "descripcion":"DIENTE FILOSO"
  },
  {
    "codigo":165661006,
    "descripcion":"FOLATO ERITROCÍTICO FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":296733007,
    "descripcion":"SOBREDOSIS DE CEFTRIAXONA"
  },
  {
    "codigo":360434004,
    "descripcion":"AGANGLIONOSIS DEL PLEXO DE AUERBACH"
  },
  {
    "codigo":131058006,
    "descripcion":"NIVEL DE 11 - DESOXI, 17 - HIDROXICORTICOSTERONA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":294898007,
    "descripcion":"ALERGIA A FUMARATO FERROSO"
  },
  {
    "codigo":1179634008,
    "descripcion":"DISTRÉS RESPIRATORIO EN PERÍODO NEONATAL TEMPRANO"
  },
  {
    "codigo":719047001,
    "descripcion":"SÍNDROME DE MICRODELECIÓN 14Q11.2"
  },
  {
    "codigo":260295004,
    "descripcion":"VE LOS MOVIMIENTOS DE LA MANO"
  },
  {
    "codigo":161991006,
    "descripcion":"VENAS ABDOMINALES PROMINENTES"
  },
  {
    "codigo":61852001,
    "descripcion":"HIPOPLASIA CONGÉNITA PARCIAL DE RIÑÓN"
  },
  {
    "codigo":94620005,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE HUESO DEL TARSO"
  },
  {
    "codigo":291228006,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR OXIPERTINA"
  },
  {
    "codigo":60017001,
    "descripcion":"CICLOFORIA"
  },
  {
    "codigo":29084009,
    "descripcion":"CUERPO EXTRAÑO EN CUALQUIER PARTE DEL ÚTERO"
  },
  {
    "codigo":717212009,
    "descripcion":"SPHINGOBACTERIUM MULTIVORUM O SPHINGOBACTERIUM SPIRITIVORUM"
  },
  {
    "codigo":127388009,
    "descripcion":"HIPERGAMMAGLOBULINEMIA"
  },
  {
    "codigo":92785008,
    "descripcion":"CARCINOMA IN SITU DEL CUELLO DE LA VEJIGA"
  },
  {
    "codigo":289393009,
    "descripcion":"NARIZ FETAL PALPABLE POR VÍA VAGINAL"
  },
  {
    "codigo":1336134002,
    "descripcion":"ALTERACIÓN DE ARTICULACIÓN RADIOCARPIANA IZQUIERDA"
  },
  {
    "codigo":254790003,
    "descripcion":"HEMANGIOMA HEMOSIDERÓTICO CON HALO"
  },
  {
    "codigo":123718001,
    "descripcion":"CITOPENIA PRIMARIA"
  },
  {
    "codigo":713542007,
    "descripcion":"HIPERTENSIÓN PORTAL CAUSADA POR FÁRMACO ANTIRRETROVIRAL"
  },
  {
    "codigo":1137691001,
    "descripcion":"TRATA DE ABANDONAR EL USO DE CIGARRILLO ELECTRÓNICO"
  },
  {
    "codigo":56347002,
    "descripcion":"VITILIGO PROVOCADO POR PINTA"
  },
  {
    "codigo":449563001,
    "descripcion":"AUSENCIA DE CUERDAS TENDINOSAS PRIMARIAS DE VÁLVULA MITRAL"
  },
  {
    "codigo":1332464001,
    "descripcion":"HIPERTENSIÓN EN ENFERMEDAD RENAL CRÓNICA EN ESTADIO 2 DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":251120003,
    "descripcion":"BLOQUEO INCOMPLETO DE LA RAMA IZQUIERDA DEL HAZ DE HIS"
  },
  {
    "codigo":54512006,
    "descripcion":"REACCIÓN INMUNE NO ESPECÍFICA"
  },
  {
    "codigo":708037001,
    "descripcion":"TRASTORNO DE ASPERGER RESIDUAL"
  },
  {
    "codigo":15981711000119107,
    "descripcion":"SÍNDROME DE HIPERLAXITUD PALPEBRAL DE OJO DERECHO"
  },
  {
    "codigo":282053003,
    "descripcion":"CONTUSIÓN DE YEYUNO"
  },
  {
    "codigo":183749003,
    "descripcion":"CONSULTA DOMICILIARIA PSICOGERIÁTRICA, REALIZADA"
  },
  {
    "codigo":118213005,
    "descripcion":"HALLAZGO POSTPARTO"
  },
  {
    "codigo":249285005,
    "descripcion":"SIN CONCIENCIA SOBRE LA NECESIDAD DE ORINAR"
  },
  {
    "codigo":85445006,
    "descripcion":"DICÉFALO DIPUS TETRABRAQUIO"
  },
  {
    "codigo":1363397002,
    "descripcion":"NEOVASCULARIZACIÓN DE CUADRANTE SUPERIOR DE ÁNGULO IRIDOCORNEAL DE OJO IZQUIERDO"
  },
  {
    "codigo":52677002,
    "descripcion":"DEFICIENCIA DE N - ACETILGALACTOSAMINA - 4 - SULFATASA"
  },
  {
    "codigo":444058005,
    "descripcion":"VIRILIZACIÓN FEMENINA POR TRANSLOCACIÓN DEL GEN SRY"
  },
  {
    "codigo":1197722008,
    "descripcion":"LESIÓN DE DIEULAFOY DE INTESTINO DELGADO"
  },
  {
    "codigo":1163119007,
    "descripcion":"ENFERMEDAD DE CREUTZFELDT JAKOB POSTERIOR A INJERTO DE DURAMADRE"
  },
  {
    "codigo":212847009,
    "descripcion":"EFECTO TÓXICO DE FÓSFORO Y\/O COMPUESTOS DE FÓSFORO"
  },
  {
    "codigo":704367009,
    "descripcion":"CON MAYOR RIESGO DE CONFLICTO ENTRE CREENCIA RELIGIOSA Y RECOMENDACIÓN DE ATENCIÓN SANITARIA"
  },
  {
    "codigo":211012003,
    "descripcion":"PICADURA INFECTADA DE INSECTO NO VENENOSO EN LA CABEZA"
  },
  {
    "codigo":473156005,
    "descripcion":"RETENCIÓN DE STENT URETERAL"
  },
  {
    "codigo":1259588007,
    "descripcion":"TRASTORNO TARDÍO DE SUSTANCIA BLANCA CEREBRAL DEBIDO A HIPOXIA Y POSTERIOR A ELLA"
  },
  {
    "codigo":276548008,
    "descripcion":"TRASTORNOS DEL HÍGADO Y DEL SISTEMA BILIAR DURANTE EL PERÍODO PERINATAL"
  },
  {
    "codigo":702532009,
    "descripcion":"CON BAJO RIESGO DE EXPERIMENTAR DAÑOS POR ACCIONES DE OTROS"
  },
  {
    "codigo":1290521002,
    "descripcion":"RADIOGRAFÍA DE PERONÉ ANORMAL"
  },
  {
    "codigo":373017003,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM BRUMAE"
  },
  {
    "codigo":405785004,
    "descripcion":"CON MAYOR RIESGO DE RECIDIVA"
  },
  {
    "codigo":241945005,
    "descripcion":"ANAFILAXIS NO ALÉRGICA CAUSADA POR INMUNOGLOBULINA"
  },
  {
    "codigo":897305005,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE MIEMBRO INFERIOR CON INFECCIÓN"
  },
  {
    "codigo":79940008,
    "descripcion":"INTOXICACIÓN POR MELICA DECUMBENS"
  },
  {
    "codigo":305646000,
    "descripcion":"ATENDIDO POR ESPECIALISTA EN CUIDADOS INTENSIVOS PEDIÁTRICOS"
  },
  {
    "codigo":698862003,
    "descripcion":"LACERACIÓN DE HÍGADO CON HERIDA ABIERTA EN CAVIDAD ABDOMINAL"
  },
  {
    "codigo":403950007,
    "descripcion":"ADENOCARCINOMA DE LA GLÁNDULA DE MOLL"
  },
  {
    "codigo":240110008,
    "descripcion":"GANGRENA GASEOSA INTESTINAL"
  },
  {
    "codigo":860867001,
    "descripcion":"INTERTRIGO GENITOCRURAL CAUSADO POR CANDIDA"
  },
  {
    "codigo":1286851007,
    "descripcion":"CIERRE DE ÁNGULO DEBIDO A SÍNDROME ENDOTELIAL IRIDOCORNEAL"
  },
  {
    "codigo":301976001,
    "descripcion":"DRENAJE DE LÁGRIMAS CON FLUORESCEÍNA ALTERADO"
  },
  {
    "codigo":255581000119100,
    "descripcion":"CRANEOSINOSTOSIS SIMPLE"
  },
  {
    "codigo":234605000,
    "descripcion":"DEFICIENCIA DEL FACTOR B"
  },
  {
    "codigo":1186712009,
    "descripcion":"INMUNODEFICIENCIA COMBINADA POR DEFICIENCIA DE CARMIL2"
  },
  {
    "codigo":39832008,
    "descripcion":"MANCHAS RETINIANAS ALGODONOSAS"
  },
  {
    "codigo":1217645003,
    "descripcion":"MACULOPATÍA ISQUÉMICA DEBIDA A OCLUSIÓN DE VENA CENTRAL DE LA RETINA"
  },
  {
    "codigo":201837004,
    "descripcion":"ARTROSIS PRIMARIA LOCALIZADA, DE TOBILLO Y\/O PIE"
  },
  {
    "codigo":365677005,
    "descripcion":"CANTIDAD DE HECES - HALLAZGO"
  },
  {
    "codigo":70765006,
    "descripcion":"TEMBLOR MERCURIAL"
  },
  {
    "codigo":300141006,
    "descripcion":"DEFORMACIÓN DE LA MEMBRANA TIMPÁNICA"
  },
  {
    "codigo":1074781000119102,
    "descripcion":"ARTRITIS BILATERAL DE PRIMERAS ARTICULACIONES CARPOMETACARPIANAS"
  },
  {
    "codigo":298306002,
    "descripcion":"HALLAZGO RELACIONADO CON EL EQUILIBRIO EN BIPEDESTACIÓN"
  },
  {
    "codigo":167234002,
    "descripcion":"ORINA: DILUIDA"
  },
  {
    "codigo":36162004,
    "descripcion":"PÓLIPO ADENOMATOSO HIPERPLÁSICO DE ESTÓMAGO"
  },
  {
    "codigo":296471000,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE TRETINOÍNA"
  },
  {
    "codigo":722455002,
    "descripcion":"SÍNDROME DE DISCAPACIDAD INTELECTUAL, CUERPO CALLOSO HIPOPLÁSICO Y APÉNDICE PREAURICULAR"
  },
  {
    "codigo":34327003,
    "descripcion":"HEMORRAGIA ASOCIADA CON HIPERFIBRINÓLISIS DE LAS PARTURIENTAS"
  },
  {
    "codigo":165399006,
    "descripcion":"HEMOGLOBINA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":425708006,
    "descripcion":"DEFICIENCIA DE AROMATASA PLACENTARIA"
  },
  {
    "codigo":63425006,
    "descripcion":"HERNIA INGUINAL SUPERFICIAL"
  },
  {
    "codigo":1306774000,
    "descripcion":"GLAUCOMA BILATERAL POR DEPÓSITO DE PARTÍCULAS DE CRISTALINO"
  },
  {
    "codigo":30657009,
    "descripcion":"QUEILITIS GLANDULAR, TIPO SUPURATIVO PROFUNDO"
  },
  {
    "codigo":10632951000119102,
    "descripcion":"CELULITIS DE MUSLO IZQUIERDO"
  },
  {
    "codigo":782486000,
    "descripcion":"ENFERMEDAD CAUSADA POR CESTODO DE DIPHYLLOBOTHRIIDEA"
  },
  {
    "codigo":292801008,
    "descripcion":"REACCIÓN ADVERSA A LA FLUCITOSINA"
  },
  {
    "codigo":127126001,
    "descripcion":"LINFADENOPATÍA DEL ANILLO LINFÁTICO DEL CARDIAS DEL ESTÓMAGO"
  },
  {
    "codigo":290966006,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR VIGABATRINA"
  },
  {
    "codigo":94358004,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA REGIÓN DE UNIÓN DE LA EPIGLOTIS"
  },
  {
    "codigo":92523001,
    "descripcion":"CARCINOMA IN SITU DE SENO PARANASAL"
  },
  {
    "codigo":289131001,
    "descripcion":"REALIZA ACTIVIDADES DE CUIDADO DEL CABELLO"
  },
  {
    "codigo":715115001,
    "descripcion":"SE TRANSFIERE DEL AUTOMÓVIL A LA SILLA DE RUEDAS"
  },
  {
    "codigo":1335872000,
    "descripcion":"ICTERICIA NEONATAL PRECOZ DEBIDA A HEPATITIS"
  },
  {
    "codigo":188992001,
    "descripcion":"LIPOMA DE LA PARED TORÁCICA POSTERIOR"
  },
  {
    "codigo":254528004,
    "descripcion":"NEOPLASIA DE CARTÍLAGO LARÍNGEO"
  },
  {
    "codigo":16039671000119106,
    "descripcion":"CONDROMALACIA DE AMBAS ARTICULACIONES GLENOHUMERALES"
  },
  {
    "codigo":90688005,
    "descripcion":"SÍNDROME DE INSUFICIENCIA RENAL CRÓNICA"
  },
  {
    "codigo":57920007,
    "descripcion":"GINGIVOESTOMATITIS HERPÉTICA"
  },
  {
    "codigo":1237568007,
    "descripcion":"VENA VARICOSA DE TALÓN IZQUIERDO"
  },
  {
    "codigo":1268501005,
    "descripcion":"CARCINOMA TUBULOQUÍSTICO PRIMARIO DE CÉLULAS RENALES"
  },
  {
    "codigo":285461006,
    "descripcion":"CAPAZ DE ABRIR LA BOCA"
  },
  {
    "codigo":54250004,
    "descripcion":"INTOLERANCIA A LACTOSA EN NIÑOS SIN DEFICIENCIA DE LACTASA"
  },
  {
    "codigo":283626007,
    "descripcion":"HERIDA POR PINCHAZO DE AGUJA EN LA REGIÓN PÉLVICA"
  },
  {
    "codigo":1363135002,
    "descripcion":"ASTILLA EN PENE"
  },
  {
    "codigo":314559002,
    "descripcion":"QUERATITIS ADENOVIRAL"
  },
  {
    "codigo":11999121000119104,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO DE MANO DERECHA"
  },
  {
    "codigo":52415006,
    "descripcion":"PELVIS DE ASIMILACIÓN BAJA"
  },
  {
    "codigo":871615008,
    "descripcion":"ESTRECHAMIENTO ADQUIRIDO DE TÚNEL INTRAVENTRICULAR CARDÍACO CONSTRUIDO"
  },
  {
    "codigo":609471009,
    "descripcion":"INTERRUPCIÓN INDUCIDA DEL EMBARAZO COMPLICADA POR LACERACIÓN DE VAGINA"
  },
  {
    "codigo":247188005,
    "descripcion":"LESIÓN CORIORRETINIANA FOCAL"
  },
  {
    "codigo":771476007,
    "descripcion":"SÍNDROME DE LEUCOENCEFALOPATÍA, ACCIDENTE CEREBROVASCULAR ISQUÉMICO Y RETINITIS PIGMENTARIA, AUTOSÓMICO RECESIVO"
  },
  {
    "codigo":15685521000119107,
    "descripcion":"RETINITIS SIFILÍTICA IZQUIERDA"
  },
  {
    "codigo":15977008,
    "descripcion":"TRASTORNO DE ADAPTACIÓN, CON INHIBICIÓN ACADÉMICA"
  },
  {
    "codigo":866110001,
    "descripcion":"ABSCESO DE HÍGADO LINFOGÉNICO"
  },
  {
    "codigo":276286003,
    "descripcion":"HEMORRAGIA SUBARACNOIDEA PROVENIENTE DE ANEURISMA DE LA ARTERIA CARÓTIDA"
  },
  {
    "codigo":1259326007,
    "descripcion":"CARCINOMA PRIMARIO DE FRENILLO LABIAL SUPERIOR"
  },
  {
    "codigo":733203002,
    "descripcion":"HIPERTRICOSIS NO ANDROGÉNICA CONCOMITANTE CON ENFERMEDAD GENÉTICA Y DEBIDA A ELLA"
  },
  {
    "codigo":307219002,
    "descripcion":"SARCOMA RETROPERITONEAL"
  },
  {
    "codigo":208915004,
    "descripcion":"DESGARRO AGUDO DE MENISCO INTERNO, CUERNO ANTERIOR"
  },
  {
    "codigo":51231000087102,
    "descripcion":"ACTINOTIGNUM SANGUINIS O ACTINOTIGNUM SCHAALII"
  },
  {
    "codigo":40991000087102,
    "descripcion":"QUEMADURA DE GLÚTEO DERECHO"
  },
  {
    "codigo":43240000,
    "descripcion":"DIARREA DE ORIGEN PRESUNTAMENTE INFECCIOSO"
  },
  {
    "codigo":1222888000,
    "descripcion":"CICATRIZ DE POLO POSTERIOR DE RETINA"
  },
  {
    "codigo":43551000087106,
    "descripcion":"CONTUSIÓN DE PÁRPADO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":1255656000,
    "descripcion":"CARCINOMA DE CÉLULAS GIGANTES DE HIPOFARINGE"
  },
  {
    "codigo":46111000087108,
    "descripcion":"ESGUINCE DE LIGAMENTO SACROESPINOSO IZQUIERDO"
  },
  {
    "codigo":239848007,
    "descripcion":"BURSITIS GOTOSA"
  },
  {
    "codigo":762301001,
    "descripcion":"INESTABILIDAD ARTICULAR RECURRENTE"
  },
  {
    "codigo":41405005,
    "descripcion":"FIBRILACIÓN MUSCULAR"
  },
  {
    "codigo":238013008,
    "descripcion":"DEFICIENCIA DE LA COLINA FOSFOTRANSFERASA CITOSINA DIFOSFATO"
  },
  {
    "codigo":400018004,
    "descripcion":"ACROQUERATOSIS VERRUCIFORME DE ENFERMEDAD DE DARIER"
  },
  {
    "codigo":365415001,
    "descripcion":"HALLAZGO RELACIONADO CON EL COMPLEJO QRS DEL ELECTROCARDIOGRAMA"
  },
  {
    "codigo":4967002,
    "descripcion":"EVALUACIÓN DE DISCAPACIDAD: 99%"
  },
  {
    "codigo":267111003,
    "descripcion":"VEGANO O VEGETARIANO ESTRICTO"
  },
  {
    "codigo":1184615004,
    "descripcion":"AMBIENTE SUCIO"
  },
  {
    "codigo":168807005,
    "descripcion":"BRONCOGRAFÍA NORMAL"
  },
  {
    "codigo":70503004,
    "descripcion":"ESTADO HIPNÓTICO"
  },
  {
    "codigo":1217383007,
    "descripcion":"EPENDIMOMA SUPRATENTORIAL CON FUSIÓN POSITIVA DE GEN RELA"
  },
  {
    "codigo":299879008,
    "descripcion":"REFLEJO AQUÍLEO NORMAL"
  },
  {
    "codigo":234343008,
    "descripcion":"ANEMIA NORMOCÍTICA POR APLASIA"
  },
  {
    "codigo":396348002,
    "descripcion":"ECCEMA AGUDO"
  },
  {
    "codigo":201575009,
    "descripcion":"ARTRITIS REACTIVA DE PRIMERA ARTICULACIÓN METATARSOFALÁNGICA"
  },
  {
    "codigo":103271006,
    "descripcion":"DILATACIÓN DE LA PUPILA FIJA"
  },
  {
    "codigo":368991000119100,
    "descripcion":"INFECCIÓN DE LA VÍA URINARIA CAUSADA POR ENTEROCOCCUS"
  },
  {
    "codigo":134204007,
    "descripcion":"ACÚMULOS DE PLAQUETAS"
  },
  {
    "codigo":296209000,
    "descripcion":"SOBREDOSIS DE PERICIAZINA"
  },
  {
    "codigo":230673001,
    "descripcion":"DEFICIENCIA CONGÉNITA DE LA PLACA TERMINAL DEL RECEPTOR DE ACETILCOLINA"
  },
  {
    "codigo":1297003,
    "descripcion":"INFECCIÓN CAUSADA POR CLADOSPORIUM CARRIONII"
  },
  {
    "codigo":32230006,
    "descripcion":"SÍNDROME DE MALABSORCIÓN"
  },
  {
    "codigo":294374007,
    "descripcion":"ALERGIA A VALACICLOVIR"
  },
  {
    "codigo":292539006,
    "descripcion":"REACCIÓN ADVERSA A LA HOMATROPINA"
  },
  {
    "codigo":63163008,
    "descripcion":"EFECTO TÓXICO DE CARBARILO"
  },
  {
    "codigo":95931009,
    "descripcion":"CÓNYUGE DESATENDIDO"
  },
  {
    "codigo":390843008,
    "descripcion":"SENSIBILIDAD ESCOTÓPICA"
  },
  {
    "codigo":16671071000119105,
    "descripcion":"FRACTURA NO EXPUESTA DE ÁNGULO DE MANDÍBULA IZQUIERDA"
  },
  {
    "codigo":126864006,
    "descripcion":"NEOPLASIA DE PÁNCREAS ENDOCRINO"
  },
  {
    "codigo":1306512006,
    "descripcion":"CARCINOMA INFLAMATORIO PRIMARIO DE MAMA"
  },
  {
    "codigo":94096009,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE TIMO"
  },
  {
    "codigo":714853002,
    "descripcion":"LIMPIA AGUJAS"
  },
  {
    "codigo":342521000119101,
    "descripcion":"DERMATITIS ECCEMATOSA DE PÁRPADO SUPERIOR DERECHO"
  },
  {
    "codigo":92261004,
    "descripcion":"NEOPLASIA BENIGNA DE PALADAR"
  },
  {
    "codigo":288869004,
    "descripcion":"DIFICULTAD PARA BEBER CON UN SORBETE"
  },
  {
    "codigo":1079801000119102,
    "descripcion":"DERMATOFIBROMA DE MIEMBRO INFERIOR DERECHO"
  },
  {
    "codigo":254266000,
    "descripcion":"TRISOMÍA PARCIAL DEL CROMOSOMA 18 EN EL SÍNDROME DE EDWARD"
  },
  {
    "codigo":713018004,
    "descripcion":"ALERGIA A DARUNAVIR"
  },
  {
    "codigo":418106004,
    "descripcion":"HIFEMA TOTAL"
  },
  {
    "codigo":876858006,
    "descripcion":"ESTENOSIS DE LA RAMA CIRCUNFLEJA DE LA ARTERIA CORONARIA IZQUIERDA"
  },
  {
    "codigo":1237306007,
    "descripcion":"ARTROFIBROSIS DE RODILLA"
  },
  {
    "codigo":57658009,
    "descripcion":"INFARTO MESENTÉRICO EMBÓLICO"
  },
  {
    "codigo":283364000,
    "descripcion":"LACERACIÓN DE CUELLO"
  },
  {
    "codigo":23055009,
    "descripcion":"FRACTURA DE LA CAVIDAD GLENOIDEA Y DEL CUELLO DEL OMÓPLATO"
  },
  {
    "codigo":285199009,
    "descripcion":"CAPAZ DE RECORDAR EL NOMBRE DEL PRIMER MINISTRO ACTUAL"
  },
  {
    "codigo":840420004,
    "descripcion":"DISECCIÓN DE ARTERIA VERTEBRAL EXTRACRANEAL"
  },
  {
    "codigo":281529004,
    "descripcion":"FRACTURA DE APÓFISIS CORONOIDES DE CÚBITO"
  },
  {
    "codigo":1297337005,
    "descripcion":"CIERRE DE ÁNGULO AGUDO POSOPERATORIO DE AMBOS OJOS"
  },
  {
    "codigo":248761007,
    "descripcion":"PENETRACIÓN IMPOSIBLE"
  },
  {
    "codigo":707513007,
    "descripcion":"ASMA SEVERA PERSISTENTE NO COMPLICADA"
  },
  {
    "codigo":609209009,
    "descripcion":"INFECCIÓN DE SENO PREAURICULAR"
  },
  {
    "codigo":246926002,
    "descripcion":"VASCULARIZACIÓN CORNEAL PERIFÉRICA SUPERFICIAL INDUCIDA POR LENTES DE CONTACTO"
  },
  {
    "codigo":1295502007,
    "descripcion":"HIPERTENSIÓN OCULAR SECUNDARIA DE AMBOS OJOS"
  },
  {
    "codigo":83086008,
    "descripcion":"INTOXICACIÓN POR NICOTIANA GLAUCA"
  },
  {
    "codigo":115854008,
    "descripcion":"FENOTIPO GERBICH POSITIVO"
  },
  {
    "codigo":212323006,
    "descripcion":"LESIÓN ABIERTA DE NERVIO PERONEO PROFUNDO"
  },
  {
    "codigo":1259064004,
    "descripcion":"CEFALEA AGUDA POR LESIÓN DEBIDA A LATIGAZO"
  },
  {
    "codigo":470391000124100,
    "descripcion":"CEPILLADO DENTAL AUTÓNOMO"
  },
  {
    "codigo":1193528006,
    "descripcion":"TRASTORNO PERINATAL DE FETO Y\/O NEONATO DEBIDO A ANOMALÍA DE ESTRUCTURA AMNIÓTICA"
  },
  {
    "codigo":767544007,
    "descripcion":"CARCINOMA ESCAMOCELULAR INTRAEPITELIAL DE REGIÓN ANOGENITAL"
  },
  {
    "codigo":12045002,
    "descripcion":"TRIPTOFANURIA CON ENANISMO"
  },
  {
    "codigo":306957004,
    "descripcion":"CUERDA VOCAL NO ADUCE DURANTE LA RESPIRACIÓN"
  },
  {
    "codigo":896781006,
    "descripcion":"ATRESIA ADQUIRIDA DE VAGINA"
  },
  {
    "codigo":15635091000119108,
    "descripcion":"MASA DE AMBAS GLÁNDULAS PARÓTIDAS"
  },
  {
    "codigo":403426003,
    "descripcion":"PITIRIASIS ESTEATOIDE"
  },
  {
    "codigo":237751000,
    "descripcion":"HIPERPLASIA SUPRARRENAL CONGÉNITA"
  },
  {
    "codigo":1255394008,
    "descripcion":"CARCINOMA INDIFERENCIADO DE ENDOMETRIO"
  },
  {
    "codigo":303287007,
    "descripcion":"EQUIMOSIS DE LENGUA"
  },
  {
    "codigo":8375009,
    "descripcion":"RETROGNATISMO MAXILAR"
  },
  {
    "codigo":235916001,
    "descripcion":"ICTIOSIS CONGÉNITA CON ATRESIA BILIAR"
  },
  {
    "codigo":270519009,
    "descripcion":"DEFECTO CRANEANO LOCALIZADO CONGÉNITO"
  },
  {
    "codigo":432524006,
    "descripcion":"SÍNCOPE DEBIDO A HIPOTENSIÓN ORTOSTÁTICA"
  },
  {
    "codigo":103009000,
    "descripcion":"CEFALEA POR EXPOSICIÓN AL FRÍO"
  },
  {
    "codigo":168545001,
    "descripcion":"RADIOGRAFÍA SIMPLE DE MANDÍBULA NORMAL"
  },
  {
    "codigo":1153420008,
    "descripcion":"GOTA CRÓNICA CAUSADA POR PLOMO"
  },
  {
    "codigo":365153000,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA PASAR PÁGINAS"
  },
  {
    "codigo":397921003,
    "descripcion":"BLOQUEO DE CONDUCCIÓN NERVIOSA MOTORA - EN EXCESO"
  },
  {
    "codigo":345031000119101,
    "descripcion":"QUERATOCONJUNTIVITIS NEUROTRÓFICA BILATERAL"
  },
  {
    "codigo":234081006,
    "descripcion":"ANEURISMA VENOSO"
  },
  {
    "codigo":70241007,
    "descripcion":"TRASTORNO POR DEFICIENCIA NUTRICIONAL"
  },
  {
    "codigo":232246001,
    "descripcion":"PÓLIPO DE LA MEMBRANA TIMPÁNICA"
  },
  {
    "codigo":230411000,
    "descripcion":"CONVULSIONES BENIGNAS NO FAMILIARES EN EL RECIÉN NACIDO"
  },
  {
    "codigo":263179007,
    "descripcion":"FRACTURA DE APÓFISIS TRANSVERSA DE COLUMNA VERTEBRAL, CON LESIÓN DE LA MÉDULA ESPINAL"
  },
  {
    "codigo":359648001,
    "descripcion":"LEUCEMIA MIELOIDE AGUDA CON MADURACIÓN, FAB M2"
  },
  {
    "codigo":294112007,
    "descripcion":"ALERGIA A TERFENADINA"
  },
  {
    "codigo":95669001,
    "descripcion":"NEURALGIA DE NERVIO LARÍNGEO SUPERIOR"
  },
  {
    "codigo":10666951000119107,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN EN CABEZA NO ESTADIFICABLE"
  },
  {
    "codigo":292277001,
    "descripcion":"REACCIÓN ADVERSA AL CARBONATO DE LITIO"
  },
  {
    "codigo":1082311000119107,
    "descripcion":"CARCINOMA DE CÉLULAS DE TRANSICIÓN DE URÉTER DERECHO"
  },
  {
    "codigo":1177013005,
    "descripcion":"TUBERCULOSIS DE COLUMNA LUMBOSACRA"
  },
  {
    "codigo":423349005,
    "descripcion":"CARCINOMA DE LA PUNTA DE LA NARIZ"
  },
  {
    "codigo":1339018001,
    "descripcion":"TRASTORNO DE MÉDULA ESPINAL DEBIDO A RADIOTERAPIA Y POSTERIOR A ELLA"
  },
  {
    "codigo":93834003,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA REGIÓN INGUINAL"
  },
  {
    "codigo":15991751000119109,
    "descripcion":"IRITIS BILATERAL POR VIRUS DEL HERPES HUMANO 3"
  },
  {
    "codigo":318561000119103,
    "descripcion":"CIFOSIS DORSOLUMBAR POSTURAL ADQUIRIDA"
  },
  {
    "codigo":126602005,
    "descripcion":"NEOPLASIA DE PARTES BLANDAS DE LA CARA"
  },
  {
    "codigo":192138007,
    "descripcion":"DISLEXIA CONGÉNITA"
  },
  {
    "codigo":290442007,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR LACTULOSA"
  },
  {
    "codigo":91999001,
    "descripcion":"NEOPLASIA BENIGNA DE VASO SANGUÍNEO DEL PIE"
  },
  {
    "codigo":288607002,
    "descripcion":"NO EMPLEA LOS ELEMENTOS DEL LENGUAJE"
  },
  {
    "codigo":16702561000119104,
    "descripcion":"RETRASO PSICOMOTOR DEBIDO A ACCIDENTE CEREBROVASCULAR CON HEMORRAGIA INTRACRANEAL Y POSTERIOR A ÉL"
  },
  {
    "codigo":716426009,
    "descripcion":"CAPAZ DE MOVILIZARSE EN EL EXTERIOR CON SILLA DE RUEDAS MOTORIZADA"
  },
  {
    "codigo":190303007,
    "descripcion":"TRASTORNO EN LA SECRECIÓN DE TIROCALCITONINA"
  },
  {
    "codigo":11787361000119105,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE DEDO MEDIO DE MANO IZQUIERDA CON INFECCIÓN"
  },
  {
    "codigo":254004006,
    "descripcion":"DISPLASIA FRONTONASAL"
  },
  {
    "codigo":286772008,
    "descripcion":"CARÁCTER ESCRUPULOSO"
  },
  {
    "codigo":1237044008,
    "descripcion":"METÁSTASIS DE CARCINOMA DE CURVATURA MENOR DE ESTÓMAGO"
  },
  {
    "codigo":448777006,
    "descripcion":"VALVA DE VÁLVULA AURICULOVENTRICULAR SIN COAPTACIÓN EN DEFECTO DE TABIQUE AURICULOVENTRICULAR"
  },
  {
    "codigo":219401009,
    "descripcion":"HERIDA DE GUERRA POR EXPLOSIÓN ACCIDENTAL DE LAS MUNICIONES EMPLEADAS EN BATALLA"
  },
  {
    "codigo":20958005,
    "descripcion":"AMEBOMA"
  },
  {
    "codigo":53726008,
    "descripcion":"CONJUNTIVITIS AGUDA"
  },
  {
    "codigo":283102009,
    "descripcion":"ARAÑAZO DE RODILLA"
  },
  {
    "codigo":838323002,
    "descripcion":"MIOCLONÍA OPSOCLÓNICA AUTOINMUNITARIA"
  },
  {
    "codigo":1297075002,
    "descripcion":"POLIDIPSIA PRIMARIA ORGÁNICA"
  },
  {
    "codigo":16279481000119100,
    "descripcion":"OCLUSIÓN DE ARTERIAS CILIORRETINIANAS DE AMBOS OJOS"
  },
  {
    "codigo":105401000119101,
    "descripcion":"DIABETES MELLITUS DEBIDA A LESIÓN PANCREÁTICA"
  },
  {
    "codigo":1088441000119101,
    "descripcion":"INFLAMACIÓN CRÓNICA DE CAVIDAD MASTOIDEA IZQUIERDA"
  },
  {
    "codigo":11837881000119103,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO INTRÍNSECO DE DEDO MEDIO DE MANO DERECHA"
  },
  {
    "codigo":16097721000119104,
    "descripcion":"ARTROFIBROSIS DE ARTICULACIÓN DE MANO DERECHA"
  },
  {
    "codigo":707251008,
    "descripcion":"PERIODONTITIS CRÓNICA GENERALIZADA"
  },
  {
    "codigo":292281000119103,
    "descripcion":"COMPRESIÓN DE NERVIO OBTURADOR DERECHO"
  },
  {
    "codigo":82361000119107,
    "descripcion":"COMPORTAMIENTO ALTERADO EN LA DEMENCIA DEBIDA A COREA DE HUNTINGTON"
  },
  {
    "codigo":15688121000119108,
    "descripcion":"CAPSULITIS DE TARSO DERECHO"
  },
  {
    "codigo":10977721000119109,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR COAGULANTE"
  },
  {
    "codigo":15675321000119106,
    "descripcion":"TENDINITIS DE AMBOS MÚSCULOS FLEXORES LARGOS DE DEDO GORDO"
  },
  {
    "codigo":338361000119104,
    "descripcion":"RECESIÓN DEL ÁNGULO DE LA CÁMARA DEL OJO IZQUIERDO"
  },
  {
    "codigo":16845241000119104,
    "descripcion":"TUMOR GIST (GASTROINTESTINAL STROMAL TUMOR) DE GLÁNDULA SUPRARRENAL"
  },
  {
    "codigo":12198841000119108,
    "descripcion":"LUXACIÓN DE PRÓTESIS DE ARTICULACIÓN GLENOHUMERAL IZQUIERDA"
  },
  {
    "codigo":343481000119106,
    "descripcion":"DESPRENDIMIENTO SEROSO DE RETINA DE AMBOS OJOS"
  },
  {
    "codigo":90041000119109,
    "descripcion":"EDENTULISMO COMPLETO CLASE I"
  },
  {
    "codigo":12001721000119107,
    "descripcion":"HEMORRAGIA POSTERIOR A CREACIÓN DE FÍSTULA ARTERIOVENOSA QUIRÚRGICA"
  },
  {
    "codigo":410504008,
    "descripcion":"RESTRICCIÓN MUSCULAR EXTRAOCULAR"
  },
  {
    "codigo":212061003,
    "descripcion":"QUEMADURA QUE COMPROMETE 20-29 PORCIENTO DE LA SUPERFICIE DEL CUERPO, CON QUEMADURA DE ESPESOR COMPLETO QUE AFECTA 20-29 PORCIENTO DE LA SUPERFICIE CORPORAL"
  },
  {
    "codigo":15453007,
    "descripcion":"LUXACIÓN CONGÉNITA DE LA RODILLA CON GENU RECURVATUM"
  },
  {
    "codigo":277597005,
    "descripcion":"SÍNDROME MIELODISPLÁSICO CON DELECIÓN (5Q) AISLADA"
  },
  {
    "codigo":79154001,
    "descripcion":"INFECCIÓN CAUSADA POR MYXOBOLUS"
  },
  {
    "codigo":308530002,
    "descripcion":"SITUACIÓN DE CRIBADO EN ADULTO MAYOR"
  },
  {
    "codigo":408669002,
    "descripcion":"LARINGITIS AGUDA CON OBSTRUCCIÓN"
  },
  {
    "codigo":1084821000119103,
    "descripcion":"CISTITIS CAUSADA POR CHLAMYDIA"
  },
  {
    "codigo":111922007,
    "descripcion":"INFECCIÓN CAUSADA POR FASCIOLA"
  },
  {
    "codigo":242994008,
    "descripcion":"CORTE ACCIDENTAL DURANTE ATENCIÓN MÉDICA"
  },
  {
    "codigo":110087006,
    "descripcion":"LACERACIÓN COMPLEJA CONTAMINADA DE LA LENGUA"
  },
  {
    "codigo":44551007,
    "descripcion":"OSIFICACIÓN DE MÚSCULO"
  },
  {
    "codigo":698076003,
    "descripcion":"OSTEOMA DE CÓNDILO MANDIBULAR"
  },
  {
    "codigo":304860005,
    "descripcion":"RELACIÓN DE ACERCAMIENTO-EVITACIÓN"
  },
  {
    "codigo":403164008,
    "descripcion":"ARAÑAZO Y\/O LACERACIÓN POR ANIMAL"
  },
  {
    "codigo":1287900009,
    "descripcion":"FÍSTULA DE ARTICULACIÓN DE REGIÓN DE HOMBRO"
  },
  {
    "codigo":204721004,
    "descripcion":"OCLUSIÓN CONGÉNITA DEL ANO CON FÍSTULA"
  },
  {
    "codigo":301190002,
    "descripcion":"HALLAZGO RELACIONADO CON EL COLOR DE LA MUCOSA NASAL"
  },
  {
    "codigo":366726003,
    "descripcion":"PRUEBA DE DEDO-DEDO - HALLAZGO"
  },
  {
    "codigo":347541000119109,
    "descripcion":"FORMA COMBINADA DE CATARATA SENIL DE OJO IZQUIERDO"
  },
  {
    "codigo":321071000119103,
    "descripcion":"INESTABILIDAD DE ARTICULACIÓN DE REGIÓN SACROCOCCÍGEA"
  },
  {
    "codigo":235654003,
    "descripcion":"GASTRITIS NEUTRÓFILA AGUDA"
  },
  {
    "codigo":170118008,
    "descripcion":"EXAMEN DEL NIÑO A LAS SEIS SEMANAS: NORMAL"
  },
  {
    "codigo":201051000,
    "descripcion":"ESCLERODACTILIA"
  },
  {
    "codigo":283699008,
    "descripcion":"MORDEDURA HUMANA EN EL HOMBRO"
  },
  {
    "codigo":233819005,
    "descripcion":"ANGINA DE PECHO ESTABLE"
  },
  {
    "codigo":723504000,
    "descripcion":"SÍNDROME DE RAMOS ARROYO"
  },
  {
    "codigo":364891009,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA MOVER UNA PARTE DEL CUERPO"
  },
  {
    "codigo":231984002,
    "descripcion":"RETINITIS VIRAL"
  },
  {
    "codigo":428592003,
    "descripcion":"INFECCIÓN CAUSADA POR BRUCELLA OVIS"
  },
  {
    "codigo":363056008,
    "descripcion":"TRASTORNO DEGENERATIVO DE EXTREMIDAD"
  },
  {
    "codigo":262917005,
    "descripcion":"LESIÓN TRAUMÁTICA DE ÓRGANO GENITAL MASCULINO"
  },
  {
    "codigo":66309005,
    "descripcion":"ANEMIA MEDIADA POR ANTICUERPOS"
  },
  {
    "codigo":721669006,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE LESIÓN SUPERPUESTA DE INTESTINO DELGADO"
  },
  {
    "codigo":230149008,
    "descripcion":"MENINGITIS POR STAPHYLOCOCCUS EPIDERMIDIS"
  },
  {
    "codigo":295685009,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE DOXORUBICINA"
  },
  {
    "codigo":228314002,
    "descripcion":"BEBEDOR DE FIN DE SEMANA"
  },
  {
    "codigo":719834005,
    "descripcion":"SÍNDROME DE WILSON TURNER"
  },
  {
    "codigo":293850009,
    "descripcion":"ALERGIA A FLUOXETINA"
  },
  {
    "codigo":29871001,
    "descripcion":"INFECCIÓN CAUSADA POR ASPERGILLUS CLAVATUS"
  },
  {
    "codigo":160943002,
    "descripcion":"VIVE EN CASA PROPIA"
  },
  {
    "codigo":62639006,
    "descripcion":"DERMATITIS VESICULAR INTRAGRANULOSA"
  },
  {
    "codigo":292015006,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR NITRATO"
  },
  {
    "codigo":880004000,
    "descripcion":"PERFORACIÓN DE VENTRÍCULO IZQUIERDO LUEGO DE PROCEDIMIENTO"
  },
  {
    "codigo":95407008,
    "descripcion":"RECHAZO LOCAL DE IMPLANTE MEDICAMENTOSO"
  },
  {
    "codigo":677731000119100,
    "descripcion":"PERIVASCULITIS RETINIANA DE OJO DERECHO"
  },
  {
    "codigo":124505003,
    "descripcion":"DEFICIENCIA DE PEPTIDOGLUCANO ENDOPEPTIDASA"
  },
  {
    "codigo":26201005,
    "descripcion":"TÚNEL VENTRICULAR IZQUIERDO AÓRTICO"
  },
  {
    "codigo":288345009,
    "descripcion":"LLEVA"
  },
  {
    "codigo":89902003,
    "descripcion":"SÍNDROME DE GRISEL"
  },
  {
    "codigo":253742004,
    "descripcion":"BRONCOMALACIA CONGÉNITA PRIMARIA"
  },
  {
    "codigo":778030005,
    "descripcion":"PARAPLEJÍA ESPÁSTICA AUTOSÓMICA RECESIVA TIPO 27"
  },
  {
    "codigo":286510006,
    "descripcion":"COCINA SEGÚN UNA RECETA"
  },
  {
    "codigo":11818851000119104,
    "descripcion":"ESGUINCE DE LIGAMENTO DE MANO DERECHA"
  },
  {
    "codigo":282840000,
    "descripcion":"NO SE MUEVE DE UNA POSICIÓN"
  },
  {
    "codigo":86232000,
    "descripcion":"INTOXICACIÓN POR PIRIMINIL"
  },
  {
    "codigo":250072004,
    "descripcion":"ESPASMO MUSCULAR PROTECTOR"
  },
  {
    "codigo":315608004,
    "descripcion":"MIOCARDIOPATÍA EN LA DISTROFIA MUSCULAR DE DUCHENNE"
  },
  {
    "codigo":446680006,
    "descripcion":"QUISTE EPIDERMOIDE DE PIEL DE ESPALDA"
  },
  {
    "codigo":413912008,
    "descripcion":"SE OBSERVA MEDIO DE CONTRASTE EN LA PLACA"
  },
  {
    "codigo":20696009,
    "descripcion":"INSUFICIENCIA VENOSA PERIFÉRICA"
  },
  {
    "codigo":281005004,
    "descripcion":"TINCIÓN DEL EPITELIO CORNEAL - HALLAZGO"
  },
  {
    "codigo":1231277009,
    "descripcion":"QUISTE EPIDERMOIDE DE PÁRPADO"
  },
  {
    "codigo":49794002,
    "descripcion":"SIGNO AUSCULTATORIO"
  },
  {
    "codigo":82562007,
    "descripcion":"OSTEOCONDRITIS DISECANTE"
  },
  {
    "codigo":705154007,
    "descripcion":"RECHAZO AGUDO DE INJERTO VASCULAR"
  },
  {
    "codigo":15191001,
    "descripcion":"ORIGEN DE TRONCO BRAQUIOCEFÁLICO EN LADO IZQUIERDO DE CAYADO AÓRTICO"
  },
  {
    "codigo":1260375002,
    "descripcion":"EPILEPSIA DEBIDA A SÍNDROME DE DEFICIENCIA DE PROTEÍNA TRANSPORTADORA DE GLUCOSA TIPO 1"
  },
  {
    "codigo":1293143003,
    "descripcion":"CARCINOMA ESCAMOSO CON CÉLULAS GIGANTES SIMILARES A OSTEOCLASTOS"
  },
  {
    "codigo":703319006,
    "descripcion":"ESTENOSIS DE VÁLVULA TRICÚSPIDE CON INSUFICIENCIA"
  },
  {
    "codigo":373804000,
    "descripcion":"GRADO 1 DE LA ESCALA DEL ESTADO FUNCIONAL DE LA ORGANIZACIÓN MUNDIAL DE LA SALUD"
  },
  {
    "codigo":275500001,
    "descripcion":"PLEURITIS EXUDATIVA"
  },
  {
    "codigo":406572006,
    "descripcion":"INFECCIÓN DEL SISTEMA NERVIOSO CENTRAL POR EHRLICHIA"
  },
  {
    "codigo":371969003,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL VÉRTICE DE LA VEJIGA"
  },
  {
    "codigo":109825004,
    "descripcion":"NEOPLASIA BENIGNA DE CONDUCTO DE GLÁNDULA SALIVAL"
  },
  {
    "codigo":240897005,
    "descripcion":"DERMATITIS POR CHEYLETIELLA"
  },
  {
    "codigo":699649006,
    "descripcion":"HIPERTROFIA DE MÚSCULO MASETERO"
  },
  {
    "codigo":239062001,
    "descripcion":"ENFERMEDAD DE DEGOS"
  },
  {
    "codigo":402902002,
    "descripcion":"ROSÉOLA INFANTIL CAUSADA POR VIRUS HERPES HUMANO 6"
  },
  {
    "codigo":763350002,
    "descripcion":"SÍNDROME DE DISCAPACIDAD INTELECTUAL, OBESIDAD, MALFORMACIÓN CEREBRAL Y DISMORFISMO FACIAL"
  },
  {
    "codigo":304598004,
    "descripcion":"EXAMEN POSNATAL - HALLAZGO"
  },
  {
    "codigo":206294001,
    "descripcion":"ASPIRACIÓN NEONATAL DE SANGRE"
  },
  {
    "codigo":1287638006,
    "descripcion":"MASTITIS POSPARTO"
  },
  {
    "codigo":9686009,
    "descripcion":"SIGNO DE GOODELL"
  },
  {
    "codigo":73387003,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE EXTREMO PROXIMAL DE HUESO METACARPIANO DE MUÑECA"
  },
  {
    "codigo":1351339005,
    "descripcion":"NACIMIENTO EN HOSPITAL"
  },
  {
    "codigo":237227006,
    "descripcion":"ENFERMEDAD CARDÍACA CONGÉNITA DURANTE EL EMBARAZO"
  },
  {
    "codigo":106155008,
    "descripcion":"HALLAZGO EN EL QUINTO PAR CRANEAL"
  },
  {
    "codigo":827051009,
    "descripcion":"ERUPCIÓN DEBIDA A BABEO"
  },
  {
    "codigo":300928006,
    "descripcion":"VEGETARIANO"
  },
  {
    "codigo":268160006,
    "descripcion":"OPACIDAD CORNEAL CONGÉNITA"
  },
  {
    "codigo":725077001,
    "descripcion":"HERIDA DE ESTRUCTURA DE REGIÓN ESTERNAL"
  },
  {
    "codigo":4181001,
    "descripcion":"VELOCIDAD DE FLUJO ESPIRATORIO PICO, NORMAL"
  },
  {
    "codigo":299093002,
    "descripcion":"AMPLITUD DE ABDUCCIÓN PASIVA DE DEDO DE LA MANO AUMENTADA"
  },
  {
    "codigo":67882000,
    "descripcion":"PRURITO DE LA VULVA"
  },
  {
    "codigo":461098000,
    "descripcion":"ANOMALÍA CARDIOVASCULAR DEBIDA A CONDUCTO ARTERIOSO BILATERAL"
  },
  {
    "codigo":1149226001,
    "descripcion":"SOBREDOSIS CRÓNICA"
  },
  {
    "codigo":200789009,
    "descripcion":"DERMATITIS DE CONTACTO CAUSADA POR CETONA"
  },
  {
    "codigo":168021008,
    "descripcion":"LÍQUIDO ASCÍTICO: CÉLULAS MALIGNAS"
  },
  {
    "codigo":360959000,
    "descripcion":"DEFICIENCIA CITOSOL DIPEPTIDASA NO ESPECÍFICA"
  },
  {
    "codigo":262655002,
    "descripcion":"HEMATOMA DE MUCOSA BUCAL ALVEOLAR"
  },
  {
    "codigo":721407004,
    "descripcion":"LESIÓN TRAUMÁTICA DE CORDÓN DE PLEXO BRAQUIAL"
  },
  {
    "codigo":295423006,
    "descripcion":"SOBREDOSIS DE METOCLOPRAMIDA"
  },
  {
    "codigo":866056007,
    "descripcion":"MIELITIS CAUSADA POR VIRUS DE EPSTEIN-BARR"
  },
  {
    "codigo":293588000,
    "descripcion":"ALERGIA A PENTAZOCINA"
  },
  {
    "codigo":197119006,
    "descripcion":"ESTREÑIMIENTO AGUDO"
  },
  {
    "codigo":162516007,
    "descripcion":"DIETA CON ALTO NIVEL DE MONOINSATURADOS"
  },
  {
    "codigo":64212008,
    "descripcion":"GLOMERULONEFRITIS DIFUSA CON SEMILUNAS"
  },
  {
    "codigo":29609001,
    "descripcion":"PÓLIPO DE LA VAGINA"
  },
  {
    "codigo":226217002,
    "descripcion":"DIETA METABÓLICA"
  },
  {
    "codigo":129748009,
    "descripcion":"CALCIFICACIÓN RADIOGRÁFICA"
  },
  {
    "codigo":95145004,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE COLON TRANSVERSO"
  },
  {
    "codigo":160681005,
    "descripcion":"MÓVIL EN EXTERIORES CON AYUDA"
  },
  {
    "codigo":62377009,
    "descripcion":"MIOCARDIOPATÍA POSTPARTO"
  },
  {
    "codigo":420990001,
    "descripcion":"CONSTRICCIÓN DEL CAMPO VISUAL EN TÚNEL"
  },
  {
    "codigo":93310003,
    "descripcion":"POSICIÓN ANÓMALA CONGÉNITA DEL ARCO DE LA VÉRTEBRA DORSAL"
  },
  {
    "codigo":224382003,
    "descripcion":"NO BUSCA TRABAJO"
  },
  {
    "codigo":715902009,
    "descripcion":"TEMBLOR ORTOSTÁTICO PRIMARIO"
  },
  {
    "codigo":27774009,
    "descripcion":"DEFORMIDAD CONGÉNITA DE ARTICULACIÓN DE TOBILLO"
  },
  {
    "codigo":365501000,
    "descripcion":"INSTALACIONES DOMÉSTICAS - HALLAZGO"
  },
  {
    "codigo":124243004,
    "descripcion":"DEFICIENCIA DE GLICINA HIDROXIMETILTRANSFERASA"
  },
  {
    "codigo":1303891001,
    "descripcion":"GLAUCOMA DE ÁNGULO ABIERTO BILATERAL DEBIDO A SÍNDROME SISTÉMICO"
  },
  {
    "codigo":286248002,
    "descripcion":"CAPAZ DE USAR TONOS VOCALES Y UNIDADES FONÉTICAS"
  },
  {
    "codigo":187944004,
    "descripcion":"NEOPLASIA MALIGNA DE HUESO DEL CARPO - GANCHOSO"
  },
  {
    "codigo":253480004,
    "descripcion":"AUSENCIA CONGÉNITA DE MÚSCULO PAPILAR DE VÁLVULA AURICULOVENTRICULAR DERECHA"
  },
  {
    "codigo":249810000,
    "descripcion":"ANTEPIÉ ADUCTO"
  },
  {
    "codigo":284413009,
    "descripcion":"DIFICULTAD PARA MANTENER EL EQUILIBRIO AL ALCANZAR ALGO"
  },
  {
    "codigo":282578007,
    "descripcion":"BRINCA EN UN PIE"
  },
  {
    "codigo":247975006,
    "descripcion":"CONDUCTA EXCÉNTRICA"
  },
  {
    "codigo":82300000,
    "descripcion":"ARTROSIS DE TOBILLO Y\/O PIE"
  },
  {
    "codigo":135781000119105,
    "descripcion":"DEGENERACIÓN CEREBRAL DEBIDA A HIPOTIROIDISMO"
  },
  {
    "codigo":278908004,
    "descripcion":"MECANISMOS RESPIRATORIOS"
  },
  {
    "codigo":703057000,
    "descripcion":"MYCOBACTERIUM TUBERCULOSIS O MYCOBACTERIUM CANETTII"
  },
  {
    "codigo":213372008,
    "descripcion":"LUXACIONES, ESGUINCES Y DISTENSIONES QUE COMPROMETEN MÚLTIPLES REGIONES DE MIEMBROS SUPERIORES E INFERIORES"
  },
  {
    "codigo":11987711000119101,
    "descripcion":"QUEMADURA EPIDÉRMICA DE PALMA DERECHA"
  },
  {
    "codigo":211537004,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DEL CRÁNEO"
  },
  {
    "codigo":735825004,
    "descripcion":"RUPTURA TRAUMÁTICA DE LIGAMENTO LATERAL DE ARTICULACIÓN INTERFALÁNGICA DE DEDO DE LA MANO"
  },
  {
    "codigo":766758001,
    "descripcion":"CARCINOMA INDIFERENCIADA DE CUERPO UTERINO"
  },
  {
    "codigo":471846004,
    "descripcion":"MIOCARDIOPATÍA DEBIDA A TRASTORNO NEUROMUSCULAR"
  },
  {
    "codigo":209702005,
    "descripcion":"SECCIÓN EXPUESTA DE LIGAMENTO DE TOBILLO"
  },
  {
    "codigo":13094009,
    "descripcion":"APNEA EN EL RECIÉN NACIDO"
  },
  {
    "codigo":240635003,
    "descripcion":"NEUMONÍA CAUSADA POR LEISHMANIA"
  },
  {
    "codigo":76795007,
    "descripcion":"HEPATITIS VIRAL AGUDA TIPO B"
  },
  {
    "codigo":15919871000119105,
    "descripcion":"REACCIÓN ALÉRGICA CAUSADA POR AGENTE ANTIINFECCIOSO"
  },
  {
    "codigo":1354747007,
    "descripcion":"FRACTURA DE DUODÉCIMA COSTILLA"
  },
  {
    "codigo":402640002,
    "descripcion":"DAÑO DEL TALLO PILOSO POR SUSTANCIA QUÍMICA"
  },
  {
    "codigo":238800003,
    "descripcion":"LINFANGIOMA DIFUSO"
  },
  {
    "codigo":74960003,
    "descripcion":"INSUFICIENCIA VENTRICULAR IZQUIERDA, CONGESTIVA AGUDA"
  },
  {
    "codigo":271568003,
    "descripcion":"NEOPLASIA MALIGNA DE MEMBRANA MUCOSA DE LABIO INFERIOR"
  },
  {
    "codigo":42192008,
    "descripcion":"ESPUTO PURULENTO"
  },
  {
    "codigo":73125001,
    "descripcion":"EMPIEMA DE LA VESICULAR BILIAR"
  },
  {
    "codigo":7589002,
    "descripcion":"BRAQUIMEGALODACTILIA"
  },
  {
    "codigo":1092351000119107,
    "descripcion":"MENINGITIS CAUSADA VIRUS DE LA RUBÉOLA"
  },
  {
    "codigo":5754000,
    "descripcion":"VÍCTIMA DE CONTIENDA TERRESTRE"
  },
  {
    "codigo":366202001,
    "descripcion":"ASPECTO DE ARTERIA PULMONAR - HALLAZGO"
  },
  {
    "codigo":398970001,
    "descripcion":"NEVO LIQUENOIDE EPIDÉRMICO"
  },
  {
    "codigo":15729561000119103,
    "descripcion":"TRASTORNO DE ARTICULACIÓN DE REGIÓN DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":300666006,
    "descripcion":"REALIZA EJERCICIO DE SEGURIDAD VIAL"
  },
  {
    "codigo":235130007,
    "descripcion":"XEROSTOMÍA FARMACÓGENA"
  },
  {
    "codigo":724815006,
    "descripcion":"NEUROPATÍA AUTONÓMICA DEBIDA A TRASTORNO DE LA FUNCIÓN INMUNITARIA"
  },
  {
    "codigo":722980006,
    "descripcion":"DEMENCIA DEBIDA A ANOMALÍA CROMOSÓMICA"
  },
  {
    "codigo":34852006,
    "descripcion":"VARIANTE DE ANEMIA POR DEFICIENCIA DE GLUCOSA-6-FOSFATO DESHIDROGENASA CLASE II"
  },
  {
    "codigo":295161000,
    "descripcion":"SOBREDOSIS DE METADONA"
  },
  {
    "codigo":296996007,
    "descripcion":"SOBREDOSIS DE BRETILIO"
  },
  {
    "codigo":360697003,
    "descripcion":"DEFICIENCIA DE GLUCONOLACTONASA"
  },
  {
    "codigo":65785006,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA VENA MESENTÉRICA SUPERIOR Y\/O SUS DIVISIONES PRINCIPALES"
  },
  {
    "codigo":229625009,
    "descripcion":"NO FLUIDEZ NORMAL"
  },
  {
    "codigo":719310005,
    "descripcion":"ABRASIONES Y CALLOS EN NUDILLOS DEL DORSO DE LA MANO DEBIDOS A VÓMITOS AUTOINDUCIDOS"
  },
  {
    "codigo":19861000146103,
    "descripcion":"CAPAZ DE REALIZAR ACTIVIDADES DE CUIDADO BUCAL DE FORMA INDEPENDIENTE"
  },
  {
    "codigo":302131000119104,
    "descripcion":"OSTEOCONDROSIS DEL ADULTO DE COLUMNA VERTEBRAL DORSOLUMBAR"
  },
  {
    "codigo":783011004,
    "descripcion":"VÁLVULA DE EUSTAQUIO PERSISTENTE"
  },
  {
    "codigo":1340067005,
    "descripcion":"CONTUSIÓN DE MÚSCULO DORSAL ANCHO"
  },
  {
    "codigo":193187004,
    "descripcion":"POLINEUROPATÍA DEBIDA A AMILOIDOSIS"
  },
  {
    "codigo":94883007,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LOS ISLOTES DE LANGERHANS"
  },
  {
    "codigo":224120001,
    "descripcion":"FAMILIA CON NIÑOS PEQUEÑOS"
  },
  {
    "codigo":60280003,
    "descripcion":"PRESIÓN INTRAOCULAR NORMAL"
  },
  {
    "codigo":289656006,
    "descripcion":"FONDO UTERINO DESPLAZADO POR DEBAJO DEL INTROITO CON TRACCIÓN"
  },
  {
    "codigo":255053001,
    "descripcion":"NEOPLASIA BENIGNA DE ORIGEN DESCONOCIDO"
  },
  {
    "codigo":386125002,
    "descripcion":"TABIQUE ATRAVESADO POR DISPOSITIVO"
  },
  {
    "codigo":11770931000119107,
    "descripcion":"ESGUINCE DE LIGAMENTO COLATERAL RADIAL DE ARTICULACIÓN DE CODO IZQUIERDO"
  },
  {
    "codigo":123981005,
    "descripcion":"EDAD ÓSEA NORMAL"
  },
  {
    "codigo":253218002,
    "descripcion":"ORIFICIO LAGRIMAL SUPERNUMERARIO"
  },
  {
    "codigo":449826002,
    "descripcion":"FIMOSIS"
  },
  {
    "codigo":56610005,
    "descripcion":"TEMBLOR ESTÁTICO"
  },
  {
    "codigo":417058005,
    "descripcion":"DESPLAZAMIENTO DE LA PORCIÓN POSTERIOR DEL PUBIS"
  },
  {
    "codigo":23842007,
    "descripcion":"PERICARDITIS MEDICAMENTOSA"
  },
  {
    "codigo":89378007,
    "descripcion":"DESPLAZAMIENTO CONGÉNITO DE ESTÓMAGO"
  },
  {
    "codigo":285986005,
    "descripcion":"ACTIVA LA LLAVE PRINCIPAL DE ELECTRICIDAD"
  },
  {
    "codigo":187682009,
    "descripcion":"NEOPLASIA MALIGNA DE LA EPIGLOTIS, BORDE LIBRE"
  },
  {
    "codigo":284151004,
    "descripcion":"INCAPAZ DE MOVER LA PIERNA"
  },
  {
    "codigo":447991007,
    "descripcion":"PAPILOMA DE LENGUA"
  },
  {
    "codigo":218615007,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR FENBUFÉN"
  },
  {
    "codigo":85708001,
    "descripcion":"ANAPLASMOSIS HUMANA CAUSADA POR ANAPLASMA PHAGOCYTOPHILUM"
  },
  {
    "codigo":216780005,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR HUMOS DE PLOMO"
  },
  {
    "codigo":446156008,
    "descripcion":"INFECCIÓN CAUSADA POR ACINETOBACTER RESISTENTE A MÚLTIPLES FÁRMACOS"
  },
  {
    "codigo":870305003,
    "descripcion":"TRASTORNO GENERALIZADO DEL DESARROLLO CON RETRASO DEL DESARROLLO COGNITIVO Y ALTERACIÓN ACENTUADA DEL LENGUAJE FUNCIONAL"
  },
  {
    "codigo":247713003,
    "descripcion":"PERCEPCIÓN AUDITIVA AUMENTADA"
  },
  {
    "codigo":51105006,
    "descripcion":"URETRITIS CAUSADA POR UREAPLASMA UREALYTICUM"
  },
  {
    "codigo":313249007,
    "descripcion":"NEOPLASIA MALIGNA DEL PÁRPADO SUPERIOR"
  },
  {
    "codigo":18337009,
    "descripcion":"INTOXICACIÓN POR INSULINA"
  },
  {
    "codigo":12235981000119109,
    "descripcion":"DEFORMIDAD CONGÉNITA DE PIE DERECHO"
  },
  {
    "codigo":16905421000119109,
    "descripcion":"CARCINOMA BASOCELULAR PRIMARIO DE PÁRPADO SUPERIOR DERECHO"
  },
  {
    "codigo":442486007,
    "descripcion":"MIOSITIS PARANEOPLÁSICA"
  },
  {
    "codigo":278646009,
    "descripcion":"DISPOSITIVO ORTODÓNCICO FLOJO"
  },
  {
    "codigo":735563002,
    "descripcion":"CICATRIZ DE OÍDO MEDIO"
  },
  {
    "codigo":1217075009,
    "descripcion":"HIPOALDOSTERONISMO HIPERRENINÉMICO FAMILIAR TIPO 1A"
  },
  {
    "codigo":45600000,
    "descripcion":"NEUROPATÍA TÓXICA"
  },
  {
    "codigo":276811008,
    "descripcion":"LINFOMA GÁSTRICO"
  },
  {
    "codigo":473419009,
    "descripcion":"CARCINOMA MUCINOSO PAPILAR INTRADUCTAL IN SITU DE PÁNCREAS"
  },
  {
    "codigo":1290784005,
    "descripcion":"FRACTURA POR SOBRECARGA DE HUESO DE REGIÓN DE MUÑECA"
  },
  {
    "codigo":897568006,
    "descripcion":"DELECIÓN DISTAL DEL CROMOSOMA 14"
  },
  {
    "codigo":209440009,
    "descripcion":"ESGUINCE NO ESPECÍFICO DE LIGAMENTO RADIOCARPIANO PROXIMAL"
  },
  {
    "codigo":830197002,
    "descripcion":"GLOMANGIOPERICITOMA"
  },
  {
    "codigo":305909002,
    "descripcion":"ATENDIDO EN HOSPITAL DE DÍA PSICOGERIÁTRICO"
  },
  {
    "codigo":331111000119108,
    "descripcion":"DESPRENDIMIENTO DE RETINA COMPLETO"
  },
  {
    "codigo":15977831000119109,
    "descripcion":"MELANOMA MALIGNO DE COROIDES DE AMBOS OJOS"
  },
  {
    "codigo":402378006,
    "descripcion":"ENFERMEDAD DE CROHN METASTÁSICA DE PIEL"
  },
  {
    "codigo":1287114008,
    "descripcion":"CUERPO EXTRAÑO RETENIDO EN TEJIDOS BLANDOS DE SITIOS MÚLTIPLES"
  },
  {
    "codigo":72863001,
    "descripcion":"HALLAZGO RELACIONADO CON EL RONQUIDO"
  },
  {
    "codigo":203935000,
    "descripcion":"ESPINA BÍFIDA DORSAL CON HIDROCEFALIA"
  },
  {
    "codigo":40095003,
    "descripcion":"LESIÓN TRAUMÁTICA DEL RIÑÓN"
  },
  {
    "codigo":236703003,
    "descripcion":"CISTITIS INFECCIOSA RECURRENTE"
  },
  {
    "codigo":171167004,
    "descripcion":"SIN EXTENDIDO - AMPUTACIÓN DE CUELLO UTERINO"
  },
  {
    "codigo":5492000,
    "descripcion":"ÚLCERA PÉPTICA CRÓNICA SIN HEMORRAGIA Y SIN PERFORACIÓN"
  },
  {
    "codigo":105631009,
    "descripcion":"ENFERMEDAD CAUSADA POR PARAMYXOVIRIDAE"
  },
  {
    "codigo":300404004,
    "descripcion":"MASA ABDOMINAL VISIBLE"
  },
  {
    "codigo":365940004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA MANTENER LA AUTOESTIMA"
  },
  {
    "codigo":890228005,
    "descripcion":"ATRESIA DE NARINAS BILATERAL"
  },
  {
    "codigo":71028008,
    "descripcion":"HEMORRAGIA FETOMATERNA"
  },
  {
    "codigo":3657001,
    "descripcion":"INTOXICACIÓN POR OSTEOSPERMUM"
  },
  {
    "codigo":15705601000119107,
    "descripcion":"CONCRECIÓN EN CONJUNTIVA DE PÁRPADO SUPERIOR DERECHO"
  },
  {
    "codigo":726388008,
    "descripcion":"DELECIÓN DE PARTE DEL BRAZO CORTO DEL CROMOSOMA 16"
  },
  {
    "codigo":298569005,
    "descripcion":"AMPLITUD DE ROTACIÓN PASIVA HACIA LA IZQUIERDA DE LA COLUMNA VERTEBRAL DORSAL, NORMAL"
  },
  {
    "codigo":724553007,
    "descripcion":"CARCINOMA INDIFERENCIADO PRIMARIO DE GLÁNDULA TIROIDES"
  },
  {
    "codigo":1052233008,
    "descripcion":"CONTRACCIÓN DEL CAMPO VISUAL DEL OJO IZQUIERDO"
  },
  {
    "codigo":296734001,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE CEFTRIAXONA"
  },
  {
    "codigo":69193009,
    "descripcion":"CARÁCTER INFLEXIBLE"
  },
  {
    "codigo":722718001,
    "descripcion":"MENINGIOMA MALIGNO PRIMARIO"
  },
  {
    "codigo":1822007,
    "descripcion":"TRASTORNO DE LA TOLERANCIA A LA GLUCOSA ASOCIADA CON ENFERMEDAD PANCREÁTICA"
  },
  {
    "codigo":131059003,
    "descripcion":"NIVEL DE 11-DESOXI, 17-HIDROXICORTICOSTERONA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":65523004,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE AXILA SIN INFECCIÓN"
  },
  {
    "codigo":294899004,
    "descripcion":"ALERGIA A GLUCONATO FERROSO"
  },
  {
    "codigo":260296003,
    "descripcion":"PERCIBE LUZ SOLAMENTE"
  },
  {
    "codigo":161992004,
    "descripcion":"VENAS TORÁCICAS PROMINENTES"
  },
  {
    "codigo":687771000119106,
    "descripcion":"RABDOMIOSARCOMA PRIMARIO DE ABDOMEN"
  },
  {
    "codigo":719048006,
    "descripcion":"HIPERGARGALESTESIA"
  },
  {
    "codigo":293064008,
    "descripcion":"REACCIÓN ADVERSA A LA PENTAMIDINA"
  },
  {
    "codigo":5941000119101,
    "descripcion":"QUISTE RENAL CONGÉNITO ÚNICO"
  },
  {
    "codigo":717213004,
    "descripcion":"STREPTOCOCCUS ANGINOSUS O STREPTOCOCCUS DYSGALACTIAE SUBESPECIE EQUISIMILIS"
  },
  {
    "codigo":29085005,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE LA MANO, SIN INFECCIÓN"
  },
  {
    "codigo":291229003,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR OXIPERTINA"
  },
  {
    "codigo":94621009,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE HUESO TEMPORAL"
  },
  {
    "codigo":289394003,
    "descripcion":"REBORDE ORBITARIO FETAL PALPABLE POR VÍA VAGINAL"
  },
  {
    "codigo":92786009,
    "descripcion":"CARCINOMA IN SITU DEL APARATO URINARIO"
  },
  {
    "codigo":713543002,
    "descripcion":"ENFERMEDAD DESMIELINIZANTE DEL SISTEMA NERVIOSO CENTRAL CONCOMITANTE CON INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":189255002,
    "descripcion":"CARCINOMA IN SITU DE CARTÍLAGO ARITENOIDES"
  },
  {
    "codigo":1336135001,
    "descripcion":"ALTERACIÓN DE ARTICULACIÓN RADIOCARPIANA DERECHA"
  },
  {
    "codigo":25415003,
    "descripcion":"FRACTURA NO EXPUESTA DE FÉMUR"
  },
  {
    "codigo":123719009,
    "descripcion":"CITOPENIA SECUNDARIA"
  },
  {
    "codigo":10874831000119100,
    "descripcion":"LACERACIÓN DE PÁRPADO IZQUIERDO"
  },
  {
    "codigo":449564007,
    "descripcion":"FENESTRACIÓN DE CÚSPIDE DE VÁLVULA TRONCAL"
  },
  {
    "codigo":1332465000,
    "descripcion":"HIPERTENSIÓN EN ENFERMEDAD RENAL CRÓNICA EN ESTADIO 3B DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":1137692008,
    "descripcion":"EX USUARIO DE CIGARRILLO ELECTRÓNICO POR MÁS DE 1 AÑO"
  },
  {
    "codigo":10629071000119102,
    "descripcion":"LINFADENITIS AGUDA DE AXILA"
  },
  {
    "codigo":447729009,
    "descripcion":"AMELOBLASTOMA DE MANDÍBULA"
  },
  {
    "codigo":183750003,
    "descripcion":"CONSULTA DOMICILIARIA ONCOLÓGICA, REALIZADA"
  },
  {
    "codigo":16035791000119103,
    "descripcion":"OSTEÓLISIS DE HÚMERO DERECHO"
  },
  {
    "codigo":249286006,
    "descripcion":"INCAPAZ DE SUJETAR BEBIDAS"
  },
  {
    "codigo":1363398007,
    "descripcion":"NEOVASCULARIZACIÓN DE CUADRANTE INFERIOR DE ÁNGULO IRIDOCORNEAL DE OJO IZQUIERDO"
  },
  {
    "codigo":216518007,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR TRANQUILIZANTES"
  },
  {
    "codigo":282054009,
    "descripcion":"HEMATOMA DE YEYUNO"
  },
  {
    "codigo":444059002,
    "descripcion":"HIPERCOLESTEROLEMIA BIEN CONTROLADA"
  },
  {
    "codigo":1197723003,
    "descripcion":"OBSTRUCCIÓN POSOPERATORIA DE INTESTINO GRUESO"
  },
  {
    "codigo":49008000,
    "descripcion":"ROTACIÓN ANÓMALA DE RIÑÓN"
  },
  {
    "codigo":1163120001,
    "descripcion":"COLITIS POR SHIGELLA SONNEI"
  },
  {
    "codigo":704368004,
    "descripcion":"CON MAYOR RIESGO DE FUGA DE ESTABLECIMIENTO ASISTENCIAL"
  },
  {
    "codigo":442224005,
    "descripcion":"ARTERIOSCLEROSIS EN INJERTO-PUENTE AUTÓLOGO DE VENA EN ARTERIA CORONARIA"
  },
  {
    "codigo":276549000,
    "descripcion":"ICTERICIA FISIOLÓGICA NEONATAL"
  },
  {
    "codigo":14405000,
    "descripcion":"ABSCESO ESPINAL SUBDURAL"
  },
  {
    "codigo":473157001,
    "descripcion":"AGOTAMIENTO DE BATERÍA DE MARCAPASOS"
  },
  {
    "codigo":407621003,
    "descripcion":"CONVULSIONES DIARIAS"
  },
  {
    "codigo":1259589004,
    "descripcion":"CARCINOMA UROTELIAL RENAL PRIMARIO"
  },
  {
    "codigo":702533004,
    "descripcion":"AMBIENTE DE BAJO RIESGO PARA ALTA DE PACIENTE"
  },
  {
    "codigo":307151000119108,
    "descripcion":"ARTRITIS ENTEROPÁTICA DE ARTICULACIÓN RADIOCARPIANA IZQUIERDA"
  },
  {
    "codigo":15681641000119102,
    "descripcion":"ENDOFTALMITIS BILATERAL DEBIDA A SÍNDROME DE SENO SILENTE"
  },
  {
    "codigo":209178002,
    "descripcion":"SUBLUXACIÓN VERTEBRAL NO EXPUESTA CON LESIÓN MEDULAR COMPLETA A NIVEL LUMBAR"
  },
  {
    "codigo":733466005,
    "descripcion":"SÍNDROME DE CAMPTODACTILIA CON TAURINURIA"
  },
  {
    "codigo":897306006,
    "descripcion":"IRRITACIÓN BRONQUIAL"
  },
  {
    "codigo":274714007,
    "descripcion":"SOMBRA PULMONAR"
  },
  {
    "codigo":12570008,
    "descripcion":"QUERATITIS NUMULAR"
  },
  {
    "codigo":1290522009,
    "descripcion":"RADIOGRAFÍA DE PERONÉ NORMAL"
  },
  {
    "codigo":45338009,
    "descripcion":"HIPERTROFIA DE GLÁNDULA SALIVAL"
  },
  {
    "codigo":373018008,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM CELATUM"
  },
  {
    "codigo":403951006,
    "descripcion":"ADENOCARCINOMA DE GLÁNDULA CERUMINOSA DE PIEL"
  },
  {
    "codigo":240111007,
    "descripcion":"MIOSITIS FÚNGICA"
  },
  {
    "codigo":116841000119105,
    "descripcion":"LINFOMA DE LA ZONA MARGINAL DE GANGLIOS LINFÁTICOS DE MÚLTIPLES LOCALIZACIONES"
  },
  {
    "codigo":305647009,
    "descripcion":"ATENDIDO POR UN PEDIATRA"
  },
  {
    "codigo":8900005,
    "descripcion":"HIPOPROTEINEMIA"
  },
  {
    "codigo":860868006,
    "descripcion":"ENCEFALITIS CAUSADA POR VIRUS ME TRI"
  },
  {
    "codigo":1003400003,
    "descripcion":"HETEROTOPÍA CONGÉNITA DE MUCOSA GÁSTRICA DE DUODENO"
  },
  {
    "codigo":39833003,
    "descripcion":"CARÁCTER ANTISOCIAL"
  },
  {
    "codigo":1186713004,
    "descripcion":"SÍNDROME DE RETRASO DE CRECIMIENTO, DISCAPACIDAD INTELECTUAL Y HEPATOPATÍA"
  },
  {
    "codigo":269209005,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE PÁRPADOS Y\/O REGIÓN PERIOCULAR"
  },
  {
    "codigo":236441006,
    "descripcion":"QUISTE RENAL ADQUIRIDO CON CAMBIO NEOPLÁSICO"
  },
  {
    "codigo":365678000,
    "descripcion":"HALLAZGO RELACIONADO CON LA MEDICIÓN DEL VOLUMEN URINARIO"
  },
  {
    "codigo":1217646002,
    "descripcion":"FIBROSIS CONJUNTIVAL"
  },
  {
    "codigo":300142004,
    "descripcion":"SACO DE RETRACCIÓN CENTRAL DE LA MEMBRANA TIMPÁNICA"
  },
  {
    "codigo":267374005,
    "descripcion":"BOCIO DIFUSO TÓXICO"
  },
  {
    "codigo":398446008,
    "descripcion":"RABIA HUMANA"
  },
  {
    "codigo":167235001,
    "descripcion":"ORINA: ROJA - SANGRE"
  },
  {
    "codigo":5230009,
    "descripcion":"AUSENCIA CONGÉNITA DE LA ARTERIA CORONARIA"
  },
  {
    "codigo":10821891000119104,
    "descripcion":"FRACTURA EXPUESTA DE BASE DE CUELLO DE FÉMUR IZQUIERDO"
  },
  {
    "codigo":298307006,
    "descripcion":"HALLAZGO RELACIONADO CON EL EQUILIBRIO AL CAMINAR"
  },
  {
    "codigo":722456001,
    "descripcion":"SÍNDROME DE DISCAPACIDAD INTELECTUAL, RETRASO DEL DESARROLLO Y CONTRACTURAS"
  },
  {
    "codigo":36163009,
    "descripcion":"DOLOR NOCTURNO"
  },
  {
    "codigo":460312001,
    "descripcion":"ARTERIA COLATERAL QUE DERIVA EL FLUJO SISTÉMICO HACIA LA CIRCULACIÓN PULMONAR DESDE LA ARTERIA CARÓTIDA IZQUIERDA"
  },
  {
    "codigo":12214531000119106,
    "descripcion":"INFECCIÓN DE RÓTULA IZQUIERDA ASOCIADA CON DISPOSITIVO DE FIJACIÓN INTERNA"
  },
  {
    "codigo":336131000119106,
    "descripcion":"CALCOSIS OCULAR DERECHA"
  },
  {
    "codigo":15956381000119100,
    "descripcion":"ADENOCARCINOMA DE PULMÓN DERECHO"
  },
  {
    "codigo":296472007,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE TRETINOÍNA"
  },
  {
    "codigo":196333005,
    "descripcion":"PULPA DENTAL MOMIFICADA"
  },
  {
    "codigo":423874001,
    "descripcion":"ASUME NUEVO PAPEL"
  },
  {
    "codigo":292802001,
    "descripcion":"REACCIÓN ADVERSA A LA TERBINAFINA"
  },
  {
    "codigo":391106002,
    "descripcion":"BUENA TÉCNICA DE NEBULIZACIÓN"
  },
  {
    "codigo":389271000,
    "descripcion":"ESPONDILOENCONDROMATOSIS CON CALCIFICACIÓN DE GANGLIOS BASALES"
  },
  {
    "codigo":127127005,
    "descripcion":"LINFADENOPATÍA GASTROEPIPLOICA"
  },
  {
    "codigo":94359007,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA ZONA DE UNIÓN DE LA LENGUA"
  },
  {
    "codigo":715116000,
    "descripcion":"SE TRANSFIERE DE LA SILLA A LA CAMA"
  },
  {
    "codigo":225431009,
    "descripcion":"HALLAZGO RELACIONADO CON EL RECONOCIMIENTO"
  },
  {
    "codigo":26988005,
    "descripcion":"MILIARIA PUSTULOSA"
  },
  {
    "codigo":59756006,
    "descripcion":"INFECCIÓN CAUSADA POR PROTOTHECA ZOPFI"
  },
  {
    "codigo":92524007,
    "descripcion":"CARCINOMA IN SITU DE ADENOIDES"
  },
  {
    "codigo":289132008,
    "descripcion":"NO REALIZA ACTIVIDADES PARA EL CUIDADO DEL PELO"
  },
  {
    "codigo":1237569004,
    "descripcion":"VENA VARICOSA DE TALÓN DERECHO"
  },
  {
    "codigo":1335873005,
    "descripcion":"ICTERICIA NEONATAL PRECOZ DEBIDA A DAÑO HEPATOCELULAR"
  },
  {
    "codigo":57921006,
    "descripcion":"ADHERENCIAS EPIPLOICAS CONGÉNITAS"
  },
  {
    "codigo":254529007,
    "descripcion":"NEOPLASIA BENIGNA DE CARTÍLAGO LARÍNGEO"
  },
  {
    "codigo":188993006,
    "descripcion":"LIPOMA DE AXILA"
  },
  {
    "codigo":88854002,
    "descripcion":"ANEMIA HIPOPLÁSICA CONGÉNITA"
  },
  {
    "codigo":1268502003,
    "descripcion":"SARCOMA EMBRIONARIO PRIMARIO DE HÍGADO"
  },
  {
    "codigo":285462004,
    "descripcion":"INCAPAZ DE ABRIR LA BOCA"
  },
  {
    "codigo":283627003,
    "descripcion":"HERIDA POR PINCHAZO DE AGUJA EN EL PERINEO"
  },
  {
    "codigo":281792000,
    "descripcion":"PANTORRILLA TUMEFACTA"
  },
  {
    "codigo":1363136001,
    "descripcion":"ASTILLA EN PENE CON INFECCIÓN"
  },
  {
    "codigo":609472002,
    "descripcion":"INTERRUPCIÓN INDUCIDA DEL EMBARAZO COMPLICADA POR INSUFICIENCIA RENAL AGUDA CON OLIGURIA"
  },
  {
    "codigo":11833911000119105,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN PERISEMILUNAR DE MUÑECA DERECHA"
  },
  {
    "codigo":249024002,
    "descripcion":"ORIFICIO CERVICAL EXTERNO, CERRADO"
  },
  {
    "codigo":1075921000119100,
    "descripcion":"SINOVITIS ARTICULAR DE PIE DERECHO"
  },
  {
    "codigo":50581000,
    "descripcion":"SÍNDROME DE GOODPASTURE"
  },
  {
    "codigo":871616009,
    "descripcion":"SITUS INVERSUS AURICULAR"
  },
  {
    "codigo":247189002,
    "descripcion":"LESIÓN CORIORRETINIANA SOBREELEVADA SOLITARIA"
  },
  {
    "codigo":771477003,
    "descripcion":"SÍNDROME DE SOBRECRECIMIENTO 15Q"
  },
  {
    "codigo":15978003,
    "descripcion":"GLUCOGENOSIS, FORMA MUSCULAR"
  },
  {
    "codigo":441962003,
    "descripcion":"LINFOMA DE CÉLULAS GRANDES DE GANGLIOS LINFÁTICOS INTRAPÉLVICOS"
  },
  {
    "codigo":81514003,
    "descripcion":"PARA 9"
  },
  {
    "codigo":1162858007,
    "descripcion":"GONADOBLASTOMA"
  },
  {
    "codigo":866111002,
    "descripcion":"LINFEDEMA DEBIDO A INFLAMACIÓN CRÓNICA"
  },
  {
    "codigo":1259327003,
    "descripcion":"CARCINOMA PRIMARIO DE FRENILLO LABIAL INFERIOR"
  },
  {
    "codigo":276287007,
    "descripcion":"LATENCIA DEL COMPONENTE P100"
  },
  {
    "codigo":208916003,
    "descripcion":"DESGARRO AGUDO DE MENISCO INTERNO, CUERNO POSTERIOR"
  },
  {
    "codigo":733204008,
    "descripcion":"ALOPECIA CICATRIZAL DEBIDA A LESIÓN TRAUMÁTICA"
  },
  {
    "codigo":338641000119107,
    "descripcion":"CORIORRETINITIS DISEMINADA DE POLO POSTERIOR IZQUIERDO"
  },
  {
    "codigo":403689003,
    "descripcion":"CICATRIZ QUIRÚRGICA ATRÓFICA"
  },
  {
    "codigo":239849004,
    "descripcion":"ARTRITIS Y PERIARTRITIS INTRARTICULAR PRODUCIDAS POR ESTEROIDES"
  },
  {
    "codigo":698601005,
    "descripcion":"ANOMALÍA CONGÉNITA ÚNICA"
  },
  {
    "codigo":1222889008,
    "descripcion":"ALERGIA A INMUNOGLOBULINA HUMANA ANTI-D"
  },
  {
    "codigo":1255657009,
    "descripcion":"CARCINOMA DE SENO ESFENOIDAL"
  },
  {
    "codigo":238014002,
    "descripcion":"DEFICIENCIA DE LA DIHIDROPIRIMIDINASA"
  },
  {
    "codigo":762302008,
    "descripcion":"VASCULITIS DE PEQUEÑOS VASOS POR INMUNOCOMPLEJOS CAUSADA POR FÁRMACO"
  },
  {
    "codigo":203411002,
    "descripcion":"OSTEOCONDRITIS DISECANTE DE LA MUÑECA"
  },
  {
    "codigo":301715003,
    "descripcion":"DOLOR EN EL CUADRANTE SUPEROIZQUIERDO"
  },
  {
    "codigo":39161000087100,
    "descripcion":"DOLOR VISCERAL CRÓNICO DEBIDO A TRASTORNO"
  },
  {
    "codigo":6803002,
    "descripcion":"OSTEOMIELITIS POR SALMONELLA"
  },
  {
    "codigo":44281000087103,
    "descripcion":"CONTUSIÓN DE MALÉOLO INTERNO IZQUIERDO"
  },
  {
    "codigo":400019007,
    "descripcion":"TRASTORNO CUTÁNEO DE GENITALES Y PERINEO"
  },
  {
    "codigo":365416000,
    "descripcion":"HALLAZGO ELECTROCARDIOGRÁFICO EN EL SEGMENTO ST"
  },
  {
    "codigo":168808000,
    "descripcion":"BRONCOGRAFÍA ANORMAL"
  },
  {
    "codigo":1184616003,
    "descripcion":"AMBIENTE CALUROSO"
  },
  {
    "codigo":103272004,
    "descripcion":"REFLEJO PUPILAR DETERIORADO"
  },
  {
    "codigo":267112005,
    "descripcion":"EL PACIENTE SE SIENTE BIEN"
  },
  {
    "codigo":299880006,
    "descripcion":"REFLEJO AQUÍLEO ACTIVO"
  },
  {
    "codigo":201576005,
    "descripcion":"ARTRITIS REACTIVA DE ARTICULACIÓN METATARSOFALÁNGICA DE SEGUNDO A QUINTO DEDOS DEL PIE"
  },
  {
    "codigo":41721000087107,
    "descripcion":"QUEMADURA DE TERCER DEDO DE PIE IZQUIERDO"
  },
  {
    "codigo":15631211000119108,
    "descripcion":"RUPTURA COMPLETA NO TRAUMÁTICA DE MANGUITO ROTADOR DE AMBOS HOMBROS"
  },
  {
    "codigo":134205008,
    "descripcion":"VISCOSIDAD DEL SEMEN"
  },
  {
    "codigo":199741009,
    "descripcion":"DESNUTRICIÓN DURANTE EL EMBARAZO"
  },
  {
    "codigo":296210005,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE PERICIAZINA"
  },
  {
    "codigo":230674007,
    "descripcion":"MIASTENIA SEUDOMIOPÁTICA"
  },
  {
    "codigo":787730008,
    "descripcion":"HIDROCELE CONGÉNITO DE CONDUCTO DE NUCK"
  },
  {
    "codigo":294375008,
    "descripcion":"ALERGIA A INTERFERÓN"
  },
  {
    "codigo":95932002,
    "descripcion":"PADRES DESATENDIDOS"
  },
  {
    "codigo":15987871000119100,
    "descripcion":"COLOBOMA CONGÉNITO DE CRISTALINO DERECHO"
  },
  {
    "codigo":94097000,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE CONDUCTO TIROGLOSO"
  },
  {
    "codigo":292540008,
    "descripcion":"REACCIÓN ADVERSA AL IPRATROPIO"
  },
  {
    "codigo":367621000119107,
    "descripcion":"HIPEROXALURIA"
  },
  {
    "codigo":290705001,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR ETOPÓSIDO"
  },
  {
    "codigo":1306513001,
    "descripcion":"NEOPLASIA MALIGNA RECURRENTE PRIMARIA DE MAMA DERECHA"
  },
  {
    "codigo":126865007,
    "descripcion":"NEOPLASIA DEL PERITONEO"
  },
  {
    "codigo":26726000,
    "descripcion":"LEGIONELOSIS"
  },
  {
    "codigo":15932421000119109,
    "descripcion":"ABSCESO DE TROMPA DE FALOPIO DERECHA Y OVARIO DERECHO"
  },
  {
    "codigo":59494005,
    "descripcion":"DEFECTO CONGÉNITO DEL TABIQUE CARDÍACO"
  },
  {
    "codigo":92262006,
    "descripcion":"NEOPLASIA BENIGNA DE HUESO PALATINO"
  },
  {
    "codigo":714854008,
    "descripcion":"INCAPAZ DE ASIMILARSE CULTURALMENTE"
  },
  {
    "codigo":287035002,
    "descripcion":"RUPTURA DE MEMBRANA SINOVIAL DE HOMBRO"
  },
  {
    "codigo":1237307003,
    "descripcion":"ARTROFIBROSIS DE ARTICULACIÓN DE HOMBRO"
  },
  {
    "codigo":876859003,
    "descripcion":"ESTENOSIS DE LA RAMA DESCENDENTE ANTERIOR DE LA ARTERIA CORONARIA IZQUIERDA"
  },
  {
    "codigo":418107008,
    "descripcion":"INCONSCIENTE"
  },
  {
    "codigo":449040002,
    "descripcion":"HIPOPLASIA DE ANILLO DE VÁLVULA AURICULOVENTRICULAR DERECHA EN VENTRÍCULO CON DOBLE TRACTO DE ENTRADA"
  },
  {
    "codigo":23056005,
    "descripcion":"CIÁTICA"
  },
  {
    "codigo":68921000119100,
    "descripcion":"MAL FUNCIONAMIENTO DE CARDIOVERSOR DESFIBRILADOR IMPLANTABLE AUTOMÁTICO BIVENTRICULAR"
  },
  {
    "codigo":840421000,
    "descripcion":"TRASTORNO DE UNIÓN NEUROMUSCULAR CAUSADA POR TOXINA BOTULÍNICA"
  },
  {
    "codigo":11783481000119101,
    "descripcion":"AMPOLLA DE MUÑECA DERECHA, CON INFECCIÓN"
  },
  {
    "codigo":283365004,
    "descripcion":"LACERACIÓN DE LA GARGANTA"
  },
  {
    "codigo":305843005,
    "descripcion":"VISTO POR EL SERVICIO DE MUSICOTERAPIA"
  },
  {
    "codigo":341151000119108,
    "descripcion":"EDEMA MACULAR CISTOIDE DE OJO IZQUIERDO DEBIDO A CIRUGÍA DE CATARATA Y POSTERIOR A ELLA"
  },
  {
    "codigo":248762000,
    "descripcion":"EXCITADO SEXUALMENTE"
  },
  {
    "codigo":16207161000119102,
    "descripcion":"HEMANGIOMA CAVERNOSO DE MÉDULA ESPINAL"
  },
  {
    "codigo":281530009,
    "descripcion":"FRACTURA DE APÓFISIS ESTILOIDES DE CÚBITO"
  },
  {
    "codigo":246927006,
    "descripcion":"PIGMENTACIÓN DE CÓRNEA"
  },
  {
    "codigo":17551007,
    "descripcion":"DIARREA CRÓNICA DE CAUSA DESCONOCIDA"
  },
  {
    "codigo":115855009,
    "descripcion":"FENOTIPO GERBICH NEGATIVO"
  },
  {
    "codigo":15715641000119106,
    "descripcion":"SECUESTRO ÓSEO DE HUESO TEMPORAL DERECHO"
  },
  {
    "codigo":15633721000119107,
    "descripcion":"QUISTE MUCOSO DIGITAL DE AMBAS MANOS"
  },
  {
    "codigo":1259065003,
    "descripcion":"CEFALEA AGUDA DEBIDA A CRANEOTOMÍA"
  },
  {
    "codigo":767545008,
    "descripcion":"QUISTE DE INCLUSIÓN EPITELIAL DE CONJUNTIVA"
  },
  {
    "codigo":896782004,
    "descripcion":"FORMA ANCHA ANORMAL CONGÉNITA DE FALANGE QUINTO DEDO DE PIE"
  },
  {
    "codigo":110350008,
    "descripcion":"FACTOR PSICÓGENO"
  },
  {
    "codigo":44814008,
    "descripcion":"ABORTO ESPONTÁNEO CON LACERACIÓN DE TEJIDO PERIURETRAL"
  },
  {
    "codigo":274190009,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE LA EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":306958009,
    "descripcion":"ABDUCCIÓN ALTERADA DE LA CUERDA VOCAL DURANTE LA RESPIRACIÓN"
  },
  {
    "codigo":42979006,
    "descripcion":"INTOXICACIÓN POR AMANITA"
  },
  {
    "codigo":1255395009,
    "descripcion":"CARCINOMA FUSOCELULAR DE PULMÓN"
  },
  {
    "codigo":303288002,
    "descripcion":"EQUIMOSIS DE PISO DE BOCA"
  },
  {
    "codigo":270520003,
    "descripcion":"MONOSOMÍA DE TODO UN CROMOSOMA - MOSAICISMO POR FALTA DE DISYUNCIÓN MITÓTICA"
  },
  {
    "codigo":204984002,
    "descripcion":"RIÑONES FUSIONADOS"
  },
  {
    "codigo":2641000124101,
    "descripcion":"PRIMER PREMOLAR SUPERIOR IZQUIERDO PERMANENTE SUPERNUMERARIO"
  },
  {
    "codigo":440401000124102,
    "descripcion":"HALLAZGO RELACIONADO CON LA INGESTA DE SUSTANCIA BIOACTIVA"
  },
  {
    "codigo":72077002,
    "descripcion":"ESTADO PREOPERATORIO"
  },
  {
    "codigo":235917005,
    "descripcion":"COLANGITIS ESCLEROSANTE"
  },
  {
    "codigo":1153421007,
    "descripcion":"CONDROSARCOMA DE ESTERNÓN"
  },
  {
    "codigo":432525007,
    "descripcion":"MASA EN CABEZA"
  },
  {
    "codigo":168546000,
    "descripcion":"RADIOGRAFÍA SIMPLE DE MANDÍBULA ANORMAL"
  },
  {
    "codigo":301453009,
    "descripcion":"LACERACIÓN DE TENDÓN"
  },
  {
    "codigo":234082004,
    "descripcion":"CONTUSIÓN VENOSA"
  },
  {
    "codigo":103010005,
    "descripcion":"CEFALEA ASOCIADA CON LA ACTIVIDAD SEXUAL"
  },
  {
    "codigo":430690005,
    "descripcion":"TEMBLOR ORTOSTÁTICO"
  },
  {
    "codigo":365154006,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA UTILIZAR UNA LLAVE"
  },
  {
    "codigo":299618008,
    "descripcion":"AMPLITUD DE ADUCCIÓN ACTIVA DE DEDO DEL PIE NORMAL"
  },
  {
    "codigo":11838931000119109,
    "descripcion":"DISTENSIÓN DE MÚSCULO INTRÍNSECO DE DEDO MEÑIQUE DE MANO IZQUIERDA"
  },
  {
    "codigo":166711002,
    "descripcion":"UREA EN SANGRE DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":397922005,
    "descripcion":"BLOQUEO DE LA CONDUCCIÓN NERVIOSA SENSITIVA - INERVACIÓN CAUDAL INADECUADA"
  },
  {
    "codigo":232247005,
    "descripcion":"MEMBRANA TIMPÁNICA - PERFORACIÓN TOTAL"
  },
  {
    "codigo":295948004,
    "descripcion":"SOBREDOSIS DE MIANSERINA"
  },
  {
    "codigo":263180005,
    "descripcion":"FRACTURA DE JEFFERSON"
  },
  {
    "codigo":427020007,
    "descripcion":"VASCULITIS CEREBRAL"
  },
  {
    "codigo":294113002,
    "descripcion":"ALERGIA A ACRIVASTINA"
  },
  {
    "codigo":16318061000119108,
    "descripcion":"HIPOGAMMAGLOBULINEMIA DEBIDA A GAMMAPATÍA MONOCLONAL DE SIGNIFICACIÓN INDETERMINADA"
  },
  {
    "codigo":95670000,
    "descripcion":"NEURALGIA DE NERVIO INTERMEDIARIO"
  },
  {
    "codigo":31969008,
    "descripcion":"FRAMBESIA NODULAR TARDÍA DE HUESO"
  },
  {
    "codigo":359649009,
    "descripcion":"DIETA PARA DISMINUCIÓN DE PESO"
  },
  {
    "codigo":1177014004,
    "descripcion":"NEURITIS BACTERIANA"
  },
  {
    "codigo":423350005,
    "descripcion":"ACETILADOR RÁPIDO POR VARIANTE DE ENZIMA N-ACETILTRANSFERASA"
  },
  {
    "codigo":292278006,
    "descripcion":"REACCIÓN ADVERSA AL CITRATO DE LITIO"
  },
  {
    "codigo":14899007,
    "descripcion":"INTOXICACIÓN POR CESTRUM PARQUI"
  },
  {
    "codigo":126603000,
    "descripcion":"NEOPLASIA DE PARTES BLANDAS DEL CUELLO"
  },
  {
    "codigo":716427000,
    "descripcion":"CAPAZ DE PASAR DE LA POSICIÓN SEDENTE EN EL BORDE DE LA CAMA A RECOSTADO EN LA CAMA"
  },
  {
    "codigo":93835002,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA CARA INTERNA DE LABIO"
  },
  {
    "codigo":290443002,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR LACTULOSA"
  },
  {
    "codigo":1339019009,
    "descripcion":"TRASTORNO DE CONJUNTIVA CAUSADO POR RADIACIÓN"
  },
  {
    "codigo":190304001,
    "descripcion":"BOCIO DIHORMONOGÉNICO"
  },
  {
    "codigo":288608007,
    "descripcion":"DIFICULTAD PARA EMPLEAR LOS ELEMENTOS DEL LENGUAJE"
  },
  {
    "codigo":92000007,
    "descripcion":"NEOPLASIA BENIGNA DE VASO SANGUÍNEO DEL ANTEBRAZO"
  },
  {
    "codigo":24629003,
    "descripcion":"CONDRODISPLASIA METAFISARIA, TIPO JANSEN"
  },
  {
    "codigo":286773003,
    "descripcion":"TIENDE A LA INESCRUPULOSIDAD"
  },
  {
    "codigo":188469005,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE CUELLO DE ÚTERO"
  },
  {
    "codigo":16045831000119108,
    "descripcion":"ALTERACIÓN DE ALINEACIÓN DE ARTICULACIÓN DE PIE DERECHO"
  },
  {
    "codigo":254005007,
    "descripcion":"FISURA MEDIOFACIAL DE TESSIER TIPO 14"
  },
  {
    "codigo":448778001,
    "descripcion":"OBSTRUCCIÓN DEL TRACTO DE SALIDA DE VENTRÍCULO DERECHO DEBIDA A TÚNEL AORTICOVENTRICULAR IZQUIERDO"
  },
  {
    "codigo":219402002,
    "descripcion":"HERIDA DE GUERRA POR EXPLOSIÓN ACCIDENTAL DE ARMAS PROPIAS"
  },
  {
    "codigo":1237045009,
    "descripcion":"METÁSTASIS DE CARCINOMA DE CUERPO DE ESTÓMAGO"
  },
  {
    "codigo":22794007,
    "descripcion":"PROTEINURIA HEMATÓGENA"
  },
  {
    "codigo":416010008,
    "descripcion":"HIPOSPADIAS"
  },
  {
    "codigo":283103004,
    "descripcion":"ARAÑAZO DE PIERNA"
  },
  {
    "codigo":707252001,
    "descripcion":"PERIODONTITIS CRÓNICA LOCALIZADA"
  },
  {
    "codigo":281268007,
    "descripcion":"ESPÉCIMEN INSUFICIENTE"
  },
  {
    "codigo":248500008,
    "descripcion":"EDEMA INDURADO CON COLORACIÓN PARDA"
  },
  {
    "codigo":838324008,
    "descripcion":"NEUROPATÍA ÓPTICA AUTOINMUNITARIA"
  },
  {
    "codigo":445108007,
    "descripcion":"DISMINUCIÓN DE LA FUNCIÓN RENAL RELACIONADA CON LA EDAD"
  },
  {
    "codigo":246665002,
    "descripcion":"HEMIANOPSIA HOMÓNIMA INCOMPLETA"
  },
  {
    "codigo":408670001,
    "descripcion":"DEFICIENCIA IATROGÉNICA DE CARNITINA"
  },
  {
    "codigo":15454001,
    "descripcion":"TAMAÑO AUMENTADO"
  },
  {
    "codigo":1162334003,
    "descripcion":"DETENCIÓN DEL CRECIMIENTO EPIFISARIO DEBIDA A LESIÓN TRAUMÁTICA Y POSTERIOR A ELLA"
  },
  {
    "codigo":410505009,
    "descripcion":"RESTRICCIÓN DE MÚSCULO RECTO INTERNO DEL OJO"
  },
  {
    "codigo":212062005,
    "descripcion":"CORROSIÓN QUE COMPROMETE EL 20 AL 29 PORCIENTO DE LA SUPERFICIE CORPORAL"
  },
  {
    "codigo":310366008,
    "descripcion":"SITUACIÓN DE EXÁMENES\/ INFORMES MÉDICOS"
  },
  {
    "codigo":111923002,
    "descripcion":"GASTRODISCOIDIASIS"
  },
  {
    "codigo":249491000119100,
    "descripcion":"ANOMALÍAS ESTRUCTURALES DEL DESARROLLO DE CONDUCTO NEUROENTÉRICO"
  },
  {
    "codigo":349331000119101,
    "descripcion":"COLOBOMA ADQUIRIDO DE DISCO ÓPTICO DE AMBOS OJOS"
  },
  {
    "codigo":321171000119102,
    "descripcion":"ESPONDILOLISTESIS DE VÉRTEBRA LUMBAR"
  },
  {
    "codigo":15650451000119100,
    "descripcion":"CHASQUIDO DE RODILLA IZQUIERDA"
  },
  {
    "codigo":11800211000119104,
    "descripcion":"LACERACIÓN DE VENA CAVA INFERIOR"
  },
  {
    "codigo":303251000119105,
    "descripcion":"TENDINITIS CALCIFICANTE DE PIERNA DERECHA"
  },
  {
    "codigo":108691000119102,
    "descripcion":"ESPASTICIDAD COMO SECUELA DE ACCIDENTE CEREBROVASCULAR"
  },
  {
    "codigo":116371000119107,
    "descripcion":"GANGLIONEUROMA"
  },
  {
    "codigo":1091731000119108,
    "descripcion":"TRASTORNO DE OÍDO MEDIO DERECHO"
  },
  {
    "codigo":16229011000119100,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE PARTES BLANDAS DE CADERA DERECHA"
  },
  {
    "codigo":242995009,
    "descripcion":"LACERACIÓN ACCIDENTAL DURANTE UN PROCEDIMIENTO"
  },
  {
    "codigo":110088001,
    "descripcion":"AVULSIÓN DE LA LENGUA"
  },
  {
    "codigo":129171000119106,
    "descripcion":"ENFERMEDAD RENAL CRÓNICA DEBIDA A HIPERTENSIÓN, ESTADIO 3"
  },
  {
    "codigo":44552000,
    "descripcion":"VÍCTIMA DE CONTIENDA AÉREA"
  },
  {
    "codigo":1171000119108,
    "descripcion":"HERNIA INGUINAL RECURRENTE"
  },
  {
    "codigo":16715411000119108,
    "descripcion":"DISFUNCIÓN ERÉCTIL DEBIDA A RADIOTERAPIA Y POSTERIOR A ELLA"
  },
  {
    "codigo":295571000119109,
    "descripcion":"CALCIFICACIÓN Y OSIFICACIÓN DE MÚSCULO DE HOMBRO DEBIDA A QUEMADURA"
  },
  {
    "codigo":1156829005,
    "descripcion":"BOTULISMO IATROGÉNICO"
  },
  {
    "codigo":346771000119109,
    "descripcion":"AGRANDAMIENTO CRÓNICO DE AMBAS GLÁNDULAS LAGRIMALES"
  },
  {
    "codigo":698077007,
    "descripcion":"FRACTURA POR COMPRESIÓN DE COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":1287901008,
    "descripcion":"FÍSTULA DE ARTICULACIÓN DE PIE"
  },
  {
    "codigo":304861009,
    "descripcion":"RELACIÓN ARMÓNICA"
  },
  {
    "codigo":403165009,
    "descripcion":"LESIÓN TRAUMÁTICA POR ARAÑAZO DE GATO"
  },
  {
    "codigo":346171000119108,
    "descripcion":"EPÍFORA DE AMBOS OJOS DEBIDA A TRASTORNO DEL DRENAJE LAGRIMAL"
  },
  {
    "codigo":15966421000119103,
    "descripcion":"ESTENOSIS CONGÉNITA DE AMBAS ARTERIAS RENALES"
  },
  {
    "codigo":170119000,
    "descripcion":"EXAMEN DEL NIÑO A LAS SEIS SEMANAS: ANORMAL - PARA OBSERVACIÓN"
  },
  {
    "codigo":401330008,
    "descripcion":"ALTO RIESGO DE AUTODESCUIDO"
  },
  {
    "codigo":235655002,
    "descripcion":"GASTRITIS INFECCIOSA"
  },
  {
    "codigo":399495003,
    "descripcion":"HALLAZGO HISTOLÓGICO ACCIDENTAL DE TUMOR DE PRÓSTATA EN MÁS DEL 5% DE TEJIDO RESECADO"
  },
  {
    "codigo":301191003,
    "descripcion":"LESIÓN DE NARIZ"
  },
  {
    "codigo":8114009,
    "descripcion":"DIVERTICULOSIS DEL INTESTINO DELGADO"
  },
  {
    "codigo":366727007,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA CAMINAR"
  },
  {
    "codigo":430428000,
    "descripcion":"ARTROPATÍA DE TOBILLO Y\/O PIE ASOCIADA CON UN TRASTORNO NEUROLÓGICO"
  },
  {
    "codigo":364892002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA MOVER LOS CUATRO MIEMBROS"
  },
  {
    "codigo":69980003,
    "descripcion":"DIARREA NO INFECCIOSA"
  },
  {
    "codigo":397660003,
    "descripcion":"SÍNDROME DE ABSTINENCIA EN EL NIÑO"
  },
  {
    "codigo":231985001,
    "descripcion":"RETINOPATÍA POR RUBÉOLA"
  },
  {
    "codigo":166449002,
    "descripcion":"NIVELES SÉRICOS DE ESTRADIOL POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":363057004,
    "descripcion":"TRASTORNO DEGENERATIVO DE LA CABEZA"
  },
  {
    "codigo":1149489008,
    "descripcion":"BACTERIEMIA CAUSADA POR ENTEROCOCCUS"
  },
  {
    "codigo":35377009,
    "descripcion":"LARINGOTRAQUEOBRONQUITIS CAUSADA POR EL VIRUS DE LA PARAINFLUENZA"
  },
  {
    "codigo":262918000,
    "descripcion":"CONTUSIÓN DE CONDUCTO DEFERENTE"
  },
  {
    "codigo":10860911000119103,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR JABÓN"
  },
  {
    "codigo":787206005,
    "descripcion":"RABDOMIÓLISIS DEBIDA A ESTATINA"
  },
  {
    "codigo":295686005,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE DOXORUBICINA"
  },
  {
    "codigo":721670007,
    "descripcion":"NEOPLASIA NEUROENDOCRINA MALIGNA PRIMARIA DE INTESTINO DELGADO"
  },
  {
    "codigo":228315001,
    "descripcion":"BEBEDOR COMPULSIVO ESPORÁDICO"
  },
  {
    "codigo":230150008,
    "descripcion":"MENINGITIS EN LA ENFERMEDAD DE LYME"
  },
  {
    "codigo":719835006,
    "descripcion":"SÍNDROME DE CABELLO LANOSO Y QUERATODERMIA PALMOPLANTAR CON MIOCARDIOPATÍA DILATADA"
  },
  {
    "codigo":293851008,
    "descripcion":"ALERGIA A FLUVOXAMINA"
  },
  {
    "codigo":11843951000119105,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE PABELLÓN AURICULAR DERECHO"
  },
  {
    "codigo":1085961000119100,
    "descripcion":"CARIES DENTAL SOBRE SUPERFICIE CON HENDIDURAS Y FISURAS CON PENETRACIÓN HASTA LA DENTINA"
  },
  {
    "codigo":62640008,
    "descripcion":"RALES FINOS"
  },
  {
    "codigo":60805002,
    "descripcion":"ANEMIA HEMOLÍTICA CON ENFISEMA Y CUTIS LAXA"
  },
  {
    "codigo":716165003,
    "descripcion":"SÍNDROME DE MICROCÓRNEA CON PAPILA ECTÓPICA E HIPOPLASIA MACULAR"
  },
  {
    "codigo":880005004,
    "descripcion":"PERFORACIÓN DE VENTRÍCULO DERECHO LUEGO DE PROCEDIMIENTO"
  },
  {
    "codigo":348681000119101,
    "descripcion":"HIPOTROPÍA DE OJO IZQUIERDO"
  },
  {
    "codigo":93573007,
    "descripcion":"OSIFICACIÓN INCOMPLETA DEL CENTRO DE LA VÉRTEBRA CERVICAL"
  },
  {
    "codigo":288346005,
    "descripcion":"NO TRANSPORTA UN OBJETO"
  },
  {
    "codigo":417583002,
    "descripcion":"ONICOMICOSIS BLANCA SUPERFICIAL"
  },
  {
    "codigo":16732681000119104,
    "descripcion":"POSICIÓN ANÓMALA DE GENERADOR DE NEUROESTIMULADOR"
  },
  {
    "codigo":286511005,
    "descripcion":"NO SIGUE LAS INSTRUCCIONES DE UNA RECETA"
  },
  {
    "codigo":384815007,
    "descripcion":"INVASIÓN TUMORAL DE PLEURA VISCERAL PRESENTE"
  },
  {
    "codigo":253743009,
    "descripcion":"BRONCOMALACIA CONGÉNITA SECUNDARIA"
  },
  {
    "codigo":415748002,
    "descripcion":"RUPTURA TRAUMÁTICA DE TENDÓN ROTULIANO"
  },
  {
    "codigo":55300003,
    "descripcion":"CALAMBRE"
  },
  {
    "codigo":448516008,
    "descripcion":"DOBLE TRACTO DE SALIDA DE VENTRÍCULO DERECHO CON DEFECTO DE TABIQUE INTERVENTRICULAR SUPRACRISTAL Y ESTENOSIS PULMONAR"
  },
  {
    "codigo":282841001,
    "descripcion":"DIFICULTAD PARA MOVERSE DE UNA POSICIÓN"
  },
  {
    "codigo":446681005,
    "descripcion":"RUPTURA DE URETRA POSTERIOR"
  },
  {
    "codigo":1003737008,
    "descripcion":"CONTRACTURA EN FLEXIÓN DE ARTICULACIÓN INTERFALÁNGICA DISTAL DE DEDO ÍNDICE"
  },
  {
    "codigo":1231278004,
    "descripcion":"MIDRIASIS EPISÓDICA DEBIDA A INSUFICIENCIA PARASIMPÁTICA"
  },
  {
    "codigo":1264046005,
    "descripcion":"TRASTORNO FETAL CAUSADO POR AGENTE ANTIINFECCIOSO TRANSMITIDO POR VÍA PLACENTARIA"
  },
  {
    "codigo":703320000,
    "descripcion":"ESTENOSIS DE VÁLVULA MITRAL CON INSUFICIENCIA DE ETIOLOGÍA NO REUMÁTICA"
  },
  {
    "codigo":705155008,
    "descripcion":"ANGIOMA EN RACIMO"
  },
  {
    "codigo":408408004,
    "descripcion":"DERIVACIÓN INADECUADA"
  },
  {
    "codigo":406573001,
    "descripcion":"ENCEFALITIS PRIMARIA"
  },
  {
    "codigo":275501002,
    "descripcion":"PLEURITIS SEROSA"
  },
  {
    "codigo":15887011000119107,
    "descripcion":"BEBÉ PREMATURO, 24 SEMANAS"
  },
  {
    "codigo":373805004,
    "descripcion":"GRADO 2 DE LA ESCALA DEL ESTADO FUNCIONAL DE LA ORGANIZACIÓN MUNDIAL DE LA SALUD"
  },
  {
    "codigo":1293144009,
    "descripcion":"HEMANGIOENDOTELIOMA PSEUDOMIOGÉNICO SIMILAR A SARCOMA EPITELIOIDE"
  },
  {
    "codigo":371970002,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA VÍA BILIAR"
  },
  {
    "codigo":109826003,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE CONDUCTO DE GLÁNDULA SALIVAL"
  },
  {
    "codigo":44290007,
    "descripcion":"INTOXICACIÓN POR TAXUS"
  },
  {
    "codigo":206295000,
    "descripcion":"ASPIRACIÓN DE VÓMITO EN EL RECIÉN NACIDO"
  },
  {
    "codigo":208130009,
    "descripcion":"FRACTURA EXPUESTA DE HUESO HIOIDES"
  },
  {
    "codigo":763351003,
    "descripcion":"ATAXIA CEREBELOSA AUTOSÓMICA RECESIVA ASOCIADA CON ESPECTRINA"
  },
  {
    "codigo":1254871005,
    "descripcion":"REACCIÓN FOTOTÓXICA CAUSADA POR PSORALENO TÓPICO"
  },
  {
    "codigo":239063006,
    "descripcion":"ERITROQUERATODERMIA PROGRESIVA DE GOTTRON"
  },
  {
    "codigo":402903007,
    "descripcion":"ROSÉOLA INFANTIL CAUSADA POR VIRUS HERPES HUMANO 7"
  },
  {
    "codigo":40620001,
    "descripcion":"SÍNDROME DE LAS LÁGRIMAS DE COCODRILO"
  },
  {
    "codigo":827052002,
    "descripcion":"ERUPCIÓN DEBIDA A GOTEO DE ORINA"
  },
  {
    "codigo":204460003,
    "descripcion":"TERMINACIÓN ANÓMALA DE VENA PORTA"
  },
  {
    "codigo":401068004,
    "descripcion":"ATENDIDO POR ASESOR DEL CESE DE TABAQUISMO"
  },
  {
    "codigo":106156009,
    "descripcion":"HALLAZGO EN EL SEXTO PAR CRANEANO"
  },
  {
    "codigo":302764009,
    "descripcion":"NO INMUNE A RUBÉOLA"
  },
  {
    "codigo":300929003,
    "descripcion":"ADENOAMIGDALITIS"
  },
  {
    "codigo":366465004,
    "descripcion":"HALLAZGO RELACIONADO CON RUIDOS EN ABDOMEN"
  },
  {
    "codigo":399233006,
    "descripcion":"LESIÓN DEL NERVIO TIBIAL"
  },
  {
    "codigo":168022001,
    "descripcion":"LÍQUIDO ASCÍTICO: PIOCITOS"
  },
  {
    "codigo":15997911000119103,
    "descripcion":"OCLUSIÓN VASCULAR DE RETINA DE OJO IZQUIERDO"
  },
  {
    "codigo":725078006,
    "descripcion":"TRASTORNO CONGÉNITO DE LA GLICOSILACIÓN TIPO 1E"
  },
  {
    "codigo":69718008,
    "descripcion":"NEFROPATÍA POR OXALATO"
  },
  {
    "codigo":264491001,
    "descripcion":"REMANENTE MULLERIANO"
  },
  {
    "codigo":430166008,
    "descripcion":"ANOMALÍA CONGÉNITA DE VASO SANGUÍNEO PERIFÉRICO"
  },
  {
    "codigo":788779003,
    "descripcion":"ALERGIA A GALACTOSA-ALFA-1,3 GALACTOSA"
  },
  {
    "codigo":299094008,
    "descripcion":"AMPLITUD DE ABDUCCIÓN PASIVA DE DEDO E LA MANO DISMINUIDA"
  },
  {
    "codigo":461099008,
    "descripcion":"ANOMALÍA CARDIOVASCULAR DEBIDA A CONDUCTO ARTERIOSO PERMEABLE"
  },
  {
    "codigo":262656001,
    "descripcion":"LESIÓN PENETRANTE DE CAVIDAD BUCAL"
  },
  {
    "codigo":197120000,
    "descripcion":"ESTREÑIMIENTO CRÓNICO SIN DIARREA POR REBOSAMIENTO"
  },
  {
    "codigo":295424000,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE METOCLOPRAMIDA"
  },
  {
    "codigo":424661000,
    "descripcion":"ESPACIO VITAL DESORDENADO"
  },
  {
    "codigo":721408009,
    "descripcion":"LESIÓN TRAUMÁTICA DE DIVISIÓN DE PLEXO BRAQUIAL"
  },
  {
    "codigo":129749001,
    "descripcion":"MACROCALCIFICACIÓN (TIPO PALOMITA DE MAÍZ)"
  },
  {
    "codigo":64213003,
    "descripcion":"LUXACIÓN NO EXPUESTA ANTERIOR DE EXTREMO DISTAL DE FÉMUR"
  },
  {
    "codigo":162517003,
    "descripcion":"DIETA CON ALTO CONTENIDO DE GRASAS SATURADAS"
  },
  {
    "codigo":1088471000119108,
    "descripcion":"OTITIS EXTERNA CRÓNICA DEL CONDUCTO AUDITIVO EXTERNO IZQUIERDO CAUSADA POR HONGO"
  },
  {
    "codigo":293589008,
    "descripcion":"ALERGIA A FENAZOCINA"
  },
  {
    "codigo":160682003,
    "descripcion":"MÓVIL EN DOMICILIO"
  },
  {
    "codigo":95146003,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL TRAPECIO"
  },
  {
    "codigo":226218007,
    "descripcion":"DIETA DE INVESTIGACIÓN"
  },
  {
    "codigo":781439002,
    "descripcion":"DISTENSIÓN DE TENDÓN DE DEDO DE LA MANO"
  },
  {
    "codigo":190643008,
    "descripcion":"OSTEOMALACIA PUERPERAL"
  },
  {
    "codigo":289919004,
    "descripcion":"DEGLUTE LENTAMENTE"
  },
  {
    "codigo":715903004,
    "descripcion":"MEDULOEPITELIOMA"
  },
  {
    "codigo":93311004,
    "descripcion":"POSICIÓN ANÓMALA CONGÉNITA DEL CALCÁNEO"
  },
  {
    "codigo":224383008,
    "descripcion":"SOLICITA ORIENTACIÓN VOCACIONAL"
  },
  {
    "codigo":25940001,
    "descripcion":"QUISTE TRAUMÁTICO DE MANDÍBULA"
  },
  {
    "codigo":131037000,
    "descripcion":"NIVEL DE NOREPINEFRINA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":124244005,
    "descripcion":"DEFICIENCIA DE FOSFORRIBOSILGLICINAMIDA FORMILTRANSFERASA"
  },
  {
    "codigo":253481000,
    "descripcion":"FUSIÓN CONGÉNITA DE MÚSCULOS PAPILARES DE VÁLVULA AURICULOVENTRICULAR DERECHA"
  },
  {
    "codigo":417321001,
    "descripcion":"UVEÍTIS ASOCIADA AL HTLV-1"
  },
  {
    "codigo":1303892008,
    "descripcion":"GLAUCOMA DE ÁNGULO ABIERTO DE OJO DERECHO DEBIDO A DESPRENDIMIENTO DE RETINA"
  },
  {
    "codigo":187945003,
    "descripcion":"NEOPLASIA MALIGNA DEL PRIMER METACARPIANO"
  },
  {
    "codigo":286249005,
    "descripcion":"INCAPAZ DE USAR TONOS VOCALES Y UNIDADES FONÉTICAS"
  },
  {
    "codigo":15725681000119108,
    "descripcion":"FÍSTULA DE ARTICULACIONES BILATERALES DE MUÑECAS"
  },
  {
    "codigo":284414003,
    "descripcion":"NO MANTIENE EL EQUILIBRIO AL ALCANZAR ALGO"
  },
  {
    "codigo":448254007,
    "descripcion":"LINFOMA NO HODGKIN DE SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":87806008,
    "descripcion":"ANEMIA MEGALOBLÁSTICA POR ESPRUE TROPICAL"
  },
  {
    "codigo":249811001,
    "descripcion":"DEFORMIDAD DE ANTEPIÉ EN SUPINACIÓN"
  },
  {
    "codigo":85971001,
    "descripcion":"ESTENOSIS DE VÁLVULA PULMONAR REUMÁTICA CON INSUFICIENCIA"
  },
  {
    "codigo":282579004,
    "descripcion":"NO BRINCA"
  },
  {
    "codigo":446419007,
    "descripcion":"PRÓSTATA MÍNIMAMENTE AGRANDADA"
  },
  {
    "codigo":870568002,
    "descripcion":"ORTOREXIA NERVIOSA"
  },
  {
    "codigo":247976007,
    "descripcion":"CONDUCTA LIBERTINA"
  },
  {
    "codigo":80466000,
    "descripcion":"GANGRENA GASEOSA"
  },
  {
    "codigo":735826003,
    "descripcion":"RUPTURA TRAUMÁTICA DE LIGAMENTO PALMAR A LA ALTURA DE ARTICULACIÓN METACARPOFALÁNGICA DE MANO"
  },
  {
    "codigo":703058005,
    "descripcion":"ACINETOBACTER CALCOACETICUS O ACINETOBACTER HAEMOLYTICUS"
  },
  {
    "codigo":209703000,
    "descripcion":"SECCIÓN EXPUESTA DE LIGAMENTO INTERNO DE TOBILLO"
  },
  {
    "codigo":309842008,
    "descripcion":"VIRGEN"
  },
  {
    "codigo":78631004,
    "descripcion":"ERITROMELANOSIS FOLICULAR DE LA CARA Y\/O DEL CUELLO"
  },
  {
    "codigo":764924000,
    "descripcion":"MOVIMIENTO, SENSIBILIDAD Y CIRCULACIÓN DE MIEMBRO SUPERIOR NORMALES"
  },
  {
    "codigo":766759009,
    "descripcion":"RABDOMIOSARCOMA VULVOVAGINAL"
  },
  {
    "codigo":240636002,
    "descripcion":"LEISHMANIASIS HEMORRÁGICA"
  },
  {
    "codigo":371708003,
    "descripcion":"LESIÓN CAUSADA POR EXPOSICIÓN A LA ELECTRICIDAD"
  },
  {
    "codigo":16711231000119100,
    "descripcion":"EDEMA DE MÁCULA RETINIANA DEBIDO A OCLUSIÓN DE VENA CENTRAL DE LA RETINA DERECHA"
  },
  {
    "codigo":76796008,
    "descripcion":"ÚLCERA GÁSTRICA CRÓNICA SIN HEMORRAGIA Y SIN PERFORACIÓN"
  },
  {
    "codigo":109564008,
    "descripcion":"CARIES DENTAL ASOCIADA CON HIPOMINERALIZACIÓN DEL ESMALTE"
  },
  {
    "codigo":402641003,
    "descripcion":"ACNÉ DE ORIGEN EXTERNO"
  },
  {
    "codigo":271569006,
    "descripcion":"HIDROCEFALIA COMUNICANTE"
  },
  {
    "codigo":304337006,
    "descripcion":"AMPLITUD DE MOVIMIENTO DE DEDO DEL PIE NORMAL"
  },
  {
    "codigo":300667002,
    "descripcion":"NO REALIZA EJERCICIO DE SEGURIDAD VIAL"
  },
  {
    "codigo":38523005,
    "descripcion":"PARKINSONISMO SIFILÍTICO"
  },
  {
    "codigo":366203006,
    "descripcion":"HALLAZGO RELACIONADO CON EL ESTADO DE LA PARED ARTERIAL"
  },
  {
    "codigo":235131006,
    "descripcion":"LESIÓN TRAUMÁTICA DE GLÁNDULA SALIVAL"
  },
  {
    "codigo":36688000,
    "descripcion":"FORÚNCULO DE MAMA"
  },
  {
    "codigo":724816007,
    "descripcion":"ANHIDROSIS ADQUIRIDA CONCOMITANTE CON TRASTORNO AUTONÓMICO PRIMARIO Y DEBIDA A ÉL"
  },
  {
    "codigo":10649151000119107,
    "descripcion":"ÚLCERA DE PANTORRILLA DERECHA"
  },
  {
    "codigo":296997003,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE BRETILIO"
  },
  {
    "codigo":722981005,
    "descripcion":"CEFALEA TENSIONAL EPISÓDICA INFRECUENTE"
  },
  {
    "codigo":229626005,
    "descripcion":"TARTAMUDEO PRIMARIO"
  },
  {
    "codigo":721146009,
    "descripcion":"SÍNDROME DE DISCAPACIDAD INTELECTUAL, EPILEPSIA, NARIZ BULBOSA"
  },
  {
    "codigo":63951004,
    "descripcion":"MILIARIA"
  },
  {
    "codigo":94884001,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL ISTMO UTERINO"
  },
  {
    "codigo":291492004,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ERITROMICINA"
  },
  {
    "codigo":783012006,
    "descripcion":"SÍNDROME PIRAMIDAL PARKINSONIANO"
  },
  {
    "codigo":225956009,
    "descripcion":"CON MAYOR RIESGO DE INFECCIÓN DE VÍAS URINARIAS"
  },
  {
    "codigo":193188009,
    "descripcion":"POLINEUROPATÍA DEBIDA A DEFICIENCIA DE VITAMINA B"
  },
  {
    "codigo":289657002,
    "descripcion":"FONDO UTERINO DESPLAZADO POR DEBAJO DEL INTROITO DURANTE EL ESFUERZO"
  },
  {
    "codigo":224121002,
    "descripcion":"FAMILIA CON UN NIÑO PEQUEÑO"
  },
  {
    "codigo":93049005,
    "descripcion":"QUISTE CONGÉNITO DEL BAZO"
  },
  {
    "codigo":15701721000119108,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE TENDÓN DE AMBAS MANOS"
  },
  {
    "codigo":123982003,
    "descripcion":"EDAD ÓSEA AVANZADA"
  },
  {
    "codigo":285987001,
    "descripcion":"NO ENCIENDE EL CONDUCTOR ELÉCTRICO PRINCIPAL"
  },
  {
    "codigo":417059002,
    "descripcion":"CONVOCATORIA VERBAL PARA CONTROL DE ACCIDENTE CEREBROVASCULAR\/ATAQUE ISQUÉMICO TRANSITORIO"
  },
  {
    "codigo":187683004,
    "descripcion":"NEOPLASIA MALIGNA DEL PLIEGUE GLOSOEPIGLÓTICO"
  },
  {
    "codigo":253219005,
    "descripcion":"AGENESIA DE CONDUCTO NASOLAGRIMAL"
  },
  {
    "codigo":449827006,
    "descripcion":"LOQUIOS BLANCOS"
  },
  {
    "codigo":415224005,
    "descripcion":"ABERRACIÓN DEL FRENTE DE ONDAS, QUADRAFOIL"
  },
  {
    "codigo":284152006,
    "descripcion":"MUEVE LA PIERNA"
  },
  {
    "codigo":413389003,
    "descripcion":"LEUCEMIA MIELOIDE CRÓNICA EN FASE ACELERADA"
  },
  {
    "codigo":282317005,
    "descripcion":"CAPAZ DE ESTAR PARADO SOLO"
  },
  {
    "codigo":1263522001,
    "descripcion":"MENINGITIS DEBIDA A SÍNDROME DE SJÖGREN"
  },
  {
    "codigo":870306002,
    "descripcion":"TRASTORNO GENERALIZADO DEL DESARROLLO CON ALTERACIÓN COMPLETA DEL LENGUAJE FUNCIONAL"
  },
  {
    "codigo":313250007,
    "descripcion":"NEOPLASIA MALIGNA DEL PÁRPADO INFERIOR"
  },
  {
    "codigo":278647000,
    "descripcion":"COMPONENTE DE DISPOSITIVO ORTODÓNCICO, FRACTURADO"
  },
  {
    "codigo":247714009,
    "descripcion":"LOS SONIDOS PARECEN ARTIFICIALMENTE CLAROS"
  },
  {
    "codigo":49271002,
    "descripcion":"DIAGNÓSTICO APLAZADO EN EL EJE II"
  },
  {
    "codigo":276812001,
    "descripcion":"LEIOMIOMA GÁSTRICO"
  },
  {
    "codigo":473420003,
    "descripcion":"GEMELOS CON CRECIMIENTO FETAL DISCORDANTE"
  },
  {
    "codigo":735564008,
    "descripcion":"ATROFIA DE OÍDO"
  },
  {
    "codigo":733729003,
    "descripcion":"AMILOIDOSIS CUTÁNEA PRIMARIA LOCALIZADA"
  },
  {
    "codigo":303271000119101,
    "descripcion":"TENDINITIS CALCIFICANTE DE MUSLO DERECHO"
  },
  {
    "codigo":897569003,
    "descripcion":"DELECIÓN DISTAL DEL CROMOSOMA 15"
  },
  {
    "codigo":1290785006,
    "descripcion":"FRACTURA POR SOBRECARGA DE HUESO DE PIERNA"
  },
  {
    "codigo":240374000,
    "descripcion":"ISOSESPORIASIS INTESTINAL CRÓNICA"
  },
  {
    "codigo":209441008,
    "descripcion":"ESGUINCE DE ARTICULACIÓN RADIOCUBITAL DISTAL"
  },
  {
    "codigo":43766001,
    "descripcion":"LINFADENOPATÍA FIBRÓTICA"
  },
  {
    "codigo":10625191000119102,
    "descripcion":"BRONCONEUMONÍA CAUSADA POR STREPTOCOCCUS DEL GRUPO B"
  },
  {
    "codigo":76534005,
    "descripcion":"MIOCARDITIS POR TOXOPLASMOSIS ADQUIRIDA"
  },
  {
    "codigo":10998006,
    "descripcion":"LESIÓN TRAUMÁTICA DE COLON SIGMOIDE CON HERIDA ABIERTA HACIA CAVIDAD ABDOMINAL"
  },
  {
    "codigo":305910007,
    "descripcion":"ATENDIDO EN HOSPITAL DE DÍA GERIÁTRICO"
  },
  {
    "codigo":109302008,
    "descripcion":"OSTEOMIELITIS ESCLEROSANTE DIFUSA"
  },
  {
    "codigo":238539001,
    "descripcion":"ECCEMA DE MANO"
  },
  {
    "codigo":1156043001,
    "descripcion":"FENITOÍNA SÉRICA POR ENCIMA DEL RANGO TERAPÉUTICO"
  },
  {
    "codigo":402379003,
    "descripcion":"GRANULOMA POR TALCO DE OMBLIGO"
  },
  {
    "codigo":205771006,
    "descripcion":"CRANEÓPAGO FRONTAL"
  },
  {
    "codigo":74699008,
    "descripcion":"CUERPO EXTRAÑO EN LA NARIZ"
  },
  {
    "codigo":1287115009,
    "descripcion":"MÚLTIPLES CUERPOS EXTRAÑOS RETENIDOS EN TEJIDO BLANDO"
  },
  {
    "codigo":105632002,
    "descripcion":"ENFERMEDAD CAUSADA POR BUNYAVIRIDAE"
  },
  {
    "codigo":1285280000,
    "descripcion":"RAZÓN INTERNACIONAL NORMALIZADA POR DEBAJO DE RANGO DE REFERENCIA"
  },
  {
    "codigo":203936004,
    "descripcion":"ESPINA BÍFIDA LUMBAR CON HIDROCEFALIA"
  },
  {
    "codigo":365941000,
    "descripcion":"HALLAZGO RELACIONADO CON LOS HÁBITOS"
  },
  {
    "codigo":726389000,
    "descripcion":"DELECIÓN DE PARTE DEL CROMOSOMA 17"
  },
  {
    "codigo":890229002,
    "descripcion":"ENFERMEDAD HEPÁTICA POLIQUÍSTICA AUTOSÓMICA DOMINANTE"
  },
  {
    "codigo":300405003,
    "descripcion":"CONTORNO ABDOMINAL NORMAL"
  },
  {
    "codigo":171168009,
    "descripcion":"EXTENDIDO DE CÚPULA VAGINAL PENDIENTE"
  },
  {
    "codigo":38261007,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA VENA CAVA SUPERIOR"
  },
  {
    "codigo":396874001,
    "descripcion":"TUMOR SÓLIDO, TOTALMENTE ENCAPSULADO"
  },
  {
    "codigo":1052234002,
    "descripcion":"CONTRACCIÓN DEL CAMPO VISUAL DEL OJO DERECHO"
  },
  {
    "codigo":724554001,
    "descripcion":"NEOPLASIA EPITELIAL MALIGNA PRIMARIA DE GLÁNDULA ENDOCRINA"
  },
  {
    "codigo":69194003,
    "descripcion":"HIPERALDOSTERONISMO CON HIPERPLASIA NODULAR DE LA CORTEZA SUPRARRENAL"
  },
  {
    "codigo":112961000119103,
    "descripcion":"ARTROSIS DE ARTICULACIÓN DE AMBOS PIES"
  },
  {
    "codigo":298570006,
    "descripcion":"AMPLITUD DE ROTACIÓN PASIVA HACIA LA IZQUIERDA DE LA COLUMNA VERTEBRAL DORSAL, AUMENTADA"
  },
  {
    "codigo":36426008,
    "descripcion":"BRONQUITIS SUBAGUDA"
  },
  {
    "codigo":296735000,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE CEFTRIAXONA"
  },
  {
    "codigo":67359005,
    "descripcion":"PREECLAMPSIA SOBREAGREGADA A HIPERTENSIÓN PREEXISTENTE"
  },
  {
    "codigo":722719009,
    "descripcion":"MENINGITIS NO INFECCIOSA DEBIDA A TRASTORNO INFLAMATORIO"
  },
  {
    "codigo":65524005,
    "descripcion":"MANOSIDOSIS"
  },
  {
    "codigo":31041000119106,
    "descripcion":"TRABAJO DE PARTO OBSTRUIDO POR DETENCIÓN TRANSVERSA PROFUNDA Y POSICIÓN OCCIPITOPOSTERIOR PERSISTENTE"
  },
  {
    "codigo":131060008,
    "descripcion":"ESTRÓGENO ANORMAL"
  },
  {
    "codigo":294900009,
    "descripcion":"ALERGIA A SULFATO DE GLICINA FERROSO"
  },
  {
    "codigo":30921002,
    "descripcion":"HEMORRAGIA PULMONAR MASIVA PERINATAL"
  },
  {
    "codigo":719049003,
    "descripcion":"MIELOLIPOMA DE GLÁNDULA SUPRARRENAL"
  },
  {
    "codigo":686401000119107,
    "descripcion":"HISTIOCITOMA FIBROSO MALIGNO PRIMARIO DE PARTES BLANDAS DE TÓRAX"
  },
  {
    "codigo":16906561000119108,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE PÁRPADO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":260297007,
    "descripcion":"PERCEPCIÓN DE LA LUZ - PROYECCIÓN PRECISA"
  },
  {
    "codigo":161993009,
    "descripcion":"VENAS DEL BRAZO PROMINENTES"
  },
  {
    "codigo":94622002,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL LÓBULO TEMPORAL"
  },
  {
    "codigo":782750002,
    "descripcion":"DEFICIENCIA DE LINFOCITOS T POSITIVOS PARA EL RECEPTOR ALFA\/BETA DE LINFOCITOS T"
  },
  {
    "codigo":192926004,
    "descripcion":"ESCLEROSIS MÚLTIPLE - TRONCO ENCEFÁLICO"
  },
  {
    "codigo":717214005,
    "descripcion":"STREPTOCOCCUS DYSGALACTIAE SUBESPECIE DYSGALACTIAE O STREPTOCOCCUS DYSGALACTIAE SUBESPECIE EQUISIMILIS O STREPTOCOCCUS DEL GRUPO G"
  },
  {
    "codigo":127390005,
    "descripcion":"NIVEL DE BETAGLOBULINA FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":92787000,
    "descripcion":"CARCINOMA IN SITU DE LOS ANEXOS UTERINOS"
  },
  {
    "codigo":289395002,
    "descripcion":"MANO FETAL PALPABLE POR VÍA VAGINAL"
  },
  {
    "codigo":1336136000,
    "descripcion":"ALTERACIÓN DE ARTICULACIÓN DE REGIÓN DE MUÑECA DERECHA"
  },
  {
    "codigo":189256001,
    "descripcion":"CARCINOMA IN SITU DE CARTÍLAGO CORNICULADO"
  },
  {
    "codigo":58184002,
    "descripcion":"ENFERMEDAD RECURRENTE"
  },
  {
    "codigo":25416002,
    "descripcion":"NEURALGIA DE NERVIO PERIFÉRICO"
  },
  {
    "codigo":387699008,
    "descripcion":"INERCIA UTERINA PRIMARIA"
  },
  {
    "codigo":123720003,
    "descripcion":"CITOPENIA LEVE"
  },
  {
    "codigo":254792006,
    "descripcion":"ANGIOENDOTELIOMATOSIS PROLIFERATIVA"
  },
  {
    "codigo":713544008,
    "descripcion":"NEUMONÍA BACTERIANA CONCOMITANTE CON INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":418632009,
    "descripcion":"TRASTORNO ENDOMETRIAL"
  },
  {
    "codigo":1137693003,
    "descripcion":"HERPES SIMPLE DE GENITALES MASCULINOS"
  },
  {
    "codigo":332251000119108,
    "descripcion":"ESCLEROPERIQUERATITIS DERECHA"
  },
  {
    "codigo":87282003,
    "descripcion":"PARASITISMO INTESTINAL"
  },
  {
    "codigo":447730004,
    "descripcion":"CORDOMA DE SACRO"
  },
  {
    "codigo":1332466004,
    "descripcion":"HIPERTENSIÓN EN ENFERMEDAD RENAL CRÓNICA EN ESTADIO 3A DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":54514007,
    "descripcion":"BRONCOFONÍA"
  },
  {
    "codigo":249287002,
    "descripcion":"DIURESIS INCOMPLETA"
  },
  {
    "codigo":118215003,
    "descripcion":"HALLAZGO RELACIONADO CON EL PARTO"
  },
  {
    "codigo":445895003,
    "descripcion":"ANATOMÍA BRONQUIAL NORMAL"
  },
  {
    "codigo":183751004,
    "descripcion":"CONSULTA DOMICILIARIA DIABETOLÓGICA, REALIZADA"
  },
  {
    "codigo":282055005,
    "descripcion":"SECCIÓN DE YEYUNO"
  },
  {
    "codigo":19911007,
    "descripcion":"PUBERTAD PRECOZ FEMENINA"
  },
  {
    "codigo":1363399004,
    "descripcion":"NEOVASCULARIZACIÓN DE CUADRANTE SUPERIOR DE ÁNGULO IRIDOCORNEAL DE OJO DERECHO"
  },
  {
    "codigo":216519004,
    "descripcion":"INTOXICACIÓN ACCIDENTAL CAUSADA POR TRANQUILIZANTE FENOTIAZÍNICO"
  },
  {
    "codigo":50844007,
    "descripcion":"INTENTO FALLIDO DE ABORTO CON PERITONITIS PÉLVICA"
  },
  {
    "codigo":1197724009,
    "descripcion":"ÚLCERA DUODENAL POR ALCOHOL"
  },
  {
    "codigo":1163121002,
    "descripcion":"COLITIS POR YERSINIA ENTEROCOLITICA"
  },
  {
    "codigo":688911000119101,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE MEMBRANA MUCOSA DE LABIO SUPERIOR"
  },
  {
    "codigo":442225006,
    "descripcion":"NO DETECTADO POR MEDICIÓN"
  },
  {
    "codigo":704369007,
    "descripcion":"FATIGA DEBIDA A TRATAMIENTO"
  },
  {
    "codigo":276550000,
    "descripcion":"ICTERICIA FISIOLÓGICA PROLONGADA DEL RECIÉN NACIDO"
  },
  {
    "codigo":407622005,
    "descripcion":"MUCHAS CONVULSIONES POR DÍA"
  },
  {
    "codigo":1259590008,
    "descripcion":"CARCINOMA DUCTAL INFILTRANTE PRIMARIO DE MAMA"
  },
  {
    "codigo":45339001,
    "descripcion":"NISTAGMO POR DEPRIVACIÓN VISUAL"
  },
  {
    "codigo":241947002,
    "descripcion":"ANAFILAXIS NO ALÉRGICA CAUSADA POR FÁRMACO"
  },
  {
    "codigo":443656000,
    "descripcion":"DISCAPACITADO POR ALTERACIÓN DEL DESARROLLO"
  },
  {
    "codigo":733467001,
    "descripcion":"ANETODERMIA HEREDITARIA"
  },
  {
    "codigo":897307002,
    "descripcion":"IRRITACIÓN RECTAL"
  },
  {
    "codigo":209179005,
    "descripcion":"SUBLUXACIÓN VERTEBRAL NO EXPUESTA CON LESIÓN MEDULAR ANTERIOR A NIVEL LUMBAR"
  },
  {
    "codigo":373019000,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM CHITAE"
  },
  {
    "codigo":240112000,
    "descripcion":"MIOSITIS POR PROTOZOOS"
  },
  {
    "codigo":646218511000119105,
    "descripcion":"NÓDULO DE DESGASTE DE AMBAS HÉLICES DE PABELLONES AURICULARES"
  },
  {
    "codigo":10736002,
    "descripcion":"DEFICIENCIA AISLADA DE TIROLIBERINA"
  },
  {
    "codigo":76272004,
    "descripcion":"SÍFILIS"
  },
  {
    "codigo":403952004,
    "descripcion":"TUMOR LINFOEPITELIAL DE PIEL"
  },
  {
    "codigo":15735721000119100,
    "descripcion":"DEGENERACIÓN DE CÓRNEA DE OJO IZQUIERDO"
  },
  {
    "codigo":305648004,
    "descripcion":"ATENDIDO POR UN PEDIATRA COMUNITARIO"
  },
  {
    "codigo":74437002,
    "descripcion":"SIGNO DE AHLFELD"
  },
  {
    "codigo":860869003,
    "descripcion":"ERITEMA MULTIFORME DEBIDO A INFECCIÓN POR HERPES SIMPLE"
  },
  {
    "codigo":1072041000119101,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE TENDÓN FLEXOR DE MUSLO"
  },
  {
    "codigo":16007951000119107,
    "descripcion":"OSTEOMIELITIS DE AMBOS RADIOS"
  },
  {
    "codigo":1286853005,
    "descripcion":"CIERRE DE ÁNGULO DEBIDO A SINEQUIA POSTERIOR"
  },
  {
    "codigo":301978000,
    "descripcion":"HALLAZGO RELACIONADO CON LA VISIÓN"
  },
  {
    "codigo":7066000,
    "descripcion":"LINFANGITIS INFECCIOSA"
  },
  {
    "codigo":269210000,
    "descripcion":"AMPOLLA TRAUMÁTICA DE PÁRPADOS Y REGIÓN PERIOCULAR"
  },
  {
    "codigo":8901009,
    "descripcion":"ARTERIOLITIS"
  },
  {
    "codigo":236442004,
    "descripcion":"QUISTE RENAL ADQUIRIDO SIN CAMBIO NEOPLÁSICO"
  },
  {
    "codigo":1186714005,
    "descripcion":"INMUNODEFICIENCIA COMBINADA POR DEFICIENCIA DE ITK"
  },
  {
    "codigo":201839001,
    "descripcion":"COXARTROSIS PRIMARIA, BILATERAL"
  },
  {
    "codigo":398447004,
    "descripcion":"SÍNDROME RESPIRATORIO AGUDO SEVERO"
  },
  {
    "codigo":1217647006,
    "descripcion":"UVEÍTIS ANTERIOR CRÓNICA IDIOPÁTICA"
  },
  {
    "codigo":365679008,
    "descripcion":"MATERIA FECAL: CONSTITUYENTES EXTRAÑOS - HALLAZGO"
  },
  {
    "codigo":298308001,
    "descripcion":"HALLAZGO DE ALTERNANCIA DEL EQUILIBRIO MIENTRAS CAMINA"
  },
  {
    "codigo":167236000,
    "descripcion":"ORINA DE ASPECTO LÍMPIDO"
  },
  {
    "codigo":234607008,
    "descripcion":"DEFICIENCIA DEL FACTOR D"
  },
  {
    "codigo":75443009,
    "descripcion":"ELIPTOCITOSIS HEREDITARIA POR PROTEÍNA 4, 1 ANORMAL"
  },
  {
    "codigo":300143009,
    "descripcion":"BOLSILLO DE RETRACCIÓN DE LA MEMBRANA TIMPÁNICA A LA ALTURA DEL ÁTICO"
  },
  {
    "codigo":11312041000119105,
    "descripcion":"FRACTURA EXPUESTA DE QUINTA VÉRTEBRA LUMBAR"
  },
  {
    "codigo":334761000119107,
    "descripcion":"GLAUCOMA DE ÁNGULO CERRADO INTERMITENTE DE OJO DERECHO"
  },
  {
    "codigo":722457005,
    "descripcion":"SÍNDROME DE CATARATA JUVENIL, MICROCÓRNEA Y GLUCOSURIA RENAL"
  },
  {
    "codigo":294638006,
    "descripcion":"ALERGIA A INMUNOGLOBULINA CONTRA EL TÉTANOS"
  },
  {
    "codigo":423875000,
    "descripcion":"CONOCIMIENTO DEFICIENTE DE LOS MÉTODOS DE PLANIFICACIÓN FAMILIAR"
  },
  {
    "codigo":1144771006,
    "descripcion":"INTOXICACIÓN POR QUINOLINA"
  },
  {
    "codigo":292803006,
    "descripcion":"REACCIÓN ADVERSA AL NITROFENOL"
  },
  {
    "codigo":127128000,
    "descripcion":"LINFADENOPATÍA PILÓRICA"
  },
  {
    "codigo":391107006,
    "descripcion":"MALA TÉCNICA DE NEBULIZACIÓN"
  },
  {
    "codigo":94360002,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE RIÑÓN"
  },
  {
    "codigo":1306776003,
    "descripcion":"NEFROBLASTOMATOSIS PERILOBULAR HIPERPLÁSICA DIFUSA"
  },
  {
    "codigo":16747741000119100,
    "descripcion":"RETINOPATÍA PROLIFERATIVA DE OJO IZQUIERDO DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":389272007,
    "descripcion":"OSTEOCONDROMATOSIS CARPOTARSIANA"
  },
  {
    "codigo":190829000,
    "descripcion":"NEFROPATÍA GOTOSA CRÓNICA"
  },
  {
    "codigo":290968007,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR FENITOÍNA"
  },
  {
    "codigo":11777091000119108,
    "descripcion":"LACERACIÓN DE TENDÓN DE MÚSCULO TRÍCEPS BRAQUIAL DERECHO"
  },
  {
    "codigo":418370000,
    "descripcion":"REACCIÓN ADVERSA AL ATENOLOL"
  },
  {
    "codigo":92525008,
    "descripcion":"CARCINOMA IN SITU DE ANEXOS EPIDÉRMICOS"
  },
  {
    "codigo":254530002,
    "descripcion":"NEOPLASIA MALIGNA DE ESPACIO PARAFARÍNGEO LATERAL"
  },
  {
    "codigo":188994000,
    "descripcion":"LIPOMA DE HOMBRO"
  },
  {
    "codigo":1335874004,
    "descripcion":"ICTERICIA NEONATAL PRECOZ DEBIDA A ANEMIA HEMOLÍTICA HEREDITARIA"
  },
  {
    "codigo":715117009,
    "descripcion":"SE TRANSFIERE DE LA SILLA AL INODORO"
  },
  {
    "codigo":711447007,
    "descripcion":"ELECTROCARDIOGRAMA CON RITMO DE MARCAPASOS Y REGISTRO ELÉCTRICO"
  },
  {
    "codigo":1268503008,
    "descripcion":"CARCINOMA PAPILAR DE CÉLULAS RENALES PRIMARIO"
  },
  {
    "codigo":709612002,
    "descripcion":"RETRACCIÓN DE LENGUA"
  },
  {
    "codigo":185324002,
    "descripcion":"ENCUENTRO FALLIDO"
  },
  {
    "codigo":15983991000119100,
    "descripcion":"MIOQUIMIA DE MÚSCULO OBLICUO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":871617000,
    "descripcion":"INSUFICIENCIA CARDÍACA CON BAJO GASTO CARDÍACO DEBIDA A OPERACIÓN DE FONTAN Y POSTERIOR A ELLA"
  },
  {
    "codigo":283628008,
    "descripcion":"HERIDA POR PINCHAZO DE AGUJA EN LOS GENITALES"
  },
  {
    "codigo":249025001,
    "descripcion":"ORIFICIO CERVICAL INTERNO, CERRADO"
  },
  {
    "codigo":337271000119101,
    "descripcion":"LAGOFTALMOS CICATRIZAL SUPERIOR IZQUIERDO"
  },
  {
    "codigo":1074551000119101,
    "descripcion":"ARTROSIS SECUNDARIA DE PIE IZQUIERDO"
  },
  {
    "codigo":1363137005,
    "descripcion":"ASTILLA EN VULVA"
  },
  {
    "codigo":314561006,
    "descripcion":"QUERATITIS ESTÉRIL"
  },
  {
    "codigo":609473007,
    "descripcion":"INTERRUPCIÓN INDUCIDA DEL EMBARAZO COMPLICADA POR PARAMETRITIS"
  },
  {
    "codigo":281793005,
    "descripcion":"CONFUSIÓN INTERMITENTE"
  },
  {
    "codigo":247190006,
    "descripcion":"LESIONES CORIORRETINIANAS SOBREELEVADAS MÚLTIPLES"
  },
  {
    "codigo":50582007,
    "descripcion":"HEMIPLEJÍA"
  },
  {
    "codigo":443798008,
    "descripcion":"INFLAMACIÓN DE ARTICULACIÓN DE REGIÓN DE HOMBRO"
  },
  {
    "codigo":771478008,
    "descripcion":"MIOCARDIOPATÍA HIPERTRÓFICA MITOCONDRIAL CON ACIDOSIS LÁCTICA POR DEFICIENCIA DE MTO1"
  },
  {
    "codigo":48747004,
    "descripcion":"DESPLAZAMIENTO LATERAL DEL GLOBO OCULAR"
  },
  {
    "codigo":1162859004,
    "descripcion":"GONADOBLASTOMA TESTICULAR"
  },
  {
    "codigo":441963008,
    "descripcion":"CUTIS LAXO DE PÁRPADO SUPERIOR"
  },
  {
    "codigo":14144000,
    "descripcion":"TRASTORNO DELIRANTE TIPO EROTOMANÍACO"
  },
  {
    "codigo":10960401000119100,
    "descripcion":"HERIDA ABIERTA DE ANTEBRAZO IZQUIERDO DEBIDA A MORDEDURA HUMANA"
  },
  {
    "codigo":11861521000119100,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚSCULO CRURAL POSTERIOR DE PIERNA IZQUIERDA"
  },
  {
    "codigo":11779601000119100,
    "descripcion":"HERIDA INFECTADA DE ANTEBRAZO IZQUIERDO DEBIDA A PICADURA DE INSECTO NO VENENOSO"
  },
  {
    "codigo":866112009,
    "descripcion":"LINFEDEMA DEBIDO A INFECCIÓN RECURRENTE"
  },
  {
    "codigo":1259328008,
    "descripcion":"CARCINOMA PRIMARIO DE COMISURA DE LABIO"
  },
  {
    "codigo":10331000132107,
    "descripcion":"COLON TORTUOSO"
  },
  {
    "codigo":307221007,
    "descripcion":"OCLUSIÓN VENOSA"
  },
  {
    "codigo":208917007,
    "descripcion":"DESGARRO MENISCAL AGUDO, INTERNO, EN ASA DE BALDE"
  },
  {
    "codigo":733205009,
    "descripcion":"HISTIOCITOSIS DE CÉLULAS DENDRÍTICAS DÉRMICA"
  },
  {
    "codigo":700437007,
    "descripcion":"ARTROPATÍA DE CHARCOT DE REGIÓN MEDIA DEL PIE"
  },
  {
    "codigo":1255658004,
    "descripcion":"CARCINOSARCOMA DE PULMÓN"
  },
  {
    "codigo":403690007,
    "descripcion":"HEMATOMA POSQUIRÚRGICO EXTENSO"
  },
  {
    "codigo":43242008,
    "descripcion":"CEFALEA POR SUSPENSIÓN DE MEDICACIÓN"
  },
  {
    "codigo":1157354009,
    "descripcion":"DEMUESTRA CONOCIMIENTO SOBRE TERAPIA FÍSICA"
  },
  {
    "codigo":762303003,
    "descripcion":"SÍNDROME DE SJÖGREN DE COMIENZO EN LA INFANCIA"
  },
  {
    "codigo":8639004,
    "descripcion":"GRANULOMA CUTÁNEO POR CIRCONIO"
  },
  {
    "codigo":400020001,
    "descripcion":"DERMATITIS POR HERPES ZÓSTER"
  },
  {
    "codigo":301716002,
    "descripcion":"DOLOR EN EL CUADRANTE INFEROIZQUIERDO"
  },
  {
    "codigo":432788009,
    "descripcion":"FALTA DE PROGRESO PEDIÁTRICO"
  },
  {
    "codigo":234345001,
    "descripcion":"ANEMIA DE VON JAKSCH"
  },
  {
    "codigo":201577001,
    "descripcion":"ARTRITIS REACTIVA DE ARTICULACIÓN INTERFALÁNGICA DE DEDO DEL PIE"
  },
  {
    "codigo":4969004,
    "descripcion":"CEFALEA SINUSAL"
  },
  {
    "codigo":299881005,
    "descripcion":"REFLEJO AQUÍLEO RETARDADO"
  },
  {
    "codigo":70505006,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DE ANTEBRAZO"
  },
  {
    "codigo":1184617007,
    "descripcion":"AMBIENTE FRÍO"
  },
  {
    "codigo":203412009,
    "descripcion":"OSTEOCONDRITIS DISECANTE DE CABEZA DE FÉMUR"
  },
  {
    "codigo":365417009,
    "descripcion":"HALLAZGO ELECTROCARDIOGRÁFICO RELACIONADO CON EL INTERVALO QT"
  },
  {
    "codigo":199742002,
    "descripcion":"DISPOSITIVO INTRAUTERINO RETENIDO DURANTE EL EMBARAZO"
  },
  {
    "codigo":103273009,
    "descripcion":"AUSENCIA DE REFLEJO PUPILAR A LA LUZ DIRECTA"
  },
  {
    "codigo":166974006,
    "descripcion":"NIVEL TERAPÉUTICO DE ANTICONVULSIVO"
  },
  {
    "codigo":68670009,
    "descripcion":"DERMATITIS POR CONTACTO DE PÁRPADO"
  },
  {
    "codigo":197907002,
    "descripcion":"ÚLCERA DE MEATO URETRAL"
  },
  {
    "codigo":42451000087101,
    "descripcion":"ABRASIÓN DE TRÁQUEA"
  },
  {
    "codigo":39891000087102,
    "descripcion":"HEMATOMA DE REGIÓN DE OJO IZQUIERDO"
  },
  {
    "codigo":230675008,
    "descripcion":"SÍNDROME DEL CANAL LENTO"
  },
  {
    "codigo":47571000087105,
    "descripcion":"FRACTURA DE ACETÁBULO DERECHO"
  },
  {
    "codigo":296211009,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE PERICIAZINA"
  },
  {
    "codigo":32232003,
    "descripcion":"ESPINA BÍFIDA DE LA REGIÓN CERVICAL"
  },
  {
    "codigo":425448004,
    "descripcion":"ESTENOSIS DE ARTERIA BRAQUIOCEFÁLICA"
  },
  {
    "codigo":34771000087109,
    "descripcion":"MÚLTIPLES LESIONES NASALES INTERNAS TRAUMÁTICAS"
  },
  {
    "codigo":294376009,
    "descripcion":"ALERGIA A INTERFERÓN GAMMA-1B"
  },
  {
    "codigo":194237006,
    "descripcion":"OTITIS MEDIA NO SUPURATIVA CON TRASTORNO DE TROMPA DE EUSTAQUIO"
  },
  {
    "codigo":292541007,
    "descripcion":"REACCIÓN ADVERSA AL METIXENO"
  },
  {
    "codigo":95933007,
    "descripcion":"ANCIANO DESATENDIDO"
  },
  {
    "codigo":339781000119102,
    "descripcion":"ORZUELO EXTERNO DE PÁRPADO INFERIOR DE OJO IZQUIERDO"
  },
  {
    "codigo":216851008,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR MONÓXIDO DE CARBONO DE VAPOR DE HORNO"
  },
  {
    "codigo":94098005,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA GLÁNDULA TIROIDES"
  },
  {
    "codigo":1306514007,
    "descripcion":"NEOPLASIA MALIGNA RECURRENTE PRIMARIA DE MAMA IZQUIERDA"
  },
  {
    "codigo":126866008,
    "descripcion":"NEOPLASIA DEL PERITONEO PARIETAL"
  },
  {
    "codigo":92263001,
    "descripcion":"NEOPLASIA BENIGNA DE AMÍGDALA"
  },
  {
    "codigo":1077061000119104,
    "descripcion":"QUISTE ÓSEO DE MANO DERECHA"
  },
  {
    "codigo":288871004,
    "descripcion":"CAPAZ DE LLEVAR LÍQUIDOS A LA BOCA"
  },
  {
    "codigo":59495006,
    "descripcion":"CONFIGURACIÓN DEL SOPLO CARDÍACO"
  },
  {
    "codigo":287036001,
    "descripcion":"RUPTURA DE MEMBRANA SINOVIAL DE CODO"
  },
  {
    "codigo":90428001,
    "descripcion":"PERICARDITIS GONOCÓCICA"
  },
  {
    "codigo":254268004,
    "descripcion":"TRISOMÍA PARCIAL DEL CROMOSOMA 13 EN EL SÍNDROME DE PATAU"
  },
  {
    "codigo":188732008,
    "descripcion":"LEUCEMIA MIELOIDE"
  },
  {
    "codigo":416273007,
    "descripcion":"DELLEN DE LA ESCLERÓTICA"
  },
  {
    "codigo":843433951000119102,
    "descripcion":"TROMBOSIS VENOSA PROFUNDA AGUDA DE VENA PERONEA DERECHA"
  },
  {
    "codigo":86758001,
    "descripcion":"INTOXICACIÓN POR MERCURIALIS"
  },
  {
    "codigo":283366003,
    "descripcion":"LACERACIÓN DEL MIEMBRO SUPERIOR"
  },
  {
    "codigo":414438005,
    "descripcion":"OBESIDAD HIPERPLÁSICA"
  },
  {
    "codigo":840422007,
    "descripcion":"DISECCIÓN DE ARTERIA CEREBRAL ANTERIOR"
  },
  {
    "codigo":609211000,
    "descripcion":"ABSCESO DE SENO PREAURICULAR"
  },
  {
    "codigo":248763005,
    "descripcion":"NO PUEDE EXCITARSE SEXUALMENTE"
  },
  {
    "codigo":19387007,
    "descripcion":"PÁNCREAS ECTÓPICO"
  },
  {
    "codigo":50320000,
    "descripcion":"INTOXICACIÓN POR ALUCINÓGENOS"
  },
  {
    "codigo":246928001,
    "descripcion":"MELANOSIS CORNEAL"
  },
  {
    "codigo":281531008,
    "descripcion":"FRACTURA DE MALÉOLO INTERNO"
  },
  {
    "codigo":17552000,
    "descripcion":"CÁLCULO DENTAL"
  },
  {
    "codigo":1297339008,
    "descripcion":"CIERRE DE ÁNGULO DE OJO DERECHO DEBIDO A MALFORMACIÓN CONGÉNITA DE ÁNGULO DE CÁMARA ANTERIOR DE OJO DERECHO"
  },
  {
    "codigo":445371009,
    "descripcion":"UBICACIÓN INFRACARDÍACA DE CONEXIONES VENOSAS PULMONARES ANÓMALAS EN VENA CAVA INFERIOR"
  },
  {
    "codigo":48485000,
    "descripcion":"ABORTO ESPONTÁNEO EN EL TERCER TRIMESTRE"
  },
  {
    "codigo":212325004,
    "descripcion":"LESIÓN CERRADA DE NERVIO SENSITIVO CUTÁNEO DE MIEMBRO INFERIOR"
  },
  {
    "codigo":703845008,
    "descripcion":"DEPENDENCIA DE BUPRENORFINA"
  },
  {
    "codigo":1162597008,
    "descripcion":"DIENTE EN CLAVIJA"
  },
  {
    "codigo":1259066002,
    "descripcion":"TRASTORNO DE SISTEMA NERVIOSO AUTÓNOMO DEBIDO A DEMENCIA SENIL TIPO CUERPOS DE LEWY"
  },
  {
    "codigo":306959001,
    "descripcion":"MOVIMIENTO PARADÓJICO DE LA CUERDA VOCAL DURANTE LA RESPIRACIÓN"
  },
  {
    "codigo":16097401000119104,
    "descripcion":"ARTROFIBROSIS DE AMBAS CADERAS"
  },
  {
    "codigo":110351007,
    "descripcion":"LIMITACIÓN PSIQUIÁTRICA DEL COMPORTAMIENTO"
  },
  {
    "codigo":10212000,
    "descripcion":"SIGNO DE KOCHER"
  },
  {
    "codigo":896783009,
    "descripcion":"FORMA ANCHA ANORMAL CONGÉNITA DE FALANGE PROXIMAL DE PIE"
  },
  {
    "codigo":403428002,
    "descripcion":"SEUDOQUISTE DE OREJA"
  },
  {
    "codigo":274191008,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE HOMBRO"
  },
  {
    "codigo":44815009,
    "descripcion":"ESTADIO DE BRESLOW, PROFUNDIDAD MAYOR DE 1,75 MM"
  },
  {
    "codigo":12247161000119106,
    "descripcion":"OSTEONECROSIS DE CÓNDILO FEMORAL EXTERNO IZQUIERDO"
  },
  {
    "codigo":11837561000119105,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE PIERNA IZQUIERDA CON INFECCIÓN"
  },
  {
    "codigo":204985001,
    "descripcion":"HIPERPLASIA RENAL"
  },
  {
    "codigo":237753002,
    "descripcion":"HIPERPLASIA SUPRARRENAL CONGÉNITA PERDEDORA DE SAL"
  },
  {
    "codigo":270521004,
    "descripcion":"TRISOMÍA Y TRISOMÍA PARCIAL DE AUTOSOMA"
  },
  {
    "codigo":303289005,
    "descripcion":"EQUIMOSIS DE MUCOSA YUGAL"
  },
  {
    "codigo":235918000,
    "descripcion":"OBSTRUCCIÓN DE LA VÍA BILIAR"
  },
  {
    "codigo":342291000119102,
    "descripcion":"CATARATA INFANTIL Y\/O JUVENIL"
  },
  {
    "codigo":1153422000,
    "descripcion":"CONDROSARCOMA DE MANDÍBULA"
  },
  {
    "codigo":397923000,
    "descripcion":"TRASTORNO DE SOMATIZACIÓN"
  },
  {
    "codigo":37475001,
    "descripcion":"SINESTESIALGIA"
  },
  {
    "codigo":201315001,
    "descripcion":"CALCIFICACIÓN POSFLEBÍTICA SUBCUTÁNEA"
  },
  {
    "codigo":432526008,
    "descripcion":"ESTATURA BAJA FAMILIAR"
  },
  {
    "codigo":299619000,
    "descripcion":"AMPLITUD DE ADUCCIÓN ACTIVA DE DEDO DE PIE AUMENTADA"
  },
  {
    "codigo":365155007,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA ABIR Y CERRAR CANILLAS"
  },
  {
    "codigo":168547009,
    "descripcion":"RADIOGRAFÍA SIMPLE DE ARTICULACIÓN TEMPOROMANDIBULAR NORMAL"
  },
  {
    "codigo":103011009,
    "descripcion":"CEFALEA PRIMARIA POR ESFUERZO"
  },
  {
    "codigo":430691009,
    "descripcion":"HIPERTERMIA NEUROGÉNICA"
  },
  {
    "codigo":234083009,
    "descripcion":"PUNCIÓN VENOSA"
  },
  {
    "codigo":164877000,
    "descripcion":"HIPERTROFIA DE VENTRÍCULO DERECHO EN EL ELECTROCARDIOGRAMA"
  },
  {
    "codigo":166712009,
    "descripcion":"UREA EN SANGRE FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":35640008,
    "descripcion":"ENCEFALITIS ADENOVIRAL AGUDA"
  },
  {
    "codigo":461624009,
    "descripcion":"OBSTRUCCIÓN ADQUIRIDA DE LUZ DE CAYADO AÓRTICO ENTRE ARTERIA CARÓTIDA PRIMITIVA IZQUIERDA Y ARTERIA CARÓTIDA PRIMITIVA DERECHA"
  },
  {
    "codigo":230413002,
    "descripcion":"EPILEPSIA DE AUSENCIA JUVENIL"
  },
  {
    "codigo":540971000124109,
    "descripcion":"MASA DE LÓBULO INFERIOR DERECHO DE PULMÓN"
  },
  {
    "codigo":295949007,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE MIANSERINA"
  },
  {
    "codigo":425186004,
    "descripcion":"TONO MUSCULAR DISMINUIDO - LADO IZQUIERDO MÁS ACENTUADO QUE EL DERECHO"
  },
  {
    "codigo":1079571000119109,
    "descripcion":"CONDROSARCOMA PRIMARIO DE HUESO DE MANO IZQUIERDA"
  },
  {
    "codigo":294114008,
    "descripcion":"ALERGIA A LORATADINA"
  },
  {
    "codigo":95671001,
    "descripcion":"COMPRESIÓN DE LA RAÍZ NERVIOSA CERVICAL"
  },
  {
    "codigo":195810009,
    "descripcion":"LARINGITIS Y LARINGOTRAQUEÍTIS CRÓNICAS"
  },
  {
    "codigo":1177015003,
    "descripcion":"ARTERITIS CEREBRAL TUBERCULOSA"
  },
  {
    "codigo":292279003,
    "descripcion":"REACCIÓN ADVERSA A UN ANTIDEPRESIVO TRICÍCLICO"
  },
  {
    "codigo":93836001,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA CARA INTERNA DE LABIO INFERIOR"
  },
  {
    "codigo":1339020003,
    "descripcion":"TRASTORNO DE NERVIO CRANEAL CAUSADO POR RADIACIÓN IONIZANTE"
  },
  {
    "codigo":716428005,
    "descripcion":"CAPAZ DE MOVERSE EN LA CUNA"
  },
  {
    "codigo":126604006,
    "descripcion":"NEOPLASIA DE PARTES BLANDAS DE HOMBRO"
  },
  {
    "codigo":59233003,
    "descripcion":"SÍFILIS SECUNDARIA DE LA PIEL"
  },
  {
    "codigo":92001006,
    "descripcion":"NEOPLASIA BENIGNA DE VASO SANGUÍNEO DE LA MANO"
  },
  {
    "codigo":1237046005,
    "descripcion":"METÁSTASIS DE CARCINOMA DE DUODENO"
  },
  {
    "codigo":254006008,
    "descripcion":"FISURA MEDIOFACIAL DE TESSIER 30"
  },
  {
    "codigo":286774009,
    "descripcion":"RASGO DE LA PERSONALIDAD: FIRMEZA - HALLAZGO"
  },
  {
    "codigo":88331000,
    "descripcion":"REACCIÓN AUTOINMUNITARIA MEDIADA POR CÉLULAS T"
  },
  {
    "codigo":24630008,
    "descripcion":"MENINGOENCEFALITIS POR LISTERIA"
  },
  {
    "codigo":219403007,
    "descripcion":"HERIDA DE GUERRA POR EXPLOSIÓN DE CASCO DE PROYECTIL"
  },
  {
    "codigo":11840071000119105,
    "descripcion":"HEMATOMA DE REGIÓN AURICULAR DERECHA"
  },
  {
    "codigo":1004000003,
    "descripcion":"SERRATIA MARCESCENS O SERRATIA UREILYTICA"
  },
  {
    "codigo":283104005,
    "descripcion":"ARAÑAZO DE TOBILLO"
  },
  {
    "codigo":20960007,
    "descripcion":"TRASTORNO BIPOLAR II GRAVE, EPISODIO MÁS RECIENTE DE CARACTERÍSTICAS DEPRESIVAS PROFUNDAS CON SÍNTOMAS PSICÓTICOS, INCONGRUENTE CON EL ESTADO DE ÁNIMO"
  },
  {
    "codigo":281269004,
    "descripcion":"ESPÉCIMEN CON ALTO RIESGO DE INFECCIÓN"
  },
  {
    "codigo":445109004,
    "descripcion":"ARTERIA CARÓTIDA PRIMITIVA IZQUIERDA AISLADA"
  },
  {
    "codigo":707253006,
    "descripcion":"ÚLCERA DE CAVIDAD BUCAL DEBIDA A ENFERMEDAD INMUNOAMPOLLAR"
  },
  {
    "codigo":248501007,
    "descripcion":"EDEMA DE LA ESTRUCTURA INTERNA DEL OJO"
  },
  {
    "codigo":125511000119108,
    "descripcion":"SÍNDROME DE TRISOMÍA COMPLETA DE CROMOSOMA 18 FETAL"
  },
  {
    "codigo":115594000,
    "descripcion":"CRISTAL URINARIO, URATO AMORFO"
  },
  {
    "codigo":838325009,
    "descripcion":"TRASTORNO DEL DESARROLLO SEXUAL 46 XY DEBIDO A INGESTIÓN MATERNA DE ESTRÓGENO"
  },
  {
    "codigo":1295242003,
    "descripcion":"TUMOR TENOSINOVIAL DE CÉLULAS GIGANTES MALIGNO"
  },
  {
    "codigo":246666001,
    "descripcion":"HEMIANOPSIA HOMÓNIMA POR FALTA DE ATENCIÓN"
  },
  {
    "codigo":15663841000119103,
    "descripcion":"HEMARTROSIS DE AMBAS RODILLAS"
  },
  {
    "codigo":410506005,
    "descripcion":"RESTRICCIÓN MÚSCULO RECTO INFERIOR"
  },
  {
    "codigo":344801000119103,
    "descripcion":"GRANULOMA DE AMBAS ÓRBITAS"
  },
  {
    "codigo":1162335002,
    "descripcion":"CONDRÓLISIS DEBIDA A LESIÓN TRAUMÁTICA Y POSTERIOR A ELLA"
  },
  {
    "codigo":408671002,
    "descripcion":"POLINEUROPATÍA EN LA ENFERMEDAD MALIGNA DEL COLÁGENO"
  },
  {
    "codigo":310367004,
    "descripcion":"EXAMEN DEL NIÑO\/INFORMES\/ESTADO DE ENCUENTROS"
  },
  {
    "codigo":79156004,
    "descripcion":"INTOXICACIÓN POR PANCREATINA"
  },
  {
    "codigo":308532005,
    "descripcion":"SITUACIÓN DE LA VACUNACIÓN ANTIGRIPAL"
  },
  {
    "codigo":208393000,
    "descripcion":"FRACTURA DE HUESO METACARPIANO"
  },
  {
    "codigo":44553005,
    "descripcion":"SÍNDROME DE DUBIN-JOHNSON"
  },
  {
    "codigo":110089009,
    "descripcion":"LACERACIÓN SIMPLE DEL PISO DE LA BOCA"
  },
  {
    "codigo":304862002,
    "descripcion":"RELACIÓN BASADA EN UNA ACTITUD DEPRESIVA"
  },
  {
    "codigo":42718004,
    "descripcion":"BORRAMIENTO CERVICAL, 90%"
  },
  {
    "codigo":403166005,
    "descripcion":"LESIÓN TRAUMÁTICA DE PIEL POR ANIMAL"
  },
  {
    "codigo":9950006,
    "descripcion":"FALLA DE INJERTO DEBIDA A ISQUEMIA PROLONGADA"
  },
  {
    "codigo":204723001,
    "descripcion":"ESTENOSIS CONGÉNITA DE ANO"
  },
  {
    "codigo":73651003,
    "descripcion":"HERNIA DIAFRAGMÁTICA CON GANGRENA Y OBSTRUCCIÓN"
  },
  {
    "codigo":316781000119100,
    "descripcion":"DOLOR DE ARTICULACIÓN DE CADERA IZQUIERDA"
  },
  {
    "codigo":1077101000119101,
    "descripcion":"QUISTE ÓSEO DEL PERONÉ DERECHO"
  },
  {
    "codigo":301421000119102,
    "descripcion":"ABSCESO DE BOLSA SEROSA DE MANO IZQUIERDA"
  },
  {
    "codigo":16908141000119103,
    "descripcion":"NEVO EPIDÉRMICO DE PÁRPADO SUPERIOR DERECHO"
  },
  {
    "codigo":306541000119104,
    "descripcion":"GOTA CRÓNICA DE HOMBRO, SIN TOFO, CAUSADA POR FÁRMACO"
  },
  {
    "codigo":15971181000119105,
    "descripcion":"HERNIA CRURAL DERECHA"
  },
  {
    "codigo":334701000119106,
    "descripcion":"QUERATITIS INTERSTICIAL DE OJO DERECHO"
  },
  {
    "codigo":339821000119107,
    "descripcion":"DERMATOCALASIA DE PÁRPADO INFERIOR IZQUIERDO"
  },
  {
    "codigo":1082221000119106,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE PIEL DE MIEMBRO INFERIOR DERECHO"
  },
  {
    "codigo":11857261000119109,
    "descripcion":"HEMATOMA DE PIE DERECHO"
  },
  {
    "codigo":170120006,
    "descripcion":"EXAMEN DEL NIÑO A LAS SEIS SEMANAS: ANORMAL - DERIVADO"
  },
  {
    "codigo":321901000119109,
    "descripcion":"RIGIDEZ DE ARTICULACIÓN DEL PIE IZQUIERDO"
  },
  {
    "codigo":16442221000119107,
    "descripcion":"DOLOR PERIORBITARIO BILATERAL"
  },
  {
    "codigo":22381000119105,
    "descripcion":"DEMENCIA DEGENERATIVA PRIMARIA"
  },
  {
    "codigo":233821000,
    "descripcion":"ANGINA DE PECHO, NUEVO INICIO"
  },
  {
    "codigo":202888004,
    "descripcion":"SÍNDROME DE ESTRÉS TIBIAL ANTERIOR"
  },
  {
    "codigo":15930221000119109,
    "descripcion":"EDEMA DE ESTROMA DE CÓRNEA IZQUIERDA"
  },
  {
    "codigo":266589005,
    "descripcion":"ENDOMETRIOSIS DE OVARIO"
  },
  {
    "codigo":69981004,
    "descripcion":"ESFEROCITOSIS HEREDITARIA POR DEFECTO DE ESPECTRINA BETA"
  },
  {
    "codigo":364893007,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA MOVER UN MIEMBRO"
  },
  {
    "codigo":231986000,
    "descripcion":"NECROSIS RETINIANA AGUDA"
  },
  {
    "codigo":4445009,
    "descripcion":"TUBERCULOSIS DEL APARATO GENITOURINARIO"
  },
  {
    "codigo":299357005,
    "descripcion":"AMPLITUD DE ROTACIÓN INTERNA PASIVA DE LA RODILLA NORMAL"
  },
  {
    "codigo":1149490004,
    "descripcion":"BACTERIEMIA CAUSADA POR CHROMOBACTERIUM"
  },
  {
    "codigo":291861000119103,
    "descripcion":"TRASTORNO DE NERVIO PERIFÉRICO DE MIEMBRO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":363058009,
    "descripcion":"TRASTORNO DEGENERATIVO DE MÚSCULO"
  },
  {
    "codigo":721671006,
    "descripcion":"CARCINOMA NEUROENDOCRINO PRIMARIO DE INTESTINO DELGADO"
  },
  {
    "codigo":262919008,
    "descripcion":"LACERACIÓN DE CONDUCTO DEFERENTE"
  },
  {
    "codigo":228316000,
    "descripcion":"BORRACHERA QUE EXCEDE CANTIDADES RAZONABLES"
  },
  {
    "codigo":347311000119100,
    "descripcion":"UVEÍTIS ANTERIOR AGUDA DE AMBOS OJOS"
  },
  {
    "codigo":424924007,
    "descripcion":"HALLAZGO RELACIONADO CON LOS RECURSOS COMUNITARIOS"
  },
  {
    "codigo":457692008,
    "descripcion":"RUPTURA DE ANILLO DE VÁLVULA AÓRTICA"
  },
  {
    "codigo":719836007,
    "descripcion":"ARTROGRIPOSIS MÚLTIPLE DISTAL CONGÉNITA LIGADA AL CROMOSOMA X"
  },
  {
    "codigo":717875005,
    "descripcion":"DUODENITIS INFECCIOSA"
  },
  {
    "codigo":93574001,
    "descripcion":"OSIFICACIÓN INCOMPLETA DEL CENTRO DE LA VÉRTEBRA LUMBAR"
  },
  {
    "codigo":716166002,
    "descripcion":"SÍNDROME DE MICROCÓRNEA CON GLAUCOMA Y AUSENCIA DE SENO FRONTAL"
  },
  {
    "codigo":880006003,
    "descripcion":"ANOMALÍA ADQUIRIDA DE AURÍCULA DERECHA"
  },
  {
    "codigo":101551000119103,
    "descripcion":"MASA DE PIEL DE DORSO"
  },
  {
    "codigo":290182008,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR HEROÍNA"
  },
  {
    "codigo":288347001,
    "descripcion":"DIFICULTAD PARA TRANSPORTAR UN OBJETO"
  },
  {
    "codigo":124507006,
    "descripcion":"DEFICIENCIA DE GLUTAMINASA"
  },
  {
    "codigo":712496000,
    "descripcion":"SÍNDROME DEL CUBOIDES"
  },
  {
    "codigo":26203008,
    "descripcion":"TRASTORNO BIPOLAR I DEPRESIVO GRAVE CON SÍNTOMAS PSICÓTICOS, INCONGRUENTE CON EL ESTADO DE ÁNIMO"
  },
  {
    "codigo":188208002,
    "descripcion":"NEOPLASIA MALIGNA DE CONDUCTO DE GARTNER"
  },
  {
    "codigo":286512003,
    "descripcion":"DIFICULTAD PARA SEGUIR LAS INSTRUCCIONES DE UNA RECETA"
  },
  {
    "codigo":15639881000119100,
    "descripcion":"CALAMBRE DE MÚSCULO DE AMBAS EXTREMIDADES SUPERIORES"
  },
  {
    "codigo":384816008,
    "descripcion":"INVASIÓN TUMORAL DE PLEURA VISCERAL AUSENTE"
  },
  {
    "codigo":448517004,
    "descripcion":"ANILLO VASCULAR CON CAYADO AÓRTICO IZQUIERDO Y AORTA DESCENDENTE DERECHA RETROESOFÁGICA Y CONDUCTO ARTERIAL DERECHO ORIGINADO EN DIVERTÍCULO AÓRTICO Y ARTERIA SUBCLAVIA DERECHA ABERRANTE"
  },
  {
    "codigo":415749005,
    "descripcion":"RUPTURA TRAUMÁTICA DE TENDÓN"
  },
  {
    "codigo":446682003,
    "descripcion":"TRASTORNO NEUROPSIQUIÁTRICO PEDIÁTRICO AUTOINMUNITARIO ASOCIADO CON INFECCIÓN ESTREPTOCÓCICA"
  },
  {
    "codigo":86234004,
    "descripcion":"CARDIOPATÍA Y NEFROPATÍA HIPERTENSIVAS"
  },
  {
    "codigo":1003738003,
    "descripcion":"CONTRACTURA EN FLEXIÓN DE ARTICULACIÓN INTERFALÁNGICA DISTAL DE DEDO MEDIO DE MANO"
  },
  {
    "codigo":53466008,
    "descripcion":"LUXACIONES TRAUMÁTICAS EXPUESTAS MÚLTIPLES DE ARTICULACIONES DE MANO"
  },
  {
    "codigo":1264047001,
    "descripcion":"TRASTORNO FETAL CAUSADO POR TRANSFERENCIA PLACENTARIA DE SUSTANCIA"
  },
  {
    "codigo":282842008,
    "descripcion":"CAPAZ DE MOVERSE DENTRO DE UNA POSICIÓN"
  },
  {
    "codigo":84399007,
    "descripcion":"CANALICULITIS LAGRIMAL AGUDA"
  },
  {
    "codigo":1231279007,
    "descripcion":"ENDOFTALMITIS ENDÓGENA CAUSADA POR FUNGI"
  },
  {
    "codigo":17028003,
    "descripcion":"OSTEOMIELITIS DEL ANTEBRAZO"
  },
  {
    "codigo":15193003,
    "descripcion":"DEPRESIÓN MAYOR RECURRENTE GRAVE CON SÍNTOMAS PSICÓTICOS, INCONGRUENTE CON EL ESTADO DE ÁNIMO"
  },
  {
    "codigo":1260377005,
    "descripcion":"EPILEPSIA DEBIDA A ANOMALÍA CEREBRAL CONGÉNITA"
  },
  {
    "codigo":1293145005,
    "descripcion":"ANGIOLIPOMA CELULAR"
  },
  {
    "codigo":320841000119108,
    "descripcion":"QUISTE ÓSEO SOLITARIO DE REGIÓN DE ARTICULACIÓN DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":10862051000119102,
    "descripcion":"HERIDA PUNZANTE DE PIE IZQUIERDO"
  },
  {
    "codigo":373806003,
    "descripcion":"GRADO 3 DE LA ESCALA DEL ESTADO FUNCIONAL DE LA ORGANIZACIÓN MUNDIAL DE LA SALUD"
  },
  {
    "codigo":46126003,
    "descripcion":"RUPTURA ARTERIAL"
  },
  {
    "codigo":406574007,
    "descripcion":"INFECCIÓN CAUSADA POR ENTEROCOCOS"
  },
  {
    "codigo":78894008,
    "descripcion":"HURGAR LOS OJOS"
  },
  {
    "codigo":371971003,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL CUERPO UTERINO"
  },
  {
    "codigo":765187004,
    "descripcion":"SÍNDROME DE LA PIEL RÍGIDA"
  },
  {
    "codigo":699651005,
    "descripcion":"INCLINACIÓN DISTAL DE DIENTE"
  },
  {
    "codigo":109827007,
    "descripcion":"CARCINOMA IN SITU DE CONDUCTO DE GLÁNDULA SALIVAL"
  },
  {
    "codigo":208131008,
    "descripcion":"FRACTURA EXPUESTA DE CARTÍLAGO TIROIDES"
  },
  {
    "codigo":271832001,
    "descripcion":"DOLOR POR FLATULENCIAS, ERUCTOS Y METEORISMO"
  },
  {
    "codigo":402904001,
    "descripcion":"VERRUGA VIRAL EN DEDO DE LA MANO"
  },
  {
    "codigo":1254872003,
    "descripcion":"LESIÓN PIGMENTADA DE PIEL DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":206296004,
    "descripcion":"ASPIRACIÓN DE LECHE Y ALIMENTO REGURGITADO EN EL RECIÉN NACIDO"
  },
  {
    "codigo":763352005,
    "descripcion":"DISCINESIA FAMILIAR Y MIOQUIMIA FACIAL"
  },
  {
    "codigo":239064000,
    "descripcion":"ERITEMA QUERATOLÍTICO INVERNAL"
  },
  {
    "codigo":106157000,
    "descripcion":"HALLAZGO EN EL SÉPTIMO PAR CRANEAL"
  },
  {
    "codigo":204461004,
    "descripcion":"FÍSTULA ENTRE LA VENA PORTA Y LA ARTERIA HEPÁTICA"
  },
  {
    "codigo":1351341006,
    "descripcion":"INMUNODEFICIENCIA COMBINADA AUTOSÓMICA RECESIVA DEBIDA A DEFICIENCIA DE COMPONENTE 10 DEL COMPLEJO DE MANTENIMIENTO DE MINICROMOSOMAS"
  },
  {
    "codigo":725079003,
    "descripcion":"TRASTORNO CONGÉNITO DE LA GLUCOSILACIÓN TIPO 1J"
  },
  {
    "codigo":4183003,
    "descripcion":"ENFERMEDAD DE CHARCOT - MARIE - TOOTH, TIPO IC"
  },
  {
    "codigo":168023006,
    "descripcion":"LÍQUIDO ASCÍTICO: ERITROCITOS"
  },
  {
    "codigo":461100000,
    "descripcion":"ANOMALÍA CARDIOVASCULAR DEBIDA A ORIGEN ANÓMALO DE CONDUCTO ARTERIOSO"
  },
  {
    "codigo":299095009,
    "descripcion":"SIN AMPLITUD PASIVA DE ABDUCCIÓN DE DEDO DE LA MANO"
  },
  {
    "codigo":1149228000,
    "descripcion":"INTOXICACIÓN ACCIDENTAL CAUSADA POR ÁCIDO FLUOROACÉTICO"
  },
  {
    "codigo":721409001,
    "descripcion":"LESIÓN TRAUMÁTICA DE TRONCO DE PLEXO BRAQUIAL"
  },
  {
    "codigo":295425004,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE METOCLOPRAMIDA"
  },
  {
    "codigo":262657005,
    "descripcion":"LESIÓN PENETRANTE DE PALADAR"
  },
  {
    "codigo":129750001,
    "descripcion":"CALCIFICACIÓN DISTRÓFICA"
  },
  {
    "codigo":31446002,
    "descripcion":"TRASTORNO BIPOLAR I, EPISODIO MÁS RECIENTE HIPOMANÍACO"
  },
  {
    "codigo":293590004,
    "descripcion":"ALERGIA A ANÁLOGO DE METADONA"
  },
  {
    "codigo":1087101000119109,
    "descripcion":"HEPATITIS CAUSADA POR VIRUS HERPES SIMPLE HUMANO"
  },
  {
    "codigo":719574007,
    "descripcion":"SÍNDROME DE MICRODELECIÓN 14Q12"
  },
  {
    "codigo":16051991000119104,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE TENDÓN DE MÚSCULO PLANTAR DE EXTREMIDAD INFERIOR DERECHA"
  },
  {
    "codigo":226219004,
    "descripcion":"DIETA DE PRUEBA"
  },
  {
    "codigo":95147007,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE HUESO TRAPEZOIDE"
  },
  {
    "codigo":160683008,
    "descripcion":"NECESITA AYUDA PARA LA DEAMBULACIÓN EN EL HOGAR"
  },
  {
    "codigo":781440000,
    "descripcion":"DISTENSIÓN DE TENDÓN DEL MÚSCULO PLANTAR"
  },
  {
    "codigo":224384002,
    "descripcion":"REGISTRADO EN CENTRO DE EMPLEOS"
  },
  {
    "codigo":289920005,
    "descripcion":"DEGLUTE RÁPIDAMENTE"
  },
  {
    "codigo":191616006,
    "descripcion":"DEPRESIÓN RECURRENTE"
  },
  {
    "codigo":715904005,
    "descripcion":"TUMOR DE PARÉNQUIMA DE GLÁNDULA PINEAL CON DIFERENCIACIÓN INTERMEDIA"
  },
  {
    "codigo":93312006,
    "descripcion":"POSICIÓN ANÓMALA CONGÉNITA DE LA ARTERIA CARÓTIDA"
  },
  {
    "codigo":27776006,
    "descripcion":"INFECCIÓN CAUSADA POR NOSEMA CONNORI"
  },
  {
    "codigo":1303893003,
    "descripcion":"GLAUCOMA DE ÁNGULO ABIERTO DE OJO IZQUIERDO DEBIDO A DESPRENDIMIENTO DE RETINA"
  },
  {
    "codigo":124245006,
    "descripcion":"DEFICIENCIA DE FOSFORRIBOSILAMINOIMIDAZOLCARBOXAMIDA FORMILTRANSFERASA"
  },
  {
    "codigo":187946002,
    "descripcion":"NEOPLASIA MALIGNA DEL SEGUNDO METACARPIANO"
  },
  {
    "codigo":286250005,
    "descripcion":"UTILIZA TONOS VOCALES Y UNIDADES FONÉTICAS"
  },
  {
    "codigo":253482007,
    "descripcion":"HIPOPLASIA CONGÉNITA DE MÚSCULO PAPILAR DE VÁLVULA AURICULOVENTRICULAR DERECHA"
  },
  {
    "codigo":284415002,
    "descripcion":"MANTIENE EL EQUILIBRIO AL ESTIRARSE"
  },
  {
    "codigo":87807004,
    "descripcion":"HIPOPIÓN"
  },
  {
    "codigo":22271007,
    "descripcion":"LATIDO CARDÍACO FETAL ANORMAL DETECTADO POR PRIMERA VEZ DURANTE EL TRABAJO DE PARTO Y\/O EL PARTO EN INFANTE NACIDO VIVO"
  },
  {
    "codigo":315348000,
    "descripcion":"CARDIOPATÍA CORONARIA ASINTOMÁTICA"
  },
  {
    "codigo":282580001,
    "descripcion":"DIFICULTAD PARA BRINCAR"
  },
  {
    "codigo":85972008,
    "descripcion":"TRASTORNO SENSITIVO"
  },
  {
    "codigo":184276009,
    "descripcion":"AGUARDA CARTA DE ALTA HOSPITALARIA POR DEFUNCIÓN"
  },
  {
    "codigo":249812008,
    "descripcion":"ANTEPIÉ PRONADO"
  },
  {
    "codigo":413652008,
    "descripcion":"DEFICIENCIA DE BIOTINA"
  },
  {
    "codigo":247977003,
    "descripcion":"DESINHIBICIÓN SOCIAL"
  },
  {
    "codigo":16766000,
    "descripcion":"FIEBRE HEMORRÁGICA POR ARBOVIRUS"
  },
  {
    "codigo":770430000,
    "descripcion":"ATROFIA MUSCULAR ESPINAL DISTAL AUTOSÓMICA RECESIVA TIPO 3"
  },
  {
    "codigo":49534003,
    "descripcion":"ATRESIA CONGÉNITA DE URÉTER"
  },
  {
    "codigo":15697841000119109,
    "descripcion":"ABSCESO DE BOLSA SEROSA DE AMBOS PIES"
  },
  {
    "codigo":82302008,
    "descripcion":"FUMADOR DE PIPA"
  },
  {
    "codigo":213374009,
    "descripcion":"LESIONES TRAUMÁTICAS POR APLASTAMIENTO QUE COMPROMETEN MÚLTIPLES REGIONES DE MIEMBROS SUPERIORES E INFERIORES"
  },
  {
    "codigo":703059002,
    "descripcion":"KOCURIA VARIANS O KOCURIA ROSEA"
  },
  {
    "codigo":309843003,
    "descripcion":"BOLSA PARA ESTOMA URINARIO ADAPTADA"
  },
  {
    "codigo":1260115001,
    "descripcion":"CARCINOMA TIPO GLÁNDULA SALIVAL DE PULMÓN"
  },
  {
    "codigo":735827007,
    "descripcion":"RUPTURA TRAUMÁTICA DE LIGAMENTO PALMAR A LA ALTURA DE ARTICULACIÓN INTERFALÁNGICA DE DEDO DE LA MANO"
  },
  {
    "codigo":352331000119105,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE CORDÓN ESPERMÁTICO IZQUIERDO"
  },
  {
    "codigo":766760004,
    "descripcion":"CROMOSOMA X PEQUEÑO EN ANILLO"
  },
  {
    "codigo":209704006,
    "descripcion":"SECCIÓN EXPUESTA DE LIGAMENTO EXTERNO DE TOBILLO"
  },
  {
    "codigo":111400008,
    "descripcion":"HIPOVITAMINOSIS A CON MANIFESTACIONES OCULARES"
  },
  {
    "codigo":45864009,
    "descripcion":"DEGENERACIÓN SENIL DEL CEREBRO"
  },
  {
    "codigo":764925004,
    "descripcion":"MOVIMIENTO, SENSIBILIDAD Y CIRCULACIÓN DE MIEMBRO INFERIOR NORMALES"
  },
  {
    "codigo":240637006,
    "descripcion":"LEISHMANIASIS CUTÁNEA"
  },
  {
    "codigo":699389008,
    "descripcion":"MIEDO A TRATAMIENTO MÉDICO"
  },
  {
    "codigo":304338001,
    "descripcion":"AMPLITUD DE MOVIMIENTO DE DEDO DEL PIE AUMENTADA"
  },
  {
    "codigo":9426002,
    "descripcion":"ERITROCITOSIS POR HIDRONEFROSIS"
  },
  {
    "codigo":402642005,
    "descripcion":"ACNÉ CON FOLICULITIS POR GRAMNEGATIVO"
  },
  {
    "codigo":1156306006,
    "descripcion":"ESPONDILOLISTESIS LUMBOSACRA CONGÉNITA"
  },
  {
    "codigo":271570007,
    "descripcion":"TRASTORNO DE LA CÁPSULA DEL CRISTALINO"
  },
  {
    "codigo":269735005,
    "descripcion":"LESIÓN DE CAUSA ACCIDENTAL O INTENCIONAL NO DETERMINADA"
  },
  {
    "codigo":366204000,
    "descripcion":"PERMEABILIDAD DE INJERTO CORONARIO - HALLAZGO"
  },
  {
    "codigo":235132004,
    "descripcion":"NEOPLASIA DE GLÁNDULA SALIVAL"
  },
  {
    "codigo":12095871000119100,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DE TOBILLO DERECHO"
  },
  {
    "codigo":300668007,
    "descripcion":"DIFICULTAD PARA REALIZAR EJERCICIO DE SEGURIDAD VIAL"
  },
  {
    "codigo":724817003,
    "descripcion":"TRASTORNO DEL SISTEMA NERVIOSO POSTERIOR A PROCEDIMIENTO"
  },
  {
    "codigo":167761003,
    "descripcion":"EXAMEN DE SEMEN: BUENA FERTILIDAD"
  },
  {
    "codigo":298833005,
    "descripcion":"AMPLITUD DE ROTACIÓN EXTERNA ACTIVA DE ARTICULACIÓN DE HOMBRO, NORMAL"
  },
  {
    "codigo":397137005,
    "descripcion":"HALLAZGO DE LA EVALUACIÓN MAMOGRÁFICA"
  },
  {
    "codigo":36689008,
    "descripcion":"PIELONEFRITIS AGUDA"
  },
  {
    "codigo":722982003,
    "descripcion":"CEFALEA TENSIONAL EPISÓDICA FRECUENTE"
  },
  {
    "codigo":231462006,
    "descripcion":"PATRÓN DE USO NOCIVO DE BARBITÚRICO"
  },
  {
    "codigo":721147000,
    "descripcion":"DISPLASIA ECTODÉRMICA HIDRÓTICA, TIPO HALAL"
  },
  {
    "codigo":229627001,
    "descripcion":"TARTAMUDEO SECUNDARIO"
  },
  {
    "codigo":295163002,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE METADONA"
  },
  {
    "codigo":296998008,
    "descripcion":"SOBREDOSIS INTENCIONAL DE BRETILIO"
  },
  {
    "codigo":196859000,
    "descripcion":"HERNIA UMBILICAL OBSTRUIDA"
  },
  {
    "codigo":213256002,
    "descripcion":"SHOCK SÉPTICO POSOPERATORIO"
  },
  {
    "codigo":94885000,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE HUESO DE LA QUIJADA"
  },
  {
    "codigo":783013001,
    "descripcion":"SÍNDROME DE PIEL RÍGIDA TIPO PARANÁ"
  },
  {
    "codigo":422565003,
    "descripcion":"POLIARTRITIS POSINFECCIOSA"
  },
  {
    "codigo":16028031000119108,
    "descripcion":"EXOSTOSIS DE PERONÉ DERECHO"
  },
  {
    "codigo":62117008,
    "descripcion":"AUMENTO DE ANTICUERPOS ANTIBACTERIANOS, ESPECÍMENES PAREADOS"
  },
  {
    "codigo":291493009,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR ERITROMICINA"
  },
  {
    "codigo":1141626005,
    "descripcion":"ADENOCARCINOMA DE PÁNCREAS CON FUSIÓN DEL GEN NRG1"
  },
  {
    "codigo":93050005,
    "descripcion":"DILATACIÓN CONGÉNITA DEL CAYADO AÓRTICO"
  },
  {
    "codigo":11823641000119103,
    "descripcion":"ABRASIÓN DE PIEL DE BRAZO DERECHO"
  },
  {
    "codigo":224122009,
    "descripcion":"FAMILIA CON NIÑOS MENORES DE UN AÑO"
  },
  {
    "codigo":15673881000119104,
    "descripcion":"MIOSITIS INFECCIOSA DE AMBOS BRAZOS"
  },
  {
    "codigo":123983008,
    "descripcion":"EDAD ÓSEA RETRASADA"
  },
  {
    "codigo":449828001,
    "descripcion":"LOQUIOS SEROSOS"
  },
  {
    "codigo":255055008,
    "descripcion":"NEOPLASIA DE CABEZA Y CUELLO"
  },
  {
    "codigo":253220004,
    "descripcion":"FÍSTULA LAGRIMAL CONGÉNITA"
  },
  {
    "codigo":285988006,
    "descripcion":"DIFICULTAD PARA ENCENDER EL CONDUCTOR ELÉCTRICO PRINCIPAL"
  },
  {
    "codigo":22009001,
    "descripcion":"CARÚNCULA DE LA VAGINA"
  },
  {
    "codigo":284153001,
    "descripcion":"NO MUEVE LA PIERNA"
  },
  {
    "codigo":282318000,
    "descripcion":"INCAPAZ DE PARARSE SOLO"
  },
  {
    "codigo":16220851000119102,
    "descripcion":"ANAFILAXIA CAUSADA POR VENENO DE ABEJA MIELERA"
  },
  {
    "codigo":52942000,
    "descripcion":"NACIMIENTO DE TÉRMINO DE MELLIZOS MUERTOS"
  },
  {
    "codigo":741070003,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO DE CABEZA Y CUELLO"
  },
  {
    "codigo":691000119103,
    "descripcion":"DISFUNCIÓN ERÉCTIL DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":249550009,
    "descripcion":"PULSACIÓN ABDOMINAL VISIBLE"
  },
  {
    "codigo":446158009,
    "descripcion":"CONEXIONES VENOSAS PULMONARES NORMALES"
  },
  {
    "codigo":870307006,
    "descripcion":"TRASTORNO GENERALIZADO DEL DESARROLLO CON AUSENCIA DE LENGUAJE FUNCIONAL"
  },
  {
    "codigo":280483007,
    "descripcion":"PARAMETRITIS"
  },
  {
    "codigo":1263523006,
    "descripcion":"MENINGITIS DEBIDA A ENFERMEDAD DE BEHCET"
  },
  {
    "codigo":278648005,
    "descripcion":"CAÍDA DE RETENEDOR ORTODÓNCICO"
  },
  {
    "codigo":11852621000119100,
    "descripcion":"AMPUTACIÓN PARCIAL TRAUMÁTICA DE SEGUNDO A QUINTO DEDOS DE PIE DERECHO"
  },
  {
    "codigo":14669001,
    "descripcion":"SÍNDROME DE INSUFICIENCIA RENAL AGUDA"
  },
  {
    "codigo":328371000119107,
    "descripcion":"PANCITOPENIA CAUSADA POR FÁRMACO ANTITIROIDEO"
  },
  {
    "codigo":473421004,
    "descripcion":"SORDERA DE OÍDO DERECHO"
  },
  {
    "codigo":440653007,
    "descripcion":"INFECCIÓN ASOCIADA CON CATÉTER"
  },
  {
    "codigo":735565009,
    "descripcion":"PERFORACIÓN DE ARTERIA CORONARIA CONCOMITANTE CON ANEURISMA DE ARTERIA CORONARIA Y DEBIDA A ÉL"
  },
  {
    "codigo":897570002,
    "descripcion":"ARTROGRIPOSIS DISTAL TIPO 3"
  },
  {
    "codigo":78370002,
    "descripcion":"ESCLERITIS"
  },
  {
    "codigo":209442001,
    "descripcion":"ESGUINCE DE LIGAMENTO CARPO RADIAL LATERAL"
  },
  {
    "codigo":307746006,
    "descripcion":"ABORTO INCOMPLETO INEVITABLE COMPLICADO CON EMBOLIA"
  },
  {
    "codigo":1290786007,
    "descripcion":"CONTUSIÓN SUPERFICIAL DE PIEL"
  },
  {
    "codigo":109303003,
    "descripcion":"OSTEOMIELITIS DE LOS HUESOS DE LA CARA"
  },
  {
    "codigo":240375004,
    "descripcion":"MICROSPORIDIOSIS INTESTINAL"
  },
  {
    "codigo":43767005,
    "descripcion":"FRACTURA NO EXPUESTA DE HUESO PISIFORME DEL CARPO"
  },
  {
    "codigo":305911006,
    "descripcion":"ATENDIDO EN CENTRO DE CUIDADOS PALIATIVOS"
  },
  {
    "codigo":402380000,
    "descripcion":"GRANULOMA POR ERIZO DE MAR"
  },
  {
    "codigo":15948621000119105,
    "descripcion":"ÚLCERA DE PIE IZQUIERDO DEBIDA A SÍNDROME POSTROMBÓTICO"
  },
  {
    "codigo":685031000119100,
    "descripcion":"HEMANGIOMA DE MÚSCULO"
  },
  {
    "codigo":9164007,
    "descripcion":"FIEBRE DE MAYARO"
  },
  {
    "codigo":41932008,
    "descripcion":"AMOK"
  },
  {
    "codigo":171169001,
    "descripcion":"EXTENDIDO NO REALIZADO - AUSENCIA DE CUELLO UTERINO"
  },
  {
    "codigo":1156044007,
    "descripcion":"FENITOÍNA SÉRICA DENTRO DEL RANGO TERAPÉUTICO"
  },
  {
    "codigo":7329003,
    "descripcion":"ABSCESO DE LA CABEZA, SIN COMPROMISO DE LA CARA"
  },
  {
    "codigo":1186977004,
    "descripcion":"COMPLIANCIA PULMONAR DENTRO DE RANGO DE REFERENCIA"
  },
  {
    "codigo":105633007,
    "descripcion":"ENFERMEDAD CAUSADA POR PICORNAVIRIDAE"
  },
  {
    "codigo":269473008,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LOS APARATOS RESPIRATORIO Y DIGESTIVO"
  },
  {
    "codigo":202102003,
    "descripcion":"DESGARRO ANTIGUO DE MENISCO DE RODILLA"
  },
  {
    "codigo":5494004,
    "descripcion":"PULPITIS AGUDA"
  },
  {
    "codigo":365942007,
    "descripcion":"HÁBITOS ORALES - HALLAZGO"
  },
  {
    "codigo":396875000,
    "descripcion":"TUMOR SÓLIDO, PARCIALMENTE ENCAPSULADO"
  },
  {
    "codigo":724555000,
    "descripcion":"TRASTORNO DE LA PUBERTAD DEBIDO A RESISTENCIA A LOS ESTRÓGENOS"
  },
  {
    "codigo":69195002,
    "descripcion":"DEGENERACIÓN DE DISCO INTERVERTEBRAL CERVICAL"
  },
  {
    "codigo":267638009,
    "descripcion":"PIGMENTACIÓN ESTROMAL"
  },
  {
    "codigo":36427004,
    "descripcion":"DISCOPATÍA"
  },
  {
    "codigo":298571005,
    "descripcion":"AMPLITUD DE ROTACIÓN PASIVA HACIA LA IZQUIERDA DE LA COLUMNA VERTEBRAL DORSAL, DISMINUIDA"
  },
  {
    "codigo":429643006,
    "descripcion":"ARTROPATÍA DE CODO ASOCIADA CON TRASTORNO NEUROLÓGICO"
  },
  {
    "codigo":10761191000119104,
    "descripcion":"TRABAJO DE PARTO PRETÉRMINO EN EL TERCER TRIMESTRE CON PARTO PRETÉRMINO EN EL TERCER TRIMESTRE DE GESTACIÓN"
  },
  {
    "codigo":726390009,
    "descripcion":"DELECIÓN DE PARTE DEL BRAZO CORTO DEL CROMOSOMA 17"
  },
  {
    "codigo":67360000,
    "descripcion":"BERIBERI HÚMEDO"
  },
  {
    "codigo":1824008,
    "descripcion":"GASTRITIS ALÉRGICA"
  },
  {
    "codigo":330881000119101,
    "descripcion":"VITILIGO DE PIEL DE PÁRPADO SUPERIOR DERECHO Y REGIÓN PERIOCULAR"
  },
  {
    "codigo":360437006,
    "descripcion":"DISTENSIÓN DE TENDÓN CERVICAL"
  },
  {
    "codigo":131061007,
    "descripcion":"ANDRÓGENO ANORMAL"
  },
  {
    "codigo":15731841000119102,
    "descripcion":"TRASTORNO DE NERVIO ÓPTICO DERECHO"
  },
  {
    "codigo":294901008,
    "descripcion":"ALERGIA A SUCCINATO FERROSO"
  },
  {
    "codigo":260298002,
    "descripcion":"PERCEPCIÓN DE LA LUZ - PROYECCIÓN IMPRECISA"
  },
  {
    "codigo":293066005,
    "descripcion":"REACCIÓN ADVERSA A LA DILOXANIDA"
  },
  {
    "codigo":29087002,
    "descripcion":"CODO VARO ADQUIRIDO"
  },
  {
    "codigo":782751003,
    "descripcion":"INMUNODEFICIENCIA COMBINADA SEVERA DEBIDA A DEFICIENCIA DE INHIBIDOR DE LA SUBUNIDAD BETA DE INHIBIDOR DE FACTOR NUCLEAR KAPPA B CINASA"
  },
  {
    "codigo":291231007,
    "descripcion":"INTOXICACIÓN POR REMOXIPRIDA"
  },
  {
    "codigo":192927008,
    "descripcion":"ESCLEROSIS MÚLTIPLE DE LA MÉDULA ESPINAL"
  },
  {
    "codigo":289396001,
    "descripcion":"PIE FETAL PALPABLE POR VÍA VAGINAL"
  },
  {
    "codigo":94623007,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE TESTÍCULO"
  },
  {
    "codigo":92788005,
    "descripcion":"CARCINOMA IN SITU DEL ÚTERO"
  },
  {
    "codigo":254793001,
    "descripcion":"LINFANGIOMA CAVERNOSO CUTÁNEO"
  },
  {
    "codigo":387700009,
    "descripcion":"FASE LATENTE DE TRABAJO DE PARTO PROLONGADA"
  },
  {
    "codigo":123721004,
    "descripcion":"CITOPENIA MODERADA"
  },
  {
    "codigo":189257005,
    "descripcion":"CARCINOMA IN SITU DE CARTÍLAGO CUNEIFORME DE LA LARINGE"
  },
  {
    "codigo":713545009,
    "descripcion":"INFECCIÓN CAUSADA POR NOCARDIA CONCOMITANTE CON INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":85121000119109,
    "descripcion":"SUSCEPTIBILIDAD GENÉTICA AL CÁNCER"
  },
  {
    "codigo":11773211000119103,
    "descripcion":"RUPTURA TRAUMÁTICA DE LIGAMENTO RADIAL COLATERAL DE CODO DERECHO"
  },
  {
    "codigo":11855131000119103,
    "descripcion":"AMPOLLA TRAUMÁTICA DE MITAD DERECHA DE PARED POSTERIOR DE TÓRAX"
  },
  {
    "codigo":447731000,
    "descripcion":"ADENOMA DE DUODENO"
  },
  {
    "codigo":1137694009,
    "descripcion":"PELIOSIS DE BAZO"
  },
  {
    "codigo":251123001,
    "descripcion":"BLOQUEO COMPLETO DE LA RAMA DERECHA DEL HAZ DE HIS"
  },
  {
    "codigo":185587005,
    "descripcion":"CRIBADO PARA DETECCIÓN DE ANTICUERPOS ANTIRRUBEÓLICOS - BORRADO"
  },
  {
    "codigo":54515008,
    "descripcion":"SARCOIDOSIS, TIPO PLACA"
  },
  {
    "codigo":773576000,
    "descripcion":"DISTROFIA RETINIANA PROGRESIVA POR DEFECTO DEL TRANSPORTE DE RETINOL"
  },
  {
    "codigo":118216002,
    "descripcion":"HALLAZGO RELACIONADO CON EL TRABAJO DE PARTO"
  },
  {
    "codigo":445896002,
    "descripcion":"TIENE ACCESO A ARMA"
  },
  {
    "codigo":1332467008,
    "descripcion":"HIPERTENSIÓN EN ENFERMEDAD RENAL CRÓNICA EN ESTADIO 5 DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":216520005,
    "descripcion":"INTOXICACIÓN ACCIDENTAL CAUSADA POR CLORPROMAZINA"
  },
  {
    "codigo":249288007,
    "descripcion":"VACIAMIENTO INCOMPLETO DE VEJIGA URINARIA"
  },
  {
    "codigo":247453004,
    "descripcion":"SECRECIÓN A PARTIR DE UNA ÚLCERA CUTÁNEA"
  },
  {
    "codigo":1197725005,
    "descripcion":"OBSTRUCCIÓN POSOPERATORIA DE INTESTINO DELGADO"
  },
  {
    "codigo":140571000119108,
    "descripcion":"INMUNIZACIÓN DESACTUALIZADA DEBIDO A ESQUEMA ALTERNATIVO"
  },
  {
    "codigo":18077009,
    "descripcion":"SÍNDROME TRICORRINOFALÁNGICO"
  },
  {
    "codigo":737138006,
    "descripcion":"CHASQUIDO DE AMBAS ARTICULACIONES TEMPOROMANDIBULARES DURANTE LA APERTURA"
  },
  {
    "codigo":16242007,
    "descripcion":"ACIDURIA ORÓTICA HEREDITARIA"
  },
  {
    "codigo":704370008,
    "descripcion":"ALTERACIÓN DEL DESARROLLO DEL LACTANTE"
  },
  {
    "codigo":276551001,
    "descripcion":"HEPATITIS PERINATAL"
  },
  {
    "codigo":407623000,
    "descripcion":"TRATAMIENTO DE EMERGENCIA DE LA EPILEPSIA DESDE LA ÚLTIMA CONSULTA"
  },
  {
    "codigo":1163122009,
    "descripcion":"COLITIS POR SHIGELLA FLEXNERI"
  },
  {
    "codigo":440391004,
    "descripcion":"DEFORMIDAD CONGÉNITA DE LA ESCÁPULA"
  },
  {
    "codigo":702535006,
    "descripcion":"ANSIEDAD POR FALTA DE ALIENTO"
  },
  {
    "codigo":1259591007,
    "descripcion":"DEMENCIA DEBIDA A HIPOTIROIDISMO ADQUIRIDO"
  },
  {
    "codigo":405788002,
    "descripcion":"ANOREXIA PSICÓGENA"
  },
  {
    "codigo":733468006,
    "descripcion":"SÍNDROME DE DISPLASIA ESQUELÉTICA CON HUESOS WORMIANOS, FRACTURAS MÚLTIPLES Y DENTINOGÉNESIS IMPERFECTA"
  },
  {
    "codigo":241948007,
    "descripcion":"ANAFILAXIS NO ALÉRGICA CAUSADA POR FÁRMACO ANTIINFLAMATORIO NO ESTEROIDE"
  },
  {
    "codigo":373020006,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM CHUBUENSE"
  },
  {
    "codigo":333391000119101,
    "descripcion":"PANUVEÍTIS DEL OJO DERECHO"
  },
  {
    "codigo":240113005,
    "descripcion":"MIOSITIS POR CESTODO"
  },
  {
    "codigo":687541000119108,
    "descripcion":"NEVO EPIDÉRMICO PILOSO PIGMENTADO DE LABIO"
  },
  {
    "codigo":305649007,
    "descripcion":"ATENDIDO POR UN NEONATÓLOGO"
  },
  {
    "codigo":403953009,
    "descripcion":"LINFADENOMA CUTÁNEO"
  },
  {
    "codigo":860870002,
    "descripcion":"ERITEMA MULTIFORME DEBIDO A INFECCIÓN POR MYCOPLASMA PNEUMONIAE"
  },
  {
    "codigo":76273009,
    "descripcion":"INFECCIÓN CAUSADA POR SYPHACIA"
  },
  {
    "codigo":762566005,
    "descripcion":"DERMATITIS ALÉRGICA POR CONTACTO OCUPACIONAL CAUSADA POR COMPUESTO METÁLICO"
  },
  {
    "codigo":269211001,
    "descripcion":"PICADURA DE INSECTO EN PÁRPADOS Y REGIÓN PERIOCULAR"
  },
  {
    "codigo":367515004,
    "descripcion":"TRASTORNO DE LENGUAJE RECEPTIVO"
  },
  {
    "codigo":1186715006,
    "descripcion":"INMUNODEFICIENCIA COMBINADA DEBIDA A DEFICIENCIA DE CD70"
  },
  {
    "codigo":301979008,
    "descripcion":"HALLAZGO RELACIONADO CON LA VISIÓN DE LOS COLORES"
  },
  {
    "codigo":236443009,
    "descripcion":"RIÑÓN CON MÉDULA EN ESPONJA"
  },
  {
    "codigo":234608003,
    "descripcion":"DEFICIENCIA EL COMPONENTE TERMINAL"
  },
  {
    "codigo":201840004,
    "descripcion":"COXARTROSIS CAUSADA POR DISPLASIA, BILATERAL"
  },
  {
    "codigo":300144003,
    "descripcion":"SACO DE RETRACCIÓN POSTEROMARGINAL DE LA MEMBRANA TIMPÁNICA"
  },
  {
    "codigo":365680006,
    "descripcion":"VOLUMEN URINARIO DE 24 HORAS - HALLAZGO"
  },
  {
    "codigo":306921000119100,
    "descripcion":"DERRAME ARTICULAR DE TOBILLO DERECHO"
  },
  {
    "codigo":10956521000119101,
    "descripcion":"HERIDA ABIERTA DE DEDO ÍNDICE IZQUIERDO"
  },
  {
    "codigo":722458000,
    "descripcion":"SÍNDROME DE MATTHEW WOOD"
  },
  {
    "codigo":298309009,
    "descripcion":"SIGNO DE EQUILIBRIO CON NOMBRE PROPIO"
  },
  {
    "codigo":12103401000119102,
    "descripcion":"QUEMADURA DE TOBILLO DERECHO"
  },
  {
    "codigo":296474008,
    "descripcion":"SOBREDOSIS DE ISOTRETINOÍNA"
  },
  {
    "codigo":294639003,
    "descripcion":"ALERGIA A INMUNOGLOBULINA CONTRA VIRUS VARICELA ZÓSTER"
  },
  {
    "codigo":425711007,
    "descripcion":"MASA COLÓNICA"
  },
  {
    "codigo":16527081000119105,
    "descripcion":"LACERACIÓN DE CEJA IZQUIERDA"
  },
  {
    "codigo":1179375008,
    "descripcion":"ADENOCARCINOMA PARATIROIDEO"
  },
  {
    "codigo":389273002,
    "descripcion":"QUERUBINISMO CON FIBROMATOSIS GINGIVAL"
  },
  {
    "codigo":94361003,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LOS LABIOS MAYORES DE LA VULVA"
  },
  {
    "codigo":290969004,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR FENITOÍNA"
  },
  {
    "codigo":1306777007,
    "descripcion":"GLAUCOMA FACOMÓRFICO BILATERAL"
  },
  {
    "codigo":127129008,
    "descripcion":"LINFADENOPATÍA SUPRAPILÓRICA"
  },
  {
    "codigo":715118004,
    "descripcion":"SE TRANSFIERE DE LA SILLA A LA SILLA DE RUEDAS"
  },
  {
    "codigo":59758007,
    "descripcion":"PELVIS RENAL TRÍFIDA"
  },
  {
    "codigo":92526009,
    "descripcion":"CARCINOMA IN SITU DE LA CORTEZA SUPRARRENAL"
  },
  {
    "codigo":1335875003,
    "descripcion":"ICTERICIA NEONATAL PRECOZ DEBIDA A INFECCIÓN"
  },
  {
    "codigo":1237571004,
    "descripcion":"EPILEPSIA FAMILIAR INFANTIL AUTOLIMITADA"
  },
  {
    "codigo":254531003,
    "descripcion":"NEOPLASIA BENIGNA DE ESPACIO PARAFARÍNGEO"
  },
  {
    "codigo":188995004,
    "descripcion":"LIPOMA DE BRAZO"
  },
  {
    "codigo":187160001,
    "descripcion":"FILARIASIS CAUSADA POR BRUGIA TIMORI"
  },
  {
    "codigo":285464003,
    "descripcion":"ABRE LA BOCA"
  },
  {
    "codigo":1073181000119100,
    "descripcion":"ARTRITIS DE TOBILLO DERECHO CAUSADA POR STREPTOCOCCUS"
  },
  {
    "codigo":283629000,
    "descripcion":"HERIDA POR PINCHAZO DE AGUJA EN INGLE"
  },
  {
    "codigo":250861008,
    "descripcion":"HALLAZGO RELACIONADO CON LA FORMA DE LA ONDA"
  },
  {
    "codigo":609474001,
    "descripcion":"INTERRUPCIÓN INDUCIDA DEL EMBARAZO COMPLICADA POR PERITONITIS PÉLVICA"
  },
  {
    "codigo":1363138000,
    "descripcion":"ASTILLA EN VULVA CON INFECCIÓN"
  },
  {
    "codigo":314562004,
    "descripcion":"QUERATITIS ESTÉRIL ASOCIADA CON LENTE DE CONTACTO"
  },
  {
    "codigo":281794004,
    "descripcion":"INFECCIÓN VIRAL DEL TRACTO RESPIRATORIO SUPERIOR"
  },
  {
    "codigo":871618005,
    "descripcion":"DISPLASIA CONGÉNITA DE VÁLVULA TRONCAL"
  },
  {
    "codigo":771479000,
    "descripcion":"INMUNODEFICIENCIA COMBINADA POR DEFICIENCIA DE SERINA\/TREONINA CINASA 4"
  },
  {
    "codigo":83351003,
    "descripcion":"MIGRAÑA BASILAR"
  },
  {
    "codigo":247191005,
    "descripcion":"LESIÓN CORIORRETINIANA PLANA"
  },
  {
    "codigo":335901000119105,
    "descripcion":"ENTROPIÓN CICATRIZAL DE PÁRPADO DERECHO"
  },
  {
    "codigo":1259329000,
    "descripcion":"CARCINOMA PRIMARIO DE FRENILLO DE LENGUA"
  },
  {
    "codigo":767809001,
    "descripcion":"HEPATITIS C CRÓNICA CAUSADA POR GENOTIPO 6 DE VIRUS HEPATITIS C"
  },
  {
    "codigo":866113004,
    "descripcion":"LINFANGIOMA DE LARINGE"
  },
  {
    "codigo":276289005,
    "descripcion":"HABILIDADES AISLADAS RELACIONADAS CON UNA ALTERACIÓN GENERAL"
  },
  {
    "codigo":12310001,
    "descripcion":"BRONQUIECTASIA DE LA NIÑEZ"
  },
  {
    "codigo":598221000005106,
    "descripcion":"CONSUMIDORA DE NICOTINA DURANTE EMBARAZO"
  },
  {
    "codigo":208918002,
    "descripcion":"DESGARRO MENISCAL AGUDO, INTERNO, RADIAL"
  },
  {
    "codigo":700438002,
    "descripcion":"ARTROPATÍA DE CHARCOT DE REGIÓN POSTERIOR DE PIE"
  },
  {
    "codigo":733206005,
    "descripcion":"ERITRODERMIA EN LA LACTANCIA"
  },
  {
    "codigo":1222891000,
    "descripcion":"REACCIÓN ADVERSA A INMUNOGLOBULINA HUMANA ANTI-D"
  },
  {
    "codigo":897046009,
    "descripcion":"ERUPCIÓN MACULOPAPULAR POR FLUOROQUINOLONA"
  },
  {
    "codigo":403691006,
    "descripcion":"HEMORRAGIA POSTERIOR A CIRUGÍA CUTÁNEA"
  },
  {
    "codigo":1255659007,
    "descripcion":"CARCINOMA EPITELIAL-MIOEPITELIAL DE OROFARINGE"
  },
  {
    "codigo":10631351000119105,
    "descripcion":"ABSCESO DE PIEL DE CADERA IZQUIERDA"
  },
  {
    "codigo":74176008,
    "descripcion":"COITO BREVE"
  },
  {
    "codigo":432789001,
    "descripcion":"EDEMA MACULAR NO CISTOIDE DE RETINA"
  },
  {
    "codigo":203413004,
    "descripcion":"OSTEOCONDRITIS DISECANTE DEL ASTRÁGALO"
  },
  {
    "codigo":301717006,
    "descripcion":"DOLOR EN EL CUADRANTE SUPERODERECHO"
  },
  {
    "codigo":234346000,
    "descripcion":"ANEMIA DILUCIONAL"
  },
  {
    "codigo":1184618002,
    "descripcion":"AMBIENTE CÁLIDO"
  },
  {
    "codigo":299882003,
    "descripcion":"REFLEJO AQUÍLEO INVERTIDO"
  },
  {
    "codigo":365418004,
    "descripcion":"HALLAZGO RELACIONADO CON LA ONDA T DEL ELECTROCARDIOGRAMA"
  },
  {
    "codigo":103274003,
    "descripcion":"PRESIÓN INTRAOCULAR NORMAL CON HENDIDURA ESTRECHA"
  },
  {
    "codigo":15683921000119103,
    "descripcion":"BURSITIS ISQUIOGLÚTEA DE AMBAS CADERAS"
  },
  {
    "codigo":398186009,
    "descripcion":"EQUIPO DESCONECTADO"
  },
  {
    "codigo":789567007,
    "descripcion":"ÚLCERA DE TALÓN DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":165140000,
    "descripcion":"ENDOSCOPIA NORMAL"
  },
  {
    "codigo":3135009,
    "descripcion":"OTITIS EXTERNA"
  },
  {
    "codigo":66836003,
    "descripcion":"UTILIZA DUCHA POSCOITAL ANTICONCEPTIVA"
  },
  {
    "codigo":294377000,
    "descripcion":"ALERGIA A INTERFERÓN ALFA-2A"
  },
  {
    "codigo":230676009,
    "descripcion":"DEFECTO SUPUESTO EN LA SÍNTESIS O EMPAQUETAMIENTO DE ACETILCOLINA"
  },
  {
    "codigo":292542000,
    "descripcion":"REACCIÓN ADVERSA A LA ORFENADRINA"
  },
  {
    "codigo":95934001,
    "descripcion":"VÍCTIMA DE CRIMEN"
  },
  {
    "codigo":65001009,
    "descripcion":"COLANGITIS PIOGÉNICA RECIDIVANTE"
  },
  {
    "codigo":28563001,
    "descripcion":"INTOXICACIÓN CAUSADA POR ACTINOMICINA"
  },
  {
    "codigo":94099002,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE TIBIA"
  },
  {
    "codigo":126867004,
    "descripcion":"NEOPLASIA DEL PERITONEO PÉLVICO"
  },
  {
    "codigo":421779007,
    "descripcion":"MACULOPATÍA EXUDATIVA DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":1306515008,
    "descripcion":"NEOPLASIA MALIGNA RECURRENTE PRIMARIA DE MAMA"
  },
  {
    "codigo":290707009,
    "descripcion":"INTOXICACIÓN POR AMSACRINA"
  },
  {
    "codigo":419944002,
    "descripcion":"SÍNDROME DE ISQUEMIA ORBITARIA"
  },
  {
    "codigo":35501000087105,
    "descripcion":"ISQUEMIA MIOCÁRDICA ANTEROLATERAL"
  },
  {
    "codigo":43181000087108,
    "descripcion":"HERIDA PUNZANTE DE PIERNA IZQUIERDA CON CUERPO EXTRAÑO"
  },
  {
    "codigo":1075691000119106,
    "descripcion":"GRANULOMA POR CUERPO EXTRAÑO DE PARTES BLANDAS DE PIE DERECHO"
  },
  {
    "codigo":714856005,
    "descripcion":"INCAPAZ DE ADOPTAR EL PAPEL DE ENFERMO"
  },
  {
    "codigo":92264007,
    "descripcion":"NEOPLASIA BENIGNA DE PÁNCREAS"
  },
  {
    "codigo":38061000087109,
    "descripcion":"ACINESIA DE SEGMENTO INFEROSEPTAL BASAL DE VENTRÍCULO CARDÍACO IZQUIERDO"
  },
  {
    "codigo":338411000119106,
    "descripcion":"QUERATITIS PUNTEADA DEL OJO IZQUIERDO"
  },
  {
    "codigo":48301000087107,
    "descripcion":"FRACTURA DE MÚLTIPLES COSTILLAS DEL LADO IZQUIERDO"
  },
  {
    "codigo":188733003,
    "descripcion":"LEUCEMIA EOSINÓFILA CRÓNICA"
  },
  {
    "codigo":287037005,
    "descripcion":"RUPTURA DE MEMBRANA SINOVIAL DE MUÑECA"
  },
  {
    "codigo":254269007,
    "descripcion":"TRISOMÍA CROMOSÓMICA COMPLETA - FALTA DE DISYUNCIÓN MEIÓTICA"
  },
  {
    "codigo":15958661000119103,
    "descripcion":"MELANOMA MALIGNO METASTÁSICO DE RIÑÓN IZQUIERDO"
  },
  {
    "codigo":88594005,
    "descripcion":"HERPES SIMPLE"
  },
  {
    "codigo":840423002,
    "descripcion":"LINFOMA DIFUSO DE LINFOCITOS B GRANDES DE INTESTINO DELGADO"
  },
  {
    "codigo":311941000119104,
    "descripcion":"OSTEOCONDROSIS JUVENIL DE COLUMNA VERTEBRAL TORACOLUMBAR"
  },
  {
    "codigo":53991003,
    "descripcion":"CISTITIS CON BILHARZIASIS"
  },
  {
    "codigo":283367007,
    "descripcion":"LACERACIÓN DE HOMBRO"
  },
  {
    "codigo":281532001,
    "descripcion":"FRACTURA DE MALÉOLO POSTERIOR"
  },
  {
    "codigo":248764004,
    "descripcion":"LENTO PARA EXCITARSE SEXUALMENTE"
  },
  {
    "codigo":822031000000101,
    "descripcion":"MENINGITIS AGUDA"
  },
  {
    "codigo":52156004,
    "descripcion":"TROMBOSIS DE ARTERIA FEMORAL"
  },
  {
    "codigo":1297340005,
    "descripcion":"CIERRE DE ÁNGULO DE OJO IZQUIERDO DEBIDO A MALFORMACIÓN CONGÉNITA DE ÁNGULO DE CÁMARA ANTERIOR DE OJO IZQUIERDO"
  },
  {
    "codigo":944911000000105,
    "descripcion":"CAPAZ DE ESTABLECER OBJETIVOS PERSONALES"
  },
  {
    "codigo":771217005,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DE CABEZA Y\/O CUELLO"
  },
  {
    "codigo":246929009,
    "descripcion":"HALLAZGO DEL NERVIO CORNEAL"
  },
  {
    "codigo":212326003,
    "descripcion":"LESIÓN ABIERTA DE NERVIO SENSITIVO CUTÁNEO DE MIEMBRO INFERIOR"
  },
  {
    "codigo":703846009,
    "descripcion":"ABSTINENCIA DE BUPRENORFINA"
  },
  {
    "codigo":1259067006,
    "descripcion":"TRASTORNO DE SISTEMA NERVIOSO AUTÓNOMO DEBIDO A ENCEFALITIS AUTOINMUNITARIA"
  },
  {
    "codigo":12048000,
    "descripcion":"SIGNO DE HOMANS"
  },
  {
    "codigo":110352000,
    "descripcion":"DETERIORO COGNITIVO MÍNIMO"
  },
  {
    "codigo":274192001,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE LA MUÑECA"
  },
  {
    "codigo":896784003,
    "descripcion":"FORMA ANCHA ANORMAL CONGÉNITA DE FALANGE PROXIMAL DE DEDO GORDO"
  },
  {
    "codigo":13883009,
    "descripcion":"HÁLITO DE PLOMO"
  },
  {
    "codigo":303290001,
    "descripcion":"EQUIMOSIS DE SUPERFICIE INTRABUCAL DE LABIO"
  },
  {
    "codigo":243971001000119103,
    "descripcion":"MELANOMA MALIGNO DE PIEL DE TOBILLO DERECHO"
  },
  {
    "codigo":237754008,
    "descripcion":"HIPERPLASIA SUPRARRENAL CONGÉNITA DE INICIO TARDÍO"
  },
  {
    "codigo":301455002,
    "descripcion":"ENDOMETRIO ATRÓFICO"
  },
  {
    "codigo":1153423005,
    "descripcion":"CONDROSARCOMA DE COSTILLA"
  },
  {
    "codigo":235919008,
    "descripcion":"CÁLCULO DE LA VESÍCULA BILIAR"
  },
  {
    "codigo":103012002,
    "descripcion":"CEFALEA POR USO EXCESIVO DE ANALGÉSICOS"
  },
  {
    "codigo":234084003,
    "descripcion":"LACERACIÓN VENOSA"
  },
  {
    "codigo":168548004,
    "descripcion":"RADIOGRAFÍA SIMPLE DE ARTICULACIÓN TEMPOROMANDIBULAR ANORMAL"
  },
  {
    "codigo":4708004,
    "descripcion":"EVALUACIÓN DE DISCAPACIDAD: 35%"
  },
  {
    "codigo":1078201000119106,
    "descripcion":"TENDÓN DE AQUILES IZQUIERDO CORTO CONGÉNITO"
  },
  {
    "codigo":299620006,
    "descripcion":"AMPLITUD DE ADUCCIÓN ACTIVA DE DEDO DEL PIE DISMINUIDA"
  },
  {
    "codigo":365156008,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA ABRIR LAS CANILLAS DE AGUA"
  },
  {
    "codigo":340921000119107,
    "descripcion":"ENOFTALMÍA DE OJO IZQUIERDO"
  },
  {
    "codigo":428857003,
    "descripcion":"ENFERMEDAD DE KASHIN-BECK DE COLUMNA VERTEBRAL"
  },
  {
    "codigo":68409003,
    "descripcion":"NEUMONÍA ORGANIZADA"
  },
  {
    "codigo":232249008,
    "descripcion":"HEMOTÍMPANO TRAUMÁTICO"
  },
  {
    "codigo":1038000,
    "descripcion":"DISACARIDURIA"
  },
  {
    "codigo":427022004,
    "descripcion":"ENFERMEDAD HEPÁTICA POR FIBROSIS QUÍSTICA"
  },
  {
    "codigo":164878005,
    "descripcion":"ELECTROCARDIOGRAMA: SIN HIPERTROFIA VENTRICULAR DERECHA"
  },
  {
    "codigo":295950007,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE MIANSERINA"
  },
  {
    "codigo":33806008,
    "descripcion":"ENDARTERITIS"
  },
  {
    "codigo":230414008,
    "descripcion":"EPILEPSIA CON CONVULSIONES TÓNICO-CLÓNICAS GENERALIZADAS SOLAMENTE"
  },
  {
    "codigo":195811008,
    "descripcion":"LARINGITIS SIMPLE CRÓNICA"
  },
  {
    "codigo":294115009,
    "descripcion":"ALERGIA A AZELASTINA"
  },
  {
    "codigo":1177016002,
    "descripcion":"ATAXIA POSINFECCIOSA"
  },
  {
    "codigo":423352002,
    "descripcion":"MALACOPLASIA URETRAL"
  },
  {
    "codigo":292280000,
    "descripcion":"REACCIÓN ADVERSA A LA BUTRIPTILINA"
  },
  {
    "codigo":359651008,
    "descripcion":"GASTROENTERITIS NO BACTERIANA DEL LACTANTE"
  },
  {
    "codigo":11838701000119100,
    "descripcion":"LACERACIÓN DE MÚSCULO INTRÍNSECO DE DEDO MEDIO DE MANO DERECHA"
  },
  {
    "codigo":62904009,
    "descripcion":"DISFONÍA PSEUDOBULBAR ESPÁSTICA"
  },
  {
    "codigo":716429002,
    "descripcion":"CAPAZ DE MOVER OBJETOS POR LA CASA"
  },
  {
    "codigo":421517002,
    "descripcion":"GLÓBULOS ROJOS EN VÍTREO"
  },
  {
    "codigo":1339021004,
    "descripcion":"TRASTORNO DE NERVIO PERIFÉRICO CAUSADO POR RADIACIÓN IONIZANTE"
  },
  {
    "codigo":93837005,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA CARA INTERNA DE LABIO SUPERIOR"
  },
  {
    "codigo":126605007,
    "descripcion":"NEOPLASIA DE PARTES BLANDAS DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":26466000,
    "descripcion":"LINFANGITIS AGUDA DE LA PARED DEL ABDOMEN"
  },
  {
    "codigo":290445009,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR SULFATO DE MAGNESIO"
  },
  {
    "codigo":92002004,
    "descripcion":"NEOPLASIA BENIGNA DE VASO SANGUÍNEO DE LA CABEZA"
  },
  {
    "codigo":288610009,
    "descripcion":"CAPAZ DE EMPLEAR PALABRAS"
  },
  {
    "codigo":1237047001,
    "descripcion":"METÁSTASIS DE CARCINOMA DE PÁNCREAS ENDOCRINO"
  },
  {
    "codigo":254007004,
    "descripcion":"FISURA FACIAL PARAMEDIANA - FISURA DE TESSIER TIPO 1"
  },
  {
    "codigo":286775005,
    "descripcion":"CARÁCTER FIRME"
  },
  {
    "codigo":449075002,
    "descripcion":"LINFOMA DE UNIÓN CARDIOESOFÁGICA"
  },
  {
    "codigo":188471005,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE EPIDÍDIMO Y CONDUCTO DEFERENTE"
  },
  {
    "codigo":712759008,
    "descripcion":"SENSACIÓN DE CATÁSTROFE INMINENTE"
  },
  {
    "codigo":219404001,
    "descripcion":"HERIDA DE GUERRA POR EXPLOSIÓN DE OBTURADOR"
  },
  {
    "codigo":448780007,
    "descripcion":"DEFECTO DEL TABIQUE INTERVENTRICULAR CON TABIQUE CORRESPONDIENTE AL TRACTO DE SALIDA AUSENTE Y CABALGAMIENTO DE VÁLVULA TRONCAL CON EXTENSIÓN DE TABIQUE MEMBRANOSO"
  },
  {
    "codigo":86497005,
    "descripcion":"VIRUELA PLANA"
  },
  {
    "codigo":283105006,
    "descripcion":"ARAÑAZO DE PIE"
  },
  {
    "codigo":707254000,
    "descripcion":"ADHERENCIA AMNIÓTICA"
  },
  {
    "codigo":281270003,
    "descripcion":"ESPÉCIMEN EN TRÁNSITO RETRASADO"
  },
  {
    "codigo":314038003,
    "descripcion":"DEFORMIDAD DE DEDO DEL PIE EN VARO ADQUIRIDA"
  },
  {
    "codigo":15990151000119103,
    "descripcion":"CATARATA COMPLICADA DE AMBOS OJOS"
  },
  {
    "codigo":215734004,
    "descripcion":"LESIÓN SUFRIDA A BORDO DE MEDIO DE TRANSPORTE ACUÁTICO CAUSADA POR MAQUINARIA DE CARGA, NADADOR LESIONADO"
  },
  {
    "codigo":838326005,
    "descripcion":"TRASTORNO DEL DESARROLLO SEXUAL 46,XX DEBIDO A NEOPLASIA DE KRUKENBERG MATERNA"
  },
  {
    "codigo":410507001,
    "descripcion":"CONJUNTIVITIS NEONATAL POR VIRUS DEL HERPES SIMPLE"
  },
  {
    "codigo":115595004,
    "descripcion":"CRISTAL URINARIO, FOSFATO AMORFO"
  },
  {
    "codigo":18361000122109,
    "descripcion":"HIPERSENSIBILIDAD NO ALÉRGICA A MOEXIPRIL"
  },
  {
    "codigo":246667005,
    "descripcion":"HEMIANOPSIA BITEMPORAL COMPLETA"
  },
  {
    "codigo":82827007,
    "descripcion":"INTOXICACIÓN POR CICUTA VIROSA"
  },
  {
    "codigo":343431000119105,
    "descripcion":"ANILLO DE SOEMMERRING DE AMBOS OJOS"
  },
  {
    "codigo":1162336001,
    "descripcion":"ARTRITIS REUMATOIDE EROSIVA CON ANTICUERPOS ANTIPÉPTIDO CÍCLICO CITRULINADO POSITIVOS"
  },
  {
    "codigo":11785761000119100,
    "descripcion":"ABRASIÓN DE PIEL DE LA MANO DERECHA"
  },
  {
    "codigo":441440007,
    "descripcion":"ELEGIBLE COMO DONANTE"
  },
  {
    "codigo":210229000,
    "descripcion":"LESIÓN DE MÚLTIPLES ÓRGANOS DE LA REGIÓN PÉLVICA"
  },
  {
    "codigo":310368009,
    "descripcion":"SITUACIÓN DE NOTIFICACIÓN DE ENFERMEDAD INFECCIOSA"
  },
  {
    "codigo":408672009,
    "descripcion":"REACCIÓN ADVERSA A VACUNA VIRAL"
  },
  {
    "codigo":1080711000119107,
    "descripcion":"LIPOSARCOMA PRIMARIO DE PARTES BLANDAS DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":242997001,
    "descripcion":"LESIÓN POR FUEGO DE BOMBA INCENDIARIA"
  },
  {
    "codigo":275765006,
    "descripcion":"PIOCITOS EN ORINA"
  },
  {
    "codigo":110090000,
    "descripcion":"LACERACIÓN SIMPLE CONTAMINADA DEL PISO DE LA BOCA"
  },
  {
    "codigo":208394006,
    "descripcion":"FRACTURA NO EXPUESTA DE HUESO METACARPIANO"
  },
  {
    "codigo":403167001,
    "descripcion":"PROTOTECOSIS DE LA PIEL"
  },
  {
    "codigo":1255135001,
    "descripcion":"QUEMADURA QUÍMICA DE ESPESOR PARCIAL DE PIE"
  },
  {
    "codigo":763615003,
    "descripcion":"SÍNDROME DE ANOMALÍA DEL CAYADO AÓRTICO, DISMORFISMO FACIAL Y DISCAPACIDAD INTELECTUAL"
  },
  {
    "codigo":304863007,
    "descripcion":"RELACIÓN DE POSICIÓN ESQUIZO-PARANOIDE"
  },
  {
    "codigo":401332000,
    "descripcion":"CONTROL DE ENFERMEDAD CORONARIA REALIZADO"
  },
  {
    "codigo":40884005,
    "descripcion":"DERRAME ARTICULAR DE LA REGIÓN DEL HOMBRO"
  },
  {
    "codigo":8116006,
    "descripcion":"FENOTIPO"
  },
  {
    "codigo":204724007,
    "descripcion":"ESTENOSIS CONGÉNITA DEL ANO CON FÍSTULA"
  },
  {
    "codigo":366729005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA CAMINAR PENDIENTE ARRIBA"
  },
  {
    "codigo":170121005,
    "descripcion":"EXAMEN DEL NIÑO A LAS SEIS SEMANAS: ANORMAL - EN TRATAMIENTO"
  },
  {
    "codigo":432265007,
    "descripcion":"RECHAZO DE INJERTO DE CÓRNEA LUEGO DE QUERATOPLASTIA PENETRANTE"
  },
  {
    "codigo":299358000,
    "descripcion":"AMPLITUD DE ROTACIÓN INTERNA PASIVA DE LA RODILLA AUMENTADA"
  },
  {
    "codigo":364894001,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA MOVER EL BRAZO"
  },
  {
    "codigo":290491000119102,
    "descripcion":"HEMIPLEJÍA ESPÁSTICA DE LADO DERECHO NO DOMINANTE"
  },
  {
    "codigo":15636001000119108,
    "descripcion":"EPICONDILITIS DE AMBOS HÚMEROS"
  },
  {
    "codigo":1251465007,
    "descripcion":"METÁSTASIS DE OSTEOSARCOMA EXTRAESQUELÉTICO"
  },
  {
    "codigo":399497006,
    "descripcion":"HIPERPLASIA COMPLEJA ENDOMETRIAL ATÍPICA"
  },
  {
    "codigo":201054008,
    "descripcion":"QUERATODERMIA CLIMATÉRICA"
  },
  {
    "codigo":363059001,
    "descripcion":"TRASTORNO DEGENERATIVO DEL SISTEMA MUSCULOESQUELÉTICO"
  },
  {
    "codigo":37214009,
    "descripcion":"EXOTROPÍA ALTERNANTE"
  },
  {
    "codigo":16015431000119100,
    "descripcion":"TRASTORNO ÓSEO DE ARTICULACIÓN DE TOBILLO DERECHO POSTERIOR A POLIOMIELITIS"
  },
  {
    "codigo":16038471000119100,
    "descripcion":"OSTEOPATÍA DE FÉMUR IZQUIERDO POSTERIOR A POLIOMIELITIS"
  },
  {
    "codigo":317511000119102,
    "descripcion":"TENDINITIS DE TENDÓN ROTULIANO IZQUIERDO"
  },
  {
    "codigo":1077831000119102,
    "descripcion":"OSTEONECROSIS DE CÓNDILO FEMORAL INTERNO DERECHO"
  },
  {
    "codigo":16028231000119104,
    "descripcion":"EXOSTOSIS DE PIE DERECHO"
  },
  {
    "codigo":340551000119105,
    "descripcion":"ATROFIA DE DISCO ÓPTICO DE OJO IZQUIERDO DEBIDA A GLAUCOMA"
  },
  {
    "codigo":16010311000119105,
    "descripcion":"CLIC DE CADERA IZQUIERDA"
  },
  {
    "codigo":10626631000119104,
    "descripcion":"CARBUNCO DE EXTREMIDAD SUPERIOR DERECHA"
  },
  {
    "codigo":368711000119106,
    "descripcion":"RETINOPATÍA NO PROLIFERATIVA LEVE DEBIDA A DIABETES MELLITUS SECUNDARIA"
  },
  {
    "codigo":10631751000119106,
    "descripcion":"ONIQUIA DE PULGAR IZQUIERDO"
  },
  {
    "codigo":678471000119107,
    "descripcion":"TRASTORNO DE DIRECCIÓN DE FLUJO DE HUMOR ACUOSO DE OJO IZQUIERDO"
  },
  {
    "codigo":291911000119107,
    "descripcion":"NEUROMA DE EXTREMIDAD SUPERIOR DERECHA POSTERIOR A CIRUGÍA"
  },
  {
    "codigo":286174791000119107,
    "descripcion":"ÚLCERA VENOSA DE PANTORRILLA IZQUIERDA"
  },
  {
    "codigo":1075271000119108,
    "descripcion":"DEFORMIDAD EN VALGO ADQUIRIDA DE ARTICULACIÓN DE REGIÓN DE MUÑECA DERECHA"
  },
  {
    "codigo":16376391000119106,
    "descripcion":"NEUROPATÍA ÓPTICA ISQUÉMICA ANTERIOR ARTERÍTICA DE OJO DERECHO"
  },
  {
    "codigo":16007751000119109,
    "descripcion":"TROMBOSIS DE ARTERIA DE EXTREMIDAD SUPERIOR DERECHA"
  },
  {
    "codigo":10682951000119109,
    "descripcion":"TUMEFACCIÓN DEL TEJIDO CELULAR SUBCUTÁNEO DE LA PIERNA DERECHA"
  },
  {
    "codigo":168747591000119109,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DEBIDO A EMBOLIA DE AMBAS ARTERIAS CEREBRALES POSTERIORES"
  },
  {
    "codigo":426760008,
    "descripcion":"TRASTORNO DE HIPERSENSIBILIDAD TARDÍA"
  },
  {
    "codigo":719837003,
    "descripcion":"CONDRODISPLASIA DOMINANTE LIGADA AL CROMOSOMA X TIPO CHASSAING LACOMBE"
  },
  {
    "codigo":293853006,
    "descripcion":"ALERGIA A MAPROTILINA"
  },
  {
    "codigo":776009,
    "descripcion":"OCLUSIÓN PARCIAL DE ARTERIA DE LA RETINA"
  },
  {
    "codigo":95410001,
    "descripcion":"TENDINITIS RETROFARÍNGEA"
  },
  {
    "codigo":424925008,
    "descripcion":"DEFICIENCIA DE ENZIMA CYP2E1 DE CITOCROMO P450"
  },
  {
    "codigo":228317009,
    "descripcion":"BORRACHERA QUE EXCEDE CANTIDADES SEGURAS"
  },
  {
    "codigo":93575000,
    "descripcion":"OSIFICACIÓN INCOMPLETA DE CENTRO DE VÉRTEBRA SACRA"
  },
  {
    "codigo":29874009,
    "descripcion":"CÓLICO DEL APÉNDICE"
  },
  {
    "codigo":28039004,
    "descripcion":"SENO PILONIDAL DEL BARBERO"
  },
  {
    "codigo":60807005,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN LA REGIÓN DE LABIO, CON INFECCIÓN"
  },
  {
    "codigo":880007007,
    "descripcion":"ANOMALÍA ADQUIRIDA DE VÁLVULA AURICULOVENTRICULAR DERECHA POSTERIOR A REPARACIÓN DE VENTRÍCULO CON DOBLE TRACTO DE ENTRADA"
  },
  {
    "codigo":58972000,
    "descripcion":"GOTEO"
  },
  {
    "codigo":124508001,
    "descripcion":"DEFICIENCIA DE W - AMIDASA"
  },
  {
    "codigo":714332003,
    "descripcion":"ALERGIA A BANANA"
  },
  {
    "codigo":345941000119106,
    "descripcion":"DESGARRO RETINIANO GIGANTE DE AMBOS OJOS"
  },
  {
    "codigo":253745002,
    "descripcion":"DISPLASIA DE PULMÓN"
  },
  {
    "codigo":384817004,
    "descripcion":"INVASIÓN TUMORAL DE PLEURA VISCERAL INDETERMINADA"
  },
  {
    "codigo":188209005,
    "descripcion":"NEOPLASIA MALIGNA DE LA BÓVEDA VAGINAL"
  },
  {
    "codigo":155441006,
    "descripcion":"POLIARTERITIS NUDOSA"
  },
  {
    "codigo":24369008,
    "descripcion":"SARCOIDOSIS PULMONAR"
  },
  {
    "codigo":712497009,
    "descripcion":"GANGRENA DEBIDA A INSUFICIENCIA ARTERIAL"
  },
  {
    "codigo":1269553009,
    "descripcion":"CON MAYOR RIESGO DE TRASTORNO PERINATAL"
  },
  {
    "codigo":415750005,
    "descripcion":"ESTADO DE INMUNIZACIÓN PARA VIAJE"
  },
  {
    "codigo":10641391000119104,
    "descripcion":"ÚLCERA CRÓNICA DE PIEL DE PIERNA"
  },
  {
    "codigo":53467004,
    "descripcion":"TRASTORNO DE ANSIEDAD EN LA NIÑEZ"
  },
  {
    "codigo":282843003,
    "descripcion":"INCAPAZ DE MOVERSE DENTRO DE UNA POSICIÓN"
  },
  {
    "codigo":1003739006,
    "descripcion":"CONTRACTURA EN FLEXIÓN DE ARTICULACIÓN INTERFALÁNGICA DISTAL DE DEDO ANULAR"
  },
  {
    "codigo":444848005,
    "descripcion":"EDEMA DE ESPALDA"
  },
  {
    "codigo":1264048006,
    "descripcion":"TRASTORNO NEONATAL CAUSADO POR SUSTANCIA TRANSMITIDA POR LECHE MATERNA"
  },
  {
    "codigo":129161000119100,
    "descripcion":"ENFERMEDAD RENAL CRÓNICA DEBIDA A HIPERTENSIÓN, ESTADIO 5"
  },
  {
    "codigo":1231280005,
    "descripcion":"ENDOFTALMITIS ENDÓGENA CAUSADA POR BACTERIA"
  },
  {
    "codigo":17029006,
    "descripcion":"SENSACIÓN DE DESESPERANZA"
  },
  {
    "codigo":1260378000,
    "descripcion":"DISTONÍA DEBIDA A ACIDURIA GLUTÁRICA"
  },
  {
    "codigo":1293146006,
    "descripcion":"ADENOCARCINOMA DE GLÁNDULAS ANOGENITALES DE TIPO MAMARIO"
  },
  {
    "codigo":275503004,
    "descripcion":"NEUMATOCELE A TENSIÓN"
  },
  {
    "codigo":373807007,
    "descripcion":"GRADO 4 DE LA ESCALA DEL ESTADO FUNCIONAL DE LA OMS"
  },
  {
    "codigo":406575008,
    "descripcion":"INFECCIÓN CAUSADA POR ENTEROCOCO RESISTENTE A VANCOMICINA"
  },
  {
    "codigo":78895009,
    "descripcion":"NEUMONÍA CONGÉNITA"
  },
  {
    "codigo":109828002,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE CONDUCTO DE GLÁNDULA SALIVAL"
  },
  {
    "codigo":699652003,
    "descripcion":"IRRITACIÓN DE TEJIDO PRESACRO POR CONTENIDO DE VÍSCERA ROTA"
  },
  {
    "codigo":371972005,
    "descripcion":"NEOPLASIA MALIGNA DEL CUERPO UTERINO"
  },
  {
    "codigo":402905000,
    "descripcion":"VERRUGA VIRAL EN NARIZ"
  },
  {
    "codigo":763353000,
    "descripcion":"SÍNDROME CEREBROFACIOARTICULAR"
  },
  {
    "codigo":765188009,
    "descripcion":"INMUNODEFICIENCIA COMBINADA SEVERA DEBIDA A DEFICIENCIA DE LOS GENES ACTIVADORES DE LA RECOMBINACIÓN 1 Y\/O 2"
  },
  {
    "codigo":239065004,
    "descripcion":"QUERATÓLISIS EXFOLIATIVA"
  },
  {
    "codigo":1254873008,
    "descripcion":"TELANGIECTASIA FOTODISTRIBUIDA"
  },
  {
    "codigo":237230004,
    "descripcion":"UREMIA EN EL EMBARAZO SIN HIPERTENSIÓN"
  },
  {
    "codigo":106158005,
    "descripcion":"HALLAZGO EN EL OCTAVO PAR CRANEAL"
  },
  {
    "codigo":73390009,
    "descripcion":"ENDOFLEBITIS DE SENO VENOSO CAVERNOSO"
  },
  {
    "codigo":300931007,
    "descripcion":"QUISTE PERIAMIGDALINO"
  },
  {
    "codigo":268163008,
    "descripcion":"PTOSIS CONGÉNITA DE PÁRPADO SUPERIOR"
  },
  {
    "codigo":71555008,
    "descripcion":"FRACTURA NO EXPUESTA DE CÚBITO"
  },
  {
    "codigo":4184009,
    "descripcion":"ANOMALÍA CONGÉNITA DE GLÁNDULA ENDOCRINA"
  },
  {
    "codigo":461101001,
    "descripcion":"ORIGEN ANÓMALO DE CONDUCTO ARTERIOSO EN AORTA DESCENDENTE DISTAL"
  },
  {
    "codigo":321981000119101,
    "descripcion":"OSTEOMIELITIS SUBAGUDA DE MANO IZQUIERDA"
  },
  {
    "codigo":16077091000119107,
    "descripcion":"DEPENDENCIA DE TABACO CAUSADA POR CIGARRILLOS"
  },
  {
    "codigo":262658000,
    "descripcion":"LESIÓN PENETRANTE DE ENCÍAS"
  },
  {
    "codigo":15968701000119102,
    "descripcion":"SÍNDROME DE ABERTURA DE SALIDA TORÁCICA NEUROGÉNICO DE PLEXO BRAQUIAL DERECHO"
  },
  {
    "codigo":35117008,
    "descripcion":"TUBERCULOSIS DE INTESTINO DELGADO"
  },
  {
    "codigo":1149229008,
    "descripcion":"INTOXICACIÓN POR ÁCIDO FLUOROACÉTICO"
  },
  {
    "codigo":721410006,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO FRÉNICO"
  },
  {
    "codigo":66050007,
    "descripcion":"CUERPO EXTRAÑO EN EL SENO NASAL"
  },
  {
    "codigo":293591000,
    "descripcion":"ALERGIA A DEXTROMORAMIDA"
  },
  {
    "codigo":129751002,
    "descripcion":"CALCIFICACIÓN RADIOGRÁFICA EN CÁSCARA DE HUEVO"
  },
  {
    "codigo":719575008,
    "descripcion":"SÍNDROME DE MICRODELECIÓN 15Q14"
  },
  {
    "codigo":95148002,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL NERVIO TRIGÉMINO"
  },
  {
    "codigo":160684002,
    "descripcion":"LIMITADO A UNA SILLA"
  },
  {
    "codigo":226220005,
    "descripcion":"DIETA LIMPIA"
  },
  {
    "codigo":71741000112102,
    "descripcion":"LESIÓN FARÍNGEA"
  },
  {
    "codigo":93313001,
    "descripcion":"POSICIÓN ANÓMALA CONGÉNITA DEL CARPO"
  },
  {
    "codigo":224385001,
    "descripcion":"REGISTRADO CON OFICIAL DE UBICACIÓN LABORAL"
  },
  {
    "codigo":295511000119101,
    "descripcion":"CALCIFICACIÓN Y OSIFICACIÓN DE MÚSCULO DE ANTEBRAZO DEBIDA A QUEMADURA"
  },
  {
    "codigo":715905006,
    "descripcion":"POLIMICROGIRIA UNILATERAL"
  },
  {
    "codigo":289921009,
    "descripcion":"AUSENCIA ADQUIRIDA DE OVARIO"
  },
  {
    "codigo":91478007,
    "descripcion":"HIPERPARATIROIDISMO SECUNDARIO"
  },
  {
    "codigo":124246007,
    "descripcion":"DEFICIENCIA DE GLICINA FORMIMINOTRANSFERASA"
  },
  {
    "codigo":25942009,
    "descripcion":"FIBROSIS DEL PÁNCREAS"
  },
  {
    "codigo":58710009,
    "descripcion":"PERITONITIS NEUMOCÓCICA"
  },
  {
    "codigo":253483002,
    "descripcion":"ANOMALÍA DE LA VÁLVULA AURICULOVENTRICULAR IZQUIERDA EN VENTRÍCULO CON DOBLE TRACTO DE ENTRADA"
  },
  {
    "codigo":1303894009,
    "descripcion":"GLAUCOMA DE ÁNGULO ABIERTO BILATERAL DEBIDO A DESPRENDIMIENTO DE RETINA"
  },
  {
    "codigo":187947006,
    "descripcion":"NEOPLASIA MALIGNA DEL TERCER METACARPIANO"
  },
  {
    "codigo":16024151000119105,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DEBIDO A OCLUSIÓN DE ARTERIA CEREBELOSA IZQUIERDA"
  },
  {
    "codigo":55040001,
    "descripcion":"PELVIS COXÁLGICA"
  },
  {
    "codigo":286251009,
    "descripcion":"NO USA TONOS VOCALES Y UNIDADES FONÉTICAS"
  },
  {
    "codigo":284416001,
    "descripcion":"INCAPAZ DE MANTENER EL EQUILIBRIO AL ALCANZAR ALGO"
  },
  {
    "codigo":251648004,
    "descripcion":"CRISTALIZACIÓN DEL MOCO CERVICAL EN HOJA DE HELECHO"
  },
  {
    "codigo":184277000,
    "descripcion":"CARTA DE ALTA HOSPITALARIA POR DEFUNCIÓN RECIBIDA"
  },
  {
    "codigo":448256009,
    "descripcion":"ODONTOMA DE MAXILAR SUPERIOR"
  },
  {
    "codigo":249813003,
    "descripcion":"TUMORACIÓN EN LA REGIÓN POSTERIOR DEL TALÓN"
  },
  {
    "codigo":1088241000119102,
    "descripcion":"OTITIS MEDIA ADHESIVA DEL OÍDO IZQUIERDO"
  },
  {
    "codigo":1263786003,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS BASALOIDE DE NASOFARINGE METASTÁSICO"
  },
  {
    "codigo":84138006,
    "descripcion":"APLASTAMIENTO VERTEBRAL"
  },
  {
    "codigo":247978008,
    "descripcion":"HACE COMENTARIOS EN FORMA IMPULSIVA"
  },
  {
    "codigo":770431001,
    "descripcion":"ENCEFALOPATÍA EPILÉPTICA DE INICIO TEMPRANO Y DISCAPACIDAD INTELECTUAL POR MUTACIÓN EN GRIN2A"
  },
  {
    "codigo":82303003,
    "descripcion":"EVALUACIÓN DE DISCAPACIDAD: 95%"
  },
  {
    "codigo":213375005,
    "descripcion":"LESIONES POR APLASTAMIENTO DEL TÓRAX CON EL EL ABDOMEN, REGIÓN LUMBAR Y PELVIS CON UNA DE LAS\/LAS EXTREMIDADES"
  },
  {
    "codigo":1260116000,
    "descripcion":"SARCOMA PRIMARIO MALIGNO DE ESTROMA DE ENDOMETRIO"
  },
  {
    "codigo":735828002,
    "descripcion":"RUPTURA TRAUMÁTICA DE PLACA PALMAR DE ARTICULACIÓN METACARPOFALÁNGICA DE DEDO DE LA MANO"
  },
  {
    "codigo":703060007,
    "descripcion":"PREVOTELLA BUCCALIS O PREVOTELLA ORALIS"
  },
  {
    "codigo":766761000,
    "descripcion":"FISURA DE PALADAR Y ANQUILOGLOSIA LIGADAS AL CROMOSOMA X"
  },
  {
    "codigo":309844009,
    "descripcion":"BOLSA PARA ESTOMA URINARIO CAMBIADA"
  },
  {
    "codigo":78633001,
    "descripcion":"PROCESOS DEL PENSAMIENTO ALTERADOS"
  },
  {
    "codigo":45865005,
    "descripcion":"CUERPO EXTRAÑO EN EL ÁRBOL TRAQUEOBRONQUIAL"
  },
  {
    "codigo":15670001000119108,
    "descripcion":"LUXACIÓN CONGÉNITA DE CABEZA DE RADIO DERECHO"
  },
  {
    "codigo":209705007,
    "descripcion":"SECCIÓN EXPUESTA DE LIGAMENTO CALCANEOPERONEO"
  },
  {
    "codigo":240638001,
    "descripcion":"RECIDIVA DE LEISHMANIASIS"
  },
  {
    "codigo":699390004,
    "descripcion":"ECO EN EL OÍDO"
  },
  {
    "codigo":109566005,
    "descripcion":"CARIES DENTAL ASOCIADA CON HIPOPLASIA DEL ESMALTE"
  },
  {
    "codigo":402643000,
    "descripcion":"ERUPCIÓN ACNEIFORME CAUSADA POR SUSTANCIA QUÍMICA"
  },
  {
    "codigo":238803001,
    "descripcion":"LINFANGIOMA BUCAL"
  },
  {
    "codigo":304339009,
    "descripcion":"AMPLITUD DE MOVIMIENTO DE DEDO DEL PIE DISMINUIDA"
  },
  {
    "codigo":449544002,
    "descripcion":"DEFICIENCIA DE CÚSPIDE DE VÁLVULA TRONCAL"
  },
  {
    "codigo":366205004,
    "descripcion":"HALLAZGO RELACIONADO CON LA PERMEABILIDAD DE STENT CORONARIO"
  },
  {
    "codigo":11848741000119102,
    "descripcion":"CONTUSIÓN PERIORBITARIA IZQUIERDA"
  },
  {
    "codigo":235133009,
    "descripcion":"TRASTORNO DE CONDUCTO SALIVAL"
  },
  {
    "codigo":397138000,
    "descripcion":"EVALUACIÓN MAMOGRÁFICA (CATEGORÍA 0) - REQUIERE EVALUACIÓN ADICIONAL CON IMÁGENES"
  },
  {
    "codigo":298834004,
    "descripcion":"AMPLITUD DE ROTACIÓN EXTERNA ACTIVA DE ARTICULACIÓN DE HOMBRO, AUMENTADA"
  },
  {
    "codigo":167762005,
    "descripcion":"EXAMEN DE SEMEN: FERTILIDAD MODERADA"
  },
  {
    "codigo":724818008,
    "descripcion":"MONOPARESIA FUNCIONAL"
  },
  {
    "codigo":2087000,
    "descripcion":"NOCARDIASIS PULMONAR"
  },
  {
    "codigo":165927006,
    "descripcion":"CÉLULAS LE, PRESENTES"
  },
  {
    "codigo":722983008,
    "descripcion":"CEFALEA DEBIDA A LESIÓN TRAUMÁTICA DE CABEZA Y CUELLO"
  },
  {
    "codigo":33020000,
    "descripcion":"SÍNDROME DEL ANTRO RETENIDO"
  },
  {
    "codigo":721148005,
    "descripcion":"DISPLASIA DE CADERA, TIPO BEUKES"
  },
  {
    "codigo":229628006,
    "descripcion":"TARTAMUDEO ENCUBIERTO"
  },
  {
    "codigo":16000191000119101,
    "descripcion":"SÍNDROME BILATERAL DE IRIS FLÁCIDO INTRAOPERATORIO"
  },
  {
    "codigo":10675391000119101,
    "descripcion":"ASMA PERSISTENTE SEVERA CONTROLADA"
  },
  {
    "codigo":195025008,
    "descripcion":"GLUCOGENOSIS CARDÍACA"
  },
  {
    "codigo":29350000,
    "descripcion":"OTITIS MEDIA CATARRAL"
  },
  {
    "codigo":422566002,
    "descripcion":"LO DEJARON SOLO INAPROPIADAMENTE"
  },
  {
    "codigo":11986111000119102,
    "descripcion":"QUEMADURA EPIDÉRMICA DE DORSO DE MANO IZQUIERDA"
  },
  {
    "codigo":94886004,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE YEYUNO"
  },
  {
    "codigo":193190005,
    "descripcion":"POLINEUROPATÍA EN EL HERPES ZÓSTER"
  },
  {
    "codigo":1208998007,
    "descripcion":"SÍNDROME DE RETRASO MOTOR Y DE LA ADQUISICIÓN DEL HABLA, DISMORFIA FACIAL, ANOMALÍAS DIGITALES, DEFECTO CARDÍACO ASOCIADO AL GEN FACTOR 7 ASOCIADO A RECEPTOR DE FACTOR DE NECROSIS TUMORAL"
  },
  {
    "codigo":783014007,
    "descripcion":"LIPODISTROFIA LOCALIZADA INDUCIDA POR PANICULITIS"
  },
  {
    "codigo":1141627001,
    "descripcion":"CARCINOMA PULMONAR NO MICROCÍTICO CON FUSIÓN DEL GEN DE LA NEURREGULINA 1"
  },
  {
    "codigo":289659004,
    "descripcion":"HALLAZGO RELACIONADO CON LAS PROPORCIONES UTERINAS"
  },
  {
    "codigo":224123004,
    "descripcion":"FAMILIA CON UN NIÑO MENOR DE UN AÑO"
  },
  {
    "codigo":93051009,
    "descripcion":"DILATACIÓN CONGÉNITA DE LA AURÍCULA"
  },
  {
    "codigo":123984002,
    "descripcion":"CUERPOS CETÓNICOS POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":253221000,
    "descripcion":"LENTICONO"
  },
  {
    "codigo":255056009,
    "descripcion":"NEOPLASIA MALIGNA DE CABEZA Y\/O CUELLO"
  },
  {
    "codigo":187685006,
    "descripcion":"NEOPLASIA MALIGNA DE LA REGIÓN DE UNIÓN DE LA EPIGLOTIS"
  },
  {
    "codigo":284154007,
    "descripcion":"DIFICULTAD PARA MOVER LA PIERNA"
  },
  {
    "codigo":446159001,
    "descripcion":"INTOXICACIÓN POR MACRÓLIDO"
  },
  {
    "codigo":741071004,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO DE CABEZA Y\/O CUELLO"
  },
  {
    "codigo":1263524000,
    "descripcion":"DISTONÍA DEBIDA A ENFERMEDAD DE WILSON"
  },
  {
    "codigo":870308001,
    "descripcion":"TRASTORNO GENERALIZADO DEL DESARROLLO CON RETRASO DEL DESARROLLO COGNITIVO Y ALTERACIÓN COMPLETA DEL LENGUAJE FUNCIONAL"
  },
  {
    "codigo":282319008,
    "descripcion":"SE PARA SOLO"
  },
  {
    "codigo":247716006,
    "descripcion":"PERCEPCIÓN VISUAL AUMENTADA"
  },
  {
    "codigo":409721000,
    "descripcion":"HALLAZGO RELACIONADO CON ESTADIO DEL SISTEMA INTERNACIONAL DE ESTADIFICACIÓN DE NEUROBLASTOMA"
  },
  {
    "codigo":51108008,
    "descripcion":"HEMATOCELE DEL LIGAMENTO ANCHO"
  },
  {
    "codigo":444324009,
    "descripcion":"SONDA DE VÍA URINARIA SALIDA"
  },
  {
    "codigo":278649002,
    "descripcion":"CAÍDA DE BANDA ORTODÓNCICA"
  },
  {
    "codigo":735566005,
    "descripcion":"RUPTURA DE ARTERIA CORONARIA CONCOMITANTE CON ANEURISMA DE ARTERIA CORONARIA Y DEBIDO A ÉL"
  },
  {
    "codigo":473422006,
    "descripcion":"SORDERA DE OÍDO IZQUIERDO"
  },
  {
    "codigo":240376003,
    "descripcion":"TUBERCULOSIS DEL TRACTO GASTROINTESTINAL"
  },
  {
    "codigo":300531000119106,
    "descripcion":"TRASTORNO DE TENDÓN DE PIERNA IZQUIERDA"
  },
  {
    "codigo":238541000,
    "descripcion":"DERMATITIS ATÓPICA DE AMBAS MANOS"
  },
  {
    "codigo":109304009,
    "descripcion":"OSTEOMIELITIS DE HUESO FRONTAL"
  },
  {
    "codigo":402381001,
    "descripcion":"URTICARIA EPISÓDICA IDIOPÁTICA"
  },
  {
    "codigo":50040121000188107,
    "descripcion":"GRAN VOLUMEN DE ORINA RESIDUAL POSMICCIONAL"
  },
  {
    "codigo":1156045008,
    "descripcion":"FENITOÍNA SÉRICA POR DEBAJO DEL RANGO TERAPÉUTICO"
  },
  {
    "codigo":105634001,
    "descripcion":"ENFERMEDAD CAUSADA POR REOVIRIDAE"
  },
  {
    "codigo":236706006,
    "descripcion":"ESQUISTOSOMIASIS URINARIA"
  },
  {
    "codigo":1186978009,
    "descripcion":"CAPACIDAD DE DIFUSIÓN PULMONAR DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":365943002,
    "descripcion":"PERCENTIL DE PERÍMETRO CEFÁLICO INFANTIL - HALLAZGO"
  },
  {
    "codigo":267639001,
    "descripcion":"PIGMENTACIÓN CORNEAL POSTERIOR"
  },
  {
    "codigo":72866009,
    "descripcion":"VENAS VARICOSAS DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":890231006,
    "descripcion":"ALERGIA A POLIESTRADIOL"
  },
  {
    "codigo":726391008,
    "descripcion":"DELECIÓN DE PARTE DEL CROMOSOMA 18"
  },
  {
    "codigo":298572003,
    "descripcion":"SIN AMPLITUD DE ROTACIÓN PASIVA HACIA LA IZQUIERDA DE LA COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":724556004,
    "descripcion":"ANEMIA POR DEFICIENCIA DE HIERRO DEBIDA A PÉRDIDA DE SANGRE"
  },
  {
    "codigo":396876004,
    "descripcion":"TUMOR QUÍSTICO, TOTALMENTE ENCAPSULADO"
  },
  {
    "codigo":36428009,
    "descripcion":"EDAD GESTACIONAL, 42 SEMANAS"
  },
  {
    "codigo":722721004,
    "descripcion":"SÍNDROME URÉMICO HEMOLÍTICO FAMILIAR"
  },
  {
    "codigo":131062000,
    "descripcion":"NIVEL DE ESTRONA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":294902001,
    "descripcion":"ALERGIA A SULFATO FERROSO"
  },
  {
    "codigo":32758004,
    "descripcion":"BLOQUEO DE RAMA DERECHA CON BLOQUEO DE RAMA IZQUIERDA PRINCIPAL DEL HAZ DE HIS"
  },
  {
    "codigo":65526007,
    "descripcion":"FROTE PLEUROPERICÁRDICO"
  },
  {
    "codigo":63691004,
    "descripcion":"DIENTE EVAGINADO"
  },
  {
    "codigo":291232000,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR REMOXIPRIDA"
  },
  {
    "codigo":94624001,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL MESENTERIO"
  },
  {
    "codigo":782752005,
    "descripcion":"SÍNDROME DE NEUROPATÍA PERIFÉRICA, MIOPATÍA, DISFONÍA Y PÉRDIDA DE LA AUDICIÓN"
  },
  {
    "codigo":15704001000119100,
    "descripcion":"CONTRACTURA DE MÚSCULO GEMELO DERECHO DEBIDA A PARÁLISIS"
  },
  {
    "codigo":717216007,
    "descripcion":"STREPTOCOCCUS PNEUMONIAE O STREPTOCOCCUS DEL GRUPO VIRIDANS"
  },
  {
    "codigo":92789002,
    "descripcion":"CARCINOMA IN SITU DEL TRACTO UVEAL"
  },
  {
    "codigo":27253007,
    "descripcion":"MARCHA EQUINA"
  },
  {
    "codigo":189258000,
    "descripcion":"CARCINOMA IN SITU DEL PLIEGUE ARITENOEPIGLÓTICO"
  },
  {
    "codigo":60021008,
    "descripcion":"MORTIERELOSIS"
  },
  {
    "codigo":25418001,
    "descripcion":"QUISTE PRIMORDIAL"
  },
  {
    "codigo":713546005,
    "descripcion":"ISOSPORIASIS CONCOMITANTE CON INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":123722006,
    "descripcion":"CITOPENIA SEVERA"
  },
  {
    "codigo":254794007,
    "descripcion":"ANGIOSARCOMA CUTÁNEO"
  },
  {
    "codigo":56351000,
    "descripcion":"CELULITIS DEL TALÓN"
  },
  {
    "codigo":303041000119104,
    "descripcion":"ARTROSIS DE PRIMERAS ARTICULACIONES CARPOMETACARPIANAS DE AMBAS MANOS"
  },
  {
    "codigo":1137695005,
    "descripcion":"FRACASO DE AUTOINJERTO DE ARTERIA PULMONAR"
  },
  {
    "codigo":185588000,
    "descripcion":"CRIBADO PARA DETECCIÓN DE ANTICUERPOS ANTIRRUBEÓLICOS - INFORMADO COMO SIN INMUNIDAD"
  },
  {
    "codigo":87284002,
    "descripcion":"EFECTOS DE LA ALTURA"
  },
  {
    "codigo":218356002,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR SULFAMETOXAZOL"
  },
  {
    "codigo":1332468003,
    "descripcion":"HIPERTENSIÓN EN ENFERMEDAD RENAL CRÓNICA EN ESTADIO 4 DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":447732007,
    "descripcion":"FIBROMA DE PARED TORÁCICA"
  },
  {
    "codigo":251124007,
    "descripcion":"BLOQUEO INCOMPLETO DE LA RAMA DERECHA DEL HAZ DE HIS"
  },
  {
    "codigo":183753001,
    "descripcion":"CONSULTA DOMICILIARIA DE CIRUGÍA GENERAL, REALIZADA"
  },
  {
    "codigo":54516009,
    "descripcion":"PASAJERO EN ACCIDENTE DE EMBARCACIÓN"
  },
  {
    "codigo":52681002,
    "descripcion":"FORÚNCULO DE REGIÓN TEMPORAL"
  },
  {
    "codigo":139201000119107,
    "descripcion":"SÍNDROME DE RESPUESTA INFLAMATORIA SISTÉMICA NO INFECCIOSA SIN FALLA ORGÁNICA AGUDA"
  },
  {
    "codigo":249289004,
    "descripcion":"TIENE QUE ORINAR REITERADAMENTE PARA VACIAR VEJIGA URINARIA"
  },
  {
    "codigo":413129005,
    "descripcion":"SE SOLICITÓ AL PACIENTE QUE CONCERTARA UNA CITA"
  },
  {
    "codigo":445897006,
    "descripcion":"LESIÓN TRANSVERSAL INCOMPLETA DE MÉDULA ESPINAL DORSAL"
  },
  {
    "codigo":168648641000119107,
    "descripcion":"SINOSTOSIS RADIOCUBITAL DE ANTEBRAZO DERECHO POSTERIOR A LESIÓN TRAUMÁTICA"
  },
  {
    "codigo":773577009,
    "descripcion":"SÍNDROME DE DISQUERATOSIS CORNEAL INTRAEPITELIAL, HIPERQUERATOSIS PALMOPLANTAR Y DISQUERATOSIS LARÍNGEA"
  },
  {
    "codigo":216521009,
    "descripcion":"INTOXICACIÓN ACCIDENTAL CAUSADA POR FLUFENAZINA"
  },
  {
    "codigo":1197726006,
    "descripcion":"COLITIS NO INFECCIOSA DEBIDA A ENFERMEDAD INJERTO CONTRA HUÉSPED"
  },
  {
    "codigo":50846009,
    "descripcion":"APENDICITIS GANGRENOSA AGUDA"
  },
  {
    "codigo":737139003,
    "descripcion":"CHASQUIDO DE ARTICULACIÓN TEMPOROMANDIBULAR IZQUIERDA DURANTE LA APERTURA"
  },
  {
    "codigo":49011004,
    "descripcion":"LESIÓN TRAUMÁTICA INTERNA DE ÓRGANO ABDOMINAL"
  },
  {
    "codigo":1163123004,
    "descripcion":"COLITIS POR SHIGELLA BOYDII"
  },
  {
    "codigo":704371007,
    "descripcion":"ALTERACIÓN DEL DESARROLLO NEONATAL"
  },
  {
    "codigo":1259592000,
    "descripcion":"POROCARCINOMA ECRINO PRIMARIO DE PIEL"
  },
  {
    "codigo":473160008,
    "descripcion":"MIGRACIÓN DE SONDA NASOGÁSTRICA"
  },
  {
    "codigo":276552008,
    "descripcion":"DAÑO HEPATOCELULAR PERINATAL"
  },
  {
    "codigo":733469003,
    "descripcion":"SÍNDROME DE MÁCULAS CUTÁNEAS HIPOMELANÓTICAS E HIPERMELANÓTICAS CONGÉNITAS HEREDITARIAS, RETRASO DEL CRECIMIENTO Y DISCAPACIDAD INTELECTUAL"
  },
  {
    "codigo":241949004,
    "descripcion":"ANAFILAXIS NO ALÉRGICA CAUSADA POR ASPIRINA"
  },
  {
    "codigo":373021005,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM CONFLUENTIS"
  },
  {
    "codigo":766237006,
    "descripcion":"DISOMÍA UNIPARENTAL MATERNA DEL CROMOSOMA 2"
  },
  {
    "codigo":209181007,
    "descripcion":"SÍNDROME MEDULAR POSTERIOR DE MÉDULA LUMBAR DEBIDO A SUBLUXACIÓN VERTEBRAL NO EXPUESTA DE COLUMNA LUMBAR"
  },
  {
    "codigo":403954003,
    "descripcion":"CARCINOMA ANEXIAL DE PIEL MIXTO, ECRINO\/PILAR"
  },
  {
    "codigo":240114004,
    "descripcion":"MIOSITIS POR CISTICERCOSIS"
  },
  {
    "codigo":305650007,
    "descripcion":"ATENDIDO POR UN NEURÓLOGO INFANTIL"
  },
  {
    "codigo":860871003,
    "descripcion":"FOLICULITIS EOSINOFÍLICA DEBIDA A INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":236444003,
    "descripcion":"NEFROCALCINOSIS MICROSCÓPICA"
  },
  {
    "codigo":7068004,
    "descripcion":"CARÚNCULA DE LABIO DE LA VAGINA"
  },
  {
    "codigo":301980006,
    "descripcion":"HALLAZGO RELACIONADO CON EL CAMPO VISUAL"
  },
  {
    "codigo":1285020006,
    "descripcion":"DISECCIÓN DE ARTERIA RADIAL"
  },
  {
    "codigo":201841000,
    "descripcion":"GONARTROSIS PRIMARIA, BILATERAL"
  },
  {
    "codigo":269212008,
    "descripcion":"ASTILLA DE PÁRPADOS Y REGIÓN PERIOCULAR"
  },
  {
    "codigo":300145002,
    "descripcion":"LESIÓN DE MEMBRANA TIMPÁNICA"
  },
  {
    "codigo":234609006,
    "descripcion":"DEFICIENCIA DEL COMPONENTE 5"
  },
  {
    "codigo":10627471000119102,
    "descripcion":"FORÚNCULO DE HOMBRO DERECHO"
  },
  {
    "codigo":1217649009,
    "descripcion":"HERNIA GRASA DE ÓRBITA DEBIDA A EXCESO DE PIEL DE PÁRPADO"
  },
  {
    "codigo":429382003,
    "descripcion":"CAPTACIÓN DEL TRAZADOR POR DEBAJO DEL DIAFRAGMA"
  },
  {
    "codigo":167238004,
    "descripcion":"ORINA TURBIA"
  },
  {
    "codigo":16034191000119103,
    "descripcion":"HIPERTROFIA DE HUESO DE AMBOS HÚMEROS"
  },
  {
    "codigo":3398004,
    "descripcion":"INTOXICACIÓN POR CADMIO"
  },
  {
    "codigo":1563006,
    "descripcion":"ENFERMEDAD POR DEFICIENCIA DE PROTEÍNA S"
  },
  {
    "codigo":1148443007,
    "descripcion":"HEMORRAGIA INTRACRANEAL POSQUIRÚRGICA"
  },
  {
    "codigo":722459008,
    "descripcion":"SÍNDROME DE HIPOGONADISMO HIPERGONADOTRÓFICO MASCULINO, DISCAPACIDAD INTELECTUAL Y ANOMALÍAS ESQUELÉTICAS"
  },
  {
    "codigo":427547007,
    "descripcion":"INFERTILIDAD FEMENINA DEBIDA A DISMINUCIÓN DE LA RESERVA OVÁRICA"
  },
  {
    "codigo":296475009,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE ISOTRETINOÍNA"
  },
  {
    "codigo":65264005,
    "descripcion":"CONSTRICCIÓN MACROMOLECULAR"
  },
  {
    "codigo":688681000119100,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE CUERPO DE LA LENGUA"
  },
  {
    "codigo":1179376009,
    "descripcion":"COMA MIXEDEMATOSO DEBIDO A HIPOTIROIDISMO SUBCLÍNICO"
  },
  {
    "codigo":292805004,
    "descripcion":"REACCIÓN ADVERSA AL TOLNAFTATO"
  },
  {
    "codigo":305551000119108,
    "descripcion":"CONTRACTURA DE ARTICULACIÓN DE CADERA DERECHA"
  },
  {
    "codigo":225434001,
    "descripcion":"NO SE RECONOCE"
  },
  {
    "codigo":28826002,
    "descripcion":"SIALOLITIASIS"
  },
  {
    "codigo":127130003,
    "descripcion":"LINFADENOPATÍA SUBPILÓRICA"
  },
  {
    "codigo":1306778002,
    "descripcion":"GLAUCOMA FACOMÓRFICO DE OJO DERECHO DEBIDO A TRASTORNO DE CRISTALINO"
  },
  {
    "codigo":94362005,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LOS LABIOS MENORES DE LA VULVA"
  },
  {
    "codigo":389274008,
    "descripcion":"OSTEÓLISIS CARPOTARSIANA Y FALÁNGICA DE WHYTE HEMINGWAY"
  },
  {
    "codigo":92527000,
    "descripcion":"CARCINOMA IN SITU DE LA GLÁNDULA SUPRARRENAL"
  },
  {
    "codigo":289135005,
    "descripcion":"DIFICULTAD PARA REALIZAR ACTIVIDADES PARA EL CUIDADO DEL PELO"
  },
  {
    "codigo":715119007,
    "descripcion":"SE TRANSFIERE DEL INODORO A LA SILLA"
  },
  {
    "codigo":1335876002,
    "descripcion":"ICTERICIA NEONATAL PRECOZ DEBIDA A FIBROSIS QUÍSTICA"
  },
  {
    "codigo":188996003,
    "descripcion":"LIPOMA DE ANTEBRAZO"
  },
  {
    "codigo":254532005,
    "descripcion":"TUMOR DE ÓRGANO DIGESTIVO"
  },
  {
    "codigo":1237572006,
    "descripcion":"VIVE EN HOGAR PARA PERSONAS CON DISCAPACIDAD INTELECTUAL"
  },
  {
    "codigo":418372008,
    "descripcion":"CARCINOMA ESCAMOCELULAR DE LA MEMBRANA MUCOSA DE LABIO INFERIOR"
  },
  {
    "codigo":285465002,
    "descripcion":"NO ABRE LA BOCA"
  },
  {
    "codigo":711449005,
    "descripcion":"ELECTROCARDIOGRAMA CON REGISTRO ELÉCTRICO DESPUÉS DE LA COLOCACIÓN DE MARCAPASOS TEMPORARIO"
  },
  {
    "codigo":1137433009,
    "descripcion":"ACEPTA ESTADO DE SALUD"
  },
  {
    "codigo":449305009,
    "descripcion":"NEUROPATÍA SENSITIVA PARANEOPLÁSICA"
  },
  {
    "codigo":283630005,
    "descripcion":"HERIDA POR PINCHAZO DE AGUJA EN EXTREMIDAD INFERIOR"
  },
  {
    "codigo":609475000,
    "descripcion":"INTERRUPCIÓN INDUCIDA DEL EMBARAZO COMPLICADA POR PERFORACIÓN DE INTESTINO"
  },
  {
    "codigo":871619002,
    "descripcion":"CIRROSIS HEPÁTICA DEBIDA A PROCEDIMIENTO CARDÍACO Y POSTERIOR A ÉL"
  },
  {
    "codigo":281795003,
    "descripcion":"AMÍGDALAS INFLAMADAS"
  },
  {
    "codigo":85187004,
    "descripcion":"TIMPANISMO DEL CIEGO"
  },
  {
    "codigo":1363139008,
    "descripcion":"ASTILLA EN VAGINA"
  },
  {
    "codigo":247192003,
    "descripcion":"LESIÓN CORIORRETINIANA EN SACABOCADOS"
  },
  {
    "codigo":105171000220101,
    "descripcion":"RESORCIÓN DENTAL EXTERNA PATOLÓGICA DEBIDA A DIENTE IMPACTADO"
  },
  {
    "codigo":50584008,
    "descripcion":"ENFERMEDAD DE FORDYCE"
  },
  {
    "codigo":11803331000119107,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN METACARPOFALÁNGICA DE DEDO ANULAR DE MANO DERECHA"
  },
  {
    "codigo":334531000119108,
    "descripcion":"TRASTORNO DE CÓRNEA DERECHA POSTERIOR A CIRUGÍA DE CATARATA"
  },
  {
    "codigo":276290001,
    "descripcion":"HABILIDADES MUSICALES AISLADAS"
  },
  {
    "codigo":866114005,
    "descripcion":"OPACIDADES LOCALIZADAS DE CATARATAS DEBIDAS A LESIÓN TRAUMÁTICA Y POSTERIOR A ELLA"
  },
  {
    "codigo":767810006,
    "descripcion":"HEPATITIS C CRÓNICA CAUSADA POR GENOTIPO 5 DE VIRUS HEPATITIS C"
  },
  {
    "codigo":1259330005,
    "descripcion":"CARCINOMA PRIMARIO DE AMÍGDALA LINGUAL"
  },
  {
    "codigo":46914009,
    "descripcion":"MEMBRANAS FETALES INTACTAS"
  },
  {
    "codigo":733207001,
    "descripcion":"NECROSIS DE COLGAJO MIOCUTÁNEO"
  },
  {
    "codigo":45079001,
    "descripcion":"POSICIÓN ACROMIOILÍACA IZQUIERDA ANTERIOR"
  },
  {
    "codigo":700439005,
    "descripcion":"OSTEOMIELITIS DE PORCIÓN MEDIA DEL PIE"
  },
  {
    "codigo":307223005,
    "descripcion":"TRASTORNO DE LA VENA PORTA"
  },
  {
    "codigo":208919005,
    "descripcion":"DESGARRO MENISCAL AGUDO, INTERNO, DESPRENDIMIENTO PERIFÉRICO"
  },
  {
    "codigo":308061000119105,
    "descripcion":"HIPERLAXITUD ARTICULAR DE CADERA DERECHA"
  },
  {
    "codigo":1255660002,
    "descripcion":"CARCINOMA DE CÉLULAS ESCAMOSAS DE SENO ESFENOIDAL"
  },
  {
    "codigo":403692004,
    "descripcion":"HIPOMELANOSIS POR CRIOTERAPIA"
  },
  {
    "codigo":11832311000119100,
    "descripcion":"LESIÓN TRAUMÁTICA DE VASO SANGUÍNEO DE DEDO MEÑIQUE DE MANO IZQUIERDA"
  },
  {
    "codigo":239852007,
    "descripcion":"TOFO POR COLESTEROL"
  },
  {
    "codigo":8641003,
    "descripcion":"HIPERSENSIBILIDAD TIPO JONES-MOTE"
  },
  {
    "codigo":74177004,
    "descripcion":"LUXACIONES EXPUESTAS MÚLTIPLES DEL DORSO"
  },
  {
    "codigo":762305005,
    "descripcion":"DEGENERACIÓN DE COLUMNA VERTEBRAL"
  },
  {
    "codigo":238017009,
    "descripcion":"TRASTORNO DEL METABOLISMO Y DEPÓSITO DE LÍPIDOS"
  },
  {
    "codigo":39574006,
    "descripcion":"HIPOPLASIA CONGÉNITA DEL ESTRATO GRANULAR INTERNO DEL CEREBELO"
  },
  {
    "codigo":398187000,
    "descripcion":"ENFERMEDAD DE CHARCOT-MARIE-TOOTH, TIPO II"
  },
  {
    "codigo":400022009,
    "descripcion":"NEVO CUTÁNEO MELANOCÍTICO DESMOPLÁSTICO DE CÉLULAS EPITELIOIDES Y FUSIFORMES"
  },
  {
    "codigo":103275002,
    "descripcion":"PRESIÓN INTRAOCULAR NORMAL CON PECTINADO IMPERFORADO"
  },
  {
    "codigo":37739004,
    "descripcion":"TRASTORNO DEL ESTADO DE ÁNIMO POR UNA ENFERMEDAD MÉDICA GENERAL"
  },
  {
    "codigo":1184619005,
    "descripcion":"AMBIENTE HELADO"
  },
  {
    "codigo":365419007,
    "descripcion":"DURACIÓN DE LA ONDA T ELECTROCARDIOGRÁFICA - HALLAZGO"
  },
  {
    "codigo":29771000175104,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN EN CADERA IZQUIERDA"
  },
  {
    "codigo":234347009,
    "descripcion":"ANEMIA DE LOS TRASTORNOS CRÓNICOS"
  },
  {
    "codigo":789568002,
    "descripcion":"ÚLCERA DE REGIÓN MEDIA DE PIE DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":18000001000004101,
    "descripcion":"ESTENOSIS DE ARTERIA SUBCLAVIA IZQUIERDA"
  },
  {
    "codigo":1074321000119100,
    "descripcion":"ARTROSIS SECUNDARIA DE CADERA IZQUIERDA"
  },
  {
    "codigo":230677000,
    "descripcion":"DEFICIENCIA CONGÉNITA DE LA PLACA TERMINAL DE ACETILCOLINESTERASA"
  },
  {
    "codigo":165141001,
    "descripcion":"GASTROSCOPIA NORMAL"
  },
  {
    "codigo":16010231000119107,
    "descripcion":"CLIC DE CADERA DERECHA"
  },
  {
    "codigo":18960001000004105,
    "descripcion":"FRACTURA POR ESTALLIDO DE CUARTA VÉRTEBRA DORSAL"
  },
  {
    "codigo":427285006,
    "descripcion":"LIPOMA ATÍPICO DE PARTES BLANDAS"
  },
  {
    "codigo":296213007,
    "descripcion":"SOBREDOSIS DE DECANOATO DE FLUFENAZINA"
  },
  {
    "codigo":294378005,
    "descripcion":"ALERGIA A INTERFERÓN ALFA-2B"
  },
  {
    "codigo":91281000119103,
    "descripcion":"ADENOCARCINOMA METASTÁSICO DE HUESO"
  },
  {
    "codigo":95935000,
    "descripcion":"VÍCTIMA DE ROBO"
  },
  {
    "codigo":337041000119104,
    "descripcion":"MOLESTIA VISUAL DE OJO IZQUIERDO"
  },
  {
    "codigo":292543005,
    "descripcion":"REACCIÓN ADVERSA AL CLORHIDRATO DE ORFENADRINA"
  },
  {
    "codigo":423615009,
    "descripcion":"ADENOCARCINOMA QUÍSTICO DE GLÁNDULA PARÓTIDA"
  },
  {
    "codigo":290708004,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR AMSACRINA"
  },
  {
    "codigo":714857001,
    "descripcion":"NO SE ABSTIENE DE BEBER"
  },
  {
    "codigo":288873001,
    "descripcion":"INCAPAZ DE LLEVAR LÍQUIDOS A LA BOCA"
  },
  {
    "codigo":126868009,
    "descripcion":"NEOPLASIA DEL FONDO DE SACO RECTOUTERINO"
  },
  {
    "codigo":16639121000119107,
    "descripcion":"COMPRESIÓN DE AMBOS NERVIOS PLANTARES"
  },
  {
    "codigo":1306516009,
    "descripcion":"CARCINOMA LOBULILLAR PRIMARIO DE MAMA IZQUIERDA"
  },
  {
    "codigo":26729007,
    "descripcion":"QUEMADURA DE ESPESOR COMPLETO DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":287038000,
    "descripcion":"RUPTURA DE MEMBRANA SINOVIAL DE MANO"
  },
  {
    "codigo":92265008,
    "descripcion":"NEOPLASIA BENIGNA DE CONDUCTO PANCREÁTICO"
  },
  {
    "codigo":450878002,
    "descripcion":"TUMORACIÓN DE AMÍGDALA PALATINA"
  },
  {
    "codigo":57662003,
    "descripcion":"LESIÓN TRAUMÁTICA DE VASO SANGUÍNEO"
  },
  {
    "codigo":385342005,
    "descripcion":"DENSIDAD ÓSEA - HALLAZGO"
  },
  {
    "codigo":416275000,
    "descripcion":"DISFUNCIÓN SOMÁTICA DE MANO"
  },
  {
    "codigo":188734009,
    "descripcion":"LEUCEMIA NEUTRÓFILA CRÓNICA"
  },
  {
    "codigo":254270008,
    "descripcion":"TRISOMÍA CROMOSÓMICA COMPLETA - MOSAICISMO POR FALTA DE DISYUNCIÓN MITÓTICA"
  },
  {
    "codigo":55827005,
    "descripcion":"HIPERTROFIA VENTRICULAR IZQUIERDA"
  },
  {
    "codigo":43911000087101,
    "descripcion":"CORTE EN PIEL DE HOMBRO DERECHO"
  },
  {
    "codigo":38791000087103,
    "descripcion":"SÍNDROME DE DOLOR PÉLVICO PRIMARIO CRÓNICO"
  },
  {
    "codigo":41351000087104,
    "descripcion":"HEMATOMA DE DEDO GORDO DE PIE DERECHO"
  },
  {
    "codigo":56711000087106,
    "descripcion":"INFLUENCIA NEGATIVA DE GRUPO SOCIAL"
  },
  {
    "codigo":283368002,
    "descripcion":"LACERACIÓN DE LA AXILA"
  },
  {
    "codigo":46471000087106,
    "descripcion":"FRACTURA DE HUESO METACARPIANO DE MANO DERECHA"
  },
  {
    "codigo":310571000119106,
    "descripcion":"INFECCIÓN PIÓGENA DE DISCO INTERVERTEBRAL TORACOLUMBAR"
  },
  {
    "codigo":295944002,
    "descripcion":"SOBREDOSIS DE MAPROTILINA"
  },
  {
    "codigo":840424008,
    "descripcion":"LINFOMA DIFUSO DE LINFOCITOS B GRANDES DE ESTÓMAGO"
  },
  {
    "codigo":248765003,
    "descripcion":"FÁCILMENTE EXCITABLE SEXUALMENTE"
  },
  {
    "codigo":281533006,
    "descripcion":"FRACTURA DE CABEZA DE PERONÉ"
  },
  {
    "codigo":445373007,
    "descripcion":"ORIFICIO AÓRTICO POSTERIOR CON RESPECTO A ORIFICIO PULMONAR"
  },
  {
    "codigo":1297341009,
    "descripcion":"CIERRE DE ÁNGULO DE AMBOS OJOS DEBIDO A MALFORMACIÓN CONGÉNITA DE ÁNGULO DE CÁMARA ANTERIOR DE AMBOS OJOS"
  },
  {
    "codigo":246930004,
    "descripcion":"NERVIOS CORNEALES ENGROSADOS"
  },
  {
    "codigo":83090005,
    "descripcion":"OSIFICACIÓN DE LA DURAMADRE"
  },
  {
    "codigo":1162599006,
    "descripcion":"LESIÓN TRAUMÁTICA DENTAL"
  },
  {
    "codigo":212327007,
    "descripcion":"LESIÓN CERRADA DEL NERVIO CUTÁNEO LATERAL DEL MUSLO"
  },
  {
    "codigo":15930821000119105,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE AMBOS OVARIOS"
  },
  {
    "codigo":896785002,
    "descripcion":"FORMA ANCHA ANORMAL CONGÉNITA DE FALANGE PROXIMAL DE SEGUNDO DEDO DE PIE"
  },
  {
    "codigo":110353005,
    "descripcion":"HÁBITO PARAFUNCIONAL"
  },
  {
    "codigo":274193006,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DEL DEDO"
  },
  {
    "codigo":208657007,
    "descripcion":"FRACTURA NO EXPUESTA DE TOBILLO, MALÉOLO EXTERNO, INFERIOR"
  },
  {
    "codigo":42982001,
    "descripcion":"SIALOADENITIS"
  },
  {
    "codigo":15986271000119103,
    "descripcion":"ANOMALÍA CONGÉNITA DE AMBAS PAPILAS ÓPTICAS"
  },
  {
    "codigo":303291002,
    "descripcion":"EQUIMOSIS DE MUCOSA ALVEOLAR BUCAL"
  },
  {
    "codigo":301456001,
    "descripcion":"PILORITIS"
  },
  {
    "codigo":237755009,
    "descripcion":"HIPERPLASIA SUPRARRENAL CONGÉNITA - DEFICIENCIA DE DESMOLASA"
  },
  {
    "codigo":1153424004,
    "descripcion":"CONDROSARCOMA DE HUESO DE PARED PÉLVICA"
  },
  {
    "codigo":15714041000119100,
    "descripcion":"DEDO GORDO EN MARTILLO ADQUIRIDO DE AMBOS PIES"
  },
  {
    "codigo":299621005,
    "descripcion":"SIN AMPLITUD ACTIVA DE ADUCCIÓN DE DEDO DEL PIE"
  },
  {
    "codigo":103013007,
    "descripcion":"DOLOR ARDIENTE"
  },
  {
    "codigo":166714005,
    "descripcion":"CREATININA SÉRICA FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":195812001,
    "descripcion":"LARINGITIS CATARRAL CRÓNICA"
  },
  {
    "codigo":64740002,
    "descripcion":"LINFANGITIS AGUDA DE LA PARED DEL TÓRAX"
  },
  {
    "codigo":294116005,
    "descripcion":"ALERGIA A CETIRIZINA"
  },
  {
    "codigo":292281001,
    "descripcion":"REACCIÓN ADVERSA A LA DOXEPINA"
  },
  {
    "codigo":95673003,
    "descripcion":"PARESTESIA DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":1177017006,
    "descripcion":"ARTRITIS POSINFECCIOSA DEBIDA A ENTERITIS CAUSADA POR YERSINIA ENTEROCOLITICA"
  },
  {
    "codigo":61070002,
    "descripcion":"ERITROFAGOCITOSIS"
  },
  {
    "codigo":290446005,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR SULFATO DE MAGNESIO"
  },
  {
    "codigo":1339022006,
    "descripcion":"TRASTORNO DEL SISTEMA NERVIOSO POSTERIOR A RADIOTERAPIA"
  },
  {
    "codigo":421518007,
    "descripcion":"HALLAZGO RELACIONADO CON LA CLASIFICACIÓN DE LA ASOCIACIÓN CARDIOLÓGICA DE NUEVA YORK"
  },
  {
    "codigo":126606008,
    "descripcion":"NEOPLASIA DE LAS PARTES BLANDAS DE CADERA"
  },
  {
    "codigo":28302007,
    "descripcion":"ESTERILIDAD ASPERMATOGÉNICA"
  },
  {
    "codigo":716430007,
    "descripcion":"CAPAZ DE OPERAR UN TELÉFONO CELULAR"
  },
  {
    "codigo":288611008,
    "descripcion":"INCAPAZ DE EMPLEAR PALABRAS"
  },
  {
    "codigo":92003009,
    "descripcion":"NEOPLASIA BENIGNA DE VASO SANGUÍNEO DE LA CADERA"
  },
  {
    "codigo":1237048006,
    "descripcion":"METÁSTASIS DE CARCINOMA ESCAMOSO EN BRONQUIO"
  },
  {
    "codigo":485062701000119100,
    "descripcion":"MELANOMA IN SITU DE MEMBRANA MUCOSA DE BOCA"
  },
  {
    "codigo":219405000,
    "descripcion":"HERIDA DE GUERRA POR EXPLOSIÓN DE BLOQUE DE CAÑÓN"
  },
  {
    "codigo":254008009,
    "descripcion":"FISURA FACIAL PARAMEDIANA - FISURA DE TESSIER TIPO 2"
  },
  {
    "codigo":286776006,
    "descripcion":"CARÁCTER INDECISO"
  },
  {
    "codigo":2271000124107,
    "descripcion":"INCISIVO LATERAL SUPERIOR IZQUIERDO DECIDUO SUPERNUMERARIO"
  },
  {
    "codigo":55565007,
    "descripcion":"INSUFICIENCIA CARDÍACA POSTERIOR A PROCEDIMIENTO OBSTÉTRICO"
  },
  {
    "codigo":342061000119102,
    "descripcion":"AMBLIOPÍA DE OJO IZQUIERDO"
  },
  {
    "codigo":250338000,
    "descripcion":"VÍA DE COAGULACIÓN EXTRÍNSECA - HALLAZGO"
  },
  {
    "codigo":446946005,
    "descripcion":"REINFECCIÓN DE TUBERCULOSIS PULMONAR"
  },
  {
    "codigo":283106007,
    "descripcion":"ARAÑAZO DE DEDO DEL PIE"
  },
  {
    "codigo":1231543000,
    "descripcion":"SIGNO DE RETRASO EN ROTACIÓN EXTERNA DE HOMBRO"
  },
  {
    "codigo":838327001,
    "descripcion":"TRASTORNO DEL DESARROLLO SEXUAL 46,XX DEBIDO A ARRENOBLASTOMA MATERNO"
  },
  {
    "codigo":215735003,
    "descripcion":"LESIÓN SUFRIDA A BORDO DE MEDIO DE TRANSPORTE ACUÁTICO CAUSADA POR MAQUINARIA DE CARGA, CARGADOR DE MUELLES O ESTIBADOR LESIONADO"
  },
  {
    "codigo":707255004,
    "descripcion":"HIPOPLASIA DE ESMALTE LOCALIZADA"
  },
  {
    "codigo":248503005,
    "descripcion":"EDEMA FINO CORNEAL"
  },
  {
    "codigo":772791006,
    "descripcion":"SARCOPENIA"
  },
  {
    "codigo":1079341000119105,
    "descripcion":"NEOPLASIA BENIGNA DE PIEL DE OÍDO IZQUIERDO"
  },
  {
    "codigo":246668000,
    "descripcion":"HEMIANOPSIA BITEMPORAL INCOMPLETA"
  },
  {
    "codigo":410508006,
    "descripcion":"CONJUNTIVITIS POR VIRUS DEL HERPES SIMPLE"
  },
  {
    "codigo":48225000,
    "descripcion":"CORIORRETINITIS DISEMINADA TUBERCULOSA"
  },
  {
    "codigo":310369001,
    "descripcion":"SITUACIÓN DE NOTIFICACIÓN DE DROGADICCIÓN"
  },
  {
    "codigo":408673004,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR HORMONA ADENOHIPOFISARIA"
  },
  {
    "codigo":1162337005,
    "descripcion":"OSTEONECROSIS DE FÉMUR DEBIDA A HEMOGLOBINOPATÍA"
  },
  {
    "codigo":212065007,
    "descripcion":"QUEMADURA QUE COMPROMETE 30-39 PORCIENTO DE LA SUPERFICIE DEL CUERPO, CON QUEMADURA DE ESPESOR COMPLETO QUE AFECTA 10-19 PORCIENTO DE LA SUPERFICIE CORPORAL"
  },
  {
    "codigo":79158003,
    "descripcion":"QUERATITIS INTERSTICIAL TUBERCULOSA"
  },
  {
    "codigo":111926005,
    "descripcion":"INFECCIÓN CAUSADA POR ANOPLOCEPHALA PERFOLIATA"
  },
  {
    "codigo":308534006,
    "descripcion":"ESTADO DE MONITORIZACIÓN DE REEMPLAZO HORMONAL"
  },
  {
    "codigo":275766007,
    "descripcion":"CUERPO EXTRAÑO EN ORINA - MICROSCOPIA"
  },
  {
    "codigo":77323000,
    "descripcion":"INFLAMACIÓN DE BOLSA SEROSA SUBTENDINOSA INFERIOR DE MÚSCULO BÍCEPS FEMORAL"
  },
  {
    "codigo":110091001,
    "descripcion":"LACERACIÓN COMPLEJA DEL PISO DE LA BOCA"
  },
  {
    "codigo":242998006,
    "descripcion":"LESIÓN POR LANZALLAMAS"
  },
  {
    "codigo":304864001,
    "descripcion":"RELACIÓN PASIVA-AGRESIVA"
  },
  {
    "codigo":763616002,
    "descripcion":"SÍNDROME VELOFACIOESQUELÉTICO"
  },
  {
    "codigo":403168006,
    "descripcion":"CALLOSIDAD LABORAL"
  },
  {
    "codigo":8117002,
    "descripcion":"MARCHA NORMAL"
  },
  {
    "codigo":10856801000119101,
    "descripcion":"BEZOAR INTESTINAL"
  },
  {
    "codigo":366730000,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA CAMINAR PENDIENTE ABAJO"
  },
  {
    "codigo":6282000,
    "descripcion":"ANOMALÍA CONGÉNITA DE CONDUCTO DEFERENTE"
  },
  {
    "codigo":301194006,
    "descripcion":"HALLAZGO RELACIONADO CON LA SENSIBILIDAD NASAL"
  },
  {
    "codigo":1251466008,
    "descripcion":"METÁSTASIS DE OSTEOSARCOMA EN CARTÍLAGO ARTICULAR DE CLAVÍCULA"
  },
  {
    "codigo":397663001,
    "descripcion":"FUENTE DE DERIVACIÓN"
  },
  {
    "codigo":233823002,
    "descripcion":"ISQUEMIA DE MIOCARDIO SILENTE"
  },
  {
    "codigo":364895000,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA MOVER LA MANO"
  },
  {
    "codigo":299359008,
    "descripcion":"AMPLITUD DE ROTACIÓN INTERNA PASIVA DE LA RODILLA DISMINUIDA"
  },
  {
    "codigo":201055009,
    "descripcion":"QUERATODERMIA SIMÉTRICA"
  },
  {
    "codigo":723508002,
    "descripcion":"ENFERMEDAD LEUCOPROLIFERATIVA AUTOINMUNITARIA ASOCIADA A RAS"
  },
  {
    "codigo":789044001,
    "descripcion":"CISTADENOMA SEROSO DE OVARIO CON POTENCIAL MALIGNO LIMÍTROFE"
  },
  {
    "codigo":231988004,
    "descripcion":"CORIORRETINITIS BACTERIANA"
  },
  {
    "codigo":1149492007,
    "descripcion":"DISBIOSIS INTESTINAL"
  },
  {
    "codigo":16755041000119107,
    "descripcion":"SANGRADO UTERINO ANORMAL DEBIDO A HIPERPLASIA ENDOMETRIAL"
  },
  {
    "codigo":262921003,
    "descripcion":"LESIÓN TRAUMÁTICA TESTICULAR"
  },
  {
    "codigo":295689003,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE EPIRUBICINA"
  },
  {
    "codigo":230153005,
    "descripcion":"MENINGITIS PARASITARIA"
  },
  {
    "codigo":426761007,
    "descripcion":"TAQUICARDIA SUPRAVENTRICULAR EN EL ELECTROCARDIOGRAMA"
  },
  {
    "codigo":293854000,
    "descripcion":"ALERGIA A MIANSERINA"
  },
  {
    "codigo":721673009,
    "descripcion":"NEOPLASIA NEUROENDOCRINA MALIGNA PRIMARIA DE APÉNDICE ILEOCECAL"
  },
  {
    "codigo":98811000119103,
    "descripcion":"DISCINESIA SUBAGUDA CAUSADA POR FÁRMACO"
  },
  {
    "codigo":719838008,
    "descripcion":"NEUROPATÍA SENSITIVA Y AUTONÓMICA HEREDITARIA LIGADA AL CROMOSOMA X CON SORDERA"
  },
  {
    "codigo":292019000,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR NITRITO"
  },
  {
    "codigo":15744801000119100,
    "descripcion":"MASA DE ARTICULACIÓN DE RODILLA IZQUIERDA"
  },
  {
    "codigo":1086241000119101,
    "descripcion":"ABSCESO DE ÍLEON CONCOMITANTE CON DIVERTICULITIS Y DEBIDO A ELLA"
  },
  {
    "codigo":15716641000119102,
    "descripcion":"ENOSTOSIS DE CÚBITO IZQUIERDO"
  },
  {
    "codigo":62643005,
    "descripcion":"QUEMADURA DEL COLON"
  },
  {
    "codigo":16638241000119100,
    "descripcion":"NEURALGIA DE AMBOS NERVIOS ILIOHIPOGÁSTRICOS"
  },
  {
    "codigo":15639841000119105,
    "descripcion":"PTOSIS DE AMBAS CEJAS"
  },
  {
    "codigo":284961000119106,
    "descripcion":"ENFERMEDAD RENAL CRÓNICA DEBIDA A HIPERTENSIÓN BENIGNA"
  },
  {
    "codigo":15742241000119107,
    "descripcion":"SÍNDROME DE CONDUCTO DEL TARSO EN AMBOS TOBILLOS"
  },
  {
    "codigo":331041000119108,
    "descripcion":"ALTERACIÓN VASCULAR DE PÁRPADO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":36641000119106,
    "descripcion":"TIROIDITIS EUTIROIDEA"
  },
  {
    "codigo":72481000119103,
    "descripcion":"INSUFICIENCIA CARDÍACA CONGESTIVA COMO COMPLICACIÓN POSOPERATORIA TEMPRANA"
  },
  {
    "codigo":315681000119104,
    "descripcion":"OSTEOMIELITIS DE VÉRTEBRA CERVICAL"
  },
  {
    "codigo":305441000119105,
    "descripcion":"CONTRACTURA DE ARTICULACIÓN DE CODO IZQUIERDO"
  },
  {
    "codigo":93576004,
    "descripcion":"OSIFICACIÓN INCOMPLETA DEL CENTRO DE LA VÉRTEBRA DORSAL"
  },
  {
    "codigo":13601000119109,
    "descripcion":"NECROSIS DE SISTEMA NERVIOSO CENTRAL CAUSADA POR RADIACIÓN IONIZANTE"
  },
  {
    "codigo":141601000119107,
    "descripcion":"CAMBIOS COGNITIVOS DEBIDOS A TRASTORNO ORGÁNICO"
  },
  {
    "codigo":341281000119108,
    "descripcion":"TRASTORNO DE CÓRNEA IZQUIERDA CAUSADO POR LENTES DE CONTACTO"
  },
  {
    "codigo":421256007,
    "descripcion":"TRASTORNO OCULAR DEBIDO A DIABETES MELLITUS RELACIONADA CON DESNUTRICIÓN"
  },
  {
    "codigo":15683361000119109,
    "descripcion":"BURSITIS DE AMBAS BOLSAS SEROSAS DEL TENDÓN DE AQUILES"
  },
  {
    "codigo":290184009,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR DIHIDROCODEÍNA"
  },
  {
    "codigo":1081851000119108,
    "descripcion":"CARCINOMA MICROCÍTICO PRIMARIO DE BRONQUIO PRINCIPAL IZQUIERDO"
  },
  {
    "codigo":253746001,
    "descripcion":"CARTÍLAGO Y HUESO ECTÓPICOS EN PULMÓN"
  },
  {
    "codigo":124509009,
    "descripcion":"DEFICIENCIA DE AMIDASA"
  },
  {
    "codigo":286514002,
    "descripcion":"CAPAZ DE COCINAR ALIMENTOS"
  },
  {
    "codigo":712498004,
    "descripcion":"MASA DE SEGUNDO A QUINTO DEDOS DEL PIE"
  },
  {
    "codigo":384818009,
    "descripcion":"INVASIÓN TUMORAL DE PLEURA VISCERAL NO APLICABLE"
  },
  {
    "codigo":57138009,
    "descripcion":"PSEUDOPAPILEDEMA"
  },
  {
    "codigo":24370009,
    "descripcion":"ESCOTOMA DE SEIDEL"
  },
  {
    "codigo":250076001,
    "descripcion":"TONO MUSCULAR FLUCTUANTE"
  },
  {
    "codigo":413916006,
    "descripcion":"ECTASIA CORNEAL DEBIDA A QUERATOMILEUSIS IN SITU ASISTIDA CON LÁSER"
  },
  {
    "codigo":1003740008,
    "descripcion":"CONTRACTURA EN FLEXIÓN DE ARTICULACIÓN INTERFALÁNGICA DE DEDO DE MANO"
  },
  {
    "codigo":282844009,
    "descripcion":"SE MUEVE EN UNA POSICIÓN"
  },
  {
    "codigo":444849002,
    "descripcion":"OSTEONECROSIS DE CADERA"
  },
  {
    "codigo":1231281009,
    "descripcion":"ANOMALÍA DEL DESARROLLO SEXUAL 46,XY POR DEFICIENCIA AISLADA DE 17,20-LIASA"
  },
  {
    "codigo":703323003,
    "descripcion":"INSUFICIENCIA DE VÁLVULA AÓRTICA DEBIDA A DILATACIÓN DE AORTA"
  },
  {
    "codigo":277339005,
    "descripcion":"QUISTE EPIDERMOIDE ESPINAL"
  },
  {
    "codigo":15195005,
    "descripcion":"EVALUACIÓN DE DISCAPACIDAD: 70%"
  },
  {
    "codigo":1260379008,
    "descripcion":"PARKINSONISMO CAUSADO POR ANTAGONISTA DE RECEPTOR DE DOPAMINA"
  },
  {
    "codigo":275504005,
    "descripcion":"QUISTE DE PULMÓN"
  },
  {
    "codigo":1084361000119100,
    "descripcion":"PERFORACIÓN DE AMBAS MEMBRANAS TIMPÁNICAS"
  },
  {
    "codigo":371973000,
    "descripcion":"NEOPLASIA MALIGNA DEL ÚTERO"
  },
  {
    "codigo":15748041000119101,
    "descripcion":"MASA BILATERAL DE CODOS"
  },
  {
    "codigo":699653008,
    "descripcion":"INGESTA ORAL DE ALIMENTOS INADECUADA PARA LAS NECESIDADES FISIOLÓGICAS"
  },
  {
    "codigo":271834000,
    "descripcion":"ERUCTO"
  },
  {
    "codigo":1254874002,
    "descripcion":"DERMATITIS DE CONTACTO FOTOALÉRGICA DEBIDA A PANTALLA SOLAR"
  },
  {
    "codigo":42458003,
    "descripcion":"HEMOTÓRAX TRAUMÁTICO"
  },
  {
    "codigo":402906004,
    "descripcion":"VERRUGA VIRAL EN LABIO"
  },
  {
    "codigo":239066003,
    "descripcion":"QUERATODERMIA PALMOPLANTAR HEREDITARIA"
  },
  {
    "codigo":101321000119102,
    "descripcion":"ENCONDROMA DE HUESO CORTO DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":204463001,
    "descripcion":"AUSENCIA DE VENA CAVA INFERIOR"
  },
  {
    "codigo":106159002,
    "descripcion":"HALLAZGO EN EL NOVENO PAR CRANEAL"
  },
  {
    "codigo":302767002,
    "descripcion":"CUIDA A UN FAMILIAR"
  },
  {
    "codigo":7855006,
    "descripcion":"EFECTO TÓXICO DEL ÁCIDO CLORHÍDRICO"
  },
  {
    "codigo":300932000,
    "descripcion":"UVULITIS"
  },
  {
    "codigo":73391008,
    "descripcion":"DISPLASIA DE CUELLO UTERINO"
  },
  {
    "codigo":6020002,
    "descripcion":"TIÑA DE LOS PIES"
  },
  {
    "codigo":169860002,
    "descripcion":"PESO AL NACER MENOR DE 3% (MENOR DE 2500 G)"
  },
  {
    "codigo":397401005,
    "descripcion":"TRASTORNO DEL CORDÓN UMBILICAL NEONATAL"
  },
  {
    "codigo":266329009,
    "descripcion":"VENAS VARICOSAS SIMPLES"
  },
  {
    "codigo":1149230003,
    "descripcion":"CAPAZ DE ADHERIR A UN ESQUEMA DE AUTOMONITOREO CON DIFICULTAD"
  },
  {
    "codigo":428334004,
    "descripcion":"DESVIACIÓN HACIA ABAJO DEL BRAZO HIPEREXTENDIDO EN POSICIÓN SUPINA"
  },
  {
    "codigo":297262003,
    "descripcion":"DILATACIÓN BILATERAL FIJA DE LA PUPILA"
  },
  {
    "codigo":461102008,
    "descripcion":"INSERCIÓN ANÓMALA DE CONDUCTO ARTERIOSO EN ARTERIA PULMONAR IZQUIERDA DISTAL"
  },
  {
    "codigo":721411005,
    "descripcion":"LACERACIÓN MENOR DE ARTERIA CARÓTIDA"
  },
  {
    "codigo":295427007,
    "descripcion":"SOBREDOSIS DE FÁRMACO ANTAGONISTA DEL RECEPTOR 5-HT3"
  },
  {
    "codigo":262659008,
    "descripcion":"LESIÓN PENETRANTE DE LENGUA"
  },
  {
    "codigo":10970211000119105,
    "descripcion":"LACERACIÓN DE PIE DERECHO"
  },
  {
    "codigo":293592007,
    "descripcion":"ALERGIA A DEXTROPROPOXIFENO"
  },
  {
    "codigo":424664008,
    "descripcion":"DEFORMIDAD EN FLEXIÓN DE DEDO DE LA MANO, DEDO COMPLETAMENTE FLEXIONADO"
  },
  {
    "codigo":719576009,
    "descripcion":"SÍNDROME DE MICRODELECIÓN 16P11.2P12.2"
  },
  {
    "codigo":422829002,
    "descripcion":"INFECCIÓN DE PARTES BLANDAS DE LA COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":160685001,
    "descripcion":"PACIENTE EN CAMA"
  },
  {
    "codigo":129752009,
    "descripcion":"GRAN CALCIFICACIÓN RADIOGRÁFICA CILÍNDRICA"
  },
  {
    "codigo":95149005,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL TRÍGONO VESICAL"
  },
  {
    "codigo":226221009,
    "descripcion":"DIETA ESTÉRIL"
  },
  {
    "codigo":289922002,
    "descripcion":"MASA EN OVARIO"
  },
  {
    "codigo":191618007,
    "descripcion":"TRASTORNO AFECTIVO BIPOLAR, ACTUALMENTE CON EPISODIOS MANÍACOS"
  },
  {
    "codigo":781442008,
    "descripcion":"DISTENSIÓN DE TENDÓN EXTENSOR DE LOS DEDOS"
  },
  {
    "codigo":58711008,
    "descripcion":"ÚLCERA GASTROYEYUNAL AGUDA CON HEMORRAGIA, PERFORACIÓN Y OBSTRUCCIÓN"
  },
  {
    "codigo":187948001,
    "descripcion":"NEOPLASIA MALIGNA DEL CUARTO METACARPIANO"
  },
  {
    "codigo":286252002,
    "descripcion":"DIFICULTAD PARA USAR TONOS VOCALES Y UNIDADES FONÉTICAS"
  },
  {
    "codigo":253484008,
    "descripcion":"ATRESIA DE VÁLVULA AURICULOVENTRICULAR IZQUIERDA"
  },
  {
    "codigo":284417005,
    "descripcion":"CAPAZ DE MANTENER EL EQUILIBRIO AL EXTENDERSE PARA ALCANZAR ALGO"
  },
  {
    "codigo":10671511000119102,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN EN PIERNA DERECHA"
  },
  {
    "codigo":1300225009,
    "descripcion":"RETINOPATÍA CAUSADA POR TALCO"
  },
  {
    "codigo":774102003,
    "descripcion":"SÍNDROME DE DISCAPACIDAD INTELECTUAL, OBESIDAD, PROGNATISMO, ANOMALÍAS DE OJOS Y PIEL"
  },
  {
    "codigo":184278005,
    "descripcion":"CARTA DE ALTA HOSPITALARIA POR DEFUNCIÓN SOLICITADA"
  },
  {
    "codigo":53206008,
    "descripcion":"FÍSTULA DE CONDUCTO BILIAR"
  },
  {
    "codigo":85974009,
    "descripcion":"MASA DE ESTRUCTURA INTRACRANEAL"
  },
  {
    "codigo":413654009,
    "descripcion":"ASFIXIA DURANTE EL NACIMIENTO"
  },
  {
    "codigo":249814009,
    "descripcion":"PIE EN FORMA DE HABICHUELA"
  },
  {
    "codigo":282582009,
    "descripcion":"CAPAZ DE REBOTAR"
  },
  {
    "codigo":51371005,
    "descripcion":"ENANISMO HIPOFISARIO CON NIVELES NORMALES DE SOMATOTROFINA Y NIVELES BAJOS DE SOMATOMEDINA"
  },
  {
    "codigo":247979000,
    "descripcion":"HACE COMENTARIOS INSENSIBLES"
  },
  {
    "codigo":213376006,
    "descripcion":"AMPUTACIONES TRAUMÁTICAS QUE AFECTAN A MÚLTIPLES REGIONES DEL CUERPO"
  },
  {
    "codigo":770432008,
    "descripcion":"ECTASIA DE APÉNDICE AURICULAR IZQUIERDO"
  },
  {
    "codigo":82304009,
    "descripcion":"OSTEOARTROSIS INTERESPINAL"
  },
  {
    "codigo":735829005,
    "descripcion":"RUPTURA TRAUMÁTICA DE PLACA PALMAR DE ARTICULACIÓN INTERFALÁNGICA DE DEDO DE LA MANO"
  },
  {
    "codigo":703061006,
    "descripcion":"CANDIDA ALBICANS O CANDIDA DUBLINIENSIS"
  },
  {
    "codigo":323121000119102,
    "descripcion":"LONGITUD DESIGUAL DE EXTREMIDAD SUPERIOR DEBIDA A ACORTAMIENTO ADQUIRIDO DE HÚMERO DERECHO"
  },
  {
    "codigo":1260117009,
    "descripcion":"EPILEPSIA FOCAL Y GENERALIZADA COMBINADA"
  },
  {
    "codigo":209706008,
    "descripcion":"SECCIÓN EXPUESTA DE LIGAMENTO TIBIOPERONEO DISTAL"
  },
  {
    "codigo":76799001,
    "descripcion":"RUPTURA FAMILIAR DEBIDA A DIVORCIO"
  },
  {
    "codigo":371711002,
    "descripcion":"LESIÓN POR LÁSER"
  },
  {
    "codigo":44031002,
    "descripcion":"CONFUSIÓN POSTCONVULSIVA"
  },
  {
    "codigo":699391000,
    "descripcion":"MIEDO A LA SORDERA"
  },
  {
    "codigo":11263005,
    "descripcion":"ENFERMEDAD VASCULAR DE LA PIEL"
  },
  {
    "codigo":240639009,
    "descripcion":"LEISHMANIASIS CUTÁNEA ANTROPONÓTICA DE LA INDIA"
  },
  {
    "codigo":9428001,
    "descripcion":"POLIOPÍA REFRACTARIA"
  },
  {
    "codigo":304340006,
    "descripcion":"SIN MOVIMIENTO DEL DEDO DEL PIE"
  },
  {
    "codigo":238804007,
    "descripcion":"LINFANGIOMATOSIS SISTÉMICA"
  },
  {
    "codigo":1156308007,
    "descripcion":"INTOXICACIÓN POR HERBICIDA Y\/O FUNGICIDA"
  },
  {
    "codigo":402644006,
    "descripcion":"ERUPCIÓN ACNEIFORME"
  },
  {
    "codigo":269737002,
    "descripcion":"LESIÓN POR EFECTO LOCAL DE SUSTANCIA CÁUSTICA CAUSADA CON INTENCIONALIDAD INDETERMINADA"
  },
  {
    "codigo":40361008,
    "descripcion":"EVALUACIÓN DE DISCAPACIDAD: 3%"
  },
  {
    "codigo":5758002,
    "descripcion":"BACTERIEMIA"
  },
  {
    "codigo":366206003,
    "descripcion":"HALLAZGO EN EL FLUJO VENOSO"
  },
  {
    "codigo":235134003,
    "descripcion":"LESIÓN DE CONDUCTO SALIVAL"
  },
  {
    "codigo":300670003,
    "descripcion":"CAPAZ DE CRUZAR LA CALLE"
  },
  {
    "codigo":724819000,
    "descripcion":"PARAPARESIA FUNCIONAL"
  },
  {
    "codigo":71294008,
    "descripcion":"TRASTORNO BIPOLAR II LEVE, EPISODIO MÁS RECIENTE DE CARACTERÍSTICAS DEPRESIVAS PROFUNDAS"
  },
  {
    "codigo":298835003,
    "descripcion":"AMPLITUD DE ROTACIÓN EXTERNA ACTIVA DE ARTICULACIÓN DE HOMBRO, DISMINUIDA"
  },
  {
    "codigo":722984002,
    "descripcion":"MIELOPATÍA DEBIDA A TRASTORNO METABÓLICO"
  },
  {
    "codigo":297000002,
    "descripcion":"SOBREDOSIS DE ANTIARRÍTMICO DE CLASE III"
  },
  {
    "codigo":67624004,
    "descripcion":"ABSCESO DE LA GLÁNDULA DE BARTOLINO"
  },
  {
    "codigo":229629003,
    "descripcion":"TARTAMUDEO IDIOPÁTICO"
  },
  {
    "codigo":253005,
    "descripcion":"SICOSIS - FOLICULITIS"
  },
  {
    "codigo":16899941000119102,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE PIEL DEL ANO"
  },
  {
    "codigo":295165009,
    "descripcion":"SOBREDOSIS DE OPIOIDE MORFÍNICO"
  },
  {
    "codigo":196861009,
    "descripcion":"HERNIA PARAUMBILICAL CON OBSTRUCCIÓN"
  },
  {
    "codigo":63954007,
    "descripcion":"ÚLCERA GASTROYEYUNAL AGUDA CON HEMORRAGIA"
  },
  {
    "codigo":291495002,
    "descripcion":"INTOXICACIÓN POR AZITROMICINA"
  },
  {
    "codigo":1089381000119105,
    "descripcion":"OTORRAGIA DEL OÍDO IZQUIERDO"
  },
  {
    "codigo":715644000,
    "descripcion":"MALFORMACIÓN GLOMOVENOSA"
  },
  {
    "codigo":193191009,
    "descripcion":"NEUROPATÍA ASOCIADA CON HIPOGLUCEMIA"
  },
  {
    "codigo":93052002,
    "descripcion":"DILATACIÓN CONGÉNITA DE VEJIGA URINARIA"
  },
  {
    "codigo":94887008,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA REGIÓN DE UNIÓN DE LA EPIGLOTIS"
  },
  {
    "codigo":224124005,
    "descripcion":"FAMILIA CON NIÑOS MENORES DE CINCO AÑOS"
  },
  {
    "codigo":1141628006,
    "descripcion":"AINHUM DE QUINTO DEDO DEL PIE"
  },
  {
    "codigo":289660009,
    "descripcion":"ÚTERO SIMÉTRICO"
  },
  {
    "codigo":91217009,
    "descripcion":"ANEMIA MEGALOBLÁSTICA POR EMBARAZO"
  },
  {
    "codigo":449830004,
    "descripcion":"DÍMERO D POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":285990007,
    "descripcion":"CAPAZ DE APAGAR EL CONDUCTOR ELÉCTRICO PRINCIPAL"
  },
  {
    "codigo":218619001,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR KETOPROFENO"
  },
  {
    "codigo":22011005,
    "descripcion":"ENFERMEDAD DE HARTNUP, TIPO RENAL"
  },
  {
    "codigo":251387006,
    "descripcion":"TOLERANCIA GASTROINTESTINAL - HALLAZGO"
  },
  {
    "codigo":249552001,
    "descripcion":"HIPER-RESONANCIA ABDOMINAL"
  },
  {
    "codigo":282320002,
    "descripcion":"NO SE PONE DE PIE SOLO"
  },
  {
    "codigo":247717002,
    "descripcion":"LAS COSAS APARECEN CON COLORES VIVOS"
  },
  {
    "codigo":1263525004,
    "descripcion":"MENINGITIS DEBIDA A INYECCIÓN INTRATECAL Y POSTERIOR A ELLA"
  },
  {
    "codigo":444325005,
    "descripcion":"TROMBOSIS VENOSA PROFUNDA DE AMBAS EXTREMIDADES INFERIORES"
  },
  {
    "codigo":16506000,
    "descripcion":"TRASTORNO BIPOLAR I MIXTO"
  },
  {
    "codigo":313253009,
    "descripcion":"ÚLCERA DE PÁRPADO"
  },
  {
    "codigo":870309009,
    "descripcion":"PROTEINURIA ORTOSTÁTICA PERSISTENTE"
  },
  {
    "codigo":278650002,
    "descripcion":"DESDENTADO"
  },
  {
    "codigo":49274005,
    "descripcion":"SUPERADUCCIÓN DE LOS PLIEGUES VOCALES"
  },
  {
    "codigo":409722007,
    "descripcion":"SISTEMA INTERNACIONAL DE ESTADIFICACIÓN DE NEUROBLASTOMA, ESTADIO 1"
  },
  {
    "codigo":735567001,
    "descripcion":"PERFORACIÓN DE ARTERIA PULMONAR CONCOMITANTE CON ANEURISMA DE ARTERIA PULMONAR Y POSTERIOR A ÉL"
  },
  {
    "codigo":473423001,
    "descripcion":"PÉRDIDA DE LA AUDICIÓN DEL OÍDO DERECHO"
  },
  {
    "codigo":309583004,
    "descripcion":"HALLAZGOS CITOLÓGICOS PRESENTES"
  },
  {
    "codigo":276815004,
    "descripcion":"LINFOMA INTESTINAL"
  },
  {
    "codigo":209444000,
    "descripcion":"ESGUINCE SUPERFICIAL DE LIGAMENTO RADIOCARPIANO PALMAR"
  },
  {
    "codigo":897572005,
    "descripcion":"ANOMALÍA CONGÉNITA DE CONDUCTO SEMICIRCULAR"
  },
  {
    "codigo":78372005,
    "descripcion":"VESÍCULA BILIAR INTRAHEPÁTICA"
  },
  {
    "codigo":682291000119101,
    "descripcion":"ANGIOSARCOMA PRIMARIO DE REGIÓN AXILAR"
  },
  {
    "codigo":109305005,
    "descripcion":"OSTEOMIELITIS DE HUESO CIGOMÁTICO"
  },
  {
    "codigo":43769008,
    "descripcion":"TRASTORNO BIPOLAR I MIXTO LEVE"
  },
  {
    "codigo":205774003,
    "descripcion":"CRANEÓPAGO PARASITARIO"
  },
  {
    "codigo":238542007,
    "descripcion":"DERMATITIS ATÓPICA DE PATRÓN INVERSO"
  },
  {
    "codigo":105635000,
    "descripcion":"ENFERMEDAD CAUSADA POR RETROVIRIDAE"
  },
  {
    "codigo":1186979001,
    "descripcion":"CAPACIDAD DE DIFUSIÓN PULMONAR POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":27901000146106,
    "descripcion":"INDEPENDIENTE EN EL MANEJO DE MEDICACIÓN"
  },
  {
    "codigo":402382008,
    "descripcion":"ANGIOEDEMA IDIOPÁTICO"
  },
  {
    "codigo":269475001,
    "descripcion":"NEOPLASIA MALIGNA DE TEJIDO HEMATOPOYÉTICO, LINFÁTICO Y\/O RELACIONADO"
  },
  {
    "codigo":41934009,
    "descripcion":"ANÁLISIS DE TIPO DE SUSTANCIA NO REALIZADO"
  },
  {
    "codigo":1156046009,
    "descripcion":"HALLAZGO RELACIONADO CON NIVEL DE TEOFILINA"
  },
  {
    "codigo":431480000,
    "descripcion":"FÍSTULA NEFROVISCERAL"
  },
  {
    "codigo":300408001,
    "descripcion":"HALLAZGO RELACIONADO CON EL TONO ABDOMINAL"
  },
  {
    "codigo":40099009,
    "descripcion":"MENINGOENCEFALITIS CAUSADA POR VIRUS DE PAROTIDITIS URLIANA"
  },
  {
    "codigo":726392001,
    "descripcion":"DELECIÓN DE PARTE DEL CROMOSOMA 19"
  },
  {
    "codigo":890232004,
    "descripcion":"REACCIÓN ADVERSA A POLIESTRADIOL"
  },
  {
    "codigo":38264004,
    "descripcion":"DIVERTÍCULO BRONQUIAL"
  },
  {
    "codigo":365944008,
    "descripcion":"HÁBITOS RELACIONADOS CON EL CABELLO - HALLAZGO"
  },
  {
    "codigo":724557008,
    "descripcion":"ANEMIA POR DEFICIENCIA DE HIERRO ADQUIRIDA DEBIDA A DISMINUCIÓN DE LA ABSORCIÓN"
  },
  {
    "codigo":1052237009,
    "descripcion":"PARÁLISIS DEL LADO IZQUIERDO DE LA LENGUA"
  },
  {
    "codigo":298573008,
    "descripcion":"HALLAZGO RELACIONADO CON ESTABILIDAD DE LA COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":396877008,
    "descripcion":"TUMOR QUÍSTICO, PARCIALMENTE ENCAPSULADO"
  },
  {
    "codigo":296738003,
    "descripcion":"SOBREDOSIS DE CEFTIBUTENO"
  },
  {
    "codigo":1826005,
    "descripcion":"GRANULOMA DE LABIO"
  },
  {
    "codigo":82381000119103,
    "descripcion":"DEMENCIA EPILÉPTICA CON ALTERACIÓN DE LA CONDUCTA"
  },
  {
    "codigo":722722006,
    "descripcion":"INFECCIÓN INVASIVA POR HAEMOPHILUS INFLUENZAE TIPO B"
  },
  {
    "codigo":67362008,
    "descripcion":"ANEURISMA AÓRTICO"
  },
  {
    "codigo":131063005,
    "descripcion":"NIVEL DE ESTRONA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":327671006,
    "descripcion":"MUTACIÓN SIN SENTIDO"
  },
  {
    "codigo":196599007,
    "descripcion":"MEGAESÓFAGO EN LA ENFERMEDAD DE CHAGAS"
  },
  {
    "codigo":784307009,
    "descripcion":"TIMOMA BENIGNO"
  },
  {
    "codigo":294903006,
    "descripcion":"ALERGIA A FOSFATO FERROSO"
  },
  {
    "codigo":293068006,
    "descripcion":"REACCIÓN ADVERSA AL CLIOQUINOL"
  },
  {
    "codigo":719052006,
    "descripcion":"CARCINOMA ESCAMOCELULAR RECURRENTE"
  },
  {
    "codigo":782753000,
    "descripcion":"SÍNDROME DE DISCAPACIDAD INTELECTUAL, CARA TOSCA, MACROCEFALIA E HIPOTROFIA DE CEREBELO"
  },
  {
    "codigo":1145036008,
    "descripcion":"DEMUESTRA CONOCIMIENTO SOBRE RESPUESTA PSICOSOCIAL A PROCEDIMIENTO"
  },
  {
    "codigo":63692006,
    "descripcion":"FIBROSIS DEL ESCROTO"
  },
  {
    "codigo":717217003,
    "descripcion":"YERSINIA ENTEROCOLITICA O YERSINIA FREDERIKSENII O YERSINIA INTERMEDIA"
  },
  {
    "codigo":94625000,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL MESOCOLON"
  },
  {
    "codigo":291233005,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR REMOXIPRIDA"
  },
  {
    "codigo":192929006,
    "descripcion":"EXACERBACIÓN DE ESCLEROSIS MÚLTIPLE"
  },
  {
    "codigo":127393007,
    "descripcion":"NIVEL DE ALFAGLOBULINA FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":289398000,
    "descripcion":"NALGA FETAL PALPABLE POR VÍA VAGINAL"
  },
  {
    "codigo":27254001,
    "descripcion":"HEMATOPOYESIS EXTRAMEDULAR DEL BAZO"
  },
  {
    "codigo":387702001,
    "descripcion":"ANEMIA PERINATAL"
  },
  {
    "codigo":16030311000119102,
    "descripcion":"OSTEOMIELITIS SUBAGUDA DE PIE DERECHO"
  },
  {
    "codigo":301671000119103,
    "descripcion":"ABSCESO DE VAINA TENDINOSA DE MUSLO DERECHO"
  },
  {
    "codigo":92790006,
    "descripcion":"CARCINOMA IN SITU DE LA ÚVULA"
  },
  {
    "codigo":123723001,
    "descripcion":"CITOPENIA TÓXICA"
  },
  {
    "codigo":189259008,
    "descripcion":"CARCINOMA IN SITU DE PLIEGUE VESTIBULAR"
  },
  {
    "codigo":1268768004,
    "descripcion":"SELLADOR DE FISURA DENTAL DEFECTUOSO"
  },
  {
    "codigo":1332469006,
    "descripcion":"ENFERMEDAD RENAL CRÓNICA ESTADIO 3B DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":251125008,
    "descripcion":"DEFECTO LEVE DE LA CONDUCCIÓN INTRAVENTRICULAR"
  },
  {
    "codigo":445898001,
    "descripcion":"DISPOSICIÓN AURICULAR ANORMAL"
  },
  {
    "codigo":216522002,
    "descripcion":"INTOXICACIÓN ACCIDENTAL CAUSADA POR PROCLORPERAZINA"
  },
  {
    "codigo":240819007,
    "descripcion":"EQUINOCOCOSIS LARVARIA"
  },
  {
    "codigo":183754007,
    "descripcion":"CONSULTA DOMICILIARIA OFTALMOLÓGICA, REALIZADA"
  },
  {
    "codigo":50847000,
    "descripcion":"MÚSCULO ESQUELÉTICO ACCESORIO"
  },
  {
    "codigo":282058007,
    "descripcion":"QUEMADURA DE ÍLEON"
  },
  {
    "codigo":1197727002,
    "descripcion":"ENFERMEDAD DE CROHN DE PIEL PARAESTOMAL"
  },
  {
    "codigo":247455006,
    "descripcion":"PÁPULAS DE GOTTRON"
  },
  {
    "codigo":18079007,
    "descripcion":"CICLO OVULATORIO Y ANOVULATORIO ALTERNANTE"
  },
  {
    "codigo":704372000,
    "descripcion":"FALTA DE CONFIANZA EN EL PROFESIONAL DE LA SALUD"
  },
  {
    "codigo":737140001,
    "descripcion":"CHASQUIDO DE ARTICULACIÓN TEMPOROMANDIBULAR DERECHA DURANTE LA APERTURA"
  },
  {
    "codigo":81780002,
    "descripcion":"SÍNDROME DE BECKWITH - WIEDEMANN"
  },
  {
    "codigo":312991009,
    "descripcion":"DEMENCIA DE INICIO TARDÍO DEBIDA A ENFERMEDAD DE CUERPOS DE LEWY"
  },
  {
    "codigo":15676161000119105,
    "descripcion":"TENDINITIS BILATERAL DE TENDÓN DE LA PATA DE GANSO"
  },
  {
    "codigo":1163124005,
    "descripcion":"COLITIS POR SHIGELLA DYSENTERIAE"
  },
  {
    "codigo":442228008,
    "descripcion":"RESULTADO DE PROCEDIMIENTO DE MEDICIÓN, AUSENTE"
  },
  {
    "codigo":702537003,
    "descripcion":"SÍNTOMA INEXPLICABLE CLÍNICAMENTE"
  },
  {
    "codigo":276553003,
    "descripcion":"HEPATITIS IDIOPÁTICA DE LA LACTANCIA"
  },
  {
    "codigo":1259593005,
    "descripcion":"CARCINOMA PRIMARIO ECRINO PAPILAR DIGITAL DE PIEL"
  },
  {
    "codigo":473161007,
    "descripcion":"REMOCIÓN ACCIDENTAL DE SONDA NASOGÁSTRICA"
  },
  {
    "codigo":209182000,
    "descripcion":"SUBLUXACIÓN VERTEBRAL NO EXPUESTA CON LESIÓN DE LA COLA DE CABALLO"
  },
  {
    "codigo":405790001,
    "descripcion":"MASTICACIÓN EXCESIVA"
  },
  {
    "codigo":766238001,
    "descripcion":"DISOMÍA UNIPARENTAL MATERNA DEL CROMOSOMA 4"
  },
  {
    "codigo":373022003,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM CONSPICUUM"
  },
  {
    "codigo":733470002,
    "descripcion":"CARCINOMA DE CONDUCTO COLECTOR RENAL"
  },
  {
    "codigo":274718005,
    "descripcion":"ORQUITIS"
  },
  {
    "codigo":12574004,
    "descripcion":"GASTROENTERITIS NO INFECCIOSA"
  },
  {
    "codigo":45342007,
    "descripcion":"UÑAS AMARILLAS"
  },
  {
    "codigo":897310009,
    "descripcion":"OSTEODISTROFIA RENAL CON ALTA TASA DE RENOVACIÓN ÓSEA"
  },
  {
    "codigo":403955002,
    "descripcion":"CARCINOMA ANEXIAL DE PIEL NO DIFERENCIADO"
  },
  {
    "codigo":240115003,
    "descripcion":"MIOSITIS POR HIDATIDOSIS"
  },
  {
    "codigo":43507005,
    "descripcion":"MIXEDEMA DEL ADULTO"
  },
  {
    "codigo":305651006,
    "descripcion":"ATENDIDO POR UN ONCÓLOGO INFANTIL"
  },
  {
    "codigo":8904001,
    "descripcion":"EFECTO TÓXICO DE HUMOS NITROSOS"
  },
  {
    "codigo":698867009,
    "descripcion":"CON MAYOR RIESGO DE DESPLAZAMIENTO PERIOPERATORIO DE LÍQUIDOS"
  },
  {
    "codigo":402120005,
    "descripcion":"INFECCIÓN POR HERPES SIMPLEX CUTÁNEA DISEMINADA"
  },
  {
    "codigo":860872005,
    "descripcion":"ESOFAGITIS DEBIDA A DEBIDA A ENFERMEDAD POR VIRUS DE LA INMUNODEFICIENCIA HUMANA"
  },
  {
    "codigo":236445002,
    "descripcion":"NEFROCALCINOSIS MACROSCÓPICA"
  },
  {
    "codigo":39837002,
    "descripcion":"ESOTROPÍA ALTERNANTE"
  },
  {
    "codigo":1285021005,
    "descripcion":"ANEMIA DE FANCONI, GRUPO DE COMPLEMENTACIÓN C"
  },
  {
    "codigo":170909007,
    "descripcion":"EFECTOS COLATERALES DE FÁRMACO DE ALTO RIESGO"
  },
  {
    "codigo":72605008,
    "descripcion":"VULVOVAGINITIS POR CANDIDA"
  },
  {
    "codigo":300146001,
    "descripcion":"VESÍCULAS EN MEMBRANA TIMPÁNICA"
  },
  {
    "codigo":365682003,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA USAR RAZONAMIENTO VERBAL"
  },
  {
    "codigo":201842007,
    "descripcion":"ARTROSIS PRIMARIA DE LA PRIMERA ARTICULACIÓN CARPOMETACARPIANA, BILATERAL"
  },
  {
    "codigo":1217650009,
    "descripcion":"CATARATA DEBIDA A TRASTORNO DEGENERATIVO"
  },
  {
    "codigo":167239007,
    "descripcion":"ORINA DE COLOR ANORMAL"
  },
  {
    "codigo":15950901000119105,
    "descripcion":"MELANOMA MALIGNO DE PIEL DE AMBOS PIES"
  },
  {
    "codigo":1148444001,
    "descripcion":"ENFERMEDAD POR DEPÓSITO DE HIDROXIAPATITA DE ARTICULACIÓN DE CODO"
  },
  {
    "codigo":68935009,
    "descripcion":"INTOXICACIÓN POR CICUTA MACULATUM"
  },
  {
    "codigo":296476005,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE ISOTRETINOÍNA"
  },
  {
    "codigo":1179377000,
    "descripcion":"ADENOCARCINOMA HIPOFISARIO"
  },
  {
    "codigo":294641002,
    "descripcion":"ALERGIA A COMPONENTE DE VACUNA QUE CONTIENE ANTÍGENO DE BACILLUS ANTHRACIS"
  },
  {
    "codigo":195791000119101,
    "descripcion":"GLOMERULONEFRITIS PROLIFERATIVA CRÓNICA"
  },
  {
    "codigo":32497008,
    "descripcion":"FRACTURA DE ESTRUCTURA LARÍNGEA"
  },
  {
    "codigo":292806003,
    "descripcion":"REACCIÓN ADVERSA A LA AMOROLFINA"
  },
  {
    "codigo":225435000,
    "descripcion":"NO SE RECONOCE EN EL ESPEJO"
  },
  {
    "codigo":127131004,
    "descripcion":"LINFADENOPATÍA RETROPILÓRICA"
  },
  {
    "codigo":192667007,
    "descripcion":"MENINGITIS CAUSADA POR ECHOVIRUS"
  },
  {
    "codigo":1208475008,
    "descripcion":"CISTOADENOMA DE OVARIO EN INFANCIA"
  },
  {
    "codigo":389275009,
    "descripcion":"ACROSTEÓLISIS NEUROGÉNICA FAMILIAR DE GIACCI"
  },
  {
    "codigo":715120001,
    "descripcion":"SE TRANSFIERE DEL INODORO A LA SILLA DE RUEDAS"
  },
  {
    "codigo":16006351000119106,
    "descripcion":"TROMBOFLEBITIS DE AMBOS MIEMBROS SUPERIORES"
  },
  {
    "codigo":289136006,
    "descripcion":"HALLAZGO RELACIONADO CON EL PATRÓN ALIMENTARIO"
  },
  {
    "codigo":92528005,
    "descripcion":"CARCINOMA IN SITU DE LA MÉDULA SUPRARRENAL"
  },
  {
    "codigo":254533000,
    "descripcion":"TUMOR DE ESÓFAGO, ESTÓMAGO Y\/O DUODENO"
  },
  {
    "codigo":1237573001,
    "descripcion":"ACROQUERATODERMIA PUNTEADA CON PIGMENTACIÓN SIMILAR A PECAS"
  },
  {
    "codigo":59760009,
    "descripcion":"INFECCIÓN CAUSADA POR GLUGEA"
  },
  {
    "codigo":1335877006,
    "descripcion":"ICTERICIA NEONATAL PRECOZ DEBIDA A POLICITEMIA"
  },
  {
    "codigo":10681551000119108,
    "descripcion":"MASA DE PIEL DE AMBOS PIES"
  },
  {
    "codigo":90693008,
    "descripcion":"ASIMETRÍA CONGÉNITA DE MANDÍBULA"
  },
  {
    "codigo":188997007,
    "descripcion":"LIPOMA DE MANO"
  },
  {
    "codigo":285466001,
    "descripcion":"DIFICULTAD PARA ABRIR LA BOCA"
  },
  {
    "codigo":1137434003,
    "descripcion":"TIENE ACCESO A TRANSPORTE"
  },
  {
    "codigo":449306005,
    "descripcion":"NEVO MELANOCÍTICO DE PIEL DE PARED ABDOMINAL"
  },
  {
    "codigo":416538006,
    "descripcion":"DEFICIENCIA DE LÍPIDOS LAGRIMALES"
  },
  {
    "codigo":56090007,
    "descripcion":"PSEUDOHIPOPARATIROIDISMO TIPO I B"
  },
  {
    "codigo":202419009,
    "descripcion":"HEMARTROSIS DE LA PRIMERA ARTICULACIÓN METATARSOFALÁNGICA"
  },
  {
    "codigo":333161000119105,
    "descripcion":"PTERIGIÓN PERIFÉRICO ESTACIONARIO DE OJO DERECHO"
  },
  {
    "codigo":283631009,
    "descripcion":"HERIDA POR PINCHAZO DE AGUJA EN EL GLÚTEO"
  },
  {
    "codigo":447471009,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN ADQUIRIDA EN HOSPITAL COMUNITARIO"
  },
  {
    "codigo":249028004,
    "descripcion":"PRESENTACIÓN NO ENCAJADA"
  },
  {
    "codigo":609476004,
    "descripcion":"INTERRUPCIÓN INDUCIDA DEL EMBARAZO COMPLICADA POR PERFORACIÓN DE CUELLO UTERINO"
  },
  {
    "codigo":1363140005,
    "descripcion":"ASTILLA EN VAGINA CON INFECCIÓN"
  },
  {
    "codigo":19652000,
    "descripcion":"FRACTURA EXPUESTA DEL CÓNDILO FEMORAL"
  },
  {
    "codigo":445636003,
    "descripcion":"ORIFICIO AÓRTICO ANTERIOR DERECHO CON RESPECTO A ORIFICIO PULMONAR"
  },
  {
    "codigo":871620008,
    "descripcion":"DEFECTO PERIMEMBRANOSO DEL TABIQUE INTERVENTRICULAR, EN EL CONO DE ENTRADA"
  },
  {
    "codigo":81518000,
    "descripcion":"ÚLCERA PÉPTICA CRÓNICA CON HEMORRAGIA PERO SIN OBSTRUCCIÓN"
  },
  {
    "codigo":142851000119103,
    "descripcion":"HEMORRAGIA CEREBELOSA ESPONTÁNEA"
  },
  {
    "codigo":276291002,
    "descripcion":"HABILIDADES MATEMÁTICAS AISLADAS"
  },
  {
    "codigo":767811005,
    "descripcion":"LESIÓN DE CARA"
  },
  {
    "codigo":866115006,
    "descripcion":"SÍFILIS MALIGNA"
  },
  {
    "codigo":707507003,
    "descripcion":"NEUMONÍA CAUSADA POR SCHISTOSOMA JAPONICUM"
  },
  {
    "codigo":1259331009,
    "descripcion":"CARCINOMA PRIMARIO DE PORCIÓN ANTERIOR DE PISO DE BOCA"
  },
  {
    "codigo":208920004,
    "descripcion":"DESGARRO AGUDO DE MENISCO INTERNO, SEPARACIÓN HORIZONTAL"
  },
  {
    "codigo":307224004,
    "descripcion":"INVASIÓN TUMORAL EN VENA PORTA HEPÁTICA"
  },
  {
    "codigo":733208006,
    "descripcion":"FALLA COMPUESTA DE INJERTO"
  },
  {
    "codigo":700440007,
    "descripcion":"OSTEOMIELITIS DE REGIÓN POSTERIOR DEL PIE"
  },
  {
    "codigo":1222893002,
    "descripcion":"CAPACIDAD PARA PATEAR OBJETO"
  },
  {
    "codigo":1255661003,
    "descripcion":"CARCINOMA MIOEPITELIAL DE OROFARINGE"
  },
  {
    "codigo":43245005,
    "descripcion":"REORDENAMIENTO GENÉTICO"
  },
  {
    "codigo":403693009,
    "descripcion":"HIPERMELANOSIS POR CRIOTERAPIA"
  },
  {
    "codigo":238018004,
    "descripcion":"DEFICIENCIA TOTAL DE HEXOSAMINIDASA - INFANTIL"
  },
  {
    "codigo":762306006,
    "descripcion":"HUESO WORMIANO DEL CRÁNEO"
  },
  {
    "codigo":74178009,
    "descripcion":"TEMBLOR METÁLICO"
  },
  {
    "codigo":6807001,
    "descripcion":"MIELINÓLISIS PONTINA CENTRAL"
  },
  {
    "codigo":400023004,
    "descripcion":"HERIDA POR MORDEDURA DE FOCA"
  },
  {
    "codigo":39575007,
    "descripcion":"ORINA OSCURA"
  },
  {
    "codigo":116381000119105,
    "descripcion":"GANGLIONEUROBLASTOMA"
  },
  {
    "codigo":103276001,
    "descripcion":"AUDICIÓN DISMINUIDA"
  },
  {
    "codigo":301719009,
    "descripcion":"CAPAZ DE REALIZAR ACTIVIDADES RELACIONADAS CON LA POSTULACIÓN A UN TRABAJO"
  },
  {
    "codigo":365420001,
    "descripcion":"HALLAZGO RELACIONADO CON EL NIVEL DE NEUROSIS"
  },
  {
    "codigo":234348004,
    "descripcion":"ANEMIA POR ENFERMEDAD RENAL"
  },
  {
    "codigo":1184620004,
    "descripcion":"PERIODONTITIS EXACERBADA POR SÍNDROME DE COHEN"
  },
  {
    "codigo":689821000119105,
    "descripcion":"CARCINOMA DE CÉLULAS DE TRANSICIÓN DE PARED POSTERIOR DE VEJIGA URINARIA"
  },
  {
    "codigo":199745000,
    "descripcion":"COMPLICACIÓN DURANTE EL TRABAJO DE PARTO Y EL PARTO"
  },
  {
    "codigo":134209002,
    "descripcion":"PROLACTINOMA"
  },
  {
    "codigo":789569005,
    "descripcion":"ÚLCERA NEUROPÁTICA DE TALÓN DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":15926941000119108,
    "descripcion":"LESIÓN DE PÁRPADO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":89911000119102,
    "descripcion":"HIPOVENTILACIÓN O HIPOXEMIA RELACIONADAS CON EL SUEÑO"
  },
  {
    "codigo":7991000119102,
    "descripcion":"DILATACIÓN CONGÉNITA DE RAÍZ AÓRTICA"
  },
  {
    "codigo":296214001,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE DECANOATO DE FLUFENAZINA"
  },
  {
    "codigo":230678005,
    "descripcion":"DISMINUCIÓN DE LA AMPLITUD MOTRIZ DE LA PLACA TERMINAL, SIN DEFICIENCIA DEL RECEPTOR DE ACETILCOLINA"
  },
  {
    "codigo":427286007,
    "descripcion":"OBSTRUCCIÓN DEL TRACTO RESPIRATORIO INFERIOR"
  },
  {
    "codigo":165142008,
    "descripcion":"BRONCOSCOPIA NORMAL"
  },
  {
    "codigo":294379002,
    "descripcion":"ALERGIA A INTERFERÓN ALFA-N1"
  },
  {
    "codigo":196075003,
    "descripcion":"PLEURITIS"
  },
  {
    "codigo":720363008,
    "descripcion":"ARTRITIS DE COLUMNA VERTEBRAL LUMBOSACRA"
  },
  {
    "codigo":63168004,
    "descripcion":"ANEURISMA ARTERIOVENOSO CONGÉNITO PERIFÉRICO"
  },
  {
    "codigo":30400005,
    "descripcion":"HEMORRAGIA MENÍNGEA MEDIA TRAUMÁTICA"
  },
  {
    "codigo":335671000119106,
    "descripcion":"TRASTORNO DE CÓRNEA DERECHA CAUSADO POR LENTES DE CONTACTO"
  },
  {
    "codigo":12521000132103,
    "descripcion":"DISTENSIÓN DE MANDÍBULA"
  },
  {
    "codigo":194240006,
    "descripcion":"OTITIS MEDIA AGUDA NO SUPURATIVA SEROSA"
  },
  {
    "codigo":126869001,
    "descripcion":"NEOPLASIA DEL MESENTERIO"
  },
  {
    "codigo":292544004,
    "descripcion":"REACCIÓN ADVERSA AL CITRATO DE ORFENADRINA"
  },
  {
    "codigo":1306517000,
    "descripcion":"CARCINOMA LOBULILLAR PRIMARIO DE MAMA DERECHA"
  },
  {
    "codigo":290709007,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR AMSACRINA"
  },
  {
    "codigo":94101009,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA LENGUA"
  },
  {
    "codigo":26730002,
    "descripcion":"CONDUCTO TIROGLOSO PERSISTENTE"
  },
  {
    "codigo":714858006,
    "descripcion":"NO SE ADAPTA A SITUACIÓN LABORAL"
  },
  {
    "codigo":288874007,
    "descripcion":"SE LLEVA BEBIDAS A LA BOCA"
  },
  {
    "codigo":92266009,
    "descripcion":"NEOPLASIA BENIGNA DEL CUERPO PARAÓRTICO"
  },
  {
    "codigo":450879005,
    "descripcion":"NÓDULO DE CAVIDAD NASAL"
  },
  {
    "codigo":55828000,
    "descripcion":"ECTROPIÓN DE LA ÚVEA"
  },
  {
    "codigo":287039008,
    "descripcion":"RUPTURA DE MEMBRANA SINOVIAL DE CADERA"
  },
  {
    "codigo":23060008,
    "descripcion":"DEFORMIDAD EN CUELLO DE CISNE"
  },
  {
    "codigo":283369005,
    "descripcion":"LACERACIÓN DE BRAZO"
  },
  {
    "codigo":281534000,
    "descripcion":"FRACTURA DE CUELLO DE PERONÉ"
  },
  {
    "codigo":445374001,
    "descripcion":"LINFEDEMA POSTURAL"
  },
  {
    "codigo":1297342002,
    "descripcion":"CIERRE DE ÁNGULO DE OJO DERECHO DEBIDO A NEOVASCULARIZACIÓN"
  },
  {
    "codigo":248766002,
    "descripcion":"SEQUEDAD VAGINAL DURANTE EL COITO"
  },
  {
    "codigo":246931000,
    "descripcion":"NERVIOS CORNEALES INFLAMADOS"
  },
  {
    "codigo":1295507001,
    "descripcion":"HIPERTENSIÓN OCULAR DE OJO DERECHO DEBIDA A UVEÍTIS"
  },
  {
    "codigo":39521000087102,
    "descripcion":"DISTENSIÓN DE TENDÓN DE REGIÓN DE HOMBRO DERECHO"
  },
  {
    "codigo":47201000087103,
    "descripcion":"DISTENSIÓN DE TENDÓN DE MÚSCULO SUBESCAPULAR DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":771219008,
    "descripcion":"QUEMADURA EPIDÉRMICA DE CABEZA Y\/O CUELLO"
  },
  {
    "codigo":81256000,
    "descripcion":"ANOMALÍA DE LA POSICIÓN DENTAL"
  },
  {
    "codigo":212328002,
    "descripcion":"LESIÓN ABIERTA DEL NERVIO CUTÁNEO LATERAL DEL MUSLO"
  },
  {
    "codigo":15720001,
    "descripcion":"ENTEROPATÍA HEMORRÁGICA DE ÍLEON TERMINAL"
  },
  {
    "codigo":42081000087104,
    "descripcion":"CONTUSIÓN DE ÁREA SUPRAORBITARIA IZQUIERDA"
  },
  {
    "codigo":703848005,
    "descripcion":"ABSTINENCIA DE CANNABIS"
  },
  {
    "codigo":441704009,
    "descripcion":"PSICOSIS AFECTIVA"
  },
  {
    "codigo":1075461000119101,
    "descripcion":"RUPTURA CRÓNICA DE LIGAMENTO CRUZADO POSTERIOR DE RODILLA IZQUIERDA"
  },
  {
    "codigo":1193533005,
    "descripcion":"LESIÓN TRAUMÁTICA DE PLACENTA"
  },
  {
    "codigo":210493006,
    "descripcion":"HERIDAS ABIERTAS QUE COMPROMETEN CABEZA CON CUELLO"
  },
  {
    "codigo":274194000,
    "descripcion":"LESIÓN SUPERFICIAL DEL PULGAR"
  },
  {
    "codigo":896786001,
    "descripcion":"FORMA ANCHA ANORMAL CONGÉNITA DE FALANGE PROXIMAL DE TERCER DEDO DE PIE"
  },
  {
    "codigo":1259069009,
    "descripcion":"TRASTORNO DE SISTEMA NERVIOSO AUTÓNOMO DEBIDO A INFECCIÓN CAUSADA POR CLOSTRIDIUM BOTULINUM"
  },
  {
    "codigo":405266003,
    "descripcion":"DISFUNCIÓN SOMÁTICA AGUDA"
  },
  {
    "codigo":306962003,
    "descripcion":"ASIMETRÍA AMIGDALINA"
  },
  {
    "codigo":208658002,
    "descripcion":"FRACTURA NO EXPUESTA DE TOBILLO, MALÉOLO EXTERNO, SUPERIOR"
  },
  {
    "codigo":403431001,
    "descripcion":"COMPLICACIÓN POR PERFORACIÓN DE OREJA PARA INSERTAR PENDIENTES, AROS U OTROS ORNAMENTOS"
  },
  {
    "codigo":303292009,
    "descripcion":"EQUIMOSIS DE LA OROFARINGE"
  },
  {
    "codigo":235921003,
    "descripcion":"ESTRECHEZ DE LA VÍA BILIAR"
  },
  {
    "codigo":1153425003,
    "descripcion":"CONDROSARCOMA DE CLAVÍCULA"
  },
  {
    "codigo":203153007,
    "descripcion":"OSTEOMIELITIS AGUDA DE PIERNA"
  },
  {
    "codigo":234086001,
    "descripcion":"SECCIÓN DE VENA"
  },
  {
    "codigo":103014001,
    "descripcion":"DOLOR RADICULAR CERVICAL"
  },
  {
    "codigo":1217126006,
    "descripcion":"CONOCIMIENTO DEFICIENTE SOBRE RÉGIMEN DE LÍQUIDOS"
  },
  {
    "codigo":168550007,
    "descripcion":"RADIOGRAFÍA SIMPLE DE DIENTES NORMAL"
  },
  {
    "codigo":365158009,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA CERRAR LAS CANILLAS DE AGUA"
  },
  {
    "codigo":166715006,
    "descripcion":"CREATININA SÉRICA POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":232251007,
    "descripcion":"OTITIS MEDIA SUPURATIVA AGUDA RECURRENTE"
  },
  {
    "codigo":66576001,
    "descripcion":"HEMOCROMATOSIS NUTRICIONAL AFRICANA"
  },
  {
    "codigo":295952004,
    "descripcion":"SOBREDOSIS DE TRAZODONA"
  },
  {
    "codigo":787472005,
    "descripcion":"HAMARTOMA MESENQUIMÁTICO RABDOMIOMATOSO CONGÉNITO"
  },
  {
    "codigo":16833081000119100,
    "descripcion":"DISPEPSIA DURANTE EMBARAZO"
  },
  {
    "codigo":790731321000119100,
    "descripcion":"DISTROFIA RETICULAR DE AMBAS CÓRNEAS"
  },
  {
    "codigo":125619004,
    "descripcion":"LUXACIÓN TRAUMÁTICA DE ARTICULACIÓN DE DEDO DE LA MANO"
  },
  {
    "codigo":230416005,
    "descripcion":"SÍNDROME DE WEST CRIPTOGÉNICO"
  },
  {
    "codigo":10633631000119107,
    "descripcion":"CELULITIS DE PULGAR DERECHO"
  },
  {
    "codigo":64741003,
    "descripcion":"CATARATA MIOTÓNICA"
  },
  {
    "codigo":195813006,
    "descripcion":"LARINGITIS HIPERPLÁSICA CRÓNICA"
  },
  {
    "codigo":359653006,
    "descripcion":"ESPRUE NO CLASIFICADO"
  },
  {
    "codigo":1177018001,
    "descripcion":"UVEÍTIS ANTERIOR TUBERCULOSA"
  },
  {
    "codigo":30138004,
    "descripcion":"INTOXICACIÓN POR ÉTER"
  },
  {
    "codigo":292282008,
    "descripcion":"REACCIÓN ADVERSA AL IPRINDOL"
  },
  {
    "codigo":95674009,
    "descripcion":"NEUROPRAXIA CUBITAL"
  },
  {
    "codigo":1339023001,
    "descripcion":"TRASTORNO CEREBRAL DIFERIDO PRECOZ DEBIDO A RADIOTERAPIA Y POSTERIOR A ELLA"
  },
  {
    "codigo":61071003,
    "descripcion":"DEFICIENCIA DE PROLINA DESHIDROGENASA"
  },
  {
    "codigo":126607004,
    "descripcion":"NEOPLASIA DE PARTES BLANDAS DE MIEMBRO INFERIOR"
  },
  {
    "codigo":716431006,
    "descripcion":"CAPAZ DE PARTICIPAR EN JUEGOS EN LÍNEA"
  },
  {
    "codigo":93839008,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LOS ÓRGANOS INTRABDOMINALES"
  },
  {
    "codigo":288612001,
    "descripcion":"EMPLEA PALABRAS"
  },
  {
    "codigo":190308003,
    "descripcion":"ANOMALÍA DE LA GLOBULINA FIJADORA DE HORMONA TIROIDEA"
  },
  {
    "codigo":26468004,
    "descripcion":"ISQUEMIA RETINIANA"
  },
  {
    "codigo":92004003,
    "descripcion":"NEOPLASIA BENIGNA DE VASO SANGUÍNEO DE LA REGIÓN INGUINAL"
  },
  {
    "codigo":254009001,
    "descripcion":"FISURA FACIAL PARAMEDIANA - FISURA DE TESSIER TIPO 3"
  },
  {
    "codigo":286777002,
    "descripcion":"RASGO DE LA PERSONALIDAD: NIVEL DE CURIOSIDAD - HALLAZGO"
  },
  {
    "codigo":712761004,
    "descripcion":"ESPECIE DE HISTOPLASMA O ESPECIE DE AJELLOMYCES"
  },
  {
    "codigo":1471771000168108,
    "descripcion":"TRABAJA MUCHAS HORAS"
  },
  {
    "codigo":448782004,
    "descripcion":"VENA CAVA INFERIOR DERECHA INTERRUMPIDA"
  },
  {
    "codigo":219406004,
    "descripcion":"LESIÓN DE GUERRA POR EXPLOSIÓN DE BOMBA DE MORTERO"
  },
  {
    "codigo":1004003001,
    "descripcion":"EPÍFISIS PEQUEÑA DE FALANGE MEDIA DE DEDO DE MANO"
  },
  {
    "codigo":283107003,
    "descripcion":"ARAÑAZO DE DEDO GORDO DEL PIE"
  },
  {
    "codigo":445112001,
    "descripcion":"ALUCINACIONES RELACIONADAS CON EL SUEÑO"
  },
  {
    "codigo":707256003,
    "descripcion":"XEROSTOMÍA DEBIDA A RESPIRACIÓN BUCAL"
  },
  {
    "codigo":471481000124101,
    "descripcion":"CATÉTER EPIDURAL IN SITU"
  },
  {
    "codigo":281272006,
    "descripcion":"ESPÉCIMEN CON FECHA DE AYER PERO RECIBIDO HOY"
  },
  {
    "codigo":838328006,
    "descripcion":"TRASTORNO DEL DESARROLLO SEXUAL 46,XX DEBIDO A ANDROLUTEOMA MATERNO"
  },
  {
    "codigo":314040008,
    "descripcion":"ÚTERO MUY PEQUEÑO"
  },
  {
    "codigo":1295245001,
    "descripcion":"MIOEPITELIOMA"
  },
  {
    "codigo":410509003,
    "descripcion":"CONJUNTIVITIS POR VIRUS DEL HERPES ZÓSTER"
  },
  {
    "codigo":441000124107,
    "descripcion":"LUGAR DE ACCESO PARA HEMODIÁLISIS PERMEABLE"
  },
  {
    "codigo":440761000124108,
    "descripcion":"INGESTA EXCESIVA DE ÁCIDO PANTOTÉNICO"
  },
  {
    "codigo":314221000119101,
    "descripcion":"MIOSITIS OSIFICANTE TRAUMÁTICA DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":16206701000119101,
    "descripcion":"TRASTORNO DE AMBOS NERVIOS CIÁTICOS"
  },
  {
    "codigo":1162338000,
    "descripcion":"OSTEÓLISIS DEBIDA A LESIÓN TRAUMÁTICA Y POSTERIOR A ELLA"
  },
  {
    "codigo":310370000,
    "descripcion":"SITUACIÓN DE CONSULTA POSNATAL"
  },
  {
    "codigo":246669008,
    "descripcion":"HEMIANOPSIA ALTITUDINAL"
  },
  {
    "codigo":277602003,
    "descripcion":"LEUCEMIA MEGACARIOBLÁSTICA AGUDA"
  },
  {
    "codigo":212066008,
    "descripcion":"QUEMADURA QUE COMPROMETE 30-39 PORCIENTO DE LA SUPERFICIE DEL CUERPO, CON QUEMADURA DE ESPESOR COMPLETO QUE AFECTA 20-29 PORCIENTO DE LA SUPERFICIE CORPORAL"
  },
  {
    "codigo":111927001,
    "descripcion":"INFECCIÓN CAUSADA POR DRASCHIA"
  },
  {
    "codigo":242999003,
    "descripcion":"LESIÓN POR PROYECTIL"
  },
  {
    "codigo":77324006,
    "descripcion":"FORMA DE UNA COLONIA BACTERIANA, FUSIFORME"
  },
  {
    "codigo":304865000,
    "descripcion":"RELACIÓN ESQUIZOIDE"
  },
  {
    "codigo":110092008,
    "descripcion":"LACERACIÓN COMPLEJA CONTAMINADA DEL PISO DE LA BOCA"
  },
  {
    "codigo":403169003,
    "descripcion":"CALLOSIDAD POR TIC HABITUAL"
  },
  {
    "codigo":1156833003,
    "descripcion":"GERMINOMA DEL SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":763617006,
    "descripcion":"LINFANGIOMA CONGÉNITO DE LARINGE"
  },
  {
    "codigo":9953008,
    "descripcion":"HEPATITIS ALCOHÓLICA AGUDA"
  },
  {
    "codigo":73654006,
    "descripcion":"PRESIÓN DEL PULSO ARTERIAL NORMAL"
  },
  {
    "codigo":366731001,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA CAMINAR COLINA ARRIBA"
  },
  {
    "codigo":237494009,
    "descripcion":"BOCIO DIFUSO"
  },
  {
    "codigo":39051003,
    "descripcion":"SIGNO DE KERNIG"
  },
  {
    "codigo":1251467004,
    "descripcion":"METÁSTASIS DE OSTEOSARCOMA EN CARTÍLAGO ARTICULAR DE COSTILLA"
  },
  {
    "codigo":11838471000119104,
    "descripcion":"LACERACIÓN DE MÚSCULO INTRÍNSECO DE DEDO MEÑIQUE IZQUIERDO"
  },
  {
    "codigo":301195007,
    "descripcion":"DOLOR A LA PALPACIÓN EN NARIZ"
  },
  {
    "codigo":235659008,
    "descripcion":"GASTRITIS URÉMICA"
  },
  {
    "codigo":299360003,
    "descripcion":"SIN AMPLITUD PASIVA DE ROTACIÓN INTERNA DE RODILLA"
  },
  {
    "codigo":364896004,
    "descripcion":"PATRÓN GLOBAL DEL ELECTROMIOGRAMA-HALLAZGO"
  },
  {
    "codigo":168288005,
    "descripcion":"ORGANISMO AISLADO EN CULTIVO DE HISOPADO DE OJO"
  },
  {
    "codigo":4448006,
    "descripcion":"CEFALEA ALÉRGICA"
  },
  {
    "codigo":37216006,
    "descripcion":"FRUSTRACIÓN EN LA PROFESIÓN"
  },
  {
    "codigo":789045000,
    "descripcion":"FRACTURA SIMPLE DE EXTREMO INFERIOR DE FÉMUR QUE NO SE EXTIENDE A LA ARTICULACIÓN"
  },
  {
    "codigo":1149493002,
    "descripcion":"BACTERIEMIA CAUSADA POR ERYSIPELOTHRIX RHUSIOPATHIAE"
  },
  {
    "codigo":363061005,
    "descripcion":"SECUELA DEGENERATIVA DE TRASTORNOS"
  },
  {
    "codigo":426762000,
    "descripcion":"CANDIDIASIS DE PEZÓN"
  },
  {
    "codigo":721674003,
    "descripcion":"LESIÓN TRAUMÁTICA PRIMARIA DE COLON POR EXPLOSIÓN"
  },
  {
    "codigo":230154004,
    "descripcion":"MENINGITIS LINFOCÍTICA CRÓNICA"
  },
  {
    "codigo":262922005,
    "descripcion":"HEMATOMA TRAUMÁTICO DE TESTÍCULO"
  },
  {
    "codigo":295690007,
    "descripcion":"SOBREDOSIS INTENCIONAL DE EPIRUBICINA"
  },
  {
    "codigo":719839000,
    "descripcion":"SÍNDROME DE ENFERMEDAD DE LOS TÚBULOS RENALES CON MIOCARDIOPATÍA"
  },
  {
    "codigo":1342431003,
    "descripcion":"LUXACIÓN DE ARTICULACIÓN DE DEDO DE MANO"
  },
  {
    "codigo":293855004,
    "descripcion":"ALERGIA A TRAZODONA"
  },
  {
    "codigo":343201000119104,
    "descripcion":"PÉRDIDA TRANSITORIA DE VISIÓN DE AMBOS OJOS"
  },
  {
    "codigo":64479007,
    "descripcion":"NEUMONÍA CAUSADA POR KLEBSIELLA PNEUMONIAE"
  },
  {
    "codigo":228319007,
    "descripcion":"BEBEDOR DIARIO"
  },
  {
    "codigo":423092005,
    "descripcion":"TUBERCULOSIS RESISTENTE A MÚLTIPLES FÁRMACOS"
  },
  {
    "codigo":292020006,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR NITRITO"
  },
  {
    "codigo":28041003,
    "descripcion":"FÓVEA LABIAL CONGÉNITA"
  },
  {
    "codigo":880009005,
    "descripcion":"ANOMALÍA ADQUIRIDA DE VÁLVULA AURICULOVENTRICULAR IZQUIERDA POSTERIOR A REPARACIÓN DE VENTRÍCULO CON DOBLE TRACTO DE ENTRADA"
  },
  {
    "codigo":290185005,
    "descripcion":"INTOXICACIÓN INTENCIONAL CAUSADA POR DIHIDROCODEÍNA"
  },
  {
    "codigo":93577008,
    "descripcion":"OSIFICACIÓN INCOMPLETA DE LA CLAVÍCULA"
  },
  {
    "codigo":716169009,
    "descripcion":"SÍNDROME DE SECUENCIA DE HOLOPROSENCEFALIA CON HIPOCINESIA Y CONTRACTURAS ARTICULARES CONGÉNITAS"
  },
  {
    "codigo":419422001,
    "descripcion":"ÁNGULO ESTRECHO"
  },
  {
    "codigo":288350003,
    "descripcion":"CAPAZ DE CONSTRUIR UNA TORRE"
  },
  {
    "codigo":124510004,
    "descripcion":"DEFICIENCIA DE UREASA"
  },
  {
    "codigo":26206000,
    "descripcion":"COMA HEPÁTICO DEBIDO A HEPATITIS POR VIRUS B"
  },
  {
    "codigo":188211001,
    "descripcion":"NEOPLASIA MALIGNA DE LA GLÁNDULA VESTIBULAR MAYOR (DE BARTOLINO)"
  },
  {
    "codigo":1269555002,
    "descripcion":"HEMORRAGIA ATRAUMÁTICA DE ESPACIO SUBARACNOIDEO DE ARTERIA VERTEBRAL"
  },
  {
    "codigo":16782651000119104,
    "descripcion":"MELANOMA IN SITU DE PIEL DE NARIZ"
  },
  {
    "codigo":308731000119100,
    "descripcion":"GANGLIÓN DE HOMBRO DERECHO"
  },
  {
    "codigo":677371000119101,
    "descripcion":"CÁMARA ANTERIOR PLANA DE OJO DERECHO CON HIPOTONÍA"
  },
  {
    "codigo":253747005,
    "descripcion":"ISOMERISMO BRONCOPULMONAR"
  },
  {
    "codigo":306171000119102,
    "descripcion":"GOTA TOFÁCEA CRÓNICA DE MANO CAUSADA POR FÁRMACO"
  },
  {
    "codigo":331771000119104,
    "descripcion":"ENOFTALMOS DERECHO TRAUMÁTICO"
  },
  {
    "codigo":16068091000119101,
    "descripcion":"NEOPLASIA LIPOMATOSA BENIGNA DE PIEL Y\/O DEL TEJIDO CELULAR SUBCUTÁNEO DE AMBAS EXTREMIDADES INFERIORES"
  },
  {
    "codigo":1076731000119106,
    "descripcion":"DOLOR DE ARTICULACIÓN DE MANO IZQUIERDA"
  },
  {
    "codigo":415752002,
    "descripcion":"ABERRACIÓN DEL FRENTE DE ONDA, TREFOIL"
  },
  {
    "codigo":1079291000119107,
    "descripcion":"NEOPLASIA BENIGNA DE HUESO DE MANO DERECHA"
  },
  {
    "codigo":352251000119109,
    "descripcion":"LINFOMA PEQUEÑO LINFOCÍTICO DE CÉLULAS B DE LOS GANGLIOS LINFÁTICOS DE MÚLTIPLES LOCALIZACIONES"
  },
  {
    "codigo":15635451000119107,
    "descripcion":"BEBÉ PREMATURO, 31 SEMANAS"
  },
  {
    "codigo":339451000119102,
    "descripcion":"ESOTROPÍA MONOCULAR DE OJO IZQUIERDO CON ESTRABISMO CON PATRÓN EN A"
  },
  {
    "codigo":16229371000119106,
    "descripcion":"HIPERTENSIÓN ARTERIAL SISTÉMICA LÁBIL"
  },
  {
    "codigo":10948091000119106,
    "descripcion":"HERIDA ABIERTA DE DEDO ANULAR DERECHO DEBIDA A MORDEDURA DE ANIMAL"
  },
  {
    "codigo":413917002,
    "descripcion":"PLIEGUE DE COLGAJO CORNEAL"
  },
  {
    "codigo":11818491000119107,
    "descripcion":"ESGUINCE DE LIGAMENTO DE ARTICULACIÓN INTERFALÁNGICA DE DEDO ÍNDICE IZQUIERDO"
  },
  {
    "codigo":91131000119109,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE VULVA"
  },
  {
    "codigo":250077005,
    "descripcion":"TENSIÓN DE LA EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":282845005,
    "descripcion":"NO SE MUEVE DENTRO DE UNA POSICIÓN"
  },
  {
    "codigo":1003741007,
    "descripcion":"CONTRACTURA EN FLEXIÓN DE ARTICULACIÓN DE DEDO DE MANO"
  },
  {
    "codigo":51634001,
    "descripcion":"PALUDISMO CONGÉNITO"
  },
  {
    "codigo":1231282002,
    "descripcion":"EPILEPSIA NEONATAL-INFANTIL FAMILIAR AUTOLIMITADA"
  },
  {
    "codigo":1264050003,
    "descripcion":"TRASTORNO FETAL CAUSADO POR TRANSFERENCIA PLACENTARIA DE SUSTANCIA CON MECANISMO DE ACCIÓN ANTIBACTERIANO"
  },
  {
    "codigo":248242009,
    "descripcion":"HALLAZGO FÍSICO GENERAL"
  },
  {
    "codigo":1260380006,
    "descripcion":"DISTONÍA DEBIDA A GANGLIOSIDOSIS GM 2"
  },
  {
    "codigo":15196006,
    "descripcion":"HEMATOMA INTRAPLACENTARIO"
  },
  {
    "codigo":277340007,
    "descripcion":"NEUMOENCÉFALO A TENSIÓN"
  },
  {
    "codigo":703324009,
    "descripcion":"INSUFICIENCIA DE VÁLVULA AÓRTICA DEBIDA A TRAUMATISMO"
  },
  {
    "codigo":406577000,
    "descripcion":"INFECCIÓN CAUSADA POR STAPHYLOCOCCUS AUREUS CON RESISTENCIA INTERMEDIA O COMPLETAMENTE RESISTENTE A VANCOMICINA"
  },
  {
    "codigo":308273005,
    "descripcion":"ESTADO DE SEGUIMIENTO"
  },
  {
    "codigo":275505006,
    "descripcion":"QUISTES MÚLTIPLES DE PULMÓN"
  },
  {
    "codigo":109830000,
    "descripcion":"NEOPLASIA MALIGNA SUPERPUESTA DEL PISO DE LA BOCA"
  },
  {
    "codigo":699654002,
    "descripcion":"RETRUSIÓN BIMAXILAR"
  },
  {
    "codigo":765190005,
    "descripcion":"FIBROTECOMA DE OVARIO"
  },
  {
    "codigo":371974006,
    "descripcion":"NEOPLASIA MALIGNA DE BORDE DE LA LENGUA"
  },
  {
    "codigo":1254875001,
    "descripcion":"DERMATITIS FOTOALÉRGICA DEBIDA A BIOCIDA"
  },
  {
    "codigo":271835004,
    "descripcion":"DISTENSIÓN DE ABDOMEN CAUSADA POR GAS INTESTINAL"
  },
  {
    "codigo":304603007,
    "descripcion":"VARIANTE DE ENFERMEDAD DE CREUTZFELDT-JAKOB"
  },
  {
    "codigo":402907008,
    "descripcion":"VERRUGA EN REGIÓN DE LA BARBA"
  },
  {
    "codigo":239067007,
    "descripcion":"QUERATODERMIA PALMAR Y PLANTAR HEREDITARIA"
  },
  {
    "codigo":106160007,
    "descripcion":"HALLAZGO EN EL DÉCIMO PAR CRANEAL"
  },
  {
    "codigo":204464007,
    "descripcion":"AUSENCIA DE VENA CAVA SUPERIOR"
  },
  {
    "codigo":302768007,
    "descripcion":"HALLAZGO LABORAL"
  },
  {
    "codigo":169861003,
    "descripcion":"PESO AL NACER IGUAL A 3%-9% (2500-2849 G)"
  },
  {
    "codigo":16867081000119101,
    "descripcion":"FRACTURA NO EXPUESTA DE CÓNDILO HUMERAL IZQUIERDO"
  },
  {
    "codigo":366469005,
    "descripcion":"HALLAZGO RELACIONADO CON REFLEJO DE HOFFMAN"
  },
  {
    "codigo":38789009,
    "descripcion":"EFECTO POR DOSIFICACIÓN GENÉTICA"
  },
  {
    "codigo":266330004,
    "descripcion":"RUPTURA DE VENAS VARICOSAS"
  },
  {
    "codigo":299098006,
    "descripcion":"AMPLITUD DE ADUCCIÓN ACTIVA DE DEDO DE LA MANO NORMAL"
  },
  {
    "codigo":200794009,
    "descripcion":"DERMATITIS DE CONTACTO CAUSADA POR QUERATOLÍTICO"
  },
  {
    "codigo":48819008,
    "descripcion":"PERITONITIS FIBRINOSA"
  },
  {
    "codigo":2351004,
    "descripcion":"TRANSDUCCIÓN GENÉTICA"
  },
  {
    "codigo":12115721000119104,
    "descripcion":"QUEMADURA QUÍMICA DE MUSLO DERECHO"
  },
  {
    "codigo":67887006,
    "descripcion":"INFECCIÓN CAUSADA POR HETERAKIS"
  },
  {
    "codigo":461103003,
    "descripcion":"ORIGEN ANÓMALO DE CONDUCTO ARTERIOSO EN ARTERIA SUBCLAVIA DERECHA"
  },
  {
    "codigo":297263008,
    "descripcion":"DILATACIÓN FIJA DE LA PUPILA DERECHA"
  },
  {
    "codigo":295428002,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE FÁRMACO ANTAGONISTA DEL RECEPTOR 5-HT3"
  },
  {
    "codigo":262660003,
    "descripcion":"LESIÓN PENETRANTE DEL PISO DE LA BOCA"
  },
  {
    "codigo":721412003,
    "descripcion":"LACERACIÓN MENOR DE ARTERIA VERTEBRAL"
  },
  {
    "codigo":66052004,
    "descripcion":"CARDIOPATÍA Y NEFROPATÍA HIPERTENSIVAS BENIGNAS"
  },
  {
    "codigo":719577000,
    "descripcion":"SÍNDROME DE MICRODELECIÓN 16P13.11"
  },
  {
    "codigo":64217002,
    "descripcion":"CURVATURA DE LA COLUMNA VERTEBRAL"
  },
  {
    "codigo":293593002,
    "descripcion":"ALERGIA A DIPIPANONA"
  },
  {
    "codigo":129753004,
    "descripcion":"CALCIFICACIÓN CON IMAGEN TIPO LECHE CÁLCICA EN MAMOGRAFÍA"
  },
  {
    "codigo":195289005,
    "descripcion":"ANEURISMA DE ARTERIA MESENTÉRICA INFERIOR"
  },
  {
    "codigo":162521005,
    "descripcion":"DIETA CON ALTO CONTENIDO DE FIBRA SOLUBLE"
  },
  {
    "codigo":319241000119108,
    "descripcion":"LUXACIÓN RECURRENTE DE ARTICULACIÓN DE PIE IZQUIERDO"
  },
  {
    "codigo":11788041000119108,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DE DEDO ANULAR DERECHO"
  },
  {
    "codigo":160686000,
    "descripcion":"DUEÑO DE AUTOMÓVIL"
  },
  {
    "codigo":62382002,
    "descripcion":"SÍNDROME CRST"
  },
  {
    "codigo":226222002,
    "descripcion":"DIETA NO TERAPÉUTICA"
  },
  {
    "codigo":15720201000119109,
    "descripcion":"TRASTORNO DE CARTÍLAGO ARTICULAR DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":95150005,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL NERVIO TROCLEAR"
  },
  {
    "codigo":717742006,
    "descripcion":"DISPLASIA RENAL PRIMARIA"
  },
  {
    "codigo":715907003,
    "descripcion":"NEOPLASIA ENDOCRINA MÚLTIPLE TIPO 4"
  },
  {
    "codigo":289923007,
    "descripcion":"ESTENOSIS ADQUIRIDA DE LA ARTERIA RENAL"
  },
  {
    "codigo":255320000,
    "descripcion":"INFECCIÓN - SUPURATIVA"
  },
  {
    "codigo":93315008,
    "descripcion":"POSICIÓN ANÓMALA CONGÉNITA DE VÉRTEBRA CERVICAL"
  },
  {
    "codigo":224387009,
    "descripcion":"REGISTRADO CON INCAPACIDAD PARA EL EMPLEO POR CONSEJERO"
  },
  {
    "codigo":124248008,
    "descripcion":"DEFICIENCIA DE ASPARTATO CARBAMOILTRANSFERASA"
  },
  {
    "codigo":24109003,
    "descripcion":"BROMHIDROSIFOBIA"
  },
  {
    "codigo":187949009,
    "descripcion":"NEOPLASIA MALIGNA DEL QUINTO METACARPIANO"
  },
  {
    "codigo":448258005,
    "descripcion":"SARCOMA DE MESENTERIO"
  },
  {
    "codigo":87810006,
    "descripcion":"ANEMIA MEGALOBLÁSTICA DEBIDA A ALCOHOLISMO"
  },
  {
    "codigo":55042009,
    "descripcion":"CONTUSIÓN DE TOBILLO"
  },
  {
    "codigo":282583004,
    "descripcion":"INCAPAZ DE REBOTAR"
  },
  {
    "codigo":247980002,
    "descripcion":"ACERCAMIENTOS INAPROPIADOS HACIA OTROS"
  },
  {
    "codigo":18604004,
    "descripcion":"DEFICIENCIA DE FACTOR XIII"
  },
  {
    "codigo":409985002,
    "descripcion":"HERIDA POR MORDEDURA DE ARTRÓPODO"
  },
  {
    "codigo":213377002,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE AMBAS MANOS"
  },
  {
    "codigo":770433003,
    "descripcion":"ECTASIA DE APÉNDICE AURICULAR DERECHO"
  },
  {
    "codigo":15640791000119104,
    "descripcion":"ANILLO DE ÓXIDO CORNEAL DERECHO"
  },
  {
    "codigo":111403005,
    "descripcion":"LIPOMATOSIS RENAL"
  },
  {
    "codigo":471851005,
    "descripcion":"TRASTORNO DEL MIOCARDIO ASOCIADO CON RECHAZO DE TRASPLANTE CARDÍACO"
  },
  {
    "codigo":109568006,
    "descripcion":"CARIES DENTAL SECUNDARIA A DEFECTOS DEL DESARROLLO DE LA ESTRUCTURA DE LOS DIENTES"
  },
  {
    "codigo":699392007,
    "descripcion":"PRURITO DE OÍDO"
  },
  {
    "codigo":371712009,
    "descripcion":"LESIÓN TRAUMÁTICA COMO CONSECUENCIA DE LA POSICIÓN"
  },
  {
    "codigo":16050391000119107,
    "descripcion":"ARTRITIS DE ARTICULACIÓN DE AMBAS RODILLAS DEBIDA A INMUNIZACIÓN Y POSTERIOR A ELLA"
  },
  {
    "codigo":42197002,
    "descripcion":"INFECCIÓN CAUSADA POR SCHISTOSOMATIUM"
  },
  {
    "codigo":402645007,
    "descripcion":"TRASTORNO DE OCLUSIÓN DE CONDUCTO APOCRINO"
  },
  {
    "codigo":238805008,
    "descripcion":"LINFANGIOMA ADQUIRIDO"
  },
  {
    "codigo":271573009,
    "descripcion":"ALTERACIÓN CONGÉNITA DE LA AORTA TORÁCICA Y ARTERIAS PULMONARES"
  },
  {
    "codigo":235135002,
    "descripcion":"FRENILLO LABIAL PROMINENTE"
  },
  {
    "codigo":300671004,
    "descripcion":"INCAPAZ DE CRUZAR LA CALLE"
  },
  {
    "codigo":366207007,
    "descripcion":"RETORNO VENOSO EN VENA DE EXTREMIDAD - HALLAZGO"
  },
  {
    "codigo":298836002,
    "descripcion":"SIN AMPLITUD DE ROTACIÓN EXTERNA ACTIVA DE ARTICULACIÓN DE HOMBRO"
  },
  {
    "codigo":397140005,
    "descripcion":"EVALUACIÓN MAMOGRÁFICA (CATEGORÍA 1) - NEGATIVA"
  },
  {
    "codigo":724820006,
    "descripcion":"HEMIPARESIA FUNCIONAL"
  },
  {
    "codigo":167764006,
    "descripcion":"EXAMEN DE SEMEN: BAJA FERTILIDAD"
  },
  {
    "codigo":69460006,
    "descripcion":"INTOXICACIÓN POR TOXAFENO"
  },
  {
    "codigo":722985001,
    "descripcion":"INFARTO VENOSO AGUDO DE MÉDULA ESPINAL"
  },
  {
    "codigo":2089002,
    "descripcion":"OSTEÍTIS DEFORMANTE"
  },
  {
    "codigo":297001003,
    "descripcion":"SOBREDOSIS DE AMIODARONA"
  },
  {
    "codigo":721150002,
    "descripcion":"CAPAZ DE UTILIZAR UNIDADES FONÉTICAS"
  },
  {
    "codigo":295166005,
    "descripcion":"SOBREDOSIS DE BUPRENORFINA"
  },
  {
    "codigo":229630008,
    "descripcion":"TARTAMUDEO PSICÓGENO"
  },
  {
    "codigo":719315000,
    "descripcion":"ALTERACIÓN ADQUIRIDA DEL LENGUAJE RECEPTIVO"
  },
  {
    "codigo":195027000,
    "descripcion":"MIOCARDIOPATÍA DEBIDA A MUCOPOLISACARIDOSIS"
  },
  {
    "codigo":293331003,
    "descripcion":"REACCIÓN ADVERSA AL ANTICOAGULANTE"
  },
  {
    "codigo":31187005,
    "descripcion":"FRACTURA CERRADA DEL ARCO CIGOMÁTICO"
  },
  {
    "codigo":1340072001,
    "descripcion":"HALLAZGO RELACIONADO CON VACUNA"
  },
  {
    "codigo":291496001,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR AZITROMICINA"
  },
  {
    "codigo":94888003,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA ZONA DE UNIÓN DE LA LENGUA"
  },
  {
    "codigo":29352008,
    "descripcion":"DISPLASIA TANATOFÓRICA"
  },
  {
    "codigo":783016009,
    "descripcion":"PANHIPOFISITIS"
  },
  {
    "codigo":715645004,
    "descripcion":"NEUROPATÍA TERMOSENSIBLE HEREDITARIA"
  },
  {
    "codigo":224125006,
    "descripcion":"FAMILIA CON UN NIÑO MENOR DE CINCO AÑOS"
  },
  {
    "codigo":93053007,
    "descripcion":"DILATACIÓN CONGÉNITA DEL VENTRÍCULO CARDÍACO"
  },
  {
    "codigo":289661008,
    "descripcion":"ÚTERO ASIMÉTRICO"
  },
  {
    "codigo":123986000,
    "descripcion":"ÁCIDO ORÓTICO POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":255058005,
    "descripcion":"NEOPLASIA DE TÓRAX"
  },
  {
    "codigo":449831000,
    "descripcion":"ENGROSAMIENTO DIFUSO ANORMAL DE ÍNTIMA DE ARTERIA"
  },
  {
    "codigo":253223002,
    "descripcion":"CATARATA POLAR CONGÉNITA"
  },
  {
    "codigo":285991006,
    "descripcion":"INCAPAZ DE APAGAR EL CONDUCTOR ELÉCTRICO PRINCIPAL"
  },
  {
    "codigo":78501000119105,
    "descripcion":"LIPOMA DE PIEL Y TEJIDO SUBCUTÁNEO"
  },
  {
    "codigo":218620007,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR NAPROXENO"
  },
  {
    "codigo":284156009,
    "descripcion":"CAPAZ DE MOVER UN PIE"
  },
  {
    "codigo":16026431000119101,
    "descripcion":"TROMBOSIS VENOSA CRÓNICA"
  },
  {
    "codigo":52945003,
    "descripcion":"CONTUSIÓN DE LA REGIÓN DE LA ARTICULACIÓN MANDIBULAR"
  },
  {
    "codigo":282321003,
    "descripcion":"DIFICULTAD PARA PONERSE DE PIE SOLO"
  },
  {
    "codigo":249553006,
    "descripcion":"MATIDEZ ABDOMINAL GENERALIZADA A LA PERCUSIÓN"
  },
  {
    "codigo":182182000,
    "descripcion":"EMBADOMONIASIS"
  },
  {
    "codigo":18342001,
    "descripcion":"PALUDISMO ÁLGIDO"
  },
  {
    "codigo":313254003,
    "descripcion":"VENA VARICOSA DE MIEMBRO INFERIOR CON FLEBITIS"
  },
  {
    "codigo":870310004,
    "descripcion":"INFECCIÓN MUCOCUTÁNEA PERINATAL CAUSADA POR HERPESVIRUS HUMANO 3"
  },
  {
    "codigo":280486004,
    "descripcion":"CELULITIS PÉLVICA EN LA MUJER"
  },
  {
    "codigo":247718007,
    "descripcion":"PATRONES QUE APARECEN INTRINCADAMENTE DETALLADOS"
  },
  {
    "codigo":409723002,
    "descripcion":"SISTEMA INTERNACIONAL DE ESTADIFICACIÓN DE NEUROBLASTOMA, ESTADIO 2A"
  },
  {
    "codigo":133951000119104,
    "descripcion":"ESCLEROSIS DE LÓBULO TEMPORAL"
  },
  {
    "codigo":278651003,
    "descripcion":"SIN CARIES DENTALES"
  },
  {
    "codigo":49275006,
    "descripcion":"PARÁLISIS ATETOIDE"
  },
  {
    "codigo":1163387009,
    "descripcion":"LESIONES TRAUMÁTICAS MÚLTIPLES"
  },
  {
    "codigo":16507009,
    "descripcion":"RIÑÓN ECTÓPICO"
  },
  {
    "codigo":11822041000119100,
    "descripcion":"SUBLUXACIÓN DE ARTICULACIÓN DE MUÑECA DERECHA"
  },
  {
    "codigo":735568006,
    "descripcion":"RUPTURA DE ARTERIA PULMONAR CONCOMITANTE CON ANEURISMA DE ARTERIA PULMONAR Y DEBIDA A ÉL"
  },
  {
    "codigo":78373000,
    "descripcion":"DEFICIENCIA DE SACAROSA - ISOMALTASA"
  },
  {
    "codigo":473424007,
    "descripcion":"PÉRDIDA DE LA AUDICIÓN DEL OÍDO IZQUIERDO"
  },
  {
    "codigo":897573000,
    "descripcion":"TALIPES CALCANEOVARO BILATERAL"
  },
  {
    "codigo":209445004,
    "descripcion":"ESGUINCE DE LIGAMENTO RADIOESCAFOCAPITAL"
  },
  {
    "codigo":307749004,
    "descripcion":"ABORTO INCOMPLETO INEVITABLE COMPLICADO POR INFECCIÓN PÉLVICA Y DEL APARATO GENITAL"
  },
  {
    "codigo":109306006,
    "descripcion":"OSTEOMIELITIS DE HUESO ESFENOIDES"
  },
  {
    "codigo":699130006,
    "descripcion":"RUPTURA DE LA PIEL EN LUGAR DE ACCESO DE DISPOSITIVO DE ACCESO VENOSO TOTALMENTE IMPLANTABLE"
  },
  {
    "codigo":9167000,
    "descripcion":"TRASTORNO MODERADO DEL ESTADO DE ÁNIMO"
  },
  {
    "codigo":238543002,
    "descripcion":"DERMATITIS ATÓPICA DISCOIDE"
  },
  {
    "codigo":402383003,
    "descripcion":"URTICARIA Y\/O ANGIOEDEMA IDIOPÁTICOS"
  },
  {
    "codigo":74703006,
    "descripcion":"ANEMIA HEMOLÍTICA NO ESFEROCÍTICA HEREDITARIA POR DEFICIENCIA DE PIRUVATO QUINASA"
  },
  {
    "codigo":269476000,
    "descripcion":"LINFOMA NODULAR"
  },
  {
    "codigo":40100001,
    "descripcion":"BRONQUIOLITIS OBLITERANTE"
  },
  {
    "codigo":680921000119106,
    "descripcion":"HIPOTRICOSIS DE PÁRPADO INFERIOR DERECHO"
  },
  {
    "codigo":236708007,
    "descripcion":"CÁLCULO RENAL CALICIAL"
  },
  {
    "codigo":431481001,
    "descripcion":"DOLOR CRÓNICO POR LESIÓN TRAUMÁTICA"
  },
  {
    "codigo":1090521000119107,
    "descripcion":"NEURITIS ACÚSTICA DE OÍDO DERECHO DEBIDA A ENFERMEDAD INFECCIOSA"
  },
  {
    "codigo":5497006,
    "descripcion":"FIEBRE POR VIRUS MANZANILLA"
  },
  {
    "codigo":726393006,
    "descripcion":"DELECIÓN DE BRAZO LARGO DE CROMOSOMA 19"
  },
  {
    "codigo":3662000,
    "descripcion":"HERNIA PARAESOFÁGICA"
  },
  {
    "codigo":300409009,
    "descripcion":"TONO MUSCULAR ABDOMINAL NORMAL"
  },
  {
    "codigo":365945009,
    "descripcion":"COMPORTAMIENTO DE LA ENFERMEDAD - HALLAZGO"
  },
  {
    "codigo":724558003,
    "descripcion":"NEUROPATÍA PERIFÉRICA DEBIDA A HIPERVITAMINOSIS B6"
  },
  {
    "codigo":1052238004,
    "descripcion":"PARÁLISIS DEL LADO DERECHO DE LA LENGUA"
  },
  {
    "codigo":890233009,
    "descripcion":"SÍNDROME DE ROBINOW AUTOSÓMICO DOMINANTE"
  },
  {
    "codigo":298574002,
    "descripcion":"COLUMNA VERTEBRAL DORSAL INESTABLE"
  },
  {
    "codigo":396878003,
    "descripcion":"MENOR O IGUAL A 4 MITOSIS POR CAMPO DE GRAN AUMENTO"
  },
  {
    "codigo":296739006,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE CEFTIBUTENO"
  },
  {
    "codigo":32760002,
    "descripcion":"OTITIS MEDIA EXUDATIVA"
  },
  {
    "codigo":131064004,
    "descripcion":"ESTRADIOL ANORMAL"
  },
  {
    "codigo":65528008,
    "descripcion":"INFECCIÓN CAUSADA POR ANCYCLOSTOMA CANINUM"
  },
  {
    "codigo":63693001,
    "descripcion":"TRANSFORMACIÓN GENÉTICA"
  },
  {
    "codigo":293069003,
    "descripcion":"REACCIÓN ADVERSA A AGENTE ANTIMICOBACTERIANO"
  },
  {
    "codigo":1208738002,
    "descripcion":"TMEM199-CDG (TRASTORNO CONGÉNITO DE GLICOSILACIÓN DE PROTEÍNA TRANSMEMBRANA 199)"
  },
  {
    "codigo":94626004,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE EPIPLÓN"
  },
  {
    "codigo":782754006,
    "descripcion":"SÍNDROME DE HIPOPLASIA DE FÓVEA, DEFECTO DE DECUSACIÓN DEL NERVIO ÓPTICO Y DISGENESIA DE SEGMENTO ANTERIOR"
  },
  {
    "codigo":717218008,
    "descripcion":"GRUPO VB-3 DE LOS CENTROS PARA EL CONTROL Y LA PREVENCIÓN DE ENFERMEDADES O PSEUDOMONAS STUTZERI"
  },
  {
    "codigo":15865101000119104,
    "descripcion":"PARONIQUIA BILATERAL DE PULGAR"
  },
  {
    "codigo":92791005,
    "descripcion":"CARCINOMA IN SITU DE LA VAGINA"
  },
  {
    "codigo":60023006,
    "descripcion":"HIDROMETROCOLPOS"
  },
  {
    "codigo":289399008,
    "descripcion":"PRESENTACIÓN COMPUESTA PALPABLE POR VÍA VAGINAL"
  },
  {
    "codigo":25420003,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚLTIPLES SITIOS DEL PÁNCREAS CON HERIDA ABIERTA HACIA CAVIDAD ABDOMINAL"
  },
  {
    "codigo":58188004,
    "descripcion":"ARTROPATÍA TRAUMÁTICA"
  },
  {
    "codigo":10677671000119100,
    "descripcion":"HIPERHIDROSIS FOCAL PRIMARIA DE LA PLANTA DEL PIE"
  },
  {
    "codigo":123724007,
    "descripcion":"CITOPENIA TRANSITORIA"
  },
  {
    "codigo":1336140009,
    "descripcion":"EN RECUPERACIÓN DE EVENTO ADVERSO"
  },
  {
    "codigo":254796009,
    "descripcion":"TUMOR FIBROSO SOLITARIO DE PIEL"
  },
  {
    "codigo":23585005,
    "descripcion":"TRASTORNO DE ENZIMAS LISOSÓMICAS"
  },
  {
    "codigo":1268769007,
    "descripcion":"SELLADOR DE FISURA DENTAL SATISFACTORIO PARA ODONTÓLOGO"
  },
  {
    "codigo":218358001,
    "descripcion":"HIPOMELANOSIS DE ITO"
  },
  {
    "codigo":54518005,
    "descripcion":"PULSO AUSENTE"
  },
  {
    "codigo":1332470007,
    "descripcion":"ENFERMEDAD RENAL CRÓNICA ESTADIO 3A DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":251126009,
    "descripcion":"TRAZADO RSR EN V1 Y V2"
  },
  {
    "codigo":282059004,
    "descripcion":"LACERACIÓN DE YEYUNO"
  },
  {
    "codigo":314827004,
    "descripcion":"CONTROL DE EPILEPSIA, BUENO"
  },
  {
    "codigo":773579007,
    "descripcion":"DIARREA CRÓNICA CONGÉNITA CON ENTEROPATÍA CON PÉRDIDA DE PROTEÍNAS"
  },
  {
    "codigo":249291007,
    "descripcion":"DIURESIS INFRECUENTE"
  },
  {
    "codigo":118219009,
    "descripcion":"HALLAZGO SEXUAL MASCULINO"
  },
  {
    "codigo":183755008,
    "descripcion":"CONSULTA DOMICILIARIA OTORRINOLARINGOLÓGICA, REALIZADA"
  },
  {
    "codigo":444064003,
    "descripcion":"INFECCIÓN CAUSADA POR SCEDOSPORIUM BOYDII"
  },
  {
    "codigo":216523007,
    "descripcion":"INTOXICACIÓN ACCIDENTAL CAUSADA POR PROMAZINA"
  },
  {
    "codigo":445899009,
    "descripcion":"FRACTURA NO EXPUESTA DE TROCÁNTER DE FÉMUR"
  },
  {
    "codigo":1197728007,
    "descripcion":"ENTERITIS NO INFECCIOSA DEBIDA A ENFERMEDAD AUTOINMUNITARIA"
  },
  {
    "codigo":49013001,
    "descripcion":"DEFICIENCIA DE 17 ALFA - HIDROXIPROGESTERONA ALDOLASA"
  },
  {
    "codigo":737141002,
    "descripcion":"CREPITACIÓN DE ARTICULACIÓN TEMPOROMANDIBULAR DERECHA DURANTE LA APERTURA DE LA MANDÍBULA"
  },
  {
    "codigo":704373005,
    "descripcion":"FALTA DE CONFIANZA"
  },
  {
    "codigo":1163125006,
    "descripcion":"COLITIS POR SALMONELLA PARATYPHI C"
  },
  {
    "codigo":683431000119109,
    "descripcion":"DERMATOFIBROMA DE CUELLO"
  },
  {
    "codigo":1259594004,
    "descripcion":"CARCINOMA ADENOIDE QUÍSTICO ECRINO CUTÁNEO PRIMARIO"
  },
  {
    "codigo":15648321000119103,
    "descripcion":"ANEURISMA DE PORCIÓN EXTRACRANEAL DE ARTERIA CARÓTIDA INTERNA IZQUIERDA"
  },
  {
    "codigo":241951000,
    "descripcion":"REACCIÓN DE HIPERSENSIBILIDAD NO ALÉRGICA CAUSADA POR MEMBRANA DE DIÁLISIS"
  },
  {
    "codigo":276554009,
    "descripcion":"NUTRICIÓN PARENTERAL RELACIONADA CON HEPATITIS"
  },
  {
    "codigo":405791002,
    "descripcion":"ESCUPE EN FORMA EXCESIVA"
  },
  {
    "codigo":11306561000119104,
    "descripcion":"FRACTURA EXPUESTA DE HUESO ILÍACO IZQUIERDO"
  },
  {
    "codigo":733471003,
    "descripcion":"CARCINOMA RENAL DE CÉLULAS CROMÓFOBAS"
  },
  {
    "codigo":307487006,
    "descripcion":"ESTRIDOR BIFÁSICO"
  },
  {
    "codigo":897311008,
    "descripcion":"OSTEODISTROFIA RENAL CON TASA NORMAL DE RENOVACIÓN ÓSEA"
  },
  {
    "codigo":76276001,
    "descripcion":"LESIÓN TRAUMÁTICA DE VASOS POPLÍTEOS"
  },
  {
    "codigo":240116002,
    "descripcion":"MIOSITIS POR NEMATODO"
  },
  {
    "codigo":403956001,
    "descripcion":"NEOPLASIA MIXTA DE ANEXOS CUTÁNEOS, NO CLASIFICABLE"
  },
  {
    "codigo":698868004,
    "descripcion":"CON MAYOR RIESGO DE PÉRDIDA DE SANGRE DURANTE PROCEDIMIENTO QUIRÚRGICO"
  },
  {
    "codigo":1601000119105,
    "descripcion":"DESHIDRATACIÓN MODERADA"
  },
  {
    "codigo":373023008,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM COOKII"
  },
  {
    "codigo":766239009,
    "descripcion":"DISOMÍA UNIPARENTAL MATERNA DEL CROMOSOMA 6"
  },
  {
    "codigo":860873000,
    "descripcion":"PIEL REDUNDANTE GENERALIZADA DEBIDA A DESNUTRICIÓN"
  },
  {
    "codigo":305652004,
    "descripcion":"ATENDIDO POR UN ESPECIALISTA EN EL MANEJO DEL DOLOR"
  },
  {
    "codigo":11771611000119101,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA ANTERIOR DE CODO DERECHO"
  },
  {
    "codigo":41673007,
    "descripcion":"ATAQUE DE NERVIOS"
  },
  {
    "codigo":236446001,
    "descripcion":"NEFROCALCINOSIS CORTICAL"
  },
  {
    "codigo":1259488005,
    "descripcion":"DEMENCIA DEBIDA A ANGIOPATÍA AMILOIDÓTICA CEREBRAL"
  },
  {
    "codigo":39838007,
    "descripcion":"ARTRITIS OCRONÓTICA"
  },
  {
    "codigo":1186718008,
    "descripcion":"SÍNDROME DE ENCEFALOMIOPATÍA, MIOCARDIOPATÍA Y DIFICULTAD RESPIRATORIA NEONATAL"
  },
  {
    "codigo":234611002,
    "descripcion":"DEFICIENCIA DEL COMPONENTE 6"
  },
  {
    "codigo":300147005,
    "descripcion":"LÍQUIDO TRAS LA MEMBRANA TIMPÁNICA - HALLAZGO"
  },
  {
    "codigo":365683008,
    "descripcion":"EXAMEN MICROSCÓPICO DE ORINA: PRESENCIA DE CÉLULAS - HALLAZGO"
  },
  {
    "codigo":1217651008,
    "descripcion":"CATARATA CAPSULAR SENIL"
  },
  {
    "codigo":429384002,
    "descripcion":"NO SE USÓ EQUIPO DE SEGURIDAD"
  },
  {
    "codigo":298312007,
    "descripcion":"EQUILIBRIO NORMAL"
  },
  {
    "codigo":722461004,
    "descripcion":"SÍNDROME DE MEACHAM"
  },
  {
    "codigo":460317007,
    "descripcion":"MIOCARDITIS CAUSADA POR RICKETTSIA"
  },
  {
    "codigo":1179378005,
    "descripcion":"OSTEOMIELITIS CAUSADA POR SALMONELLA ENTERICA ENTERICA SEROVARIEDAD TYPHI"
  },
  {
    "codigo":391111000,
    "descripcion":"PRUEBA DE REVERSIBILIDAD AL SALBUTAMOL: NEGATIVA"
  },
  {
    "codigo":294642009,
    "descripcion":"ALERGIA A COMPONENTE DE VACUNA QUE CONTIENE ANTÍGENO DE CORYNEBACTERIUM DIPHTHERIAE"
  },
  {
    "codigo":720626009,
    "descripcion":"DISECCIÓN DE ARTERIA CARÓTIDA"
  },
  {
    "codigo":784327005,
    "descripcion":"PSORIASIS PUSTULOSA DE PLANTA DE PIE"
  },
  {
    "codigo":10888001,
    "descripcion":"DIETA LÍQUIDA"
  },
  {
    "codigo":28828001,
    "descripcion":"ATRESIA GÁSTRICA"
  },
  {
    "codigo":685941000119105,
    "descripcion":"LIPOSARCOMA PRIMARIO DE PARTES BLANDAS DE PELVIS"
  },
  {
    "codigo":225436004,
    "descripcion":"REFLEXIONAR"
  },
  {
    "codigo":61596005,
    "descripcion":"SÍNDROME DE MONONUCLEOSIS POSITIVO PARA VIRUS DE EPSTEIN BARR"
  },
  {
    "codigo":15978511000119100,
    "descripcion":"SÍNDROME MEDULAR ANTERIOR NO TRAUMÁTICO"
  },
  {
    "codigo":94364006,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA GLÁNDULA LAGRIMAL"
  },
  {
    "codigo":389276005,
    "descripcion":"DISPLASIA DE RÓTULA"
  },
  {
    "codigo":290972006,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR SUCCINIMIDA"
  },
  {
    "codigo":92529002,
    "descripcion":"CARCINOMA IN SITU DE MUCOSA DE CRESTA ALVEOLAR"
  },
  {
    "codigo":127132006,
    "descripcion":"LINFADENOPATÍA PANCREATOESPLÉNICA"
  },
  {
    "codigo":715121002,
    "descripcion":"SE TRANSFIERE DE LA SILLA DE RUEDAS A LA CAMA"
  },
  {
    "codigo":59761008,
    "descripcion":"DEFICIENCIA DE GLUTAMATO FORMIMINOTRANSFERASA"
  },
  {
    "codigo":188998002,
    "descripcion":"LIPOMA DE PARED ABDOMINAL"
  },
  {
    "codigo":331791000119103,
    "descripcion":"PÉRDIDA VISUAL TRANSITORIA DE OJO DERECHO"
  },
  {
    "codigo":449307001,
    "descripcion":"LINFOMA NO HODGKIN FOLICULAR DE OVARIO"
  },
  {
    "codigo":23323004,
    "descripcion":"ATRICOSIS"
  },
  {
    "codigo":283632002,
    "descripcion":"HERIDA POR PINCHAZO DE AGUJA EN LA CADERA"
  },
  {
    "codigo":185328004,
    "descripcion":"PACIENTE QUE SE PRESENTA MUY TARDE"
  },
  {
    "codigo":85189001,
    "descripcion":"APENDICITIS AGUDA"
  },
  {
    "codigo":19653005,
    "descripcion":"EFECTOS DEL RUIDO SOBRE EL OÍDO INTERNO"
  },
  {
    "codigo":52421005,
    "descripcion":"CATARATA INCIPIENTE"
  },
  {
    "codigo":249029007,
    "descripcion":"PRESENTACIÓN ESCASAMENTE ENCAJADA"
  },
  {
    "codigo":609477008,
    "descripcion":"INTERRUPCIÓN INDUCIDA DEL EMBARAZO COMPLICADA POR PERFORACIÓN DE ÚTERO"
  },
  {
    "codigo":1363141009,
    "descripcion":"ASTILLA EN CODO"
  },
  {
    "codigo":445637007,
    "descripcion":"DECISIÓN DELIBERADA DE NO USAR ANTICONCEPCIÓN"
  },
  {
    "codigo":247194002,
    "descripcion":"LESIÓN CORIORRETINIANA DIFUSA"
  },
  {
    "codigo":871621007,
    "descripcion":"ESTENOSIS ADQUIRIDA DE ÁREA SUBPULMONAR"
  },
  {
    "codigo":17818006,
    "descripcion":"DISCONDROSTOSIS DE LERI - WEILL"
  },
  {
    "codigo":81519008,
    "descripcion":"CAMBIO DE REFRACCIÓN TRANSITORIO"
  },
  {
    "codigo":1259332002,
    "descripcion":"CARCINOMA PRIMARIO DE PORCIÓN LATERAL DE PISO DE BOCA"
  },
  {
    "codigo":767812003,
    "descripcion":"NEOPLASIA DE HUESO DE LA MANO"
  },
  {
    "codigo":46916006,
    "descripcion":"IRIDOCICLITIS SECUNDARIA NO INFECCIOSA"
  },
  {
    "codigo":866116007,
    "descripcion":"HISTOPLASMOSIS AFRICANA LOCALIZADA"
  },
  {
    "codigo":208921000,
    "descripcion":"DESGARRO MENISCAL AGUDO, EXTERNO"
  },
  {
    "codigo":276292009,
    "descripcion":"HABILIDADES VISUOESPACIALES AISLADAS"
  },
  {
    "codigo":765977002,
    "descripcion":"TRASTORNO HEMORRÁGICO DEBIDO A DEFICIENCIA DE GLICOPROTEÍNA VI"
  },
  {
    "codigo":733209003,
    "descripcion":"QUEMADURA DE PIEL DEBIDA A EXPOSICIÓN A FUENTE ARTIFICIAL DE RADIACIÓN ULTRAVIOLETA"
  },
  {
    "codigo":12313004,
    "descripcion":"SÍNDROME DE RESISTENCIA A LOS ANDRÓGENOS"
  },
  {
    "codigo":307225003,
    "descripcion":"DOLOR PERIANAL"
  },
  {
    "codigo":698606000,
    "descripcion":"DEFECTO LOCALIZADO DE CAMPO VISUAL"
  },
  {
    "codigo":895214001,
    "descripcion":"DAÑO A ESTRUCTURA DE SOSTÉN DENTAL"
  },
  {
    "codigo":403694003,
    "descripcion":"CICATRIZ DEBIDA A CRIOTERAPIA Y POSTERIOR A ELLA"
  },
  {
    "codigo":1255662005,
    "descripcion":"CARCINOMA MIOEPITELIAL DE PULMÓN"
  },
  {
    "codigo":1222894008,
    "descripcion":"DIFICULTAD PARA PATEAR OBJETO"
  },
  {
    "codigo":762307002,
    "descripcion":"VESTIBULOPATÍA IDIOPÁTICA CRÓNICA IZQUIERDA"
  },
  {
    "codigo":238019007,
    "descripcion":"DEFICIENCIA TOTAL DE HEXOSAMINIDASA - JUVENIL"
  },
  {
    "codigo":301720003,
    "descripcion":"INCAPAZ DE REALIZAR ACTIVIDADES RELACIONADAS CON LA POSTULACIÓN A UN TRABAJO"
  },
  {
    "codigo":400024005,
    "descripcion":"QUEMADURA DE PIEL POR ÁLCALI"
  },
  {
    "codigo":1184621000,
    "descripcion":"PERIODONTITIS EXACERBADA POR SÍNDROME DE DOWN"
  },
  {
    "codigo":299885001,
    "descripcion":"CLONO DE TOBILLO SOSTENIDO"
  },
  {
    "codigo":365421002,
    "descripcion":"ONDA U ELECTROCARDIOGRÁFICA - HALLAZGO"
  },
  {
    "codigo":4973001,
    "descripcion":"HEMIBLOQUEO DE LA RAMA IZQUIERDA DEL HAZ DE HIS"
  },
  {
    "codigo":103277005,
    "descripcion":"REFLEJO ACÚSTICO NORMAL"
  },
  {
    "codigo":234349007,
    "descripcion":"ANEMIA MICROCÍTICA"
  },
  {
    "codigo":430957008,
    "descripcion":"INFECCIÓN DE PUNTA DE CATÉTER VENOSO CENTRAL"
  },
  {
    "codigo":199746004,
    "descripcion":"TRABAJO DE PARTO OBSTRUIDO"
  },
  {
    "codigo":789570006,
    "descripcion":"ÚLCERA NEUROPÁTICA DE PORCIÓN MEDIA DE PIE DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":296215000,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE DECANOATO DE FLUFENAZINA"
  },
  {
    "codigo":230679002,
    "descripcion":"ANOMALÍA DE LAS VESÍCULAS SINÁPTICAS"
  },
  {
    "codigo":165143003,
    "descripcion":"ENDOSCOPIA ANORMAL"
  },
  {
    "codigo":32236000,
    "descripcion":"LEUCOPLASIA DE ENCÍA"
  },
  {
    "codigo":334301000119105,
    "descripcion":"ECTROPIÓN SENIL DEL PÁRPADO INFERIOR DERECHO"
  },
  {
    "codigo":196076002,
    "descripcion":"PLEURESÍA SIN DERRAME O TUBERCULOSIS ACTIVA"
  },
  {
    "codigo":294380004,
    "descripcion":"ALERGIA A RIBAVIRINA"
  },
  {
    "codigo":292545003,
    "descripcion":"REACCIÓN ADVERSA AL OXITROPIO"
  },
  {
    "codigo":126870000,
    "descripcion":"NEOPLASIA DEL MESOCOLON"
  },
  {
    "codigo":30401009,
    "descripcion":"COMPLICACIÓN TARDÍA DEL MUÑÓN DE UNA AMPUTACIÓN"
  },
  {
    "codigo":94102002,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA FOSA AMIGDALINA"
  },
  {
    "codigo":92267000,
    "descripcion":"NEOPLASIA BENIGNA DE PARAGANGLIO"
  },
  {
    "codigo":714859003,
    "descripcion":"INCAPAZ DE ADAPTARSE A SITUACIÓN LABORAL"
  },
  {
    "codigo":254272000,
    "descripcion":"TRIPLOIDÍA Y POLIPLOIDÍA"
  },
  {
    "codigo":288875008,
    "descripcion":"NO LLEVA LÍQUIDOS A LA BOCA"
  },
  {
    "codigo":287040005,
    "descripcion":"RUPTURA DE LA MEMBRANA SINOVIAL - RODILLA"
  },
  {
    "codigo":385344006,
    "descripcion":"COMPORTAMIENTO DEL BORDE TUMORAL - HALLAZGO"
  },
  {
    "codigo":117521000119100,
    "descripcion":"CHORRO MICCIONAL DÉBIL DEBIDO A HIPERTROFIA PROSTÁTICA BENIGNA"
  },
  {
    "codigo":450880008,
    "descripcion":"HEPATITIS E CRÓNICA"
  },
  {
    "codigo":285205002,
    "descripcion":"CAPAZ DE RECORDAR LA FECHA DE HOY"
  },
  {
    "codigo":23061007,
    "descripcion":"ANOMALÍA CONGÉNITA DEL CARTÍLAGO CRICOIDES"
  },
  {
    "codigo":840426005,
    "descripcion":"ANOMALÍA DEL DESARROLLO DE AMBAS PLEURAS"
  },
  {
    "codigo":283370006,
    "descripcion":"LACERACIÓN DE CODO"
  },
  {
    "codigo":445375000,
    "descripcion":"NO UTILIZA ANTICONCEPCIÓN"
  },
  {
    "codigo":19391002,
    "descripcion":"SENSACIÓN DE IMPOTENCIA, MODERADA"
  },
  {
    "codigo":281535004,
    "descripcion":"FRACTURA DE MALÉOLO LATERAL"
  },
  {
    "codigo":52159006,
    "descripcion":"MESENTERIO UNIVERSAL"
  },
  {
    "codigo":1297343007,
    "descripcion":"CIERRE DE ÁNGULO DE OJO IZQUIERDO DEBIDO A NEOVASCULARIZACIÓN"
  },
  {
    "codigo":1295508006,
    "descripcion":"HIPERTENSIÓN OCULAR DE OJO IZQUIERDO DEBIDA A UVEÍTIS"
  },
  {
    "codigo":246932007,
    "descripcion":"HALLAZGO DEL EPITELIO CORNEAL"
  },
  {
    "codigo":115860008,
    "descripcion":"FENOTIPO DE GRUPO SANGUÍNEO CROMER"
  },
  {
    "codigo":1197204009,
    "descripcion":"CARCINOMA HEPATOCELULAR DEL ADULTO"
  },
  {
    "codigo":15721002,
    "descripcion":"DIETA CON SUPLEMENTO PROTEICO"
  },
  {
    "codigo":1074091000119101,
    "descripcion":"CONDROCALCINOSIS DE CODO IZQUIERDO"
  },
  {
    "codigo":16583441000119107,
    "descripcion":"ARTRITIS REACTIVA DE ARTICULACIÓN DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":212329005,
    "descripcion":"LESIÓN DE MÚLTIPLES NERVIOS A NIVEL DE LA CADERA Y EL MUSLO"
  },
  {
    "codigo":441705005,
    "descripcion":"CUADRIPLEJÍA COMPLETA DEBIDA A LESIÓN DE MÉDULA ESPINAL ENTRE PRIMERA Y CUARTA VÉRTEBRAS CERVICALES"
  },
  {
    "codigo":703849002,
    "descripcion":"ABSTINENCIA DE BENZODIACEPINA"
  },
  {
    "codigo":1162601008,
    "descripcion":"REQUIERE VACUNACIÓN CONTRA STREPTOCOCCUS PNEUMONIAE"
  },
  {
    "codigo":13886001,
    "descripcion":"NEFROPATÍA DREPANOCÍTICA"
  },
  {
    "codigo":1193534004,
    "descripcion":"PERCEPCIÓN DE ESTRÉS, ELEVADO"
  },
  {
    "codigo":1259070005,
    "descripcion":"TRASTORNO DE TICS DE INICIO EN LA ADULTEZ"
  },
  {
    "codigo":276030007,
    "descripcion":"VIAJAR AL EXTRANJERO"
  },
  {
    "codigo":110355003,
    "descripcion":"FALTA DE CAPACIDAD PARA RAZONAR"
  },
  {
    "codigo":274195004,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE TOBILLO"
  },
  {
    "codigo":40251000087101,
    "descripcion":"TENDINITIS DE BÍCEPS FEMORAL IZQUIERDO"
  },
  {
    "codigo":896787005,
    "descripcion":"FORMA ANCHA ANORMAL CONGÉNITA DE FALANGE PROXIMAL DE CUARTO DEDO DE PIE"
  },
  {
    "codigo":405267007,
    "descripcion":"DISFUNCIÓN SOMÁTICA CRÓNICA"
  },
  {
    "codigo":42984000,
    "descripcion":"SUDORACIÓN NOCTURNA"
  },
  {
    "codigo":336811000119105,
    "descripcion":"QUISTE PARASITARIO DE CUERPO CILIAR"
  },
  {
    "codigo":1157096002,
    "descripcion":"CONDUCTA AUTODESTRUCTIVA"
  },
  {
    "codigo":306963008,
    "descripcion":"ESTENOSIS COANAL"
  },
  {
    "codigo":47931000087104,
    "descripcion":"FRACTURA DE BASE DE QUINTO METATARSIANO DERECHO"
  },
  {
    "codigo":35131000087109,
    "descripcion":"KOCURIA ARSENATIS O KOCURIA RHIZOPHILA"
  },
  {
    "codigo":42811000087103,
    "descripcion":"HERIDA PUNZANTE DE MANO DERECHA DEBIDA A PINCHAZO DE AGUJA"
  },
  {
    "codigo":75752004,
    "descripcion":"TRASTORNO BIPOLAR I, EPISODIO MÁS RECIENTE DEPRESIVO CON SÍNTOMAS MELANCÓLICOS"
  },
  {
    "codigo":403432008,
    "descripcion":"CONDRODERMATITIS NODULAR DEL ANTEHÉLICE"
  },
  {
    "codigo":8381001,
    "descripcion":"FONTANELA HUNDIDA"
  },
  {
    "codigo":584836011000119107,
    "descripcion":"PORTADOR DE ENFERMEDAD DE ORINA CON OLOR A JARABE DE ARCE TIPO IB"
  },
  {
    "codigo":303293004,
    "descripcion":"EQUIMOSIS MUSCULAR"
  },
  {
    "codigo":73917004,
    "descripcion":"ALUCINOSIS"
  },
  {
    "codigo":301458000,
    "descripcion":"HALLAZGO RELACIONADO CON LA FUNCIÓN CARDIOVASCULAR"
  },
  {
    "codigo":1153426002,
    "descripcion":"CONDROSARCOMA DE CRÁNEO"
  },
  {
    "codigo":11805611000119109,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA PROXIMAL DE DEDO MEÑIQUE IZQUIERDO"
  },
  {
    "codigo":6546006,
    "descripcion":"INFECCIÓN CAUSADA POR GONGYLONEMA VERRUCOSUM"
  },
  {
    "codigo":103015000,
    "descripcion":"DOLOR RADICULAR TORÁCICO"
  },
  {
    "codigo":72082009,
    "descripcion":"DEFORMIDAD ADQUIRIDA DEL CUELLO"
  },
  {
    "codigo":1217127002,
    "descripcion":"CONTINUIDAD DE ATENCIÓN EFECTIVA"
  },
  {
    "codigo":4711003,
    "descripcion":"ANOMALÍA CONGÉNITA DE LOS CONDUCTOS BILIARES"
  },
  {
    "codigo":365159001,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD DE SECAR LA ROPA"
  },
  {
    "codigo":234087005,
    "descripcion":"TRASTORNOS DE LOS GANGLIOS LINFÁTICOS"
  },
  {
    "codigo":168551006,
    "descripcion":"RADIOGRAFÍA SIMPLE DE DIENTES ANORMAL"
  },
  {
    "codigo":70247006,
    "descripcion":"HIPOTENSIÓN POSTURAL HIPOADRENÉRGICA"
  },
  {
    "codigo":232252000,
    "descripcion":"OTITIS MEDIA AGUDA RECURRENTE NO SUPURATIVA"
  },
  {
    "codigo":299623008,
    "descripcion":"AMPLITUD DE ADUCCIÓN PASIVA DE DEDO DEL PIE NORMAL"
  },
  {
    "codigo":35644004,
    "descripcion":"HEMATOMA ATRAUMÁTICO DE TESTÍCULO"
  },
  {
    "codigo":428860005,
    "descripcion":"HERIDA PENETRANTE DE EXTREMIDAD SUPERIOR"
  },
  {
    "codigo":166716007,
    "descripcion":"CREATININA SÉRICA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":164881000,
    "descripcion":"ELECTROCARDIOGRAMA: EXTRASÍSTOLES"
  },
  {
    "codigo":33809001,
    "descripcion":"SECRECIÓN HORMONAL NORMAL"
  },
  {
    "codigo":230417001,
    "descripcion":"SÍNDROME DE WEST SINTOMÁTICO"
  },
  {
    "codigo":16012511000119101,
    "descripcion":"EMBOLIA DE ARTERIA DE MIEMBRO INFERIOR IZQUIERDO"
  },
  {
    "codigo":295953009,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE TRAZODONA"
  },
  {
    "codigo":294118006,
    "descripcion":"ALERGIA A CLEMASTINA"
  },
  {
    "codigo":62907002,
    "descripcion":"COMPLICACIÓN RESPIRATORIA"
  },
  {
    "codigo":292283003,
    "descripcion":"REACCIÓN ADVERSA A LA LOFEPRAMINA"
  },
  {
    "codigo":95675005,
    "descripcion":"NEURITIS CUBITAL"
  },
  {
    "codigo":1177019009,
    "descripcion":"ABSCESO DE LÓBULO TEMPORAL"
  },
  {
    "codigo":716432004,
    "descripcion":"CAPAZ DE PARTICIPAR EN ACTIVIDADES EN UN PATIO DE RECREO"
  },
  {
    "codigo":61072005,
    "descripcion":"FACTOR SOCIAL"
  },
  {
    "codigo":339321000119100,
    "descripcion":"PTOSIS MIÓGENA DEL OJO IZQUIERDO"
  },
  {
    "codigo":126608009,
    "descripcion":"NEOPLASIA DE PARTES BLANDAS DEL TRONCO"
  },
  {
    "codigo":288613006,
    "descripcion":"NO EMPLEA PALABRAS"
  },
  {
    "codigo":190309006,
    "descripcion":"ATROFIA TIROIDEA"
  },
  {
    "codigo":11834591000119108,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN DE PULGAR DERECHO"
  },
  {
    "codigo":417850002,
    "descripcion":"CONGESTIÓN DE VÍAS RESPIRATORIAS Y TOS"
  },
  {
    "codigo":1237050003,
    "descripcion":"METÁSTASIS DE CARCINOMA DE CARDIAS"
  },
  {
    "codigo":15740281000119103,
    "descripcion":"DEFORMIDAD ORBITARIA IZQUIERDA"
  },
  {
    "codigo":254010006,
    "descripcion":"FISURA FACIAL SUPRAORBITARIA - FISURA DE TESSIER TIPO 8"
  },
  {
    "codigo":286778007,
    "descripcion":"CARÁCTER CURIOSO"
  },
  {
    "codigo":186639003,
    "descripcion":"HEPATITIS VIRAL TIPO B CRÓNICA, SIN AGENTE DELTA"
  },
  {
    "codigo":12217721000119105,
    "descripcion":"FRACTURA DE HUESO ADYACENTE A PRÓTESIS DE ARTICULACIÓN DE RODILLA IZQUIERDA"
  },
  {
    "codigo":16641401000119105,
    "descripcion":"NEURITIS ILIOHIPOGÁSTRICA BILATERAL"
  },
  {
    "codigo":448783009,
    "descripcion":"DILATACIÓN DE VENA PULMONAR"
  },
  {
    "codigo":86500004,
    "descripcion":"CAMPILOBACTERIOSIS"
  },
  {
    "codigo":10825081000119106,
    "descripcion":"FRACTURA EXPUESTA DE CUARTO HUESO METACARPIANO DE MANO DERECHA"
  },
  {
    "codigo":446948006,
    "descripcion":"LESIÓN TRAUMÁTICA DE PLEXO LUMBAR"
  },
  {
    "codigo":1004004007,
    "descripcion":"TOCOFOBIA PRIMARIA"
  },
  {
    "codigo":283108008,
    "descripcion":"ARAÑAZO DE DORSO DE PIE"
  },
  {
    "codigo":281273001,
    "descripcion":"ESPÉCIMEN INADECUADO PARA ESTA PRUEBA"
  },
  {
    "codigo":1119539005,
    "descripcion":"EVALUACIÓN DE CAMPO VISUAL POR CONFRONTACIÓN ANORMAL"
  },
  {
    "codigo":19129003,
    "descripcion":"ESTADO CREPUSCULAR"
  },
  {
    "codigo":838329003,
    "descripcion":"TRASTORNO DEL DESARROLLO SEXUAL 46,XX DEBIDO A NEOPLASIA SUPRARRENAL MATERNA"
  },
  {
    "codigo":314041007,
    "descripcion":"DOLOR ABDOMINAL AL PRINCIPIO DEL EMBARAZO"
  },
  {
    "codigo":1196942001,
    "descripcion":"DEFICIENCIA ADQUIRIDA DE ANTITROMBINA III"
  },
  {
    "codigo":246670009,
    "descripcion":"DESCUIDO DE LA VISIÓN"
  },
  {
    "codigo":310371001,
    "descripcion":"INMUNIZACIÓN SUPRIMIDA"
  },
  {
    "codigo":212067004,
    "descripcion":"QUEMADURA QUE COMPROMETE 30-39 PORCIENTO DE LA SUPERFICIE DEL CUERPO, CON QUEMADURA DE ESPESOR COMPLETO QUE AFECTA 30-39 PORCIENTO DE LA SUPERFICIE CORPORAL"
  },
  {
    "codigo":15459006,
    "descripcion":"DEFECTO DE LA ALMOHADILLA ENDOCÁRDICA"
  },
  {
    "codigo":243000002,
    "descripcion":"LESIÓN POR BALA"
  },
  {
    "codigo":13624003,
    "descripcion":"MANO HENDIDA CONGÉNITA"
  },
  {
    "codigo":111928006,
    "descripcion":"INFECCIÓN CAUSADA POR GNATHOSTOMA SPINIGERUM"
  },
  {
    "codigo":275768008,
    "descripcion":"CUERPO EXTRAÑO EN ORINA"
  },
  {
    "codigo":110093003,
    "descripcion":"AVULSIÓN DEL PISO DE LA BOCA"
  },
  {
    "codigo":208397004,
    "descripcion":"FRACTURA NO EXPUESTA DE BASE DE HUESO METACARPIANO"
  },
  {
    "codigo":15933101000119101,
    "descripcion":"NEOPLASIA BENIGNA DE TROMPA DE FALOPIO IZQUIERDA"
  },
  {
    "codigo":763618001,
    "descripcion":"SÍNDROME DE WIEDEMANN STEINER"
  },
  {
    "codigo":403170002,
    "descripcion":"CALLOSIDAD DEBIDA A MORDIDA Y\/O MASTICACIÓN"
  },
  {
    "codigo":370402009,
    "descripcion":"MALESTAR INDUCIDO POR RADIACIÓN"
  },
  {
    "codigo":237495005,
    "descripcion":"NÓDULO TIROIDEO"
  },
  {
    "codigo":399500000,
    "descripcion":"LOCALIZACIÓN TUMORAL NO ESPECIFICADA"
  },
  {
    "codigo":71820002,
    "descripcion":"URGENCIA RECTAL"
  },
  {
    "codigo":235660003,
    "descripcion":"GASTRITIS FOLICULAR CRÓNICA"
  },
  {
    "codigo":6284004,
    "descripcion":"ABSCESO DE CUELLO"
  },
  {
    "codigo":366732008,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA BAJAR UNA COLINA"
  },
  {
    "codigo":1251468009,
    "descripcion":"METÁSTASIS DE OSTEOSARCOMA EN CARTÍLAGO ARTICULAR DE ESTERNÓN"
  },
  {
    "codigo":168289002,
    "descripcion":"ORGANISMO NO AISLADO EN CULTIVO DE HISOPADO OCULAR"
  },
  {
    "codigo":37217002,
    "descripcion":"MIOCARDITIS POR VIRUS COXSACKIE"
  },
  {
    "codigo":397665008,
    "descripcion":"ASISTENCIA MÉDICA COMPETENTE Y ÉTICA DE ACUERDO CON LOS ESTÁNDARES LEGALES DEL EJERCICIO DE LA PROFESIÓN"
  },
  {
    "codigo":364897008,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA MOVER LA PIERNA"
  },
  {
    "codigo":461366002,
    "descripcion":"HIPOPLASIA CONGÉNITA DE AORTA DESCENDENTE"
  },
  {
    "codigo":363062003,
    "descripcion":"COMPLICACIÓN DERMATOLÓGICA DE PROCEDIMIENTO"
  },
  {
    "codigo":789046004,
    "descripcion":"TRASTORNO DEL MOVIMIENTO RELACIONADO CON EL SUEÑO CAUSADO POR FÁRMACO"
  },
  {
    "codigo":231990003,
    "descripcion":"RETINITIS POR CANDIDA"
  },
  {
    "codigo":166454006,
    "descripcion":"HORMONAS SEXUALES MASCULINAS DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":233825009,
    "descripcion":"INFARTO AGUDO DE ONDA Q - ANTEROSEPTAL"
  },
  {
    "codigo":262923000,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE TESTÍCULO"
  },
  {
    "codigo":1149494008,
    "descripcion":"SEPSIS CAUSADA POR ERYSIPELOTHRIX RHUSIOPATHIAE"
  },
  {
    "codigo":721675002,
    "descripcion":"NEUMATOSIS INTESTINAL DE INTESTINO GRUESO"
  },
  {
    "codigo":230155003,
    "descripcion":"MENINGITIS NO INFECCIOSA"
  },
  {
    "codigo":228320001,
    "descripcion":"BEBEDOR HABITUAL"
  },
  {
    "codigo":31712002,
    "descripcion":"COLANGITIS BILIAR PRIMARIA"
  },
  {
    "codigo":719840003,
    "descripcion":"SÍNDROME DE DISPLASIA RENAL CON DEFECTO DE LAS EXTREMIDADES"
  },
  {
    "codigo":293856003,
    "descripcion":"ALERGIA A VILOXAZINA"
  },
  {
    "codigo":15716321000119100,
    "descripcion":"ENOSTOSIS DE HÚMERO IZQUIERDO"
  },
  {
    "codigo":11784161000119100,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE DEDO ÍNDICE DERECHO"
  },
  {
    "codigo":423093000,
    "descripcion":"TENDINITIS DE TENDÓN FLEXOR DE LA MANO"
  },
  {
    "codigo":95413004,
    "descripcion":"TENOSINOVITIS NODULAR"
  },
  {
    "codigo":1079111000119108,
    "descripcion":"CARCINOMA BASOCELULAR PRIMARIO DE PÁRPADO IZQUIERDO"
  },
  {
    "codigo":880010000,
    "descripcion":"ANOMALÍA ADQUIRIDA DE VÁLVULA AURICULOVENTRICULAR COMÚN POSTERIOR A REPARACIÓN DE COMUNICACIÓN AURICULOVENTRICULAR BIVENTRICULAR"
  },
  {
    "codigo":783541009,
    "descripcion":"LINFOMA ANAPLÁSICO DE CÉLULAS GRANDES ASOCIADO CON IMPLANTE MAMARIO"
  },
  {
    "codigo":191882002,
    "descripcion":"PATRÓN DE USO NOCIVO CONTINUO DE ALCOHOL SIN DEPENDENCIA"
  },
  {
    "codigo":93578003,
    "descripcion":"OSIFICACIÓN INCOMPLETA DE HUESO EXOCCIPITAL"
  },
  {
    "codigo":60810003,
    "descripcion":"EMBARAZO DE CUATRILLIZOS"
  },
  {
    "codigo":716170005,
    "descripcion":"SÍNDROME DE SORDERA CON CATARATAS Y ANOMALÍAS ESQUELÉTICAS"
  },
  {
    "codigo":341831000119108,
    "descripcion":"OPACIDAD CENTRAL DE CÓRNEA IZQUIERDA"
  },
  {
    "codigo":124511000,
    "descripcion":"DEFICIENCIA DE BETA - UREIDOPROPIONASA"
  },
  {
    "codigo":288351004,
    "descripcion":"INCAPAZ DE CONSTRUIR UNA TORRE"
  },
  {
    "codigo":253748000,
    "descripcion":"ANOMALÍA DE LA PLEURA"
  },
  {
    "codigo":286516000,
    "descripcion":"COCINA ALIMENTOS"
  },
  {
    "codigo":417588006,
    "descripcion":"PRUEBA DE HEAF GRADO 4"
  },
  {
    "codigo":448521006,
    "descripcion":"INCONTINENCIA SIN PERCEPCIÓN SENSITIVA"
  },
  {
    "codigo":415753007,
    "descripcion":"TRICOBEZOAR EN EL ESTÓMAGO"
  },
  {
    "codigo":1003742000,
    "descripcion":"CONTRACTURA EN FLEXIÓN DE ARTICULACIÓN METACARPOFALÁNGICA DE DEDO ÍNDICE"
  },
  {
    "codigo":446686000,
    "descripcion":"INTOXICACIÓN POR INGESTIÓN DE PLANTA"
  },
  {
    "codigo":282846006,
    "descripcion":"DIFICULTAD PARA MOVERSE DENTRO DE UNA POSICIÓN"
  },
  {
    "codigo":413918007,
    "descripcion":"MACROESTRÍAS DE COLGAJO CORNEAL"
  },
  {
    "codigo":51635000,
    "descripcion":"AUSENCIA CONGÉNITA DE TODOS LOS DEDOS DE LA MANO"
  },
  {
    "codigo":84403003,
    "descripcion":"INFIDELIDAD CIRCUNSTANCIAL"
  },
  {
    "codigo":45168341000119100,
    "descripcion":"PROLAPSO DE ENTEROSTOMÍA"
  },
  {
    "codigo":1085141000119101,
    "descripcion":"COMPLICACIÓN DEBIDA A PANCOLITIS ULCEROSA CRÓNICA"
  },
  {
    "codigo":125141000119102,
    "descripcion":"INCUMPLIMIENTO DE LA DIÁLISIS RENAL"
  },
  {
    "codigo":10848981000119101,
    "descripcion":"CUERPO EXTRAÑO EN EL PUNTO LAGRIMAL DERECHO"
  },
  {
    "codigo":304341000119104,
    "descripcion":"GOTA TOFÁCEA CRÓNICA DE MUÑECA DEBIDA A DISFUNCIÓN RENAL"
  },
  {
    "codigo":15971541000119105,
    "descripcion":"HERNIA CRURAL IZQUIERDA"
  },
  {
    "codigo":291541000119104,
    "descripcion":"HEMORRAGIA ESPONTÁNEA DE TRONCO ENCEFÁLICO"
  },
  {
    "codigo":15958741000119107,
    "descripcion":"MELANOMA MALIGNO METASTÁSICO DE RIÑÓN DERECHO"
  },
  {
    "codigo":683221000119107,
    "descripcion":"NEVO MELANOCÍTICO CONGÉNITO DE PIEL DE LA CARA"
  },
  {
    "codigo":294101000119109,
    "descripcion":"HEMIPLEJÍA DE LADO IZQUIERDO DOMINANTE"
  },
  {
    "codigo":11857621000119102,
    "descripcion":"SUBLUXACIÓN TRAUMÁTICA DE TENDÓN DE MÚSCULO PERONEO IZQUIERDO"
  },
  {
    "codigo":15935701000119103,
    "descripcion":"DEFORMIDAD CONGÉNITA DE CLAVÍCULA IZQUIERDA"
  },
  {
    "codigo":1231283007,
    "descripcion":"DEFICIENCIA CONGÉNITA AISLADA DE ACTH (ADRENOCORTICOTROFINA)"
  },
  {
    "codigo":127701000119109,
    "descripcion":"VARIANTE CUBITAL POSITIVA DE MUÑECA, CONGÉNITA"
  },
  {
    "codigo":137941000119106,
    "descripcion":"HIPERLIPIDEMIA DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":11811541000119107,
    "descripcion":"CONTUSIÓN DE CUERPO DEL PÁNCREAS"
  },
  {
    "codigo":306901000119109,
    "descripcion":"DERRAME ARTICULAR DE LA REGIÓN DEL HOMBRO IZQUIERDO"
  },
  {
    "codigo":1260381005,
    "descripcion":"PARKINSONISMO CAUSADO POR AGENTE ANTIDOPAMINÉRGICO"
  },
  {
    "codigo":703325005,
    "descripcion":"INSUFICIENCIA DE VÁLVULA AÓRTICA DEBIDA A DISECCIÓN DE AORTA"
  },
  {
    "codigo":406578005,
    "descripcion":"INFECCIÓN DEL SISTEMA NERVIOSO CENTRAL POR ENTEROVIRUS"
  },
  {
    "codigo":699655001,
    "descripcion":"LIGAMENTO ESTILOHIOIDEO CALCIFICADO"
  },
  {
    "codigo":44295002,
    "descripcion":"COLOBOMA CONGÉNITO DE PAPILA ÓPTICA"
  },
  {
    "codigo":109831001,
    "descripcion":"NEOPLASIA MALIGNA SUPERPUESTA DEL PALADAR"
  },
  {
    "codigo":1081621000119104,
    "descripcion":"RABDOMIOSARCOMA PRIMARIO DE CADERA IZQUIERDA"
  },
  {
    "codigo":77063006,
    "descripcion":"DIETA PARA HIPERLIPOPROTEINEMIA, TIPO IV"
  },
  {
    "codigo":371975007,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL BORDE DE LA LENGUA"
  },
  {
    "codigo":304604001,
    "descripcion":"REACCIÓN TRANSFUSIONAL INMEDIATA"
  },
  {
    "codigo":765191009,
    "descripcion":"SÍNDROME DE LA RETINA CON MANCHAS DE KANDORI"
  },
  {
    "codigo":402908003,
    "descripcion":"VERRUGA BUCAL"
  },
  {
    "codigo":271836003,
    "descripcion":"ABDOMEN TIMPÁNICO"
  },
  {
    "codigo":344341000119106,
    "descripcion":"CICATRIZ CORIORRETINIANA POSTINFLAMATORIA DE AMBOS OJOS"
  },
  {
    "codigo":1287644005,
    "descripcion":"TUMOR NEUROENDOCRINO BIEN DIFERENCIADO PRIMARIO DE ÍLEON"
  },
  {
    "codigo":237233002,
    "descripcion":"EMBARAZO OCULTO"
  },
  {
    "codigo":302769004,
    "descripcion":"REGURGITA LUEGO DE TRAGAR"
  },
  {
    "codigo":106161006,
    "descripcion":"HALLAZGO EN EL UNDÉCIMO PAR CRANEAL"
  },
  {
    "codigo":268166000,
    "descripcion":"PABELLÓN AURICULAR Y CONDUCTO AUDITIVO EXTERNO AUSENTES"
  },
  {
    "codigo":169862005,
    "descripcion":"PESO AL NACER IGUAL A 10%-24% (2850-3149 G)"
  },
  {
    "codigo":6022005,
    "descripcion":"MIOCARDIOPATÍA DILATADA DEBIDA A SARCOIDOSIS"
  },
  {
    "codigo":299099003,
    "descripcion":"AMPLITUD DE ADUCCIÓN ACTIVA DE DEDO DE LA MANO AUMENTADA"
  },
  {
    "codigo":168027007,
    "descripcion":"ANÁLISIS BIOQUÍMICO DE LÍQUIDO ASCÍTICO, NO SE DETECTARON ANOMALÍAS"
  },
  {
    "codigo":36955009,
    "descripcion":"AGEUSIA"
  },
  {
    "codigo":67888001,
    "descripcion":"REACCIÓN A TRANSFUSIÓN CAUSADA POR EFECTO TÓXICO DE ANTICOAGULANTE"
  },
  {
    "codigo":297264002,
    "descripcion":"DILATACIÓN FIJA DE LA PUPILA IZQUIERDA"
  },
  {
    "codigo":1149232006,
    "descripcion":"INFECCIÓN DE FÍSTULA URACAL"
  },
  {
    "codigo":461104009,
    "descripcion":"INTERRUPCIÓN DE ARTERIA CORONARIA"
  },
  {
    "codigo":262661004,
    "descripcion":"LESIÓN PENETRANTE DE MUCOSA YUGAL"
  },
  {
    "codigo":197125005,
    "descripcion":"SÍNDROME DEL INTESTINO IRRITABLE CON DIARREA"
  },
  {
    "codigo":295429005,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE FÁRMACO ANTAGONISTA DE RECEPTOR 5-HT3"
  },
  {
    "codigo":517007,
    "descripcion":"CUERPO EXTRAÑO EN LA HIPOFARINGE"
  },
  {
    "codigo":721413008,
    "descripcion":"LACERACIÓN MENOR DE VENA YUGULAR INTERNA"
  },
  {
    "codigo":162522003,
    "descripcion":"DIETA CON ALTO CONTENIDO DE FIBRA INSOLUBLE"
  },
  {
    "codigo":16046511000119109,
    "descripcion":"ENFERMEDAD POR DEPÓSITO DE HIDROXIAPATITA DE AMBAS MANOS"
  },
  {
    "codigo":719578005,
    "descripcion":"SÍNDROME DE MICRODUPLICACIÓN 16P13.11"
  },
  {
    "codigo":15692361000119103,
    "descripcion":"QUERATITIS LAMINAR DIFUSA DE OJO IZQUIERDO"
  },
  {
    "codigo":424666005,
    "descripcion":"CARCINOMA BASOCELULAR DE PABELLÓN AURICULAR"
  },
  {
    "codigo":293594008,
    "descripcion":"ALERGIA A METADONA"
  },
  {
    "codigo":129754005,
    "descripcion":"CALCIFICACIÓN RADIOGRÁFICA CON CENTRO RADIOLÚCIDO"
  },
  {
    "codigo":226223007,
    "descripcion":"DIETA AFROCARIBEÑA"
  },
  {
    "codigo":95151009,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL TRONCO"
  },
  {
    "codigo":160687009,
    "descripcion":"TIENE ACCESO A UN AUTOMÓVIL"
  },
  {
    "codigo":109832008,
    "descripcion":"NEOPLASIA MALIGNA SUPERPUESTA DE LA OROFARINGE"
  },
  {
    "codigo":60548004,
    "descripcion":"QUERATOCONJUNTIVITIS EPIDÉMICA"
  },
  {
    "codigo":191620005,
    "descripcion":"TRASTORNO AFECTIVO BIPOLAR, EPISODIO ACTUAL MANÍACO, LEVE"
  },
  {
    "codigo":420996007,
    "descripcion":"COMA DEBIDO A DIABETES MELLITUS RELACIONADA CON DESNUTRICIÓN"
  },
  {
    "codigo":715908008,
    "descripcion":"DISTROFIA CON EROSIÓN RECURRENTE DEL EPITELIO CORNEAL"
  },
  {
    "codigo":781444009,
    "descripcion":"DISTENSIÓN DEL TENDÓN DEL MÚSCULO EXTENSOR LARGO DEL PULGAR"
  },
  {
    "codigo":714073008,
    "descripcion":"RECESIÓN GINGIVAL INTERPROXIMAL"
  },
  {
    "codigo":286254001,
    "descripcion":"CAPAZ DE PRODUCIR SONIDOS DEL HABLA"
  },
  {
    "codigo":253486005,
    "descripcion":"DISPLASIA DE VÁLVULA AURICULOVENTRICULAR IZQUIERDA"
  },
  {
    "codigo":187950009,
    "descripcion":"NEOPLASIA MALIGNA DE FALANGES DE LA MANO"
  },
  {
    "codigo":1300227001,
    "descripcion":"CIERRE DE ÁNGULO SECUNDARIO DE OJO DERECHO - SINEQUIAL"
  },
  {
    "codigo":448259002,
    "descripcion":"SARCOMA DE MEDIASTINO POSTERIOR"
  },
  {
    "codigo":55043004,
    "descripcion":"PERICARDITIS INDUCIDA POR PROCAINAMIDA"
  },
  {
    "codigo":346851000119105,
    "descripcion":"CONJUNTIVITIS CRÓNICA DE AMBOS OJOS"
  },
  {
    "codigo":315352000,
    "descripcion":"CATARATA SUBCAPSULAR ANTERIOR"
  },
  {
    "codigo":282584005,
    "descripcion":"SALTA"
  },
  {
    "codigo":15967101000119100,
    "descripcion":"MALFORMACIÓN CONGÉNITA DE HUESO DE TÓRAX"
  },
  {
    "codigo":413656006,
    "descripcion":"LEUCEMIA MIELOIDE CRÓNICA EN FASE BLÁSTICA"
  },
  {
    "codigo":53208009,
    "descripcion":"TENDINITIS DE MÚSCULO PERONEO"
  },
  {
    "codigo":444589003,
    "descripcion":"DETECCIÓN DE NEOPLASIA MALIGNA EN EL INTERVALO ENTRE EVALUACIONES DE CRIBADO RECOMENDADAS"
  },
  {
    "codigo":247981003,
    "descripcion":"INVADE EL ESPACIO PERSONAL DE OTROS"
  },
  {
    "codigo":870573008,
    "descripcion":"NEUMONITIS INTERSTICIAL CON CARACTERÍSTICAS AUTOINMUNITARIAS"
  },
  {
    "codigo":442754001,
    "descripcion":"HALLAZGO NO DEFINITORIO RELACIONADO CON EVALUACIÓN"
  },
  {
    "codigo":213378007,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE AMBOS PIES"
  },
  {
    "codigo":770434009,
    "descripcion":"RETINA MOTEADA FAMILIAR BENIGNA"
  },
  {
    "codigo":735831001,
    "descripcion":"LACERACIÓN DE ARCO PALMAR SUPERFICIAL"
  },
  {
    "codigo":80471007,
    "descripcion":"INTOXICACIÓN POR ESPECIE DE DIGITALIS"
  },
  {
    "codigo":111404004,
    "descripcion":"PERINEFRITIS"
  },
  {
    "codigo":766764008,
    "descripcion":"ATROFIA MUSCULAR ESPINAL DISTAL LIGADA AL CROMOSOMA X TIPO 3"
  },
  {
    "codigo":209708009,
    "descripcion":"SECCIÓN EXPUESTA DE LIGAMENTO DE PIE"
  },
  {
    "codigo":699393002,
    "descripcion":"TIRONEO DE LA PROPIA OREJA"
  },
  {
    "codigo":11265003,
    "descripcion":"HEMICOREA"
  },
  {
    "codigo":109569003,
    "descripcion":"CARIES DENTAL SECUNDARIA A DEFECTOS ADQUIRIDOS DE LA ESTRUCTURA DENTAL"
  },
  {
    "codigo":240641005,
    "descripcion":"LEISHMANIASIS CUTÁNEA ZOONÓTICA CLÁSICA"
  },
  {
    "codigo":304342003,
    "descripcion":"AMPLITUD DE MOVIMIENTO DE COLUMNA VERTEBRAL CERVICAL NORMAL"
  },
  {
    "codigo":271574003,
    "descripcion":"FUSIÓN PARCIAL CONGÉNITA DE COLUMNA VERTEBRAL"
  },
  {
    "codigo":42198007,
    "descripcion":"DESVIACIÓN DE PENE"
  },
  {
    "codigo":402646008,
    "descripcion":"TRASTORNO DE SECRECIÓN APOCRINA"
  },
  {
    "codigo":7595001,
    "descripcion":"PRIVACIÓN MATERNA"
  },
  {
    "codigo":238806009,
    "descripcion":"EDEMA HEMORRÁGICO AGUDO INFANTIL"
  },
  {
    "codigo":130071000119104,
    "descripcion":"TRISOMÍA 18 DETECTADA MEDIANTE CRIBADO CON MÚLTIPLES MARCADORES"
  },
  {
    "codigo":204203001,
    "descripcion":"HIPOPLASIA DE PÁRPADO"
  },
  {
    "codigo":38528001,
    "descripcion":"AINHUM"
  },
  {
    "codigo":235136001,
    "descripcion":"QUEILITIS GRANULOMATOSA"
  },
  {
    "codigo":366208002,
    "descripcion":"HALLAZGO RELACIONADO CON EL ESTADO DE LAS VENAS PERFORANTES"
  },
  {
    "codigo":300672006,
    "descripcion":"CRUZA LA CALLE"
  },
  {
    "codigo":11844631000119107,
    "descripcion":"TRANSECCIÓN COMPLETA DE AORTA TORÁCICA"
  },
  {
    "codigo":167765007,
    "descripcion":"EXAMEN DE SEMEN: MUY BAJA FERTILIDAD"
  },
  {
    "codigo":722986000,
    "descripcion":"INFARTO VENOSO CRÓNICO DE MÉDULA ESPINAL"
  },
  {
    "codigo":397141009,
    "descripcion":"EVALUACIÓN MAMOGRÁFICA (CATEGORÍA 2) - HALLAZGO BENIGNO"
  },
  {
    "codigo":67626002,
    "descripcion":"INFECCIÓN CAUSADA POR MONIEZIA"
  },
  {
    "codigo":297002005,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE AMIODARONA"
  },
  {
    "codigo":1148970006,
    "descripcion":"GESTACIÓN MÚLTIPLE DE ALTO ORDEN DEBIDA A PROCEDIMIENTO DE REPRODUCCIÓN MÉDICAMENTE ASISTIDA Y POSTERIOR A ÉL"
  },
  {
    "codigo":295167001,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE BUPRENORFINA"
  },
  {
    "codigo":229631007,
    "descripcion":"TARTAMUDEO ADQUIRIDO"
  },
  {
    "codigo":65791008,
    "descripcion":"DEFICIENCIA DE APRT, TIPO JAPONÉS"
  },
  {
    "codigo":196863007,
    "descripcion":"HERNIA UMBILICAL IRREDUCTIBLE"
  },
  {
    "codigo":424404003,
    "descripcion":"INSUFICIENCIA CARDÍACA CRÓNICA DESCOMPENSADA"
  },
  {
    "codigo":719316004,
    "descripcion":"DISARTRIA ADQUIRIDA"
  },
  {
    "codigo":293332005,
    "descripcion":"REACCIÓN ADVERSA AL ANTICOAGULANTE DE ACCIÓN DIRECTA"
  },
  {
    "codigo":291497005,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR AZITROMICINA"
  },
  {
    "codigo":1340073006,
    "descripcion":"RUPTURA ACCIDENTAL DE VACUNA DURANTE SU MANIPULACIÓN"
  },
  {
    "codigo":94889006,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL RIÑÓN"
  },
  {
    "codigo":193193007,
    "descripcion":"POLINEUROPATÍA EN LA PELAGRA"
  },
  {
    "codigo":93054001,
    "descripcion":"DILATACIÓN CONGÉNITA DE LA ARTERIA CARÓTIDA"
  },
  {
    "codigo":289662001,
    "descripcion":"LESIÓN DE ÚTERO"
  },
  {
    "codigo":715646003,
    "descripcion":"MIOPATÍA RELACIONADA CON DESMINA CON INCLUSIONES SIMILARES A LOS CUERPOS DE MALLORY"
  },
  {
    "codigo":191358004,
    "descripcion":"EOSINOFILIA HEREDITARIA"
  },
  {
    "codigo":349361000119109,
    "descripcion":"NEOPLASIA BENIGNA DE COROIDES DERECHA"
  },
  {
    "codigo":224126007,
    "descripcion":"FAMILIA CON NIÑOS EN EDAD ESCOLAR"
  },
  {
    "codigo":418899001,
    "descripcion":"EFECTOS DE LA DESCARGA INDIRECTA DE UN RAYO"
  },
  {
    "codigo":255059002,
    "descripcion":"TUMOR BENIGNO DE TORAX"
  },
  {
    "codigo":123987009,
    "descripcion":"ÁCIDO ORÓTICO POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":449832007,
    "descripcion":"LABERINTITIS OSIFICANTE"
  },
  {
    "codigo":187688008,
    "descripcion":"NEOPLASIA MALIGNA DE PARED POSTERIOR DE OROFARINGE"
  },
  {
    "codigo":284157000,
    "descripcion":"INCAPAZ DE MOVER UN PIE"
  },
  {
    "codigo":253224008,
    "descripcion":"CATARATA POLAR ANTERIOR CONGÉNITA"
  },
  {
    "codigo":447997006,
    "descripcion":"ANILLO VASCULAR CON ARTERIA PULMONAR DERECHA RETROTRAQUEAL DESDE AORTA ASCENDENTE"
  },
  {
    "codigo":54781007,
    "descripcion":"HIPERCALIEMIA, REDUCCIÓN DE LA EXCRECIÓN RENAL"
  },
  {
    "codigo":249554000,
    "descripcion":"MATIDEZ ABDOMINAL LOCALIZADA A LA PERCUSIÓN - HALLAZGO"
  },
  {
    "codigo":218621006,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR PIROXICAM"
  },
  {
    "codigo":870311000,
    "descripcion":"PROTEINURIA DE BENCE JONES PERSISTENTE"
  },
  {
    "codigo":444327002,
    "descripcion":"CARCINOMAS PRIMARIOS SINCRÓNICOS"
  },
  {
    "codigo":313255002,
    "descripcion":"ADHERENCIAS DEL TABIQUE NASAL"
  },
  {
    "codigo":247719004,
    "descripcion":"PATRONES QUE PARECEN INTERESANTES"
  },
  {
    "codigo":18343006,
    "descripcion":"CIRCUNSTANCIALIDAD"
  },
  {
    "codigo":409724008,
    "descripcion":"SISTEMA INTERNACIONAL DE ESTADIFICACIÓN DE NEUROBLASTOMA, ESTADIO 2B"
  },
  {
    "codigo":735569003,
    "descripcion":"ANOMALÍA ADQUIRIDA DE AURÍCULA CARDÍACA"
  },
  {
    "codigo":309585006,
    "descripcion":"SÍNCOPE Y COLAPSO"
  },
  {
    "codigo":276817007,
    "descripcion":"MENINGOENCEFALITIS LINFOCÍTICA"
  },
  {
    "codigo":473425008,
    "descripcion":"INTOXICACIÓN POR HIDROCARBURO FLUORADO"
  },
  {
    "codigo":209446003,
    "descripcion":"ESGUINCE DE LIGAMENTO RADIOSEMILUNAR"
  },
  {
    "codigo":307750004,
    "descripcion":"ABORTO COMPLETO INEVITABLE COMPLICADO CON EMBOLIA"
  },
  {
    "codigo":897574006,
    "descripcion":"ANOMALÍA CONGÉNITA DE VESTÍBULO DEL OÍDO INTERNO"
  },
  {
    "codigo":109307002,
    "descripcion":"OSTEOMIELITIS DE HUESO TEMPORAL"
  },
  {
    "codigo":11003002,
    "descripcion":"DIARREA NERVIOSA"
  },
  {
    "codigo":240379005,
    "descripcion":"TUBERCULOSIS DE LOS ÓRGANOS GENITALES MASCULINOS"
  },
  {
    "codigo":43771008,
    "descripcion":"MORFOLOGÍA NO APLICABLE"
  },
  {
    "codigo":74704000,
    "descripcion":"DOLOR ABDOMINAL QUE SE IRRADIA HACIA LA ESPALDA"
  },
  {
    "codigo":9168005,
    "descripcion":"ACTIVIDAD GÁSTRICA ELÉCTRICA ANORMAL"
  },
  {
    "codigo":238544008,
    "descripcion":"DERMATITIS ATÓPICA ERITRODÉRMICA"
  },
  {
    "codigo":402384009,
    "descripcion":"URTICARIA ALÉRGICA CAUSADA POR ALIMENTO INGERIDO"
  },
  {
    "codigo":236709004,
    "descripcion":"CÁLCULO EN DIVERTÍCULO CALICIAL"
  },
  {
    "codigo":203941007,
    "descripcion":"ESPINA BÍFIDA CERVICAL CON HIDROCEFALIA - ABIERTA"
  },
  {
    "codigo":351871000119108,
    "descripcion":"NEVO MELANOCÍTICO DE MIEMBRO INFERIOR DERECHO"
  },
  {
    "codigo":105637008,
    "descripcion":"ENFERMEDAD CAUSADA POR ENDAMOEBIDAE"
  },
  {
    "codigo":726394000,
    "descripcion":"DELECIÓN DE PARTE DEL BRAZO CORTO DEL CROMOSOMA 19"
  },
  {
    "codigo":679551000119109,
    "descripcion":"MUCOCELE DE SACO LAGRIMAL DERECHO"
  },
  {
    "codigo":365946005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA CONTROLAR LA AGRESIÓN"
  },
  {
    "codigo":267642007,
    "descripcion":"CONJUNTIVITIS MUCOPURULENTA AGUDA"
  },
  {
    "codigo":298575001,
    "descripcion":"COLUMNA VERTEBRAL DORSAL ESTABLE"
  },
  {
    "codigo":15726361000119104,
    "descripcion":"ARTROFITO EN ARTICULACIÓN DE PIE IZQUIERDO"
  },
  {
    "codigo":36431005,
    "descripcion":"LINFANGITIS ESCLEROSANTE DE PENE DE ORIGEN NO VENÉREO"
  },
  {
    "codigo":724559006,
    "descripcion":"MIOPATÍA CONCOMITANTE CON HIPERCALCEMIA Y DEBIDA A ELLA"
  },
  {
    "codigo":429647007,
    "descripcion":"HALLADO EN EL ASIENTO DEL PASAJERO DE UN AUTOMÓVIL"
  },
  {
    "codigo":165668000,
    "descripcion":"PRUEBA DE KLEIHAUER NORMAL"
  },
  {
    "codigo":1052239007,
    "descripcion":"PARESIA DE CUERDA VOCAL IZQUIERDA"
  },
  {
    "codigo":396879006,
    "descripcion":"SIN ACTIVIDAD MITÓTICA"
  },
  {
    "codigo":1828006,
    "descripcion":"INFESTACIÓN CAUSADA POR GASTEROPHILUS HAEMORRHOIDALIS"
  },
  {
    "codigo":198436008,
    "descripcion":"SOFOCONES MENOPÁUSICOS"
  },
  {
    "codigo":10811161000119107,
    "descripcion":"TRASTORNO DEPRESIVO MAYOR EN LA MADRE QUE COMPLICA EL EMBARAZO"
  },
  {
    "codigo":131065003,
    "descripcion":"NIVEL DE ESTRADIOL POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":360441005,
    "descripcion":"AGANGLIONOSIS COLÓNICA"
  },
  {
    "codigo":196601009,
    "descripcion":"ESOFAGITIS GANGRENOSA"
  },
  {
    "codigo":293070002,
    "descripcion":"REACCIÓN ADVERSA A FÁRMACO ANTITUBERCULOSO"
  },
  {
    "codigo":424142003,
    "descripcion":"RESISTENCIA A LA RETROPULSIÓN DEL GLOBO OCULAR"
  },
  {
    "codigo":159921000146103,
    "descripcion":"NUNCA SE SIENTE INSEGURO EN RELACIÓN AL CUIDADO DE UN NIÑO"
  },
  {
    "codigo":291235003,
    "descripcion":"INTOXICACIÓN POR INHIBIDOR DE DESCARBOXILASA"
  },
  {
    "codigo":782755007,
    "descripcion":"SÍNDROME DE MICROCEFALIA PRIMARIA, DISCAPACIDAD INTELECTUAL LEVE Y DIABETES DE COMIENZO EN LA JUVENTUD"
  },
  {
    "codigo":94627008,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE PERITONEO"
  },
  {
    "codigo":289400001,
    "descripcion":"PRESENTACIÓN VISIBLE POR VAGINA - HALLAZGO"
  },
  {
    "codigo":92792003,
    "descripcion":"CARCINOMA IN SITU DE LA VALÉCULA"
  },
  {
    "codigo":254797000,
    "descripcion":"HEMANGIOPERICITOMA MALIGNO CUTÁNEO"
  },
  {
    "codigo":58189007,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA GARGANTA"
  },
  {
    "codigo":1336141008,
    "descripcion":"ALTERACIÓN DE ARTICULACIÓN DE REGIÓN DE MUÑECA"
  },
  {
    "codigo":123725008,
    "descripcion":"HIPERPLASIA LEVE DE LA MÉDULA ÓSEA"
  },
  {
    "codigo":354381000119103,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE CONDUCTO DE GLÁNDULA LAGRIMAL DERECHA"
  },
  {
    "codigo":54519002,
    "descripcion":"ESTENOSIS DE ARTERIA BASILAR"
  },
  {
    "codigo":1332471006,
    "descripcion":"ENFERMEDAD RENAL CRÓNICA ESTADIO 3B DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":118220003,
    "descripcion":"HALLAZGO SEXUAL FEMENINO"
  },
  {
    "codigo":445900004,
    "descripcion":"NEUROTMESIS DE NERVIO PERIFÉRICO"
  },
  {
    "codigo":183756009,
    "descripcion":"CONSULTA DOMICILIARIA ORTOPÉDICA REALIZADA"
  },
  {
    "codigo":314828009,
    "descripcion":"CONTROL DE EPILEPSIA, POBRE"
  },
  {
    "codigo":282060009,
    "descripcion":"PERFORACIÓN DE YEYUNO"
  },
  {
    "codigo":1197729004,
    "descripcion":"COLANGITIS INTRAHEPÁTICA DEBIDA A COLELITIASIS INTRAHEPÁTICA"
  },
  {
    "codigo":1091661000119108,
    "descripcion":"COLESTEATOMA DE MASTOIDES DERECHA"
  },
  {
    "codigo":18081009,
    "descripcion":"CAMPILOBACTERIOSIS ENTÉRICA"
  },
  {
    "codigo":704374004,
    "descripcion":"FALTA DE ORGULLO"
  },
  {
    "codigo":12206311000119103,
    "descripcion":"INFECCIÓN ASOCIADA A IMPLANTE PROTÉSICO DE MAMA DERECHA"
  },
  {
    "codigo":868214006,
    "descripcion":"INFARTO AGUDO DE MIOCARDIO CON ELEVACIÓN DEL SEGMENTO ST DEBIDO A OCLUSIÓN DE PORCIÓN PROXIMAL DE ARTERIA CORONARIA DERECHA"
  },
  {
    "codigo":1163126007,
    "descripcion":"COLITIS POR SHIGELLA"
  },
  {
    "codigo":702539000,
    "descripcion":"INESTABILIDAD GENERAL DE TOBILLO"
  },
  {
    "codigo":737142009,
    "descripcion":"CREPITACIÓN DE ARTICULACIÓN TEMPOROMANDIBULAR IZQUIERDA DURANTE LA APERTURA DE LA MANDÍBULA"
  },
  {
    "codigo":1259595003,
    "descripcion":"EXTRAVASACIÓN DE LÍQUIDO CEFALORRAQUÍDEO DEBIDA A DRENAJE INSUFICIENTE DE DERIVACIÓN VENTRICULAR"
  },
  {
    "codigo":47179003,
    "descripcion":"INFECCIÓN CAUSADA POR PENTASTOMA DENTICULATUM"
  },
  {
    "codigo":473163005,
    "descripcion":"EMBOLIZACIÓN DE FRAGMENTO DE DISPOSITIVO VASCULAR DURANTE CATETERISMO CARDÍACO"
  },
  {
    "codigo":276555005,
    "descripcion":"TRASTORNO PERINATAL RELACIONADO CON LA REGULACIÓN DE GLUCOSA EN EL FETO Y\/O RECIÉN NACIDO"
  },
  {
    "codigo":897312001,
    "descripcion":"OSTEODISTROFIA RENAL CON BAJA TASA DE RENOVACIÓN ÓSEA"
  },
  {
    "codigo":373024002,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM DIERNHOFERI"
  },
  {
    "codigo":733472005,
    "descripcion":"SÍNDROME DE MICROCEFALIA, GLOMERULONEFRITIS Y HÁBITO MARFANOIDE"
  },
  {
    "codigo":766240006,
    "descripcion":"DISOMÍA UNIPARENTAL MATERNA DEL CROMOSOMA 9"
  },
  {
    "codigo":241952007,
    "descripcion":"ANAFILAXIA INDUCIDA POR EJERCICIO"
  },
  {
    "codigo":1290528008,
    "descripcion":"RADIOGRAFÍA DE TIBIA ANORMAL"
  },
  {
    "codigo":371189003,
    "descripcion":"AQUIRIA BILATERAL"
  },
  {
    "codigo":10741005,
    "descripcion":"ENFERMEDAD POR ALMACENAMIENTO DE LÍPIDOS"
  },
  {
    "codigo":240117006,
    "descripcion":"MIOSITIS POR TRIQUINOSIS"
  },
  {
    "codigo":41674001,
    "descripcion":"LABERINTITIS SEROSA"
  },
  {
    "codigo":402122002,
    "descripcion":"INFECCIÓN DE LA PIEL POR CITOMEGALOVIRUS"
  },
  {
    "codigo":305653009,
    "descripcion":"ATENDIDO POR UN PATÓLOGO"
  },
  {
    "codigo":15702401000119103,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE TENDÓN DE CUÁDRICEPS IZQUIERDO"
  },
  {
    "codigo":1186719000,
    "descripcion":"PREDISPOSICIÓN A UNA ENFERMEDAD FÚNGICA INVASORA POR DEFICIENCIA DE CARD9"
  },
  {
    "codigo":10869121000119104,
    "descripcion":"HERIDA PUNZANTE DE REGIÓN LUMBAR"
  },
  {
    "codigo":39839004,
    "descripcion":"HERNIA DIAFRAGMÁTICA"
  },
  {
    "codigo":236447005,
    "descripcion":"NEFROCALCINOSIS MEDULAR"
  },
  {
    "codigo":7071007,
    "descripcion":"PATRÓN DE USO NOCIVO DE FENCICLIDINA"
  },
  {
    "codigo":301983008,
    "descripcion":"HALLAZGO RELACIONADO CON EL EQUILIBRIO OCULAR"
  },
  {
    "codigo":1217652001,
    "descripcion":"CATARATA CALCIFICADA ASOCIADA A EDAD"
  },
  {
    "codigo":365684002,
    "descripcion":"HALLAZGO RELACIONADO CON EL CONTENIDO DE CÉLULAS EN LÍQUIDO CEFALORRAQUÍDEO"
  },
  {
    "codigo":300148000,
    "descripcion":"HALLAZGO RELACIONADO CON EL COLOR DE LA MEMBRANA TIMPÁNICA"
  },
  {
    "codigo":234612009,
    "descripcion":"DEFICIENCIA DEL COMPONENTE 7"
  },
  {
    "codigo":16740891000119102,
    "descripcion":"POSICIÓN ANÓMALA DE STENT URETERAL"
  },
  {
    "codigo":1279518001,
    "descripcion":"AUSENTISMO ESCOLAR"
  },
  {
    "codigo":165406005,
    "descripcion":"HEMOGRAMA COMPLETO DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1345054009,
    "descripcion":"HIPOPLASIA UNILATERAL CONGÉNITA DE MÚSCULO DEPRESOR DEL ÁNGULO DE LA BOCA"
  },
  {
    "codigo":1179379002,
    "descripcion":"MENINGITIS POR VIRUS DEL HERPES SIMPLE 1"
  },
  {
    "codigo":65267003,
    "descripcion":"INFECCIÓN CAUSADA POR LEPTOSPIRA PYROGENES"
  },
  {
    "codigo":784328000,
    "descripcion":"PSORIASIS PUSTULOSA DE PALMA DE MANO"
  },
  {
    "codigo":1144776001,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR LEVOTIROXINA"
  },
  {
    "codigo":63432002,
    "descripcion":"RESPUESTA TERAPÉUTICA, EXCELENTE"
  },
  {
    "codigo":292808002,
    "descripcion":"REACCIÓN ADVERSA A LA GRISEOFULVINA"
  },
  {
    "codigo":820048411000119105,
    "descripcion":"ÚLCERA VENOSA DE REGIÓN MEDIA DE PIE DERECHO"
  },
  {
    "codigo":30664006,
    "descripcion":"NEOPLASIA ENDOCRINA MÚLTIPLE, TIPO 1"
  },
  {
    "codigo":1208477000,
    "descripcion":"LESIONES CUTÁNEAS MACULARES ATRÓFICAS EN CONFETTI"
  },
  {
    "codigo":389277001,
    "descripcion":"DISPLASIA CIFORROTULIANA"
  },
  {
    "codigo":127133001,
    "descripcion":"LINFADENOPATÍA ESPLÉNICA"
  },
  {
    "codigo":94365007,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL INTESTINO GRUESO"
  },
  {
    "codigo":225437008,
    "descripcion":"PIENSA DE MANERA REALISTA"
  },
  {
    "codigo":59762001,
    "descripcion":"SECRECIÓN ANORMAL DE GLÁNDULA EXOCRINA"
  },
  {
    "codigo":92530007,
    "descripcion":"CARCINOMA IN SITU DE LA AMPOLLA DE VATER"
  },
  {
    "codigo":289138007,
    "descripcion":"SIEMPRE TOMA EL DESAYUNO"
  },
  {
    "codigo":715122009,
    "descripcion":"SE TRANSFIERE DE LA SILLA DE RUEDAS AL AUTOMÓVIL"
  },
  {
    "codigo":25159003,
    "descripcion":"PELO FRÁGIL"
  },
  {
    "codigo":188999005,
    "descripcion":"LIPOMA DEL PERINEO"
  },
  {
    "codigo":254535007,
    "descripcion":"CARCINOMA DE LA PORCIÓN CERVICAL DEL ESÓFAGO"
  },
  {
    "codigo":285468000,
    "descripcion":"CAPAZ DE CERRAR LA BOCA"
  },
  {
    "codigo":88860002,
    "descripcion":"NEUMOCISTOSIS"
  },
  {
    "codigo":449308006,
    "descripcion":"NEOPLASIA MALIGNA DE PLEURA VISCERAL"
  },
  {
    "codigo":303951000119101,
    "descripcion":"GOTA CRÓNICA DE CADERA, SIN TOFO, DEBIDA A DISFUNCIÓN RENAL"
  },
  {
    "codigo":283633007,
    "descripcion":"HERIDA POR PINCHAZO DE AGUJA EN EL MUSLO"
  },
  {
    "codigo":16032591000119102,
    "descripcion":"NECROSIS AVASCULAR DE MITAD IZQUIERDA DE PELVIS"
  },
  {
    "codigo":871622000,
    "descripcion":"VÁLVULA AURICULOVENTRICULAR COMÚN CON DESEQUILIBRIO HACIA VENTRÍCULO"
  },
  {
    "codigo":249030002,
    "descripcion":"PRESENTACIÓN BIEN ENCAJADA"
  },
  {
    "codigo":1363142002,
    "descripcion":"ASTILLA EN CODO CON INFECCIÓN"
  },
  {
    "codigo":609478003,
    "descripcion":"INTERRUPCIÓN INDUCIDA DEL EMBARAZO COMPLICADA POR PERFORACIÓN DE VAGINA"
  },
  {
    "codigo":773318006,
    "descripcion":"ORINA DE OLOR DULZÓN"
  },
  {
    "codigo":771483000,
    "descripcion":"INFECCIÓN CAUSADA POR ESPOROZOOS"
  },
  {
    "codigo":247195001,
    "descripcion":"HALLAZGO RELACIONADO CON LA COROIDES"
  },
  {
    "codigo":83355007,
    "descripcion":"INTOXICACIÓN POR PSILOSTROPHE"
  },
  {
    "codigo":1162864000,
    "descripcion":"PORENCEFALIA FAMILIAR"
  },
  {
    "codigo":10625871000119105,
    "descripcion":"NEUMOCONIOSIS POR POLVO ORGÁNICO"
  },
  {
    "codigo":48752009,
    "descripcion":"FRACTURA NO EXPUESTA DE HUESO HIOIDES"
  },
  {
    "codigo":140111000119107,
    "descripcion":"HIPERTENSIÓN EN ENFERMEDAD RENAL CRÓNICA EN ESTADIO 4 DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":866117003,
    "descripcion":"LEISHMANIASIS CUTÁNEA LOCALIZADA CONCOMITANTE CON LINFANGITIS NODULAR"
  },
  {
    "codigo":276293004,
    "descripcion":"HABILIDADES AISLADAS PARA EL USO DEL CALENDARIO"
  },
  {
    "codigo":46917002,
    "descripcion":"ASINCLITISMO ANTERIOR"
  },
  {
    "codigo":1259333007,
    "descripcion":"CARCINOMA PRIMARIO DE PALADAR DURO"
  },
  {
    "codigo":210757008,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA A NIVEL DE TOBILLO"
  },
  {
    "codigo":767813008,
    "descripcion":"NEOPLASIA DE HÚMERO"
  },
  {
    "codigo":307226002,
    "descripcion":"ADENOCARCINOMA METASTÁSICO DE ETIOLOGÍA DESCONOCIDA"
  },
  {
    "codigo":15678441000119103,
    "descripcion":"ENDOFTALMITIS CRÓNICA DE OJO IZQUIERDO"
  },
  {
    "codigo":45082006,
    "descripcion":"ORQUITIS AGUDA"
  },
  {
    "codigo":208922007,
    "descripcion":"DESGARRO AGUDO DE MENISCO EXTERNO, CUERNO ANTERIOR"
  },
  {
    "codigo":895215000,
    "descripcion":"DAÑO DENTAL CON COMPROMISO DE LA PULPA"
  },
  {
    "codigo":733210008,
    "descripcion":"QUEMADURA DE PIEL DEBIDA A LUMINOTERAPIA CON LUZ ULTRAVIOLETA Y POSTERIOR A ELLA"
  },
  {
    "codigo":403695002,
    "descripcion":"QUEMADURA CAUSADA POR LÁSER"
  },
  {
    "codigo":1255663000,
    "descripcion":"CARCINOMA MIOEPITELIAL DE TRÁQUEA"
  },
  {
    "codigo":16907241000119105,
    "descripcion":"MELANOMA IN SITU DE PÁRPADO INFERIOR DERECHO"
  },
  {
    "codigo":1222895009,
    "descripcion":"PATEA OBJETO"
  },
  {
    "codigo":10927081000119105,
    "descripcion":"FRACTURA NO EXPUESTA DE DIÁFISIS DE CUARTO HUESO METACARPIANO DE MANO IZQUIERDA"
  },
  {
    "codigo":238020001,
    "descripcion":"DEFICIENCIA TOTAL DE HEXOSAMINIDASA - ADULTO"
  },
  {
    "codigo":8644006,
    "descripcion":"PLENITUD EPIGÁSTRICA"
  },
  {
    "codigo":762308007,
    "descripcion":"VESTIBULOPATÍA IDIOPÁTICA CRÓNICA DERECHA"
  },
  {
    "codigo":687081000119107,
    "descripcion":"NEUROFIBROMA DE TÓRAX"
  },
  {
    "codigo":203417003,
    "descripcion":"OSTEOCONDROSIS DE LA COLUMNA VERTEBRAL DEL ADULTO"
  },
  {
    "codigo":301721004,
    "descripcion":"REALIZA ACTIVIDADES RELACIONADAS CON LA POSTULACIÓN A UN TRABAJO"
  },
  {
    "codigo":299886000,
    "descripcion":"CLONO DE TOBILLO NO SOSTENIDO"
  },
  {
    "codigo":103278000,
    "descripcion":"REFLEJO ACÚSTICO ANORMAL"
  },
  {
    "codigo":430958003,
    "descripcion":"INFECCIÓN DE CATÉTER DE DIÁLISIS PERITONEAL"
  },
  {
    "codigo":234350007,
    "descripcion":"ANEMIA NEONATAL"
  },
  {
    "codigo":68675004,
    "descripcion":"DEGENERACIÓN DE DISCO INTERVERTEBRAL TORÁCICO"
  },
  {
    "codigo":789571005,
    "descripcion":"ÚLCERA DE TALÓN DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":199747008,
    "descripcion":"TRABAJO DE PARTO OBSTRUIDO POR POSICIÓN FETAL ANÓMALA"
  },
  {
    "codigo":722200003,
    "descripcion":"ÚLCERA DUODENAL CAUSADA POR ANTIINFLAMATORIO NO ESTEROIDEO"
  },
  {
    "codigo":294381000,
    "descripcion":"ALERGIA A TRIFLUOROTIMIDINA"
  },
  {
    "codigo":1344792008,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE TENDÓN DE MÚSCULO PLANTAR"
  },
  {
    "codigo":165144009,
    "descripcion":"GASTROSCOPIA ANORMAL"
  },
  {
    "codigo":196077006,
    "descripcion":"PLEURESÍA SECA AGUDA"
  },
  {
    "codigo":425453009,
    "descripcion":"DISECCIÓN CRÓNICA NO TRAUMÁTICA DE AORTA TORÁCICA"
  },
  {
    "codigo":292546002,
    "descripcion":"REACCIÓN ADVERSA A LA OXIBUTININA"
  },
  {
    "codigo":126871001,
    "descripcion":"NEOPLASIA DE EPIPLÓN"
  },
  {
    "codigo":290711003,
    "descripcion":"INTOXICACIÓN POR CARBOPLATINO"
  },
  {
    "codigo":61335007,
    "descripcion":"DIFERENCIAS VENTILATORIAS REGIONALES"
  },
  {
    "codigo":94103007,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL PILAR AMIGDALINO"
  },
  {
    "codigo":92268005,
    "descripcion":"NEOPLASIA BENIGNA DE LOS GANGLIOS LINFÁTICOS PARAMAMARIOS"
  },
  {
    "codigo":10683831000119100,
    "descripcion":"NÓDULO DE TEJIDO CELULAR SUBCUTÁNEO DE AMBAS PIERNAS"
  },
  {
    "codigo":714860008,
    "descripcion":"NO ALCANZA LA FRECUENCIA CARDÍACA OBJETIVO"
  },
  {
    "codigo":288876009,
    "descripcion":"DIFICULTAD PARA LLEVAR LÍQUIDOS A LA BOCA"
  },
  {
    "codigo":188737002,
    "descripcion":"CLOROMA"
  },
  {
    "codigo":11857181000119107,
    "descripcion":"HEMATOMA SUBUNGUEAL DE SEGUNDO A QUINTO DEDOS DE PIE IZQUIERDO"
  },
  {
    "codigo":254273005,
    "descripcion":"DELECIÓN AUTOSÓMICA - MOSAICISMO"
  },
  {
    "codigo":450881007,
    "descripcion":"HIPERMETRÍA"
  },
  {
    "codigo":23062000,
    "descripcion":"CONGESTIÓN PASIVA DEL ESTÓMAGO"
  },
  {
    "codigo":287041009,
    "descripcion":"RUPTURA DE LA MEMBRANA SINOVIAL - TOBILLO\/PIE"
  },
  {
    "codigo":15953181000119108,
    "descripcion":"RETRACCIÓN DE PEZÓN DERECHO"
  },
  {
    "codigo":88598008,
    "descripcion":"INTERACCIÓN SOCIAL DETERIORADA"
  },
  {
    "codigo":840427001,
    "descripcion":"DERMATOSIS CAUSADA POR ÁCARO ZOONÓTICO"
  },
  {
    "codigo":283371005,
    "descripcion":"LACERACIÓN DEL ANTEBRAZO"
  },
  {
    "codigo":248768001,
    "descripcion":"ERECCIÓN INADECUADA"
  },
  {
    "codigo":1297344001,
    "descripcion":"CIERRE DE ÁNGULO DE AMBOS OJOS DEBIDO A NEOVASCULARIZACIÓN"
  },
  {
    "codigo":281536003,
    "descripcion":"FRACTURA DE HUESO CUNEIFORME"
  },
  {
    "codigo":89681000119101,
    "descripcion":"GLOMERULONEFRITIS CONCOMITANTE CON ESCLERODERMIA Y DEBIDA A ELLA"
  },
  {
    "codigo":335441000119101,
    "descripcion":"DESCEMETOCELE DE OJO DERECHO"
  },
  {
    "codigo":50325005,
    "descripcion":"ESTEATOSIS HEPÁTICA POR ALCOHOL"
  },
  {
    "codigo":1197205005,
    "descripcion":"INMUNODEFICIENCIA COMBINADA POR DEFICIENCIA DE DOCK8"
  },
  {
    "codigo":115861007,
    "descripcion":"FENOTIPO INAB"
  },
  {
    "codigo":1295509003,
    "descripcion":"HIPERTENSIÓN OCULAR BILATERAL DEBIDA A UVEÍTIS"
  },
  {
    "codigo":1162602001,
    "descripcion":"AMPLIFICACIÓN DE GEN DE RECEPTOR 2 DE FACTOR DE CRECIMIENTO EPIDÉRMICO DETECTADA"
  },
  {
    "codigo":703850002,
    "descripcion":"DELIRIO POR ABSTINENCIA DE BENZODIACEPINA"
  },
  {
    "codigo":81258004,
    "descripcion":"INTOXICACIÓN POR GÉNERO EUPHORBIA"
  },
  {
    "codigo":767551003,
    "descripcion":"HERIDA DE LA PIEL FETAL POR ESCALPELO DEBIDA A PROCEDIMIENTO DURANTE EL PARTO"
  },
  {
    "codigo":1193535003,
    "descripcion":"TRASTORNO FETAL DEBIDO A TRASTORNO PLACENTARIO"
  },
  {
    "codigo":46655005,
    "descripcion":"INTOXICACIÓN POR COBRE"
  },
  {
    "codigo":896788000,
    "descripcion":"FORMA ANCHA ANORMAL CONGÉNITA DE FALANGE PROXIMAL DE QUINTO DEDO DE PIE"
  },
  {
    "codigo":1259071009,
    "descripcion":"TRASTORNO DE SISTEMA NERVIOSO AUTÓNOMO CAUSADO POR DISOLVENTE ORGÁNICO"
  },
  {
    "codigo":306964002,
    "descripcion":"HALLAZGO RELACIONADO CON LAS COANAS POSTERIORES"
  },
  {
    "codigo":274196003,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE LA CADERA"
  },
  {
    "codigo":208660000,
    "descripcion":"FRACTURA EXPUESTA DE TOBILLO, MALÉOLO EXTERNO, SUPERIOR"
  },
  {
    "codigo":7761000119106,
    "descripcion":"TRASTORNO PSICÓTICO CAUSADO POR ANFETAMINAS"
  },
  {
    "codigo":308971000119100,
    "descripcion":"TENDINITIS CALCIFICANTE DE RODILLA IZQUIERDA"
  },
  {
    "codigo":15736401000119106,
    "descripcion":"TRASTORNO DE CÓRNEA DE AMBOS OJOS"
  },
  {
    "codigo":732948003,
    "descripcion":"PARAPLEJÍA ESPÁSTICA AUTOSÓMICA DOMINANTE TIPO 10"
  },
  {
    "codigo":241428009,
    "descripcion":"ABSORCIÓN DE LA VITAMINA B12"
  },
  {
    "codigo":403433003,
    "descripcion":"CONDRODERMATITIS NODULAR DEL TRAGO"
  },
  {
    "codigo":10217006,
    "descripcion":"LACERACIÓN PERINEAL DE TERCER GRADO"
  },
  {
    "codigo":235923000,
    "descripcion":"CÁLCULO RETENIDO EN EL CONDUCTO BILIAR"
  },
  {
    "codigo":72083004,
    "descripcion":"SÍFILIS TARDÍA"
  },
  {
    "codigo":1153427006,
    "descripcion":"CONDROSARCOMA DE COLUMNA VERTEBRAL"
  },
  {
    "codigo":301459008,
    "descripcion":"HEMODINAMICAMENTE ESTABLE"
  },
  {
    "codigo":234088000,
    "descripcion":"GANGLIO LINFÁTICO HIPERPLÁSICO"
  },
  {
    "codigo":46101000087106,
    "descripcion":"ESGUINCE DE LIGAMENTO SACROILÍACO DERECHO"
  },
  {
    "codigo":299624002,
    "descripcion":"AMPLITUD DE ADUCCIÓN PASIVA DE DEDO DEL PIE AUMENTADA"
  },
  {
    "codigo":103016004,
    "descripcion":"DOLOR RADICULAR LUMBOSACRO"
  },
  {
    "codigo":40981000087104,
    "descripcion":"QUEMADURA DE MAMA DERECHA"
  },
  {
    "codigo":365160006,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD DE ABROCHAR Y DESABROCHAR ROPA"
  },
  {
    "codigo":37480005,
    "descripcion":"PLIEGUE DE LA RETINA"
  },
  {
    "codigo":43541000087108,
    "descripcion":"CONTUSIÓN DE PÁRPADO INFERIOR IZQUIERDO"
  },
  {
    "codigo":166717003,
    "descripcion":"CREATININA SÉRICA POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":461629004,
    "descripcion":"PATRÓN DE RAMIFICACIÓN DE CAYADO AÓRTICO DERECHO"
  },
  {
    "codigo":66578000,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE MEJILLA CON INFECCIÓN"
  },
  {
    "codigo":427026001,
    "descripcion":"CON RIESGO AUMENTADO DE SANGRADO POR TRATAMIENTO CON ASPIRINA"
  },
  {
    "codigo":428861009,
    "descripcion":"TRASTORNO DE CARTÍLAGO ARTICULAR DE CADERA"
  },
  {
    "codigo":295954003,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE TRAZODONA"
  },
  {
    "codigo":230418006,
    "descripcion":"SÍNDROME DE LENNOX-GASTAUT"
  },
  {
    "codigo":164882007,
    "descripcion":"ELECTROCARDIOGRAMA: AUSENCIA DE EXTRASÍSTOLES"
  },
  {
    "codigo":294119003,
    "descripcion":"ALERGIA A MEBHIDROLINA"
  },
  {
    "codigo":31975004,
    "descripcion":"FRACTURA DE HUESO ESCAFOIDES DE MUÑECA"
  },
  {
    "codigo":1177020003,
    "descripcion":"INFECCIÓN PARASITARIA DE NERVIO CRANEAL"
  },
  {
    "codigo":423356004,
    "descripcion":"FOTISMO INDUCIDO POR SONIDO"
  },
  {
    "codigo":95676006,
    "descripcion":"PARESTESIA DE BERGER"
  },
  {
    "codigo":126609001,
    "descripcion":"NEOPLASIA DE PARTES BLANDAS DEL TÓRAX"
  },
  {
    "codigo":292284009,
    "descripcion":"REACCIÓN ADVERSA A LA NORTRIPTILINA"
  },
  {
    "codigo":337951000119101,
    "descripcion":"RETINOSQUISIS DEL OJO IZQUIERDO"
  },
  {
    "codigo":1339025008,
    "descripcion":"ENCEFALOPATÍA CAUSADA POR RADIACIÓN IONIZANTE"
  },
  {
    "codigo":93841009,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LOS ÓRGANOS INTRATORÁCICOS"
  },
  {
    "codigo":288614000,
    "descripcion":"DIFICULTAD PARA EMPLEAR PALABRAS"
  },
  {
    "codigo":716433009,
    "descripcion":"CAPAZ DE RESOLVER PROBLEMAS"
  },
  {
    "codigo":92006001,
    "descripcion":"NEOPLASIA BENIGNA DE VASO SANGUÍNEO DEL MIEMBRO INFERIOR"
  },
  {
    "codigo":57403001,
    "descripcion":"GRADO DE GLEASON: 7"
  },
  {
    "codigo":712763001,
    "descripcion":"STREPTOCOCCUS EQUI O STREPTOCOCCUS DYSGALACTIAE SUBESPECIE EQUISIMILIS"
  },
  {
    "codigo":1237051004,
    "descripcion":"METÁSTASIS DE CARCINOMA DE TERCIO INFERIOR DE ESÓFAGO"
  },
  {
    "codigo":254011005,
    "descripcion":"FISURA SUPRAORBITARIA DE TESSIER 9"
  },
  {
    "codigo":286779004,
    "descripcion":"TIENDE A LA FALTA DE CURIOSIDAD"
  },
  {
    "codigo":1075231000119105,
    "descripcion":"DEFORMIDAD ADQUIRIDA EN CAVOVARO DE PIE IZQUIERDO"
  },
  {
    "codigo":448784003,
    "descripcion":"SEPSIS CAUSADA POR HERPES SIMPLE"
  },
  {
    "codigo":283109000,
    "descripcion":"ARAÑAZO DE LA PLANTA DEL PIE"
  },
  {
    "codigo":284944009,
    "descripcion":"CAPAZ DE PARARSE EN INODORO"
  },
  {
    "codigo":314042000,
    "descripcion":"PLEURESÍA INFECCIOSA"
  },
  {
    "codigo":1004005008,
    "descripcion":"TOCOFOBIA SECUNDARIA"
  },
  {
    "codigo":248506002,
    "descripcion":"EDEMA DE RETINA GENERALIZADO"
  },
  {
    "codigo":772794003,
    "descripcion":"PROLAPSO DE MUCOSA URETRAL"
  },
  {
    "codigo":15712441000119103,
    "descripcion":"TROMBOSIS CRÓNICA DE VENA CAVA INFERIOR"
  },
  {
    "codigo":281274007,
    "descripcion":"ESPÉCIMEN CONTIENE CRIOAGLUTININAS"
  },
  {
    "codigo":838330008,
    "descripcion":"GANGLIONOPATÍA AUTOINMUNITARIA"
  },
  {
    "codigo":11862201000119104,
    "descripcion":"ABRASIÓN INFECTADA DE PIEL DE REGIÓN DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":246671008,
    "descripcion":"VISIÓN DE COLORES DE ACUERDO AL ESTÁNDAR ESTABLECIDO"
  },
  {
    "codigo":50063009,
    "descripcion":"HERNIA CRURAL"
  },
  {
    "codigo":769124002,
    "descripcion":"MICELIOS DEL REINO FUNGI DETECTADOS"
  },
  {
    "codigo":48228003,
    "descripcion":"PERIENDOCARDITIS SUBAGUDA"
  },
  {
    "codigo":277604002,
    "descripcion":"NEOPLASIA MIELOIDE-LINFOIDE MALIGNA"
  },
  {
    "codigo":1162340005,
    "descripcion":"OSTEONECROSIS DE TOBILLO DEBIDA A HEMOGLOBINOPATÍA"
  },
  {
    "codigo":12081491000119100,
    "descripcion":"QUEMADURA DE CÓRNEA DE OJO IZQUIERDO"
  },
  {
    "codigo":310372008,
    "descripcion":"SITUACIÓN DE INVITACIÓN A PROCEDIMIENTO DE VACUNACIÓN"
  },
  {
    "codigo":212068009,
    "descripcion":"CORROSIÓN QUE COMPROMETE EL 30 AL 39 PORCIENTO DE LA SUPERFICIE CORPORAL"
  },
  {
    "codigo":79161002,
    "descripcion":"DISMETRÍA OCULAR"
  },
  {
    "codigo":243001003,
    "descripcion":"LESIÓN POR BALA DE ALTA VELOCIDAD"
  },
  {
    "codigo":308537004,
    "descripcion":"SITUACIÓN DEL CONTROL"
  },
  {
    "codigo":111929003,
    "descripcion":"INFECCIÓN CAUSADA POR CYLICOSTEPHANUS"
  },
  {
    "codigo":110094009,
    "descripcion":"LACERACIÓN SIMPLE DE LA MUCOSA LABIAL"
  },
  {
    "codigo":403171003,
    "descripcion":"CALLOSIDAD CAUSADA POR ROCE CON PRÓTESIS Y\/O DISPOSITIVO"
  },
  {
    "codigo":1156835005,
    "descripcion":"ENFERMEDAD DE CHARCOT-MARIE-TOOTH AUTOSÓMICA DOMINANTE TIPO 2"
  },
  {
    "codigo":75491005,
    "descripcion":"AMIOTROFIA CONGÉNITA"
  },
  {
    "codigo":304867008,
    "descripcion":"APEGO AUTÓNOMO"
  },
  {
    "codigo":763619009,
    "descripcion":"SÍNDROME DE MECHÓN FRONTAL BLANCO CON MALFORMACIONES"
  },
  {
    "codigo":204728005,
    "descripcion":"ESTENOSIS CONGÉNITA DE RECTO CON FÍSTULA"
  },
  {
    "codigo":1077741000119100,
    "descripcion":"OSTEOMIELITIS DE FÉMUR IZQUIERDO"
  },
  {
    "codigo":1901000124103,
    "descripcion":"TRANSICIÓN DE LA ATENCIÓN DOMICILIARIA A ATENCIÓN AGUDA"
  },
  {
    "codigo":268429000,
    "descripcion":"RADIOGRAFÍA SIMPLE DE ABDOMEN EN BIPEDESTACIÓN NORMAL"
  },
  {
    "codigo":40888008,
    "descripcion":"ANOMALÍA CONGÉNITA DEL SISTEMA HEMATOPOYÉTICO"
  },
  {
    "codigo":1251469001,
    "descripcion":"METÁSTASIS DE OSTEOSARCOMA EN CARTÍLAGO ARTICULAR DE VÉRTEBRA"
  },
  {
    "codigo":6285003,
    "descripcion":"TAQUIARRITMIA"
  },
  {
    "codigo":301197004,
    "descripcion":"HALLAZGO RELACIONADO CON MEDICIONES DE LA NARIZ"
  },
  {
    "codigo":235661004,
    "descripcion":"GASTRITIS QUÍSTICA CRÓNICA"
  },
  {
    "codigo":444781000124106,
    "descripcion":"INCUMPLIMIENTO DE ESQUEMA DE AUTOMONITOREO"
  },
  {
    "codigo":285011000119108,
    "descripcion":"ENFERMEDAD RENAL CRÓNICA DEBIDA A HIPERTENSIÓN BENIGNA, ESTADIO 5"
  },
  {
    "codigo":366733003,
    "descripcion":"HALLAZGO RELACIONADO CON LA HABILIDAD PARA SUBIR UN ESCALÓN"
  },
  {
    "codigo":364898003,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA MOVER EL PIE"
  },
  {
    "codigo":233826005,
    "descripcion":"INFARTO AGUDO NO Q - ANTEROSEPTAL"
  },
  {
    "codigo":199223000,
    "descripcion":"DIABETES MELLITUS DURANTE EL EMBARAZO, EL PARTO Y EL PUERPERIO"
  },
  {
    "codigo":2615004,
    "descripcion":"QUISTE FOLICULAR DE OVARIO"
  },
  {
    "codigo":166455007,
    "descripcion":"HORMONAS SEXUALES MASCULINAS POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":721676001,
    "descripcion":"INVAGINACIÓN DE INTESTINO GRUESO"
  },
  {
    "codigo":230156002,
    "descripcion":"MENINGITIS MALIGNA"
  },
  {
    "codigo":295692004,
    "descripcion":"SOBREDOSIS DE IDARUBICINA"
  },
  {
    "codigo":340461000119106,
    "descripcion":"HIPERMETROPÍA DE OJO IZQUIERDO"
  },
  {
    "codigo":262924006,
    "descripcion":"LESIÓN DEL PENE CAUSADA POR CIERRE DE CREMALLERA"
  },
  {
    "codigo":33548005,
    "descripcion":"ANTRACOSILICOSIS"
  },
  {
    "codigo":457697002,
    "descripcion":"DEHISCENCIA DE ANILLO DE VÁLVULA AÓRTICA COMO COMPLICACIÓN DE PROCEDIMIENTO"
  },
  {
    "codigo":228321002,
    "descripcion":"BEBE CON EL ESTÓMAGO VACÍO"
  },
  {
    "codigo":95414005,
    "descripcion":"TENDINITIS CALCIFICANTE"
  },
  {
    "codigo":880011001,
    "descripcion":"OBSTRUCCIÓN DE TRACTO DE SALIDA DEL VENTRÍCULO DERECHO POSTERIOR A PROCEDIMIENTO"
  },
  {
    "codigo":290187002,
    "descripcion":"HERNIA DE SPIEGEL"
  },
  {
    "codigo":93579006,
    "descripcion":"OSIFICACIÓN INCOMPLETA DE FÉMUR"
  },
  {
    "codigo":191883007,
    "descripcion":"PATRÓN DE USO EPISÓDICO NOCIVO SIN DEPENDENCIA DE ALCOHOL"
  },
  {
    "codigo":58976002,
    "descripcion":"PSEUDOHIPOPARATIROIDISMO"
  },
  {
    "codigo":288352006,
    "descripcion":"CONSTRUYE UNA TORRE"
  },
  {
    "codigo":124512007,
    "descripcion":"DEFICIENCIA DE FORMILTETRAHIDROFOLATO DESFORMILASA"
  },
  {
    "codigo":386656009,
    "descripcion":"HALLAZGO RELACIONADO CON HENDIDURA PALPEBRAL"
  },
  {
    "codigo":16098081000119101,
    "descripcion":"ARTROFIBROSIS DE ARTICULACIÓN DE REGIÓN DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":712501004,
    "descripcion":"REQUIERE SUPERVISIÓN PARA REALIZAR LA TRANSFERENCIA A LA SILLA DE RUEDAS"
  },
  {
    "codigo":209245002,
    "descripcion":"FRACTURA-SUBLUXACIÓN NO EXPUESTA DE ARTICULACIÓN DE HOMBRO"
  },
  {
    "codigo":384821006,
    "descripcion":"ESTADO MENTAL, CONDUCTA Y\/O FUNCIÓN PSICOSOCIAL - HALLAZGO"
  },
  {
    "codigo":286517009,
    "descripcion":"NO COCINA ALIMENTOS"
  },
  {
    "codigo":186378005,
    "descripcion":"TÉTANOS OBSTÉTRICO"
  },
  {
    "codigo":282847002,
    "descripcion":"CAPAZ DE MANTENER UNA POSICIÓN"
  },
  {
    "codigo":413919004,
    "descripcion":"COLGAJO CORNEAL CON MICROESTRÍAS"
  },
  {
    "codigo":1003743005,
    "descripcion":"CONTRACTURA EN FLEXIÓN DE ARTICULACIÓN METACARPOFALÁNGICA DE DEDO MEDIO DE MANO"
  },
  {
    "codigo":315615007,
    "descripcion":"ESCLEROSIS AÓRTICA NO REUMÁTICA"
  },
  {
    "codigo":250079008,
    "descripcion":"MIOQUIMIA GENERALIZADA"
  },
  {
    "codigo":1231284001,
    "descripcion":"EPIDERMÓLISIS AMPOLLOSA DISTRÓFICA GENERALIZADA AUTOSÓMICA DOMINANTE"
  },
  {
    "codigo":248244005,
    "descripcion":"DISTANCIA DE CAMINATA DISMINUIDA"
  },
  {
    "codigo":1264052006,
    "descripcion":"SENSACIÓN DE PRESIÓN DE SENO PARANASAL"
  },
  {
    "codigo":1260382003,
    "descripcion":"LESIÓN DE GANGLIO DE NERVIO TRIGÉMINO"
  },
  {
    "codigo":80734006,
    "descripcion":"SÍNDROME DE MARINESCO-SJÖGREN"
  },
  {
    "codigo":373811001,
    "descripcion":"MOTIVO PARA NO REALIZAR UN TRATAMIENTO ONCOLÓGICO ESPECÍFICO"
  },
  {
    "codigo":406579002,
    "descripcion":"INFECCIÓN DEL SISTEMA NERVIOSO CENTRAL POR VIRUS DE EPSTEIN BARR"
  },
  {
    "codigo":275507003,
    "descripcion":"AUSENCIA DE PULMÓN"
  },
  {
    "codigo":10642351000119100,
    "descripcion":"ÚLCERA CUTÁNEA CRÓNICA DE SACRO"
  },
  {
    "codigo":292271000119101,
    "descripcion":"NEURITIS ILIOHIPOGÁSTRICA IZQUIERDA"
  },
  {
    "codigo":338351000119101,
    "descripcion":"EROSIÓN RECIDIVANTE DE LA CÓRNEA DEL OJO IZQUIERDO"
  },
  {
    "codigo":16302511000119103,
    "descripcion":"LESIÓN DE HUESO DE BRAZO DERECHO"
  },
  {
    "codigo":16054191000119104,
    "descripcion":"TRASTORNO DE VÍA VISUAL IZQUIERDA"
  },
  {
    "codigo":82351000119105,
    "descripcion":"COMPORTAMIENTO ALTERADO DEBIDO A ENFERMEDAD DE PICK"
  },
  {
    "codigo":87471000119106,
    "descripcion":"ÚLCERA DE TOBILLO DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":1075631000119107,
    "descripcion":"DOLOR EN ARTICULACIÓN ESTERNOCLAVICULAR DERECHA"
  },
  {
    "codigo":1078191000119108,
    "descripcion":"TENDÓN DE AQUILES DERECHO CORTO CONGÉNITO"
  },
  {
    "codigo":16033711000119108,
    "descripcion":"HIPERTROFIA DE HUESO DE TIBIA DERECHA"
  },
  {
    "codigo":16008111000119108,
    "descripcion":"RUPTURA DEGENERATIVA DE FIBROCARTÍLAGO TRIANGULAR DE MUÑECA DERECHA"
  },
  {
    "codigo":343471000119108,
    "descripcion":"DESPRENDIMIENTO SEROSO DEL EPITELIO PIGMENTARIO RETINIANO BILATERAL"
  },
  {
    "codigo":304605000,
    "descripcion":"PATRÓN DE USO NOCIVO DE METANOL"
  },
  {
    "codigo":16018351000119109,
    "descripcion":"INESTABILIDAD DE ARTICULACIÓN DEL PIE IZQUIERDO"
  },
  {
    "codigo":148911000119107,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE ABDOMEN"
  },
  {
    "codigo":16000431000119109,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DEBIDO A OCLUSIÓN DE ARTERIA CEREBRAL MEDIA DERECHA"
  },
  {
    "codigo":12237231000119107,
    "descripcion":"DOLOR DE MIEMBRO INFERIOR DERECHO EN REPOSO DEBIDO A ATEROSCLEROSIS"
  },
  {
    "codigo":15990191000119108,
    "descripcion":"CATARATA COMPLICADA DE OJO IZQUIERDO"
  },
  {
    "codigo":75229002,
    "descripcion":"HIFEMA"
  },
  {
    "codigo":402909006,
    "descripcion":"VERRUGA VIRAL EN DEDO DEL PIE"
  },
  {
    "codigo":271837007,
    "descripcion":"PERISTALTISMO VISIBLE"
  },
  {
    "codigo":42461002,
    "descripcion":"ANEMIA CAUSADA POR COBRE"
  },
  {
    "codigo":1254877009,
    "descripcion":"DISTROFIA UNGUEAL DEBIDA A EPIDERMÓLISIS BULLOSA"
  },
  {
    "codigo":827058003,
    "descripcion":"REFLEJOS ROTULIANOS DESIGUALES"
  },
  {
    "codigo":106162004,
    "descripcion":"HALLAZGO EN EL DUODÉCIMO PAR CRANEAL"
  },
  {
    "codigo":302770003,
    "descripcion":"TENESMO ANORRECTAL"
  },
  {
    "codigo":239069005,
    "descripcion":"ACROERITROQUERATODERMIA"
  },
  {
    "codigo":169863000,
    "descripcion":"PESO AL NACER IGUAL A 25%-49% (3150-3449 G)"
  },
  {
    "codigo":237234008,
    "descripcion":"EMBARAZO NO DIAGNOSTICADO"
  },
  {
    "codigo":1187506008,
    "descripcion":"PARAPLEJÍA ESPÁSTICA AUTOSÓMICA RECESIVA TIPO 77"
  },
  {
    "codigo":300935003,
    "descripcion":"EXCORIACIÓN DE LA PIEL ANAL"
  },
  {
    "codigo":366471005,
    "descripcion":"HALLAZGO RELACIONADO CON LA AMPLITUD DEL MOVIMIENTO DE ARTICULACIÓN DE HOMBRO"
  },
  {
    "codigo":102492002,
    "descripcion":"DIFICULTAD PARA MANTENER EL PESO"
  },
  {
    "codigo":168028002,
    "descripcion":"ANÁLISIS BIOQUÍMICO DE LÍQUIDO ASCÍTICO FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":299100006,
    "descripcion":"AMPLITUD DE ADUCCIÓN ACTIVA DE DEDO DE LA MANO DISMINUIDA"
  },
  {
    "codigo":1149233001,
    "descripcion":"INFECCIÓN DE URACO REMANENTE"
  },
  {
    "codigo":297265001,
    "descripcion":"RESPUESTA VERBAL INAPROPIADA"
  },
  {
    "codigo":725084009,
    "descripcion":"ANEUPLOIDIA DE CROMOSOMAS SEXUALES"
  },
  {
    "codigo":461105005,
    "descripcion":"ORIGEN ANÓMALO DE ARTERIA CORONARIA EN AORTA"
  },
  {
    "codigo":426502000,
    "descripcion":"DISPOSICIÓN PARA MEJORAR EL CONOCIMIENTO"
  },
  {
    "codigo":33286000,
    "descripcion":"DEFICIENCIA INMUNOLÓGICA SECUNDARIA"
  },
  {
    "codigo":518002,
    "descripcion":"AGREGACIÓN MÚLTIPLE"
  },
  {
    "codigo":721414002,
    "descripcion":"LACERACIÓN MAYOR DE VENA YUGULAR INTERNA"
  },
  {
    "codigo":262662006,
    "descripcion":"LESIÓN PENETRANTE DE SUPERFICIE INTRABUCAL DE LABIO"
  },
  {
    "codigo":424667001,
    "descripcion":"BORDE PALPEBRAL ENGROSADO"
  },
  {
    "codigo":129755006,
    "descripcion":"CALCIFICACIÓN PUNTIFORME"
  },
  {
    "codigo":16018671000119105,
    "descripcion":"DEDO EN GATILLO CONGÉNITO DE MANO IZQUIERDA"
  },
  {
    "codigo":293595009,
    "descripcion":"ALERGIA A OPIOIDE MORFINANO"
  },
  {
    "codigo":226224001,
    "descripcion":"DIETA ASIÁTICA"
  },
  {
    "codigo":95152002,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL CÚBITO"
  },
  {
    "codigo":16674031000119105,
    "descripcion":"ESGUINCE DE LIGAMENTO DE AMBAS ARTICULACIONES TEMPOROMANDIBULARES"
  },
  {
    "codigo":717744007,
    "descripcion":"DISPLASIA RENAL SECUNDARIA"
  },
  {
    "codigo":93317000,
    "descripcion":"POSICIÓN ANÓMALA CONGÉNITA DE LOS DEDOS"
  },
  {
    "codigo":781445005,
    "descripcion":"DISTENSIÓN DEL TENDÓN DEL MÚSCULO FLEXOR COMÚN PROFUNDO DE LOS DEDOS DE LA MANO"
  },
  {
    "codigo":224389007,
    "descripcion":"BUENA CONCIENCIA SOBRE SEGURIDAD LABORAL"
  },
  {
    "codigo":124250000,
    "descripcion":"DEFICIENCIA DE GLICINA AMIDINOTRANSFERASA"
  },
  {
    "codigo":191621009,
    "descripcion":"TRASTORNO AFECTIVO BIPOLAR, EPISODIO ACTUAL MANÍACO, MODERADO"
  },
  {
    "codigo":286255000,
    "descripcion":"INCAPAZ DE PRODUCIR SONIDOS DEL HABLA"
  },
  {
    "codigo":89647000,
    "descripcion":"PICNODISOSTOSIS"
  },
  {
    "codigo":253487001,
    "descripcion":"HIPOPLASIA DE VÁLVULA AURICULOVENTRICULAR IZQUIERDA"
  },
  {
    "codigo":56879003,
    "descripcion":"DISOCIACIÓN GENÉTICA INDEPENDIENTE"
  },
  {
    "codigo":345481000119105,
    "descripcion":"ESTENOSIS BILATERAL DE CANALÍCULOS LAGRIMALES"
  },
  {
    "codigo":251652004,
    "descripcion":"HALLAZGO POSCOITAL"
  },
  {
    "codigo":186116005,
    "descripcion":"DISENTERÍA AMEBIANA AGUDA"
  },
  {
    "codigo":53209001,
    "descripcion":"CONFLICTO PARA LA TOMA DE DECISIONES"
  },
  {
    "codigo":15746441000119107,
    "descripcion":"MASA DE OJO DERECHO"
  },
  {
    "codigo":735539005,
    "descripcion":"ACIDOSIS METABÓLICA DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":315353005,
    "descripcion":"CATARATA SUBCAPSULAR POSTERIOR"
  },
  {
    "codigo":282585006,
    "descripcion":"NO REBOTA"
  },
  {
    "codigo":18606002,
    "descripcion":"TRABAJO DE PARTO INCOORDINADO"
  },
  {
    "codigo":247982005,
    "descripcion":"SOCIABILIDAD EUFÓRICA"
  },
  {
    "codigo":319011000119103,
    "descripcion":"ARTRITIS REUMATOIDEA SERONEGATIVA DE ARTICULACIÓN DE TOBILLO IZQUIERDO"
  },
  {
    "codigo":444590007,
    "descripcion":"IMPOSIBILIDAD DE CONTACTARSE CON SUJETO INCLUIDO EN ENSAYO CLÍNICO"
  },
  {
    "codigo":442755000,
    "descripcion":"HALLAZGO RELACIONADO CON DIFERENCIAS EN LA FORMA DEL BORDE EN COMPARACIÓN CON EXAMEN RADIOLÓGICO PREVIO"
  },
  {
    "codigo":770435005,
    "descripcion":"VÁLVULA AÓRTICA BICÚSPIDE FAMILIAR"
  },
  {
    "codigo":409987005,
    "descripcion":"MANCHA NEGRA"
  },
  {
    "codigo":47704002,
    "descripcion":"BLEFAROCALASIA"
  },
  {
    "codigo":211544008,
    "descripcion":"LESIÓN POR APLASTAMIENTO, MAMA"
  },
  {
    "codigo":209709001,
    "descripcion":"SECCIÓN EXPUESTA DE LIGAMENTO DE ARTICULACIÓN MEDIOTARSIANA"
  },
  {
    "codigo":735832008,
    "descripcion":"LACERACIÓN DE ARCO PALMAR PROFUNDO"
  },
  {
    "codigo":111405003,
    "descripcion":"INFLAMACIÓN DE URÉTER"
  },
  {
    "codigo":13101006,
    "descripcion":"ACNÉ MECÁNICA"
  },
  {
    "codigo":766765009,
    "descripcion":"SÍNDROME RADIO-RENAL"
  },
  {
    "codigo":1354754001,
    "descripcion":"SÍNDROME DE TROMBOSIS CON TROMBOCITOPENIA POSTERIOR A VACUNACIÓN"
  },
  {
    "codigo":240642003,
    "descripcion":"LEISHMANIASIS CUTÁNEA ZOONÓTICA DE MEDIO ORIENTE"
  },
  {
    "codigo":109570002,
    "descripcion":"CARIES DENTAL PRIMARIA"
  },
  {
    "codigo":76802005,
    "descripcion":"CERVICITIS GONOCÓCICA CRÓNICA"
  },
  {
    "codigo":11266002,
    "descripcion":"MEMBRANA ESOFÁGICA SUPERIOR"
  },
  {
    "codigo":9431000,
    "descripcion":"PROBLEMA EN UNA ETAPA DE LA VIDA"
  },
  {
    "codigo":699394008,
    "descripcion":"QUEMADURA OCULAR POR DESTELLO"
  },
  {
    "codigo":238807000,
    "descripcion":"LINFEDEMA FACIAL"
  },
  {
    "codigo":271575002,
    "descripcion":"SÍNDROME DE LA MATERIA FECAL ESPESA"
  },
  {
    "codigo":402647004,
    "descripcion":"TRASTORNO DE GLÁNDULAS ECRINAS SUDORÍPARAS"
  },
  {
    "codigo":304343008,
    "descripcion":"AMPLITUD DE MOVIMIENTO DE COLUMNA CERVICAL AUMENTADA"
  },
  {
    "codigo":73132005,
    "descripcion":"TRASTORNO DE GLÁNDULA PARATIROIDES"
  },
  {
    "codigo":300673001,
    "descripcion":"NO CRUZA LA CALLE"
  },
  {
    "codigo":398977003,
    "descripcion":"LEPTOCITOSIS"
  },
  {
    "codigo":366209005,
    "descripcion":"HALLAZGO RELACIONADO CON LA ESTRUCTURA CORPORAL"
  },
  {
    "codigo":235137005,
    "descripcion":"QUEILITIS ANGULAR POR ESTAFILOCOCOS"
  },
  {
    "codigo":1085271000119102,
    "descripcion":"HEMORRAGIA RECTAL DEBIDA A RECTOSIGMOIDITIS ULCEROSA CRÓNICA"
  },
  {
    "codigo":298838001,
    "descripcion":"AMPLITUD DE ROTACIÓN EXTERNA PASIVA DE ARTICULACIÓN DE HOMBRO, NORMAL"
  },
  {
    "codigo":724822003,
    "descripcion":"DISTONÍA FUNCIONAL"
  },
  {
    "codigo":167766008,
    "descripcion":"EXAMEN DE SEMEN: INFÉRTIL"
  },
  {
    "codigo":231467000,
    "descripcion":"ADICCIÓN AL ABSINTHE (LICOR)"
  },
  {
    "codigo":297003000,
    "descripcion":"SOBREDOSIS INTENCIONAL DE AMIODARONA"
  },
  {
    "codigo":1148971005,
    "descripcion":"CAPAZ DE MODIFICAR LA CONDUCTA Y EL ESTILO DE VIDA PARA PROMOVER LA MEJORA DE LA SALUD"
  },
  {
    "codigo":2091005,
    "descripcion":"DIVERTICULITIS FARÍNGEA"
  },
  {
    "codigo":229632000,
    "descripcion":"TARTAMUDEO NEUROGÉNICO"
  },
  {
    "codigo":347991000119105,
    "descripcion":"OPACIDAD DEL VÍTREO DE OJO DERECHO"
  },
  {
    "codigo":722987009,
    "descripcion":"SÍNDROME DE ESCLEROSIS LATERAL AMIOTRÓFICA PLUS"
  },
  {
    "codigo":196864001,
    "descripcion":"ONFALOCELE - IRREDUCTIBLE"
  },
  {
    "codigo":721152005,
    "descripcion":"AUSENCIA CONGÉNITA DE MÚSCULO GÁSTRICO"
  },
  {
    "codigo":295168006,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE BUPRENORFINA"
  },
  {
    "codigo":293333000,
    "descripcion":"REACCIÓN ADVERSA A ANCROD"
  },
  {
    "codigo":195029002,
    "descripcion":"MIOCARDIOPATÍA ASOCIADA CON OTRO TRASTORNO"
  },
  {
    "codigo":15722481000119101,
    "descripcion":"ARTROSIS DE AMBAS ARTICULACIONES SUBTALARES"
  },
  {
    "codigo":1340074000,
    "descripcion":"PARAGANGLIOMA VAGAL MALIGNO"
  },
  {
    "codigo":94890002,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LABIOS MAYORES VULVARES"
  },
  {
    "codigo":422570005,
    "descripcion":"DERMATITIS VESICULAR DE PÁRPADO POR HERPES SIMPLE"
  },
  {
    "codigo":93055000,
    "descripcion":"DILATACIÓN CONGÉNITA DEL DUCTUS ARTERIOSO"
  },
  {
    "codigo":224127003,
    "descripcion":"FAMILIA CON UN NIÑO EN EDAD ESCOLAR"
  },
  {
    "codigo":289663006,
    "descripcion":"HALLAZGO RELACIONADO CON EL CONTENIDO DEL ÚTERO"
  },
  {
    "codigo":715647007,
    "descripcion":"DISTROFIA RETINIANA DE BOTNIA"
  },
  {
    "codigo":321521000119105,
    "descripcion":"RUPTURA ESPONTÁNEA DE TENDÓN FLEXOR DE MANO IZQUIERDA"
  },
  {
    "codigo":449833002,
    "descripcion":"PÓLIPO DE CIEGO"
  },
  {
    "codigo":417065002,
    "descripcion":"DISTROFIA CORNEAL DE THIEL-BEHNKE"
  },
  {
    "codigo":23849003,
    "descripcion":"GANGLIOSIDOSIS GM>2<, TIPO 2"
  },
  {
    "codigo":89385006,
    "descripcion":"DUCCIÓN LIMITADA ASOCIADA CON OTRO TRASTORNO OCULAR"
  },
  {
    "codigo":285993009,
    "descripcion":"DESACTIVA LA LLAVE PRINCIPAL DE ELECTRICIDAD"
  },
  {
    "codigo":253225009,
    "descripcion":"CATARATA POLAR POSTERIOR CONGÉNITA"
  },
  {
    "codigo":447998001,
    "descripcion":"TRACTO DE SALIDA VENTRICULAR ÚNICO POR ENCIMA DE VENTRÍCULO DERECHO"
  },
  {
    "codigo":218622004,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR AUROTIOMALATO SÓDICO"
  },
  {
    "codigo":284158005,
    "descripcion":"MUEVE EL PIE"
  },
  {
    "codigo":282323000,
    "descripcion":"CAPAZ DE PARARSE SOBRE UNA PIERNA"
  },
  {
    "codigo":52947006,
    "descripcion":"ENFERMEDAD POR VIRUS DE LA ENCEFALITIS JAPONESA"
  },
  {
    "codigo":295051000119105,
    "descripcion":"DEFORMIDAD ADQUIRIDA DE PIE"
  },
  {
    "codigo":313256001,
    "descripcion":"CONTRACCIÓN ANAL"
  },
  {
    "codigo":20179009,
    "descripcion":"INTOXICACIÓN CAUSADA POR TRICOMICINA"
  },
  {
    "codigo":247720005,
    "descripcion":"PERCEPCIÓN OLFATIVA AUMENTADA"
  },
  {
    "codigo":870312007,
    "descripcion":"HERIDA PENETRANTE DE GLOBO OCULAR CON CUERPO EXTRAÑO"
  },
  {
    "codigo":49277003,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE MUSLO, SIN INFECCIÓN"
  },
  {
    "codigo":409725009,
    "descripcion":"SISTEMA INTERNACIONAL DE ESTADIFICACIÓN DE NEUROBLASTOMA, ESTADIO 3"
  },
  {
    "codigo":735570002,
    "descripcion":"ANOMALÍA ADQUIRIDA DE VENTRÍCULO CARDÍACO"
  },
  {
    "codigo":473426009,
    "descripcion":"COMPLEJO PRIMARIO TUBERCULOSO CONFIRMADO POR CULTIVO"
  },
  {
    "codigo":678181000119104,
    "descripcion":"HIFEMA ESPONTÁNEO DE OJO IZQUIERDO"
  },
  {
    "codigo":340519003,
    "descripcion":"INTOLERANCIA A LA LISINA"
  },
  {
    "codigo":897575007,
    "descripcion":"TALIPES EQUINOVARO BILATERAL"
  },
  {
    "codigo":404220000,
    "descripcion":"IRRITABILIDAD DE VEJIGA URINARIA"
  },
  {
    "codigo":209447007,
    "descripcion":"ESGUINCE DEL LIGAMENTO RADIOESCAFOSEMILUNAR"
  },
  {
    "codigo":16052671000119100,
    "descripcion":"TENDINOSIS DE AMBOS HOMBROS"
  },
  {
    "codigo":109308007,
    "descripcion":"OSTEOMIELITIS DEL COMPLEJO ÓRBITO - NASAL"
  },
  {
    "codigo":240380008,
    "descripcion":"ÚLCERA TUBERCULOSA AGUDA"
  },
  {
    "codigo":402385005,
    "descripcion":"URTICARIA ALÉRGICA POR PICADURA Y\/O MORDEDURA"
  },
  {
    "codigo":203942000,
    "descripcion":"ESPINA BÍFIDA DORSAL CON HIDROCEFALIA - ABIERTA"
  },
  {
    "codigo":238545009,
    "descripcion":"DERMATITIS ATÓPICA FOLICULAR"
  },
  {
    "codigo":105638003,
    "descripcion":"ENFERMEDAD CAUSADA POR BALANTIDIIDAE"
  },
  {
    "codigo":300411000,
    "descripcion":"DEFENSA ABDOMINAL EN EL HIPOCONDRIO DERECHO"
  },
  {
    "codigo":365947001,
    "descripcion":"HALLAZGO RELACIONADO CON LAS INTERPRETACIONES DE LA CONDUCTA"
  },
  {
    "codigo":40102009,
    "descripcion":"HERNIA OBTURATRIZ CON GANGRENA"
  },
  {
    "codigo":236710009,
    "descripcion":"CÁLCULO EN LA PELVIS RENAL"
  },
  {
    "codigo":890235002,
    "descripcion":"ICTIOSIS EPIDERMOLÍTICA AUTOSÓMICA RECESIVA"
  },
  {
    "codigo":726395004,
    "descripcion":"DELECIÓN DE PARTE DEL CROMOSOMA 20"
  },
  {
    "codigo":298576000,
    "descripcion":"MOVIMIENTO PARADÓJICO DE LA COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":724560001,
    "descripcion":"TRASTORNO NEUROLÓGICO DEBIDO A DEFICIENCIA NUTRICIONAL"
  },
  {
    "codigo":5499009,
    "descripcion":"ENFERMEDAD VENOSA HIPERTENSIVA PULMONAR"
  },
  {
    "codigo":11792831000119106,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN DE DEDO ANULAR IZQUIERDO"
  },
  {
    "codigo":1052240009,
    "descripcion":"PARESIA DE CUERDA VOCAL DERECHA"
  },
  {
    "codigo":396880009,
    "descripcion":"ACTIVIDAD MITÓTICA NO APLICABLE"
  },
  {
    "codigo":198437004,
    "descripcion":"INSOMNIO MENOPÁUSICO"
  },
  {
    "codigo":67365005,
    "descripcion":"APENDICITIS RECURRENTE"
  },
  {
    "codigo":460581004,
    "descripcion":"ORIGEN ANÓMALO DE ARTERIA CORONARIA ACCESORIA EN SENO AÓRTICO"
  },
  {
    "codigo":296741007,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE CEFTIBUTENO"
  },
  {
    "codigo":165669008,
    "descripcion":"PRUEBA DE KLEIHAUER ANORMAL"
  },
  {
    "codigo":196602002,
    "descripcion":"ESOFAGITIS FLEMONOSA"
  },
  {
    "codigo":131066002,
    "descripcion":"NIVEL DE ESTRADIOL POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":194767001,
    "descripcion":"CARDIOPATÍA CON HIPERTENSIÓN BENIGNA E INSUFICIENCIA CARDÍACA CONGESTIVA"
  },
  {
    "codigo":30927003,
    "descripcion":"INTOXICACIÓN POR AGAVE LECHEGUILLA"
  },
  {
    "codigo":293071003,
    "descripcion":"REACCIÓN ADVERSA A LA PIRAZINAMIDA"
  },
  {
    "codigo":61860000,
    "descripcion":"PORFIRIA CUTÁNEA TARDÍA"
  },
  {
    "codigo":291236002,
    "descripcion":"INTOXICACIÓN POR SELEGILINA"
  },
  {
    "codigo":94628003,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL RETROPERITONEO"
  },
  {
    "codigo":127396004,
    "descripcion":"NIVEL DE GLOBULINA FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":782756008,
    "descripcion":"SÍNDROME DE DOLOR EPISÓDICO FAMILIAR"
  },
  {
    "codigo":289401002,
    "descripcion":"NO SE OBSERVA LA PRESENTACIÓN"
  },
  {
    "codigo":1010297003,
    "descripcion":"DEFICIENCIA DE VITAMINA B12 NEONATAL DEBIDA A DEFICIENCIA DE VITAMINA B12 MATERNA"
  },
  {
    "codigo":387705004,
    "descripcion":"ENFERMEDAD HEMOLÍTICA DEL FETO O RECIÉN NACIDO POR ISOINMUNIZACIÓN"
  },
  {
    "codigo":60025004,
    "descripcion":"FIEBRE TRANSITORIA DEL RECIÉN NACIDO"
  },
  {
    "codigo":92793008,
    "descripcion":"CARCINOMA IN SITU DE CONDUCTO DEFERENTE"
  },
  {
    "codigo":90958004,
    "descripcion":"TROMBOSIS ARTERIAL DEL MIEMBRO INFERIOR"
  },
  {
    "codigo":254798005,
    "descripcion":"HEMANGIOENDOTELIOMA CUTÁNEO"
  },
  {
    "codigo":189262006,
    "descripcion":"CARCINOMA IN SITU DE BRONQUIO Y PULMÓN"
  },
  {
    "codigo":418638008,
    "descripcion":"INFILTRADO CORNEAL MARGINAL"
  },
  {
    "codigo":123726009,
    "descripcion":"HIPERPLASIA MODERADA DE LA MÉDULA ÓSEA"
  },
  {
    "codigo":23587002,
    "descripcion":"FLEMÓN DEL PÁNCREAS"
  },
  {
    "codigo":1279496001,
    "descripcion":"MÚLTIPLES LESIONES DE RETINA DE OJO IZQUIERDO SIN DESPRENDIMIENTO"
  },
  {
    "codigo":709880000,
    "descripcion":"LATERALIDAD DESCONOCIDA"
  },
  {
    "codigo":1332472004,
    "descripcion":"ENFERMEDAD RENAL CRÓNICA ESTADIO 3A DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":183757000,
    "descripcion":"CONSULTA DOMICILIARIA NEUROQUIRÚRGICA, REALIZADA"
  },
  {
    "codigo":314829001,
    "descripcion":"DISCRIMINACIÓN TÁCTIL DEL PIE IZQUIERDO ANORMAL"
  },
  {
    "codigo":216525000,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR TRANQUILIZANTE A BASE DE BUTIROFENONA"
  },
  {
    "codigo":85453003,
    "descripcion":"LUXACIÓN EXPUESTA DE ARTICULACIÓN METATARSOFALÁNGICA"
  },
  {
    "codigo":282061008,
    "descripcion":"RUPTURA DE YEYUNO"
  },
  {
    "codigo":773581009,
    "descripcion":"SÍNDROME DE DISCAPACIDAD INTELECTUAL, DISMORFIA CRANEOFACIAL, CRIPTORQUIDIA"
  },
  {
    "codigo":444066001,
    "descripcion":"INFECCIÓN CAUSADA POR STREPTOCOCCUS DEL GRUPO C"
  },
  {
    "codigo":199746291000119109,
    "descripcion":"ÚLCERA VENOSA DE DEDO DE PIE DERECHO"
  },
  {
    "codigo":247458008,
    "descripcion":"NEVO EN EMPEDRADO"
  },
  {
    "codigo":81783000,
    "descripcion":"SÍNDROME DE DEFICIENCIA DE FACTOR MÚLTIPLE FAMILIAR"
  },
  {
    "codigo":1197730009,
    "descripcion":"ENTERITIS MICROSCÓPICA"
  },
  {
    "codigo":704375003,
    "descripcion":"CONOCIMIENTO DEFICIENTE SOBRE AMAMANTAMIENTO"
  },
  {
    "codigo":1163127003,
    "descripcion":"COLITIS POR SALMONELLA PARATYPHI A"
  },
  {
    "codigo":737143004,
    "descripcion":"CREPITACIÓN DE AMBAS ARTICULACIONES TEMPOROMANDIBULARES EN EL MOMENTO DE LA APERTURA"
  },
  {
    "codigo":868215007,
    "descripcion":"OCLUSIÓN DE PORCIÓN PROXIMAL DE ARTERIA CORONARIA DERECHA"
  },
  {
    "codigo":442231009,
    "descripcion":"CARIES QUE AFECTA MÚLTIPLES SUPERFICIES DENTALES"
  },
  {
    "codigo":1259596002,
    "descripcion":"CARCINOMA PRIMARIO ANEXIAL MICROQUÍSTICO DE PIEL"
  },
  {
    "codigo":1290529000,
    "descripcion":"RADIOGRAFÍA DE TIBIA NORMAL"
  },
  {
    "codigo":407628009,
    "descripcion":"HALLAZGO DE LA ESCALA DE DETERIORO GLOBAL PARA LA EVALUACIÓN DE DEMENCIA DEGENERATIVA PRIMARIA"
  },
  {
    "codigo":78113001,
    "descripcion":"FACIES QUERÚBICA"
  },
  {
    "codigo":300071000119101,
    "descripcion":"OSTEOMIELITIS SUBAGUDA DE TOBILLO"
  },
  {
    "codigo":209185003,
    "descripcion":"SUBLUXACIÓN EXPUESTA DE LA COLUMNA VERTEBRAL LUMBAR"
  },
  {
    "codigo":373025001,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM DUVALII"
  },
  {
    "codigo":733473000,
    "descripcion":"SÍNDROME DE MICRODUPLICACIÓN 16P13.3"
  },
  {
    "codigo":15973261000119108,
    "descripcion":"MALFORMACIÓN VASCULAR CONGÉNITA DE AMBOS MIEMBROS INFERIORES"
  },
  {
    "codigo":403958000,
    "descripcion":"NEVO ANGIOMATOSO ULCERADO"
  },
  {
    "codigo":240118001,
    "descripcion":"MIOSITIS POR TOXOCARIASIS"
  },
  {
    "codigo":305654003,
    "descripcion":"ATENDIDO POR UN MÉDICO ESPECIALISTA EN TRANSFUSIONES DE SANGRE"
  },
  {
    "codigo":698870008,
    "descripcion":"ACIDURIA 2-HIDROXIGLUTÁRICA"
  },
  {
    "codigo":762571003,
    "descripcion":"DERMATITIS ALÉRGICA POR CONTACTO OCUPACIONAL CAUSADA POR BIOCIDA"
  },
  {
    "codigo":402123007,
    "descripcion":"NEOPLASIA INTRAEPITELIAL DEBIDA A VIRUS PAPILOMA HUMANO"
  },
  {
    "codigo":860875007,
    "descripcion":"PIEL REDUNDANTE GENERALIZADA DEBIDA A ENFERMEDAD CRÓNICA"
  },
  {
    "codigo":236448000,
    "descripcion":"RIÑÓN PEQUEÑO"
  },
  {
    "codigo":301984002,
    "descripcion":"HALLAZGO RELACIONADO CON DISPOSITIVO OCULAR"
  },
  {
    "codigo":367520004,
    "descripcion":"SÍNDROME DE INCONTINENCIA PIGMENTARIA"
  },
  {
    "codigo":1186720006,
    "descripcion":"SÍNDROME AUTOINFLAMATORIO-INMUNODEFICIENCIA-DISFUNCIÓN NEUTROFÍLICA ASOCIADO AL GEN CEBPE"
  },
  {
    "codigo":10949671000119107,
    "descripcion":"HERIDA ABIERTA DE ANTEBRAZO DERECHO DEBIDA A MORDEDURA DE PERRO"
  },
  {
    "codigo":15920321000119101,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR MOLUSCO"
  },
  {
    "codigo":234613004,
    "descripcion":"DEFICIENCIA COMBINADA DE LOS COMPLEMENTOS 6 Y 7"
  },
  {
    "codigo":477402151000119107,
    "descripcion":"CARCINOMA EX ADENOMA PLEOMORFO PRIMARIO DE GLÁNDULA LAGRIMAL IZQUIERDA"
  },
  {
    "codigo":1217653006,
    "descripcion":"BLEFAROCALASIA DE PÁRPADO SUPERIOR"
  },
  {
    "codigo":1092801000119102,
    "descripcion":"ASCITIS DE ETIOLOGÍA HEPÁTICA CONCOMITANTE CON HEPATITIS CRÓNICA ACTIVA DEBIDA A HEPATOPATÍA TÓXICA"
  },
  {
    "codigo":167242001,
    "descripcion":"DENSIDAD DE ORINA DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":300149008,
    "descripcion":"MEMBRANA TIMPÁNICA ROSADA"
  },
  {
    "codigo":298314008,
    "descripcion":"HALLAZGO RELACIONADO CON LA COORDINACIÓN \/ INCOORDINACIÓN"
  },
  {
    "codigo":722463001,
    "descripcion":"SÍNDROME DE COLOBOMA DE MÁCULA, FISURA DE PALADAR Y HALLUX VALGO"
  },
  {
    "codigo":165407001,
    "descripcion":"HEMOGRAMA EN VALORES NORMALES LIMÍTROFES"
  },
  {
    "codigo":36170009,
    "descripcion":"DISTIMIA SECUNDARIA DE INICIO TARDÍO"
  },
  {
    "codigo":34335000,
    "descripcion":"INFECCIÓN CAUSADA POR SHIGELLA DEL GRUPO B"
  },
  {
    "codigo":1345055005,
    "descripcion":"SÍNDROME DE FACIES DE LLANTO ASIMÉTRICA"
  },
  {
    "codigo":1567007,
    "descripcion":"ÚLCERA GÁSTRICA CRÓNICA SIN HEMORRAGIA, SIN PERFORACIÓN Y SIN OBSTRUCCIÓN"
  },
  {
    "codigo":198175009,
    "descripcion":"ENFERMEDAD PÉLVICA INFLAMATORIA, SIFILÍTICA, FEMENINA"
  },
  {
    "codigo":1179380004,
    "descripcion":"MENINGITIS POR VIRUS HERPES SIMPLE 2"
  },
  {
    "codigo":294644005,
    "descripcion":"ALERGIA A COMPONENTE DE VACUNA QUE CONTIENE ANTÍGENOS DE CLOSTRIDIUM TETANI Y CORYNEBACTERIUM DIPHTHERIAE"
  },
  {
    "codigo":391113002,
    "descripcion":"PRUEBA DE REVERSIBILIDAD AL BROMURO DE IPRATROPIO: NEGATIVA"
  },
  {
    "codigo":292809005,
    "descripcion":"REACCIÓN ADVERSA A LA AMFOTERICINA"
  },
  {
    "codigo":1144777005,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR LEVOTIROXINA"
  },
  {
    "codigo":1306782000,
    "descripcion":"GLAUCOMA DE OJO DERECHO DEBIDO A MALFORMACIÓN CONGÉNITA DE ÁNGULO DE CÁMARA ANTERIOR DE OJO"
  },
  {
    "codigo":1208478005,
    "descripcion":"NECROSIS ESTRIATAL BILATERAL INFANTIL FAMILIAR"
  },
  {
    "codigo":61598006,
    "descripcion":"GLUCOGENOSIS CON GLUCOAMINOFOSFATURIA"
  },
  {
    "codigo":290974007,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ETOSUXIMIDA"
  },
  {
    "codigo":94366008,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA CARA LARÍNGEA DEL PLIEGUE ARITENOEPIGLÓTICO"
  },
  {
    "codigo":127134007,
    "descripcion":"LINFADENOPATÍA PANCREÁTICA"
  },
  {
    "codigo":289139004,
    "descripcion":"HALLAZGO RELACIONADO CON LA FRECUENCIA DE LA ALIMENTACIÓN"
  },
  {
    "codigo":715123004,
    "descripcion":"SE TRANSFIERE DE LA SILLA DE RUEDAS A LA SILLA"
  },
  {
    "codigo":59763006,
    "descripcion":"HIPERFOSFATASEMIA TARDÍA"
  },
  {
    "codigo":92531006,
    "descripcion":"CARCINOMA IN SITU DE CONDUCTO ANAL"
  },
  {
    "codigo":1371000119105,
    "descripcion":"RONQUERA CRÓNICA"
  },
  {
    "codigo":189000007,
    "descripcion":"LIPOMA DE LA INGLE"
  },
  {
    "codigo":1237576009,
    "descripcion":"BEBÉ PREMATURO AL MOMENTO DE PARTO, DE MENOS DE 32 SEMANAS"
  },
  {
    "codigo":449309003,
    "descripcion":"NEOPLASIA MALIGNA DE PIEL DE ESCROTO"
  },
  {
    "codigo":88861003,
    "descripcion":"INTERACCIÓN HEMO - HEMO DISMINUIDA"
  },
  {
    "codigo":1137437005,
    "descripcion":"TIENE SUEÑO ADECUADO"
  },
  {
    "codigo":285469008,
    "descripcion":"INCAPAZ DE CERRAR LA BOCA"
  },
  {
    "codigo":283634001,
    "descripcion":"HERIDA POR PINCHAZO DE AGUJA EN LA RODILLA"
  },
  {
    "codigo":185330002,
    "descripcion":"PACIENTE RETIRADO"
  },
  {
    "codigo":1332210001,
    "descripcion":"BOCA EN POSICIÓN DE APERTURA PARCIAL"
  },
  {
    "codigo":249031003,
    "descripcion":"PRESENTACIÓN AJUSTADAMENTE ENCAJADA"
  },
  {
    "codigo":871623005,
    "descripcion":"ESTENOSIS SUBAÓRTICA ADQUIRIDA"
  },
  {
    "codigo":609479006,
    "descripcion":"INTERRUPCIÓN INDUCIDA DEL EMBARAZO COMPLICADA POR CHOQUE POSOPERATORIO"
  },
  {
    "codigo":1363143007,
    "descripcion":"ASTILLA EN MUÑECA"
  },
  {
    "codigo":247196000,
    "descripcion":"PIGMENTACIÓN COROIDEA"
  },
  {
    "codigo":17820009,
    "descripcion":"ACIDURIA XANTURÉNICA"
  },
  {
    "codigo":81521003,
    "descripcion":"INTENTO FALLIDO DE ABORTO CON SALPINGITIS"
  },
  {
    "codigo":1162865004,
    "descripcion":"MALFORMACIÓN DE DIENTES"
  },
  {
    "codigo":302581000119108,
    "descripcion":"ANQUILOSIS DE ARTICULACIÓN DE PIE DERECHO"
  },
  {
    "codigo":1193798000,
    "descripcion":"ENTERITIS POR PROTOZOARIO"
  },
  {
    "codigo":1259334001,
    "descripcion":"CARCINOMA PRIMARIO DE PALADAR BLANDO"
  },
  {
    "codigo":767814002,
    "descripcion":"NEOPLASIA DE HUESO DE PIE"
  },
  {
    "codigo":276294005,
    "descripcion":"HABILIDADES DE MEMORIA AISLADAS"
  },
  {
    "codigo":14150005,
    "descripcion":"ALTERACIÓN DEL BIENESTAR: DOLOR CRÓNICO"
  },
  {
    "codigo":866118008,
    "descripcion":"TOPOLOGÍA VENTRICULAR DE MANO IZQUIERDA"
  },
  {
    "codigo":405531001,
    "descripcion":"EPISODIO ADVERSO QUE OCASIONA UNA LESIÓN POTENCIALMENTE PERMANENTE, PERO NO INCAPACITANTE"
  },
  {
    "codigo":208923002,
    "descripcion":"DESGARRO AGUDO DE MENISCO EXTERNO, CUERNO POSTERIOR"
  },
  {
    "codigo":307227006,
    "descripcion":"RETENCIÓN GÁSTRICA"
  },
  {
    "codigo":733211007,
    "descripcion":"URTICARIA POR CONTACTO OCUPACIONAL"
  },
  {
    "codigo":700443009,
    "descripcion":"INESTABILIDAD CRÓNICA DE SINDESMOSIS DE TOBILLO"
  },
  {
    "codigo":403696001,
    "descripcion":"CICATRIZ CAUSADA POR LÁSER"
  },
  {
    "codigo":10480003,
    "descripcion":"QUISTE DE EXTRAVASACIÓN DE LA GLÁNDULA SALIVAL"
  },
  {
    "codigo":1222896005,
    "descripcion":"NO PATEA OBJETO"
  },
  {
    "codigo":43248007,
    "descripcion":"SÍNDROME DE QUÍNTUPLE X"
  },
  {
    "codigo":205253000,
    "descripcion":"SINOSTOSIS RADIOCUBITAL PROXIMAL"
  },
  {
    "codigo":238021002,
    "descripcion":"DEFICIENCIA VARIANTE B DE HEXOSAMINIDASA A - INFANTIL"
  },
  {
    "codigo":762309004,
    "descripcion":"VESTIBULOPATÍA IZQUIERDA PERSISTENTE POSTERIOR A NEURONITIS VESTIBULAR"
  },
  {
    "codigo":74181004,
    "descripcion":"TUBERCULOSIS DE LOS ÓRGANOS GENITALES FEMENINOS"
  },
  {
    "codigo":41413006,
    "descripcion":"CEFALEA TEMPORAL"
  },
  {
    "codigo":10679951000119108,
    "descripcion":"TUMEFACCIÓN DEL TEJIDO CELULAR SUBCUTÁNEO DE EXTREMIDAD SUPERIOR DERECHA"
  },
  {
    "codigo":11308841000119102,
    "descripcion":"MÚLTIPLES FRACTURAS POR COMPRESIÓN LATERAL DE PELVIS CON ANILLO PÉLVICO INESTABLE"
  },
  {
    "codigo":331561000119103,
    "descripcion":"ENTROPIÓN MECÁNICO DE PÁRPADO SUPERIOR DERECHO"
  },
  {
    "codigo":301722006,
    "descripcion":"NO REALIZA ACTIVIDADES RELACIONADAS CON LA POSTULACIÓN A UN TRABAJO"
  },
  {
    "codigo":400026007,
    "descripcion":"NEOPLASIA VASCULAR BENIGNA DE PIERNA"
  },
  {
    "codigo":6810008,
    "descripcion":"HIPOALGESIA"
  },
  {
    "codigo":15732521000119104,
    "descripcion":"ENTROPIÓN CON ECTROPIÓN DE PÁRPADO SUPERIOR DERECHO"
  },
  {
    "codigo":365423004,
    "descripcion":"HALLAZGO RELACIONADO CON MORFOLOGÍA DE ESPERMATOZOIDES"
  },
  {
    "codigo":430959006,
    "descripcion":"SÍNDROME PARALÍTICO DE LADO DOMINANTE COMO EFECTO TARDÍO DE ACCIDENTE CEREBROVASCULAR"
  },
  {
    "codigo":4975008,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DEL TRONCO"
  },
  {
    "codigo":3140001,
    "descripcion":"CITRULINEMIA, TIPO SUBAGUDO"
  },
  {
    "codigo":789572003,
    "descripcion":"ÚLCERA DE REGIÓN MEDIA DE PIE DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":35908007,
    "descripcion":"ARTRITIS CRÓNICA"
  },
  {
    "codigo":722201004,
    "descripcion":"SÍNDROME DE HENDIDURA MEDIANA DE LABIO SUPERIOR, LIPOMA DE CUERPO CALLOSO Y PÓLIPO CUTÁNEO"
  },
  {
    "codigo":165145005,
    "descripcion":"BRONCOSCOPIA ANORMAL"
  },
  {
    "codigo":66841006,
    "descripcion":"DEFICIENCIA DE FACTOR INHIBITORIO DEL MULLER"
  },
  {
    "codigo":785902000,
    "descripcion":"CONTRACTURA DE ARTICULACIÓN POSTERIOR A LESIÓN TRAUMÁTICA"
  },
  {
    "codigo":296217008,
    "descripcion":"SOBREDOSIS DE ENANTATO DE FLUFENAZINA"
  },
  {
    "codigo":294382007,
    "descripcion":"ALERGIA A FOSCARNET"
  },
  {
    "codigo":423619003,
    "descripcion":"TERATOMA DE ÓRBITA"
  },
  {
    "codigo":292547006,
    "descripcion":"REACCIÓN ADVERSA A LA PROCICLIDINA"
  },
  {
    "codigo":63171007,
    "descripcion":"ENFERMEDAD INFECCIOSA AGUDA"
  },
  {
    "codigo":94104001,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA TRÁQUEA"
  },
  {
    "codigo":421784001,
    "descripcion":"DEFICIENCIA DE CARNITINA"
  },
  {
    "codigo":290712005,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR CARBOPLATINO"
  },
  {
    "codigo":716696006,
    "descripcion":"MIOPATÍA CENTRONUCLEAR AUTOSÓMICA DOMINANTE"
  },
  {
    "codigo":126872008,
    "descripcion":"NEOPLASIA DE RETROPERITONEO"
  },
  {
    "codigo":61336008,
    "descripcion":"HIPOCOLESTEROLEMIA"
  },
  {
    "codigo":92269002,
    "descripcion":"NEOPLASIA BENIGNA DE LOS GANGLIOS LINFÁTICOS PARAMETRIALES"
  },
  {
    "codigo":714861007,
    "descripcion":"INCAPAZ DE ADAPTARSE DESPUÉS DE UNA CRISIS PERSONAL"
  },
  {
    "codigo":254274004,
    "descripcion":"DELECIÓN DE PARTE DE AUTOSOMA"
  },
  {
    "codigo":23063005,
    "descripcion":"ATRESIA DE VÁLVULA MITRAL"
  },
  {
    "codigo":186903006,
    "descripcion":"SÍFILIS LATENTE TARDÍA"
  },
  {
    "codigo":285207005,
    "descripcion":"CAPAZ DE RECORDAR UNA DIRECCIÓN AL AZAR DESPUÉS DE CINCO MINUTOS"
  },
  {
    "codigo":283372003,
    "descripcion":"LACERACIÓN DE MUÑECA"
  },
  {
    "codigo":840428006,
    "descripcion":"DERMATOSIS CAUSADA POR ÁCARO DE LOS ALIMENTOS"
  },
  {
    "codigo":1297345000,
    "descripcion":"CIERRE DE ÁNGULO AGUDO SECUNDARIO FACOMÓRFICO DE OJO DERECHO"
  },
  {
    "codigo":281537007,
    "descripcion":"DISTENSIÓN DE TENDÓN DE LA CABEZA Y DEL CUELLO"
  },
  {
    "codigo":83094001,
    "descripcion":"HEMATOMA PERINEAL DURANTE EL PARTO"
  },
  {
    "codigo":248769009,
    "descripcion":"ERECCIÓN SIN EXCITACIÓN"
  },
  {
    "codigo":10846301000119109,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO SENSITIVO CUTÁNEO DE DEDO DE PIE IZQUIERDO"
  },
  {
    "codigo":246934008,
    "descripcion":"COLORACIÓN CORNEAL CON FLUORESCEÍNA INDUCIDA POR LENTES DE CONTACTO"
  },
  {
    "codigo":212331001,
    "descripcion":"LESIÓN DE MÚLTIPLES NERVIOS A NIVEL DE PIERNA"
  },
  {
    "codigo":1295510008,
    "descripcion":"HIPERTENSIÓN OCULAR DE OJO IZQUIERDO DEBIDA A TRASTORNO DE CRISTALINO"
  },
  {
    "codigo":441707002,
    "descripcion":"BALISTOCARDIOGRAMA ANORMAL"
  },
  {
    "codigo":1259072002,
    "descripcion":"DISTONÍA IDIOPÁTICA ESPORÁDICA DE INICIO EN LA ADULTEZ"
  },
  {
    "codigo":1193536002,
    "descripcion":"TRASTORNO NEONATAL PRECOZ DEBIDO A TRASTORNO PLACENTARIO"
  },
  {
    "codigo":30131000175107,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN EN TOBILLO IZQUIERDO"
  },
  {
    "codigo":276032004,
    "descripcion":"ASISTENCIA A ESCUELA ESPECIAL"
  },
  {
    "codigo":306965001,
    "descripcion":"COANAS PERMEABLES"
  },
  {
    "codigo":732949006,
    "descripcion":"PARAPLEJÍA ESPÁSTICA AUTOSÓMICA DOMINANTE TIPO 6"
  },
  {
    "codigo":274197007,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE LA EXTREMIDAD INFERIOR"
  },
  {
    "codigo":896789008,
    "descripcion":"FORMA ANCHA ANORMAL CONGÉNITA DE FALANGE MEDIA DE PIE"
  },
  {
    "codigo":110357006,
    "descripcion":"FOBIA DENTAL IRREAL"
  },
  {
    "codigo":42986003,
    "descripcion":"ENFERMEDAD DE CHARCOT - MARIE - TOOTH, TIPO IB"
  },
  {
    "codigo":15708561000119103,
    "descripcion":"TROMBOSIS VENOSA PROFUNDA CRÓNICA DE AMBAS EXTREMIDADES SUPERIORES POSTERIOR A PROCEDIMIENTO"
  },
  {
    "codigo":403434009,
    "descripcion":"QUERATOCONJUNTIVITIS ATÓPICA"
  },
  {
    "codigo":8383003,
    "descripcion":"INFESTACIÓN CAUSADA POR DEMODEX PHYLLOIDES"
  },
  {
    "codigo":204991004,
    "descripcion":"DESVIACIÓN DE URÉTER"
  },
  {
    "codigo":1153428001,
    "descripcion":"CALCIFICACIÓN MUSCULAR DEBIDA A DERMATOMIOSITIS JUVENIL"
  },
  {
    "codigo":301460003,
    "descripcion":"PESTAÑA ENCARNADA"
  },
  {
    "codigo":235924006,
    "descripcion":"QUISTE DE LA VÍA BILIAR"
  },
  {
    "codigo":397929001,
    "descripcion":"MORBILIDAD NEUROLÓGICA"
  },
  {
    "codigo":299625001,
    "descripcion":"AMPLITUD DE ADUCCIÓN PASIVA DE DEDO DEL PIE DISMINUIDA"
  },
  {
    "codigo":365161005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA ABROCHAR LA ROPA"
  },
  {
    "codigo":103017008,
    "descripcion":"MAREO POSTURAL"
  },
  {
    "codigo":37481009,
    "descripcion":"TRASTORNO DEL SENTIDO DEL GUSTO EN AL ÁREA ANTERIOR DE LA LENGUA"
  },
  {
    "codigo":428862002,
    "descripcion":"ESPALDA PLANA CONGÉNITA"
  },
  {
    "codigo":234089008,
    "descripcion":"GANGLIO LINFÁTICO HIPOPLÁSICO"
  },
  {
    "codigo":232254004,
    "descripcion":"OTITIS MEDIA CRÓNICA NO SUPURATIVA"
  },
  {
    "codigo":164883002,
    "descripcion":"ELECTROCARDIOGRAMA: EXTRASÍSTOLE"
  },
  {
    "codigo":230419003,
    "descripcion":"SÍNDROME DE LENNOX-GASTAUT CRIPTOGÉNICO"
  },
  {
    "codigo":44271000087100,
    "descripcion":"CONTUSIÓN DE MALÉOLO EXTERNO DE PERONÉ IZQUIERDO"
  },
  {
    "codigo":427027005,
    "descripcion":"NEUROPATÍA DE PLEXO RADICULAR LUMBOSACRO DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":39151000087103,
    "descripcion":"DOLOR OROFACIAL CRÓNICO DEBIDO A TRASTORNO"
  },
  {
    "codigo":66579008,
    "descripcion":"TRASTORNO DEL PERITONEO"
  },
  {
    "codigo":41711000087104,
    "descripcion":"QUEMADURA DE SEGUNDO DEDO DE PIE DERECHO"
  },
  {
    "codigo":359656003,
    "descripcion":"ENTERITIS ULCERADA IDIOPÁTICA DIFUSA NO GRANULOMATOSA"
  },
  {
    "codigo":294120009,
    "descripcion":"ALERGIA A LA MEQUITAZINA"
  },
  {
    "codigo":95677002,
    "descripcion":"TRASTORNO DE LA VISIÓN"
  },
  {
    "codigo":62909004,
    "descripcion":"ECTROPIÓN"
  },
  {
    "codigo":1177021004,
    "descripcion":"INFECCIÓN TUBERCULOSA DE CONDUCTO BILIAR"
  },
  {
    "codigo":292285005,
    "descripcion":"REACCIÓN ADVERSA A LA TRIMIPRAMINA"
  },
  {
    "codigo":93842002,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL ISQUION"
  },
  {
    "codigo":716434003,
    "descripcion":"CAPAZ DE RECONOCER LA TEMPERATURA CORPORAL"
  },
  {
    "codigo":126610006,
    "descripcion":"NEOPLASIA DE PARTES BLANDAS DE AXILA"
  },
  {
    "codigo":92007005,
    "descripcion":"NEOPLASIA BENIGNA DE VASO SANGUÍNEO DEL CUELLO"
  },
  {
    "codigo":254012003,
    "descripcion":"HENDIDURA FACIAL SUPRAORBITARIA DE TESSIER 10"
  },
  {
    "codigo":1237052006,
    "descripcion":"METÁSTASIS DE CARCINOMA EN PROLONGACIÓN AXILAR DE MAMA"
  },
  {
    "codigo":90172009,
    "descripcion":"NARCOSIS"
  },
  {
    "codigo":284945005,
    "descripcion":"INCAPAZ DE PARARSE EN INODORO"
  },
  {
    "codigo":219409006,
    "descripcion":"HERIDA DE GUERRA POR DESTRUCCIÓN DE AERONAVE"
  },
  {
    "codigo":53734002,
    "descripcion":"HIPERQUERATOSIS EN LA FRAMBESIA"
  },
  {
    "codigo":283110005,
    "descripcion":"ARAÑAZO HUMANO"
  },
  {
    "codigo":1004006009,
    "descripcion":"ESTADIO CLÍNICO DE INFECCIÓN POR VIRUS DE LA INMUNODEFICIENCIA HUMANA DE LA ORGANIZACIÓN MUNDIAL DE LA SALUD"
  },
  {
    "codigo":51899005,
    "descripcion":"ACCIONAMIENTO HIPÓXICO DESPUNTADO"
  },
  {
    "codigo":248507006,
    "descripcion":"COPA ÓPTICA RETENIDA"
  },
  {
    "codigo":838331007,
    "descripcion":"ATAXIA DEBIDA A INFECCIÓN CRÓNICA DEL SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":281275008,
    "descripcion":"SIN COÁGULO EVIDENTE EN ESPÉCIMEN"
  },
  {
    "codigo":246672001,
    "descripcion":"VISIÓN DE COLORES POR DEBAJO DEL ESTÁNDAR ESTABLECIDO"
  },
  {
    "codigo":314043005,
    "descripcion":"PLEURESÍA VIRAL"
  },
  {
    "codigo":50064003,
    "descripcion":"ESTADIO V2"
  },
  {
    "codigo":277605001,
    "descripcion":"SÍNDROME DE LISIS TUMORAL"
  },
  {
    "codigo":310373003,
    "descripcion":"INMUNIZACIÓN ACONSEJADA"
  },
  {
    "codigo":80997009,
    "descripcion":"EMBARAZO DE QUINTILLIZOS"
  },
  {
    "codigo":10632031000119109,
    "descripcion":"ABSCESO DE PULPEJO DE DEDO DE LA MANO DERECHA"
  },
  {
    "codigo":243002005,
    "descripcion":"LESIÓN POR BALA DE RIFLE"
  },
  {
    "codigo":308538009,
    "descripcion":"SITUACIÓN DE CONSULTA DOMICILIARIA"
  },
  {
    "codigo":11791001,
    "descripcion":"VASCULITIS NECROSANTE"
  },
  {
    "codigo":208399001,
    "descripcion":"FRACTURA NO EXPUESTA DEL CUELLO DE METACARPIANO"
  },
  {
    "codigo":77327004,
    "descripcion":"INFECCIÓN CAUSADA POR LEISHMANIA MEXICANA"
  },
  {
    "codigo":110095005,
    "descripcion":"LACERACIÓN SIMPLE CONTAMINADA DE LA MUCOSA LABIAL"
  },
  {
    "codigo":44559009,
    "descripcion":"INTOXICACIÓN POR PERILLA FRUTESCENS"
  },
  {
    "codigo":304868003,
    "descripcion":"UNIÓN INSEGURA"
  },
  {
    "codigo":75492003,
    "descripcion":"CONSISTENCIA DE UNA COLONIA BACTERIANA, MEMBRANOSA"
  },
  {
    "codigo":403172005,
    "descripcion":"CALLOSIDAD PLANTAR"
  },
  {
    "codigo":1156836006,
    "descripcion":"DISTROFIA MUSCULAR DE EMERY-DREIFUSS LIGADA AL CROMOSOMA X"
  },
  {
    "codigo":698084004,
    "descripcion":"FRACTURA NO EXPUESTA DE FALANGE DISTAL DE DEDO GORDO DEL PIE"
  },
  {
    "codigo":763620003,
    "descripcion":"SÍNDROME DE TRICODERMODISPLASIA Y ALTERACIONES DENTALES"
  },
  {
    "codigo":1220537002,
    "descripcion":"NISTAGMO EVOCADO POR MIRADA"
  },
  {
    "codigo":339091000119101,
    "descripcion":"DEFORMIDAD DE ÓRBITA IZQUIERDA PROPIAMENTE DICHA DEBIDA A ENFERMEDAD ÓSEA"
  },
  {
    "codigo":1251470000,
    "descripcion":"METÁSTASIS DE OSTEOSARCOMA EN HUESO"
  },
  {
    "codigo":235662006,
    "descripcion":"GASTRITIS GRANULOMATOSA CRÓNICA"
  },
  {
    "codigo":301198009,
    "descripcion":"NARIZ NORMAL"
  },
  {
    "codigo":299363001,
    "descripcion":"AMPLITUD DE ROTACIÓN EXTERNA PASIVA DE LA RODILLA NORMAL"
  },
  {
    "codigo":366734009,
    "descripcion":"HALLAZGO RELACIONADO CON LA HABILIDAD PARA BAJAR UN ESCALÓN"
  },
  {
    "codigo":233827001,
    "descripcion":"INFARTO AGUDO DE ONDA Q - ANTEROLATERAL"
  },
  {
    "codigo":1076371000119105,
    "descripcion":"INFECCIÓN DE BOLSA SEROSA PRERROTULIANA DE RODILLA DERECHA"
  },
  {
    "codigo":789048003,
    "descripcion":"DRUSAS MACULARES PEQUEÑAS"
  },
  {
    "codigo":231992006,
    "descripcion":"CORIORRETINITIS POR ONCHOCERCA VOLVULUS"
  },
  {
    "codigo":68152007,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA REGIÓN ESCAPULAR"
  },
  {
    "codigo":440391000124104,
    "descripcion":"INFUSIÓN PARA NUTRICIÓN PARENTERAL EXCESIVA"
  },
  {
    "codigo":723512008,
    "descripcion":"DISQUERATOSIS CONGÉNITA CON RETINOPATÍA EXUDATIVA BILATERAL"
  },
  {
    "codigo":781000,
    "descripcion":"INTOXICACIÓN POR CESTRUM DIURNUM"
  },
  {
    "codigo":2631000124106,
    "descripcion":"SEGUNDO MOLAR SUPERIOR DERECHO PERMANENTE SUPERNUMERARIO"
  },
  {
    "codigo":721677005,
    "descripcion":"IMPACTACIÓN DE INTESTINO GRUESO"
  },
  {
    "codigo":230157006,
    "descripcion":"VENTRICULITIS VIRAL"
  },
  {
    "codigo":262925007,
    "descripcion":"RUPTURA DE LIGAMENTO SUSPENSORIO DEL PENE"
  },
  {
    "codigo":11807891000119108,
    "descripcion":"RUPTURA TRAUMÁTICA DE LIGAMENTO DE ARTICULACIÓN DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":197389006,
    "descripcion":"CÁLCULO DE VÍA BILIAR CON COLECISTITIS AGUDA"
  },
  {
    "codigo":293858002,
    "descripcion":"ALERGIA A BECLAMIDA"
  },
  {
    "codigo":295693009,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE IDARUBICINA"
  },
  {
    "codigo":719842006,
    "descripcion":"SÍNDROME DE HIPOPLASIA CONGÉNITA DE CÚBITO Y DISCAPACIDAD INTELECTUAL"
  },
  {
    "codigo":228322009,
    "descripcion":"EPISODIO DE BEBIDA"
  },
  {
    "codigo":62647006,
    "descripcion":"ESPASMO DOLOROSO DEL ANO"
  },
  {
    "codigo":95415006,
    "descripcion":"POLIMIALGIA"
  },
  {
    "codigo":423095007,
    "descripcion":"PLAGIOCEFALIA CONGÉNITA CON OBLICUIDAD DE LA PELVIS"
  },
  {
    "codigo":191884001,
    "descripcion":"PATRÓN DE USO NOCIVO DE ALCOHOL SIN DEPENDENCIA, EN REMISIÓN"
  },
  {
    "codigo":292023008,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ESTREPTODORNASA"
  },
  {
    "codigo":60812006,
    "descripcion":"MIOCARDITIS GIGANTOCELULAR"
  },
  {
    "codigo":290188007,
    "descripcion":"INTOXICACIÓN POR NALBUFINA"
  },
  {
    "codigo":386657000,
    "descripcion":"EPICANTO - HALLAZGO"
  },
  {
    "codigo":93580009,
    "descripcion":"OSIFICACIÓN INCOMPLETA DEL PERONÉ"
  },
  {
    "codigo":880012008,
    "descripcion":"MIOCARDITIS DEBIDA A ENFERMEDAD DE KAWASAKI"
  },
  {
    "codigo":1010227005,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE PIE DERECHO"
  },
  {
    "codigo":288353001,
    "descripcion":"NO CONSTRUYE UNA TORRE"
  },
  {
    "codigo":89910002,
    "descripcion":"ENVENENAMIENTO DEBIDO A PICADURA DE ABEJA MELÍFERA"
  },
  {
    "codigo":286518004,
    "descripcion":"DIFICULTAD PARA COCINAR ALIMENTOS"
  },
  {
    "codigo":11836871000119103,
    "descripcion":"SUBLUXACIÓN DE ARTICULACIÓN TARSOMETATARSIANA DE PIE IZQUIERDO"
  },
  {
    "codigo":253750008,
    "descripcion":"MALFORMACIÓN CONGÉNITA DE LENGUA, BOCA Y FARINGE"
  },
  {
    "codigo":16014791000119105,
    "descripcion":"OCLUSIÓN DE ARTERIA POPLÍTEA IZQUIERDA"
  },
  {
    "codigo":88075009,
    "descripcion":"TRASTORNO DE LA PLEURA"
  },
  {
    "codigo":1003744004,
    "descripcion":"CONTRACTURA EN FLEXIÓN DE ARTICULACIÓN METACARPOFALÁNGICA DE DEDO ANULAR"
  },
  {
    "codigo":16260551000119106,
    "descripcion":"DISFASIA DEBIDA A ACCIDENTE CEREBROVASCULAR Y POSTERIOR A ÉL"
  },
  {
    "codigo":40391000119106,
    "descripcion":"NEFRITIS CRÓNICA SECUNDARIA"
  },
  {
    "codigo":282848007,
    "descripcion":"INCAPAZ DE MANTENER UNA POSICIÓN"
  },
  {
    "codigo":281013003,
    "descripcion":"PROGRESO SATISFACTORIO"
  },
  {
    "codigo":248245006,
    "descripcion":"SUDORACIÓN FRÍA Y VISCOSA"
  },
  {
    "codigo":51637008,
    "descripcion":"TRASTORNO BIPOLAR I CRÓNICO, EPISODIO MÁS RECIENTE DEPRESIVO"
  },
  {
    "codigo":18869009,
    "descripcion":"PIGMENTACIÓN INDUCIDA POR CLORPROMAZINA"
  },
  {
    "codigo":341601000119102,
    "descripcion":"CONJUNTIVITIS FOLICULAR CRÓNICA DE OJO IZQUIERDO"
  },
  {
    "codigo":1078881000119102,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE LÓBULO INFERIOR DE PULMÓN IZQUIERDO"
  },
  {
    "codigo":703327002,
    "descripcion":"INSUFICIENCIA DE VÁLVULA MITRAL DEBIDA A ENFERMEDAD INFILTRANTE"
  },
  {
    "codigo":15199004,
    "descripcion":"BRONQUIOLITIS AGUDA CON BRONCOESPASMO"
  },
  {
    "codigo":1260383008,
    "descripcion":"CEFALEA POR USO EXCESIVO DE ERGOTAMINA COMO MEDICAMENTO"
  },
  {
    "codigo":406580004,
    "descripcion":"INFECCIÓN DEL SISTEMA NERVIOSO CENTRAL POR ESCHERICHIA COLI"
  },
  {
    "codigo":46132008,
    "descripcion":"AMPOLLA DE LA CADERA, CON INFECCIÓN"
  },
  {
    "codigo":275508008,
    "descripcion":"INFARTO COLÓNICO"
  },
  {
    "codigo":78900008,
    "descripcion":"CONDUCTO CÍSTICO NO FUNCIONANTE"
  },
  {
    "codigo":109833003,
    "descripcion":"NEOPLASIA MALIGNA SUPERPUESTA DE LABIO, CAVIDAD BUCAL Y FARINGE"
  },
  {
    "codigo":371977004,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL CIEGO"
  },
  {
    "codigo":765193007,
    "descripcion":"LESIÓN TRAUMÁTICA DE TROMPA DE EUSTAQUIO"
  },
  {
    "codigo":402910001,
    "descripcion":"CARCINOMA ANOGENITAL VERRUGOSO DE BUSCHKE-LÖWENSTEIN"
  },
  {
    "codigo":271838002,
    "descripcion":"HIPERPERISTALTISMO"
  },
  {
    "codigo":699657009,
    "descripcion":"LINFOMA HEPATOESPLÉNICO DE CÉLULAS GAMMA-DELTA"
  },
  {
    "codigo":1254878004,
    "descripcion":"HIPERHIDROSIS MENOPÁUSICA"
  },
  {
    "codigo":239070006,
    "descripcion":"QUERATODERMIA PALMOPLANTAR PROGRESIVA DE GREITHER"
  },
  {
    "codigo":204467000,
    "descripcion":"ATRESIA DE LA VENA PULMONAR"
  },
  {
    "codigo":40627003,
    "descripcion":"AUSENCIA CONGÉNITA DE VENA"
  },
  {
    "codigo":73395004,
    "descripcion":"RESPUESTA A LA INMUNIZACIÓN"
  },
  {
    "codigo":1086601000119100,
    "descripcion":"HEMORRAGIA INTESTINAL CONCOMITANTE CON DIVERTICULOSIS Y DEBIDA A ELLA"
  },
  {
    "codigo":16218761000119102,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE PIEL DE LABIO"
  },
  {
    "codigo":1081481000119103,
    "descripcion":"NEVO EPIDÉRMICO PILOSO PIGMENTADO DE OREJA IZQUIERDA"
  },
  {
    "codigo":12199561000119104,
    "descripcion":"INFECCIÓN ASOCIADA CON PRÓTESIS ARTICULAR DE RODILLA IZQUIERDA"
  },
  {
    "codigo":367241000119104,
    "descripcion":"COMA HIPEROSMOLAR POR DIABETES MELLITUS MEDICAMENTOSA"
  },
  {
    "codigo":313481000119101,
    "descripcion":"HIPERLORDOSIS DE COLUMNA VERTEBRAL LUMBAR Y SACRA"
  },
  {
    "codigo":15681161000119107,
    "descripcion":"DERMATITIS POR CONTACTO DE AMBOS PÁRPADOS"
  },
  {
    "codigo":354441000119101,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE GLÁNDULA LAGRIMAL IZQUIERDA"
  },
  {
    "codigo":336521000119101,
    "descripcion":"CANALICULITIS LAGRIMAL AGUDA DE REGIÓN DE OJO DERECHO"
  },
  {
    "codigo":16907401000119109,
    "descripcion":"ECTROPIÓN PARALÍTICO DE PÁRPADO DERECHO"
  },
  {
    "codigo":15724681000119107,
    "descripcion":"ENTESOPATÍA DE CADERA DERECHA"
  },
  {
    "codigo":15747721000119108,
    "descripcion":"MASA DE MÚSCULO DE AMBAS EXTREMIDADES INFERIORES"
  },
  {
    "codigo":339081000119104,
    "descripcion":"EDEMA DE ÓRBITA IZQUIERDA"
  },
  {
    "codigo":674441000119105,
    "descripcion":"HIPERPLASIA PSEUDOANGIOMATOSA DE ESTROMA MAMARIO"
  },
  {
    "codigo":308361000119107,
    "descripcion":"GRANULOMA POR CUERPO EXTRAÑO DE PARTES BLANDAS DE ANTEBRAZO IZQUIERDO"
  },
  {
    "codigo":366472003,
    "descripcion":"HALLAZGO RELACIONADO CON LA AMPLITUD DE LA FLEXIÓN DE HOMBRO"
  },
  {
    "codigo":169864006,
    "descripcion":"PESO AL NACER IGUAL A 50%-74% (3450-3749 G)"
  },
  {
    "codigo":315131000119107,
    "descripcion":"OSTEOCONDRITIS DISECANTE DE HUESO DE MANO"
  },
  {
    "codigo":102493007,
    "descripcion":"CRECIMIENTO CORPORAL AUMENTADO"
  },
  {
    "codigo":299101005,
    "descripcion":"SIN AMPLITUD ACTIVA DE ADUCCIÓN DE DEDO DE LA MANO"
  },
  {
    "codigo":10692501000119101,
    "descripcion":"TUMEFACCIÓN DEL TEJIDO CELULAR SUBCUTÁNEO DEL PULGAR IZQUIERDO"
  },
  {
    "codigo":461106006,
    "descripcion":"ORÍGENES NORMALES DE ARTERIAS CORONARIAS"
  },
  {
    "codigo":262663001,
    "descripcion":"LESIÓN PENETRANTE DE MUCOSA BUCAL ALVEOLAR"
  },
  {
    "codigo":197127002,
    "descripcion":"SÍNDROME POSVAGOTOMÍA"
  },
  {
    "codigo":295431001,
    "descripcion":"SOBREDOSIS DE LAXANTE"
  },
  {
    "codigo":721415001,
    "descripcion":"FRACTURA DE PRIMERA VÉRTEBRA DORSAL"
  },
  {
    "codigo":66055002,
    "descripcion":"TALASEMIA ALFA CERO"
  },
  {
    "codigo":31452001,
    "descripcion":"ÚLCERA GÁSTRICA SIN HEMORRAGIA Y SIN PERFORACIÓN PERO CON OBSTRUCCIÓN"
  },
  {
    "codigo":719580004,
    "descripcion":"SÍNDROME DE MICRODELECIÓN 16Q24.3"
  },
  {
    "codigo":293596005,
    "descripcion":"ALERGIA A BUPRENORFINA"
  },
  {
    "codigo":10666031000119100,
    "descripcion":"ÚLCERA ISQUÉMICA DE PIERNA DEBIDA A ENFERMEDAD ATEROSCLERÓTICA"
  },
  {
    "codigo":129756007,
    "descripcion":"CALCIFICACIÓN DE FORMA REDONDEADA"
  },
  {
    "codigo":226225000,
    "descripcion":"DIETA MUSULMANA"
  },
  {
    "codigo":62385000,
    "descripcion":"ALVEOLITIS DEL MAXILAR"
  },
  {
    "codigo":15935381000119107,
    "descripcion":"DEFORMIDAD EN FLEXIÓN DE ARTICULACIÓN DE AMBOS HOMBROS"
  },
  {
    "codigo":95153007,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE TESTÍCULO RETENIDO"
  },
  {
    "codigo":160689007,
    "descripcion":"CONFINADO EN EL DOMICILIO"
  },
  {
    "codigo":422833009,
    "descripcion":"ADENOCARCINOMA QUÍSTICO DE GLÁNDULA SALIVAL"
  },
  {
    "codigo":717745008,
    "descripcion":"DISPLASIA RENAL SECUNDARIA BILATERAL"
  },
  {
    "codigo":224390003,
    "descripcion":"ESCASA CONCIENCIA SOBRE LA SEGURIDAD EN EL TRABAJO"
  },
  {
    "codigo":93318005,
    "descripcion":"POSICIÓN ANÓMALA CONGÉNITA DEL DUCTUS ARTERIOSO"
  },
  {
    "codigo":781446006,
    "descripcion":"DISTENSIÓN DEL TENDÓN DEL MÚSCULO FLEXOR SUPERFICIAL DE LOS DEDOS DE LA MANO"
  },
  {
    "codigo":124251001,
    "descripcion":"DEFICIENCIA DE TRANSCETOLASA"
  },
  {
    "codigo":25947003,
    "descripcion":"DISFONÍA DEL TEMBLOR ORGÁNICO"
  },
  {
    "codigo":91483004,
    "descripcion":"ENCEFALITIS TUBERCULOSA"
  },
  {
    "codigo":187952001,
    "descripcion":"NEOPLASIA MALIGNA DE HUESOS PÉLVICOS, SACRO Y CÓCCIX"
  },
  {
    "codigo":286256004,
    "descripcion":"PRODUCE SONIDOS DEL HABLA"
  },
  {
    "codigo":15718601000119100,
    "descripcion":"ENTESOPATÍA DE MANO IZQUIERDA"
  },
  {
    "codigo":1300229003,
    "descripcion":"CIERRE DE ÁNGULO SECUNDARIO DE OJO IZQUIERDO - SINEQUIAL"
  },
  {
    "codigo":22277006,
    "descripcion":"AMPOLLA DE LA INGLE, CON INFECCIÓN"
  },
  {
    "codigo":344111000119109,
    "descripcion":"IRIDOCICLITIS RECURRENTE DE AMBOS OJOS"
  },
  {
    "codigo":53210006,
    "descripcion":"ERROR INNATO EN EL METABOLISMO DEL PIRUVATO"
  },
  {
    "codigo":282586007,
    "descripcion":"DIFICULTAD PARA REBOTAR"
  },
  {
    "codigo":247983000,
    "descripcion":"MÁS INGENIOSO QUE LO HABITUAL"
  },
  {
    "codigo":870575001,
    "descripcion":"TRASTORNO DE AURÍCULA CARDÍACA"
  },
  {
    "codigo":249818007,
    "descripcion":"CAMBIO EN EL TAMAÑO DEL ZAPATO - HALLAZGO"
  },
  {
    "codigo":442756004,
    "descripcion":"HALLAZGO RELACIONADO CON MEDICIÓN POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":770436006,
    "descripcion":"HIPERTROFIA MAMARIA JUVENIL FAMILIAR"
  },
  {
    "codigo":82308007,
    "descripcion":"INFECCIÓN POR FASCIOLA HEPATICA"
  },
  {
    "codigo":735833003,
    "descripcion":"LACERACIÓN DE VASO SANGUÍNEO DE PULGAR"
  },
  {
    "codigo":127331000119101,
    "descripcion":"SEPSIS CAUSADA POR STAPHYLOCOCCUS AUREUS SENSIBLE A METICILINA"
  },
  {
    "codigo":80473005,
    "descripcion":"HIPERHISTIDINEMIA NEONATAL"
  },
  {
    "codigo":111406002,
    "descripcion":"ESCLEROSIS MESANGIAL DIFUSA"
  },
  {
    "codigo":766766005,
    "descripcion":"SÍNDROME DE MICRODELECIÓN 1P31P32"
  },
  {
    "codigo":209710006,
    "descripcion":"SECCIÓN EXPUESTA DE LIGAMENTO TARSOMETATARSIANO"
  },
  {
    "codigo":109571003,
    "descripcion":"CARIES DENTAL PRIMARIA DE ORIGEN INDETERMINADO"
  },
  {
    "codigo":240643008,
    "descripcion":"LEISHMANIASIS CUTÁNEA ZOONÓTICA DE LA INDIA"
  },
  {
    "codigo":428339009,
    "descripcion":"TRASTORNO DE ARTICULACIÓN DEL PIE"
  },
  {
    "codigo":304344002,
    "descripcion":"AMPLITUD DEL MOVIMIENTO DE LA COLUMNA VERTEBRAL CERVICAL, DISMINUIDA"
  },
  {
    "codigo":271576001,
    "descripcion":"FRACTURA-LUXACIÓN DE GALEAZZI"
  },
  {
    "codigo":763096004,
    "descripcion":"TRASTORNO DEL HÍGADO DEBIDO A DREPANOCITOSIS"
  },
  {
    "codigo":402648009,
    "descripcion":"TELANGIECTASIA SECUNDARIA"
  },
  {
    "codigo":346621000119101,
    "descripcion":"PIGMENTACIÓN CONJUNTIVAL DE AMBOS OJOS"
  },
  {
    "codigo":366210000,
    "descripcion":"REFLEJO DE ENDEREZAMIENTO Y MARCHA - HALLAZGO"
  },
  {
    "codigo":235138000,
    "descripcion":"FISURA DE LABIO INFERIOR POR ESTAFILOCOCOS"
  },
  {
    "codigo":300674007,
    "descripcion":"DIFICULTAD PARA CRUZAR LA CALLE"
  },
  {
    "codigo":266071000,
    "descripcion":"ENFERMEDAD INFECCIOSA INTESTINAL"
  },
  {
    "codigo":398978008,
    "descripcion":"AGUDEZA VISUAL DE OJO IZQUIERDO-CORREGIDA"
  },
  {
    "codigo":167767004,
    "descripcion":"EXAMEN DE SEMEN: ANORMAL"
  },
  {
    "codigo":397143007,
    "descripcion":"EVALUACIÓN MAMOGRÁFICA (CATEGORÍA 3) - HALLAZGO PROBABLEMENTE BENIGNO, SEGUIMIENTO A CORTO PLAZO"
  },
  {
    "codigo":724823008,
    "descripcion":"PARKINSONISMO FUNCIONAL"
  },
  {
    "codigo":69463008,
    "descripcion":"SÍNDROME DE MAROTEAUX - LAMY"
  },
  {
    "codigo":298839009,
    "descripcion":"AMPLITUD DE ROTACIÓN EXTERNA PASIVA DE ARTICULACIÓN DE HOMBRO, AUMENTADA"
  },
  {
    "codigo":1148972003,
    "descripcion":"CAPAZ DE MANTENER LA SALUD"
  },
  {
    "codigo":722988004,
    "descripcion":"COMPRESIÓN DE NERVIO OLFATORIO"
  },
  {
    "codigo":231468005,
    "descripcion":"DEPENDENCIA DE DIETILAMIDA DE ÁCIDO LISÉRGICO"
  },
  {
    "codigo":721153000,
    "descripcion":"ANOMALÍA CONGÉNITA MATERNA QUE COMPLICA EL EMBARAZO"
  },
  {
    "codigo":196865000,
    "descripcion":"HERNIA PARAUMBILICAL - IRREDUCTIBLE"
  },
  {
    "codigo":229633005,
    "descripcion":"TARTAMUDEO LIMÍTROFE"
  },
  {
    "codigo":257006,
    "descripcion":"ROSÁCEA, TIPO ERITEMATOSA TELANGIECTÁSICA"
  },
  {
    "codigo":293334006,
    "descripcion":"REACCIÓN ADVERSA A LA HEPARINA"
  },
  {
    "codigo":195030007,
    "descripcion":"MIOCARDIOPATÍA EN LA ATAXIA DE FRIEDREICH"
  },
  {
    "codigo":193195000,
    "descripcion":"NEUROPATÍA POR SARCOIDOSIS"
  },
  {
    "codigo":94891003,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LABIOS MENORES VULVARES"
  },
  {
    "codigo":1340075004,
    "descripcion":"CAMBIO DE TEMPERATURA DE VACUNA DURANTE SU TRANSPORTE"
  },
  {
    "codigo":291499008,
    "descripcion":"INTOXICACIÓN POR CLARITROMICINA"
  },
  {
    "codigo":27520001,
    "descripcion":"PSORIASIS PUSTULOSA DE PALMAS Y PLANTAS"
  },
  {
    "codigo":289664000,
    "descripcion":"HALLAZGO RELACIONADO CON EL MOVIMIENTO DEL ÚTERO"
  },
  {
    "codigo":191360002,
    "descripcion":"EOSINOFILIA MEDICAMENTOSA"
  },
  {
    "codigo":93056004,
    "descripcion":"DILATACIÓN CONGÉNITA DE LA VENA CAVA INFERIOR"
  },
  {
    "codigo":781184005,
    "descripcion":"CICATRIZACIÓN TARDÍA DE HERIDA QUIRÚRGICA"
  },
  {
    "codigo":224128008,
    "descripcion":"FAMILIA CON HIJOS ADOLESCENTES"
  },
  {
    "codigo":91221002,
    "descripcion":"FORÚNCULO DE PARED ABDOMINAL"
  },
  {
    "codigo":255061006,
    "descripcion":"TUMOR BENIGNO DE ABDOMEN"
  },
  {
    "codigo":1172565007,
    "descripcion":"ESTENOSIS POSQUIRÚRGICA DE VENA PULMONAR"
  },
  {
    "codigo":285994003,
    "descripcion":"NO APAGA EL CONDUCTOR ELÉCTRICO PRINCIPAL"
  },
  {
    "codigo":253226005,
    "descripcion":"CATARATA SUTURAL CONGÉNITA"
  },
  {
    "codigo":89386007,
    "descripcion":"INFECCIÓN CAUSADA POR GYALOCEPHALUS"
  },
  {
    "codigo":449834008,
    "descripcion":"VÉRTIGO LATERAL"
  },
  {
    "codigo":284159002,
    "descripcion":"NO MUEVE UN PIE"
  },
  {
    "codigo":87551003,
    "descripcion":"QUISTE DE CONDUCTO CÍSTICO"
  },
  {
    "codigo":447999009,
    "descripcion":"TRACTO DE SALIDA VENTRICULAR ÚNICO POR ENCIMA DE VENTRICULO IZQUIERDO"
  },
  {
    "codigo":85716005,
    "descripcion":"INTERRUPCIÓN DE LA ESPERMATOGENIA"
  },
  {
    "codigo":282324006,
    "descripcion":"INCAPAZ DE PARARSE EN UNA SOLA PIERNA"
  },
  {
    "codigo":870313002,
    "descripcion":"ENFERMEDAD DE GAUCHER PERINATAL LETAL"
  },
  {
    "codigo":21451000119101,
    "descripcion":"PÉRDIDA DE LA AUDICIÓN LEVE A MODERADA"
  },
  {
    "codigo":313257005,
    "descripcion":"ARTROSIS PRIMARIA DE LA MUÑECA, LOCALIZADA"
  },
  {
    "codigo":1263529005,
    "descripcion":"MENINGIOMA BENIGNO DE FOSA OLFATORIA"
  },
  {
    "codigo":11817931000119102,
    "descripcion":"ESGUINCE DE LIGAMENTO DE ARTICULACIÓN METACARPOFALÁNGICA DE DEDO ÍNDICE DE MANO IZQUIERDA"
  },
  {
    "codigo":247721009,
    "descripcion":"PERCEPCIÓN TÁCTIL AUMENTADA"
  },
  {
    "codigo":349131000119103,
    "descripcion":"EDEMA PERIORBITARIO BILATERAL"
  },
  {
    "codigo":409726005,
    "descripcion":"SISTEMA INTERNACIONAL DE ESTADIFICACIÓN DE NEUROBLASTOMA, ESTADIO 4"
  },
  {
    "codigo":473427000,
    "descripcion":"COMPLEJO PRIMARIO TUBERCULOSO CONFIRMADO HISTOLÓGICAMENTE"
  },
  {
    "codigo":309587003,
    "descripcion":"CALCIFICACIÓN DE MAMA"
  },
  {
    "codigo":735571003,
    "descripcion":"DEFECTO ADQUIRIDO DE TABIQUE INTERVENTRICULAR"
  },
  {
    "codigo":14675005,
    "descripcion":"FRACTURA DE SIETE COSTILLAS"
  },
  {
    "codigo":209448002,
    "descripcion":"ESGUINCE DE LIGAMENTO RADIOCARPIANO DORSAL"
  },
  {
    "codigo":307752007,
    "descripcion":"ABORTO INCOMPLETO INEVITABLE COMPLICADO CON HEMORRAGIA EXCESIVA O TARDÍA"
  },
  {
    "codigo":897576008,
    "descripcion":"ESFEROFAQUIA BILATERAL"
  },
  {
    "codigo":109309004,
    "descripcion":"OSTEOMIELITIS AGUDA DE LOS HUESOS DE LA CARA"
  },
  {
    "codigo":76541004,
    "descripcion":"PERICARDITIS SECUNDARIA A QUILOPERICARDIO"
  },
  {
    "codigo":240381007,
    "descripcion":"TUBERCULOSIS CUTÁNEA MILIAR AGUDA"
  },
  {
    "codigo":238546005,
    "descripcion":"DERMATITIS ATÓPICA PRURIGINOSA"
  },
  {
    "codigo":402386006,
    "descripcion":"URTICARIA ALÉRGICA POR ALÉRGENO INHALADO"
  },
  {
    "codigo":1186983001,
    "descripcion":"SOBREDOSIS DE ANTIÁCIDO"
  },
  {
    "codigo":203943005,
    "descripcion":"ESPINA BÍFIDA LUMBAR CON HIDROCEFALIA - ABIERTA"
  },
  {
    "codigo":171175005,
    "descripcion":"CRIBADO PARA NEOPLASIA DE MAMA NORMAL"
  },
  {
    "codigo":105639006,
    "descripcion":"ENFERMEDAD CAUSADA POR CHILOMASTIGIDAE"
  },
  {
    "codigo":236711008,
    "descripcion":"CÁLCULO EN UNIÓN URETEROPÉLVICA"
  },
  {
    "codigo":726396003,
    "descripcion":"DELECIÓN DE PARTE DEL BRAZO LARGO DEL CROMOSOMA 20"
  },
  {
    "codigo":202108004,
    "descripcion":"RUPTURA ANTIGUA DE LIGAMENTO LATERAL EXTERNO DE RODILLA"
  },
  {
    "codigo":365948006,
    "descripcion":"PREDECIBILIDAD DE LA CONDUCTA - HALLAZGO"
  },
  {
    "codigo":300412007,
    "descripcion":"DEFENSA ABDOMINAL EN EL EPIGASTRIO"
  },
  {
    "codigo":398716006,
    "descripcion":"FIBROSIS ENDOMIOCÁRDICA"
  },
  {
    "codigo":724561002,
    "descripcion":"ENCEFALOPATÍA DEBIDA A DEFICIENCIA NUTRICIONAL"
  },
  {
    "codigo":429649005,
    "descripcion":"AMPOLLAS INFECTADAS EN MÚLTIPLES LOCALIZACIONES"
  },
  {
    "codigo":396881008,
    "descripcion":"TUMOR LIMITADO AL PÁNCREAS (PÁNCREAS ENDOCRINO)"
  },
  {
    "codigo":298577009,
    "descripcion":"OBSERVACIÓN DE SENSACIÓN EN ESTRUCTURA MUSCULOESQUELÉTICA DE COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":460582006,
    "descripcion":"ORIGEN ANÓMALO DE ARTERIA CORONARIA IZQUIERDA Y ARTERIA CORONARIA DERECHA EN ARTERIA PULMONAR"
  },
  {
    "codigo":198438009,
    "descripcion":"CEFALEA MENOPÁUSICA"
  },
  {
    "codigo":131067006,
    "descripcion":"ESTRIOL ANORMAL"
  },
  {
    "codigo":30928008,
    "descripcion":"ALCALURIA"
  },
  {
    "codigo":61861001,
    "descripcion":"VELOCIDAD DE LAS ASOCIACIONES"
  },
  {
    "codigo":296191000119107,
    "descripcion":"ALTERACIÓN DE MENISCO EXTERNO DEBIDA A LESIÓN TRAUMÁTICA DE RODILLA"
  },
  {
    "codigo":129232009,
    "descripcion":"ANALBUMINEMIA"
  },
  {
    "codigo":782757004,
    "descripcion":"SÍNDROME DE MICROCEFALIA CONGÉNITA, ENCEFALOPATÍA SEVERA Y ATROFIA CEREBRAL PROGRESIVA"
  },
  {
    "codigo":717221005,
    "descripcion":"DISPLASIA METAFISARIA TIPO BRAUN TINSCHERT"
  },
  {
    "codigo":29093005,
    "descripcion":"HEMIPARESIA CRUZADA"
  },
  {
    "codigo":94629006,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE MUSLO"
  },
  {
    "codigo":1208741006,
    "descripcion":"NEOPLASIA INDIFERENCIADA DE TÓRAX CON DEFICIENCIA DE SMARCA4"
  },
  {
    "codigo":291237006,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR SELEGILINA"
  },
  {
    "codigo":351641000119102,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE URÉTER DERECHO"
  },
  {
    "codigo":92794002,
    "descripcion":"CARCINOMA IN SITU DE SUPERFICIE VENTRAL DE LENGUA"
  },
  {
    "codigo":1010298008,
    "descripcion":"TRASTORNO FETAL DEBIDO A SOBREPESO MATERNO"
  },
  {
    "codigo":289402009,
    "descripcion":"PRESENTACIÓN VISIBLE"
  },
  {
    "codigo":254799002,
    "descripcion":"ANGIOENDOTELIOMA INTRALINFÁTICO PAPILAR DE LA INFANCIA"
  },
  {
    "codigo":25423001,
    "descripcion":"SUSPIRO"
  },
  {
    "codigo":420474008,
    "descripcion":"CICATRIZ SUBCONJUNTIVAL"
  },
  {
    "codigo":189263001,
    "descripcion":"CARCINOMA IN SITU DE CARINA BRONQUIAL"
  },
  {
    "codigo":123727000,
    "descripcion":"HIPERPLASIA SEVERA DE LA MÉDULA ÓSEA"
  },
  {
    "codigo":105881000119106,
    "descripcion":"ENGROSAMIENTO DE CÁPSULA DE CRISTALINO"
  },
  {
    "codigo":15670681000119108,
    "descripcion":"LUXACIÓN CONGÉNITA DE RÓTULA IZQUIERDA"
  },
  {
    "codigo":12367411000119102,
    "descripcion":"ARTROSIS DE ARTICULACIÓN ROTULOFEMORAL IZQUIERDA"
  },
  {
    "codigo":1332473009,
    "descripcion":"CELULITIS NECROSANTE"
  },
  {
    "codigo":282062001,
    "descripcion":"DESGARRO SEROSO DE YEYUNO"
  },
  {
    "codigo":773582002,
    "descripcion":"INFECCIÓN CAUSADA POR VIRUS HENDRA"
  },
  {
    "codigo":249294004,
    "descripcion":"CHORRO MICCIONAL INTERRUMPIDO"
  },
  {
    "codigo":216526004,
    "descripcion":"INTOXICACIÓN ACCIDENTAL CAUSADA POR HALOPERIDOL"
  },
  {
    "codigo":314830006,
    "descripcion":"DISCRIMINACIÓN TÁCTIL DEL PIE DERECHO NORMAL"
  },
  {
    "codigo":445902007,
    "descripcion":"INTOXICACIÓN POR HIERRO"
  },
  {
    "codigo":247459000,
    "descripcion":"CICATRIZ DE ACNÉ"
  },
  {
    "codigo":312995000,
    "descripcion":"DECÚBITO VENTRAL EN MARCO DE RELTON HALL"
  },
  {
    "codigo":1197731008,
    "descripcion":"PROPULSIÓN DEFECATORIA INADECUADA"
  },
  {
    "codigo":737144005,
    "descripcion":"ALERGIA A ÁCIDO ZOLEDRÓNICO"
  },
  {
    "codigo":16248006,
    "descripcion":"INTOXICACIÓN CAUSADA POR TRANQUILIZANTES A BASE DE BUTIROFENONA"
  },
  {
    "codigo":440397000,
    "descripcion":"OSTEOSARCOMA DE PELVIS PRIMARIO"
  },
  {
    "codigo":407629001,
    "descripcion":"ESCALA DE DETERIORO GENERAL NIVEL 1 - SIN DETERIORO COGNITIVO"
  },
  {
    "codigo":276557002,
    "descripcion":"HIPERGLUCEMIA NEONATAL"
  },
  {
    "codigo":298701000119101,
    "descripcion":"OSTEONECROSIS DE HOMBRO DEBIDA A TRAUMATISMO"
  },
  {
    "codigo":868216008,
    "descripcion":"OCLUSIÓN DE PORCIÓN DISTAL DE ARTERIA CORONARIA DERECHA"
  },
  {
    "codigo":1163128008,
    "descripcion":"COLITIS POR SALMONELLA PARATYPHI B"
  },
  {
    "codigo":1259597006,
    "descripcion":"EXTRAVASACIÓN DE LÍQUIDO CEFALORRAQUÍDEO CRANEAL DEBIDA A PROCEDIMIENTO EN SISTEMA NERVIOSO CENTRAL Y POSTERIOR A ÉL"
  },
  {
    "codigo":373026000,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM FALLAX"
  },
  {
    "codigo":79949009,
    "descripcion":"COCCIDIOIDOMICOSIS CUTÁNEA PRIMARIA"
  },
  {
    "codigo":209186002,
    "descripcion":"SUBLUXACIÓN EXPUESTA DE LA COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":45346005,
    "descripcion":"DESEQUILIBRIO NUTRICIONAL: CONSUMO EXCESIVO PARA LOS REQUERIMIENTOS CORPORALES"
  },
  {
    "codigo":1290530005,
    "descripcion":"RADIOGRAFÍA DE HUESO DE PIERNA NORMAL"
  },
  {
    "codigo":241954008,
    "descripcion":"ANAFILAXIA IDIOPÁTICA"
  },
  {
    "codigo":305655002,
    "descripcion":"ATENDIDO POR BIOQUÍMICO CLÍNICO"
  },
  {
    "codigo":371191006,
    "descripcion":"AUSENCIA CONGÉNITA BILATERAL DE LOS PIES"
  },
  {
    "codigo":403959008,
    "descripcion":"NEVO ANGIOMATOSO QUE ALTERA LA VISIÓN"
  },
  {
    "codigo":402124001,
    "descripcion":"VERRUGAS EN ESTADO DE INMUNODEFICIENCIA"
  },
  {
    "codigo":240119009,
    "descripcion":"MIOSITIS NODULAR FOCAL"
  },
  {
    "codigo":11849421000119105,
    "descripcion":"HERIDA DE MITAD IZQUIERDA DE PARED TORÁCICA DEBIDA A PICADURA DE INSECTO NO VENENOSO"
  },
  {
    "codigo":41676004,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE LA VAGINA, CON INFECCIÓN"
  },
  {
    "codigo":10743008,
    "descripcion":"SÍNDROME DE COLON IRRITABLE"
  },
  {
    "codigo":301985001,
    "descripcion":"HALLAZGO RELACIONADO CON PRÓTESIS DE GLOBO OCULAR"
  },
  {
    "codigo":203681002,
    "descripcion":"ESPONDILOLISTESIS ADQUIRIDA"
  },
  {
    "codigo":39841003,
    "descripcion":"CONSISTENCIA NORMAL"
  },
  {
    "codigo":1186721005,
    "descripcion":"ENFERMEDAD INFLAMATORIA INTESTINAL INFANTIL CON COMPROMISO NEUROLÓGICO"
  },
  {
    "codigo":365686000,
    "descripcion":"EXAMEN MICROSCÓPICO DE ORINA, GENERAL - HALLAZGO"
  },
  {
    "codigo":1217654000,
    "descripcion":"LÍNEA DE ARLT DE CONJUNTIVA"
  },
  {
    "codigo":234614005,
    "descripcion":"DEFICIENCIA DE LA CADENA BETA DEL COMPLEMENTO 8"
  },
  {
    "codigo":431222008,
    "descripcion":"RECHAZO AGUDO DE TRASPLANTE HEPÁTICO"
  },
  {
    "codigo":70774008,
    "descripcion":"INTOXICACIÓN POR TERMINALIA OBLONGATA"
  },
  {
    "codigo":300150008,
    "descripcion":"MEMBRANA TIMPÁNICA INYECTADA"
  },
  {
    "codigo":167243006,
    "descripcion":"DENSIDAD DE ORINA POR DEBAJO DE RANGO DE REFERENCIA"
  },
  {
    "codigo":46557031000119105,
    "descripcion":"TROMBOSIS VENOSA PROFUNDA AGUDA DE VENA PERONEA IZQUIERDA"
  },
  {
    "codigo":298315009,
    "descripcion":"HALLAZGO RELACIONADO CON EL PATRÓN DE COORDINACIÓN"
  },
  {
    "codigo":296480000,
    "descripcion":"SOBREDOSIS DE ALOPURINOL"
  },
  {
    "codigo":36171008,
    "descripcion":"GLOMERULONEFRITIS"
  },
  {
    "codigo":67104004,
    "descripcion":"AUTOMATISMO AMBULATORIO"
  },
  {
    "codigo":165408006,
    "descripcion":"RECUENTO HEMATOLÓGICO COMPLETO FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1179381000,
    "descripcion":"HIPOTIROIDISMO CENTRAL ADQUIRIDO DEBIDO A SÍNDROME DE SHEEHAN"
  },
  {
    "codigo":354151000119107,
    "descripcion":"NEOPLASIA BENIGNA DE CÓRNEA IZQUIERDA"
  },
  {
    "codigo":681831000119107,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE CUELLO DE PÁNCREAS"
  },
  {
    "codigo":196341005,
    "descripcion":"ABSCESO PERIAPICAL"
  },
  {
    "codigo":294645006,
    "descripcion":"ALERGIA A COMPONENTE DE VACUNA QUE CONTIENE ANTÍGENOS DE BORDETELLA PERTUSSIS, CLOSTRIDIUM TETANI Y CORYNEBACTERIUM DIPHTHERIAE"
  },
  {
    "codigo":1144778000,
    "descripcion":"INTOXICACIÓN POR LEVOTIROXINA"
  },
  {
    "codigo":292810000,
    "descripcion":"REACCIÓN ADVERSA A LA NATAMICINA"
  },
  {
    "codigo":1208479002,
    "descripcion":"ELASTORREXIS PAPULAR"
  },
  {
    "codigo":61599003,
    "descripcion":"FLEBITIS"
  },
  {
    "codigo":94367004,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA CARA LARÍNGEA DEL PLIEGUE INTERARITENOIDEO"
  },
  {
    "codigo":1306783005,
    "descripcion":"MALFORMACIÓN CONGÉNITA DE ÁNGULO DE CÁMARA ANTERIOR DE OJO DERECHO"
  },
  {
    "codigo":225439006,
    "descripcion":"NO ESTÁ CONFUNDIDO"
  },
  {
    "codigo":127135008,
    "descripcion":"LINFADENOPATÍA PANCREATICODUODENAL"
  },
  {
    "codigo":290975008,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR ETOSUXIMIDA"
  },
  {
    "codigo":289140002,
    "descripcion":"HALLAZGO RELACIONADO CON LA REGULARIDAD DE LA ALIMENTACIÓN"
  },
  {
    "codigo":92532004,
    "descripcion":"CARCINOMA IN SITU DE LA CARA ANTERIOR DE LA EPIGLOTIS"
  },
  {
    "codigo":11796481000119106,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE DEDO DE LA MANO DERECHA"
  },
  {
    "codigo":715124005,
    "descripcion":"SE TRANSFIERE DE LA SILLA DE RUEDAS AL INODORO"
  },
  {
    "codigo":1237577000,
    "descripcion":"FORMA SINTOMÁTICA DEL SÍNDROME DE COFFIN-LOWRY EN MUJERES PORTADORAS"
  },
  {
    "codigo":959201281000119107,
    "descripcion":"LESIÓN TRAUMÁTICA POR PRESIÓN DE TEJIDO PROFUNDO DE GLÚTEO IZQUIERDO"
  },
  {
    "codigo":189001006,
    "descripcion":"LIPOMA DE CADERA"
  },
  {
    "codigo":1137438000,
    "descripcion":"DOLOR DEBIDO A ARTRITIS"
  },
  {
    "codigo":283635000,
    "descripcion":"HERIDA POR PINCHAZO DE AGUJA EN PIERNA"
  },
  {
    "codigo":416542009,
    "descripcion":"HALLAZGO RELACIONADO CON LA ROTACIÓN VERTEBRAL"
  },
  {
    "codigo":285470009,
    "descripcion":"CIERRA LA BOCA"
  },
  {
    "codigo":185331003,
    "descripcion":"MÉDICO RETIRADO"
  },
  {
    "codigo":489609371000119104,
    "descripcion":"FIBRILACIÓN AURICULAR PERSISTENTE DEBIDA A TRASTORNO DE VÁLVULA CARDÍACA"
  },
  {
    "codigo":1363144001,
    "descripcion":"ASTILLA EN MUÑECA CON INFECCIÓN"
  },
  {
    "codigo":871624004,
    "descripcion":"VÁLVULA AURICULOVENTRICULAR COMÚN CON DESEQUILIBRIO HACIA EL VENTRÍCULO DERECHO"
  },
  {
    "codigo":249032005,
    "descripcion":"HALLAZGO RELACIONADO CON LA VELOCIDAD DEL PARTO"
  },
  {
    "codigo":609480009,
    "descripcion":"INTERRUPCIÓN INDUCIDA DEL EMBARAZO COMPLICADA POR EMBOLIA PULMONAR"
  },
  {
    "codigo":443805006,
    "descripcion":"TRASTORNO DEL ESPECTRO DE NEUROPATÍA AUDITIVA"
  },
  {
    "codigo":247197009,
    "descripcion":"FONDO DE OJO ATIGRADO"
  },
  {
    "codigo":240403008,
    "descripcion":"LEPRA LEPROMATOSA LIMÍTROFE"
  },
  {
    "codigo":866119000,
    "descripcion":"ABSCESO HEPÁTICO BACTERIANO"
  },
  {
    "codigo":767815001,
    "descripcion":"QUISTE EMBRIONARIO DE EPIPLÓN"
  },
  {
    "codigo":441970008,
    "descripcion":"AGONISTA OPIÁCEO DETECTADO EN ESPÉCIMEN DE SANGRE"
  },
  {
    "codigo":1259335000,
    "descripcion":"CARCINOMA PRIMARIO DE ÚVULA"
  },
  {
    "codigo":276295006,
    "descripcion":"HABILIDADES ARTÍSTICAS AISLADAS"
  },
  {
    "codigo":733212000,
    "descripcion":"HERIDA ABIERTA DE TÓRAX"
  },
  {
    "codigo":14151009,
    "descripcion":"HIPERESTESIA"
  },
  {
    "codigo":307228001,
    "descripcion":"RETENCIÓN GÁSTRICA POSOPERATORIA"
  },
  {
    "codigo":700444003,
    "descripcion":"RUPTURA AGUDA DE SINDESMOSIS DE TOBILLO"
  },
  {
    "codigo":1193799008,
    "descripcion":"INFLAMACIÓN INTESTINAL POR PROTOZOARIO"
  },
  {
    "codigo":12316007,
    "descripcion":"ÚTERO FETAL PERSISTENTE"
  },
  {
    "codigo":405532008,
    "descripcion":"EPISODIO ADVERSO QUE OCASIONA UNA LESIÓN POTENCIALMENTE INCAPACITANTE"
  },
  {
    "codigo":1222897001,
    "descripcion":"INCAPAZ DE PATEAR OBJETO"
  },
  {
    "codigo":208924008,
    "descripcion":"DESGARRO AGUDO DE MENISCO EXTERNO, EN ASA DE BALDE"
  },
  {
    "codigo":403697005,
    "descripcion":"DESPIGMENTACIÓN INDUCIDA POR LÁSER"
  },
  {
    "codigo":698609007,
    "descripcion":"DISFUNCIÓN MEDICAMENTOSA DEL SISTEMA VESTIBULAR"
  },
  {
    "codigo":16058831000119102,
    "descripcion":"RECHAZO DE TRASPLANTE DE CÓRNEA DE OJO DERECHO"
  },
  {
    "codigo":860614004,
    "descripcion":"LESIÓN TRAUMÁTICA DE RAÍZ DE NERVIO LUMBAR"
  },
  {
    "codigo":205254006,
    "descripcion":"SINOSTOSIS RADIOCUBITAL Y LUXACIÓN DE LA CABEZA DEL RADIO"
  },
  {
    "codigo":39579001,
    "descripcion":"ANAFILAXIA"
  },
  {
    "codigo":301723001,
    "descripcion":"DIFICULTAD PARA REALIZAR ACTIVIDADES RELACIONADAS CON LA POSTULACIÓN A UN TRABAJO"
  },
  {
    "codigo":762310009,
    "descripcion":"VESTIBULOPATÍA DERECHA PERSISTENTE POSTERIOR A NEURONITIS VESTIBULAR"
  },
  {
    "codigo":400027003,
    "descripcion":"QUEMADURA CUTÁNEA POR CEMENTO"
  },
  {
    "codigo":238022009,
    "descripcion":"DEFICIENCIA VARIANTE B DE HEXOSAMINIDASA A - JUVENIL"
  },
  {
    "codigo":6811007,
    "descripcion":"PREJUICIO"
  },
  {
    "codigo":430960001,
    "descripcion":"DEFORMIDAD DE PÁRPADO"
  },
  {
    "codigo":398192003,
    "descripcion":"COMORBILIDADES"
  },
  {
    "codigo":234352004,
    "descripcion":"ANEMIA NORMOCÍTICA POR PÉRDIDA CRÓNICA DE SANGRE"
  },
  {
    "codigo":365424005,
    "descripcion":"HALLAZGO RELACIONADO CON MOTILIDAD DE ESPERMATOZOIDES"
  },
  {
    "codigo":296218003,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE ENANTATO DE FLUFENAZINA"
  },
  {
    "codigo":10953321000119103,
    "descripcion":"HERIDA ABIERTA DE DEDO MEDIO DE MANO IZQUIERDA DEBIDA A MORDEDURA DE GATO"
  },
  {
    "codigo":722202006,
    "descripcion":"SÍNDROME DE QUERATODERMIA PALMOPLANTAR, INVERSIÓN SEXUAL 46,XX Y PREDISPOSICIÓN AL CARCINOMA ESCAMOCELULAR"
  },
  {
    "codigo":230682007,
    "descripcion":"MIASTENIA INDUCIDA POR PENICILAMINA"
  },
  {
    "codigo":294383002,
    "descripcion":"ALERGIA A VIDARABINA"
  },
  {
    "codigo":425455002,
    "descripcion":"GLOMERULONEFRITIS DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":785903005,
    "descripcion":"CONTRACTURA DE MÚSCULO POSTERIOR A LESIÓN TRAUMÁTICA"
  },
  {
    "codigo":196079009,
    "descripcion":"PLEURESÍA BASAL"
  },
  {
    "codigo":30404001,
    "descripcion":"INTOXICACIÓN POR KALMIA ANGUSTIFOLIA"
  },
  {
    "codigo":16907011000119100,
    "descripcion":"NEVO MELANOCÍTICO DE PÁRPADO INFERIOR IZQUIERDO"
  },
  {
    "codigo":290713000,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR CARBOPLATINO"
  },
  {
    "codigo":94105000,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE COLON TRANSVERSO"
  },
  {
    "codigo":716697002,
    "descripcion":"PERSISTENCIA DE ALFA-FETOPROTEÍNA HEREDITARIA"
  },
  {
    "codigo":126873003,
    "descripcion":"NEOPLASIA DEL TEJIDO PERISUPRARRENAL"
  },
  {
    "codigo":61337004,
    "descripcion":"COREA ELÉCTRICA"
  },
  {
    "codigo":714862000,
    "descripcion":"INCAPAZ DE RESPETAR REGLAS Y LÍMITES"
  },
  {
    "codigo":92270001,
    "descripcion":"NEOPLASIA BENIGNA DEL PARAMETRIO"
  },
  {
    "codigo":288878005,
    "descripcion":"CAPAZ DE BEBER A SORBOS"
  },
  {
    "codigo":26734006,
    "descripcion":"ESCALA DEL COMA DE GLASGOW, 14"
  },
  {
    "codigo":254275003,
    "descripcion":"REORDENAMIENTO BALANCEADO Y MARCADOR ESTRUCTURAL"
  },
  {
    "codigo":385347004,
    "descripcion":"NIVEL DE MELANOMA DE CLARK - HALLAZGO"
  },
  {
    "codigo":418115006,
    "descripcion":"CLASE II DEL CENTRO DE PREVENCIÓN Y CONTROL DE ENFERMEDADES\/LIMPIO-CONTAMINADO"
  },
  {
    "codigo":285208000,
    "descripcion":"INCAPAZ DE RECORDAR UNA DIRECCIÓN AL AZAR DESPUÉS DE CINCO MINUTOS"
  },
  {
    "codigo":332701000119101,
    "descripcion":"AMBLIOPÍA REFRACTARIA DEL OJO DERECHO"
  },
  {
    "codigo":283373008,
    "descripcion":"LACERACIÓN DEL DORSO DE LA MANO"
  },
  {
    "codigo":86765009,
    "descripcion":"RETRASO MENTAL LEVE"
  },
  {
    "codigo":281538002,
    "descripcion":"DISTENSIÓN DE TENDÓN DEL TRONCO"
  },
  {
    "codigo":445378003,
    "descripcion":"EXACERBACIÓN AGUDA DE BRONQUIECTASIA"
  },
  {
    "codigo":31491000119109,
    "descripcion":"ALTERACIONES DEL CICLO DE SUEÑO-VIGILIA DE 24 HORAS"
  },
  {
    "codigo":248770005,
    "descripcion":"ERECCIÓN QUE SE LOGRA MUY FÁCILMENTE"
  },
  {
    "codigo":609218006,
    "descripcion":"DISCINESIA PAROXÍSTICA NO CINESIGÉNICA"
  },
  {
    "codigo":1297346004,
    "descripcion":"CIERRE DE ÁNGULO AGUDO SECUNDARIO FACOMÓRFICO DE OJO IZQUIERDO"
  },
  {
    "codigo":83095000,
    "descripcion":"CEFALOHEMATOMA FETAL"
  },
  {
    "codigo":771223000,
    "descripcion":"ENCEFALOPATÍA EPILÉPTICA DISCINÉTICA INFANTIL"
  },
  {
    "codigo":50327002,
    "descripcion":"HIPONATREMIA CRÓNICA"
  },
  {
    "codigo":1295511007,
    "descripcion":"HIPERTENSIÓN OCULAR DE OJO DERECHO DEBIDA A TRASTORNO DE CRISTALINO"
  },
  {
    "codigo":15724005,
    "descripcion":"FRACTURA DE LA COLUMNA VERTEBRAL SIN LESIÓN TRAUMÁTICA DE LA MÉDULA ESPINAL"
  },
  {
    "codigo":441708007,
    "descripcion":"TUMEFACCIÓN DE REGIÓN INFERIOR DE LA MANDÍBULA"
  },
  {
    "codigo":79425001,
    "descripcion":"INFECCIÓN CAUSADA POR GNATHOSTOMA DOLORESI"
  },
  {
    "codigo":1193537006,
    "descripcion":"TRASTORNO NEONATAL PRECOZ DEBIDO A INSUFICIENCIA PLACENTARIA"
  },
  {
    "codigo":1259073007,
    "descripcion":"TRASTORNO DE SISTEMA NERVIOSO AUTÓNOMO CAUSADO POR PIRIMILINO"
  },
  {
    "codigo":13889008,
    "descripcion":"NEFROPATÍA POR METIL-LOMUSTINA"
  },
  {
    "codigo":5021000119108,
    "descripcion":"ACALASIA DE ESÓFAGO ADQUIRIDA"
  },
  {
    "codigo":274198002,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE MUSLO"
  },
  {
    "codigo":110358001,
    "descripcion":"FOBIA GLOBAL"
  },
  {
    "codigo":896790004,
    "descripcion":"FORMA ANCHA ANORMAL CONGÉNITA DE FALANGE MEDIA DE SEGUNDO DEDO DE PIE"
  },
  {
    "codigo":276033009,
    "descripcion":"TIENE UN HIJO ADOPTADO"
  },
  {
    "codigo":405270006,
    "descripcion":"MIDRIASIS PERSISTENTE"
  },
  {
    "codigo":732950006,
    "descripcion":"SÍNDROME DE ICTIOSIS Y ANOMALÍAS BUCALES Y DIGITALES"
  },
  {
    "codigo":208662008,
    "descripcion":"FRACTURA NO EXPUESTA DE TOBILLO, BIMALEOLAR, FRACTURA PERONEA INFERIOR"
  },
  {
    "codigo":10628151000119104,
    "descripcion":"ÁNTRAX DE EXTREMIDAD INFERIOR IZQUIERDA"
  },
  {
    "codigo":403435005,
    "descripcion":"CONJUNTIVITIS LEÑOSA"
  },
  {
    "codigo":16034871000119106,
    "descripcion":"ENFERMEDAD DE PAGET DE AMBOS PIES"
  },
  {
    "codigo":41152008,
    "descripcion":"CELULITIS ANAL"
  },
  {
    "codigo":10321000132105,
    "descripcion":"TORSIÓN DE COLON CONCOMITANTE CON ADHERENCIAS Y DEBIDO A ELLAS"
  },
  {
    "codigo":237760008,
    "descripcion":"ENFERMEDAD DE ADDISON CON ADRENOLEUCODISTROFIA"
  },
  {
    "codigo":301461004,
    "descripcion":"INCAPAZ DE REALIZAR ACTIVIDADES EDUCATIVAS"
  },
  {
    "codigo":12266551000119108,
    "descripcion":"CHOQUE SÉPTICO POSTERIOR A PROCEDIMIENTO"
  },
  {
    "codigo":203157008,
    "descripcion":"OSTEOMIELITIS AGUDA DE COLUMNA VERTEBRAL CERVICAL"
  },
  {
    "codigo":1153429009,
    "descripcion":"QUIROMEGALIA"
  },
  {
    "codigo":235925007,
    "descripcion":"QUISTE DE LOS CONDUCTOS BILIARES INTRAHEPÁTICOS"
  },
  {
    "codigo":103018003,
    "descripcion":"MAREO POR ESFUERZO"
  },
  {
    "codigo":234090004,
    "descripcion":"ADENITIS MESENTÉRICA TUBERCULOSA"
  },
  {
    "codigo":365162003,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA DESABROCHAR LA ROPA"
  },
  {
    "codigo":70250009,
    "descripcion":"QUEMADURA EPIDÉRMICA DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":295956001,
    "descripcion":"SOBREDOSIS DE VILOXAZINA"
  },
  {
    "codigo":33812003,
    "descripcion":"ESTRECHEZ DE DUODENO"
  },
  {
    "codigo":16909521000119106,
    "descripcion":"DISFUNCIÓN DE GLÁNDULA DE MEIBOMIO DE PÁRPADO SUPERIOR E INFERIOR IZQUIERDO"
  },
  {
    "codigo":164884008,
    "descripcion":"ELECTROCARDIOGRAMA: LATIDOS VENTRICULARES ECTÓPICOS"
  },
  {
    "codigo":230420009,
    "descripcion":"SÍNDROME SINTOMÁTICO DE LENNOX-GASTAUT"
  },
  {
    "codigo":15680721000119107,
    "descripcion":"CONJUNTIVITIS INFECCIOSA BILATERAL"
  },
  {
    "codigo":335211000119101,
    "descripcion":"QUERATOCONJUNTIVITIS POR EXPOSICIÓN DE OJO DERECHO"
  },
  {
    "codigo":11804011000119101,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA DISTAL DE DEDO MEÑIQUE IZQUIERDO"
  },
  {
    "codigo":689361000119108,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE FOSA AMIGDALINA"
  },
  {
    "codigo":294121008,
    "descripcion":"ALERGIA A OXATOMIDA"
  },
  {
    "codigo":1177022006,
    "descripcion":"COLONIZACIÓN DE TRACTO RESPIRATORIO CAUSADA POR PNEUMOCYSTIS JIROVECII"
  },
  {
    "codigo":1144254006,
    "descripcion":"MASA DE TRÁQUEA"
  },
  {
    "codigo":95678007,
    "descripcion":"TRASTORNO DEL TRACTO UVEAL"
  },
  {
    "codigo":193982009,
    "descripcion":"EPÍFORA"
  },
  {
    "codigo":716435002,
    "descripcion":"CAPAZ DE RECONOCER EL DOLOR GENERALIZADO"
  },
  {
    "codigo":292286006,
    "descripcion":"REACCIÓN ADVERSA A LA AMOXAPINA"
  },
  {
    "codigo":34761000087100,
    "descripcion":"MÚLTIPLES LESIONES CRANEANAS TRAUMÁTICAS"
  },
  {
    "codigo":126611005,
    "descripcion":"NEOPLASIA DE PARTES BLANDAS DEL ABDOMEN"
  },
  {
    "codigo":47561000087101,
    "descripcion":"FRACTURA DE ACETÁBULO IZQUIERDO"
  },
  {
    "codigo":192147004,
    "descripcion":"TRASTORNO MIXTO DEL DESARROLLO PSICOLÓGICO"
  },
  {
    "codigo":26472000,
    "descripcion":"PARAFRENIA"
  },
  {
    "codigo":39881000087104,
    "descripcion":"HERIDA DE OÍDO EXTERNO IZQUIERDO POR MORDEDURA"
  },
  {
    "codigo":55241000087106,
    "descripcion":"SIGNOS DE DESHIDRATACIÓN"
  },
  {
    "codigo":288616003,
    "descripcion":"CAPAZ DE EMPLEAR CONSTRUCCIONES GRAMATICALES"
  },
  {
    "codigo":42441000087104,
    "descripcion":"LESIÓN TRAUMÁTICA DE LIGAMENTO LATERAL INTERNO DE RODILLA DERECHA"
  },
  {
    "codigo":92008000,
    "descripcion":"NEOPLASIA BENIGNA DE VASO SANGUÍNEO PÉLVICO"
  },
  {
    "codigo":93843007,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LOS ISLOTES DE LANGERHANS"
  },
  {
    "codigo":1237053001,
    "descripcion":"METÁSTASIS DE CARCINOMA DE CUADRANTE SUPERIOR INTERNO DE MAMA"
  },
  {
    "codigo":286781002,
    "descripcion":"HALLAZGO DE RASGOS DE LA PERSONALIDAD RELACIONADOS CON EL GRADO DE SUGESTIONABILIAD"
  },
  {
    "codigo":55570000,
    "descripcion":"ASMA SIN ESTADO ASMÁTICO"
  },
  {
    "codigo":712765008,
    "descripcion":"CANDIDA INCONSPICUA O CANDIDA LAMBICA"
  },
  {
    "codigo":254013008,
    "descripcion":"FISURA FACIAL SUPRAORBITARIA DE TESSIER 11"
  },
  {
    "codigo":219410001,
    "descripcion":"HERIDA DE GUERRA POR INCENDIO DE AERONAVE"
  },
  {
    "codigo":448786001,
    "descripcion":"DESVIACIÓN POSTERIOR DE TABIQUE INFUNDIBULAR CON LESIÓN OBSTRUCTIVA DE CAYADO AÓRTICO"
  },
  {
    "codigo":16637291000119109,
    "descripcion":"TRASTORNO DE AMBOS NERVIOS TIBIALES"
  },
  {
    "codigo":22802006,
    "descripcion":"FRACTURA PERTROCANTÉREA NO EXPUESTA"
  },
  {
    "codigo":284946006,
    "descripcion":"SE PARA EN INODORO"
  },
  {
    "codigo":1004007000,
    "descripcion":"TRASTORNO FETAL DEBIDO A TOMA DE MUESTRA DE SANGRE FETAL Y POSTERIOR A ELLA"
  },
  {
    "codigo":838332000,
    "descripcion":"ABSCESO DE TRONCO ENCEFÁLICO"
  },
  {
    "codigo":283111009,
    "descripcion":"ARAÑAZO DE PERRO"
  },
  {
    "codigo":248508001,
    "descripcion":"EDEMA DE PARED ABDOMINAL"
  },
  {
    "codigo":445116003,
    "descripcion":"ENCEFALOCELE DE VÉRTICE"
  },
  {
    "codigo":19132000,
    "descripcion":"ESTENOSIS DE COLON"
  },
  {
    "codigo":281276009,
    "descripcion":"ESPÉCIMEN OPALESCENTE"
  },
  {
    "codigo":246673006,
    "descripcion":"DISCRIMINACIÓN DE COLORES REDUCIDA"
  },
  {
    "codigo":277606000,
    "descripcion":"TUMOR LINFORRETICULAR"
  },
  {
    "codigo":48230001,
    "descripcion":"PROLAPSO UTERINO DE PRIMER GRADO"
  },
  {
    "codigo":1162342002,
    "descripcion":"OSIFICACIÓN DE LIGAMENTO LONGITUDINAL POSTERIOR Y LIGAMENTO AMARILLO"
  },
  {
    "codigo":408678008,
    "descripcion":"INFECCIÓN NOSOCOMIAL"
  },
  {
    "codigo":15462009,
    "descripcion":"ESCOTOMA ARQUEADO"
  },
  {
    "codigo":275771000,
    "descripcion":"PARACETAMOL EN ORINA"
  },
  {
    "codigo":310374009,
    "descripcion":"ESTADO DE VACUNACIÓN MMR"
  },
  {
    "codigo":767291004,
    "descripcion":"PANCREATITIS CRÓNICA DEBIDA A INTOXICACIÓN ALCOHÓLICA AGUDA"
  },
  {
    "codigo":243003000,
    "descripcion":"LESIÓN POR BALA DE AMETRALLADORA DE ALTA VELOCIDAD"
  },
  {
    "codigo":46395002,
    "descripcion":"ARTERIAS RENALES MÚLTIPLES"
  },
  {
    "codigo":11832991000119105,
    "descripcion":"ESGUINCE DE LIGAMENTO DE ARTICULACIÓN DE SEGUNDO A QUINTO DEDOS DE PIE IZQUIERDO"
  },
  {
    "codigo":110096006,
    "descripcion":"LACERACIÓN COMPLEJA DE LA MUCOSA LABIAL"
  },
  {
    "codigo":403173000,
    "descripcion":"CALLOSIDAD PRETALAR"
  },
  {
    "codigo":208400008,
    "descripcion":"FRACTURA NO EXPUESTA DE CABEZA DE METACARPIANO"
  },
  {
    "codigo":1156837002,
    "descripcion":"NEUROPATÍA MOTORA DISTAL HEREDITARIA AUTOSÓMICA DOMINANTE"
  },
  {
    "codigo":42725006,
    "descripcion":"ACONDROGÉNESIS, TIPO IA"
  },
  {
    "codigo":206565007,
    "descripcion":"RUMIACIÓN EN EL RECIÉN NACIDO"
  },
  {
    "codigo":9957009,
    "descripcion":"SECRECIÓN URETRAL"
  },
  {
    "codigo":16010911000119109,
    "descripcion":"ARTROPATÍA DE PIE DERECHO"
  },
  {
    "codigo":237498007,
    "descripcion":"BOCIO TÓXICO"
  },
  {
    "codigo":73658009,
    "descripcion":"ERITEMA POLIMORFO, TIPO EPIDÉRMICO"
  },
  {
    "codigo":301199001,
    "descripcion":"PROBLEMA NASAL"
  },
  {
    "codigo":40890009,
    "descripcion":"DISFAGIA ESOFÁGICA"
  },
  {
    "codigo":15738681000119104,
    "descripcion":"INFECCIÓN DE OJO DERECHO"
  },
  {
    "codigo":235663001,
    "descripcion":"GASTRITIS GRANULOMATOSA AISLADA"
  },
  {
    "codigo":1251471001,
    "descripcion":"METÁSTASIS DE OSTEOSARCOMA EN CLAVÍCULA"
  },
  {
    "codigo":39055007,
    "descripcion":"CLONO DE TOBILLO"
  },
  {
    "codigo":366735005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA SUBIR ESCALERAS"
  },
  {
    "codigo":364900001,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA MOVER LA CABEZA"
  },
  {
    "codigo":170127009,
    "descripcion":"EXAMEN DEL NIÑO A LOS 8 - 9 MESES: NORMAL"
  },
  {
    "codigo":233828006,
    "descripcion":"INFARTO AGUDO NO Q - ANTEROLATERAL"
  },
  {
    "codigo":299364007,
    "descripcion":"AMPLITUD DE ROTACIÓN EXTERNA PASIVA DE LA RODILLA AUMENTADA"
  },
  {
    "codigo":201060008,
    "descripcion":"TRASTORNO DE LAS VÍAS RESPIRATORIAS SUPERIORES"
  },
  {
    "codigo":337721000119107,
    "descripcion":"DESPRENDIMIENTO SEROSO DE COROIDES DE OJO IZQUIERDO"
  },
  {
    "codigo":166457004,
    "descripcion":"NIVEL SÉRICO DE TESTOSTERONA DENTRO DE RANGO DE REFERENCIA"
  },
  {
    "codigo":789049006,
    "descripcion":"EPIFISIOPATÍA ESPINAL"
  },
  {
    "codigo":721678000,
    "descripcion":"ÍLEO BILIAR DE INTESTINO GRUESO"
  },
  {
    "codigo":230158001,
    "descripcion":"VENTRICULITIS BACTERIANA"
  },
  {
    "codigo":295694003,
    "descripcion":"SOBREDOSIS INTENCIONAL DE IDARUBICINA"
  },
  {
    "codigo":10878931000119103,
    "descripcion":"HIPEMA TRAUMÁTICO DE OJO IZQUIERDO"
  },
  {
    "codigo":262926008,
    "descripcion":"LACERACIÓN DE OVARIO"
  },
  {
    "codigo":719843001,
    "descripcion":"SÍNDROME DE DEFECTO RADIAL DE CÚBITO Y PERONÉ Y BRAQUIDACTILIA"
  },
  {
    "codigo":31715000,
    "descripcion":"DELIRIO POR INTOXICACIÓN CON FENCICLIDINA"
  },
  {
    "codigo":228323004,
    "descripcion":"BORRACHERA"
  },
  {
    "codigo":392163005,
    "descripcion":"ANILLO NEURORRETINIANO - HALLAZGO"
  },
  {
    "codigo":293859005,
    "descripcion":"ALERGIA A LAMOTRIGINA"
  },
  {
    "codigo":29880001,
    "descripcion":"LESIÓN TRAUMÁTICA DE RECTO CON HERIDA ABIERTA HACIA CAVIDAD ABDOMINAL"
  },
  {
    "codigo":292024002,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR ESTREPTODORNASA"
  },
  {
    "codigo":540961000124102,
    "descripcion":"MASA DE VALÉCULA DE EPIGLOTIS"
  },
  {
    "codigo":95416007,
    "descripcion":"SÍNDROME DE MIALGIA EOSINÓFILA"
  },
  {
    "codigo":880013003,
    "descripcion":"OBSTRUCCIÓN DE TRACTO DE SALIDA DEL VENTRÍCULO IZQUIERDO POSTERIOR A PROCEDIMIENTO"
  },
  {
    "codigo":290189004,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR NALBUFINA"
  },
  {
    "codigo":28045007,
    "descripcion":"HÁLITO DE ALCOHOL"
  },
  {
    "codigo":386658005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CARÚNCULA LAGRIMAL"
  },
  {
    "codigo":288354007,
    "descripcion":"DIFICULTAD PARA CONSTRUIR UNA TORRE"
  },
  {
    "codigo":124514008,
    "descripcion":"DEFICIENCIA DE FORMAMIDASA"
  },
  {
    "codigo":712503001,
    "descripcion":"PREPARACIÓN INTESTINAL EFECTIVA PARA CIRUGÍA"
  },
  {
    "codigo":57143002,
    "descripcion":"QUEMADURA DE HOMBRO"
  },
  {
    "codigo":253751007,
    "descripcion":"PALADAR PLANO"
  },
  {
    "codigo":1234956004,
    "descripcion":"TRASTORNO FETAL DEBIDO A COMPRESIÓN DE CORDÓN UMBILICAL"
  },
  {
    "codigo":15931501000119106,
    "descripcion":"QUISTE FOLICULAR DE OVARIO IZQUIERDO"
  },
  {
    "codigo":55308005,
    "descripcion":"ENVENENAMIENTO POR VENENO DE INSECTO"
  },
  {
    "codigo":22540004,
    "descripcion":"TOXOPLASMOSIS MULTISISTÉMICA DISEMINADA"
  },
  {
    "codigo":776204008,
    "descripcion":"SÍNDROME DE MICROFTALMÍA CON COLOBOMA OCULAR CONGÉNITO, OBESIDAD, HIPOGENITALISMO Y DISCAPACIDAD INTELECTUAL"
  },
  {
    "codigo":1003745003,
    "descripcion":"CONTRACTURA EN FLEXIÓN DE ARTICULACIÓN METACARPOFALÁNGICA DE DEDO MEÑIQUE"
  },
  {
    "codigo":282849004,
    "descripcion":"MANTIENE LA POSICIÓN"
  },
  {
    "codigo":250081005,
    "descripcion":"MIOQUIMIA, HIPERHIDROSIS, SÍNDROME DE RELAJACIÓN MUSCULAR ANORMAL"
  },
  {
    "codigo":340231000119102,
    "descripcion":"COROIDITIS YUXTAPAPILAR FOCAL IZQUIERDA"
  },
  {
    "codigo":413921009,
    "descripcion":"OPACIDAD CORNEAL SUBEPITELIAL"
  },
  {
    "codigo":51638003,
    "descripcion":"ENFERMEDAD POR EL VIRUS THOGOTO"
  },
  {
    "codigo":15986951000119103,
    "descripcion":"ANIRIDIA CONGÉNITA DE OJO DERECHO"
  },
  {
    "codigo":444854006,
    "descripcion":"HALLAZGO RELACIONADO CON EL REFLEJO ACÚSTICO"
  },
  {
    "codigo":281014009,
    "descripcion":"VEGETARIANO, ESTRICTO"
  },
  {
    "codigo":703027009,
    "descripcion":"ENTEROBACTER CLOACAE O ENTEROBACTER ASBURIAE"
  },
  {
    "codigo":1260384002,
    "descripcion":"HEMICOREA DEBIDA A ESCLEROSIS MÚLTIPLE"
  },
  {
    "codigo":1293152007,
    "descripcion":"CUTIS TRICOLOR"
  },
  {
    "codigo":703328007,
    "descripcion":"INSUFICIENCIA DE VÁLVULA MITRAL DEBIDA A INFARTO AGUDO DE MIOCARDIO SIN RUPTURA DE MÚSCULO PAPILAR Y CUERDAS TENDINOSAS"
  },
  {
    "codigo":406581000,
    "descripcion":"INFECCIÓN GONOCÓCICA DEL SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":80736008,
    "descripcion":"FÍSTULA RECTAL"
  },
  {
    "codigo":373813003,
    "descripcion":"SIN TRATAMIENTO ONCOLÓGICO - ESTADO DE CUMPLIMIENTO: MALO"
  },
  {
    "codigo":767029004,
    "descripcion":"DISPLASIA CONGÉNITA DE LÓBULO DE PULMÓN IZQUIERDO CONCOMITANTE CON MALFORMACIÓN VASCULAR CONGÉNITA"
  },
  {
    "codigo":11782561000119101,
    "descripcion":"LUXACIÓN TRAUMÁTICA EXPUESTA DE RÓTULA IZQUIERDA"
  },
  {
    "codigo":308277006,
    "descripcion":"ESTADOS DE ADMISIÓN"
  },
  {
    "codigo":44298000,
    "descripcion":"ABSCESO DE GANGLIO LINFÁTICO"
  },
  {
    "codigo":13365009,
    "descripcion":"DESNUTRICIÓN LUEGO DE CIRUGÍA GASTROINTESTINAL"
  },
  {
    "codigo":765194001,
    "descripcion":"LESIÓN TRAUMÁTICA DEL OÍDO MEDIO"
  },
  {
    "codigo":11530004,
    "descripcion":"DIABETES MELLITUS LÁBIL"
  },
  {
    "codigo":11864481000119103,
    "descripcion":"CONTUSIÓN DE PIE DERECHO"
  },
  {
    "codigo":370143000,
    "descripcion":"TRASTORNO DEPRESIVO MAYOR"
  },
  {
    "codigo":206303001,
    "descripcion":"HEMORRAGIA INTRALVEOLAR PULMONAR PERINATAL"
  },
  {
    "codigo":402911002,
    "descripcion":"CARCINOMA VERRUGOSO DE BUSCHKE-LÖWENSTEIN, DE PENE"
  },
  {
    "codigo":109834009,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE HENDIDURA BRANQUIAL"
  },
  {
    "codigo":371978009,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL ESÓFAGO CERVICAL"
  },
  {
    "codigo":271839005,
    "descripcion":"INCONTINENCIA DEL ESFÍNTER ANAL"
  },
  {
    "codigo":75231006,
    "descripcion":"AUSENCIA CONGÉNITA DE TROMPA DE EUSTAQUIO"
  },
  {
    "codigo":239071005,
    "descripcion":"HIPERQUERATOSIS EPIDERMOLÍTICA DE VORNER"
  },
  {
    "codigo":1254879007,
    "descripcion":"MORFEA PROFUNDA"
  },
  {
    "codigo":827060001,
    "descripcion":"REFLEJOS RADIALES DESIGUALES"
  },
  {
    "codigo":237236005,
    "descripcion":"EMBARAZO MÚLTIPLE NO DIAGNOSTICADO"
  },
  {
    "codigo":302772006,
    "descripcion":"PARECE ENFERMO"
  },
  {
    "codigo":12247611000119100,
    "descripcion":"DOLOR DE CADERA BILATERAL"
  },
  {
    "codigo":40628008,
    "descripcion":"REPETICIÓN DE FRASES"
  },
  {
    "codigo":1187508009,
    "descripcion":"AORTITIS RELACIONADA CON INMUNOGLOBULINA G4"
  },
  {
    "codigo":7860005,
    "descripcion":"MORTINATO DE SEXO MASCULINO (2500 GRAMOS O MÁS)"
  },
  {
    "codigo":300937006,
    "descripcion":"PROBLEMAS PERSONALES"
  },
  {
    "codigo":169865007,
    "descripcion":"PESO AL NACER IGUAL A 75%-89% (3750-4049 G)"
  },
  {
    "codigo":366473008,
    "descripcion":"HALLAZGO RELACIONADO CON LA AMPLITUD DE MOVIMIENTO ACTIVO DE FLEXIÓN DE HOMBRO"
  },
  {
    "codigo":102494001,
    "descripcion":"CRECIMIENTO CORPORAL DISMINUIDO"
  },
  {
    "codigo":461107002,
    "descripcion":"ARTERIA CORONARIA ÚNICA QUE SE DIVIDE EN ARTERIA CORONARIA DERECHA Y ARTERIA CORONARIA IZQUIERDA"
  },
  {
    "codigo":339811000119100,
    "descripcion":"ECTROPIÓN DE PÁRPADO INFERIOR IZQUIERDO"
  },
  {
    "codigo":16091491000119100,
    "descripcion":"PLIEGUE DE EPICANTO DE OJO IZQUIERDO"
  },
  {
    "codigo":15625571000119102,
    "descripcion":"CRISIS PAROXÍSTICA INESPECÍFICA"
  },
  {
    "codigo":1089891000119102,
    "descripcion":"PABELLÓN AURICULAR CON FORMA ANORMAL"
  },
  {
    "codigo":140131000119102,
    "descripcion":"HIPERTENSIÓN EN ENFERMEDAD RENAL CRÓNICA EN ESTADIO 2 DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":337251000119105,
    "descripcion":"ECTROPIÓN DE PÁRPADO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":319331000119106,
    "descripcion":"LUXACIÓN RECURRENTE DE ARTICULACIÓN DE CODO DERECHO"
  },
  {
    "codigo":12266851000119105,
    "descripcion":"LUXACIÓN DE PRÓTESIS DE ARTICULACIÓN GLENOHUMERAL DERECHA"
  },
  {
    "codigo":314211000119108,
    "descripcion":"MIOSITIS OSIFICANTE TRAUMÁTICA DE PIERNA IZQUIERDA"
  },
  {
    "codigo":16662371000119109,
    "descripcion":"ANEURISMA DE ARTERIA VERTEBRAL IZQUIERDA"
  },
  {
    "codigo":306531000119108,
    "descripcion":"GOTA TOFÁCEA CRÓNICA DE HOMBRO CAUSADA POR FÁRMACO"
  },
  {
    "codigo":15630691000119109,
    "descripcion":"TENDINITIS DE MANO IZQUIERDA"
  },
  {
    "codigo":334691000119106,
    "descripcion":"IRIDODIÁLISIS DE OJO DERECHO"
  },
  {
    "codigo":1077091000119106,
    "descripcion":"QUISTE ÓSEO DE FÉMUR IZQUIERDO"
  },
  {
    "codigo":321891000119105,
    "descripcion":"RIGIDEZ DE ARTICULACIÓN DE CODO IZQUIERDO"
  },
  {
    "codigo":520004,
    "descripcion":"NARIZ ENCORVADA CONGÉNITA"
  },
  {
    "codigo":687971000119108,
    "descripcion":"SARCOMA PRIMARIO DE GLÚTEO"
  },
  {
    "codigo":293597001,
    "descripcion":"ALERGIA A CODEÍNA"
  },
  {
    "codigo":262664007,
    "descripcion":"LESIÓN TRAUMÁTICA DE OROFARINGE"
  },
  {
    "codigo":424669003,
    "descripcion":"EDEMA DE PAPILA ÓPTICA ASOCIADO CON TRASTORNO RETINIANO"
  },
  {
    "codigo":1080021000119102,
    "descripcion":"SARCOMA DE EWING PRIMARIO DE HUESO DE EXTREMIDAD INFERIOR IZQUIERDA"
  },
  {
    "codigo":95154001,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA ENCÍA SUPERIOR"
  },
  {
    "codigo":129757003,
    "descripcion":"PIEL MAMARIA CALCIFICADA"
  },
  {
    "codigo":160690003,
    "descripcion":"DEPENDE DE MEDIO DE TRANSPORTE PÚBLICO"
  },
  {
    "codigo":29618004,
    "descripcion":"DEGENERACIÓN ESTRIADO-NIGRAL"
  },
  {
    "codigo":342741000119103,
    "descripcion":"CEGUERA CORTICAL DEL LADO DERECHO DEL CEREBRO"
  },
  {
    "codigo":193458007,
    "descripcion":"CICATRIZ CORIORRETINIANA PERIFÉRICA"
  },
  {
    "codigo":420999000,
    "descripcion":"RESTOS DE VÍTREO"
  },
  {
    "codigo":717746009,
    "descripcion":"QUISTE RENAL HEMORRÁGICO CONGÉNITO"
  },
  {
    "codigo":1141895002,
    "descripcion":"GANADO EN EL AMBIENTE"
  },
  {
    "codigo":781447002,
    "descripcion":"DISTENSIÓN DE TENDÓN FLEXOR DEL PIE"
  },
  {
    "codigo":93319002,
    "descripcion":"POSICIÓN ANÓMALA CONGÉNITA DE EPIDÍDIMO"
  },
  {
    "codigo":60551006,
    "descripcion":"ÚLCERA DUODENAL CRÓNICA CON PERFORACIÓN Y OBSTRUCCIÓN"
  },
  {
    "codigo":191623007,
    "descripcion":"TRASTORNO AFECTIVO BIPOLAR, EPISODIO ACTUAL MANÍACO, GRAVE, CON SÍNTOMAS PSICÓTICOS"
  },
  {
    "codigo":91484005,
    "descripcion":"FRACASO DE LA INDUCCIÓN DEL TRABAJO DE PARTO POR MEDIO DE DROGAS OXITÓCICAS"
  },
  {
    "codigo":124252008,
    "descripcion":"DEFICIENCIA DE TRANSALDOLASA"
  },
  {
    "codigo":25948008,
    "descripcion":"ESTENOSIS ANTRAL PILÓRICA"
  },
  {
    "codigo":253489003,
    "descripcion":"SUPERPOSICIÓN DE VÁLVULA AURICULOVENTRICULAR IZQUIERDA"
  },
  {
    "codigo":24113005,
    "descripcion":"AFINIDAD NORMAL DE OXÍGENO"
  },
  {
    "codigo":286257008,
    "descripcion":"NO PRODUCE SONIDOS DEL HABLA"
  },
  {
    "codigo":87814002,
    "descripcion":"PLACENTA PREVIA MARGINAL CON HEMORRAGIA INTRAPARTO"
  },
  {
    "codigo":251654003,
    "descripcion":"FONDO VAGINAL"
  },
  {
    "codigo":186118006,
    "descripcion":"MELANODERMIA ADDISONIANA"
  },
  {
    "codigo":1300230008,
    "descripcion":"CIERRE DE ÁNGULO SECUNDARIO DE AMBOS OJOS - SINEQUIAL"
  },
  {
    "codigo":708571001,
    "descripcion":"DEMUESTRA CONOCIMIENTO DE A QUIÉN CONTACTAR EN CASO DE EMERGENCIA MÉDICA"
  },
  {
    "codigo":315355003,
    "descripcion":"PAÍS DE NACIMIENTO - EUROPEO"
  },
  {
    "codigo":85979004,
    "descripcion":"INTOXICACIÓN POR ACACIA"
  },
  {
    "codigo":20443005,
    "descripcion":"RINOFICOMICOSIS CAUSADA POR ENTOMOPHTHORA CORONATA"
  },
  {
    "codigo":247984006,
    "descripcion":"GRITO INAPROPIADO"
  },
  {
    "codigo":770437002,
    "descripcion":"FUNDUS PULVERULENTUS"
  },
  {
    "codigo":16773005,
    "descripcion":"TRASTORNO POR INHIBIDOR DE LA COAGULACIÓN INDUCIDO POR DROGAS"
  },
  {
    "codigo":703066001,
    "descripcion":"DEFECTO OSTEOCONDRAL DE MALÉOLO EXTERNO"
  },
  {
    "codigo":80474004,
    "descripcion":"AUSENCIA DE SENSIBILIDAD VIBRATORIA"
  },
  {
    "codigo":15690761000119103,
    "descripcion":"ARTRITIS ENTEROPÁTICA DE AMBAS MANOS"
  },
  {
    "codigo":735834009,
    "descripcion":"LACERACIÓN DE VASO SANGUÍNEO DE DEDO DE LA MANO"
  },
  {
    "codigo":766767001,
    "descripcion":"PARAPLEJÍA ESPÁSTICA AUTOSÓMICA RECESIVA TIPO 67"
  },
  {
    "codigo":209711005,
    "descripcion":"SECCIÓN EXPUESTA DE LIGAMENTO METATARSOFALÁNGICO"
  },
  {
    "codigo":111407006,
    "descripcion":"SÍNDROME URÉMICO HEMOLÍTICO"
  },
  {
    "codigo":13103009,
    "descripcion":"OLOR NORMAL DE LA ORINA"
  },
  {
    "codigo":240644002,
    "descripcion":"LEISHMANIASIS CUTÁNEA ZOONÓTICA SAHELIANA"
  },
  {
    "codigo":109572005,
    "descripcion":"CARIES DENTAL PRIMARIA, ORIGEN CERVICAL"
  },
  {
    "codigo":76804006,
    "descripcion":"RASGO DE PERSONALIDAD QUE CAUSA SUFRIMIENTO SUBJETIVO"
  },
  {
    "codigo":304345001,
    "descripcion":"AUSENCIA DE MOVIMIENTO DE LA COLUMNA CERVICAL"
  },
  {
    "codigo":42201002,
    "descripcion":"MUCOSA NASAL SECA"
  },
  {
    "codigo":74969002,
    "descripcion":"CRISTALINO ECTÓPICO CONGÉNITO"
  },
  {
    "codigo":271577005,
    "descripcion":"FRACTURA DIAFISARIA DE TIBIA Y PERONÉ"
  },
  {
    "codigo":398979000,
    "descripcion":"TEZ PÁLIDA"
  },
  {
    "codigo":366211001,
    "descripcion":"HALLAZGO RELACIONADO CON EL ESTADO DE PARED VENOSA"
  },
  {
    "codigo":202371002,
    "descripcion":"DERRAME DE ARTICULACIÓN ESTERNOCLAVICULAR"
  },
  {
    "codigo":71299003,
    "descripcion":"ARTRITIS POR SALMONELLA"
  },
  {
    "codigo":38531000,
    "descripcion":"SIGNOS ELECTROCARDIOGRÁFICOS DE FUERZAS VENTRICULARES IZQUIERDAS DISMINUIDAS"
  },
  {
    "codigo":345251000119104,
    "descripcion":"CORIORRETINITIS FOCAL MACULAR DE AMBOS OJOS"
  },
  {
    "codigo":235139008,
    "descripcion":"QUEILITIS EXFOLIATIVA"
  },
  {
    "codigo":397144001,
    "descripcion":"EVALUACIÓN MAMOGRÁFICA (CATEGORÍA 4) - ANORMALIDAD SOSPECHOSA, DEBE CONSIDERARSE LA REALIZACIÓN DE UNA BIOPSIA"
  },
  {
    "codigo":3928002,
    "descripcion":"ENFERMEDAD POR VIRUS ZIKA"
  },
  {
    "codigo":724824002,
    "descripcion":"TEMOR A ENFERMEDAD NEUROLÓGICA"
  },
  {
    "codigo":36696005,
    "descripcion":"CAOLINOSIS"
  },
  {
    "codigo":298840006,
    "descripcion":"AMPLITUD DE ROTACIÓN EXTERNA PASIVA DE ARTICULACIÓN DE HOMBRO, DISMINUIDA"
  },
  {
    "codigo":15965501000119100,
    "descripcion":"ABSCESO DE GLÁNDULA DE BARTOLINO DERECHA"
  },
  {
    "codigo":167768009,
    "descripcion":"EXAMEN DE SEMEN: NORMAL"
  },
  {
    "codigo":231469002,
    "descripcion":"DEPENDENCIA DE MESCALINA"
  },
  {
    "codigo":318781000119101,
    "descripcion":"TENDINITIS DE TENDÓN DEL MÚSCULO PSOAS DERECHO"
  },
  {
    "codigo":722989007,
    "descripcion":"APLASIA DE NERVIO ÓPTICO"
  },
  {
    "codigo":1148973008,
    "descripcion":"FUNCIÓN NEUROVASCULAR PERIFÉRICA NORMAL"
  },
  {
    "codigo":297005007,
    "descripcion":"SOBREDOSIS DE ANTIARRÍTMICO DE CLASE IV"
  },
  {
    "codigo":295170002,
    "descripcion":"SOBREDOSIS DE CODEÍNA"
  },
  {
    "codigo":360706005,
    "descripcion":"ONANISMO"
  },
  {
    "codigo":721154006,
    "descripcion":"CALASIA CONGÉNITA DE ESÓFAGO"
  },
  {
    "codigo":195031006,
    "descripcion":"MIOCARDIOPATÍA EN LA DISTROFIA MIOTÓNICA"
  },
  {
    "codigo":293335007,
    "descripcion":"REACCIÓN ADVERSA A LA ENOXAPARINA"
  },
  {
    "codigo":422572002,
    "descripcion":"CARCINOMA ESCAMOCELULAR DEL MENTÓN"
  },
  {
    "codigo":1340076003,
    "descripcion":"DEFECTO DE CALIDAD DE VACUNA"
  },
  {
    "codigo":193196004,
    "descripcion":"POLINEUROPATÍA URÉMICA"
  },
  {
    "codigo":291500004,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR CLARITROMICINA"
  },
  {
    "codigo":29356006,
    "descripcion":"NISTAGMO DE POSICIÓN TERMINAL"
  },
  {
    "codigo":224129000,
    "descripcion":"FAMILIA CON UN HIJO ADOLESCENTE"
  },
  {
    "codigo":292311000119101,
    "descripcion":"NEURALGIA DE NERVIO ILIOHIPOGÁSTRICO IZQUIERDO"
  },
  {
    "codigo":289665004,
    "descripcion":"HALLAZGO RELACIONADO CON LA SENSIBILIDAD UTERINA"
  },
  {
    "codigo":781185006,
    "descripcion":"SECRECIÓN POR LÍNEA DE SUTURA"
  },
  {
    "codigo":93057008,
    "descripcion":"DILATACIÓN CONGÉNITA DE TRONCO BRAQUIOCEFÁLICO"
  },
  {
    "codigo":123990003,
    "descripcion":"XANTINA POR ENCIMA DE RANGO DE REFERENCIA"
  },
  {
    "codigo":255062004,
    "descripcion":"NEOPLASIA DE CONDUCTA INCIERTA DE CAVIDAD BUCAL"
  },
  {
    "codigo":253227001,
    "descripcion":"CATARATA POR RUBÉOLA"
  },
  {
    "codigo":285995002,
    "descripcion":"DIFICULTAD PARA APAGAR EL CONDUCTOR ELÉCTRICO PRINCIPAL"
  },
  {
    "codigo":23851004,
    "descripcion":"ENFISEMA SUBCUTÁNEO DEBIDO A PROCEDIMIENTO"
  },
  {
    "codigo":417067005,
    "descripcion":"ENFERMEDAD NO NEUROINVASORA POR VIRUS DE LA ENCEFALITIS EQUINA VENEZOLANA"
  },
  {
    "codigo":449835009,
    "descripcion":"VÉRTIGO NOCTURNO"
  },
  {
    "codigo":448000003,
    "descripcion":"VENA CAVA SUPERIOR DERECHA CONECTADA A AURÍCULAS IZQUIERDA Y DERECHA"
  },
  {
    "codigo":46551000119106,
    "descripcion":"DEFECTO DE PIEL DE LA MANO"
  },
  {
    "codigo":284160007,
    "descripcion":"DIFICULTAD PARA MOVER UN PIE"
  },
  {
    "codigo":216789006,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR COMPUESTO DE ANTIMONIO"
  },
  {
    "codigo":249557007,
    "descripcion":"SIGNO DEL CHARCO"
  },
  {
    "codigo":313258000,
    "descripcion":"ARTROSIS PRIMARIA DE DEDO DEL PIE, LOCALIZADA"
  },
  {
    "codigo":282325007,
    "descripcion":"SE PARA EN UNA PIERNA"
  },
  {
    "codigo":247722002,
    "descripcion":"PERCEPCIÓN GUSTATIVA AUMENTADA"
  },
  {
    "codigo":82047000,
    "descripcion":"DIARREA CAUSADA POR INGESTA DE ALCOHOL"
  },
  {
    "codigo":870314008,
    "descripcion":"PAQUIMENINGITIS DEBIDA A ENFERMEDAD NEOPLÁSICA MALIGNA SECUNDARIA"
  },
  {
    "codigo":409727001,
    "descripcion":"SISTEMA INTERNACIONAL DE ESTADIFICACIÓN DE NEUROBLASTOMA, ESTADIO 4S"
  },
  {
    "codigo":49279000,
    "descripcion":"PROGRESIÓN LENTA DE LA DILATACIÓN DURANTE EL TRABAJO DE PARTO"
  },
  {
    "codigo":278655007,
    "descripcion":"HALLAZGO RELACIONADO CON LA LÍNEA CENTRAL DENTAL"
  },
  {
    "codigo":473428005,
    "descripcion":"COMPLEJO PRIMARIO TUBERCULOSO CONFIRMADO POR EXAMEN MICROSCÓPICO"
  },
  {
    "codigo":735572005,
    "descripcion":"OCLUSIÓN AGUDA DE ARTERIA DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":15666801000119106,
    "descripcion":"HUESO ACCESORIO DEL CARPO DE MUÑECA DERECHA"
  },
  {
    "codigo":47444008,
    "descripcion":"SÍNDROME DE LUCEY - DRISCOLL"
  },
  {
    "codigo":80212005,
    "descripcion":"HIPERTROFIA DEL CLÍTORIS"
  },
  {
    "codigo":897577004,
    "descripcion":"SIMBRAQUIDACTILIA DE MANOS Y PIES BILATERAL"
  },
  {
    "codigo":1354494000,
    "descripcion":"INTERRUPCIÓN INDUCIDA DEL EMBARAZO COMPLICADA POR DAÑO DE URETRA"
  },
  {
    "codigo":240382000,
    "descripcion":"GOMA TUBERCULOSO CUTÁNEO"
  },
  {
    "codigo":675441000119109,
    "descripcion":"BLEFARITIS DE PÁRPADO DERECHO CAUSADA POR ESTAFILOCOCO"
  },
  {
    "codigo":76542006,
    "descripcion":"FRACTURA DE SENO FRONTAL"
  },
  {
    "codigo":109310009,
    "descripcion":"OSTEOMIELITIS AGUDA DE HUESO FRONTAL"
  },
  {
    "codigo":402387002,
    "descripcion":"ANGIOEDEMA ALÉRGICO"
  },
  {
    "codigo":238547001,
    "descripcion":"DERMATITIS ATÓPICA FOTOSENSIBLE"
  },
  {
    "codigo":369619005,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA DE PELVIS RENAL, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":236712001,
    "descripcion":"CALLE LITIÁSICA"
  },
  {
    "codigo":203944004,
    "descripcion":"ESPINA BÍFIDA SACRA CON HIDROCEFALIA - ABIERTA"
  },
  {
    "codigo":269480005,
    "descripcion":"TUMOR BENIGNO DE LAS CÉLULAS DE LOS ISLOTES PANCREÁTICOS"
  },
  {
    "codigo":171176006,
    "descripcion":"CRIBADO PARA NEOPLASIA DE MAMA ANORMAL"
  },
  {
    "codigo":105640008,
    "descripcion":"ENFERMEDAD CAUSADA POR MONOCERCOMONADIDAE"
  },
  {
    "codigo":300413002,
    "descripcion":"DEFENSA ABDOMINAL EN EL HIPOCONDRIO IZQUIERDO"
  },
  {
    "codigo":365949003,
    "descripcion":"HALLAZGO RELACIONADO CON CONDUCTAS VINCULADAS A LA SALUD"
  },
  {
    "codigo":890237005,
    "descripcion":"SÍNDROME DE ROBINOW AUTOSÓMICO RECESIVO"
  },
  {
    "codigo":202109007,
    "descripcion":"RUPTURA ANTIGUA DE LIGAMENTO LATERAL INTERNO DE RODILLA"
  },
  {
    "codigo":726397007,
    "descripcion":"DELECIÓN DE PARTE DEL BRAZO CORTO DEL CROMOSOMA 20"
  },
  {
    "codigo":396882001,
    "descripcion":"TUMOR QUE INVADE MÁS ALLÁ DE LA CÁPSULA PANCREÁTICA, PERO QUE NO INVADE ESTRUCTURAS Y\/U ÓRGANOS ADYACENTES (PÁNCREAS ENDOCRINO)"
  },
  {
    "codigo":298578004,
    "descripcion":"DOLOR A LA PALPACIÓN EN COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":429650005,
    "descripcion":"MASA DE ARTICULACIÓN DE MANO"
  },
  {
    "codigo":198439001,
    "descripcion":"FALTA DE CONCENTRACIÓN DURANTE LA MENOPAUSIA"
  },
  {
    "codigo":724562009,
    "descripcion":"MIELOPATÍA DEBIDA A DEFICIENCIA NUTRICIONAL"
  },
  {
    "codigo":460583001,
    "descripcion":"ORIGEN ANÓMALO DE ARTERIA CORONARIA DE NÓDULO SINUSAL EN ORIFICIO DE SENO AÓRTICO SEPARADO"
  },
  {
    "codigo":296743005,
    "descripcion":"SOBREDOSIS DE CEFSULODINA"
  },
  {
    "codigo":395047006,
    "descripcion":"CONTROL DE ENFERMEDAD CRÓNICA NO REQUERIDO"
  },
  {
    "codigo":131068001,
    "descripcion":"NIVEL DE ESTRIOL POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":360444002,
    "descripcion":"TORTÍCOLIS TRAUMÁTICO"
  },
  {
    "codigo":293073000,
    "descripcion":"REACCIÓN ADVERSA A LA CAPREOMICINA"
  },
  {
    "codigo":424145001,
    "descripcion":"DIFICULTAD PARA EXPRESAR INTIMIDAD"
  },
  {
    "codigo":291238001,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR SELEGILINA"
  },
  {
    "codigo":94630001,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL TERCER HUESO CUNEIFORME DEL TARSO"
  },
  {
    "codigo":717222003,
    "descripcion":"SÍNDROME DE MICROFTALMIA CON ANQUILOBLÉFARON Y DISCAPACIDAD INTELECTUAL"
  },
  {
    "codigo":29094004,
    "descripcion":"TRASTORNO DEL METABOLISMO DE LAS PORFIRINAS"
  },
  {
    "codigo":1010299000,
    "descripcion":"TRASTORNO NEONATAL DEBIDO A SOBREPESO MATERNO"
  },
  {
    "codigo":782758009,
    "descripcion":"SÍNDROME DE HIPERFALANGIA DE DEDOS DE LA MANO, ANOMALÍAS DE LOS DEDOS DE LOS PIES Y PECTUS EXCAVATUS SEVERO"
  },
  {
    "codigo":92795001,
    "descripcion":"CARCINOMA IN SITU DE BORDE BERMELLÓN DE LABIO"
  },
  {
    "codigo":289403004,
    "descripcion":"PRESENTACIÓN VISIBLE EN EL INTROITO"
  },
  {
    "codigo":254800003,
    "descripcion":"SARCOMA DE CÉLULAS EPITELIOIDES DE LA PIEL"
  },
  {
    "codigo":123728005,
    "descripcion":"HIPERPLASIA RECURRENTE DE LA MÉDULA ÓSEA"
  },
  {
    "codigo":58192006,
    "descripcion":"ENFERMEDAD POR EL VIRUS INKOO"
  },
  {
    "codigo":25424007,
    "descripcion":"FRACTURA DE HUESO FRONTAL"
  },
  {
    "codigo":10672191000119107,
    "descripcion":"ÚLCERA DE GLÚTEO"
  },
  {
    "codigo":23589004,
    "descripcion":"LESIÓN TRAUMÁTICA DEL BAZO"
  },
  {
    "codigo":416805005,
    "descripcion":"CON MAYOR RIESGO DE PADECER VARIANTE DE ENFERMEDAD DE CREUTZFELDT-JAKOB"
  },
  {
    "codigo":87290003,
    "descripcion":"ANOMALÍA CONGÉNITA DE LA CABEZA"
  },
  {
    "codigo":1332474003,
    "descripcion":"MIOSITIS NECROSANTE"
  },
  {
    "codigo":323801000119103,
    "descripcion":"CARPOPTOSIS DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":447738006,
    "descripcion":"ENFERMEDAD DE PAGET DE PIEL DE ESCROTO"
  },
  {
    "codigo":677951000119109,
    "descripcion":"AGUJERO MACULAR DE OJO DERECHO"
  },
  {
    "codigo":118223001,
    "descripcion":"HALLAZGO EN EL ESTADO DEL PACIENTE"
  },
  {
    "codigo":183759002,
    "descripcion":"CONSULTA DOMICILIARIA DE CIRUGÍA PEDIÁTRICA, REALIZADA"
  },
  {
    "codigo":249295003,
    "descripcion":"LA ORINA FLUYE EN CHORROS"
  },
  {
    "codigo":314831005,
    "descripcion":"DISCRIMINACIÓN TÁCTIL DEL PIE IZQUIERDO NORMAL"
  },
  {
    "codigo":282063006,
    "descripcion":"PERFORACIÓN TARDÍA DE YEYUNO"
  },
  {
    "codigo":773583007,
    "descripcion":"SÍNDROME DE AFONÍA, SORDERA, DISTROFIA RETINIANA, HALLUX BÍFIDO Y DISCAPACIDAD INTELECTUAL"
  },
  {
    "codigo":216527008,
    "descripcion":"INTOXICACIÓN ACCIDENTAL CAUSADA POR ESPIPERONA"
  },
  {
    "codigo":18084001,
    "descripcion":"QUEMADURA DE CODO"
  },
  {
    "codigo":1363407009,
    "descripcion":"NEOVASCULARIZACIÓN DE CUADRANTE NASAL DE ÁNGULO IRIDOCORNEAL"
  },
  {
    "codigo":83620003,
    "descripcion":"MASTITIS NO PUERPERAL"
  },
  {
    "codigo":1197732001,
    "descripcion":"ENFERMEDAD DE CROHN COLORRECTAL"
  },
  {
    "codigo":16249003,
    "descripcion":"SINCLITISMO"
  },
  {
    "codigo":868217004,
    "descripcion":"INFARTO AGUDO DE MIOCARDIO CON ELEVACIÓN DEL SEGMENTO ST DEBIDO A OCLUSIÓN DE PORCIÓN DISTAL DE ARTERIA CORONARIA DERECHA"
  },
  {
    "codigo":212857005,
    "descripcion":"EFECTO TÓXICO DE GAS DE FLÚOR Y FLUORURO DE HIDRÓGENO"
  },
  {
    "codigo":704377006,
    "descripcion":"CONOCIMIENTO DEFICIENTE SOBRE DIÁLISIS PERITONEAL"
  },
  {
    "codigo":407630006,
    "descripcion":"ESCALA DE DETERIORO GENERAL NIVEL 2 - DETERIORO COGNITIVO MUY LEVE"
  },
  {
    "codigo":276558007,
    "descripcion":"HIPERGLUCEMIA NEONATAL TRANSITORIA"
  },
  {
    "codigo":766243008,
    "descripcion":"TALIPES VARO"
  },
  {
    "codigo":12579009,
    "descripcion":"FIEBRE MEDITERRÁNEA FAMILIAR"
  },
  {
    "codigo":1290531009,
    "descripcion":"RADIOGRAFÍA DE PIERNA NORMAL"
  },
  {
    "codigo":240120003,
    "descripcion":"POLIMIOSITIS EOSINOFÍLICA"
  },
  {
    "codigo":241955009,
    "descripcion":"DEFICIENCIA ADQUIRIDA DE INHIBIDOR ESTERASA C1"
  },
  {
    "codigo":373027009,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM FARCINOGENES"
  },
  {
    "codigo":76280006,
    "descripcion":"BRONQUIO TRAQUEAL RUDIMENTARIO"
  },
  {
    "codigo":305656001,
    "descripcion":"ATENDIDO POR UN PATÓLOGO GENERAL"
  },
  {
    "codigo":402125000,
    "descripcion":"ABSCESO PIOGÉNICO"
  },
  {
    "codigo":860877004,
    "descripcion":"EXCESO GENERALIZADO Y REDUNDANTE DE PIEL DESPUÉS DE CIRUGÍA BARIÁTRICA"
  },
  {
    "codigo":74445007,
    "descripcion":"TRIGONITIS"
  },
  {
    "codigo":296883007,
    "descripcion":"SOBREDOSIS DE NANDROLONA"
  },
  {
    "codigo":72610007,
    "descripcion":"INTOXICACIÓN CAUSADA POR ANTAGONISTA OPIÁCEO"
  },
  {
    "codigo":201847001,
    "descripcion":"ARTROSIS SECUNDARIA LOCALIZADA"
  },
  {
    "codigo":203682009,
    "descripcion":"ESPONDILOLISTESIS DISPLÁSICA"
  },
  {
    "codigo":431223003,
    "descripcion":"RECHAZO AGUDO DE TRASPLANTE PULMONAR"
  },
  {
    "codigo":1217655004,
    "descripcion":"TRASTORNO DE UNIÓN NEUROMUSCULAR DEBIDO A SÍNDROME DE LAMBERT-EATON"
  },
  {
    "codigo":5239005,
    "descripcion":"DISFUNCIÓN LABERÍNTICA"
  },
  {
    "codigo":234615006,
    "descripcion":"DISFUNCIÓN DE LA CADENA BETA DEL COMPLEMENTO 9"
  },
  {
    "codigo":300151007,
    "descripcion":"MEMBRANA TIMPÁNICA AZULADA"
  },
  {
    "codigo":167244000,
    "descripcion":"DENSIDAD DE ORINA POR ENCIMA DE RANGO DE REFERENCIA"
  },
  {
    "codigo":365687009,
    "descripcion":"HALLAZGO RELACIONADO CON LA PRESENCIA DE CRISTALES"
  },
  {
    "codigo":36172001,
    "descripcion":"SUBLUXACIÓN CONGÉNITA DE LA CADERA"
  },
  {
    "codigo":70775009,
    "descripcion":"INTOXICACIÓN POR IPOMEA MUELLERI"
  },
  {
    "codigo":298316005,
    "descripcion":"SIGNO DE COORDINACIÓN CON NOMBRE PROPIO"
  },
  {
    "codigo":1090061000119106,
    "descripcion":"EDENTULISMO PARCIAL CLASE I DEBIDO A CARIES"
  },
  {
    "codigo":296481001,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE ALOPURINOL"
  },
  {
    "codigo":722465008,
    "descripcion":"RECIBIÓ EDUCACIÓN EN INSTITUTO TERCIARIO DE ORIENTACIÓN TÉCNICA"
  },
  {
    "codigo":294646007,
    "descripcion":"ALERGIA A VACUNA CONTRA HEPATITIS B"
  },
  {
    "codigo":1179382007,
    "descripcion":"HIPOTIROIDISMO CENTRAL ADQUIRIDO DEBIDO A TRASTORNO DE HIPÓFISIS"
  },
  {
    "codigo":292811001,
    "descripcion":"REACCIÓN ADVERSA A LA NISTATINA"
  },
  {
    "codigo":30667004,
    "descripcion":"BLOQUEO DE RAMA DERECHA Y BLOQUEO DE LA RAMA IZQUIERDA ANTERIOR DEL HAZ DE HIS"
  },
  {
    "codigo":1144779008,
    "descripcion":"CON MAYOR RIESGO DE TENER BAJO PESO CORPORAL"
  },
  {
    "codigo":391115009,
    "descripcion":"PRUEBA DE REVERSIBILIDAD A COMBINACIÓN DE SALBUTAMOL Y BROMURO DE IPRATROPIO: NEGATIVA"
  },
  {
    "codigo":1208480004,
    "descripcion":"SÍNDROME DE LIPODERMOIDE EPIBULBAR, APÉNDICE PREAURICULAR Y POLITELIA"
  },
  {
    "codigo":1306784004,
    "descripcion":"MALFORMACIÓN CONGÉNITA DE ÁNGULO DE CÁMARA ANTERIOR DE OJO IZQUIERDO"
  },
  {
    "codigo":16054951000119106,
    "descripcion":"ASTIGMATISMO BILATERAL POSTERIOR A PROCEDIMIENTO QUIRÚRGICO"
  },
  {
    "codigo":225440008,
    "descripcion":"INICIO DE LA CONFUSIÓN"
  },
  {
    "codigo":127136009,
    "descripcion":"LINFADENOPATÍA PANCREATICODUODENAL INFERIOR"
  },
  {
    "codigo":94368009,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA COMISURA DE LA LARINGE"
  },
  {
    "codigo":289141003,
    "descripcion":"COME REGULARMENTE"
  },
  {
    "codigo":715125006,
    "descripcion":"TRANSFERENCIA INDEPENDIENTE DE LA CAMA A LA SILLA"
  },
  {
    "codigo":26997009,
    "descripcion":"EFECTO TÓXICO DE UNA SUSTANCIA AROMÁTICA CORROSIVA"
  },
  {
    "codigo":1335882004,
    "descripcion":"SINOSTOSIS RADIOCUBITAL CONGÉNITA DE ANTEBRAZO IZQUIERDO"
  },
  {
    "codigo":189002004,
    "descripcion":"LIPOMA DE MUSLO"
  },
  {
    "codigo":713290004,
    "descripcion":"AMELOBLASTOMA MALIGNO DE MANDÍBULA"
  },
  {
    "codigo":1237578005,
    "descripcion":"LINFOMA NO HODGKIN OCULOCEREBRAL PRIMARIO"
  },
  {
    "codigo":56095002,
    "descripcion":"NECROSADISMO"
  },
  {
    "codigo":15700801000119104,
    "descripcion":"DISFUNCIÓN DE MÚSCULO OBLICUO SUPERIOR DE OJO DERECHO"
  },
  {
    "codigo":416543004,
    "descripcion":"INFECCIÓN NEUROINVASIVA POR VIRUS DE LA ENCEFALITIS DE POWASSAN"
  },
  {
    "codigo":1137439008,
    "descripcion":"EN ESQUEMA DE MEDICACIÓN COMPLEJO"
  },
  {
    "codigo":11850561000119105,
    "descripcion":"CONTUSIÓN DE PARED TORÁCICA DERECHA"
  },
  {
    "codigo":285471008,
    "descripcion":"NO CIERRA LA BOCA"
  },
  {
    "codigo":283636004,
    "descripcion":"HERIDA POR PINCHAZO DE AGUJA EN LA ESPINILLA"
  },
  {
    "codigo":185332005,
    "descripcion":"CITA CANCELADA POR EL PACIENTE"
  },
  {
    "codigo":235101000,
    "descripcion":"PROCLINACIÓN BIMAXILAR"
  },
  {
    "codigo":1363145000,
    "descripcion":"ASTILLA EN DEDO DE MANO"
  },
  {
    "codigo":52425001,
    "descripcion":"QUEMADURA EPIDÉRMICA DE GENITALES FEMENINOS"
  },
  {
    "codigo":871625003,
    "descripcion":"DEFECTO DE LA PORCIÓN INTERMEDIA DEL TABIQUE AURICULOVENTRICULAR CON COMPONENTES AURICULAR Y VENTRICULAR Y VÁLVULAS AURICULOVENTRICULARES SEPARADAS"
  },
  {
    "codigo":19657006,
    "descripcion":"DESORIENTACIÓN TEMPORAL"
  },
  {
    "codigo":15864641000119109,
    "descripcion":"SUPERPOSICIÓN CONGÉNITA DE DEDOS DEL PIE IZQUIERDO"
  },
  {
    "codigo":247198004,
    "descripcion":"DESPRENDIMIENTO COROIDE ANULAR"
  },
  {
    "codigo":443806007,
    "descripcion":"RIÑÓN DERECHO AUSENTE"
  },
  {
    "codigo":441971007,
    "descripcion":"COLITIS ULCEROSA CRÓNICA DE LADO IZQUIERDO"
  },
  {
    "codigo":210760001,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA A NIVEL DE LA RODILLA"
  },
  {
    "codigo":1259336004,
    "descripcion":"CARCINOMA PRIMARIO DE SURCO BUCAL SUPERIOR"
  },
  {
    "codigo":866120006,
    "descripcion":"INFECCIÓN DE INTESTINO CAUSADA POR LARVA DE ANISAKIS"
  },
  {
    "codigo":276296007,
    "descripcion":"TRANCE DISOCIATIVO"
  },
  {
    "codigo":79688008,
    "descripcion":"OBSTRUCCIÓN DE LA VÍA AÉREA"
  },
  {
    "codigo":1193800007,
    "descripcion":"ENTERITIS POR CRYPTOSPORIDIUM"
  },
  {
    "codigo":77853002,
    "descripcion":"PERISTALTISMO DISMINUIDO"
  },
  {
    "codigo":405533003,
    "descripcion":"RESULTADO DE EPISODIO ADVERSO"
  },
  {
    "codigo":1141000119101,
    "descripcion":"ADHERENCIA LABIAL CONGÉNITA"
  },
  {
    "codigo":733213005,
    "descripcion":"LACERACIÓN DE TÓRAX CON CUERPO EXTRAÑO"
  },
  {
    "codigo":403698000,
    "descripcion":"HIPOPIGMENTACIÓN INDUCIDA POR LÁSER"
  },
  {
    "codigo":307229009,
    "descripcion":"SECRECIÓN NO PURULENTA DE HERIDA"
  },
  {
    "codigo":12207221000119102,
    "descripcion":"POSICIÓN ANÓMALA DE PRÓTESIS DE ARTICULACIÓN DE CADERA DERECHA"
  },
  {
    "codigo":208925009,
    "descripcion":"DESGARRO MENISCAL AGUDO, EXTERNO, RADIAL"
  },
  {
    "codigo":45085008,
    "descripcion":"SÍNDROME DE GOPALAN"
  },
  {
    "codigo":1222898006,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA PATEAR OBJETO"
  },
  {
    "codigo":1255666008,
    "descripcion":"ENFERMEDAD DE HODGKIN CON DEPLECIÓN DE LINFOCITOS DE GANGLIOS LINFÁTICOS DE CUELLO"
  },
  {
    "codigo":74183001,
    "descripcion":"TETRASOMÍA PARCIAL DE CROMOSOMA 9"
  },
  {
    "codigo":328821000119104,
    "descripcion":"FRACTURAS MÚLTIPLES NO EXPUESTAS DE PELVIS SIN ALTERACIÓN DEL CÍRCULO PÉLVICO"
  },
  {
    "codigo":238023004,
    "descripcion":"DEFICIENCIA VARIANTE B DE HEXOSAMINIDASA A - ADULTO"
  },
  {
    "codigo":205255007,
    "descripcion":"SINOSTOSIS RADIOCUBITAL DISTAL"
  },
  {
    "codigo":762311008,
    "descripcion":"TRASTORNO DE LABERINTO IZQUIERDO DEBIDO A SCHWANNOMA"
  },
  {
    "codigo":400028008,
    "descripcion":"DERMATOSIS RELACIONADA CON EL CICLO MENSTRUAL"
  },
  {
    "codigo":430961002,
    "descripcion":"PROLAPSO DE MUÑÓN DE CUELLO UTERINO"
  },
  {
    "codigo":725873003,
    "descripcion":"DERMATITIS IRRITATIVA POR CONTACTO INESPECÍFICA"
  },
  {
    "codigo":103281005,
    "descripcion":"SENSACIÓN DE OÍDO TAPADO"
  },
  {
    "codigo":365425006,
    "descripcion":"HALLAZGO RELACIONADO CON MEDICIÓN DE ESPERMATOZOIDES"
  },
  {
    "codigo":299889007,
    "descripcion":"CLONO ROTULIANO SOSTENIDO"
  },
  {
    "codigo":234353009,
    "descripcion":"DEFICIENCIA CONGÉNITA DE TRANSFERRINA"
  },
  {
    "codigo":789574002,
    "descripcion":"EXACERBACIÓN AGUDA DE FIBROSIS PULMONAR IDIOPÁTICA"
  },
  {
    "codigo":298054002,
    "descripcion":"ATENDIDO AL LLEGAR"
  },
  {
    "codigo":722203001,
    "descripcion":"SÍNDROME DE QUERATODERMIA PALMOPLANTAR CON SORDERA"
  },
  {
    "codigo":230683002,
    "descripcion":"MIASTENIA GRAVIS TRANSITORIA DEL RECIÉN NACIDO"
  },
  {
    "codigo":296219006,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE ENANTATO DE FLUFENAZINA"
  },
  {
    "codigo":65008003,
    "descripcion":"INFECCIÓN CAUSADA POR NEOTESTUDINA ROSATII"
  },
  {
    "codigo":196080007,
    "descripcion":"PLEURESÍA SECA CRÓNICA"
  },
  {
    "codigo":294384008,
    "descripcion":"ALERGIA A ACICLOVIR"
  },
  {
    "codigo":16030991000119107,
    "descripcion":"NECROSIS AVASCULAR DE AMBOS CÚBITOS"
  },
  {
    "codigo":423621008,
    "descripcion":"INJERTO CORNEAL ENDOTELIAL COLOCADO"
  },
  {
    "codigo":292549009,
    "descripcion":"REACCIÓN ADVERSA A ALFADORNASA"
  },
  {
    "codigo":12236201000119103,
    "descripcion":"CONJUNTIVITIS DE OJO DERECHO"
  },
  {
    "codigo":716698007,
    "descripcion":"DEFICIENCIA CONGÉNITA DE ALFA-FETOPROTEÍNA"
  },
  {
    "codigo":126874009,
    "descripcion":"NEOPLASIA DEL TEJIDO PERIRRENAL"
  },
  {
    "codigo":288879002,
    "descripcion":"INCAPAZ DE BEBER A SORBOS"
  },
  {
    "codigo":15676841000119104,
    "descripcion":"MIOSITIS DE TOBILLO DERECHO"
  },
  {
    "codigo":92271002,
    "descripcion":"NEOPLASIA BENIGNA DE LOS GANGLIOS LINFÁTICOS PARARRECTALES"
  },
  {
    "codigo":419951006,
    "descripcion":"VÍCTIMA DE RELACIÓN SEXUAL ABUSIVA CON EL ESPOSO"
  },
  {
    "codigo":254276002,
    "descripcion":"TRANSLOCACIÓN E INSERCIÓN BALANCEADAS EN UN INDIVIDUO NORMAL"
  },
  {
    "codigo":1237316004,
    "descripcion":"TRASTORNO FETAL DEBIDO A RUPTURA DE SENO MARGINAL DE PLACENTA"
  },
  {
    "codigo":90436005,
    "descripcion":"INFESTACIÓN CAUSADA POR HYPODERMA BOVIS"
  },
  {
    "codigo":55833001,
    "descripcion":"TRASTORNO DE BOLSA SEROSA DE REGIÓN DE HOMBRO"
  },
  {
    "codigo":385348009,
    "descripcion":"PROFUNDIDAD DE MELANOMA SEGÚN LA CLASIFICACIÓN DE BRESLOW - HALLAZGO"
  },
  {
    "codigo":23065003,
    "descripcion":"ESTENOSIS DE INTESTINO"
  },
  {
    "codigo":331331000119101,
    "descripcion":"XANTOMA DE PÁRPADO DERECHO"
  },
  {
    "codigo":15650371000119102,
    "descripcion":"CHASQUIDO DE RODILLA DERECHA"
  },
  {
    "codigo":285209008,
    "descripcion":"CAPAZ DE REPRODUCIR FORMAS GEOMÉTRICAS DESPUÉS DE CINCO MINUTOS"
  },
  {
    "codigo":283374002,
    "descripcion":"LACERACIÓN DE PALMA DE LA MANO"
  },
  {
    "codigo":52163004,
    "descripcion":"ESTIMULACIÓN MECÁNICA DE PENE"
  },
  {
    "codigo":281539005,
    "descripcion":"DISTENSIÓN DE TENDÓN DE MIEMBRO SUPERIOR"
  },
  {
    "codigo":1295512000,
    "descripcion":"HIPERTENSIÓN OCULAR BILATERAL DEBIDA A TRASTORNO DE CRISTALINO"
  },
  {
    "codigo":248771009,
    "descripcion":"ERECCIÓN CON VEJIGA URINARIA LLENA"
  },
  {
    "codigo":1297347008,
    "descripcion":"CIERRE DE ÁNGULO AGUDO SECUNDARIO FACOMÓRFICO DE AMBOS OJOS"
  },
  {
    "codigo":83096004,
    "descripcion":"DEPURACIÓN RENAL DISMINUIDA"
  },
  {
    "codigo":246936005,
    "descripcion":"QUERATOPATÍA PUNTEADA"
  },
  {
    "codigo":443544006,
    "descripcion":"CONGELAMIENTO DE LA MARCHA"
  },
  {
    "codigo":212333003,
    "descripcion":"LESIÓN NERVIOSA A NIVEL DE TOBILLO Y PIE"
  },
  {
    "codigo":277869007,
    "descripcion":"NEUMONÍA POR MICOBACTERIAS NO TUBERCULOSAS"
  },
  {
    "codigo":15951581000119102,
    "descripcion":"NEVO EPIDÉRMICO DE PIEL DE AMBAS EXTREMIDADES SUPERIORES"
  },
  {
    "codigo":1259074001,
    "descripcion":"TRASTORNO DE NERVIO AUTÓNOMO DEBIDO A SÍNDROME DE GUILLAIN-BARRÉ"
  },
  {
    "codigo":276034003,
    "descripcion":"TIENE HIJOS ADOPTADOS"
  },
  {
    "codigo":208663003,
    "descripcion":"FRACTURA NO EXPUESTA DE TOBILLO, BIMALEOLAR, FRACTURA PERONEA SUPERIOR"
  },
  {
    "codigo":274199005,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DEL PIE"
  },
  {
    "codigo":44823006,
    "descripcion":"ABSCESO EMBÓLICO INTRACRANEAL"
  },
  {
    "codigo":732951005,
    "descripcion":"SÍNDROME DE MIOPATÍA MITOCONDRIAL, ACIDOSIS LÁCTICA Y SORDERA"
  },
  {
    "codigo":110359009,
    "descripcion":"DISCAPACIDAD INTELECTUAL"
  },
  {
    "codigo":403436006,
    "descripcion":"CONJUNTIVITIS CICATRIZANTE"
  },
  {
    "codigo":763884007,
    "descripcion":"LINFOMA DIFUSO DE LINFOCITOS B PEQUEÑOS DE LA PULPA ROJA ESPLÉNICA"
  },
  {
    "codigo":237761007,
    "descripcion":"INSUFICIENCIA SUPRARRENAL POR METÁSTASIS SUPRARRENAL"
  },
  {
    "codigo":203158003,
    "descripcion":"OSTEOMIELITIS AGUDA DE LA COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":1153430004,
    "descripcion":"DELECIÓN PARCIAL DE BRAZO LARGO DEL CROMOSOMA 14"
  },
  {
    "codigo":301462006,
    "descripcion":"REALIZA ACTIVIDADES EDUCATIVAS"
  },
  {
    "codigo":234091000,
    "descripcion":"LINFADENITIS MICOBACTERIANA ATÍPICA"
  },
  {
    "codigo":235926008,
    "descripcion":"PERFORACIÓN DE LA VÍA BILIAR"
  },
  {
    "codigo":168555002,
    "descripcion":"RADIOGRAFÍA SIMPLE DE CRÁNEO NORMAL"
  },
  {
    "codigo":103019006,
    "descripcion":"FONTANELA ABULTADA"
  },
  {
    "codigo":365163008,
    "descripcion":"HALLAZGO RELACIONADO CON LA COLORACIÓN DE EXTREMIDAD"
  },
  {
    "codigo":428864001,
    "descripcion":"COMPLICACIÓN DE CIRCUNCISIÓN NEONATAL"
  },
  {
    "codigo":232256002,
    "descripcion":"OTITIS MEDIA CON SECRECIÓN SANGUINOLENTA"
  },
  {
    "codigo":299627009,
    "descripcion":"SIN AMPLITUD DE ADUCCIÓN PASIVA DE DEDO DEL PIE"
  },
  {
    "codigo":44808001,
    "descripcion":"TRASTORNO DE CONDUCCIÓN CARDÍACA"
  },
  {
    "codigo":10682231000119106,
    "descripcion":"TUMORACIÓN DE LA PIEL DEL ANTEBRAZO IZQUIERDO"
  },
  {
    "codigo":1045000,
    "descripcion":"COLONOESPASMO"
  },
  {
    "codigo":295957005,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE VILOXAZINA"
  },
  {
    "codigo":230421008,
    "descripcion":"EPILEPSIA ASTÁTICA MIOCLÓNICA"
  },
  {
    "codigo":164885009,
    "descripcion":"LATIDOS AURICULARES ECTÓPICOS EN EL ELECTROCARDIOGRAMA"
  },
  {
    "codigo":294122001,
    "descripcion":"ALERGIA A CICLIZINA"
  },
  {
    "codigo":31978002,
    "descripcion":"FRACTURA DE TIBIA"
  },
  {
    "codigo":687991000119109,
    "descripcion":"SARCOMA PRIMARIO DE CABEZA"
  },
  {
    "codigo":1177023001,
    "descripcion":"COLITIS MICOBACTERIANA NO TUBERCULOSA"
  },
  {
    "codigo":292287002,
    "descripcion":"REACCIÓN ADVERSA A LA AMITRIPTILINA"
  },
  {
    "codigo":333841000119104,
    "descripcion":"ESOTROPÍA MONOCULAR DE OJO DERECHO CON ESTRABISMO CON PATRÓN EN V"
  },
  {
    "codigo":95679004,
    "descripcion":"ABSCESO DE OJO"
  },
  {
    "codigo":716436001,
    "descripcion":"CAPAZ DE RECONOCER LA PROPIA INFLUENCIA SOBRE OTRAS PERSONAS"
  },
  {
    "codigo":93844001,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL ISTMO UTERINO"
  },
  {
    "codigo":126612003,
    "descripcion":"NEOPLASIA DE PARTES BLANDAS DE LA PELVIS"
  },
  {
    "codigo":10737681000119106,
    "descripcion":"TUMOR MALIGNO DE CORDÓN GERMINAL DE OVARIO DERECHO"
  },
  {
    "codigo":11311121000119106,
    "descripcion":"FRACTURA EXPUESTA DE TERCERA VÉRTEBRA DORSAL"
  },
  {
    "codigo":419689003,
    "descripcion":"DISTANCIA PARA PRUEBA DE AGUDEZA VISUAL"
  },
  {
    "codigo":288617007,
    "descripcion":"INCAPAZ DE EMPLEAR CONSTRUCCIONES GRAMATICALES"
  },
  {
    "codigo":92009008,
    "descripcion":"NEOPLASIA BENIGNA DE VASO SANGUÍNEO PERINEAL"
  },
  {
    "codigo":24638001,
    "descripcion":"EMBOLIA DESDE LA AORTA ABDOMINAL"
  },
  {
    "codigo":254014002,
    "descripcion":"FISURA FACIAL SUPRAORBITARIA TESSIER 12"
  },
  {
    "codigo":22803001,
    "descripcion":"FUNCIÓN RESPIRATORIA NORMAL"
  },
  {
    "codigo":57406009,
    "descripcion":"SÍNDROME DEL TÚNEL CARPIANO"
  },
  {
    "codigo":712766009,
    "descripcion":"VIBRIO PARAHAEMOLYTICUS O VIBRIO ALGINOLYTICUS"
  },
  {
    "codigo":219411002,
    "descripcion":"HERIDA DE GUERRA POR EXPLOSIÓN DE AERONAVE"
  },
  {
    "codigo":286782009,
    "descripcion":"MUY SUGESTIONABLE"
  },
  {
    "codigo":35491000087102,
    "descripcion":"ISQUEMIA MIOCÁRDICA LATERAL"
  },
  {
    "codigo":284947002,
    "descripcion":"NO SE PARA EN INODORO"
  },
  {
    "codigo":11776171000119105,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE ANTEBRAZO IZQUIERDO CON INFECCIÓN"
  },
  {
    "codigo":40611000087103,
    "descripcion":"ABRASIÓN DE PIEL DE TERCER DEDO DE PIE IZQUIERDO"
  },
  {
    "codigo":283112002,
    "descripcion":"ARAÑAZO DE GATO - HERIDA"
  },
  {
    "codigo":43171000087106,
    "descripcion":"HERIDA PUNZANTE DE CADERA IZQUIERDA CON CUERPO EXTRAÑO"
  },
  {
    "codigo":38051000087106,
    "descripcion":"ACINESIA DE SEGMENTO INFEROLATERAL BASAL DE VENTRÍCULO CARDÍACO IZQUIERDO"
  },
  {
    "codigo":48291000087108,
    "descripcion":"FRACTURA DE SECCIÓN CERVICAL MEDIA DE CUELLO DE FÉMUR DERECHO"
  },
  {
    "codigo":86504008,
    "descripcion":"PERICARDITIS SUBAGUDA"
  },
  {
    "codigo":281277000,
    "descripcion":"ESPÉCIMEN XANTOCRÓMICO"
  },
  {
    "codigo":707261001,
    "descripcion":"DETERIORO EN LA CAPACIDAD PARA SUBIR ESCALERAS"
  },
  {
    "codigo":19133005,
    "descripcion":"SÍNDROME DE NEUROFIBROMATOSIS"
  },
  {
    "codigo":838333005,
    "descripcion":"ATRESIA DE VÁLVULA MITRAL CON CONEXIÓN AURICULOVENTRICULAR AUSENTE"
  },
  {
    "codigo":445117007,
    "descripcion":"INFLAMACIÓN DE TENDÓN DE MÚSCULO FLEXOR RADIAL DEL CARPO"
  },
  {
    "codigo":246674000,
    "descripcion":"DISCRIMINACIÓN ROJO - VERDE, REDUCIDA"
  },
  {
    "codigo":312210001,
    "descripcion":"STAPHYLOCOCCUS AUREUS METICILINORRESISTENTE DETECTADO"
  },
  {
    "codigo":248509009,
    "descripcion":"MASA EN EL IRIS"
  },
  {
    "codigo":212071001,
    "descripcion":"QUEMADURA QUE COMPROMETE 40-49 PORCIENTO DE LA SUPERFICIE DEL CUERPO, CON QUEMADURA DE ESPESOR COMPLETO QUE AFECTA 10-19 PORCIENTO DE LA SUPERFICIE CORPORAL"
  },
  {
    "codigo":310375005,
    "descripcion":"CONSENTIMIENTO PARA VACUNACIÓN OTORGADO"
  },
  {
    "codigo":13628000,
    "descripcion":"DISFONÍA ATÁXICA"
  },
  {
    "codigo":111932000,
    "descripcion":"INFESTACIÓN CAUSADA POR DERMATOBIA"
  },
  {
    "codigo":308540004,
    "descripcion":"ESTADÍA DE INTERNACIÓN"
  },
  {
    "codigo":79164005,
    "descripcion":"ENVENENAMIENTO DEBIDO A PICADURA DE HORMIGA COSECHADORA"
  },
  {
    "codigo":243004006,
    "descripcion":"LESIÓN POR BALA DE BAJA VELOCIDAD"
  },
  {
    "codigo":822021000000103,
    "descripcion":"ENCEFALITIS AGUDA"
  },
  {
    "codigo":275772007,
    "descripcion":"IMIPRAMINA EN ORINA"
  },
  {
    "codigo":77329001,
    "descripcion":"RESPIRACIÓN BUCAL"
  },
  {
    "codigo":110097002,
    "descripcion":"LACERACIÓN COMPLEJA CONTAMINADA DE LA MUCOSA LABIAL"
  },
  {
    "codigo":15983071000119100,
    "descripcion":"OTITIS EXTERNA CRÓNICA DE AMBOS CONDUCTOS AUDITIVOS EXTERNOS CAUSADA POR VIRUS DEL HERPES SIMPLE HUMANO"
  },
  {
    "codigo":208401007,
    "descripcion":"FRACTURA NO EXPUESTA DE METACARPIANO"
  },
  {
    "codigo":336351000119102,
    "descripcion":"DEPÓSITO DE PLATA EN CÓRNEA DE OJO DERECHO"
  },
  {
    "codigo":403174006,
    "descripcion":"FORMACIÓN DE AMPOLLAS CUTÁNEAS POR PRESIÓN PROLONGADA"
  },
  {
    "codigo":304870007,
    "descripcion":"APEGO EVITATIVO INSEGURO"
  },
  {
    "codigo":206566008,
    "descripcion":"ALIMENTACIÓN INSUFICIENTE DEL RECIÉN NACIDO"
  },
  {
    "codigo":73659001,
    "descripcion":"LEUCOPLASIA DE LA LARINGE"
  },
  {
    "codigo":1156838007,
    "descripcion":"TROMBOCITOPENIA LIGADA AL CROMOSOMA X CON PARÁMETROS PLAQUETARIOS NORMALES"
  },
  {
    "codigo":763622006,
    "descripcion":"EPILEPSIA POR PENSAMIENTO"
  },
  {
    "codigo":237499004,
    "descripcion":"HIPERTIROIDISMO POR ENFERMEDAD DE GRAVES"
  },
  {
    "codigo":6288001,
    "descripcion":"ACRECIÓN SOBRE LOS DIENTES"
  },
  {
    "codigo":170128004,
    "descripcion":"EXAMEN ANORMAL DE NIÑO DE 8-9 MESES DE EDAD - PARA OBSERVACIÓN"
  },
  {
    "codigo":366736006,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA BAJAR ESCALERAS"
  },
  {
    "codigo":235664007,
    "descripcion":"ENFERMEDAD DE CROHN DEL ESTÓMAGO"
  },
  {
    "codigo":1251472008,
    "descripcion":"METÁSTASIS DE OSTEOSARCOMA EN ESTRUCTURA ÓSEA DE CABEZA"
  },
  {
    "codigo":364901002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA LEVANTAR LA CABEZA"
  },
  {
    "codigo":266597003,
    "descripcion":"CICATRIZ ANTIGUA DE LA VULVA"
  },
  {
    "codigo":233829003,
    "descripcion":"INFARTO AGUDO DE ONDA Q - INFERIOR"
  },
  {
    "codigo":168293008,
    "descripcion":"ORGANISMO AISLADO EN CULTIVO DE HISOPADO DE OÍDO"
  },
  {
    "codigo":299365008,
    "descripcion":"AMPLITUD DE ROTACIÓN EXTERNA PASIVA DE LA RODILLA DISMINUIDA"
  },
  {
    "codigo":2618002,
    "descripcion":"TRASTORNO DEPRESIVO MAYOR RECURRENTE CRÓNICO"
  },
  {
    "codigo":37221009,
    "descripcion":"AUSENCIA CONGÉNITA DE TODOS LOS DEDOS DEL PIE"
  },
  {
    "codigo":35386004,
    "descripcion":"SÍNDROME DEL SENO CAVERNOSO"
  },
  {
    "codigo":11778681000119103,
    "descripcion":"DISTENSIÓN DE MÚSCULO Y\/O TENDÓN SUBESCAPULAR DERECHO"
  },
  {
    "codigo":789050006,
    "descripcion":"ASTILLA EN TOBILLO"
  },
  {
    "codigo":12106361000119103,
    "descripcion":"QUEMADURA DE REGIÓN DE CODO IZQUIERDO"
  },
  {
    "codigo":68154008,
    "descripcion":"TOS CRÓNICA"
  },
  {
    "codigo":166458009,
    "descripcion":"NIVEL SÉRICO DE TESTOSTERONA FUERA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":231994007,
    "descripcion":"CORIORRETINITIS POR TOXOCARA CANIS"
  },
  {
    "codigo":197391003,
    "descripcion":"CÁLCULO DE VÍA BILIAR CON COLECISTITIS AGUDA Y OBSTRUCCIÓN"
  },
  {
    "codigo":262927004,
    "descripcion":"QUEMADURA DE OVARIO"
  },
  {
    "codigo":15710841000119104,
    "descripcion":"DISECCIÓN DE AMBAS ARTERIAS ILÍACAS"
  },
  {
    "codigo":721679008,
    "descripcion":"ÍLEO PARALÍTICO DE INTESTINO GRUESO"
  },
  {
    "codigo":293860000,
    "descripcion":"ALERGIA A PIRACETAM"
  },
  {
    "codigo":230159009,
    "descripcion":"VENTRICULITIS POR HONGOS"
  },
  {
    "codigo":392164004,
    "descripcion":"ADELGAZAMIENTO FOCAL DE ANILLO NEURORRETINIANO"
  },
  {
    "codigo":228324005,
    "descripcion":"SESIÓN DE BEBIDA"
  },
  {
    "codigo":719844007,
    "descripcion":"SÍNDROME DE ULCERACIÓN DEL CORDÓN UMBILICAL Y ATRESIA DE INTESTINO"
  },
  {
    "codigo":95417003,
    "descripcion":"SÍNDROME DE FIBROMIALGIA PRIMARIA"
  },
  {
    "codigo":93582001,
    "descripcion":"OSIFICACIÓN INCOMPLETA DE HUESO FRONTAL"
  },
  {
    "codigo":421262002,
    "descripcion":"HINCHAZÓN DE LENGUA"
  },
  {
    "codigo":716174001,
    "descripcion":"SÍNDROME DE HIPOPIGMENTACIÓN OCULOCEREBRAL TIPO PREUS"
  },
  {
    "codigo":1240462005,
    "descripcion":"SÍNDROME DE DESCAMACIÓN CUTÁNEA GENERALIZADA INFLAMATORIA"
  },
  {
    "codigo":60814007,
    "descripcion":"CONDUCTA ANTISOCIAL"
  },
  {
    "codigo":290190008,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR NALBUFINA"
  },
  {
    "codigo":880014009,
    "descripcion":"MIOCARDIOPATÍA DILATADA POR DEFICIENCIA DE CARNITINA"
  },
  {
    "codigo":386659002,
    "descripcion":"CANTO INTERNO - HALLAZGO"
  },
  {
    "codigo":253752000,
    "descripcion":"LENGUA LOBULADA"
  },
  {
    "codigo":286520001,
    "descripcion":"CAPAZ DE LLEVAR ALIMENTOS PREPARADOS"
  },
  {
    "codigo":712504007,
    "descripcion":"ARTROSIS DE CADERA DEBIDA A DISPLASIA"
  },
  {
    "codigo":1076141000119101,
    "descripcion":"DISFUNCIÓN DE TENDÓN TIBIAL POSTERIOR DE PIE IZQUIERDO"
  },
  {
    "codigo":1234957008,
    "descripcion":"TRASTORNO NEONATAL DEBIDO A COMPRESIÓN DE CORDÓN UMBILICAL"
  },
  {
    "codigo":1003746002,
    "descripcion":"CONTRACTURA EN FLEXIÓN DE ARTICULACIÓN INTERFALÁNGICA PROXIMAL DE DEDO ÍNDICE"
  },
  {
    "codigo":250082003,
    "descripcion":"CALAMBRES DE LA MANO"
  },
  {
    "codigo":86242003,
    "descripcion":"DELECIÓN TIPO TALASEMIA ALFA MÁS"
  },
  {
    "codigo":282850004,
    "descripcion":"NO MANTIENE UNA POSICIÓN"
  },
  {
    "codigo":248247003,
    "descripcion":"PIES SUDOROSOS"
  },
  {
    "codigo":444855007,
    "descripcion":"ARTERIOSCLEROSIS DE INJERTO-PUENTE DE ARTERIA CORONARIA DE CORAZÓN TRASPLANTADO"
  },
  {
    "codigo":18871009,
    "descripcion":"VÉRTIGO CEREBELOSO"
  },
  {
    "codigo":1259541008,
    "descripcion":"CARCINOMA PRIMARIO DE ESTÓMAGO"
  },
  {
    "codigo":16041031000119100,
    "descripcion":"ARTRITIS IDIOPÁTICA JUVENIL DE INICIO SISTÉMICO DE PIE DERECHO"
  },
  {
    "codigo":1260385001,
    "descripcion":"HEMICOREA DEBIDA A NEOPLASIA DE CEREBRO"
  },
  {
    "codigo":338861000119107,
    "descripcion":"CICATRIZ CORIORRETINIANA PERIFÉRICA DEL OJO IZQUIERDO"
  },
  {
    "codigo":703329004,
    "descripcion":"MALFORMACIÓN ARTERIOVENOSA DE TRONCO"
  },
  {
    "codigo":47969004,
    "descripcion":"DACTILARIOSIS"
  },
  {
    "codigo":275510005,
    "descripcion":"ANEURISMA ARTERIOVENOSO RENAL ADQUIRIDO"
  },
  {
    "codigo":406582007,
    "descripcion":"INFECCIÓN DEL SISTEMA NERVIOSO CENTRAL POR HAEMOPHILUS"
  },
  {
    "codigo":765195000,
    "descripcion":"LENTIGINOSIS GENERALIZADA FAMILIAR"
  },
  {
    "codigo":373814009,
    "descripcion":"SIN TRATAMIENTO CONTRA EL CÁNCER - ESTADIO AVANZADO"
  },
  {
    "codigo":767030009,
    "descripcion":"DISPLASIA CONGÉNITA DE LÓBULO DE PULMÓN DERECHO CONCOMITANTE CON MALFORMACIÓN VASCULAR CONGÉNITA"
  },
  {
    "codigo":371979001,
    "descripcion":"NEOPLASIA MALIGNA DEL CLÍTORIS"
  },
  {
    "codigo":109835005,
    "descripcion":"NEOPLASIA MALIGNA SUPERPUESTA DEL ESÓFAGO"
  },
  {
    "codigo":699659007,
    "descripcion":"TUMOR MALIGNO GLANDULAR DE VAINA DE NERVIO PERIFÉRICO"
  },
  {
    "codigo":239072003,
    "descripcion":"QUERATODERMIA CONGÉNITA PALMOPLANTAR Y PERIBUCAL DE OLMSTED"
  },
  {
    "codigo":66631000119106,
    "descripcion":"PORTADOR DE TRASTORNO POR HEMOGLOBINOPATÍA E"
  },
  {
    "codigo":1254880005,
    "descripcion":"ERITRONIQUIA LONGITUDINAL"
  },
  {
    "codigo":271840007,
    "descripcion":"HECES ANORMALES"
  },
  {
    "codigo":206304007,
    "descripcion":"HEMOPTISIS PERINATAL DE FETO Y\/O RECIÉN NACIDO"
  },
  {
    "codigo":402912009,
    "descripcion":"CARCINOMA VULVAR VERRUGOSO DE BUSCHKE-LÖWENSTEIN"
  },
  {
    "codigo":106165002,
    "descripcion":"HALLAZGO RELACIONADO CON LA FUNCIÓN CEREBRAL"
  },
  {
    "codigo":237237001,
    "descripcion":"EMBARAZO GEMELAR NO DIAGNOSTICADO"
  },
  {
    "codigo":367841000119100,
    "descripcion":"ESTRECHEZ POSINFECCIOSA DE URETRA BULBAR"
  },
  {
    "codigo":73397007,
    "descripcion":"TROMBOCITOPENIA INDUCIDA POR HEPARINA"
  },
  {
    "codigo":40161000119102,
    "descripcion":"DEBILIDAD DE MÚSCULOS FACIALES COMO SECUELA DE ACCIDENTE CEREBROVASCULAR"
  },
  {
    "codigo":300938001,
    "descripcion":"CRISIS SUDOROSA"
  },
  {
    "codigo":366474002,
    "descripcion":"HALLAZGO RELACIONADO CON LA AMPLITUD DE MOVIMIENTO PASIVO DE FLEXIÓN DE HOMBRO"
  },
  {
    "codigo":169866008,
    "descripcion":"PESO AL NACER IGUAL A 90%-96% (4050-4399 G)"
  },
  {
    "codigo":299103008,
    "descripcion":"AMPLITUD DE ADUCCIÓN PASIVA DE DEDO DE LA MANO NORMAL"
  },
  {
    "codigo":297268004,
    "descripcion":"HALLAZGO RELACIONADO CON LA GARGANTA, LA NARIZ Y EL OÍDO"
  },
  {
    "codigo":461108007,
    "descripcion":"TRASTORNO DE PRÓTESIS DE VÁLVULA AURICULOVENTRICULAR IZQUIERDA (MORFOLÓGICAMENTE NO MITRAL)"
  },
  {
    "codigo":1149236009,
    "descripcion":"INTOXICACIÓN INTENCIONAL CAUSADA POR CORTICOSTEROIDE Y\/O DERIVADO DE CORTICOSTEROIDE"
  },
  {
    "codigo":295433003,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE BISACODILO"
  },
  {
    "codigo":341371000119102,
    "descripcion":"PIGMENTACIÓN CONJUNTIVAL DE OJO IZQUIERDO"
  },
  {
    "codigo":262665008,
    "descripcion":"LACERACIÓN DE OROFARINGE"
  },
  {
    "codigo":424670002,
    "descripcion":"INSATISFACCIÓN CON EL MÉTODO ANTICONCEPTIVO"
  },
  {
    "codigo":721417009,
    "descripcion":"FRACTURA DE TERCERA VÉRTEBRA DORSAL"
  },
  {
    "codigo":13691000119103,
    "descripcion":"EMPIEMA EPIDURAL"
  },
  {
    "codigo":293598006,
    "descripcion":"ALERGIA A DIAMORFINA"
  },
  {
    "codigo":719582007,
    "descripcion":"SÍNDROME DE MICRODUPLICACIÓN 17P13.3"
  },
  {
    "codigo":129758008,
    "descripcion":"MATERIAL DE SUTURA CALCIFICADO"
  },
  {
    "codigo":1077821000119100,
    "descripcion":"OSTEOMIELITIS DE PIE DERECHO"
  },
  {
    "codigo":11809341000119101,
    "descripcion":"HERIDA DE REGIÓN LUMBAR DEBIDA A PICADURA DE INSECTO NO VENENOSO"
  },
  {
    "codigo":314941000119102,
    "descripcion":"ENFERMEDAD DE PAGET DE FÉMUR DERECHO"
  },
  {
    "codigo":312381000119103,
    "descripcion":"ENFERMEDAD DE BAASTRUP DE COLUMNA DORSAL"
  },
  {
    "codigo":10849341000119104,
    "descripcion":"CUERPO EXTRAÑO ASPIRADO EN FARINGE"
  },
  {
    "codigo":345661000119104,
    "descripcion":"QUERATITIS INTERSTICIAL DE AMBOS OJOS"
  },
  {
    "codigo":12403261000119103,
    "descripcion":"INESTABILIDAD DE PRÓTESIS DE ARTICULACIÓN DE RODILLA IZQUIERDA"
  },
  {
    "codigo":15933501000119107,
    "descripcion":"ENDOMETRIOSIS EN TROMPA DE FALOPIO IZQUIERDA"
  },
  {
    "codigo":340541000119108,
    "descripcion":"ATROFIA DE OJO IZQUIERDO"
  },
  {
    "codigo":291901000119109,
    "descripcion":"NEUROMA DE EXTREMIDAD SUPERIOR IZQUIERDA POSTERIOR A CIRUGÍA"
  },
  {
    "codigo":11852861000119106,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE MENTÓN"
  },
  {
    "codigo":302141000119108,
    "descripcion":"HIPERPLASIA DE APÓFISIS ALVEOLAR DE MAXILAR INFERIOR"
  },
  {
    "codigo":16650301000119105,
    "descripcion":"LESIÓN DE RAÍZ DE NERVIO VERTEBRAL CERVICAL IZQUIERDO"
  },
  {
    "codigo":16916541000119107,
    "descripcion":"HIGROMA SUBDURAL AGUDO NO TRAUMÁTICO"
  },
  {
    "codigo":1085501000119109,
    "descripcion":"EDENTULISMO COMPLETO DE CLASE II DEBIDO A CARIES"
  },
  {
    "codigo":5181000119108,
    "descripcion":"PLEXOPATÍA CERVICAL"
  },
  {
    "codigo":66621000119108,
    "descripcion":"PORTADOR DE TALASEMIA ALFA"
  },
  {
    "codigo":15936061000119108,
    "descripcion":"FATIGA OCULAR DE OJO DERECHO"
  },
  {
    "codigo":93320008,
    "descripcion":"POSICIÓN ANÓMALA CONGÉNITA DE OJO"
  },
  {
    "codigo":781448007,
    "descripcion":"DISTENSIÓN DE TENDÓN EXTENSOR DEL PIE"
  },
  {
    "codigo":124253003,
    "descripcion":"DEFICIENCIA DE GLUCOSAMINA ACETILTRANSFERASA"
  },
  {
    "codigo":286258003,
    "descripcion":"DIFICULTAD PARA PRODUCIR SONIDOS DEL HABLA"
  },
  {
    "codigo":253490007,
    "descripcion":"DILATACIÓN DE ANILLO DE VÁLVULA AURICULOVENTRICULAR IZQUIERDA"
  },
  {
    "codigo":56882008,
    "descripcion":"ANOREXIA NERVIOSA"
  },
  {
    "codigo":87815001,
    "descripcion":"LINFANGITIS AGUDA DEL PERINEO"
  },
  {
    "codigo":251655002,
    "descripcion":"MOCO CERVICAL POSCOITAL"
  },
  {
    "codigo":314901000119104,
    "descripcion":"OSTEÍTIS DEFORMANTE DE CÚBITO Y RADIO DERECHOS"
  },
  {
    "codigo":22279009,
    "descripcion":"INTOXICACIÓN POR DIPCADI GLAUCUM"
  },
  {
    "codigo":315356002,
    "descripcion":"PAÍS DE NACIMIENTO - ASIÁTICO"
  },
  {
    "codigo":53212003,
    "descripcion":"ESTENOSIS URETRAL POSOBSTÉTRICA"
  },
  {
    "codigo":20444004,
    "descripcion":"INFESTACIÓN CAUSADA POR PSOROPTES"
  },
  {
    "codigo":249820005,
    "descripcion":"AUSENCIA DE DEDO DEL PIE"
  },
  {
    "codigo":16289301000119106,
    "descripcion":"DISECCIÓN DE ARTERIAS SUBCLAVIAS BILATERALES"
  },
  {
    "codigo":16125461000119106,
    "descripcion":"DERRAME INTERMITENTE BILATERAL DE ARTICULACIONES DE HOMBROS"
  },
  {
    "codigo":282588008,
    "descripcion":"CAPAZ DE BRINCAR EN UN SOLO PIE"
  },
  {
    "codigo":247985007,
    "descripcion":"RISA INAPROPIADA"
  },
  {
    "codigo":870577009,
    "descripcion":"CON MAYOR RIESGO DE EXPOSICIÓN A SARS-COV-2"
  },
  {
    "codigo":770438007,
    "descripcion":"SÍNDROME DE ESPASMO INFANTIL Y PULGAR ANCHO"
  },
  {
    "codigo":211547001,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE PARTE DEL TÓRAX"
  },
  {
    "codigo":80475003,
    "descripcion":"INFARTO MESENTÉRICO TROMBÓTICO"
  },
  {
    "codigo":16017071000119104,
    "descripcion":"ALTERACIÓN DE ASTA POSTERIOR DE MENISCO INTERNO DE RODILLA IZQUIERDA"
  },
  {
    "codigo":735835005,
    "descripcion":"LACERACIÓN DE CADERA SIN CUERPO EXTRAÑO"
  },
  {
    "codigo":78640000,
    "descripcion":"TRASTORNO BIPOLAR I MANÍACO GRAVE CON SÍNTOMAS PSICÓTICOS, CONGRUENTE CON EL ESTADO DE ÁNIMO"
  },
  {
    "codigo":111408001,
    "descripcion":"SEUDOHIPERPARATIROIDISMO"
  },
  {
    "codigo":13104003,
    "descripcion":"ESTADIO CLÍNICO I"
  },
  {
    "codigo":209712003,
    "descripcion":"SECCIÓN EXPUESTA DE LIGAMENTO INTERFALÁNGICO DE DEDO DEL PIE"
  },
  {
    "codigo":11839151000119106,
    "descripcion":"DISTENSIÓN DE MÚSCULO INTRÍNSECO DE DEDO ÍNDICE DE MANO DERECHA"
  },
  {
    "codigo":109573000,
    "descripcion":"CARIES DENTAL PRIMARIA, ORIGEN EN SUPERFICIE LISA PROXIMAL"
  },
  {
    "codigo":240645001,
    "descripcion":"LEISHMANIASIS CUTÁNEA DIFUSA DEL NUEVO MUNDO"
  },
  {
    "codigo":563789641000119101,
    "descripcion":"ACCIDENTE CEREBROVASCULAR DEBIDO A TROMBOSIS DE AMBAS ARTERIAS CARÓTIDAS"
  },
  {
    "codigo":76805007,
    "descripcion":"PERIARTERITIS"
  },
  {
    "codigo":304346000,
    "descripcion":"AMPLITUD DE MOVIMIENTO DE LA COLUMNA VERTEBRAL DORSAL NORMAL"
  },
  {
    "codigo":271578000,
    "descripcion":"FALLA MECÁNICA DE PRÓTESIS ARTICULAR"
  },
  {
    "codigo":15744841000119103,
    "descripcion":"MASA BILATERAL DE RODILLAS"
  },
  {
    "codigo":238810007,
    "descripcion":"RUBOR"
  },
  {
    "codigo":9434008,
    "descripcion":"PIROPOIQUILOCITOSIS HEREDITARIA"
  },
  {
    "codigo":1187247007,
    "descripcion":"SÍNDROME DE DISMORFIA FACIAL, RETRASO DEL DESARROLLO Y ALTERACIONES DE LA CONDUCTA ASOCIADO AL GEN WAC"
  },
  {
    "codigo":7599007,
    "descripcion":"CONDUCTA GENÉTICA"
  },
  {
    "codigo":235140005,
    "descripcion":"QUEILITIS DE CÉLULAS PLASMÁTICAS"
  },
  {
    "codigo":366212008,
    "descripcion":"HALLAZGO RELACIONADO CON CARACTERÍSTICAS DEL PULSO VENOSO YUGULAR"
  },
  {
    "codigo":36697001,
    "descripcion":"FALSO NUDO DEL CORDÓN UMBILICAL"
  },
  {
    "codigo":724825001,
    "descripcion":"DERMATITIS ALÉRGICA POR CONTACTO CAUSADA POR PRODUCTO DE PELUQUERÍA"
  },
  {
    "codigo":202372009,
    "descripcion":"DERRAME DE ARTICULACIÓN ACROMIOCLAVICULAR"
  },
  {
    "codigo":397145000,
    "descripcion":"EVALUACIÓN MAMOGRÁFICA (CATEGORÍA 5) - ALTAMENTE SUGESTIVA DE MALIGNIDAD"
  },
  {
    "codigo":298841005,
    "descripcion":"SIN AMPLITUD DE ROTACIÓN EXTERNA PASIVA DE ARTICULACIÓN DE HOMBRO"
  },
  {
    "codigo":300676009,
    "descripcion":"CAPAZ DE UTILIZAR UN CRUCE PEATONAL"
  },
  {
    "codigo":231470001,
    "descripcion":"DEPENDENCIA DE ANSIOLÍTICOS"
  },
  {
    "codigo":1148974002,
    "descripcion":"BIEN FÍSICAMENTE"
  },
  {
    "codigo":722990003,
    "descripcion":"ATROFIA CONGÉNITA DE NERVIO ÓPTICO"
  },
  {
    "codigo":2094002,
    "descripcion":"EFECTO TÓXICO DEL DISULFURO DE CARBONO"
  },
  {
    "codigo":297006008,
    "descripcion":"SOBREDOSIS DE DIURÉTICO"
  },
  {
    "codigo":229635003,
    "descripcion":"DISFONÍA HIPERCINÉTICA"
  },
  {
    "codigo":295171003,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE CODEÍNA"
  },
  {
    "codigo":721155007,
    "descripcion":"ESÓFAGO CORTO CONGÉNITO"
  },
  {
    "codigo":424408000,
    "descripcion":"QUERATOACANTOMA DE PÁRPADO"
  },
  {
    "codigo":195032004,
    "descripcion":"MIOCARDIOPATÍA DISTRÓFICA"
  },
  {
    "codigo":94893000,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA GLÁNDULA LAGRIMAL"
  },
  {
    "codigo":291501000,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR CLARITROMICINA"
  },
  {
    "codigo":293336008,
    "descripcion":"REACCIÓN ADVERSA A LA DALTEPARINA"
  },
  {
    "codigo":66483005,
    "descripcion":"FRACTURA PERTROCANTÉREA EXPUESTA"
  },
  {
    "codigo":62125005,
    "descripcion":"FRACTURA NO EXPUESTA DE EPÍFISIS DE FÉMUR"
  },
  {
    "codigo":1340077007,
    "descripcion":"VACUNA VENCIDA LUEGO DE LA PUNCIÓN DEL VIAL"
  },
  {
    "codigo":93058003,
    "descripcion":"DILATACIÓN CONGÉNITA DEL TRACTO INTESTINAL"
  },
  {
    "codigo":781186007,
    "descripcion":"GRANULOMA DE HERIDA QUIRÚRGICA"
  },
  {
    "codigo":58455003,
    "descripcion":"INTOXICACIÓN POR CYCAS"
  },
  {
    "codigo":1172567004,
    "descripcion":"QUILOPERICARDIO POSQUIRÚRGICO"
  },
  {
    "codigo":123991004,
    "descripcion":"XANTINA POR DEBAJO DE RANGO DE REFERENCIA"
  },
  {
    "codigo":417068000,
    "descripcion":"CIZALLAMIENTO DEL SACRO"
  },
  {
    "codigo":187692001,
    "descripcion":"NEOPLASIA MALIGNA DE NASOFARINGE"
  },
  {
    "codigo":174131000112101,
    "descripcion":"TRASTORNO DE LIGAMENTO DE ARTICULACIÓN DE MUÑECA"
  },
  {
    "codigo":449836005,
    "descripcion":"MÚLTIPLES QUISTES DE MAMA"
  },
  {
    "codigo":253228006,
    "descripcion":"EMBRIOTOXON"
  },
  {
    "codigo":87553000,
    "descripcion":"FÍSTULA UTEROURETERAL"
  },
  {
    "codigo":112691000112107,
    "descripcion":"NEOPLASIA TERATOIDE RABDOIDE ATÍPICA MALIGNA PRIMARIA DE SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":71731000112108,
    "descripcion":"MASA DE FARINGE"
  },
  {
    "codigo":448001004,
    "descripcion":"OBSTRUCCIÓN AL TRACTO DE SALIDA DE VENTRÍCULO DERECHO DEBIDA A ANEURISMA DE TABIQUE MEMBRANOSO"
  },
  {
    "codigo":773846000,
    "descripcion":"GANGLIÓN DE LA CARA DORSAL DE LA MUÑECA DERECHA"
  },
  {
    "codigo":22017009,
    "descripcion":"CICATRIZ CORIORRETINIANA POSQUIRÚRGICA"
  },
  {
    "codigo":249558002,
    "descripcion":"PALPACIÓN PROFUNDA"
  },
  {
    "codigo":216790002,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR HUMOS DE ANTIMONIO"
  },
  {
    "codigo":282326008,
    "descripcion":"NO SE PARA EN UNA SOLA PIERNA"
  },
  {
    "codigo":1263531001,
    "descripcion":"ENFERMEDAD DE NEURONA MOTORA DEBIDA A RADIOTERAPIA DE MÉDULA ESPINAL Y POSTERIOR A ELLA"
  },
  {
    "codigo":83883001,
    "descripcion":"SÍFILIS CARDIOVASCULAR"
  },
  {
    "codigo":18347007,
    "descripcion":"ESTENOSIS DEGENERATIVA DE CONDUCTO RAQUÍDEO DE REGIÓN LUMBAR"
  },
  {
    "codigo":313259008,
    "descripcion":"ARTROSIS PRIMARIA LOCALIZADA DE CODO"
  },
  {
    "codigo":870315009,
    "descripcion":"TUMEFACCIÓN PÁLIDA DE PAPILA ÓPTICA"
  },
  {
    "codigo":49280002,
    "descripcion":"LESIÓN TRAUMÁTICA DE MÚLTIPLES ÓRGANOS INTRABDOMINALES CON HERIDA ABIERTA HACIA CAVIDAD ABDOMINAL"
  },
  {
    "codigo":1360000000,
    "descripcion":"CON MAYOR RIESGO DE NÁUSEAS Y VÓMITOS POSTOPERATORIOS"
  },
  {
    "codigo":247723007,
    "descripcion":"PERCEPCIÓN CAMBIADA DEL TIEMPO"
  },
  {
    "codigo":346391000119106,
    "descripcion":"DACRIOADENITIS BILATERAL"
  },
  {
    "codigo":16512005,
    "descripcion":"AUSENCIA CONGÉNITA DEL LABERINTO MEMBRANOSO"
  },
  {
    "codigo":16320791000119106,
    "descripcion":"DEGENERACIÓN MACULAR MIÓPICA DE AMBOS OJOS"
  },
  {
    "codigo":735573000,
    "descripcion":"OCLUSIÓN AORTOILÍACA AGUDA"
  },
  {
    "codigo":276821000,
    "descripcion":"MELANOMA MALIGNO DE ANO"
  },
  {
    "codigo":440661002,
    "descripcion":"ANÁLISIS DE INTERFERÓN GAMMA NEGATIVO"
  },
  {
    "codigo":473429002,
    "descripcion":"TUBERCULOMA DE MÉDULA ESPINAL CONFIRMADO"
  },
  {
    "codigo":82048005,
    "descripcion":"SEGUNDO RUIDO CARDÍACO ANORMAL, R>2<"
  },
  {
    "codigo":278656008,
    "descripcion":"HALLAZGO DE OCLUSIÓN DENTAL"
  },
  {
    "codigo":15720881000119100,
    "descripcion":"SUBLUXACIÓN CONGÉNITA BILATERAL DE CABEZAS DE RADIOS"
  },
  {
    "codigo":47445009,
    "descripcion":"HIPERPARATIROIDISMO SECUNDARIO A DEFICIENCIA DE VITAMINA D"
  },
  {
    "codigo":209450005,
    "descripcion":"ESGUINCE DE MENISCO CUBITOCARPIANO"
  },
  {
    "codigo":307754008,
    "descripcion":"LIPOMA EN LA REGIÓN LUMBAR"
  },
  {
    "codigo":78378009,
    "descripcion":"NEUTROPENIA ISOINMUNITARIA"
  },
  {
    "codigo":16294321000119104,
    "descripcion":"PROLIFERACIÓN ATÍPICA DE PEQUEÑOS ACINOS DE PRÓSTATA"
  },
  {
    "codigo":1354495004,
    "descripcion":"LESIÓN TRAUMÁTICA DE URETRA DURANTE PARTO VAGINAL"
  },
  {
    "codigo":240383005,
    "descripcion":"MICOBACTERIOSIS DISEMINADA"
  },
  {
    "codigo":207615004,
    "descripcion":"INFECCIÓN CAUSADA POR BORRELIA MICROTI"
  },
  {
    "codigo":404223003,
    "descripcion":"TROMBOSIS VENOSA PROFUNDA DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":109311008,
    "descripcion":"OSTEOMIELITIS AGUDA DE HUESO CIGOMÁTICO"
  },
  {
    "codigo":369620004,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA HILIAR RADIAL PROFUNDA DE PELVIS RENAL, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":238548006,
    "descripcion":"DERMATITIS ATÓPICA FOTOAGRAVADA"
  },
  {
    "codigo":402388007,
    "descripcion":"ANGIOEDEMA ALÉRGICO POR ALIMENTO INGERIDO"
  },
  {
    "codigo":236713006,
    "descripcion":"NEFROLITIASIS RECESIVA LIGADA AL CROMOSOMA X CON INSUFICIENCIA RENAL"
  },
  {
    "codigo":105641007,
    "descripcion":"ENFERMEDAD CAUSADA POR EIMERIIDAE"
  },
  {
    "codigo":293451000119102,
    "descripcion":"TROMBOSIS CRÓNICA DE VENA ILÍACA DERECHA"
  },
  {
    "codigo":269481009,
    "descripcion":"NEOPLASIA BENIGNA DE ÓRGANO DEL SISTEMA RESPIRATORIO E INTRATORÁCICO"
  },
  {
    "codigo":202110002,
    "descripcion":"RUPTURA DEL LIGAMENTO CRUZADO ANTERIOR, ANTIGUA"
  },
  {
    "codigo":71038003,
    "descripcion":"FRENESÍ"
  },
  {
    "codigo":16376241000119109,
    "descripcion":"NEUROPATÍA ÓPTICA ISQUÉMICA ANTERIOR ARTERÍTICA DE OJO IZQUIERDO"
  },
  {
    "codigo":267646005,
    "descripcion":"ADHERENCIAS CONJUNTIVALES LOCALES"
  },
  {
    "codigo":726398002,
    "descripcion":"DELECIÓN DE PARTE DEL CROMOSOMA 21"
  },
  {
    "codigo":365950003,
    "descripcion":"HALLAZGO RELACIONADO CON LA CANTIDAD DE PAREJAS SEXUALES"
  },
  {
    "codigo":300414008,
    "descripcion":"DEFENSA ABDOMINAL EN LA REGIÓN LUMBAR DERECHA"
  },
  {
    "codigo":724563004,
    "descripcion":"NEUROPATÍA DEBIDA A DEFICIENCIA NUTRICIONAL"
  },
  {
    "codigo":396883006,
    "descripcion":"TUMOR QUE INVADE MÁS ALLÁ DE LA CÁPSULA PANCREÁTICA HACIA LAS ESTRUCTURAS Y\/U ÓRGANOS ADYACENTES (PÁNCREAS ENDOCRINO)"
  },
  {
    "codigo":298579007,
    "descripcion":"DOLOR AL MOVIMIENTO DE COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":1052243006,
    "descripcion":"HEMIPARESIA DEL LADO IZQUIERDO DE LA CARA"
  },
  {
    "codigo":395048001,
    "descripcion":"CONTROL DE ENFERMEDAD CARDIOVASCULAR NO REQUERIDO"
  },
  {
    "codigo":296744004,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE CEFSULODINA"
  },
  {
    "codigo":34600007,
    "descripcion":"INTOXICACIÓN POR SULFATO DE TALIO"
  },
  {
    "codigo":460584007,
    "descripcion":"TRAYECTO ANÓMALO DE ARTERIA CORONARIA POR DETRÁS DEL TRONCO PULMONAR"
  },
  {
    "codigo":65533007,
    "descripcion":"PLAQUETA SENSIBILIZADA"
  },
  {
    "codigo":424146000,
    "descripcion":"MYCOBACTERIUM AVIUM INTRACELLULARE, LOCALIZADO"
  },
  {
    "codigo":131069009,
    "descripcion":"NIVEL DE ESTRIOL POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":293074006,
    "descripcion":"REACCIÓN ADVERSA A LA CICLOSERINA"
  },
  {
    "codigo":782759001,
    "descripcion":"ANEMIA DISERITROPOYÉTICA LIGADA AL CROMOSOMA X CON PLAQUETAS ANORMALES Y NEUTROPENIA"
  },
  {
    "codigo":94631002,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DEL ESÓFAGO TORÁCICO"
  },
  {
    "codigo":422311004,
    "descripcion":"ECTOPIA SIMPLE DE CRISTALINO"
  },
  {
    "codigo":717223008,
    "descripcion":"SÍNDROME DE EPILEPSIA CON DISCAPACIDAD PARA EL APRENDIZAJE Y TRASTORNO DE CONDUCTA LIGADO AL CROMOSOMA X"
  },
  {
    "codigo":92796000,
    "descripcion":"CARCINOMA IN SITU DE BORDE BERMELLÓN DE LABIO INFERIOR"
  },
  {
    "codigo":289404005,
    "descripcion":"SUTURA SAGITAL PALPABLE POR VÍA VAGINAL - HALLAZGO"
  },
  {
    "codigo":322431000119100,
    "descripcion":"HIPERTROFIA DE MEMBRANA SINOVIAL DE ARTICULACIÓN GLENOHUMERAL"
  },
  {
    "codigo":1303377000,
    "descripcion":"FRACTURA ÓSEA DE FÉMUR IZQUIERDO"
  },
  {
    "codigo":58193001,
    "descripcion":"PARÁLISIS CEREBRAL DIPLÉJICA"
  },
  {
    "codigo":123729002,
    "descripcion":"VIRURIA"
  },
  {
    "codigo":754012901000119107,
    "descripcion":"HIPOMELANOSIS MACULAR PROGRESIVA"
  },
  {
    "codigo":189265008,
    "descripcion":"CARCINOMA IN SITU DE PARÉNQUIMA PULMONAR Y BRONQUIO DEL LÓBULO SUPERIOR"
  },
  {
    "codigo":447739003,
    "descripcion":"MEGACISTERNA MAGNA"
  },
  {
    "codigo":282064000,
    "descripcion":"CONTUSIÓN DE ÍLEON"
  },
  {
    "codigo":773584001,
    "descripcion":"SÍNDROME DE HIPERTROFIA MUSCULAR, HEPATOMEGALIA Y POLIHIDRAMNIOS"
  },
  {
    "codigo":249296002,
    "descripcion":"DETENCIÓN SÚBITA DEL FLUJO URINARIO"
  },
  {
    "codigo":19920003,
    "descripcion":"INTOXICACIÓN CAUSADA POR BUSULFANO"
  },
  {
    "codigo":1363408004,
    "descripcion":"NEOVASCULARIZACIÓN DE CUADRANTE TEMPORAL DE ÁNGULO IRIDOCORNEAL"
  },
  {
    "codigo":216528003,
    "descripcion":"INTOXICACIÓN ACCIDENTAL CAUSADA POR TRIFLUPERIDOL"
  },
  {
    "codigo":85456006,
    "descripcion":"PROBLEMA DEL CRECIMIENTO Y DESARROLLO"
  },
  {
    "codigo":183760007,
    "descripcion":"CONSULTA DOMICILIARIA OBSTÉTRICA, REALIZADA"
  },
  {
    "codigo":18085000,
    "descripcion":"JUEGO COMPULSIVO"
  },
  {
    "codigo":1197733006,
    "descripcion":"ENFERMEDAD DE CROHN YEYUNOILEAL"
  },
  {
    "codigo":312997008,
    "descripcion":"OCLUSIÓN DE VENA RETINIANA CENTRAL - ISQUÉMICA"
  },
  {
    "codigo":1163130005,
    "descripcion":"MENINGITIS POR ASPERGILLUS"
  },
  {
    "codigo":47183003,
    "descripcion":"PASAJERO EN ACCIDENTE AÉREO"
  },
  {
    "codigo":276559004,
    "descripcion":"HIPERGLUCEMIA NEONATAL IATROGÉNICA"
  },
  {
    "codigo":407631005,
    "descripcion":"ESCALA DE DETERIORO GENERAL NIVEL 3 - DETERIORO COGNITIVO LEVE"
  },
  {
    "codigo":473167006,
    "descripcion":"HEMORRAGIA ASOCIADA CON IMPLANTE"
  },
  {
    "codigo":14415006,
    "descripcion":"NEUMOCÉFALO"
  },
  {
    "codigo":1259599009,
    "descripcion":"CARCINOMA PRIMARIO ECRINO DE PIEL"
  },
  {
    "codigo":1290532002,
    "descripcion":"RADIOGRAFÍA DE HUESO DE PIERNA ANORMAL"
  },
  {
    "codigo":274724004,
    "descripcion":"EDEMA LOCALIZADO"
  },
  {
    "codigo":241956005,
    "descripcion":"ANGIOEDEMA-URTICARIA PRODUCIDO POR VENENO"
  },
  {
    "codigo":45348006,
    "descripcion":"FORÚNCULO DE REGIÓN PECTORAL"
  },
  {
    "codigo":373028004,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM FLAVESCENS"
  },
  {
    "codigo":403961004,
    "descripcion":"GRANULOMA PIÓGENO DE LABIO"
  },
  {
    "codigo":76281005,
    "descripcion":"CONGESTIÓN HEPÁTICA"
  },
  {
    "codigo":305657005,
    "descripcion":"ATENDIDO POR UN HEMATÓLOGO"
  },
  {
    "codigo":402126004,
    "descripcion":"ENFERMEDAD BACTERIANA DE ENFERMEDAD DE TRANSMISIÓN SEXUAL"
  },
  {
    "codigo":351411000119103,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE MAMA IZQUIERDA"
  },
  {
    "codigo":762574006,
    "descripcion":"DERMATITIS ALÉRGICA POR CONTACTO OCUPACIONAL CAUSADA POR COMPUESTO DE CAUCHO"
  },
  {
    "codigo":39843000,
    "descripcion":"PAPILOMATOSIS CUTÁNEA"
  },
  {
    "codigo":860878009,
    "descripcion":"HEMIATROFIA DE LENGUA"
  },
  {
    "codigo":269219004,
    "descripcion":"HEMATOMA SUBUNGUEAL"
  },
  {
    "codigo":203683004,
    "descripcion":"ESPONDILOLISTESIS ÍSTMICA"
  },
  {
    "codigo":236451007,
    "descripcion":"SÍNDROME OCULAR RENAL"
  },
  {
    "codigo":1186723008,
    "descripcion":"ANOREXIA NERVIOSA PREPUBERAL"
  },
  {
    "codigo":300152000,
    "descripcion":"MEMBRANA TIMPÁNICA ÁMBAR"
  },
  {
    "codigo":1217656003,
    "descripcion":"DESPLAZAMIENTO DE PLACA DEBIDO A CIRUGÍA DE DRENAJE DE GLAUCOMA Y POSTERIOR A ELLA"
  },
  {
    "codigo":365688004,
    "descripcion":"EXAMEN MICROSCÓPICO DE ORINA: CRISTALES - HALLAZGO"
  },
  {
    "codigo":11820211000119106,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN MEDIOCARPIANA DERECHA"
  },
  {
    "codigo":267384006,
    "descripcion":"COMA HIPOGLUCÉMICO"
  },
  {
    "codigo":5240007,
    "descripcion":"JOCOSIDAD INAPROPIADA"
  },
  {
    "codigo":234616007,
    "descripcion":"DEFICIENCIA DEL COMPLEMENTO 8 ALFA-GAMMA"
  },
  {
    "codigo":11793741000119102,
    "descripcion":"HERIDA DE PIE IZQUIERDO DEBIDA A PICADURA DE INSECTO NO VENENOSO"
  },
  {
    "codigo":67106002,
    "descripcion":"DETERMINACIÓN DEL ESTADO DE LA ENFERMEDAD: MODERADAMENTE CONTROLADA"
  },
  {
    "codigo":679091000119109,
    "descripcion":"XEROSIS DE CÓRNEA DE OJO IZQUIERDO"
  },
  {
    "codigo":296482008,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE ALOPURINOL"
  },
  {
    "codigo":722466009,
    "descripcion":"PÉRDIDA TRAUMÁTICA DE RIÑÓN"
  },
  {
    "codigo":294647003,
    "descripcion":"ALERGIA A COMPONENTE DE VACUNA QUE CONTIENE ANTÍGENO DE VIRUS INFLUENZA"
  },
  {
    "codigo":720631006,
    "descripcion":"QUISTE Y TROFOZOÍTO DE CHILOMASTIX MESNILI"
  },
  {
    "codigo":423884000,
    "descripcion":"CONDUCTA REPETITIVA"
  },
  {
    "codigo":425719009,
    "descripcion":"LIPOMA DE LABIO GENITAL"
  },
  {
    "codigo":15971661000119105,
    "descripcion":"HERNIAS INGUINALES DIRECTAS BILATERALES"
  },
  {
    "codigo":784332006,
    "descripcion":"ESPONDILOARTRITIS"
  },
  {
    "codigo":1144780006,
    "descripcion":"CON MAYOR RIESGO DE EMBOLIA"
  },
  {
    "codigo":1208481000,
    "descripcion":"ATROFIA CEREBRAL Y CEREBELOSA PROGRESIVA"
  },
  {
    "codigo":30668009,
    "descripcion":"SENSIBILIDAD ALÉRGICA A SÍNDROME MICÓTICO"
  },
  {
    "codigo":290977000,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR FENSUXIMIDA"
  },
  {
    "codigo":1306785003,
    "descripcion":"MALFORMACIÓN CONGÉNITA BILATERAL DE ÁNGULO DE CÁMARA ANTERIOR"
  },
  {
    "codigo":292812008,
    "descripcion":"REACCIÓN ADVERSA A ANTIFÚNGICO A BASE DE AZOL"
  },
  {
    "codigo":94369001,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA CARA LARÍNGEA DE LA EPIGLOTIS"
  },
  {
    "codigo":127137000,
    "descripcion":"LINFADENOPATÍA PANCREATICODUODENAL SUPERIOR"
  },
  {
    "codigo":225441007,
    "descripcion":"NO QUIERE PENSAR EN ALGO EN PARTICULAR"
  },
  {
    "codigo":192673008,
    "descripcion":"MENINGITIS POR SARCOIDOSIS"
  },
  {
    "codigo":1290803006,
    "descripcion":"SARCOMA DE CÉLULAS REDONDAS INDIFERENCIADO"
  },
  {
    "codigo":92534003,
    "descripcion":"CARCINOMA IN SITU DE LOS DOS TERCIOS ANTERIORES DE LA LENGUA"
  },
  {
    "codigo":289142005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CANTIDAD DE ALIMENTOS INGERIDOS"
  },
  {
    "codigo":715126007,
    "descripcion":"TRANSFERENCIA INDEPENDIENTE DE LA SILLA A LA CAMA"
  },
  {
    "codigo":254539001,
    "descripcion":"CARCINOMA DE LA PORCIÓN TORÁCICA DEL ESÓFAGO"
  },
  {
    "codigo":418379004,
    "descripcion":"SIGNO DE RIZZUTTI"
  },
  {
    "codigo":189003009,
    "descripcion":"LIPOMA DE RODILLA Y REGIÓN POPLÍTEA"
  },
  {
    "codigo":1335883009,
    "descripcion":"SINOSTOSIS RADIOCUBITAL CONGÉNITA DE ANTEBRAZO DERECHO"
  },
  {
    "codigo":285472001,
    "descripcion":"DIFICULTAD PARA CERRAR LA BOCA"
  },
  {
    "codigo":185333000,
    "descripcion":"CITA CANCELADA POR EL MÉDICO"
  },
  {
    "codigo":681601000119101,
    "descripcion":"ADENOCARCINOMA PRIMARIO DE COLON ASCENDENTE"
  },
  {
    "codigo":250869005,
    "descripcion":"EQUIPAMIENTO-HALLAZGO"
  },
  {
    "codigo":283637008,
    "descripcion":"HERIDA POR PINCHAZO DE AGUJA EN LA PANTORRILLA"
  },
  {
    "codigo":609482001,
    "descripcion":"INTERRUPCIÓN INDUCIDA DEL EMBARAZO COMPLICADA POR NECROSIS TUBULAR RENAL"
  },
  {
    "codigo":871626002,
    "descripcion":"SINDACTILIA DE DEDOS CON FUSIÓN ÓSEA EN AMBOS PIES"
  },
  {
    "codigo":1363146004,
    "descripcion":"ASTILLA EN DEDO DE MANO CON INFECCIÓN"
  },
  {
    "codigo":353921000119103,
    "descripcion":"NEOPLASIA BENIGNA DE OVARIO DERECHO"
  },
  {
    "codigo":247199007,
    "descripcion":"ESCLEROSIS DE LA COROIDES"
  },
  {
    "codigo":66952001,
    "descripcion":"MIOPATÍA TÓXICA"
  },
  {
    "codigo":441972000,
    "descripcion":"TRASTORNO PSICÓGENO DEL APARATO GENITOURINARIO"
  },
  {
    "codigo":1230239009,
    "descripcion":"HENDIDURA LARINGOTRAQUEOESOFÁGICA CONGÉNITA"
  },
  {
    "codigo":81524006,
    "descripcion":"GRIPE CAUSADA POR VIRUS INFLUENZA C"
  },
  {
    "codigo":212596008,
    "descripcion":"INTOXICACIÓN CON ACETANILIDA"
  },
  {
    "codigo":210761002,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA A NIVEL DE MUSLO"
  },
  {
    "codigo":276297003,
    "descripcion":"TRASTORNO DE POSESIÓN DISOCIATIVO"
  },
  {
    "codigo":866121005,
    "descripcion":"MIELITIS CAUSADA POR SCHISTOSOMA"
  },
  {
    "codigo":1193801006,
    "descripcion":"INFLAMACIÓN INTESTINAL POR CRYPTOSPORIDIUM"
  },
  {
    "codigo":472905007,
    "descripcion":"HIPERPLASIA HABITUAL DE CONDUCTO GALACTÓFORO"
  },
  {
    "codigo":11822721000119108,
    "descripcion":"HERIDA DE AXILA IZQUIERDA DEBIDA A PICADURA DE INSECTO NO VENENOSO"
  },
  {
    "codigo":767817009,
    "descripcion":"NEOPLASIA DE VÉRTEBRA CERVICAL"
  },
  {
    "codigo":1259337008,
    "descripcion":"CARCINOMA PRIMARIO DE SURCO BUCAL INFERIOR"
  },
  {
    "codigo":733214004,
    "descripcion":"HERIDA PUNZANTE DE TÓRAX CON CUERPO EXTRAÑO"
  },
  {
    "codigo":1091201000119109,
    "descripcion":"HIDROPESÍA COCLEAR DE OÍDO INTERNO DERECHO"
  },
  {
    "codigo":208926005,
    "descripcion":"DESGARRO MENISCAL AGUDO, EXTERNO, DESPRENDIMIENTO PERIFÉRICO"
  },
  {
    "codigo":43251000,
    "descripcion":"TRAUMATISMO ACÚSTICO EXPLOSIVO QUE AFECTA AL OÍDO"
  },
  {
    "codigo":45086009,
    "descripcion":"SIGNO DE ROVSING"
  },
  {
    "codigo":77854008,
    "descripcion":"INDUCCIÓN MÉDICA FALLIDA DEL TRABAJO DE PARTO"
  },
  {
    "codigo":1222899003,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA PATEAR CON PIERNA"
  },
  {
    "codigo":76019006,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA VENA YUGULAR INTERNA"
  },
  {
    "codigo":403699008,
    "descripcion":"HIPERPIGMENTACIÓN INDUCIDA POR LÁSER"
  },
  {
    "codigo":762312001,
    "descripcion":"TRASTORNO DE LABERINTO DERECHO DEBIDO A SCHWANNOMA"
  },
  {
    "codigo":238024005,
    "descripcion":"DEFICIENCIA VARIANTE B1 DE HEXOSAMINIDASA A"
  },
  {
    "codigo":268957000,
    "descripcion":"CUADRO NEURÓTICO, INTROSPECCIÓN PRESENTE"
  },
  {
    "codigo":301725008,
    "descripcion":"CAPAZ DE REALIZAR ACTIVIDADES LABORALES"
  },
  {
    "codigo":299890003,
    "descripcion":"CLONO ROTULIANO NO SOSTENIDO"
  },
  {
    "codigo":103282003,
    "descripcion":"VÉRTIGO ESENCIAL"
  },
  {
    "codigo":365426007,
    "descripcion":"HALLAZGO RELACIONADO CON CANTIDAD DE ESPERMATOZOIDES"
  },
  {
    "codigo":37746008,
    "descripcion":"TRASTORNO DE LA PERSONALIDAD POR EVITACIÓN"
  },
  {
    "codigo":430962009,
    "descripcion":"SEUDOARTROSIS DE COLUMNA VERTEBRAL"
  },
  {
    "codigo":724039002,
    "descripcion":"RETRASO PSICOMOTOR DEBIDO A DEFICIENCIA DE S-ADENOSILHOMOCISTEÍNA HIDROLASA"
  },
  {
    "codigo":199751005,
    "descripcion":"TRABAJO DE PARTO OBSTRUIDO POR PRESENTACIÓN DE NALGAS"
  },
  {
    "codigo":1308001,
    "descripcion":"COMPLICACIÓN DE UN REIMPLANTE"
  },
  {
    "codigo":66844003,
    "descripcion":"INFECCIÓN GENERALIZADA DURANTE EL TRABAJO DE PARTO"
  },
  {
    "codigo":16003151000119100,
    "descripcion":"TRASTORNO UNGUEAL DEBIDO A OTRO TRASTORNO"
  },
  {
    "codigo":230684008,
    "descripcion":"MIASTENIA OCULAR"
  },
  {
    "codigo":196081006,
    "descripcion":"PLEURESÍA ESTÉRIL"
  },
  {
    "codigo":15947701000119108,
    "descripcion":"ÚLCERA DE PIE DERECHO DEBIDA A SÍNDROME POSTROMBÓTICO"
  },
  {
    "codigo":10678351000119102,
    "descripcion":"TUMEFACCIÓN LOCALIZADA DE DEDO DE PIE DERECHO"
  },
  {
    "codigo":294385009,
    "descripcion":"ALERGIA A IDOXURIDINA"
  },
  {
    "codigo":30406004,
    "descripcion":"ADHERENCIAS TUBO - OVÁRICAS"
  },
  {
    "codigo":718534009,
    "descripcion":"ALERGIA A CERIVASTATINA"
  },
  {
    "codigo":28571002,
    "descripcion":"QUEMADURA DE ESPESOR PARCIAL DE DEDO DEL PIE"
  },
  {
    "codigo":716699004,
    "descripcion":"EPIDERMÓLISIS BULLOSA SIMPLE DEBIDA A DEFICIENCIA DE PLACOFILINA"
  },
  {
    "codigo":126875005,
    "descripcion":"NEOPLASIA DEL TEJIDO RETROCECAL"
  },
  {
    "codigo":1306523005,
    "descripcion":"CARCINOMA IN SITU DE CUADRANTE SUPERIOR EXTERNO DE MAMA"
  },
  {
    "codigo":290715007,
    "descripcion":"INTOXICACIÓN POR CISPLATINO"
  },
  {
    "codigo":94107008,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE HUESO TRAPEZOIDE"
  },
  {
    "codigo":419952004,
    "descripcion":"QUISTE DERMOIDE"
  },
  {
    "codigo":288880004,
    "descripcion":"BEBE A SORBOS"
  },
  {
    "codigo":287045000,
    "descripcion":"DOLOR EN EL BRAZO IZQUIERDO"
  },
  {
    "codigo":713029000,
    "descripcion":"DISECCIÓN DE AORTA TORACOABDOMINAL"
  },
  {
    "codigo":92272009,
    "descripcion":"NEOPLASIA BENIGNA DE LA GLÁNDULA PARATIROIDES"
  },
  {
    "codigo":254277006,
    "descripcion":"ANORMALIDAD DE CROMOSOMA SEXUAL-FENOTIPO FEMENINO"
  },
  {
    "codigo":57669007,
    "descripcion":"REQUERIMIENTO METABÓLICO AUMENTADO"
  },
  {
    "codigo":1237317008,
    "descripcion":"TRASTORNO FETAL DEBIDO A PLACENTA GRANDE"
  },
  {
    "codigo":416282001,
    "descripcion":"CANDIDIASIS OCULAR"
  },
  {
    "codigo":23066002,
    "descripcion":"OTOESCLEROSIS QUE COMPROMETE A LA CÁPSULA ÓTICA"
  },
  {
    "codigo":11307241000119102,
    "descripcion":"FRACTURA NO EXPUESTA DE PAREDES TRANSVERSAL Y POSTERIOR DE ACETÁBULO IZQUIERDO"
  },
  {
    "codigo":285210003,
    "descripcion":"INCAPAZ DE REPRODUCIR FORMAS GEOMÉTRICAS DESPUÉS DE CINCO MINUTOS"
  },
  {
    "codigo":283375001,
    "descripcion":"LACERACIÓN DE TRONCO"
  },
  {
    "codigo":15730921000119105,
    "descripcion":"PARÁLISIS PARCIAL DE NERVIO OCULOMOTOR DERECHO"
  },
  {
    "codigo":248772002,
    "descripcion":"ERECCIÓN MATUTINA"
  },
  {
    "codigo":281540007,
    "descripcion":"DISTENSIÓN DE TENDÓN DE BRAZO"
  },
  {
    "codigo":707524009,
    "descripcion":"TUMEFACCIÓN DE ENCÍA Y CRESTA ALVEOLAR DESDENTADA CAUSADA POR FÁRMACO"
  },
  {
    "codigo":246937001,
    "descripcion":"DEGENERACIÓN EPITELIAL MICROCISTOIDE DE LA CÓRNEA"
  },
  {
    "codigo":303491000119101,
    "descripcion":"DEPÓSITO DE CALCIO EN BOLSA SEROSA DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":11854211000119102,
    "descripcion":"DISTENSIÓN DE MÚSCULO INTRÍNSECO DE PIE DERECHO"
  },
  {
    "codigo":13891000,
    "descripcion":"LACERACIÓN MAYOR DE HÍGADO SIN HERIDA ABIERTA HACIA CAVIDAD ABDOMINAL"
  },
  {
    "codigo":212334009,
    "descripcion":"LESIÓN DEL NERVIO PLANTAR EXTERNO"
  },
  {
    "codigo":1259075000,
    "descripcion":"TRASTORNO DE NERVIO AUTONÓMICO DEBIDO A ALTERACIÓN DE TOLERANCIA A GLUCOSA"
  },
  {
    "codigo":46659004,
    "descripcion":"SÍNDROME DE VON HIPPEL - LINDAU"
  },
  {
    "codigo":79427009,
    "descripcion":"UNIO MYSTICA"
  },
  {
    "codigo":12056002,
    "descripcion":"TRASTORNO AUTÓNOMO DEL SÉPTIMO NERVIO CRANEAL"
  },
  {
    "codigo":405272003,
    "descripcion":"HIPOVENTILACIÓN ALVEOLAR PRIMARIA"
  },
  {
    "codigo":732952003,
    "descripcion":"SÍNDROME DE CATARATA CONGÉNITA E ICTIOSIS"
  },
  {
    "codigo":306968004,
    "descripcion":"NO SE ABROCHA LA ROPA"
  },
  {
    "codigo":274200008,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE DEDO DEL PIE"
  },
  {
    "codigo":208664009,
    "descripcion":"FRACTURA EXPUESTA DE TOBILLO, BIMALEOLAR, FRACTURA PERONEA INFERIOR"
  },
  {
    "codigo":403437002,
    "descripcion":"CONJUNTIVITIS DEBIDA A TRÍADA DE ARTRITIS REACTIVA"
  },
  {
    "codigo":10221004,
    "descripcion":"INTOXICACIÓN POR LUPINUS DIGITATUS"
  },
  {
    "codigo":763885008,
    "descripcion":"DISPLASIA ESPONDILOEPIMETAFISARIA TIPO HANDIGODU"
  },
  {
    "codigo":237762000,
    "descripcion":"INSUFICIENCIA SUPRARRENAL POSTSUPRARRENALECTOMÍA"
  },
  {
    "codigo":301463001,
    "descripcion":"NO REALIZA ACTIVIDADES EDUCATIVAS"
  },
  {
    "codigo":11827741000119104,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN ROTULOFEMORAL DERECHA"
  },
  {
    "codigo":235927004,
    "descripcion":"ADHERENCIAS DE LA VÍA BILIAR"
  },
  {
    "codigo":203159006,
    "descripcion":"OSTEOMIELITIS AGUDA DE LA COLUMNA VERTEBRAL LUMBAR"
  },
  {
    "codigo":103020000,
    "descripcion":"ADRENARCA"
  },
  {
    "codigo":168556001,
    "descripcion":"RADIOGRAFÍA SIMPLE DE CRÁNEO ANORMAL"
  },
  {
    "codigo":365164002,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA DIVERTIRSE"
  },
  {
    "codigo":397932003,
    "descripcion":"PIE EQUINOVARO"
  },
  {
    "codigo":299628004,
    "descripcion":"ARTICULACIÓN DEL DEDO DEL PIE RÍGIDA"
  },
  {
    "codigo":234092007,
    "descripcion":"LINFADENITIS CRÓNICA POR WUCHERERIA BANCROFTI"
  },
  {
    "codigo":232257006,
    "descripcion":"OTITIS MEDIA CRÓNICA NO SUPURATIVA SIN DERRAME"
  },
  {
    "codigo":295958000,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE VILOXAZINA"
  },
  {
    "codigo":230422001,
    "descripcion":"EPILEPSIA CON AUSENCIAS MIOCLÓNICAS"
  },
  {
    "codigo":1046004,
    "descripcion":"URETERITIS GLANDULAR"
  },
  {
    "codigo":294123006,
    "descripcion":"ALERGIA A DIMENHIDRINATO"
  },
  {
    "codigo":425195007,
    "descripcion":"AUSENCIA DE APTITUD PARA LA COMUNICACIÓN ALTERNATIVA: GESTOS"
  },
  {
    "codigo":30144000,
    "descripcion":"OBSTRUCCIÓN DE CONDUCTO BILIAR"
  },
  {
    "codigo":95680001,
    "descripcion":"ESCLEROUVEÍTIS"
  },
  {
    "codigo":29761000175107,
    "descripcion":"ÚLCERA POR PRESIÓN EN CADERA DERECHA, ESTADIO IV"
  },
  {
    "codigo":292288007,
    "descripcion":"REACCIÓN ADVERSA A LA CLOMIPRAMINA"
  },
  {
    "codigo":93845000,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA MANDÍBULA"
  },
  {
    "codigo":290453001,
    "descripcion":"INTOXICACIÓN POR CÁSCARA SAGRADA"
  },
  {
    "codigo":1339029002,
    "descripcion":"PROCTITIS CAUSADA POR CHLAMYDIA TRACHOMATIS"
  },
  {
    "codigo":1177024007,
    "descripcion":"INFECCIÓN POR MAMMOMONOGAMUS LARYNGEUS"
  },
  {
    "codigo":716437005,
    "descripcion":"CAPAZ DE RECONOCER LETRAS DEL ALFABETO"
  },
  {
    "codigo":10900151000119108,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE CONJUNTIVA IZQUIERDA"
  },
  {
    "codigo":126613008,
    "descripcion":"NEOPLASIA DE PARTES BLANDAS DE NALGA"
  },
  {
    "codigo":288618002,
    "descripcion":"EMPLEA CONSTRUCCIONES GRAMATICALES"
  },
  {
    "codigo":92010003,
    "descripcion":"NEOPLASIA BENIGNA DE VASO SANGUÍNEO DEL HUECO POPLÍTEO"
  },
  {
    "codigo":254015001,
    "descripcion":"FISURA FACIAL SUPRAORBITARIA - FISURA DE TESSIER TIPO 13"
  },
  {
    "codigo":286783004,
    "descripcion":"MODERADAMENTE SUGESTIONABLE"
  },
  {
    "codigo":90175006,
    "descripcion":"ANEMIA SIDEROBLÁSTICA SECUNDARIA ADQUIRIDA"
  },
  {
    "codigo":448788000,
    "descripcion":"FRACTURA EXPUESTA DE COLUMNA VERTEBRAL LUMBAR CON LESIÓN INCOMPLETA DE MÉDULA ESPINAL LUMBAR"
  },
  {
    "codigo":1237055008,
    "descripcion":"METÁSTASIS DE CARCINOMA DE CUADRANTE SUPERIOR EXTERNO DE MAMA"
  },
  {
    "codigo":16090091000119100,
    "descripcion":"AUSENCIA CONGÉNITA DE MANO IZQUIERDA"
  },
  {
    "codigo":284948007,
    "descripcion":"DIFICULTAD PARA PARARSE EN INODORO"
  },
  {
    "codigo":250345000,
    "descripcion":"HALLAZGO RELACIONADO CON LA DETECCIÓN SELECTIVA DEL FIBRINÓGENO"
  },
  {
    "codigo":446953001,
    "descripcion":"DEHISCENCIA DE ANASTOMOSIS"
  },
  {
    "codigo":219412009,
    "descripcion":"HERIDA DE GUERRA POR AERONAVE DERRIBADA"
  },
  {
    "codigo":283113007,
    "descripcion":"ARAÑAZO DE CONEJO"
  },
  {
    "codigo":306001000119108,
    "descripcion":"TRASTORNO DE LIGAMENTO DE PIE IZQUIERDO"
  },
  {
    "codigo":1231550001,
    "descripcion":"SIGNO DE RETRASO EN ROTACIÓN INTERNA DE HOMBRO"
  },
  {
    "codigo":86505009,
    "descripcion":"INTOXICACIÓN POR INGESTA DE HONGOS"
  },
  {
    "codigo":445118002,
    "descripcion":"BLOQUEO FASCICULAR IZQUIERDO ANTERIOR EN EL ELECTROCARDIOGRAMA"
  },
  {
    "codigo":248510004,
    "descripcion":"NÓDULO DE IRIS"
  },
  {
    "codigo":281278005,
    "descripcion":"ESPÉCIMEN LÍMPIDO"
  },
  {
    "codigo":838334004,
    "descripcion":"ABLÉFARON BILATERAL"
  },
  {
    "codigo":707262008,
    "descripcion":"DETERIORO EN LA CAPACIDAD PARA COMUNICARSE"
  },
  {
    "codigo":246675004,
    "descripcion":"DISCRIMINACIÓN AMARILLO - AZUL, REDUCIDA"
  },
  {
    "codigo":82835005,
    "descripcion":"TROMBOCITOPENIA NEONATAL ASOCIADA CON PÚRPURA TROMBOCITOPÉNICA IDIOPÁTICA MATERNAL"
  },
  {
    "codigo":38781000087100,
    "descripcion":"LUMBALGIA CRÓNICA PRIMARIA"
  },
  {
    "codigo":41341000087102,
    "descripcion":"HEMATOMA DE QUINTO DEDO DE PIE DERECHO"
  },
  {
    "codigo":46461000087102,
    "descripcion":"FRACTURA DE HUESO METACARPIANO DE MANO IZQUIERDA"
  },
  {
    "codigo":43901000087103,
    "descripcion":"HERIDA CORTANTE DE PIEL DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":408680002,
    "descripcion":"NEUMONÍA BACTERIANA ASOCIADA CON LA ATENCIÓN MÉDICA"
  },
  {
    "codigo":56701000087109,
    "descripcion":"COMPORTAMIENTO INTRUSIVO"
  },
  {
    "codigo":310376006,
    "descripcion":"CONSENTIMIENTO PARA VACUNACIÓN NO OTORGADO"
  },
  {
    "codigo":81000006,
    "descripcion":"PEDICULOSIS CAPILAR"
  },
  {
    "codigo":212072008,
    "descripcion":"QUEMADURA QUE COMPROMETE 40-49 PORCIENTO DE LA SUPERFICIE DEL CUERPO, CON QUEMADURA DE ESPESOR COMPLETO QUE AFECTA 20-29 PORCIENTO DE LA SUPERFICIE CORPORAL"
  },
  {
    "codigo":275773002,
    "descripcion":"ANFETAMINA EN ORINA"
  },
  {
    "codigo":46397005,
    "descripcion":"INFECCIÓN CORONARIA POR ENTEROVIRUS"
  },
  {
    "codigo":243005007,
    "descripcion":"LESIÓN POR BALA DE PISTOLA"
  },
  {
    "codigo":13629008,
    "descripcion":"HIPOTERMIA DEL RECIÉN NACIDO"
  },
  {
    "codigo":77330006,
    "descripcion":"ENFERMEDAD GRANULOMATOSA CRÓNICA, TIPO II"
  },
  {
    "codigo":110098007,
    "descripcion":"AVULSIÓN DE LA MUCOSA LABIAL"
  },
  {
    "codigo":763623001,
    "descripcion":"INMUNODEFICIENCIA COMBINADA SEVERA DEBIDA A DEFICIENCIA DE CITIDINA 5-PRIMA TRIFOSFATO SINTETASA"
  },
  {
    "codigo":206567004,
    "descripcion":"ALIMENTACIÓN EXCESIVA DEL RECIÉN NACIDO"
  },
  {
    "codigo":1255143006,
    "descripcion":"ICTIOSIS HISTRIX GRAVIOR"
  },
  {
    "codigo":304871006,
    "descripcion":"APEGO ANSIOSO-EVITATIVO"
  },
  {
    "codigo":16037151000119100,
    "descripcion":"DETENCIÓN DE CRECIMIENTO EPIFISARIO DE HÚMERO IZQUIERDO"
  },
  {
    "codigo":73660006,
    "descripcion":"ESTENOSIS SUBAÓRTICA CONGÉNITA"
  },
  {
    "codigo":237500008,
    "descripcion":"HASHITOXICOSIS - TRANSITORIA"
  },
  {
    "codigo":703100191000119101,
    "descripcion":"DOLOR A LA DESCOMPRESIÓN DEL CUADRANTE SUPERIOR DERECHO DEL ABDOMEN"
  },
  {
    "codigo":301201004,
    "descripcion":"SENOS PARANASALES NORMALES"
  },
  {
    "codigo":399505005,
    "descripcion":"PÓLIPO DE INTESTINO GRUESO"
  },
  {
    "codigo":1251473003,
    "descripcion":"METÁSTASIS DE OSTEOSARCOMA EN COSTILLA"
  },
  {
    "codigo":170129007,
    "descripcion":"EXAMEN ANORMAL DE NIÑO DE 8-9 MESES DE EDAD - DERIVADO"
  },
  {
    "codigo":10630431000119102,
    "descripcion":"LINFANGITIS AGUDA DE ANTEBRAZO IZQUIERDO"
  },
  {
    "codigo":168294002,
    "descripcion":"ORGANISMO NO AISLADO EN CULTIVO DE HISOPADO DE OÍDO"
  },
  {
    "codigo":266598008,
    "descripcion":"VAGINISMO DE CAUSA NO PSICÓGENA"
  },
  {
    "codigo":364902009,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA GIRAR LA CABEZA"
  },
  {
    "codigo":299366009,
    "descripcion":"SIN AMPLITUD PASIVA DE ROTACIÓN EXTERNA DE RODILLA"
  },
  {
    "codigo":308511000119104,
    "descripcion":"GRANULOMA POR CUERPO EXTRAÑO DE PARTES BLANDAS DE MUSLO"
  },
  {
    "codigo":233830008,
    "descripcion":"INFARTO AGUDO NO Q - INFERIOR"
  },
  {
    "codigo":789051005,
    "descripcion":"CARCINOMA ESCAMOCELULAR IN SITU DE PIEL CAUSADO POR LUZ SOLAR"
  },
  {
    "codigo":231995008,
    "descripcion":"ATROFIA CORIORRETINIANA MIÓPICA"
  },
  {
    "codigo":363067009,
    "descripcion":"SECUELAS GASTROINTESTINALES DE TRASTORNOS"
  },
  {
    "codigo":426768001,
    "descripcion":"SÍNDROME DE PRENDIMIENTO DE INJERTO"
  },
  {
    "codigo":461371009,
    "descripcion":"HIPOPLASIA CONGÉNITA DE AORTA ABDOMINAL"
  },
  {
    "codigo":230160004,
    "descripcion":"VENTRICULITIS CEREBRAL MALIGNA"
  },
  {
    "codigo":33552005,
    "descripcion":"ANOMALÍA PLACENTARIA"
  },
  {
    "codigo":35387008,
    "descripcion":"AFAQUIA CONGÉNITA"
  },
  {
    "codigo":295696001,
    "descripcion":"SOBREDOSIS DE ANTIMETABOLITO"
  },
  {
    "codigo":721680006,
    "descripcion":"PSEUDO-OBSTRUCCIÓN DE COLON"
  },
  {
    "codigo":293861001,
    "descripcion":"ALERGIA A GABAPENTINA"
  },
  {
    "codigo":262928009,
    "descripcion":"APLASTAMIENTO DE OVARIO"
  },
  {
    "codigo":228325006,
    "descripcion":"SESIÓN DE CONSUMO EXCESIVO DE ALCOHOL"
  },
  {
    "codigo":292026000,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR ESTREPTOQUINASA"
  },
  {
    "codigo":719845008,
    "descripcion":"SÍNDROME DE VAN DEN ENDE-GUPTA"
  },
  {
    "codigo":31717008,
    "descripcion":"QUEMADURA PROFUNDA DE TERCER GRADO DE PIEL DE LA NARIZ"
  },
  {
    "codigo":193722001,
    "descripcion":"VISIÓN ESCASA EN AMBOS OJOS"
  },
  {
    "codigo":95418008,
    "descripcion":"ESPASMO DE MÚSCULO DE CABEZA Y\/O CUELLO"
  },
  {
    "codigo":1240463000,
    "descripcion":"SÍNDROME DE DESCAMACIÓN CUTÁNEA GENERALIZADA NO INFLAMATORIA"
  },
  {
    "codigo":423098009,
    "descripcion":"ESCALERAS EMPINADAS EN EL HOGAR"
  },
  {
    "codigo":60815008,
    "descripcion":"GRADO NO DETERMINADO"
  },
  {
    "codigo":191887008,
    "descripcion":"ADICCIÓN AL TABACO, CONTINUA"
  },
  {
    "codigo":124516005,
    "descripcion":"DEFICIENCIA DE DIHIDROOROTASA"
  },
  {
    "codigo":1074771000119100,
    "descripcion":"ARTRITIS DE DEDOS DE AMBAS MANOS"
  },
  {
    "codigo":386660007,
    "descripcion":"REACCIÓN PUPILAR ANORMAL"
  },
  {
    "codigo":288356009,
    "descripcion":"CAPAZ DE LANZAR OBJETOS"
  },
  {
    "codigo":286521002,
    "descripcion":"INCAPAZ DE LLEVAR ALIMENTOS PREPARADOS"
  },
  {
    "codigo":253753005,
    "descripcion":"HAMARTOMA DE LENGUA"
  },
  {
    "codigo":11996601000119108,
    "descripcion":"DOLOR EN MUÑÓN DE AMPUTACIÓN DE EXTREMIDAD SUPERIOR DERECHA"
  },
  {
    "codigo":1234958003,
    "descripcion":"TRASTORNO NEONATAL DEBIDO A TRASTORNO DE CORDÓN UMBILICAL"
  },
  {
    "codigo":88078006,
    "descripcion":"HERNIA INTERMUSCULAR"
  },
  {
    "codigo":55310007,
    "descripcion":"PÓLIPO MUCOSO DEL CUELLO UTERINO"
  },
  {
    "codigo":22542007,
    "descripcion":"ENTEROPATÍA EXUDATIVA"
  },
  {
    "codigo":282851000,
    "descripcion":"DIFICULTAD PARA MANTENER UNA POSICIÓN"
  },
  {
    "codigo":1003747006,
    "descripcion":"CONTRACTURA EN FLEXIÓN DE ARTICULACIÓN INTERFALÁNGICA PROXIMAL DE DEDO MEDIO DE MANO"
  },
  {
    "codigo":413923007,
    "descripcion":"DEFORMIDAD CORNEAL INDUCIDA POR LENTES DE CONTACTO"
  },
  {
    "codigo":11806291000119105,
    "descripcion":"LUXACIÓN TRAUMÁTICA POSTERIOR NO EXPUESTA DE RODILLA DERECHA"
  },
  {
    "codigo":1231288003,
    "descripcion":"ANOMALÍA CONGÉNITA DE EXTREMIDAD INFERIOR IZQUIERDA"
  },
  {
    "codigo":2261000124100,
    "descripcion":"INCISIVO CENTRAL IZQUIERDO MANDIBULAR SUPERNUMERARIO TEMPORARIO"
  },
  {
    "codigo":204296002,
    "descripcion":"CONEXIÓN VENTRICULOARTERIAL DISCORDANTE"
  },
  {
    "codigo":281016006,
    "descripcion":"INCOORDINACIÓN"
  },
  {
    "codigo":248248008,
    "descripcion":"MANOS SUDOROSAS"
  },
  {
    "codigo":444856008,
    "descripcion":"ARTERIOSCLEROSIS DE INJERTO-PUENTE ENTRE ARTERIA MAMARIA INTERNA Y ARTERIA CORONARIA"
  },
  {
    "codigo":1260386000,
    "descripcion":"HEMICOREA DEBIDA A INFARTO CEREBRAL"
  },
  {
    "codigo":408418009,
    "descripcion":"SÍNDROME DE RESISTENCIA DE LA VÍA AÉREA SUPERIOR"
  },
  {
    "codigo":406583002,
    "descripcion":"ENFERMEDAD INVASIVA POR HAEMOPHILUS INFLUENZAE"
  },
  {
    "codigo":15202009,
    "descripcion":"TUBERCULOMA"
  },
  {
    "codigo":703330009,
    "descripcion":"INSUFICIENCIA DE VÁLVULA MITRAL DEBIDA A INFARTO AGUDO DE MIOCARDIO CON RUPTURA DE MÚSCULO PAPILAR Y CUERDAS TENDINOSAS"
  },
  {
    "codigo":373815005,
    "descripcion":"PACIENTE FALLECIDO ANTES DEL TRATAMIENTO ONCOLÓGICO"
  },
  {
    "codigo":767031008,
    "descripcion":"MACROSTOMÍA CONGÉNITA DE LADO IZQUIERDO DE LA BOCA"
  },
  {
    "codigo":371980003,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL CLÍTORIS"
  },
  {
    "codigo":765196004,
    "descripcion":"MIOTILINOPATÍA DISTAL"
  },
  {
    "codigo":311021000119106,
    "descripcion":"DERRAME INTERMITENTE DE ARTICULACIÓN DE REGIÓN DE HOMBRO DERECHO"
  },
  {
    "codigo":109836006,
    "descripcion":"NEOPLASIA MALIGNA SUPERPUESTA DE ESTÓMAGO"
  },
  {
    "codigo":402913004,
    "descripcion":"PAPULOSIS BOWENOIDE"
  },
  {
    "codigo":271841006,
    "descripcion":"MATERIA FECAL ABUNDANTE"
  },
  {
    "codigo":15957741000119108,
    "descripcion":"FEOCROMOCITOMA BENIGNO BILATERAL"
  },
  {
    "codigo":206305008,
    "descripcion":"HEMORRAGIA TRAQUEOBRONQUIAL ORIGINADA EN EL PERÍODO PERINATAL"
  },
  {
    "codigo":239073008,
    "descripcion":"QUERATODERMA PALMOPLANTAR CIRCUNSCRIPTO"
  },
  {
    "codigo":16750471000119102,
    "descripcion":"INFARTO AGUDO DIFUSO DE INTESTINO DELGADO"
  },
  {
    "codigo":204470001,
    "descripcion":"ARTERIA UMBILICAL ÚNICA"
  },
  {
    "codigo":73398002,
    "descripcion":"INTOXICACIÓN POR QUERCUS HAVARDI"
  },
  {
    "codigo":7862002,
    "descripcion":"PÉRDIDA PROLONGADA DE LA CONSCIENCIA"
  },
  {
    "codigo":1187510006,
    "descripcion":"ENFERMEDAD OCULAR ASOCIADA A INMUNOGLOBULINA G4"
  },
  {
    "codigo":237238006,
    "descripcion":"EMBARAZO CON EDAD GESTACIONAL INCIERTA"
  },
  {
    "codigo":1351350008,
    "descripcion":"SÍNDROME DE MALFORMACIÓN DE FOSA CEREBRAL POSTERIOR, HEMANGIOMA FACIAL, ANOMALÍA ARTERIAL, DEFECTO CARDÍACO, COARTACIÓN AÓRTICA, ANOMALÍA OCULAR Y ANOMALÍAS ESTERNALES"
  },
  {
    "codigo":366475001,
    "descripcion":"HALLAZGO RELACIONADO CON LA AMPLITUD DE LA EXTENSIÓN DE HOMBRO"
  },
  {
    "codigo":169867004,
    "descripcion":"PESO AL NACER IGUAL O MAYOR DEL 96% (MÁS DE 4499 G)"
  },
  {
    "codigo":38795005,
    "descripcion":"SIALIDOSIS"
  },
  {
    "codigo":11835271000119105,
    "descripcion":"SUBLUXACIÓN ROTATORIA DE ARTICULACIÓN DE ESCAFOIDES DE MUÑECA DERECHA"
  },
  {
    "codigo":300939009,
    "descripcion":"ALCOHÓLICO ABSTEMIO"
  },
  {
    "codigo":299104002,
    "descripcion":"AMPLITUD DE ADUCCIÓN PASIVA DE DEDO DE LA MANO AUMENTADA"
  },
  {
    "codigo":102496004,
    "descripcion":"FIEBRE ONDULANTE"
  },
  {
    "codigo":16013191000119107,
    "descripcion":"TROMBOSIS BILATERAL DE ARTERIA FEMORAL"
  },
  {
    "codigo":67893003,
    "descripcion":"INTOXICACIÓN POR LISERGIDA"
  },
  {
    "codigo":461109004,
    "descripcion":"TRAYECTO ANÓMALO DE ARTERIA CORONARIA POR DELANTE DEL TRONCO PULMONAR Y DE LA AORTA"
  },
  {
    "codigo":35125005,
    "descripcion":"TORSIÓN AUMENTADA"
  },
  {
    "codigo":120711000119108,
    "descripcion":"FALTA DE PERCEPCIÓN DE SIGNOS DE HIPOGLUCEMIA DEBIDA A DIABETES MELLITUS TIPO 1"
  },
  {
    "codigo":721418004,
    "descripcion":"FRACTURA DE CUARTA VÉRTEBRA DORSAL"
  },
  {
    "codigo":129759000,
    "descripcion":"CALCIFICACIÓN VASCULAR"
  },
  {
    "codigo":197130009,
    "descripcion":"VÓMITO POSCIRUGÍA DEL TRACTO GASTROINTESTINAL"
  },
  {
    "codigo":719583002,
    "descripcion":"SÍNDROME DE MICRODUPLICACIÓN 17Q11.2"
  },
  {
    "codigo":293599003,
    "descripcion":"ALERGIA A DIHIDROCODEÍNA"
  },
  {
    "codigo":295434009,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE BISACODILO"
  },
  {
    "codigo":195295006,
    "descripcion":"ENFERMEDAD DE RAYNAUD"
  },
  {
    "codigo":226228003,
    "descripcion":"DIETA SIKH"
  },
  {
    "codigo":95156004,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL MIEMBRO SUPERIOR"
  },
  {
    "codigo":717748005,
    "descripcion":"RIÑÓN CON MÉDULA EN ESPONJA BILATERAL"
  },
  {
    "codigo":816052006,
    "descripcion":"TUMORACIÓN DE CUADRANTE SUPERIOR INTERNO DE MAMA"
  },
  {
    "codigo":160692006,
    "descripcion":"MOVILIDAD, MALA"
  },
  {
    "codigo":224393001,
    "descripcion":"ESCASA ACEPTACIÓN DE LA AUTORIDAD EN EL TRABAJO"
  },
  {
    "codigo":781449004,
    "descripcion":"DISTENSIÓN DEL TENDÓN DEL MÚSCULO FLEXOR LARGO DEL DEDO PULGAR"
  },
  {
    "codigo":93321007,
    "descripcion":"POSICIÓN ANÓMALA CONGÉNITA DE FÉMUR"
  },
  {
    "codigo":25950000,
    "descripcion":"ENFERMEDAD SUPUESTA PERO NO COMPROBADA"
  },
  {
    "codigo":58718002,
    "descripcion":"FIEBRE REUMÁTICA"
  },
  {
    "codigo":124254009,
    "descripcion":"DEFICIENCIA DE GLUCOSAMINA - FOSFATO ACETILTRANSFERASA"
  },
  {
    "codigo":98071000119100,
    "descripcion":"ARTROPATÍA DE HOMBRO DEBIDA A TRASTORNO NEUROLÓGICO"
  },
  {
    "codigo":16054551000119100,
    "descripcion":"TRASTORNO DE VÍA VISUAL DERECHA"
  },
  {
    "codigo":16039191000119102,
    "descripcion":"CONDROMALACIA DE HOMBRO IZQUIERDO"
  },
  {
    "codigo":10632471000119103,
    "descripcion":"ABSCESO DE MUSLO DERECHO"
  },
  {
    "codigo":15629591000119103,
    "descripcion":"INSUFICIENCIA CARDÍACA CONGESTIVA EN ESTADIO B DEBIDA A MIOCARDIOPATÍA ISQUÉMICA"
  },
  {
    "codigo":292834071000119104,
    "descripcion":"TROMBOSIS VENOSA PROFUNDA AGUDA DURANTE EMBARAZO"
  },
  {
    "codigo":1081111000119103,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE MÚSCULO DE EXTREMIDAD SUPERIOR DERECHA"
  },
  {
    "codigo":15990551000119107,
    "descripcion":"TRASTORNO DEGENERATIVO DE OJO DERECHO"
  },
  {
    "codigo":15875351000119108,
    "descripcion":"DEFORMIDAD EN VARO DE LA TIBIA IZQUIERDA"
  },
  {
    "codigo":333591000119109,
    "descripcion":"SIDEROSIS DE OJO DERECHO"
  },
  {
    "codigo":39191000119103,
    "descripcion":"COAGULACIÓN INTRAVASCULAR DISEMINADA DEBIDA A DESPRENDIMIENTO DE PLACENTA"
  },
  {
    "codigo":16668951000119104,
    "descripcion":"FRACTURA NO EXPUESTA DE PORCIÓN NASO-ORBITARIA DE HUESO ETMOIDES IZQUIERDO"
  },
  {
    "codigo":282589000,
    "descripcion":"INCAPAZ DE BRINCAR EN UN SOLO PIE"
  },
  {
    "codigo":12204311000119108,
    "descripcion":"DOLOR DE TESTÍCULO POSTERIOR A PROCEDIMIENTO"
  },
  {
    "codigo":284951000119109,
    "descripcion":"BLOQUEO AURICULOVENTRICULAR POSOPERATORIO"
  },
  {
    "codigo":10629911000119106,
    "descripcion":"CELULITIS DE CADERA DERECHA"
  },
  {
    "codigo":62231000119108,
    "descripcion":"RETARDO LEVE DEL LENGUAJE EXPRESIVO"
  },
  {
    "codigo":323351000119108,
    "descripcion":"ANOMALÍA DEL TAMAÑO DE LA MANDÍBULA"
  },
  {
    "codigo":12242711000119109,
    "descripcion":"DEBILIDAD DE MÚSCULO FACIAL IZQUIERDO DEBIDA A ACCIDENTE CEREBROVASCULAR Y POSTERIOR A ÉL"
  },
  {
    "codigo":12001621000119100,
    "descripcion":"HEMORRAGIA ASOCIADA CON CATÉTER DE HEMODIÁLISIS"
  },
  {
    "codigo":315357006,
    "descripcion":"PAÍS DE NACIMIENTO - CONTINENTE AMERICANO"
  },
  {
    "codigo":249821009,
    "descripcion":"DEFORMIDAD EN DORSIFLEXIÓN DEL PRIMER DEDO DEL PIE"
  },
  {
    "codigo":870578004,
    "descripcion":"ELECTROLITOS ANORMALES PERSISTENTES"
  },
  {
    "codigo":368981000119103,
    "descripcion":"ESTRECHEZ TRAUMÁTICA DE URETRA FEMENINA"
  },
  {
    "codigo":247986008,
    "descripcion":"CANTO INAPROPIADO"
  },
  {
    "codigo":278919001,
    "descripcion":"TRASTORNO DE LA COMUNICACIÓN"
  },
  {
    "codigo":213383004,
    "descripcion":"LESIÓN ENCEFÁLICA Y DE PARES CRANEALES CON LESIONES NERVIOSAS Y MEDULARES CERVICALES"
  },
  {
    "codigo":47708004,
    "descripcion":"PREDISPOSICIÓN GENÉTICA"
  },
  {
    "codigo":211548006,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA DE ÓRGANOS GENITALES EXTERNOS"
  },
  {
    "codigo":735836006,
    "descripcion":"LACERACIÓN DE MUSLO SIN CUERPO EXTRAÑO"
  },
  {
    "codigo":50227004,
    "descripcion":"BALANITIS AMEBIANA"
  },
  {
    "codigo":440924009,
    "descripcion":"HIPERFIBRINOGENEMIA HEREDITARIA"
  },
  {
    "codigo":111409009,
    "descripcion":"CISTITIS ULCERATIVA"
  },
  {
    "codigo":109574006,
    "descripcion":"CARIES DENTAL PRIMARIA, ORIGEN EN SUPERFICIE LISA NO PROXIMAL"
  },
  {
    "codigo":238811006,
    "descripcion":"MÁCULAS DE BIER"
  },
  {
    "codigo":304347009,
    "descripcion":"AMPLITUD DE MOVIMIENTO DE COLUMNA DORSAL AUMENTADA"
  },
  {
    "codigo":40368002,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO DE LA REGIÓN ESCAPULAR"
  },
  {
    "codigo":96751000119106,
    "descripcion":"CARDIOPATÍA HIPERTENSIVA Y ENFERMEDAD RENAL CRÓNICA, ESTADIO1"
  },
  {
    "codigo":204208005,
    "descripcion":"AGENESIA DE ORIFICIO LAGRIMAL"
  },
  {
    "codigo":300677000,
    "descripcion":"INCAPAZ DE CRUZAR POR CRUCE PEATONAL"
  },
  {
    "codigo":366213003,
    "descripcion":"FRAGILIDAD CAPILAR - HALLAZGO"
  },
  {
    "codigo":202373004,
    "descripcion":"DERRAME DE ARTICULACIÓN DE CODO"
  },
  {
    "codigo":5765005,
    "descripcion":"INFECCIÓN CAUSADA POR LEISHMANIA TROPICA MINOR"
  },
  {
    "codigo":342511000119108,
    "descripcion":"EDEMA DE PÁRPADO IZQUIERDO"
  },
  {
    "codigo":69466000,
    "descripcion":"PROCEDIMIENTO DESCONOCIDO"
  },
  {
    "codigo":724826000,
    "descripcion":"BLEFAROCONJUNTIVITIS ALÉRGICA POR CONTACTO"
  },
  {
    "codigo":722991004,
    "descripcion":"MIOPATÍA AUTOINMUNITARIA"
  },
  {
    "codigo":297007004,
    "descripcion":"SOBREDOSIS DE DIURÉTICO TIAZÍDICO"
  },
  {
    "codigo":229636002,
    "descripcion":"DISFONÍA HIPOFUNCIONAL"
  },
  {
    "codigo":11784841000119106,
    "descripcion":"AMPOLLA TRAUMÁTICA DE MUÑECA DERECHA"
  },
  {
    "codigo":295172005,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE CODEÍNA"
  },
  {
    "codigo":33028007,
    "descripcion":"VULVITIS AGUDA"
  },
  {
    "codigo":721156008,
    "descripcion":"DOLOR PÉLVICO CÍCLICO"
  },
  {
    "codigo":293337004,
    "descripcion":"REACCIÓN ADVERSA A LA TINZAPARINA"
  },
  {
    "codigo":1145305006,
    "descripcion":"CAPAZ DE LIMPIAR LA VÍA AÉREA DE MANERA EFICAZ"
  },
  {
    "codigo":195033009,
    "descripcion":"SARCOIDOSIS DEL MÚSCULO CARDÍACO"
  },
  {
    "codigo":1340078002,
    "descripcion":"VACUNA VENCIDA LUEGO DE SU DESCONGELAMIENTO"
  },
  {
    "codigo":193198003,
    "descripcion":"INFECCIÓN SOBREAGREGADA"
  },
  {
    "codigo":94894006,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DEL INTESTINO GRUESO"
  },
  {
    "codigo":781187003,
    "descripcion":"HERIDA QUIRÚRGICA NO CICATRIZANTE"
  },
  {
    "codigo":60291005,
    "descripcion":"AUSENCIA CONGÉNITA DE CLÍTORIS"
  },
  {
    "codigo":93059006,
    "descripcion":"DILATACIÓN CONGÉNITA DE LA ARTERIA PULMONAR"
  },
  {
    "codigo":289667007,
    "descripcion":"CUERPO UTERINO DOLOROSO A LA PALPACIÓN"
  },
  {
    "codigo":255064003,
    "descripcion":"NEOPLASIA DE CONDUCTA INCIERTA DE VÍAS BILIARES"
  },
  {
    "codigo":23853001,
    "descripcion":"TRASTORNO DEL SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":449837001,
    "descripcion":"QUISTE COMPLEJO DE MAMA"
  },
  {
    "codigo":285997005,
    "descripcion":"CAPAZ DE ABRIR LA TUBERÍA DE GAS MAESTRA"
  },
  {
    "codigo":187693006,
    "descripcion":"NEOPLASIA MALIGNA DE PARED POSTERIOR DE NASOFARINGE"
  },
  {
    "codigo":417069008,
    "descripcion":"MOVIMIENTO DE LAS COSTILLAS INFERIORES ANÁLOGO A LA ROTACIÓN INTERNA Y EXTERNA"
  },
  {
    "codigo":218626001,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR PIRABITAL"
  },
  {
    "codigo":284162004,
    "descripcion":"CAPAZ DE MOVER LA CABEZA"
  },
  {
    "codigo":85719003,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA VENA SUBCLAVIA"
  },
  {
    "codigo":282327004,
    "descripcion":"DIFICULTAD PARA PARARSE EN UNA SOLA PIERNA"
  },
  {
    "codigo":249559005,
    "descripcion":"PALPACIÓN PROFUNDA SOBRE HÍGADO"
  },
  {
    "codigo":345021000119104,
    "descripcion":"DEGENERACIÓN NODULAR DE AMBAS CÓRNEAS"
  },
  {
    "codigo":52951008,
    "descripcion":"ANEMIA DISERITROPOYÉTICA CONGÉNITA"
  },
  {
    "codigo":444332001,
    "descripcion":"CONCIENTE DEL PRONÓSTICO"
  },
  {
    "codigo":247724001,
    "descripcion":"EL TIEMPO PARECE TRANSCURRIR CON GRAN LENTITUD"
  },
  {
    "codigo":318551000119100,
    "descripcion":"CIFOSIS DORSAL POSTURAL ADQUIRIDA"
  },
  {
    "codigo":16513000,
    "descripcion":"DOLOR POSTCORDOTOMÍA"
  },
  {
    "codigo":1360001001,
    "descripcion":"CON MAYOR RIESGO DE CICATRIZACIÓN TARDÍA DE HERIDA QUIRÚRGICA"
  },
  {
    "codigo":13016151000119101,
    "descripcion":"ESTREÑIMIENTO DURANTE EMBARAZO"
  },
  {
    "codigo":409729003,
    "descripcion":"CLASIFICACIÓN INTERNACIONAL DE NEUROBLASTOMA: GRUPO CON HISTOLOGÍA FAVORABLE, PACIENTE DE CUALQUIER EDAD, CON GANGLIONEUROMA"
  },
  {
    "codigo":213121005,
    "descripcion":"INFECCIÓN DE PRÓTESIS ARTICULAR"
  },
  {
    "codigo":1082301000119109,
    "descripcion":"CARCINOMA DE CÉLULAS DE TRANSICIÓN DE PELVIS RENAL DERECHA"
  },
  {
    "codigo":735574006,
    "descripcion":"OCLUSIÓN AGUDA DE ARTERIA DE MIEMBRO INFERIOR"
  },
  {
    "codigo":276822007,
    "descripcion":"MELANOMA MALIGNO DE RECTO"
  },
  {
    "codigo":473430007,
    "descripcion":"COMPLEJO PRIMARIO TUBERCULOSO CONFIRMADO"
  },
  {
    "codigo":440662009,
    "descripcion":"ANÁLISIS DE INTERFERÓN GAMMA POSITIVO"
  },
  {
    "codigo":438827002,
    "descripcion":"DISFIBRINOGENEMIA TROMBOFÍLICA HEREDITARIA"
  },
  {
    "codigo":897579001,
    "descripcion":"SINDACTILIA SIMPLE DE DEDOS DEL PIE DEL SEGUNDO ESPACIO INTERDIGITAL BILATERAL"
  },
  {
    "codigo":209451009,
    "descripcion":"ESGUINCE DEL FIBROCARTÍLAGO TRIANGULAR"
  },
  {
    "codigo":307755009,
    "descripcion":"NEFROPATÍA TUBULOINTERSTICIAL DEBIDA A LUPUS ERITEMATOSO SISTÉMICO"
  },
  {
    "codigo":1354496003,
    "descripcion":"LESIÓN TRAUMÁTICA DE URETRA DURANTE OPERACIÓN CESÁREA"
  },
  {
    "codigo":109312001,
    "descripcion":"OSTEOMIELITIS AGUDA DE HUESO ESFENOIDES"
  },
  {
    "codigo":240384004,
    "descripcion":"PESTE GASTROINTESTINAL"
  },
  {
    "codigo":11008006,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE LA SÉPTIMA VÉRTEBRA CERVICAL"
  },
  {
    "codigo":733739009,
    "descripcion":"MEJORÍA EN LA DENTICIÓN"
  },
  {
    "codigo":369621000,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA DE PARÉNQUIMA RENAL Y PELVIS RENAL, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":404224009,
    "descripcion":"DEPÓSITOS DE CALCIO EN TENDÓN"
  },
  {
    "codigo":238549003,
    "descripcion":"ECCEMA CONSTITUCIONAL DE MANOS Y PIES"
  },
  {
    "codigo":402389004,
    "descripcion":"ANGIOEDEMA ALÉRGICO POR MORDEDURA Y\/O PICADURA"
  },
  {
    "codigo":72791000119108,
    "descripcion":"DEFECTO ADQUIRIDO DE CARTÍLAGO ARTICULAR"
  },
  {
    "codigo":105642000,
    "descripcion":"ENFERMEDAD CAUSADA POR SARCOCYSTIDAE"
  },
  {
    "codigo":203946002,
    "descripcion":"ESPINA BÍFIDA CON HIDROCEFALIA - CERRADA"
  },
  {
    "codigo":302250008,
    "descripcion":"DEFICIENCIA DE AMILASA"
  },
  {
    "codigo":202111003,
    "descripcion":"RUPTURA DEL LIGAMENTO CRUZADO POSTERIOR, ANTIGUA"
  },
  {
    "codigo":398719004,
    "descripcion":"CONDRODISPLASIA PUNTEADA TIPO CONRADI-HÜNERMANN"
  },
  {
    "codigo":726399005,
    "descripcion":"DELECIÓN DE PARTE DEL CROMOSOMA 22"
  },
  {
    "codigo":71039006,
    "descripcion":"FRACTURA EXPUESTA DE LA DIÁFISIS DE LA CLAVÍCULA"
  },
  {
    "codigo":365951004,
    "descripcion":"CANTIDAD DE PAREJAS SEXUALES ACTUALES - HALLAZGO"
  },
  {
    "codigo":396884000,
    "descripcion":"TUMOR QUE INVADE MÁS ALLÁ DE LA CÁPSULA PANCRÉATICA HACIA EL DUODENO (PÁNCREAS ENDOCRINO)"
  },
  {
    "codigo":300415009,
    "descripcion":"DEFENSA ABDOMINAL EN LA REGIÓN LUMBAR IZQUIERDA"
  },
  {
    "codigo":1052244000,
    "descripcion":"HEMIPARESIA DEL LADO DERECHO DE LA CARA"
  },
  {
    "codigo":298580005,
    "descripcion":"COLUMNA VERTEBRAL DORSAL, CREPITACIÓN"
  },
  {
    "codigo":347531000119100,
    "descripcion":"CATARATA CORTICAL SENIL DE OJO IZQUIERDO"
  },
  {
    "codigo":296745003,
    "descripcion":"SOBREDOSIS VOLUNTARIA DE CEFSULODINA"
  },
  {
    "codigo":34601006,
    "descripcion":"CONVULSIÓN SOMATOSENSITIVA"
  },
  {
    "codigo":460585008,
    "descripcion":"TRAYECTO ANÓMALO DE ARTERIA CORONARIA POR DETRÁS DE LA AORTA"
  },
  {
    "codigo":395049009,
    "descripcion":"CONTROL DIABÉTICO NO REQUERIDO"
  },
  {
    "codigo":292081000119109,
    "descripcion":"NEUROPATÍA DE NERVIO CIÁTICO POPLÍTEO EXTERNO DERECHO EN CABEZA DE PERONÉ"
  },
  {
    "codigo":131070005,
    "descripcion":"NIVEL DE PREGNANETRIOL POR DEBAJO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1145043002,
    "descripcion":"MASA DEL CIEGO"
  },
  {
    "codigo":719059002,
    "descripcion":"CRYPTOCOCCUS GATTII O CRYPTOCOCCUS NEOFORMANS"
  },
  {
    "codigo":293075007,
    "descripcion":"REACCIÓN ADVERSA A LA RIFAMPICINA"
  },
  {
    "codigo":717224002,
    "descripcion":"SÍNDROME DE TRASTORNO PIGMENTARIO RETICULADO LIGADO AL CROMOSOMA X CON MANIFESTACIONES SISTÉMICAS"
  },
  {
    "codigo":1208744003,
    "descripcion":"TUMOR NEUROENDOCRINO NO FUNCIONANTE DE PÁNCREAS"
  },
  {
    "codigo":127400004,
    "descripcion":"HALLAZGO EN LA HEMATOPOYESIS"
  },
  {
    "codigo":15912331000119106,
    "descripcion":"FRACTURA NO EXPUESTA DE CABEZA DE FÉMUR IZQUIERDO"
  },
  {
    "codigo":94632009,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE TIMO"
  },
  {
    "codigo":289405006,
    "descripcion":"SUTURA SAGITAL EN DIÁMETRO ANTEROPOSTERIOR"
  },
  {
    "codigo":1010301007,
    "descripcion":"TRASTORNO NEONATAL DEBIDO A OBESIDAD MATERNA"
  },
  {
    "codigo":92797009,
    "descripcion":"CARCINOMA IN SITU DE BORDE BERMELLÓN DE LABIO SUPERIOR"
  },
  {
    "codigo":1303378005,
    "descripcion":"FRACTURA ÓSEA DE FÉMUR DERECHO"
  },
  {
    "codigo":254802006,
    "descripcion":"NEVO MELANOCÍTICO DE LA UNIÓN DERMOEPIDÉRMICA DE LA PIEL"
  },
  {
    "codigo":58194007,
    "descripcion":"OTITIS MEDIA CRÓNICA SEROMUCINOSA"
  },
  {
    "codigo":189266009,
    "descripcion":"CARCINOMA IN SITU DE PARÉNQUIMA PULMONAR Y BRONQUIO DEL LÓBULO MEDIO"
  },
  {
    "codigo":447740001,
    "descripcion":"RETRASO DEL DESARROLLO FISIOLÓGICO"
  },
  {
    "codigo":1332476001,
    "descripcion":"HISTIOCITOSIS DE CÉLULAS DE LANGERHANS DISEMINADA DE HUESO"
  },
  {
    "codigo":185596005,
    "descripcion":"CONTROL DE TÍTULOS ANTIRRUBEÓLICOS - ANULADO"
  },
  {
    "codigo":282065004,
    "descripcion":"HEMATOMA DE ÍLEON"
  },
  {
    "codigo":249297006,
    "descripcion":"ESPASMO DE VEJIGA URINARIA"
  },
  {
    "codigo":1363409007,
    "descripcion":"NEOVASCULARIZACIÓN DE CUADRANTE INFERIOR DE ÁNGULO IRIDOCORNEAL"
  },
  {
    "codigo":1197734000,
    "descripcion":"PROCTALGIA CRÓNICA"
  },
  {
    "codigo":183761006,
    "descripcion":"CONSULTA DOMICILIARIA GINECOLÓGICA, REALIZADA"
  },
  {
    "codigo":247462002,
    "descripcion":"ESTRÍAS DE WICKHAM"
  },
  {
    "codigo":312998003,
    "descripcion":"OCLUSIÓN DE VENA RETINIANA CENTRAL - NO ISQUÉMICA"
  },
  {
    "codigo":868219001,
    "descripcion":"OCLUSIÓN DE PORCIÓN MEDIA DE ARTERIA CORONARIA DERECHA"
  },
  {
    "codigo":737147003,
    "descripcion":"INFLAMACIÓN CRÓNICA DE CAVIDAD MASTOIDEA"
  },
  {
    "codigo":81787004,
    "descripcion":"INFECCIÓN CAUSADA POR TYZZERIA"
  },
  {
    "codigo":212859008,
    "descripcion":"EFECTO TÓXICO DEL DIÓXIDO DE CARBONO"
  },
  {
    "codigo":704379009,
    "descripcion":"CONOCIMIENTO DEFICIENTE SOBRE COMPORTAMIENTO SEXUAL"
  },
  {
    "codigo":1163131009,
    "descripcion":"ABSCESO DE CEREBRO CAUSADO POR ASPERGILLUS"
  },
  {
    "codigo":407632003,
    "descripcion":"ESCALA DE DETERIORO GENERAL NIVEL 4 - DETERIORO COGNITIVO MODERADO"
  },
  {
    "codigo":211024005,
    "descripcion":"LESIONES SUPERFICIALES MÚLTIPLES EN LA CABEZA"
  },
  {
    "codigo":1259600007,
    "descripcion":"EXTRAVASACIÓN DE LÍQUIDO CEFALORRAQUÍDEO CRANEAL DEBIDA A INVASIÓN DE NEOPLASIA CRANEAL"
  },
  {
    "codigo":241957001,
    "descripcion":"ANGIOEDEMA-URTICARIA PRODUCIDO POR ALIMENTOS"
  },
  {
    "codigo":276560009,
    "descripcion":"DIABETES MELLITUS EN RECIÉN NACIDO PEQUEÑO PARA LA EDAD GESTACIONAL"
  },
  {
    "codigo":766245001,
    "descripcion":"TALIPES CALCANEOCAVO"
  },
  {
    "codigo":1290533007,
    "descripcion":"RADIOGRAFÍA DE PIERNA ANORMAL"
  },
  {
    "codigo":373029007,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTEROIDES ABSCESSUS"
  },
  {
    "codigo":305658000,
    "descripcion":"ATENDIDO POR UN MICROBIÓLOGO"
  },
  {
    "codigo":15669081000119103,
    "descripcion":"AUSENCIA CONGÉNITA DE MÚSCULO PECTORAL DERECHO"
  },
  {
    "codigo":240122006,
    "descripcion":"OSIFICACIÓN SECUNDARIA DE MÚSCULO"
  },
  {
    "codigo":677721000119103,
    "descripcion":"PERIVASCULITIS RETINIANA DE OJO IZQUIERDO"
  },
  {
    "codigo":1286863002,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE CIEGO Y\/O COLON Y\/O RECTO"
  },
  {
    "codigo":41679006,
    "descripcion":"SÍNDROME DE INFECCIÓN POR TOXOPLASMA, OTRAS INFECCIONES, RUBÉOLA, CITOMEGALOVIRUS Y HERPES SIMPLE"
  },
  {
    "codigo":236452000,
    "descripcion":"NEFRITIS TUBULOINTERSTICIAL CRÓNICA INDUCIDA POR FÁRMACO"
  },
  {
    "codigo":402127008,
    "descripcion":"BRUCELOSIS DE LA PIEL"
  },
  {
    "codigo":1186724002,
    "descripcion":"ENFERMEDAD CEREBRAL DE PEQUEÑO VASO AUTOSÓMICA DOMINANTE ASOCIADA AL GEN HTRA1"
  },
  {
    "codigo":367524008,
    "descripcion":"HIPOPLASIA DE GLÁNDULA TIROIDES"
  },
  {
    "codigo":234617003,
    "descripcion":"DEFICIENCIA DEL COMPLEMENTO 9"
  },
  {
    "codigo":201849003,
    "descripcion":"ARTROSIS SECUNDARIA LOCALIZADA DE REGIÓN DE HOMBRO"
  },
  {
    "codigo":300153005,
    "descripcion":"MEMBRANA TIMPÁNICA ERITEMATOSA BRILLANTE"
  },
  {
    "codigo":5241006,
    "descripcion":"PROLAPSO DEL PREPUCIO"
  },
  {
    "codigo":365689007,
    "descripcion":"HALLAZGO RELACIONADO CON CILINDROS EN EL EXAMEN MICROSCÓPICO DE ORINA"
  },
  {
    "codigo":1119353009,
    "descripcion":"ATAXIA CEREBELOSA CON MARCHA CUADRÚPEDA"
  },
  {
    "codigo":298318006,
    "descripcion":"PRUEBA TALÓN-ESPINILLA NORMAL"
  },
  {
    "codigo":722467000,
    "descripcion":"ENFERMEDAD RENAL CRÓNICA DEBIDA A PÉRDIDA TRAUMÁTICA DE RIÑÓN"
  },
  {
    "codigo":427555000,
    "descripcion":"GLOMERULONEFRITIS DEBIDA A GRANULOMATOSIS DE WEGENER CON POLIANGEÍTIS"
  },
  {
    "codigo":198179003,
    "descripcion":"ENFERMEDADES INFLAMATORIAS UTERINAS, EXCEPTO EN EL CUELLO UTERINO"
  },
  {
    "codigo":165411007,
    "descripcion":"HEMATÓCRITO DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":720632004,
    "descripcion":"MACROGIRIA BILATERAL CENTRAL"
  },
  {
    "codigo":1179384008,
    "descripcion":"HIPOTIROIDISMO CENTRAL ADQUIRIDO CAUSADO POR RADIACIÓN IONIZANTE"
  },
  {
    "codigo":391117001,
    "descripcion":"PRUEBA DE REVERSIBILIDAD A CORTICOSTEROIDE: NEGATIVA"
  },
  {
    "codigo":292813003,
    "descripcion":"REACCIÓN ADVERSA A UNDECENOATOS"
  },
  {
    "codigo":11847821000119101,
    "descripcion":"PICADURA DE INSECTO NO VENENOSO EN MEJILLA"
  },
  {
    "codigo":128973006,
    "descripcion":"HALLAZGO RELACIONADO CON EL ESTADO FISIOLÓGICO DEL PACIENTE"
  },
  {
    "codigo":225442000,
    "descripcion":"NO QUIERE PENSAR"
  },
  {
    "codigo":63437008,
    "descripcion":"ANOSODIAFORIA"
  },
  {
    "codigo":94370000,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA LARINGE"
  },
  {
    "codigo":290978005,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR FENSUXIMIDA"
  },
  {
    "codigo":127138005,
    "descripcion":"LINFADENOPATÍA PANCREÁTICA INFERIOR"
  },
  {
    "codigo":1208482007,
    "descripcion":"ARTROGRIPOSIS DISTAL TIPO 10"
  },
  {
    "codigo":289143000,
    "descripcion":"HALLAZGO RELACIONADO CON AVERSIÓN Y DESEO VEHEMENTE DE ALIMENTOS"
  },
  {
    "codigo":420215000,
    "descripcion":"MATERIAL DE LENTE EN CÁMARA ANTERIOR"
  },
  {
    "codigo":92535002,
    "descripcion":"CARCINOMA IN SITU DE LA PARED ANTERIOR DE LA NASOFARINGE"
  },
  {
    "codigo":715127003,
    "descripcion":"AYUDA MÍNIMA PARA PASAR DE LA SILLA A LA CAMA"
  },
  {
    "codigo":189004003,
    "descripcion":"LIPOMA DE PIERNA"
  },
  {
    "codigo":254540004,
    "descripcion":"CARCINOMA IN SITU DE LA PORCIÓN TORÁCICA DEL ESÓFAGO"
  },
  {
    "codigo":1335884003,
    "descripcion":"SINOSTOSIS RADIOCUBITAL CONGÉNITA DE AMBOS ANTEBRAZOS"
  },
  {
    "codigo":90700008,
    "descripcion":"PROMISCUIDAD PATOLÓGICA"
  },
  {
    "codigo":56097005,
    "descripcion":"MIGRAÑA SIN AURA"
  },
  {
    "codigo":449313005,
    "descripcion":"DOLOR FACIAL REFERIDO"
  },
  {
    "codigo":711457008,
    "descripcion":"ÁNGULO DE PLANO MANDIBULAR HIPODIVERGENTE"
  },
  {
    "codigo":283638003,
    "descripcion":"HERIDA POR PINCHAZO DE AGUJA EN EL TOBILLO"
  },
  {
    "codigo":250870006,
    "descripcion":"RESPIRADOR - HALLAZGO"
  },
  {
    "codigo":185334006,
    "descripcion":"PACIENTE DE VACACIONES"
  },
  {
    "codigo":609483006,
    "descripcion":"INTERRUPCIÓN INDUCIDA DEL EMBARAZO COMPLICADA POR SALPINGITIS"
  },
  {
    "codigo":871627006,
    "descripcion":"AURÍCULA COMÚN CON UNIÓN AURICULOVENTRICULAR COMÚN"
  },
  {
    "codigo":1363147008,
    "descripcion":"ASTILLA EN ANTEBRAZO"
  },
  {
    "codigo":247200005,
    "descripcion":"ATROFIA DE LA COROIDES"
  },
  {
    "codigo":352551000119106,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE TESTÍCULO IZQUIERDO DESCENDIDO"
  },
  {
    "codigo":212597004,
    "descripcion":"INTOXICACIÓN CON FENACETINA"
  },
  {
    "codigo":441973005,
    "descripcion":"MORFOLOGÍA DE ERITROCITO ANORMAL"
  },
  {
    "codigo":15999271000119108,
    "descripcion":"CICATRIZ DE CÓRNEA DE OJO DERECHO"
  },
  {
    "codigo":14154001,
    "descripcion":"INTOXICACIÓN POR PILOCARPINA"
  },
  {
    "codigo":1259338003,
    "descripcion":"CARCINOMA PRIMARIO DE SURCO LABIAL SUPERIOR"
  },
  {
    "codigo":767818004,
    "descripcion":"NEOPLASIA DE SACRO"
  },
  {
    "codigo":15727041000119103,
    "descripcion":"LUXACIÓN DE RODILLA DERECHA DEBIDA A DISPLASIA CONGÉNITA"
  },
  {
    "codigo":866122003,
    "descripcion":"INFECCIÓN DE INTESTINO GRUESO CAUSADA POR ENTAMOEBA HISTOLYTICA"
  },
  {
    "codigo":1193802004,
    "descripcion":"ENTERITIS POR ENTAMOEBA HISTOLYTICA"
  },
  {
    "codigo":210762009,
    "descripcion":"AMPUTACIÓN TRAUMÁTICA A NIVEL DE LA CADERA"
  },
  {
    "codigo":208927001,
    "descripcion":"DESGARRO AGUDO DE MENISCO EXTERNO POR SEPARACIÓN HORIZONTAL"
  },
  {
    "codigo":733215003,
    "descripcion":"MORDEDURA ABIERTA DE TÓRAX"
  },
  {
    "codigo":405535005,
    "descripcion":"EPISODIO ADVERSO QUE OCASIONA LA MUERTE"
  },
  {
    "codigo":700447005,
    "descripcion":"COLPOSCOPIA NORMAL"
  },
  {
    "codigo":76020000,
    "descripcion":"PELVIS ESPONDILOLISTÉSICA"
  },
  {
    "codigo":1222900008,
    "descripcion":"CAPACIDAD PARA PATEAR CON PIERNA"
  },
  {
    "codigo":8649001,
    "descripcion":"ANOMALÍA CONGÉNITA DE LA CAJA TORÁCICA"
  },
  {
    "codigo":403700009,
    "descripcion":"RESULTADO NO SATISFACTORIO DE CIRUGÍA CON LÁSER"
  },
  {
    "codigo":762313006,
    "descripcion":"VESTIBULOPATÍA IZQUIERDA POSTERIOR A INTERVENCIÓN MÉDICA"
  },
  {
    "codigo":238025006,
    "descripcion":"GANGLIOSIDOSIS GM1"
  },
  {
    "codigo":10949211000119102,
    "descripcion":"HERIDA ABIERTA DE MUÑECA IZQUIERDA DEBIDA A MORDEDURA DE PERRO"
  },
  {
    "codigo":74185008,
    "descripcion":"HIPONATREMIA CON DEPLECIÓN DEL LÍQUIDO EXTRACELULAR"
  },
  {
    "codigo":268958005,
    "descripcion":"ESCASA INTROSPECCIÓN EN EL CUADRO NEURÓTICO"
  },
  {
    "codigo":301726009,
    "descripcion":"INCAPAZ DE REALIZAR ACTIVIDADES LABORALES"
  },
  {
    "codigo":365427003,
    "descripcion":"MEDICIÓN DEL SEMEN - HALLAZGO"
  },
  {
    "codigo":299891004,
    "descripcion":"RESPUESTA PLANTAR EXTENSORA IZQUIERDA"
  },
  {
    "codigo":381531000119104,
    "descripcion":"INFECCIÓN POSTERIOR A CISTOSTOMÍA"
  },
  {
    "codigo":725875005,
    "descripcion":"SIN PARIENTES CERCANOS"
  },
  {
    "codigo":724040000,
    "descripcion":"DEFICIENCIA DE S-ADENOSILHOMOCISTEÍNA HIDROLASA"
  },
  {
    "codigo":35912001,
    "descripcion":"AMINOACIDURIA"
  },
  {
    "codigo":396360001,
    "descripcion":"LOCALIZACIÓN TUMORAL, NO APLICABLE"
  },
  {
    "codigo":199752003,
    "descripcion":"TRABAJO DE PARTO OBSTRUIDO POR PRESENTACIÓN DE CARA"
  },
  {
    "codigo":298056000,
    "descripcion":"LACERACIÓN EN COLGAJO DE PIERNA"
  },
  {
    "codigo":3144005,
    "descripcion":"PLEURESÍA ESTAFILOCÓCICA"
  },
  {
    "codigo":296221001,
    "descripcion":"SOBREDOSIS DE TIETILPERAZINA"
  },
  {
    "codigo":1344797002,
    "descripcion":"OSTEOCONDROSIS JUVENIL DE TIBIA PROXIMAL"
  },
  {
    "codigo":427293006,
    "descripcion":"DOLOR IRRADIADO AL LADO IZQUIERDO DEL PECHO"
  },
  {
    "codigo":722205008,
    "descripcion":"QUERATODERMIA PALMOPLANTAR, TIPO NAGASHIMA"
  },
  {
    "codigo":230685009,
    "descripcion":"MIASTENIA GRAVE ASOCIADA CON TIMOMA"
  },
  {
    "codigo":1179122001,
    "descripcion":"AMBIENTE SEGURO"
  },
  {
    "codigo":63175003,
    "descripcion":"MASTOCITOSIS EXTRACUTÁNEA LOCALIZADA"
  },
  {
    "codigo":718535005,
    "descripcion":"ALERGIA A PITAVASTATINA"
  },
  {
    "codigo":423623006,
    "descripcion":"SECRECIÓN CONJUNTIVAL MUCOPURULENTA"
  },
  {
    "codigo":292551008,
    "descripcion":"REACCIÓN ADVERSA AL TILOXAPOL"
  },
  {
    "codigo":94108003,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL NERVIO TRIGÉMINO"
  },
  {
    "codigo":716700003,
    "descripcion":"EPIDERMÓLISIS BULLOSA SIMPLE CON ERITEMA MIGRATORIO CIRCINADO"
  },
  {
    "codigo":126876006,
    "descripcion":"NEOPLASIA DEL TEJIDO MESOTELIAL DEL PERITONEO"
  },
  {
    "codigo":288881000,
    "descripcion":"NO BEBE A SORBOS"
  },
  {
    "codigo":28572009,
    "descripcion":"GONORREA CRÓNICA DE LAS VÍAS GENITOURINARIAS"
  },
  {
    "codigo":290716008,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR CISPLATINO"
  },
  {
    "codigo":92273004,
    "descripcion":"NEOPLASIA BENIGNA DE LAS GLÁNDULAS PARAURETRALES"
  },
  {
    "codigo":911000119102,
    "descripcion":"PRÓTESIS DE ARTICULACIÓN DE RODILLA PRESENTE"
  },
  {
    "codigo":385350001,
    "descripcion":"REVERSIBILIDAD DE LA ESPIROMETRÍA - HALLAZGO"
  },
  {
    "codigo":450886002,
    "descripcion":"SÍNDROME DE ENCEFALOPATÍA POSTERIOR REVERSIBLE"
  },
  {
    "codigo":287046004,
    "descripcion":"DOLOR EN EL BRAZO DERECHO"
  },
  {
    "codigo":713030005,
    "descripcion":"DISECCIÓN CRÓNICA DE AORTA TORÁCICA"
  },
  {
    "codigo":88603000,
    "descripcion":"INTOXICACIÓN POR PTERONIA PALLENS"
  },
  {
    "codigo":285211004,
    "descripcion":"CAPAZ DE RECORDAR UN NÚMERO DE CINCO DÍGITOS DESPUÉS DE CINCO MINUTOS"
  },
  {
    "codigo":840432000,
    "descripcion":"INFECCIÓN DEL SISTEMA NERVIOSO CENTRAL CAUSADA POR PARACOCCIDIOIDES BRASILIENSIS"
  },
  {
    "codigo":283376000,
    "descripcion":"LACERACIÓN DE LA MAMA"
  },
  {
    "codigo":414448007,
    "descripcion":"IDENTIFICADO COMO DE ALTO RIESGO PARA INMUNIZACIÓN POR VIAJE"
  },
  {
    "codigo":1197747005,
    "descripcion":"LAMINOPATÍA LIPODISTRÓFICA GRAVE AUTOSÓMICA SEMIDOMINANTE"
  },
  {
    "codigo":707525005,
    "descripcion":"INFECCIÓN POR VIBRIO CHOLERAE NO-O1 Y NO-O139"
  },
  {
    "codigo":52165006,
    "descripcion":"ENFERMEDAD DE NIEMANN - PICK TIPO A"
  },
  {
    "codigo":248773007,
    "descripcion":"NO PUEDE LOGRAR UNA ERECCIÓN"
  },
  {
    "codigo":302121000119102,
    "descripcion":"OSTEOCONDROSIS DEL ADULTO DE COLUMNA VERTEBRAL DORSAL"
  },
  {
    "codigo":609221008,
    "descripcion":"DISCINESIA CINESIGÉNICA PAROXÍSTICA"
  },
  {
    "codigo":115866002,
    "descripcion":"FENOTIPO DE GRUPO SANGUÍNEO CHIDO - RODGERS"
  },
  {
    "codigo":1295514004,
    "descripcion":"HIPERTENSIÓN OCULAR DE OJO IZQUIERDO DEBIDA A SÍNDROME SISTÉMICO"
  },
  {
    "codigo":246938006,
    "descripcion":"DELLEN DE LA CÓRNEA"
  },
  {
    "codigo":17562007,
    "descripcion":"QUEMADURA PROFUNDA DE TERCER GRADO DEL OÍDO"
  },
  {
    "codigo":310639000,
    "descripcion":"FÍSTULA POSQUIRÚRGICA DE HERIDA"
  },
  {
    "codigo":771226008,
    "descripcion":"QUEMADURA PROFUNDA DE TERCER GRADO DE ABDOMEN"
  },
  {
    "codigo":50330009,
    "descripcion":"TRASTORNO DEL SISTEMA NERVIOSO SIMPÁTICO"
  },
  {
    "codigo":212335005,
    "descripcion":"LESIÓN DE NERVIO PLANTAR INTERNO"
  },
  {
    "codigo":703855007,
    "descripcion":"STREPTOCOCCUS ANGINOSUS O STREPTOCOCCUS INTERMEDIUS"
  },
  {
    "codigo":441711008,
    "descripcion":"DOLOR PSICÓGENO CRÓNICO"
  },
  {
    "codigo":210500001,
    "descripcion":"HERIDAS ABIERTAS MÚLTIPLES DE BRAZO"
  },
  {
    "codigo":15703081000119106,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE TENDÓN FLEXOR DE MUÑECA IZQUIERDA"
  },
  {
    "codigo":208665005,
    "descripcion":"FRACTURA EXPUESTA DE TOBILLO, BIMALEOLAR, FRACTURA PERONEA SUPERIOR"
  },
  {
    "codigo":77593006,
    "descripcion":"BRONQUIECTASIA CONGÉNITA"
  },
  {
    "codigo":732953008,
    "descripcion":"SÍNDROME DE DISPLASIA ECTODÉRMICA Y SORDERA NEUROSENSORIAL"
  },
  {
    "codigo":405273008,
    "descripcion":"ESTADO DE ÁNIMO MANÍACO"
  },
  {
    "codigo":403438007,
    "descripcion":"HOYUELOS CONGÉNITOS EN LABIO INFERIOR"
  },
  {
    "codigo":763886009,
    "descripcion":"SÍNDROME DE DISPLASIA ESPONDILOPERIFÉRICA CON CÚBITO CORTO"
  },
  {
    "codigo":237763005,
    "descripcion":"INSUFICIENCIA SUPRARRENAL IATROGÉNICA"
  },
  {
    "codigo":203160001,
    "descripcion":"OSTEOMIELITIS AGUDA DE SACRO"
  },
  {
    "codigo":39320004,
    "descripcion":"DESVIACIÓN PERONEA"
  },
  {
    "codigo":301464007,
    "descripcion":"DIFICULTAD PARA REALIZAR ACTIVIDADES EDUCATIVAS"
  },
  {
    "codigo":6552007,
    "descripcion":"FÓRMULA SIN LACTOSA PARA LACTANTES"
  },
  {
    "codigo":103021001,
    "descripcion":"ADRENARCA PREMATURA"
  },
  {
    "codigo":235928009,
    "descripcion":"ATROFIA DE LA VÍA BILIAR"
  },
  {
    "codigo":234093002,
    "descripcion":"LINFADENITIS FILARIÁSICA CRÓNICA POR BRUGIA MALAYI"
  },
  {
    "codigo":365165001,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA ATARSE LOS CORDONES"
  },
  {
    "codigo":201325006,
    "descripcion":"QUISTE DERMOIDE DE PIEL"
  },
  {
    "codigo":397933008,
    "descripcion":"FALLA\/ERROR DE EQUIPO"
  },
  {
    "codigo":461634000,
    "descripcion":"ANOMALÍA INTRATORÁCICA DEBIDA A INTERRUPCIÓN DEL CAYADO AÓRTICO"
  },
  {
    "codigo":232258001,
    "descripcion":"ATELECTASIA DE MEMBRANA TIMPÁNICA"
  },
  {
    "codigo":428866004,
    "descripcion":"QUISTE DE SENO MAXILAR"
  },
  {
    "codigo":363330008,
    "descripcion":"COMPLICACIÓN TRAUMÁTICA DE PROCEDIMIENTO"
  },
  {
    "codigo":164887001,
    "descripcion":"ARRITMIA SUPRAVENTRICULAR EN EL ELECTROCARDIOGRAMA"
  },
  {
    "codigo":263191003,
    "descripcion":"FRACTURA DE CUELLO DEL HÚMERO"
  },
  {
    "codigo":230423006,
    "descripcion":"SÍNDROME DE UNVERRICHT-LUNDBORG"
  },
  {
    "codigo":359660000,
    "descripcion":"COLITIS IDIOPÁTICA"
  },
  {
    "codigo":331101000119105,
    "descripcion":"COROIDITIS POR TOXOPLASMA"
  },
  {
    "codigo":423361002,
    "descripcion":"LIPOMA DE LA MÉDULA ESPINAL DORSAL"
  },
  {
    "codigo":95681002,
    "descripcion":"FIBROSIS DE LA CÁMARA ANTERIOR DEL OJO"
  },
  {
    "codigo":292289004,
    "descripcion":"REACCIÓN ADVERSA A LA DESIPRAMINA"
  },
  {
    "codigo":716438000,
    "descripcion":"CAPAZ DE RECONOCER LA NECESIDAD DE CUIDADO EN ÁREA DE PRESIÓN"
  },
  {
    "codigo":126614002,
    "descripcion":"NEOPLASIA DE PARTES BLANDAS DE REGIÓN INGUINAL"
  },
  {
    "codigo":93846004,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL YEYUNO"
  },
  {
    "codigo":290454007,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR CÁSCARA SAGRADA"
  },
  {
    "codigo":1339030007,
    "descripcion":"PROCTITIS POR NEISSERIA GONORRHOEAE"
  },
  {
    "codigo":26475003,
    "descripcion":"PELVIS CIFOESCOLIORRAQUÍTICA"
  },
  {
    "codigo":92011004,
    "descripcion":"NEOPLASIA BENIGNA DE VASO SANGUÍNEO DE HOMBRO"
  },
  {
    "codigo":288619005,
    "descripcion":"NO EMPLEA CONSTRUCCIONES GRAMATICALES"
  },
  {
    "codigo":4891000175102,
    "descripcion":"ESCALERAS EXTERNAS EN EL HOGAR"
  },
  {
    "codigo":254016000,
    "descripcion":"FISURA FACIAL INFRAORBITARIA - FISURA DE TESSIER TIPO 4"
  },
  {
    "codigo":286784005,
    "descripcion":"BAJO NIVEL DE SUGESTIONABILIDAD"
  },
  {
    "codigo":90176007,
    "descripcion":"AMIGDALITIS"
  },
  {
    "codigo":1237056009,
    "descripcion":"METÁSTASIS DE CARCINOMA DE CUADRANTE INFERIOR INTERNO DE MAMA"
  },
  {
    "codigo":13490001000004105,
    "descripcion":"ACIDOSIS D-LÁCTICA"
  },
  {
    "codigo":14770001000004107,
    "descripcion":"ABSCESO DE ABDOMEN CAUSADO POR NOCARDIA"
  },
  {
    "codigo":12511000132108,
    "descripcion":"PROTEINURIA PERSISTENTE"
  },
  {
    "codigo":219413004,
    "descripcion":"HERIDA DE GUERRA POR APLASTAMIENTO PRODUCIDO POR AVIÓN ESTRELLADO"
  },
  {
    "codigo":283114001,
    "descripcion":"AMPOLLA TRAUMÁTICA SUPERFICIAL DE CABEZA Y CUELLO"
  },
  {
    "codigo":10626551000119109,
    "descripcion":"CARBUNCO DE MANO IZQUIERDA"
  },
  {
    "codigo":414186007,
    "descripcion":"ENCUENTRO FALLIDO - ACCESO AL MÉDICO DENEGADO"
  },
  {
    "codigo":248511000,
    "descripcion":"NÓDULOS ESTROMALES DE IRIS"
  },
  {
    "codigo":281279002,
    "descripcion":"ESPÉCIMEN COAGULADO"
  },
  {
    "codigo":838335003,
    "descripcion":"PICADURA DE ARTRÓPODO CAUSADA POR ATRAX"
  },
  {
    "codigo":445119005,
    "descripcion":"SÍNDROME NEFRÓTICO DE LA INFANCIA SENSIBLE A ESTEROIDES"
  },
  {
    "codigo":17300000,
    "descripcion":"SÍNDROME CERVICOCRANEAL"
  },
  {
    "codigo":1196948002,
    "descripcion":"DEFECTO DE GEN DE ENSAMBLAJE DE COMPLEJO I DE CADENA RESPIRATORIA MITOCONDRIAL"
  },
  {
    "codigo":1295252004,
    "descripcion":"SINOVITIS CRÓNICA DE CODO DEBIDA A HEMARTROSIS"
  },
  {
    "codigo":1162345000,
    "descripcion":"OSIFICACIÓN DE SUBPERIOSTIO DEBIDA A LESIÓN TRAUMÁTICA Y POSTERIOR A ELLA"
  },
  {
    "codigo":408681003,
    "descripcion":"LEGIONELOSIS ASOCIADA CON LA ATENCIÓN MÉDICA"
  },
  {
    "codigo":48233004,
    "descripcion":"LESIÓN TRAUMÁTICA DE NERVIO ÓPTICO"
  },
  {
    "codigo":212073003,
    "descripcion":"QUEMADURA QUE COMPROMETE 40-49 PORCIENTO DE LA SUPERFICIE DEL CUERPO, CON QUEMADURA DE ESPESOR COMPLETO QUE AFECTA 30-39 PORCIENTO DE LA SUPERFICIE CORPORAL"
  },
  {
    "codigo":277609007,
    "descripcion":"ENFERMEDAD DE HODGKIN A PREDOMINIO LINFOCÍTICO - DIFUSA"
  },
  {
    "codigo":13630003,
    "descripcion":"AUSENCIA CONGÉNITA DEL LÓBULO HEPÁTICO"
  },
  {
    "codigo":111934004,
    "descripcion":"INFESTACIÓN CAUSADA POR IXODIDAE"
  },
  {
    "codigo":275774008,
    "descripcion":"PARAQUAT EN ORINA"
  },
  {
    "codigo":243006008,
    "descripcion":"LESIÓN POR PROYECTILES DE ESCOPETA"
  },
  {
    "codigo":44563002,
    "descripcion":"INFESTACIÓN CAUSADA POR SARCOPTES SCABIEI VARIEDAD BOVIS"
  },
  {
    "codigo":110099004,
    "descripcion":"LACERACIÓN SIMPLE DE MUCOSA YUGAL"
  },
  {
    "codigo":208403005,
    "descripcion":"FRACTURA NO EXPUESTA DE PRIMER METACARPIANO"
  },
  {
    "codigo":47191000087100,
    "descripcion":"DISTENSIÓN DE TENDÓN DE MÚSCULO PSOAS DERECHO"
  },
  {
    "codigo":54871000087103,
    "descripcion":"CAPAZ DE RECOSTARSE SIN AYUDA"
  },
  {
    "codigo":75496000,
    "descripcion":"INTOXICACIÓN POR PROCAINAMIDA"
  },
  {
    "codigo":39511000087105,
    "descripcion":"DISTENSIÓN DE TENDÓN DE MÚSCULO DE MITAD IZQUIERDA DE PARED ANTERIOR DE TÓRAX"
  },
  {
    "codigo":1156840002,
    "descripcion":"NEUROPATÍA MOTORA DISTAL HEREDITARIA LIGADA AL CROMOSOMA X"
  },
  {
    "codigo":698088001,
    "descripcion":"REACCIÓN ADVERSA CAUSADA POR DIPIRONA"
  },
  {
    "codigo":304872004,
    "descripcion":"APEGO EVITATIVO MIXTO"
  },
  {
    "codigo":763624007,
    "descripcion":"SINDACTILIA TIPO 6"
  },
  {
    "codigo":403176008,
    "descripcion":"EDEMA AGUDO-SÍNDROME DE DISTENSIÓN CUTÁNEA"
  },
  {
    "codigo":206568009,
    "descripcion":"DIFICULTAD PARA EL AMAMANTAMIENTO"
  },
  {
    "codigo":1351613000,
    "descripcion":"INMUNODEFICIENCIA COMBINADA SEVERA DEBIDA A DEFICIENCIA DE BCL11B"
  },
  {
    "codigo":237501007,
    "descripcion":"TIROTOXICOSIS POR TIROIDITIS AGUDA"
  },
  {
    "codigo":170130002,
    "descripcion":"EXAMEN ANORMAL DE NIÑO DE 8-9 MESES DE EDAD - EN TRATAMIENTO"
  },
  {
    "codigo":399506006,
    "descripcion":"TUMOR MULTIFOCAL"
  },
  {
    "codigo":301202006,
    "descripcion":"PROBLEMA DE SENOS PARANASALES"
  },
  {
    "codigo":299367000,
    "descripcion":"ARTICULACIÓN DE LA RODILLA ESTABLE"
  },
  {
    "codigo":39058009,
    "descripcion":"NEUROPATÍA DE PLEXO RADICULAR LUMBOSACRO DEBIDA A DIABETES MELLITUS"
  },
  {
    "codigo":266599000,
    "descripcion":"DISMENORREA"
  },
  {
    "codigo":235666009,
    "descripcion":"SÍNDROME DE VACIAMIENTO RÁPIDO TEMPRANO"
  },
  {
    "codigo":364903004,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD DE CONTROLAR LA POSICIÓN"
  },
  {
    "codigo":1251474009,
    "descripcion":"METÁSTASIS DE OSTEOSARCOMA EN VÉRTEBRA"
  },
  {
    "codigo":37223007,
    "descripcion":"CELULITIS DEL CUELLO"
  },
  {
    "codigo":233831007,
    "descripcion":"INFARTO AGUDO DE ONDA Q - INFEROLATERAL"
  },
  {
    "codigo":789052003,
    "descripcion":"MICOSIS SUBCUTÁNEA"
  },
  {
    "codigo":307141000119106,
    "descripcion":"ARTRITIS ENTEROPÁTICA DE ARTICULACIÓN GLENOHUMERAL IZQUIERDA"
  },
  {
    "codigo":230161000,
    "descripcion":"ENCEFALITIS VIRAL AGUDA"
  },
  {
    "codigo":231996009,
    "descripcion":"ESCLEROSIS COROIDEA AREOLAR CENTRAL"
  },
  {
    "codigo":33553000,
    "descripcion":"PERSONA VIUDA"
  },
  {
    "codigo":16009311000119101,
    "descripcion":"EMBOLIA ATEROMATOSA DE ARTERIA DE AMBOS MIEMBROS SUPERIORES"
  },
  {
    "codigo":295697005,
    "descripcion":"SOBREDOSIS DE ÓXIDO MERCÚRICO"
  },
  {
    "codigo":721681005,
    "descripcion":"COLITIS CAUSADA POR BACTERIA"
  },
  {
    "codigo":11857861000119108,
    "descripcion":"RUPTURA DE TENDÓN DE MÚSCULO PLANTAR IZQUIERDO"
  },
  {
    "codigo":12240991000119102,
    "descripcion":"CARCINOMA ESCAMOCELULAR DE PULMÓN DERECHO"
  },
  {
    "codigo":426769009,
    "descripcion":"RECIBIÓ EDUCACIÓN DE GRADO"
  },
  {
    "codigo":392166002,
    "descripcion":"PALIDEZ DE ANILLO NEURORRETINIANO"
  },
  {
    "codigo":15953861000119109,
    "descripcion":"FIBROESCLEROSIS DE AMBAS MAMAS"
  },
  {
    "codigo":457702006,
    "descripcion":"TRASTORNO DE PRÓTESIS DE VÁLVULA AÓRTICA"
  },
  {
    "codigo":228326007,
    "descripcion":"INGESTIÓN COMPULSIVA DE ALCOHOL"
  },
  {
    "codigo":719846009,
    "descripcion":"NO SE OBSERVA INFILTRACIÓN ADIPOSA"
  },
  {
    "codigo":423099001,
    "descripcion":"HIDROCISTOMA APOCRINO DE PÁRPADO"
  },
  {
    "codigo":690271000119104,
    "descripcion":"HEMIPLEJÍA DE LADO NO DOMINANTE DEBIDA A ACCIDENTE CEREBROVASCULAR EMBÓLICO Y POSTERIOR A ÉL"
  },
  {
    "codigo":128187005,
    "descripcion":"CEFALEA VASCULAR"
  },
  {
    "codigo":440584001,
    "descripcion":"INCAPAZ DE REALIZAR ACTIVIDADES LABORALES EN FORMA PERMANENTE DEBIDO A AFECCIÓN MÉDICA"
  },
  {
    "codigo":93584000,
    "descripcion":"OSIFICACIÓN INCOMPLETA DE HÚMERO"
  },
  {
    "codigo":10684511000119105,
    "descripcion":"NÓDULO DEL TEJIDO CELULAR SUBCUTÁNEO DE LA MANO DERECHA"
  },
  {
    "codigo":188040008,
    "descripcion":"MELANOMA MALIGNO DE LA FRENTE"
  },
  {
    "codigo":292027009,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR ESTREPTOQUINASA"
  },
  {
    "codigo":191888003,
    "descripcion":"ADICCIÓN AL TABACO, EPISÓDICA"
  },
  {
    "codigo":1240464006,
    "descripcion":"PSORIASIS FOLICULAR"
  },
  {
    "codigo":16228601000119100,
    "descripcion":"DERRAME INTERMITENTE DE ARTICULACIÓN DE TOBILLO DERECHO"
  },
  {
    "codigo":288357000,
    "descripcion":"INCAPAZ DE LANZAR OBJETOS"
  },
  {
    "codigo":124517001,
    "descripcion":"DEFICIENCIA DE ALANTOINASA"
  },
  {
    "codigo":386661006,
    "descripcion":"FIEBRE"
  },
  {
    "codigo":778042000,
    "descripcion":"SÍNDROME DE HIPOPLASIA FOVEAL CON CATARATA PRESENIL"
  },
  {
    "codigo":253754004,
    "descripcion":"QUISTE DE LENGUA"
  },
  {
    "codigo":8441000119103,
    "descripcion":"TRANSLOCACIÓN AUTOSÓMICA EQUILIBRADA EN UN INDIVIDUO NORMAL"
  },
  {
    "codigo":1269562006,
    "descripcion":"CON MAYOR RIESGO DE TRASTORNO POSPARTO"
  },
  {
    "codigo":89914006,
    "descripcion":"FORMACIÓN ÓSEA ENDOCONDRAL NORMAL"
  },
  {
    "codigo":450362008,
    "descripcion":"HEMORRAGIA EN ESPACIO SUBARACNOIDEO DEL NEUROEJE"
  },
  {
    "codigo":286522009,
    "descripcion":"LLEVA COMIDAS PREPARADAS"
  },
  {
    "codigo":22543002,
    "descripcion":"INTOXICACIÓN POR TETRADIMIA GLABRATA"
  },
  {
    "codigo":712506009,
    "descripcion":"DESPRENDIMIENTO DE RETINA REGMATÓGENO CON RUPTURA ÚNICA"
  },
  {
    "codigo":1234959006,
    "descripcion":"TRASTORNO FETAL DEBIDO A TRASTORNO DE CORDÓN UMBILICAL"
  },
  {
    "codigo":90361000119105,
    "descripcion":"INSOMNIO CONDUCTUAL INFANTIL"
  },
  {
    "codigo":1003748001,
    "descripcion":"CONTRACTURA EN FLEXIÓN DE ARTICULACIÓN CARPOMETACARPIANA DE PULGAR"
  },
  {
    "codigo":250084002,
    "descripcion":"CALAMBRE EN LA PANTORRILLA"
  },
  {
    "codigo":413924001,
    "descripcion":"ALTERACIÓN VISUAL CORTICAL"
  },
  {
    "codigo":53476006,
    "descripcion":"HEPATITIS POR RADIACIÓN"
  },
  {
    "codigo":248249000,
    "descripcion":"AXILAS SUDOROSAS"
  },
  {
    "codigo":281017002,
    "descripcion":"DIFICULTAD PARA INICIAR EL VACIAMIENTO VESICAL"
  },
  {
    "codigo":84409004,
    "descripcion":"BRONQUITIS CRÓNICA FÉTIDA"
  },
  {
    "codigo":1231289006,
    "descripcion":"ANOMALÍA CONGÉNITA DE EXTREMIDAD INFERIOR DERECHA"
  },
  {
    "codigo":770702001,
    "descripcion":"REACCIÓN ADVERSA A PRODUCTOS DEL FACTOR VII ACTIVADO"
  },
  {
    "codigo":17038008,
    "descripcion":"TEMPERATURA AUMENTADA DE LA PIEL"
  },
  {
    "codigo":15203004,
    "descripcion":"PÉRDIDA VISUAL SÚBITA"
  },
  {
    "codigo":15628691000119105,
    "descripcion":"DISTROFIA PSEUDOINFLAMATORIA DE SORSBY DE FONDO DE OJO IZQUIERDO"
  },
  {
    "codigo":1260387009,
    "descripcion":"HEMICOREA DEBIDA A TRAUMATISMO CRANEOENCEFÁLICO"
  },
  {
    "codigo":703331008,
    "descripcion":"MALFORMACIÓN ARTERIOVENOSA DE MIEMBRO"
  },
  {
    "codigo":767032001,
    "descripcion":"MACROSTOMÍA CONGÉNITA DE LADO DERECHO DE LA BOCA"
  },
  {
    "codigo":431000124102,
    "descripcion":"LUGAR DE ACCESO PARA HEMODIÁLISIS NO PERMEABLE"
  },
  {
    "codigo":373816006,
    "descripcion":"SIN TRATAMIENTO ONCOLÓGICO - COMORBILIDAD SIGNIFICATIVA"
  },
  {
    "codigo":1356856009,
    "descripcion":"SÍNDROME DE SÓLO CÉLULAS DE SERTOLI"
  },
  {
    "codigo":109837002,
    "descripcion":"NEOPLASIA MALIGNA SUPERPUESTA DEL INTESTINO DELGADO"
  },
  {
    "codigo":371981004,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE LA COMISURA LABIAL"
  },
  {
    "codigo":77069005,
    "descripcion":"SIGNO DEL PSOAS"
  },
  {
    "codigo":1287650000,
    "descripcion":"DEFORMIDAD EN VALGO DE DEDO GORDO DE PIE IZQUIERDO"
  },
  {
    "codigo":765197008,
    "descripcion":"FORMA SINTOMÁTICA DE DISTROFIA MUSCULAR DE DUCHENNE Y BECKER EN PORTADORA DE SEXO FEMENINO"
  },
  {
    "codigo":1254882002,
    "descripcion":"COMPORTAMIENTO COMPULSIVO DE MORDERSE LOS NUDILLOS"
  },
  {
    "codigo":10850861000119103,
    "descripcion":"ASPIRACIÓN DE CONTENIDO GÁSTRICO HACIA FARINGE"
  },
  {
    "codigo":402914005,
    "descripcion":"QUISTES EPIDERMOIDES PLANTARES CAUSADOS POR VIRUS DEL PAPILOMA HUMANO 60"
  },
  {
    "codigo":42466007,
    "descripcion":"BORRAMIENTO CERVICAL, 70%"
  },
  {
    "codigo":237239003,
    "descripcion":"EMBARAZO DE BAJO RIESGO"
  },
  {
    "codigo":827063004,
    "descripcion":"REFLEJOS TRICIPITALES DESIGUALES"
  },
  {
    "codigo":106167005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CONSCIENCIA"
  },
  {
    "codigo":1187511005,
    "descripcion":"FORMA NEONATAL DE DEFICIENCIA DE CARNITINA PALMITOILTRANSFERASA II"
  },
  {
    "codigo":1351351007,
    "descripcion":"INMUNODEFICIENCIA POR EXPRESIÓN DEFECTUOSA DE LA CLASE I DEL COMPLEJO MAYOR DE HISTOCOMPATIBILIDAD DEBIDA A MUTACIÓN DE BETA-2-MICROGLOBULINA"
  },
  {
    "codigo":366476000,
    "descripcion":"HALLAZGO RELACIONADO CON LA AMPLITUD DE MOVIMIENTO ACTIVO DE EXTENSIÓN DE HOMBRO"
  },
  {
    "codigo":40631009,
    "descripcion":"DESVIACIÓN OBLICUA"
  },
  {
    "codigo":268172000,
    "descripcion":"OREJA DISPLÁSICA"
  },
  {
    "codigo":399244003,
    "descripcion":"TRASTORNO DE LA HIPÓFISIS"
  },
  {
    "codigo":300940006,
    "descripcion":"ÓRBITA OCULAR INFECTADA"
  },
  {
    "codigo":169868009,
    "descripcion":"PESO DEL RECIÉN NACIDO ENTRE 4400 - 4499 G"
  },
  {
    "codigo":299105001,
    "descripcion":"AMPLITUD DE ADUCCIÓN PASIVA DE DEDO DE LA MANO DISMINUIDA"
  },
  {
    "codigo":830003005,
    "descripcion":"VISUALIZACIÓN INADECUADA DE FONDO DE OJO"
  },
  {
    "codigo":266337001,
    "descripcion":"EPIGLOTITIS AGUDA NO ESTREPTOCÓCICA"
  },
  {
    "codigo":69729007,
    "descripcion":"PULMÓN UNILOBULAR"
  },
  {
    "codigo":102497008,
    "descripcion":"SÍNTOMAS DE ESTRÉS"
  },
  {
    "codigo":1149238005,
    "descripcion":"INTOXICACIÓN CRÓNICA POR COMPUESTO DE BROMO"
  },
  {
    "codigo":67894009,
    "descripcion":"ANEMIA MEGALOBLÁSTICA POR AUMENTO DE LOS REQUERIMIENTOS"
  },
  {
    "codigo":461110009,
    "descripcion":"TRAYECTO ABERRANTE DE ARTERIA CORONARIA POSTERIOR AL TRONCO PULMONAR Y A LA AORTA"
  },
  {
    "codigo":426507006,
    "descripcion":"ENTERITIS CAUSADA POR CANDIDA"
  },
  {
    "codigo":721419007,
    "descripcion":"FRACTURA DE QUINTA VÉRTEBRA DORSAL"
  },
  {
    "codigo":293600000,
    "descripcion":"ALERGIA A NALBUFINA"
  },
  {
    "codigo":129760005,
    "descripcion":"CALCIFICACIÓN AMORFA"
  },
  {
    "codigo":719584008,
    "descripcion":"SÍNDROME DE MICRODELECIÓN 17Q23.1Q23.2"
  },
  {
    "codigo":816053001,
    "descripcion":"TUMORACIÓN DE CUADRANTE INFERIOR INTERNO DE MAMA"
  },
  {
    "codigo":1075911000119107,
    "descripcion":"SINOVITIS ARTICULAR DE PIE IZQUIERDO"
  },
  {
    "codigo":160693001,
    "descripcion":"MOVILIDAD ESCASA"
  },
  {
    "codigo":717749002,
    "descripcion":"DISPLASIA POLIQUÍSTICA DE AMBOS RIÑONES"
  },
  {
    "codigo":226229006,
    "descripcion":"DIETA EQUILIBRADA"
  },
  {
    "codigo":62389006,
    "descripcion":"ANEMIA MEGALOBLÁSTICA AGUDA POR ENFERMEDAD SEVERA"
  },
  {
    "codigo":93322000,
    "descripcion":"POSICIÓN ANÓMALA CONGÉNITA DEL PERONÉ"
  },
  {
    "codigo":286515001,
    "descripcion":"INCAPAZ DE COCINAR ALIMENTOS"
  },
  {
    "codigo":91487003,
    "descripcion":"DERMATITIS DEL PAÑAL"
  },
  {
    "codigo":124255005,
    "descripcion":"DEFICIENCIA DE ARILAMINA ACETILTRANSFERASA"
  },
  {
    "codigo":11780961000119105,
    "descripcion":"LACERACIÓN DE MÚSCULO BÍCEPS BRAQUIAL DERECHO"
  },
  {
    "codigo":15713121000119105,
    "descripcion":"INFARTO AGUDO DE MIOCARDIO CON ELEVACIÓN DE SEGMENTO ST DEBIDO A OCLUSIÓN DE ARTERIA CORONARIA DERECHA"
  },
  {
    "codigo":187956003,
    "descripcion":"NEOPLASIA MALIGNA DE VÉRTEBRA SACRA"
  },
  {
    "codigo":253492004,
    "descripcion":"CABALGAMIENTO DE VÁLVULA AURICULOVENTRICULAR IZQUIERDA"
  },
  {
    "codigo":1269300004,
    "descripcion":"MEGACOLON ADQUIRIDO EN ADULTO"
  },
  {
    "codigo":367611000119100,
    "descripcion":"HIDRONEFROSIS DEBIDA A ESTENOSIS URETERAL"
  },
  {
    "codigo":448265002,
    "descripcion":"DOLOR A LA PALPACIÓN DE CUADRANTE SUPERIOR DERECHO DEL ABDOMEN"
  },
  {
    "codigo":22281006,
    "descripcion":"SEUDOGEUSESTESIA"
  },
  {
    "codigo":11862881000119108,
    "descripcion":"ABRASIÓN DE PIEL DE DEDO GORDO IZQUIERDO"
  },
  {
    "codigo":315358001,
    "descripcion":"PAÍS DE NACIMIENTO - AFRICANO"
  },
  {
    "codigo":249822002,
    "descripcion":"NÓDULO EN DEDO DE PIE"
  },
  {
    "codigo":446430005,
    "descripcion":"DEHISCENCIA DE PILOROPLASTIA"
  },
  {
    "codigo":282590009,
    "descripcion":"SALTA SOBRE UN PIE"
  },
  {
    "codigo":247987004,
    "descripcion":"ACTUACIÓN EXTRAÑA EN PÚBLICO"
  },
  {
    "codigo":1521000119100,
    "descripcion":"ÚLCERA DE PIE DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":1089521000119102,
    "descripcion":"ESTENOSIS TRAUMÁTICA DE CONDUCTO AUDITIVO EXTERNO IZQUIERDO"
  },
  {
    "codigo":870579007,
    "descripcion":"OCLUSIÓN DE RAMA DE ARTERIA BASILAR"
  },
  {
    "codigo":16782321000119104,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE PIEL DE MANO DERECHA"
  },
  {
    "codigo":1086961000119105,
    "descripcion":"HEMORRAGIA POR GASTROSTOMÍA"
  },
  {
    "codigo":15714801000119106,
    "descripcion":"SÍNDROME COMPARTIMENTAL NO TRAUMÁTICO BILATERAL DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":677361000119107,
    "descripcion":"CÁMARA ANTERIOR PLANA DE OJO IZQUIERDO CON HIPOTONÍA"
  },
  {
    "codigo":109041000119107,
    "descripcion":"DISLIPIDEMIA COMPLEJA"
  },
  {
    "codigo":313841000119109,
    "descripcion":"ATROFIA DE MÚSCULO DE BRAZO IZQUIERDO"
  },
  {
    "codigo":15702001000119109,
    "descripcion":"RUPTURA NO TRAUMÁTICA DE TENDÓN DE MÚSCULO BÍCEPS FEMORAL IZQUIERDO"
  },
  {
    "codigo":15725041000119105,
    "descripcion":"ENTESOPATÍA DE CODO IZQUIERDO"
  },
  {
    "codigo":306161000119108,
    "descripcion":"GOTA CRÓNICA DE CODO SIN TOFO CAUSADA POR FÁRMACO"
  },
  {
    "codigo":11311601000119109,
    "descripcion":"FRACTURA OSTEOPORÓTICA DE VÉRTEBRA"
  },
  {
    "codigo":1076721000119108,
    "descripcion":"DOLOR DE ARTICULACIÓN DE MANO DERECHA"
  },
  {
    "codigo":19441000119107,
    "descripcion":"DISFUNCIÓN DE REGIÓN CERVICOTORÁCICA"
  },
  {
    "codigo":278920007,
    "descripcion":"DISPRAXIAS RELACIONADAS CON EL HABLA Y EL LENGUAJE"
  },
  {
    "codigo":440925005,
    "descripcion":"RINOVIRUS HUMANO PRESENTE"
  },
  {
    "codigo":1079281000119109,
    "descripcion":"NEOPLASIA BENIGNA DE HUESO DE PIE DERECHO"
  },
  {
    "codigo":735837002,
    "descripcion":"HERIDA PUNZANTE DE CADERA SIN CUERPO EXTRAÑO"
  },
  {
    "codigo":11809941000119102,
    "descripcion":"ABRASIÓN DE PIEL DE RODILLA IZQUIERDA"
  },
  {
    "codigo":13106001,
    "descripcion":"AUSENCIA DE DISCRIMINACIÓN ENTRE DOS PUNTOS"
  },
  {
    "codigo":47709007,
    "descripcion":"HIPERCALCEMIA HUMORAL MALIGNA"
  },
  {
    "codigo":471858004,
    "descripcion":"MIOCARDIOPATÍA VALVULAR"
  },
  {
    "codigo":111410004,
    "descripcion":"HIPERTROFIA DE VEJIGA URINARIA"
  },
  {
    "codigo":78642008,
    "descripcion":"ALBINISMO OCULAR LIGADO AL CROMOSOMA X, TIPO NETTLESHIP"
  },
  {
    "codigo":44039000,
    "descripcion":"FRACTURA EXPUESTA DE CINCO COSTILLAS"
  },
  {
    "codigo":76807004,
    "descripcion":"CERVICOBRAQUIALGIA"
  },
  {
    "codigo":1354759006,
    "descripcion":"DISTENSIÓN DE TENDÓN DE MÚSCULO PSOAS"
  },
  {
    "codigo":109575007,
    "descripcion":"CARIES DENTAL PRIMARIA, ORIGEN EN FOSITA Y HENDIDURA"
  },
  {
    "codigo":238812004,
    "descripcion":"TRASTORNO EXANTEMATOSO"
  },
  {
    "codigo":304348004,
    "descripcion":"AMPLITUD DE MOVIMIENTO DE COLUMNA DORSAL DISMINUIDA"
  },
  {
    "codigo":341141000119106,
    "descripcion":"DEGENERACIÓN MACULAR CISTOIDE DE RETINA IZQUIERDA"
  },
  {
    "codigo":402652009,
    "descripcion":"TUMOR VASCULAR MALIGNO DE PIEL"
  },
  {
    "codigo":1187249005,
    "descripcion":"LEUCODISTROFIA HIPOMIELINIZANTE AUTOSÓMICA RECESIVA ASOCIADA AL GEN VPS11"
  },
  {
    "codigo":111240004,
    "descripcion":"ENTESOPATÍA DE REGIÓN DE HOMBRO"
  },
  {
    "codigo":914650261000119108,
    "descripcion":"ANEURISMA ROTO DE AORTA ABDOMINAL INFRARRENAL"
  },
  {
    "codigo":7601009,
    "descripcion":"MEATO URINARIO DOBLE"
  },
  {
    "codigo":202374005,
    "descripcion":"DERRAME DE ARTICULACIÓN RADIOCUBITAL DISTAL"
  },
  {
    "codigo":300678005,
    "descripcion":"UTILIZA LA SENDA PEATONAL"
  },
  {
    "codigo":366214009,
    "descripcion":"HALLAZGO RELACIONADO CON EL FLUJO SANGUÍNEO PERIFÉRICO"
  },
  {
    "codigo":167771001,
    "descripcion":"VOLUMEN DE SEMEN, BUENO: 2-5 ML"
  },
  {
    "codigo":36699003,
    "descripcion":"ABSCESO DE VEJIGA URINARIA"
  },
  {
    "codigo":722992006,
    "descripcion":"HIDROCEFALIA COMUNICANTE CONCOMITANTE CON AGENESIA CONGÉNITA DE VELLOSIDADES ARACNOIDEAS Y DEBIDA A ELLA"
  },
  {
    "codigo":428080007,
    "descripcion":"OBSTRUCCIÓN PARCIAL DE LA VÍA AÉREA CAUSADA POR SANGRE"
  },
  {
    "codigo":231472009,
    "descripcion":"DEPENDENCIA DE BARBITÚRICOS"
  },
  {
    "codigo":297008009,
    "descripcion":"SOBREDOSIS DE BENDROFLUAZIDA"
  },
  {
    "codigo":360709003,
    "descripcion":"DEFICIENCIA DE DESACILASA DE ACETIL-COA"
  },
  {
    "codigo":721157004,
    "descripcion":"CAPAZ DE RECORDAR EVENTOS PASADOS"
  },
  {
    "codigo":229637006,
    "descripcion":"DISFONÍA HIPERFUNCIONAL"
  },
  {
    "codigo":63962004,
    "descripcion":"INFECCIÓN CAUSADA POR ACANTHOCEPHALUS"
  },
  {
    "codigo":1145306007,
    "descripcion":"BUENA RED DE APOYO SOCIAL"
  },
  {
    "codigo":422575000,
    "descripcion":"INHIBICIÓN FARMACOLÓGICA DE ENZIMA CYP1A2 DEL CITOCROMO P450"
  },
  {
    "codigo":31194008,
    "descripcion":"INFECCIÓN FÚNGICA DEL OJO"
  },
  {
    "codigo":291503002,
    "descripcion":"INTOXICACIÓN ACCIDENTAL POR OLEANDOMICINA"
  },
  {
    "codigo":94895007,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA CARA LARÍNGEA DEL PLIEGUE ARITENOEPIGLÓTICO"
  },
  {
    "codigo":93060001,
    "descripcion":"DILATACIÓN CONGÉNITA DE ESTÓMAGO"
  },
  {
    "codigo":715652002,
    "descripcion":"DISPLASIA MESOMÉLICA TIPO SAVARIRAYAN"
  },
  {
    "codigo":224132002,
    "descripcion":"VIVE CON UN AMIGO"
  },
  {
    "codigo":1080931000119100,
    "descripcion":"MELANOMA IN SITU DE EXTREMIDAD INFERIOR IZQUIERDA"
  },
  {
    "codigo":781188008,
    "descripcion":"HIPERGRANULACIÓN DE HERIDA QUIRÚRGICA POR SEGUNDA INTENCIÓN"
  },
  {
    "codigo":386137000,
    "descripcion":"ARTERIA CORONARIA TORTUOSA"
  },
  {
    "codigo":123993001,
    "descripcion":"NIVEL DE ÁCIDO HOMOGENTÍSICO POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":1296691005,
    "descripcion":"HIPERTENSIÓN OCULAR DE OJO DERECHO DEBIDA A AFAQUIA"
  },
  {
    "codigo":187694000,
    "descripcion":"NEOPLASIA MALIGNA DE ADENOIDES"
  },
  {
    "codigo":285998000,
    "descripcion":"INCAPAZ DE ABRIR LA TUBERÍA DE GAS MAESTRA"
  },
  {
    "codigo":343651000119102,
    "descripcion":"ECTASIA DE AMBAS ESCLERÓTICAS"
  },
  {
    "codigo":23854007,
    "descripcion":"PARAPSORIASIS EN PLACAS PEQUEÑAS"
  },
  {
    "codigo":253230008,
    "descripcion":"ESTAFILOMA ANTERIOR CONGÉNITO"
  },
  {
    "codigo":89390009,
    "descripcion":"QUEMADURA EPIDÉRMICA DE MÚLTIPLES SITIOS DE MIEMBRO INFERIOR"
  },
  {
    "codigo":87555007,
    "descripcion":"SÍNDROME DE CLAUDE"
  },
  {
    "codigo":249560000,
    "descripcion":"PALPACIÓN PROFUNDA SOBRE BAZO"
  },
  {
    "codigo":284163009,
    "descripcion":"INCAPAZ DE MOVER LA CABEZA"
  },
  {
    "codigo":20184003,
    "descripcion":"INTOXICACIÓN POR STROPHANTHUS"
  },
  {
    "codigo":247725000,
    "descripcion":"EL TIEMPO PARECE TRANSCURRIR CON EXCESIVA RAPIDEZ"
  },
  {
    "codigo":870317001,
    "descripcion":"PAQUIMENINGITIS DEBIDA A TRASTORNO INFLAMATORIO"
  },
  {
    "codigo":313261004,
    "descripcion":"HERIDA ABIERTA DEL MENTÓN"
  },
  {
    "codigo":442498002,
    "descripcion":"DISFUNCIÓN DE EJE ENDOCRINO"
  },
  {
    "codigo":16514006,
    "descripcion":"PIEL HÚMEDA"
  },
  {
    "codigo":409730008,
    "descripcion":"CLASIFICACIÓN INTERNACIONAL DE NEUROBLASTOMA: NO PUEDE DETERMINARSE"
  },
  {
    "codigo":47447001,
    "descripcion":"TRASTORNO DELIRANTE, TIPO DE GRANDIOSIDAD"
  },
  {
    "codigo":278658009,
    "descripcion":"DIENTE NO ERUPCIONADO"
  },
  {
    "codigo":440663004,
    "descripcion":"ESCLEROSIS PERITONEAL ENCAPSULADA ASOCIADA CON DIÁLISIS PERITONEAL"
  },
  {
    "codigo":473431006,
    "descripcion":"COMPLEJO PRIMARIO TUBERCULOSO CON RESULTADO DESCONOCIDO DE EXÁMENES BACTERIOLÓGICO O HISTOLÓGICO"
  },
  {
    "codigo":735575007,
    "descripcion":"PERFORACIÓN DE AORTA TORÁCICA CONCOMITANTE CON ANEURISMA DE AORTA TORÁCICA Y DEBIDA A ÉL"
  },
  {
    "codigo":71421000119105,
    "descripcion":"HIPERTENSIÓN EN ENFERMEDAD RENAL CRÓNICA DEBIDA A DIABETES MELLITUS TIPO 2"
  },
  {
    "codigo":209452002,
    "descripcion":"ESGUINCE DEL LIGAMENTO CUBITOSEMILUNAR"
  },
  {
    "codigo":307756005,
    "descripcion":"PARÁLISIS CEREBRAL, NO CONGÉNITA O INFANTIL, AGUDA"
  },
  {
    "codigo":240385003,
    "descripcion":"MUERMO SEPTICÉMICO"
  },
  {
    "codigo":404225005,
    "descripcion":"OSTEODESMOSIS"
  },
  {
    "codigo":109313006,
    "descripcion":"OSTEOMIELITIS AGUDA DE HUESO TEMPORAL"
  },
  {
    "codigo":16019351000119102,
    "descripcion":"ATEROSCLEROSIS DE INJERTO-PUENTE DE EXTREMIDAD SUPERIOR IZQUIERDA"
  },
  {
    "codigo":238550003,
    "descripcion":"QUEIROPODOPÓNFOLIX AGUDO"
  },
  {
    "codigo":402390008,
    "descripcion":"ANAFILAXIA CAUSADA POR ALIMENTO INGERIDO"
  },
  {
    "codigo":105643005,
    "descripcion":"ENFERMEDAD CAUSADA POR RETORTAMONADIDAE"
  },
  {
    "codigo":269483007,
    "descripcion":"NEOPLASIA BENIGNA DE COLUMNA VERTEBRAL, EXCLUIDOS SACRO Y CÓCCIX"
  },
  {
    "codigo":7339009,
    "descripcion":"POLINEUROPATÍA CAUSADA POR FÁRMACO"
  },
  {
    "codigo":726400003,
    "descripcion":"DISOMÍA UNIPARENTAL"
  },
  {
    "codigo":300416005,
    "descripcion":"DEFENSA ABDOMINAL EN LA REGIÓN UMBILICAL"
  },
  {
    "codigo":202112005,
    "descripcion":"RUPTURA ANTIGUA DEL LIGAMENTO DE LA CÁPSULA ROTULIANA"
  },
  {
    "codigo":396885004,
    "descripcion":"TUMOR QUE INVADE MÁS ALLÁ DE LA CÁPSULA PANCREÁTICA HACIA LA VÍA BILIAR (PÁNCREAS ENDOCRINO)"
  },
  {
    "codigo":1052245004,
    "descripcion":"AGRANDAMIENTO DE AMÍGDALA IZQUIERDA"
  },
  {
    "codigo":724565006,
    "descripcion":"TRASTORNO DE LA SUSTANCIA BLANCA DEBIDA A DEFICIENCIA NUTRICIONAL"
  },
  {
    "codigo":200277008,
    "descripcion":"FIEBRE PUERPERAL DE ORIGEN DESCONOCIDO"
  },
  {
    "codigo":298581009,
    "descripcion":"CREPITACIÓN PALPABLE DE LA COLUMNA DORSAL"
  },
  {
    "codigo":346161000119102,
    "descripcion":"EPIESCLERITIS DE AMBOS OJOS"
  },
  {
    "codigo":34602004,
    "descripcion":"ÚLCERA DUODENAL CRÓNICA CON PERFORACIÓN PERO SIN OBSTRUCCIÓN"
  },
  {
    "codigo":15665201000119103,
    "descripcion":"OPACIDAD VÍTREA CONGÉNITA DE OJO DERECHO"
  },
  {
    "codigo":395050009,
    "descripcion":"CONTROL DE HIPERTENSIÓN NO REQUERIDO"
  },
  {
    "codigo":460586009,
    "descripcion":"ORIGEN ANÓMALO DE ARTERIA CORONARIA DERECHA EN ARTERIA CORONARIA IZQUIERDA"
  },
  {
    "codigo":32767004,
    "descripcion":"INTOXICACIÓN POR AESCULUS HIPPOCASTANUM"
  },
  {
    "codigo":196607008,
    "descripcion":"ÚLCERA ESOFÁGICA CAUSADA POR ASPIRINA"
  },
  {
    "codigo":131071009,
    "descripcion":"PREGNANEDIOL ANORMAL"
  },
  {
    "codigo":162004006,
    "descripcion":"SÍNTOMAS DENTALES"
  },
  {
    "codigo":127401000,
    "descripcion":"HALLAZGO EN LA ERITROCITOPOYESIS"
  },
  {
    "codigo":717225001,
    "descripcion":"EPILEPSIA MIOCLÓNICA FAMILIAR BENIGNA DEL ADULTO"
  },
  {
    "codigo":15747121000119107,
    "descripcion":"LESIÓN DE CANTO DERECHO"
  },
  {
    "codigo":1145044008,
    "descripcion":"SOBREDOSIS DE VITAMINA B Y\/O DERIVADO DE VITAMINA B"
  },
  {
    "codigo":94633004,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE CONDUCTO TIROGLOSO"
  },
  {
    "codigo":782761005,
    "descripcion":"ASPERGILOSIS PULMONAR INVASIVA SUBAGUDA"
  },
  {
    "codigo":1208745002,
    "descripcion":"NEOPLASIA NEUROENDOCRINA DE PÁNCREAS PRODUCTORA DE SEROTONINA"
  },
  {
    "codigo":293076008,
    "descripcion":"REACCIÓN ADVERSA A LA RIFABUTINA"
  },
  {
    "codigo":1010302000,
    "descripcion":"TRASTORNO FETAL DEBIDO A OBESIDAD MATERNA"
  },
  {
    "codigo":92798004,
    "descripcion":"CARCINOMA IN SITU DEL VESTÍBULO DE LA BOCA"
  },
  {
    "codigo":1083441000119109,
    "descripcion":"HIDROPESÍA COCLEAR DE AMBOS OÍDOS INTERNOS"
  },
  {
    "codigo":289406007,
    "descripcion":"SUTURA SAGITAL EN DIÁMETRO TRANSVERSO"
  },
  {
    "codigo":189267000,
    "descripcion":"CARCINOMA IN SITU DE PARÉNQUIMA PULMONAR Y BRONQUIO DE LÓBULO INFERIOR"
  },
  {
    "codigo":27262009,
    "descripcion":"AUSENCIA CONGÉNITA DEL MÚSCULO PECTORAL"
  },
  {
    "codigo":1303379002,
    "descripcion":"FRACTURA DE AMBAS CLAVÍCULAS"
  },
  {
    "codigo":254803001,
    "descripcion":"NEVO DE MYERSON"
  },
  {
    "codigo":449576007,
    "descripcion":"ARTERIA PULMONAR IZQUIERDA CON CONEXIÓN ARTERIAL PROXIMAL AUSENTE"
  },
  {
    "codigo":87293001,
    "descripcion":"MANEJO DE UN HOGAR QUE ATRAVIESA UNA SITUACIÓN DE ALTERACIÓN, LEVE"
  },
  {
    "codigo":1332477005,
    "descripcion":"ÚLCERA TRAUMÁTICA DE PIEL DE EXTREMIDAD INFERIOR"
  },
  {
    "codigo":216530001,
    "descripcion":"INTOXICACIÓN ACCIDENTAL CAUSADA POR TRANQUILIZANTE BENZODIAZEPÍNICO"
  },
  {
    "codigo":1363410002,
    "descripcion":"NEOVASCULARIZACIÓN DE CUADRANTE SUPERIOR DE ÁNGULO IRIDOCORNEAL"
  },
  {
    "codigo":282066003,
    "descripcion":"LACERACIÓN DE ÍLEON"
  },
  {
    "codigo":773586004,
    "descripcion":"OSIFICACIÓN INCOMPLETA DE CRÁNEO"
  },
  {
    "codigo":183762004,
    "descripcion":"CONSULTA DOMICILIARIA DE CIRUGÍA PLÁSTICA, REALIZADA"
  },
  {
    "codigo":19922006,
    "descripcion":"SADISMO SEXUAL COMPULSIVO"
  },
  {
    "codigo":118226009,
    "descripcion":"HALLAZGO TEMPORAL"
  },
  {
    "codigo":1197735004,
    "descripcion":"PSEUDOBSTRUCCIÓN COLÓNICA CRÓNICA"
  },
  {
    "codigo":312999006,
    "descripcion":"TRASTORNO DE LA MÁCULA DE LA RETINA"
  },
  {
    "codigo":247463007,
    "descripcion":"UNTO SEBÁCEO"
  },
  {
    "codigo":50855007,
    "descripcion":"HEMOCROMATOSIS JUVENIL"
  },
  {
    "codigo":1163132002,
    "descripcion":"MENINGITIS POR BACILO AEROBIO GRAMPOSITIVO"
  },
  {
    "codigo":442236004,
    "descripcion":"DOLOR EN TESTÍCULO COMO EFECTO TARDÍO DE LESIÓN TRAUMÁTICA TESTICULAR"
  },
  {
    "codigo":868220007,
    "descripcion":"INFARTO AGUDO DE MIOCARDIO CON ELEVACIÓN DEL SEGMENTO ST DEBIDO A OCLUSIÓN DE PORCIÓN MEDIA DE ARTERIA CORONARIA DERECHA"
  },
  {
    "codigo":47185005,
    "descripcion":"LESIÓN TRAUMÁTICA DEL NERVIO AXILAR"
  },
  {
    "codigo":79953006,
    "descripcion":"INTOXICACIÓN POR GUANETIDINA"
  },
  {
    "codigo":1259601006,
    "descripcion":"MIXOFIBROSARCOMA PRIMARIO DE PIEL"
  },
  {
    "codigo":407633008,
    "descripcion":"ESCALA DE DETERIORO GENERAL NIVEL 5 - DETERIORO COGNITIVO MODERADAMENTE GRAVE"
  },
  {
    "codigo":766246000,
    "descripcion":"ENFERMEDAD DE MARBURG"
  },
  {
    "codigo":276561008,
    "descripcion":"HIPOGLUCEMIA NEONATAL TRANSITORIA"
  },
  {
    "codigo":373030002,
    "descripcion":"INFECCIÓN CAUSADA POR MYCOBACTERIUM GADIUM"
  },
  {
    "codigo":1085951000119102,
    "descripcion":"CARIES DENTAL SOBRE SUPERFICIE CON HENDIDURAS Y FISURAS LIMITADA AL ESMALTE"
  },
  {
    "codigo":241958006,
    "descripcion":"URTICARIA ANGIOEDEMATOSA AGRAVADA POR FÁRMACOS"
  },
  {
    "codigo":240123001,
    "descripcion":"MIOSITIS OSIFICANTE DEBIDA A QUEMADURA"
  },
  {
    "codigo":403963001,
    "descripcion":"HEMANGIOMA DE LA CAVIDAD ORAL"
  },
  {
    "codigo":43515008,
    "descripcion":"ESPÉCIMEN NO REPRESENTATIVO DEL SITIO ANATÓMICO DE ORIGEN"
  },
  {
    "codigo":305659008,
    "descripcion":"ATENDIDO POR UN NEUROPATÓLOGO"
  },
  {
    "codigo":860880003,
    "descripcion":"HIPERHIDROSIS DEBIDA A DESREGULACIÓN AUTONÓMICA"
  },
  {
    "codigo":402128003,
    "descripcion":"LISTERIOSIS CUTÁNEO"
  },
  {
    "codigo":1286864008,
    "descripcion":"FRACTURA DE HUESO DE CINTURA ESCAPULAR DERECHA"
  },
  {
    "codigo":1186725001,
    "descripcion":"SÍNDROME DE VERRUGAS, INMUNODEFICIENCIA, LINFEDEMA Y DISPLASIA ANOGENITAL"
  },
  {
    "codigo":8912009,
    "descripcion":"SALPINGITIS AGUDA"
  },
  {
    "codigo":11791001000119101,
    "descripcion":"CONTUSIÓN DE PIERNA IZQUIERDA"
  },
  {
    "codigo":170917004,
    "descripcion":"EFECTOS COLATERALES DE LA WARFARINA"
  },
  {
    "codigo":236453005,
    "descripcion":"NEFRITIS TUBULOINTERSTICIAL CRÓNICA CAUSADA POR METAL PESADO"
  },
  {
    "codigo":203685006,
    "descripcion":"ESPONDILOLISTESIS PEDICULAR"
  },
  {
    "codigo":72613009,
    "descripcion":"ABORTO ESPONTÁNEO CON OLIGURIA"
  },
  {
    "codigo":1217658002,
    "descripcion":"DESPLAZAMIENTO DE TUBO POSTERIOR A CIRUGÍA DE GLAUCOMA"
  },
  {
    "codigo":1119354003,
    "descripcion":"ATAXIA CEREBELOSA NO PROGRESIVA"
  },
  {
    "codigo":365690003,
    "descripcion":"HALLAZGO RELACIONADO CON LA PRESENCIA DE ORGANISMOS"
  },
  {
    "codigo":300154004,
    "descripcion":"MEMBRANA TIMPÁNICA DE COLOR NORMAL"
  },
  {
    "codigo":169082008,
    "descripcion":"RESONANCIA MAGNÉTICA NUCLEAR NORMAL"
  },
  {
    "codigo":267386008,
    "descripcion":"GIGANTISMO Y ACROMEGALIA"
  },
  {
    "codigo":38010008,
    "descripcion":"HEMORRAGIA INTRAPARTO"
  },
  {
    "codigo":234618008,
    "descripcion":"DEFECTO DEL FACTOR REGULADOR DEL COMPLEMENTO"
  },
  {
    "codigo":429391004,
    "descripcion":"NUEVO INFARTO DE MIOCARDIO EN COMPARACIÓN CON ESTUDIO PREVIO"
  },
  {
    "codigo":462159005,
    "descripcion":"RETENCIÓN FETAL DE LÍQUIDO"
  },
  {
    "codigo":36175004,
    "descripcion":"FORÚNCULO DE TALÓN"
  },
  {
    "codigo":198180000,
    "descripcion":"ENFERMEDAD INFLAMATORIA UTERINA AGUDA"
  },
  {
    "codigo":722468005,
    "descripcion":"ACIDOSIS TUBULAR RENAL DISTAL CONCOMITANTE CON SORDERA NEUROSENSORIAL"
  },
  {
    "codigo":460324008,
    "descripcion":"DISECCIÓN DE VENA ILIOFEMORAL COMO COMPLICACIÓN DE CATETERISMO DE VENA FEMORAL"
  },
  {
    "codigo":128974000,
    "descripcion":"ESTADO INICIAL"
  },
  {
    "codigo":720633009,
    "descripcion":"SINDACTILIA TIPO 7"
  },
  {
    "codigo":1179385009,
    "descripcion":"HIPOTIROIDISMO CENTRAL ADQUIRIDO CAUSADO POR FÁRMACO"
  },
  {
    "codigo":15723161000119109,
    "descripcion":"ARTROSIS SECUNDARIA DE AMBOS CODOS"
  },
  {
    "codigo":391118006,
    "descripcion":"PRUEBA DE REVERSIBILIDAD AL SALBUTAMOL: POSITIVA"
  },
  {
    "codigo":260046006,
    "descripcion":"DERMATITIS DE LA PIEL SECA"
  },
  {
    "codigo":94371001,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LA PORCIÓN LATERAL DEL PISO DE LA BOCA"
  },
  {
    "codigo":1208483002,
    "descripcion":"CORIOCARCINOMA PRIMARIO DE SISTEMA NERVIOSO CENTRAL"
  },
  {
    "codigo":292814009,
    "descripcion":"REACCIÓN ADVERSA A ANTIFÚNGICO A BASE DE IMIDAZOL"
  },
  {
    "codigo":127139002,
    "descripcion":"LINFADENOPATÍA PANCREÁTICA SUPERIOR"
  },
  {
    "codigo":225443005,
    "descripcion":"RECUPERACIÓN DE LA MEMORIA"
  },
  {
    "codigo":1306787006,
    "descripcion":"GLAUCOMA DE OJO IZQUIERDO DEBIDO A MALFORMACIÓN CONGÉNITA DE ÁNGULO DE CÁMARA ANTERIOR DE OJO"
  },
  {
    "codigo":28835009,
    "descripcion":"RETINITIS PIGMENTARIA"
  },
  {
    "codigo":92536001,
    "descripcion":"CARCINOMA IN SITU DE LA PARED ANTERIOR DE LA VEJIGA"
  },
  {
    "codigo":423859003,
    "descripcion":"ESPACIO VITAL ATESTADO"
  },
  {
    "codigo":289144006,
    "descripcion":"HALLAZGO RELACIONADO CON EL ALIMENTO EN LA BOCA"
  },
  {
    "codigo":715128008,
    "descripcion":"INCAPAZ DE PASAR LA CAMA A UNA SILLA"
  },
  {
    "codigo":57933001,
    "descripcion":"REACCIÓN AGRESIVA ANTISOCIAL EN LA NIÑEZ"
  },
  {
    "codigo":713293002,
    "descripcion":"NEOPLASIA MALIGNA DE CÉLULAS GERMINALES DE MEDIASTINO"
  },
  {
    "codigo":1335885002,
    "descripcion":"VIVE EN EL EXTERIOR"
  },
  {
    "codigo":90701007,
    "descripcion":"APNEA SECUNDARIA"
  },
  {
    "codigo":56098000,
    "descripcion":"PROBLEMA SOCIAL NO CAUSADO POR UN TRASTORNO MENTAL"
  },
  {
    "codigo":285474000,
    "descripcion":"CAPAZ DE MOVER LOS LABIOS"
  },
  {
    "codigo":1137442002,
    "descripcion":"CALCIFICACIÓN PUNTEADA DE HUESO"
  },
  {
    "codigo":1088461000119102,
    "descripcion":"OTITIS CRÓNICA MUCOIDE DE OÍDO MEDIO IZQUIERDO"
  },
  {
    "codigo":351181000119103,
    "descripcion":"ANEMIA DEBIDA A ENZIMOPATÍA"
  },
  {
    "codigo":416546007,
    "descripcion":"DESPLAZAMIENTO ANTERIOR DEL SACRO"
  },
  {
    "codigo":283639006,
    "descripcion":"HERIDA POR PINCHAZO DE AGUJA EN EL PIE"
  },
  {
    "codigo":185335007,
    "descripcion":"CITA CANCELADA POR EL HOSPITAL"
  },
  {
    "codigo":609484000,
    "descripcion":"INTERRUPCIÓN INDUCIDA DEL EMBARAZO COMPLICADA POR SALPINGOOFORITIS"
  },
  {
    "codigo":105421000119105,
    "descripcion":"ENFERMEDAD DE ALZHEIMER DE COMIENZO TEMPRANO CON ALTERACIÓN DEL COMPORTAMIENTO"
  },
  {
    "codigo":1363148003,
    "descripcion":"ASTILLA EN ANTEBRAZO CON INFECCIÓN"
  },
  {
    "codigo":19660004,
    "descripcion":"TRASTORNO DE PARTES BLANDAS"
  },
  {
    "codigo":771489001,
    "descripcion":"FRACTURAS QUE COMPROMETEN REGIONES MÚLTIPLES DE LA EXTREMIDAD INFERIOR IZQUIERDA"
  },
  {
    "codigo":247201009,
    "descripcion":"HALLAZGO RELACIONADO CON LA PAPILA ÓPTICA"
  },
  {
    "codigo":15990001,
    "descripcion":"INFARTO AGUDO DE MIOCARDIO DE PARED POSTEROLATERAL"
  },
  {
    "codigo":441974004,
    "descripcion":"TUMEFACCIÓN DE GLÚTEO"
  },
  {
    "codigo":276299000,
    "descripcion":"ANESTESIA DISOCIATIVA"
  },
  {
    "codigo":1259339006,
    "descripcion":"CARCINOMA PRIMARIO DE SURCO LABIAL INFERIOR"
  },
  {
    "codigo":866123008,
    "descripcion":"MIELITIS CAUSADA POR SCHISTOSOMA HAEMATOBIUM"
  },
  {
    "codigo":1193803009,
    "descripcion":"INFLAMACIÓN INTESTINAL POR ENTAMOEBA HISTOLYTICA"
  },
  {
    "codigo":733216002,
    "descripcion":"LUXACIÓN TRAUMÁTICA DE ARTICULACIÓN DE PARED TORÁCICA"
  },
  {
    "codigo":248584002,
    "descripcion":"BOCANADA DE AIRE"
  },
  {
    "codigo":405536006,
    "descripcion":"MIEMBRO DEL PERSONAL, ENFERMO"
  },
  {
    "codigo":307232007,
    "descripcion":"FÍSTULA SUBFRÉNICA BRONCOPLEURAL"
  },
  {
    "codigo":45088005,
    "descripcion":"INTOXICACIÓN POR ÁCIDO FÓLICO"
  },
  {
    "codigo":1255669001,
    "descripcion":"EN RIESGO DE EXPOSICIÓN A ENTIDAD POTENCIALMENTE PERJUDICIAL"
  },
  {
    "codigo":1222901007,
    "descripcion":"INCAPAZ DE PATEAR CON PIERNA"
  },
  {
    "codigo":762314000,
    "descripcion":"VESTIBULOPATÍA DERECHA POSTERIOR A INTERVENCIÓN MÉDICA"
  },
  {
    "codigo":403701008,
    "descripcion":"ULCERACIÓN PARAESTOMAL"
  },
  {
    "codigo":11769211000119106,
    "descripcion":"LACERACIÓN DE TENDÓN DEL ANTEBRAZO IZQUIERDO"
  },
  {
    "codigo":10485008,
    "descripcion":"INFECCIÓN CAUSADA POR CHOANOTAENIA"
  },
  {
    "codigo":238026007,
    "descripcion":"GANGLIOSIDOSIS GM1 INFANTIL"
  },
  {
    "codigo":301727000,
    "descripcion":"REALIZA ACTIVIDADES LABORALES"
  },
  {
    "codigo":205258009,
    "descripcion":"ACROCEFALOSINDACTILIA TIPO I"
  },
  {
    "codigo":6815003,
    "descripcion":"BARTOLINITIS"
  },
  {
    "codigo":170655007,
    "descripcion":"EJERCICIO RESTRINGIDO POR EL ASMA"
  },
  {
    "codigo":400031009,
    "descripcion":"XANTOGRANULOMA JUVENIL"
  },
  {
    "codigo":103284002,
    "descripcion":"VÉRTIGO POSICIONAL"
  },
  {
    "codigo":267124003,
    "descripcion":"NIVEL 1 DE ACTIVIDAD SEGÚN EL PRINCIPIO DE FRECUENCIA, INTENSIDAD, DURACIÓN Y TIPO DE EJERCICIO"
  },
  {
    "codigo":299892006,
    "descripcion":"RESPUESTA PLANTAR EXTENSORA DERECHA"
  },
  {
    "codigo":365428008,
    "descripcion":"VOLUMEN DEL SEMEN - HALLAZGO"
  },
  {
    "codigo":1090971000119101,
    "descripcion":"PERFORACIÓN CENTRAL DE LA MEMBRANA TIMPÁNICA DERECHA"
  },
  {
    "codigo":35913006,
    "descripcion":"DEFICIENCIA ADQUIRIDA DE FACTOR V"
  },
  {
    "codigo":199753008,
    "descripcion":"TRABAJO DE PARTO OBSTRUIDO POR PRESENTACIÓN CEFÁLICA DE BREGMA"
  },
  {
    "codigo":1310004,
    "descripcion":"TRASTORNO DE LA TOLERANCIA A LA GLUCOSA ASOCIADA CON SÍNDROME GENÉTICO"
  },
  {
    "codigo":230686005,
    "descripcion":"MIASTENIA GENERALIZADA"
  },
  {
    "codigo":296222008,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE TIETILPERAZINA"
  },
  {
    "codigo":722206009,
    "descripcion":"SÍNDROME DE HIPOPLASIA PANCREÁTICA, DIABETES MELLITUS Y CARDIOPATÍA CONGÉNITA"
  },
  {
    "codigo":1179123006,
    "descripcion":"AMBIENTE PACÍFICO"
  },
  {
    "codigo":107931000119105,
    "descripcion":"DISFUNCIÓN DE TENDÓN DE MÚSCULO TIBIAL POSTERIOR"
  },
  {
    "codigo":390856001,
    "descripcion":"ATENDIDO POR ESPECIALISTA EN EXPLORACIÓN DE RETINA"
  },
  {
    "codigo":194248004,
    "descripcion":"OTITIS SEROSA CRÓNICA BILATERAL"
  },
  {
    "codigo":718536006,
    "descripcion":"ALERGIA A LOVASTATINA"
  },
  {
    "codigo":61341000,
    "descripcion":"ABRASIÓN Y\/O QUEMADURA POR FRICCIÓN DE MUSLO CON INFECCIÓN"
  },
  {
    "codigo":126877002,
    "descripcion":"TRASTORNO DEL METABOLISMO DE LA GLUCOSA"
  },
  {
    "codigo":716701004,
    "descripcion":"EPIDERMÓLISIS BULLOSA SIMPLE CONCOMITANTE CON ATRESIA DE PÍLORO"
  },
  {
    "codigo":290717004,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR CISPLATINO"
  },
  {
    "codigo":94109006,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DEL TRÍGONO VESICAL"
  },
  {
    "codigo":92274005,
    "descripcion":"NEOPLASIA BENIGNA DE LOS GANGLIOS LINFÁTICOS PARAVAGINALES"
  },
  {
    "codigo":288882007,
    "descripcion":"DIFICULTAD PARA BEBER A SORBOS"
  },
  {
    "codigo":26738009,
    "descripcion":"LESIÓN TRAUMÁTICA DE LA MÉDULA ESPINAL SIN LESIÓN ÓSEA"
  },
  {
    "codigo":287047008,
    "descripcion":"DOLOR EN MIEMBRO INFERIOR IZQUIERDO"
  },
  {
    "codigo":285212006,
    "descripcion":"INCAPAZ DE RECORDAR UN NÚMERO DE CINCO DÍGITOS DESPUÉS DE CINCO MINUTOS"
  },
  {
    "codigo":55836009,
    "descripcion":"INCOORDINACIÓN DEL MÚSCULO PAPILAR"
  },
  {
    "codigo":21233002,
    "descripcion":"HEMORRAGIA MENÍNGEA"
  },
  {
    "codigo":449052009,
    "descripcion":"TUMOR ADENOMATOIDE DE EPIDÍDIMO"
  },
  {
    "codigo":414449004,
    "descripcion":"IDENTIFICADO COMO DE BAJO RIESGO PARA INMUNIZACIÓN POR VIAJE"
  },
  {
    "codigo":445382001,
    "descripcion":"PLIEGUES CUTÁNEOS VISIBLES EN MIEMBRO EDEMATOSO"
  },
  {
    "codigo":248774001,
    "descripcion":"ERECCIÓN RETRASADA"
  },
  {
    "codigo":281542004,
    "descripcion":"DISTENSIÓN DE TENDÓN DE MIEMBRO INFERIOR"
  },
  {
    "codigo":1295515003,
    "descripcion":"HIPERTENSIÓN OCULAR DE OJO DERECHO DEBIDA A SÍNDROME SISTÉMICO"
  },
  {
    "codigo":771227004,
    "descripcion":"QUEMADURA DE TERCER GRADO DE ABDOMEN"
  },
  {
    "codigo":115867006,
    "descripcion":"FENOTIPO CH - RG"
  },
  {
    "codigo":1229979007,
    "descripcion":"OSTEONECROSIS TRAUMÁTICA"
  },
  {
    "codigo":277872000,
    "descripcion":"HIPERPLASIA SUPRARRENAL CON PUBERTAD PRECOZ"
  },
  {
    "codigo":212336006,
    "descripcion":"LESIÓN DE NERVIO SENSITIVO CUTÁNEO A NIVEL DE TOBILLO Y PIE"
  },
  {
    "codigo":274202000,
    "descripcion":"HEMATOMA SUBUNGUEAL DE LA MANO"
  },
  {
    "codigo":1259077008,
    "descripcion":"ENFERMEDAD AUTOINMUNITARIA DE NERVIO AUTÓNOMO"
  },
  {
    "codigo":732954002,
    "descripcion":"SÍNDROME DE OSTEOPENIA, DISCAPACIDAD INTELECTUAL Y PELO RALO"
  },
  {
    "codigo":405274002,
    "descripcion":"CUERPO DE ALDER-REILLY"
  },
  {
    "codigo":10760041000119103,
    "descripcion":"TIROIDITIS EN LA MADRE QUE COMPLICA EL NACIMIENTO"
  },
  {
    "codigo":208666006,
    "descripcion":"FRACTURA NO EXPUESTA DE TOBILLO, TRIMALEOLAR, FRACTURA PERONEA INFERIOR"
  },
  {
    "codigo":110362007,
    "descripcion":"AUSENCIA DE ACMESTESIA"
  },
  {
    "codigo":306970008,
    "descripcion":"INCAPAZ DE ESCUCHAR SUSURRO"
  },
  {
    "codigo":403439004,
    "descripcion":"ÚLCERA DE LABIO POR ARTERIA DE CALIBRE PERSISTENTE"
  },
  {
    "codigo":10923881000119105,
    "descripcion":"FRACTURA NO EXPUESTA DE BASE DE CUARTO HUESO METACARPIANO DE MANO DERECHA"
  },
  {
    "codigo":237764004,
    "descripcion":"HIPOPLASIA SUPRARRENAL CONGÉNITA, LIGADA AL CROMOSOMA X"
  },
  {
    "codigo":94515004,
    "descripcion":"NEOPLASIA MALIGNA METASTÁSICA DE LAS VÍAS RESPIRATORIAS"
  },
  {
    "codigo":41156006,
    "descripcion":"TUBERCULOSIS PAPULONECRÓTICA"
  },
  {
    "codigo":72089000,
    "descripcion":"DEFORMIDAD CONGÉNITA DE LA NARIZ"
  },
  {
    "codigo":235929001,
    "descripcion":"HIPERTROFIA DE LA VÍA BILIAR"
  },
  {
    "codigo":683881000119107,
    "descripcion":"NEVO EPIDÉRMICO DE CUERO CABELLUDO"
  },
  {
    "codigo":329731000119100,
    "descripcion":"COMPRESIÓN DE NERVIO MEDIANO IZQUIERDO"
  },
  {
    "codigo":203161002,
    "descripcion":"OSTEOMIELITIS AGUDA DEL CÓCCIX"
  },
  {
    "codigo":39321000,
    "descripcion":"SOMBRA"
  },
  {
    "codigo":365166000,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA DARLE CUERDA AL RELOJ"
  },
  {
    "codigo":299630002,
    "descripcion":"ARTICULACIÓN DE DEDO DEL PIE INESTABLE"
  },
  {
    "codigo":15648771000119103,
    "descripcion":"ATEROSCLEROSIS DE AMBAS ARTERIAS RENALES"
  },
  {
    "codigo":234094008,
    "descripcion":"LINFADENITIS FILARIÁSICA CRÓNICA POR BRUGIA TIMORI"
  },
  {
    "codigo":363331007,
    "descripcion":"LESIÓN TRAUMÁTICA DEL SISTEMA INMUNITARIO"
  },
  {
    "codigo":428867008,
    "descripcion":"DIARREA CAUSADA POR MEDICAMENTO"
  },
  {
    "codigo":232259009,
    "descripcion":"DISFUNCIÓN DE TROMPA DE EUSTAQUIO POR BAROTRAUMA"
  },
  {
    "codigo":10897411000119105,
    "descripcion":"LACERACIÓN DE ÓRGANOS GENITALES EXTERNOS MASCULINOS"
  },
  {
    "codigo":295960003,
    "descripcion":"SOBREDOSIS DE FÁRMACO ANTICONVULSIVANTE"
  },
  {
    "codigo":715272002,
    "descripcion":"INFECCIÓN DE SALIDA DE CATÉTER DE HEMODIÁLISIS"
  },
  {
    "codigo":164888006,
    "descripcion":"ARRITMIA SUPRAVENTRICULAR AUSENTE EN EL ELECTROCARDIOGRAMA"
  },
  {
    "codigo":263192005,
    "descripcion":"FRACTURA DE EXTREMO DISTAL DE HÚMERO"
  },
  {
    "codigo":359661001,
    "descripcion":"DIFICULTAD ESPECÍFICA DE NÚMERO"
  },
  {
    "codigo":64749001,
    "descripcion":"MIOCARDIOPATÍA DILATADA DEBIDA A INFILTRACIÓN"
  },
  {
    "codigo":294125004,
    "descripcion":"ALERGIA A ANTAZOLINA"
  },
  {
    "codigo":62914000,
    "descripcion":"ENFERMEDAD CEREBROVASCULAR"
  },
  {
    "codigo":30146003,
    "descripcion":"INFECCIÓN CAUSADA POR TRYPANOSOMA SUIS"
  },
  {
    "codigo":292290008,
    "descripcion":"REACCIÓN ADVERSA A LA DOTIEPINA"
  },
  {
    "codigo":126615001,
    "descripcion":"NEOPLASIA DE PARTES BLANDAS DEL PERINEO"
  },
  {
    "codigo":95682009,
    "descripcion":"CORIORRETINITIS GRANULOMATOSA"
  },
  {
    "codigo":1177026009,
    "descripcion":"TUBERCULOSIS DE CONDUCTO ANAL"
  },
  {
    "codigo":388759003,
    "descripcion":"INFECCIÓN CAUSADA POR ENTAMOEBA HISTOLYTICA"
  },
  {
    "codigo":1339031006,
    "descripcion":"DEMENCIA CAUSADA POR RADIACIÓN IONIZANTE"
  },
  {
    "codigo":421527008,
    "descripcion":"RESISTENCIA A PROTEÍNA C ACTIVADA DEBIDA A MUTACIÓN DE FACTOR V DE LEIDEN"
  },
  {
    "codigo":290455008,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR CÁSCARA SAGRADA"
  },
  {
    "codigo":716439008,
    "descripcion":"CAPAZ DE RECONOCER DOLOR Y SUFRIMIENTO EMOCIONALES PROPIOS"
  },
  {
    "codigo":288620004,
    "descripcion":"DIFICULTAD PARA EMPLEAR CONSTRUCCIONES GRAMATICALES"
  },
  {
    "codigo":414464311000119100,
    "descripcion":"MASTITIS GRANULOMATOSA DE MAMA IZQUIERDA"
  },
  {
    "codigo":92012006,
    "descripcion":"NEOPLASIA BENIGNA DE VASO SANGUÍNEO DE MUSLO"
  },
  {
    "codigo":1237057000,
    "descripcion":"METÁSTASIS DE CARCINOMA DE CUADRANTE INFERIOR EXTERNO DE MAMA"
  },
  {
    "codigo":303261000119107,
    "descripcion":"TENDINITIS CALCIFICADA DE HOMBRO DERECHO"
  },
  {
    "codigo":286785006,
    "descripcion":"RASGO DE LA PERSONALIDAD CON RESPECTO AL NIVEL DE AGRESIVIDAD - HALLAZGO"
  },
  {
    "codigo":31031000119102,
    "descripcion":"DESACONDICIONAMIENTO FÍSICO"
  },
  {
    "codigo":254017009,
    "descripcion":"FISURA FACIAL INFRAORBITARIA - FISURA DE TESSIER TIPO 5"
  },
  {
    "codigo":284950004,
    "descripcion":"CAPAZ DE LAVARSE LUEGO DE IR AL BAÑO"
  },
  {
    "codigo":448790004,
    "descripcion":"ORIENTACIÓN ANTEROPOSTERIOR DE VÁLVULA AÓRTICA BICÚSPIDE"
  },
  {
    "codigo":283115000,
    "descripcion":"AMPOLLA TRAUMÁTICA DE LA CABEZA"
  },
  {
    "codigo":86507001,
    "descripcion":"AUSENCIA CONGÉNITA DE LA VESÍCULA BILIAR"
  },
  {
    "codigo":414187003,
    "descripcion":"FALLA EN LA CONCEPCIÓN POR INFERTILIDAD DE LA PAREJA MASCULINA"
  },
  {
    "codigo":1004011006,
    "descripcion":"TRASTORNO NEONATAL DEBIDO A TOMA DE MUESTRA DE SANGRE FETAL Y POSTERIOR A ELLA"
  },
  {
    "codigo":686391000119105,
    "descripcion":"HISTIOCITOMA FIBROSO MALIGNO PRIMARIO DE PARTES BLANDAS DE HOMBRO"
  },
  {
    "codigo":838336002,
    "descripcion":"TRASTORNO DEL DESARROLLO SEXUAL 46,XY DEBIDO A INGESTIÓN MATERNA DE PROGESTÁGENO"
  },
  {
    "codigo":445120004,
    "descripcion":"UREMIA DEBIDA A PERFUSIÓN RENAL INADECUADA"
  },
  {
    "codigo":281280004,
    "descripcion":"ESPÉCIMEN TURBIO"
  },
  {
    "codigo":248512007,
    "descripcion":"NÓDULOS DE BUSSACA DE IRIS"
  },
  {
    "codigo":443285000,
    "descripcion":"REALIZA TODAS LAS ACTIVIDADES DE LA VIDA COTIDIANA SIN AYUDA"
  },
  {
    "codigo":82837002,
    "descripcion":"SÍNDROME DE KENNY"
  },
  {
    "codigo":12237111000119107,
    "descripcion":"DOLOR DE MIEMBRO INFERIOR IZQUIERDO EN REPOSO DEBIDO A ATEROSCLEROSIS"
  },
  {
    "codigo":10680631000119107,
    "descripcion":"NÓDULO DE PIEL DE DEDO DE MANO IZQUIERDA"
  },
  {
    "codigo":1196949005,
    "descripcion":"DEFECTO DE GEN DE SUBUNIDAD ESTRUCTURAL DE COMPLEJO III DE CADENA RESPIRATORIA MITOCONDRIAL"
  },
  {
    "codigo":10736081000119101,
    "descripcion":"ATRESIA CONGÉNITA DE VAGINA"
  },
  {
    "codigo":246677007,
    "descripcion":"CONGESTIÓN CONJUNTIVAL PASIVA"
  },
  {
    "codigo":277610002,
    "descripcion":"ENFERMEDAD DE HODGKIN A PREDOMINIO LINFOCÍTICO CON ESCLEROSIS NODULAR"
  },
  {
    "codigo":1162346004,
    "descripcion":"OSTEOSARCOMA DE ESTERNÓN"
  },
  {
    "codigo":408682005,
    "descripcion":"TOS FERINA ASOCIADA CON LA ATENCIÓN MÉDICA"
  },
  {
    "codigo":11827511000119109,
    "descripcion":"LUXACIÓN TRAUMÁTICA NO EXPUESTA DE ARTICULACIÓN INTERFALÁNGICA DE DEDO GORDO DERECHO"
  },
  {
    "codigo":15466007,
    "descripcion":"ERITROCITOSIS POR HEMANGIOMA CEREBELOSO"
  },
  {
    "codigo":212074009,
    "descripcion":"QUEMADURA QUE COMPROMETE 40-49 PORCIENTO DE LA SUPERFICIE DEL CUERPO, CON QUEMADURA DE ESPESOR COMPLETO QUE AFECTA 40-49 PORCIENTO DE LA SUPERFICIE CORPORAL"
  },
  {
    "codigo":111935003,
    "descripcion":"ENFERMEDAD CAUSADA POR ARMILLIFER"
  },
  {
    "codigo":243007004,
    "descripcion":"LESIÓN POR PERDIGÓN"
  },
  {
    "codigo":13631004,
    "descripcion":"INFESTACIÓN CAUSADA POR PYEMOTES VENTRICOSUS"
  },
  {
    "codigo":275775009,
    "descripcion":"FENOTIAZINA EN ORINA"
  },
  {
    "codigo":77332003,
    "descripcion":"PARCIALISMO"
  },
  {
    "codigo":208404004,
    "descripcion":"FRACTURA NO EXPUESTA DE LA BASE DEL PRIMER METACARPIANO, INTRARTICULAR DE ROLANDO"
  },
  {
    "codigo":332241000119106,
    "descripcion":"ESCLEROQUERATITIS DE OJO DERECHO"
  },
  {
    "codigo":372244006,
    "descripcion":"MELANOMA MALIGNO"
  },
  {
    "codigo":110100007,
    "descripcion":"LACERACIÓN SIMPLE CONTAMINADA DE MUCOSA YUGAL"
  },
  {
    "codigo":44564008,
    "descripcion":"AFONÍA"
  },
  {
    "codigo":1156841003,
    "descripcion":"PARAPLEJÍA ESPÁSTICA HEREDITARIA COMPLEJA LIGADA AL CROMOSOMA X"
  },
  {
    "codigo":403177004,
    "descripcion":"AMPOLLA POR EDEMA AGUDO"
  },
  {
    "codigo":304873009,
    "descripcion":"APEGO DESORGANIZADO"
  },
  {
    "codigo":235667000,
    "descripcion":"SÍNDROME DE VACIAMIENTO RÁPIDO TARDÍO"
  },
  {
    "codigo":301203001,
    "descripcion":"HALLAZGO RELACIONADO CON LAS ADENOIDES"
  },
  {
    "codigo":399507002,
    "descripcion":"VASCULARIZACIÓN DEL TEJIDO TUMORAL"
  },
  {
    "codigo":42801000087100,
    "descripcion":"HERIDA POR PINCHAZO DE AGUJA EN MANO IZQUIERDA"
  },
  {
    "codigo":1251475005,
    "descripcion":"METÁSTASIS DE OSTEOSARCOMA EN ESTERNÓN"
  },
  {
    "codigo":47921000087101,
    "descripcion":"FRACTURA DE BASE DE QUINTO METATARSIANO IZQUIERDO"
  },
  {
    "codigo":168296000,
    "descripcion":"ORGANISMO AISLADO EN CULTIVO DE HISOPADO NASAL"
  },
  {
    "codigo":37224001,
    "descripcion":"VÓMITO PSICÓGENO"
  },
  {
    "codigo":40241000087104,
    "descripcion":"HERIDA PUNZANTE DE MUSLO DERECHO CON CUERPO EXTRAÑO"
  },
  {
    "codigo":233832000,
    "descripcion":"INFARTO AGUDO NO Q - INFEROLATERAL"
  },
  {
    "codigo":364904005,
    "descripcion":"HALLAZGO RELACIONADO CON LA CAPACIDAD PARA ADOPTAR Y MANTENER UNA POSTURA"
  },
  {
    "codigo":231997000,
    "descripcion":"ESCLEROSIS COROIDEA PERIPAPILAR"
  },
  {
    "codigo":199229001,
    "descripcion":"DIABETES MELLITUS TIPO 1 PREEXISTENTE"
  },
  {
    "codigo":11774571000119107,
    "descripcion":"CUERPO EXTRAÑO EN PIEL DE PULGAR DERECHO CON INFECCIÓN"
  },
  {
    "codigo":166461005,
    "descripcion":"ÍNDICE DE ANDRÓGENOS LIBRES DENTRO DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":789053008,
    "descripcion":"TIC MOTOR TRANSITORIO"
  },
  {
    "codigo":295698000,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE ÓXIDO MERCÚRICO"
  },
  {
    "codigo":12403461000119102,
    "descripcion":"TUMOR NEUROENDOCRINO BIEN DIFERENCIADO DE CAVIDAD NASAL"
  },
  {
    "codigo":721682003,
    "descripcion":"COLITIS CAUSADA POR SALMONELLA"
  },
  {
    "codigo":426770005,
    "descripcion":"DISPOSICIÓN PARA MEJORAR UN BALANCE HÍDRICO POSITIVO"
  },
  {
    "codigo":262930006,
    "descripcion":"QUEMADURA DE TROMPA DE FALOPIO"
  },
  {
    "codigo":230162007,
    "descripcion":"ENCEFALITIS ENTEROVIRAL"
  },
  {
    "codigo":228327003,
    "descripcion":"DÍA DE BEBIDA"
  },
  {
    "codigo":688901000119104,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE MEMBRANA MUCOSA DE LABIO INFERIOR"
  },
  {
    "codigo":128188000,
    "descripcion":"PARÁLISIS CEREBRAL"
  },
  {
    "codigo":95420006,
    "descripcion":"LIMITACIÓN CRÓNICA DEL MOVIMIENTO DEL CUELLO"
  },
  {
    "codigo":10656671000119100,
    "descripcion":"ÚLCERA NEUROPÁTICA DE PIE IZQUIERDO"
  },
  {
    "codigo":93585004,
    "descripcion":"OSIFICACIÓN INCOMPLETA DE HUESO HIOIDES"
  },
  {
    "codigo":290193005,
    "descripcion":"INTOXICACIÓN INTENCIONAL POR MORFINA"
  },
  {
    "codigo":191889006,
    "descripcion":"ADICCIÓN AL TABACO, EN REMISIÓN"
  },
  {
    "codigo":7071000119102,
    "descripcion":"HEMORRAGIA GÁSTRICA DEBIDA A GASTRITIS EROSIVA"
  },
  {
    "codigo":714342001,
    "descripcion":"FALLECIDO EN AMBULANCIA"
  },
  {
    "codigo":288358005,
    "descripcion":"LANZA OBJETOS"
  },
  {
    "codigo":26214006,
    "descripcion":"TROMBOSIS DE LA ARTERIA RETINIANA"
  },
  {
    "codigo":712507000,
    "descripcion":"DESPRENDIMIENTO DE RETINA REGMATÓGENO CON MÚLTIPLES RUPTURAS"
  },
  {
    "codigo":450363003,
    "descripcion":"HEMORRAGIA EN ESPACIO SUBARACNOIDEO DE COLUMNA VERTEBRAL"
  },
  {
    "codigo":286523004,
    "descripcion":"NO LLEVA ALIMENTOS PREPARADOS"
  },
  {
    "codigo":253755003,
    "descripcion":"MALFORMACIÓN CONGÉNITA DE CONDUCTOS Y GLÁNDULAS SALIVALES"
  },
  {
    "codigo":778043005,
    "descripcion":"SÍNDROME DEL CROMOSOMA 17 EN ANILLO"
  },
  {
    "codigo":188219004,
    "descripcion":"NEOPLASIA MALIGNA DE TESTÍCULO NO DESCENDIDO"
  },
  {
    "codigo":448528000,
    "descripcion":"ANEURISMA DE SENO DE VALSALVA AÓRTICO CON RUPTURA EN CAVIDAD PERICÁRDICA"
  },
  {
    "codigo":1234960001,
    "descripcion":"TRASTORNO FETAL DEBIDO A CIRCULAR DE CORDÓN UMBILICAL"
  },
  {
    "codigo":219152002,
    "descripcion":"LACERACIONES AUTOINFLIGIDAS EN LA MUÑECA"
  },
  {
    "codigo":15981471000119105,
    "descripcion":"ENTROPIÓN DE AMBOS PÁRPADOS INFERIORES"
  },
  {
    "codigo":282853002,
    "descripcion":"CAPAZ DE MANTENERSE EN BIPEDESTACIÓN"
  },
  {
    "codigo":10957881000119102,
    "descripcion":"HERIDA ABIERTA DE DEDO GORDO DE PIE IZQUIERDO"
  },
  {
    "codigo":1003749009,
    "descripcion":"CONTRACTURA EN FLEXIÓN DE ARTICULACIÓN INTERFALÁNGICA DE DEDO PULGAR"
  },
  {
    "codigo":10738591000119109,
    "descripcion":"HIPERPLASIA DE CONDUCTO GALACTÓFORO DE MAMA DERECHA"
  },
  {
    "codigo":281018007,
    "descripcion":"EX FUMADOR DE CIGARRILLOS"
  },
  {
    "codigo":17039000,
    "descripcion":"AMPOLLA DE LA PARED ABDOMINAL, CON INFECCIÓN"
  },
  {
    "codigo":444858009,
    "descripcion":"TRANSLOCACIÓN CROMOSÓMICA DESEQUILIBRADA"
  },
  {
    "codigo":84410009,
    "descripcion":"TRASTORNO DEL TRACTO DIGESTIVO"
  },
  {
    "codigo":703332001,
    "descripcion":"PERICARDITIS DEBIDA A ENFERMEDAD METABÓLICA"
  },
  {
    "codigo":49807009,
    "descripcion":"DACTILITIS TUBERCULOSA"
  },
  {
    "codigo":1260388004,
    "descripcion":"HEMICOREA DEBIDA A MALFORMACIÓN ARTERIOVENOSA CEREBRAL"
  },
  {
    "codigo":441188004,
    "descripcion":"DEFICIENCIA HOMOCIGOTA PROTEÍNA C"
  },
  {
    "codigo":47972006,
    "descripcion":"LESIÓN TRAUMÁTICA SUPERFICIAL DE LA PARED ABDOMINAL, CON INFECCIÓN"
  },
  {
    "codigo":373817002,
    "descripcion":"SIN TRATAMIENTO ONCOLÓGICO DISPONIBLE"
  },
  {
    "codigo":691411000119101,
    "descripcion":"ANEMIA CONCOMITANTE CON ENFERMEDAD RENAL CRÓNICA EN ESTADIO 5 Y DEBIDA A ELLA"
  },
  {
    "codigo":275513007,
    "descripcion":"PERICARDITIS VIRAL - VIRUS NO IDENTIFICADO"
  },
  {
    "codigo":371982006,
    "descripcion":"NEOPLASIA MALIGNA DE GLÁNDULA ENDOCRINA"
  },
  {
    "codigo":109838007,
    "descripcion":"NEOPLASIA MALIGNA SUPERPUESTA DEL COLON"
  },
  {
    "codigo":239075001,
    "descripcion":"QUERATODERMIA PALMOPLANTAR CON LEUCOPLASIA"
  },
  {
    "codigo":1287651001,
    "descripcion":"DEFORMIDAD EN VALGO DE DEDO GORDO DE PIE DERECHO"
  },
  {
    "codigo":1254883007,
    "descripcion":"HIPERQUERATOSIS DE REGIÓN POSTERIOR DE PIE"
  },
  {
    "codigo":106168000,
    "descripcion":"HALLAZGO RELACIONADO CON EL SUEÑO"
  },
  {
    "codigo":237240001,
    "descripcion":"EMBARAZO ADOLESCENTE"
  },
  {
    "codigo":271843009,
    "descripcion":"ESFUERZO DOLOROSO PARA DEFECAR"
  },
  {
    "codigo":1187512003,
    "descripcion":"HIPOACUSIA NEUROSENSORIAL MITOCONDRIAL NO SINDRÓMICA"
  },
  {
    "codigo":40632002,
    "descripcion":"ENFERMEDAD DE CHARCOT - MARIE - TOOTH, TIPO IA"
  },
  {
    "codigo":827064005,
    "descripcion":"FUERZA DE ARTICULACIÓN NORMAL"
  },
  {
    "codigo":300941005,
    "descripcion":"INFECCIÓN DE CARA"
  },
  {
    "codigo":268173005,
    "descripcion":"FÍSTULA DE LA HENDIDURA BRANQUIAL"
  },
  {
    "codigo":299106000,
    "descripcion":"SIN AMPLITUD PASIVA DE ADUCCIÓN DE DEDO DE LA MANO"
  },
  {
    "codigo":366477009,
    "descripcion":"HALLAZGO RELACIONADO CON LA AMPLITUD DE MOVIMIENTO PASIVO DE EXTENSIÓN DE HOMBRO"
  },
  {
    "codigo":69730002,
    "descripcion":"TAQUICARDIA IDIOPÁTICA DE LA UNIÓN AURICULOVENTRICULAR"
  },
  {
    "codigo":102498003,
    "descripcion":"AGONÍA"
  },
  {
    "codigo":1074541000119103,
    "descripcion":"ARTROSIS SECUNDARIA DE PIE DERECHO"
  },
  {
    "codigo":200802008,
    "descripcion":"DERMATITIS POR CONTACTO CAUSADA POR ÁCIDOS"
  },
  {
    "codigo":2359002,
    "descripcion":"HIPER BETA - ALANINEMIA"
  },
  {
    "codigo":1149239002,
    "descripcion":"SOBREDOSIS DE DIETILAMIDA DE ÁCIDO LISÉRGICO"
  },
  {
    "codigo":67895005,
    "descripcion":"QUERATOCONJUNTIVITIS FLICTENULAR"
  },
  {
    "codigo":264503005,
    "descripcion":"ANEURISMA DEL TABIQUE MEMBRANOSO"
  },
  {
    "codigo":461111008,
    "descripcion":"TRAYECTO ANÓMALO DE ARTERIA CORONARIA POR DELANTE DE LA AORTA"
  },
  {
    "codigo":197132001,
    "descripcion":"DIARREA POSCIRUGÍA DEL TRACTO GASTROINTESTINAL"
  },
  {
    "codigo":721420001,
    "descripcion":"FRACTURA DE SEXTA VÉRTEBRA DORSAL"
  },
  {
    "codigo":426508001,
    "descripcion":"INFLAMACIÓN DE BOLSA ILEAL"
  },
  {
    "codigo":262668005,
    "descripcion":"HEMATOMA DE OROFARINGE"
  },
  {
    "codigo":295436006,
    "descripcion":"SOBREDOSIS DE DANTRÓN"
  },
  {
    "codigo":293601001,
    "descripcion":"ALERGIA A MORFINA"
  },
  {
    "codigo":337261000119107,
    "descripcion":"DERMATOCALASIA DE PÁRPADO SUPERIOR IZQUIERDO"
  },
  {
    "codigo":10632711000119101,
    "descripcion":"ABSCESO DE MANO IZQUIERDA"
  },
  {
    "codigo":31457007,
    "descripcion":"SÍNCOPE POR ESFUERZO"
  },
  {
    "codigo":422838000,
    "descripcion":"SUFRIMIENTO MORAL"
  },
  {
    "codigo":193462001,
    "descripcion":"INSOMNIO"
  },
  {
    "codigo":226230001,
    "descripcion":"DIETA BRISTOL"
  },
  {
    "codigo":95158003,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LAS VÍAS RESPIRATORIAS SUPERIORES"
  },
  {
    "codigo":129761009,
    "descripcion":"CALCIFICACIÓN FINA, LINEAL"
  },
  {
    "codigo":717750002,
    "descripcion":"HIDRONEFROSIS PRIMARIA CONGÉNITA BILATERAL"
  },
  {
    "codigo":816054007,
    "descripcion":"TUMORACIÓN DE CUADRANTE INFERIOR EXTERNO DE MAMA"
  },
  {
    "codigo":60555002,
    "descripcion":"VASCULITIS LEUCOCITOCLÁSTICA"
  },
  {
    "codigo":27787003,
    "descripcion":"PERIOSTITIS SUPURATIVA DE LA MANDÍBULA"
  },
  {
    "codigo":421003004,
    "descripcion":"VASO CENTINELA DE LA CONJUNTIVA"
  },
  {
    "codigo":94984000,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LAS GLÁNDULAS PARAURETRALES"
  },
  {
    "codigo":16039431000119105,
    "descripcion":"CONDROMALACIA DE CADERA IZQUIERDA"
  },
  {
    "codigo":322699009,
    "descripcion":"ANEMIA HEMOLÍTICA INTRACORPUSCULAR"
  },
  {
    "codigo":191627008,
    "descripcion":"TRASTORNO AFECTIVO BIPOLAR, ACTUALMENTE EPISODIO DEPRESIVO"
  },
  {
    "codigo":224395008,
    "descripcion":"BUENA ACEPTACIÓN DE LA SUPERVISIÓN EN EL TRABAJO"
  },
  {
    "codigo":124256006,
    "descripcion":"DEFICIENCIA DE COLINA ACETILTRANSFERASA"
  },
  {
    "codigo":1269301000,
    "descripcion":"MEGACOLON IDIOPÁTICO EN EL ADULTO"
  },
  {
    "codigo":25952008,
    "descripcion":"ALTERACIÓN DE LA MOVILIDAD DE LOS HUESECILLOS DEL OÍDO, EXCEPTO EL MARTILLO"
  },
  {
    "codigo":286261002,
    "descripcion":"CAPAZ DE ACOMODAR LOS ÓRGANOS DE LA FONACIÓN AL MOMENTO DE ARTICULAR PALABRAS"
  },
  {
    "codigo":187957007,
    "descripcion":"NEOPLASIA MALIGNA DE VÉRTEBRA COCCÍGEA"
  },
  {
    "codigo":55050000,
    "descripcion":"HIPERMNESIA"
  },
  {
    "codigo":251658000,
    "descripcion":"ESPERMATOZOIDES EN MOCO CERVICAL POSCOITAL, MOTILIDAD DE PROGRESIÓN RÁPIDA"
  },
  {
    "codigo":253493009,
    "descripcion":"ANOMALÍA DE VALVA DE VÁLVULA AURICULOVENTRICULAR IZQUIERDA"
  },
  {
    "codigo":184287001,
    "descripcion":"PACIENTE PARA CREMACIÓN"
  },
  {
    "codigo":20447006,
    "descripcion":"DISCRASIA DE CÉLULAS PLASMÁTICAS CON NEUROPATÍA"
  },
  {
    "codigo":249823007,
    "descripcion":"DEFORMIDAD EN FLEXIÓN DE PRIMER DEDO DE PIE"
  },
  {
    "codigo":282591008,
    "descripcion":"NO BRINCA EN UN SOLO PIE"
  },
  {
    "codigo":444596001,
    "descripcion":"TIMOMA MALIGNO"
  },
  {
    "codigo":446431009,
    "descripcion":"FILTRACIÓN DESDE PILOROPLASTIA"
  },
  {
    "codigo":315359009,
    "descripcion":"PAÍS DE NACIMIENTO - AUSTRALASIÁTICO"
  },
  {
    "codigo":339771000119100,
    "descripcion":"ORZUELO INTERNO DEL PÁRPADO INFERIOR IZQUIERDO"
  },
  {
    "codigo":247988009,
    "descripcion":"ATRAE LA ATENCIÓN DE LA GENTE EN FORMA DESFAVORABLE"
  },
  {
    "codigo":442761002,
    "descripcion":"DISFUNCIÓN DEL EJE HIPOTALÁMICO-HIPOFISARIO-GONADAL"
  },
  {
    "codigo":278921006,
    "descripcion":"AFECCIÓN DEL HABLA Y LA FONOLOGÍA"
  },
  {
    "codigo":213385006,
    "descripcion":"LESIONES DE VASOS SANGUÍNEOS QUE COMPROMETEN MÚLTIPLES REGIONES DEL CUERPO"
  },
  {
    "codigo":211550003,
    "descripcion":"LESIÓN TRAUMÁTICA POR APLASTAMIENTO, HOMBRO Y BRAZO"
  },
  {
    "codigo":440926006,
    "descripcion":"CATÉTER TRANSITORIO DE DIÁLISIS PERITONEAL IN SITU"
  },
  {
    "codigo":1260126007,
    "descripcion":"EXTRAVASACIÓN DE LÍQUIDO CEFALORRAQUÍDEO CRANEAL DEBIDA A PROCEDIMIENTO QUIRÚRGICO Y POSTERIOR A ÉL"
  },
  {
    "codigo":111411000,
    "descripcion":"ESTENOSIS URETRAL POSOPERATORIA"
  },
  {
    "codigo":209715001,
    "descripcion":"SECCIÓN ABIERTA DE LIGAMENTO PÉLVICO"
  },
  {
    "codigo":735838007,
    "descripcion":"HERIDA PUNZANTE DE MUSLO SIN CUERPO EXTRAÑO"
  },
  {
    "codigo":368331000119100,
    "descripcion":"BAJA ESTATURA CONCOMITANTE CON TRASTORNO ENDOCRINO Y DEBIDA A ÉL"
  },
  {
    "codigo":10861771000119101,
    "descripcion":"HERIDA ABIERTA DE CUERO CABELLUDO DEBIDA A MORDEDURA DE PERRO"
  },
  {
    "codigo":15864011000119101,
    "descripcion":"QUISTE DE REGIÓN PREAURICULAR IZQUIERDA"
  },
  {
    "codigo":11773131000119103,
    "descripcion":"LACERACIÓN DE MÚSCULO DE ANTEBRAZO DERECHO"
  },
  {
    "codigo":317131000119104,
    "descripcion":"REUMATISMO PALINDRÓMICO DE ARTICULACIÓN DE MUÑECA DERECHA"
  },
  {
    "codigo":340171000119105,
    "descripcion":"QUERATOCONO DE LA CÓRNEA IZQUIERDA"
  },
  {
    "codigo":678091000119102,
    "descripcion":"HEMORRAGIA PRERRETINIANA DE OJO DERECHO"
  },
  {
    "codigo":342731000119107,
    "descripcion":"QUISTE DE PÁRPADO IZQUIERDO"
  },
  {
    "codigo":16836811000119108,
    "descripcion":"ABORTO ESPONTÁNEO DE EMBARAZO ECTÓPICO EN TROMPA DE FALOPIO IZQUIERDA"
  },
  {
    "codigo":352971000119109,
    "descripcion":"NEOPLASIA MALIGNA PRIMARIA DE HUESO DE MANO IZQUIERDA"
  },
  {
    "codigo":16227531000119109,
    "descripcion":"ANTÍGENO ASOCIADO A CARCINOMA 19-9 POR ENCIMA DEL RANGO DE REFERENCIA"
  },
  {
    "codigo":332491000119104,
    "descripcion":"HEMORRAGIA DE RETINA DERECHA"
  },
  {
    "codigo":109771000119103,
    "descripcion":"DOLOR POSOPERATORIO CRÓNICO"
  },
  {
    "codigo":9437001,
    "descripcion":"PRESENCIA ANORMAL DE MIOGLOBINA"
  },
  {
    "codigo":1085131000119105,
    "descripcion":"ABSCESO DE INTESTINO CONCOMITANTE CON PANCOLITIS ULCEROSA CRÓNICA Y DEBIDO A ELLA"
  },
  {
    "codigo":16754891000119106,
    "descripcion":"SANGRADO UTERINO ANORMAL DEBIDO A FIBROMA UTERINO"
  },
  {
    "codigo":145611000119107,
    "descripcion":"MIGRAÑA ALÉRGICA"
  },
  {
    "codigo":240648004,
    "descripcion":"LEISHMANIASIS CUTÁNEA POR LEISHMANIA BRAZILIENSIS GUYANENSIS"
  },
  {
    "codigo":214036171000119109,
    "descripcion":"COLITIS ULCEROSA DE COLON IZQUIERDO EN REMISIÓN"
  },
  {
    "codigo":1287389003,
    "descripcion":"HERIDA POR ARMA DE FUEGO DE REGIÓN DE TOBILLO"
  },
  {
    "codigo":109576008,
    "descripcion":"CARIES DENTAL PRIMARIA, ORIGEN EN LA SUPERFICIE RADICULAR"
  },
  {
    "codigo":304349007,
    "descripcion":"AUSENCIA DE MOVIMIENTO DE LA COLUMNA DORSAL"
  },
  {
    "codigo":238813009,
    "descripcion":"EXANTEMA POR FÁRMACOS"
  },
  {
    "codigo":402653004,
    "descripcion":"PÚRPURA TROMBOCITOPÉNICA POR LA PRODUCCIÓN DEFECTUOSA DE PLAQUETAS"
  },
  {
    "codigo":74973004,
    "descripcion":"PANCREATITIS FIBROSANTE CRÓNICA"
  },
  {
    "codigo":1187250005,
    "descripcion":"SÍNDROME DE CRISIS CONVULSIVAS, ESCOLIOSIS Y MACROCEFALIA"
  },
  {
    "codigo":40370006,
    "descripcion":"URTICARIA INMUNOLÓGICA"
  },
  {
    "codigo":1156317007,
    "descripcion":"SÍNDROME DE INSENSIBILIDAD ANDROGÉNICA LEVE"
  },
  {
    "codigo":300679002,
    "descripcion":"NO CRUZA POR PASO A NIVEL"
  },
  {
    "codigo":366215005,
    "descripcion":"HALLAZGO RELACIONADO CON LA PERMEABILIDAD DE VASO DISTAL"
  },
  {
    "codigo":235143007,
    "descripcion":"TRAYECTO FISTULOSO CONGÉNITO DE LÍNEA MEDIA DE SURCO NASOLABIAL"
  },
  {
    "codigo":71303008,
    "descripcion":"DOLOR FACIAL ATÍPICO"
  },
  {
    "codigo":298844002,
    "descripcion":"AMPLITUD DE CIRCUNDUCCIÓN ACTIVA DE HOMBRO NORMAL"
  },
  {
    "codigo":167772008,
    "descripcion":"VOLUMEN DE SEMEN, MODERADO: 1-2 ML"
  },
  {
    "codigo":722993001,
    "descripcion":"HERIDA COMPLEJA DE CABEZA"
  },
  {
    "codigo":15960021000119107,
    "descripcion":"DILATACIÓN DE RAÍZ AÓRTICA DEBIDA A SÍNDROME DE MARFAN"
  },
  {
    "codigo":297009001,
    "descripcion":"SOBREDOSIS ACCIDENTAL DE BENDROFLUAZIDA"
  },
  {
    "codigo":788529004,
    "descripcion":"DEPÓSITO DE EXCESO DE GRASA EN EL PERICARDIO VISCERAL"
  },
  {
    "codigo":231473004,
    "descripcion":"DEPENDENCIA DE BENZODIAZEPINAS"
  },
  {
    "codigo":16015471000119102,
    "descripcion":"OSTEOPATÍA DE PIE DERECHO POSTERIOR A POLIOMIELITIS"
  },
  {
    "codigo":229638001,
    "descripcion":"AFONÍA HIPERCINÉTICA"
  },
  {
    "codigo":65798002,
    "descripcion":"CRUZAMIENTO MOLECULAR"
  },
  {
    "codigo":11673711000119103,
    "descripcion":"CRISTALINO ARTIFICIAL PRESENTE EN OJO IZQUIERDO"
  },
  {
    "codigo":295174006,
    "descripcion":"SOBREDOSIS DE HEROÍNA"
  },
  {
    "codigo":426246007,
    "descripcion":"LESIÓN PENETRANTE CAUSADA POR CUCHILLO"
  },
  {
    "codigo":293339001,
    "descripcion":"REACCIÓN ADVERSA A HEPARINOIDE"
  },
  {
    "codigo":721158009,
    "descripcion":"DELECIÓN 5Q35"
  },
  {
    "codigo":1145307003,
    "descripcion":"ALIMENTADO CON LACTANCIA MATERNA EXCLUSIVA"
  },
  {
    "codigo":422576004,
    "descripcion":"COORDINACIÓN DISMINUIDA"
  },
  {
    "codigo":1340080008,
    "descripcion":"CICATRIZ DE PIEL POSTERIOR A PRIMERA VACUNACIÓN"
  },
  {
    "codigo":94896008,
    "descripcion":"NEOPLASIA DE COMPORTAMIENTO INCIERTO DE LA CARA LARÍNGEA DEL PLIEGUE INTERARITENOIDEO"
  },
  {
    "codigo":93061002,
    "descripcion":"DILATACIÓN CONGÉNITA DE ARTERIA SUBCLAVIA"
  },
  {
    "codigo":291504008,
    "descripcion":"INTOXICACIÓN VOLUNTARIA POR OLEANDOMICINA"
  },
  {
    "codigo":289669005,
    "descripcion":"DOLOR DEL ÚTERO"
  },
  {
    "codigo":715653007,
    "descripcion":"SÍNDROME ESPONDILOOCULAR"
  },
  {
    "codigo":25690000,
    "descripcion":"NEUROPATÍA FEMORAL"
  },
  {
    "codigo":255066001,
    "descripcion":"CARCINOMA DE ÓRGANO GENITOURINARIO"
  },
  {
    "codigo":224133007,
    "descripcion":"VIVE CON LA FAMILIA"
  },
  {
    "codigo":10690671000119109,
    "descripcion":"FIBROSIS HEPÁTICA ESTADIO 3"
  },
  {
    "codigo":386138005,
    "descripcion":"ARTERIA CORONARIA CON STENT"
  },
  {
    "codigo":1079561000119103,
    "descripcion":"CONDROSARCOMA PRIMARIO DE HUESO DE PIE IZQUIERDO"
  },
  {
    "codigo":16670831000119109,
    "descripcion":"FRACTURA NO EXPUESTA DE ÁNGULO DE MANDÍBULA DERECHA"
  },
  {
    "codigo":56623003,
    "descripcion":"FÍSTULA ISQUIORRECTAL"
  },
  {
    "codigo":449839003,
    "descripcion":"OTITIS MEDIA CRÓNICA CON DERRAME SANGUÍNEO"
  },
  {
    "codigo":253231007,
    "descripcion":"ANIRIDIA TIPO 1"
  },
  {
    "codigo":23855008,
    "descripcion":"INFESTACIÓN CAUSADA POR CUTEREBRA"
  },
  {
    "codigo":285999008,
    "descripcion":"ABRE LA LLAVE PRINCIPAL DE GAS"
  },
  {
    "codigo":284164003,
    "descripcion":"MUEVE LA CABEZA"
  },
  {
    "codigo":448004007,
    "descripcion":"VÁLVULA PULMONAR UNICÚSPIDE ACOMISURAL"
  },
  {
    "codigo":87556008,
    "descripcion":"HIPERPLASIA VAGINAL"
  },
  {
    "codigo":249561001,
    "descripcion":"ÓRGANO ABDOMINAL - HALLAZGO"
  },
  {
    "codigo":51118003,
    "descripcion":"ATRESIA DE DUODENO"
  },
  {
    "codigo":247726004,
    "descripcion":"SIENTE QUE SU PROPIO CUERPO ES IRREAL"
  },
  {
    "codigo":313262006,
    "descripcion":"CONTUSIÓN DE LA REGIÓN SACRA"
  },
  {
    "codigo":870318006,
    "descripcion":"OSTEOSARCOMA DE HUESO DE LA CABEZA"
  },
  {
    "codigo":83886009,
    "descripcion":"PARÁLISIS DE KLUMPKE - DÉJERINE"
  },
  {
    "codigo":1263534009,
    "descripcion":"ENFERMEDAD DE NEURONA MOTORA DEBIDA A HERPES ZÓSTER"
  },
  {
    "codigo":82051003,
    "descripcion":"INFECCIÓN CAUSADA POR CLOSTRIDIUM PERFRINGENS TIPO D"
  },
  {
    "codigo":409731007,
    "descripcion":"HALLAZGO RELACIONADO CON LA CLASIFICACIÓN INTERNACIONAL DE NEUROBLASTOMA"
  },
  {
    "codigo":213123008,
    "descripcion":"INFECCIÓN DE HUESO ASOCIADA CON CLAVO INTRAMEDULAR"
  },
  {
    "codigo":193459004,
    "descripcion":"CICATRICES CORIORRETINIANAS DISEMINADAS"
  },
  {
    "codigo":735576008,
    "descripcion":"PERFORACIÓN DE AORTA ABDOMINAL CONCOMITANTE CON ANEURISMA DE AORTA ABDOMINAL Y DEBIDA A ÉL"
  },
  {
    "codigo":307757001,
    "descripcion":"HEPATITIS ALCOHÓLICA CRÓNICA"
  },
  {
    "codigo":78381004,
    "descripcion":"CARDIOPATÍA EN LA MADRE, QUE COMPLICA EL EMBARAZO, EL PARTO Y\/O EL PUERPERIO"
  },
  {
    "codigo":733741005,
    "descripcion":"ALTERACIÓN FUNCIONAL DEL SISTEMA CARDIOVASCULAR"
  },
  {
    "codigo":45613006,
    "descripcion":"CONTUSIÓN DE PIERNA"
  },
  {
    "codigo":209453007,
    "descripcion":"ESGUINCE DE LIGAMENTO LATERAL CUBITAL DE ARTICULACIÓN DE LA MUÑECA"
  },
  {
    "codigo":109314000,
    "descripcion":"OSTEOMIELITIS AGUDA DEL COMPLEJO ÓRBITO - NASAL"
  },
  {
    "codigo":240386002,
    "descripcion":"MUERMO SUPURATIVO LOCALIZADO AGUDO"
  },
  {
    "codigo":369623002,
    "descripcion":"MARGEN DE RESECCIÓN QUIRÚRGICA DE LA CÁPSULA RENAL, CON COMPROMISO TUMORAL"
  },
  {
    "codigo":238551004,
    "descripcion":"ECCEMA HIPERQUERATÓSICO DE PALMAS Y PLANTAS"
  },
  {
    "codigo":125501000119105,
    "descripcion":"SÍNDROME DE TRISOMÍA COMPLETA DE CROMOSOMA 21 FETAL"
  },
  {
    "codigo":203948001,
    "descripcion":"ESPINA BÍFIDA CERVICAL CON HIDROCEFALIA - CERRADA"
  },
  {
    "codigo":105644004,
    "descripcion":"ENFERMEDAD CAUSADA POR HEXAMITIDAE"
  },
  {
    "codigo":1186988005,
    "descripcion":"MIEDO A PADECER NEOPLASIA MALIGNA DE SISTEMA LINFÁTICO"
  },
  {
    "codigo":40108008,
    "descripcion":"TALASEMIA"
  },
  {
    "codigo":300417001,
    "descripcion":"DEFENSA ABDOMINAL EN LA FOSA ILÍACA DERECHA"
  },
  {
    "codigo":365953001,
    "descripcion":"HALLAZGO RELACIONADO CON EL USO DE PROTECCIÓN PARA EL ACTO SEXUAL"
  },
  {
    "codigo":267649003,
    "descripcion":"ENTROPIÓN Y TRIQUIASIS PALPEBRAL"
  },
  {
    "codigo":726401004,
    "descripcion":"DISOMÍA UNIPARENTAL DE ORIGEN MATERNO"
  },
  {
    "codigo":5505005,
    "descripcion":"BRONQUIOLITIS AGUDA"
  },
  {
    "codigo":69206000,
    "descripcion":"AFASIA FLUENTE"
  },
  {
    "codigo":1082071000119102,
    "descripcion":"CARCINOMA ESCAMOCELULAR PRIMARIO DE PABELLÓN AURICULAR IZQUIERDO"
  },
  {
    "codigo":298582002,
    "descripcion":"CREPITACIÓN AUDIBLE DE LA COLUMNA DORSAL"
  },
  {
    "codigo":396886003,
    "descripcion":"TUMOR QUE INVADE MÁS ALLÁ DE LA CÁPSULA PANCREÁTICA HACIA EL ESTÓMAGO (PÁNCREAS ENDOCRINO)"
  },
  {
    "codigo":15991511000119102,
    "descripcion":"CORIORRETINITIS DE OJO DERECHO CAUSADA POR MYCOBACTERIUM TUBERCULOSIS"
  },
  {
    "codigo":1052246003,
    "descripcion":"AGRANDAMIENTO DE AMÍGDALA DERECHA"
  },
  {
    "codigo":724566007,
    "descripcion":"TRASTORNO NEUROLÓGICO DEBIDO A INGESTIÓN EXCESIVA DE MICRONUTRIENTES"
  },
  {
    "codigo":460587000,
    "descripcion":"ORIGEN ANÓMALO DE ARTERIA CORONARIA ÚNICA EN SENO AÓRTICO DE ARTERIA CORONARIA IZQUIERDA"
  },
  {
    "codigo":344791000119104,
    "descripcion":"HEMORRAGIA DE AMBAS ÓRBITAS"
  },
  {
    "codigo":296747006,
    "descripcion":"SOBREDOSIS DE CEFALOSPORINA DE CUARTA GENERACIÓN"
  }
]
